
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire687c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire687c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.4";

});

parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});


parcelRegister("5aWMQ", function(module, exports) {

$parcel$export(module.exports, "BLACK", () => BLACK);
$parcel$export(module.exports, "WHITE", () => WHITE);
$parcel$export(module.exports, "LIGHT_GRAY", () => LIGHT_GRAY);
$parcel$export(module.exports, "GRAY", () => GRAY);
$parcel$export(module.exports, "BROWN", () => BROWN);
$parcel$export(module.exports, "DARK_GREEN", () => DARK_GREEN);
$parcel$export(module.exports, "GREEN", () => GREEN);
$parcel$export(module.exports, "LIME_GREEN", () => LIME_GREEN);
$parcel$export(module.exports, "YELLOW", () => YELLOW);
$parcel$export(module.exports, "LIGHT_YELLOW", () => LIGHT_YELLOW);
$parcel$export(module.exports, "DARK_BLUE", () => DARK_BLUE);
$parcel$export(module.exports, "BLUE", () => BLUE);
$parcel$export(module.exports, "LIGHT_BLUE", () => LIGHT_BLUE);
$parcel$export(module.exports, "CYAN", () => CYAN);
$parcel$export(module.exports, "MAGENTA", () => MAGENTA);
$parcel$export(module.exports, "PURPLE", () => PURPLE);
$parcel$export(module.exports, "DARK_RED", () => DARK_RED);
$parcel$export(module.exports, "RED", () => RED);
$parcel$export(module.exports, "LIGHT_RED", () => LIGHT_RED);
$parcel$export(module.exports, "ORANGE", () => ORANGE);
$parcel$export(module.exports, "getHexForName", () => getHexForName);
$parcel$export(module.exports, "getDefaultColors", () => getDefaultColors);
$parcel$export(module.exports, "getEmptyConfigState", () => getEmptyConfigState);
$parcel$export(module.exports, "getDescriptionForDataType", () => getDescriptionForDataType);
$parcel$export(module.exports, "getPlaceholderForDataType", () => getPlaceholderForDataType);
$parcel$export(module.exports, "getModalContainer", () => getModalContainer);
$parcel$export(module.exports, "IsEmptyStyle", () => IsEmptyStyle);
$parcel$export(module.exports, "IsNotEmptyStyle", () => IsNotEmptyStyle);
$parcel$export(module.exports, "getMessageTypeByStatusColour", () => getMessageTypeByStatusColour);
$parcel$export(module.exports, "getButtonToneByMessageType", () => getButtonToneByMessageType);
$parcel$export(module.exports, "getGlyphByMessageType", () => getGlyphByMessageType);
$parcel$export(module.exports, "getColorByMessageType", () => getColorByMessageType);
$parcel$export(module.exports, "getCSSColorByMessageType", () => getCSSColorByMessageType);
$parcel$export(module.exports, "getStyleForStatusColour", () => getStyleForStatusColour);
$parcel$export(module.exports, "getStyleForMessageType", () => getStyleForMessageType);
$parcel$export(module.exports, "getGlyphForStatusColour", () => getGlyphForStatusColour);
$parcel$export(module.exports, "getGlyphForMessageType", () => getGlyphForMessageType);
$parcel$export(module.exports, "getButtonToneForMessageType", () => getButtonToneForMessageType);
$parcel$export(module.exports, "getScheduleDescription", () => getScheduleDescription);
$parcel$export(module.exports, "getWeekDayByIndex", () => getWeekDayByIndex);
$parcel$export(module.exports, "getMessageTypeFromAdaptableAlerts", () => getMessageTypeFromAdaptableAlerts);
$parcel$export(module.exports, "getButtonColourForAdaptableAlerts", () => getButtonColourForAdaptableAlerts);
$parcel$export(module.exports, "getButtonTextColourForArrayandMessageType", () => getButtonTextColourForArrayandMessageType);
$parcel$export(module.exports, "getButtonTextColourForMessageType", () => getButtonTextColourForMessageType);
$parcel$export(module.exports, "getAdaptableToolPanelWidth", () => getAdaptableToolPanelWidth);
$parcel$export(module.exports, "getCSSVariableValue", () => getCSSVariableValue);
$parcel$export(module.exports, "getSimpleButtonPaddingWidth", () => getSimpleButtonPaddingWidth);
$parcel$export(module.exports, "isBrowserDocumentAvailable", () => isBrowserDocumentAvailable);
$parcel$export(module.exports, "setCSSVariableValue", () => setCSSVariableValue);
$parcel$export(module.exports, "UIHelper", () => UIHelper);
$parcel$export(module.exports, "default", () => $3c4b7cbdc2a84c8b$export$2e2bcd8739ae039);

var $4hg7e = parcelRequire("4hg7e");

var $hrtGQ = parcelRequire("hrtGQ");

var $9OAZF = parcelRequire("9OAZF");

var $9g4SS = parcelRequire("9g4SS");

var $9AsCL = parcelRequire("9AsCL");
const BLACK = 'Black';
const WHITE = 'White';
const LIGHT_GRAY = 'LightGray';
const GRAY = 'Gray';
const BROWN = 'Brown';
const DARK_GREEN = 'DarkGreen';
const GREEN = 'Green';
const LIME_GREEN = 'LimeGreen';
const YELLOW = 'Yellow';
const LIGHT_YELLOW = 'LightYellow';
const DARK_BLUE = 'DarkBlue';
const BLUE = 'Blue';
const LIGHT_BLUE = 'LightBlue';
const CYAN = 'Cyan';
const MAGENTA = 'Magenta';
const PURPLE = 'Purple';
const DARK_RED = 'DarkRed';
const RED = 'Red';
const LIGHT_RED = 'LightRed';
const ORANGE = 'Orange';
function getHexForName(name) {
    switch(name){
        case BLACK:
            return '#000000';
        case WHITE:
            return '#FFFFFF';
        case LIGHT_GRAY:
            return '#D3D3D3';
        case GRAY:
            return '#808080';
        case BROWN:
            return '#A52A2A';
        case DARK_GREEN:
            return '#006400';
        case GREEN:
            return '#008000';
        case LIME_GREEN:
            return '#32CD32';
        case YELLOW:
            return '#FFFF00';
        case LIGHT_YELLOW:
            return '#FFFFE0';
        case DARK_BLUE:
            return '#00008B';
        case BLUE:
            return '#0000FF';
        case LIGHT_BLUE:
            return '#87CEFA';
        case CYAN:
            return '#00FFFF';
        case MAGENTA:
            return '#FF00FF';
        case PURPLE:
            return '#800080';
        case DARK_RED:
            return '#8B0000';
        case RED:
            return '#FF0000';
        case LIGHT_RED:
            return '#DC143C';
        case ORANGE:
            return '#FFA500';
        default:
            return 'not found';
    }
}
function getDefaultColors() {
    return [
        getHexForName(BLACK),
        getHexForName(WHITE),
        getHexForName(LIGHT_GRAY),
        getHexForName(GRAY),
        getHexForName(BROWN),
        getHexForName(DARK_GREEN),
        getHexForName(GREEN),
        getHexForName(LIME_GREEN),
        getHexForName(YELLOW),
        getHexForName(LIGHT_YELLOW),
        getHexForName(DARK_BLUE),
        getHexForName(BLUE),
        getHexForName(LIGHT_BLUE),
        getHexForName(CYAN),
        getHexForName(MAGENTA),
        getHexForName(PURPLE),
        getHexForName(DARK_RED),
        getHexForName(RED),
        getHexForName(LIGHT_RED),
        getHexForName(ORANGE)
    ];
}
function getEmptyConfigState() {
    return {
        editedAdaptableObject: null,
        wizardStartIndex: 0,
        wizardStatus: (0, $4hg7e.WizardStatus).None
    };
}
function getDescriptionForDataType(dataType) {
    switch(dataType){
        case 'text':
            return 'text';
        case 'number':
            return 'number';
        case 'date':
            return 'date';
    }
}
function getPlaceholderForDataType(dataType) {
    switch(dataType){
        case 'text':
            return 'Enter Value';
        case 'number':
            return 'Enter Number';
        case 'date':
            return 'Enter Date';
    }
}
function getModalContainer(adaptableOptions, document1, context) {
    let modalContainer = (0, $9AsCL.resolveContainerElement)(adaptableOptions.containerOptions.modalContainer, context, document1);
    if (modalContainer) {
        const modalContainerClassName = ' modal-container';
        if (!modalContainer.className.includes(modalContainerClassName)) modalContainer.className += modalContainerClassName;
    }
    if (!modalContainer) modalContainer = document1.body;
    return modalContainer;
}
function IsEmptyStyle(style) {
    return !IsNotEmptyStyle(style);
}
function IsNotEmptyStyle(style) {
    return style.BackColor != null || style.ForeColor != null || style.BorderColor != null || style.FontWeight != (0, $hrtGQ.FontWeight).Normal || style.FontStyle != (0, $hrtGQ.FontStyle).Normal || style.FontSize != null || (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(style.ClassName);
}
function getMessageTypeByStatusColour(statusColour) {
    switch(statusColour){
        case (0, $hrtGQ.StatusColour).Error:
            return 'Error';
        case (0, $hrtGQ.StatusColour).Warn:
            return 'Warning';
        case (0, $hrtGQ.StatusColour).Success:
            return 'Success';
        case (0, $hrtGQ.StatusColour).Info:
            return 'Info';
    }
}
function getButtonToneByMessageType(messageType) {
    switch(messageType){
        case 'Info':
            return 'info';
        case 'Success':
            return 'success';
        case 'Warning':
            return 'warning';
        case 'Error':
            return 'error';
        default:
            return 'neutral';
    }
}
function getGlyphByMessageType(messageType) {
    switch(messageType){
        case 'Info':
            return 'info';
        case 'Success':
            return 'check';
        case 'Warning':
            return 'warning';
        case 'Error':
            return 'error';
    }
}
function getColorByMessageType(messageType) {
    switch(messageType){
        case 'Error':
            return 'var(--ab-color-error)';
        case 'Warning':
            return 'var(--ab-color-warn)';
        case 'Success':
            return 'var(--ab-color-success)';
        case 'Info':
            return 'var(--ab-color-info)';
    }
}
function getCSSColorByMessageType(messageType) {
    switch(messageType){
        case 'Error':
            return 'error';
        case 'Warning':
            return 'warn';
        case 'Success':
            return 'success';
        case 'Info':
            return 'info';
        default:
            return '';
    }
}
function getStyleForStatusColour(statusColour) {
    let result;
    switch(statusColour){
        case (0, $hrtGQ.StatusColour).Info:
            result = {
                fill: 'var(--ab-color-info)'
            };
            break;
        case (0, $hrtGQ.StatusColour).Success:
            result = {
                fill: 'var(--ab-color-success)'
            };
            break;
        case (0, $hrtGQ.StatusColour).Warn:
            result = {
                fill: 'var(--ab-color-warn)'
            };
            break;
        case (0, $hrtGQ.StatusColour).Error:
            result = {
                fill: 'var(--ab-color-error)'
            };
            break;
    }
    if (result) result.color = result.fill;
    return result;
}
function getStyleForMessageType(messageType) {
    let result;
    switch(messageType){
        case 'Info':
            result = {
                fill: 'var(--ab-color-info)'
            };
            break;
        case 'Success':
            result = {
                fill: 'var(--ab-color-success)'
            };
            break;
        case 'Warning':
            result = {
                fill: 'var(--ab-color-warn)'
            };
            break;
        case 'Error':
            result = {
                fill: 'var(--ab-color-error)'
            };
            break;
    }
    if (result) result.color = result.fill;
    return result;
}
function getGlyphForStatusColour(statusColour) {
    switch(statusColour){
        case (0, $hrtGQ.StatusColour).Info:
            return 'info';
        case (0, $hrtGQ.StatusColour).Success:
            return 'check';
        case (0, $hrtGQ.StatusColour).Warn:
            return 'warning';
        case (0, $hrtGQ.StatusColour).Error:
            return 'error';
    }
}
function getGlyphForMessageType(messageType) {
    switch(messageType){
        case 'Info':
            return 'info';
        case 'Success':
            return 'check';
        case 'Warning':
            return 'warning';
        case 'Error':
            return 'error';
    }
}
function getButtonToneForMessageType(messageType) {
    switch(messageType){
        case 'Info':
            return 'info';
        case 'Warning':
            return 'warning';
        case 'Error':
            return 'error';
        case 'Success':
            return 'success';
    }
}
function getScheduleDescription(schedule) {
    if (schedule == null) return '[No Schedule]';
    let dateString;
    if (schedule.OneOffDate == null) {
        if ((0, $9g4SS.default).ContainsItem(schedule.DaysOfWeek, 'Monday') && (0, $9g4SS.default).ContainsItem(schedule.DaysOfWeek, 'Tuesday') && (0, $9g4SS.default).ContainsItem(schedule.DaysOfWeek, 'Wednesday') && (0, $9g4SS.default).ContainsItem(schedule.DaysOfWeek, 'Thursday') && (0, $9g4SS.default).ContainsItem(schedule.DaysOfWeek, 'Friday')) {
            if ((0, $9g4SS.default).ContainsItem(schedule.DaysOfWeek, 'Sunday') && (0, $9g4SS.default).ContainsItem(schedule.DaysOfWeek, 'Saturday')) dateString = 'Everyday';
            else dateString = 'Weekdays';
        } else {
            const names = schedule.DaysOfWeek.sort().map((d)=>getShortenedDayString(d));
            dateString = (0, $9g4SS.default).createCommaSeparatedString(names);
        }
    } else dateString = new Date(schedule.OneOffDate).toDateString();
    return `${dateString} @ ${addLeadingZero(schedule.Hour)}:${addLeadingZero(schedule.Minute)}`;
}
function getShortenedDayString(dayOfWeek) {
    switch(dayOfWeek){
        case 'Sunday':
            return 'Sun';
        case 'Monday':
            return 'Mon';
        case 'Tuesday':
            return 'Tues';
        case 'Wednesday':
            return 'Weds';
        case 'Thursday':
            return 'Thurs';
        case 'Friday':
            return 'Fri';
        case 'Saturday':
            return 'Sat';
    }
}
function getWeekDayByIndex(dayOfWeek) {
    switch(dayOfWeek){
        case 0:
            return 'Sunday';
        case 1:
            return 'Monday';
        case 2:
            return 'Tuesday';
        case 3:
            return 'Wednesday';
        case 4:
            return 'Thursday';
        case 5:
            return 'Friday';
        case 6:
            return 'Saturday';
    }
}
function addLeadingZero(item) {
    item = item || 0;
    if (item < 10) return `0${item && item.toString ? item.toString() : item}`;
    return item.toString();
}
function getMessageTypeFromAdaptableAlerts(adaptableAlerts) {
    if (adaptableAlerts.find((a)=>a.alertDefinition.MessageType == 'Error') != null) return 'Error';
    if (adaptableAlerts.find((a)=>a.alertDefinition.MessageType == 'Warning') != null) return 'Warning';
    if (adaptableAlerts.find((a)=>a.alertDefinition.MessageType == 'Success') != null) return 'Success';
    return 'Info';
}
function getButtonColourForAdaptableAlerts(adaptableAlerts, messageTypeColor) {
    return (0, $9g4SS.default).IsNotNullOrEmpty(adaptableAlerts) ? messageTypeColor : 'primary';
}
function getButtonTextColourForArrayandMessageType(adaptableAlerts, messageType) {
    if ((0, $9g4SS.default).IsNullOrEmpty(adaptableAlerts)) return 'text-on-primary';
    return this.getButtonTextColourForMessageType(messageType);
}
function getButtonTextColourForMessageType(messageType) {
    switch(messageType){
        case 'Info':
            return 'var( --ab-color-text-on-info)';
        case 'Success':
            return 'var( --ab-color-text-on-success)';
        case 'Warning':
            return 'var( --ab-color-text-on-warn)';
        case 'Error':
            return 'var( --ab-color-text-on-error)';
    }
}
function getNumericCSSVariableValue(stringValue, defaultValue) {
    const numericValue = typeof stringValue === 'string' ? +stringValue.match(/\d/g)?.join('') : stringValue;
    return typeof numericValue === 'number' ? numericValue : defaultValue;
}
function getAdaptableToolPanelWidth() {
    return getNumericCSSVariableValue(getCSSVariableValue('--ab-cmp-toolpanel__width'), 200);
}
function getSimpleButtonPaddingWidth() {
    return getNumericCSSVariableValue(getCSSVariableValue('--ab-base-space'), 4);
}
function getCSSVariableValue(cssVariable) {
    if (!isBrowserDocumentAvailable()) // possible during static/server-side rendering (should happen only in test cases)
    return undefined;
    return getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
}
function setCSSVariableValue(cssVariable, value) {
    if (!isBrowserDocumentAvailable()) // possible during static/server-side rendering (should happen only in test cases)
    return undefined;
    document.documentElement.style.setProperty(cssVariable, value);
}
function isBrowserDocumentAvailable() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
}
const UIHelper = {
    getHexForName: getHexForName,
    getDefaultColors: getDefaultColors,
    getEmptyConfigState: getEmptyConfigState,
    getDescriptionForDataType: getDescriptionForDataType,
    getPlaceholderForDataType: getPlaceholderForDataType,
    getModalContainer: getModalContainer,
    IsEmptyStyle: IsEmptyStyle,
    IsNotEmptyStyle: IsNotEmptyStyle,
    getMessageTypeByStatusColour: getMessageTypeByStatusColour,
    getGlyphByMessageType: getGlyphByMessageType,
    getButtonToneByMessageType: getButtonToneByMessageType,
    getStyleForStatusColour: getStyleForStatusColour,
    getGlyphForStatusColour: getGlyphForStatusColour,
    getButtonToneForMessageType: getButtonToneForMessageType,
    getScheduleDescription: getScheduleDescription,
    getWeekDayByIndex: getWeekDayByIndex,
    getColorByMessageType: getColorByMessageType,
    getGlyphForMessageType: getGlyphForMessageType,
    getStyleForMessageType: getStyleForMessageType,
    getMessageTypeFromAdaptableAlerts: getMessageTypeFromAdaptableAlerts,
    getCSSColorByMessageType: getCSSColorByMessageType,
    getButtonColourForAdaptableAlerts: getButtonColourForAdaptableAlerts,
    getButtonTextColourForArrayandMessageType: getButtonTextColourForArrayandMessageType,
    getButtonTextColourForMessageType: getButtonTextColourForMessageType,
    getCSSVariableValue: getCSSVariableValue,
    setCSSVariableValue: setCSSVariableValue,
    getAdaptableToolPanelWidth: getAdaptableToolPanelWidth,
    isBrowserDocumentAvailable: isBrowserDocumentAvailable,
    getSimpleButtonPaddingWidth: getSimpleButtonPaddingWidth
};
var $3c4b7cbdc2a84c8b$export$2e2bcd8739ae039 = UIHelper;

});
parcelRegister("4hg7e", function(module, exports) {

$parcel$export(module.exports, "WizardStatus", () => $31d540347e218d28$export$a647958a5ef22c55);
/// <reference path="../../typings/.d.ts" />
var $31d540347e218d28$export$a647958a5ef22c55;
(function(WizardStatus) {
    WizardStatus["New"] = "New";
    WizardStatus["Edit"] = "Edit";
    WizardStatus["None"] = "None";
})($31d540347e218d28$export$a647958a5ef22c55 || ($31d540347e218d28$export$a647958a5ef22c55 = {}));

});

parcelRegister("hrtGQ", function(module, exports) {

$parcel$export(module.exports, "MathOperation", () => $cb2bfd1a3aac0c86$export$20e729fc9aa8bb68);
$parcel$export(module.exports, "ScheduleType", () => $cb2bfd1a3aac0c86$export$38e26ec75b48a88c);
$parcel$export(module.exports, "SortOrder", () => $cb2bfd1a3aac0c86$export$7ae723045d45777a);
$parcel$export(module.exports, "FontWeight", () => $cb2bfd1a3aac0c86$export$1c11f686df781f87);
$parcel$export(module.exports, "FontStyle", () => $cb2bfd1a3aac0c86$export$23b468d4ca3f8c96);
$parcel$export(module.exports, "FontSize", () => $cb2bfd1a3aac0c86$export$80f2abd03de5ca5a);
$parcel$export(module.exports, "StatusColour", () => $cb2bfd1a3aac0c86$export$4fb0f05d0251b011);
$parcel$export(module.exports, "SummaryOperation", () => $cb2bfd1a3aac0c86$export$1638c4388604f16d);
$parcel$export(module.exports, "FilterOnDataChangeOptions", () => $cb2bfd1a3aac0c86$export$980b432a15116ed4);
// General Enums
var $cb2bfd1a3aac0c86$export$20e729fc9aa8bb68;
(function(MathOperation) {
    MathOperation["Add"] = "Add";
    MathOperation["Subtract"] = "Subtract";
    MathOperation["Multiply"] = "Multiply";
    MathOperation["Divide"] = "Divide";
})($cb2bfd1a3aac0c86$export$20e729fc9aa8bb68 || ($cb2bfd1a3aac0c86$export$20e729fc9aa8bb68 = {}));
var $cb2bfd1a3aac0c86$export$38e26ec75b48a88c;
(function(ScheduleType) {
    ScheduleType["Report"] = "Report";
    ScheduleType["ipushpull"] = "ipushpull";
    ScheduleType["Reminder"] = "Reminder";
    ScheduleType["OpenFin"] = "OpenFin";
})($cb2bfd1a3aac0c86$export$38e26ec75b48a88c || ($cb2bfd1a3aac0c86$export$38e26ec75b48a88c = {}));
var $cb2bfd1a3aac0c86$export$7ae723045d45777a;
(function(SortOrder) {
    SortOrder["Asc"] = "Asc";
    SortOrder["Desc"] = "Desc";
})($cb2bfd1a3aac0c86$export$7ae723045d45777a || ($cb2bfd1a3aac0c86$export$7ae723045d45777a = {}));
var $cb2bfd1a3aac0c86$export$91484609d16ec765;
(function(SelectionMode) {
    SelectionMode["Multi"] = "Multi";
    SelectionMode["Single"] = "Single";
})($cb2bfd1a3aac0c86$export$91484609d16ec765 || ($cb2bfd1a3aac0c86$export$91484609d16ec765 = {}));
var $cb2bfd1a3aac0c86$export$1c11f686df781f87;
(function(FontWeight) {
    FontWeight["Normal"] = "Normal";
    FontWeight["Bold"] = "Bold";
})($cb2bfd1a3aac0c86$export$1c11f686df781f87 || ($cb2bfd1a3aac0c86$export$1c11f686df781f87 = {}));
var $cb2bfd1a3aac0c86$export$23b468d4ca3f8c96;
(function(FontStyle) {
    FontStyle["Normal"] = "Normal";
    FontStyle["Italic"] = "Italic";
})($cb2bfd1a3aac0c86$export$23b468d4ca3f8c96 || ($cb2bfd1a3aac0c86$export$23b468d4ca3f8c96 = {}));
var $cb2bfd1a3aac0c86$export$80f2abd03de5ca5a;
(function(FontSize) {
    //  Default = 'Default',
    FontSize["XSmall"] = "XSmall";
    FontSize["Small"] = "Small";
    FontSize["Medium"] = "Medium";
    FontSize["Large"] = "Large";
    FontSize["XLarge"] = "XLarge";
})($cb2bfd1a3aac0c86$export$80f2abd03de5ca5a || ($cb2bfd1a3aac0c86$export$80f2abd03de5ca5a = {}));
var $cb2bfd1a3aac0c86$export$4fb0f05d0251b011;
(function(StatusColour) {
    StatusColour["Error"] = "var(--ab-color-error)";
    StatusColour["Warn"] = "var(--ab-color-warn)";
    StatusColour["Success"] = "var(--ab-color-success)";
    StatusColour["Info"] = "var(--ab-color-info)";
})($cb2bfd1a3aac0c86$export$4fb0f05d0251b011 || ($cb2bfd1a3aac0c86$export$4fb0f05d0251b011 = {}));
var $cb2bfd1a3aac0c86$export$1638c4388604f16d;
(function(SummaryOperation) {
    SummaryOperation["Sum"] = "Sum";
    SummaryOperation["Average"] = "Average";
    SummaryOperation["Median"] = "Median";
    SummaryOperation["Mode"] = "Mode";
    SummaryOperation["Distinct"] = "Distinct";
    SummaryOperation["Max"] = "Max";
    SummaryOperation["Min"] = "Min";
    SummaryOperation["Count"] = "Count";
    SummaryOperation["Std_Deviation"] = "Std Deviation";
    SummaryOperation["Only"] = "Only";
    SummaryOperation["Weighted_Average"] = "Weighted Avg";
})($cb2bfd1a3aac0c86$export$1638c4388604f16d || ($cb2bfd1a3aac0c86$export$1638c4388604f16d = {}));
var $cb2bfd1a3aac0c86$export$980b432a15116ed4;
(function(FilterOnDataChangeOptions) {
    FilterOnDataChangeOptions["Always"] = "Always";
    FilterOnDataChangeOptions["Never"] = "Never";
    FilterOnDataChangeOptions["Throttle"] = "Throttle";
})($cb2bfd1a3aac0c86$export$980b432a15116ed4 || ($cb2bfd1a3aac0c86$export$980b432a15116ed4 = {}));
var $cb2bfd1a3aac0c86$export$c26e08a4c76653db;
(function(ChangeDirection) {
    ChangeDirection["Up"] = "Up";
    ChangeDirection["Down"] = "Down";
    ChangeDirection["Neutral"] = "Neutral";
})($cb2bfd1a3aac0c86$export$c26e08a4c76653db || ($cb2bfd1a3aac0c86$export$c26e08a4c76653db = {}));

});

parcelRegister("9OAZF", function(module, exports) {

$parcel$export(module.exports, "IsNullOrEmpty", () => $72557abfe5fc53e9$export$b026abb20816d8bb);
$parcel$export(module.exports, "IsNotNullOrEmpty", () => $72557abfe5fc53e9$export$b63b0b2df67dcaec);
$parcel$export(module.exports, "IsNullOrEmptyOrWhiteSpace", () => $72557abfe5fc53e9$export$fed51d8f7ced96d5);
$parcel$export(module.exports, "IsNotNullOrEmptyOrWhiteSpace", () => $72557abfe5fc53e9$export$5a98ec5760b03c64);
$parcel$export(module.exports, "CapitaliseFirstLetter", () => $72557abfe5fc53e9$export$bc983745c151c024);
$parcel$export(module.exports, "Humanize", () => $72557abfe5fc53e9$export$d55444718f2d314c);
$parcel$export(module.exports, "StringExtensions", () => $72557abfe5fc53e9$export$b206acfc2391d598);
$parcel$export(module.exports, "default", () => $72557abfe5fc53e9$export$2e2bcd8739ae039);

var $eUgui = parcelRequire("eUgui");
function $72557abfe5fc53e9$export$dc16d859efbf6a80(stringToCheck) {
    return stringToCheck == null || stringToCheck == undefined;
}
function $72557abfe5fc53e9$export$81ea6049dc516d3a(stringToCheck) {
    return !$72557abfe5fc53e9$export$dc16d859efbf6a80(stringToCheck);
}
function $72557abfe5fc53e9$export$2e0cb3e383d455e0(stringToCheck) {
    return stringToCheck === '';
}
function $72557abfe5fc53e9$export$569a6a4825184dfc(stringToCheck) {
    return !$72557abfe5fc53e9$export$2e0cb3e383d455e0(stringToCheck);
}
function $72557abfe5fc53e9$export$b026abb20816d8bb(stringToCheck) {
    return $72557abfe5fc53e9$export$dc16d859efbf6a80(stringToCheck) || $72557abfe5fc53e9$export$2e0cb3e383d455e0(stringToCheck);
}
function $72557abfe5fc53e9$export$b63b0b2df67dcaec(stringToCheck) {
    return !$72557abfe5fc53e9$export$b026abb20816d8bb(stringToCheck);
}
function $72557abfe5fc53e9$export$fed51d8f7ced96d5(stringToCheck) {
    return $72557abfe5fc53e9$export$b026abb20816d8bb(stringToCheck) || $72557abfe5fc53e9$export$2e0cb3e383d455e0(stringToCheck?.trim());
}
function $72557abfe5fc53e9$export$5a98ec5760b03c64(stringToCheck) {
    return !$72557abfe5fc53e9$export$fed51d8f7ced96d5(stringToCheck);
}
function $72557abfe5fc53e9$export$e351d6b90d48aaf5(camelCase) {
    if (!camelCase || camelCase == null) return null;
    // either split on a lowercase followed by uppercase ie  asHereTo -> as Here To
    const rex = /([a-z])([A-Z])/g;
    // or starts with uppercase and we take all expect the last which is assumed to be part of next word if followed by lowercase HEREToThere -> HERE To There
    const rexCaps = /([A-Z]+)([A-Z])([a-z])/g;
    const words = camelCase.replace(rex, '$1 $2').replace(rexCaps, '$1 $2$3').replace(/\./g, ' ').split(' ');
    return words.map((word)=>word.substring(0, 1).toUpperCase() + (word.length > 1 ? word.substring(1, word.length) : '')).join(' ');
}
function $72557abfe5fc53e9$export$667871b8f9eaea85(stringToCheck) {
    return stringToCheck.replace(/,\s*$/, '');
}
function $72557abfe5fc53e9$export$65aa409c6ad2ce34(stringToCheck) {
    return $72557abfe5fc53e9$export$b026abb20816d8bb(stringToCheck) ? stringToCheck : stringToCheck.toLowerCase();
}
function $72557abfe5fc53e9$export$874c480dbba767e5(stringToCheck, valueToCheck) {
    return stringToCheck.includes(valueToCheck);
}
function $72557abfe5fc53e9$export$41e94e71a9e6b09f(stringToCheck, valueToCheck) {
    return !$72557abfe5fc53e9$export$874c480dbba767e5(stringToCheck, valueToCheck);
}
function $72557abfe5fc53e9$export$696e10649b0673cc(stringToAbbreviate, maxLength) {
    return stringToAbbreviate.length < maxLength ? stringToAbbreviate : stringToAbbreviate.substr(0, maxLength) + '...';
}
function $72557abfe5fc53e9$export$bc983745c151c024(str) {
    return `${str.charAt(0).toUpperCase()}${str.substring(1)}`;
}
function $72557abfe5fc53e9$export$d55444718f2d314c(str) {
    return (0, $eUgui.default)(str);
}
function $72557abfe5fc53e9$export$4c145fb628057f79(str = '') {
    return str.replace(/ /g, '_');
}
function $72557abfe5fc53e9$export$4d926b029fa61cfe(str) {
    if (typeof str !== 'string') return false;
    return !isNaN(parseFloat(str));
}
function $72557abfe5fc53e9$export$56ecf446e217435a(str) {
    if (!str || typeof str !== 'string') return str;
    let preparedStr = str;
    const map = [
        {
            target: /&apos;|&#39;/gi,
            replacement: "'"
        },
        {
            target: /&quot;|&#34;/gi,
            replacement: '"'
        },
        {
            target: /&amp;|&#38;/gi,
            replacement: '&'
        },
        {
            target: /&lt;|&#60;/gi,
            replacement: '<'
        },
        {
            target: /&gt;|&#62;/gi,
            replacement: '>'
        },
        {
            target: /&nbsp;|&#160;/gi,
            replacement: ' '
        }
    ];
    for (const transform of map)preparedStr = preparedStr.replace(transform.target, transform.replacement);
    return preparedStr;
}
function $72557abfe5fc53e9$export$bb1204090f5a974c(str, searchTerm, replacement) {
    // Find the index of the last occurrence of the search string
    const lastIndex = str.lastIndexOf(searchTerm);
    // If the string is not found, return the original string
    if (lastIndex === -1) return str;
    // Slice the string into two parts: before and after the last occurrence
    const partBeforeLast = str.slice(0, lastIndex);
    const partAfterLast = str.slice(lastIndex);
    // Replace all occurrences in the first part
    const replacedPart = partBeforeLast.replaceAll(searchTerm, replacement);
    // Recombine the modified first part with the untouched second part
    return replacedPart + partAfterLast;
}
const $72557abfe5fc53e9$export$b206acfc2391d598 = {
    IsNull: $72557abfe5fc53e9$export$dc16d859efbf6a80,
    IsNotNull: $72557abfe5fc53e9$export$81ea6049dc516d3a,
    IsEmpty: $72557abfe5fc53e9$export$2e0cb3e383d455e0,
    IsNotEmpty: $72557abfe5fc53e9$export$569a6a4825184dfc,
    IsNullOrEmpty: $72557abfe5fc53e9$export$b026abb20816d8bb,
    IsNotNullOrEmpty: $72557abfe5fc53e9$export$b63b0b2df67dcaec,
    IsNullOrEmptyOrWhiteSpace: $72557abfe5fc53e9$export$fed51d8f7ced96d5,
    IsNotNullOrEmptyOrWhiteSpace: $72557abfe5fc53e9$export$5a98ec5760b03c64,
    CamelCaseToHumanText: $72557abfe5fc53e9$export$e351d6b90d48aaf5,
    RemoveTrailingComma: $72557abfe5fc53e9$export$667871b8f9eaea85,
    ToLowerCase: $72557abfe5fc53e9$export$65aa409c6ad2ce34,
    Includes: $72557abfe5fc53e9$export$874c480dbba767e5,
    NotIncludes: $72557abfe5fc53e9$export$41e94e71a9e6b09f,
    AbbreviateString: $72557abfe5fc53e9$export$696e10649b0673cc,
    CapitaliseFirstLetter: $72557abfe5fc53e9$export$bc983745c151c024,
    Humanize: $72557abfe5fc53e9$export$d55444718f2d314c,
    ReplaceEmptySpacesWithUnderscore: $72557abfe5fc53e9$export$4c145fb628057f79,
    IsNumeric: $72557abfe5fc53e9$export$4d926b029fa61cfe,
    UnescapeHtmlEntities: $72557abfe5fc53e9$export$56ecf446e217435a,
    ReplaceAllOccurencesExceptLastOne: $72557abfe5fc53e9$export$bb1204090f5a974c
};
var $72557abfe5fc53e9$export$2e2bcd8739ae039 = $72557abfe5fc53e9$export$b206acfc2391d598;

});
parcelRegister("eUgui", function(module, exports) {

$parcel$export(module.exports, "default", () => $ada315bf759e2a24$export$2e2bcd8739ae039);
/**
 * Converts string to Start Case.
 * Drop-in replacement for lodash/startCase.
 */ 
var $9CW7w = parcelRequire("9CW7w");
function $ada315bf759e2a24$var$capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
function $ada315bf759e2a24$export$2e2bcd8739ae039(string) {
    return (0, $9CW7w.default)(string).map($ada315bf759e2a24$var$capitalize).join(' ');
}

});
parcelRegister("9CW7w", function(module, exports) {

$parcel$export(module.exports, "default", () => $7024bf294037296e$export$2e2bcd8739ae039);
/**
 * Split a string into words: handles camelCase, PascalCase, UPPER_CASE,
 * UPPER_SNAKE_CASE, snake_case, kebab-case, spaces, and dot.notation.
 *
 * Shared helper used by kebabCase, startCase, and sentenceCase.
 */ function $7024bf294037296e$export$2e2bcd8739ae039(str) {
    const matches = str.match(/[A-Z]?[a-z]+|[A-Z]+(?=[A-Z][a-z]|\d|$|[^a-zA-Z0-9])|[A-Z]|[0-9]+/g);
    return matches || [];
}

});



parcelRegister("9g4SS", function(module, exports) {

$parcel$export(module.exports, "areArraysEqual", () => $6bd965929cd0f08b$export$94fd53d40f0652a);
$parcel$export(module.exports, "getGenericComparatorForGridCell", () => $6bd965929cd0f08b$export$f895358ab99dd930);
$parcel$export(module.exports, "sortCellValueArray", () => $6bd965929cd0f08b$export$8d09ffc8cc1c21be);
$parcel$export(module.exports, "getNumericComparatorForGridCell", () => $6bd965929cd0f08b$export$a24e513bb247d57c);
$parcel$export(module.exports, "sortCellValueArrayNumeric", () => $6bd965929cd0f08b$export$26c2ca9be142187f);
$parcel$export(module.exports, "getDateComparatorForGridCell", () => $6bd965929cd0f08b$export$76fbe1e454ab193b);
$parcel$export(module.exports, "sortCellValueArrayDates", () => $6bd965929cd0f08b$export$e4b1d0840bbeb4d6);
$parcel$export(module.exports, "SumArray", () => $6bd965929cd0f08b$export$26ee18eb42106f05);
$parcel$export(module.exports, "ArrayExtensions", () => $6bd965929cd0f08b$export$27cd59af48d4b51c);
$parcel$export(module.exports, "default", () => $6bd965929cd0f08b$export$2e2bcd8739ae039);

var $hrtGQ = parcelRequire("hrtGQ");
function $6bd965929cd0f08b$export$ebf490c37943e0a9(arrayToCheck) {
    return $6bd965929cd0f08b$export$81ea6049dc516d3a(arrayToCheck) ? arrayToCheck.length : 0;
}
function $6bd965929cd0f08b$export$afd7e66be2b1a19a(arrayToCheck, requiredLength) {
    return $6bd965929cd0f08b$export$ebf490c37943e0a9(arrayToCheck) == requiredLength;
}
function $6bd965929cd0f08b$export$1ec07190e3e0076f(arrayToCheck, requiredLength) {
    return !$6bd965929cd0f08b$export$afd7e66be2b1a19a(arrayToCheck, requiredLength);
}
function $6bd965929cd0f08b$export$996d6d982dac0ef7(array, itemToAdd) {
    if ($6bd965929cd0f08b$export$f55d13254d2b8543(array, itemToAdd)) array.push(itemToAdd);
}
function $6bd965929cd0f08b$export$3e42880db42adfe7(array, itemToCheck) {
    if (array == null) return false;
    return array.indexOf(itemToCheck) > -1;
}
function $6bd965929cd0f08b$export$78a456bb315a519e(array, itemsToCheck) {
    if (array == null) return false;
    let foundItem = false;
    itemsToCheck.forEach((item)=>{
        if (!foundItem) {
            if ($6bd965929cd0f08b$export$3e42880db42adfe7(array, item)) foundItem = true;
        }
    });
    return foundItem;
}
function $6bd965929cd0f08b$export$f55d13254d2b8543(array, itemToCheck) {
    return !$6bd965929cd0f08b$export$3e42880db42adfe7(array, itemToCheck);
}
function $6bd965929cd0f08b$export$d6e9a41973548da7(array) {
    return Array.from(new Set(array.map((item)=>item)));
}
function $6bd965929cd0f08b$export$dc16d859efbf6a80(arrayToCheck) {
    return arrayToCheck == null || arrayToCheck == undefined;
}
function $6bd965929cd0f08b$export$81ea6049dc516d3a(arrayToCheck) {
    return !$6bd965929cd0f08b$export$dc16d859efbf6a80(arrayToCheck);
}
function $6bd965929cd0f08b$export$2e0cb3e383d455e0(arrayToCheck) {
    return arrayToCheck?.length == 0;
}
function $6bd965929cd0f08b$export$569a6a4825184dfc(arrayToCheck) {
    return !$6bd965929cd0f08b$export$2e0cb3e383d455e0(arrayToCheck);
}
function $6bd965929cd0f08b$export$b026abb20816d8bb(arrayToCheck) {
    return $6bd965929cd0f08b$export$dc16d859efbf6a80(arrayToCheck) || $6bd965929cd0f08b$export$2e0cb3e383d455e0(arrayToCheck);
}
function $6bd965929cd0f08b$export$b63b0b2df67dcaec(arrayToCheck) {
    return $6bd965929cd0f08b$export$81ea6049dc516d3a(arrayToCheck) && $6bd965929cd0f08b$export$569a6a4825184dfc(arrayToCheck);
}
function $6bd965929cd0f08b$export$c89dc8dc76062a14(arrayToCheck) {
    if ($6bd965929cd0f08b$export$b026abb20816d8bb(arrayToCheck)) return true;
    if ($6bd965929cd0f08b$export$7f48a69c85549d95(arrayToCheck)) return true;
    return false;
}
function $6bd965929cd0f08b$export$5c6c1bed8402d474(arrayToCheck) {
    return !$6bd965929cd0f08b$export$c89dc8dc76062a14(arrayToCheck);
}
function $6bd965929cd0f08b$export$7f48a69c85549d95(arrayToCheck) {
    if (arrayToCheck.length == 1 && arrayToCheck[0] == '') return true;
    return false;
}
function $6bd965929cd0f08b$export$8a70528033dc3b2c(arrayToCheck, valueToCheck) {
    var count = 0;
    arrayToCheck.forEach((v)=>v === valueToCheck && count++);
    return count;
}
function $6bd965929cd0f08b$export$1e0f7094a1b0ce0b(arrayToCheck) {
    return $6bd965929cd0f08b$export$e461f0ef064ee2b5(arrayToCheck, 1);
}
function $6bd965929cd0f08b$export$e461f0ef064ee2b5(arrayToCheck, numberOfItems) {
    return arrayToCheck.length == numberOfItems;
}
function $6bd965929cd0f08b$export$2f3f9678178e797c(array, from, to) {
    array.splice(to, 0, array.splice(from, 1)[0]);
}
function $6bd965929cd0f08b$export$94fd53d40f0652a(arr1, arr2) {
    if ($6bd965929cd0f08b$export$b026abb20816d8bb(arr1) && $6bd965929cd0f08b$export$b63b0b2df67dcaec(arr2)) return false;
    if ($6bd965929cd0f08b$export$b63b0b2df67dcaec(arr1) && $6bd965929cd0f08b$export$b026abb20816d8bb(arr2)) return false;
    if (arr1.length !== arr2.length) return false;
    return arr1.every((x)=>arr2.indexOf(x) != -1);
}
function $6bd965929cd0f08b$export$c6875d85a1a86b1a(arr1, arr2) {
    return !$6bd965929cd0f08b$export$94fd53d40f0652a(arr1, arr2);
}
function $6bd965929cd0f08b$export$d17fca2021919989(arr1, arr2) {
    if (arr1 == null) return true;
    if (arr1.length !== arr2.length) return false;
    return arr1.every((x, index)=>arr2.indexOf(x) == index);
}
function $6bd965929cd0f08b$export$762ea21d0711ab2c(arr1, arr2, equalityFn) {
    // Handle null/undefined cases
    if (!arr1 && !arr2) return true;
    if (!arr1 || !arr2) return false;
    // Check length
    if (arr1.length !== arr2.length) return false;
    // Use default equality comparison if no custom function provided
    const compareElements = equalityFn || ((a, b)=>a === b);
    // For each element in arr1, find a matching element in arr2
    const arr2Copy = [
        ...arr2
    ];
    for(let i = 0; i < arr1.length; i++){
        const element = arr1[i];
        const matchIndex = arr2Copy.findIndex((el)=>compareElements(element, el));
        if (matchIndex === -1) return false;
        // Remove the matched element to prevent duplicate matches
        arr2Copy.splice(matchIndex, 1);
    }
    return true;
}
function $6bd965929cd0f08b$export$7e2fabb39d37734d(value, other) {
    const type = Object.prototype.toString.call(value);
    // If the two objects are not the same type, return false
    if (type !== Object.prototype.toString.call(other)) return false;
    // If items are not an object or array, return false
    if ([
        '[object Array]',
        '[object Object]'
    ].indexOf(type) < 0) return false;
    // Compare the length of the length of the two items
    const valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
    const otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) return false;
    // Compare two items
    const compare = function(item1, item2) {
        // Get the object type
        const itemType = Object.prototype.toString.call(item1);
        // If an object or array, compare recursively
        if ([
            '[object Array]',
            '[object Object]'
        ].indexOf(itemType) >= 0) {
            if (!$6bd965929cd0f08b$export$7e2fabb39d37734d(item1, item2)) return false;
        } else {
            // If the two items are not the same type, return false
            if (itemType !== Object.prototype.toString.call(item2)) return false;
            // Else if it's a function, convert to a string and compare
            // Otherwise, just compare
            if (itemType === '[object Function]') {
                if (item1.toString() !== item2.toString()) return false;
            } else {
                if (item1 !== item2) return false;
            }
        }
    };
    // Compare properties
    if (type === '[object Array]') for(let i = 0; i < valueLen; i++){
        if (compare(value[i], other[i]) === false) return false;
    }
    else {
        for(let key in value)if (value.hasOwnProperty(key)) {
            if (compare(value[key], other[key]) === false) return false;
        }
    }
    // If nothing failed, return true
    return true;
}
function $6bd965929cd0f08b$export$6fb08a1d2f8e9aa9(sortOrder, values, sortProperty) {
    if (sortProperty) {
        let newValues = [].concat(values);
        let direction = 1;
        if (sortOrder == (0, $hrtGQ.SortOrder).Desc) direction = -1;
        return newValues.sort((a, b)=>{
            let aSortProperty = a[sortProperty];
            let bSortProperty = b[sortProperty];
            if (typeof aSortProperty == 'string' && typeof bSortProperty == 'string') return aSortProperty.localeCompare(bSortProperty) * direction;
            else return aSortProperty < bSortProperty ? -1 * direction : aSortProperty > bSortProperty ? 1 * direction : 0;
        });
    } else return $6bd965929cd0f08b$export$92f26f2c62c5b941(values, sortOrder);
}
function $6bd965929cd0f08b$export$92f26f2c62c5b941(values, sortOrder = (0, $hrtGQ.SortOrder).Asc) {
    const newValues = [].concat(values);
    const direction = sortOrder == (0, $hrtGQ.SortOrder).Asc ? 1 : -1;
    return newValues.sort((a, b)=>a < b ? -1 * direction : a > b ? 1 * direction : 0);
}
const $6bd965929cd0f08b$export$f895358ab99dd930 = (sortOrder)=>{
    const direction = sortOrder == (0, $hrtGQ.SortOrder).Asc ? 1 : -1;
    return (a, b)=>{
        return a.rawValue < b.rawValue ? -1 * direction : a.rawValue > b.rawValue ? 1 * direction : 0;
    };
};
function $6bd965929cd0f08b$export$8d09ffc8cc1c21be(cellValues, sortOrder = (0, $hrtGQ.SortOrder).Asc) {
    const newValues = [].concat(cellValues);
    const comparator = $6bd965929cd0f08b$export$f895358ab99dd930(sortOrder);
    return newValues.sort(comparator);
}
const $6bd965929cd0f08b$export$a24e513bb247d57c = (sortOrder)=>{
    const direction = sortOrder == (0, $hrtGQ.SortOrder).Asc ? 1 : -1;
    return (a, b)=>{
        const valueAAsNumber = Number(a.rawValue);
        const valueBAsNumber = Number(b.rawValue);
        if (isNaN(valueAAsNumber)) return 0;
        if (isNaN(valueBAsNumber)) return 0;
        return valueAAsNumber < valueBAsNumber ? -1 * direction : valueAAsNumber > valueBAsNumber ? 1 * direction : 0;
    };
};
function $6bd965929cd0f08b$export$26c2ca9be142187f(cellValues, sortOrder = (0, $hrtGQ.SortOrder).Asc) {
    const newValues = [].concat(cellValues);
    const comparator = $6bd965929cd0f08b$export$a24e513bb247d57c(sortOrder);
    return newValues.sort(comparator);
}
const $6bd965929cd0f08b$export$76fbe1e454ab193b = (sortOrder)=>{
    return (a, b)=>{
        return sortOrder == (0, $hrtGQ.SortOrder).Asc ? +new Date(a.rawValue) - +new Date(b.rawValue) : +new Date(b.rawValue) - +new Date(a.rawValue);
    };
};
function $6bd965929cd0f08b$export$e4b1d0840bbeb4d6(cellValues, sortOrder = (0, $hrtGQ.SortOrder).Asc) {
    const comparator = $6bd965929cd0f08b$export$76fbe1e454ab193b(sortOrder);
    return [].concat(cellValues).sort(comparator);
}
function $6bd965929cd0f08b$export$2575ebeb99ad8c68(array, prop) {
    return array.reduce((acc, item)=>{
        let key = item[prop];
        acc[key] = acc[key] || [];
        acc[key].push(item);
        return acc;
    }, {});
}
function $6bd965929cd0f08b$export$51767bbd4adc6e5(values) {
    return values.join(', ');
}
function $6bd965929cd0f08b$export$26ee18eb42106f05(array) {
    return array.filter((num)=>typeof num === 'number' && !isNaN(num)).reduce((a, b)=>a + b, 0);
}
function $6bd965929cd0f08b$export$e76ffa2153e00a15(array, startIndex, endIndex) {
    const result = [
        ...array
    ];
    if (startIndex > array.length - 1) // not much that we can do if the dragged item is out of bounds...
    return result;
    if (endIndex > array.length - 1) endIndex = array.length - 1;
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}
function $6bd965929cd0f08b$export$2d46862c7dd470cd(array, order, /**
 *
 * The array can contain items which are not listed in the order array.
 * So sortUnorderedItems decides whether to leave these items untouched
 * in the current order in which they are in the array (sortUnorderedItems: false)
 * or to sort them using normal comparison rules
 */ { sortUnorderedItems: sortUnorderedItems }) {
    const itemsToIndex = array.reduce((acc, x, i)=>{
        acc.set(x, i);
        return acc;
    }, new Map());
    const orderItemsToIndex = order.reduce((acc, x, i)=>{
        acc.set(x, i);
        return acc;
    }, new Map());
    function compareItemsOfCustomSort(valueA, valueB) {
        const orderContainsFirstElement = orderItemsToIndex.has(valueA);
        const indexInOrderOfFirstElement = orderContainsFirstElement ? orderItemsToIndex.get(valueA) : -1;
        const orderContainsSecondElement = orderItemsToIndex.has(valueB);
        const indexInOrderSecondElement = orderContainsSecondElement ? orderItemsToIndex.get(valueB) : -1;
        //if none of the element are in the order list we just return normal compare
        if (!orderContainsFirstElement && !orderContainsSecondElement) {
            if (!sortUnorderedItems) // keep the original order
            return itemsToIndex.get(valueA) - itemsToIndex.get(valueB);
            if (valueA == valueB) return 0;
            return valueA < valueB ? -1 : 1;
        }
        //if first item not in the list make sure we put it after the second item
        if (!orderContainsFirstElement) return 1;
        //if second item not in the list make sure we put it after the first item
        if (!orderContainsSecondElement) return -1;
        //return the comparison from the list if the two items are in the list
        return indexInOrderOfFirstElement - indexInOrderSecondElement;
    }
    return [].concat(array).sort(compareItemsOfCustomSort);
}
const $6bd965929cd0f08b$export$27cd59af48d4b51c = {
    GetLength: $6bd965929cd0f08b$export$ebf490c37943e0a9,
    CorrectLength: $6bd965929cd0f08b$export$afd7e66be2b1a19a,
    NotCorrectLength: $6bd965929cd0f08b$export$1ec07190e3e0076f,
    groupArrayBy: $6bd965929cd0f08b$export$2575ebeb99ad8c68,
    AddItem: $6bd965929cd0f08b$export$996d6d982dac0ef7,
    ContainsItem: $6bd965929cd0f08b$export$3e42880db42adfe7,
    NotContainsItem: $6bd965929cd0f08b$export$f55d13254d2b8543,
    ContainsAnyItem: $6bd965929cd0f08b$export$78a456bb315a519e,
    RetrieveDistinct: $6bd965929cd0f08b$export$d6e9a41973548da7,
    IsNull: $6bd965929cd0f08b$export$dc16d859efbf6a80,
    IsNotNull: $6bd965929cd0f08b$export$81ea6049dc516d3a,
    IsEmpty: $6bd965929cd0f08b$export$2e0cb3e383d455e0,
    IsNotEmpty: $6bd965929cd0f08b$export$569a6a4825184dfc,
    IsNullOrEmpty: $6bd965929cd0f08b$export$b026abb20816d8bb,
    IsNotNullOrEmpty: $6bd965929cd0f08b$export$b63b0b2df67dcaec,
    IsNullOrEmptyOrContainsSingleEmptyValue: $6bd965929cd0f08b$export$c89dc8dc76062a14,
    IsNotNullOrEmptyNorContainsSingleEmptyValue: $6bd965929cd0f08b$export$5c6c1bed8402d474,
    HasSingleEmptyValue: $6bd965929cd0f08b$export$7f48a69c85549d95,
    getOccurrence: $6bd965929cd0f08b$export$8a70528033dc3b2c,
    hasOneItem: $6bd965929cd0f08b$export$1e0f7094a1b0ce0b,
    hasItemsOfCount: $6bd965929cd0f08b$export$e461f0ef064ee2b5,
    moveArray: $6bd965929cd0f08b$export$2f3f9678178e797c,
    areArraysEqual: $6bd965929cd0f08b$export$94fd53d40f0652a,
    areArraysNotEqual: $6bd965929cd0f08b$export$c6875d85a1a86b1a,
    areArraysEqualWithOrder: $6bd965929cd0f08b$export$d17fca2021919989,
    areArraysEqualWithOrderAndProperties: $6bd965929cd0f08b$export$7e2fabb39d37734d,
    areArraysEqualWithCustomComparator: $6bd965929cd0f08b$export$762ea21d0711ab2c,
    sortArray: $6bd965929cd0f08b$export$92f26f2c62c5b941,
    sortCellValueArray: $6bd965929cd0f08b$export$8d09ffc8cc1c21be,
    sortCellValueArrayNumeric: $6bd965929cd0f08b$export$26c2ca9be142187f,
    sortCellValueArrayDates: $6bd965929cd0f08b$export$e4b1d0840bbeb4d6,
    sortArrayWithProperty: $6bd965929cd0f08b$export$6fb08a1d2f8e9aa9,
    createCommaSeparatedString: $6bd965929cd0f08b$export$51767bbd4adc6e5,
    SumArray: $6bd965929cd0f08b$export$26ee18eb42106f05,
    reorderArray: $6bd965929cd0f08b$export$e76ffa2153e00a15,
    sortArrayWithOrder: $6bd965929cd0f08b$export$2d46862c7dd470cd
};
var $6bd965929cd0f08b$export$2e2bcd8739ae039 = $6bd965929cd0f08b$export$27cd59af48d4b51c;

});

parcelRegister("9AsCL", function(module, exports) {

$parcel$export(module.exports, "resolveContainerElement", () => $6fadae01d4cb62e6$export$7dbfd549a0835fc3);
/**
 * Resolves a container option value to an `HTMLElement`.
 *
 * Resolution order:
 * 1. If `container` is `null`/`undefined`, returns `null`.
 * 2. If `container` is a function, it is called with the provided `context` and the result is resolved.
 * 3. If the value is an `HTMLElement`, it is returned directly.
 * 4. If the value is an `AdaptableCSSSelector` (`{ selector: string }`), `document.querySelectorAll` is used.
 *    If multiple elements match, the first is returned and a console warning is logged.
 * 5. If the value is a `string`, it is treated as an element ID and `document.getElementById` is used.
 *
 * @param container - The container reference to resolve.
 * @param context - Optional context passed to the function form of the container.
 * @param doc - The document to query against (defaults to `globalThis.document`).
 * @returns The resolved `HTMLElement`, or `null` if not found.
 */ function $6fadae01d4cb62e6$export$7dbfd549a0835fc3(container, context, doc = globalThis.document) {
    if (container == null) return null;
    // Unwrap function form — pass context if the container is a function
    const value = typeof container === 'function' ? container(context) : container;
    // Guard against null/undefined returned by a callback (e.g. document.getElementById(...))
    if (value == null) return null;
    // Direct HTMLElement reference
    if (value instanceof HTMLElement) return value;
    // CSS Selector object
    if (typeof value === 'object' && 'selector' in value) {
        const matches = doc.querySelectorAll(value.selector);
        if (matches.length > 1) console.warn(`[AdapTable] CSS selector "${value.selector}" matched ${matches.length} elements. Using the first match. Consider using a more specific selector.`);
        return matches[0] ?? null;
    }
    // String element ID
    if (typeof value === 'string') return doc.getElementById(value);
    return null;
}

});


parcelRegister("8m4NT", function(module, exports) {

$parcel$export(module.exports, "renderToStaticMarkup", () => $61541ab712b0f8a9$export$eb3a06aef9e6ee51, (v) => $61541ab712b0f8a9$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToString", () => $61541ab712b0f8a9$export$80e7718417253a51, (v) => $61541ab712b0f8a9$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $61541ab712b0f8a9$export$83d89fbfd8236492, (v) => $61541ab712b0f8a9$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*


 JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)

 Copyright (c) 2011 Gary Court
 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
*/ var $61541ab712b0f8a9$export$eb3a06aef9e6ee51;
var $61541ab712b0f8a9$export$80e7718417253a51;
var $61541ab712b0f8a9$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $61541ab712b0f8a9$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $61541ab712b0f8a9$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $61541ab712b0f8a9$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $61541ab712b0f8a9$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $61541ab712b0f8a9$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $61541ab712b0f8a9$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $61541ab712b0f8a9$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $61541ab712b0f8a9$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $61541ab712b0f8a9$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $61541ab712b0f8a9$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $61541ab712b0f8a9$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $61541ab712b0f8a9$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $61541ab712b0f8a9$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $61541ab712b0f8a9$var$REACT_SCOPE_TYPE = Symbol.for("react.scope"), $61541ab712b0f8a9$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $61541ab712b0f8a9$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden"), $61541ab712b0f8a9$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $61541ab712b0f8a9$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $61541ab712b0f8a9$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $61541ab712b0f8a9$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $61541ab712b0f8a9$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$61541ab712b0f8a9$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $61541ab712b0f8a9$var$isArrayImpl = Array.isArray;
function $61541ab712b0f8a9$var$murmurhash3_32_gc(key, seed) {
    var remainder = key.length & 3;
    var bytes = key.length - remainder;
    var h1 = seed;
    for(seed = 0; seed < bytes;){
        var k1 = key.charCodeAt(seed) & 255 | (key.charCodeAt(++seed) & 255) << 8 | (key.charCodeAt(++seed) & 255) << 16 | (key.charCodeAt(++seed) & 255) << 24;
        ++seed;
        k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295;
        k1 = k1 << 15 | k1 >>> 17;
        k1 = 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
        h1 ^= k1;
        h1 = h1 << 13 | h1 >>> 19;
        h1 = 5 * (h1 & 65535) + ((5 * (h1 >>> 16) & 65535) << 16) & 4294967295;
        h1 = (h1 & 65535) + 27492 + (((h1 >>> 16) + 58964 & 65535) << 16);
    }
    k1 = 0;
    switch(remainder){
        case 3:
            k1 ^= (key.charCodeAt(seed + 2) & 255) << 16;
        case 2:
            k1 ^= (key.charCodeAt(seed + 1) & 255) << 8;
        case 1:
            k1 ^= key.charCodeAt(seed) & 255, k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295, k1 = k1 << 15 | k1 >>> 17, h1 ^= 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
    }
    h1 ^= key.length;
    h1 ^= h1 >>> 16;
    h1 = 2246822507 * (h1 & 65535) + ((2246822507 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    h1 ^= h1 >>> 13;
    h1 = 3266489909 * (h1 & 65535) + ((3266489909 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    return (h1 ^ h1 >>> 16) >>> 0;
}
var $61541ab712b0f8a9$var$assign = Object.assign, $61541ab712b0f8a9$var$hasOwnProperty = Object.prototype.hasOwnProperty, $61541ab712b0f8a9$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $61541ab712b0f8a9$var$illegalAttributeNameCache = {}, $61541ab712b0f8a9$var$validatedAttributeNameCache = {};
function $61541ab712b0f8a9$var$isAttributeNameSafe(attributeName) {
    if ($61541ab712b0f8a9$var$hasOwnProperty.call($61541ab712b0f8a9$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($61541ab712b0f8a9$var$hasOwnProperty.call($61541ab712b0f8a9$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($61541ab712b0f8a9$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $61541ab712b0f8a9$var$validatedAttributeNameCache[attributeName] = !0;
    $61541ab712b0f8a9$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $61541ab712b0f8a9$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), $61541ab712b0f8a9$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $61541ab712b0f8a9$var$matchHtmlRegExp = /["'&<>]/;
function $61541ab712b0f8a9$var$escapeTextForBrowser(text) {
    if ("boolean" === typeof text || "number" === typeof text || "bigint" === typeof text) return "" + text;
    text = "" + text;
    var match = $61541ab712b0f8a9$var$matchHtmlRegExp.exec(text);
    if (match) {
        var html = "", index, lastIndex = 0;
        for(index = match.index; index < text.length; index++){
            switch(text.charCodeAt(index)){
                case 34:
                    match = "&quot;";
                    break;
                case 38:
                    match = "&amp;";
                    break;
                case 39:
                    match = "&#x27;";
                    break;
                case 60:
                    match = "&lt;";
                    break;
                case 62:
                    match = "&gt;";
                    break;
                default:
                    continue;
            }
            lastIndex !== index && (html += text.slice(lastIndex, index));
            lastIndex = index + 1;
            html += match;
        }
        text = lastIndex !== index ? html + text.slice(lastIndex, index) : html;
    }
    return text;
}
var $61541ab712b0f8a9$var$uppercasePattern = /([A-Z])/g, $61541ab712b0f8a9$var$msPattern = /^ms-/, $61541ab712b0f8a9$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $61541ab712b0f8a9$var$sanitizeURL(url) {
    return $61541ab712b0f8a9$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $61541ab712b0f8a9$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $61541ab712b0f8a9$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $61541ab712b0f8a9$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $61541ab712b0f8a9$var$previousDispatcher = $61541ab712b0f8a9$var$ReactDOMSharedInternals.d;
$61541ab712b0f8a9$var$ReactDOMSharedInternals.d = {
    f: $61541ab712b0f8a9$var$previousDispatcher.f,
    r: $61541ab712b0f8a9$var$previousDispatcher.r,
    D: $61541ab712b0f8a9$var$prefetchDNS,
    C: $61541ab712b0f8a9$var$preconnect,
    L: $61541ab712b0f8a9$var$preload,
    m: $61541ab712b0f8a9$var$preloadModule,
    X: $61541ab712b0f8a9$var$preinitScript,
    S: $61541ab712b0f8a9$var$preinitStyle,
    M: $61541ab712b0f8a9$var$preinitModuleScript
};
var $61541ab712b0f8a9$var$PRELOAD_NO_CREDS = [], $61541ab712b0f8a9$var$currentlyFlushingRenderState = null, $61541ab712b0f8a9$var$scriptRegex = /(<\/|<)(s)(cript)/gi;
function $61541ab712b0f8a9$var$scriptReplacer(match, prefix, s, suffix) {
    return "" + prefix + ("s" === s ? "\\u0073" : "\\u0053") + suffix;
}
function $61541ab712b0f8a9$var$createResumableState(identifierPrefix, externalRuntimeConfig, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
    return {
        idPrefix: void 0 === identifierPrefix ? "" : identifierPrefix,
        nextFormID: 0,
        streamingFormat: 0,
        bootstrapScriptContent: bootstrapScriptContent,
        bootstrapScripts: bootstrapScripts,
        bootstrapModules: bootstrapModules,
        instructions: 0,
        hasBody: !1,
        hasHtml: !1,
        unknownResources: {},
        dnsResources: {},
        connectResources: {
            default: {},
            anonymous: {},
            credentials: {}
        },
        imageResources: {},
        styleResources: {},
        scriptResources: {},
        moduleUnknownResources: {},
        moduleScriptResources: {}
    };
}
function $61541ab712b0f8a9$var$createFormatContext(insertionMode, selectedValue, tagScope, viewTransition) {
    return {
        insertionMode: insertionMode,
        selectedValue: selectedValue,
        tagScope: tagScope,
        viewTransition: viewTransition
    };
}
function $61541ab712b0f8a9$var$getChildFormatContext(parentContext, type, props) {
    var subtreeScope = parentContext.tagScope & -25;
    switch(type){
        case "noscript":
            return $61541ab712b0f8a9$var$createFormatContext(2, null, subtreeScope | 1, null);
        case "select":
            return $61541ab712b0f8a9$var$createFormatContext(2, null != props.value ? props.value : props.defaultValue, subtreeScope, null);
        case "svg":
            return $61541ab712b0f8a9$var$createFormatContext(4, null, subtreeScope, null);
        case "picture":
            return $61541ab712b0f8a9$var$createFormatContext(2, null, subtreeScope | 2, null);
        case "math":
            return $61541ab712b0f8a9$var$createFormatContext(5, null, subtreeScope, null);
        case "foreignObject":
            return $61541ab712b0f8a9$var$createFormatContext(2, null, subtreeScope, null);
        case "table":
            return $61541ab712b0f8a9$var$createFormatContext(6, null, subtreeScope, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $61541ab712b0f8a9$var$createFormatContext(7, null, subtreeScope, null);
        case "colgroup":
            return $61541ab712b0f8a9$var$createFormatContext(9, null, subtreeScope, null);
        case "tr":
            return $61541ab712b0f8a9$var$createFormatContext(8, null, subtreeScope, null);
        case "head":
            if (2 > parentContext.insertionMode) return $61541ab712b0f8a9$var$createFormatContext(3, null, subtreeScope, null);
            break;
        case "html":
            if (0 === parentContext.insertionMode) return $61541ab712b0f8a9$var$createFormatContext(1, null, subtreeScope, null);
    }
    return 6 <= parentContext.insertionMode || 2 > parentContext.insertionMode ? $61541ab712b0f8a9$var$createFormatContext(2, null, subtreeScope, null) : parentContext.tagScope !== subtreeScope ? $61541ab712b0f8a9$var$createFormatContext(parentContext.insertionMode, parentContext.selectedValue, subtreeScope, null) : parentContext;
}
function $61541ab712b0f8a9$var$getSuspenseViewTransition(parentViewTransition) {
    return null === parentViewTransition ? null : {
        update: parentViewTransition.update,
        enter: "none",
        exit: "none",
        share: parentViewTransition.update,
        name: parentViewTransition.autoName,
        autoName: parentViewTransition.autoName,
        nameIdx: 0
    };
}
function $61541ab712b0f8a9$var$getSuspenseFallbackFormatContext(resumableState, parentContext) {
    parentContext.tagScope & 32 && (resumableState.instructions |= 128);
    return $61541ab712b0f8a9$var$createFormatContext(parentContext.insertionMode, parentContext.selectedValue, parentContext.tagScope | 12, $61541ab712b0f8a9$var$getSuspenseViewTransition(parentContext.viewTransition));
}
function $61541ab712b0f8a9$var$getSuspenseContentFormatContext(resumableState, parentContext) {
    resumableState = $61541ab712b0f8a9$var$getSuspenseViewTransition(parentContext.viewTransition);
    var subtreeScope = parentContext.tagScope | 16;
    null !== resumableState && "none" !== resumableState.share && (subtreeScope |= 64);
    return $61541ab712b0f8a9$var$createFormatContext(parentContext.insertionMode, parentContext.selectedValue, subtreeScope, resumableState);
}
var $61541ab712b0f8a9$var$styleNameCache = new Map();
function $61541ab712b0f8a9$var$pushStyleAttribute(target, style) {
    if ("object" !== typeof style) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(62));
    var isFirst = !0, styleName;
    for(styleName in style)if ($61541ab712b0f8a9$var$hasOwnProperty.call(style, styleName)) {
        var styleValue = style[styleName];
        if (null != styleValue && "boolean" !== typeof styleValue && "" !== styleValue) {
            if (0 === styleName.indexOf("--")) {
                var nameChunk = $61541ab712b0f8a9$var$escapeTextForBrowser(styleName);
                styleValue = $61541ab712b0f8a9$var$escapeTextForBrowser(("" + styleValue).trim());
            } else nameChunk = $61541ab712b0f8a9$var$styleNameCache.get(styleName), void 0 === nameChunk && (nameChunk = $61541ab712b0f8a9$var$escapeTextForBrowser(styleName.replace($61541ab712b0f8a9$var$uppercasePattern, "-$1").toLowerCase().replace($61541ab712b0f8a9$var$msPattern, "-ms-")), $61541ab712b0f8a9$var$styleNameCache.set(styleName, nameChunk)), styleValue = "number" === typeof styleValue ? 0 === styleValue || $61541ab712b0f8a9$var$unitlessNumbers.has(styleName) ? "" + styleValue : styleValue + "px" : $61541ab712b0f8a9$var$escapeTextForBrowser(("" + styleValue).trim());
            isFirst ? (isFirst = !1, target.push(' style="', nameChunk, ":", styleValue)) : target.push(";", nameChunk, ":", styleValue);
        }
    }
    isFirst || target.push('"');
}
function $61541ab712b0f8a9$var$pushBooleanAttribute(target, name, value) {
    value && "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '=""');
}
function $61541ab712b0f8a9$var$pushStringAttribute(target, name, value) {
    "function" !== typeof value && "symbol" !== typeof value && "boolean" !== typeof value && target.push(" ", name, '="', $61541ab712b0f8a9$var$escapeTextForBrowser(value), '"');
}
var $61541ab712b0f8a9$var$actionJavaScriptURL = $61541ab712b0f8a9$var$escapeTextForBrowser("javascript:throw new Error('React form unexpectedly submitted.')");
function $61541ab712b0f8a9$var$pushAdditionalFormField(value, key) {
    this.push('<input type="hidden"');
    $61541ab712b0f8a9$var$validateAdditionalFormField(value);
    $61541ab712b0f8a9$var$pushStringAttribute(this, "name", key);
    $61541ab712b0f8a9$var$pushStringAttribute(this, "value", value);
    this.push("/>");
}
function $61541ab712b0f8a9$var$validateAdditionalFormField(value) {
    if ("string" !== typeof value) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(480));
}
function $61541ab712b0f8a9$var$getCustomFormFields(resumableState, formAction) {
    if ("function" === typeof formAction.$$FORM_ACTION) {
        var id = resumableState.nextFormID++;
        resumableState = resumableState.idPrefix + id;
        try {
            var customFields = formAction.$$FORM_ACTION(resumableState);
            if (customFields) {
                var formData = customFields.data;
                null != formData && formData.forEach($61541ab712b0f8a9$var$validateAdditionalFormField);
            }
            return customFields;
        } catch (x) {
            if ("object" === typeof x && null !== x && "function" === typeof x.then) throw x;
        }
    }
    return null;
}
function $61541ab712b0f8a9$var$pushFormActionAttribute(target, resumableState, renderState, formAction, formEncType, formMethod, formTarget, name) {
    var formData = null;
    if ("function" === typeof formAction) {
        var customFields = $61541ab712b0f8a9$var$getCustomFormFields(resumableState, formAction);
        null !== customFields ? (name = customFields.name, formAction = customFields.action || "", formEncType = customFields.encType, formMethod = customFields.method, formTarget = customFields.target, formData = customFields.data) : (target.push(" ", "formAction", '="', $61541ab712b0f8a9$var$actionJavaScriptURL, '"'), formTarget = formMethod = formEncType = formAction = name = null, $61541ab712b0f8a9$var$injectFormReplayingRuntime(resumableState, renderState));
    }
    null != name && $61541ab712b0f8a9$var$pushAttribute(target, "name", name);
    null != formAction && $61541ab712b0f8a9$var$pushAttribute(target, "formAction", formAction);
    null != formEncType && $61541ab712b0f8a9$var$pushAttribute(target, "formEncType", formEncType);
    null != formMethod && $61541ab712b0f8a9$var$pushAttribute(target, "formMethod", formMethod);
    null != formTarget && $61541ab712b0f8a9$var$pushAttribute(target, "formTarget", formTarget);
    return formData;
}
function $61541ab712b0f8a9$var$pushAttribute(target, name, value) {
    switch(name){
        case "className":
            $61541ab712b0f8a9$var$pushStringAttribute(target, "class", value);
            break;
        case "tabIndex":
            $61541ab712b0f8a9$var$pushStringAttribute(target, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $61541ab712b0f8a9$var$pushStringAttribute(target, name, value);
            break;
        case "style":
            $61541ab712b0f8a9$var$pushStyleAttribute(target, value);
            break;
        case "src":
        case "href":
            if ("" === value) break;
        case "action":
        case "formAction":
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) break;
            value = $61541ab712b0f8a9$var$sanitizeURL("" + value);
            target.push(" ", name, '="', $61541ab712b0f8a9$var$escapeTextForBrowser(value), '"');
            break;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "ref":
            break;
        case "autoFocus":
        case "multiple":
        case "muted":
            $61541ab712b0f8a9$var$pushBooleanAttribute(target, name.toLowerCase(), value);
            break;
        case "xlinkHref":
            if ("function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) break;
            value = $61541ab712b0f8a9$var$sanitizeURL("" + value);
            target.push(" ", "xlink:href", '="', $61541ab712b0f8a9$var$escapeTextForBrowser(value), '"');
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '="', $61541ab712b0f8a9$var$escapeTextForBrowser(value), '"');
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '=""');
            break;
        case "capture":
        case "download":
            !0 === value ? target.push(" ", name, '=""') : !1 !== value && "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '="', $61541ab712b0f8a9$var$escapeTextForBrowser(value), '"');
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value && target.push(" ", name, '="', $61541ab712b0f8a9$var$escapeTextForBrowser(value), '"');
            break;
        case "rowSpan":
        case "start":
            "function" === typeof value || "symbol" === typeof value || isNaN(value) || target.push(" ", name, '="', $61541ab712b0f8a9$var$escapeTextForBrowser(value), '"');
            break;
        case "xlinkActuate":
            $61541ab712b0f8a9$var$pushStringAttribute(target, "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $61541ab712b0f8a9$var$pushStringAttribute(target, "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $61541ab712b0f8a9$var$pushStringAttribute(target, "xlink:role", value);
            break;
        case "xlinkShow":
            $61541ab712b0f8a9$var$pushStringAttribute(target, "xlink:show", value);
            break;
        case "xlinkTitle":
            $61541ab712b0f8a9$var$pushStringAttribute(target, "xlink:title", value);
            break;
        case "xlinkType":
            $61541ab712b0f8a9$var$pushStringAttribute(target, "xlink:type", value);
            break;
        case "xmlBase":
            $61541ab712b0f8a9$var$pushStringAttribute(target, "xml:base", value);
            break;
        case "xmlLang":
            $61541ab712b0f8a9$var$pushStringAttribute(target, "xml:lang", value);
            break;
        case "xmlSpace":
            $61541ab712b0f8a9$var$pushStringAttribute(target, "xml:space", value);
            break;
        default:
            if (!(2 < name.length) || "o" !== name[0] && "O" !== name[0] || "n" !== name[1] && "N" !== name[1]) {
                if (name = $61541ab712b0f8a9$var$aliases.get(name) || name, $61541ab712b0f8a9$var$isAttributeNameSafe(name)) {
                    switch(typeof value){
                        case "function":
                        case "symbol":
                            return;
                        case "boolean":
                            var prefix$8 = name.toLowerCase().slice(0, 5);
                            if ("data-" !== prefix$8 && "aria-" !== prefix$8) return;
                    }
                    target.push(" ", name, '="', $61541ab712b0f8a9$var$escapeTextForBrowser(value), '"');
                }
            }
    }
}
function $61541ab712b0f8a9$var$pushInnerHTML(target, innerHTML, children) {
    if (null != innerHTML) {
        if (null != children) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(60));
        if ("object" !== typeof innerHTML || !("__html" in innerHTML)) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(61));
        innerHTML = innerHTML.__html;
        null !== innerHTML && void 0 !== innerHTML && target.push("" + innerHTML);
    }
}
function $61541ab712b0f8a9$var$flattenOptionChildren(children) {
    var content = "";
    $acw62.Children.forEach(children, function(child) {
        null != child && (content += child);
    });
    return content;
}
function $61541ab712b0f8a9$var$injectFormReplayingRuntime(resumableState, renderState) {
    if (0 === (resumableState.instructions & 16)) {
        resumableState.instructions |= 16;
        var preamble = renderState.preamble, bootstrapChunks = renderState.bootstrapChunks;
        (preamble.htmlChunks || preamble.headChunks) && 0 === bootstrapChunks.length ? (bootstrapChunks.push(renderState.startInlineScript), $61541ab712b0f8a9$var$pushCompletedShellIdAttribute(bootstrapChunks, resumableState), bootstrapChunks.push(">", 'addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error(\'React form unexpectedly submitted.\')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});', "\x3c/script>")) : bootstrapChunks.unshift(renderState.startInlineScript, ">", 'addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error(\'React form unexpectedly submitted.\')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});', "\x3c/script>");
    }
}
function $61541ab712b0f8a9$var$pushLinkImpl(target, props) {
    target.push($61541ab712b0f8a9$var$startChunkForTag("link"));
    for(var propKey in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
            case "dangerouslySetInnerHTML":
                throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(399, "link"));
            default:
                $61541ab712b0f8a9$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push("/>");
    return null;
}
var $61541ab712b0f8a9$var$styleRegex = /(<\/|<)(s)(tyle)/gi;
function $61541ab712b0f8a9$var$styleReplacer(match, prefix, s, suffix) {
    return "" + prefix + ("s" === s ? "\\73 " : "\\53 ") + suffix;
}
function $61541ab712b0f8a9$var$pushSelfClosing(target, props, tag) {
    target.push($61541ab712b0f8a9$var$startChunkForTag(tag));
    for(var propKey in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
            case "dangerouslySetInnerHTML":
                throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(399, tag));
            default:
                $61541ab712b0f8a9$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push("/>");
    return null;
}
function $61541ab712b0f8a9$var$pushTitleImpl(target, props) {
    target.push($61541ab712b0f8a9$var$startChunkForTag("title"));
    var children = null, innerHTML = null, propKey;
    for(propKey in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                children = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $61541ab712b0f8a9$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push(">");
    props = Array.isArray(children) ? 2 > children.length ? children[0] : null : children;
    "function" !== typeof props && "symbol" !== typeof props && null !== props && void 0 !== props && target.push($61541ab712b0f8a9$var$escapeTextForBrowser("" + props));
    $61541ab712b0f8a9$var$pushInnerHTML(target, innerHTML, children);
    target.push($61541ab712b0f8a9$var$endChunkForTag("title"));
    return null;
}
function $61541ab712b0f8a9$var$pushScriptImpl(target, props) {
    target.push($61541ab712b0f8a9$var$startChunkForTag("script"));
    var children = null, innerHTML = null, propKey;
    for(propKey in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                children = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $61541ab712b0f8a9$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push(">");
    $61541ab712b0f8a9$var$pushInnerHTML(target, innerHTML, children);
    "string" === typeof children && target.push(("" + children).replace($61541ab712b0f8a9$var$scriptRegex, $61541ab712b0f8a9$var$scriptReplacer));
    target.push($61541ab712b0f8a9$var$endChunkForTag("script"));
    return null;
}
function $61541ab712b0f8a9$var$pushStartSingletonElement(target, props, tag) {
    target.push($61541ab712b0f8a9$var$startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for(propKey in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                tag = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $61541ab712b0f8a9$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push(">");
    $61541ab712b0f8a9$var$pushInnerHTML(target, innerHTML, tag);
    return tag;
}
function $61541ab712b0f8a9$var$pushStartGenericElement(target, props, tag) {
    target.push($61541ab712b0f8a9$var$startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for(propKey in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                tag = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $61541ab712b0f8a9$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push(">");
    $61541ab712b0f8a9$var$pushInnerHTML(target, innerHTML, tag);
    return "string" === typeof tag ? (target.push($61541ab712b0f8a9$var$escapeTextForBrowser(tag)), null) : tag;
}
var $61541ab712b0f8a9$var$VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $61541ab712b0f8a9$var$validatedTagCache = new Map();
function $61541ab712b0f8a9$var$startChunkForTag(tag) {
    var tagStartChunk = $61541ab712b0f8a9$var$validatedTagCache.get(tag);
    if (void 0 === tagStartChunk) {
        if (!$61541ab712b0f8a9$var$VALID_TAG_REGEX.test(tag)) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(65, tag));
        tagStartChunk = "<" + tag;
        $61541ab712b0f8a9$var$validatedTagCache.set(tag, tagStartChunk);
    }
    return tagStartChunk;
}
function $61541ab712b0f8a9$var$pushStartInstance(target$jscomp$0, type, props, resumableState, renderState, preambleState, hoistableState, formatContext, textEmbedded) {
    switch(type){
        case "div":
        case "span":
        case "svg":
        case "path":
            break;
        case "a":
            target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag("a"));
            var children = null, innerHTML = null, propKey;
            for(propKey in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "children":
                        children = propValue;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML = propValue;
                        break;
                    case "href":
                        "" === propValue ? $61541ab712b0f8a9$var$pushStringAttribute(target$jscomp$0, "href", "") : $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey, propValue);
                        break;
                    default:
                        $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey, propValue);
                }
            }
            target$jscomp$0.push(">");
            $61541ab712b0f8a9$var$pushInnerHTML(target$jscomp$0, innerHTML, children);
            if ("string" === typeof children) {
                target$jscomp$0.push($61541ab712b0f8a9$var$escapeTextForBrowser(children));
                var JSCompiler_inline_result = null;
            } else JSCompiler_inline_result = children;
            return JSCompiler_inline_result;
        case "g":
        case "p":
        case "li":
            break;
        case "select":
            target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag("select"));
            var children$jscomp$0 = null, innerHTML$jscomp$0 = null, propKey$jscomp$0;
            for(propKey$jscomp$0 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$0)) {
                var propValue$jscomp$0 = props[propKey$jscomp$0];
                if (null != propValue$jscomp$0) switch(propKey$jscomp$0){
                    case "children":
                        children$jscomp$0 = propValue$jscomp$0;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$0 = propValue$jscomp$0;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey$jscomp$0, propValue$jscomp$0);
                }
            }
            target$jscomp$0.push(">");
            $61541ab712b0f8a9$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$0, children$jscomp$0);
            return children$jscomp$0;
        case "option":
            var selectedValue = formatContext.selectedValue;
            target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag("option"));
            var children$jscomp$1 = null, value = null, selected = null, innerHTML$jscomp$1 = null, propKey$jscomp$1;
            for(propKey$jscomp$1 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$1)) {
                var propValue$jscomp$1 = props[propKey$jscomp$1];
                if (null != propValue$jscomp$1) switch(propKey$jscomp$1){
                    case "children":
                        children$jscomp$1 = propValue$jscomp$1;
                        break;
                    case "selected":
                        selected = propValue$jscomp$1;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$1 = propValue$jscomp$1;
                        break;
                    case "value":
                        value = propValue$jscomp$1;
                    default:
                        $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey$jscomp$1, propValue$jscomp$1);
                }
            }
            if (null != selectedValue) {
                var stringValue = null !== value ? "" + value : $61541ab712b0f8a9$var$flattenOptionChildren(children$jscomp$1);
                if ($61541ab712b0f8a9$var$isArrayImpl(selectedValue)) {
                    for(var i = 0; i < selectedValue.length; i++)if ("" + selectedValue[i] === stringValue) {
                        target$jscomp$0.push(' selected=""');
                        break;
                    }
                } else "" + selectedValue === stringValue && target$jscomp$0.push(' selected=""');
            } else selected && target$jscomp$0.push(' selected=""');
            target$jscomp$0.push(">");
            $61541ab712b0f8a9$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$1, children$jscomp$1);
            return children$jscomp$1;
        case "textarea":
            target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag("textarea"));
            var value$jscomp$0 = null, defaultValue = null, children$jscomp$2 = null, propKey$jscomp$2;
            for(propKey$jscomp$2 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$2)) {
                var propValue$jscomp$2 = props[propKey$jscomp$2];
                if (null != propValue$jscomp$2) switch(propKey$jscomp$2){
                    case "children":
                        children$jscomp$2 = propValue$jscomp$2;
                        break;
                    case "value":
                        value$jscomp$0 = propValue$jscomp$2;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$jscomp$2;
                        break;
                    case "dangerouslySetInnerHTML":
                        throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(91));
                    default:
                        $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey$jscomp$2, propValue$jscomp$2);
                }
            }
            null === value$jscomp$0 && null !== defaultValue && (value$jscomp$0 = defaultValue);
            target$jscomp$0.push(">");
            if (null != children$jscomp$2) {
                if (null != value$jscomp$0) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(92));
                if ($61541ab712b0f8a9$var$isArrayImpl(children$jscomp$2)) {
                    if (1 < children$jscomp$2.length) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(93));
                    value$jscomp$0 = "" + children$jscomp$2[0];
                }
                value$jscomp$0 = "" + children$jscomp$2;
            }
            "string" === typeof value$jscomp$0 && "\n" === value$jscomp$0[0] && target$jscomp$0.push("\n");
            null !== value$jscomp$0 && target$jscomp$0.push($61541ab712b0f8a9$var$escapeTextForBrowser("" + value$jscomp$0));
            return null;
        case "input":
            target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag("input"));
            var name = null, formAction = null, formEncType = null, formMethod = null, formTarget = null, value$jscomp$1 = null, defaultValue$jscomp$0 = null, checked = null, defaultChecked = null, propKey$jscomp$3;
            for(propKey$jscomp$3 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$3)) {
                var propValue$jscomp$3 = props[propKey$jscomp$3];
                if (null != propValue$jscomp$3) switch(propKey$jscomp$3){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(399, "input"));
                    case "name":
                        name = propValue$jscomp$3;
                        break;
                    case "formAction":
                        formAction = propValue$jscomp$3;
                        break;
                    case "formEncType":
                        formEncType = propValue$jscomp$3;
                        break;
                    case "formMethod":
                        formMethod = propValue$jscomp$3;
                        break;
                    case "formTarget":
                        formTarget = propValue$jscomp$3;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$jscomp$3;
                        break;
                    case "defaultValue":
                        defaultValue$jscomp$0 = propValue$jscomp$3;
                        break;
                    case "checked":
                        checked = propValue$jscomp$3;
                        break;
                    case "value":
                        value$jscomp$1 = propValue$jscomp$3;
                        break;
                    default:
                        $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey$jscomp$3, propValue$jscomp$3);
                }
            }
            var formData = $61541ab712b0f8a9$var$pushFormActionAttribute(target$jscomp$0, resumableState, renderState, formAction, formEncType, formMethod, formTarget, name);
            null !== checked ? $61541ab712b0f8a9$var$pushBooleanAttribute(target$jscomp$0, "checked", checked) : null !== defaultChecked && $61541ab712b0f8a9$var$pushBooleanAttribute(target$jscomp$0, "checked", defaultChecked);
            null !== value$jscomp$1 ? $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, "value", value$jscomp$1) : null !== defaultValue$jscomp$0 && $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, "value", defaultValue$jscomp$0);
            target$jscomp$0.push("/>");
            null != formData && formData.forEach($61541ab712b0f8a9$var$pushAdditionalFormField, target$jscomp$0);
            return null;
        case "button":
            target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag("button"));
            var children$jscomp$3 = null, innerHTML$jscomp$2 = null, name$jscomp$0 = null, formAction$jscomp$0 = null, formEncType$jscomp$0 = null, formMethod$jscomp$0 = null, formTarget$jscomp$0 = null, propKey$jscomp$4;
            for(propKey$jscomp$4 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$4)) {
                var propValue$jscomp$4 = props[propKey$jscomp$4];
                if (null != propValue$jscomp$4) switch(propKey$jscomp$4){
                    case "children":
                        children$jscomp$3 = propValue$jscomp$4;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$2 = propValue$jscomp$4;
                        break;
                    case "name":
                        name$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formAction":
                        formAction$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formEncType":
                        formEncType$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formMethod":
                        formMethod$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formTarget":
                        formTarget$jscomp$0 = propValue$jscomp$4;
                        break;
                    default:
                        $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey$jscomp$4, propValue$jscomp$4);
                }
            }
            var formData$jscomp$0 = $61541ab712b0f8a9$var$pushFormActionAttribute(target$jscomp$0, resumableState, renderState, formAction$jscomp$0, formEncType$jscomp$0, formMethod$jscomp$0, formTarget$jscomp$0, name$jscomp$0);
            target$jscomp$0.push(">");
            null != formData$jscomp$0 && formData$jscomp$0.forEach($61541ab712b0f8a9$var$pushAdditionalFormField, target$jscomp$0);
            $61541ab712b0f8a9$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$2, children$jscomp$3);
            if ("string" === typeof children$jscomp$3) {
                target$jscomp$0.push($61541ab712b0f8a9$var$escapeTextForBrowser(children$jscomp$3));
                var JSCompiler_inline_result$jscomp$0 = null;
            } else JSCompiler_inline_result$jscomp$0 = children$jscomp$3;
            return JSCompiler_inline_result$jscomp$0;
        case "form":
            target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag("form"));
            var children$jscomp$4 = null, innerHTML$jscomp$3 = null, formAction$jscomp$1 = null, formEncType$jscomp$1 = null, formMethod$jscomp$1 = null, formTarget$jscomp$1 = null, propKey$jscomp$5;
            for(propKey$jscomp$5 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$5)) {
                var propValue$jscomp$5 = props[propKey$jscomp$5];
                if (null != propValue$jscomp$5) switch(propKey$jscomp$5){
                    case "children":
                        children$jscomp$4 = propValue$jscomp$5;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$3 = propValue$jscomp$5;
                        break;
                    case "action":
                        formAction$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "encType":
                        formEncType$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "method":
                        formMethod$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "target":
                        formTarget$jscomp$1 = propValue$jscomp$5;
                        break;
                    default:
                        $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey$jscomp$5, propValue$jscomp$5);
                }
            }
            var formData$jscomp$1 = null, formActionName = null;
            if ("function" === typeof formAction$jscomp$1) {
                var customFields = $61541ab712b0f8a9$var$getCustomFormFields(resumableState, formAction$jscomp$1);
                null !== customFields ? (formAction$jscomp$1 = customFields.action || "", formEncType$jscomp$1 = customFields.encType, formMethod$jscomp$1 = customFields.method, formTarget$jscomp$1 = customFields.target, formData$jscomp$1 = customFields.data, formActionName = customFields.name) : (target$jscomp$0.push(" ", "action", '="', $61541ab712b0f8a9$var$actionJavaScriptURL, '"'), formTarget$jscomp$1 = formMethod$jscomp$1 = formEncType$jscomp$1 = formAction$jscomp$1 = null, $61541ab712b0f8a9$var$injectFormReplayingRuntime(resumableState, renderState));
            }
            null != formAction$jscomp$1 && $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, "action", formAction$jscomp$1);
            null != formEncType$jscomp$1 && $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, "encType", formEncType$jscomp$1);
            null != formMethod$jscomp$1 && $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, "method", formMethod$jscomp$1);
            null != formTarget$jscomp$1 && $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, "target", formTarget$jscomp$1);
            target$jscomp$0.push(">");
            null !== formActionName && (target$jscomp$0.push('<input type="hidden"'), $61541ab712b0f8a9$var$pushStringAttribute(target$jscomp$0, "name", formActionName), target$jscomp$0.push("/>"), null != formData$jscomp$1 && formData$jscomp$1.forEach($61541ab712b0f8a9$var$pushAdditionalFormField, target$jscomp$0));
            $61541ab712b0f8a9$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$3, children$jscomp$4);
            if ("string" === typeof children$jscomp$4) {
                target$jscomp$0.push($61541ab712b0f8a9$var$escapeTextForBrowser(children$jscomp$4));
                var JSCompiler_inline_result$jscomp$1 = null;
            } else JSCompiler_inline_result$jscomp$1 = children$jscomp$4;
            return JSCompiler_inline_result$jscomp$1;
        case "menuitem":
            target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag("menuitem"));
            for(var propKey$jscomp$6 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$6)) {
                var propValue$jscomp$6 = props[propKey$jscomp$6];
                if (null != propValue$jscomp$6) switch(propKey$jscomp$6){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(400));
                    default:
                        $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey$jscomp$6, propValue$jscomp$6);
                }
            }
            target$jscomp$0.push(">");
            return null;
        case "object":
            target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag("object"));
            var children$jscomp$5 = null, innerHTML$jscomp$4 = null, propKey$jscomp$7;
            for(propKey$jscomp$7 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$7)) {
                var propValue$jscomp$7 = props[propKey$jscomp$7];
                if (null != propValue$jscomp$7) switch(propKey$jscomp$7){
                    case "children":
                        children$jscomp$5 = propValue$jscomp$7;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$4 = propValue$jscomp$7;
                        break;
                    case "data":
                        var sanitizedValue = $61541ab712b0f8a9$var$sanitizeURL("" + propValue$jscomp$7);
                        if ("" === sanitizedValue) break;
                        target$jscomp$0.push(" ", "data", '="', $61541ab712b0f8a9$var$escapeTextForBrowser(sanitizedValue), '"');
                        break;
                    default:
                        $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey$jscomp$7, propValue$jscomp$7);
                }
            }
            target$jscomp$0.push(">");
            $61541ab712b0f8a9$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$4, children$jscomp$5);
            if ("string" === typeof children$jscomp$5) {
                target$jscomp$0.push($61541ab712b0f8a9$var$escapeTextForBrowser(children$jscomp$5));
                var JSCompiler_inline_result$jscomp$2 = null;
            } else JSCompiler_inline_result$jscomp$2 = children$jscomp$5;
            return JSCompiler_inline_result$jscomp$2;
        case "title":
            var noscriptTagInScope = formatContext.tagScope & 1, isFallback = formatContext.tagScope & 4;
            if (4 === formatContext.insertionMode || noscriptTagInScope || null != props.itemProp) var JSCompiler_inline_result$jscomp$3 = $61541ab712b0f8a9$var$pushTitleImpl(target$jscomp$0, props);
            else isFallback ? JSCompiler_inline_result$jscomp$3 = null : ($61541ab712b0f8a9$var$pushTitleImpl(renderState.hoistableChunks, props), JSCompiler_inline_result$jscomp$3 = void 0);
            return JSCompiler_inline_result$jscomp$3;
        case "link":
            var noscriptTagInScope$jscomp$0 = formatContext.tagScope & 1, isFallback$jscomp$0 = formatContext.tagScope & 4, rel = props.rel, href = props.href, precedence = props.precedence;
            if (4 === formatContext.insertionMode || noscriptTagInScope$jscomp$0 || null != props.itemProp || "string" !== typeof rel || "string" !== typeof href || "" === href) {
                $61541ab712b0f8a9$var$pushLinkImpl(target$jscomp$0, props);
                var JSCompiler_inline_result$jscomp$4 = null;
            } else if ("stylesheet" === props.rel) {
                if ("string" !== typeof precedence || null != props.disabled || props.onLoad || props.onError) JSCompiler_inline_result$jscomp$4 = $61541ab712b0f8a9$var$pushLinkImpl(target$jscomp$0, props);
                else {
                    var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
                    if (null !== resourceState) {
                        resumableState.styleResources[href] = null;
                        styleQueue || (styleQueue = {
                            precedence: $61541ab712b0f8a9$var$escapeTextForBrowser(precedence),
                            rules: [],
                            hrefs: [],
                            sheets: new Map()
                        }, renderState.styles.set(precedence, styleQueue));
                        var resource = {
                            state: 0,
                            props: $61541ab712b0f8a9$var$assign({}, props, {
                                "data-precedence": props.precedence,
                                precedence: null
                            })
                        };
                        if (resourceState) {
                            2 === resourceState.length && $61541ab712b0f8a9$var$adoptPreloadCredentials(resource.props, resourceState);
                            var preloadResource = renderState.preloads.stylesheets.get(href);
                            preloadResource && 0 < preloadResource.length ? preloadResource.length = 0 : resource.state = 1;
                        }
                        styleQueue.sheets.set(href, resource);
                        hoistableState && hoistableState.stylesheets.add(resource);
                    } else if (styleQueue) {
                        var resource$9 = styleQueue.sheets.get(href);
                        resource$9 && hoistableState && hoistableState.stylesheets.add(resource$9);
                    }
                    textEmbedded && target$jscomp$0.push("\x3c!-- --\x3e");
                    JSCompiler_inline_result$jscomp$4 = null;
                }
            } else props.onLoad || props.onError ? JSCompiler_inline_result$jscomp$4 = $61541ab712b0f8a9$var$pushLinkImpl(target$jscomp$0, props) : (textEmbedded && target$jscomp$0.push("\x3c!-- --\x3e"), JSCompiler_inline_result$jscomp$4 = isFallback$jscomp$0 ? null : $61541ab712b0f8a9$var$pushLinkImpl(renderState.hoistableChunks, props));
            return JSCompiler_inline_result$jscomp$4;
        case "script":
            var noscriptTagInScope$jscomp$1 = formatContext.tagScope & 1, asyncProp = props.async;
            if ("string" !== typeof props.src || !props.src || !asyncProp || "function" === typeof asyncProp || "symbol" === typeof asyncProp || props.onLoad || props.onError || 4 === formatContext.insertionMode || noscriptTagInScope$jscomp$1 || null != props.itemProp) var JSCompiler_inline_result$jscomp$5 = $61541ab712b0f8a9$var$pushScriptImpl(target$jscomp$0, props);
            else {
                var key = props.src;
                if ("module" === props.type) {
                    var resources = resumableState.moduleScriptResources;
                    var preloads = renderState.preloads.moduleScripts;
                } else resources = resumableState.scriptResources, preloads = renderState.preloads.scripts;
                var resourceState$jscomp$0 = resources.hasOwnProperty(key) ? resources[key] : void 0;
                if (null !== resourceState$jscomp$0) {
                    resources[key] = null;
                    var scriptProps = props;
                    if (resourceState$jscomp$0) {
                        2 === resourceState$jscomp$0.length && (scriptProps = $61541ab712b0f8a9$var$assign({}, props), $61541ab712b0f8a9$var$adoptPreloadCredentials(scriptProps, resourceState$jscomp$0));
                        var preloadResource$jscomp$0 = preloads.get(key);
                        preloadResource$jscomp$0 && (preloadResource$jscomp$0.length = 0);
                    }
                    var resource$jscomp$0 = [];
                    renderState.scripts.add(resource$jscomp$0);
                    $61541ab712b0f8a9$var$pushScriptImpl(resource$jscomp$0, scriptProps);
                }
                textEmbedded && target$jscomp$0.push("\x3c!-- --\x3e");
                JSCompiler_inline_result$jscomp$5 = null;
            }
            return JSCompiler_inline_result$jscomp$5;
        case "style":
            var noscriptTagInScope$jscomp$2 = formatContext.tagScope & 1, precedence$jscomp$0 = props.precedence, href$jscomp$0 = props.href, nonce = props.nonce;
            if (4 === formatContext.insertionMode || noscriptTagInScope$jscomp$2 || null != props.itemProp || "string" !== typeof precedence$jscomp$0 || "string" !== typeof href$jscomp$0 || "" === href$jscomp$0) {
                target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag("style"));
                var children$jscomp$6 = null, innerHTML$jscomp$5 = null, propKey$jscomp$8;
                for(propKey$jscomp$8 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$8)) {
                    var propValue$jscomp$8 = props[propKey$jscomp$8];
                    if (null != propValue$jscomp$8) switch(propKey$jscomp$8){
                        case "children":
                            children$jscomp$6 = propValue$jscomp$8;
                            break;
                        case "dangerouslySetInnerHTML":
                            innerHTML$jscomp$5 = propValue$jscomp$8;
                            break;
                        default:
                            $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey$jscomp$8, propValue$jscomp$8);
                    }
                }
                target$jscomp$0.push(">");
                var child = Array.isArray(children$jscomp$6) ? 2 > children$jscomp$6.length ? children$jscomp$6[0] : null : children$jscomp$6;
                "function" !== typeof child && "symbol" !== typeof child && null !== child && void 0 !== child && target$jscomp$0.push(("" + child).replace($61541ab712b0f8a9$var$styleRegex, $61541ab712b0f8a9$var$styleReplacer));
                $61541ab712b0f8a9$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$5, children$jscomp$6);
                target$jscomp$0.push($61541ab712b0f8a9$var$endChunkForTag("style"));
                var JSCompiler_inline_result$jscomp$6 = null;
            } else {
                var styleQueue$jscomp$0 = renderState.styles.get(precedence$jscomp$0);
                if (null !== (resumableState.styleResources.hasOwnProperty(href$jscomp$0) ? resumableState.styleResources[href$jscomp$0] : void 0)) {
                    resumableState.styleResources[href$jscomp$0] = null;
                    styleQueue$jscomp$0 || (styleQueue$jscomp$0 = {
                        precedence: $61541ab712b0f8a9$var$escapeTextForBrowser(precedence$jscomp$0),
                        rules: [],
                        hrefs: [],
                        sheets: new Map()
                    }, renderState.styles.set(precedence$jscomp$0, styleQueue$jscomp$0));
                    var nonceStyle = renderState.nonce.style;
                    if (!nonceStyle || nonceStyle === nonce) {
                        styleQueue$jscomp$0.hrefs.push($61541ab712b0f8a9$var$escapeTextForBrowser(href$jscomp$0));
                        var target = styleQueue$jscomp$0.rules, children$jscomp$7 = null, innerHTML$jscomp$6 = null, propKey$jscomp$9;
                        for(propKey$jscomp$9 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$9)) {
                            var propValue$jscomp$9 = props[propKey$jscomp$9];
                            if (null != propValue$jscomp$9) switch(propKey$jscomp$9){
                                case "children":
                                    children$jscomp$7 = propValue$jscomp$9;
                                    break;
                                case "dangerouslySetInnerHTML":
                                    innerHTML$jscomp$6 = propValue$jscomp$9;
                            }
                        }
                        var child$jscomp$0 = Array.isArray(children$jscomp$7) ? 2 > children$jscomp$7.length ? children$jscomp$7[0] : null : children$jscomp$7;
                        "function" !== typeof child$jscomp$0 && "symbol" !== typeof child$jscomp$0 && null !== child$jscomp$0 && void 0 !== child$jscomp$0 && target.push(("" + child$jscomp$0).replace($61541ab712b0f8a9$var$styleRegex, $61541ab712b0f8a9$var$styleReplacer));
                        $61541ab712b0f8a9$var$pushInnerHTML(target, innerHTML$jscomp$6, children$jscomp$7);
                    }
                }
                styleQueue$jscomp$0 && hoistableState && hoistableState.styles.add(styleQueue$jscomp$0);
                textEmbedded && target$jscomp$0.push("\x3c!-- --\x3e");
                JSCompiler_inline_result$jscomp$6 = void 0;
            }
            return JSCompiler_inline_result$jscomp$6;
        case "meta":
            var noscriptTagInScope$jscomp$3 = formatContext.tagScope & 1, isFallback$jscomp$1 = formatContext.tagScope & 4;
            if (4 === formatContext.insertionMode || noscriptTagInScope$jscomp$3 || null != props.itemProp) var JSCompiler_inline_result$jscomp$7 = $61541ab712b0f8a9$var$pushSelfClosing(target$jscomp$0, props, "meta");
            else textEmbedded && target$jscomp$0.push("\x3c!-- --\x3e"), JSCompiler_inline_result$jscomp$7 = isFallback$jscomp$1 ? null : "string" === typeof props.charSet ? $61541ab712b0f8a9$var$pushSelfClosing(renderState.charsetChunks, props, "meta") : "viewport" === props.name ? $61541ab712b0f8a9$var$pushSelfClosing(renderState.viewportChunks, props, "meta") : $61541ab712b0f8a9$var$pushSelfClosing(renderState.hoistableChunks, props, "meta");
            return JSCompiler_inline_result$jscomp$7;
        case "listing":
        case "pre":
            target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag(type));
            var children$jscomp$8 = null, innerHTML$jscomp$7 = null, propKey$jscomp$10;
            for(propKey$jscomp$10 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$10)) {
                var propValue$jscomp$10 = props[propKey$jscomp$10];
                if (null != propValue$jscomp$10) switch(propKey$jscomp$10){
                    case "children":
                        children$jscomp$8 = propValue$jscomp$10;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$7 = propValue$jscomp$10;
                        break;
                    default:
                        $61541ab712b0f8a9$var$pushAttribute(target$jscomp$0, propKey$jscomp$10, propValue$jscomp$10);
                }
            }
            target$jscomp$0.push(">");
            if (null != innerHTML$jscomp$7) {
                if (null != children$jscomp$8) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(60));
                if ("object" !== typeof innerHTML$jscomp$7 || !("__html" in innerHTML$jscomp$7)) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(61));
                var html = innerHTML$jscomp$7.__html;
                null !== html && void 0 !== html && ("string" === typeof html && 0 < html.length && "\n" === html[0] ? target$jscomp$0.push("\n", html) : target$jscomp$0.push("" + html));
            }
            "string" === typeof children$jscomp$8 && "\n" === children$jscomp$8[0] && target$jscomp$0.push("\n");
            return children$jscomp$8;
        case "img":
            var pictureOrNoScriptTagInScope = formatContext.tagScope & 3, src = props.src, srcSet = props.srcSet;
            if (!("lazy" === props.loading || !src && !srcSet || "string" !== typeof src && null != src || "string" !== typeof srcSet && null != srcSet || "low" === props.fetchPriority || pictureOrNoScriptTagInScope) && ("string" !== typeof src || ":" !== src[4] || "d" !== src[0] && "D" !== src[0] || "a" !== src[1] && "A" !== src[1] || "t" !== src[2] && "T" !== src[2] || "a" !== src[3] && "A" !== src[3]) && ("string" !== typeof srcSet || ":" !== srcSet[4] || "d" !== srcSet[0] && "D" !== srcSet[0] || "a" !== srcSet[1] && "A" !== srcSet[1] || "t" !== srcSet[2] && "T" !== srcSet[2] || "a" !== srcSet[3] && "A" !== srcSet[3])) {
                null !== hoistableState && formatContext.tagScope & 64 && (hoistableState.suspenseyImages = !0);
                var sizes = "string" === typeof props.sizes ? props.sizes : void 0, key$jscomp$0 = srcSet ? srcSet + "\n" + (sizes || "") : src, promotablePreloads = renderState.preloads.images, resource$jscomp$1 = promotablePreloads.get(key$jscomp$0);
                if (resource$jscomp$1) {
                    if ("high" === props.fetchPriority || 10 > renderState.highImagePreloads.size) promotablePreloads.delete(key$jscomp$0), renderState.highImagePreloads.add(resource$jscomp$1);
                } else if (!resumableState.imageResources.hasOwnProperty(key$jscomp$0)) {
                    resumableState.imageResources[key$jscomp$0] = $61541ab712b0f8a9$var$PRELOAD_NO_CREDS;
                    var input = props.crossOrigin;
                    var JSCompiler_inline_result$jscomp$8 = "string" === typeof input ? "use-credentials" === input ? input : "" : void 0;
                    var headers = renderState.headers, header;
                    headers && 0 < headers.remainingCapacity && "string" !== typeof props.srcSet && ("high" === props.fetchPriority || 500 > headers.highImagePreloads.length) && (header = $61541ab712b0f8a9$var$getPreloadAsHeader(src, "image", {
                        imageSrcSet: props.srcSet,
                        imageSizes: props.sizes,
                        crossOrigin: JSCompiler_inline_result$jscomp$8,
                        integrity: props.integrity,
                        nonce: props.nonce,
                        type: props.type,
                        fetchPriority: props.fetchPriority,
                        referrerPolicy: props.refererPolicy
                    }), 0 <= (headers.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key$jscomp$0] = $61541ab712b0f8a9$var$PRELOAD_NO_CREDS, headers.highImagePreloads && (headers.highImagePreloads += ", "), headers.highImagePreloads += header) : (resource$jscomp$1 = [], $61541ab712b0f8a9$var$pushLinkImpl(resource$jscomp$1, {
                        rel: "preload",
                        as: "image",
                        href: srcSet ? void 0 : src,
                        imageSrcSet: srcSet,
                        imageSizes: sizes,
                        crossOrigin: JSCompiler_inline_result$jscomp$8,
                        integrity: props.integrity,
                        type: props.type,
                        fetchPriority: props.fetchPriority,
                        referrerPolicy: props.referrerPolicy
                    }), "high" === props.fetchPriority || 10 > renderState.highImagePreloads.size ? renderState.highImagePreloads.add(resource$jscomp$1) : (renderState.bulkPreloads.add(resource$jscomp$1), promotablePreloads.set(key$jscomp$0, resource$jscomp$1)));
                }
            }
            return $61541ab712b0f8a9$var$pushSelfClosing(target$jscomp$0, props, "img");
        case "base":
        case "area":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "param":
        case "source":
        case "track":
        case "wbr":
            return $61541ab712b0f8a9$var$pushSelfClosing(target$jscomp$0, props, type);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            break;
        case "head":
            if (2 > formatContext.insertionMode) {
                var preamble = preambleState || renderState.preamble;
                if (preamble.headChunks) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(545, "`<head>`"));
                null !== preambleState && target$jscomp$0.push("\x3c!--head--\x3e");
                preamble.headChunks = [];
                var JSCompiler_inline_result$jscomp$9 = $61541ab712b0f8a9$var$pushStartSingletonElement(preamble.headChunks, props, "head");
            } else JSCompiler_inline_result$jscomp$9 = $61541ab712b0f8a9$var$pushStartGenericElement(target$jscomp$0, props, "head");
            return JSCompiler_inline_result$jscomp$9;
        case "body":
            if (2 > formatContext.insertionMode) {
                var preamble$jscomp$0 = preambleState || renderState.preamble;
                if (preamble$jscomp$0.bodyChunks) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(545, "`<body>`"));
                null !== preambleState && target$jscomp$0.push("\x3c!--body--\x3e");
                preamble$jscomp$0.bodyChunks = [];
                var JSCompiler_inline_result$jscomp$10 = $61541ab712b0f8a9$var$pushStartSingletonElement(preamble$jscomp$0.bodyChunks, props, "body");
            } else JSCompiler_inline_result$jscomp$10 = $61541ab712b0f8a9$var$pushStartGenericElement(target$jscomp$0, props, "body");
            return JSCompiler_inline_result$jscomp$10;
        case "html":
            if (0 === formatContext.insertionMode) {
                var preamble$jscomp$1 = preambleState || renderState.preamble;
                if (preamble$jscomp$1.htmlChunks) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(545, "`<html>`"));
                null !== preambleState && target$jscomp$0.push("\x3c!--html--\x3e");
                preamble$jscomp$1.htmlChunks = [
                    ""
                ];
                var JSCompiler_inline_result$jscomp$11 = $61541ab712b0f8a9$var$pushStartSingletonElement(preamble$jscomp$1.htmlChunks, props, "html");
            } else JSCompiler_inline_result$jscomp$11 = $61541ab712b0f8a9$var$pushStartGenericElement(target$jscomp$0, props, "html");
            return JSCompiler_inline_result$jscomp$11;
        default:
            if (-1 !== type.indexOf("-")) {
                target$jscomp$0.push($61541ab712b0f8a9$var$startChunkForTag(type));
                var children$jscomp$9 = null, innerHTML$jscomp$8 = null, propKey$jscomp$11;
                for(propKey$jscomp$11 in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey$jscomp$11)) {
                    var propValue$jscomp$11 = props[propKey$jscomp$11];
                    if (null != propValue$jscomp$11) {
                        var attributeName = propKey$jscomp$11;
                        switch(propKey$jscomp$11){
                            case "children":
                                children$jscomp$9 = propValue$jscomp$11;
                                break;
                            case "dangerouslySetInnerHTML":
                                innerHTML$jscomp$8 = propValue$jscomp$11;
                                break;
                            case "style":
                                $61541ab712b0f8a9$var$pushStyleAttribute(target$jscomp$0, propValue$jscomp$11);
                                break;
                            case "suppressContentEditableWarning":
                            case "suppressHydrationWarning":
                            case "ref":
                                break;
                            case "className":
                                attributeName = "class";
                            default:
                                if ($61541ab712b0f8a9$var$isAttributeNameSafe(propKey$jscomp$11) && "function" !== typeof propValue$jscomp$11 && "symbol" !== typeof propValue$jscomp$11 && !1 !== propValue$jscomp$11) {
                                    if (!0 === propValue$jscomp$11) propValue$jscomp$11 = "";
                                    else if ("object" === typeof propValue$jscomp$11) continue;
                                    target$jscomp$0.push(" ", attributeName, '="', $61541ab712b0f8a9$var$escapeTextForBrowser(propValue$jscomp$11), '"');
                                }
                        }
                    }
                }
                target$jscomp$0.push(">");
                $61541ab712b0f8a9$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$8, children$jscomp$9);
                return children$jscomp$9;
            }
    }
    return $61541ab712b0f8a9$var$pushStartGenericElement(target$jscomp$0, props, type);
}
var $61541ab712b0f8a9$var$endTagCache = new Map();
function $61541ab712b0f8a9$var$endChunkForTag(tag) {
    var chunk = $61541ab712b0f8a9$var$endTagCache.get(tag);
    void 0 === chunk && (chunk = "</" + tag + ">", $61541ab712b0f8a9$var$endTagCache.set(tag, chunk));
    return chunk;
}
function $61541ab712b0f8a9$var$hoistPreambleState(renderState, preambleState) {
    renderState = renderState.preamble;
    null === renderState.htmlChunks && preambleState.htmlChunks && (renderState.htmlChunks = preambleState.htmlChunks);
    null === renderState.headChunks && preambleState.headChunks && (renderState.headChunks = preambleState.headChunks);
    null === renderState.bodyChunks && preambleState.bodyChunks && (renderState.bodyChunks = preambleState.bodyChunks);
}
function $61541ab712b0f8a9$var$writeBootstrap(destination, renderState) {
    renderState = renderState.bootstrapChunks;
    for(var i = 0; i < renderState.length - 1; i++)destination.push(renderState[i]);
    return i < renderState.length ? (i = renderState[i], renderState.length = 0, destination.push(i)) : !0;
}
function $61541ab712b0f8a9$var$writeStartPendingSuspenseBoundary(destination, renderState, id) {
    destination.push('\x3c!--$?--\x3e<template id="');
    if (null === id) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(395));
    destination.push(renderState.boundaryPrefix);
    renderState = id.toString(16);
    destination.push(renderState);
    return destination.push('"></template>');
}
function $61541ab712b0f8a9$var$writeStartSegment(destination, renderState, formatContext, id) {
    switch(formatContext.insertionMode){
        case 0:
        case 1:
        case 3:
        case 2:
            return destination.push('<div hidden id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 4:
            return destination.push('<svg aria-hidden="true" style="display:none" id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 5:
            return destination.push('<math aria-hidden="true" style="display:none" id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 6:
            return destination.push('<table hidden id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 7:
            return destination.push('<table hidden><tbody id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 8:
            return destination.push('<table hidden><tr id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 9:
            return destination.push('<table hidden><colgroup id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        default:
            throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(397));
    }
}
function $61541ab712b0f8a9$var$writeEndSegment(destination, formatContext) {
    switch(formatContext.insertionMode){
        case 0:
        case 1:
        case 3:
        case 2:
            return destination.push("</div>");
        case 4:
            return destination.push("</svg>");
        case 5:
            return destination.push("</math>");
        case 6:
            return destination.push("</table>");
        case 7:
            return destination.push("</tbody></table>");
        case 8:
            return destination.push("</tr></table>");
        case 9:
            return destination.push("</colgroup></table>");
        default:
            throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(397));
    }
}
var $61541ab712b0f8a9$var$regexForJSStringsInInstructionScripts = /[<\u2028\u2029]/g;
function $61541ab712b0f8a9$var$escapeJSStringsForInstructionScripts(input) {
    return JSON.stringify(input).replace($61541ab712b0f8a9$var$regexForJSStringsInInstructionScripts, function(match) {
        switch(match){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $61541ab712b0f8a9$var$regexForJSStringsInScripts = /[&><\u2028\u2029]/g;
function $61541ab712b0f8a9$var$escapeJSObjectForInstructionScripts(input) {
    return JSON.stringify(input).replace($61541ab712b0f8a9$var$regexForJSStringsInScripts, function(match) {
        switch(match){
            case "&":
                return "\\u0026";
            case ">":
                return "\\u003e";
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $61541ab712b0f8a9$var$currentlyRenderingBoundaryHasStylesToHoist = !1, $61541ab712b0f8a9$var$destinationHasCapacity = !0;
function $61541ab712b0f8a9$var$flushStyleTagsLateForBoundary(styleQueue) {
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs, i = 0;
    if (hrefs.length) {
        this.push($61541ab712b0f8a9$var$currentlyFlushingRenderState.startInlineStyle);
        this.push(' media="not all" data-precedence="');
        this.push(styleQueue.precedence);
        for(this.push('" data-href="'); i < hrefs.length - 1; i++)this.push(hrefs[i]), this.push(" ");
        this.push(hrefs[i]);
        this.push('">');
        for(i = 0; i < rules.length; i++)this.push(rules[i]);
        $61541ab712b0f8a9$var$destinationHasCapacity = this.push("</style>");
        $61541ab712b0f8a9$var$currentlyRenderingBoundaryHasStylesToHoist = !0;
        rules.length = 0;
        hrefs.length = 0;
    }
}
function $61541ab712b0f8a9$var$hasStylesToHoist(stylesheet) {
    return 2 !== stylesheet.state ? $61541ab712b0f8a9$var$currentlyRenderingBoundaryHasStylesToHoist = !0 : !1;
}
function $61541ab712b0f8a9$var$writeHoistablesForBoundary(destination, hoistableState, renderState) {
    $61541ab712b0f8a9$var$currentlyRenderingBoundaryHasStylesToHoist = !1;
    $61541ab712b0f8a9$var$destinationHasCapacity = !0;
    $61541ab712b0f8a9$var$currentlyFlushingRenderState = renderState;
    hoistableState.styles.forEach($61541ab712b0f8a9$var$flushStyleTagsLateForBoundary, destination);
    $61541ab712b0f8a9$var$currentlyFlushingRenderState = null;
    hoistableState.stylesheets.forEach($61541ab712b0f8a9$var$hasStylesToHoist);
    $61541ab712b0f8a9$var$currentlyRenderingBoundaryHasStylesToHoist && (renderState.stylesToHoist = !0);
    return $61541ab712b0f8a9$var$destinationHasCapacity;
}
function $61541ab712b0f8a9$var$flushResource(resource) {
    for(var i = 0; i < resource.length; i++)this.push(resource[i]);
    resource.length = 0;
}
var $61541ab712b0f8a9$var$stylesheetFlushingQueue = [];
function $61541ab712b0f8a9$var$flushStyleInPreamble(stylesheet) {
    $61541ab712b0f8a9$var$pushLinkImpl($61541ab712b0f8a9$var$stylesheetFlushingQueue, stylesheet.props);
    for(var i = 0; i < $61541ab712b0f8a9$var$stylesheetFlushingQueue.length; i++)this.push($61541ab712b0f8a9$var$stylesheetFlushingQueue[i]);
    $61541ab712b0f8a9$var$stylesheetFlushingQueue.length = 0;
    stylesheet.state = 2;
}
function $61541ab712b0f8a9$var$flushStylesInPreamble(styleQueue) {
    var hasStylesheets = 0 < styleQueue.sheets.size;
    styleQueue.sheets.forEach($61541ab712b0f8a9$var$flushStyleInPreamble, this);
    styleQueue.sheets.clear();
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs;
    if (!hasStylesheets || hrefs.length) {
        this.push($61541ab712b0f8a9$var$currentlyFlushingRenderState.startInlineStyle);
        this.push(' data-precedence="');
        this.push(styleQueue.precedence);
        styleQueue = 0;
        if (hrefs.length) {
            for(this.push('" data-href="'); styleQueue < hrefs.length - 1; styleQueue++)this.push(hrefs[styleQueue]), this.push(" ");
            this.push(hrefs[styleQueue]);
        }
        this.push('">');
        for(styleQueue = 0; styleQueue < rules.length; styleQueue++)this.push(rules[styleQueue]);
        this.push("</style>");
        rules.length = 0;
        hrefs.length = 0;
    }
}
function $61541ab712b0f8a9$var$preloadLateStyle(stylesheet) {
    if (0 === stylesheet.state) {
        stylesheet.state = 1;
        var props = stylesheet.props;
        $61541ab712b0f8a9$var$pushLinkImpl($61541ab712b0f8a9$var$stylesheetFlushingQueue, {
            rel: "preload",
            as: "style",
            href: stylesheet.props.href,
            crossOrigin: props.crossOrigin,
            fetchPriority: props.fetchPriority,
            integrity: props.integrity,
            media: props.media,
            hrefLang: props.hrefLang,
            referrerPolicy: props.referrerPolicy
        });
        for(stylesheet = 0; stylesheet < $61541ab712b0f8a9$var$stylesheetFlushingQueue.length; stylesheet++)this.push($61541ab712b0f8a9$var$stylesheetFlushingQueue[stylesheet]);
        $61541ab712b0f8a9$var$stylesheetFlushingQueue.length = 0;
    }
}
function $61541ab712b0f8a9$var$preloadLateStyles(styleQueue) {
    styleQueue.sheets.forEach($61541ab712b0f8a9$var$preloadLateStyle, this);
    styleQueue.sheets.clear();
}
function $61541ab712b0f8a9$var$pushCompletedShellIdAttribute(target, resumableState) {
    0 === (resumableState.instructions & 32) && (resumableState.instructions |= 32, target.push(' id="', $61541ab712b0f8a9$var$escapeTextForBrowser("_" + resumableState.idPrefix + "R_"), '"'));
}
function $61541ab712b0f8a9$var$writeStyleResourceDependenciesInJS(destination, hoistableState) {
    destination.push("[");
    var nextArrayOpenBrackChunk = "[";
    hoistableState.stylesheets.forEach(function(resource) {
        if (2 !== resource.state) {
            if (3 === resource.state) destination.push(nextArrayOpenBrackChunk), resource = $61541ab712b0f8a9$var$escapeJSObjectForInstructionScripts("" + resource.props.href), destination.push(resource), destination.push("]"), nextArrayOpenBrackChunk = ",[";
            else {
                destination.push(nextArrayOpenBrackChunk);
                var precedence = resource.props["data-precedence"], props = resource.props, coercedHref = $61541ab712b0f8a9$var$sanitizeURL("" + resource.props.href);
                coercedHref = $61541ab712b0f8a9$var$escapeJSObjectForInstructionScripts(coercedHref);
                destination.push(coercedHref);
                precedence = "" + precedence;
                destination.push(",");
                precedence = $61541ab712b0f8a9$var$escapeJSObjectForInstructionScripts(precedence);
                destination.push(precedence);
                for(var propKey in props)if ($61541ab712b0f8a9$var$hasOwnProperty.call(props, propKey) && (precedence = props[propKey], null != precedence)) switch(propKey){
                    case "href":
                    case "rel":
                    case "precedence":
                    case "data-precedence":
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(399, "link"));
                    default:
                        $61541ab712b0f8a9$var$writeStyleResourceAttributeInJS(destination, propKey, precedence);
                }
                destination.push("]");
                nextArrayOpenBrackChunk = ",[";
                resource.state = 3;
            }
        }
    });
    destination.push("]");
}
function $61541ab712b0f8a9$var$writeStyleResourceAttributeInJS(destination, name, value) {
    var attributeName = name.toLowerCase();
    switch(typeof value){
        case "function":
        case "symbol":
            return;
    }
    switch(name){
        case "innerHTML":
        case "dangerouslySetInnerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "style":
        case "ref":
            return;
        case "className":
            attributeName = "class";
            name = "" + value;
            break;
        case "hidden":
            if (!1 === value) return;
            name = "";
            break;
        case "src":
        case "href":
            value = $61541ab712b0f8a9$var$sanitizeURL(value);
            name = "" + value;
            break;
        default:
            if (2 < name.length && ("o" === name[0] || "O" === name[0]) && ("n" === name[1] || "N" === name[1]) || !$61541ab712b0f8a9$var$isAttributeNameSafe(name)) return;
            name = "" + value;
    }
    destination.push(",");
    attributeName = $61541ab712b0f8a9$var$escapeJSObjectForInstructionScripts(attributeName);
    destination.push(attributeName);
    destination.push(",");
    attributeName = $61541ab712b0f8a9$var$escapeJSObjectForInstructionScripts(name);
    destination.push(attributeName);
}
function $61541ab712b0f8a9$var$createHoistableState() {
    return {
        styles: new Set(),
        stylesheets: new Set(),
        suspenseyImages: !1
    };
}
function $61541ab712b0f8a9$var$prefetchDNS(href) {
    var request = $61541ab712b0f8a9$var$currentRequest ? $61541ab712b0f8a9$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if ("string" === typeof href && href) {
            if (!resumableState.dnsResources.hasOwnProperty(href)) {
                resumableState.dnsResources[href] = null;
                resumableState = renderState.headers;
                var header, JSCompiler_temp;
                if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity) JSCompiler_temp = (header = "<" + ("" + href).replace($61541ab712b0f8a9$var$regexForHrefInLinkHeaderURLContext, $61541ab712b0f8a9$var$escapeHrefForLinkHeaderURLContextReplacer) + ">; rel=dns-prefetch", 0 <= (resumableState.remainingCapacity -= header.length + 2));
                JSCompiler_temp ? (renderState.resets.dns[href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (header = [], $61541ab712b0f8a9$var$pushLinkImpl(header, {
                    href: href,
                    rel: "dns-prefetch"
                }), renderState.preconnects.add(header));
            }
            $61541ab712b0f8a9$var$enqueueFlush(request);
        }
    } else $61541ab712b0f8a9$var$previousDispatcher.D(href);
}
function $61541ab712b0f8a9$var$preconnect(href, crossOrigin) {
    var request = $61541ab712b0f8a9$var$currentRequest ? $61541ab712b0f8a9$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if ("string" === typeof href && href) {
            var bucket = "use-credentials" === crossOrigin ? "credentials" : "string" === typeof crossOrigin ? "anonymous" : "default";
            if (!resumableState.connectResources[bucket].hasOwnProperty(href)) {
                resumableState.connectResources[bucket][href] = null;
                resumableState = renderState.headers;
                var header, JSCompiler_temp;
                if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity) {
                    JSCompiler_temp = "<" + ("" + href).replace($61541ab712b0f8a9$var$regexForHrefInLinkHeaderURLContext, $61541ab712b0f8a9$var$escapeHrefForLinkHeaderURLContextReplacer) + ">; rel=preconnect";
                    if ("string" === typeof crossOrigin) {
                        var escapedCrossOrigin = ("" + crossOrigin).replace($61541ab712b0f8a9$var$regexForLinkHeaderQuotedParamValueContext, $61541ab712b0f8a9$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer);
                        JSCompiler_temp += '; crossorigin="' + escapedCrossOrigin + '"';
                    }
                    JSCompiler_temp = (header = JSCompiler_temp, 0 <= (resumableState.remainingCapacity -= header.length + 2));
                }
                JSCompiler_temp ? (renderState.resets.connect[bucket][href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (bucket = [], $61541ab712b0f8a9$var$pushLinkImpl(bucket, {
                    rel: "preconnect",
                    href: href,
                    crossOrigin: crossOrigin
                }), renderState.preconnects.add(bucket));
            }
            $61541ab712b0f8a9$var$enqueueFlush(request);
        }
    } else $61541ab712b0f8a9$var$previousDispatcher.C(href, crossOrigin);
}
function $61541ab712b0f8a9$var$preload(href, as, options) {
    var request = $61541ab712b0f8a9$var$currentRequest ? $61541ab712b0f8a9$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (as && href) {
            switch(as){
                case "image":
                    if (options) {
                        var imageSrcSet = options.imageSrcSet;
                        var imageSizes = options.imageSizes;
                        var fetchPriority = options.fetchPriority;
                    }
                    var key = imageSrcSet ? imageSrcSet + "\n" + (imageSizes || "") : href;
                    if (resumableState.imageResources.hasOwnProperty(key)) return;
                    resumableState.imageResources[key] = $61541ab712b0f8a9$var$PRELOAD_NO_CREDS;
                    resumableState = renderState.headers;
                    var header;
                    resumableState && 0 < resumableState.remainingCapacity && "string" !== typeof imageSrcSet && "high" === fetchPriority && (header = $61541ab712b0f8a9$var$getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key] = $61541ab712b0f8a9$var$PRELOAD_NO_CREDS, resumableState.highImagePreloads && (resumableState.highImagePreloads += ", "), resumableState.highImagePreloads += header) : (resumableState = [], $61541ab712b0f8a9$var$pushLinkImpl(resumableState, $61541ab712b0f8a9$var$assign({
                        rel: "preload",
                        href: imageSrcSet ? void 0 : href,
                        as: as
                    }, options)), "high" === fetchPriority ? renderState.highImagePreloads.add(resumableState) : (renderState.bulkPreloads.add(resumableState), renderState.preloads.images.set(key, resumableState)));
                    break;
                case "style":
                    if (resumableState.styleResources.hasOwnProperty(href)) return;
                    imageSrcSet = [];
                    $61541ab712b0f8a9$var$pushLinkImpl(imageSrcSet, $61541ab712b0f8a9$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options));
                    resumableState.styleResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $61541ab712b0f8a9$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    renderState.preloads.stylesheets.set(href, imageSrcSet);
                    renderState.bulkPreloads.add(imageSrcSet);
                    break;
                case "script":
                    if (resumableState.scriptResources.hasOwnProperty(href)) return;
                    imageSrcSet = [];
                    renderState.preloads.scripts.set(href, imageSrcSet);
                    renderState.bulkPreloads.add(imageSrcSet);
                    $61541ab712b0f8a9$var$pushLinkImpl(imageSrcSet, $61541ab712b0f8a9$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options));
                    resumableState.scriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $61541ab712b0f8a9$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    break;
                default:
                    if (resumableState.unknownResources.hasOwnProperty(as)) {
                        if (imageSrcSet = resumableState.unknownResources[as], imageSrcSet.hasOwnProperty(href)) return;
                    } else imageSrcSet = {}, resumableState.unknownResources[as] = imageSrcSet;
                    imageSrcSet[href] = $61541ab712b0f8a9$var$PRELOAD_NO_CREDS;
                    if ((resumableState = renderState.headers) && 0 < resumableState.remainingCapacity && "font" === as && (key = $61541ab712b0f8a9$var$getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= key.length + 2))) renderState.resets.font[href] = $61541ab712b0f8a9$var$PRELOAD_NO_CREDS, resumableState.fontPreloads && (resumableState.fontPreloads += ", "), resumableState.fontPreloads += key;
                    else switch(resumableState = [], href = $61541ab712b0f8a9$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options), $61541ab712b0f8a9$var$pushLinkImpl(resumableState, href), as){
                        case "font":
                            renderState.fontPreloads.add(resumableState);
                            break;
                        default:
                            renderState.bulkPreloads.add(resumableState);
                    }
            }
            $61541ab712b0f8a9$var$enqueueFlush(request);
        }
    } else $61541ab712b0f8a9$var$previousDispatcher.L(href, as, options);
}
function $61541ab712b0f8a9$var$preloadModule(href, options) {
    var request = $61541ab712b0f8a9$var$currentRequest ? $61541ab712b0f8a9$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (href) {
            var as = options && "string" === typeof options.as ? options.as : "script";
            switch(as){
                case "script":
                    if (resumableState.moduleScriptResources.hasOwnProperty(href)) return;
                    as = [];
                    resumableState.moduleScriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $61541ab712b0f8a9$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    renderState.preloads.moduleScripts.set(href, as);
                    break;
                default:
                    if (resumableState.moduleUnknownResources.hasOwnProperty(as)) {
                        var resources = resumableState.unknownResources[as];
                        if (resources.hasOwnProperty(href)) return;
                    } else resources = {}, resumableState.moduleUnknownResources[as] = resources;
                    as = [];
                    resources[href] = $61541ab712b0f8a9$var$PRELOAD_NO_CREDS;
            }
            $61541ab712b0f8a9$var$pushLinkImpl(as, $61541ab712b0f8a9$var$assign({
                rel: "modulepreload",
                href: href
            }, options));
            renderState.bulkPreloads.add(as);
            $61541ab712b0f8a9$var$enqueueFlush(request);
        }
    } else $61541ab712b0f8a9$var$previousDispatcher.m(href, options);
}
function $61541ab712b0f8a9$var$preinitStyle(href, precedence, options) {
    var request = $61541ab712b0f8a9$var$currentRequest ? $61541ab712b0f8a9$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (href) {
            precedence = precedence || "default";
            var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
            null !== resourceState && (resumableState.styleResources[href] = null, styleQueue || (styleQueue = {
                precedence: $61541ab712b0f8a9$var$escapeTextForBrowser(precedence),
                rules: [],
                hrefs: [],
                sheets: new Map()
            }, renderState.styles.set(precedence, styleQueue)), precedence = {
                state: 0,
                props: $61541ab712b0f8a9$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options)
            }, resourceState && (2 === resourceState.length && $61541ab712b0f8a9$var$adoptPreloadCredentials(precedence.props, resourceState), (renderState = renderState.preloads.stylesheets.get(href)) && 0 < renderState.length ? renderState.length = 0 : precedence.state = 1), styleQueue.sheets.set(href, precedence), $61541ab712b0f8a9$var$enqueueFlush(request));
        }
    } else $61541ab712b0f8a9$var$previousDispatcher.S(href, precedence, options);
}
function $61541ab712b0f8a9$var$preinitScript(src, options) {
    var request = $61541ab712b0f8a9$var$currentRequest ? $61541ab712b0f8a9$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (src) {
            var resourceState = resumableState.scriptResources.hasOwnProperty(src) ? resumableState.scriptResources[src] : void 0;
            null !== resourceState && (resumableState.scriptResources[src] = null, options = $61541ab712b0f8a9$var$assign({
                src: src,
                async: !0
            }, options), resourceState && (2 === resourceState.length && $61541ab712b0f8a9$var$adoptPreloadCredentials(options, resourceState), src = renderState.preloads.scripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), $61541ab712b0f8a9$var$pushScriptImpl(src, options), $61541ab712b0f8a9$var$enqueueFlush(request));
        }
    } else $61541ab712b0f8a9$var$previousDispatcher.X(src, options);
}
function $61541ab712b0f8a9$var$preinitModuleScript(src, options) {
    var request = $61541ab712b0f8a9$var$currentRequest ? $61541ab712b0f8a9$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (src) {
            var resourceState = resumableState.moduleScriptResources.hasOwnProperty(src) ? resumableState.moduleScriptResources[src] : void 0;
            null !== resourceState && (resumableState.moduleScriptResources[src] = null, options = $61541ab712b0f8a9$var$assign({
                src: src,
                type: "module",
                async: !0
            }, options), resourceState && (2 === resourceState.length && $61541ab712b0f8a9$var$adoptPreloadCredentials(options, resourceState), src = renderState.preloads.moduleScripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), $61541ab712b0f8a9$var$pushScriptImpl(src, options), $61541ab712b0f8a9$var$enqueueFlush(request));
        }
    } else $61541ab712b0f8a9$var$previousDispatcher.M(src, options);
}
function $61541ab712b0f8a9$var$adoptPreloadCredentials(target, preloadState) {
    null == target.crossOrigin && (target.crossOrigin = preloadState[0]);
    null == target.integrity && (target.integrity = preloadState[1]);
}
function $61541ab712b0f8a9$var$getPreloadAsHeader(href, as, params) {
    href = ("" + href).replace($61541ab712b0f8a9$var$regexForHrefInLinkHeaderURLContext, $61541ab712b0f8a9$var$escapeHrefForLinkHeaderURLContextReplacer);
    as = ("" + as).replace($61541ab712b0f8a9$var$regexForLinkHeaderQuotedParamValueContext, $61541ab712b0f8a9$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer);
    as = "<" + href + '>; rel=preload; as="' + as + '"';
    for(var paramName in params)$61541ab712b0f8a9$var$hasOwnProperty.call(params, paramName) && (href = params[paramName], "string" === typeof href && (as += "; " + paramName.toLowerCase() + '="' + ("" + href).replace($61541ab712b0f8a9$var$regexForLinkHeaderQuotedParamValueContext, $61541ab712b0f8a9$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer) + '"'));
    return as;
}
var $61541ab712b0f8a9$var$regexForHrefInLinkHeaderURLContext = /[<>\r\n]/g;
function $61541ab712b0f8a9$var$escapeHrefForLinkHeaderURLContextReplacer(match) {
    switch(match){
        case "<":
            return "%3C";
        case ">":
            return "%3E";
        case "\n":
            return "%0A";
        case "\r":
            return "%0D";
        default:
            throw Error("escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
}
var $61541ab712b0f8a9$var$regexForLinkHeaderQuotedParamValueContext = /["';,\r\n]/g;
function $61541ab712b0f8a9$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer(match) {
    switch(match){
        case '"':
            return "%22";
        case "'":
            return "%27";
        case ";":
            return "%3B";
        case ",":
            return "%2C";
        case "\n":
            return "%0A";
        case "\r":
            return "%0D";
        default:
            throw Error("escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
}
function $61541ab712b0f8a9$var$hoistStyleQueueDependency(styleQueue) {
    this.styles.add(styleQueue);
}
function $61541ab712b0f8a9$var$hoistStylesheetDependency(stylesheet) {
    this.stylesheets.add(stylesheet);
}
function $61541ab712b0f8a9$var$hoistHoistables(parentState, childState) {
    childState.styles.forEach($61541ab712b0f8a9$var$hoistStyleQueueDependency, parentState);
    childState.stylesheets.forEach($61541ab712b0f8a9$var$hoistStylesheetDependency, parentState);
    childState.suspenseyImages && (parentState.suspenseyImages = !0);
}
function $61541ab712b0f8a9$var$createRenderState(resumableState, generateStaticMarkup) {
    var idPrefix = resumableState.idPrefix, bootstrapChunks = [], bootstrapScriptContent = resumableState.bootstrapScriptContent, bootstrapScripts = resumableState.bootstrapScripts, bootstrapModules = resumableState.bootstrapModules;
    void 0 !== bootstrapScriptContent && (bootstrapChunks.push("<script"), $61541ab712b0f8a9$var$pushCompletedShellIdAttribute(bootstrapChunks, resumableState), bootstrapChunks.push(">", ("" + bootstrapScriptContent).replace($61541ab712b0f8a9$var$scriptRegex, $61541ab712b0f8a9$var$scriptReplacer), "\x3c/script>"));
    bootstrapScriptContent = idPrefix + "P:";
    var JSCompiler_object_inline_segmentPrefix_1673 = idPrefix + "S:";
    idPrefix += "B:";
    var JSCompiler_object_inline_preconnects_1687 = new Set(), JSCompiler_object_inline_fontPreloads_1688 = new Set(), JSCompiler_object_inline_highImagePreloads_1689 = new Set(), JSCompiler_object_inline_styles_1690 = new Map(), JSCompiler_object_inline_bootstrapScripts_1691 = new Set(), JSCompiler_object_inline_scripts_1692 = new Set(), JSCompiler_object_inline_bulkPreloads_1693 = new Set(), JSCompiler_object_inline_preloads_1694 = {
        images: new Map(),
        stylesheets: new Map(),
        scripts: new Map(),
        moduleScripts: new Map()
    };
    if (void 0 !== bootstrapScripts) for(var i = 0; i < bootstrapScripts.length; i++){
        var scriptConfig = bootstrapScripts[i], src, crossOrigin = void 0, integrity = void 0, props = {
            rel: "preload",
            as: "script",
            fetchPriority: "low",
            nonce: void 0
        };
        "string" === typeof scriptConfig ? props.href = src = scriptConfig : (props.href = src = scriptConfig.src, props.integrity = integrity = "string" === typeof scriptConfig.integrity ? scriptConfig.integrity : void 0, props.crossOrigin = crossOrigin = "string" === typeof scriptConfig || null == scriptConfig.crossOrigin ? void 0 : "use-credentials" === scriptConfig.crossOrigin ? "use-credentials" : "");
        scriptConfig = resumableState;
        var href = src;
        scriptConfig.scriptResources[href] = null;
        scriptConfig.moduleScriptResources[href] = null;
        scriptConfig = [];
        $61541ab712b0f8a9$var$pushLinkImpl(scriptConfig, props);
        JSCompiler_object_inline_bootstrapScripts_1691.add(scriptConfig);
        bootstrapChunks.push('<script src="', $61541ab712b0f8a9$var$escapeTextForBrowser(src), '"');
        "string" === typeof integrity && bootstrapChunks.push(' integrity="', $61541ab712b0f8a9$var$escapeTextForBrowser(integrity), '"');
        "string" === typeof crossOrigin && bootstrapChunks.push(' crossorigin="', $61541ab712b0f8a9$var$escapeTextForBrowser(crossOrigin), '"');
        $61541ab712b0f8a9$var$pushCompletedShellIdAttribute(bootstrapChunks, resumableState);
        bootstrapChunks.push(' async="">\x3c/script>');
    }
    if (void 0 !== bootstrapModules) for(bootstrapScripts = 0; bootstrapScripts < bootstrapModules.length; bootstrapScripts++)props = bootstrapModules[bootstrapScripts], crossOrigin = src = void 0, integrity = {
        rel: "modulepreload",
        fetchPriority: "low",
        nonce: void 0
    }, "string" === typeof props ? integrity.href = i = props : (integrity.href = i = props.src, integrity.integrity = crossOrigin = "string" === typeof props.integrity ? props.integrity : void 0, integrity.crossOrigin = src = "string" === typeof props || null == props.crossOrigin ? void 0 : "use-credentials" === props.crossOrigin ? "use-credentials" : ""), props = resumableState, scriptConfig = i, props.scriptResources[scriptConfig] = null, props.moduleScriptResources[scriptConfig] = null, props = [], $61541ab712b0f8a9$var$pushLinkImpl(props, integrity), JSCompiler_object_inline_bootstrapScripts_1691.add(props), bootstrapChunks.push('<script type="module" src="', $61541ab712b0f8a9$var$escapeTextForBrowser(i), '"'), "string" === typeof crossOrigin && bootstrapChunks.push(' integrity="', $61541ab712b0f8a9$var$escapeTextForBrowser(crossOrigin), '"'), "string" === typeof src && bootstrapChunks.push(' crossorigin="', $61541ab712b0f8a9$var$escapeTextForBrowser(src), '"'), $61541ab712b0f8a9$var$pushCompletedShellIdAttribute(bootstrapChunks, resumableState), bootstrapChunks.push(' async="">\x3c/script>');
    return {
        placeholderPrefix: bootstrapScriptContent,
        segmentPrefix: JSCompiler_object_inline_segmentPrefix_1673,
        boundaryPrefix: idPrefix,
        startInlineScript: "<script",
        startInlineStyle: "<style",
        preamble: {
            htmlChunks: null,
            headChunks: null,
            bodyChunks: null
        },
        externalRuntimeScript: null,
        bootstrapChunks: bootstrapChunks,
        importMapChunks: [],
        onHeaders: void 0,
        headers: null,
        resets: {
            font: {},
            dns: {},
            connect: {
                default: {},
                anonymous: {},
                credentials: {}
            },
            image: {},
            style: {}
        },
        charsetChunks: [],
        viewportChunks: [],
        hoistableChunks: [],
        preconnects: JSCompiler_object_inline_preconnects_1687,
        fontPreloads: JSCompiler_object_inline_fontPreloads_1688,
        highImagePreloads: JSCompiler_object_inline_highImagePreloads_1689,
        styles: JSCompiler_object_inline_styles_1690,
        bootstrapScripts: JSCompiler_object_inline_bootstrapScripts_1691,
        scripts: JSCompiler_object_inline_scripts_1692,
        bulkPreloads: JSCompiler_object_inline_bulkPreloads_1693,
        preloads: JSCompiler_object_inline_preloads_1694,
        nonce: {
            script: void 0,
            style: void 0
        },
        stylesToHoist: !1,
        generateStaticMarkup: generateStaticMarkup
    };
}
function $61541ab712b0f8a9$var$pushTextInstance(target, text, renderState, textEmbedded) {
    if (renderState.generateStaticMarkup) return target.push($61541ab712b0f8a9$var$escapeTextForBrowser(text)), !1;
    "" === text ? target = textEmbedded : (textEmbedded && target.push("\x3c!-- --\x3e"), target.push($61541ab712b0f8a9$var$escapeTextForBrowser(text)), target = !0);
    return target;
}
function $61541ab712b0f8a9$var$pushSegmentFinale(target, renderState, lastPushedText, textEmbedded) {
    renderState.generateStaticMarkup || lastPushedText && textEmbedded && target.push("\x3c!-- --\x3e");
}
var $61541ab712b0f8a9$var$bind = Function.prototype.bind, $61541ab712b0f8a9$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $61541ab712b0f8a9$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $61541ab712b0f8a9$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $61541ab712b0f8a9$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $61541ab712b0f8a9$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $61541ab712b0f8a9$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $61541ab712b0f8a9$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $61541ab712b0f8a9$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $61541ab712b0f8a9$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $61541ab712b0f8a9$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $61541ab712b0f8a9$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $61541ab712b0f8a9$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $61541ab712b0f8a9$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $61541ab712b0f8a9$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $61541ab712b0f8a9$var$getComponentNameFromType(type.type) || "Memo";
        case $61541ab712b0f8a9$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $61541ab712b0f8a9$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $61541ab712b0f8a9$var$emptyContextObject = {}, $61541ab712b0f8a9$var$currentActiveSnapshot = null;
function $61541ab712b0f8a9$var$popToNearestCommonAncestor(prev, next) {
    if (prev !== next) {
        prev.context._currentValue2 = prev.parentValue;
        prev = prev.parent;
        var parentNext = next.parent;
        if (null === prev) {
            if (null !== parentNext) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(401));
        } else {
            if (null === parentNext) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(401));
            $61541ab712b0f8a9$var$popToNearestCommonAncestor(prev, parentNext);
        }
        next.context._currentValue2 = next.value;
    }
}
function $61541ab712b0f8a9$var$popAllPrevious(prev) {
    prev.context._currentValue2 = prev.parentValue;
    prev = prev.parent;
    null !== prev && $61541ab712b0f8a9$var$popAllPrevious(prev);
}
function $61541ab712b0f8a9$var$pushAllNext(next) {
    var parentNext = next.parent;
    null !== parentNext && $61541ab712b0f8a9$var$pushAllNext(parentNext);
    next.context._currentValue2 = next.value;
}
function $61541ab712b0f8a9$var$popPreviousToCommonLevel(prev, next) {
    prev.context._currentValue2 = prev.parentValue;
    prev = prev.parent;
    if (null === prev) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(402));
    prev.depth === next.depth ? $61541ab712b0f8a9$var$popToNearestCommonAncestor(prev, next) : $61541ab712b0f8a9$var$popPreviousToCommonLevel(prev, next);
}
function $61541ab712b0f8a9$var$popNextToCommonLevel(prev, next) {
    var parentNext = next.parent;
    if (null === parentNext) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(402));
    prev.depth === parentNext.depth ? $61541ab712b0f8a9$var$popToNearestCommonAncestor(prev, parentNext) : $61541ab712b0f8a9$var$popNextToCommonLevel(prev, parentNext);
    next.context._currentValue2 = next.value;
}
function $61541ab712b0f8a9$var$switchContext(newSnapshot) {
    var prev = $61541ab712b0f8a9$var$currentActiveSnapshot;
    prev !== newSnapshot && (null === prev ? $61541ab712b0f8a9$var$pushAllNext(newSnapshot) : null === newSnapshot ? $61541ab712b0f8a9$var$popAllPrevious(prev) : prev.depth === newSnapshot.depth ? $61541ab712b0f8a9$var$popToNearestCommonAncestor(prev, newSnapshot) : prev.depth > newSnapshot.depth ? $61541ab712b0f8a9$var$popPreviousToCommonLevel(prev, newSnapshot) : $61541ab712b0f8a9$var$popNextToCommonLevel(prev, newSnapshot), $61541ab712b0f8a9$var$currentActiveSnapshot = newSnapshot);
}
var $61541ab712b0f8a9$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload) {
        inst = inst._reactInternals;
        null !== inst.queue && inst.queue.push(payload);
    },
    enqueueReplaceState: function(inst, payload) {
        inst = inst._reactInternals;
        inst.replace = !0;
        inst.queue = [
            payload
        ];
    },
    enqueueForceUpdate: function() {}
}, $61541ab712b0f8a9$var$emptyTreeContext = {
    id: 1,
    overflow: ""
};
function $61541ab712b0f8a9$var$pushTreeContext(baseContext, totalChildren, index) {
    var baseIdWithLeadingBit = baseContext.id;
    baseContext = baseContext.overflow;
    var baseLength = 32 - $61541ab712b0f8a9$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $61541ab712b0f8a9$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        return {
            id: 1 << 32 - $61541ab712b0f8a9$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit,
            overflow: length + baseContext
        };
    }
    return {
        id: 1 << length | index << baseLength | baseIdWithLeadingBit,
        overflow: baseContext
    };
}
var $61541ab712b0f8a9$var$clz32 = Math.clz32 ? Math.clz32 : $61541ab712b0f8a9$var$clz32Fallback, $61541ab712b0f8a9$var$log = Math.log, $61541ab712b0f8a9$var$LN2 = Math.LN2;
function $61541ab712b0f8a9$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($61541ab712b0f8a9$var$log(x) / $61541ab712b0f8a9$var$LN2 | 0) | 0;
}
function $61541ab712b0f8a9$var$noop() {}
var $61541ab712b0f8a9$var$SuspenseException = Error($61541ab712b0f8a9$var$formatProdErrorMessage(460));
function $61541ab712b0f8a9$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($61541ab712b0f8a9$var$noop, $61541ab712b0f8a9$var$noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then($61541ab712b0f8a9$var$noop, $61541ab712b0f8a9$var$noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            $61541ab712b0f8a9$var$suspendedThenable = thenable;
            throw $61541ab712b0f8a9$var$SuspenseException;
    }
}
var $61541ab712b0f8a9$var$suspendedThenable = null;
function $61541ab712b0f8a9$var$getSuspendedThenable() {
    if (null === $61541ab712b0f8a9$var$suspendedThenable) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(459));
    var thenable = $61541ab712b0f8a9$var$suspendedThenable;
    $61541ab712b0f8a9$var$suspendedThenable = null;
    return thenable;
}
function $61541ab712b0f8a9$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $61541ab712b0f8a9$var$objectIs = "function" === typeof Object.is ? Object.is : $61541ab712b0f8a9$var$is, $61541ab712b0f8a9$var$currentlyRenderingComponent = null, $61541ab712b0f8a9$var$currentlyRenderingTask = null, $61541ab712b0f8a9$var$currentlyRenderingRequest = null, $61541ab712b0f8a9$var$currentlyRenderingKeyPath = null, $61541ab712b0f8a9$var$firstWorkInProgressHook = null, $61541ab712b0f8a9$var$workInProgressHook = null, $61541ab712b0f8a9$var$isReRender = !1, $61541ab712b0f8a9$var$didScheduleRenderPhaseUpdate = !1, $61541ab712b0f8a9$var$localIdCounter = 0, $61541ab712b0f8a9$var$actionStateCounter = 0, $61541ab712b0f8a9$var$actionStateMatchingIndex = -1, $61541ab712b0f8a9$var$thenableIndexCounter = 0, $61541ab712b0f8a9$var$thenableState = null, $61541ab712b0f8a9$var$renderPhaseUpdates = null, $61541ab712b0f8a9$var$numberOfReRenders = 0;
function $61541ab712b0f8a9$var$resolveCurrentlyRenderingComponent() {
    if (null === $61541ab712b0f8a9$var$currentlyRenderingComponent) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(321));
    return $61541ab712b0f8a9$var$currentlyRenderingComponent;
}
function $61541ab712b0f8a9$var$createHook() {
    if (0 < $61541ab712b0f8a9$var$numberOfReRenders) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $61541ab712b0f8a9$var$createWorkInProgressHook() {
    null === $61541ab712b0f8a9$var$workInProgressHook ? null === $61541ab712b0f8a9$var$firstWorkInProgressHook ? ($61541ab712b0f8a9$var$isReRender = !1, $61541ab712b0f8a9$var$firstWorkInProgressHook = $61541ab712b0f8a9$var$workInProgressHook = $61541ab712b0f8a9$var$createHook()) : ($61541ab712b0f8a9$var$isReRender = !0, $61541ab712b0f8a9$var$workInProgressHook = $61541ab712b0f8a9$var$firstWorkInProgressHook) : null === $61541ab712b0f8a9$var$workInProgressHook.next ? ($61541ab712b0f8a9$var$isReRender = !1, $61541ab712b0f8a9$var$workInProgressHook = $61541ab712b0f8a9$var$workInProgressHook.next = $61541ab712b0f8a9$var$createHook()) : ($61541ab712b0f8a9$var$isReRender = !0, $61541ab712b0f8a9$var$workInProgressHook = $61541ab712b0f8a9$var$workInProgressHook.next);
    return $61541ab712b0f8a9$var$workInProgressHook;
}
function $61541ab712b0f8a9$var$getThenableStateAfterSuspending() {
    var state = $61541ab712b0f8a9$var$thenableState;
    $61541ab712b0f8a9$var$thenableState = null;
    return state;
}
function $61541ab712b0f8a9$var$resetHooksState() {
    $61541ab712b0f8a9$var$currentlyRenderingKeyPath = $61541ab712b0f8a9$var$currentlyRenderingRequest = $61541ab712b0f8a9$var$currentlyRenderingTask = $61541ab712b0f8a9$var$currentlyRenderingComponent = null;
    $61541ab712b0f8a9$var$didScheduleRenderPhaseUpdate = !1;
    $61541ab712b0f8a9$var$firstWorkInProgressHook = null;
    $61541ab712b0f8a9$var$numberOfReRenders = 0;
    $61541ab712b0f8a9$var$workInProgressHook = $61541ab712b0f8a9$var$renderPhaseUpdates = null;
}
function $61541ab712b0f8a9$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $61541ab712b0f8a9$var$useReducer(reducer, initialArg, init) {
    $61541ab712b0f8a9$var$currentlyRenderingComponent = $61541ab712b0f8a9$var$resolveCurrentlyRenderingComponent();
    $61541ab712b0f8a9$var$workInProgressHook = $61541ab712b0f8a9$var$createWorkInProgressHook();
    if ($61541ab712b0f8a9$var$isReRender) {
        var queue = $61541ab712b0f8a9$var$workInProgressHook.queue;
        initialArg = queue.dispatch;
        if (null !== $61541ab712b0f8a9$var$renderPhaseUpdates && (init = $61541ab712b0f8a9$var$renderPhaseUpdates.get(queue), void 0 !== init)) {
            $61541ab712b0f8a9$var$renderPhaseUpdates.delete(queue);
            queue = $61541ab712b0f8a9$var$workInProgressHook.memoizedState;
            do queue = reducer(queue, init.action), init = init.next;
            while (null !== init);
            $61541ab712b0f8a9$var$workInProgressHook.memoizedState = queue;
            return [
                queue,
                initialArg
            ];
        }
        return [
            $61541ab712b0f8a9$var$workInProgressHook.memoizedState,
            initialArg
        ];
    }
    reducer = reducer === $61541ab712b0f8a9$var$basicStateReducer ? "function" === typeof initialArg ? initialArg() : initialArg : void 0 !== init ? init(initialArg) : initialArg;
    $61541ab712b0f8a9$var$workInProgressHook.memoizedState = reducer;
    reducer = $61541ab712b0f8a9$var$workInProgressHook.queue = {
        last: null,
        dispatch: null
    };
    reducer = reducer.dispatch = $61541ab712b0f8a9$var$dispatchAction.bind(null, $61541ab712b0f8a9$var$currentlyRenderingComponent, reducer);
    return [
        $61541ab712b0f8a9$var$workInProgressHook.memoizedState,
        reducer
    ];
}
function $61541ab712b0f8a9$var$useMemo(nextCreate, deps) {
    $61541ab712b0f8a9$var$currentlyRenderingComponent = $61541ab712b0f8a9$var$resolveCurrentlyRenderingComponent();
    $61541ab712b0f8a9$var$workInProgressHook = $61541ab712b0f8a9$var$createWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    if (null !== $61541ab712b0f8a9$var$workInProgressHook) {
        var prevState = $61541ab712b0f8a9$var$workInProgressHook.memoizedState;
        if (null !== prevState && null !== deps) {
            var prevDeps = prevState[1];
            a: if (null === prevDeps) prevDeps = !1;
            else {
                for(var i = 0; i < prevDeps.length && i < deps.length; i++)if (!$61541ab712b0f8a9$var$objectIs(deps[i], prevDeps[i])) {
                    prevDeps = !1;
                    break a;
                }
                prevDeps = !0;
            }
            if (prevDeps) return prevState[0];
        }
    }
    nextCreate = nextCreate();
    $61541ab712b0f8a9$var$workInProgressHook.memoizedState = [
        nextCreate,
        deps
    ];
    return nextCreate;
}
function $61541ab712b0f8a9$var$dispatchAction(componentIdentity, queue, action) {
    if (25 <= $61541ab712b0f8a9$var$numberOfReRenders) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(301));
    if (componentIdentity === $61541ab712b0f8a9$var$currentlyRenderingComponent) {
        if ($61541ab712b0f8a9$var$didScheduleRenderPhaseUpdate = !0, componentIdentity = {
            action: action,
            next: null
        }, null === $61541ab712b0f8a9$var$renderPhaseUpdates && ($61541ab712b0f8a9$var$renderPhaseUpdates = new Map()), action = $61541ab712b0f8a9$var$renderPhaseUpdates.get(queue), void 0 === action) $61541ab712b0f8a9$var$renderPhaseUpdates.set(queue, componentIdentity);
        else {
            for(queue = action; null !== queue.next;)queue = queue.next;
            queue.next = componentIdentity;
        }
    }
}
function $61541ab712b0f8a9$var$throwOnUseEffectEventCall() {
    throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(440));
}
function $61541ab712b0f8a9$var$unsupportedStartTransition() {
    throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(394));
}
function $61541ab712b0f8a9$var$unsupportedSetOptimisticState() {
    throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(479));
}
function $61541ab712b0f8a9$var$useActionState(action, initialState, permalink) {
    $61541ab712b0f8a9$var$resolveCurrentlyRenderingComponent();
    var actionStateHookIndex = $61541ab712b0f8a9$var$actionStateCounter++, request = $61541ab712b0f8a9$var$currentlyRenderingRequest;
    if ("function" === typeof action.$$FORM_ACTION) {
        var nextPostbackStateKey = null, componentKeyPath = $61541ab712b0f8a9$var$currentlyRenderingKeyPath;
        request = request.formState;
        var isSignatureEqual = action.$$IS_SIGNATURE_EQUAL;
        if (null !== request && "function" === typeof isSignatureEqual) {
            var postbackKey = request[1];
            isSignatureEqual.call(action, request[2], request[3]) && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + $61541ab712b0f8a9$var$murmurhash3_32_gc(JSON.stringify([
                componentKeyPath,
                null,
                actionStateHookIndex
            ]), 0), postbackKey === nextPostbackStateKey && ($61541ab712b0f8a9$var$actionStateMatchingIndex = actionStateHookIndex, initialState = request[0]));
        }
        var boundAction = action.bind(null, initialState);
        action = function(payload) {
            boundAction(payload);
        };
        "function" === typeof boundAction.$$FORM_ACTION && (action.$$FORM_ACTION = function(prefix) {
            prefix = boundAction.$$FORM_ACTION(prefix);
            void 0 !== permalink && (permalink += "", prefix.action = permalink);
            var formData = prefix.data;
            formData && (null === nextPostbackStateKey && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + $61541ab712b0f8a9$var$murmurhash3_32_gc(JSON.stringify([
                componentKeyPath,
                null,
                actionStateHookIndex
            ]), 0)), formData.append("$ACTION_KEY", nextPostbackStateKey));
            return prefix;
        });
        return [
            initialState,
            action,
            !1
        ];
    }
    var boundAction$22 = action.bind(null, initialState);
    return [
        initialState,
        function(payload) {
            boundAction$22(payload);
        },
        !1
    ];
}
function $61541ab712b0f8a9$var$unwrapThenable(thenable) {
    var index = $61541ab712b0f8a9$var$thenableIndexCounter;
    $61541ab712b0f8a9$var$thenableIndexCounter += 1;
    null === $61541ab712b0f8a9$var$thenableState && ($61541ab712b0f8a9$var$thenableState = []);
    return $61541ab712b0f8a9$var$trackUsedThenable($61541ab712b0f8a9$var$thenableState, thenable, index);
}
function $61541ab712b0f8a9$var$unsupportedRefresh() {
    throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(393));
}
var $61541ab712b0f8a9$var$HooksDispatcher = {
    readContext: function(context) {
        return context._currentValue2;
    },
    use: function(usable) {
        if (null !== usable && "object" === typeof usable) {
            if ("function" === typeof usable.then) return $61541ab712b0f8a9$var$unwrapThenable(usable);
            if (usable.$$typeof === $61541ab712b0f8a9$var$REACT_CONTEXT_TYPE) return usable._currentValue2;
        }
        throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(438, String(usable)));
    },
    useContext: function(context) {
        $61541ab712b0f8a9$var$resolveCurrentlyRenderingComponent();
        return context._currentValue2;
    },
    useMemo: $61541ab712b0f8a9$var$useMemo,
    useReducer: $61541ab712b0f8a9$var$useReducer,
    useRef: function(initialValue) {
        $61541ab712b0f8a9$var$currentlyRenderingComponent = $61541ab712b0f8a9$var$resolveCurrentlyRenderingComponent();
        $61541ab712b0f8a9$var$workInProgressHook = $61541ab712b0f8a9$var$createWorkInProgressHook();
        var previousRef = $61541ab712b0f8a9$var$workInProgressHook.memoizedState;
        return null === previousRef ? (initialValue = {
            current: initialValue
        }, $61541ab712b0f8a9$var$workInProgressHook.memoizedState = initialValue) : previousRef;
    },
    useState: function(initialState) {
        return $61541ab712b0f8a9$var$useReducer($61541ab712b0f8a9$var$basicStateReducer, initialState);
    },
    useInsertionEffect: $61541ab712b0f8a9$var$noop,
    useLayoutEffect: $61541ab712b0f8a9$var$noop,
    useCallback: function(callback, deps) {
        return $61541ab712b0f8a9$var$useMemo(function() {
            return callback;
        }, deps);
    },
    useImperativeHandle: $61541ab712b0f8a9$var$noop,
    useEffect: $61541ab712b0f8a9$var$noop,
    useDebugValue: $61541ab712b0f8a9$var$noop,
    useDeferredValue: function(value, initialValue) {
        $61541ab712b0f8a9$var$resolveCurrentlyRenderingComponent();
        return void 0 !== initialValue ? initialValue : value;
    },
    useTransition: function() {
        $61541ab712b0f8a9$var$resolveCurrentlyRenderingComponent();
        return [
            !1,
            $61541ab712b0f8a9$var$unsupportedStartTransition
        ];
    },
    useId: function() {
        var JSCompiler_inline_result = $61541ab712b0f8a9$var$currentlyRenderingTask.treeContext;
        var overflow = JSCompiler_inline_result.overflow;
        JSCompiler_inline_result = JSCompiler_inline_result.id;
        JSCompiler_inline_result = (JSCompiler_inline_result & ~(1 << 32 - $61541ab712b0f8a9$var$clz32(JSCompiler_inline_result) - 1)).toString(32) + overflow;
        var resumableState = $61541ab712b0f8a9$var$currentResumableState;
        if (null === resumableState) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(404));
        overflow = $61541ab712b0f8a9$var$localIdCounter++;
        JSCompiler_inline_result = "_" + resumableState.idPrefix + "R_" + JSCompiler_inline_result;
        0 < overflow && (JSCompiler_inline_result += "H" + overflow.toString(32));
        return JSCompiler_inline_result + "_";
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        if (void 0 === getServerSnapshot) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(407));
        return getServerSnapshot();
    },
    useOptimistic: function(passthrough) {
        $61541ab712b0f8a9$var$resolveCurrentlyRenderingComponent();
        return [
            passthrough,
            $61541ab712b0f8a9$var$unsupportedSetOptimisticState
        ];
    },
    useActionState: $61541ab712b0f8a9$var$useActionState,
    useFormState: $61541ab712b0f8a9$var$useActionState,
    useHostTransitionStatus: function() {
        $61541ab712b0f8a9$var$resolveCurrentlyRenderingComponent();
        return $61541ab712b0f8a9$var$sharedNotPendingObject;
    },
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = $61541ab712b0f8a9$var$REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return $61541ab712b0f8a9$var$unsupportedRefresh;
    },
    useEffectEvent: function() {
        return $61541ab712b0f8a9$var$throwOnUseEffectEventCall;
    }
}, $61541ab712b0f8a9$var$currentResumableState = null, $61541ab712b0f8a9$var$DefaultAsyncDispatcher = {
    getCacheForType: function() {
        throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(248));
    },
    cacheSignal: function() {
        throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(248));
    }
}, $61541ab712b0f8a9$var$prefix, $61541ab712b0f8a9$var$suffix;
function $61541ab712b0f8a9$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $61541ab712b0f8a9$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $61541ab712b0f8a9$var$prefix = match && match[1] || "";
        $61541ab712b0f8a9$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $61541ab712b0f8a9$var$prefix + name + $61541ab712b0f8a9$var$suffix;
}
var $61541ab712b0f8a9$var$reentry = !1;
function $61541ab712b0f8a9$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $61541ab712b0f8a9$var$reentry) return "";
    $61541ab712b0f8a9$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$24) {
                                control = x$24;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$25) {
                            control = x$25;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $61541ab712b0f8a9$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $61541ab712b0f8a9$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $61541ab712b0f8a9$var$describeComponentStackByType(type) {
    if ("string" === typeof type) return $61541ab712b0f8a9$var$describeBuiltInComponentFrame(type);
    if ("function" === typeof type) return type.prototype && type.prototype.isReactComponent ? $61541ab712b0f8a9$var$describeNativeComponentFrame(type, !0) : $61541ab712b0f8a9$var$describeNativeComponentFrame(type, !1);
    if ("object" === typeof type && null !== type) {
        switch(type.$$typeof){
            case $61541ab712b0f8a9$var$REACT_FORWARD_REF_TYPE:
                return $61541ab712b0f8a9$var$describeNativeComponentFrame(type.render, !1);
            case $61541ab712b0f8a9$var$REACT_MEMO_TYPE:
                return $61541ab712b0f8a9$var$describeNativeComponentFrame(type.type, !1);
            case $61541ab712b0f8a9$var$REACT_LAZY_TYPE:
                var lazyComponent = type, payload = lazyComponent._payload;
                lazyComponent = lazyComponent._init;
                try {
                    type = lazyComponent(payload);
                } catch (x) {
                    return $61541ab712b0f8a9$var$describeBuiltInComponentFrame("Lazy");
                }
                return $61541ab712b0f8a9$var$describeComponentStackByType(type);
        }
        if ("string" === typeof type.name) {
            a: {
                payload = type.name;
                lazyComponent = type.env;
                var location = type.debugLocation;
                if (null != location && (type = Error.prepareStackTrace, Error.prepareStackTrace = void 0, location = location.stack, Error.prepareStackTrace = type, location.startsWith("Error: react-stack-top-frame\n") && (location = location.slice(29)), type = location.indexOf("\n"), -1 !== type && (location = location.slice(type + 1)), type = location.indexOf("react_stack_bottom_frame"), -1 !== type && (type = location.lastIndexOf("\n", type)), type = -1 !== type ? location = location.slice(0, type) : "", location = type.lastIndexOf("\n"), type = -1 === location ? type : type.slice(location + 1), -1 !== type.indexOf(payload))) {
                    payload = "\n" + type;
                    break a;
                }
                payload = $61541ab712b0f8a9$var$describeBuiltInComponentFrame(payload + (lazyComponent ? " [" + lazyComponent + "]" : ""));
            }
            return payload;
        }
    }
    switch(type){
        case $61541ab712b0f8a9$var$REACT_SUSPENSE_LIST_TYPE:
            return $61541ab712b0f8a9$var$describeBuiltInComponentFrame("SuspenseList");
        case $61541ab712b0f8a9$var$REACT_SUSPENSE_TYPE:
            return $61541ab712b0f8a9$var$describeBuiltInComponentFrame("Suspense");
    }
    return "";
}
function $61541ab712b0f8a9$var$isEligibleForOutlining(request, boundary) {
    return (500 < boundary.byteSize || !1) && null === boundary.contentPreamble;
}
function $61541ab712b0f8a9$var$defaultErrorHandler(error) {
    if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
        var JSCompiler_inline_result = error.environmentName;
        error = [
            error
        ].slice(0);
        "string" === typeof error[0] ? error.splice(0, 1, "[%s] " + error[0], " " + JSCompiler_inline_result + " ") : error.splice(0, 0, "[%s]", " " + JSCompiler_inline_result + " ");
        error.unshift(console);
        JSCompiler_inline_result = $61541ab712b0f8a9$var$bind.apply(console.error, error);
        JSCompiler_inline_result();
    } else console.error(error);
    return null;
}
function $61541ab712b0f8a9$var$RequestInstance(resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    var abortSet = new Set();
    this.destination = null;
    this.flushScheduled = !1;
    this.resumableState = resumableState;
    this.renderState = renderState;
    this.rootFormatContext = rootFormatContext;
    this.progressiveChunkSize = void 0 === progressiveChunkSize ? 12800 : progressiveChunkSize;
    this.status = 10;
    this.fatalError = null;
    this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0;
    this.completedPreambleSegments = this.completedRootSegment = null;
    this.byteSize = 0;
    this.abortableTasks = abortSet;
    this.pingedTasks = [];
    this.clientRenderedBoundaries = [];
    this.completedBoundaries = [];
    this.partialBoundaries = [];
    this.trackedPostpones = null;
    this.onError = void 0 === onError ? $61541ab712b0f8a9$var$defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? $61541ab712b0f8a9$var$noop : onPostpone;
    this.onAllReady = void 0 === onAllReady ? $61541ab712b0f8a9$var$noop : onAllReady;
    this.onShellReady = void 0 === onShellReady ? $61541ab712b0f8a9$var$noop : onShellReady;
    this.onShellError = void 0 === onShellError ? $61541ab712b0f8a9$var$noop : onShellError;
    this.onFatalError = void 0 === onFatalError ? $61541ab712b0f8a9$var$noop : onFatalError;
    this.formState = void 0 === formState ? null : formState;
}
function $61541ab712b0f8a9$var$createRequest(children, resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    resumableState = new $61541ab712b0f8a9$var$RequestInstance(resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState);
    renderState = $61541ab712b0f8a9$var$createPendingSegment(resumableState, 0, null, rootFormatContext, !1, !1);
    renderState.parentFlushed = !0;
    children = $61541ab712b0f8a9$var$createRenderTask(resumableState, null, children, -1, null, renderState, null, null, resumableState.abortableTasks, null, rootFormatContext, null, $61541ab712b0f8a9$var$emptyTreeContext, null, null);
    $61541ab712b0f8a9$var$pushComponentStack(children);
    resumableState.pingedTasks.push(children);
    return resumableState;
}
var $61541ab712b0f8a9$var$currentRequest = null;
function $61541ab712b0f8a9$var$pingTask(request, task) {
    request.pingedTasks.push(task);
    1 === request.pingedTasks.length && (request.flushScheduled = null !== request.destination, $61541ab712b0f8a9$var$performWork(request));
}
function $61541ab712b0f8a9$var$createSuspenseBoundary(request, row, fallbackAbortableTasks, contentPreamble, fallbackPreamble) {
    fallbackAbortableTasks = {
        status: 0,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        row: row,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: fallbackAbortableTasks,
        errorDigest: null,
        contentState: $61541ab712b0f8a9$var$createHoistableState(),
        fallbackState: $61541ab712b0f8a9$var$createHoistableState(),
        contentPreamble: contentPreamble,
        fallbackPreamble: fallbackPreamble,
        trackedContentKeyPath: null,
        trackedFallbackNode: null
    };
    null !== row && (row.pendingTasks++, contentPreamble = row.boundaries, null !== contentPreamble && (request.allPendingTasks++, fallbackAbortableTasks.pendingTasks++, contentPreamble.push(fallbackAbortableTasks)), request = row.inheritedHoistables, null !== request && $61541ab712b0f8a9$var$hoistHoistables(fallbackAbortableTasks.contentState, request));
    return fallbackAbortableTasks;
}
function $61541ab712b0f8a9$var$createRenderTask(request, thenableState, node, childIndex, blockedBoundary, blockedSegment, blockedPreamble, hoistableState, abortSet, keyPath, formatContext, context, treeContext, row, componentStack) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    null !== row && row.pendingTasks++;
    var task = {
        replay: null,
        node: node,
        childIndex: childIndex,
        ping: function() {
            return $61541ab712b0f8a9$var$pingTask(request, task);
        },
        blockedBoundary: blockedBoundary,
        blockedSegment: blockedSegment,
        blockedPreamble: blockedPreamble,
        hoistableState: hoistableState,
        abortSet: abortSet,
        keyPath: keyPath,
        formatContext: formatContext,
        context: context,
        treeContext: treeContext,
        row: row,
        componentStack: componentStack,
        thenableState: thenableState
    };
    abortSet.add(task);
    return task;
}
function $61541ab712b0f8a9$var$createReplayTask(request, thenableState, replay, node, childIndex, blockedBoundary, hoistableState, abortSet, keyPath, formatContext, context, treeContext, row, componentStack) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    null !== row && row.pendingTasks++;
    replay.pendingTasks++;
    var task = {
        replay: replay,
        node: node,
        childIndex: childIndex,
        ping: function() {
            return $61541ab712b0f8a9$var$pingTask(request, task);
        },
        blockedBoundary: blockedBoundary,
        blockedSegment: null,
        blockedPreamble: null,
        hoistableState: hoistableState,
        abortSet: abortSet,
        keyPath: keyPath,
        formatContext: formatContext,
        context: context,
        treeContext: treeContext,
        row: row,
        componentStack: componentStack,
        thenableState: thenableState
    };
    abortSet.add(task);
    return task;
}
function $61541ab712b0f8a9$var$createPendingSegment(request, index, boundary, parentFormatContext, lastPushedText, textEmbedded) {
    return {
        status: 0,
        parentFlushed: !1,
        id: -1,
        index: index,
        chunks: [],
        children: [],
        preambleChildren: [],
        parentFormatContext: parentFormatContext,
        boundary: boundary,
        lastPushedText: lastPushedText,
        textEmbedded: textEmbedded
    };
}
function $61541ab712b0f8a9$var$pushComponentStack(task) {
    var node = task.node;
    if ("object" === typeof node && null !== node) switch(node.$$typeof){
        case $61541ab712b0f8a9$var$REACT_ELEMENT_TYPE:
            task.componentStack = {
                parent: task.componentStack,
                type: node.type
            };
    }
}
function $61541ab712b0f8a9$var$replaceSuspenseComponentStackWithSuspenseFallbackStack(componentStack) {
    return null === componentStack ? null : {
        parent: componentStack.parent,
        type: "Suspense Fallback"
    };
}
function $61541ab712b0f8a9$var$getThrownInfo(node$jscomp$0) {
    var errorInfo = {};
    node$jscomp$0 && Object.defineProperty(errorInfo, "componentStack", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            try {
                var info = "", node = node$jscomp$0;
                do info += $61541ab712b0f8a9$var$describeComponentStackByType(node.type), node = node.parent;
                while (node);
                var JSCompiler_inline_result = info;
            } catch (x) {
                JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
            }
            Object.defineProperty(errorInfo, "componentStack", {
                value: JSCompiler_inline_result
            });
            return JSCompiler_inline_result;
        }
    });
    return errorInfo;
}
function $61541ab712b0f8a9$var$logRecoverableError(request, error, errorInfo) {
    request = request.onError;
    error = request(error, errorInfo);
    if (null == error || "string" === typeof error) return error;
}
function $61541ab712b0f8a9$var$fatalError(request, error) {
    var onShellError = request.onShellError, onFatalError = request.onFatalError;
    onShellError(error);
    onFatalError(error);
    null !== request.destination ? (request.status = 14, request.destination.destroy(error)) : (request.status = 13, request.fatalError = error);
}
function $61541ab712b0f8a9$var$finishSuspenseListRow(request, row) {
    $61541ab712b0f8a9$var$unblockSuspenseListRow(request, row.next, row.hoistables);
}
function $61541ab712b0f8a9$var$unblockSuspenseListRow(request, unblockedRow, inheritedHoistables) {
    for(; null !== unblockedRow;){
        null !== inheritedHoistables && ($61541ab712b0f8a9$var$hoistHoistables(unblockedRow.hoistables, inheritedHoistables), unblockedRow.inheritedHoistables = inheritedHoistables);
        var unblockedBoundaries = unblockedRow.boundaries;
        if (null !== unblockedBoundaries) {
            unblockedRow.boundaries = null;
            for(var i = 0; i < unblockedBoundaries.length; i++){
                var unblockedBoundary = unblockedBoundaries[i];
                null !== inheritedHoistables && $61541ab712b0f8a9$var$hoistHoistables(unblockedBoundary.contentState, inheritedHoistables);
                $61541ab712b0f8a9$var$finishedTask(request, unblockedBoundary, null, null);
            }
        }
        unblockedRow.pendingTasks--;
        if (0 < unblockedRow.pendingTasks) break;
        inheritedHoistables = unblockedRow.hoistables;
        unblockedRow = unblockedRow.next;
    }
}
function $61541ab712b0f8a9$var$tryToResolveTogetherRow(request, togetherRow) {
    var boundaries = togetherRow.boundaries;
    if (null !== boundaries && togetherRow.pendingTasks === boundaries.length) {
        for(var allCompleteAndInlinable = !0, i = 0; i < boundaries.length; i++){
            var rowBoundary = boundaries[i];
            if (1 !== rowBoundary.pendingTasks || rowBoundary.parentFlushed || $61541ab712b0f8a9$var$isEligibleForOutlining(request, rowBoundary)) {
                allCompleteAndInlinable = !1;
                break;
            }
        }
        allCompleteAndInlinable && $61541ab712b0f8a9$var$unblockSuspenseListRow(request, togetherRow, togetherRow.hoistables);
    }
}
function $61541ab712b0f8a9$var$createSuspenseListRow(previousRow) {
    var newRow = {
        pendingTasks: 1,
        boundaries: null,
        hoistables: $61541ab712b0f8a9$var$createHoistableState(),
        inheritedHoistables: null,
        together: !1,
        next: null
    };
    null !== previousRow && 0 < previousRow.pendingTasks && (newRow.pendingTasks++, newRow.boundaries = [], previousRow.next = newRow);
    return newRow;
}
function $61541ab712b0f8a9$var$renderSuspenseListRows(request, task, keyPath, rows, revealOrder) {
    var prevKeyPath = task.keyPath, prevTreeContext = task.treeContext, prevRow = task.row;
    task.keyPath = keyPath;
    keyPath = rows.length;
    var previousSuspenseListRow = null;
    if (null !== task.replay) {
        var resumeSlots = task.replay.slots;
        if (null !== resumeSlots && "object" === typeof resumeSlots) for(var n = 0; n < keyPath; n++){
            var i = "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder ? n : keyPath - 1 - n, node = rows[i];
            task.row = previousSuspenseListRow = $61541ab712b0f8a9$var$createSuspenseListRow(previousSuspenseListRow);
            task.treeContext = $61541ab712b0f8a9$var$pushTreeContext(prevTreeContext, keyPath, i);
            var resumeSegmentID = resumeSlots[i];
            "number" === typeof resumeSegmentID ? ($61541ab712b0f8a9$var$resumeNode(request, task, resumeSegmentID, node, i), delete resumeSlots[i]) : $61541ab712b0f8a9$var$renderNode(request, task, node, i);
            0 === --previousSuspenseListRow.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, previousSuspenseListRow);
        }
        else for(resumeSlots = 0; resumeSlots < keyPath; resumeSlots++)n = "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder ? resumeSlots : keyPath - 1 - resumeSlots, i = rows[n], task.row = previousSuspenseListRow = $61541ab712b0f8a9$var$createSuspenseListRow(previousSuspenseListRow), task.treeContext = $61541ab712b0f8a9$var$pushTreeContext(prevTreeContext, keyPath, n), $61541ab712b0f8a9$var$renderNode(request, task, i, n), 0 === --previousSuspenseListRow.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, previousSuspenseListRow);
    } else if ("backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder) for(revealOrder = 0; revealOrder < keyPath; revealOrder++)resumeSlots = rows[revealOrder], task.row = previousSuspenseListRow = $61541ab712b0f8a9$var$createSuspenseListRow(previousSuspenseListRow), task.treeContext = $61541ab712b0f8a9$var$pushTreeContext(prevTreeContext, keyPath, revealOrder), $61541ab712b0f8a9$var$renderNode(request, task, resumeSlots, revealOrder), 0 === --previousSuspenseListRow.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, previousSuspenseListRow);
    else {
        revealOrder = task.blockedSegment;
        resumeSlots = revealOrder.children.length;
        n = revealOrder.chunks.length;
        for(i = keyPath - 1; 0 <= i; i--){
            node = rows[i];
            task.row = previousSuspenseListRow = $61541ab712b0f8a9$var$createSuspenseListRow(previousSuspenseListRow);
            task.treeContext = $61541ab712b0f8a9$var$pushTreeContext(prevTreeContext, keyPath, i);
            resumeSegmentID = $61541ab712b0f8a9$var$createPendingSegment(request, n, null, task.formatContext, 0 === i ? revealOrder.lastPushedText : !0, !0);
            revealOrder.children.splice(resumeSlots, 0, resumeSegmentID);
            task.blockedSegment = resumeSegmentID;
            try {
                $61541ab712b0f8a9$var$renderNode(request, task, node, i), $61541ab712b0f8a9$var$pushSegmentFinale(resumeSegmentID.chunks, request.renderState, resumeSegmentID.lastPushedText, resumeSegmentID.textEmbedded), resumeSegmentID.status = 1, 0 === --previousSuspenseListRow.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, previousSuspenseListRow);
            } catch (thrownValue) {
                throw resumeSegmentID.status = 12 === request.status ? 3 : 4, thrownValue;
            }
        }
        task.blockedSegment = revealOrder;
        revealOrder.lastPushedText = !1;
    }
    null !== prevRow && null !== previousSuspenseListRow && 0 < previousSuspenseListRow.pendingTasks && (prevRow.pendingTasks++, previousSuspenseListRow.next = prevRow);
    task.treeContext = prevTreeContext;
    task.row = prevRow;
    task.keyPath = prevKeyPath;
}
function $61541ab712b0f8a9$var$renderWithHooks(request, task, keyPath, Component, props, secondArg) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    $61541ab712b0f8a9$var$currentlyRenderingComponent = {};
    $61541ab712b0f8a9$var$currentlyRenderingTask = task;
    $61541ab712b0f8a9$var$currentlyRenderingRequest = request;
    $61541ab712b0f8a9$var$currentlyRenderingKeyPath = keyPath;
    $61541ab712b0f8a9$var$actionStateCounter = $61541ab712b0f8a9$var$localIdCounter = 0;
    $61541ab712b0f8a9$var$actionStateMatchingIndex = -1;
    $61541ab712b0f8a9$var$thenableIndexCounter = 0;
    $61541ab712b0f8a9$var$thenableState = prevThenableState;
    for(request = Component(props, secondArg); $61541ab712b0f8a9$var$didScheduleRenderPhaseUpdate;)$61541ab712b0f8a9$var$didScheduleRenderPhaseUpdate = !1, $61541ab712b0f8a9$var$actionStateCounter = $61541ab712b0f8a9$var$localIdCounter = 0, $61541ab712b0f8a9$var$actionStateMatchingIndex = -1, $61541ab712b0f8a9$var$thenableIndexCounter = 0, $61541ab712b0f8a9$var$numberOfReRenders += 1, $61541ab712b0f8a9$var$workInProgressHook = null, request = Component(props, secondArg);
    $61541ab712b0f8a9$var$resetHooksState();
    return request;
}
function $61541ab712b0f8a9$var$finishFunctionComponent(request, task, keyPath, children, hasId, actionStateCount, actionStateMatchingIndex) {
    var didEmitActionStateMarkers = !1;
    if (0 !== actionStateCount && null !== request.formState) {
        var segment = task.blockedSegment;
        if (null !== segment) {
            didEmitActionStateMarkers = !0;
            segment = segment.chunks;
            for(var i = 0; i < actionStateCount; i++)i === actionStateMatchingIndex ? segment.push("\x3c!--F!--\x3e") : segment.push("\x3c!--F--\x3e");
        }
    }
    actionStateCount = task.keyPath;
    task.keyPath = keyPath;
    hasId ? (keyPath = task.treeContext, task.treeContext = $61541ab712b0f8a9$var$pushTreeContext(keyPath, 1, 0), $61541ab712b0f8a9$var$renderNode(request, task, children, -1), task.treeContext = keyPath) : didEmitActionStateMarkers ? $61541ab712b0f8a9$var$renderNode(request, task, children, -1) : $61541ab712b0f8a9$var$renderNodeDestructive(request, task, children, -1);
    task.keyPath = actionStateCount;
}
function $61541ab712b0f8a9$var$renderElement(request, task, keyPath, type, props, ref) {
    if ("function" === typeof type) {
        if (type.prototype && type.prototype.isReactComponent) {
            var newProps = props;
            if ("ref" in props) {
                newProps = {};
                for(var propName in props)"ref" !== propName && (newProps[propName] = props[propName]);
            }
            var defaultProps = type.defaultProps;
            if (defaultProps) {
                newProps === props && (newProps = $61541ab712b0f8a9$var$assign({}, newProps, props));
                for(var propName$43 in defaultProps)void 0 === newProps[propName$43] && (newProps[propName$43] = defaultProps[propName$43]);
            }
            props = newProps;
            newProps = $61541ab712b0f8a9$var$emptyContextObject;
            defaultProps = type.contextType;
            "object" === typeof defaultProps && null !== defaultProps && (newProps = defaultProps._currentValue2);
            newProps = new type(props, newProps);
            var initialState = void 0 !== newProps.state ? newProps.state : null;
            newProps.updater = $61541ab712b0f8a9$var$classComponentUpdater;
            newProps.props = props;
            newProps.state = initialState;
            defaultProps = {
                queue: [],
                replace: !1
            };
            newProps._reactInternals = defaultProps;
            ref = type.contextType;
            newProps.context = "object" === typeof ref && null !== ref ? ref._currentValue2 : $61541ab712b0f8a9$var$emptyContextObject;
            ref = type.getDerivedStateFromProps;
            "function" === typeof ref && (ref = ref(props, initialState), initialState = null === ref || void 0 === ref ? initialState : $61541ab712b0f8a9$var$assign({}, initialState, ref), newProps.state = initialState);
            if ("function" !== typeof type.getDerivedStateFromProps && "function" !== typeof newProps.getSnapshotBeforeUpdate && ("function" === typeof newProps.UNSAFE_componentWillMount || "function" === typeof newProps.componentWillMount)) {
                if (type = newProps.state, "function" === typeof newProps.componentWillMount && newProps.componentWillMount(), "function" === typeof newProps.UNSAFE_componentWillMount && newProps.UNSAFE_componentWillMount(), type !== newProps.state && $61541ab712b0f8a9$var$classComponentUpdater.enqueueReplaceState(newProps, newProps.state, null), null !== defaultProps.queue && 0 < defaultProps.queue.length) {
                    if (type = defaultProps.queue, ref = defaultProps.replace, defaultProps.queue = null, defaultProps.replace = !1, ref && 1 === type.length) newProps.state = type[0];
                    else {
                        defaultProps = ref ? type[0] : newProps.state;
                        initialState = !0;
                        for(ref = ref ? 1 : 0; ref < type.length; ref++)propName$43 = type[ref], propName$43 = "function" === typeof propName$43 ? propName$43.call(newProps, defaultProps, props, void 0) : propName$43, null != propName$43 && (initialState ? (initialState = !1, defaultProps = $61541ab712b0f8a9$var$assign({}, defaultProps, propName$43)) : $61541ab712b0f8a9$var$assign(defaultProps, propName$43));
                        newProps.state = defaultProps;
                    }
                } else defaultProps.queue = null;
            }
            type = newProps.render();
            if (12 === request.status) throw null;
            props = task.keyPath;
            task.keyPath = keyPath;
            $61541ab712b0f8a9$var$renderNodeDestructive(request, task, type, -1);
            task.keyPath = props;
        } else {
            type = $61541ab712b0f8a9$var$renderWithHooks(request, task, keyPath, type, props, void 0);
            if (12 === request.status) throw null;
            $61541ab712b0f8a9$var$finishFunctionComponent(request, task, keyPath, type, 0 !== $61541ab712b0f8a9$var$localIdCounter, $61541ab712b0f8a9$var$actionStateCounter, $61541ab712b0f8a9$var$actionStateMatchingIndex);
        }
    } else if ("string" === typeof type) {
        if (newProps = task.blockedSegment, null === newProps) newProps = props.children, defaultProps = task.formatContext, initialState = task.keyPath, task.formatContext = $61541ab712b0f8a9$var$getChildFormatContext(defaultProps, type, props), task.keyPath = keyPath, $61541ab712b0f8a9$var$renderNode(request, task, newProps, -1), task.formatContext = defaultProps, task.keyPath = initialState;
        else {
            initialState = $61541ab712b0f8a9$var$pushStartInstance(newProps.chunks, type, props, request.resumableState, request.renderState, task.blockedPreamble, task.hoistableState, task.formatContext, newProps.lastPushedText);
            newProps.lastPushedText = !1;
            defaultProps = task.formatContext;
            ref = task.keyPath;
            task.keyPath = keyPath;
            if (3 === (task.formatContext = $61541ab712b0f8a9$var$getChildFormatContext(defaultProps, type, props)).insertionMode) {
                keyPath = $61541ab712b0f8a9$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1);
                newProps.preambleChildren.push(keyPath);
                task.blockedSegment = keyPath;
                try {
                    keyPath.status = 6, $61541ab712b0f8a9$var$renderNode(request, task, initialState, -1), $61541ab712b0f8a9$var$pushSegmentFinale(keyPath.chunks, request.renderState, keyPath.lastPushedText, keyPath.textEmbedded), keyPath.status = 1;
                } finally{
                    task.blockedSegment = newProps;
                }
            } else $61541ab712b0f8a9$var$renderNode(request, task, initialState, -1);
            task.formatContext = defaultProps;
            task.keyPath = ref;
            a: {
                task = newProps.chunks;
                request = request.resumableState;
                switch(type){
                    case "title":
                    case "style":
                    case "script":
                    case "area":
                    case "base":
                    case "br":
                    case "col":
                    case "embed":
                    case "hr":
                    case "img":
                    case "input":
                    case "keygen":
                    case "link":
                    case "meta":
                    case "param":
                    case "source":
                    case "track":
                    case "wbr":
                        break a;
                    case "body":
                        if (1 >= defaultProps.insertionMode) {
                            request.hasBody = !0;
                            break a;
                        }
                        break;
                    case "html":
                        if (0 === defaultProps.insertionMode) {
                            request.hasHtml = !0;
                            break a;
                        }
                        break;
                    case "head":
                        if (1 >= defaultProps.insertionMode) break a;
                }
                task.push($61541ab712b0f8a9$var$endChunkForTag(type));
            }
            newProps.lastPushedText = !1;
        }
    } else {
        switch(type){
            case $61541ab712b0f8a9$var$REACT_LEGACY_HIDDEN_TYPE:
            case $61541ab712b0f8a9$var$REACT_STRICT_MODE_TYPE:
            case $61541ab712b0f8a9$var$REACT_PROFILER_TYPE:
            case $61541ab712b0f8a9$var$REACT_FRAGMENT_TYPE:
                type = task.keyPath;
                task.keyPath = keyPath;
                $61541ab712b0f8a9$var$renderNodeDestructive(request, task, props.children, -1);
                task.keyPath = type;
                return;
            case $61541ab712b0f8a9$var$REACT_ACTIVITY_TYPE:
                type = task.blockedSegment;
                null === type ? "hidden" !== props.mode && (type = task.keyPath, task.keyPath = keyPath, $61541ab712b0f8a9$var$renderNode(request, task, props.children, -1), task.keyPath = type) : "hidden" !== props.mode && (request.renderState.generateStaticMarkup || type.chunks.push("\x3c!--&--\x3e"), type.lastPushedText = !1, newProps = task.keyPath, task.keyPath = keyPath, $61541ab712b0f8a9$var$renderNode(request, task, props.children, -1), task.keyPath = newProps, request.renderState.generateStaticMarkup || type.chunks.push("\x3c!--/&--\x3e"), type.lastPushedText = !1);
                return;
            case $61541ab712b0f8a9$var$REACT_SUSPENSE_LIST_TYPE:
                a: {
                    type = props.children;
                    props = props.revealOrder;
                    if ("forwards" === props || "backwards" === props || "unstable_legacy-backwards" === props) {
                        if ($61541ab712b0f8a9$var$isArrayImpl(type)) {
                            $61541ab712b0f8a9$var$renderSuspenseListRows(request, task, keyPath, type, props);
                            break a;
                        }
                        if (newProps = $61541ab712b0f8a9$var$getIteratorFn(type)) {
                            if (newProps = newProps.call(type)) {
                                defaultProps = newProps.next();
                                if (!defaultProps.done) {
                                    do defaultProps = newProps.next();
                                    while (!defaultProps.done);
                                    $61541ab712b0f8a9$var$renderSuspenseListRows(request, task, keyPath, type, props);
                                }
                                break a;
                            }
                        }
                    }
                    "together" === props ? (props = task.keyPath, newProps = task.row, defaultProps = task.row = $61541ab712b0f8a9$var$createSuspenseListRow(null), defaultProps.boundaries = [], defaultProps.together = !0, task.keyPath = keyPath, $61541ab712b0f8a9$var$renderNodeDestructive(request, task, type, -1), 0 === --defaultProps.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, defaultProps), task.keyPath = props, task.row = newProps, null !== newProps && 0 < defaultProps.pendingTasks && (newProps.pendingTasks++, defaultProps.next = newProps)) : (props = task.keyPath, task.keyPath = keyPath, $61541ab712b0f8a9$var$renderNodeDestructive(request, task, type, -1), task.keyPath = props);
                }
                return;
            case $61541ab712b0f8a9$var$REACT_VIEW_TRANSITION_TYPE:
            case $61541ab712b0f8a9$var$REACT_SCOPE_TYPE:
                throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(343));
            case $61541ab712b0f8a9$var$REACT_SUSPENSE_TYPE:
                a: if (null !== task.replay) {
                    type = task.keyPath;
                    newProps = task.formatContext;
                    defaultProps = task.row;
                    task.keyPath = keyPath;
                    task.formatContext = $61541ab712b0f8a9$var$getSuspenseContentFormatContext(request.resumableState, newProps);
                    task.row = null;
                    keyPath = props.children;
                    try {
                        $61541ab712b0f8a9$var$renderNode(request, task, keyPath, -1);
                    } finally{
                        task.keyPath = type, task.formatContext = newProps, task.row = defaultProps;
                    }
                } else {
                    type = task.keyPath;
                    ref = task.formatContext;
                    var prevRow = task.row, parentBoundary = task.blockedBoundary;
                    propName$43 = task.blockedPreamble;
                    var parentHoistableState = task.hoistableState;
                    propName = task.blockedSegment;
                    var fallback = props.fallback;
                    props = props.children;
                    var fallbackAbortSet = new Set();
                    var newBoundary = $61541ab712b0f8a9$var$createSuspenseBoundary(request, task.row, fallbackAbortSet, null, null);
                    null !== request.trackedPostpones && (newBoundary.trackedContentKeyPath = keyPath);
                    var boundarySegment = $61541ab712b0f8a9$var$createPendingSegment(request, propName.chunks.length, newBoundary, task.formatContext, !1, !1);
                    propName.children.push(boundarySegment);
                    propName.lastPushedText = !1;
                    var contentRootSegment = $61541ab712b0f8a9$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1);
                    contentRootSegment.parentFlushed = !0;
                    if (null !== request.trackedPostpones) {
                        newProps = task.componentStack;
                        defaultProps = [
                            keyPath[0],
                            "Suspense Fallback",
                            keyPath[2]
                        ];
                        initialState = [
                            defaultProps[1],
                            defaultProps[2],
                            [],
                            null
                        ];
                        request.trackedPostpones.workingMap.set(defaultProps, initialState);
                        newBoundary.trackedFallbackNode = initialState;
                        task.blockedSegment = boundarySegment;
                        task.blockedPreamble = newBoundary.fallbackPreamble;
                        task.keyPath = defaultProps;
                        task.formatContext = $61541ab712b0f8a9$var$getSuspenseFallbackFormatContext(request.resumableState, ref);
                        task.componentStack = $61541ab712b0f8a9$var$replaceSuspenseComponentStackWithSuspenseFallbackStack(newProps);
                        boundarySegment.status = 6;
                        try {
                            $61541ab712b0f8a9$var$renderNode(request, task, fallback, -1), $61541ab712b0f8a9$var$pushSegmentFinale(boundarySegment.chunks, request.renderState, boundarySegment.lastPushedText, boundarySegment.textEmbedded), boundarySegment.status = 1;
                        } catch (thrownValue) {
                            throw boundarySegment.status = 12 === request.status ? 3 : 4, thrownValue;
                        } finally{
                            task.blockedSegment = propName, task.blockedPreamble = propName$43, task.keyPath = type, task.formatContext = ref;
                        }
                        task = $61541ab712b0f8a9$var$createRenderTask(request, null, props, -1, newBoundary, contentRootSegment, newBoundary.contentPreamble, newBoundary.contentState, task.abortSet, keyPath, $61541ab712b0f8a9$var$getSuspenseContentFormatContext(request.resumableState, task.formatContext), task.context, task.treeContext, null, newProps);
                        $61541ab712b0f8a9$var$pushComponentStack(task);
                        request.pingedTasks.push(task);
                    } else {
                        task.blockedBoundary = newBoundary;
                        task.blockedPreamble = newBoundary.contentPreamble;
                        task.hoistableState = newBoundary.contentState;
                        task.blockedSegment = contentRootSegment;
                        task.keyPath = keyPath;
                        task.formatContext = $61541ab712b0f8a9$var$getSuspenseContentFormatContext(request.resumableState, ref);
                        task.row = null;
                        contentRootSegment.status = 6;
                        try {
                            if ($61541ab712b0f8a9$var$renderNode(request, task, props, -1), $61541ab712b0f8a9$var$pushSegmentFinale(contentRootSegment.chunks, request.renderState, contentRootSegment.lastPushedText, contentRootSegment.textEmbedded), contentRootSegment.status = 1, $61541ab712b0f8a9$var$queueCompletedSegment(newBoundary, contentRootSegment), 0 === newBoundary.pendingTasks && 0 === newBoundary.status) {
                                if (newBoundary.status = 1, !$61541ab712b0f8a9$var$isEligibleForOutlining(request, newBoundary)) {
                                    null !== prevRow && 0 === --prevRow.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, prevRow);
                                    0 === request.pendingRootTasks && task.blockedPreamble && $61541ab712b0f8a9$var$preparePreamble(request);
                                    break a;
                                }
                            } else null !== prevRow && prevRow.together && $61541ab712b0f8a9$var$tryToResolveTogetherRow(request, prevRow);
                        } catch (thrownValue$30) {
                            newBoundary.status = 4, 12 === request.status ? (contentRootSegment.status = 3, newProps = request.fatalError) : (contentRootSegment.status = 4, newProps = thrownValue$30), defaultProps = $61541ab712b0f8a9$var$getThrownInfo(task.componentStack), initialState = $61541ab712b0f8a9$var$logRecoverableError(request, newProps, defaultProps), newBoundary.errorDigest = initialState, $61541ab712b0f8a9$var$untrackBoundary(request, newBoundary);
                        } finally{
                            task.blockedBoundary = parentBoundary, task.blockedPreamble = propName$43, task.hoistableState = parentHoistableState, task.blockedSegment = propName, task.keyPath = type, task.formatContext = ref, task.row = prevRow;
                        }
                        task = $61541ab712b0f8a9$var$createRenderTask(request, null, fallback, -1, parentBoundary, boundarySegment, newBoundary.fallbackPreamble, newBoundary.fallbackState, fallbackAbortSet, [
                            keyPath[0],
                            "Suspense Fallback",
                            keyPath[2]
                        ], $61541ab712b0f8a9$var$getSuspenseFallbackFormatContext(request.resumableState, task.formatContext), task.context, task.treeContext, task.row, $61541ab712b0f8a9$var$replaceSuspenseComponentStackWithSuspenseFallbackStack(task.componentStack));
                        $61541ab712b0f8a9$var$pushComponentStack(task);
                        request.pingedTasks.push(task);
                    }
                }
                return;
        }
        if ("object" === typeof type && null !== type) switch(type.$$typeof){
            case $61541ab712b0f8a9$var$REACT_FORWARD_REF_TYPE:
                if ("ref" in props) for(fallback in newProps = {}, props)"ref" !== fallback && (newProps[fallback] = props[fallback]);
                else newProps = props;
                type = $61541ab712b0f8a9$var$renderWithHooks(request, task, keyPath, type.render, newProps, ref);
                $61541ab712b0f8a9$var$finishFunctionComponent(request, task, keyPath, type, 0 !== $61541ab712b0f8a9$var$localIdCounter, $61541ab712b0f8a9$var$actionStateCounter, $61541ab712b0f8a9$var$actionStateMatchingIndex);
                return;
            case $61541ab712b0f8a9$var$REACT_MEMO_TYPE:
                $61541ab712b0f8a9$var$renderElement(request, task, keyPath, type.type, props, ref);
                return;
            case $61541ab712b0f8a9$var$REACT_CONTEXT_TYPE:
                defaultProps = props.children;
                newProps = task.keyPath;
                props = props.value;
                initialState = type._currentValue2;
                type._currentValue2 = props;
                ref = $61541ab712b0f8a9$var$currentActiveSnapshot;
                $61541ab712b0f8a9$var$currentActiveSnapshot = type = {
                    parent: ref,
                    depth: null === ref ? 0 : ref.depth + 1,
                    context: type,
                    parentValue: initialState,
                    value: props
                };
                task.context = type;
                task.keyPath = keyPath;
                $61541ab712b0f8a9$var$renderNodeDestructive(request, task, defaultProps, -1);
                request = $61541ab712b0f8a9$var$currentActiveSnapshot;
                if (null === request) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(403));
                request.context._currentValue2 = request.parentValue;
                request = $61541ab712b0f8a9$var$currentActiveSnapshot = request.parent;
                task.context = request;
                task.keyPath = newProps;
                return;
            case $61541ab712b0f8a9$var$REACT_CONSUMER_TYPE:
                props = props.children;
                type = props(type._context._currentValue2);
                props = task.keyPath;
                task.keyPath = keyPath;
                $61541ab712b0f8a9$var$renderNodeDestructive(request, task, type, -1);
                task.keyPath = props;
                return;
            case $61541ab712b0f8a9$var$REACT_LAZY_TYPE:
                newProps = type._init;
                type = newProps(type._payload);
                if (12 === request.status) throw null;
                $61541ab712b0f8a9$var$renderElement(request, task, keyPath, type, props, ref);
                return;
        }
        throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(130, null == type ? type : typeof type, ""));
    }
}
function $61541ab712b0f8a9$var$resumeNode(request, task, segmentId, node, childIndex) {
    var prevReplay = task.replay, blockedBoundary = task.blockedBoundary, resumedSegment = $61541ab712b0f8a9$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1);
    resumedSegment.id = segmentId;
    resumedSegment.parentFlushed = !0;
    try {
        task.replay = null, task.blockedSegment = resumedSegment, $61541ab712b0f8a9$var$renderNode(request, task, node, childIndex), resumedSegment.status = 1, null === blockedBoundary ? request.completedRootSegment = resumedSegment : ($61541ab712b0f8a9$var$queueCompletedSegment(blockedBoundary, resumedSegment), blockedBoundary.parentFlushed && request.partialBoundaries.push(blockedBoundary));
    } finally{
        task.replay = prevReplay, task.blockedSegment = null;
    }
}
function $61541ab712b0f8a9$var$renderNodeDestructive(request, task, node, childIndex) {
    null !== task.replay && "number" === typeof task.replay.slots ? $61541ab712b0f8a9$var$resumeNode(request, task, task.replay.slots, node, childIndex) : (task.node = node, task.childIndex = childIndex, node = task.componentStack, $61541ab712b0f8a9$var$pushComponentStack(task), $61541ab712b0f8a9$var$retryNode(request, task), task.componentStack = node);
}
function $61541ab712b0f8a9$var$retryNode(request, task) {
    var node = task.node, childIndex = task.childIndex;
    if (null !== node) {
        if ("object" === typeof node) {
            switch(node.$$typeof){
                case $61541ab712b0f8a9$var$REACT_ELEMENT_TYPE:
                    var type = node.type, key = node.key, props = node.props;
                    node = props.ref;
                    var ref = void 0 !== node ? node : null, name = $61541ab712b0f8a9$var$getComponentNameFromType(type), keyOrIndex = null == key ? -1 === childIndex ? 0 : childIndex : key;
                    key = [
                        task.keyPath,
                        name,
                        keyOrIndex
                    ];
                    if (null !== task.replay) a: {
                        var replay = task.replay;
                        childIndex = replay.nodes;
                        for(node = 0; node < childIndex.length; node++){
                            var node$jscomp$0 = childIndex[node];
                            if (keyOrIndex === node$jscomp$0[1]) {
                                if (4 === node$jscomp$0.length) {
                                    if (null !== name && name !== node$jscomp$0[0]) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(490, node$jscomp$0[0], name));
                                    var childNodes = node$jscomp$0[2];
                                    name = node$jscomp$0[3];
                                    keyOrIndex = task.node;
                                    task.replay = {
                                        nodes: childNodes,
                                        slots: name,
                                        pendingTasks: 1
                                    };
                                    try {
                                        $61541ab712b0f8a9$var$renderElement(request, task, key, type, props, ref);
                                        if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(488));
                                        task.replay.pendingTasks--;
                                    } catch (x) {
                                        if ("object" === typeof x && null !== x && (x === $61541ab712b0f8a9$var$SuspenseException || "function" === typeof x.then)) throw task.node === keyOrIndex ? task.replay = replay : childIndex.splice(node, 1), x;
                                        task.replay.pendingTasks--;
                                        props = $61541ab712b0f8a9$var$getThrownInfo(task.componentStack);
                                        key = request;
                                        request = task.blockedBoundary;
                                        type = x;
                                        props = $61541ab712b0f8a9$var$logRecoverableError(key, type, props);
                                        $61541ab712b0f8a9$var$abortRemainingReplayNodes(key, request, childNodes, name, type, props);
                                    }
                                    task.replay = replay;
                                } else {
                                    if (type !== $61541ab712b0f8a9$var$REACT_SUSPENSE_TYPE) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(490, "Suspense", $61541ab712b0f8a9$var$getComponentNameFromType(type) || "Unknown"));
                                    b: {
                                        replay = void 0;
                                        type = node$jscomp$0[5];
                                        ref = node$jscomp$0[2];
                                        name = node$jscomp$0[3];
                                        keyOrIndex = null === node$jscomp$0[4] ? [] : node$jscomp$0[4][2];
                                        node$jscomp$0 = null === node$jscomp$0[4] ? null : node$jscomp$0[4][3];
                                        var prevKeyPath = task.keyPath, prevContext = task.formatContext, prevRow = task.row, previousReplaySet = task.replay, parentBoundary = task.blockedBoundary, parentHoistableState = task.hoistableState, content = props.children, fallback = props.fallback, fallbackAbortSet = new Set();
                                        props = $61541ab712b0f8a9$var$createSuspenseBoundary(request, task.row, fallbackAbortSet, null, null);
                                        props.parentFlushed = !0;
                                        props.rootSegmentID = type;
                                        task.blockedBoundary = props;
                                        task.hoistableState = props.contentState;
                                        task.keyPath = key;
                                        task.formatContext = $61541ab712b0f8a9$var$getSuspenseContentFormatContext(request.resumableState, prevContext);
                                        task.row = null;
                                        task.replay = {
                                            nodes: ref,
                                            slots: name,
                                            pendingTasks: 1
                                        };
                                        try {
                                            $61541ab712b0f8a9$var$renderNode(request, task, content, -1);
                                            if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(488));
                                            task.replay.pendingTasks--;
                                            if (0 === props.pendingTasks && 0 === props.status) {
                                                props.status = 1;
                                                request.completedBoundaries.push(props);
                                                break b;
                                            }
                                        } catch (error) {
                                            props.status = 4, childNodes = $61541ab712b0f8a9$var$getThrownInfo(task.componentStack), replay = $61541ab712b0f8a9$var$logRecoverableError(request, error, childNodes), props.errorDigest = replay, task.replay.pendingTasks--, request.clientRenderedBoundaries.push(props);
                                        } finally{
                                            task.blockedBoundary = parentBoundary, task.hoistableState = parentHoistableState, task.replay = previousReplaySet, task.keyPath = prevKeyPath, task.formatContext = prevContext, task.row = prevRow;
                                        }
                                        childNodes = $61541ab712b0f8a9$var$createReplayTask(request, null, {
                                            nodes: keyOrIndex,
                                            slots: node$jscomp$0,
                                            pendingTasks: 0
                                        }, fallback, -1, parentBoundary, props.fallbackState, fallbackAbortSet, [
                                            key[0],
                                            "Suspense Fallback",
                                            key[2]
                                        ], $61541ab712b0f8a9$var$getSuspenseFallbackFormatContext(request.resumableState, task.formatContext), task.context, task.treeContext, task.row, $61541ab712b0f8a9$var$replaceSuspenseComponentStackWithSuspenseFallbackStack(task.componentStack));
                                        $61541ab712b0f8a9$var$pushComponentStack(childNodes);
                                        request.pingedTasks.push(childNodes);
                                    }
                                }
                                childIndex.splice(node, 1);
                                break a;
                            }
                        }
                    }
                    else $61541ab712b0f8a9$var$renderElement(request, task, key, type, props, ref);
                    return;
                case $61541ab712b0f8a9$var$REACT_PORTAL_TYPE:
                    throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(257));
                case $61541ab712b0f8a9$var$REACT_LAZY_TYPE:
                    childNodes = node._init;
                    node = childNodes(node._payload);
                    if (12 === request.status) throw null;
                    $61541ab712b0f8a9$var$renderNodeDestructive(request, task, node, childIndex);
                    return;
            }
            if ($61541ab712b0f8a9$var$isArrayImpl(node)) {
                $61541ab712b0f8a9$var$renderChildrenArray(request, task, node, childIndex);
                return;
            }
            if (childNodes = $61541ab712b0f8a9$var$getIteratorFn(node)) {
                if (childNodes = childNodes.call(node)) {
                    node = childNodes.next();
                    if (!node.done) {
                        props = [];
                        do props.push(node.value), node = childNodes.next();
                        while (!node.done);
                        $61541ab712b0f8a9$var$renderChildrenArray(request, task, props, childIndex);
                    }
                    return;
                }
            }
            if ("function" === typeof node.then) return task.thenableState = null, $61541ab712b0f8a9$var$renderNodeDestructive(request, task, $61541ab712b0f8a9$var$unwrapThenable(node), childIndex);
            if (node.$$typeof === $61541ab712b0f8a9$var$REACT_CONTEXT_TYPE) return $61541ab712b0f8a9$var$renderNodeDestructive(request, task, node._currentValue2, childIndex);
            childIndex = Object.prototype.toString.call(node);
            throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(31, "[object Object]" === childIndex ? "object with keys {" + Object.keys(node).join(", ") + "}" : childIndex));
        }
        if ("string" === typeof node) childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = $61541ab712b0f8a9$var$pushTextInstance(childIndex.chunks, node, request.renderState, childIndex.lastPushedText));
        else if ("number" === typeof node || "bigint" === typeof node) childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = $61541ab712b0f8a9$var$pushTextInstance(childIndex.chunks, "" + node, request.renderState, childIndex.lastPushedText));
    }
}
function $61541ab712b0f8a9$var$renderChildrenArray(request, task, children, childIndex) {
    var prevKeyPath = task.keyPath;
    if (-1 !== childIndex && (task.keyPath = [
        task.keyPath,
        "Fragment",
        childIndex
    ], null !== task.replay)) {
        for(var replay = task.replay, replayNodes = replay.nodes, j = 0; j < replayNodes.length; j++){
            var node = replayNodes[j];
            if (node[1] === childIndex) {
                childIndex = node[2];
                node = node[3];
                task.replay = {
                    nodes: childIndex,
                    slots: node,
                    pendingTasks: 1
                };
                try {
                    $61541ab712b0f8a9$var$renderChildrenArray(request, task, children, -1);
                    if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(488));
                    task.replay.pendingTasks--;
                } catch (x) {
                    if ("object" === typeof x && null !== x && (x === $61541ab712b0f8a9$var$SuspenseException || "function" === typeof x.then)) throw x;
                    task.replay.pendingTasks--;
                    children = $61541ab712b0f8a9$var$getThrownInfo(task.componentStack);
                    var boundary = task.blockedBoundary, error = x;
                    children = $61541ab712b0f8a9$var$logRecoverableError(request, error, children);
                    $61541ab712b0f8a9$var$abortRemainingReplayNodes(request, boundary, childIndex, node, error, children);
                }
                task.replay = replay;
                replayNodes.splice(j, 1);
                break;
            }
        }
        task.keyPath = prevKeyPath;
        return;
    }
    replay = task.treeContext;
    replayNodes = children.length;
    if (null !== task.replay && (j = task.replay.slots, null !== j && "object" === typeof j)) {
        for(childIndex = 0; childIndex < replayNodes; childIndex++)node = children[childIndex], task.treeContext = $61541ab712b0f8a9$var$pushTreeContext(replay, replayNodes, childIndex), boundary = j[childIndex], "number" === typeof boundary ? ($61541ab712b0f8a9$var$resumeNode(request, task, boundary, node, childIndex), delete j[childIndex]) : $61541ab712b0f8a9$var$renderNode(request, task, node, childIndex);
        task.treeContext = replay;
        task.keyPath = prevKeyPath;
        return;
    }
    for(j = 0; j < replayNodes; j++)childIndex = children[j], task.treeContext = $61541ab712b0f8a9$var$pushTreeContext(replay, replayNodes, j), $61541ab712b0f8a9$var$renderNode(request, task, childIndex, j);
    task.treeContext = replay;
    task.keyPath = prevKeyPath;
}
function $61541ab712b0f8a9$var$trackPostponedBoundary(request, trackedPostpones, boundary) {
    boundary.status = 5;
    boundary.rootSegmentID = request.nextSegmentId++;
    request = boundary.trackedContentKeyPath;
    if (null === request) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(486));
    var fallbackReplayNode = boundary.trackedFallbackNode, children = [], boundaryNode = trackedPostpones.workingMap.get(request);
    if (void 0 === boundaryNode) return boundary = [
        request[1],
        request[2],
        children,
        null,
        fallbackReplayNode,
        boundary.rootSegmentID
    ], trackedPostpones.workingMap.set(request, boundary), $61541ab712b0f8a9$var$addToReplayParent(boundary, request[0], trackedPostpones), boundary;
    boundaryNode[4] = fallbackReplayNode;
    boundaryNode[5] = boundary.rootSegmentID;
    return boundaryNode;
}
function $61541ab712b0f8a9$var$trackPostpone(request, trackedPostpones, task, segment) {
    segment.status = 5;
    var keyPath = task.keyPath, boundary = task.blockedBoundary;
    if (null === boundary) segment.id = request.nextSegmentId++, trackedPostpones.rootSlots = segment.id, null !== request.completedRootSegment && (request.completedRootSegment.status = 5);
    else {
        if (null !== boundary && 0 === boundary.status) {
            var boundaryNode = $61541ab712b0f8a9$var$trackPostponedBoundary(request, trackedPostpones, boundary);
            if (boundary.trackedContentKeyPath === keyPath && -1 === task.childIndex) {
                -1 === segment.id && (segment.id = segment.parentFlushed ? boundary.rootSegmentID : request.nextSegmentId++);
                boundaryNode[3] = segment.id;
                return;
            }
        }
        -1 === segment.id && (segment.id = segment.parentFlushed && null !== boundary ? boundary.rootSegmentID : request.nextSegmentId++);
        if (-1 === task.childIndex) null === keyPath ? trackedPostpones.rootSlots = segment.id : (task = trackedPostpones.workingMap.get(keyPath), void 0 === task ? (task = [
            keyPath[1],
            keyPath[2],
            [],
            segment.id
        ], $61541ab712b0f8a9$var$addToReplayParent(task, keyPath[0], trackedPostpones)) : task[3] = segment.id);
        else {
            if (null === keyPath) {
                if (request = trackedPostpones.rootSlots, null === request) request = trackedPostpones.rootSlots = {};
                else {
                    if ("number" === typeof request) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(491));
                }
            } else if (boundary = trackedPostpones.workingMap, boundaryNode = boundary.get(keyPath), void 0 === boundaryNode) request = {}, boundaryNode = [
                keyPath[1],
                keyPath[2],
                [],
                request
            ], boundary.set(keyPath, boundaryNode), $61541ab712b0f8a9$var$addToReplayParent(boundaryNode, keyPath[0], trackedPostpones);
            else if (request = boundaryNode[3], null === request) request = boundaryNode[3] = {};
            else if ("number" === typeof request) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(491));
            request[task.childIndex] = segment.id;
        }
    }
}
function $61541ab712b0f8a9$var$untrackBoundary(request, boundary) {
    request = request.trackedPostpones;
    null !== request && (boundary = boundary.trackedContentKeyPath, null !== boundary && (boundary = request.workingMap.get(boundary), void 0 !== boundary && (boundary.length = 4, boundary[2] = [], boundary[3] = null)));
}
function $61541ab712b0f8a9$var$spawnNewSuspendedReplayTask(request, task, thenableState) {
    return $61541ab712b0f8a9$var$createReplayTask(request, thenableState, task.replay, task.node, task.childIndex, task.blockedBoundary, task.hoistableState, task.abortSet, task.keyPath, task.formatContext, task.context, task.treeContext, task.row, task.componentStack);
}
function $61541ab712b0f8a9$var$spawnNewSuspendedRenderTask(request, task, thenableState) {
    var segment = task.blockedSegment, newSegment = $61541ab712b0f8a9$var$createPendingSegment(request, segment.chunks.length, null, task.formatContext, segment.lastPushedText, !0);
    segment.children.push(newSegment);
    segment.lastPushedText = !1;
    return $61541ab712b0f8a9$var$createRenderTask(request, thenableState, task.node, task.childIndex, task.blockedBoundary, newSegment, task.blockedPreamble, task.hoistableState, task.abortSet, task.keyPath, task.formatContext, task.context, task.treeContext, task.row, task.componentStack);
}
function $61541ab712b0f8a9$var$renderNode(request, task, node, childIndex) {
    var previousFormatContext = task.formatContext, previousContext = task.context, previousKeyPath = task.keyPath, previousTreeContext = task.treeContext, previousComponentStack = task.componentStack, segment = task.blockedSegment;
    if (null === segment) {
        segment = task.replay;
        try {
            return $61541ab712b0f8a9$var$renderNodeDestructive(request, task, node, childIndex);
        } catch (thrownValue) {
            if ($61541ab712b0f8a9$var$resetHooksState(), node = thrownValue === $61541ab712b0f8a9$var$SuspenseException ? $61541ab712b0f8a9$var$getSuspendedThenable() : thrownValue, 12 !== request.status && "object" === typeof node && null !== node) {
                if ("function" === typeof node.then) {
                    childIndex = thrownValue === $61541ab712b0f8a9$var$SuspenseException ? $61541ab712b0f8a9$var$getThenableStateAfterSuspending() : null;
                    request = $61541ab712b0f8a9$var$spawnNewSuspendedReplayTask(request, task, childIndex).ping;
                    node.then(request, request);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    task.replay = segment;
                    $61541ab712b0f8a9$var$switchContext(previousContext);
                    return;
                }
                if ("Maximum call stack size exceeded" === node.message) {
                    node = thrownValue === $61541ab712b0f8a9$var$SuspenseException ? $61541ab712b0f8a9$var$getThenableStateAfterSuspending() : null;
                    node = $61541ab712b0f8a9$var$spawnNewSuspendedReplayTask(request, task, node);
                    request.pingedTasks.push(node);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    task.replay = segment;
                    $61541ab712b0f8a9$var$switchContext(previousContext);
                    return;
                }
            }
        }
    } else {
        var childrenLength = segment.children.length, chunkLength = segment.chunks.length;
        try {
            return $61541ab712b0f8a9$var$renderNodeDestructive(request, task, node, childIndex);
        } catch (thrownValue$62) {
            if ($61541ab712b0f8a9$var$resetHooksState(), segment.children.length = childrenLength, segment.chunks.length = chunkLength, node = thrownValue$62 === $61541ab712b0f8a9$var$SuspenseException ? $61541ab712b0f8a9$var$getSuspendedThenable() : thrownValue$62, 12 !== request.status && "object" === typeof node && null !== node) {
                if ("function" === typeof node.then) {
                    segment = node;
                    node = thrownValue$62 === $61541ab712b0f8a9$var$SuspenseException ? $61541ab712b0f8a9$var$getThenableStateAfterSuspending() : null;
                    request = $61541ab712b0f8a9$var$spawnNewSuspendedRenderTask(request, task, node).ping;
                    segment.then(request, request);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    $61541ab712b0f8a9$var$switchContext(previousContext);
                    return;
                }
                if ("Maximum call stack size exceeded" === node.message) {
                    segment = thrownValue$62 === $61541ab712b0f8a9$var$SuspenseException ? $61541ab712b0f8a9$var$getThenableStateAfterSuspending() : null;
                    segment = $61541ab712b0f8a9$var$spawnNewSuspendedRenderTask(request, task, segment);
                    request.pingedTasks.push(segment);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    $61541ab712b0f8a9$var$switchContext(previousContext);
                    return;
                }
            }
        }
    }
    task.formatContext = previousFormatContext;
    task.context = previousContext;
    task.keyPath = previousKeyPath;
    task.treeContext = previousTreeContext;
    $61541ab712b0f8a9$var$switchContext(previousContext);
    throw node;
}
function $61541ab712b0f8a9$var$abortTaskSoft(task) {
    var boundary = task.blockedBoundary, segment = task.blockedSegment;
    null !== segment && (segment.status = 3, $61541ab712b0f8a9$var$finishedTask(this, boundary, task.row, segment));
}
function $61541ab712b0f8a9$var$abortRemainingReplayNodes(request$jscomp$0, boundary, nodes, slots, error, errorDigest$jscomp$0) {
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (4 === node.length) $61541ab712b0f8a9$var$abortRemainingReplayNodes(request$jscomp$0, boundary, node[2], node[3], error, errorDigest$jscomp$0);
        else {
            node = node[5];
            var request = request$jscomp$0, errorDigest = errorDigest$jscomp$0, resumedBoundary = $61541ab712b0f8a9$var$createSuspenseBoundary(request, null, new Set(), null, null);
            resumedBoundary.parentFlushed = !0;
            resumedBoundary.rootSegmentID = node;
            resumedBoundary.status = 4;
            resumedBoundary.errorDigest = errorDigest;
            resumedBoundary.parentFlushed && request.clientRenderedBoundaries.push(resumedBoundary);
        }
    }
    nodes.length = 0;
    if (null !== slots) {
        if (null === boundary) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(487));
        4 !== boundary.status && (boundary.status = 4, boundary.errorDigest = errorDigest$jscomp$0, boundary.parentFlushed && request$jscomp$0.clientRenderedBoundaries.push(boundary));
        if ("object" === typeof slots) for(var index in slots)delete slots[index];
    }
}
function $61541ab712b0f8a9$var$abortTask(task, request, error) {
    var boundary = task.blockedBoundary, segment = task.blockedSegment;
    if (null !== segment) {
        if (6 === segment.status) return;
        segment.status = 3;
    }
    var errorInfo = $61541ab712b0f8a9$var$getThrownInfo(task.componentStack);
    if (null === boundary) {
        if (13 !== request.status && 14 !== request.status) {
            boundary = task.replay;
            if (null === boundary) {
                null !== request.trackedPostpones && null !== segment ? (boundary = request.trackedPostpones, $61541ab712b0f8a9$var$logRecoverableError(request, error, errorInfo), $61541ab712b0f8a9$var$trackPostpone(request, boundary, task, segment), $61541ab712b0f8a9$var$finishedTask(request, null, task.row, segment)) : ($61541ab712b0f8a9$var$logRecoverableError(request, error, errorInfo), $61541ab712b0f8a9$var$fatalError(request, error));
                return;
            }
            boundary.pendingTasks--;
            0 === boundary.pendingTasks && 0 < boundary.nodes.length && (segment = $61541ab712b0f8a9$var$logRecoverableError(request, error, errorInfo), $61541ab712b0f8a9$var$abortRemainingReplayNodes(request, null, boundary.nodes, boundary.slots, error, segment));
            request.pendingRootTasks--;
            0 === request.pendingRootTasks && $61541ab712b0f8a9$var$completeShell(request);
        }
    } else {
        var trackedPostpones$63 = request.trackedPostpones;
        if (4 !== boundary.status) {
            if (null !== trackedPostpones$63 && null !== segment) return $61541ab712b0f8a9$var$logRecoverableError(request, error, errorInfo), $61541ab712b0f8a9$var$trackPostpone(request, trackedPostpones$63, task, segment), boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
                return $61541ab712b0f8a9$var$abortTask(fallbackTask, request, error);
            }), boundary.fallbackAbortableTasks.clear(), $61541ab712b0f8a9$var$finishedTask(request, boundary, task.row, segment);
            boundary.status = 4;
            segment = $61541ab712b0f8a9$var$logRecoverableError(request, error, errorInfo);
            boundary.status = 4;
            boundary.errorDigest = segment;
            $61541ab712b0f8a9$var$untrackBoundary(request, boundary);
            boundary.parentFlushed && request.clientRenderedBoundaries.push(boundary);
        }
        boundary.pendingTasks--;
        segment = boundary.row;
        null !== segment && 0 === --segment.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, segment);
        boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
            return $61541ab712b0f8a9$var$abortTask(fallbackTask, request, error);
        });
        boundary.fallbackAbortableTasks.clear();
    }
    task = task.row;
    null !== task && 0 === --task.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, task);
    request.allPendingTasks--;
    0 === request.allPendingTasks && $61541ab712b0f8a9$var$completeAll(request);
}
function $61541ab712b0f8a9$var$safelyEmitEarlyPreloads(request, shellComplete) {
    try {
        var renderState = request.renderState, onHeaders = renderState.onHeaders;
        if (onHeaders) {
            var headers = renderState.headers;
            if (headers) {
                renderState.headers = null;
                var linkHeader = headers.preconnects;
                headers.fontPreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.fontPreloads);
                headers.highImagePreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.highImagePreloads);
                if (!shellComplete) {
                    var queueIter = renderState.styles.values(), queueStep = queueIter.next();
                    b: for(; 0 < headers.remainingCapacity && !queueStep.done; queueStep = queueIter.next())for(var sheetIter = queueStep.value.sheets.values(), sheetStep = sheetIter.next(); 0 < headers.remainingCapacity && !sheetStep.done; sheetStep = sheetIter.next()){
                        var sheet = sheetStep.value, props = sheet.props, key = props.href, props$jscomp$0 = sheet.props, header = $61541ab712b0f8a9$var$getPreloadAsHeader(props$jscomp$0.href, "style", {
                            crossOrigin: props$jscomp$0.crossOrigin,
                            integrity: props$jscomp$0.integrity,
                            nonce: props$jscomp$0.nonce,
                            type: props$jscomp$0.type,
                            fetchPriority: props$jscomp$0.fetchPriority,
                            referrerPolicy: props$jscomp$0.referrerPolicy,
                            media: props$jscomp$0.media
                        });
                        if (0 <= (headers.remainingCapacity -= header.length + 2)) renderState.resets.style[key] = $61541ab712b0f8a9$var$PRELOAD_NO_CREDS, linkHeader && (linkHeader += ", "), linkHeader += header, renderState.resets.style[key] = "string" === typeof props.crossOrigin || "string" === typeof props.integrity ? [
                            props.crossOrigin,
                            props.integrity
                        ] : $61541ab712b0f8a9$var$PRELOAD_NO_CREDS;
                        else break b;
                    }
                }
                linkHeader ? onHeaders({
                    Link: linkHeader
                }) : onHeaders({});
            }
        }
    } catch (error) {
        $61541ab712b0f8a9$var$logRecoverableError(request, error, {});
    }
}
function $61541ab712b0f8a9$var$completeShell(request) {
    null === request.trackedPostpones && $61541ab712b0f8a9$var$safelyEmitEarlyPreloads(request, !0);
    null === request.trackedPostpones && $61541ab712b0f8a9$var$preparePreamble(request);
    request.onShellError = $61541ab712b0f8a9$var$noop;
    request = request.onShellReady;
    request();
}
function $61541ab712b0f8a9$var$completeAll(request) {
    $61541ab712b0f8a9$var$safelyEmitEarlyPreloads(request, null === request.trackedPostpones ? !0 : null === request.completedRootSegment || 5 !== request.completedRootSegment.status);
    $61541ab712b0f8a9$var$preparePreamble(request);
    request = request.onAllReady;
    request();
}
function $61541ab712b0f8a9$var$queueCompletedSegment(boundary, segment) {
    if (0 === segment.chunks.length && 1 === segment.children.length && null === segment.children[0].boundary && -1 === segment.children[0].id) {
        var childSegment = segment.children[0];
        childSegment.id = segment.id;
        childSegment.parentFlushed = !0;
        1 !== childSegment.status && 3 !== childSegment.status && 4 !== childSegment.status || $61541ab712b0f8a9$var$queueCompletedSegment(boundary, childSegment);
    } else boundary.completedSegments.push(segment);
}
function $61541ab712b0f8a9$var$finishedTask(request, boundary, row, segment) {
    null !== row && (0 === --row.pendingTasks ? $61541ab712b0f8a9$var$finishSuspenseListRow(request, row) : row.together && $61541ab712b0f8a9$var$tryToResolveTogetherRow(request, row));
    request.allPendingTasks--;
    if (null === boundary) {
        if (null !== segment && segment.parentFlushed) {
            if (null !== request.completedRootSegment) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(389));
            request.completedRootSegment = segment;
        }
        request.pendingRootTasks--;
        0 === request.pendingRootTasks && $61541ab712b0f8a9$var$completeShell(request);
    } else if (boundary.pendingTasks--, 4 !== boundary.status) {
        if (0 === boundary.pendingTasks) {
            if (0 === boundary.status && (boundary.status = 1), null !== segment && segment.parentFlushed && (1 === segment.status || 3 === segment.status) && $61541ab712b0f8a9$var$queueCompletedSegment(boundary, segment), boundary.parentFlushed && request.completedBoundaries.push(boundary), 1 === boundary.status) row = boundary.row, null !== row && $61541ab712b0f8a9$var$hoistHoistables(row.hoistables, boundary.contentState), $61541ab712b0f8a9$var$isEligibleForOutlining(request, boundary) || (boundary.fallbackAbortableTasks.forEach($61541ab712b0f8a9$var$abortTaskSoft, request), boundary.fallbackAbortableTasks.clear(), null !== row && 0 === --row.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, row)), 0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary.contentPreamble && $61541ab712b0f8a9$var$preparePreamble(request);
            else if (5 === boundary.status && (boundary = boundary.row, null !== boundary)) {
                if (null !== request.trackedPostpones) {
                    row = request.trackedPostpones;
                    var postponedRow = boundary.next;
                    if (null !== postponedRow && (segment = postponedRow.boundaries, null !== segment)) for(postponedRow.boundaries = null, postponedRow = 0; postponedRow < segment.length; postponedRow++){
                        var postponedBoundary = segment[postponedRow];
                        $61541ab712b0f8a9$var$trackPostponedBoundary(request, row, postponedBoundary);
                        $61541ab712b0f8a9$var$finishedTask(request, postponedBoundary, null, null);
                    }
                }
                0 === --boundary.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, boundary);
            }
        } else null === segment || !segment.parentFlushed || 1 !== segment.status && 3 !== segment.status || ($61541ab712b0f8a9$var$queueCompletedSegment(boundary, segment), 1 === boundary.completedSegments.length && boundary.parentFlushed && request.partialBoundaries.push(boundary)), boundary = boundary.row, null !== boundary && boundary.together && $61541ab712b0f8a9$var$tryToResolveTogetherRow(request, boundary);
    }
    0 === request.allPendingTasks && $61541ab712b0f8a9$var$completeAll(request);
}
function $61541ab712b0f8a9$var$performWork(request$jscomp$2) {
    if (14 !== request$jscomp$2.status && 13 !== request$jscomp$2.status) {
        var prevContext = $61541ab712b0f8a9$var$currentActiveSnapshot, prevDispatcher = $61541ab712b0f8a9$var$ReactSharedInternals.H;
        $61541ab712b0f8a9$var$ReactSharedInternals.H = $61541ab712b0f8a9$var$HooksDispatcher;
        var prevAsyncDispatcher = $61541ab712b0f8a9$var$ReactSharedInternals.A;
        $61541ab712b0f8a9$var$ReactSharedInternals.A = $61541ab712b0f8a9$var$DefaultAsyncDispatcher;
        var prevRequest = $61541ab712b0f8a9$var$currentRequest;
        $61541ab712b0f8a9$var$currentRequest = request$jscomp$2;
        var prevResumableState = $61541ab712b0f8a9$var$currentResumableState;
        $61541ab712b0f8a9$var$currentResumableState = request$jscomp$2.resumableState;
        try {
            var pingedTasks = request$jscomp$2.pingedTasks, i;
            for(i = 0; i < pingedTasks.length; i++){
                var task = pingedTasks[i], request = request$jscomp$2, segment = task.blockedSegment;
                if (null === segment) {
                    var request$jscomp$0 = request;
                    if (0 !== task.replay.pendingTasks) {
                        $61541ab712b0f8a9$var$switchContext(task.context);
                        try {
                            "number" === typeof task.replay.slots ? $61541ab712b0f8a9$var$resumeNode(request$jscomp$0, task, task.replay.slots, task.node, task.childIndex) : $61541ab712b0f8a9$var$retryNode(request$jscomp$0, task);
                            if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(488));
                            task.replay.pendingTasks--;
                            task.abortSet.delete(task);
                            $61541ab712b0f8a9$var$finishedTask(request$jscomp$0, task.blockedBoundary, task.row, null);
                        } catch (thrownValue) {
                            $61541ab712b0f8a9$var$resetHooksState();
                            var x = thrownValue === $61541ab712b0f8a9$var$SuspenseException ? $61541ab712b0f8a9$var$getSuspendedThenable() : thrownValue;
                            if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                                var ping = task.ping;
                                x.then(ping, ping);
                                task.thenableState = thrownValue === $61541ab712b0f8a9$var$SuspenseException ? $61541ab712b0f8a9$var$getThenableStateAfterSuspending() : null;
                            } else {
                                task.replay.pendingTasks--;
                                task.abortSet.delete(task);
                                var errorInfo = $61541ab712b0f8a9$var$getThrownInfo(task.componentStack);
                                request = void 0;
                                var request$jscomp$1 = request$jscomp$0, boundary = task.blockedBoundary, error$jscomp$0 = 12 === request$jscomp$0.status ? request$jscomp$0.fatalError : x, replayNodes = task.replay.nodes, resumeSlots = task.replay.slots;
                                request = $61541ab712b0f8a9$var$logRecoverableError(request$jscomp$1, error$jscomp$0, errorInfo);
                                $61541ab712b0f8a9$var$abortRemainingReplayNodes(request$jscomp$1, boundary, replayNodes, resumeSlots, error$jscomp$0, request);
                                request$jscomp$0.pendingRootTasks--;
                                0 === request$jscomp$0.pendingRootTasks && $61541ab712b0f8a9$var$completeShell(request$jscomp$0);
                                request$jscomp$0.allPendingTasks--;
                                0 === request$jscomp$0.allPendingTasks && $61541ab712b0f8a9$var$completeAll(request$jscomp$0);
                            }
                        } finally{}
                    }
                } else if (request$jscomp$0 = void 0, request$jscomp$1 = segment, 0 === request$jscomp$1.status) {
                    request$jscomp$1.status = 6;
                    $61541ab712b0f8a9$var$switchContext(task.context);
                    var childrenLength = request$jscomp$1.children.length, chunkLength = request$jscomp$1.chunks.length;
                    try {
                        $61541ab712b0f8a9$var$retryNode(request, task), $61541ab712b0f8a9$var$pushSegmentFinale(request$jscomp$1.chunks, request.renderState, request$jscomp$1.lastPushedText, request$jscomp$1.textEmbedded), task.abortSet.delete(task), request$jscomp$1.status = 1, $61541ab712b0f8a9$var$finishedTask(request, task.blockedBoundary, task.row, request$jscomp$1);
                    } catch (thrownValue) {
                        $61541ab712b0f8a9$var$resetHooksState();
                        request$jscomp$1.children.length = childrenLength;
                        request$jscomp$1.chunks.length = chunkLength;
                        var x$jscomp$0 = thrownValue === $61541ab712b0f8a9$var$SuspenseException ? $61541ab712b0f8a9$var$getSuspendedThenable() : 12 === request.status ? request.fatalError : thrownValue;
                        if (12 === request.status && null !== request.trackedPostpones) {
                            var trackedPostpones = request.trackedPostpones, thrownInfo = $61541ab712b0f8a9$var$getThrownInfo(task.componentStack);
                            task.abortSet.delete(task);
                            $61541ab712b0f8a9$var$logRecoverableError(request, x$jscomp$0, thrownInfo);
                            $61541ab712b0f8a9$var$trackPostpone(request, trackedPostpones, task, request$jscomp$1);
                            $61541ab712b0f8a9$var$finishedTask(request, task.blockedBoundary, task.row, request$jscomp$1);
                        } else if ("object" === typeof x$jscomp$0 && null !== x$jscomp$0 && "function" === typeof x$jscomp$0.then) {
                            request$jscomp$1.status = 0;
                            task.thenableState = thrownValue === $61541ab712b0f8a9$var$SuspenseException ? $61541ab712b0f8a9$var$getThenableStateAfterSuspending() : null;
                            var ping$jscomp$0 = task.ping;
                            x$jscomp$0.then(ping$jscomp$0, ping$jscomp$0);
                        } else {
                            var errorInfo$jscomp$0 = $61541ab712b0f8a9$var$getThrownInfo(task.componentStack);
                            task.abortSet.delete(task);
                            request$jscomp$1.status = 4;
                            var boundary$jscomp$0 = task.blockedBoundary, row = task.row;
                            null !== row && 0 === --row.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, row);
                            request.allPendingTasks--;
                            request$jscomp$0 = $61541ab712b0f8a9$var$logRecoverableError(request, x$jscomp$0, errorInfo$jscomp$0);
                            if (null === boundary$jscomp$0) $61541ab712b0f8a9$var$fatalError(request, x$jscomp$0);
                            else if (boundary$jscomp$0.pendingTasks--, 4 !== boundary$jscomp$0.status) {
                                boundary$jscomp$0.status = 4;
                                boundary$jscomp$0.errorDigest = request$jscomp$0;
                                $61541ab712b0f8a9$var$untrackBoundary(request, boundary$jscomp$0);
                                var boundaryRow = boundary$jscomp$0.row;
                                null !== boundaryRow && 0 === --boundaryRow.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, boundaryRow);
                                boundary$jscomp$0.parentFlushed && request.clientRenderedBoundaries.push(boundary$jscomp$0);
                                0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary$jscomp$0.contentPreamble && $61541ab712b0f8a9$var$preparePreamble(request);
                            }
                            0 === request.allPendingTasks && $61541ab712b0f8a9$var$completeAll(request);
                        }
                    } finally{}
                }
            }
            pingedTasks.splice(0, i);
            null !== request$jscomp$2.destination && $61541ab712b0f8a9$var$flushCompletedQueues(request$jscomp$2, request$jscomp$2.destination);
        } catch (error) {
            $61541ab712b0f8a9$var$logRecoverableError(request$jscomp$2, error, {}), $61541ab712b0f8a9$var$fatalError(request$jscomp$2, error);
        } finally{
            $61541ab712b0f8a9$var$currentResumableState = prevResumableState, $61541ab712b0f8a9$var$ReactSharedInternals.H = prevDispatcher, $61541ab712b0f8a9$var$ReactSharedInternals.A = prevAsyncDispatcher, prevDispatcher === $61541ab712b0f8a9$var$HooksDispatcher && $61541ab712b0f8a9$var$switchContext(prevContext), $61541ab712b0f8a9$var$currentRequest = prevRequest;
        }
    }
}
function $61541ab712b0f8a9$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments) {
    segment.preambleChildren.length && collectedPreambleSegments.push(segment.preambleChildren);
    for(var pendingPreambles = !1, i = 0; i < segment.children.length; i++)pendingPreambles = $61541ab712b0f8a9$var$preparePreambleFromSegment(request, segment.children[i], collectedPreambleSegments) || pendingPreambles;
    return pendingPreambles;
}
function $61541ab712b0f8a9$var$preparePreambleFromSegment(request, segment, collectedPreambleSegments) {
    var boundary = segment.boundary;
    if (null === boundary) return $61541ab712b0f8a9$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
    var preamble = boundary.contentPreamble, fallbackPreamble = boundary.fallbackPreamble;
    if (null === preamble || null === fallbackPreamble) return !1;
    switch(boundary.status){
        case 1:
            $61541ab712b0f8a9$var$hoistPreambleState(request.renderState, preamble);
            request.byteSize += boundary.byteSize;
            segment = boundary.completedSegments[0];
            if (!segment) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(391));
            return $61541ab712b0f8a9$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
        case 5:
            if (null !== request.trackedPostpones) return !0;
        case 4:
            if (1 === segment.status) return $61541ab712b0f8a9$var$hoistPreambleState(request.renderState, fallbackPreamble), $61541ab712b0f8a9$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
        default:
            return !0;
    }
}
function $61541ab712b0f8a9$var$preparePreamble(request) {
    if (request.completedRootSegment && null === request.completedPreambleSegments) {
        var collectedPreambleSegments = [], originalRequestByteSize = request.byteSize, hasPendingPreambles = $61541ab712b0f8a9$var$preparePreambleFromSegment(request, request.completedRootSegment, collectedPreambleSegments), preamble = request.renderState.preamble;
        !1 === hasPendingPreambles || preamble.headChunks && preamble.bodyChunks ? request.completedPreambleSegments = collectedPreambleSegments : request.byteSize = originalRequestByteSize;
    }
}
function $61541ab712b0f8a9$var$flushSubtree(request, destination, segment, hoistableState) {
    segment.parentFlushed = !0;
    switch(segment.status){
        case 0:
            segment.id = request.nextSegmentId++;
        case 5:
            return hoistableState = segment.id, segment.lastPushedText = !1, segment.textEmbedded = !1, request = request.renderState, destination.push('<template id="'), destination.push(request.placeholderPrefix), request = hoistableState.toString(16), destination.push(request), destination.push('"></template>');
        case 1:
            segment.status = 2;
            var r = !0, chunks = segment.chunks, chunkIdx = 0;
            segment = segment.children;
            for(var childIdx = 0; childIdx < segment.length; childIdx++){
                for(r = segment[childIdx]; chunkIdx < r.index; chunkIdx++)destination.push(chunks[chunkIdx]);
                r = $61541ab712b0f8a9$var$flushSegment(request, destination, r, hoistableState);
            }
            for(; chunkIdx < chunks.length - 1; chunkIdx++)destination.push(chunks[chunkIdx]);
            chunkIdx < chunks.length && (r = destination.push(chunks[chunkIdx]));
            return r;
        case 3:
            return !0;
        default:
            throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(390));
    }
}
var $61541ab712b0f8a9$var$flushedByteSize = 0;
function $61541ab712b0f8a9$var$flushSegment(request, destination, segment, hoistableState) {
    var boundary = segment.boundary;
    if (null === boundary) return $61541ab712b0f8a9$var$flushSubtree(request, destination, segment, hoistableState);
    boundary.parentFlushed = !0;
    if (4 === boundary.status) {
        var row = boundary.row;
        null !== row && 0 === --row.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, row);
        request.renderState.generateStaticMarkup || (boundary = boundary.errorDigest, destination.push("\x3c!--$!--\x3e"), destination.push("<template"), boundary && (destination.push(' data-dgst="'), boundary = $61541ab712b0f8a9$var$escapeTextForBrowser(boundary), destination.push(boundary), destination.push('"')), destination.push("></template>"));
        $61541ab712b0f8a9$var$flushSubtree(request, destination, segment, hoistableState);
        request = request.renderState.generateStaticMarkup ? !0 : destination.push("\x3c!--/$--\x3e");
        return request;
    }
    if (1 !== boundary.status) return 0 === boundary.status && (boundary.rootSegmentID = request.nextSegmentId++), 0 < boundary.completedSegments.length && request.partialBoundaries.push(boundary), $61541ab712b0f8a9$var$writeStartPendingSuspenseBoundary(destination, request.renderState, boundary.rootSegmentID), hoistableState && $61541ab712b0f8a9$var$hoistHoistables(hoistableState, boundary.fallbackState), $61541ab712b0f8a9$var$flushSubtree(request, destination, segment, hoistableState), destination.push("\x3c!--/$--\x3e");
    if (!$61541ab712b0f8a9$var$flushingPartialBoundaries && $61541ab712b0f8a9$var$isEligibleForOutlining(request, boundary) && $61541ab712b0f8a9$var$flushedByteSize + boundary.byteSize > request.progressiveChunkSize) return boundary.rootSegmentID = request.nextSegmentId++, request.completedBoundaries.push(boundary), $61541ab712b0f8a9$var$writeStartPendingSuspenseBoundary(destination, request.renderState, boundary.rootSegmentID), $61541ab712b0f8a9$var$flushSubtree(request, destination, segment, hoistableState), destination.push("\x3c!--/$--\x3e");
    $61541ab712b0f8a9$var$flushedByteSize += boundary.byteSize;
    hoistableState && $61541ab712b0f8a9$var$hoistHoistables(hoistableState, boundary.contentState);
    segment = boundary.row;
    null !== segment && $61541ab712b0f8a9$var$isEligibleForOutlining(request, boundary) && 0 === --segment.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, segment);
    request.renderState.generateStaticMarkup || destination.push("\x3c!--$--\x3e");
    segment = boundary.completedSegments;
    if (1 !== segment.length) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(391));
    $61541ab712b0f8a9$var$flushSegment(request, destination, segment[0], hoistableState);
    request = request.renderState.generateStaticMarkup ? !0 : destination.push("\x3c!--/$--\x3e");
    return request;
}
function $61541ab712b0f8a9$var$flushSegmentContainer(request, destination, segment, hoistableState) {
    $61541ab712b0f8a9$var$writeStartSegment(destination, request.renderState, segment.parentFormatContext, segment.id);
    $61541ab712b0f8a9$var$flushSegment(request, destination, segment, hoistableState);
    return $61541ab712b0f8a9$var$writeEndSegment(destination, segment.parentFormatContext);
}
function $61541ab712b0f8a9$var$flushCompletedBoundary(request, destination, boundary) {
    $61541ab712b0f8a9$var$flushedByteSize = boundary.byteSize;
    for(var completedSegments = boundary.completedSegments, i = 0; i < completedSegments.length; i++)$61541ab712b0f8a9$var$flushPartiallyCompletedSegment(request, destination, boundary, completedSegments[i]);
    completedSegments.length = 0;
    completedSegments = boundary.row;
    null !== completedSegments && $61541ab712b0f8a9$var$isEligibleForOutlining(request, boundary) && 0 === --completedSegments.pendingTasks && $61541ab712b0f8a9$var$finishSuspenseListRow(request, completedSegments);
    $61541ab712b0f8a9$var$writeHoistablesForBoundary(destination, boundary.contentState, request.renderState);
    completedSegments = request.resumableState;
    request = request.renderState;
    i = boundary.rootSegmentID;
    boundary = boundary.contentState;
    var requiresStyleInsertion = request.stylesToHoist;
    request.stylesToHoist = !1;
    destination.push(request.startInlineScript);
    destination.push(">");
    requiresStyleInsertion ? (0 === (completedSegments.instructions & 4) && (completedSegments.instructions |= 4, destination.push('$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};')), 0 === (completedSegments.instructions & 2) && (completedSegments.instructions |= 2, destination.push('$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};\n$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};')), 0 === (completedSegments.instructions & 8) ? (completedSegments.instructions |= 8, destination.push('$RM=new Map;$RR=function(n,w,p){function u(q){this._p=null;q()}for(var r=new Map,t=document,h,b,e=t.querySelectorAll("link[data-precedence],style[data-precedence]"),v=[],k=0;b=e[k++];)"not all"===b.getAttribute("media")?v.push(b):("LINK"===b.tagName&&$RM.set(b.getAttribute("href"),b),r.set(b.dataset.precedence,h=b));e=0;b=[];var l,a;for(k=!0;;){if(k){var f=p[e++];if(!f){k=!1;e=0;continue}var c=!1,m=0;var d=f[m++];if(a=$RM.get(d)){var g=a._p;c=!0}else{a=t.createElement("link");a.href=d;a.rel=\n"stylesheet";for(a.dataset.precedence=l=f[m++];g=f[m++];)a.setAttribute(g,f[m++]);g=a._p=new Promise(function(q,x){a.onload=u.bind(a,q);a.onerror=u.bind(a,x)});$RM.set(d,a)}d=a.getAttribute("media");!g||d&&!matchMedia(d).matches||b.push(g);if(c)continue}else{a=v[e++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=r.get(l)||h;c===h&&(h=a);r.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=t.head,c.insertBefore(a,c.firstChild))}if(p=document.getElementById(n))p.previousSibling.data=\n"$~";Promise.all(b).then($RC.bind(null,n,w),$RX.bind(null,n,"CSS failed to load"))};$RR("')) : destination.push('$RR("')) : (0 === (completedSegments.instructions & 2) && (completedSegments.instructions |= 2, destination.push('$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};\n$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};')), destination.push('$RC("'));
    completedSegments = i.toString(16);
    destination.push(request.boundaryPrefix);
    destination.push(completedSegments);
    destination.push('","');
    destination.push(request.segmentPrefix);
    destination.push(completedSegments);
    requiresStyleInsertion ? (destination.push('",'), $61541ab712b0f8a9$var$writeStyleResourceDependenciesInJS(destination, boundary)) : destination.push('"');
    boundary = destination.push(")\x3c/script>");
    return $61541ab712b0f8a9$var$writeBootstrap(destination, request) && boundary;
}
function $61541ab712b0f8a9$var$flushPartiallyCompletedSegment(request, destination, boundary, segment) {
    if (2 === segment.status) return !0;
    var hoistableState = boundary.contentState, segmentID = segment.id;
    if (-1 === segmentID) {
        if (-1 === (segment.id = boundary.rootSegmentID)) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(392));
        return $61541ab712b0f8a9$var$flushSegmentContainer(request, destination, segment, hoistableState);
    }
    if (segmentID === boundary.rootSegmentID) return $61541ab712b0f8a9$var$flushSegmentContainer(request, destination, segment, hoistableState);
    $61541ab712b0f8a9$var$flushSegmentContainer(request, destination, segment, hoistableState);
    boundary = request.resumableState;
    request = request.renderState;
    destination.push(request.startInlineScript);
    destination.push(">");
    0 === (boundary.instructions & 1) ? (boundary.instructions |= 1, destination.push('$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')) : destination.push('$RS("');
    destination.push(request.segmentPrefix);
    segmentID = segmentID.toString(16);
    destination.push(segmentID);
    destination.push('","');
    destination.push(request.placeholderPrefix);
    destination.push(segmentID);
    destination = destination.push('")\x3c/script>');
    return destination;
}
var $61541ab712b0f8a9$var$flushingPartialBoundaries = !1;
function $61541ab712b0f8a9$var$flushCompletedQueues(request, destination) {
    try {
        if (!(0 < request.pendingRootTasks)) {
            var i, completedRootSegment = request.completedRootSegment;
            if (null !== completedRootSegment) {
                if (5 === completedRootSegment.status) return;
                var completedPreambleSegments = request.completedPreambleSegments;
                if (null === completedPreambleSegments) return;
                $61541ab712b0f8a9$var$flushedByteSize = request.byteSize;
                var resumableState = request.resumableState, renderState = request.renderState, preamble = renderState.preamble, htmlChunks = preamble.htmlChunks, headChunks = preamble.headChunks, i$jscomp$0;
                if (htmlChunks) {
                    for(i$jscomp$0 = 0; i$jscomp$0 < htmlChunks.length; i$jscomp$0++)destination.push(htmlChunks[i$jscomp$0]);
                    if (headChunks) for(i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)destination.push(headChunks[i$jscomp$0]);
                    else {
                        var chunk = $61541ab712b0f8a9$var$startChunkForTag("head");
                        destination.push(chunk);
                        destination.push(">");
                    }
                } else if (headChunks) for(i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)destination.push(headChunks[i$jscomp$0]);
                var charsetChunks = renderState.charsetChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < charsetChunks.length; i$jscomp$0++)destination.push(charsetChunks[i$jscomp$0]);
                charsetChunks.length = 0;
                renderState.preconnects.forEach($61541ab712b0f8a9$var$flushResource, destination);
                renderState.preconnects.clear();
                var viewportChunks = renderState.viewportChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < viewportChunks.length; i$jscomp$0++)destination.push(viewportChunks[i$jscomp$0]);
                viewportChunks.length = 0;
                renderState.fontPreloads.forEach($61541ab712b0f8a9$var$flushResource, destination);
                renderState.fontPreloads.clear();
                renderState.highImagePreloads.forEach($61541ab712b0f8a9$var$flushResource, destination);
                renderState.highImagePreloads.clear();
                $61541ab712b0f8a9$var$currentlyFlushingRenderState = renderState;
                renderState.styles.forEach($61541ab712b0f8a9$var$flushStylesInPreamble, destination);
                $61541ab712b0f8a9$var$currentlyFlushingRenderState = null;
                var importMapChunks = renderState.importMapChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < importMapChunks.length; i$jscomp$0++)destination.push(importMapChunks[i$jscomp$0]);
                importMapChunks.length = 0;
                renderState.bootstrapScripts.forEach($61541ab712b0f8a9$var$flushResource, destination);
                renderState.scripts.forEach($61541ab712b0f8a9$var$flushResource, destination);
                renderState.scripts.clear();
                renderState.bulkPreloads.forEach($61541ab712b0f8a9$var$flushResource, destination);
                renderState.bulkPreloads.clear();
                resumableState.instructions |= 32;
                var hoistableChunks = renderState.hoistableChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < hoistableChunks.length; i$jscomp$0++)destination.push(hoistableChunks[i$jscomp$0]);
                for(resumableState = hoistableChunks.length = 0; resumableState < completedPreambleSegments.length; resumableState++){
                    var segments = completedPreambleSegments[resumableState];
                    for(renderState = 0; renderState < segments.length; renderState++)$61541ab712b0f8a9$var$flushSegment(request, destination, segments[renderState], null);
                }
                var preamble$jscomp$0 = request.renderState.preamble, headChunks$jscomp$0 = preamble$jscomp$0.headChunks;
                if (preamble$jscomp$0.htmlChunks || headChunks$jscomp$0) {
                    var chunk$jscomp$0 = $61541ab712b0f8a9$var$endChunkForTag("head");
                    destination.push(chunk$jscomp$0);
                }
                var bodyChunks = preamble$jscomp$0.bodyChunks;
                if (bodyChunks) for(completedPreambleSegments = 0; completedPreambleSegments < bodyChunks.length; completedPreambleSegments++)destination.push(bodyChunks[completedPreambleSegments]);
                $61541ab712b0f8a9$var$flushSegment(request, destination, completedRootSegment, null);
                request.completedRootSegment = null;
                var renderState$jscomp$0 = request.renderState;
                if (0 !== request.allPendingTasks || 0 !== request.clientRenderedBoundaries.length || 0 !== request.completedBoundaries.length || null !== request.trackedPostpones && (0 !== request.trackedPostpones.rootNodes.length || null !== request.trackedPostpones.rootSlots)) {
                    var resumableState$jscomp$0 = request.resumableState;
                    if (0 === (resumableState$jscomp$0.instructions & 64)) {
                        resumableState$jscomp$0.instructions |= 64;
                        destination.push(renderState$jscomp$0.startInlineScript);
                        if (0 === (resumableState$jscomp$0.instructions & 32)) {
                            resumableState$jscomp$0.instructions |= 32;
                            var shellId = "_" + resumableState$jscomp$0.idPrefix + "R_";
                            destination.push(' id="');
                            var chunk$jscomp$1 = $61541ab712b0f8a9$var$escapeTextForBrowser(shellId);
                            destination.push(chunk$jscomp$1);
                            destination.push('"');
                        }
                        destination.push(">");
                        destination.push("requestAnimationFrame(function(){$RT=performance.now()});");
                        destination.push("\x3c/script>");
                    }
                }
                $61541ab712b0f8a9$var$writeBootstrap(destination, renderState$jscomp$0);
            }
            var renderState$jscomp$1 = request.renderState;
            completedRootSegment = 0;
            var viewportChunks$jscomp$0 = renderState$jscomp$1.viewportChunks;
            for(completedRootSegment = 0; completedRootSegment < viewportChunks$jscomp$0.length; completedRootSegment++)destination.push(viewportChunks$jscomp$0[completedRootSegment]);
            viewportChunks$jscomp$0.length = 0;
            renderState$jscomp$1.preconnects.forEach($61541ab712b0f8a9$var$flushResource, destination);
            renderState$jscomp$1.preconnects.clear();
            renderState$jscomp$1.fontPreloads.forEach($61541ab712b0f8a9$var$flushResource, destination);
            renderState$jscomp$1.fontPreloads.clear();
            renderState$jscomp$1.highImagePreloads.forEach($61541ab712b0f8a9$var$flushResource, destination);
            renderState$jscomp$1.highImagePreloads.clear();
            renderState$jscomp$1.styles.forEach($61541ab712b0f8a9$var$preloadLateStyles, destination);
            renderState$jscomp$1.scripts.forEach($61541ab712b0f8a9$var$flushResource, destination);
            renderState$jscomp$1.scripts.clear();
            renderState$jscomp$1.bulkPreloads.forEach($61541ab712b0f8a9$var$flushResource, destination);
            renderState$jscomp$1.bulkPreloads.clear();
            var hoistableChunks$jscomp$0 = renderState$jscomp$1.hoistableChunks;
            for(completedRootSegment = 0; completedRootSegment < hoistableChunks$jscomp$0.length; completedRootSegment++)destination.push(hoistableChunks$jscomp$0[completedRootSegment]);
            hoistableChunks$jscomp$0.length = 0;
            var clientRenderedBoundaries = request.clientRenderedBoundaries;
            for(i = 0; i < clientRenderedBoundaries.length; i++){
                var boundary = clientRenderedBoundaries[i];
                renderState$jscomp$1 = destination;
                var resumableState$jscomp$1 = request.resumableState, renderState$jscomp$2 = request.renderState, id = boundary.rootSegmentID, errorDigest = boundary.errorDigest;
                renderState$jscomp$1.push(renderState$jscomp$2.startInlineScript);
                renderState$jscomp$1.push(">");
                0 === (resumableState$jscomp$1.instructions & 4) ? (resumableState$jscomp$1.instructions |= 4, renderState$jscomp$1.push('$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("')) : renderState$jscomp$1.push('$RX("');
                renderState$jscomp$1.push(renderState$jscomp$2.boundaryPrefix);
                var chunk$jscomp$2 = id.toString(16);
                renderState$jscomp$1.push(chunk$jscomp$2);
                renderState$jscomp$1.push('"');
                if (errorDigest) {
                    renderState$jscomp$1.push(",");
                    var chunk$jscomp$3 = $61541ab712b0f8a9$var$escapeJSStringsForInstructionScripts(errorDigest || "");
                    renderState$jscomp$1.push(chunk$jscomp$3);
                }
                var JSCompiler_inline_result = renderState$jscomp$1.push(")\x3c/script>");
                if (!JSCompiler_inline_result) {
                    request.destination = null;
                    i++;
                    clientRenderedBoundaries.splice(0, i);
                    return;
                }
            }
            clientRenderedBoundaries.splice(0, i);
            var completedBoundaries = request.completedBoundaries;
            for(i = 0; i < completedBoundaries.length; i++)if (!$61541ab712b0f8a9$var$flushCompletedBoundary(request, destination, completedBoundaries[i])) {
                request.destination = null;
                i++;
                completedBoundaries.splice(0, i);
                return;
            }
            completedBoundaries.splice(0, i);
            $61541ab712b0f8a9$var$flushingPartialBoundaries = !0;
            var partialBoundaries = request.partialBoundaries;
            for(i = 0; i < partialBoundaries.length; i++){
                var boundary$69 = partialBoundaries[i];
                a: {
                    clientRenderedBoundaries = request;
                    boundary = destination;
                    $61541ab712b0f8a9$var$flushedByteSize = boundary$69.byteSize;
                    var completedSegments = boundary$69.completedSegments;
                    for(JSCompiler_inline_result = 0; JSCompiler_inline_result < completedSegments.length; JSCompiler_inline_result++)if (!$61541ab712b0f8a9$var$flushPartiallyCompletedSegment(clientRenderedBoundaries, boundary, boundary$69, completedSegments[JSCompiler_inline_result])) {
                        JSCompiler_inline_result++;
                        completedSegments.splice(0, JSCompiler_inline_result);
                        var JSCompiler_inline_result$jscomp$0 = !1;
                        break a;
                    }
                    completedSegments.splice(0, JSCompiler_inline_result);
                    var row = boundary$69.row;
                    null !== row && row.together && 1 === boundary$69.pendingTasks && (1 === row.pendingTasks ? $61541ab712b0f8a9$var$unblockSuspenseListRow(clientRenderedBoundaries, row, row.hoistables) : row.pendingTasks--);
                    JSCompiler_inline_result$jscomp$0 = $61541ab712b0f8a9$var$writeHoistablesForBoundary(boundary, boundary$69.contentState, clientRenderedBoundaries.renderState);
                }
                if (!JSCompiler_inline_result$jscomp$0) {
                    request.destination = null;
                    i++;
                    partialBoundaries.splice(0, i);
                    return;
                }
            }
            partialBoundaries.splice(0, i);
            $61541ab712b0f8a9$var$flushingPartialBoundaries = !1;
            var largeBoundaries = request.completedBoundaries;
            for(i = 0; i < largeBoundaries.length; i++)if (!$61541ab712b0f8a9$var$flushCompletedBoundary(request, destination, largeBoundaries[i])) {
                request.destination = null;
                i++;
                largeBoundaries.splice(0, i);
                return;
            }
            largeBoundaries.splice(0, i);
        }
    } finally{
        $61541ab712b0f8a9$var$flushingPartialBoundaries = !1, 0 === request.allPendingTasks && 0 === request.clientRenderedBoundaries.length && 0 === request.completedBoundaries.length && (request.flushScheduled = !1, i = request.resumableState, i.hasBody && (partialBoundaries = $61541ab712b0f8a9$var$endChunkForTag("body"), destination.push(partialBoundaries)), i.hasHtml && (i = $61541ab712b0f8a9$var$endChunkForTag("html"), destination.push(i)), request.status = 14, destination.push(null), request.destination = null);
    }
}
function $61541ab712b0f8a9$var$enqueueFlush(request) {
    if (!1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination) {
        request.flushScheduled = !0;
        var destination = request.destination;
        destination ? $61541ab712b0f8a9$var$flushCompletedQueues(request, destination) : request.flushScheduled = !1;
    }
}
function $61541ab712b0f8a9$var$startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, destination.destroy(request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            $61541ab712b0f8a9$var$flushCompletedQueues(request, destination);
        } catch (error) {
            $61541ab712b0f8a9$var$logRecoverableError(request, error, {}), $61541ab712b0f8a9$var$fatalError(request, error);
        }
    }
}
function $61541ab712b0f8a9$var$abort(request, reason) {
    if (11 === request.status || 10 === request.status) request.status = 12;
    try {
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error($61541ab712b0f8a9$var$formatProdErrorMessage(432)) : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error($61541ab712b0f8a9$var$formatProdErrorMessage(530)) : reason;
            request.fatalError = error;
            abortableTasks.forEach(function(task) {
                return $61541ab712b0f8a9$var$abortTask(task, request, error);
            });
            abortableTasks.clear();
        }
        null !== request.destination && $61541ab712b0f8a9$var$flushCompletedQueues(request, request.destination);
    } catch (error$71) {
        $61541ab712b0f8a9$var$logRecoverableError(request, error$71, {}), $61541ab712b0f8a9$var$fatalError(request, error$71);
    }
}
function $61541ab712b0f8a9$var$addToReplayParent(node, parentKeyPath, trackedPostpones) {
    if (null === parentKeyPath) trackedPostpones.rootNodes.push(node);
    else {
        var workingMap = trackedPostpones.workingMap, parentNode = workingMap.get(parentKeyPath);
        void 0 === parentNode && (parentNode = [
            parentKeyPath[1],
            parentKeyPath[2],
            [],
            null
        ], workingMap.set(parentKeyPath, parentNode), $61541ab712b0f8a9$var$addToReplayParent(parentNode, parentKeyPath[0], trackedPostpones));
        parentNode[2].push(node);
    }
}
function $61541ab712b0f8a9$var$onError() {}
function $61541ab712b0f8a9$var$renderToStringImpl(children, options, generateStaticMarkup, abortReason) {
    var didFatal = !1, fatalError = null, result = "", readyToStream = !1;
    options = $61541ab712b0f8a9$var$createResumableState(options ? options.identifierPrefix : void 0);
    children = $61541ab712b0f8a9$var$createRequest(children, options, $61541ab712b0f8a9$var$createRenderState(options, generateStaticMarkup), $61541ab712b0f8a9$var$createFormatContext(0, null, 0, null), Infinity, $61541ab712b0f8a9$var$onError, void 0, function() {
        readyToStream = !0;
    }, void 0, void 0, void 0);
    children.flushScheduled = null !== children.destination;
    $61541ab712b0f8a9$var$performWork(children);
    10 === children.status && (children.status = 11);
    null === children.trackedPostpones && $61541ab712b0f8a9$var$safelyEmitEarlyPreloads(children, 0 === children.pendingRootTasks);
    $61541ab712b0f8a9$var$abort(children, abortReason);
    $61541ab712b0f8a9$var$startFlowing(children, {
        push: function(chunk) {
            null !== chunk && (result += chunk);
            return !0;
        },
        destroy: function(error) {
            didFatal = !0;
            fatalError = error;
        }
    });
    if (didFatal && fatalError !== abortReason) throw fatalError;
    if (!readyToStream) throw Error($61541ab712b0f8a9$var$formatProdErrorMessage(426));
    return result;
}
$61541ab712b0f8a9$export$eb3a06aef9e6ee51 = function(children, options) {
    return $61541ab712b0f8a9$var$renderToStringImpl(children, options, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$61541ab712b0f8a9$export$80e7718417253a51 = function(children, options) {
    return $61541ab712b0f8a9$var$renderToStringImpl(children, options, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$61541ab712b0f8a9$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});


parcelRegister("3AwCA", function(module, exports) {

$parcel$export(module.exports, "prerender", () => $29ce09d30a26f47a$export$4f10e897d13fb72b, (v) => $29ce09d30a26f47a$export$4f10e897d13fb72b = v);
$parcel$export(module.exports, "renderToReadableStream", () => $29ce09d30a26f47a$export$7020a3240b287705, (v) => $29ce09d30a26f47a$export$7020a3240b287705 = v);
$parcel$export(module.exports, "resume", () => $29ce09d30a26f47a$export$fbb4d68fe60c1629, (v) => $29ce09d30a26f47a$export$fbb4d68fe60c1629 = v);
$parcel$export(module.exports, "resumeAndPrerender", () => $29ce09d30a26f47a$export$2e1a48258ce555d9, (v) => $29ce09d30a26f47a$export$2e1a48258ce555d9 = v);
$parcel$export(module.exports, "version", () => $29ce09d30a26f47a$export$83d89fbfd8236492, (v) => $29ce09d30a26f47a$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*


 JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)

 Copyright (c) 2011 Gary Court
 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
*/ var $29ce09d30a26f47a$export$4f10e897d13fb72b;
var $29ce09d30a26f47a$export$7020a3240b287705;
var $29ce09d30a26f47a$export$fbb4d68fe60c1629;
var $29ce09d30a26f47a$export$2e1a48258ce555d9;
var $29ce09d30a26f47a$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $29ce09d30a26f47a$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $29ce09d30a26f47a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $29ce09d30a26f47a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $29ce09d30a26f47a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $29ce09d30a26f47a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $29ce09d30a26f47a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $29ce09d30a26f47a$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $29ce09d30a26f47a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $29ce09d30a26f47a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $29ce09d30a26f47a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $29ce09d30a26f47a$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $29ce09d30a26f47a$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $29ce09d30a26f47a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $29ce09d30a26f47a$var$REACT_SCOPE_TYPE = Symbol.for("react.scope"), $29ce09d30a26f47a$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $29ce09d30a26f47a$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden"), $29ce09d30a26f47a$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $29ce09d30a26f47a$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $29ce09d30a26f47a$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $29ce09d30a26f47a$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $29ce09d30a26f47a$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$29ce09d30a26f47a$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $29ce09d30a26f47a$var$isArrayImpl = Array.isArray;
function $29ce09d30a26f47a$var$murmurhash3_32_gc(key, seed) {
    var remainder = key.length & 3;
    var bytes = key.length - remainder;
    var h1 = seed;
    for(seed = 0; seed < bytes;){
        var k1 = key.charCodeAt(seed) & 255 | (key.charCodeAt(++seed) & 255) << 8 | (key.charCodeAt(++seed) & 255) << 16 | (key.charCodeAt(++seed) & 255) << 24;
        ++seed;
        k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295;
        k1 = k1 << 15 | k1 >>> 17;
        k1 = 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
        h1 ^= k1;
        h1 = h1 << 13 | h1 >>> 19;
        h1 = 5 * (h1 & 65535) + ((5 * (h1 >>> 16) & 65535) << 16) & 4294967295;
        h1 = (h1 & 65535) + 27492 + (((h1 >>> 16) + 58964 & 65535) << 16);
    }
    k1 = 0;
    switch(remainder){
        case 3:
            k1 ^= (key.charCodeAt(seed + 2) & 255) << 16;
        case 2:
            k1 ^= (key.charCodeAt(seed + 1) & 255) << 8;
        case 1:
            k1 ^= key.charCodeAt(seed) & 255, k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295, k1 = k1 << 15 | k1 >>> 17, h1 ^= 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
    }
    h1 ^= key.length;
    h1 ^= h1 >>> 16;
    h1 = 2246822507 * (h1 & 65535) + ((2246822507 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    h1 ^= h1 >>> 13;
    h1 = 3266489909 * (h1 & 65535) + ((3266489909 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    return (h1 ^ h1 >>> 16) >>> 0;
}
var $29ce09d30a26f47a$var$channel = new MessageChannel(), $29ce09d30a26f47a$var$taskQueue = [];
$29ce09d30a26f47a$var$channel.port1.onmessage = function() {
    var task = $29ce09d30a26f47a$var$taskQueue.shift();
    task && task();
};
function $29ce09d30a26f47a$var$scheduleWork(callback) {
    $29ce09d30a26f47a$var$taskQueue.push(callback);
    $29ce09d30a26f47a$var$channel.port2.postMessage(null);
}
function $29ce09d30a26f47a$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var $29ce09d30a26f47a$var$LocalPromise = Promise, $29ce09d30a26f47a$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    $29ce09d30a26f47a$var$LocalPromise.resolve(null).then(callback).catch($29ce09d30a26f47a$var$handleErrorInNextTick);
}, $29ce09d30a26f47a$var$currentView = null, $29ce09d30a26f47a$var$writtenBytes = 0;
function $29ce09d30a26f47a$var$writeChunk(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < $29ce09d30a26f47a$var$writtenBytes && (destination.enqueue(new Uint8Array($29ce09d30a26f47a$var$currentView.buffer, 0, $29ce09d30a26f47a$var$writtenBytes)), $29ce09d30a26f47a$var$currentView = new Uint8Array(2048), $29ce09d30a26f47a$var$writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = $29ce09d30a26f47a$var$currentView.length - $29ce09d30a26f47a$var$writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue($29ce09d30a26f47a$var$currentView) : ($29ce09d30a26f47a$var$currentView.set(chunk.subarray(0, allowableBytes), $29ce09d30a26f47a$var$writtenBytes), destination.enqueue($29ce09d30a26f47a$var$currentView), chunk = chunk.subarray(allowableBytes)), $29ce09d30a26f47a$var$currentView = new Uint8Array(2048), $29ce09d30a26f47a$var$writtenBytes = 0);
            $29ce09d30a26f47a$var$currentView.set(chunk, $29ce09d30a26f47a$var$writtenBytes);
            $29ce09d30a26f47a$var$writtenBytes += chunk.byteLength;
        }
    }
}
function $29ce09d30a26f47a$var$writeChunkAndReturn(destination, chunk) {
    $29ce09d30a26f47a$var$writeChunk(destination, chunk);
    return !0;
}
function $29ce09d30a26f47a$var$completeWriting(destination) {
    $29ce09d30a26f47a$var$currentView && 0 < $29ce09d30a26f47a$var$writtenBytes && (destination.enqueue(new Uint8Array($29ce09d30a26f47a$var$currentView.buffer, 0, $29ce09d30a26f47a$var$writtenBytes)), $29ce09d30a26f47a$var$currentView = null, $29ce09d30a26f47a$var$writtenBytes = 0);
}
var $29ce09d30a26f47a$var$textEncoder = new TextEncoder();
function $29ce09d30a26f47a$var$stringToChunk(content) {
    return $29ce09d30a26f47a$var$textEncoder.encode(content);
}
function $29ce09d30a26f47a$var$stringToPrecomputedChunk(content) {
    return $29ce09d30a26f47a$var$textEncoder.encode(content);
}
function $29ce09d30a26f47a$var$byteLengthOfChunk(chunk) {
    return chunk.byteLength;
}
function $29ce09d30a26f47a$var$closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var $29ce09d30a26f47a$var$assign = Object.assign, $29ce09d30a26f47a$var$hasOwnProperty = Object.prototype.hasOwnProperty, $29ce09d30a26f47a$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $29ce09d30a26f47a$var$illegalAttributeNameCache = {}, $29ce09d30a26f47a$var$validatedAttributeNameCache = {};
function $29ce09d30a26f47a$var$isAttributeNameSafe(attributeName) {
    if ($29ce09d30a26f47a$var$hasOwnProperty.call($29ce09d30a26f47a$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($29ce09d30a26f47a$var$hasOwnProperty.call($29ce09d30a26f47a$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($29ce09d30a26f47a$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $29ce09d30a26f47a$var$validatedAttributeNameCache[attributeName] = !0;
    $29ce09d30a26f47a$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $29ce09d30a26f47a$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), $29ce09d30a26f47a$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $29ce09d30a26f47a$var$matchHtmlRegExp = /["'&<>]/;
function $29ce09d30a26f47a$var$escapeTextForBrowser(text) {
    if ("boolean" === typeof text || "number" === typeof text || "bigint" === typeof text) return "" + text;
    text = "" + text;
    var match = $29ce09d30a26f47a$var$matchHtmlRegExp.exec(text);
    if (match) {
        var html = "", index, lastIndex = 0;
        for(index = match.index; index < text.length; index++){
            switch(text.charCodeAt(index)){
                case 34:
                    match = "&quot;";
                    break;
                case 38:
                    match = "&amp;";
                    break;
                case 39:
                    match = "&#x27;";
                    break;
                case 60:
                    match = "&lt;";
                    break;
                case 62:
                    match = "&gt;";
                    break;
                default:
                    continue;
            }
            lastIndex !== index && (html += text.slice(lastIndex, index));
            lastIndex = index + 1;
            html += match;
        }
        text = lastIndex !== index ? html + text.slice(lastIndex, index) : html;
    }
    return text;
}
var $29ce09d30a26f47a$var$uppercasePattern = /([A-Z])/g, $29ce09d30a26f47a$var$msPattern = /^ms-/, $29ce09d30a26f47a$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $29ce09d30a26f47a$var$sanitizeURL(url) {
    return $29ce09d30a26f47a$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $29ce09d30a26f47a$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $29ce09d30a26f47a$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $29ce09d30a26f47a$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $29ce09d30a26f47a$var$previousDispatcher = $29ce09d30a26f47a$var$ReactDOMSharedInternals.d;
$29ce09d30a26f47a$var$ReactDOMSharedInternals.d = {
    f: $29ce09d30a26f47a$var$previousDispatcher.f,
    r: $29ce09d30a26f47a$var$previousDispatcher.r,
    D: $29ce09d30a26f47a$var$prefetchDNS,
    C: $29ce09d30a26f47a$var$preconnect,
    L: $29ce09d30a26f47a$var$preload,
    m: $29ce09d30a26f47a$var$preloadModule,
    X: $29ce09d30a26f47a$var$preinitScript,
    S: $29ce09d30a26f47a$var$preinitStyle,
    M: $29ce09d30a26f47a$var$preinitModuleScript
};
var $29ce09d30a26f47a$var$PRELOAD_NO_CREDS = [], $29ce09d30a26f47a$var$currentlyFlushingRenderState = null;
$29ce09d30a26f47a$var$stringToPrecomputedChunk('"></template>');
var $29ce09d30a26f47a$var$startInlineScript = $29ce09d30a26f47a$var$stringToPrecomputedChunk("<script"), $29ce09d30a26f47a$var$endInlineScript = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c/script>"), $29ce09d30a26f47a$var$startScriptSrc = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<script src="'), $29ce09d30a26f47a$var$startModuleSrc = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<script type="module" src="'), $29ce09d30a26f47a$var$scriptNonce = $29ce09d30a26f47a$var$stringToPrecomputedChunk(' nonce="'), $29ce09d30a26f47a$var$scriptIntegirty = $29ce09d30a26f47a$var$stringToPrecomputedChunk(' integrity="'), $29ce09d30a26f47a$var$scriptCrossOrigin = $29ce09d30a26f47a$var$stringToPrecomputedChunk(' crossorigin="'), $29ce09d30a26f47a$var$endAsyncScript = $29ce09d30a26f47a$var$stringToPrecomputedChunk(' async="">\x3c/script>'), $29ce09d30a26f47a$var$startInlineStyle = $29ce09d30a26f47a$var$stringToPrecomputedChunk("<style"), $29ce09d30a26f47a$var$scriptRegex = /(<\/|<)(s)(cript)/gi;
function $29ce09d30a26f47a$var$scriptReplacer(match, prefix, s, suffix) {
    return "" + prefix + ("s" === s ? "\\u0073" : "\\u0053") + suffix;
}
var $29ce09d30a26f47a$var$importMapScriptStart = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<script type="importmap">'), $29ce09d30a26f47a$var$importMapScriptEnd = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c/script>");
function $29ce09d30a26f47a$var$createRenderState(resumableState, nonce, externalRuntimeConfig, importMap, onHeaders, maxHeadersLength) {
    externalRuntimeConfig = "string" === typeof nonce ? nonce : nonce && nonce.script;
    var inlineScriptWithNonce = void 0 === externalRuntimeConfig ? $29ce09d30a26f47a$var$startInlineScript : $29ce09d30a26f47a$var$stringToPrecomputedChunk('<script nonce="' + $29ce09d30a26f47a$var$escapeTextForBrowser(externalRuntimeConfig) + '"'), nonceStyle = "string" === typeof nonce ? void 0 : nonce && nonce.style, inlineStyleWithNonce = void 0 === nonceStyle ? $29ce09d30a26f47a$var$startInlineStyle : $29ce09d30a26f47a$var$stringToPrecomputedChunk('<style nonce="' + $29ce09d30a26f47a$var$escapeTextForBrowser(nonceStyle) + '"'), idPrefix = resumableState.idPrefix, bootstrapChunks = [], bootstrapScriptContent = resumableState.bootstrapScriptContent, bootstrapScripts = resumableState.bootstrapScripts, bootstrapModules = resumableState.bootstrapModules;
    void 0 !== bootstrapScriptContent && (bootstrapChunks.push(inlineScriptWithNonce), $29ce09d30a26f47a$var$pushCompletedShellIdAttribute(bootstrapChunks, resumableState), bootstrapChunks.push($29ce09d30a26f47a$var$endOfStartTag, $29ce09d30a26f47a$var$stringToChunk(("" + bootstrapScriptContent).replace($29ce09d30a26f47a$var$scriptRegex, $29ce09d30a26f47a$var$scriptReplacer)), $29ce09d30a26f47a$var$endInlineScript));
    bootstrapScriptContent = [];
    void 0 !== importMap && (bootstrapScriptContent.push($29ce09d30a26f47a$var$importMapScriptStart), bootstrapScriptContent.push($29ce09d30a26f47a$var$stringToChunk(("" + JSON.stringify(importMap)).replace($29ce09d30a26f47a$var$scriptRegex, $29ce09d30a26f47a$var$scriptReplacer))), bootstrapScriptContent.push($29ce09d30a26f47a$var$importMapScriptEnd));
    importMap = onHeaders ? {
        preconnects: "",
        fontPreloads: "",
        highImagePreloads: "",
        remainingCapacity: 2 + ("number" === typeof maxHeadersLength ? maxHeadersLength : 2e3)
    } : null;
    onHeaders = {
        placeholderPrefix: $29ce09d30a26f47a$var$stringToPrecomputedChunk(idPrefix + "P:"),
        segmentPrefix: $29ce09d30a26f47a$var$stringToPrecomputedChunk(idPrefix + "S:"),
        boundaryPrefix: $29ce09d30a26f47a$var$stringToPrecomputedChunk(idPrefix + "B:"),
        startInlineScript: inlineScriptWithNonce,
        startInlineStyle: inlineStyleWithNonce,
        preamble: $29ce09d30a26f47a$var$createPreambleState(),
        externalRuntimeScript: null,
        bootstrapChunks: bootstrapChunks,
        importMapChunks: bootstrapScriptContent,
        onHeaders: onHeaders,
        headers: importMap,
        resets: {
            font: {},
            dns: {},
            connect: {
                default: {},
                anonymous: {},
                credentials: {}
            },
            image: {},
            style: {}
        },
        charsetChunks: [],
        viewportChunks: [],
        hoistableChunks: [],
        preconnects: new Set(),
        fontPreloads: new Set(),
        highImagePreloads: new Set(),
        styles: new Map(),
        bootstrapScripts: new Set(),
        scripts: new Set(),
        bulkPreloads: new Set(),
        preloads: {
            images: new Map(),
            stylesheets: new Map(),
            scripts: new Map(),
            moduleScripts: new Map()
        },
        nonce: {
            script: externalRuntimeConfig,
            style: nonceStyle
        },
        hoistableState: null,
        stylesToHoist: !1
    };
    if (void 0 !== bootstrapScripts) for(importMap = 0; importMap < bootstrapScripts.length; importMap++)idPrefix = bootstrapScripts[importMap], nonceStyle = inlineScriptWithNonce = void 0, inlineStyleWithNonce = {
        rel: "preload",
        as: "script",
        fetchPriority: "low",
        nonce: nonce
    }, "string" === typeof idPrefix ? inlineStyleWithNonce.href = maxHeadersLength = idPrefix : (inlineStyleWithNonce.href = maxHeadersLength = idPrefix.src, inlineStyleWithNonce.integrity = nonceStyle = "string" === typeof idPrefix.integrity ? idPrefix.integrity : void 0, inlineStyleWithNonce.crossOrigin = inlineScriptWithNonce = "string" === typeof idPrefix || null == idPrefix.crossOrigin ? void 0 : "use-credentials" === idPrefix.crossOrigin ? "use-credentials" : ""), idPrefix = resumableState, bootstrapScriptContent = maxHeadersLength, idPrefix.scriptResources[bootstrapScriptContent] = null, idPrefix.moduleScriptResources[bootstrapScriptContent] = null, idPrefix = [], $29ce09d30a26f47a$var$pushLinkImpl(idPrefix, inlineStyleWithNonce), onHeaders.bootstrapScripts.add(idPrefix), bootstrapChunks.push($29ce09d30a26f47a$var$startScriptSrc, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(maxHeadersLength)), $29ce09d30a26f47a$var$attributeEnd), externalRuntimeConfig && bootstrapChunks.push($29ce09d30a26f47a$var$scriptNonce, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(externalRuntimeConfig)), $29ce09d30a26f47a$var$attributeEnd), "string" === typeof nonceStyle && bootstrapChunks.push($29ce09d30a26f47a$var$scriptIntegirty, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(nonceStyle)), $29ce09d30a26f47a$var$attributeEnd), "string" === typeof inlineScriptWithNonce && bootstrapChunks.push($29ce09d30a26f47a$var$scriptCrossOrigin, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(inlineScriptWithNonce)), $29ce09d30a26f47a$var$attributeEnd), $29ce09d30a26f47a$var$pushCompletedShellIdAttribute(bootstrapChunks, resumableState), bootstrapChunks.push($29ce09d30a26f47a$var$endAsyncScript);
    if (void 0 !== bootstrapModules) for(nonce = 0; nonce < bootstrapModules.length; nonce++)nonceStyle = bootstrapModules[nonce], maxHeadersLength = importMap = void 0, inlineScriptWithNonce = {
        rel: "modulepreload",
        fetchPriority: "low",
        nonce: externalRuntimeConfig
    }, "string" === typeof nonceStyle ? inlineScriptWithNonce.href = bootstrapScripts = nonceStyle : (inlineScriptWithNonce.href = bootstrapScripts = nonceStyle.src, inlineScriptWithNonce.integrity = maxHeadersLength = "string" === typeof nonceStyle.integrity ? nonceStyle.integrity : void 0, inlineScriptWithNonce.crossOrigin = importMap = "string" === typeof nonceStyle || null == nonceStyle.crossOrigin ? void 0 : "use-credentials" === nonceStyle.crossOrigin ? "use-credentials" : ""), nonceStyle = resumableState, inlineStyleWithNonce = bootstrapScripts, nonceStyle.scriptResources[inlineStyleWithNonce] = null, nonceStyle.moduleScriptResources[inlineStyleWithNonce] = null, nonceStyle = [], $29ce09d30a26f47a$var$pushLinkImpl(nonceStyle, inlineScriptWithNonce), onHeaders.bootstrapScripts.add(nonceStyle), bootstrapChunks.push($29ce09d30a26f47a$var$startModuleSrc, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(bootstrapScripts)), $29ce09d30a26f47a$var$attributeEnd), externalRuntimeConfig && bootstrapChunks.push($29ce09d30a26f47a$var$scriptNonce, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(externalRuntimeConfig)), $29ce09d30a26f47a$var$attributeEnd), "string" === typeof maxHeadersLength && bootstrapChunks.push($29ce09d30a26f47a$var$scriptIntegirty, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(maxHeadersLength)), $29ce09d30a26f47a$var$attributeEnd), "string" === typeof importMap && bootstrapChunks.push($29ce09d30a26f47a$var$scriptCrossOrigin, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(importMap)), $29ce09d30a26f47a$var$attributeEnd), $29ce09d30a26f47a$var$pushCompletedShellIdAttribute(bootstrapChunks, resumableState), bootstrapChunks.push($29ce09d30a26f47a$var$endAsyncScript);
    return onHeaders;
}
function $29ce09d30a26f47a$var$createResumableState(identifierPrefix, externalRuntimeConfig, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
    return {
        idPrefix: void 0 === identifierPrefix ? "" : identifierPrefix,
        nextFormID: 0,
        streamingFormat: 0,
        bootstrapScriptContent: bootstrapScriptContent,
        bootstrapScripts: bootstrapScripts,
        bootstrapModules: bootstrapModules,
        instructions: 0,
        hasBody: !1,
        hasHtml: !1,
        unknownResources: {},
        dnsResources: {},
        connectResources: {
            default: {},
            anonymous: {},
            credentials: {}
        },
        imageResources: {},
        styleResources: {},
        scriptResources: {},
        moduleUnknownResources: {},
        moduleScriptResources: {}
    };
}
function $29ce09d30a26f47a$var$createPreambleState() {
    return {
        htmlChunks: null,
        headChunks: null,
        bodyChunks: null
    };
}
function $29ce09d30a26f47a$var$createFormatContext(insertionMode, selectedValue, tagScope, viewTransition) {
    return {
        insertionMode: insertionMode,
        selectedValue: selectedValue,
        tagScope: tagScope,
        viewTransition: viewTransition
    };
}
function $29ce09d30a26f47a$var$createRootFormatContext(namespaceURI) {
    return $29ce09d30a26f47a$var$createFormatContext("http://www.w3.org/2000/svg" === namespaceURI ? 4 : "http://www.w3.org/1998/Math/MathML" === namespaceURI ? 5 : 0, null, 0, null);
}
function $29ce09d30a26f47a$var$getChildFormatContext(parentContext, type, props) {
    var subtreeScope = parentContext.tagScope & -25;
    switch(type){
        case "noscript":
            return $29ce09d30a26f47a$var$createFormatContext(2, null, subtreeScope | 1, null);
        case "select":
            return $29ce09d30a26f47a$var$createFormatContext(2, null != props.value ? props.value : props.defaultValue, subtreeScope, null);
        case "svg":
            return $29ce09d30a26f47a$var$createFormatContext(4, null, subtreeScope, null);
        case "picture":
            return $29ce09d30a26f47a$var$createFormatContext(2, null, subtreeScope | 2, null);
        case "math":
            return $29ce09d30a26f47a$var$createFormatContext(5, null, subtreeScope, null);
        case "foreignObject":
            return $29ce09d30a26f47a$var$createFormatContext(2, null, subtreeScope, null);
        case "table":
            return $29ce09d30a26f47a$var$createFormatContext(6, null, subtreeScope, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $29ce09d30a26f47a$var$createFormatContext(7, null, subtreeScope, null);
        case "colgroup":
            return $29ce09d30a26f47a$var$createFormatContext(9, null, subtreeScope, null);
        case "tr":
            return $29ce09d30a26f47a$var$createFormatContext(8, null, subtreeScope, null);
        case "head":
            if (2 > parentContext.insertionMode) return $29ce09d30a26f47a$var$createFormatContext(3, null, subtreeScope, null);
            break;
        case "html":
            if (0 === parentContext.insertionMode) return $29ce09d30a26f47a$var$createFormatContext(1, null, subtreeScope, null);
    }
    return 6 <= parentContext.insertionMode || 2 > parentContext.insertionMode ? $29ce09d30a26f47a$var$createFormatContext(2, null, subtreeScope, null) : parentContext.tagScope !== subtreeScope ? $29ce09d30a26f47a$var$createFormatContext(parentContext.insertionMode, parentContext.selectedValue, subtreeScope, null) : parentContext;
}
function $29ce09d30a26f47a$var$getSuspenseViewTransition(parentViewTransition) {
    return null === parentViewTransition ? null : {
        update: parentViewTransition.update,
        enter: "none",
        exit: "none",
        share: parentViewTransition.update,
        name: parentViewTransition.autoName,
        autoName: parentViewTransition.autoName,
        nameIdx: 0
    };
}
function $29ce09d30a26f47a$var$getSuspenseFallbackFormatContext(resumableState, parentContext) {
    parentContext.tagScope & 32 && (resumableState.instructions |= 128);
    return $29ce09d30a26f47a$var$createFormatContext(parentContext.insertionMode, parentContext.selectedValue, parentContext.tagScope | 12, $29ce09d30a26f47a$var$getSuspenseViewTransition(parentContext.viewTransition));
}
function $29ce09d30a26f47a$var$getSuspenseContentFormatContext(resumableState, parentContext) {
    resumableState = $29ce09d30a26f47a$var$getSuspenseViewTransition(parentContext.viewTransition);
    var subtreeScope = parentContext.tagScope | 16;
    null !== resumableState && "none" !== resumableState.share && (subtreeScope |= 64);
    return $29ce09d30a26f47a$var$createFormatContext(parentContext.insertionMode, parentContext.selectedValue, subtreeScope, resumableState);
}
var $29ce09d30a26f47a$var$textSeparator = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c!-- --\x3e");
function $29ce09d30a26f47a$var$pushTextInstance(target, text, renderState, textEmbedded) {
    if ("" === text) return textEmbedded;
    textEmbedded && target.push($29ce09d30a26f47a$var$textSeparator);
    target.push($29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(text)));
    return !0;
}
var $29ce09d30a26f47a$var$styleNameCache = new Map(), $29ce09d30a26f47a$var$styleAttributeStart = $29ce09d30a26f47a$var$stringToPrecomputedChunk(' style="'), $29ce09d30a26f47a$var$styleAssign = $29ce09d30a26f47a$var$stringToPrecomputedChunk(":"), $29ce09d30a26f47a$var$styleSeparator = $29ce09d30a26f47a$var$stringToPrecomputedChunk(";");
function $29ce09d30a26f47a$var$pushStyleAttribute(target, style) {
    if ("object" !== typeof style) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(62));
    var isFirst = !0, styleName;
    for(styleName in style)if ($29ce09d30a26f47a$var$hasOwnProperty.call(style, styleName)) {
        var styleValue = style[styleName];
        if (null != styleValue && "boolean" !== typeof styleValue && "" !== styleValue) {
            if (0 === styleName.indexOf("--")) {
                var nameChunk = $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(styleName));
                styleValue = $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(("" + styleValue).trim()));
            } else nameChunk = $29ce09d30a26f47a$var$styleNameCache.get(styleName), void 0 === nameChunk && (nameChunk = $29ce09d30a26f47a$var$stringToPrecomputedChunk($29ce09d30a26f47a$var$escapeTextForBrowser(styleName.replace($29ce09d30a26f47a$var$uppercasePattern, "-$1").toLowerCase().replace($29ce09d30a26f47a$var$msPattern, "-ms-"))), $29ce09d30a26f47a$var$styleNameCache.set(styleName, nameChunk)), styleValue = "number" === typeof styleValue ? 0 === styleValue || $29ce09d30a26f47a$var$unitlessNumbers.has(styleName) ? $29ce09d30a26f47a$var$stringToChunk("" + styleValue) : $29ce09d30a26f47a$var$stringToChunk(styleValue + "px") : $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(("" + styleValue).trim()));
            isFirst ? (isFirst = !1, target.push($29ce09d30a26f47a$var$styleAttributeStart, nameChunk, $29ce09d30a26f47a$var$styleAssign, styleValue)) : target.push($29ce09d30a26f47a$var$styleSeparator, nameChunk, $29ce09d30a26f47a$var$styleAssign, styleValue);
        }
    }
    isFirst || target.push($29ce09d30a26f47a$var$attributeEnd);
}
var $29ce09d30a26f47a$var$attributeSeparator = $29ce09d30a26f47a$var$stringToPrecomputedChunk(" "), $29ce09d30a26f47a$var$attributeAssign = $29ce09d30a26f47a$var$stringToPrecomputedChunk('="'), $29ce09d30a26f47a$var$attributeEnd = $29ce09d30a26f47a$var$stringToPrecomputedChunk('"'), $29ce09d30a26f47a$var$attributeEmptyString = $29ce09d30a26f47a$var$stringToPrecomputedChunk('=""');
function $29ce09d30a26f47a$var$pushBooleanAttribute(target, name, value) {
    value && "function" !== typeof value && "symbol" !== typeof value && target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk(name), $29ce09d30a26f47a$var$attributeEmptyString);
}
function $29ce09d30a26f47a$var$pushStringAttribute(target, name, value) {
    "function" !== typeof value && "symbol" !== typeof value && "boolean" !== typeof value && target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk(name), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(value)), $29ce09d30a26f47a$var$attributeEnd);
}
var $29ce09d30a26f47a$var$actionJavaScriptURL = $29ce09d30a26f47a$var$stringToPrecomputedChunk($29ce09d30a26f47a$var$escapeTextForBrowser("javascript:throw new Error('React form unexpectedly submitted.')")), $29ce09d30a26f47a$var$startHiddenInputChunk = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<input type="hidden"');
function $29ce09d30a26f47a$var$pushAdditionalFormField(value, key) {
    this.push($29ce09d30a26f47a$var$startHiddenInputChunk);
    $29ce09d30a26f47a$var$validateAdditionalFormField(value);
    $29ce09d30a26f47a$var$pushStringAttribute(this, "name", key);
    $29ce09d30a26f47a$var$pushStringAttribute(this, "value", value);
    this.push($29ce09d30a26f47a$var$endOfStartTagSelfClosing);
}
function $29ce09d30a26f47a$var$validateAdditionalFormField(value) {
    if ("string" !== typeof value) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(480));
}
function $29ce09d30a26f47a$var$getCustomFormFields(resumableState, formAction) {
    if ("function" === typeof formAction.$$FORM_ACTION) {
        var id = resumableState.nextFormID++;
        resumableState = resumableState.idPrefix + id;
        try {
            var customFields = formAction.$$FORM_ACTION(resumableState);
            if (customFields) {
                var formData = customFields.data;
                null != formData && formData.forEach($29ce09d30a26f47a$var$validateAdditionalFormField);
            }
            return customFields;
        } catch (x) {
            if ("object" === typeof x && null !== x && "function" === typeof x.then) throw x;
        }
    }
    return null;
}
function $29ce09d30a26f47a$var$pushFormActionAttribute(target, resumableState, renderState, formAction, formEncType, formMethod, formTarget, name) {
    var formData = null;
    if ("function" === typeof formAction) {
        var customFields = $29ce09d30a26f47a$var$getCustomFormFields(resumableState, formAction);
        null !== customFields ? (name = customFields.name, formAction = customFields.action || "", formEncType = customFields.encType, formMethod = customFields.method, formTarget = customFields.target, formData = customFields.data) : (target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk("formAction"), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$actionJavaScriptURL, $29ce09d30a26f47a$var$attributeEnd), formTarget = formMethod = formEncType = formAction = name = null, $29ce09d30a26f47a$var$injectFormReplayingRuntime(resumableState, renderState));
    }
    null != name && $29ce09d30a26f47a$var$pushAttribute(target, "name", name);
    null != formAction && $29ce09d30a26f47a$var$pushAttribute(target, "formAction", formAction);
    null != formEncType && $29ce09d30a26f47a$var$pushAttribute(target, "formEncType", formEncType);
    null != formMethod && $29ce09d30a26f47a$var$pushAttribute(target, "formMethod", formMethod);
    null != formTarget && $29ce09d30a26f47a$var$pushAttribute(target, "formTarget", formTarget);
    return formData;
}
function $29ce09d30a26f47a$var$pushAttribute(target, name, value) {
    switch(name){
        case "className":
            $29ce09d30a26f47a$var$pushStringAttribute(target, "class", value);
            break;
        case "tabIndex":
            $29ce09d30a26f47a$var$pushStringAttribute(target, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $29ce09d30a26f47a$var$pushStringAttribute(target, name, value);
            break;
        case "style":
            $29ce09d30a26f47a$var$pushStyleAttribute(target, value);
            break;
        case "src":
        case "href":
            if ("" === value) break;
        case "action":
        case "formAction":
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) break;
            value = $29ce09d30a26f47a$var$sanitizeURL("" + value);
            target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk(name), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(value)), $29ce09d30a26f47a$var$attributeEnd);
            break;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "ref":
            break;
        case "autoFocus":
        case "multiple":
        case "muted":
            $29ce09d30a26f47a$var$pushBooleanAttribute(target, name.toLowerCase(), value);
            break;
        case "xlinkHref":
            if ("function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) break;
            value = $29ce09d30a26f47a$var$sanitizeURL("" + value);
            target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk("xlink:href"), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(value)), $29ce09d30a26f47a$var$attributeEnd);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            "function" !== typeof value && "symbol" !== typeof value && target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk(name), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(value)), $29ce09d30a26f47a$var$attributeEnd);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value && target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk(name), $29ce09d30a26f47a$var$attributeEmptyString);
            break;
        case "capture":
        case "download":
            !0 === value ? target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk(name), $29ce09d30a26f47a$var$attributeEmptyString) : !1 !== value && "function" !== typeof value && "symbol" !== typeof value && target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk(name), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(value)), $29ce09d30a26f47a$var$attributeEnd);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value && target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk(name), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(value)), $29ce09d30a26f47a$var$attributeEnd);
            break;
        case "rowSpan":
        case "start":
            "function" === typeof value || "symbol" === typeof value || isNaN(value) || target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk(name), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(value)), $29ce09d30a26f47a$var$attributeEnd);
            break;
        case "xlinkActuate":
            $29ce09d30a26f47a$var$pushStringAttribute(target, "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $29ce09d30a26f47a$var$pushStringAttribute(target, "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $29ce09d30a26f47a$var$pushStringAttribute(target, "xlink:role", value);
            break;
        case "xlinkShow":
            $29ce09d30a26f47a$var$pushStringAttribute(target, "xlink:show", value);
            break;
        case "xlinkTitle":
            $29ce09d30a26f47a$var$pushStringAttribute(target, "xlink:title", value);
            break;
        case "xlinkType":
            $29ce09d30a26f47a$var$pushStringAttribute(target, "xlink:type", value);
            break;
        case "xmlBase":
            $29ce09d30a26f47a$var$pushStringAttribute(target, "xml:base", value);
            break;
        case "xmlLang":
            $29ce09d30a26f47a$var$pushStringAttribute(target, "xml:lang", value);
            break;
        case "xmlSpace":
            $29ce09d30a26f47a$var$pushStringAttribute(target, "xml:space", value);
            break;
        default:
            if (!(2 < name.length) || "o" !== name[0] && "O" !== name[0] || "n" !== name[1] && "N" !== name[1]) {
                if (name = $29ce09d30a26f47a$var$aliases.get(name) || name, $29ce09d30a26f47a$var$isAttributeNameSafe(name)) {
                    switch(typeof value){
                        case "function":
                        case "symbol":
                            return;
                        case "boolean":
                            var prefix$8 = name.toLowerCase().slice(0, 5);
                            if ("data-" !== prefix$8 && "aria-" !== prefix$8) return;
                    }
                    target.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk(name), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(value)), $29ce09d30a26f47a$var$attributeEnd);
                }
            }
    }
}
var $29ce09d30a26f47a$var$endOfStartTag = $29ce09d30a26f47a$var$stringToPrecomputedChunk(">"), $29ce09d30a26f47a$var$endOfStartTagSelfClosing = $29ce09d30a26f47a$var$stringToPrecomputedChunk("/>");
function $29ce09d30a26f47a$var$pushInnerHTML(target, innerHTML, children) {
    if (null != innerHTML) {
        if (null != children) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(60));
        if ("object" !== typeof innerHTML || !("__html" in innerHTML)) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(61));
        innerHTML = innerHTML.__html;
        null !== innerHTML && void 0 !== innerHTML && target.push($29ce09d30a26f47a$var$stringToChunk("" + innerHTML));
    }
}
function $29ce09d30a26f47a$var$flattenOptionChildren(children) {
    var content = "";
    $acw62.Children.forEach(children, function(child) {
        null != child && (content += child);
    });
    return content;
}
var $29ce09d30a26f47a$var$selectedMarkerAttribute = $29ce09d30a26f47a$var$stringToPrecomputedChunk(' selected=""'), $29ce09d30a26f47a$var$formReplayingRuntimeScript = $29ce09d30a26f47a$var$stringToPrecomputedChunk('addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error(\'React form unexpectedly submitted.\')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});');
function $29ce09d30a26f47a$var$injectFormReplayingRuntime(resumableState, renderState) {
    if (0 === (resumableState.instructions & 16)) {
        resumableState.instructions |= 16;
        var preamble = renderState.preamble, bootstrapChunks = renderState.bootstrapChunks;
        (preamble.htmlChunks || preamble.headChunks) && 0 === bootstrapChunks.length ? (bootstrapChunks.push(renderState.startInlineScript), $29ce09d30a26f47a$var$pushCompletedShellIdAttribute(bootstrapChunks, resumableState), bootstrapChunks.push($29ce09d30a26f47a$var$endOfStartTag, $29ce09d30a26f47a$var$formReplayingRuntimeScript, $29ce09d30a26f47a$var$endInlineScript)) : bootstrapChunks.unshift(renderState.startInlineScript, $29ce09d30a26f47a$var$endOfStartTag, $29ce09d30a26f47a$var$formReplayingRuntimeScript, $29ce09d30a26f47a$var$endInlineScript);
    }
}
var $29ce09d30a26f47a$var$formStateMarkerIsMatching = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c!--F!--\x3e"), $29ce09d30a26f47a$var$formStateMarkerIsNotMatching = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c!--F--\x3e");
function $29ce09d30a26f47a$var$pushLinkImpl(target, props) {
    target.push($29ce09d30a26f47a$var$startChunkForTag("link"));
    for(var propKey in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
            case "dangerouslySetInnerHTML":
                throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(399, "link"));
            default:
                $29ce09d30a26f47a$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($29ce09d30a26f47a$var$endOfStartTagSelfClosing);
    return null;
}
var $29ce09d30a26f47a$var$styleRegex = /(<\/|<)(s)(tyle)/gi;
function $29ce09d30a26f47a$var$styleReplacer(match, prefix, s, suffix) {
    return "" + prefix + ("s" === s ? "\\73 " : "\\53 ") + suffix;
}
function $29ce09d30a26f47a$var$pushSelfClosing(target, props, tag) {
    target.push($29ce09d30a26f47a$var$startChunkForTag(tag));
    for(var propKey in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
            case "dangerouslySetInnerHTML":
                throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(399, tag));
            default:
                $29ce09d30a26f47a$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($29ce09d30a26f47a$var$endOfStartTagSelfClosing);
    return null;
}
function $29ce09d30a26f47a$var$pushTitleImpl(target, props) {
    target.push($29ce09d30a26f47a$var$startChunkForTag("title"));
    var children = null, innerHTML = null, propKey;
    for(propKey in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                children = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $29ce09d30a26f47a$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($29ce09d30a26f47a$var$endOfStartTag);
    props = Array.isArray(children) ? 2 > children.length ? children[0] : null : children;
    "function" !== typeof props && "symbol" !== typeof props && null !== props && void 0 !== props && target.push($29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser("" + props)));
    $29ce09d30a26f47a$var$pushInnerHTML(target, innerHTML, children);
    target.push($29ce09d30a26f47a$var$endChunkForTag("title"));
    return null;
}
var $29ce09d30a26f47a$var$headPreambleContributionChunk = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c!--head--\x3e"), $29ce09d30a26f47a$var$bodyPreambleContributionChunk = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c!--body--\x3e"), $29ce09d30a26f47a$var$htmlPreambleContributionChunk = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c!--html--\x3e");
function $29ce09d30a26f47a$var$pushScriptImpl(target, props) {
    target.push($29ce09d30a26f47a$var$startChunkForTag("script"));
    var children = null, innerHTML = null, propKey;
    for(propKey in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                children = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $29ce09d30a26f47a$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($29ce09d30a26f47a$var$endOfStartTag);
    $29ce09d30a26f47a$var$pushInnerHTML(target, innerHTML, children);
    "string" === typeof children && target.push($29ce09d30a26f47a$var$stringToChunk(("" + children).replace($29ce09d30a26f47a$var$scriptRegex, $29ce09d30a26f47a$var$scriptReplacer)));
    target.push($29ce09d30a26f47a$var$endChunkForTag("script"));
    return null;
}
function $29ce09d30a26f47a$var$pushStartSingletonElement(target, props, tag) {
    target.push($29ce09d30a26f47a$var$startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for(propKey in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                tag = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $29ce09d30a26f47a$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($29ce09d30a26f47a$var$endOfStartTag);
    $29ce09d30a26f47a$var$pushInnerHTML(target, innerHTML, tag);
    return tag;
}
function $29ce09d30a26f47a$var$pushStartGenericElement(target, props, tag) {
    target.push($29ce09d30a26f47a$var$startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for(propKey in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                tag = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $29ce09d30a26f47a$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($29ce09d30a26f47a$var$endOfStartTag);
    $29ce09d30a26f47a$var$pushInnerHTML(target, innerHTML, tag);
    return "string" === typeof tag ? (target.push($29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(tag))), null) : tag;
}
var $29ce09d30a26f47a$var$leadingNewline = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\n"), $29ce09d30a26f47a$var$VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $29ce09d30a26f47a$var$validatedTagCache = new Map();
function $29ce09d30a26f47a$var$startChunkForTag(tag) {
    var tagStartChunk = $29ce09d30a26f47a$var$validatedTagCache.get(tag);
    if (void 0 === tagStartChunk) {
        if (!$29ce09d30a26f47a$var$VALID_TAG_REGEX.test(tag)) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(65, tag));
        tagStartChunk = $29ce09d30a26f47a$var$stringToPrecomputedChunk("<" + tag);
        $29ce09d30a26f47a$var$validatedTagCache.set(tag, tagStartChunk);
    }
    return tagStartChunk;
}
var $29ce09d30a26f47a$var$doctypeChunk = $29ce09d30a26f47a$var$stringToPrecomputedChunk("<!DOCTYPE html>");
function $29ce09d30a26f47a$var$pushStartInstance(target$jscomp$0, type, props, resumableState, renderState, preambleState, hoistableState, formatContext, textEmbedded) {
    switch(type){
        case "div":
        case "span":
        case "svg":
        case "path":
            break;
        case "a":
            target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag("a"));
            var children = null, innerHTML = null, propKey;
            for(propKey in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "children":
                        children = propValue;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML = propValue;
                        break;
                    case "href":
                        "" === propValue ? $29ce09d30a26f47a$var$pushStringAttribute(target$jscomp$0, "href", "") : $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey, propValue);
                        break;
                    default:
                        $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey, propValue);
                }
            }
            target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTag);
            $29ce09d30a26f47a$var$pushInnerHTML(target$jscomp$0, innerHTML, children);
            if ("string" === typeof children) {
                target$jscomp$0.push($29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(children)));
                var JSCompiler_inline_result = null;
            } else JSCompiler_inline_result = children;
            return JSCompiler_inline_result;
        case "g":
        case "p":
        case "li":
            break;
        case "select":
            target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag("select"));
            var children$jscomp$0 = null, innerHTML$jscomp$0 = null, propKey$jscomp$0;
            for(propKey$jscomp$0 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$0)) {
                var propValue$jscomp$0 = props[propKey$jscomp$0];
                if (null != propValue$jscomp$0) switch(propKey$jscomp$0){
                    case "children":
                        children$jscomp$0 = propValue$jscomp$0;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$0 = propValue$jscomp$0;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey$jscomp$0, propValue$jscomp$0);
                }
            }
            target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTag);
            $29ce09d30a26f47a$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$0, children$jscomp$0);
            return children$jscomp$0;
        case "option":
            var selectedValue = formatContext.selectedValue;
            target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag("option"));
            var children$jscomp$1 = null, value = null, selected = null, innerHTML$jscomp$1 = null, propKey$jscomp$1;
            for(propKey$jscomp$1 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$1)) {
                var propValue$jscomp$1 = props[propKey$jscomp$1];
                if (null != propValue$jscomp$1) switch(propKey$jscomp$1){
                    case "children":
                        children$jscomp$1 = propValue$jscomp$1;
                        break;
                    case "selected":
                        selected = propValue$jscomp$1;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$1 = propValue$jscomp$1;
                        break;
                    case "value":
                        value = propValue$jscomp$1;
                    default:
                        $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey$jscomp$1, propValue$jscomp$1);
                }
            }
            if (null != selectedValue) {
                var stringValue = null !== value ? "" + value : $29ce09d30a26f47a$var$flattenOptionChildren(children$jscomp$1);
                if ($29ce09d30a26f47a$var$isArrayImpl(selectedValue)) {
                    for(var i = 0; i < selectedValue.length; i++)if ("" + selectedValue[i] === stringValue) {
                        target$jscomp$0.push($29ce09d30a26f47a$var$selectedMarkerAttribute);
                        break;
                    }
                } else "" + selectedValue === stringValue && target$jscomp$0.push($29ce09d30a26f47a$var$selectedMarkerAttribute);
            } else selected && target$jscomp$0.push($29ce09d30a26f47a$var$selectedMarkerAttribute);
            target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTag);
            $29ce09d30a26f47a$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$1, children$jscomp$1);
            return children$jscomp$1;
        case "textarea":
            target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag("textarea"));
            var value$jscomp$0 = null, defaultValue = null, children$jscomp$2 = null, propKey$jscomp$2;
            for(propKey$jscomp$2 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$2)) {
                var propValue$jscomp$2 = props[propKey$jscomp$2];
                if (null != propValue$jscomp$2) switch(propKey$jscomp$2){
                    case "children":
                        children$jscomp$2 = propValue$jscomp$2;
                        break;
                    case "value":
                        value$jscomp$0 = propValue$jscomp$2;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$jscomp$2;
                        break;
                    case "dangerouslySetInnerHTML":
                        throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(91));
                    default:
                        $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey$jscomp$2, propValue$jscomp$2);
                }
            }
            null === value$jscomp$0 && null !== defaultValue && (value$jscomp$0 = defaultValue);
            target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTag);
            if (null != children$jscomp$2) {
                if (null != value$jscomp$0) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(92));
                if ($29ce09d30a26f47a$var$isArrayImpl(children$jscomp$2)) {
                    if (1 < children$jscomp$2.length) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(93));
                    value$jscomp$0 = "" + children$jscomp$2[0];
                }
                value$jscomp$0 = "" + children$jscomp$2;
            }
            "string" === typeof value$jscomp$0 && "\n" === value$jscomp$0[0] && target$jscomp$0.push($29ce09d30a26f47a$var$leadingNewline);
            null !== value$jscomp$0 && target$jscomp$0.push($29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser("" + value$jscomp$0)));
            return null;
        case "input":
            target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag("input"));
            var name = null, formAction = null, formEncType = null, formMethod = null, formTarget = null, value$jscomp$1 = null, defaultValue$jscomp$0 = null, checked = null, defaultChecked = null, propKey$jscomp$3;
            for(propKey$jscomp$3 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$3)) {
                var propValue$jscomp$3 = props[propKey$jscomp$3];
                if (null != propValue$jscomp$3) switch(propKey$jscomp$3){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(399, "input"));
                    case "name":
                        name = propValue$jscomp$3;
                        break;
                    case "formAction":
                        formAction = propValue$jscomp$3;
                        break;
                    case "formEncType":
                        formEncType = propValue$jscomp$3;
                        break;
                    case "formMethod":
                        formMethod = propValue$jscomp$3;
                        break;
                    case "formTarget":
                        formTarget = propValue$jscomp$3;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$jscomp$3;
                        break;
                    case "defaultValue":
                        defaultValue$jscomp$0 = propValue$jscomp$3;
                        break;
                    case "checked":
                        checked = propValue$jscomp$3;
                        break;
                    case "value":
                        value$jscomp$1 = propValue$jscomp$3;
                        break;
                    default:
                        $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey$jscomp$3, propValue$jscomp$3);
                }
            }
            var formData = $29ce09d30a26f47a$var$pushFormActionAttribute(target$jscomp$0, resumableState, renderState, formAction, formEncType, formMethod, formTarget, name);
            null !== checked ? $29ce09d30a26f47a$var$pushBooleanAttribute(target$jscomp$0, "checked", checked) : null !== defaultChecked && $29ce09d30a26f47a$var$pushBooleanAttribute(target$jscomp$0, "checked", defaultChecked);
            null !== value$jscomp$1 ? $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, "value", value$jscomp$1) : null !== defaultValue$jscomp$0 && $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, "value", defaultValue$jscomp$0);
            target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTagSelfClosing);
            null != formData && formData.forEach($29ce09d30a26f47a$var$pushAdditionalFormField, target$jscomp$0);
            return null;
        case "button":
            target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag("button"));
            var children$jscomp$3 = null, innerHTML$jscomp$2 = null, name$jscomp$0 = null, formAction$jscomp$0 = null, formEncType$jscomp$0 = null, formMethod$jscomp$0 = null, formTarget$jscomp$0 = null, propKey$jscomp$4;
            for(propKey$jscomp$4 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$4)) {
                var propValue$jscomp$4 = props[propKey$jscomp$4];
                if (null != propValue$jscomp$4) switch(propKey$jscomp$4){
                    case "children":
                        children$jscomp$3 = propValue$jscomp$4;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$2 = propValue$jscomp$4;
                        break;
                    case "name":
                        name$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formAction":
                        formAction$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formEncType":
                        formEncType$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formMethod":
                        formMethod$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formTarget":
                        formTarget$jscomp$0 = propValue$jscomp$4;
                        break;
                    default:
                        $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey$jscomp$4, propValue$jscomp$4);
                }
            }
            var formData$jscomp$0 = $29ce09d30a26f47a$var$pushFormActionAttribute(target$jscomp$0, resumableState, renderState, formAction$jscomp$0, formEncType$jscomp$0, formMethod$jscomp$0, formTarget$jscomp$0, name$jscomp$0);
            target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTag);
            null != formData$jscomp$0 && formData$jscomp$0.forEach($29ce09d30a26f47a$var$pushAdditionalFormField, target$jscomp$0);
            $29ce09d30a26f47a$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$2, children$jscomp$3);
            if ("string" === typeof children$jscomp$3) {
                target$jscomp$0.push($29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(children$jscomp$3)));
                var JSCompiler_inline_result$jscomp$0 = null;
            } else JSCompiler_inline_result$jscomp$0 = children$jscomp$3;
            return JSCompiler_inline_result$jscomp$0;
        case "form":
            target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag("form"));
            var children$jscomp$4 = null, innerHTML$jscomp$3 = null, formAction$jscomp$1 = null, formEncType$jscomp$1 = null, formMethod$jscomp$1 = null, formTarget$jscomp$1 = null, propKey$jscomp$5;
            for(propKey$jscomp$5 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$5)) {
                var propValue$jscomp$5 = props[propKey$jscomp$5];
                if (null != propValue$jscomp$5) switch(propKey$jscomp$5){
                    case "children":
                        children$jscomp$4 = propValue$jscomp$5;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$3 = propValue$jscomp$5;
                        break;
                    case "action":
                        formAction$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "encType":
                        formEncType$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "method":
                        formMethod$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "target":
                        formTarget$jscomp$1 = propValue$jscomp$5;
                        break;
                    default:
                        $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey$jscomp$5, propValue$jscomp$5);
                }
            }
            var formData$jscomp$1 = null, formActionName = null;
            if ("function" === typeof formAction$jscomp$1) {
                var customFields = $29ce09d30a26f47a$var$getCustomFormFields(resumableState, formAction$jscomp$1);
                null !== customFields ? (formAction$jscomp$1 = customFields.action || "", formEncType$jscomp$1 = customFields.encType, formMethod$jscomp$1 = customFields.method, formTarget$jscomp$1 = customFields.target, formData$jscomp$1 = customFields.data, formActionName = customFields.name) : (target$jscomp$0.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk("action"), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$actionJavaScriptURL, $29ce09d30a26f47a$var$attributeEnd), formTarget$jscomp$1 = formMethod$jscomp$1 = formEncType$jscomp$1 = formAction$jscomp$1 = null, $29ce09d30a26f47a$var$injectFormReplayingRuntime(resumableState, renderState));
            }
            null != formAction$jscomp$1 && $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, "action", formAction$jscomp$1);
            null != formEncType$jscomp$1 && $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, "encType", formEncType$jscomp$1);
            null != formMethod$jscomp$1 && $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, "method", formMethod$jscomp$1);
            null != formTarget$jscomp$1 && $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, "target", formTarget$jscomp$1);
            target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTag);
            null !== formActionName && (target$jscomp$0.push($29ce09d30a26f47a$var$startHiddenInputChunk), $29ce09d30a26f47a$var$pushStringAttribute(target$jscomp$0, "name", formActionName), target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTagSelfClosing), null != formData$jscomp$1 && formData$jscomp$1.forEach($29ce09d30a26f47a$var$pushAdditionalFormField, target$jscomp$0));
            $29ce09d30a26f47a$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$3, children$jscomp$4);
            if ("string" === typeof children$jscomp$4) {
                target$jscomp$0.push($29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(children$jscomp$4)));
                var JSCompiler_inline_result$jscomp$1 = null;
            } else JSCompiler_inline_result$jscomp$1 = children$jscomp$4;
            return JSCompiler_inline_result$jscomp$1;
        case "menuitem":
            target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag("menuitem"));
            for(var propKey$jscomp$6 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$6)) {
                var propValue$jscomp$6 = props[propKey$jscomp$6];
                if (null != propValue$jscomp$6) switch(propKey$jscomp$6){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(400));
                    default:
                        $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey$jscomp$6, propValue$jscomp$6);
                }
            }
            target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTag);
            return null;
        case "object":
            target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag("object"));
            var children$jscomp$5 = null, innerHTML$jscomp$4 = null, propKey$jscomp$7;
            for(propKey$jscomp$7 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$7)) {
                var propValue$jscomp$7 = props[propKey$jscomp$7];
                if (null != propValue$jscomp$7) switch(propKey$jscomp$7){
                    case "children":
                        children$jscomp$5 = propValue$jscomp$7;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$4 = propValue$jscomp$7;
                        break;
                    case "data":
                        var sanitizedValue = $29ce09d30a26f47a$var$sanitizeURL("" + propValue$jscomp$7);
                        if ("" === sanitizedValue) break;
                        target$jscomp$0.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk("data"), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(sanitizedValue)), $29ce09d30a26f47a$var$attributeEnd);
                        break;
                    default:
                        $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey$jscomp$7, propValue$jscomp$7);
                }
            }
            target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTag);
            $29ce09d30a26f47a$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$4, children$jscomp$5);
            if ("string" === typeof children$jscomp$5) {
                target$jscomp$0.push($29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(children$jscomp$5)));
                var JSCompiler_inline_result$jscomp$2 = null;
            } else JSCompiler_inline_result$jscomp$2 = children$jscomp$5;
            return JSCompiler_inline_result$jscomp$2;
        case "title":
            var noscriptTagInScope = formatContext.tagScope & 1, isFallback = formatContext.tagScope & 4;
            if (4 === formatContext.insertionMode || noscriptTagInScope || null != props.itemProp) var JSCompiler_inline_result$jscomp$3 = $29ce09d30a26f47a$var$pushTitleImpl(target$jscomp$0, props);
            else isFallback ? JSCompiler_inline_result$jscomp$3 = null : ($29ce09d30a26f47a$var$pushTitleImpl(renderState.hoistableChunks, props), JSCompiler_inline_result$jscomp$3 = void 0);
            return JSCompiler_inline_result$jscomp$3;
        case "link":
            var noscriptTagInScope$jscomp$0 = formatContext.tagScope & 1, isFallback$jscomp$0 = formatContext.tagScope & 4, rel = props.rel, href = props.href, precedence = props.precedence;
            if (4 === formatContext.insertionMode || noscriptTagInScope$jscomp$0 || null != props.itemProp || "string" !== typeof rel || "string" !== typeof href || "" === href) {
                $29ce09d30a26f47a$var$pushLinkImpl(target$jscomp$0, props);
                var JSCompiler_inline_result$jscomp$4 = null;
            } else if ("stylesheet" === props.rel) {
                if ("string" !== typeof precedence || null != props.disabled || props.onLoad || props.onError) JSCompiler_inline_result$jscomp$4 = $29ce09d30a26f47a$var$pushLinkImpl(target$jscomp$0, props);
                else {
                    var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
                    if (null !== resourceState) {
                        resumableState.styleResources[href] = null;
                        styleQueue || (styleQueue = {
                            precedence: $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(precedence)),
                            rules: [],
                            hrefs: [],
                            sheets: new Map()
                        }, renderState.styles.set(precedence, styleQueue));
                        var resource = {
                            state: 0,
                            props: $29ce09d30a26f47a$var$assign({}, props, {
                                "data-precedence": props.precedence,
                                precedence: null
                            })
                        };
                        if (resourceState) {
                            2 === resourceState.length && $29ce09d30a26f47a$var$adoptPreloadCredentials(resource.props, resourceState);
                            var preloadResource = renderState.preloads.stylesheets.get(href);
                            preloadResource && 0 < preloadResource.length ? preloadResource.length = 0 : resource.state = 1;
                        }
                        styleQueue.sheets.set(href, resource);
                        hoistableState && hoistableState.stylesheets.add(resource);
                    } else if (styleQueue) {
                        var resource$9 = styleQueue.sheets.get(href);
                        resource$9 && hoistableState && hoistableState.stylesheets.add(resource$9);
                    }
                    textEmbedded && target$jscomp$0.push($29ce09d30a26f47a$var$textSeparator);
                    JSCompiler_inline_result$jscomp$4 = null;
                }
            } else props.onLoad || props.onError ? JSCompiler_inline_result$jscomp$4 = $29ce09d30a26f47a$var$pushLinkImpl(target$jscomp$0, props) : (textEmbedded && target$jscomp$0.push($29ce09d30a26f47a$var$textSeparator), JSCompiler_inline_result$jscomp$4 = isFallback$jscomp$0 ? null : $29ce09d30a26f47a$var$pushLinkImpl(renderState.hoistableChunks, props));
            return JSCompiler_inline_result$jscomp$4;
        case "script":
            var noscriptTagInScope$jscomp$1 = formatContext.tagScope & 1, asyncProp = props.async;
            if ("string" !== typeof props.src || !props.src || !asyncProp || "function" === typeof asyncProp || "symbol" === typeof asyncProp || props.onLoad || props.onError || 4 === formatContext.insertionMode || noscriptTagInScope$jscomp$1 || null != props.itemProp) var JSCompiler_inline_result$jscomp$5 = $29ce09d30a26f47a$var$pushScriptImpl(target$jscomp$0, props);
            else {
                var key = props.src;
                if ("module" === props.type) {
                    var resources = resumableState.moduleScriptResources;
                    var preloads = renderState.preloads.moduleScripts;
                } else resources = resumableState.scriptResources, preloads = renderState.preloads.scripts;
                var resourceState$jscomp$0 = resources.hasOwnProperty(key) ? resources[key] : void 0;
                if (null !== resourceState$jscomp$0) {
                    resources[key] = null;
                    var scriptProps = props;
                    if (resourceState$jscomp$0) {
                        2 === resourceState$jscomp$0.length && (scriptProps = $29ce09d30a26f47a$var$assign({}, props), $29ce09d30a26f47a$var$adoptPreloadCredentials(scriptProps, resourceState$jscomp$0));
                        var preloadResource$jscomp$0 = preloads.get(key);
                        preloadResource$jscomp$0 && (preloadResource$jscomp$0.length = 0);
                    }
                    var resource$jscomp$0 = [];
                    renderState.scripts.add(resource$jscomp$0);
                    $29ce09d30a26f47a$var$pushScriptImpl(resource$jscomp$0, scriptProps);
                }
                textEmbedded && target$jscomp$0.push($29ce09d30a26f47a$var$textSeparator);
                JSCompiler_inline_result$jscomp$5 = null;
            }
            return JSCompiler_inline_result$jscomp$5;
        case "style":
            var noscriptTagInScope$jscomp$2 = formatContext.tagScope & 1, precedence$jscomp$0 = props.precedence, href$jscomp$0 = props.href, nonce = props.nonce;
            if (4 === formatContext.insertionMode || noscriptTagInScope$jscomp$2 || null != props.itemProp || "string" !== typeof precedence$jscomp$0 || "string" !== typeof href$jscomp$0 || "" === href$jscomp$0) {
                target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag("style"));
                var children$jscomp$6 = null, innerHTML$jscomp$5 = null, propKey$jscomp$8;
                for(propKey$jscomp$8 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$8)) {
                    var propValue$jscomp$8 = props[propKey$jscomp$8];
                    if (null != propValue$jscomp$8) switch(propKey$jscomp$8){
                        case "children":
                            children$jscomp$6 = propValue$jscomp$8;
                            break;
                        case "dangerouslySetInnerHTML":
                            innerHTML$jscomp$5 = propValue$jscomp$8;
                            break;
                        default:
                            $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey$jscomp$8, propValue$jscomp$8);
                    }
                }
                target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTag);
                var child = Array.isArray(children$jscomp$6) ? 2 > children$jscomp$6.length ? children$jscomp$6[0] : null : children$jscomp$6;
                "function" !== typeof child && "symbol" !== typeof child && null !== child && void 0 !== child && target$jscomp$0.push($29ce09d30a26f47a$var$stringToChunk(("" + child).replace($29ce09d30a26f47a$var$styleRegex, $29ce09d30a26f47a$var$styleReplacer)));
                $29ce09d30a26f47a$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$5, children$jscomp$6);
                target$jscomp$0.push($29ce09d30a26f47a$var$endChunkForTag("style"));
                var JSCompiler_inline_result$jscomp$6 = null;
            } else {
                var styleQueue$jscomp$0 = renderState.styles.get(precedence$jscomp$0);
                if (null !== (resumableState.styleResources.hasOwnProperty(href$jscomp$0) ? resumableState.styleResources[href$jscomp$0] : void 0)) {
                    resumableState.styleResources[href$jscomp$0] = null;
                    styleQueue$jscomp$0 || (styleQueue$jscomp$0 = {
                        precedence: $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(precedence$jscomp$0)),
                        rules: [],
                        hrefs: [],
                        sheets: new Map()
                    }, renderState.styles.set(precedence$jscomp$0, styleQueue$jscomp$0));
                    var nonceStyle = renderState.nonce.style;
                    if (!nonceStyle || nonceStyle === nonce) {
                        styleQueue$jscomp$0.hrefs.push($29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(href$jscomp$0)));
                        var target = styleQueue$jscomp$0.rules, children$jscomp$7 = null, innerHTML$jscomp$6 = null, propKey$jscomp$9;
                        for(propKey$jscomp$9 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$9)) {
                            var propValue$jscomp$9 = props[propKey$jscomp$9];
                            if (null != propValue$jscomp$9) switch(propKey$jscomp$9){
                                case "children":
                                    children$jscomp$7 = propValue$jscomp$9;
                                    break;
                                case "dangerouslySetInnerHTML":
                                    innerHTML$jscomp$6 = propValue$jscomp$9;
                            }
                        }
                        var child$jscomp$0 = Array.isArray(children$jscomp$7) ? 2 > children$jscomp$7.length ? children$jscomp$7[0] : null : children$jscomp$7;
                        "function" !== typeof child$jscomp$0 && "symbol" !== typeof child$jscomp$0 && null !== child$jscomp$0 && void 0 !== child$jscomp$0 && target.push($29ce09d30a26f47a$var$stringToChunk(("" + child$jscomp$0).replace($29ce09d30a26f47a$var$styleRegex, $29ce09d30a26f47a$var$styleReplacer)));
                        $29ce09d30a26f47a$var$pushInnerHTML(target, innerHTML$jscomp$6, children$jscomp$7);
                    }
                }
                styleQueue$jscomp$0 && hoistableState && hoistableState.styles.add(styleQueue$jscomp$0);
                textEmbedded && target$jscomp$0.push($29ce09d30a26f47a$var$textSeparator);
                JSCompiler_inline_result$jscomp$6 = void 0;
            }
            return JSCompiler_inline_result$jscomp$6;
        case "meta":
            var noscriptTagInScope$jscomp$3 = formatContext.tagScope & 1, isFallback$jscomp$1 = formatContext.tagScope & 4;
            if (4 === formatContext.insertionMode || noscriptTagInScope$jscomp$3 || null != props.itemProp) var JSCompiler_inline_result$jscomp$7 = $29ce09d30a26f47a$var$pushSelfClosing(target$jscomp$0, props, "meta");
            else textEmbedded && target$jscomp$0.push($29ce09d30a26f47a$var$textSeparator), JSCompiler_inline_result$jscomp$7 = isFallback$jscomp$1 ? null : "string" === typeof props.charSet ? $29ce09d30a26f47a$var$pushSelfClosing(renderState.charsetChunks, props, "meta") : "viewport" === props.name ? $29ce09d30a26f47a$var$pushSelfClosing(renderState.viewportChunks, props, "meta") : $29ce09d30a26f47a$var$pushSelfClosing(renderState.hoistableChunks, props, "meta");
            return JSCompiler_inline_result$jscomp$7;
        case "listing":
        case "pre":
            target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag(type));
            var children$jscomp$8 = null, innerHTML$jscomp$7 = null, propKey$jscomp$10;
            for(propKey$jscomp$10 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$10)) {
                var propValue$jscomp$10 = props[propKey$jscomp$10];
                if (null != propValue$jscomp$10) switch(propKey$jscomp$10){
                    case "children":
                        children$jscomp$8 = propValue$jscomp$10;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$7 = propValue$jscomp$10;
                        break;
                    default:
                        $29ce09d30a26f47a$var$pushAttribute(target$jscomp$0, propKey$jscomp$10, propValue$jscomp$10);
                }
            }
            target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTag);
            if (null != innerHTML$jscomp$7) {
                if (null != children$jscomp$8) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(60));
                if ("object" !== typeof innerHTML$jscomp$7 || !("__html" in innerHTML$jscomp$7)) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(61));
                var html = innerHTML$jscomp$7.__html;
                null !== html && void 0 !== html && ("string" === typeof html && 0 < html.length && "\n" === html[0] ? target$jscomp$0.push($29ce09d30a26f47a$var$leadingNewline, $29ce09d30a26f47a$var$stringToChunk(html)) : target$jscomp$0.push($29ce09d30a26f47a$var$stringToChunk("" + html)));
            }
            "string" === typeof children$jscomp$8 && "\n" === children$jscomp$8[0] && target$jscomp$0.push($29ce09d30a26f47a$var$leadingNewline);
            return children$jscomp$8;
        case "img":
            var pictureOrNoScriptTagInScope = formatContext.tagScope & 3, src = props.src, srcSet = props.srcSet;
            if (!("lazy" === props.loading || !src && !srcSet || "string" !== typeof src && null != src || "string" !== typeof srcSet && null != srcSet || "low" === props.fetchPriority || pictureOrNoScriptTagInScope) && ("string" !== typeof src || ":" !== src[4] || "d" !== src[0] && "D" !== src[0] || "a" !== src[1] && "A" !== src[1] || "t" !== src[2] && "T" !== src[2] || "a" !== src[3] && "A" !== src[3]) && ("string" !== typeof srcSet || ":" !== srcSet[4] || "d" !== srcSet[0] && "D" !== srcSet[0] || "a" !== srcSet[1] && "A" !== srcSet[1] || "t" !== srcSet[2] && "T" !== srcSet[2] || "a" !== srcSet[3] && "A" !== srcSet[3])) {
                null !== hoistableState && formatContext.tagScope & 64 && (hoistableState.suspenseyImages = !0);
                var sizes = "string" === typeof props.sizes ? props.sizes : void 0, key$jscomp$0 = srcSet ? srcSet + "\n" + (sizes || "") : src, promotablePreloads = renderState.preloads.images, resource$jscomp$1 = promotablePreloads.get(key$jscomp$0);
                if (resource$jscomp$1) {
                    if ("high" === props.fetchPriority || 10 > renderState.highImagePreloads.size) promotablePreloads.delete(key$jscomp$0), renderState.highImagePreloads.add(resource$jscomp$1);
                } else if (!resumableState.imageResources.hasOwnProperty(key$jscomp$0)) {
                    resumableState.imageResources[key$jscomp$0] = $29ce09d30a26f47a$var$PRELOAD_NO_CREDS;
                    var input = props.crossOrigin;
                    var JSCompiler_inline_result$jscomp$8 = "string" === typeof input ? "use-credentials" === input ? input : "" : void 0;
                    var headers = renderState.headers, header;
                    headers && 0 < headers.remainingCapacity && "string" !== typeof props.srcSet && ("high" === props.fetchPriority || 500 > headers.highImagePreloads.length) && (header = $29ce09d30a26f47a$var$getPreloadAsHeader(src, "image", {
                        imageSrcSet: props.srcSet,
                        imageSizes: props.sizes,
                        crossOrigin: JSCompiler_inline_result$jscomp$8,
                        integrity: props.integrity,
                        nonce: props.nonce,
                        type: props.type,
                        fetchPriority: props.fetchPriority,
                        referrerPolicy: props.refererPolicy
                    }), 0 <= (headers.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key$jscomp$0] = $29ce09d30a26f47a$var$PRELOAD_NO_CREDS, headers.highImagePreloads && (headers.highImagePreloads += ", "), headers.highImagePreloads += header) : (resource$jscomp$1 = [], $29ce09d30a26f47a$var$pushLinkImpl(resource$jscomp$1, {
                        rel: "preload",
                        as: "image",
                        href: srcSet ? void 0 : src,
                        imageSrcSet: srcSet,
                        imageSizes: sizes,
                        crossOrigin: JSCompiler_inline_result$jscomp$8,
                        integrity: props.integrity,
                        type: props.type,
                        fetchPriority: props.fetchPriority,
                        referrerPolicy: props.referrerPolicy
                    }), "high" === props.fetchPriority || 10 > renderState.highImagePreloads.size ? renderState.highImagePreloads.add(resource$jscomp$1) : (renderState.bulkPreloads.add(resource$jscomp$1), promotablePreloads.set(key$jscomp$0, resource$jscomp$1)));
                }
            }
            return $29ce09d30a26f47a$var$pushSelfClosing(target$jscomp$0, props, "img");
        case "base":
        case "area":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "param":
        case "source":
        case "track":
        case "wbr":
            return $29ce09d30a26f47a$var$pushSelfClosing(target$jscomp$0, props, type);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            break;
        case "head":
            if (2 > formatContext.insertionMode) {
                var preamble = preambleState || renderState.preamble;
                if (preamble.headChunks) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(545, "`<head>`"));
                null !== preambleState && target$jscomp$0.push($29ce09d30a26f47a$var$headPreambleContributionChunk);
                preamble.headChunks = [];
                var JSCompiler_inline_result$jscomp$9 = $29ce09d30a26f47a$var$pushStartSingletonElement(preamble.headChunks, props, "head");
            } else JSCompiler_inline_result$jscomp$9 = $29ce09d30a26f47a$var$pushStartGenericElement(target$jscomp$0, props, "head");
            return JSCompiler_inline_result$jscomp$9;
        case "body":
            if (2 > formatContext.insertionMode) {
                var preamble$jscomp$0 = preambleState || renderState.preamble;
                if (preamble$jscomp$0.bodyChunks) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(545, "`<body>`"));
                null !== preambleState && target$jscomp$0.push($29ce09d30a26f47a$var$bodyPreambleContributionChunk);
                preamble$jscomp$0.bodyChunks = [];
                var JSCompiler_inline_result$jscomp$10 = $29ce09d30a26f47a$var$pushStartSingletonElement(preamble$jscomp$0.bodyChunks, props, "body");
            } else JSCompiler_inline_result$jscomp$10 = $29ce09d30a26f47a$var$pushStartGenericElement(target$jscomp$0, props, "body");
            return JSCompiler_inline_result$jscomp$10;
        case "html":
            if (0 === formatContext.insertionMode) {
                var preamble$jscomp$1 = preambleState || renderState.preamble;
                if (preamble$jscomp$1.htmlChunks) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(545, "`<html>`"));
                null !== preambleState && target$jscomp$0.push($29ce09d30a26f47a$var$htmlPreambleContributionChunk);
                preamble$jscomp$1.htmlChunks = [
                    $29ce09d30a26f47a$var$doctypeChunk
                ];
                var JSCompiler_inline_result$jscomp$11 = $29ce09d30a26f47a$var$pushStartSingletonElement(preamble$jscomp$1.htmlChunks, props, "html");
            } else JSCompiler_inline_result$jscomp$11 = $29ce09d30a26f47a$var$pushStartGenericElement(target$jscomp$0, props, "html");
            return JSCompiler_inline_result$jscomp$11;
        default:
            if (-1 !== type.indexOf("-")) {
                target$jscomp$0.push($29ce09d30a26f47a$var$startChunkForTag(type));
                var children$jscomp$9 = null, innerHTML$jscomp$8 = null, propKey$jscomp$11;
                for(propKey$jscomp$11 in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey$jscomp$11)) {
                    var propValue$jscomp$11 = props[propKey$jscomp$11];
                    if (null != propValue$jscomp$11) {
                        var attributeName = propKey$jscomp$11;
                        switch(propKey$jscomp$11){
                            case "children":
                                children$jscomp$9 = propValue$jscomp$11;
                                break;
                            case "dangerouslySetInnerHTML":
                                innerHTML$jscomp$8 = propValue$jscomp$11;
                                break;
                            case "style":
                                $29ce09d30a26f47a$var$pushStyleAttribute(target$jscomp$0, propValue$jscomp$11);
                                break;
                            case "suppressContentEditableWarning":
                            case "suppressHydrationWarning":
                            case "ref":
                                break;
                            case "className":
                                attributeName = "class";
                            default:
                                if ($29ce09d30a26f47a$var$isAttributeNameSafe(propKey$jscomp$11) && "function" !== typeof propValue$jscomp$11 && "symbol" !== typeof propValue$jscomp$11 && !1 !== propValue$jscomp$11) {
                                    if (!0 === propValue$jscomp$11) propValue$jscomp$11 = "";
                                    else if ("object" === typeof propValue$jscomp$11) continue;
                                    target$jscomp$0.push($29ce09d30a26f47a$var$attributeSeparator, $29ce09d30a26f47a$var$stringToChunk(attributeName), $29ce09d30a26f47a$var$attributeAssign, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(propValue$jscomp$11)), $29ce09d30a26f47a$var$attributeEnd);
                                }
                        }
                    }
                }
                target$jscomp$0.push($29ce09d30a26f47a$var$endOfStartTag);
                $29ce09d30a26f47a$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$8, children$jscomp$9);
                return children$jscomp$9;
            }
    }
    return $29ce09d30a26f47a$var$pushStartGenericElement(target$jscomp$0, props, type);
}
var $29ce09d30a26f47a$var$endTagCache = new Map();
function $29ce09d30a26f47a$var$endChunkForTag(tag) {
    var chunk = $29ce09d30a26f47a$var$endTagCache.get(tag);
    void 0 === chunk && (chunk = $29ce09d30a26f47a$var$stringToPrecomputedChunk("</" + tag + ">"), $29ce09d30a26f47a$var$endTagCache.set(tag, chunk));
    return chunk;
}
function $29ce09d30a26f47a$var$hoistPreambleState(renderState, preambleState) {
    renderState = renderState.preamble;
    null === renderState.htmlChunks && preambleState.htmlChunks && (renderState.htmlChunks = preambleState.htmlChunks);
    null === renderState.headChunks && preambleState.headChunks && (renderState.headChunks = preambleState.headChunks);
    null === renderState.bodyChunks && preambleState.bodyChunks && (renderState.bodyChunks = preambleState.bodyChunks);
}
function $29ce09d30a26f47a$var$writeBootstrap(destination, renderState) {
    renderState = renderState.bootstrapChunks;
    for(var i = 0; i < renderState.length - 1; i++)$29ce09d30a26f47a$var$writeChunk(destination, renderState[i]);
    return i < renderState.length ? (i = renderState[i], renderState.length = 0, $29ce09d30a26f47a$var$writeChunkAndReturn(destination, i)) : !0;
}
var $29ce09d30a26f47a$var$shellTimeRuntimeScript = $29ce09d30a26f47a$var$stringToPrecomputedChunk("requestAnimationFrame(function(){$RT=performance.now()});"), $29ce09d30a26f47a$var$placeholder1 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<template id="'), $29ce09d30a26f47a$var$placeholder2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('"></template>'), $29ce09d30a26f47a$var$startActivityBoundary = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c!--&--\x3e"), $29ce09d30a26f47a$var$endActivityBoundary = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c!--/&--\x3e"), $29ce09d30a26f47a$var$startCompletedSuspenseBoundary = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c!--$--\x3e"), $29ce09d30a26f47a$var$startPendingSuspenseBoundary1 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('\x3c!--$?--\x3e<template id="'), $29ce09d30a26f47a$var$startPendingSuspenseBoundary2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('"></template>'), $29ce09d30a26f47a$var$startClientRenderedSuspenseBoundary = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c!--$!--\x3e"), $29ce09d30a26f47a$var$endSuspenseBoundary = $29ce09d30a26f47a$var$stringToPrecomputedChunk("\x3c!--/$--\x3e"), $29ce09d30a26f47a$var$clientRenderedSuspenseBoundaryError1 = $29ce09d30a26f47a$var$stringToPrecomputedChunk("<template"), $29ce09d30a26f47a$var$clientRenderedSuspenseBoundaryErrorAttrInterstitial = $29ce09d30a26f47a$var$stringToPrecomputedChunk('"'), $29ce09d30a26f47a$var$clientRenderedSuspenseBoundaryError1A = $29ce09d30a26f47a$var$stringToPrecomputedChunk(' data-dgst="');
$29ce09d30a26f47a$var$stringToPrecomputedChunk(' data-msg="');
$29ce09d30a26f47a$var$stringToPrecomputedChunk(' data-stck="');
$29ce09d30a26f47a$var$stringToPrecomputedChunk(' data-cstck="');
var $29ce09d30a26f47a$var$clientRenderedSuspenseBoundaryError2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk("></template>");
function $29ce09d30a26f47a$var$writeStartPendingSuspenseBoundary(destination, renderState, id) {
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$startPendingSuspenseBoundary1);
    if (null === id) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(395));
    $29ce09d30a26f47a$var$writeChunk(destination, renderState.boundaryPrefix);
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk(id.toString(16)));
    return $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$startPendingSuspenseBoundary2);
}
var $29ce09d30a26f47a$var$startSegmentHTML = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<div hidden id="'), $29ce09d30a26f47a$var$startSegmentHTML2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('">'), $29ce09d30a26f47a$var$endSegmentHTML = $29ce09d30a26f47a$var$stringToPrecomputedChunk("</div>"), $29ce09d30a26f47a$var$startSegmentSVG = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<svg aria-hidden="true" style="display:none" id="'), $29ce09d30a26f47a$var$startSegmentSVG2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('">'), $29ce09d30a26f47a$var$endSegmentSVG = $29ce09d30a26f47a$var$stringToPrecomputedChunk("</svg>"), $29ce09d30a26f47a$var$startSegmentMathML = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<math aria-hidden="true" style="display:none" id="'), $29ce09d30a26f47a$var$startSegmentMathML2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('">'), $29ce09d30a26f47a$var$endSegmentMathML = $29ce09d30a26f47a$var$stringToPrecomputedChunk("</math>"), $29ce09d30a26f47a$var$startSegmentTable = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<table hidden id="'), $29ce09d30a26f47a$var$startSegmentTable2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('">'), $29ce09d30a26f47a$var$endSegmentTable = $29ce09d30a26f47a$var$stringToPrecomputedChunk("</table>"), $29ce09d30a26f47a$var$startSegmentTableBody = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<table hidden><tbody id="'), $29ce09d30a26f47a$var$startSegmentTableBody2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('">'), $29ce09d30a26f47a$var$endSegmentTableBody = $29ce09d30a26f47a$var$stringToPrecomputedChunk("</tbody></table>"), $29ce09d30a26f47a$var$startSegmentTableRow = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<table hidden><tr id="'), $29ce09d30a26f47a$var$startSegmentTableRow2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('">'), $29ce09d30a26f47a$var$endSegmentTableRow = $29ce09d30a26f47a$var$stringToPrecomputedChunk("</tr></table>"), $29ce09d30a26f47a$var$startSegmentColGroup = $29ce09d30a26f47a$var$stringToPrecomputedChunk('<table hidden><colgroup id="'), $29ce09d30a26f47a$var$startSegmentColGroup2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('">'), $29ce09d30a26f47a$var$endSegmentColGroup = $29ce09d30a26f47a$var$stringToPrecomputedChunk("</colgroup></table>");
function $29ce09d30a26f47a$var$writeStartSegment(destination, renderState, formatContext, id) {
    switch(formatContext.insertionMode){
        case 0:
        case 1:
        case 3:
        case 2:
            return $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$startSegmentHTML), $29ce09d30a26f47a$var$writeChunk(destination, renderState.segmentPrefix), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk(id.toString(16))), $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$startSegmentHTML2);
        case 4:
            return $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$startSegmentSVG), $29ce09d30a26f47a$var$writeChunk(destination, renderState.segmentPrefix), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk(id.toString(16))), $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$startSegmentSVG2);
        case 5:
            return $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$startSegmentMathML), $29ce09d30a26f47a$var$writeChunk(destination, renderState.segmentPrefix), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk(id.toString(16))), $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$startSegmentMathML2);
        case 6:
            return $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$startSegmentTable), $29ce09d30a26f47a$var$writeChunk(destination, renderState.segmentPrefix), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk(id.toString(16))), $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$startSegmentTable2);
        case 7:
            return $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$startSegmentTableBody), $29ce09d30a26f47a$var$writeChunk(destination, renderState.segmentPrefix), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk(id.toString(16))), $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$startSegmentTableBody2);
        case 8:
            return $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$startSegmentTableRow), $29ce09d30a26f47a$var$writeChunk(destination, renderState.segmentPrefix), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk(id.toString(16))), $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$startSegmentTableRow2);
        case 9:
            return $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$startSegmentColGroup), $29ce09d30a26f47a$var$writeChunk(destination, renderState.segmentPrefix), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk(id.toString(16))), $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$startSegmentColGroup2);
        default:
            throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(397));
    }
}
function $29ce09d30a26f47a$var$writeEndSegment(destination, formatContext) {
    switch(formatContext.insertionMode){
        case 0:
        case 1:
        case 3:
        case 2:
            return $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$endSegmentHTML);
        case 4:
            return $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$endSegmentSVG);
        case 5:
            return $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$endSegmentMathML);
        case 6:
            return $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$endSegmentTable);
        case 7:
            return $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$endSegmentTableBody);
        case 8:
            return $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$endSegmentTableRow);
        case 9:
            return $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$endSegmentColGroup);
        default:
            throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(397));
    }
}
var $29ce09d30a26f47a$var$completeSegmentScript1Full = $29ce09d30a26f47a$var$stringToPrecomputedChunk('$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $29ce09d30a26f47a$var$completeSegmentScript1Partial = $29ce09d30a26f47a$var$stringToPrecomputedChunk('$RS("'), $29ce09d30a26f47a$var$completeSegmentScript2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('","'), $29ce09d30a26f47a$var$completeSegmentScriptEnd = $29ce09d30a26f47a$var$stringToPrecomputedChunk('")\x3c/script>');
$29ce09d30a26f47a$var$stringToPrecomputedChunk('<template data-rsi="" data-sid="');
$29ce09d30a26f47a$var$stringToPrecomputedChunk('" data-pid="');
var $29ce09d30a26f47a$var$completeBoundaryScriptFunctionOnly = $29ce09d30a26f47a$var$stringToPrecomputedChunk('$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};\n$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};');
$29ce09d30a26f47a$var$stringToChunk('$RV=function(A,g){function k(a,b){var e=a.getAttribute(b);e&&(b=a.style,l.push(a,b.viewTransitionName,b.viewTransitionClass),"auto"!==e&&(b.viewTransitionClass=e),(a=a.getAttribute("vt-name"))||(a="_T_"+K++ +"_"),b.viewTransitionName=a,B=!0)}var B=!1,K=0,l=[];try{var f=document.__reactViewTransition;if(f){f.finished.finally($RV.bind(null,g));return}var m=new Map;for(f=1;f<g.length;f+=2)for(var h=g[f].querySelectorAll("[vt-share]"),d=0;d<h.length;d++){var c=h[d];m.set(c.getAttribute("vt-name"),c)}var u=[];for(h=0;h<g.length;h+=2){var C=g[h],x=C.parentNode;if(x){var v=x.getBoundingClientRect();if(v.left||v.top||v.width||v.height){c=C;for(f=0;c;){if(8===c.nodeType){var r=c.data;if("/$"===r)if(0===f)break;else f--;else"$"!==r&&"$?"!==r&&"$~"!==r&&"$!"!==r||f++}else if(1===c.nodeType){d=c;var D=d.getAttribute("vt-name"),y=m.get(D);k(d,y?"vt-share":"vt-exit");y&&(k(y,"vt-share"),m.set(D,null));var E=d.querySelectorAll("[vt-share]");for(d=0;d<E.length;d++){var F=E[d],G=F.getAttribute("vt-name"),\nH=m.get(G);H&&(k(F,"vt-share"),k(H,"vt-share"),m.set(G,null))}}c=c.nextSibling}for(var I=g[h+1],t=I.firstElementChild;t;)null!==m.get(t.getAttribute("vt-name"))&&k(t,"vt-enter"),t=t.nextElementSibling;c=x;do for(var n=c.firstElementChild;n;){var J=n.getAttribute("vt-update");J&&"none"!==J&&!l.includes(n)&&k(n,"vt-update");n=n.nextElementSibling}while((c=c.parentNode)&&1===c.nodeType&&"none"!==c.getAttribute("vt-update"));u.push.apply(u,I.querySelectorAll(\'img[src]:not([loading="lazy"])\'))}}}if(B){var z=\ndocument.__reactViewTransition=document.startViewTransition({update:function(){A(g);for(var a=[document.documentElement.clientHeight,document.fonts.ready],b={},e=0;e<u.length;b={g:b.g},e++)if(b.g=u[e],!b.g.complete){var p=b.g.getBoundingClientRect();0<p.bottom&&0<p.right&&p.top<window.innerHeight&&p.left<window.innerWidth&&(p=new Promise(function(w){return function(q){w.g.addEventListener("load",q);w.g.addEventListener("error",q)}}(b)),a.push(p))}return Promise.race([Promise.all(a),new Promise(function(w){var q=\nperformance.now();setTimeout(w,2300>q&&2E3<q?2300-q:500)})])},types:[]});z.ready.finally(function(){for(var a=l.length-3;0<=a;a-=3){var b=l[a],e=b.style;e.viewTransitionName=l[a+1];e.viewTransitionClass=l[a+1];""===b.getAttribute("style")&&b.removeAttribute("style")}});z.finished.finally(function(){document.__reactViewTransition===z&&(document.__reactViewTransition=null)});$RB=[];return}}catch(a){}A(g)}.bind(null,$RV);');
var $29ce09d30a26f47a$var$completeBoundaryScript1Partial = $29ce09d30a26f47a$var$stringToPrecomputedChunk('$RC("'), $29ce09d30a26f47a$var$completeBoundaryWithStylesScript1FullPartial = $29ce09d30a26f47a$var$stringToPrecomputedChunk('$RM=new Map;$RR=function(n,w,p){function u(q){this._p=null;q()}for(var r=new Map,t=document,h,b,e=t.querySelectorAll("link[data-precedence],style[data-precedence]"),v=[],k=0;b=e[k++];)"not all"===b.getAttribute("media")?v.push(b):("LINK"===b.tagName&&$RM.set(b.getAttribute("href"),b),r.set(b.dataset.precedence,h=b));e=0;b=[];var l,a;for(k=!0;;){if(k){var f=p[e++];if(!f){k=!1;e=0;continue}var c=!1,m=0;var d=f[m++];if(a=$RM.get(d)){var g=a._p;c=!0}else{a=t.createElement("link");a.href=d;a.rel=\n"stylesheet";for(a.dataset.precedence=l=f[m++];g=f[m++];)a.setAttribute(g,f[m++]);g=a._p=new Promise(function(q,x){a.onload=u.bind(a,q);a.onerror=u.bind(a,x)});$RM.set(d,a)}d=a.getAttribute("media");!g||d&&!matchMedia(d).matches||b.push(g);if(c)continue}else{a=v[e++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=r.get(l)||h;c===h&&(h=a);r.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=t.head,c.insertBefore(a,c.firstChild))}if(p=document.getElementById(n))p.previousSibling.data=\n"$~";Promise.all(b).then($RC.bind(null,n,w),$RX.bind(null,n,"CSS failed to load"))};$RR("'), $29ce09d30a26f47a$var$completeBoundaryWithStylesScript1Partial = $29ce09d30a26f47a$var$stringToPrecomputedChunk('$RR("'), $29ce09d30a26f47a$var$completeBoundaryScript2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('","'), $29ce09d30a26f47a$var$completeBoundaryScript3a = $29ce09d30a26f47a$var$stringToPrecomputedChunk('",'), $29ce09d30a26f47a$var$completeBoundaryScript3b = $29ce09d30a26f47a$var$stringToPrecomputedChunk('"'), $29ce09d30a26f47a$var$completeBoundaryScriptEnd = $29ce09d30a26f47a$var$stringToPrecomputedChunk(")\x3c/script>");
$29ce09d30a26f47a$var$stringToPrecomputedChunk('<template data-rci="" data-bid="');
$29ce09d30a26f47a$var$stringToPrecomputedChunk('<template data-rri="" data-bid="');
$29ce09d30a26f47a$var$stringToPrecomputedChunk('" data-sid="');
$29ce09d30a26f47a$var$stringToPrecomputedChunk('" data-sty="');
var $29ce09d30a26f47a$var$clientRenderScriptFunctionOnly = $29ce09d30a26f47a$var$stringToPrecomputedChunk('$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};'), $29ce09d30a26f47a$var$clientRenderScript1Full = $29ce09d30a26f47a$var$stringToPrecomputedChunk('$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'), $29ce09d30a26f47a$var$clientRenderScript1Partial = $29ce09d30a26f47a$var$stringToPrecomputedChunk('$RX("'), $29ce09d30a26f47a$var$clientRenderScript1A = $29ce09d30a26f47a$var$stringToPrecomputedChunk('"'), $29ce09d30a26f47a$var$clientRenderErrorScriptArgInterstitial = $29ce09d30a26f47a$var$stringToPrecomputedChunk(","), $29ce09d30a26f47a$var$clientRenderScriptEnd = $29ce09d30a26f47a$var$stringToPrecomputedChunk(")\x3c/script>");
$29ce09d30a26f47a$var$stringToPrecomputedChunk('<template data-rxi="" data-bid="');
$29ce09d30a26f47a$var$stringToPrecomputedChunk('" data-dgst="');
$29ce09d30a26f47a$var$stringToPrecomputedChunk('" data-msg="');
$29ce09d30a26f47a$var$stringToPrecomputedChunk('" data-stck="');
$29ce09d30a26f47a$var$stringToPrecomputedChunk('" data-cstck="');
var $29ce09d30a26f47a$var$regexForJSStringsInInstructionScripts = /[<\u2028\u2029]/g;
function $29ce09d30a26f47a$var$escapeJSStringsForInstructionScripts(input) {
    return JSON.stringify(input).replace($29ce09d30a26f47a$var$regexForJSStringsInInstructionScripts, function(match) {
        switch(match){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $29ce09d30a26f47a$var$regexForJSStringsInScripts = /[&><\u2028\u2029]/g;
function $29ce09d30a26f47a$var$escapeJSObjectForInstructionScripts(input) {
    return JSON.stringify(input).replace($29ce09d30a26f47a$var$regexForJSStringsInScripts, function(match) {
        switch(match){
            case "&":
                return "\\u0026";
            case ">":
                return "\\u003e";
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $29ce09d30a26f47a$var$lateStyleTagResourceOpen1 = $29ce09d30a26f47a$var$stringToPrecomputedChunk(' media="not all" data-precedence="'), $29ce09d30a26f47a$var$lateStyleTagResourceOpen2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('" data-href="'), $29ce09d30a26f47a$var$lateStyleTagResourceOpen3 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('">'), $29ce09d30a26f47a$var$lateStyleTagTemplateClose = $29ce09d30a26f47a$var$stringToPrecomputedChunk("</style>"), $29ce09d30a26f47a$var$currentlyRenderingBoundaryHasStylesToHoist = !1, $29ce09d30a26f47a$var$destinationHasCapacity = !0;
function $29ce09d30a26f47a$var$flushStyleTagsLateForBoundary(styleQueue) {
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs, i = 0;
    if (hrefs.length) {
        $29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$currentlyFlushingRenderState.startInlineStyle);
        $29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$lateStyleTagResourceOpen1);
        $29ce09d30a26f47a$var$writeChunk(this, styleQueue.precedence);
        for($29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$lateStyleTagResourceOpen2); i < hrefs.length - 1; i++)$29ce09d30a26f47a$var$writeChunk(this, hrefs[i]), $29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$spaceSeparator);
        $29ce09d30a26f47a$var$writeChunk(this, hrefs[i]);
        $29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$lateStyleTagResourceOpen3);
        for(i = 0; i < rules.length; i++)$29ce09d30a26f47a$var$writeChunk(this, rules[i]);
        $29ce09d30a26f47a$var$destinationHasCapacity = $29ce09d30a26f47a$var$writeChunkAndReturn(this, $29ce09d30a26f47a$var$lateStyleTagTemplateClose);
        $29ce09d30a26f47a$var$currentlyRenderingBoundaryHasStylesToHoist = !0;
        rules.length = 0;
        hrefs.length = 0;
    }
}
function $29ce09d30a26f47a$var$hasStylesToHoist(stylesheet) {
    return 2 !== stylesheet.state ? $29ce09d30a26f47a$var$currentlyRenderingBoundaryHasStylesToHoist = !0 : !1;
}
function $29ce09d30a26f47a$var$writeHoistablesForBoundary(destination, hoistableState, renderState) {
    $29ce09d30a26f47a$var$currentlyRenderingBoundaryHasStylesToHoist = !1;
    $29ce09d30a26f47a$var$destinationHasCapacity = !0;
    $29ce09d30a26f47a$var$currentlyFlushingRenderState = renderState;
    hoistableState.styles.forEach($29ce09d30a26f47a$var$flushStyleTagsLateForBoundary, destination);
    $29ce09d30a26f47a$var$currentlyFlushingRenderState = null;
    hoistableState.stylesheets.forEach($29ce09d30a26f47a$var$hasStylesToHoist);
    $29ce09d30a26f47a$var$currentlyRenderingBoundaryHasStylesToHoist && (renderState.stylesToHoist = !0);
    return $29ce09d30a26f47a$var$destinationHasCapacity;
}
function $29ce09d30a26f47a$var$flushResource(resource) {
    for(var i = 0; i < resource.length; i++)$29ce09d30a26f47a$var$writeChunk(this, resource[i]);
    resource.length = 0;
}
var $29ce09d30a26f47a$var$stylesheetFlushingQueue = [];
function $29ce09d30a26f47a$var$flushStyleInPreamble(stylesheet) {
    $29ce09d30a26f47a$var$pushLinkImpl($29ce09d30a26f47a$var$stylesheetFlushingQueue, stylesheet.props);
    for(var i = 0; i < $29ce09d30a26f47a$var$stylesheetFlushingQueue.length; i++)$29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$stylesheetFlushingQueue[i]);
    $29ce09d30a26f47a$var$stylesheetFlushingQueue.length = 0;
    stylesheet.state = 2;
}
var $29ce09d30a26f47a$var$styleTagResourceOpen1 = $29ce09d30a26f47a$var$stringToPrecomputedChunk(' data-precedence="'), $29ce09d30a26f47a$var$styleTagResourceOpen2 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('" data-href="'), $29ce09d30a26f47a$var$spaceSeparator = $29ce09d30a26f47a$var$stringToPrecomputedChunk(" "), $29ce09d30a26f47a$var$styleTagResourceOpen3 = $29ce09d30a26f47a$var$stringToPrecomputedChunk('">'), $29ce09d30a26f47a$var$styleTagResourceClose = $29ce09d30a26f47a$var$stringToPrecomputedChunk("</style>");
function $29ce09d30a26f47a$var$flushStylesInPreamble(styleQueue) {
    var hasStylesheets = 0 < styleQueue.sheets.size;
    styleQueue.sheets.forEach($29ce09d30a26f47a$var$flushStyleInPreamble, this);
    styleQueue.sheets.clear();
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs;
    if (!hasStylesheets || hrefs.length) {
        $29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$currentlyFlushingRenderState.startInlineStyle);
        $29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$styleTagResourceOpen1);
        $29ce09d30a26f47a$var$writeChunk(this, styleQueue.precedence);
        styleQueue = 0;
        if (hrefs.length) {
            for($29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$styleTagResourceOpen2); styleQueue < hrefs.length - 1; styleQueue++)$29ce09d30a26f47a$var$writeChunk(this, hrefs[styleQueue]), $29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$spaceSeparator);
            $29ce09d30a26f47a$var$writeChunk(this, hrefs[styleQueue]);
        }
        $29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$styleTagResourceOpen3);
        for(styleQueue = 0; styleQueue < rules.length; styleQueue++)$29ce09d30a26f47a$var$writeChunk(this, rules[styleQueue]);
        $29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$styleTagResourceClose);
        rules.length = 0;
        hrefs.length = 0;
    }
}
function $29ce09d30a26f47a$var$preloadLateStyle(stylesheet) {
    if (0 === stylesheet.state) {
        stylesheet.state = 1;
        var props = stylesheet.props;
        $29ce09d30a26f47a$var$pushLinkImpl($29ce09d30a26f47a$var$stylesheetFlushingQueue, {
            rel: "preload",
            as: "style",
            href: stylesheet.props.href,
            crossOrigin: props.crossOrigin,
            fetchPriority: props.fetchPriority,
            integrity: props.integrity,
            media: props.media,
            hrefLang: props.hrefLang,
            referrerPolicy: props.referrerPolicy
        });
        for(stylesheet = 0; stylesheet < $29ce09d30a26f47a$var$stylesheetFlushingQueue.length; stylesheet++)$29ce09d30a26f47a$var$writeChunk(this, $29ce09d30a26f47a$var$stylesheetFlushingQueue[stylesheet]);
        $29ce09d30a26f47a$var$stylesheetFlushingQueue.length = 0;
    }
}
function $29ce09d30a26f47a$var$preloadLateStyles(styleQueue) {
    styleQueue.sheets.forEach($29ce09d30a26f47a$var$preloadLateStyle, this);
    styleQueue.sheets.clear();
}
$29ce09d30a26f47a$var$stringToPrecomputedChunk('<link rel="expect" href="#');
$29ce09d30a26f47a$var$stringToPrecomputedChunk('" blocking="render"/>');
var $29ce09d30a26f47a$var$completedShellIdAttributeStart = $29ce09d30a26f47a$var$stringToPrecomputedChunk(' id="');
function $29ce09d30a26f47a$var$pushCompletedShellIdAttribute(target, resumableState) {
    0 === (resumableState.instructions & 32) && (resumableState.instructions |= 32, target.push($29ce09d30a26f47a$var$completedShellIdAttributeStart, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser("_" + resumableState.idPrefix + "R_")), $29ce09d30a26f47a$var$attributeEnd));
}
var $29ce09d30a26f47a$var$arrayFirstOpenBracket = $29ce09d30a26f47a$var$stringToPrecomputedChunk("["), $29ce09d30a26f47a$var$arraySubsequentOpenBracket = $29ce09d30a26f47a$var$stringToPrecomputedChunk(",["), $29ce09d30a26f47a$var$arrayInterstitial = $29ce09d30a26f47a$var$stringToPrecomputedChunk(","), $29ce09d30a26f47a$var$arrayCloseBracket = $29ce09d30a26f47a$var$stringToPrecomputedChunk("]");
function $29ce09d30a26f47a$var$writeStyleResourceDependenciesInJS(destination, hoistableState) {
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$arrayFirstOpenBracket);
    var nextArrayOpenBrackChunk = $29ce09d30a26f47a$var$arrayFirstOpenBracket;
    hoistableState.stylesheets.forEach(function(resource) {
        if (2 !== resource.state) {
            if (3 === resource.state) $29ce09d30a26f47a$var$writeChunk(destination, nextArrayOpenBrackChunk), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeJSObjectForInstructionScripts("" + resource.props.href))), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$arrayCloseBracket), nextArrayOpenBrackChunk = $29ce09d30a26f47a$var$arraySubsequentOpenBracket;
            else {
                $29ce09d30a26f47a$var$writeChunk(destination, nextArrayOpenBrackChunk);
                var precedence = resource.props["data-precedence"], props = resource.props, coercedHref = $29ce09d30a26f47a$var$sanitizeURL("" + resource.props.href);
                $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeJSObjectForInstructionScripts(coercedHref)));
                precedence = "" + precedence;
                $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$arrayInterstitial);
                $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeJSObjectForInstructionScripts(precedence)));
                for(var propKey in props)if ($29ce09d30a26f47a$var$hasOwnProperty.call(props, propKey) && (precedence = props[propKey], null != precedence)) switch(propKey){
                    case "href":
                    case "rel":
                    case "precedence":
                    case "data-precedence":
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(399, "link"));
                    default:
                        $29ce09d30a26f47a$var$writeStyleResourceAttributeInJS(destination, propKey, precedence);
                }
                $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$arrayCloseBracket);
                nextArrayOpenBrackChunk = $29ce09d30a26f47a$var$arraySubsequentOpenBracket;
                resource.state = 3;
            }
        }
    });
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$arrayCloseBracket);
}
function $29ce09d30a26f47a$var$writeStyleResourceAttributeInJS(destination, name, value) {
    var attributeName = name.toLowerCase();
    switch(typeof value){
        case "function":
        case "symbol":
            return;
    }
    switch(name){
        case "innerHTML":
        case "dangerouslySetInnerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "style":
        case "ref":
            return;
        case "className":
            attributeName = "class";
            name = "" + value;
            break;
        case "hidden":
            if (!1 === value) return;
            name = "";
            break;
        case "src":
        case "href":
            value = $29ce09d30a26f47a$var$sanitizeURL(value);
            name = "" + value;
            break;
        default:
            if (2 < name.length && ("o" === name[0] || "O" === name[0]) && ("n" === name[1] || "N" === name[1]) || !$29ce09d30a26f47a$var$isAttributeNameSafe(name)) return;
            name = "" + value;
    }
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$arrayInterstitial);
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeJSObjectForInstructionScripts(attributeName)));
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$arrayInterstitial);
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeJSObjectForInstructionScripts(name)));
}
function $29ce09d30a26f47a$var$createHoistableState() {
    return {
        styles: new Set(),
        stylesheets: new Set(),
        suspenseyImages: !1
    };
}
function $29ce09d30a26f47a$var$prefetchDNS(href) {
    var request = $29ce09d30a26f47a$var$currentRequest ? $29ce09d30a26f47a$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if ("string" === typeof href && href) {
            if (!resumableState.dnsResources.hasOwnProperty(href)) {
                resumableState.dnsResources[href] = null;
                resumableState = renderState.headers;
                var header, JSCompiler_temp;
                if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity) JSCompiler_temp = (header = "<" + ("" + href).replace($29ce09d30a26f47a$var$regexForHrefInLinkHeaderURLContext, $29ce09d30a26f47a$var$escapeHrefForLinkHeaderURLContextReplacer) + ">; rel=dns-prefetch", 0 <= (resumableState.remainingCapacity -= header.length + 2));
                JSCompiler_temp ? (renderState.resets.dns[href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (header = [], $29ce09d30a26f47a$var$pushLinkImpl(header, {
                    href: href,
                    rel: "dns-prefetch"
                }), renderState.preconnects.add(header));
            }
            $29ce09d30a26f47a$var$enqueueFlush(request);
        }
    } else $29ce09d30a26f47a$var$previousDispatcher.D(href);
}
function $29ce09d30a26f47a$var$preconnect(href, crossOrigin) {
    var request = $29ce09d30a26f47a$var$currentRequest ? $29ce09d30a26f47a$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if ("string" === typeof href && href) {
            var bucket = "use-credentials" === crossOrigin ? "credentials" : "string" === typeof crossOrigin ? "anonymous" : "default";
            if (!resumableState.connectResources[bucket].hasOwnProperty(href)) {
                resumableState.connectResources[bucket][href] = null;
                resumableState = renderState.headers;
                var header, JSCompiler_temp;
                if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity) {
                    JSCompiler_temp = "<" + ("" + href).replace($29ce09d30a26f47a$var$regexForHrefInLinkHeaderURLContext, $29ce09d30a26f47a$var$escapeHrefForLinkHeaderURLContextReplacer) + ">; rel=preconnect";
                    if ("string" === typeof crossOrigin) {
                        var escapedCrossOrigin = ("" + crossOrigin).replace($29ce09d30a26f47a$var$regexForLinkHeaderQuotedParamValueContext, $29ce09d30a26f47a$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer);
                        JSCompiler_temp += '; crossorigin="' + escapedCrossOrigin + '"';
                    }
                    JSCompiler_temp = (header = JSCompiler_temp, 0 <= (resumableState.remainingCapacity -= header.length + 2));
                }
                JSCompiler_temp ? (renderState.resets.connect[bucket][href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (bucket = [], $29ce09d30a26f47a$var$pushLinkImpl(bucket, {
                    rel: "preconnect",
                    href: href,
                    crossOrigin: crossOrigin
                }), renderState.preconnects.add(bucket));
            }
            $29ce09d30a26f47a$var$enqueueFlush(request);
        }
    } else $29ce09d30a26f47a$var$previousDispatcher.C(href, crossOrigin);
}
function $29ce09d30a26f47a$var$preload(href, as, options) {
    var request = $29ce09d30a26f47a$var$currentRequest ? $29ce09d30a26f47a$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (as && href) {
            switch(as){
                case "image":
                    if (options) {
                        var imageSrcSet = options.imageSrcSet;
                        var imageSizes = options.imageSizes;
                        var fetchPriority = options.fetchPriority;
                    }
                    var key = imageSrcSet ? imageSrcSet + "\n" + (imageSizes || "") : href;
                    if (resumableState.imageResources.hasOwnProperty(key)) return;
                    resumableState.imageResources[key] = $29ce09d30a26f47a$var$PRELOAD_NO_CREDS;
                    resumableState = renderState.headers;
                    var header;
                    resumableState && 0 < resumableState.remainingCapacity && "string" !== typeof imageSrcSet && "high" === fetchPriority && (header = $29ce09d30a26f47a$var$getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key] = $29ce09d30a26f47a$var$PRELOAD_NO_CREDS, resumableState.highImagePreloads && (resumableState.highImagePreloads += ", "), resumableState.highImagePreloads += header) : (resumableState = [], $29ce09d30a26f47a$var$pushLinkImpl(resumableState, $29ce09d30a26f47a$var$assign({
                        rel: "preload",
                        href: imageSrcSet ? void 0 : href,
                        as: as
                    }, options)), "high" === fetchPriority ? renderState.highImagePreloads.add(resumableState) : (renderState.bulkPreloads.add(resumableState), renderState.preloads.images.set(key, resumableState)));
                    break;
                case "style":
                    if (resumableState.styleResources.hasOwnProperty(href)) return;
                    imageSrcSet = [];
                    $29ce09d30a26f47a$var$pushLinkImpl(imageSrcSet, $29ce09d30a26f47a$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options));
                    resumableState.styleResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $29ce09d30a26f47a$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    renderState.preloads.stylesheets.set(href, imageSrcSet);
                    renderState.bulkPreloads.add(imageSrcSet);
                    break;
                case "script":
                    if (resumableState.scriptResources.hasOwnProperty(href)) return;
                    imageSrcSet = [];
                    renderState.preloads.scripts.set(href, imageSrcSet);
                    renderState.bulkPreloads.add(imageSrcSet);
                    $29ce09d30a26f47a$var$pushLinkImpl(imageSrcSet, $29ce09d30a26f47a$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options));
                    resumableState.scriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $29ce09d30a26f47a$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    break;
                default:
                    if (resumableState.unknownResources.hasOwnProperty(as)) {
                        if (imageSrcSet = resumableState.unknownResources[as], imageSrcSet.hasOwnProperty(href)) return;
                    } else imageSrcSet = {}, resumableState.unknownResources[as] = imageSrcSet;
                    imageSrcSet[href] = $29ce09d30a26f47a$var$PRELOAD_NO_CREDS;
                    if ((resumableState = renderState.headers) && 0 < resumableState.remainingCapacity && "font" === as && (key = $29ce09d30a26f47a$var$getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= key.length + 2))) renderState.resets.font[href] = $29ce09d30a26f47a$var$PRELOAD_NO_CREDS, resumableState.fontPreloads && (resumableState.fontPreloads += ", "), resumableState.fontPreloads += key;
                    else switch(resumableState = [], href = $29ce09d30a26f47a$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options), $29ce09d30a26f47a$var$pushLinkImpl(resumableState, href), as){
                        case "font":
                            renderState.fontPreloads.add(resumableState);
                            break;
                        default:
                            renderState.bulkPreloads.add(resumableState);
                    }
            }
            $29ce09d30a26f47a$var$enqueueFlush(request);
        }
    } else $29ce09d30a26f47a$var$previousDispatcher.L(href, as, options);
}
function $29ce09d30a26f47a$var$preloadModule(href, options) {
    var request = $29ce09d30a26f47a$var$currentRequest ? $29ce09d30a26f47a$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (href) {
            var as = options && "string" === typeof options.as ? options.as : "script";
            switch(as){
                case "script":
                    if (resumableState.moduleScriptResources.hasOwnProperty(href)) return;
                    as = [];
                    resumableState.moduleScriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $29ce09d30a26f47a$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    renderState.preloads.moduleScripts.set(href, as);
                    break;
                default:
                    if (resumableState.moduleUnknownResources.hasOwnProperty(as)) {
                        var resources = resumableState.unknownResources[as];
                        if (resources.hasOwnProperty(href)) return;
                    } else resources = {}, resumableState.moduleUnknownResources[as] = resources;
                    as = [];
                    resources[href] = $29ce09d30a26f47a$var$PRELOAD_NO_CREDS;
            }
            $29ce09d30a26f47a$var$pushLinkImpl(as, $29ce09d30a26f47a$var$assign({
                rel: "modulepreload",
                href: href
            }, options));
            renderState.bulkPreloads.add(as);
            $29ce09d30a26f47a$var$enqueueFlush(request);
        }
    } else $29ce09d30a26f47a$var$previousDispatcher.m(href, options);
}
function $29ce09d30a26f47a$var$preinitStyle(href, precedence, options) {
    var request = $29ce09d30a26f47a$var$currentRequest ? $29ce09d30a26f47a$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (href) {
            precedence = precedence || "default";
            var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
            null !== resourceState && (resumableState.styleResources[href] = null, styleQueue || (styleQueue = {
                precedence: $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(precedence)),
                rules: [],
                hrefs: [],
                sheets: new Map()
            }, renderState.styles.set(precedence, styleQueue)), precedence = {
                state: 0,
                props: $29ce09d30a26f47a$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options)
            }, resourceState && (2 === resourceState.length && $29ce09d30a26f47a$var$adoptPreloadCredentials(precedence.props, resourceState), (renderState = renderState.preloads.stylesheets.get(href)) && 0 < renderState.length ? renderState.length = 0 : precedence.state = 1), styleQueue.sheets.set(href, precedence), $29ce09d30a26f47a$var$enqueueFlush(request));
        }
    } else $29ce09d30a26f47a$var$previousDispatcher.S(href, precedence, options);
}
function $29ce09d30a26f47a$var$preinitScript(src, options) {
    var request = $29ce09d30a26f47a$var$currentRequest ? $29ce09d30a26f47a$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (src) {
            var resourceState = resumableState.scriptResources.hasOwnProperty(src) ? resumableState.scriptResources[src] : void 0;
            null !== resourceState && (resumableState.scriptResources[src] = null, options = $29ce09d30a26f47a$var$assign({
                src: src,
                async: !0
            }, options), resourceState && (2 === resourceState.length && $29ce09d30a26f47a$var$adoptPreloadCredentials(options, resourceState), src = renderState.preloads.scripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), $29ce09d30a26f47a$var$pushScriptImpl(src, options), $29ce09d30a26f47a$var$enqueueFlush(request));
        }
    } else $29ce09d30a26f47a$var$previousDispatcher.X(src, options);
}
function $29ce09d30a26f47a$var$preinitModuleScript(src, options) {
    var request = $29ce09d30a26f47a$var$currentRequest ? $29ce09d30a26f47a$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (src) {
            var resourceState = resumableState.moduleScriptResources.hasOwnProperty(src) ? resumableState.moduleScriptResources[src] : void 0;
            null !== resourceState && (resumableState.moduleScriptResources[src] = null, options = $29ce09d30a26f47a$var$assign({
                src: src,
                type: "module",
                async: !0
            }, options), resourceState && (2 === resourceState.length && $29ce09d30a26f47a$var$adoptPreloadCredentials(options, resourceState), src = renderState.preloads.moduleScripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), $29ce09d30a26f47a$var$pushScriptImpl(src, options), $29ce09d30a26f47a$var$enqueueFlush(request));
        }
    } else $29ce09d30a26f47a$var$previousDispatcher.M(src, options);
}
function $29ce09d30a26f47a$var$adoptPreloadCredentials(target, preloadState) {
    null == target.crossOrigin && (target.crossOrigin = preloadState[0]);
    null == target.integrity && (target.integrity = preloadState[1]);
}
function $29ce09d30a26f47a$var$getPreloadAsHeader(href, as, params) {
    href = ("" + href).replace($29ce09d30a26f47a$var$regexForHrefInLinkHeaderURLContext, $29ce09d30a26f47a$var$escapeHrefForLinkHeaderURLContextReplacer);
    as = ("" + as).replace($29ce09d30a26f47a$var$regexForLinkHeaderQuotedParamValueContext, $29ce09d30a26f47a$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer);
    as = "<" + href + '>; rel=preload; as="' + as + '"';
    for(var paramName in params)$29ce09d30a26f47a$var$hasOwnProperty.call(params, paramName) && (href = params[paramName], "string" === typeof href && (as += "; " + paramName.toLowerCase() + '="' + ("" + href).replace($29ce09d30a26f47a$var$regexForLinkHeaderQuotedParamValueContext, $29ce09d30a26f47a$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer) + '"'));
    return as;
}
var $29ce09d30a26f47a$var$regexForHrefInLinkHeaderURLContext = /[<>\r\n]/g;
function $29ce09d30a26f47a$var$escapeHrefForLinkHeaderURLContextReplacer(match) {
    switch(match){
        case "<":
            return "%3C";
        case ">":
            return "%3E";
        case "\n":
            return "%0A";
        case "\r":
            return "%0D";
        default:
            throw Error("escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
}
var $29ce09d30a26f47a$var$regexForLinkHeaderQuotedParamValueContext = /["';,\r\n]/g;
function $29ce09d30a26f47a$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer(match) {
    switch(match){
        case '"':
            return "%22";
        case "'":
            return "%27";
        case ";":
            return "%3B";
        case ",":
            return "%2C";
        case "\n":
            return "%0A";
        case "\r":
            return "%0D";
        default:
            throw Error("escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
}
function $29ce09d30a26f47a$var$hoistStyleQueueDependency(styleQueue) {
    this.styles.add(styleQueue);
}
function $29ce09d30a26f47a$var$hoistStylesheetDependency(stylesheet) {
    this.stylesheets.add(stylesheet);
}
function $29ce09d30a26f47a$var$hoistHoistables(parentState, childState) {
    childState.styles.forEach($29ce09d30a26f47a$var$hoistStyleQueueDependency, parentState);
    childState.stylesheets.forEach($29ce09d30a26f47a$var$hoistStylesheetDependency, parentState);
    childState.suspenseyImages && (parentState.suspenseyImages = !0);
}
function $29ce09d30a26f47a$var$hasSuspenseyContent(hoistableState) {
    return 0 < hoistableState.stylesheets.size || hoistableState.suspenseyImages;
}
var $29ce09d30a26f47a$var$bind = Function.prototype.bind, $29ce09d30a26f47a$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $29ce09d30a26f47a$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $29ce09d30a26f47a$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $29ce09d30a26f47a$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $29ce09d30a26f47a$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $29ce09d30a26f47a$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $29ce09d30a26f47a$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $29ce09d30a26f47a$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $29ce09d30a26f47a$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $29ce09d30a26f47a$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $29ce09d30a26f47a$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $29ce09d30a26f47a$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $29ce09d30a26f47a$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $29ce09d30a26f47a$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $29ce09d30a26f47a$var$getComponentNameFromType(type.type) || "Memo";
        case $29ce09d30a26f47a$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $29ce09d30a26f47a$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $29ce09d30a26f47a$var$emptyContextObject = {}, $29ce09d30a26f47a$var$currentActiveSnapshot = null;
function $29ce09d30a26f47a$var$popToNearestCommonAncestor(prev, next) {
    if (prev !== next) {
        prev.context._currentValue = prev.parentValue;
        prev = prev.parent;
        var parentNext = next.parent;
        if (null === prev) {
            if (null !== parentNext) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(401));
        } else {
            if (null === parentNext) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(401));
            $29ce09d30a26f47a$var$popToNearestCommonAncestor(prev, parentNext);
        }
        next.context._currentValue = next.value;
    }
}
function $29ce09d30a26f47a$var$popAllPrevious(prev) {
    prev.context._currentValue = prev.parentValue;
    prev = prev.parent;
    null !== prev && $29ce09d30a26f47a$var$popAllPrevious(prev);
}
function $29ce09d30a26f47a$var$pushAllNext(next) {
    var parentNext = next.parent;
    null !== parentNext && $29ce09d30a26f47a$var$pushAllNext(parentNext);
    next.context._currentValue = next.value;
}
function $29ce09d30a26f47a$var$popPreviousToCommonLevel(prev, next) {
    prev.context._currentValue = prev.parentValue;
    prev = prev.parent;
    if (null === prev) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(402));
    prev.depth === next.depth ? $29ce09d30a26f47a$var$popToNearestCommonAncestor(prev, next) : $29ce09d30a26f47a$var$popPreviousToCommonLevel(prev, next);
}
function $29ce09d30a26f47a$var$popNextToCommonLevel(prev, next) {
    var parentNext = next.parent;
    if (null === parentNext) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(402));
    prev.depth === parentNext.depth ? $29ce09d30a26f47a$var$popToNearestCommonAncestor(prev, parentNext) : $29ce09d30a26f47a$var$popNextToCommonLevel(prev, parentNext);
    next.context._currentValue = next.value;
}
function $29ce09d30a26f47a$var$switchContext(newSnapshot) {
    var prev = $29ce09d30a26f47a$var$currentActiveSnapshot;
    prev !== newSnapshot && (null === prev ? $29ce09d30a26f47a$var$pushAllNext(newSnapshot) : null === newSnapshot ? $29ce09d30a26f47a$var$popAllPrevious(prev) : prev.depth === newSnapshot.depth ? $29ce09d30a26f47a$var$popToNearestCommonAncestor(prev, newSnapshot) : prev.depth > newSnapshot.depth ? $29ce09d30a26f47a$var$popPreviousToCommonLevel(prev, newSnapshot) : $29ce09d30a26f47a$var$popNextToCommonLevel(prev, newSnapshot), $29ce09d30a26f47a$var$currentActiveSnapshot = newSnapshot);
}
var $29ce09d30a26f47a$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload) {
        inst = inst._reactInternals;
        null !== inst.queue && inst.queue.push(payload);
    },
    enqueueReplaceState: function(inst, payload) {
        inst = inst._reactInternals;
        inst.replace = !0;
        inst.queue = [
            payload
        ];
    },
    enqueueForceUpdate: function() {}
}, $29ce09d30a26f47a$var$emptyTreeContext = {
    id: 1,
    overflow: ""
};
function $29ce09d30a26f47a$var$pushTreeContext(baseContext, totalChildren, index) {
    var baseIdWithLeadingBit = baseContext.id;
    baseContext = baseContext.overflow;
    var baseLength = 32 - $29ce09d30a26f47a$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $29ce09d30a26f47a$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        return {
            id: 1 << 32 - $29ce09d30a26f47a$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit,
            overflow: length + baseContext
        };
    }
    return {
        id: 1 << length | index << baseLength | baseIdWithLeadingBit,
        overflow: baseContext
    };
}
var $29ce09d30a26f47a$var$clz32 = Math.clz32 ? Math.clz32 : $29ce09d30a26f47a$var$clz32Fallback, $29ce09d30a26f47a$var$log = Math.log, $29ce09d30a26f47a$var$LN2 = Math.LN2;
function $29ce09d30a26f47a$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($29ce09d30a26f47a$var$log(x) / $29ce09d30a26f47a$var$LN2 | 0) | 0;
}
function $29ce09d30a26f47a$var$noop() {}
var $29ce09d30a26f47a$var$SuspenseException = Error($29ce09d30a26f47a$var$formatProdErrorMessage(460));
function $29ce09d30a26f47a$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($29ce09d30a26f47a$var$noop, $29ce09d30a26f47a$var$noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then($29ce09d30a26f47a$var$noop, $29ce09d30a26f47a$var$noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            $29ce09d30a26f47a$var$suspendedThenable = thenable;
            throw $29ce09d30a26f47a$var$SuspenseException;
    }
}
var $29ce09d30a26f47a$var$suspendedThenable = null;
function $29ce09d30a26f47a$var$getSuspendedThenable() {
    if (null === $29ce09d30a26f47a$var$suspendedThenable) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(459));
    var thenable = $29ce09d30a26f47a$var$suspendedThenable;
    $29ce09d30a26f47a$var$suspendedThenable = null;
    return thenable;
}
function $29ce09d30a26f47a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $29ce09d30a26f47a$var$objectIs = "function" === typeof Object.is ? Object.is : $29ce09d30a26f47a$var$is, $29ce09d30a26f47a$var$currentlyRenderingComponent = null, $29ce09d30a26f47a$var$currentlyRenderingTask = null, $29ce09d30a26f47a$var$currentlyRenderingRequest = null, $29ce09d30a26f47a$var$currentlyRenderingKeyPath = null, $29ce09d30a26f47a$var$firstWorkInProgressHook = null, $29ce09d30a26f47a$var$workInProgressHook = null, $29ce09d30a26f47a$var$isReRender = !1, $29ce09d30a26f47a$var$didScheduleRenderPhaseUpdate = !1, $29ce09d30a26f47a$var$localIdCounter = 0, $29ce09d30a26f47a$var$actionStateCounter = 0, $29ce09d30a26f47a$var$actionStateMatchingIndex = -1, $29ce09d30a26f47a$var$thenableIndexCounter = 0, $29ce09d30a26f47a$var$thenableState = null, $29ce09d30a26f47a$var$renderPhaseUpdates = null, $29ce09d30a26f47a$var$numberOfReRenders = 0;
function $29ce09d30a26f47a$var$resolveCurrentlyRenderingComponent() {
    if (null === $29ce09d30a26f47a$var$currentlyRenderingComponent) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(321));
    return $29ce09d30a26f47a$var$currentlyRenderingComponent;
}
function $29ce09d30a26f47a$var$createHook() {
    if (0 < $29ce09d30a26f47a$var$numberOfReRenders) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $29ce09d30a26f47a$var$createWorkInProgressHook() {
    null === $29ce09d30a26f47a$var$workInProgressHook ? null === $29ce09d30a26f47a$var$firstWorkInProgressHook ? ($29ce09d30a26f47a$var$isReRender = !1, $29ce09d30a26f47a$var$firstWorkInProgressHook = $29ce09d30a26f47a$var$workInProgressHook = $29ce09d30a26f47a$var$createHook()) : ($29ce09d30a26f47a$var$isReRender = !0, $29ce09d30a26f47a$var$workInProgressHook = $29ce09d30a26f47a$var$firstWorkInProgressHook) : null === $29ce09d30a26f47a$var$workInProgressHook.next ? ($29ce09d30a26f47a$var$isReRender = !1, $29ce09d30a26f47a$var$workInProgressHook = $29ce09d30a26f47a$var$workInProgressHook.next = $29ce09d30a26f47a$var$createHook()) : ($29ce09d30a26f47a$var$isReRender = !0, $29ce09d30a26f47a$var$workInProgressHook = $29ce09d30a26f47a$var$workInProgressHook.next);
    return $29ce09d30a26f47a$var$workInProgressHook;
}
function $29ce09d30a26f47a$var$getThenableStateAfterSuspending() {
    var state = $29ce09d30a26f47a$var$thenableState;
    $29ce09d30a26f47a$var$thenableState = null;
    return state;
}
function $29ce09d30a26f47a$var$resetHooksState() {
    $29ce09d30a26f47a$var$currentlyRenderingKeyPath = $29ce09d30a26f47a$var$currentlyRenderingRequest = $29ce09d30a26f47a$var$currentlyRenderingTask = $29ce09d30a26f47a$var$currentlyRenderingComponent = null;
    $29ce09d30a26f47a$var$didScheduleRenderPhaseUpdate = !1;
    $29ce09d30a26f47a$var$firstWorkInProgressHook = null;
    $29ce09d30a26f47a$var$numberOfReRenders = 0;
    $29ce09d30a26f47a$var$workInProgressHook = $29ce09d30a26f47a$var$renderPhaseUpdates = null;
}
function $29ce09d30a26f47a$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $29ce09d30a26f47a$var$useReducer(reducer, initialArg, init) {
    $29ce09d30a26f47a$var$currentlyRenderingComponent = $29ce09d30a26f47a$var$resolveCurrentlyRenderingComponent();
    $29ce09d30a26f47a$var$workInProgressHook = $29ce09d30a26f47a$var$createWorkInProgressHook();
    if ($29ce09d30a26f47a$var$isReRender) {
        var queue = $29ce09d30a26f47a$var$workInProgressHook.queue;
        initialArg = queue.dispatch;
        if (null !== $29ce09d30a26f47a$var$renderPhaseUpdates && (init = $29ce09d30a26f47a$var$renderPhaseUpdates.get(queue), void 0 !== init)) {
            $29ce09d30a26f47a$var$renderPhaseUpdates.delete(queue);
            queue = $29ce09d30a26f47a$var$workInProgressHook.memoizedState;
            do queue = reducer(queue, init.action), init = init.next;
            while (null !== init);
            $29ce09d30a26f47a$var$workInProgressHook.memoizedState = queue;
            return [
                queue,
                initialArg
            ];
        }
        return [
            $29ce09d30a26f47a$var$workInProgressHook.memoizedState,
            initialArg
        ];
    }
    reducer = reducer === $29ce09d30a26f47a$var$basicStateReducer ? "function" === typeof initialArg ? initialArg() : initialArg : void 0 !== init ? init(initialArg) : initialArg;
    $29ce09d30a26f47a$var$workInProgressHook.memoizedState = reducer;
    reducer = $29ce09d30a26f47a$var$workInProgressHook.queue = {
        last: null,
        dispatch: null
    };
    reducer = reducer.dispatch = $29ce09d30a26f47a$var$dispatchAction.bind(null, $29ce09d30a26f47a$var$currentlyRenderingComponent, reducer);
    return [
        $29ce09d30a26f47a$var$workInProgressHook.memoizedState,
        reducer
    ];
}
function $29ce09d30a26f47a$var$useMemo(nextCreate, deps) {
    $29ce09d30a26f47a$var$currentlyRenderingComponent = $29ce09d30a26f47a$var$resolveCurrentlyRenderingComponent();
    $29ce09d30a26f47a$var$workInProgressHook = $29ce09d30a26f47a$var$createWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    if (null !== $29ce09d30a26f47a$var$workInProgressHook) {
        var prevState = $29ce09d30a26f47a$var$workInProgressHook.memoizedState;
        if (null !== prevState && null !== deps) {
            var prevDeps = prevState[1];
            a: if (null === prevDeps) prevDeps = !1;
            else {
                for(var i = 0; i < prevDeps.length && i < deps.length; i++)if (!$29ce09d30a26f47a$var$objectIs(deps[i], prevDeps[i])) {
                    prevDeps = !1;
                    break a;
                }
                prevDeps = !0;
            }
            if (prevDeps) return prevState[0];
        }
    }
    nextCreate = nextCreate();
    $29ce09d30a26f47a$var$workInProgressHook.memoizedState = [
        nextCreate,
        deps
    ];
    return nextCreate;
}
function $29ce09d30a26f47a$var$dispatchAction(componentIdentity, queue, action) {
    if (25 <= $29ce09d30a26f47a$var$numberOfReRenders) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(301));
    if (componentIdentity === $29ce09d30a26f47a$var$currentlyRenderingComponent) {
        if ($29ce09d30a26f47a$var$didScheduleRenderPhaseUpdate = !0, componentIdentity = {
            action: action,
            next: null
        }, null === $29ce09d30a26f47a$var$renderPhaseUpdates && ($29ce09d30a26f47a$var$renderPhaseUpdates = new Map()), action = $29ce09d30a26f47a$var$renderPhaseUpdates.get(queue), void 0 === action) $29ce09d30a26f47a$var$renderPhaseUpdates.set(queue, componentIdentity);
        else {
            for(queue = action; null !== queue.next;)queue = queue.next;
            queue.next = componentIdentity;
        }
    }
}
function $29ce09d30a26f47a$var$throwOnUseEffectEventCall() {
    throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(440));
}
function $29ce09d30a26f47a$var$unsupportedStartTransition() {
    throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(394));
}
function $29ce09d30a26f47a$var$unsupportedSetOptimisticState() {
    throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(479));
}
function $29ce09d30a26f47a$var$useActionState(action, initialState, permalink) {
    $29ce09d30a26f47a$var$resolveCurrentlyRenderingComponent();
    var actionStateHookIndex = $29ce09d30a26f47a$var$actionStateCounter++, request = $29ce09d30a26f47a$var$currentlyRenderingRequest;
    if ("function" === typeof action.$$FORM_ACTION) {
        var nextPostbackStateKey = null, componentKeyPath = $29ce09d30a26f47a$var$currentlyRenderingKeyPath;
        request = request.formState;
        var isSignatureEqual = action.$$IS_SIGNATURE_EQUAL;
        if (null !== request && "function" === typeof isSignatureEqual) {
            var postbackKey = request[1];
            isSignatureEqual.call(action, request[2], request[3]) && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + $29ce09d30a26f47a$var$murmurhash3_32_gc(JSON.stringify([
                componentKeyPath,
                null,
                actionStateHookIndex
            ]), 0), postbackKey === nextPostbackStateKey && ($29ce09d30a26f47a$var$actionStateMatchingIndex = actionStateHookIndex, initialState = request[0]));
        }
        var boundAction = action.bind(null, initialState);
        action = function(payload) {
            boundAction(payload);
        };
        "function" === typeof boundAction.$$FORM_ACTION && (action.$$FORM_ACTION = function(prefix) {
            prefix = boundAction.$$FORM_ACTION(prefix);
            void 0 !== permalink && (permalink += "", prefix.action = permalink);
            var formData = prefix.data;
            formData && (null === nextPostbackStateKey && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + $29ce09d30a26f47a$var$murmurhash3_32_gc(JSON.stringify([
                componentKeyPath,
                null,
                actionStateHookIndex
            ]), 0)), formData.append("$ACTION_KEY", nextPostbackStateKey));
            return prefix;
        });
        return [
            initialState,
            action,
            !1
        ];
    }
    var boundAction$22 = action.bind(null, initialState);
    return [
        initialState,
        function(payload) {
            boundAction$22(payload);
        },
        !1
    ];
}
function $29ce09d30a26f47a$var$unwrapThenable(thenable) {
    var index = $29ce09d30a26f47a$var$thenableIndexCounter;
    $29ce09d30a26f47a$var$thenableIndexCounter += 1;
    null === $29ce09d30a26f47a$var$thenableState && ($29ce09d30a26f47a$var$thenableState = []);
    return $29ce09d30a26f47a$var$trackUsedThenable($29ce09d30a26f47a$var$thenableState, thenable, index);
}
function $29ce09d30a26f47a$var$unsupportedRefresh() {
    throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(393));
}
var $29ce09d30a26f47a$var$HooksDispatcher = {
    readContext: function(context) {
        return context._currentValue;
    },
    use: function(usable) {
        if (null !== usable && "object" === typeof usable) {
            if ("function" === typeof usable.then) return $29ce09d30a26f47a$var$unwrapThenable(usable);
            if (usable.$$typeof === $29ce09d30a26f47a$var$REACT_CONTEXT_TYPE) return usable._currentValue;
        }
        throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(438, String(usable)));
    },
    useContext: function(context) {
        $29ce09d30a26f47a$var$resolveCurrentlyRenderingComponent();
        return context._currentValue;
    },
    useMemo: $29ce09d30a26f47a$var$useMemo,
    useReducer: $29ce09d30a26f47a$var$useReducer,
    useRef: function(initialValue) {
        $29ce09d30a26f47a$var$currentlyRenderingComponent = $29ce09d30a26f47a$var$resolveCurrentlyRenderingComponent();
        $29ce09d30a26f47a$var$workInProgressHook = $29ce09d30a26f47a$var$createWorkInProgressHook();
        var previousRef = $29ce09d30a26f47a$var$workInProgressHook.memoizedState;
        return null === previousRef ? (initialValue = {
            current: initialValue
        }, $29ce09d30a26f47a$var$workInProgressHook.memoizedState = initialValue) : previousRef;
    },
    useState: function(initialState) {
        return $29ce09d30a26f47a$var$useReducer($29ce09d30a26f47a$var$basicStateReducer, initialState);
    },
    useInsertionEffect: $29ce09d30a26f47a$var$noop,
    useLayoutEffect: $29ce09d30a26f47a$var$noop,
    useCallback: function(callback, deps) {
        return $29ce09d30a26f47a$var$useMemo(function() {
            return callback;
        }, deps);
    },
    useImperativeHandle: $29ce09d30a26f47a$var$noop,
    useEffect: $29ce09d30a26f47a$var$noop,
    useDebugValue: $29ce09d30a26f47a$var$noop,
    useDeferredValue: function(value, initialValue) {
        $29ce09d30a26f47a$var$resolveCurrentlyRenderingComponent();
        return void 0 !== initialValue ? initialValue : value;
    },
    useTransition: function() {
        $29ce09d30a26f47a$var$resolveCurrentlyRenderingComponent();
        return [
            !1,
            $29ce09d30a26f47a$var$unsupportedStartTransition
        ];
    },
    useId: function() {
        var JSCompiler_inline_result = $29ce09d30a26f47a$var$currentlyRenderingTask.treeContext;
        var overflow = JSCompiler_inline_result.overflow;
        JSCompiler_inline_result = JSCompiler_inline_result.id;
        JSCompiler_inline_result = (JSCompiler_inline_result & ~(1 << 32 - $29ce09d30a26f47a$var$clz32(JSCompiler_inline_result) - 1)).toString(32) + overflow;
        var resumableState = $29ce09d30a26f47a$var$currentResumableState;
        if (null === resumableState) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(404));
        overflow = $29ce09d30a26f47a$var$localIdCounter++;
        JSCompiler_inline_result = "_" + resumableState.idPrefix + "R_" + JSCompiler_inline_result;
        0 < overflow && (JSCompiler_inline_result += "H" + overflow.toString(32));
        return JSCompiler_inline_result + "_";
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        if (void 0 === getServerSnapshot) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(407));
        return getServerSnapshot();
    },
    useOptimistic: function(passthrough) {
        $29ce09d30a26f47a$var$resolveCurrentlyRenderingComponent();
        return [
            passthrough,
            $29ce09d30a26f47a$var$unsupportedSetOptimisticState
        ];
    },
    useActionState: $29ce09d30a26f47a$var$useActionState,
    useFormState: $29ce09d30a26f47a$var$useActionState,
    useHostTransitionStatus: function() {
        $29ce09d30a26f47a$var$resolveCurrentlyRenderingComponent();
        return $29ce09d30a26f47a$var$sharedNotPendingObject;
    },
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = $29ce09d30a26f47a$var$REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return $29ce09d30a26f47a$var$unsupportedRefresh;
    },
    useEffectEvent: function() {
        return $29ce09d30a26f47a$var$throwOnUseEffectEventCall;
    }
}, $29ce09d30a26f47a$var$currentResumableState = null, $29ce09d30a26f47a$var$DefaultAsyncDispatcher = {
    getCacheForType: function() {
        throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(248));
    },
    cacheSignal: function() {
        throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(248));
    }
}, $29ce09d30a26f47a$var$prefix, $29ce09d30a26f47a$var$suffix;
function $29ce09d30a26f47a$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $29ce09d30a26f47a$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $29ce09d30a26f47a$var$prefix = match && match[1] || "";
        $29ce09d30a26f47a$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $29ce09d30a26f47a$var$prefix + name + $29ce09d30a26f47a$var$suffix;
}
var $29ce09d30a26f47a$var$reentry = !1;
function $29ce09d30a26f47a$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $29ce09d30a26f47a$var$reentry) return "";
    $29ce09d30a26f47a$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$24) {
                                control = x$24;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$25) {
                            control = x$25;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $29ce09d30a26f47a$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $29ce09d30a26f47a$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $29ce09d30a26f47a$var$describeComponentStackByType(type) {
    if ("string" === typeof type) return $29ce09d30a26f47a$var$describeBuiltInComponentFrame(type);
    if ("function" === typeof type) return type.prototype && type.prototype.isReactComponent ? $29ce09d30a26f47a$var$describeNativeComponentFrame(type, !0) : $29ce09d30a26f47a$var$describeNativeComponentFrame(type, !1);
    if ("object" === typeof type && null !== type) {
        switch(type.$$typeof){
            case $29ce09d30a26f47a$var$REACT_FORWARD_REF_TYPE:
                return $29ce09d30a26f47a$var$describeNativeComponentFrame(type.render, !1);
            case $29ce09d30a26f47a$var$REACT_MEMO_TYPE:
                return $29ce09d30a26f47a$var$describeNativeComponentFrame(type.type, !1);
            case $29ce09d30a26f47a$var$REACT_LAZY_TYPE:
                var lazyComponent = type, payload = lazyComponent._payload;
                lazyComponent = lazyComponent._init;
                try {
                    type = lazyComponent(payload);
                } catch (x) {
                    return $29ce09d30a26f47a$var$describeBuiltInComponentFrame("Lazy");
                }
                return $29ce09d30a26f47a$var$describeComponentStackByType(type);
        }
        if ("string" === typeof type.name) {
            a: {
                payload = type.name;
                lazyComponent = type.env;
                var location = type.debugLocation;
                if (null != location && (type = Error.prepareStackTrace, Error.prepareStackTrace = void 0, location = location.stack, Error.prepareStackTrace = type, location.startsWith("Error: react-stack-top-frame\n") && (location = location.slice(29)), type = location.indexOf("\n"), -1 !== type && (location = location.slice(type + 1)), type = location.indexOf("react_stack_bottom_frame"), -1 !== type && (type = location.lastIndexOf("\n", type)), type = -1 !== type ? location = location.slice(0, type) : "", location = type.lastIndexOf("\n"), type = -1 === location ? type : type.slice(location + 1), -1 !== type.indexOf(payload))) {
                    payload = "\n" + type;
                    break a;
                }
                payload = $29ce09d30a26f47a$var$describeBuiltInComponentFrame(payload + (lazyComponent ? " [" + lazyComponent + "]" : ""));
            }
            return payload;
        }
    }
    switch(type){
        case $29ce09d30a26f47a$var$REACT_SUSPENSE_LIST_TYPE:
            return $29ce09d30a26f47a$var$describeBuiltInComponentFrame("SuspenseList");
        case $29ce09d30a26f47a$var$REACT_SUSPENSE_TYPE:
            return $29ce09d30a26f47a$var$describeBuiltInComponentFrame("Suspense");
    }
    return "";
}
function $29ce09d30a26f47a$var$isEligibleForOutlining(request, boundary) {
    return (500 < boundary.byteSize || $29ce09d30a26f47a$var$hasSuspenseyContent(boundary.contentState)) && null === boundary.contentPreamble;
}
function $29ce09d30a26f47a$var$defaultErrorHandler(error) {
    if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
        var JSCompiler_inline_result = error.environmentName;
        error = [
            error
        ].slice(0);
        "string" === typeof error[0] ? error.splice(0, 1, "%c%s%c " + error[0], "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", " " + JSCompiler_inline_result + " ", "") : error.splice(0, 0, "%c%s%c", "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", " " + JSCompiler_inline_result + " ", "");
        error.unshift(console);
        JSCompiler_inline_result = $29ce09d30a26f47a$var$bind.apply(console.error, error);
        JSCompiler_inline_result();
    } else console.error(error);
    return null;
}
function $29ce09d30a26f47a$var$RequestInstance(resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    var abortSet = new Set();
    this.destination = null;
    this.flushScheduled = !1;
    this.resumableState = resumableState;
    this.renderState = renderState;
    this.rootFormatContext = rootFormatContext;
    this.progressiveChunkSize = void 0 === progressiveChunkSize ? 12800 : progressiveChunkSize;
    this.status = 10;
    this.fatalError = null;
    this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0;
    this.completedPreambleSegments = this.completedRootSegment = null;
    this.byteSize = 0;
    this.abortableTasks = abortSet;
    this.pingedTasks = [];
    this.clientRenderedBoundaries = [];
    this.completedBoundaries = [];
    this.partialBoundaries = [];
    this.trackedPostpones = null;
    this.onError = void 0 === onError ? $29ce09d30a26f47a$var$defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? $29ce09d30a26f47a$var$noop : onPostpone;
    this.onAllReady = void 0 === onAllReady ? $29ce09d30a26f47a$var$noop : onAllReady;
    this.onShellReady = void 0 === onShellReady ? $29ce09d30a26f47a$var$noop : onShellReady;
    this.onShellError = void 0 === onShellError ? $29ce09d30a26f47a$var$noop : onShellError;
    this.onFatalError = void 0 === onFatalError ? $29ce09d30a26f47a$var$noop : onFatalError;
    this.formState = void 0 === formState ? null : formState;
}
function $29ce09d30a26f47a$var$createRequest(children, resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    resumableState = new $29ce09d30a26f47a$var$RequestInstance(resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState);
    renderState = $29ce09d30a26f47a$var$createPendingSegment(resumableState, 0, null, rootFormatContext, !1, !1);
    renderState.parentFlushed = !0;
    children = $29ce09d30a26f47a$var$createRenderTask(resumableState, null, children, -1, null, renderState, null, null, resumableState.abortableTasks, null, rootFormatContext, null, $29ce09d30a26f47a$var$emptyTreeContext, null, null);
    $29ce09d30a26f47a$var$pushComponentStack(children);
    resumableState.pingedTasks.push(children);
    return resumableState;
}
function $29ce09d30a26f47a$var$createPrerenderRequest(children, resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone) {
    children = $29ce09d30a26f47a$var$createRequest(children, resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, void 0);
    children.trackedPostpones = {
        workingMap: new Map(),
        rootNodes: [],
        rootSlots: null
    };
    return children;
}
function $29ce09d30a26f47a$var$resumeRequest(children, postponedState, renderState, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone) {
    renderState = new $29ce09d30a26f47a$var$RequestInstance(postponedState.resumableState, renderState, postponedState.rootFormatContext, postponedState.progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, null);
    renderState.nextSegmentId = postponedState.nextSegmentId;
    if ("number" === typeof postponedState.replaySlots) return onError = $29ce09d30a26f47a$var$createPendingSegment(renderState, 0, null, postponedState.rootFormatContext, !1, !1), onError.parentFlushed = !0, children = $29ce09d30a26f47a$var$createRenderTask(renderState, null, children, -1, null, onError, null, null, renderState.abortableTasks, null, postponedState.rootFormatContext, null, $29ce09d30a26f47a$var$emptyTreeContext, null, null), $29ce09d30a26f47a$var$pushComponentStack(children), renderState.pingedTasks.push(children), renderState;
    children = $29ce09d30a26f47a$var$createReplayTask(renderState, null, {
        nodes: postponedState.replayNodes,
        slots: postponedState.replaySlots,
        pendingTasks: 0
    }, children, -1, null, null, renderState.abortableTasks, null, postponedState.rootFormatContext, null, $29ce09d30a26f47a$var$emptyTreeContext, null, null);
    $29ce09d30a26f47a$var$pushComponentStack(children);
    renderState.pingedTasks.push(children);
    return renderState;
}
function $29ce09d30a26f47a$var$resumeAndPrerenderRequest(children, postponedState, renderState, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone) {
    children = $29ce09d30a26f47a$var$resumeRequest(children, postponedState, renderState, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone);
    children.trackedPostpones = {
        workingMap: new Map(),
        rootNodes: [],
        rootSlots: null
    };
    return children;
}
var $29ce09d30a26f47a$var$currentRequest = null;
function $29ce09d30a26f47a$var$pingTask(request, task) {
    request.pingedTasks.push(task);
    1 === request.pingedTasks.length && (request.flushScheduled = null !== request.destination, null !== request.trackedPostpones || 10 === request.status ? $29ce09d30a26f47a$var$scheduleMicrotask(function() {
        return $29ce09d30a26f47a$var$performWork(request);
    }) : $29ce09d30a26f47a$var$scheduleWork(function() {
        return $29ce09d30a26f47a$var$performWork(request);
    }));
}
function $29ce09d30a26f47a$var$createSuspenseBoundary(request, row, fallbackAbortableTasks, contentPreamble, fallbackPreamble) {
    fallbackAbortableTasks = {
        status: 0,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        row: row,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: fallbackAbortableTasks,
        errorDigest: null,
        contentState: $29ce09d30a26f47a$var$createHoistableState(),
        fallbackState: $29ce09d30a26f47a$var$createHoistableState(),
        contentPreamble: contentPreamble,
        fallbackPreamble: fallbackPreamble,
        trackedContentKeyPath: null,
        trackedFallbackNode: null
    };
    null !== row && (row.pendingTasks++, contentPreamble = row.boundaries, null !== contentPreamble && (request.allPendingTasks++, fallbackAbortableTasks.pendingTasks++, contentPreamble.push(fallbackAbortableTasks)), request = row.inheritedHoistables, null !== request && $29ce09d30a26f47a$var$hoistHoistables(fallbackAbortableTasks.contentState, request));
    return fallbackAbortableTasks;
}
function $29ce09d30a26f47a$var$createRenderTask(request, thenableState, node, childIndex, blockedBoundary, blockedSegment, blockedPreamble, hoistableState, abortSet, keyPath, formatContext, context, treeContext, row, componentStack) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    null !== row && row.pendingTasks++;
    var task = {
        replay: null,
        node: node,
        childIndex: childIndex,
        ping: function() {
            return $29ce09d30a26f47a$var$pingTask(request, task);
        },
        blockedBoundary: blockedBoundary,
        blockedSegment: blockedSegment,
        blockedPreamble: blockedPreamble,
        hoistableState: hoistableState,
        abortSet: abortSet,
        keyPath: keyPath,
        formatContext: formatContext,
        context: context,
        treeContext: treeContext,
        row: row,
        componentStack: componentStack,
        thenableState: thenableState
    };
    abortSet.add(task);
    return task;
}
function $29ce09d30a26f47a$var$createReplayTask(request, thenableState, replay, node, childIndex, blockedBoundary, hoistableState, abortSet, keyPath, formatContext, context, treeContext, row, componentStack) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    null !== row && row.pendingTasks++;
    replay.pendingTasks++;
    var task = {
        replay: replay,
        node: node,
        childIndex: childIndex,
        ping: function() {
            return $29ce09d30a26f47a$var$pingTask(request, task);
        },
        blockedBoundary: blockedBoundary,
        blockedSegment: null,
        blockedPreamble: null,
        hoistableState: hoistableState,
        abortSet: abortSet,
        keyPath: keyPath,
        formatContext: formatContext,
        context: context,
        treeContext: treeContext,
        row: row,
        componentStack: componentStack,
        thenableState: thenableState
    };
    abortSet.add(task);
    return task;
}
function $29ce09d30a26f47a$var$createPendingSegment(request, index, boundary, parentFormatContext, lastPushedText, textEmbedded) {
    return {
        status: 0,
        parentFlushed: !1,
        id: -1,
        index: index,
        chunks: [],
        children: [],
        preambleChildren: [],
        parentFormatContext: parentFormatContext,
        boundary: boundary,
        lastPushedText: lastPushedText,
        textEmbedded: textEmbedded
    };
}
function $29ce09d30a26f47a$var$pushComponentStack(task) {
    var node = task.node;
    if ("object" === typeof node && null !== node) switch(node.$$typeof){
        case $29ce09d30a26f47a$var$REACT_ELEMENT_TYPE:
            task.componentStack = {
                parent: task.componentStack,
                type: node.type
            };
    }
}
function $29ce09d30a26f47a$var$replaceSuspenseComponentStackWithSuspenseFallbackStack(componentStack) {
    return null === componentStack ? null : {
        parent: componentStack.parent,
        type: "Suspense Fallback"
    };
}
function $29ce09d30a26f47a$var$getThrownInfo(node$jscomp$0) {
    var errorInfo = {};
    node$jscomp$0 && Object.defineProperty(errorInfo, "componentStack", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            try {
                var info = "", node = node$jscomp$0;
                do info += $29ce09d30a26f47a$var$describeComponentStackByType(node.type), node = node.parent;
                while (node);
                var JSCompiler_inline_result = info;
            } catch (x) {
                JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
            }
            Object.defineProperty(errorInfo, "componentStack", {
                value: JSCompiler_inline_result
            });
            return JSCompiler_inline_result;
        }
    });
    return errorInfo;
}
function $29ce09d30a26f47a$var$logRecoverableError(request, error, errorInfo) {
    request = request.onError;
    error = request(error, errorInfo);
    if (null == error || "string" === typeof error) return error;
}
function $29ce09d30a26f47a$var$fatalError(request, error) {
    var onShellError = request.onShellError, onFatalError = request.onFatalError;
    onShellError(error);
    onFatalError(error);
    null !== request.destination ? (request.status = 14, $29ce09d30a26f47a$var$closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
}
function $29ce09d30a26f47a$var$finishSuspenseListRow(request, row) {
    $29ce09d30a26f47a$var$unblockSuspenseListRow(request, row.next, row.hoistables);
}
function $29ce09d30a26f47a$var$unblockSuspenseListRow(request, unblockedRow, inheritedHoistables) {
    for(; null !== unblockedRow;){
        null !== inheritedHoistables && ($29ce09d30a26f47a$var$hoistHoistables(unblockedRow.hoistables, inheritedHoistables), unblockedRow.inheritedHoistables = inheritedHoistables);
        var unblockedBoundaries = unblockedRow.boundaries;
        if (null !== unblockedBoundaries) {
            unblockedRow.boundaries = null;
            for(var i = 0; i < unblockedBoundaries.length; i++){
                var unblockedBoundary = unblockedBoundaries[i];
                null !== inheritedHoistables && $29ce09d30a26f47a$var$hoistHoistables(unblockedBoundary.contentState, inheritedHoistables);
                $29ce09d30a26f47a$var$finishedTask(request, unblockedBoundary, null, null);
            }
        }
        unblockedRow.pendingTasks--;
        if (0 < unblockedRow.pendingTasks) break;
        inheritedHoistables = unblockedRow.hoistables;
        unblockedRow = unblockedRow.next;
    }
}
function $29ce09d30a26f47a$var$tryToResolveTogetherRow(request, togetherRow) {
    var boundaries = togetherRow.boundaries;
    if (null !== boundaries && togetherRow.pendingTasks === boundaries.length) {
        for(var allCompleteAndInlinable = !0, i = 0; i < boundaries.length; i++){
            var rowBoundary = boundaries[i];
            if (1 !== rowBoundary.pendingTasks || rowBoundary.parentFlushed || $29ce09d30a26f47a$var$isEligibleForOutlining(request, rowBoundary)) {
                allCompleteAndInlinable = !1;
                break;
            }
        }
        allCompleteAndInlinable && $29ce09d30a26f47a$var$unblockSuspenseListRow(request, togetherRow, togetherRow.hoistables);
    }
}
function $29ce09d30a26f47a$var$createSuspenseListRow(previousRow) {
    var newRow = {
        pendingTasks: 1,
        boundaries: null,
        hoistables: $29ce09d30a26f47a$var$createHoistableState(),
        inheritedHoistables: null,
        together: !1,
        next: null
    };
    null !== previousRow && 0 < previousRow.pendingTasks && (newRow.pendingTasks++, newRow.boundaries = [], previousRow.next = newRow);
    return newRow;
}
function $29ce09d30a26f47a$var$renderSuspenseListRows(request, task, keyPath, rows, revealOrder) {
    var prevKeyPath = task.keyPath, prevTreeContext = task.treeContext, prevRow = task.row;
    task.keyPath = keyPath;
    keyPath = rows.length;
    var previousSuspenseListRow = null;
    if (null !== task.replay) {
        var resumeSlots = task.replay.slots;
        if (null !== resumeSlots && "object" === typeof resumeSlots) for(var n = 0; n < keyPath; n++){
            var i = "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder ? n : keyPath - 1 - n, node = rows[i];
            task.row = previousSuspenseListRow = $29ce09d30a26f47a$var$createSuspenseListRow(previousSuspenseListRow);
            task.treeContext = $29ce09d30a26f47a$var$pushTreeContext(prevTreeContext, keyPath, i);
            var resumeSegmentID = resumeSlots[i];
            "number" === typeof resumeSegmentID ? ($29ce09d30a26f47a$var$resumeNode(request, task, resumeSegmentID, node, i), delete resumeSlots[i]) : $29ce09d30a26f47a$var$renderNode(request, task, node, i);
            0 === --previousSuspenseListRow.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, previousSuspenseListRow);
        }
        else for(resumeSlots = 0; resumeSlots < keyPath; resumeSlots++)n = "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder ? resumeSlots : keyPath - 1 - resumeSlots, i = rows[n], task.row = previousSuspenseListRow = $29ce09d30a26f47a$var$createSuspenseListRow(previousSuspenseListRow), task.treeContext = $29ce09d30a26f47a$var$pushTreeContext(prevTreeContext, keyPath, n), $29ce09d30a26f47a$var$renderNode(request, task, i, n), 0 === --previousSuspenseListRow.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, previousSuspenseListRow);
    } else if ("backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder) for(revealOrder = 0; revealOrder < keyPath; revealOrder++)resumeSlots = rows[revealOrder], task.row = previousSuspenseListRow = $29ce09d30a26f47a$var$createSuspenseListRow(previousSuspenseListRow), task.treeContext = $29ce09d30a26f47a$var$pushTreeContext(prevTreeContext, keyPath, revealOrder), $29ce09d30a26f47a$var$renderNode(request, task, resumeSlots, revealOrder), 0 === --previousSuspenseListRow.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, previousSuspenseListRow);
    else {
        revealOrder = task.blockedSegment;
        resumeSlots = revealOrder.children.length;
        n = revealOrder.chunks.length;
        for(i = keyPath - 1; 0 <= i; i--){
            node = rows[i];
            task.row = previousSuspenseListRow = $29ce09d30a26f47a$var$createSuspenseListRow(previousSuspenseListRow);
            task.treeContext = $29ce09d30a26f47a$var$pushTreeContext(prevTreeContext, keyPath, i);
            resumeSegmentID = $29ce09d30a26f47a$var$createPendingSegment(request, n, null, task.formatContext, 0 === i ? revealOrder.lastPushedText : !0, !0);
            revealOrder.children.splice(resumeSlots, 0, resumeSegmentID);
            task.blockedSegment = resumeSegmentID;
            try {
                $29ce09d30a26f47a$var$renderNode(request, task, node, i), resumeSegmentID.lastPushedText && resumeSegmentID.textEmbedded && resumeSegmentID.chunks.push($29ce09d30a26f47a$var$textSeparator), resumeSegmentID.status = 1, $29ce09d30a26f47a$var$finishedSegment(request, task.blockedBoundary, resumeSegmentID), 0 === --previousSuspenseListRow.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, previousSuspenseListRow);
            } catch (thrownValue) {
                throw resumeSegmentID.status = 12 === request.status ? 3 : 4, thrownValue;
            }
        }
        task.blockedSegment = revealOrder;
        revealOrder.lastPushedText = !1;
    }
    null !== prevRow && null !== previousSuspenseListRow && 0 < previousSuspenseListRow.pendingTasks && (prevRow.pendingTasks++, previousSuspenseListRow.next = prevRow);
    task.treeContext = prevTreeContext;
    task.row = prevRow;
    task.keyPath = prevKeyPath;
}
function $29ce09d30a26f47a$var$renderWithHooks(request, task, keyPath, Component, props, secondArg) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    $29ce09d30a26f47a$var$currentlyRenderingComponent = {};
    $29ce09d30a26f47a$var$currentlyRenderingTask = task;
    $29ce09d30a26f47a$var$currentlyRenderingRequest = request;
    $29ce09d30a26f47a$var$currentlyRenderingKeyPath = keyPath;
    $29ce09d30a26f47a$var$actionStateCounter = $29ce09d30a26f47a$var$localIdCounter = 0;
    $29ce09d30a26f47a$var$actionStateMatchingIndex = -1;
    $29ce09d30a26f47a$var$thenableIndexCounter = 0;
    $29ce09d30a26f47a$var$thenableState = prevThenableState;
    for(request = Component(props, secondArg); $29ce09d30a26f47a$var$didScheduleRenderPhaseUpdate;)$29ce09d30a26f47a$var$didScheduleRenderPhaseUpdate = !1, $29ce09d30a26f47a$var$actionStateCounter = $29ce09d30a26f47a$var$localIdCounter = 0, $29ce09d30a26f47a$var$actionStateMatchingIndex = -1, $29ce09d30a26f47a$var$thenableIndexCounter = 0, $29ce09d30a26f47a$var$numberOfReRenders += 1, $29ce09d30a26f47a$var$workInProgressHook = null, request = Component(props, secondArg);
    $29ce09d30a26f47a$var$resetHooksState();
    return request;
}
function $29ce09d30a26f47a$var$finishFunctionComponent(request, task, keyPath, children, hasId, actionStateCount, actionStateMatchingIndex) {
    var didEmitActionStateMarkers = !1;
    if (0 !== actionStateCount && null !== request.formState) {
        var segment = task.blockedSegment;
        if (null !== segment) {
            didEmitActionStateMarkers = !0;
            segment = segment.chunks;
            for(var i = 0; i < actionStateCount; i++)i === actionStateMatchingIndex ? segment.push($29ce09d30a26f47a$var$formStateMarkerIsMatching) : segment.push($29ce09d30a26f47a$var$formStateMarkerIsNotMatching);
        }
    }
    actionStateCount = task.keyPath;
    task.keyPath = keyPath;
    hasId ? (keyPath = task.treeContext, task.treeContext = $29ce09d30a26f47a$var$pushTreeContext(keyPath, 1, 0), $29ce09d30a26f47a$var$renderNode(request, task, children, -1), task.treeContext = keyPath) : didEmitActionStateMarkers ? $29ce09d30a26f47a$var$renderNode(request, task, children, -1) : $29ce09d30a26f47a$var$renderNodeDestructive(request, task, children, -1);
    task.keyPath = actionStateCount;
}
function $29ce09d30a26f47a$var$renderElement(request, task, keyPath, type, props, ref) {
    if ("function" === typeof type) {
        if (type.prototype && type.prototype.isReactComponent) {
            var newProps = props;
            if ("ref" in props) {
                newProps = {};
                for(var propName in props)"ref" !== propName && (newProps[propName] = props[propName]);
            }
            var defaultProps = type.defaultProps;
            if (defaultProps) {
                newProps === props && (newProps = $29ce09d30a26f47a$var$assign({}, newProps, props));
                for(var propName$44 in defaultProps)void 0 === newProps[propName$44] && (newProps[propName$44] = defaultProps[propName$44]);
            }
            props = newProps;
            newProps = $29ce09d30a26f47a$var$emptyContextObject;
            defaultProps = type.contextType;
            "object" === typeof defaultProps && null !== defaultProps && (newProps = defaultProps._currentValue);
            newProps = new type(props, newProps);
            var initialState = void 0 !== newProps.state ? newProps.state : null;
            newProps.updater = $29ce09d30a26f47a$var$classComponentUpdater;
            newProps.props = props;
            newProps.state = initialState;
            defaultProps = {
                queue: [],
                replace: !1
            };
            newProps._reactInternals = defaultProps;
            ref = type.contextType;
            newProps.context = "object" === typeof ref && null !== ref ? ref._currentValue : $29ce09d30a26f47a$var$emptyContextObject;
            ref = type.getDerivedStateFromProps;
            "function" === typeof ref && (ref = ref(props, initialState), initialState = null === ref || void 0 === ref ? initialState : $29ce09d30a26f47a$var$assign({}, initialState, ref), newProps.state = initialState);
            if ("function" !== typeof type.getDerivedStateFromProps && "function" !== typeof newProps.getSnapshotBeforeUpdate && ("function" === typeof newProps.UNSAFE_componentWillMount || "function" === typeof newProps.componentWillMount)) {
                if (type = newProps.state, "function" === typeof newProps.componentWillMount && newProps.componentWillMount(), "function" === typeof newProps.UNSAFE_componentWillMount && newProps.UNSAFE_componentWillMount(), type !== newProps.state && $29ce09d30a26f47a$var$classComponentUpdater.enqueueReplaceState(newProps, newProps.state, null), null !== defaultProps.queue && 0 < defaultProps.queue.length) {
                    if (type = defaultProps.queue, ref = defaultProps.replace, defaultProps.queue = null, defaultProps.replace = !1, ref && 1 === type.length) newProps.state = type[0];
                    else {
                        defaultProps = ref ? type[0] : newProps.state;
                        initialState = !0;
                        for(ref = ref ? 1 : 0; ref < type.length; ref++)propName$44 = type[ref], propName$44 = "function" === typeof propName$44 ? propName$44.call(newProps, defaultProps, props, void 0) : propName$44, null != propName$44 && (initialState ? (initialState = !1, defaultProps = $29ce09d30a26f47a$var$assign({}, defaultProps, propName$44)) : $29ce09d30a26f47a$var$assign(defaultProps, propName$44));
                        newProps.state = defaultProps;
                    }
                } else defaultProps.queue = null;
            }
            type = newProps.render();
            if (12 === request.status) throw null;
            props = task.keyPath;
            task.keyPath = keyPath;
            $29ce09d30a26f47a$var$renderNodeDestructive(request, task, type, -1);
            task.keyPath = props;
        } else {
            type = $29ce09d30a26f47a$var$renderWithHooks(request, task, keyPath, type, props, void 0);
            if (12 === request.status) throw null;
            $29ce09d30a26f47a$var$finishFunctionComponent(request, task, keyPath, type, 0 !== $29ce09d30a26f47a$var$localIdCounter, $29ce09d30a26f47a$var$actionStateCounter, $29ce09d30a26f47a$var$actionStateMatchingIndex);
        }
    } else if ("string" === typeof type) {
        if (newProps = task.blockedSegment, null === newProps) newProps = props.children, defaultProps = task.formatContext, initialState = task.keyPath, task.formatContext = $29ce09d30a26f47a$var$getChildFormatContext(defaultProps, type, props), task.keyPath = keyPath, $29ce09d30a26f47a$var$renderNode(request, task, newProps, -1), task.formatContext = defaultProps, task.keyPath = initialState;
        else {
            initialState = $29ce09d30a26f47a$var$pushStartInstance(newProps.chunks, type, props, request.resumableState, request.renderState, task.blockedPreamble, task.hoistableState, task.formatContext, newProps.lastPushedText);
            newProps.lastPushedText = !1;
            defaultProps = task.formatContext;
            ref = task.keyPath;
            task.keyPath = keyPath;
            if (3 === (task.formatContext = $29ce09d30a26f47a$var$getChildFormatContext(defaultProps, type, props)).insertionMode) {
                keyPath = $29ce09d30a26f47a$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1);
                newProps.preambleChildren.push(keyPath);
                task.blockedSegment = keyPath;
                try {
                    keyPath.status = 6, $29ce09d30a26f47a$var$renderNode(request, task, initialState, -1), keyPath.lastPushedText && keyPath.textEmbedded && keyPath.chunks.push($29ce09d30a26f47a$var$textSeparator), keyPath.status = 1, $29ce09d30a26f47a$var$finishedSegment(request, task.blockedBoundary, keyPath);
                } finally{
                    task.blockedSegment = newProps;
                }
            } else $29ce09d30a26f47a$var$renderNode(request, task, initialState, -1);
            task.formatContext = defaultProps;
            task.keyPath = ref;
            a: {
                task = newProps.chunks;
                request = request.resumableState;
                switch(type){
                    case "title":
                    case "style":
                    case "script":
                    case "area":
                    case "base":
                    case "br":
                    case "col":
                    case "embed":
                    case "hr":
                    case "img":
                    case "input":
                    case "keygen":
                    case "link":
                    case "meta":
                    case "param":
                    case "source":
                    case "track":
                    case "wbr":
                        break a;
                    case "body":
                        if (1 >= defaultProps.insertionMode) {
                            request.hasBody = !0;
                            break a;
                        }
                        break;
                    case "html":
                        if (0 === defaultProps.insertionMode) {
                            request.hasHtml = !0;
                            break a;
                        }
                        break;
                    case "head":
                        if (1 >= defaultProps.insertionMode) break a;
                }
                task.push($29ce09d30a26f47a$var$endChunkForTag(type));
            }
            newProps.lastPushedText = !1;
        }
    } else {
        switch(type){
            case $29ce09d30a26f47a$var$REACT_LEGACY_HIDDEN_TYPE:
            case $29ce09d30a26f47a$var$REACT_STRICT_MODE_TYPE:
            case $29ce09d30a26f47a$var$REACT_PROFILER_TYPE:
            case $29ce09d30a26f47a$var$REACT_FRAGMENT_TYPE:
                type = task.keyPath;
                task.keyPath = keyPath;
                $29ce09d30a26f47a$var$renderNodeDestructive(request, task, props.children, -1);
                task.keyPath = type;
                return;
            case $29ce09d30a26f47a$var$REACT_ACTIVITY_TYPE:
                type = task.blockedSegment;
                null === type ? "hidden" !== props.mode && (type = task.keyPath, task.keyPath = keyPath, $29ce09d30a26f47a$var$renderNode(request, task, props.children, -1), task.keyPath = type) : "hidden" !== props.mode && (type.chunks.push($29ce09d30a26f47a$var$startActivityBoundary), type.lastPushedText = !1, newProps = task.keyPath, task.keyPath = keyPath, $29ce09d30a26f47a$var$renderNode(request, task, props.children, -1), task.keyPath = newProps, type.chunks.push($29ce09d30a26f47a$var$endActivityBoundary), type.lastPushedText = !1);
                return;
            case $29ce09d30a26f47a$var$REACT_SUSPENSE_LIST_TYPE:
                a: {
                    type = props.children;
                    props = props.revealOrder;
                    if ("forwards" === props || "backwards" === props || "unstable_legacy-backwards" === props) {
                        if ($29ce09d30a26f47a$var$isArrayImpl(type)) {
                            $29ce09d30a26f47a$var$renderSuspenseListRows(request, task, keyPath, type, props);
                            break a;
                        }
                        if (newProps = $29ce09d30a26f47a$var$getIteratorFn(type)) {
                            if (newProps = newProps.call(type)) {
                                defaultProps = newProps.next();
                                if (!defaultProps.done) {
                                    do defaultProps = newProps.next();
                                    while (!defaultProps.done);
                                    $29ce09d30a26f47a$var$renderSuspenseListRows(request, task, keyPath, type, props);
                                }
                                break a;
                            }
                        }
                    }
                    "together" === props ? (props = task.keyPath, newProps = task.row, defaultProps = task.row = $29ce09d30a26f47a$var$createSuspenseListRow(null), defaultProps.boundaries = [], defaultProps.together = !0, task.keyPath = keyPath, $29ce09d30a26f47a$var$renderNodeDestructive(request, task, type, -1), 0 === --defaultProps.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, defaultProps), task.keyPath = props, task.row = newProps, null !== newProps && 0 < defaultProps.pendingTasks && (newProps.pendingTasks++, defaultProps.next = newProps)) : (props = task.keyPath, task.keyPath = keyPath, $29ce09d30a26f47a$var$renderNodeDestructive(request, task, type, -1), task.keyPath = props);
                }
                return;
            case $29ce09d30a26f47a$var$REACT_VIEW_TRANSITION_TYPE:
            case $29ce09d30a26f47a$var$REACT_SCOPE_TYPE:
                throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(343));
            case $29ce09d30a26f47a$var$REACT_SUSPENSE_TYPE:
                a: if (null !== task.replay) {
                    type = task.keyPath;
                    newProps = task.formatContext;
                    defaultProps = task.row;
                    task.keyPath = keyPath;
                    task.formatContext = $29ce09d30a26f47a$var$getSuspenseContentFormatContext(request.resumableState, newProps);
                    task.row = null;
                    keyPath = props.children;
                    try {
                        $29ce09d30a26f47a$var$renderNode(request, task, keyPath, -1);
                    } finally{
                        task.keyPath = type, task.formatContext = newProps, task.row = defaultProps;
                    }
                } else {
                    type = task.keyPath;
                    ref = task.formatContext;
                    var prevRow = task.row;
                    propName$44 = task.blockedBoundary;
                    propName = task.blockedPreamble;
                    var parentHoistableState = task.hoistableState, parentSegment = task.blockedSegment, fallback = props.fallback;
                    props = props.children;
                    var fallbackAbortSet = new Set();
                    var newBoundary = 2 > task.formatContext.insertionMode ? $29ce09d30a26f47a$var$createSuspenseBoundary(request, task.row, fallbackAbortSet, $29ce09d30a26f47a$var$createPreambleState(), $29ce09d30a26f47a$var$createPreambleState()) : $29ce09d30a26f47a$var$createSuspenseBoundary(request, task.row, fallbackAbortSet, null, null);
                    null !== request.trackedPostpones && (newBoundary.trackedContentKeyPath = keyPath);
                    var boundarySegment = $29ce09d30a26f47a$var$createPendingSegment(request, parentSegment.chunks.length, newBoundary, task.formatContext, !1, !1);
                    parentSegment.children.push(boundarySegment);
                    parentSegment.lastPushedText = !1;
                    var contentRootSegment = $29ce09d30a26f47a$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1);
                    contentRootSegment.parentFlushed = !0;
                    if (null !== request.trackedPostpones) {
                        newProps = task.componentStack;
                        defaultProps = [
                            keyPath[0],
                            "Suspense Fallback",
                            keyPath[2]
                        ];
                        initialState = [
                            defaultProps[1],
                            defaultProps[2],
                            [],
                            null
                        ];
                        request.trackedPostpones.workingMap.set(defaultProps, initialState);
                        newBoundary.trackedFallbackNode = initialState;
                        task.blockedSegment = boundarySegment;
                        task.blockedPreamble = newBoundary.fallbackPreamble;
                        task.keyPath = defaultProps;
                        task.formatContext = $29ce09d30a26f47a$var$getSuspenseFallbackFormatContext(request.resumableState, ref);
                        task.componentStack = $29ce09d30a26f47a$var$replaceSuspenseComponentStackWithSuspenseFallbackStack(newProps);
                        boundarySegment.status = 6;
                        try {
                            $29ce09d30a26f47a$var$renderNode(request, task, fallback, -1), boundarySegment.lastPushedText && boundarySegment.textEmbedded && boundarySegment.chunks.push($29ce09d30a26f47a$var$textSeparator), boundarySegment.status = 1, $29ce09d30a26f47a$var$finishedSegment(request, propName$44, boundarySegment);
                        } catch (thrownValue) {
                            throw boundarySegment.status = 12 === request.status ? 3 : 4, thrownValue;
                        } finally{
                            task.blockedSegment = parentSegment, task.blockedPreamble = propName, task.keyPath = type, task.formatContext = ref;
                        }
                        task = $29ce09d30a26f47a$var$createRenderTask(request, null, props, -1, newBoundary, contentRootSegment, newBoundary.contentPreamble, newBoundary.contentState, task.abortSet, keyPath, $29ce09d30a26f47a$var$getSuspenseContentFormatContext(request.resumableState, task.formatContext), task.context, task.treeContext, null, newProps);
                        $29ce09d30a26f47a$var$pushComponentStack(task);
                        request.pingedTasks.push(task);
                    } else {
                        task.blockedBoundary = newBoundary;
                        task.blockedPreamble = newBoundary.contentPreamble;
                        task.hoistableState = newBoundary.contentState;
                        task.blockedSegment = contentRootSegment;
                        task.keyPath = keyPath;
                        task.formatContext = $29ce09d30a26f47a$var$getSuspenseContentFormatContext(request.resumableState, ref);
                        task.row = null;
                        contentRootSegment.status = 6;
                        try {
                            if ($29ce09d30a26f47a$var$renderNode(request, task, props, -1), contentRootSegment.lastPushedText && contentRootSegment.textEmbedded && contentRootSegment.chunks.push($29ce09d30a26f47a$var$textSeparator), contentRootSegment.status = 1, $29ce09d30a26f47a$var$finishedSegment(request, newBoundary, contentRootSegment), $29ce09d30a26f47a$var$queueCompletedSegment(newBoundary, contentRootSegment), 0 === newBoundary.pendingTasks && 0 === newBoundary.status) {
                                if (newBoundary.status = 1, !$29ce09d30a26f47a$var$isEligibleForOutlining(request, newBoundary)) {
                                    null !== prevRow && 0 === --prevRow.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, prevRow);
                                    0 === request.pendingRootTasks && task.blockedPreamble && $29ce09d30a26f47a$var$preparePreamble(request);
                                    break a;
                                }
                            } else null !== prevRow && prevRow.together && $29ce09d30a26f47a$var$tryToResolveTogetherRow(request, prevRow);
                        } catch (thrownValue$31) {
                            newBoundary.status = 4, 12 === request.status ? (contentRootSegment.status = 3, newProps = request.fatalError) : (contentRootSegment.status = 4, newProps = thrownValue$31), defaultProps = $29ce09d30a26f47a$var$getThrownInfo(task.componentStack), initialState = $29ce09d30a26f47a$var$logRecoverableError(request, newProps, defaultProps), newBoundary.errorDigest = initialState, $29ce09d30a26f47a$var$untrackBoundary(request, newBoundary);
                        } finally{
                            task.blockedBoundary = propName$44, task.blockedPreamble = propName, task.hoistableState = parentHoistableState, task.blockedSegment = parentSegment, task.keyPath = type, task.formatContext = ref, task.row = prevRow;
                        }
                        task = $29ce09d30a26f47a$var$createRenderTask(request, null, fallback, -1, propName$44, boundarySegment, newBoundary.fallbackPreamble, newBoundary.fallbackState, fallbackAbortSet, [
                            keyPath[0],
                            "Suspense Fallback",
                            keyPath[2]
                        ], $29ce09d30a26f47a$var$getSuspenseFallbackFormatContext(request.resumableState, task.formatContext), task.context, task.treeContext, task.row, $29ce09d30a26f47a$var$replaceSuspenseComponentStackWithSuspenseFallbackStack(task.componentStack));
                        $29ce09d30a26f47a$var$pushComponentStack(task);
                        request.pingedTasks.push(task);
                    }
                }
                return;
        }
        if ("object" === typeof type && null !== type) switch(type.$$typeof){
            case $29ce09d30a26f47a$var$REACT_FORWARD_REF_TYPE:
                if ("ref" in props) for(parentSegment in newProps = {}, props)"ref" !== parentSegment && (newProps[parentSegment] = props[parentSegment]);
                else newProps = props;
                type = $29ce09d30a26f47a$var$renderWithHooks(request, task, keyPath, type.render, newProps, ref);
                $29ce09d30a26f47a$var$finishFunctionComponent(request, task, keyPath, type, 0 !== $29ce09d30a26f47a$var$localIdCounter, $29ce09d30a26f47a$var$actionStateCounter, $29ce09d30a26f47a$var$actionStateMatchingIndex);
                return;
            case $29ce09d30a26f47a$var$REACT_MEMO_TYPE:
                $29ce09d30a26f47a$var$renderElement(request, task, keyPath, type.type, props, ref);
                return;
            case $29ce09d30a26f47a$var$REACT_CONTEXT_TYPE:
                defaultProps = props.children;
                newProps = task.keyPath;
                props = props.value;
                initialState = type._currentValue;
                type._currentValue = props;
                ref = $29ce09d30a26f47a$var$currentActiveSnapshot;
                $29ce09d30a26f47a$var$currentActiveSnapshot = type = {
                    parent: ref,
                    depth: null === ref ? 0 : ref.depth + 1,
                    context: type,
                    parentValue: initialState,
                    value: props
                };
                task.context = type;
                task.keyPath = keyPath;
                $29ce09d30a26f47a$var$renderNodeDestructive(request, task, defaultProps, -1);
                request = $29ce09d30a26f47a$var$currentActiveSnapshot;
                if (null === request) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(403));
                request.context._currentValue = request.parentValue;
                request = $29ce09d30a26f47a$var$currentActiveSnapshot = request.parent;
                task.context = request;
                task.keyPath = newProps;
                return;
            case $29ce09d30a26f47a$var$REACT_CONSUMER_TYPE:
                props = props.children;
                type = props(type._context._currentValue);
                props = task.keyPath;
                task.keyPath = keyPath;
                $29ce09d30a26f47a$var$renderNodeDestructive(request, task, type, -1);
                task.keyPath = props;
                return;
            case $29ce09d30a26f47a$var$REACT_LAZY_TYPE:
                newProps = type._init;
                type = newProps(type._payload);
                if (12 === request.status) throw null;
                $29ce09d30a26f47a$var$renderElement(request, task, keyPath, type, props, ref);
                return;
        }
        throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(130, null == type ? type : typeof type, ""));
    }
}
function $29ce09d30a26f47a$var$resumeNode(request, task, segmentId, node, childIndex) {
    var prevReplay = task.replay, blockedBoundary = task.blockedBoundary, resumedSegment = $29ce09d30a26f47a$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1);
    resumedSegment.id = segmentId;
    resumedSegment.parentFlushed = !0;
    try {
        task.replay = null, task.blockedSegment = resumedSegment, $29ce09d30a26f47a$var$renderNode(request, task, node, childIndex), resumedSegment.status = 1, $29ce09d30a26f47a$var$finishedSegment(request, blockedBoundary, resumedSegment), null === blockedBoundary ? request.completedRootSegment = resumedSegment : ($29ce09d30a26f47a$var$queueCompletedSegment(blockedBoundary, resumedSegment), blockedBoundary.parentFlushed && request.partialBoundaries.push(blockedBoundary));
    } finally{
        task.replay = prevReplay, task.blockedSegment = null;
    }
}
function $29ce09d30a26f47a$var$renderNodeDestructive(request, task, node, childIndex) {
    null !== task.replay && "number" === typeof task.replay.slots ? $29ce09d30a26f47a$var$resumeNode(request, task, task.replay.slots, node, childIndex) : (task.node = node, task.childIndex = childIndex, node = task.componentStack, $29ce09d30a26f47a$var$pushComponentStack(task), $29ce09d30a26f47a$var$retryNode(request, task), task.componentStack = node);
}
function $29ce09d30a26f47a$var$retryNode(request, task) {
    var node = task.node, childIndex = task.childIndex;
    if (null !== node) {
        if ("object" === typeof node) {
            switch(node.$$typeof){
                case $29ce09d30a26f47a$var$REACT_ELEMENT_TYPE:
                    var type = node.type, key = node.key, props = node.props;
                    node = props.ref;
                    var ref = void 0 !== node ? node : null, name = $29ce09d30a26f47a$var$getComponentNameFromType(type), keyOrIndex = null == key ? -1 === childIndex ? 0 : childIndex : key;
                    key = [
                        task.keyPath,
                        name,
                        keyOrIndex
                    ];
                    if (null !== task.replay) a: {
                        var replay = task.replay;
                        childIndex = replay.nodes;
                        for(node = 0; node < childIndex.length; node++){
                            var node$jscomp$0 = childIndex[node];
                            if (keyOrIndex === node$jscomp$0[1]) {
                                if (4 === node$jscomp$0.length) {
                                    if (null !== name && name !== node$jscomp$0[0]) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(490, node$jscomp$0[0], name));
                                    var childNodes = node$jscomp$0[2];
                                    name = node$jscomp$0[3];
                                    keyOrIndex = task.node;
                                    task.replay = {
                                        nodes: childNodes,
                                        slots: name,
                                        pendingTasks: 1
                                    };
                                    try {
                                        $29ce09d30a26f47a$var$renderElement(request, task, key, type, props, ref);
                                        if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(488));
                                        task.replay.pendingTasks--;
                                    } catch (x) {
                                        if ("object" === typeof x && null !== x && (x === $29ce09d30a26f47a$var$SuspenseException || "function" === typeof x.then)) throw task.node === keyOrIndex ? task.replay = replay : childIndex.splice(node, 1), x;
                                        task.replay.pendingTasks--;
                                        props = $29ce09d30a26f47a$var$getThrownInfo(task.componentStack);
                                        key = request;
                                        request = task.blockedBoundary;
                                        type = x;
                                        props = $29ce09d30a26f47a$var$logRecoverableError(key, type, props);
                                        $29ce09d30a26f47a$var$abortRemainingReplayNodes(key, request, childNodes, name, type, props);
                                    }
                                    task.replay = replay;
                                } else {
                                    if (type !== $29ce09d30a26f47a$var$REACT_SUSPENSE_TYPE) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(490, "Suspense", $29ce09d30a26f47a$var$getComponentNameFromType(type) || "Unknown"));
                                    b: {
                                        replay = void 0;
                                        type = node$jscomp$0[5];
                                        ref = node$jscomp$0[2];
                                        name = node$jscomp$0[3];
                                        keyOrIndex = null === node$jscomp$0[4] ? [] : node$jscomp$0[4][2];
                                        node$jscomp$0 = null === node$jscomp$0[4] ? null : node$jscomp$0[4][3];
                                        var prevKeyPath = task.keyPath, prevContext = task.formatContext, prevRow = task.row, previousReplaySet = task.replay, parentBoundary = task.blockedBoundary, parentHoistableState = task.hoistableState, content = props.children, fallback = props.fallback, fallbackAbortSet = new Set();
                                        props = 2 > task.formatContext.insertionMode ? $29ce09d30a26f47a$var$createSuspenseBoundary(request, task.row, fallbackAbortSet, $29ce09d30a26f47a$var$createPreambleState(), $29ce09d30a26f47a$var$createPreambleState()) : $29ce09d30a26f47a$var$createSuspenseBoundary(request, task.row, fallbackAbortSet, null, null);
                                        props.parentFlushed = !0;
                                        props.rootSegmentID = type;
                                        task.blockedBoundary = props;
                                        task.hoistableState = props.contentState;
                                        task.keyPath = key;
                                        task.formatContext = $29ce09d30a26f47a$var$getSuspenseContentFormatContext(request.resumableState, prevContext);
                                        task.row = null;
                                        task.replay = {
                                            nodes: ref,
                                            slots: name,
                                            pendingTasks: 1
                                        };
                                        try {
                                            $29ce09d30a26f47a$var$renderNode(request, task, content, -1);
                                            if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(488));
                                            task.replay.pendingTasks--;
                                            if (0 === props.pendingTasks && 0 === props.status) {
                                                props.status = 1;
                                                request.completedBoundaries.push(props);
                                                break b;
                                            }
                                        } catch (error) {
                                            props.status = 4, childNodes = $29ce09d30a26f47a$var$getThrownInfo(task.componentStack), replay = $29ce09d30a26f47a$var$logRecoverableError(request, error, childNodes), props.errorDigest = replay, task.replay.pendingTasks--, request.clientRenderedBoundaries.push(props);
                                        } finally{
                                            task.blockedBoundary = parentBoundary, task.hoistableState = parentHoistableState, task.replay = previousReplaySet, task.keyPath = prevKeyPath, task.formatContext = prevContext, task.row = prevRow;
                                        }
                                        childNodes = $29ce09d30a26f47a$var$createReplayTask(request, null, {
                                            nodes: keyOrIndex,
                                            slots: node$jscomp$0,
                                            pendingTasks: 0
                                        }, fallback, -1, parentBoundary, props.fallbackState, fallbackAbortSet, [
                                            key[0],
                                            "Suspense Fallback",
                                            key[2]
                                        ], $29ce09d30a26f47a$var$getSuspenseFallbackFormatContext(request.resumableState, task.formatContext), task.context, task.treeContext, task.row, $29ce09d30a26f47a$var$replaceSuspenseComponentStackWithSuspenseFallbackStack(task.componentStack));
                                        $29ce09d30a26f47a$var$pushComponentStack(childNodes);
                                        request.pingedTasks.push(childNodes);
                                    }
                                }
                                childIndex.splice(node, 1);
                                break a;
                            }
                        }
                    }
                    else $29ce09d30a26f47a$var$renderElement(request, task, key, type, props, ref);
                    return;
                case $29ce09d30a26f47a$var$REACT_PORTAL_TYPE:
                    throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(257));
                case $29ce09d30a26f47a$var$REACT_LAZY_TYPE:
                    childNodes = node._init;
                    node = childNodes(node._payload);
                    if (12 === request.status) throw null;
                    $29ce09d30a26f47a$var$renderNodeDestructive(request, task, node, childIndex);
                    return;
            }
            if ($29ce09d30a26f47a$var$isArrayImpl(node)) {
                $29ce09d30a26f47a$var$renderChildrenArray(request, task, node, childIndex);
                return;
            }
            if (childNodes = $29ce09d30a26f47a$var$getIteratorFn(node)) {
                if (childNodes = childNodes.call(node)) {
                    node = childNodes.next();
                    if (!node.done) {
                        props = [];
                        do props.push(node.value), node = childNodes.next();
                        while (!node.done);
                        $29ce09d30a26f47a$var$renderChildrenArray(request, task, props, childIndex);
                    }
                    return;
                }
            }
            if ("function" === typeof node.then) return task.thenableState = null, $29ce09d30a26f47a$var$renderNodeDestructive(request, task, $29ce09d30a26f47a$var$unwrapThenable(node), childIndex);
            if (node.$$typeof === $29ce09d30a26f47a$var$REACT_CONTEXT_TYPE) return $29ce09d30a26f47a$var$renderNodeDestructive(request, task, node._currentValue, childIndex);
            childIndex = Object.prototype.toString.call(node);
            throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(31, "[object Object]" === childIndex ? "object with keys {" + Object.keys(node).join(", ") + "}" : childIndex));
        }
        if ("string" === typeof node) childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = $29ce09d30a26f47a$var$pushTextInstance(childIndex.chunks, node, request.renderState, childIndex.lastPushedText));
        else if ("number" === typeof node || "bigint" === typeof node) childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = $29ce09d30a26f47a$var$pushTextInstance(childIndex.chunks, "" + node, request.renderState, childIndex.lastPushedText));
    }
}
function $29ce09d30a26f47a$var$renderChildrenArray(request, task, children, childIndex) {
    var prevKeyPath = task.keyPath;
    if (-1 !== childIndex && (task.keyPath = [
        task.keyPath,
        "Fragment",
        childIndex
    ], null !== task.replay)) {
        for(var replay = task.replay, replayNodes = replay.nodes, j = 0; j < replayNodes.length; j++){
            var node = replayNodes[j];
            if (node[1] === childIndex) {
                childIndex = node[2];
                node = node[3];
                task.replay = {
                    nodes: childIndex,
                    slots: node,
                    pendingTasks: 1
                };
                try {
                    $29ce09d30a26f47a$var$renderChildrenArray(request, task, children, -1);
                    if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(488));
                    task.replay.pendingTasks--;
                } catch (x) {
                    if ("object" === typeof x && null !== x && (x === $29ce09d30a26f47a$var$SuspenseException || "function" === typeof x.then)) throw x;
                    task.replay.pendingTasks--;
                    children = $29ce09d30a26f47a$var$getThrownInfo(task.componentStack);
                    var boundary = task.blockedBoundary, error = x;
                    children = $29ce09d30a26f47a$var$logRecoverableError(request, error, children);
                    $29ce09d30a26f47a$var$abortRemainingReplayNodes(request, boundary, childIndex, node, error, children);
                }
                task.replay = replay;
                replayNodes.splice(j, 1);
                break;
            }
        }
        task.keyPath = prevKeyPath;
        return;
    }
    replay = task.treeContext;
    replayNodes = children.length;
    if (null !== task.replay && (j = task.replay.slots, null !== j && "object" === typeof j)) {
        for(childIndex = 0; childIndex < replayNodes; childIndex++)node = children[childIndex], task.treeContext = $29ce09d30a26f47a$var$pushTreeContext(replay, replayNodes, childIndex), boundary = j[childIndex], "number" === typeof boundary ? ($29ce09d30a26f47a$var$resumeNode(request, task, boundary, node, childIndex), delete j[childIndex]) : $29ce09d30a26f47a$var$renderNode(request, task, node, childIndex);
        task.treeContext = replay;
        task.keyPath = prevKeyPath;
        return;
    }
    for(j = 0; j < replayNodes; j++)childIndex = children[j], task.treeContext = $29ce09d30a26f47a$var$pushTreeContext(replay, replayNodes, j), $29ce09d30a26f47a$var$renderNode(request, task, childIndex, j);
    task.treeContext = replay;
    task.keyPath = prevKeyPath;
}
function $29ce09d30a26f47a$var$trackPostponedBoundary(request, trackedPostpones, boundary) {
    boundary.status = 5;
    boundary.rootSegmentID = request.nextSegmentId++;
    request = boundary.trackedContentKeyPath;
    if (null === request) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(486));
    var fallbackReplayNode = boundary.trackedFallbackNode, children = [], boundaryNode = trackedPostpones.workingMap.get(request);
    if (void 0 === boundaryNode) return boundary = [
        request[1],
        request[2],
        children,
        null,
        fallbackReplayNode,
        boundary.rootSegmentID
    ], trackedPostpones.workingMap.set(request, boundary), $29ce09d30a26f47a$var$addToReplayParent(boundary, request[0], trackedPostpones), boundary;
    boundaryNode[4] = fallbackReplayNode;
    boundaryNode[5] = boundary.rootSegmentID;
    return boundaryNode;
}
function $29ce09d30a26f47a$var$trackPostpone(request, trackedPostpones, task, segment) {
    segment.status = 5;
    var keyPath = task.keyPath, boundary = task.blockedBoundary;
    if (null === boundary) segment.id = request.nextSegmentId++, trackedPostpones.rootSlots = segment.id, null !== request.completedRootSegment && (request.completedRootSegment.status = 5);
    else {
        if (null !== boundary && 0 === boundary.status) {
            var boundaryNode = $29ce09d30a26f47a$var$trackPostponedBoundary(request, trackedPostpones, boundary);
            if (boundary.trackedContentKeyPath === keyPath && -1 === task.childIndex) {
                -1 === segment.id && (segment.id = segment.parentFlushed ? boundary.rootSegmentID : request.nextSegmentId++);
                boundaryNode[3] = segment.id;
                return;
            }
        }
        -1 === segment.id && (segment.id = segment.parentFlushed && null !== boundary ? boundary.rootSegmentID : request.nextSegmentId++);
        if (-1 === task.childIndex) null === keyPath ? trackedPostpones.rootSlots = segment.id : (task = trackedPostpones.workingMap.get(keyPath), void 0 === task ? (task = [
            keyPath[1],
            keyPath[2],
            [],
            segment.id
        ], $29ce09d30a26f47a$var$addToReplayParent(task, keyPath[0], trackedPostpones)) : task[3] = segment.id);
        else {
            if (null === keyPath) {
                if (request = trackedPostpones.rootSlots, null === request) request = trackedPostpones.rootSlots = {};
                else {
                    if ("number" === typeof request) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(491));
                }
            } else if (boundary = trackedPostpones.workingMap, boundaryNode = boundary.get(keyPath), void 0 === boundaryNode) request = {}, boundaryNode = [
                keyPath[1],
                keyPath[2],
                [],
                request
            ], boundary.set(keyPath, boundaryNode), $29ce09d30a26f47a$var$addToReplayParent(boundaryNode, keyPath[0], trackedPostpones);
            else if (request = boundaryNode[3], null === request) request = boundaryNode[3] = {};
            else if ("number" === typeof request) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(491));
            request[task.childIndex] = segment.id;
        }
    }
}
function $29ce09d30a26f47a$var$untrackBoundary(request, boundary) {
    request = request.trackedPostpones;
    null !== request && (boundary = boundary.trackedContentKeyPath, null !== boundary && (boundary = request.workingMap.get(boundary), void 0 !== boundary && (boundary.length = 4, boundary[2] = [], boundary[3] = null)));
}
function $29ce09d30a26f47a$var$spawnNewSuspendedReplayTask(request, task, thenableState) {
    return $29ce09d30a26f47a$var$createReplayTask(request, thenableState, task.replay, task.node, task.childIndex, task.blockedBoundary, task.hoistableState, task.abortSet, task.keyPath, task.formatContext, task.context, task.treeContext, task.row, task.componentStack);
}
function $29ce09d30a26f47a$var$spawnNewSuspendedRenderTask(request, task, thenableState) {
    var segment = task.blockedSegment, newSegment = $29ce09d30a26f47a$var$createPendingSegment(request, segment.chunks.length, null, task.formatContext, segment.lastPushedText, !0);
    segment.children.push(newSegment);
    segment.lastPushedText = !1;
    return $29ce09d30a26f47a$var$createRenderTask(request, thenableState, task.node, task.childIndex, task.blockedBoundary, newSegment, task.blockedPreamble, task.hoistableState, task.abortSet, task.keyPath, task.formatContext, task.context, task.treeContext, task.row, task.componentStack);
}
function $29ce09d30a26f47a$var$renderNode(request, task, node, childIndex) {
    var previousFormatContext = task.formatContext, previousContext = task.context, previousKeyPath = task.keyPath, previousTreeContext = task.treeContext, previousComponentStack = task.componentStack, segment = task.blockedSegment;
    if (null === segment) {
        segment = task.replay;
        try {
            return $29ce09d30a26f47a$var$renderNodeDestructive(request, task, node, childIndex);
        } catch (thrownValue) {
            if ($29ce09d30a26f47a$var$resetHooksState(), node = thrownValue === $29ce09d30a26f47a$var$SuspenseException ? $29ce09d30a26f47a$var$getSuspendedThenable() : thrownValue, 12 !== request.status && "object" === typeof node && null !== node) {
                if ("function" === typeof node.then) {
                    childIndex = thrownValue === $29ce09d30a26f47a$var$SuspenseException ? $29ce09d30a26f47a$var$getThenableStateAfterSuspending() : null;
                    request = $29ce09d30a26f47a$var$spawnNewSuspendedReplayTask(request, task, childIndex).ping;
                    node.then(request, request);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    task.replay = segment;
                    $29ce09d30a26f47a$var$switchContext(previousContext);
                    return;
                }
                if ("Maximum call stack size exceeded" === node.message) {
                    node = thrownValue === $29ce09d30a26f47a$var$SuspenseException ? $29ce09d30a26f47a$var$getThenableStateAfterSuspending() : null;
                    node = $29ce09d30a26f47a$var$spawnNewSuspendedReplayTask(request, task, node);
                    request.pingedTasks.push(node);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    task.replay = segment;
                    $29ce09d30a26f47a$var$switchContext(previousContext);
                    return;
                }
            }
        }
    } else {
        var childrenLength = segment.children.length, chunkLength = segment.chunks.length;
        try {
            return $29ce09d30a26f47a$var$renderNodeDestructive(request, task, node, childIndex);
        } catch (thrownValue$63) {
            if ($29ce09d30a26f47a$var$resetHooksState(), segment.children.length = childrenLength, segment.chunks.length = chunkLength, node = thrownValue$63 === $29ce09d30a26f47a$var$SuspenseException ? $29ce09d30a26f47a$var$getSuspendedThenable() : thrownValue$63, 12 !== request.status && "object" === typeof node && null !== node) {
                if ("function" === typeof node.then) {
                    segment = node;
                    node = thrownValue$63 === $29ce09d30a26f47a$var$SuspenseException ? $29ce09d30a26f47a$var$getThenableStateAfterSuspending() : null;
                    request = $29ce09d30a26f47a$var$spawnNewSuspendedRenderTask(request, task, node).ping;
                    segment.then(request, request);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    $29ce09d30a26f47a$var$switchContext(previousContext);
                    return;
                }
                if ("Maximum call stack size exceeded" === node.message) {
                    segment = thrownValue$63 === $29ce09d30a26f47a$var$SuspenseException ? $29ce09d30a26f47a$var$getThenableStateAfterSuspending() : null;
                    segment = $29ce09d30a26f47a$var$spawnNewSuspendedRenderTask(request, task, segment);
                    request.pingedTasks.push(segment);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    $29ce09d30a26f47a$var$switchContext(previousContext);
                    return;
                }
            }
        }
    }
    task.formatContext = previousFormatContext;
    task.context = previousContext;
    task.keyPath = previousKeyPath;
    task.treeContext = previousTreeContext;
    $29ce09d30a26f47a$var$switchContext(previousContext);
    throw node;
}
function $29ce09d30a26f47a$var$abortTaskSoft(task) {
    var boundary = task.blockedBoundary, segment = task.blockedSegment;
    null !== segment && (segment.status = 3, $29ce09d30a26f47a$var$finishedTask(this, boundary, task.row, segment));
}
function $29ce09d30a26f47a$var$abortRemainingReplayNodes(request$jscomp$0, boundary, nodes, slots, error, errorDigest$jscomp$0) {
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (4 === node.length) $29ce09d30a26f47a$var$abortRemainingReplayNodes(request$jscomp$0, boundary, node[2], node[3], error, errorDigest$jscomp$0);
        else {
            node = node[5];
            var request = request$jscomp$0, errorDigest = errorDigest$jscomp$0, resumedBoundary = $29ce09d30a26f47a$var$createSuspenseBoundary(request, null, new Set(), null, null);
            resumedBoundary.parentFlushed = !0;
            resumedBoundary.rootSegmentID = node;
            resumedBoundary.status = 4;
            resumedBoundary.errorDigest = errorDigest;
            resumedBoundary.parentFlushed && request.clientRenderedBoundaries.push(resumedBoundary);
        }
    }
    nodes.length = 0;
    if (null !== slots) {
        if (null === boundary) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(487));
        4 !== boundary.status && (boundary.status = 4, boundary.errorDigest = errorDigest$jscomp$0, boundary.parentFlushed && request$jscomp$0.clientRenderedBoundaries.push(boundary));
        if ("object" === typeof slots) for(var index in slots)delete slots[index];
    }
}
function $29ce09d30a26f47a$var$abortTask(task, request, error) {
    var boundary = task.blockedBoundary, segment = task.blockedSegment;
    if (null !== segment) {
        if (6 === segment.status) return;
        segment.status = 3;
    }
    var errorInfo = $29ce09d30a26f47a$var$getThrownInfo(task.componentStack);
    if (null === boundary) {
        if (13 !== request.status && 14 !== request.status) {
            boundary = task.replay;
            if (null === boundary) {
                null !== request.trackedPostpones && null !== segment ? (boundary = request.trackedPostpones, $29ce09d30a26f47a$var$logRecoverableError(request, error, errorInfo), $29ce09d30a26f47a$var$trackPostpone(request, boundary, task, segment), $29ce09d30a26f47a$var$finishedTask(request, null, task.row, segment)) : ($29ce09d30a26f47a$var$logRecoverableError(request, error, errorInfo), $29ce09d30a26f47a$var$fatalError(request, error));
                return;
            }
            boundary.pendingTasks--;
            0 === boundary.pendingTasks && 0 < boundary.nodes.length && (segment = $29ce09d30a26f47a$var$logRecoverableError(request, error, errorInfo), $29ce09d30a26f47a$var$abortRemainingReplayNodes(request, null, boundary.nodes, boundary.slots, error, segment));
            request.pendingRootTasks--;
            0 === request.pendingRootTasks && $29ce09d30a26f47a$var$completeShell(request);
        }
    } else {
        var trackedPostpones$64 = request.trackedPostpones;
        if (4 !== boundary.status) {
            if (null !== trackedPostpones$64 && null !== segment) return $29ce09d30a26f47a$var$logRecoverableError(request, error, errorInfo), $29ce09d30a26f47a$var$trackPostpone(request, trackedPostpones$64, task, segment), boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
                return $29ce09d30a26f47a$var$abortTask(fallbackTask, request, error);
            }), boundary.fallbackAbortableTasks.clear(), $29ce09d30a26f47a$var$finishedTask(request, boundary, task.row, segment);
            boundary.status = 4;
            segment = $29ce09d30a26f47a$var$logRecoverableError(request, error, errorInfo);
            boundary.status = 4;
            boundary.errorDigest = segment;
            $29ce09d30a26f47a$var$untrackBoundary(request, boundary);
            boundary.parentFlushed && request.clientRenderedBoundaries.push(boundary);
        }
        boundary.pendingTasks--;
        segment = boundary.row;
        null !== segment && 0 === --segment.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, segment);
        boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
            return $29ce09d30a26f47a$var$abortTask(fallbackTask, request, error);
        });
        boundary.fallbackAbortableTasks.clear();
    }
    task = task.row;
    null !== task && 0 === --task.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, task);
    request.allPendingTasks--;
    0 === request.allPendingTasks && $29ce09d30a26f47a$var$completeAll(request);
}
function $29ce09d30a26f47a$var$safelyEmitEarlyPreloads(request, shellComplete) {
    try {
        var renderState = request.renderState, onHeaders = renderState.onHeaders;
        if (onHeaders) {
            var headers = renderState.headers;
            if (headers) {
                renderState.headers = null;
                var linkHeader = headers.preconnects;
                headers.fontPreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.fontPreloads);
                headers.highImagePreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.highImagePreloads);
                if (!shellComplete) {
                    var queueIter = renderState.styles.values(), queueStep = queueIter.next();
                    b: for(; 0 < headers.remainingCapacity && !queueStep.done; queueStep = queueIter.next())for(var sheetIter = queueStep.value.sheets.values(), sheetStep = sheetIter.next(); 0 < headers.remainingCapacity && !sheetStep.done; sheetStep = sheetIter.next()){
                        var sheet = sheetStep.value, props = sheet.props, key = props.href, props$jscomp$0 = sheet.props, header = $29ce09d30a26f47a$var$getPreloadAsHeader(props$jscomp$0.href, "style", {
                            crossOrigin: props$jscomp$0.crossOrigin,
                            integrity: props$jscomp$0.integrity,
                            nonce: props$jscomp$0.nonce,
                            type: props$jscomp$0.type,
                            fetchPriority: props$jscomp$0.fetchPriority,
                            referrerPolicy: props$jscomp$0.referrerPolicy,
                            media: props$jscomp$0.media
                        });
                        if (0 <= (headers.remainingCapacity -= header.length + 2)) renderState.resets.style[key] = $29ce09d30a26f47a$var$PRELOAD_NO_CREDS, linkHeader && (linkHeader += ", "), linkHeader += header, renderState.resets.style[key] = "string" === typeof props.crossOrigin || "string" === typeof props.integrity ? [
                            props.crossOrigin,
                            props.integrity
                        ] : $29ce09d30a26f47a$var$PRELOAD_NO_CREDS;
                        else break b;
                    }
                }
                linkHeader ? onHeaders({
                    Link: linkHeader
                }) : onHeaders({});
            }
        }
    } catch (error) {
        $29ce09d30a26f47a$var$logRecoverableError(request, error, {});
    }
}
function $29ce09d30a26f47a$var$completeShell(request) {
    null === request.trackedPostpones && $29ce09d30a26f47a$var$safelyEmitEarlyPreloads(request, !0);
    null === request.trackedPostpones && $29ce09d30a26f47a$var$preparePreamble(request);
    request.onShellError = $29ce09d30a26f47a$var$noop;
    request = request.onShellReady;
    request();
}
function $29ce09d30a26f47a$var$completeAll(request) {
    $29ce09d30a26f47a$var$safelyEmitEarlyPreloads(request, null === request.trackedPostpones ? !0 : null === request.completedRootSegment || 5 !== request.completedRootSegment.status);
    $29ce09d30a26f47a$var$preparePreamble(request);
    request = request.onAllReady;
    request();
}
function $29ce09d30a26f47a$var$queueCompletedSegment(boundary, segment) {
    if (0 === segment.chunks.length && 1 === segment.children.length && null === segment.children[0].boundary && -1 === segment.children[0].id) {
        var childSegment = segment.children[0];
        childSegment.id = segment.id;
        childSegment.parentFlushed = !0;
        1 !== childSegment.status && 3 !== childSegment.status && 4 !== childSegment.status || $29ce09d30a26f47a$var$queueCompletedSegment(boundary, childSegment);
    } else boundary.completedSegments.push(segment);
}
function $29ce09d30a26f47a$var$finishedSegment(request, boundary, segment) {
    if (null !== $29ce09d30a26f47a$var$byteLengthOfChunk) {
        segment = segment.chunks;
        for(var segmentByteSize = 0, i = 0; i < segment.length; i++)segmentByteSize += segment[i].byteLength;
        null === boundary ? request.byteSize += segmentByteSize : boundary.byteSize += segmentByteSize;
    }
}
function $29ce09d30a26f47a$var$finishedTask(request, boundary, row, segment) {
    null !== row && (0 === --row.pendingTasks ? $29ce09d30a26f47a$var$finishSuspenseListRow(request, row) : row.together && $29ce09d30a26f47a$var$tryToResolveTogetherRow(request, row));
    request.allPendingTasks--;
    if (null === boundary) {
        if (null !== segment && segment.parentFlushed) {
            if (null !== request.completedRootSegment) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(389));
            request.completedRootSegment = segment;
        }
        request.pendingRootTasks--;
        0 === request.pendingRootTasks && $29ce09d30a26f47a$var$completeShell(request);
    } else if (boundary.pendingTasks--, 4 !== boundary.status) {
        if (0 === boundary.pendingTasks) {
            if (0 === boundary.status && (boundary.status = 1), null !== segment && segment.parentFlushed && (1 === segment.status || 3 === segment.status) && $29ce09d30a26f47a$var$queueCompletedSegment(boundary, segment), boundary.parentFlushed && request.completedBoundaries.push(boundary), 1 === boundary.status) row = boundary.row, null !== row && $29ce09d30a26f47a$var$hoistHoistables(row.hoistables, boundary.contentState), $29ce09d30a26f47a$var$isEligibleForOutlining(request, boundary) || (boundary.fallbackAbortableTasks.forEach($29ce09d30a26f47a$var$abortTaskSoft, request), boundary.fallbackAbortableTasks.clear(), null !== row && 0 === --row.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, row)), 0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary.contentPreamble && $29ce09d30a26f47a$var$preparePreamble(request);
            else if (5 === boundary.status && (boundary = boundary.row, null !== boundary)) {
                if (null !== request.trackedPostpones) {
                    row = request.trackedPostpones;
                    var postponedRow = boundary.next;
                    if (null !== postponedRow && (segment = postponedRow.boundaries, null !== segment)) for(postponedRow.boundaries = null, postponedRow = 0; postponedRow < segment.length; postponedRow++){
                        var postponedBoundary = segment[postponedRow];
                        $29ce09d30a26f47a$var$trackPostponedBoundary(request, row, postponedBoundary);
                        $29ce09d30a26f47a$var$finishedTask(request, postponedBoundary, null, null);
                    }
                }
                0 === --boundary.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, boundary);
            }
        } else null === segment || !segment.parentFlushed || 1 !== segment.status && 3 !== segment.status || ($29ce09d30a26f47a$var$queueCompletedSegment(boundary, segment), 1 === boundary.completedSegments.length && boundary.parentFlushed && request.partialBoundaries.push(boundary)), boundary = boundary.row, null !== boundary && boundary.together && $29ce09d30a26f47a$var$tryToResolveTogetherRow(request, boundary);
    }
    0 === request.allPendingTasks && $29ce09d30a26f47a$var$completeAll(request);
}
function $29ce09d30a26f47a$var$performWork(request$jscomp$2) {
    if (14 !== request$jscomp$2.status && 13 !== request$jscomp$2.status) {
        var prevContext = $29ce09d30a26f47a$var$currentActiveSnapshot, prevDispatcher = $29ce09d30a26f47a$var$ReactSharedInternals.H;
        $29ce09d30a26f47a$var$ReactSharedInternals.H = $29ce09d30a26f47a$var$HooksDispatcher;
        var prevAsyncDispatcher = $29ce09d30a26f47a$var$ReactSharedInternals.A;
        $29ce09d30a26f47a$var$ReactSharedInternals.A = $29ce09d30a26f47a$var$DefaultAsyncDispatcher;
        var prevRequest = $29ce09d30a26f47a$var$currentRequest;
        $29ce09d30a26f47a$var$currentRequest = request$jscomp$2;
        var prevResumableState = $29ce09d30a26f47a$var$currentResumableState;
        $29ce09d30a26f47a$var$currentResumableState = request$jscomp$2.resumableState;
        try {
            var pingedTasks = request$jscomp$2.pingedTasks, i;
            for(i = 0; i < pingedTasks.length; i++){
                var task = pingedTasks[i], request = request$jscomp$2, segment = task.blockedSegment;
                if (null === segment) {
                    var request$jscomp$0 = request;
                    if (0 !== task.replay.pendingTasks) {
                        $29ce09d30a26f47a$var$switchContext(task.context);
                        try {
                            "number" === typeof task.replay.slots ? $29ce09d30a26f47a$var$resumeNode(request$jscomp$0, task, task.replay.slots, task.node, task.childIndex) : $29ce09d30a26f47a$var$retryNode(request$jscomp$0, task);
                            if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(488));
                            task.replay.pendingTasks--;
                            task.abortSet.delete(task);
                            $29ce09d30a26f47a$var$finishedTask(request$jscomp$0, task.blockedBoundary, task.row, null);
                        } catch (thrownValue) {
                            $29ce09d30a26f47a$var$resetHooksState();
                            var x = thrownValue === $29ce09d30a26f47a$var$SuspenseException ? $29ce09d30a26f47a$var$getSuspendedThenable() : thrownValue;
                            if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                                var ping = task.ping;
                                x.then(ping, ping);
                                task.thenableState = thrownValue === $29ce09d30a26f47a$var$SuspenseException ? $29ce09d30a26f47a$var$getThenableStateAfterSuspending() : null;
                            } else {
                                task.replay.pendingTasks--;
                                task.abortSet.delete(task);
                                var errorInfo = $29ce09d30a26f47a$var$getThrownInfo(task.componentStack);
                                request = void 0;
                                var request$jscomp$1 = request$jscomp$0, boundary = task.blockedBoundary, error$jscomp$0 = 12 === request$jscomp$0.status ? request$jscomp$0.fatalError : x, replayNodes = task.replay.nodes, resumeSlots = task.replay.slots;
                                request = $29ce09d30a26f47a$var$logRecoverableError(request$jscomp$1, error$jscomp$0, errorInfo);
                                $29ce09d30a26f47a$var$abortRemainingReplayNodes(request$jscomp$1, boundary, replayNodes, resumeSlots, error$jscomp$0, request);
                                request$jscomp$0.pendingRootTasks--;
                                0 === request$jscomp$0.pendingRootTasks && $29ce09d30a26f47a$var$completeShell(request$jscomp$0);
                                request$jscomp$0.allPendingTasks--;
                                0 === request$jscomp$0.allPendingTasks && $29ce09d30a26f47a$var$completeAll(request$jscomp$0);
                            }
                        } finally{}
                    }
                } else if (request$jscomp$0 = void 0, request$jscomp$1 = segment, 0 === request$jscomp$1.status) {
                    request$jscomp$1.status = 6;
                    $29ce09d30a26f47a$var$switchContext(task.context);
                    var childrenLength = request$jscomp$1.children.length, chunkLength = request$jscomp$1.chunks.length;
                    try {
                        $29ce09d30a26f47a$var$retryNode(request, task), request$jscomp$1.lastPushedText && request$jscomp$1.textEmbedded && request$jscomp$1.chunks.push($29ce09d30a26f47a$var$textSeparator), task.abortSet.delete(task), request$jscomp$1.status = 1, $29ce09d30a26f47a$var$finishedSegment(request, task.blockedBoundary, request$jscomp$1), $29ce09d30a26f47a$var$finishedTask(request, task.blockedBoundary, task.row, request$jscomp$1);
                    } catch (thrownValue) {
                        $29ce09d30a26f47a$var$resetHooksState();
                        request$jscomp$1.children.length = childrenLength;
                        request$jscomp$1.chunks.length = chunkLength;
                        var x$jscomp$0 = thrownValue === $29ce09d30a26f47a$var$SuspenseException ? $29ce09d30a26f47a$var$getSuspendedThenable() : 12 === request.status ? request.fatalError : thrownValue;
                        if (12 === request.status && null !== request.trackedPostpones) {
                            var trackedPostpones = request.trackedPostpones, thrownInfo = $29ce09d30a26f47a$var$getThrownInfo(task.componentStack);
                            task.abortSet.delete(task);
                            $29ce09d30a26f47a$var$logRecoverableError(request, x$jscomp$0, thrownInfo);
                            $29ce09d30a26f47a$var$trackPostpone(request, trackedPostpones, task, request$jscomp$1);
                            $29ce09d30a26f47a$var$finishedTask(request, task.blockedBoundary, task.row, request$jscomp$1);
                        } else if ("object" === typeof x$jscomp$0 && null !== x$jscomp$0 && "function" === typeof x$jscomp$0.then) {
                            request$jscomp$1.status = 0;
                            task.thenableState = thrownValue === $29ce09d30a26f47a$var$SuspenseException ? $29ce09d30a26f47a$var$getThenableStateAfterSuspending() : null;
                            var ping$jscomp$0 = task.ping;
                            x$jscomp$0.then(ping$jscomp$0, ping$jscomp$0);
                        } else {
                            var errorInfo$jscomp$0 = $29ce09d30a26f47a$var$getThrownInfo(task.componentStack);
                            task.abortSet.delete(task);
                            request$jscomp$1.status = 4;
                            var boundary$jscomp$0 = task.blockedBoundary, row = task.row;
                            null !== row && 0 === --row.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, row);
                            request.allPendingTasks--;
                            request$jscomp$0 = $29ce09d30a26f47a$var$logRecoverableError(request, x$jscomp$0, errorInfo$jscomp$0);
                            if (null === boundary$jscomp$0) $29ce09d30a26f47a$var$fatalError(request, x$jscomp$0);
                            else if (boundary$jscomp$0.pendingTasks--, 4 !== boundary$jscomp$0.status) {
                                boundary$jscomp$0.status = 4;
                                boundary$jscomp$0.errorDigest = request$jscomp$0;
                                $29ce09d30a26f47a$var$untrackBoundary(request, boundary$jscomp$0);
                                var boundaryRow = boundary$jscomp$0.row;
                                null !== boundaryRow && 0 === --boundaryRow.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, boundaryRow);
                                boundary$jscomp$0.parentFlushed && request.clientRenderedBoundaries.push(boundary$jscomp$0);
                                0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary$jscomp$0.contentPreamble && $29ce09d30a26f47a$var$preparePreamble(request);
                            }
                            0 === request.allPendingTasks && $29ce09d30a26f47a$var$completeAll(request);
                        }
                    } finally{}
                }
            }
            pingedTasks.splice(0, i);
            null !== request$jscomp$2.destination && $29ce09d30a26f47a$var$flushCompletedQueues(request$jscomp$2, request$jscomp$2.destination);
        } catch (error) {
            $29ce09d30a26f47a$var$logRecoverableError(request$jscomp$2, error, {}), $29ce09d30a26f47a$var$fatalError(request$jscomp$2, error);
        } finally{
            $29ce09d30a26f47a$var$currentResumableState = prevResumableState, $29ce09d30a26f47a$var$ReactSharedInternals.H = prevDispatcher, $29ce09d30a26f47a$var$ReactSharedInternals.A = prevAsyncDispatcher, prevDispatcher === $29ce09d30a26f47a$var$HooksDispatcher && $29ce09d30a26f47a$var$switchContext(prevContext), $29ce09d30a26f47a$var$currentRequest = prevRequest;
        }
    }
}
function $29ce09d30a26f47a$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments) {
    segment.preambleChildren.length && collectedPreambleSegments.push(segment.preambleChildren);
    for(var pendingPreambles = !1, i = 0; i < segment.children.length; i++)pendingPreambles = $29ce09d30a26f47a$var$preparePreambleFromSegment(request, segment.children[i], collectedPreambleSegments) || pendingPreambles;
    return pendingPreambles;
}
function $29ce09d30a26f47a$var$preparePreambleFromSegment(request, segment, collectedPreambleSegments) {
    var boundary = segment.boundary;
    if (null === boundary) return $29ce09d30a26f47a$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
    var preamble = boundary.contentPreamble, fallbackPreamble = boundary.fallbackPreamble;
    if (null === preamble || null === fallbackPreamble) return !1;
    switch(boundary.status){
        case 1:
            $29ce09d30a26f47a$var$hoistPreambleState(request.renderState, preamble);
            request.byteSize += boundary.byteSize;
            segment = boundary.completedSegments[0];
            if (!segment) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(391));
            return $29ce09d30a26f47a$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
        case 5:
            if (null !== request.trackedPostpones) return !0;
        case 4:
            if (1 === segment.status) return $29ce09d30a26f47a$var$hoistPreambleState(request.renderState, fallbackPreamble), $29ce09d30a26f47a$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
        default:
            return !0;
    }
}
function $29ce09d30a26f47a$var$preparePreamble(request) {
    if (request.completedRootSegment && null === request.completedPreambleSegments) {
        var collectedPreambleSegments = [], originalRequestByteSize = request.byteSize, hasPendingPreambles = $29ce09d30a26f47a$var$preparePreambleFromSegment(request, request.completedRootSegment, collectedPreambleSegments), preamble = request.renderState.preamble;
        !1 === hasPendingPreambles || preamble.headChunks && preamble.bodyChunks ? request.completedPreambleSegments = collectedPreambleSegments : request.byteSize = originalRequestByteSize;
    }
}
function $29ce09d30a26f47a$var$flushSubtree(request, destination, segment, hoistableState) {
    segment.parentFlushed = !0;
    switch(segment.status){
        case 0:
            segment.id = request.nextSegmentId++;
        case 5:
            return hoistableState = segment.id, segment.lastPushedText = !1, segment.textEmbedded = !1, request = request.renderState, $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$placeholder1), $29ce09d30a26f47a$var$writeChunk(destination, request.placeholderPrefix), request = $29ce09d30a26f47a$var$stringToChunk(hoistableState.toString(16)), $29ce09d30a26f47a$var$writeChunk(destination, request), $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$placeholder2);
        case 1:
            segment.status = 2;
            var r = !0, chunks = segment.chunks, chunkIdx = 0;
            segment = segment.children;
            for(var childIdx = 0; childIdx < segment.length; childIdx++){
                for(r = segment[childIdx]; chunkIdx < r.index; chunkIdx++)$29ce09d30a26f47a$var$writeChunk(destination, chunks[chunkIdx]);
                r = $29ce09d30a26f47a$var$flushSegment(request, destination, r, hoistableState);
            }
            for(; chunkIdx < chunks.length - 1; chunkIdx++)$29ce09d30a26f47a$var$writeChunk(destination, chunks[chunkIdx]);
            chunkIdx < chunks.length && (r = $29ce09d30a26f47a$var$writeChunkAndReturn(destination, chunks[chunkIdx]));
            return r;
        case 3:
            return !0;
        default:
            throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(390));
    }
}
var $29ce09d30a26f47a$var$flushedByteSize = 0;
function $29ce09d30a26f47a$var$flushSegment(request, destination, segment, hoistableState) {
    var boundary = segment.boundary;
    if (null === boundary) return $29ce09d30a26f47a$var$flushSubtree(request, destination, segment, hoistableState);
    boundary.parentFlushed = !0;
    if (4 === boundary.status) {
        var row = boundary.row;
        null !== row && 0 === --row.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, row);
        boundary = boundary.errorDigest;
        $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$startClientRenderedSuspenseBoundary);
        $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$clientRenderedSuspenseBoundaryError1);
        boundary && ($29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$clientRenderedSuspenseBoundaryError1A), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(boundary))), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$clientRenderedSuspenseBoundaryErrorAttrInterstitial));
        $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$clientRenderedSuspenseBoundaryError2);
        $29ce09d30a26f47a$var$flushSubtree(request, destination, segment, hoistableState);
    } else if (1 !== boundary.status) 0 === boundary.status && (boundary.rootSegmentID = request.nextSegmentId++), 0 < boundary.completedSegments.length && request.partialBoundaries.push(boundary), $29ce09d30a26f47a$var$writeStartPendingSuspenseBoundary(destination, request.renderState, boundary.rootSegmentID), hoistableState && $29ce09d30a26f47a$var$hoistHoistables(hoistableState, boundary.fallbackState), $29ce09d30a26f47a$var$flushSubtree(request, destination, segment, hoistableState);
    else if (!$29ce09d30a26f47a$var$flushingPartialBoundaries && $29ce09d30a26f47a$var$isEligibleForOutlining(request, boundary) && ($29ce09d30a26f47a$var$flushedByteSize + boundary.byteSize > request.progressiveChunkSize || $29ce09d30a26f47a$var$hasSuspenseyContent(boundary.contentState))) boundary.rootSegmentID = request.nextSegmentId++, request.completedBoundaries.push(boundary), $29ce09d30a26f47a$var$writeStartPendingSuspenseBoundary(destination, request.renderState, boundary.rootSegmentID), $29ce09d30a26f47a$var$flushSubtree(request, destination, segment, hoistableState);
    else {
        $29ce09d30a26f47a$var$flushedByteSize += boundary.byteSize;
        hoistableState && $29ce09d30a26f47a$var$hoistHoistables(hoistableState, boundary.contentState);
        segment = boundary.row;
        null !== segment && $29ce09d30a26f47a$var$isEligibleForOutlining(request, boundary) && 0 === --segment.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, segment);
        $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$startCompletedSuspenseBoundary);
        segment = boundary.completedSegments;
        if (1 !== segment.length) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(391));
        $29ce09d30a26f47a$var$flushSegment(request, destination, segment[0], hoistableState);
    }
    return $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$endSuspenseBoundary);
}
function $29ce09d30a26f47a$var$flushSegmentContainer(request, destination, segment, hoistableState) {
    $29ce09d30a26f47a$var$writeStartSegment(destination, request.renderState, segment.parentFormatContext, segment.id);
    $29ce09d30a26f47a$var$flushSegment(request, destination, segment, hoistableState);
    return $29ce09d30a26f47a$var$writeEndSegment(destination, segment.parentFormatContext);
}
function $29ce09d30a26f47a$var$flushCompletedBoundary(request, destination, boundary) {
    $29ce09d30a26f47a$var$flushedByteSize = boundary.byteSize;
    for(var completedSegments = boundary.completedSegments, i = 0; i < completedSegments.length; i++)$29ce09d30a26f47a$var$flushPartiallyCompletedSegment(request, destination, boundary, completedSegments[i]);
    completedSegments.length = 0;
    completedSegments = boundary.row;
    null !== completedSegments && $29ce09d30a26f47a$var$isEligibleForOutlining(request, boundary) && 0 === --completedSegments.pendingTasks && $29ce09d30a26f47a$var$finishSuspenseListRow(request, completedSegments);
    $29ce09d30a26f47a$var$writeHoistablesForBoundary(destination, boundary.contentState, request.renderState);
    completedSegments = request.resumableState;
    request = request.renderState;
    i = boundary.rootSegmentID;
    boundary = boundary.contentState;
    var requiresStyleInsertion = request.stylesToHoist;
    request.stylesToHoist = !1;
    $29ce09d30a26f47a$var$writeChunk(destination, request.startInlineScript);
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$endOfStartTag);
    requiresStyleInsertion ? (0 === (completedSegments.instructions & 4) && (completedSegments.instructions |= 4, $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$clientRenderScriptFunctionOnly)), 0 === (completedSegments.instructions & 2) && (completedSegments.instructions |= 2, $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completeBoundaryScriptFunctionOnly)), 0 === (completedSegments.instructions & 8) ? (completedSegments.instructions |= 8, $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completeBoundaryWithStylesScript1FullPartial)) : $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completeBoundaryWithStylesScript1Partial)) : (0 === (completedSegments.instructions & 2) && (completedSegments.instructions |= 2, $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completeBoundaryScriptFunctionOnly)), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completeBoundaryScript1Partial));
    completedSegments = $29ce09d30a26f47a$var$stringToChunk(i.toString(16));
    $29ce09d30a26f47a$var$writeChunk(destination, request.boundaryPrefix);
    $29ce09d30a26f47a$var$writeChunk(destination, completedSegments);
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completeBoundaryScript2);
    $29ce09d30a26f47a$var$writeChunk(destination, request.segmentPrefix);
    $29ce09d30a26f47a$var$writeChunk(destination, completedSegments);
    requiresStyleInsertion ? ($29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completeBoundaryScript3a), $29ce09d30a26f47a$var$writeStyleResourceDependenciesInJS(destination, boundary)) : $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completeBoundaryScript3b);
    boundary = $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$completeBoundaryScriptEnd);
    return $29ce09d30a26f47a$var$writeBootstrap(destination, request) && boundary;
}
function $29ce09d30a26f47a$var$flushPartiallyCompletedSegment(request, destination, boundary, segment) {
    if (2 === segment.status) return !0;
    var hoistableState = boundary.contentState, segmentID = segment.id;
    if (-1 === segmentID) {
        if (-1 === (segment.id = boundary.rootSegmentID)) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(392));
        return $29ce09d30a26f47a$var$flushSegmentContainer(request, destination, segment, hoistableState);
    }
    if (segmentID === boundary.rootSegmentID) return $29ce09d30a26f47a$var$flushSegmentContainer(request, destination, segment, hoistableState);
    $29ce09d30a26f47a$var$flushSegmentContainer(request, destination, segment, hoistableState);
    boundary = request.resumableState;
    request = request.renderState;
    $29ce09d30a26f47a$var$writeChunk(destination, request.startInlineScript);
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$endOfStartTag);
    0 === (boundary.instructions & 1) ? (boundary.instructions |= 1, $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completeSegmentScript1Full)) : $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completeSegmentScript1Partial);
    $29ce09d30a26f47a$var$writeChunk(destination, request.segmentPrefix);
    segmentID = $29ce09d30a26f47a$var$stringToChunk(segmentID.toString(16));
    $29ce09d30a26f47a$var$writeChunk(destination, segmentID);
    $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completeSegmentScript2);
    $29ce09d30a26f47a$var$writeChunk(destination, request.placeholderPrefix);
    $29ce09d30a26f47a$var$writeChunk(destination, segmentID);
    destination = $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$completeSegmentScriptEnd);
    return destination;
}
var $29ce09d30a26f47a$var$flushingPartialBoundaries = !1;
function $29ce09d30a26f47a$var$flushCompletedQueues(request, destination) {
    $29ce09d30a26f47a$var$currentView = new Uint8Array(2048);
    $29ce09d30a26f47a$var$writtenBytes = 0;
    try {
        if (!(0 < request.pendingRootTasks)) {
            var i, completedRootSegment = request.completedRootSegment;
            if (null !== completedRootSegment) {
                if (5 === completedRootSegment.status) return;
                var completedPreambleSegments = request.completedPreambleSegments;
                if (null === completedPreambleSegments) return;
                $29ce09d30a26f47a$var$flushedByteSize = request.byteSize;
                var resumableState = request.resumableState, renderState = request.renderState, preamble = renderState.preamble, htmlChunks = preamble.htmlChunks, headChunks = preamble.headChunks, i$jscomp$0;
                if (htmlChunks) {
                    for(i$jscomp$0 = 0; i$jscomp$0 < htmlChunks.length; i$jscomp$0++)$29ce09d30a26f47a$var$writeChunk(destination, htmlChunks[i$jscomp$0]);
                    if (headChunks) for(i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)$29ce09d30a26f47a$var$writeChunk(destination, headChunks[i$jscomp$0]);
                    else $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$startChunkForTag("head")), $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$endOfStartTag);
                } else if (headChunks) for(i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)$29ce09d30a26f47a$var$writeChunk(destination, headChunks[i$jscomp$0]);
                var charsetChunks = renderState.charsetChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < charsetChunks.length; i$jscomp$0++)$29ce09d30a26f47a$var$writeChunk(destination, charsetChunks[i$jscomp$0]);
                charsetChunks.length = 0;
                renderState.preconnects.forEach($29ce09d30a26f47a$var$flushResource, destination);
                renderState.preconnects.clear();
                var viewportChunks = renderState.viewportChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < viewportChunks.length; i$jscomp$0++)$29ce09d30a26f47a$var$writeChunk(destination, viewportChunks[i$jscomp$0]);
                viewportChunks.length = 0;
                renderState.fontPreloads.forEach($29ce09d30a26f47a$var$flushResource, destination);
                renderState.fontPreloads.clear();
                renderState.highImagePreloads.forEach($29ce09d30a26f47a$var$flushResource, destination);
                renderState.highImagePreloads.clear();
                $29ce09d30a26f47a$var$currentlyFlushingRenderState = renderState;
                renderState.styles.forEach($29ce09d30a26f47a$var$flushStylesInPreamble, destination);
                $29ce09d30a26f47a$var$currentlyFlushingRenderState = null;
                var importMapChunks = renderState.importMapChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < importMapChunks.length; i$jscomp$0++)$29ce09d30a26f47a$var$writeChunk(destination, importMapChunks[i$jscomp$0]);
                importMapChunks.length = 0;
                renderState.bootstrapScripts.forEach($29ce09d30a26f47a$var$flushResource, destination);
                renderState.scripts.forEach($29ce09d30a26f47a$var$flushResource, destination);
                renderState.scripts.clear();
                renderState.bulkPreloads.forEach($29ce09d30a26f47a$var$flushResource, destination);
                renderState.bulkPreloads.clear();
                htmlChunks || headChunks || (resumableState.instructions |= 32);
                var hoistableChunks = renderState.hoistableChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < hoistableChunks.length; i$jscomp$0++)$29ce09d30a26f47a$var$writeChunk(destination, hoistableChunks[i$jscomp$0]);
                for(resumableState = hoistableChunks.length = 0; resumableState < completedPreambleSegments.length; resumableState++){
                    var segments = completedPreambleSegments[resumableState];
                    for(renderState = 0; renderState < segments.length; renderState++)$29ce09d30a26f47a$var$flushSegment(request, destination, segments[renderState], null);
                }
                var preamble$jscomp$0 = request.renderState.preamble, headChunks$jscomp$0 = preamble$jscomp$0.headChunks;
                (preamble$jscomp$0.htmlChunks || headChunks$jscomp$0) && $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$endChunkForTag("head"));
                var bodyChunks = preamble$jscomp$0.bodyChunks;
                if (bodyChunks) for(completedPreambleSegments = 0; completedPreambleSegments < bodyChunks.length; completedPreambleSegments++)$29ce09d30a26f47a$var$writeChunk(destination, bodyChunks[completedPreambleSegments]);
                $29ce09d30a26f47a$var$flushSegment(request, destination, completedRootSegment, null);
                request.completedRootSegment = null;
                var renderState$jscomp$0 = request.renderState;
                if (0 !== request.allPendingTasks || 0 !== request.clientRenderedBoundaries.length || 0 !== request.completedBoundaries.length || null !== request.trackedPostpones && (0 !== request.trackedPostpones.rootNodes.length || null !== request.trackedPostpones.rootSlots)) {
                    var resumableState$jscomp$0 = request.resumableState;
                    if (0 === (resumableState$jscomp$0.instructions & 64)) {
                        resumableState$jscomp$0.instructions |= 64;
                        $29ce09d30a26f47a$var$writeChunk(destination, renderState$jscomp$0.startInlineScript);
                        if (0 === (resumableState$jscomp$0.instructions & 32)) {
                            resumableState$jscomp$0.instructions |= 32;
                            var shellId = "_" + resumableState$jscomp$0.idPrefix + "R_";
                            $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$completedShellIdAttributeStart);
                            $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeTextForBrowser(shellId)));
                            $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$attributeEnd);
                        }
                        $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$endOfStartTag);
                        $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$shellTimeRuntimeScript);
                        $29ce09d30a26f47a$var$writeChunkAndReturn(destination, $29ce09d30a26f47a$var$endInlineScript);
                    }
                }
                $29ce09d30a26f47a$var$writeBootstrap(destination, renderState$jscomp$0);
            }
            var renderState$jscomp$1 = request.renderState;
            completedRootSegment = 0;
            var viewportChunks$jscomp$0 = renderState$jscomp$1.viewportChunks;
            for(completedRootSegment = 0; completedRootSegment < viewportChunks$jscomp$0.length; completedRootSegment++)$29ce09d30a26f47a$var$writeChunk(destination, viewportChunks$jscomp$0[completedRootSegment]);
            viewportChunks$jscomp$0.length = 0;
            renderState$jscomp$1.preconnects.forEach($29ce09d30a26f47a$var$flushResource, destination);
            renderState$jscomp$1.preconnects.clear();
            renderState$jscomp$1.fontPreloads.forEach($29ce09d30a26f47a$var$flushResource, destination);
            renderState$jscomp$1.fontPreloads.clear();
            renderState$jscomp$1.highImagePreloads.forEach($29ce09d30a26f47a$var$flushResource, destination);
            renderState$jscomp$1.highImagePreloads.clear();
            renderState$jscomp$1.styles.forEach($29ce09d30a26f47a$var$preloadLateStyles, destination);
            renderState$jscomp$1.scripts.forEach($29ce09d30a26f47a$var$flushResource, destination);
            renderState$jscomp$1.scripts.clear();
            renderState$jscomp$1.bulkPreloads.forEach($29ce09d30a26f47a$var$flushResource, destination);
            renderState$jscomp$1.bulkPreloads.clear();
            var hoistableChunks$jscomp$0 = renderState$jscomp$1.hoistableChunks;
            for(completedRootSegment = 0; completedRootSegment < hoistableChunks$jscomp$0.length; completedRootSegment++)$29ce09d30a26f47a$var$writeChunk(destination, hoistableChunks$jscomp$0[completedRootSegment]);
            hoistableChunks$jscomp$0.length = 0;
            var clientRenderedBoundaries = request.clientRenderedBoundaries;
            for(i = 0; i < clientRenderedBoundaries.length; i++){
                var boundary = clientRenderedBoundaries[i];
                renderState$jscomp$1 = destination;
                var resumableState$jscomp$1 = request.resumableState, renderState$jscomp$2 = request.renderState, id = boundary.rootSegmentID, errorDigest = boundary.errorDigest;
                $29ce09d30a26f47a$var$writeChunk(renderState$jscomp$1, renderState$jscomp$2.startInlineScript);
                $29ce09d30a26f47a$var$writeChunk(renderState$jscomp$1, $29ce09d30a26f47a$var$endOfStartTag);
                0 === (resumableState$jscomp$1.instructions & 4) ? (resumableState$jscomp$1.instructions |= 4, $29ce09d30a26f47a$var$writeChunk(renderState$jscomp$1, $29ce09d30a26f47a$var$clientRenderScript1Full)) : $29ce09d30a26f47a$var$writeChunk(renderState$jscomp$1, $29ce09d30a26f47a$var$clientRenderScript1Partial);
                $29ce09d30a26f47a$var$writeChunk(renderState$jscomp$1, renderState$jscomp$2.boundaryPrefix);
                $29ce09d30a26f47a$var$writeChunk(renderState$jscomp$1, $29ce09d30a26f47a$var$stringToChunk(id.toString(16)));
                $29ce09d30a26f47a$var$writeChunk(renderState$jscomp$1, $29ce09d30a26f47a$var$clientRenderScript1A);
                errorDigest && ($29ce09d30a26f47a$var$writeChunk(renderState$jscomp$1, $29ce09d30a26f47a$var$clientRenderErrorScriptArgInterstitial), $29ce09d30a26f47a$var$writeChunk(renderState$jscomp$1, $29ce09d30a26f47a$var$stringToChunk($29ce09d30a26f47a$var$escapeJSStringsForInstructionScripts(errorDigest || ""))));
                var JSCompiler_inline_result = $29ce09d30a26f47a$var$writeChunkAndReturn(renderState$jscomp$1, $29ce09d30a26f47a$var$clientRenderScriptEnd);
                if (!JSCompiler_inline_result) {
                    request.destination = null;
                    i++;
                    clientRenderedBoundaries.splice(0, i);
                    return;
                }
            }
            clientRenderedBoundaries.splice(0, i);
            var completedBoundaries = request.completedBoundaries;
            for(i = 0; i < completedBoundaries.length; i++)if (!$29ce09d30a26f47a$var$flushCompletedBoundary(request, destination, completedBoundaries[i])) {
                request.destination = null;
                i++;
                completedBoundaries.splice(0, i);
                return;
            }
            completedBoundaries.splice(0, i);
            $29ce09d30a26f47a$var$completeWriting(destination);
            $29ce09d30a26f47a$var$currentView = new Uint8Array(2048);
            $29ce09d30a26f47a$var$writtenBytes = 0;
            $29ce09d30a26f47a$var$flushingPartialBoundaries = !0;
            var partialBoundaries = request.partialBoundaries;
            for(i = 0; i < partialBoundaries.length; i++){
                var boundary$70 = partialBoundaries[i];
                a: {
                    clientRenderedBoundaries = request;
                    boundary = destination;
                    $29ce09d30a26f47a$var$flushedByteSize = boundary$70.byteSize;
                    var completedSegments = boundary$70.completedSegments;
                    for(JSCompiler_inline_result = 0; JSCompiler_inline_result < completedSegments.length; JSCompiler_inline_result++)if (!$29ce09d30a26f47a$var$flushPartiallyCompletedSegment(clientRenderedBoundaries, boundary, boundary$70, completedSegments[JSCompiler_inline_result])) {
                        JSCompiler_inline_result++;
                        completedSegments.splice(0, JSCompiler_inline_result);
                        var JSCompiler_inline_result$jscomp$0 = !1;
                        break a;
                    }
                    completedSegments.splice(0, JSCompiler_inline_result);
                    var row = boundary$70.row;
                    null !== row && row.together && 1 === boundary$70.pendingTasks && (1 === row.pendingTasks ? $29ce09d30a26f47a$var$unblockSuspenseListRow(clientRenderedBoundaries, row, row.hoistables) : row.pendingTasks--);
                    JSCompiler_inline_result$jscomp$0 = $29ce09d30a26f47a$var$writeHoistablesForBoundary(boundary, boundary$70.contentState, clientRenderedBoundaries.renderState);
                }
                if (!JSCompiler_inline_result$jscomp$0) {
                    request.destination = null;
                    i++;
                    partialBoundaries.splice(0, i);
                    return;
                }
            }
            partialBoundaries.splice(0, i);
            $29ce09d30a26f47a$var$flushingPartialBoundaries = !1;
            var largeBoundaries = request.completedBoundaries;
            for(i = 0; i < largeBoundaries.length; i++)if (!$29ce09d30a26f47a$var$flushCompletedBoundary(request, destination, largeBoundaries[i])) {
                request.destination = null;
                i++;
                largeBoundaries.splice(0, i);
                return;
            }
            largeBoundaries.splice(0, i);
        }
    } finally{
        $29ce09d30a26f47a$var$flushingPartialBoundaries = !1, 0 === request.allPendingTasks && 0 === request.clientRenderedBoundaries.length && 0 === request.completedBoundaries.length ? (request.flushScheduled = !1, i = request.resumableState, i.hasBody && $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$endChunkForTag("body")), i.hasHtml && $29ce09d30a26f47a$var$writeChunk(destination, $29ce09d30a26f47a$var$endChunkForTag("html")), $29ce09d30a26f47a$var$completeWriting(destination), request.status = 14, destination.close(), request.destination = null) : $29ce09d30a26f47a$var$completeWriting(destination);
    }
}
function $29ce09d30a26f47a$var$startWork(request) {
    request.flushScheduled = null !== request.destination;
    $29ce09d30a26f47a$var$scheduleMicrotask(function() {
        return $29ce09d30a26f47a$var$performWork(request);
    });
    $29ce09d30a26f47a$var$scheduleWork(function() {
        10 === request.status && (request.status = 11);
        null === request.trackedPostpones && $29ce09d30a26f47a$var$safelyEmitEarlyPreloads(request, 0 === request.pendingRootTasks);
    });
}
function $29ce09d30a26f47a$var$enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, $29ce09d30a26f47a$var$scheduleWork(function() {
        var destination = request.destination;
        destination ? $29ce09d30a26f47a$var$flushCompletedQueues(request, destination) : request.flushScheduled = !1;
    }));
}
function $29ce09d30a26f47a$var$startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, $29ce09d30a26f47a$var$closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            $29ce09d30a26f47a$var$flushCompletedQueues(request, destination);
        } catch (error) {
            $29ce09d30a26f47a$var$logRecoverableError(request, error, {}), $29ce09d30a26f47a$var$fatalError(request, error);
        }
    }
}
function $29ce09d30a26f47a$var$abort(request, reason) {
    if (11 === request.status || 10 === request.status) request.status = 12;
    try {
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error($29ce09d30a26f47a$var$formatProdErrorMessage(432)) : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error($29ce09d30a26f47a$var$formatProdErrorMessage(530)) : reason;
            request.fatalError = error;
            abortableTasks.forEach(function(task) {
                return $29ce09d30a26f47a$var$abortTask(task, request, error);
            });
            abortableTasks.clear();
        }
        null !== request.destination && $29ce09d30a26f47a$var$flushCompletedQueues(request, request.destination);
    } catch (error$72) {
        $29ce09d30a26f47a$var$logRecoverableError(request, error$72, {}), $29ce09d30a26f47a$var$fatalError(request, error$72);
    }
}
function $29ce09d30a26f47a$var$addToReplayParent(node, parentKeyPath, trackedPostpones) {
    if (null === parentKeyPath) trackedPostpones.rootNodes.push(node);
    else {
        var workingMap = trackedPostpones.workingMap, parentNode = workingMap.get(parentKeyPath);
        void 0 === parentNode && (parentNode = [
            parentKeyPath[1],
            parentKeyPath[2],
            [],
            null
        ], workingMap.set(parentKeyPath, parentNode), $29ce09d30a26f47a$var$addToReplayParent(parentNode, parentKeyPath[0], trackedPostpones));
        parentNode[2].push(node);
    }
}
function $29ce09d30a26f47a$var$getPostponedState(request) {
    var trackedPostpones = request.trackedPostpones;
    if (null === trackedPostpones || 0 === trackedPostpones.rootNodes.length && null === trackedPostpones.rootSlots) return request.trackedPostpones = null;
    if (null === request.completedRootSegment || 5 !== request.completedRootSegment.status && null !== request.completedPreambleSegments) {
        var nextSegmentId = request.nextSegmentId;
        var replaySlots = trackedPostpones.rootSlots;
        var resumableState = request.resumableState;
        resumableState.bootstrapScriptContent = void 0;
        resumableState.bootstrapScripts = void 0;
        resumableState.bootstrapModules = void 0;
    } else {
        nextSegmentId = 0;
        replaySlots = -1;
        resumableState = request.resumableState;
        var renderState = request.renderState;
        resumableState.nextFormID = 0;
        resumableState.hasBody = !1;
        resumableState.hasHtml = !1;
        resumableState.unknownResources = {
            font: renderState.resets.font
        };
        resumableState.dnsResources = renderState.resets.dns;
        resumableState.connectResources = renderState.resets.connect;
        resumableState.imageResources = renderState.resets.image;
        resumableState.styleResources = renderState.resets.style;
        resumableState.scriptResources = {};
        resumableState.moduleUnknownResources = {};
        resumableState.moduleScriptResources = {};
        resumableState.instructions = 0;
    }
    return {
        nextSegmentId: nextSegmentId,
        rootFormatContext: request.rootFormatContext,
        progressiveChunkSize: request.progressiveChunkSize,
        resumableState: request.resumableState,
        replayNodes: trackedPostpones.rootNodes,
        replaySlots: replaySlots
    };
}
function $29ce09d30a26f47a$var$ensureCorrectIsomorphicReactVersion() {
    var isomorphicReactPackageVersion = $acw62.version;
    if ("19.2.4" !== isomorphicReactPackageVersion) throw Error($29ce09d30a26f47a$var$formatProdErrorMessage(527, isomorphicReactPackageVersion, "19.2.4"));
}
$29ce09d30a26f47a$var$ensureCorrectIsomorphicReactVersion();
$29ce09d30a26f47a$var$ensureCorrectIsomorphicReactVersion();
$29ce09d30a26f47a$export$4f10e897d13fb72b = function(children, options) {
    return new Promise(function(resolve, reject) {
        var onHeaders = options ? options.onHeaders : void 0, onHeadersImpl;
        onHeaders && (onHeadersImpl = function(headersDescriptor) {
            onHeaders(new Headers(headersDescriptor));
        });
        var resources = $29ce09d30a26f47a$var$createResumableState(options ? options.identifierPrefix : void 0, options ? options.unstable_externalRuntimeSrc : void 0, options ? options.bootstrapScriptContent : void 0, options ? options.bootstrapScripts : void 0, options ? options.bootstrapModules : void 0), request = $29ce09d30a26f47a$var$createPrerenderRequest(children, resources, $29ce09d30a26f47a$var$createRenderState(resources, void 0, options ? options.unstable_externalRuntimeSrc : void 0, options ? options.importMap : void 0, onHeadersImpl, options ? options.maxHeadersLength : void 0), $29ce09d30a26f47a$var$createRootFormatContext(options ? options.namespaceURI : void 0), options ? options.progressiveChunkSize : void 0, options ? options.onError : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    $29ce09d30a26f47a$var$startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    $29ce09d30a26f47a$var$abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            stream = {
                postponed: $29ce09d30a26f47a$var$getPostponedState(request),
                prelude: stream
            };
            resolve(stream);
        }, void 0, void 0, reject, options ? options.onPostpone : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) $29ce09d30a26f47a$var$abort(request, signal.reason);
            else {
                var listener = function() {
                    $29ce09d30a26f47a$var$abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        $29ce09d30a26f47a$var$startWork(request);
    });
};
$29ce09d30a26f47a$export$7020a3240b287705 = function(children, options) {
    return new Promise(function(resolve, reject) {
        var onFatalError, onAllReady, allReady = new Promise(function(res, rej) {
            onAllReady = res;
            onFatalError = rej;
        }), onHeaders = options ? options.onHeaders : void 0, onHeadersImpl;
        onHeaders && (onHeadersImpl = function(headersDescriptor) {
            onHeaders(new Headers(headersDescriptor));
        });
        var resumableState = $29ce09d30a26f47a$var$createResumableState(options ? options.identifierPrefix : void 0, options ? options.unstable_externalRuntimeSrc : void 0, options ? options.bootstrapScriptContent : void 0, options ? options.bootstrapScripts : void 0, options ? options.bootstrapModules : void 0), request = $29ce09d30a26f47a$var$createRequest(children, resumableState, $29ce09d30a26f47a$var$createRenderState(resumableState, options ? options.nonce : void 0, options ? options.unstable_externalRuntimeSrc : void 0, options ? options.importMap : void 0, onHeadersImpl, options ? options.maxHeadersLength : void 0), $29ce09d30a26f47a$var$createRootFormatContext(options ? options.namespaceURI : void 0), options ? options.progressiveChunkSize : void 0, options ? options.onError : void 0, onAllReady, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    $29ce09d30a26f47a$var$startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    $29ce09d30a26f47a$var$abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            stream.allReady = allReady;
            resolve(stream);
        }, function(error) {
            allReady.catch(function() {});
            reject(error);
        }, onFatalError, options ? options.onPostpone : void 0, options ? options.formState : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) $29ce09d30a26f47a$var$abort(request, signal.reason);
            else {
                var listener = function() {
                    $29ce09d30a26f47a$var$abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        $29ce09d30a26f47a$var$startWork(request);
    });
};
$29ce09d30a26f47a$export$fbb4d68fe60c1629 = function(children, postponedState, options) {
    return new Promise(function(resolve, reject) {
        var onFatalError, onAllReady, allReady = new Promise(function(res, rej) {
            onAllReady = res;
            onFatalError = rej;
        }), request = $29ce09d30a26f47a$var$resumeRequest(children, postponedState, $29ce09d30a26f47a$var$createRenderState(postponedState.resumableState, options ? options.nonce : void 0, void 0, void 0, void 0, void 0), options ? options.onError : void 0, onAllReady, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    $29ce09d30a26f47a$var$startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    $29ce09d30a26f47a$var$abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            stream.allReady = allReady;
            resolve(stream);
        }, function(error) {
            allReady.catch(function() {});
            reject(error);
        }, onFatalError, options ? options.onPostpone : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) $29ce09d30a26f47a$var$abort(request, signal.reason);
            else {
                var listener = function() {
                    $29ce09d30a26f47a$var$abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        $29ce09d30a26f47a$var$startWork(request);
    });
};
$29ce09d30a26f47a$export$2e1a48258ce555d9 = function(children, postponedState, options) {
    return new Promise(function(resolve, reject) {
        var request = $29ce09d30a26f47a$var$resumeAndPrerenderRequest(children, postponedState, $29ce09d30a26f47a$var$createRenderState(postponedState.resumableState, void 0, void 0, void 0, void 0, void 0), options ? options.onError : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    $29ce09d30a26f47a$var$startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    $29ce09d30a26f47a$var$abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            stream = {
                postponed: $29ce09d30a26f47a$var$getPostponedState(request),
                prelude: stream
            };
            resolve(stream);
        }, void 0, void 0, reject, options ? options.onPostpone : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) $29ce09d30a26f47a$var$abort(request, signal.reason);
            else {
                var listener = function() {
                    $29ce09d30a26f47a$var$abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        $29ce09d30a26f47a$var$startWork(request);
    });
};
$29ce09d30a26f47a$export$83d89fbfd8236492 = "19.2.4";

});

parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("iZZ9K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42, (v) => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd4d5cd9b8817e88$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $dd4d5cd9b8817e88$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd4d5cd9b8817e88$var$objectIs = "function" === typeof Object.is ? Object.is : $dd4d5cd9b8817e88$var$is, $dd4d5cd9b8817e88$var$useSyncExternalStore = $acw62.useSyncExternalStore, $dd4d5cd9b8817e88$var$useRef = $acw62.useRef, $dd4d5cd9b8817e88$var$useEffect = $acw62.useEffect, $dd4d5cd9b8817e88$var$useMemo = $acw62.useMemo, $dd4d5cd9b8817e88$var$useDebugValue = $acw62.useDebugValue;
$dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd4d5cd9b8817e88$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd4d5cd9b8817e88$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd4d5cd9b8817e88$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd4d5cd9b8817e88$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd4d5cd9b8817e88$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd4d5cd9b8817e88$var$useDebugValue(value);
    return value;
};

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.4" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});




var $acw62 = parcelRequire("acw62");
const $53c62e7ff907ad8d$export$e04fb47aee2138fd = 'https://www.adaptabletools.com';
const $53c62e7ff907ad8d$export$6fb62bf2d8008f92 = `${$53c62e7ff907ad8d$export$e04fb47aee2138fd}/docs`;
const $53c62e7ff907ad8d$export$21349425a3747427 = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/ui-expression-editor`;
const $53c62e7ff907ad8d$export$f5c7639fe3b50c2 = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/adaptable-ql-expression-standard`;
const $53c62e7ff907ad8d$export$6bee4ae4ed72a3a2 = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/adaptable-ql-expression-standard`;
const $53c62e7ff907ad8d$export$cb8ecca2196c506a = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/adaptable-ql-expression-observable`;
const $53c62e7ff907ad8d$export$ca49290a085ae96f = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/adaptable-ql-expression-aggregation`;
const $53c62e7ff907ad8d$export$3f9e7d8c07a7d633 = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/adaptable-ql-expression-aggregation`;
const $53c62e7ff907ad8d$export$7b3f99bbf2928c = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/adaptable-ql-expression-cumulative`;
const $53c62e7ff907ad8d$export$ff649e5dcba07647 = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/adaptable-ql-expression-quantile`;
const $53c62e7ff907ad8d$export$84bd4f31fbbffa34 = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/adaptable-predicate`;
const $53c62e7ff907ad8d$export$67bdec9cfb148ab5 = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/getting-started-primary-key`;
const $53c62e7ff907ad8d$export$aaffa8febb381f15 = `${$53c62e7ff907ad8d$export$e04fb47aee2138fd}/buy/buying-adaptable-licensing`;
const $53c62e7ff907ad8d$export$583e39ddfce4335e = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/technical-reference-adaptable-options`;
const $53c62e7ff907ad8d$export$1f919f567885fa35 = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/getting-started-aggrid-modules`;
const $53c62e7ff907ad8d$export$5a4f95df1865185a = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/handbook-alerting-message`;
const $53c62e7ff907ad8d$export$97c302ec6cca56ba = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/handbook-column-formatting-display-format-placeholder`;
const $53c62e7ff907ad8d$export$1768e4e871cc8a23 = `${$53c62e7ff907ad8d$export$6fb62bf2d8008f92}/getting-started-aggrid-modules#mandatory-modules`;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $88ab1a78ec8ca4b4$var$Th = Object.create;
var $88ab1a78ec8ca4b4$var$Us = Object.defineProperty;
var $88ab1a78ec8ca4b4$var$Sh = Object.getOwnPropertyDescriptor;
var $88ab1a78ec8ca4b4$var$Ch = Object.getOwnPropertyNames;
var $88ab1a78ec8ca4b4$var$wh = Object.getPrototypeOf, $88ab1a78ec8ca4b4$var$Ih = Object.prototype.hasOwnProperty;
var $88ab1a78ec8ca4b4$var$vh = (o, e)=>()=>(e || o((e = {
            exports: {}
        }).exports, e), e.exports);
var $88ab1a78ec8ca4b4$var$Rh = (o, e, t, n)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let r of $88ab1a78ec8ca4b4$var$Ch(e))!$88ab1a78ec8ca4b4$var$Ih.call(o, r) && r !== t && $88ab1a78ec8ca4b4$var$Us(o, r, {
        get: ()=>e[r],
        enumerable: !(n = $88ab1a78ec8ca4b4$var$Sh(e, r)) || n.enumerable
    });
    return o;
};
var $88ab1a78ec8ca4b4$var$qn = (o, e, t)=>(t = o != null ? $88ab1a78ec8ca4b4$var$Th($88ab1a78ec8ca4b4$var$wh(o)) : {}, $88ab1a78ec8ca4b4$var$Rh(e || !o || !o.__esModule ? $88ab1a78ec8ca4b4$var$Us(t, "default", {
        value: o,
        enumerable: !0
    }) : t, o));
var $88ab1a78ec8ca4b4$var$Dn = $88ab1a78ec8ca4b4$var$vh((_P, Fu)=>{
    "use strict";
    Fu.exports = function(o, e, t, n, r) {
        var i, a;
        if (n === void 0) n = 0;
        else if (n = n | 0, n < 0 || n >= o.length) throw new RangeError("invalid lower bound");
        if (r === void 0) r = o.length - 1;
        else if (r = r | 0, r < n || r >= o.length) throw new RangeError("invalid upper bound");
        for(; n <= r;)if (i = n + (r - n >>> 1), a = +t(o[i], e, i, o), a < 0) n = i + 1;
        else if (a > 0) r = i - 1;
        else return i;
        return ~n;
    };
});
function $88ab1a78ec8ca4b4$export$61fc7d43ac8f84b0(o, { wait: e }) {
    let t = null;
    return function(...n) {
        let r = this;
        t !== null && clearTimeout(t), t = setTimeout(()=>{
            o.apply(r, n);
        }, e);
    };
}
var $88ab1a78ec8ca4b4$var$X = (...o)=>o.filter((e)=>!!`${e}`).join(" ");
function $88ab1a78ec8ca4b4$var$ye(o = !1) {
    let e = null, t = [], n = null, r = (i, a)=>{
        let l = [];
        if (o) n != null && (cancelAnimationFrame(n), n = null), requestAnimationFrame(()=>{
            e = i, n = null;
            for(let s = 0, c = t.length; s < c; s++)l.push(t[s](i));
            a?.(l);
        });
        else {
            e = i;
            for(let s = 0, c = t.length; s < c; s++)l.push(t[s](i));
            a?.(l);
        }
    };
    return r.get = ()=>e, r.onChange = (i)=>(t.push(i), ()=>{
            t = t.filter((a)=>a !== i);
        }), r.destroy = ()=>{
        r(null), t.length = 0;
    }, r.getListenersCount = ()=>t.length, r;
}
function $88ab1a78ec8ca4b4$var$ot(o) {
    let e = !1, t = null;
    return (...r)=>(e || (e = !0, t = o(...r)), t);
}
var $88ab1a78ec8ca4b4$var$Ys = (o, e)=>o - e;
var $88ab1a78ec8ca4b4$var$Rr = (o, e)=>$88ab1a78ec8ca4b4$var$Ys(o.revision, e.revision), $88ab1a78ec8ca4b4$export$1c737028a0cb2e00 = class o {
    constructor(e){
        this.map = new Map;
        this.length = 0;
        this.revision = 0;
        this.emptyKey = Symbol("emptyKey");
        this.visit = (e)=>{
            this.map.forEach((t, n)=>this.visitKey(n, this.map, [], e, !1));
        };
        this.visitSome = (e)=>{
            this.visitWithNext([], e, !0);
        };
        this.visitDepthFirst = (e)=>{
            this.visitWithNext([], e, !1);
        };
        this.visitWithNext = (e, t, n, r = this.map, i, a)=>{
            if (!r) return;
            let l = 0, s = r.has(this.emptyKey), c = !a;
            if (i !== void 0) {
                if (i < 0) return;
                i--;
            }
            let u = (d, f)=>{
                let p = r.get(f);
                if (!p) return;
                let { map: m } = p, g = f === this.emptyKey;
                if (g && !c) return;
                let b = g ? [] : [
                    ...e,
                    f
                ], h = m ? ()=>this.visitWithNext(b, t, n, m, i !== void 0 ? i - 1 : void 0) : void 0;
                if (p.hasOwnProperty("value")) {
                    let y = t(p.value, b, l, h, p);
                    if (n && y === !0) return !0;
                    l++;
                } else h?.();
            };
            s && (u(void 0, this.emptyKey), c = !1, l = 0);
            for (let [d, f] of r){
                let p = u(f, d);
                if (n && p === !0) return p;
            }
        };
        this.fill(e);
    }
    static clone(e) {
        let t = new o;
        return e.visit((n, r)=>{
            t.set(r, n.value);
        }), t;
    }
    fill(e) {
        e && e.forEach((t)=>{
            let [n, r] = t;
            this.set(n, r);
        });
    }
    getValuesStartingWith(e, t) {
        let n = [];
        return this.getStartingWith(e, (r, i)=>{
            n.push(i);
        }, t), n;
    }
    getEntriesStartingWith(e, t) {
        let n = [];
        return this.getStartingWith(e, (r, i)=>{
            n.push([
                r,
                i
            ]);
        }, t), n;
    }
    getLeafNodesStartingWith(e, t, n) {
        let { respectOrder: r = !1 } = n || {}, i = [], a = [];
        return this.getStartingWith(e, (l, s, c)=>{
            !c.map && c.hasOwnProperty("value") && (r ? i.push(c) : a.push(t(c)));
        }, n), r ? i.sort($88ab1a78ec8ca4b4$var$Rr).map(t) : a;
    }
    getKeysForLeafNodesStartingWith(e, t) {
        return this.getLeafNodesStartingWith(e, (n)=>n.keys, t);
    }
    getKeysAndValuesForLeafNodesStartingWith(e, t) {
        return this.getLeafNodesStartingWith(e, (n)=>[
                n.keys,
                n.value
            ], t);
    }
    getKeysOfFirstChildOnEachBranchStartingWith(e, t) {
        let { excludeSelf: n, depthLimit: r, respectOrder: i = !0 } = t || {}, a = [], l = [], s = (f)=>{
            i ? a.push(f) : l.push(f.keys);
        }, c = this.map, u, d = !1;
        if (e.length) for(let f = 0, p = e.length; f < p; f++){
            let m = e[f];
            if (u = c.get(m), !u || !u.map) {
                if (d = !0, f === p - 1) {
                    d = !0;
                    break;
                } else return [];
            }
            c = u.map;
        }
        else if (!n && c.has(this.emptyKey)) return [
            []
        ];
        return u && u.value !== void 0 && (n || (s({
            ...u,
            keys: e
        }), d = !0)), d ? i ? a.sort($88ab1a78ec8ca4b4$var$Rr).map((f)=>f.keys) : l : (this.visitWithNext(e, (f, p, m, g, b)=>{
            s({
                ...b,
                keys: p
            });
        }, !1, c, r, n), i ? a.sort($88ab1a78ec8ca4b4$var$Rr).map((f)=>f.keys) : l);
    }
    getKeysStartingWith(e, t) {
        let n = [];
        return this.getStartingWith(e, (r)=>{
            n.push(r);
        }, t), n;
    }
    getStartingWith(e, t, n) {
        let { excludeSelf: r, depthLimit: i } = n || {}, a = this.map, l, s = !1;
        if (e.length) for(let c = 0, u = e.length; c < u; c++){
            let d = e[c];
            if (l = a.get(d), !l || !l.map) {
                if (s = !0, c === u - 1) {
                    s = !0;
                    break;
                } else return;
            }
            a = l.map;
        }
        l && l.value !== void 0 && (r || t(e, l.value, {
            ...l,
            keys: e
        })), !s && this.visitWithNext(e, (c, u, d, f, p)=>{
            t(u, c, {
                ...p,
                keys: u
            }), f?.();
        }, !1, a, i, r);
    }
    getMapAt(e) {
        let t = this.map, n;
        if (!e.length) return this.map;
        for(let r = 0, i = e.length; r < i; r++){
            let a = e[r];
            if (n = t.get(a), !n || !n.map) return;
            t = n.map;
        }
        return t;
    }
    getAllChildrenSizeFor(e) {
        let t = this.map, n;
        if (!e.length) return this.length;
        for(let r = 0, i = e.length; r < i; r++){
            let a = e[r];
            if (n = t.get(a), !n || !n.map) return 0;
            t = n.map;
        }
        return n.length;
    }
    getDirectChildrenSizeFor(e) {
        let t = this.map;
        e.length || (e = [
            this.emptyKey
        ]);
        for(let n = 0, r = e.length; n < r; n++){
            let i = e[n], a = n === r - 1, l = t.get(i);
            if (!l || !l.map) return 0;
            if (t = l.map, a) return t?.size ?? 0;
        }
        return 0;
    }
    set(e, t) {
        let n = this.map;
        e.length || (e = [
            this.emptyKey
        ]);
        for(let r = 0, i = e.length; r < i; r++){
            let a = e[r], l = r === i - 1, s = n.get(a) || {
                length: 0
            };
            l ? (s.revision = this.revision++, s.value = t, n.set(a, s), this.length++) : (s.map || (s.map = new Map, n.set(a, s)), s.length++, n = s.map);
        }
        return this;
    }
    get(e) {
        let t = this.map;
        e.length || (e = [
            this.emptyKey
        ]);
        for(let n = 0, r = e.length; n < r; n++){
            let i = e[n], a = n === r - 1, l = t.get(i);
            if (a) return l ? l.value : void 0;
            if (!l || !l.map) return;
            t = l.map;
        }
    }
    get size() {
        return this.length;
    }
    clear() {
        let e = (t)=>{
            t.forEach((n, r)=>{
                let { map: i } = n;
                i && e(i);
            }), t.clear();
        };
        e(this.map), this.length = 0, this.revision = 0;
    }
    delete(e) {
        let t = this.map;
        e.length ? e = [
            ...e
        ] : e = [
            this.emptyKey
        ];
        let n = [
            t
        ], r = [], i = !1;
        for(let a = 0, l = e.length; a < l; a++){
            let s = e[a], c = a === l - 1, u = t.get(s);
            if (c) {
                u && (u.hasOwnProperty("value") && (delete u.value, delete u.revision, i = !0, r.forEach((d)=>{
                    d.length--;
                }), this.length--), u.map && u.map.size === 0 && delete u.map, u.map || t.delete(s));
                break;
            } else {
                if (!u || !u.map) {
                    i = !1;
                    break;
                }
                r.push(u), t = u.map, n.push(t);
            }
        }
        for(; n.length;){
            let a = n.pop(), l = e.length;
            if (e.pop(), l > 0 && a?.size === 0) {
                let s = n[n.length - 1], c = e[e.length - 1], u = s?.get(c);
                u && (delete u.map, u.hasOwnProperty("value") || s.delete(c));
            }
        }
        return i;
    }
    has(e) {
        let t = this.map;
        e.length || (e = [
            this.emptyKey
        ]);
        for(let n = 0, r = e.length; n < r; n++){
            let i = e[n], a = n === r - 1, l = t.get(i);
            if (a) return l ? l.hasOwnProperty("value") : !1;
            if (!l || !l.map) return !1;
            t = l.map;
        }
        return !1;
    }
    visitKey(e, t, n, r, i) {
        let a = t.get(e);
        if (!a) return;
        let { map: l } = a, s = e === this.emptyKey ? [] : [
            ...n,
            e
        ], c = $88ab1a78ec8ca4b4$var$ot(()=>{
            if (l) for (let [u] of l){
                let d = this.visitKey(u, l, s, r, i);
                if (i && d === !0) return !0;
            }
            return !1;
        });
        if (a.hasOwnProperty("value")) {
            let u = r(a, s, c);
            if (i && u === !0) return !0;
        }
        c();
    }
    getArray(e) {
        let t = [];
        return this.visit((n, r)=>{
            let i = e({
                ...n,
                keys: r
            });
            r.length === 0 ? t.splice(0, 0, i) : t.push(i);
        }), t;
    }
    rawKeysAt(e) {
        let t = this.getMapAt(e);
        return t ? [
            ...t.keys()
        ] : [];
    }
    valuesAt(e) {
        let t = this.getMapAt(e);
        if (!t) return [];
        let n = [];
        return t.forEach((r)=>{
            r.value !== void 0 && n.push(r.value);
        }), n;
    }
    values() {
        return this.sortedIterator((e)=>e.value);
    }
    keys() {
        return this.sortedIterator((t)=>t.keys);
    }
    entries() {
        return this.sortedIterator((e)=>[
                e.keys,
                e.value
            ]);
    }
    topDownEntries() {
        return this.getArray((e)=>[
                e.keys,
                e.value
            ]);
    }
    topDownKeys() {
        return this.getArray((e)=>e.keys);
    }
    topDownValues() {
        return this.getArray((e)=>e.value);
    }
    sortedIterator(e) {
        let t = [];
        this.visit((r, i)=>{
            t.push({
                ...r,
                keys: i
            });
        }), t.sort($88ab1a78ec8ca4b4$var$Rr);
        function* n() {
            for(let r = 0, i = t.length; r < i; r++)yield e(t[r]);
        }
        return n();
    }
};
globalThis.DeepMap = $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
function $88ab1a78ec8ca4b4$var$Re() {
    return globalThis;
}
var $88ab1a78ec8ca4b4$var$Pr = [
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
], $88ab1a78ec8ca4b4$var$qs = Symbol("color"), $88ab1a78ec8ca4b4$var$xr = new WeakMap, $88ab1a78ec8ca4b4$var$wa = $88ab1a78ec8ca4b4$var$ye();
function $88ab1a78ec8ca4b4$var$Ia(o = $88ab1a78ec8ca4b4$var$Pr) {
    $88ab1a78ec8ca4b4$var$xr.set(o, o.map((e)=>0));
}
$88ab1a78ec8ca4b4$var$Ia();
var $88ab1a78ec8ca4b4$var$xh = (o = $88ab1a78ec8ca4b4$var$Pr)=>{
    let e = [];
    $88ab1a78ec8ca4b4$var$xr.has(o) ? e = $88ab1a78ec8ca4b4$var$xr.get(o) : (e = o.map((n)=>0), $88ab1a78ec8ca4b4$var$xr.set(o, e));
    let t = e.reduce((n, r, i, a)=>r < a[n] ? i : n, 0);
    return e[t] != null && e[t]++, o[t] ?? o[0] ?? $88ab1a78ec8ca4b4$var$Pr[0];
}, $88ab1a78ec8ca4b4$var$Fo = ":", $88ab1a78ec8ca4b4$var$va = "*", $88ab1a78ec8ca4b4$var$Xs = "-", $88ab1a78ec8ca4b4$var$Ph = ",", $88ab1a78ec8ca4b4$var$Dh = "debug", $88ab1a78ec8ca4b4$var$Mh = "diffdebug", $88ab1a78ec8ca4b4$var$Qs = !1, $88ab1a78ec8ca4b4$var$No = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00, $88ab1a78ec8ca4b4$var$Lo = new Map;
function $88ab1a78ec8ca4b4$var$Ra(o, e) {
    let t = o.split($88ab1a78ec8ca4b4$var$Fo), n = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
    n.set(t, !0);
    let r = e.split($88ab1a78ec8ca4b4$var$Fo), i = new Set(r).has($88ab1a78ec8ca4b4$var$va), a = r.indexOf($88ab1a78ec8ca4b4$var$va), l = i ? r.slice(0, a) : r;
    if (n.getKeysStartingWith(l, {
        excludeSelf: i
    }).length > 0) {
        let s = r.slice(a + 1);
        return s.length ? o.endsWith(s.join($88ab1a78ec8ca4b4$var$Fo)) : !0;
    }
}
function $88ab1a78ec8ca4b4$var$Js(o, e) {
    let t = `channel=${o}_permissions=${e}`;
    if ($88ab1a78ec8ca4b4$var$Lo.has(t)) return $88ab1a78ec8ca4b4$var$Lo.get(t);
    let n = e.split($88ab1a78ec8ca4b4$var$Ph);
    function r(l) {
        return $88ab1a78ec8ca4b4$var$Lo.set(t, l), l;
    }
    let i = [], a = [];
    n.forEach((l)=>{
        l.includes($88ab1a78ec8ca4b4$var$va) ? a.push(l) : i.push(l);
    });
    for(let l = 0; l < i.length; l++){
        let s = i[l], c = s.startsWith($88ab1a78ec8ca4b4$var$Xs);
        if (c && (s = s.substring($88ab1a78ec8ca4b4$var$Xs.length)), $88ab1a78ec8ca4b4$var$Ra(o, s)) return r(!c);
    }
    for(let l = 0; l < a.length; l++){
        let s = a[l], c = s.startsWith("-");
        if (c && (s = s.substring(1)), $88ab1a78ec8ca4b4$var$Ra(o, s)) return r(!c);
    }
    return r(!1);
}
var $88ab1a78ec8ca4b4$var$xa = ()=>$88ab1a78ec8ca4b4$export$1c9f709888824e05.enable ?? ($88ab1a78ec8ca4b4$var$Re() && $88ab1a78ec8ca4b4$var$Re().localStorage?.getItem($88ab1a78ec8ca4b4$var$Dh)) ?? "", $88ab1a78ec8ca4b4$var$Eh = ()=>$88ab1a78ec8ca4b4$export$1c9f709888824e05.diffenable ?? ($88ab1a78ec8ca4b4$var$Re() && $88ab1a78ec8ca4b4$var$Re().localStorage?.getItem($88ab1a78ec8ca4b4$var$Mh)) ?? `${$88ab1a78ec8ca4b4$var$Qs}`, $88ab1a78ec8ca4b4$var$Pa = "", $88ab1a78ec8ca4b4$var$ec = $88ab1a78ec8ca4b4$var$Qs;
function $88ab1a78ec8ca4b4$var$Da(o) {
    $88ab1a78ec8ca4b4$var$ec = `${$88ab1a78ec8ca4b4$var$Eh()}` == "true", $88ab1a78ec8ca4b4$var$Pa !== o && ($88ab1a78ec8ca4b4$var$Pa = o, $88ab1a78ec8ca4b4$var$Lo.clear());
}
function $88ab1a78ec8ca4b4$var$tc(o) {
    $88ab1a78ec8ca4b4$var$Da($88ab1a78ec8ca4b4$var$xa()), typeof $88ab1a78ec8ca4b4$var$Re() < "u" && $88ab1a78ec8ca4b4$var$Re().addEventListener && $88ab1a78ec8ca4b4$var$Re().addEventListener("storage", function() {
        $88ab1a78ec8ca4b4$var$Da($88ab1a78ec8ca4b4$var$xa());
    });
    function e(t, n) {
        let r = n ? `${n}${$88ab1a78ec8ca4b4$var$Fo}${t}` : t, i = r.split($88ab1a78ec8ca4b4$var$Fo), a = $88ab1a78ec8ca4b4$var$No.get(i);
        if (a) return a;
        let l = $88ab1a78ec8ca4b4$var$No.get(i.slice(0, -1)), s = (l ? l.logFn : $88ab1a78ec8ca4b4$export$1c9f709888824e05.logFn) ?? $88ab1a78ec8ca4b4$var$nc, c = s, u, d = 0, f = ()=>u ?? $88ab1a78ec8ca4b4$var$Js(r, $88ab1a78ec8ca4b4$var$Pa), p = $88ab1a78ec8ca4b4$var$xh($88ab1a78ec8ca4b4$export$1c9f709888824e05.colors), m = Object.defineProperties((...g)=>{
            let b = $88ab1a78ec8ca4b4$var$wa.getListenersCount(), h;
            if (b > 0 && (h = h ?? Date.now(), $88ab1a78ec8ca4b4$var$wa({
                color: p,
                channel: r,
                args: g,
                timestamp: h
            })), f()) {
                if (h = h ?? Date.now(), d && $88ab1a78ec8ca4b4$var$ec) {
                    let C = h - d;
                    c(`%c[${r}]`, `color: ${p}`, `+${C}ms:`);
                }
                d = h;
                let y = [], S;
                if (g.forEach((C)=>{
                    if (C[$88ab1a78ec8ca4b4$var$qs]) S === void 0 && (S = !0), y.push(...C);
                    else {
                        if (typeof C != "string" && typeof C != "number") {
                            S = !1;
                            return;
                        }
                        y.push(`${C}%s`);
                    }
                }), S) {
                    let C = [
                        `%c[${r}]%c %s`,
                        `color: ${p}`,
                        "",
                        ...y,
                        ""
                    ];
                    c(...C);
                } else c(`%c[${r}]%c %s`, `color: ${p}`, "", ...g);
            }
        }, {
            channel: {
                value: r
            },
            color: {
                value: (g, ...b)=>{
                    let h = [
                        `%c${b.join(" ")}%c%s`,
                        `color: ${g}`,
                        ""
                    ];
                    return h.toString = ()=>b.join(" "), h[$88ab1a78ec8ca4b4$var$qs] = !0, h;
                }
            },
            extend: {
                value: (g)=>e(g, r)
            },
            enabled: {
                get: ()=>f(),
                set: (g)=>{
                    u = g;
                }
            },
            logFn: {
                configurable: !1,
                get: ()=>c,
                set: (g)=>{
                    c = g ?? s;
                }
            },
            destroy: {
                value: ()=>{
                    $88ab1a78ec8ca4b4$var$No.delete(i);
                }
            }
        });
        return $88ab1a78ec8ca4b4$var$No.set(i, m), m;
    }
    return e(o);
}
var $88ab1a78ec8ca4b4$var$nc = console.log.bind(console), $88ab1a78ec8ca4b4$var$Zs;
Object.defineProperty($88ab1a78ec8ca4b4$var$tc, "enable", {
    get: ()=>$88ab1a78ec8ca4b4$var$Zs,
    set: (o)=>{
        $88ab1a78ec8ca4b4$var$Zs = o, $88ab1a78ec8ca4b4$var$Da($88ab1a78ec8ca4b4$var$xa());
    }
});
var $88ab1a78ec8ca4b4$export$1c9f709888824e05 = $88ab1a78ec8ca4b4$var$tc;
$88ab1a78ec8ca4b4$export$1c9f709888824e05.colors = $88ab1a78ec8ca4b4$var$Pr;
$88ab1a78ec8ca4b4$export$1c9f709888824e05.logFn = $88ab1a78ec8ca4b4$var$nc;
var $88ab1a78ec8ca4b4$var$Ah = (o, e)=>$88ab1a78ec8ca4b4$var$wa.onChange((t)=>{
        if (!t) return;
        let { channel: n, args: r, color: i, timestamp: a } = t;
        $88ab1a78ec8ca4b4$var$Ra(n, o) && e({
            channel: n,
            color: i,
            args: r,
            timestamp: a
        });
    });
$88ab1a78ec8ca4b4$export$1c9f709888824e05.onLogIntent = $88ab1a78ec8ca4b4$var$Ah;
$88ab1a78ec8ca4b4$export$1c9f709888824e05.isChannelEnabled = $88ab1a78ec8ca4b4$var$Js;
$88ab1a78ec8ca4b4$export$1c9f709888824e05.destroyAll = ()=>{
    $88ab1a78ec8ca4b4$var$Ia(), $88ab1a78ec8ca4b4$var$Ia($88ab1a78ec8ca4b4$export$1c9f709888824e05.colors), $88ab1a78ec8ca4b4$var$No.clear(), $88ab1a78ec8ca4b4$var$Lo.clear();
};
var $88ab1a78ec8ca4b4$var$St = (o)=>{
    let e = $88ab1a78ec8ca4b4$export$1c9f709888824e05(o ? `IT:${o}:TYPE=debug` : "IT:TYPE=debug");
    return e.logFn = console.log.bind(console), e;
}, $88ab1a78ec8ca4b4$var$on = (o)=>{
    let e = $88ab1a78ec8ca4b4$export$1c9f709888824e05(o ? `IT:${o}:TYPE=error` : "IT:TYPE=error");
    return e.logFn = console.error.bind(console), e;
}, $88ab1a78ec8ca4b4$var$ko = ()=>$88ab1a78ec8ca4b4$var$ko;
$88ab1a78ec8ca4b4$var$ko.extend = ()=>$88ab1a78ec8ca4b4$var$ko;
var $88ab1a78ec8ca4b4$var$st = class {
    constructor(e){
        this.debug = $88ab1a78ec8ca4b4$var$ko, this.error = $88ab1a78ec8ca4b4$var$ko;
    }
};
var $88ab1a78ec8ca4b4$var$zo = (o, e, t = {
    debounce: 0
})=>{
    let n = t.debounce ?? 0, r = window.ResizeObserver, i = n ? $88ab1a78ec8ca4b4$export$61fc7d43ac8f84b0(e, {
        wait: n
    }) : e, a = new r((l)=>{
        let s = l[0], { width: c, height: u } = s.contentRect;
        if (s.borderBoxSize?.[0]) u = s.borderBoxSize[0].blockSize, c = s.borderBoxSize[0].inlineSize;
        else {
            let d = o.getBoundingClientRect();
            u = d.height, c = d.width;
        }
        i({
            width: c,
            height: u
        });
    });
    return a.observe(o), ()=>{
        a.disconnect();
    };
}, $88ab1a78ec8ca4b4$var$Dr = (o, e, t = {
    earlyAttach: !1,
    debounce: 0
})=>{
    let n = (0, $acw62.useRef)({
        width: 0,
        height: 0
    }), r = (i)=>{
        let a;
        return o.current && (a = $88ab1a78ec8ca4b4$var$zo(o.current, (l)=>{
            l = {
                width: Math.round(l.width),
                height: Math.round(l.height)
            };
            let s = n.current;
            (s.width !== l.width || s.height !== l.height) && (n.current = l, i(l));
        }, {
            debounce: t.debounce
        })), ()=>{
            a && a();
        };
    };
    (0, $acw62.useEffect)(()=>t.earlyAttach ? ()=>{} : r(e), [
        o.current,
        e,
        t.earlyAttach,
        t.debounce
    ]), (0, $acw62.useLayoutEffect)(()=>t.earlyAttach ? r(e) : ()=>{}, [
        o.current,
        e,
        t.earlyAttach
    ]);
};
var $88ab1a78ec8ca4b4$var$Lh = $88ab1a78ec8ca4b4$var$on("CSSVariableWatch"), $88ab1a78ec8ca4b4$var$kh = $88ab1a78ec8ca4b4$var$St("CSSVariableWatch"), $88ab1a78ec8ca4b4$var$zh = {
    position: "absolute",
    pointerEvents: "none",
    width: 0,
    height: 0,
    lineHeight: 0,
    fontSize: 0,
    overflow: "hidden"
}, $88ab1a78ec8ca4b4$var$Vh = (o)=>{
    let e = (0, $acw62.useRef)(0), t = $acw62.useCallback(({ height: n })=>{
        n != null && n !== e.current && (e.current = n, o.onChange(n));
    }, [
        o.onChange
    ]);
    $88ab1a78ec8ca4b4$var$Dr(o.ref, t, {
        earlyAttach: !0
    }), $acw62.useLayoutEffect(()=>{
        let n = o.ref.current.getBoundingClientRect().height;
        if (n != null) return e.current = n, $88ab1a78ec8ca4b4$var$kh(`Variable ${o.varName} found and equals ${n}.`), o.onChange(n);
        $88ab1a78ec8ca4b4$var$Lh(`Specified variable ${o.varName} not found or does not have a numeric value.`);
    }, []);
}, $88ab1a78ec8ca4b4$var$Vo = (o)=>{
    let e = (0, $acw62.useRef)(null);
    $88ab1a78ec8ca4b4$var$Vh({
        ...o,
        ref: e
    });
    let t = o.varName.startsWith("var(") ? o.varName : `var(${o.varName})`, { allowInts: n = !1 } = o;
    return $acw62.createElement("div", {
        "data-name": "css-variable-watcher",
        "data-var": o.varName,
        style: $88ab1a78ec8ca4b4$var$zh
    }, $acw62.createElement("div", {
        ref: e,
        style: {
            height: n ? `calc(1px * ${t})` : t
        }
    }));
};
var $88ab1a78ec8ca4b4$var$Ma;
function $88ab1a78ec8ca4b4$var$Go() {
    return $88ab1a78ec8ca4b4$var$Ma || ($88ab1a78ec8ca4b4$var$Ma = $acw62.createContext({
        api: null,
        getState: ()=>null,
        assignState: ()=>null,
        getDataSourceMasterContext: ()=>{},
        componentState: null,
        componentActions: null
    }));
}
var $88ab1a78ec8ca4b4$var$Ea;
function $88ab1a78ec8ca4b4$var$Mr() {
    return $88ab1a78ec8ca4b4$var$Ea || ($88ab1a78ec8ca4b4$var$Ea = $acw62.createContext(void 0));
}
function $88ab1a78ec8ca4b4$export$c5a52c32d527b09b() {
    let o = $88ab1a78ec8ca4b4$var$Go();
    return $acw62.useContext(o).componentState;
}
function $88ab1a78ec8ca4b4$var$_e() {
    let o = $88ab1a78ec8ca4b4$var$Go();
    return $acw62.useContext(o);
}
function $88ab1a78ec8ca4b4$var$Ve() {
    let o = $88ab1a78ec8ca4b4$var$Mr();
    return $acw62.useContext(o);
}
function $88ab1a78ec8ca4b4$var$Aa(o, e) {
    let t = new Set;
    function n(...r) {
        let i = e ? e.getProxyTargetFromArgs(...r) : r[0];
        t.clear();
        let a = {
            get: function(c, u) {
                return t.add(u), c[u];
            }
        }, l = new Proxy(i, a), s = e ? e.putProxyToArgs(l, ...r) : [
            l
        ];
        return o.apply(this, s);
    }
    return {
        fn: n,
        propertyReads: t
    };
}
var $88ab1a78ec8ca4b4$var$_a = (o)=>o && o.substr(0, 1).toUpperCase() + o.substr(1);
function $88ab1a78ec8ca4b4$var$an(o) {
    if (o == null) return !1;
    let e = o;
    return !0;
}
function $88ab1a78ec8ca4b4$var$Ho(o) {
    return o !== void 0;
}
function $88ab1a78ec8ca4b4$var$ln(o, e) {
    let t = e[o];
    return $88ab1a78ec8ca4b4$var$Ho(t);
}
var $88ab1a78ec8ca4b4$var$Ct = ()=>{
    let [o, e] = (0, $acw62.useState)(0);
    return [
        o,
        (0, $acw62.useCallback)(()=>{
            e((t)=>t + 1);
        }, [
            e
        ])
    ];
};
var $88ab1a78ec8ca4b4$var$ac = (o)=>{
    let e = (0, $acw62.useCallback)(o, []), t = (0, $acw62.useRef)(!1), n = (0, $acw62.useRef)(!1), r = (0, $acw62.useRef)(void 0), [i, a] = $88ab1a78ec8ca4b4$var$Ct();
    t.current && (n.current = !0), (0, $acw62.useEffect)(()=>(t.current || (r.current = e, t.current = !0), a(), ()=>{
            n.current && r.current && r.current();
        }), []);
};
function $88ab1a78ec8ca4b4$var$Me(o) {
    let e = (0, $acw62.useRef)(o);
    return e.current = o, (0, $acw62.useCallback)(()=>e.current, []);
}
var $88ab1a78ec8ca4b4$export$5cae361ad82dce8b = (o, e)=>{
    let t = (0, $acw62.useRef)(e === void 0 ? o : e);
    return (0, $acw62.useLayoutEffect)(()=>{
        t.current = o;
    }), t.current;
};
var $88ab1a78ec8ca4b4$var$Ko = {
    DataSource: {
        track: "DataSource",
        labels: {
            RemoteDataLoad: "Remote data load",
            TreeUnfilteredTreePaths: "Computing unfiltered tree paths",
            Filter: "Filter",
            Sort: "Sort",
            Group: "Group",
            LazyGroup: "Lazy group",
            Tree: "Tree",
            FlattenTree: "Flatten tree",
            Flatten: "Flatten groups",
            PrepareData: "Preparing data",
            ComputeSelectionCount: "Computing selection count",
            ComputeSelectionCountLazy: "Computing selection count (lazy)",
            PrepareRowInfo: "Preparing row info array",
            DiffRowInfoInStore: "setDataArray diffing in RowInfoStore"
        }
    },
    InfiniteTable: {
        track: "InfiniteTable",
        labels: {
            Render: "Rendering"
        }
    },
    MatrixBrain: {
        track: "Layout Computations",
        labels: {
            ComputeRenderRange: "Computing render range"
        }
    },
    ComponentState: {
        track: "ComponentState",
        labels: {
            PropUpdate: "Prop update"
        }
    }
};
var $88ab1a78ec8ca4b4$var$Na = class o {
    constructor(e){
        this.debugId = e;
        this.markerDetails = {
            label: "",
            track: "",
            trackGroup: void 0,
            color: void 0,
            details: [],
            tooltip: void 0
        };
        this.stopped = !1;
        this.start = (e)=>{
            if (this.markerDetails.startTs) return this;
            let t = performance.now();
            return this.markerDetails.details = e?.details ?? [], this.markerDetails.startTs = t, this;
        };
        this.end = (e = {})=>{
            if (this.stopped) return this;
            this.stopped = !0;
            let t = e.startTs ?? this.markerDetails.startTs, n = e.endTs ?? this.markerDetails.endTs ?? performance.now(), r = e.color || this.markerDetails.color || "primary", i = e.trackGroup || this.markerDetails.trackGroup || `Infinite Table (${this.debugId})`, a = [
                ...this.markerDetails.details || [],
                ...e.details || []
            ], l = e.tooltip || this.markerDetails.tooltip, s = e.label || this.markerDetails.label || "Unknown", c = e.track || this.markerDetails.track || "Unknown";
            return performance.measure(s, {
                start: t,
                end: n,
                detail: {
                    devtools: {
                        dataType: "track-entry",
                        trackGroup: i,
                        track: c,
                        color: r,
                        properties: a.length > 0 ? a.map((u)=>[
                                u.name,
                                u.value
                            ]) : void 0,
                        tooltipText: l
                    }
                }
            }), this;
        };
        this.debugId = e;
    }
    static create(e) {
        return new o(e);
    }
    get startTimestamp() {
        return this.markerDetails.startTs;
    }
    get track() {
        let e = this;
        return Object.keys($88ab1a78ec8ca4b4$var$Ko).reduce((t, n)=>{
            let r = {
                start: e.start,
                end: (i)=>e.end({
                        ...i,
                        track: $88ab1a78ec8ca4b4$var$Ko[n].track,
                        label: i.label
                    }),
                get label () {
                    let i = $88ab1a78ec8ca4b4$var$Ko[n];
                    return Object.keys(i.labels).reduce((a, l)=>{
                        let s = {
                            start: e.start,
                            end: (c)=>e.end({
                                    ...c,
                                    track: i.track,
                                    label: i.labels[l]
                                })
                        };
                        return Object.defineProperty(a, l, {
                            get: ()=>(e.markerDetails.label = i.labels[l], s)
                        }), a;
                    }, {});
                }
            };
            return Object.defineProperty(t, n, {
                get: ()=>{
                    let i = $88ab1a78ec8ca4b4$var$Ko[n];
                    return e.markerDetails.track = i.track, r;
                }
            }), t;
        }, {});
    }
};
function $88ab1a78ec8ca4b4$var$qe(o) {
    return $88ab1a78ec8ca4b4$var$Na.create(o);
}
var $88ab1a78ec8ca4b4$var$Qh = (o, e, t)=>{
    let n = o[e];
    typeof n == "function" && n(...t);
}, $88ab1a78ec8ca4b4$var$La;
function $88ab1a78ec8ca4b4$var$cc() {
    return $88ab1a78ec8ca4b4$var$La || ($88ab1a78ec8ca4b4$var$La = (0, $acw62.createContext)(null));
}
function $88ab1a78ec8ca4b4$var$Jh(o, e, t, n, r, i, a) {
    let l = e();
    return Object.keys(l).reduce((s, c)=>{
        let u = c;
        return Object.defineProperty(s, c, {
            set: (f)=>{
                let p = t(), m = e(), g = m[u], b = !0;
                if (i && typeof i[u] == "function" && i[u](f, {
                    actions: s,
                    state: m
                }) === !1 && (b = !1), b) {
                    let S = [
                        f
                    ], C = `on${$88ab1a78ec8ca4b4$var$_a(c)}Change`;
                    if (a && a[u]) {
                        let T = a[u](f, m);
                        C = T.callbackName || C, S = T.callbackParams;
                    }
                    $88ab1a78ec8ca4b4$var$Qh(p, C, S);
                }
                let h = n[u];
                typeof h == "function" && (f = h(f));
                let y = !!r?.[u];
                $88ab1a78ec8ca4b4$var$ln(c, p) && !y || o({
                    payload: {
                        updatedProps: null,
                        mappedState: {
                            [c]: f
                        }
                    }
                });
            }
        }), s;
    }, {});
}
function $88ab1a78ec8ca4b4$var$eb(o, e, t) {
    let n = {};
    for(let r in o)if (o.hasOwnProperty(r)) {
        let i = o[r], a = $88ab1a78ec8ca4b4$var$ln(r, e) ? e[r] : e[`default${$88ab1a78ec8ca4b4$var$_a(r)}`];
        typeof i == "function" && (a = i(a, t)), n[r] = a;
    }
    return n;
}
function $88ab1a78ec8ca4b4$export$c6a0e0787a01a4e5(o) {
    let e = o.getParentState || (()=>null);
    function t(r) {
        let [i] = (0, $acw62.useState)(()=>o.initSetupState ? o.initSetupState(r) : {}), a = (0, $acw62.useRef)(new Set), l = (0, $acw62.useMemo)(()=>o.forwardProps ? o.forwardProps(i, r) : {}, [
            i
        ]), s = e(), c = $88ab1a78ec8ca4b4$var$Me(s);
        function u() {
            let v = {};
            l && (v = $88ab1a78ec8ca4b4$var$eb(l, r, i));
            let R = {
                ...i,
                ...v
            };
            if (o.mapPropsToState) {
                let { fn: x, propertyReads: M } = $88ab1a78ec8ca4b4$var$Aa(o.mapPropsToState, {
                    getProxyTargetFromArgs: (E)=>E.props,
                    putProxyToArgs: (E, P)=>[
                            {
                                ...P,
                                props: E
                            }
                        ]
                }), A = x({
                    props: r,
                    state: R,
                    oldState: null,
                    parentState: s
                });
                return a.current = new Set([
                    ...a.current,
                    ...M
                ]), {
                    ...R,
                    ...A
                };
            }
            return R;
        }
        let [d] = (0, $acw62.useState)(u), f = $88ab1a78ec8ca4b4$var$Me(r), p = (v, R)=>{
            if (R.type === "REPLACE_STATE") return R.payload;
            let x = c?.() ?? null, M = R.payload.mappedState, A = R.payload.updatedPropsToState, E = {
                ...v
            };
            if (M && Object.assign(E, M), o.mapPropsToState) {
                let { fn: _, propertyReads: D } = $88ab1a78ec8ca4b4$var$Aa(o.mapPropsToState, {
                    getProxyTargetFromArgs: (F)=>F.props,
                    putProxyToArgs: (F, W)=>[
                            {
                                ...W,
                                props: F
                            }
                        ]
                }), O = _({
                    props: f(),
                    state: E,
                    oldState: v,
                    parentState: x
                });
                a.current = new Set([
                    ...a.current,
                    ...D
                ]), Object.assign(E, O);
            }
            return R.type === "ASSIGN_STATE" && Object.assign(E, R.payload), o.concludeReducer ? o.concludeReducer({
                previousState: v,
                state: E,
                updatedProps: A,
                parentState: x
            }) : E;
        }, [m, g] = (0, $acw62.useReducer)(p, d), b = $88ab1a78ec8ca4b4$var$Me(m), { allowedControlledPropOverrides: h } = o, y = (0, $acw62.useMemo)(()=>$88ab1a78ec8ca4b4$var$Jh(g, b, f, l, h, o.interceptActions, o.mappedCallbacks), [
            g,
            l,
            h
        ]), S = o.Context ?? $88ab1a78ec8ca4b4$var$cc(), C = (0, $acw62.useMemo)(()=>({
                componentState: m,
                componentActions: y,
                getComponentState: b,
                replaceState: (v)=>{
                    g({
                        type: "REPLACE_STATE",
                        payload: v
                    });
                },
                assignState: (v)=>{
                    g({
                        type: "ASSIGN_STATE",
                        payload: v
                    });
                }
            }), [
            m,
            y,
            b
        ]), T = $88ab1a78ec8ca4b4$export$5cae361ad82dce8b(r), I = (0, $acw62.useRef)(!1);
        I.current = !1;
        let w = o.layoutEffect ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
        return w(()=>{
            let v = r, R = {}, x = 0, M = {}, A = 0, E = {}, P = 0;
            if (new Set([
                ...Object.keys(v),
                ...Object.keys(T)
            ]).forEach((O)=>{
                let F = O, W = T[F], z = v[F];
                if (F !== "children" && W !== z && (E[F] = {
                    newValue: z,
                    oldValue: W
                }, P++, $88ab1a78ec8ca4b4$var$ln(F, r) || $88ab1a78ec8ca4b4$var$ln(F, T))) {
                    if (l.hasOwnProperty(O)) {
                        let L = z, ae = l[O];
                        typeof ae == "function" && (L = ae(z)), m[F] !== L && (R[F] = L, x++);
                    } else a.current.has(O) && (M[F] = v[F], A++);
                }
            }), A > 0 || x > 0) {
                let O = m.debugId, F = O ? $88ab1a78ec8ca4b4$var$qe(O).track.ComponentState.label.PropUpdate.start() : void 0, W = o.debugName ? typeof o.debugName == "function" ? `${o.debugName(v)}:rerender` : `${o.debugName}:rerender` : "rerender";
                $88ab1a78ec8ca4b4$var$St(W)("Triggered by new values for the following props", ...Object.keys(R ?? {}), ...Object.keys(M ?? {})), F && F.end({
                    label: W,
                    details: [
                        x > 0 ? {
                            name: "Updated properties",
                            value: Object.keys(R).join(", ")
                        } : void 0,
                        A > 0 ? {
                            name: "Updated props",
                            value: Object.keys(M).join(", ")
                        } : void 0,
                        A > 0 || M ? {
                            name: "Details",
                            value: "The time for this marker is not accurate. The marker is only displayed so you can easily identify the props that triggered the rerender."
                        } : void 0
                    ].filter($88ab1a78ec8ca4b4$var$an)
                });
                let L = {
                    payload: {
                        mappedState: x ? R : null,
                        updatedPropsToState: A ? M : null
                    }
                };
                if (I.current = !0, g(L), o.onPropChange) {
                    for(var D in E)if (E.hasOwnProperty(D)) {
                        let { newValue: ae, oldValue: te } = E[D];
                        o.onPropChange({
                            name: D,
                            newValue: ae,
                            oldValue: te
                        }, r, y, m);
                    }
                }
                o.onPropsChange && P && o.onPropsChange(E, r, y, m);
            }
        }), w(()=>{
            s != null && !I.current && g({
                type: "PARENT_STATE_CHANGE",
                payload: {}
            });
        }, [
            s
        ]), $88ab1a78ec8ca4b4$var$ac(()=>()=>{
                o.cleanup?.(b());
            }), {
            contextValue: C,
            ContextComponent: S
        };
    }
    return {
        ManagedComponentContextProvider: $acw62.memo(function(i) {
            let { contextValue: a, ContextComponent: l } = t(i);
            return $acw62.createElement(l.Provider, {
                value: a
            }, i.children);
        }),
        useManagedComponent: t
    };
}
function $88ab1a78ec8ca4b4$export$2e1456d250441a8(o) {
    return o = o ?? $88ab1a78ec8ca4b4$var$cc(), $acw62.useContext(o);
}
var $88ab1a78ec8ca4b4$var$rt = "Infinite", $88ab1a78ec8ca4b4$var$Fe = {
    rootClassName: $88ab1a78ec8ca4b4$var$rt
};
var $88ab1a78ec8ca4b4$var$Ar = ()=>$88ab1a78ec8ca4b4$var$Fe;
var $88ab1a78ec8ca4b4$var$uc = "_16lm1iw2 _16lm1iw23 _16lm1iw26 _16lm1iw2c _16lm1iw2a", $88ab1a78ec8ca4b4$var$dc = {
    center: "_16lm1iw2j",
    stretch: "_16lm1iw2k",
    start: "_16lm1iw2l",
    end: "_16lm1iw2m"
};
var $88ab1a78ec8ca4b4$var$Lt = "_16lm1iw3b _16lm1iw3c _16lm1iw35", $88ab1a78ec8ca4b4$var$fc = {
    pointer: "_16lm1iwk",
    default: "_16lm1iwl",
    colResize: "_16lm1iwm",
    grabbing: "_16lm1iwn",
    grab: "_16lm1iwo"
}, $88ab1a78ec8ca4b4$var$Zn = {
    flex: "_16lm1iw1p",
    contents: "_16lm1iw1q",
    none: "_16lm1iw1r",
    block: "_16lm1iw1s",
    grid: "_16lm1iw1t",
    inlineBlock: "_16lm1iw1u",
    inlineFlex: "_16lm1iw1v",
    inlineGrid: "_16lm1iw1w"
};
var $88ab1a78ec8ca4b4$var$_r = {
    1: "_16lm1iw1c",
    none: "_16lm1iw1d"
}, $88ab1a78ec8ca4b4$var$Bo = {
    column: "_16lm1iw2f",
    columnReverse: "_16lm1iw2g",
    row: "_16lm1iw2h",
    rowReverse: "_16lm1iw2i"
};
var $88ab1a78ec8ca4b4$var$pc = {
    0: "_16lm1iw1y",
    "100%": "_16lm1iw1z",
    "50%": "_16lm1iw20"
}, $88ab1a78ec8ca4b4$var$mc = {
    center: "_16lm1iw30",
    spaceBetween: "_16lm1iw31",
    spaceAround: "_16lm1iw32",
    start: "_16lm1iw33",
    end: "_16lm1iw34"
}, $88ab1a78ec8ca4b4$var$gc = {
    0: "_16lm1iw26",
    "100%": "_16lm1iw27",
    "50%": "_16lm1iw28",
    auto: "_16lm1iw29"
};
var $88ab1a78ec8ca4b4$var$hc = {
    none: "_16lm1iwd"
}, $88ab1a78ec8ca4b4$var$bc = {
    hidden: "_16lm1iw35",
    auto: "_16lm1iw36",
    visible: "_16lm1iw37"
};
var $88ab1a78ec8ca4b4$var$Or = {
    relative: "_16lm1iw1",
    absolute: "_16lm1iw2",
    static: "_16lm1iw3",
    sticky: "_16lm1iw4",
    fixed: "_16lm1iw5"
};
var $88ab1a78ec8ca4b4$var$yc = {
    0: "_16lm1iw23",
    "100%": "_16lm1iw24",
    "50%": "_16lm1iw25"
};
var $88ab1a78ec8ca4b4$var$Tc = {
    none: "_16lm1iw1x"
};
var $88ab1a78ec8ca4b4$var$Sc = {
    visible: "_16lm1iw38",
    hidden: "_16lm1iw39"
};
var $88ab1a78ec8ca4b4$var$Cc = {
    1: "_16lm1iw1e",
    10: "_16lm1iw1f",
    100: "_16lm1iw1g",
    1e3: "_16lm1iw1h",
    1e4: "_16lm1iw1i",
    1e5: "_16lm1iw1j",
    1e6: "_16lm1iw1k",
    1e7: "_16lm1iw1l",
    "1k": "_16lm1iw1m",
    "10k": "_16lm1iw1n",
    "100k": "_16lm1iw1o"
};
function $88ab1a78ec8ca4b4$var$Ic(o) {
    let { rootClassName: e } = $88ab1a78ec8ca4b4$var$Ar();
    return $acw62.createElement("div", {
        ...o,
        className: $88ab1a78ec8ca4b4$var$X(`${e}Footer`, $88ab1a78ec8ca4b4$var$Or.relative, $88ab1a78ec8ca4b4$var$Zn.flex, $88ab1a78ec8ca4b4$var$Bo.row, o.className)
    });
}
function $88ab1a78ec8ca4b4$var$Nr(o) {
    let e = {};
    return Object.keys(o).forEach((t)=>{
        e[t] = t;
    }), e;
}
function $88ab1a78ec8ca4b4$var$Y(o) {
    return o.slice(4, -1);
}
var $88ab1a78ec8ca4b4$var$Le = (o)=>{
    let e = o.size ?? "var(--infinite-icon-size)", t = {
        flex: "none",
        width: e,
        height: e,
        fill: "currentColor",
        ...o.style
    };
    return $acw62.createElement("svg", {
        viewBox: "0 0 24 24",
        ...o,
        style: t
    }, o.children);
};
var $88ab1a78ec8ca4b4$var$Rc = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o
    }, $acw62.createElement("path", {
        d: "M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4H11.14M12 6.29L14.03 11.71H9.96L12 6.29"
    }), $acw62.createElement("path", {
        d: "M4 18V15H2V20H22V18Z"
    }), $acw62.createElement("path", {
        d: "M20 14V18H2V20H22V14Z"
    }));
var $88ab1a78ec8ca4b4$var$xc = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o
    }, $acw62.createElement("path", {
        d: "M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4M12 6.29L14.03 11.71H9.96M20 14V18H2V20H22V14Z"
    }));
var $88ab1a78ec8ca4b4$var$Va = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o
    }, $acw62.createElement("path", {
        d: "M19,10H5V8H19V10M19,16H5V14H19V16Z"
    }));
var $88ab1a78ec8ca4b4$var$Pc = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o
    }, $acw62.createElement("path", {
        d: "M6.5,2.27L20,10.14L6.5,18L5.5,16.27L16.03,10.14L5.5,4L6.5,2.27M20,20V22H5V20H20Z"
    }));
var $88ab1a78ec8ca4b4$var$Dc = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o
    }, $acw62.createElement("path", {
        d: "M5.5,4.14L4.5,5.86L15,12L4.5,18.14L5.5,19.86L19,12L5.5,4.14Z"
    }));
var $88ab1a78ec8ca4b4$var$Mc = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o
    }, $acw62.createElement("path", {
        d: "M18.5,2.27L5,10.14L18.5,18L19.5,16.27L8.97,10.14L19.5,4L18.5,2.27M5,20V22H20V20H5Z"
    }));
var $88ab1a78ec8ca4b4$var$Ec = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o
    }, $acw62.createElement("path", {
        d: "M18.5,4.14L19.5,5.86L8.97,12L19.5,18.14L18.5,19.86L5,12L18.5,4.14Z"
    }));
var $88ab1a78ec8ca4b4$var$Ac = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o
    }, $acw62.createElement("path", {
        d: "M21,10H9V8H21V10M21,16H9V14H21V16M4,5H6V16H4V5M6,18V20H4V18H6Z"
    }));
var $88ab1a78ec8ca4b4$var$_c = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o
    }, $acw62.createElement("path", {
        d: "M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4M12 6.29L14.03 11.71H9.96M4 18V15H2V20H22V18Z"
    }));
var $88ab1a78ec8ca4b4$var$$a;
function $88ab1a78ec8ca4b4$var$Qn() {
    return $88ab1a78ec8ca4b4$var$$a || ($88ab1a78ec8ca4b4$var$$a = (0, $acw62.createContext)(null));
}
var $88ab1a78ec8ca4b4$var$Q = ()=>{
    let o = $88ab1a78ec8ca4b4$var$Qn();
    return (0, $acw62.useContext)(o);
};
var $88ab1a78ec8ca4b4$var$Oc = ()=>{
    let o = $88ab1a78ec8ca4b4$var$Qn(), { state: e } = (0, $acw62.useContext)(o);
    return e;
};
function $88ab1a78ec8ca4b4$var$rb(o, e) {
    if (typeof o != "object" || !o) return o;
    var t = o[Symbol.toPrimitive];
    if (t !== void 0) {
        var n = t.call(o, e || "default");
        if (typeof n != "object") return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (e === "string" ? String : Number)(o);
}
function $88ab1a78ec8ca4b4$var$ib(o) {
    var e = $88ab1a78ec8ca4b4$var$rb(o, "string");
    return typeof e == "symbol" ? e : String(e);
}
function $88ab1a78ec8ca4b4$var$ab(o, e, t) {
    return e = $88ab1a78ec8ca4b4$var$ib(e), e in o ? Object.defineProperty(o, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : o[e] = t, o;
}
function $88ab1a78ec8ca4b4$var$Nc(o, e) {
    var t = Object.keys(o);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(o);
        e && (n = n.filter(function(r) {
            return Object.getOwnPropertyDescriptor(o, r).enumerable;
        })), t.push.apply(t, n);
    }
    return t;
}
function $88ab1a78ec8ca4b4$var$Fc(o) {
    for(var e = 1; e < arguments.length; e++){
        var t = arguments[e] != null ? arguments[e] : {};
        e % 2 ? $88ab1a78ec8ca4b4$var$Nc(Object(t), !0).forEach(function(n) {
            $88ab1a78ec8ca4b4$var$ab(o, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(t)) : $88ab1a78ec8ca4b4$var$Nc(Object(t)).forEach(function(n) {
            Object.defineProperty(o, n, Object.getOwnPropertyDescriptor(t, n));
        });
    }
    return o;
}
function $88ab1a78ec8ca4b4$var$Lc(o, e) {
    var t = {};
    for(var n in o)t[n] = e(o[n], n);
    return t;
}
var $88ab1a78ec8ca4b4$var$lb = (o, e, t)=>{
    for (var n of Object.keys(o)){
        var r;
        if (o[n] !== ((r = e[n]) !== null && r !== void 0 ? r : t[n])) return !1;
    }
    return !0;
}, $88ab1a78ec8ca4b4$var$fe = (o)=>{
    var e = (t)=>{
        var n = o.defaultClassName, r = $88ab1a78ec8ca4b4$var$Fc($88ab1a78ec8ca4b4$var$Fc({}, o.defaultVariants), t);
        for(var i in r){
            var a, l = (a = r[i]) !== null && a !== void 0 ? a : o.defaultVariants[i];
            if (l != null) {
                var s = l;
                typeof s == "boolean" && (s = s === !0 ? "true" : "false");
                var c = o.variantClassNames[i][s];
                c && (n += " " + c);
            }
        }
        for (var [u, d] of o.compoundVariants)$88ab1a78ec8ca4b4$var$lb(u, r, o.defaultVariants) && (n += " " + d);
        return n;
    };
    return e.variants = ()=>Object.keys(o.variantClassNames), e.classNames = {
        get base () {
            return o.defaultClassName.split(" ")[0];
        },
        get variants () {
            return $88ab1a78ec8ca4b4$var$Lc(o.variantClassNames, (t)=>$88ab1a78ec8ca4b4$var$Lc(t, (n)=>n.split(" ")[0]));
        }
    }, e;
};
var $88ab1a78ec8ca4b4$var$kc = "_1eexc2a6";
var $88ab1a78ec8ca4b4$var$zc = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_12zfob12c _16lm1iw1z _16lm1iw22 _16lm1iw1p _16lm1iw2h _16lm1iw2j _16lm1iw33",
    variantClassNames: {
        filtered: {
            false: "_12zfob12d",
            true: "_12zfob12e"
        },
        verticalAlign: {
            start: "_12zfob12f",
            end: "_12zfob12g",
            center: "_12zfob12h"
        },
        align: {
            start: "_12zfob12i",
            end: "_12zfob12j",
            center: "_12zfob12k"
        }
    },
    defaultVariants: {},
    compoundVariants: []
}), $88ab1a78ec8ca4b4$var$Vc = "_12zfob1q _16lm1iw2 _16lm1iw1k _16lm1iw3b _16lm1iw3c _16lm1iw35", $88ab1a78ec8ca4b4$var$Gc = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_16lm1iw2 _16lm1iw25 _16lm1iw26 _16lm1iwh _16lm1iwf",
    variantClassNames: {
        visible: {
            true: "_12zfob19",
            false: "_12zfob1a"
        }
    },
    defaultVariants: {},
    compoundVariants: []
}), $88ab1a78ec8ca4b4$var$Hc = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_12zfob1r",
    variantClassNames: {
        rowActive: {
            false: "_12zfob1s",
            true: "_12zfob1t"
        },
        cellSelected: {
            false: "_12zfob1u",
            true: "_12zfob1v"
        },
        rowSelected: {
            false: "_12zfob1w",
            true: "_12zfob1x",
            null: "_12zfob1y"
        },
        rowDisabled: {
            false: "_12zfob1z",
            true: "_12zfob110"
        },
        firstRow: {
            false: "_12zfob111",
            true: "_12zfob112"
        },
        treeNode: {
            parent: "_12zfob113",
            leaf: "_12zfob114",
            false: "_12zfob115"
        },
        firstRowInHorizontalLayoutPage: {
            false: "_12zfob116",
            true: "_12zfob117"
        },
        groupRow: {
            false: "_12zfob118",
            true: "_12zfob119"
        },
        groupCell: {
            false: "_12zfob11a",
            true: "_12zfob11b"
        },
        align: {
            start: "_12zfob11c",
            end: "_12zfob11d",
            center: "_12zfob11e"
        },
        verticalAlign: {
            start: "_12zfob11f",
            end: "_12zfob11g",
            center: "_12zfob11h"
        },
        zebra: {
            false: "_12zfob11i",
            even: "_12zfob11j",
            odd: "_12zfob11k"
        },
        dragging: {
            true: "_12zfob11l",
            false: "_12zfob11m"
        },
        insideDisabledDraggingPage: {
            true: "_12zfob11n",
            false: "_12zfob11o"
        },
        first: {
            true: "_12zfob11p",
            false: "_12zfob11q"
        },
        last: {
            true: "_12zfob11r",
            false: "_12zfob11s"
        },
        groupByField: {
            true: "_12zfob11t",
            false: "_12zfob11u"
        },
        firstInCategory: {
            true: "_12zfob11v",
            false: "_12zfob11w"
        },
        lastInCategory: {
            true: "_12zfob11x",
            false: "_12zfob11y"
        },
        pinned: {
            start: "_12zfob11z",
            end: "_12zfob120",
            false: "_12zfob121"
        },
        filtered: {
            true: "_12zfob122",
            false: "_12zfob123"
        }
    },
    defaultVariants: {},
    compoundVariants: [
        [
            {
                pinned: "start",
                lastInCategory: !0
            },
            "_12zfob124"
        ],
        [
            {
                pinned: "end",
                firstInCategory: !0
            },
            "_12zfob125"
        ],
        [
            {
                pinned: !1,
                lastInCategory: !0
            },
            "_12zfob126"
        ]
    ]
}), $88ab1a78ec8ca4b4$var$Kc = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_12zfob1c _16lm1iw1s _16lm1iw2",
    variantClassNames: {
        pinned: {
            start: "_12zfob1d",
            end: "_12zfob1e",
            false: "_12zfob1f"
        },
        firstInCategory: {
            true: "_12zfob1g",
            false: "_12zfob1h"
        },
        lastInCategory: {
            true: "_12zfob1i",
            false: "_12zfob1j"
        },
        overflow: {
            true: "_12zfob1k",
            false: "_12zfob1l"
        }
    },
    defaultVariants: {},
    compoundVariants: [
        [
            {
                overflow: !0,
                pinned: "start"
            },
            "_12zfob1m"
        ],
        [
            {
                pinned: "start",
                firstInCategory: !0
            },
            "_12zfob1n"
        ],
        [
            {
                overflow: !0,
                pinned: "end"
            },
            "_12zfob1o"
        ],
        [
            {
                pinned: "end",
                lastInCategory: !0
            },
            "_12zfob1p"
        ]
    ]
}), $88ab1a78ec8ca4b4$var$Bc = "_12zfob12u _16lm1iw22 _16lm1iw1z";
var $88ab1a78ec8ca4b4$var$Wc = "_12zfob17", $88ab1a78ec8ca4b4$var$jc = "_12zfob12q _16lm1iw1p _16lm1iw2h _16lm1iw2j _16lm1iw1", $88ab1a78ec8ca4b4$var$$c = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_12zfob12r _16lm1iw1 _16lm1iw23",
    variantClassNames: {
        disabled: {
            true: "_12zfob12s",
            false: "_12zfob12t"
        }
    },
    defaultVariants: {},
    compoundVariants: []
}), $88ab1a78ec8ca4b4$var$Ua = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_12zfob12n _16lm1iw1p _16lm1iw2h _16lm1iw2k _16lm1iw1",
    variantClassNames: {
        active: {
            true: "_12zfob12o",
            false: "_12zfob12p"
        }
    },
    defaultVariants: {},
    compoundVariants: []
}), $88ab1a78ec8ca4b4$var$Uc = "_12zfob12m _16lm1iw1p _16lm1iw2h _16lm1iw2j", $88ab1a78ec8ca4b4$var$Yc = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_12zfob127 _16lm1iw1 _16lm1iw1p _16lm1iw2f _16lm1iw32 _16lm1iw39",
    variantClassNames: {
        menuVisible: {
            true: "_12zfob128"
        },
        reserveSpaceWhenHidden: {
            true: "_12zfob129",
            false: "_12zfob12a"
        }
    },
    defaultVariants: {},
    compoundVariants: [
        [
            {
                menuVisible: !0,
                reserveSpaceWhenHidden: !1
            },
            "_12zfob12b"
        ]
    ]
}), $88ab1a78ec8ca4b4$var$qc = "_12zfob1b _16lm1iw2", $88ab1a78ec8ca4b4$var$Xc = "_16lm1iw1", $88ab1a78ec8ca4b4$var$Zc = "_12zfob16", $88ab1a78ec8ca4b4$var$Qc = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_12zfob12",
    variantClassNames: {
        align: {
            start: "_12zfob13",
            center: "_12zfob14",
            end: "_12zfob15"
        }
    },
    defaultVariants: {},
    compoundVariants: []
}), $88ab1a78ec8ca4b4$var$Jc = "_12zfob12l _16lm1iw35 _16lm1iw1 _16lm1iw1p _16lm1iw2h";
var $88ab1a78ec8ca4b4$var$ft = "InfiniteIcon";
var $88ab1a78ec8ca4b4$var$eu = "_6aunoi0 _16lm1iw1p _16lm1iw2f _16lm1iw1 _16lm1iw32 _16lm1iw2j";
var $88ab1a78ec8ca4b4$var$ub = {
    transition: "width 0.25s, opacity 0.25s"
};
function $88ab1a78ec8ca4b4$var$eo(o) {
    let [e, t] = (0, $acw62.useState)(!0), [n, r] = (0, $acw62.useState)(0), { lineWidth: i = 1, style: a, className: l, index: s } = o, c = s != null && s > 0, u = o.size ?? 16, d = Math.floor(u / 4), f = [
        u - 1 * d,
        u - 2 * d,
        u - 3 * d
    ], p = {
        ...$88ab1a78ec8ca4b4$var$ub,
        borderTop: `${i}px solid currentColor`,
        ...o.lineStyle,
        opacity: n
    };
    if ((0, $acw62.useEffect)(()=>{
        if (!e) return;
        let g = requestAnimationFrame(()=>{
            r(1);
        });
        return ()=>{
            cancelAnimationFrame(g);
        };
    }, [
        e
    ]), (0, $acw62.useLayoutEffect)(()=>{
        t(!0);
    }, []), !e) return null;
    let m = {};
    return $acw62.createElement("div", {
        "data-name": "filter-icon",
        style: {
            ...a,
            width: u
        },
        className: $88ab1a78ec8ca4b4$var$X(l, $88ab1a78ec8ca4b4$var$ft, $88ab1a78ec8ca4b4$var$eu, `${$88ab1a78ec8ca4b4$var$ft}-filter`)
    }, c ? $acw62.createElement("div", {
        "data-name": "index",
        style: m,
        className: $88ab1a78ec8ca4b4$var$Wc
    }, s) : null, $acw62.createElement("div", {
        style: {
            width: f[0],
            ...p
        }
    }), $acw62.createElement("div", {
        style: {
            width: f[1],
            ...p
        }
    }), $acw62.createElement("div", {
        style: {
            width: f[2],
            ...p
        }
    }));
}
var $88ab1a78ec8ca4b4$var$Ya = (o)=>{
    let { availableSize: e, items: t, minSize: n, maxSize: r } = o;
    if (e < 0) throw "The provided availableSize cannot be negative!";
    let i = 0, a = 0, l = 0, s = [], c = [];
    t.forEach((w, v)=>{
        let R = w.maxSize ?? r ?? void 0, x = w.minSize ?? n ?? void 0;
        s.push(x), c.push(R), w.size != null && (R != null && w.size > R && (w.size = R), x != null && w.size < x && (w.size = x));
        let M = w.flex == 0 ? null : w.flex;
        if (w.size == null && M == null) throw `Items must specify either a size or a flex property. Item at index ${v} doesn't have either of those.`;
        M != null && (l += 1), a += M ?? 0, i += w.size ?? 0;
    });
    let u = o.computeSpecialSpaceDistribution ? Math.max(e, 0) : Math.max(e - i, 0), d = u / a, f = {}, p = {}, m = 0;
    t.forEach((w, v)=>{
        if (w.flex != null) {
            let R = d * w.flex, x = w.maxSize ?? r ?? void 0, M = w.minSize ?? n ?? void 0, A = !1, E = 0;
            x != null && R > x && (f[v] = !0, A = !0, E = x), M != null && R < M && (p[v] = !0, A = !0, E = M), A && (m += 1, l -= 1, a -= w.flex, u -= E);
        }
    }), m && (d = u / a);
    let g = [], b = 0, h = u, y = a, S = 0, C = 0, T = [];
    return {
        items: t.map((w, v)=>{
            let R = {
                ...w
            }, x = w.maxSize ?? r ?? void 0, M = w.minSize ?? n ?? void 0, A = 0, E = f[v], P = p[v], _ = E || P, D = w.size ?? 0;
            if (w.flex != null) {
                if (_) P && (A = M), E && (A = x);
                else {
                    b += 1;
                    let O = (F)=>(x != null && F > x && (F = x), M != null && F < M && (F = M), F);
                    b === l ? A = O(h) : (A = O(Math.round(w.flex * d)), C += A, h = u - C, y -= w.flex, d = h / y);
                }
                D = A, R.flexSize = A;
            }
            return g.push(A), T.push(D), R.computedSize = D, S += D, R;
        }),
        flexSizes: g,
        minSizes: s,
        maxSizes: c,
        computedSizes: T,
        remainingSize: Math.round(e - S)
    };
};
function $88ab1a78ec8ca4b4$var$Fr(o, e, t, n) {
    return e != null && o <= e ? {
        value: e,
        clamped: "min",
        diff: (o - e) * n
    } : t != null && o >= t ? {
        value: t,
        clamped: "max",
        diff: (t - o) * n
    } : {
        value: o,
        clamped: !1,
        diff: 0
    };
}
var $88ab1a78ec8ca4b4$var$qa = (o)=>{
    let { availableSize: e, reservedWidth: t = 0 } = o, n = Object.keys(o.columnSizing).reduce((x, M)=>(x[M] = {
            ...o.columnSizing[M]
        }, x), {});
    if (e < 0) throw "The provided availableSize cannot be negative!";
    let r = o.dragHandleOffset, i = o.dragHandlePositionAfter, a = o.dragHandlePositionAfter + 1, l = o.items[i], s = o.items[a], c = l.id, u = s?.id, d = l.computedWidth, f = l.computedMinWidth, p = l.computedMaxWidth, m = l.computedFlex ? "flex" : "width", g = s?.computedWidth, b = s?.computedMinWidth, h = s?.computedMaxWidth, y = s?.computedFlex ? "flex" : "width", S = !1, C = !1, T = r > 0 ? 1 : -1, { value: I, clamped: w, diff: v } = $88ab1a78ec8ca4b4$var$Fr(d + r, f, p, T);
    if (o.shareSpaceOnResize) {
        if (s == null) return n[c] = {
            ...n[c],
            [m]: I
        }, C = w === "min", S = w === "max", {
            adjustedDiff: I - d,
            reservedWidth: t,
            columnSizing: n,
            minReached: C,
            maxReached: S,
            constrained: C || S
        };
        let { value: x, clamped: M, diff: A } = $88ab1a78ec8ca4b4$var$Fr(g - r, b, h, T);
        if (w && M && (Math.abs(v) > Math.abs(A) ? M = !1 : w = !1), !(!w && !M)) {
            if (w) {
                let E = $88ab1a78ec8ca4b4$var$Fr(g - r - v, b, h, T);
                x = E.value, M = E.clamped, A = E.diff;
            } else if (M) {
                let E = $88ab1a78ec8ca4b4$var$Fr(d + r + A, f, p, T);
                I = E.value, w = E.clamped, v = E.diff;
            }
        }
        n[c] = {
            ...n[c],
            [m]: I
        }, n[u] = {
            ...n[u],
            [y]: x
        }, C = w === "min" || M === "min", S = w === "max" || M === "max";
    } else n[c] = {
        ...n[c],
        [m]: I
    }, C = w === "min", S = w === "max";
    let R = I - d;
    return {
        adjustedDiff: R,
        reservedWidth: o.shareSpaceOnResize ? t : t - R,
        columnSizing: n,
        minReached: C,
        maxReached: S,
        constrained: C || S
    };
};
function $88ab1a78ec8ca4b4$var$nu(o, e) {
    return o + e;
}
function $88ab1a78ec8ca4b4$var$db(o) {
    return Object.keys(o).reduce((t, n)=>(t[n] = {
            ...o[n]
        }, t), {});
}
var $88ab1a78ec8ca4b4$var$ou = (o)=>{
    let { availableSize: e, reservedWidth: t = 0 } = o, n = Object.keys(o.columnSizing).reduce((h, y)=>(h[y] = {
            ...o.columnSizing[y]
        }, h), {});
    if (e < 0) throw "The provided availableSize cannot be negative!";
    let r = o.dragHandleOffset, i = [
        ...new Array(o.columnGroupSize)
    ].map((h, y)=>o.dragHandlePositionAfter - y).reverse(), a = i.map((h)=>o.items[h]), l = a.map((h)=>h.computedWidth), s = a.map((h)=>h.computedFlex ? "flex" : "width"), c = 0, { computedSizes: u } = $88ab1a78ec8ca4b4$var$Ya({
        items: a.map((h)=>(h.resizable === !1 && (c += h.computedWidth), {
                maxSize: h.computedMaxWidth,
                minSize: h.computedMinWidth,
                flex: h.resizable ? h.computedWidth : null,
                size: 0
            })),
        computeSpecialSpaceDistribution: !0,
        availableSize: Math.max(l.reduce($88ab1a78ec8ca4b4$var$nu, 0) + r - c, 0)
    }), d = a.map((h, y)=>u[y] - h.computedWidth), f = !0, p = !0, m = !0, g = [];
    d.forEach((h, y)=>{
        let S = a[y];
        if (!S.resizable) {
            g.push(0);
            return;
        }
        let C = s[y], T = l[y], I = $88ab1a78ec8ca4b4$var$db(n), { maxReached: w, minReached: v, constrained: R, adjustedDiff: x } = $88ab1a78ec8ca4b4$var$qa({
            availableSize: o.availableSize,
            reservedWidth: o.reservedWidth,
            dragHandleOffset: h,
            dragHandlePositionAfter: i[y],
            shareSpaceOnResize: !1,
            items: o.items,
            columnSizing: I
        });
        n[S.id] = {
            ...I[S.id],
            [C]: T + x
        }, g.push(x), w || (p = !1), v || (f = !1), R || (m = !1);
    });
    let b = g.reduce($88ab1a78ec8ca4b4$var$nu, 0);
    return {
        minReached: f,
        maxReached: p,
        constrained: m,
        adjustedDiffs: g,
        adjustedDiff: b,
        columnSizing: n,
        reservedWidth: t - b
    };
};
var $88ab1a78ec8ca4b4$var$Lr;
function $88ab1a78ec8ca4b4$var$sn() {
    if ($88ab1a78ec8ca4b4$var$Lr != null) return $88ab1a78ec8ca4b4$var$Lr;
    let o = $88ab1a78ec8ca4b4$var$Re().document ?? null;
    if (!o) return 0;
    let e = o.createElement("div");
    e.style.visibility = "hidden", e.style.overflow = "scroll", o.body.appendChild(e);
    let t = o.createElement("div");
    return e.appendChild(t), $88ab1a78ec8ca4b4$var$Lr = e.offsetWidth - t.offsetWidth, e.parentNode?.removeChild(e), $88ab1a78ec8ca4b4$var$Lr;
}
var $88ab1a78ec8ca4b4$var$ru = [
    "start",
    void 0,
    "end"
], $88ab1a78ec8ca4b4$var$iu = (o, e)=>(e && Object.keys(e).length > 0 && o.sort((t, n)=>{
        let r = e[t], i = e[n];
        return r === !0 && (r = "start"), i === !0 && (i = "start"), r == i ? 0 : $88ab1a78ec8ca4b4$var$ru.indexOf(r) - $88ab1a78ec8ca4b4$var$ru.indexOf(i);
    }), o);
function $88ab1a78ec8ca4b4$var$au(o, e, ...t) {
    let n = e;
    return t.forEach((r)=>{
        for(let i in r)r.hasOwnProperty(i) && o(r[i], i) && (n[i] = r[i]);
    }), n;
}
function $88ab1a78ec8ca4b4$var$Xa(o, ...e) {
    return $88ab1a78ec8ca4b4$var$au((t)=>t != null, o, ...e);
}
function $88ab1a78ec8ca4b4$var$lu(o, e, ...t) {
    return $88ab1a78ec8ca4b4$var$au((n, r)=>!(r in o), e, ...t);
}
var $88ab1a78ec8ca4b4$var$kr = Object.freeze({}), $88ab1a78ec8ca4b4$var$fb = {
    string: $88ab1a78ec8ca4b4$var$kr,
    number: {}
};
function $88ab1a78ec8ca4b4$var$Za(o, e) {
    let t = e.default || $88ab1a78ec8ca4b4$var$kr;
    return o.type === void 0 ? t : o.type === null ? $88ab1a78ec8ca4b4$var$kr : typeof o.type == "string" ? e[o.type] || $88ab1a78ec8ca4b4$var$fb[o.type] || $88ab1a78ec8ca4b4$var$kr : o.type.reduce((n, r)=>Object.assign(n, e[r]), {});
}
var $88ab1a78ec8ca4b4$var$zr = !0, $88ab1a78ec8ca4b4$var$pb = !0, $88ab1a78ec8ca4b4$var$mb = !0, $88ab1a78ec8ca4b4$var$gb = "string", $88ab1a78ec8ca4b4$var$to = "unknown", $88ab1a78ec8ca4b4$var$hb = $88ab1a78ec8ca4b4$var$on("getComputedVisibleColumns"), $88ab1a78ec8ca4b4$var$bb = (o, e, t)=>o[t] !== !1, $88ab1a78ec8ca4b4$var$Qa = (o, e)=>{
    if (!e) return !1;
    let t = e[o];
    return t === "start" || t === !0 ? "start" : t === "end" ? "end" : !1;
}, $88ab1a78ec8ca4b4$var$su = ({ columns: o, bodySize: e, columnMinWidth: t, columnMaxWidth: n, columnDefaultWidth: r, columnDefaultFlex: i, scrollbarWidth: a, columnCssEllipsis: l, columnHeaderCssEllipsis: s, pinnedStartMaxWidth: c, pinnedEndMaxWidth: u, filterValue: d, sortable: f, sortInfo: p, multiSort: m, filterTypes: g = $88ab1a78ec8ca4b4$export$c41ade90600bede4, viewportReservedWidth: b, resizableColumns: h, draggableColumns: y, columnDefaultDraggable: S, columnOrder: C, columnPinning: T, editable: I, columnDefaultEditable: w, columnDefaultFilterable: v, columnDefaultGroupable: R, columnDefaultSortable: x, columnSizing: M, columnTypes: A, columnVisibility: E, columnVisibilityAssumeVisible: P, groupBy: _ })=>{
    let D = 0, O = {};
    _.forEach((V, ne)=>{
        V.field && (O[V.field] = ne);
    });
    let F = (d || []).reduce((V, ne)=>{
        let { id: ie, field: be } = ne;
        return be && (V[be] = ne), ie && (V[ie] = ne), V;
    }, {}), W = $88ab1a78ec8ca4b4$var$iu(C === !0 ? Object.keys(o) : C, T), z = W.filter((V)=>o[V] ? $88ab1a78ec8ca4b4$var$bb(E, P, V) : ($88ab1a78ec8ca4b4$var$hb(`Column with id "${V}" specified in columnOrder array cannot be found in the columns map.`), !1)), L = new Map, ae = z.map((V, ne)=>{
        let ie = o[V];
        return L.set(V, ne), ie;
    }), te = (p ?? []).reduce((V, ne, ie)=>(ne.id ? V[ne.id] = {
            sortInfo: ne,
            index: ie
        } : ne.field && (V[ne.field] = {
            sortInfo: ne,
            index: ie
        }), V), {});
    function B(V) {
        let ne = o[V], ie = $88ab1a78ec8ca4b4$var$Za(ne, A), be = {
            minWidth: ie?.minWidth,
            maxWidth: ie?.maxWidth,
            width: ie?.defaultWidth,
            flex: ie?.defaultFlex
        }, je = $88ab1a78ec8ca4b4$var$Xa({
            width: ne?.defaultWidth,
            flex: ne?.defaultFlex,
            minWidth: ne?.minWidth,
            maxWidth: ne?.maxWidth
        }, M[V]);
        je.width != null && delete be.flex, je.flex != null && delete be.width, je = $88ab1a78ec8ca4b4$var$Xa(be, je);
        let k = je.flex ?? void 0, Se = je.minWidth ?? ne?.minWidth ?? t, nn = je.maxWidth ?? ne?.maxWidth ?? n, Tt = k != null ? void 0 : je.width ?? (i ? void 0 : r);
        return !Tt && k == null && (i ? k = i : Tt = Se), {
            size: Tt,
            flex: k,
            minSize: Se,
            maxSize: nn
        };
    }
    let j = $88ab1a78ec8ca4b4$var$Ya({
        availableSize: Math.max(e.width - (b ?? 0) - (a ?? $88ab1a78ec8ca4b4$var$sn()), 0),
        maxSize: n,
        minSize: t,
        items: z.map(B)
    }), { computedSizes: oe, flexSizes: me, minSizes: pe, maxSizes: ce } = j, ue = [], ge = [], H = [], G = [];
    G.length = z.length;
    let q = new Map, K = new Map, re = 0, J = 0, de = 0, we = null, N1 = [], $ = 0, ee = 0, le = 0;
    ae.forEach((V, ne)=>{
        let ie = z[ne], be = oe[ne], je = N1[ne] = $88ab1a78ec8ca4b4$var$Qa(ie, T);
        je === "start" ? $ += be : je === "end" ? le += be : ee += be;
    });
    let De = e.width - le, Oe = [], Ne = new Map;
    z.forEach((V, ne)=>{
        let ie = ae[ne];
        Ne.set(V, ie);
    });
    let he = [];
    Object.keys(o).forEach((V)=>{
        let ne = o[V];
        he.push(V), Ne.has(V) || Ne.set(V, ne);
    });
    let Ke = new Map;
    Ne.forEach((V, ne)=>{
        let ie = L.get(ne);
        ie == null && (ie = -1);
        let be = ie != -1, je = z[ie + 1], k = $88ab1a78ec8ca4b4$var$Za(V, A), Se = ie, nn = te[ne] ? te[ne] : V.field ? te[V.field] ?? null : null, Tt = nn?.sortInfo ?? null, xt = !!Tt, Pt = xt && Tt.dir === 1, Eo = xt && !Pt, Ao = nn?.index ?? -1, Yn = be ? {} : B(ne), _o = be ? oe[ie] : Yn.size || 0, ga = be && me[ie] || null, ha = be ? pe[ie] || 0 : Yn.minSize || 0, ba = be ? ce[ie] || 1e4 : Yn.maxSize || 1e4, tt = be ? $88ab1a78ec8ca4b4$var$Qa(ne, T) : !1, Ir = be ? ie === z.length - 1 : !1, ve = Se, nt = be ? tt === "start" ? J : tt === "end" ? de : D - J : 0;
        tt == "start" ? ve = be ? Se : -1 : tt === "end" ? ve = be ? Se - (ue.length + H.length) : -1 : ve = be ? Se - ue.length : -1;
        let Kt = be ? tt === "start" || tt === !1 ? D : De + de : -1, Dt = be ? tt !== we : !1, Oo = be ? Ir || tt !== $88ab1a78ec8ca4b4$var$Qa(je, T) : !1, Ks = V.cssEllipsis ?? k.cssEllipsis ?? l, fh = V.headerCssEllipsis ?? k.cssEllipsis ?? V.cssEllipsis ?? k.headerCssEllipsis ?? s ?? Ks, vr = be && (F[ne] || V.field || V.groupByForColumn) && (F[ne] || F[V.field || V.groupByForColumn]) || null, ph = V.defaultFilterable ?? k.defaultFilterable ?? v ?? !0, mh = I ?? V.defaultEditable ?? k.defaultEditable ?? w ?? !1, ya = V.dataType || k.dataType || (Array.isArray(V.type) ? V.type[0] : V.type) || $88ab1a78ec8ca4b4$var$gb, gh = V.sortType || k.sortType || ya, Bs = V.filterType || k.filterType || ya, Ws = !1;
        if (vr != null && !vr.disabled) {
            let Ca = g[Bs];
            Ca && (!Ca.emptyValues || !Ca.emptyValues.includes(vr.filter.value)) && (Ws = !0);
        }
        let In = V.field ?? k.field, js = V.valueGetter ?? k.valueGetter, Ta = V.defaultGroupable ?? k.defaultGroupable ?? R ?? !!In;
        In || (Ta = !1), V.groupByForColumn && (Ta = !1);
        let Sa = V.defaultSortable ?? k.defaultSortable;
        Sa == null && !V.groupByForColumn && In == null && js == null && (Sa = !1);
        let $s = In ? O[In] !== void 0 : !1, hh = $s ? O[In] : void 0, bh = f ?? Sa ?? x ?? $88ab1a78ec8ca4b4$var$zr, yh = V.resizable ?? k.resizable ?? h ?? $88ab1a78ec8ca4b4$var$pb, $e = {
            colType: k,
            align: k.align,
            headerAlign: k.headerAlign,
            computedVisible: be,
            verticalAlign: k.verticalAlign,
            defaultHiddenWhenGroupedBy: k.defaultHiddenWhenGroupedBy,
            valueGetter: js,
            valueFormatter: k.valueFormatter,
            renderValue: k.renderValue,
            render: k.render,
            style: k.style,
            className: k.className,
            contentFocusable: k.contentFocusable,
            renderMenuIcon: k.renderMenuIcon,
            renderSortIcon: k.renderSortIcon,
            renderRowDetailIcon: k.renderRowDetailIcon,
            renderSelectionCheckBox: k.renderSelectionCheckBox,
            renderHeaderSelectionCheckBox: k.renderHeaderSelectionCheckBox,
            headerStyle: k.headerStyle,
            headerClassName: k.headerClassName,
            columnGroup: k.columnGroup,
            getValueToEdit: k.getValueToEdit,
            getValueToPersist: k.getValueToPersist,
            shouldAcceptEdit: k.shouldAcceptEdit,
            field: In,
            ...V,
            components: {
                ...k.components,
                ...V.components
            },
            computedResizable: yh,
            computedMinWidth: ha,
            computedMaxWidth: ba,
            computedFlex: ga,
            computedDataType: ya,
            computedEditable: mh,
            computedSortType: gh,
            computedFilterType: Bs,
            cssEllipsis: Ks,
            headerCssEllipsis: fh,
            computedFilterValue: vr,
            computedFiltered: Ws,
            computedFilterable: ph,
            computedGroupable: Ta,
            computedGroupedBy: $s,
            computedGroupedByIndex: hh,
            computedWidth: _o,
            computedAbsoluteOffset: Kt,
            computedPinningOffset: nt,
            computedVisibleIndexInCategory: ve,
            computedOffset: D,
            computedSortable: bh,
            computedSortInfo: Tt,
            computedSortIndex: Ao,
            computedMultiSort: m,
            computedSorted: xt,
            computedSortedAsc: Pt,
            computedSortedDesc: Eo,
            computedVisibleIndex: Se,
            computedPinned: tt,
            computedDraggable: y ?? V.defaultDraggable ?? S ?? $88ab1a78ec8ca4b4$var$mb,
            computedFirstInCategory: Dt,
            computedLastInCategory: Oo,
            computedFirst: ie === 0,
            computedLast: Ir,
            id: ne,
            header: V.header ?? k.header ?? V.name ?? V.field
        };
        be && (D += _o, q.set($e.id, $e), G[ie] = $e, tt === "start" && (ue.push($e), J += $e.computedWidth), tt === "end" && (ge.push($e), de += $e.computedWidth), tt || (H.push($e), re += $e.computedWidth), we = tt), $e.groupByForColumn && ($e.computedSortType = V.sortType || k.sortType || $88ab1a78ec8ca4b4$var$to, Oe.push($e)), K.set($e.id, $e), $e.field && !$e.groupByForColumn && !Ke.has($e.field) && Ke.set($e.field, $e);
    }), Oe.forEach((V)=>{
        V.computedSortable = $88ab1a78ec8ca4b4$var$cu(V, {
            fieldsToColumn: Ke,
            sortable: f,
            columnDefaultSortable: x
        });
    });
    let Be = new Map;
    he.forEach((V)=>{
        let ne = K.get(V);
        ne && Be.set(V, ne);
    }), K.forEach((V)=>{
        Be.has(V.id) || Be.set(V.id, V);
    });
    let dt = c != null ? Math.min(c, J) : J, Rt = u != null ? Math.min(u, de) : de;
    return {
        computedRemainingSpace: e.width - ($ + le + ee),
        computedPinnedStartColumnsWidth: J,
        computedPinnedEndColumnsWidth: de,
        computedUnpinnedColumnsWidth: re,
        computedColumnOrder: W,
        computedPinnedStartColumns: ue,
        computedPinnedEndColumns: ge,
        computedUnpinnedOffset: J,
        computedPinnedEndOffset: J + re,
        computedUnpinnedColumns: H,
        computedVisibleColumns: G,
        computedColumnsMap: K,
        computedColumnsMapInInitialOrder: Be,
        computedVisibleColumnsMap: q,
        computedPinnedEndWidth: Rt,
        computedPinnedStartWidth: dt,
        renderSelectionCheckBox: G.reduce((V, ne)=>V || !!ne.renderSelectionCheckBox, !1),
        fieldsToColumn: Ke
    };
};
function $88ab1a78ec8ca4b4$var$cu(o, e) {
    let { sortable: t, fieldsToColumn: n, columnDefaultSortable: r } = e;
    if (t) return t;
    let i = o.defaultSortable ?? o.colType.defaultSortable;
    if (i != null) return i;
    let a = r ?? $88ab1a78ec8ca4b4$var$zr;
    return o.computedSortType !== $88ab1a78ec8ca4b4$var$to && a ? !0 : (s)=>{
        let { column: c, api: u } = s, d = c.groupByForColumn || [];
        return d != null && !Array.isArray(d) && (d = [
            d
        ]), (d || []).reduce((f, p)=>{
            if (!f) return !1;
            let m = p.field || p.groupField, g;
            if (m) {
                let b = n.get(m), h = b ? u.getColumnApi(b.id) : void 0;
                b && h ? g = h.isSortable() : g = !1;
            }
            return g === void 0 && p.valueGetter && (g = !0), g ?? r ?? $88ab1a78ec8ca4b4$var$zr;
        }, !0);
    };
}
function $88ab1a78ec8ca4b4$var$it(o, e) {
    let { getComputed: t, getState: n, actions: r, api: i } = e;
    typeof o == "number" && (o = t().computedVisibleColumns[o]);
    let a = typeof o == "string" ? t().computedColumnsMap.get(o) : o;
    if (!a) return null;
    let l = {
        getCellValuesByPrimaryKey (s) {
            return e.api.getCellValues({
                columnId: a.id,
                primaryKey: s
            });
        },
        getCellValueByPrimaryKey (s) {
            return l.getCellValuesByPrimaryKey(s)?.value ?? null;
        },
        toggleContextMenu (s) {
            n().columnMenuVisibleForColumnId === a.id ? this.hideContextMenu() : this.showContextMenu(s);
        },
        toggleFilterOperatorMenu (s) {
            n().filterOperatorMenuVisibleForColumnId === a.id ? this.hideFilterOperatorMenu() : this.showFilterOperatorMenu(s);
        },
        showFilterOperatorMenu (s) {
            n().onFilterOperatorMenuClick({
                target: s,
                column: a
            });
        },
        hideFilterOperatorMenu () {
            i.hideFilterOperatorMenu();
        },
        showContextMenu (s) {
            n().onColumnMenuClick({
                target: s,
                column: a
            });
        },
        hideContextMenu () {
            r.columnMenuVisibleForColumnId = null;
        },
        isVisible () {
            return t().computedVisibleColumnsMap.has(a.id);
        },
        setVisible (s) {
            i.setVisibilityForColumn(a.id, s);
        },
        toggleSort (s = {
            multiSortBehavior: "replace"
        }) {
            return i.toggleSortingForColumn(a.id, s);
        },
        isSortable () {
            let { computedColumnsMap: s } = t();
            return typeof a.computedSortable == "function" ? a.computedSortable({
                api: i,
                columnApi: l,
                column: a,
                columns: s
            }) : a.computedSortable;
        },
        getSortDir () {
            return i.getSortingForColumn(a.id);
        },
        setFilter (s) {
            return i.setColumnFilter(a.id, s);
        },
        clearFilter () {
            return i.clearColumnFilter(a.id);
        },
        getSortInfo () {
            return i.getSortInfoForColumn(a.id);
        },
        setSort (s) {
            s ? i.setSortingForColumn(a.id, s) : i.setSortInfoForColumn(a.id, null);
        },
        clearSort () {
            this.setSort(null);
        }
    };
    return l;
}
function $88ab1a78ec8ca4b4$var$Pn(o, e, t) {
    let n = typeof o == "string" ? e.getComputed().computedColumnsMap.get(o) : o, { api: r, getComputed: i, getDataSourceState: a, actions: l, dataSourceActions: s, dataSourceApi: c } = e, u = a(), { allRowsSelected: d, someRowsSelected: f, selectionMode: p } = u, m = i(), g = n.header && typeof n.header != "function" ? n.header : n.name || n.id || "";
    if (typeof n.header == "function") {
        let b = $88ab1a78ec8ca4b4$var$it(n.id, {
            ...e,
            actions: l,
            dataSourceActions: s,
            dataSourceApi: c
        });
        g = n.header({
            horizontalLayoutPageIndex: null,
            column: n,
            columnApi: b,
            dataSourceApi: c,
            renderLocation: t,
            dragging: !1,
            columnsMap: m.computedColumnsMap,
            columnSortInfo: n.computedSortInfo,
            columnFilterValue: n.computedFilterValue,
            filtered: n.computedFiltered,
            allRowsSelected: d,
            someRowsSelected: f,
            selectionMode: p,
            api: r,
            renderBag: {
                header: g
            }
        }) ?? null;
    }
    return g;
}
var $88ab1a78ec8ca4b4$var$Vr = `${$88ab1a78ec8ca4b4$var$rt}HeaderCell__filter`, $88ab1a78ec8ca4b4$var$Ja = `${$88ab1a78ec8ca4b4$var$rt}HeaderCell__filterOperator`, $88ab1a78ec8ca4b4$var$el = $acw62.createContext(null);
var $88ab1a78ec8ca4b4$var$Tb = `${$88ab1a78ec8ca4b4$var$Vr}__input`, $88ab1a78ec8ca4b4$var$Gr = (o)=>o.stopPropagation();
function $88ab1a78ec8ca4b4$var$fu(o) {
    let { filterOperatorMenuVisibleForColumnId: e } = $88ab1a78ec8ca4b4$var$Oc(), { column: t } = $88ab1a78ec8ca4b4$export$cff1069d94cb1729(), n = o.filterEditor, r = o.filterOperatorSwitch, [i, a] = (0, $acw62.useState)(!1), l = $acw62.useCallback(()=>{
        a(!0);
    }, []), s = $acw62.useCallback(()=>{
        a(!1);
    }, []), c = e === t.id || i;
    return $acw62.createElement("div", {
        onPointerUp: $88ab1a78ec8ca4b4$var$Gr,
        onPointerDown: $88ab1a78ec8ca4b4$var$Gr,
        onFocus: l,
        onBlur: s,
        className: `${$88ab1a78ec8ca4b4$var$Vr} ${$88ab1a78ec8ca4b4$var$Ua({
            active: c
        })}`,
        style: {
            height: o.columnHeaderHeight
        }
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$el.Provider, {
        value: o
    }, $acw62.createElement(r, null), $acw62.createElement(n, null)));
}
function $88ab1a78ec8ca4b4$var$pu() {
    let { columnApi: o, disabled: e, operator: t } = $88ab1a78ec8ca4b4$export$23f34334c4af2266(), n = t?.components?.Icon ?? $88ab1a78ec8ca4b4$var$eo;
    return $acw62.createElement("div", {
        "data-name": "filter-operator",
        "data-disabled": e,
        onMouseDown: (r)=>{
            r.stopPropagation(), !e && o.toggleFilterOperatorMenu(r.target);
        },
        className: $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$Ja, $88ab1a78ec8ca4b4$var$jc, e ? `${$88ab1a78ec8ca4b4$var$Ja}--disabled` : "")
    }, $acw62.createElement(n, {
        size: 20,
        className: `${$88ab1a78ec8ca4b4$var$$c({
            disabled: e
        })}`
    }));
}
function $88ab1a78ec8ca4b4$var$mu() {
    return $acw62.createElement("div", {
        onPointerUp: $88ab1a78ec8ca4b4$var$Gr,
        onPointerDown: $88ab1a78ec8ca4b4$var$Gr,
        className: `${$88ab1a78ec8ca4b4$var$Vr} ${$88ab1a78ec8ca4b4$var$Ua({
            active: !1
        })} ${$88ab1a78ec8ca4b4$var$pc["50%"]}`
    });
}
function $88ab1a78ec8ca4b4$export$23f34334c4af2266() {
    let o = $88ab1a78ec8ca4b4$var$Q(), { column: e, columnApi: t } = $88ab1a78ec8ca4b4$export$cff1069d94cb1729(), n = $88ab1a78ec8ca4b4$var$Pn(e, o, "column-filter"), r = $acw62.useContext($88ab1a78ec8ca4b4$var$el), { columnFilterType: i, filterTypes: a, columnFilterValue: l } = r, s = a[i], [c, u] = (0, $acw62.useState)(l?.filter.value ?? ""), d = $acw62.useCallback((b)=>{
        u(b), r.onChange(b);
    }, [
        r.onChange
    ]), f = $acw62.useCallback(()=>{
        o.api.clearColumnFilter(e.id);
    }, [
        e.id
    ]), p = $acw62.useCallback(()=>{
        o.api.removeColumnFilter(e.id);
    }, [
        e.id
    ]);
    (0, $acw62.useEffect)(()=>{
        if (l) c !== l.filter.value && u(l.filter.value);
        else if (s) {
            let b = [
                ...s.emptyValues
            ][0];
            b !== c && u(b);
        }
    }, [
        l?.filter.value
    ]);
    let m = r.operator, g = m?.name;
    return {
        api: o.api,
        column: e,
        columnFilterValue: l,
        columnApi: t,
        operatorName: g,
        operator: m,
        value: c,
        disabled: l?.disabled,
        filterType: s,
        filterTypes: a,
        filterTypeKey: i,
        filtered: e.computedFiltered,
        setValue: d,
        clearValue: f,
        removeColumnFilter: p,
        ariaLabel: `Filter for ${n}`,
        className: `${$88ab1a78ec8ca4b4$var$Bc} ${$88ab1a78ec8ca4b4$var$Tb}`
    };
}
function $88ab1a78ec8ca4b4$var$no() {
    let { ariaLabel: o, value: e, setValue: t, className: n, disabled: r } = $88ab1a78ec8ca4b4$export$23f34334c4af2266();
    return $acw62.createElement("input", {
        "data-xxx": !0,
        "aria-label": o,
        type: "text",
        disabled: r,
        value: e,
        onChange: (i)=>{
            t(i.target.value);
        },
        className: n
    });
}
function $88ab1a78ec8ca4b4$var$Kr() {
    let { ariaLabel: o, value: e, setValue: t, className: n, disabled: r } = $88ab1a78ec8ca4b4$export$23f34334c4af2266();
    return $acw62.createElement("input", {
        "aria-label": o,
        type: "number",
        "data-yyy": !0,
        disabled: r,
        value: e ?? "",
        onChange: (i)=>{
            let a = isNaN(i.target.valueAsNumber) ? i.target.value : i.target.valueAsNumber;
            t(a);
        },
        className: n
    });
}
function $88ab1a78ec8ca4b4$var$Sb() {
    return {
        string: {
            label: "Text",
            emptyValues: [
                ""
            ],
            defaultOperator: "includes",
            components: {
                FilterEditor: $88ab1a78ec8ca4b4$var$no
            },
            operators: [
                {
                    name: "includes",
                    components: {
                        Icon: $88ab1a78ec8ca4b4$var$Rc
                    },
                    label: "Includes",
                    fn: ({ currentValue: e, filterValue: t })=>typeof e == "string" && typeof t == "string" && e.toLowerCase().includes(t.toLowerCase())
                },
                {
                    label: "Equals",
                    components: {
                        Icon: $88ab1a78ec8ca4b4$var$Va
                    },
                    name: "eq",
                    fn: ({ currentValue: e, filterValue: t })=>typeof e == "string" && e === t
                },
                {
                    name: "startsWith",
                    components: {
                        Icon: $88ab1a78ec8ca4b4$var$_c
                    },
                    label: "Starts With",
                    fn: ({ currentValue: e, filterValue: t })=>e.startsWith(t)
                },
                {
                    name: "endsWith",
                    components: {
                        Icon: $88ab1a78ec8ca4b4$var$xc
                    },
                    label: "Ends With",
                    fn: ({ currentValue: e, filterValue: t })=>e.endsWith(t)
                }
            ]
        },
        number: {
            label: "Number",
            emptyValues: [
                "",
                null,
                void 0
            ],
            defaultOperator: "eq",
            components: {
                FilterEditor: $88ab1a78ec8ca4b4$var$Kr
            },
            operators: [
                {
                    label: "Equals",
                    components: {
                        Icon: $88ab1a78ec8ca4b4$var$Va
                    },
                    name: "eq",
                    fn: ({ currentValue: e, filterValue: t })=>e == t
                },
                {
                    label: "Not Equals",
                    components: {
                        Icon: $88ab1a78ec8ca4b4$var$Ac
                    },
                    name: "neq",
                    fn: ({ currentValue: e, filterValue: t })=>e != t
                },
                {
                    name: "gt",
                    label: "Greater Than",
                    components: {
                        Icon: $88ab1a78ec8ca4b4$var$Dc
                    },
                    fn: ({ currentValue: e, filterValue: t, emptyValues: n })=>n.includes(e) ? !0 : e > t
                },
                {
                    name: "gte",
                    components: {
                        Icon: $88ab1a78ec8ca4b4$var$Pc
                    },
                    label: "Greater Than or Equal",
                    fn: ({ currentValue: e, filterValue: t, emptyValues: n })=>n.includes(e) ? !0 : e >= t
                },
                {
                    name: "lt",
                    components: {
                        Icon: $88ab1a78ec8ca4b4$var$Ec
                    },
                    label: "Less Than",
                    fn: ({ currentValue: e, filterValue: t, emptyValues: n })=>n.includes(e) ? !0 : e < t
                },
                {
                    name: "lte",
                    components: {
                        Icon: $88ab1a78ec8ca4b4$var$Mc
                    },
                    label: "Less Than or Equal",
                    fn: ({ currentValue: e, filterValue: t, emptyValues: n })=>n.includes(e) ? !0 : e <= t
                }
            ]
        }
    };
}
var $88ab1a78ec8ca4b4$export$c41ade90600bede4 = $88ab1a78ec8ca4b4$var$Sb();
function $88ab1a78ec8ca4b4$var$Br(o, e, t, n) {
    let r = [
        ...e
    ], i = {
        filtered: o.computedFiltered,
        first: o.computedFirst,
        last: o.computedLast,
        groupByField: !!o.groupByForColumn,
        firstInCategory: o.computedFirstInCategory,
        lastInCategory: o.computedLastInCategory,
        pinned: o.computedPinned || !1,
        cellSelected: n.cellSelected || !1,
        rowSelected: n.rowSelected ?? "null",
        rowActive: n.rowActive,
        dragging: n.dragging,
        insideDisabledDraggingPage: n.insideDisabledDraggingPage,
        firstRow: n.firstRow ?? !1,
        firstRowInHorizontalLayoutPage: n.firstRowInHorizontalLayoutPage ?? !1,
        rowDisabled: n.rowDisabled,
        groupRow: n.groupRow,
        groupCell: n.groupCell,
        treeNode: n.treeNode,
        verticalAlign: n.verticalAlign,
        align: n.align,
        zebra: n.zebra
    }, a = t(i);
    return r.push(a), o.computedFirst && r.push(...e.map((l)=>`${l}--first`)), o.groupByForColumn && r.push(...e.map((l)=>`${l}--group-column`)), o.computedLast && r.push(...e.map((l)=>`${l}--last`)), o.computedFirstInCategory && r.push(...e.map((l)=>`${l}--first-in-category`)), o.computedLastInCategory && r.push(...e.map((l)=>`${l}--last-in-category`)), n.rowSelected && r.push(...e.map((l)=>`${l}--row-selected`)), n.cellSelected && r.push(...e.map((l)=>`${l}--cell-selected`)), n.firstRow && r.push(...e.map((l)=>`${l}--first-row`)), n.firstRowInHorizontalLayoutPage && r.push(...e.map((l)=>`${l}--first-row-in-horizontal-layout-page`)), n.rowDisabled && r.push(...e.map((l)=>`${l}--disabled`)), n.treeNode && r.push(...e.map((l)=>`${l}--tree-node ${l}-tree-${n.treeNode}-node`)), n.groupRow && (r.push(...e.map((l)=>`${l}--group-row`)), r.push(...e.map((l)=>`${l}--${n.rowExpanded ? "group-row-expanded" : "group-row-collapsed"}`))), o.computedPinned ? r.push(...e.map((l)=>`${l}--pinned-${o.computedPinned}`)) : r.push(...e.map((l)=>`${l}--unpinned`)), r.filter(Boolean).join(" ");
}
function $88ab1a78ec8ca4b4$var$cn(o, e) {
    let t = o;
    if (!t) return null;
    if (t && t.matches(e)) return t;
    for(; t = t.parentElement;)if (t.matches(e)) return t;
    return null;
}
function $88ab1a78ec8ca4b4$var$gu(o, e, t) {
    let n = o;
    if (!n) return null;
    if (n && n.matches(e)) return n;
    for(; n = n.parentElement;){
        if (n.matches(e)) return n;
        if (n === t) return null;
    }
    return null;
}
var $88ab1a78ec8ca4b4$var$U = {
    currentColumnTransformX: "var(--_16hkbkc0)",
    y: "var(--_16hkbkc1)",
    currentFlashingBackground: "var(--_16hkbkc2)",
    currentFlashingDuration: "var(--_16hkbkc3)",
    activeCellRowOffset: "var(--_16hkbkc4)",
    activeCellRowOffsetX: "var(--_16hkbkc5)",
    activeCellRowHeight: "var(--_16hkbkc6)",
    activeCellOffsetX: "var(--_16hkbkc7)",
    activeCellOffsetY: "var(--_16hkbkc8)",
    scrollTopForActiveRow: "var(--_16hkbkc9)",
    scrollLeftForActiveRowWhenHorizontalLayout: "var(--_16hkbkca)",
    activeCellColWidth: "var(--_16hkbkcb)",
    activeCellColOffset: "var(--_16hkbkcc)",
    columnReorderEffectDurationAtIndex: "var(--_16hkbkcd)",
    columnWidthAtIndex: "var(--_16hkbkce)",
    columnOffsetAtIndex: "var(--_16hkbkcf)",
    columnOffsetAtIndexWhileReordering: "var(--_16hkbkcg)",
    columnVisibilityAtIndex: "var(--_16hkbkch)",
    columnZIndexAtIndex: "var(--_16hkbkci)",
    pinnedStartWidth: "var(--_16hkbkcj)",
    pinnedEndWidth: "var(--_16hkbkck)",
    pinnedEndOffset: "var(--_16hkbkcl)",
    computedVisibleColumnsCount: "var(--_16hkbkcm)",
    baseZIndexForCells: "var(--_16hkbkcn)",
    bodyWidth: "var(--_16hkbkco)",
    bodyHeight: "var(--_16hkbkcp)",
    scrollbarWidthHorizontal: "var(--_16hkbkcq)",
    scrollbarWidthVertical: "var(--_16hkbkcr)",
    scrollLeft: "var(--_16hkbkcs)",
    scrollTop: "var(--_16hkbkct)"
};
var $88ab1a78ec8ca4b4$var$hu = "true", $88ab1a78ec8ca4b4$var$se = {
    loaded: "var(--infinite-loaded)",
    themeName: "var(--infinite-theme-name)",
    themeMode: "var(--infinite-theme-mode)",
    color: {
        accent: "var(--infinite-accent-color)",
        success: "var(--infinite-success-color)",
        error: "var(--infinite-error-color)",
        color: "var(--infinite-color)"
    },
    spacing: {
        0: "var(--infinite-space-0)",
        1: "var(--infinite-space-1)",
        2: "var(--infinite-space-2)",
        3: "var(--infinite-space-3)",
        4: "var(--infinite-space-4)",
        5: "var(--infinite-space-5)",
        6: "var(--infinite-space-6)",
        7: "var(--infinite-space-7)",
        8: "var(--infinite-space-8)",
        9: "var(--infinite-space-9)",
        10: "var(--infinite-space-10)"
    },
    fontSize: {
        0: "var(--infinite-font-size-0)",
        1: "var(--infinite-font-size-1)",
        2: "var(--infinite-font-size-2)",
        3: "var(--infinite-font-size-3)",
        4: "var(--infinite-font-size-4)",
        5: "var(--infinite-font-size-5)",
        6: "var(--infinite-font-size-6)",
        7: "var(--infinite-font-size-7)"
    },
    fontFamily: "var(--infinite-font-family)",
    minHeight: "var(--infinite-min-height)",
    borderRadius: "var(--infinite-border-radius)",
    focusOutline: "var(--infinite-focus-outline)",
    background: "var(--infinite-background)",
    iconSize: "var(--infinite-icon-size)",
    runtime: {
        bodyWidth: "var(--infinite-runtime-body-content-width)",
        totalVisibleColumnsWidthValue: "var(--infinite-runtime-total-visible-columns-width)",
        totalVisibleColumnsWidthVar: "var(--infinite-runtime-total-visible-columns-width-var)",
        visibleColumnsCount: "var(--infinite-runtime-visible-columns-count)",
        browserScrollbarWidth: "var(--infinite-runtime-browser-scrollbar-width)"
    },
    components: {
        GroupingToolbar: {
            color: "var(--infinite-grouping-toolbar-color)",
            background: "var(--infinite-grouping-toolbar-background)",
            rejectBackground: "var(--infinite-grouping-toolbar-reject-background)",
            activeBackground: "var(--infinite-grouping-toolbar-active-background)",
            activeBackgroundAlpha: "var(--infinite-grouping-toolbar-active-background-alpha)",
            padding: "var(--infinite-grouping-toolbar-padding)",
            border: "var(--infinite-grouping-toolbar-border)",
            rejectBorder: "var(--infinite-grouping-toolbar-reject-border)",
            gap: "var(--infinite-grouping-toolbar-gap)"
        },
        GroupingToolbarItem: {
            border: "var(--infinite-grouping-toolbar-item-border)",
            borderRadius: "var(--infinite-grouping-toolbar-item-border-radius)",
            activeBorder: "var(--infinite-grouping-toolbar-item-active-border)",
            background: "var(--infinite-grouping-toolbar-item-background)",
            activeBackground: "var(--infinite-grouping-toolbar-item-active-background)",
            activeBackgroundAlpha: "var(--infinite-grouping-toolbar-item-active-background-alpha)"
        },
        LoadMask: {
            padding: "var(--infinite-load-mask-padding)",
            color: "var(--infinite-load-mask-color)",
            textBackground: "var(--infinite-load-mask-text-background)",
            overlayBackground: "var(--infinite-load-mask-overlay-background)",
            overlayOpacity: "var(--infinite-load-mask-overlay-opacity)",
            borderRadius: "var(--infinite-load-mask-border-radius)"
        },
        Header: {
            background: "var(--infinite-header-background)",
            color: "var(--infinite-header-color)",
            columnHeaderHeight: "var(--infinite-column-header-height)"
        },
        HeaderCell: {
            background: "var(--infinite-header-cell-background)",
            hoverBackground: "var(--infinite-header-cell-hover-background)",
            border: "var(--infinite-header-cell-border)",
            padding: "var(--infinite-header-cell-padding)",
            paddingX: "var(--infinite-header-cell-padding-x)",
            paddingY: "var(--infinite-header-cell-padding-y)",
            iconSize: "var(--infinite-header-cell-icon-size)",
            menuIconLineWidth: "var(--infinite-header-cell-menu-icon-line-width)",
            sortIconMargin: "var(--infinite-header-cell-sort-icon-margin)",
            borderRight: "var(--infinite-header-cell-border-right)",
            resizeHandleActiveAreaWidth: "var(--infinite-resize-handle-active-area-width)",
            resizeHandleWidth: "var(--infinite-resize-handle-width)",
            resizeHandleHoverBackground: "var(--infinite-resize-handle-hover-background)",
            resizeHandleConstrainedHoverBackground: "var(--infinite-resize-handle-constrained-hover-background)",
            filterOperatorPaddingX: "var(--infinite-filter-operator-padding-x)",
            filterEditorPaddingX: "var(--infinite-filter-editor-padding-x)",
            filterEditorMarginX: "var(--infinite-filter-editor-margin-x)",
            filterOperatorPaddingY: "var(--infinite-filter-operator-padding-y)",
            filterEditorPaddingY: "var(--infinite-filter-editor-padding-y)",
            filterEditorMarginY: "var(--infinite-filter-editor-margin-y)",
            filterEditorBackground: "var(--infinite-filter-editor-background)",
            filterEditorBorder: "var(--infinite-filter-editor-border)",
            filterEditorFocusBorderColor: "var(--infinite-filter-editor-focus-border-color)",
            filterEditorBorderRadius: "var(--infinite-filter-editor-border-radius)",
            filterEditorColor: "var(--infinite-filter-editor-color)"
        },
        ActiveCellIndicator: {
            inset: "var(--infinite-active-cell-indicator-inset)"
        },
        Cell: {
            flashingDuration: "var(--infinite-flashing-duration)",
            flashingAnimationName: "var(--infinite-flashing-animation-name)",
            flashingOverlayZIndex: "var(--infinite-flashing-overlay-z-index)",
            flashingBackground: "var(--infinite-flashing-background)",
            flashingUpBackground: "var(--infinite-flashing-up-background)",
            flashingDownBackground: "var(--infinite-flashing-down-background)",
            padding: "var(--infinite-cell-padding)",
            borderWidth: "var(--infinite-cell-border-width)",
            borderColor: "var(--infinite-cell-border-color)",
            border: "var(--infinite-cell-border)",
            borderLeft: "var(--infinite-cell-border-left)",
            borderRight: "var(--infinite-cell-border-right)",
            borderTop: "var(--infinite-cell-border-top)",
            borderInvisible: "var(--infinite-cell-border-invisible)",
            borderRadius: "var(--infinite-cell-border-radius)",
            reorderEffectDuration: "var(--infinite-column-reorder-effect-duration)",
            pinnedBorder: "var(--infinite-pinned-cell-border)",
            horizontalLayoutColumnReorderDisabledPageOpacity: "var(--infinite-horizontal-layout-column-reorder-disabled-page-opacity)",
            color: "var(--infinite-cell-color)",
            selectedBackground: "var(--infinite-selected-cell-background)",
            selectedBackgroundDefault: "var(--infinite-selected-cell-background-default)",
            selectedBackgroundAlpha: "var(--infinite-selected-cell-background-alpha)",
            selectedBackgroundAlphaWhenTableUnfocused: "var(--infinite-selected-cell-background-alpha--table-unfocused)",
            selectedBorderColor: "var(--infinite-selected-cell-border-color)",
            selectedBorderWidth: "var(--infinite-selected-cell-border-width)",
            selectedBorderStyle: "var(--infinite-selected-cell-border-style)",
            selectedBorder: "var(--infinite-selected-cell-border)",
            activeBackgroundAlpha: "var(--infinite-active-cell-background-alpha)",
            activeBackgroundAlphaWhenTableUnfocused: "var(--infinite-active-cell-background-alpha--table-unfocused)",
            activeBackground: "var(--infinite-active-cell-background)",
            activeBackgroundDefault: "var(--infinite-active-cell-background-default)",
            activeBorderColor: "var(--infinite-active-cell-border-color)",
            activeBorderWidth: "var(--infinite-active-cell-border-width)",
            activeBorderStyle: "var(--infinite-active-cell-border-style)",
            activeBorder: "var(--infinite-active-cell-border)"
        },
        SelectionCheckBox: {
            marginInline: "var(--infinite-selection-checkbox-margin-inline)"
        },
        ExpandCollapseIcon: {
            color: "var(--infinite-expand-collapse-icon-color)"
        },
        Menu: {
            background: "var(--infinite-menu-background)",
            color: "var(--infinite-menu-color)",
            separatorColor: "var(--infinite-menu-separator-color)",
            padding: "var(--infinite-menu-padding)",
            cellPaddingVertical: "var(--infinite-menu-cell-padding-vertical)",
            cellPaddingHorizontal: "var(--infinite-menu-cell-padding-horizontal)",
            cellMarginVertical: "var(--infinite-menu-cell-margin-vertical)",
            itemDisabledBackground: "var(--infinite-menu-item-disabled-background)",
            itemActiveBackground: "var(--infinite-menu-item-active-background)",
            itemActiveOpacity: "var(--infinite-menu-item-active-opacity)",
            itemPressedOpacity: "var(--infinite-menu-item-pressed-opacity)",
            itemPressedBackground: "var(--infinite-menu-item-pressed-background)",
            itemDisabledOpacity: "var(--infinite-menu-item-disabled-opacity)",
            borderRadius: "var(--infinite-menu-border-radius)",
            shadowColor: "var(--infinite-menu-shadow-color)"
        },
        RowDetail: {
            background: "var(--infinite-rowdetail-background)",
            padding: "var(--infinite-rowdetail-padding)",
            gridHeight: "var(--infinite-rowdetail-grid-height)"
        },
        Row: {
            background: "var(--infinite-row-background)",
            oddBackground: "var(--infinite-row-odd-background)",
            disabledBackground: "var(--infinite-row-disabled-background)",
            oddDisabledBackground: "var(--infinite-row-odd-disabled-background)",
            selectedBackground: "var(--infinite-row-selected-background)",
            disabledOpacity: "var(--infinite-row-disabled-opacity)",
            activeBackground: "var(--infinite-active-row-background)",
            activeBorderColor: "var(--infinite-active-row-border-color)",
            activeBorderWidth: "var(--infinite-active-row-border-width)",
            activeBorderStyle: "var(--infinite-active-row-border-style)",
            activeBorder: "var(--infinite-active-row-border)",
            activeBackgroundAlpha: "var(--infinite-active-row-background-alpha)",
            activeBackgroundAlphaWhenTableUnfocused: "var(--infinite-active-row-background-alpha--table-unfocused)",
            hoverBackground: "var(--infinite-row-hover-background)",
            selectedHoverBackground: "var(--infinite-row-selected-hover-background)",
            selectedDisabledBackground: "var(--infinite-row-selected-disabled-background)",
            groupRowBackground: "var(--infinite-group-row-background)",
            groupRowColumnNesting: "var(--infinite-group-row-column-nesting)",
            groupNesting: "var(--infinite-dont-override-group-row-nesting-length)",
            pointerEventsWhileScrolling: "var(--infinite-row-pointer-events-while-scrolling)"
        },
        ColumnCell: {
            background: "var(--infinite-column-cell-bg-dont-override)"
        }
    }
}, $88ab1a78ec8ca4b4$var$bu = "column-header-height";
var $88ab1a78ec8ca4b4$var$yu = `.${$88ab1a78ec8ca4b4$var$Fe.rootClassName}`;
function $88ab1a78ec8ca4b4$var$nl(o) {
    return $88ab1a78ec8ca4b4$var$cn(o, $88ab1a78ec8ca4b4$var$yu);
}
var $88ab1a78ec8ca4b4$var$Tu = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.scrollLeft), $88ab1a78ec8ca4b4$var$Cb = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.scrollTop), $88ab1a78ec8ca4b4$var$wb = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnWidthAtIndex), $88ab1a78ec8ca4b4$var$ol = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnOffsetAtIndex), $88ab1a78ec8ca4b4$var$Su = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnReorderEffectDurationAtIndex), $88ab1a78ec8ca4b4$var$Ib = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnOffsetAtIndexWhileReordering), $88ab1a78ec8ca4b4$var$vb = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnVisibilityAtIndex), $88ab1a78ec8ca4b4$var$Rb = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnZIndexAtIndex);
function $88ab1a78ec8ca4b4$var$kt(o, e, t) {
    let n = t ? $88ab1a78ec8ca4b4$var$nl(t) : document.querySelector($88ab1a78ec8ca4b4$var$yu);
    $88ab1a78ec8ca4b4$var$xb(o, e, n);
}
function $88ab1a78ec8ca4b4$var$xb(o, e, t) {
    if (t) {
        let n = o, r = $88ab1a78ec8ca4b4$var$U[n] ? $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U[n]) : o;
        t.style.setProperty(r, `${e}`);
    }
}
function $88ab1a78ec8ca4b4$var$oo(o, e) {
    if (e) for(var t in o){
        let n = $88ab1a78ec8ca4b4$var$U[t] ? $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U[t]) : t, r = `${o[t]}`;
        e.style.setProperty(n, r);
    }
}
function $88ab1a78ec8ca4b4$var$rl(o, e, t) {
    $88ab1a78ec8ca4b4$var$kt(`${$88ab1a78ec8ca4b4$var$ol}-${o.computedVisibleIndex}`, o.computedPinned ? `calc( ${o.computedAbsoluteOffset + e}px + var(${$88ab1a78ec8ca4b4$var$Tu}))` : `${o.computedAbsoluteOffset + e}px`, t);
}
function $88ab1a78ec8ca4b4$var$il(o, e, t) {
    $88ab1a78ec8ca4b4$var$kt(`${$88ab1a78ec8ca4b4$var$Rb}-${o}`, `${e}`, t);
}
function $88ab1a78ec8ca4b4$var$ro(o, e, t) {
    $88ab1a78ec8ca4b4$var$kt(`${$88ab1a78ec8ca4b4$var$Ib}-${o}`, typeof e == "number" ? `calc( var(${$88ab1a78ec8ca4b4$var$ol}-${o}) + ${e}px )` : e, t);
}
function $88ab1a78ec8ca4b4$var$$o(o, e, t) {
    $88ab1a78ec8ca4b4$var$kt(`${$88ab1a78ec8ca4b4$var$vb}-${o}`, e, t);
}
function $88ab1a78ec8ca4b4$var$Wr(o, e, t) {
    $88ab1a78ec8ca4b4$var$kt(`${$88ab1a78ec8ca4b4$var$Su}-${o}`, t ?? "", e);
}
function $88ab1a78ec8ca4b4$var$al(o, e) {
    let t = `${$88ab1a78ec8ca4b4$var$Su}-${o}`;
    $88ab1a78ec8ca4b4$var$kt(t, $88ab1a78ec8ca4b4$var$se.components.Cell.reorderEffectDuration, e);
}
var $88ab1a78ec8ca4b4$var$Ce = {
    columnWidths: {
        get (o) {
            return `var(${this.getVarName(o)})`;
        },
        getVarName (o) {
            return this.varName.get(o);
        },
        varName: {
            get (o) {
                return `${$88ab1a78ec8ca4b4$var$wb}-${o}`;
            }
        },
        set (o, e, t) {
            e = typeof e == "number" ? e + "px" : e, $88ab1a78ec8ca4b4$var$kt(this.varName.get(o), e, t);
        }
    },
    columnOffsets: {
        get (o) {
            return `var(${this.getVarName(o)})`;
        },
        getVarName (o) {
            return this.varName.get(o);
        },
        varName: {
            get (o) {
                return `${$88ab1a78ec8ca4b4$var$ol}-${o}`;
            }
        },
        set (o, e, t) {
            e = typeof e == "number" ? e + "px" : e, $88ab1a78ec8ca4b4$var$kt(this.varName.get(o), e, t);
        }
    }
};
function $88ab1a78ec8ca4b4$var$Cu(o, e) {
    $88ab1a78ec8ca4b4$var$oo({
        [$88ab1a78ec8ca4b4$var$Tu]: `${o.scrollLeft}px`,
        [$88ab1a78ec8ca4b4$var$Cb]: `${o.scrollTop}px`
    }, e);
}
var $88ab1a78ec8ca4b4$var$wu = "_16lm1iw1", $88ab1a78ec8ca4b4$var$Iu = "_1yeub2v0 _16lm1iw1 _16lm1iw1p _16lm1iw2f _16lm1iw0", $88ab1a78ec8ca4b4$var$vu = "_1yeub2vs", $88ab1a78ec8ca4b4$var$Ru = "_1yeub2vr", $88ab1a78ec8ca4b4$var$xu = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_1yeub2v2",
    variantClassNames: {
        horizontalLayout: {
            true: "_1yeub2v3",
            false: "_1yeub2v4"
        },
        focused: {
            true: "_1yeub2v5",
            false: "_1yeub2v6"
        },
        focusedWithin: {
            true: "_1yeub2v7",
            false: "_1yeub2v8"
        },
        hasPinnedStart: {
            true: "_1yeub2v9",
            false: "_1yeub2va"
        },
        hasPinnedEnd: {
            true: "_1yeub2vb",
            false: "_1yeub2vc"
        },
        hasPinnedStartOverflow: {
            true: "_1yeub2vd",
            false: "_1yeub2ve"
        },
        hasPinnedEndOverflow: {
            true: "_1yeub2vf",
            false: "_1yeub2vg"
        }
    },
    defaultVariants: {},
    compoundVariants: [
        [
            {
                focused: !1,
                focusedWithin: !1
            },
            "_1yeub2vh"
        ]
    ]
});
var $88ab1a78ec8ca4b4$var$ll = "_1yeub2vp";
var $88ab1a78ec8ca4b4$var$yP = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_1yeub2vl",
    variantClassNames: {
        pinned: {
            start: "_1yeub2vm",
            end: "_1yeub2vn",
            false: "_1yeub2vo"
        }
    },
    defaultVariants: {},
    compoundVariants: []
});
var $88ab1a78ec8ca4b4$var$sl = (o)=>{
    let e = 0;
    return (...t)=>{
        e && cancelAnimationFrame(e), e = requestAnimationFrame(()=>{
            e = 0, o(...t);
        });
    };
};
var $88ab1a78ec8ca4b4$var$Uo = {
    bodyWidth: {
        name: $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$se.runtime.bodyWidth),
        value: ""
    },
    totalVisibleColumnsWidthValue: {
        name: $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$se.runtime.totalVisibleColumnsWidthValue),
        value: ""
    },
    totalVisibleColumnsWidthVar: {
        name: $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$se.runtime.totalVisibleColumnsWidthVar),
        value: ""
    },
    visibleColumnsCount: {
        name: $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$se.runtime.visibleColumnsCount),
        value: ""
    },
    browserScrollbarWidth: {
        name: $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$se.runtime.browserScrollbarWidth),
        value: ""
    }
}, $88ab1a78ec8ca4b4$var$Pb = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.scrollbarWidthHorizontal), $88ab1a78ec8ca4b4$var$Pu = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.scrollbarWidthVertical), $88ab1a78ec8ca4b4$var$Db = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnWidthAtIndex), $88ab1a78ec8ca4b4$var$Mb = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnZIndexAtIndex), $88ab1a78ec8ca4b4$var$Du = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.scrollLeft), $88ab1a78ec8ca4b4$var$Eb = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.activeCellColWidth), $88ab1a78ec8ca4b4$var$Mu = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.activeCellColOffset), $88ab1a78ec8ca4b4$var$Ou = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.baseZIndexForCells), $88ab1a78ec8ca4b4$var$Ab = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.pinnedStartWidth), $88ab1a78ec8ca4b4$var$Eu = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.bodyWidth), $88ab1a78ec8ca4b4$var$_b = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.bodyHeight), $88ab1a78ec8ca4b4$var$Au = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.pinnedEndOffset), $88ab1a78ec8ca4b4$var$_u = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.pinnedEndWidth), $88ab1a78ec8ca4b4$var$Ob = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.computedVisibleColumnsCount);
function $88ab1a78ec8ca4b4$var$cl(o, e) {
    let t = "auto", n = o.computedVisibleIndex;
    return o.computedPinned ? o.computedPinned === "start" ? t = e.pinnedStartColsCount - o.computedVisibleIndexInCategory : o.computedPinned === "end" && (t = e.visibleColsCount + o.computedVisibleIndexInCategory) : t = -n * 10, typeof t == "number" ? `calc( var(${$88ab1a78ec8ca4b4$var$Ou}) ` + (t < 0 ? "-" : "+") + ` ${Math.abs(t)} )` : "auto";
}
function $88ab1a78ec8ca4b4$var$Nu(o) {
    let e = $88ab1a78ec8ca4b4$var$sn(), { computed: t, state: n, actions: r, getState: i } = $88ab1a78ec8ca4b4$var$Q(), { focused: a, focusedWithin: l, domRef: s, scrollerDOMRef: c, onBlurWithin: u, onFocusWithin: d, onSelfFocus: f, onSelfBlur: p, bodySize: m, activeCellIndex: g, wrapRowsHorizontally: b } = n, { computedPinnedStartColumnsWidth: h, computedPinnedEndColumnsWidth: y, computedPinnedStartColumns: S, computedPinnedEndColumns: C, computedVisibleColumns: T, computedUnpinnedColumnsWidth: I, scrollbars: w } = t, v = [], R = T.reduce((D, O)=>{
        let F = O.computedVisibleIndex;
        D[$88ab1a78ec8ca4b4$var$Ce.columnWidths.varName.get(F)] = O.computedWidth + "px", D[$88ab1a78ec8ca4b4$var$Ce.columnOffsets.varName.get(F)] = O.computedPinned === "start" ? `calc( ${O.computedOffset}px + var(${$88ab1a78ec8ca4b4$var$Du}) )` : O.computedPinned === "end" ? `calc( var(${$88ab1a78ec8ca4b4$var$Au}) ${v.length ? "+" : ""} ${v.map((z)=>$88ab1a78ec8ca4b4$var$Ce.columnWidths.get(z.computedVisibleIndex)).join(" + ")} + var(${$88ab1a78ec8ca4b4$var$Du}) )` : `${O.computedOffset}px`;
        let W = $88ab1a78ec8ca4b4$var$cl(O, {
            pinnedStartColsCount: S.length,
            visibleColsCount: T.length
        });
        return D[`${$88ab1a78ec8ca4b4$var$Mb}-${F}`] = `${W}`, O.computedPinned === "end" && v.push(O), D;
    }, {});
    if (m.width && (R[$88ab1a78ec8ca4b4$var$Uo.browserScrollbarWidth.name] = `${$88ab1a78ec8ca4b4$var$sn()}px`), R[$88ab1a78ec8ca4b4$var$Uo.bodyWidth.name] = `calc(${$88ab1a78ec8ca4b4$var$U.bodyWidth} - ${$88ab1a78ec8ca4b4$var$U.scrollbarWidthVertical})`, R[$88ab1a78ec8ca4b4$var$Uo.totalVisibleColumnsWidthValue.name] = `${h + y + I}px`, R[$88ab1a78ec8ca4b4$var$Uo.totalVisibleColumnsWidthVar.name] = `calc(${T.map((D, O)=>`var(${$88ab1a78ec8ca4b4$var$Db}-${O})`).join(" + ")})`, R[$88ab1a78ec8ca4b4$var$Uo.visibleColumnsCount.name] = T.length, g != null) {
        R[$88ab1a78ec8ca4b4$var$Eb] = $88ab1a78ec8ca4b4$var$Ce.columnWidths.get(g[1]);
        let D = $88ab1a78ec8ca4b4$var$Ce.columnOffsets.get(g[1]);
        if (n.brain.isHorizontalLayoutBrain) {
            let O = n.brain.getPageIndexForRow(g[0]);
            R[$88ab1a78ec8ca4b4$var$Mu] = O ? `calc( ${$88ab1a78ec8ca4b4$var$se.runtime.totalVisibleColumnsWidthVar} * ${O} + ${D})` : D;
        } else R[$88ab1a78ec8ca4b4$var$Mu] = D;
    }
    R[$88ab1a78ec8ca4b4$var$Ob] = T.length, R[$88ab1a78ec8ca4b4$var$Pb] = w.horizontal ? `${e}px` : "0px", R[$88ab1a78ec8ca4b4$var$Pu] = w.vertical ? `${e}px` : "0px", R[$88ab1a78ec8ca4b4$var$Ab] = "calc( " + S.map((D)=>$88ab1a78ec8ca4b4$var$Ce.columnWidths.get(D.computedVisibleIndex)).join(" + ") + ")", R[$88ab1a78ec8ca4b4$var$_u] = "calc( " + C.map((D)=>$88ab1a78ec8ca4b4$var$Ce.columnWidths.get(D.computedVisibleIndex)).join(" + ") + ")", R[$88ab1a78ec8ca4b4$var$Ou] = T.length * 10, R[$88ab1a78ec8ca4b4$var$Au] = `calc( var(${$88ab1a78ec8ca4b4$var$Eu}) - var(${$88ab1a78ec8ca4b4$var$_u}) - var(${$88ab1a78ec8ca4b4$var$Pu}) )`, R[$88ab1a78ec8ca4b4$var$Eu] = `${m.width}px`, R[$88ab1a78ec8ca4b4$var$_b] = `${m.height}px`;
    let x = $88ab1a78ec8ca4b4$var$sl((D)=>{
        r.focused = D;
    }), M = $88ab1a78ec8ca4b4$var$sl((D)=>{
        r.focusedWithin = D;
    }), P = {
        ...o,
        onFocus: (D)=>{
            if (o?.onFocus?.(D), D.target === s.current || D.target === c.current) {
                if (i().focused) return;
                x(!0), f?.(D), l && (M(!1), u?.(D));
                return;
            }
            l || (M(!0), d?.(D));
        },
        onBlur: (D)=>{
            if (o?.onBlur?.(D), D.target === s.current || D.target === c.current) {
                if (!i().focused) return;
                x(!1), p?.(D), l && (M(!1), u?.(D));
                return;
            }
            s.current?.contains(D.relatedTarget) || (M(!1), u?.(D));
        }
    }, _ = $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$export$152f516c829750a, $88ab1a78ec8ca4b4$var$Iu, b ? `${$88ab1a78ec8ca4b4$export$152f516c829750a}--horizontal-layout` : null, P?.className, h ? `${$88ab1a78ec8ca4b4$export$152f516c829750a}--has-pinned-start ${$88ab1a78ec8ca4b4$var$Ru}` : null, y ? `${$88ab1a78ec8ca4b4$export$152f516c829750a}--has-pinned-end  ${$88ab1a78ec8ca4b4$var$vu}` : null, a ? `${$88ab1a78ec8ca4b4$export$152f516c829750a}--focused` : null, l ? `${$88ab1a78ec8ca4b4$export$152f516c829750a}--focused-within` : null, a && n.focusedClassName ? n.focusedClassName : null, l && n.focusedWithinClassName ? n.focusedWithinClassName : null, t.computedPinnedStartOverflow ? `${$88ab1a78ec8ca4b4$export$152f516c829750a}--has-pinned-start-overflow` : null, t.computedPinnedEndOverflow ? `${$88ab1a78ec8ca4b4$export$152f516c829750a}--has-pinned-end-overflow` : null, $88ab1a78ec8ca4b4$var$xu({
        horizontalLayout: !!b,
        hasPinnedStart: !!h,
        hasPinnedEnd: !!y,
        focused: a,
        focusedWithin: l
    }));
    return P.className = _, P.style = {
        ...o?.style,
        ...R
    }, a && n.focusedStyle && Object.assign(P.style, n.focusedStyle), l && n.focusedWithinStyle && Object.assign(P.style, n.focusedWithinStyle), P;
}
var $88ab1a78ec8ca4b4$var$Bu = $88ab1a78ec8ca4b4$var$qn($88ab1a78ec8ca4b4$var$Dn());
function $88ab1a78ec8ca4b4$var$jr(o) {
    return o.map((e)=>e instanceof $88ab1a78ec8ca4b4$var$un ? e : new $88ab1a78ec8ca4b4$var$un(null, [
            e
        ]));
}
var $88ab1a78ec8ca4b4$var$un = class o {
    constructor(e, t = []){
        this.__operands = [];
        this.__operation = null;
        this.__operands = t, this.__operation = e;
    }
    add(...e) {
        return new o("+", [
            this,
            ...e
        ]);
    }
    subtract(...e) {
        return new o("-", [
            this,
            ...e
        ]);
    }
    minus(...e) {
        return this.subtract(...e);
    }
    multiply(...e) {
        return new o("*", [
            this,
            ...e
        ]);
    }
    divide(...e) {
        return new o("/", [
            this,
            ...e
        ]);
    }
    __get(e) {
        let { __operation: t, __operands: n } = this, r = n.map((a)=>$88ab1a78ec8ca4b4$var$Nb(a, this)).join(` ${t} `);
        return (n.length <= 1 ? !0 : e?.__operation === "+" || e?.__operation === "-") ? r : `(${r})`;
    }
    done() {
        let e = this.__get();
        return `calc${e.startsWith("(") && e.endsWith(")") ? e : `(${e})`}`;
    }
};
function $88ab1a78ec8ca4b4$var$Nb(o, e) {
    return typeof o == "string" || typeof o == "number" ? `${o}` : e ? o.__get(e) : o.done();
}
var $88ab1a78ec8ca4b4$var$Fb = (...o)=>new $88ab1a78ec8ca4b4$var$un("+", $88ab1a78ec8ca4b4$var$jr(o)), $88ab1a78ec8ca4b4$var$Lu = (...o)=>new $88ab1a78ec8ca4b4$var$un("-", $88ab1a78ec8ca4b4$var$jr(o)), $88ab1a78ec8ca4b4$var$Lb = (...o)=>new $88ab1a78ec8ca4b4$var$un("*", $88ab1a78ec8ca4b4$var$jr(o)), $88ab1a78ec8ca4b4$var$kb = (...o)=>new $88ab1a78ec8ca4b4$var$un("/", $88ab1a78ec8ca4b4$var$jr(o)), $88ab1a78ec8ca4b4$var$Yo = {
    add: $88ab1a78ec8ca4b4$var$Fb,
    subtract: $88ab1a78ec8ca4b4$var$Lu,
    minus: $88ab1a78ec8ca4b4$var$Lu,
    multiply: $88ab1a78ec8ca4b4$var$Lb,
    divide: $88ab1a78ec8ca4b4$var$kb
};
var $88ab1a78ec8ca4b4$var$Mn = (o, e, t)=>{
    if (o = [
        ...o
    ], e === t || o[e] === void 0 || o[t] === void 0) return o;
    let n = o[e];
    return o.splice(e, 1), o.splice(t, 0, n), o;
};
var $88ab1a78ec8ca4b4$var$ke = $88ab1a78ec8ca4b4$var$Re().requestAnimationFrame || ((o)=>setTimeout(o, 16)), $88ab1a78ec8ca4b4$var$At = $88ab1a78ec8ca4b4$var$Re().cancelAnimationFrame || ((o)=>clearTimeout(o));
var $88ab1a78ec8ca4b4$var$ku = (o)=>{
    let e = null, t = null;
    return {
        stop () {
            e !== null && $88ab1a78ec8ca4b4$var$At(e), t != null && $88ab1a78ec8ca4b4$var$At(t);
        },
        scroll (n) {
            e !== null && $88ab1a78ec8ca4b4$var$At(e), t != null && $88ab1a78ec8ca4b4$var$At(t);
            let r = {
                offset: 100,
                scrollAmountsPerRaf: [
                    1,
                    1,
                    2,
                    4,
                    6,
                    8,
                    11,
                    15
                ],
                ...o,
                ...n
            }, i = this;
            function a() {
                let s = r.scrollOffsetStart + r.offset - r.mousePosition.clientX;
                if (!(s > 0 && s <= r.offset)) return !1;
                let u = r.scrollAmountsPerRaf.length, d = Math.round(r.offset / u), f = 0;
                for(let p = 0; p < u; p++)s > (p + 1) * d && (f = r.scrollAmountsPerRaf[p]);
                return n.scrollLeft = n.scrollLeft - f, e = $88ab1a78ec8ca4b4$var$ke(()=>{
                    i.scroll(n);
                }), !0;
            }
            function l() {
                let s = r.mousePosition.clientX - (r.scrollOffsetEnd - r.offset);
                if (!(s > 0 && s <= r.offset)) return !1;
                let u = r.scrollAmountsPerRaf.length, d = Math.round(r.offset / u), f = 0;
                for(let p = 0; p < u; p++)s > (p + 1) * d && (f = r.scrollAmountsPerRaf[p]);
                return n.scrollLeft = n.scrollLeft + f, t = $88ab1a78ec8ca4b4$var$ke(()=>{
                    i.scroll(n);
                }), !0;
            }
            return !!(a() || l());
        }
    };
};
var $88ab1a78ec8ca4b4$var$Ge = class o {
    constructor(e){
        this.top = 0;
        this.left = 0;
        this.left = e.left, this.top = e.top;
    }
    static clone(e) {
        return new o(e);
    }
    static from(e) {
        return new o(e);
    }
    shift(e) {
        return e.top != null && (this.top += e.top), e.left != null && (this.left += e.left), this;
    }
    getDistanceToPoint(e) {
        let t = e.top - this.top, n = e.left - this.left;
        return {
            top: t,
            left: n
        };
    }
};
function $88ab1a78ec8ca4b4$var$zu(o, e) {
    let t = Math.atan2(o.top - e.top, o.left - e.left);
    return t <= 0 && (t = 2 * Math.PI + t), t;
}
function $88ab1a78ec8ca4b4$var$Vu(o, e) {
    return Math.sqrt((e.top - o.top) ** 2 + (e.left - o.left) ** 2);
}
function $88ab1a78ec8ca4b4$var$zb(o, e, t) {
    let n = $88ab1a78ec8ca4b4$var$zu(o, t), r = $88ab1a78ec8ca4b4$var$zu(e, t);
    return n === r ? $88ab1a78ec8ca4b4$var$Vu(t, e) - $88ab1a78ec8ca4b4$var$Vu(t, o) : n - r;
}
function $88ab1a78ec8ca4b4$var$Gu(o) {
    if (o.length < 3) return o;
    let [...e] = o, t = {
        top: 0,
        left: 0
    };
    return o.forEach((n)=>{
        t.top += n.top, t.left += n.left;
    }), t.top /= o.length, t.left /= o.length, e.sort((n, r)=>$88ab1a78ec8ca4b4$var$zb(n, r, t)), e;
}
function $88ab1a78ec8ca4b4$var$Vb(o) {
    if (o.length < 2) return !1;
    let e = o[0].left, t = o[0].top, n = {
        left: !1,
        top: !1
    };
    for(let r = 1, i = o.length; r < i; r++){
        if (n.left && n.top) return !1;
        o[r].left !== e && (n.left = !0), o[r].top !== t && (n.top = !0);
    }
    return !(n.left && n.top);
}
function $88ab1a78ec8ca4b4$var$Gb(o, e) {
    if (o.length < 2) return o[0] ? o[0].left === e.left && o[0].top === e.top : !1;
    o = $88ab1a78ec8ca4b4$var$Gu(o);
    let t = o[0], n = o[o.length - 1];
    return t.left === n.left ? e.left === t.left && e.top >= Math.min(t.top, n.top) && e.top <= Math.max(t.top, n.top) : e.top === t.top && e.left >= Math.min(t.left, n.left) && e.left <= Math.max(t.left, n.left);
}
function $88ab1a78ec8ca4b4$var$Hu(o, e) {
    if ($88ab1a78ec8ca4b4$var$Vb(o)) return $88ab1a78ec8ca4b4$var$Gb(o, e);
    o = $88ab1a78ec8ca4b4$var$Gu(o);
    let [t] = o;
    for(let n = 1, r = o.length - 1; n < r; n++){
        let i = o[n], a = o[n + 1];
        if ($88ab1a78ec8ca4b4$var$Hb([
            t,
            i,
            a
        ], e)) return !0;
    }
    return !1;
}
function $88ab1a78ec8ca4b4$var$Hb(o, e) {
    let [t, n, r] = o, i = e, a = (n.left - t.left) * (r.top - t.top) - (n.top - t.top) * (r.left - t.left);
    return a * ((n.left - t.left) * (i.top - t.top) - (n.top - t.top) * (i.left - t.left)) >= 0 && a * ((r.left - n.left) * (i.top - n.top) - (r.top - n.top) * (i.left - n.left)) >= 0 && a * ((t.left - r.left) * (i.top - r.top) - (t.top - r.top) * (i.left - r.left)) >= 0;
}
var $88ab1a78ec8ca4b4$var$io = class {
    containsPoint(e) {
        return $88ab1a78ec8ca4b4$var$Hu(this.getPoints(), e);
    }
    contains(e) {
        let t = e.getPoints();
        for(let n = 0, r = t.length; n < r; n++)if (!this.containsPoint(t[n])) return !1;
        return !0;
    }
    intersects(e) {
        return this.privateIntersects(e, !1);
    }
    privateIntersects(e, t) {
        let n = e.getPoints();
        for(let r = 0, i = n.length; r < i; r++)if (this.containsPoint(n[r])) return !0;
        return t ? !1 : e.privateIntersects(this, !0);
    }
};
var $88ab1a78ec8ca4b4$var$ao = class o extends $88ab1a78ec8ca4b4$var$io {
    static clone(e) {
        return new o(e);
    }
    constructor(e){
        super(), this.points = e.map($88ab1a78ec8ca4b4$var$Ge.clone);
    }
    getPoints() {
        return this.points;
    }
    shift(e) {
        return this.points.forEach((t)=>{
            t.shift(e);
        }), this;
    }
};
function $88ab1a78ec8ca4b4$var$Kb(o, e) {
    let t = Math.min(o.left, e.left), n = Math.min(o.top, e.top), r = o.left + o.width, i = e.left + e.width, a = Math.max(r, i), l = o.top + o.height, s = e.top + e.height, c = Math.max(l, s);
    return new $88ab1a78ec8ca4b4$var$Ie({
        top: n,
        left: t,
        width: a - t,
        height: c - n
    });
}
var $88ab1a78ec8ca4b4$var$Ie = class o extends $88ab1a78ec8ca4b4$var$io {
    constructor(t){
        super();
        this.top = 0;
        this.left = 0;
        this.width = 0;
        this.height = 0;
        this.top = t.top, this.left = t.left, typeof t.width == "number" ? (this.width = t.width, this.height = t.height) : (this.width = t.right - t.left, this.height = t.bottom - t.top);
    }
    static fromDOMRect(t) {
        return new o(t);
    }
    static clone(t) {
        return new o(t);
    }
    static from(t) {
        return o.clone(t);
    }
    static fromPoint(t) {
        return o.from({
            top: t.top,
            left: t.left,
            width: 0,
            height: 0
        });
    }
    getMinimumBoundingRectangle(...t) {
        let n = this;
        for (let r of t)n = $88ab1a78ec8ca4b4$var$Kb(n, r);
        return n;
    }
    toDOMRect() {
        return {
            top: this.top,
            left: this.left,
            bottom: this.top + this.height,
            right: this.left + this.width,
            height: this.height,
            width: this.width,
            x: this.left,
            y: this.top,
            toJSON: ()=>({
                    top: this.top,
                    left: this.left,
                    bottom: this.top + this.height,
                    right: this.left + this.width,
                    height: this.height,
                    width: this.width,
                    x: this.left,
                    y: this.top
                })
        };
    }
    containsPoint(t) {
        return new $88ab1a78ec8ca4b4$var$ao(this.getPoints()).containsPoint(t);
    }
    getTopLeft() {
        return {
            left: this.left,
            top: this.top
        };
    }
    getTopRight() {
        return {
            left: this.left + this.width,
            top: this.top
        };
    }
    getBottomLeft() {
        return {
            left: this.left,
            top: this.top + this.height
        };
    }
    getBottomRight() {
        return {
            left: this.left + this.width,
            top: this.top + this.height
        };
    }
    getCenter() {
        return {
            left: this.left + this.width / 2,
            top: this.top + this.height / 2
        };
    }
    getPoints() {
        return [
            this.getTopLeft(),
            this.getTopRight(),
            this.getBottomLeft(),
            this.getBottomRight()
        ].map($88ab1a78ec8ca4b4$var$Ge.from);
    }
    shift(t) {
        return t.top != null && (this.top += t.top), t.left != null && (this.left += t.left), this;
    }
};
var $88ab1a78ec8ca4b4$var$Ku = 10, $88ab1a78ec8ca4b4$var$Bb = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.pinnedStartWidth);
function $88ab1a78ec8ca4b4$var$Wu(o) {
    let { computedVisibleColumns: e, computedVisibleColumnsMap: t, computedPinnedEndColumns: n, computedPinnedStartColumns: r, dragColumnId: i, infiniteDOMNode: a, brain: l, dragColumnHeaderTargetRect: s, draggableColumnsRestrictTo: c, tableRect: u, acceptDropToReorderRect: d, allowColumnHideOnDrag: f, setProxyPosition: p, setDragColumnOutside: m, getCurrentDragSourceAndTarget: g, api: b, horizontalLayoutPageIndex: h, pageWidth: y } = o;
    function S(G) {
        let q = G === "start" ? F : W;
        return _ === O ? q : O === G ? q + E.computedWidth : _ === G ? q - E.computedWidth : q;
    }
    function C(G) {
        if (G.columnIndex === P || h != null) return !0;
        let q = e[G.columnIndex];
        if (q.computedPinned) return !0;
        let K = l.getScrollPosition().scrollLeft, re = q.computedOffset + (h != null && y != null ? y * h : 0);
        return re >= K + S("start") && re + q.computedWidth <= K + u.width - S("end");
    }
    let T = (G, q)=>{
        let { restrictToParentGroup: K, dragColumn: re } = q, J = [];
        if (G.forEach((we)=>{
            if (we.computedVisibleIndex === P) return;
            let N1 = {
                columnId: we.id,
                columnIndex: we.computedVisibleIndex,
                offsetX: we.computedOffset + Math.round(we.computedWidth / 2)
            };
            C(N1) && J.push(N1);
        }), K) {
            let N1 = function(ee, le, De) {
                let Oe = G[ee];
                Oe && (Oe.columnGroup !== re.columnGroup && De.add(Oe.id), N1(ee + le, le, De));
            };
            var de = N1;
            let we = re.computedVisibleIndex, $ = new Set;
            N1(we - 1, -1, $), N1(we + 1, 1, $), J = J.filter((ee)=>!$.has(ee.columnId));
        }
        return J;
    }, w = r.length, v = {
        clientX: Math.round(o.initialMousePosition.clientX),
        clientY: Math.round(o.initialMousePosition.clientY)
    }, R = {
        left: v.clientX - u.left - (v.clientX - s.left) + $88ab1a78ec8ca4b4$var$Ku,
        top: v.clientY - u.top - (v.clientY - s.top) + $88ab1a78ec8ca4b4$var$Ku
    }, x = l.getScrollPosition(), M = e.map((G)=>G.computedVisibleIndex), A = M, E = t.get(i), P = E.computedVisibleIndex, _ = E?.computedPinned, D = P, O = _, F = l.getFixedStartColsWidth(), W = l.getFixedEndColsWidth(), z = v, L = {
        x: 0,
        y: 0
    }, ae = 1, te = 0;
    function B(G) {
        let q = Math.round(G.clientX), K = Math.round(G.clientY);
        if (q === z.clientX && K === z.clientY) return $88ab1a78ec8ca4b4$var$Ie.from(s).shift({
            left: L.x,
            top: L.y
        });
        z = {
            clientX: q,
            clientY: K
        };
        let J = l.getScrollPosition().scrollLeft - x.scrollLeft;
        return L.x = z.clientX - v.clientX, L.y = z.clientY - v.clientY, te = L.x + J, ae = te < 0 ? -1 : 1, p({
            left: R.left + L.x,
            top: R.top + L.y
        }), $88ab1a78ec8ca4b4$var$Ie.from(s).shift({
            left: L.x,
            top: L.y
        });
    }
    function j(G) {
        let q = 0;
        _ ? _ === "start" && G.forEach((K, re)=>{
            q || e[K]?.computedPinned !== "start" && (q = re);
        }) : G.forEach((K, re)=>{
            e[K]?.computedPinned === "start" && (q = re + 1);
        }), w = q, oe("start", G, q);
    }
    function oe(G, q, K) {
        if (G === "start") {
            let re = 0;
            for(let J = 0; J < K; J++){
                let de = q[J], we = e[de];
                re += we.computedWidth;
            }
            $88ab1a78ec8ca4b4$var$kt($88ab1a78ec8ca4b4$var$Bb, `${re}px`, a);
        }
    }
    function me(G) {
        if (G == null || G === D) return;
        if (D === -1 && G !== -1 && ($88ab1a78ec8ca4b4$var$$o(P, "", a), m(!1)), D = G, G === -1) {
            pe(P);
            return;
        }
        let q = $88ab1a78ec8ca4b4$var$Mn(M, P, D > P ? D - 1 : D);
        w = 0;
        let re = new Set;
        return q.forEach((J, de)=>{
            let we = A[de];
            J !== we && re.add(J), j(q);
        }), A = q, ce(re), {
            newColumnIndexes: q,
            indexesWithTransition: re,
            pinnedStartCount: w
        };
    }
    function pe(G) {
        A = A.filter((K)=>K !== G), e.forEach((K)=>{
            let re = K.computedVisibleIndex, J = re > G;
            $88ab1a78ec8ca4b4$var$al(re, a);
            let de = "";
            J && (de = $88ab1a78ec8ca4b4$var$Yo.minus($88ab1a78ec8ca4b4$var$Ce.columnOffsets.get(re), $88ab1a78ec8ca4b4$var$Ce.columnWidths.get(G)).done()), $88ab1a78ec8ca4b4$var$ro(re, de, a);
        }), $88ab1a78ec8ca4b4$var$$o(G, "hidden", a), m(!0);
    }
    function ce(G) {
        e.forEach((q)=>{
            let K = q.computedVisibleIndex;
            G.has(K) ? $88ab1a78ec8ca4b4$var$al(K, a) : $88ab1a78ec8ca4b4$var$Wr(K, a);
            let re = K === P, J = ae === -1 ? K < D || K > P : K < P || K >= D, de = "";
            ae === -1 ? de = re ? $88ab1a78ec8ca4b4$var$Ce.columnOffsets.get(D) : J ? $88ab1a78ec8ca4b4$var$Ce.columnOffsets.get(K) : $88ab1a78ec8ca4b4$var$Yo.add($88ab1a78ec8ca4b4$var$Ce.columnOffsets.get(K), $88ab1a78ec8ca4b4$var$Ce.columnWidths.get(P)).done() : de = J ? $88ab1a78ec8ca4b4$var$Ce.columnOffsets.get(K) : re ? $88ab1a78ec8ca4b4$var$Yo.add($88ab1a78ec8ca4b4$var$Ce.columnOffsets.get(D - 1), $88ab1a78ec8ca4b4$var$Ce.columnWidths.get(D - 1)).minus($88ab1a78ec8ca4b4$var$Ce.columnWidths.get(P)).done() : $88ab1a78ec8ca4b4$var$Yo.minus($88ab1a78ec8ca4b4$var$Ce.columnOffsets.get(K), $88ab1a78ec8ca4b4$var$Ce.columnWidths.get(P)).done(), $88ab1a78ec8ca4b4$var$ro(K, de, a);
        });
    }
    let ue = u.left + S("start"), ge = u.right - S("end"), H = $88ab1a78ec8ca4b4$var$ku({
        scrollOffsetStart: ue,
        scrollOffsetEnd: ge
    });
    return B(v), {
        speedScroller: H,
        stop () {
            H.stop();
        },
        onMove (G) {
            let q = B(G);
            if (g().dropTargetListId === "grouping-toolbar" || f && !d.containsPoint(q.getCenter())) return f && me(-1), null;
            H.scroll({
                mousePosition: z,
                get scrollLeft () {
                    return l.getScrollPosition().scrollLeft;
                },
                set scrollLeft (N){
                    b.scrollLeft = N;
                }
            });
            let K = T(e, {
                dragColumn: E,
                restrictToParentGroup: c === "group"
            }), re = ae === -1 ? E.computedOffset + te : E.computedOffset + E.computedWidth + te, J = (0, $88ab1a78ec8ca4b4$var$Bu.default)(K, re, ({ offsetX: N1 }, $)=>N1 < $ ? -1 : N1 > $ ? 1 : 0);
            J < 0 && (J = ~J), K.length ? J = K[J] ? K[J].columnIndex : K[K.length - 1].columnIndex + 1 : (e.length > 1 && console.error("No breakpoints available, something is wrong!"), J = 0), J === P + 1 && (J = P), me(J);
            let de = {};
            n.forEach((N1)=>{
                de[N1.id] = "end";
            });
            for(let N1 = 0; N1 < w; N1++){
                let $ = A[N1], ee = e[$];
                de[ee.id] = "start";
            }
            let we = A.map((N1)=>e[N1].id);
            return {
                columnPinning: de,
                columnOrder: we
            };
        }
    };
}
function $88ab1a78ec8ca4b4$var$wt(o, e, t) {
    if (o === e) return !0;
    if (!o || !e) return !1;
    var n = Object.keys(o), r = Object.keys(e);
    t && (n = n.filter((s)=>!t.has(s)), r = r.filter((s)=>!t.has(s)));
    var i = n.length;
    if (r.length !== i) return !1;
    for(var a = 0; a < i; a++){
        var l = n[a];
        if (!(t && t.has(l)) && (o[l] !== e[l] || !Object.prototype.hasOwnProperty.call(e, l))) return !1;
    }
    return !0;
}
function $88ab1a78ec8ca4b4$var$ul(o) {
    let { newColumnOrder: e, visibleColumnOrder: t, existingColumnOrder: n, dragColumnId: r } = o;
    if (t.length !== e.length) return console.warn("new column order cannot contain less columns than the visible column order"), e;
    let i = t.indexOf(r), a = e.indexOf(r);
    if (i === a) return n;
    if (a > i) {
        let l = e.indexOf(r), s = e[l - 1], c = n.indexOf(s), u = n.indexOf(r);
        return $88ab1a78ec8ca4b4$var$Mn(n, u, c);
    } else {
        let l = e.indexOf(r), s = e[l + 1], c = n.indexOf(s), u = n.indexOf(r);
        return $88ab1a78ec8ca4b4$var$Mn(n, u, c);
    }
    return e;
}
var $88ab1a78ec8ca4b4$var$En = class {
    constructor(e){
        this.listeners = {};
        e && Object.keys(e).forEach((t)=>{
            this.on(t, e[t]);
        });
    }
    on(e, t) {
        return this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(t), ()=>this.off(e, t);
    }
    once(e, t) {
        let n = (...r)=>{
            this.off(e, n), t(...r);
        };
        return this.on(e, n);
    }
    off(e, t) {
        let n = this.listeners[e];
        if (!n) return;
        let r = n.indexOf(t);
        r !== -1 && n.splice(r, 1);
    }
    emit(e, ...t) {
        let n = this.listeners[e];
        n && n.slice().forEach((r)=>{
            try {
                r(...t);
            } catch (i) {
                console.error(`Error in event handler for event '${String(e)}':`, i);
            }
        });
    }
    clear(e) {
        this.listeners[e] && (this.listeners[e] = []);
    }
    clearAll() {
        Object.keys(this.listeners).forEach((e)=>{
            this.listeners[e] = [];
        });
    }
};
var $88ab1a78ec8ca4b4$var$ju = $88ab1a78ec8ca4b4$var$qn($88ab1a78ec8ca4b4$var$Dn());
var $88ab1a78ec8ca4b4$var$$u = (o, e)=>{
    let { offset: t, activeDragSource: n } = o, { orientation: r, draggableItems: i, listId: a, listRectangle: l } = e.getData(), { dragItem: s, listId: c, dragIndex: u, dragRectangle: d } = n, f = c === a, p = $88ab1a78ec8ca4b4$var$Ge.from(d.getCenter());
    if (!l.containsPoint(p)) return null;
    e.activeDragSourcePosition = "inside";
    let m = f ? r === "horizontal" ? t.left > 0 ? 1 : -1 : t.top > 0 ? 1 : -1 : 1, g = d.toDOMRect(), b = e.breakpoints, h = Math.round(m === 1 ? r === "horizontal" ? g.right - (f ? 0 : g.width / 2) : g.bottom - (f ? 0 : g.height / 2) : r === "horizontal" ? g.left + (f ? 0 : g.width / 2) : g.top + (f ? 0 : g.height / 2)), y = (0, $88ab1a78ec8ca4b4$var$ju.default)(b, h, (w, v)=>w - v);
    y < 0 && (y = ~y), m === 1 && y === u + 1 && f && y--;
    let S = Math.min(u, y), C = Math.max(u, y), T = f ? i.map((w, v)=>{
        if (v === u && f) return t;
        if (v < S || v >= C) return {
            left: 0,
            top: 0
        };
        let R = y <= v ? 1 : -1;
        return r === "horizontal" ? {
            left: Math.round(R * g.width),
            top: 0
        } : {
            left: 0,
            top: Math.round(R * g.height)
        };
    }) : i.map((w, v)=>{
        let R = y <= v ? 1 : 0;
        return r === "horizontal" ? {
            left: Math.round(R * g.width),
            top: 0
        } : {
            left: 0,
            top: Math.round(R * g.height)
        };
    }), I = {
        offset: t,
        dropIndex: y,
        dragSourceListId: c,
        dropTargetListId: a,
        dragIndex: u,
        outside: !1,
        items: i,
        dragItem: s,
        offsetsForItems: T,
        dragRect: g,
        status: "accepted"
    };
    return e.acceptsDrop(I) ? {
        event: I,
        error: null,
        success: !0
    } : (I.status = "rejected", {
        event: I,
        error: "rejected by interaction target",
        success: !1
    });
}, $88ab1a78ec8ca4b4$var$Uu = (o, e)=>{
    let { offset: t, activeDragSource: n } = o, { orientation: r, listId: i, listRectangle: a, draggableItems: l } = e.getData(), { dragRectangle: s, dragItem: c, listId: u } = n, d = $88ab1a78ec8ca4b4$var$Ge.from(s.getCenter()), f = u === i, p = a.containsPoint(d);
    if (p && !(f && !e.acceptsSelfDrops()) || e.activeDragSourcePosition === "outside" && !f) return null;
    e.activeDragSourcePosition = "outside";
    let m = f ? n.dragIndex : -1, g = s.toDOMRect(), b = {
        offset: t,
        dropIndex: -1,
        dragIndex: m,
        dragItem: c,
        outside: !p,
        items: l,
        dragSourceListId: u,
        dropTargetListId: i,
        offsetsForItems: f ? l.map((h, y)=>h.id === c.id ? t : p ? {
                left: 0,
                top: 0
            } : y > m ? r === "horizontal" ? {
                left: -c.rect.width,
                top: 0
            } : {
                left: 0,
                top: -c.rect.height
            } : {
                left: 0,
                top: 0
            }) : l.map((h)=>({
                left: 0,
                top: 0
            })),
        dragRect: g,
        status: "accepted"
    };
    return e.acceptsDrop(b) ? {
        event: b,
        error: null,
        success: !0
    } : (b.status = "rejected", {
        event: b,
        error: "rejected by interaction target",
        success: !1
    });
};
var $88ab1a78ec8ca4b4$var$Ee = class Ee {
    static startDrag(e, t) {
        let n = e instanceof $88ab1a78ec8ca4b4$var$lo ? e : new $88ab1a78ec8ca4b4$var$lo(e), r = new $88ab1a78ec8ca4b4$var$dl({
            activeDragSource: n,
            startPoint: t
        });
        return r.on("start", Ee.onDragStart), r.on("move", Ee.onDragMove), r.on("drop", Ee.onDragDrop), r.start(), r;
    }
    static emit(e, ...t) {
        Ee.emitter.emit(e, ...t);
    }
    static on(e, t) {
        return Ee.emitter.on(e, t);
    }
    static registerDragInteractionTarget(e) {
        if (Ee.dragInteractionTargetsMap.has(e.listId)) {
            console.warn(`DragInteractionTarget with listId ${e.listId} already registered`);
            return;
        }
        return Ee.dragInteractionTargetsMap.set(e.listId, e), Ee.emit("register", e), ()=>{
            Ee.unregisterDragInteractionTarget(e);
        };
    }
    static unregisterAll() {
        Ee.dragInteractionTargetsMap.forEach((e)=>{
            Ee.unregisterDragInteractionTarget(e);
        });
    }
    static unregisterDragInteractionTarget(e) {
        if (e) {
            if (!Ee.dragInteractionTargetsMap.has(e.listId)) {
                console.warn(`DragInteractionTarget with listId ${e.listId} not found`);
                return;
            }
            Ee.dragInteractionTargetsMap.delete(e.listId), e.unregister(), Ee.emit("unregister", e);
        }
    }
    static onDragStart(e) {
        let { dragItem: t, dragIndex: n } = e.activeDragSource, r = e.activeDragSource.listId, a = Ee.dragInteractionTargetsMap.get(r)?.getData().acceptDropsFrom, s = !a || a.includes(r) ? r : null;
        Ee.dragInteractionTargetsMap.forEach((c)=>{
            let u = c.getData();
            c.start({
                dragIndex: u.listId === r ? n : -1,
                dragItem: t,
                dragSourceListId: r,
                dropTargetListId: s
            });
        }), Ee.emitter.emit("drag-start", {
            dragSourceListId: r,
            dropTargetListId: s,
            dragItem: t,
            dragIndex: n
        });
    }
    static withDragMove(e, t) {
        let { activeDragSource: n } = e, { listId: r } = n, i = [], a = !0, l = Ee.dragInteractionTargetsMap.get(r);
        l && (a = l.acceptsSelfDrops(), a && i.push(Ee.dragInteractionTargetsMap.get(r))), Ee.dragInteractionTargetsMap.forEach((s)=>{
            s.listId !== r && i.push(s);
        });
        for (let s of i){
            let c = $88ab1a78ec8ca4b4$var$$u(e, s);
            if (c) {
                t(s, c), i.splice(i.indexOf(s), 1);
                break;
            }
        }
        a || i.unshift(l);
        for (let s of i){
            let c = $88ab1a78ec8ca4b4$var$Uu(e, s);
            c && t(s, c);
        }
    }
    static onDragMove(e) {
        let { activeDragSource: t } = e, { listId: n, dragItem: r } = t, i = null, a = [];
        Ee.withDragMove(e, (c, { event: u })=>{
            c.move(u), a.push(u), u.outside || (i = u);
        });
        let l = i ?? a[0] ?? null, s = l?.dropTargetListId ?? null;
        Ee.emit("drag-move", {
            dragSourceListId: n,
            dropTargetListId: s,
            items: l?.items ?? [],
            dragItem: r,
            status: l?.status ?? "accepted",
            dragIndex: l?.dragIndex ?? -1,
            dropIndex: l?.dropIndex ?? -1
        });
    }
    static onDragDrop(e) {
        let { activeDragSource: t } = e, { listId: n, dragItem: r } = t, i = null, a = [];
        Ee.withDragMove(e, (s, { event: c })=>{
            s.drop(c), a.push(c), c.outside || (i = c);
        });
        let l = i ?? a[0] ?? null;
        Ee.emit("drag-drop", {
            dragSourceListId: n,
            dropTargetListId: l?.dropTargetListId ?? null,
            items: l?.items ?? [],
            dragItem: r,
            status: l?.status ?? "accepted",
            dragIndex: l?.dragIndex ?? -1,
            dropIndex: l?.dropIndex ?? -1
        }), Ee.unregisterAll();
    }
};
$88ab1a78ec8ca4b4$var$Ee.dragInteractionTargetsMap = new Map, $88ab1a78ec8ca4b4$var$Ee.emitter = new $88ab1a78ec8ca4b4$var$En;
var $88ab1a78ec8ca4b4$var$pt = $88ab1a78ec8ca4b4$var$Ee, $88ab1a78ec8ca4b4$var$lo = class o {
    static clone(e) {
        let t = e.getData();
        return new o(t);
    }
    constructor(e){
        this.setData(e);
    }
    get listId() {
        return this.data.listId;
    }
    get dragIndex() {
        return this.data.dragIndex ?? -1;
    }
    get dragItem() {
        return this.data.dragItem;
    }
    setData(e) {
        $88ab1a78ec8ca4b4$var$wt(this.data, e) || (this.data = e, this.dragRectangle = new $88ab1a78ec8ca4b4$var$Ie(this.data.dragItem.rect));
    }
    getData() {
        return this.data;
    }
    static shift(e, t) {
        let n = o.clone(e), r = $88ab1a78ec8ca4b4$var$Ie.from(n.dragRectangle);
        return r.shift(t), n.dragRectangle = r, n;
    }
}, $88ab1a78ec8ca4b4$var$dl = class extends $88ab1a78ec8ca4b4$var$En {
    constructor(t){
        super(t.listeners);
        this.phase = "start";
        this.currentOffset = {
            top: 0,
            left: 0
        };
        this.initialDragSource = $88ab1a78ec8ca4b4$var$lo.clone(t.activeDragSource), this.activeDragSource = this.initialDragSource, this.startPoint = {
            top: Math.round(t.startPoint.top),
            left: Math.round(t.startPoint.left)
        };
    }
    get offset() {
        return this.currentOffset;
    }
    start() {
        let { listId: t, dragItem: n } = this.activeDragSource, r = {
            dragSourceListId: t,
            dragItemId: n.id,
            startPoint: this.startPoint
        };
        return this.emit("start", this, r), r;
    }
    drop() {
        this.phase = "drop", this.emit("drop", this);
    }
    move(t) {
        if (this.phase !== "start" && this.phase !== "move") return;
        this.phase = "move";
        let n = {
            top: Math.round(t.top - this.startPoint.top),
            left: Math.round(t.left - this.startPoint.left)
        };
        this.activeDragSource = $88ab1a78ec8ca4b4$var$lo.shift(this.initialDragSource, n), this.currentOffset = n, this.emit("move", this);
    }
};
globalThis.DragManager = $88ab1a78ec8ca4b4$var$pt;
var $88ab1a78ec8ca4b4$var$Yu = $acw62.createContext({
    dragSourceListId: null,
    dropTargetListId: null,
    dragItemId: "",
    status: "accepted",
    updateDragOperationSourceAndTarget: (o)=>{},
    getCurrentDragSourceAndTarget: ()=>({
            dragSourceListId: null,
            dropTargetListId: null,
            status: "accepted",
            dragItemId: ""
        })
}), $88ab1a78ec8ca4b4$var$An = ()=>$acw62.useContext($88ab1a78ec8ca4b4$var$Yu), $88ab1a78ec8ca4b4$var$fl = (o)=>{
    let [e, t] = $acw62.useState({
        dragSourceListId: null,
        dropTargetListId: null,
        dragItemId: "",
        status: "accepted"
    }), n = $acw62.useRef(e);
    n.current = e;
    let r = $acw62.useCallback(()=>{
        let a = n.current;
        return {
            dragSourceListId: a.dragSourceListId,
            dropTargetListId: a.dropTargetListId,
            dragItemId: a.dragItemId,
            status: a.status
        };
    }, []), i = $acw62.useMemo(()=>({
            dragSourceListId: e.dragSourceListId,
            dropTargetListId: e.dropTargetListId,
            dragItemId: e.dragItemId,
            status: e.status,
            updateDragOperationSourceAndTarget: t,
            getCurrentDragSourceAndTarget: r
        }), [
        e,
        t
    ]);
    return (0, $acw62.useEffect)(()=>{
        let a = $88ab1a78ec8ca4b4$var$pt.on("drag-start", (c)=>{
            t({
                dragSourceListId: c.dragSourceListId,
                dropTargetListId: c.dropTargetListId,
                dragItemId: c.dragItem.id,
                status: "accepted"
            });
        }), l = $88ab1a78ec8ca4b4$var$pt.on("drag-move", (c)=>{
            let u = n.current, d = {
                dragSourceListId: c.dragSourceListId,
                dropTargetListId: c.dropTargetListId,
                dragItemId: c.dragItem.id,
                status: c.status
            };
            JSON.stringify(u) !== JSON.stringify(d) && t(d);
        }), s = $88ab1a78ec8ca4b4$var$pt.on("drag-drop", ()=>{
            t({
                dragSourceListId: null,
                dropTargetListId: null,
                dragItemId: "",
                status: "accepted"
            });
        });
        return ()=>{
            a(), l(), s();
        };
    }, [
        $88ab1a78ec8ca4b4$var$pt,
        t
    ]), $acw62.createElement($88ab1a78ec8ca4b4$var$Yu.Provider, {
        value: i
    }, typeof o.children == "function" ? o.children(i) : o.children);
};
var $88ab1a78ec8ca4b4$var$pl = `${$88ab1a78ec8ca4b4$var$rt}Body`, $88ab1a78ec8ca4b4$var$qu = (o)=>o.querySelector(`.${$88ab1a78ec8ca4b4$var$pl}`);
var $88ab1a78ec8ca4b4$var$_n = `${$88ab1a78ec8ca4b4$var$rt}HeaderCell`, $88ab1a78ec8ca4b4$var$ml = `${$88ab1a78ec8ca4b4$var$rt}HeaderWrapper`, $88ab1a78ec8ca4b4$var$Xu = (o)=>Array.from(o.querySelectorAll(`.${$88ab1a78ec8ca4b4$var$ml}`));
function $88ab1a78ec8ca4b4$var$$r(o) {
    if (!o) return !1;
    let e = o.tagName;
    return e === "INPUT" || e === "BUTTON";
}
var $88ab1a78ec8ca4b4$var$jb = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.baseZIndexForCells), $88ab1a78ec8ca4b4$var$$b = (o, e)=>{
    let t = !o || Object.keys(o).length === 0, n = !e || Object.keys(e).length === 0;
    return t && n ? !0 : !!o != !!e ? !1 : $88ab1a78ec8ca4b4$var$wt(o, e);
}, $88ab1a78ec8ca4b4$var$Ju = ({ columnId: o, domRef: e, horizontalLayoutPageIndex: t, allowColumnHideOnDrag: n })=>{
    let [r, i] = (0, $acw62.useState)(null), [a, l] = (0, $acw62.useState)(!1), { getCurrentDragSourceAndTarget: s } = $88ab1a78ec8ca4b4$var$An(), { actions: c, computed: u, getComputed: d, getState: f, api: p, state: { domRef: m } } = $88ab1a78ec8ca4b4$var$Q(), g = (0, $acw62.useCallback)((h)=>{
        let y = d().computedVisibleColumnsMap.get(o);
        if (!y || !y.computedSortable) return;
        let { multiSortBehavior: S } = f();
        p.toggleSortingForColumn(o, {
            multiSortBehavior: S === "replace" && (h.ctrlKey || h.metaKey) ? "append" : S
        });
    }, []), b = (0, $acw62.useCallback)((h)=>{
        if ($88ab1a78ec8ca4b4$var$$r(h.target)) return;
        let { brain: y, draggableColumnsRestrictTo: S } = f(), { computedVisibleColumns: C, computedVisibleColumnsMap: T, computedPinnedStartColumns: I, computedUnpinnedColumns: w, computedPinnedEndColumns: v } = d(), R = T.get(o);
        if (!R.computedDraggable) {
            g(h);
            return;
        }
        let x = e.current, M = x.getBoundingClientRect(), A = m.current.getBoundingClientRect(), E = y.getAvailableSize(), P = R.computedVisibleIndex, _ = y.getVirtualColIndex(R.computedVisibleIndex, {
            pageIndex: t || 0
        }), D = y.isHorizontalLayoutBrain ? y.getPageWidth() : null, O = x.style.cursor ?? "auto", F = !1, W = m.current, z = $88ab1a78ec8ca4b4$var$Ie.from($88ab1a78ec8ca4b4$var$qu(W).getBoundingClientRect()), L = $88ab1a78ec8ca4b4$var$Xu(W).map((ue)=>$88ab1a78ec8ca4b4$var$Ie.from(ue.getBoundingClientRect())), ae = z.getMinimumBoundingRectangle(...L), te = $88ab1a78ec8ca4b4$var$Wu({
            brain: y,
            horizontalLayoutPageIndex: t,
            allowColumnHideOnDrag: n,
            pageWidth: D,
            draggableColumnsRestrictTo: S,
            computedPinnedEndColumns: v,
            computedPinnedStartColumns: I,
            computedUnpinnedColumns: w,
            computedVisibleColumns: C,
            computedVisibleColumnsMap: T,
            dragColumnHeaderTargetRect: M,
            dragColumnId: o,
            getCurrentDragSourceAndTarget: s,
            api: p,
            infiniteDOMNode: m.current,
            setProxyPosition: i,
            setDragColumnOutside: l,
            tableRect: A,
            acceptDropToReorderRect: ae,
            initialMousePosition: {
                clientX: h.clientX,
                clientY: h.clientY
            }
        }), B = null, j, oe;
        function me(ue) {
            let { columnPinning: ge, columnOrder: H } = ue;
            $88ab1a78ec8ca4b4$var$$b(f().columnPinning, ge) || (c.columnPinning = ge);
            let G = d().computedColumnOrder;
            JSON.stringify(H, G) && (C.forEach((q)=>{
                $88ab1a78ec8ca4b4$var$ro(q.computedVisibleIndex, "", m.current);
            }), c.columnOrder = $88ab1a78ec8ca4b4$var$ul({
                newColumnOrder: H,
                visibleColumnOrder: d().computedVisibleColumns.map((q)=>q.id),
                existingColumnOrder: G,
                dragColumnId: o
            }));
        }
        let pe = (ue)=>{
            let { headerBrain: ge, brain: H } = f();
            if (!F) {
                F = !0;
                let G = H.keepColumnRendered(_), q = ge.keepColumnRendered(_);
                if (H.isHorizontalLayoutBrain) {
                    let re = H.extendRenderRange({
                        start: !0,
                        end: !0,
                        direction: "horizontal"
                    }), J = ge.extendRenderRange({
                        start: !0,
                        end: !0,
                        direction: "horizontal"
                    });
                    oe = ()=>{
                        re(), J();
                    };
                }
                j = ()=>{
                    G(), q();
                }, c.columnReorderDragColumnId = R.id, t != null && (c.columnReorderInPageIndex = t), $88ab1a78ec8ca4b4$var$il(P, `calc( var(${$88ab1a78ec8ca4b4$var$jb}) + 10000 )`, m.current), m.current?.classList.add($88ab1a78ec8ca4b4$var$ll), x.style.cursor = "grabbing";
            }
            B = te.onMove(ue);
        }, ce = (ue)=>{
            let ge = ue.pointerId;
            requestAnimationFrame(()=>{
                let { multiSortBehavior: H } = f(), G = e.current;
                m.current?.classList.remove($88ab1a78ec8ca4b4$var$ll), te.stop(), y.update({
                    ...E
                }), j?.(), oe?.(), C.forEach((K)=>{
                    $88ab1a78ec8ca4b4$var$Wr(K.computedVisibleIndex, m.current), $88ab1a78ec8ca4b4$var$$o(K.computedVisibleIndex, "", m.current), $88ab1a78ec8ca4b4$var$ro(K.computedVisibleIndex, "", m.current);
                }), $88ab1a78ec8ca4b4$var$il(P, $88ab1a78ec8ca4b4$var$cl(R, {
                    pinnedStartColsCount: I.length,
                    visibleColsCount: C.length
                }), m.current), G.style.cursor = O, G.releasePointerCapture(ge), G.removeEventListener("pointermove", pe), G.removeEventListener("pointerup", ce), i(null);
                let q = p.getColumnApi(R.id)?.isSortable() ?? !1;
                !F && q && p.toggleSortingForColumn(R.id, {
                    multiSortBehavior: H === "replace" && (ue.ctrlKey || ue.metaKey) ? "append" : H
                }), B ? me(B) : F && n && p.setVisibilityForColumn(R.id, !1), c.columnReorderDragColumnId = !1, t != null && (c.columnReorderInPageIndex = null);
            });
        };
        x.addEventListener("pointermove", pe), x.addEventListener("pointerup", ce), x.setPointerCapture(h.pointerId);
    }, [
        o,
        t
    ]);
    return {
        onPointerDown: u.computedVisibleColumnsMap.get(o)?.computedDraggable ? b : g,
        dragColumnOutside: a,
        proxyPosition: r
    };
};
var $88ab1a78ec8ca4b4$var$ed = (o)=>o.dataSourceHasGrouping && o.isGroupRow && o.childrenLoading || !o.selfLoaded;
var $88ab1a78ec8ca4b4$var$td = "_6rdmyg0 _16lm1iw1d _16lm1iwk _16lm1iw9", $88ab1a78ec8ca4b4$var$nd = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_6rdmyg1",
    variantClassNames: {
        expanded: {
            true: "_16lm1iwi",
            false: "_6rdmyg3"
        },
        direction: {
            end: "_6rdmyg4",
            start: "_6rdmyg5"
        },
        disabled: {
            true: "_6rdmyg6",
            false: "_6rdmyg7"
        }
    },
    defaultVariants: {},
    compoundVariants: [
        [
            {
                expanded: !1,
                direction: "end"
            },
            "_16lm1iwj"
        ]
    ]
});
var $88ab1a78ec8ca4b4$var$Ur = `${$88ab1a78ec8ca4b4$var$ft}-expand-collapse`;
function $88ab1a78ec8ca4b4$var$On(o) {
    let { size: e = 24, direction: t = "start", disabled: n = !1 } = o, [r, i] = (0, $acw62.useState)(o.expanded ?? o.defaultExpanded), a = ()=>{
        o.onChange?.(!r), $88ab1a78ec8ca4b4$var$ln("expanded", o) || i(!r);
    };
    $acw62.useEffect(()=>{
        $88ab1a78ec8ca4b4$var$ln("expanded", o) && i(o.expanded);
    }, [
        o.expanded
    ]);
    let l = r ? "expanded" : "collapsed";
    return $acw62.createElement("svg", {
        "data-name": "expand-collapse-icon",
        "data-state": l,
        "data-disabled": n,
        xmlns: "http://www.w3.org/2000/svg",
        height: `${e}px`,
        viewBox: "0 0 24 24",
        width: `${e}px`,
        style: o.style,
        onClick: n ? void 0 : a,
        className: $88ab1a78ec8ca4b4$var$X(o.className, $88ab1a78ec8ca4b4$var$td, $88ab1a78ec8ca4b4$var$nd({
            direction: t || "start",
            expanded: r,
            disabled: n
        }), `${$88ab1a78ec8ca4b4$var$ft}`, `${$88ab1a78ec8ca4b4$var$Ur}`, `${$88ab1a78ec8ca4b4$var$Ur}--${l}`, `${$88ab1a78ec8ca4b4$var$Ur}--${t === "end" ? "end" : "start"}`, n ? `${$88ab1a78ec8ca4b4$var$Ur}--disabled` : "")
    }, $acw62.createElement("path", {
        d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
    }));
}
var $88ab1a78ec8ca4b4$var$od = "_16lm1iwb _16lm1iw1d _16lm1iwk";
var $88ab1a78ec8ca4b4$var$rd = (o)=>$acw62.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            margin: "auto",
            display: "block",
            shapeRendering: "auto"
        },
        width: "24px",
        height: "24px",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: $88ab1a78ec8ca4b4$var$X(o.className, $88ab1a78ec8ca4b4$var$od, "InfiniteIcon", "InfiniteIcon-loading")
    }, $acw62.createElement("circle", {
        cx: "50",
        cy: "50",
        fill: "none",
        strokeWidth: "10",
        r: "35",
        strokeDasharray: "164.93361431346415 56.97787143782138"
    }, $acw62.createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        repeatCount: "indefinite",
        dur: "1s",
        values: "0 50 50;360 50 50",
        keyTimes: "0;1"
    })));
var { rootClassName: $88ab1a78ec8ca4b4$var$Yb } = $88ab1a78ec8ca4b4$var$Fe, $88ab1a78ec8ca4b4$var$zt = `${$88ab1a78ec8ca4b4$var$Yb}ColumnCell`;
var $88ab1a78ec8ca4b4$var$id = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_7pupv01",
    variantClassNames: {
        align: {
            start: "_7pupv02",
            center: "_7pupv03",
            end: "_7pupv04"
        }
    },
    defaultVariants: {},
    compoundVariants: []
}), $88ab1a78ec8ca4b4$var$ad = "_7pupv00", $88ab1a78ec8ca4b4$var$ld = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_7pupv05",
    variantClassNames: {
        align: {
            start: "_7pupv06",
            center: "_7pupv07",
            end: "_7pupv08"
        }
    },
    defaultVariants: {},
    compoundVariants: []
});
function $88ab1a78ec8ca4b4$var$sd({ rowInfo: o }) {
    return {
        [$88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$se.components.Row.groupNesting)]: o.dataSourceHasGrouping ? o.isGroupRow ? o.groupNesting - 1 : o.groupNesting : 0
    };
}
function $88ab1a78ec8ca4b4$var$qr({ groupIndexForColumn: o, groupRenderStrategy: e }) {
    return (t)=>{
        let { rowInfo: n, renderBag: r, column: i, align: a } = t, { value: l, groupIcon: s, selectionCheckBox: c } = r, u = n, d = $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$Zn.flex, i.align === "end" ? $88ab1a78ec8ca4b4$var$Bo.rowReverse : $88ab1a78ec8ca4b4$var$Bo.row, $88ab1a78ec8ca4b4$var$dc.center, `${$88ab1a78ec8ca4b4$var$zt}Expander`, e === "single-column" || e === "multi-column" && (!n.isGroupRow || c) ? $88ab1a78ec8ca4b4$var$id({
            align: a
        }) : null);
        if (e === "multi-column") {
            if (o + 1 !== u.groupNesting && u.isGroupRow) return c ? $acw62.createElement("div", {
                className: d
            }, c) : null;
        } else e === "single-column" && u.isGroupRow;
        return $acw62.createElement("div", {
            className: d
        }, s, c, $acw62.createElement("div", {
            className: $88ab1a78ec8ca4b4$var$Lt
        }, l ?? null));
    };
}
function $88ab1a78ec8ca4b4$var$Xr({ groupIndexForColumn: o, groupRenderStrategy: e, toggleGroupRow: t, initialRenderGroupIcon: n }) {
    return (r)=>{
        let { rowInfo: i, value: a, rootGroupBy: l, pivotBy: s, column: c } = r, u = e !== "inline" ? i : i.isGroupRow && i.parents?.[o] || i;
        if (!u) return null;
        let d = u.collapsed;
        if (e === "inline") {
            if (u.groupCount === 1) return a;
            if (u.groupNesting === o && d) return null;
        } else if (!u.isGroupRow || e === "multi-column" && o + 1 !== u.groupNesting) return null;
        let f = u.groupKeys, p = null, m = s ? (u.groupKeys?.length || 0) < l?.length : (u.groupKeys?.length || 0) <= l?.length;
        return $88ab1a78ec8ca4b4$var$ed(u) ? p = $acw62.createElement($88ab1a78ec8ca4b4$var$rd, null) : m && (p = $acw62.createElement($88ab1a78ec8ca4b4$var$On, {
            expanded: !d,
            direction: c.align === "end" ? "end" : "start",
            onChange: ()=>{
                t(f);
            }
        })), n && (r.renderBag.groupIcon = p, p = $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
            render: n,
            renderParam: r
        })), p;
    };
}
function $88ab1a78ec8ca4b4$var$cd(o, e, t) {
    let { groupByForColumn: n, groupIndexForColumn: r, groupRenderStrategy: i } = o, a = n.column ? {
        ...n.column
    } : {}, l = {
        header: `Group by ${n.field || n.groupField}`,
        groupByForColumn: n,
        render: $88ab1a78ec8ca4b4$var$qr({
            groupIndexForColumn: r,
            groupRenderStrategy: i
        }),
        ...a,
        renderGroupIcon: $88ab1a78ec8ca4b4$var$Xr({
            initialRenderGroupIcon: a?.renderGroupIcon,
            groupIndexForColumn: r,
            toggleGroupRow: e,
            groupRenderStrategy: i
        })
    };
    return t && (typeof t == "function" ? l = {
        ...l,
        ...t(o, e)
    } : l = {
        ...l,
        ...t
    }), l;
}
function $88ab1a78ec8ca4b4$var$ud(o, e, t) {
    let n = typeof t == "function" ? t(o, e) : t, r = {};
    return o.sortable != null && (r.sortable = o.sortable), {
        ...r,
        header: "Group",
        groupByForColumn: o.groupBy,
        renderSelectionCheckBox: o.selectionMode === "multi-row",
        render: $88ab1a78ec8ca4b4$var$qr({
            groupIndexForColumn: 0,
            groupRenderStrategy: "single-column"
        }),
        ...n,
        renderGroupIcon: $88ab1a78ec8ca4b4$var$Xr({
            initialRenderGroupIcon: n?.renderGroupIcon,
            groupIndexForColumn: 0,
            toggleGroupRow: e,
            groupRenderStrategy: "single-column"
        })
    };
}
var $88ab1a78ec8ca4b4$var$dd = "_1eexc2a7 _1eexc2a6", $88ab1a78ec8ca4b4$var$fd = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_1eexc2an",
    variantClassNames: {
        dragging: {
            false: "_1eexc2ao",
            true: "_1eexc2ap"
        },
        insideDisabledDraggingPage: {
            true: "_1eexc2aq",
            false: "_1eexc2ar"
        },
        cellSelected: {
            false: "_1eexc2as",
            true: "_1eexc2at"
        },
        treeNode: {
            parent: "_1eexc2au",
            leaf: "_1eexc2av",
            false: "_1eexc2aw"
        },
        align: {
            start: "_1eexc2ax",
            end: "_1eexc2ay",
            center: "_1eexc2az"
        },
        verticalAlign: {
            start: "_1eexc2a10",
            end: "_1eexc2a11",
            center: "_1eexc2a12"
        },
        rowActive: {
            false: "_1eexc2a13",
            true: "_1eexc2a14"
        },
        groupRow: {
            false: "_1eexc2a15",
            true: "_1eexc2a16"
        },
        groupCell: {
            false: "_1eexc2a17",
            true: "_1eexc2a18"
        },
        rowDisabled: {
            false: "_1eexc2a19",
            true: "_1eexc2a1a"
        },
        zebra: {
            false: "_1eexc2a1b",
            even: "_1eexc2a1c",
            odd: "_1eexc2a1d"
        },
        rowSelected: {
            true: "_1eexc2a1e",
            false: "_1eexc2a1f",
            null: "_1eexc2a1g"
        },
        first: {
            true: "_1eexc2a1h",
            false: "_1eexc2a1i"
        },
        last: {
            true: "_1eexc2a1j",
            false: "_1eexc2a1k"
        },
        groupByField: {
            true: "_1eexc2a1l",
            false: "_1eexc2a1m"
        },
        firstInCategory: {
            true: "_1eexc2a1n",
            false: "_1eexc2a1o"
        },
        firstRow: {
            true: "_1eexc2a1p",
            false: "_1eexc2a1q"
        },
        firstRowInHorizontalLayoutPage: {
            true: "_1eexc2a1r",
            false: "_1eexc2a1s"
        },
        lastInCategory: {
            true: "_1eexc2a1t",
            false: "_1eexc2a1u"
        },
        pinned: {
            start: "_1eexc2a1v",
            end: "_1eexc2a1w",
            false: "_1eexc2a1x"
        },
        filtered: {
            true: "_1eexc2a1y",
            false: "_1eexc2a1z"
        }
    },
    defaultVariants: {},
    compoundVariants: [
        [
            {
                firstRowInHorizontalLayoutPage: !0,
                firstRow: !1
            },
            "_1eexc2a20"
        ],
        [
            {
                pinned: "start",
                lastInCategory: !0
            },
            "_1eexc2a21"
        ],
        [
            {
                pinned: "start",
                firstInCategory: !0
            },
            "_1eexc2a22"
        ],
        [
            {
                pinned: "end",
                firstInCategory: !0
            },
            "_1eexc2a23"
        ],
        [
            {
                pinned: "end",
                lastInCategory: !0
            },
            "_1eexc2a24"
        ],
        [
            {
                align: "center",
                groupCell: !1
            },
            "_1eexc2a25"
        ],
        [
            {
                rowDisabled: !0,
                zebra: "odd"
            },
            "_1eexc2a26"
        ]
    ]
}), $88ab1a78ec8ca4b4$var$pd = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_1eexc2ae",
    variantClassNames: {
        right: {
            true: "_1eexc2af",
            false: "_1eexc2ag"
        },
        left: {
            true: "_1eexc2ah",
            false: "_1eexc2ai"
        },
        top: {
            true: "_1eexc2aj",
            false: "_1eexc2ak"
        },
        bottom: {
            true: "_1eexc2al",
            false: "_1eexc2am"
        }
    },
    defaultVariants: {},
    compoundVariants: []
});
var $88ab1a78ec8ca4b4$var$md = "_1eexc2a5", $88ab1a78ec8ca4b4$var$Zr = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_1eexc2aa",
    variantClassNames: {
        direction: {
            up: "_1eexc2ab",
            down: "_1eexc2ac",
            neutral: "_1eexc2ad"
        }
    },
    defaultVariants: {},
    compoundVariants: []
}), $88ab1a78ec8ca4b4$var$Qr = "_1eexc2a8";
var $88ab1a78ec8ca4b4$var$gd = "qz8ht90 _16lm1iwk";
function $88ab1a78ec8ca4b4$var$Zb() {
    return {
        checked: 1,
        disabled: (o)=>o ?? !1,
        domProps: 1
    };
}
var { ManagedComponentContextProvider: $88ab1a78ec8ca4b4$var$Qb } = $88ab1a78ec8ca4b4$export$c6a0e0787a01a4e5({
    forwardProps: $88ab1a78ec8ca4b4$var$Zb,
    mappedCallbacks: {
        checked: (o)=>({
                callbackName: "onChange",
                callbackParams: [
                    o
                ]
            })
    },
    debugName: "InfiniteCheckBox"
});
function $88ab1a78ec8ca4b4$var$Jb() {
    let { componentState: o, componentActions: e } = $88ab1a78ec8ca4b4$export$2e1456d250441a8(), { checked: t, domProps: n, disabled: r } = o, i = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(()=>{
        i.current.indeterminate = t == null;
    }, [
        t
    ]), $acw62.createElement("input", {
        ...n,
        className: $88ab1a78ec8ca4b4$var$X("InfiniteCheckBox", $88ab1a78ec8ca4b4$var$gd, n?.className),
        type: "checkbox",
        ref: i,
        checked: !!t,
        disabled: r,
        onChange: ()=>{
            r || (e.checked = !t);
        }
    });
}
function $88ab1a78ec8ca4b4$var$Wt(o) {
    return $acw62.createElement($88ab1a78ec8ca4b4$var$Qb, {
        ...o
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$Jb, null));
}
function $88ab1a78ec8ca4b4$var$ey(o) {
    return typeof o.field == "string";
}
function $88ab1a78ec8ca4b4$var$hd(o) {
    let { column: e, rowInfo: t, fieldsToColumn: n } = o, r;
    if (e.groupByForColumn) {
        if (t.isGroupRow) {
            let i = t.groupBy[t.groupBy.length - 1];
            r = i ? n.get(i.field || i.groupField) : void 0;
        }
        !r && e.field && (r = n.get(e.field));
    }
    return r;
}
function $88ab1a78ec8ca4b4$var$mt(o) {
    let { getComputed: e, getDataSourceState: t, getState: n, rowIndex: r, columnId: i, api: a, dataSourceApi: l } = o, { dataArray: s } = t(), c = s[r], { isGroupRow: u, isTreeNode: d } = c, f = e().computedColumnsMap.get(i), { activeRowIndex: p, keyboardNavigation: m, isRowDetailEnabled: g } = n(), b = r === p && m === "row", h = !g || typeof g == "function" && !g(c) ? !1 : a.rowDetailApi.isRowDetailExpanded(c.id) ? "expanded" : "collapsed", { formattedValue: y, formattedValueContext: { rawValue: S } } = $88ab1a78ec8ca4b4$var$so({
        column: f,
        rowInfo: c,
        rowDetailState: h,
        columnsMap: e().computedColumnsMap,
        context: o
    }), C = $88ab1a78ec8ca4b4$var$it(f.id, o);
    return u ? {
        api: a,
        dataSourceApi: l,
        column: f,
        columnApi: C,
        isParentNode: !1,
        isGroupRow: !0,
        isTreeNode: !1,
        rowDetailState: !1,
        data: c.data,
        rowActive: b,
        rowInfo: c,
        rowSelected: c.rowSelected,
        value: y,
        rawValue: S
    } : d ? c.isParentNode ? {
        api: a,
        dataSourceApi: l,
        columnApi: C,
        column: f,
        nodeExpanded: c.nodeExpanded,
        isTreeNode: !0,
        isGroupRow: !1,
        isParentNode: !0,
        rowDetailState: h,
        data: c.data,
        rowActive: b,
        rowInfo: c,
        rowSelected: c.rowSelected,
        value: y,
        rawValue: S
    } : {
        api: a,
        dataSourceApi: l,
        columnApi: C,
        column: f,
        nodeExpanded: !1,
        isTreeNode: !0,
        isGroupRow: !1,
        isParentNode: !1,
        rowDetailState: h,
        data: c.data,
        rowActive: b,
        rowInfo: c,
        rowSelected: c.rowSelected,
        value: y,
        rawValue: S
    } : {
        api: a,
        dataSourceApi: l,
        columnApi: C,
        column: f,
        isTreeNode: !1,
        isParentNode: !1,
        isGroupRow: !1,
        rowDetailState: h,
        data: c.data,
        rowActive: b,
        rowInfo: c,
        rowSelected: c.rowSelected,
        value: y,
        rawValue: S
    };
}
function $88ab1a78ec8ca4b4$var$bd(o) {
    return $88ab1a78ec8ca4b4$var$Td(o.column, o.rowInfo);
}
function $88ab1a78ec8ca4b4$var$yd(o) {
    let { column: e, context: t, rowInfo: n, visibleColumnsIds: r } = o, i = $88ab1a78ec8ca4b4$var$hd({
        rowInfo: n,
        column: e,
        fieldsToColumn: o.fieldsToColumn,
        groupRenderStrategy: t.getState().groupRenderStrategy
    }), { getState: a } = t, { editingCell: l } = a(), s = $88ab1a78ec8ca4b4$var$so(o), { formattedValueContext: c } = s, u = t.api.isEditorVisibleForCell({
        columnId: e.id,
        rowIndex: n.indexInAll
    }), d = Object.assign({
        rowIndexInHorizontalLayoutPage: o.rowIndexInHorizontalLayoutPage,
        horizontalLayoutPageIndex: o.horizontalLayoutPageIndex,
        column: o.column,
        inEdit: u,
        rowHasSelectedCells: !1
    }, c, {
        editError: l && l.primaryKey === n.id && l.columnId === e.id && !l.active && l.accepted instanceof Error ? l.accepted : void 0
    });
    Object.defineProperty(d, "rowHasSelectedCells", {
        get () {
            return n.hasSelectedCells(r);
        }
    });
    let f = typeof e.align == "function" ? e.align({
        isHeader: !1,
        ...d
    }) : e.align ?? "start", p = typeof e.verticalAlign == "function" ? e.verticalAlign({
        isHeader: !1,
        ...d
    }) : e.verticalAlign ?? "center";
    return {
        inEdit: u,
        stylingParam: d,
        formattedValueContext: c,
        renderFunctions: {
            renderGroupIcon: e.renderGroupIcon || i?.renderGroupIcon,
            renderSelectionCheckBox: e.renderSelectionCheckBox,
            renderRowDetailIcon: e.renderRowDetailIcon,
            renderTreeIcon: e.renderTreeIcon,
            renderTreeIconForParentNode: e.renderTreeIconForParentNode,
            renderTreeIconForLeafNode: e.renderTreeIconForLeafNode,
            renderValue: e.renderValue || i?.renderValue,
            renderGroupValue: e.renderGroupValue || i?.renderGroupValue,
            renderLeafValue: e.renderLeafValue || i?.renderLeafValue
        },
        renderParams: $88ab1a78ec8ca4b4$var$ty({
            rowIndexInHorizontalLayoutPage: o.rowIndexInHorizontalLayoutPage,
            horizontalLayoutPageIndex: o.horizontalLayoutPageIndex,
            column: o.column,
            rowInfo: o.rowInfo,
            visibleColumnsIds: o.visibleColumnsIds,
            columnsMap: o.columnsMap,
            fieldsToColumn: o.fieldsToColumn,
            context: o.context,
            align: f,
            verticalAlign: p,
            formattedValueContext: c
        }),
        groupByColumnReference: i
    };
}
function $88ab1a78ec8ca4b4$var$ty(o) {
    let { column: e, context: t, rowInfo: n, align: r, verticalAlign: i, visibleColumnsIds: a, columnsMap: l, fieldsToColumn: s, formattedValueContext: c } = o, { value: u } = c, { api: d, getDataSourceState: f, getState: p, dataSourceApi: m } = t, { editingCell: g } = p(), { indexInAll: b } = n, h = f(), { selectionMode: y, cellSelection: S } = h, C = $88ab1a78ec8ca4b4$var$hd({
        rowInfo: n,
        column: e,
        fieldsToColumn: s,
        groupRenderStrategy: t.getState().groupRenderStrategy
    }), T = d.toggleGroupRow, I = S?.isCellSelected(n.id, e.id) ?? !1, w = {
        column: e,
        columnsMap: l,
        fieldsToColumn: s,
        align: r,
        verticalAlign: i,
        cellSelected: I,
        rowHasSelectedCells: !1,
        horizontalLayoutPageIndex: o.horizontalLayoutPageIndex,
        rowIndexInHorizontalLayoutPage: o.rowIndexInHorizontalLayoutPage,
        ...c,
        editError: g && g.primaryKey === n.id && g.columnId === e.id && !g.active && g.accepted instanceof Error ? g.accepted : void 0,
        groupByColumn: C,
        selectionMode: y,
        api: d,
        dataSourceApi: m,
        toggleCurrentRowDetails: ()=>d.rowDetailApi.toggleRowDetail(n.id),
        toggleRowDetails: d.rowDetailApi.toggleRowDetail,
        expandRowDetails: d.rowDetailApi.expandRowDetail,
        collapseRowDetails: d.rowDetailApi.collapseRowDetail,
        toggleCurrentTreeNode: ()=>{
            m.treeApi.toggleNode(n.nodePath);
        },
        toggleTreeNode: m.treeApi.toggleNode,
        expandTreeNode: m.treeApi.expandNode,
        collapseTreeNode: m.treeApi.collapseNode,
        selectTreeNode: m.treeApi.selectNode,
        deselectTreeNode: m.treeApi.deselectNode,
        toggleTreeNodeSelection: m.treeApi.toggleNodeSelection,
        toggleCurrentTreeNodeSelection: ()=>{
            n.isTreeNode && m.treeApi.toggleNodeSelection(n.nodePath);
        },
        selectRow: d.rowSelectionApi.selectRow,
        deselectRow: d.rowSelectionApi.deselectRow,
        toggleRowSelection: d.rowSelectionApi.toggleRowSelection,
        toggleGroupRowSelection: d.rowSelectionApi.toggleGroupRowSelection,
        selectCell: ()=>{
            d.cellSelectionApi.selectCell({
                rowId: n.id,
                colId: e.id
            });
        },
        deselectCell: ()=>{
            d.cellSelectionApi.deselectCell({
                rowId: n.id,
                colId: e.id
            });
        },
        renderBag: {
            all: null,
            value: typeof u == "boolean" ? `${u}` : u,
            selectionCheckBox: null,
            groupIcon: null,
            treeIcon: null
        },
        selectCurrentRow: ()=>{
            if (!n.isTreeNode) return d.rowSelectionApi.selectRow(n.id, n.dataSourceHasGrouping ? n.groupKeys : void 0);
        },
        deselectCurrentRow: ()=>{
            if (!n.isTreeNode) return d.rowSelectionApi.deselectRow(n.id, n.dataSourceHasGrouping ? n.groupKeys : void 0);
        },
        rowIndex: b,
        toggleGroupRow: T,
        toggleCurrentGroupRow: ()=>{
            n.isGroupRow && T(n.groupKeys);
        },
        toggleCurrentRowSelection: ()=>{
            if (!(n.isGroupRow || n.isTreeNode)) return d.rowSelectionApi.toggleRowSelection(n.id);
        },
        toggleCurrentGroupRowSelection: ()=>{
            if (n.isGroupRow) return d.rowSelectionApi.toggleGroupRowSelection(n.isGroupRow ? n.groupKeys : []);
        },
        rootGroupBy: h.groupBy,
        pivotBy: h.pivotBy
    };
    return Object.defineProperty(w, "rowHasSelectedCells", {
        get () {
            return n.hasSelectedCells(a);
        }
    }), w;
}
function $88ab1a78ec8ca4b4$var$Td(o, e) {
    let { data: t, isGroupRow: n, dataSourceHasGrouping: r } = e, i = r ? e.groupBy : void 0, a = n && i && o.groupByForColumn && (Array.isArray(o.groupByForColumn) || o.groupByForColumn === i[i.length - 1]) ? e.value : $88ab1a78ec8ca4b4$var$ey(o) ? t?.[o.field] : null;
    return o.field && e.isGroupRow && e.reducerData && e.reducerData[o.field] != null && (a = e.reducerData[o.field]), o.valueGetter && !e.isGroupRow && e.data && (a = o.valueGetter({
        data: e.data,
        field: o.field
    })), a;
}
function $88ab1a78ec8ca4b4$var$ny(o, e, t, n, r) {
    let { rowSelected: i, indexInAll: a } = t, { activeRowIndex: l, keyboardNavigation: s } = n.getState(), c = a === l && s === "row";
    return t.isGroupRow ? {
        rowInfo: t,
        isGroupRow: !0,
        isTreeNode: !1,
        isParentNode: !1,
        data: t.data,
        rowDetailState: !1,
        rowSelected: i,
        rowActive: c,
        value: o,
        rawValue: o,
        field: e.field
    } : t.isTreeNode ? t.isParentNode ? {
        rowInfo: t,
        isGroupRow: !1,
        isTreeNode: !0,
        isParentNode: !0,
        nodeExpanded: t.nodeExpanded,
        data: t.data,
        rowDetailState: r,
        rowSelected: i,
        rowActive: c,
        value: o,
        rawValue: o,
        field: e.field
    } : {
        rowInfo: t,
        isGroupRow: !1,
        isTreeNode: !0,
        isParentNode: !1,
        nodeExpanded: !1,
        data: t.data,
        rowDetailState: r,
        rowSelected: i,
        rowActive: c,
        value: o,
        rawValue: o,
        field: e.field
    } : {
        rowInfo: t,
        isGroupRow: !1,
        isTreeNode: !1,
        isParentNode: !1,
        data: t.data,
        rowDetailState: r,
        rowSelected: i,
        rowActive: c,
        value: o,
        rawValue: o,
        field: e.field
    };
}
function $88ab1a78ec8ca4b4$var$so(o) {
    let { column: e, rowInfo: t, context: n, rowDetailState: r } = o, i = $88ab1a78ec8ca4b4$var$Td(e, t), a = $88ab1a78ec8ca4b4$var$ny(i, e, t, n, r), l = e.valueFormatter ? e.valueFormatter(a) : i;
    return a.value = l, {
        formattedValue: l,
        formattedValueContext: a
    };
}
var { rootClassName: $88ab1a78ec8ca4b4$var$Sd } = $88ab1a78ec8ca4b4$var$Fe, $88ab1a78ec8ca4b4$var$Fn = `${$88ab1a78ec8ca4b4$var$Sd}Cell`, $88ab1a78ec8ca4b4$var$gl = `${$88ab1a78ec8ca4b4$var$Sd}Cell_content`, $88ab1a78ec8ca4b4$var$oy = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnWidthAtIndex), $88ab1a78ec8ca4b4$var$ry = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnReorderEffectDurationAtIndex);
function $88ab1a78ec8ca4b4$var$iy(o) {
    let { cssEllipsis: e = !0, virtualized: t = !0, skipColumnShifting: n = !1, contentStyle: r, column: i, domRef: a, width: l, contentClassName: s, rowId: c, afterChildren: u, beforeChildren: d, cellType: f, cssPosition: p, renderChildren: m, horizontalLayoutPageIndex: g, ...b } = o, h = typeof m == "function" ? m() : m, y = {
        width: `var(${$88ab1a78ec8ca4b4$var$oy}-${i.computedVisibleIndex})`,
        transition: `transform var(${$88ab1a78ec8ca4b4$var$ry}-${i.computedVisibleIndex}, 0s)`,
        ...b.style
    }, S = {
        ...b,
        style: y,
        "data-column-id": i.id,
        "data-z-index": y.zIndex,
        className: $88ab1a78ec8ca4b4$var$X(b.className, $88ab1a78ec8ca4b4$var$Fn, $88ab1a78ec8ca4b4$var$dd),
        children: $acw62.createElement($acw62.Fragment, null, d, $acw62.createElement("div", {
            className: $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$gl, e ? $88ab1a78ec8ca4b4$var$Lt : $88ab1a78ec8ca4b4$var$bc.hidden, s),
            style: r
        }, h), u)
    };
    c != null && (S["data-row-id"] = `${c}`);
    let C = f === "body" ? i.components?.ColumnCell : i.components?.HeaderCell;
    return C ? $acw62.createElement(C, {
        ...S,
        ref: a
    }) : $acw62.createElement("div", {
        ...S,
        ref: a
    });
}
var $88ab1a78ec8ca4b4$var$ei = $acw62.memo($88ab1a78ec8ca4b4$var$iy);
function $88ab1a78ec8ca4b4$var$wd() {
    let { initialValue: o, setValue: e, confirmEdit: t, cancelEdit: n, readOnly: r } = $88ab1a78ec8ca4b4$export$ff3e76fda71b9e93(), i = (0, $acw62.useRef)(null), a = (0, $acw62.useRef)(!1), l = $acw62.useCallback((u)=>{
        i.current = u, u && u.focus();
    }, []), s = (0, $acw62.useCallback)((u)=>{
        let { key: d } = u;
        d === "Enter" || d === "Tab" ? t() : d === "Escape" ? (a.current = !0, n()) : u.stopPropagation();
    }, []), c = (0, $acw62.useCallback)(()=>{
        a.current || t();
    }, []);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement("input", {
        readOnly: r,
        ref: l,
        onKeyDown: s,
        onBlur: c,
        className: $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$uc, $88ab1a78ec8ca4b4$var$hc.none),
        type: "text",
        defaultValue: o,
        onChange: (0, $acw62.useCallback)((u)=>{
            e(u.target.value);
        }, [])
    }));
}
function $88ab1a78ec8ca4b4$var$Id(o, e) {
    let t = [];
    for(let n in o)o.hasOwnProperty(n) && !e.hasOwnProperty(n) && t.push(o[n]);
    return t;
}
var $88ab1a78ec8ca4b4$var$cy = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnZIndexAtIndex), $88ab1a78ec8ca4b4$var$uy = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnVisibilityAtIndex);
function $88ab1a78ec8ca4b4$var$dy({ rowInfo: o }) {
    return {
        [$88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$se.components.Row.groupNesting)]: o.isTreeNode ? o.isParentNode ? o.treeNesting : o.treeNesting + 1 : 0
    };
}
var $88ab1a78ec8ca4b4$var$Xo = $acw62.createContext(null), $88ab1a78ec8ca4b4$var$fy = (o)=>{
    let { toggleCurrentRowDetails: e, rowDetailState: t } = o;
    return $acw62.createElement($88ab1a78ec8ca4b4$var$On, {
        style: {
            visibility: t === !1 ? "hidden" : "visible"
        },
        expanded: t === "expanded",
        onChange: e
    });
}, $88ab1a78ec8ca4b4$var$py = {
    display: "inline-block",
    visibility: "visible"
}, $88ab1a78ec8ca4b4$var$yl = (o)=>{
    let { rowInfo: e, toggleCurrentTreeNode: t, nodeExpanded: n, api: r } = o, i = r.getDataSourceState().isNodeReadOnly;
    return $acw62.createElement($88ab1a78ec8ca4b4$var$On, {
        disabled: e.isTreeNode && e.isParentNode ? i(e) : !1,
        style: $88ab1a78ec8ca4b4$var$py,
        expanded: n,
        onChange: t
    });
}, $88ab1a78ec8ca4b4$var$my = (o)=>{
    let { rowInfo: e, selectCurrentRow: t, deselectCurrentRow: n, toggleCurrentGroupRowSelection: r, column: i, dataSourceApi: a, api: l } = o;
    e.isGroupRow && i.groupByForColumn;
    let { components: s } = l.getState(), c = l.getDataSourceState().isNodeSelectable, u = s?.CheckBox || $88ab1a78ec8ca4b4$var$Wt;
    return $acw62.createElement(u, {
        domProps: {
            className: $88ab1a78ec8ca4b4$var$Qr
        },
        disabled: e.isTreeNode ? !c(e) : !1,
        onChange: (d)=>{
            if (e.isTreeNode) {
                a.treeApi.setNodeSelection(e.nodePath, d ?? !1);
                return;
            }
            if (e.isGroupRow) {
                r();
                return;
            }
            d ? t() : n();
        },
        checked: e.rowSelected
    });
};
function $88ab1a78ec8ca4b4$var$Tl(o, e) {
    return o ? typeof o == "function" ? o(e) : o : void 0;
}
function $88ab1a78ec8ca4b4$var$Sl(o, e, t) {
    return typeof e == "function" ? {
        ...o,
        ...e(t)
    } : {
        ...o,
        ...e
    };
}
function $88ab1a78ec8ca4b4$var$gy(o) {
    let { dataSourceStatePartialForCell: e, rowInfoStore: t, rowStyle: n, rowClassName: r, rowIndexInHorizontalLayoutPage: i, horizontalLayoutPageIndex: a, getData: l, cellStyle: s, cellClassName: c, rowDetailState: u, width: d, column: f, onMouseLeave: p, onMouseEnter: m, onRowMouseEnter: g, onRowMouseLeave: b, rowIndex: h, rowHeight: y, columnsMap: S, fieldsToColumn: C, domRef: T, hidden: I, showZebraRows: w, getDataSourceState: v, dataSourceApi: R, dataSourceActions: x, getState: M, imperativeApi: A, componentActions: E, getComputed: P, getDataSourceMasterContext: _ } = o, D = (0, $acw62.useSyncExternalStore)((0, $acw62.useCallback)((ve)=>t.subscribeToRowIndex(h, ve), [
        t,
        h
    ]), (0, $acw62.useCallback)(()=>t.getRowInfoAtIndex(h), [
        t,
        h
    ])), O = !D, F = !f, W = $acw62.useRef(null), z = (0, $acw62.useCallback)((ve)=>{
        W.current = ve, T && T(ve);
    }, [
        T
    ]), L = D ?? {
        id: "",
        indexInAll: h,
        rowSelected: !1,
        rowDisabled: !1,
        isCellSelected: ()=>!1,
        hasSelectedCells: ()=>!1,
        isGroupRow: !1,
        isTreeNode: !1,
        isParentNode: !1,
        treeNesting: 0,
        nodePath: [],
        collapsed: !1,
        dataSourceHasGrouping: !1,
        selfLoaded: !0,
        data: {}
    }, { rowSelected: ae } = L, te = P(), { activeRowIndex: B, keyboardNavigation: j, columnReorderInPageIndex: oe } = M(), me = h === B && j === "row", pe = {
        getState: M,
        getDataSourceState: v,
        getDataSourceMasterContext: _,
        actions: E,
        dataSourceActions: x,
        api: A,
        dataSourceApi: R
    }, ce = L.rowDisabled, ue = te.computedVisibleColumns.map((ve)=>ve.id), ge = $88ab1a78ec8ca4b4$var$yd({
        horizontalLayoutPageIndex: a,
        rowIndexInHorizontalLayoutPage: i,
        column: f,
        rowInfo: L,
        rowDetailState: u,
        columnsMap: S,
        visibleColumnsIds: ue,
        fieldsToColumn: C,
        context: pe
    }), { stylingParam: H, renderParams: G, formattedValueContext: q, renderFunctions: K, groupByColumnReference: re, inEdit: J } = ge, { align: de, verticalAlign: we } = G, N1 = G, $ = $acw62.useRef(N1), ee = g && m ? (ve)=>{
        let Kt = {
            ...q,
            rowIndex: h
        };
        g(Kt, ve), m(ve);
    } : m, le = b && p ? (ve)=>{
        let nt = {
            ...q,
            rowIndex: h,
            rowInfo: L
        };
        b(nt, ve), p(ve);
    } : p, De = (0, $acw62.useCallback)((ve)=>{
        let nt = f.computedVisibleIndex;
        M().cellClick({
            rowIndex: h,
            colIndex: nt,
            event: ve
        });
    }, [
        h,
        f.computedVisibleIndex,
        j
    ]), Oe = (0, $acw62.useCallback)((ve)=>{
        let nt = f.computedVisibleIndex;
        if (M().cellMouseDown({
            rowIndex: h,
            colIndex: nt,
            event: ve
        }), j === "row") {
            ce || (E.activeRowIndex = h);
            return;
        }
        j === "cell" && (E.activeCellIndex = [
            h,
            nt
        ]);
    }, [
        h,
        ce,
        f.computedVisibleIndex,
        j
    ]), { selectionMode: Ne, cellSelection: he, isNodeReadOnly: Ke } = e, Be = N1.cellSelected;
    N1.domRef = z, N1.htmlElementRef = W, N1.toggleCurrentTreeNode = (0, $acw62.useCallback)(N1.toggleCurrentTreeNode, [
        L
    ]), N1.selectCell = (0, $acw62.useCallback)(N1.selectCell, [
        L
    ]), N1.deselectCell = (0, $acw62.useCallback)(N1.deselectCell, [
        L
    ]), N1.selectCurrentRow = (0, $acw62.useCallback)(N1.selectCurrentRow, [
        L
    ]), N1.deselectCurrentRow = (0, $acw62.useCallback)(N1.deselectCurrentRow, [
        L
    ]), N1.toggleCurrentGroupRow = (0, $acw62.useCallback)(N1.toggleCurrentGroupRow, [
        L
    ]), N1.toggleCurrentRowSelection = (0, $acw62.useCallback)(N1.toggleCurrentRowSelection, [
        L
    ]), N1.toggleCurrentGroupRowSelection = (0, $acw62.useCallback)(N1.toggleCurrentGroupRowSelection, [
        L
    ]), N1.toggleCurrentTreeNodeSelection = (0, $acw62.useCallback)(N1.toggleCurrentTreeNodeSelection, [
        L
    ]);
    let dt = f.components?.Editor ?? $88ab1a78ec8ca4b4$var$wd, Rt = J ? $acw62.createElement($88ab1a78ec8ca4b4$var$Rd, {
        contextValue: N1
    }, $acw62.createElement(dt, null)) : null, Ze = (0, $acw62.useCallback)($88ab1a78ec8ca4b4$var$ot(()=>{
        if (I || J) return null;
        if ($.current = N1, K.renderGroupIcon && (N1.renderBag.groupIcon = $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
            render: K.renderGroupIcon,
            renderParam: {
                ...N1,
                renderBag: {
                    ...N1.renderBag
                }
            }
        })), K.renderSelectionCheckBox && Ne == "multi-row" && (N1.renderBag.selectionCheckBox = $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
            render: $88ab1a78ec8ca4b4$var$my,
            renderParam: N1
        }), K.renderSelectionCheckBox !== !0 && (N1.renderBag.selectionCheckBox = $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
            render: K.renderSelectionCheckBox,
            renderParam: {
                ...N1,
                renderBag: {
                    ...N1.renderBag
                }
            }
        }))), L.isTreeNode) {
            let { isParentNode: Kt } = L, Dt;
            Dt = (Kt ? K.renderTreeIconForParentNode : K.renderTreeIconForLeafNode) || typeof K.renderTreeIcon == "function" ? K.renderTreeIcon : Kt && K.renderTreeIcon === !0 ? $88ab1a78ec8ca4b4$var$yl : void 0, Dt === !0 ? Dt = $88ab1a78ec8ca4b4$var$yl : Dt && (N1.renderBag.treeIcon = $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
                render: $88ab1a78ec8ca4b4$var$yl,
                renderParam: N1
            })), Dt && (N1.renderBag.treeIcon = $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
                render: Dt,
                renderParam: {
                    ...N1,
                    renderBag: {
                        ...N1.renderBag
                    }
                }
            }));
        }
        K.renderRowDetailIcon && (N1.renderBag.rowDetailsIcon = $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
            render: $88ab1a78ec8ca4b4$var$fy,
            renderParam: {
                ...N1,
                renderBag: {
                    ...N1.renderBag
                }
            }
        }), typeof K.renderRowDetailIcon == "function" && (N1.renderBag.rowDetailsIcon = $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
            render: K.renderRowDetailIcon,
            renderParam: {
                ...N1,
                renderBag: {
                    ...N1.renderBag
                }
            }
        }))), K.renderValue && (N1.renderBag.value = $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
            render: K.renderValue,
            renderParam: {
                ...N1,
                renderBag: {
                    ...N1.renderBag
                }
            }
        })), L.isGroupRow && K.renderGroupValue && (N1.renderBag.value = $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
            render: K.renderGroupValue,
            renderParam: {
                ...N1,
                renderBag: {
                    ...N1.renderBag
                }
            }
        })), !L.isGroupRow && K.renderLeafValue && (N1.renderBag.value = $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
            render: K.renderLeafValue,
            renderParam: {
                ...N1,
                renderBag: {
                    ...N1.renderBag
                }
            }
        })), $.current = N1;
        let ve = N1.renderBag.value;
        ve instanceof Date && (ve = ve.toLocaleDateString());
        let nt = $acw62.createElement($acw62.Fragment, null, de !== "end" ? N1.renderBag.treeIcon : null, de !== "end" ? N1.renderBag.groupIcon : null, de !== "end" ? N1.renderBag.rowDetailsIcon : null, de !== "end" ? N1.renderBag.selectionCheckBox : null, ve, de === "end" ? N1.renderBag.selectionCheckBox : null, de === "end" ? N1.renderBag.rowDetailsIcon : null, de === "end" ? N1.renderBag.groupIcon : null, de === "end" ? N1.renderBag.treeIcon : null);
        return f.render ? $acw62.createElement($88ab1a78ec8ca4b4$var$ut, {
            render: f.render,
            renderParam: {
                ...N1,
                renderBag: {
                    ...N1.renderBag,
                    all: nt
                }
            }
        }) : nt;
    }), [
        f,
        I,
        J,
        u,
        f.renderTreeIcon || f.renderTreeIconForParentNode ? Ke : !1,
        ...$88ab1a78ec8ca4b4$var$Id(N1, {
            renderBag: !0,
            selectCell: !0,
            deselectCell: !0,
            selectCurrentRow: !0,
            deselectCurrentRow: !0,
            toggleCurrentGroupRow: !0,
            toggleCurrentRowDetails: !0,
            toggleCurrentRowSelection: !0,
            toggleCurrentGroupRowSelection: !0,
            toggleCurrentTreeNodeSelection: !0,
            toggleCurrentTreeNode: !0,
            rowHasSelectedCells: !0
        })
    ]), V = te.computedVisibleColumns.map((ve)=>ve.id), ne = te.computedColumnOrder, ie = {
        ...q,
        visibleColumnIds: V,
        allColumnIds: ne,
        rowIndex: h,
        rowHasSelectedCells: !1
    };
    Object.defineProperty(ie, "rowHasSelectedCells", {
        get () {
            return L.hasSelectedCells(V);
        }
    });
    let be = L.isTreeNode && (f.renderTreeIcon || f.renderTreeIconForLeafNode || f.renderTreeIconForParentNode), je = typeof r == "function" ? r(ie) : r, k;
    re?.className && (k = $88ab1a78ec8ca4b4$var$Tl(re.className, H)), c && (k = $88ab1a78ec8ca4b4$var$X(k, $88ab1a78ec8ca4b4$var$Tl(c, H))), f.className && (k = $88ab1a78ec8ca4b4$var$X(k, $88ab1a78ec8ca4b4$var$Tl(f.className, H))), be && (k = $88ab1a78ec8ca4b4$var$X(k, $88ab1a78ec8ca4b4$var$ld({
        align: de
    })));
    let Se;
    L.dataSourceHasGrouping && f.groupByForColumn && (Se = $88ab1a78ec8ca4b4$var$sd({
        rowInfo: L
    })), be && (Se = $88ab1a78ec8ca4b4$var$dy({
        rowInfo: L
    })), n && (Se = typeof n == "function" ? {
        ...Se,
        ...n(ie)
    } : {
        ...Se,
        ...n
    }), s && (Se = $88ab1a78ec8ca4b4$var$Sl(Se, s, H)), re?.style && (Se = $88ab1a78ec8ca4b4$var$Sl(Se, re.style, H)), f.style && (Se = $88ab1a78ec8ca4b4$var$Sl(Se, f.style, H)), Se = Se || {}, Se.height = y, Se.zIndex = `var(${$88ab1a78ec8ca4b4$var$cy}-${f.computedVisibleIndex})`, Se.visibility = `var(${$88ab1a78ec8ca4b4$var$uy}-${f.computedVisibleIndex}, visible)`;
    let nn = (0, $acw62.useMemo)(()=>Se, [
        Se ? JSON.stringify(Se) : null
    ]), Tt = i != null ? i % 2 === 1 : (L.indexInAll != null ? L.indexInAll : h) % 2 === 1, xt = w ? Tt ? "odd" : "even" : !1, Pt = !1, Eo = !1, Ao = !1, Yn = !1;
    if (he && Be) {
        let ve = l(), nt = ve[L.indexInAll - 1], Kt = ve[L.indexInAll + 1], Dt = te.computedVisibleColumns[f.computedVisibleIndex + 1], Oo = te.computedVisibleColumns[f.computedVisibleIndex - 1];
        Pt = nt ? !he.isCellSelected(nt.id, f.id) : !0, f.computedPinned === "end" && f.computedFirstInCategory ? Eo = !0 : Eo = Oo ? !he.isCellSelected(L.id, Oo.id) : !0, f.computedPinned === "start" && f.computedLastInCategory ? Ao = !0 : Ao = Dt ? !he.isCellSelected(L.id, Dt.id) : !0, Yn = Kt ? !he.isCellSelected(Kt.id, f.id) : !0;
    }
    let _o = he && Be ? {
        top: Pt,
        left: Eo,
        right: Ao,
        bottom: Yn
    } : null, ga = oe != null ? a !== oe : !1, ha = Rt, ba = Ze(), tt = {
        domRef: z,
        cellType: "body",
        column: f,
        width: d,
        rowId: L.id,
        horizontalLayoutPageIndex: a,
        style: nn,
        onMouseLeave: le,
        onMouseEnter: ee,
        onClick: De,
        afterChildren: ha,
        onMouseDown: Oe,
        cssEllipsis: f.cssEllipsis ?? !0,
        className: $88ab1a78ec8ca4b4$var$X(_o ? $88ab1a78ec8ca4b4$var$pd(_o) : "", $88ab1a78ec8ca4b4$var$Br(f, [
            $88ab1a78ec8ca4b4$var$zt,
            $88ab1a78ec8ca4b4$var$Fn
        ], $88ab1a78ec8ca4b4$var$fd, {
            dragging: !1,
            insideDisabledDraggingPage: ga,
            zebra: xt,
            align: de,
            verticalAlign: we,
            rowDisabled: ce,
            rowActive: me,
            cellSelected: Be,
            rowSelected: ae,
            treeNode: L.isTreeNode ? L.isParentNode ? "parent" : "leaf" : !1,
            firstRow: L.indexInAll === 0,
            firstRowInHorizontalLayoutPage: i === 0,
            groupRow: L.isGroupRow,
            groupCell: L.isGroupRow ? !!f.groupByForColumn : !1,
            rowExpanded: L.isGroupRow ? !L.collapsed : !1
        }), k, je),
        renderChildren: (0, $acw62.useCallback)(()=>ba, [
            Ze
        ])
    }, Ir = $88ab1a78ec8ca4b4$var$Xo.Provider;
    return F || O ? $acw62.createElement("div", {
        ref: z,
        style: {
            display: "none"
        }
    }) : $acw62.createElement(Ir, {
        value: $.current
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$ei, {
        ...tt
    }));
}
var $88ab1a78ec8ca4b4$var$vd = $acw62.memo($88ab1a78ec8ca4b4$var$gy);
function $88ab1a78ec8ca4b4$export$966ffef3d3cf676c() {
    return (0, $acw62.useContext)($88ab1a78ec8ca4b4$var$Xo);
}
function $88ab1a78ec8ca4b4$export$ff3e76fda71b9e93() {
    let { api: o, state: { editingValueRef: e, editingCell: t } } = $88ab1a78ec8ca4b4$var$Q(), { column: n, rowInfo: r } = $88ab1a78ec8ca4b4$export$966ffef3d3cf676c(), [i] = $acw62.useState(()=>t?.value), [a, l] = $acw62.useState(i), s = t ? !t.active && !!t.waiting : !1, c = $acw62.useCallback((p)=>{
        e.current = p, l(p);
    }, []);
    $acw62.useLayoutEffect(()=>{
        e.current = i;
    }, []);
    let u = o.confirmEdit, d = o.cancelEdit, f = o.rejectEdit;
    return {
        api: o,
        initialValue: i,
        value: a,
        readOnly: s,
        column: n,
        rowInfo: r,
        setValue: c,
        confirmEdit: u,
        cancelEdit: d,
        rejectEdit: f
    };
}
function $88ab1a78ec8ca4b4$var$Zo(o) {
    return o.render(o.renderParam) ?? null;
}
function $88ab1a78ec8ca4b4$var$ut(o) {
    let e = $88ab1a78ec8ca4b4$var$Xo.Provider;
    return $acw62.createElement(e, {
        value: o.renderParam
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$Zo, {
        render: o.render,
        renderParam: o.renderParam
    }));
}
function $88ab1a78ec8ca4b4$var$Rd(o) {
    let e = $88ab1a78ec8ca4b4$var$Xo.Provider;
    return $acw62.createElement(e, {
        value: o.contextValue
    }, o.children);
}
function $88ab1a78ec8ca4b4$var$dn(o) {
    let e = $88ab1a78ec8ca4b4$var$ni.Provider;
    return $acw62.createElement(e, {
        value: o.renderParam
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$Zo, {
        render: o.render,
        renderParam: o.renderParam
    }));
}
var $88ab1a78ec8ca4b4$var$hy = {
    width: "100%",
    pointerEvents: "none"
}, $88ab1a78ec8ca4b4$var$Cl = `${$88ab1a78ec8ca4b4$var$ft}-menu`, $88ab1a78ec8ca4b4$var$wl = $88ab1a78ec8ca4b4$var$Nr({
    "data-name": ""
}), $88ab1a78ec8ca4b4$var$Il = {
    [$88ab1a78ec8ca4b4$var$wl["data-name"]]: "menu-icon"
};
function $88ab1a78ec8ca4b4$var$Qo(o) {
    let { style: e, className: t, domProps: n, reserveSpaceWhenHidden: r, menuVisible: i, children: a } = o, l = {
        ...$88ab1a78ec8ca4b4$var$hy,
        borderTop: `${$88ab1a78ec8ca4b4$var$se.components.HeaderCell.menuIconLineWidth} solid currentColor`,
        ...o.lineStyle
    };
    return $acw62.createElement("div", {
        ...n,
        style: e,
        ...$88ab1a78ec8ca4b4$var$Il,
        onPointerDown: (s)=>s.stopPropagation(),
        className: $88ab1a78ec8ca4b4$var$X(t, $88ab1a78ec8ca4b4$var$Yc({
            menuVisible: i,
            reserveSpaceWhenHidden: r
        }), $88ab1a78ec8ca4b4$var$ft, `${$88ab1a78ec8ca4b4$var$ft}-menu`)
    }, a ?? $acw62.createElement($acw62.Fragment, null, $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$Cl,
        style: l
    }), $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$Cl,
        style: l
    }), $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$Cl,
        style: l
    })));
}
var $88ab1a78ec8ca4b4$var$xd = "_1ek6mqy0 _16lm1iw1p _16lm1iw2f _16lm1iw1 _16lm1iw32";
var $88ab1a78ec8ca4b4$var$yy = {
    transition: "width 0.25s, opacity 0.25s"
};
function $88ab1a78ec8ca4b4$var$oi(o) {
    let [e, t] = (0, $acw62.useState)(!0), [n, r] = (0, $acw62.useState)(0), { direction: i, lineWidth: a = 1, style: l, className: s, index: c } = o, u = c != null && c > 0, d = o.size ?? 16, f = Math.floor(d / 4), p = i ? [
        d - 3 * f,
        d - 2 * f,
        d - f
    ] : [
        0,
        0,
        0
    ];
    i === -1 && p.reverse();
    let m = {
        ...$88ab1a78ec8ca4b4$var$yy,
        borderTop: `${a}px solid currentColor`,
        ...o.lineStyle,
        opacity: n
    };
    (0, $acw62.useEffect)(()=>{
        let h = i != 0 ? 1 : 0;
        if (!e && h && t(!0), h !== n) {
            let y = requestAnimationFrame(()=>{
                r(h);
            });
            return ()=>{
                cancelAnimationFrame(y);
            };
        }
        return ()=>{};
    }, [
        i,
        e
    ]);
    let g = ()=>{
        let y = !(n === 0 && i === 0);
        y !== e && t(y);
    };
    if (!e && !o.forceSize) return null;
    let b = {};
    return i === -1 && (b.top = "100%"), $acw62.createElement("div", {
        "data-name": "sort-icon",
        style: {
            ...l,
            width: d
        },
        className: $88ab1a78ec8ca4b4$var$X(s, $88ab1a78ec8ca4b4$var$ft, $88ab1a78ec8ca4b4$var$xd, `${$88ab1a78ec8ca4b4$var$ft}-sort`)
    }, u ? $acw62.createElement("div", {
        "data-name": "index",
        style: b,
        className: $88ab1a78ec8ca4b4$var$Zc
    }, c) : null, $acw62.createElement("div", {
        style: {
            width: p[0],
            ...m
        },
        onTransitionEnd: g
    }), $acw62.createElement("div", {
        style: {
            width: p[1],
            ...m
        }
    }), $acw62.createElement("div", {
        style: {
            width: p[2],
            ...m
        }
    }));
}
function $88ab1a78ec8ca4b4$var$Dd(o, { columns: e, shareSpaceOnResize: t, domRef: n }) {
    let r = e[o];
    return {
        resize (i) {
            $88ab1a78ec8ca4b4$var$Ce.columnWidths.set(o, r.computedWidth + i, n.current);
            let a = o + 1;
            if (t) {
                let l = e[a];
                if (!l) return;
                $88ab1a78ec8ca4b4$var$Ce.columnWidths.set(a, l.computedWidth - i, n.current), l.computedPinned === "start" ? $88ab1a78ec8ca4b4$var$rl(l, i, n.current) : $88ab1a78ec8ca4b4$var$Ce.columnOffsets.set(a, l.computedOffset + i, n.current);
                return;
            }
            if (r.computedPinned !== "end") {
                if (r.computedPinned === "start") {
                    for(let l = a, s = e.length; l < s; l++){
                        let c = e[l];
                        if (c.computedPinned === "start") {
                            $88ab1a78ec8ca4b4$var$rl(c, i, n.current);
                            continue;
                        }
                        c.computedPinned !== "end" && $88ab1a78ec8ca4b4$var$Ce.columnOffsets.set(l, c.computedOffset + i, n.current);
                    }
                    return;
                }
                for(let l = a, s = e.length; l < s; l++){
                    let c = e[l];
                    c.computedPinned || $88ab1a78ec8ca4b4$var$Ce.columnOffsets.set(l, c.computedOffset + i, n.current);
                }
            }
        }
    };
}
function $88ab1a78ec8ca4b4$var$Md(o, e) {
    let t = o[o.length - 1];
    return {
        resize (n) {
            let { columns: r, domRef: i } = e, a = r[o[0]], l = a.computedOffset, s = 0, c = i.current;
            if (n.forEach((u, d)=>{
                s += u;
                let f = o[d], p = r[f], m = p.computedWidth + u;
                $88ab1a78ec8ca4b4$var$Ce.columnWidths.set(f, m, c), p.computedPinned !== "end" && (l && $88ab1a78ec8ca4b4$var$Ce.columnOffsets.set(f, l, c), l += m);
            }), a.computedPinned !== "end") for(let u = t + 1; u < r.length; u++){
                let d = r[u];
                d.computedPinned !== "end" && $88ab1a78ec8ca4b4$var$Ce.columnOffsets.set(u, d.computedOffset + s, c);
            }
        }
    };
}
var $88ab1a78ec8ca4b4$var$ri = "zneyzh0 _16lm1iw2 _16lm1iw23 _16lm1iw2c _16lm1iw2a _16lm1iwm _16lm1iw35", $88ab1a78ec8ca4b4$var$ii = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "zneyzhc _16lm1iw2 _16lm1iw23 _16lm1iw2a",
    variantClassNames: {
        constrained: {
            false: "zneyzhd",
            true: "zneyzhe"
        },
        computedPinned: {
            start: "zneyzhf",
            end: "zneyzhg",
            false: "zneyzhh"
        },
        computedFirstInCategory: {
            true: "zneyzhi",
            false: "zneyzhj"
        },
        computedLastInCategory: {
            true: "zneyzhk",
            false: "zneyzhl"
        }
    },
    defaultVariants: {},
    compoundVariants: [
        [
            {
                computedPinned: "start",
                computedLastInCategory: !0,
                computedFirstInCategory: !1
            },
            "zneyzhm"
        ],
        [
            {
                computedPinned: "end",
                computedFirstInCategory: !0,
                computedLastInCategory: !1
            },
            "zneyzhn"
        ]
    ]
}), $88ab1a78ec8ca4b4$var$ai = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "zneyzh1",
    variantClassNames: {
        computedPinned: {
            start: "zneyzh2",
            end: "zneyzh3 _16lm1iw26 _16lm1iw2e",
            false: "zneyzh4"
        },
        computedFirstInCategory: {
            true: "zneyzh5",
            false: "zneyzh6"
        },
        computedLastInCategory: {
            true: "zneyzh7",
            false: "zneyzh8"
        }
    },
    defaultVariants: {},
    compoundVariants: [
        [
            {
                computedPinned: "end",
                computedLastInCategory: !1,
                computedFirstInCategory: !0
            },
            "zneyzh9"
        ],
        [
            {
                computedPinned: !1,
                computedFirstInCategory: !1,
                computedLastInCategory: !0
            },
            "zneyzha"
        ],
        [
            {
                computedPinned: "start",
                computedFirstInCategory: !1,
                computedLastInCategory: !0
            },
            "zneyzhb"
        ]
    ]
});
var { rootClassName: $88ab1a78ec8ca4b4$var$Sy } = $88ab1a78ec8ca4b4$var$Fe, $88ab1a78ec8ca4b4$var$Cy = `${$88ab1a78ec8ca4b4$var$Sy}HeaderCell_ResizeHandle`;
function $88ab1a78ec8ca4b4$var$wy(o) {
    let { state: { brain: e, headerBrain: t } } = $88ab1a78ec8ca4b4$var$Q(), n = (0, $acw62.useRef)(null), [r, i] = (0, $acw62.useState)(!1), a = (0, $acw62.useRef)(r);
    a.current = r;
    let l = o.columns[o.columnIndex], s = o.horizontalLayoutPageIndex;
    if (!l) return null;
    let c = l.computedPinned, u = l.computedFirstInCategory, d = l.computedLastInCategory, f = ()=>{}, p = (g)=>{
        g.stopPropagation();
        let b = !!g.shiftKey, h = g.pointerId, y = g.clientX, S = g.target;
        if (e.isHorizontalLayoutBrain) {
            let v = e.extendRenderRange({
                start: !0,
                end: !0,
                direction: "horizontal"
            }), R = t.extendRenderRange({
                start: !0,
                end: !0,
                direction: "horizontal"
            });
            f = ()=>{
                v(), R();
            };
        }
        S.setPointerCapture(h);
        let C = $88ab1a78ec8ca4b4$var$Dd(o.columnIndex, {
            columns: o.columns,
            shareSpaceOnResize: b,
            domRef: n
        }), T = (v, { done: R } = {})=>{
            s && (v = v / (s + 1), R && (v = Math.round(v))), c === "end" && (v *= -1);
            let { adjustedDiff: x, constrained: M } = o.computeResize({
                diff: v,
                shareSpaceOnResize: b
            });
            return a.current !== M && i(M), C.resize(x), x;
        }, I = (v)=>{
            T(Math.round(v.clientX - y));
        }, w = (v)=>{
            S.releasePointerCapture(h), S.removeEventListener("pointermove", I), S.removeEventListener("pointerup", w);
            let R = Math.round(v.clientX - y), x = T(R, {
                done: !0
            });
            f(), o.onResize({
                diff: x,
                shareSpaceOnResize: b
            });
        };
        S.addEventListener("pointermove", I), S.addEventListener("pointerup", w);
    }, m = (c === !1 || c === "start") && d ? {
        right: c === "start" ? void 0 : 0
    } : c === "end" && u ? {
        right: void 0
    } : void 0;
    return $acw62.createElement("div", {
        ref: n,
        className: `${$88ab1a78ec8ca4b4$var$Cy} ${$88ab1a78ec8ca4b4$var$ri} ${$88ab1a78ec8ca4b4$var$ai({
            computedPinned: c,
            computedFirstInCategory: u,
            computedLastInCategory: d
        })}`,
        onPointerDown: p
    }, $acw62.createElement("div", {
        style: m,
        className: $88ab1a78ec8ca4b4$var$ii({
            constrained: r,
            computedPinned: c,
            computedFirstInCategory: u,
            computedLastInCategory: d
        })
    }));
}
var $88ab1a78ec8ca4b4$var$Ad = $acw62.memo($88ab1a78ec8ca4b4$var$wy);
function $88ab1a78ec8ca4b4$var$Nd(o, e) {
    let { computed: { computedVisibleColumns: t }, getState: n, getComputed: r, actions: i } = $88ab1a78ec8ca4b4$var$Q(), a = (0, $acw62.useCallback)(({ diff: c, shareSpaceOnResize: u })=>{
        let d = n(), { columnSizing: f, viewportReservedWidth: p, bodySize: m } = d, g = r().computedVisibleColumns, b = !1, h = g.reduce((C, T)=>(T.computedFlex && (C[T.id] = {
                ...f[T.id],
                flex: T.computedWidth
            }, b = !0), C), {}), y = b ? {
            ...f,
            ...h
        } : f;
        return $88ab1a78ec8ca4b4$var$qa({
            shareSpaceOnResize: u,
            availableSize: m.width,
            reservedWidth: p || 0,
            dragHandleOffset: c,
            dragHandlePositionAfter: o.computedVisibleIndex,
            columnSizing: y,
            items: g.map((C)=>({
                    id: C.id,
                    computedFlex: C.computedFlex,
                    computedWidth: C.computedWidth,
                    computedMinWidth: C.computedMinWidth,
                    computedMaxWidth: C.computedMaxWidth
                }))
        });
    }, [
        o
    ]), l = (0, $acw62.useCallback)(({ diff: c, shareSpaceOnResize: u })=>{
        let { columnSizing: d, reservedWidth: f } = a({
            diff: c,
            shareSpaceOnResize: u
        });
        u || (i.viewportReservedWidth = f), i.columnSizing = d;
    }, [
        a
    ]);
    return o.computedResizable ? $acw62.createElement($88ab1a78ec8ca4b4$var$Ad, {
        horizontalLayoutPageIndex: e.horizontalLayoutPageIndex,
        columns: t,
        columnIndex: o.computedVisibleIndex,
        computeResize: a,
        onResize: l
    }) : null;
}
var $88ab1a78ec8ca4b4$var$Fd = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_16lm1iw3a _16lm1iw1",
    variantClassNames: {
        dragging: {
            true: "_16lm1iwn _16lm1iw1x"
        }
    },
    defaultVariants: {},
    compoundVariants: []
}), $88ab1a78ec8ca4b4$var$Ld = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_16lm1iw3a _16lm1iw1 _16lm1iwo",
    variantClassNames: {
        active: {
            true: "_3dmbka5 _16lm1iw1k _3dmbka2"
        },
        draggingInProgress: {
            true: "_16lm1iw1x"
        }
    },
    defaultVariants: {},
    compoundVariants: [
        [
            {
                active: !1,
                draggingInProgress: !0
            },
            "_3dmbka3"
        ]
    ]
});
function $88ab1a78ec8ca4b4$var$kd(o, e) {
    return $88ab1a78ec8ca4b4$var$wt(o, e);
}
var $88ab1a78ec8ca4b4$var$li = class extends $88ab1a78ec8ca4b4$var$En {
    constructor(t){
        super();
        this.dragIndex = -1;
        this.breakpoints = [];
        this.activeDragSourcePosition = "outside";
        this.previousAcceptsDropResult = !0;
        this.setData(t);
    }
    get listId() {
        return this.data.listId;
    }
    setData(t) {
        return $88ab1a78ec8ca4b4$var$kd(this.data, t) ? !1 : (this.data = t, !0);
    }
    getData() {
        return this.data;
    }
    isEqual(t) {
        return $88ab1a78ec8ca4b4$var$kd(this.data, t.getData());
    }
    acceptsSelfDrops() {
        return !this.data.acceptDropsFrom || this.data.acceptDropsFrom.includes(this.data.listId);
    }
    acceptsDrop(t) {
        let n = !0;
        return typeof this.data.shouldAcceptDrop == "function" && (n = this.data.shouldAcceptDrop(t)), n = !!n, n !== this.previousAcceptsDropResult && (this.previousAcceptsDropResult = n, n ? this.emit("accept-feedback", t) : this.emit("reject-feedback", t)), n;
    }
    move(t) {
        this.emit("move", t);
    }
    unregister() {
        this.emit("unregister", this);
    }
    start(t) {
        let n = t.dragSourceListId === this.data.listId, { draggableItems: r } = this.data, i = r.length;
        this.breakpoints = r.map((a, l)=>n || l === i - 1 ? this.data.orientation === "horizontal" ? a.rect.left + a.rect.width / 2 : a.rect.top + a.rect.height / 2 : this.data.orientation === "horizontal" ? a.rect.right : a.rect.bottom), this.activeDragSourcePosition = n ? "inside" : "outside", this.emit("start", t);
    }
    drop(t) {
        let { dropIndex: n, dragIndex: r, items: i, dragSourceListId: a, dropTargetListId: l, dragItem: s, outside: c } = t, u = Array.from({
            length: i.length
        }, (p, m)=>m), d = [];
        n === -1 ? d = u.filter((p)=>p !== r) : d = $88ab1a78ec8ca4b4$var$Mn(u, r, n > r ? n - 1 : n);
        let f = {
            dragIndex: r,
            dropIndex: n,
            dragItem: s,
            items: i,
            dragSourceListId: a,
            dropTargetListId: l,
            sortedIndexes: d,
            outside: c,
            status: t.status
        };
        this.emit("drop", f);
    }
};
var $88ab1a78ec8ca4b4$var$Vd = $acw62.createContext({
    dragItemId: null,
    onDragItemPointerDown: ()=>{},
    draggingInProgress: !1,
    dragListId: "",
    status: "accepted",
    dragSourceListId: null,
    dropTargetListId: null
}), $88ab1a78ec8ca4b4$var$er = ()=>$acw62.useContext($88ab1a78ec8ca4b4$var$Vd), $88ab1a78ec8ca4b4$var$Iy = (o)=>{
    let { node: e, offset: t } = o;
    if (!t) {
        e.style.transform = "none";
        return;
    }
    e.style.transform = `translate3d(${t.left}px, ${t.top}px, 0px)`;
}, $88ab1a78ec8ca4b4$var$vy = (o)=>`${o.getAttribute($88ab1a78ec8ca4b4$var$pn)}`;
function $88ab1a78ec8ca4b4$var$Ry(o) {
    let e = o.current?.querySelectorAll($88ab1a78ec8ca4b4$var$si) ?? [];
    return !e || e.length, Array.from(e).map((n)=>{
        let r = $88ab1a78ec8ca4b4$var$vy(n), i = n.getBoundingClientRect();
        return {
            id: r,
            rect: i
        };
    });
}
function $88ab1a78ec8ca4b4$var$xy(o) {
    let { domRef: e, orientation: t, dragListId: n } = o, r = $88ab1a78ec8ca4b4$var$Ie.from(e.current.getBoundingClientRect());
    return {
        draggableItems: $88ab1a78ec8ca4b4$var$Ry(e),
        orientation: t,
        listId: n,
        listRectangle: r,
        acceptDropsFrom: o.acceptDropsFrom,
        shouldAcceptDrop: o.shouldAcceptDrop,
        initial: o.initial
    };
}
function $88ab1a78ec8ca4b4$var$Gd(o) {
    return new $88ab1a78ec8ca4b4$var$li($88ab1a78ec8ca4b4$var$xy(o));
}
function $88ab1a78ec8ca4b4$var$Py(o, e) {
    let t = $88ab1a78ec8ca4b4$var$Me(e), [n, r] = $acw62.useState(null), i = (0, $acw62.useCallback)((l)=>{
        if (l) $88ab1a78ec8ca4b4$var$pt.registerDragInteractionTarget(l);
        else {
            let s = a();
            s && $88ab1a78ec8ca4b4$var$pt.unregisterDragInteractionTarget(s);
        }
        r(l);
    }, []), a = $88ab1a78ec8ca4b4$var$Me(n);
    return (0, $acw62.useEffect)(()=>$88ab1a78ec8ca4b4$var$pt.on("register", (l)=>{
            let { dragListId: s, acceptDropsFrom: c, orientation: u, shouldAcceptDrop: d } = t(), f = l.getData();
            if (f.initial && f.listId !== s && c?.includes(f.listId)) {
                let p = $88ab1a78ec8ca4b4$var$Gd({
                    domRef: o,
                    orientation: u,
                    dragListId: s,
                    initial: !1,
                    acceptDropsFrom: c,
                    shouldAcceptDrop: d
                });
                l.once("unregister", ()=>{
                    i(null);
                }), i(p);
            }
        }), [
        t
    ]), {
        interactionTarget: n,
        setInteractionTarget: i,
        getInteractionTarget: a
    };
}
var $88ab1a78ec8ca4b4$var$kn = (o)=>{
    let e = $acw62.useRef(null), { dropTargetListId: t, dragSourceListId: n } = $88ab1a78ec8ca4b4$var$An(), { updateDragOperationSourceAndTarget: r, dragItemId: i, status: a } = $88ab1a78ec8ca4b4$var$An(), l = $88ab1a78ec8ca4b4$var$Me(o.onDrop), s = $88ab1a78ec8ca4b4$var$Me(o.onAcceptDrop), c = $88ab1a78ec8ca4b4$var$Me(o.onRemove), u = $88ab1a78ec8ca4b4$var$Me(o.updatePosition ?? $88ab1a78ec8ca4b4$var$Iy), { interactionTarget: d, setInteractionTarget: f } = $88ab1a78ec8ca4b4$var$Py(e, o);
    (0, $acw62.useEffect)(()=>{
        let T = document.querySelector(`[${$88ab1a78ec8ca4b4$var$zd}="${o.dragListId}"]`);
        T ? e.current = T : console.warn(`DragList with id "${o.dragListId}" not found. You're probably not spreading the domProps to the parent element. Make sure you also include the "className" prop.`);
    }, [
        o.dragListId
    ]), (0, $acw62.useEffect)(()=>{
        if (d) {
            let T = o.dragListId, I = d.on("start", ({ dragItem: R, dragSourceListId: x, dropTargetListId: M })=>{
                r({
                    dragSourceListId: x,
                    dropTargetListId: M,
                    dragItemId: R.id,
                    status: "accepted"
                });
            }), w = d.on("move", ({ offsetsForItems: R, items: x, status: M })=>{
                if (M === "rejected") return;
                let A = m(), E = u();
                x.forEach((P, _)=>{
                    let D = R[_], O = A[_];
                    O && E({
                        id: P.id,
                        node: O,
                        offset: D
                    });
                });
            }), v = d.on("drop", (R)=>{
                let { sortedIndexes: x, dragIndex: M, dropIndex: A, dragItem: E, items: P, dragSourceListId: _, dropTargetListId: D, outside: O, status: F } = R, W = m();
                p.current = [];
                let z = s(), L = c(), ae = l(), te = u();
                P.forEach((oe, me)=>{
                    let pe = W[me];
                    pe && te({
                        id: oe.id,
                        node: pe,
                        offset: null
                    });
                }), T === D && _ !== T && z && F === "accepted" && z({
                    dragItemId: E.id,
                    dragSourceListId: _,
                    dropTargetListId: D,
                    dragIndex: M,
                    dropIndex: A,
                    dropItemId: P[A]?.id
                });
                let j = null;
                A === -1 && _ === T && D === T && O && (j = L), A !== -1 && D === T && _ === T && (j = ae), j && j?.(x, {
                    dragIndex: M,
                    dropIndex: A,
                    dragItemId: P[M].id,
                    dropItemId: P[A]?.id
                });
            });
            return ()=>{
                I(), w(), v();
            };
        }
    }, [
        d,
        o.dragListId
    ]);
    let p = $acw62.useRef([]), m = (0, $acw62.useCallback)(()=>{
        let T = p.current;
        return (!T || T.length === 0) && (T = Array.from(e.current?.querySelectorAll($88ab1a78ec8ca4b4$var$si) ?? []), p.current = T), T;
    }, []), g = (0, $acw62.useCallback)((T)=>{
        let I = T.currentTarget, w = I.getAttribute($88ab1a78ec8ca4b4$var$pn);
        if (w == null) {
            let O = $88ab1a78ec8ca4b4$var$cn(I, $88ab1a78ec8ca4b4$var$si);
            O && (w = O.getAttribute($88ab1a78ec8ca4b4$var$pn));
        }
        if (w == null) {
            console.warn("Could not find drag item id for element", I, `Make sure you have a parent element with a ${$88ab1a78ec8ca4b4$var$pn} attribute`);
            return;
        }
        w = `${w}`;
        let v = null, R = Array.from(e.current?.querySelectorAll($88ab1a78ec8ca4b4$var$si) ?? []);
        p.current = R;
        let x = $88ab1a78ec8ca4b4$var$Gd({
            domRef: e,
            orientation: o.orientation,
            dragListId: o.dragListId,
            acceptDropsFrom: o.acceptDropsFrom,
            initial: !0
        }), M = x.getData().draggableItems, A = M.findIndex((O)=>O.id === w), E = M[A];
        f(x);
        let P = {
            left: T.clientX,
            top: T.clientY
        }, _ = (O)=>{
            v || (v = $88ab1a78ec8ca4b4$var$pt.startDrag({
                listId: o.dragListId,
                dragItem: E,
                dragIndex: A
            }, P)), v.move({
                left: O.clientX,
                top: O.clientY
            });
        }, D = ()=>{
            if ($88ab1a78ec8ca4b4$var$Re().removeEventListener("pointermove", _), !v) {
                f(null);
                return;
            }
            v.drop(), v = null;
        };
        $88ab1a78ec8ca4b4$var$Re().addEventListener("pointermove", _), $88ab1a78ec8ca4b4$var$Re().addEventListener("pointerup", D, {
            once: !0
        });
    }, [
        o.orientation,
        o.dragListId,
        o.acceptDropsFrom,
        o.removeOnDropOutside
    ]), b = (T)=>T === void 0 ? i != null : `${T}` === i, h = !!i, y = $acw62.useMemo(()=>({
            dragItemId: i,
            onDragItemPointerDown: g,
            dragSourceListId: n,
            dropTargetListId: t,
            status: a,
            dragListId: o.dragListId,
            draggingInProgress: h
        }), [
        i,
        g,
        b,
        h,
        n,
        t,
        o.dragListId
    ]), S = {
        className: $88ab1a78ec8ca4b4$var$X("DragList", h ? "DragList--dragging" : "", $88ab1a78ec8ca4b4$var$Fd({
            dragging: h
        })),
        [$88ab1a78ec8ca4b4$var$zd]: o.dragListId
    }, C = typeof o.children == "function" ? o.children(S, y) : o.children;
    return $acw62.createElement($88ab1a78ec8ca4b4$var$Vd.Provider, {
        value: y
    }, C);
}, $88ab1a78ec8ca4b4$var$zd = "data-drag-list-id", $88ab1a78ec8ca4b4$var$pn = "data-drag-item-id", $88ab1a78ec8ca4b4$var$si = `[${$88ab1a78ec8ca4b4$var$pn}]`, $88ab1a78ec8ca4b4$var$Dy = $acw62.createContext({
    dragItemId: "",
    dragListId: "",
    active: !1,
    draggingInProgress: !1,
    dragSourceListId: "",
    dropTargetListId: ""
}), $88ab1a78ec8ca4b4$var$My = (o)=>{
    let { onDragItemPointerDown: e, draggingInProgress: t, dragListId: n, dragItemId: r, dragSourceListId: i, dropTargetListId: a } = $88ab1a78ec8ca4b4$var$er(), l = i === n && r === `${o.id}`, s = $acw62.useMemo(()=>({
            dragItemId: o.id,
            active: l,
            dragListId: n,
            draggingInProgress: t,
            dragSourceListId: i,
            dropTargetListId: a
        }), [
        o.id,
        l,
        t,
        i,
        a
    ]), c = {
        "data-drag-item-id": `${o.id}`,
        onPointerDown: e,
        className: $88ab1a78ec8ca4b4$var$X("DraggableItem", l ? "DraggableItem--active" : "", $88ab1a78ec8ca4b4$var$Ld({
            active: l,
            draggingInProgress: t
        }))
    }, u = typeof o.children == "function" ? o.children(c, s) : o.children;
    return $acw62.createElement($88ab1a78ec8ca4b4$var$Dy.Provider, {
        value: s
    }, u);
};
$88ab1a78ec8ca4b4$var$kn.DraggableItem = $88ab1a78ec8ca4b4$var$My;
var $88ab1a78ec8ca4b4$var$Hd = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
    }));
function $88ab1a78ec8ca4b4$var$Kd() {
    return {};
}
var $88ab1a78ec8ca4b4$var$Bd = (o)=>({
        allowColumnHideWhileDragging: (e)=>e ?? !0
    });
var $88ab1a78ec8ca4b4$var$Ay = (0, $acw62.createContext)(null);
function $88ab1a78ec8ca4b4$var$Pl() {
    return $88ab1a78ec8ca4b4$var$Ay;
}
function $88ab1a78ec8ca4b4$var$_y(o) {
    let { height: e, width: t, count: n } = o;
    return $acw62.createElement("div", {
        "data-count": n,
        "data-placeholder-width": void 0,
        "data-placeholder-height": void 0,
        "data-name": "SpacePlaceholder",
        style: {
            height: e,
            width: t,
            zIndex: -1,
            opacity: 0,
            pointerEvents: "none",
            contain: "strict"
        }
    });
}
var $88ab1a78ec8ca4b4$var$Wd = $acw62.memo($88ab1a78ec8ca4b4$var$_y);
var $88ab1a78ec8ca4b4$var$jd = "mlx2t3";
var $88ab1a78ec8ca4b4$var$$d = (o, e)=>{
    (0, $acw62.useEffect)(()=>{
        let t = o?.current, n = (i)=>{
            let a = i.target;
            e?.({
                scrollTop: a.scrollTop,
                scrollLeft: a.scrollLeft
            });
        }, r = {
            passive: !1
        };
        return t?.addEventListener("scroll", n, r), ()=>{
            t?.removeEventListener("scroll", n);
        };
    }, [
        e,
        o?.current
    ]);
};
var $88ab1a78ec8ca4b4$var$Ud = {
    true: "_1ueijco2",
    false: "_1ueijco3",
    visible: "_1ueijco4",
    auto: "_1ueijco5",
    hidden: "_1ueijco6"
}, $88ab1a78ec8ca4b4$var$Yd = {
    true: "_1ueijco7",
    false: "_1ueijco8",
    visible: "_1ueijco9",
    auto: "_1ueijcoa",
    hidden: "_1ueijcob"
}, $88ab1a78ec8ca4b4$var$qd = {
    true: "_1ueijcoc",
    false: "_1ueijcod",
    visible: "_1ueijcoe",
    auto: "_1ueijcof",
    hidden: "_1ueijcog"
}, $88ab1a78ec8ca4b4$var$Dl = "_1ueijco1", $88ab1a78ec8ca4b4$var$Xd = "_1ueijco0 _16lm1iw0";
var $88ab1a78ec8ca4b4$var$Zd = (o)=>{
    let e = "";
    return typeof o == "boolean" || typeof o == "string" ? e = $88ab1a78ec8ca4b4$var$Ud[`${o}`] : e = $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$Yd[`${o.horizontal}`], $88ab1a78ec8ca4b4$var$qd[`${o.vertical}`]), e;
};
var $88ab1a78ec8ca4b4$var$Fy = "InfiniteVirtualScrollContainer";
var $88ab1a78ec8ca4b4$var$Qd = $acw62.forwardRef(function(e, t) {
    let { children: n, scrollable: r = !0, onContainerScroll: i, className: a, tabIndex: l, style: s, autoFocus: c } = e, u = t ?? (0, $acw62.useRef)(null);
    return $88ab1a78ec8ca4b4$var$$d(u, i), $acw62.createElement("div", {
        ref: u,
        style: s,
        autoFocus: c,
        tabIndex: l,
        className: $88ab1a78ec8ca4b4$var$X(a, $88ab1a78ec8ca4b4$var$Fy, $88ab1a78ec8ca4b4$var$Xd, $88ab1a78ec8ca4b4$var$Zd(r))
    }, n);
});
var $88ab1a78ec8ca4b4$var$Vy = ()=>!1;
function $88ab1a78ec8ca4b4$var$Gy(o) {
    let [e, t] = (0, $acw62.useState)(o.updater.get), n = (0, $acw62.useRef)(null), r = o.shouldFlushSync ?? $88ab1a78ec8ca4b4$var$Vy;
    return (0, $acw62.useLayoutEffect)(()=>{
        function i(l) {
            let s = r();
            o.useraf ? (n.current != null && cancelAnimationFrame(n.current), n.current = requestAnimationFrame(()=>{
                s ? queueMicrotask(()=>{
                    (0, $1u0KT.flushSync)(()=>{
                        t(l);
                    });
                }) : t(l);
            })) : s ? queueMicrotask(()=>{
                (0, $1u0KT.flushSync)(()=>{
                    t(l);
                });
            }) : t(l);
        }
        let a = o.updater.onChange(i);
        return ()=>{
            n.current != null && cancelAnimationFrame(n.current), a();
        };
    }, [
        o.updater,
        o.useraf,
        r
    ]), e ?? null;
}
var $88ab1a78ec8ca4b4$var$mn = $acw62.memo($88ab1a78ec8ca4b4$var$Gy);
var $88ab1a78ec8ca4b4$var$tf = $88ab1a78ec8ca4b4$var$qn($88ab1a78ec8ca4b4$var$Dn());
var $88ab1a78ec8ca4b4$var$Ml = (o, e)=>o - e, $88ab1a78ec8ca4b4$var$$t = {
    horizontal: !0,
    vertical: !0
};
function $88ab1a78ec8ca4b4$var$di(o, e) {
    let t = e.length;
    if (!t) return 0;
    let n = -1;
    for(let r = 0; r < t; r++){
        let i = 0, a = 0;
        if (t - r <= n) break;
        for(let l = r; l < t; l++)if (i += e[l], a++, i > o) {
            a > n && (n = a);
            break;
        }
    }
    return n < 0 ? t : Math.min(n, t);
}
var $88ab1a78ec8ca4b4$var$El = "DebugID=";
function $88ab1a78ec8ca4b4$var$gn(o, e) {
    return e && e.startsWith($88ab1a78ec8ca4b4$var$El) ? e : e ? `${$88ab1a78ec8ca4b4$var$El}${o}:${e}` : `${$88ab1a78ec8ca4b4$var$El}${o}`;
}
var $88ab1a78ec8ca4b4$var$fi = {
    start: 0,
    end: 0
}, $88ab1a78ec8ca4b4$var$Al = (o)=>{
    o();
}, $88ab1a78ec8ca4b4$var$_l = (o)=>{
    let { start: e, end: t } = o, [n, r] = e, [i, a] = t, l = i - n, s = a - r;
    return l * s;
}, $88ab1a78ec8ca4b4$var$nf = (o)=>{
    let { start: e, end: t } = o, [n] = e, [r] = t;
    return r - n;
}, $88ab1a78ec8ca4b4$var$tr = typeof window < "u" ? requestAnimationFrame : (o)=>setTimeout(o, 0);
function $88ab1a78ec8ca4b4$var$Hy(o) {
    return o.horizontalChange || o.verticalChange;
}
var $88ab1a78ec8ca4b4$var$zn = class extends $88ab1a78ec8ca4b4$var$st {
    constructor(t){
        let n = $88ab1a78ec8ca4b4$var$gn(t, `${t}:MatrixBrain`);
        super(n);
        this.scrolling = !1;
        this.RENDER_COUNT_SAFETY_MARGIN_START = 1;
        this.RENDER_COUNT_SAFETY_MARGIN_END = 1;
        this.availableWidth = 0;
        this.availableRenderWidth = 0;
        this.isHorizontalLayoutBrain = !1;
        this.name = "";
        this.availableHeight = 0;
        this.availableRenderHeight = 0;
        this.cols = 0;
        this.rows = 0;
        this.alwaysRenderedColumns = new Set;
        this._rowsPerPage = 0;
        this.rowHeight = 0;
        this.colWidth = 0;
        this.verticalTotalSize = 0;
        this.horizontalTotalSize = 0;
        this.horizontalRenderCount = void 0;
        this.verticalRenderCount = void 0;
        this.maxHorizontalRenderCount = 0;
        this.maxVerticalRenderCount = 0;
        this.horizontalExtendRangeBy = $88ab1a78ec8ca4b4$var$fi;
        this.verticalExtendRangeBy = $88ab1a78ec8ca4b4$var$fi;
        this.horizontalRenderRange = {
            startIndex: 0,
            endIndex: 0
        };
        this.verticalRenderRange = {
            startIndex: 0,
            endIndex: 0
        };
        this.extraSpanCells = [];
        this.scrollPosition = {
            scrollLeft: 0,
            scrollTop: 0
        };
        this.onScrollFns = [];
        this.onRenderRangeChangeFns = new Set;
        this.onVerticalRenderRangeChangeFns = new Set;
        this.onHorizontalRenderRangeChangeFns = new Set;
        this.onDestroyFns = [];
        this.destroyed = !1;
        this.onRenderCountChangeFns = new Set;
        this.onAvailableSizeChangeFns = new Set;
        this.onScrollStartFns = [];
        this.onScrollStopFns = [];
        this.scrollTimeoutId = 0;
        this.scrollStopDelay = 250;
        this.fixedColsStart = 0;
        this.fixedColsEnd = 0;
        this.fixedRowsStart = 0;
        this.fixedRowsEnd = 0;
        this.setScrollStopDelay = (t)=>{
            this.scrollStopDelay = t;
        };
        this.getRowCount = ()=>this.rows;
        this.getColCount = ()=>this.cols;
        this.setScrolling = (t)=>{
            let n = this.scrolling;
            this.scrolling = t, t && (this.scrollTimeoutId && clearTimeout(this.scrollTimeoutId), this.scrollTimeoutId = setTimeout(()=>{
                this.setScrolling(!1), this.scrollTimeoutId = 0;
            }, this.scrollStopDelay)), t !== n && (t ? this.notifyScrollStart() : this.notifyScrollStop());
        };
        this.notifyScrollStart = ()=>{
            if (this.destroyed) return;
            let t = this.onScrollStartFns;
            for(let n = 0, r = t.length; n < r; n++)t[n]();
        };
        this.notifyScrollStop = ()=>{
            if (this.destroyed) return;
            let t = this.onScrollStopFns, n = this.scrollPosition, r = this.getRenderRange();
            for(let i = 0, a = t.length; i < a; i++)t[i](n, r);
        };
        this.notifyAvailableSizeChange = ()=>{
            if (this.destroyed) return;
            let t = this.onAvailableSizeChangeFns, n = this.getAvailableSize();
            t.forEach((r)=>{
                $88ab1a78ec8ca4b4$var$tr(()=>{
                    this.destroyed || t.has(r) && r(n);
                });
            });
        };
        this.notifyVerticalRenderRangeChange = (t = !1)=>{
            if (this.destroyed) return;
            let n = this.onVerticalRenderRangeChangeFns, r = this.verticalRenderRange, i = t ? $88ab1a78ec8ca4b4$var$Al : $88ab1a78ec8ca4b4$var$tr;
            n.forEach((a)=>{
                i(()=>{
                    this.destroyed || n.has(a) && a([
                        r.startIndex,
                        r.endIndex
                    ]);
                });
            });
        };
        this.notifyHorizontalRenderRangeChange = (t = !1)=>{
            if (this.destroyed) return;
            let n = this.onHorizontalRenderRangeChangeFns, r = this.horizontalRenderRange, i = t ? $88ab1a78ec8ca4b4$var$Al : $88ab1a78ec8ca4b4$var$tr;
            n.forEach((a)=>{
                i(()=>{
                    this.destroyed || n.has(a) && a([
                        r.startIndex,
                        r.endIndex
                    ]);
                });
            });
        };
        this.isColFixedEnd = (t)=>this.fixedColsEnd ? t >= this.cols - this.fixedColsEnd : !1;
        this.isColFixedStart = (t)=>this.fixedColsStart ? t < this.fixedColsStart : !1;
        this.isRowFixedEnd = (t)=>this.fixedRowsEnd ? t >= this.rows - this.fixedRowsEnd : !1;
        this.isRowFixedStart = (t)=>this.fixedRowsStart ? t < this.fixedRowsStart : !1;
        this.isColFixed = (t)=>this.isColFixedStart(t) || this.isColFixedEnd(t);
        this.isRowFixed = (t)=>this.isRowFixedStart(t) || this.isRowFixedEnd(t);
        this.getFixedEndColsWidth = ()=>{
            if (!this.fixedColsEnd) return 0;
            let t = 0;
            for(let n = this.cols - this.fixedColsEnd; n < this.cols; n++)t += this.getColWidth(n);
            return t;
        };
        this.getFixedEndColsOffsets = ({ skipScroll: t } = {
            skipScroll: !1
        })=>{
            if (!this.fixedColsEnd) return [];
            let { scrollLeft: n } = this.scrollPosition, { width: r } = this.getAvailableSize(), i = [], a = [], l = 0;
            for(let u = this.cols - this.fixedColsEnd; u < this.cols; u++){
                let d = this.getColWidth(u);
                a.push(d), l += d;
            }
            let s = r - l + (t ? 0 : n);
            l = 0;
            let c = 0;
            for(let u = this.cols - this.fixedColsEnd; u < this.cols; u++){
                let d = s + l;
                i[u] = d, l += a[c], c++;
            }
            return i;
        };
        this.getFixedEndRowsOffsets = ({ skipScroll: t } = {
            skipScroll: !1
        })=>{
            if (!this.fixedRowsEnd) return [];
            let { scrollTop: n } = this.scrollPosition, { height: r } = this.getAvailableSize(), i = [], a = [], l = 0;
            for(let u = this.rows - this.fixedRowsEnd; u < this.rows; u++){
                let d = this.getRowHeight(u);
                a.push(d), l += d;
            }
            let s = r - l + (t ? 0 : n);
            l = 0;
            let c = 0;
            for(let u = this.rows - this.fixedRowsEnd; u < this.rows; u++){
                let d = s + l;
                i[u] = d, l += a[c], c++;
            }
            return i;
        };
        this.getFixedStartColsWidth = ()=>{
            if (!this.fixedColsStart) return 0;
            let t = 0;
            for(let n = 0; n < this.fixedColsStart; n++)t += this.getColWidth(n);
            return t;
        };
        this.getFixedEndRowsHeight = ()=>{
            if (!this.fixedRowsEnd) return 0;
            let t = 0;
            for(let n = this.rows - this.fixedRowsEnd; n < this.rows; n++)t += this.getRowHeight(n);
            return t;
        };
        this.getFixedStartRowsHeight = ()=>{
            if (!this.fixedRowsStart) return 0;
            let t = 0;
            for(let n = 0; n < this.fixedRowsStart; n++)t += this.getRowHeight(n);
            return t;
        };
        this.computeRenderCount = (t = $88ab1a78ec8ca4b4$var$$t)=>{
            let n = t.horizontal, r = t.vertical, i = this.horizontalRenderCount || 0, a = this.verticalRenderCount || 0;
            return n && (i = this.computeDirectionalRenderCount("horizontal", this.colWidth, this.cols, this.getAvailableRenderSize())), r && (a = this.computeDirectionalRenderCount("vertical", this.rowHeight, this.rows, this.getAvailableRenderSize())), {
                horizontal: i,
                vertical: a
            };
        };
        this.setRenderCount = ({ horizontal: t, vertical: n })=>{
            t === void 0 && (t = this.horizontalRenderCount), n === void 0 && (n = this.verticalRenderCount);
            let r = t === this.horizontalRenderCount, i = n === this.verticalRenderCount;
            r && i || (this.horizontalRenderCount = t, this.verticalRenderCount = n, this.updateRenderRange({
                horizontal: !r,
                vertical: !i
            }), this.notifyRenderCountChange());
        };
        this.updateFixedCells = (t)=>{
            t.fixedColsStart != this.fixedColsStart && (this.fixedColsStart = t.fixedColsStart || 0), t.fixedColsEnd != this.fixedColsEnd && (this.fixedColsEnd = t.fixedColsEnd || 0), t.fixedRowsStart != this.fixedRowsStart && (this.fixedRowsStart = t.fixedRowsStart || 0), t.fixedRowsEnd != this.fixedRowsEnd && (this.fixedRowsEnd = t.fixedRowsEnd || 0);
        };
        this.getFixedCellInfo = ()=>{
            let { fixedRowsStart: t, fixedColsStart: n, fixedRowsEnd: r, fixedColsEnd: i } = this;
            return {
                fixedRowsStart: t,
                fixedColsStart: n,
                fixedRowsEnd: r,
                fixedColsEnd: i
            };
        };
        this.updateRenderRange = (t = $88ab1a78ec8ca4b4$var$$t)=>{
            this.setRenderRange(this.computeRenderRange(t));
        };
        this.getExtraSpanCellsForRange = ({ horizontal: t, vertical: n })=>{
            let { colspan: r, rowspan: i } = this, a = [];
            if (i) {
                let l = n.startIndex, s = t.startIndex, c = t.endIndex;
                for(let u = s; u < c; u++){
                    this.computeItemSpanUpTo(l, u, "vertical");
                    let d = this.rowspanParent.get(u);
                    if (d[l] != l) {
                        let f = l;
                        for(; d[f] != f;)f--;
                        a.push([
                            f,
                            u
                        ]);
                    }
                }
            }
            if (r) {
                let l = t.startIndex, s = n.startIndex, c = n.endIndex;
                for(let u = s; u < c; u++){
                    this.computeItemSpanUpTo(u, l, "horizontal");
                    let d = this.colspanParent.get(u);
                    if (d[l] != l) {
                        let f = l;
                        for(; d[f] != f;)f--;
                        a.push([
                            u,
                            f
                        ]);
                    }
                }
            }
            return a;
        };
        this.computeRenderRange = (t = $88ab1a78ec8ca4b4$var$$t)=>{
            let n = t.horizontal ? this.computeDirectionalRenderRange("horizontal") : this.horizontalRenderRange, r = t.vertical ? this.computeDirectionalRenderRange("vertical") : this.verticalRenderRange;
            return {
                horizontal: n,
                vertical: r,
                extraCells: this.getExtraSpanCellsForRange({
                    horizontal: n,
                    vertical: r
                })
            };
        };
        this.computeDirectionalRenderRange = (t)=>{
            let n = t === "horizontal" ? this.colWidth : this.rowHeight, r = t === "horizontal" ? this.horizontalRenderCount : this.verticalRenderCount, i = t === "horizontal" ? this.cols : this.rows;
            if (!r) return {
                startIndex: 0,
                endIndex: 0
            };
            let a = (t === "horizontal" ? this.fixedColsStart : this.fixedRowsStart) || 0, l = t === "horizontal" ? this.scrollPosition.scrollLeft : this.scrollPosition.scrollTop;
            l += this.getFixedStartSize(t);
            let s = typeof n != "function", c = t === "horizontal" ? this.horizontalExtendRangeBy : this.verticalExtendRangeBy, u = this.getItemAt(l, t), d = c.start || 0, f = c.end || 0;
            s || (d += this.RENDER_COUNT_SAFETY_MARGIN_START, f += this.RENDER_COUNT_SAFETY_MARGIN_END), d && (u = Math.max(0, u - d), r += d), f && (r += f);
            let p = u + r, m = Math.max(a, i - (t === "horizontal" ? this.fixedColsEnd : this.fixedRowsEnd));
            return p > m && (p = m, u = Math.max(a, p - r)), {
                startIndex: u,
                endIndex: p
            };
        };
        this.getItemAt = (t, n)=>{
            let r = n === "horizontal" ? this.colWidth : this.rowHeight, i = n === "horizontal" ? this.cols : this.rows;
            if (typeof r != "function") return Math.min(Math.max(0, Math.floor(t / r)), i - 1);
            let a = n === "horizontal" ? this.colOffsetCache : this.rowOffsetCache, l = n === "horizontal" ? this.colWidthCache : this.rowHeightCache, s = a.length - 1, c = l.length - 1, u = a[s], d;
            for(; u < t;)if (s >= i || (c += 1, this.computeCacheFor(c, n), d = u, u = a[c], d === u && d != 0)) return i - 1;
            let f = (0, $88ab1a78ec8ca4b4$var$tf.default)(a, t, $88ab1a78ec8ca4b4$var$Ml);
            return f >= 0 ? f : ~f - 1;
        };
        this.computeCacheFor = (t, n)=>{
            let r = n === "horizontal" ? this.colWidth : this.rowHeight, i = n === "horizontal" ? this.colWidthCache : this.rowHeightCache, a = n === "horizontal" ? this.colOffsetCache : this.rowOffsetCache;
            if (typeof r != "function") return;
            let l = r(t);
            if (i[t] = l, t > 0) {
                let s = a[t - 1], c = i[t - 1];
                s == null && console.error(`Offset was not available for ${n === "horizontal" ? "col" : "row"} ${t - 1}`), c == null && console.error(`Size was not available for ${n === "horizontal" ? "col" : "row"} ${t - 1}`);
                let u = s + c;
                a[t] = u;
            }
        };
        this.computeItemSpanUpTo = (t, n, r)=>{
            let i = r === "horizontal" ? n : t, a = r === "horizontal" ? t : n, l = r === "horizontal" ? this.cols : this.rows, s = r === "horizontal" ? this.colspan : this.rowspan;
            if (!s) return;
            let c = r === "horizontal" ? this.colspanParent : this.rowspanParent;
            c.has(a) || c.set(a, []);
            let u = r === "horizontal" ? this.colspanValue : this.rowspanValue;
            u.has(a) || u.set(a, []);
            let d = c.get(a), f = u.get(a);
            if (d[i] === void 0) {
                let p = d.length, m = l ? Math.min(i, l - 1) : 0, g = {
                    rowIndex: t,
                    colIndex: n
                };
                for(; p <= m; p++)if (d[p] === void 0) {
                    g[r === "horizontal" ? "colIndex" : "rowIndex"] = p;
                    let b = s(g);
                    d[p] = p, f[p] = b;
                    let h = p;
                    for(; b > 1;)h += 1, d[h] = p, f[h] = 0, b -= 1;
                }
            }
        };
        this.getCellSpan = (t, n, r)=>{
            let i = r === "horizontal" ? this.colspan : this.rowspan, a = r === "horizontal" ? n : t, l = r === "horizontal" ? t : n;
            if (!i) return 1;
            let s = r === "horizontal" ? this.colspanValue : this.rowspanValue, c = s.get(l);
            return (!c || c[a] === void 0) && this.computeItemSpanUpTo(t, n, r), c || (c = s.get(l)), c[a] || 1;
        };
        this.getRowspan = (t, n)=>this.getCellSpan(t, n, "vertical");
        this.getColspan = (t, n)=>this.getCellSpan(t, n, "horizontal");
        this.getRowspanParent = (t, n)=>this.getItemSpanParent(t, n, "vertical");
        this.getColspanParent = (t, n)=>this.getItemSpanParent(t, n, "horizontal");
        this.getItemSpanParent = (t, n, r)=>{
            let i = r == "horizontal" ? this.colspan : this.rowspan, a = r === "horizontal" ? n : t, l = r === "horizontal" ? t : n;
            if (!i) return a;
            let s = r === "horizontal" ? this.colspanParent : this.rowspanParent, c = s.get(l);
            return (!c || c[a] === void 0) && this.computeItemSpanUpTo(t, n, r), c || (c = s.get(l)), c[a];
        };
        this.getRowHeightWithSpan = (t, n, r)=>this.getItemSizeWithSpan(t, n, r, "vertical");
        this.getColWidthWithSpan = (t, n, r)=>this.getItemSizeWithSpan(t, n, r, "horizontal");
        this.getItemSizeWithSpan = (t, n, r, i)=>{
            let a = i === "horizontal" ? n : t, l = this.getItemSize(a, i);
            for(; r > 1;)a += 1, r -= 1, l += this.getItemSize(a, i);
            return l;
        };
        this.getRowHeight = (t)=>this.getItemSize(t, "vertical");
        this.getColWidth = (t)=>this.getItemSize(t, "horizontal");
        this.getItemSize = (t, n)=>{
            let r = n === "horizontal" ? this.cols : this.rows, i = n === "horizontal" ? this.colWidth : this.rowHeight;
            if (typeof i != "function") return i;
            let a = this.getItemSizeCacheFor(t, n), l = n === "horizontal" ? this.colWidthCache : this.rowHeightCache;
            if (a === void 0) {
                let s = l.length, c = Math.min(t, r - 1);
                for(; s <= c; s++)this.computeCacheFor(s, n);
                a = this.getItemSizeCacheFor(t, n);
            }
            return a;
        };
        this.keepColumnRendered = (t)=>(this.alwaysRenderedColumns.add(t), ()=>{
                this.alwaysRenderedColumns.delete(t);
            });
        this.getAlwaysRenderedColumns = ()=>Array.from(this.alwaysRenderedColumns);
        this.setRenderRange = ({ horizontal: t, vertical: n, extraCells: r })=>{
            let i = !1;
            (t.startIndex !== this.horizontalRenderRange.startIndex || t.endIndex !== this.horizontalRenderRange.endIndex) && (this.horizontalRenderRange = t, i = !0);
            let a = !1;
            (n.startIndex !== this.verticalRenderRange.startIndex || n.endIndex !== this.verticalRenderRange.endIndex) && (this.verticalRenderRange = n, a = !0), this.extraSpanCells = r || [], (i || a) && this.notifyRenderRangeChange(), a && this.notifyVerticalRenderRangeChange(), i && this.notifyHorizontalRenderRangeChange();
        };
        this.getRenderRangeCellCount = $88ab1a78ec8ca4b4$var$_l;
        this.getMaxCellCount = ()=>this.maxHorizontalRenderCount * this.maxVerticalRenderCount;
        this.getExtraCells = ()=>this.extraSpanCells;
        this.getScrollPosition = ()=>this.scrollPosition;
        this.getRenderRange = ()=>({
                start: [
                    this.verticalRenderRange.startIndex,
                    this.horizontalRenderRange.startIndex
                ],
                end: [
                    this.verticalRenderRange.endIndex,
                    this.horizontalRenderRange.endIndex
                ]
            });
        this.onScroll = (t)=>(this.onScrollFns.push(t), ()=>{
                this.onScrollFns = this.onScrollFns.filter((n)=>n !== t);
            });
        this.onScrollStart = (t)=>(this.onScrollStartFns.push(t), ()=>{
                this.onScrollStartFns = this.onScrollStartFns.filter((n)=>n !== t);
            });
        this.onScrollStop = (t)=>(this.onScrollStopFns.push(t), ()=>{
                this.onScrollStopFns = this.onScrollStopFns.filter((n)=>n !== t);
            });
        this.onRenderRangeChange = (t)=>(this.onRenderRangeChangeFns.add(t), ()=>{
                this.onRenderRangeChangeFns.delete(t);
            });
        this.onVerticalRenderRangeChange = (t)=>(this.onVerticalRenderRangeChangeFns.add(t), ()=>{
                this.onVerticalRenderRangeChangeFns.delete(t);
            });
        this.onHorizontalRenderRangeChange = (t)=>(this.onHorizontalRenderRangeChangeFns.add(t), ()=>{
                this.onHorizontalRenderRangeChangeFns.delete(t);
            });
        this.onRenderCountChange = (t)=>(this.onRenderCountChangeFns.add(t), ()=>{
                this.onRenderCountChangeFns.delete(t);
            });
        this.onAvailableSizeChange = (t)=>(this.onAvailableSizeChangeFns.add(t), ()=>{
                this.onAvailableSizeChangeFns.delete(t);
            });
        this.onDestroy = (t)=>(this.onDestroyFns.push(t), ()=>{
                this.onDestroyFns = this.onDestroyFns.filter((n)=>n !== t);
            });
        this.getAvailableSize = ()=>({
                width: this.availableWidth,
                height: this.availableHeight
            });
        this.getAvailableRenderSize = ()=>({
                width: this.availableRenderWidth ?? this.availableWidth,
                height: this.availableRenderHeight ?? this.availableHeight
            });
        this.name = n, this.update = this.update.bind(this), this.destroy = this.destroy.bind(this), this.getCellOffset = this.getCellOffset.bind(this), this.reset();
    }
    set rowsPerPage(t) {
        t != this._rowsPerPage && (this._rowsPerPage = t);
    }
    get rowsPerPage() {
        return this._rowsPerPage;
    }
    reset(t = $88ab1a78ec8ca4b4$var$$t) {
        t.vertical && this.resetVertical(), t.horizontal && this.resetHorizontal(), this.extraSpanCells = [];
    }
    resetVertical() {
        this.rowspanParent = new Map, this.rowspanValue = new Map, this.rowHeightCache = [], this.rowOffsetCache = [
            0
        ], this.verticalRenderCount = void 0, this.verticalTotalSize = 0, this.verticalRenderRange = {
            startIndex: 0,
            endIndex: 0
        };
    }
    resetHorizontal() {
        this.colspanParent = new Map, this.colspanValue = new Map, this.colWidthCache = [], this.colOffsetCache = [
            0
        ], this.horizontalRenderCount = void 0, this.horizontalTotalSize = 0, this.horizontalRenderRange = {
            startIndex: 0,
            endIndex: 0
        };
    }
    getVirtualColIndex(t, n) {
        return t;
    }
    update(t, n) {
        let { rows: r, cols: i, rowHeight: a, colWidth: l, width: s, height: c } = t, u = typeof s == "number", d = typeof c == "number", f = u && s !== this.availableWidth, p = d && c !== this.availableHeight;
        f && (this.availableWidth = s, this.availableRenderWidth = s), p && (this.availableHeight = c, this.availableRenderHeight = c), (f || p) && this.notifyAvailableSizeChange();
        let m = typeof r == "number", g = typeof i == "number", b = m && r !== this.rows, h = g && i !== this.cols;
        m && (this.rows = r, this.rowsPerPage = r), g && (this.cols = i);
        let y = a != null, S = l != null, C = y && a !== this.rowHeight, T = S && l !== this.colWidth;
        y && (this.rowHeight = a), S && (this.colWidth = l);
        let I = t.rowspan != null, w = t.colspan != null, v = I && t.rowspan != this.rowspan, R = w && t.colspan != this.colspan;
        v && (this.rowspan = t.rowspan), R && (this.colspan = t.colspan);
        let x = h || T || f || R, M = b || C || p || v;
        (n || $88ab1a78ec8ca4b4$var$Hy)({
            horizontalChange: x,
            verticalChange: M,
            colsChanged: h,
            colWidthChanged: T,
            widthChanged: f,
            colspanChanged: R,
            rowsChanged: b,
            rowHeightChanged: C,
            heightChanged: p,
            rowspanChanged: v
        }) && this.updateRenderCount({
            horizontal: x,
            vertical: M
        });
    }
    extendRenderRange(t) {
        let { direction: n } = t, r = n === "horizontal", i = r ? this.horizontalRenderCount || this.getInitialCols() : this.verticalRenderCount || this.getInitialRows(), a = typeof t.start == "number" ? t.start : t.start === !0 ? i : 0, l = typeof t.end == "number" ? t.end : t.end === !0 ? i : 0;
        return r ? this.horizontalExtendRangeBy = {
            start: a,
            end: l
        } : this.verticalExtendRangeBy = {
            start: a,
            end: l
        }, this.updateRenderRange({
            horizontal: r,
            vertical: !r
        }), ()=>{
            this.extendRenderRange({
                start: 0,
                end: 0,
                direction: n
            });
        };
    }
    updateRenderCount(t = $88ab1a78ec8ca4b4$var$$t) {
        this.reset(t), this.doUpdateRenderCount(t);
    }
    doUpdateRenderCount(t = $88ab1a78ec8ca4b4$var$$t) {
        if (!this.availableWidth || !this.availableHeight) {
            let n = {
                horizontal: void 0,
                vertical: void 0
            };
            this.availableWidth || (n.horizontal = 0), this.availableHeight || (n.vertical = 0), this.setRenderCount(n);
        }
        this.setRenderCount(this.computeRenderCount(t));
    }
    get scrollTopMax() {
        return this.getVirtualizedContentSize().height - this.availableHeight;
    }
    get scrollLeftMax() {
        return this.getVirtualizedContentSize().width - this.availableWidth;
    }
    setScrollPosition(t, n) {
        this.setScrolling(!0);
        let r = t.scrollLeft !== this.scrollPosition.scrollLeft, i = t.scrollTop !== this.scrollPosition.scrollTop;
        this.scrollPosition = t, (r || i) && (n?.(t), this.updateRenderRange({
            horizontal: r,
            vertical: i
        }), this.notifyScrollChange());
    }
    notifyRenderRangeChange(t = !1) {
        if (this.destroyed) return;
        let n = this.onRenderRangeChangeFns, r = this.getRenderRange(), i = t ? $88ab1a78ec8ca4b4$var$Al : $88ab1a78ec8ca4b4$var$tr;
        n.forEach((a)=>{
            i(()=>{
                this.destroyed || n.has(a) && a(r);
            });
        });
    }
    notifyScrollChange() {
        if (this.destroyed) return;
        let { scrollPosition: t } = this, n = this.onScrollFns;
        for(let r = 0, i = n.length; r < i; r++)n[r](t);
    }
    computeDirectionalRenderCount(t, n, r, i) {
        let a = 0, l = t === "horizontal" ? i.width : i.height;
        if (l -= this.getFixedSize(t), l <= 0) return 0;
        let s = t === "horizontal" ? this.fixedColsStart : this.fixedRowsStart, c = t === "horizontal" ? this.fixedColsEnd : this.fixedRowsEnd;
        if (typeof n == "function") {
            let u = [], d = 0, f = r;
            d += s, f -= c;
            for(let p = d; p < f; p++)u.push(this.getItemSize(p, t));
            a = $88ab1a78ec8ca4b4$var$di(l, u);
        } else a = (n ? Math.ceil(l / n) : 0) + 1;
        return a += s + c, t === "horizontal" ? this.maxHorizontalRenderCount = a : this.maxVerticalRenderCount = a, a = Math.min(r, a), a;
    }
    getFixedSize(t) {
        return t === "horizontal" ? this.getFixedStartColsWidth() + this.getFixedEndColsWidth() : this.getFixedStartRowsHeight() + this.getFixedEndRowsHeight();
    }
    getFixedStartSize(t) {
        return t === "horizontal" ? this.getFixedStartColsWidth() : this.getFixedStartRowsHeight();
    }
    getFixedEndSize(t) {
        return t === "horizontal" ? this.getFixedEndColsWidth() : this.getFixedEndRowsHeight();
    }
    notifyRenderCountChange() {
        if (this.destroyed) return;
        let { horizontalRenderCount: t, verticalRenderCount: n } = this, r = {
            horizontal: t,
            vertical: n
        }, i = this.onRenderCountChangeFns;
        i.forEach((a)=>{
            $88ab1a78ec8ca4b4$var$tr(()=>{
                this.destroyed || i.has(a) && a(r);
            });
        });
    }
    getCellOffset(t, n) {
        return {
            x: this.getItemOffsetFor(n, "horizontal"),
            y: this.getItemOffsetFor(t, "vertical")
        };
    }
    getInitialRowHeight() {
        return this.rowHeight;
    }
    getInitialCols() {
        return this.cols;
    }
    getInitialRows() {
        return this.rows;
    }
    getItemOffsetFor(t, n) {
        let r = n === "horizontal" ? this.colWidth : this.rowHeight;
        if (typeof r != "function") return t * r;
        let i = n === "horizontal" ? this.colOffsetCache : this.rowOffsetCache, a = n === "horizontal" ? this.colWidthCache : this.rowHeightCache, l = i[t];
        if (l == null) {
            let s = a.length - 1;
            for(; s < t;)s += 1, this.computeCacheFor(s, n);
            l = i[t];
        }
        return l;
    }
    getItemSizeCacheFor(t, n) {
        return (n === "horizontal" ? this.colWidthCache : this.rowHeightCache)[t];
    }
    getRowIndexInPage(t) {
        return t;
    }
    getPageIndexForRow(t) {
        return 0;
    }
    getVirtualizedContentSize() {
        return {
            height: this.getVirtualizedContentSizeFor("vertical"),
            width: this.getVirtualizedContentSizeFor("horizontal")
        };
    }
    getVirtualizedContentSizeFor(t) {
        let n = t === "horizontal" ? this.cols : this.rows, r = t === "horizontal" ? this.colWidth : this.rowHeight, i = t === "horizontal" ? this.horizontalTotalSize : this.verticalTotalSize;
        if (typeof r != "function") return r * n;
        if (i !== 0 && !isNaN(i)) return i;
        let a = t === "horizontal" ? this.colOffsetCache : this.rowOffsetCache, l = n ? this.getItemSize(n - 1, t) : 0, s = n ? a[n - 1] : 0, c = l + s;
        return t === "horizontal" ? this.horizontalTotalSize = c : this.verticalTotalSize = c, c;
    }
    notifyDestroy() {
        let t = this.onDestroyFns;
        for(let n = 0, r = t.length; n < r; n++)t[n]();
    }
    destroy() {
        this.destroyed || (this.notifyDestroy(), this.reset(), this.rowspanParent.clear(), this.colspanParent.clear(), this.alwaysRenderedColumns.clear(), this.horizontalExtendRangeBy = $88ab1a78ec8ca4b4$var$fi, this.verticalExtendRangeBy = $88ab1a78ec8ca4b4$var$fi, this.destroyed = !0, this.onDestroyFns = [], this.onScrollFns = [], this.onScrollStartFns = [], this.onScrollStopFns = [], this.onRenderCountChangeFns.clear(), this.onRenderRangeChangeFns.clear(), this.onVerticalRenderRangeChangeFns.clear(), this.onHorizontalRenderRangeChangeFns.clear());
    }
};
var $88ab1a78ec8ca4b4$var$Nl = $88ab1a78ec8ca4b4$var$qn($88ab1a78ec8ca4b4$var$Dn());
function $88ab1a78ec8ca4b4$var$of(...o) {
    if (!o.length) return new Set;
    let [e, ...t] = o;
    return new Set([
        ...e
    ].filter((n)=>t.every((r)=>r.has(n))));
}
function $88ab1a78ec8ca4b4$var$rf(o, e) {
    let t = new Set;
    for (let n of o)e(n) && t.add(n);
    return t;
}
function $88ab1a78ec8ca4b4$var$nr(o, e) {
    for (let t of o)if (e(t)) return t;
}
var $88ab1a78ec8ca4b4$var$af = new Map, $88ab1a78ec8ca4b4$var$Ky = ()=>{}, $88ab1a78ec8ca4b4$var$Ol = class {
    constructor(e, t){
        this.element = null;
        this.mounted = !1;
        this.IS_UPDATED_WHILE_SCROLLING_IN_HORIZONTAL_LAYOUT = !1;
        this.mountSubscription = $88ab1a78ec8ca4b4$var$ye();
        this.isUpdatedWhileScrolling = ()=>this.IS_UPDATED_WHILE_SCROLLING_IN_HORIZONTAL_LAYOUT;
        let n = $88ab1a78ec8ca4b4$var$af.get(e) ?? 0, r = `${e}:GridCellReact:${n}`;
        $88ab1a78ec8ca4b4$var$af.set(e, n + 1), this.debugId = r, this.cellInfo = t, this.updater = $88ab1a78ec8ca4b4$var$ye(), this.node = $acw62.createElement($88ab1a78ec8ca4b4$var$mn, {
            key: r,
            name: r,
            updater: this.updater,
            shouldFlushSync: this.isUpdatedWhileScrolling
        }), this.ref = (i)=>{
            this.element = i, i ? (this.mounted = !0, this.mountSubscription(this)) : this.mounted = !1;
        };
    }
    isMounted() {
        return this.mounted;
    }
    onMount(e) {
        return this.mountSubscription.onChange((n)=>{
            n != null && e(n);
        });
    }
    destroy() {
        this.mountSubscription.destroy(), this.updater.destroy(), this.ref = $88ab1a78ec8ca4b4$var$Ky, this.element = null, this.node = null;
    }
    getNode() {
        return this.node;
    }
    update(e, t, n) {
        this.IS_UPDATED_WHILE_SCROLLING_IN_HORIZONTAL_LAYOUT = n ? n.scrolling && n.isHorizontalLayout : !1, this.updater(e), this.cellInfo = t;
    }
    getAdditionalInfo() {
        return this.cellInfo;
    }
    getElement() {
        return this.element;
    }
}, $88ab1a78ec8ca4b4$var$fo = class fo extends $88ab1a78ec8ca4b4$var$st {
    constructor(t){
        super(`${t}:GridCellPoolForReact`);
        this.debugId = t;
        this.cellRemoveSubscription = $88ab1a78ec8ca4b4$var$ye();
        this.cellAttachmentChangeSubscription = $88ab1a78ec8ca4b4$var$ye();
        this.attachedCells = new Set, this.detachedCells = new Set, this.allCellsOrdered = new Set;
    }
    destroy() {
        this.reset();
    }
    onRemoveCell(t) {
        return this.cellRemoveSubscription.onChange((r)=>{
            r != null && t(r);
        });
    }
    onCellAttachmentChange(t) {
        return this.cellAttachmentChangeSubscription.onChange((r)=>{
            if (r == null) return;
            let { cell: i, attached: a } = r;
            t(i, a);
        });
    }
    reset() {
        this.attachedCells.clear(), this.detachedCells.clear(), this.allCellsOrdered.clear(), this.cellRemoveSubscription.destroy(), this.cellAttachmentChangeSubscription.destroy();
    }
    getAttachedCells() {
        return this.attachedCells;
    }
    getDetachedCells() {
        return this.detachedCells;
    }
    getAllCells() {
        return this.allCellsOrdered;
    }
    createCell() {
        let t = new $88ab1a78ec8ca4b4$var$Ol(this.debugId);
        return this.detachedCells.add(t), this.allCellsOrdered.add(t), t;
    }
    removeCell(t) {
        this.detachedCells.delete(t), this.attachedCells.delete(t), this.allCellsOrdered.delete(t), t.destroy(), this.cellRemoveSubscription(t);
    }
    attachCell(t) {
        return t && this.attachedCells.has(t) || (t || (t = this.getDetachedCell()), this.detachedCells.delete(t), this.attachedCells.add(t), this.cellAttachmentChangeSubscription({
            cell: t,
            attached: !0
        })), t;
    }
    detachCell(t) {
        return this.detachedCells.has(t) ? !1 : (this.attachedCells.delete(t), this.detachedCells.add(t), this.cellAttachmentChangeSubscription({
            cell: t,
            attached: !1
        }), !0);
    }
    getDetachedCell() {
        let { detachedCells: t } = this, n = t.values().next().value;
        return n || (this.poolSize += fo.POOL_SIZE_INCREMENT, n = t.values().next().value), n || this.error("No cells available in the pool!"), n;
    }
    get attachedSize() {
        return this.attachedCells.size;
    }
    get detachedSize() {
        return this.detachedCells.size;
    }
    get poolSize() {
        return this.allCellsOrdered.size;
    }
    set poolSize(t) {
        t = Math.ceil(t / fo.POOL_SIZE_INCREMENT) * fo.POOL_SIZE_INCREMENT;
        let n = this.poolSize;
        if (t === n) return;
        let { detachedCells: r } = this, i = n - t;
        if (i > 0) {
            i > r.size && (i = r.size, this.debug("Trying to destroy more cells than are currently detached!"));
            let a = r.values();
            for(; i > 0;){
                let l = a.next().value;
                this.removeCell(l), i--;
            }
        } else for(i = -i; i > 0;)this.createCell(), i--;
    }
};
$88ab1a78ec8ca4b4$var$fo.POOL_SIZE_INCREMENT = 1;
var $88ab1a78ec8ca4b4$var$pi = $88ab1a78ec8ca4b4$var$fo;
var $88ab1a78ec8ca4b4$var$mi = (o, e)=>o - e, $88ab1a78ec8ca4b4$var$gi = class extends $88ab1a78ec8ca4b4$var$st {
    constructor(t){
        super(`${t}:GridCellManager`);
        this.matrix = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.rowsWithCellsHistory = new Map;
        this.columnsWithCellsHistory = new Map;
        this.cellToMatrixPosition = new WeakMap;
        this.getCellsOutsideRenderRange = (t)=>{
            let { start: n, end: r } = t, [i, a] = n, [l, s] = r, c = new Set;
            return this.matrix.visit(({ value: u }, d)=>{
                if (!u) return;
                let [f, p] = d, m = f < i, g = f >= l, b = p < a, h = p >= s;
                (m || g || b || h) && c.add(u);
            }), c;
        };
        this.debugId = t, this.pool = new $88ab1a78ec8ca4b4$var$pi(t), this.offRemoveCell = this.pool.onRemoveCell((n)=>this.onRemoveCell(n));
    }
    onRemoveCell(t) {
        let n = this.cellToMatrixPosition.get(t);
        this.cellToMatrixPosition.delete(t), n && this.clearCellFromMatrix(t, n, {
            skipHistory: !1
        });
    }
    set poolSize(t) {
        this.pool.poolSize = t;
    }
    get poolSize() {
        return this.pool.poolSize;
    }
    getDetachedCell() {
        return this.pool.getDetachedCell();
    }
    clearCellFromMatrix(t, n, r) {
        if (this.matrix.delete(n), r.skipHistory) return;
        let [i, a] = n, l = this.rowsWithCellsHistory.get(i), s = this.columnsWithCellsHistory.get(a);
        l && (l.delete(t), l.size === 0 && this.rowsWithCellsHistory.delete(i)), s && (s.delete(t), s.size === 0 && this.columnsWithCellsHistory.delete(a));
    }
    addCellToMatrix(t, n) {
        let [r, i] = n;
        this.matrix.set(n, t), this.cellToMatrixPosition.set(t, n);
        let a = this.rowsWithCellsHistory.get(r), l = this.columnsWithCellsHistory.get(i);
        a ? a.add(t) : (a = new Set, a.add(t), this.rowsWithCellsHistory.set(r, a)), l ? l.add(t) : (l = new Set, l.add(t), this.columnsWithCellsHistory.set(i, l));
    }
    setCellPositionInMatrix(t, n) {
        let r = this.cellToMatrixPosition.get(t);
        if (n == null) {
            r && this.clearCellFromMatrix(t, r, {
                skipHistory: !0
            });
            return;
        }
        let [i, a] = n, l = r && r[0] === i && r[1] === a;
        r && !l && this.clearCellFromMatrix(t, r, {
            skipHistory: !1
        }), this.addCellToMatrix(t, n);
    }
    renderNodeAtCell(t, n, r, i, a) {
        let l = this.getCellAt(r);
        return l && l !== n && this.detachCellAt(r), this.pool.attachCell(n), this.setCellPositionInMatrix(n, r), n.update(t, i, a), n;
    }
    getCellPosition(t) {
        let n = this.cellToMatrixPosition.get(t);
        return !n || this.getCellAt(n) != t ? null : n;
    }
    getCellAt(t) {
        return this.matrix.get(t);
    }
    getCellFor(t, n) {
        let r = this.getCellAt(t);
        if (r) return r;
        let [i, a] = t;
        if (n === "row") {
            let l = this.rowsWithCellsHistory.get(i);
            l && (r = $88ab1a78ec8ca4b4$var$nr(l, (s)=>!this.isCellAttached(s)));
        }
        if (n === "column") {
            let l = this.columnsWithCellsHistory.get(a);
            l && (r = $88ab1a78ec8ca4b4$var$nr(l, (s)=>!this.isCellAttached(s)));
        }
        return r ?? this.getDetachedCell();
    }
    isCellAttached(t) {
        return this.getCellPosition(t) !== null;
    }
    isCellAttachedAt(t) {
        let n = this.getCellAt(t);
        return n ? this.isCellAttached(n) : !1;
    }
    getMatrix() {
        let t = this.getRowsWithCells().pop() ?? -1, n = this.getColumnsWithCells().pop() ?? -1;
        return Array.from({
            length: t + 1
        }, (i, a)=>Array.from({
                length: n + 1
            }, (s, c)=>{
                let u = [
                    a,
                    c
                ], d = this.getCellAt(u);
                return d ? d.getNode() : null;
            }));
    }
    getAllCells() {
        return [
            ...this.pool.getAllCells()
        ];
    }
    getCellsForRow(t) {
        return this.matrix.getKeysStartingWith([
            t
        ]).map((n)=>this.getCellAt(n)).filter(Boolean);
    }
    getOneAttachedCell() {
        return this.pool.getAttachedCells().values().next().value;
    }
    getRowsWithCells() {
        return this.matrix.rawKeysAt([]).sort($88ab1a78ec8ca4b4$var$mi);
    }
    getColumnsWithCells() {
        let t = this.matrix.getKeysOfFirstChildOnEachBranchStartingWith([], {
            excludeSelf: !0
        });
        return [
            ...new Set(t.map((r)=>r[1])).values()
        ].sort($88ab1a78ec8ca4b4$var$mi);
    }
    isRowAttached(t) {
        return this.getRowsWithCells().includes(t);
    }
    isColumnAttached(t) {
        return this.getColumnsWithCells().includes(t);
    }
    detachRow(t) {
        this.matrix.getKeysStartingWith([
            t
        ]).forEach((r)=>this.detachCellAt(r));
    }
    detachCol(t) {
        this.matrix.visit((n, r)=>{
            r[1] === t && this.detachCellAt(r);
        });
    }
    detachCell(t) {
        return t ? (this.pool.detachCell(t) && this.setCellPositionInMatrix(t, null), !0) : !1;
    }
    detachCells(t) {
        t.forEach((n)=>this.detachCell(n));
    }
    detachRowsStartingWith(t) {
        let n = this.getRowsWithCells().sort(), r = (0, $88ab1a78ec8ca4b4$var$Nl.default)(n, t, $88ab1a78ec8ca4b4$var$mi);
        r < 0 && (r = ~r), n.slice(r).forEach((a)=>this.detachRow(a));
    }
    detachColsStartingWith(t) {
        let n = this.getColumnsWithCells().sort(), r = (0, $88ab1a78ec8ca4b4$var$Nl.default)(n, t, $88ab1a78ec8ca4b4$var$mi);
        r < 0 && (r = ~r), n.slice(r).forEach((a)=>this.detachCol(a));
    }
    detachCellsStartingAt(t) {
        let [n, r] = t;
        this.matrix.visit((i, a)=>{
            let [l, s] = a;
            l > n && this.detachCellAt(a), l === n && s >= r && this.detachCellAt(a);
        });
    }
    detachCellAt(t) {
        let n = this.getCellAt(t);
        return n ? this.detachCell(n) : !1;
    }
    onCellAttachmentChange(t) {
        return this.pool.onCellAttachmentChange(t);
    }
    getCellFromListForRow(t, n) {
        return $88ab1a78ec8ca4b4$var$nr(t, (r)=>this.getCellPosition(r)?.[0] === n);
    }
    getCellFromListForColumn(t, n) {
        return $88ab1a78ec8ca4b4$var$nr(t, (r)=>this.getCellPosition(r)?.[1] === n);
    }
    getCellCountInMatrix() {
        return this.matrix.size;
    }
    destroy() {
        this.reset();
    }
    reset() {
        this.pool.reset(), this.matrix.clear(), this.rowsWithCellsHistory.clear(), this.columnsWithCellsHistory.clear(), this.offRemoveCell(), this.offRemoveCell = ()=>{};
    }
    makeDetachedCellsEmpty() {
        this.pool.getDetachedCells().forEach((t)=>{
            t.update(null);
        });
    }
    withDetachedCells(t) {
        this.pool.getDetachedCells().forEach(t);
    }
};
var $88ab1a78ec8ca4b4$var$uf = $88ab1a78ec8ca4b4$var$qn($88ab1a78ec8ca4b4$var$Dn());
var $88ab1a78ec8ca4b4$var$sf = new Map, $88ab1a78ec8ca4b4$var$By = ()=>{}, $88ab1a78ec8ca4b4$var$Fl = class {
    constructor(e){
        this.element = null;
        this.mounted = !1;
        this.mountSubscription = $88ab1a78ec8ca4b4$var$ye();
        let t = $88ab1a78ec8ca4b4$var$sf.get(e) ?? 0, n = `${e}:ListRowReact:${t}`;
        $88ab1a78ec8ca4b4$var$sf.set(e, t + 1), this.debugId = n, this.updater = $88ab1a78ec8ca4b4$var$ye(), this.node = $acw62.createElement($88ab1a78ec8ca4b4$var$mn, {
            key: `detail-row-${n}`,
            name: `detail-row-${n}`,
            updater: this.updater
        }), this.ref = (r)=>{
            this.element = r, r ? (this.mounted = !0, this.mountSubscription(this)) : this.mounted = !1;
        };
    }
    isMounted() {
        return this.mounted;
    }
    onMount(e) {
        return this.mountSubscription.onChange((n)=>{
            n != null && e(n);
        });
    }
    destroy() {
        this.mountSubscription.destroy(), this.updater.destroy(), this.ref = $88ab1a78ec8ca4b4$var$By, this.element = null, this.node = null;
    }
    getNode() {
        return this.node;
    }
    update(e) {
        this.updater(e);
    }
    getElement() {
        return this.element;
    }
}, $88ab1a78ec8ca4b4$var$po = class po extends $88ab1a78ec8ca4b4$var$st {
    constructor(t){
        super(`${t}:ListRowPoolForReact`);
        this.debugId = t;
        this.rowRemoveSubscription = $88ab1a78ec8ca4b4$var$ye();
        this.rowAttachmentChangeSubscription = $88ab1a78ec8ca4b4$var$ye();
        this.attachedRows = new Set, this.detachedRows = new Set, this.allRowsOrdered = new Set;
    }
    destroy() {
        this.reset();
    }
    onRemoveRow(t) {
        return this.rowRemoveSubscription.onChange((r)=>{
            r != null && t(r);
        });
    }
    onRowAttachmentChange(t) {
        return this.rowAttachmentChangeSubscription.onChange((r)=>{
            if (r == null) return;
            let { row: i, attached: a } = r;
            t(i, a);
        });
    }
    reset() {
        this.attachedRows.clear(), this.detachedRows.clear(), this.allRowsOrdered.clear(), this.rowRemoveSubscription.destroy(), this.rowAttachmentChangeSubscription.destroy();
    }
    getAttachedRows() {
        return this.attachedRows;
    }
    getDetachedRows() {
        return this.detachedRows;
    }
    getAllRows() {
        return this.allRowsOrdered;
    }
    createRow() {
        let t = new $88ab1a78ec8ca4b4$var$Fl(this.debugId);
        return this.detachedRows.add(t), this.allRowsOrdered.add(t), t;
    }
    removeRow(t) {
        this.detachedRows.delete(t), this.attachedRows.delete(t), this.allRowsOrdered.delete(t), t.destroy(), this.rowRemoveSubscription(t);
    }
    attachRow(t) {
        return t && this.attachedRows.has(t) || (t || (t = this.getDetachedRow()), this.detachedRows.delete(t), this.attachedRows.add(t), this.rowAttachmentChangeSubscription({
            row: t,
            attached: !0
        })), t;
    }
    detachRow(t) {
        return this.detachedRows.has(t) ? !1 : (this.attachedRows.delete(t), this.detachedRows.add(t), this.rowAttachmentChangeSubscription({
            row: t,
            attached: !1
        }), !0);
    }
    getDetachedRow() {
        let { detachedRows: t } = this, n = t.values().next().value;
        return n || (this.poolSize += po.POOL_SIZE_INCREMENT), n = t.values().next().value, n || this.error("No rows available in the pool!"), n;
    }
    get attachedSize() {
        return this.attachedRows.size;
    }
    get detachedSize() {
        return this.detachedRows.size;
    }
    get poolSize() {
        return this.allRowsOrdered.size;
    }
    set poolSize(t) {
        t = Math.ceil(t / po.POOL_SIZE_INCREMENT) * po.POOL_SIZE_INCREMENT;
        let n = this.poolSize;
        if (t === n) return;
        let { detachedRows: r } = this, i = n - t;
        if (i > 0) {
            i > r.size && (i = r.size, this.debug("Trying to destroy more rows than are currently detached!"));
            let a = r.values();
            for(; i > 0;){
                let l = a.next().value;
                this.removeRow(l), i--;
            }
        } else for(i = -i; i > 0;)this.createRow(), i--;
    }
};
$88ab1a78ec8ca4b4$var$po.POOL_SIZE_INCREMENT = 1;
var $88ab1a78ec8ca4b4$var$hi = $88ab1a78ec8ca4b4$var$po;
var $88ab1a78ec8ca4b4$var$bi = class extends $88ab1a78ec8ca4b4$var$st {
    constructor(t){
        super(`${t}:ListRowManager`);
        this.indexToRow = new Map;
        this.rowToIndex = new WeakMap;
        this.debugId = t, this.pool = new $88ab1a78ec8ca4b4$var$hi(t), this.offRemoveRow = this.pool.onRemoveRow((n)=>this.onRemoveRow(n));
    }
    onRemoveRow(t) {
        let n = this.rowToIndex.get(t);
        n != null && (this.rowToIndex.delete(t), this.indexToRow.delete(n));
    }
    set poolSize(t) {
        this.pool.poolSize = t;
    }
    get poolSize() {
        return this.pool.poolSize;
    }
    getDetachedRow() {
        return this.pool.getDetachedRow();
    }
    getRowFor(t) {
        return this.getRowAt(t) ?? this.getDetachedRow();
    }
    setRowIndexInList(t, n) {
        let r = this.rowToIndex.get(t);
        r != null && this.indexToRow.delete(r), n == null ? this.rowToIndex.delete(t) : (this.rowToIndex.set(t, n), this.indexToRow.set(n, t));
    }
    detachStartingWith(t) {
        let n = this.getAttachedIndexes(), r = (0, $88ab1a78ec8ca4b4$var$uf.default)(n, t, (a, l)=>a - l);
        r < 0 && (r = ~r), n.slice(r).forEach((a)=>this.detachRowAt(a));
    }
    getRowAt(t) {
        return this.indexToRow.get(t);
    }
    getRowIndex(t) {
        return this.rowToIndex.get(t);
    }
    isRowAttached(t) {
        return this.getRowIndex(t) != null;
    }
    isRowAttachedAt(t) {
        return !!this.getRowAt(t);
    }
    getList() {
        let t = Math.max(...this.indexToRow.keys());
        return Array.from({
            length: t + 1
        }, (r, i)=>{
            let a = this.indexToRow.get(i);
            return a ? a.getNode() : null;
        });
    }
    getAttachedCount() {
        return this.indexToRow.size;
    }
    forEachAttachedRow(t) {
        this.indexToRow.forEach(t);
    }
    getAttachedIndexes() {
        return Array.from(this.indexToRow.keys()).sort();
    }
    getAllRows() {
        return [
            ...this.pool.getAllRows()
        ];
    }
    detachRowAt(t) {
        let n = this.getRowAt(t);
        n && (this.setRowIndexInList(n, null), this.pool.detachRow(n));
    }
    detachRow(t) {
        let n = this.getRowIndex(t);
        n != null && this.detachRowAt(n);
    }
    renderNodeAtRow(t, n, r) {
        let i = this.getRowAt(r);
        return i && i !== n && this.detachRowAt(r), this.pool.attachRow(n), this.setRowIndexInList(n, r), n.update(t), n;
    }
    makeDetachedRowsEmpty() {
        this.pool.getDetachedRows().forEach((t)=>{
            t.update(null);
        });
    }
    onRowAttachmentChange(t) {
        return this.pool.onRowAttachmentChange(t);
    }
    withDetachedRows(t) {
        this.pool.getDetachedRows().forEach(t);
    }
    destroy() {
        this.reset();
    }
    reset() {
        this.pool.reset(), this.indexToRow.clear(), this.offRemoveRow(), this.offRemoveRow = ()=>{};
    }
};
var $88ab1a78ec8ca4b4$var$df = !0, $88ab1a78ec8ca4b4$var$Vn = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.y), $88ab1a78ec8ca4b4$var$ff = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.scrollTop), $88ab1a78ec8ca4b4$var$n_ = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnOffsetAtIndex), $88ab1a78ec8ca4b4$var$kl = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnOffsetAtIndexWhileReordering), $88ab1a78ec8ca4b4$var$Ll = {
    scrolling: !1,
    isHorizontalLayout: !1
}, $88ab1a78ec8ca4b4$var$mo = class extends $88ab1a78ec8ca4b4$var$st {
    constructor(t, n){
        n = n || "ReactHeadlessTableRenderer";
        super(n);
        this.debugId = "";
        this.destroyed = !1;
        this.scrolling = !1;
        this.cellHoverClassNames = [];
        this.cellDetachedClassNames = [];
        this.lastEnteredRow = -1;
        this.lastExitedRow = -1;
        this.hoverRowUpdatesInProgress = new Map;
        this.infiniteNode = null;
        this.setDetailTransform = (t, n, { y: r, scrollTop: i, scrollLeft: a })=>{
            t.style.setProperty($88ab1a78ec8ca4b4$var$Vn, i ? `calc( ${r}px + var(${$88ab1a78ec8ca4b4$var$ff}) )` : `${r}px`), t.style.transform = `translate3d(${a || 0}px, var(${$88ab1a78ec8ca4b4$var$Vn}), 0)`;
        };
        this.setTransform = (t, n, r, { x: i, y: a, scrollLeft: l, scrollTop: s }, c)=>{
            let u = $88ab1a78ec8ca4b4$var$Ce.columnOffsets.get(r), d = `${$88ab1a78ec8ca4b4$var$kl}-${r}`, f = s ? `calc( ${a}px + var(${$88ab1a78ec8ca4b4$var$ff}) )` : `${a}px`;
            t.__currentTransformY !== f && (t.__currentTransformY = f, t.style.setProperty($88ab1a78ec8ca4b4$var$Vn, f));
            let p = `translate3d(var(${d}, ${u}), var(${$88ab1a78ec8ca4b4$var$Vn}), 0)`;
            t.__transformValue !== p && (t.__transformValue = p, t.style.transform = p), c;
        };
        this.getFullyVisibleRowsRange = ()=>{
            let { start: [t], end: [n] } = this.brain.getRenderRange();
            for(; !this.isRowFullyVisible(t);)if (t++, t === n) return null;
            for(; !this.isRowFullyVisible(n);)if (n--, n === t) return null;
            return {
                start: t,
                end: n
            };
        };
        this.getScrollPositionForScrollRowIntoView = (t, n = {
            offset: 0
        })=>{
            if (this.destroyed) return null;
            let { brain: r } = this, i = r.getScrollPosition(), a = i.scrollLeft, { scrollAdjustPosition: l, offset: s = 0 } = n;
            if (this.isRowFullyVisible(t) && !l) return i;
            let c = r.getItemOffsetFor(t, "vertical"), u = r.getItemSize(t, "vertical"), d = r.getFixedStartRowsHeight(), f = r.getFixedEndRowsHeight(), p = i.scrollTop, m = r.getAvailableSize();
            if (!m.height) return null;
            let g = p + m.height;
            l || (l = c > g - f ? "end" : c < p + d ? "start" : "end");
            let b = i.scrollTop;
            if (l === "center" ? b = c - Math.floor((r.getAvailableSize().height - d - f) / 2) : l === "start" ? (s = -s, b += c - p + s - d) : (s += u, b += c - g + s + f), this.brain.isHorizontalLayoutBrain) {
                let h = n.colIndex ?? Math.ceil(this.brain.getInitialCols() / 2), y = this.getScrollPositionForScrollColumnIntoView(h, {
                    ...n,
                    horizontalLayoutPageIndex: this.brain.getPageIndexForRow(t)
                });
                y && (a = y.scrollLeft);
            }
            return {
                scrollLeft: a,
                scrollTop: b
            };
        };
        this.getScrollPositionForScrollColumnIntoView = (t, n = {
            offset: 0
        })=>{
            if (this.destroyed) return null;
            let { brain: r } = this, i = r.getScrollPosition(), a = n.horizontalLayoutPageIndex != null ? {
                horizontalLayoutPageIndex: n.horizontalLayoutPageIndex
            } : void 0, { scrollAdjustPosition: l, offset: s = 0 } = n;
            if (this.isColumnFullyVisible(t, void 0, a) && !l) return i;
            a && (t = r.getInitialCols() * a.horizontalLayoutPageIndex + t);
            let c = r.getItemOffsetFor(t, "horizontal"), u = r.getItemSize(t, "horizontal"), d = r.getFixedStartColsWidth(), f = r.getFixedStartColsWidth(), p = i.scrollLeft, m = r.getAvailableSize();
            if (!m.width) return null;
            let g = p + m.width;
            l || (l = c > g - f ? "end" : c < p + d ? "start" : "end");
            let b = i.scrollLeft;
            return l === "center" ? b = c - Math.floor((r.getAvailableSize().width - d - f) / 2) : l === "start" ? (s = -s, b += c - p + s - d) : (s += u, b += c - g + s + f), {
                ...i,
                scrollLeft: b
            };
        };
        this.getScrollPositionForScrollCellIntoView = (t, n, r = {
            offsetLeft: 0,
            offsetTop: 0
        })=>{
            if (this.destroyed) return null;
            let i = this.getScrollPositionForScrollColumnIntoView(n, {
                scrollAdjustPosition: r.colScrollAdjustPosition || r.scrollAdjustPosition,
                offset: r.offsetLeft
            }), a = this.getScrollPositionForScrollRowIntoView(t, {
                scrollAdjustPosition: r.rowScrollAdjustPosition || r.scrollAdjustPosition,
                offset: r.offsetTop
            });
            if (!i || !a) return null;
            let { scrollLeft: l } = i, { scrollTop: s } = a;
            return {
                scrollLeft: l,
                scrollTop: s
            };
        };
        this.isRowFullyVisible = (t, n = 2)=>this.isRowVisible(t, this.brain.getRowHeight(t) - n);
        this.isRowVisible = (t, n = 10)=>{
            if (!this.isRowRendered(t)) return !1;
            t = this.brain.getPageIndexForRow(t) && this.brain.rowsPerPage ? t % this.brain.rowsPerPage : t;
            let { brain: i } = this;
            if (i.isRowFixed(t)) return !0;
            let { start: [a], end: [l] } = this.brain.getRenderRange(), s = Math.floor((a + l) / 2);
            if (t < a || t >= l) return !1;
            if (t >= s) {
                let c = i.getItemAt(i.getAvailableSize().height + i.getScrollPosition().scrollTop - n, "vertical");
                return t <= c;
            }
            if (t < s) {
                let c = i.getItemAt(i.getScrollPosition().scrollTop + n, "vertical");
                return t >= c;
            }
            return !0;
        };
        this.isRowRendered = (t)=>{
            if (!this.brain.isHorizontalLayoutBrain) return this.cellManager.isRowAttached(t);
            let n = t;
            return t = this.brain.rowsPerPage ? t % this.brain.rowsPerPage : t, this.cellManager.getCellsForRow(t).filter((r)=>r.getAdditionalInfo()?.renderRowIndex === n).length > 0;
        };
        this.isCellVisible = (t, n)=>this.isRowVisible(t) && this.isColumnVisible(n);
        this.isCellFullyVisible = (t, n, r)=>this.isRowFullyVisible(t) && this.isColumnVisible(n, void 0, r);
        this.isColumnFullyVisible = (t, n = 2, r)=>this.isColumnVisible(t, this.brain.getColWidth(t) - n, r);
        this.isColumnVisible = (t, n = 10, r)=>{
            if (!this.isColumnRendered(t, r)) return !1;
            let { brain: i } = this;
            if (i.isColFixed(t)) return !0;
            r && r.horizontalLayoutPageIndex != null && (t = i.getVirtualColIndex(t, {
                pageIndex: r.horizontalLayoutPageIndex
            }));
            let { start: [a, l], end: [s, c] } = i.getRenderRange();
            if (t < l || t >= c) return !1;
            let u = Math.floor((l + c) / 2);
            if (t >= u) {
                let d = i.getItemAt(i.getAvailableSize().width + i.getScrollPosition().scrollLeft - n - i.getFixedEndColsWidth(), "horizontal");
                return t <= d;
            }
            if (t < u) {
                let d = i.getItemAt(i.getScrollPosition().scrollLeft + n + i.getFixedStartColsWidth(), "horizontal");
                return t >= d;
            }
            return !0;
        };
        this.isCellRendered = (t, n, r)=>this.isRowRendered(t) && this.isColumnRendered(n, r);
        this.isColumnRendered = (t, n)=>{
            let { start: [r] } = this.brain.getRenderRange();
            return n?.horizontalLayoutPageIndex != null && (t = this.brain.getInitialCols() * n.horizontalLayoutPageIndex + t), this.cellManager.isCellAttachedAt([
                r,
                t
            ]);
        };
        this.getExtraSpanCellsForRange = (t)=>{
            let { start: n, end: r } = t, [i, a] = n, [l, s] = r;
            return this.brain.getExtraSpanCellsForRange({
                horizontal: {
                    startIndex: a,
                    endIndex: s
                },
                vertical: {
                    startIndex: i,
                    endIndex: l
                }
            });
        };
        this.getFixedRanges = (t)=>{
            let { fixedRowsStart: n, fixedRowsEnd: r, fixedColsStart: i, fixedColsEnd: a } = this.brain.getFixedCellInfo();
            if (!n && !i && !r && !a) return [];
            let l = this.brain.getColCount(), s = this.brain.getRowCount(), { start: c, end: u } = t, [d, f] = c, [p, m] = u, g = [];
            if (i && (n && g.push({
                rowFixed: "start",
                colFixed: "start",
                start: [
                    0,
                    0
                ],
                end: [
                    n,
                    i
                ]
            }), r && g.push({
                rowFixed: "end",
                colFixed: "start",
                start: [
                    s - r,
                    0
                ],
                end: [
                    s,
                    i
                ]
            }), g.push({
                rowFixed: !1,
                colFixed: "start",
                start: [
                    d,
                    0
                ],
                end: [
                    p,
                    i
                ]
            })), a && (n && g.push({
                colFixed: "end",
                rowFixed: "start",
                start: [
                    0,
                    l - a
                ],
                end: [
                    n,
                    l
                ]
            }), r && g.push({
                colFixed: "end",
                rowFixed: "end",
                start: [
                    s - r,
                    l - a
                ],
                end: [
                    s,
                    l
                ]
            }), g.push({
                colFixed: "end",
                rowFixed: !1,
                start: [
                    d,
                    l - a
                ],
                end: [
                    p,
                    l
                ]
            })), n) {
                let b = {
                    start: [
                        0,
                        f
                    ],
                    end: [
                        n,
                        m
                    ],
                    rowFixed: "start",
                    colFixed: !1
                };
                g.push(b);
            }
            if (r) {
                let b = {
                    rowFixed: "end",
                    colFixed: !1,
                    start: [
                        s - r,
                        f
                    ],
                    end: [
                        s,
                        m
                    ]
                };
                g.push(b);
            }
            return g;
        };
        this.isCellFixed = (t, n)=>{
            let { fixedRowsStart: r, fixedRowsEnd: i, fixedColsStart: a, fixedColsEnd: l } = this.brain.getFixedCellInfo(), s = this.brain.getColCount(), c = this.brain.getRowCount(), u = !1, d = !1, f = !1;
            if (t < r && (u = !0, f = "start"), i && !u) {
                let p = c - i;
                t >= p && (u = !0, f = "end");
            }
            if (n < a && (d = !0, f = "start"), l && !d) {
                let p = s - l;
                n >= p && (d = !0, f = "end");
            }
            return {
                row: u ? f : !1,
                col: d ? f : !1
            };
        };
        this.isCellCovered = (t, n)=>{
            let r = this.brain.getRowspanParent(t, n), i = this.brain.getColspanParent(t, n), a = r != t, l = i != n;
            return a || l ? [
                r,
                i
            ] : !1;
        };
        this.onMouseEnterNotBound = (t)=>{
            let n = Number(t.target.dataset.rowIndex);
            this.onMouseEnter(n);
        };
        this.onMouseLeaveNotBound = (t)=>{
            let n = Number(t.target.dataset.rowIndex);
            this.onMouseLeave(n);
        };
        this.onMouseEnter = (t)=>{
            this.lastEnteredRow = t, this.lastExitedRow = -1, !this.scrolling && t != -1 && this.addHoverClass(t);
        };
        this.addHoverClass = (t)=>{
            this.cellManager.getCellsForRow(t).forEach((n)=>{
                let r = n.getElement();
                r && this.cellHoverClassNames.forEach((i)=>{
                    r.classList.add(i);
                });
            });
        };
        this.onMouseLeave = (t)=>{
            this.lastExitedRow = t, this.lastEnteredRow = -1, !this.scrolling && t != -1 && this.removeHoverClass(t);
        };
        this.removeHoverClass = (t)=>{
            this.cellManager.getCellsForRow(t).forEach((n)=>{
                let r = n.getElement();
                r && this.cellHoverClassNames.forEach((i)=>{
                    r.classList.remove(i);
                });
            });
        };
        this.updateHoverClassNamesForRow = (t)=>{
            if (this.scrolling || this.hoverRowUpdatesInProgress.has(t)) return;
            this.hoverRowUpdatesInProgress.set(t, !0);
            let n = ()=>{
                !this.scrolling && this.lastEnteredRow != -1 && (this.lastEnteredRow === t ? this.addHoverClass(t) : this.removeHoverClass(t));
            };
            $88ab1a78ec8ca4b4$var$ke(()=>{
                this.destroyed || (n(), this.hoverRowUpdatesInProgress.delete(t));
            });
        };
        this.updateElementPosition = (t, n)=>{
            if (this.destroyed) return;
            let r = t.getElement(), i = this.cellManager.getCellPosition(t);
            if (!i) return;
            let [a, l] = i, s = this.brain.getCellOffset(a, l);
            if (s == null) return;
            let { x: c, y: u } = s;
            if (r) {
                this.updateHoverClassNamesForRow(a);
                let d = this.getCellRealCoordinates(a, l);
                if (r.dataset.rowIndex = d.rowIndex, r.dataset.colIndex = d.colIndex, $88ab1a78ec8ca4b4$var$df) {
                    this.setTransform(r, a, l, {
                        x: c,
                        y: u
                    }, null), r.style.willChange = "transform", r.style.backfaceVisibility = "hidden";
                    let p = (n ? n.hidden : !!this.isCellCovered(a, l)) ? "-1" : r.dataset.zIndex || "auto";
                    r.__zIndex !== p && (r.__zIndex = p, r.style.zIndex = p);
                } else r.style.display = "", r.style.left = `${c}px`, r.style.top = `${u}px`;
            }
        };
        this.updateDetailElementPosition = (t)=>{
            if (this.destroyed) return;
            let n = t.getElement(), r = this.rowManager.getRowIndex(t);
            if (r == null) return;
            let i = this.brain.getItemOffsetFor(r, "vertical");
            if (i == null) return;
            let a = i;
            n && (n.dataset.detailRowIndex = r, $88ab1a78ec8ca4b4$var$df && (this.setDetailTransform(n, r, {
                y: a,
                scrollLeft: this.brain.getScrollPosition().scrollLeft
            }), n.style.willChange = "transform", n.style.backfaceVisibility = "hidden", n.style.zIndex = n.dataset.zIndex || "auto"));
        };
        this.onScrollStart = ()=>{
            this.scrolling = !0, this.lastEnteredRow != -1 && this.removeHoverClass(this.lastEnteredRow);
        };
        this.onScrollStop = ()=>{
            this.scrolling = !1, this.lastEnteredRow != -1 && this.addHoverClass(this.lastEnteredRow), this.lastExitedRow != -1 && this.removeHoverClass(this.lastExitedRow);
        };
        this.adjustFixedElementsOnScroll = (t = this.brain.getScrollPosition())=>{
            let { brain: n, cellManager: r, rowManager: i } = this, a = this.brain.getColCount(), l = this.brain.getRowCount(), { fixedColsStart: s, fixedColsEnd: c, fixedRowsStart: u, fixedRowsEnd: d } = this.brain.getFixedCellInfo();
            if (i.getAttachedCount() && i.forEachAttachedRow((P)=>{
                let _ = i.getRowIndex(P);
                if (_ != null) {
                    let D = this.brain.getItemOffsetFor(_, "vertical");
                    if (D == null) return;
                    let O = P.getElement();
                    if (!O) return;
                    this.setDetailTransform(O, _, {
                        y: D,
                        scrollLeft: t.scrollLeft
                    });
                }
            }), !s && !c && !u && !d) return;
            let f = this.cellManager.getOneAttachedCell();
            f && $88ab1a78ec8ca4b4$var$Cu(t, this.getInfiniteNode(f.getElement()));
            let p = this.brain.getFixedEndColsOffsets({
                skipScroll: !0
            }), m = this.brain.getFixedEndRowsOffsets({
                skipScroll: !0
            }), { start: g, end: b } = this.brain.getRenderRange(), [h, y] = g, [S, C] = b;
            function T(P, _, D) {
                let O = r.getCellAt([
                    P,
                    _
                ]);
                if (O == null) return;
                let F = n.getCellOffset(P, _), W = O.getElement();
                W && F && D(P, _, W, F);
            }
            let I = (P, _, D, { x: O, y: F })=>{
                this.setTransform(D, P, _, {
                    x: O,
                    y: F,
                    scrollLeft: !0
                }, s - _);
            }, w = (P, _, D, O)=>{
                this.setTransform(D, P, _, {
                    x: O.x,
                    y: O.y,
                    scrollTop: !0
                }, u - P);
            }, v = (P, _, D, { y: O })=>{
                let F = p[_];
                this.setTransform(D, P, _, {
                    x: F,
                    y: O,
                    scrollLeft: !0
                }, a - _);
            }, R = (P, _, D, O)=>{
                this.setTransform(D, P, _, {
                    x: O.x,
                    y: m[P],
                    scrollTop: !0
                }, l - P);
            }, x = (P, _, D, { x: O, y: F })=>{
                this.setTransform(D, P, _, {
                    x: O,
                    scrollLeft: !0,
                    y: F,
                    scrollTop: !0
                }, 1e5);
            }, M = (P, _, D, { x: O })=>{
                this.setTransform(D, P, _, {
                    x: O,
                    scrollLeft: !0,
                    y: m[P],
                    scrollTop: !0
                }, 2e5);
            }, A = (P, _, D, O)=>{
                this.setTransform(D, P, _, {
                    x: p[_],
                    y: O.y,
                    scrollLeft: !0,
                    scrollTop: !0
                }, 3e5);
            }, E = (P, _, D)=>{
                this.setTransform(D, P, _, {
                    x: p[_],
                    y: m[P],
                    scrollLeft: !0,
                    scrollTop: !0
                }, 4e5);
            };
            if (s || c) for(let P = h; P < S; P++){
                for(let _ = 0; _ < s; _++)T(P, _, I);
                if (c) {
                    let _ = a - c;
                    for(let D = _; D < a; D++)T(P, D, v);
                }
            }
            if (u || d) for(let P = y; P < C; P++){
                for(let _ = 0; _ < u; _++)T(_, P, w);
                if (d) {
                    let _ = l - d;
                    for(let D = _; D < l; D++)T(D, P, R);
                }
            }
            if (s && u) for(let P = 0; P < u; P++)for(let _ = 0; _ < s; _++)T(P, _, x);
            if (s && d) {
                let P = l - d;
                for(let _ = P; _ < l; _++)for(let D = 0; D < s; D++)T(_, D, M);
            }
            if (c && u) {
                let P = a - c;
                for(let _ = 0; _ < u; _++)for(let D = P; D < a; D++)T(_, D, A);
            }
            if (c && d) {
                let P = l - d, _ = a - c;
                for(let D = P; D < l; D++)for(let O = _; O < a; O++)T(D, O, E);
            }
        };
        this.destroy = ()=>{
            this.destroyed || (this.destroyed = !0, this.reset(), this.onDestroy(), this.hoverRowUpdatesInProgress.clear(), this.hoverRowUpdatesInProgress = null, this.brain = null);
        };
        this.brain = t, this.debugId = n, this.cellManager = new $88ab1a78ec8ca4b4$var$gi(n), this.cellManager.onCellAttachmentChange((s, c)=>{
            c ? this.onCellAttached(s) : this.onCellDetached(s);
        }), this.rowManager = new $88ab1a78ec8ca4b4$var$bi(n), this.rowManager.onRowAttachmentChange((s, c)=>{
            c ? this.onRowAttached(s) : this.onRowDetached(s);
        }), this.renderRange = this.renderRange.bind(this);
        let r = t.onScroll(this.adjustFixedElementsOnScroll), i = t.onAvailableSizeChange(()=>{
            this.adjustFixedElementsOnScroll(), $88ab1a78ec8ca4b4$var$ke(()=>{
                this.destroyed || this.adjustFixedElementsOnScroll();
            });
        }), a = t.onScrollStart(this.onScrollStart), l = t.onScrollStop(this.onScrollStop);
        this.onDestroy = ()=>{
            r(), i(), a(), l();
        };
    }
    getInfiniteNode(t) {
        return this.infiniteNode || (this.infiniteNode = $88ab1a78ec8ca4b4$var$nl(t)), this.infiniteNode;
    }
    onCellAttached(t) {
        if (this.cellDetachedClassNames.length) {
            let n = t.getElement();
            n && this.cellDetachedClassNames.forEach((r)=>{
                n.classList.remove(r);
            });
        }
    }
    onCellDetached(t) {
        if (this.cellDetachedClassNames.length) {
            let n = t.getElement();
            n && this.cellDetachedClassNames.forEach((r)=>{
                n.classList.add(r);
            });
        }
    }
    onRowAttached(t) {
        if (this.cellDetachedClassNames.length) {
            let n = t.getElement();
            n && this.cellDetachedClassNames.forEach((r)=>{
                n.classList.remove(r);
            });
        }
    }
    onRowDetached(t) {
        if (this.cellDetachedClassNames.length) {
            let n = t.getElement();
            n && this.cellDetachedClassNames.forEach((r)=>{
                n.classList.add(r);
            });
        }
    }
    isCellRenderedAndMappedCorrectly(t, n) {
        let r = !!this.cellManager.getCellAt([
            t,
            n
        ]);
        return {
            rendered: r,
            mapped: r
        };
    }
    renderRange(t, { renderCell: n, renderDetailRow: r, force: i, onRender: a }) {
        if (this.destroyed) return [];
        let { start: l, end: s } = t, c = this.brain.isHorizontalLayoutBrain, { rowManager: u, cellManager: d } = this, f = this.getFixedRanges(t), p = [
            t,
            ...f
        ], m = this.brain.getAlwaysRenderedColumns();
        if (m.length > 0) {
            let x = t.start[1], M = t.end[1];
            m.forEach((A)=>{
                x <= A && A < M || p.push({
                    start: [
                        t.start[0],
                        A
                    ],
                    end: [
                        t.end[0],
                        A + 1
                    ]
                });
            });
        }
        let g = new Map, b = p.map(this.getExtraSpanCellsForRange).flat();
        b && b.forEach(([x, M])=>{
            g.set(`${x}:${M}`, !0);
        });
        let h = p.reduce((x, M)=>x + $88ab1a78ec8ca4b4$var$_l(M), 0), y = r ? p.reduce((x, M)=>x + $88ab1a78ec8ca4b4$var$nf(M), 0) : 0, S = this.brain.getRowCount(), C = this.brain.getColCount();
        d.detachCellsStartingAt([
            S,
            C
        ]);
        let T = Math.min(S * C, h);
        r && (u.detachStartingWith(this.brain.getRowCount()), u.poolSize > y && (u.poolSize = y));
        let I = $88ab1a78ec8ca4b4$var$of(...p.map((x)=>d.getCellsOutsideRenderRange(x)));
        I = $88ab1a78ec8ca4b4$var$rf(I, (x)=>{
            let M = d.getCellPosition(x);
            return !(M && g.has(`${M[0]}:${M[1]}`));
        }), d.detachCells(I), d.poolSize = T;
        let w = new Map, v = new Map;
        p.forEach((x)=>{
            let { start: M, end: A } = x, [E, P] = M, [_, D] = A;
            for(let O = E; O < _; O++){
                for(let W = P; W < D; W++){
                    let z = `${O}:${W}`;
                    if (w.has(z)) continue;
                    w.set(z, !0);
                    let { rendered: L, mapped: ae } = this.isCellRenderedAndMappedCorrectly(O, W);
                    if (O === E || W === P) {
                        let B = this.isCellCovered(O, W);
                        if (B && g.has(`${B[0]}:${B[1]}`)) {
                            let j = d.getCellAt([
                                O,
                                W
                            ]);
                            j != null && d.detachCell(j);
                            continue;
                        }
                    }
                    if (L && !i && ae) continue;
                    let te;
                    L ? te = d.getCellAt([
                        O,
                        W
                    ]) : te = d.getCellFor([
                        O,
                        W
                    ], c ? "row" : "column"), te == null && (te = d.getDetachedCell()), this.renderCellAt(O, W, te, n);
                }
                !r || v.has(O) || (v.set(O, !0), u.isRowAttachedAt(O) && !i) || this.renderDetailRowAtElement(O, this.rowManager.getRowFor(O), r);
            }
        }), b.forEach(([x, M])=>{
            let { rendered: A, mapped: E } = this.isCellRenderedAndMappedCorrectly(x, M);
            if (A) {
                if (i || !E) {
                    let _ = [
                        x,
                        M
                    ], D = d.getCellAt(_);
                    this.renderCellAt(x, M, D, n);
                }
                return;
            }
            let P = d.getCellFor([
                x,
                M
            ], c ? "row" : "column");
            P != null && this.renderCellAt(x, M, P, n);
        });
        let R = d.getAllCells().map((x)=>x.getNode());
        return r && u.getAllRows().forEach((x)=>{
            R.push(x.getNode());
        }), this.adjustFixedElementsOnScroll(), a && a(R), R;
    }
    renderDetailRowAtElement(t, n, r) {
        if (this.destroyed) return;
        let i = !1, a = this.brain.getRowHeight(t), l = this.brain.isRowFixedStart(t) ? "start" : this.brain.isRowFixedEnd(t) ? "end" : !1, c = r({
            rowIndex: t,
            height: a,
            rowFixed: l,
            hidden: !!i,
            onMouseEnter: ()=>{},
            onMouseLeave: ()=>{},
            domRef: n.ref
        });
        if (n.isMounted() || n.onMount((u)=>{
            let d = u.getElement();
            d && (d.style.position = "absolute", d.style.left = "0px"), this.updateDetailElementPosition(u);
        }), !c) {
            this.rowManager.detachRow(n);
            return;
        }
        this.rowManager.renderNodeAtRow(c, n, t), this.updateDetailElementPosition(n);
    }
    getCellRealCoordinates(t, n) {
        return {
            rowIndex: t,
            colIndex: n
        };
    }
    renderCellAt(t, n, r, i) {
        if (this.destroyed) return;
        let a = this.isCellCovered(t, n), l = this.brain.getRowHeight(t), s = this.brain.getColWidth(n), c = this.brain.getRowspan(t, n), u = this.brain.getColspan(t, n), d = c === 1 ? l : this.brain.getRowHeightWithSpan(t, n, c), f = u === 1 ? s : this.brain.getColWidthWithSpan(t, n, u), { row: p, col: m } = this.isCellFixed(t, n), g = !!a, { rowIndex: b, colIndex: h } = this.getCellRealCoordinates(t, n), y = i({
            rowIndex: b,
            colIndex: h,
            height: l,
            width: s,
            rowspan: c,
            colspan: u,
            rowFixed: p,
            colFixed: m,
            hidden: g,
            heightWithRowspan: d,
            widthWithColspan: f,
            onMouseEnter: this.onMouseEnterNotBound,
            onMouseLeave: this.onMouseLeaveNotBound,
            domRef: r.ref
        });
        r.isMounted() || r.onMount((T)=>{
            let I = T.getElement();
            I && (I.style.position = "absolute", I.style.left = "0px", I.style.top = "0px"), this.updateElementPosition(T);
        });
        let S = this.brain.isHorizontalLayoutBrain ? {
            renderRowIndex: b,
            renderColIndex: h
        } : void 0, C = this.brain.isHorizontalLayoutBrain;
        if (!y) {
            C ? this.cellManager.detachCell(r) : this.cellManager.detachCell(r);
            return;
        }
        $88ab1a78ec8ca4b4$var$Ll.scrolling = this.scrolling, $88ab1a78ec8ca4b4$var$Ll.isHorizontalLayout = C, this.cellManager.renderNodeAtCell(y, r, [
            t,
            n
        ], S, $88ab1a78ec8ca4b4$var$Ll), this.updateElementPosition(r, {
            hidden: g,
            rowspan: c,
            colspan: u
        });
    }
    reset() {
        this.cellManager.reset(), this.rowManager.reset();
    }
};
var $88ab1a78ec8ca4b4$var$yi = class extends $88ab1a78ec8ca4b4$var$mo {
    constructor(t, n){
        super(t, n);
        this.setTransform = (t, n, r, i, a)=>{
            let l = this.getCellRealCoordinates(n, r), { y: s } = i, c = Math.floor(l.rowIndex / this.brain.rowsPerPage), u = $88ab1a78ec8ca4b4$var$se.runtime.totalVisibleColumnsWidthVar, d = c ? `calc(${u} * ${c})` : "0px", f = $88ab1a78ec8ca4b4$var$Ce.columnOffsets.get(l.colIndex), p = `${$88ab1a78ec8ca4b4$var$kl}-${l.colIndex}`, m = `${s}px`;
            t.__currentTransformY !== m && (t.__currentTransformY = m, t.style.setProperty($88ab1a78ec8ca4b4$var$Vn, m));
            let g = `calc(var(${p}, ${f}) + ${d})`, b = `var(${$88ab1a78ec8ca4b4$var$Vn})`, h = `translate3d(${g}, ${b}, 0px)`;
            t.__transformValue !== h && (t.__transformValue = h, t.style.transform = h);
        };
        this.brain = t;
    }
    getCellRealCoordinates(t, n) {
        return this.brain.getHorizontalLayoutPositionFromMatrixCoordinates({
            rowIndex: t,
            colIndex: n
        });
    }
    isCellRenderedAndMappedCorrectly(t, n) {
        let r = this.cellManager.getCellAt([
            t,
            n
        ]), i = !!r;
        if (!i) return {
            rendered: i,
            mapped: !1
        };
        let a = r.getAdditionalInfo();
        if (!a) return {
            rendered: i,
            mapped: !1
        };
        let l = this.getCellRealCoordinates(t, n), s = l.colIndex === a.renderColIndex && l.rowIndex === a.renderRowIndex;
        return {
            rendered: i,
            mapped: s
        };
    }
};
function $88ab1a78ec8ca4b4$var$or(o) {
    let e = o.isHorizontalLayoutBrain ? new $88ab1a78ec8ca4b4$var$yi(o, `${o.name}:HorizontalLayoutTableRenderer`) : new $88ab1a78ec8ca4b4$var$mo(o, `${o.name}:ReactHeadlessTableRenderer`), t = $88ab1a78ec8ca4b4$var$ye();
    return o.onDestroy(()=>{
        e.destroy(), t.destroy();
    }), {
        renderer: e,
        onRenderUpdater: t
    };
}
function $88ab1a78ec8ca4b4$var$jy(o) {
    let { brain: e, renderCell: t, renderDetailRow: n, forceRerenderTimestamp: r } = o, { renderer: i, onRenderUpdater: a } = (0, $acw62.useMemo)(()=>o.onRenderUpdater && o.renderer ? {
            renderer: o.renderer,
            onRenderUpdater: o.onRenderUpdater
        } : $88ab1a78ec8ca4b4$var$or(e), [
        e,
        o.onRenderUpdater,
        o.renderer
    ]);
    return (0, $acw62.useLayoutEffect)(()=>{
        i.cellHoverClassNames = o.cellHoverClassNames || [];
    }, [
        i,
        o.cellHoverClassNames
    ]), (0, $acw62.useLayoutEffect)(()=>{
        i.cellDetachedClassNames = o.cellDetachedClassNames || [];
    }, [
        i,
        o.cellDetachedClassNames
    ]), (0, $acw62.useLayoutEffect)(()=>{
        let l = e.getRenderRange();
        return i.renderRange(l, {
            onRender: a,
            force: !0,
            renderCell: t,
            renderDetailRow: n
        }), e.onRenderRangeChange((c)=>{
            i.renderRange(c, {
                force: !1,
                onRender: (u)=>{
                    let d = a.get();
                    d && u && d.length === u.length || a(u);
                },
                renderCell: t,
                renderDetailRow: n
            });
        });
    }, [
        i,
        e,
        t,
        n,
        a,
        r
    ]), $acw62.createElement($88ab1a78ec8ca4b4$var$mn, {
        updater: a
    });
}
var $88ab1a78ec8ca4b4$var$Si = $acw62.memo($88ab1a78ec8ca4b4$var$jy);
var $88ab1a78ec8ca4b4$var$pf = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "nxbq1c1 _16lm1iwz _16lm1iw2",
    variantClassNames: {
        visible: {
            true: "nxbq1c3",
            false: "nxbq1c4"
        }
    },
    defaultVariants: {},
    compoundVariants: []
}), $88ab1a78ec8ca4b4$var$Ci = "nxbq1c0 _16lm1iwz _16lm1iw4 _16lm1iw26 _16lm1iw23 _16lm1iw1y _16lm1iw1k";
var $88ab1a78ec8ca4b4$var$mf = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "j26lrx0 _16lm1iwz _16lm1iw2 _16lm1iw23 _16lm1iw26",
    variantClassNames: {
        active: {
            true: "j26lrx2",
            false: "j26lrx3"
        }
    },
    defaultVariants: {},
    compoundVariants: []
});
var { rootClassName: $88ab1a78ec8ca4b4$var$qy } = $88ab1a78ec8ca4b4$var$Fe, $88ab1a78ec8ca4b4$var$Xy = `${$88ab1a78ec8ca4b4$var$qy}-ActiveRowIndicator`, $88ab1a78ec8ca4b4$var$Zy = `calc(${$88ab1a78ec8ca4b4$var$U.activeCellRowOffsetX} + var(${$88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.scrollLeftForActiveRowWhenHorizontalLayout)}, 0px))`, $88ab1a78ec8ca4b4$var$Qy = {
    [$88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.activeCellOffsetY)]: $88ab1a78ec8ca4b4$var$U.activeCellRowOffset,
    transform: `translate3d(${$88ab1a78ec8ca4b4$var$Zy}, calc( ${$88ab1a78ec8ca4b4$var$U.activeCellOffsetY} + var(${$88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.scrollTopForActiveRow)}, 0px)), 0px)`,
    height: $88ab1a78ec8ca4b4$var$U.activeCellRowHeight,
    maxWidth: $88ab1a78ec8ca4b4$var$se.runtime.totalVisibleColumnsWidthVar
}, $88ab1a78ec8ca4b4$var$Jy = (o)=>{
    let { brain: e } = o, t = (0, $acw62.useRef)(null), n = o.activeRowIndex != null && e.getInitialRows() > o.activeRowIndex, [r, i] = $88ab1a78ec8ca4b4$var$Ct();
    return (0, $acw62.useLayoutEffect)(()=>{
        if (o.activeRowIndex == null) return;
        let a = "0px", l = o.activeRowIndex;
        if (e.isHorizontalLayoutBrain && e.rowsPerPage) {
            let f = e.getPageIndexForRow(l);
            f > 0 && (a = `calc(${$88ab1a78ec8ca4b4$var$se.runtime.totalVisibleColumnsWidthVar} * ${f})`), l = l % e.rowsPerPage;
        }
        let s = e.getRowHeight(l), c = e.getItemOffsetFor(l, "vertical"), u = t.current, d = {
            activeCellRowHeight: `${s}px`,
            activeCellRowOffset: `${c}px`,
            activeCellRowOffsetX: a
        };
        $88ab1a78ec8ca4b4$var$oo(d, u);
    }, [
        o.activeRowIndex,
        e
    ]), (0, $acw62.useEffect)(()=>{
        let a = (c)=>{
            $88ab1a78ec8ca4b4$var$oo({
                scrollTopForActiveRow: `${-c.scrollTop}px`,
                scrollLeftForActiveRowWhenHorizontalLayout: e.isHorizontalLayoutBrain ? `${-c.scrollLeft}px` : "0px"
            }, t.current);
        };
        a(e.getScrollPosition());
        let l = e.onScroll(a), s = e.onRenderCountChange(i);
        return ()=>{
            s(), l();
        };
    }, [
        e
    ]), $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$Ci,
        "data-name": "active-row"
    }, $acw62.createElement("div", {
        ref: t,
        "data-name": "active-row-indicator",
        className: `${$88ab1a78ec8ca4b4$var$Xy} ${$88ab1a78ec8ca4b4$var$mf({
            active: n
        })}`,
        style: n ? $88ab1a78ec8ca4b4$var$Qy : void 0
    }));
}, $88ab1a78ec8ca4b4$var$gf = $acw62.memo($88ab1a78ec8ca4b4$var$Jy);
var { rootClassName: $88ab1a78ec8ca4b4$var$oT } = $88ab1a78ec8ca4b4$var$Fe, $88ab1a78ec8ca4b4$var$rT = `${$88ab1a78ec8ca4b4$var$oT}-ActiveCellIndicator`, $88ab1a78ec8ca4b4$var$iT = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnZIndexAtIndex), $88ab1a78ec8ca4b4$var$aT = (o, e, t, n)=>{
    if (e == null) return;
    let [r] = e;
    o.isHorizontalLayoutBrain && o.rowsPerPage && (r = r % o.rowsPerPage);
    let i = typeof t == "function" ? t(r) : t ?? o.getRowHeight(r), a = o.getItemOffsetFor(r, "vertical"), l = n.current;
    $88ab1a78ec8ca4b4$var$oo({
        activeCellRowHeight: `${i}px`,
        activeCellRowOffset: `${a}px`
    }, l);
}, $88ab1a78ec8ca4b4$var$lT = (o)=>{
    let { brain: e } = o, [t, n] = $88ab1a78ec8ca4b4$var$Ct(), r = (0, $acw62.useRef)(null), i = o.activeCellIndex != null && e.getInitialRows() > o.activeCellIndex[0];
    return (0, $acw62.useLayoutEffect)(()=>{
        $88ab1a78ec8ca4b4$var$aT(e, o.activeCellIndex, o.rowHeight, r);
    }, [
        o.activeCellIndex,
        o.rowHeight,
        e
    ]), (0, $acw62.useEffect)(()=>{
        let a = e.onRenderCountChange(()=>{
            n();
        });
        return ()=>{
            a();
        };
    }, [
        e
    ]), $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$Ci,
        ref: r,
        "data-name": "active-cell",
        style: i ? {
            zIndex: `var(${$88ab1a78ec8ca4b4$var$iT}-${o.activeCellIndex[1]})`
        } : void 0
    }, $acw62.createElement("div", {
        "data-name": "active-cell-indicator",
        className: `${$88ab1a78ec8ca4b4$var$rT} ${$88ab1a78ec8ca4b4$var$pf({
            visible: i
        })}`
    }));
}, $88ab1a78ec8ca4b4$var$hf = $acw62.memo($88ab1a78ec8ca4b4$var$lT);
var $88ab1a78ec8ca4b4$var$wi = [
    $88ab1a78ec8ca4b4$var$md,
    `${$88ab1a78ec8ca4b4$var$rt}DetachedCell`
];
function $88ab1a78ec8ca4b4$var$Ii(o, e, t) {
    t && (t.fixedColsStart || t.fixedColsEnd || t.fixedRowsStart || t.fixedRowsEnd) && o.updateFixedCells({
        fixedColsStart: t.fixedColsStart,
        fixedColsEnd: t.fixedColsEnd,
        fixedRowsStart: t.fixedRowsStart,
        fixedRowsEnd: t.fixedRowsEnd
    }), o.update({
        height: e.height,
        width: e.width,
        cols: e.cols,
        rows: e.rows,
        colWidth: e.colWidth,
        rowHeight: e.rowHeight,
        rowspan: e.rowspan,
        colspan: e.colspan
    });
}
var $88ab1a78ec8ca4b4$var$uT = $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$jd, $88ab1a78ec8ca4b4$var$Dl);
function $88ab1a78ec8ca4b4$var$yf(o) {
    let { brain: e, scrollerDOMRef: t, scrollStopDelay: n, renderCell: r, renderDetailRow: i, activeCellRowHeight: a, cellHoverClassNames: l, renderer: s, activeRowIndex: c, activeCellIndex: u, onRenderUpdater: d, wrapRowsHorizontally: f, forceRerenderTimestamp: p, scrollVarHostRef: m, ...g } = o, { autoFocus: b } = g, h = (0, $acw62.useRef)(null), [y, S] = (0, $acw62.useState)({
        width: 0,
        height: 0
    });
    (0, $acw62.useEffect)(()=>{
        n != null && e.setScrollStopDelay(n);
    }, [
        n,
        e
    ]), (0, $acw62.useEffect)(()=>{
        let I = h.current?.parentNode;
        return I ? (b && document.activeElement !== I && I.focus(), $88ab1a78ec8ca4b4$var$zo(I, ()=>{
            let R = {
                height: I.clientHeight,
                width: I.clientWidth
            };
            e.update(R);
        }, {
            debounce: 50
        })) : void 0;
    }, [
        f,
        e
    ]);
    let C = (0, $acw62.useCallback)((I)=>{
        requestAnimationFrame(()=>{
            h.current && h.current.style.setProperty("transform", `translate3d(${-I.scrollLeft}px, ${-I.scrollTop}px, 0px)`);
        });
    }, []), T = (0, $acw62.useCallback)((I)=>{
        e.setScrollPosition(I, C);
    }, [
        e,
        C
    ]);
    return (0, $acw62.useEffect)(()=>{
        let I = e.onRenderCountChange(()=>{
            S(e.getVirtualizedContentSize());
        });
        return S(e.getVirtualizedContentSize()), C(e.getScrollPosition() || {
            scrollLeft: 0,
            scrollTop: 0
        }), I;
    }, [
        e
    ]), $acw62.createElement($88ab1a78ec8ca4b4$var$Qd, {
        onContainerScroll: T,
        ...g,
        ref: t
    }, $acw62.createElement("div", {
        ref: h,
        className: $88ab1a78ec8ca4b4$var$uT,
        "data-name": "scroll-transform-target"
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$Si, {
        forceRerenderTimestamp: p,
        renderer: s,
        onRenderUpdater: d,
        renderCell: r,
        renderDetailRow: i,
        brain: e,
        cellHoverClassNames: l,
        cellDetachedClassNames: $88ab1a78ec8ca4b4$var$wi
    }), u != null ? $acw62.createElement($88ab1a78ec8ca4b4$var$hf, {
        brain: e,
        rowHeight: a,
        activeCellIndex: u
    }) : null), c != null ? $acw62.createElement($88ab1a78ec8ca4b4$var$gf, {
        brain: e,
        activeRowIndex: c
    }) : null, $acw62.createElement($88ab1a78ec8ca4b4$var$Wd, {
        width: y.width,
        height: y.height
    }));
}
function $88ab1a78ec8ca4b4$var$Tf(o, e, t, n) {
    let r = new Map, i = new Map, a = new Map;
    o.forEach((u, d)=>{
        let f = u.id, p = o[d - 1], m = p?.id ?? "", g = new Set, b = p?.computedPinned !== u.computedPinned ? new Set : a.get(m) ?? new Set;
        a.set(f, g);
        let h = {
            type: "column",
            id: f,
            ref: u,
            groupOffset: 0,
            computedPinned: u.computedPinned,
            computedWidth: u.computedWidth,
            depth: u.columnGroup ? (t.get(u.columnGroup) ?? 0) + 1 : 0
        };
        r.set([
            f
        ], h);
        let y = u.columnGroup, S, C = h;
        for(; y;){
            let T = e[y];
            if (T) {
                g.add(y);
                let I = [
                    f,
                    ...g
                ];
                S = b.has(y) ? i.get(y) : void 0, S || (S = {
                    id: y,
                    type: "group",
                    ref: T,
                    columnItems: [],
                    children: [],
                    groupOffset: 0,
                    uniqueGroupId: [
                        y
                    ],
                    computedWidth: 0,
                    computedPinned: h.computedPinned,
                    depth: t.get(y) ?? 0
                }, r.set(I, S), i.set(y, S)), S.columnItems.push(h), S.uniqueGroupId.push(h.id), C && !b.has(C.id) && S.children.push(C), C = S, y = T.columnGroup;
            } else break;
        }
    });
    let l = [], s = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00, c = 0;
    return r.forEach((u)=>{
        if (!u.ref.columnGroup) {
            let d = u.type === "column" ? u.ref.computedWidth : u.columnItems.reduce((f, p)=>f + p.ref.computedWidth, 0);
            u.groupOffset = c, u.computedWidth = d, u.type === "group" && $88ab1a78ec8ca4b4$var$Sf(u.children), l.push(u), c += d;
        }
        if (u.type === "group") u.columnItems.forEach((d)=>{
            s.set([
                u.depth,
                d.ref.computedVisibleIndex
            ], u);
        });
        else for(let d = u.depth; d <= n + 1; d++)s.set([
            d,
            u.ref.computedVisibleIndex
        ], u);
    }), r.clear(), i.clear(), {
        tree: l,
        pathsToCells: s
    };
}
function $88ab1a78ec8ca4b4$var$Sf(o, e = 0) {
    o.forEach((t)=>{
        let n = t.type === "column" ? t.ref.computedWidth : t.columnItems.reduce((r, i)=>r + i.ref.computedWidth, 0);
        t.computedWidth = n, t.groupOffset = e, t.type === "group" && $88ab1a78ec8ca4b4$var$Sf(t.children), e += n;
    });
}
var { rootClassName: $88ab1a78ec8ca4b4$var$fT } = $88ab1a78ec8ca4b4$var$Fe, $88ab1a78ec8ca4b4$var$pT = `${$88ab1a78ec8ca4b4$var$fT}HeaderCell_ResizeHandle`;
function $88ab1a78ec8ca4b4$var$mT(o) {
    let e = (0, $acw62.useRef)(null), [t, n] = (0, $acw62.useState)(!1), r = (0, $acw62.useRef)(t);
    r.current = t;
    let i = o.groupColumns[0];
    if (!i) return null;
    let a = i.computedPinned, l = i.computedFirstInCategory, s = i.computedLastInCategory, c = (d)=>{
        d.stopPropagation();
        let f = d.pointerId, p = d.clientX, m = d.target;
        m.setPointerCapture(f);
        let g = !0, b = $88ab1a78ec8ca4b4$var$Md(o.groupColumns.map((C)=>C.computedVisibleIndex), {
            columns: o.columns,
            domRef: e
        }), h = (C)=>{
            a === "end" && (C *= -1);
            let { constrained: T, adjustedDiffs: I, adjustedDiff: w } = o.computeResize(C);
            return r.current !== T && n(T), b.resize(I), w;
        }, y = (C)=>{
            if (g) {
                let T = o.groupColumns.reduce((v, R)=>v + R.computedWidth - R.computedMinWidth, 0), I = o.brain.getAvailableSize(), w = {
                    width: I.width + T,
                    height: I.height
                };
                o.brain.update(w), g = !1;
            }
            h(Math.round(C.clientX - p));
        }, S = (C)=>{
            m.releasePointerCapture(f), m.removeEventListener("pointermove", y), m.removeEventListener("pointerup", S);
            let T = Math.round(C.clientX - p), I = h(T);
            o.onResize(I);
        };
        m.addEventListener("pointermove", y), m.addEventListener("pointerup", S);
    }, u = (a === !1 || a === "start") && s ? {
        right: a === "start" ? void 0 : $88ab1a78ec8ca4b4$var$se.components.HeaderCell.resizeHandleWidth
    } : a === "end" && l ? {
        right: void 0
    } : void 0;
    return $acw62.createElement("div", {
        ref: e,
        className: `${$88ab1a78ec8ca4b4$var$pT} ${$88ab1a78ec8ca4b4$var$ri} ${$88ab1a78ec8ca4b4$var$ai({
            computedPinned: a,
            computedFirstInCategory: l,
            computedLastInCategory: s
        })}`,
        onPointerDown: c
    }, $acw62.createElement("div", {
        style: {
            ...u,
            ...o.style
        },
        className: $88ab1a78ec8ca4b4$var$ii({
            constrained: t
        })
    }));
}
var $88ab1a78ec8ca4b4$var$wf = $acw62.memo($88ab1a78ec8ca4b4$var$mT);
function $88ab1a78ec8ca4b4$var$Rf(o, e) {
    let { bodyBrain: t, groupHeight: n, columnGroup: r, columnGroupsMaxDepth: i } = e, { computed: { computedVisibleColumns: a }, getState: l, getComputed: s, actions: c } = $88ab1a78ec8ca4b4$var$Q(), u = o[o.length - 1], d = (0, $acw62.useCallback)((g)=>{
        let b = l(), { columnSizing: h, viewportReservedWidth: y, bodySize: S } = b, C = s().computedVisibleColumns, T = !1, I = C.reduce((R, x)=>(x.computedFlex && (R[x.id] = {
                ...h[x.id],
                flex: x.computedWidth
            }, T = !0), R), {}), w = T ? {
            ...h,
            ...I
        } : h;
        return $88ab1a78ec8ca4b4$var$ou({
            availableSize: S.width,
            reservedWidth: y || 0,
            dragHandleOffset: g,
            dragHandlePositionAfter: u.computedVisibleIndex,
            columnSizing: w,
            columnGroupSize: o.length,
            items: C.map((R)=>({
                    id: R.id,
                    resizable: R.computedResizable,
                    computedFlex: R.computedFlex,
                    computedWidth: R.computedWidth,
                    computedMinWidth: R.computedMinWidth,
                    computedMaxWidth: R.computedMaxWidth
                }))
        });
    }, [
        u
    ]), f = (0, $acw62.useCallback)((g)=>{
        let { columnSizing: b, reservedWidth: h } = d(g);
        c.viewportReservedWidth = h, c.columnSizing = b;
    }, [
        d
    ]);
    return o.some((g)=>g.computedResizable) ? $acw62.createElement($88ab1a78ec8ca4b4$var$wf, {
        brain: t,
        style: {
            height: n * (i - r.depth + 2)
        },
        columns: a,
        groupColumns: o,
        computeResize: d,
        onResize: f
    }) : null;
}
var $88ab1a78ec8ca4b4$var$xf = `${$88ab1a78ec8ca4b4$var$rt}HeaderGroup`, $88ab1a78ec8ca4b4$var$Pf = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnWidthAtIndex), $88ab1a78ec8ca4b4$var$gT = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnZIndexAtIndex);
function $88ab1a78ec8ca4b4$var$Df(o) {
    let { columnGroup: e, height: t, columns: n, bodyBrain: r, columnGroupsMaxDepth: i } = o, { header: a, style: l } = e;
    a instanceof Function && (a = a({
        columnGroup: e,
        horizontalLayoutPageIndex: o.horizontalLayoutPageIndex
    }));
    let s = $88ab1a78ec8ca4b4$var$Rf(n, {
        bodyBrain: r,
        groupHeight: t,
        columnGroup: e,
        columnGroupsMaxDepth: i
    }), c = n[0], u = n.length > 1 ? "calc( " + n.map((p)=>`var(${$88ab1a78ec8ca4b4$var$Pf}-${p.computedVisibleIndex})`).join(" + ") + " )" : `var(${$88ab1a78ec8ca4b4$var$Pf}-${c.computedVisibleIndex})`, d = `calc(var(${$88ab1a78ec8ca4b4$var$gT}-${c.computedVisibleIndex}) + ${i - e.depth})`, f = typeof l == "function" ? l({
        columnGroup: e,
        horizontalLayoutPageIndex: o.horizontalLayoutPageIndex
    }) : l;
    return f = f && typeof f == "object" ? f : {}, f.width = u, f.height = t, $acw62.createElement("div", {
        ref: o.domRef,
        "data-group-id": e.uniqueGroupId,
        className: $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$Uc, $88ab1a78ec8ca4b4$var$xf),
        style: f,
        "data-z-index": d
    }, $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$X(`${$88ab1a78ec8ca4b4$var$xf}__header-content`, $88ab1a78ec8ca4b4$var$Lt)
    }, a), s);
}
var { rootClassName: $88ab1a78ec8ca4b4$var$yT } = $88ab1a78ec8ca4b4$var$Fe, $88ab1a78ec8ca4b4$var$TT = [], $88ab1a78ec8ca4b4$var$Ef = `${$88ab1a78ec8ca4b4$var$yT}Header`, $88ab1a78ec8ca4b4$var$ST = $88ab1a78ec8ca4b4$var$Kc({
    overflow: !1
}), $88ab1a78ec8ca4b4$var$Af = ()=>{};
function $88ab1a78ec8ca4b4$var$CT(o) {
    let { bodyBrain: e, columns: t, style: n, className: r, columnHeaderHeight: i, columnAndGroupTreeInfo: a, columnGroupsMaxDepth: l } = o, { computed: s, getState: c, state: { headerBrain: u, headerOptions: d, showColumnFilters: f, headerRenderer: p, headerOnRenderUpdater: m } } = $88ab1a78ec8ca4b4$var$Q(), { computedColumnsMap: g } = s, b = (0, $acw62.useRef)(null), h = (0, $acw62.useCallback)((C)=>{
        b.current && (b.current.style.transform = `translate3d(-${C.scrollLeft}px, 0px, 0px)`);
    }, []);
    (0, $acw62.useEffect)(()=>{
        let C = u.onScroll(h);
        return h(u.getScrollPosition() || {
            scrollLeft: 0,
            scrollTop: 0
        }), C;
    }, [
        u
    ]);
    let y = {
        ref: b,
        className: $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$Ef, `${$88ab1a78ec8ca4b4$var$Ef}--virtualized`, r, $88ab1a78ec8ca4b4$var$ST),
        style: {
            ...n,
            height: i
        }
    }, S = (0, $acw62.useCallback)((C)=>{
        let { rowIndex: T, colIndex: I, domRef: w, height: v, widthWithColspan: R, heightWithRowspan: x, hidden: M } = C, A = t[I];
        if (!A || M) return null;
        let E = u.isHorizontalLayoutBrain ? u.getPageIndexForRow(T) : null, P = a ? a.pathsToCells.get([
            T,
            I
        ]) : null;
        if (P && P.type === "group") {
            let _ = P.columnItems.map((F)=>F.ref), D = {
                ...P.ref,
                id: P.id,
                uniqueGroupId: P.uniqueGroupId,
                depth: P.depth,
                columns: _.map((F)=>F.id),
                computedWidth: P.computedWidth,
                groupOffset: P.groupOffset
            };
            return c().columnGroupVisibility[P.id] !== !1 ? $acw62.createElement($88ab1a78ec8ca4b4$var$Df, {
                horizontalLayoutPageIndex: E,
                bodyBrain: e,
                columnGroupsMaxDepth: l,
                domRef: w,
                columns: _,
                width: R,
                height: v,
                columnGroup: D
            }) : null;
        }
        return $acw62.createElement($88ab1a78ec8ca4b4$var$Of, {
            domRef: w,
            column: A,
            horizontalLayoutPageIndex: E,
            headerOptions: d,
            width: R,
            height: x,
            columnsMap: g
        });
    }, [
        d,
        t,
        i,
        a,
        l,
        f,
        u
    ]);
    return $acw62.createElement($88ab1a78ec8ca4b4$var$kn, {
        orientation: "horizontal",
        dragListId: "header",
        onDrop: $88ab1a78ec8ca4b4$var$Af,
        updatePosition: $88ab1a78ec8ca4b4$var$Af
    }, (C)=>$acw62.createElement("div", {
            ...C,
            ...y,
            className: $88ab1a78ec8ca4b4$var$X(C.className, y.className)
        }, $acw62.createElement($88ab1a78ec8ca4b4$var$Si, {
            name: "header",
            renderCell: S,
            brain: u,
            renderer: p,
            onRenderUpdater: m,
            cellHoverClassNames: $88ab1a78ec8ca4b4$var$TT,
            cellDetachedClassNames: $88ab1a78ec8ca4b4$var$wi
        })));
}
var $88ab1a78ec8ca4b4$var$_f = $acw62.memo($88ab1a78ec8ca4b4$var$CT);
function $88ab1a78ec8ca4b4$var$Nf(o) {
    let { headerBrain: e, bodyBrain: t, scrollbars: n } = o, r = $88ab1a78ec8ca4b4$var$Q(), { computedPinnedStartColumns: i, computedPinnedEndColumns: a, computedVisibleColumns: l, columnSize: s } = r.computed, { state: { columnHeaderHeight: c, columnGroupsDepthsMap: u, columnGroupsMaxDepth: d, computedColumnGroups: f, showColumnFilters: p } } = r, m = !f || !Object.keys(f).length ? 1 : d + 2, g = m * c + (p ? c : 0), b = $acw62.useMemo(()=>{
        if (!(!f || !Object.keys(f).length)) return $88ab1a78ec8ca4b4$var$Tf(l, f, u, d);
    }, [
        l,
        f,
        u
    ]), h = $acw62.useCallback(({ rowIndex: w, colIndex: v })=>{
        let R = l[v], x = 1, M = 1;
        if (!R || !b) return {
            rowspan: x,
            colspan: M
        };
        let A = b.pathsToCells.get([
            w,
            v
        ]);
        if (!A) return {
            rowspan: x,
            colspan: M
        };
        if (A.type === "column") return {
            colspan: M,
            rowspan: m - A.depth
        };
        let E = A.columnItems.findIndex((P)=>P.id === R.id);
        return {
            rowspan: x,
            colspan: E === 0 ? A.columnItems.length : 1
        };
    }, [
        f,
        d,
        l,
        b,
        m,
        u
    ]), y = $acw62.useCallback(({ rowIndex: w, colIndex: v })=>h({
            rowIndex: w,
            colIndex: v
        }).rowspan, [
        h
    ]), S = $acw62.useCallback(({ rowIndex: w, colIndex: v })=>h({
            rowIndex: w,
            colIndex: v
        }).colspan, [
        h
    ]), C = $acw62.useCallback((w)=>p ? w < m - 1 ? c : 2 * c : c, [
        m,
        p,
        c
    ]);
    $88ab1a78ec8ca4b4$var$Ii(e, {
        colWidth: s,
        rowHeight: C,
        rows: m,
        cols: l.length,
        height: g,
        rowspan: y,
        colspan: S
    }, {
        fixedColsEnd: a.length,
        fixedColsStart: i.length
    });
    let T = $acw62.createElement($88ab1a78ec8ca4b4$var$_f, {
        columns: l,
        headerBrain: e,
        bodyBrain: t,
        columnHeaderHeight: g,
        columnGroupsMaxDepth: d,
        columnAndGroupTreeInfo: b
    }), I = n.vertical && $88ab1a78ec8ca4b4$var$sn() ? $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$qc,
        style: {
            zIndex: 1e3,
            width: $88ab1a78ec8ca4b4$var$sn()
        }
    }) : null;
    return $acw62.createElement("div", {
        className: `${$88ab1a78ec8ca4b4$var$ml} ${$88ab1a78ec8ca4b4$var$Jc}`,
        style: {
            height: g
        }
    }, T, I);
}
var { ManagedComponentContextProvider: $88ab1a78ec8ca4b4$var$wT } = $88ab1a78ec8ca4b4$export$c6a0e0787a01a4e5({
    initSetupState: $88ab1a78ec8ca4b4$var$Kd,
    forwardProps: $88ab1a78ec8ca4b4$var$Bd,
    Context: $88ab1a78ec8ca4b4$var$Pl()
});
function $88ab1a78ec8ca4b4$var$Hl(o) {
    let e = $88ab1a78ec8ca4b4$var$Q(), { state: t, getComputed: n } = e, { header: r, brain: i, headerBrain: a, wrapRowsHorizontally: l } = t, { scrollbars: s } = n();
    return r ? $acw62.createElement($88ab1a78ec8ca4b4$var$wT, {
        ...o
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$Nf, {
        wrapRowsHorizontally: !!l,
        bodyBrain: i,
        headerBrain: a,
        scrollbars: s
    })) : null;
}
function $88ab1a78ec8ca4b4$var$Ff() {
    return $acw62.useContext($88ab1a78ec8ca4b4$var$Pl()).componentState;
}
var $88ab1a78ec8ca4b4$var$PT = (o)=>{
    let { allRowsSelected: e, someRowsSelected: t, api: n, dataSourceApi: r } = o, i = e ? !0 : t ? null : !1, { components: a, isTree: l } = n.getState(), s = a?.CheckBox || $88ab1a78ec8ca4b4$var$Wt;
    return $acw62.createElement(s, {
        domProps: {
            className: $88ab1a78ec8ca4b4$var$Qr
        },
        onChange: (c)=>{
            if (l) {
                c ? r.treeApi.selectAll() : r.treeApi.deselectAll();
                return;
            }
            c ? n.rowSelectionApi.selectAll() : n.rowSelectionApi.deselectAll();
        },
        checked: i
    });
}, $88ab1a78ec8ca4b4$var$ni = $acw62.createContext(null);
var $88ab1a78ec8ca4b4$var$DT = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnZIndexAtIndex), $88ab1a78ec8ca4b4$var$MT = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnVisibilityAtIndex), $88ab1a78ec8ca4b4$var$Kl = $acw62.createElement("div", {
    className: $88ab1a78ec8ca4b4$var$_r[1]
}), $88ab1a78ec8ca4b4$var$kf = $88ab1a78ec8ca4b4$var$Nr({
    "data-name": "",
    "data-field": "",
    "data-header-align": "",
    "data-column-id": "",
    "data-sort": "",
    "data-sort-index": "",
    [$88ab1a78ec8ca4b4$var$pn]: ""
});
function $88ab1a78ec8ca4b4$var$Of(o) {
    let e = o.column, { allowColumnHideWhileDragging: t } = $88ab1a78ec8ca4b4$var$Ff(), { onDragItemPointerDown: n } = $88ab1a78ec8ca4b4$var$er(), { api: r, getComputed: i, getState: a, actions: l, state: { showColumnFilters: s, components: c, portalDOMRef: u, columnHeaderHeight: d, columnReorderDragColumnId: f, columnMenuVisibleForColumnId: p, columnReorderInPageIndex: m }, getDataSourceMasterContext: g } = $88ab1a78ec8ca4b4$var$Q(), { api: b, componentActions: h, getState: y, componentState: { filterDelay: S, filterTypes: C } } = $88ab1a78ec8ca4b4$var$_e(), { allRowsSelected: T, someRowsSelected: I, selectionMode: w } = $88ab1a78ec8ca4b4$export$c5a52c32d527b09b(), v = o.horizontalLayoutPageIndex, R = f === e.id, x = m != null ? v !== m : !1, { onResize: M, height: A, width: E, headerOptions: P, columnsMap: _ } = o, D = e.computedSortInfo, O = e.header, F = (0, $acw62.useCallback)((k)=>{
        H.current = k, o.domRef?.(k);
    }, [
        o.domRef
    ]), W = P.alwaysReserveSpaceForSortIcon, z = e.headerAlign ?? e.align, L = (typeof z == "function" ? z({
        isHeader: !0,
        column: e
    }) : z) ?? "start", ae = (typeof e.verticalAlign == "function" ? e.verticalAlign({
        isHeader: !0,
        column: e
    }) : e.verticalAlign) ?? "center", te = $88ab1a78ec8ca4b4$var$it(e, {
        actions: l,
        api: r,
        dataSourceActions: h,
        dataSourceApi: b,
        getComputed: i,
        getDataSourceState: y,
        getDataSourceMasterContext: g,
        getState: a
    }), B = te.isSortable(), j = B && (e.computedSorted || W) ? $acw62.createElement($88ab1a78ec8ca4b4$var$oi, {
        index: e.computedMultiSort ? e.computedSortIndex + 1 : void 0,
        style: {
            marginInlineStart: $88ab1a78ec8ca4b4$var$se.spacing[2],
            marginInlineEnd: $88ab1a78ec8ca4b4$var$se.spacing[2]
        },
        className: `${$88ab1a78ec8ca4b4$var$_n}__sort-icon ${$88ab1a78ec8ca4b4$var$Xc} ${$88ab1a78ec8ca4b4$var$Qc({
            align: L
        })}`,
        direction: e.computedSorted ? e.computedSortedAsc ? 1 : -1 : 0
    }) : null, me = e.computedFilterable && e.computedFiltered ? $acw62.createElement($88ab1a78ec8ca4b4$var$eo, null) : null, pe = e.headerCssEllipsis ?? e.cssEllipsis ?? !0, ce = {
        reserveSpaceWhenHidden: L === "center",
        menuVisible: p === e.id,
        style: L === "end" ? {
            marginInlineStart: `calc(${$88ab1a78ec8ca4b4$var$se.components.HeaderCell.resizeHandleActiveAreaWidth} / 2)`,
            marginInlineEnd: $88ab1a78ec8ca4b4$var$se.spacing[2]
        } : {
            marginInlineEnd: `calc(${$88ab1a78ec8ca4b4$var$se.components.HeaderCell.resizeHandleActiveAreaWidth} / 2)`,
            marginInlineStart: $88ab1a78ec8ca4b4$var$se.spacing[2]
        },
        domProps: {
            onMouseDown: (k)=>{
                k.stopPropagation(), te.toggleContextMenu(k.target);
            }
        }
    }, ue = e.components?.MenuIcon || c?.MenuIcon || $88ab1a78ec8ca4b4$var$Qo, ge = $acw62.createElement(ue, {
        ...ce
    }), H = (0, $acw62.useRef)(null), G = {
        horizontalLayoutPageIndex: v,
        dragging: R,
        domRef: F,
        htmlElementRef: H,
        renderLocation: "column-header",
        column: e,
        columnsMap: _,
        columnSortInfo: D,
        columnFilterValue: e.computedFilterValue,
        filtered: e.computedFiltered,
        someRowsSelected: I,
        allRowsSelected: T,
        selectionMode: w,
        api: r,
        dataSourceApi: b,
        columnApi: te,
        renderBag: {
            sortIcon: j,
            filterIcon: me,
            menuIcon: ge,
            menuIconProps: ce,
            selectionCheckBox: null,
            header: e.header && typeof e.header != "function" ? e.header : e.name
        }
    }, q = G, K = q.renderBag.header, re = ()=>{
        let k = {
            ...G,
            renderBag: {
                ...G.renderBag
            }
        };
        if (e.renderSortIcon && (k.renderBag.sortIcon = $acw62.createElement($88ab1a78ec8ca4b4$var$dn, {
            render: e.renderSortIcon,
            renderParam: {
                ...k,
                renderBag: {
                    ...k.renderBag
                }
            }
        })), e.renderFilterIcon && (k.renderBag.filterIcon = $acw62.createElement($88ab1a78ec8ca4b4$var$dn, {
            render: e.renderFilterIcon,
            renderParam: {
                ...k,
                renderBag: {
                    ...k.renderBag
                }
            }
        })), typeof e.renderMenuIcon == "function" && (k.renderBag.menuIcon = $acw62.createElement($88ab1a78ec8ca4b4$var$dn, {
            render: (xt)=>{
                if (typeof e.renderMenuIcon != "function") return null;
                let Pt = e.renderMenuIcon(xt);
                return Pt ? Pt.type === ue || Pt.type === $88ab1a78ec8ca4b4$var$Qo ? Pt : $acw62.createElement(ue, {
                    ...ce
                }, Pt) : null;
            },
            renderParam: {
                ...k,
                renderBag: {
                    ...k.renderBag
                }
            }
        })), e.renderSelectionCheckBox && w === "multi-row") {
            k.renderBag.selectionCheckBox = $acw62.createElement($88ab1a78ec8ca4b4$var$dn, {
                render: $88ab1a78ec8ca4b4$var$PT,
                renderParam: {
                    ...k,
                    renderBag: {
                        ...k.renderBag
                    }
                }
            });
            let xt = e.renderHeaderSelectionCheckBox ?? e.renderSelectionCheckBox;
            xt && xt !== !0 && (k.renderBag.selectionCheckBox = $acw62.createElement($88ab1a78ec8ca4b4$var$dn, {
                render: xt,
                renderParam: {
                    ...k,
                    renderBag: {
                        ...k.renderBag
                    }
                }
            }));
        }
        O instanceof Function && (k.renderBag.header = K = $acw62.createElement($88ab1a78ec8ca4b4$var$dn, {
            render: O,
            renderParam: {
                ...k,
                renderBag: {
                    ...k.renderBag
                }
            }
        }));
        let Se = e.renderMenuIcon === !1 ? null : k.renderBag.menuIcon, nn = pe ? $acw62.createElement("div", {
            className: $88ab1a78ec8ca4b4$var$Lt
        }, k.renderBag.header) : k.renderBag.header, Tt = $acw62.createElement($acw62.Fragment, null, L === "center" ? $88ab1a78ec8ca4b4$var$Kl : null, k.renderBag.selectionCheckBox, nn, k.renderBag.sortIcon, k.renderBag.filterIcon, L === "center" ? $88ab1a78ec8ca4b4$var$Kl : null, L !== "center" ? $88ab1a78ec8ca4b4$var$Kl : null, Se);
        return e.renderHeader ? $acw62.createElement($88ab1a78ec8ca4b4$var$dn, {
            render: e.renderHeader,
            renderParam: {
                ...k,
                renderBag: {
                    ...k.renderBag,
                    all: Tt
                }
            }
        }) : Tt;
    };
    (0, $acw62.useEffect)(()=>{
        let k = null, Se = H.current;
        return M && Se && (k = $88ab1a78ec8ca4b4$var$zo(Se, M)), ()=>{
            k?.();
        };
    }, [
        H.current,
        o.onResize
    ]);
    let J = {
        height: A
    };
    e.headerStyle && (J = typeof e.headerStyle == "function" ? {
        ...J,
        ...e.headerStyle(q) || {}
    } : {
        ...J,
        ...e.headerStyle
    });
    let de = typeof e.headerClassName == "function" ? e.headerClassName(q) : e.headerClassName, { onPointerDown: we, proxyPosition: N1, dragColumnOutside: $ } = $88ab1a78ec8ca4b4$var$Ju({
        columnId: e.id,
        domRef: H,
        horizontalLayoutPageIndex: v,
        allowColumnHideOnDrag: t
    }), ee = null, le = $88ab1a78ec8ca4b4$var$ni.Provider, De = {
        filtered: e.computedFiltered,
        verticalAlign: ae,
        align: L
    }, Oe = $acw62.useMemo(()=>{
        let k = (Se)=>{
            r.setColumnFilter(e.id, Se);
        };
        return S > 0 ? $88ab1a78ec8ca4b4$export$61fc7d43ac8f84b0(k, {
            wait: S
        }) : k;
    }, [
        S,
        e.id
    ]), Ne = e.computedFilterType, he = C[Ne], Ke = e.computedFilterable ? e.computedFilterValue?.filter.operator ?? he?.defaultOperator : void 0, Be = e.computedFilterable && he ? he.operators.find((k)=>k.name === Ke) : void 0, dt = Be?.components?.FilterEditor || he?.components?.FilterEditor || e.components?.FilterEditor || $88ab1a78ec8ca4b4$var$no, Rt = he?.components?.FilterOperatorSwitch || e.components?.FilterOperatorSwitch, Ze = $88ab1a78ec8ca4b4$var$Nd(e, {
        horizontalLayoutPageIndex: v
    }), V = `var(${$88ab1a78ec8ca4b4$var$DT}-${e.computedVisibleIndex})`;
    J.zIndex = V, J.visibility = `var(${$88ab1a78ec8ca4b4$var$MT}-${e.computedVisibleIndex}, visible)`;
    let ne = {
        "data-field": `${e.field || ""}`,
        "data-column-id": e.id,
        [$88ab1a78ec8ca4b4$var$pn]: e.id,
        "data-header-align": L,
        "data-name": "HeaderCell",
        "data-sort": e.computedSortedAsc ? "asc" : e.computedSortedDesc ? "desc" : "none",
        "data-sort-index": `${e.computedSortIndex ?? -1}`
    }, ie = e.computedFilterable ? $acw62.createElement($88ab1a78ec8ca4b4$var$fu, {
        horizontalLayoutPageIndex: v,
        filterEditor: dt,
        filterOperatorSwitch: Rt ?? $88ab1a78ec8ca4b4$var$pu,
        operator: Be,
        filterTypes: C,
        onChange: Oe,
        columnFilterType: Ne,
        columnLabel: e.field || e.name || e.id,
        columnFilterValue: e.computedFilterValue,
        columnHeaderHeight: d
    }) : $acw62.createElement($88ab1a78ec8ca4b4$var$mu, null);
    q.renderBag.filterEditor = ie;
    let be = (0, $acw62.useCallback)((k)=>{
        we(k), n(k);
    }, [
        we,
        n
    ]), je = re();
    return R && N1 && (ee = $acw62.createElement("div", {
        key: e.id,
        className: `${$88ab1a78ec8ca4b4$var$_n}Proxy ${$88ab1a78ec8ca4b4$var$Vc}`,
        style: {
            height: A,
            width: E,
            left: N1.left ?? 0,
            top: N1.top ?? 0
        }
    }, $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$Gc({
            visible: $
        })
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$Hd, {
        size: 16
    })), K), ee = (0, $1u0KT.createPortal)(ee, u.current)), $acw62.createElement(le, {
        value: q
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$ei, {
        domRef: F,
        horizontalLayoutPageIndex: o.horizontalLayoutPageIndex,
        cellType: "header",
        column: e,
        ...ne,
        "data-z-index": V,
        style: J,
        width: E,
        onPointerDown: be,
        contentClassName: $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$zc(De), $88ab1a78ec8ca4b4$var$mc[L]),
        contentStyle: s ? {
            height: A / 2
        } : void 0,
        className: $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$_n, $88ab1a78ec8ca4b4$var$Tc.none, B ? $88ab1a78ec8ca4b4$var$fc.pointer : "", de, $88ab1a78ec8ca4b4$var$Br(e, [
            $88ab1a78ec8ca4b4$var$_n,
            $88ab1a78ec8ca4b4$var$Fn
        ], $88ab1a78ec8ca4b4$var$Hc, {
            dragging: R,
            insideDisabledDraggingPage: x,
            align: L,
            verticalAlign: ae,
            rowSelected: !1,
            cellSelected: !1,
            rowDisabled: !1,
            zebra: !1,
            rowActive: !1,
            firstRow: !0,
            firstRowInHorizontalLayoutPage: !0,
            treeNode: !1,
            groupCell: !1,
            groupRow: !1,
            rowExpanded: !1
        }), $88ab1a78ec8ca4b4$var$kc),
        cssEllipsis: pe,
        afterChildren: $acw62.createElement($acw62.Fragment, null, s ? ie : null, Ze),
        renderChildren: je
    }), ee);
}
function $88ab1a78ec8ca4b4$export$cff1069d94cb1729() {
    return (0, $acw62.useContext)($88ab1a78ec8ca4b4$var$ni);
}
function $88ab1a78ec8ca4b4$var$zf(o, e) {
    let { separator: t } = e ?? {
        separator: "-"
    };
    return o.replace(/([a-z\d])([A-Z])/g, "$1" + t + "$2").replace(new RegExp("(" + t + "[A-Z])([A-Z])", "g"), "$1" + t + "$2").toLowerCase();
}
var $88ab1a78ec8ca4b4$var$Vf = {
    padding: $88ab1a78ec8ca4b4$var$se.spacing[2],
    textAlign: "end",
    opacity: "1",
    visibility: "visible",
    display: "block",
    fontSize: "0.85rem",
    background: "white",
    color: "black"
}, $88ab1a78ec8ca4b4$var$AT = {
    opacity: 1,
    visibility: "visible",
    display: "inline-block",
    pointerEvents: "all",
    color: "black",
    textDecoration: "underline"
}, $88ab1a78ec8ca4b4$var$Gf = (o, e)=>{
    if (o) for (let [t, n] of Object.entries(e))o.style.setProperty($88ab1a78ec8ca4b4$var$zf(t), n, "important");
}, $88ab1a78ec8ca4b4$var$Hf = $acw62.forwardRef(function(e, t) {
    let { rootClassName: n } = $88ab1a78ec8ca4b4$var$Ar(), r = $acw62.useRef(null), i = $acw62.useCallback((a)=>{
        r.current = a, t && (typeof t == "function" ? t(a) : t.current = a);
    }, []);
    return (0, $acw62.useEffect)(()=>{
        let a = ()=>{
            setTimeout(()=>{
                $88ab1a78ec8ca4b4$var$Gf(r.current, $88ab1a78ec8ca4b4$var$Vf), $88ab1a78ec8ca4b4$var$Gf(r.current?.firstElementChild, $88ab1a78ec8ca4b4$var$AT);
            });
        };
        a();
        let l = setInterval(a, 1e3);
        return ()=>{
            clearInterval(l);
        };
    }, []), $acw62.createElement("div", {
        ref: i,
        ...e,
        className: $88ab1a78ec8ca4b4$var$X(`${n}-Footer`, $88ab1a78ec8ca4b4$var$wu, e.className),
        style: $88ab1a78ec8ca4b4$var$Vf
    }, "Powered by", " ", $acw62.createElement("a", {
        href: "https://infinite-table.com",
        rel: "noopener noreferrer",
        role: "link",
        target: "_blank"
    }, "Infinite Table"));
});
function $88ab1a78ec8ca4b4$var$Bl(o) {
    return o.map($88ab1a78ec8ca4b4$var$Vt);
}
function $88ab1a78ec8ca4b4$var$Vt(o) {
    if ($88ab1a78ec8ca4b4$var$Re().structuredClone) return $88ab1a78ec8ca4b4$var$Re().structuredClone(o);
    if (o === null || typeof o != "object") return o;
    if (Array.isArray(o)) return $88ab1a78ec8ca4b4$var$Bl(o);
    if (o instanceof Date) return new Date(o);
    if (o instanceof Set) return new Set($88ab1a78ec8ca4b4$var$Bl(Array.from(o)));
    if (o instanceof Map) return new Map($88ab1a78ec8ca4b4$var$Bl(Array.from(o)));
    let e = {};
    for(let t in o)o.hasOwnProperty(t) && (e[t] = $88ab1a78ec8ca4b4$var$Vt(o[t]));
    return e;
}
function $88ab1a78ec8ca4b4$var$sr(o) {
    return o;
}
var $88ab1a78ec8ca4b4$var$Hn = Object.seal({
    data: null,
    field: null
});
var $88ab1a78ec8ca4b4$var$yn = "____root____", $88ab1a78ec8ca4b4$var$Bf = "____not_loaded_yet____";
function $88ab1a78ec8ca4b4$var$bn() {
    return !1;
}
function $88ab1a78ec8ca4b4$var$Wl(o) {
    if (!o || !Object.keys(o).length) return {};
    let e = {};
    for(let t in o)if (o.hasOwnProperty(t)) {
        let n = o[t].initialValue;
        e[t] = typeof n == "function" ? n() : n;
    }
    return e;
}
function $88ab1a78ec8ca4b4$var$vi(o, e, t, n, r) {
    if (!(!t || !Object.keys(t).length)) {
        for(let i in t)if (t.hasOwnProperty(i)) {
            let a = t[i];
            if (typeof a.reducer != "function") continue;
            let l = n[i], s = a.getter ? a.getter(o) ?? null : a.field ? o[a.field] : null;
            n[i] = a.reducer(l, s, o, e, r);
        }
    }
}
function $88ab1a78ec8ca4b4$var$Wf(o, e) {
    let { marker: t, reducers: n = {}, pivot: r, groupBy: i, indexer: a, toPrimaryKey: l, cache: s, mappings: c } = o;
    t && t.start();
    let u = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
    function d(h, y, S, C = 0, T = []) {
        let I = !S.length || C === S.length - 1, w = y[c?.values || "values"] || {};
        for(let v in w)if (w.hasOwnProperty(v)) {
            let R = v;
            T.push(R), f.set(T, !0), h.set(T, {
                reducerResults: w[v][c?.totals || "totals"] || {},
                items: []
            }), I || d(h, w[v], S, C + 1, T), T.pop();
        }
    }
    let f = r ? new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00 : void 0, p = [], m = $88ab1a78ec8ca4b4$var$Wl(n), g = $88ab1a78ec8ca4b4$var$Vt(m);
    e.visitDepthFirst((h, y, S, C)=>{
        let [T, ...I] = y, w = h.children, v = u.get(I);
        if (v && (v.cache = h.cache, v.childrenLoading = h.childrenLoading, v.childrenAvailable = h.childrenAvailable, v.error = h.error), I.length == i.length && i.length) {
            if (v) {
                v.items = w;
                for(let x = 0, M = I.length; x < M; x++){
                    let A = I.slice(0, x), E = u.get(A);
                    E && (E.items = E.items || [], E.items = E.items.concat(w));
                }
                w = a.indexArray(w, {
                    toPrimaryKey: l,
                    cache: s,
                    nodesKey: void 0
                });
            }
            return C?.();
        }
        for(let R = 0, x = w.length; R < x; R++){
            if (!w[R]) {
                let P = {
                    items: [],
                    reducerResults: {},
                    cache: !1,
                    childrenLoading: !1,
                    childrenAvailable: !1,
                    isTree: !1,
                    isGroupBy: !0
                };
                u.set([
                    ...I,
                    `${$88ab1a78ec8ca4b4$var$Bf}${R}`
                ], P);
                continue;
            }
            let M = w[R].data, A = w[R].keys || [];
            if (A.length) {
                let P = A[A.length - 1];
                I.push(P);
            }
            let E = {
                items: [],
                cache: !1,
                childrenLoading: !1,
                childrenAvailable: !1,
                commonData: M,
                totalChildrenCount: w[R].totalChildrenCount,
                reducerResults: w[R].aggregations || {},
                isTree: !1,
                isGroupBy: !0
            };
            if (u.set(I, E), r) {
                let P = E.pivotDeepMap = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00, _ = w[R].pivot;
                d(P, _, r, 0, p);
            }
            A.length && I.pop();
        }
        C?.();
    });
    let b = {
        deepMap: u,
        groupParams: o,
        initialData: e,
        reducerResults: g
    };
    return r && (b.topLevelPivotColumns = f, b.pivot = r), t && t.end({
        details: [
            {
                name: "Group by fields",
                value: i.map((h)=>h.field).join(", ")
            }
        ]
    }), b;
}
function $88ab1a78ec8ca4b4$var$Kf(o, e, t, n, r, i, a, l, s, c = $88ab1a78ec8ca4b4$var$sr) {
    let { items: u, reducerResults: d, pivotDeepMap: f } = o.get(e);
    if (u.push(n), a && $88ab1a78ec8ca4b4$var$vi(n, r, a, d, e), i) {
        for(let p = 0, m = i.length; p < m; p++){
            let { field: g, valueGetter: b, toKey: h } = i[p], y = g ? n[g] : null;
            b && ($88ab1a78ec8ca4b4$var$Hn.data = n, $88ab1a78ec8ca4b4$var$Hn.field = g, y = b($88ab1a78ec8ca4b4$var$Hn));
            let S = (h || c)(y, n);
            t.push(S), f.has(t) || (l.set(t, !0), f?.set(t, {
                reducerResults: $88ab1a78ec8ca4b4$var$Vt(s),
                items: []
            }));
            let { reducerResults: C, items: T } = f.get(t);
            T.push(n), a && $88ab1a78ec8ca4b4$var$vi(n, r, a, C, e);
        }
        t.length = 0;
    }
}
function $88ab1a78ec8ca4b4$var$jf(o, e, t, n, r, i, a, l) {
    let { isLeafNode: s, getNodeChildren: c, toKey: u } = o, d = u(r), f = [
        ...n,
        d
    ], p = s(r);
    if (t.set(f, !0), p) {
        for(let h = 0, y = n.length; h <= y; h++){
            let S = n.slice(0, h), C = e.get(S), { reducerResults: T, items: I } = C;
            I.push(r), C.leavesAvailableCount++, C.totalLeafNodesCount++, a && $88ab1a78ec8ca4b4$var$vi(r, i, a, T, S);
        }
        return;
    }
    let m = $88ab1a78ec8ca4b4$var$Vt(l), g = [];
    e.set(f, {
        items: g,
        isTree: !0,
        isGroupBy: !1,
        node: r,
        reducerResults: m,
        cache: !1,
        childrenLoading: !1,
        childrenAvailable: !0,
        totalLeafNodesCount: 0,
        leavesAvailableCount: 0,
        treeNesting: n.length
    });
    let b = c(r);
    if (!(!b || !Array.isArray(b))) {
        for(let h = 0, y = b.length; h < y; h++){
            let S = b[h];
            $88ab1a78ec8ca4b4$var$jf(o, e, t, f, S, h, a, l);
        }
        a && $88ab1a78ec8ca4b4$var$cr(a, m, g);
    }
}
function $88ab1a78ec8ca4b4$var$jl(o, e) {
    let { reducers: t, marker: n } = o;
    if (n) {
        let c = Object.keys(t ?? {});
        n.start({
            details: c.length > 0 ? [
                {
                    name: "Reducers",
                    value: c.join(", ")
                }
            ] : void 0
        });
    }
    let r = $88ab1a78ec8ca4b4$var$Wl(t), i = $88ab1a78ec8ca4b4$var$Vt(r), a = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00, l = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
    a.set([], {
        items: [],
        isTree: !0,
        isGroupBy: !1,
        reducerResults: i,
        cache: !1,
        childrenLoading: !1,
        childrenAvailable: !0,
        totalLeafNodesCount: 0,
        leavesAvailableCount: 0,
        node: null,
        treeNesting: -1
    });
    for(let c = 0, u = e.length; c < u; c++)$88ab1a78ec8ca4b4$var$jf(o, a, l, [], e[c], c, t, r);
    t && $88ab1a78ec8ca4b4$var$cr(t, i, e);
    let s = {
        deepMap: a,
        treeParams: o,
        treePaths: l,
        initialData: e,
        reducerResults: i
    };
    return n && n.end(), s;
}
function $88ab1a78ec8ca4b4$export$e5e25fbcc1f7affe(o, e) {
    let { marker: t, groupBy: n, defaultToKey: r = $88ab1a78ec8ca4b4$var$sr, pivot: i, reducers: a } = o;
    t && t.start();
    let l = n.length, s = i ? new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00 : void 0, c = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00, u = [], d = [], f = $88ab1a78ec8ca4b4$var$Wl(a), p = $88ab1a78ec8ca4b4$var$Vt(f);
    if (!l) {
        let g = {
            items: [],
            isTree: !1,
            isGroupBy: !0,
            cache: !1,
            childrenLoading: !1,
            childrenAvailable: !1,
            reducerResults: $88ab1a78ec8ca4b4$var$Vt(f)
        };
        i && (g.pivotDeepMap = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00), c.set(u, g);
    }
    for(let g = 0, b = e.length; g < b; g++){
        let h = e[g], y = {};
        for(let S = 0; S < l; S++){
            let { field: C, groupField: T, valueGetter: I, toKey: w } = n[S], v = C ? h[C] : null;
            I && ($88ab1a78ec8ca4b4$var$Hn.data = h, $88ab1a78ec8ca4b4$var$Hn.field = C, v = I($88ab1a78ec8ca4b4$var$Hn));
            let R = (w || r)(v, h);
            if (y[C || T] = R, u.push(R), !c.has(u)) {
                let x = {
                    items: [],
                    isTree: !1,
                    isGroupBy: !0,
                    cache: !1,
                    commonData: {
                        ...y
                    },
                    childrenLoading: !1,
                    childrenAvailable: !1,
                    reducerResults: $88ab1a78ec8ca4b4$var$Vt(f)
                };
                i && (x.pivotDeepMap = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00), c.set(u, x);
            }
            $88ab1a78ec8ca4b4$var$Kf(c, u, d, h, g, i, a, s, f, r);
        }
        l || $88ab1a78ec8ca4b4$var$Kf(c, u, d, h, g, i, a, s, f, r), a && $88ab1a78ec8ca4b4$var$vi(h, g, a, p, u), u.length = 0;
    }
    a && (c.visitDepthFirst((g, b, h, y)=>{
        $88ab1a78ec8ca4b4$var$cr(a, g.reducerResults, g.items), i && g.pivotDeepMap.visitDepthFirst(({ items: S, reducerResults: C }, T, I, w)=>{
            $88ab1a78ec8ca4b4$var$cr(a, C, S), w?.();
        }), y?.();
    }), $88ab1a78ec8ca4b4$var$cr(a, p, e));
    let m = {
        deepMap: c,
        groupParams: o,
        initialData: e,
        reducerResults: p
    };
    return i && (m.topLevelPivotColumns = s, m.pivot = i), t && t.end({
        details: [
            {
                name: "Group by fields",
                value: n.map((g)=>g.field).join(", ")
            }
        ]
    }), m;
}
function $88ab1a78ec8ca4b4$export$bffa455ba8c619a6(o) {
    let { groupParams: e, deepMap: t } = o, n = e.groupBy.length, r = [];
    return t.topDownKeys().reduce((i, a)=>{
        if (a.length === n) {
            let l = t.get(a).items;
            i.push(...l);
        }
        return i;
    }, r), r;
}
function $88ab1a78ec8ca4b4$var$OT(o, e) {
    let { groupBy: t, groupKeys: n, parents: r, reducers: i, lazyLoad: a } = o, l = n.length, { items: s, reducerResults: c, pivotDeepMap: u, commonData: d } = e, f = d ?? null, p;
    if (Object.keys(c).length > 0) {
        f = {
            ...d
        }, p = {};
        for(let y in i)if (i.hasOwnProperty(y)) {
            let C = i[y].field;
            C && (p[C] = c[y]), C && f[C] == null && (f[C] = c[y]);
        }
    }
    let m = !0, g = n[n.length - 1], b = g;
    if (f != null) {
        let y = t[n.length - 1];
        y && y.field && (b = f[y.field]), y && y.toKey && (b = y.toKey(b, f)), b = b ?? g;
    }
    return typeof b == "string" && b.startsWith($88ab1a78ec8ca4b4$var$Bf) && (m = !1, b = null), {
        data: f,
        reducerData: p,
        groupCount: s.length,
        groupData: s,
        groupKeys: n,
        isTreeNode: !1,
        rowSelected: !1,
        selectedChildredCount: 0,
        deselectedChildredCount: 0,
        id: `${n}`,
        collapsed: !1,
        dataSourceHasGrouping: !0,
        rowDisabled: !1,
        isCellSelected: $88ab1a78ec8ca4b4$var$bn,
        hasSelectedCells: $88ab1a78ec8ca4b4$var$bn,
        selfLoaded: m,
        error: o.error,
        parents: r,
        deepRowInfoArray: [],
        collapsedChildrenCount: 0,
        collapsedGroupsCount: 0,
        totalChildrenCount: o.totalChildrenCount,
        childrenAvailable: a ? o.childrenAvailable : !0,
        childrenLoading: o.childrenLoading,
        indexInParentGroups: o.indexInParentGroups,
        indexInGroup: o.indexInGroup,
        indexInAll: o.indexInAll,
        directChildrenCount: o.directChildrenCount,
        directChildrenLoadedCount: a ? o.directChildrenLoadedCount : o.directChildrenCount,
        value: b,
        rootGroupBy: t,
        groupBy: l === t.length ? t : t.slice(0, l),
        isGroupRow: !0,
        pivotValuesMap: u,
        groupNesting: l,
        reducerResults: c
    };
}
function $88ab1a78ec8ca4b4$var$Ri(o, e, t) {
    return {
        ...o,
        id: `duplicate_row_on_page_${t}_for__${o.id}`,
        indexInAll: e,
        duplicateOf: o.id
    };
}
function $88ab1a78ec8ca4b4$var$cr(o, e, t) {
    if (o) {
        for(let n in o)if (o.hasOwnProperty(n)) {
            let r = o[n];
            r.done && (e[n] = r.done(e[n], t));
        }
    }
    return e;
}
function $88ab1a78ec8ca4b4$var$$f(o, e, t, n, r, i) {
    let a = e.length, { isLeafNode: l, getNodeChildren: s } = r.treeParams, { toPrimaryKey: c, treeResult: u, isRowDisabled: d, isNodeSelected: f, withRowInfo: p, isNodeExpanded: m, treeSelectionState: g, repeatWrappedGroupRows: b, rowsPerPage: h } = r, { deepMap: y } = u, S = o.length, C = t[t.length - 1], T = C ? C.nodeExpanded : !0;
    for(let I = 0; I < S; I++){
        let w = o[I], v = c(w, I), R = [
            ...e,
            v
        ];
        if (l(w)) {
            let D = {
                id: v,
                nodePath: R,
                isGroupRow: !1,
                data: w,
                treeNesting: a,
                totalLeafNodesCount: 0,
                collapsedLeafNodesCount: 0,
                isTreeNode: !0,
                isParentNode: !1,
                selfLoaded: !0,
                rowSelected: !1,
                rowDisabled: !1,
                isCellSelected: $88ab1a78ec8ca4b4$var$bn,
                hasSelectedCells: $88ab1a78ec8ca4b4$var$bn,
                dataSourceHasGrouping: !1,
                parentNodes: Array.from(t),
                indexInParentNodes: [
                    ...n,
                    I
                ],
                indexInParent: I,
                indexInAll: T ? i.length : -1
            };
            f && (D.rowSelected = f(D)), d && (D.rowDisabled = d(D)), p && p(D);
            let O = b && h != null && h > 0 && D.indexInAll % h === 0 ? D.indexInAll / h : null;
            for(let F = 0, W = t.length; F < W; F++){
                let z = t[F];
                if (T || (z.collapsedLeafNodesCount += 1), z.deepRowInfoArray.push(D), O != null && T) {
                    if (typeof b == "function" && b(z) !== !0) continue;
                    let L = $88ab1a78ec8ca4b4$var$Ri(z, D.indexInAll, O);
                    i[L.indexInAll] = L, D.indexInAll++;
                }
            }
            T && (i[D.indexInAll] = D);
            continue;
        }
        let A = y.get(R)?.totalLeafNodesCount ?? 0, E = {
            dataSourceHasGrouping: !1,
            nodeExpanded: !1,
            selfExpanded: !1,
            nodePath: R,
            id: v,
            data: w,
            indexInAll: i.length,
            indexInParent: I,
            indexInParentNodes: [
                ...n,
                I
            ],
            totalLeafNodesCount: A,
            treeNesting: a,
            selfLoaded: !0,
            isParentNode: !0,
            isTreeNode: !0,
            isGroupRow: !1,
            deepRowInfoArray: [],
            parentNodes: Array.from(t),
            collapsedLeafNodesCount: 0,
            rowSelected: !1,
            rowDisabled: !1,
            isCellSelected: $88ab1a78ec8ca4b4$var$bn,
            hasSelectedCells: $88ab1a78ec8ca4b4$var$bn,
            selectedLeafNodesCount: 0,
            deselectedLeafNodesCount: 0
        };
        if (f && (E.rowSelected = f(E), g)) {
            let D = g.getSelectionCountFor(E.nodePath);
            E.selectedLeafNodesCount = D.selectedCount, E.deselectedLeafNodesCount = D.deselectedCount;
        }
        d && (E.rowDisabled = d(E)), p && p(E);
        let P = !0;
        if (m && (E.selfExpanded = P = m(E)), T || (P = !1), E.nodeExpanded = P, T && b && h != null && h > 0) {
            let D = E.indexInAll, O = E.parentNodes;
            if (O.length > 0 && D % h === 0) {
                let F = D / h, W = 0;
                O.forEach((z)=>{
                    typeof b == "function" && b(z) !== !0 || (i.push($88ab1a78ec8ca4b4$var$Ri(z, D + W, F)), W++, E.indexInAll++);
                });
            }
        }
        T && (i[E.indexInAll] = E);
        let _ = s(w);
        Array.isArray(_) && $88ab1a78ec8ca4b4$var$$f(_, R, [
            ...t,
            E
        ], E.indexInParentNodes, r, i);
    }
    return i;
}
function $88ab1a78ec8ca4b4$var$Uf(o) {
    let { dataArray: e, marker: t } = o;
    t && t.start();
    let n = [];
    return $88ab1a78ec8ca4b4$var$$f(e, [], [], [], o, n), t && t.end(), {
        data: n
    };
}
function $88ab1a78ec8ca4b4$var$Yf(o) {
    let { marker: e, lazyLoad: t, groupResult: n, rowsPerPage: r, repeatWrappedGroupRows: i, withRowInfo: a, toPrimaryKey: l, groupRowsState: s, isRowDisabled: c, isRowSelected: u, rowSelectionState: d, generateGroupRows: f, reducers: p = {} } = o, { groupParams: m, deepMap: g, pivot: b } = n, { groupBy: h } = m;
    e && e.start({
        details: [
            {
                name: "Group by fields",
                value: h.map((I)=>I.field).join(", ")
            }
        ]
    });
    let y = [], S = [], C = [], T = [];
    return g.visitDepthFirst((I, w, v, R)=>{
        let x = I.items, M = w.length, A = s?.isGroupRowCollapsed(w) ?? !1;
        T.push(v);
        let E = $88ab1a78ec8ca4b4$var$OT({
            lazyLoad: t,
            groupBy: h,
            parents: Array.from(C),
            reducers: p,
            indexInGroup: v,
            indexInParentGroups: Array.from(T),
            indexInAll: y.length,
            groupKeys: w,
            error: I.error,
            totalChildrenCount: I.totalChildrenCount,
            childrenLoading: (I.childrenLoading || !A && !I.childrenAvailable) && t,
            childrenAvailable: I.childrenAvailable,
            directChildrenCount: w.length === h.length ? I.items.length : g.getDirectChildrenSizeFor(w),
            directChildrenLoadedCount: 0
        }, I);
        if (u && (E.rowSelected = u(E), d)) {
            let F = d.getSelectionCountFor(E.groupKeys);
            E.selectedChildredCount = F.selectedCount, E.deselectedChildredCount = F.deselectedCount;
        }
        c && (E.rowDisabled = c(E));
        let P = C[C.length - 1], _ = P?.collapsed ?? !1;
        _ && (A = !0), E.collapsed = A;
        let D = f || A;
        if (_ && (D = !1), D) {
            if (i && r != null && r > 0) {
                let F = E.indexInAll, W = E.parents;
                if (W.length > 0 && F % r === 0) {
                    let z = F / r, L = 0;
                    W.forEach((ae)=>{
                        typeof i == "function" && i(ae) !== !0 || (y.push($88ab1a78ec8ca4b4$var$Ri(ae, F + L, z)), L++, E.indexInAll++);
                    });
                }
            }
            y.push(E), S.push(y.length - 1);
        }
        E.collapsedChildrenCount = 0, C.forEach((F)=>{
            F.deepRowInfoArray.push(E), F.collapsedGroupsCount += A ? 1 : 0;
        }), P && E.selfLoaded && t && (P.directChildrenLoadedCount += 1), a && a(E), C.push(E);
        let O = !0;
        if (O) {
            if (R) R();
            else if (!b) {
                let F = y.length;
                A || (y.length += x.length);
                let W = 0;
                for(let z = 0, L = x.length; z < L; z++){
                    let ae = x[z];
                    if (!A && i && r != null && r > 0) {
                        let oe = F + z + W;
                        if (oe % r === 0) {
                            let me = oe / r;
                            C.forEach((pe)=>{
                                if (typeof i == "function" && i(pe) !== !0) return;
                                let ce = F + z + W;
                                y[ce] = $88ab1a78ec8ca4b4$var$Ri(pe, ce, me), W++, y.length++;
                            });
                        }
                    }
                    let te = F + z + W, j = {
                        id: ae ? l(ae, te) : `${w}-${z}`,
                        data: ae,
                        isCellSelected: $88ab1a78ec8ca4b4$var$bn,
                        hasSelectedCells: $88ab1a78ec8ca4b4$var$bn,
                        dataSourceHasGrouping: !0,
                        isTreeNode: !1,
                        isGroupRow: !1,
                        selfLoaded: !!ae,
                        rowSelected: !1,
                        rowDisabled: !1,
                        rootGroupBy: h,
                        collapsed: A,
                        groupKeys: w,
                        parents: Array.from(C),
                        indexInParentGroups: [
                            ...T,
                            z
                        ],
                        indexInGroup: z,
                        indexInAll: te,
                        groupBy: h,
                        groupNesting: M + 1,
                        groupCount: E.groupCount
                    };
                    u && (j.rowSelected = u(j)), c && (j.rowDisabled = c(j)), a && a(j), C.forEach((oe, me)=>{
                        me === C.length - 1 && ae && (oe.directChildrenLoadedCount += 1), A && (oe.collapsedChildrenCount += 1), oe.deepRowInfoArray.push(j);
                    }), A || (y[F + z + W] = j);
                }
            }
        }
        C.pop(), T.pop();
    }), e && e.end(), {
        data: y,
        groupRowsIndexes: S
    };
}
var $88ab1a78ec8ca4b4$var$NT = ()=>{};
function $88ab1a78ec8ca4b4$export$e0456a0e6570d75d(o, e) {
    let t = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00, n = e.nodesKey ?? "children", r = e.emptyGroup ?? {}, i = typeof e.pathKey == "function" ? e.pathKey : (l)=>l[e.pathKey];
    for (let l of o){
        let s = i(l);
        for(let c = 0; c < s.length; c++){
            let u = s.slice(0, c);
            t.has(u) || t.set(u, void 0);
        }
        t.set(s, l);
    }
    function a(l, s) {
        let c = t.getKeysStartingWith(l, {
            excludeSelf: !0,
            depthLimit: 1
        });
        for (let u of c){
            let d = [
                ...l,
                u[u.length - 1]
            ], f = t.get(d), p = f ? f[n] ?? [] : [];
            a(d, p), p.length && (f || (f = typeof r == "function" ? r(d, p) : r), f[n] = p), s.push(f);
        }
        return s;
    }
    return a([], []);
}
function $88ab1a78ec8ca4b4$var$qf(o, e, t, n) {
    let { isLeafNode: r, getNodeChildren: i, toKey: a } = o, { onParentNode: l, onNode: s, onLeafNode: c } = e, u = a(n), d = [
        ...t,
        u
    ], f = r(n), p = $88ab1a78ec8ca4b4$var$ot(()=>{
        let m = i(n);
        if (!(!m || !Array.isArray(m))) for(let g = 0, b = m.length; g < b; g++){
            let h = m[g];
            $88ab1a78ec8ca4b4$var$qf(o, e, d, h);
        }
    });
    f ? (c?.(n), s?.(n, $88ab1a78ec8ca4b4$var$NT)) : (l?.(n, p, i(n)), s?.(n, p));
}
function $88ab1a78ec8ca4b4$var$Xf(o, e, t) {
    for(let n = 0, r = t.length; n < r; n++)$88ab1a78ec8ca4b4$var$qf(o, e, [], t[n]);
}
var $88ab1a78ec8ca4b4$var$LT = function(o, e) {
    return o - e;
}, $88ab1a78ec8ca4b4$var$kT = function(o, e) {
    return o = `${o}`, e = `${e}`, o.localeCompare(e);
}, $88ab1a78ec8ca4b4$var$zT = function(o, e) {
    return o - e;
}, $88ab1a78ec8ca4b4$var$VT = {
    number: $88ab1a78ec8ca4b4$var$LT,
    string: $88ab1a78ec8ca4b4$var$kT,
    date: $88ab1a78ec8ca4b4$var$zT
}, $88ab1a78ec8ca4b4$var$ur = $88ab1a78ec8ca4b4$var$VT;
function $88ab1a78ec8ca4b4$var$Zf(o) {
    return o.map((t)=>Array.isArray(t.field) ? t.field.map((n, r)=>{
            let i = Array.isArray(t.type) ? t.type[r] ?? t.type[0] : t.type;
            return typeof n == "function" ? {
                ...t,
                valueGetter: n,
                field: void 0,
                type: i
            } : {
                ...t,
                type: i,
                field: n
            };
        }) : t).flat();
}
var $88ab1a78ec8ca4b4$export$4c4a0f6d9a37d837 = (o, e, t)=>{
    let n = typeof t == "function" ? t : t?.get, r = t && typeof t == "object" ? t.marker : void 0;
    return r && r.start(), e.sort($88ab1a78ec8ca4b4$var$Qf($88ab1a78ec8ca4b4$var$Zf(o), n)), r && r.end(), e;
}, $88ab1a78ec8ca4b4$export$54fedfbcf9c64b86 = (o, e, t)=>{
    let { marker: n } = t;
    n && n.start();
    let r = $88ab1a78ec8ca4b4$var$Qf($88ab1a78ec8ca4b4$var$Zf(o), t.get), i = t.depthFirst ?? !1, a = t.inplace ?? !1;
    i || (a ? e.sort(r) : e = [
        ...e
    ].sort(r));
    let { nodesKey: l, toKey: s } = t, c = (d)=>d[l], u = (d)=>d[l] === void 0;
    return $88ab1a78ec8ca4b4$var$Xf({
        isLeafNode: t.isLeafNode ?? u,
        getNodeChildren: t.getNodeChildren ?? c,
        toKey: s
    }, {
        onParentNode: (d, f, p)=>{
            if (i && f(), Array.isArray(p)) {
                let m = a ? p.sort(r) : [
                    ...p
                ].sort(r);
                d[l] = m;
            }
            i || f();
        }
    }, e), i && (a ? e.sort(r) : e = [
        ...e
    ].sort(r)), n && n.end(), e;
};
$88ab1a78ec8ca4b4$export$4c4a0f6d9a37d837.knownTypes = $88ab1a78ec8ca4b4$var$ur;
var $88ab1a78ec8ca4b4$var$GT = (o)=>{
    if (!o) return;
    let e = o.field, t = o.valueGetter, n = o.dir < 0 ? -1 : o.dir > 0 ? 1 : 0;
    if (!n) return;
    let r = o.fn;
    if (!r && o.type) {
        let i = Array.isArray(o.type) ? o.type[0] : o.type;
        r = $88ab1a78ec8ca4b4$export$4c4a0f6d9a37d837.knownTypes[i], r || console.warn(`Unknown sort type "${o.type}" - please pass one of ${Object.keys($88ab1a78ec8ca4b4$export$4c4a0f6d9a37d837.knownTypes).join(", ")}`);
    }
    return r || (r = $88ab1a78ec8ca4b4$var$ur.string), (i, a)=>{
        let l = t ? t(i) : e ? i[e] : i, s = t ? t(a) : e ? a[e] : a, c = r(l, s);
        return c === 0 ? c : n * c;
    };
}, $88ab1a78ec8ca4b4$var$HT = (o)=>o.map($88ab1a78ec8ca4b4$var$GT).filter((e)=>e instanceof Function), $88ab1a78ec8ca4b4$var$Qf = (o, e)=>{
    let t = $88ab1a78ec8ca4b4$var$HT(o);
    return (n, r)=>{
        e && (n = e(n), r = e(r));
        let i = 0, a = 0, l, s = t.length;
        for(; a < s; a++)if (l = t[a], !!l && (i = l(n, r), i !== 0)) return i;
        return i;
    };
};
var $88ab1a78ec8ca4b4$var$xi = class {
    constructor(e){
        let t = e instanceof Object.getPrototypeOf(this).constructor ? e.getState() : e, n = this.getPositiveFromState(t), r = this.getNegativeFromState(t);
        this.update({
            negativeItems: r,
            positiveItems: n
        });
    }
    getInitialState() {
        return this.initialState;
    }
    destroy() {
        this.positiveMap?.clear(), this.negativeMap?.clear(), delete this.positiveMap, delete this.negativeMap;
    }
    update(e) {
        let { positiveItems: t, negativeItems: n } = e;
        if (this.allNegative = n === !0, this.allPositive = t === !0, this.allNegative && this.allPositive) throw "Cannot have both negativeItems and positiveItems be true!";
        n !== !0 && (this.negativeMap ? (this.negativeMap.clear(), this.negativeMap.fill(n.map((r)=>[
                r,
                !0
            ]))) : this.negativeMap = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00(n.map((r)=>[
                r,
                !0
            ])), this.positiveMap && this.positiveMap.clear()), t !== !0 && (this.positiveMap ? (this.positiveMap.clear(), this.positiveMap.fill(t.map((r)=>[
                r,
                !0
            ]))) : this.positiveMap = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00(t.map((r)=>[
                r,
                !0
            ])), this.negativeMap && this.negativeMap.clear());
    }
    areAllNegative() {
        return this.allNegative && (this.positiveMap ? this.positiveMap.size === 0 : !0);
    }
    areAllPositive() {
        return this.allPositive && (this.negativeMap ? this.negativeMap.size === 0 : !0);
    }
    makeAllNegative() {
        this.update({
            negativeItems: !0,
            positiveItems: []
        });
    }
    makeAllPositive() {
        this.update({
            positiveItems: !0,
            negativeItems: []
        });
    }
    isItemPositive(e) {
        if (this.allPositive === !0) {
            if (this.allNegative === !0) throw 'Cannot have both positiveItems and negativeItems be "true"';
            return !this.negativeMap?.has(e);
        }
        return this.positiveMap?.has(e);
    }
    isItemNegative(e) {
        return !this.isItemPositive(e);
    }
    setItemValue(e, t) {
        if (t !== this.isItemPositive(e)) {
            if (t) {
                if (this.allNegative === !0) {
                    if (!this.positiveMap) throw `No positiveMap found when trying to set item ${e.join(",")} be positive`;
                    this.positiveMap.set(e, !0);
                } else if (this.allPositive === !0) {
                    if (!this.negativeMap) throw `No negativeMap found when trying to set item ${e.join(",")} be positive`;
                    this.negativeMap.delete(e);
                }
            } else if (this.allPositive === !0) {
                if (!this.negativeMap) throw `No negativeMap found when trying to set item ${e.join(",")} be negative`;
                this.negativeMap.set(e, !0);
            } else if (this.allNegative === !0) {
                if (!this.positiveMap) throw `No positiveMap found when trying to set item ${e.join(",")} be negative`;
                this.positiveMap?.delete(e);
            }
        }
    }
    makeItemNegative(e) {
        this.setItemValue(e, !1);
    }
    makeItemPositive(e) {
        this.setItemValue(e, !0);
    }
    toggleItem(e) {
        this.setItemValue(e, !this.isItemPositive(e));
    }
};
var $88ab1a78ec8ca4b4$export$f4a923078262b9c3 = class extends $88ab1a78ec8ca4b4$var$xi {
    constructor(e){
        super(e);
    }
    getState() {
        return {
            expandedRows: this.allPositive ? !0 : this.positiveMap?.topDownKeys() ?? [],
            collapsedRows: this.allNegative ? !0 : this.negativeMap?.topDownKeys() ?? []
        };
    }
    getPositiveFromState(e) {
        return e.expandedRows;
    }
    getNegativeFromState(e) {
        return e.collapsedRows;
    }
    areAllCollapsed() {
        return this.areAllNegative();
    }
    areAllExpanded() {
        return this.areAllPositive();
    }
    collapseAll() {
        this.makeAllNegative();
    }
    expandAll() {
        this.makeAllPositive();
    }
    isGroupRowExpanded(e) {
        return this.isItemPositive(e);
    }
    isGroupRowCollapsed(e) {
        return !this.isGroupRowExpanded(e);
    }
    setGroupRowExpanded(e, t) {
        return this.setItemValue(e, t);
    }
    collapseGroupRow(e) {
        this.setGroupRowExpanded(e, !1);
    }
    expandGroupRow(e) {
        this.setGroupRowExpanded(e, !0);
    }
    toggleGroupRow(e) {
        this.toggleItem(e);
    }
};
function $88ab1a78ec8ca4b4$var$go(o, e) {
    return e.reduce((t, n)=>{
        let { field: r, valueGetter: i, toKey: a } = n, l = r ? o[r] : i?.({
            data: o,
            field: r
        }), s = (a || $88ab1a78ec8ca4b4$var$sr)(l, o);
        return t.push(s), t;
    }, []);
}
var $88ab1a78ec8ca4b4$export$fdba2ac35241013c = class o {
    constructor(e, t, n){
        this.selectedRows = null;
        this.deselectedRows = null;
        this.defaultSelection = !1;
        this.selectedMap = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.deselectedMap = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.onlyUsePrimaryKeys = !1;
        this.selectionCache = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.selectionCountCache = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.mapSet = (e, t)=>{
            Array.isArray(t) || (this.onlyUsePrimaryKeys ? t = [
                t
            ] : t = [
                ...this.getGroupKeysForPrimaryKey(t),
                t
            ]), this.xcache(), e === "selected" ? this.selectedMap.set(t, !0) : this.deselectedMap.set(t, !0);
        };
        this._selectedMapSet = (e)=>{
            this.mapSet("selected", e);
        };
        this._deselectedMapSet = (e)=>{
            this.mapSet("deselected", e);
        };
        let r = e instanceof Object.getPrototypeOf(this).constructor ? e.getState() : e;
        this.getConfig = t, this.onlyUsePrimaryKeys = t().onlyUsePrimaryKeys, n && Object.assign(this, n), this.update(r);
    }
    getGroupKeysForPrimaryKey(e) {
        let { indexer: t, groupBy: n } = this.getConfig(), r = t.getDataForPrimaryKey(e);
        return r ? $88ab1a78ec8ca4b4$var$go(r, n) : [];
    }
    getGroupDeepMap() {
        return this.getConfig().groupDeepMap;
    }
    getGroupCount(e) {
        if (e.length == 0) return this.getConfig().totalCount;
        let n = this.getGroupDeepMap()?.get(e);
        return n ? n.totalChildrenCount ?? (n.items.length || 0) : 0;
    }
    getGroupKeysDirectlyInsideGroup(e) {
        let { groupDeepMap: t } = this.getConfig();
        return t?.getKeysStartingWith(e, {
            excludeSelf: !0,
            depthLimit: 1
        }) || [];
    }
    getAllPrimaryKeysInsideGroup(e) {
        let { groupDeepMap: t } = this.getConfig();
        if (!e.length) return (t?.getKeysStartingWith([], {
            excludeSelf: !0,
            depthLimit: 1
        }) || []).map((i)=>this.getAllPrimaryKeysInsideGroup(i)).flat();
        let n = t?.get(e);
        return n ? n.items.map(this.getConfig().toPrimaryKey) : [];
    }
    getGroupByLength() {
        return this.getConfig().groupBy.length;
    }
    static from(e, t, n) {
        return new o(e, t, n);
    }
    update(e) {
        this.selectedRows = e.selectedRows || null, this.deselectedRows = e.deselectedRows || null, this.selectedMap.clear(), this.deselectedMap.clear(), this.selectedRows?.forEach(this._selectedMapSet), this.deselectedRows?.forEach(this._deselectedMapSet), this.defaultSelection = e.defaultSelection, this.xcache();
    }
    xcache() {
        this.selectionCache.clear(), this.selectionCountCache.clear();
    }
    getState() {
        let e = (r)=>{
            let i = this.getGroupByLength();
            return r.map((a)=>this.onlyUsePrimaryKeys ? a[0] : a.length > i ? a.pop() : a);
        }, t = e(this.selectedMap.topDownKeys()), n = e(this.deselectedMap.topDownKeys());
        return {
            defaultSelection: this.defaultSelection,
            selectedRows: t,
            deselectedRows: n
        };
    }
    deselectAll() {
        this.update({
            defaultSelection: !1,
            selectedRows: [],
            deselectedRows: []
        });
    }
    selectAll() {
        this.update({
            defaultSelection: !0,
            deselectedRows: [],
            selectedRows: []
        });
    }
    isRowDefaultSelected() {
        return this.defaultSelection === !0;
    }
    isRowDefaultDeselected() {
        return this.defaultSelection === !1;
    }
    isRowSelected(e, t) {
        if (this.onlyUsePrimaryKeys) return this.defaultSelection ? !this.deselectedMap.has([
            e
        ]) : this.selectedMap.has([
            e
        ]);
        t = t || this.getGroupKeysForPrimaryKey(e);
        let n = [
            ...t,
            e
        ], r = this.selectionCache.get(n);
        if (r !== void 0) return r;
        let i = this.selectedMap.has(n), a = this.deselectedMap.has(n);
        if (i) return this.selectionCache.set(n, !0), !0;
        if (a) return this.selectionCache.set(n, !1), !1;
        if (this.selectedMap.has(t)) return this.selectionCache.set(n, !0), !0;
        if (this.deselectedMap.has(t)) return this.selectionCache.set(n, !1), !1;
        for(t = [
            ...t
        ]; t.length;){
            t.pop();
            let l = this.selectedMap.has(t), s = this.deselectedMap.has(t);
            if (l) return this.selectionCache.set(n, !0), !0;
            if (s) return this.selectionCache.set(n, !1), !1;
        }
        return this.selectionCache.set(n, this.defaultSelection), this.defaultSelection;
    }
    isRowDeselected(e, t) {
        return !this.isRowSelected(e, t);
    }
    setRowSelected(e, t, n) {
        t ? this.setRowAsSelected(e, n) : this.setRowAsDeselected(e, n);
    }
    getGroupRowSelectionState(e) {
        let t = this.selectionCache.get(e);
        if (t !== void 0) return t;
        let { selectedCount: n, deselectedCount: r } = this.getSelectionCountFor(e, this.onlyUsePrimaryKeys ? void 0 : this.getGroupRowBooleanSelectionStateFromParent(e)), i = n && r ? null : !!n;
        return this.selectionCache.set(e, i), i;
    }
    getGroupRowBooleanSelectionStateFromParent(e) {
        if (!e.length) return this.defaultSelection;
        let t = [
            ...e
        ], n = this.deselectedMap.has(t), r = this.selectedMap.has(t), i = r && !n ? !0 : n && !r ? !1 : void 0;
        if (i === void 0) for(; t.length;){
            if (t.pop(), this.deselectedMap.has(t)) {
                i = !1;
                break;
            }
            if (this.selectedMap.has(t)) {
                i = !0;
                break;
            }
        }
        return i === void 0 && (i = this.defaultSelection), i;
    }
    isGroupRowPartlySelected(e) {
        return this.getGroupRowSelectionState(e) === null;
    }
    isGroupRowSelected(e) {
        return this.getGroupRowSelectionState(e) === !0;
    }
    isGroupRowDeselected(e) {
        return this.getGroupRowSelectionState(e) === !1;
    }
    selectGroupRow(e) {
        if (this.onlyUsePrimaryKeys) {
            this.getAllPrimaryKeysInsideGroup(e).forEach((i)=>{
                this.defaultSelection === !0 ? this.deselectedMap.delete([
                    i
                ]) : this._selectedMapSet(i);
            }), this.xcache();
            return;
        }
        this.selectedMap.getKeysStartingWith(e, {
            excludeSelf: !0
        }).forEach((r)=>{
            this.selectedMap.delete(r);
        }), e.length === 1 && this.defaultSelection === !0 || this._selectedMapSet(e), this.deselectedMap.getKeysStartingWith(e).forEach((r)=>{
            this.deselectedMap.delete(r);
        });
    }
    deselectGroupRow(e) {
        if (this.onlyUsePrimaryKeys) {
            this.getAllPrimaryKeysInsideGroup(e).forEach((i)=>{
                this.defaultSelection === !1 ? this.selectedMap.delete([
                    i
                ]) : this._deselectedMapSet(i);
            }), this.xcache();
            return;
        }
        this.deselectedMap.getKeysStartingWith(e, {
            excludeSelf: !0
        }).forEach((r)=>{
            this.deselectedMap.delete(r);
        }), e.length === 1 && this.defaultSelection === !1 || this._deselectedMapSet(e), this.selectedMap.getKeysStartingWith(e).forEach((r)=>{
            this.selectedMap.delete(r);
        });
    }
    setRowAsSelected(e, t) {
        if (this.onlyUsePrimaryKeys) {
            this.defaultSelection ? this.deselectedMap.delete([
                e
            ]) : this._selectedMapSet(e), this.xcache();
            return;
        }
        t = t || this.getGroupKeysForPrimaryKey(e);
        let n = [
            ...t,
            e
        ];
        this.deselectedMap.delete(n), this.xcache(), this.getGroupRowSelectionState(t) !== !0 && (this._selectedMapSet(n), this.getGroupRowSelectionState(t) === !0 && this.selectGroupRow(t));
    }
    setRowAsDeselected(e, t) {
        if (this.onlyUsePrimaryKeys) {
            this.defaultSelection ? this._deselectedMapSet(e) : this.selectedMap.delete([
                e
            ]), this.xcache();
            return;
        }
        t = t || this.getGroupKeysForPrimaryKey(e);
        let n = [
            ...t,
            e
        ];
        this.selectedMap.delete(n), this.xcache(), this.getGroupRowSelectionState(t) !== !1 && (this._deselectedMapSet(n), this.getGroupRowSelectionState(t) === !1 && this.deselectGroupRow(t));
    }
    deselectRow(e, t) {
        this.setRowSelected(e, !1, t);
    }
    selectRow(e, t) {
        this.setRowSelected(e, !0, t);
    }
    toggleGroupRowSelection(e) {
        this.getGroupRowSelectionState(e) === !0 ? this.deselectGroupRow(e) : this.selectGroupRow(e);
    }
    toggleRowSelection(e, t) {
        this.isRowSelected(e, t) ? this.deselectRow(e, t) : this.selectRow(e, t);
    }
    getSelectedCount() {
        return this.getSelectionCountFor([]).selectedCount;
    }
    getDeselectedCount() {
        return this.getSelectionCountFor([]).deselectedCount;
    }
    getSelectionCountFor(e = [], t) {
        let n = this.selectionCountCache.get(e);
        if (n != null) return n;
        let r = this.getGroupByLength();
        if (e.length > r) {
            let c = this.isRowSelected(e) ? {
                selectedCount: 1,
                deselectedCount: 0
            } : {
                selectedCount: 0,
                deselectedCount: 1
            };
            return this.selectionCountCache.set(e, c), c;
        }
        if (r && this.onlyUsePrimaryKeys) {
            let c = this.getAllPrimaryKeysInsideGroup(e), u = 0, d = 0;
            c.forEach((p)=>{
                if (this.defaultSelection) {
                    if (this.deselectedMap.has([
                        p
                    ])) {
                        d++;
                        return;
                    }
                    u++;
                } else {
                    if (this.selectedMap.has([
                        p
                    ])) {
                        u++;
                        return;
                    }
                    d++;
                }
            });
            let f = {
                selectedCount: u,
                deselectedCount: d
            };
            return this.selectionCountCache.set(e, f), f;
        }
        t = t ?? this.getGroupRowBooleanSelectionStateFromParent(e);
        let i = this.getGroupKeysDirectlyInsideGroup(e);
        if (e.length === this.getGroupByLength()) {
            let c = this.selectedMap.has(e) ? !0 : this.deselectedMap.has(e) ? !1 : t, u = this.getGroupCount(e), d = this.selectedMap.getKeysStartingWith(e, {
                excludeSelf: !0,
                depthLimit: 1
            }).length, f = this.deselectedMap.getKeysStartingWith(e, {
                excludeSelf: !0,
                depthLimit: 1
            }).length, p = u - (d + f), m = {
                selectedCount: d + (c ? p : 0),
                deselectedCount: f + (c ? 0 : p)
            };
            return this.selectionCountCache.set(e, m), m;
        }
        let a = 0, l = 0;
        if (this.getConfig().lazyLoad && !i.length) {
            let c = this.getConfig().groupDeepMap?.get(e)?.totalChildrenCount || 0;
            t ? (a = c, l = this.deselectedMap.getAllChildrenSizeFor(e), l === c && (a = 0)) : (l = c, a = this.selectedMap.getAllChildrenSizeFor(e), a === c && (l = 0));
        }
        i.forEach((c)=>{
            let u = this.selectedMap.get(c), d = this.deselectedMap.get(c), f = u ? !0 : d ? !1 : t, { selectedCount: p, deselectedCount: m } = this.getSelectionCountFor(c, f);
            a += p, l += m;
        });
        let s = {
            selectedCount: a,
            deselectedCount: l
        };
        return this.selectionCountCache.set(e, s), s;
    }
};
var $88ab1a78ec8ca4b4$var$KT = "*", $88ab1a78ec8ca4b4$export$31e3cce2e16ab248 = class {
    constructor(e){
        this.wildcard = $88ab1a78ec8ca4b4$var$KT;
        this.cache = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.selectedRowsToColumns = new Map;
        this.selectedColumnsToRows = new Map;
        this.deselectedRowsToColumns = new Map;
        this.deselectedColumnsToRows = new Map;
        this.defaultSelection = !1;
        this.debugId = "";
        this.deselectAll = ()=>{
            this.update({
                defaultSelection: !1,
                selectedCells: []
            });
        };
        this.selectAll = ()=>{
            this.update({
                defaultSelection: !0,
                deselectedCells: []
            });
        };
        let t = e && e instanceof Object.getPrototypeOf(this).constructor ? e.getState() : e;
        t && this.update(t);
    }
    selectCell(e, t) {
        this.setCellSelected(e, t, !0);
    }
    deselectCell(e, t) {
        this.setCellSelected(e, t, !1);
    }
    selectColumn(e) {
        this.setCellSelected(this.wildcard, e, !0);
    }
    deselectColumn(e) {
        this.setCellSelected(this.wildcard, e, !1);
    }
    setCellSelected(e, t, n) {
        let r = e === this.wildcard, i = t === this.wildcard;
        if (this.isCellSelected_Internal(e, t) === n) return;
        let l = [];
        if (r) {
            let c = this.deselectedColumnsToRows.get(t), u = this.selectedColumnsToRows.get(t);
            c?.forEach((d)=>{
                d !== this.wildcard && this.setCellInDeselection(d, t, !1);
            }), u?.forEach((d)=>{
                d !== this.wildcard && this.setCellInSelection(d, t, !1);
            }), [
                ...this.cache.keys()
            ].forEach((d)=>{
                let [f, p] = d;
                p === t && l.push([
                    f,
                    t
                ]);
            });
        }
        if (i) {
            let c = this.deselectedRowsToColumns.get(t), u = this.selectedRowsToColumns.get(t);
            c?.forEach((d)=>{
                d !== this.wildcard && this.setCellInDeselection(e, d, !1);
            }), u?.forEach((d)=>{
                d !== this.wildcard && this.setCellInSelection(e, d, !1);
            }), [
                ...this.cache.keys()
            ].forEach((d)=>{
                let [f] = d;
                f === e && l.push([
                    e,
                    t
                ]);
            });
        }
        let s = [
            e,
            t
        ];
        if (l.forEach((c)=>{
            this.cache.delete(c);
        }), this.cache.delete(s), n) {
            if (this.defaultSelection) {
                let c = this.deselectedRowsToColumns.get(e);
                c && c.has(t) && this.setCellInDeselection(e, t, !1);
                let u = this.deselectedRowsToColumns.get(this.wildcard), d = this.deselectedColumnsToRows.get(this.wildcard);
                (u?.has(t) || d?.has(e)) && this.setCellInSelection(e, t, !0);
            } else {
                let c = this.deselectedRowsToColumns.get(e);
                c && c.has(t) && this.setCellInDeselection(e, t, !1), this.setCellInSelection(e, t, !0);
            }
        } else if (this.defaultSelection) this.selectedRowsToColumns.get(e)?.has(t) && this.setCellInSelection(e, t, !1), this.setCellInDeselection(e, t, !0);
        else {
            this.selectedRowsToColumns.get(e)?.has(t) && this.setCellInSelection(e, t, !1);
            let u = this.selectedRowsToColumns.get(this.wildcard), d = this.selectedColumnsToRows.get(this.wildcard);
            if (u?.has(t) || d?.has(e)) {
                this.setCellInDeselection(e, t, !0);
                return;
            }
        }
    }
    setCellInDeselection(e, t, n) {
        if (n) {
            let r = this.deselectedRowsToColumns.get(e) || new Set;
            r.add(t), this.deselectedRowsToColumns.set(e, r);
        } else {
            let r = this.deselectedRowsToColumns.get(e);
            r && (r.delete(t), r.size === 0 && this.deselectedRowsToColumns.delete(e));
        }
        if (n) {
            let r = this.deselectedColumnsToRows.get(t) || new Set;
            r.add(e), this.deselectedColumnsToRows.set(t, r);
        } else {
            let r = this.deselectedColumnsToRows.get(t);
            r && (r.delete(e), r.size === 0 && this.deselectedColumnsToRows.delete(t));
        }
    }
    setCellInSelection(e, t, n) {
        if (e === this.wildcard && t === this.wildcard) throw new Error("rowId and colId cannot be used as a wildcard at the same time!");
        if (n) {
            let r = this.selectedRowsToColumns.get(e) || new Set;
            r.add(t), this.selectedRowsToColumns.set(e, r);
        } else {
            let r = this.selectedRowsToColumns.get(e);
            r && (r.delete(t), r.size === 0 && this.selectedRowsToColumns.delete(e));
        }
        if (n) {
            let r = this.selectedColumnsToRows.get(t) || new Set;
            r.add(e), this.selectedColumnsToRows.set(t, r);
        } else {
            let r = this.selectedColumnsToRows.get(t);
            r && (r.delete(e), r.size === 0 && this.selectedColumnsToRows.delete(t));
        }
    }
    update(e) {
        let t = e.selectedCells || null, n = e.deselectedCells || null;
        this.selectedRowsToColumns.clear(), this.selectedColumnsToRows.clear(), this.deselectedRowsToColumns.clear(), this.deselectedColumnsToRows.clear(), this.cache.clear(), t && t.forEach(([r, i])=>{
            this.setCellInSelection(r, i, !0);
        }), n && n.forEach(([r, i])=>{
            this.setCellInDeselection(r, i, !0);
        }), this.defaultSelection = e.defaultSelection;
    }
    isCellSelectionInRow(e, t) {
        if (this.defaultSelection) {
            let r = this.deselectedRowsToColumns.get(e);
            if (r) {
                if (r.has(this.wildcard)) {
                    let i = this.selectedRowsToColumns.get(e);
                    return i && i.size > 0 ? t.some((a)=>i.has(a)) : !1;
                }
                return t.some((i)=>!r.has(i));
            }
            return !0;
        }
        let n = this.selectedRowsToColumns.get(e);
        if (n) {
            if (n.has(this.wildcard)) {
                let r = this.deselectedRowsToColumns.get(e);
                return r && r.size > 0 ? !t.every((a)=>r.has(a)) : !0;
            }
            return t ? t.some((r)=>n.has(r)) : !1;
        }
        return !1;
    }
    error(e) {
        $88ab1a78ec8ca4b4$var$on(`${this.debugId}:CellSelectionState`)(e);
    }
    isCellSelected(e, t) {
        return e === this.wildcard || t === this.wildcard ? (this.error("CellSelectionState.isCellSelected should not be called with wildcard"), !1) : this.isCellSelected_Internal(e, t);
    }
    isCellSelected_Internal(e, t) {
        let n = [
            e,
            t
        ], { cache: r } = this, i = r.get(n);
        if (i != null) return i;
        let a = ()=>(r.set(n, !1), !1), l = ()=>(r.set(n, !0), !0), s = this.deselectedColumnsToRows.get(this.wildcard), c = this.deselectedRowsToColumns.get(this.wildcard), u = this.selectedColumnsToRows.get(this.wildcard), d = this.selectedRowsToColumns.get(this.wildcard);
        if (this.defaultSelection) {
            let m = this.deselectedRowsToColumns.get(e);
            return m && m.has(t) ? a() : s?.has(e) || c?.has(t) ? this.selectedRowsToColumns.get(e)?.has(t) ? l() : a() : l();
        }
        let p = this.selectedRowsToColumns.get(e);
        return p && p.has(t) ? l() : u?.has(e) || d?.has(t) ? this.deselectedRowsToColumns.get(e)?.has(t) ? a() : l() : a();
    }
    getState() {
        let e = [], t = [];
        return this.deselectedRowsToColumns.forEach((n, r)=>{
            n.forEach((i)=>{
                e.push([
                    r,
                    i
                ]);
            });
        }), this.selectedRowsToColumns.forEach((n, r)=>{
            n.forEach((i)=>{
                t.push([
                    r,
                    i
                ]);
            });
        }), {
            defaultSelection: this.defaultSelection,
            deselectedCells: e,
            selectedCells: t
        };
    }
};
var $88ab1a78ec8ca4b4$var$BT = $88ab1a78ec8ca4b4$export$1c9f709888824e05("IT:InfiniteTable"), $88ab1a78ec8ca4b4$var$WT = "#dc3545", $88ab1a78ec8ca4b4$var$jT = "#eb9316";
var $88ab1a78ec8ca4b4$var$ep = "Warn", $88ab1a78ec8ca4b4$var$tp = "Error", $88ab1a78ec8ca4b4$var$$T = "Info", $88ab1a78ec8ca4b4$var$UT = "Success", $88ab1a78ec8ca4b4$var$YT = "Logs", $88ab1a78ec8ca4b4$var$Pi = $88ab1a78ec8ca4b4$var$BT.extend($88ab1a78ec8ca4b4$var$YT), $88ab1a78ec8ca4b4$var$RF = $88ab1a78ec8ca4b4$var$Pi.extend($88ab1a78ec8ca4b4$var$$T), $88ab1a78ec8ca4b4$var$qT = $88ab1a78ec8ca4b4$var$Pi.extend($88ab1a78ec8ca4b4$var$ep), $88ab1a78ec8ca4b4$var$XT = $88ab1a78ec8ca4b4$var$Pi.extend($88ab1a78ec8ca4b4$var$tp), $88ab1a78ec8ca4b4$var$xF = $88ab1a78ec8ca4b4$var$Pi.extend($88ab1a78ec8ca4b4$var$UT);
var $88ab1a78ec8ca4b4$var$ZT = $88ab1a78ec8ca4b4$var$jT, $88ab1a78ec8ca4b4$var$QT = $88ab1a78ec8ca4b4$var$WT;
var $88ab1a78ec8ca4b4$var$JT = (o, e)=>{
    e = e ? e.extend ? e.extend($88ab1a78ec8ca4b4$var$ep) : e : $88ab1a78ec8ca4b4$var$qT, e(typeof e.color == "function" ? e.color($88ab1a78ec8ca4b4$var$ZT, o) : o);
}, $88ab1a78ec8ca4b4$var$eS = (o, e)=>{
    e = e ? e.extend ? e.extend($88ab1a78ec8ca4b4$var$tp) : e : $88ab1a78ec8ca4b4$var$XT, e(typeof e.color == "function" ? e.color($88ab1a78ec8ca4b4$var$QT, o) : o);
};
var $88ab1a78ec8ca4b4$var$Jf = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00, $88ab1a78ec8ca4b4$var$np = (o, ...e)=>{
    $88ab1a78ec8ca4b4$var$Jf.has(e) || ($88ab1a78ec8ca4b4$var$Jf.set(e, !0), o());
};
var $88ab1a78ec8ca4b4$var$ho = (o, e = o, t)=>{
    $88ab1a78ec8ca4b4$var$np(()=>$88ab1a78ec8ca4b4$var$JT(o, t), e, "warn");
}, $88ab1a78ec8ca4b4$var$op = (o, e = o, t)=>{
    $88ab1a78ec8ca4b4$var$np(()=>$88ab1a78ec8ca4b4$var$eS(o, t), e, "error");
};
function $88ab1a78ec8ca4b4$var$Di(o, e) {
    return new $88ab1a78ec8ca4b4$export$fdba2ac35241013c(o, $88ab1a78ec8ca4b4$var$at(e));
}
function $88ab1a78ec8ca4b4$var$at(o) {
    return ()=>{
        let e = typeof o == "function" ? o() : o;
        return {
            lazyLoad: !!e.lazyLoad,
            toPrimaryKey: e.toPrimaryKey,
            onlyUsePrimaryKeys: !e.useGroupKeysForMultiRowSelection,
            groupBy: e.groupBy,
            groupDeepMap: e.groupDeepMap,
            indexer: e.indexer,
            totalCount: e.unfilteredCount
        };
    };
}
function $88ab1a78ec8ca4b4$var$rp(o) {
    let { getDataSourceState: e, dataSourceActions: t } = o;
    return {
        get allRowsSelected () {
            return e().allRowsSelected;
        },
        selectAll () {
            let { rowSelection: r, selectionMode: i } = e();
            if (i !== "multi-row") throw "Selection mode is not multi-row";
            if (!(r instanceof $88ab1a78ec8ca4b4$export$fdba2ac35241013c)) throw "Invalid row selection";
            let a = new $88ab1a78ec8ca4b4$export$fdba2ac35241013c(r, $88ab1a78ec8ca4b4$var$at(e));
            a.selectAll(), t.rowSelection = a;
        },
        deselectAll () {
            let { rowSelection: r, selectionMode: i } = e();
            if (i !== "multi-row") throw "Selection mode is not multi-row";
            if (!(r instanceof $88ab1a78ec8ca4b4$export$fdba2ac35241013c)) throw "Invalid row selection";
            let a = new $88ab1a78ec8ca4b4$export$fdba2ac35241013c(r, $88ab1a78ec8ca4b4$var$at(e));
            a.deselectAll(), t.rowSelection = a;
        },
        isRowSelected (r, i) {
            let { rowSelection: a, selectionMode: l, indexer: s, groupBy: c } = e();
            if (l === "single-row") return a === r;
            if (l !== "multi-row") throw "Selection mode is not multi-row or single-row";
            if (!(a instanceof $88ab1a78ec8ca4b4$export$fdba2ac35241013c)) throw "Invalid row selection";
            if (!i) {
                let u = s.getDataForPrimaryKey(r);
                i = u ? $88ab1a78ec8ca4b4$var$go(u, c) : [];
            }
            return a.isRowSelected(r, i);
        },
        isRowDeselected (r, i) {
            return !this.isRowSelected(r, i);
        },
        selectRow (r, i) {
            let { rowSelection: a, selectionMode: l, indexer: s, groupBy: c } = e();
            if (l === "single-row") {
                t.rowSelection = r;
                return;
            }
            if (l !== "multi-row") throw "Selection mode is not multi-row or single-row";
            if (!(a instanceof $88ab1a78ec8ca4b4$export$fdba2ac35241013c)) throw "Invalid row selection";
            if (!i) {
                let d = s.getDataForPrimaryKey(r);
                i = d ? $88ab1a78ec8ca4b4$var$go(d, c) : [];
            }
            let u = new $88ab1a78ec8ca4b4$export$fdba2ac35241013c(a, $88ab1a78ec8ca4b4$var$at(e));
            u.selectRow(r, i), t.rowSelection = u;
        },
        deselectRow (r, i) {
            let { selectionMode: a, rowSelection: l, indexer: s, groupBy: c } = e();
            if (a === "single-row") {
                t.rowSelection = null;
                return;
            }
            if (a !== "multi-row") throw "Selection mode is not multi-row or single-row";
            if (!(l instanceof $88ab1a78ec8ca4b4$export$fdba2ac35241013c)) throw "Invalid row selection";
            if (a === "multi-row") {
                if (!i) {
                    let d = s.getDataForPrimaryKey(r);
                    i = d ? $88ab1a78ec8ca4b4$var$go(d, c) : [];
                }
                let u = new $88ab1a78ec8ca4b4$export$fdba2ac35241013c(l, $88ab1a78ec8ca4b4$var$at(e));
                u.deselectRow(r, i), t.rowSelection = u;
            }
        },
        toggleRowSelection (r, i) {
            this.isRowSelected(r, i) ? this.deselectRow(r, i) : this.selectRow(r, i);
        },
        selectGroupRow (r) {
            let { selectionMode: i, rowSelection: a, groupBy: l } = e();
            if (i !== "multi-row") throw 'Selection mode should be "multi-row"';
            if (!l) throw "No grouping specified";
            if (!(a instanceof $88ab1a78ec8ca4b4$export$fdba2ac35241013c)) throw "Invalid row selection";
            let s = new $88ab1a78ec8ca4b4$export$fdba2ac35241013c(a, $88ab1a78ec8ca4b4$var$at(e));
            s.selectGroupRow(r), t.rowSelection = s;
        },
        deselectGroupRow (r) {
            let { selectionMode: i, rowSelection: a, groupBy: l } = e();
            if (i !== "multi-row") throw 'Selection mode should be "multi-row"';
            if (!l) throw "No grouping specified";
            if (!(a instanceof $88ab1a78ec8ca4b4$export$fdba2ac35241013c)) throw "Invalid row selection";
            let s = new $88ab1a78ec8ca4b4$export$fdba2ac35241013c(a, $88ab1a78ec8ca4b4$var$at(e));
            s.deselectGroupRow(r), t.rowSelection = s;
        },
        toggleGroupRowSelection (r) {
            let { selectionMode: i, rowSelection: a, groupBy: l } = e();
            if (i !== "multi-row") throw 'Selection mode should be "multi-row"';
            if (!l) throw "No grouping specified";
            if (!(a instanceof $88ab1a78ec8ca4b4$export$fdba2ac35241013c)) throw "Invalid row selection";
            let s = new $88ab1a78ec8ca4b4$export$fdba2ac35241013c(a, $88ab1a78ec8ca4b4$var$at(e));
            s.toggleGroupRowSelection(r), t.rowSelection = s;
        },
        getGroupRowSelectionState (r, i) {
            let a = e(), { selectionMode: l, groupBy: s } = a, c = i ? new $88ab1a78ec8ca4b4$export$fdba2ac35241013c(i, $88ab1a78ec8ca4b4$var$at(a)) : a.rowSelection;
            if (l !== "multi-row") throw 'Selection mode should be "multi-row"';
            if (!s) throw "No grouping specified";
            if (!(c instanceof $88ab1a78ec8ca4b4$export$fdba2ac35241013c)) throw "Invalid row selection";
            return c.getGroupRowSelectionState(r);
        },
        getSelectedPrimaryKeys: (r)=>{
            let i = e(), a = r ? new $88ab1a78ec8ca4b4$export$fdba2ac35241013c(r, $88ab1a78ec8ca4b4$var$at(i)) : i.rowSelection, l = [];
            return i.lazyLoad && console.error("getSelectedPrimaryKeys should not be called for lazy-loaded datasources as it wont return reliable results"), i.originalDataArray.forEach((s)=>{
                let c = i.toPrimaryKey(s);
                a.isRowSelected(c) && l.push(c);
            }), l;
        }
    };
}
var $88ab1a78ec8ca4b4$var$Yl = new WeakMap, $88ab1a78ec8ca4b4$var$tS = (o)=>o;
function $88ab1a78ec8ca4b4$var$ip(o, e = 50, t) {
    $88ab1a78ec8ca4b4$var$Yl.set(o, {
        lastCallTime: 0,
        lastCallArg: null
    });
    let n = t ?? $88ab1a78ec8ca4b4$var$tS;
    return (r)=>{
        let { lastCallTime: i, lastCallArg: a } = $88ab1a78ec8ca4b4$var$Yl.get(o) || {
            lastCallTime: 0,
            lastCallArg: null
        }, l = Date.now(), s = l - i, c = $88ab1a78ec8ca4b4$var$wt(n(a), n(r));
        s < e && c || ($88ab1a78ec8ca4b4$var$Yl.set(o, {
            lastCallTime: l,
            lastCallArg: r
        }), o(r));
    };
}
var $88ab1a78ec8ca4b4$var$Mi = class {
    constructor(){
        this.primaryKeyToData = new Map;
        this.nodePathsToData = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.removeNodePath = (e, t)=>{
            if (this.nodePathsToData.delete(e), this.remove(e[e.length - 1]), !t) return;
            let n = this.nodePathsToData.get(e);
            if (n) {
                let r = t.getNodeChildren ? t.getNodeChildren(n) : t.nodesKey ? n[t.nodesKey] : null;
                if (r && Array.isArray(r)) for(let i = 0, a = r.length; i < a; i++){
                    let l = r[i], s = [
                        ...e,
                        t.toPrimaryKey(l)
                    ];
                    this.removeNodePath(s, t);
                }
            }
        };
        this.remove = (e)=>{
            this.primaryKeyToData.delete(e);
        };
        this.add = (e, t)=>{
            this.primaryKeyToData.set(e, t);
        };
        this.addNodePath = (e, t, n)=>{
            if (this.nodePathsToData.set(e, t), this.add(e[e.length - 1], t), !n) return;
            let r = n.getNodeChildren ? n.getNodeChildren(t) : n.nodesKey ? t[n.nodesKey] : null;
            if (r && Array.isArray(r)) for(let i = 0, a = r.length; i < a; i++){
                let l = r[i], s = [
                    ...e,
                    n.toPrimaryKey(l)
                ];
                this.addNodePath(s, l, n);
            }
        };
        this.clear = ()=>{
            this.primaryKeyToData.clear(), this.nodePathsToData.clear();
        };
        this.getDataForPrimaryKey = (e)=>this.primaryKeyToData.get(e);
        this.getDataForNodePath = (e)=>this.nodePathsToData.get(e);
        this.indexArray = (e, t)=>{
            let { cache: n, toPrimaryKey: r, getNodeChildren: i, isLeafNode: a, nodesKey: l } = t, s = !!i && !!a;
            n && n.shouldResetDataSource() && (this.clear(), e = []);
            let c = n && !n.isEmpty();
            if (c && (e = e.concat()), !e.length && n) {
                if (!n.isEmpty()) {
                    let u = [
                        ...n.getMutationsArray(),
                        ...n.getTreeMutationsArray()
                    ];
                    for(let d = 0, f = u.length; d < f; d++){
                        let p = u[d];
                        if (p.type === "insert") {
                            let m = r(p.data);
                            s ? this.addNodePath([
                                m
                            ], p.data, t) : this.add(m, p.data), e.push(p.data);
                        }
                    }
                    n?.removeInfo(void 0);
                }
            } else {
                let u = (d, f)=>{
                    for(let p = 0; p < d.length; p++){
                        let m = d[p];
                        c && s && Array.isArray(m[l]) && (m = d[p] = {
                            ...m
                        });
                        let g = !1;
                        if (m != null) {
                            let b = r(m), h = s ? [
                                ...f,
                                b
                            ] : void 0, y = s && !!h, S = y ? n?.getMutationsForNodePath(h) : n?.getMutationsForPrimaryKey(b);
                            if (S && S.length) {
                                for(let C = 0, T = S.length; C < T; C++){
                                    let I = S[C];
                                    if (I.type === "delete" && !g && (y ? this.removeNodePath(h, t) : this.remove(b), g = !0, d.splice(p, 1), p--), I.type === "update" && !g && (m = {
                                        ...m,
                                        ...I.data
                                    }, d[p] = m), I.type === "update-children" && !g) {
                                        let w = I.children(m[l], m);
                                        m = {
                                            ...m
                                        }, w !== void 0 ? m[l] = w : delete m[l], d[p] = m;
                                    }
                                    I.type === "insert" && (I.position === "before" ? (d.splice(p, 0, I.data), p--) : d.splice(p + 1, 0, I.data));
                                }
                                y ? n?.removeNodePathInfo(h) : n?.removeInfo(b);
                            }
                            if (!g) {
                                if (y) {
                                    this.addNodePath(h, m);
                                    let C = a(m), T = C ? null : i(m);
                                    !C && Array.isArray(T) && (f.push(b), c && (m[l] = T = T.concat()), u(T, f), f.pop());
                                } else this.add(b, m);
                            }
                        }
                    }
                };
                u(e, []);
            }
            return e;
        };
    }
};
function $88ab1a78ec8ca4b4$export$8b8dc02abb309004(o, e) {
    let t = (0, $acw62.useRef)({}), n = (0, $acw62.useRef)({}), r = n.current, i = (0, $acw62.useRef)({}), a = i.current, l = [];
    for(let s in e)e.hasOwnProperty(s) && (e[s] !== t.current[s] && (a[s] = e[s], r[s] = t.current[s]), l.push(e[s]));
    t.current = e, (0, $acw62.useEffect)(()=>{
        let s = i.current, c;
        return Object.keys(s).length !== 0 && (c = o(s, r)), i.current = {}, n.current = {}, c;
    }, l);
}
function $88ab1a78ec8ca4b4$export$5eee781003e5ebab(o, e) {
    let t = (0, $acw62.useRef)({}), n = (0, $acw62.useRef)({}), r = n.current, i = (0, $acw62.useRef)({}), a = i.current, l = [];
    for(let s in e)e.hasOwnProperty(s) && (e[s] !== t.current[s] && (a[s] = e[s], r[s] = t.current[s]), l.push(e[s]));
    t.current = e, (0, $acw62.useLayoutEffect)(()=>{
        let s = i.current, c;
        return Object.keys(s).length !== 0 && (c = o(s, r)), i.current = {}, n.current = {}, c;
    }, l);
}
function $88ab1a78ec8ca4b4$export$8c1bd23e96962b48(o, e) {
    let t = [];
    for(let n in e)e.hasOwnProperty(n) && t.push(e[n]);
    (0, $acw62.useEffect)(o, t);
}
function $88ab1a78ec8ca4b4$var$ql(...o) {
    return (...t)=>{
        o.forEach((n)=>{
            typeof n == "function" && n(...t);
        });
    };
}
function $88ab1a78ec8ca4b4$var$Xl(o) {
    let { pivotByAtIndex: e, pivotAggregator: t } = o;
    return e?.column && (typeof e.column == "function" ? Object.assign(o, e.column({
        column: o
    })) : Object.assign(o, e.column)), t?.pivotColumn && (typeof t.pivotColumn == "function" ? Object.assign(o, t.pivotColumn({
        column: o
    })) : Object.assign(o, t.pivotColumn)), o;
}
function $88ab1a78ec8ca4b4$var$Zl(o) {
    let { pivotByAtIndex: e } = o;
    return e?.columnGroup && (typeof e.columnGroup == "function" ? Object.assign(o, e.columnGroup({
        columnGroup: o
    })) : Object.assign(o, e.columnGroup)), o;
}
function $88ab1a78ec8ca4b4$var$lp({ deepMap: o, pivotBy: e, pivotTotalColumnPosition: t, pivotGrandTotalColumnPosition: n, reducers: r = {}, showSeparatePivotColumnForSingleAggregation: i = !1 }) {
    let a = e.length, l = Object.keys(r).map((p)=>({
            ...r[p],
            id: p
        }));
    l.length || (i = !0, n = !1, t = !1, l.push({
        id: "__empty-aggregation-reducer__",
        name: "-",
        initialValue: null,
        reducer: ()=>null
    }));
    let s = {}, c = {}, u = $88ab1a78ec8ca4b4$var$ot(function() {
        l.forEach((p, m)=>{
            s[`total:${p.id}`] = $88ab1a78ec8ca4b4$var$Xl({
                header: `${p.name || p.id} total`,
                pivotBy: e,
                pivotColumn: !0,
                pivotTotalColumn: !0,
                pivotAggregator: p,
                pivotAggregatorIndex: m,
                pivotGroupKeys: [],
                pivotGroupKey: "",
                pivotIndex: -1,
                valueFormatter: ({ rowInfo: g })=>g.isGroupRow ? g.reducerResults?.[p.id] : null
            });
        });
    });
    (!a && t === "start" || n === "start") && u();
    let d = !i && l.length === 1;
    return o.visitDepthFirst((p, m, g, b)=>{
        if (m = [
            ...m
        ], t === "end" && b?.(), m.length === a) {
            let h = e[m.length - 1], S = m.slice(0, -1).join("/");
            if (!d) {
                let C = S;
                S = m.join("/");
                let T = m[m.length - 1];
                c[S] = $88ab1a78ec8ca4b4$var$Zl({
                    header: `${T}`,
                    columnGroup: C,
                    pivotBy: e,
                    pivotGroupKeys: m,
                    pivotByAtIndex: h,
                    pivotIndex: m.length - 1,
                    pivotGroupKey: T
                });
            }
            l.forEach((C, T)=>{
                let I = d ? `${m[m.length - 1]}` : C.name || C.id, w = $88ab1a78ec8ca4b4$var$Xl({
                    pivotBy: e,
                    pivotColumn: !0,
                    pivotTotalColumn: !1,
                    pivotAggregator: C,
                    pivotAggregatorIndex: T,
                    pivotGroupKeys: m,
                    pivotGroupKey: m[m.length - 1],
                    pivotIndex: m.length - 1,
                    pivotByAtIndex: h,
                    defaultSortable: !1,
                    columnGroup: S,
                    header: I,
                    valueFormatter: ({ rowInfo: R })=>R.isGroupRow ? R.pivotValuesMap?.get(m)?.reducerResults[C.id] : null
                }), v = `${C.id}:${m.join("/")}`;
                s[v] = w;
            });
        } else {
            let h = m.join("/"), y = m.slice(0, -1);
            if (c[h] = $88ab1a78ec8ca4b4$var$Zl({
                columnGroup: y.length ? y.join("/") : void 0,
                header: `${m[m.length - 1]}`,
                pivotBy: e,
                pivotGroupKeys: m,
                pivotIndex: m.length - 1,
                pivotByAtIndex: e[m.length - 1],
                pivotGroupKey: m[m.length - 1]
            }), t !== !1) {
                let S = e[m.length - 1], C = y.length ? y.join("/") : void 0;
                if (!d) {
                    let T = C;
                    C = `total:${m.join("/")}`, c[C] = $88ab1a78ec8ca4b4$var$Zl({
                        header: `${m[m.length - 1]} total`,
                        columnGroup: T,
                        pivotBy: e,
                        pivotTotalColumnGroup: !0,
                        pivotGroupKeys: m,
                        pivotIndex: m.length - 1,
                        pivotByAtIndex: S,
                        pivotGroupKey: m[m.length - 1]
                    });
                }
                l.forEach((T, I)=>{
                    let w = d ? `${m[m.length - 1]} total ` : `${T.name || T.id} total`, v = $88ab1a78ec8ca4b4$var$Xl({
                        columnGroup: C,
                        header: w,
                        pivotAggregator: T,
                        pivotAggregatorIndex: I,
                        pivotColumn: !0,
                        pivotTotalColumn: !0,
                        pivotGroupKeys: m,
                        pivotGroupKey: m[m.length - 1],
                        pivotByAtIndex: S,
                        pivotIndex: m.length - 1,
                        pivotBy: e,
                        defaultSortable: !1,
                        valueFormatter: ({ rowInfo: R })=>R.isGroupRow ? R.pivotValuesMap?.get(m)?.reducerResults[T.id] : null
                    });
                    s[`total:${T.id}:${m.join("/")}`] = v;
                });
            }
        }
        (t === "start" || t === !1) && b?.();
    }), (!a && t === "end" || n === "end") && u(), {
        columns: s,
        columnGroups: c
    };
}
var $88ab1a78ec8ca4b4$var$sp = Symbol("CLEAR"), $88ab1a78ec8ca4b4$var$Kn = class o {
    constructor(e){
        this.affectedFields = new Set;
        this.allFieldsAffected = !1;
        this.primaryKeyToData = new Map;
        this.nodePathToData = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.getAffectedFields = ()=>this.allFieldsAffected ? !0 : this.affectedFields;
        this.delete = (e, t, n)=>{
            this.allFieldsAffected = !0;
            let r = e, i = this.primaryKeyToData.get(r) || [];
            i.push({
                type: "delete",
                primaryKey: e,
                originalData: t,
                metadata: n
            }), this.primaryKeyToData.set(r, i);
        };
        this.deleteNodePath = (e, t, n)=>{
            this.allFieldsAffected = !0;
            let r = this.nodePathToData.get(e) || [];
            r.push({
                type: "delete",
                nodePath: e,
                originalData: t,
                metadata: n
            }), this.nodePathToData.set(e, r);
        };
        this.insert = (e, t, n, r)=>{
            let i = e, a = this.primaryKeyToData.get(i) || [];
            this.allFieldsAffected = !0, a.push({
                type: "insert",
                primaryKey: e,
                data: t,
                position: n,
                originalData: null,
                metadata: r
            }), this.primaryKeyToData.set(i, a);
        };
        this.insertNodePath = (e, t, n, r)=>{
            let i = this.nodePathToData.get(e) || [];
            this.allFieldsAffected = !0, i.push({
                type: "insert",
                nodePath: e,
                data: t,
                position: n,
                originalData: null,
                metadata: r
            }), this.nodePathToData.set(e, i);
        };
        this.update = (e, t, n, r)=>{
            this.allFieldsAffected || (this.nodesKey && Array.isArray(t[this.nodesKey]) ? this.allFieldsAffected = !0 : Object.keys(t).forEach((s)=>this.affectedFields.add(s)));
            let i = e, a = this.primaryKeyToData.get(i) || [];
            a.push({
                type: "update",
                primaryKey: e,
                data: t,
                originalData: n,
                metadata: r
            }), this.primaryKeyToData.set(e, a);
        };
        this.updateNodePath = (e, t, n, r)=>{
            this.allFieldsAffected || (this.nodesKey && Array.isArray(t[this.nodesKey]) ? this.allFieldsAffected = !0 : Object.keys(t).forEach((l)=>this.affectedFields.add(l)));
            let i = this.nodePathToData.get(e) || [];
            i.push({
                type: "update",
                nodePath: e,
                data: t,
                originalData: n,
                metadata: r
            }), this.nodePathToData.set(e, i);
        };
        this.updateChildren = (e, t, n, r)=>{
            this.allFieldsAffected = !0;
            let i = this.nodePathToData.get(e) || [];
            i.push({
                type: "update-children",
                nodePath: e,
                children: t,
                originalData: n,
                metadata: r
            }), this.nodePathToData.set(e, i);
        };
        this.resetDataSource = (e)=>{
            this.clear(), this.allFieldsAffected = !0;
            let t = $88ab1a78ec8ca4b4$var$sp, n = this.primaryKeyToData.get(t) || [];
            n.push({
                type: "clear-all",
                primaryKey: void 0,
                metadata: e
            }), this.primaryKeyToData.set(t, n);
        };
        this.shouldResetDataSource = ()=>this.primaryKeyToData.has($88ab1a78ec8ca4b4$var$sp);
        this.clear = ()=>{
            this.allFieldsAffected = !1, this.affectedFields.clear(), this.primaryKeyToData.clear();
        };
        this.isEmpty = ()=>this.primaryKeyToData.size === 0 && this.nodePathToData.size === 0;
        this.removeInfo = (e)=>{
            this.primaryKeyToData.delete(e);
        };
        this.removeNodePathInfo = (e)=>{
            this.nodePathToData.delete(e);
        };
        this.getMutationsForPrimaryKey = (e)=>this.primaryKeyToData.get(e);
        this.getMutationsForNodePath = (e)=>this.nodePathToData.get(e);
        this.getMutationsCount = ()=>this.primaryKeyToData.size;
        this.getMutations = ()=>new Map(this.primaryKeyToData);
        this.getTreeMutations = ()=>$88ab1a78ec8ca4b4$export$1c737028a0cb2e00.clone(this.nodePathToData);
        this.getMutationsArray = ()=>Array.from(this.primaryKeyToData.values()).flat();
        this.getTreeMutationsArray = ()=>Array.from(this.nodePathToData.values()).flat();
        this.nodesKey = e.nodesKey;
    }
    static clone(e, { light: t = !1 } = {}) {
        let n = new o({
            nodesKey: e.nodesKey
        });
        return n.allFieldsAffected = e.allFieldsAffected, n.affectedFields = new Set(e.affectedFields), n.primaryKeyToData = t ? e.primaryKeyToData : new Map(e.primaryKeyToData), n.nodePathToData = t ? e.nodePathToData : $88ab1a78ec8ca4b4$export$1c737028a0cb2e00.clone(e.nodePathToData), n;
    }
};
function $88ab1a78ec8ca4b4$var$Tn(o, e) {
    return e().dataArray[o];
}
function $88ab1a78ec8ca4b4$var$Ei(o) {
    return o().dataArray;
}
var $88ab1a78ec8ca4b4$export$bb181fe227550f9d = class {
    constructor(e){
        this.collapsedPathsMap = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.expandedPathsMap = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.collapsedIdsMap = new Map;
        this.expandedIdsMap = new Map;
        this._mode = "path";
        this.defaultExpanded = !1;
        this.expandAll = ()=>{
            this.update({
                defaultExpanded: !0,
                collapsedPaths: []
            });
        };
        this.collapseAll = ()=>{
            this.update({
                defaultExpanded: !1,
                expandedPaths: []
            });
        };
        let t = e && e instanceof Object.getPrototypeOf(this).constructor ? e.getState() : e;
        t && this.update(t);
    }
    get mode() {
        return this._mode;
    }
    reset() {
        this.collapsedPathsMap.clear(), this.expandedPathsMap.clear(), this.collapsedIdsMap.clear(), this.expandedIdsMap.clear();
    }
    destroy() {
        this.reset();
    }
    expandNode(e) {
        this.setNodeExpanded(e, !0);
    }
    collapseNode(e) {
        this.setNodeExpanded(e, !1);
    }
    setNodeExpanded(e, t) {
        let { collapsedPathsMap: n, collapsedIdsMap: r, expandedPathsMap: i, expandedIdsMap: a, defaultExpanded: l, _mode: s } = this;
        s === "id" && Array.isArray(e) && (e = e[e.length - 1]), t === l ? t ? s === "path" && Array.isArray(e) ? n.delete(e) : r.delete(e) : s === "path" && Array.isArray(e) ? i.delete(e) : a.delete(e) : t ? s === "path" && Array.isArray(e) ? i.set(e, !0) : a.set(e, !0) : s === "path" && Array.isArray(e) ? n.set(e, !0) : r.set(e, !0);
    }
    isNodeExpandedByPath(e) {
        return this.isNodeExpanded(e);
    }
    isNodeExpandedById(e) {
        return this.isNodeExpanded(e);
    }
    isNodeExpanded(e) {
        if (this._mode === "id" && Array.isArray(e) && (e = e[e.length - 1]), this._mode === "id" && Array.isArray(e)) throw `You try to check if a node is expanded by id (${e}) but your TreeExpandState is configured to use node paths.`;
        if (this._mode === "path" && !Array.isArray(e)) throw `You try to check if a node is expanded by path (${e}) but your TreeExpandState is configured to use node ids.`;
        return this.defaultExpanded ? this._mode === "path" && Array.isArray(e) ? !this.collapsedPathsMap.has(e) : !this.collapsedIdsMap.has(e) : this._mode === "path" && Array.isArray(e) ? this.expandedPathsMap.has(e) : this.expandedIdsMap.has(e);
    }
    update(e) {
        if (this.defaultExpanded = e.defaultExpanded, this.reset(), e.expandedPaths || e.collapsedPaths) {
            this._mode = "path";
            let r = e.expandedPaths || null, i = e.collapsedPaths || null;
            if (r) for(let a = 0, l = r.length; a < l; a++)this.expandedPathsMap.set(r[a], !0);
            if (i) for(let a = 0, l = i.length; a < l; a++)this.collapsedPathsMap.set(i[a], !0);
            return;
        }
        this._mode = "id";
        let t = e.expandedIds || null, n = e.collapsedIds || null;
        if (t) for(let r = 0, i = t.length; r < i; r++)this.expandedIdsMap.set(t[r], !0);
        if (n) for(let r = 0, i = n.length; r < i; r++)this.collapsedIdsMap.set(n[r], !0);
    }
    getState() {
        if (this._mode === "path") {
            let n = Array.from(this.collapsedPathsMap.keys()), r = Array.from(this.expandedPathsMap.keys());
            return {
                defaultExpanded: this.defaultExpanded,
                collapsedPaths: n,
                expandedPaths: r
            };
        }
        let e = Array.from(this.collapsedIdsMap.keys()), t = Array.from(this.expandedIdsMap.keys());
        return {
            defaultExpanded: this.defaultExpanded,
            collapsedIds: e,
            expandedIds: t
        };
    }
};
var $88ab1a78ec8ca4b4$var$oS = (o, e)=>o.length - e.length, $88ab1a78ec8ca4b4$export$3feed6aa923fae79 = class o {
    constructor(e, t){
        this.selectedPaths = null;
        this.deselectedPaths = null;
        this.defaultSelection = !1;
        this.selectionMap = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.cache = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.strictMode = !1;
        let n = e instanceof Object.getPrototypeOf(this).constructor, r = n ? e.getState() : e;
        this.setConfig(t || (n ? e.config : {
            treePaths: new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00
        })), this.disableStrictMode(), this.update(r), this.config.strictCheckPaths && this.enableStrictMode();
    }
    getTreePaths(e) {
        return e ? Array.isArray(e) ? new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00(e.map((t)=>[
                t,
                !0
            ])) : e : this.config.treePaths;
    }
    withTreePaths(e, t) {
        let n = this.config.treePaths;
        t = this.getTreePaths(t);
        let r = t !== n;
        r && this.xcache(), this.config.treePaths = t;
        let i = e(t);
        return this.config.treePaths = n, r && this.xcache(), i;
    }
    getLeafNodePaths(e = [], t) {
        return this.withTreePaths((n)=>n.getKeysForLeafNodesStartingWith(e), t);
    }
    forEachLeafNodePath(e, t = [], n) {
        let r = {
            selected: !1
        };
        this.withTreePaths((i)=>{
            i.getLeafNodesStartingWith(t, (a)=>{
                r.selected = this.isNodeSelected(a.keys) === !0, e(a.keys, r);
            });
        }, n);
    }
    getSelectedLeafNodePaths(e = [], t) {
        let n = [];
        return this.withTreePaths((r)=>{
            r.getLeafNodesStartingWith(e, (i)=>{
                this.isNodeSelected(i.keys) && n.push(i.keys);
            });
        }, t), n;
    }
    getDeselectedLeafNodePaths(e = [], t) {
        let n = [];
        return this.withTreePaths((r)=>{
            r.getLeafNodesStartingWith(e, (i)=>{
                this.isNodeSelected(i.keys) || n.push(i.keys);
            });
        }, t), n;
    }
    isLeafNode(e) {
        let { treePaths: t } = this.config;
        return t.has(e) ? t.getKeysForLeafNodesStartingWith(e).length === 1 : null;
    }
    getLeafNodesCount(e) {
        return this.config.treePaths.getKeysForLeafNodesStartingWith(e).length;
    }
    static from(e, t) {
        return new o(e, t);
    }
    setConfig(e) {
        let t = typeof e == "function" ? e() : e;
        this.config = {
            treePaths: Array.isArray(t.treePaths) ? new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00(t.treePaths.map((n)=>[
                    n,
                    !0
                ])) : t.treePaths,
            strictCheckPaths: t.strictCheckPaths ?? !0
        }, this.xcache();
    }
    xcache() {
        this.cache.clear();
    }
    update(e) {
        this.selectedPaths = e.selectedPaths || null, this.deselectedPaths = e.deselectedPaths || null;
        let { selectionMap: t, selectedPaths: n, deselectedPaths: r } = this;
        t.clear(), n?.forEach((i)=>this.setSelectionForPath(i, !0)), r?.forEach((i)=>this.setSelectionForPath(i, !1)), this.defaultSelection = e.defaultSelection, this.xcache();
    }
    setSelectionForPath(e, t) {
        this.isPathAvailable(e) && this.selectionMap.set(e, t);
    }
    getState() {
        let e = [], t = [];
        return this.selectionMap.topDownEntries().forEach(([n, r])=>{
            r ? e.push(n) : t.push(n);
        }), {
            defaultSelection: this.defaultSelection,
            selectedPaths: e,
            deselectedPaths: t
        };
    }
    deselectAll() {
        this.update({
            defaultSelection: !1,
            selectedPaths: [],
            deselectedPaths: []
        });
    }
    selectAll() {
        this.update({
            defaultSelection: !0,
            deselectedPaths: [],
            selectedPaths: []
        });
    }
    enableStrictMode() {
        this.strictMode = !0;
    }
    disableStrictMode() {
        this.strictMode = !1;
    }
    isPathAvailable(e) {
        if (!this.strictMode) return !0;
        let { treePaths: t } = this.config;
        return t.has(e);
    }
    isNodeSelected(e) {
        return this.isPathSelected(e);
    }
    isSelfSelected(e) {
        return this.selectionMap.get(e) ?? null;
    }
    cacheIt(e, t) {
        return this.cache.set(e, t), t;
    }
    getSelectionStateForNode(e, t) {
        let n = this.cache.get(e);
        if (n) return n;
        if (this.isLeafNode(e) !== !1) {
            let d = this.isSelfSelected(e);
            if (d !== null) return this.cacheIt(e, {
                selected: d,
                selectedCount: d ? 1 : 0,
                deselectedCount: d ? 0 : 1,
                leafCount: 1
            });
        }
        let r = this.getLeafNodesCount(e), i = this.isSelfSelected(e), { selectionMap: a } = this, l = a.getKeysOfFirstChildOnEachBranchStartingWith(e, {
            excludeSelf: !0
        }).sort($88ab1a78ec8ca4b4$var$oS);
        if (this.strictMode && (l = l.filter((d)=>this.isPathAvailable(d))), !l.length) {
            if (i !== null) {
                let f = r ? i : !1;
                return this.cacheIt(e, {
                    selected: f,
                    selectedCount: f ? r : 0,
                    deselectedCount: f ? 0 : r,
                    leafCount: r
                });
            }
            let d = this.getNodeBooleanSelectionStateFromParent(e);
            return this.cacheIt(e, {
                selected: d,
                selectedCount: d ? r : 0,
                deselectedCount: d ? 0 : r,
                leafCount: r
            });
        }
        let s = 0, c = 0, u = this.getNodeBooleanSelectionStateFromParent(e);
        u ? s += r : c += r;
        for(let d = 0, f = l.length; d < f; d++){
            let p = l[d], { selectedCount: m, deselectedCount: g } = this.getSelectionStateForNode(p);
            if (u ? (s -= g, c += g) : (c -= m, s += m), t && m > 0 && g > 0) return this.cacheIt(e, {
                selected: null,
                leafCount: r,
                selectedCount: s,
                deselectedCount: c
            });
        }
        if (!s && !c) return this.cacheIt(e, {
            selected: u,
            selectedCount: u ? r : 0,
            deselectedCount: u ? 0 : r,
            leafCount: r
        });
        if (s) {
            let d = s === r ? !0 : null;
            return this.cacheIt(e, {
                selected: d,
                selectedCount: s,
                deselectedCount: c,
                leafCount: r
            });
        }
        return this.cacheIt(e, {
            selected: !1,
            selectedCount: 0,
            deselectedCount: r,
            leafCount: r
        });
    }
    isPathSelected(e) {
        return this.isPathAvailable(e) ? this.getSelectionStateForNode(e, !0).selected : !1;
    }
    getNodeBooleanSelectionStateFromParent(e) {
        let { defaultSelection: t, selectionMap: n } = this;
        if (!e.length) return t;
        let r = [
            ...e
        ];
        do {
            let i = n.get(r);
            if (i !== void 0) return i;
            r.pop();
        }while (r.length);
        return t;
    }
    setNodeSelection(e, t) {
        if (!e.length) return;
        if (this.xcache(), this.selectionMap.getKeysStartingWith(e).forEach((r)=>{
            this.selectionMap.delete(r);
        }), !(e.length === 1 && this.defaultSelection === t)) {
            if (this.setSelectionForPath(e, t), e.length > 1) {
                let r = e.slice(0, -1);
                this.isNodeSelected(r) === t && this.setNodeSelection(r, t);
            }
        }
    }
    selectNode(e) {
        this.setNodeSelection(e, !0);
    }
    deselectNode(e) {
        this.setNodeSelection(e, !1);
    }
    toggleNodeSelection(e) {
        this.setNodeSelection(e, !this.isNodeSelected(e));
    }
    getSelectedCount() {
        return this.getSelectionCountFor([]).selectedCount;
    }
    getDeselectedCount() {
        return this.getSelectionCountFor([]).deselectedCount;
    }
    getSelectionCountFor(e = []) {
        let { selectedCount: t, deselectedCount: n } = this.getSelectionStateForNode(e);
        return {
            selectedCount: t,
            deselectedCount: n
        };
    }
    destroy() {
        this.config = void 0, this.xcache(), this.selectionMap.clear();
    }
};
function $88ab1a78ec8ca4b4$var$_i(o, e) {
    return new $88ab1a78ec8ca4b4$export$3feed6aa923fae79(o, $88ab1a78ec8ca4b4$var$To(e));
}
function $88ab1a78ec8ca4b4$var$To(o) {
    return ()=>({
            treePaths: (typeof o == "function" ? o() : o).treePaths
        });
}
var $88ab1a78ec8ca4b4$var$Ai = class {
    constructor(e){
        this.setNodeSelection = (e, t, n)=>{
            let { treeSelectionState: r, selectionMode: i } = this.getState();
            if (!this.isNodeSelectable(e) && !n?.force) return;
            if (i === "single-row") {
                this.actions.treeSelection = t ? e[e.length - 1] : null;
                return;
            }
            if (i !== "multi-row") throw "Selection mode is not multi-row or single-row";
            if (!(r instanceof $88ab1a78ec8ca4b4$export$3feed6aa923fae79)) throw "Invalid tree selection";
            let a = new $88ab1a78ec8ca4b4$export$3feed6aa923fae79(r, $88ab1a78ec8ca4b4$var$To(this.getState));
            a.setNodeSelection(e, t), this.getState().lastSelectionUpdatedNodePathRef.current = {
                nodePath: e,
                selected: t
            }, this.actions.treeSelection = a;
        };
        this.getCallbackParam = (e)=>({
                dataSourceApi: this.dataSourceApi
            });
        this.getState = e.getState, this.actions = e.actions, this.dataSourceApi = e.dataSourceApi;
    }
    getSelectedLeafNodePaths(e) {
        let { treePaths: t } = this.getState(), n = e?.treeSelectionState || this.getState().treeSelectionState;
        return n ? n.getSelectedLeafNodePaths(e?.rootNodePath, t) : [];
    }
    getDeselectedLeafNodePaths(e) {
        let { treePaths: t } = this.getState(), n = e?.treeSelectionState || this.getState().treeSelectionState;
        return n ? n.getDeselectedLeafNodePaths(e?.rootNodePath, t) : [];
    }
    getSelectedLeafRowInfos(e) {
        let { treePaths: t } = this.getState(), n = e?.treeSelectionState || this.getState().treeSelectionState;
        if (!t || !n) return [];
        let r = e?.rootNodePath || [], i = [];
        return t.getLeafNodesStartingWith(r, (a)=>{
            if (n.isNodeSelected(a.keys)) {
                let l = this.getRowInfoByPath(a.keys);
                l && i.push(l);
            }
        }, {
            excludeSelf: !0
        }), i;
    }
    get allRowsSelected() {
        return this.getState().allRowsSelected;
    }
    isNodeReadOnly(e) {
        let t = this.getRowInfoByPath(e), n = this.getState().isNodeReadOnly;
        return t && t.isTreeNode && t.isParentNode && n ? n(t) : !1;
    }
    isNodeSelectable(e) {
        let t = this.getRowInfoByPath(e), n = this.getState().isNodeSelectable;
        return t && t.isTreeNode ? n(t) : !1;
    }
    isNodeExpanded(e) {
        let t = this.getState(), { isNodeExpanded: n, isNodeCollapsed: r, treeExpandState: i } = t, a = this.getRowInfoByPath(e);
        if (a) {
            if (!a.isTreeNode || !a.isParentNode) return !1;
            if (r) return !n(a, i);
            if (n) return n(a, i);
        }
        return i.isNodeExpanded(e);
    }
    expandAll() {
        let e = new $88ab1a78ec8ca4b4$export$bb181fe227550f9d({
            defaultExpanded: !0,
            collapsedPaths: []
        });
        this.getState().lastExpandStateInfoRef.current = {
            state: "expanded",
            nodePath: null
        }, this.actions.treeExpandState = e;
    }
    collapseAll() {
        let e = new $88ab1a78ec8ca4b4$export$bb181fe227550f9d({
            defaultExpanded: !1,
            expandedPaths: []
        });
        this.getState().lastExpandStateInfoRef.current = {
            state: "collapsed",
            nodePath: null
        }, this.actions.treeExpandState = e;
    }
    expandNode(e, t) {
        if (this.isNodeReadOnly(e) && !t?.force) return;
        let n = this.getState(), r = new $88ab1a78ec8ca4b4$export$bb181fe227550f9d(n.treeExpandState);
        r.expandNode(e), this.getState().lastExpandStateInfoRef.current = {
            state: "expanded",
            nodePath: e
        }, this.actions.treeExpandState = r, n.onNodeExpand?.(e, this.getCallbackParam(e));
    }
    collapseNode(e, t) {
        if (this.isNodeReadOnly(e) && !t?.force) return;
        let n = this.getState(), r = new $88ab1a78ec8ca4b4$export$bb181fe227550f9d(n.treeExpandState);
        r.collapseNode(e), this.getState().lastExpandStateInfoRef.current = {
            state: "collapsed",
            nodePath: e
        }, this.actions.treeExpandState = r, n.onNodeCollapse?.(e, this.getCallbackParam(e));
    }
    toggleNode(e, t) {
        let n = this.getState(), r = new $88ab1a78ec8ca4b4$export$bb181fe227550f9d(n.treeExpandState), i = !this.isNodeExpanded(e);
        this.isNodeReadOnly(e) && !t?.force || (r.setNodeExpanded(e, i), this.getState().lastExpandStateInfoRef.current = {
            state: i ? "expanded" : "collapsed",
            nodePath: e
        }, this.actions.treeExpandState = r, i ? n.onNodeExpand?.(e, this.getCallbackParam(e)) : n.onNodeCollapse?.(e, this.getCallbackParam(e)));
    }
    getNodeDataByPath(e) {
        if (!e.length) return null;
        let t = this.getRowInfoByPath(e);
        return t ? t.data : null;
    }
    getRowInfoByPath(e) {
        let { pathToIndexMap: t } = this.getState(), n = t.get(e);
        return n !== void 0 ? $88ab1a78ec8ca4b4$var$Tn(n, this.getState) : null;
    }
    selectAll() {
        let { treeSelectionState: e, selectionMode: t } = this.getState();
        if (t !== "multi-row") throw "Selection mode is not multi-row";
        if (!(e instanceof $88ab1a78ec8ca4b4$export$3feed6aa923fae79)) throw "Invalid node selection";
        let n = new $88ab1a78ec8ca4b4$export$3feed6aa923fae79(e, $88ab1a78ec8ca4b4$var$To(this.getState));
        n.selectAll(), this.getState().lastSelectionUpdatedNodePathRef.current = null, this.actions.treeSelection = n;
    }
    deselectAll() {
        let { treeSelectionState: e, selectionMode: t } = this.getState();
        if (t !== "multi-row") throw "Selection mode is not multi-row";
        if (!(e instanceof $88ab1a78ec8ca4b4$export$3feed6aa923fae79)) throw "Invalid node selection";
        let n = new $88ab1a78ec8ca4b4$export$3feed6aa923fae79(e, $88ab1a78ec8ca4b4$var$To(this.getState));
        n.deselectAll(), this.getState().lastSelectionUpdatedNodePathRef.current = null, this.actions.treeSelection = n;
    }
    isNodeSelected(e) {
        let { treeSelectionState: t, treeSelection: n, selectionMode: r } = this.getState();
        if (r === "single-row") {
            let i = e[e.length - 1];
            return Array.isArray(n) ? treeSelection.join(",") === e.join(",") : n === i;
        }
        if (r !== "multi-row") throw "Selection mode is not multi-row or single-row";
        if (!(t instanceof $88ab1a78ec8ca4b4$export$3feed6aa923fae79)) throw "Invalid tree selection";
        return t.isNodeSelected(e);
    }
    selectNode(e, t) {
        this.setNodeSelection(e, !0, t);
    }
    deselectNode(e, t) {
        this.setNodeSelection(e, !1, t);
    }
    toggleNodeSelection(e, t) {
        this.isNodeSelected(e) ? this.deselectNode(e, t) : this.selectNode(e, t);
    }
};
var $88ab1a78ec8ca4b4$var$So = class {
    constructor(e){
        let t = e instanceof Object.getPrototypeOf(this).constructor ? e.getState() : e, n = this.getPositiveFromState(t), r = this.getNegativeFromState(t);
        this.update({
            negativeItems: r,
            positiveItems: n
        });
    }
    getInitialState() {
        return this.initialState;
    }
    destroy() {
        this.positiveMap?.clear(), this.negativeMap?.clear(), delete this.positiveMap, delete this.negativeMap;
    }
    update(e) {
        let { positiveItems: t, negativeItems: n } = e;
        if (this.allNegative = n === !0, this.allPositive = t === !0, this.allNegative && this.allPositive) throw "Cannot have both negativeItems and positiveItems be true!";
        if (n && n !== !0) {
            this.negativeMap || (this.negativeMap = new Map), this.negativeMap.clear();
            for (let r of n)this.negativeMap.set(r, !0);
            this.positiveMap && this.positiveMap.clear();
        }
        if (t && t !== !0) {
            this.positiveMap || (this.positiveMap = new Map), this.positiveMap.clear();
            for (let r of t)this.positiveMap.set(r, !0);
            this.negativeMap && this.negativeMap.clear();
        }
    }
    isDefaultNegativeSelection() {
        return this.allNegative;
    }
    isDefaultPositiveSelection() {
        return this.allPositive;
    }
    areAllNegative() {
        return this.allNegative && (this.positiveMap ? this.positiveMap.size === 0 : !0);
    }
    areAllPositive() {
        return this.allPositive && (this.negativeMap ? this.negativeMap.size === 0 : !0);
    }
    makeAllNegative() {
        this.update({
            negativeItems: !0,
            positiveItems: []
        });
    }
    makeAllPositive() {
        this.update({
            positiveItems: !0,
            negativeItems: []
        });
    }
    isItemPositive(e) {
        if (this.allPositive === !0) {
            if (this.allNegative === !0) throw 'Cannot have both positiveItems and negativeItems be "true"';
            return !this.negativeMap?.has(e);
        }
        return !!this.positiveMap?.has(e);
    }
    isItemNegative(e) {
        return !this.isItemPositive(e);
    }
    setItemValue(e, t) {
        if (t !== this.isItemPositive(e)) {
            if (t) {
                if (this.allNegative === !0) {
                    if (!this.positiveMap) throw `No positiveMap found when trying to set item ${e} be positive`;
                    this.positiveMap.set(e, !0);
                } else if (this.allPositive === !0) {
                    if (!this.negativeMap) throw `No negativeMap found when trying to set item ${e} be positive`;
                    this.negativeMap.delete(e);
                }
            } else if (this.allPositive === !0) {
                if (!this.negativeMap) throw `No negativeMap found when trying to set item ${e} be negative`;
                this.negativeMap.set(e, !0);
            } else if (this.allNegative === !0) {
                if (!this.positiveMap) throw `No positiveMap found when trying to set item ${e} be negative`;
                this.positiveMap?.delete(e);
            }
        }
    }
    makeItemNegative(e) {
        this.setItemValue(e, !1);
    }
    makeItemPositive(e) {
        this.setItemValue(e, !0);
    }
    toggleItem(e) {
        this.setItemValue(e, !this.isItemPositive(e));
    }
};
var $88ab1a78ec8ca4b4$export$7cb388ded2a86ac7 = class extends $88ab1a78ec8ca4b4$var$So {
    constructor(t){
        super(t);
        this.isRowEnabled = (t)=>!!this.isItemPositive(t);
    }
    getState() {
        let t = this.allPositive ? !0 : [
            ...this.positiveMap?.keys() ?? []
        ], n = this.allNegative ? !0 : [
            ...this.negativeMap?.keys() ?? []
        ];
        return {
            enabledRows: t,
            disabledRows: n
        };
    }
    getPositiveFromState(t) {
        return t.enabledRows;
    }
    getNegativeFromState(t) {
        return t.disabledRows;
    }
    areAllDisabled() {
        return this.areAllNegative();
    }
    areAllEnabled() {
        return this.areAllPositive();
    }
    disableAll() {
        this.makeAllNegative();
    }
    enableAll() {
        this.makeAllPositive();
    }
    isRowDisabled(t) {
        return !this.isRowEnabled(t);
    }
    setRowEnabled(t, n) {
        return this.setItemValue(t, n);
    }
    disableRow(t) {
        this.setRowEnabled(t, !1);
    }
    enableRow(t) {
        this.setRowEnabled(t, !0);
    }
    toggleRow(t) {
        this.toggleItem(t);
    }
};
var $88ab1a78ec8ca4b4$var$Ql = 1e3;
function $88ab1a78ec8ca4b4$var$cp(o) {
    return new $88ab1a78ec8ca4b4$var$Jl(o);
}
var $88ab1a78ec8ca4b4$var$Jl = class {
    constructor(e){
        this.pendingOperations = [];
        this.batchOperationRafId = 0;
        this.batchOperationTimeoutId = 0;
        this.pendingPromise = null;
        this.resolvePendingPromise = null;
        this.toPrimaryKey = (e)=>this.getState().toPrimaryKey(e);
        this.getRowInfoArray = ()=>$88ab1a78ec8ca4b4$var$Ei(this.getState);
        this.getRowInfoByIndex = (e)=>$88ab1a78ec8ca4b4$var$Tn(e, this.getState) ?? null;
        this.getRowInfoByPrimaryKey = (e)=>{
            let t = this.getIndexByPrimaryKey(e);
            return this.getRowInfoByIndex(t);
        };
        this.getRowInfoByNodePath = (e)=>{
            let t = this.getIndexByNodePath(e);
            return this.getRowInfoByIndex(t);
        };
        this.getIndexByPrimaryKey = (e)=>this.getState().idToIndexMap.get(e) ?? -1;
        this.getIndexByNodePath = (e)=>this.getState().pathToIndexMap.get(e) ?? -1;
        this.getNodePathById = (e)=>this.getState().idToPathMap.get(e) ?? null;
        this.getNodePathByIndex = (e)=>{
            let t = this.getRowInfoByIndex(e);
            return t && t.isTreeNode ? t.nodePath : null;
        };
        this.getPrimaryKeyByIndex = (e)=>{
            let t = this.getRowInfoByIndex(e);
            return t ? t.id : void 0;
        };
        this.getOriginalDataArray = ()=>this.getState().originalDataArray;
        this.getDataByIndex = (e)=>{
            let t = this.getRowInfoByIndex(e);
            return t ? t.data : null;
        };
        this.getDataByPrimaryKey = (e)=>{
            let { indexer: t } = this.getState();
            return t.getDataForPrimaryKey(e) ?? null;
        };
        this.isNodePathAvailable = (e)=>this.getState().indexer.getDataForNodePath(e) !== void 0;
        this.getDataByNodePath = (e)=>{
            let { indexer: t } = this.getState(), n = t.getDataForNodePath(e);
            return n || null;
        };
        this.replaceAllData = (e, t)=>(this.batchOperation({
                type: "replace-all",
                array: e,
                metadata: t?.metadata
            }), this.addDataArray(e, t));
        this.clearAllData = (e)=>this.replaceAllData([], e);
        this.updateData = (e, t)=>this.updateDataArray([
                e
            ], t);
        this.updateDataArray = (e, t)=>{
            let n = this.getState().isTree, r = n ? void 0 : e.map((l)=>this.toPrimaryKey(l)), i = n ? e.map((l)=>this.getNodePathById(this.toPrimaryKey(l)) || []) : null, a = r ? this.batchOperation({
                type: "update",
                array: e,
                primaryKeys: e.map((l)=>this.toPrimaryKey(l)),
                metadata: t?.metadata
            }) : this.batchOperation({
                type: "update",
                array: e,
                nodePaths: i || [],
                metadata: t?.metadata
            });
            return t?.flush && this.commit(), a;
        };
        this.withWaitForNode = (e, t, n)=>{
            let r = n?.waitForNode ?? !0;
            if (r === !0 || typeof r == "number") {
                let a = r === !0 ? $88ab1a78ec8ca4b4$var$Ql : r;
                return isNaN(a) || (a = $88ab1a78ec8ca4b4$var$Ql), this.waitForNodePath(e, {
                    timeout: a
                }).then((l)=>{
                    if (!l) {
                        let s = `Cannot find node path "${e.join("/")}" (we waited for it ${a}ms)`;
                        return console.error(s), t({
                            error: s,
                            resolved: !1
                        });
                    }
                    return t({
                        resolved: !0
                    });
                });
            }
            let i = t({
                resolved: void 0
            });
            return i instanceof Promise ? i : Promise.resolve(i);
        };
        this.updateChildrenByNodePath = (e, t, n)=>this.withWaitForNode(t, ({ error: r })=>r ? !1 : this.updateChildrenByNodePath_Internal(e, t, n), n);
        this.updateChildrenByNodePath_Internal = (e, t, n)=>{
            let r = typeof e == "function" ? e : ()=>e;
            return this.updateDataArrayByNodePath_Internal([
                {
                    nodePath: t,
                    children: r
                }
            ], n);
        };
        this.updateDataByNodePath = (e, t, n)=>this.isNodePathAvailable(t) ? this.updateDataArrayByNodePath_Internal([
                {
                    data: e,
                    nodePath: t
                }
            ], n) : this.withWaitForNode(t, ({ error: r })=>r ? !1 : this.updateDataArrayByNodePath_Internal([
                    {
                        data: e,
                        nodePath: t
                    }
                ], n), n);
        this.updateDataArrayByNodePath = (e, t)=>{
            if (t && typeof t.waitForNode < "u" && !t.waitForNode) return this.updateDataArrayByNodePath_Internal(e, t);
            let n = e.map((i)=>i.nodePath);
            return Promise.allSettled(n.map((i)=>this.withWaitForNode(i, ({ error: a })=>!a, t))).then((i)=>i.every(Boolean) ? this.updateDataArrayByNodePath_Internal(e, t) : !1);
        };
        this.updateDataArrayByNodePath_Internal = (e, t)=>{
            let n = [], r = [];
            e.forEach((a)=>{
                a.data ? n.push(a.data) : a.children && n.push(a.children), r.push(a.nodePath);
            });
            let i = this.batchOperation({
                type: "update",
                array: n,
                nodePaths: r,
                metadata: t?.metadata
            });
            return t?.flush && this.commit(), i;
        };
        this.removeDataByPrimaryKey = (e, t)=>{
            if (this.getState().isTree) return this.removeDataByNodePath(this.getNodePathById(e) || [], t);
            let r = this.batchOperation({
                type: "delete",
                primaryKeys: [
                    e
                ],
                metadata: t?.metadata
            });
            return t?.flush && this.commit(), r;
        };
        this.removeDataByNodePath = (e, t)=>this.batchDeleteNodePaths([
                e
            ], t);
        this.removeData = (e, t)=>{
            if (this.getState().isTree) {
                let r = this.getNodePathById(this.toPrimaryKey(e));
                return this.removeDataByNodePath(r, t);
            }
            return this.batchDeletePrimaryKeys([
                this.toPrimaryKey(e)
            ], t);
        };
        this.removeDataArrayByPrimaryKeys = (e, t)=>{
            if (this.getState().isTree) {
                let r = e.map((i)=>this.getNodePathById(i) || []);
                return this.batchDeleteNodePaths(r, t);
            }
            return this.batchDeletePrimaryKeys(e, t);
        };
        this.batchDeleteNodePaths = (e, t)=>{
            let n = this.batchOperation({
                type: "delete",
                nodePaths: e || [],
                metadata: t?.metadata
            });
            return t?.flush && this.commit(), n;
        };
        this.batchDeletePrimaryKeys = (e, t)=>{
            let n = this.batchOperation({
                type: "delete",
                primaryKeys: e,
                metadata: t?.metadata
            });
            return t?.flush && this.commit(), n;
        };
        this.removeDataArray = (e, t)=>{
            if (this.getState().isTree) {
                let i = e.map((a)=>this.getNodePathById(this.toPrimaryKey(a)) || []);
                return this.batchDeleteNodePaths(i, t);
            }
            let r = e.map(this.toPrimaryKey);
            return this.batchDeletePrimaryKeys(r, t);
        };
        this.addData = (e, t)=>this.addDataArray([
                e
            ], t);
        this.addDataArray = (e, t)=>this.insertDataArray(e, {
                ...t,
                position: "end"
            });
        this.insertData = (e, t)=>this.insertDataArray([
                e
            ], t);
        this.insertDataArray = (e, t)=>{
            let n = this.getState().isTree, r = "before", i, a = t.nodePath;
            if (n && a?.length) return this.withWaitForNode(a, ({ error: s })=>{
                if (s) return !1;
                if (t.position === "before" || t.position === "after") return this.batchTreeInsert(e, t.position, a, t);
                let c = (u)=>t.position === "start" ? [
                        ...e,
                        ...u || []
                    ] : [
                        ...u || [],
                        ...e
                    ];
                return this.updateChildrenByNodePath(c, a, t);
            }, t);
            if (t.position === "before" || t.position === "after") r = t.position, i = t.primaryKey;
            else {
                let s = this.getOriginalDataArray();
                t.position === "start" ? (r = "before", s.length ? i = this.toPrimaryKey(s[0]) : i = void 0) : (r = "after", s.length ? i = this.toPrimaryKey(s[s.length - 1]) : i = void 0);
            }
            let l = n ? this.batchOperation({
                type: "insert",
                array: e,
                position: r,
                metadata: t?.metadata,
                nodePath: this.getNodePathById(i) || []
            }) : this.batchOperation({
                type: "insert",
                array: e,
                position: r,
                metadata: t?.metadata,
                primaryKey: i,
                nodePath: a
            });
            return t?.flush && this.commit(), l;
        };
        this.batchTreeInsert = (e, t, n, r)=>{
            if (n.length && !this.isNodePathAvailable(n)) return this.withWaitForNode(n, ({ error: a })=>{
                if (a) return !1;
                let l = this.batchOperation({
                    type: "insert",
                    array: e,
                    position: t,
                    metadata: r?.metadata,
                    nodePath: n
                });
                return r?.flush && this.commit(), l;
            }, r);
            let i = this.batchOperation({
                type: "insert",
                array: e,
                position: t,
                metadata: r?.metadata,
                nodePath: n
            });
            return r?.flush && this.commit(), i;
        };
        this.setSortInfo = (e)=>{
            let t = this.getState().multiSort;
            if (Array.isArray(e)) {
                this.actions.sortInfo = e.length ? t ? e : e[0] : null;
                return;
            }
            this.actions.sortInfo = e;
        };
        this.setGroupBy = (e)=>{
            this.actions.groupBy = e;
        };
        this.toggleGroupByField = (e)=>{
            let t = this.getState().groupBy;
            t.findIndex((r)=>r.field === e) === -1 ? this.actions.groupBy = [
                ...t,
                {
                    field: e
                }
            ] : this.actions.groupBy = t.filter((r)=>r.field !== e);
        };
        this.isRowDisabledAt = (e)=>this.getRowInfoByIndex(e)?.rowDisabled ?? !1;
        this.isRowDisabled = (e)=>this.getRowInfoByPrimaryKey(e)?.rowDisabled ?? !1;
        this.setRowEnabledAt = (e, t)=>{
            let n = this.getState().rowDisabledState, r = n ? new $88ab1a78ec8ca4b4$export$7cb388ded2a86ac7(n) : new $88ab1a78ec8ca4b4$export$7cb388ded2a86ac7({
                enabledRows: !0,
                disabledRows: []
            }), i = this.getRowInfoByIndex(e);
            i && (r.setRowEnabled(i.id, t), this.actions.rowDisabledState = r);
        };
        this.setRowEnabled = (e, t)=>{
            let n = this.getRowInfoByPrimaryKey(e);
            n && this.setRowEnabledAt(n.indexInAll, t);
        };
        this.enableAllRows = ()=>{
            let e = this.getState().rowDisabledState;
            if (!e) {
                this.actions.rowDisabledState = new $88ab1a78ec8ca4b4$export$7cb388ded2a86ac7({
                    enabledRows: !0,
                    disabledRows: []
                });
                return;
            }
            let t = new $88ab1a78ec8ca4b4$export$7cb388ded2a86ac7(e);
            t.enableAll(), this.actions.rowDisabledState = t;
        };
        this.disableAllRows = ()=>{
            let e = this.getState().rowDisabledState;
            if (!e) {
                this.actions.rowDisabledState = new $88ab1a78ec8ca4b4$export$7cb388ded2a86ac7({
                    disabledRows: !0,
                    enabledRows: []
                });
                return;
            }
            let t = new $88ab1a78ec8ca4b4$export$7cb388ded2a86ac7(e);
            t.disableAll(), this.actions.rowDisabledState = t;
        };
        this.areAllRowsEnabled = ()=>{
            let e = this.getState().rowDisabledState;
            return e ? e.areAllEnabled() : !0;
        };
        this.areAllRowsDisabled = ()=>{
            let e = this.getState().rowDisabledState;
            return e ? e.areAllDisabled() : !1;
        };
        this.getState = e.getState, this.getState().__apiRef.current = this, this.actions = e.actions, this.treeApi = new $88ab1a78ec8ca4b4$var$Ai({
            ...e,
            dataSourceApi: this
        });
    }
    getPendingOperationPromise() {
        return this.pendingPromise;
    }
    batchOperation(e) {
        if (!this.pendingPromise) {
            this.pendingPromise = new Promise((n)=>{
                this.resolvePendingPromise = n;
            });
            let t = Math.max(0, this.getState().batchOperationDelay ?? 0);
            t === 0 ? this.batchOperationRafId = setTimeout(()=>{
                this.commit();
            }) : this.batchOperationTimeoutId = setTimeout(()=>{
                this.batchOperationRafId = setTimeout(()=>{
                    this.commit();
                });
            }, t);
        }
        return e.type === "replace-all" && (this.pendingOperations.length = 0), this.pendingOperations.push(e), this.pendingPromise;
    }
    commitOperations(e) {
        if (!e.length) return;
        let t = this.getState().cache, { isTree: n, nodesKey: r } = this.getState(), i = t ? $88ab1a78ec8ca4b4$var$Kn.clone(t, {
            light: !0
        }) : new $88ab1a78ec8ca4b4$var$Kn({
            nodesKey: n ? r : void 0
        });
        e.forEach((a)=>{
            switch(a.type){
                case "update":
                    a.array.forEach((u, d)=>{
                        if (a.primaryKeys) {
                            let f = a.primaryKeys[d], p = this.getDataByPrimaryKey(f);
                            p && i.update(a.primaryKeys[d], u, p, a.metadata);
                        } else if (a.nodePaths) {
                            let f = this.getDataByNodePath(a.nodePaths[d]);
                            f && (typeof u == "function" ? i.updateChildren(a.nodePaths[d], u, f, a.metadata) : i.updateNodePath(a.nodePaths[d], u, f, a.metadata));
                        }
                    });
                    break;
                case "delete":
                    a.primaryKeys ? a.primaryKeys.forEach((u)=>{
                        let d = this.getDataByPrimaryKey(u);
                        d && i.delete(u, d, a.metadata);
                    }) : a.nodePaths && a.nodePaths.forEach((u)=>{
                        let d = this.getDataByNodePath(u);
                        d && i.deleteNodePath(u, d, a.metadata);
                    });
                    break;
                case "insert":
                    let l = a.primaryKey, s = a.position, c = a.nodePath;
                    c ? a.array.forEach((u)=>{
                        i.insertNodePath([
                            ...c
                        ], u, s, a.metadata), l = this.toPrimaryKey(u), c.pop(), c.push(l), s = "after";
                    }) : a.array.forEach((u)=>{
                        i.insert(l, u, s, a.metadata), l = this.toPrimaryKey(u), s = "after";
                    });
                    break;
                case "replace-all":
                    i.resetDataSource(a.metadata);
                    break;
            }
        }), this.actions.cache = i;
    }
    flush() {
        return this.commit();
    }
    waitForNodePath(e, t) {
        let n = this.getState();
        if (this.isNodePathAvailable(e)) return Promise.resolve(!0);
        let r = t?.timeout ?? $88ab1a78ec8ca4b4$var$Ql, i = n.waitForNodePathPromises.get(e);
        if (i) return i.promise;
        let a = Date.now(), l = ()=>{}, s = new Promise((c)=>{
            let u, d;
            l = (f)=>{
                clearTimeout(d), u = f, n.waitForNodePathPromises.delete(e), c(f);
            }, d = setTimeout(()=>{
                u === void 0 && l(!1);
            }, r);
        });
        return n.waitForNodePathPromises.set(e, {
            timestamp: a,
            promise: s,
            resolve: l
        }), s;
    }
    commit() {
        this.commitOperations(this.pendingOperations), this.pendingOperations.length = 0;
        let e = this.pendingPromise;
        if (e && this.resolvePendingPromise) {
            let t = this.resolvePendingPromise;
            requestAnimationFrame(()=>{
                t(!0);
            }), this.pendingPromise = null, this.resolvePendingPromise = null;
        }
        return e || Promise.resolve(!0);
    }
};
function $88ab1a78ec8ca4b4$var$up(o) {
    let e = o.cache;
    if (!e) return {
        sortInfo: !1,
        groupBy: !1,
        tree: !1,
        filterValue: !1,
        aggregationReducers: !1
    };
    let t = !1, n = !1, r = !1, i = !1, a = !1, l = e.getAffectedFields(), { sortInfo: s, groupBy: c, filterValue: u, aggregationReducers: d, nodesKey: f, isTree: p } = o;
    if (s && s.length) {
        if (l === !0) t = !0;
        else for (let m of s){
            let g = m.field;
            if (g && (g = Array.isArray(g) ? g : [
                g
            ], t = g.reduce((b, h)=>b || typeof h != "function" ? l.has(h) : !1, !1), t)) break;
        }
    }
    if (c && c.length) {
        if (l === !0) n = !0;
        else for (let m of c)if (m.field && l.has(m.field)) {
            n = !0;
            break;
        }
    }
    if (p && (l === !0 ? r = !0 : r = l.has(f)), u && u.length) {
        if (l === !0) i = !0;
        else for (let m of u){
            if (m.id) {
                i = !0;
                break;
            }
            if (m.field && l.has(m.field)) {
                i = !0;
                break;
            }
        }
    }
    if (d && Object.keys(d).length) {
        if (l === !0) a = !0;
        else for(let m in d)if (d.hasOwnProperty(m)) {
            let g = d[m];
            if (g.field) {
                if (l.has(g.field)) {
                    a = !0;
                    break;
                }
            } else {
                a = !0;
                break;
            }
        }
    }
    return {
        sortInfo: t,
        groupBy: n,
        filterValue: i,
        aggregationReducers: a,
        tree: r
    };
}
function $88ab1a78ec8ca4b4$var$Oi(o) {
    if (!o) return;
    let e = Object.keys(o);
    if (!e.length) return;
    let t = {};
    for(let n = 0, r = e.length; n < r; n++){
        let i = e[n], a = o[i].initialValue;
        a !== void 0 && (t[i] = typeof a == "function" ? a() : a);
    }
    return t;
}
function $88ab1a78ec8ca4b4$var$Ni(o) {
    let e = o.reducerKeys, t = o.reducers, n = o.results;
    for(let r = 0, i = e.length; r < i; r++){
        let a = e[r], l = t[a].reducer;
        n[a] = l(n[a], o.rowInfo);
    }
}
function $88ab1a78ec8ca4b4$var$Fi(o) {
    let e = Object.keys(o.reducers || {});
    if (!e.length || !o.results) return o.results;
    let t = o.reducers, n = o.results;
    for(let r = 0, i = e.length; r < i; r++){
        let a = e[r], l = t[a].done;
        typeof l == "function" && (n[a] = l(n[a], o.array));
    }
    return n;
}
function $88ab1a78ec8ca4b4$var$ts(o, e) {
    return o && o.filter((t)=>{
        let n = e[t.filter.type];
        return !(!n || n.emptyValues && n.emptyValues.includes(t.filter.value));
    });
}
var $88ab1a78ec8ca4b4$var$Gt = (o, e, t)=>{
    for(let n = 0, r = t.length; n < r; n++){
        let i = t[n], a = o[i], l = e[i];
        if (a !== l) return !0;
    }
    return !1;
};
function $88ab1a78ec8ca4b4$var$es() {
    return !1;
}
function $88ab1a78ec8ca4b4$var$rS(o, e, t, n, r, i) {
    let a = {
        dataSourceHasGrouping: !1,
        isTreeNode: !1,
        data: o,
        id: e,
        indexInAll: t,
        isGroupRow: !1,
        selfLoaded: !0,
        rowSelected: !1,
        rowDisabled: !1,
        isCellSelected: $88ab1a78ec8ca4b4$var$es,
        hasSelectedCells: $88ab1a78ec8ca4b4$var$es
    };
    return n && (a.rowSelected = n(a)), r && (a.rowDisabled = r(a)), i && (a.isCellSelected = (l)=>i.isCellSelected(a.id, l), a.hasSelectedCells = (l)=>i.isCellSelectionInRow(a.id, l)), a;
}
var $88ab1a78ec8ca4b4$var$iS = $88ab1a78ec8ca4b4$var$ot(()=>{
    console.warn(`Your "treeFilterFunction" should NOT MUTATE the data object. You're probably mutating the node children.

Your filtering function probably looks like this:

function treeFilterFunction({ data }) {
  data.children = data.children.filter(...) // <-- THIS MUTATION IS NOT SUPPORTED (data.children = ...)!
  
  return data
}

Make sure you avoid mutations.

`);
});
function $88ab1a78ec8ca4b4$var$dp(o) {
    let { dataArray: e, treeFilterFunction: t, toPrimaryKey: n, getNodeChildren: r, isLeafNode: i, nodesKey: a } = o, l = [], s = (c)=>{
        let u = r(c);
        if (i(c) || !Array.isArray(u)) return c;
        let d = $88ab1a78ec8ca4b4$var$dp({
            ...o,
            dataArray: u
        });
        return d.length === 0 ? !1 : (c = {
            ...c,
            [a]: d
        }, c);
    };
    for(let c = 0, u = e.length; c < u; c++){
        let d = e[c], f = r(d), p = t({
            data: d,
            index: c,
            dataArray: e,
            primaryKey: n(d, c),
            filterTreeNode: s
        });
        p && (p === !0 ? p = d : typeof p == "object" && p === d && f !== r(p) && $88ab1a78ec8ca4b4$var$iS(), l.push(p));
    }
    return l;
}
function $88ab1a78ec8ca4b4$export$3b30da392703a555(o) {
    let { filterTypes: e, marker: t, operatorsByFilterType: n, filterFunction: r, toPrimaryKey: i, treeFilterFunction: a, getNodeChildren: l, nodesKey: s, isLeafNode: c } = o, { dataArray: u } = o;
    t?.start({
        details: [
            {
                name: "Count before",
                value: u.length
            }
        ]
    }), r && (u = u.filter((f, p, m)=>r({
            data: f,
            index: p,
            dataArray: m,
            primaryKey: i(f, p)
        }))), a && (u = $88ab1a78ec8ca4b4$var$dp({
        ...o,
        treeFilterFunction: a,
        getNodeChildren: l,
        nodesKey: s,
        isLeafNode: c
    }));
    let d = $88ab1a78ec8ca4b4$var$ts(o.filterValue, e) || [];
    if (d && d.length) {
        let f = u.filter((p, m, g)=>{
            let b = {
                data: p,
                index: m,
                dataArray: g,
                primaryKey: i(p, m),
                field: void 0
            };
            for(let h = 0, y = d.length; h < y; h++){
                let S = d[h], { disabled: C, field: T, valueGetter: I, filter: { type: w, value: v, operator: R } } = S, x = e[w];
                if (C || !x) continue;
                let M = n[w]?.[R];
                if (!M) continue;
                let E = I || x.valueGetter || (({ data: _, field: D })=>D ? _[D] : _);
                b.field = T;
                let P = b;
                if (P.filterValue = v, P.currentValue = E(P), P.emptyValues = x.emptyValues, !M.fn(P)) return !1;
            }
            return !0;
        });
        return t?.end({
            details: [
                {
                    name: "Count after",
                    value: f.length
                }
            ]
        }), f;
    }
    return t?.end({
        details: [
            {
                name: "Count after",
                value: u.length
            }
        ]
    }), u;
}
function $88ab1a78ec8ca4b4$var$pp(o) {
    let e, { state: t, previousState: n } = o, r = t.debugId, i;
    r && (i = $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.PrepareData.start());
    let a = $88ab1a78ec8ca4b4$var$up(t), l = t.sortInfo, s = t.sortMode, c = l?.length ? s === "local" : !1;
    (t.lazyLoad || t.livePagination) && (c = !1);
    let u = $88ab1a78ec8ca4b4$var$Gt(n, t, [
        "refetchKey"
    ]), d = $88ab1a78ec8ca4b4$var$Gt(n, t, [
        "cache",
        "originalDataArray",
        "originalLazyGroupDataChangeDetect"
    ]);
    Array.isArray(t.data) && u && (d = !0);
    let p = t.cache ? $88ab1a78ec8ca4b4$var$Kn.clone(t.cache) : void 0;
    p && !p.isEmpty() && (d = !0);
    let m = t.toPrimaryKey, g = t.nodesKey, b = t.isTree, h = g ? ($)=>$[g] : void 0, y = g ? ($)=>$[g] === void 0 : void 0, S, C;
    d && (t.indexer.clear(), t.lazyLoad || (S = p?.getMutations(), C = p?.getTreeMutations(), t.originalDataArray = t.indexer.indexArray(t.originalDataArray, {
        toPrimaryKey: m,
        cache: p,
        getNodeChildren: h,
        isLeafNode: y,
        nodesKey: g
    }), b && t.waitForNodePathPromises.visit(({ value: $ }, ee)=>{
        $ && t.indexer.getDataForNodePath(ee) !== void 0 && $.resolve(!0);
    }))), p && (p.clear(), t.cache = void 0);
    let { filterFunction: I, treeFilterFunction: w, filterValue: v, filterTypes: R, operatorsByFilterType: x } = t, M = !!I || !!w || Array.isArray(v) && v.length, A = M && t.filterMode === "local", E = $88ab1a78ec8ca4b4$var$Gt(n, t, [
        "filterFunction",
        "treeFilterFunction",
        "filterValue",
        "filterTypes"
    ]), P = d || E, _ = $88ab1a78ec8ca4b4$var$Gt(n, t, [
        "sortInfo"
    ]), D = d || E || _, O = t.filterMode === "local" && (P || !t.lastFilterDataArray), F = c && (D || !t.lastSortDataArray || a.sortInfo), W = t.groupBy, z = t.pivotBy, L = !b && (W.length > 0 || !!z), ae = b, te = $88ab1a78ec8ca4b4$var$Gt(n, t, [
        "rowDisabledState",
        "isRowDisabled"
    ]), B = $88ab1a78ec8ca4b4$var$Gt(n, t, [
        "rowSelection",
        "cellSelection",
        "isRowSelected",
        "originalLazyGroupDataChangeDetect"
    ]), j = $88ab1a78ec8ca4b4$var$Gt(n, t, [
        "treeSelection",
        "cellSelection",
        "isNodeSelected",
        "originalLazyGroupDataChangeDetect"
    ]), oe = d || D || $88ab1a78ec8ca4b4$var$Gt(n, t, [
        "generateGroupRows",
        "originalLazyGroupData",
        "originalLazyGroupDataChangeDetect",
        "groupBy",
        "groupRowsState",
        "pivotBy",
        "aggregationReducers",
        "pivotTotalColumnPosition",
        "pivotGrandTotalColumnPosition",
        "showSeparatePivotColumnForSingleAggregation",
        "repeatWrappedGroupRows",
        "rowsPerPage"
    ]), me = d || D || $88ab1a78ec8ca4b4$var$Gt(n, t, [
        "originalLazyGroupData",
        "originalLazyGroupDataChangeDetect",
        "treeExpandState",
        "isNodeExpanded",
        "isNodeCollapsed",
        "aggregationReducers",
        "repeatWrappedGroupRows",
        "rowsPerPage"
    ]), pe = $88ab1a78ec8ca4b4$var$Gt(n, t, [
        "rowInfoReducers"
    ]), ce = L && (oe || !t.lastGroupDataArray || a.groupBy) || B || te || pe, ue = ae && (me || a.tree || !t.lastTreeDataArray) || j || te || pe, ge = Date.now(), H = t.originalDataArray;
    if (ae && ue) {
        let $ = {
            marker: r ? $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.TreeUnfilteredTreePaths.start() : void 0,
            isLeafNode: y,
            getNodeChildren: h,
            toKey: m
        };
        t.unfilteredTreePaths = $88ab1a78ec8ca4b4$var$jl($, H).treePaths;
    }
    if (M || (t.unfilteredCount = H.length), A) {
        t.unfilteredCount = H.length;
        let $ = ge;
        O ? (t.devToolsDetected && ($ = Date.now()), H = $88ab1a78ec8ca4b4$export$3b30da392703a555({
            marker: r ? $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.Filter.start() : void 0,
            getNodeChildren: h,
            isLeafNode: y,
            nodesKey: g,
            treeFilterFunction: w,
            dataArray: H,
            toPrimaryKey: m,
            filterTypes: R,
            operatorsByFilterType: x,
            filterFunction: I,
            filterValue: v
        }), t.devToolsDetected && t.debugTimings.set("filter", Date.now() - $)) : H = t.lastFilterDataArray, t.lastFilterDataArray = H, t.filteredAt = ge;
    }
    if (t.filteredCount = H.length, t.postFilterDataArray = H, c) {
        let $ = $88ab1a78ec8ca4b4$export$4c4a0f6d9a37d837.knownTypes;
        if ($88ab1a78ec8ca4b4$export$4c4a0f6d9a37d837.knownTypes = {
            ...$,
            ...t.sortTypes
        }, F) {
            let ee = ge;
            if (t.devToolsDetected && (ee = Date.now()), r && (e = $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.Sort.start({
                details: [
                    {
                        name: "Count",
                        value: H.length
                    }
                ]
            })), t.sortFunction ? (H = t.sortFunction(l, [
                ...H
            ]), e && (e.end(), e = void 0)) : b ? H = $88ab1a78ec8ca4b4$export$54fedfbcf9c64b86(l, H, {
                marker: e,
                inplace: !1,
                isLeafNode: y,
                getNodeChildren: h,
                toKey: m,
                nodesKey: g
            }) : H = $88ab1a78ec8ca4b4$export$4c4a0f6d9a37d837(l, [
                ...H
            ], {
                marker: e
            }), r && (e?.end(), e = void 0), t.devToolsDetected) {
                let le = Date.now() - ee;
                t.debugTimings.set("sort", le);
            }
        } else H = t.lastSortDataArray;
        $88ab1a78ec8ca4b4$export$4c4a0f6d9a37d837.knownTypes = $, t.lastSortDataArray = H, t.sortedAt = ge;
    }
    t.postSortDataArray = H;
    let G = t.dataArray, q = t.rowSelection instanceof $88ab1a78ec8ca4b4$export$fdba2ac35241013c ? t.rowSelection : void 0, K = t.treeExpandState instanceof $88ab1a78ec8ca4b4$export$bb181fe227550f9d ? t.treeExpandState : void 0, re = t.cellSelection instanceof $88ab1a78ec8ca4b4$export$31e3cce2e16ab248 ? t.cellSelection : void 0;
    q?.xcache();
    let J = t.selectionMode === "single-row" ? ($)=>$.id === t.rowSelection : t.selectionMode === "multi-row" ? ($)=>{
        let ee = q;
        return $.isGroupRow ? ee.getGroupRowSelectionState($.groupKeys) : ee.isRowSelected($.id, $.dataSourceHasGrouping ? $.groupKeys : void 0);
    } : void 0, de = t.isRowDisabled || $88ab1a78ec8ca4b4$var$es;
    t.isRowSelected && t.selectionMode === "multi-row" && (J = ($)=>t.isRowSelected($, q, t.selectionMode));
    let we;
    t.isNodeExpanded && (we = ($)=>t.isNodeExpanded($, K)), t.isNodeCollapsed && (we = ($)=>!t.isNodeExpanded($, K)), we || (we = (ee)=>K.isNodeExpanded(ee.nodePath));
    let N1 = t.rowInfoReducers;
    if (L) {
        if (ce) {
            let $ = ge;
            t.devToolsDetected && ($ = Date.now());
            let ee = t.aggregationReducers, le = t.lazyLoad ? $88ab1a78ec8ca4b4$var$Wf({
                groupBy: W,
                pivot: z,
                mappings: t.pivotMappings,
                reducers: ee,
                indexer: t.indexer,
                toPrimaryKey: m,
                cache: p,
                marker: r ? $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.LazyGroup.start() : void 0
            }, t.originalLazyGroupData) : $88ab1a78ec8ca4b4$export$e5e25fbcc1f7affe({
                groupBy: W,
                pivot: z,
                reducers: ee,
                marker: r ? $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.Group.start() : void 0
            }, H);
            t.groupDeepMap = le.deepMap, q && (q.getConfig = $88ab1a78ec8ca4b4$var$at(t));
            let De = Object.keys(N1 || {}), Oe = $88ab1a78ec8ca4b4$var$Oi(N1), Ne = {
                reducers: N1,
                results: Oe,
                reducerKeys: De,
                rowInfo: {}
            }, he = Oe ? (Ze)=>{
                Ne.rowInfo = Ze, $88ab1a78ec8ca4b4$var$Ni(Ne);
            } : void 0, Ke = re ? (Ze)=>{
                Ze.isCellSelected = (V)=>re.isCellSelected(Ze.id, V);
            } : void 0, Be = he || Ke ? $88ab1a78ec8ca4b4$var$ql(he, Ke) : void 0, dt = $88ab1a78ec8ca4b4$var$Yf({
                marker: r ? $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.FlattenTree.start() : void 0,
                groupResult: le,
                lazyLoad: !!t.lazyLoad,
                reducers: ee,
                toPrimaryKey: m,
                isRowSelected: J,
                rowSelectionState: q,
                withRowInfo: Be,
                repeatWrappedGroupRows: t.rowsPerPage != null ? t.repeatWrappedGroupRows : !1,
                rowsPerPage: t.rowsPerPage,
                groupRowsState: t.groupRowsState,
                generateGroupRows: t.generateGroupRows
            });
            G = dt.data, t.rowInfoReducerResults = $88ab1a78ec8ca4b4$var$Fi({
                reducers: N1,
                results: Oe,
                array: G
            }), t.groupRowsIndexesInDataArray = dt.groupRowsIndexes, t.reducerResults = le.reducerResults;
            let Rt = z ? $88ab1a78ec8ca4b4$var$lp({
                deepMap: le.topLevelPivotColumns,
                pivotBy: z,
                pivotTotalColumnPosition: t.pivotTotalColumnPosition ?? "end",
                pivotGrandTotalColumnPosition: t.pivotGrandTotalColumnPosition ?? !1,
                reducers: t.aggregationReducers,
                showSeparatePivotColumnForSingleAggregation: t.showSeparatePivotColumnForSingleAggregation
            }) : void 0;
            t.pivotColumns = Rt?.columns, t.pivotColumnGroups = Rt?.columnGroups, t.devToolsDetected && t.debugTimings.set("group-and-pivot", Date.now() - $);
        } else G = t.lastGroupDataArray;
        t.lastGroupDataArray = G, t.groupedAt = ge;
    } else if (ae) {
        if (ue) {
            let $ = ge;
            t.devToolsDetected && ($ = Date.now());
            let ee = t.aggregationReducers, le = {
                marker: r ? $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.Tree.start() : void 0,
                isLeafNode: y,
                getNodeChildren: h,
                toKey: m,
                reducers: ee
            }, De = $88ab1a78ec8ca4b4$var$jl(le, H);
            t.treeDeepMap = De.deepMap, t.treePaths = De.treePaths;
            let Oe = t.selectionMode === "multi-row" ? $88ab1a78ec8ca4b4$var$mp(t.treeSelection, t.selectionMode, t) : void 0;
            t.treeSelectionState = Oe;
            let Ne = Object.keys(N1 || {}), he = $88ab1a78ec8ca4b4$var$Oi(N1), Ke = {
                reducers: N1,
                results: he,
                reducerKeys: Ne,
                rowInfo: {}
            }, Be = he ? (ie)=>{
                Ke.rowInfo = ie, $88ab1a78ec8ca4b4$var$Ni(Ke);
            } : void 0, dt = re ? (ie)=>{
                ie.isCellSelected = (be)=>re.isCellSelected(ie.id, be);
            } : void 0, Rt = Be || dt ? $88ab1a78ec8ca4b4$var$ql(Be, dt) : void 0, Ze = t.selectionMode === "single-row" ? (ie)=>ie.id === t.treeSelection : t.selectionMode === "multi-row" ? (ie)=>Oe.isNodeSelected(ie.nodePath) : void 0, V = t.rowsPerPage != null ? t.repeatWrappedGroupRows : !1;
            G = $88ab1a78ec8ca4b4$var$Uf({
                marker: r ? $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.FlattenTree.start() : void 0,
                treeResult: De,
                treeParams: le,
                dataArray: H,
                reducers: ee,
                toPrimaryKey: m,
                isNodeSelected: Ze,
                isNodeExpanded: we,
                treeSelectionState: Oe,
                withRowInfo: Rt,
                repeatWrappedGroupRows: V,
                rowsPerPage: t.rowsPerPage
            }).data, t.rowInfoReducerResults = $88ab1a78ec8ca4b4$var$Fi({
                reducers: N1,
                results: he,
                array: G
            }), t.reducerResults = De.reducerResults, t.totalLeafNodesCount = De.deepMap.get([])?.totalLeafNodesCount ?? 0, t.treeAt = ge, t.devToolsDetected && t.debugTimings.set("tree", Date.now() - $);
        } else G = t.lastTreeDataArray;
        t.lastTreeDataArray = G;
    } else if (t.groupDeepMap = void 0, t.pivotColumns = void 0, t.groupRowsIndexesInDataArray = void 0, n.postSortDataArray != t.postSortDataArray || oe || B || te || pe) {
        let ee = Object.keys(N1 || {}), le = $88ab1a78ec8ca4b4$var$Oi(N1), De = {
            reducers: N1,
            results: le,
            reducerKeys: ee,
            rowInfo: {}
        };
        G = H.map((Oe, Ne)=>{
            let he = $88ab1a78ec8ca4b4$var$rS(Oe, Oe ? m(Oe) : Ne, Ne, J, de, re);
            return le && (De.rowInfo = he, $88ab1a78ec8ca4b4$var$Ni(De)), he;
        }), t.rowInfoReducerResults = $88ab1a78ec8ca4b4$var$Fi({
            reducers: N1,
            results: le,
            array: G
        });
    }
    if (t.postGroupDataArray = G, G !== t.dataArray && (t.updatedAt = ge), t.dataArray = G, t.reducedAt = ge, t.selectionMode === "multi-row") {
        if (L && t.lazyLoad) {
            r && (e = $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.ComputeSelectionCountLazy.start());
            let $ = !0, ee = !1;
            t.dataArray.forEach((le)=>{
                if (!le.isTreeNode && le.isGroupRow && le.groupKeys.length === 1) {
                    let { rowSelected: De } = le;
                    De !== !0 && ($ = !1), (De === !0 || De === null) && (ee = !0);
                }
            }), t.allRowsSelected = $, t.someRowsSelected = ee, r && (e?.end(), e = void 0);
        } else {
            r && (e = $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.ComputeSelectionCount.start());
            let $ = t.isTree ? t.totalLeafNodesCount : t.filteredCount, ee = t.isTree ? t.treeSelectionState ? t.treeSelectionState.getSelectedCount() : 0 : t.rowSelection.getSelectedCount();
            t.allRowsSelected = $ === ee, t.someRowsSelected = ee > 0, r && (e?.end(), e = void 0);
        }
    }
    return t.originalDataArrayChanged = d, d && (t.originalDataArrayChangedInfo = {
        timestamp: ge,
        mutations: S?.size ? S : void 0,
        treeMutations: C?.size ? C : void 0
    }), t.rowInfoStore.notifyDataArray(G, {
        marker: r ? $88ab1a78ec8ca4b4$var$qe(r).track.DataSource.label.DiffRowInfoInStore : void 0
    }), i && i?.track.DataSource.label.PrepareData.end({
        details: [
            O || F || ce || ue ? {
                name: "Performed operations",
                value: [
                    O ? "filter" : null,
                    F ? "sort" : null,
                    ce ? "group" : null,
                    ue ? "tree" : null
                ].filter($88ab1a78ec8ca4b4$var$an).join(", ")
            } : null,
            u ? {
                name: "Refetch key",
                value: `Old ${n.refetchKey} -> New ${t.refetchKey}`
            } : null,
            d ? {
                name: "Original data array changed",
                value: ""
            } : null,
            {
                name: "Unfiltered data length",
                value: t.originalDataArray.length
            }
        ].filter($88ab1a78ec8ca4b4$var$an)
    }), t;
}
function $88ab1a78ec8ca4b4$var$Ot() {
    let o = $88ab1a78ec8ca4b4$var$Re().performance?.now();
    return `${Date.now()}:${o}`;
}
function $88ab1a78ec8ca4b4$var$aS(o, e, t) {
    return e = e.replaceAll("$ERR_CODE", o), e = `${e}

ERROR_CODE = ${o}

See http://infinite-table.com/docs/reference/error-codes#${o} for more info.`, {
        code: o,
        message: e,
        type: t ?? "error"
    };
}
function $88ab1a78ec8ca4b4$var$gp(o) {
    return Object.entries(o).reduce((e, [t, n])=>{
        let r = t, i = $88ab1a78ec8ca4b4$var$aS(r, typeof n == "string" ? n : n.message, typeof n == "string" ? void 0 : n.type);
        return e[r] = i, e;
    }, {});
}
function $88ab1a78ec8ca4b4$var$lS(o) {
    return {
        message: o.join(""),
        type: "warning"
    };
}
function $88ab1a78ec8ca4b4$var$sS(o) {
    return {
        message: o.join(""),
        type: "error"
    };
}
var $88ab1a78ec8ca4b4$var$cS = $88ab1a78ec8ca4b4$var$gp({
    DS001: $88ab1a78ec8ca4b4$var$lS`The "data" prop of your DataSource seems to be updating too frequently.
Make sure you don't pass a new reference on every render.`
}), $88ab1a78ec8ca4b4$var$uS = $88ab1a78ec8ca4b4$var$gp({
    CSS001_CSS: $88ab1a78ec8ca4b4$var$sS`It appears you have not loaded the CSS file for InfiniteTable.
In most environments, you should be able to fix this by adding the following line:
  
import '@infinite-table/infinite-react/index.css'
  `
}), $88ab1a78ec8ca4b4$var$hp = {
    ...$88ab1a78ec8ca4b4$var$cS,
    ...$88ab1a78ec8ca4b4$var$uS
};
var $88ab1a78ec8ca4b4$var$qt = new Map, $88ab1a78ec8ca4b4$var$Xt = new Map, $88ab1a78ec8ca4b4$var$Sn = new Map, $88ab1a78ec8ca4b4$var$Zt = new Map;
var $88ab1a78ec8ca4b4$var$It = new Map, $88ab1a78ec8ca4b4$var$bp = (o)=>{
    $88ab1a78ec8ca4b4$var$It.delete(o), $88ab1a78ec8ca4b4$var$Sn.delete(o), $88ab1a78ec8ca4b4$var$qt.delete(o), $88ab1a78ec8ca4b4$var$Zt.delete(o), $88ab1a78ec8ca4b4$var$Xt.delete(o);
};
function $88ab1a78ec8ca4b4$var$ns(o, e, t) {
    let n = $88ab1a78ec8ca4b4$var$It.get(o);
    if (!n) return;
    let r = $88ab1a78ec8ca4b4$var$Sn.get(o);
    (!r || !Object.hasOwn(r, e)) && $88ab1a78ec8ca4b4$var$Sn.set(o, {
        ...r || {},
        [e]: n.getState()[e]
    }), $88ab1a78ec8ca4b4$var$qt.set(o, {
        ...$88ab1a78ec8ca4b4$var$qt.get(o) || {},
        [e]: t
    }), n.actions[e] = t;
}
function $88ab1a78ec8ca4b4$var$Li(o, e, t) {
    let n = $88ab1a78ec8ca4b4$var$It.get(o);
    if (!n) return;
    let r = $88ab1a78ec8ca4b4$var$Zt.get(o);
    (!r || !Object.hasOwn(r, e)) && $88ab1a78ec8ca4b4$var$Zt.set(o, {
        ...r || {},
        [e]: n.getDataSourceState()[e]
    }), $88ab1a78ec8ca4b4$var$Xt.set(o, {
        ...$88ab1a78ec8ca4b4$var$Xt.get(o) || {},
        [e]: t
    }), n.dataSourceActions[e] = t;
}
var $88ab1a78ec8ca4b4$var$dS = (o)=>{
    let e = o.type === "error" ? $88ab1a78ec8ca4b4$var$on(o.debugId) : $88ab1a78ec8ca4b4$var$St(o.debugId), t = o.type === "error" ? $88ab1a78ec8ca4b4$var$op : $88ab1a78ec8ca4b4$var$ho, n = o.debugId ? `${o.code}-${o.debugId}` : o.code, r = o.message;
    o.debugId && (r = `${r}

Component DEBUG_ID = "${o.debugId}"`), t(r, n, e);
}, $88ab1a78ec8ca4b4$var$dr = (o)=>{
    let { debugId: e, key: t } = o, n = $88ab1a78ec8ca4b4$var$hp[t];
    if (n && ($88ab1a78ec8ca4b4$var$dS({
        ...n,
        debugId: e
    }), e && t)) {
        let r = $88ab1a78ec8ca4b4$var$It.get(e);
        r && r.getState().devToolsDetected && n && (r.getState().debugWarnings.set(t, {
            ...n,
            debugId: e,
            status: "new"
        }), $88ab1a78ec8ca4b4$var$fr(e));
    }
};
globalThis.logDevToolsWarning = $88ab1a78ec8ca4b4$var$dr;
var $88ab1a78ec8ca4b4$var$fr = (o)=>{
    let e = window.__INFINITE_TABLE_DEVTOOLS_HOOK__;
    if (!e) return;
    let t = $88ab1a78ec8ca4b4$var$It.get(o);
    t && e(o, t);
};
var $88ab1a78ec8ca4b4$var$yp = !0, $88ab1a78ec8ca4b4$var$pS = ()=>new Promise((o)=>{
        $88ab1a78ec8ca4b4$var$ke(o);
    }), $88ab1a78ec8ca4b4$var$mS = {
    originalDataArray: !0,
    changes: !0
}, $88ab1a78ec8ca4b4$var$gS = {
    filterValue: (o, e)=>JSON.stringify(o) === JSON.stringify(e),
    groupRowsState: (o, e)=>JSON.stringify(o) === JSON.stringify(e)
};
function $88ab1a78ec8ca4b4$var$Qt(o, e, t) {
    let n = o.multiSort ? o.sortInfo : o.sortInfo?.[0] ?? null, r = {
        append: !1,
        originalDataArray: o.originalDataArray,
        sortInfo: n,
        refetchKey: o.refetchKey,
        groupBy: o.groupBy,
        pivotBy: o.pivotBy,
        filterValue: o.filterValue,
        aggregationReducers: o.aggregationReducers
    };
    if (t && (r.masterRowInfo = t.masterRowInfo), r.groupBy && (r.groupRowsState = o.groupRowsState.getState()), o.livePagination !== void 0 && (r.livePaginationCursor = o.livePaginationCursor, r.__cursorId = o.cursorId), o.lazyLoad && (o.lazyLoadBatchSize != null && o.lazyLoadBatchSize > 0 && (r.lazyLoadBatchSize = o.lazyLoadBatchSize, r.lazyLoadStartIndex = 0), r.groupKeys = []), e && Object.assign(r, e), r.filterValue && r.filterValue.length) {
        let l = $88ab1a78ec8ca4b4$var$Cp(r.filterValue, {
            filterMode: o.filterMode,
            filterTypes: o.filterTypes
        });
        l && l.length && (r.filterValue = l);
    }
    let i = {}, a = o.dataParams || {};
    for(let l in r)if (r.hasOwnProperty(l) && !$88ab1a78ec8ca4b4$var$mS[l]) {
        let s = l, c = $88ab1a78ec8ca4b4$var$gS[s], u = r[s], d = a[s];
        (c ? c(u, d) : u === d) || (i[s] = !0);
    }
    return r.changes = i, r;
}
function $88ab1a78ec8ca4b4$var$Bn(o, e, t, n, r) {
    let i = $88ab1a78ec8ca4b4$var$Qt(e, n, r), a = i.append;
    if (e.lazyLoad) {
        let s = e.originalLazyGroupData, c = [
            $88ab1a78ec8ca4b4$var$yn,
            ...i.groupKeys || []
        ], u = s.get(c);
        if (!u) {
            let d = [
                ...i.groupKeys || [],
                i.lazyLoadStartIndex
            ];
            e.lazyLoadCacheOfLoadedBatches.set(d, !0);
        }
        if (u && u.cache && c.length > 1) {
            let d = u.children, f = d.length, p = !0;
            for(let m = 0; m < f; m++)if (d[m] == null) {
                p = !1;
                break;
            }
            if (p) return Promise.resolve(!0);
        }
        u ? u.childrenLoading || (u.childrenLoading = !0) : s.set(c, {
            error: void 0,
            children: [],
            childrenLoading: !0,
            childrenAvailable: !1,
            cache: $88ab1a78ec8ca4b4$var$yp,
            totalCount: 0,
            totalCountUnfiltered: 0
        }), t.originalLazyGroupDataChangeDetect = $88ab1a78ec8ca4b4$var$Ot();
    }
    typeof o == "function" && (o = o(i));
    let l = typeof o == "object" && typeof o.then == "function";
    return l && (!e.lazyLoad || e.lazyLoad && !a) && (t.loading = !0), Promise.resolve(o).then((s)=>{
        let c = [], u = !1;
        if (Array.isArray(s.data)) {
            let f = s;
            if (c = f.data, f.livePaginationCursor !== void 0 && (t.livePaginationCursor = f.livePaginationCursor), f.mappings && (t.pivotMappings = f.mappings), f.totalCountUnfiltered && (t.unfilteredCount = f.totalCountUnfiltered), e.lazyLoad) {
                let m = function(g, b, h) {
                    let y = [
                        $88ab1a78ec8ca4b4$var$yn,
                        ...g
                    ], S = b.data, C = {
                        cache: b.cache ?? $88ab1a78ec8ca4b4$var$yp,
                        childrenLoading: !1,
                        childrenAvailable: !0,
                        totalCount: b.totalCount ?? S.length,
                        totalCountUnfiltered: b.totalCount ?? S.length,
                        children: S,
                        error: b.error
                    }, T = [];
                    if (i.lazyLoadBatchSize && !h) {
                        let w = p.get(y), v = !w, R = $88ab1a78ec8ca4b4$var$lu({
                            children: !0
                        }, w || {}, C);
                        v && (R.chidren = []), R.children.length = R.totalCount;
                        let x = i.lazyLoadStartIndex ?? 0, M = Math.min(b.totalCount ?? S.length, x + i.lazyLoadBatchSize);
                        for(let A = x; A < M; A++){
                            let E = C.children[A - x];
                            if (!E) throw `lazily loaded item not found at index ${A - x}`;
                            R.children[A] = E, E.dataset && T.push({
                                keys: E.keys,
                                dataset: E.dataset
                            });
                        }
                        v && p.set(y, R);
                    } else C.children.forEach((w)=>{
                        w && w.dataset && T.push({
                            keys: w.keys,
                            dataset: w.dataset
                        });
                    }), C.children.length = C.totalCount, p.set(y, C);
                    let I = !1;
                    if (!g || !g.length) {
                        let w = p.get([
                            $88ab1a78ec8ca4b4$var$yn
                        ]);
                        t.originalDataArray = [
                            ...w.children
                        ], I = !0;
                    }
                    if (I || (t.originalLazyGroupDataChangeDetect = $88ab1a78ec8ca4b4$var$Ot()), T.length) {
                        let w = g;
                        T.forEach(({ keys: v, dataset: R })=>{
                            m(v, R, w);
                        });
                    }
                };
                var d = m;
                let p = e.originalLazyGroupData;
                u = !0, m(i.groupKeys || [], f);
            }
        } else c = s;
        u || (t.originalDataArray = a ? e.originalDataArray.concat(c) : c), l && (!e.lazyLoad || e.lazyLoad && !a) && (t.loading = !1);
    });
}
function $88ab1a78ec8ca4b4$var$Cp(o, { filterTypes: e, filterMode: t }) {
    return t === "local" ? o : ($88ab1a78ec8ca4b4$var$ts(o, e) || []).map((n)=>{
        let r = {
            ...n
        };
        return delete r.valueGetter, r;
    });
}
function $88ab1a78ec8ca4b4$var$Tp(o, e) {
    let t = !!o, { stateReadyAsDetails: n } = e(), r = t && o.shouldRestoreState ? n : !0;
    return {
        isDetail: t,
        isDetailReady: r
    };
}
function $88ab1a78ec8ca4b4$var$wp(o) {
    let { getComponentState: e, componentActions: t, componentState: n } = o, { data: r, dataArray: i, notifyScrollbarsChange: a, refetchKey: l, sortInfo: s, shouldReloadData: c, groupBy: u, pivotBy: d, filterValue: f, filterMode: p, livePagination: m, livePaginationCursor: g, filterTypes: b, cursorId: h } = n, [y, S] = (0, $acw62.useState)({
        vertical: !1,
        horizontal: !1
    }), C = (0, $acw62.useRef)(y);
    (0, $acw62.useEffect)(()=>(a.onChange((x)=>{
            x && (C.current = x, S(x));
        }), ()=>a.destroy()), [
        a
    ]), (0, $acw62.useEffect)(()=>{
        if (!m) return;
        let x = requestAnimationFrame(()=>{
            C.current?.vertical || g && (t.cursorId = g);
        });
        return ()=>cancelAnimationFrame(x);
    }, [
        g
    ]), (0, $acw62.useEffect)(()=>{
        if (!m || g !== void 0) return;
        let x = requestAnimationFrame(()=>{
            C.current?.vertical || h != null && i.length && (t.cursorId = i.length);
        });
        return ()=>cancelAnimationFrame(x);
    }, [
        i.length,
        g
    ]), (0, $acw62.useEffect)(()=>{
        let x = e(), { livePaginationCursor: M, livePagination: A, dataArray: E } = x;
        !y.vertical && A && (M ? t.cursorId = M : M === void 0 && E.length && (t.cursorId = E.length));
    }, [
        y.vertical
    ]);
    let T = (0, $acw62.useMemo)(()=>$88ab1a78ec8ca4b4$var$Cp(f, {
            filterTypes: b,
            filterMode: p
        }), [
        f,
        p,
        b
    ]), I = {
        sortInfo: c.sortInfo ? s : null,
        groupBy: c.groupBy ? u : null,
        pivotBy: c.pivotBy ? d : null,
        refetchKey: l,
        filterValue: c.filterValue ? T : null,
        cursorId: m ? h : null
    }, w = (0, $acw62.useRef)(!0);
    $88ab1a78ec8ca4b4$var$hS(o, {
        sortInfo: s,
        groupBy: u,
        pivotBy: d,
        filterValue: f,
        refetchKey: l,
        cursorId: m ? h : null
    });
    let v = $88ab1a78ec8ca4b4$var$Me($88ab1a78ec8ca4b4$var$Ve()), R = (0, $acw62.useRef)([]);
    $88ab1a78ec8ca4b4$export$8b8dc02abb309004(()=>{
        let x = e(), M = v(), { isDetail: A, isDetailReady: E } = $88ab1a78ec8ca4b4$var$Tp(M, e);
        if (A && !E) return;
        let P = Date.now(), _ = R.current;
        _.length >= 10 && _.splice(0, 1), _.push(P), P - _[0] < 200 && _.length >= 10 && $88ab1a78ec8ca4b4$var$dr({
            debugId: x.debugId,
            key: "DS001"
        }), typeof x.data != "function" && $88ab1a78ec8ca4b4$var$Bn(x.data, x, t, void 0, M);
    }, {
        data: r
    }), $88ab1a78ec8ca4b4$export$8b8dc02abb309004((x)=>{
        let M = Object.keys(x), A = !1;
        if (M.length === 1) {
            if (A = !!x.cursorId, x.filterValue && e().filterMode === "local") return;
            let O = e().data;
            if (Array.isArray(O) && x.refetchKey) {
                t.originalDataArray = O;
                return;
            }
        }
        let E = v(), { isDetail: P, isDetailReady: _ } = $88ab1a78ec8ca4b4$var$Tp(E, e);
        if (P && !_) return;
        let D = e();
        if (typeof D.data == "function") {
            let O;
            D.debugId && (O = $88ab1a78ec8ca4b4$var$qe(D.debugId).track.DataSource.label.RemoteDataLoad.start()), $88ab1a78ec8ca4b4$var$Bn(D.data, D, t, {
                append: A
            }, E).then(()=>{
                O?.end();
            });
        }
    }, {
        ...I,
        data: r
    }), $88ab1a78ec8ca4b4$export$8b8dc02abb309004(()=>{
        let x = e();
        if (w.current) {
            w.current = !1;
            let M = $88ab1a78ec8ca4b4$var$Qt(x, void 0, v());
            t.dataParams = M;
        }
    }, I);
}
function $88ab1a78ec8ca4b4$var$hS(o, e) {
    let { getComponentState: t, componentActions: n, componentState: r } = o;
    (0, $acw62.useEffect)(()=>{
        n.lazyLoadCacheOfLoadedBatches = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
    }, [
        r.data,
        r.dataParams
    ]);
    let { lazyLoadBatchSize: i, lazyLoad: a, originalLazyGroupDataChangeDetect: l, notifyRenderRangeChange: s, dataArray: c, groupRowsState: u, scrollStopDelayUpdatedByTable: d } = r, f = (0, $acw62.useRef)(null), p = (g, b, h = t().lazyLoadCacheOfLoadedBatches)=>{
        let y = t();
        if (g = g || f.current, !g) return;
        let { renderStartIndex: S, renderEndIndex: C } = g, { lazyLoadBatchSize: T, lazyLoad: I } = y;
        I && ((!T || T <= 0) && (!y.groupBy || y.groupBy.length === 0) || $88ab1a78ec8ca4b4$var$bS({
            startIndex: S,
            endIndex: C,
            lazyLoadBatchSize: T,
            componentState: y,
            componentActions: n,
            dismissLoadedRows: b?.dismissLoadedRows ?? !1
        }, h));
    }, m = (0, $acw62.useMemo)(()=>$88ab1a78ec8ca4b4$export$61fc7d43ac8f84b0(p, {
            wait: d
        }), [
        d
    ]);
    $88ab1a78ec8ca4b4$export$8b8dc02abb309004((g)=>{
        if (a) return g.sortInfo || g.filterValue || g.groupBy || g.pivotBy || g.refetchKey || g.cursorId ? (t().lazyLoadCacheOfLoadedBatches.clear(), t().originalLazyGroupData.clear(), p(s.get(), {
            dismissLoadedRows: !0
        })) : (g.originalLazyGroupDataChangeDetect || g.groupRowsState) && p(s.get()), s.onChange((b)=>{
            f.current = b, p(b);
        });
    }, {
        sortInfo: e.sortInfo,
        filterValue: e.filterValue,
        groupBy: e.groupBy,
        pivotBy: e.pivotBy,
        refetchKey: e.refetchKey,
        cursorId: e.cursorId,
        lazyLoadBatchSize: i,
        lazyLoad: a,
        originalLazyGroupDataChangeDetect: l,
        groupRowsState: u
    }), (0, $acw62.useEffect)(()=>{
        i && i > 0 && m();
    }, [
        c
    ]);
}
function $88ab1a78ec8ca4b4$var$bS(o, e) {
    let { startIndex: t, endIndex: n, lazyLoadBatchSize: r, componentState: i, componentActions: a, dismissLoadedRows: l } = o, { dataArray: s } = i, c = l ? ()=>!1 : (g)=>s[g].data != null, u = !l, d = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00, f = [
        "_______xxx______"
    ];
    for(let g = t; g <= n; g++){
        let b = s[g];
        if (!b) continue;
        let h = c(g), y = b.dataSourceHasGrouping && b.groupKeys ? [
            ...b.groupKeys
        ] : [];
        b.isGroupRow && b.dataSourceHasGrouping && b.groupKeys && y.pop();
        let S = y.length ? y : f, C = b.dataSourceHasGrouping ? b.indexInGroup : b.indexInAll;
        if (b.isGroupRow && !b.collapsed && !b.childrenAvailable) {
            let T = {
                lazyLoadStartIndex: 0,
                lazyLoadBatchSize: r,
                groupKeys: b.groupKeys,
                append: u
            }, I = b.groupKeys, w = d.get(I);
            if (!w?.[b.id]) {
                let v = !w;
                w = w || {}, w[b.id] || (w[b.id] = T), v && d.set(I, w);
            }
        }
        if (!h && r != null) {
            let T = d.get(S), I = Math.floor(C / r) * r, w = C - I, v = s[b.indexInAll - w].indexInAll, R = c(v), x = s[v].id;
            if (R || T?.[x]) continue;
            let M = !T;
            T = T || {};
            let A = {
                lazyLoadStartIndex: I,
                lazyLoadBatchSize: r,
                groupKeys: y,
                append: u
            };
            T[x] || (T[x] = A), M && d.set(S, T);
        }
    }
    let p = Promise.resolve(!0), m = [];
    d.topDownValues().forEach((g)=>{
        m.push(...Object.values(g));
    }), m.reduce((g, b)=>{
        let h = [
            ...b.groupKeys,
            b.lazyLoadStartIndex
        ];
        if (e && e.has(h)) return g;
        e?.set(h, !0);
        let y = [
            i.data,
            i,
            a,
            b
        ];
        return g.then(()=>$88ab1a78ec8ca4b4$var$pS()).then(()=>$88ab1a78ec8ca4b4$var$Bn(...y));
    }, p);
}
var $88ab1a78ec8ca4b4$var$yS = Object.freeze([]), $88ab1a78ec8ca4b4$var$Ip = (o, e)=>{
    let t = o ?? $88ab1a78ec8ca4b4$var$yS, n = Array.isArray(t) ? t : [
        t
    ];
    if (e && e.has(t)) {
        let r = e.get(t);
        if (r && r.length === n.length) return r;
    }
    return e && t && e.set(t, n), n;
};
function $88ab1a78ec8ca4b4$var$zi(o, e) {
    if (o === e) return !0;
    if (o == null || e == null) return o === e;
    if (typeof o != typeof e) return !1;
    if (Array.isArray(o) && Array.isArray(e)) {
        if (o.length !== e.length) return !1;
        for(let t = 0, n = o.length; t < n; t++)if (!$88ab1a78ec8ca4b4$var$zi(o[t], e[t])) return !1;
        return !0;
    }
    if (typeof o == "object") {
        let t = Object.keys(o), n = Object.keys(e);
        if (t.length !== n.length) return !1;
        for (let r of t)if (!Object.prototype.hasOwnProperty.call(e, r) || !$88ab1a78ec8ca4b4$var$zi(o[r], e[r])) return !1;
        return !0;
    }
    return !1;
}
function $88ab1a78ec8ca4b4$var$TS(o, e) {
    return !(o === void 0 || e === void 0 || o.isGroupRow !== e.isGroupRow || o.dataSourceHasGrouping !== e.dataSourceHasGrouping || o.isTreeNode !== e.isTreeNode || o.isTreeNode && o.isParentNode !== e.isParentNode);
}
var $88ab1a78ec8ca4b4$var$Vi = {
    id: !0,
    value: !0,
    indexInAll: !0,
    rowSelected: !0,
    rowDisabled: !0,
    isCellSelected: !1,
    hasSelectedCells: !1
}, $88ab1a78ec8ca4b4$var$vp = {
    ...$88ab1a78ec8ca4b4$var$Vi,
    dataSourceHasGrouping: !0,
    isTreeNode: !0,
    data: !1,
    isGroupRow: !0,
    selfLoaded: !0
}, $88ab1a78ec8ca4b4$var$SS = {
    indexInGroup: !0,
    groupKeys: !0,
    groupBy: !0,
    rootGroupBy: !0,
    parents: !1,
    indexInParentGroups: !0,
    groupCount: !0,
    groupNesting: !0,
    collapsed: !0,
    selfLoaded: !0
}, $88ab1a78ec8ca4b4$var$CS = {
    ...$88ab1a78ec8ca4b4$var$Vi,
    ...$88ab1a78ec8ca4b4$var$SS,
    dataSourceHasGrouping: !0,
    isTreeNode: !0,
    data: !1,
    reducerData: !0,
    isGroupRow: !0,
    duplicateOf: !1,
    deepRowInfoArray: !1,
    error: !0,
    reducerResults: !0,
    groupCount: !0,
    groupData: !0,
    selectedChildredCount: !0,
    deselectedChildredCount: !0,
    totalChildrenCount: !0,
    collapsedChildrenCount: !0,
    collapsedGroupsCount: !0,
    directChildrenCount: !0,
    directChildrenLoadedCount: !0,
    pivotValuesMap: !0,
    childrenAvailable: !0,
    childrenLoading: !0
}, $88ab1a78ec8ca4b4$var$Rp = {
    isTreeNode: !0,
    isParentNode: !0,
    indexInParent: !0,
    nodePath: !0,
    parentNodes: !1,
    indexInParentNodes: !0,
    totalLeafNodesCount: !0,
    collapsedLeafNodesCount: !0,
    treeNesting: !0,
    selfLoaded: !0
}, $88ab1a78ec8ca4b4$var$wS = {
    ...$88ab1a78ec8ca4b4$var$Vi,
    ...$88ab1a78ec8ca4b4$var$Rp,
    dataSourceHasGrouping: !0,
    isTreeNode: !0,
    isGroupRow: !0,
    isParentNode: !0,
    data: !1
}, $88ab1a78ec8ca4b4$var$IS = {
    ...$88ab1a78ec8ca4b4$var$Vi,
    ...$88ab1a78ec8ca4b4$var$Rp,
    dataSourceHasGrouping: !0,
    isParentNode: !0,
    isGroupRow: !0,
    nodeExpanded: !0,
    selfExpanded: !0,
    data: !1,
    selectedLeafNodesCount: !0,
    deepRowInfoArray: !1,
    deselectedLeafNodesCount: !0,
    duplicateOf: !1
}, $88ab1a78ec8ca4b4$var$vS = Object.entries($88ab1a78ec8ca4b4$var$vp).map(([o, e])=>e ? o : void 0).filter(Boolean), $88ab1a78ec8ca4b4$var$RS = Object.entries($88ab1a78ec8ca4b4$var$vp).map(([o, e])=>e ? o : void 0), $88ab1a78ec8ca4b4$var$xS = Object.entries($88ab1a78ec8ca4b4$var$CS).map(([o, e])=>e ? o : void 0), $88ab1a78ec8ca4b4$var$PS = Object.entries($88ab1a78ec8ca4b4$var$wS).map(([o, e])=>e ? o : void 0), $88ab1a78ec8ca4b4$var$DS = Object.entries($88ab1a78ec8ca4b4$var$IS).map(([o, e])=>e ? o : void 0);
function $88ab1a78ec8ca4b4$var$MS(o, e) {
    if (o === e) return !0;
    if (!o || !e || !$88ab1a78ec8ca4b4$var$TS(o, e) || o.id !== e.id || o.data !== e.data && !$88ab1a78ec8ca4b4$var$zi(o.data, e.data)) return !1;
    let t = [];
    o.dataSourceHasGrouping ? t = o.isGroupRow ? $88ab1a78ec8ca4b4$var$xS : $88ab1a78ec8ca4b4$var$RS : o.isTreeNode ? t = o.isTreeNode && o.isParentNode ? $88ab1a78ec8ca4b4$var$DS : $88ab1a78ec8ca4b4$var$PS : t = $88ab1a78ec8ca4b4$var$vS;
    for (let n of t){
        let r = o[n], i = e[n];
        if (!(typeof r == "function" || typeof i == "function") && !$88ab1a78ec8ca4b4$var$zi(r, i)) return !1;
    }
    return !0;
}
function $88ab1a78ec8ca4b4$var$xp() {
    let o = [], e = new Map, t = (s, c)=>{
        let u = o, d = c?.marker;
        d && d.start({
            details: [
                {
                    name: "new dataArray length",
                    value: s.length
                },
                {
                    name: "old dataArray length",
                    value: u.length
                }
            ]
        });
        let f = [], p = i();
        for (let m of p){
            let g = u[m], b = s[m];
            if (b === void 0) {
                f.push(m);
                continue;
            }
            $88ab1a78ec8ca4b4$var$MS(g, b) || f.push(m);
        }
        o = s, f.length > 0 && queueMicrotask(()=>{
            for(let m = 0, g = f.length; m < g; m++){
                let b = f[m], h = e.get(b);
                if (h) for (let y of h)y();
            }
        }), d && d.end({
            details: [
                {
                    name: "updated row infos",
                    value: f.length
                }
            ]
        });
    }, n = (s)=>o[s], r = (s, c)=>{
        let u = e.get(s);
        return u || (u = new Set, e.set(s, u)), u.add(c), ()=>{
            let d = e.get(s);
            d && (d.delete(c), d.size === 0 && e.delete(s));
        };
    }, i = ()=>Array.from(e.keys());
    return {
        notifyDataArray: t,
        getRowInfoAtIndex: n,
        subscribeToRowIndex: r,
        getDataArray: ()=>o,
        clear: ()=>{
            o = [], e.clear();
        }
    };
}
var $88ab1a78ec8ca4b4$var$ES = Symbol("cursorId"), $88ab1a78ec8ca4b4$var$Pp = (o)=>o.totalLeafNodesCount === 0, $88ab1a78ec8ca4b4$var$AS = (o)=>o.isParentNode ? !$88ab1a78ec8ca4b4$var$Pp(o) : !0;
function $88ab1a78ec8ca4b4$var$Dp(o) {
    let e = Date.now(), t = [], n = [], r = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
    return {
        logger: $88ab1a78ec8ca4b4$var$St(`${o.debugId}:DataSource`),
        debugTimings: new Map,
        debugWarnings: new Map,
        devToolsDetected: !!globalThis.__INFINITE_TABLE_DEVTOOLS_HOOK__,
        rowInfoStore: $88ab1a78ec8ca4b4$var$xp(),
        indexer: new $88ab1a78ec8ca4b4$var$Mi,
        totalLeafNodesCount: 0,
        __apiRef: {
            current: null
        },
        repeatWrappedGroupRows: !1,
        destroyedRef: {
            current: !1
        },
        lastSelectionUpdatedNodePathRef: {
            current: null
        },
        lastExpandStateInfoRef: {
            current: {
                state: "collapsed",
                nodePath: null
            }
        },
        idToIndexMap: new Map,
        idToPathMap: new Map,
        pathToIndexMap: new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00,
        waitForNodePathPromises: new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00,
        getDataSourceMasterContextRef: {
            current: ()=>{}
        },
        cache: void 0,
        detailDataSourcesStateToRestore: new Map,
        stateReadyAsDetails: !1,
        originalDataArrayChanged: !1,
        originalDataArrayChangedInfo: {
            timestamp: 0,
            mutations: void 0
        },
        rowsPerPage: null,
        lazyLoadCacheOfLoadedBatches: new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00,
        dataParams: void 0,
        onCleanup: $88ab1a78ec8ca4b4$var$ye(),
        notifyScrollbarsChange: $88ab1a78ec8ca4b4$var$ye(),
        notifyScrollStop: $88ab1a78ec8ca4b4$var$ye(),
        notifyRenderRangeChange: $88ab1a78ec8ca4b4$var$ye(),
        pivotTotalColumnPosition: "end",
        pivotGrandTotalColumnPosition: !1,
        scrollStopDelayUpdatedByTable: 100,
        originalLazyGroupData: r,
        originalLazyGroupDataChangeDetect: 0,
        originalDataArray: t,
        cursorId: $88ab1a78ec8ca4b4$var$ES,
        showSeparatePivotColumnForSingleAggregation: !1,
        propsCache: new Map([
            [
                "sortInfo",
                new WeakMap
            ],
            [
                "rowDisabledState",
                new WeakMap
            ]
        ]),
        rowInfoReducerResults: void 0,
        pivotMappings: void 0,
        pivotColumns: void 0,
        pivotColumnGroups: void 0,
        dataArray: n,
        unfilteredCount: n.length,
        filteredCount: n.length,
        updatedAt: e,
        groupedAt: 0,
        sortedAt: 0,
        treeAt: 0,
        filteredAt: 0,
        reducedAt: e,
        generateGroupRows: !0,
        groupDeepMap: void 0,
        reducerResults: void 0,
        allRowsSelected: !1,
        someRowsSelected: !1,
        postSortDataArray: void 0,
        postGroupDataArray: void 0,
        lastSortDataArray: void 0,
        lastGroupDataArray: void 0,
        forceRerenderTimestamp: 0
    };
}
function $88ab1a78ec8ca4b4$var$_S(o) {
    let e = {
        ...o
    };
    return delete e.originalDataArray, e;
}
var $88ab1a78ec8ca4b4$var$OS = [], $88ab1a78ec8ca4b4$var$Mp = (o)=>{
    o.destroyedRef.current = !0, o.__apiRef.current = null, o.lastSelectionUpdatedNodePathRef.current = null, o.lastExpandStateInfoRef.current = {
        state: "collapsed",
        nodePath: null
    }, o.treeExpandState?.destroy(), o.treePaths?.clear(), o.unfilteredTreePaths?.clear(), o.waitForNodePathPromises.clear(), o.pathToIndexMap?.clear(), o.rowDisabledState?.destroy(), o.groupRowsState?.destroy(), o.treeSelectionState?.destroy(), o.idToPathMap.clear(), o.idToIndexMap.clear(), o.rowInfoStore.clear();
}, $88ab1a78ec8ca4b4$var$Ep = (o, e)=>({
        onDataParamsChange: (t)=>t ? $88ab1a78ec8ca4b4$var$ip(t, 100, $88ab1a78ec8ca4b4$var$_S) : void 0,
        lazyLoad: (t)=>!!t,
        isNodeReadOnly: (t)=>t ?? $88ab1a78ec8ca4b4$var$Pp,
        isNodeSelectable: (t)=>t ?? $88ab1a78ec8ca4b4$var$AS,
        data: 1,
        nodesKey: 1,
        isNodeExpanded: 1,
        isNodeCollapsed: 1,
        pivotBy: 1,
        primaryKey: 1,
        livePagination: 1,
        treeSelection: 1,
        refetchKey: (t)=>t ?? "",
        filterFunction: 1,
        treeFilterFunction: 1,
        filterValue: 1,
        useGroupKeysForMultiRowSelection: (t)=>t ?? !1,
        filterDelay: (t)=>t ?? 200,
        filterTypes: (t)=>({
                ...$88ab1a78ec8ca4b4$export$c41ade90600bede4,
                ...t
            }),
        sortTypes: (t)=>({
                ...$88ab1a78ec8ca4b4$var$ur,
                ...t
            }),
        sortFunction: 1,
        onReady: 1,
        rowInfoReducers: (t, n)=>{
            let r = {
                initialValue: ()=>{
                    n.idToIndexMap.clear();
                },
                reducer: (a, l)=>{
                    e.debugId && !e.nodesKey && n.idToIndexMap.has(l.id) && console.warn(`Duplicate id found in data source: ${l.id}`), n.idToIndexMap.set(l.id, l.indexInAll);
                }
            }, i = t ? {
                ...t,
                __idToIndex: r
            } : {
                __idToIndex: r
            };
            if (e.nodesKey) {
                let a = {
                    initialValue: ()=>{
                        n.idToPathMap.clear(), n.pathToIndexMap.clear();
                    },
                    reducer: (l, s)=>{
                        s.isTreeNode && (n.idToPathMap.set(s.id, s.nodePath), e.debugId && n.pathToIndexMap.has(s.nodePath) && console.warn(`Duplicate node path found in data source (debugId: ${e.debugId || "none"}): ${s.nodePath}`), n.pathToIndexMap.set(s.nodePath, s.indexInAll));
                    }
                };
                i.__pathToIndex = a;
            }
            return i;
        },
        onNodeCollapse: 1,
        onNodeExpand: 1,
        batchOperationDelay: 1,
        isRowSelected: 1,
        isNodeSelected: 1,
        isRowDisabled: 1,
        rowDisabledState: (t)=>{
            if (!t) return null;
            if (t instanceof $88ab1a78ec8ca4b4$export$7cb388ded2a86ac7) return t;
            let n = o.propsCache.get("rowDisabledState") ?? $88ab1a78ec8ca4b4$var$Nt, r = n.get(t);
            return r || (r = new $88ab1a78ec8ca4b4$export$7cb388ded2a86ac7(t), n.set(t, r)), t = r, t ?? null;
        },
        onDataArrayChange: 1,
        onDataMutations: 1,
        onTreeDataMutations: 1,
        aggregationReducers: 1,
        collapseGroupRowsOnDataFunctionChange: (t)=>t ?? !0,
        loading: (t)=>t ?? !1,
        sortInfo: (t)=>$88ab1a78ec8ca4b4$var$Ip(t, o.propsCache.get("sortInfo")),
        groupBy: (t)=>t ?? $88ab1a78ec8ca4b4$var$OS
    });
function $88ab1a78ec8ca4b4$var$NS(o, e) {
    return typeof o == "function" ? o({
        array: e.originalDataArray,
        length: e.originalDataArray.length,
        lastItem: e.originalDataArray[e.originalDataArray.length - 1]
    }) : o;
}
var $88ab1a78ec8ca4b4$var$Nt = new WeakMap;
function $88ab1a78ec8ca4b4$var$FS(o) {
    if (typeof o == "boolean") return {
        filterValue: o,
        sortInfo: o,
        groupBy: o,
        pivotBy: o
    };
    let e = {};
    return o.filterValue != null && (e.filterValue = o.filterValue), o.sortInfo != null && (e.sortInfo = o.sortInfo), o.groupBy != null && (e.groupBy = o.groupBy), o.pivotBy != null && (e.pivotBy = o.pivotBy), e;
}
var $88ab1a78ec8ca4b4$var$LS = {
    selectedPaths: [],
    deselectedPaths: [],
    defaultSelection: !1
};
function $88ab1a78ec8ca4b4$var$mp(o, e, t) {
    if (e != "multi-row") throw new Error(`TreeSelectionState is only supported for multi-row selection. Your current selection mode is "${e}". See https://infinite-table.com/docs/reference/datasource-props#selectionMode for details. 


`);
    let n = $88ab1a78ec8ca4b4$var$To(t);
    if (o instanceof $88ab1a78ec8ca4b4$export$3feed6aa923fae79) return o.setConfig(n), o;
    (o == null || typeof o != "object") && (o = void 0);
    let r = o ?? $88ab1a78ec8ca4b4$var$LS, i = $88ab1a78ec8ca4b4$var$Nt.get(r);
    return i && i.setConfig(n), i = i ?? new $88ab1a78ec8ca4b4$export$3feed6aa923fae79(r, n), $88ab1a78ec8ca4b4$var$Nt.set(r, i), i;
}
function $88ab1a78ec8ca4b4$var$Ap(o) {
    let { props: e, state: t, oldState: n } = o, r = !!t.nodesKey, i = $88ab1a78ec8ca4b4$var$Ho(e.sortInfo), a = $88ab1a78ec8ca4b4$var$Ho(e.filterValue), { filterTypes: l } = t, s = Object.keys(l).reduce((P, _)=>{
        let D = l[_].operators;
        P[_] = P[_] || {};
        let O = P[_];
        return D.forEach((F)=>{
            O[F.name] = F;
        }), P;
    }, {}), c = e, u = e.selectionMode;
    if (u === void 0) {
        if (e.cellSelection !== void 0 || e.defaultCellSelection !== void 0) u = "multi-cell";
        else {
            let P = e.rowSelection !== void 0 ? e.rowSelection : e.defaultRowSelection;
            if (P !== void 0 && (P && typeof P == "object" ? u = "multi-row" : u = "single-row"), !u) {
                let _ = c.treeSelection ?? c.defaultTreeSelection;
                _ !== void 0 && (u = typeof _ == "object" ? "multi-row" : "single-row");
            }
            u = u ?? !1;
        }
    }
    let d = null, f = null, p = e.rowSelection !== void 0 ? e.rowSelection : t.rowSelection === void 0 ? e.defaultRowSelection !== void 0 ? e.defaultRowSelection : null : t.rowSelection, m = e.cellSelection !== void 0 ? e.cellSelection : t.cellSelection === void 0 ? e.defaultCellSelection !== void 0 ? e.defaultCellSelection : null : t.cellSelection || null;
    if (!r && (u !== !1 && (u === "single-row" || u === "multi-row") && (p === null ? d = u === "single-row" ? null : new $88ab1a78ec8ca4b4$export$fdba2ac35241013c({
        selectedRows: [],
        deselectedRows: [],
        defaultSelection: !1
    }, $88ab1a78ec8ca4b4$var$at(t)) : u === "single-row" || p instanceof $88ab1a78ec8ca4b4$export$fdba2ac35241013c ? d = p : d = new $88ab1a78ec8ca4b4$export$fdba2ac35241013c(p, $88ab1a78ec8ca4b4$var$at(t))), u === "single-cell" || u === "multi-cell")) {
        if (m === null) f = u === "single-cell" ? null : new $88ab1a78ec8ca4b4$export$31e3cce2e16ab248;
        else if (m instanceof $88ab1a78ec8ca4b4$export$31e3cce2e16ab248) f = m;
        else {
            let P = $88ab1a78ec8ca4b4$var$Nt.get(m) ?? new $88ab1a78ec8ca4b4$export$31e3cce2e16ab248(m);
            $88ab1a78ec8ca4b4$var$Nt.set(m, P), f = P;
        }
    }
    let g = t.primaryKey, b = typeof g == "function" ? (P)=>g(P) : (P)=>P[g], h = c.treeExpandState || t.treeExpandState || c.defaultTreeExpandState;
    if (h && !(h instanceof $88ab1a78ec8ca4b4$export$bb181fe227550f9d)) {
        let P = $88ab1a78ec8ca4b4$var$Nt.get(h) ?? new $88ab1a78ec8ca4b4$export$bb181fe227550f9d(h);
        $88ab1a78ec8ca4b4$var$Nt.set(h, P), h = P;
    }
    h = h || new $88ab1a78ec8ca4b4$export$bb181fe227550f9d({
        defaultExpanded: !0,
        collapsedPaths: []
    });
    let y = e.groupRowsState || t.groupRowsState || e.defaultGroupRowsState;
    if (y && !(y instanceof $88ab1a78ec8ca4b4$export$f4a923078262b9c3)) {
        let P = $88ab1a78ec8ca4b4$var$Nt.get(y) ?? new $88ab1a78ec8ca4b4$export$f4a923078262b9c3(y);
        $88ab1a78ec8ca4b4$var$Nt.set(y, P), y = P;
    }
    y = y || new $88ab1a78ec8ca4b4$export$f4a923078262b9c3(t.lazyLoad ? {
        expandedRows: [],
        collapsedRows: !0
    } : {
        expandedRows: !0,
        collapsedRows: []
    });
    let S = $88ab1a78ec8ca4b4$var$FS(e.shouldReloadData || {}), C = e.groupMode ?? (S.groupBy != null ? S.groupBy ? "remote" : "local" : void 0), T = e.sortMode ?? S.sortInfo != null ? S.sortInfo ? "remote" : "local" : void 0, I = e.filterMode ?? S.filterValue != null ? S.filterValue ? "remote" : "local" : void 0;
    e.groupMode && $88ab1a78ec8ca4b4$var$ho('"groupMode" prop is deprecated for the <DataSource />, use "shouldReloadData.groupBy: true|false" instead', "groupMode deprecated", t.logger), e.sortMode && $88ab1a78ec8ca4b4$var$ho('"sortMode" prop is deprecated for the <DataSource />, use "shouldReloadData.sortInfo: true|false" instead', "sortMode deprecated", t.logger), e.filterMode && $88ab1a78ec8ca4b4$var$ho('"filterMode" prop is deprecated for the <DataSource />, use "shouldReloadData.filterValue: true|false" instead', "filterMode deprecated", t.logger);
    let w = typeof e.data == "function" ? C ?? "local" : "local", v = e.sortFunction ? "local" : T ?? (i ? "remote" : "local"), R = typeof e.filterFunction == "function" || typeof e.treeFilterFunction == "function" ? "local" : I ?? (typeof e.data == "function" ? "remote" : "local"), x = S.pivotBy ? "remote" : "local", M = t.rowDisabledState, A = e.isRowDisabled;
    if (!A && M) {
        let P = $88ab1a78ec8ca4b4$var$Nt.get(M);
        P ? A = P : (A = (_)=>M.isRowDisabled(_.id), $88ab1a78ec8ca4b4$var$Nt.set(M, A));
    }
    let E = {
        debugId: t.debugId ?? e.debugId,
        isTree: r,
        selectionMode: u,
        groupRowsState: y,
        treeExpandState: h,
        treeExpandMode: h.mode,
        shouldReloadData: {
            filterValue: S?.filterValue ?? R === "remote",
            sortInfo: S?.sortInfo ?? v === "remote",
            groupBy: S?.groupBy ?? w === "remote",
            pivotBy: S?.pivotBy ?? x === "remote"
        },
        isRowDisabled: A,
        rowSelection: d,
        cellSelection: f,
        groupMode: w,
        sortMode: v,
        filterMode: R,
        pivotMode: x,
        toPrimaryKey: b,
        operatorsByFilterType: s,
        controlledSort: i,
        controlledFilter: a,
        multiSort: Array.isArray(i ? e.sortInfo : e.defaultSortInfo),
        lazyLoadBatchSize: typeof e.lazyLoad == "object" ? e.lazyLoad.batchSize : void 0
    };
    if (e.livePagination) {
        let P = !n || n.originalDataArray !== t.originalDataArray, _ = typeof e.livePaginationCursor == "function" ? P ? $88ab1a78ec8ca4b4$var$NS(e.livePaginationCursor, t) : t.livePaginationCursor : e.livePaginationCursor;
        E.livePaginationCursor = _;
    }
    if (t.devToolsDetected && t.debugId) {
        let P = $88ab1a78ec8ca4b4$var$Xt.get(t.debugId);
        P && (E = {
            ...E,
            ...P
        });
    }
    return E;
}
var $88ab1a78ec8ca4b4$var$kS = $88ab1a78ec8ca4b4$var$St("DataSource:fullLazyLoad");
function $88ab1a78ec8ca4b4$var$_p(o, e, t) {
    let { name: n, newValue: r } = o;
    n === "data" && typeof r == "function" && !e.groupRowsState && (e.lazyLoad && $88ab1a78ec8ca4b4$var$kS('"data" function prop has changed'), e.collapseGroupRowsOnDataFunctionChange !== !1 && (t.groupRowsState = new $88ab1a78ec8ca4b4$export$f4a923078262b9c3({
        collapsedRows: !0,
        expandedRows: []
    })));
}
function $88ab1a78ec8ca4b4$var$Op() {
    return {
        rowSelection: (o, e)=>e.selectionMode === "single-row" ? {
                callbackParams: [
                    o,
                    "single-row"
                ]
            } : {
                callbackParams: [
                    o.getState(),
                    "multi-row"
                ]
            },
        treeSelection: (o, e)=>{
            if (e.selectionMode === "single-row") return {
                callbackParams: [
                    o,
                    {
                        selectionMode: "single-row"
                    }
                ]
            };
            let t = e.__apiRef.current, n = t.treeApi;
            return {
                callbackParams: [
                    o.getState(),
                    {
                        treeSelectionState: o,
                        prevTreeSelectionState: e.treeSelectionState,
                        selectionMode: "multi-row",
                        lastUpdatedNodeInfo: e.lastSelectionUpdatedNodePathRef.current,
                        unfilteredTreePaths: e.unfilteredTreePaths,
                        dataSourceApi: t,
                        treeApi: n
                    }
                ]
            };
        },
        treeExpandState: (o, e)=>({
                callbackParams: [
                    o.getState(),
                    {
                        nodeState: e.lastExpandStateInfoRef.current.state,
                        nodePath: e.lastExpandStateInfoRef.current.nodePath,
                        dataSourceApi: e.__apiRef.current
                    }
                ]
            }),
        cellSelection: (o, e)=>e.selectionMode === "single-cell" ? {
                callbackParams: [
                    o instanceof $88ab1a78ec8ca4b4$export$31e3cce2e16ab248 ? o.getState().selectedCells : null,
                    "single-cell"
                ]
            } : {
                callbackParams: [
                    o.getState(),
                    "multi-cell"
                ]
            }
    };
}
function $88ab1a78ec8ca4b4$var$Np() {
    return {
        sortInfo: (o, { actions: e, state: t })=>{
            let n = t.getDataSourceMasterContextRef.current, r = $88ab1a78ec8ca4b4$var$Qt(t, {
                sortInfo: o,
                livePaginationCursor: null
            }, n());
            e.dataParams = r, t.livePagination && $88ab1a78ec8ca4b4$var$ke(()=>{
                e.livePaginationCursor = null;
            });
        },
        groupBy: (o, { actions: e, state: t })=>{
            let n = t.getDataSourceMasterContextRef.current, r = $88ab1a78ec8ca4b4$var$Qt(t, {
                groupBy: o,
                livePaginationCursor: null
            }, n());
            e.dataParams = r, t.livePagination && $88ab1a78ec8ca4b4$var$ke(()=>{
                e.livePaginationCursor = null;
            });
        },
        pivotBy: (o, { actions: e, state: t })=>{
            let n = t.getDataSourceMasterContextRef.current, r = $88ab1a78ec8ca4b4$var$Qt(t, {
                pivotBy: o,
                livePaginationCursor: null
            }, n());
            e.dataParams = r, t.livePagination && $88ab1a78ec8ca4b4$var$ke(()=>{
                e.livePaginationCursor = null;
            });
        },
        filterValue: (o, { actions: e, state: t })=>{
            let n = t.getDataSourceMasterContextRef.current, r = $88ab1a78ec8ca4b4$var$Qt(t, {
                filterValue: o,
                livePaginationCursor: null
            }, n());
            e.dataParams = r, t.livePagination && $88ab1a78ec8ca4b4$var$ke(()=>{
                e.livePaginationCursor = null;
            });
        },
        cursorId: (o, { actions: e, state: t })=>{
            let n = t.getDataSourceMasterContextRef.current, r = $88ab1a78ec8ca4b4$var$Qt(t, {
                __cursorId: o
            }, n());
            e.dataParams = r;
        },
        livePaginationCursor: (o, { actions: e, state: t })=>{
            let n = t.getDataSourceMasterContextRef.current, r = $88ab1a78ec8ca4b4$var$Qt(t, {
                livePaginationCursor: o
            }, n());
            e.dataParams = r;
        },
        dataParams: (o, { state: e })=>$88ab1a78ec8ca4b4$var$wt(o, e.dataParams, new Set([
                "changes",
                "originalDataArray",
                "masterRowInfo"
            ])) ? !1 : ($88ab1a78ec8ca4b4$var$St($88ab1a78ec8ca4b4$var$gn(e.debugId, "DataSource:dataParams"))("onDataParamsChange triggered because the following values have changed", o?.changes), !0)
    };
}
function $88ab1a78ec8ca4b4$var$Fp(o) {
    return {
        originalDataArray: o.originalDataArray,
        groupRowsState: o.groupRowsState,
        groupBy: o.groupBy,
        pivotBy: o.pivotBy,
        sortInfo: o.sortInfo,
        filterValue: o.filterValue,
        livePaginationCursor: o.livePaginationCursor
    };
}
function $88ab1a78ec8ca4b4$export$ffce2aa747f4000f(o) {
    let e = $88ab1a78ec8ca4b4$var$Ve(), t = $88ab1a78ec8ca4b4$var$Me(e), n = !!e, r = n ? e.masterRowInfo.id : "master", { contextValue: i, ContextComponent: a } = $88ab1a78ec8ca4b4$export$92c41314d512b050(o), { componentActions: l, componentState: s, assignState: c } = i;
    s.getDataSourceMasterContextRef.current = t;
    let u = $88ab1a78ec8ca4b4$var$Me(s), [d] = (0, $acw62.useState)(()=>$88ab1a78ec8ca4b4$var$cp({
            getState: u,
            actions: l
        })), f = {
        componentState: s,
        componentActions: l,
        getDataSourceMasterContext: t,
        getState: u,
        assignState: c,
        api: d
    }, p = $88ab1a78ec8ca4b4$var$Me(i), m = $88ab1a78ec8ca4b4$var$Me(f), g = $88ab1a78ec8ca4b4$var$Go(), b = (0, $acw62.useCallback)(({ children: h })=>(typeof h == "function" && (h = h(u())), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(a.Provider, {
            key: r,
            value: p()
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(g.Provider, {
            value: m()
        }, h))), [
        a,
        n,
        r
    ]);
    return (0, $acw62.useLayoutEffect)(()=>{
        e && e.registerDetail(f);
    }, []), (0, $acw62.useLayoutEffect)(()=>()=>{
            let h = u();
            h.onCleanup(h);
        }, []), $88ab1a78ec8ca4b4$var$wp({
        componentState: s,
        componentActions: l,
        getComponentState: u
    }), (0, $acw62.useEffect)(()=>{
        s.onDataArrayChange?.(s.originalDataArray, s.originalDataArrayChangedInfo), s.onDataMutations && s.originalDataArrayChangedInfo.mutations && s.originalDataArrayChangedInfo.mutations.size && s.onDataMutations({
            primaryKeyField: typeof s.primaryKey == "string" ? s.primaryKey : void 0,
            dataArray: s.originalDataArray,
            mutations: s.originalDataArrayChangedInfo.mutations,
            timestamp: s.originalDataArrayChangedInfo.timestamp
        }), s.onTreeDataMutations && s.originalDataArrayChangedInfo.treeMutations && s.originalDataArrayChangedInfo.treeMutations.size && s.onTreeDataMutations({
            nodesKey: s.nodesKey ? s.nodesKey : void 0,
            dataArray: s.originalDataArray,
            treeMutations: s.originalDataArrayChangedInfo.treeMutations,
            timestamp: s.originalDataArrayChangedInfo.timestamp
        });
    }, [
        s.originalDataArrayChangedInfo
    ]), (0, $acw62.useEffect)(()=>{
        s.onReady?.(d);
    }, []), {
        DataSource: b,
        state: f.componentState
    };
}
var $88ab1a78ec8ca4b4$export$d3e437bd1492a8aa = class extends $88ab1a78ec8ca4b4$var$So {
    constructor(t){
        super(t);
        this.isRowDetailsExpanded = (t)=>!!this.isItemPositive(t);
    }
    getState() {
        let t = this.allPositive ? !0 : [
            ...this.positiveMap?.keys() ?? []
        ], n = this.allNegative ? !0 : [
            ...this.negativeMap?.keys() ?? []
        ];
        return {
            expandedRows: t,
            collapsedRows: n
        };
    }
    getPositiveFromState(t) {
        return t.expandedRows;
    }
    getNegativeFromState(t) {
        return t.collapsedRows;
    }
    areAllCollapsed() {
        return this.areAllNegative();
    }
    areAllExpanded() {
        return this.areAllPositive();
    }
    collapseAll() {
        this.makeAllNegative();
    }
    expandAll() {
        this.makeAllPositive();
    }
    isRowDetailsCollapsed(t) {
        return !this.isRowDetailsExpanded(t);
    }
    setRowDetailsExpanded(t, n) {
        return this.setItemValue(t, n);
    }
    collapseRowDetails(t) {
        this.setRowDetailsExpanded(t, !1);
    }
    expandRowDetails(t) {
        this.setRowDetailsExpanded(t, !0);
    }
    toggleRowDetails(t) {
        this.toggleItem(t);
    }
};
var $88ab1a78ec8ca4b4$var$Hi = class Hi {
    constructor(e, t){
        this.keysInOrder = [];
        if (typeof e == "number") this.maxSize = e, this.currentMap = new Map;
        else if (this.maxSize = t ?? Hi.DEFAULT_SIZE, e) {
            let n = Array.from(e);
            this.maxSize < n.length && n.slice(n.length - this.maxSize), this.currentMap = new Map, n.forEach(([r, i])=>{
                this.set(r, i);
            });
        } else this.currentMap = new Map;
    }
    values() {
        return this.currentMap.values();
    }
    get size() {
        return this.currentMap.size;
    }
    delete(e) {
        return this.currentMap.has(e) ? (this.currentMap.delete(e), this.keysInOrder = this.keysInOrder.filter((t)=>t !== e), !0) : !1;
    }
    has(e) {
        return this.currentMap.has(e);
    }
    get(e) {
        return this.currentMap.get(e);
    }
    set(e, t) {
        if (this.has(e) && this.delete(e), this.maxSize - this.currentMap.size <= 0) {
            let [r] = this.keysInOrder.splice(0, 1);
            r != null && this.currentMap.delete(r);
        }
        return this.keysInOrder.push(e), this.currentMap.set(e, t), this;
    }
};
$88ab1a78ec8ca4b4$var$Hi.DEFAULT_SIZE = 10;
var $88ab1a78ec8ca4b4$var$Gi = $88ab1a78ec8ca4b4$var$Hi;
var $88ab1a78ec8ca4b4$var$os = class {
    add(e, t) {}
    get(e) {}
    delete(e) {}
    has(e) {
        return !1;
    }
}, $88ab1a78ec8ca4b4$var$Ki = class {
    constructor(e){
        this.storage = new $88ab1a78ec8ca4b4$var$Gi(e);
    }
    add(e, t) {
        this.storage.set(e, t);
    }
    get(e) {
        return this.storage.get(e);
    }
    delete(e) {
        this.storage.delete(e);
    }
    has(e) {
        return this.storage.has(e);
    }
}, $88ab1a78ec8ca4b4$var$rs = class {
    constructor(){
        this.storage = new Map;
    }
    add(e, t) {
        this.storage.set(e, t);
    }
    get(e) {
        return this.storage.get(e);
    }
    delete(e) {
        this.storage.delete(e);
    }
    has(e) {
        return this.storage.has(e);
    }
}, $88ab1a78ec8ca4b4$export$3b26ed2846f6af2c = class {
    constructor(e){
        this.cacheStorage = e === !1 ? new $88ab1a78ec8ca4b4$var$os : e === !0 ? new $88ab1a78ec8ca4b4$var$rs : typeof e == "number" ? new $88ab1a78ec8ca4b4$var$Ki(e) : new $88ab1a78ec8ca4b4$var$Ki(5);
    }
    add(e, t) {
        this.cacheStorage.add(e, t);
    }
    get(e) {
        return this.cacheStorage.get(e);
    }
    delete(e) {
        this.cacheStorage.delete(e);
    }
    has(e) {
        return this.cacheStorage.has(e);
    }
};
var $88ab1a78ec8ca4b4$export$6e848c151d1cb3a5 = ((e)=>(e.INIT = "INIT", e))($88ab1a78ec8ca4b4$export$6e848c151d1cb3a5 || {});
var { useManagedComponent: $88ab1a78ec8ca4b4$export$92c41314d512b050 } = $88ab1a78ec8ca4b4$export$c6a0e0787a01a4e5({
    debugName: "DataSource",
    initSetupState: $88ab1a78ec8ca4b4$var$Dp,
    forwardProps: $88ab1a78ec8ca4b4$var$Ep,
    concludeReducer: $88ab1a78ec8ca4b4$var$pp,
    mapPropsToState: $88ab1a78ec8ca4b4$var$Ap,
    onPropChange: $88ab1a78ec8ca4b4$var$_p,
    cleanup: $88ab1a78ec8ca4b4$var$Mp,
    interceptActions: $88ab1a78ec8ca4b4$var$Np(),
    mappedCallbacks: $88ab1a78ec8ca4b4$var$Op()
});
function $88ab1a78ec8ca4b4$export$accd73d198d77d2f(o) {
    let { DataSource: e } = $88ab1a78ec8ca4b4$export$ffce2aa747f4000f(o);
    return $acw62.createElement(e, null, o.children ?? null);
}
function $88ab1a78ec8ca4b4$export$b4a1086cfd725745() {
    let { rowInfoReducerResults: o } = $88ab1a78ec8ca4b4$export$c5a52c32d527b09b();
    return o;
}
function $88ab1a78ec8ca4b4$export$937120bc5f19677c() {
    let o = $88ab1a78ec8ca4b4$var$Ve();
    if (o) return o.masterRowInfo;
}
function $88ab1a78ec8ca4b4$var$is(o) {
    let { getComputed: e, getState: t, actions: n } = o, r = t().columnMenuVisibleForColumnId;
    if (!r) return;
    let i = e(), a = i.computedVisibleColumnsMap, l = i.computedColumnOrder;
    if (a.has(r)) {
        n.columnMenuVisibleKey = Date.now();
        return;
    }
    function s(p, m) {
        let g = l[c + p * m], b = a.get(g);
        if (b && b.renderMenuIcon !== !1) return g;
    }
    let c = l.indexOf(r), u = 0, d = -1, f;
    for(; !f && u < l.length && (u++, f = s(u, d), f || (d *= -1, f = s(u, d)), !f););
    return f && (n.columnMenuVisibleForColumnId = f), f;
}
function $88ab1a78ec8ca4b4$var$Bi(o, e) {
    let { rowIndex: t, colIndex: n } = o, { rowIndex: r, colIndex: i } = e, [a, l] = n > i ? [
        i,
        n
    ] : [
        n,
        i
    ], [s, c] = t > r ? [
        r,
        t
    ] : [
        t,
        r
    ];
    return [
        {
            rowIndex: s,
            colIndex: a
        },
        {
            rowIndex: c,
            colIndex: l
        }
    ];
}
function $88ab1a78ec8ca4b4$var$as(o, e, t) {
    let { rowsPerPage: n } = t;
    return n ? Math.floor(o.rowIndex / n) === Math.floor(e.rowIndex / n) : !0;
}
function $88ab1a78ec8ca4b4$var$Hp(o, e, t) {
    if ($88ab1a78ec8ca4b4$var$as(o, e, t)) throw "You should not call this when the positions are in the same page";
    let { rowsPerPage: n, columnsPerSet: r } = t;
    if (n === 0) throw "rowsPerPage cannot be 0";
    let i = o, a = e;
    Math.floor(o.rowIndex / n) > Math.floor(e.rowIndex / n) && (i = e, a = o);
    let { rowIndex: l, colIndex: s } = i, { rowIndex: c, colIndex: u } = a, d = Math.floor(l / n), f = Math.floor(c / n), p = l % n, m = c % n, g = Math.min(p, m), b = Math.max(p, m), h = [];
    for(let y = d; y <= f; y++)for(let S = g; S <= b; S++){
        let C = y * n + S;
        if (y === d) for(let T = s; T < r; T++)h.push({
            rowIndex: C,
            colIndex: T
        });
        else if (y === f) for(let T = 0; T <= u; T++)h.push({
            rowIndex: C,
            colIndex: T
        });
        else for(let T = 0; T < r; T++)h.push({
            rowIndex: C,
            colIndex: T
        });
    }
    return h;
}
function $88ab1a78ec8ca4b4$var$HS(o, e) {
    let t = new Set(o);
    return e.map((n)=>t.has(n) ? n : null).filter((n)=>n != null);
}
var $88ab1a78ec8ca4b4$var$ls = class {
    constructor(e){
        this.getCellSelectionPosition = (e)=>{
            let t = e.rowId ?? $88ab1a78ec8ca4b4$var$Tn(e.rowIndex, this.getDataSourceState)?.id, n = e.colId ?? this.getComputed().computedVisibleColumns[e.colIndex].id;
            return [
                t,
                n
            ];
        };
        this.setRangeSelected = (e, t, n)=>{
            let r = this.getDataSourceState(), i = r.cellSelection;
            if (!i) return;
            let a = new $88ab1a78ec8ca4b4$export$31e3cce2e16ab248(i);
            a.debugId = r.debugId ?? "";
            let [l, s] = this.getCellSelectionPosition(e), [c, u] = this.getCellSelectionPosition(t), d = this.getComputed().computedVisibleColumnsMap.get(s), f = this.getComputed().computedVisibleColumnsMap.get(u);
            if (!d || !f) return;
            let p = d.computedVisibleIndex, m = f.computedVisibleIndex, g = $88ab1a78ec8ca4b4$var$Tn(l, this.getDataSourceState), b = $88ab1a78ec8ca4b4$var$Tn(c, this.getDataSourceState);
            if (!g || !b) return;
            let h = g.indexInAll, y = b.indexInAll, [S, C] = $88ab1a78ec8ca4b4$var$Bi({
                rowIndex: h,
                colIndex: p
            }, {
                rowIndex: y,
                colIndex: m
            });
            for(let T = S.rowIndex; T <= C.rowIndex; T++)for(let I = S.colIndex; I <= C.colIndex; I++){
                let w = {
                    rowIndex: T,
                    colIndex: I
                }, [v, R] = this.getCellSelectionPosition(w);
                n ? a.selectCell(v, R) : a.deselectCell(v, R);
            }
            this.dataSourceActions.cellSelection = a;
        };
        this.getCellSelectionPositionsWithFn = (e, t)=>{
            let n = $88ab1a78ec8ca4b4$var$Ei(this.getDataSourceState), { computedVisibleColumns: r } = this.getComputed(), i = r.map((d)=>d.id), a = new Set, l = [], s = new Set;
            n.filter((d)=>{
                r.forEach((f)=>{
                    this.isCellSelected({
                        rowId: d.id,
                        colId: f.id
                    }) && (a.has(f.id) || a.add(f.id), s.has(d.id) || (s.add(d.id), l.push(d)));
                });
            });
            let c = $88ab1a78ec8ca4b4$var$HS(Array.from(a), i), u = l.map((d)=>c.map((f)=>this.isCellSelected({
                        rowId: d.id,
                        colId: f
                    }) ? e(d, f) : t));
            return {
                columnIds: c,
                positions: u
            };
        };
        this.getAllCellSelectionPositions = ()=>this.getCellSelectionPositionsWithFn((e, t)=>[
                    e.id,
                    t
                ], null);
        this.mapCellSelectionPositions = (e, t)=>this.getCellSelectionPositionsWithFn(e, t);
        this.deselectAll = ()=>{
            let e = this.getDataSourceState(), t = e.cellSelection;
            if (!t) return;
            let n = new $88ab1a78ec8ca4b4$export$31e3cce2e16ab248(t);
            n.debugId = e.debugId ?? "", n.deselectAll(), this.dataSourceActions.cellSelection = n;
        };
        this.clear = ()=>{
            this.deselectAll();
        };
        this.selectAll = ()=>{
            let e = this.getDataSourceState(), t = e.cellSelection;
            if (!t) return;
            let n = new $88ab1a78ec8ca4b4$export$31e3cce2e16ab248(t);
            n.debugId = e.debugId ?? "", n.selectAll(), this.dataSourceActions.cellSelection = n;
        };
        this.selectRange = (e, t)=>{
            this.setRangeSelected(e, t, !0);
        };
        this.deselectRange = (e, t)=>{
            this.setRangeSelected(e, t, !1);
        };
        this.isCellSelected = (e)=>{
            let [t, n] = this.getCellSelectionPosition(e);
            return this.getDataSourceState().cellSelection?.isCellSelected(t, n) ?? !1;
        };
        this.selectCell = (e)=>{
            let t = this.getDataSourceState(), n = t.cellSelection;
            if (!n) return;
            let [r, i] = this.getCellSelectionPosition(e), a = e.clear ? new $88ab1a78ec8ca4b4$export$31e3cce2e16ab248 : new $88ab1a78ec8ca4b4$export$31e3cce2e16ab248(n);
            a.debugId = t.debugId ?? "", a.selectCell(r, i), this.dataSourceActions.cellSelection = a;
        };
        this.deselectCell = (e)=>{
            let t = this.getDataSourceState(), n = t.cellSelection;
            if (!n) return;
            let [r, i] = this.getCellSelectionPosition(e), a = new $88ab1a78ec8ca4b4$export$31e3cce2e16ab248(n);
            a.debugId = t.debugId ?? "", a.deselectCell(r, i), this.dataSourceActions.cellSelection = a;
        };
        this.selectColumn = (e, t)=>{
            t?.clear && this.deselectAll();
            let n = this.getDataSourceState(), r = n.cellSelection;
            if (!r) return;
            let i = new $88ab1a78ec8ca4b4$export$31e3cce2e16ab248(r);
            i.debugId = n.debugId ?? "", i.selectColumn(e), this.dataSourceActions.cellSelection = i;
        };
        this.deselectColumn = (e)=>{
            let t = this.getDataSourceState(), n = t.cellSelection;
            if (!n) return;
            let r = new $88ab1a78ec8ca4b4$export$31e3cce2e16ab248(n);
            r.debugId = t.debugId ?? "", r.deselectColumn(e), this.dataSourceActions.cellSelection = r;
        };
        this.getComputed = e.getComputed, this.getDataSourceState = e.getDataSourceState, this.dataSourceActions = e.dataSourceActions;
    }
};
function $88ab1a78ec8ca4b4$var$Kp(o) {
    return new $88ab1a78ec8ca4b4$var$ls(o);
}
function $88ab1a78ec8ca4b4$var$Bp(o) {
    let { dataSourceApi: e, getState: t, actions: n } = o, r = {
        collapseAllDetails () {
            n.rowDetailState = new $88ab1a78ec8ca4b4$export$d3e437bd1492a8aa({
                collapsedRows: !0,
                expandedRows: []
            });
        },
        expandAllDetails () {
            n.rowDetailState = new $88ab1a78ec8ca4b4$export$d3e437bd1492a8aa({
                expandedRows: !0,
                collapsedRows: []
            });
        },
        isRowDetailCollapsed (i) {
            let a = t().isRowDetailExpanded;
            if (!a) return !0;
            let l = e.getRowInfoByPrimaryKey(i);
            return l ? !a(l) : !0;
        },
        isRowDetailEnabledForRow (i) {
            let { isRowDetailEnabled: a } = t();
            if (!a) return !1;
            if (typeof a == "function") {
                let l = e.getRowInfoByPrimaryKey(i);
                return l ? a(l) : !1;
            }
            return !0;
        },
        isRowDetailExpanded (i) {
            return !r.isRowDetailCollapsed(i);
        },
        collapseRowDetail (i) {
            let a = t(), l = a.rowDetailState;
            if (!l) {
                console.error("Cannot collapse row details via rowDetailState, as no props.rowDetailState is provided.");
                return;
            }
            let s = new $88ab1a78ec8ca4b4$export$d3e437bd1492a8aa(l);
            s.collapseRowDetails(i), a.lastRowToExpandRef.current = null, a.lastRowToCollapseRef.current = i, n.rowDetailState = s;
        },
        expandRowDetail (i) {
            let a = t(), l = a.rowDetailState;
            if (!l) {
                console.error("Cannot expand row details via rowDetailState, as no props.rowDetailState is provided.");
                return;
            }
            let s = new $88ab1a78ec8ca4b4$export$d3e437bd1492a8aa(l);
            s.expandRowDetails(i), a.lastRowToCollapseRef.current = null, a.lastRowToExpandRef.current = i, n.rowDetailState = s;
        },
        toggleRowDetail (i) {
            r.isRowDetailExpanded(i) ? r.collapseRowDetail(i) : r.expandRowDetail(i);
        }
    };
    return r;
}
function $88ab1a78ec8ca4b4$var$Cn(o, e, t) {
    return Math.min(Math.max(o, e), t);
}
function $88ab1a78ec8ca4b4$var$Wi(o, e, t) {
    let n = o().dataArray, r = 0, i = n.length - 1, a = e;
    do {
        a += t;
        let l = n[a];
        if (!l) return a < r ? r : i;
        if (!l.rowDisabled) return a;
    }while (a >= r && a <= i);
    return $88ab1a78ec8ca4b4$var$Cn(a, r, i);
}
function $88ab1a78ec8ca4b4$var$KS(o, e) {
    let { getState: t, getDataSourceState: n, actions: r, api: i, dataSourceApi: a } = o, { key: l } = e, s = n().dataArray, c = s.length, u = t(), { brain: d } = u, { activeRowIndex: f } = u;
    if (f == null) return !1;
    let { start: [p], end: [m] } = d.getRenderRange(), g = f, b = m - p - 1, h = 0, y = c - 1, S = {
        ArrowDown: ()=>{
            f = $88ab1a78ec8ca4b4$var$Wi(n, f, 1);
        },
        ArrowUp: ()=>{
            f = $88ab1a78ec8ca4b4$var$Wi(n, f, -1);
        },
        ArrowLeft: ()=>{
            let T = s[f];
            if (d.isHorizontalLayoutBrain) {
                let I = d.rowsPerPage;
                f - I >= h ? f = f - I : S.ArrowUp();
                return;
            }
            return T && T.isGroupRow ? i.collapseGroupRow(T.groupKeys) : T && i.rowDetailApi.isRowDetailEnabledForRow(T.id) ? i.rowDetailApi.collapseRowDetail(T.id) : !1;
        },
        ArrowRight: ()=>{
            let T = s[f];
            if (d.isHorizontalLayoutBrain) {
                let I = d.rowsPerPage;
                f + I <= y ? f = f + I : S.ArrowDown();
                return;
            }
            return T && T.isGroupRow ? i.expandGroupRow(T.groupKeys) : T && i.rowDetailApi.isRowDetailEnabledForRow(T.id) ? i.rowDetailApi.expandRowDetail(T.id) : !1;
        },
        Enter: ()=>{
            let T = s[f];
            return T && T.isGroupRow ? i.toggleGroupRow(T.groupKeys) : T && T.isTreeNode && T.isParentNode ? a.treeApi.toggleNode(T.nodePath) : i.rowDetailApi.isRowDetailEnabledForRow(T.id) ? i.rowDetailApi.toggleRowDetail(T.id) : !1;
        },
        PageDown: ()=>{
            f = Math.min(f + b, c - 1);
        },
        PageUp: ()=>{
            f = Math.max(f - b, h);
        },
        End: ()=>{
            f = y;
        },
        Home: ()=>{
            f = h;
        }
    }, C = S[l];
    return C ? (C(), g !== f ? (r.activeRowIndex = f, !0) : !1) : !1;
}
function $88ab1a78ec8ca4b4$var$ss(o, e) {
    let { api: t, getState: n, getComputed: r, getDataSourceState: i, dataSourceApi: a } = o, { key: l, shiftKey: s } = e, c = i().dataArray, u = n(), { activeCellIndex: d, brain: f } = u;
    if (!d) return !1;
    let [p, m] = d, { start: [g, b], end: [h, y] } = f.getRenderRange(), S = h - g - 1, C = y - b - 1, T = i().dataArray.length - 1, I = r().computedVisibleColumns.length - 1, w = 0, v = 0;
    p = $88ab1a78ec8ca4b4$var$Cn(p, 0, T), m = $88ab1a78ec8ca4b4$var$Cn(m, 0, I);
    let R = {
        ArrowDown: ()=>{
            p = $88ab1a78ec8ca4b4$var$Cn(p + 1, w, T);
        },
        ArrowUp: ()=>{
            p = $88ab1a78ec8ca4b4$var$Cn(p - 1, w, T);
        },
        ArrowLeft: ()=>{
            if (m === v) {
                if (p !== w && (m = I), f.isHorizontalLayoutBrain) {
                    let M = f.rowsPerPage;
                    p - M >= w ? p = p - M : R.ArrowUp();
                } else R.ArrowUp();
            } else m = $88ab1a78ec8ca4b4$var$Cn(m - 1, v, I);
        },
        ArrowRight: ()=>{
            if (m === I) {
                if (p !== T && (m = v), f.isHorizontalLayoutBrain) {
                    let M = f.rowsPerPage;
                    p + M <= T ? p = p + M : R.ArrowDown();
                } else R.ArrowDown();
            } else m = $88ab1a78ec8ca4b4$var$Cn(m + 1, v, I);
        },
        Enter: ()=>{
            let M = c[p];
            return M && M.isGroupRow ? t.toggleGroupRow(M.groupKeys) : M && M.isTreeNode && M.isParentNode ? a.treeApi.toggleNode(M.nodePath) : M && t.rowDetailApi.isRowDetailEnabledForRow(M.id) ? t.rowDetailApi.toggleRowDetail(M.id) : !1;
        },
        PageDown: ()=>{
            s ? m = Math.min(m + C, I) : p = Math.min(p + S, T);
        },
        PageUp: ()=>{
            s ? m = Math.max(m - C, v) : p = Math.max(p - S, w);
        },
        End: ()=>{
            s ? m = I : p = T;
        },
        Home: ()=>{
            s ? m = v : p = w;
        }
    }, x = R[l];
    return x ? (x(), [
        p,
        m
    ]) : !1;
}
function $88ab1a78ec8ca4b4$var$BS(o, e) {
    let t = $88ab1a78ec8ca4b4$var$ss(o, e);
    return t ? (o.actions.activeCellIndex = t, !0) : !1;
}
var $88ab1a78ec8ca4b4$var$WS = {
    ArrowUp: !0,
    ArrowDown: !0,
    ArrowLeft: !0,
    ArrowRight: !0,
    PageUp: !0,
    PageDown: !0,
    Home: !0,
    End: !0,
    Enter: !0,
    " ": !0
};
function $88ab1a78ec8ca4b4$var$Wp(o, e) {
    let { key: t } = e, { getState: n } = o, r = n(), { activeRowIndex: i, activeCellIndex: a, keyboardNavigation: l, cellContextMenuVisibleFor: s, contextMenuVisibleFor: c } = r;
    return s || c || !$88ab1a78ec8ca4b4$var$WS[t] ? !1 : i != null && l === "row" ? $88ab1a78ec8ca4b4$var$KS(o, e) : a != null && l === "cell" ? $88ab1a78ec8ca4b4$var$BS(o, e) : !1;
}
var $88ab1a78ec8ca4b4$var$cs = class {
    constructor(e){
        this.param = e;
    }
    setKeyboardNavigation(e) {
        this.param.actions.keyboardNavigation = e;
    }
    setActiveCellIndex(e) {
        this.param.actions.activeCellIndex = e;
    }
    setActiveRowIndex(e) {
        this.param.actions.activeRowIndex = e;
    }
    gotoRowWithDirection(e) {
        let { getDataSourceState: t, getState: n } = this.param, { activeRowIndex: r, keyboardNavigation: i } = n();
        if (i !== "row") return console.error("Keyboard navigation is not enabled for rows"), !1;
        if (r == null) return !1;
        let a = $88ab1a78ec8ca4b4$var$Wi(t, r, e);
        return a !== r ? (this.param.actions.activeRowIndex = a, a) : !1;
    }
    gotoRow(e) {
        return this.gotoRowWithDirection(e);
    }
    gotoNextRow() {
        return this.gotoRow(1);
    }
    gotoPreviousRow() {
        return this.gotoRow(-1);
    }
    gotoCell(e) {
        let { direction: t } = e, n = t == "top" ? "ArrowUp" : t == "bottom" ? "ArrowDown" : t == "left" ? "ArrowLeft" : "ArrowRight", r = $88ab1a78ec8ca4b4$var$ss(this.param, {
            key: n,
            shiftKey: !1
        });
        return r === !1 ? !1 : (this.param.actions.activeCellIndex = r, r);
    }
};
function $88ab1a78ec8ca4b4$var$jp(o) {
    return new $88ab1a78ec8ca4b4$var$cs(o);
}
function $88ab1a78ec8ca4b4$var$$p(o, e) {
    return o.id ? o.id === e.id : !!(o.field && o.field === e.field);
}
var $88ab1a78ec8ca4b4$var$us = class {
    constructor(e){
        this.getVisibleRenderRange = ()=>this.getState().brain.getRenderRange();
        this.hideFilterOperatorMenu = ()=>{
            this.actions.filterOperatorMenuVisibleForColumnId = null;
        };
        this.setGroupRenderStrategy = (e)=>{
            this.actions.groupRenderStrategy = e;
        };
        this.getColumnOrder = ()=>this.getComputed().computedColumnOrder;
        this.getComputedColumnById = (e)=>this.getComputed().computedColumnsMap.get(e);
        this.getVisibleColumnOrder = ()=>{
            let e = this.getColumnOrder(), t = this.getComputed().computedVisibleColumnsMap;
            return e.filter((n)=>t.has(n));
        };
        this.persistEdit = async (e)=>{
            e = e ?? {};
            let { editingCell: t, editingValueRef: n } = this.getState();
            if (!t) return Promise.resolve(new Error("no edit in progress"));
            await new Promise((d)=>requestAnimationFrame(d));
            let r = this.getComputed().computedColumnsMap.get(t.columnId), i = e.value ?? t.value;
            !t.active && t.waiting !== "persist" && (this.actions.editingCell = {
                ...t,
                active: !1,
                waiting: "persist"
            });
            let a = {
                ...$88ab1a78ec8ca4b4$var$mt({
                    rowIndex: t.rowIndex,
                    columnId: t.columnId,
                    ...this.context,
                    api: this
                }),
                value: i,
                initialValue: t.initialValue
            }, l = i;
            n.current = null, r.getValueToPersist && (l = await r.getValueToPersist(a)), a.value = l, t.value = l;
            let s = this.getState().persistEdit ?? (()=>{
                if (!a.column.field) return i;
                let d = this.getDataSourceState().primaryKey, f = a.data && typeof d == "string" ? {
                    [d]: a.data[d],
                    [a.column.field]: l
                } : {
                    ...a.data,
                    [a.column.field]: l
                };
                return this.context.dataSourceApi.updateData(f);
            }), c;
            try {
                c = await s(a);
            } catch (d) {
                c = d;
            }
            let u = c instanceof Error ? c : !0;
            return this.actions.editingCell = {
                ...t,
                active: !1,
                accepted: !1,
                waiting: !1,
                persisted: u
            }, Promise.resolve(u);
        };
        this.clearEditInfo = ()=>{
            this.actions.editingCell = null;
        };
        this.isEditInProgress = ()=>{
            let { editingCell: e } = this.getState();
            return e ? e.active : !1;
        };
        this.isEditorVisibleForCell = (e)=>{
            let { rowIndex: t, columnId: n } = e, { dataArray: r } = this.getDataSourceState(), { editingCell: i } = this.getState(), a = r[t];
            return !a || !i ? !1 : i.columnId === n && i.primaryKey === a.id && !!(i.active || i.waiting);
        };
        this.confirmEdit = (e)=>this.stopEdit({
                value: e
            });
        this.stopEdit = async (e)=>{
            let t = this.getState(), { editingCell: n, editingValueRef: r } = t;
            if (!n) return !0;
            e || (e = {});
            let i = e.value ?? r.current;
            if (!e.cancel && !e.reject) {
                let { rowIndex: a, columnId: l } = n;
                this.actions.editingCell = {
                    ...t.editingCell,
                    value: i,
                    active: !1,
                    waiting: "accept"
                };
                let { computedColumnsMap: s } = this.getComputed(), c = s.get(l), u = t.shouldAcceptEdit ?? c.shouldAcceptEdit, d = u ? u({
                    ...$88ab1a78ec8ca4b4$var$mt({
                        ...this.context,
                        api: this,
                        dataSourceApi: this.context.dataSourceApi,
                        columnId: l,
                        rowIndex: a
                    }),
                    value: i,
                    initialValue: n.initialValue
                }) : !0;
                return await new Promise((f)=>requestAnimationFrame(f)), Promise.resolve(d).then((f)=>{
                    if (f === !0) return this.actions.editingCell = {
                        ...t.editingCell,
                        active: !1,
                        accepted: !0,
                        persisted: !1,
                        waiting: "persist",
                        value: i
                    }, !0;
                    throw f;
                }).catch((f)=>(f instanceof Error || (f = new Error(`Edit rejected: ${f}`)), this.actions.editingCell = {
                        ...n,
                        value: i,
                        persisted: !1,
                        active: !1,
                        waiting: !1,
                        accepted: f
                    }, {
                        reject: f,
                        value: i
                    }));
            }
            return e.cancel && n?.active ? (this.actions.editingCell = {
                ...n,
                active: !1,
                cancelled: !0,
                waiting: !1,
                persisted: !1
            }, {
                cancel: !0,
                value: i
            }) : e.reject && n?.active ? (this.actions.editingCell = {
                ...n,
                value: i,
                active: !1,
                persisted: !1,
                waiting: !1,
                accepted: e.reject
            }, {
                reject: e.reject,
                value: i
            }) : !0;
        };
        this.cancelEdit = ()=>this.stopEdit({
                cancel: !0
            });
        this.rejectEdit = (e)=>this.stopEdit({
                reject: e
            });
        this.getColumnAtIndex = (e)=>this.getComputed().computedVisibleColumns[e] ?? null;
        this.isCellEditable = (e)=>{
            let { rowIndex: t, primaryKey: n, columnId: r } = e, i = t ?? this.context.dataSourceApi.getIndexByPrimaryKey(n), { computedColumnsMap: a } = this.getComputed(), l = a.get(r);
            if (!l || !l.computedEditable || l.groupByForColumn) return Promise.resolve(!1);
            let s = this.getDataSourceState().dataArray[i];
            if (!s || s.isGroupRow) return Promise.resolve(!1);
            if (l.computedEditable === !0) return Promise.resolve(!0);
            let c = l.computedEditable($88ab1a78ec8ca4b4$var$mt({
                ...this.context,
                api: this,
                columnId: r,
                rowIndex: i
            }));
            return typeof c == "boolean" ? Promise.resolve(c) : c;
        };
        this.getColumnApi = (e)=>$88ab1a78ec8ca4b4$var$it(e, {
                ...this.context,
                api: this
            });
        this.isColumnSortable = (e)=>this.getColumnApi(e)?.isSortable() ?? !1;
        this.getCellValue = (e)=>this.getCellValues(e)?.value ?? null;
        this.getCellValues = (e)=>{
            let { rowIndex: t, primaryKey: n, columnId: r } = e, { dataSourceApi: i, getState: a } = this.context, { computedColumnsMap: l } = this.getComputed(), s = t ?? i.getIndexByPrimaryKey(n), c = l.get(r), u = i.getRowInfoByIndex(s), d = u?.id;
            if (!u || !c) return c || console.warn(`No column found with id: "${r}"`), u || console.warn(`No row found with index: "${s}" or primary key: "${d}"`), null;
            let f = this, { isRowDetailEnabled: p } = a(), m = !p || typeof p == "function" && !p(u) ? !1 : this.rowDetailApi.isRowDetailExpanded(u.id) ? "expanded" : "collapsed", g = $88ab1a78ec8ca4b4$var$so({
                column: c,
                rowInfo: u,
                columnsMap: l,
                context: {
                    ...this.context,
                    api: f
                },
                rowDetailState: m
            });
            return {
                value: g.formattedValueContext.value,
                formattedValue: g.formattedValue,
                rawValue: g.formattedValueContext.rawValue
            };
        };
        this.getVerticalRenderRange = ()=>{
            let e = this.getState().brain.getRenderRange();
            return {
                renderStartIndex: e.start[0],
                renderEndIndex: e.end[0]
            };
        };
        this.setColumnOrder = (e)=>{
            this.actions.columnOrder = e;
        };
        this.setVisibilityForColumnGroup = (e, t)=>{
            let n = {
                ...this.getState().columnGroupVisibility
            };
            t ? delete n[e] : n[e] = !1, this.actions.columnGroupVisibility = n;
        };
        this.collapseAllGroupRows = ()=>{
            let e = this.getDataSourceState(), t = new $88ab1a78ec8ca4b4$export$f4a923078262b9c3(e.groupRowsState);
            t.collapseAll(), this.dataSourceActions.groupRowsState = t;
        };
        this.collapseGroupRow = (e)=>this.getDataSourceState().groupRowsState.isGroupRowExpanded(e) ? (this.toggleGroupRow(e), !0) : !1;
        this.expandGroupRow = (e)=>this.getDataSourceState().groupRowsState.isGroupRowCollapsed(e) ? (this.toggleGroupRow(e), !0) : !1;
        this.toggleGroupRow = (e)=>{
            let t = this.getDataSourceState(), n = new $88ab1a78ec8ca4b4$export$f4a923078262b9c3(t.groupRowsState);
            if (n.toggleGroupRow(e), this.dataSourceActions.groupRowsState = n, t.lazyLoad) {
                let r = [
                    $88ab1a78ec8ca4b4$var$yn,
                    ...e
                ], i = t.originalLazyGroupData.get(r);
                n.isGroupRowExpanded(e) ? i?.cache || $88ab1a78ec8ca4b4$var$Bn(t.data, t, this.dataSourceActions, {
                    groupKeys: e
                }, this.context.getDataSourceMasterContext()) : i?.cache || (t.lazyLoadCacheOfLoadedBatches.getKeysStartingWith(e).forEach((l)=>{
                    t.lazyLoadCacheOfLoadedBatches.delete(l);
                }), this.dataSourceActions.lazyLoadCacheOfLoadedBatches = $88ab1a78ec8ca4b4$export$1c737028a0cb2e00.clone(t.lazyLoadCacheOfLoadedBatches), t.originalLazyGroupData.delete(r), this.dataSourceActions.originalLazyGroupDataChangeDetect = $88ab1a78ec8ca4b4$var$Ot());
            }
        };
        this.toggleSortingForColumn = (e, t)=>{
            if (!this.getComputed().computedColumnsMap.get(e)) return;
            let r = this.getSortingForColumn(e);
            r === null ? r = 1 : r = r === 1 ? -1 : null, this.setSortingForColumn(e, r, t);
        };
        this.getState = ()=>this.context.getState();
        this.getComputed = ()=>this.context.getComputed();
        this.getDataSourceState = ()=>this.context.getDataSourceState();
        this.scrollCellIntoView = (e, t, n = {
            offset: 0
        })=>{
            let r = this.getState(), i = this.getComputed(), a = t;
            if (typeof t == "string") {
                let g = i.computedVisibleColumnsMap.get(t);
                if (!g) return !1;
                a = g.computedVisibleIndex;
            }
            if (r.brain.isHorizontalLayoutBrain) {
                n = n || {};
                let g = r.brain.getPageIndexForRow(e);
                n.horizontalLayoutPageIndex = g || 0;
            }
            let l = r.renderer.getScrollPositionForScrollColumnIntoView(a, n), s = r.renderer.getScrollPositionForScrollRowIntoView(e, n);
            if (!l || !s) return !1;
            let c = {
                scrollLeft: l.scrollLeft,
                scrollTop: s.scrollTop
            }, u = r.brain.getScrollPosition(), d = r.brain.scrollLeftMax, f = r.brain.scrollTopMax;
            if (d < 0 && f < 0) return !0;
            let p = c.scrollLeft > d + (n.offset || 0), m = c.scrollTop > f + (n.offset || 0);
            return p && m ? !1 : (c.scrollLeft !== u.scrollLeft && !p && (r.scrollerDOMRef.current.scrollLeft = c.scrollLeft), c.scrollTop !== u.scrollTop && !m && (r.scrollerDOMRef.current.scrollTop = c.scrollTop), !0);
        };
        this.context = e, this.rowSelectionApi = $88ab1a78ec8ca4b4$var$rp({
            dataSourceActions: e.dataSourceActions,
            getDataSourceState: e.getDataSourceState
        }), this.keyboardNavigationApi = $88ab1a78ec8ca4b4$var$jp({
            getState: e.getState,
            getDataSourceState: e.getDataSourceState,
            actions: e.actions,
            getComputed: e.getComputed,
            api: this,
            dataSourceApi: e.dataSourceApi
        }), this.rowDetailApi = $88ab1a78ec8ca4b4$var$Bp({
            getState: e.getState,
            actions: e.actions,
            dataSourceApi: e.dataSourceApi
        }), this.cellSelectionApi = $88ab1a78ec8ca4b4$var$Kp({
            dataSourceActions: e.dataSourceActions,
            getDataSourceState: e.getDataSourceState,
            getComputed: e.getComputed
        });
    }
    get actions() {
        return this.context.actions;
    }
    get dataSourceActions() {
        return this.context.dataSourceActions;
    }
    get dataSourceApi() {
        return this.context.dataSourceApi;
    }
    focus() {
        this.getState().scrollerDOMRef.current?.focus();
    }
    hideContextMenu() {
        this.actions.contextMenuVisibleFor = null, this.actions.cellContextMenuVisibleFor = null;
    }
    realignColumnContextMenu(e) {
        let t = {
            actions: this.actions,
            getState: this.getState,
            getComputed: this.getComputed
        }, n = this.getState().columnMenuRealignDelay;
        (!n || n < 0) && ($88ab1a78ec8ca4b4$var$is(t), e?.()), setTimeout(()=>{
            this.isDestroyed() || ($88ab1a78ec8ca4b4$var$is(t), e?.());
        }, n);
    }
    isDestroyed() {
        return !this.getState().domRef.current;
    }
    async startEdit(e) {
        let { columnId: t, rowIndex: n, primaryKey: r, value: i } = e, a = n ?? this.context.dataSourceApi.getIndexByPrimaryKey(r);
        return this.isCellEditable({
            rowIndex: a,
            columnId: t
        }).then(async (l)=>{
            if (l) {
                let s = this.getDataSourceState().dataArray, u = this.getComputed().computedColumnsMap.get(t), d = s[a], f = i ?? $88ab1a78ec8ca4b4$var$bd({
                    column: u,
                    rowInfo: d
                }), p = f;
                u.getValueToEdit && (f = await u.getValueToEdit($88ab1a78ec8ca4b4$var$mt({
                    ...this.context,
                    rowIndex: a,
                    columnId: t,
                    api: this
                }))), this.actions.editingCell = {
                    active: !0,
                    accepted: !1,
                    persisted: !1,
                    columnId: t,
                    value: f,
                    initialValue: p,
                    rowIndex: a,
                    primaryKey: s[a]?.id
                };
            }
            return l;
        });
    }
    setSortingForColumn(e, t, n) {
        let { computedColumnsMap: r } = this.getComputed(), i = r.get(e);
        if (!i || this.getSortingForColumn(e) === t && this.getDataSourceState().multiSort === !1) return;
        if (t === null) {
            this.setSortInfoForColumn(e, null, n);
            return;
        }
        let l = i.groupByForColumn, s = i.field, c = l ? Array.isArray(l) ? l : [
            l
        ] : [], u = c.map((p)=>p.valueGetter ? (m)=>p.valueGetter({
                    data: m,
                    field: p.field
                }) : p.field ? p.field : p.groupField ?? void 0).filter($88ab1a78ec8ca4b4$var$an);
        u.length && (s = u);
        let d = i.computedSortType;
        c.length && d === $88ab1a78ec8ca4b4$var$to && (d = c.flatMap((m)=>{
            let g = m.field ?? m.groupField, b = g ? r.get(g) : null;
            return b ? b.computedSortType : $88ab1a78ec8ca4b4$var$to;
        }));
        let f = {
            dir: t,
            id: i.id,
            field: s,
            type: d
        };
        i.valueGetter && (f.valueGetter = (p)=>i.valueGetter({
                data: p,
                field: i.field
            })), this.setSortInfoForColumn(e, f, n);
    }
    setSortInfoForColumn(e, t, n) {
        let r = this.getDataSourceState(), i = this.getComputed().computedColumnsMap.get(e);
        if (!i) return;
        if (!r.multiSort) {
            this.dataSourceApi.setSortInfo(t ? [
                t
            ] : null);
            return;
        }
        let a = i.field, l = {
            id: e,
            field: a
        }, s = r.sortInfo?.slice() ?? [];
        if (t === null) {
            s = s.filter((d)=>!$88ab1a78ec8ca4b4$var$$p(d, l)), this.dataSourceApi.setSortInfo(s);
            return;
        }
        let c = !1;
        if ((n?.multiSortBehavior ?? this.getState().multiSortBehavior) === "replace") {
            this.dataSourceApi.setSortInfo([
                t
            ]);
            return;
        }
        s = s.map((d)=>c ? d : $88ab1a78ec8ca4b4$var$$p(d, l) ? (c = !0, t) : d), c || s.push(t), this.dataSourceApi.setSortInfo(s);
    }
    getSortTypeForColumn(e) {
        let t = this.getComputed().computedColumnsMap.get(e);
        return t ? t.computedSortType : null;
    }
    getSortInfoForColumn(e) {
        let t = this.getComputed().computedColumnsMap.get(e);
        return t ? t.computedSortInfo : null;
    }
    getSortingForColumn(e) {
        let t = this.getSortInfoForColumn(e);
        return t ? t.dir : null;
    }
    setPinningForColumn(e, t) {
        let n = {
            ...this.getState().columnPinning
        };
        t === !1 ? delete n[e] : n[e] = t, this.actions.columnPinning = n;
    }
    setColumnFilter(e, t) {
        let n = this.getComputed().computedColumnsMap.get(e);
        if (!n) return;
        let r = this.getDataSourceState(), { filterTypes: i } = r, a;
        if (n.computedFilterValue) a = {
            ...n.computedFilterValue,
            filter: {
                ...n.computedFilterValue.filter
            }
        };
        else {
            let l = n.computedFilterType;
            if (!i[l]) return;
            let s = {
                filter: {
                    type: l,
                    value: t,
                    operator: i[l].defaultOperator
                },
                valueGetter: n.valueGetter
            };
            (n.field || typeof n.groupByForColumn == "string") && (s.field = n.field || n.groupByForColumn), a = s;
        }
        a.id = n.id, a.filter.value = t, this.setFilterValueForColumn(e, a);
    }
    setColumnFilterOperator(e, t) {
        let n = this.getComputed().computedColumnsMap.get(e);
        if (!n) return;
        let r = this.getDataSourceState(), { filterTypes: i } = r, a = n.computedFilterType, l = i[a].operators, s = l.find((d)=>d.name === t) ?? l.find((d)=>d.name === i[a].defaultOperator), c = s.name, u;
        n.computedFilterValue ? (u = {
            ...n.computedFilterValue,
            filter: {
                ...n.computedFilterValue.filter,
                operator: c
            }
        }, s.defaultFilterValue !== void 0 && (u.filter.value = s.defaultFilterValue)) : (u = {
            filter: {
                operator: c,
                type: a,
                value: s.defaultFilterValue !== void 0 ? s.defaultFilterValue : [
                    ...i[a].emptyValues.values()
                ][0]
            },
            valueGetter: n.valueGetter
        }, n.field && (u.field = n.field)), u.id = n.id, this.setFilterValueForColumn(e, u);
    }
    setFilterValueForColumn(e, t) {
        let n = this.getComputed().computedColumnsMap.get(e);
        if (!n) return;
        let i = this.getDataSourceState().filterValue ?? [], a = !1;
        i = i.map((l)=>l === n.computedFilterValue ? (a = !0, t) : l), a || i.push(t), this.dataSourceActions.filterValue = i;
    }
    removeColumnFilter(e) {
        let t = this.getComputed().computedColumnsMap.get(e);
        if (!t) return;
        let r = this.getDataSourceState().filterValue ?? [], i = !1;
        r = r.filter((a)=>a === t.computedFilterValue ? (i = !0, !1) : !0), i && (this.dataSourceActions.filterValue = r);
    }
    clearColumnFilter(e) {
        let t = this.getComputed().computedColumnsMap.get(e);
        if (!t) return;
        let n = this.getDataSourceState(), r = n.filterValue ?? [], i = !1;
        r = r.map((a)=>{
            if (a === t.computedFilterValue) {
                let l = t.computedFilterValue.filter.type, s = n.operatorsByFilterType[l], c = n.filterTypes[l];
                if (i = !0, !c) return null;
                let u = a.filter.operator ?? c?.defaultOperator, f = s[u].defaultFilterValue ?? (c.emptyValues || [])[0] ?? void 0;
                return {
                    ...a,
                    filter: {
                        ...a.filter,
                        operator: u,
                        value: f
                    }
                };
            }
            return a;
        }).filter($88ab1a78ec8ca4b4$var$an), i && (this.dataSourceActions.filterValue = r);
    }
    setVisibilityForColumn(e, t) {
        let n = {
            ...this.getState().columnVisibility
        };
        t ? delete n[e] : n[e] = !1, this.actions.columnVisibility = n;
    }
    getVisibleColumnsCount() {
        return this.getComputed().computedVisibleColumns.length;
    }
    setColumnVisibility(e) {
        this.actions.columnVisibility = e;
    }
    get scrollContainer() {
        return this.getState().scrollerDOMRef.current;
    }
    get scrollLeftMax() {
        return this.getState().brain.scrollLeftMax;
    }
    get scrollTopMax() {
        return this.getState().brain.scrollTopMax;
    }
    get scrollLeft() {
        return this.getState().brain.getScrollPosition().scrollLeft;
    }
    set scrollLeft(e) {
        let t = this.getState();
        t.scrollerDOMRef.current && (t.scrollerDOMRef.current.scrollLeft = Math.max(e, 0));
    }
    get scrollTop() {
        return this.getState().brain.getScrollPosition().scrollTop;
    }
    set scrollTop(e) {
        let t = this.getState();
        t.scrollerDOMRef.current && (t.scrollerDOMRef.current.scrollTop = Math.max(e, 0));
    }
    scrollRowIntoView(e, t = {
        offset: 0
    }) {
        let n = this.getState(), r = this.getComputed(), i = n.brain.getScrollPosition(), a = t.columnId, l;
        !a && n.brain.isHorizontalLayoutBrain && r.computedVisibleColumns.length > 0 && (a = r.computedVisibleColumns[Math.ceil(r.computedVisibleColumns.length / 2)].id, l = r.computedVisibleColumnsMap.get(a)?.computedVisibleIndex);
        let s = n.renderer.getScrollPositionForScrollRowIntoView(e, {
            ...t,
            colIndex: l
        });
        if (!s) return !1;
        let c = n.brain.scrollTopMax, u = s.scrollLeft !== i.scrollLeft, d = s.scrollTop <= c + (t.offset || 0);
        return !d && !u ? !1 : (d && s.scrollTop !== i.scrollTop && (n.scrollerDOMRef.current.scrollTop = s.scrollTop), u && (n.scrollerDOMRef.current.scrollLeft = s.scrollLeft), !0);
    }
    scrollColumnIntoView(e, t = {
        offset: 0
    }) {
        let n = this.getState(), i = this.getComputed().computedVisibleColumnsMap.get(e);
        if (!i) return !1;
        let a = i.computedVisibleIndex, l = n.renderer.getScrollPositionForScrollColumnIntoView(a, t);
        if (!l) return !1;
        let s = n.brain.getScrollPosition(), c = n.brain.scrollLeftMax;
        return l.scrollLeft > c + (t.offset || 0) ? !1 : (l.scrollLeft !== s.scrollLeft && (n.scrollerDOMRef.current.scrollLeft = l.scrollLeft), !0);
    }
};
function $88ab1a78ec8ca4b4$var$Up(o) {
    return new $88ab1a78ec8ca4b4$var$us(o);
}
var $88ab1a78ec8ca4b4$var$US = 10;
function $88ab1a78ec8ca4b4$var$YS(o, e) {
    let { includeHeader: t, columnsToResize: n, columnsToSkip: r } = e, i = `.${$88ab1a78ec8ca4b4$var$Fn} > .${$88ab1a78ec8ca4b4$var$gl}`, a = o.current?.querySelectorAll(i), l = {}, s = {};
    return a && a.length && a.forEach((c)=>{
        let u = c.parentElement, d = u.matches(`.${$88ab1a78ec8ca4b4$var$_n}`);
        if (t === !1 && d) return;
        let f = u.getAttribute("data-column-id"), p = c.cloneNode(!0);
        p.style.visibility = "hidden", p.style.pointerEvents = "none", p.classList.remove(...$88ab1a78ec8ca4b4$var$Lt.split(" ")), p.style.position = "absolute", p.style.width = "auto", u.appendChild(p);
        let m = p.offsetWidth;
        if (u.removeChild(p), !s[f]) {
            let g = $88ab1a78ec8ca4b4$var$Re().getComputedStyle(u);
            s[f] = parseInt(g.paddingLeft, 10) + parseInt(g.paddingRight, 10) + parseInt(g.borderLeftWidth, 10) + parseInt(g.borderRightWidth, 10) + $88ab1a78ec8ca4b4$var$US;
        }
        if (m += s[f], d) {
            let g = 0;
            u.childNodes.forEach((b)=>{
                if (b !== c) {
                    let h = b, y = Math.max(h.offsetWidth, parseInt(h.style.width, 10));
                    if (isNaN(y) && (y = 0), g += y, y > 0) {
                        let S = $88ab1a78ec8ca4b4$var$Re().getComputedStyle(h);
                        g += parseInt(S.marginLeft, 10) + parseInt(S.marginRight, 10);
                    }
                }
            }), m += g;
        }
        r && r.has(f) || n && !n.has(f) || (l[f] = Math.max(m, l[f] || 0));
    }), l;
}
function $88ab1a78ec8ca4b4$var$qp() {
    let { getComponentState: o, componentActions: e, componentState: { domRef: t, ready: n, autoSizeColumnsKey: r, brain: i } } = $88ab1a78ec8ca4b4$export$2e1456d250441a8(), [a, l] = (0, $acw62.useState)(0), s = typeof r == "object" ? r.key : r, c = $88ab1a78ec8ca4b4$var$Me(s), u = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (c() == null) return;
        let { current: f } = u, p = ()=>{
            r !== f && l(a + 1);
        };
        return i.onRenderRangeChange(p);
    }, [
        i
    ]), (0, $acw62.useEffect)(()=>{
        if (s == null) return;
        let { autoSizeColumnsKey: d } = o(), f, p, m = !0;
        typeof d == "object" && (d.columnsToResize && (f = new Set(d.columnsToResize)), d.columnsToSkip && (p = new Set(d.columnsToSkip)), m = d.includeHeader ?? m), u.current = s;
        let g = $88ab1a78ec8ca4b4$var$YS(t, {
            includeHeader: m,
            columnsToResize: f,
            columnsToSkip: p
        }), b = Object.keys(g);
        if (!b.length) return;
        let h = o().columnSizing, y = {
            ...h
        }, S = !1;
        b.forEach((C)=>{
            y[C] = {
                width: g[C]
            }, S = S || y[C].width !== h[C]?.width;
        }), S && (e.columnSizing = y);
    }, [
        s,
        n,
        a
    ]);
}
var $88ab1a78ec8ca4b4$var$ji = class {
    constructor(e){
        this.multiSelectStartPosition = {
            rowIndex: 0,
            colIndex: 0
        };
        this.getPrimaryKeyByIndex = e.getPrimaryKeyByIndex, this.getColumnIdByIndex = e.getColumnIdByIndex;
    }
    getCellSelectionPosition(e) {
        let { rowIndex: t, colIndex: n } = e, r = this.getPrimaryKeyByIndex(t), i = this.getColumnIdByIndex(n);
        if (!(r === void 0 || !i)) return [
            r,
            i
        ];
    }
    set cellSelectionState(e) {
        this._cellSelectionState = e;
    }
    get cellSelectionState() {
        return this._cellSelectionState;
    }
    resetClick(e) {
        this.cellSelectionState.deselectAll();
        let t = this.getCellSelectionPosition(e);
        t && (this.cellSelectionState.deselectAll(), this.cellSelectionState.selectCell(...t), this.multiSelectStartPosition = e, this.multiSelectEndPosition = void 0);
    }
    singleAddClick(e) {
        let t = this.getCellSelectionPosition(e);
        if (t) {
            if (this.cellSelectionState.isCellSelected(...t)) {
                this.cellSelectionState.deselectCell(...t);
                let n = {
                    rowIndex: e.rowIndex + 1,
                    colIndex: e.colIndex
                };
                this.getCellSelectionPosition(n) && (this.multiSelectStartPosition = n);
            } else this.cellSelectionState.selectCell(...t), this.multiSelectStartPosition = e, this.multiSelectEndPosition = void 0;
        }
    }
    multiSelectClick(e, t) {
        !this.multiSelectStartPosition || !this.getCellSelectionPosition(e) || (this.multiSelectEndPosition && this.deselectRange(this.multiSelectStartPosition, this.multiSelectEndPosition, t), this.selectRange(this.multiSelectStartPosition, e, t), this.multiSelectEndPosition = e);
    }
    setRangeSelected(e, t, n, r) {
        if (r.horizontalLayout && !$88ab1a78ec8ca4b4$var$as(e, t, r)) {
            $88ab1a78ec8ca4b4$var$Hp(e, t, {
                rowsPerPage: r.rowsPerPage,
                columnsPerSet: r.columnsPerSet
            }).forEach((u)=>{
                let d = this.getCellSelectionPosition({
                    rowIndex: u.rowIndex,
                    colIndex: u.colIndex
                });
                d && (n ? this.cellSelectionState.selectCell(...d) : this.cellSelectionState.deselectCell(...d));
            });
            return;
        }
        let [i, a] = $88ab1a78ec8ca4b4$var$Bi(e, t), l = this.getCellSelectionPosition(i), s = this.getCellSelectionPosition(a);
        if (!(!l || !s)) for(let c = i.rowIndex; c <= a.rowIndex; c++)for(let u = i.colIndex; u <= a.colIndex; u++){
            let d = this.getCellSelectionPosition({
                rowIndex: c,
                colIndex: u
            });
            d && (n ? this.cellSelectionState.selectCell(...d) : this.cellSelectionState.deselectCell(...d));
        }
    }
    deselectRange(e, t, n) {
        this.setRangeSelected(e, t, !1, n);
    }
    selectRange(e, t, n) {
        this.setRangeSelected(e, t, !0, n);
    }
};
function $88ab1a78ec8ca4b4$var$Xp(o, e) {
    return o < e ? [
        o,
        e
    ] : [
        e,
        o
    ];
}
var $88ab1a78ec8ca4b4$var$$i = class {
    constructor(e){
        this.multiSelectStartIndex = 0;
        this.getIdForIndex = e.getIdForIndex, this.isRowDisabledAt = e.isRowDisabledAt;
    }
    set rowSelectionState(e) {
        this._rowSelectionState = e;
    }
    get rowSelectionState() {
        return this._rowSelectionState;
    }
    selectRange(e, t) {
        let [n, r] = $88ab1a78ec8ca4b4$var$Xp(e, t), i = this.rowSelectionState;
        for(let a = n; a <= r; a++){
            let l = this.getIdForIndex(a);
            this.isRowDisabledAt(a) || i.selectRow(l);
        }
    }
    deselectRange(e, t) {
        let [n, r] = $88ab1a78ec8ca4b4$var$Xp(e, t), i = this.rowSelectionState;
        for(let a = n; a <= r; a++){
            let l = this.getIdForIndex(a);
            this.isRowDisabledAt(a) || i.deselectRow(l);
        }
    }
    resetClick(e) {
        this.rowSelectionState.deselectAll();
        let t = this.getIdForIndex(e);
        this.rowSelectionState.selectRow(t), this.multiSelectStartIndex = e, this.multiSelectEndIndex = void 0;
    }
    singleAddClick(e) {
        let t = this.getIdForIndex(e);
        if (this.rowSelectionState.isRowSelected(t)) this.rowSelectionState.deselectRow(t), this.rowSelectionState.isRowSelected(this.getIdForIndex(e + 1)) && (this.multiSelectStartIndex = e + 1);
        else {
            this.rowSelectionState.selectRow(t), this.multiSelectStartIndex = e;
            let n;
            for(let r = e - 1; r >= 0; r--){
                let i = this.getIdForIndex(r);
                if (this.rowSelectionState.isRowSelected(i)) n = r;
                else break;
            }
            this.multiSelectEndIndex = n;
        }
    }
    multiSelectClick(e) {
        this.multiSelectEndIndex != null && this.deselectRange(this.multiSelectStartIndex, this.multiSelectEndIndex), this.selectRange(this.multiSelectStartIndex, e), this.multiSelectEndIndex = e;
    }
};
function $88ab1a78ec8ca4b4$var$Zp(o) {
    let { getState: e } = $88ab1a78ec8ca4b4$var$_e();
    return (0, $acw62.useMemo)(()=>o.filter((r)=>typeof r.rowspan == "function").length ? ({ rowIndex: r, colIndex: i })=>{
            let a = e().dataArray, l = a[r];
            if (!l) return 1;
            let s = l.data, c = o[i];
            return !c || !c.rowspan ? 1 : c.rowspan({
                column: c,
                data: s,
                dataArray: a,
                rowInfo: l,
                rowIndex: r
            });
        } : void 0, [
        o
    ]);
}
var $88ab1a78ec8ca4b4$var$Hz = $88ab1a78ec8ca4b4$var$St("useColumnSizeFn");
function $88ab1a78ec8ca4b4$var$Qp(o) {
    return (0, $acw62.useCallback)((t)=>{
        let n = o[t];
        return n ? n.computedWidth : 0;
    }, [
        o
    ]);
}
var $88ab1a78ec8ca4b4$var$ZS = {
    scrollLeft: 0,
    scrollTop: 0
}, $88ab1a78ec8ca4b4$var$gr = class {
    constructor(){
        this.scrollPosition = $88ab1a78ec8ca4b4$var$ZS;
        this.onScrollFns = [];
        this.getScrollPosition = ()=>this.scrollPosition;
        this.onScroll = (e)=>(this.onScrollFns.push(e), ()=>{
                this.onScrollFns = this.onScrollFns.filter((t)=>t !== e);
            });
        this.setScrollPosition = (e)=>{
            this.scrollPosition = e, this.notifyScrollChange();
        };
        this.destroy = ()=>{
            this.onScrollFns = [];
        };
    }
    notifyScrollChange() {
        let { scrollPosition: e } = this, t = this.onScrollFns;
        for(let n = 0, r = t.length; n < r; n++)t[n](e);
    }
};
function $88ab1a78ec8ca4b4$var$Jp(o, e) {
    let t = new Map;
    function n(r) {
        return e[r] !== !1;
    }
    return Object.keys(o).forEach((r)=>{
        let a = o[r].columnGroup, l = 0;
        for(n(r) || (l = -1); a;){
            let s = o[a];
            if (!s) break;
            n(a) && l++, a = s.columnGroup;
        }
        t.set(r, l);
    }), t;
}
function $88ab1a78ec8ca4b4$var$tm(o) {
    return (e, t)=>$acw62.createElement(o, {
            key: e.id,
            rowInfo: e,
            cache: t
        });
}
var $88ab1a78ec8ca4b4$var$hr = class extends $88ab1a78ec8ca4b4$var$zn {
    constructor(t, n){
        super(`${t}:HorizontalLayout`);
        this.visiblePageCount = 0;
        this.isHorizontalLayoutBrain = !0;
        this._totalPageCount = 0;
        this.pageWidth = 0;
        this.initialCols = 0;
        this.initialRows = 0;
        this.initialColWidth = 0;
        this.colWidth = ()=>10;
        this.getColWidth = (t)=>typeof this.initialColWidth == "number" ? this.initialColWidth : this.initialColWidth(t % this.initialCols);
        this.onTotalPageCountChangeFns = new Set;
        this.onTotalPageCountChange = (t)=>(this.onTotalPageCountChangeFns.add(t), ()=>{
                this.onTotalPageCountChangeFns.delete(t);
            });
        this.options = n, this.options.masterBrain && this.options.masterBrain.onTotalPageCountChange(()=>{
            this.updateRenderCount({
                horizontal: !0,
                vertical: !0
            });
        });
    }
    computeDirectionalRenderCount(t, n, r, i) {
        if (t === "vertical" || typeof n == "number") return super.computeDirectionalRenderCount(t, n, r, i);
        let a = 0, l = i.width, s = Math.floor(l / this.pageWidth);
        a += s * this.initialCols;
        let c = l - s * this.pageWidth, u = [];
        for(let d = 0; d < this.initialCols; d++)u.push(this.getItemSize(d, t));
        return a += $88ab1a78ec8ca4b4$var$di(c, u.concat(u)), t === "horizontal" ? this.maxHorizontalRenderCount = a : this.maxVerticalRenderCount = a, a = Math.min(r, a), a;
    }
    getRowIndexInPage(t) {
        return this.rowsPerPage ? t % this.rowsPerPage : t;
    }
    getInitialCols() {
        return this.initialCols;
    }
    getInitialRows() {
        return this.initialRows;
    }
    getPageIndexForRow(t) {
        return Math.floor(t / this.rowsPerPage);
    }
    getMatrixCoordinatesForHorizontalLayoutPosition(t) {
        let n = t.rowIndex, r = t.colIndex;
        return t.rowIndex >= this.rowsPerPage && this.rowsPerPage > 0 && (n = t.rowIndex % this.rowsPerPage, r = Math.floor(t.rowIndex / this.rowsPerPage) * this.initialCols + r), {
            rowIndex: n,
            colIndex: r
        };
    }
    getHorizontalLayoutPositionFromMatrixCoordinates(t) {
        let n = t.rowIndex, r = t.colIndex;
        if (t.colIndex >= this.initialCols && this.initialCols > 0) {
            let i = Math.floor(t.colIndex / this.initialCols);
            r = t.colIndex - i * this.initialCols, n = this.rowsPerPage * i + t.rowIndex;
        }
        return {
            colIndex: Math.min(r, this.initialCols),
            rowIndex: this.options.isHeader ? n : Math.min(n, this.initialRows)
        };
    }
    update(t) {
        let { rows: n, cols: r, rowHeight: i, colWidth: a, width: l, height: s } = t, c = typeof l == "number", u = typeof s == "number", d = c && l !== this.availableWidth, f = u && s !== this.availableHeight;
        d && (this.availableWidth = l, this.availableRenderWidth = l), f && (this.availableHeight = s, this.availableRenderHeight = s), (d || f) && this.notifyAvailableSizeChange();
        let p = typeof n == "number", m = typeof r == "number", g = p && n !== this.initialRows, b = m && r !== this.initialCols;
        p && g && (this.initialRows = n, this.rows = n), m && b && (this.initialCols = r, this.cols = r);
        let h = i != null, y = a != null, S = h && i !== this.rowHeight, C = y && a !== this.initialColWidth;
        h && (this.rowHeight = i), y && (this.initialColWidth = a, this.colWidth = this.getColWidth);
        let T = g || S || f, I = b || C || d || T;
        (I || T) && this.updateRenderCount({
            horizontal: I,
            vertical: T
        });
    }
    getInitialRowHeight() {
        return typeof this.rowHeight != "number" ? this.getRowHeight(0) : this.rowHeight;
    }
    get totalPageCount() {
        return this.options.masterBrain ? this.options.masterBrain.totalPageCount : this._totalPageCount;
    }
    set totalPageCount(t) {
        this.options.masterBrain || (this._totalPageCount = t);
    }
    getPageWidth() {
        return this.pageWidth;
    }
    doUpdateRenderCount(t = $88ab1a78ec8ca4b4$var$$t) {
        let n = this.getInitialRowHeight(), r = 0;
        for(let a = 0; a < this.initialCols; a++)r += this.getColWidth(a);
        this.pageWidth = r, this.rowsPerPage = Math.floor(this.availableHeight / n);
        let i = !1;
        if (!this.options.masterBrain) {
            let a = this.totalPageCount;
            this.totalPageCount = this.rowsPerPage ? Math.ceil(this.initialRows / this.rowsPerPage) : 0, a != this.totalPageCount && (i = !0);
        }
        this.visiblePageCount = this.totalPageCount && this.pageWidth ? Math.max(Math.ceil(this.availableWidth / this.pageWidth), 1) : 1, this.availableRenderHeight = this.visiblePageCount * this.rowsPerPage * n, this.cols = Math.max(this.totalPageCount * this.initialCols, this.initialCols), this.rows = this.rowsPerPage, super.doUpdateRenderCount(t), i && this.notifyTotalPageCountChange();
    }
    notifyTotalPageCountChange() {
        if (this.destroyed) return;
        let t = this.onTotalPageCountChangeFns;
        t.forEach((n)=>{
            $88ab1a78ec8ca4b4$var$ke(()=>{
                this.destroyed || t.has(n) && n(this.totalPageCount);
            });
        });
    }
    getVirtualColIndex(t, n) {
        return this.initialCols * (n?.pageIndex ?? 0) + t;
    }
    destroy() {
        this.destroyed || (super.destroy(), this.options.masterBrain = void 0, this.onTotalPageCountChangeFns.clear());
    }
    getVirtualizedContentSizeFor(t) {
        return t === "vertical" ? this.getInitialRowHeight() * this.rowsPerPage : this.pageWidth * this.totalPageCount;
    }
};
var $88ab1a78ec8ca4b4$var$nm = {};
function $88ab1a78ec8ca4b4$var$ds(o) {
    return `.${$88ab1a78ec8ca4b4$var$zt}[data-row-index${o ? `="${o.rowIndex}"` : ""}][data-col-index${o ? `="${o.colIndex}"` : ""}]`;
}
function $88ab1a78ec8ca4b4$var$fs(o, e) {
    let t = $88ab1a78ec8ca4b4$var$gn(o), n = e ? new $88ab1a78ec8ca4b4$var$hr(t, {
        isHeader: !1
    }) : new $88ab1a78ec8ca4b4$var$zn(t), r = `${t}:header`, i = e ? new $88ab1a78ec8ca4b4$var$hr(r, {
        isHeader: !0,
        masterBrain: n
    }) : new $88ab1a78ec8ca4b4$var$zn(r);
    n.onScroll((u)=>{
        i.setScrollPosition({
            scrollLeft: u.scrollLeft,
            scrollTop: 0
        });
    });
    let { renderer: a, onRenderUpdater: l } = $88ab1a78ec8ca4b4$var$or(n), { renderer: s, onRenderUpdater: c } = $88ab1a78ec8ca4b4$var$or(i);
    return n.onAvailableSizeChange((u)=>{
        i.update({
            width: u.width
        });
    }), {
        brain: n,
        headerBrain: i,
        renderer: a,
        onRenderUpdater: l,
        headerRenderer: s,
        headerOnRenderUpdater: c
    };
}
function $88ab1a78ec8ca4b4$var$om({ debugId: o, wrapRowsHorizontally: e }) {
    let t = {}, { brain: n, headerBrain: r, renderer: i, onRenderUpdater: a, headerRenderer: l, headerOnRenderUpdater: s } = $88ab1a78ec8ca4b4$var$fs(o, !!e), c = (0, $acw62.createRef)(), u = Date.now();
    return {
        debugWarnings: new Map,
        renderer: i,
        onRenderUpdater: a,
        headerRenderer: l,
        headerOnRenderUpdater: s,
        updatedAt: u,
        devToolsDetected: !!globalThis.__INFINITE_TABLE_DEVTOOLS_HOOK__,
        propsCache: new Map([]),
        lastRowToCollapseRef: {
            current: null
        },
        lastRowToExpandRef: {
            current: null
        },
        cellContextMenuVisibleFor: null,
        contextMenuVisibleFor: null,
        columnMenuVisibleForColumnId: null,
        columnMenuVisibleKey: 0,
        filterOperatorMenuVisibleForColumnId: null,
        getDOMNodeForCell: (d)=>{
            if (!c.current) return null;
            let f = $88ab1a78ec8ca4b4$var$ds(d);
            return c.current.querySelector(f) || null;
        },
        brain: n,
        headerBrain: r,
        domRef: c,
        columnMenuTargetRef: (0, $acw62.createRef)(),
        editingValueRef: (0, $acw62.createRef)(),
        scrollerDOMRef: (0, $acw62.createRef)(),
        portalDOMRef: (0, $acw62.createRef)(),
        focusDetectDOMRef: (0, $acw62.createRef)(),
        activeCellIndicatorDOMRef: (0, $acw62.createRef)(),
        onColumnMenuClick: $88ab1a78ec8ca4b4$var$ye(),
        cellContextMenu: $88ab1a78ec8ca4b4$var$ye(),
        contextMenu: $88ab1a78ec8ca4b4$var$ye(),
        onFilterOperatorMenuClick: $88ab1a78ec8ca4b4$var$ye(),
        flashingDurationCSSVarValue: null,
        onFlashingDurationCSSVarChange: $88ab1a78ec8ca4b4$var$ye(),
        onRowHeightCSSVarChange: $88ab1a78ec8ca4b4$var$ye(),
        onRowDetailHeightCSSVarChange: $88ab1a78ec8ca4b4$var$ye(),
        onColumnHeaderHeightCSSVarChange: $88ab1a78ec8ca4b4$var$ye(),
        cellClick: $88ab1a78ec8ca4b4$var$ye(),
        cellMouseDown: $88ab1a78ec8ca4b4$var$ye(),
        keyDown: $88ab1a78ec8ca4b4$var$ye(),
        bodySize: {
            width: 0,
            height: 0
        },
        scrollPosition: {
            scrollTop: 0,
            scrollLeft: 0
        },
        columnReorderDragColumnId: !1,
        columnReorderInPageIndex: null,
        ready: !1,
        focused: !1,
        focusedWithin: !1,
        columnsWhenGrouping: t,
        columnVisibilityForGrouping: {},
        pinnedStartScrollListener: new $88ab1a78ec8ca4b4$var$gr,
        pinnedEndScrollListener: new $88ab1a78ec8ca4b4$var$gr,
        columnsWhenInlineGroupRenderStrategy: void 0,
        editingCell: null,
        forceBodyRerenderTimestamp: 0
    };
}
var $88ab1a78ec8ca4b4$var$rm = (o)=>({
        debugId: 1,
        scrollTopKey: 1,
        components: 1,
        id: 1,
        loadingText: 1,
        pivotColumns: 1,
        groupColumn: 1,
        onReady: 1,
        domProps: 1,
        onKeyDown: 1,
        onCellClick: 1,
        onCellDoubleClick: 1,
        focusedClassName: 1,
        focusedWithinClassName: 1,
        focusedStyle: 1,
        focusedWithinStyle: 1,
        onSelfFocus: 1,
        onFocusWithin: 1,
        onSelfBlur: 1,
        onBlurWithin: 1,
        onContextMenu: 1,
        onCellContextMenu: 1,
        onRenderRangeChange: 1,
        onRowMouseEnter: 1,
        onRowMouseLeave: 1,
        onScrollToTop: 1,
        onScrollToBottom: 1,
        onScrollStop: 1,
        scrollToBottomOffset: 1,
        getColumnMenuItems: 1,
        getCellContextMenuItems: 1,
        getContextMenuItems: 1,
        columnPinning: 1,
        editable: 1,
        columnDefaultEditable: 1,
        columnDefaultFilterable: 1,
        columnDefaultGroupable: 1,
        columnDefaultSortable: 1,
        keyboardShortcuts: 1,
        rowStyle: 1,
        cellStyle: 1,
        rowProps: 1,
        rowClassName: 1,
        rowHoverClassName: 1,
        cellClassName: 1,
        repeatWrappedGroupRows: 1,
        pinnedStartMaxWidth: 1,
        pinnedEndMaxWidth: 1,
        pivotColumn: 1,
        pivotColumnGroups: 1,
        getFilterOperatorMenuItems: 1,
        onScrollbarsChange: 1,
        autoSizeColumnsKey: 1,
        wrapRowsHorizontally: 1,
        columnDefaultFlex: 1,
        draggableColumnsRestrictTo: (e)=>e ?? !1,
        columnMenuRealignDelay: (e)=>e ?? 50,
        scrollStopDelay: (e)=>e ?? 250,
        viewportReservedWidth: (e)=>e ?? 0,
        resizableColumns: (e)=>e ?? !0,
        rowDetailCache: (e)=>new $88ab1a78ec8ca4b4$export$3b26ed2846f6af2c(e),
        hideColumnWhenGrouped: (e)=>e ?? !1,
        columnMinWidth: (e)=>e ?? 30,
        columnMaxWidth: (e)=>e ?? 5e3,
        columnDefaultWidth: (e)=>e ?? 200,
        columnCssEllipsis: (e)=>e ?? !0,
        draggableColumns: 1,
        columnDefaultDraggable: 1,
        headerOptions: (e)=>({
                alwaysReserveSpaceForSortIcon: !0,
                ...e
            }),
        showSeparatePivotColumnForSingleAggregation: (e)=>e ?? !1,
        sortable: 1,
        hideEmptyGroupColumns: (e)=>e ?? !1,
        pivotTotalColumnPosition: (e)=>e ?? "end",
        pivotGrandTotalColumnPosition: 1,
        licenseKey: (e)=>e || "",
        keyboardSelection: (e)=>e ?? !0,
        activeRowIndex: 1,
        activeCellIndex: 1,
        columnOrder: (e)=>e ?? !0,
        header: (e)=>e ?? !0,
        showZebraRows: (e)=>e ?? !0,
        showHoverRows: (e)=>e ?? !0,
        virtualizeColumns: (e)=>e ?? !0,
        rowHeight: (e)=>typeof e == "number" || typeof e == "function" ? e : 0,
        rowDetailHeight: (e)=>typeof e == "number" || typeof e == "function" ? e : 300,
        columnHeaderHeight: (e)=>typeof e == "number" ? e : 30,
        columns: 1,
        columnVisibility: (e)=>e ?? $88ab1a78ec8ca4b4$var$nm,
        columnGroupVisibility: (e)=>e ?? $88ab1a78ec8ca4b4$var$nm,
        columnSizing: (e)=>e || {},
        columnTypes: (e)=>e || {},
        onEditCancelled: 1,
        onEditRejected: 1,
        onEditAccepted: 1,
        persistEdit: 1,
        shouldAcceptEdit: 1,
        onEditPersistError: 1,
        onEditPersistSuccess: 1,
        multiSortBehavior: (e)=>e ?? "replace",
        collapsedColumnGroups: (e)=>e ?? new Map,
        columnGroups: 1
    });
function $88ab1a78ec8ca4b4$var$QS(o) {
    let { groupBy: e, groupColumn: t, groupRenderStrategy: n } = o;
    return n || (t != null && typeof t == "object" ? "single-column" : (e.filter((i)=>i.column).length, "multi-column"));
}
var $88ab1a78ec8ca4b4$var$im = (o)=>{
    o.brain.destroy(), o.headerBrain.destroy(), o.renderer.destroy(), o.headerRenderer.destroy(), o.onRenderUpdater.destroy(), o.headerOnRenderUpdater.destroy(), o.onFlashingDurationCSSVarChange.destroy(), o.onRowHeightCSSVarChange.destroy(), o.onColumnHeaderHeightCSSVarChange.destroy(), o.onColumnMenuClick.destroy(), o.onFilterOperatorMenuClick.destroy(), o.domRef.current = null, o.columnMenuTargetRef.current = null, o.scrollerDOMRef.current = null, o.portalDOMRef.current = null, o.onRowDetailHeightCSSVarChange.destroy(), o.pinnedEndScrollListener.destroy(), o.pinnedStartScrollListener.destroy();
};
function $88ab1a78ec8ca4b4$var$am(o) {
    return o.reduce((e, t, n)=>{
        let r = {
            groupBy: t,
            groupIndex: n
        };
        return t.field ? e.set(t.field, r) : t.groupField && e.set(t.groupField, r), e;
    }, new Map);
}
var $88ab1a78ec8ca4b4$var$Ui = new WeakMap;
function $88ab1a78ec8ca4b4$var$lm() {
    return {
        rowDetailState: (o, e)=>({
                callbackParams: [
                    o,
                    {
                        expandRow: e.lastRowToExpandRef.current,
                        collapseRow: e.lastRowToCollapseRef.current
                    }
                ]
            })
    };
}
var $88ab1a78ec8ca4b4$var$sm = (o)=>{
    let { props: e, state: t, oldState: n, parentState: r } = o, i = t.pivotColumnGroups || t.columnGroups, a = t.columnGroups && t.columnGroups != n?.columnGroups || t.columnGroups && t.columnGroupVisibility != n?.columnGroupVisibility || t.pivotColumnGroups && t.pivotColumnGroups != n?.pivotColumnGroups ? $88ab1a78ec8ca4b4$var$Jp(i, t.columnGroupVisibility) : t.columnGroupsDepthsMap, l = r?.groupBy, s = $88ab1a78ec8ca4b4$var$QS({
        groupRenderStrategy: e.groupRenderStrategy,
        groupBy: l,
        groupColumn: e.groupColumn
    }), c, u = e.rowDetailRenderer, d = e.components?.RowDetail;
    if (!u && d) {
        let b = $88ab1a78ec8ca4b4$var$Ui.get(d);
        b || (b = $88ab1a78ec8ca4b4$var$tm(d), $88ab1a78ec8ca4b4$var$Ui.set(d, b)), u = b;
    }
    u && (c = e.rowDetailState || t.rowDetailState || e.defaultRowDetailState, c && !(c instanceof $88ab1a78ec8ca4b4$export$d3e437bd1492a8aa) && (c = new $88ab1a78ec8ca4b4$export$d3e437bd1492a8aa(c)), c = c || new $88ab1a78ec8ca4b4$export$d3e437bd1492a8aa({
        expandedRows: [],
        collapsedRows: !0
    }));
    let f = t.columnsWhenGrouping || t.columnsWhenInlineGroupRenderStrategy || t.columns, p = c ? e.isRowDetailExpanded : void 0;
    !p && c && (p = $88ab1a78ec8ca4b4$var$Ui.get(c), p || (p = (b)=>c.isRowDetailsExpanded(b.id), typeof c == "object" && $88ab1a78ec8ca4b4$var$Ui.set(c, p)));
    let m = u ? e.isRowDetailEnabled || !0 : !1, g = {
        updatedAt: Date.now(),
        isTree: r.isTree,
        rowDetailRenderer: u,
        rowDetailState: c,
        isRowDetailExpanded: p,
        isRowDetailEnabled: m,
        showColumnFilters: e.showColumnFilters ?? !!r.filterValue,
        controlledColumnVisibility: !!e.columnVisibility,
        groupRenderStrategy: s,
        groupBy: l,
        computedColumns: f,
        initialColumns: e.columns,
        keyboardNavigation: e.keyboardNavigation ?? (t.activeCellIndex != null ? "cell" : t.activeRowIndex != null ? "row" : "cell"),
        columnHeaderCssEllipsis: e.columnHeaderCssEllipsis ?? e.columnCssEllipsis ?? !0,
        columnGroupsDepthsMap: a,
        columnGroupsMaxDepth: a != t.columnGroupsDepthsMap ? Math.max(...a.values(), -1) : t.columnGroupsMaxDepth,
        computedColumnGroups: i,
        rowHeightCSSVar: typeof e.rowHeight == "string" ? e.rowHeight : "",
        rowDetailHeightCSSVar: typeof e.rowDetailHeight == "string" ? e.rowDetailHeight : "",
        columnHeaderHeightCSSVar: typeof e.columnHeaderHeight == "string" ? e.columnHeaderHeight || $88ab1a78ec8ca4b4$var$se.components.Header.columnHeaderHeight : ""
    };
    if (t.devToolsDetected && t.debugId) {
        let b = $88ab1a78ec8ca4b4$var$qt.get(t.debugId);
        b && (g = {
            ...g,
            ...b
        });
    }
    return g;
};
function $88ab1a78ec8ca4b4$var$cm(o, e) {
    let t = {};
    return Object.keys(o).forEach((n)=>{
        let r = o[n], i = r;
        if (!i.groupByForColumn || Array.isArray(i.groupByForColumn)) return;
        let { groupByForColumn: a } = i, l = a.field || a.groupField;
        l && e.get(l) && (t[n] = r);
    }), t;
}
function $88ab1a78ec8ca4b4$var$um(o) {
    let { hideEmptyGroupColumns: e, groupByMap: t, computedGroupColumns: n, groupRowsIndexesInDataArray: r, dataArray: i, groupBy: a } = o, l = {
        ...o.columnVisibility
    };
    if (!e) return Object.keys(n).forEach((d)=>{
        l[d] === !1 && delete l[d];
    }), l;
    if (!r || !r.length) return l;
    let s = a.length, c = 0, u = r.length;
    for(let d = 0; d < u; d++){
        let f = r[d], p = i[f];
        if (!p.isTreeNode && p.isGroupRow && (c = Math.max(c, p.groupNesting - 1), c === s - 1)) break;
    }
    return Object.keys(n).forEach((d)=>{
        let f = n[d], { groupByForColumn: p } = f;
        if (Array.isArray(p)) return;
        let m = p.field || p.groupField;
        if (!m) return;
        t.get(m).groupIndex > c && e ? l[d] !== !1 && (l[d] = !1) : l.hasOwnProperty(d) && delete l[d];
    }), l;
}
function $88ab1a78ec8ca4b4$var$ps() {
    let { getState: o, componentActions: e, getDataSourceMasterContext: t } = $88ab1a78ec8ca4b4$var$_e();
    return (0, $acw62.useCallback)((r)=>{
        let i = o(), a = new $88ab1a78ec8ca4b4$export$f4a923078262b9c3(i.groupRowsState);
        if (a.toggleGroupRow(r), e.groupRowsState = a, i.lazyLoad) {
            let l = [
                $88ab1a78ec8ca4b4$var$yn,
                ...r
            ], s = i.originalLazyGroupData.get(l);
            a.isGroupRowExpanded(r) ? s?.cache || $88ab1a78ec8ca4b4$var$Bn(i.data, i, e, {
                groupKeys: r
            }, t()) : s?.cache || (i.lazyLoadCacheOfLoadedBatches.getKeysStartingWith(r).forEach((u)=>{
                i.lazyLoadCacheOfLoadedBatches.delete(u);
            }), e.lazyLoadCacheOfLoadedBatches = $88ab1a78ec8ca4b4$export$1c737028a0cb2e00.clone(i.lazyLoadCacheOfLoadedBatches), i.originalLazyGroupData.delete(l), e.originalLazyGroupDataChangeDetect = $88ab1a78ec8ca4b4$var$Ot());
        }
    }, []);
}
function $88ab1a78ec8ca4b4$var$nC(o) {
    return (0, $acw62.useMemo)(()=>$88ab1a78ec8ca4b4$var$am(o), [
        o
    ]);
}
function $88ab1a78ec8ca4b4$var$dm() {
    let { componentState: { groupBy: o }, componentActions: e } = $88ab1a78ec8ca4b4$var$_e(), { componentState: { groupRenderStrategy: t, pivotTotalColumnPosition: n, pivotGrandTotalColumnPosition: r } } = $88ab1a78ec8ca4b4$export$2e1456d250441a8();
    (0, $acw62.useEffect)(()=>{
        e.generateGroupRows = t !== "inline";
    }, [
        t
    ]), (0, $acw62.useEffect)(()=>{
        e.pivotTotalColumnPosition = n;
    }, [
        n
    ]), (0, $acw62.useEffect)(()=>{
        r != null && (e.pivotGrandTotalColumnPosition = r);
    }, [
        r
    ]);
    let i = $88ab1a78ec8ca4b4$var$nC(o);
    $88ab1a78ec8ca4b4$var$oC(i);
    let { toggleGroupRow: a } = $88ab1a78ec8ca4b4$var$rC();
    return $88ab1a78ec8ca4b4$var$iC(i), {
        toggleGroupRow: a
    };
}
function $88ab1a78ec8ca4b4$var$oC(o) {
    let e = $88ab1a78ec8ca4b4$var$ps(), { componentActions: t, componentState: { columns: n, groupRenderStrategy: r, isTree: i } } = $88ab1a78ec8ca4b4$export$2e1456d250441a8();
    function a(l, s, c, u) {
        let d = {};
        if (c === "inline") return Object.keys(l).forEach((f)=>{
            let p = l[f], m = {}, g = s.get(p.field);
            if (g && c === "inline") {
                let { groupIndex: h } = g;
                m = {
                    groupByForColumn: g.groupBy,
                    field: g.groupBy?.field,
                    valueGetter: g.groupBy?.valueGetter,
                    valueFormatter: ({ rowInfo: y })=>y.isGroupRow ? y.groupKeys?.[h] : y.value,
                    rowspan: ({ rowInfo: y, dataArray: S })=>{
                        if (y.isTreeNode || !y.isGroupRow) return 1;
                        let C = S[y.indexInAll - 1] || {
                            indexInParentGroups: []
                        };
                        if (!C || !C.dataSourceHasGrouping) return 1;
                        let T = C.indexInParentGroups || [], I = y.indexInParentGroups || [], w = !1;
                        for(let x = 0; x <= h; x++){
                            let M = T[x];
                            if (I[x] !== M) {
                                w = !0;
                                break;
                            }
                        }
                        if (!w) return 1;
                        let v = y.parents[h];
                        return v ? v.groupCount - (v.collapsedChildrenCount || 0) + (v.collapsedGroupsCount || 0) : 1;
                    },
                    renderGroupIcon: $88ab1a78ec8ca4b4$var$Xr({
                        groupIndexForColumn: h,
                        groupRenderStrategy: c,
                        toggleGroupRow: u,
                        initialRenderGroupIcon: p.renderGroupIcon
                    }),
                    render: $88ab1a78ec8ca4b4$var$qr({
                        groupIndexForColumn: h,
                        groupRenderStrategy: c
                    })
                };
            }
            let b = {
                ...m,
                ...p
            };
            d[f] = b;
        }), Object.keys(d).length === 0 ? void 0 : d;
    }
    (0, $acw62.useEffect)(()=>{
        (()=>{
            t.columnsWhenInlineGroupRenderStrategy = i ? void 0 : a(n, o, r, e);
        })();
    }, [
        n,
        o,
        r,
        e
    ]);
}
function $88ab1a78ec8ca4b4$var$rC() {
    let { componentState: { groupBy: o, pivotBy: e, selectionMode: t } } = $88ab1a78ec8ca4b4$var$_e(), { componentActions: n, componentState: { columns: r, groupColumn: i, hideColumnWhenGrouped: a, groupRenderStrategy: l, pivotColumns: s, pivotColumn: c, pivotTotalColumnPosition: u, pivotGrandTotalColumnPosition: d }, getComponentState: f } = $88ab1a78ec8ca4b4$export$2e1456d250441a8(), p = $88ab1a78ec8ca4b4$var$ps();
    return (0, $acw62.useEffect)(()=>{
        (()=>{
            let { columns: g, groupColumnIds: b } = $88ab1a78ec8ca4b4$var$aC({
                columns: r,
                groupColumn: i,
                pivotColumn: c,
                pivotTotalColumnPosition: u,
                pivotGrandTotalColumnPosition: d,
                groupRenderStrategy: l === "inline" ? "single-column" : l,
                groupBy: o,
                pivotBy: e,
                pivotColumns: s,
                toggleGroupRow: p,
                selectionMode: t
            });
            n.columnsWhenGrouping = g;
            let h = f().columnOrder;
            if (b.length && Array.isArray(h)) {
                let y = new Set(h), S = !1;
                b.forEach((C)=>{
                    y.has(C) || (S = !0, h = [
                        C,
                        ...h
                    ]);
                }), S && (n.columnOrder = h);
            }
        })();
    }, [
        r,
        o,
        e,
        t,
        a,
        i,
        l,
        s,
        u,
        c
    ]), {
        toggleGroupRow: p
    };
}
function $88ab1a78ec8ca4b4$var$iC(o) {
    let { componentState: { dataArray: e, groupRowsIndexesInDataArray: t, groupBy: n, groupRowsState: r, originalLazyGroupDataChangeDetect: i }, getState: a } = $88ab1a78ec8ca4b4$var$_e(), { getComponentState: l, componentActions: s, componentState: { columnTypes: c, computedColumns: u, hideColumnWhenGrouped: d, hideEmptyGroupColumns: f, groupRenderStrategy: p } } = $88ab1a78ec8ca4b4$export$2e1456d250441a8();
    (0, $acw62.useLayoutEffect)(()=>{
        if (p !== "multi-column") return;
        let m = l(), g = $88ab1a78ec8ca4b4$var$cm(u, o), b = $88ab1a78ec8ca4b4$var$um({
            computedGroupColumns: g,
            columnVisibility: m.columnVisibility,
            hideEmptyGroupColumns: f,
            groupRowsIndexesInDataArray: t,
            dataArray: e,
            groupBy: n,
            groupByMap: o
        });
        $88ab1a78ec8ca4b4$var$wt(m.columnVisibility, b) || (s.columnVisibility = b);
    }, [
        a,
        p,
        i,
        n,
        o,
        u,
        f ? e : null,
        f ? r : null,
        f ? t : null,
        f
    ]), (0, $acw62.useEffect)(()=>{
        let m = n.length > 0, g = l(), { columnVisibility: b, columnVisibilityForGrouping: h, hideColumnWhenGrouped: y } = g, S = {
            ...b
        }, C = {
            ...h
        }, T = !1, I = new Set, w = new Set;
        Object.keys(u).forEach((v)=>{
            let R = u[v];
            if (R.defaultHiddenWhenGroupedBy || y != null) {
                if (R.defaultHiddenWhenGroupedBy === "*" && m || (R.defaultHiddenWhenGroupedBy === !0 || y) && R.field && o.get(R.field) || typeof R.defaultHiddenWhenGroupedBy == "string" && o.get(R.defaultHiddenWhenGroupedBy) || typeof R.defaultHiddenWhenGroupedBy == "object" && Object.keys(R.defaultHiddenWhenGroupedBy).reduce((M, A)=>M || o.has(A), !1)) {
                    if (C[v] !== !1) {
                        if (b[v] === !1) return;
                        C[v] = !1, T = !0, I.add(v);
                    }
                } else C[v] === !1 && (delete C[v], T = !0, w.add(v));
            }
        }), T && (s.columnVisibilityForGrouping = C, w.forEach((v)=>{
            delete S[v];
        }), I.forEach((v)=>{
            S[v] = !1;
        }), s.columnVisibility = S);
    }, [
        u,
        c,
        n,
        o,
        d
    ]);
}
function $88ab1a78ec8ca4b4$var$aC(o) {
    let { pivotColumns: e, groupBy: t, pivotBy: n, selectionMode: r, groupColumn: i, pivotTotalColumnPosition: a, pivotGrandTotalColumnPosition: l, pivotColumn: s, groupRenderStrategy: c, toggleGroupRow: u, columns: d } = o;
    if (c === "inline") return {
        columns: void 0,
        groupColumnIds: []
    };
    let f = {}, p = [];
    if (c === "multi-column") t.forEach((m, g, b)=>{
        let h = $88ab1a78ec8ca4b4$var$cd({
            groupByForColumn: m,
            groupBy: t,
            pivotBy: n,
            groupIndexForColumn: g,
            groupCount: b.length,
            groupRenderStrategy: c,
            selectionMode: r
        }, u, i), y = h.id || `group-by-${m.field || m.groupField}`;
        p.push(y), f[y] = h;
    });
    else if (c === "single-column" && t.length) {
        let m = $88ab1a78ec8ca4b4$var$ud({
            groupCount: t.length,
            groupBy: t,
            pivotBy: n,
            groupRenderStrategy: c,
            selectionMode: r
        }, u, i), g = m.id || "group-by";
        p.push(g), f[g] = m;
    }
    if (e) {
        let m = {};
        Object.keys(d).forEach((g)=>{
            let b = d[g];
            b.field && (m[b.field] = b);
        }), Object.keys(e).forEach((g)=>{
            let b = e[g], h = b.pivotTotalColumn && b.columnGroup, y = b.pivotTotalColumn && !b.columnGroup;
            if (h && a === !1 || y && l === !1) return;
            let S = {
                ...b
            };
            s && (typeof s == "function" ? S = {
                ...S,
                ...s({
                    column: S,
                    pivotBy: n,
                    groupBy: t
                })
            } : S = {
                ...S,
                ...s
            }), S.inheritFromColumn !== !1 && (S = {
                ...typeof S.inheritFromColumn == "string" ? d[S.inheritFromColumn] : S.pivotAggregator?.field ? m[S.pivotAggregator?.field] : void 0,
                ...S
            }), !S.render && S.renderValue && (S.render = (C)=>S.renderValue(C)), f[g] = S;
        });
    } else Object.keys(d).forEach((m)=>{
        let g = d[m];
        f[m] = g;
    });
    return {
        columns: Object.keys(f).length ? f : void 0,
        groupColumnIds: p
    };
}
var $88ab1a78ec8ca4b4$var$fm = ({ columns: o, bodySize: e, columnMinWidth: t, columnMaxWidth: n, columnDefaultWidth: r, columnDefaultFlex: i, sortable: a, columnCssEllipsis: l, columnHeaderCssEllipsis: s, draggableColumns: c, columnDefaultDraggable: u, sortInfo: d, multiSort: f, filterValue: p, filterTypes: m, columnOrder: g, columnPinning: b, editable: h, columnDefaultEditable: y, columnDefaultFilterable: S, columnDefaultGroupable: C, columnDefaultSortable: T, scrollbarWidth: I, columnTypes: w, pinnedEndMaxWidth: v, pinnedStartMaxWidth: R, viewportReservedWidth: x, resizableColumns: M, columnVisibility: A, columnVisibilityAssumeVisible: E, columnSizing: P, groupBy: _ })=>{
    let { computedRemainingSpace: O, computedColumnOrder: F, computedVisibleColumns: W, computedVisibleColumnsMap: z, computedPinnedStartColumns: L, computedPinnedEndColumns: ae, computedUnpinnedColumns: te, computedPinnedStartColumnsWidth: B, computedPinnedEndColumnsWidth: j, computedUnpinnedColumnsWidth: oe, computedUnpinnedOffset: me, computedPinnedEndOffset: pe, computedPinnedEndWidth: ce, computedPinnedStartWidth: ue, renderSelectionCheckBox: ge, computedColumnsMap: H, computedColumnsMapInInitialOrder: G, fieldsToColumn: q } = (0, $acw62.useMemo)(()=>$88ab1a78ec8ca4b4$var$su({
            columns: o,
            scrollbarWidth: I,
            bodySize: e,
            columnMinWidth: t,
            columnMaxWidth: n,
            columnDefaultWidth: r,
            columnDefaultFlex: i,
            columnCssEllipsis: l,
            columnHeaderCssEllipsis: s,
            viewportReservedWidth: x,
            resizableColumns: M,
            filterValue: p,
            filterTypes: m,
            sortable: a,
            sortInfo: d,
            multiSort: f,
            pinnedEndMaxWidth: v,
            pinnedStartMaxWidth: R,
            draggableColumns: c,
            columnDefaultDraggable: u,
            columnOrder: g,
            columnPinning: b,
            columnDefaultEditable: y,
            columnDefaultFilterable: S,
            columnDefaultGroupable: C,
            columnDefaultSortable: T,
            editable: h,
            columnSizing: P,
            columnTypes: w,
            columnVisibility: A,
            columnVisibilityAssumeVisible: E ?? !0,
            groupBy: _
        }), [
        o,
        e.width,
        t,
        n,
        r,
        x,
        I,
        a,
        d,
        f,
        p,
        m,
        g,
        A,
        E,
        u,
        c,
        M,
        v,
        R,
        P,
        w,
        b,
        y,
        S,
        C,
        h,
        _,
        1
    ]);
    return {
        renderSelectionCheckBox: ge,
        columns: o,
        computedColumnsMap: H,
        computedPinnedEndWidth: ce,
        computedPinnedStartWidth: ue,
        computedRemainingSpace: O,
        computedUnpinnedOffset: me,
        computedPinnedEndOffset: pe,
        computedPinnedStartColumnsWidth: B,
        computedPinnedEndColumnsWidth: j,
        computedUnpinnedColumnsWidth: oe,
        computedPinnedStartColumns: L,
        computedPinnedEndColumns: ae,
        computedUnpinnedColumns: te,
        computedVisibleColumns: W,
        computedVisibleColumnsMap: z,
        computedColumnOrder: F,
        computedColumnsMapInInitialOrder: G,
        fieldsToColumn: q
    };
};
var $88ab1a78ec8ca4b4$var$ms = class {
    constructor(){
        this.rowHeight = new Map;
        this.rowDetailHeight = new Map;
        this.getRowHeight = (e)=>this.rowHeight.get(e) ?? 0;
        this.getRowDetailHeight = (e)=>this.rowDetailHeight.get(e) ?? 0;
    }
    getTotalRowHeight(e) {
        return this.getRowHeight(e) + this.getRowDetailHeight(e);
    }
    getSize(e) {
        let t = this.getRowHeight(e), n = this.getRowDetailHeight(e);
        return {
            rowHeight: t,
            rowDetailHeight: n,
            totalRowHeight: t + n
        };
    }
};
function $88ab1a78ec8ca4b4$var$cC(o, e) {
    let t = o.rowDetailHeight, n = o.rowHeight, { isRowDetailsExpanded: r, isRowDetailsEnabled: i, getDataSourceState: a } = o;
    if (!r) return typeof n == "function" ? (u)=>{
        if (e && e.rowHeight.has(u)) return e.rowHeight.get(u);
        let d = a().dataArray[u], f = d ? n(d) : 0;
        return e && e.rowHeight.set(u, f), f;
    } : n;
    let l = typeof n == "function", s = typeof t == "function";
    return (u)=>{
        if (e && e.rowHeight.has(u) && e.rowDetailHeight.has(u)) return e.rowHeight.get(u) + e.rowDetailHeight.get(u);
        let d = a().dataArray[u];
        if (!d) return e && (e.rowHeight.set(u, 0), e.rowDetailHeight.set(u, 0)), 0;
        let f = l ? n(d) : n;
        if (!!(!i || typeof i == "function" && i(d) === !1) || !r(d)) return e && (e.rowHeight.set(u, f), e.rowDetailHeight.set(u, 0)), f;
        let m = 0;
        return s ? m = t(d) : m = t, e && (e.rowHeight.set(u, f), e.rowDetailHeight.set(u, m)), f + m;
    };
}
function $88ab1a78ec8ca4b4$var$pm(o) {
    return (0, $acw62.useMemo)(()=>{
        let e = new $88ab1a78ec8ca4b4$var$ms;
        return {
            computedRowHeight: $88ab1a78ec8ca4b4$var$cC(o, e),
            computedRowSizeCacheForDetails: o.isRowDetailsExpanded ? e : void 0
        };
    }, [
        o.rowHeight,
        o.rowDetailHeight,
        o.isRowDetailsExpanded,
        o.isRowDetailsEnabled,
        o.getDataSourceState
    ]);
}
var $88ab1a78ec8ca4b4$var$pC = {
    vertical: !1,
    horizontal: !1
};
function $88ab1a78ec8ca4b4$var$mm(o) {
    let { getComponentState: e } = $88ab1a78ec8ca4b4$export$2e1456d250441a8(), { getState: t } = $88ab1a78ec8ca4b4$var$_e(), [n, r] = (0, $acw62.useState)($88ab1a78ec8ca4b4$var$pC);
    return (0, $acw62.useEffect)(()=>o.onRenderCountChange(()=>{
            let { scrollTopMax: i, scrollLeftMax: a } = o;
            r({
                vertical: i > 0,
                horizontal: a > 0
            });
        }), [
        o
    ]), (0, $acw62.useLayoutEffect)(()=>{
        let i = t(), { onScrollbarsChange: a } = e(), { notifyScrollbarsChange: l } = i;
        a && i.updatedAt && i.dataArray.length && a(n), l(n);
    }, [
        n
    ]), n;
}
function $88ab1a78ec8ca4b4$var$gm() {
    let { componentActions: o, componentState: e } = $88ab1a78ec8ca4b4$export$2e1456d250441a8(), { componentActions: t, componentState: n, getState: r, api: i } = $88ab1a78ec8ca4b4$var$_e(), { columnOrder: a, columnVisibility: l, columnPinning: s, columnSizing: c, editable: u, columnDefaultEditable: d, columnDefaultFilterable: f, columnDefaultGroupable: p, columnTypes: m, rowHeight: g, rowDetailHeight: b, isRowDetailExpanded: h, isRowDetailEnabled: y, brain: S, bodySize: C, showSeparatePivotColumnForSingleAggregation: T } = e;
    (0, $acw62.useState)(()=>{
        e.onRowHeightCSSVarChange.onChange((N1)=>{
            N1 && (o.rowHeight = N1);
        }), e.onFlashingDurationCSSVarChange.onChange((N1)=>{
            let $ = N1 ? N1 * 1 : null;
            $ != null && !isNaN($) && (o.flashingDurationCSSVarValue = $);
        }), e.onRowDetailHeightCSSVarChange.onChange((N1)=>{
            N1 && (o.rowDetailHeight = N1);
        }), e.onColumnHeaderHeightCSSVarChange.onChange((N1)=>{
            N1 && (o.columnHeaderHeight = N1);
        });
    }), (0, $acw62.useEffect)(()=>{
        t.showSeparatePivotColumnForSingleAggregation = T;
    }, [
        T
    ]);
    let { multiSort: I, filterValue: w, filterTypes: v, groupBy: R } = n, { toggleGroupRow: x } = $88ab1a78ec8ca4b4$var$dm(), M = e.computedColumns, { computedColumnOrder: A, computedVisibleColumns: E, computedVisibleColumnsMap: P, computedPinnedStartColumns: _, computedPinnedEndColumns: D, computedUnpinnedColumns: O, computedPinnedStartColumnsWidth: F, computedPinnedEndColumnsWidth: W, computedUnpinnedColumnsWidth: z, computedUnpinnedOffset: L, computedPinnedEndOffset: ae, computedRemainingSpace: te, computedPinnedStartWidth: B, computedPinnedEndWidth: j, renderSelectionCheckBox: oe, computedColumnsMap: me, computedColumnsMapInInitialOrder: pe, fieldsToColumn: ce } = $88ab1a78ec8ca4b4$var$fm({
        columns: M,
        scrollbarWidth: void 0,
        columnCssEllipsis: e.columnCssEllipsis,
        columnHeaderCssEllipsis: e.columnHeaderCssEllipsis,
        columnMinWidth: e.columnMinWidth,
        columnMaxWidth: e.columnMaxWidth,
        columnDefaultWidth: e.columnDefaultWidth,
        columnDefaultFlex: e.columnDefaultFlex,
        columnDefaultSortable: e.columnDefaultSortable,
        columnDefaultDraggable: e.columnDefaultDraggable,
        pinnedStartMaxWidth: e.pinnedStartMaxWidth,
        pinnedEndMaxWidth: e.pinnedEndMaxWidth,
        bodySize: C,
        viewportReservedWidth: e.viewportReservedWidth,
        resizableColumns: e.resizableColumns,
        sortable: e.sortable,
        draggableColumns: e.draggableColumns,
        sortInfo: n.sortInfo ?? void 0,
        multiSort: I,
        groupBy: R,
        columnOrder: a,
        columnVisibility: l,
        columnVisibilityAssumeVisible: !0,
        columnPinning: s,
        editable: u,
        columnDefaultEditable: d,
        columnDefaultFilterable: f,
        columnDefaultGroupable: p,
        filterValue: w,
        filterTypes: v,
        columnSizing: c,
        columnTypes: m
    }), ue = $88ab1a78ec8ca4b4$var$Zp(E), ge = $88ab1a78ec8ca4b4$var$Qp(E), H = $88ab1a78ec8ca4b4$var$mm(S), G = B ? F > B : !1, q = j ? W > j : !1, [K] = (0, $acw62.useState)(()=>new $88ab1a78ec8ca4b4$var$$i({
            isRowDisabledAt: ($)=>r().dataArray[$]?.rowDisabled ?? !1,
            getIdForIndex: ($)=>r().dataArray[$]?.id ?? -1
        })), re = $88ab1a78ec8ca4b4$var$Me(E), [J] = (0, $acw62.useState)(()=>new $88ab1a78ec8ca4b4$var$ji({
            getPrimaryKeyByIndex: i.getPrimaryKeyByIndex,
            getColumnIdByIndex: (N1)=>re()[N1]?.id || ""
        })), { computedRowHeight: de, computedRowSizeCacheForDetails: we } = $88ab1a78ec8ca4b4$var$pm({
        rowDetailHeight: b,
        rowHeight: g,
        isRowDetailsExpanded: h,
        isRowDetailsEnabled: y,
        getDataSourceState: r
    });
    return {
        multiRowSelector: K,
        multiCellSelector: J,
        computedRowSizeCacheForDetails: we,
        computedRowHeight: de,
        scrollbars: H,
        columnSize: ge,
        rowspan: ue,
        toggleGroupRow: x,
        computedColumnsMap: me,
        computedColumnsMapInInitialOrder: pe,
        renderSelectionCheckBox: oe,
        computedPinnedStartOverflow: G,
        computedPinnedEndOverflow: q,
        computedPinnedStartWidth: B,
        computedPinnedEndWidth: j,
        computedVisibleColumns: E,
        computedColumnOrder: A,
        computedRemainingSpace: te,
        computedVisibleColumnsMap: P,
        computedPinnedStartColumns: _,
        computedPinnedEndColumns: D,
        computedUnpinnedColumns: O,
        computedPinnedStartColumnsWidth: F,
        computedPinnedEndColumnsWidth: W,
        computedUnpinnedColumnsWidth: z,
        computedUnpinnedOffset: L,
        computedPinnedEndOffset: ae,
        fieldsToColumn: ce
    };
}
function $88ab1a78ec8ca4b4$var$gC(o = 3988292384) {
    var e = new Array, t, n, r;
    for(t = 0; t < 256; t++){
        for(r = t, n = 8; n > 0; n--)(r & 1) == 1 ? r = r >>> 1 ^ o : r = r >>> 1;
        e[t] = r;
    }
    return e;
}
function $88ab1a78ec8ca4b4$var$hC() {
    return 4294967295;
}
function $88ab1a78ec8ca4b4$var$bC(o, e, t) {
    return e = e >>> 8 ^ o[t ^ e & 255], e;
}
function $88ab1a78ec8ca4b4$var$yC(o) {
    return o = ~o, o = o < 0 ? 4294967295 + o + 1 : o, o;
}
function $88ab1a78ec8ca4b4$var$hs(o, e = 3988292384) {
    var t = $88ab1a78ec8ca4b4$var$gC(e), n = 0, r;
    for(n = $88ab1a78ec8ca4b4$var$hC(), r = 0; r < o.length; r++)n = $88ab1a78ec8ca4b4$var$bC(t, n, o.charCodeAt(r));
    return n = $88ab1a78ec8ca4b4$var$yC(n), `${n}`;
}
var $88ab1a78ec8ca4b4$var$TC = (o)=>{
    let e = o.reduce((n, r)=>(n.set(r.name, r.value), n), new Map);
    return {
        distribution: e.get("Type") === "distribution",
        count: e.get("DevCount") ? Number(e.get("DevCount")) : 0,
        start: new Date(e.get("StartDate")),
        end: new Date(e.get("EndDate")),
        owner: e.get("Owner"),
        type: e.get("Type"),
        timestamp: e.get("TS") ? Number(e.get("TS")) : 0,
        trial: e.get("Trial") === "true",
        ref: e.get("Ref") ?? ""
    };
}, $88ab1a78ec8ca4b4$var$hm = (o, e = console.error.bind(console))=>{
    o = [
        "* * * infinite-table.com * * *",
        ...o
    ];
    let t = Math.max(Math.max(...o.map((n)=>n.length)) + 8, 60);
    o.forEach((n)=>{
        let r = (t - n.length) / 2 - 1, i = 0;
        r !== Math.round(r) && (i = -1, r = Math.round(r));
        let a = r + i, l = r;
        e("*".repeat(a) + " " + n + " " + "*".repeat(l));
    }), e("*".repeat(t));
}, $88ab1a78ec8ca4b4$var$bm = (o = "", e, t)=>{
    let n;
    try {
        n = $88ab1a78ec8ca4b4$var$SC(o);
    } catch  {
        return $88ab1a78ec8ca4b4$var$hm([
            "You don't have a valid Infinite Table license",
            "Please visit infinite-table.com to purchase a license.",
            "Thank you for playing fair!"
        ], t), !1;
    }
    let r = new Date(e.publishedAt), i = new Date(n.end);
    return i < r ? ($88ab1a78ec8ca4b4$var$hm([
        `
Your Infinite Table license has expired on ${i.toDateString()}.
`,
        `You are using version "${e.version}" of Infinite Table, which was published on ${r.toDateString()}.`,
        "Please visit infinite-table.com to renew your license.",
        "Thank you for playing fair!"
    ], t), !1) : !0;
}, $88ab1a78ec8ca4b4$var$SC = (o)=>{
    let e = "", t = o.split("|").map((l)=>{
        let [s, c] = l.split("=");
        return s === "C" && (e = c), {
            name: s,
            value: c
        };
    });
    if (!e) throw "Invalid license";
    let n = e.split(",").reverse(), r = n.pop();
    n.forEach((l, s)=>{
        let c = t[s];
        if ($88ab1a78ec8ca4b4$var$hs(c.value) !== l) throw "Invalid license";
    });
    let i = [
        ...t
    ];
    i.pop();
    let a = i.map((l)=>`${l.name}=${l.value}`).join("|");
    if ($88ab1a78ec8ca4b4$var$hs(a) !== r) throw "Invalid license";
    return t = t.map((l)=>({
            ...l,
            value: decodeURI(l.value)
        })), $88ab1a78ec8ca4b4$var$TC(t);
};
var $88ab1a78ec8ca4b4$var$wC = /(https):\/\/\d+\-\d+\-\d+\-(sandpack\.codesandbox\.io)/g, $88ab1a78ec8ca4b4$var$IC = /(https):\/\/\S+(\.csb\.app)/g, $88ab1a78ec8ca4b4$var$ym = typeof window < "u" ? window.location.origin : "", $88ab1a78ec8ca4b4$var$vC = ()=>{
    let [o, e, t] = Array.from($88ab1a78ec8ca4b4$var$wC.exec($88ab1a78ec8ca4b4$var$ym) || []);
    return e === "https" && t === "sandpack.codesandbox.io";
}, $88ab1a78ec8ca4b4$var$RC = ()=>{
    let [o, e, t] = Array.from($88ab1a78ec8ca4b4$var$IC.exec($88ab1a78ec8ca4b4$var$ym) || []);
    return e === "https" && t === ".csb.app";
}, $88ab1a78ec8ca4b4$var$xC = $88ab1a78ec8ca4b4$var$RC() || $88ab1a78ec8ca4b4$var$vC(), $88ab1a78ec8ca4b4$var$Tm = (o = "")=>{
    let t = !!$88ab1a78ec8ca4b4$var$Ve();
    return (0, $acw62.useMemo)(()=>{
        if (t) return !0;
        let r = $88ab1a78ec8ca4b4$var$bm(o, {
            publishedAt: 1624970570587,
            version: "7.5.1"
        });
        return !o && !r && $88ab1a78ec8ca4b4$var$xC ? !0 : r;
    }, [
        o,
        t
    ]);
};
var $88ab1a78ec8ca4b4$var$PC = 10;
function $88ab1a78ec8ca4b4$var$wm(o, e, t) {
    let n = (0, $acw62.useRef)(!1), r = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        o != null && (n.current = !1, $88ab1a78ec8ca4b4$var$At(r.current));
    }, [
        o
    ]), (0, $acw62.useEffect)(()=>{
        if (o != null && !n.current) {
            let a = function(l = 0) {
                l++, $88ab1a78ec8ca4b4$var$At(r.current), r.current = $88ab1a78ec8ca4b4$var$ke(()=>{
                    n.current = t.scrollCellIntoView(o[0], o[1], {
                        offset: 30
                    }), !n.current && l < $88ab1a78ec8ca4b4$var$PC && a(l);
                });
            };
            var i = a;
            a();
        }
        return ()=>{
            $88ab1a78ec8ca4b4$var$At(r.current);
        };
    }, [
        o,
        e
    ]);
}
var $88ab1a78ec8ca4b4$var$DC = 10;
function $88ab1a78ec8ca4b4$var$Rm(o, e, t) {
    let n = (0, $acw62.useRef)(!1), r = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        o != null && (n.current = !1, cancelAnimationFrame(r.current));
    }, [
        o
    ]), (0, $acw62.useEffect)(()=>{
        if (o != null && !n.current) {
            let a = function(l = 0) {
                l++, r.current = requestAnimationFrame(()=>{
                    n.current = t.scrollRowIntoView(o, {
                        offset: 0
                    }), !n.current && l < $88ab1a78ec8ca4b4$var$DC && a(l);
                });
            };
            var i = a;
            a();
        }
        return ()=>{
            cancelAnimationFrame(r.current);
        };
    }, [
        o,
        e
    ]);
}
var $88ab1a78ec8ca4b4$var$xm = (o)=>`--infinite-${o}`;
function $88ab1a78ec8ca4b4$var$Pm(o, e) {
    $88ab1a78ec8ca4b4$var$bs(o, e), $88ab1a78ec8ca4b4$var$EC(o, e), e.detail === 2 && $88ab1a78ec8ca4b4$var$MC(o, e), o.getState().onCellClick?.(o, e);
}
function $88ab1a78ec8ca4b4$var$MC(o, e) {
    if ($88ab1a78ec8ca4b4$var$$r(e.target)) return;
    let { onCellDoubleClick: t } = o.getState(), n = {
        preventEdit: !1
    };
    if (t) {
        let a = t(o, e);
        a && typeof a == "object" && (n = {
            ...n,
            ...a
        });
    }
    if (n.preventEdit) return;
    let i = o.getComputed().computedVisibleColumns[o.colIndex];
    o.api.startEdit({
        rowIndex: o.rowIndex,
        columnId: i.id
    });
}
function $88ab1a78ec8ca4b4$var$EC(o, e) {
    let { getDataSourceState: t, getState: n, getComputed: r, rowIndex: i, colIndex: a, dataSourceActions: l } = o, s = t(), { selectionMode: c, cellSelection: u } = s;
    if (!u || c !== "multi-cell") return;
    let { multiCellSelector: d, computedVisibleColumns: f } = r(), { brain: p, debugId: m } = n(), { rowsPerPage: g } = p, b = f.length, h = new $88ab1a78ec8ca4b4$export$31e3cce2e16ab248(u);
    h.debugId = m ?? "", d.cellSelectionState = h;
    let y = {
        rowIndex: i,
        colIndex: a
    };
    if (e.metaKey || e.ctrlKey) d.singleAddClick(y);
    else if (e.shiftKey) {
        let S = !!n().wrapRowsHorizontally;
        d.multiSelectClick(y, S ? {
            horizontalLayout: S,
            rowsPerPage: g,
            columnsPerSet: b
        } : {
            horizontalLayout: S
        });
    } else d.resetClick(y);
    l.cellSelection = h;
}
function $88ab1a78ec8ca4b4$var$bs(o, e) {
    let { rowIndex: t, getDataSourceState: n, getComputed: r, dataSourceActions: i, api: a, cloneRowSelection: l } = o, { multiRowSelector: s, renderSelectionCheckBox: c } = r(), u = n(), { selectionMode: d, groupBy: f, dataArray: p, isTree: m } = u;
    if (f.length || m || p[t]?.rowDisabled) return !1;
    if (d === "multi-row") {
        if (c && !e.key) return !1;
        let { rowSelection: b } = u;
        if (b = l(b), s.rowSelectionState = b, b && typeof b == "object") return e.shiftKey ? s.multiSelectClick(t) : e.metaKey || e.ctrlKey ? s.singleAddClick(t) : s.resetClick(t), i.rowSelection = b, !0;
    } else if (d === "single-row") {
        let h = p[t].id;
        e.metaKey || e.ctrlKey ? a.rowSelectionApi.toggleRowSelection(h) : a.rowSelectionApi.selectRow(h);
    }
    return !1;
}
function $88ab1a78ec8ca4b4$var$Dm(o, e) {
    e.detail;
}
var $88ab1a78ec8ca4b4$var$AC = {
    Enter: !0,
    " ": !0,
    a: !0
};
function $88ab1a78ec8ca4b4$var$Mm(o, e) {
    let { getState: t, getDataSourceState: n, dataSourceActions: r, api: i, dataSourceApi: a, cloneRowSelection: l, cloneTreeSelection: s } = o, { key: c, ctrlKey: u, metaKey: d } = e;
    if (!$88ab1a78ec8ca4b4$var$AC[c]) return !1;
    let f = t(), p = n(), { activeRowIndex: m, activeCellIndex: g, keyboardNavigation: b, keyboardSelection: h } = f, { selectionMode: y, groupBy: S, rowSelection: C, treeSelectionState: T, isTree: I } = p;
    if (h === !1) return !1;
    let w = b === "row" && m != null ? m : b === "cell" && g != null ? g[0] : null, v = w != null ? p.dataArray[w] : null;
    if (!v || w == null) return !1;
    if (y === "single-row" && c === " ") return i.rowSelectionApi.toggleRowSelection(v.id), !0;
    if (y !== "multi-row") return !1;
    if (c === "a" && (u || d)) {
        if (I && T) {
            let x = s(T);
            return x.selectAll(), r.treeSelection = x, !0;
        }
        let R = l(C);
        return R.selectAll(), r.rowSelection = R, !0;
    }
    if (c === " ") {
        if (S.length) return v.isGroupRow && v.groupKeys ? i.rowSelectionApi.toggleGroupRowSelection(v.groupKeys) : i.rowSelectionApi.toggleRowSelection(v.id), !0;
        if (I) {
            if (v.isTreeNode && v.nodePath) return a.treeApi.toggleNodeSelection(v.nodePath), !0;
        } else {
            let R = {
                ...e
            }, { renderSelectionCheckBox: x } = o.getComputed();
            return x && (R.metaKey = !1, R.ctrlKey = !0), $88ab1a78ec8ca4b4$var$bs({
                ...o,
                rowIndex: w
            }, R);
        }
    }
    return !1;
}
var $88ab1a78ec8ca4b4$var$Em = [
    "input",
    "textarea",
    "select",
    "[tabindex]",
    "a[href]",
    "button",
    "object"
].join(", "), $88ab1a78ec8ca4b4$var$Am = (o)=>Array.from(o.querySelectorAll($88ab1a78ec8ca4b4$var$Em)).filter((t)=>!!t.offsetParent), $88ab1a78ec8ca4b4$var$Yi = (o)=>o.querySelector($88ab1a78ec8ca4b4$var$Em);
var $88ab1a78ec8ca4b4$var$Om = $88ab1a78ec8ca4b4$var$qn($88ab1a78ec8ca4b4$var$Dn());
async function $88ab1a78ec8ca4b4$var$_m(o, e = 10, t = 300) {
    return new Promise((n, r)=>{
        let i = Date.now();
        function a() {
            if (Date.now() - i > t) return r(!1);
            if (!o()) {
                setTimeout(a, e);
                return;
            }
            n(!0);
        }
        a();
    });
}
var $88ab1a78ec8ca4b4$var$_C = 10, $88ab1a78ec8ca4b4$var$OC = (o, e)=>o - e;
function $88ab1a78ec8ca4b4$var$qi(o, e) {
    let { getComputed: t, getDataSourceState: n, getState: r, api: i, dataSourceApi: a } = e, { editingCell: l, isRowDetailEnabled: s } = r(), { dataArray: c } = n(), { computedVisibleColumns: u, computedColumnsMap: d } = t(), f = u[o.colIndex];
    if (!f) return !1;
    if (l && l.columnId === f.id && l.rowIndex === o.rowIndex) return !0;
    if (!f.contentFocusable) return !1;
    if (f.contentFocusable === !0) return !0;
    let p = c[o.rowIndex], m = !s || typeof s == "function" && !s(p) ? !1 : i.rowDetailApi.isRowDetailExpanded(p.id) ? "expanded" : "collapsed", g = $88ab1a78ec8ca4b4$var$it(f.id, e);
    return f.contentFocusable({
        column: f,
        ...$88ab1a78ec8ca4b4$var$so({
            column: f,
            rowInfo: p,
            columnsMap: d,
            context: e,
            rowDetailState: m
        }).formattedValueContext,
        columnApi: g,
        api: i,
        dataSourceApi: a
    });
}
function $88ab1a78ec8ca4b4$var$ys(o, e, t) {
    let n = t.getState().editingCell;
    return $88ab1a78ec8ca4b4$var$NC(o, e, t, {
        isCellFocusable: $88ab1a78ec8ca4b4$var$qi,
        isColumnElligible: (i)=>n && n.columnId === i.id ? !0 : !!i.contentFocusable
    });
}
function $88ab1a78ec8ca4b4$var$Nm(o, e, t) {
    let n = (0, $88ab1a78ec8ca4b4$var$Om.default)(t, o + e, $88ab1a78ec8ca4b4$var$OC);
    return n < 0 && (n = ~n, e > 0 && n >= t.length || e < 0 && n === 0) ? null : t[n] ?? null;
}
globalThis.getNextCol = $88ab1a78ec8ca4b4$var$Nm;
function $88ab1a78ec8ca4b4$var$NC(o, e, t, n) {
    let { isColumnElligible: r, isCellFocusable: i } = n, a = t.getComputed().computedVisibleColumns.filter(r).reduce((d, f)=>(d.push(f.computedVisibleIndex), d), []);
    if (!a.length) return null;
    let { getDataSourceState: l } = t, { dataArray: s } = l(), c = o.rowIndex, u = o.colIndex;
    for(; c != null || u != null;){
        if (u = u === null ? a[e === -1 ? a.length - 1 : 0] : $88ab1a78ec8ca4b4$var$Nm(u, e, a), u === null) {
            if (c += e, c < 0 || c >= s.length) return null;
            continue;
        }
        if (i({
            colIndex: u,
            rowIndex: c
        }, t)) return {
            colIndex: u,
            rowIndex: c
        };
    }
    return null;
}
async function $88ab1a78ec8ca4b4$var$Fm(o) {
    let e = {
        rowIndex: o.getDataSourceState().dataArray.length - 1,
        colIndex: o.getComputed().computedVisibleColumns.length - 1
    }, t = $88ab1a78ec8ca4b4$var$qi(e, o) ? e : $88ab1a78ec8ca4b4$var$ys(e, -1, o);
    if (t) {
        await $88ab1a78ec8ca4b4$var$Ts([
            t.rowIndex,
            t.colIndex
        ], o);
        let n = o.getState().getDOMNodeForCell(t);
        if (!n) return;
        $88ab1a78ec8ca4b4$var$Yi(n)?.focus();
    }
}
async function $88ab1a78ec8ca4b4$var$Ts([o, e], t) {
    let { api: n } = t;
    return new Promise((r, i)=>{
        let a = $88ab1a78ec8ca4b4$var$_C, l = null, s = !1;
        function c(u = 0) {
            u++, $88ab1a78ec8ca4b4$var$At(l), l = $88ab1a78ec8ca4b4$var$ke(async ()=>{
                if (s = n.scrollCellIntoView(o, e, {
                    offset: 30
                }), !s && u < a && c(u), s) {
                    try {
                        await $88ab1a78ec8ca4b4$var$_m(()=>!!t.getState().getDOMNodeForCell({
                                rowIndex: o,
                                colIndex: e
                            }));
                    } catch (d) {
                        i(d);
                        return;
                    }
                    r(!0);
                }
            });
        }
        c();
    });
}
var $88ab1a78ec8ca4b4$var$FC = `.${$88ab1a78ec8ca4b4$var$zt}`;
function $88ab1a78ec8ca4b4$var$Lm(o, e) {
    if (e.key !== "Tab") return !1;
    let t = e.shiftKey ? -1 : 1, n = e.target, r = o.getState().scrollerDOMRef.current, i = document.activeElement === r || n === r;
    if (!r || i && t === -1) return !1;
    let a = i ? null : $88ab1a78ec8ca4b4$var$cn(n, $88ab1a78ec8ca4b4$var$FC), l = null, s = null;
    if (a) l = Number(a.getAttribute("data-row-index")), s = Number(a.getAttribute("data-col-index"));
    else if (i) {
        let { activeCellIndex: u } = o.getState();
        [l, s] = u || [
            0,
            0
        ];
    }
    if (l == null || s == null || isNaN(l) || isNaN(s)) return !1;
    let c = i && $88ab1a78ec8ca4b4$var$qi({
        colIndex: s,
        rowIndex: l
    }, o) ? {
        rowIndex: l,
        colIndex: s
    } : $88ab1a78ec8ca4b4$var$ys({
        rowIndex: l,
        colIndex: s
    }, t, o);
    if (!c) {
        if (t === -1) r.focus();
        else {
            let u = $88ab1a78ec8ca4b4$var$Am(document.body), d = o.getState().focusDetectDOMRef.current, f = u.findIndex((m)=>m === d);
            u[f + 1]?.focus();
        }
        return !0;
    }
    return $88ab1a78ec8ca4b4$var$Ts([
        c.rowIndex,
        c.colIndex
    ], o).then(()=>{
        let u = o.getState().getDOMNodeForCell(c);
        if (!u) return;
        $88ab1a78ec8ca4b4$var$Yi(u)?.focus();
    }), !0;
}
var $88ab1a78ec8ca4b4$var$km = {
    control: "ctrl"
}, $88ab1a78ec8ca4b4$var$zm = {
    "control|cmd": "ctrl",
    "cmd|control": "ctrl",
    "ctrl|cmd": "ctrl",
    "cmd|ctrl": "ctrl"
}, $88ab1a78ec8ca4b4$var$LC = {
    esc: "escape"
}, $88ab1a78ec8ca4b4$var$Gm = {
    cmd: (o)=>o.metaKey,
    alt: (o)=>o.altKey,
    ctrl: (o)=>o.ctrlKey,
    shift: (o)=>o.shiftKey
}, $88ab1a78ec8ca4b4$var$Hm = Object.keys($88ab1a78ec8ca4b4$var$Gm), $88ab1a78ec8ca4b4$var$Ss = new Set($88ab1a78ec8ca4b4$var$Hm), $88ab1a78ec8ca4b4$var$kC = new Set([
    "shift",
    "alt"
]);
function $88ab1a78ec8ca4b4$export$2e1d1f4b6eba8ed2(o, e) {
    return Array.isArray(e) ? e.some((t)=>$88ab1a78ec8ca4b4$var$Vm(o, t)) : $88ab1a78ec8ca4b4$var$Vm(o, e);
}
function $88ab1a78ec8ca4b4$var$Vm(o, e) {
    let t = o.key.toLowerCase(), n = e.split("+").map((f)=>f.toLowerCase().trim()), r = n.find((f)=>$88ab1a78ec8ca4b4$var$zm[f]), i = n.map((f)=>$88ab1a78ec8ca4b4$var$km[f] || $88ab1a78ec8ca4b4$var$zm[f] || $88ab1a78ec8ca4b4$var$LC[f] || f), a = i.filter((f)=>$88ab1a78ec8ca4b4$var$Ss.has(f)), l = i.filter((f)=>!$88ab1a78ec8ca4b4$var$Ss.has(f)), s = $88ab1a78ec8ca4b4$var$Hm.reduce((f, p)=>(f[p] = $88ab1a78ec8ca4b4$var$Gm[p](o), f), {});
    r && s.cmd && (s.cmd = !1, s.ctrl = !0);
    let c = Object.keys(s).filter((f)=>s[f]);
    if (!a.every((f)=>s[f] === !0)) return !1;
    if (l.includes("*")) {
        if (c.length < a.length || c.filter((p)=>!$88ab1a78ec8ca4b4$var$kC.has(p)).length) return !1;
    } else if (a.length != c.length) return !1;
    return !l.length || $88ab1a78ec8ca4b4$var$Ss.has(t) || t === "meta" || $88ab1a78ec8ca4b4$var$km[t] ? !1 : l.reduce((f, p)=>f ? p === "*" || t === p : !1, !0);
}
async function $88ab1a78ec8ca4b4$var$Km(o, e) {
    let t = {
        ...o,
        cloneRowSelection: (a)=>$88ab1a78ec8ca4b4$var$Di(a, o.getDataSourceState),
        cloneTreeSelection: (a)=>$88ab1a78ec8ca4b4$var$_i(a, o.getDataSourceState)
    }, { onKeyDown: n } = o.getState(), r = {
        preventEdit: !1,
        preventEditStop: !1,
        preventDefaultForTabKeyWhenEditing: !0,
        preventSelection: !1,
        preventNavigation: !1
    };
    if (n) {
        let a = n(o, e);
        a && typeof a == "object" && (r = {
            ...r,
            ...a
        });
    }
    if (!r.preventSelection && $88ab1a78ec8ca4b4$var$Mm(t, e) && e.preventDefault(), ($88ab1a78ec8ca4b4$var$Lm(t, e) || !o.getState().focusedWithin && !r.preventNavigation && $88ab1a78ec8ca4b4$var$Wp(t, e)) && e.preventDefault(), !r.preventEdit && e.key === "Enter" && !o.api.isEditInProgress()) {
        let { activeCellIndex: a } = o.getState();
        if (a) {
            let [l, s] = a, c = o.getComputed().computedVisibleColumns[s];
            c.computedEditable && o.api.startEdit({
                rowIndex: l,
                columnId: c.id
            });
        }
    }
    o.api.isEditInProgress() && (e.key === "Escape" && !r.preventEditStop && o.api.stopEdit({
        cancel: !0
    }), e.key === "Tab" && r.preventDefaultForTabKeyWhenEditing && e.preventDefault());
    let { keyboardShortcuts: i } = o.getState();
    if (i) for await (let a of i){
        if (!$88ab1a78ec8ca4b4$export$2e1d1f4b6eba8ed2(e, a.key) || a.when && !await a.when(o)) continue;
        let l = await a.handler(o, e);
        if (l && l.stopNext) break;
    }
}
function $88ab1a78ec8ca4b4$var$HC() {
    let { getState: o, actions: e, api: t, getComputed: n, getDataSourceMasterContext: r } = $88ab1a78ec8ca4b4$var$Q(), { getState: i, componentActions: a, api: l } = $88ab1a78ec8ca4b4$var$_e();
    return (0, $acw62.useMemo)(()=>({
            getComputed: n,
            getDataSourceMasterContext: r,
            dataSourceApi: l,
            api: t,
            getState: o,
            actions: e,
            getDataSourceState: i,
            dataSourceActions: a,
            cloneTreeSelection: (u)=>$88ab1a78ec8ca4b4$var$_i(u, i),
            cloneRowSelection: (u)=>$88ab1a78ec8ca4b4$var$Di(u, i)
        }), [
        o,
        e,
        i,
        a,
        t,
        l,
        n
    ]);
}
function $88ab1a78ec8ca4b4$var$KC() {
    let o = $88ab1a78ec8ca4b4$var$HC();
    (0, $acw62.useEffect)(()=>{
        let e = o.getState().keyDown.onChange((a)=>{
            $88ab1a78ec8ca4b4$var$Km(o, a);
        });
        function t(a) {
            if (!a) return;
            let l = a.event, s = o.getComputed().computedVisibleColumns[a.colIndex], c = $88ab1a78ec8ca4b4$var$it(s.id, o);
            $88ab1a78ec8ca4b4$var$Pm({
                ...o,
                rowIndex: a.rowIndex,
                colIndex: a.colIndex,
                column: s,
                columnApi: c
            }, {
                ...l,
                key: ""
            });
        }
        let n = o.getState().cellClick.onChange(t);
        function r(a) {
            if (!a) return;
            let { event: l, rowIndex: s, colIndex: c } = a, u = o.getComputed().computedVisibleColumns[c], d = $88ab1a78ec8ca4b4$var$it(u.id, o);
            $88ab1a78ec8ca4b4$var$Dm({
                ...o,
                rowIndex: s,
                colIndex: c,
                column: u,
                columnApi: d
            }, l);
        }
        let i = o.getState().cellMouseDown.onChange(r);
        return ()=>{
            e(), n(), i();
        };
    }, []);
}
function $88ab1a78ec8ca4b4$var$BC() {
    let { getState: o } = $88ab1a78ec8ca4b4$var$Q();
    return {
        onKeyDown: (0, $acw62.useCallback)((t)=>{
            o().keyDown(t);
        }, [])
    };
}
function $88ab1a78ec8ca4b4$var$Bm() {
    return $88ab1a78ec8ca4b4$var$KC(), $88ab1a78ec8ca4b4$var$BC();
}
function $88ab1a78ec8ca4b4$var$ws(o) {
    return !!o.tagName;
}
function $88ab1a78ec8ca4b4$var$$m(o) {
    let { alignTarget: e, alignAnchor: t, constrainTo: n, alignPosition: r } = o, i = $88ab1a78ec8ca4b4$var$Ie.from($88ab1a78ec8ca4b4$var$ws(e) ? e.getBoundingClientRect() : e), a = $88ab1a78ec8ca4b4$var$Ie.from($88ab1a78ec8ca4b4$var$ws(t) ? t.getBoundingClientRect() : t), l = n ? $88ab1a78ec8ca4b4$var$Ie.from($88ab1a78ec8ca4b4$var$ws(n) ? n.getBoundingClientRect() : n) : null;
    if (!l) return {
        ...$88ab1a78ec8ca4b4$var$Wm({
            anchorRect: a,
            targetRect: i,
            position: r[0]
        }),
        index: 0
    };
    let s = null;
    for(let c = 0, u = r.length; c < u; c++){
        let d = $88ab1a78ec8ca4b4$var$Wm({
            anchorRect: a,
            targetRect: i,
            position: r[c],
            constrainRect: l
        });
        if (c === 0 && (s = {
            ...d,
            index: 0
        }), d.valid) return {
            ...d,
            index: c
        };
    }
    return s;
}
function $88ab1a78ec8ca4b4$var$Wm(o) {
    let e = $88ab1a78ec8ca4b4$var$Ie.from(o.targetRect), t = $88ab1a78ec8ca4b4$var$Ie.from(o.anchorRect), n = o.constrainRect ? $88ab1a78ec8ca4b4$var$Ie.from(o.constrainRect) : null, { position: r } = o, [i, a] = r, l = $88ab1a78ec8ca4b4$var$jm(e, i), s = $88ab1a78ec8ca4b4$var$jm(t, a), c = l.getDistanceToPoint(s);
    e.shift(c);
    let u = n ? n.contains(e) : !0;
    return {
        alignPosition: r,
        alignedRect: e,
        valid: u,
        distance: c
    };
}
function $88ab1a78ec8ca4b4$var$jm(o, e) {
    return e === "TopLeft" ? $88ab1a78ec8ca4b4$var$Ge.from({
        top: o.top,
        left: o.left
    }) : e === "TopCenter" ? $88ab1a78ec8ca4b4$var$Ge.from({
        top: o.top,
        left: o.left + (o.width > 0 ? Math.round(o.width / 2) : 0)
    }) : e === "TopRight" ? $88ab1a78ec8ca4b4$var$Ge.from({
        top: o.top,
        left: o.left + o.width
    }) : e === "BottomLeft" ? $88ab1a78ec8ca4b4$var$Ge.from({
        left: o.left,
        top: o.top + o.height
    }) : e === "BottomCenter" ? $88ab1a78ec8ca4b4$var$Ge.from({
        left: o.left + (o.width > 0 ? Math.round(o.width / 2) : 0),
        top: o.top + o.height
    }) : e === "BottomRight" ? $88ab1a78ec8ca4b4$var$Ge.from({
        left: o.left + o.width,
        top: o.top + o.height
    }) : e === "CenterLeft" ? $88ab1a78ec8ca4b4$var$Ge.from({
        left: o.left,
        top: o.top + (o.height > 0 ? Math.round(o.height / 2) : 0)
    }) : e === "CenterRight" ? $88ab1a78ec8ca4b4$var$Ge.from({
        left: o.left + o.width,
        top: o.top + (o.height > 0 ? Math.round(o.height / 2) : 0)
    }) : $88ab1a78ec8ca4b4$var$Ge.from({
        left: o.left + (o.width > 0 ? Math.round(o.width / 2) : 0),
        top: o.top + (o.height > 0 ? Math.round(o.height / 2) : 0)
    });
}
var $88ab1a78ec8ca4b4$var$Xi = "__is_infinite_menu_component";
function $88ab1a78ec8ca4b4$var$UC(o) {
    return o && typeof o.then == "function" || o instanceof Promise;
}
function $88ab1a78ec8ca4b4$var$qm(o) {
    return o == null || typeof o == "string" ? !1 : typeof o.tagName == "string";
}
async function $88ab1a78ec8ca4b4$var$Um(o) {
    return typeof o == "function" && (o = o()), $88ab1a78ec8ca4b4$var$UC(o) && (o = await o), typeof o == "string" && (o = document.querySelector(o)), o && $88ab1a78ec8ca4b4$var$qm(o) && (o = o.getBoundingClientRect()), o ? $88ab1a78ec8ca4b4$var$Ie.from(o) : null;
}
async function $88ab1a78ec8ca4b4$var$YC(o) {
    let e = null;
    typeof o == "function" ? e = o() : e = o;
    function t(n) {
        let r = null;
        return typeof n == "string" && (r = document.querySelector(n)), $88ab1a78ec8ca4b4$var$qm(n) && (r = n), r || null;
    }
    return t(await e);
}
function $88ab1a78ec8ca4b4$var$qC(o) {
    return $acw62.createElement("div", {
        style: {
            position: "fixed",
            top: 0,
            left: 0
        }
    }, o.children);
}
function $88ab1a78ec8ca4b4$var$XC(o) {
    let e = $acw62.useRef(null);
    return (0, $acw62.useEffect)(()=>o.realign.onChange((t)=>{
            e.current && t && $88ab1a78ec8ca4b4$export$2a6255dd2e7d69a8(e.current, t);
        }), [
        o.realign
    ]), $acw62.createElement("div", {
        style: {
            position: "absolute",
            top: 0,
            left: 0
        },
        ref: (0, $acw62.useCallback)((t)=>{
            t && $88ab1a78ec8ca4b4$export$2a6255dd2e7d69a8(t, o), e.current = t;
        }, [])
    }, typeof o.children == "function" ? o.children() : o.children);
}
async function $88ab1a78ec8ca4b4$export$2a6255dd2e7d69a8(o, e) {
    let { constrainTo: t, alignTo: n, alignPosition: r } = e;
    Object.keys(n).length === 2 && n.top !== void 0 && n.left !== void 0 && (n = {
        ...n,
        width: 0,
        height: 0
    }), typeof t == "boolean" && (t = t ? document.documentElement.getBoundingClientRect() : void 0);
    let i = t && await $88ab1a78ec8ca4b4$var$Um(t) || void 0, a = n ? await $88ab1a78ec8ca4b4$var$Um(n) : void 0, l = $88ab1a78ec8ca4b4$var$Ie.from(o.getBoundingClientRect());
    if (!a) return;
    let { alignedRect: s } = $88ab1a78ec8ca4b4$var$$m({
        constrainTo: i,
        alignAnchor: a,
        alignTarget: l,
        alignPosition: r
    });
    o.style.transform = `translate3d(${s.left}px,${s.top}px, 0px)`;
    let c = o.getBoundingClientRect();
    if (c.left !== s.left || c.top !== s.top) {
        let u = o.offsetParent;
        if (u) {
            let d = u.getBoundingClientRect(), f = d.left, p = d.top, m = s.left - f, g = s.top - p;
            o.style.transform = `translate3d(${m}px,${g}px, 0px)`;
        }
    }
}
function $88ab1a78ec8ca4b4$export$995f00f219a72f3c(o, e) {
    let [t, n] = (0, $acw62.useState)(null);
    return (0, $acw62.useLayoutEffect)(()=>{
        async function r() {
            let i = e ? await $88ab1a78ec8ca4b4$var$YC(e) : null;
            i != null && n(i);
        }
        e && r();
    }, [
        e
    ]), e ? t ? (0, $1u0KT.createPortal)(o, t) : $acw62.createElement($acw62.Fragment, null) : e === null || e === !1 ? o : $acw62.createElement($88ab1a78ec8ca4b4$var$qC, null, o);
}
function $88ab1a78ec8ca4b4$var$QC(o) {
    if ($acw62.Children.count(o) === 1) {
        let e = $acw62.Children.only(o);
        if ($acw62.isValidElement(e)) return e.props.id || e.key;
    }
    return null;
}
function $88ab1a78ec8ca4b4$var$JC(o, e, t) {
    if ($acw62.Children.count(o) === 1) {
        let n = $acw62.Children.only(o);
        if ($acw62.isValidElement(n) && n.type[$88ab1a78ec8ca4b4$var$Xi]) {
            let r = {};
            return n.props.portalContainer === void 0 && (r.portalContainer = e), n.props.constrainTo === void 0 && (r.constrainTo = t), $acw62.cloneElement(n, r);
        }
    }
    return o;
}
function $88ab1a78ec8ca4b4$export$ea8f71083e90600f(o) {
    let e = o, [t] = (0, $acw62.useState)(()=>new Map), [n, r] = (0, $acw62.useState)(null), [i, a] = (0, $acw62.useState)(0), l = (0, $acw62.useCallback)(()=>{
        let m = [];
        for (let [g, b] of t)m.push($acw62.createElement($88ab1a78ec8ca4b4$var$XC, {
            ...b,
            key: b.key
        }));
        return m;
    }, []), [s, c] = $88ab1a78ec8ca4b4$var$Ct(), u = $88ab1a78ec8ca4b4$export$995f00f219a72f3c(l(), o.portalContainer), d = (0, $acw62.useCallback)((m, g)=>{
        let h = `${g.id || $88ab1a78ec8ca4b4$var$QC(m) || $88ab1a78ec8ca4b4$var$Ot()}`, y = t.get(h), S = (I)=>()=>{
                let w = typeof I == "function" ? I() : I;
                return $88ab1a78ec8ca4b4$var$JC(w, e.portalContainer, g.constrainTo ?? e.constrainTo);
            }, C = S(m), T = (I, w)=>{
            if (!y) return;
            let v = S(I);
            Object.assign(y, {
                children: v
            }), c(), !!!w?.skipRealign && (r(y.key), a(Date.now()));
        };
        return y ? (Object.assign(y, g), T(m), T) : (y = {
            key: h,
            children: C,
            alignPosition: g.alignPosition,
            alignTo: g.alignTo,
            constrainTo: g.constrainTo,
            realign: $88ab1a78ec8ca4b4$var$ye()
        }, t.set(y.key, y), c(), T);
    }, [
        t,
        e.portalContainer,
        c
    ]);
    $acw62.useEffect(()=>{
        if (n) {
            let m = t.get(n);
            m && m.realign(m);
        }
    }, [
        n,
        i
    ]);
    let f = (m)=>{
        m = `${m}`, t.has(m) && (t.delete(m), c());
    }, p = ()=>{
        t.clear(), c();
    };
    return $acw62.useEffect(()=>{}, []), {
        portal: u,
        hideOverlay: f,
        clearAll: p,
        rerenderOverlays: c,
        showOverlay: d
    };
}
function $88ab1a78ec8ca4b4$var$Qi(o) {
    return null;
}
$88ab1a78ec8ca4b4$var$Qi.defaultProps = {
    __is_menu_item: !0
};
var $88ab1a78ec8ca4b4$var$Xm = "db3arf0 _16lm1iw0 _16lm1iw1 _16lm1iw1w _16lm1iw2f _16lm1iw8", $88ab1a78ec8ca4b4$var$Zm = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "db3arf2 _16lm1iw1p _16lm1iw2j _16lm1iw1x",
    variantClassNames: {
        disabled: {
            true: "db3arf3 _16lm1iwl _16lm1iw1x",
            false: "_16lm1iwk"
        },
        active: {
            true: "db3arf5",
            false: "db3arf6"
        },
        pressed: {
            false: "db3arf7",
            true: "db3arf8"
        },
        keyboardActive: {
            true: "db3arf9",
            false: "db3arfa"
        }
    },
    defaultVariants: {},
    compoundVariants: [
        [
            {
                active: !0,
                disabled: !1
            },
            "db3arfb"
        ],
        [
            {
                pressed: !0,
                active: !0,
                disabled: !1
            },
            "db3arfc"
        ]
    ]
}), $88ab1a78ec8ca4b4$var$Qm = "db3arf1", $88ab1a78ec8ca4b4$var$Jm = "db3arfd";
var $88ab1a78ec8ca4b4$var$ew = "-";
function $88ab1a78ec8ca4b4$var$tw() {
    return $acw62.createElement("hr", {
        className: $88ab1a78ec8ca4b4$var$Jm
    });
}
var $88ab1a78ec8ca4b4$var$Ji = ({ columns: o, keyboardActiveItemKey: e, activeItemKey: t, menuId: n }, r)=>{
    let i = r && (r.key != null || r.label != null) ? r : null, a = i === null ? r === $88ab1a78ec8ca4b4$var$ew ? $acw62.createElement($88ab1a78ec8ca4b4$var$tw, null) : r : null;
    return i != null ? {
        type: "item",
        parentMenuId: n,
        disabled: !!i.disabled,
        keyboardActive: i.key === e,
        active: i.key === t,
        value: i,
        span: i.span || 1,
        key: i.key,
        menu: i.menu || null,
        style: i.style,
        className: i.className,
        originalMenuItem: i
    } : {
        type: "decoration",
        value: a,
        span: o.length,
        style: {
            gridColumnStart: 1,
            gridColumnEnd: o.length + 10
        }
    };
};
function $88ab1a78ec8ca4b4$var$eg(o, e) {
    return $acw62.Children.map(e, (t)=>{
        if (t && (t.props.__is_menu_item || t.type === $88ab1a78ec8ca4b4$var$Qi)) {
            let n = {
                ...t.props
            };
            return n.key || (n.key = t.key), n.description || (n.description = t.props.children), n.label || (n.label = n.children), $88ab1a78ec8ca4b4$var$Ji(o, n);
        }
        return $88ab1a78ec8ca4b4$var$Ji(o, t);
    }) || [];
}
var $88ab1a78ec8ca4b4$var$tg = "submenu";
function $88ab1a78ec8ca4b4$var$ng() {
    let o = $acw62.createRef();
    return {
        keyboardActiveItemKey: null,
        activeItemKey: null,
        generatedId: $88ab1a78ec8ca4b4$var$Ot(),
        focused: !1,
        destroyed: !1,
        domRef: o
    };
}
var $88ab1a78ec8ca4b4$var$og = ()=>({
        parentMenuId: 1,
        parentMenuItemKey: 1,
        onHideIntent: 1,
        constrainTo: 1,
        onAction: 1,
        onShow: 1,
        onHide: 1,
        autoFocus: 1,
        wrapLabels: 1
    }), $88ab1a78ec8ca4b4$var$nw = [
    {
        name: "label"
    }
], $88ab1a78ec8ca4b4$var$rg = (o)=>{
    let { props: e, state: t } = o, { activeItemKey: n, keyboardActiveItemKey: r } = t, { items: i, children: a, addSubmenuColumnIfNeeded: l, parentMenuId: s } = e, c = e.id || t.generatedId;
    s && (c = `${s}-${c}`);
    let u = [
        ...e.columns || $88ab1a78ec8ca4b4$var$nw
    ], d = {
        columns: u,
        keyboardActiveItemKey: r,
        activeItemKey: n,
        menuId: c
    }, f = [];
    i ? f = i.map($88ab1a78ec8ca4b4$var$Ji.bind(null, d)) : !i && typeof a != "function" && (f = $88ab1a78ec8ca4b4$var$eg(d, a)), l && f.filter((g)=>g.type === "item" && g.menu != null).length > 0 && !u.find((g)=>g.name == $88ab1a78ec8ca4b4$var$tg) && u.push({
        name: $88ab1a78ec8ca4b4$var$tg,
        render: ({ domProps: g, item: b })=>b.menu ? $acw62.createElement("div", {
                ...g
            }, $acw62.createElement($88ab1a78ec8ca4b4$var$On, {
                expanded: !1
            })) : $acw62.createElement("div", {
                ...g
            })
    });
    let p = f.filter((m)=>m.type === "item" && !m.disabled);
    return {
        runtimeItems: f,
        runtimeSelectableItems: p,
        columns: u,
        menuId: c
    };
};
var $88ab1a78ec8ca4b4$var$yr = class extends $88ab1a78ec8ca4b4$var$ao {
    constructor(e){
        super(e.slice(0, 3));
    }
};
var $88ab1a78ec8ca4b4$var$ow = 250;
function $88ab1a78ec8ca4b4$var$rw(o, e = 100) {
    let t = Date.now();
    return new Promise((n)=>{
        let r, i = ()=>{
            if (r = o(), r !== void 0) {
                n(r);
                return;
            }
            if (Date.now() - t > e) {
                n(void 0);
                return;
            }
            $88ab1a78ec8ca4b4$var$ke(i);
        };
        $88ab1a78ec8ca4b4$var$ke(()=>{
            i();
        });
    });
}
var $88ab1a78ec8ca4b4$var$iw = $88ab1a78ec8ca4b4$var$Re(), $88ab1a78ec8ca4b4$var$ea = class {
    constructor(e){
        this.activeItem = null;
        this.currentHoveredItem = null;
        this.activeItemLeavePoint = null;
        this.menuLeaveTimeoutId = null;
        this.activeItemMenuRect = null;
        this.lastPointerMoveTimestamp = 0;
        this.mouseMoveTimeoutId = 0;
        this.lastHorizontalDiff = 0;
        this.getTimeout = ()=>this.params.timeout || $88ab1a78ec8ca4b4$var$ow;
        this.getPointerMoveTarget = ()=>document.documentElement || $88ab1a78ec8ca4b4$var$iw;
        this.removePointerMoveListener = ()=>{
            this.getPointerMoveTarget().removeEventListener("pointermove", this.onPointerMoveWhileActiveItem);
        };
        this.onPointerMoveWhileActiveItem = (e)=>{
            if (clearTimeout(this.mouseMoveTimeoutId), !e) {
                this.lastPointerMoveTimestamp = Date.now();
                return;
            }
            if (!this.currentHoveredItem || this.currentHoveredItem === this.activeItem) return;
            let t = Date.now();
            this.lastPointerMoveTimestamp || (this.lastPointerMoveTimestamp = t);
            let r = t - this.lastPointerMoveTimestamp > this.getTimeout();
            this.lastPointerMoveTimestamp = t;
            let i = ()=>{
                this.setActiveItem(null, null), this.onItemChange(!0, this.currentHoveredItem, e);
            };
            if (r) {
                i();
                return;
            }
            let a = this.currentHoveredItem;
            this.mouseMoveTimeoutId = setTimeout(()=>{
                if (a !== this.currentHoveredItem) return;
                Date.now() - this.lastPointerMoveTimestamp > this.getTimeout() && i();
            }, this.getTimeout());
            let l = new $88ab1a78ec8ca4b4$var$Ge({
                left: e.clientX,
                top: e.clientY
            });
            if (!this.activeItemMenuRect || !this.activeItemLeavePoint) return;
            let s = this.activeItemLeavePoint.left < this.activeItemMenuRect.left, u = (s ? 1 : -1) * (l.left - this.activeItemLeavePoint.left);
            if (u - this.lastHorizontalDiff < 0) {
                this.lastHorizontalDiff = 0, i();
                return;
            }
            this.lastHorizontalDiff = u, (s ? new $88ab1a78ec8ca4b4$var$yr([
                this.activeItemLeavePoint,
                this.activeItemMenuRect.getTopLeft(),
                this.activeItemMenuRect.getBottomLeft()
            ]) : new $88ab1a78ec8ca4b4$var$yr([
                this.activeItemLeavePoint,
                this.activeItemMenuRect.getTopRight(),
                this.activeItemMenuRect.getBottomRight()
            ])).containsPoint(l) || (this.setActiveItem(null, null), this.onItemChange(!0, this.currentHoveredItem, e));
        };
        this.setupMenuLeaveTracking = ()=>{
            this.menuLeaveTimeoutId = setTimeout(()=>{
                this.activeItem && this.params.itemHasSubMenu(this.activeItem) || this.setActiveItem(null, null);
            }, this.getTimeout());
        };
        this.setActiveItem = (e, t)=>{
            if (e !== this.activeItem) {
                if (e == null) {
                    this.removePointerMoveListener(), this.params.onItemActivate(null, null), this.activeItem = null, this.activeItemMenuRect = null;
                    return;
                }
                this.activeItem = e, this.params.onItemActivate(e, t), this.activeItemMenuRect = null, $88ab1a78ec8ca4b4$var$rw(()=>this.activeItem != e ? !1 : this.params.getMenuRectFor(e)).then((n)=>{
                    this.activeItem == e && n && (this.activeItemMenuRect = n);
                });
            }
        };
        this.onItemChange = (e, t, n)=>{
            if (clearTimeout(this.menuLeaveTimeoutId), clearTimeout(this.mouseMoveTimeoutId), !e) {
                this.removePointerMoveListener(), t === this.activeItem && (this.activeItemLeavePoint = new $88ab1a78ec8ca4b4$var$Ge({
                    left: n.clientX,
                    top: n.clientY
                })), this.setupMenuLeaveTracking();
                return;
            }
            if (this.currentHoveredItem = t, !this.activeItem || !this.params.itemHasSubMenu(this.activeItem)) {
                this.setActiveItem(t, n.target);
                return;
            }
            this.onPointerMoveWhileActiveItem(), this.getPointerMoveTarget().addEventListener("pointermove", this.onPointerMoveWhileActiveItem);
        };
        this.getHandlers = ()=>({
                onItemEnter: (e, t)=>{
                    this.onItemChange(!0, e, t);
                },
                onItemLeave: (e, t)=>{
                    this.onItemChange(!1, e, t);
                }
            });
        this.params = e;
    }
};
var $88ab1a78ec8ca4b4$var$vs = (0, $acw62.createContext)(null);
function $88ab1a78ec8ca4b4$var$Rs() {
    return (0, $acw62.useContext)($88ab1a78ec8ca4b4$var$vs);
}
function $88ab1a78ec8ca4b4$var$ig() {
    let o = (0, $acw62.useRef)(!0);
    return (0, $acw62.useEffect)(()=>(o.current = !0, ()=>{
            o.current = !1;
        }), []), (0, $acw62.useCallback)(()=>o.current, []);
}
function $88ab1a78ec8ca4b4$var$pw(o, e) {
    let { parentMenuId: t, setSubmenuApi: n, setActiveItemKey: r, setKeyboardActiveItemKey: i, constrainTo: a, onHideIntent: l, api: s } = e, c = `${t}-submenu`, u = o.menu;
    return u ? (typeof u == "function" && (u = u()), $acw62.createElement($88ab1a78ec8ca4b4$export$d9b273488cd8ce6f, {
        key: c,
        parentMenuItemKey: o.key,
        parentMenuId: t,
        constrainTo: a,
        ...u,
        autoFocus: !1,
        onShow: (d, f)=>{
            u?.onShow?.(d, f), n(f);
        },
        onHideIntent: (d)=>{
            u?.onHideIntent?.(d), l(d);
        },
        onHide: (d)=>{
            d.focused && (r(null), i(o.key), s.focus());
        }
    })) : null;
}
function $88ab1a78ec8ca4b4$var$mw(o, e) {
    let t = $88ab1a78ec8ca4b4$var$ag(o, e);
    if (!t.length) return null;
    let n = $88ab1a78ec8ca4b4$var$Ie.from(t[0]?.getBoundingClientRect()), r = $88ab1a78ec8ca4b4$var$Ie.from(t[t.length - 1].getBoundingClientRect()), i = n;
    return i.width = r.left + r.width - n.left, i;
}
function $88ab1a78ec8ca4b4$var$ag(o, e) {
    let t = $88ab1a78ec8ca4b4$var$cn(document.querySelector(`[data-menu-id="${o}"] [data-menu-item-key="${e}"]`), `[data-menu-id="${o}"]`);
    if (!t) return [];
    let n = t.querySelectorAll(`[data-menu-item-key="${e}"]`);
    return Array.from(n);
}
function $88ab1a78ec8ca4b4$var$gw(o, e) {
    let t = $88ab1a78ec8ca4b4$var$ag(o, e);
    if (!t.length) return null;
    for (let n of t){
        let r = n.querySelector('input[type="checkbox"]');
        if (r) return r;
    }
    return null;
}
function $88ab1a78ec8ca4b4$var$hw({ onItemActivate: o }) {
    let { getState: e } = $88ab1a78ec8ca4b4$var$Rs(), [{ onItemEnter: t, onItemLeave: n }] = (0, $acw62.useState)(()=>new $88ab1a78ec8ca4b4$var$ea({
            parentMenuId: e().parentMenuId,
            onItemActivate: (r)=>{
                if (!r) {
                    o(null);
                    return;
                }
                let i = e().runtimeItems.filter((a)=>a.type === "item" && a.key === r)[0];
                o(i);
            },
            itemHasSubMenu: (r)=>!!e().runtimeItems.filter((a)=>a.type === "item" && a.key === r && a.menu)[0],
            getMenuRectFor: (r)=>{
                let i = `[data-submenu-for="${r}"]`, a = document.querySelector(i);
                return a ? $88ab1a78ec8ca4b4$var$Ie.from(a.getBoundingClientRect()) : void 0;
            }
        }).getHandlers());
    return {
        onItemEnter: (0, $acw62.useCallback)(t, []),
        onItemLeave: (0, $acw62.useCallback)(n, [])
    };
}
function $88ab1a78ec8ca4b4$var$lg(o) {
    let { domProps: e } = o, { componentState: { columns: t, runtimeItems: n, menuId: r, activeItemKey: i, keyboardActiveItemKey: a, constrainTo: l, destroyed: s, onAction: c, wrapLabels: u, onShow: d, onHide: f, autoFocus: p, parentMenuItemKey: m, domRef: g }, componentActions: b, getState: h } = $88ab1a78ec8ca4b4$var$Rs(), y = (0, $acw62.useCallback)((B)=>{
        b.keyboardActiveItemKey = B;
    }, []), S = (0, $acw62.useCallback)((B)=>{
        b.activeItemKey = B;
    }, []), C = $88ab1a78ec8ca4b4$var$ig(), [T, I] = (0, $acw62.useState)(null), w = null;
    (0, $acw62.useLayoutEffect)(()=>{
        let { runtimeItems: B } = h(), j = B.filter((oe)=>oe.type === "item" && i === oe.key)[0];
        if (!j || !j.menu) {
            I(null), M();
            return;
        }
        if (j) {
            let oe = $88ab1a78ec8ca4b4$var$mw(r, j.key);
            oe && R(()=>$88ab1a78ec8ca4b4$var$pw(j, {
                    constrainTo: l,
                    setSubmenuApi: I,
                    setActiveItemKey: S,
                    setKeyboardActiveItemKey: y,
                    parentMenuId: r,
                    onHideIntent: z,
                    api: L
                }), {
                id: `${r}-submenu`,
                alignTo: oe,
                alignPosition: [
                    [
                        "TopLeft",
                        "TopRight"
                    ],
                    [
                        "TopRight",
                        "TopLeft"
                    ]
                ],
                constrainTo: l
            });
            return;
        }
    }, [
        i
    ]);
    let v = (B, j)=>{
        y(j.key), S(j.key), j.originalMenuItem.onClick && j.originalMenuItem.onClick(B);
        let oe = {
            key: j.key,
            item: j.originalMenuItem,
            hideMenu: z
        };
        j.originalMenuItem.onAction && j.originalMenuItem.onAction(oe), c && c(oe), j.originalMenuItem.hideMenuOnAction && z();
    }, { showOverlay: R, portal: x, clearAll: M } = $88ab1a78ec8ca4b4$export$ea8f71083e90600f({
        portalContainer: !1
    }), { onItemEnter: A, onItemLeave: E } = $88ab1a78ec8ca4b4$var$hw({
        onItemActivate: (B)=>{
            if (!C()) return;
            let j = B ? B.key : null;
            S(j);
        }
    });
    w = n.map((B, j)=>$acw62.createElement($88ab1a78ec8ca4b4$var$bw, {
            key: B.type === "item" ? B.key : j,
            onItemEnter: (oe, me)=>{
                A(oe.key, me);
            },
            onItemLeave: (oe, me)=>{
                E(oe.key, me);
            },
            columns: t,
            active: B.type === "item" && B.key === i,
            keyboardActive: B.type === "item" && B.key === a,
            item: B,
            index: j,
            onClick: v
        }));
    let P = t.map((B)=>B.width || (typeof B.flex == "number" ? `${B.flex}fr` : B.flex) || "auto").join(" "), _ = {
        ...e.style,
        gridTemplateColumns: P,
        gridTemplateRows: n.map(()=>"auto").join(" ")
    };
    u || (_.whiteSpace = "nowrap");
    function D(B) {
        let { runtimeItems: j, runtimeSelectableItems: oe } = h(), me = j.findIndex((H)=>H.type === "item" && H.key === a), pe = a, ce = j[me], ue = {
            ArrowUp: ()=>{
                let H = j.slice(0, me).filter((G)=>G.type === "item" && !G.disabled).pop();
                H && H.type === "item" && H.key && (pe = H.key);
            },
            ArrowDown: ()=>{
                let H = j.slice(me + 1).filter((G)=>G.type === "item" && !G.disabled)[0];
                H && H.type === "item" && H.key && (pe = H.key);
            },
            Home: ()=>{
                ue.PageUp();
            },
            End: ()=>{
                ue.PageDown();
            },
            PageUp: ()=>{
                pe = oe[0].key;
            },
            PageDown: ()=>{
                pe = oe[oe.length - 1].key;
            },
            ArrowLeft: ()=>{
                S(null), h().parentMenuId && (b.destroyed = !0);
            },
            ArrowRight: ()=>{
                ce && (S(ce.key), $88ab1a78ec8ca4b4$var$ke(()=>{
                    C() && T && T.getParentMenuId() === h().menuId && T.focus();
                }));
            },
            Enter: ()=>{
                if (ce) {
                    if (ce.originalMenuItem?.menu) {
                        if (ce && ce.originalMenuItem.menu && T) {
                            ue.ArrowLeft();
                            return;
                        }
                        ce && S(ce.key);
                    } else v(B, ce);
                }
            },
            " ": ()=>{
                if (!ce) return;
                ce.originalMenuItem.menu || v(B, ce);
                let H = $88ab1a78ec8ca4b4$var$gw(r, ce.key);
                H && H.click();
            },
            Escape: ()=>{
                ue.ArrowLeft();
                let H = h();
                H.parentMenuId || H.onHideIntent?.(H);
            }
        }, ge = ue[B.key];
        ge && (ge(), B.preventDefault()), pe != a && y(pe);
    }
    function O() {
        b.focused = !1;
    }
    let F = (0, $acw62.useCallback)(function() {
        b.focused = !0, setTimeout(()=>{
            W.current && g.current && g.current === document.activeElement && h().keyboardActiveItemKey == null && y(h().runtimeSelectableItems[0]?.key ?? null);
        });
    }, []), W = (0, $acw62.useRef)(!0), z = (0, $acw62.useCallback)(()=>{
        let B = h();
        B.onHideIntent?.(B);
    }, [
        h
    ]), [L] = (0, $acw62.useState)(()=>({
            hideMenu: z,
            focus: ()=>{
                g.current && (g.current.focus(), setTimeout(()=>{
                    g.current && g.current !== document.activeElement && g.current.focus();
                }, 10), F());
            },
            getMenuId: ()=>h().menuId,
            getParentMenuId: ()=>h().parentMenuId
        })), ae = (0, $acw62.useCallback)((B)=>{
        B ? (g.current = B, d?.(h(), L), p && L.focus()) : (f?.(h()), g.current = B);
    }, []), te = $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$Zn.contents
    }, $acw62.createElement("div", {
        ...e,
        "data-menu-id": r,
        "data-submenu-for": m,
        tabIndex: 0,
        ref: ae,
        onKeyDown: (B)=>{
            e.onKeyDown?.(B), D(B);
        },
        onMouseDown: (B)=>{
            W.current = !1, e.onMouseDown?.(B);
        },
        onMouseUp: (B)=>{
            W.current = !0, e.onMouseUp?.(B);
        },
        onFocus: F,
        onBlur: O,
        className: $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$Xm, e.className, "InfiniteMenu"),
        style: _
    }, w), x);
    return s ? null : te;
}
function $88ab1a78ec8ca4b4$var$bw(o) {
    let [e, t] = $acw62.useState(!1), { columns: n, item: r, index: i, active: a, keyboardActive: l } = o, s = r.type === "item" ? r.value.key : i, c = null;
    if (r.type === "decoration") c = $acw62.createElement("div", {
        style: r.style
    }, r.value);
    else {
        let u = 0;
        c = n.map((d, f)=>{
            let p = r.value, m = d.field || d.name, g = f + 1, b = g + r.span;
            if (g < u) return null;
            u = b;
            let y = {
                style: {
                    ...d.style,
                    ...r.style,
                    gridColumnStart: g,
                    gridColumnEnd: b
                },
                "data-menu-column-id": `${r.parentMenuId}-col-${d.name}`,
                "data-menu-col-name": `${d.name}`,
                "data-menu-row-id": `${r.parentMenuId}-row-${i}`,
                "data-menu-row-index": `${i}`,
                "data-menu-item-key": `${r.key}`,
                className: $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$Zm({
                    active: a,
                    disabled: !!r.disabled,
                    keyboardActive: l,
                    pressed: e || o.active
                }), r.className),
                onPointerEnter: (S)=>{
                    r.disabled || o.onItemEnter?.(r, S);
                },
                onPointerLeave: (S)=>{
                    r.disabled || o.onItemLeave?.(r, S);
                },
                onMouseDown: ()=>{
                    r.disabled || t(!0);
                },
                onMouseUp: ()=>{
                    r.disabled || t(!1);
                },
                onClick: (S)=>{
                    r.disabled || o.onClick(S, r);
                }
            };
            return d.render ? $acw62.createElement($88ab1a78ec8ca4b4$var$Zo, {
                key: `${s}-${m}`,
                render: d.render,
                renderParam: {
                    item: p,
                    column: d,
                    value: p[m],
                    domProps: y
                }
            }) : $acw62.createElement("div", {
                key: `${s}-${m}`,
                ...y
            }, p[m]);
        }).filter(Boolean);
    }
    return $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$Qm
    }, c);
}
var { ManagedComponentContextProvider: $88ab1a78ec8ca4b4$var$yw } = $88ab1a78ec8ca4b4$export$c6a0e0787a01a4e5({
    initSetupState: $88ab1a78ec8ca4b4$var$ng,
    forwardProps: $88ab1a78ec8ca4b4$var$og,
    mapPropsToState: $88ab1a78ec8ca4b4$var$rg,
    layoutEffect: !0
});
function $88ab1a78ec8ca4b4$var$Tw(o) {
    let { componentActions: e, componentState: t } = $88ab1a78ec8ca4b4$export$2e1456d250441a8(), n = $88ab1a78ec8ca4b4$var$Me(t);
    return $acw62.createElement($88ab1a78ec8ca4b4$var$vs.Provider, {
        value: {
            componentActions: e,
            componentState: t,
            getState: n
        }
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$lg, {
        domProps: o.domProps
    }));
}
function $88ab1a78ec8ca4b4$export$d9b273488cd8ce6f(o) {
    let { children: e, portalContainer: t, items: n, parentMenuId: r, addSubmenuColumnIfNeeded: i = !0, bubbleActionsFromSubmenus: a = !0, onShow: l, onHide: s, wrapLabels: c = !1, onAction: u, constrainTo: d, columns: f, parentMenuItemKey: p, autoFocus: m, id: g, onHideIntent: b, __is_infinite_menu_component: h, ...y } = o;
    return $acw62.createElement($88ab1a78ec8ca4b4$var$yw, {
        addSubmenuColumnIfNeeded: i,
        bubbleActionsFromSubmenus: a,
        wrapLabels: c,
        ...o
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$Tw, {
        domProps: y
    }));
}
$88ab1a78ec8ca4b4$export$d9b273488cd8ce6f[$88ab1a78ec8ca4b4$var$Xi] = !0;
function $88ab1a78ec8ca4b4$var$sg(o, e) {
    let { columnApi: t, column: n, getComputed: r, api: i, dataSourceApi: a } = e, s = t.isSortable() ? [
        {
            key: "sort-asc",
            label: "Sort Ascending",
            disabled: n.computedSortedAsc,
            onAction: ()=>{
                i.setSortingForColumn(n.id, 1);
            }
        },
        {
            key: "sort-desc",
            label: "Sort Descending",
            disabled: n.computedSortedDesc,
            onAction: ()=>{
                i.setSortingForColumn(n.id, -1);
            }
        },
        {
            key: "sort-none",
            label: "Unsort",
            disabled: !n.computedSorted,
            onAction: ()=>{
                i.setSortingForColumn(n.id, null);
            }
        },
        "-"
    ] : [];
    return [
        ...n.groupByForColumn ? [
            {
                key: "collapse-all",
                label: "Collapse All",
                onAction: ()=>{
                    i.collapseAllGroupRows();
                }
            },
            "-"
        ] : [],
        ...s,
        n.computedFilterable ? {
            key: "clear-filter",
            label: "Clear Filter",
            disabled: !n.computedFiltered,
            onAction: ()=>{
                i.clearColumnFilter(n.id);
            }
        } : null,
        n.computedFilterable ? "-" : null,
        {
            key: "pin-start",
            label: "Pin to start",
            disabled: n.computedPinned === "start",
            onAction: ()=>{
                i.setPinningForColumn(n.id, "start");
            }
        },
        {
            key: "unpin",
            label: "Unpin",
            disabled: !n.computedPinned,
            onAction: ()=>{
                i.setPinningForColumn(n.id, !1);
            }
        },
        "-",
        {
            key: "columns",
            label: "Columns",
            menu: ()=>{
                let u = [];
                return r().computedColumnsMapInInitialOrder.forEach((f, p)=>{
                    let m = $88ab1a78ec8ca4b4$var$Pn(f, e, "column-menu");
                    u.push({
                        key: p,
                        label: m,
                        check: $acw62.createElement($88ab1a78ec8ca4b4$var$Wt, {
                            key: f.id,
                            disabled: f.computedVisible && i.getVisibleColumnsCount() === 1,
                            checked: f.computedVisible,
                            onChange: (g)=>{
                                let b = !!g;
                                i.setVisibilityForColumn(f.id, b), requestAnimationFrame(()=>{
                                    i.realignColumnContextMenu();
                                });
                            }
                        })
                    });
                }), {
                    columns: [
                        {
                            name: "check"
                        },
                        {
                            name: "label"
                        }
                    ],
                    items: u
                };
            }
        },
        "-",
        {
            key: "group-by",
            label: "Group by",
            menu: ()=>{
                let u = [];
                return r().computedColumnsMapInInitialOrder.forEach((f, p)=>{
                    if (f.groupByForColumn) return;
                    let m = $88ab1a78ec8ca4b4$var$Pn(f, e, "column-menu");
                    u.push({
                        key: p,
                        label: m,
                        check: $acw62.createElement($88ab1a78ec8ca4b4$var$Wt, {
                            key: f.id,
                            disabled: !f.computedGroupable,
                            checked: f.computedGroupedBy,
                            onChange: ()=>{
                                a.toggleGroupByField(f.field);
                            }
                        })
                    });
                }), {
                    columns: [
                        {
                            name: "check"
                        },
                        {
                            name: "label"
                        }
                    ],
                    items: u
                };
            }
        }
    ].filter((u)=>!!u);
}
function $88ab1a78ec8ca4b4$var$ug(o, e, t) {
    if (o == null) return null;
    let { getComputed: n, getState: r } = e, { components: i, getColumnMenuItems: a } = r(), l = i?.Menu ?? $88ab1a78ec8ca4b4$export$d9b273488cd8ce6f, s = n().computedColumnsMap.get(o);
    if (!s) return null;
    let c = {
        column: s,
        columnApi: $88ab1a78ec8ca4b4$var$it(s.id, e),
        ...e
    }, u = $88ab1a78ec8ca4b4$var$sg([], c), d = a ? a(u, c) : u, f = (m)=>{
        m.__insideMenu = !0;
    }, p = (m)=>{
        m.domRef.current?.parentNode?.removeEventListener("mousedown", f);
    };
    return !d || !d.length ? null : $acw62.createElement(l, {
        autoFocus: !0,
        items: d,
        onShow: (m)=>{
            m.domRef.current?.parentNode?.addEventListener("mousedown", f);
        },
        onHide: p,
        onHideIntent: (m)=>{
            p(m), t?.();
        }
    });
}
var $88ab1a78ec8ca4b4$var$Sw = `[${$88ab1a78ec8ca4b4$var$wl["data-name"]}="${$88ab1a78ec8ca4b4$var$Il["data-name"]}"]`;
function $88ab1a78ec8ca4b4$var$Cw(o) {
    let { columnId: e, context: t, clearAll: n, showOverlay: r } = o, { getState: i, actions: a } = t, { columnMenuTargetRef: l, domRef: s } = i();
    function c() {
        n(), a.columnMenuVisibleForColumnId = null;
    }
    let u = o.target;
    if (u || (u = l.current ?? void 0, u && !s.current.contains(u) && (u = void 0)), !u) {
        let d = `[${$88ab1a78ec8ca4b4$var$kf["data-column-id"]}="${e}"] ${$88ab1a78ec8ca4b4$var$Sw}`;
        u = i().domRef.current.querySelector(d);
    }
    if (!u) {
        console.warn(`Cannot show column menu for column "${e}"`);
        return;
    }
    l.current = null, r(()=>$88ab1a78ec8ca4b4$var$ug(e, t, c), {
        constrainTo: s.current,
        id: "column-menu",
        alignTo: u,
        alignPosition: [
            [
                "TopLeft",
                "BottomLeft"
            ],
            [
                "TopRight",
                "BottomRight"
            ]
        ]
    });
}
function $88ab1a78ec8ca4b4$var$fg() {
    let o = $88ab1a78ec8ca4b4$var$Q(), e = $88ab1a78ec8ca4b4$var$Ve(), { getState: t, actions: n } = o, { showOverlay: r, portal: i, clearAll: a } = $88ab1a78ec8ca4b4$export$ea8f71083e90600f({
        portalContainer: e ? e.getMasterState().portalDOMRef.current : !1
    });
    (0, $acw62.useEffect)(()=>{
        let { actions: c, getState: u } = o, d = u();
        return d.onColumnMenuClick.onChange((f)=>{
            f && (d.columnMenuTargetRef.current = f.target, c.contextMenuVisibleFor = null, c.cellContextMenuVisibleFor = null, c.filterOperatorMenuVisibleForColumnId = null, c.columnMenuVisibleForColumnId = f.column.id);
        });
    }, []);
    let { columnMenuVisibleForColumnId: l, columnMenuVisibleKey: s } = t();
    return (0, $acw62.useEffect)(()=>{
        let { columnMenuVisibleForColumnId: c, columnMenuTargetRef: u } = t();
        if (c) {
            let f = function(p) {
                p.__insideMenu !== !0 && (a(), n.columnMenuVisibleForColumnId = null);
            };
            var d = f;
            return document.documentElement.addEventListener("mousedown", f), $88ab1a78ec8ca4b4$var$Cw({
                columnId: c,
                context: o,
                clearAll: a,
                showOverlay: r
            }), ()=>{
                document.documentElement.removeEventListener("mousedown", f);
            };
        } else u.current = null, a();
        return ()=>{};
    }, [
        l,
        s
    ]), {
        menuPortal: i
    };
}
var $88ab1a78ec8ca4b4$var$Iw = {
    width: 0,
    height: 0,
    overflow: "hidden",
    pointerEvents: "none",
    outline: "none",
    zIndex: -1
};
function $88ab1a78ec8ca4b4$var$mg() {
    let { getState: o, api: e, actions: t, getComputed: n, dataSourceApi: r, dataSourceActions: i } = $88ab1a78ec8ca4b4$var$Q(), { getState: a, getDataSourceMasterContext: l } = $88ab1a78ec8ca4b4$var$_e(), { focusDetectDOMRef: s } = o(), c = (0, $acw62.useCallback)(async ()=>{
        $88ab1a78ec8ca4b4$var$Fm({
            getDataSourceState: a,
            getDataSourceMasterContext: l,
            getComputed: n,
            actions: t,
            dataSourceActions: i,
            api: e,
            getState: o,
            dataSourceApi: r
        });
    }, []);
    return $acw62.createElement("div", {
        onFocus: c,
        ref: s,
        tabIndex: 0,
        style: $88ab1a78ec8ca4b4$var$Iw
    });
}
function $88ab1a78ec8ca4b4$var$vw() {
    let o = $88ab1a78ec8ca4b4$var$Q(), { getState: e } = o, { editingCell: t } = e(), n = t && !t.active ? t.cancelled : void 0;
    (0, $acw62.useEffect)(()=>{
        if (n) {
            let { rowIndex: r, columnId: i, initialValue: a } = e().editingCell, { onEditCancelled: l } = e();
            l?.({
                ...$88ab1a78ec8ca4b4$var$mt({
                    rowIndex: r,
                    columnId: i,
                    ...o
                }),
                initialValue: a
            });
        }
    }, [
        n
    ]);
}
function $88ab1a78ec8ca4b4$var$Rw() {
    let o = $88ab1a78ec8ca4b4$var$Q(), { getState: e, state: { editingCell: t } } = o, n = t && !t.active && t.accepted instanceof Error ? t.accepted : void 0;
    (0, $acw62.useEffect)(()=>{
        if (n) {
            let { rowIndex: r, columnId: i, value: a, initialValue: l } = e().editingCell, { onEditRejected: s } = e();
            s?.({
                ...$88ab1a78ec8ca4b4$var$mt({
                    rowIndex: r,
                    columnId: i,
                    ...o
                }),
                value: a,
                error: n,
                initialValue: l
            });
        }
    }, [
        n
    ]);
}
function $88ab1a78ec8ca4b4$var$xw() {
    let o = $88ab1a78ec8ca4b4$var$Q(), { state: { editingCell: e } } = o, t = e?.active, n = $88ab1a78ec8ca4b4$export$5cae361ad82dce8b(t);
    (0, $acw62.useEffect)(()=>{
        !t && n && o.api.focus();
    }, [
        t,
        n
    ]);
}
function $88ab1a78ec8ca4b4$var$Pw() {
    let o = $88ab1a78ec8ca4b4$var$Q(), { state: { editingCell: e }, getState: t } = o, n = e && !e.active && !e.cancelled && e.accepted === !0;
    (0, $acw62.useEffect)(()=>{
        if (n) {
            let { editingCell: r } = t(), { value: i, rowIndex: a, columnId: l, initialValue: s } = r, c = {
                ...$88ab1a78ec8ca4b4$var$mt({
                    rowIndex: a,
                    columnId: l,
                    ...o
                }),
                value: i,
                initialValue: s
            };
            t().onEditAccepted?.(c), o.api.persistEdit({
                value: i
            });
        }
    }, [
        n
    ]);
}
function $88ab1a78ec8ca4b4$var$Dw() {
    let o = $88ab1a78ec8ca4b4$var$Q(), { state: { editingCell: e }, getState: t } = o, n = e ? e.persisted : void 0;
    (0, $acw62.useEffect)(()=>{
        if (n) {
            let { editingCell: r, onEditPersistError: i, onEditPersistSuccess: a } = t();
            if (!r) return;
            let { rowIndex: l, columnId: s, value: c, initialValue: u } = r, d = {
                ...$88ab1a78ec8ca4b4$var$mt({
                    rowIndex: l,
                    columnId: s,
                    ...o
                }),
                value: c,
                initialValue: u
            };
            n instanceof Error ? i?.({
                ...d,
                error: n
            }) : a?.(d);
        }
    }, [
        n
    ]);
}
function $88ab1a78ec8ca4b4$var$gg() {
    $88ab1a78ec8ca4b4$var$vw(), $88ab1a78ec8ca4b4$var$Rw(), $88ab1a78ec8ca4b4$var$Pw(), $88ab1a78ec8ca4b4$var$Dw(), $88ab1a78ec8ca4b4$var$xw();
}
var $88ab1a78ec8ca4b4$var$ta = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o
    }, $acw62.createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }));
var $88ab1a78ec8ca4b4$var$hg = (o)=>$acw62.createElement($88ab1a78ec8ca4b4$var$Le, {
        ...o
    }, $acw62.createElement("path", {
        d: "m9.55 19-6.725-6.725L5.25 9.85l4.3 4.325 9.225-9.225 2.425 2.4Z"
    }));
function $88ab1a78ec8ca4b4$var$bg(o, e, t) {
    if (o == null) return null;
    let { getComputed: n, getState: r, getDataSourceState: i, actions: a, dataSourceApi: l, dataSourceActions: s, api: c } = e, { components: u, getFilterOperatorMenuItems: d } = r(), f = u?.Menu ?? $88ab1a78ec8ca4b4$export$d9b273488cd8ce6f, p = n().computedColumnsMap.get(o);
    if (!p) return null;
    let m = (w)=>{
        w.__insideMenu = !0;
    }, g = (w)=>{
        w.domRef.current?.parentNode?.removeEventListener("mousedown", m);
    }, { filterTypes: b } = i(), h = b[p.computedFilterType];
    if (!h) return null;
    let y = h.operators.map((w)=>{
        let v = w.name, R = p.computedFilterValue ? p.computedFilterValue.filter.operator === v : v === h.defaultOperator, x = w.components?.Icon ?? $88ab1a78ec8ca4b4$var$eo;
        return {
            key: v,
            icon: $acw62.createElement(x, null),
            label: $acw62.createElement($acw62.Fragment, null, w.label ?? w.name),
            onAction: ()=>{
                c.setColumnFilterOperator(o, v);
            },
            checked: R ? $acw62.createElement($88ab1a78ec8ca4b4$var$hg, {
                size: 16
            }) : null
        };
    }), C = [
        {
            key: "close",
            label: "Close Menu",
            icon: null,
            onAction: ()=>{
                c.hideFilterOperatorMenu();
            }
        },
        {
            key: "reset",
            label: "Reset",
            icon: $acw62.createElement($88ab1a78ec8ca4b4$var$ta, null),
            disabled: !p.computedFiltered,
            onAction: ()=>{
                c.clearColumnFilter(o);
            }
        },
        "-",
        ...y
    ], T = {
        column: p,
        api: c,
        getState: r,
        getDataSourceState: i,
        getComputed: n,
        actions: a,
        dataSourceApi: l,
        dataSourceActions: s,
        columnFilterValue: p.computedFilterValue,
        filterTypes: b
    }, I = d ? d(C, T) : C;
    return $acw62.createElement(f, {
        autoFocus: !0,
        columns: [
            {
                name: "icon"
            },
            {
                name: "label"
            },
            {
                name: "checked"
            }
        ],
        items: I,
        onShow: (w)=>{
            w.domRef.current?.parentNode?.addEventListener("mousedown", m);
        },
        onHide: g,
        onHideIntent: (w)=>{
            g(w), t?.();
        }
    });
}
var $88ab1a78ec8ca4b4$var$na = 10;
function $88ab1a78ec8ca4b4$var$Tg() {
    let o = $88ab1a78ec8ca4b4$var$Q(), e = $88ab1a78ec8ca4b4$var$Ve(), { getState: t, actions: n } = o, { showOverlay: r, portal: i, clearAll: a } = $88ab1a78ec8ca4b4$export$ea8f71083e90600f({
        portalContainer: e ? e.getMasterState().portalDOMRef.current : !1
    });
    return (0, $acw62.useEffect)(()=>{
        let { actions: l, getState: s } = o;
        return s().onFilterOperatorMenuClick.onChange((u)=>{
            if (!u) return;
            let { target: d, column: f } = u;
            function p() {
                a(), l.filterOperatorMenuVisibleForColumnId = null;
            }
            let m = d?.parentElement || d, g = $88ab1a78ec8ca4b4$var$Ie.from(m.getBoundingClientRect());
            g.top -= $88ab1a78ec8ca4b4$var$na, g.left -= $88ab1a78ec8ca4b4$var$na, g.width += 2 * $88ab1a78ec8ca4b4$var$na, g.height += 2 * $88ab1a78ec8ca4b4$var$na, r(()=>$88ab1a78ec8ca4b4$var$bg(f.id, o, p), {
                constrainTo: s().domRef.current,
                id: "filter-operator-menu",
                alignTo: g,
                alignPosition: [
                    [
                        "TopLeft",
                        "BottomLeft"
                    ],
                    [
                        "TopRight",
                        "BottomRight"
                    ]
                ]
            }), l.contextMenuVisibleFor = null, l.cellContextMenuVisibleFor = null, l.columnMenuVisibleForColumnId = null, l.filterOperatorMenuVisibleForColumnId = f.id;
        });
    }, []), (0, $acw62.useEffect)(()=>{
        let { filterOperatorMenuVisibleForColumnId: l } = t();
        if (l) {
            let c = function(u) {
                u.__insideMenu !== !0 && (a(), n.filterOperatorMenuVisibleForColumnId = null);
            };
            var s = c;
            return document.documentElement.addEventListener("mousedown", c), ()=>{
                document.documentElement.removeEventListener("mousedown", c);
            };
        } else a();
        return ()=>{};
    }, [
        t().filterOperatorMenuVisibleForColumnId
    ]), {
        menuPortal: i
    };
}
function $88ab1a78ec8ca4b4$var$oa(o) {
    let e = o ? Array.isArray(o) ? o : o.items : null, t = o && !Array.isArray(o) ? o.columns : void 0;
    return {
        items: e,
        columns: t
    };
}
function $88ab1a78ec8ca4b4$var$As(o) {
    let e = (r)=>{
        r.__insideMenu = !0;
    }, t = (r)=>{
        r.domRef.current?.parentNode?.removeEventListener("mousedown", e);
    };
    return {
        columns: [],
        items: [],
        autoFocus: !0,
        onShow: (r)=>{
            r.domRef.current?.parentNode?.addEventListener("mousedown", e);
        },
        onHide: t,
        onHideIntent: (r)=>{
            t(r), o.onHideIntent?.();
        }
    };
}
function $88ab1a78ec8ca4b4$var$_s(o, e, t) {
    if (!o) return null;
    let n = $88ab1a78ec8ca4b4$var$ye();
    return o.then((r)=>{
        let { items: i, columns: a } = $88ab1a78ec8ca4b4$var$oa(r);
        i && i.length && n($acw62.createElement(t, {
            ...e,
            items: i || [],
            columns: a
        }));
    }), $acw62.createElement($88ab1a78ec8ca4b4$var$mn, {
        updater: n
    });
}
function $88ab1a78ec8ca4b4$var$Sg(o, e, t) {
    let { columnId: n, rowIndex: r, event: i } = o, { getComputed: a, getState: l } = e, { components: s, getCellContextMenuItems: c } = l(), u = s?.Menu ?? $88ab1a78ec8ca4b4$export$d9b273488cd8ce6f, { computedColumnsMap: d } = a(), f = d.get(n), p = {
        ...$88ab1a78ec8ca4b4$var$mt({
            ...e,
            rowIndex: r,
            columnId: f.id
        }),
        event: i
    };
    if (!f || !c) return {
        cellContext: p,
        menu: null,
        preventDefault: !1
    };
    let m = $88ab1a78ec8ca4b4$var$As({
        onHideIntent: t
    }), g = c(p, e), b = g instanceof Promise || Array.isArray(g) ? !0 : !!(g && Array.isArray(g.items));
    if (g instanceof Promise) return {
        cellContext: p,
        menu: $88ab1a78ec8ca4b4$var$_s(g, m, u),
        preventDefault: b
    };
    let { items: h, columns: y } = $88ab1a78ec8ca4b4$var$oa(g);
    return !h || !h.length ? {
        cellContext: p,
        menu: null,
        preventDefault: Array.isArray(h)
    } : {
        preventDefault: b,
        menu: $acw62.createElement(u, {
            ...m,
            columns: y,
            items: h
        }),
        cellContext: p
    };
}
function $88ab1a78ec8ca4b4$var$Cg(o, e, t) {
    let { getState: n, getComputed: r } = e, { components: i, getContextMenuItems: a } = n(), l = i?.Menu ?? $88ab1a78ec8ca4b4$export$d9b273488cd8ce6f, { computedColumnsMap: s } = r(), c = o.columnId ? s.get(o.columnId) : void 0, u = c ? {
        ...o,
        ...$88ab1a78ec8ca4b4$var$mt({
            ...e,
            rowIndex: o.rowIndex,
            columnId: c.id
        })
    } : o;
    if (!a) return {
        cellContext: u,
        menu: null,
        preventDefault: !1
    };
    let d = $88ab1a78ec8ca4b4$var$As({
        onHideIntent: t
    }), f = a(u, e), p = f instanceof Promise || Array.isArray(f) ? !0 : !!(f && Array.isArray(f.items));
    if (f instanceof Promise) return {
        cellContext: u,
        menu: $88ab1a78ec8ca4b4$var$_s(f, d, l),
        preventDefault: p
    };
    let { items: m, columns: g } = $88ab1a78ec8ca4b4$var$oa(f);
    return !m || !m.length ? {
        cellContext: u,
        menu: null,
        preventDefault: Array.isArray(m)
    } : {
        preventDefault: p,
        menu: $acw62.createElement(l, {
            ...d,
            columns: g,
            items: m
        }),
        cellContext: u
    };
}
var $88ab1a78ec8ca4b4$var$ia = 5, $88ab1a78ec8ca4b4$var$wg = [
    [
        "TopLeft",
        "BottomLeft"
    ],
    [
        "TopRight",
        "BottomRight"
    ],
    [
        "BottomLeft",
        "BottomLeft"
    ],
    [
        "BottomRight",
        "BottomRight"
    ],
    [
        "TopCenter",
        "TopLeft"
    ],
    [
        "BottomCenter",
        "TopLeft"
    ],
    [
        "CenterLeft",
        "TopLeft"
    ],
    [
        "CenterRight",
        "TopLeft"
    ]
];
function $88ab1a78ec8ca4b4$var$Ig() {
    let o = $88ab1a78ec8ca4b4$var$Q(), e = $88ab1a78ec8ca4b4$var$Ve(), { getState: t, actions: n } = o, { showOverlay: r, portal: i, clearAll: a } = $88ab1a78ec8ca4b4$export$ea8f71083e90600f({
        portalContainer: e ? e.getMasterState().portalDOMRef.current : !1
    });
    return (0, $acw62.useEffect)(()=>{
        let { actions: l, getState: s, getDataSourceState: c } = o;
        return s().cellContextMenu.onChange((d)=>{
            if (!d) return;
            let { event: f } = d;
            function p() {
                a(), l.cellContextMenuVisibleFor = null;
            }
            let { menu: m, cellContext: g, preventDefault: b } = $88ab1a78ec8ca4b4$var$Sg(d, o, p), h = $88ab1a78ec8ca4b4$var$Ie.fromPoint({
                top: f.clientY,
                left: f.clientX
            });
            h.width += $88ab1a78ec8ca4b4$var$ia, h.height += $88ab1a78ec8ca4b4$var$ia, r(m, {
                constrainTo: s().domRef.current,
                id: "cell-context-menu",
                alignTo: h,
                alignPosition: $88ab1a78ec8ca4b4$var$wg
            }), b && f.preventDefault(), l.cellContextMenuVisibleFor = {
                columnId: d.columnId,
                rowId: d.rowId,
                rowIndex: d.rowIndex,
                colIndex: d.colIndex
            };
            let { onCellContextMenu: y } = s();
            y && y({
                ...g,
                getState: s,
                getDataSourceState: c
            }, f);
        });
    }, []), (0, $acw62.useEffect)(()=>{
        let { cellContextMenuVisibleFor: l } = t();
        if (l) {
            let c = function(u) {
                u.__insideMenu !== !0 && (a(), n.cellContextMenuVisibleFor = null);
            };
            var s = c;
            return document.documentElement.addEventListener("mousedown", c), ()=>{
                document.documentElement.removeEventListener("mousedown", c);
            };
        } else a();
        return ()=>{};
    }, [
        t().cellContextMenuVisibleFor
    ]), {
        menuPortal: i
    };
}
function $88ab1a78ec8ca4b4$var$vg() {
    let o = $88ab1a78ec8ca4b4$var$Q(), e = $88ab1a78ec8ca4b4$var$Ve(), { getState: t, actions: n } = o, { showOverlay: r, portal: i, clearAll: a } = $88ab1a78ec8ca4b4$export$ea8f71083e90600f({
        portalContainer: e ? e.getMasterState().portalDOMRef.current : !1
    });
    return (0, $acw62.useEffect)(()=>{
        let { actions: l, getState: s } = o;
        return s().contextMenu.onChange((u)=>{
            if (!u) return;
            let { event: d } = u;
            function f() {
                a(), l.contextMenuVisibleFor = null;
            }
            let { menu: p, cellContext: m, preventDefault: g } = $88ab1a78ec8ca4b4$var$Cg(u, o, f), b = {
                top: d.clientY,
                left: d.clientX
            }, h = $88ab1a78ec8ca4b4$var$Ie.fromPoint(b);
            h.width += $88ab1a78ec8ca4b4$var$ia, h.height += $88ab1a78ec8ca4b4$var$ia, r(p, {
                constrainTo: s().domRef.current,
                id: "table-context-menu",
                alignTo: h,
                alignPosition: $88ab1a78ec8ca4b4$var$wg
            }), g && d.preventDefault(), l.contextMenuVisibleFor = {
                point: b,
                ...u
            };
            let { onContextMenu: y } = s();
            y && y({
                ...o,
                ...m
            }, d);
        });
    }, []), (0, $acw62.useEffect)(()=>{
        let { contextMenuVisibleFor: l } = t();
        if (l) {
            let c = function(u) {
                u.__insideMenu !== !0 && (a(), n.contextMenuVisibleFor = null);
            };
            var s = c;
            return document.documentElement.addEventListener("mousedown", c), ()=>{
                document.documentElement.removeEventListener("mousedown", c);
            };
        } else a();
        return ()=>{};
    }, [
        t().contextMenuVisibleFor
    ]), {
        menuPortal: i
    };
}
function $88ab1a78ec8ca4b4$export$d3441dc29db31b8c(o, e) {
    let { state: { brain: t } } = $88ab1a78ec8ca4b4$var$Q(), n = (0, $acw62.useCallback)(o, e);
    (0, $acw62.useEffect)(()=>t.onScroll(n), [
        t,
        n
    ]);
}
var $88ab1a78ec8ca4b4$var$Fs = "yzx0vj0";
function $88ab1a78ec8ca4b4$var$xg(o) {
    let { width: e, maxWidth: t, minWidth: n, scrollable: r, ...i } = o, a = (0, $acw62.useRef)(null);
    $88ab1a78ec8ca4b4$export$d3441dc29db31b8c((s)=>{
        a.current && r !== !1 && (a.current.style.transform = `translate3d(${-s.scrollLeft}px, 0px, 0px)`);
    }, [
        r
    ]);
    let l = {
        ...i.style
    };
    return e === "column" ? l.width = $88ab1a78ec8ca4b4$var$se.runtime.totalVisibleColumnsWidthValue : e === "viewport" && (l.width = $88ab1a78ec8ca4b4$var$se.runtime.bodyWidth), n === "column" ? l.minWidth = $88ab1a78ec8ca4b4$var$se.runtime.totalVisibleColumnsWidthValue : n === "viewport" && (l.minWidth = $88ab1a78ec8ca4b4$var$se.runtime.bodyWidth), t === "column" ? l.maxWidth = $88ab1a78ec8ca4b4$var$se.runtime.totalVisibleColumnsWidthValue : t === "viewport" && (l.maxWidth = $88ab1a78ec8ca4b4$var$se.runtime.bodyWidth), $acw62.createElement("div", {
        ref: a,
        ...i,
        className: i.className ? $88ab1a78ec8ca4b4$var$X(i.className, $88ab1a78ec8ca4b4$var$Fs) : $88ab1a78ec8ca4b4$var$Fs,
        style: l
    }, i.children);
}
var $88ab1a78ec8ca4b4$var$_w = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnWidthAtIndex), $88ab1a78ec8ca4b4$var$Ow = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.columnOffsetAtIndex);
function $88ab1a78ec8ca4b4$export$44156f8cc732d228() {
    return $88ab1a78ec8ca4b4$var$Q().computed.computedVisibleColumns.map((e)=>({
            id: e.id,
            width: e.computedWidth,
            cssVarForWidth: `var(${$88ab1a78ec8ca4b4$var$_w}-${e.computedVisibleIndex})`,
            offset: e.computedOffset,
            cssVarForOffset: `var(${$88ab1a78ec8ca4b4$var$Ow}-${e.computedVisibleIndex})`,
            pinned: e.computedPinned
        }));
}
var $88ab1a78ec8ca4b4$var$aa = "InfiniteTable";
function $88ab1a78ec8ca4b4$var$Pg() {
    let { getState: o, actions: e, dataSourceActions: t, getDataSourceState: n } = $88ab1a78ec8ca4b4$var$Q(), { groupBy: r, isTree: i } = n(), a = o(), { brain: l, wrapRowsHorizontally: s } = a, c = a.repeatWrappedGroupRows;
    s || (c = !1), (0, $acw62.useEffect)(()=>{
        if (!s) {
            n().repeatWrappedGroupRows && (t.repeatWrappedGroupRows = !1);
            return;
        }
        let u = ()=>{
            let { rowsPerPage: p, repeatWrappedGroupRows: m } = n(), g = !1, b = l.rowsPerPage, h = (r && r.length > 0 || i) && b > 0 ? b : null;
            return p != h && (t.rowsPerPage = h, g = !0), m != c && (t.repeatWrappedGroupRows = c ?? !1, g = !0), g;
        };
        u();
        let d, f = l.onVerticalRenderRangeChange(()=>{
            u() && (d = setTimeout(()=>{
                e.forceBodyRerenderTimestamp = Date.now();
            }));
        });
        return ()=>{
            d && clearTimeout(d), f();
        };
    }, [
        l,
        s,
        r,
        i,
        c
    ]);
}
var $88ab1a78ec8ca4b4$var$Sr = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "_143ofgf0",
    variantClassNames: {
        active: {
            true: "_143ofgf1",
            false: "_143ofgf2"
        }
    },
    defaultVariants: {},
    compoundVariants: []
}), $88ab1a78ec8ca4b4$var$Dg = "_143ofgf5", $88ab1a78ec8ca4b4$var$Mg = "_143ofgf3";
var $88ab1a78ec8ca4b4$var$kw = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$se.loaded), $88ab1a78ec8ca4b4$var$Ls = {
    source: "infinite-table-page",
    target: "infinite-table-devtools-background"
};
function $88ab1a78ec8ca4b4$var$Eg(o, e) {
    let { type: t, debugId: n } = o;
    if (t === "unmount") return {
        ...$88ab1a78ec8ca4b4$var$Ls,
        url: $88ab1a78ec8ca4b4$var$ks(),
        type: t,
        payload: {
            debugId: n
        }
    };
    let r = e, i = r.getComputed(), a = r.getDataSourceState(), l = r.getState();
    return {
        ...$88ab1a78ec8ca4b4$var$Ls,
        url: $88ab1a78ec8ca4b4$var$ks(),
        type: t,
        payload: {
            debugId: n,
            columnVisibility: l.columnVisibility,
            columnOrder: i.computedColumnOrder,
            visibleColumnIds: i.computedVisibleColumns.map((c)=>c.id),
            selectionMode: a.selectionMode,
            columns: Object.fromEntries(i.computedVisibleColumns.map((c)=>[
                    c.id,
                    {
                        field: c.field,
                        dataType: c.computedDataType,
                        sortType: c.computedSortType,
                        filtered: c.computedFiltered,
                        sorted: c.computedSorted,
                        width: c.computedWidth
                    }
                ])),
            groupRenderStrategy: l.groupRenderStrategy,
            groupBy: a.groupBy.map((c)=>c.field ? `${c.field}` : "<fn>"),
            sortInfo: (a.sortInfo || []).filter((c)=>typeof c.field == "string").map((c)=>({
                    field: `${c.field}`,
                    dir: c.dir,
                    type: Array.isArray(c.type) ? c.type[0] : c.type ?? "string"
                })),
            multiSort: a.multiSort,
            devToolsDetected: l.devToolsDetected,
            debugTimings: Object.fromEntries(a.debugTimings),
            debugWarnings: {
                ...Object.fromEntries(a.debugWarnings),
                ...Object.fromEntries(l.debugWarnings)
            }
        }
    };
}
var $88ab1a78ec8ca4b4$var$ks = $88ab1a78ec8ca4b4$var$ot(function() {
    let o = new URL(window.location.href);
    return o.origin + o.pathname;
});
function $88ab1a78ec8ca4b4$var$zw(o) {
    window.postMessage(o);
}
var $88ab1a78ec8ca4b4$var$Vw = $88ab1a78ec8ca4b4$var$ot(()=>{
    console.log("Infinite Table DevTools detected!");
    let o = (e, t)=>{
        if (t) {
            $88ab1a78ec8ca4b4$var$It.set(e, t);
            let { devToolsDetected: n } = t.getState();
            n || (t.actions.devToolsDetected = !0);
            let r = t.getDataSourceState();
            r.debugId !== e && (t.dataSourceActions.debugId = e), r.devToolsDetected || (t.dataSourceActions.devToolsDetected = !0), window.postMessage($88ab1a78ec8ca4b4$var$Eg({
                type: "update",
                debugId: e
            }, t));
        } else $88ab1a78ec8ca4b4$var$bp(e), window.postMessage($88ab1a78ec8ca4b4$var$Eg({
            type: "unmount",
            debugId: e
        }, null));
    };
    return window.__INFINITE_TABLE_DEVTOOLS_HOOK__ = o, $88ab1a78ec8ca4b4$export$1c9f709888824e05.onLogIntent("IT:*", (e)=>{
        $88ab1a78ec8ca4b4$var$zw({
            ...$88ab1a78ec8ca4b4$var$Ls,
            url: $88ab1a78ec8ca4b4$var$ks(),
            type: "log",
            payload: {
                debugId: void 0,
                channel: e.channel,
                color: e.color,
                args: e.args.map((t)=>{
                    if (typeof t == "object" && t !== null) {
                        let n = "";
                        try {
                            n = JSON.stringify(t);
                        } catch  {
                            console.error("Cannot stringify arg in global log interceptor", t);
                        }
                        return n;
                    }
                    return String(t);
                }),
                timestamp: e.timestamp
            }
        });
    }), o;
});
function $88ab1a78ec8ca4b4$var$Ag() {
    let { getState: o, getDataSourceState: e, dataSourceActions: t } = $88ab1a78ec8ca4b4$var$Q(), n = o(), { domRef: r, debugId: i } = n;
    return i && r.current && getComputedStyle(r.current).getPropertyValue($88ab1a78ec8ca4b4$var$kw) !== `${$88ab1a78ec8ca4b4$var$hu}` && $88ab1a78ec8ca4b4$var$dr({
        debugId: i,
        key: "CSS001_CSS"
    }), (0, $acw62.useEffect)(()=>{
        e().debugId !== i && (t.debugId = i);
    }, [
        i
    ]), $88ab1a78ec8ca4b4$var$Kw();
}
var $88ab1a78ec8ca4b4$var$sa = $88ab1a78ec8ca4b4$var$ye(), $88ab1a78ec8ca4b4$var$Gw = {
    revertAll: (o)=>{
        let e = $88ab1a78ec8ca4b4$var$It.get(o.debugId);
        if (e) {
            let t = $88ab1a78ec8ca4b4$var$Sn.get(o.debugId);
            $88ab1a78ec8ca4b4$var$Sn.delete(o.debugId), $88ab1a78ec8ca4b4$var$qt.delete(o.debugId), t && Object.keys(t).forEach((r)=>{
                e.actions[r] = t[r], delete t[r];
            });
            let n = $88ab1a78ec8ca4b4$var$Zt.get(o.debugId);
            $88ab1a78ec8ca4b4$var$Zt.delete(o.debugId), $88ab1a78ec8ca4b4$var$Xt.delete(o.debugId), n && Object.keys(n).forEach((r)=>{
                e.dataSourceActions[r] = n[r], delete n[r];
            });
        }
    },
    revertProperty: (o)=>{
        let e = $88ab1a78ec8ca4b4$var$It.get(o.debugId);
        if (e) {
            let t = o.property, n = $88ab1a78ec8ca4b4$var$qt.get(o.debugId), r = $88ab1a78ec8ca4b4$var$Sn.get(o.debugId), i = $88ab1a78ec8ca4b4$var$Xt.get(o.debugId), a = $88ab1a78ec8ca4b4$var$Zt.get(o.debugId), l = t;
            r && n && n[l] !== void 0 && (delete n[l], e.actions[l] = r[l], delete r[l]);
            let s = t;
            if (a && i && i[s] !== void 0) {
                let c = $88ab1a78ec8ca4b4$var$Zt.get(o.debugId) || {};
                delete i[s], e.dataSourceActions[s] = c[s], delete c[s];
            }
        }
    },
    discardWarning: (o)=>{
        let e = $88ab1a78ec8ca4b4$var$It.get(o.debugId);
        if (e) {
            let t = o.warning, n = e.getDataSourceState().debugWarnings;
            if (n.get(t)) n.delete(t), $88ab1a78ec8ca4b4$var$fr(o.debugId);
            else {
                let i = o.warning, a = e.getState().debugWarnings;
                a.get(i) && (a.delete(i), $88ab1a78ec8ca4b4$var$fr(o.debugId));
            }
        }
    },
    discardAllWarnings: (o)=>{
        let e = $88ab1a78ec8ca4b4$var$It.get(o.debugId);
        e && (e.getDataSourceState().debugWarnings.clear(), e.getState().debugWarnings.clear(), $88ab1a78ec8ca4b4$var$fr(o.debugId));
    },
    setColumnVisibility: (o)=>{
        $88ab1a78ec8ca4b4$var$ns(o.debugId, "columnVisibility", o.columnVisibility);
    },
    setGroupBy: (o)=>{
        $88ab1a78ec8ca4b4$var$Li(o.debugId, "groupBy", o.groupBy);
    },
    setGroupRenderStrategy: (o)=>{
        $88ab1a78ec8ca4b4$var$ns(o.debugId, "groupRenderStrategy", o.groupRenderStrategy);
    },
    setSortInfo: (o)=>{
        $88ab1a78ec8ca4b4$var$Li(o.debugId, "sortInfo", o.sortInfo);
    },
    setMultiSort: (o)=>{
        $88ab1a78ec8ca4b4$var$Li(o.debugId, "multiSort", o.multiSort);
    },
    highlight: (o)=>{
        let e = $88ab1a78ec8ca4b4$var$It.get(o.debugId);
        if (e) {
            let t = e.getState().domRef.current;
            if (t) {
                let n = t.getBoundingClientRect(), r = document.querySelector(`.${$88ab1a78ec8ca4b4$var$Sr.classNames.base}`);
                r || (r = document.createElement("div"), r.classList.add($88ab1a78ec8ca4b4$var$Sr.classNames.base), r.innerHTML = [
                    `<div class="${$88ab1a78ec8ca4b4$var$Mg}"></div>`,
                    `<div class="${$88ab1a78ec8ca4b4$var$Dg}"></div>`
                ].join(""), document.body.appendChild(r));
                let i = r.firstElementChild;
                if (r) {
                    r.style.left = `${n.left}px`, r.style.top = `${n.top}px`, r.style.width = `${n.width}px`, r.style.height = `${n.height}px`, i.innerHTML = o.debugId;
                    let a = r.lastElementChild, l = ()=>{
                        r.classList.remove($88ab1a78ec8ca4b4$var$Sr.classNames.variants.active.true), a.removeEventListener("animationend", l);
                    };
                    a.addEventListener("animationend", l), r.classList.add($88ab1a78ec8ca4b4$var$Sr.classNames.variants.active.true);
                }
            }
        }
    }
};
function $88ab1a78ec8ca4b4$var$Hw() {
    typeof window < "u" && window.addEventListener("message", (o)=>{
        if (o && o.data && typeof o.data.source == "string" && typeof o.data.target == "string" && o.data.target === "infinite-table-page" && o.data.source.startsWith("infinite-table-devtools-contentscript") && (window.__INFINITE_TABLE_DEVTOOLS_HOOK__ || ($88ab1a78ec8ca4b4$var$Vw(), $88ab1a78ec8ca4b4$var$sa(window.__INFINITE_TABLE_DEVTOOLS_HOOK__)), typeof o.data.type == "string")) {
            let e = o.data.type, t = $88ab1a78ec8ca4b4$var$Gw[e];
            t && t(o.data.payload);
        }
    });
}
$88ab1a78ec8ca4b4$var$Hw();
function $88ab1a78ec8ca4b4$var$Kw() {
    let { getState: o, getComputed: e, getDataSourceState: t, dataSourceActions: n, actions: r, dataSourceApi: i, api: a } = $88ab1a78ec8ca4b4$var$Q(), s = o().debugId, c = (0, $acw62.useRef)(s);
    return c.current = s, (0, $acw62.useEffect)(()=>{
        let u = c.current;
        if (!u) return;
        let d = (p)=>{
            p(u, {
                getState: o,
                getDataSourceState: t,
                getComputed: e,
                dataSourceActions: n,
                actions: r,
                api: a,
                dataSourceApi: i
            });
        }, f = $88ab1a78ec8ca4b4$var$sa.get();
        if (f) {
            d(f);
            return;
        }
        return $88ab1a78ec8ca4b4$var$sa.onChange((p)=>{
            p && d(p);
        });
    }, []), (0, $acw62.useEffect)(()=>{
        let u = c.current;
        if (!u) return;
        let d = $88ab1a78ec8ca4b4$var$sa.get();
        d && d(u, {
            getState: o,
            getDataSourceState: t,
            getComputed: e,
            dataSourceActions: n,
            actions: r,
            api: a,
            dataSourceApi: i
        });
    }), (0, $acw62.useEffect)(()=>{
        if (s) return ()=>{
            let u = globalThis.__INFINITE_TABLE_DEVTOOLS_HOOK__;
            u && u(s, null);
        };
    }, [
        s
    ]), s;
}
function $88ab1a78ec8ca4b4$export$c33414df554d876b() {
    let o = $88ab1a78ec8ca4b4$var$Ve(), e = o ? o.getMasterState() : null, t = $88ab1a78ec8ca4b4$var$Q().getState();
    return (e || t).portalDOMRef.current;
}
var $88ab1a78ec8ca4b4$var$_g = "hs68h8j _16lm1iwk _16lm1iwx _16lm1iw2n", $88ab1a78ec8ca4b4$var$Og = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "hs68h8e _16lm1iw12 _16lm1iw1x _16lm1iw2j _16lm1iw1p",
    variantClassNames: {
        active: {
            true: "hs68h8f _16lm1iwn _16lm1iw1h",
            false: "_16lm1iwo"
        },
        draggingInProgress: {
            true: "hs68h8h",
            false: "hs68h8i"
        }
    },
    defaultVariants: {},
    compoundVariants: []
}), $88ab1a78ec8ca4b4$var$Ng = "hs68h81", $88ab1a78ec8ca4b4$var$Fg = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "hs68h80 _16lm1iw1p",
    variantClassNames: {
        orientation: {
            horizontal: "_16lm1iw2h _16lm1iw2j",
            vertical: "_16lm1iw2f"
        },
        draggingInProgress: {
            true: "_16lm1iw1h",
            false: "hs68h86"
        },
        dropRejected: {
            true: "hs68h87",
            false: "hs68h88"
        },
        active: {
            true: "hs68h89",
            false: "hs68h8a"
        }
    },
    defaultVariants: {},
    compoundVariants: [
        [
            {
                dropRejected: !0,
                active: !0
            },
            "hs68h8b"
        ],
        [
            {
                dropRejected: !1,
                active: !0
            },
            "hs68h8c"
        ],
        [
            {
                active: !1,
                dropRejected: !1
            },
            "hs68h8d"
        ]
    ]
});
function $88ab1a78ec8ca4b4$var$Lg(o) {
    return $acw62.createElement("div", {
        ...o.domProps
    });
}
function $88ab1a78ec8ca4b4$var$kg(o) {
    let { active: e } = o;
    return $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$Ng
    }, e ? "Drop to group" : "Drag columns to group");
}
function $88ab1a78ec8ca4b4$var$zg(o) {
    let e = (t)=>{
        (t.key === "Enter" || t.key === " ") && (t.preventDefault(), o.onClear?.());
    };
    return $acw62.createElement("div", {
        ...o.domProps
    }, o.label, $acw62.createElement("div", {
        className: $88ab1a78ec8ca4b4$var$_r[1]
    }), $acw62.createElement("div", {
        tabIndex: 0,
        role: "button",
        "aria-label": `Clear grouping by ${o.field}`,
        className: $88ab1a78ec8ca4b4$var$_g,
        onKeyDown: e,
        onMouseDown: o.onClear
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$ta, {
        size: 20
    })));
}
var $88ab1a78ec8ca4b4$var$jw = (o, e)=>(t)=>{
        e && e(t);
        let n = Date.now(), r = !1, i = ()=>{
            r = !0;
        };
        $88ab1a78ec8ca4b4$var$Re().addEventListener("mousemove", i, {
            once: !0
        }), $88ab1a78ec8ca4b4$var$Re().addEventListener("mouseup", ()=>{
            r || ($88ab1a78ec8ca4b4$var$Re().removeEventListener("mousemove", i), Date.now() - n < 200 && requestAnimationFrame(()=>{
                o();
            }));
        }, {
            once: !0
        });
    };
function $88ab1a78ec8ca4b4$var$$w(o) {
    let { column: e, onClear: t, components: n, field: r, id: i, toggleSorting: a } = o, { dragSourceListId: l, dragItemId: s } = $88ab1a78ec8ca4b4$var$er(), c = l === $88ab1a78ec8ca4b4$var$Ro, u = $88ab1a78ec8ca4b4$var$Q(), d = (e ? $88ab1a78ec8ca4b4$var$Pn(e.id, u, "grouping-toolbar") : r) ?? i, f = e ? $acw62.createElement($88ab1a78ec8ca4b4$var$oi, {
        forceSize: !0,
        size: 20,
        direction: e.computedSortedAsc ? 1 : e.computedSortedDesc ? -1 : 0
    }) : null, p = $acw62.createElement($acw62.Fragment, null, d, f), m = s === i && l === $88ab1a78ec8ca4b4$var$Ro, g = $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$Og({
        draggingInProgress: c,
        active: m
    }), o.domProps?.className), b = $88ab1a78ec8ca4b4$var$jw(a, o.domProps?.onMouseDown), h = {
        ...o.domProps,
        className: g,
        onMouseDown: b
    }, y = n?.ToolbarItem ?? $88ab1a78ec8ca4b4$var$zg;
    return $acw62.createElement(y, {
        active: m,
        domProps: h,
        column: e,
        field: r,
        label: p,
        onClear: t
    });
}
var $88ab1a78ec8ca4b4$var$Ro = "grouping-toolbar";
function $88ab1a78ec8ca4b4$var$Vg(o) {
    let { groupBy: e } = $88ab1a78ec8ca4b4$export$c5a52c32d527b09b(), { getComputed: t, dataSourceApi: n, api: r } = $88ab1a78ec8ca4b4$var$Q(), { dropTargetListId: i, dragSourceListId: a } = $88ab1a78ec8ca4b4$var$An(), { fieldsToColumn: l, computedColumnsMap: s } = t(), c = i === $88ab1a78ec8ca4b4$var$Ro, u = a === $88ab1a78ec8ca4b4$var$Ro, d = o.components?.Placeholder ?? $88ab1a78ec8ca4b4$var$kg, f = o.components?.Host ?? $88ab1a78ec8ca4b4$var$Lg, p = e.length ? $acw62.createElement($acw62.Fragment, null, e.map((S, C)=>{
        let T = S.field ? l.get(S.field) : void 0, I = `${S.field ?? `idx-${C}`}`;
        return $acw62.createElement($88ab1a78ec8ca4b4$var$kn.DraggableItem, {
            key: I,
            id: I
        }, (w)=>$acw62.createElement($88ab1a78ec8ca4b4$var$$w, {
                id: I,
                components: o.components,
                domProps: w,
                field: S.field,
                column: T,
                toggleSorting: ()=>{
                    T && r.toggleSortingForColumn(T.id);
                },
                onClear: ()=>{
                    let v = e.filter((R)=>R !== S).filter(Boolean);
                    n.setGroupBy(v);
                }
            }));
    })) : $acw62.createElement(d, {
        draggingInProgress: u,
        active: c,
        groupBy: e
    }), m = (S)=>{
        let C = S.map((T)=>e[T]);
        n.setGroupBy(C);
    }, g = (S)=>{
        let { dragItemId: C } = S, T = C, I = s.get(T);
        if (!I || !I.field || !I.computedGroupable) return;
        let w = [
            ...e
        ];
        w.splice(S.dropIndex, 0, {
            field: I.field
        }), n.setGroupBy(w);
    }, b = (0, $acw62.useCallback)((S)=>{
        let { computedColumnsMap: C } = t(), T = S.dragItem.id, I = C.get(T);
        return !(!I || !I.computedGroupable || e.some((w)=>w.field === I.field));
    }, [
        e
    ]), h = o.orientation ?? "horizontal", { domProps: y } = o;
    return $acw62.createElement($88ab1a78ec8ca4b4$var$kn, {
        orientation: h,
        dragListId: $88ab1a78ec8ca4b4$var$Ro,
        acceptDropsFrom: [
            "header",
            $88ab1a78ec8ca4b4$var$Ro
        ],
        onDrop: m,
        onAcceptDrop: g,
        shouldAcceptDrop: b
    }, (S, { draggingInProgress: C, status: T })=>{
        let I = $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$Fg({
            active: c,
            orientation: h,
            draggingInProgress: C,
            dropRejected: T === "rejected"
        }), S.className, y?.className), w = {
            ...S,
            ...y,
            className: I,
            children: p
        };
        return $acw62.createElement(f, {
            active: c,
            rejectDrop: T === "rejected",
            domProps: w,
            orientation: h
        });
    });
}
function $88ab1a78ec8ca4b4$var$Gg(o) {
    let { dataArray: e, brain: t, computedPinnedEndColumns: n, computedPinnedStartColumns: r, computedVisibleColumns: i, computedRowHeight: a, columnSize: l, rowspan: s } = o;
    return $88ab1a78ec8ca4b4$var$Ii(t, {
        colWidth: l,
        rowHeight: a,
        rows: e.length,
        cols: i.length,
        rowspan: s
    }, {
        fixedColsEnd: n.length,
        fixedColsStart: r.length
    }), t;
}
var $88ab1a78ec8ca4b4$var$Hg = $88ab1a78ec8ca4b4$var$fe({
    defaultClassName: "evqes20",
    variantClassNames: {},
    defaultVariants: {},
    compoundVariants: []
});
function $88ab1a78ec8ca4b4$var$Yw(o, e) {
    let { masterState: t, detailContext: n } = e, r = t.detailDataSourcesStateToRestore;
    if (r.has(o)) {
        let i = r.get(o);
        return n.assignState(i), !0;
    }
    return !1;
}
function $88ab1a78ec8ca4b4$var$qw(o, e) {
    let { detailState: t, masterState: n, masterActions: r, cacheEntryForRow: i } = e, a = new Map(n.detailDataSourcesStateToRestore), l = $88ab1a78ec8ca4b4$var$Fp(t);
    i.all || (i.groupBy || delete l.groupBy, i.sortInfo || delete l.sortInfo, i.filterValue || delete l.filterValue, i.data || delete l.originalDataArray), a.set(o, l), r.detailDataSourcesStateToRestore = a;
}
function $88ab1a78ec8ca4b4$var$Xw(o, e) {
    let t = (0, $acw62.useRef)(!1);
    return {
        currentRowCache: (0, $acw62.useMemo)(()=>({
                getRowId: ()=>o,
                add: (r)=>{
                    t.current = !0, e.add(o, r);
                },
                get: ()=>e.get(o),
                delete: ()=>(t.current = !0, e.delete(o)),
                has: ()=>e.has(o)
            }), [
            e,
            o
        ]),
        cacheCalledByRowDetailRenderer: t
    };
}
function $88ab1a78ec8ca4b4$var$Bg(o) {
    let { rowDetailsCache: e, rowInfo: t } = o, { getState: n, componentActions: r } = $88ab1a78ec8ca4b4$var$_e(), { getState: i } = $88ab1a78ec8ca4b4$var$Q(), { currentRowCache: a, cacheCalledByRowDetailRenderer: l } = $88ab1a78ec8ca4b4$var$Xw(t.id, e), s = (0, $acw62.useMemo)(()=>{
        let c = n().detailDataSourcesStateToRestore.has(t.id) && a.has();
        return {
            registerDetail: $88ab1a78ec8ca4b4$var$ot((d)=>{
                if (l.current || a.add({
                    all: !0
                }), !a.has()) {
                    requestAnimationFrame(()=>{
                        d.componentState.destroyedRef.current || (d.componentActions.stateReadyAsDetails = !0);
                    });
                    return;
                }
                $88ab1a78ec8ca4b4$var$Yw(t.id, {
                    masterState: n(),
                    detailContext: d
                }), requestAnimationFrame(()=>{
                    d.componentState.destroyedRef.current || (d.componentActions.stateReadyAsDetails = !0);
                }), d.componentState.onCleanup.onChange(()=>{
                    let f = a.get();
                    f && $88ab1a78ec8ca4b4$var$qw(t.id, {
                        detailState: d.getState(),
                        masterActions: r,
                        masterState: n(),
                        cacheEntryForRow: f
                    });
                });
            }),
            shouldRestoreState: c
        };
    }, [
        t.id,
        a
    ]);
    return s.masterRowInfo = t, s.getMasterDataSourceState = n, s.getMasterState = i, {
        masterDetailContextValue: s,
        currentRowCache: a
    };
}
var { rootClassName: $88ab1a78ec8ca4b4$var$Zw } = $88ab1a78ec8ca4b4$var$Fe, $88ab1a78ec8ca4b4$var$Qw = `${$88ab1a78ec8ca4b4$var$Zw}RowDetail`;
function $88ab1a78ec8ca4b4$var$Jw(o) {
    let e = $88ab1a78ec8ca4b4$var$Mr(), { domRef: t, rowDetailRenderer: n, rowDetailHeight: r, rowInfo: i, detailOffset: a, rowDetailsCache: l } = o, { masterDetailContextValue: s, currentRowCache: c } = $88ab1a78ec8ca4b4$var$Bg({
        rowDetailsCache: l,
        rowInfo: i
    });
    return $acw62.createElement(e.Provider, {
        value: s
    }, $acw62.createElement("div", {
        ref: t,
        className: $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$Qw, $88ab1a78ec8ca4b4$var$Hg({})),
        style: {
            position: "absolute",
            top: `${a}px`,
            left: 0,
            width: `calc(${$88ab1a78ec8ca4b4$var$U.bodyWidth} - ${$88ab1a78ec8ca4b4$var$U.scrollbarWidthVertical})`,
            height: r
        }
    }, n(i, c)));
}
var $88ab1a78ec8ca4b4$var$Wg = $acw62.memo($88ab1a78ec8ca4b4$var$Jw);
var $88ab1a78ec8ca4b4$var$nI = 1;
function $88ab1a78ec8ca4b4$var$$g(o) {
    let { computed: e, bodySize: t, imperativeApi: n } = o, { actions: r, state: i, getState: a, getComputed: l, getDataSourceMasterContext: s } = $88ab1a78ec8ca4b4$var$Q(), { computedPinnedStartColumns: c, computedPinnedEndColumns: u, computedVisibleColumns: d, computedColumnsMap: f, computedRowHeight: p, computedRowSizeCacheForDetails: m, fieldsToColumn: g, rowspan: b, toggleGroupRow: h, columnSize: y } = e, { componentState: S, getState: C, componentActions: T, api: I } = $88ab1a78ec8ca4b4$var$_e(), { dataArray: w, rowInfoStore: v, selectionMode: R, cellSelection: x, isNodeReadOnly: M } = S, A = $88ab1a78ec8ca4b4$var$Me(w), { rowHeight: E, rowDetailHeight: P, onRowMouseEnter: _, onRowMouseLeave: D, groupRenderStrategy: O, brain: F, showZebraRows: W, rowDetailRenderer: z, isRowDetailExpanded: L, isRowDetailEnabled: ae, cellClassName: te, cellStyle: B, rowStyle: j, rowDetailCache: oe, rowClassName: me, onScrollToTop: pe, onScrollToBottom: ce, onScrollStop: ue, scrollToBottomOffset: ge, wrapRowsHorizontally: H, updatedAt: G, ready: q, editingCell: K } = i, re = S.updatedAt;
    $88ab1a78ec8ca4b4$var$Gg({
        columnSize: y,
        brain: F,
        computedPinnedStartColumns: c,
        computedPinnedEndColumns: u,
        computedVisibleColumns: d,
        computedRowHeight: p,
        dataArray: w,
        bodySize: t,
        rowspan: b
    });
    let J = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>F.onRenderCountChange(()=>{
            J.current = F.scrollTopMax;
        }), [
        F
    ]), (0, $acw62.useEffect)(()=>F.onRenderRangeChange((ee)=>{
            a().onRenderRangeChange?.(ee);
        }), [
        F
    ]), (0, $acw62.useEffect)(()=>F.onScrollStop((ee)=>{
            let { scrollTop: le, scrollLeft: De } = ee;
            if (le === 0 && pe?.(), le + (ge ?? $88ab1a78ec8ca4b4$var$nI) >= J.current) {
                ce?.();
                let { livePagination: he, livePaginationCursor: Ke, dataArray: Be } = C();
                he && (T.cursorId = Ke !== void 0 ? Date.now() : Be.length);
            }
            if (ue) {
                let he = F.getRenderRange();
                ue({
                    scrollTop: le,
                    scrollLeft: De,
                    renderRange: he,
                    viewportSize: a().bodySize,
                    firstVisibleRowIndex: he.start[0],
                    lastVisibleRowIndex: he.end[0],
                    firstVisibleColIndex: he.start[1],
                    lastVisibleColIndex: he.end[1]
                });
            }
        }), [
        F,
        pe,
        ce,
        ue
    ]), (0, $acw62.useEffect)(()=>{
        t.height && (r.ready = !0);
    }, [
        !!t.height
    ]), (0, $acw62.useEffect)(()=>{
        let { onReady: ee } = a();
        ee && ee({
            api: n,
            dataSourceApi: I
        });
    }, [
        q
    ]);
    let [, de] = $88ab1a78ec8ca4b4$var$Ct();
    (0, $acw62.useEffect)(()=>{
        de();
    }, [
        S
    ]);
    let we = (0, $acw62.useMemo)(()=>({
            isNodeReadOnly: M,
            selectionMode: R,
            cellSelection: x
        }), [
        M,
        R,
        x
    ]), N1 = (0, $acw62.useCallback)((ee)=>{
        let { rowIndex: le, colIndex: De, heightWithRowspan: Oe, domRef: Ne, hidden: he, width: Ke, onMouseLeave: Be, onMouseEnter: dt } = ee, Ze = A()[le], V = d[De];
        if (!Ze || !V) return null;
        let ne = m ? m.getRowHeight(le) : Oe, ie = !1;
        !ae || typeof ae == "function" && !ae(Ze) ? ie = !1 : L && (ie = L(Ze) ? "expanded" : "collapsed");
        let be = H ? F.getRowIndexInPage(le) : null, je = H ? F.getPageIndexForRow(le) : null, k = n.isEditorVisibleForCell({
            rowIndex: le,
            columnId: V.id
        });
        return $acw62.createElement($88ab1a78ec8ca4b4$var$vd, {
            getData: A,
            virtualized: !0,
            showZebraRows: W,
            groupRenderStrategy: O,
            rowIndexInHorizontalLayoutPage: be,
            horizontalLayoutPageIndex: je,
            rowIndex: le,
            rowInfoStore: v,
            hidden: he,
            toggleGroupRow: h,
            rowHeight: ne,
            rowDetailState: ie,
            onMouseEnter: dt,
            onMouseLeave: Be,
            onRowMouseEnter: _,
            onRowMouseLeave: D,
            domRef: Ne,
            width: Ke,
            column: V,
            columnsMap: f,
            fieldsToColumn: g,
            rowStyle: j,
            rowClassName: me,
            cellStyle: B,
            cellClassName: te,
            inEditMode: k,
            getDataSourceState: C,
            dataSourceApi: I,
            dataSourceActions: T,
            getState: a,
            imperativeApi: n,
            componentActions: r,
            getComputed: l,
            getDataSourceMasterContext: s,
            dataSourceStatePartialForCell: we
        });
    }, [
        E,
        P,
        _,
        D,
        m,
        p,
        L,
        A,
        d,
        f,
        g,
        O,
        H,
        h,
        W,
        F,
        re,
        v,
        j,
        me,
        te,
        B,
        C,
        I,
        T,
        a,
        n,
        r,
        l,
        s,
        G,
        K,
        we
    ]), $ = (0, $acw62.useMemo)(()=>{
        if (L) return (ee)=>{
            let { rowIndex: le, domRef: De } = ee, Ne = A()[le];
            if (!Ne || !L(Ne) || !m) return $acw62.createElement("div", {
                ref: De,
                className: $88ab1a78ec8ca4b4$var$Sc.hidden
            });
            let { rowDetailHeight: he, rowHeight: Ke } = m.getSize(le);
            return $acw62.createElement($88ab1a78ec8ca4b4$var$Wg, {
                rowInfo: Ne,
                rowDetailsCache: oe,
                rowIndex: le,
                domRef: De,
                detailOffset: Ke,
                rowDetailHeight: he,
                rowDetailRenderer: z
            });
        };
    }, [
        q,
        N1,
        z,
        P,
        L,
        oe
    ]);
    return {
        renderCell: N1,
        renderDetailRow: $
    };
}
function $88ab1a78ec8ca4b4$var$Ug() {
    let { state: o, getState: e, actions: t } = $88ab1a78ec8ca4b4$var$Q(), { wrapRowsHorizontally: n } = o, r = $88ab1a78ec8ca4b4$export$5cae361ad82dce8b(n);
    (0, $acw62.useEffect)(()=>{
        if (r !== n) {
            let { brain: i, headerBrain: a, renderer: l, onRenderUpdater: s } = e();
            i.destroy(), a.destroy(), l.destroy(), s.destroy();
            let c = $88ab1a78ec8ca4b4$var$fs($88ab1a78ec8ca4b4$var$aa, !!n);
            t.brain = c.brain, t.headerBrain = c.headerBrain, t.renderer = c.renderer, t.onRenderUpdater = c.onRenderUpdater, t.headerRenderer = c.headerRenderer, t.headerOnRenderUpdater = c.headerOnRenderUpdater;
        }
    }, [
        r,
        n
    ]);
}
var $88ab1a78ec8ca4b4$var$Yg = "_16lm1iw1 _16lm1iw1c _16lm1iwe";
var $88ab1a78ec8ca4b4$var$qg = $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$Yg, $88ab1a78ec8ca4b4$var$pl);
function $88ab1a78ec8ca4b4$var$Zg(o) {
    return $acw62.createElement("div", {
        ...o,
        className: o.className ? $88ab1a78ec8ca4b4$var$X($88ab1a78ec8ca4b4$var$qg, o.className) : $88ab1a78ec8ca4b4$var$qg
    });
}
var $88ab1a78ec8ca4b4$var$Qg = {
    visible: "qy58ya1 qy58ya0 _16lm1iw2 _16lm1iw23 _16lm1iw26 _16lm1iw2c _16lm1iw2a",
    hidden: "qy58ya2 qy58ya0 _16lm1iw2 _16lm1iw23 _16lm1iw26 _16lm1iw2c _16lm1iw2a"
}, $88ab1a78ec8ca4b4$var$Jg = "qy58ya3 _16lm1iw2 _16lm1iw23 _16lm1iw26 _16lm1iw2c _16lm1iw2a", $88ab1a78ec8ca4b4$var$eh = "qy58ya4";
var { rootClassName: $88ab1a78ec8ca4b4$var$rI } = $88ab1a78ec8ca4b4$var$Fe, $88ab1a78ec8ca4b4$var$zs = `${$88ab1a78ec8ca4b4$var$rI}-LoadMask`;
function $88ab1a78ec8ca4b4$var$iI(o) {
    let { visible: e, children: t = "Loading" } = o;
    return $acw62.createElement("div", {
        className: `${$88ab1a78ec8ca4b4$var$Qg[e ? "visible" : "hidden"]} ${$88ab1a78ec8ca4b4$var$zs}`
    }, $acw62.createElement("div", {
        className: `${$88ab1a78ec8ca4b4$var$Jg} ${$88ab1a78ec8ca4b4$var$zs}-Overlay`
    }), $acw62.createElement("div", {
        className: `${$88ab1a78ec8ca4b4$var$eh} ${$88ab1a78ec8ca4b4$var$zs}-Text`
    }, t));
}
var $88ab1a78ec8ca4b4$var$ua = $acw62.memo($88ab1a78ec8ca4b4$var$iI);
var $88ab1a78ec8ca4b4$var$lI = [
    $88ab1a78ec8ca4b4$var$ad,
    `${$88ab1a78ec8ca4b4$var$zt}--hovered`
];
function $88ab1a78ec8ca4b4$var$sI(o) {
    return Array.isArray(o) && (o = o.join(" ")), o.split(" ").map((e)=>e.trim()).filter(Boolean);
}
function $88ab1a78ec8ca4b4$var$Un(o) {
    let e = $88ab1a78ec8ca4b4$var$Q(), t = $88ab1a78ec8ca4b4$var$Ve(), { state: n, getComputed: r, api: i } = e, { renderer: a, onRenderUpdater: l, debugId: s, keyboardNavigation: c, activeRowIndex: u, loadingText: d, scrollStopDelay: f, brain: p, scrollerDOMRef: m, components: g, bodySize: b, activeCellIndex: h, rowDetailRenderer: y, showHoverRows: S, wrapRowsHorizontally: C, domProps: T, domRef: I, rowHoverClassName: w } = n, v = g?.LoadMask ?? $88ab1a78ec8ca4b4$var$ua, R = r(), { computedRowHeight: x, computedRowSizeCacheForDetails: M } = R, A = M?.getRowHeight || x, { componentState: { loading: E } } = $88ab1a78ec8ca4b4$var$_e(), P = $acw62.useCallback((z)=>{
        let L = e.getState(), ae = z.target;
        if (!t && z._from_row_detail) return;
        t && (z._from_row_detail = !0);
        let te = $88ab1a78ec8ca4b4$var$gu(ae, $88ab1a78ec8ca4b4$var$ds(), L.domRef.current), B, j, oe, me;
        te && (j = Number(te.dataset.colIndex), me = Number(te.dataset.rowIndex), B = e.getComputed().computedVisibleColumns[j].id, oe = e.dataSourceApi.getRowInfoArray()[me].id);
        let pe = {
            columnId: B,
            colIndex: j,
            rowId: oe,
            rowIndex: me,
            event: z,
            target: te ?? z.target
        };
        te && L.cellContextMenu(pe), L.contextMenu(pe);
    }, []), { renderCell: _, renderDetailRow: D } = $88ab1a78ec8ca4b4$var$$g({
        imperativeApi: i,
        getComputed: r,
        domRef: I,
        bodySize: b,
        computed: R
    }), { autoFocus: O, tabIndex: F } = T ?? {};
    $88ab1a78ec8ca4b4$var$Ug();
    let W = (0, $acw62.useMemo)(()=>{
        if (!S) return;
        let z = [];
        return w && (z = z.concat(w)), o.rowHoverClassName && (z = z.concat(o.rowHoverClassName)), $88ab1a78ec8ca4b4$var$Un.rowHoverClassName && (z = z.concat($88ab1a78ec8ca4b4$var$Un.rowHoverClassName)), $88ab1a78ec8ca4b4$var$sI(z);
    }, [
        S,
        w,
        o.rowHoverClassName,
        $88ab1a78ec8ca4b4$var$Un.rowHoverClassName
    ]);
    return $acw62.createElement($88ab1a78ec8ca4b4$var$Zg, {
        onContextMenu: P
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$yf, {
        forceRerenderTimestamp: n.forceBodyRerenderTimestamp,
        debugId: s,
        tabIndex: F ?? 0,
        autoFocus: O ?? void 0,
        activeRowIndex: n.ready && c === "row" ? u : null,
        activeCellIndex: n.ready && c === "cell" && !n.columnReorderDragColumnId ? h : null,
        scrollStopDelay: f,
        renderer: a,
        wrapRowsHorizontally: C,
        onRenderUpdater: l,
        brain: p,
        activeCellRowHeight: A,
        renderCell: _,
        renderDetailRow: y ? D : void 0,
        cellHoverClassNames: W,
        scrollerDOMRef: m,
        scrollVarHostRef: I
    }), $acw62.createElement(v, {
        visible: E
    }, d));
}
$88ab1a78ec8ca4b4$var$Un.rowHoverClassName = $88ab1a78ec8ca4b4$var$lI;
var $88ab1a78ec8ca4b4$export$152f516c829750a = $88ab1a78ec8ca4b4$var$Fe.rootClassName, { ManagedComponentContextProvider: $88ab1a78ec8ca4b4$var$cI } = $88ab1a78ec8ca4b4$export$c6a0e0787a01a4e5({
    initSetupState: $88ab1a78ec8ca4b4$var$om,
    forwardProps: $88ab1a78ec8ca4b4$var$rm,
    mapPropsToState: $88ab1a78ec8ca4b4$var$sm,
    cleanup: $88ab1a78ec8ca4b4$var$im,
    allowedControlledPropOverrides: {
        rowHeight: !0,
        columnHeaderHeight: !0
    },
    mappedCallbacks: $88ab1a78ec8ca4b4$var$lm(),
    getParentState: ()=>$88ab1a78ec8ca4b4$export$c5a52c32d527b09b(),
    debugName: (o)=>$88ab1a78ec8ca4b4$var$gn(o.debugId, $88ab1a78ec8ca4b4$var$aa)
}), $88ab1a78ec8ca4b4$export$d60feede32fc9d27 = $acw62.memo(function() {
    let e = $88ab1a78ec8ca4b4$var$Q(), t = $88ab1a78ec8ca4b4$var$Ve(), { state: n, api: r, children: i } = e, { componentState: { dataArray: a }, getState: l, componentActions: s } = $88ab1a78ec8ca4b4$var$_e(), { domRef: c, portalDOMRef: u, onRowHeightCSSVarChange: d, onFlashingDurationCSSVarChange: f, onRowDetailHeightCSSVarChange: p, onColumnHeaderHeightCSSVarChange: m, rowHeightCSSVar: g, rowDetailHeightCSSVar: b, columnHeaderHeightCSSVar: h, scrollStopDelay: y, brain: S, activeRowIndex: C, activeCellIndex: T } = n, { licenseKey: I } = n;
    !I && $88ab1a78ec8ca4b4$export$6f97e3045480ac8c.licenseKey && (I = $88ab1a78ec8ca4b4$export$6f97e3045480ac8c.licenseKey), $88ab1a78ec8ca4b4$var$Rm(C, a.length, r), $88ab1a78ec8ca4b4$var$wm(T, a.length, r);
    let { onKeyDown: w } = $88ab1a78ec8ca4b4$var$Bm();
    $acw62.useEffect(()=>{
        let W = l(), z = $88ab1a78ec8ca4b4$export$61fc7d43ac8f84b0((L)=>{
            W.notifyRenderRangeChange({
                renderStartIndex: L[0],
                renderEndIndex: L[1]
            });
        }, {
            wait: y
        });
        return S.onVerticalRenderRangeChange(z);
    }, [
        S,
        y
    ]);
    let v = $88ab1a78ec8ca4b4$var$Tm(I), { autoFocus: R, tabIndex: x, ...M } = n.domProps ?? {}, A = $88ab1a78ec8ca4b4$var$Nu(M);
    $acw62.useEffect(()=>{
        S.setScrollStopDelay(y), s.scrollStopDelayUpdatedByTable = y;
    }, [
        y
    ]), $88ab1a78ec8ca4b4$var$qp(), $88ab1a78ec8ca4b4$var$Pg(), $88ab1a78ec8ca4b4$var$gg();
    let { menuPortal: E } = $88ab1a78ec8ca4b4$var$fg(), { menuPortal: P } = $88ab1a78ec8ca4b4$var$Ig(), { menuPortal: _ } = $88ab1a78ec8ca4b4$var$vg(), { menuPortal: D } = $88ab1a78ec8ca4b4$var$Tg();
    $acw62.useEffect(()=>{
        typeof globalThis.__DO_NOT_USE_UNLESS_YOU_KNOW_WHAT_YOURE_DOING_IS_READY == "function" && globalThis.__DO_NOT_USE_UNLESS_YOU_KNOW_WHAT_YOURE_DOING_IS_READY(n.id, n.ready, e.api, e);
    }, [
        n.ready,
        e.api
    ]);
    let O = $88ab1a78ec8ca4b4$var$Ag();
    $acw62.useEffect(()=>{
        t && (u.current = t.getMasterState().portalDOMRef.current);
    }, []);
    let F = i ?? $acw62.createElement($acw62.Fragment, null, $acw62.createElement($88ab1a78ec8ca4b4$var$Hl, null), $acw62.createElement($88ab1a78ec8ca4b4$var$Un, null));
    return $acw62.createElement("div", {
        "data-debug-id": O,
        onKeyDown: w,
        ref: c,
        ...A
    }, F, $acw62.createElement("div", {
        ref: u,
        className: $88ab1a78ec8ca4b4$var$X(`${$88ab1a78ec8ca4b4$var$rt}Portal`, $88ab1a78ec8ca4b4$var$Cc[1e7], $88ab1a78ec8ca4b4$var$Or.absolute, $88ab1a78ec8ca4b4$var$yc[0], $88ab1a78ec8ca4b4$var$gc[0])
    }, E, P, _, D), g ? $acw62.createElement($88ab1a78ec8ca4b4$var$Vo, {
        key: "row-height",
        varName: g,
        onChange: d
    }) : null, $acw62.createElement($88ab1a78ec8ca4b4$var$Vo, {
        key: "flashing-duration",
        allowInts: !0,
        varName: $88ab1a78ec8ca4b4$var$se.components.Cell.flashingDuration,
        onChange: f
    }), b ? $acw62.createElement($88ab1a78ec8ca4b4$var$Vo, {
        key: "row-detail-height",
        varName: b,
        onChange: p
    }) : null, h ? $acw62.createElement($88ab1a78ec8ca4b4$var$Vo, {
        key: "column-header-height",
        varName: h,
        onChange: m
    }) : null, v ? null : $acw62.createElement($88ab1a78ec8ca4b4$var$Hf, null), $acw62.createElement($88ab1a78ec8ca4b4$var$mg, null));
});
function $88ab1a78ec8ca4b4$var$dI({ children: o }) {
    let { componentActions: e, componentState: t } = $88ab1a78ec8ca4b4$export$2e1456d250441a8(), { scrollerDOMRef: n, scrollTopKey: r } = t, i = $88ab1a78ec8ca4b4$var$gm(), a = $88ab1a78ec8ca4b4$var$Me(i), l = $88ab1a78ec8ca4b4$var$Me(t), s = $88ab1a78ec8ca4b4$var$Ve(), { getState: c, componentActions: u, getDataSourceMasterContext: d, api: f } = $88ab1a78ec8ca4b4$var$_e(), [p] = $acw62.useState(()=>$88ab1a78ec8ca4b4$var$Up({
            getComputed: a,
            getState: l,
            getDataSourceState: c,
            getDataSourceMasterContext: d,
            dataSourceApi: f,
            actions: e,
            dataSourceActions: u
        })), m = {
        actions: e,
        state: t,
        computed: i,
        dataSourceActions: u,
        getDataSourceMasterContext: d,
        getDataSourceState: c,
        getComputed: a,
        getState: l,
        api: p,
        dataSourceApi: f,
        children: o
    };
    $88ab1a78ec8ca4b4$var$Dr(n, (b)=>{
        let h = {
            width: b.width,
            height: b.height
        };
        e.bodySize = h;
    }, {
        earlyAttach: !0,
        debounce: 50
    }), $acw62.useEffect(()=>{
        n.current && (n.current.scrollTop = 0);
    }, [
        r,
        n
    ]);
    let g = $88ab1a78ec8ca4b4$var$Qn();
    return $acw62.createElement(g.Provider, {
        value: m
    }, $acw62.createElement($88ab1a78ec8ca4b4$export$d60feede32fc9d27, null));
}
var $88ab1a78ec8ca4b4$var$fI = 40, $88ab1a78ec8ca4b4$var$pI = $88ab1a78ec8ca4b4$var$xm($88ab1a78ec8ca4b4$var$bu), $88ab1a78ec8ca4b4$export$6f97e3045480ac8c = function(o) {
    return $acw62.createElement($88ab1a78ec8ca4b4$var$cI, {
        repeatWrappedGroupRows: !!o.wrapRowsHorizontally,
        rowHeight: $88ab1a78ec8ca4b4$var$fI,
        columnHeaderHeight: $88ab1a78ec8ca4b4$var$pI,
        ...o
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$fl, null, $acw62.createElement($88ab1a78ec8ca4b4$var$dI, {
        children: o.children
    })));
};
$88ab1a78ec8ca4b4$export$6f97e3045480ac8c.Header = $88ab1a78ec8ca4b4$var$Hl;
$88ab1a78ec8ca4b4$export$6f97e3045480ac8c.Body = $88ab1a78ec8ca4b4$var$Un;
$88ab1a78ec8ca4b4$export$6f97e3045480ac8c.HScrollSyncContent = $88ab1a78ec8ca4b4$var$xg;
$88ab1a78ec8ca4b4$export$6f97e3045480ac8c.Footer = ()=>$acw62.createElement($88ab1a78ec8ca4b4$var$Ic, null);
$88ab1a78ec8ca4b4$export$6f97e3045480ac8c.GroupingToolbar = $88ab1a78ec8ca4b4$var$Vg;
function $88ab1a78ec8ca4b4$export$d2f9abb45e45a117(o) {
    let { DataSource: e } = $88ab1a78ec8ca4b4$export$ffce2aa747f4000f({
        nodesKey: "children",
        ...o
    });
    return $acw62.createElement(e, null, o.children ?? null);
}
function $88ab1a78ec8ca4b4$export$8db26091c27bd60d(o) {
    return $acw62.createElement($88ab1a78ec8ca4b4$export$6f97e3045480ac8c, {
        ...o
    });
}
var $88ab1a78ec8ca4b4$export$aa6afc0444c40e88 = (o)=>(t, { unfilteredTreePaths: n, treeSelectionState: r, prevTreeSelectionState: i, lastUpdatedNodeInfo: a })=>{
        let l = new $88ab1a78ec8ca4b4$export$3feed6aa923fae79(i, {
            treePaths: n
        });
        r.forEachLeafNodePath((u, { selected: d })=>{
            l.setNodeSelection(u, d);
        }), a && r.forEachLeafNodePath((u)=>{
            l.setNodeSelection(u, a.selected);
        }, a.nodePath);
        let c = {
            defaultSelection: !1,
            selectedPaths: l.getSelectedLeafNodePaths()
        };
        o(c);
    };
var $88ab1a78ec8ca4b4$var$da = class {
    constructor(e){
        this.state = "idle";
        this.result = void 0;
        this.error = void 0;
        this.doneAt = 0;
        this.pendingPromise = void 0;
        this.debugName = "";
        this.fetch = async (e, ...t)=>{
            this.state = "loading";
            let n = ()=>{};
            try {
                this.logger(`Fetching query ${this.debugName}...`), this.pendingPromise = new Promise((r)=>{
                    n = r;
                }), this.result = await e(...t), this.state = "success";
            } catch (r) {
                this.result = void 0, this.error = r, this.state = "error";
            }
            return this.doneAt = Date.now(), this.pendingPromise = void 0, n(this), this.logger(`Fetched query ${this.debugName}. State: ${this.state}.`), this.getDoneSnapshot();
        };
        this.getCurrentSnapshot = ()=>{
            let e = {
                state: this.state,
                result: this.result,
                doneAt: this.doneAt,
                error: this.error,
                done: this.isDone()
            };
            return e.done || (e.promise = this.pendingPromise), e;
        };
        this.getDoneSnapshot = async ()=>{
            if (this.state === "idle") throw new Error("DataQuery is still idle");
            return this.pendingPromise && await this.pendingPromise, {
                state: this.state,
                result: this.result,
                error: this.error,
                done: this.isDone(),
                doneAt: this.doneAt
            };
        };
        this.getResult = ()=>{
            if (!this.isDone()) throw new Error("DataQuery is not done yet");
            return this.result;
        };
        this.isDone = ()=>this.state === "success" || this.state === "error";
        this.isSuccess = ()=>this.state === "success";
        this.debugName = e || "", this.logger = $88ab1a78ec8ca4b4$export$1c9f709888824e05(`IT:${e}:DataQuery`);
    }
};
function $88ab1a78ec8ca4b4$export$4d4556cf4eebfd6(o) {
    if (Array.isArray(o)) return o.map($88ab1a78ec8ca4b4$export$4d4556cf4eebfd6);
    if (typeof o == "object") {
        if (o === null) return o;
        let e = o, t = Object.keys(e).sort((r, i)=>r.localeCompare(i)), n = {};
        return t.forEach((r)=>{
            let i = e[r];
            i !== void 0 && (n[r] = $88ab1a78ec8ca4b4$export$4d4556cf4eebfd6(i));
        }), JSON.stringify(n);
    }
    return o instanceof Date ? o.toISOString() : o;
}
var $88ab1a78ec8ca4b4$var$tn = class tn {
    constructor(e){
        this.queryCache = new $88ab1a78ec8ca4b4$export$1c737028a0cb2e00;
        this.removeQueryIfErrored = (e, t)=>{
            if (e.getCurrentSnapshot().state !== "success") {
                let n = this.queryCache.get(t);
                if (e === n) return this.queryCache.delete(t), !0;
            }
            return !1;
        };
        this.fireQuery = (e)=>{
            let t = $88ab1a78ec8ca4b4$export$4d4556cf4eebfd6(e.key), n = this.options.cache ? this.queryCache.get(t) : null;
            if (n != null) {
                let i = n.getCurrentSnapshot();
                if (i.state === "success") return {
                    query: n,
                    fromCache: !0
                };
                if (i.state === "loading") return {
                    query: n,
                    fromCache: !0
                };
                i.state === "error" && this.removeQueryIfErrored(n, t);
            }
            let r = new $88ab1a78ec8ca4b4$var$da(`${this.name}:${e.name}`);
            return this.queryCache.set(t, r), r.fetch(e.fn, e.key), r.getCurrentSnapshot().promise?.then(()=>{
                this.removeQueryIfErrored(r, t);
            }), {
                query: r,
                fromCache: !1
            };
        };
        this.query = (e)=>this.fireQuery(e).query.getCurrentSnapshot();
        this.awaitQuery = async (e)=>{
            let { query: t, fromCache: n } = this.fireQuery(e), r = t.getCurrentSnapshot();
            return r.promise && (r = await t.getDoneSnapshot(), r.state === "error" && n) ? await this.fireQuery(e).query.getDoneSnapshot() : r;
        };
        this.isQueryInProgress = (e)=>{
            let t = $88ab1a78ec8ca4b4$export$4d4556cf4eebfd6(e);
            return this.queryCache.get(t)?.getCurrentSnapshot().done ?? !1;
        };
        this.hasQueryForKey = (e)=>{
            let t = $88ab1a78ec8ca4b4$export$4d4556cf4eebfd6(e);
            return this.queryCache.has(t);
        };
        this.discardQueryForKey = (e)=>{
            let t = $88ab1a78ec8ca4b4$export$4d4556cf4eebfd6(e);
            this.queryCache.delete(t);
        };
        if (this.options = e, tn.clients.has(e.name)) {
            let t = `There's already a DataClient with name "${e.name}". Specify a different name for the client`;
            throw new Error(t);
        }
        tn.clients.set(e.name, this), this.name = e.name;
    }
    static destroy(e) {
        let t = tn.clients.get(e);
        t && t.destroy();
    }
    static destroyAll() {
        tn.clients.forEach((e)=>{
            tn.destroy(e.name);
        });
    }
    destroy() {
        tn.clients.delete(this.options.name);
    }
};
$88ab1a78ec8ca4b4$var$tn.clients = new Map;
var $88ab1a78ec8ca4b4$export$3dfb1772e1955e60 = $88ab1a78ec8ca4b4$var$tn;
var $88ab1a78ec8ca4b4$var$hI = {
    key: "*",
    when: (o)=>{
        let { activeCellIndex: e } = o.getState();
        if (e) {
            let [t, n] = e, r = o.api.getColumnAtIndex(n);
            return r ? o.api.isCellEditable({
                rowIndex: t,
                columnId: r.id
            }) : !1;
        }
        return !1;
    },
    handler: (o, e)=>{
        let { key: t } = e;
        if (t != "Escape" && t.length === 1) {
            let { activeCellIndex: n } = o.getState();
            if (n) {
                let [r, i] = n, a = o.api.getColumnAtIndex(i);
                if (!a) return;
                requestAnimationFrame(()=>{
                    o.api.startEdit({
                        rowIndex: r,
                        value: t,
                        columnId: a.id
                    });
                });
            }
        }
    }
}, $88ab1a78ec8ca4b4$export$fba2b28e0cef5a73 = {
    instantEdit: $88ab1a78ec8ca4b4$var$hI
};
function $88ab1a78ec8ca4b4$export$913cb0f5f9aa7d2a(o, e) {
    let { set: t, delete: n, clear: r } = o;
    return e.set && (o.set = (i, a)=>(t.call(o, i, a), e.set(i, a), o)), e.delete && (o.delete = (i)=>{
        let a = n.call(o, i);
        return e.delete(i), a;
    }), (e.clear || e.beforeClear) && (o.clear = ()=>{
        e.beforeClear && e.beforeClear(o);
        let i = r.call(o);
        return e.clear && e.clear(), i;
    }), ()=>{
        t && (o.set = t), n && (o.delete = n), r && (o.clear = r);
    };
}
var $88ab1a78ec8ca4b4$var$fa = class fa {
    constructor(e, t){
        this.orderRefs = [];
        if (typeof e == "number") this.maxSize = e, this.currentSet = new Set;
        else if (this.maxSize = t ?? fa.DEFAULT_SIZE, e) {
            let n = Array.from(e);
            this.maxSize < n.length && n.slice(n.length - this.maxSize), this.currentSet = new Set, n.forEach((r)=>{
                this.add(r);
            });
        } else this.currentSet = new Set;
    }
    values() {
        return this.currentSet.values();
    }
    get size() {
        return this.currentSet.size;
    }
    delete(e) {
        return this.currentSet.has(e) ? (this.currentSet.delete(e), this.orderRefs = this.orderRefs.filter((t)=>t !== e), !0) : !1;
    }
    has(e) {
        return this.currentSet.has(e);
    }
    add(e) {
        if (this.currentSet.has(e)) return this;
        if (this.maxSize - this.currentSet.size <= 0) {
            let [n] = this.orderRefs.splice(0, 1);
            n && this.currentSet.delete(n);
        }
        return this.orderRefs.push(e), this.currentSet.add(e), this;
    }
};
$88ab1a78ec8ca4b4$var$fa.DEFAULT_SIZE = 10;
var $88ab1a78ec8ca4b4$export$c06751430747f62f = $88ab1a78ec8ca4b4$var$fa;
var $88ab1a78ec8ca4b4$var$pa = class pa {
    constructor(e, t){
        this.orderRefs = [];
        if (typeof e == "number") this.maxSize = e, this.currentSet = new Set;
        else if (this.maxSize = t ?? pa.DEFAULT_SIZE, e) {
            let n = Array.from(e);
            this.maxSize < n.length && n.slice(n.length - this.maxSize), this.currentSet = new Set, n.forEach((r)=>{
                this.add(r);
            });
        } else this.currentSet = new Set;
    }
    values() {
        return this.currentSet.values();
    }
    get size() {
        return this.currentSet.size;
    }
    delete(e) {
        return this.currentSet.has(e) ? (this.currentSet.delete(e), this.orderRefs = this.orderRefs.filter((t)=>t.deref() !== e), !0) : !1;
    }
    has(e) {
        return this.currentSet.has(e);
    }
    add(e) {
        if (this.currentSet.has(e)) return this;
        if (this.maxSize - this.currentSet.size <= 0) {
            let [n] = this.orderRefs.splice(0, 1), r = n.deref();
            r && this.currentSet.delete(r);
        }
        return this.orderRefs.push(new WeakRef(e)), this.currentSet.add(e), this;
    }
};
$88ab1a78ec8ca4b4$var$pa.DEFAULT_SIZE = 10;
var $88ab1a78ec8ca4b4$export$5425789e4ff48f98 = $88ab1a78ec8ca4b4$var$pa;
var $88ab1a78ec8ca4b4$var$SI = (o, e)=>o.every((t, n)=>t === e[n]), $88ab1a78ec8ca4b4$export$5a542ee480fe5227 = (o, e)=>{
    let t = (0, $acw62.useRef)(e), n = $88ab1a78ec8ca4b4$var$SI(e, t.current), r = (0, $acw62.useRef)(!0);
    t.current = e;
    let i = (0, $acw62.useRef)([
        "same"
    ]), a = n ? [
        Date.now()
    ] : i.current;
    i.current = a;
    let l = (0, $acw62.useRef)(o);
    l.current = o, (0, $acw62.useEffect)(()=>{
        if (r.current) {
            r.current = !1;
            return;
        }
        return l.current();
    }, a);
};
var $88ab1a78ec8ca4b4$var$rh = (o, e, t)=>o.every((n, r)=>t ? t(n, e[r]) : n === e[r]), $88ab1a78ec8ca4b4$export$edace375a4201ce1 = (o, e)=>{
    let { same: t, different: n, compare: r } = e, i = (0, $acw62.useRef)(t), a = (0, $acw62.useRef)(n), l = $88ab1a78ec8ca4b4$var$rh(t, i.current, r), s = !$88ab1a78ec8ca4b4$var$rh(n, a.current, r), c = (0, $acw62.useRef)(!0);
    i.current = t, a.current = n;
    let u = (0, $acw62.useRef)([
        "same"
    ]), d = l && s ? [
        Date.now()
    ] : u.current;
    u.current = d;
    let f = (0, $acw62.useRef)(o);
    f.current = o, l && s && (c.current = !1), (0, $acw62.useEffect)(()=>{
        if (!c.current) return f.current();
    }, d);
};
var $88ab1a78ec8ca4b4$var$ih = $88ab1a78ec8ca4b4$var$Y($88ab1a78ec8ca4b4$var$U.currentFlashingDuration), $88ab1a78ec8ca4b4$var$II = ({ children: o })=>$acw62.createElement($acw62.Fragment, null, o), $88ab1a78ec8ca4b4$var$ah = 1e3, $88ab1a78ec8ca4b4$var$lh = {
    up: $88ab1a78ec8ca4b4$var$Zr({
        direction: "up"
    }).split(" "),
    down: $88ab1a78ec8ca4b4$var$Zr({
        direction: "down"
    }).split(" "),
    neutral: $88ab1a78ec8ca4b4$var$Zr({
        direction: "neutral"
    }).split(" ")
}, $88ab1a78ec8ca4b4$export$9dc80522d023cc2c = (o = {})=>{
    let { flashDuration: e, flashClassName: t, render: n = $88ab1a78ec8ca4b4$var$II } = o;
    return $acw62.forwardRef((i, a)=>{
        let l = $88ab1a78ec8ca4b4$export$966ffef3d3cf676c(), { state: { flashingDurationCSSVarValue: s } } = $88ab1a78ec8ca4b4$var$Q(), c = typeof s == "number" ? s ?? e ?? $88ab1a78ec8ca4b4$var$ah : e ?? $88ab1a78ec8ca4b4$var$ah, { domRef: u, value: d, column: f, rowInfo: p, htmlElementRef: m } = l, g = p.id, b = f.id, h = $acw62.useRef(!0), y = $acw62.useRef(d), S = h.current ? null : y.current;
        h.current = !1;
        let C = $acw62.useRef(void 0), T = $acw62.useRef(void 0), I = $acw62.useRef(void 0);
        return $88ab1a78ec8ca4b4$export$edace375a4201ce1(()=>{
            if (d === y.current) return;
            let w = ()=>{
                let M = m.current;
                if (C.current && (clearTimeout(C.current), C.current = void 0), I.current && (clearTimeout(I.current), I.current = void 0), T.current && M) {
                    let A = T.current, E = $88ab1a78ec8ca4b4$var$lh[A];
                    M.classList.remove(...t ? [
                        t,
                        ...E
                    ] : E), M.style.removeProperty($88ab1a78ec8ca4b4$var$ih), T.current = void 0;
                }
            };
            y.current = d;
            let v = m.current;
            if (!v) return;
            w();
            let R = typeof d == "number" ? d > S ? "up" : "down" : "neutral", x = $88ab1a78ec8ca4b4$var$lh[R];
            return v.style.setProperty($88ab1a78ec8ca4b4$var$ih, `${c}`), v.classList.add(...t ? [
                t,
                ...x
            ] : x), T.current = R, C.current = setTimeout(w, c), w;
        }, {
            same: [
                b,
                g
            ],
            different: [
                d
            ]
        }), $acw62.createElement("div", {
            ref: u,
            ...i,
            className: $88ab1a78ec8ca4b4$var$X(i.className)
        }, n({
            children: i.children,
            oldValue: S
        }));
    });
}, $88ab1a78ec8ca4b4$export$f0e354735bbbc92 = $88ab1a78ec8ca4b4$export$9dc80522d023cc2c();
function $88ab1a78ec8ca4b4$export$d9b37ccc472d33cc(o) {
    let [e, t] = $acw62.useState(null);
    return (0, $acw62.useEffect)(()=>{
        let { debugTarget: n } = o, r = setInterval(()=>{
            if (globalThis.INFINITE && globalThis.INFINITE[n]) {
                let i = globalThis.INFINITE[n].getState;
                clearInterval(r), t(()=>i);
            }
        }, 100);
        return ()=>{
            clearInterval(r);
        };
    }, [
        o.debugTarget
    ]), typeof e == "function" ? $acw62.createElement($88ab1a78ec8ca4b4$var$dh.Provider, {
        value: {
            getState: e
        }
    }, $acw62.createElement($88ab1a78ec8ca4b4$var$PI, null)) : null;
}
var $88ab1a78ec8ca4b4$var$dh = $acw62.createContext({
    getState: ()=>null
});
function $88ab1a78ec8ca4b4$var$PI() {
    let o = $acw62.useContext($88ab1a78ec8ca4b4$var$dh), { getState: e } = o, [, t] = $88ab1a78ec8ca4b4$var$Ct(), n = e().renderer.cellManager;
    (0, $acw62.useEffect)(()=>{
        let s = $88ab1a78ec8ca4b4$export$61fc7d43ac8f84b0(()=>{
            console.log("rerender"), t();
        }, {
            wait: 500
        });
        return n.onCellAttachmentChange(s);
    }, [
        n,
        t
    ]);
    let r = n.getRowsWithCells(), i = n.getColumnsWithCells(), a = (0, $acw62.useRef)(null), l = (0, $acw62.useRef)(null);
    return $acw62.createElement("div", {
        style: {
            overflow: "auto"
        }
    }, (0, $1u0KT.createPortal)($acw62.createElement("div", {
        ref: a,
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "0px",
            height: "0px",
            pointerEvents: "none",
            background: "rgba(255, 0, 0, 0.5)",
            opacity: "0"
        }
    }), document.body), $acw62.createElement("table", {
        style: {
            borderCollapse: "collapse"
        }
    }, $acw62.createElement("thead", null, $acw62.createElement("tr", null, i.map((s)=>$acw62.createElement("th", {
            key: s,
            "data-col-index": s
        }, s)))), $acw62.createElement("tbody", null, r.map((s)=>$acw62.createElement("tr", {
            key: s,
            "data-row-index": s
        }, i.map((c)=>$acw62.createElement("td", {
                key: c,
                style: {
                    padding: 5,
                    border: "1px solid gray",
                    background: n.getCellAt([
                        s,
                        c
                    ])?.getNode() ? "rgba(0, 255, 0, 0.3)" : "rgba(255, 0, 0, 0.3)"
                },
                "data-col-index": c
            }, $acw62.createElement("button", {
                onClick: ()=>{
                    let u = n.getCellAt([
                        s,
                        c
                    ])?.getElement();
                    if (!u) return;
                    let d = u.getBoundingClientRect();
                    a.current.style.top = `${d.top}px`, a.current.style.left = `${d.left}px`, a.current.style.width = `${d.width}px`, a.current.style.height = `${d.height}px`, a.current.style.opacity = "0.5", a.current.style.transition = "opacity 0.5s", l.current && clearTimeout(l.current), l.current = setTimeout(()=>{
                        a.current.style.opacity = "0", l.current = null;
                    }, 2e3), console.log(u);
                },
                style: {
                    cursor: "pointer"
                }
            }, "(", s, ",", c, ")"))))))));
}
var $88ab1a78ec8ca4b4$export$9b5ac10f59f76296 = {
    CheckBox: $88ab1a78ec8ca4b4$var$Wt,
    LoadMask: $88ab1a78ec8ca4b4$var$ua,
    MenuIcon: $88ab1a78ec8ca4b4$var$Qo,
    StringFilterEditor: $88ab1a78ec8ca4b4$var$no,
    NumberFilterEditor: $88ab1a78ec8ca4b4$var$Kr
};
 //!collapsed || lazyLoad;


const $10f858c943b30cc8$var$performanceTime = (previousTime)=>{
    const now = performance.now();
    return Math.round(previousTime ? now - previousTime : now);
};
const $10f858c943b30cc8$var$errorOnceFlags = {};
const $10f858c943b30cc8$export$45c997b35cb132f6 = (message)=>{
    if ($10f858c943b30cc8$var$errorOnceFlags[message]) return;
    console.error(message);
    $10f858c943b30cc8$var$errorOnceFlags[message] = true;
};
class $10f858c943b30cc8$export$a58502b374804b0f {
    adaptableId;
    debugger;
    infoLogger;
    successLogger;
    warnLogger;
    errorLogger;
    perfLogger;
    // use static loggers whenever access to AdaptableLogger instance is not feasible
    static consoleErrorBase(message, ...optionalParams) {
        if (optionalParams?.length) console.error(message, optionalParams);
        else console.error(message);
    }
    static consoleWarnBase(message, ...optionalParams) {
        if (optionalParams?.length) console.warn(message, optionalParams);
        else console.warn(message);
    }
    static consoleLogBase(message, ...optionalParams) {
        if (optionalParams?.length) console.log(message, optionalParams);
        else console.log(message);
    }
    constructor(adaptableId){
        this.adaptableId = adaptableId;
        this.debugger = (0, $88ab1a78ec8ca4b4$export$1c9f709888824e05)(`Adaptable:${adaptableId}`);
        this.infoLogger = this.debugger.extend(`info`);
        this.infoLogger.logFn = console.info.bind(console);
        this.successLogger = this.debugger.extend(`success`);
        this.successLogger.logFn = console.log.bind(console);
        this.warnLogger = this.debugger.extend(`warn`);
        this.warnLogger.logFn = console.warn.bind(console);
        this.errorLogger = this.debugger.extend(`error`);
        this.errorLogger.logFn = console.error.bind(console);
        this.perfLogger = this.debugger.extend(`perf`);
        this.perfLogger.logFn = console.info.bind(console);
    }
    beginPerf(sectionName) {
        this.perfLogger(`[BEGIN] - ${sectionName}`);
        const startTime = $10f858c943b30cc8$var$performanceTime();
        return {
            end: (additionalComment)=>{
                this.perfLogger(`[END]   - ${sectionName} ${additionalComment ? `(${additionalComment})` : ''} :: [delta +${$10f858c943b30cc8$var$performanceTime(startTime)}ms]`);
            }
        };
    }
    info(message, ...optionalParams) {
        if (optionalParams?.length) this.infoLogger(message, ...optionalParams);
        else this.infoLogger(message);
    }
    success(message, ...optionalParams) {
        if (optionalParams?.length) this.successLogger(message, ...optionalParams);
        else this.successLogger(message);
    }
    warn(message, ...optionalParams) {
        if (optionalParams?.length) this.warnLogger(message, ...optionalParams);
        else this.warnLogger(message);
    }
    error(message, ...optionalParams) {
        if (optionalParams?.length) this.errorLogger(message, ...optionalParams);
        else this.errorLogger(message);
    }
    consoleLogByMessageType(message, messageType, ...optionalParams) {
        message = `AdapTable:${this.adaptableId} ${messageType}: ${message}`;
        switch(messageType){
            case 'Info':
                console.info(message, optionalParams);
                break;
            case 'Success':
                console.log(message, optionalParams);
                break;
            case 'Warning':
                console.warn(message, optionalParams);
                break;
            case 'Error':
                console.error(message, optionalParams);
                break;
        }
    }
    consoleInfo(message, ...optionalParams) {
        message = `AdapTable:${this.adaptableId}: ${message}`;
        if (optionalParams?.length) console.info(message, optionalParams);
        else console.info(message);
    }
    consoleLog(message, ...optionalParams) {
        message = `AdapTable:${this.adaptableId}: ${message}`;
        if (optionalParams?.length) console.log(message, optionalParams);
        else console.log(message);
    }
    consoleWarn(message, ...optionalParams) {
        message = `AdapTable:${this.adaptableId}: ${message}`;
        if (optionalParams?.length) console.warn(message, optionalParams);
        else console.warn(message);
    }
    consoleError(message, ...optionalParams) {
        message = `AdapTable:${this.adaptableId}: ${message}`;
        if (optionalParams?.length) console.error(message, optionalParams);
        else console.error(message);
    }
}
// change the default colors a bit to remove
// the dark blues that are hard to read on my monitor
(0, $88ab1a78ec8ca4b4$export$1c9f709888824e05).colors = [
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];


/**
 * Creates a throttled function that only invokes func at most once per
 * every wait milliseconds. The throttled function comes with a cancel
 * method to cancel delayed func invocations and a flush method to
 * immediately invoke them.
 *
 * Supports options: { leading, trailing }
 * Drop-in replacement for lodash/throttle.
 *
 * Implemented using debounce with maxWait (same approach as lodash).
 */ /**
 * Creates a debounced function that delays invoking func until after wait
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a cancel method to cancel
 * delayed func invocations and a flush method to immediately invoke them.
 *
 * Supports options: { leading, trailing, maxWait }
 * Drop-in replacement for lodash/debounce.
 */ function $c34d1d35432b7498$export$2e2bcd8739ae039(func, wait = 0, options) {
    let lastArgs;
    let lastThis;
    let result;
    let timerId;
    let lastCallTime;
    let lastInvokeTime = 0;
    const leading = options?.leading ?? false;
    const trailing = options?.trailing ?? true;
    const maxWait = options?.maxWait;
    const hasMaxWait = maxWait !== undefined;
    const maxing = hasMaxWait;
    function invokeFunc(time) {
        const args = lastArgs;
        const thisArg = lastThis;
        lastArgs = undefined;
        lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function startTimer(pendingFunc, waitMs) {
        timerId = setTimeout(pendingFunc, waitMs);
    }
    function cancelTimer() {
        if (timerId !== undefined) clearTimeout(timerId);
        timerId = undefined;
    }
    function remainingWait(time) {
        const timeSinceLastCall = time - (lastCallTime ?? 0);
        const timeSinceLastInvoke = time - lastInvokeTime;
        const timeWaiting = wait - timeSinceLastCall;
        return maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        const timeSinceLastCall = time - (lastCallTime ?? 0);
        const timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        const time = Date.now();
        if (shouldInvoke(time)) {
            trailingEdge(time);
            return;
        }
        // Restart the timer
        startTimer(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        if (trailing && lastArgs) invokeFunc(time);
        else {
            lastArgs = undefined;
            lastThis = undefined;
        }
    }
    function leadingEdge(time) {
        lastInvokeTime = time;
        startTimer(timerExpired, wait);
        if (leading) invokeFunc(time);
    }
    function debounced(...args) {
        const time = Date.now();
        const isInvoking = shouldInvoke(time);
        lastArgs = args;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) {
                leadingEdge(time);
                return result;
            }
            if (maxing) {
                // Handle invocations in a tight loop with maxWait
                cancelTimer();
                startTimer(timerExpired, wait);
                invokeFunc(time);
                return result;
            }
        }
        if (timerId === undefined) startTimer(timerExpired, wait);
        return result;
    }
    debounced.cancel = function cancel() {
        cancelTimer();
        lastInvokeTime = 0;
        lastArgs = undefined;
        lastCallTime = undefined;
        lastThis = undefined;
    };
    debounced.flush = function flush() {
        if (timerId === undefined) return result;
        trailingEdge(Date.now());
        return result;
    };
    return debounced;
}


function $3a4c9a3b92c4503b$export$2e2bcd8739ae039(func, wait = 0, options) {
    return (0, $c34d1d35432b7498$export$2e2bcd8739ae039)(func, wait, {
        leading: options?.leading ?? true,
        trailing: options?.trailing ?? true,
        maxWait: wait
    });
}



// packages/ag-grid-community/src/agStack/events/localEventService.ts
var $437b23f6a393c3bf$export$820da7696a401cdc = class {
    constructor(){
        this.allSyncListeners = /* @__PURE__ */ new Map();
        this.allAsyncListeners = /* @__PURE__ */ new Map();
        this.globalSyncListeners = /* @__PURE__ */ new Set();
        this.globalAsyncListeners = /* @__PURE__ */ new Set();
        this.asyncFunctionsQueue = [];
        this.scheduled = false;
        // using an object performs better than a Set for the number of different events we have
        this.firedEvents = {};
    }
    setFrameworkOverrides(frameworkOverrides) {
        this.frameworkOverrides = frameworkOverrides;
    }
    getListeners(eventType, async, autoCreateListenerCollection) {
        const listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
        let listeners = listenerMap.get(eventType);
        if (!listeners && autoCreateListenerCollection) {
            listeners = /* @__PURE__ */ new Set();
            listenerMap.set(eventType, listeners);
        }
        return listeners;
    }
    noRegisteredListenersExist() {
        return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
    }
    addEventListener(eventType, listener, async = false) {
        this.getListeners(eventType, async, true).add(listener);
    }
    removeEventListener(eventType, listener, async = false) {
        const listeners = this.getListeners(eventType, async, false);
        if (!listeners) return;
        listeners.delete(listener);
        if (listeners.size === 0) (async ? this.allAsyncListeners : this.allSyncListeners).delete(eventType);
    }
    addGlobalListener(listener, async = false) {
        this.getGlobalListeners(async).add(listener);
    }
    removeGlobalListener(listener, async = false) {
        this.getGlobalListeners(async).delete(listener);
    }
    dispatchEvent(event) {
        this.dispatchToListeners(event, true);
        this.dispatchToListeners(event, false);
        this.firedEvents[event.type] = true;
    }
    dispatchEventOnce(event) {
        if (!this.firedEvents[event.type]) this.dispatchEvent(event);
    }
    dispatchToListeners(event, async) {
        const eventType = event.type;
        if (async && "event" in event) {
            const browserEvent = event.event;
            if (browserEvent instanceof Event) event.eventPath = browserEvent.composedPath();
        }
        const { frameworkOverrides: frameworkOverrides } = this;
        const runCallback = (func)=>{
            const callback = frameworkOverrides ? ()=>frameworkOverrides.wrapIncoming(func) : func;
            if (async) this.dispatchAsync(callback);
            else callback();
        };
        const originalListeners = this.getListeners(eventType, async, false);
        if ((originalListeners?.size ?? 0) > 0) {
            const listeners = new Set(originalListeners);
            for (const listener of listeners){
                if (!originalListeners?.has(listener)) continue;
                runCallback(()=>listener(event));
            }
        }
        const globalListenersSrc = this.getGlobalListeners(async);
        if (globalListenersSrc.size > 0) {
            const globalListeners = new Set(globalListenersSrc);
            for (const listener of globalListeners)runCallback(()=>listener(eventType, event));
        }
    }
    getGlobalListeners(async) {
        return async ? this.globalAsyncListeners : this.globalSyncListeners;
    }
    // this gets called inside the grid's thread, for each event that it
    // wants to set async. the grid then batches the events into one setTimeout()
    // because setTimeout() is an expensive operation. ideally we would have
    // each event in it's own setTimeout(), but we batch for performance.
    dispatchAsync(func) {
        this.asyncFunctionsQueue.push(func);
        if (!this.scheduled) {
            const flush = ()=>{
                window.setTimeout(this.flushAsyncQueue.bind(this), 0);
            };
            this.frameworkOverrides ? this.frameworkOverrides.wrapIncoming(flush) : flush();
            this.scheduled = true;
        }
    }
    // this happens in the next VM turn only, and empties the queue of events
    flushAsyncQueue() {
        this.scheduled = false;
        const queueCopy = this.asyncFunctionsQueue.slice();
        this.asyncFunctionsQueue = [];
        for (const func of queueCopy)func();
    }
};
// packages/ag-grid-community/src/agStack/utils/generic.ts
var $437b23f6a393c3bf$export$4978424c4f7b5fc0 = (value)=>{
    if (value == null || value === "") return null;
    return value;
};
function $437b23f6a393c3bf$export$25d27f17d3af40f7(value) {
    return value != null && value !== "";
}
function $437b23f6a393c3bf$export$672d9e47bc342bac(value) {
    return !$437b23f6a393c3bf$export$25d27f17d3af40f7(value);
}
var $437b23f6a393c3bf$export$2a74c29220d5c88e = (value)=>{
    return value != null && typeof value.toString === "function" ? value.toString() : null;
};
var $437b23f6a393c3bf$export$dbc2068cc90f5875 = (val1, val2)=>{
    const val1Json = val1 ? JSON.stringify(val1) : null;
    const val2Json = val2 ? JSON.stringify(val2) : null;
    return val1Json === val2Json;
};
var $437b23f6a393c3bf$export$b0cca9f3c87c8df8 = (valueA, valueB, accentedCompare = false)=>{
    if (valueA == null) return valueB == null ? 0 : -1;
    if (valueB == null) return 1;
    if (typeof valueA === "object" && valueA.toNumber) valueA = valueA.toNumber();
    if (typeof valueB === "object" && valueB.toNumber) valueB = valueB.toNumber();
    if (!accentedCompare || typeof valueA !== "string") {
        if (valueA > valueB) return 1;
        if (valueA < valueB) return -1;
        return 0;
    }
    return valueA.localeCompare(valueB);
};
// packages/ag-grid-community/src/agStack/utils/string.ts
var $437b23f6a393c3bf$var$reUnescapedHtml = /[&<>"']/g;
var $437b23f6a393c3bf$var$HTML_ESCAPES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function $437b23f6a393c3bf$export$a16cfb6652fe466f(toEscape) {
    return toEscape?.toString().toString() ?? null;
}
function $437b23f6a393c3bf$export$3df06b741968da82(toEscape) {
    return $437b23f6a393c3bf$export$a16cfb6652fe466f(toEscape)?.replace($437b23f6a393c3bf$var$reUnescapedHtml, (chr)=>$437b23f6a393c3bf$var$HTML_ESCAPES[chr]) ?? null;
}
function $437b23f6a393c3bf$export$8e19bf64bae2d78a(value) {
    return typeof value === "string" && value.startsWith("=") && value.length > 1;
}
// packages/ag-grid-community/src/agStack/utils/document.ts
function $437b23f6a393c3bf$export$1911dd00c79744c0(beans) {
    return beans.eRootDiv.getRootNode();
}
function $437b23f6a393c3bf$export$16bc98d422315038(beans) {
    return $437b23f6a393c3bf$export$1911dd00c79744c0(beans).activeElement;
}
function $437b23f6a393c3bf$export$f63d0991874c6f81(beans) {
    const { gos: gos, eRootDiv: eRootDiv } = beans;
    let result = null;
    const optionsGetDocument = gos.get("getDocument");
    if (optionsGetDocument && $437b23f6a393c3bf$export$25d27f17d3af40f7(optionsGetDocument)) result = optionsGetDocument();
    else if (eRootDiv) result = eRootDiv.ownerDocument;
    if (result && $437b23f6a393c3bf$export$25d27f17d3af40f7(result)) return result;
    return document;
}
function $437b23f6a393c3bf$export$8ff9eef09a45371f(beans) {
    const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
    return activeEl === null || activeEl === $437b23f6a393c3bf$export$f63d0991874c6f81(beans).body;
}
function $437b23f6a393c3bf$var$_getWindow(beans) {
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    return eDocument.defaultView || window;
}
function $437b23f6a393c3bf$export$50c54e860701cf22(beans) {
    let rootNode = null;
    let targetEl = null;
    try {
        rootNode = $437b23f6a393c3bf$export$f63d0991874c6f81(beans).fullscreenElement;
    } catch (e) {} finally{
        if (!rootNode) rootNode = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        const body = rootNode.querySelector("body");
        if (body) targetEl = body;
        else if (rootNode instanceof ShadowRoot) targetEl = rootNode;
        else if (rootNode instanceof Document) targetEl = rootNode?.documentElement;
        else targetEl = rootNode;
    }
    return targetEl;
}
function $437b23f6a393c3bf$var$_getBodyWidth(beans) {
    const body = $437b23f6a393c3bf$export$50c54e860701cf22(beans);
    return body?.clientWidth ?? (window.innerWidth || -1);
}
function $437b23f6a393c3bf$var$_getBodyHeight(beans) {
    const body = $437b23f6a393c3bf$export$50c54e860701cf22(beans);
    return body?.clientHeight ?? (window.innerHeight || -1);
}
// packages/ag-grid-community/src/agStack/utils/aria.ts
function $437b23f6a393c3bf$var$_toggleAriaAttribute(element, attribute, value) {
    if (value == null || typeof value === "string" && value == "") $437b23f6a393c3bf$var$_removeAriaAttribute(element, attribute);
    else $437b23f6a393c3bf$var$_setAriaAttribute(element, attribute, value);
}
function $437b23f6a393c3bf$var$_setAriaAttribute(element, attribute, value) {
    element.setAttribute($437b23f6a393c3bf$var$_ariaAttributeName(attribute), value.toString());
}
function $437b23f6a393c3bf$var$_removeAriaAttribute(element, attribute) {
    element.removeAttribute($437b23f6a393c3bf$var$_ariaAttributeName(attribute));
}
function $437b23f6a393c3bf$var$_ariaAttributeName(attribute) {
    return `aria-${attribute}`;
}
function $437b23f6a393c3bf$export$f8d01fa01787902(element, role) {
    if (role) element.setAttribute("role", role);
    else element.removeAttribute("role");
}
function $437b23f6a393c3bf$var$_getAriaSortState(directionOrDef) {
    const direction = directionOrDef?.direction;
    if (direction === "asc") return "ascending";
    else if (direction === "desc") return "descending";
    else if (direction === "mixed") return "other";
    return "none";
}
function $437b23f6a393c3bf$export$70c3a20563598672(element) {
    return Number.parseInt(element.getAttribute("aria-posinset"), 10);
}
function $437b23f6a393c3bf$var$_getAriaLabel(element) {
    return element.getAttribute("aria-label");
}
function $437b23f6a393c3bf$export$e81cb0dd07f289f6(element, label) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "label", label);
}
function $437b23f6a393c3bf$export$84233c40c4c74001(element, labelledBy) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "labelledby", labelledBy);
}
function $437b23f6a393c3bf$export$3c2bc877474a7797(element, describedby) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "describedby", describedby);
}
function $437b23f6a393c3bf$var$_setAriaLive(element, live) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "live", live);
}
function $437b23f6a393c3bf$var$_setAriaAtomic(element, atomic) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "atomic", atomic);
}
function $437b23f6a393c3bf$var$_setAriaRelevant(element, relevant) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "relevant", relevant);
}
function $437b23f6a393c3bf$export$fd1450327e6900f2(element, invalid) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "invalid", invalid);
}
function $437b23f6a393c3bf$export$9eaf1f20171625e8(element, level) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "level", level);
}
function $437b23f6a393c3bf$export$7ed376f43c6f2bbd(element, disabled) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "disabled", disabled);
}
function $437b23f6a393c3bf$export$ee52c2b3744c455d(element, hidden) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "hidden", hidden);
}
function $437b23f6a393c3bf$export$5db804730c3c8346(element, descendantId) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "activedescendant", descendantId);
}
function $437b23f6a393c3bf$export$3ad3518dddf15485(element, expanded) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "expanded", expanded);
}
function $437b23f6a393c3bf$export$2254dfb132f01330(element) {
    $437b23f6a393c3bf$var$_removeAriaAttribute(element, "expanded");
}
function $437b23f6a393c3bf$export$3d494c2007bbcac1(element, setsize) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "setsize", setsize);
}
function $437b23f6a393c3bf$export$c3d3aede41065a84(element, position) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "posinset", position);
}
function $437b23f6a393c3bf$var$_setAriaMultiSelectable(element, multiSelectable) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "multiselectable", multiSelectable);
}
function $437b23f6a393c3bf$export$1ad8496b26b660f8(element, rowCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowcount", rowCount);
}
function $437b23f6a393c3bf$export$ba731dedf9d88615(element, rowIndex) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowindex", rowIndex);
}
function $437b23f6a393c3bf$var$_setAriaRowSpan(element, spanCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowspan", spanCount);
}
function $437b23f6a393c3bf$export$56744a26086b5898(element, colCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colcount", colCount);
}
function $437b23f6a393c3bf$export$84b73ecd0b234e89(element, colIndex) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colindex", colIndex);
}
function $437b23f6a393c3bf$export$371d80f0281454ce(element, colSpan) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colspan", colSpan);
}
function $437b23f6a393c3bf$export$c8dd030b968c6fd2(element, sort) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "sort", sort);
}
function $437b23f6a393c3bf$export$26c7aa61eda05134(element) {
    $437b23f6a393c3bf$var$_removeAriaAttribute(element, "sort");
}
function $437b23f6a393c3bf$export$c22e3722e8a33469(element, selected) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "selected", selected);
}
function $437b23f6a393c3bf$export$43b4d6c0ec0fa4c7(element, checked) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "checked", checked === void 0 ? "mixed" : checked);
}
function $437b23f6a393c3bf$export$26fd6a3f123d4e67(controllerElement, controlledId) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(controllerElement, "controls", controlledId);
}
function $437b23f6a393c3bf$export$6ff31a4a210c60ad(controllerElement, controlledElement) {
    $437b23f6a393c3bf$export$26fd6a3f123d4e67(controllerElement, controlledElement.id);
    $437b23f6a393c3bf$export$84233c40c4c74001(controlledElement, controllerElement.id);
}
function $437b23f6a393c3bf$var$_setAriaOwns(ownerElement, ownedId) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(ownerElement, "owns", ownedId);
}
function $437b23f6a393c3bf$export$668d180e9cbef6da(element, hasPopup) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "haspopup", hasPopup === false ? null : hasPopup);
}
function $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, state) {
    return state === void 0 ? translate("ariaIndeterminate", "indeterminate") : state === true ? translate("ariaChecked", "checked") : translate("ariaUnchecked", "unchecked");
}
// packages/ag-grid-community/src/agStack/utils/dom.ts
function $437b23f6a393c3bf$export$605571c1b2992cfe(element, elementClass, otherElementClass) {
    const parent = element.parentElement;
    let sibling = parent && parent.firstChild;
    while(sibling){
        if (elementClass) sibling.classList.toggle(elementClass, sibling === element);
        if (otherElementClass) sibling.classList.toggle(otherElementClass, sibling !== element);
        sibling = sibling.nextSibling;
    }
}
var $437b23f6a393c3bf$var$FOCUSABLE_SELECTOR = "[tabindex], input, select, button, textarea, [href]";
var $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function $437b23f6a393c3bf$var$_isFocusableFormField(element) {
    if (!element) return false;
    const isFocusable = element.matches("input, select, button, textarea");
    if (!isFocusable) return false;
    const isNotFocusable = element.matches($437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE);
    if (!isNotFocusable) return false;
    return $437b23f6a393c3bf$export$2badf4aa566524cb(element);
}
function $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, displayed, options = {}) {
    const { skipAriaHidden: skipAriaHidden } = options;
    element.classList.toggle("ag-hidden", !displayed);
    if (!skipAriaHidden) $437b23f6a393c3bf$export$ee52c2b3744c455d(element, !displayed);
}
function $437b23f6a393c3bf$export$a6c2c477cd60daa8(element, visible, options = {}) {
    const { skipAriaHidden: skipAriaHidden } = options;
    element.classList.toggle("ag-invisible", !visible);
    if (!skipAriaHidden) $437b23f6a393c3bf$export$ee52c2b3744c455d(element, !visible);
}
function $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element, disabled) {
    const attributeName = "disabled";
    const addOrRemoveDisabledAttribute = disabled ? (e)=>e.setAttribute(attributeName, "") : (e)=>e.removeAttribute(attributeName);
    addOrRemoveDisabledAttribute(element);
    const inputs = element.querySelectorAll("input") ?? [];
    for (const input of inputs)addOrRemoveDisabledAttribute(input);
}
function $437b23f6a393c3bf$var$_isElementChildOfClass(element, cls, maxNest) {
    let counter = 0;
    while(element){
        if (element.classList.contains(cls)) return true;
        element = element.parentElement;
        if (typeof maxNest == "number") {
            if (++counter > maxNest) break;
        } else if (element === maxNest) break;
    }
    return false;
}
function $437b23f6a393c3bf$var$_getElementSize(el) {
    const { height: height, width: width, borderTopWidth: borderTopWidth, borderRightWidth: borderRightWidth, borderBottomWidth: borderBottomWidth, borderLeftWidth: borderLeftWidth, paddingTop: paddingTop, paddingRight: paddingRight, paddingBottom: paddingBottom, paddingLeft: paddingLeft, marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, boxSizing: boxSizing } = window.getComputedStyle(el);
    const pf = Number.parseFloat;
    return {
        height: pf(height || "0"),
        width: pf(width || "0"),
        borderTopWidth: pf(borderTopWidth || "0"),
        borderRightWidth: pf(borderRightWidth || "0"),
        borderBottomWidth: pf(borderBottomWidth || "0"),
        borderLeftWidth: pf(borderLeftWidth || "0"),
        paddingTop: pf(paddingTop || "0"),
        paddingRight: pf(paddingRight || "0"),
        paddingBottom: pf(paddingBottom || "0"),
        paddingLeft: pf(paddingLeft || "0"),
        marginTop: pf(marginTop || "0"),
        marginRight: pf(marginRight || "0"),
        marginBottom: pf(marginBottom || "0"),
        marginLeft: pf(marginLeft || "0"),
        boxSizing: boxSizing
    };
}
function $437b23f6a393c3bf$export$c20e968103d9c16e(el) {
    const size = $437b23f6a393c3bf$var$_getElementSize(el);
    if (size.boxSizing === "border-box") return size.height - size.paddingTop - size.paddingBottom - size.borderTopWidth - size.borderBottomWidth;
    return size.height;
}
function $437b23f6a393c3bf$export$cc615e4191ec3e0c(el) {
    const size = $437b23f6a393c3bf$var$_getElementSize(el);
    if (size.boxSizing === "border-box") return size.width - size.paddingLeft - size.paddingRight - size.borderLeftWidth - size.borderRightWidth;
    return size.width;
}
function $437b23f6a393c3bf$export$d23c22492e0f7c0c(el) {
    const { height: height, marginBottom: marginBottom, marginTop: marginTop } = $437b23f6a393c3bf$var$_getElementSize(el);
    return Math.floor(height + marginBottom + marginTop);
}
function $437b23f6a393c3bf$export$642efcb17474eb51(el) {
    const { width: width, marginLeft: marginLeft, marginRight: marginRight } = $437b23f6a393c3bf$var$_getElementSize(el);
    return Math.floor(width + marginLeft + marginRight);
}
function $437b23f6a393c3bf$var$_getElementRectWithOffset(el) {
    const offsetElementRect = el.getBoundingClientRect();
    const { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth, borderRightWidth: borderRightWidth, borderBottomWidth: borderBottomWidth } = $437b23f6a393c3bf$var$_getElementSize(el);
    return {
        top: offsetElementRect.top + (borderTopWidth || 0),
        left: offsetElementRect.left + (borderLeftWidth || 0),
        right: offsetElementRect.right + (borderRightWidth || 0),
        bottom: offsetElementRect.bottom + (borderBottomWidth || 0)
    };
}
function $437b23f6a393c3bf$var$_getScrollLeft(element, rtl) {
    let scrollLeft = element.scrollLeft;
    if (rtl) scrollLeft = Math.abs(scrollLeft);
    return scrollLeft;
}
function $437b23f6a393c3bf$var$_setScrollLeft(element, value, rtl) {
    if (rtl) value *= -1;
    element.scrollLeft = value;
}
function $437b23f6a393c3bf$export$69e6e10709eabd91(el) {
    while(el?.firstChild)el.firstChild.remove();
}
function $437b23f6a393c3bf$export$dd4d52e41fb4cef5(node) {
    if (node?.parentNode) node.remove();
}
function $437b23f6a393c3bf$var$_isInDOM(element) {
    return !!element.offsetParent;
}
function $437b23f6a393c3bf$export$2badf4aa566524cb(element) {
    if (element.checkVisibility) return element.checkVisibility({
        checkVisibilityCSS: true
    });
    const isHidden = !$437b23f6a393c3bf$var$_isInDOM(element) || window.getComputedStyle(element).visibility !== "visible";
    return !isHidden;
}
function $437b23f6a393c3bf$export$b1f57d075ca6d5fb(template) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = (template || "").trim();
    return tempDiv.firstChild;
}
function $437b23f6a393c3bf$var$_ensureDomOrder(eContainer, eChild, eChildBefore) {
    if (eChildBefore && eChildBefore.nextSibling === eChild) return;
    if (!eContainer.firstChild) eContainer.appendChild(eChild);
    else if (eChildBefore) {
        if (eChildBefore.nextSibling) eContainer.insertBefore(eChild, eChildBefore.nextSibling);
        else eContainer.appendChild(eChild);
    } else if (eContainer.firstChild && eContainer.firstChild !== eChild) eContainer.insertAdjacentElement("afterbegin", eChild);
}
function $437b23f6a393c3bf$var$_setDomChildOrder(eContainer, orderedChildren) {
    for(let i = 0; i < orderedChildren.length; i++){
        const correctCellAtIndex = orderedChildren[i];
        const actualCellAtIndex = eContainer.children[i];
        if (actualCellAtIndex !== correctCellAtIndex) eContainer.insertBefore(correctCellAtIndex, actualCellAtIndex);
    }
}
function $437b23f6a393c3bf$var$_camelCaseToHyphenated(camelCase) {
    return camelCase.replace(/[A-Z]/g, (s)=>`-${s.toLocaleLowerCase()}`);
}
function $437b23f6a393c3bf$var$_addStylesToElement(eElement, styles) {
    if (!styles) return;
    for (const key of Object.keys(styles)){
        const value = styles[key];
        if (!key?.length || value == null) continue;
        const parsedKey = $437b23f6a393c3bf$var$_camelCaseToHyphenated(key);
        const valueAsString = value.toString();
        const parsedValue = valueAsString.replace(/\s*!important/g, "");
        const priority = parsedValue.length != valueAsString.length ? "important" : void 0;
        eElement.style.setProperty(parsedKey, parsedValue, priority);
    }
}
function $437b23f6a393c3bf$export$8980540b0a37a11d(getElement2) {
    return ()=>{
        const element = getElement2();
        if (!element) return true;
        return $437b23f6a393c3bf$var$_isHorizontalScrollShowing(element) || $437b23f6a393c3bf$var$_isVerticalScrollShowing(element);
    };
}
function $437b23f6a393c3bf$var$_isHorizontalScrollShowing(element) {
    return element.clientWidth < element.scrollWidth;
}
function $437b23f6a393c3bf$var$_isVerticalScrollShowing(element) {
    return element.clientHeight < element.scrollHeight;
}
function $437b23f6a393c3bf$var$_setElementWidth(element, width) {
    if (width === "flex") {
        element.style.removeProperty("width");
        element.style.removeProperty("minWidth");
        element.style.removeProperty("maxWidth");
        element.style.flex = "1 1 auto";
    } else $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width);
}
function $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width) {
    width = $437b23f6a393c3bf$var$_formatSize(width);
    element.style.width = width;
    element.style.maxWidth = width;
    element.style.minWidth = width;
}
function $437b23f6a393c3bf$var$_setFixedHeight(element, height) {
    height = $437b23f6a393c3bf$var$_formatSize(height);
    element.style.height = height;
    element.style.maxHeight = height;
    element.style.minHeight = height;
}
function $437b23f6a393c3bf$var$_formatSize(size) {
    return typeof size === "number" ? `${size}px` : size;
}
function $437b23f6a393c3bf$export$6e6303ef478b0c94(o) {
    return o instanceof Node || o instanceof HTMLElement;
}
function $437b23f6a393c3bf$var$_addOrRemoveAttribute(element, name, value) {
    if (value == null || value === "") element.removeAttribute(name);
    else element.setAttribute(name, value.toString());
}
function $437b23f6a393c3bf$export$9aef8476630687be(beans, element, callback) {
    const win = $437b23f6a393c3bf$var$_getWindow(beans);
    const ResizeObserverImpl = win.ResizeObserver;
    const resizeObserver = ResizeObserverImpl ? new ResizeObserverImpl(callback) : null;
    resizeObserver?.observe(element);
    return ()=>resizeObserver?.disconnect();
}
function $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, callback) {
    const win = $437b23f6a393c3bf$var$_getWindow(beans);
    if (win.requestAnimationFrame) win.requestAnimationFrame(callback);
    else if (win.webkitRequestAnimationFrame) win.webkitRequestAnimationFrame(callback);
    else win.setTimeout(callback, 0);
}
var $437b23f6a393c3bf$var$DataRefAttribute = "data-ref";
var $437b23f6a393c3bf$var$whitespaceNode;
function $437b23f6a393c3bf$var$getWhitespaceNode() {
    $437b23f6a393c3bf$var$whitespaceNode ?? ($437b23f6a393c3bf$var$whitespaceNode = document.createTextNode(" "));
    return $437b23f6a393c3bf$var$whitespaceNode.cloneNode();
}
function $437b23f6a393c3bf$export$378bc9c64290bc8b(params) {
    const { attrs: attrs, children: children, cls: cls, ref: ref, role: role, tag: tag } = params;
    const element = document.createElement(tag);
    if (cls) element.className = cls;
    if (ref) element.setAttribute($437b23f6a393c3bf$var$DataRefAttribute, ref);
    if (role) element.setAttribute("role", role);
    if (attrs) for (const key of Object.keys(attrs))element.setAttribute(key, attrs[key]);
    if (children) {
        if (typeof children === "string") element.textContent = children;
        else {
            let addFirstWhitespace = true;
            for (const child of children)if (child) {
                if (typeof child === "string") {
                    element.appendChild(document.createTextNode(child));
                    addFirstWhitespace = false;
                } else if (typeof child === "function") element.appendChild(child());
                else {
                    if (addFirstWhitespace) {
                        element.appendChild($437b23f6a393c3bf$var$getWhitespaceNode());
                        addFirstWhitespace = false;
                    }
                    element.append($437b23f6a393c3bf$export$378bc9c64290bc8b(child));
                    element.appendChild($437b23f6a393c3bf$var$getWhitespaceNode());
                }
            }
        }
    }
    return element;
}
// packages/ag-grid-community/src/agStack/utils/event.ts
var $437b23f6a393c3bf$var$PASSIVE_EVENTS = [
    "touchstart",
    "touchend",
    "touchmove",
    "touchcancel",
    "scroll"
];
var $437b23f6a393c3bf$var$NON_PASSIVE_EVENTS = [
    "wheel"
];
var $437b23f6a393c3bf$var$supports = {};
var $437b23f6a393c3bf$var$_isEventSupported = /* @__PURE__ */ (()=>{
    const tags = {
        select: "input",
        change: "input",
        submit: "form",
        reset: "form",
        error: "img",
        load: "img",
        abort: "img"
    };
    const eventChecker = (eventName)=>{
        if (typeof $437b23f6a393c3bf$var$supports[eventName] === "boolean") return $437b23f6a393c3bf$var$supports[eventName];
        const el = document.createElement(tags[eventName] || "div");
        eventName = "on" + eventName;
        return $437b23f6a393c3bf$var$supports[eventName] = eventName in el;
    };
    return eventChecker;
})();
function $437b23f6a393c3bf$export$b5446458166e97b4(element, event) {
    if (!event || !element) return false;
    return $437b23f6a393c3bf$var$_getEventPath(event).indexOf(element) >= 0;
}
function $437b23f6a393c3bf$var$_createEventPath(event) {
    const res = [];
    let pointer = event.target;
    while(pointer){
        res.push(pointer);
        pointer = pointer.parentElement;
    }
    return res;
}
function $437b23f6a393c3bf$var$_getEventPath(event) {
    const eventNoType = event;
    if (eventNoType.path) return eventNoType.path;
    if (eventNoType.composedPath) return eventNoType.composedPath();
    return $437b23f6a393c3bf$var$_createEventPath(eventNoType);
}
function $437b23f6a393c3bf$var$_addSafePassiveEventListener(eElement, event, listener) {
    const passive = $437b23f6a393c3bf$var$getPassiveStateForEvent(event);
    let options;
    if (passive != null) options = {
        passive: passive
    };
    eElement.addEventListener(event, listener, options);
}
var $437b23f6a393c3bf$var$getPassiveStateForEvent = (event)=>{
    const isPassive = $437b23f6a393c3bf$var$PASSIVE_EVENTS.includes(event);
    const isNonPassive = $437b23f6a393c3bf$var$NON_PASSIVE_EVENTS.includes(event);
    if (isPassive) return true;
    if (isNonPassive) return false;
};
function $437b23f6a393c3bf$var$_areEventsNear(e1, e2, pixelCount) {
    if (pixelCount === 0) return false;
    const diffX = Math.abs(e1.clientX - e2.clientX);
    const diffY = Math.abs(e1.clientY - e2.clientY);
    return Math.max(diffX, diffY) <= pixelCount;
}
var $437b23f6a393c3bf$var$_getFirstActiveTouch = (touch, touchList)=>{
    const identifier = touch.identifier;
    for(let i = 0, len = touchList.length; i < len; ++i){
        const item = touchList[i];
        if (item.identifier === identifier) return item;
    }
    return null;
};
function $437b23f6a393c3bf$var$_isEventFromThisInstance(beans, event) {
    return beans.gos.isElementInThisInstance(event.target);
}
function $437b23f6a393c3bf$export$3ce6b987cf48b8c2(element, mouseMoveEvent, beans) {
    const eRect = element.getBoundingClientRect();
    const height = eRect.height;
    const browserWidth = $437b23f6a393c3bf$var$_getBodyWidth(beans) - 2;
    const browserHeight = $437b23f6a393c3bf$var$_getBodyHeight(beans) - 2;
    const offsetParent = element.offsetParent;
    if (!offsetParent) return;
    const offsetParentSize = $437b23f6a393c3bf$var$_getElementRectWithOffset(element.offsetParent);
    const { clientY: clientY, clientX: clientX } = mouseMoveEvent;
    let top = clientY - offsetParentSize.top - height / 2;
    let left = clientX - offsetParentSize.left - 10;
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    const win = eDocument.defaultView || window;
    const windowScrollY = win.pageYOffset || eDocument.documentElement.scrollTop;
    const windowScrollX = win.pageXOffset || eDocument.documentElement.scrollLeft;
    if (browserWidth > 0 && left + element.clientWidth > browserWidth + windowScrollX) left = browserWidth + windowScrollX - element.clientWidth;
    if (left < 0) left = 0;
    if (browserHeight > 0 && top + element.clientHeight > browserHeight + windowScrollY) top = browserHeight + windowScrollY - element.clientHeight;
    if (top < 0) top = 0;
    element.style.left = `${left}px`;
    element.style.top = `${top}px`;
}
var $437b23f6a393c3bf$var$addTempEventHandlers = (list, ...handlers)=>{
    for (const handler of handlers){
        const [target, type, eventListener, options] = handler;
        target.addEventListener(type, eventListener, options);
        list.push(handler);
    }
};
var $437b23f6a393c3bf$var$clearTempEventHandlers = (list)=>{
    if (list) {
        for (const [target, type, listener, options] of list)target.removeEventListener(type, listener, options);
        list.length = 0;
    }
};
var $437b23f6a393c3bf$var$preventEventDefault = (event)=>{
    if (event.cancelable) event.preventDefault();
};
// packages/ag-grid-community/src/agStack/utils/locale.ts
function $437b23f6a393c3bf$var$defaultLocaleTextFunc(_key, defaultValue) {
    return defaultValue;
}
function $437b23f6a393c3bf$export$cc0bf4adff5b95e7(localeSvc) {
    return localeSvc?.getLocaleTextFunc() ?? $437b23f6a393c3bf$var$defaultLocaleTextFunc;
}
function $437b23f6a393c3bf$export$4ad3db330991f17d(bean, localeValues, key, variableValues) {
    const defaultValue = localeValues[key];
    return bean.getLocaleTextFunc()(key, typeof defaultValue === "function" ? defaultValue(variableValues) : defaultValue, variableValues);
}
function $437b23f6a393c3bf$export$b2a251dd30f2791(getLocaleText) {
    return (key, defaultValue, variableValues)=>{
        return getLocaleText({
            key: key,
            defaultValue: defaultValue,
            variableValues: variableValues
        });
    };
}
function $437b23f6a393c3bf$export$5a79576e712817ac(localeText) {
    return (key, defaultValue, variableValues)=>{
        let localisedText = localeText?.[key];
        if (localisedText && variableValues?.length) {
            let found = 0;
            while(true){
                if (found >= variableValues.length) break;
                const idx = localisedText.indexOf("${variable}");
                if (idx === -1) break;
                localisedText = localisedText.replace("${variable}", variableValues[found++]);
            }
        }
        return localisedText ?? defaultValue;
    };
}
// packages/ag-grid-community/src/agStack/core/agBeanStub.ts
var $437b23f6a393c3bf$export$347db2b30d253083 = class {
    constructor(){
        // not named context to allow children to use 'context' as a variable name
        this.destroyFunctions = [];
        this.destroyed = false;
        // for vue 3 - prevents Vue from trying to make this (and obviously any sub classes) from being reactive
        // prevents vue from creating proxies for created objects and prevents identity related issues
        this.__v_skip = true;
        this.propertyListenerId = 0;
        // Enable multiple grid properties to be updated together by the user but only trigger shared logic once.
        // Closely related to logic in GridOptionsUtils.ts _processOnChange
        this.lastChangeSetIdLookup = {};
        this.isAlive = ()=>!this.destroyed;
    }
    preWireBeans(beans) {
        this.beans = beans;
        this.stubContext = beans.context;
        this.eventSvc = beans.eventSvc;
        this.gos = beans.gos;
    }
    // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
    // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
    // points to a bean or component that was not properly disposed of.
    // constructor() {
    //     setTimeout(()=> {
    //         if (this.isAlive()) {
    //             let prototype: any = Object.getPrototypeOf(this);
    //             const constructor: any = prototype.constructor;
    //             const constructorString = constructor.toString();
    //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
    //             console.log('is alive ' + beanName);
    //         }
    //     }, 5000);
    // }
    destroy() {
        const { destroyFunctions: destroyFunctions } = this;
        for(let i = 0; i < destroyFunctions.length; i++)destroyFunctions[i]();
        destroyFunctions.length = 0;
        this.destroyed = true;
        this.dispatchLocalEvent({
            type: "destroyed"
        });
    }
    /** Add a local event listener against this BeanStub */ addEventListener(eventType, listener, async) {
        if (!this.localEventService) this.localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.localEventService.addEventListener(eventType, listener, async);
    }
    /** Remove a local event listener from this BeanStub */ removeEventListener(eventType, listener, async) {
        this.localEventService?.removeEventListener(eventType, listener, async);
    }
    dispatchLocalEvent(event) {
        this.localEventService?.dispatchEvent(event);
    }
    addManagedElementListeners(object, handlers) {
        return this._setupListeners(object, handlers);
    }
    addManagedEventListeners(handlers) {
        return this._setupListeners(this.eventSvc, handlers);
    }
    addManagedListeners(object, handlers) {
        return this._setupListeners(object, handlers);
    }
    _setupListeners(object, handlers) {
        const destroyFuncs = [];
        for (const k of Object.keys(handlers)){
            const handler = handlers[k];
            if (handler) destroyFuncs.push(this._setupListener(object, k, handler));
        }
        return destroyFuncs;
    }
    _setupListener(object, event, listener) {
        if (this.destroyed) return ()=>null;
        let destroyFunc;
        if ($437b23f6a393c3bf$var$isAgEventEmitter(object)) {
            object.__addEventListener(event, listener);
            destroyFunc = ()=>{
                object.__removeEventListener(event, listener);
                return null;
            };
        } else {
            const objIsEventService = $437b23f6a393c3bf$var$isEventService(object);
            if (object instanceof HTMLElement) $437b23f6a393c3bf$var$_addSafePassiveEventListener(object, event, listener);
            else if (objIsEventService) object.addListener(event, listener);
            else object.addEventListener(event, listener);
            destroyFunc = objIsEventService ? ()=>{
                object.removeListener(event, listener);
                return null;
            } : ()=>{
                object.removeEventListener(event, listener);
                return null;
            };
        }
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    /**
   * Setup a managed property listener for the given property.
   * However, stores the destroy function in the beanStub so that if this bean
   * is a component the destroy function will be called when the component is destroyed
   * as opposed to being cleaned up only when the properties service is destroyed.
   */ setupPropertyListener(event, listener) {
        const { gos: gos } = this;
        gos.addPropertyEventListener(event, listener);
        const destroyFunc = ()=>{
            gos.removePropertyEventListener(event, listener);
            return null;
        };
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    /**
   * Setup a managed property listener for the given GridOption property.
   * @param event GridOption property to listen to changes for.
   * @param listener Listener to run when property value changes
   */ addManagedPropertyListener(event, listener) {
        if (this.destroyed) return ()=>null;
        return this.setupPropertyListener(event, listener);
    }
    /**
   * Setup managed property listeners for the given set of GridOption properties.
   * The listener will be run if any of the property changes but will only run once if
   * multiple of the properties change within the same framework lifecycle event.
   * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
   * @param events Array of GridOption properties to listen for changes too.
   * @param listener Shared listener to run if any of the properties change
   */ addManagedPropertyListeners(events, listener) {
        if (this.destroyed) return;
        const eventsKey = events.join("-") + this.propertyListenerId++;
        const wrappedListener = (event)=>{
            if (event.changeSet) {
                if (event.changeSet && event.changeSet.id === this.lastChangeSetIdLookup[eventsKey]) return;
                this.lastChangeSetIdLookup[eventsKey] = event.changeSet.id;
            }
            const propertiesChangeEvent = {
                type: "propertyChanged",
                changeSet: event.changeSet,
                source: event.source
            };
            listener(propertiesChangeEvent);
        };
        for (const event of events)this.setupPropertyListener(event, wrappedListener);
    }
    getLocaleTextFunc() {
        return $437b23f6a393c3bf$export$cc0bf4adff5b95e7(this.beans.localeSvc);
    }
    addDestroyFunc(func) {
        if (this.isAlive()) this.destroyFunctions.push(func);
        else func();
    }
    /** doesn't throw an error if `bean` is undefined */ createOptionalManagedBean(bean, context) {
        return bean ? this.createManagedBean(bean, context) : void 0;
    }
    createManagedBean(bean, context) {
        const res = this.createBean(bean, context);
        this.addDestroyFunc(this.destroyBean.bind(this, bean, context));
        return res;
    }
    createBean(bean, context, afterPreCreateCallback) {
        return (context || this.stubContext).createBean(bean, afterPreCreateCallback);
    }
    /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */ destroyBean(bean, context) {
        return (context || this.stubContext).destroyBean(bean);
    }
    /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */ destroyBeans(beans, context) {
        return (context || this.stubContext).destroyBeans(beans);
    }
};
function $437b23f6a393c3bf$var$isAgEventEmitter(object) {
    return object.__addEventListener !== void 0;
}
function $437b23f6a393c3bf$var$isEventService(object) {
    return object.eventServiceType === "global";
}
// packages/ag-grid-community/src/context/beanStub.ts
var $437b23f6a393c3bf$export$2032c8ef3788dfbd = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
};
// packages/ag-grid-community/src/agStack/utils/function.ts
var $437b23f6a393c3bf$var$doOnceSet = /* @__PURE__ */ new Set();
var $437b23f6a393c3bf$export$e150fb6ea3b45c0d = (func, key)=>{
    if (!$437b23f6a393c3bf$var$doOnceSet.has(key)) {
        $437b23f6a393c3bf$var$doOnceSet.add(key);
        func();
    }
};
$437b23f6a393c3bf$export$e150fb6ea3b45c0d._set = $437b23f6a393c3bf$var$doOnceSet;
var $437b23f6a393c3bf$var$batchedCallsSetTimeout = {
    pending: false,
    funcs: []
};
var $437b23f6a393c3bf$var$batchedCallsRaf = {
    pending: false,
    funcs: []
};
function $437b23f6a393c3bf$export$8ea55376d0d59592(func, mode = "setTimeout", beans) {
    const batch = mode === "raf" ? $437b23f6a393c3bf$var$batchedCallsRaf : $437b23f6a393c3bf$var$batchedCallsSetTimeout;
    batch.funcs.push(func);
    if (batch.pending) return;
    batch.pending = true;
    const runBatch = ()=>{
        const funcsCopy = batch.funcs.slice();
        batch.funcs.length = 0;
        batch.pending = false;
        for (const func2 of funcsCopy)func2();
    };
    if (mode === "raf") $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, runBatch);
    else window.setTimeout(runBatch, 0);
}
function $437b23f6a393c3bf$export$cf7e39bfb94de6e(bean, func, delay) {
    let timeout;
    return function(...args) {
        const context = this;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(function() {
            if (bean.isAlive()) func.apply(context, args);
        }, delay);
        return timeout;
    };
}
function $437b23f6a393c3bf$var$_throttle(func, wait) {
    let previousCall = 0;
    return function(...args) {
        const context = this;
        const currentCall = Date.now();
        if (currentCall - previousCall < wait) return;
        previousCall = currentCall;
        func.apply(context, args);
    };
}
function $437b23f6a393c3bf$export$b863e7aac7884b8(bean, condition, callback, timeout = 100) {
    const timeStamp = Date.now();
    let interval = null;
    let executed = false;
    const clearWait = ()=>{
        if (interval != null) {
            window.clearInterval(interval);
            interval = null;
        }
    };
    bean.addDestroyFunc(clearWait);
    const internalCallback = ()=>{
        const reachedTimeout = Date.now() - timeStamp > timeout;
        if (condition() || reachedTimeout) {
            callback();
            executed = true;
            clearWait();
        }
    };
    internalCallback();
    if (!executed) interval = window.setInterval(internalCallback, 10);
}
// packages/ag-grid-community/src/utils/mergeDeep.ts
var $437b23f6a393c3bf$var$SKIP_JS_BUILTINS = /* @__PURE__ */ new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
function $437b23f6a393c3bf$var$_iterateObject(object, callback) {
    if (object == null) return;
    if (Array.isArray(object)) {
        for(let i = 0; i < object.length; i++)callback(i.toString(), object[i]);
        return;
    }
    for (const key of Object.keys(object).filter((key2)=>!$437b23f6a393c3bf$var$SKIP_JS_BUILTINS.has(key2)))callback(key, object[key]);
}
function $437b23f6a393c3bf$export$8ade6bd474fcde42(dest, source, copyUndefined = true, makeCopyOfSimpleObjects = false) {
    if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(source)) return;
    $437b23f6a393c3bf$var$_iterateObject(source, (key, sourceValue)=>{
        let destValue = dest[key];
        if (destValue === sourceValue) return;
        if (makeCopyOfSimpleObjects) {
            const objectIsDueToBeCopied = destValue == null && sourceValue != null;
            if (objectIsDueToBeCopied) {
                const doNotCopyAsSourceIsSimpleObject = typeof sourceValue === "object" && sourceValue.constructor === Object;
                if (doNotCopyAsSourceIsSimpleObject) {
                    destValue = {};
                    dest[key] = destValue;
                }
            }
        }
        if ($437b23f6a393c3bf$var$_isNonNullObject(sourceValue) && $437b23f6a393c3bf$var$_isNonNullObject(destValue) && !Array.isArray(destValue)) $437b23f6a393c3bf$export$8ade6bd474fcde42(destValue, sourceValue, copyUndefined, makeCopyOfSimpleObjects);
        else if (copyUndefined || sourceValue !== void 0) dest[key] = sourceValue;
    });
}
function $437b23f6a393c3bf$var$_isNonNullObject(value) {
    return typeof value === "object" && value !== null;
}
// packages/ag-grid-community/src/globalGridOptions.ts
var $437b23f6a393c3bf$var$_GlobalGridOptions = class _GlobalGridOptions {
    /**
   * @param providedOptions
   * @returns Shallow copy of the provided options with global options merged in.
   */ static applyGlobalGridOptions(providedOptions) {
        if (!_GlobalGridOptions.gridOptions) return {
            ...providedOptions
        };
        let mergedGridOps = {};
        $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedGridOps, _GlobalGridOptions.gridOptions, true, true);
        if (_GlobalGridOptions.mergeStrategy === "deep") $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedGridOps, providedOptions, true, true);
        else mergedGridOps = {
            ...mergedGridOps,
            ...providedOptions
        };
        if (_GlobalGridOptions.gridOptions.context) mergedGridOps.context = _GlobalGridOptions.gridOptions.context;
        if (providedOptions.context) {
            if (_GlobalGridOptions.mergeStrategy === "deep" && mergedGridOps.context) $437b23f6a393c3bf$export$8ade6bd474fcde42(providedOptions.context, mergedGridOps.context, true, true);
            mergedGridOps.context = providedOptions.context;
        }
        return mergedGridOps;
    }
    /**
   * Apply global grid option for a specific option key.
   * If the merge strategy is 'deep' and both global and provided values are objects, they will be merged deeply.
   * Otherwise, the provided value is returned as is.
   * @param optionKey - The key of the grid option to apply.
   * @param providedValue - The value provided to the grid instance.
   * @returns The merged value if applicable, otherwise the provided value.
   */ static applyGlobalGridOption(optionKey, providedValue) {
        if (_GlobalGridOptions.mergeStrategy === "deep") {
            const globalValue = $437b23f6a393c3bf$export$c3524a7ed99826d4(optionKey);
            if (globalValue && typeof globalValue === "object" && typeof providedValue === "object") return _GlobalGridOptions.applyGlobalGridOptions({
                [optionKey]: providedValue
            })[optionKey];
        }
        return providedValue;
    }
};
$437b23f6a393c3bf$var$_GlobalGridOptions.gridOptions = void 0;
$437b23f6a393c3bf$var$_GlobalGridOptions.mergeStrategy = "shallow";
var $437b23f6a393c3bf$var$GlobalGridOptions = $437b23f6a393c3bf$var$_GlobalGridOptions;
function $437b23f6a393c3bf$export$9def8154c643bfd1(gridOptions, mergeStrategy = "shallow") {
    $437b23f6a393c3bf$var$GlobalGridOptions.gridOptions = gridOptions;
    $437b23f6a393c3bf$var$GlobalGridOptions.mergeStrategy = mergeStrategy;
}
function $437b23f6a393c3bf$export$c3524a7ed99826d4(gridOption) {
    return $437b23f6a393c3bf$var$GlobalGridOptions.gridOptions?.[gridOption];
}
// packages/ag-grid-community/src/gridOptionsDefault.ts
var $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS = {
    suppressContextMenu: false,
    preventDefaultOnContextMenu: false,
    allowContextMenuWithControlKey: false,
    suppressMenuHide: true,
    enableBrowserTooltips: false,
    tooltipTrigger: "hover",
    tooltipShowDelay: 2e3,
    tooltipHideDelay: 1e4,
    tooltipMouseTrack: false,
    tooltipShowMode: "standard",
    tooltipInteraction: false,
    copyHeadersToClipboard: false,
    copyGroupHeadersToClipboard: false,
    clipboardDelimiter: "	",
    suppressCopyRowsToClipboard: false,
    suppressCopySingleCellRanges: false,
    suppressLastEmptyLineOnPaste: false,
    suppressClipboardPaste: false,
    suppressClipboardApi: false,
    suppressCutToClipboard: false,
    maintainColumnOrder: false,
    enableStrictPivotColumnOrder: false,
    suppressFieldDotNotation: false,
    allowDragFromColumnsToolPanel: false,
    suppressMovableColumns: false,
    suppressColumnMoveAnimation: false,
    suppressMoveWhenColumnDragging: false,
    suppressDragLeaveHidesColumns: false,
    suppressRowGroupHidesColumns: false,
    suppressAutoSize: false,
    autoSizePadding: 20,
    skipHeaderOnAutoSize: false,
    singleClickEdit: false,
    suppressClickEdit: false,
    readOnlyEdit: false,
    stopEditingWhenCellsLoseFocus: false,
    enterNavigatesVertically: false,
    enterNavigatesVerticallyAfterEdit: false,
    enableCellEditingOnBackspace: false,
    undoRedoCellEditing: false,
    undoRedoCellEditingLimit: 10,
    suppressCsvExport: false,
    suppressExcelExport: false,
    cacheQuickFilter: false,
    includeHiddenColumnsInQuickFilter: false,
    excludeChildrenWhenTreeDataFiltering: false,
    enableAdvancedFilter: false,
    includeHiddenColumnsInAdvancedFilter: false,
    enableCharts: false,
    masterDetail: false,
    keepDetailRows: false,
    keepDetailRowsCount: 10,
    detailRowAutoHeight: false,
    tabIndex: 0,
    rowBuffer: 10,
    valueCache: false,
    valueCacheNeverExpires: false,
    enableCellExpressions: false,
    suppressTouch: false,
    suppressFocusAfterRefresh: false,
    suppressBrowserResizeObserver: false,
    suppressPropertyNamesCheck: false,
    suppressChangeDetection: false,
    debug: false,
    suppressLoadingOverlay: false,
    suppressNoRowsOverlay: false,
    pagination: false,
    paginationPageSize: 100,
    paginationPageSizeSelector: true,
    paginationAutoPageSize: false,
    paginateChildRows: false,
    suppressPaginationPanel: false,
    pivotMode: false,
    pivotPanelShow: "never",
    pivotDefaultExpanded: 0,
    pivotSuppressAutoColumn: false,
    suppressExpandablePivotGroups: false,
    functionsReadOnly: false,
    suppressAggFuncInHeader: false,
    alwaysAggregateAtRootLevel: false,
    aggregateOnlyChangedColumns: false,
    suppressAggFilteredOnly: false,
    removePivotHeaderRowWhenSingleValueColumn: false,
    animateRows: true,
    cellFlashDuration: 500,
    cellFadeDuration: 1e3,
    allowShowChangeAfterFilter: false,
    domLayout: "normal",
    ensureDomOrder: false,
    enableRtl: false,
    suppressColumnVirtualisation: false,
    suppressMaxRenderedRowRestriction: false,
    suppressRowVirtualisation: false,
    rowDragManaged: false,
    refreshAfterGroupEdit: false,
    rowDragInsertDelay: 500,
    suppressRowDrag: false,
    suppressMoveWhenRowDragging: false,
    rowDragEntireRow: false,
    rowDragMultiRow: false,
    embedFullWidthRows: false,
    groupDisplayType: "singleColumn",
    groupDefaultExpanded: 0,
    groupMaintainOrder: false,
    groupSelectsChildren: false,
    groupSuppressBlankHeader: false,
    groupSelectsFiltered: false,
    showOpenedGroup: false,
    groupRemoveSingleChildren: false,
    groupRemoveLowestSingleChildren: false,
    groupHideOpenParents: false,
    groupAllowUnbalanced: false,
    rowGroupPanelShow: "never",
    suppressMakeColumnVisibleAfterUnGroup: false,
    treeData: false,
    rowGroupPanelSuppressSort: false,
    suppressGroupRowsSticky: false,
    rowModelType: "clientSide",
    asyncTransactionWaitMillis: 50,
    suppressModelUpdateAfterUpdateTransaction: false,
    cacheOverflowSize: 1,
    infiniteInitialRowCount: 1,
    serverSideInitialRowCount: 1,
    cacheBlockSize: 100,
    maxBlocksInCache: -1,
    maxConcurrentDatasourceRequests: 2,
    blockLoadDebounceMillis: 0,
    purgeClosedRowNodes: false,
    serverSideSortAllLevels: false,
    serverSideOnlyRefreshFilteredGroups: false,
    serverSidePivotResultFieldSeparator: "_",
    viewportRowModelPageSize: 5,
    viewportRowModelBufferSize: 5,
    alwaysShowHorizontalScroll: false,
    alwaysShowVerticalScroll: false,
    debounceVerticalScrollbar: false,
    suppressHorizontalScroll: false,
    suppressScrollOnNewData: false,
    suppressScrollWhenPopupsAreOpen: false,
    suppressAnimationFrame: false,
    suppressMiddleClickScrolls: false,
    suppressPreventDefaultOnMouseWheel: false,
    rowMultiSelectWithClick: false,
    suppressRowDeselection: false,
    suppressRowClickSelection: false,
    suppressCellFocus: false,
    suppressHeaderFocus: false,
    suppressMultiRangeSelection: false,
    enableCellTextSelection: false,
    enableRangeSelection: false,
    enableRangeHandle: false,
    enableFillHandle: false,
    fillHandleDirection: "xy",
    suppressClearOnFillReduction: false,
    accentedSort: false,
    unSortIcon: false,
    suppressMultiSort: false,
    alwaysMultiSort: false,
    suppressMaintainUnsortedOrder: false,
    suppressRowHoverHighlight: false,
    suppressRowTransform: false,
    columnHoverHighlight: false,
    deltaSort: false,
    enableGroupEdit: false,
    groupLockGroupColumns: 0,
    serverSideEnableClientSideSort: false,
    suppressServerSideFullWidthLoadingRow: false,
    pivotMaxGeneratedColumns: -1,
    columnMenu: "new",
    reactiveCustomComponents: true,
    suppressSetFilterByDefault: false,
    enableFilterHandlers: false
};
// packages/ag-grid-community/src/baseUrl.ts
var $437b23f6a393c3bf$var$BASE_URL = "https://www.ag-grid.com";
// packages/ag-grid-community/src/utils/log.ts
function $437b23f6a393c3bf$var$_logIfDebug(gos, message, ...args) {
    if (gos.get("debug")) console.log("AG Grid: " + message, ...args);
}
function $437b23f6a393c3bf$export$2cf41453020eef66(msg, ...args) {
    $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>console.warn("AG Grid: " + msg, ...args), msg + args?.join(""));
}
function $437b23f6a393c3bf$var$_errorOnce(msg, ...args) {
    $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>console.error("AG Grid: " + msg, ...args), msg + args?.join(""));
}
// packages/ag-grid-community/src/modules/moduleRegistry.ts
var $437b23f6a393c3bf$var$allRegisteredModules = /* @__PURE__ */ new Set();
var $437b23f6a393c3bf$var$globalModulesMap = {};
var $437b23f6a393c3bf$var$gridModulesMap = {};
var $437b23f6a393c3bf$var$currentModuleVersion;
var $437b23f6a393c3bf$var$userHasRegistered = false;
var $437b23f6a393c3bf$var$areGridScopedModules = false;
var $437b23f6a393c3bf$var$isUmd = false;
function $437b23f6a393c3bf$var$isValidModuleVersion(module) {
    const [moduleMajor, moduleMinor] = module.version.split(".") || [];
    const [currentModuleMajor, currentModuleMinor] = $437b23f6a393c3bf$var$currentModuleVersion.split(".") || [];
    return moduleMajor === currentModuleMajor && moduleMinor === currentModuleMinor;
}
function $437b23f6a393c3bf$var$runVersionChecks(module) {
    if (!$437b23f6a393c3bf$var$currentModuleVersion) $437b23f6a393c3bf$var$currentModuleVersion = module.version;
    const errorMsg = (details)=>`You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. ${details} Please update all modules to the same version.`;
    if (!module.version) $437b23f6a393c3bf$var$_errorOnce(errorMsg(`'${module.moduleName}' is incompatible.`));
    else if (!$437b23f6a393c3bf$var$isValidModuleVersion(module)) $437b23f6a393c3bf$var$_errorOnce(errorMsg(`'${module.moduleName}' is version ${module.version} but the other modules are version ${$437b23f6a393c3bf$var$currentModuleVersion}.`));
    const result = module.validate?.();
    if (result && !result.isValid) $437b23f6a393c3bf$var$_errorOnce(`${result.message}`);
}
function $437b23f6a393c3bf$export$d0b008fbcc09e577(module, gridId, isInternalRegistration = false) {
    if (!isInternalRegistration) $437b23f6a393c3bf$var$userHasRegistered = true;
    $437b23f6a393c3bf$var$runVersionChecks(module);
    const rowModels = module.rowModels ?? [
        "all"
    ];
    $437b23f6a393c3bf$var$allRegisteredModules.add(module);
    let moduleStore;
    if (gridId !== void 0) {
        $437b23f6a393c3bf$var$areGridScopedModules = true;
        if ($437b23f6a393c3bf$var$gridModulesMap[gridId] === void 0) $437b23f6a393c3bf$var$gridModulesMap[gridId] = {};
        moduleStore = $437b23f6a393c3bf$var$gridModulesMap[gridId];
    } else moduleStore = $437b23f6a393c3bf$var$globalModulesMap;
    for (const rowModel of rowModels){
        if (moduleStore[rowModel] === void 0) moduleStore[rowModel] = {};
        moduleStore[rowModel][module.moduleName] = module;
    }
    if (module.dependsOn) for (const dependency of module.dependsOn)$437b23f6a393c3bf$export$d0b008fbcc09e577(dependency, gridId, isInternalRegistration);
}
function $437b23f6a393c3bf$var$_unRegisterGridModules(gridId) {
    delete $437b23f6a393c3bf$var$gridModulesMap[gridId];
}
function $437b23f6a393c3bf$var$_isModuleRegistered(moduleName, gridId, rowModel) {
    const isRegisteredForRowModel = (model)=>!!$437b23f6a393c3bf$var$globalModulesMap[model]?.[moduleName] || !!$437b23f6a393c3bf$var$gridModulesMap[gridId]?.[model]?.[moduleName];
    return isRegisteredForRowModel(rowModel) || isRegisteredForRowModel("all");
}
function $437b23f6a393c3bf$var$_areModulesGridScoped() {
    return $437b23f6a393c3bf$var$areGridScopedModules;
}
function $437b23f6a393c3bf$var$_getRegisteredModules(gridId, rowModel) {
    const gridModules = $437b23f6a393c3bf$var$gridModulesMap[gridId] ?? {};
    return [
        ...Object.values($437b23f6a393c3bf$var$globalModulesMap["all"] ?? {}),
        ...Object.values(gridModules["all"] ?? {}),
        ...Object.values($437b23f6a393c3bf$var$globalModulesMap[rowModel] ?? {}),
        ...Object.values(gridModules[rowModel] ?? {})
    ];
}
function $437b23f6a393c3bf$var$_getAllRegisteredModules() {
    return new Set($437b23f6a393c3bf$var$allRegisteredModules);
}
function $437b23f6a393c3bf$export$7c244c452cd4b417(gridId, rowModel) {
    const gridModules = $437b23f6a393c3bf$var$gridModulesMap[gridId] ?? {};
    return [
        ...Object.values(gridModules["all"] ?? {}),
        ...Object.values(gridModules[rowModel] ?? {})
    ];
}
function $437b23f6a393c3bf$var$_hasUserRegistered() {
    return $437b23f6a393c3bf$var$userHasRegistered;
}
function $437b23f6a393c3bf$var$_isUmd() {
    return $437b23f6a393c3bf$var$isUmd;
}
function $437b23f6a393c3bf$export$8bf1e03cfb50cab5() {
    $437b23f6a393c3bf$var$isUmd = true;
}
var $437b23f6a393c3bf$export$dc053975cc7f6c11 = class {
    /**
   * @deprecated v33 Use `registerModules([module])` instead.
   */ static register(module) {
        $437b23f6a393c3bf$export$d0b008fbcc09e577(module, void 0);
    }
    /**
   * Globally register the given modules for all grids.
   * @param modules - modules to register
   */ static registerModules(modules) {
        for (const module of modules)$437b23f6a393c3bf$export$d0b008fbcc09e577(module, void 0);
    }
};
// packages/ag-grid-community/src/version.ts
var $437b23f6a393c3bf$var$VERSION = "35.0.1";
// packages/ag-grid-community/src/validation/logging.ts
var $437b23f6a393c3bf$var$MAX_URL_LENGTH = 2e3;
var $437b23f6a393c3bf$var$MIN_PARAM_LENGTH = 100;
var $437b23f6a393c3bf$var$VERSION_PARAM_NAME = "_version_";
var $437b23f6a393c3bf$var$getConsoleMessage = null;
var $437b23f6a393c3bf$var$baseDocLink = `${$437b23f6a393c3bf$var$BASE_URL}/javascript-data-grid`;
function $437b23f6a393c3bf$var$provideValidationServiceLogger(logger) {
    $437b23f6a393c3bf$var$getConsoleMessage = logger;
}
function $437b23f6a393c3bf$var$setValidationDocLink(docLink) {
    $437b23f6a393c3bf$var$baseDocLink = docLink;
}
function $437b23f6a393c3bf$var$getErrorParts(id, args, defaultMessage) {
    return $437b23f6a393c3bf$var$getConsoleMessage?.(id, args) ?? [
        $437b23f6a393c3bf$var$minifiedLog(id, args, defaultMessage)
    ];
}
function $437b23f6a393c3bf$var$getMsgOrDefault(logger, id, args, isWarning, defaultMessage) {
    logger(`${isWarning ? "warning" : "error"} #${id}`, ...$437b23f6a393c3bf$var$getErrorParts(id, args, defaultMessage));
}
function $437b23f6a393c3bf$var$stringifyObject(inputObj) {
    if (!inputObj) return String(inputObj);
    const object = {};
    for (const prop of Object.keys(inputObj))if (typeof inputObj[prop] !== "object" && typeof inputObj[prop] !== "function") object[prop] = inputObj[prop];
    return JSON.stringify(object);
}
function $437b23f6a393c3bf$var$stringifyValue(value) {
    let output = value;
    if (value instanceof Error) output = value.toString();
    else if (typeof value === "object") output = $437b23f6a393c3bf$var$stringifyObject(value);
    return output;
}
function $437b23f6a393c3bf$var$toStringWithNullUndefined(str) {
    return str === void 0 ? "undefined" : str === null ? "null" : str;
}
function $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params) {
    return `${baseUrl}?${params.toString()}`;
}
function $437b23f6a393c3bf$var$truncateUrl(baseUrl, params, maxLength) {
    const sortedParams = Array.from(params.entries()).sort((a, b)=>b[1].length - a[1].length);
    let url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    for (const [key, value] of sortedParams){
        if (key === $437b23f6a393c3bf$var$VERSION_PARAM_NAME) continue;
        const excessLength = url.length - maxLength;
        if (excessLength <= 0) break;
        const ellipse = "...";
        const truncateAmount = excessLength + ellipse.length;
        const truncatedValue = value.length - truncateAmount > $437b23f6a393c3bf$var$MIN_PARAM_LENGTH ? value.slice(0, value.length - truncateAmount) + ellipse : value.slice(0, $437b23f6a393c3bf$var$MIN_PARAM_LENGTH) + ellipse;
        params.set(key, truncatedValue);
        url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    }
    return url;
}
function $437b23f6a393c3bf$var$getErrorLink(errorNum, args) {
    const params = new URLSearchParams();
    params.append($437b23f6a393c3bf$var$VERSION_PARAM_NAME, $437b23f6a393c3bf$var$VERSION);
    if (args) for (const key of Object.keys(args))params.append(key, $437b23f6a393c3bf$var$stringifyValue(args[key]));
    const baseUrl = `${$437b23f6a393c3bf$var$baseDocLink}/errors/${errorNum}`;
    const url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    return url.length <= $437b23f6a393c3bf$var$MAX_URL_LENGTH ? url : $437b23f6a393c3bf$var$truncateUrl(baseUrl, params, $437b23f6a393c3bf$var$MAX_URL_LENGTH);
}
var $437b23f6a393c3bf$var$minifiedLog = (errorNum, args, defaultMessage)=>{
    const errorLink = $437b23f6a393c3bf$var$getErrorLink(errorNum, args);
    const prefix = `${defaultMessage ? defaultMessage + " \n" : ""}Visit ${errorLink}`;
    if ($437b23f6a393c3bf$var$_isUmd()) return prefix;
    return `${prefix}${defaultMessage ? "" : " \n  Alternatively register the ValidationModule to see the full message in the console."}`;
};
function $437b23f6a393c3bf$export$545083624300f13d(...args) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$export$2cf41453020eef66, args[0], args[1], true);
}
function $437b23f6a393c3bf$export$a20c7248650823a9(...args) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$var$_errorOnce, args[0], args[1], false);
}
function $437b23f6a393c3bf$var$_logPreInitErr(id, args, defaultMessage) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$var$_errorOnce, id, args, false, defaultMessage);
}
function $437b23f6a393c3bf$export$2ff8152c3f8aff5b(id, args, defaultMessage) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$export$2cf41453020eef66, id, args, true, defaultMessage);
}
function $437b23f6a393c3bf$var$getErrMsg(defaultMessage, args) {
    const id = args[0];
    return `error #${id} ` + $437b23f6a393c3bf$var$getErrorParts(id, args[1], defaultMessage).join(" ");
}
function $437b23f6a393c3bf$export$680bb5102fca525e(...args) {
    return $437b23f6a393c3bf$var$getErrMsg(void 0, args);
}
function $437b23f6a393c3bf$export$d73cab7876c2c868(...args) {
    return $437b23f6a393c3bf$var$getErrMsg("\n", args);
}
// packages/ag-grid-community/src/gridOptionsUtils.ts
function $437b23f6a393c3bf$var$isRowModelType(gos, rowModelType) {
    return gos.get("rowModelType") === rowModelType;
}
function $437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel) {
    return $437b23f6a393c3bf$var$isRowModelType(gos, "clientSide");
}
function $437b23f6a393c3bf$export$cf1bac0013650216(gos, rowModel) {
    return $437b23f6a393c3bf$var$isRowModelType(gos, "serverSide");
}
function $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, domLayout) {
    return gos.get("domLayout") === domLayout;
}
function $437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos) {
    return $437b23f6a393c3bf$export$80b6607444b3274f(gos) !== void 0;
}
function $437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(gos) {
    return typeof gos.get("getRowHeight") === "function";
}
function $437b23f6a393c3bf$var$_shouldMaintainColumnOrder(gos, isPivotColumns) {
    if (isPivotColumns) return !gos.get("enableStrictPivotColumnOrder");
    return gos.get("maintainColumnOrder");
}
function $437b23f6a393c3bf$export$58f4eed4127eb370({ gos: gos, formula: formula }) {
    const rowNumbers = gos.get("rowNumbers");
    return rowNumbers || !!formula?.active && rowNumbers !== false;
}
function $437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, rowNode, allowEstimate = false, defaultRowHeight) {
    const { gos: gos, environment: environment } = beans;
    if (defaultRowHeight == null) defaultRowHeight = environment.getDefaultRowHeight();
    if ($437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(gos)) {
        if (allowEstimate) return {
            height: defaultRowHeight,
            estimated: true
        };
        const params = {
            node: rowNode,
            data: rowNode.data
        };
        const height = gos.getCallback("getRowHeight")(params);
        if ($437b23f6a393c3bf$var$isNumeric(height)) {
            if (height === 0) $437b23f6a393c3bf$export$545083624300f13d(23);
            return {
                height: Math.max(1, height),
                estimated: false
            };
        }
    }
    if (rowNode.detail && gos.get("masterDetail")) return $437b23f6a393c3bf$var$getMasterDetailRowHeight(gos);
    const gridOptionsRowHeight = gos.get("rowHeight");
    const rowHeight = gridOptionsRowHeight && $437b23f6a393c3bf$var$isNumeric(gridOptionsRowHeight) ? gridOptionsRowHeight : defaultRowHeight;
    return {
        height: rowHeight,
        estimated: false
    };
}
function $437b23f6a393c3bf$var$getMasterDetailRowHeight(gos) {
    if (gos.get("detailRowAutoHeight")) return {
        height: 1,
        estimated: false
    };
    const defaultRowHeight = gos.get("detailRowHeight");
    if ($437b23f6a393c3bf$var$isNumeric(defaultRowHeight)) return {
        height: defaultRowHeight,
        estimated: false
    };
    return {
        height: 300,
        estimated: false
    };
}
function $437b23f6a393c3bf$export$8966875adec41e5b(beans) {
    const { environment: environment, gos: gos } = beans;
    const gridOptionsRowHeight = gos.get("rowHeight");
    if (!gridOptionsRowHeight || $437b23f6a393c3bf$export$672d9e47bc342bac(gridOptionsRowHeight)) return environment.getDefaultRowHeight();
    const rowHeight = environment.refreshRowHeightVariable();
    if (rowHeight !== -1) return rowHeight;
    $437b23f6a393c3bf$export$545083624300f13d(24);
    return environment.getDefaultRowHeight();
}
function $437b23f6a393c3bf$var$isNumeric(value) {
    return !isNaN(value) && typeof value === "number" && isFinite(value);
}
function $437b23f6a393c3bf$var$_getDomData(gos, element, key) {
    const domData = element[gos.getDomDataKey()];
    return domData ? domData[key] : void 0;
}
function $437b23f6a393c3bf$var$_setDomData(gos, element, key, value) {
    const domDataKey = gos.getDomDataKey();
    let domData = element[domDataKey];
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(domData)) {
        domData = {};
        element[domDataKey] = domData;
    }
    domData[key] = value;
}
function $437b23f6a393c3bf$export$27adf74cf591fd1e(gos) {
    if (gos.get("ensureDomOrder")) return false;
    return gos.get("animateRows");
}
function $437b23f6a393c3bf$export$d5f33aacea6a0849(gos) {
    return !(gos.get("paginateChildRows") || gos.get("groupHideOpenParents") || $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print"));
}
function $437b23f6a393c3bf$export$96c51c2547b81aed(gos) {
    const autoGroupColumnDef = gos.get("autoGroupColumnDef");
    return !autoGroupColumnDef?.comparator && !gos.get("treeData");
}
function $437b23f6a393c3bf$export$3708afee0330994(gos) {
    const userValue = gos.get("groupAggFiltering");
    if (typeof userValue === "function") return gos.getCallback("groupAggFiltering");
    if (userValue === true) return ()=>true;
    return void 0;
}
function $437b23f6a393c3bf$export$c6fad27ed643a862(gos) {
    return gos.get("grandTotalRow");
}
function $437b23f6a393c3bf$export$713d6cabeaa7f2a5(gos) {
    const userValue = gos.get("groupTotalRow");
    if (typeof userValue === "function") return gos.getCallback("groupTotalRow");
    return ()=>userValue ?? void 0;
}
function $437b23f6a393c3bf$export$7122eb216a66bef2(gos) {
    const isHideOpenParents = !!gos.get("groupHideOpenParents");
    if (isHideOpenParents) return true;
    return gos.get("groupDisplayType") === "multipleColumns";
}
function $437b23f6a393c3bf$export$b911c5b172d227b4(gos, pivotMode) {
    if (pivotMode) return false;
    return gos.get("groupDisplayType") === "groupRows";
}
function $437b23f6a393c3bf$export$410912a9c501b8cc(gos, node, pivotMode) {
    return !!node.group && !node.footer && $437b23f6a393c3bf$export$b911c5b172d227b4(gos, pivotMode);
}
function $437b23f6a393c3bf$export$57c3bb2f89b59a89(gos) {
    const getRowId = gos.getCallback("getRowId");
    if (getRowId === void 0) return getRowId;
    return (params)=>{
        let id = getRowId(params);
        if (typeof id !== "string") {
            $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>$437b23f6a393c3bf$export$545083624300f13d(25, {
                    id: id
                }), "getRowIdString");
            id = String(id);
        }
        return id;
    };
}
function $437b23f6a393c3bf$export$2f5892ff24cc879d(gos, node) {
    const isSkippingGroups = gos.get("groupHideParentOfSingleChild");
    if (isSkippingGroups === true) return true;
    if (isSkippingGroups === "leafGroupsOnly" && node.leafGroup) return true;
    if (gos.get("groupRemoveSingleChildren")) return true;
    if (gos.get("groupRemoveLowestSingleChildren") && node.leafGroup) return true;
    return false;
}
function $437b23f6a393c3bf$export$efae4c751fa7cc4d(gos) {
    const res = gos.get("maxConcurrentDatasourceRequests");
    return res > 0 ? res : void 0;
}
function $437b23f6a393c3bf$export$d80073cdfb810fa8(gos, isGrouped) {
    const preventVisibilityChanges = gos.get("suppressGroupChangesColumnVisibility");
    if (preventVisibilityChanges === true) return false;
    if (isGrouped && preventVisibilityChanges === "suppressHideOnGroup") return false;
    if (!isGrouped && preventVisibilityChanges === "suppressShowOnUngroup") return false;
    const legacySuppressOnGroup = gos.get("suppressRowGroupHidesColumns");
    if (isGrouped && legacySuppressOnGroup === true) return false;
    const legacySuppressOnUngroup = gos.get("suppressMakeColumnVisibleAfterUnGroup");
    if (!isGrouped && legacySuppressOnUngroup === true) return false;
    return true;
}
function $437b23f6a393c3bf$export$6df3a55606bca6ae(selection) {
    return selection?.checkboxes ?? true;
}
function $437b23f6a393c3bf$export$e92e75627785d7a4(selection) {
    return selection?.mode === "multiRow" && (selection.headerCheckbox ?? true);
}
function $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection) {
    if (typeof rowSelection !== "object") return void 0;
    return rowSelection.checkboxLocation ?? "selectionColumn";
}
function $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(selection) {
    return selection?.hideDisabledCheckboxes ?? false;
}
function $437b23f6a393c3bf$export$d3c80fcacb2e2d55(gos) {
    const rowSelection = gos.get("rowSelection");
    return typeof rowSelection !== "string";
}
function $437b23f6a393c3bf$export$63600d24670d494d(gos) {
    return gos.get("cellSelection") !== void 0;
}
function $437b23f6a393c3bf$export$93073c0b97dd7eba(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return gos.get("suppressMultiRangeSelection");
    return typeof selection !== "boolean" ? selection?.suppressMultiRanges ?? false : false;
}
function $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    return useNewAPI ? !!selection : gos.get("enableRangeSelection");
}
function $437b23f6a393c3bf$export$c96ba82819c56957(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return {
        mode: "fill",
        setFillValue: gos.get("fillOperation"),
        direction: gos.get("fillHandleDirection"),
        suppressClearOnFillReduction: gos.get("suppressClearOnFillReduction")
    };
    return typeof selection !== "boolean" && selection.handle?.mode === "fill" ? selection.handle : void 0;
}
function $437b23f6a393c3bf$export$8242077b143dbc86(gos) {
    const cellSelection = gos.get("cellSelection") ?? false;
    return (typeof cellSelection === "object" && cellSelection.enableColumnSelection) ?? false;
}
function $437b23f6a393c3bf$var$_getEnableClickSelection(gos) {
    const selection = gos.get("rowSelection") ?? "single";
    if (typeof selection === "string") {
        const suppressRowClickSelection = gos.get("suppressRowClickSelection");
        const suppressRowDeselection = gos.get("suppressRowDeselection");
        if (suppressRowClickSelection && suppressRowDeselection) return false;
        else if (suppressRowClickSelection) return "enableDeselection";
        else if (suppressRowDeselection) return "enableSelection";
        else return true;
    }
    return selection.mode === "singleRow" || selection.mode === "multiRow" ? selection.enableClickSelection ?? false : false;
}
function $437b23f6a393c3bf$var$_getEnableSelection(gos) {
    const enableClickSelection = $437b23f6a393c3bf$var$_getEnableClickSelection(gos);
    return enableClickSelection === true || enableClickSelection === "enableSelection";
}
function $437b23f6a393c3bf$var$_getEnableDeselection(gos) {
    const enableClickSelection = $437b23f6a393c3bf$var$_getEnableClickSelection(gos);
    return enableClickSelection === true || enableClickSelection === "enableDeselection";
}
function $437b23f6a393c3bf$export$351959be716b3b33(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") return gos.get("isRowSelectable");
    return selection?.isRowSelectable;
}
function $437b23f6a393c3bf$export$80b6607444b3274f(arg) {
    const selection = "beanName" in arg && arg.beanName === "gos" ? arg.get("rowSelection") : arg.rowSelection;
    if (typeof selection === "string") switch(selection){
        case "multiple":
            return "multiRow";
        case "single":
            return "singleRow";
        default:
            return;
    }
    switch(selection?.mode){
        case "multiRow":
        case "singleRow":
            return selection.mode;
        default:
            return;
    }
}
function $437b23f6a393c3bf$export$7bd8c52ebc4117d6(arg) {
    const mode = $437b23f6a393c3bf$export$80b6607444b3274f(arg);
    return mode === "multiRow";
}
function $437b23f6a393c3bf$var$_getEnableSelectionWithoutKeys(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") return gos.get("rowMultiSelectWithClick");
    return selection?.enableSelectionWithoutKeys ?? false;
}
function $437b23f6a393c3bf$export$673080972d8c733e(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") {
        const groupSelectsChildren = gos.get("groupSelectsChildren");
        const groupSelectsFiltered = gos.get("groupSelectsFiltered");
        if (groupSelectsChildren && groupSelectsFiltered) return "filteredDescendants";
        else if (groupSelectsChildren) return "descendants";
        else return "self";
    }
    return selection?.mode === "multiRow" ? selection.groupSelects : void 0;
}
function $437b23f6a393c3bf$var$_getSelectAll(gos, defaultValue = true) {
    const rowSelection = gos.get("rowSelection");
    if (typeof rowSelection !== "object") return defaultValue ? "all" : void 0;
    return rowSelection.mode === "multiRow" ? rowSelection.selectAll : "all";
}
function $437b23f6a393c3bf$var$_getCtrlASelectsRows(gos) {
    const rowSelection = gos.get("rowSelection");
    if (typeof rowSelection === "string") return false;
    return rowSelection?.mode === "multiRow" ? rowSelection.ctrlASelectsRows ?? false : false;
}
function $437b23f6a393c3bf$export$460e5745f0e6a40d(gos) {
    const groupSelection = $437b23f6a393c3bf$export$673080972d8c733e(gos);
    return groupSelection === "descendants" || groupSelection === "filteredDescendants";
}
function $437b23f6a393c3bf$var$_getMasterSelects(gos) {
    const rowSelection = gos.get("rowSelection");
    return typeof rowSelection === "object" && rowSelection.masterSelects || "self";
}
function $437b23f6a393c3bf$export$b68e6345dc6b83fa(gos) {
    return gos.isModuleRegistered("SetFilter") && !gos.get("suppressSetFilterByDefault");
}
function $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos) {
    return gos.get("columnMenu") === "legacy";
}
function $437b23f6a393c3bf$export$cfe4cf52f3717a7b(gos) {
    return !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
}
function $437b23f6a393c3bf$export$2badf35af69344c1(eventName) {
    if (!eventName || eventName.length < 2) return eventName;
    return "on" + eventName[0].toUpperCase() + eventName.substring(1);
}
function $437b23f6a393c3bf$export$bfe37fc2d3c03134(gridOptions, component, gridOptionsKeys) {
    if (typeof gridOptions !== "object") gridOptions = {};
    const mergedOptions = {
        ...gridOptions
    };
    for (const key of gridOptionsKeys){
        const value = component[key];
        if (typeof value !== "undefined") mergedOptions[key] = value;
    }
    return mergedOptions;
}
function $437b23f6a393c3bf$export$52208033bd24c2b2(changes, api) {
    if (!changes) return;
    const gridChanges = {};
    let hasChanges = false;
    for (const key of Object.keys(changes)){
        gridChanges[key] = changes[key];
        hasChanges = true;
    }
    if (!hasChanges) return;
    const internalUpdateEvent = {
        type: "gridOptionsChanged",
        options: gridChanges
    };
    api.dispatchEvent(internalUpdateEvent);
    const event = {
        type: "componentStateChanged",
        ...gridChanges
    };
    api.dispatchEvent(event);
}
function $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, params) {
    return gos.addCommon(params);
}
function $437b23f6a393c3bf$export$aa5750e97994dd3(providedGridOptions, gridOption) {
    return providedGridOptions[gridOption] ?? providedGridOptions[`gridOptions`]?.[gridOption] ?? $437b23f6a393c3bf$export$c3524a7ed99826d4(gridOption) ?? $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS[gridOption];
}
function $437b23f6a393c3bf$export$f8093014f10b296a({ gos: gos }, event) {
    return event.button === 2 || event.ctrlKey && gos.get("allowContextMenuWithControlKey");
}
// packages/ag-grid-community/src/entities/agColumn.ts
var $437b23f6a393c3bf$var$COL_DEF_DEFAULTS = {
    resizable: true,
    sortable: true
};
var $437b23f6a393c3bf$var$instanceIdSequence = 0;
function $437b23f6a393c3bf$var$getNextColInstanceId() {
    return $437b23f6a393c3bf$var$instanceIdSequence++;
}
function $437b23f6a393c3bf$export$891484e65a02ec71(col) {
    return col instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2;
}
var $437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER = [
    "asc",
    "desc",
    null
];
var $437b23f6a393c3bf$var$DEFAULT_ABSOLUTE_SORTING_ORDER = [
    {
        type: "absolute",
        direction: "asc"
    },
    {
        type: "absolute",
        direction: "desc"
    },
    null
];
var $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(colDef, userProvidedColDef, colId, primary){
        super();
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.colId = colId;
        this.primary = primary;
        this.isColumn = true;
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = $437b23f6a393c3bf$var$getNextColInstanceId();
        // The measured height of this column's header when autoHeaderHeight is enabled
        this.autoHeaderHeight = null;
        this.sortDef = $437b23f6a393c3bf$export$2a92f4fc1f337c5a();
        this._wasSortExplicitlyRemoved = false;
        this.moving = false;
        this.resizing = false;
        this.menuVisible = false;
        this.formulaRef = null;
        this.lastLeftPinned = false;
        this.firstRightPinned = false;
        this.filterActive = false;
        this.colEventSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.tooltipEnabled = false;
        this.rowGroupActive = false;
        this.pivotActive = false;
        this.aggregationActive = false;
        this.flex = null;
        this.colIdSanitised = $437b23f6a393c3bf$export$3df06b741968da82(colId);
    }
    destroy() {
        super.destroy();
        this.beans.rowSpanSvc?.deregister(this);
    }
    getInstanceId() {
        return this.instanceId;
    }
    initState() {
        const { colDef: colDef, beans: { sortSvc: sortSvc, pinnedCols: pinnedCols, colFlex: colFlex } } = this;
        sortSvc?.initCol(this);
        const hide = colDef.hide;
        if (hide !== void 0) this.visible = !hide;
        else this.visible = !colDef.initialHide;
        pinnedCols?.initCol(this);
        colFlex?.initCol(this);
    }
    // gets called when user provides an alternative colDef, eg
    setColDef(colDef, userProvidedColDef, source) {
        const colSpanChanged = colDef.spanRows !== this.colDef.spanRows;
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.initMinAndMaxWidths();
        this.initDotNotation();
        this.initTooltip();
        if (colSpanChanged) {
            this.beans.rowSpanSvc?.deregister(this);
            this.initRowSpan();
        }
        this.dispatchColEvent("colDefChanged", source);
    }
    getUserProvidedColDef() {
        return this.userProvidedColDef;
    }
    getParent() {
        return this.parent;
    }
    getOriginalParent() {
        return this.originalParent;
    }
    // this is done after constructor as it uses gridOptionsService
    postConstruct() {
        this.initState();
        this.initMinAndMaxWidths();
        this.resetActualWidth("gridInitializing");
        this.initDotNotation();
        this.initTooltip();
        this.initRowSpan();
        this.addPivotListener();
    }
    initDotNotation() {
        const { gos: gos, colDef: { field: field, tooltipField: tooltipField } } = this;
        const suppressDotNotation = gos.get("suppressFieldDotNotation");
        this.fieldContainsDots = $437b23f6a393c3bf$export$25d27f17d3af40f7(field) && field.includes(".") && !suppressDotNotation;
        this.tooltipFieldContainsDots = $437b23f6a393c3bf$export$25d27f17d3af40f7(tooltipField) && tooltipField.includes(".") && !suppressDotNotation;
    }
    initMinAndMaxWidths() {
        const colDef = this.colDef;
        this.minWidth = colDef.minWidth ?? this.beans.environment.getDefaultColumnMinWidth();
        this.maxWidth = colDef.maxWidth ?? Number.MAX_SAFE_INTEGER;
    }
    initTooltip() {
        this.beans.tooltipSvc?.initCol(this);
    }
    initRowSpan() {
        if (this.colDef.spanRows) this.beans.rowSpanSvc?.register(this);
    }
    addPivotListener() {
        const pivotColDefSvc = this.beans.pivotColDefSvc;
        const pivotValueColumn = this.colDef.pivotValueColumn;
        if (!pivotColDefSvc || !pivotValueColumn) return;
        this.addManagedListeners(pivotValueColumn, {
            colDefChanged: (evt)=>{
                const colDef = pivotColDefSvc.recreateColDef(this.colDef);
                this.setColDef(colDef, colDef, evt.source);
            }
        });
    }
    resetActualWidth(source) {
        const initialWidth = this.calculateColInitialWidth(this.colDef);
        this.setActualWidth(initialWidth, source, true);
    }
    calculateColInitialWidth(colDef) {
        let width;
        const colDefWidth = colDef.width;
        const colDefInitialWidth = colDef.initialWidth;
        if (colDefWidth != null) width = colDefWidth;
        else if (colDefInitialWidth != null) width = colDefInitialWidth;
        else width = 200;
        return Math.max(Math.min(width, this.maxWidth), this.minWidth);
    }
    isEmptyGroup() {
        return false;
    }
    isRowGroupDisplayed(colId) {
        return this.beans.showRowGroupCols?.isRowGroupDisplayed(this, colId) ?? false;
    }
    isPrimary() {
        return this.primary;
    }
    isFilterAllowed() {
        const filterDefined = !!this.colDef.filter;
        return filterDefined;
    }
    isFieldContainsDots() {
        return this.fieldContainsDots;
    }
    isTooltipEnabled() {
        return this.tooltipEnabled;
    }
    isTooltipFieldContainsDots() {
        return this.tooltipFieldContainsDots;
    }
    getHighlighted() {
        return this.highlighted;
    }
    __addEventListener(eventType, listener) {
        this.colEventSvc.addEventListener(eventType, listener);
    }
    __removeEventListener(eventType, listener) {
        this.colEventSvc.removeEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ addEventListener(eventType, userListener) {
        this.frameworkEventListenerService = this.beans.frameworkOverrides.createLocalEventListenerWrapper?.(this.frameworkEventListenerService, this.colEventSvc);
        const listener = this.frameworkEventListenerService?.wrap(eventType, userListener) ?? userListener;
        this.colEventSvc.addEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ removeEventListener(eventType, userListener) {
        const listener = this.frameworkEventListenerService?.unwrap(eventType, userListener) ?? userListener;
        this.colEventSvc.removeEventListener(eventType, listener);
    }
    createColumnFunctionCallbackParams(rowNode) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            column: this,
            colDef: this.colDef
        });
    }
    isSuppressNavigable(rowNode) {
        return this.beans.cellNavigation?.isSuppressNavigable(this, rowNode) ?? false;
    }
    isCellEditable(rowNode) {
        return this.beans.editSvc?.isCellEditable({
            rowNode: rowNode,
            column: this
        }) ?? false;
    }
    isSuppressFillHandle() {
        return !!this.colDef.suppressFillHandle;
    }
    isAutoHeight() {
        return !!this.colDef.autoHeight;
    }
    isAutoHeaderHeight() {
        return !!this.colDef.autoHeaderHeight;
    }
    isRowDrag(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.rowDrag);
    }
    isDndSource(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.dndSource);
    }
    isCellCheckboxSelection(rowNode) {
        return this.beans.selectionSvc?.isCellCheckboxSelection(this, rowNode) ?? false;
    }
    isSuppressPaste(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef?.suppressPaste ?? null);
    }
    isResizable() {
        return !!this.getColDefValue("resizable");
    }
    /** Get value from ColDef or default if it exists. */ getColDefValue(key) {
        return this.colDef[key] ?? $437b23f6a393c3bf$var$COL_DEF_DEFAULTS[key];
    }
    isColumnFunc(rowNode, value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "function") {
            const params = this.createColumnFunctionCallbackParams(rowNode);
            const editableFunc = value;
            return editableFunc(params);
        }
        return false;
    }
    createColumnEvent(type, source) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            type: type,
            column: this,
            columns: [
                this
            ],
            source: source
        });
    }
    isMoving() {
        return this.moving;
    }
    getSort() {
        return this.sortDef.direction;
    }
    /**
   * Returns null if no sort direction applied
   */ getSortDef() {
        if (!this.sortDef.direction) return null;
        return this.sortDef;
    }
    getColDefAllowedSortTypes() {
        const res = [];
        const { sort: sort, initialSort: initialSort } = this.colDef;
        const colDefSortType = sort === null ? sort : $437b23f6a393c3bf$export$fb66185d3079b298(sort?.type);
        const colDefInitialSortType = initialSort === null ? initialSort : $437b23f6a393c3bf$export$fb66185d3079b298(initialSort?.type);
        if (colDefSortType) res.push(colDefSortType);
        if (colDefInitialSortType) res.push(colDefInitialSortType);
        return res;
    }
    getSortingOrder() {
        const defaultSortingOrder = this.getColDefAllowedSortTypes().includes("absolute") ? $437b23f6a393c3bf$var$DEFAULT_ABSOLUTE_SORTING_ORDER : $437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER;
        return (this.colDef.sortingOrder ?? this.gos.get("sortingOrder") ?? defaultSortingOrder).map((objOrDirection)=>$437b23f6a393c3bf$export$2a92f4fc1f337c5a(objOrDirection));
    }
    getAvailableSortTypes() {
        const explicitSortTypesFromSortingOrder = this.getSortingOrder().reduce((acc, so)=>{
            if (so.direction) acc.push(so.type);
            return acc;
        }, this.getColDefAllowedSortTypes());
        return new Set(explicitSortTypesFromSortingOrder);
    }
    get wasSortExplicitlyRemoved() {
        return this._wasSortExplicitlyRemoved;
    }
    setSortDef(sortDef, initial = false) {
        if (!initial) this._wasSortExplicitlyRemoved = !sortDef.direction;
        this.sortDef = sortDef;
    }
    isSortable() {
        return !!this.getColDefValue("sortable");
    }
    /** @deprecated v32 use col.getSort() === 'asc */ isSortAscending() {
        return this.getSort() === "asc";
    }
    /** @deprecated v32 use col.getSort() === 'desc */ isSortDescending() {
        return this.getSort() === "desc";
    }
    /** @deprecated v32 use col.getSort() === undefined */ isSortNone() {
        return $437b23f6a393c3bf$export$672d9e47bc342bac(this.getSort());
    }
    /** @deprecated v32 use col.getSort() !== undefined */ isSorting() {
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(this.getSort());
    }
    getSortIndex() {
        return this.sortIndex;
    }
    isMenuVisible() {
        return this.menuVisible;
    }
    getAggFunc() {
        return this.aggFunc;
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    getRight() {
        return this.left + this.actualWidth;
    }
    setLeft(left, source) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.dispatchColEvent("leftChanged", source);
        }
    }
    isFilterActive() {
        return this.filterActive;
    }
    /** @deprecated v33 Use `api.isColumnHovered(column)` instead. */ isHovered() {
        $437b23f6a393c3bf$export$545083624300f13d(261);
        return !!this.beans.colHover?.isHovered(this);
    }
    setFirstRightPinned(firstRightPinned, source) {
        if (this.firstRightPinned !== firstRightPinned) {
            this.firstRightPinned = firstRightPinned;
            this.dispatchColEvent("firstRightPinnedChanged", source);
        }
    }
    setLastLeftPinned(lastLeftPinned, source) {
        if (this.lastLeftPinned !== lastLeftPinned) {
            this.lastLeftPinned = lastLeftPinned;
            this.dispatchColEvent("lastLeftPinnedChanged", source);
        }
    }
    isFirstRightPinned() {
        return this.firstRightPinned;
    }
    isLastLeftPinned() {
        return this.lastLeftPinned;
    }
    isPinned() {
        return this.pinned === "left" || this.pinned === "right";
    }
    isPinnedLeft() {
        return this.pinned === "left";
    }
    isPinnedRight() {
        return this.pinned === "right";
    }
    getPinned() {
        return this.pinned;
    }
    setVisible(visible, source) {
        const newValue = visible === true;
        if (this.visible !== newValue) {
            this.visible = newValue;
            this.dispatchColEvent("visibleChanged", source);
        }
        this.dispatchStateUpdatedEvent("hide");
    }
    isVisible() {
        return this.visible;
    }
    isSpanHeaderHeight() {
        const colDef = this.getColDef();
        return !colDef.suppressSpanHeaderHeight;
    }
    /**
   * Returns the first parent that is not a padding group.
   */ getFirstRealParent() {
        let parent = this.getOriginalParent();
        while(parent?.isPadding())parent = parent.getOriginalParent();
        return parent;
    }
    getColumnGroupPaddingInfo() {
        let parent = this.getParent();
        if (!parent?.isPadding()) return {
            numberOfParents: 0,
            isSpanningTotal: false
        };
        const numberOfParents = parent.getPaddingLevel() + 1;
        let isSpanningTotal = true;
        while(parent){
            if (!parent.isPadding()) {
                isSpanningTotal = false;
                break;
            }
            parent = parent.getParent();
        }
        return {
            numberOfParents: numberOfParents,
            isSpanningTotal: isSpanningTotal
        };
    }
    getColDef() {
        return this.colDef;
    }
    getDefinition() {
        return this.colDef;
    }
    getColumnGroupShow() {
        return this.colDef.columnGroupShow;
    }
    getColId() {
        return this.colId;
    }
    getId() {
        return this.colId;
    }
    getUniqueId() {
        return this.colId;
    }
    getActualWidth() {
        return this.actualWidth;
    }
    getAutoHeaderHeight() {
        return this.autoHeaderHeight;
    }
    /** Returns true if the header height has changed */ setAutoHeaderHeight(height) {
        const changed = height !== this.autoHeaderHeight;
        this.autoHeaderHeight = height;
        return changed;
    }
    createBaseColDefParams(rowNode) {
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            colDef: this.colDef,
            column: this
        });
        return params;
    }
    getColSpan(rowNode) {
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.colDef.colSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const colSpan = this.colDef.colSpan(params);
        return Math.max(colSpan, 1);
    }
    getRowSpan(rowNode) {
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.colDef.rowSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const rowSpan = this.colDef.rowSpan(params);
        return Math.max(rowSpan, 1);
    }
    setActualWidth(actualWidth, source, silent = false) {
        actualWidth = Math.max(actualWidth, this.minWidth);
        actualWidth = Math.min(actualWidth, this.maxWidth);
        if (this.actualWidth !== actualWidth) {
            this.actualWidth = actualWidth;
            if (this.flex != null && source !== "flex" && source !== "gridInitializing") this.flex = null;
            if (!silent) this.fireColumnWidthChangedEvent(source);
        }
        this.dispatchStateUpdatedEvent("width");
    }
    fireColumnWidthChangedEvent(source) {
        this.dispatchColEvent("widthChanged", source);
    }
    isGreaterThanMax(width) {
        return width > this.maxWidth;
    }
    getMinWidth() {
        return this.minWidth;
    }
    getMaxWidth() {
        return this.maxWidth;
    }
    getFlex() {
        return this.flex;
    }
    isRowGroupActive() {
        return this.rowGroupActive;
    }
    isPivotActive() {
        return this.pivotActive;
    }
    isAnyFunctionActive() {
        return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
    }
    isAnyFunctionAllowed() {
        return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
    }
    isValueActive() {
        return this.aggregationActive;
    }
    isAllowPivot() {
        return this.colDef.enablePivot === true;
    }
    isAllowValue() {
        return this.colDef.enableValue === true;
    }
    isAllowRowGroup() {
        return this.colDef.enableRowGroup === true;
    }
    isAllowFormula() {
        return this.colDef.allowFormula === true;
    }
    dispatchColEvent(type, source, additionalEventAttributes) {
        const colEvent = this.createColumnEvent(type, source);
        if (additionalEventAttributes) $437b23f6a393c3bf$export$8ade6bd474fcde42(colEvent, additionalEventAttributes);
        this.colEventSvc.dispatchEvent(colEvent);
    }
    dispatchStateUpdatedEvent(key) {
        this.colEventSvc.dispatchEvent({
            type: "columnStateUpdated",
            key: key
        });
    }
};
function $437b23f6a393c3bf$export$2a92f4fc1f337c5a(input) {
    if ($437b23f6a393c3bf$var$_isSortDefValid(input)) return {
        direction: input.direction,
        type: input.type
    };
    return {
        direction: $437b23f6a393c3bf$export$b26b2467cef719c1(input),
        type: $437b23f6a393c3bf$export$fb66185d3079b298(input)
    };
}
function $437b23f6a393c3bf$export$12c7f6d8339d30ad(maybeSortDir) {
    return maybeSortDir === "asc" || maybeSortDir === "desc" || maybeSortDir === null;
}
function $437b23f6a393c3bf$export$dd4a0f5f19676fa0(maybeSortType) {
    return maybeSortType === "default" || maybeSortType === "absolute";
}
function $437b23f6a393c3bf$var$_isSortDefValid(maybeSortDef) {
    if (!maybeSortDef || typeof maybeSortDef !== "object") return false;
    const maybeSortDefT = maybeSortDef;
    return $437b23f6a393c3bf$export$dd4a0f5f19676fa0(maybeSortDefT.type) && $437b23f6a393c3bf$export$12c7f6d8339d30ad(maybeSortDefT.direction);
}
function $437b23f6a393c3bf$export$1d4824b7d3b8a5c8(sortDef1, sortDef2) {
    if (!sortDef1) return sortDef2 ? sortDef2.direction === null : true;
    if (!sortDef2) return sortDef1 ? sortDef1.direction === null : true;
    return sortDef1.type === sortDef2.type && sortDef1.direction === sortDef2.direction;
}
function $437b23f6a393c3bf$export$b26b2467cef719c1(sortDirectionLike) {
    return $437b23f6a393c3bf$export$12c7f6d8339d30ad(sortDirectionLike) ? sortDirectionLike : null;
}
function $437b23f6a393c3bf$export$fb66185d3079b298(sortTypeLike) {
    return $437b23f6a393c3bf$export$dd4a0f5f19676fa0(sortTypeLike) ? sortTypeLike : "default";
}
// packages/ag-grid-community/src/entities/agProvidedColumnGroup.ts
function $437b23f6a393c3bf$export$bb4bfad2b594b78e(col) {
    return col instanceof $437b23f6a393c3bf$export$7ff27642a6ecc1cf;
}
var $437b23f6a393c3bf$export$7ff27642a6ecc1cf = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(colGroupDef, groupId, padding, level){
        super();
        this.colGroupDef = colGroupDef;
        this.groupId = groupId;
        this.padding = padding;
        this.level = level;
        this.isColumn = false;
        this.expandable = false;
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = $437b23f6a393c3bf$var$getNextColInstanceId();
        this.expandableListenerRemoveCallback = null;
        this.expanded = !!colGroupDef?.openByDefault;
    }
    destroy() {
        if (this.expandableListenerRemoveCallback) this.reset(null, void 0);
        super.destroy();
    }
    reset(colGroupDef, level) {
        this.colGroupDef = colGroupDef;
        this.level = level;
        this.originalParent = null;
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        this.children = void 0;
        this.expandable = void 0;
    }
    getInstanceId() {
        return this.instanceId;
    }
    getOriginalParent() {
        return this.originalParent;
    }
    getLevel() {
        return this.level;
    }
    isVisible() {
        if (this.children) return this.children.some((child)=>child.isVisible());
        return false;
    }
    isPadding() {
        return this.padding;
    }
    setExpanded(expanded) {
        this.expanded = expanded === void 0 ? false : expanded;
        this.dispatchLocalEvent({
            type: "expandedChanged"
        });
    }
    isExpandable() {
        return this.expandable;
    }
    isExpanded() {
        return this.expanded;
    }
    getGroupId() {
        return this.groupId;
    }
    getId() {
        return this.getGroupId();
    }
    setChildren(children) {
        this.children = children;
    }
    getChildren() {
        return this.children;
    }
    getColGroupDef() {
        return this.colGroupDef;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    forEachLeafColumn(callback) {
        if (!this.children) return;
        for (const child of this.children){
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) callback(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.forEachLeafColumn(callback);
        }
    }
    addLeafColumns(leafColumns) {
        if (!this.children) return;
        for (const child of this.children){
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.addLeafColumns(leafColumns);
        }
    }
    getColumnGroupShow() {
        const colGroupDef = this.colGroupDef;
        if (!colGroupDef) return;
        return colGroupDef.columnGroupShow;
    }
    // need to check that this group has at least one col showing when both expanded and contracted.
    // if not, then we don't allow expanding and contracting on this group
    setupExpandable() {
        this.setExpandable();
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        const listener = this.onColumnVisibilityChanged.bind(this);
        for (const col of this.getLeafColumns())col.__addEventListener("visibleChanged", listener);
        this.expandableListenerRemoveCallback = ()=>{
            for (const col of this.getLeafColumns())col.__removeEventListener("visibleChanged", listener);
            this.expandableListenerRemoveCallback = null;
        };
    }
    setExpandable() {
        if (this.isPadding()) return;
        let atLeastOneShowingWhenOpen = false;
        let atLeastOneShowingWhenClosed = false;
        let atLeastOneChangeable = false;
        const children = this.findChildrenRemovingPadding();
        for(let i = 0, j = children.length; i < j; i++){
            const abstractColumn = children[i];
            if (!abstractColumn.isVisible()) continue;
            const headerGroupShow = abstractColumn.getColumnGroupShow();
            if (headerGroupShow === "open") {
                atLeastOneShowingWhenOpen = true;
                atLeastOneChangeable = true;
            } else if (headerGroupShow === "closed") {
                atLeastOneShowingWhenClosed = true;
                atLeastOneChangeable = true;
            } else {
                atLeastOneShowingWhenOpen = true;
                atLeastOneShowingWhenClosed = true;
            }
        }
        const expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
        if (this.expandable !== expandable) {
            this.expandable = expandable;
            this.dispatchLocalEvent({
                type: "expandableChanged"
            });
        }
    }
    findChildrenRemovingPadding() {
        const res = [];
        const process = (items)=>{
            for (const item of items){
                const skipBecausePadding = $437b23f6a393c3bf$export$bb4bfad2b594b78e(item) && item.isPadding();
                if (skipBecausePadding) process(item.children);
                else res.push(item);
            }
        };
        process(this.children);
        return res;
    }
    onColumnVisibilityChanged() {
        this.setExpandable();
    }
};
// packages/ag-grid-community/src/entities/defaultColumnTypes.ts
var $437b23f6a393c3bf$var$DefaultColumnTypes = {
    numericColumn: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    },
    rightAligned: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupUtils.ts
function $437b23f6a393c3bf$var$createMergedColGroupDef(beans, colGroupDef, groupId) {
    const colGroupDefMerged = {};
    const gos = beans.gos;
    Object.assign(colGroupDefMerged, gos.get("defaultColGroupDef"));
    Object.assign(colGroupDefMerged, colGroupDef);
    gos.validateColDef(colGroupDefMerged, groupId);
    return colGroupDefMerged;
}
// packages/ag-grid-community/src/columns/columnKeyCreator.ts
var $437b23f6a393c3bf$export$f67d1427302c96a3 = class {
    constructor(){
        this.existingKeys = {};
    }
    addExistingKeys(keys) {
        for(let i = 0; i < keys.length; i++)this.existingKeys[keys[i]] = true;
    }
    getUniqueKey(colId, colField) {
        colId = $437b23f6a393c3bf$export$2a74c29220d5c88e(colId);
        let count = 0;
        while(true){
            let idToTry = colId ?? colField;
            if (idToTry) {
                if (count !== 0) idToTry += "_" + count;
            } else idToTry = count;
            if (!this.existingKeys[idToTry]) {
                const usedId = String(idToTry);
                if (colId && count > 0) $437b23f6a393c3bf$export$545083624300f13d(273, {
                    providedId: colId,
                    usedId: usedId
                });
                this.existingKeys[usedId] = true;
                return usedId;
            }
            count++;
        }
    }
};
// packages/ag-grid-community/src/agStack/utils/array.ts
var $437b23f6a393c3bf$export$c758d9371030a6ac = Object.freeze([]);
function $437b23f6a393c3bf$export$236389741107357f(arr) {
    if (!arr?.length) return;
    return arr[arr.length - 1];
}
function $437b23f6a393c3bf$export$893967cdb9833fdd(a, b, comparator) {
    if (a === b) return true;
    if (!a || !b) return a == null && b == null;
    const len = a.length;
    if (len !== b.length) return false;
    for(let i = 0; i < len; i++){
        if (a[i] !== b[i] && !comparator?.(a[i], b[i])) return false;
    }
    return true;
}
function $437b23f6a393c3bf$var$_forAll(array, callback) {
    if (!array) return;
    for (const value of array){
        if (callback(value)) return true;
    }
}
function $437b23f6a393c3bf$export$83a881c8b5120679(array, object) {
    const index = array.indexOf(object);
    if (index >= 0) array.splice(index, 1);
}
function $437b23f6a393c3bf$export$d938638f12233be7(array, elementsToRemove) {
    let i = 0;
    let j = 0;
    for(; i < array.length; i++)if (!elementsToRemove.includes(array[i])) {
        array[j] = array[i];
        j++;
    }
    while(j < array.length)array.pop();
}
function $437b23f6a393c3bf$var$_moveInArray(array, objectsToMove, toIndex) {
    for(let i = 0; i < objectsToMove.length; i++)$437b23f6a393c3bf$export$83a881c8b5120679(array, objectsToMove[i]);
    for(let i = objectsToMove.length - 1; i >= 0; i--)array.splice(toIndex, 0, objectsToMove[i]);
}
function $437b23f6a393c3bf$export$5e3f39c5068e375d(arrays) {
    return [].concat.apply([], arrays);
}
// packages/ag-grid-community/src/columns/columnUtils.ts
var $437b23f6a393c3bf$export$a7016588c430dba6 = "ag-Grid-AutoColumn";
var $437b23f6a393c3bf$export$dd05e5f089eb2421 = "ag-Grid-SelectionColumn";
var $437b23f6a393c3bf$export$f55c01dfb205b029 = "ag-Grid-RowNumbersColumn";
var $437b23f6a393c3bf$export$2c8ac3f8e81f483f = "ag-Grid-HierarchyColumn";
function $437b23f6a393c3bf$export$42da2aea8fab5b(rootColumns) {
    const result = [];
    const recursiveFindColumns = (childColumns)=>{
        for(let i = 0; i < childColumns.length; i++){
            const child = childColumns[i];
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) result.push(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) recursiveFindColumns(child.getChildren());
        }
    };
    recursiveFindColumns(rootColumns);
    return result;
}
function $437b23f6a393c3bf$var$getWidthOfColsInList(columnList) {
    return columnList.reduce((width, col)=>width + col.getActualWidth(), 0);
}
function $437b23f6a393c3bf$export$dbaaa57234b60d8f(beans, oldTree, newTree) {
    const oldObjectsById = {};
    if (!oldTree) return;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, oldTree, (child)=>{
        oldObjectsById[child.getInstanceId()] = child;
    });
    if (newTree) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, newTree, (child)=>{
        oldObjectsById[child.getInstanceId()] = null;
    });
    const colsToDestroy = Object.values(oldObjectsById).filter((item)=>item != null);
    beans.context.destroyBeans(colsToDestroy);
}
function $437b23f6a393c3bf$export$61b34611dc010a97(col) {
    const colId = col.getId();
    return colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
}
function $437b23f6a393c3bf$export$f6074a9792015c5d(col) {
    const id = typeof col === "string" ? col : "getColId" in col ? col.getColId() : col.colId;
    return id?.startsWith($437b23f6a393c3bf$export$dd05e5f089eb2421) ?? false;
}
function $437b23f6a393c3bf$export$3d3e7d751f0445eb(col) {
    const id = typeof col === "string" ? col : "getColId" in col ? col.getColId() : col.colId;
    return id?.startsWith($437b23f6a393c3bf$export$f55c01dfb205b029) ?? false;
}
function $437b23f6a393c3bf$export$ee97d5717f8d44ec(col) {
    return $437b23f6a393c3bf$export$f6074a9792015c5d(col) || $437b23f6a393c3bf$export$3d3e7d751f0445eb(col);
}
function $437b23f6a393c3bf$var$convertColumnTypes(type) {
    let typeKeys = [];
    if (type instanceof Array) typeKeys = type;
    else if (typeof type === "string") typeKeys = type.split(",");
    return typeKeys;
}
function $437b23f6a393c3bf$export$f56e341a1fe35ed4(colsA, colsB) {
    return $437b23f6a393c3bf$export$893967cdb9833fdd(colsA, colsB, (a, b)=>a.getColId() === b.getColId());
}
function $437b23f6a393c3bf$export$c82fd63ff1738bed(cols) {
    cols.map = {};
    for (const col of cols.list)cols.map[col.getId()] = col;
}
function $437b23f6a393c3bf$export$eb2a92b6162267d1(source) {
    return source === "optionsUpdated" ? "gridOptionsChanged" : source;
}
function $437b23f6a393c3bf$export$f5687d41c39fa1b3(column, key) {
    const columnMatches = column === key;
    const colDefMatches = column.getColDef() === key;
    const idMatches = column.getColId() == key;
    return columnMatches || colDefMatches || idMatches;
}
var $437b23f6a393c3bf$var$getValueFactory = (stateItem, defaultState)=>(key1, key2)=>{
        const obj = {
            value1: void 0,
            value2: void 0
        };
        let calculated = false;
        if (stateItem) {
            if (stateItem[key1] !== void 0) {
                obj.value1 = stateItem[key1];
                calculated = true;
            }
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(key2) && stateItem[key2] !== void 0) {
                obj.value2 = stateItem[key2];
                calculated = true;
            }
        }
        if (!calculated && defaultState) {
            if (defaultState[key1] !== void 0) obj.value1 = defaultState[key1];
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(key2) && defaultState[key2] !== void 0) obj.value2 = defaultState[key2];
        }
        return obj;
    };
function $437b23f6a393c3bf$export$2fd1bdef8244d93c(colDef, colId) {
    const state = {
        ...colDef,
        sort: void 0,
        colId: colId
    };
    const sortDef = $437b23f6a393c3bf$export$f24a224f07655b28(colDef);
    if (sortDef) {
        state.sort = sortDef.direction;
        state.sortType = sortDef.type;
    }
    return state;
}
function $437b23f6a393c3bf$export$f24a224f07655b28(colDef) {
    const { sort: sort, initialSort: initialSort } = colDef;
    const sortIsValid = $437b23f6a393c3bf$var$_isSortDefValid(sort) || $437b23f6a393c3bf$export$12c7f6d8339d30ad(sort);
    const initialSortIsValid = $437b23f6a393c3bf$var$_isSortDefValid(initialSort) || $437b23f6a393c3bf$export$12c7f6d8339d30ad(initialSort);
    if (sortIsValid) return $437b23f6a393c3bf$export$2a92f4fc1f337c5a(sort);
    if (initialSortIsValid) return $437b23f6a393c3bf$export$2a92f4fc1f337c5a(initialSort);
    return null;
}
// packages/ag-grid-community/src/columns/columnFactoryUtils.ts
var $437b23f6a393c3bf$var$depthFirstCallback = (child, parent)=>{
    if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.setupExpandable();
    child.originalParent = parent;
};
function $437b23f6a393c3bf$export$575b8d8234793d75(beans, defs = null, primaryColumns, existingTree, source) {
    const { existingCols: existingCols, existingGroups: existingGroups } = $437b23f6a393c3bf$var$extractExistingTreeData(existingTree);
    const colIdMap = new Map(existingCols.map((col)=>[
            col.getId(),
            col
        ]));
    const colGroupIdMap = new Map(existingGroups.map((group)=>[
            group.getId(),
            group
        ]));
    let maxDepth = 0;
    const recursivelyProcessColDef = (def, level)=>{
        maxDepth = Math.max(maxDepth, level);
        if ($437b23f6a393c3bf$var$isColumnGroupDef(def)) {
            if (!beans.colGroupSvc) return null;
            const groupId = def.groupId;
            const group = colGroupIdMap.get(groupId);
            const colGroupDef = $437b23f6a393c3bf$var$createMergedColGroupDef(beans, def, groupId);
            const newGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDef, groupId, false, level);
            beans.context.createBean(newGroup);
            if (group) newGroup.setExpanded(group.isExpanded());
            newGroup.setChildren(def.children.map((child)=>recursivelyProcessColDef(child, level + 1)));
            return newGroup;
        }
        const colId = def.colId;
        let column = colIdMap.get(colId);
        const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, def, column?.getColId() ?? colId);
        if (!column) {
            column = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDefMerged, def, colId, primaryColumns);
            beans.context.createBean(column);
        } else {
            column.setColDef(colDefMerged, def, source);
            $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDefMerged, source);
        }
        beans.dataTypeSvc?.addColumnListeners(column);
        return column;
    };
    const root = defs?.map((def)=>recursivelyProcessColDef(def, 0)) ?? [];
    let counter = 0;
    const keyCreator = {
        getUniqueKey: (_colId, _field)=>String(++counter)
    };
    const columnTree = beans.colGroupSvc ? beans.colGroupSvc.balanceColumnTree(root, 0, maxDepth, keyCreator) : root;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, columnTree, $437b23f6a393c3bf$var$depthFirstCallback);
    return {
        columnTree: columnTree,
        treeDepth: maxDepth
    };
}
function $437b23f6a393c3bf$export$e03b26088dedc2ab(beans, defs = null, primaryColumns, existingTree, source) {
    const columnKeyCreator = new $437b23f6a393c3bf$export$f67d1427302c96a3();
    const { existingCols: existingCols, existingGroups: existingGroups, existingColKeys: existingColKeys } = $437b23f6a393c3bf$var$extractExistingTreeData(existingTree);
    columnKeyCreator.addExistingKeys(existingColKeys);
    const unbalancedTree = $437b23f6a393c3bf$var$_recursivelyCreateColumns(beans, defs, 0, primaryColumns, existingCols, columnKeyCreator, existingGroups, source);
    const { colGroupSvc: colGroupSvc } = beans;
    const treeDepth = colGroupSvc?.findMaxDepth(unbalancedTree, 0) ?? 0;
    const columnTree = colGroupSvc ? colGroupSvc.balanceColumnTree(unbalancedTree, 0, treeDepth, columnKeyCreator) : unbalancedTree;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, columnTree, $437b23f6a393c3bf$var$depthFirstCallback);
    return {
        columnTree: columnTree,
        treeDepth: treeDepth
    };
}
function $437b23f6a393c3bf$var$extractExistingTreeData(existingTree) {
    const existingCols = [];
    const existingGroups = [];
    const existingColKeys = [];
    if (existingTree) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, existingTree, (item)=>{
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(item)) {
            const group = item;
            existingGroups.push(group);
        } else {
            const col = item;
            existingColKeys.push(col.getId());
            existingCols.push(col);
        }
    });
    return {
        existingCols: existingCols,
        existingGroups: existingGroups,
        existingColKeys: existingColKeys
    };
}
function $437b23f6a393c3bf$var$_recursivelyCreateColumns(beans, defs, level, primaryColumns, existingColsCopy, columnKeyCreator, existingGroups, source) {
    if (!defs) return [];
    const { colGroupSvc: colGroupSvc } = beans;
    const result = new Array(defs.length);
    for(let i = 0; i < result.length; i++){
        const def = defs[i];
        if (colGroupSvc && $437b23f6a393c3bf$var$isColumnGroupDef(def)) result[i] = colGroupSvc.createProvidedColumnGroup(primaryColumns, def, level, existingColsCopy, columnKeyCreator, existingGroups, source);
        else result[i] = $437b23f6a393c3bf$var$createColumn(beans, primaryColumns, def, existingColsCopy, columnKeyCreator, source);
    }
    return result;
}
function $437b23f6a393c3bf$var$createColumn(beans, primaryColumns, colDef, existingColsCopy, columnKeyCreator, source) {
    const existingColAndIndex = $437b23f6a393c3bf$var$findExistingColumn(colDef, existingColsCopy);
    if (existingColAndIndex) existingColsCopy?.splice(existingColAndIndex.idx, 1);
    let column = existingColAndIndex?.column;
    if (!column) {
        const colId = columnKeyCreator.getUniqueKey(colDef.colId, colDef.field);
        const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, colId);
        column = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDefMerged, colDef, colId, primaryColumns);
        beans.context.createBean(column);
    } else {
        const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, column.getColId());
        column.setColDef(colDefMerged, colDef, source);
        $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDefMerged, source);
    }
    beans.dataTypeSvc?.addColumnListeners(column);
    return column;
}
function $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, hide, sort, sortIndex, pinned, flex, source) {
    const { sortSvc: sortSvc, pinnedCols: pinnedCols, colFlex: colFlex } = beans;
    if (hide !== void 0) column.setVisible(!hide, source);
    if (sortSvc) {
        sortSvc.updateColSort(column, sort, source);
        if (sortIndex !== void 0) sortSvc.setColSortIndex(column, sortIndex);
    }
    if (pinned !== void 0) pinnedCols?.setColPinned(column, pinned);
    if (flex !== void 0) colFlex?.setColFlex(column, flex);
}
function $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDef, source) {
    $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, colDef.hide, colDef.sort, colDef.sortIndex, colDef.pinned, colDef.flex, source);
    const colFlex = column.getFlex();
    if (colFlex != null && colFlex > 0) return;
    if (colDef.width != null) column.setActualWidth(colDef.width, source);
    else {
        const widthBeforeUpdate = column.getActualWidth();
        column.setActualWidth(widthBeforeUpdate, source);
    }
}
function $437b23f6a393c3bf$var$findExistingColumn(newColDef, existingColsCopy) {
    if (!existingColsCopy) return void 0;
    for(let i = 0; i < existingColsCopy.length; i++){
        const def = existingColsCopy[i].getUserProvidedColDef();
        if (!def) continue;
        const newHasId = newColDef.colId != null;
        if (newHasId) {
            if (existingColsCopy[i].getId() === newColDef.colId) return {
                idx: i,
                column: existingColsCopy[i]
            };
            continue;
        }
        const newHasField = newColDef.field != null;
        if (newHasField) {
            if (def.field === newColDef.field) return {
                idx: i,
                column: existingColsCopy[i]
            };
            continue;
        }
        if (def === newColDef) return {
            idx: i,
            column: existingColsCopy[i]
        };
    }
    return void 0;
}
function $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, colId, isAutoCol) {
    const { gos: gos, dataTypeSvc: dataTypeSvc } = beans;
    const res = {};
    const defaultColDef = gos.get("defaultColDef");
    $437b23f6a393c3bf$export$8ade6bd474fcde42(res, defaultColDef, false, true);
    const columnType = $437b23f6a393c3bf$var$updateColDefAndGetColumnType(beans, res, colDef, colId);
    if (columnType) $437b23f6a393c3bf$var$assignColumnTypes(beans, columnType, res);
    const cellDataType = res.cellDataType;
    $437b23f6a393c3bf$export$8ade6bd474fcde42(res, colDef, false, true);
    if (cellDataType !== void 0) res.cellDataType = cellDataType;
    const autoGroupColDef = gos.get("autoGroupColumnDef");
    const isSortingCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
    if (colDef.rowGroup && autoGroupColDef && isSortingCoupled) $437b23f6a393c3bf$export$8ade6bd474fcde42(res, {
        sort: autoGroupColDef.sort,
        initialSort: autoGroupColDef.initialSort
    }, false, true);
    dataTypeSvc?.postProcess(res);
    dataTypeSvc?.validateColDef(res);
    gos.validateColDef(res, colId, isAutoCol);
    return res;
}
function $437b23f6a393c3bf$var$updateColDefAndGetColumnType(beans, colDef, userColDef, colId) {
    const dataTypeDefinitionColumnType = beans.dataTypeSvc?.updateColDefAndGetColumnType(colDef, userColDef, colId);
    const columnTypes = userColDef.type ?? dataTypeDefinitionColumnType ?? colDef.type;
    colDef.type = columnTypes;
    return columnTypes ? $437b23f6a393c3bf$var$convertColumnTypes(columnTypes) : void 0;
}
function $437b23f6a393c3bf$var$assignColumnTypes(beans, typeKeys, colDefMerged) {
    if (!typeKeys.length) return;
    const allColumnTypes = Object.assign({}, $437b23f6a393c3bf$var$DefaultColumnTypes);
    const userTypes = beans.gos.get("columnTypes") || {};
    for (const key of Object.keys(userTypes)){
        const value = userTypes[key];
        if (key in allColumnTypes) $437b23f6a393c3bf$export$545083624300f13d(34, {
            key: key
        });
        else {
            const colType = value;
            if (colType.type) $437b23f6a393c3bf$export$545083624300f13d(35);
            allColumnTypes[key] = value;
        }
    }
    for (const t of typeKeys){
        const typeColDef = allColumnTypes[t.trim()];
        if (typeColDef) $437b23f6a393c3bf$export$8ade6bd474fcde42(colDefMerged, typeColDef, false, true);
        else $437b23f6a393c3bf$export$545083624300f13d(36, {
            t: t
        });
    }
}
function $437b23f6a393c3bf$var$isColumnGroupDef(abstractColDef) {
    return abstractColDef.children !== void 0;
}
function $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(parent, tree, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(child, child.getChildren(), callback);
        callback(child, parent);
    }
}
// packages/ag-grid-community/src/columnMove/columnMoveUtils.ts
function $437b23f6a393c3bf$var$placeLockedColumns(cols, gos) {
    const left = [];
    const normal = [];
    const right = [];
    cols.forEach((col)=>{
        const position = col.getColDef().lockPosition;
        if (position === "right") right.push(col);
        else if (position === "left" || position === true) left.push(col);
        else normal.push(col);
    });
    const isRtl = gos.get("enableRtl");
    if (isRtl) return [
        ...right,
        ...normal,
        ...left
    ];
    return [
        ...left,
        ...normal,
        ...right
    ];
}
function $437b23f6a393c3bf$var$doesMovePassMarryChildren(allColumnsCopy, gridBalancedTree) {
    let rulePassed = true;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, gridBalancedTree, (child)=>{
        if (!$437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) return;
        const columnGroup = child;
        const colGroupDef = columnGroup.getColGroupDef();
        const marryChildren = colGroupDef?.marryChildren;
        if (!marryChildren) return;
        const newIndexes = [];
        for (const col of columnGroup.getLeafColumns()){
            const newColIndex = allColumnsCopy.indexOf(col);
            newIndexes.push(newColIndex);
        }
        const maxIndex = Math.max.apply(Math, newIndexes);
        const minIndex = Math.min.apply(Math, newIndexes);
        const spread = maxIndex - minIndex;
        const maxSpread = columnGroup.getLeafColumns().length - 1;
        if (spread > maxSpread) rulePassed = false;
    });
    return rulePassed;
}
// packages/ag-grid-community/src/columns/columnEventUtils.ts
function $437b23f6a393c3bf$var$getCommonValue(cols, valueGetter) {
    if (!cols || cols.length == 0) return void 0;
    const firstValue = valueGetter(cols[0]);
    for(let i = 1; i < cols.length; i++){
        if (firstValue !== valueGetter(cols[i])) return void 0;
    }
    return firstValue;
}
function $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(eventSvc, changedColumns, source) {
    if (!changedColumns.length) return;
    const column = changedColumns.length === 1 ? changedColumns[0] : null;
    const pinned = $437b23f6a393c3bf$var$getCommonValue(changedColumns, (col)=>col.getPinned());
    eventSvc.dispatchEvent({
        type: "columnPinned",
        // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
        pinned: pinned != null ? pinned : null,
        columns: changedColumns,
        column: column,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnVisibleEvent(eventSvc, changedColumns, source) {
    if (!changedColumns.length) return;
    const column = changedColumns.length === 1 ? changedColumns[0] : null;
    const visible = $437b23f6a393c3bf$var$getCommonValue(changedColumns, (col)=>col.isVisible());
    eventSvc.dispatchEvent({
        type: "columnVisible",
        visible: visible,
        columns: changedColumns,
        column: column,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnChangedEvent(eventSvc, type, columns, source) {
    eventSvc.dispatchEvent({
        type: type,
        columns: columns,
        column: columns && columns.length == 1 ? columns[0] : null,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnResizedEvent(eventSvc, columns, finished, source, flexColumns = null) {
    if (columns?.length) eventSvc.dispatchEvent({
        type: "columnResized",
        columns: columns,
        column: columns.length === 1 ? columns[0] : null,
        flexColumns: flexColumns,
        finished: finished,
        source: source
    });
}
// packages/ag-grid-community/src/columns/columnStateUtils.ts
function $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, params, source) {
    const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, colAnimation: colAnimation, visibleCols: visibleCols, pivotResultCols: pivotResultCols, environment: environment, valueColsSvc: valueColsSvc, eventSvc: eventSvc, gos: gos } = beans;
    const providedCols = colModel.getColDefCols() ?? [];
    const selectionCols = selectionColSvc?.getColumns();
    if (!providedCols.length && !selectionCols?.length) return false;
    if (params?.state && !params.state.forEach) {
        $437b23f6a393c3bf$export$545083624300f13d(32);
        return false;
    }
    const syncColumnWithStateItem = (column, stateItem, rowGroupIndexes, pivotIndexes, autoCol)=>{
        if (!column) return;
        const getValue = $437b23f6a393c3bf$var$getValueFactory(stateItem, params.defaultState);
        const flex = getValue("flex").value1;
        const maybeSortDirection = getValue("sort").value1;
        const maybeSortType = getValue("sortType").value1;
        const isSortUpdate = $437b23f6a393c3bf$export$12c7f6d8339d30ad(maybeSortDirection) || $437b23f6a393c3bf$export$dd4a0f5f19676fa0(maybeSortType);
        const type = $437b23f6a393c3bf$export$fb66185d3079b298(maybeSortType);
        const direction = $437b23f6a393c3bf$export$b26b2467cef719c1(maybeSortDirection);
        const newSortDef = isSortUpdate ? {
            type: type,
            direction: direction
        } : void 0;
        $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, getValue("hide").value1, newSortDef, getValue("sortIndex").value1, getValue("pinned").value1, flex, source);
        if (flex == null) {
            const width = getValue("width").value1;
            if (width != null) {
                const minColWidth = column.getColDef().minWidth ?? environment.getDefaultColumnMinWidth();
                if (minColWidth != null && width >= minColWidth) column.setActualWidth(width, source);
            }
        }
        if (autoCol || !column.isPrimary()) return;
        valueColsSvc?.syncColumnWithState(column, source, getValue);
        rowGroupColsSvc?.syncColumnWithState(column, source, getValue, rowGroupIndexes);
        pivotColsSvc?.syncColumnWithState(column, source, getValue, pivotIndexes);
    };
    const applyStates = (states, existingColumns, getById2)=>{
        const dispatchEventsFunc = $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source);
        const columnsWithNoState = existingColumns.slice();
        const rowGroupIndexes = {};
        const pivotIndexes = {};
        const autoColStates = [];
        const selectionColStates = [];
        const unmatchedAndAutoStates2 = [];
        let unmatchedCount2 = 0;
        const previousRowGroupCols = rowGroupColsSvc?.columns.slice() ?? [];
        const previousPivotCols = pivotColsSvc?.columns.slice() ?? [];
        for (const state of states){
            const colId = state.colId;
            const isAutoGroupColumn = colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
            if (isAutoGroupColumn) {
                autoColStates.push(state);
                unmatchedAndAutoStates2.push(state);
                continue;
            }
            if ($437b23f6a393c3bf$export$f6074a9792015c5d(colId)) {
                selectionColStates.push(state);
                unmatchedAndAutoStates2.push(state);
                continue;
            }
            const column = getById2(colId);
            if (!column) {
                unmatchedAndAutoStates2.push(state);
                unmatchedCount2 += 1;
            } else {
                syncColumnWithStateItem(column, state, rowGroupIndexes, pivotIndexes, false);
                $437b23f6a393c3bf$export$83a881c8b5120679(columnsWithNoState, column);
            }
        }
        const applyDefaultsFunc = (col)=>syncColumnWithStateItem(col, null, rowGroupIndexes, pivotIndexes, false);
        columnsWithNoState.forEach(applyDefaultsFunc);
        rowGroupColsSvc?.sortColumns($437b23f6a393c3bf$var$comparatorByIndex.bind(rowGroupColsSvc, rowGroupIndexes, previousRowGroupCols));
        pivotColsSvc?.sortColumns($437b23f6a393c3bf$var$comparatorByIndex.bind(pivotColsSvc, pivotIndexes, previousPivotCols));
        colModel.refreshCols(false, source);
        const syncColStates = (getCol, colStates, columns = [])=>{
            for (const stateItem of colStates){
                const col = getCol(stateItem.colId);
                $437b23f6a393c3bf$export$83a881c8b5120679(columns, col);
                syncColumnWithStateItem(col, stateItem, null, null, true);
            }
            columns.forEach(applyDefaultsFunc);
        };
        syncColStates((colId)=>autoColSvc?.getColumn(colId) ?? null, autoColStates, autoColSvc?.getColumns()?.slice());
        syncColStates((colId)=>selectionColSvc?.getColumn(colId) ?? null, selectionColStates, selectionColSvc?.getColumns()?.slice());
        $437b23f6a393c3bf$var$orderLiveColsLikeState(params, colModel, gos);
        visibleCols.refresh(source);
        eventSvc.dispatchEvent({
            type: "columnEverythingChanged",
            source: source
        });
        dispatchEventsFunc();
        return {
            unmatchedAndAutoStates: unmatchedAndAutoStates2,
            unmatchedCount: unmatchedCount2
        };
    };
    colAnimation?.start();
    let { unmatchedAndAutoStates: unmatchedAndAutoStates, unmatchedCount: unmatchedCount } = applyStates(params.state || [], providedCols, (id)=>colModel.getColDefCol(id));
    if (unmatchedAndAutoStates.length > 0 || $437b23f6a393c3bf$export$25d27f17d3af40f7(params.defaultState)) {
        const pivotResultColsList = pivotResultCols?.getPivotResultCols()?.list ?? [];
        unmatchedCount = applyStates(unmatchedAndAutoStates, pivotResultColsList, (id)=>pivotResultCols?.getPivotResultCol(id) ?? null).unmatchedCount;
    }
    colAnimation?.finish();
    return unmatchedCount === 0;
}
function $437b23f6a393c3bf$export$96a6cbc000255060(beans, source) {
    const { colModel: colModel, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, eventSvc: eventSvc, gos: gos } = beans;
    const primaryCols = colModel.getColDefCols();
    if (!primaryCols?.length) return;
    const primaryColumnTree = colModel.getColDefColTree();
    const primaryColumns = $437b23f6a393c3bf$export$42da2aea8fab5b(primaryColumnTree);
    const columnStates = [];
    let letRowGroupIndex = 1e3;
    let letPivotIndex = 1e3;
    const addColState = (col)=>{
        const stateItem = $437b23f6a393c3bf$var$getColumnStateFromColDef(col);
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(stateItem.rowGroupIndex) && stateItem.rowGroup) stateItem.rowGroupIndex = letRowGroupIndex++;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(stateItem.pivotIndex) && stateItem.pivot) stateItem.pivotIndex = letPivotIndex++;
        columnStates.push(stateItem);
    };
    autoColSvc?.getColumns()?.forEach(addColState);
    selectionColSvc?.getColumns()?.forEach(addColState);
    primaryColumns?.forEach(addColState);
    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
        state: columnStates
    }, source);
    const autoCols = autoColSvc?.getColumns() ?? [];
    const selectionCols = selectionColSvc?.getColumns() ?? [];
    const orderedCols = [
        ...selectionCols,
        ...autoCols,
        ...primaryCols
    ];
    const orderedColState = orderedCols.map((col)=>({
            colId: col.colId
        }));
    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
        state: orderedColState,
        applyOrder: true
    }, source);
    eventSvc.dispatchEvent($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        type: "columnsReset",
        source: source
    }));
}
function $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source) {
    const { rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, valueColsSvc: valueColsSvc, colModel: colModel, sortSvc: sortSvc, eventSvc: eventSvc } = beans;
    const startState = {
        rowGroupColumns: rowGroupColsSvc?.columns.slice() ?? [],
        pivotColumns: pivotColsSvc?.columns.slice() ?? [],
        valueColumns: valueColsSvc?.columns.slice() ?? []
    };
    const columnStateBefore = $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
    const columnStateBeforeMap = {};
    for (const col of columnStateBefore)columnStateBeforeMap[col.colId] = col;
    return ()=>{
        const dispatchWhenListsDifferent = (eventType, colsBefore, colsAfter, idMapper)=>{
            const beforeList = colsBefore.map(idMapper);
            const afterList = colsAfter.map(idMapper);
            const unchanged = $437b23f6a393c3bf$export$893967cdb9833fdd(beforeList, afterList);
            if (unchanged) return;
            const changes = new Set(colsBefore);
            for (const id of colsAfter)if (!changes.delete(id)) changes.add(id);
            const changesArr = [
                ...changes
            ];
            eventSvc.dispatchEvent({
                type: eventType,
                columns: changesArr,
                column: changesArr.length === 1 ? changesArr[0] : null,
                source: source
            });
        };
        const getChangedColumns = (changedPredicate)=>{
            const changedColumns2 = [];
            colModel.forAllCols((column)=>{
                const colStateBefore = columnStateBeforeMap[column.getColId()];
                if (colStateBefore && changedPredicate(colStateBefore, column)) changedColumns2.push(column);
            });
            return changedColumns2;
        };
        const columnIdMapper = (c)=>c.getColId();
        dispatchWhenListsDifferent("columnRowGroupChanged", startState.rowGroupColumns, rowGroupColsSvc?.columns ?? [], columnIdMapper);
        dispatchWhenListsDifferent("columnPivotChanged", startState.pivotColumns, pivotColsSvc?.columns ?? [], columnIdMapper);
        const valueChangePredicate = (cs, c)=>{
            const oldActive = cs.aggFunc != null;
            const activeChanged = oldActive != c.isValueActive();
            const aggFuncChanged = oldActive && cs.aggFunc != c.getAggFunc();
            return activeChanged || aggFuncChanged;
        };
        const changedValues = getChangedColumns(valueChangePredicate);
        if (changedValues.length > 0) $437b23f6a393c3bf$var$dispatchColumnChangedEvent(eventSvc, "columnValueChanged", changedValues, source);
        const resizeChangePredicate = (cs, c)=>cs.width != c.getActualWidth();
        $437b23f6a393c3bf$var$dispatchColumnResizedEvent(eventSvc, getChangedColumns(resizeChangePredicate), true, source);
        const pinnedChangePredicate = (cs, c)=>cs.pinned != c.getPinned();
        $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(eventSvc, getChangedColumns(pinnedChangePredicate), source);
        const visibilityChangePredicate = (cs, c)=>cs.hide == c.isVisible();
        $437b23f6a393c3bf$var$dispatchColumnVisibleEvent(eventSvc, getChangedColumns(visibilityChangePredicate), source);
        const sortChangePredicate = (cs, c)=>!$437b23f6a393c3bf$export$1d4824b7d3b8a5c8(c.getSortDef(), {
                type: $437b23f6a393c3bf$export$fb66185d3079b298(cs.sortType),
                direction: $437b23f6a393c3bf$export$b26b2467cef719c1(cs.sort)
            }) || cs.sortIndex != c.getSortIndex();
        const changedColumns = getChangedColumns(sortChangePredicate);
        if (changedColumns.length > 0) sortSvc?.dispatchSortChangedEvents(source, changedColumns);
        const colStateAfter = $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
        $437b23f6a393c3bf$var$normaliseColumnMovedEventForColumnState(columnStateBefore, colStateAfter, source, colModel, eventSvc);
    };
}
function $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans) {
    const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = beans;
    const primaryCols = colModel.getColDefCols();
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(primaryCols) || !colModel.isAlive()) return [];
    const rowGroupColumns = rowGroupColsSvc?.columns;
    const pivotColumns = pivotColsSvc?.columns;
    const res = [];
    const createStateItemFromColumn = (column)=>{
        const rowGroupIndex = column.isRowGroupActive() && rowGroupColumns ? rowGroupColumns.indexOf(column) : null;
        const pivotIndex = column.isPivotActive() && pivotColumns ? pivotColumns.indexOf(column) : null;
        const aggFunc = column.isValueActive() ? column.getAggFunc() : null;
        const sortIndex = column.getSortIndex() != null ? column.getSortIndex() : null;
        res.push({
            colId: column.getColId(),
            width: column.getActualWidth(),
            hide: !column.isVisible(),
            pinned: column.getPinned(),
            sort: column.getSort(),
            sortType: column.getSortDef()?.type,
            sortIndex: sortIndex,
            aggFunc: aggFunc,
            rowGroup: column.isRowGroupActive(),
            rowGroupIndex: rowGroupIndex,
            pivot: column.isPivotActive(),
            pivotIndex: pivotIndex,
            flex: column.getFlex() ?? null
        });
    };
    colModel.forAllCols((col)=>createStateItemFromColumn(col));
    const colIdToGridIndexMap = new Map(colModel.getCols().map((col, index)=>[
            col.getColId(),
            index
        ]));
    res.sort((itemA, itemB)=>{
        const posA = colIdToGridIndexMap.has(itemA.colId) ? colIdToGridIndexMap.get(itemA.colId) : -1;
        const posB = colIdToGridIndexMap.has(itemB.colId) ? colIdToGridIndexMap.get(itemB.colId) : -1;
        return posA - posB;
    });
    return res;
}
function $437b23f6a393c3bf$var$getColumnStateFromColDef(column) {
    const getValueOrNull = (a, b)=>a != null ? a : b != null ? b : null;
    const colDef = column.getColDef();
    const sortDefFromColDef = $437b23f6a393c3bf$export$2a92f4fc1f337c5a(getValueOrNull(colDef.sort, colDef.initialSort));
    const sort = sortDefFromColDef.direction;
    const sortType = sortDefFromColDef.type;
    const sortIndex = getValueOrNull(colDef.sortIndex, colDef.initialSortIndex);
    const hide = getValueOrNull(colDef.hide, colDef.initialHide);
    const pinned = getValueOrNull(colDef.pinned, colDef.initialPinned);
    const width = getValueOrNull(colDef.width, colDef.initialWidth);
    const flex = getValueOrNull(colDef.flex, colDef.initialFlex);
    let rowGroupIndex = getValueOrNull(colDef.rowGroupIndex, colDef.initialRowGroupIndex);
    let rowGroup = getValueOrNull(colDef.rowGroup, colDef.initialRowGroup);
    if (rowGroupIndex == null && !rowGroup) {
        rowGroupIndex = null;
        rowGroup = null;
    }
    let pivotIndex = getValueOrNull(colDef.pivotIndex, colDef.initialPivotIndex);
    let pivot = getValueOrNull(colDef.pivot, colDef.initialPivot);
    if (pivotIndex == null && !pivot) {
        pivotIndex = null;
        pivot = null;
    }
    const aggFunc = getValueOrNull(colDef.aggFunc, colDef.initialAggFunc);
    return {
        colId: column.getColId(),
        sort: sort,
        sortType: sortType,
        sortIndex: sortIndex,
        hide: hide,
        pinned: pinned,
        width: width,
        flex: flex,
        rowGroup: rowGroup,
        rowGroupIndex: rowGroupIndex,
        pivot: pivot,
        pivotIndex: pivotIndex,
        aggFunc: aggFunc
    };
}
function $437b23f6a393c3bf$var$orderLiveColsLikeState(params, colModel, gos) {
    if (!params.applyOrder || !params.state) return;
    const colIds = [];
    for (const item of params.state)if (item.colId != null) colIds.push(item.colId);
    $437b23f6a393c3bf$var$sortColsLikeKeys(colModel.cols, colIds, colModel, gos);
}
function $437b23f6a393c3bf$var$sortColsLikeKeys(cols, colIds, colModel, gos) {
    if (cols == null) return;
    let newOrder = [];
    const processedColIds = {};
    for (const colId of colIds){
        if (processedColIds[colId]) continue;
        const col = cols.map[colId];
        if (col) {
            newOrder.push(col);
            processedColIds[colId] = true;
        }
    }
    let autoGroupInsertIndex = 0;
    for (const col of cols.list){
        const colId = col.getColId();
        const alreadyProcessed = processedColIds[colId] != null;
        if (alreadyProcessed) continue;
        const isAutoGroupCol = colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
        if (isAutoGroupCol) newOrder.splice(autoGroupInsertIndex++, 0, col);
        else newOrder.push(col);
    }
    newOrder = $437b23f6a393c3bf$var$placeLockedColumns(newOrder, gos);
    if (!$437b23f6a393c3bf$var$doesMovePassMarryChildren(newOrder, colModel.getColTree())) {
        $437b23f6a393c3bf$export$545083624300f13d(39);
        return;
    }
    cols.list = newOrder;
}
function $437b23f6a393c3bf$var$normaliseColumnMovedEventForColumnState(colStateBefore, colStateAfter, source, colModel, eventSvc) {
    const colStateAfterMapped = {};
    for (const s of colStateAfter)colStateAfterMapped[s.colId] = s;
    const colsIntersectIds = {};
    for (const s of colStateBefore)if (colStateAfterMapped[s.colId]) colsIntersectIds[s.colId] = true;
    const beforeFiltered = colStateBefore.filter((c)=>colsIntersectIds[c.colId]);
    const afterFiltered = colStateAfter.filter((c)=>colsIntersectIds[c.colId]);
    const movedColumns = [];
    afterFiltered.forEach((csAfter, index)=>{
        const csBefore = beforeFiltered?.[index];
        if (csBefore && csBefore.colId !== csAfter.colId) {
            const gridCol = colModel.getCol(csBefore.colId);
            if (gridCol) movedColumns.push(gridCol);
        }
    });
    if (!movedColumns.length) return;
    eventSvc.dispatchEvent({
        type: "columnMoved",
        columns: movedColumns,
        column: movedColumns.length === 1 ? movedColumns[0] : null,
        finished: true,
        source: source
    });
}
var $437b23f6a393c3bf$var$comparatorByIndex = (indexes, oldList, colA, colB)=>{
    const indexA = indexes[colA.getId()];
    const indexB = indexes[colB.getId()];
    const aHasIndex = indexA != null;
    const bHasIndex = indexB != null;
    if (aHasIndex && bHasIndex) return indexA - indexB;
    if (aHasIndex) return -1;
    if (bHasIndex) return 1;
    const oldIndexA = oldList.indexOf(colA);
    const oldIndexB = oldList.indexOf(colB);
    const aHasOldIndex = oldIndexA >= 0;
    const bHasOldIndex = oldIndexB >= 0;
    if (aHasOldIndex && bHasOldIndex) return oldIndexA - oldIndexB;
    if (aHasOldIndex) return -1;
    return 1;
};
// packages/ag-grid-community/src/columns/columnModel.ts
var $437b23f6a393c3bf$var$ColumnModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colModel";
        // if pivotMode is on, however pivot results are NOT shown if no pivot columns are set
        this.pivotMode = false;
        this.ready = false;
        this.changeEventsDispatching = false;
    }
    postConstruct() {
        this.pivotMode = this.gos.get("pivotMode");
        this.addManagedPropertyListeners([
            "groupDisplayType",
            "treeData",
            "treeDataDisplayType",
            "groupHideOpenParents",
            "rowNumbers",
            "hidePaddedHeaderRows"
        ], (event)=>this.refreshAll($437b23f6a393c3bf$export$eb2a92b6162267d1(event.source)));
        this.addManagedPropertyListeners([
            "defaultColDef",
            "defaultColGroupDef",
            "columnTypes",
            "suppressFieldDotNotation"
        ], this.recreateColumnDefs.bind(this));
        this.addManagedPropertyListener("pivotMode", (event)=>this.setPivotMode(this.gos.get("pivotMode"), $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source)));
    }
    // called from SyncService, when grid has finished initialising
    createColsFromColDefs(source) {
        const { beans: beans } = this;
        const { valueCache: valueCache, colAutosize: colAutosize, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, valueColsSvc: valueColsSvc, visibleCols: visibleCols, eventSvc: eventSvc, groupHierarchyColSvc: groupHierarchyColSvc } = beans;
        const dispatchEventsFunc = this.colDefs ? $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source) : void 0;
        valueCache?.expire();
        const oldCols = this.colDefCols?.list;
        const oldTree = this.colDefCols?.tree;
        const newTree = $437b23f6a393c3bf$export$e03b26088dedc2ab(beans, this.colDefs, true, oldTree, source);
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(beans, this.colDefCols?.tree, newTree.columnTree);
        const tree = newTree.columnTree;
        const treeDepth = newTree.treeDepth;
        const list = $437b23f6a393c3bf$export$42da2aea8fab5b(tree);
        const map = {};
        for (const col of list)map[col.getId()] = col;
        this.colDefCols = {
            tree: tree,
            treeDepth: treeDepth,
            list: list,
            map: map
        };
        this.createColumnsForService([
            groupHierarchyColSvc
        ], this.colDefCols, source);
        rowGroupColsSvc?.extractCols(source, oldCols);
        pivotColsSvc?.extractCols(source, oldCols);
        valueColsSvc?.extractCols(source, oldCols);
        this.ready = true;
        this.changeEventsDispatching = true;
        this.refreshCols(true, source);
        this.changeEventsDispatching = false;
        visibleCols.refresh(source);
        eventSvc.dispatchEvent({
            type: "columnEverythingChanged",
            source: source
        });
        if (dispatchEventsFunc) {
            this.changeEventsDispatching = true;
            dispatchEventsFunc();
            this.changeEventsDispatching = false;
        }
        eventSvc.dispatchEvent({
            type: "newColumnsLoaded",
            source: source
        });
        if (source === "gridInitializing") colAutosize?.applyAutosizeStrategy();
    }
    // called from: buildAutoGroupColumns (events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents')
    // createColsFromColDefs (recreateColumnDefs, setColumnsDefs),
    // setPivotMode, applyColumnState,
    // functionColsService.setPrimaryColList, functionColsService.updatePrimaryColList,
    // pivotResultCols.setPivotResultCols
    refreshCols(newColDefs, source) {
        if (!this.colDefCols) return;
        const prevColTree = this.cols?.tree;
        this.saveColOrder();
        const { autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, rowNumbersSvc: rowNumbersSvc, quickFilter: quickFilter, pivotResultCols: pivotResultCols, showRowGroupCols: showRowGroupCols, rowAutoHeight: rowAutoHeight, visibleCols: visibleCols, colViewport: colViewport, eventSvc: eventSvc, formula: formula } = this.beans;
        const cols = this.selectCols(pivotResultCols, this.colDefCols);
        formula?.setFormulasActive(cols);
        this.createColumnsForService([
            autoColSvc,
            selectionColSvc,
            rowNumbersSvc
        ], cols, source);
        const shouldSortNewColDefs = $437b23f6a393c3bf$var$_shouldMaintainColumnOrder(this.gos, this.showingPivotResult);
        if (!newColDefs || shouldSortNewColDefs) this.restoreColOrder(cols);
        this.positionLockedCols(cols);
        showRowGroupCols?.refresh();
        quickFilter?.refreshCols();
        this.setColSpanActive();
        rowAutoHeight?.setAutoHeightActive(cols);
        visibleCols.clear();
        colViewport.clear();
        if (!$437b23f6a393c3bf$export$893967cdb9833fdd(prevColTree, this.cols.tree)) eventSvc.dispatchEvent({
            type: "gridColumnsChanged"
        });
    }
    createColumnsForService(services, cols, source) {
        for (const service of services){
            if (!service) continue;
            service.createColumns(cols, (updateOrder)=>{
                this.lastOrder = updateOrder(this.lastOrder);
                this.lastPivotOrder = updateOrder(this.lastPivotOrder);
            }, source);
            service.addColumns(cols);
        }
    }
    selectCols(pivotResultColsSvc, colDefCols) {
        const pivotResultCols = pivotResultColsSvc?.getPivotResultCols() ?? null;
        this.showingPivotResult = pivotResultCols != null;
        const { map: map, list: list, tree: tree, treeDepth: treeDepth } = pivotResultCols ?? colDefCols;
        this.cols = {
            list: list.slice(),
            map: {
                ...map
            },
            tree: tree.slice(),
            treeDepth: treeDepth
        };
        if (pivotResultCols) {
            const hasSameColumns = pivotResultCols.list.some((col)=>this.cols?.map[col.getColId()] !== void 0);
            if (!hasSameColumns) this.lastPivotOrder = null;
        }
        return this.cols;
    }
    getColsToShow() {
        if (!this.cols) return [];
        const { beans: beans, showingPivotResult: showingPivotResult, cols: cols } = this;
        const { valueColsSvc: valueColsSvc, selectionColSvc: selectionColSvc } = beans;
        const showAutoGroupAndValuesOnly = this.isPivotMode() && !showingPivotResult;
        const showSelectionColumn = selectionColSvc?.isSelectionColumnEnabled();
        const showRowNumbers = $437b23f6a393c3bf$export$58f4eed4127eb370(beans);
        const valueColumns = valueColsSvc?.columns;
        const res = cols.list.filter((col)=>{
            const isAutoGroupCol = $437b23f6a393c3bf$export$61b34611dc010a97(col);
            if (showAutoGroupAndValuesOnly) {
                const isValueCol = valueColumns?.includes(col);
                return isAutoGroupCol || isValueCol || showSelectionColumn && $437b23f6a393c3bf$export$f6074a9792015c5d(col) || showRowNumbers && $437b23f6a393c3bf$export$3d3e7d751f0445eb(col);
            } else return isAutoGroupCol || col.isVisible();
        });
        return res;
    }
    // on events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents'
    refreshAll(source) {
        if (!this.ready) return;
        this.refreshCols(false, source);
        this.beans.visibleCols.refresh(source);
    }
    setColsVisible(keys, visible = false, source) {
        $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
            state: keys.map((key)=>({
                    colId: typeof key === "string" ? key : key.getColId(),
                    hide: !visible
                }))
        }, source);
    }
    /**
   * Restores provided columns order to the previous order in this.lastPivotOrder / this.lastOrder
   * If columns are not in the last order:
   *  - Check column groups, and apply column after the last column in the lowest shared group
   *  - If no sibling is found, apply the column at the end of the cols
   */ restoreColOrder(cols) {
        const lastOrder = this.showingPivotResult ? this.lastPivotOrder : this.lastOrder;
        if (!lastOrder) return;
        const preservedOrder = lastOrder.filter((col)=>cols.map[col.getId()] != null);
        if (preservedOrder.length === 0) return;
        if (preservedOrder.length === cols.list.length) {
            cols.list = preservedOrder;
            return;
        }
        const hasSiblings = (col)=>{
            const ancestor = col.getOriginalParent();
            if (!ancestor) return false;
            const children = ancestor.getChildren();
            if (children.length > 1) return true;
            return hasSiblings(ancestor);
        };
        if (!preservedOrder.some((col)=>hasSiblings(col))) {
            const preservedOrderSet = new Set(preservedOrder);
            for (const col of cols.list)if (!preservedOrderSet.has(col)) preservedOrder.push(col);
            cols.list = preservedOrder;
            return;
        }
        const colPositionMap = /* @__PURE__ */ new Map();
        for(let i = 0; i < preservedOrder.length; i++){
            const col = preservedOrder[i];
            colPositionMap.set(col, i);
        }
        const additionalCols = cols.list.filter((col)=>!colPositionMap.has(col));
        if (additionalCols.length === 0) {
            cols.list = preservedOrder;
            return;
        }
        const getPreviousSibling = (col, group)=>{
            const parent = group ? group.getOriginalParent() : col.getOriginalParent();
            if (!parent) return null;
            let highestIdx = null;
            let highestSibling = null;
            for (const child of parent.getChildren()){
                if (child === group || child === col) continue;
                if (child instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2) {
                    const colIdx = colPositionMap.get(child);
                    if (colIdx == null) continue;
                    if (highestIdx == null || highestIdx < colIdx) {
                        highestIdx = colIdx;
                        highestSibling = child;
                    }
                    continue;
                }
                child.forEachLeafColumn((leafCol)=>{
                    const colIdx = colPositionMap.get(leafCol);
                    if (colIdx == null) return;
                    if (highestIdx == null || highestIdx < colIdx) {
                        highestIdx = colIdx;
                        highestSibling = leafCol;
                    }
                });
            }
            if (highestSibling == null) return getPreviousSibling(col, parent);
            return highestSibling;
        };
        const noSiblingsAvailable = [];
        const previousSiblingPosMap = /* @__PURE__ */ new Map();
        for (const col of additionalCols){
            const prevSiblingIdx = getPreviousSibling(col, null);
            if (prevSiblingIdx == null) {
                noSiblingsAvailable.push(col);
                continue;
            }
            const prev = previousSiblingPosMap.get(prevSiblingIdx);
            if (prev === void 0) previousSiblingPosMap.set(prevSiblingIdx, col);
            else if (Array.isArray(prev)) prev.push(col);
            else previousSiblingPosMap.set(prevSiblingIdx, [
                prev,
                col
            ]);
        }
        const result = new Array(cols.list.length);
        let resultPointer = result.length - 1;
        for(let i = noSiblingsAvailable.length - 1; i >= 0; i--)result[resultPointer--] = noSiblingsAvailable[i];
        for(let i = preservedOrder.length - 1; i >= 0; i--){
            const nextCol = preservedOrder[i];
            const extraCols = previousSiblingPosMap.get(nextCol);
            if (extraCols) {
                if (Array.isArray(extraCols)) for(let x = extraCols.length - 1; x >= 0; x--){
                    const col = extraCols[x];
                    result[resultPointer--] = col;
                }
                else result[resultPointer--] = extraCols;
            }
            result[resultPointer--] = nextCol;
        }
        cols.list = result;
    }
    positionLockedCols(cols) {
        cols.list = $437b23f6a393c3bf$var$placeLockedColumns(cols.list, this.gos);
    }
    saveColOrder() {
        if (this.showingPivotResult) this.lastPivotOrder = this.cols?.list ?? null;
        else this.lastOrder = this.cols?.list ?? null;
    }
    getColumnDefs(sorted) {
        return this.colDefCols && this.beans.colDefFactory?.getColumnDefs(this.colDefCols.list, this.showingPivotResult, this.lastOrder, this.cols?.list ?? [], sorted);
    }
    setColSpanActive() {
        this.colSpanActive = !!this.cols?.list.some((col)=>col.getColDef().colSpan != null);
    }
    isPivotMode() {
        return this.pivotMode;
    }
    setPivotMode(pivotMode, source) {
        if (pivotMode === this.pivotMode) return;
        this.pivotMode = pivotMode;
        if (!this.ready) return;
        this.refreshCols(false, source);
        const { visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        visibleCols.refresh(source);
        eventSvc.dispatchEvent({
            type: "columnPivotModeChanged"
        });
    }
    // + clientSideRowModel
    isPivotActive() {
        const pivotColumns = this.beans.pivotColsSvc?.columns;
        return this.pivotMode && !!pivotColumns?.length;
    }
    // called when dataTypes change
    recreateColumnDefs(e) {
        if (!this.cols) return;
        this.beans.autoColSvc?.updateColumns(e);
        const source = $437b23f6a393c3bf$export$eb2a92b6162267d1(e.source);
        this.createColsFromColDefs(source);
    }
    setColumnDefs(columnDefs, source) {
        this.colDefs = columnDefs;
        this.createColsFromColDefs(source);
    }
    destroy() {
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.colDefCols?.tree);
        super.destroy();
    }
    getColTree() {
        return this.cols?.tree ?? [];
    }
    // + columnSelectPanel
    getColDefColTree() {
        return this.colDefCols?.tree ?? [];
    }
    // + clientSideRowController -> sorting, building quick filter text
    // + headerRenderer -> sorting (clearing icon)
    getColDefCols() {
        return this.colDefCols?.list ?? null;
    }
    // + moveColumnController
    getCols() {
        return this.cols?.list ?? [];
    }
    /**
   * If callback returns true, exit early.
   */ forAllCols(callback) {
        const { pivotResultCols: pivotResultCols, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, groupHierarchyColSvc: groupHierarchyColSvc } = this.beans;
        if ($437b23f6a393c3bf$var$_forAll(this.colDefCols?.list, callback)) return;
        if ($437b23f6a393c3bf$var$_forAll(autoColSvc?.columns?.list, callback)) return;
        if ($437b23f6a393c3bf$var$_forAll(selectionColSvc?.columns?.list, callback)) return;
        if ($437b23f6a393c3bf$var$_forAll(groupHierarchyColSvc?.columns?.list, callback)) return;
        if ($437b23f6a393c3bf$var$_forAll(pivotResultCols?.getPivotResultCols()?.list, callback)) return;
    }
    getColsForKeys(keys) {
        if (!keys) return [];
        return keys.map((key)=>this.getCol(key)).filter((col)=>col != null);
    }
    getColDefCol(key) {
        if (!this.colDefCols?.list) return null;
        return this.getColFromCollection(key, this.colDefCols);
    }
    getCol(key) {
        if (key == null) return null;
        return this.getColFromCollection(key, this.cols);
    }
    /**
   * Get column exclusively by ID.
   *
   * Note getCol/getColFromCollection have poor performance when col has been removed.
   */ getColById(key) {
        return this.cols?.map[key] ?? null;
    }
    getColFromCollection(key, cols) {
        if (cols == null) return null;
        const { map: map, list: list } = cols;
        if (typeof key == "string" && map[key]) return map[key];
        for(let i = 0; i < list.length; i++){
            if ($437b23f6a393c3bf$export$f5687d41c39fa1b3(list[i], key)) return list[i];
        }
        const { autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, groupHierarchyColSvc: groupHierarchyColSvc } = this.beans;
        return autoColSvc?.getColumn(key) ?? selectionColSvc?.getColumn(key) ?? groupHierarchyColSvc?.getColumn(key) ?? null;
    }
};
// packages/ag-grid-community/src/columns/baseColsService.ts
var $437b23f6a393c3bf$export$3687f0f5678a5df3 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.dispatchColumnChangedEvent = $437b23f6a393c3bf$var$dispatchColumnChangedEvent;
        this.columns = [];
        this.columnIndexMap = {};
        this.updateIndexMap = ()=>{
            this.columnIndexMap = {};
            this.columns.forEach((col, index)=>this.columnIndexMap[col.getId()] = index);
        };
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.aggFuncSvc = beans.aggFuncSvc;
        this.visibleCols = beans.visibleCols;
        this.groupHierarchCols = beans.groupHierarchyColSvc;
    }
    sortColumns(compareFn) {
        const { groupHierarchCols: groupHierarchCols } = this;
        this.columns.sort((a, b)=>groupHierarchCols?.compareVirtualColumns(a, b) ?? compareFn(a, b));
        this.updateIndexMap();
    }
    setColumns(colKeys, source) {
        this.setColList(colKeys, this.columns, this.eventName, true, true, this.columnProcessors.set, source);
    }
    addColumns(colKeys, source) {
        this.updateColList(colKeys, this.columns, true, true, this.columnProcessors.add, this.eventName, source);
    }
    removeColumns(colKeys, source) {
        this.updateColList(colKeys, this.columns, false, true, this.columnProcessors.remove, this.eventName, source);
    }
    getColumnIndex(colId) {
        return this.columnIndexMap[colId];
    }
    setColList(colKeys = [], masterList, eventName, detectOrderChange, autoGroupsNeedBuilding, columnCallback, source) {
        const gridColumns = this.colModel.getCols();
        if (!gridColumns || gridColumns.length === 0) return;
        const changes = /* @__PURE__ */ new Map();
        masterList.forEach((col, idx)=>changes.set(col, idx));
        masterList.length = 0;
        for (const key of colKeys){
            const column = this.colModel.getColDefCol(key);
            if (column) masterList.push(column);
        }
        masterList.forEach((col, idx)=>{
            const oldIndex = changes.get(col);
            if (oldIndex === void 0) {
                changes.set(col, 0);
                return;
            }
            if (detectOrderChange && oldIndex !== idx) return;
            changes.delete(col);
        });
        this.updateIndexMap();
        const primaryCols = this.colModel.getColDefCols();
        for (const column of primaryCols ?? []){
            const added = masterList.indexOf(column) >= 0;
            columnCallback(column, added, source);
        }
        autoGroupsNeedBuilding && this.colModel.refreshCols(false, source);
        this.visibleCols.refresh(source);
        this.dispatchColumnChangedEvent(this.eventSvc, eventName, [
            ...changes.keys()
        ], source);
    }
    updateColList(keys = [], masterList, actionIsAdd, autoGroupsNeedBuilding, columnCallback, eventType, source) {
        if (!keys || keys.length === 0) return;
        let atLeastOne = false;
        const updatedCols = /* @__PURE__ */ new Set();
        for (const key of keys){
            if (!key) continue;
            const columnToAdd = this.colModel.getColDefCol(key);
            if (!columnToAdd) continue;
            updatedCols.add(columnToAdd);
            if (actionIsAdd) {
                if (masterList.indexOf(columnToAdd) >= 0) continue;
                masterList.push(columnToAdd);
            } else {
                const currentIndex = masterList.indexOf(columnToAdd);
                if (currentIndex < 0) continue;
                for(let i = currentIndex + 1; i < masterList.length; i++)updatedCols.add(masterList[i]);
                $437b23f6a393c3bf$export$83a881c8b5120679(masterList, columnToAdd);
            }
            columnCallback(columnToAdd, actionIsAdd, source);
            atLeastOne = true;
        }
        if (!atLeastOne) return;
        this.updateIndexMap();
        if (autoGroupsNeedBuilding) this.colModel.refreshCols(false, source);
        this.visibleCols.refresh(source);
        const eventColumns = Array.from(updatedCols);
        this.eventSvc.dispatchEvent({
            type: eventType,
            columns: eventColumns,
            column: eventColumns.length === 1 ? eventColumns[0] : null,
            source: source
        });
    }
    extractCols(source, oldProvidedCols = []) {
        const previousCols = this.columns;
        const colsWithIndex = [];
        const colsWithValue = [];
        const { setFlagFunc: setFlagFunc, getIndexFunc: getIndexFunc, getInitialIndexFunc: getInitialIndexFunc, getValueFunc: getValueFunc, getInitialValueFunc: getInitialValueFunc } = this.columnExtractors;
        const primaryCols = this.colModel.getColDefCols();
        for (const col of primaryCols ?? []){
            const colIsNew = !oldProvidedCols.includes(col);
            const colDef = col.getColDef();
            const value = getValueFunc(colDef);
            const initialValue = getInitialValueFunc(colDef);
            const index = getIndexFunc(colDef);
            const initialIndex = getInitialIndexFunc(colDef);
            let include;
            const valuePresent = value !== void 0;
            const indexPresent = index !== void 0;
            const initialValuePresent = initialValue !== void 0;
            const initialIndexPresent = initialIndex !== void 0;
            if (valuePresent) include = value;
            else if (indexPresent) {
                if (index === null) include = false;
                else include = index >= 0;
            } else if (colIsNew) {
                if (initialValuePresent) include = initialValue;
                else if (initialIndexPresent) include = initialIndex != null && initialIndex >= 0;
                else include = false;
            } else include = previousCols.indexOf(col) >= 0;
            if (include) {
                const useIndex = colIsNew ? index != null || initialIndex != null : index != null;
                useIndex ? colsWithIndex.push(col) : colsWithValue.push(col);
            }
        }
        const getIndexForCol = (col)=>{
            const colDef = col.getColDef();
            return getIndexFunc(colDef) ?? getInitialIndexFunc(colDef);
        };
        colsWithIndex.sort((colA, colB)=>getIndexForCol(colA) - getIndexForCol(colB));
        const res = [];
        const groupHierarchCols = this.groupHierarchCols;
        const addCol = (col)=>{
            if (groupHierarchCols) groupHierarchCols.expandColumnInto(res, col);
            else res.push(col);
        };
        colsWithIndex.forEach(addCol);
        for (const col of previousCols)if (colsWithValue.indexOf(col) >= 0) addCol(col);
        for (const col of colsWithValue)if (res.indexOf(col) < 0) addCol(col);
        for (const col of previousCols)if (res.indexOf(col) < 0) setFlagFunc(col, false, source);
        for (const col of res)if (previousCols.indexOf(col) < 0) setFlagFunc(col, true, source);
        this.columns = res;
        this.updateIndexMap();
        return this.columns;
    }
    restoreColumnOrder(columnStateAccumulator, incomingColumnState) {
        const colList = this.columns;
        const primaryCols = this.colModel.getColDefCols();
        if (!colList.length || !primaryCols) return columnStateAccumulator;
        const updatedColIdArray = Object.keys(incomingColumnState);
        const updatedColIds = new Set(updatedColIdArray);
        const newColIds = new Set(updatedColIdArray);
        const allColIds = new Set(colList.map((column)=>{
            const colId = column.getColId();
            newColIds.delete(colId);
            return colId;
        }).concat(updatedColIdArray));
        const colIdsInOriginalOrder = [];
        const originalOrderMap = {};
        let orderIndex = 0;
        for(let i = 0; i < primaryCols.length; i++){
            const colId = primaryCols[i].getColId();
            if (allColIds.has(colId)) {
                colIdsInOriginalOrder.push(colId);
                originalOrderMap[colId] = orderIndex++;
            }
        }
        let index = 1e3;
        let hasAddedNewCols = false;
        let lastIndex = 0;
        const enableProp = this.columnOrdering.enableProp;
        const initialEnableProp = this.columnOrdering.initialEnableProp;
        const indexProp = this.columnOrdering.indexProp;
        const initialIndexProp = this.columnOrdering.initialIndexProp;
        const processPrecedingNewCols = (colId)=>{
            const originalOrderIndex = originalOrderMap[colId];
            for(let i = lastIndex; i < originalOrderIndex; i++){
                const newColId = colIdsInOriginalOrder[i];
                if (newColIds.has(newColId)) {
                    incomingColumnState[newColId][indexProp] = index++;
                    newColIds.delete(newColId);
                }
            }
            lastIndex = originalOrderIndex;
        };
        for (const column of colList){
            const colId = column.getColId();
            if (updatedColIds.has(colId)) {
                processPrecedingNewCols(colId);
                incomingColumnState[colId][indexProp] = index++;
            } else {
                const colDef = column.getColDef();
                const missingIndex = colDef[indexProp] === null || colDef[indexProp] === void 0 && colDef[initialIndexProp] == null;
                if (missingIndex) {
                    if (!hasAddedNewCols) {
                        const propEnabled = colDef[enableProp] || colDef[enableProp] === void 0 && colDef[initialEnableProp];
                        if (propEnabled) processPrecedingNewCols(colId);
                        else {
                            for (const newColId of newColIds)incomingColumnState[newColId][indexProp] = index + originalOrderMap[newColId];
                            index += colIdsInOriginalOrder.length;
                            hasAddedNewCols = true;
                        }
                    }
                    if (!columnStateAccumulator[colId]) columnStateAccumulator[colId] = {
                        colId: colId
                    };
                    columnStateAccumulator[colId][indexProp] = index++;
                }
            }
        }
        return columnStateAccumulator;
    }
};
// packages/ag-grid-community/src/columns/groupInstanceIdCreator.ts
var $437b23f6a393c3bf$export$b3b24737a74261fb = class {
    constructor(){
        // this map contains keys to numbers, so we remember what the last call was
        this.existingIds = {};
    }
    getInstanceIdForKey(key) {
        const lastResult = this.existingIds[key];
        let result;
        if (typeof lastResult !== "number") result = 0;
        else result = lastResult + 1;
        this.existingIds[key] = result;
        return result;
    }
};
// packages/ag-grid-community/src/components/emptyBean.ts
var $437b23f6a393c3bf$export$4f8bbae47c6ad8d2 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
};
function $437b23f6a393c3bf$var$setupCompBean(ctrl, ctx, compBean) {
    if (compBean) ctrl.addDestroyFunc(()=>ctx.destroyBean(compBean));
    return compBean ?? ctrl;
}
// packages/ag-grid-community/src/agStack/interfaces/agComponent.ts
var $437b23f6a393c3bf$export$6c811454646ed8be = null;
function $437b23f6a393c3bf$export$e9be47ed2688240e(item) {
    return typeof item?.getGui === "function";
}
// packages/ag-grid-community/src/agStack/rendering/cssClassManager.ts
var $437b23f6a393c3bf$export$a7053cb7eb605bd2 = class {
    constructor(getGui){
        // to minimise DOM hits, we only apply CSS classes if they have changed. as adding a CSS class that is already
        // there, or removing one that wasn't present, all takes CPU.
        this.cssClassStates = {};
        this.getGui = getGui;
    }
    toggleCss(className, addOrRemove) {
        if (!className) return;
        if (className.includes(" ")) {
            const list = (className || "").split(" ");
            if (list.length > 1) {
                for (const cls of list)this.toggleCss(cls, addOrRemove);
                return;
            }
        }
        const updateNeeded = this.cssClassStates[className] !== addOrRemove;
        if (updateNeeded && className.length) {
            this.getGui()?.classList.toggle(className, addOrRemove);
            this.cssClassStates[className] = addOrRemove;
        }
    }
};
// packages/ag-grid-community/src/agStack/core/agComponentStub.ts
var $437b23f6a393c3bf$var$compIdSequence = 0;
var $437b23f6a393c3bf$export$e6818678a6454cbe = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(templateOrParams, componentSelectors){
        super();
        this.suppressDataRefValidation = false;
        // if false, then CSS class "ag-hidden" is applied, which sets "display: none"
        this.displayed = true;
        // if false, then CSS class "ag-invisible" is applied, which sets "visibility: hidden"
        this.visible = true;
        // unique id for this row component. this is used for getting a reference to the HTML dom.
        // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
        // around as we create a new rowComp instance for the same row node).
        this.compId = $437b23f6a393c3bf$var$compIdSequence++;
        this.cssManager = new $437b23f6a393c3bf$export$a7053cb7eb605bd2(()=>this.eGui);
        this.componentSelectors = new Map((componentSelectors ?? []).map((comp)=>[
                comp.selector,
                comp
            ]));
        if (templateOrParams) this.setTemplate(templateOrParams);
    }
    preConstruct() {
        this.wireTemplate(this.getGui());
        const debugId = "component-" + Object.getPrototypeOf(this)?.constructor?.name;
        for (const css of this.css ?? [])this.beans.environment.addGlobalCSS(css, debugId);
    }
    wireTemplate(element, paramsMap) {
        if (element && this.gos) {
            this.applyElementsToComponent(element);
            this.createChildComponentsFromTags(element, paramsMap);
        }
    }
    getCompId() {
        return this.compId;
    }
    getDataRefAttribute(element) {
        if (element.getAttribute) return element.getAttribute($437b23f6a393c3bf$var$DataRefAttribute);
        return null;
    }
    applyElementsToComponent(element, elementRef, paramsMap, newComponent = null) {
        if (elementRef === void 0) elementRef = this.getDataRefAttribute(element);
        if (elementRef) {
            const current = this[elementRef];
            if (current === $437b23f6a393c3bf$export$6c811454646ed8be) this[elementRef] = newComponent ?? element;
            else {
                const usedAsParamRef = paramsMap?.[elementRef];
                if (!this.suppressDataRefValidation && !usedAsParamRef) throw new Error(`data-ref: ${elementRef} on ${this.constructor.name} with ${current}`);
            }
        }
    }
    // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
    createChildComponentsFromTags(parentNode, paramsMap) {
        const childNodeList = [];
        for (const childNode of parentNode.childNodes ?? [])childNodeList.push(childNode);
        for (const childNode of childNodeList){
            if (!(childNode instanceof HTMLElement)) continue;
            const childComp = this.createComponentFromElement(childNode, (childComp2)=>{
                const childGui = childComp2.getGui();
                if (childGui) for (const attr of childNode.attributes ?? [])childGui.setAttribute(attr.name, attr.value);
            }, paramsMap);
            if (childComp) {
                if (childComp.addItems && childNode.children.length) {
                    this.createChildComponentsFromTags(childNode, paramsMap);
                    const items = Array.prototype.slice.call(childNode.children);
                    childComp.addItems(items);
                }
                this.swapComponentForNode(childComp, parentNode, childNode);
            } else if (childNode.childNodes) this.createChildComponentsFromTags(childNode, paramsMap);
        }
    }
    createComponentFromElement(element, afterPreCreateCallback, paramsMap) {
        const key = element.nodeName;
        const elementRef = this.getDataRefAttribute(element);
        const isAgGridComponent = key.indexOf("AG-") === 0;
        const componentSelector = isAgGridComponent ? this.componentSelectors.get(key) : null;
        let newComponent = null;
        if (componentSelector) {
            const componentParams = paramsMap && elementRef ? paramsMap[elementRef] : void 0;
            newComponent = new componentSelector.component(componentParams);
            newComponent.setParentComponent(this);
            this.createBean(newComponent, null, afterPreCreateCallback);
        } else if (isAgGridComponent) throw new Error(`selector: ${key}`);
        this.applyElementsToComponent(element, elementRef, paramsMap, newComponent);
        return newComponent;
    }
    swapComponentForNode(newComponent, parentNode, childNode) {
        const eComponent = newComponent.getGui();
        parentNode.replaceChild(eComponent, childNode);
        parentNode.insertBefore(document.createComment(childNode.nodeName), eComponent);
        this.addDestroyFunc(this.destroyBean.bind(this, newComponent));
    }
    activateTabIndex(elements, overrideTabIndex) {
        const tabIndex = overrideTabIndex ?? this.gos.get("tabIndex");
        if (!elements) elements = [];
        if (!elements.length) elements.push(this.getGui());
        for (const el of elements)el.setAttribute("tabindex", tabIndex.toString());
    }
    setTemplate(templateOrParams, componentSelectors, paramsMap) {
        let eGui;
        if (typeof templateOrParams === "string" || templateOrParams == null) eGui = $437b23f6a393c3bf$export$b1f57d075ca6d5fb(templateOrParams);
        else eGui = $437b23f6a393c3bf$export$378bc9c64290bc8b(templateOrParams);
        this.setTemplateFromElement(eGui, componentSelectors, paramsMap);
    }
    setTemplateFromElement(element, components, paramsMap, suppressDataRefValidation = false) {
        this.eGui = element;
        this.suppressDataRefValidation = suppressDataRefValidation;
        if (components) for(let i = 0; i < components.length; i++){
            const component = components[i];
            this.componentSelectors.set(component.selector, component);
        }
        this.wireTemplate(element, paramsMap);
    }
    getGui() {
        return this.eGui;
    }
    getFocusableElement() {
        return this.eGui;
    }
    getAriaElement() {
        return this.getFocusableElement();
    }
    setParentComponent(component) {
        this.parentComponent = component;
    }
    getParentComponent() {
        return this.parentComponent;
    }
    // this method is for older code, that wants to provide the gui element,
    // it is not intended for this to be in ag-Stack
    setGui(eGui) {
        this.eGui = eGui;
    }
    queryForHtmlElement(cssSelector) {
        return this.eGui.querySelector(cssSelector);
    }
    getContainerAndElement(newChild, container) {
        let parent = container;
        if (newChild == null) return null;
        if (!parent) parent = this.eGui;
        if ($437b23f6a393c3bf$export$6e6303ef478b0c94(newChild)) return {
            element: newChild,
            parent: parent
        };
        return {
            element: newChild.getGui(),
            parent: parent
        };
    }
    prependChild(newChild, container) {
        const { element: element, parent: parent } = this.getContainerAndElement(newChild, container) || {};
        if (!element || !parent) return;
        parent.insertAdjacentElement("afterbegin", element);
    }
    appendChild(newChild, container) {
        const { element: element, parent: parent } = this.getContainerAndElement(newChild, container) || {};
        if (!element || !parent) return;
        parent.appendChild(element);
    }
    isDisplayed() {
        return this.displayed;
    }
    setVisible(visible, options = {}) {
        if (visible !== this.visible) {
            this.visible = visible;
            const { skipAriaHidden: skipAriaHidden } = options;
            $437b23f6a393c3bf$export$a6c2c477cd60daa8(this.eGui, visible, {
                skipAriaHidden: skipAriaHidden
            });
        }
    }
    setDisplayed(displayed, options = {}) {
        if (displayed !== this.displayed) {
            this.displayed = displayed;
            const { skipAriaHidden: skipAriaHidden } = options;
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eGui, displayed, {
                skipAriaHidden: skipAriaHidden
            });
            const event = {
                type: "displayChanged",
                visible: this.displayed
            };
            this.dispatchLocalEvent(event);
        }
    }
    destroy() {
        if (this.parentComponent) this.parentComponent = void 0;
        super.destroy();
    }
    addGuiEventListener(event, listener, options) {
        this.eGui.addEventListener(event, listener, options);
        this.addDestroyFunc(()=>this.eGui.removeEventListener(event, listener));
    }
    addCss(className) {
        this.cssManager.toggleCss(className, true);
    }
    removeCss(className) {
        this.cssManager.toggleCss(className, false);
    }
    toggleCss(className, addOrRemove) {
        this.cssManager.toggleCss(className, addOrRemove);
    }
    registerCSS(css) {
        this.css || (this.css = []);
        this.css.push(css);
    }
};
// packages/ag-grid-community/src/widgets/component.ts
var $437b23f6a393c3bf$export$16fa2f45be04daa8 = class extends $437b23f6a393c3bf$export$e6818678a6454cbe {
};
// packages/ag-grid-community/src/interfaces/iFilter.ts
function $437b23f6a393c3bf$var$isColumnFilterComp(filter) {
    return typeof filter === "object" && !!filter.component;
}
// packages/ag-grid-community/src/agStack/utils/promise.ts
function $437b23f6a393c3bf$export$2395b9dc826192b2(fn) {
    return typeof fn.then === "function";
}
function $437b23f6a393c3bf$var$_wrapInterval(action, timeout) {
    return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
        resolve(window.setInterval(action, timeout));
    });
}
var $437b23f6a393c3bf$export$30ec7836a4847721 = class _AgPromise {
    constructor(callback){
        this.status = 0 /* IN_PROGRESS */ ;
        this.resolution = null;
        this.waiters = [];
        callback((value)=>this.onDone(value), (params)=>this.onReject(params));
    }
    static all(promises) {
        return promises.length ? new _AgPromise((resolve)=>{
            let remainingToResolve = promises.length;
            const combinedValues = new Array(remainingToResolve);
            promises.forEach((promise, index)=>{
                promise.then((value)=>{
                    combinedValues[index] = value;
                    remainingToResolve--;
                    if (remainingToResolve === 0) resolve(combinedValues);
                });
            });
        }) : _AgPromise.resolve();
    }
    static resolve(value = null) {
        return new _AgPromise((resolve)=>resolve(value));
    }
    then(func) {
        return new _AgPromise((resolve)=>{
            if (this.status === 1 /* RESOLVED */ ) resolve(func(this.resolution));
            else this.waiters.push((value)=>resolve(func(value)));
        });
    }
    onDone(value) {
        this.status = 1 /* RESOLVED */ ;
        this.resolution = value;
        for (const waiter of this.waiters)waiter(value);
    }
    onReject(_) {}
};
// packages/ag-grid-community/src/components/framework/userComponentFactory.ts
function $437b23f6a393c3bf$var$doesImplementIComponent(candidate) {
    if (!candidate) return false;
    return candidate.prototype && "getGui" in candidate.prototype;
}
function $437b23f6a393c3bf$var$_getUserCompKeys(frameworkOverrides, defObject, type, params) {
    const { name: name } = type;
    let compName;
    let jsComp;
    let fwComp;
    let paramsFromSelector;
    let popupFromSelector;
    let popupPositionFromSelector;
    if (defObject) {
        const defObjectAny = defObject;
        const selectorFunc = defObjectAny[name + "Selector"];
        const selectorRes = selectorFunc ? selectorFunc(params) : null;
        const assignComp = (providedJsComp)=>{
            if (typeof providedJsComp === "string") compName = providedJsComp;
            else if (providedJsComp != null && providedJsComp !== true) {
                const isFwkComp = frameworkOverrides.isFrameworkComponent(providedJsComp);
                if (isFwkComp) fwComp = providedJsComp;
                else jsComp = providedJsComp;
            }
        };
        if (selectorRes) {
            assignComp(selectorRes.component);
            paramsFromSelector = selectorRes.params;
            popupFromSelector = selectorRes.popup;
            popupPositionFromSelector = selectorRes.popupPosition;
        } else assignComp(defObjectAny[name]);
    }
    return {
        compName: compName,
        jsComp: jsComp,
        fwComp: fwComp,
        paramsFromSelector: paramsFromSelector,
        popupFromSelector: popupFromSelector,
        popupPositionFromSelector: popupPositionFromSelector
    };
}
var $437b23f6a393c3bf$var$UserComponentFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "userCompFactory";
    }
    wireBeans(beans) {
        this.agCompUtils = beans.agCompUtils;
        this.registry = beans.registry;
        this.frameworkCompWrapper = beans.frameworkCompWrapper;
        this.gridOptions = beans.gridOptions;
    }
    getCompDetailsFromGridOptions(type, defaultName, params, mandatory = false) {
        return this.getCompDetails(this.gridOptions, type, defaultName, params, mandatory);
    }
    getCompDetails(defObject, type, defaultName, params, mandatory = false) {
        const { name: name, cellRenderer: cellRenderer } = type;
        let { compName: compName, jsComp: jsComp, fwComp: fwComp, paramsFromSelector: paramsFromSelector, popupFromSelector: popupFromSelector, popupPositionFromSelector: popupPositionFromSelector } = $437b23f6a393c3bf$var$_getUserCompKeys(this.beans.frameworkOverrides, defObject, type, params);
        let defaultCompParams;
        let defaultCompProcessParams;
        const lookupFromRegistry = (key)=>{
            const item = this.registry.getUserComponent(name, key);
            if (item) {
                jsComp = !item.componentFromFramework ? item.component : void 0;
                fwComp = item.componentFromFramework ? item.component : void 0;
                defaultCompParams = item.params;
                defaultCompProcessParams = item.processParams;
            }
        };
        if (compName != null) lookupFromRegistry(compName);
        if (jsComp == null && fwComp == null && defaultName != null) lookupFromRegistry(defaultName);
        if (jsComp && cellRenderer && !$437b23f6a393c3bf$var$doesImplementIComponent(jsComp)) jsComp = this.agCompUtils?.adaptFunction(type, jsComp);
        if (!jsComp && !fwComp) {
            const { validation: validation } = this.beans;
            if (mandatory && (compName !== defaultName || !defaultName)) {
                if (compName) {
                    if (!validation?.isProvidedUserComp(compName)) $437b23f6a393c3bf$export$a20c7248650823a9(50, {
                        compName: compName
                    });
                } else if (defaultName) {
                    if (!validation) $437b23f6a393c3bf$export$a20c7248650823a9(260, {
                        ...this.gos.getModuleErrorParams(),
                        propName: name,
                        compName: defaultName
                    });
                } else $437b23f6a393c3bf$export$a20c7248650823a9(216, {
                    name: name
                });
            } else if (defaultName && !validation) $437b23f6a393c3bf$export$a20c7248650823a9(146, {
                comp: defaultName
            });
            return;
        }
        const paramsMerged = this.mergeParams(defObject, type, params, paramsFromSelector, defaultCompParams, defaultCompProcessParams);
        const componentFromFramework = jsComp == null;
        const componentClass = jsComp ?? fwComp;
        return {
            componentFromFramework: componentFromFramework,
            componentClass: componentClass,
            params: paramsMerged,
            type: type,
            popupFromSelector: popupFromSelector,
            popupPositionFromSelector: popupPositionFromSelector,
            newAgStackInstance: ()=>this.newAgStackInstance(componentClass, componentFromFramework, paramsMerged, type)
        };
    }
    newAgStackInstance(ComponentClass, componentFromFramework, params, type) {
        const jsComponent = !componentFromFramework;
        let instance;
        if (jsComponent) instance = new ComponentClass();
        else instance = this.frameworkCompWrapper.wrap(ComponentClass, type.mandatoryMethods, type.optionalMethods, type);
        this.createBean(instance);
        const deferredInit = instance.init?.(params);
        if (deferredInit == null) return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(instance);
        return deferredInit.then(()=>instance);
    }
    /**
   * merges params with application provided params
   * used by Floating Filter
   */ mergeParams(defObject, type, paramsFromGrid, paramsFromSelector = null, defaultCompParams, defaultCompProcessParams) {
        const params = {
            ...paramsFromGrid,
            ...defaultCompParams
        };
        const defObjectAny = defObject;
        const userParams = defObjectAny?.[type.name + "Params"];
        if (typeof userParams === "function") {
            const userParamsFromFunc = userParams(paramsFromGrid);
            $437b23f6a393c3bf$export$8ade6bd474fcde42(params, userParamsFromFunc);
        } else if (typeof userParams === "object") $437b23f6a393c3bf$export$8ade6bd474fcde42(params, userParams);
        $437b23f6a393c3bf$export$8ade6bd474fcde42(params, paramsFromSelector);
        return defaultCompProcessParams ? defaultCompProcessParams(params) : params;
    }
};
// packages/ag-grid-community/src/components/framework/userCompUtils.ts
var $437b23f6a393c3bf$var$DateComponent = {
    name: "dateComponent",
    mandatoryMethods: [
        "getDate",
        "setDate"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "setInputPlaceholder",
        "setInputAriaLabel",
        "setDisabled",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$DragAndDropImageComponent = {
    name: "dragAndDropImageComponent",
    mandatoryMethods: [
        "setIcon",
        "setLabel"
    ]
};
var $437b23f6a393c3bf$var$HeaderComponent = {
    name: "headerComponent",
    optionalMethods: [
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$InnerHeaderComponent = {
    name: "innerHeaderComponent"
};
var $437b23f6a393c3bf$var$InnerHeaderGroupComponent = {
    name: "innerHeaderGroupComponent"
};
var $437b23f6a393c3bf$var$HeaderGroupComponent = {
    name: "headerGroupComponent"
};
var $437b23f6a393c3bf$var$InnerCellRendererComponent = {
    name: "innerRenderer",
    cellRenderer: true,
    optionalMethods: [
        "afterGuiAttached"
    ]
};
var $437b23f6a393c3bf$var$CellRendererComponent = {
    name: "cellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$EditorRendererComponent = {
    name: "cellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ]
};
var $437b23f6a393c3bf$var$LoadingCellRendererComponent = {
    name: "loadingCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$CellEditorComponent = {
    name: "cellEditor",
    mandatoryMethods: [
        "getValue"
    ],
    optionalMethods: [
        "isPopup",
        "isCancelBeforeStart",
        "isCancelAfterEnd",
        "getPopupPosition",
        "focusIn",
        "focusOut",
        "afterGuiAttached",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$TooltipComponent = {
    name: "tooltipComponent"
};
var $437b23f6a393c3bf$var$FilterComponent = {
    name: "filter",
    mandatoryMethods: [
        "isFilterActive",
        "doesFilterPass",
        "getModel",
        "setModel"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "afterGuiDetached",
        "onNewRowsLoaded",
        "getModelAsString",
        "onFloatingFilterChanged",
        "onAnyFilterChanged",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$FloatingFilterComponent = {
    name: "floatingFilterComponent",
    mandatoryMethods: [
        "onParentModelChanged"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$FullWidth = {
    name: "fullWidthCellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthLoading = {
    name: "loadingCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthGroup = {
    name: "groupRowRenderer",
    optionalMethods: [
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthDetail = {
    name: "detailCellRenderer",
    optionalMethods: [
        "refresh"
    ],
    cellRenderer: true
};
function $437b23f6a393c3bf$var$_getDragAndDropImageCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$DragAndDropImageComponent, "agDragAndDropImage", params, true);
}
function $437b23f6a393c3bf$export$c3f4e745c2fdf1c0(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$InnerCellRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getHeaderCompDetails(userCompFactory, colDef, params) {
    return userCompFactory.getCompDetails(colDef, $437b23f6a393c3bf$var$HeaderComponent, "agColumnHeader", params);
}
function $437b23f6a393c3bf$var$_getInnerHeaderCompDetails(userCompFactory, headerCompParams, params) {
    return userCompFactory.getCompDetails(headerCompParams, $437b23f6a393c3bf$var$InnerHeaderComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getHeaderGroupCompDetails(userCompFactory, params) {
    const colGroupDef = params.columnGroup.getColGroupDef();
    return userCompFactory.getCompDetails(colGroupDef, $437b23f6a393c3bf$var$HeaderGroupComponent, "agColumnGroupHeader", params);
}
function $437b23f6a393c3bf$var$_getInnerHeaderGroupCompDetails(userCompFactory, headerGroupCompParams, params) {
    return userCompFactory.getCompDetails(headerGroupCompParams, $437b23f6a393c3bf$var$InnerHeaderGroupComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getFullWidthCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidth, void 0, params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthLoadingCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthLoading, "agLoadingCellRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthGroupCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthGroup, "agGroupRowRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthDetailCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthDetail, "agDetailCellRenderer", params, true);
}
function $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$CellRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$export$85a10ea90cfc8a53(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$EditorRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getLoadingCellRendererDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$LoadingCellRendererComponent, "agSkeletonCellRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getCellEditorDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$CellEditorComponent, "agCellEditor", params, true);
}
function $437b23f6a393c3bf$export$e6db9a2d59456da0(userCompFactory, def, params, defaultFilter) {
    const filter = def.filter;
    if ($437b23f6a393c3bf$var$isColumnFilterComp(filter)) def = {
        filter: filter.component,
        filterParams: def.filterParams
    };
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$FilterComponent, defaultFilter, params, true);
}
function $437b23f6a393c3bf$var$_getDateCompDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$DateComponent, "agDateInput", params, true);
}
function $437b23f6a393c3bf$var$_getTooltipCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetails(params.colDef, $437b23f6a393c3bf$var$TooltipComponent, "agTooltipComponent", params, true);
}
function $437b23f6a393c3bf$export$14d0998f093f007e(userCompFactory, def, params, defaultFloatingFilter) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$FloatingFilterComponent, defaultFloatingFilter, params);
}
function $437b23f6a393c3bf$var$_getFilterCompKeys(frameworkOverrides, def) {
    return $437b23f6a393c3bf$var$_getUserCompKeys(frameworkOverrides, def, $437b23f6a393c3bf$var$FilterComponent);
}
function $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(userCompFactory, defObject, paramsFromGrid) {
    return userCompFactory.mergeParams(defObject, $437b23f6a393c3bf$var$FilterComponent, paramsFromGrid);
}
// packages/ag-grid-community/src/components/framework/unwrapUserComp.ts
function $437b23f6a393c3bf$export$213d4c63c3df47e4(comp) {
    const compAsAny = comp;
    const isProxy = compAsAny?.getFrameworkComponentInstance != null;
    return isProxy ? compAsAny.getFrameworkComponentInstance() : comp;
}
// packages/ag-grid-community/src/context/context.ts
function $437b23f6a393c3bf$var$isComponentMetaFunc(componentMeta) {
    return typeof componentMeta === "object" && !!componentMeta.getComp;
}
// packages/ag-grid-community/src/agStack/constants/keyCode.ts
var $437b23f6a393c3bf$export$e9e0d96f49f57c33 = {
    BACKSPACE: "Backspace",
    TAB: "Tab",
    ENTER: "Enter",
    ESCAPE: "Escape",
    SPACE: " ",
    LEFT: "ArrowLeft",
    UP: "ArrowUp",
    RIGHT: "ArrowRight",
    DOWN: "ArrowDown",
    DELETE: "Delete",
    F2: "F2",
    PAGE_UP: "PageUp",
    PAGE_DOWN: "PageDown",
    PAGE_HOME: "Home",
    PAGE_END: "End",
    // these should be used with `event.code` instead of `event.key`
    // as `event.key` changes when non-latin keyboards are used
    A: "KeyA",
    C: "KeyC",
    D: "KeyD",
    V: "KeyV",
    X: "KeyX",
    Y: "KeyY",
    Z: "KeyZ"
};
var $437b23f6a393c3bf$var$A_KEYCODE = 65;
var $437b23f6a393c3bf$var$C_KEYCODE = 67;
var $437b23f6a393c3bf$var$V_KEYCODE = 86;
var $437b23f6a393c3bf$var$D_KEYCODE = 68;
var $437b23f6a393c3bf$var$Z_KEYCODE = 90;
var $437b23f6a393c3bf$var$Y_KEYCODE = 89;
function $437b23f6a393c3bf$var$_normaliseQwertyAzerty(keyboardEvent) {
    const { keyCode: keyCode } = keyboardEvent;
    let code;
    switch(keyCode){
        case $437b23f6a393c3bf$var$A_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.A;
            break;
        case $437b23f6a393c3bf$var$C_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.C;
            break;
        case $437b23f6a393c3bf$var$V_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.V;
            break;
        case $437b23f6a393c3bf$var$D_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.D;
            break;
        case $437b23f6a393c3bf$var$Z_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.Z;
            break;
        case $437b23f6a393c3bf$var$Y_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.Y;
            break;
        default:
            code = keyboardEvent.code;
    }
    return code;
}
// packages/ag-grid-community/src/agStack/popup/agPopupComponent.ts
var $437b23f6a393c3bf$export$acd471c9223f27ae = class extends $437b23f6a393c3bf$export$e6818678a6454cbe {
    isPopup() {
        return true;
    }
    setParentComponent(container) {
        container.addCss("ag-has-popup");
        super.setParentComponent(container);
    }
    destroy() {
        const parentComp = this.parentComponent;
        const hasParent = parentComp?.isAlive();
        if (hasParent) parentComp.getGui().classList.remove("ag-has-popup");
        super.destroy();
    }
};
// packages/ag-grid-community/src/agStack/utils/browser.ts
var $437b23f6a393c3bf$var$isSafari;
var $437b23f6a393c3bf$var$isFirefox;
var $437b23f6a393c3bf$var$isMacOs;
var $437b23f6a393c3bf$var$isIOS;
var $437b23f6a393c3bf$var$invisibleScrollbar;
var $437b23f6a393c3bf$var$browserScrollbarWidth;
var $437b23f6a393c3bf$var$maxDivHeight;
function $437b23f6a393c3bf$export$8caf403dacd36a68() {
    if ($437b23f6a393c3bf$var$isSafari === void 0) $437b23f6a393c3bf$var$isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return $437b23f6a393c3bf$var$isSafari;
}
function $437b23f6a393c3bf$export$ca98fb7c82ac5538() {
    if ($437b23f6a393c3bf$var$isFirefox === void 0) $437b23f6a393c3bf$var$isFirefox = /(firefox)/i.test(navigator.userAgent);
    return $437b23f6a393c3bf$var$isFirefox;
}
function $437b23f6a393c3bf$var$_isMacOsUserAgent() {
    if ($437b23f6a393c3bf$var$isMacOs === void 0) $437b23f6a393c3bf$var$isMacOs = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    return $437b23f6a393c3bf$var$isMacOs;
}
function $437b23f6a393c3bf$export$6b6034a68325bd8a() {
    if ($437b23f6a393c3bf$var$isIOS === void 0) $437b23f6a393c3bf$var$isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return $437b23f6a393c3bf$var$isIOS;
}
function $437b23f6a393c3bf$var$_getTabIndex(el) {
    if (!el) return null;
    const numberTabIndex = el.tabIndex;
    const tabIndex = el.getAttribute("tabIndex");
    if (numberTabIndex === -1 && (tabIndex === null || tabIndex === "" && !$437b23f6a393c3bf$export$ca98fb7c82ac5538())) return null;
    return numberTabIndex.toString();
}
function $437b23f6a393c3bf$var$_getMaxDivHeight() {
    if ($437b23f6a393c3bf$var$maxDivHeight !== void 0) return $437b23f6a393c3bf$var$maxDivHeight;
    if (!document.body) return -1;
    let res = 1e6;
    const testUpTo = $437b23f6a393c3bf$export$ca98fb7c82ac5538() ? 6e6 : 1e9;
    const div = document.createElement("div");
    document.body.appendChild(div);
    while(true){
        const test = res * 2;
        div.style.height = test + "px";
        if (test > testUpTo || div.clientHeight !== test) break;
        else res = test;
    }
    div.remove();
    $437b23f6a393c3bf$var$maxDivHeight = res;
    return res;
}
function $437b23f6a393c3bf$var$_getScrollbarWidth() {
    if ($437b23f6a393c3bf$var$browserScrollbarWidth == null) $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility();
    return $437b23f6a393c3bf$var$browserScrollbarWidth;
}
function $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility() {
    const body = document.body;
    const div = document.createElement("div");
    div.style.width = div.style.height = "100px";
    div.style.opacity = "0";
    div.style.overflow = "scroll";
    div.style.msOverflowStyle = "scrollbar";
    div.style.position = "absolute";
    body.appendChild(div);
    let width = div.offsetWidth - div.clientWidth;
    if (width === 0 && div.clientWidth === 0) width = null;
    if (div.parentNode) div.remove();
    if (width != null) {
        $437b23f6a393c3bf$var$browserScrollbarWidth = width;
        $437b23f6a393c3bf$var$invisibleScrollbar = width === 0;
    }
}
function $437b23f6a393c3bf$var$_isInvisibleScrollbar() {
    if ($437b23f6a393c3bf$var$invisibleScrollbar == null) $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility();
    return $437b23f6a393c3bf$var$invisibleScrollbar;
}
// packages/ag-grid-community/src/agStack/utils/focus.ts
var $437b23f6a393c3bf$var$keyboardModeActive = false;
var $437b23f6a393c3bf$var$instanceCount = 0;
function $437b23f6a393c3bf$var$addKeyboardModeEvents(doc) {
    if ($437b23f6a393c3bf$var$instanceCount > 0) return;
    doc.addEventListener("keydown", $437b23f6a393c3bf$var$toggleKeyboardMode);
    doc.addEventListener("mousedown", $437b23f6a393c3bf$var$toggleKeyboardMode);
}
function $437b23f6a393c3bf$var$removeKeyboardModeEvents(doc) {
    if ($437b23f6a393c3bf$var$instanceCount > 0) return;
    doc.removeEventListener("keydown", $437b23f6a393c3bf$var$toggleKeyboardMode);
    doc.removeEventListener("mousedown", $437b23f6a393c3bf$var$toggleKeyboardMode);
}
function $437b23f6a393c3bf$var$toggleKeyboardMode(event) {
    const isKeyboardActive = $437b23f6a393c3bf$var$keyboardModeActive;
    const isKeyboardEvent = event.type === "keydown";
    if (isKeyboardEvent) {
        if (event.ctrlKey || event.metaKey || event.altKey) return;
    }
    if (isKeyboardActive === isKeyboardEvent) return;
    $437b23f6a393c3bf$var$keyboardModeActive = isKeyboardEvent;
}
function $437b23f6a393c3bf$var$_registerKeyboardFocusEvents(beans) {
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    $437b23f6a393c3bf$var$addKeyboardModeEvents(eDocument);
    $437b23f6a393c3bf$var$instanceCount++;
    return ()=>{
        $437b23f6a393c3bf$var$instanceCount--;
        $437b23f6a393c3bf$var$removeKeyboardModeEvents(eDocument);
    };
}
function $437b23f6a393c3bf$export$e4c8c227337b7f23() {
    return $437b23f6a393c3bf$var$keyboardModeActive;
}
function $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, exclude, onlyUnmanaged = false) {
    const focusableString = $437b23f6a393c3bf$var$FOCUSABLE_SELECTOR;
    let excludeString = $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE;
    if (exclude) excludeString += ", " + exclude;
    if (onlyUnmanaged) excludeString += ', [tabindex="-1"]';
    const nodes = Array.prototype.slice.apply(rootNode.querySelectorAll(focusableString)).filter((node)=>{
        return $437b23f6a393c3bf$export$2badf4aa566524cb(node);
    });
    const excludeNodes = Array.prototype.slice.apply(rootNode.querySelectorAll(excludeString));
    if (!excludeNodes.length) return nodes;
    const diff = (a, b)=>a.filter((element)=>b.indexOf(element) === -1);
    return diff(nodes, excludeNodes);
}
function $437b23f6a393c3bf$export$8598088d375f416f(rootNode, up = false, onlyUnmanaged = false, excludeTabGuards = false) {
    const focusableElements = $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, excludeTabGuards ? ".ag-tab-guard" : null, onlyUnmanaged);
    const toFocus = up ? $437b23f6a393c3bf$export$236389741107357f(focusableElements) : focusableElements[0];
    if (toFocus) {
        toFocus.focus({
            preventScroll: true
        });
        return true;
    }
    return false;
}
function $437b23f6a393c3bf$export$83fc12531358bd28(beans, rootNode, onlyManaged, backwards) {
    const focusable = $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, onlyManaged ? ':not([tabindex="-1"])' : null);
    const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
    let currentIndex;
    if (onlyManaged) currentIndex = focusable.findIndex((el)=>el.contains(activeEl));
    else currentIndex = focusable.indexOf(activeEl);
    const nextIndex = currentIndex + (backwards ? -1 : 1);
    if (nextIndex < 0 || nextIndex >= focusable.length) return null;
    return focusable[nextIndex];
}
function $437b23f6a393c3bf$export$c4c49c776025d475(node, limit = 5) {
    let counter = 0;
    while(node && $437b23f6a393c3bf$var$_getTabIndex(node) === null && ++counter <= limit)node = node.parentElement;
    if ($437b23f6a393c3bf$var$_getTabIndex(node) === null) return null;
    return node;
}
// packages/ag-grid-community/src/agStack/focus/agManagedFocusFeature.ts
var $437b23f6a393c3bf$export$e24a3eb8593af8d8 = "ag-focus-managed";
var $437b23f6a393c3bf$var$AgManagedFocusFeature = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(eFocusable, stopPropagationCallbacks = {
        isStopPropagation: ()=>false,
        stopPropagation: ()=>{}
    }, callbacks = {}){
        super();
        this.eFocusable = eFocusable;
        this.stopPropagationCallbacks = stopPropagationCallbacks;
        this.callbacks = callbacks;
        this.callbacks = {
            shouldStopEventPropagation: ()=>false,
            onTabKeyDown: (e)=>{
                if (e.defaultPrevented) return;
                const nextRoot = $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, this.eFocusable, false, e.shiftKey);
                if (!nextRoot) return;
                nextRoot.focus();
                e.preventDefault();
            },
            ...callbacks
        };
    }
    postConstruct() {
        const { eFocusable: eFocusable, callbacks: { onFocusIn: onFocusIn, onFocusOut: onFocusOut } } = this;
        eFocusable.classList.add($437b23f6a393c3bf$export$e24a3eb8593af8d8);
        this.addKeyDownListeners(eFocusable);
        if (onFocusIn) this.addManagedElementListeners(eFocusable, {
            focusin: onFocusIn
        });
        if (onFocusOut) this.addManagedElementListeners(eFocusable, {
            focusout: onFocusOut
        });
    }
    addKeyDownListeners(eGui) {
        this.addManagedElementListeners(eGui, {
            keydown: (e)=>{
                if (e.defaultPrevented || this.stopPropagationCallbacks.isStopPropagation(e)) return;
                const { callbacks: callbacks } = this;
                if (callbacks.shouldStopEventPropagation(e)) {
                    this.stopPropagationCallbacks.stopPropagation(e);
                    return;
                }
                if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) callbacks.onTabKeyDown(e);
                else if (callbacks.handleKeyDown) callbacks.handleKeyDown(e);
            }
        });
    }
};
// packages/ag-grid-community/src/agStack/focus/tabGuardCtrl.ts
var $437b23f6a393c3bf$export$3be5727576441c72 = {
    TAB_GUARD: "ag-tab-guard",
    TAB_GUARD_TOP: "ag-tab-guard-top",
    TAB_GUARD_BOTTOM: "ag-tab-guard-bottom"
};
var $437b23f6a393c3bf$var$AgTabGuardCtrl = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(params, stopPropagationCallbacks){
        super();
        this.stopPropagationCallbacks = stopPropagationCallbacks;
        this.skipTabGuardFocus = false;
        this.forcingFocusOut = false;
        // Used when `isFocusableContainer` enabled
        this.allowFocus = false;
        const { comp: comp, eTopGuard: eTopGuard, eBottomGuard: eBottomGuard, focusTrapActive: focusTrapActive, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty, isFocusableContainer: isFocusableContainer, focusInnerElement: focusInnerElement, onFocusIn: onFocusIn, onFocusOut: onFocusOut, shouldStopEventPropagation: shouldStopEventPropagation, onTabKeyDown: onTabKeyDown, handleKeyDown: handleKeyDown, isEmpty: isEmpty, eFocusableElement: eFocusableElement } = params;
        this.comp = comp;
        this.eTopGuard = eTopGuard;
        this.eBottomGuard = eBottomGuard;
        this.providedFocusInnerElement = focusInnerElement;
        this.eFocusableElement = eFocusableElement;
        this.focusTrapActive = !!focusTrapActive;
        this.forceFocusOutWhenTabGuardsAreEmpty = !!forceFocusOutWhenTabGuardsAreEmpty;
        this.isFocusableContainer = !!isFocusableContainer;
        this.providedFocusIn = onFocusIn;
        this.providedFocusOut = onFocusOut;
        this.providedShouldStopEventPropagation = shouldStopEventPropagation;
        this.providedOnTabKeyDown = onTabKeyDown;
        this.providedHandleKeyDown = handleKeyDown;
        this.providedIsEmpty = isEmpty;
    }
    postConstruct() {
        this.createManagedBean(new $437b23f6a393c3bf$var$AgManagedFocusFeature(this.eFocusableElement, this.stopPropagationCallbacks, {
            shouldStopEventPropagation: ()=>this.shouldStopEventPropagation(),
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e),
            onFocusIn: (e)=>this.onFocusIn(e),
            onFocusOut: (e)=>this.onFocusOut(e)
        }));
        this.activateTabGuards();
        for (const guard of [
            this.eTopGuard,
            this.eBottomGuard
        ])this.addManagedElementListeners(guard, {
            focus: this.onFocus.bind(this)
        });
    }
    handleKeyDown(e) {
        if (this.providedHandleKeyDown) this.providedHandleKeyDown(e);
    }
    tabGuardsAreActive() {
        return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
    }
    shouldStopEventPropagation() {
        if (this.providedShouldStopEventPropagation) return this.providedShouldStopEventPropagation();
        return false;
    }
    activateTabGuards() {
        if (this.forcingFocusOut) return;
        const tabIndex = this.gos.get("tabIndex");
        this.comp.setTabIndex(tabIndex.toString());
    }
    deactivateTabGuards() {
        this.comp.setTabIndex();
    }
    onFocus(e) {
        if (this.isFocusableContainer && !this.eFocusableElement.contains(e.relatedTarget)) {
            if (!this.allowFocus) {
                this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
                return;
            }
        }
        if (this.skipTabGuardFocus) {
            this.skipTabGuardFocus = false;
            return;
        }
        if (this.forceFocusOutWhenTabGuardsAreEmpty) {
            const isEmpty = this.providedIsEmpty ? this.providedIsEmpty() : $437b23f6a393c3bf$export$7acf44f59625b1f6(this.eFocusableElement, ".ag-tab-guard").length === 0;
            if (isEmpty) {
                this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
                return;
            }
        }
        if (this.isFocusableContainer && this.eFocusableElement.contains(e.relatedTarget)) return;
        const fromBottom = e.target === this.eBottomGuard;
        const hasFocusedInnerElement = this.providedFocusInnerElement ? this.providedFocusInnerElement(fromBottom) : this.focusInnerElement(fromBottom);
        if (!hasFocusedInnerElement && this.forceFocusOutWhenTabGuardsAreEmpty) this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
    }
    findNextElementOutsideAndFocus(up) {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        const focusableEls = $437b23f6a393c3bf$export$7acf44f59625b1f6(eDocument.body, null, true);
        const index = focusableEls.indexOf(up ? this.eTopGuard : this.eBottomGuard);
        if (index === -1) return;
        let start;
        let end;
        if (up) {
            start = 0;
            end = index;
        } else {
            start = index + 1;
            end = focusableEls.length;
        }
        const focusableRange = focusableEls.slice(start, end);
        const targetTabIndex = this.gos.get("tabIndex");
        focusableRange.sort((a, b)=>{
            const indexA = Number.parseInt(a.getAttribute("tabindex") || "0");
            const indexB = Number.parseInt(b.getAttribute("tabindex") || "0");
            if (indexB === targetTabIndex) return 1;
            if (indexA === targetTabIndex) return -1;
            if (indexA === 0) return 1;
            if (indexB === 0) return -1;
            return indexA - indexB;
        });
        focusableRange[up ? focusableRange.length - 1 : 0]?.focus();
    }
    onFocusIn(e) {
        if (this.focusTrapActive || this.forcingFocusOut) return;
        if (this.providedFocusIn) this.providedFocusIn(e);
        if (!this.isFocusableContainer) this.deactivateTabGuards();
    }
    onFocusOut(e) {
        if (this.focusTrapActive) return;
        if (this.providedFocusOut) this.providedFocusOut(e);
        if (!this.eFocusableElement.contains(e.relatedTarget)) this.activateTabGuards();
    }
    onTabKeyDown(e) {
        if (this.providedOnTabKeyDown) {
            this.providedOnTabKeyDown(e);
            return;
        }
        if (this.focusTrapActive) return;
        if (e.defaultPrevented) return;
        const tabGuardsAreActive = this.tabGuardsAreActive();
        if (tabGuardsAreActive) this.deactivateTabGuards();
        const nextRoot = this.getNextFocusableElement(e.shiftKey);
        if (tabGuardsAreActive) setTimeout(()=>this.activateTabGuards(), 0);
        if (!nextRoot) return;
        nextRoot.focus();
        e.preventDefault();
    }
    focusInnerElement(fromBottom = false) {
        const focusable = $437b23f6a393c3bf$export$7acf44f59625b1f6(this.eFocusableElement);
        if (this.tabGuardsAreActive()) {
            focusable.splice(0, 1);
            focusable.splice(-1, 1);
        }
        if (!focusable.length) return false;
        focusable[fromBottom ? focusable.length - 1 : 0].focus({
            preventScroll: true
        });
        return true;
    }
    getNextFocusableElement(backwards) {
        return $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, this.eFocusableElement, false, backwards);
    }
    forceFocusOutOfContainer(up = false) {
        if (this.forcingFocusOut) return;
        const tabGuardToFocus = up ? this.eTopGuard : this.eBottomGuard;
        this.activateTabGuards();
        this.skipTabGuardFocus = true;
        this.forcingFocusOut = true;
        tabGuardToFocus.focus();
        window.setTimeout(()=>{
            this.forcingFocusOut = false;
            this.activateTabGuards();
        });
    }
    isTabGuard(element, bottom) {
        return element === this.eTopGuard && !bottom || element === this.eBottomGuard && (bottom ?? true);
    }
    setAllowFocus(allowFocus) {
        this.allowFocus = allowFocus;
    }
};
// packages/ag-grid-community/src/agStack/rendering/autoScrollService.ts
var $437b23f6a393c3bf$export$c66bdc3d55a4f95 = class {
    constructor(params){
        this.tickingInterval = null;
        this.onScrollCallback = null;
        this.scrollContainer = params.scrollContainer;
        this.scrollHorizontally = params.scrollAxis.includes("x");
        this.scrollVertically = params.scrollAxis.includes("y");
        this.scrollByTick = params.scrollByTick ?? 20;
        if (params.onScrollCallback) this.onScrollCallback = params.onScrollCallback;
        if (this.scrollVertically) {
            this.getVerticalPosition = params.getVerticalPosition;
            this.setVerticalPosition = params.setVerticalPosition;
        }
        if (this.scrollHorizontally) {
            this.getHorizontalPosition = params.getHorizontalPosition;
            this.setHorizontalPosition = params.setHorizontalPosition;
        }
        this.shouldSkipVerticalScroll = params.shouldSkipVerticalScroll || (()=>false);
        this.shouldSkipHorizontalScroll = params.shouldSkipHorizontalScroll || (()=>false);
    }
    /** True while auto-scrolling */ get scrolling() {
        return this.tickingInterval !== null;
    }
    check(mouseEvent, forceSkipVerticalScroll = false) {
        const skipVerticalScroll = forceSkipVerticalScroll || this.shouldSkipVerticalScroll();
        if (skipVerticalScroll && this.shouldSkipHorizontalScroll()) return;
        const rect = this.scrollContainer.getBoundingClientRect();
        const scrollTick = this.scrollByTick;
        this.tickLeft = mouseEvent.clientX < rect.left + scrollTick;
        this.tickRight = mouseEvent.clientX > rect.right - scrollTick;
        this.tickUp = mouseEvent.clientY < rect.top + scrollTick && !skipVerticalScroll;
        this.tickDown = mouseEvent.clientY > rect.bottom - scrollTick && !skipVerticalScroll;
        if (this.tickLeft || this.tickRight || this.tickUp || this.tickDown) this.ensureTickingStarted();
        else this.ensureCleared();
    }
    ensureTickingStarted() {
        if (this.tickingInterval === null) {
            this.tickingInterval = window.setInterval(this.doTick.bind(this), 100);
            this.tickCount = 0;
        }
    }
    doTick() {
        this.tickCount++;
        const tickAmount = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;
        if (this.scrollVertically) {
            const vScrollPosition = this.getVerticalPosition();
            if (this.tickUp) this.setVerticalPosition(vScrollPosition - tickAmount);
            if (this.tickDown) this.setVerticalPosition(vScrollPosition + tickAmount);
        }
        if (this.scrollHorizontally) {
            const hScrollPosition = this.getHorizontalPosition();
            if (this.tickLeft) this.setHorizontalPosition(hScrollPosition - tickAmount);
            if (this.tickRight) this.setHorizontalPosition(hScrollPosition + tickAmount);
        }
        if (this.onScrollCallback) this.onScrollCallback();
    }
    ensureCleared() {
        if (this.tickingInterval) {
            window.clearInterval(this.tickingInterval);
            this.tickingInterval = null;
        }
    }
};
// packages/ag-grid-community/src/agStack/rendering/agPositionableFeature.ts
var $437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE = "ag-resizer-wrapper";
var $437b23f6a393c3bf$var$makeDiv = (dataRefPrefix, classSuffix)=>({
        tag: "div",
        ref: `${dataRefPrefix}Resizer`,
        cls: `ag-resizer ag-resizer-${classSuffix}`
    });
var $437b23f6a393c3bf$var$RESIZE_TEMPLATE = {
    tag: "div",
    cls: $437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE,
    children: [
        $437b23f6a393c3bf$var$makeDiv("eTopLeft", "topLeft"),
        $437b23f6a393c3bf$var$makeDiv("eTop", "top"),
        $437b23f6a393c3bf$var$makeDiv("eTopRight", "topRight"),
        $437b23f6a393c3bf$var$makeDiv("eRight", "right"),
        $437b23f6a393c3bf$var$makeDiv("eBottomRight", "bottomRight"),
        $437b23f6a393c3bf$var$makeDiv("eBottom", "bottom"),
        $437b23f6a393c3bf$var$makeDiv("eBottomLeft", "bottomLeft"),
        $437b23f6a393c3bf$var$makeDiv("eLeft", "left")
    ]
};
var $437b23f6a393c3bf$export$2da1335e50678d79 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(element, config){
        super();
        this.element = element;
        this.dragStartPosition = {
            x: 0,
            y: 0
        };
        this.position = {
            x: 0,
            y: 0
        };
        this.lastSize = {
            width: -1,
            height: -1
        };
        this.positioned = false;
        this.resizersAdded = false;
        this.resizeListeners = [];
        this.boundaryEl = null;
        this.isResizing = false;
        this.isMoving = false;
        this.resizable = {};
        this.movable = false;
        this.currentResizer = null;
        this.config = {
            popup: false,
            ...config
        };
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
        this.dragSvc = beans.dragSvc;
    }
    center(postProcessCallback) {
        const { clientHeight: clientHeight, clientWidth: clientWidth } = this.offsetParent;
        const x = clientWidth / 2 - this.getWidth() / 2;
        const y = clientHeight / 2 - this.getHeight() / 2;
        this.offsetElement(x, y, postProcessCallback);
    }
    initialisePosition(postProcessCallback) {
        if (this.positioned) return;
        const { centered: centered, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent, minWidth: minWidth, width: width, minHeight: minHeight, height: height, x: x, y: y } = this.config;
        if (!this.offsetParent) this.setOffsetParent();
        let computedMinHeight = 0;
        let computedMinWidth = 0;
        const isElementVisible = $437b23f6a393c3bf$export$2badf4aa566524cb(this.element);
        if (isElementVisible) {
            const boundaryEl = this.findBoundaryElement();
            const offsetParentComputedStyles = window.getComputedStyle(boundaryEl);
            if (offsetParentComputedStyles.minWidth != null) {
                const paddingWidth = boundaryEl.offsetWidth - this.element.offsetWidth;
                computedMinWidth = Number.parseInt(offsetParentComputedStyles.minWidth, 10) - paddingWidth;
            }
            if (offsetParentComputedStyles.minHeight != null) {
                const paddingHeight = boundaryEl.offsetHeight - this.element.offsetHeight;
                computedMinHeight = Number.parseInt(offsetParentComputedStyles.minHeight, 10) - paddingHeight;
            }
        }
        this.minHeight = minHeight || computedMinHeight;
        this.minWidth = minWidth || computedMinWidth;
        if (width) this.setWidth(width);
        if (height) this.setHeight(height);
        if (!width || !height) this.refreshSize();
        if (centered) this.center(postProcessCallback);
        else if (x || y) this.offsetElement(x, y, postProcessCallback);
        else if (isElementVisible && forcePopupParentAsOffsetParent) {
            let boundaryEl = this.boundaryEl;
            let initialisedDuringPositioning = true;
            if (!boundaryEl) {
                boundaryEl = this.findBoundaryElement();
                initialisedDuringPositioning = false;
            }
            if (boundaryEl) {
                const top = Number.parseFloat(boundaryEl.style.top);
                const left = Number.parseFloat(boundaryEl.style.left);
                if (initialisedDuringPositioning) this.offsetElement(Number.isNaN(left) ? 0 : left, Number.isNaN(top) ? 0 : top, postProcessCallback);
                else this.setPosition(left, top);
            }
        }
        this.positioned = !!this.offsetParent;
    }
    isPositioned() {
        return this.positioned;
    }
    getPosition() {
        return this.position;
    }
    setMovable(movable, moveElement) {
        if (!this.config.popup || movable === this.movable) return;
        this.movable = movable;
        const params = this.moveElementDragListener || {
            eElement: moveElement,
            onDragStart: this.onMoveStart.bind(this),
            onDragging: this.onMove.bind(this),
            onDragStop: this.onMoveEnd.bind(this)
        };
        if (movable) {
            this.dragSvc?.addDragSource(params);
            this.moveElementDragListener = params;
        } else {
            this.dragSvc?.removeDragSource(params);
            this.moveElementDragListener = void 0;
        }
    }
    setResizable(resizable) {
        this.clearResizeListeners();
        if (resizable) this.addResizers();
        else this.removeResizers();
        if (typeof resizable === "boolean") {
            if (resizable === false) return;
            resizable = {
                topLeft: resizable,
                top: resizable,
                topRight: resizable,
                right: resizable,
                bottomRight: resizable,
                bottom: resizable,
                bottomLeft: resizable,
                left: resizable
            };
        }
        for (const side of Object.keys(resizable)){
            const isSideResizable = !!resizable[side];
            const resizerEl = this.getResizerElement(side);
            const params = {
                dragStartPixels: 0,
                eElement: resizerEl,
                onDragStart: (e)=>this.onResizeStart(e, side),
                onDragging: this.onResize.bind(this),
                onDragStop: (e)=>this.onResizeEnd(e, side)
            };
            if (isSideResizable || !this.isAlive() && !isSideResizable) {
                if (isSideResizable) {
                    this.dragSvc?.addDragSource(params);
                    this.resizeListeners.push(params);
                    resizerEl.style.pointerEvents = "all";
                } else resizerEl.style.pointerEvents = "none";
                this.resizable[side] = isSideResizable;
            }
        }
    }
    removeSizeFromEl() {
        this.element.style.removeProperty("height");
        this.element.style.removeProperty("width");
        this.element.style.removeProperty("flex");
    }
    restoreLastSize() {
        this.element.style.flex = "0 0 auto";
        const { height: height, width: width } = this.lastSize;
        if (width !== -1) this.element.style.width = `${width}px`;
        if (height !== -1) this.element.style.height = `${height}px`;
    }
    getHeight() {
        return this.element.offsetHeight;
    }
    setHeight(height) {
        const { popup: popup } = this.config;
        const eGui = this.element;
        let isPercent = false;
        if (typeof height === "string" && height.includes("%")) {
            $437b23f6a393c3bf$var$_setFixedHeight(eGui, height);
            height = $437b23f6a393c3bf$export$d23c22492e0f7c0c(eGui);
            isPercent = true;
        } else {
            height = Math.max(this.minHeight, height);
            if (this.positioned) {
                const availableHeight = this.getAvailableHeight();
                if (availableHeight && height > availableHeight) height = availableHeight;
            }
        }
        if (this.getHeight() === height) return;
        if (isPercent) {
            eGui.style.maxHeight = "unset";
            eGui.style.minHeight = "unset";
        } else if (popup) $437b23f6a393c3bf$var$_setFixedHeight(eGui, height);
        else {
            eGui.style.height = `${height}px`;
            eGui.style.flex = "0 0 auto";
            this.lastSize.height = typeof height === "number" ? height : Number.parseFloat(height);
        }
    }
    getAvailableHeight() {
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        if (!this.positioned) this.initialisePosition();
        const { clientHeight: clientHeight } = this.offsetParent;
        if (!clientHeight) return null;
        const elRect = this.element.getBoundingClientRect();
        const offsetParentRect = this.offsetParent.getBoundingClientRect();
        const yPosition = popup ? this.position.y : elRect.top;
        const parentTop = popup ? 0 : offsetParentRect.top;
        let additionalHeight = 0;
        if (forcePopupParentAsOffsetParent) {
            const parentEl = this.element.parentElement;
            if (parentEl) {
                const { bottom: bottom } = parentEl.getBoundingClientRect();
                additionalHeight = bottom - elRect.bottom;
            }
        }
        const availableHeight = clientHeight + parentTop - yPosition - additionalHeight;
        return availableHeight;
    }
    getWidth() {
        return this.element.offsetWidth;
    }
    setWidth(width) {
        const eGui = this.element;
        const { popup: popup } = this.config;
        let isPercent = false;
        if (typeof width === "string" && width.includes("%")) {
            $437b23f6a393c3bf$export$ce98ba7f5cfe7725(eGui, width);
            width = $437b23f6a393c3bf$export$642efcb17474eb51(eGui);
            isPercent = true;
        } else if (this.positioned) {
            width = Math.max(this.minWidth, width);
            const { clientWidth: clientWidth } = this.offsetParent;
            const xPosition = popup ? this.position.x : this.element.getBoundingClientRect().left;
            if (clientWidth && width + xPosition > clientWidth) width = clientWidth - xPosition;
        }
        if (this.getWidth() === width) return;
        if (isPercent) {
            eGui.style.maxWidth = "unset";
            eGui.style.minWidth = "unset";
        } else if (this.config.popup) $437b23f6a393c3bf$export$ce98ba7f5cfe7725(eGui, width);
        else {
            eGui.style.width = `${width}px`;
            eGui.style.flex = " unset";
            this.lastSize.width = typeof width === "number" ? width : Number.parseFloat(width);
        }
    }
    offsetElement(x = 0, y = 0, postProcessCallback) {
        const { forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        const ePopup = forcePopupParentAsOffsetParent ? this.boundaryEl : this.element;
        if (!ePopup) return;
        this.popupSvc?.positionPopup({
            ePopup: ePopup,
            keepWithinBounds: true,
            skipObserver: this.movable || this.isResizable(),
            updatePosition: ()=>({
                    x: x,
                    y: y
                }),
            postProcessCallback: postProcessCallback
        });
        this.setPosition(Number.parseFloat(ePopup.style.left), Number.parseFloat(ePopup.style.top));
    }
    constrainSizeToAvailableHeight(constrain) {
        if (!this.config.forcePopupParentAsOffsetParent) return;
        const applyMaxHeightToElement = ()=>{
            const availableHeight = this.getAvailableHeight();
            this.element.style.setProperty("max-height", `${availableHeight}px`);
        };
        if (constrain && this.popupSvc) {
            this.resizeObserverSubscriber?.();
            this.resizeObserverSubscriber = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.popupSvc?.getPopupParent(), applyMaxHeightToElement);
        } else {
            this.element.style.removeProperty("max-height");
            if (this.resizeObserverSubscriber) {
                this.resizeObserverSubscriber();
                this.resizeObserverSubscriber = void 0;
            }
        }
    }
    setPosition(x, y) {
        this.position.x = x;
        this.position.y = y;
    }
    updateDragStartPosition(x, y) {
        this.dragStartPosition = {
            x: x,
            y: y
        };
    }
    calculateMouseMovement(params) {
        const { e: e, isLeft: isLeft, isTop: isTop, anywhereWithin: anywhereWithin, topBuffer: topBuffer } = params;
        const xDiff = e.clientX - this.dragStartPosition.x;
        const yDiff = e.clientY - this.dragStartPosition.y;
        const movementX = this.shouldSkipX(e, !!isLeft, !!anywhereWithin, xDiff) ? 0 : xDiff;
        const movementY = this.shouldSkipY(e, !!isTop, topBuffer, yDiff) ? 0 : yDiff;
        return {
            movementX: movementX,
            movementY: movementY
        };
    }
    shouldSkipX(e, isLeft, anywhereWithin, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const xPosition = this.config.popup ? this.position.x : elRect.left;
        let skipX = xPosition <= 0 && parentRect.left >= e.clientX || parentRect.right <= e.clientX && parentRect.right <= boundaryElRect.right;
        if (skipX) return true;
        if (isLeft) skipX = // is positioned to the right of the left side anchor
        diff < 0 && e.clientX > xPosition + parentRect.left || // skip if we are moving to the right and the cursor
        // is positioned to the left of the dialog
        diff > 0 && e.clientX < xPosition + parentRect.left;
        else if (anywhereWithin) skipX = diff < 0 && e.clientX > boundaryElRect.right || diff > 0 && e.clientX < xPosition + parentRect.left;
        else skipX = // we skip if we are moving to the left and the cursor
        // is to the right of the dialog
        diff < 0 && e.clientX > boundaryElRect.right || // or skip if we are moving to the right and the cursor
        // is to the left of the right side anchor
        diff > 0 && e.clientX < boundaryElRect.right;
        return skipX;
    }
    shouldSkipY(e, isTop, topBuffer = 0, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const yPosition = this.config.popup ? this.position.y : elRect.top;
        let skipY = yPosition <= 0 && parentRect.top >= e.clientY || parentRect.bottom <= e.clientY && parentRect.bottom <= boundaryElRect.bottom;
        if (skipY) return true;
        if (isTop) skipY = // below the top anchor + topBuffer
        // note: topBuffer is used when moving the dialog using the title bar
        diff < 0 && e.clientY > yPosition + parentRect.top + topBuffer || // skip if we are moving to the bottom and the cursor is
        // above the top anchor
        diff > 0 && e.clientY < yPosition + parentRect.top;
        else skipY = // is below the bottom anchor
        diff < 0 && e.clientY > boundaryElRect.bottom || // skip if we are moving towards the bottom and the cursor
        // is above the bottom anchor
        diff > 0 && e.clientY < boundaryElRect.bottom;
        return skipY;
    }
    createResizeMap() {
        const getElement2 = (ref)=>({
                element: this.element.querySelector(`[data-ref=${ref}Resizer]`)
            });
        this.resizerMap = {
            topLeft: getElement2("eTopLeft"),
            top: getElement2("eTop"),
            topRight: getElement2("eTopRight"),
            right: getElement2("eRight"),
            bottomRight: getElement2("eBottomRight"),
            bottom: getElement2("eBottom"),
            bottomLeft: getElement2("eBottomLeft"),
            left: getElement2("eLeft")
        };
    }
    addResizers() {
        if (this.resizersAdded) return;
        const eGui = this.element;
        if (!eGui) return;
        eGui.appendChild($437b23f6a393c3bf$export$378bc9c64290bc8b($437b23f6a393c3bf$var$RESIZE_TEMPLATE));
        this.createResizeMap();
        this.resizersAdded = true;
    }
    removeResizers() {
        this.resizerMap = void 0;
        const resizerEl = this.element.querySelector(`.${$437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE}`);
        resizerEl?.remove();
        this.resizersAdded = false;
    }
    getResizerElement(side) {
        return this.resizerMap[side].element;
    }
    onResizeStart(e, side) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.currentResizer = {
            isTop: !!side.match(/top/i),
            isRight: !!side.match(/right/i),
            isBottom: !!side.match(/bottom/i),
            isLeft: !!side.match(/left/i)
        };
        this.element.classList.add("ag-resizing");
        this.resizerMap[side].element.classList.add("ag-active");
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        if (!popup && !forcePopupParentAsOffsetParent) this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop);
        this.isResizing = true;
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    getSiblings() {
        const element = this.element;
        const parent = element.parentElement;
        if (!parent) return null;
        return Array.prototype.slice.call(parent.children).filter((el)=>!el.classList.contains("ag-hidden"));
    }
    getMinSizeOfSiblings() {
        const siblings = this.getSiblings() || [];
        let height = 0;
        let width = 0;
        for (const currentEl of siblings){
            const isFlex = !!currentEl.style.flex && currentEl.style.flex !== "0 0 auto";
            if (currentEl === this.element) continue;
            let nextHeight = this.minHeight || 0;
            let nextWidth = this.minWidth || 0;
            if (isFlex) {
                const computedStyle = window.getComputedStyle(currentEl);
                if (computedStyle.minHeight) nextHeight = Number.parseInt(computedStyle.minHeight, 10);
                if (computedStyle.minWidth) nextWidth = Number.parseInt(computedStyle.minWidth, 10);
            } else {
                nextHeight = currentEl.offsetHeight;
                nextWidth = currentEl.offsetWidth;
            }
            height += nextHeight;
            width += nextWidth;
        }
        return {
            height: height,
            width: width
        };
    }
    applySizeToSiblings(vertical) {
        let containerToFlex = null;
        const siblings = this.getSiblings();
        if (!siblings) return;
        for(let i = 0; i < siblings.length; i++){
            const el = siblings[i];
            if (el === containerToFlex) continue;
            if (vertical) el.style.height = `${el.offsetHeight}px`;
            else el.style.width = `${el.offsetWidth}px`;
            el.style.flex = "0 0 auto";
            if (el === this.element) containerToFlex = siblings[i + 1];
        }
        if (containerToFlex) {
            containerToFlex.style.removeProperty("height");
            containerToFlex.style.removeProperty("min-height");
            containerToFlex.style.removeProperty("max-height");
            containerToFlex.style.flex = "1 1 auto";
        }
    }
    isResizable() {
        return Object.values(this.resizable).some((value)=>value);
    }
    onResize(e) {
        if (!this.isResizing || !this.currentResizer) return;
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        const { isTop: isTop, isRight: isRight, isBottom: isBottom, isLeft: isLeft } = this.currentResizer;
        const isHorizontal = isRight || isLeft;
        const isVertical = isBottom || isTop;
        const { movementX: movementX, movementY: movementY } = this.calculateMouseMovement({
            e: e,
            isLeft: isLeft,
            isTop: isTop
        });
        const xPosition = this.position.x;
        const yPosition = this.position.y;
        let offsetLeft = 0;
        let offsetTop = 0;
        if (isHorizontal && movementX) {
            const direction = isLeft ? -1 : 1;
            const oldWidth = this.getWidth();
            const newWidth = oldWidth + movementX * direction;
            let skipWidth = false;
            if (isLeft) {
                offsetLeft = oldWidth - newWidth;
                if (xPosition + offsetLeft <= 0 || newWidth <= this.minWidth) {
                    skipWidth = true;
                    offsetLeft = 0;
                }
            }
            if (!skipWidth) this.setWidth(newWidth);
        }
        if (isVertical && movementY) {
            const direction = isTop ? -1 : 1;
            const oldHeight = this.getHeight();
            const newHeight = oldHeight + movementY * direction;
            let skipHeight = false;
            if (isTop) {
                offsetTop = oldHeight - newHeight;
                if (yPosition + offsetTop <= 0 || newHeight <= this.minHeight) {
                    skipHeight = true;
                    offsetTop = 0;
                }
            } else if (// do not let the size of all siblings be higher than the parent container
            !this.config.popup && !this.config.forcePopupParentAsOffsetParent && oldHeight < newHeight && this.getMinSizeOfSiblings().height + newHeight > this.element.parentElement.offsetHeight) skipHeight = true;
            if (!skipHeight) this.setHeight(newHeight);
        }
        this.updateDragStartPosition(e.clientX, e.clientY);
        if ((popup || forcePopupParentAsOffsetParent) && offsetLeft || offsetTop) this.offsetElement(xPosition + offsetLeft, yPosition + offsetTop);
    }
    onResizeEnd(e, side) {
        this.isResizing = false;
        this.currentResizer = null;
        this.boundaryEl = null;
        this.element.classList.remove("ag-resizing");
        this.resizerMap[side].element.classList.remove("ag-active");
        this.dispatchLocalEvent({
            type: "resize"
        });
    }
    refreshSize() {
        const eGui = this.element;
        if (this.config.popup) {
            if (!this.config.width) this.setWidth(eGui.offsetWidth);
            if (!this.config.height) this.setHeight(eGui.offsetHeight);
        }
    }
    onMoveStart(e) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.isMoving = true;
        this.element.classList.add("ag-moving");
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMove(e) {
        if (!this.isMoving) return;
        const { x: x, y: y } = this.position;
        let topBuffer;
        if (this.config.calculateTopBuffer) topBuffer = this.config.calculateTopBuffer();
        const { movementX: movementX, movementY: movementY } = this.calculateMouseMovement({
            e: e,
            isTop: true,
            anywhereWithin: true,
            topBuffer: topBuffer
        });
        this.offsetElement(x + movementX, y + movementY);
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMoveEnd() {
        this.isMoving = false;
        this.boundaryEl = null;
        this.element.classList.remove("ag-moving");
    }
    setOffsetParent() {
        if (this.config.forcePopupParentAsOffsetParent && this.popupSvc) this.offsetParent = this.popupSvc.getPopupParent();
        else this.offsetParent = this.element.offsetParent;
    }
    findBoundaryElement() {
        let el = this.element;
        while(el){
            if (window.getComputedStyle(el).position !== "static") return el;
            el = el.parentElement;
        }
        return this.element;
    }
    clearResizeListeners() {
        while(this.resizeListeners.length){
            const params = this.resizeListeners.pop();
            this.dragSvc?.removeDragSource(params);
        }
    }
    destroy() {
        super.destroy();
        if (this.moveElementDragListener) this.dragSvc?.removeDragSource(this.moveElementDragListener);
        this.constrainSizeToAvailableHeight(false);
        this.clearResizeListeners();
        this.removeResizers();
    }
};
// packages/ag-grid-community/src/agStack/utils/date.ts
var $437b23f6a393c3bf$var$DATE_TIME_SEPARATOR = "T";
var $437b23f6a393c3bf$var$DATE_TIME_SEPARATOR_REGEXP = new RegExp(`[${$437b23f6a393c3bf$var$DATE_TIME_SEPARATOR} ]`);
var $437b23f6a393c3bf$var$DATE_TIME_REGEXP = new RegExp(`^\\d{4}-\\d{2}-\\d{2}(${$437b23f6a393c3bf$var$DATE_TIME_SEPARATOR}\\d{2}:\\d{2}:\\d{2}\\D?)?`);
function $437b23f6a393c3bf$var$_padStartWidthZeros(value, totalStringSize) {
    return value.toString().padStart(totalStringSize, "0");
}
function $437b23f6a393c3bf$export$3d7fedfb21962874(date, includeTime = true, separator = $437b23f6a393c3bf$var$DATE_TIME_SEPARATOR) {
    if (!date) return null;
    let serialised = [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()
    ].map((part)=>$437b23f6a393c3bf$var$_padStartWidthZeros(part, 2)).join("-");
    if (includeTime) serialised += separator + [
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    ].map((part)=>$437b23f6a393c3bf$var$_padStartWidthZeros(part, 2)).join(":");
    return serialised;
}
function $437b23f6a393c3bf$export$bb4eb333cc2b3e25(d, includeTime = true) {
    if (!d) return null;
    if (includeTime) return [
        String(d.getFullYear()),
        String(d.getMonth() + 1),
        $437b23f6a393c3bf$var$_padStartWidthZeros(d.getDate(), 2),
        $437b23f6a393c3bf$var$_padStartWidthZeros(d.getHours(), 2),
        `:${$437b23f6a393c3bf$var$_padStartWidthZeros(d.getMinutes(), 2)}`,
        `:${$437b23f6a393c3bf$var$_padStartWidthZeros(d.getSeconds(), 2)}`
    ];
    return [
        d.getFullYear(),
        d.getMonth() + 1,
        $437b23f6a393c3bf$var$_padStartWidthZeros(d.getDate(), 2)
    ].map(String);
}
var $437b23f6a393c3bf$var$calculateOrdinal = (value)=>{
    if (value > 3 && value < 21) return "th";
    const remainder = value % 10;
    switch(remainder){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
    }
    return "th";
};
var $437b23f6a393c3bf$export$ae5a33daf12ff29 = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $437b23f6a393c3bf$var$DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
function $437b23f6a393c3bf$var$_dateToFormattedString(date, format) {
    if (format == null) return $437b23f6a393c3bf$export$3d7fedfb21962874(date, false);
    const fullYear = $437b23f6a393c3bf$var$_padStartWidthZeros(date.getFullYear(), 4);
    const replace = {
        YYYY: ()=>fullYear.slice(fullYear.length - 4, fullYear.length),
        YY: ()=>fullYear.slice(fullYear.length - 2, fullYear.length),
        Y: ()=>`${date.getFullYear()}`,
        MMMM: ()=>$437b23f6a393c3bf$export$ae5a33daf12ff29[date.getMonth()],
        MMM: ()=>$437b23f6a393c3bf$export$ae5a33daf12ff29[date.getMonth()].slice(0, 3),
        MM: ()=>$437b23f6a393c3bf$var$_padStartWidthZeros(date.getMonth() + 1, 2),
        Mo: ()=>`${date.getMonth() + 1}${$437b23f6a393c3bf$var$calculateOrdinal(date.getMonth() + 1)}`,
        M: ()=>`${date.getMonth() + 1}`,
        Do: ()=>`${date.getDate()}${$437b23f6a393c3bf$var$calculateOrdinal(date.getDate())}`,
        DD: ()=>$437b23f6a393c3bf$var$_padStartWidthZeros(date.getDate(), 2),
        D: ()=>`${date.getDate()}`,
        dddd: ()=>$437b23f6a393c3bf$var$DAYS[date.getDay()],
        ddd: ()=>$437b23f6a393c3bf$var$DAYS[date.getDay()].slice(0, 3),
        dd: ()=>$437b23f6a393c3bf$var$DAYS[date.getDay()].slice(0, 2),
        do: ()=>`${date.getDay()}${$437b23f6a393c3bf$var$calculateOrdinal(date.getDay())}`,
        d: ()=>`${date.getDay()}`
    };
    const regexp = new RegExp(Object.keys(replace).join("|"), "g");
    return format.replace(regexp, (match)=>{
        if (match in replace) return replace[match]();
        return match;
    });
}
function $437b23f6a393c3bf$var$_isValidDate(value, bailIfInvalidTime = false) {
    return !!$437b23f6a393c3bf$export$26ded2d88c01b527(value, bailIfInvalidTime);
}
function $437b23f6a393c3bf$var$_isValidDateTime(value) {
    return $437b23f6a393c3bf$var$_isValidDate(value, true);
}
function $437b23f6a393c3bf$export$26ded2d88c01b527(value, bailIfInvalidTime = false, skipValidation) {
    if (!value) return null;
    if (!skipValidation && !$437b23f6a393c3bf$var$DATE_TIME_REGEXP.test(value)) return null;
    const [dateStr, timeStr] = value.split($437b23f6a393c3bf$var$DATE_TIME_SEPARATOR_REGEXP);
    if (!dateStr) return null;
    const fields = dateStr.split("-").map((f)=>Number.parseInt(f, 10));
    if (fields.filter((f)=>!isNaN(f)).length !== 3) return null;
    const [year, month, day] = fields;
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
    if (!timeStr && bailIfInvalidTime) return null;
    if (!timeStr || timeStr === "00:00:00") return date;
    const [hours, minutes, seconds] = timeStr.split(":").map((part)=>Number.parseInt(part, 10));
    if (hours >= 0 && hours < 24) date.setHours(hours);
    else if (bailIfInvalidTime) return null;
    if (minutes >= 0 && minutes < 60) date.setMinutes(minutes);
    else if (bailIfInvalidTime) return null;
    if (seconds >= 0 && seconds < 60) date.setSeconds(seconds);
    else if (bailIfInvalidTime) return null;
    return date;
}
// packages/ag-grid-community/src/agStack/utils/fuzzyMatch.ts
function $437b23f6a393c3bf$export$85cab1b5a4aa292c(params) {
    const { inputValue: inputValue, allSuggestions: allSuggestions, hideIrrelevant: hideIrrelevant, filterByPercentageOfBestMatch: filterByPercentageOfBestMatch } = params;
    let thisSuggestions = (allSuggestions ?? []).map((text, idx)=>({
            value: text,
            relevance: $437b23f6a393c3bf$var$_getLevenshteinSimilarityDistance(inputValue, text),
            idx: idx
        }));
    thisSuggestions.sort((a, b)=>a.relevance - b.relevance);
    if (hideIrrelevant) thisSuggestions = thisSuggestions.filter((suggestion)=>suggestion.relevance < Math.max(suggestion.value.length, inputValue.length));
    if (thisSuggestions.length > 0 && filterByPercentageOfBestMatch && filterByPercentageOfBestMatch > 0) {
        const bestMatch = thisSuggestions[0].relevance;
        const limit = bestMatch * filterByPercentageOfBestMatch;
        thisSuggestions = thisSuggestions.filter((suggestion)=>limit - suggestion.relevance < 0);
    }
    const values = [];
    const indices = [];
    for (const suggestion of thisSuggestions){
        values.push(suggestion.value);
        indices.push(suggestion.idx);
    }
    return {
        values: values,
        indices: indices
    };
}
function $437b23f6a393c3bf$var$_getLevenshteinSimilarityDistance(source, target) {
    const sourceLength = source.length;
    const targetLength = target.length;
    if (targetLength === 0) return sourceLength ? sourceLength : 0;
    let inputLower = source.toLocaleLowerCase();
    let targetLower = target.toLocaleLowerCase();
    let swapTmp;
    if (source.length < target.length) {
        swapTmp = targetLower;
        targetLower = inputLower;
        inputLower = swapTmp;
        swapTmp = target;
        target = source;
        source = swapTmp;
    }
    let previousRow = new Uint16Array(targetLength + 1);
    let currentRow = new Uint16Array(targetLength + 1);
    for(let j = 0; j <= targetLength; j++)previousRow[j] = j;
    let secondaryScore = 0;
    const earlyMatchLimit = sourceLength / 2 - 10;
    for(let i = 1; i <= sourceLength; i++){
        const inputChar = source[i - 1];
        const inputCharLower = inputLower[i - 1];
        currentRow[0] = i;
        for(let j = 1; j <= targetLength; j++){
            const targetChar = target[j - 1];
            const targetCharLower = targetLower[j - 1];
            if (inputCharLower !== targetCharLower) {
                const insertCost = currentRow[j - 1];
                const deleteCost = previousRow[j];
                const replaceCost = previousRow[j - 1];
                let cost = insertCost < deleteCost ? insertCost : deleteCost;
                if (replaceCost < cost) cost = replaceCost;
                currentRow[j] = cost + 1 | 0;
                continue;
            }
            secondaryScore++;
            if (inputChar === targetChar) secondaryScore++;
            if (i > 1 && j > 1) {
                const prevSourceChar = source[i - 2];
                const prevSourceCharLower = inputLower[i - 2];
                const prevTargetChar = target[j - 2];
                const prevTargetCharLower = targetLower[j - 2];
                if (prevSourceCharLower === prevTargetCharLower) {
                    secondaryScore++;
                    if (prevSourceChar === prevTargetChar) secondaryScore++;
                }
            }
            if (i < earlyMatchLimit) secondaryScore++;
            currentRow[j] = previousRow[j - 1];
        }
        swapTmp = previousRow;
        previousRow = currentRow;
        currentRow = swapTmp;
    }
    return previousRow[targetLength] / (secondaryScore + 1);
}
// packages/ag-grid-community/src/agStack/utils/keyboard.ts
function $437b23f6a393c3bf$export$33ecd6e270298858(event) {
    if (event.altKey || event.ctrlKey || event.metaKey) return false;
    const printableCharacter = event.key?.length === 1;
    return printableCharacter;
}
// packages/ag-grid-community/src/agStack/widgets/agAbstractLabel.css-GENERATED.ts
var $437b23f6a393c3bf$var$agAbstractLabelCSS = /*css*/ `.ag-label{white-space:nowrap}:where(.ag-ltr) .ag-label{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-label-align-right) .ag-label{order:1}:where(.ag-ltr) :where(.ag-label-align-right) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) :where(.ag-label-align-right) .ag-label{margin-right:var(--ag-spacing)}.ag-label-align-right>*{flex:none}.ag-label-align-top{align-items:flex-start;flex-direction:column;>*{align-self:stretch}}.ag-label-ellipsis{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-label-align-top) .ag-label{margin-bottom:calc(var(--ag-spacing)*.5)}`;
// packages/ag-grid-community/src/agStack/widgets/agAbstractLabel.ts
var $437b23f6a393c3bf$export$d72ea6e1c340e03b = class extends $437b23f6a393c3bf$export$e6818678a6454cbe {
    constructor(config, template, components){
        super(template, components);
        this.labelSeparator = "";
        this.labelAlignment = "left";
        this.disabled = false;
        this.label = "";
        this.config = config || {};
        this.registerCSS($437b23f6a393c3bf$var$agAbstractLabelCSS);
    }
    postConstruct() {
        this.addCss("ag-labeled");
        this.eLabel.classList.add("ag-label");
        const { labelSeparator: labelSeparator, label: label, labelWidth: labelWidth, labelAlignment: labelAlignment, disabled: disabled, labelEllipsis: labelEllipsis } = this.config;
        if (disabled != null) this.setDisabled(disabled);
        if (labelSeparator != null) this.setLabelSeparator(labelSeparator);
        if (label != null) this.setLabel(label);
        if (labelWidth != null) this.setLabelWidth(labelWidth);
        if (labelEllipsis != null) this.setLabelEllipsis(labelEllipsis);
        this.setLabelAlignment(labelAlignment || this.labelAlignment);
        this.refreshLabel();
    }
    refreshLabel() {
        const { label: label, eLabel: eLabel } = this;
        $437b23f6a393c3bf$export$69e6e10709eabd91(eLabel);
        if (typeof label === "string") eLabel.innerText = label + this.labelSeparator;
        else if (label) eLabel.appendChild(label);
        if (label === "") {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eLabel, false);
            $437b23f6a393c3bf$export$f8d01fa01787902(eLabel, "presentation");
        } else {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eLabel, true);
            $437b23f6a393c3bf$export$f8d01fa01787902(eLabel, null);
        }
    }
    setLabelSeparator(labelSeparator) {
        if (this.labelSeparator === labelSeparator) return this;
        this.labelSeparator = labelSeparator;
        if (this.label != null) this.refreshLabel();
        return this;
    }
    getLabelId() {
        const eLabel = this.eLabel;
        eLabel.id = eLabel.id || `ag-${this.getCompId()}-label`;
        return eLabel.id;
    }
    getLabel() {
        return this.label;
    }
    setLabel(label) {
        if (this.label === label) return this;
        this.label = label;
        this.refreshLabel();
        return this;
    }
    setLabelAlignment(alignment) {
        const eGui = this.getGui();
        const eGuiClassList = eGui.classList;
        eGuiClassList.toggle("ag-label-align-left", alignment === "left");
        eGuiClassList.toggle("ag-label-align-right", alignment === "right");
        eGuiClassList.toggle("ag-label-align-top", alignment === "top");
        return this;
    }
    setLabelEllipsis(hasEllipsis) {
        this.eLabel.classList.toggle("ag-label-ellipsis", hasEllipsis);
        return this;
    }
    setLabelWidth(width) {
        if (this.label == null) return this;
        $437b23f6a393c3bf$var$_setElementWidth(this.eLabel, width);
        return this;
    }
    setDisabled(disabled) {
        disabled = !!disabled;
        const element = this.getGui();
        $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element, disabled);
        element.classList.toggle("ag-disabled", disabled);
        this.disabled = disabled;
        return this;
    }
    isDisabled() {
        return !!this.disabled;
    }
};
// packages/ag-grid-community/src/agStack/widgets/agAbstractField.ts
var $437b23f6a393c3bf$var$AgAbstractField = class extends $437b23f6a393c3bf$export$d72ea6e1c340e03b {
    constructor(config, template, components, className){
        super(config, template, components);
        this.className = className;
    }
    postConstruct() {
        super.postConstruct();
        const { width: width, value: value, onValueChange: onValueChange, ariaLabel: ariaLabel } = this.config;
        if (width != null) this.setWidth(width);
        if (value != null) this.setValue(value);
        if (onValueChange != null) this.onValueChange(onValueChange);
        if (ariaLabel != null) this.setAriaLabel(ariaLabel);
        if (this.className) this.addCss(this.className);
        this.refreshAriaLabelledBy();
    }
    setLabel(label) {
        super.setLabel(label);
        this.refreshAriaLabelledBy();
        return this;
    }
    refreshAriaLabelledBy() {
        const ariaEl = this.getAriaElement();
        const labelId = this.getLabelId();
        const label = this.getLabel();
        if (label == null || label == "" || $437b23f6a393c3bf$var$_getAriaLabel(ariaEl) !== null) $437b23f6a393c3bf$export$84233c40c4c74001(ariaEl, "");
        else $437b23f6a393c3bf$export$84233c40c4c74001(ariaEl, labelId ?? "");
    }
    setAriaLabel(label) {
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.getAriaElement(), label);
        this.refreshAriaLabelledBy();
        return this;
    }
    onValueChange(callbackFn) {
        this.addManagedListeners(this, {
            fieldValueChanged: ()=>callbackFn(this.getValue())
        });
        return this;
    }
    getWidth() {
        return this.getGui().clientWidth;
    }
    setWidth(width) {
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.getGui(), width);
        return this;
    }
    getPreviousValue() {
        return this.previousValue;
    }
    getValue() {
        return this.value;
    }
    setValue(value, silent) {
        if (this.value === value) return this;
        this.previousValue = this.value;
        this.value = value;
        if (!silent) this.dispatchLocalEvent({
            type: "fieldValueChanged"
        });
        return this;
    }
};
// packages/ag-grid-community/src/agStack/widgets/agAbstractInputField.ts
function $437b23f6a393c3bf$var$buildTemplate(displayFieldTag) {
    return {
        tag: "div",
        role: "presentation",
        children: [
            {
                tag: "div",
                ref: "eLabel",
                cls: "ag-input-field-label"
            },
            {
                tag: "div",
                ref: "eWrapper",
                cls: "ag-wrapper ag-input-wrapper",
                role: "presentation",
                children: [
                    {
                        tag: displayFieldTag,
                        ref: "eInput",
                        cls: "ag-input-field-input"
                    }
                ]
            }
        ]
    };
}
var $437b23f6a393c3bf$export$9671f513d4aa42e3 = class extends $437b23f6a393c3bf$var$AgAbstractField {
    constructor(config, className, inputType = "text", displayFieldTag = "input"){
        super(config, config?.template ?? $437b23f6a393c3bf$var$buildTemplate(displayFieldTag), [], className);
        this.inputType = inputType;
        this.displayFieldTag = displayFieldTag;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eInput = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        super.postConstruct();
        this.setInputType(this.inputType);
        const { eLabel: eLabel, eWrapper: eWrapper, eInput: eInput, className: className } = this;
        eLabel.classList.add(`${className}-label`);
        eWrapper.classList.add(`${className}-input-wrapper`);
        eInput.classList.add(`${className}-input`);
        this.addCss("ag-input-field");
        eInput.id = eInput.id || `ag-${this.getCompId()}-input`;
        const { inputName: inputName, inputWidth: inputWidth, inputPlaceholder: inputPlaceholder, autoComplete: autoComplete, tabIndex: tabIndex } = this.config;
        if (inputName != null) this.setInputName(inputName);
        if (inputWidth != null) this.setInputWidth(inputWidth);
        if (inputPlaceholder != null) this.setInputPlaceholder(inputPlaceholder);
        if (autoComplete != null) this.setAutoComplete(autoComplete);
        this.addInputListeners();
        this.activateTabIndex([
            eInput
        ], tabIndex);
    }
    addInputListeners() {
        this.addManagedElementListeners(this.eInput, {
            input: (e)=>this.setValue(e.target.value)
        });
    }
    setInputType(inputType) {
        if (this.displayFieldTag === "input") {
            this.inputType = inputType;
            $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "type", inputType);
        }
    }
    getInputElement() {
        return this.eInput;
    }
    getWrapperElement() {
        return this.eWrapper;
    }
    setInputWidth(width) {
        $437b23f6a393c3bf$var$_setElementWidth(this.eWrapper, width);
        return this;
    }
    setInputName(name) {
        this.getInputElement().setAttribute("name", name);
        return this;
    }
    getFocusableElement() {
        return this.eInput;
    }
    setMaxLength(length) {
        const eInput = this.eInput;
        eInput.maxLength = length;
        return this;
    }
    setInputPlaceholder(placeholder) {
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "placeholder", placeholder);
        return this;
    }
    setInputAriaLabel(label) {
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.eInput, label);
        this.refreshAriaLabelledBy();
        return this;
    }
    setDisabled(disabled) {
        $437b23f6a393c3bf$export$b6b4f08392e9bfaf(this.eInput, disabled);
        return super.setDisabled(disabled);
    }
    setAutoComplete(value) {
        if (value === true) $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "autocomplete", null);
        else {
            const autoCompleteValue = typeof value === "string" ? value : "off";
            $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "autocomplete", autoCompleteValue);
        }
        return this;
    }
};
// packages/ag-grid-community/src/agStack/widgets/agCheckbox.ts
var $437b23f6a393c3bf$export$b00c508c1ae18d07 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config, className = "ag-checkbox", inputType = "checkbox"){
        super(config, className, inputType);
        this.labelAlignment = "right";
        this.selected = false;
        this.readOnly = false;
        this.passive = false;
    }
    postConstruct() {
        super.postConstruct();
        const { readOnly: readOnly, passive: passive, name: name } = this.config;
        if (typeof readOnly === "boolean") this.setReadOnly(readOnly);
        if (typeof passive === "boolean") this.setPassive(passive);
        if (name != null) this.setName(name);
    }
    addInputListeners() {
        this.addManagedElementListeners(this.eInput, {
            click: this.onCheckboxClick.bind(this)
        });
        this.addManagedElementListeners(this.eLabel, {
            click: this.toggle.bind(this)
        });
    }
    getNextValue() {
        return this.selected === void 0 ? true : !this.selected;
    }
    setPassive(passive) {
        this.passive = passive;
    }
    isReadOnly() {
        return this.readOnly;
    }
    setReadOnly(readOnly) {
        this.eWrapper.classList.toggle("ag-disabled", readOnly);
        this.eInput.disabled = readOnly;
        this.readOnly = readOnly;
    }
    setDisabled(disabled) {
        this.eWrapper.classList.toggle("ag-disabled", disabled);
        return super.setDisabled(disabled);
    }
    toggle() {
        if (this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const nextValue = this.getNextValue();
        if (this.passive) this.dispatchChange(nextValue, previousValue);
        else this.setValue(nextValue);
    }
    getValue() {
        return this.isSelected();
    }
    setValue(value, silent) {
        this.refreshSelectedClass(value);
        this.setSelected(value, silent);
        return this;
    }
    setName(name) {
        const input = this.getInputElement();
        input.name = name;
        return this;
    }
    isSelected() {
        return this.selected;
    }
    setSelected(selected, silent) {
        if (this.isSelected() === selected) return;
        this.previousValue = this.isSelected();
        selected = this.selected = typeof selected === "boolean" ? selected : void 0;
        const eInput = this.eInput;
        eInput.checked = selected;
        eInput.indeterminate = selected === void 0;
        if (!silent) this.dispatchChange(this.selected, this.previousValue);
    }
    dispatchChange(selected, previousValue, event) {
        this.dispatchLocalEvent({
            type: "fieldValueChanged",
            selected: selected,
            previousValue: previousValue,
            event: event
        });
        const input = this.getInputElement();
        this.eventSvc.dispatchEvent({
            type: "checkboxChanged",
            id: input.id,
            name: input.name,
            selected: selected,
            previousValue: previousValue
        });
    }
    onCheckboxClick(e) {
        if (this.passive || this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const selected = this.selected = e.target.checked;
        this.refreshSelectedClass(selected);
        this.dispatchChange(selected, previousValue, e);
    }
    refreshSelectedClass(value) {
        const classList = this.eWrapper.classList;
        classList.toggle("ag-checked", value === true);
        classList.toggle("ag-indeterminate", value == null);
    }
};
var $437b23f6a393c3bf$export$2e2c317d2e31f2ca = {
    selector: "AG-CHECKBOX",
    component: $437b23f6a393c3bf$export$b00c508c1ae18d07
};
// packages/ag-grid-community/src/agStack/widgets/agRadioButton.ts
var $437b23f6a393c3bf$export$5caa9ea96bbb722 = class extends $437b23f6a393c3bf$export$b00c508c1ae18d07 {
    constructor(config){
        super(config, "ag-radio-button", "radio");
    }
    isSelected() {
        return this.eInput.checked;
    }
    toggle() {
        if (this.eInput.disabled) return;
        if (!this.isSelected()) this.setValue(true);
    }
    addInputListeners() {
        super.addInputListeners();
        this.addManagedEventListeners({
            checkboxChanged: this.onChange.bind(this)
        });
    }
    /**
   * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
   * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
   * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
   * not deselected, so we need to use our own event.
   */ onChange(event) {
        const eInput = this.eInput;
        if (event.selected && event.name && eInput.name && eInput.name === event.name && event.id && eInput.id !== event.id) this.setValue(false, true);
    }
};
var $437b23f6a393c3bf$export$87f0c19f7b666331 = {
    selector: "AG-RADIO-BUTTON",
    component: $437b23f6a393c3bf$export$5caa9ea96bbb722
};
// packages/ag-grid-community/src/agStack/widgets/agToggleButton.css-GENERATED.ts
var $437b23f6a393c3bf$var$agToggleButtonCSS = /*css*/ `.ag-toggle-button{flex:none;min-width:unset;width:unset}.ag-toggle-button-input-wrapper{background-color:var(--ag-toggle-button-off-background-color);border-radius:calc(var(--ag-toggle-button-height)*.5);flex:none;height:var(--ag-toggle-button-height);max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);position:relative;transition:background-color .1s;:where(.ag-toggle-button-input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-toggle-button-height);margin:0;max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);opacity:0}&:before{background-color:var(--ag-toggle-button-switch-background-color);border-radius:100%;content:"";display:block;height:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2);left:var(--ag-toggle-button-switch-inset);pointer-events:none;position:absolute;top:var(--ag-toggle-button-switch-inset);transition:left .1s;width:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2)}&.ag-checked{background-color:var(--ag-toggle-button-on-background-color);&:before{left:calc(100% - var(--ag-toggle-button-height) + var(--ag-toggle-button-switch-inset))}}&:focus-within{box-shadow:var(--ag-focus-shadow)}&.ag-disabled{opacity:.5}}`;
// packages/ag-grid-community/src/agStack/widgets/agToggleButton.ts
var $437b23f6a393c3bf$export$167b21bf245ce0bf = class extends $437b23f6a393c3bf$export$b00c508c1ae18d07 {
    constructor(config){
        super(config, "ag-toggle-button");
        this.registerCSS($437b23f6a393c3bf$var$agToggleButtonCSS);
    }
    setValue(value, silent) {
        super.setValue(value, silent);
        this.toggleCss("ag-selected", this.getValue());
        return this;
    }
};
var $437b23f6a393c3bf$export$b825a5135f318030 = {
    selector: "AG-TOGGLE-BUTTON",
    component: $437b23f6a393c3bf$export$167b21bf245ce0bf
};
// packages/ag-grid-community/src/agStack/widgets/agInputTextField.ts
var $437b23f6a393c3bf$export$8c027679838afd47 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config, className = "ag-text-field", inputType = "text"){
        super(config, className, inputType);
    }
    postConstruct() {
        super.postConstruct();
        if (this.config.allowedCharPattern) this.preventDisallowedCharacters();
    }
    setValue(value, silent) {
        const eInput = this.eInput;
        if (eInput.value !== value) eInput.value = $437b23f6a393c3bf$export$25d27f17d3af40f7(value) ? value : "";
        return super.setValue(value, silent);
    }
    /** Used to set an initial value into the input without necessarily setting `this.value` or triggering events (e.g. to set an invalid value) */ setStartValue(value) {
        this.setValue(value, true);
    }
    setCustomValidity(message) {
        const eInput = this.eInput;
        const isInvalid = message.length > 0;
        eInput.setCustomValidity(message);
        if (isInvalid) eInput.reportValidity();
        $437b23f6a393c3bf$export$fd1450327e6900f2(eInput, isInvalid);
    }
    preventDisallowedCharacters() {
        const pattern = new RegExp(`[${this.config.allowedCharPattern}]`);
        const preventCharacters = (event)=>{
            if (!$437b23f6a393c3bf$export$33ecd6e270298858(event)) return;
            if (event.key && !pattern.test(event.key)) event.preventDefault();
        };
        this.addManagedListeners(this.eInput, {
            keydown: preventCharacters,
            paste: (e)=>{
                const text = e.clipboardData?.getData("text");
                if (text?.split("").some((c)=>!pattern.test(c))) e.preventDefault();
            }
        });
    }
};
var $437b23f6a393c3bf$export$31e2985be4ee06ab = {
    selector: "AG-INPUT-TEXT-FIELD",
    component: $437b23f6a393c3bf$export$8c027679838afd47
};
// packages/ag-grid-community/src/agStack/widgets/agInputTextArea.ts
var $437b23f6a393c3bf$export$fd677433260ffbc8 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config){
        super(config, "ag-text-area", null, "textarea");
    }
    setValue(value, silent) {
        const ret = super.setValue(value, silent);
        this.eInput.value = value;
        return ret;
    }
    setCols(cols) {
        this.eInput.cols = cols;
        return this;
    }
    setRows(rows) {
        this.eInput.rows = rows;
        return this;
    }
};
var $437b23f6a393c3bf$var$AgInputTextAreaSelector = {
    selector: "AG-INPUT-TEXT-AREA",
    component: $437b23f6a393c3bf$export$fd677433260ffbc8
};
// packages/ag-grid-community/src/agStack/widgets/agInputNumberField.ts
var $437b23f6a393c3bf$export$c8aa0be99738aee = class extends $437b23f6a393c3bf$export$8c027679838afd47 {
    constructor(config){
        super(config, "ag-number-field", "number");
    }
    postConstruct() {
        super.postConstruct();
        const eInput = this.eInput;
        this.addManagedListeners(eInput, {
            blur: ()=>{
                const floatedValue = Number.parseFloat(eInput.value);
                const value = isNaN(floatedValue) ? "" : this.normalizeValue(floatedValue.toString());
                if (this.value !== value) this.setValue(value);
            },
            wheel: this.onWheel.bind(this)
        });
        eInput.step = "any";
        const { precision: precision, min: min, max: max, step: step } = this.config;
        if (typeof precision === "number") this.setPrecision(precision);
        if (typeof min === "number") this.setMin(min);
        if (typeof max === "number") this.setMax(max);
        if (typeof step === "number") this.setStep(step);
    }
    onWheel(e) {
        if ($437b23f6a393c3bf$export$16bc98d422315038(this.beans) === this.eInput) e.preventDefault();
    }
    normalizeValue(value) {
        if (value === "") return "";
        if (this.precision != null) value = this.adjustPrecision(value);
        return value;
    }
    adjustPrecision(value, isScientificNotation) {
        const precision = this.precision;
        if (precision == null) return value;
        if (isScientificNotation) {
            const floatString = Number.parseFloat(value).toFixed(precision);
            return Number.parseFloat(floatString).toString();
        }
        const parts = String(value).split(".");
        if (parts.length > 1) {
            if (parts[1].length <= precision) return value;
            else if (precision > 0) return `${parts[0]}.${parts[1].slice(0, precision)}`;
        }
        return parts[0];
    }
    setMin(min) {
        if (this.min === min) return this;
        this.min = min;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(max) {
        if (this.max === max) return this;
        this.max = max;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setPrecision(precision) {
        this.precision = precision;
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    setValue(value, silent) {
        return this.setValueOrInputValue((v)=>super.setValue(v, silent), ()=>this, value);
    }
    setStartValue(value) {
        return this.setValueOrInputValue((v)=>super.setValue(v, true), (v)=>{
            this.eInput.value = v;
        }, value);
    }
    setValueOrInputValue(setValueFunc, setInputValueOnlyFunc, value) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) {
            let setInputValueOnly = this.isScientificNotation(value);
            if (setInputValueOnly && this.eInput.validity.valid) return setValueFunc(value);
            if (!setInputValueOnly) {
                value = this.adjustPrecision(value);
                const normalizedValue = this.normalizeValue(value);
                setInputValueOnly = value != normalizedValue;
            }
            if (setInputValueOnly) return setInputValueOnlyFunc(value);
        }
        return setValueFunc(value);
    }
    getValue(ignoreValidity = false) {
        const eInput = this.eInput;
        if (!eInput.validity.valid && !ignoreValidity) return void 0;
        const inputValue = eInput.value;
        if (this.isScientificNotation(inputValue)) return this.adjustPrecision(inputValue, true);
        return super.getValue();
    }
    isScientificNotation(value) {
        return typeof value === "string" && value.includes("e");
    }
};
var $437b23f6a393c3bf$export$c18153c9c909b7d7 = {
    selector: "AG-INPUT-NUMBER-FIELD",
    component: $437b23f6a393c3bf$export$c8aa0be99738aee
};
// packages/ag-grid-community/src/agStack/widgets/agInputDateField.ts
var $437b23f6a393c3bf$export$9e01ec8ba43de612 = class extends $437b23f6a393c3bf$export$8c027679838afd47 {
    constructor(config){
        super(config, "ag-date-field", "date");
    }
    postConstruct() {
        super.postConstruct();
        const usingSafari = $437b23f6a393c3bf$export$8caf403dacd36a68();
        this.addManagedListeners(this.eInput, {
            wheel: this.onWheel.bind(this),
            mousedown: ()=>{
                if (this.isDisabled() || usingSafari) return;
                this.eInput.focus();
            }
        });
        this.eInput.step = "any";
    }
    onWheel(e) {
        if ($437b23f6a393c3bf$export$16bc98d422315038(this.beans) === this.eInput) e.preventDefault();
    }
    setMin(minDate) {
        const min = minDate instanceof Date ? $437b23f6a393c3bf$export$3d7fedfb21962874(minDate ?? null, !!this.includeTime) ?? void 0 : minDate;
        if (this.min === min) return this;
        this.min = min;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(maxDate) {
        const max = maxDate instanceof Date ? $437b23f6a393c3bf$export$3d7fedfb21962874(maxDate ?? null, !!this.includeTime) ?? void 0 : maxDate;
        if (this.max === max) return this;
        this.max = max;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    setIncludeTime(includeTime) {
        if (this.includeTime === includeTime) return this;
        this.includeTime = includeTime;
        super.setInputType(includeTime ? "datetime-local" : "date");
        if (includeTime) this.setStep(1);
        return this;
    }
    getDate() {
        if (!this.eInput.validity.valid) return void 0;
        return $437b23f6a393c3bf$export$26ded2d88c01b527(this.getValue()) ?? void 0;
    }
    setDate(date, silent) {
        this.setValue($437b23f6a393c3bf$export$3d7fedfb21962874(date ?? null, this.includeTime), silent);
    }
};
var $437b23f6a393c3bf$var$AgInputDateFieldSelector = {
    selector: "AG-INPUT-DATE-FIELD",
    component: $437b23f6a393c3bf$export$9e01ec8ba43de612
};
// packages/ag-grid-community/src/agStack/widgets/agList.css-GENERATED.ts
var $437b23f6a393c3bf$var$agListCSS = /*css*/ `.ag-list-item{align-items:center;display:flex;height:var(--ag-list-item-height);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;&.ag-active-item{background-color:var(--ag-row-hover-color)}}`;
// packages/ag-grid-community/src/agStack/widgets/agListItem.ts
var $437b23f6a393c3bf$var$ACTIVE_CLASS = "ag-active-item";
var $437b23f6a393c3bf$var$getAgListElement = (cssIdentifier, label)=>({
        tag: "div",
        cls: `ag-list-item ag-${cssIdentifier}-list-item`,
        attrs: {
            role: "option"
        },
        children: [
            {
                tag: "span",
                ref: "eText",
                children: label
            }
        ]
    });
var $437b23f6a393c3bf$var$AgListItem = class extends $437b23f6a393c3bf$export$e6818678a6454cbe {
    constructor(cssIdentifier, label, value){
        super($437b23f6a393c3bf$var$getAgListElement(cssIdentifier, label));
        this.label = label;
        this.value = value;
        this.eText = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        this.createTooltip();
        this.addEventListeners();
    }
    setHighlighted(highlighted) {
        const eGui = this.getGui();
        eGui.classList.toggle($437b23f6a393c3bf$var$ACTIVE_CLASS, highlighted);
        $437b23f6a393c3bf$export$c22e3722e8a33469(eGui, highlighted);
        this.dispatchLocalEvent({
            type: "itemHighlighted",
            highlighted: highlighted
        });
    }
    getHeight() {
        return this.getGui().clientHeight;
    }
    setIndex(idx, setSize) {
        const eGui = this.getGui();
        $437b23f6a393c3bf$export$c3d3aede41065a84(eGui, idx);
        $437b23f6a393c3bf$export$3d494c2007bbcac1(eGui, setSize);
    }
    createTooltip() {
        const tooltipCtrl = {
            getTooltipValue: ()=>this.label,
            getGui: ()=>this.getGui(),
            getLocation: ()=>"UNKNOWN",
            // only show tooltips for items where the text cannot be fully displayed
            shouldDisplayTooltip: ()=>$437b23f6a393c3bf$var$_isHorizontalScrollShowing(this.eText)
        };
        const tooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("highlightTooltipFeature", false, tooltipCtrl, this));
        if (tooltipFeature) this.tooltipFeature = tooltipFeature;
    }
    addEventListeners() {
        const parentComponent = this.getParentComponent();
        if (!parentComponent) return;
        this.addGuiEventListener("mouseover", ()=>{
            parentComponent.highlightItem(this);
        });
        this.addGuiEventListener("mousedown", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            parentComponent.setValue(this.value);
        });
    }
};
// packages/ag-grid-community/src/agStack/widgets/agList.ts
var $437b23f6a393c3bf$var$AgList = class extends $437b23f6a393c3bf$export$e6818678a6454cbe {
    constructor(cssIdentifier = "default"){
        super({
            tag: "div",
            cls: `ag-list ag-${cssIdentifier}-list`
        });
        this.cssIdentifier = cssIdentifier;
        this.options = [];
        this.listItems = [];
        this.highlightedItem = null;
        this.registerCSS($437b23f6a393c3bf$var$agListCSS);
    }
    postConstruct() {
        const eGui = this.getGui();
        this.addManagedElementListeners(eGui, {
            mouseleave: ()=>this.clearHighlighted()
        });
    }
    handleKeyDown(e) {
        const key = e.key;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                if (!this.highlightedItem) this.setValue(this.getValue());
                else {
                    const pos = this.listItems.indexOf(this.highlightedItem);
                    this.setValueByIndex(pos);
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                e.preventDefault();
                this.navigate(key);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                e.preventDefault();
                this.navigateToPage(key);
                break;
        }
    }
    addOptions(listOptions) {
        for (const listOption of listOptions)this.addOption(listOption);
        return this;
    }
    addOption(listOption) {
        const { value: value, text: text } = listOption;
        const valueToRender = text ?? value;
        this.options.push({
            value: value,
            text: valueToRender
        });
        this.renderOption(value, valueToRender);
        this.updateIndices();
        return this;
    }
    clearOptions() {
        this.options = [];
        this.reset(true);
        for (const item of this.listItems)item.destroy();
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.getGui());
        this.listItems = [];
        this.refreshAriaRole();
    }
    updateOptions(listOptions) {
        const needsUpdate = this.options !== listOptions;
        if (needsUpdate) {
            this.clearOptions();
            this.addOptions(listOptions);
        }
        return needsUpdate;
    }
    setValue(value, silent) {
        if (this.value === value) {
            this.fireItemSelected();
            return this;
        }
        if (value == null) {
            this.reset(silent);
            return this;
        }
        const idx = this.options.findIndex((option)=>option.value === value);
        if (idx !== -1) {
            const option = this.options[idx];
            this.value = option.value;
            this.displayValue = option.text;
            this.highlightItem(this.listItems[idx]);
            if (!silent) this.fireChangeEvent();
        }
        return this;
    }
    setValueByIndex(idx) {
        return this.setValue(this.options[idx].value);
    }
    getValue() {
        return this.value;
    }
    getDisplayValue() {
        return this.displayValue;
    }
    refreshHighlighted() {
        this.clearHighlighted();
        const idx = this.options.findIndex((option)=>option.value === this.value);
        if (idx !== -1) this.highlightItem(this.listItems[idx]);
    }
    highlightItem(item) {
        const itemEl = item.getGui();
        if (!$437b23f6a393c3bf$export$2badf4aa566524cb(itemEl)) return;
        this.clearHighlighted();
        item.setHighlighted(true);
        this.highlightedItem = item;
        const eGui = this.getGui();
        const { scrollTop: scrollTop, clientHeight: clientHeight } = eGui;
        const { offsetTop: offsetTop, offsetHeight: offsetHeight } = itemEl;
        if (offsetTop + offsetHeight > scrollTop + clientHeight || offsetTop < scrollTop) itemEl.scrollIntoView({
            block: "nearest"
        });
    }
    hideItemTooltip() {
        this.highlightedItem?.tooltipFeature?.attemptToHideTooltip();
    }
    destroy() {
        this.hideItemTooltip();
        super.destroy();
    }
    reset(silent) {
        this.value = null;
        this.displayValue = null;
        this.clearHighlighted();
        if (!silent) this.fireChangeEvent();
    }
    clearHighlighted() {
        this.highlightedItem?.setHighlighted(false);
        this.highlightedItem = null;
    }
    renderOption(value, text) {
        const item = new $437b23f6a393c3bf$var$AgListItem(this.cssIdentifier, text, value);
        item.setParentComponent(this);
        const listItem = this.createManagedBean(item);
        this.listItems.push(listItem);
        this.getGui().appendChild(listItem.getGui());
    }
    navigate(key) {
        const isDown = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        let itemToHighlight;
        const { listItems: listItems, highlightedItem: highlightedItem } = this;
        if (!highlightedItem) itemToHighlight = isDown ? listItems[0] : $437b23f6a393c3bf$export$236389741107357f(listItems);
        else {
            const currentIdx = listItems.indexOf(highlightedItem);
            let nextPos = currentIdx + (isDown ? 1 : -1);
            nextPos = Math.min(Math.max(nextPos, 0), listItems.length - 1);
            itemToHighlight = listItems[nextPos];
        }
        this.highlightItem(itemToHighlight);
    }
    navigateToPage(key) {
        const { listItems: listItems, highlightedItem: highlightedItem } = this;
        if (!highlightedItem || listItems.length === 0) return;
        const currentIdx = listItems.indexOf(highlightedItem);
        const rowCount = this.options.length - 1;
        const itemHeight = listItems[0].getHeight();
        const pageSize = Math.floor(this.getGui().clientHeight / itemHeight);
        let newIndex = -1;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME) newIndex = 0;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END) newIndex = rowCount;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN) newIndex = Math.min(currentIdx + pageSize, rowCount);
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP) newIndex = Math.max(currentIdx - pageSize, 0);
        if (newIndex === -1) return;
        this.highlightItem(listItems[newIndex]);
    }
    refreshAriaRole() {
        $437b23f6a393c3bf$export$f8d01fa01787902(this.getGui(), this.options.length === 0 ? "presentation" : "listbox");
    }
    updateIndices() {
        this.refreshAriaRole();
        const listItems = this.listItems;
        const len = listItems.length;
        listItems.forEach((item, idx)=>{
            item.setIndex(idx + 1, len);
        });
    }
    fireChangeEvent() {
        this.dispatchLocalEvent({
            type: "fieldValueChanged"
        });
        this.fireItemSelected();
    }
    fireItemSelected() {
        this.dispatchLocalEvent({
            type: "selectedItem"
        });
    }
};
// packages/ag-grid-community/src/agStack/widgets/agPickerField.css-GENERATED.ts
var $437b23f6a393c3bf$var$agPickerFieldCSS = /*css*/ `.ag-picker-field-display{flex:1 1 auto}.ag-picker-field{align-items:center;display:flex}.ag-picker-field-icon{border:0;cursor:pointer;display:flex;margin:0;padding:0}.ag-picker-field-wrapper{background-color:var(--ag-picker-button-background-color);border:var(--ag-picker-button-border);border-radius:5px;min-height:max(var(--ag-list-item-height),calc(var(--ag-spacing)*4));overflow:hidden;&:where(.ag-picker-has-focus),&:where(:focus-within){background-color:var(--ag-picker-button-focus-background-color);border:var(--ag-picker-button-focus-border);box-shadow:var(--ag-focus-shadow);&:where(.invalid){box-shadow:var(--ag-focus-error-shadow)}}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:disabled{opacity:.5}}`;
// packages/ag-grid-community/src/agStack/widgets/agPickerField.ts
var $437b23f6a393c3bf$var$AgPickerFieldElement = {
    tag: "div",
    cls: "ag-picker-field",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eLabel"
        },
        {
            tag: "div",
            ref: "eWrapper",
            cls: "ag-wrapper ag-picker-field-wrapper ag-picker-collapsed",
            children: [
                {
                    tag: "div",
                    ref: "eDisplayField",
                    cls: "ag-picker-field-display"
                },
                {
                    tag: "div",
                    ref: "eIcon",
                    cls: "ag-picker-field-icon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$export$1f14489b6fdeb99b = class extends $437b23f6a393c3bf$var$AgAbstractField {
    constructor(config){
        super(config, config?.template || $437b23f6a393c3bf$var$AgPickerFieldElement, config?.agComponents || [], config?.className);
        this.isPickerDisplayed = false;
        this.skipClick = false;
        this.pickerGap = 4;
        this.hideCurrentPicker = null;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDisplayField = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eIcon = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$agPickerFieldCSS);
        this.ariaRole = config?.ariaRole;
        this.onPickerFocusIn = this.onPickerFocusIn.bind(this);
        this.onPickerFocusOut = this.onPickerFocusOut.bind(this);
        if (!config) return;
        const { pickerGap: pickerGap, maxPickerHeight: maxPickerHeight, variableWidth: variableWidth, minPickerWidth: minPickerWidth, maxPickerWidth: maxPickerWidth } = config;
        if (pickerGap != null) this.pickerGap = pickerGap;
        this.variableWidth = !!variableWidth;
        if (maxPickerHeight != null) this.setPickerMaxHeight(maxPickerHeight);
        if (minPickerWidth != null) this.setPickerMinWidth(minPickerWidth);
        if (maxPickerWidth != null) this.setPickerMaxWidth(maxPickerWidth);
    }
    postConstruct() {
        super.postConstruct();
        this.setupAria();
        const displayId = `ag-${this.getCompId()}-display`;
        this.eDisplayField.setAttribute("id", displayId);
        const ariaEl = this.getAriaElement();
        this.addManagedElementListeners(ariaEl, {
            keydown: this.onKeyDown.bind(this)
        });
        this.addManagedElementListeners(this.eLabel, {
            mousedown: this.onLabelOrWrapperMouseDown.bind(this)
        });
        this.addManagedElementListeners(this.eWrapper, {
            mousedown: this.onLabelOrWrapperMouseDown.bind(this)
        });
        const { pickerIcon: pickerIcon, inputWidth: inputWidth } = this.config;
        if (pickerIcon) {
            const icon = this.beans.iconSvc.createIconNoSpan(pickerIcon);
            if (icon) this.eIcon.appendChild(icon);
        }
        if (inputWidth != null) this.setInputWidth(inputWidth);
    }
    setupAria() {
        const ariaEl = this.getAriaElement();
        ariaEl.setAttribute("tabindex", this.gos.get("tabIndex").toString());
        $437b23f6a393c3bf$export$3ad3518dddf15485(ariaEl, false);
        if (this.ariaRole) $437b23f6a393c3bf$export$f8d01fa01787902(ariaEl, this.ariaRole);
    }
    onLabelOrWrapperMouseDown(e) {
        if (e) {
            const focusableEl = this.getFocusableElement();
            if (focusableEl !== this.eWrapper && e?.target === focusableEl) return;
            e.preventDefault();
            this.getFocusableElement().focus();
        }
        if (this.skipClick) {
            this.skipClick = false;
            return;
        }
        if (this.isDisabled()) return;
        if (this.isPickerDisplayed) this.hidePicker();
        else this.showPicker();
    }
    onKeyDown(e) {
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE:
                e.preventDefault();
                this.onLabelOrWrapperMouseDown();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (this.isPickerDisplayed) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.hideCurrentPicker) this.hideCurrentPicker();
                }
                break;
        }
    }
    showPicker() {
        this.isPickerDisplayed = true;
        if (!this.pickerComponent) this.pickerComponent = this.createPickerComponent();
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.addEventListener("focusin", this.onPickerFocusIn);
        pickerGui.addEventListener("focusout", this.onPickerFocusOut);
        this.hideCurrentPicker = this.renderAndPositionPicker();
        this.toggleExpandedStyles(true);
    }
    renderAndPositionPicker() {
        const ePicker = this.pickerComponent.getGui();
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) [this.destroyMouseWheelFunc] = this.addManagedEventListeners({
            bodyScroll: ()=>{
                this.hidePicker();
            }
        });
        const translate = this.getLocaleTextFunc();
        const { config: { pickerAriaLabelKey: pickerAriaLabelKey, pickerAriaLabelValue: pickerAriaLabelValue, modalPicker: modalPicker = true }, maxPickerHeight: maxPickerHeight, minPickerWidth: minPickerWidth, maxPickerWidth: maxPickerWidth, variableWidth: variableWidth, beans: beans, eWrapper: eWrapper } = this;
        const popupParams = {
            modal: modalPicker,
            eChild: ePicker,
            closeOnEsc: true,
            closedCallback: ()=>{
                const shouldRestoreFocus = $437b23f6a393c3bf$export$8ff9eef09a45371f(beans);
                this.beforeHidePicker();
                if (shouldRestoreFocus && this.isAlive()) this.getFocusableElement().focus();
            },
            ariaLabel: translate(pickerAriaLabelKey, pickerAriaLabelValue),
            anchorToElement: eWrapper
        };
        ePicker.style.position = "absolute";
        const popupSvc = beans.popupSvc;
        const addPopupRes = popupSvc.addPopup(popupParams);
        if (variableWidth) {
            if (minPickerWidth) ePicker.style.minWidth = minPickerWidth;
            ePicker.style.width = $437b23f6a393c3bf$var$_formatSize($437b23f6a393c3bf$export$642efcb17474eb51(eWrapper));
            if (maxPickerWidth) ePicker.style.maxWidth = maxPickerWidth;
        } else $437b23f6a393c3bf$var$_setElementWidth(ePicker, maxPickerWidth ?? $437b23f6a393c3bf$export$642efcb17474eb51(eWrapper));
        const maxHeight = maxPickerHeight ?? `${$437b23f6a393c3bf$export$c20e968103d9c16e(popupSvc.getPopupParent())}px`;
        ePicker.style.setProperty("max-height", maxHeight);
        this.alignPickerToComponent();
        return addPopupRes.hideFunc;
    }
    alignPickerToComponent() {
        if (!this.pickerComponent) return;
        const { pickerGap: pickerGap, config: { pickerType: pickerType }, beans: { popupSvc: popupSvc, gos: gos }, eWrapper: eWrapper, pickerComponent: pickerComponent } = this;
        const alignSide = gos.get("enableRtl") ? "right" : "left";
        popupSvc.positionPopupByComponent({
            type: pickerType,
            eventSource: eWrapper,
            ePopup: pickerComponent.getGui(),
            position: "under",
            alignSide: alignSide,
            keepWithinBounds: true,
            nudgeY: pickerGap
        });
    }
    beforeHidePicker() {
        if (this.destroyMouseWheelFunc) {
            this.destroyMouseWheelFunc();
            this.destroyMouseWheelFunc = void 0;
        }
        this.toggleExpandedStyles(false);
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.removeEventListener("focusin", this.onPickerFocusIn);
        pickerGui.removeEventListener("focusout", this.onPickerFocusOut);
        this.isPickerDisplayed = false;
        this.pickerComponent = void 0;
        this.hideCurrentPicker = null;
    }
    toggleExpandedStyles(expanded) {
        if (!this.isAlive()) return;
        const ariaEl = this.getAriaElement();
        $437b23f6a393c3bf$export$3ad3518dddf15485(ariaEl, expanded);
        const classList = this.eWrapper.classList;
        classList.toggle("ag-picker-expanded", expanded);
        classList.toggle("ag-picker-collapsed", !expanded);
    }
    onPickerFocusIn() {
        this.togglePickerHasFocus(true);
    }
    onPickerFocusOut(e) {
        if (!this.pickerComponent?.getGui().contains(e.relatedTarget)) this.togglePickerHasFocus(false);
    }
    togglePickerHasFocus(focused) {
        if (!this.pickerComponent) return;
        this.eWrapper.classList.toggle("ag-picker-has-focus", focused);
    }
    hidePicker() {
        if (this.hideCurrentPicker) {
            this.hideCurrentPicker();
            this.dispatchLocalEvent({
                type: "pickerHidden"
            });
        }
    }
    setInputWidth(width) {
        $437b23f6a393c3bf$var$_setElementWidth(this.eWrapper, width);
        return this;
    }
    getFocusableElement() {
        return this.eWrapper;
    }
    setPickerGap(gap) {
        this.pickerGap = gap;
        return this;
    }
    setPickerMinWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.minPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.maxPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxHeight(height) {
        if (typeof height === "number") height = `${height}px`;
        this.maxPickerHeight = height == null ? void 0 : height;
        return this;
    }
    destroy() {
        this.hidePicker();
        super.destroy();
    }
};
// packages/ag-grid-community/src/agStack/widgets/agSelect.css-GENERATED.ts
var $437b23f6a393c3bf$var$agSelectCSS = /*css*/ `.ag-select{align-items:center;display:flex;&.ag-disabled{opacity:.5}}:where(.ag-select){.ag-picker-field-wrapper{cursor:default}&.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}&:not(.ag-cell-editor,.ag-label-align-top){min-height:var(--ag-list-item-height)}.ag-picker-field-display{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-picker-field-icon{align-items:center;display:flex}}:where(.ag-ltr) :where(.ag-select){.ag-picker-field-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding)/2);padding-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-select){.ag-picker-field-wrapper{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-cell-horizontal-padding)/2)}}.ag-select-list{background-color:var(--ag-picker-list-background-color);border:var(--ag-picker-list-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);overflow:hidden auto}.ag-select-list-item{cursor:default;-webkit-user-select:none;-moz-user-select:none;user-select:none;:where(span){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}:where(.ag-ltr) .ag-select-list-item{padding-left:calc(var(--ag-cell-horizontal-padding)/2)}:where(.ag-rtl) .ag-select-list-item{padding-right:calc(var(--ag-cell-horizontal-padding)/2)}`;
// packages/ag-grid-community/src/agStack/widgets/agSelect.ts
var $437b23f6a393c3bf$export$6f9c460854d56032 = class extends $437b23f6a393c3bf$export$1f14489b6fdeb99b {
    constructor(config){
        super({
            pickerAriaLabelKey: "ariaLabelSelectField",
            pickerAriaLabelValue: "Select Field",
            pickerType: "ag-list",
            className: "ag-select",
            pickerIcon: "selectOpen",
            ariaRole: "combobox",
            ...config
        });
        this.registerCSS($437b23f6a393c3bf$var$agSelectCSS);
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            shouldDisplayTooltip: $437b23f6a393c3bf$export$8980540b0a37a11d(()=>this.eDisplayField),
            getGui: ()=>this.getGui()
        }));
        super.postConstruct();
        this.createListComponent();
        this.eWrapper.tabIndex = this.gos.get("tabIndex");
        const { options: options, value: value, placeholder: placeholder } = this.config;
        if (options != null) this.addOptions(options);
        if (value != null) this.setValue(value, true);
        if (placeholder && value == null) this.eDisplayField.textContent = placeholder;
        this.addManagedElementListeners(this.eWrapper, {
            focusout: this.onWrapperFocusOut.bind(this)
        });
    }
    onWrapperFocusOut(e) {
        if (!this.eWrapper.contains(e.relatedTarget)) this.hidePicker();
    }
    createListComponent() {
        const listComponent = this.createBean(new $437b23f6a393c3bf$var$AgList("select"));
        this.listComponent = listComponent;
        listComponent.setParentComponent(this);
        const eListAriaEl = listComponent.getAriaElement();
        const listId = `ag-select-list-${listComponent.getCompId()}`;
        eListAriaEl.setAttribute("id", listId);
        $437b23f6a393c3bf$export$6ff31a4a210c60ad(this.getAriaElement(), eListAriaEl);
        listComponent.addManagedElementListeners(listComponent.getGui(), {
            mousedown: (e)=>{
                e?.preventDefault();
            }
        });
        listComponent.addManagedListeners(listComponent, {
            selectedItem: ()=>{
                this.hidePicker();
                this.dispatchLocalEvent({
                    type: "selectedItem"
                });
            },
            fieldValueChanged: ()=>{
                if (!this.listComponent) return;
                this.setValue(this.listComponent.getValue(), false, true);
                this.hidePicker();
            }
        });
    }
    createPickerComponent() {
        return this.listComponent;
    }
    beforeHidePicker() {
        this.listComponent?.hideItemTooltip();
        super.beforeHidePicker();
    }
    onKeyDown(e) {
        const { key: key } = e;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) this.hidePicker();
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                e.preventDefault();
                if (this.isPickerDisplayed) this.listComponent?.handleKeyDown(e);
                else super.onKeyDown(e);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                super.onKeyDown(e);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE:
                if (this.isPickerDisplayed) e.preventDefault();
                else super.onKeyDown(e);
                break;
        }
    }
    showPicker() {
        const listComponent = this.listComponent;
        if (!listComponent) return;
        super.showPicker();
        listComponent.refreshHighlighted();
    }
    addOptions(options) {
        for (const option of options)this.addOption(option);
        return this;
    }
    addOption(option) {
        this.listComponent.addOption(option);
        return this;
    }
    clearOptions() {
        this.listComponent?.clearOptions();
        this.setValue(void 0, true);
        return this;
    }
    updateOptions(options) {
        if (this.listComponent?.updateOptions(options)) this.setValue(void 0, true);
        return this;
    }
    setValue(value, silent, fromPicker) {
        const { listComponent: listComponent, config: { placeholder: placeholder }, eDisplayField: eDisplayField, tooltipFeature: tooltipFeature } = this;
        if (this.value === value || !listComponent) return this;
        if (!fromPicker) listComponent.setValue(value, true);
        const newValue = listComponent.getValue();
        if (newValue === this.getValue()) return this;
        let displayValue = listComponent.getDisplayValue();
        if (displayValue == null && placeholder) displayValue = placeholder;
        eDisplayField.textContent = displayValue;
        tooltipFeature?.setTooltipAndRefresh(displayValue ?? null);
        return super.setValue(value, silent);
    }
    destroy() {
        this.listComponent = this.destroyBean(this.listComponent);
        super.destroy();
    }
};
var $437b23f6a393c3bf$export$e32612175ad118ef = {
    selector: "AG-SELECT",
    component: $437b23f6a393c3bf$export$6f9c460854d56032
};
// packages/ag-grid-community/src/agStack/constants/direction.ts
var $437b23f6a393c3bf$export$cacd6541cfeeb6c1 = /* @__PURE__ */ ((Direction2)=>{
    Direction2[Direction2["Vertical"] = 0] = "Vertical";
    Direction2[Direction2["Horizontal"] = 1] = "Horizontal";
    return Direction2;
})($437b23f6a393c3bf$export$cacd6541cfeeb6c1 || {});
// packages/ag-grid-community/src/agStack/theming/shared/shared.css-GENERATED.ts
var $437b23f6a393c3bf$var$sharedCSS = /*css*/ `:where(.ag-root-wrapper,.ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart),:where(.ag-root-wrapper,.ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]){box-sizing:border-box;&:after,&:before{box-sizing:border-box}&:where(div,span,label):focus-visible{box-shadow:inset var(--ag-focus-shadow);outline:none;&:where(.invalid){box-shadow:inset var(--ag-focus-error-shadow)}}&:where(button){color:inherit}}:where(.ag-root-wrapper,ag-external,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]) ::-ms-clear{display:none}.ag-hidden{display:none!important}.ag-invisible{visibility:hidden!important}.ag-tab-guard{display:block;height:0;position:absolute;width:0}.ag-tab-guard-top{top:1px}.ag-tab-guard-bottom{bottom:1px}.ag-measurement-container{height:0;overflow:hidden;visibility:hidden;width:0}.ag-measurement-element-border{display:inline-block;&:before{border-left:var(--ag-internal-measurement-border);content:"";display:block}}.ag-popup-child{top:0;z-index:5;&:where(:not(.ag-tooltip-custom)){box-shadow:var(--ag-popup-shadow)}}.ag-input-wrapper,.ag-picker-field-wrapper{align-items:center;display:flex;flex:1 1 auto;line-height:normal;position:relative}.ag-input-field{align-items:center;display:flex;flex-direction:row}.ag-input-field-input:where(:not([type=checkbox],[type=radio])){flex:1 1 auto;min-width:0;width:100%}.ag-chart,.ag-dnd-ghost,.ag-external,.ag-popup,.ag-root-wrapper{cursor:default;line-height:normal;white-space:normal;-webkit-font-smoothing:antialiased;background-color:var(--ag-background-color);color:var(--ag-text-color);color-scheme:var(--ag-browser-color-scheme);font-family:var(--ag-font-family);font-size:var(--ag-font-size);--ag-indentation-level:0}:where(.ag-icon):before{align-items:center;background-color:currentcolor;color:inherit;content:"";display:flex;font-family:inherit;font-size:var(--ag-icon-size);font-style:normal;font-variant:normal;height:var(--ag-icon-size);justify-content:center;line-height:var(--ag-icon-size);-webkit-mask-size:contain;mask-size:contain;text-transform:none;width:var(--ag-icon-size)}.ag-icon{background-position:50%;background-repeat:no-repeat;background-size:contain;color:var(--ag-icon-color);display:block;height:var(--ag-icon-size);position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-icon-size)}.ag-disabled,[disabled]{.ag-icon{opacity:.5}&.ag-icon-grip{opacity:.35}}.ag-resizer{pointer-events:none;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none;z-index:1}:where(.ag-resizer){&.ag-resizer-topLeft{cursor:nwse-resize;height:5px;left:0;top:0;width:5px}&.ag-resizer-top{cursor:ns-resize;height:5px;left:5px;right:5px;top:0}&.ag-resizer-topRight{cursor:nesw-resize;height:5px;right:0;top:0;width:5px}&.ag-resizer-right{bottom:5px;cursor:ew-resize;right:0;top:5px;width:5px}&.ag-resizer-bottomRight{bottom:0;cursor:nwse-resize;height:5px;right:0;width:5px}&.ag-resizer-bottom{bottom:0;cursor:ns-resize;height:5px;left:5px;right:5px}&.ag-resizer-bottomLeft{bottom:0;cursor:nesw-resize;height:5px;left:0;width:5px}&.ag-resizer-left{bottom:5px;cursor:ew-resize;left:0;top:5px;width:5px}}`;
// packages/ag-grid-community/src/agStack/theming/inject.ts
var $437b23f6a393c3bf$var$IS_SSR = typeof window !== "object" || !window?.document?.fonts?.forEach;
var $437b23f6a393c3bf$var$FORCE_LEGACY_THEMES = false;
var $437b23f6a393c3bf$var$_injectGlobalCSS = (css, styleContainer, debugId, layer, priority, nonce)=>{
    if ($437b23f6a393c3bf$var$IS_SSR) return;
    if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return;
    if (layer) css = `@layer ${CSS.escape(layer).replaceAll("\\.", ".")} { ${css} }`;
    let injections = $437b23f6a393c3bf$var$injectionState.map.get(styleContainer);
    if (!injections) {
        injections = [];
        $437b23f6a393c3bf$var$injectionState.map.set(styleContainer, injections);
    }
    if (injections.some((i)=>i.css === css)) return;
    const el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.dataset.agGlobalCss = debugId;
    el.textContent = css;
    const newInjection = {
        css: css,
        el: el,
        priority: priority
    };
    let insertAfter;
    for (const injection of injections){
        if (injection.priority > priority) break;
        insertAfter = injection;
    }
    if (insertAfter) {
        insertAfter.el.insertAdjacentElement("afterend", el);
        const index = injections.indexOf(insertAfter);
        injections.splice(index + 1, 0, newInjection);
    } else {
        styleContainer.insertBefore(el, styleContainer.querySelector(":not(title, meta)"));
        injections.push(newInjection);
    }
};
var $437b23f6a393c3bf$var$_injectCoreAndModuleCSS = (styleContainer, layer, nonce, moduleCss)=>{
    $437b23f6a393c3bf$var$_injectGlobalCSS($437b23f6a393c3bf$var$sharedCSS, styleContainer, "shared", layer, 0, nonce);
    moduleCss?.forEach((css, debugId)=>css.forEach((singleCss)=>$437b23f6a393c3bf$var$_injectGlobalCSS(singleCss, styleContainer, debugId, layer, 0, nonce)));
};
var $437b23f6a393c3bf$var$_registerInstanceUsingThemingAPI = (environment)=>{
    $437b23f6a393c3bf$var$injectionState.grids.add(environment);
};
var $437b23f6a393c3bf$var$_unregisterInstanceUsingThemingAPI = (environment)=>{
    $437b23f6a393c3bf$var$injectionState.grids.delete(environment);
    if ($437b23f6a393c3bf$var$injectionState.grids.size === 0) {
        $437b23f6a393c3bf$var$injectionState.map = /* @__PURE__ */ new WeakMap();
        for (const style of document.head.querySelectorAll("style[data-ag-global-css]"))style.remove();
    }
};
var $437b23f6a393c3bf$var$_a;
var $437b23f6a393c3bf$var$injectionState = ($437b23f6a393c3bf$var$_a = typeof window === "object" ? window : {}).agStyleInjectionState ?? ($437b23f6a393c3bf$var$_a.agStyleInjectionState = {
    map: /* @__PURE__ */ new WeakMap(),
    grids: /* @__PURE__ */ new Set()
});
// packages/ag-grid-community/src/agStack/theming/partImpl.ts
var $437b23f6a393c3bf$export$6e6f0e372f4cb988 = (args)=>{
    return new $437b23f6a393c3bf$var$PartImpl(args);
};
var $437b23f6a393c3bf$var$defaultModeName = "$default";
var $437b23f6a393c3bf$var$partCounter = 0;
var $437b23f6a393c3bf$var$PartImpl = class {
    constructor({ feature: feature, params: params, modeParams: modeParams = {}, css: css, cssImports: cssImports }){
        this.feature = feature;
        this.css = css;
        this.cssImports = cssImports;
        this.modeParams = {
            // NOTE: it's important that default is defined first, putting it
            // first in iteration order, because when merging params the default
            // params override any prior modal params, so modal params in this
            // part need to come after default params to prevent them from being
            // immediately overridden.
            [$437b23f6a393c3bf$var$defaultModeName]: {
                ...modeParams[$437b23f6a393c3bf$var$defaultModeName] ?? {},
                ...params ?? {}
            },
            ...modeParams
        };
    }
    use(styleContainer, layer, nonce) {
        let inject = this._inject;
        if (inject == null) {
            let { css: css } = this;
            if (css) {
                const className = `ag-theme-${this.feature ?? "part"}-${++$437b23f6a393c3bf$var$partCounter}`;
                if (typeof css === "function") css = css();
                css = `:where(.${className}) {
${css}
}
`;
                for (const cssImport of this.cssImports ?? [])css = `@import url(${JSON.stringify(cssImport)});
${css}`;
                inject = {
                    css: css,
                    class: className
                };
            } else inject = false;
            this._inject = inject;
        }
        if (inject && styleContainer) $437b23f6a393c3bf$var$_injectGlobalCSS(inject.css, styleContainer, inject.class, layer, 1, nonce);
        return inject ? inject.class : false;
    }
};
// packages/ag-grid-community/src/agStack/theming/themeUtils.ts
var $437b23f6a393c3bf$var$kebabCase = (str)=>str.replace(/[A-Z]/g, (m)=>`-${m}`).toLowerCase();
var $437b23f6a393c3bf$export$e95ae2f248d19dee = (paramName)=>`--ag-${$437b23f6a393c3bf$var$kebabCase(paramName)}`;
var $437b23f6a393c3bf$var$paramToVariableExpression = (paramName)=>`var(${$437b23f6a393c3bf$export$e95ae2f248d19dee(paramName)})`;
var $437b23f6a393c3bf$var$clamp = (value, min, max)=>Math.max(min, Math.min(max, value));
var $437b23f6a393c3bf$var$memoize = (fn)=>{
    const values = /* @__PURE__ */ new Map();
    return (a)=>{
        const key = a;
        if (!values.has(key)) values.set(key, fn(a));
        return values.get(key);
    };
};
var $437b23f6a393c3bf$var$accentMix = (mix)=>({
        ref: "accentColor",
        mix: mix
    });
var $437b23f6a393c3bf$var$foregroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix
    });
var $437b23f6a393c3bf$var$foregroundBackgroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix,
        onto: "backgroundColor"
    });
var $437b23f6a393c3bf$var$foregroundHeaderBackgroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix,
        onto: "headerBackgroundColor"
    });
var $437b23f6a393c3bf$var$backgroundColor = {
    ref: "backgroundColor"
};
var $437b23f6a393c3bf$var$foregroundColor = {
    ref: "foregroundColor"
};
var $437b23f6a393c3bf$var$accentColor = {
    ref: "accentColor"
};
// packages/ag-grid-community/src/agStack/theming/shared/shared-css.ts
var $437b23f6a393c3bf$var$defaultLightColorSchemeParams = {
    backgroundColor: "#fff",
    foregroundColor: "#181d1f",
    borderColor: $437b23f6a393c3bf$var$foregroundMix(0.15),
    chromeBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.02),
    browserColorScheme: "light"
};
var $437b23f6a393c3bf$var$sharedDefaults = {
    ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
    textColor: $437b23f6a393c3bf$var$foregroundColor,
    accentColor: "#2196f3",
    invalidColor: "#e02525",
    fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Roboto",
        "Oxygen-Sans",
        "Ubuntu",
        "Cantarell",
        "Helvetica Neue",
        "sans-serif"
    ],
    subtleTextColor: {
        ref: "textColor",
        mix: 0.5
    },
    borderWidth: 1,
    borderRadius: 4,
    spacing: 8,
    fontSize: 14,
    focusShadow: {
        spread: 3,
        color: $437b23f6a393c3bf$var$accentMix(0.5)
    },
    focusErrorShadow: {
        spread: 3,
        color: {
            ref: "invalidColor",
            onto: "backgroundColor",
            mix: 0.5
        }
    },
    popupShadow: "0 0 16px #00000026",
    cardShadow: "0 1px 4px 1px #00000018",
    dropdownShadow: {
        ref: "cardShadow"
    },
    listItemHeight: {
        calc: "max(iconSize, dataFontSize) + widgetVerticalSpacing"
    },
    dragAndDropImageBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    dragAndDropImageBorder: true,
    dragAndDropImageNotAllowedBorder: {
        color: {
            ref: "invalidColor",
            onto: "dragAndDropImageBackgroundColor",
            mix: 0.5
        }
    },
    dragAndDropImageShadow: {
        ref: "popupShadow"
    },
    iconSize: 16,
    iconColor: "inherit",
    toggleButtonWidth: 28,
    toggleButtonHeight: 18,
    toggleButtonOnBackgroundColor: $437b23f6a393c3bf$var$accentColor,
    toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
    toggleButtonSwitchBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    toggleButtonSwitchInset: 2,
    tooltipBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    tooltipErrorBackgroundColor: {
        ref: "invalidColor",
        onto: "backgroundColor",
        mix: 0.1
    },
    tooltipTextColor: {
        ref: "textColor"
    },
    tooltipErrorTextColor: {
        ref: "invalidColor"
    },
    tooltipBorder: true,
    tooltipErrorBorder: {
        color: {
            ref: "invalidColor",
            onto: "backgroundColor",
            mix: 0.25
        }
    }
};
// packages/ag-grid-community/src/agStack/theming/themeTypeUtils.ts
var $437b23f6a393c3bf$var$paramTypes = [
    "colorScheme",
    "color",
    "length",
    "scale",
    "borderStyle",
    "border",
    "shadow",
    "image",
    "fontFamily",
    "fontWeight",
    "duration"
];
var $437b23f6a393c3bf$export$20ba727bff35015f = $437b23f6a393c3bf$var$memoize((param)=>{
    param = param.toLowerCase();
    return $437b23f6a393c3bf$var$paramTypes.find((type)=>param.endsWith(type.toLowerCase())) ?? "length";
});
var $437b23f6a393c3bf$var$literalToCSS = (value)=>{
    if (typeof value === "object" && value?.ref) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    if (typeof value === "string") return value;
    if (typeof value === "number") return String(value);
    return false;
};
var $437b23f6a393c3bf$var$colorValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value && "ref" in value) {
        const colorExpr = $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
        if (value.mix == null) return colorExpr;
        const backgroundExpr = value.onto ? $437b23f6a393c3bf$var$paramToVariableExpression(value.onto) : "transparent";
        return `color-mix(in srgb, ${backgroundExpr}, ${colorExpr} ${$437b23f6a393c3bf$var$clamp(value.mix * 100, 0, 100)}%)`;
    }
    return false;
};
var $437b23f6a393c3bf$var$colorSchemeValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$lengthValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (typeof value === "number") return `${value}px`;
    if (value && "calc" in value) {
        const valueWithSpaces = value.calc.replace(/ ?[*/+] ?/g, " $& ");
        return `calc(${valueWithSpaces.replace(/-?\b[a-z][a-z0-9]*\b(?![-(])/gi, (p)=>p[0] === "-" ? p : " " + $437b23f6a393c3bf$var$paramToVariableExpression(p) + " ")})`;
    }
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$scaleValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$borderValueToCss = (value, param)=>{
    if (typeof value === "string") return value;
    if (value === true) return $437b23f6a393c3bf$var$borderValueToCss({}, param);
    if (value === false) return param === "columnBorder" ? $437b23f6a393c3bf$var$borderValueToCss({
        color: "transparent"
    }, param) : "none";
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return $437b23f6a393c3bf$var$borderStyleValueToCss(value.style ?? "solid") + " " + $437b23f6a393c3bf$var$lengthValueToCss(value.width ?? {
        ref: "borderWidth"
    }) + " " + $437b23f6a393c3bf$var$colorValueToCss(value.color ?? {
        ref: "borderColor"
    });
};
var $437b23f6a393c3bf$var$shadowValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value === false) return "none";
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return [
        $437b23f6a393c3bf$var$lengthValueToCss(value.offsetX ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.offsetY ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.radius ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.spread ?? 0),
        $437b23f6a393c3bf$var$colorValueToCss(value.color ?? {
            ref: "foregroundColor"
        })
    ].join(" ");
};
var $437b23f6a393c3bf$var$borderStyleValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$fontFamilyValueToCss = (value)=>{
    if (typeof value === "string") return value.includes(",") ? value : $437b23f6a393c3bf$var$quoteUnsafeChars(value);
    if (value && "googleFont" in value) return $437b23f6a393c3bf$var$fontFamilyValueToCss(value.googleFont);
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    if (Array.isArray(value)) return value.map((font)=>{
        if (typeof font === "object" && "googleFont" in font) font = font.googleFont;
        return $437b23f6a393c3bf$var$quoteUnsafeChars(font);
    }).join(", ");
    return false;
};
var $437b23f6a393c3bf$var$quoteUnsafeChars = (font)=>// don't quote var() expressions or quote safe identifier names, so that
    // people can specify fonts like sans-serif which are keywords not strings,
    // or var(--my-var)
    /^[\w-]+$|\w\(/.test(font) ? font : JSON.stringify(font);
var $437b23f6a393c3bf$var$fontWeightValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$imageValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value && "url" in value) return `url(${JSON.stringify(value.url)})`;
    if (value && "svg" in value) return $437b23f6a393c3bf$var$imageValueToCss({
        url: `data:image/svg+xml,${encodeURIComponent(value.svg)}`
    });
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$durationValueToCss = (value, param, themeLogger)=>{
    if (typeof value === "string") return value;
    if (typeof value === "number") {
        if (value >= 10) themeLogger.warn(104, {
            value: value,
            param: param
        });
        return `${value}s`;
    }
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$paramValidators = {
    color: $437b23f6a393c3bf$var$colorValueToCss,
    colorScheme: $437b23f6a393c3bf$var$colorSchemeValueToCss,
    length: $437b23f6a393c3bf$var$lengthValueToCss,
    scale: $437b23f6a393c3bf$var$scaleValueToCss,
    border: $437b23f6a393c3bf$var$borderValueToCss,
    borderStyle: $437b23f6a393c3bf$var$borderStyleValueToCss,
    shadow: $437b23f6a393c3bf$var$shadowValueToCss,
    image: $437b23f6a393c3bf$var$imageValueToCss,
    fontFamily: $437b23f6a393c3bf$var$fontFamilyValueToCss,
    fontWeight: $437b23f6a393c3bf$var$fontWeightValueToCss,
    duration: $437b23f6a393c3bf$var$durationValueToCss
};
var $437b23f6a393c3bf$export$fe812a0355b3f366 = (param, value, themeLogger)=>{
    const type = $437b23f6a393c3bf$export$20ba727bff35015f(param);
    return $437b23f6a393c3bf$var$paramValidators[type](value, param, themeLogger);
};
// packages/ag-grid-community/src/agStack/theming/themeImpl.ts
var $437b23f6a393c3bf$export$638c0e26f33cd834 = (theme)=>{
    if (!(theme instanceof $437b23f6a393c3bf$var$ThemeImpl)) throw new Error("theme is not an object created by createTheme");
    return theme;
};
var $437b23f6a393c3bf$var$createSharedTheme = (themeLogger)=>new $437b23f6a393c3bf$var$ThemeImpl(themeLogger);
var $437b23f6a393c3bf$var$ThemeImpl = class _ThemeImpl {
    constructor(themeLogger, parts = []){
        this.themeLogger = themeLogger;
        this.parts = parts;
    }
    withPart(part) {
        if (typeof part === "function") part = part();
        if (!(part instanceof $437b23f6a393c3bf$var$PartImpl)) {
            this.themeLogger.preInitErr(259, "Invalid part", {
                part: part
            });
            return this;
        }
        return new _ThemeImpl(this.themeLogger, [
            ...this.parts,
            part
        ]);
    }
    withoutPart(feature) {
        return this.withPart($437b23f6a393c3bf$export$6e6f0e372f4cb988({
            feature: feature
        }));
    }
    withParams(params, mode = $437b23f6a393c3bf$var$defaultModeName) {
        return this.withPart($437b23f6a393c3bf$export$6e6f0e372f4cb988({
            modeParams: {
                [mode]: params
            }
        }));
    }
    /**
   * Called by a grid instance when it starts using the theme. This installs
   * the theme's parts into document head, or the shadow DOM if the provided
   * container is within a shadow root.
   */ _startUse({ styleContainer: styleContainer, cssLayer: cssLayer, nonce: nonce, loadThemeGoogleFonts: loadThemeGoogleFonts, moduleCss: moduleCss }) {
        if ($437b23f6a393c3bf$var$IS_SSR) return;
        if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return;
        $437b23f6a393c3bf$var$uninstallLegacyCSS();
        $437b23f6a393c3bf$var$_injectCoreAndModuleCSS(styleContainer, cssLayer, nonce, moduleCss);
        const googleFontsUsed = $437b23f6a393c3bf$var$getGoogleFontsUsed(this);
        if (googleFontsUsed.length > 0) {
            for (const googleFont of googleFontsUsed)if (loadThemeGoogleFonts) $437b23f6a393c3bf$var$loadGoogleFont(googleFont, nonce);
        }
        for (const part of this.parts)part.use(styleContainer, cssLayer, nonce);
    }
    /**
   * Return CSS that that applies the params of this theme to elements with
   * the provided class name
   */ _getCssClass() {
        if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return "ag-theme-quartz";
        return this._cssClassCache ?? (this._cssClassCache = $437b23f6a393c3bf$var$deduplicatePartsByFeature(this.parts).map((part)=>part.use(void 0, void 0, void 0)).filter(Boolean).join(" "));
    }
    _getModeParams() {
        let paramsCache = this._paramsCache;
        if (!paramsCache) {
            const mergedModeParams = {
                // NOTE: defining the default mode here is important, it ensures
                // that the default mode is first in iteration order, which puts
                // it first in outputted CSS, allowing other modes to override it
                [$437b23f6a393c3bf$var$defaultModeName]: {
                    ...$437b23f6a393c3bf$var$sharedDefaults
                }
            };
            for (const part of $437b23f6a393c3bf$var$deduplicatePartsByFeature(this.parts))for (const partMode of Object.keys(part.modeParams)){
                const partParams = part.modeParams[partMode];
                if (partParams) {
                    const mergedParams = mergedModeParams[partMode] ?? (mergedModeParams[partMode] = {});
                    const partParamNames = /* @__PURE__ */ new Set();
                    for (const partParamName of Object.keys(partParams)){
                        const partParamValue = partParams[partParamName];
                        if (partParamValue !== void 0) {
                            mergedParams[partParamName] = partParamValue;
                            partParamNames.add(partParamName);
                        }
                    }
                    if (partMode === $437b23f6a393c3bf$var$defaultModeName) for (const mergedMode of Object.keys(mergedModeParams)){
                        const mergedParams2 = mergedModeParams[mergedMode];
                        if (mergedMode !== $437b23f6a393c3bf$var$defaultModeName) for (const partParamName of partParamNames)delete mergedParams2[partParamName];
                    }
                }
            }
            this._paramsCache = paramsCache = mergedModeParams;
        }
        return paramsCache;
    }
    /**
   * Return the CSS chunk that is inserted into the grid DOM, and will
   * therefore be removed automatically when the grid is destroyed or it
   * starts to use a new theme.
   *
   * @param className a unique class name on the grid wrapper used to scope the returned CSS to the grid instance
   */ _getPerInstanceCss(className) {
        const selectorPlaceholder = "##SELECTOR##";
        let innerParamsCss = this._paramsCssCache;
        if (!innerParamsCss) {
            let variablesCss = "";
            let inheritanceCss = "";
            const modeParams = this._getModeParams();
            for (const mode of Object.keys(modeParams)){
                const params = modeParams[mode];
                if (mode !== $437b23f6a393c3bf$var$defaultModeName) {
                    const escapedMode = typeof CSS === "object" ? CSS.escape(mode) : mode;
                    const wrapPrefix = `:where([data-ag-theme-mode="${escapedMode}"]) & {
`;
                    variablesCss += wrapPrefix;
                    inheritanceCss += wrapPrefix;
                }
                for (const key of Object.keys(params).sort()){
                    const value = params[key];
                    const cssValue = $437b23f6a393c3bf$export$fe812a0355b3f366(key, value, this.themeLogger);
                    if (cssValue === false) this.themeLogger.error(107, {
                        key: key,
                        value: value
                    });
                    else {
                        const cssName = $437b23f6a393c3bf$export$e95ae2f248d19dee(key);
                        const inheritedName = cssName.replace("--ag-", "--ag-inherited-");
                        variablesCss += `	${cssName}: var(${inheritedName}, ${cssValue});
`;
                        inheritanceCss += `	${inheritedName}: var(${cssName});
`;
                    }
                }
                if (mode !== $437b23f6a393c3bf$var$defaultModeName) {
                    variablesCss += "}\n";
                    inheritanceCss += "}\n";
                }
            }
            let css = `${selectorPlaceholder} {
${variablesCss}}
`;
            css += `:has(> ${selectorPlaceholder}):not(${selectorPlaceholder}) {
${inheritanceCss}}
`;
            this._paramsCssCache = innerParamsCss = css;
        }
        return innerParamsCss.replaceAll(selectorPlaceholder, `:where(.${className})`);
    }
};
var $437b23f6a393c3bf$var$deduplicatePartsByFeature = (parts)=>{
    const lastPartByFeature = /* @__PURE__ */ new Map();
    for (const part of parts)lastPartByFeature.set(part.feature, part);
    const result = [];
    for (const part of parts)if (!part.feature || lastPartByFeature.get(part.feature) === part) result.push(part);
    return result;
};
var $437b23f6a393c3bf$var$getGoogleFontsUsed = (theme)=>{
    const googleFontsUsed = /* @__PURE__ */ new Set();
    const visitParamValue = (paramValue)=>{
        if (Array.isArray(paramValue)) paramValue.forEach(visitParamValue);
        else {
            const googleFont = paramValue?.googleFont;
            if (typeof googleFont === "string") googleFontsUsed.add(googleFont);
        }
    };
    const allModeValues = Object.values(theme._getModeParams());
    const allValues = allModeValues.flatMap((mv)=>Object.values(mv));
    allValues.forEach(visitParamValue);
    return Array.from(googleFontsUsed).sort();
};
var $437b23f6a393c3bf$var$uninstalledLegacyCSS = false;
var $437b23f6a393c3bf$var$uninstallLegacyCSS = ()=>{
    if ($437b23f6a393c3bf$var$uninstalledLegacyCSS) return;
    $437b23f6a393c3bf$var$uninstalledLegacyCSS = true;
    for (const style of Array.from(document.head.querySelectorAll('style[data-ag-scope="legacy"]')))style.remove();
};
var $437b23f6a393c3bf$var$loadGoogleFont = async (font, nonce)=>{
    const css = `@import url('https://${$437b23f6a393c3bf$var$googleFontsDomain}/css2?family=${encodeURIComponent(font)}:wght@100;200;300;400;500;600;700;800;900&display=swap');
`;
    $437b23f6a393c3bf$var$_injectGlobalCSS(css, document.head, `googleFont:${font}`, void 0, 0, nonce);
};
var $437b23f6a393c3bf$var$googleFontsDomain = "fonts.googleapis.com";
// packages/ag-grid-community/src/agStack/core/agContext.ts
var $437b23f6a393c3bf$var$contextId = 1;
var $437b23f6a393c3bf$export$1e4aca051de0f84c = class {
    constructor(params){
        this.beans = {};
        this.createdBeans = [];
        this.destroyed = false;
        this.instanceId = $437b23f6a393c3bf$var$contextId++;
        if (!params?.beanClasses) return;
        this.beanDestroyComparator = params.beanDestroyComparator;
        this.init(params);
    }
    init(params) {
        this.id = params.id;
        this.beans.context = this;
        this.destroyCallback = params.destroyCallback;
        for (const beanName of Object.keys(params.providedBeanInstances))this.beans[beanName] = params.providedBeanInstances[beanName];
        for (const BeanClass of params.beanClasses){
            const instance = new BeanClass();
            if (instance.beanName) this.beans[instance.beanName] = instance;
            else console.error(`Bean ${BeanClass.name} is missing beanName`);
            this.createdBeans.push(instance);
        }
        for (const beanFunc of params.derivedBeans ?? []){
            const { beanName: beanName, bean: bean } = beanFunc(this);
            this.beans[beanName] = bean;
            this.createdBeans.push(bean);
        }
        if (params.beanInitComparator) this.createdBeans.sort(params.beanInitComparator);
        this.initBeans(this.createdBeans);
    }
    getBeanInstances() {
        return Object.values(this.beans);
    }
    createBean(bean, afterPreCreateCallback) {
        this.initBeans([
            bean
        ], afterPreCreateCallback);
        return bean;
    }
    initBeans(beanInstances, afterPreCreateCallback) {
        const beans = this.beans;
        for (const instance of beanInstances){
            instance.preWireBeans?.(beans);
            instance.wireBeans?.(beans);
        }
        for (const instance of beanInstances)instance.preConstruct?.();
        if (afterPreCreateCallback) beanInstances.forEach(afterPreCreateCallback);
        for (const instance of beanInstances)instance.postConstruct?.();
    }
    getBeans() {
        return this.beans;
    }
    getBean(name) {
        return this.beans[name];
    }
    getId() {
        return this.id;
    }
    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        const beanInstances = this.getBeanInstances();
        if (this.beanDestroyComparator) beanInstances.sort(this.beanDestroyComparator);
        this.destroyBeans(beanInstances);
        this.beans = {};
        this.createdBeans = [];
        this.destroyCallback?.();
    }
    /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */ destroyBean(bean) {
        bean?.destroy?.();
    }
    /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */ destroyBeans(beans) {
        if (beans) for(let i = 0; i < beans.length; i++)this.destroyBean(beans[i]);
        return [];
    }
    isDestroyed() {
        return this.destroyed;
    }
};
// packages/ag-grid-community/src/agStack/core/baseEnvironment.ts
var $437b23f6a393c3bf$var$paramsId = 0;
var $437b23f6a393c3bf$var$LIST_ITEM_HEIGHT = {
    cssName: "--ag-list-item-height",
    changeKey: "listItemHeightChanged",
    defaultValue: 24
};
var $437b23f6a393c3bf$export$13d30f6a265c57c6 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "environment";
        this.sizeEls = /* @__PURE__ */ new Map();
        this.lastKnownValues = /* @__PURE__ */ new Map();
        this.sizesMeasured = false;
        this.paramsClass = `ag-theme-params-${++$437b23f6a393c3bf$var$paramsId}`;
        this.globalCSS = [];
    }
    wireBeans(beans) {
        this.eRootDiv = beans.eRootDiv;
    }
    postConstruct() {
        const { gos: gos, eRootDiv: eRootDiv } = this;
        gos.setInstanceDomData(eRootDiv);
        const themeStyleContainer = gos.get("themeStyleContainer");
        const hasShadowRootGlobal = typeof ShadowRoot !== "undefined";
        const isShadowRoot = hasShadowRootGlobal && eRootDiv.getRootNode() instanceof ShadowRoot;
        this.eStyleContainer = (typeof themeStyleContainer === "function" ? themeStyleContainer() : themeStyleContainer) ?? (isShadowRoot ? eRootDiv : document.head);
        if (!themeStyleContainer && !isShadowRoot && hasShadowRootGlobal) $437b23f6a393c3bf$var$warnOnAttachToShadowRoot(eRootDiv, this.shadowRootError.bind(this), this.addDestroyFunc.bind(this));
        this.cssLayer = gos.get("themeCssLayer");
        this.styleNonce = gos.get("styleNonce");
        this.addManagedPropertyListener("theme", ()=>this.handleThemeChange());
        this.handleThemeChange();
        this.getSizeEl($437b23f6a393c3bf$var$LIST_ITEM_HEIGHT);
        this.initVariables();
        this.addDestroyFunc(()=>$437b23f6a393c3bf$var$_unregisterInstanceUsingThemingAPI(this));
        this.mutationObserver = new MutationObserver(()=>{
            this.fireStylesChangedEvent("themeChanged");
        });
        this.addDestroyFunc(()=>this.mutationObserver.disconnect());
    }
    applyThemeClasses(el, extraClasses = []) {
        const { theme: theme } = this;
        let themeClass;
        if (theme) themeClass = `${this.paramsClass} ${theme._getCssClass()}`;
        else themeClass = this.applyLegacyThemeClasses();
        for (const className of Array.from(el.classList))if (className.startsWith("ag-theme-")) el.classList.remove(className);
        if (themeClass) {
            const oldClass = el.className;
            el.className = `${oldClass}${oldClass ? " " : ""}${themeClass}${extraClasses?.length ? " " + extraClasses.join(" ") : ""}`;
        }
    }
    applyLegacyThemeClasses() {
        let themeClass = "";
        this.mutationObserver.disconnect();
        let node = this.eRootDiv;
        while(node){
            let isThemeEl = false;
            for (const className of Array.from(node.classList))if (className.startsWith("ag-theme-")) {
                isThemeEl = true;
                themeClass = themeClass ? `${themeClass} ${className}` : className;
            }
            if (isThemeEl) this.mutationObserver.observe(node, {
                attributes: true,
                attributeFilter: [
                    "class"
                ]
            });
            node = node.parentElement;
        }
        return themeClass;
    }
    addGlobalCSS(css, debugId) {
        if (this.theme) $437b23f6a393c3bf$var$_injectGlobalCSS(css, this.eStyleContainer, debugId, this.cssLayer, 0, this.styleNonce);
        else this.globalCSS.push([
            css,
            debugId
        ]);
    }
    getDefaultListItemHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$LIST_ITEM_HEIGHT);
    }
    getCSSVariablePixelValue(variable) {
        const cached = this.lastKnownValues.get(variable);
        if (cached != null) return cached;
        const measurement = this.measureSizeEl(variable);
        if (measurement === "detached" || measurement === "no-styles") {
            if (variable.cacheDefault) this.lastKnownValues.set(variable, variable.defaultValue);
            return variable.defaultValue;
        }
        this.lastKnownValues.set(variable, measurement);
        return measurement;
    }
    measureSizeEl(variable) {
        const sizeEl = this.getSizeEl(variable);
        if (sizeEl.offsetParent == null) return "detached";
        const newSize = sizeEl.offsetWidth;
        if (newSize === $437b23f6a393c3bf$var$NO_VALUE_SENTINEL) return "no-styles";
        this.sizesMeasured = true;
        return newSize;
    }
    getMeasurementContainer() {
        let container = this.eMeasurementContainer;
        if (!container) {
            container = this.eMeasurementContainer = $437b23f6a393c3bf$export$378bc9c64290bc8b({
                tag: "div",
                cls: "ag-measurement-container"
            });
            this.eRootDiv.appendChild(container);
        }
        return container;
    }
    getSizeEl(variable) {
        let sizeEl = this.sizeEls.get(variable);
        if (sizeEl) return sizeEl;
        const container = this.getMeasurementContainer();
        sizeEl = $437b23f6a393c3bf$export$378bc9c64290bc8b({
            tag: "div"
        });
        const { border: border, noWarn: noWarn } = variable;
        if (border) {
            sizeEl.className = "ag-measurement-element-border";
            sizeEl.style.setProperty("--ag-internal-measurement-border", `var(${variable.cssName}, solid ${$437b23f6a393c3bf$var$NO_VALUE_SENTINEL}px)`);
        } else sizeEl.style.width = `var(${variable.cssName}, ${$437b23f6a393c3bf$var$NO_VALUE_SENTINEL}px)`;
        container.appendChild(sizeEl);
        this.sizeEls.set(variable, sizeEl);
        let lastMeasurement = this.measureSizeEl(variable);
        if (lastMeasurement === "no-styles" && !noWarn) this.varError(variable);
        const unsubscribe = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, sizeEl, ()=>{
            const newMeasurement = this.measureSizeEl(variable);
            if (newMeasurement === "detached" || newMeasurement === "no-styles") return;
            this.lastKnownValues.set(variable, newMeasurement);
            if (newMeasurement !== lastMeasurement) {
                lastMeasurement = newMeasurement;
                this.fireStylesChangedEvent(variable.changeKey);
            }
        });
        this.addDestroyFunc(()=>unsubscribe());
        return sizeEl;
    }
    handleThemeChange() {
        const { gos: gos, theme: oldTheme } = this;
        const themeProperty = gos.get("theme");
        let newTheme;
        if (themeProperty === "legacy") newTheme = void 0;
        else {
            const themeOrDefault = themeProperty ?? this.getDefaultTheme();
            if (themeOrDefault instanceof $437b23f6a393c3bf$var$ThemeImpl) newTheme = themeOrDefault;
            else this.themeError(themeOrDefault);
        }
        if (newTheme !== oldTheme) this.handleNewTheme(newTheme);
        this.postProcessThemeChange(newTheme, themeProperty);
    }
    handleNewTheme(newTheme) {
        const { gos: gos, eRootDiv: eRootDiv, globalCSS: globalCSS } = this;
        const additionalCss = this.getAdditionalCss();
        if (newTheme) {
            $437b23f6a393c3bf$var$_registerInstanceUsingThemingAPI(this);
            $437b23f6a393c3bf$var$_injectCoreAndModuleCSS(this.eStyleContainer, this.cssLayer, this.styleNonce, additionalCss);
            for (const [css, debugId] of globalCSS)$437b23f6a393c3bf$var$_injectGlobalCSS(css, this.eStyleContainer, debugId, this.cssLayer, 0, this.styleNonce);
            globalCSS.length = 0;
        }
        this.theme = newTheme;
        newTheme?._startUse({
            loadThemeGoogleFonts: gos.get("loadThemeGoogleFonts"),
            styleContainer: this.eStyleContainer,
            cssLayer: this.cssLayer,
            nonce: this.styleNonce,
            moduleCss: additionalCss
        });
        let eParamsStyle = this.eParamsStyle;
        if (!eParamsStyle) {
            eParamsStyle = this.eParamsStyle = $437b23f6a393c3bf$export$378bc9c64290bc8b({
                tag: "style"
            });
            const styleNonce = gos.get("styleNonce");
            if (styleNonce) eParamsStyle.setAttribute("nonce", styleNonce);
            eRootDiv.appendChild(eParamsStyle);
        }
        if (!$437b23f6a393c3bf$var$IS_SSR) eParamsStyle.textContent = newTheme?._getPerInstanceCss(this.paramsClass) || "";
        this.applyThemeClasses(eRootDiv);
        this.fireStylesChangedEvent("themeChanged");
    }
    fireStylesChangedEvent(change) {
        this.eventSvc.dispatchEvent({
            type: "stylesChanged",
            [change]: true
        });
    }
};
var $437b23f6a393c3bf$var$NO_VALUE_SENTINEL = 15538;
var $437b23f6a393c3bf$var$warnOnAttachToShadowRoot = (el, errorCallback, onDestroy)=>{
    let retries = 60;
    const interval = setInterval(()=>{
        if (typeof ShadowRoot !== "undefined" && el.getRootNode() instanceof ShadowRoot) {
            errorCallback();
            clearInterval(interval);
        }
        if ($437b23f6a393c3bf$var$_isInDOM(el) || --retries < 0) clearInterval(interval);
    }, 1e3);
    onDestroy(()=>clearInterval(interval));
};
// packages/ag-grid-community/src/agStack/core/baseRegistry.ts
var $437b23f6a393c3bf$export$95e025d9098f4893 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "registry";
    }
    registerDynamicBeans(dynamicBeans) {
        if (dynamicBeans) {
            this.dynamicBeans ?? (this.dynamicBeans = {});
            for (const name of Object.keys(dynamicBeans))this.dynamicBeans[name] = dynamicBeans[name];
        }
    }
    createDynamicBean(name, mandatory, ...args) {
        if (!this.dynamicBeans) throw new Error(this.getDynamicError(name, true));
        const BeanClass = this.dynamicBeans[name];
        if (BeanClass == null) {
            if (mandatory) throw new Error(this.getDynamicError(name, false));
            return void 0;
        }
        return new BeanClass(...args);
    }
};
// packages/ag-grid-community/src/agStack/events/baseEventService.ts
var $437b23f6a393c3bf$export$495c88faa5a4d068 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "eventSvc";
        this.eventServiceType = "global";
        this.globalSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
    }
    addListener(eventType, listener, async) {
        this.globalSvc.addEventListener(eventType, listener, async);
    }
    removeListener(eventType, listener, async) {
        this.globalSvc.removeEventListener(eventType, listener, async);
    }
    addGlobalListener(listener, async = false) {
        this.globalSvc.addGlobalListener(listener, async);
    }
    removeGlobalListener(listener, async = false) {
        this.globalSvc.removeGlobalListener(listener, async);
    }
    dispatchEvent(event) {
        this.globalSvc.dispatchEvent(this.gos.addCommon(event));
    }
    dispatchEventOnce(event) {
        this.globalSvc.dispatchEventOnce(this.gos.addCommon(event));
    }
};
// packages/ag-grid-community/src/agStack/tooltip/agTooltipFeature.ts
var $437b23f6a393c3bf$export$e72bd8c9b85d3e72 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(ctrl, beans){
        super();
        this.ctrl = ctrl;
        if (beans) this.beans = beans;
    }
    postConstruct() {
        this.refreshTooltip();
    }
    /**
   *
   * @param tooltip The tooltip value
   * @param allowEmptyString Set it to true to allow the title to be set to `''`. This is necessary
   * when the browser adds a default tooltip the element and the tooltip service will be displayed
   * next to a browser tooltip causing confusion.
   */ setBrowserTooltip(tooltip, allowEmptyString) {
        const name = "title";
        const eGui = this.ctrl.getGui();
        if (!eGui) return;
        if (tooltip != null && (tooltip != "" || allowEmptyString)) eGui.setAttribute(name, tooltip);
        else eGui.removeAttribute(name);
    }
    updateTooltipText() {
        const { getTooltipValue: getTooltipValue } = this.ctrl;
        if (getTooltipValue) this.tooltip = getTooltipValue();
    }
    createTooltipFeatureIfNeeded() {
        if (this.tooltipManager == null) {
            const tooltipManager = this.beans.registry.createDynamicBean("tooltipStateManager", true, this.ctrl, ()=>this.tooltip);
            if (tooltipManager) this.tooltipManager = this.createBean(tooltipManager, this.beans.context);
        }
    }
    attemptToShowTooltip() {
        this.tooltipManager?.prepareToShowTooltip();
    }
    attemptToHideTooltip() {
        this.tooltipManager?.hideTooltip();
    }
    setTooltipAndRefresh(tooltip) {
        this.tooltip = tooltip;
        this.refreshTooltip();
    }
    refreshTooltip(clearWithEmptyString) {
        this.browserTooltips = this.beans.gos.get("enableBrowserTooltips");
        this.updateTooltipText();
        if (this.browserTooltips) {
            this.setBrowserTooltip(this.tooltip);
            this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        } else {
            this.setBrowserTooltip(clearWithEmptyString ? "" : null, clearWithEmptyString);
            this.createTooltipFeatureIfNeeded();
        }
    }
    destroy() {
        this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        super.destroy();
    }
};
// packages/ag-grid-community/src/agStack/tooltip/baseTooltipStateManager.ts
var $437b23f6a393c3bf$var$SHOW_QUICK_TOOLTIP_DIFF = 1e3;
var $437b23f6a393c3bf$var$FADE_OUT_TOOLTIP_TIMEOUT = 1e3;
var $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY = 100;
var $437b23f6a393c3bf$var$lastTooltipHideTime;
var $437b23f6a393c3bf$var$isLocked = false;
var $437b23f6a393c3bf$export$96f12f5ea073bed1 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(tooltipCtrl, getTooltipValue){
        super();
        this.tooltipCtrl = tooltipCtrl;
        this.getTooltipValue = getTooltipValue;
        this.interactionEnabled = false;
        this.isInteractingWithTooltip = false;
        this.state = 0 /* NOTHING */ ;
        // when showing the tooltip, we need to make sure it's the most recent instance we request, as due to
        // async we could request two tooltips before the first instance returns, in which case we should
        // disregard the second instance.
        this.tooltipInstanceCount = 0;
        this.tooltipMouseTrack = false;
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
    }
    postConstruct() {
        if (this.gos.get("tooltipInteraction")) this.interactionEnabled = true;
        this.tooltipTrigger = this.getTooltipTrigger();
        this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
        const el = this.tooltipCtrl.getGui();
        if (this.tooltipTrigger === 0 /* HOVER */ ) this.addManagedListeners(el, {
            mouseenter: this.onMouseEnter.bind(this),
            mouseleave: this.onMouseLeave.bind(this)
        });
        if (this.tooltipTrigger === 1 /* FOCUS */ ) this.addManagedListeners(el, {
            focusin: this.onFocusIn.bind(this),
            focusout: this.onFocusOut.bind(this)
        });
        this.addManagedListeners(el, {
            mousemove: this.onMouseMove.bind(this)
        });
        if (!this.interactionEnabled) this.addManagedListeners(el, {
            mousedown: this.onMouseDown.bind(this),
            keydown: this.onKeyDown.bind(this)
        });
    }
    getGridOptionsTooltipDelay(delayOption) {
        const delay = this.gos.get(delayOption);
        return Math.max(200, delay);
    }
    getTooltipDelay(type) {
        if (type === "show") return this.tooltipCtrl.getTooltipShowDelayOverride?.() ?? this.getGridOptionsTooltipDelay("tooltipShowDelay");
        return this.tooltipCtrl.getTooltipHideDelayOverride?.() ?? this.getGridOptionsTooltipDelay("tooltipHideDelay");
    }
    destroy() {
        this.setToDoNothing();
        super.destroy();
    }
    getTooltipTrigger() {
        const trigger = this.gos.get("tooltipTrigger");
        if (!trigger || trigger === "hover") return 0 /* HOVER */ ;
        return 1 /* FOCUS */ ;
    }
    onMouseEnter(e) {
        if (this.interactionEnabled && this.interactiveTooltipTimeoutId) {
            this.unlockService();
            this.startHideTimeout();
        }
        if ($437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        if ($437b23f6a393c3bf$var$isLocked) this.showTooltipTimeoutId = window.setTimeout(()=>{
            this.prepareToShowTooltip(e);
        }, $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY);
        else this.prepareToShowTooltip(e);
    }
    onMouseMove(e) {
        if (this.lastMouseEvent) this.lastMouseEvent = e;
        if (this.tooltipMouseTrack && this.state === 2 /* SHOWING */  && this.tooltipComp) this.positionTooltip();
    }
    onMouseDown() {
        this.setToDoNothing();
    }
    onMouseLeave() {
        if (this.interactionEnabled) this.lockService();
        else this.setToDoNothing();
    }
    onFocusIn() {
        this.prepareToShowTooltip();
    }
    onFocusOut(e) {
        const relatedTarget = e.relatedTarget;
        const parentCompGui = this.tooltipCtrl.getGui();
        const tooltipGui = this.tooltipComp?.getGui();
        if (this.isInteractingWithTooltip || parentCompGui.contains(relatedTarget) || this.interactionEnabled && tooltipGui?.contains(relatedTarget)) return;
        this.setToDoNothing();
    }
    onKeyDown() {
        if (this.isInteractingWithTooltip) this.isInteractingWithTooltip = false;
        this.setToDoNothing();
    }
    prepareToShowTooltip(mouseEvent) {
        if (this.state != 0 /* NOTHING */  || $437b23f6a393c3bf$var$isLocked) return;
        let delay = 0;
        if (mouseEvent) delay = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show");
        this.lastMouseEvent = mouseEvent || null;
        this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), delay);
        this.state = 1 /* WAITING_TO_SHOW */ ;
    }
    isLastTooltipHiddenRecently() {
        const now = Date.now();
        const then = $437b23f6a393c3bf$var$lastTooltipHideTime;
        return now - then < $437b23f6a393c3bf$var$SHOW_QUICK_TOOLTIP_DIFF;
    }
    setToDoNothing(fromHideTooltip) {
        if (!fromHideTooltip && this.state === 2 /* SHOWING */ ) this.hideTooltip();
        if (this.onBodyScrollEventCallback) {
            this.onBodyScrollEventCallback();
            this.onBodyScrollEventCallback = void 0;
        }
        this.clearEventHandlers();
        if (this.onDocumentKeyDownCallback) {
            this.onDocumentKeyDownCallback();
            this.onDocumentKeyDownCallback = void 0;
        }
        this.clearTimeouts();
        this.state = 0 /* NOTHING */ ;
        this.lastMouseEvent = null;
    }
    showTooltip() {
        const value = this.getTooltipValue();
        const ctrl = this.tooltipCtrl;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) || ctrl.shouldDisplayTooltip && !ctrl.shouldDisplayTooltip()) {
            this.setToDoNothing();
            return;
        }
        const params = this.gos.addCommon({
            location: ctrl.getLocation?.() ?? "UNKNOWN",
            value: value,
            hideTooltipCallback: ()=>this.hideTooltip(true),
            ...ctrl.getAdditionalParams?.()
        });
        this.state = 2 /* SHOWING */ ;
        this.tooltipInstanceCount++;
        const callback = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
        this.createTooltipComp(params, callback);
    }
    hideTooltip(forceHide) {
        if (!forceHide && this.isInteractingWithTooltip) return;
        if (this.tooltipComp) {
            this.destroyTooltipComp();
            $437b23f6a393c3bf$var$lastTooltipHideTime = Date.now();
        }
        this.eventSvc.dispatchEvent({
            type: "tooltipHide",
            parentGui: this.tooltipCtrl.getGui()
        });
        if (forceHide) this.isInteractingWithTooltip = false;
        this.setToDoNothing(true);
    }
    newTooltipComponentCallback(tooltipInstanceCopy, tooltipComp) {
        const compNoLongerNeeded = this.state !== 2 /* SHOWING */  || this.tooltipInstanceCount !== tooltipInstanceCopy;
        if (compNoLongerNeeded) {
            this.destroyBean(tooltipComp);
            return;
        }
        const eGui = tooltipComp.getGui();
        this.tooltipComp = tooltipComp;
        if (!eGui.classList.contains("ag-tooltip")) eGui.classList.add("ag-tooltip-custom");
        if (this.tooltipTrigger === 0 /* HOVER */ ) eGui.classList.add("ag-tooltip-animate");
        if (this.interactionEnabled) eGui.classList.add("ag-tooltip-interactive");
        const translate = this.getLocaleTextFunc();
        const addPopupRes = this.popupSvc?.addPopup({
            eChild: eGui,
            ariaLabel: translate("ariaLabelTooltip", "Tooltip")
        });
        if (addPopupRes) this.tooltipPopupDestroyFunc = addPopupRes.hideFunc;
        this.positionTooltip();
        if (this.tooltipTrigger === 1 /* FOCUS */ ) {
            const listener = ()=>this.setToDoNothing();
            [this.onBodyScrollEventCallback] = this.addManagedEventListeners({
                bodyScroll: listener
            });
            this.setEventHandlers(listener);
        }
        if (this.interactionEnabled) {
            [this.tooltipMouseEnterListener, this.tooltipMouseLeaveListener] = this.addManagedElementListeners(eGui, {
                mouseenter: this.onTooltipMouseEnter.bind(this),
                mouseleave: this.onTooltipMouseLeave.bind(this)
            });
            [this.onDocumentKeyDownCallback] = this.addManagedElementListeners($437b23f6a393c3bf$export$f63d0991874c6f81(this.beans), {
                keydown: (e)=>{
                    if (!eGui.contains(e?.target)) this.onKeyDown();
                }
            });
            if (this.tooltipTrigger === 1 /* FOCUS */ ) [this.tooltipFocusInListener, this.tooltipFocusOutListener] = this.addManagedElementListeners(eGui, {
                focusin: this.onTooltipFocusIn.bind(this),
                focusout: this.onTooltipFocusOut.bind(this)
            });
        }
        this.eventSvc.dispatchEvent({
            type: "tooltipShow",
            tooltipGui: eGui,
            parentGui: this.tooltipCtrl.getGui()
        });
        this.startHideTimeout();
    }
    onTooltipMouseEnter() {
        this.isInteractingWithTooltip = true;
        this.unlockService();
    }
    onTooltipMouseLeave() {
        if (this.isTooltipFocused()) return;
        this.isInteractingWithTooltip = false;
        this.lockService();
    }
    onTooltipFocusIn() {
        this.isInteractingWithTooltip = true;
    }
    isTooltipFocused() {
        const tooltipGui = this.tooltipComp?.getGui();
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return !!tooltipGui && tooltipGui.contains(activeEl);
    }
    onTooltipFocusOut(e) {
        const parentGui = this.tooltipCtrl.getGui();
        if (this.isTooltipFocused()) return;
        this.isInteractingWithTooltip = false;
        if (parentGui.contains(e.relatedTarget)) this.startHideTimeout();
        else this.hideTooltip();
    }
    positionTooltip() {
        const params = {
            type: "tooltip",
            ePopup: this.tooltipComp.getGui(),
            nudgeY: 18,
            skipObserver: this.tooltipMouseTrack
        };
        if (this.lastMouseEvent) this.popupSvc?.positionPopupUnderMouseEvent({
            ...params,
            mouseEvent: this.lastMouseEvent
        });
        else this.popupSvc?.positionPopupByComponent({
            ...params,
            eventSource: this.tooltipCtrl.getGui(),
            position: "under",
            keepWithinBounds: true,
            nudgeY: 5
        });
    }
    destroyTooltipComp() {
        this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
        const tooltipPopupDestroyFunc = this.tooltipPopupDestroyFunc;
        const tooltipComp = this.tooltipComp;
        const delay = this.tooltipTrigger === 0 /* HOVER */  ? $437b23f6a393c3bf$var$FADE_OUT_TOOLTIP_TIMEOUT : 0;
        window.setTimeout(()=>{
            tooltipPopupDestroyFunc();
            this.destroyBean(tooltipComp);
        }, delay);
        this.clearTooltipListeners();
        this.tooltipPopupDestroyFunc = void 0;
        this.tooltipComp = void 0;
    }
    clearTooltipListeners() {
        for (const listener of [
            this.tooltipMouseEnterListener,
            this.tooltipMouseLeaveListener,
            this.tooltipFocusInListener,
            this.tooltipFocusOutListener
        ])if (listener) listener();
        this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
    }
    lockService() {
        $437b23f6a393c3bf$var$isLocked = true;
        this.interactiveTooltipTimeoutId = window.setTimeout(()=>{
            this.unlockService();
            this.setToDoNothing();
        }, $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY);
    }
    unlockService() {
        $437b23f6a393c3bf$var$isLocked = false;
        this.clearInteractiveTimeout();
    }
    startHideTimeout() {
        this.clearHideTimeout();
        this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
    }
    clearShowTimeout() {
        if (!this.showTooltipTimeoutId) return;
        window.clearTimeout(this.showTooltipTimeoutId);
        this.showTooltipTimeoutId = void 0;
    }
    clearHideTimeout() {
        if (!this.hideTooltipTimeoutId) return;
        window.clearTimeout(this.hideTooltipTimeoutId);
        this.hideTooltipTimeoutId = void 0;
    }
    clearInteractiveTimeout() {
        if (!this.interactiveTooltipTimeoutId) return;
        window.clearTimeout(this.interactiveTooltipTimeoutId);
        this.interactiveTooltipTimeoutId = void 0;
    }
    clearTimeouts() {
        this.clearShowTimeout();
        this.clearHideTimeout();
        this.clearInteractiveTimeout();
    }
};
// packages/ag-grid-community/src/agStack/tooltip/agHighlightTooltipFeature.ts
var $437b23f6a393c3bf$var$AgHighlightTooltipFeature = class extends $437b23f6a393c3bf$export$e72bd8c9b85d3e72 {
    constructor(ctrl, highlightTracker, beans){
        super(ctrl, beans);
        this.highlightTracker = highlightTracker;
        this.onHighlight = this.onHighlight.bind(this);
    }
    postConstruct() {
        super.postConstruct();
        this.wireHighlightListeners();
    }
    wireHighlightListeners() {
        this.addManagedPropertyListener("tooltipTrigger", ({ currentValue: currentValue })=>{
            this.setTooltipMode(currentValue);
        });
        this.setTooltipMode(this.gos.get("tooltipTrigger"));
        this.highlightTracker.addEventListener("itemHighlighted", this.onHighlight);
    }
    onHighlight(event) {
        if (this.tooltipMode !== 1 /* FOCUS */ ) return;
        if (event.highlighted) this.attemptToShowTooltip();
        else this.attemptToHideTooltip();
    }
    setTooltipMode(tooltipTriggerMode = "focus") {
        this.tooltipMode = tooltipTriggerMode === "focus" ? 1 /* FOCUS */  : 0 /* HOVER */ ;
    }
    destroy() {
        this.highlightTracker.removeEventListener("itemHighlighted", this.onHighlight);
        super.destroy();
    }
};
// packages/ag-grid-community/src/agStack/popup/basePopupService.ts
var $437b23f6a393c3bf$var$instanceIdSeq = 0;
var $437b23f6a393c3bf$var$WAIT_FOR_POPUP_CONTENT_RESIZE = 200;
var $437b23f6a393c3bf$export$a5869429525f9944 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "popupSvc";
        this.popupList = [];
    }
    postConstruct() {
        this.addManagedEventListeners({
            stylesChanged: this.handleThemeChange.bind(this)
        });
    }
    getPopupParent() {
        const ePopupParent = this.gos.get("popupParent");
        if (ePopupParent) return ePopupParent;
        return this.getDefaultPopupParent();
    }
    positionPopupUnderMouseEvent(params) {
        const { ePopup: ePopup, nudgeX: nudgeX, nudgeY: nudgeY, skipObserver: skipObserver } = params;
        this.positionPopup({
            ePopup: ePopup,
            nudgeX: nudgeX,
            nudgeY: nudgeY,
            keepWithinBounds: true,
            skipObserver: skipObserver,
            updatePosition: ()=>this.calculatePointerAlign(params.mouseEvent),
            postProcessCallback: ()=>this.callPostProcessPopup(params.additionalParams, params.type, params.ePopup, null, params.mouseEvent)
        });
    }
    calculatePointerAlign(e) {
        const parentRect = this.getParentRect();
        return {
            x: e.clientX - parentRect.left,
            y: e.clientY - parentRect.top
        };
    }
    positionPopupByComponent(params) {
        const { ePopup: ePopup, nudgeX: nudgeX, nudgeY: nudgeY, keepWithinBounds: keepWithinBounds, eventSource: eventSource, alignSide: alignSide = "left", position: position = "over", type: type } = params;
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        this.setAlignedTo(eventSource, ePopup);
        const updatePosition = ()=>{
            let x = sourceRect.left - parentRect.left;
            if (alignSide === "right") x -= ePopup.offsetWidth - sourceRect.width;
            let y;
            if (position === "over") {
                y = sourceRect.top - parentRect.top;
                this.setAlignedStyles(ePopup, "over");
            } else {
                this.setAlignedStyles(ePopup, "under");
                const alignSide2 = this.shouldRenderUnderOrAbove(ePopup, sourceRect, parentRect, params.nudgeY || 0);
                if (alignSide2 === "under") y = sourceRect.top - parentRect.top + sourceRect.height;
                else y = sourceRect.top - ePopup.offsetHeight - (nudgeY || 0) * 2 - parentRect.top;
            }
            return {
                x: x,
                y: y
            };
        };
        this.positionPopup({
            ePopup: ePopup,
            nudgeX: nudgeX,
            nudgeY: nudgeY,
            keepWithinBounds: keepWithinBounds,
            updatePosition: updatePosition,
            postProcessCallback: ()=>this.callPostProcessPopup(params.additionalParams, type, ePopup, eventSource, null)
        });
    }
    positionPopupForMenu(params) {
        const { eventSource: eventSource, ePopup: ePopup, event: event } = params;
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        this.setAlignedTo(eventSource, ePopup);
        let minWidthSet = false;
        const updatePosition = ()=>{
            const y = this.keepXYWithinBounds(ePopup, sourceRect.top - parentRect.top, 0 /* Vertical */ );
            const minWidth = ePopup.clientWidth > 0 ? ePopup.clientWidth : 200;
            if (!minWidthSet) {
                ePopup.style.minWidth = `${minWidth}px`;
                minWidthSet = true;
            }
            const widthOfParent = parentRect.right - parentRect.left;
            const maxX = widthOfParent - minWidth;
            let x;
            if (this.gos.get("enableRtl")) {
                x = xLeftPosition();
                if (x < 0) {
                    x = xRightPosition();
                    this.setAlignedStyles(ePopup, "left");
                }
                if (x > maxX) {
                    x = 0;
                    this.setAlignedStyles(ePopup, "right");
                }
            } else {
                x = xRightPosition();
                if (x > maxX) {
                    x = xLeftPosition();
                    this.setAlignedStyles(ePopup, "right");
                }
                if (x < 0) {
                    x = 0;
                    this.setAlignedStyles(ePopup, "left");
                }
            }
            return {
                x: x,
                y: y
            };
            function xRightPosition() {
                return sourceRect.right - parentRect.left - 2;
            }
            function xLeftPosition() {
                return sourceRect.left - parentRect.left - minWidth;
            }
        };
        this.positionPopup({
            ePopup: ePopup,
            keepWithinBounds: true,
            updatePosition: updatePosition,
            postProcessCallback: ()=>this.callPostProcessPopup(params.additionalParams, "subMenu", ePopup, eventSource, event instanceof MouseEvent ? event : void 0)
        });
    }
    shouldRenderUnderOrAbove(ePopup, targetCompRect, parentRect, nudgeY) {
        const spaceAvailableUnder = parentRect.bottom - targetCompRect.bottom;
        const spaceAvailableAbove = targetCompRect.top - parentRect.top;
        const spaceRequired = ePopup.offsetHeight + nudgeY;
        if (spaceAvailableUnder > spaceRequired) return "under";
        if (spaceAvailableAbove > spaceRequired || spaceAvailableAbove > spaceAvailableUnder) return "above";
        return "under";
    }
    setAlignedStyles(ePopup, positioned) {
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx === -1) return;
        const popup = this.popupList[popupIdx];
        const { alignedToElement: alignedToElement } = popup;
        if (!alignedToElement) return;
        const positions = [
            "right",
            "left",
            "over",
            "above",
            "under"
        ];
        for (const position of positions){
            alignedToElement.classList.remove(`ag-has-popup-positioned-${position}`);
            ePopup.classList.remove(`ag-popup-positioned-${position}`);
        }
        if (!positioned) return;
        alignedToElement.classList.add(`ag-has-popup-positioned-${positioned}`);
        ePopup.classList.add(`ag-popup-positioned-${positioned}`);
    }
    setAlignedTo(eventSource, ePopup) {
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx !== -1) {
            const popup = this.popupList[popupIdx];
            popup.alignedToElement = eventSource;
        }
    }
    positionPopup(params) {
        const { ePopup: ePopup, keepWithinBounds: keepWithinBounds, nudgeX: nudgeX, nudgeY: nudgeY, skipObserver: skipObserver, updatePosition: updatePosition } = params;
        const lastSize = {
            width: 0,
            height: 0
        };
        const updatePopupPosition = (fromResizeObserver = false)=>{
            let { x: x, y: y } = updatePosition();
            if (fromResizeObserver && ePopup.clientWidth === lastSize.width && ePopup.clientHeight === lastSize.height) return;
            lastSize.width = ePopup.clientWidth;
            lastSize.height = ePopup.clientHeight;
            if (nudgeX) x += nudgeX;
            if (nudgeY) y += nudgeY;
            if (keepWithinBounds) {
                x = this.keepXYWithinBounds(ePopup, x, 1 /* Horizontal */ );
                y = this.keepXYWithinBounds(ePopup, y, 0 /* Vertical */ );
            }
            ePopup.style.left = `${x}px`;
            ePopup.style.top = `${y}px`;
            if (params.postProcessCallback) params.postProcessCallback();
        };
        updatePopupPosition();
        if (!skipObserver) {
            const resizeObserverDestroyFunc = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, ePopup, ()=>updatePopupPosition(true));
            setTimeout(()=>resizeObserverDestroyFunc(), $437b23f6a393c3bf$var$WAIT_FOR_POPUP_CONTENT_RESIZE);
        }
    }
    getParentRect() {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        let popupParent = this.getPopupParent();
        if (popupParent === eDocument.body) popupParent = eDocument.documentElement;
        else if (getComputedStyle(popupParent).position === "static") popupParent = popupParent.offsetParent;
        return $437b23f6a393c3bf$var$_getElementRectWithOffset(popupParent);
    }
    keepXYWithinBounds(ePopup, position, direction) {
        const isVertical = direction === 0 /* Vertical */ ;
        const sizeProperty = isVertical ? "clientHeight" : "clientWidth";
        const anchorProperty = isVertical ? "top" : "left";
        const offsetProperty = isVertical ? "height" : "width";
        const scrollPositionProperty = isVertical ? "scrollTop" : "scrollLeft";
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        const docElement = eDocument.documentElement;
        const popupParent = this.getPopupParent();
        const popupRect = ePopup.getBoundingClientRect();
        const parentRect = popupParent.getBoundingClientRect();
        const documentRect = eDocument.documentElement.getBoundingClientRect();
        const isBody = popupParent === eDocument.body;
        const offsetSize = Math.ceil(popupRect[offsetProperty]);
        const getSize2 = isVertical ? $437b23f6a393c3bf$export$d23c22492e0f7c0c : $437b23f6a393c3bf$export$642efcb17474eb51;
        let sizeOfParent = isBody ? getSize2(docElement) + docElement[scrollPositionProperty] : popupParent[sizeProperty];
        if (isBody) sizeOfParent -= Math.abs(documentRect[anchorProperty] - parentRect[anchorProperty]);
        const max = sizeOfParent - offsetSize;
        return Math.min(Math.max(position, 0), Math.max(max, 0));
    }
    addPopup(params) {
        const { eChild: eChild, ariaLabel: ariaLabel, ariaOwns: ariaOwns, alwaysOnTop: alwaysOnTop, positionCallback: positionCallback, anchorToElement: anchorToElement } = params;
        const pos = this.getPopupIndex(eChild);
        if (pos !== -1) {
            const popup = this.popupList[pos];
            return {
                hideFunc: popup.hideFunc
            };
        }
        this.initialisePopupPosition(eChild);
        const wrapperEl = this.createPopupWrapper(eChild, !!alwaysOnTop, ariaLabel, ariaOwns);
        const removeListeners = this.addEventListenersToPopup({
            ...params,
            wrapperEl: wrapperEl
        });
        if (positionCallback) positionCallback();
        this.addPopupToPopupList(eChild, wrapperEl, removeListeners, anchorToElement);
        return {
            hideFunc: removeListeners
        };
    }
    initialisePopupPosition(element) {
        const ePopupParent = this.getPopupParent();
        const ePopupParentRect = ePopupParent.getBoundingClientRect();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(element.style.top)) element.style.top = `${ePopupParentRect.top * -1}px`;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(element.style.left)) element.style.left = `${ePopupParentRect.left * -1}px`;
    }
    createPopupWrapper(element, alwaysOnTop, ariaLabel, ariaOwns) {
        const ePopupParent = this.getPopupParent();
        const { environment: environment, gos: gos } = this.beans;
        const eWrapper = $437b23f6a393c3bf$export$378bc9c64290bc8b({
            tag: "div"
        });
        environment.applyThemeClasses(eWrapper);
        eWrapper.classList.add("ag-popup");
        element.classList.add(gos.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child");
        if (!element.hasAttribute("role")) $437b23f6a393c3bf$export$f8d01fa01787902(element, "dialog");
        if (ariaLabel) $437b23f6a393c3bf$export$e81cb0dd07f289f6(element, ariaLabel);
        else if (ariaOwns) {
            element.id || (element.id = `popup-component-${$437b23f6a393c3bf$var$instanceIdSeq}`);
            $437b23f6a393c3bf$var$_setAriaOwns(ariaOwns, element.id);
        }
        eWrapper.appendChild(element);
        ePopupParent.appendChild(eWrapper);
        if (alwaysOnTop) this.setAlwaysOnTop(element, true);
        else this.bringPopupToFront(element);
        return eWrapper;
    }
    addEventListenersToPopup(params) {
        const beans = this.beans;
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        const { wrapperEl: wrapperEl, eChild: popupEl, closedCallback: closedCallback, afterGuiAttached: afterGuiAttached, closeOnEsc: closeOnEsc, modal: modal, ariaOwns: ariaOwns } = params;
        let popupHidden = false;
        const hidePopupOnKeyboardEvent = (event)=>{
            if (!wrapperEl.contains($437b23f6a393c3bf$export$16bc98d422315038(beans))) return;
            const key = event.key;
            if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE && !this.isStopPropagation(event)) removeListeners({
                keyboardEvent: event
            });
        };
        const hidePopupOnMouseEvent = (event)=>removeListeners({
                mouseEvent: event
            });
        const hidePopupOnTouchEvent = (event)=>removeListeners({
                touchEvent: event
            });
        const removeListeners = (popupParams = {})=>{
            const { mouseEvent: mouseEvent, touchEvent: touchEvent, keyboardEvent: keyboardEvent, forceHide: forceHide } = popupParams;
            if (!forceHide && // we don't hide popup if the event was on the child, or any
            // children of this child
            (this.isEventFromCurrentPopup({
                mouseEvent: mouseEvent,
                touchEvent: touchEvent
            }, popupEl) || // this method should only be called once. the client can have different
            // paths, each one wanting to close, so this method may be called multiple times.
            popupHidden)) return;
            popupHidden = true;
            wrapperEl.remove();
            eDocument.removeEventListener("keydown", hidePopupOnKeyboardEvent);
            eDocument.removeEventListener("mousedown", hidePopupOnMouseEvent);
            eDocument.removeEventListener("touchstart", hidePopupOnTouchEvent);
            eDocument.removeEventListener("contextmenu", hidePopupOnMouseEvent);
            this.eventSvc.removeListener("dragStarted", hidePopupOnMouseEvent);
            if (closedCallback) closedCallback(mouseEvent || touchEvent || keyboardEvent);
            this.removePopupFromPopupList(popupEl, ariaOwns);
        };
        if (afterGuiAttached) afterGuiAttached({
            hidePopup: removeListeners
        });
        window.setTimeout(()=>{
            if (closeOnEsc) eDocument.addEventListener("keydown", hidePopupOnKeyboardEvent);
            if (modal) {
                eDocument.addEventListener("mousedown", hidePopupOnMouseEvent);
                this.eventSvc.addListener("dragStarted", hidePopupOnMouseEvent);
                eDocument.addEventListener("touchstart", hidePopupOnTouchEvent);
                eDocument.addEventListener("contextmenu", hidePopupOnMouseEvent);
            }
        }, 0);
        return removeListeners;
    }
    addPopupToPopupList(element, wrapperEl, removeListeners, anchorToElement) {
        this.popupList.push({
            element: element,
            wrapper: wrapperEl,
            hideFunc: removeListeners,
            instanceId: $437b23f6a393c3bf$var$instanceIdSeq,
            isAnchored: !!anchorToElement
        });
        if (anchorToElement) this.setPopupPositionRelatedToElement(element, anchorToElement);
        $437b23f6a393c3bf$var$instanceIdSeq = $437b23f6a393c3bf$var$instanceIdSeq + 1;
    }
    getPopupIndex(el) {
        return this.popupList.findIndex((p)=>p.element === el);
    }
    setPopupPositionRelatedToElement(popupEl, relativeElement) {
        const popupIndex = this.getPopupIndex(popupEl);
        if (popupIndex === -1) return;
        const popup = this.popupList[popupIndex];
        if (popup.stopAnchoringPromise) popup.stopAnchoringPromise.then((destroyFunc)=>destroyFunc && destroyFunc());
        popup.stopAnchoringPromise = void 0;
        popup.isAnchored = false;
        if (!relativeElement) return;
        const destroyPositionTracker = this.keepPopupPositionedRelativeTo({
            element: relativeElement,
            ePopup: popupEl,
            hidePopup: popup.hideFunc
        });
        popup.stopAnchoringPromise = destroyPositionTracker;
        popup.isAnchored = true;
        return destroyPositionTracker;
    }
    removePopupFromPopupList(element, ariaOwns) {
        this.setAlignedStyles(element, null);
        this.setPopupPositionRelatedToElement(element, null);
        if (ariaOwns) $437b23f6a393c3bf$var$_setAriaOwns(ariaOwns, null);
        this.popupList = this.popupList.filter((p)=>p.element !== element);
    }
    keepPopupPositionedRelativeTo(params) {
        const eParent = this.getPopupParent();
        const parentRect = eParent.getBoundingClientRect();
        const { element: element, ePopup: ePopup } = params;
        const sourceRect = element.getBoundingClientRect();
        const extractFromPixelValue = (pxSize)=>Number.parseInt(pxSize.substring(0, pxSize.length - 1), 10);
        const createPosition = (prop, direction)=>{
            const initialDiff = parentRect[prop] - sourceRect[prop];
            const initial = extractFromPixelValue(ePopup.style[prop]);
            return {
                initialDiff: initialDiff,
                lastDiff: initialDiff,
                initial: initial,
                last: initial,
                direction: direction
            };
        };
        const topPosition = createPosition("top", 0 /* Vertical */ );
        const leftPosition = createPosition("left", 1 /* Horizontal */ );
        const fwOverrides = this.beans.frameworkOverrides;
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            fwOverrides.wrapIncoming(()=>{
                $437b23f6a393c3bf$var$_wrapInterval(()=>{
                    const pRect = eParent.getBoundingClientRect();
                    const sRect = element.getBoundingClientRect();
                    const elementNotInDom = sRect.top == 0 && sRect.left == 0 && sRect.height == 0 && sRect.width == 0;
                    if (elementNotInDom) {
                        params.hidePopup();
                        return;
                    }
                    const calculateNewPosition = (position, prop)=>{
                        const current = extractFromPixelValue(ePopup.style[prop]);
                        if (position.last !== current) {
                            position.initial = current;
                            position.last = current;
                        }
                        const currentDiff = pRect[prop] - sRect[prop];
                        if (currentDiff != position.lastDiff) {
                            const newValue = this.keepXYWithinBounds(ePopup, position.initial + position.initialDiff - currentDiff, position.direction);
                            ePopup.style[prop] = `${newValue}px`;
                            position.last = newValue;
                        }
                        position.lastDiff = currentDiff;
                    };
                    calculateNewPosition(topPosition, "top");
                    calculateNewPosition(leftPosition, "left");
                }, 200).then((intervalId)=>{
                    const result = ()=>{
                        if (intervalId != null) window.clearInterval(intervalId);
                    };
                    resolve(result);
                });
            }, "popupPositioning");
        });
    }
    isEventFromCurrentPopup(params, target) {
        const { mouseEvent: mouseEvent, touchEvent: touchEvent } = params;
        const event = mouseEvent ? mouseEvent : touchEvent;
        if (!event) return false;
        const indexOfThisChild = this.getPopupIndex(target);
        if (indexOfThisChild === -1) return false;
        for(let i = indexOfThisChild; i < this.popupList.length; i++){
            const popup = this.popupList[i];
            if ($437b23f6a393c3bf$export$b5446458166e97b4(popup.element, event)) return true;
        }
        return this.isElementWithinCustomPopup(event.target);
    }
    isElementWithinCustomPopup(el) {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        while(el && el !== eDocument.body){
            if (el.classList.contains("ag-custom-component-popup") || el.parentElement === null) return true;
            el = el.parentElement;
        }
        return false;
    }
    getWrapper(ePopup) {
        while(!ePopup.classList.contains("ag-popup") && ePopup.parentElement)ePopup = ePopup.parentElement;
        return ePopup.classList.contains("ag-popup") ? ePopup : null;
    }
    setAlwaysOnTop(ePopup, alwaysOnTop) {
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper) return;
        eWrapper.classList.toggle("ag-always-on-top", !!alwaysOnTop);
        if (alwaysOnTop) this.bringPopupToFront(eWrapper);
    }
    /** @returns true if moved */ bringPopupToFront(ePopup) {
        const parent = this.getPopupParent();
        const popupList = Array.prototype.slice.call(parent.querySelectorAll(".ag-popup"));
        const popupLen = popupList.length;
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper || popupLen <= 1 || !parent.contains(ePopup)) return;
        const standardPopupList = [];
        const alwaysOnTopList = [];
        for (const popup of popupList){
            if (popup === eWrapper) continue;
            if (popup.classList.contains("ag-always-on-top")) alwaysOnTopList.push(popup);
            else standardPopupList.push(popup);
        }
        const innerElsScrollMap = [];
        const onTopLength = alwaysOnTopList.length;
        const isPopupAlwaysOnTop = eWrapper.classList.contains("ag-always-on-top");
        const shouldBeLast = isPopupAlwaysOnTop || !onTopLength;
        const targetList = shouldBeLast ? [
            ...standardPopupList,
            ...alwaysOnTopList,
            eWrapper
        ] : [
            ...standardPopupList,
            eWrapper,
            ...alwaysOnTopList
        ];
        for(let i = 0; i <= popupLen; i++){
            const currentPopup = targetList[i];
            if (popupList[i] === targetList[i] || currentPopup === eWrapper) continue;
            const innerEls = currentPopup.querySelectorAll("div");
            for (const el of innerEls)if (el.scrollTop !== 0) innerElsScrollMap.push([
                el,
                el.scrollTop
            ]);
            if (i === 0) parent.insertAdjacentElement("afterbegin", currentPopup);
            else targetList[i - 1].insertAdjacentElement("afterend", currentPopup);
        }
        while(innerElsScrollMap.length){
            const currentEl = innerElsScrollMap.pop();
            currentEl[0].scrollTop = currentEl[1];
        }
    }
    handleThemeChange(e) {
        if (e.themeChanged) {
            const environment = this.beans.environment;
            for (const popup of this.popupList)environment.applyThemeClasses(popup.wrapper);
        }
    }
};
// packages/ag-grid-community/src/agStack/tooltip/agTooltipComponent.ts
var $437b23f6a393c3bf$export$7347ac91f8ec5988 = class extends $437b23f6a393c3bf$export$acd471c9223f27ae {
    constructor(){
        super({
            tag: "div",
            cls: "ag-tooltip"
        });
    }
    // will need to type params
    init(params) {
        const { value: value } = params;
        const eGui = this.getGui();
        eGui.textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(value);
        const locationKebabCase = params.location.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
        eGui.classList.add(`ag-${locationKebabCase}-tooltip`);
    }
};
// packages/ag-grid-community/src/agStack/events/pointerCapture.ts
var $437b23f6a393c3bf$var$tryPointerCapture = (eElement, pointerId)=>{
    if (pointerId != null && eElement?.setPointerCapture) try {
        eElement.setPointerCapture(pointerId);
        return eElement.hasPointerCapture(pointerId);
    } catch  {}
    return false;
};
var $437b23f6a393c3bf$var$capturePointer = (eElement, mouseEvent)=>{
    if (typeof PointerEvent === "undefined" || !(mouseEvent instanceof PointerEvent)) return null;
    const pointerId = mouseEvent.pointerId;
    if (!$437b23f6a393c3bf$var$tryPointerCapture(eElement, pointerId)) return null;
    const capture = {
        eElement: eElement,
        pointerId: pointerId,
        onLost (pointerEvent) {
            $437b23f6a393c3bf$var$pointerLostHandler(capture, pointerEvent);
        }
    };
    eElement.addEventListener("lostpointercapture", capture.onLost);
    return capture;
};
var $437b23f6a393c3bf$var$releasePointerCapture = (capture)=>{
    if (!capture) return;
    $437b23f6a393c3bf$var$removeLostHandler(capture);
    const { eElement: eElement, pointerId: pointerId } = capture;
    if (!eElement) return;
    try {
        eElement.releasePointerCapture(pointerId);
    } catch  {}
    capture.eElement = null;
};
var $437b23f6a393c3bf$var$removeLostHandler = (capture)=>{
    const { eElement: eElement, onLost: onLost } = capture;
    if (eElement && onLost) {
        eElement.removeEventListener("lostpointercapture", onLost);
        capture.onLost = null;
    }
};
var $437b23f6a393c3bf$var$pointerLostHandler = (capture, pointerEvent)=>{
    $437b23f6a393c3bf$var$removeLostHandler(capture);
    const { eElement: eElement, pointerId: pointerId } = capture;
    if (eElement && pointerEvent.pointerId === pointerId) $437b23f6a393c3bf$var$tryPointerCapture(eElement, pointerId);
};
// packages/ag-grid-community/src/agStack/core/baseDragService.ts
var $437b23f6a393c3bf$var$activePointerDrags;
var $437b23f6a393c3bf$var$handledDragEvents;
var $437b23f6a393c3bf$var$PASSIVE_TRUE = {
    passive: true
};
var $437b23f6a393c3bf$var$PASSIVE_FALSE = {
    passive: false
};
var $437b23f6a393c3bf$var$addHandledDragEvent = (event)=>{
    if (!$437b23f6a393c3bf$var$handledDragEvents) $437b23f6a393c3bf$var$handledDragEvents = /* @__PURE__ */ new WeakSet();
    else if ($437b23f6a393c3bf$var$handledDragEvents.has(event)) return false;
    $437b23f6a393c3bf$var$handledDragEvents.add(event);
    return true;
};
var $437b23f6a393c3bf$export$746301531a60a666 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "dragSvc";
        this.dragging = false;
        this.drag = null;
        this.dragSources = [];
    }
    get startTarget() {
        return this.drag?.start.target ?? null;
    }
    /** True if there is at least one active pointer drag in any BaseDragService instance in the page */ isPointer() {
        return !!$437b23f6a393c3bf$var$activePointerDrags?.has($437b23f6a393c3bf$export$1911dd00c79744c0(this.beans));
    }
    hasPointerCapture() {
        const capture = this.drag?.pointerCapture;
        return !!(capture && this.beans.eRootDiv.hasPointerCapture?.(capture.pointerId));
    }
    destroy() {
        if (this.drag) this.cancelDrag();
        const dragSources = this.dragSources;
        for (const entry of dragSources)$437b23f6a393c3bf$var$destroyDragSourceEntry(entry);
        dragSources.length = 0;
        super.destroy();
    }
    removeDragSource(params) {
        const dragSources = this.dragSources;
        for(let i = 0, len = dragSources.length; i < len; ++i){
            const entry = dragSources[i];
            if (entry.params === params) {
                dragSources.splice(i, 1);
                $437b23f6a393c3bf$var$destroyDragSourceEntry(entry);
                break;
            }
        }
    }
    addDragSource(params) {
        if (!this.isAlive()) return;
        const { eElement: eElement, includeTouch: includeTouch } = params;
        const handlers = [];
        let oldTouchAction;
        if (includeTouch) {
            const style = eElement.style;
            if (style) {
                oldTouchAction = style.touchAction;
                style.touchAction = "none";
            }
        }
        const dragSource = {
            handlers: handlers,
            params: params,
            oldTouchAction: oldTouchAction
        };
        this.dragSources.push(dragSource);
        const pointerDownListener = (event)=>this.onPointerDown(params, event);
        const mouseListener = (event)=>this.onMouseDown(params, event);
        $437b23f6a393c3bf$var$addTempEventHandlers(handlers, [
            eElement,
            "pointerdown",
            pointerDownListener,
            $437b23f6a393c3bf$var$PASSIVE_FALSE
        ], [
            eElement,
            "mousedown",
            mouseListener
        ]);
        const suppressTouch = this.gos.get("suppressTouch");
        if (includeTouch && !suppressTouch) {
            const touchListener = (touchEvent)=>this.onTouchStart(params, touchEvent);
            $437b23f6a393c3bf$var$addTempEventHandlers(handlers, [
                eElement,
                "touchstart",
                touchListener,
                $437b23f6a393c3bf$var$PASSIVE_FALSE
            ]);
        }
    }
    cancelDrag(eElement) {
        const drag = this.drag;
        eElement ?? (eElement = drag?.eElement);
        if (eElement) this.eventSvc.dispatchEvent({
            type: "dragCancelled",
            target: eElement
        });
        drag?.params.onDragCancel?.();
        this.destroyDrag();
    }
    shouldPreventMouseEvent(mouseEvent) {
        const type = mouseEvent.type;
        const isMouseMove = type === "mousemove" || type === "pointermove";
        return isMouseMove && mouseEvent.cancelable && $437b23f6a393c3bf$var$_isEventFromThisInstance(this.beans, mouseEvent) && !$437b23f6a393c3bf$var$_isFocusableFormField($437b23f6a393c3bf$var$getEventTargetElement(mouseEvent));
    }
    initDrag(drag, ...handlers) {
        this.drag = drag;
        const beans = this.beans;
        const onScroll = (event)=>this.onScroll(event);
        const keydownEvent = (ev)=>this.onKeyDown(ev);
        const rootEl = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        $437b23f6a393c3bf$var$addTempEventHandlers(drag.handlers, [
            rootEl,
            "contextmenu",
            $437b23f6a393c3bf$var$preventEventDefault
        ], [
            rootEl,
            "keydown",
            keydownEvent
        ], [
            eDocument,
            "scroll",
            onScroll,
            {
                capture: true
            }
        ], [
            eDocument.defaultView || window,
            "scroll",
            onScroll
        ], ...handlers);
    }
    destroyDrag() {
        this.dragging = false;
        const drag = this.drag;
        if (drag) {
            const rootEl = drag.rootEl;
            if ($437b23f6a393c3bf$var$activePointerDrags?.get(rootEl) === drag) $437b23f6a393c3bf$var$activePointerDrags.delete(rootEl);
            this.drag = null;
            $437b23f6a393c3bf$var$releasePointerCapture(drag.pointerCapture);
            $437b23f6a393c3bf$var$clearTempEventHandlers(drag.handlers);
        }
    }
    // Pointer Events path (preferred when supported)
    onPointerDown(params, pointerEvent) {
        if (this.isPointer()) return;
        const beans = this.beans;
        if ($437b23f6a393c3bf$var$handledDragEvents?.has(pointerEvent)) return;
        const pointerType = pointerEvent.pointerType;
        if (pointerType === "touch") {
            if (beans.gos.get("suppressTouch") || !params.includeTouch) return;
            if (params.stopPropagationForTouch) pointerEvent.stopPropagation();
            if ($437b23f6a393c3bf$var$_isFocusableFormField($437b23f6a393c3bf$var$getEventTargetElement(pointerEvent))) return;
        }
        if (!pointerEvent.isPrimary) return;
        if (pointerType === "mouse" && pointerEvent.button !== 0) return;
        this.destroyDrag();
        const rootEl = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        const eElement = params.eElement;
        const pointerId = pointerEvent.pointerId;
        const pointerDrag = new $437b23f6a393c3bf$var$Dragging(rootEl, params, pointerEvent, pointerId);
        $437b23f6a393c3bf$var$activePointerDrags ?? ($437b23f6a393c3bf$var$activePointerDrags = /* @__PURE__ */ new WeakMap());
        $437b23f6a393c3bf$var$activePointerDrags.set(rootEl, pointerDrag);
        const onPointerMove = (ev)=>{
            if (ev.pointerId === pointerId) this.onMouseOrPointerMove(ev);
        };
        const onUp = (ev)=>{
            if (ev.pointerId === pointerId) this.onMouseOrPointerUp(ev);
        };
        const onCancel = (ev)=>{
            if (ev.pointerId === pointerId && $437b23f6a393c3bf$var$addHandledDragEvent(ev)) this.cancelDrag();
        };
        const dragPreventEventDefault = (e)=>this.draggingPreventDefault(e);
        this.initDrag(pointerDrag, [
            rootEl,
            "pointerup",
            onUp
        ], [
            rootEl,
            "pointercancel",
            onCancel
        ], [
            rootEl,
            "pointermove",
            onPointerMove,
            $437b23f6a393c3bf$var$PASSIVE_FALSE
        ], [
            rootEl,
            "touchmove",
            dragPreventEventDefault,
            $437b23f6a393c3bf$var$PASSIVE_FALSE
        ], [
            eElement,
            "mousemove",
            dragPreventEventDefault,
            $437b23f6a393c3bf$var$PASSIVE_FALSE
        ]);
        if (params.dragStartPixels === 0) this.onMouseOrPointerMove(pointerEvent);
        else $437b23f6a393c3bf$var$addHandledDragEvent(pointerEvent);
    }
    // gets called whenever mouse down on any drag source
    onTouchStart(params, touchEvent) {
        const suppressTouch = this.gos.get("suppressTouch");
        if (suppressTouch || !params.includeTouch) return;
        if (!$437b23f6a393c3bf$var$addHandledDragEvent(touchEvent)) return;
        if ($437b23f6a393c3bf$var$_isFocusableFormField($437b23f6a393c3bf$var$getEventTargetElement(touchEvent))) return;
        if (params.stopPropagationForTouch) touchEvent.stopPropagation();
        if (this.isPointer()) {
            if (this.dragging) $437b23f6a393c3bf$var$preventEventDefault(touchEvent);
            return;
        }
        this.destroyDrag();
        const beans = this.beans;
        const rootEl = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        const touchDrag = new $437b23f6a393c3bf$var$Dragging(rootEl, params, touchEvent.touches[0]);
        const touchMoveEvent = (e)=>this.onTouchMove(e);
        const touchEndEvent = (e)=>this.onTouchUp(e);
        const touchCancelEvent = (e)=>this.onTouchCancel(e);
        const dragPreventEventDefault = (e)=>this.draggingPreventDefault(e);
        const rootNode = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        const target = touchEvent.target ?? params.eElement;
        this.initDrag(touchDrag, [
            target,
            "touchmove",
            touchMoveEvent,
            $437b23f6a393c3bf$var$PASSIVE_TRUE
        ], [
            target,
            "touchend",
            touchEndEvent,
            $437b23f6a393c3bf$var$PASSIVE_TRUE
        ], [
            target,
            "touchcancel",
            touchCancelEvent,
            $437b23f6a393c3bf$var$PASSIVE_TRUE
        ], [
            rootNode,
            "touchmove",
            dragPreventEventDefault,
            $437b23f6a393c3bf$var$PASSIVE_FALSE
        ], [
            rootNode,
            "touchend",
            touchEndEvent,
            $437b23f6a393c3bf$var$PASSIVE_FALSE
        ], [
            rootNode,
            "touchcancel",
            touchCancelEvent,
            $437b23f6a393c3bf$var$PASSIVE_FALSE
        ]);
        if (params.dragStartPixels === 0) this.onMove(touchDrag.start);
    }
    /** preventEventDefault on the event while dragging only and if the event is cancellable */ draggingPreventDefault(e) {
        if (this.dragging) $437b23f6a393c3bf$var$preventEventDefault(e);
    }
    // gets called whenever mouse down on any drag source
    onMouseDown(params, mouseEvent) {
        if (mouseEvent.button !== 0) return;
        if ($437b23f6a393c3bf$var$handledDragEvents?.has(mouseEvent)) return;
        if (this.isPointer()) return;
        const beans = this.beans;
        this.destroyDrag();
        const mouseDrag = new $437b23f6a393c3bf$var$Dragging($437b23f6a393c3bf$export$1911dd00c79744c0(beans), params, mouseEvent);
        const mouseMoveEvent = (event)=>this.onMouseOrPointerMove(event);
        const mouseUpEvent = (event)=>this.onMouseOrPointerUp(event);
        const target = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        this.initDrag(mouseDrag, [
            target,
            "mousemove",
            mouseMoveEvent
        ], [
            target,
            "mouseup",
            mouseUpEvent
        ]);
        if (params.dragStartPixels === 0) this.onMouseOrPointerMove(mouseEvent);
        else $437b23f6a393c3bf$var$addHandledDragEvent(mouseEvent);
    }
    onScroll(event) {
        if (!$437b23f6a393c3bf$var$addHandledDragEvent(event)) return;
        const drag = this.drag;
        const lastDrag = drag?.lastDrag;
        if (lastDrag && this.dragging) drag.params?.onDragging?.(lastDrag);
    }
    /** only gets called after a mouse down - as this is only added after mouseDown and is removed when mouseUp happens */ onMouseOrPointerMove(mouseEvent) {
        if (!$437b23f6a393c3bf$var$addHandledDragEvent(mouseEvent)) return;
        if ($437b23f6a393c3bf$export$8caf403dacd36a68()) $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans).getSelection()?.removeAllRanges();
        if (this.shouldPreventMouseEvent(mouseEvent)) $437b23f6a393c3bf$var$preventEventDefault(mouseEvent);
        this.onMove(mouseEvent);
    }
    onTouchCancel(touchEvent) {
        const drag = this.drag;
        if (!drag || !$437b23f6a393c3bf$var$addHandledDragEvent(touchEvent)) return;
        if (!$437b23f6a393c3bf$var$_getFirstActiveTouch(drag.start, touchEvent.changedTouches)) return;
        this.cancelDrag();
    }
    onTouchMove(touchEvent) {
        const drag = this.drag;
        if (!drag || !$437b23f6a393c3bf$var$addHandledDragEvent(touchEvent)) return;
        const touch = $437b23f6a393c3bf$var$_getFirstActiveTouch(drag.start, touchEvent.touches);
        if (touch) {
            this.onMove(touch);
            this.draggingPreventDefault(touchEvent);
        }
    }
    onMove(currentEvent) {
        const drag = this.drag;
        if (!drag) return;
        drag.lastDrag = currentEvent;
        const dragSource = drag.params;
        if (!this.dragging) {
            const start = drag.start;
            const dragStartPixels = dragSource.dragStartPixels;
            const requiredPixelDiff = dragStartPixels ?? 4;
            if ($437b23f6a393c3bf$var$_areEventsNear(currentEvent, start, requiredPixelDiff)) return;
            this.dragging = true;
            if (dragSource.capturePointer) drag.pointerCapture = $437b23f6a393c3bf$var$capturePointer(this.beans.eRootDiv, currentEvent);
            this.eventSvc.dispatchEvent({
                type: "dragStarted",
                target: dragSource.eElement
            });
            dragSource.onDragStart?.(start);
            if (this.drag !== drag) return;
            dragSource.onDragging?.(start);
            if (this.drag !== drag) return;
        }
        dragSource.onDragging?.(currentEvent);
    }
    onTouchUp(touchEvent) {
        const drag = this.drag;
        if (drag && $437b23f6a393c3bf$var$addHandledDragEvent(touchEvent)) this.onUp($437b23f6a393c3bf$var$_getFirstActiveTouch(drag.start, touchEvent.changedTouches));
    }
    onMouseOrPointerUp(mouseEvent) {
        if ($437b23f6a393c3bf$var$addHandledDragEvent(mouseEvent)) this.onUp(mouseEvent);
    }
    onUp(eventOrTouch) {
        const drag = this.drag;
        if (!drag) return;
        if (!eventOrTouch) eventOrTouch = drag.lastDrag;
        if (eventOrTouch && this.dragging) {
            this.dragging = false;
            drag.params.onDragStop?.(eventOrTouch);
            this.eventSvc.dispatchEvent({
                type: "dragStopped",
                target: drag.params.eElement
            });
        }
        this.destroyDrag();
    }
    // shared keydown handler to cancel current drag with ESC
    onKeyDown(event) {
        if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE) this.cancelDrag();
    }
};
var $437b23f6a393c3bf$var$destroyDragSourceEntry = (dragSource)=>{
    $437b23f6a393c3bf$var$clearTempEventHandlers(dragSource.handlers);
    const oldTouchAction = dragSource.oldTouchAction;
    if (oldTouchAction != null) {
        const style = dragSource.params.eElement.style;
        if (style) style.touchAction = oldTouchAction;
    }
};
var $437b23f6a393c3bf$var$Dragging = class {
    constructor(rootEl, params, start, pointerId = null){
        this.rootEl = rootEl;
        this.params = params;
        this.start = start;
        this.pointerId = pointerId;
        this.handlers = [];
        this.lastDrag = null;
        this.pointerCapture = null;
        this.eElement = params.eElement;
    }
};
var $437b23f6a393c3bf$var$getEventTargetElement = (event)=>{
    const target = event.target;
    return target instanceof Element ? target : null;
};
// packages/ag-grid-community/src/agStack/core/baseDragAndDropService.ts
var $437b23f6a393c3bf$export$95d9806a07659825 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super(...arguments);
        this.beanName = "dragAndDrop";
        this.dragSourceAndParamsList = [];
        this.dragItem = null;
        this.dragInitialSourcePointerOffsetX = 0;
        this.dragInitialSourcePointerOffsetY = 0;
        this.lastMouseEvent = null;
        this.lastDraggingEvent = null;
        this.dragSource = null;
        this.dragImageCompPromise = null;
        this.dragImageComp = null;
        this.dragImageLastIcon = void 0;
        this.dragImageLastLabel = void 0;
        this.dropTargets = [];
        this.externalDropZoneCount = 0;
        this.lastDropTarget = null;
    }
    addDragSource(dragSource, allowTouch = false) {
        const entry = {
            capturePointer: true,
            dragSource: dragSource,
            eElement: dragSource.eElement,
            dragStartPixels: dragSource.dragStartPixels,
            onDragStart: (mouseEvent)=>this.onDragStart(dragSource, mouseEvent),
            onDragStop: this.onDragStop.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragCancel: this.onDragCancel.bind(this),
            includeTouch: allowTouch
        };
        this.dragSourceAndParamsList.push(entry);
        this.beans.dragSvc.addDragSource(entry);
    }
    setDragImageCompIcon(iconName, shake = false) {
        const component = this.dragImageComp;
        if (component && (shake || this.dragImageLastIcon !== iconName)) {
            this.dragImageLastIcon = iconName;
            component.setIcon(iconName, shake);
        }
    }
    removeDragSource(dragSource) {
        const { dragSourceAndParamsList: dragSourceAndParamsList, beans: beans } = this;
        for(let i = 0, len = dragSourceAndParamsList.length; i < len; i++)if (dragSourceAndParamsList[i].dragSource === dragSource) {
            const sourceAndParams = dragSourceAndParamsList[i];
            beans.dragSvc?.removeDragSource(sourceAndParams);
            dragSourceAndParamsList.splice(i, 1);
            break;
        }
    }
    destroy() {
        const { dragSourceAndParamsList: dragSourceAndParamsList, dropTargets: dropTargets, beans: beans } = this;
        const dragSvc = beans.dragSvc;
        for (const sourceAndParams of dragSourceAndParamsList)dragSvc?.removeDragSource(sourceAndParams);
        dragSourceAndParamsList.length = 0;
        dropTargets.length = 0;
        this.externalDropZoneCount = 0;
        this.clearDragAndDropProperties();
        super.destroy();
    }
    nudge() {
        const lastMouseEvent = this.lastMouseEvent;
        if (lastMouseEvent) this.onDragging(lastMouseEvent, true);
    }
    onDragStart(dragSource, mouseEvent) {
        this.lastMouseEvent = mouseEvent;
        this.dragSource = dragSource;
        this.dragItem = dragSource.getDragItem();
        const rect = dragSource.eElement.getBoundingClientRect();
        this.dragInitialSourcePointerOffsetX = mouseEvent.clientX - rect.left;
        this.dragInitialSourcePointerOffsetY = mouseEvent.clientY - rect.top;
        dragSource.onDragStarted?.();
        this.createAndUpdateDragImageComp(dragSource);
    }
    onDragStop(mouseEvent) {
        const { dragSource: dragSource, lastDropTarget: lastDropTarget } = this;
        dragSource?.onDragStopped?.();
        if (lastDropTarget) {
            const dragEndEvent = this.dropTargetEvent(lastDropTarget, mouseEvent, false);
            lastDropTarget.onDragStop?.(dragEndEvent);
        }
        this.clearDragAndDropProperties();
    }
    onDragCancel() {
        const { dragSource: dragSource, lastDropTarget: lastDropTarget, lastMouseEvent: lastMouseEvent } = this;
        dragSource?.onDragCancelled?.();
        if (lastDropTarget && lastMouseEvent) {
            const dragCancelEvent = this.dropTargetEvent(lastDropTarget, lastMouseEvent, false);
            lastDropTarget.onDragCancel?.(dragCancelEvent);
        }
        this.clearDragAndDropProperties();
    }
    onDragging(mouseEvent, fromNudge = false) {
        this.positionDragImageComp(mouseEvent);
        const dropTarget = this.findCurrentDropTarget(mouseEvent);
        const { lastDropTarget: lastDropTarget, dragSource: dragSource, dragItem: dragItem } = this;
        let needUpdate = false;
        if (dropTarget !== lastDropTarget) {
            needUpdate = true;
            if (lastDropTarget) {
                const dragLeaveEvent = this.dropTargetEvent(lastDropTarget, mouseEvent, fromNudge);
                lastDropTarget.onDragLeave?.(dragLeaveEvent);
            }
            if (lastDropTarget !== null && !dropTarget) this.handleExit(dragSource, dragItem);
            else if (lastDropTarget === null && dropTarget) this.handleEnter(dragSource, dragItem);
            if (dropTarget) {
                const dragEnterEvent = this.dropTargetEvent(dropTarget, mouseEvent, fromNudge);
                dropTarget.onDragEnter?.(dragEnterEvent);
            }
            this.lastDropTarget = dropTarget;
        } else if (dropTarget) {
            const dragMoveEvent = this.dropTargetEvent(dropTarget, mouseEvent, fromNudge);
            dropTarget.onDragging?.(dragMoveEvent);
            if (dragMoveEvent?.changed) needUpdate = true;
        }
        this.lastMouseEvent = mouseEvent;
        if (needUpdate) this.updateDragImageComp();
    }
    clearDragAndDropProperties() {
        this.removeDragImageComp(this.dragImageComp);
        this.dragImageCompPromise = null;
        this.dragImageLastIcon = void 0;
        this.dragImageLastLabel = void 0;
        this.lastMouseEvent = null;
        this.lastDraggingEvent = null;
        this.lastDropTarget = null;
        this.dragItem = null;
        this.dragInitialSourcePointerOffsetX = 0;
        this.dragInitialSourcePointerOffsetY = 0;
        this.dragSource = null;
    }
    getAllContainersFromDropTarget(dropTarget) {
        const primaryContainer = dropTarget.getContainer();
        const secondaryContainers = dropTarget.getSecondaryContainers?.();
        const secondaryContainersLen = secondaryContainers?.length;
        if (!secondaryContainersLen) return [
            [
                primaryContainer
            ]
        ];
        const containers = new Array(secondaryContainersLen + 1);
        containers[0] = [
            primaryContainer
        ];
        for(let i = 0; i < secondaryContainersLen; ++i)containers[i + 1] = secondaryContainers[i];
        return containers;
    }
    // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
    isMouseOnDropTarget(mouseEvent, dropTarget) {
        const allContainersFromDropTarget = this.getAllContainersFromDropTarget(dropTarget);
        let mouseOverTarget = false;
        const allContainersIntersect = (mouseEvent2, containers)=>{
            for (const container of containers){
                const { width: width, height: height, left: left, right: right, top: top, bottom: bottom } = container.getBoundingClientRect();
                if (width === 0 || height === 0) return false;
                const horizontalFit = mouseEvent2.clientX >= left && mouseEvent2.clientX < right;
                const verticalFit = mouseEvent2.clientY >= top && mouseEvent2.clientY < bottom;
                if (!horizontalFit || !verticalFit) return false;
            }
            return true;
        };
        for (const currentContainers of allContainersFromDropTarget)if (allContainersIntersect(mouseEvent, currentContainers)) {
            mouseOverTarget = true;
            break;
        }
        const { eElement: eElement, type: type } = this.dragSource;
        if (dropTarget.targetContainsSource && !dropTarget.getContainer().contains(eElement)) return false;
        return mouseOverTarget && dropTarget.isInterestedIn(type, eElement);
    }
    findCurrentDropTarget(mouseEvent) {
        const validDropTargets = [];
        const dropTargets = this.dropTargets;
        for(let i = 0, len2 = dropTargets.length; i < len2; ++i){
            const target = dropTargets[i];
            if (this.isMouseOnDropTarget(mouseEvent, target)) validDropTargets.push(target);
        }
        const len = validDropTargets.length;
        if (len === 0) return null;
        if (len === 1) return validDropTargets[0];
        const rootNode = $437b23f6a393c3bf$export$1911dd00c79744c0(this.beans);
        const elementStack = rootNode.elementsFromPoint(mouseEvent.clientX, mouseEvent.clientY);
        for(let i = 0, stackLen = elementStack.length; i < stackLen; ++i){
            const el = elementStack[i];
            for(let targetIndex = 0, targetsLen = validDropTargets.length; targetIndex < targetsLen; targetIndex++){
                const dropTarget = validDropTargets[targetIndex];
                const containerGroups = this.getAllContainersFromDropTarget(dropTarget);
                let matched = false;
                for(let groupIdx = 0, groupLen = containerGroups.length; groupIdx < groupLen && !matched; groupIdx++){
                    const group = containerGroups[groupIdx];
                    for(let elIdx = 0, elLen = group.length; elIdx < elLen; elIdx++)if (group[elIdx] === el) {
                        matched = true;
                        break;
                    }
                }
                if (matched) return dropTarget;
            }
        }
        return null;
    }
    addDropTarget(dropTarget) {
        this.dropTargets.push(dropTarget);
        if (dropTarget.external) this.externalDropZoneCount++;
    }
    removeDropTarget(dropTarget) {
        const container = dropTarget.getContainer();
        const dropTargets = this.dropTargets;
        let writeIndex = 0;
        for(let readIndex = 0, len = dropTargets.length; readIndex < len; ++readIndex){
            const target = dropTargets[readIndex];
            if (target.getContainer() === container) {
                if (target.external) --this.externalDropZoneCount;
                continue;
            }
            if (writeIndex !== readIndex) dropTargets[writeIndex] = target;
            ++writeIndex;
        }
        dropTargets.length = writeIndex;
    }
    hasExternalDropZones() {
        return this.externalDropZoneCount > 0;
    }
    findExternalZone(container) {
        const dropTargets = this.dropTargets;
        for(let i = 0, len = dropTargets.length; i < len; ++i){
            const zone = dropTargets[i];
            if (zone.external && zone.getContainer() === container) return zone;
        }
        return null;
    }
    dropTargetEvent(dropTarget, mouseEvent, fromNudge) {
        const { dragSource: dragSource, dragItem: dragItem, lastDraggingEvent: lastDraggingEvent, lastMouseEvent: lastMouseEvent, dragInitialSourcePointerOffsetX: dragInitialSourcePointerOffsetX, dragInitialSourcePointerOffsetY: dragInitialSourcePointerOffsetY } = this;
        const dropZoneTarget = dropTarget.getContainer();
        const rect = dropZoneTarget.getBoundingClientRect();
        const { clientX: clientX, clientY: clientY } = mouseEvent;
        const xDir = clientX - (lastMouseEvent?.clientX || 0);
        const yDir = clientY - (lastMouseEvent?.clientY || 0);
        const draggingEvent = this.createEvent({
            event: mouseEvent,
            x: clientX - rect.left,
            // relative x
            y: clientY - rect.top,
            // relative y
            vDirection: yDir > 0 ? "down" : yDir < 0 ? "up" : null,
            hDirection: xDir < 0 ? "left" : xDir > 0 ? "right" : null,
            initialSourcePointerOffsetX: dragInitialSourcePointerOffsetX,
            initialSourcePointerOffsetY: dragInitialSourcePointerOffsetY,
            dragSource: dragSource,
            fromNudge: fromNudge,
            dragItem: dragItem,
            dropZoneTarget: dropZoneTarget,
            dropTarget: lastDraggingEvent?.dropTarget ?? null,
            // updated by rowDragFeature
            changed: !!lastDraggingEvent?.changed
        });
        this.lastDraggingEvent = draggingEvent;
        return draggingEvent;
    }
    positionDragImageComp(event) {
        const gui = this.dragImageComp?.getGui();
        if (gui) $437b23f6a393c3bf$export$3ce6b987cf48b8c2(gui, event, this.beans);
    }
    removeDragImageComp(comp) {
        if (this.dragImageComp === comp) this.dragImageComp = null;
        if (comp) {
            comp.getGui()?.remove();
            this.destroyBean(comp);
        }
    }
    createAndUpdateDragImageComp(dragSource) {
        const promise = this.createDragImageComp(dragSource) ?? null;
        this.dragImageCompPromise = promise;
        promise?.then((dragImageComp)=>{
            if (promise !== this.dragImageCompPromise || !this.lastMouseEvent || !this.isAlive()) {
                this.destroyBean(dragImageComp);
                return;
            }
            this.dragImageCompPromise = null;
            this.dragImageLastIcon = void 0;
            this.dragImageLastLabel = void 0;
            const oldDragImageComp = this.dragImageComp;
            if (oldDragImageComp !== dragImageComp) {
                this.dragImageComp = dragImageComp;
                this.removeDragImageComp(oldDragImageComp);
            }
            if (dragImageComp) {
                this.appendDragImageComp(dragImageComp);
                this.updateDragImageComp();
            }
        });
    }
    appendDragImageComp(component) {
        const eGui = component.getGui();
        const style = eGui.style;
        style.position = "absolute";
        style.zIndex = "9999";
        if (this.beans.dragSvc?.hasPointerCapture()) style.pointerEvents = "none";
        this.gos.setInstanceDomData(eGui);
        this.beans.environment.applyThemeClasses(eGui);
        style.top = "20px";
        style.left = "20px";
        const targetEl = $437b23f6a393c3bf$export$50c54e860701cf22(this.beans);
        if (!targetEl) this.warnNoBody();
        else targetEl.appendChild(eGui);
    }
    updateDragImageComp() {
        const { dragImageComp: dragImageComp, dragSource: dragSource, lastDropTarget: lastDropTarget, lastDraggingEvent: lastDraggingEvent, dragImageLastLabel: dragImageLastLabel } = this;
        if (!dragImageComp) return;
        this.setDragImageCompIcon(lastDropTarget?.getIconName?.(lastDraggingEvent) ?? null);
        let label = dragSource?.dragItemName;
        if (typeof label === "function") label = label(lastDraggingEvent);
        label || (label = "");
        if (dragImageLastLabel !== label) {
            this.dragImageLastLabel = label;
            dragImageComp.setLabel(label);
        }
    }
};
// packages/ag-grid-community/src/agStack/focus/agTabGuardFeature.ts
var $437b23f6a393c3bf$export$63dba2ace36fd065 = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(comp, stopPropagationCallbacks){
        super();
        this.comp = comp;
        this.stopPropagationCallbacks = stopPropagationCallbacks;
    }
    initialiseTabGuard(params) {
        this.eTopGuard = this.createTabGuard("top");
        this.eBottomGuard = this.createTabGuard("bottom");
        this.eFocusableElement = this.comp.getFocusableElement();
        const { eTopGuard: eTopGuard, eBottomGuard: eBottomGuard, eFocusableElement: eFocusableElement, stopPropagationCallbacks: stopPropagationCallbacks } = this;
        const tabGuards = [
            eTopGuard,
            eBottomGuard
        ];
        const compProxy = {
            setTabIndex: (tabIndex)=>{
                for (const tabGuard of tabGuards)tabIndex == null ? tabGuard.removeAttribute("tabindex") : tabGuard.setAttribute("tabindex", tabIndex);
            }
        };
        this.addTabGuards(eTopGuard, eBottomGuard);
        const { focusTrapActive: focusTrapActive = false, onFocusIn: onFocusIn, onFocusOut: onFocusOut, focusInnerElement: focusInnerElement, handleKeyDown: handleKeyDown, onTabKeyDown: onTabKeyDown, shouldStopEventPropagation: shouldStopEventPropagation, isEmpty: isEmpty, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty, isFocusableContainer: isFocusableContainer } = params;
        this.tabGuardCtrl = this.createManagedBean(new $437b23f6a393c3bf$var$AgTabGuardCtrl({
            comp: compProxy,
            focusTrapActive: focusTrapActive,
            eTopGuard: eTopGuard,
            eBottomGuard: eBottomGuard,
            eFocusableElement: eFocusableElement,
            onFocusIn: onFocusIn,
            onFocusOut: onFocusOut,
            focusInnerElement: focusInnerElement,
            handleKeyDown: handleKeyDown,
            onTabKeyDown: onTabKeyDown,
            shouldStopEventPropagation: shouldStopEventPropagation,
            isEmpty: isEmpty,
            forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty,
            isFocusableContainer: isFocusableContainer
        }, stopPropagationCallbacks));
    }
    getTabGuardCtrl() {
        return this.tabGuardCtrl;
    }
    createTabGuard(side) {
        const tabGuard = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans).createElement("div");
        const cls = side === "top" ? $437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD_TOP : $437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD_BOTTOM;
        tabGuard.classList.add($437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD, cls);
        $437b23f6a393c3bf$export$f8d01fa01787902(tabGuard, "presentation");
        return tabGuard;
    }
    addTabGuards(topTabGuard, bottomTabGuard) {
        const eFocusableElement = this.eFocusableElement;
        eFocusableElement.prepend(topTabGuard);
        eFocusableElement.append(bottomTabGuard);
    }
    removeAllChildrenExceptTabGuards() {
        const tabGuards = [
            this.eTopGuard,
            this.eBottomGuard
        ];
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.comp.getFocusableElement());
        this.addTabGuards(...tabGuards);
    }
    forceFocusOutOfContainer(up = false) {
        this.tabGuardCtrl.forceFocusOutOfContainer(up);
    }
    appendChild(appendChild, newChild, container) {
        if (!$437b23f6a393c3bf$export$6e6303ef478b0c94(newChild)) newChild = newChild.getGui();
        const { eBottomGuard: bottomTabGuard } = this;
        if (bottomTabGuard) bottomTabGuard.before(newChild);
        else appendChild(newChild, container);
    }
    destroy() {
        const { eTopGuard: eTopGuard, eBottomGuard: eBottomGuard } = this;
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(eTopGuard);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(eBottomGuard);
        super.destroy();
    }
};
// packages/ag-grid-community/src/agStack/focus/agTabGuardComp.ts
var $437b23f6a393c3bf$export$d62d00723c2ea1b5 = class extends $437b23f6a393c3bf$export$e6818678a6454cbe {
    initialiseTabGuard(params, stopPropagationCallbacks) {
        this.tabGuardFeature = this.createManagedBean(new $437b23f6a393c3bf$export$63dba2ace36fd065(this, stopPropagationCallbacks));
        this.tabGuardFeature.initialiseTabGuard(params);
    }
    forceFocusOutOfContainer(up = false) {
        this.tabGuardFeature.forceFocusOutOfContainer(up);
    }
    appendChild(newChild, container) {
        this.tabGuardFeature.appendChild(super.appendChild.bind(this), newChild, container);
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragAndDropService.ts
var $437b23f6a393c3bf$export$46ba5a92125911d9 = /* @__PURE__ */ ((DragSourceType2)=>{
    DragSourceType2[DragSourceType2["ToolPanel"] = 0] = "ToolPanel";
    DragSourceType2[DragSourceType2["HeaderCell"] = 1] = "HeaderCell";
    DragSourceType2[DragSourceType2["RowDrag"] = 2] = "RowDrag";
    DragSourceType2[DragSourceType2["ChartPanel"] = 3] = "ChartPanel";
    DragSourceType2[DragSourceType2["AdvancedFilterBuilder"] = 4] = "AdvancedFilterBuilder";
    return DragSourceType2;
})($437b23f6a393c3bf$export$46ba5a92125911d9 || {});
var $437b23f6a393c3bf$var$DragAndDropService = class extends $437b23f6a393c3bf$export$95d9806a07659825 {
    createEvent(event) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, event);
    }
    createDragImageComp(dragSource) {
        const { gos: gos, beans: beans } = this;
        const userCompDetails = $437b23f6a393c3bf$var$_getDragAndDropImageCompDetails(beans.userCompFactory, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            dragSource: dragSource
        }));
        return userCompDetails?.newAgStackInstance();
    }
    handleEnter(dragSource, dragItem) {
        dragSource?.onGridEnter?.(dragItem);
    }
    handleExit(dragSource, dragItem) {
        dragSource?.onGridExit?.(dragItem);
    }
    warnNoBody() {
        $437b23f6a393c3bf$export$545083624300f13d(54);
    }
    isDropZoneWithinThisGrid(draggingEvent) {
        return this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody.contains(draggingEvent.dropZoneTarget);
    }
    registerGridDropTarget(elementFn, ctrl) {
        const dropTarget = {
            getContainer: elementFn,
            isInterestedIn: (type)=>type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */ ,
            getIconName: ()=>"notAllowed"
        };
        this.addDropTarget(dropTarget);
        ctrl.addDestroyFunc(()=>this.removeDropTarget(dropTarget));
    }
};
// packages/ag-grid-community/src/entities/agColumnGroup.ts
function $437b23f6a393c3bf$var$createUniqueColumnGroupId(groupId, instanceId) {
    return groupId + "_" + instanceId;
}
function $437b23f6a393c3bf$export$1f44a60fc23f9028(col) {
    return col instanceof $437b23f6a393c3bf$export$273c80940a54c770;
}
var $437b23f6a393c3bf$export$273c80940a54c770 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(providedColumnGroup, groupId, partId, pinned){
        super();
        this.providedColumnGroup = providedColumnGroup;
        this.groupId = groupId;
        this.partId = partId;
        this.pinned = pinned;
        this.isColumn = false;
        // depends on the open/closed state of the group, only displaying columns are stored here
        this.displayedChildren = [];
        // The measured height of this column's header when autoHeaderHeight is enabled
        this.autoHeaderHeight = null;
        this.parent = null;
        this.colIdSanitised = $437b23f6a393c3bf$export$3df06b741968da82(this.getUniqueId());
    }
    // as the user is adding and removing columns, the groups are recalculated.
    // this reset clears out all children, ready for children to be added again
    reset() {
        this.parent = null;
        this.children = null;
        this.displayedChildren = null;
    }
    getParent() {
        return this.parent;
    }
    getUniqueId() {
        return $437b23f6a393c3bf$var$createUniqueColumnGroupId(this.groupId, this.partId);
    }
    isEmptyGroup() {
        return this.displayedChildren.length === 0;
    }
    isMoving() {
        const allLeafColumns = this.getProvidedColumnGroup().getLeafColumns();
        if (!allLeafColumns || allLeafColumns.length === 0) return false;
        return allLeafColumns.every((col)=>col.isMoving());
    }
    checkLeft() {
        for (const child of this.displayedChildren)if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.checkLeft();
        if (this.displayedChildren.length > 0) {
            if (this.gos.get("enableRtl")) {
                const lastChild = $437b23f6a393c3bf$export$236389741107357f(this.displayedChildren);
                const lastChildLeft = lastChild.getLeft();
                this.setLeft(lastChildLeft);
            } else {
                const firstChildLeft = this.displayedChildren[0].getLeft();
                this.setLeft(firstChildLeft);
            }
        } else this.setLeft(null);
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    setLeft(left) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.dispatchLocalEvent({
                type: "leftChanged"
            });
        }
    }
    getPinned() {
        return this.pinned;
    }
    getGroupId() {
        return this.groupId;
    }
    getPartId() {
        return this.partId;
    }
    getActualWidth() {
        let groupActualWidth = 0;
        for (const child of this.displayedChildren ?? [])groupActualWidth += child.getActualWidth();
        return groupActualWidth;
    }
    isResizable() {
        if (!this.displayedChildren) return false;
        let result = false;
        for (const child of this.displayedChildren)if (child.isResizable()) result = true;
        return result;
    }
    getMinWidth() {
        let result = 0;
        for (const groupChild of this.displayedChildren)result += groupChild.getMinWidth();
        return result;
    }
    addChild(child) {
        if (!this.children) this.children = [];
        this.children.push(child);
    }
    getDisplayedChildren() {
        return this.displayedChildren;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    getDisplayedLeafColumns() {
        const result = [];
        this.addDisplayedLeafColumns(result);
        return result;
    }
    getDefinition() {
        return this.providedColumnGroup.getColGroupDef();
    }
    getColGroupDef() {
        return this.providedColumnGroup.getColGroupDef();
    }
    isPadding() {
        return this.providedColumnGroup.isPadding();
    }
    isExpandable() {
        return this.providedColumnGroup.isExpandable();
    }
    isExpanded() {
        return this.providedColumnGroup.isExpanded();
    }
    setExpanded(expanded) {
        this.providedColumnGroup.setExpanded(expanded);
    }
    isAutoHeaderHeight() {
        return !!this.getColGroupDef()?.autoHeaderHeight;
    }
    getAutoHeaderHeight() {
        return this.autoHeaderHeight;
    }
    /** Returns true if the header height has changed */ setAutoHeaderHeight(height) {
        const changed = height !== this.autoHeaderHeight;
        this.autoHeaderHeight = height;
        return changed;
    }
    addDisplayedLeafColumns(leafColumns) {
        for (const child of this.displayedChildren ?? []){
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.addDisplayedLeafColumns(leafColumns);
        }
    }
    addLeafColumns(leafColumns) {
        for (const child of this.children ?? []){
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.addLeafColumns(leafColumns);
        }
    }
    getChildren() {
        return this.children;
    }
    getColumnGroupShow() {
        return this.providedColumnGroup.getColumnGroupShow();
    }
    getProvidedColumnGroup() {
        return this.providedColumnGroup;
    }
    getPaddingLevel() {
        const parent = this.getParent();
        if (!this.isPadding() || !parent?.isPadding()) return 0;
        return 1 + parent.getPaddingLevel();
    }
    calculateDisplayedColumns() {
        this.displayedChildren = [];
        let parentWithExpansion = this;
        while(parentWithExpansion?.isPadding())parentWithExpansion = parentWithExpansion.getParent();
        const isExpandable = parentWithExpansion ? parentWithExpansion.getProvidedColumnGroup().isExpandable() : false;
        if (!isExpandable) {
            this.displayedChildren = this.children;
            this.dispatchLocalEvent({
                type: "displayedChildrenChanged"
            });
            return;
        }
        for (const child of this.children ?? []){
            const emptyGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(child) && !child.displayedChildren?.length;
            if (emptyGroup) continue;
            const headerGroupShow = child.getColumnGroupShow();
            switch(headerGroupShow){
                case "open":
                    if (parentWithExpansion.getProvidedColumnGroup().isExpanded()) this.displayedChildren.push(child);
                    break;
                case "closed":
                    if (!parentWithExpansion.getProvidedColumnGroup().isExpanded()) this.displayedChildren.push(child);
                    break;
                default:
                    this.displayedChildren.push(child);
                    break;
            }
        }
        this.dispatchLocalEvent({
            type: "displayedChildrenChanged"
        });
    }
};
// packages/ag-grid-community/src/entities/rowNode.ts
var $437b23f6a393c3bf$export$cb038fdaa8338d9f = "row-group-";
var $437b23f6a393c3bf$export$27b0e4a919abc336 = "t-";
var $437b23f6a393c3bf$export$5f755686e611c1ea = "b-";
var $437b23f6a393c3bf$var$OBJECT_ID_SEQUENCE = 0;
var $437b23f6a393c3bf$export$6af91cd58ec2edf9 = class {
    constructor(beans){
        /** Unique ID for the node. Either provided by the application, or generated by the grid if not. */ this.id = void 0;
        /**
     * Indicates whether this row node has been removed from the grid.
     * A row node is considered removed if it is no longer part of the row model.
     * A removed row model instance will never be reused even if the same data item is added back to the grid.
     */ this.destroyed = false;
        /**
     * Backing field for groupData property.
     * If re-naming this property, you must also update `IGNORED_SIBLING_PROPERTIES`
     */ this._groupData = void 0;
        /** `true` if this row is a master row, part of master / detail (ie row can be expanded to show detail) */ this.master = false;
        /** `true` if this row is a detail row, part of master / detail (ie child row of an expanded master row)*/ this.detail = void 0;
        /** The current row index. If the row is filtered out or in a collapsed group, this value is set to `null`. */ this.rowIndex = null;
        /** The field we are grouping on eg 'country'. */ this.field = null;
        /** The row group column used for this group, e.g. the Country column instance. */ this.rowGroupColumn = null;
        /** The key for the group eg Ireland, UK, USA */ this.key = null;
        /**
     * CSRM only - The index of the row in the source rowData array including any updates via transactions.
     * It does not change when sorting, filtering, grouping, pivoting or any other UI related operations.
     * If this is a filler node (a visual row created by AG Grid in tree data or grouping) the value is set to `-1`.
     */ this.sourceRowIndex = -1;
        /**
     * CSRM only - all lowest level nodes beneath this node, no groups. Backing field for allLeafChildren property.
     * - undefined if not yet loaded.
     * - null if there are no no leaf children.
     * - not empty array containing all the leaf children.
     * If re-naming this property, you must also update `IGNORED_SIBLING_PROPERTIES`
     */ this._leafs = void 0;
        /** Children mapped by the pivot columns or group key */ this.childrenMapped = null;
        /**
     * Parent RowNode for tree data.
     * When set, the parent node in the hierarchy is updated during Client-Side Row Model (CSRM) grouping.
     * Used by the ClientSideChildrenTreeNodeManager, TreeGroupStrategy, RowDragFeature
     * If re-naming this property, you must also update `IGNORED_SIBLING_PROPERTIES`
     */ this.treeParent = null;
        /**
     * The flags associated to this node. Used only internally within TreeGroupStrategy.
     * If re-naming this property, you must also update `IGNORED_SIBLING_PROPERTIES`
     */ this.treeNodeFlags = 0;
        /**
     * This is `true` if the row has a rowIndex assigned, otherwise `false`.
     */ this.displayed = false;
        /** The row top position in pixels. */ this.rowTop = null;
        /** The top pixel for this row last time, makes sense if data set was ordered or filtered,
     * it is used so new rows can animate in from their old position. */ this.oldRowTop = null;
        /** `true` by default - can be overridden via gridOptions.isRowSelectable(rowNode) */ this.selectable = true;
        /**
     * Used by sorting service - to give deterministic sort to groups. Previously we
     * just id for this, however id is a string and had slower sorting compared to numbers.
     * If re-naming this property, you must also update `IGNORED_SIBLING_PROPERTIES`
     */ this.__objectId = $437b23f6a393c3bf$var$OBJECT_ID_SEQUENCE++;
        /** `true` when nodes with the same id are being removed and added as part of the same batch transaction */ this.alreadyRendered = false;
        this.formulaRowIndex = null;
        this.hovered = false;
        this.__selected = false;
        this.beans = beans;
    }
    /**
   * If using row grouping, contains the group values for this group.
   * When using CSRM, this field is lazily loaded via the GroupStage when required.
   */ get groupData() {
        const groupData = this._groupData;
        if (groupData !== void 0) return groupData;
        if (this.footer) return this.sibling?.groupData;
        return this.beans.groupStage?.loadGroupData(this) ?? null;
    }
    set groupData(value) {
        this._groupData = value;
    }
    /** CSRM only - do not use this property internally, this is exposed to the end user only. Use `_leafs` instead. */ get allLeafChildren() {
        const leafs = this._leafs;
        return leafs === void 0 ? this.beans.groupStage?.loadLeafs?.(this) ?? null : leafs;
    }
    set allLeafChildren(value) {
        this._leafs = value;
    }
    /**
   * Replaces the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */ setData(data) {
        this.setDataCommon(data, false);
    }
    // similar to setRowData, however it is expected that the data is the same data item. this
    // is intended to be used with Redux type stores, where the whole data can be changed. we are
    // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
    // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
    // dataChanged event, refreshes the cells rather than rip them all out (so user can show transitions).
    /**
   * Updates the data on the `rowNode`. When this method is called, the grid refreshes the entire rendered row if it is displayed.
   */ updateData(data) {
        this.setDataCommon(data, true);
    }
    setDataCommon(data, update) {
        const { valueCache: valueCache, eventSvc: eventSvc } = this.beans;
        const oldData = this.data;
        this.data = data;
        valueCache?.onDataChanged();
        this.updateDataOnDetailNode();
        this.resetQuickFilterAggregateText();
        const event = this.createDataChangedEvent(data, oldData, update);
        this.__localEventService?.dispatchEvent(event);
        if (this.sibling) {
            this.sibling.data = data;
            const event2 = this.sibling.createDataChangedEvent(data, oldData, update);
            this.sibling.__localEventService?.dispatchEvent(event2);
        }
        eventSvc.dispatchEvent({
            type: "rowNodeDataChanged",
            node: this
        });
        const pinnedSibling = this.pinnedSibling;
        if (pinnedSibling) {
            pinnedSibling.data = data;
            pinnedSibling.__localEventService?.dispatchEvent(pinnedSibling.createDataChangedEvent(data, oldData, update));
            eventSvc.dispatchEvent({
                type: "rowNodeDataChanged",
                node: pinnedSibling
            });
        }
    }
    // when we are doing master / detail, the detail node is lazy created, but then kept around.
    // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
    // in sync, otherwise expand/collapse of the detail would still show the old values.
    updateDataOnDetailNode() {
        const detailNode = this.detailNode;
        if (detailNode) detailNode.data = this.data;
    }
    createDataChangedEvent(newData, oldData, update) {
        return {
            type: "dataChanged",
            node: this,
            oldData: oldData,
            newData: newData,
            update: update
        };
    }
    getRowIndexString() {
        if (this.rowIndex == null) {
            $437b23f6a393c3bf$export$a20c7248650823a9(13);
            return null;
        }
        if (this.rowPinned === "top") return $437b23f6a393c3bf$export$27b0e4a919abc336 + this.rowIndex;
        if (this.rowPinned === "bottom") return $437b23f6a393c3bf$export$5f755686e611c1ea + this.rowIndex;
        return this.rowIndex.toString();
    }
    setDataAndId(data, id) {
        const { selectionSvc: selectionSvc } = this.beans;
        const oldNode = selectionSvc?.createDaemonNode?.(this);
        const oldData = this.data;
        this.data = data;
        this.updateDataOnDetailNode();
        this.setId(id);
        if (selectionSvc) {
            selectionSvc.updateRowSelectable(this);
            selectionSvc.syncInRowNode(this, oldNode);
        }
        const event = this.createDataChangedEvent(data, oldData, false);
        this.__localEventService?.dispatchEvent(event);
    }
    setId(id) {
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.beans.gos);
        if (getRowIdFunc) {
            if (this.data) {
                const parentKeys = this.parent?.getRoute() ?? [];
                this.id = getRowIdFunc({
                    data: this.data,
                    parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
                    level: this.level,
                    rowPinned: this.rowPinned
                });
                if (this.id.startsWith($437b23f6a393c3bf$export$cb038fdaa8338d9f)) $437b23f6a393c3bf$export$a20c7248650823a9(14, {
                    groupPrefix: $437b23f6a393c3bf$export$cb038fdaa8338d9f
                });
            } else this.id = void 0;
        } else this.id = id;
    }
    setRowTop(rowTop) {
        this.oldRowTop = this.rowTop;
        if (this.rowTop === rowTop) return;
        this.rowTop = rowTop;
        this.dispatchRowEvent("topChanged");
        const displayed = rowTop !== null;
        if (this.displayed !== displayed) {
            this.displayed = displayed;
            this.dispatchRowEvent("displayedChanged");
        }
    }
    clearRowTopAndRowIndex() {
        this.oldRowTop = null;
        this.setRowTop(null);
        this.setRowIndex(null);
    }
    setHovered(hovered) {
        this.hovered = hovered;
    }
    isHovered() {
        return this.hovered;
    }
    /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */ setRowHeight(rowHeight, estimated = false) {
        this.rowHeight = rowHeight;
        this.rowHeightEstimated = estimated;
        this.dispatchRowEvent("heightChanged");
    }
    setExpanded(expanded, e, forceSync) {
        this.beans.expansionSvc?.setExpanded(this, expanded, e, forceSync);
    }
    /**
   * Replaces the value on the `rowNode` for the specified column. When complete,
   * the grid refreshes the rendered cell on the required row only.
   * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
   * **Note**: This method defers to EditModule if available and batches the edit when `fullRow` or `batchEdit` is enabled.
   *
   * @param colKey The column where the value should be updated
   * @param newValue The new value
   * @param eventSource The source of the event
   * @returns `true` if the value was changed, otherwise `false`.
   */ setDataValue(colKey, newValue, eventSource) {
        const { colModel: colModel, valueSvc: valueSvc, gos: gos, editSvc: editSvc } = this.beans;
        const column = typeof colKey !== "string" ? colKey : colModel.getCol(colKey) ?? colModel.getColDefCol(colKey);
        if (!column) return false;
        const oldValue = valueSvc.getValueForDisplay({
            column: column,
            node: this,
            source: "api"
        }).value;
        if (gos.get("readOnlyEdit")) {
            const { beans: { eventSvc: eventSvc }, data: data, rowIndex: rowIndex, rowPinned: rowPinned } = this;
            eventSvc.dispatchEvent({
                type: "cellEditRequest",
                event: null,
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                column: column,
                colDef: column.colDef,
                data: data,
                node: this,
                oldValue: oldValue,
                newValue: newValue,
                value: newValue,
                source: eventSource
            });
            return false;
        }
        if (editSvc && !editSvc.committing) {
            const result = editSvc.setDataValue({
                rowNode: this,
                column: column
            }, newValue, eventSource);
            if (result != null) return result;
        }
        const valueChanged = valueSvc.setValue(this, column, newValue, eventSource);
        this.dispatchCellChangedEvent(column, newValue, oldValue);
        if (valueChanged) this.pinnedSibling?.dispatchCellChangedEvent(column, newValue, oldValue);
        return valueChanged;
    }
    updateHasChildren() {
        let newValue = this.group && !this.footer || !!this.childrenAfterGroup?.length;
        const { rowChildrenSvc: rowChildrenSvc } = this.beans;
        if (rowChildrenSvc) newValue = rowChildrenSvc.getHasChildrenValue(this);
        if (newValue !== this.__hasChildren) {
            this.__hasChildren = !!newValue;
            this.dispatchRowEvent("hasChildrenChanged");
        }
    }
    hasChildren() {
        if (this.__hasChildren == null) this.updateHasChildren();
        return this.__hasChildren;
    }
    dispatchCellChangedEvent(column, newValue, oldValue) {
        const cellChangedEvent = {
            type: "cellChanged",
            node: this,
            column: column,
            newValue: newValue,
            oldValue: oldValue
        };
        this.__localEventService?.dispatchEvent(cellChangedEvent);
    }
    /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However, if you edit without using grid editing, you need to clear this string down for the row to be updated with the new values.
   * Otherwise, new values would not work with the `quickFilter`. */ resetQuickFilterAggregateText() {
        this.quickFilterAggregateText = null;
    }
    /** Returns:
   * - `true` if the node can be expanded, i.e it is a group or master row.
   * - `false` if the node cannot be expanded
   */ isExpandable() {
        return this.beans.expansionSvc?.isExpandable(this) ?? false;
    }
    /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */ isSelected() {
        if (this.footer) return this.sibling.isSelected();
        const pinnedSibling = this.rowPinned && this.pinnedSibling;
        if (pinnedSibling) return pinnedSibling.isSelected();
        return this.__selected;
    }
    /** Perform a depth-first search of this node and its children. */ depthFirstSearch(callback) {
        const childrenAfterGroup = this.childrenAfterGroup;
        if (childrenAfterGroup) for(let i = 0, len = childrenAfterGroup.length; i < len; ++i)childrenAfterGroup[i].depthFirstSearch(callback);
        callback(this);
    }
    dispatchRowEvent(type) {
        this.__localEventService?.dispatchEvent({
            type: type,
            node: this
        });
    }
    /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` selects the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param source - Source property that appears in the `selectionChanged` event.
   */ setSelected(newValue, clearSelection = false, source = "api") {
        this.beans.selectionSvc?.setNodesSelected({
            nodes: [
                this
            ],
            newValue: newValue,
            clearSelection: clearSelection,
            source: source
        });
    }
    /**
   * Returns:
   * - `true` if node is either pinned to the `top` or `bottom`
   * - `false` if the node isn't pinned
   */ isRowPinned() {
        return !!this.rowPinned;
    }
    __addEventListener(eventType, listener) {
        const localEventService = this.__localEventService ?? (this.__localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc());
        localEventService.addEventListener(eventType, listener);
    }
    __removeEventListener(eventType, listener) {
        this.removeLocalListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ addEventListener(eventType, userListener) {
        this.beans.validation?.checkRowEvents(eventType);
        const localEventService = this.__localEventService ?? (this.__localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc());
        this.frameworkEventListenerService = this.beans.frameworkOverrides.createLocalEventListenerWrapper?.(this.frameworkEventListenerService, localEventService);
        const listener = this.frameworkEventListenerService?.wrap(eventType, userListener) ?? userListener;
        localEventService.addEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ removeEventListener(eventType, userListener) {
        const listener = this.frameworkEventListenerService?.unwrap(eventType, userListener) ?? userListener;
        this.removeLocalListener(eventType, listener);
    }
    removeLocalListener(eventType, listener) {
        const localEventService = this.__localEventService;
        if (localEventService) {
            localEventService.removeEventListener(eventType, listener);
            if (localEventService.noRegisteredListenersExist()) this.__localEventService = null;
        }
    }
    /**
   * @deprecated v32.2.0 Check `node.detail` then user provided callback `isFullWidthRow` instead.
   *
   * Returns:
   * - `true` if the node is a full width cell
   * - `false` if the node is not a full width cell
   */ isFullWidthCell() {
        $437b23f6a393c3bf$export$545083624300f13d(61);
        if (this.detail) return true;
        const isFullWidthCellFunc = this.beans.gos.getCallback("isFullWidthRow");
        return isFullWidthCellFunc ? isFullWidthCellFunc({
            rowNode: this
        }) : false;
    }
    /**
   * Returns the route of keys to the row node. Returns undefined if the node has no key.
   */ getRoute() {
        if (this.level === -1) return [];
        if (this.key == null) return void 0;
        const res = [];
        let pointer = this;
        while(pointer?.key != null){
            res.push(pointer.key);
            pointer = pointer.parent;
        }
        return res.reverse();
    }
    setRowIndex(rowIndex) {
        if (this.rowIndex !== rowIndex) {
            this.rowIndex = rowIndex;
            this.dispatchRowEvent("rowIndexChanged");
        }
    }
    setAllChildrenCount(allChildrenCount) {
        if (this.allChildrenCount !== allChildrenCount) {
            this.allChildrenCount = allChildrenCount;
            this.dispatchRowEvent("allChildrenCountChanged");
        }
    }
    setUiLevel(uiLevel) {
        if (this.uiLevel !== uiLevel) {
            this.uiLevel = uiLevel;
            this.dispatchRowEvent("uiLevelChanged");
        }
    }
    getFirstChild() {
        const childStore = this.childStore;
        if (childStore) return childStore.getFirstNode();
        return this.childrenAfterSort?.[0] ?? null;
    }
    /** Called internally to destroy this node */ _destroy(fadeOut) {
        if (this.destroyed) return false;
        this.destroyed = true;
        if (fadeOut) this.clearRowTopAndRowIndex();
        else {
            this.setRowTop(null);
            this.setRowIndex(null);
        }
        if (!this.footer) {
            const detailNode = this.detailNode;
            if (detailNode) detailNode._destroy(fadeOut);
            const sibling = this.sibling;
            if (sibling) sibling._destroy(fadeOut);
        }
        return true;
    }
};
// packages/ag-grid-community/src/entities/rowNodeUtils.ts
function $437b23f6a393c3bf$export$5c5bd6257397e1bc(rowNode, gos, type) {
    return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        type: type,
        node: rowNode,
        data: rowNode.data,
        rowIndex: rowNode.rowIndex,
        rowPinned: rowNode.rowPinned
    });
}
var $437b23f6a393c3bf$var$IGNORED_SIBLING_PROPERTIES = /* @__PURE__ */ new Set([
    "__autoHeights",
    "__checkAutoHeightsDebounced",
    "__localEventService",
    "__objectId",
    "_groupData",
    "_leafs",
    "childStore",
    "groupValue",
    "oldRowTop",
    "sticky",
    "treeNodeFlags",
    "treeParent"
]);
var $437b23f6a393c3bf$export$48fabbbfcde9fe36 = (rowNode, beans)=>{
    const sibling = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
    for (const key of Object.keys(rowNode)){
        if ($437b23f6a393c3bf$var$IGNORED_SIBLING_PROPERTIES.has(key)) continue;
        sibling[key] = rowNode[key];
    }
    sibling.oldRowTop = null;
    return sibling;
};
var $437b23f6a393c3bf$export$c2c097fde6ba0eab = (rowModel, direction, initial)=>{
    if (!initial) return void 0;
    let rowIndex = initial.rowIndex;
    if (rowIndex == null) return void 0;
    rowIndex += direction;
    const rowCount = rowModel.getRowCount();
    while(rowIndex >= 0 && rowIndex < rowCount){
        const row = rowModel.getRow(rowIndex);
        if (!row || !row.footer && !row.detail) return row;
        rowIndex += direction;
    }
    return void 0;
};
// packages/ag-grid-community/src/filter/columnFilterUtils.ts
var $437b23f6a393c3bf$var$FILTER_HANDLER_MAP = {
    agSetColumnFilter: "agSetColumnFilterHandler",
    agMultiColumnFilter: "agMultiColumnFilterHandler",
    agGroupColumnFilter: "agGroupColumnFilterHandler",
    agNumberColumnFilter: "agNumberColumnFilterHandler",
    agDateColumnFilter: "agDateColumnFilterHandler",
    agTextColumnFilter: "agTextColumnFilterHandler"
};
var $437b23f6a393c3bf$var$FILTER_HANDLERS = new Set(Object.values($437b23f6a393c3bf$var$FILTER_HANDLER_MAP));
function $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, skipCreate) {
    const filterUi = filterWrapper.filterUi;
    if (!filterUi) return null;
    if (filterUi.created) return filterUi.promise;
    if (skipCreate) return null;
    const promise = filterUi.create(filterUi.refreshed);
    const createdFilterUi = filterUi;
    createdFilterUi.created = true;
    createdFilterUi.promise = promise;
    return promise;
}
function $437b23f6a393c3bf$export$1fc9ad198b29415d(getFilterUi, handler, handlerParams, model, state, source, additionalEventAttributes) {
    handler.refresh?.({
        ...handlerParams,
        model: model,
        source: source,
        additionalEventAttributes: additionalEventAttributes
    });
    return getFilterUi().then((filterUi)=>{
        if (filterUi) {
            const { filter: filter, filterParams: filterParams } = filterUi;
            $437b23f6a393c3bf$export$8e370ccb0273c891(filter, filterParams, model, state, source, additionalEventAttributes);
        }
    });
}
function $437b23f6a393c3bf$export$8e370ccb0273c891(filter, filterParams, model, state, source, additionalEventAttributes) {
    filter?.refresh?.({
        ...filterParams,
        model: model,
        state: state,
        source: source,
        additionalEventAttributes: additionalEventAttributes
    });
}
function $437b23f6a393c3bf$var$getAndRefreshFilterUi(getFilterUi, getModel, getState2, additionalEventAttributes) {
    const filterUi = getFilterUi();
    if (filterUi?.created) filterUi.promise.then((filter)=>{
        const model = getModel();
        $437b23f6a393c3bf$export$8e370ccb0273c891(filter, filterUi.filterParams, model, getState2() ?? {
            model: model
        }, "ui", additionalEventAttributes);
    });
}
function $437b23f6a393c3bf$export$3305e8c6f4c8572a(params) {
    let state;
    let shouldUpdateModel = false;
    let model;
    const { action: action, filterParams: filterParams, getFilterUi: getFilterUi, getModel: getModel, getState: getState2, updateState: updateState, updateModel: updateModel, processModelToApply: processModelToApply } = params;
    switch(action){
        case "apply":
            {
                const oldState = getState2();
                model = oldState?.model ?? null;
                if (processModelToApply) model = processModelToApply(model);
                state = {
                    // keep the other UI state
                    state: oldState?.state,
                    model: model
                };
                shouldUpdateModel = true;
                break;
            }
        case "clear":
            state = {
                // wipe other UI state
                model: null
            };
            if (!filterParams?.buttons?.includes("apply")) {
                shouldUpdateModel = true;
                model = null;
            }
            break;
        case "reset":
            state = {
                // wipe other UI state
                model: null
            };
            shouldUpdateModel = true;
            model = null;
            break;
        case "cancel":
            state = {
                // wipe other UI state
                model: getModel()
            };
            break;
    }
    updateState(state);
    if (shouldUpdateModel) updateModel(model);
    else $437b23f6a393c3bf$var$getAndRefreshFilterUi(getFilterUi, getModel, getState2, {
        fromAction: action
    });
}
function $437b23f6a393c3bf$export$8981db65da4532f2(model, colId) {
    return model[colId] ?? null;
}
// packages/ag-grid-community/src/utils/element.ts
function $437b23f6a393c3bf$export$a232bb0480ae674a(params) {
    return $437b23f6a393c3bf$export$378bc9c64290bc8b(params);
}
// packages/ag-grid-community/src/filter/filterButtonComp.ts
function $437b23f6a393c3bf$var$getElement(className) {
    return {
        tag: "div",
        cls: className
    };
}
var $437b23f6a393c3bf$export$226c2a54d31bd592 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(config){
        const { className: className = "ag-filter-apply-panel" } = config ?? {};
        super($437b23f6a393c3bf$var$getElement(className));
        this.listeners = [];
        this.validationMessage = null;
        this.className = className;
    }
    updateButtons(buttons, useForm) {
        const oldButtons = this.buttons;
        this.buttons = buttons;
        if (oldButtons === buttons) return;
        const eGui = this.getGui();
        $437b23f6a393c3bf$export$69e6e10709eabd91(eGui);
        let eApplyButton;
        this.destroyListeners();
        const fragment = document.createDocumentFragment();
        const className = this.className;
        const addButton = ({ type: type, label: label })=>{
            const clickListener = (event)=>{
                this.dispatchLocalEvent({
                    type: type,
                    event: event
                });
            };
            if (![
                "apply",
                "clear",
                "reset",
                "cancel"
            ].includes(type)) $437b23f6a393c3bf$export$545083624300f13d(75);
            const isApply = type === "apply";
            const buttonType = isApply && useForm ? "submit" : "button";
            const button = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "button",
                attrs: {
                    type: buttonType
                },
                ref: `${type}FilterButton`,
                cls: `ag-button ag-standard-button ${className}-button${isApply ? " " + className + "-apply-button" : ""}`,
                children: label
            });
            this.activateTabIndex([
                button
            ]);
            if (isApply) eApplyButton = button;
            const keydownListener = (event)=>{
                if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) {
                    event.preventDefault();
                    clickListener(event);
                }
            };
            const listeners = this.listeners;
            button.addEventListener("click", clickListener);
            listeners.push(()=>button.removeEventListener("click", clickListener));
            button.addEventListener("keydown", keydownListener);
            listeners.push(()=>button.removeEventListener("keydown", keydownListener));
            fragment.append(button);
        };
        for (const button of buttons)addButton(button);
        this.eApply = eApplyButton;
        const tooltip = this.validationTooltipFeature;
        if (eApplyButton && !tooltip) this.validationTooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.eApply,
            getLocation: ()=>"advancedFilter",
            getTooltipShowDelayOverride: ()=>1e3
        }));
        else if (!eApplyButton && tooltip) this.validationTooltipFeature = this.destroyBean(tooltip);
        eGui.append(fragment);
    }
    getApplyButton() {
        return this.eApply;
    }
    updateValidity(valid, message = null) {
        const eApplyButton = this.eApply;
        if (!eApplyButton) return;
        $437b23f6a393c3bf$export$b6b4f08392e9bfaf(eApplyButton, !valid);
        this.validationMessage = message;
        this.validationTooltipFeature?.setTooltipAndRefresh(this.validationMessage);
    }
    destroyListeners() {
        for (const destroyFunc of this.listeners)destroyFunc();
        this.listeners = [];
    }
    destroy() {
        this.destroyListeners();
        super.destroy();
    }
};
var $437b23f6a393c3bf$export$4a8eed8acd632fcc = {
    selector: "AG-FILTER-BUTTON",
    component: $437b23f6a393c3bf$export$226c2a54d31bd592
};
// packages/ag-grid-community/src/filter/filterLocaleText.ts
var $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT = {
    applyFilter: "Apply",
    clearFilter: "Clear",
    resetFilter: "Reset",
    cancelFilter: "Cancel",
    textFilter: "Text Filter",
    numberFilter: "Number Filter",
    dateFilter: "Date Filter",
    setFilter: "Set Filter",
    filterOoo: "Filter...",
    empty: "Choose one",
    equals: "Equals",
    notEqual: "Does not equal",
    lessThan: "Less than",
    greaterThan: "Greater than",
    inRange: "Between",
    inRangeStart: "From",
    inRangeEnd: "To",
    lessThanOrEqual: "Less than or equal to",
    greaterThanOrEqual: "Greater than or equal to",
    contains: "Contains",
    notContains: "Does not contain",
    startsWith: "Begins with",
    endsWith: "Ends with",
    blank: "Blank",
    notBlank: "Not blank",
    before: "Before",
    after: "After",
    andCondition: "AND",
    orCondition: "OR",
    dateFormatOoo: "yyyy-mm-dd",
    filterSummaryInactive: "is (All)",
    filterSummaryContains: "contains",
    filterSummaryNotContains: "does not contain",
    filterSummaryTextEquals: "equals",
    filterSummaryTextNotEqual: "does not equal",
    filterSummaryStartsWith: "begins with",
    filterSummaryEndsWith: "ends with",
    filterSummaryBlank: "is blank",
    filterSummaryNotBlank: "is not blank",
    filterSummaryEquals: "=",
    filterSummaryNotEqual: "!=",
    filterSummaryGreaterThan: ">",
    filterSummaryGreaterThanOrEqual: ">=",
    filterSummaryLessThan: "<",
    filterSummaryLessThanOrEqual: "<=",
    filterSummaryInRange: "between",
    filterSummaryInRangeValues: (variableValues)=>`(${variableValues[0]}, ${variableValues[1]})`,
    filterSummaryTextQuote: (variableValues)=>`"${variableValues[0]}"`,
    minDateValidation: (variableValues)=>`Date must be after ${variableValues[0]}`,
    maxDateValidation: (variableValues)=>`Date must be before ${variableValues[0]}`,
    strictMinValueValidation: (variableValues)=>`Must be greater than ${variableValues[0]}`,
    strictMaxValueValidation: (variableValues)=>`Must be less than ${variableValues[0]}`
};
function $437b23f6a393c3bf$export$e2a0ae4af921fff8(bean, key, variableValues) {
    return $437b23f6a393c3bf$export$4ad3db330991f17d(bean, $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT, key, variableValues);
}
// packages/ag-grid-community/src/filter/provided/providedFilterUtils.ts
function $437b23f6a393c3bf$var$getDebounceMs(params, debounceDefault) {
    const { debounceMs: debounceMs } = params;
    if ($437b23f6a393c3bf$export$527c1b777ebd9069(params)) {
        if (debounceMs != null) $437b23f6a393c3bf$export$545083624300f13d(71);
        return 0;
    }
    return debounceMs ?? debounceDefault;
}
function $437b23f6a393c3bf$export$527c1b777ebd9069(params) {
    return (params.buttons?.indexOf("apply") ?? -1) >= 0;
}
function $437b23f6a393c3bf$var$getPlaceholderText(bean, filterPlaceholder, defaultPlaceholder, filterOptionKey) {
    let placeholder = $437b23f6a393c3bf$export$e2a0ae4af921fff8(bean, defaultPlaceholder);
    if (typeof filterPlaceholder === "function") {
        const filterOption = $437b23f6a393c3bf$export$e2a0ae4af921fff8(bean, filterOptionKey);
        placeholder = filterPlaceholder({
            filterOptionKey: filterOptionKey,
            filterOption: filterOption,
            placeholder: placeholder
        });
    } else if (typeof filterPlaceholder === "string") placeholder = filterPlaceholder;
    return placeholder;
}
// packages/ag-grid-community/src/filter/filterWrapperComp.ts
var $437b23f6a393c3bf$export$70acaf0e0e30e7d = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(column, wrapper, eventParent, updateModel, isGlobalButtons, enableGlobalButtonCheck){
        super();
        this.column = column;
        this.wrapper = wrapper;
        this.eventParent = eventParent;
        this.updateModel = updateModel;
        this.isGlobalButtons = isGlobalButtons;
        this.enableGlobalButtonCheck = enableGlobalButtonCheck;
        this.hidePopup = null;
        this.applyActive = false;
    }
    postConstruct() {
        const { comp: comp, params: originalParams } = this.wrapper;
        const params = originalParams;
        const useForm = params.useForm;
        const tag = useForm ? "form" : "div";
        this.setTemplate({
            tag: tag,
            cls: "ag-filter-wrapper"
        });
        if (useForm) this.addManagedElementListeners(this.getGui(), {
            submit: (e)=>{
                e?.preventDefault();
            },
            keydown: this.handleKeyDown.bind(this)
        });
        this.appendChild(comp.getGui());
        this.params = params;
        this.resetButtonsPanel(params);
        this.addManagedListeners(this.eventParent, {
            filterParamsChanged: ({ column: column, params: eventParams })=>{
                if (column === this.column) this.resetButtonsPanel(eventParams, this.params);
            },
            filterStateChanged: ({ column: column, state: state })=>{
                if (column === this.column) this.eButtons?.updateValidity(state.valid !== false);
            },
            filterAction: ({ column: column, action: action, event: keyboardEvent })=>{
                if (column === this.column) this.afterAction(action, keyboardEvent);
            },
            ...this.enableGlobalButtonCheck ? {
                filterGlobalButtons: ({ isGlobal: isGlobal })=>{
                    if (isGlobal !== this.isGlobalButtons) {
                        this.isGlobalButtons = isGlobal;
                        const currentParams = this.params;
                        this.resetButtonsPanel(currentParams, currentParams, true);
                    }
                }
            } : void 0
        });
    }
    afterGuiAttached(params) {
        if (params) this.hidePopup = params.hidePopup;
    }
    resetButtonsPanel(newParams, oldParams, forceUpdate) {
        const { buttons: oldButtons, readOnly: oldReadOnly } = oldParams ?? {};
        const { buttons: newButtons, readOnly: readOnly, useForm: useForm } = newParams;
        if (!forceUpdate && oldReadOnly === readOnly && $437b23f6a393c3bf$export$dbc2068cc90f5875(oldButtons, newButtons)) return;
        const hasButtons = newButtons && newButtons.length > 0 && !newParams.readOnly && !this.isGlobalButtons;
        let eButtonsPanel = this.eButtons;
        if (hasButtons) {
            const buttons = newButtons.map((type)=>{
                const localeKey = `${type}Filter`;
                return {
                    type: type,
                    label: $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, localeKey)
                };
            });
            this.applyActive = $437b23f6a393c3bf$export$527c1b777ebd9069(this.params);
            if (!eButtonsPanel) {
                eButtonsPanel = this.createBean(new $437b23f6a393c3bf$export$226c2a54d31bd592());
                this.appendChild(eButtonsPanel.getGui());
                const column = this.column;
                const getListener = (action)=>({ event: event })=>{
                        this.updateModel(column, action, {
                            fromButtons: true
                        });
                        this.afterAction(action, event);
                    };
                eButtonsPanel?.addManagedListeners(eButtonsPanel, {
                    apply: getListener("apply"),
                    clear: getListener("clear"),
                    reset: getListener("reset"),
                    cancel: getListener("cancel")
                });
                this.eButtons = eButtonsPanel;
            }
            eButtonsPanel.updateButtons(buttons, useForm);
        } else {
            this.applyActive = false;
            if (eButtonsPanel) {
                $437b23f6a393c3bf$export$dd4d52e41fb4cef5(eButtonsPanel.getGui());
                this.eButtons = this.destroyBean(eButtonsPanel);
            }
        }
    }
    close(e) {
        const hidePopup = this.hidePopup;
        if (!hidePopup) return;
        const keyboardEvent = e;
        const key = keyboardEvent?.key;
        let params;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) params = {
            keyboardEvent: keyboardEvent
        };
        hidePopup(params);
        this.hidePopup = null;
    }
    afterAction(action, event) {
        const { params: params, applyActive: applyActive } = this;
        const closeOnApply = params?.closeOnApply;
        switch(action){
            case "apply":
                event?.preventDefault();
                if (closeOnApply && applyActive) this.close(event);
                break;
            case "reset":
                if (closeOnApply && applyActive) this.close();
                break;
            case "cancel":
                if (closeOnApply) this.close(event);
                break;
        }
    }
    handleKeyDown(event) {
        if (!event.defaultPrevented && event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER && this.applyActive) {
            this.updateModel(this.column, "apply", {
                fromButtons: true
            });
            this.afterAction("apply", event);
        }
    }
    destroy() {
        this.hidePopup = null;
        this.eButtons = this.destroyBean(this.eButtons);
    }
};
// packages/ag-grid-community/src/filter/filterComp.ts
var $437b23f6a393c3bf$var$FilterElement = {
    tag: "div",
    cls: "ag-filter"
};
var $437b23f6a393c3bf$export$7db6d402989d8b90 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(column, source, enableGlobalButtonCheck){
        super($437b23f6a393c3bf$var$FilterElement);
        this.column = column;
        this.source = source;
        this.enableGlobalButtonCheck = enableGlobalButtonCheck;
        this.wrapper = null;
    }
    postConstruct() {
        this.beans.colFilter?.activeFilterComps.add(this);
        this.createFilter(true);
        this.addManagedEventListeners({
            filterDestroyed: this.onFilterDestroyed.bind(this)
        });
    }
    hasFilter() {
        return this.wrapper != null;
    }
    getFilter() {
        return this.wrapper?.then((wrapper)=>wrapper.comp) ?? null;
    }
    afterInit() {
        return this.wrapper?.then(()=>{}) ?? $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    afterGuiAttached(params) {
        this.afterGuiAttachedParams = params;
        this.wrapper?.then((wrapper)=>{
            this.comp?.afterGuiAttached(params);
            wrapper?.comp?.afterGuiAttached?.(params);
        });
    }
    afterGuiDetached() {
        this.wrapper?.then((wrapper)=>{
            wrapper?.comp?.afterGuiDetached?.();
        });
    }
    createFilter(init) {
        const { column: column, source: source, beans: { colFilter: colFilter } } = this;
        const filterPromise = colFilter.getFilterUiForDisplay(column) ?? null;
        this.wrapper = filterPromise;
        filterPromise?.then((wrapper)=>{
            if (!wrapper) return;
            const { isHandler: isHandler, comp: comp } = wrapper;
            let filterGui;
            if (isHandler) {
                const enableGlobalButtonCheck = !!this.enableGlobalButtonCheck;
                const displayComp = this.createBean(new $437b23f6a393c3bf$export$70acaf0e0e30e7d(column, wrapper, colFilter, colFilter.updateModel.bind(colFilter), enableGlobalButtonCheck && colFilter.isGlobalButtons, enableGlobalButtonCheck));
                this.comp = displayComp;
                filterGui = displayComp.getGui();
            } else {
                filterGui = comp.getGui();
                if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(filterGui)) $437b23f6a393c3bf$export$545083624300f13d(69, {
                    guiFromFilter: filterGui
                });
            }
            this.appendChild(filterGui);
            if (init) this.eventSvc.dispatchEvent({
                type: "filterOpened",
                column: column,
                source: source,
                eGui: this.getGui()
            });
            else comp.afterGuiAttached?.(this.afterGuiAttachedParams);
        });
    }
    onFilterDestroyed(event) {
        const { source: source, column: column } = event;
        if ((source === "api" || source === "paramsUpdated") && column.getId() === this.column.getId() && this.beans.colModel.getColDefCol(this.column)) {
            $437b23f6a393c3bf$export$69e6e10709eabd91(this.getGui());
            this.comp = this.destroyBean(this.comp);
            this.createFilter();
        }
    }
    destroy() {
        this.beans.colFilter?.activeFilterComps.delete(this);
        this.eventSvc.dispatchEvent({
            type: "filterClosed",
            column: this.column
        });
        this.wrapper = null;
        this.comp = this.destroyBean(this.comp);
        this.afterGuiAttachedParams = void 0;
        super.destroy();
    }
};
// packages/ag-grid-community/src/filter/filterDataTypeUtils.ts
var $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT = {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December"
};
var $437b23f6a393c3bf$var$MONTH_KEYS = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
function $437b23f6a393c3bf$var$setFilterNumberComparator(a, b) {
    if (a == null) return -1;
    if (b == null) return 1;
    return Number.parseFloat(a) - Number.parseFloat(b);
}
function $437b23f6a393c3bf$var$isValidDate(value) {
    return value instanceof Date && !isNaN(value.getTime());
}
var $437b23f6a393c3bf$var$filterParamsForEachDataType = {
    number: ()=>void 0,
    boolean: ()=>({
            maxNumConditions: 1,
            debounceMs: 0,
            filterOptions: [
                "empty",
                {
                    displayKey: "true",
                    displayName: "True",
                    predicate: (_filterValues, cellValue)=>cellValue,
                    numberOfInputs: 0
                },
                {
                    displayKey: "false",
                    displayName: "False",
                    predicate: (_filterValues, cellValue)=>cellValue === false,
                    numberOfInputs: 0
                }
            ]
        }),
    date: ()=>({
            isValidDate: $437b23f6a393c3bf$var$isValidDate
        }),
    dateString: ({ dataTypeDefinition: dataTypeDefinition })=>({
            comparator: (filterDate, cellValue)=>{
                const cellAsDate = dataTypeDefinition.dateParser(cellValue);
                if (cellValue == null || cellAsDate < filterDate) return -1;
                if (cellAsDate > filterDate) return 1;
                return 0;
            },
            isValidDate: (value)=>typeof value === "string" && $437b23f6a393c3bf$var$isValidDate(dataTypeDefinition.dateParser(value))
        }),
    dateTime: (args)=>$437b23f6a393c3bf$var$filterParamsForEachDataType.date(args),
    dateTimeString: (args)=>$437b23f6a393c3bf$var$filterParamsForEachDataType.dateString(args),
    object: ()=>void 0,
    text: ()=>void 0
};
var $437b23f6a393c3bf$var$setFilterParamsForEachDataType = {
    number: ()=>({
            comparator: $437b23f6a393c3bf$var$setFilterNumberComparator
        }),
    boolean: ({ t: t })=>({
            valueFormatter: (params)=>$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value) ? t(String(params.value), params.value ? "True" : "False") : t("blanks", "(Blanks)")
        }),
    date: ({ formatValue: formatValue, t: t })=>({
            valueFormatter: (params)=>{
                const valueFormatted = formatValue(params);
                return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : t("blanks", "(Blanks)");
            },
            treeList: true,
            treeListFormatter: (pathKey, level)=>{
                if (pathKey === "NaN") return t("invalidDate", "Invalid Date");
                if (level === 1 && pathKey != null) {
                    const monthKey = $437b23f6a393c3bf$var$MONTH_KEYS[Number(pathKey) - 1];
                    return t(monthKey, $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT[monthKey]);
                }
                return pathKey ?? t("blanks", "(Blanks)");
            },
            treeListPathGetter: (date)=>$437b23f6a393c3bf$export$bb4eb333cc2b3e25(date, false)
        }),
    dateString: ({ formatValue: formatValue, dataTypeDefinition: dataTypeDefinition, t: t })=>({
            valueFormatter: (params)=>{
                const valueFormatted = formatValue(params);
                return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : t("blanks", "(Blanks)");
            },
            treeList: true,
            treeListPathGetter: (value)=>$437b23f6a393c3bf$export$bb4eb333cc2b3e25(dataTypeDefinition.dateParser(value ?? void 0), false),
            treeListFormatter: (pathKey, level)=>{
                if (level === 1 && pathKey != null) {
                    const monthKey = $437b23f6a393c3bf$var$MONTH_KEYS[Number(pathKey) - 1];
                    return t(monthKey, $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT[monthKey]);
                }
                return pathKey ?? t("blanks", "(Blanks)");
            }
        }),
    dateTime: (args)=>{
        const params = $437b23f6a393c3bf$var$setFilterParamsForEachDataType.date(args);
        params.treeListPathGetter = $437b23f6a393c3bf$export$bb4eb333cc2b3e25;
        return params;
    },
    dateTimeString (args) {
        const convertToDate = args.dataTypeDefinition.dateParser;
        const params = $437b23f6a393c3bf$var$setFilterParamsForEachDataType.dateString(args);
        params.treeListPathGetter = (value)=>$437b23f6a393c3bf$export$bb4eb333cc2b3e25(convertToDate(value ?? void 0));
        return params;
    },
    object: ({ formatValue: formatValue, t: t })=>({
            valueFormatter: (params)=>{
                const valueFormatted = formatValue(params);
                return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : t("blanks", "(Blanks)");
            }
        }),
    text: ()=>void 0
};
function $437b23f6a393c3bf$export$4a99b58ce484acc(filter, existingFilterParams, existingFilterValueGetter, dataTypeDefinition, formatValue, beans, translate) {
    let filterParams = existingFilterParams;
    let filterValueGetter = existingFilterValueGetter;
    const usingSetFilter = filter === "agSetColumnFilter";
    if (!filterValueGetter && dataTypeDefinition.baseDataType === "object" && !usingSetFilter) filterValueGetter = ({ column: column, node: node })=>formatValue({
            column: column,
            node: node,
            value: beans.valueSvc.getValue(column, node)
        });
    const filterParamsMap = usingSetFilter ? $437b23f6a393c3bf$var$setFilterParamsForEachDataType : $437b23f6a393c3bf$var$filterParamsForEachDataType;
    const filterParamsGetter = filterParamsMap[dataTypeDefinition.baseDataType];
    const newFilterParams = filterParamsGetter({
        dataTypeDefinition: dataTypeDefinition,
        formatValue: formatValue,
        t: translate
    });
    filterParams = typeof existingFilterParams === "object" ? {
        ...newFilterParams,
        ...existingFilterParams
    } : newFilterParams;
    return {
        filterParams: filterParams,
        filterValueGetter: filterValueGetter
    };
}
var $437b23f6a393c3bf$var$defaultFilters = {
    boolean: "agTextColumnFilter",
    date: "agDateColumnFilter",
    dateString: "agDateColumnFilter",
    dateTime: "agDateColumnFilter",
    dateTimeString: "agDateColumnFilter",
    number: "agNumberColumnFilter",
    object: "agTextColumnFilter",
    text: "agTextColumnFilter"
};
var $437b23f6a393c3bf$var$defaultFloatingFilters = {
    boolean: "agTextColumnFloatingFilter",
    date: "agDateColumnFloatingFilter",
    dateString: "agDateColumnFloatingFilter",
    dateTime: "agDateColumnFloatingFilter",
    dateTimeString: "agDateColumnFloatingFilter",
    number: "agNumberColumnFloatingFilter",
    object: "agTextColumnFloatingFilter",
    text: "agTextColumnFloatingFilter"
};
function $437b23f6a393c3bf$export$4a4e3cf6acc7e93(cellDataType, isFloating = false) {
    const filterSet = isFloating ? $437b23f6a393c3bf$var$defaultFloatingFilters : $437b23f6a393c3bf$var$defaultFilters;
    return filterSet[cellDataType ?? "text"];
}
// packages/ag-grid-community/src/rendering/features/positionableFeature.ts
var $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6 = class extends $437b23f6a393c3bf$export$2da1335e50678d79 {
};
// packages/ag-grid-community/src/utils/gridEvent.ts
var $437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION = "__ag_Grid_Stop_Propagation";
function $437b23f6a393c3bf$export$456c40e80134d72a(event) {
    event[$437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION] = true;
}
function $437b23f6a393c3bf$export$9a48e23524c6d58(event) {
    return event[$437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION] === true;
}
// packages/ag-grid-community/src/widgets/managedFocusFeature.ts
var $437b23f6a393c3bf$export$24fcbcdf47263033 = {
    isStopPropagation: $437b23f6a393c3bf$export$9a48e23524c6d58,
    stopPropagation: $437b23f6a393c3bf$export$456c40e80134d72a
};
var $437b23f6a393c3bf$export$5510e53ed3962582 = class extends $437b23f6a393c3bf$var$AgManagedFocusFeature {
    constructor(eFocusable, callbacks){
        super(eFocusable, $437b23f6a393c3bf$export$24fcbcdf47263033, callbacks);
    }
};
// packages/ag-grid-community/src/filter/provided/providedFilter.ts
var $437b23f6a393c3bf$export$a927a1327c2cc7f0 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(filterNameKey, cssIdentifier){
        super();
        this.filterNameKey = filterNameKey;
        this.cssIdentifier = cssIdentifier;
        this.applyActive = false;
        this.debouncePending = false;
        // subclasses can override this to provide alternative debounce defaults
        this.defaultDebounceMs = 0;
    }
    postConstruct() {
        const element = {
            tag: "div",
            cls: `ag-filter-body-wrapper ag-${this.cssIdentifier}-body-wrapper`,
            children: [
                this.createBodyTemplate()
            ]
        };
        this.setTemplate(element, this.getAgComponents());
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.getFocusableElement(), {
            handleKeyDown: this.handleKeyDown.bind(this)
        }));
        this.positionableFeature = this.createBean(new $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6(this.getPositionableElement(), {
            forcePopupParentAsOffsetParent: true
        }));
    }
    handleKeyDown(_e) {}
    init(legacyParams) {
        const params = legacyParams;
        this.setParams(params);
        this.setModelIntoUi(params.state.model, true).then(()=>this.updateUiVisibility());
    }
    areStatesEqual(stateA, stateB) {
        return stateA === stateB;
    }
    refresh(legacyNewParams) {
        const newParams = legacyNewParams;
        const oldParams = this.params;
        this.params = newParams;
        const { source: source, state: newState, additionalEventAttributes: additionalEventAttributes } = newParams;
        if (source === "colDef") this.updateParams(newParams, oldParams);
        const oldState = this.state;
        this.state = newState;
        const fromAction = additionalEventAttributes?.fromAction;
        if (fromAction && fromAction !== "apply" || newState.model !== oldState.model || !this.areStatesEqual(newState.state, oldState.state)) this.setModelIntoUi(newState.model);
        return true;
    }
    /** Called on init only. Override in subclasses */ setParams(params) {
        this.params = params;
        this.state = params.state;
        this.commonUpdateParams(params);
    }
    /** Called on refresh only. Override in subclasses */ updateParams(newParams, oldParams) {
        this.commonUpdateParams(newParams, oldParams);
    }
    commonUpdateParams(newParams, _oldParams) {
        this.applyActive = $437b23f6a393c3bf$export$527c1b777ebd9069(newParams);
        this.setupApplyDebounced();
    }
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ doesFilterPass(params) {
        $437b23f6a393c3bf$export$545083624300f13d(283);
        const { getHandler: getHandler, model: model, column: column } = this.params;
        return getHandler().doesFilterPass({
            ...params,
            model: model,
            handlerParams: this.beans.colFilter.getHandlerParams(column)
        });
    }
    getFilterTitle() {
        return this.translate(this.filterNameKey);
    }
    /**
   * @deprecated v34 Filters are active when they have a model. Use `api.getColumnFilterModel()` instead.
   */ isFilterActive() {
        $437b23f6a393c3bf$export$545083624300f13d(284);
        return this.params.model != null;
    }
    setupApplyDebounced() {
        const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(this.params, this.defaultDebounceMs);
        const debounceFunc = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.checkApplyDebounce.bind(this), debounceMs);
        this.applyDebounced = ()=>{
            this.debouncePending = true;
            debounceFunc();
        };
    }
    checkApplyDebounce() {
        if (this.debouncePending) {
            this.debouncePending = false;
            this.doApplyModel();
        }
    }
    /**
   * @deprecated v34 Use (`api.getColumnFilterModel()`) instead.
   */ getModel() {
        $437b23f6a393c3bf$export$545083624300f13d(285);
        return this.params.model;
    }
    /**
   * @deprecated v34 Use (`api.setColumnFilterModel()`) instead.
   */ setModel(model) {
        $437b23f6a393c3bf$export$545083624300f13d(286);
        const { beans: beans, params: params } = this;
        return beans.colFilter.setModelForColumnLegacy(params.column, model);
    }
    /**
   * Applies changes made in the UI to the filter, and returns true if the model has changed.
   */ applyModel(_source = "api") {
        return this.doApplyModel();
    }
    canApply(_model) {
        return true;
    }
    doApplyModel(additionalEventAttributes) {
        const { params: params, state: { valid: valid = true, model: model } } = this;
        if (!valid) return false;
        const changed = !this.areModelsEqual(params.model, model);
        if (changed) params.onAction("apply", additionalEventAttributes);
        return changed;
    }
    /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */ onNewRowsLoaded() {}
    /**
   * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
   * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
   * be adjusted by using the apply parameter.
   */ onUiChanged(apply, afterFloatingFilter = false) {
        this.updateUiVisibility();
        const model = this.getModelFromUi();
        const state = {
            model: model,
            state: this.getState(),
            valid: this.canApply(model)
        };
        this.state = state;
        const { params: params, gos: gos, eventSvc: eventSvc, applyActive: applyActive } = this;
        params.onStateChange(state);
        params.onUiChange(this.getUiChangeEventParams());
        if (!gos.get("enableFilterHandlers")) eventSvc.dispatchEvent({
            type: "filterModified",
            column: params.column,
            filterInstance: this
        });
        if (!state.valid) return;
        apply ?? (apply = applyActive ? void 0 : "debounce");
        if (apply === "immediately") this.doApplyModel({
            afterFloatingFilter: afterFloatingFilter,
            afterDataChange: false
        });
        else if (apply === "debounce") this.applyDebounced();
    }
    getState() {
        return void 0;
    }
    getUiChangeEventParams() {
        return void 0;
    }
    afterGuiAttached(params) {
        this.lastContainerType = params?.container;
        this.refreshFilterResizer(params?.container);
    }
    refreshFilterResizer(containerType) {
        const { positionableFeature: positionableFeature, gos: gos } = this;
        if (!positionableFeature) return;
        const isResizable = containerType === "floatingFilter" || containerType === "columnFilter";
        if (isResizable) {
            positionableFeature.restoreLastSize();
            positionableFeature.setResizable(gos.get("enableRtl") ? {
                bottom: true,
                bottomLeft: true,
                left: true
            } : {
                bottom: true,
                bottomRight: true,
                right: true
            });
        } else {
            positionableFeature.removeSizeFromEl();
            positionableFeature.setResizable(false);
        }
        positionableFeature.constrainSizeToAvailableHeight(isResizable);
    }
    afterGuiDetached() {
        this.checkApplyDebounce();
        this.positionableFeature?.constrainSizeToAvailableHeight(false);
    }
    destroy() {
        this.positionableFeature = this.destroyBean(this.positionableFeature);
        super.destroy();
    }
    translate(key, variableValues) {
        return $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, key, variableValues);
    }
    // override to control positionable feature
    getPositionableElement() {
        return this.getGui();
    }
    areModelsEqual(a, b) {
        if (a === b || a == null && b == null) return true;
        if (a == null || b == null) return false;
        return this.areNonNullModelsEqual(a, b);
    }
};
// packages/ag-grid-community/src/filter/provided/iSimpleFilter.ts
function $437b23f6a393c3bf$export$a3f343af66a0c1bd(model) {
    return !!model.operator;
}
// packages/ag-grid-community/src/filter/floating/floatingFilterMapper.ts
function $437b23f6a393c3bf$export$47072b32bdaf5d61(frameworkOverrides, def, getFromDefault) {
    if (def == null) return null;
    let defaultFloatingFilterType = null;
    const { compName: compName, jsComp: jsComp, fwComp: fwComp } = $437b23f6a393c3bf$var$_getFilterCompKeys(frameworkOverrides, def);
    if (compName) {
        const floatingFilterTypeMap = {
            agSetColumnFilter: "agSetColumnFloatingFilter",
            agMultiColumnFilter: "agMultiColumnFloatingFilter",
            agGroupColumnFilter: "agGroupColumnFloatingFilter",
            agNumberColumnFilter: "agNumberColumnFloatingFilter",
            agDateColumnFilter: "agDateColumnFloatingFilter",
            agTextColumnFilter: "agTextColumnFloatingFilter"
        };
        defaultFloatingFilterType = floatingFilterTypeMap[compName];
    } else {
        const usingDefaultFilter = jsComp == null && fwComp == null && def.filter === true;
        if (usingDefaultFilter) defaultFloatingFilterType = getFromDefault();
    }
    return defaultFloatingFilterType;
}
// packages/ag-grid-community/src/interfaces/structuredSchemaParams.ts
var $437b23f6a393c3bf$export$e85ca1dd7f3d099e = [
    "aggregation",
    "filter",
    "sort",
    "pivot",
    "columnVisibility",
    "columnSizing",
    "rowGroup"
];
// packages/ag-grid-community/src/styling/layoutFeature.ts
var $437b23f6a393c3bf$var$LayoutCssClasses = {
    AUTO_HEIGHT: "ag-layout-auto-height",
    NORMAL: "ag-layout-normal",
    PRINT: "ag-layout-print"
};
var $437b23f6a393c3bf$var$LayoutFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(view){
        super();
        this.view = view;
    }
    postConstruct() {
        this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this));
        this.updateLayoutClasses();
    }
    updateLayoutClasses() {
        const domLayout = this.gos.get("domLayout");
        const params = {
            autoHeight: domLayout === "autoHeight",
            normal: domLayout === "normal",
            print: domLayout === "print"
        };
        const cssClass = params.autoHeight ? $437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT : params.print ? $437b23f6a393c3bf$var$LayoutCssClasses.PRINT : $437b23f6a393c3bf$var$LayoutCssClasses.NORMAL;
        this.view.updateLayoutClasses(cssClass, params);
    }
};
// packages/ag-grid-community/src/gridBodyComp/gridBodyScrollFeature.ts
var $437b23f6a393c3bf$var$VIEWPORT = "Viewport";
var $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR = "fakeVScrollComp";
var $437b23f6a393c3bf$var$HORIZONTAL_SOURCES = [
    "fakeHScrollComp",
    "centerHeader",
    "topCenter",
    "bottomCenter",
    "stickyTopCenter",
    "stickyBottomCenter"
];
var $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT = 100;
var $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT = 150;
var $437b23f6a393c3bf$var$GridBodyScrollFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eBodyViewport){
        super();
        // listeners for when ensureIndexVisible is waiting for SSRM data to load
        this.clearRetryListenerFncs = [];
        this.lastScrollSource = [
            null,
            null
        ];
        this.scrollLeft = -1;
        this.nextScrollTop = -1;
        this.scrollTop = -1;
        // Used to provide approximate values of scrollTop and offsetHeight
        // without forcing the browser to recalculate styles.
        this.lastOffsetHeight = -1;
        this.lastScrollTop = -1;
        this.lastIsHorizontalScrollShowing = false;
        this.scrollTimer = 0;
        this.isScrollActive = false;
        this.isVerticalPositionInvalidated = true;
        this.isHorizontalPositionInvalidated = true;
        this.eBodyViewport = eBodyViewport;
        this.resetLastHScrollDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.lastScrollSource[1 /* Horizontal */ ] = null, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
        this.resetLastVScrollDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.lastScrollSource[0 /* Vertical */ ] = null, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.animationFrameSvc = beans.animationFrameSvc;
        this.visibleCols = beans.visibleCols;
    }
    destroy() {
        super.destroy();
        this.clearRetryListenerFncs = [];
        window.clearTimeout(this.scrollTimer);
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        const invalidateVerticalScroll = this.invalidateVerticalScroll.bind(this);
        const invalidateHorizontalScroll = this.invalidateHorizontalScroll.bind(this);
        this.addManagedEventListeners({
            displayedColumnsWidthChanged: this.onDisplayedColumnsWidthChanged.bind(this),
            bodyHeightChanged: invalidateVerticalScroll,
            // We only invalidate horizontal scrolling when the viewport switches
            // between scrollable and non-scrollable, avoiding unnecessary
            // invalidation on every gridSizeChanged event. If more properties
            // require invalidation, read/write DOM cycles may be needed.
            scrollGapChanged: invalidateHorizontalScroll
        });
        this.addManagedElementListeners(this.eBodyViewport, {
            scroll: invalidateVerticalScroll
        });
        this.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowsCtrl = p.center;
            this.onDisplayedColumnsWidthChanged();
            this.addScrollListener();
        });
    }
    invalidateHorizontalScroll() {
        this.isHorizontalPositionInvalidated = true;
    }
    invalidateVerticalScroll() {
        this.isVerticalPositionInvalidated = true;
    }
    addScrollListener() {
        this.addHorizontalScrollListeners();
        this.addVerticalScrollListeners();
    }
    addHorizontalScrollListeners() {
        this.addManagedElementListeners(this.centerRowsCtrl.eViewport, {
            scroll: this.onHScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT)
        });
        for (const source of $437b23f6a393c3bf$var$HORIZONTAL_SOURCES){
            const scrollPartner = this.ctrlsSvc.get(source);
            this.registerScrollPartner(scrollPartner, this.onHScroll.bind(this, source));
        }
    }
    addVerticalScrollListeners() {
        const fakeVScrollComp = this.ctrlsSvc.get("fakeVScrollComp");
        const isDebounce = this.gos.get("debounceVerticalScrollbar");
        const onVScroll = isDebounce ? $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onVScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT), $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT) : this.onVScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT);
        const onFakeVScroll = isDebounce ? $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onVScroll.bind(this, $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR), $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT) : this.onVScroll.bind(this, $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR);
        this.addManagedElementListeners(this.eBodyViewport, {
            scroll: onVScroll
        });
        this.registerScrollPartner(fakeVScrollComp, onFakeVScroll);
    }
    registerScrollPartner(comp, callback) {
        comp.onScrollCallback(callback);
    }
    onDisplayedColumnsWidthChanged() {
        if (this.enableRtl) this.horizontallyScrollHeaderCenterAndFloatingCenter();
    }
    horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft) {
        const notYetInitialised = this.centerRowsCtrl == null;
        if (notYetInitialised) return;
        if (scrollLeft === void 0) scrollLeft = this.centerRowsCtrl.getCenterViewportScrollLeft();
        this.setScrollLeftForAllContainersExceptCurrent(Math.abs(scrollLeft));
    }
    setScrollLeftForAllContainersExceptCurrent(scrollLeft) {
        for (const container of [
            ...$437b23f6a393c3bf$var$HORIZONTAL_SOURCES,
            $437b23f6a393c3bf$var$VIEWPORT
        ]){
            if (this.lastScrollSource[1 /* Horizontal */ ] === container) continue;
            const viewport = this.getViewportForSource(container);
            $437b23f6a393c3bf$var$_setScrollLeft(viewport, scrollLeft, this.enableRtl);
        }
    }
    getViewportForSource(source) {
        if (source === $437b23f6a393c3bf$var$VIEWPORT) return this.centerRowsCtrl.eViewport;
        return this.ctrlsSvc.get(source).eViewport;
    }
    isControllingScroll(source, direction) {
        if (this.lastScrollSource[direction] == null) {
            if (direction === 0 /* Vertical */ ) this.lastScrollSource[0] = source;
            else this.lastScrollSource[1] = source;
            return true;
        }
        return this.lastScrollSource[direction] === source;
    }
    onHScroll(source) {
        if (!this.isControllingScroll(source, 1 /* Horizontal */ )) return;
        const centerContainerViewport = this.centerRowsCtrl.eViewport;
        const { scrollLeft: scrollLeft } = centerContainerViewport;
        if (this.shouldBlockScrollUpdate(1 /* Horizontal */ , scrollLeft, true)) return;
        const newScrollLeft = $437b23f6a393c3bf$var$_getScrollLeft(this.getViewportForSource(source), this.enableRtl);
        this.doHorizontalScroll(newScrollLeft);
        this.resetLastHScrollDebounced();
    }
    onVScroll(source) {
        if (!this.isControllingScroll(source, 0 /* Vertical */ )) return;
        let scrollTop;
        if (source === $437b23f6a393c3bf$var$VIEWPORT) scrollTop = this.eBodyViewport.scrollTop;
        else scrollTop = this.ctrlsSvc.get("fakeVScrollComp").getScrollPosition();
        if (this.shouldBlockScrollUpdate(0 /* Vertical */ , scrollTop, true)) return;
        const { animationFrameSvc: animationFrameSvc } = this;
        animationFrameSvc?.setScrollTop(scrollTop);
        this.nextScrollTop = scrollTop;
        if (source === $437b23f6a393c3bf$var$VIEWPORT) this.ctrlsSvc.get("fakeVScrollComp").setScrollPosition(scrollTop);
        else this.eBodyViewport.scrollTop = scrollTop;
        if (animationFrameSvc?.active) animationFrameSvc.schedule();
        else this.scrollGridIfNeeded(true);
        this.resetLastVScrollDebounced();
    }
    doHorizontalScroll(scrollLeft) {
        const fakeScrollLeft = this.ctrlsSvc.get("fakeHScrollComp").getScrollPosition();
        if (this.scrollLeft === scrollLeft && scrollLeft === fakeScrollLeft) return;
        this.scrollLeft = scrollLeft;
        this.fireScrollEvent(1 /* Horizontal */ );
        this.horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft);
        this.centerRowsCtrl.onHorizontalViewportChanged(true);
    }
    isScrolling() {
        return this.isScrollActive;
    }
    fireScrollEvent(direction) {
        const bodyScrollEvent = {
            type: "bodyScroll",
            direction: direction === 1 /* Horizontal */  ? "horizontal" : "vertical",
            left: this.scrollLeft,
            top: this.scrollTop
        };
        this.isScrollActive = true;
        this.eventSvc.dispatchEvent(bodyScrollEvent);
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(()=>{
            this.scrollTimer = 0;
            this.isScrollActive = false;
            this.eventSvc.dispatchEvent({
                ...bodyScrollEvent,
                type: "bodyScrollEnd"
            });
        }, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
    }
    shouldBlockScrollUpdate(direction, scrollTo, touchOnly = false) {
        if (touchOnly && !$437b23f6a393c3bf$export$6b6034a68325bd8a()) return false;
        if (direction === 0 /* Vertical */ ) return this.shouldBlockVerticalScroll(scrollTo);
        return this.shouldBlockHorizontalScroll(scrollTo);
    }
    shouldBlockVerticalScroll(scrollTo) {
        const clientHeight = $437b23f6a393c3bf$export$c20e968103d9c16e(this.eBodyViewport);
        const { scrollHeight: scrollHeight } = this.eBodyViewport;
        return !!(scrollTo < 0 || scrollTo + clientHeight > scrollHeight);
    }
    shouldBlockHorizontalScroll(scrollTo) {
        const clientWidth = this.centerRowsCtrl.getCenterWidth();
        const { scrollWidth: scrollWidth } = this.centerRowsCtrl.eViewport;
        if (this.enableRtl) {
            if (scrollTo > 0) return true;
        } else if (scrollTo < 0) return true;
        return Math.abs(scrollTo) + clientWidth > scrollWidth;
    }
    redrawRowsAfterScroll() {
        this.fireScrollEvent(0 /* Vertical */ );
    }
    // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
    // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
    // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
    // back to the left to be kept in sync.
    // adding and removing the grid from the DOM both resets the scroll position and
    // triggers a resize event, so notify listeners if the scroll position has changed
    checkScrollLeft() {
        const scrollLeft = this.scrollLeft;
        let hasHorizontalScrollersOutOfSync = false;
        for (const source of $437b23f6a393c3bf$var$HORIZONTAL_SOURCES){
            const viewport = this.getViewportForSource(source);
            if (viewport.scrollLeft !== scrollLeft) {
                hasHorizontalScrollersOutOfSync = true;
                break;
            }
        }
        if (hasHorizontalScrollersOutOfSync) this.onHScroll($437b23f6a393c3bf$var$VIEWPORT);
    }
    scrollGridIfNeeded(suppressedAnimationFrame = false) {
        const frameNeeded = this.scrollTop != this.nextScrollTop;
        if (frameNeeded) {
            this.scrollTop = this.nextScrollTop;
            if (suppressedAnimationFrame) this.invalidateVerticalScroll();
            this.redrawRowsAfterScroll();
        }
        return frameNeeded;
    }
    // called by scrollHorizontally method and alignedGridsService
    setHorizontalScrollPosition(hScrollPosition, fromAlignedGridsService = false) {
        const minScrollLeft = 0;
        const maxScrollLeft = this.centerRowsCtrl.eViewport.scrollWidth - this.centerRowsCtrl.getCenterWidth();
        if (!fromAlignedGridsService && this.shouldBlockScrollUpdate(1 /* Horizontal */ , hScrollPosition)) {
            if (this.enableRtl) hScrollPosition = hScrollPosition > 0 ? 0 : maxScrollLeft;
            else hScrollPosition = Math.min(Math.max(hScrollPosition, minScrollLeft), maxScrollLeft);
        }
        $437b23f6a393c3bf$var$_setScrollLeft(this.centerRowsCtrl.eViewport, Math.abs(hScrollPosition), this.enableRtl);
        this.doHorizontalScroll(hScrollPosition);
    }
    setVerticalScrollPosition(vScrollPosition) {
        this.invalidateVerticalScroll();
        this.eBodyViewport.scrollTop = vScrollPosition;
    }
    getVScrollPosition() {
        if (!this.isVerticalPositionInvalidated) {
            const { lastOffsetHeight: lastOffsetHeight, lastScrollTop: lastScrollTop } = this;
            return {
                top: lastScrollTop,
                bottom: lastScrollTop + lastOffsetHeight
            };
        }
        this.isVerticalPositionInvalidated = false;
        const { scrollTop: scrollTop, offsetHeight: offsetHeight } = this.eBodyViewport;
        this.lastScrollTop = scrollTop;
        this.lastOffsetHeight = offsetHeight;
        return {
            top: scrollTop,
            bottom: scrollTop + offsetHeight
        };
    }
    /** Get an approximate scroll position that returns the last real value read.
   * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
   * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
   */ getApproximateVScollPosition() {
        if (this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0) return {
            top: this.scrollTop,
            bottom: this.scrollTop + this.lastOffsetHeight
        };
        return this.getVScrollPosition();
    }
    getHScrollPosition() {
        return this.centerRowsCtrl.getHScrollPosition();
    }
    isHorizontalScrollShowing() {
        if (this.isHorizontalPositionInvalidated) {
            this.lastIsHorizontalScrollShowing = this.centerRowsCtrl.isHorizontalScrollShowing();
            this.isHorizontalPositionInvalidated = false;
        }
        return this.lastIsHorizontalScrollShowing;
    }
    // called by the headerRootComp and moveColumnController
    scrollHorizontally(pixels) {
        const oldScrollPosition = this.centerRowsCtrl.eViewport.scrollLeft;
        this.setHorizontalScrollPosition(oldScrollPosition + pixels);
        return this.centerRowsCtrl.eViewport.scrollLeft - oldScrollPosition;
    }
    // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
    scrollToTop() {
        this.eBodyViewport.scrollTop = 0;
    }
    // Valid values for position are bottom, middle and top
    ensureNodeVisible(comparator, position = null) {
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.getRowCount();
        let indexToSelect = -1;
        for(let i = 0; i < rowCount; i++){
            const node = rowModel.getRow(i);
            if (typeof comparator === "function") {
                const predicate = comparator;
                if (node && predicate(node)) {
                    indexToSelect = i;
                    break;
                }
            } else if (comparator === node || comparator === node.data) {
                indexToSelect = i;
                break;
            }
        }
        if (indexToSelect >= 0) this.ensureIndexVisible(indexToSelect, position);
    }
    // Valid values for position are bottom, middle and top
    // position should be {'top','middle','bottom', or undefined/null}.
    // if undefined/null, then the grid will to the minimal amount of scrolling,
    // eg if grid needs to scroll up, it scrolls until row is on top,
    //    if grid needs to scroll down, it scrolls until row is on bottom,
    //    if row is already in view, grid does not scroll
    ensureIndexVisible(index, position, retry = 0) {
        if ($437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print")) return;
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.getRowCount();
        if (typeof index !== "number" || index < 0 || index >= rowCount) {
            $437b23f6a393c3bf$export$545083624300f13d(88, {
                index: index
            });
            return;
        }
        this.clearRetryListeners();
        const { frameworkOverrides: frameworkOverrides, pageBounds: pageBounds, rowContainerHeight: heightScaler, rowRenderer: rowRenderer } = this.beans;
        frameworkOverrides.wrapIncoming(()=>{
            const gridBodyCtrl = this.ctrlsSvc.getGridBodyCtrl();
            const rowNode = rowModel.getRow(index);
            let rowGotShiftedDuringOperation;
            let stickyHeightsChanged;
            let attempt = 0;
            this.invalidateVerticalScroll();
            do {
                const { stickyTopHeight: stickyTopHeight, stickyBottomHeight: stickyBottomHeight } = gridBodyCtrl;
                const startingRowTop = rowNode.rowTop;
                const startingRowHeight = rowNode.rowHeight;
                const paginationOffset = pageBounds.getPixelOffset();
                const rowTopPixel = rowNode.rowTop - paginationOffset;
                const rowBottomPixel = rowTopPixel + rowNode.rowHeight;
                const scrollPosition = this.getVScrollPosition();
                const heightOffset = heightScaler.divStretchOffset;
                const vScrollTop = scrollPosition.top + heightOffset;
                const vScrollBottom = scrollPosition.bottom + heightOffset;
                const viewportHeight = vScrollBottom - vScrollTop;
                const pxTop = heightScaler.getScrollPositionForPixel(rowTopPixel);
                const pxBottom = heightScaler.getScrollPositionForPixel(rowBottomPixel - viewportHeight);
                const pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
                const rowAboveViewport = vScrollTop + stickyTopHeight > rowTopPixel;
                const rowBelowViewport = vScrollBottom - stickyBottomHeight < rowBottomPixel;
                let newScrollPosition = null;
                if (position === "top") newScrollPosition = pxTop - stickyTopHeight;
                else if (position === "bottom") newScrollPosition = pxBottom + stickyBottomHeight;
                else if (position === "middle") newScrollPosition = pxMiddle;
                else if (rowAboveViewport) newScrollPosition = pxTop - stickyTopHeight;
                else if (rowBelowViewport) {
                    if (pxBottom - pxTop > viewportHeight) newScrollPosition = pxTop - stickyTopHeight;
                    else newScrollPosition = pxBottom + stickyBottomHeight;
                }
                if (newScrollPosition !== null) {
                    this.setVerticalScrollPosition(newScrollPosition);
                    rowRenderer.redraw({
                        afterScroll: true
                    });
                }
                rowGotShiftedDuringOperation = startingRowTop !== rowNode.rowTop || startingRowHeight !== rowNode.rowHeight;
                stickyHeightsChanged = stickyTopHeight !== gridBodyCtrl.stickyTopHeight || stickyBottomHeight !== gridBodyCtrl.stickyBottomHeight;
                attempt++;
            }while ((rowGotShiftedDuringOperation || stickyHeightsChanged) && attempt < 10);
            this.animationFrameSvc?.flushAllFrames();
            if (retry < 10 && (rowNode?.stub || !this.beans.rowAutoHeight?.areRowsMeasured())) {
                const scrollTop = this.getVScrollPosition().top;
                this.clearRetryListenerFncs = this.addManagedEventListeners({
                    bodyScroll: ()=>{
                        const newScrollTop = this.getVScrollPosition().top;
                        if (scrollTop === newScrollTop) return;
                        this.clearRetryListeners();
                    },
                    modelUpdated: ()=>{
                        this.clearRetryListeners();
                        if (index >= rowModel.getRowCount()) return;
                        this.ensureIndexVisible(index, position, retry + 1);
                    }
                });
            }
        });
    }
    clearRetryListeners() {
        for (const callback of this.clearRetryListenerFncs)callback();
        this.clearRetryListenerFncs = [];
    }
    ensureColumnVisible(key, position = "auto") {
        const { colModel: colModel, frameworkOverrides: frameworkOverrides } = this.beans;
        const column = colModel.getCol(key);
        if (!column) return;
        if (column.isPinned()) return;
        if (!this.visibleCols.isColDisplayed(column)) return;
        const newHorizontalScroll = this.getPositionedHorizontalScroll(column, position);
        frameworkOverrides.wrapIncoming(()=>{
            if (newHorizontalScroll !== null) this.centerRowsCtrl.setCenterViewportScrollLeft(newHorizontalScroll);
            this.centerRowsCtrl.onHorizontalViewportChanged();
            this.animationFrameSvc?.flushAllFrames();
        });
    }
    getPositionedHorizontalScroll(column, position) {
        const { columnBeforeStart: columnBeforeStart, columnAfterEnd: columnAfterEnd } = this.isColumnOutsideViewport(column);
        const viewportTooSmallForColumn = this.centerRowsCtrl.getCenterWidth() < column.getActualWidth();
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const isRtl = this.enableRtl;
        let alignColToStart = (isRtl ? columnBeforeStart : columnAfterEnd) || viewportTooSmallForColumn;
        let alignColToEnd = isRtl ? columnAfterEnd : columnBeforeStart;
        if (position !== "auto") {
            alignColToStart = position === "start";
            alignColToEnd = position === "end";
        }
        const isMiddle = position === "middle";
        if (alignColToStart || alignColToEnd || isMiddle) {
            const { colLeft: colLeft, colMiddle: colMiddle, colRight: colRight } = this.getColumnBounds(column);
            if (isMiddle) return colMiddle - viewportWidth / 2;
            if (alignColToStart) return isRtl ? colRight : colLeft;
            return isRtl ? colLeft - viewportWidth : colRight - viewportWidth;
        }
        return null;
    }
    isColumnOutsideViewport(column) {
        const { start: viewportStart, end: viewportEnd } = this.getViewportBounds();
        const { colLeft: colLeft, colRight: colRight } = this.getColumnBounds(column);
        const isRtl = this.enableRtl;
        const columnBeforeStart = isRtl ? viewportStart > colRight : viewportEnd < colRight;
        const columnAfterEnd = isRtl ? viewportEnd < colLeft : viewportStart > colLeft;
        return {
            columnBeforeStart: columnBeforeStart,
            columnAfterEnd: columnAfterEnd
        };
    }
    getColumnBounds(column) {
        const isRtl = this.enableRtl;
        const bodyWidth = this.visibleCols.bodyWidth;
        const colWidth = column.getActualWidth();
        const colLeft = column.getLeft();
        const multiplier = isRtl ? -1 : 1;
        const colLeftPixel = isRtl ? bodyWidth - colLeft : colLeft;
        const colRightPixel = colLeftPixel + colWidth * multiplier;
        const colMidPixel = colLeftPixel + colWidth / 2 * multiplier;
        return {
            colLeft: colLeftPixel,
            colMiddle: colMidPixel,
            colRight: colRightPixel
        };
    }
    getViewportBounds() {
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const scrollPosition = this.centerRowsCtrl.getCenterViewportScrollLeft();
        const viewportStartPixel = scrollPosition;
        const viewportEndPixel = viewportWidth + scrollPosition;
        return {
            start: viewportStartPixel,
            end: viewportEndPixel,
            width: viewportWidth
        };
    }
};
// packages/ag-grid-community/src/gridBodyComp/centerWidthFeature.ts
var $437b23f6a393c3bf$var$CenterWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(callback, addSpacer = false){
        super();
        this.callback = callback;
        this.addSpacer = addSpacer;
    }
    postConstruct() {
        const listener = this.setWidth.bind(this);
        this.addManagedPropertyListener("domLayout", listener);
        this.addManagedEventListeners({
            columnContainerWidthChanged: listener,
            displayedColumnsChanged: listener,
            leftPinnedWidthChanged: listener
        });
        if (this.addSpacer) this.addManagedEventListeners({
            rightPinnedWidthChanged: listener,
            scrollVisibilityChanged: listener,
            scrollbarWidthChanged: listener
        });
        this.setWidth();
    }
    setWidth() {
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const { visibleCols: visibleCols, scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        const centerWidth = visibleCols.bodyWidth;
        const leftWidth = visibleCols.getColsLeftWidth();
        const rightWidth = visibleCols.getDisplayedColumnsRightWidth();
        let totalWidth;
        if (printLayout) totalWidth = centerWidth + leftWidth + rightWidth;
        else {
            totalWidth = centerWidth;
            if (this.addSpacer) {
                const relevantWidth = this.gos.get("enableRtl") ? leftWidth : rightWidth;
                if (relevantWidth === 0 && scrollVisibleSvc.verticalScrollShowing) totalWidth += scrollVisibleSvc.getScrollbarWidth();
            }
        }
        this.callback(totalWidth);
    }
};
// packages/ag-grid-community/src/gridBodyComp/viewportSizeFeature.ts
var $437b23f6a393c3bf$var$ViewportSizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(centerContainerCtrl){
        super();
        this.centerContainerCtrl = centerContainerCtrl;
    }
    wireBeans(beans) {
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.listenForResize();
        });
        this.addManagedEventListeners({
            scrollbarWidthChanged: this.onScrollbarWidthChanged.bind(this)
        });
        this.addManagedPropertyListeners([
            "alwaysShowHorizontalScroll",
            "alwaysShowVerticalScroll"
        ], ()=>{
            this.checkViewportAndScrolls();
        });
    }
    listenForResize() {
        const { beans: beans, centerContainerCtrl: centerContainerCtrl, gridBodyCtrl: gridBodyCtrl } = this;
        const listener = ()=>{
            $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>{
                this.onCenterViewportResized();
            });
        };
        centerContainerCtrl.registerViewportResizeListener(listener);
        gridBodyCtrl.registerBodyViewportResizeListener(listener);
    }
    onScrollbarWidthChanged() {
        this.checkViewportAndScrolls();
    }
    onCenterViewportResized() {
        this.scrollVisibleSvc.updateScrollGap();
        if (this.centerContainerCtrl.isViewportInTheDOMTree()) {
            const { pinnedCols: pinnedCols, colFlex: colFlex } = this.beans;
            pinnedCols?.keepPinnedColumnsNarrowerThanViewport();
            this.checkViewportAndScrolls();
            const newWidth = this.centerContainerCtrl.getCenterWidth();
            if (newWidth !== this.centerWidth) {
                this.centerWidth = newWidth;
                colFlex?.refreshFlexedColumns({
                    viewportWidth: this.centerWidth,
                    updateBodyWidths: true,
                    fireResizedEvent: true
                });
            }
        } else this.bodyHeight = 0;
    }
    // gets called every time the viewport size changes. we use this to check visibility of scrollbars
    // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
    checkViewportAndScrolls() {
        this.updateScrollVisibleService();
        this.checkBodyHeight();
        this.onHorizontalViewportChanged();
        this.gridBodyCtrl.scrollFeature.checkScrollLeft();
    }
    getBodyHeight() {
        return this.bodyHeight;
    }
    checkBodyHeight() {
        const eBodyViewport = this.gridBodyCtrl.eBodyViewport;
        const bodyHeight = $437b23f6a393c3bf$export$c20e968103d9c16e(eBodyViewport);
        if (this.bodyHeight !== bodyHeight) {
            this.bodyHeight = bodyHeight;
            this.eventSvc.dispatchEvent({
                type: "bodyHeightChanged"
            });
        }
    }
    updateScrollVisibleService() {
        this.updateScrollVisibleServiceImpl();
        setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
    }
    updateScrollVisibleServiceImpl() {
        if (!this.isAlive()) return;
        const params = {
            horizontalScrollShowing: this.centerContainerCtrl.isHorizontalScrollShowing(),
            verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
        };
        this.scrollVisibleSvc.setScrollsVisible(params);
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged() {
        const scrollWidth = this.centerContainerCtrl.getCenterWidth();
        const scrollPosition = this.centerContainerCtrl.getViewportScrollLeft();
        this.beans.colViewport.setScrollPosition(scrollWidth, scrollPosition);
    }
};
// packages/ag-grid-community/src/rendering/renderUtils.ts
function $437b23f6a393c3bf$export$d7866551eadae1d3(gos, column, node, event) {
    const suppressMouseEventHandling = column.getColDef().cellRendererParams?.suppressMouseEventHandling;
    return $437b23f6a393c3bf$var$suppressMouseEvent(gos, column, node, event, suppressMouseEventHandling);
}
function $437b23f6a393c3bf$var$_suppressFullWidthMouseEvent(gos, cellRendererParams, node, event) {
    const suppressMouseEventHandling = cellRendererParams?.suppressMouseEventHandling;
    return $437b23f6a393c3bf$var$suppressMouseEvent(gos, void 0, node, event, suppressMouseEventHandling);
}
function $437b23f6a393c3bf$var$suppressMouseEvent(gos, column, node, event, suppressMouseEventHandling) {
    if (!suppressMouseEventHandling) return false;
    return suppressMouseEventHandling($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        column: column,
        node: node,
        event: event
    }));
}
function $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, eventTarget, type) {
    let sourceElement = eventTarget;
    while(sourceElement){
        const renderedComp = $437b23f6a393c3bf$var$_getDomData(gos, sourceElement, type);
        if (renderedComp) return renderedComp;
        sourceElement = sourceElement.parentElement;
    }
    return null;
}
var $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL = "cellCtrl";
function $437b23f6a393c3bf$export$b5bf61dcea514250(gos, eventTarget) {
    return $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, eventTarget, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL);
}
var $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL = "renderedRow";
function $437b23f6a393c3bf$export$d06ffa2f01e3cdc7(gos, eventTarget) {
    return $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, eventTarget, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL);
}
// packages/ag-grid-community/src/utils/keyboardEvent.ts
function $437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(gos, keyboardEvent, rowNode, column, editing) {
    const colDefFunc = column ? column.getColDef().suppressKeyboardEvent : void 0;
    if (!colDefFunc) return false;
    const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        event: keyboardEvent,
        editing: editing,
        column: column,
        node: rowNode,
        data: rowNode.data,
        colDef: column.getColDef()
    });
    if (colDefFunc) {
        const colDefFuncResult = colDefFunc(params);
        if (colDefFuncResult) return true;
    }
    return false;
}
// packages/ag-grid-community/src/utils/selection.ts
function $437b23f6a393c3bf$export$57896ee3d2f5a3d(beans) {
    const { pinnedRowModel: pinnedRowModel, rowModel: rowModel, rangeSvc: rangeSvc, visibleCols: visibleCols } = beans;
    if (!rangeSvc || visibleCols.allCols.length === 0) return;
    const isEmptyPinnedTop = pinnedRowModel?.isEmpty("top") ?? true;
    const isEmptyPinnedBottom = pinnedRowModel?.isEmpty("bottom") ?? true;
    const floatingStart = isEmptyPinnedTop ? null : "top";
    let floatingEnd;
    let rowEnd;
    if (isEmptyPinnedBottom) {
        floatingEnd = null;
        rowEnd = rowModel.getRowCount() - 1;
    } else {
        floatingEnd = "bottom";
        rowEnd = pinnedRowModel?.getPinnedBottomRowCount() ?? -1;
    }
    rangeSvc.setCellRange({
        rowStartIndex: 0,
        rowStartPinned: floatingStart,
        rowEndIndex: rowEnd,
        rowEndPinned: floatingEnd
    });
}
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerEventsFeature.ts
var $437b23f6a393c3bf$var$RowContainerEventsFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(element){
        super();
        this.element = element;
    }
    postConstruct() {
        this.addKeyboardListeners();
        this.addMouseListeners();
        this.beans.touchSvc?.mockRowContextMenu(this);
        this.editSvc = this.beans.editSvc;
    }
    addKeyboardListeners() {
        const eventName = "keydown";
        const listener = this.processKeyboardEvent.bind(this, eventName);
        this.addManagedElementListeners(this.element, {
            [eventName]: listener
        });
    }
    addMouseListeners() {
        const mouseDownEvent = $437b23f6a393c3bf$var$_isEventSupported("touchstart") ? "touchstart" : "mousedown";
        const eventNames = [
            "dblclick",
            "contextmenu",
            "mouseover",
            "mouseout",
            "click",
            mouseDownEvent
        ];
        for (const eventName of eventNames){
            const listener = this.processMouseEvent.bind(this, eventName);
            this.addManagedElementListeners(this.element, {
                [eventName]: listener
            });
        }
    }
    processMouseEvent(eventName, mouseEvent) {
        if (!$437b23f6a393c3bf$var$_isEventFromThisInstance(this.beans, mouseEvent) || $437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(mouseEvent.target);
        if (eventName === "contextmenu") {
            if (cellCtrl?.column) cellCtrl.dispatchCellContextMenuEvent(mouseEvent);
            this.beans.contextMenuSvc?.handleContextMenuMouseEvent(mouseEvent, void 0, rowCtrl, cellCtrl);
        } else {
            if (cellCtrl) cellCtrl.onMouseEvent(eventName, mouseEvent);
            if (rowCtrl) rowCtrl.onMouseEvent(eventName, mouseEvent);
        }
    }
    getControlsForEventTarget(target) {
        const { gos: gos } = this;
        return {
            cellCtrl: $437b23f6a393c3bf$export$b5bf61dcea514250(gos, target),
            rowCtrl: $437b23f6a393c3bf$export$d06ffa2f01e3cdc7(gos, target)
        };
    }
    processKeyboardEvent(eventName, keyboardEvent) {
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(keyboardEvent.target);
        if (keyboardEvent.defaultPrevented) return;
        if (cellCtrl) this.processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent);
        else if (rowCtrl?.isFullWidth()) this.processFullWidthRowKeyboardEvent(rowCtrl, eventName, keyboardEvent);
    }
    processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent) {
        const editing = this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        }) ?? false;
        const gridProcessingAllowed = !$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, cellCtrl.rowNode, cellCtrl.column, editing);
        if (gridProcessingAllowed) {
            if (eventName === "keydown") {
                const wasScrollKey = !editing && this.beans.navigation?.handlePageScrollingKey(keyboardEvent);
                if (!wasScrollKey) cellCtrl.onKeyDown(keyboardEvent);
                this.doGridOperations(keyboardEvent, editing);
                if ($437b23f6a393c3bf$export$33ecd6e270298858(keyboardEvent)) cellCtrl.processCharacter(keyboardEvent);
            }
        }
        if (eventName === "keydown") this.eventSvc.dispatchEvent(cellCtrl.createEvent(keyboardEvent, "cellKeyDown"));
    }
    processFullWidthRowKeyboardEvent(rowCtrl, eventName, keyboardEvent) {
        const { rowNode: rowNode } = rowCtrl;
        const { focusSvc: focusSvc, navigation: navigation } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        const column = focusedCell?.column;
        const gridProcessingAllowed = !$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, rowNode, column, false);
        if (gridProcessingAllowed) {
            const key = keyboardEvent.key;
            if (eventName === "keydown") switch(key){
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
                    navigation?.handlePageScrollingKey(keyboardEvent, true);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                    if (!this.gos.get("embedFullWidthRows")) break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                    rowCtrl.onKeyboardNavigate(keyboardEvent);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                    rowCtrl.onTabKeyDown(keyboardEvent);
                    break;
                default:
            }
        }
        if (eventName === "keydown") this.eventSvc.dispatchEvent(rowCtrl.createRowEvent("cellKeyDown", keyboardEvent));
    }
    doGridOperations(keyboardEvent, editing) {
        if (!keyboardEvent.ctrlKey && !keyboardEvent.metaKey) return;
        if (editing) return;
        if (!$437b23f6a393c3bf$var$_isEventFromThisInstance(this.beans, keyboardEvent)) return;
        const keyCode = $437b23f6a393c3bf$var$_normaliseQwertyAzerty(keyboardEvent);
        const { clipboardSvc: clipboardSvc, undoRedo: undoRedo } = this.beans;
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.A) return this.onCtrlAndA(keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.C) return this.onCtrlAndC(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.D) return this.onCtrlAndD(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.V) return this.onCtrlAndV(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.X) return this.onCtrlAndX(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.Y) return this.onCtrlAndY(undoRedo);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.Z) return this.onCtrlAndZ(undoRedo, keyboardEvent);
    }
    onCtrlAndA(event) {
        const { beans: { rowModel: rowModel, rangeSvc: rangeSvc, selectionSvc: selectionSvc }, gos: gos } = this;
        if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) && !$437b23f6a393c3bf$var$_getCtrlASelectsRows(gos) && rowModel.isRowsToRender()) $437b23f6a393c3bf$export$57896ee3d2f5a3d(this.beans);
        else if (selectionSvc) selectionSvc.selectAllRowNodes({
            source: "keyboardSelectAll",
            selectAll: $437b23f6a393c3bf$var$_getSelectAll(gos)
        });
        event.preventDefault();
    }
    onCtrlAndC(clipboardSvc, event) {
        if (!clipboardSvc || this.gos.get("enableCellTextSelection")) return;
        const { cellCtrl: cellCtrl } = this.getControlsForEventTarget(event.target);
        if (this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        event.preventDefault();
        clipboardSvc.copyToClipboard();
    }
    onCtrlAndX(clipboardSvc, event) {
        if (!clipboardSvc || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard")) return;
        const { cellCtrl: cellCtrl } = this.getControlsForEventTarget(event.target);
        if (this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        event.preventDefault();
        clipboardSvc.cutToClipboard(void 0, "ui");
    }
    onCtrlAndV(clipboardSvc, event) {
        const { cellCtrl: cellCtrl } = this.getControlsForEventTarget(event.target);
        if (this.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        if (clipboardSvc && !this.gos.get("suppressClipboardPaste")) clipboardSvc.pasteFromClipboard();
    }
    onCtrlAndD(clipboardSvc, event) {
        if (clipboardSvc && !this.gos.get("suppressClipboardPaste")) clipboardSvc.copyRangeDown();
        event.preventDefault();
    }
    onCtrlAndZ(undoRedo, event) {
        if (!this.gos.get("undoRedoCellEditing") || !undoRedo) return;
        event.preventDefault();
        if (event.shiftKey) undoRedo.redo("ui");
        else undoRedo.undo("ui");
    }
    onCtrlAndY(undoRedo) {
        undoRedo?.redo("ui");
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/setHeightFeature.ts
var $437b23f6a393c3bf$var$SetHeightFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eContainer, eViewport){
        super();
        this.eContainer = eContainer;
        this.eViewport = eViewport;
    }
    postConstruct() {
        this.addManagedEventListeners({
            rowContainerHeightChanged: this.onHeightChanged.bind(this, this.beans.rowContainerHeight)
        });
    }
    onHeightChanged(maxDivHeightScaler) {
        const height = maxDivHeightScaler.uiContainerHeight;
        const heightString = height != null ? `${height}px` : ``;
        this.eContainer.style.height = heightString;
        if (this.eViewport) this.eViewport.style.height = heightString;
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerCtrl.ts
var $437b23f6a393c3bf$var$getTopRowCtrls = (r)=>r.topRowCtrls;
var $437b23f6a393c3bf$var$getStickyTopRowCtrls = (r)=>r.getStickyTopRowCtrls();
var $437b23f6a393c3bf$var$getStickyBottomRowCtrls = (r)=>r.getStickyBottomRowCtrls();
var $437b23f6a393c3bf$var$getBottomRowCtrls = (r)=>r.bottomRowCtrls;
var $437b23f6a393c3bf$var$getCentreRowCtrls = (r)=>r.allRowCtrls;
var $437b23f6a393c3bf$var$getSpannedTopRowCtrls = (r)=>r.getCtrls("top");
var $437b23f6a393c3bf$var$getSpannedCenterRowCtrls = (r)=>r.getCtrls("center");
var $437b23f6a393c3bf$var$getSpannedBottomRowCtrls = (r)=>r.getCtrls("bottom");
var $437b23f6a393c3bf$var$ContainerCssClasses = {
    center: {
        type: "center",
        name: "center-cols",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    left: {
        type: "left",
        name: "pinned-left-cols",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    right: {
        type: "right",
        name: "pinned-right-cols",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    fullWidth: {
        type: "fullWidth",
        name: "full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls
    },
    topCenter: {
        type: "center",
        name: "floating-top",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topLeft: {
        type: "left",
        name: "pinned-left-floating",
        container: "ag-pinned-left-floating-top",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topRight: {
        type: "right",
        name: "pinned-right-floating",
        container: "ag-pinned-right-floating-top",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topFullWidth: {
        type: "fullWidth",
        name: "floating-top-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls
    },
    stickyTopCenter: {
        type: "center",
        name: "sticky-top",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopLeft: {
        type: "left",
        name: "pinned-left-sticky-top",
        container: "ag-pinned-left-sticky-top",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopRight: {
        type: "right",
        name: "pinned-right-sticky-top",
        container: "ag-pinned-right-sticky-top",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopFullWidth: {
        type: "fullWidth",
        name: "sticky-top-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyBottomCenter: {
        type: "center",
        name: "sticky-bottom",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomLeft: {
        type: "left",
        name: "pinned-left-sticky-bottom",
        container: "ag-pinned-left-sticky-bottom",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomRight: {
        type: "right",
        name: "pinned-right-sticky-bottom",
        container: "ag-pinned-right-sticky-bottom",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomFullWidth: {
        type: "fullWidth",
        name: "sticky-bottom-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    bottomCenter: {
        type: "center",
        name: "floating-bottom",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomLeft: {
        type: "left",
        name: "pinned-left-floating-bottom",
        container: "ag-pinned-left-floating-bottom",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomRight: {
        type: "right",
        name: "pinned-right-floating-bottom",
        container: "ag-pinned-right-floating-bottom",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomFullWidth: {
        type: "fullWidth",
        name: "floating-bottom-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls
    }
};
function $437b23f6a393c3bf$export$65619730ec980d6a(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return `ag-${options.name}-viewport`;
}
function $437b23f6a393c3bf$export$35e1b2dddf7fc6e9(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return options.container ?? `ag-${options.name}-container`;
}
function $437b23f6a393c3bf$export$cd6b90bdf6c4fcfd(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return `ag-${options.name}-spanned-cells-container`;
}
function $437b23f6a393c3bf$export$a46aad9f8c79261f(name) {
    return $437b23f6a393c3bf$var$ContainerCssClasses[name];
}
var $437b23f6a393c3bf$var$allTopNoFW = [
    "topCenter",
    "topLeft",
    "topRight"
];
var $437b23f6a393c3bf$var$allBottomNoFW = [
    "bottomCenter",
    "bottomLeft",
    "bottomRight"
];
var $437b23f6a393c3bf$var$allMiddleNoFW = [
    "center",
    "left",
    "right"
];
var $437b23f6a393c3bf$var$allMiddle = [
    "center",
    "left",
    "right",
    "fullWidth"
];
var $437b23f6a393c3bf$var$allCenter = [
    "stickyTopCenter",
    "stickyBottomCenter",
    "center",
    "topCenter",
    "bottomCenter"
];
var $437b23f6a393c3bf$var$allLeft = [
    "left",
    "bottomLeft",
    "topLeft",
    "stickyTopLeft",
    "stickyBottomLeft"
];
var $437b23f6a393c3bf$var$allRight = [
    "right",
    "bottomRight",
    "topRight",
    "stickyTopRight",
    "stickyBottomRight"
];
var $437b23f6a393c3bf$var$allStickyTopNoFW = [
    "stickyTopCenter",
    "stickyTopLeft",
    "stickyTopRight"
];
var $437b23f6a393c3bf$var$allStickyBottomNoFW = [
    "stickyBottomCenter",
    "stickyBottomLeft",
    "stickyBottomRight"
];
var $437b23f6a393c3bf$var$allStickyContainers = [
    ...$437b23f6a393c3bf$var$allStickyTopNoFW,
    "stickyTopFullWidth",
    ...$437b23f6a393c3bf$var$allStickyBottomNoFW,
    "stickyBottomFullWidth"
];
var $437b23f6a393c3bf$var$allNoFW = [
    ...$437b23f6a393c3bf$var$allTopNoFW,
    ...$437b23f6a393c3bf$var$allBottomNoFW,
    ...$437b23f6a393c3bf$var$allMiddleNoFW,
    ...$437b23f6a393c3bf$var$allStickyTopNoFW,
    ...$437b23f6a393c3bf$var$allStickyBottomNoFW
];
var $437b23f6a393c3bf$export$2d4385f6f566fe5e = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(name){
        super();
        this.name = name;
        this.visible = true;
        // Maintaining a constant reference enables optimization in React.
        this.EMPTY_CTRLS = [];
        this.options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        this.forContainers([
            "center"
        ], ()=>{
            this.viewportSizeFeature = this.createManagedBean(new $437b23f6a393c3bf$var$ViewportSizeFeature(this));
            this.addManagedEventListeners({
                stickyTopOffsetChanged: this.onStickyTopOffsetChanged.bind(this)
            });
        });
    }
    onStickyTopOffsetChanged(event) {
        this.comp.setOffsetTop(`${event.offset}px`);
    }
    registerWithCtrlsService() {
        if (this.options.fullWidth) return;
        this.beans.ctrlsSvc.register(this.name, this);
    }
    forContainers(names, callback) {
        if (names.indexOf(this.name) >= 0) callback();
    }
    setComp(view, eContainer, eSpannedContainer, eViewport) {
        this.comp = view;
        this.eContainer = eContainer;
        this.eSpannedContainer = eSpannedContainer;
        this.eViewport = eViewport;
        this.createManagedBean(new $437b23f6a393c3bf$var$RowContainerEventsFeature(this.eViewport ?? this.eContainer));
        this.addPreventScrollWhileDragging();
        this.listenOnDomOrder();
        const { pinnedCols: pinnedCols, rangeSvc: rangeSvc } = this.beans;
        const pinnedWidthChanged = ()=>this.onPinnedWidthChanged();
        this.forContainers($437b23f6a393c3bf$var$allLeft, ()=>{
            this.pinnedWidthFeature = this.createOptionalManagedBean(pinnedCols?.createPinnedWidthFeature(true, this.eContainer, this.eSpannedContainer));
            this.addManagedEventListeners({
                leftPinnedWidthChanged: pinnedWidthChanged
            });
        });
        this.forContainers($437b23f6a393c3bf$var$allRight, ()=>{
            this.pinnedWidthFeature = this.createOptionalManagedBean(pinnedCols?.createPinnedWidthFeature(false, this.eContainer, this.eSpannedContainer));
            this.addManagedEventListeners({
                rightPinnedWidthChanged: pinnedWidthChanged
            });
        });
        this.forContainers($437b23f6a393c3bf$var$allMiddle, ()=>this.createManagedBean(new $437b23f6a393c3bf$var$SetHeightFeature(this.eContainer, this.name === "center" ? eViewport : void 0)));
        if (rangeSvc) this.forContainers($437b23f6a393c3bf$var$allNoFW, ()=>this.createManagedBean(rangeSvc.createDragListenerFeature(this.eContainer)));
        this.forContainers($437b23f6a393c3bf$var$allCenter, ()=>this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.comp.setContainerWidth(`${width}px`))));
        this.visible = this.isContainerVisible();
        this.addListeners();
        this.registerWithCtrlsService();
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
    addListeners() {
        const { spannedRowRenderer: spannedRowRenderer, gos: gos } = this.beans;
        const onDisplayedColumnsChanged = this.onDisplayedColumnsChanged.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: onDisplayedColumnsChanged,
            displayedColumnsWidthChanged: onDisplayedColumnsChanged,
            displayedRowsChanged: (params)=>this.onDisplayedRowsChanged(params.afterScroll)
        });
        onDisplayedColumnsChanged();
        this.onDisplayedRowsChanged();
        if (spannedRowRenderer && this.options.getSpannedRowCtrls && gos.get("enableCellSpan")) this.addManagedListeners(spannedRowRenderer, {
            spannedRowsUpdated: ()=>{
                const spannedCtrls = this.options.getSpannedRowCtrls(spannedRowRenderer);
                if (!spannedCtrls) return;
                this.comp.setSpannedRowCtrls(spannedCtrls, false);
            }
        });
    }
    listenOnDomOrder() {
        const isStickContainer = $437b23f6a393c3bf$var$allStickyContainers.indexOf(this.name) >= 0;
        if (isStickContainer) {
            this.comp.setDomOrder(true);
            return;
        }
        const listener = ()=>{
            const isEnsureDomOrder = this.gos.get("ensureDomOrder");
            const isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
            this.comp.setDomOrder(isEnsureDomOrder || isPrintLayout);
        };
        this.addManagedPropertyListener("domLayout", listener);
        listener();
    }
    onDisplayedColumnsChanged() {
        this.forContainers([
            "center"
        ], ()=>this.onHorizontalViewportChanged());
    }
    // this methods prevents the grid views from being scrolled while the dragService is being used
    // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
    addPreventScrollWhileDragging() {
        const { dragSvc: dragSvc } = this.beans;
        if (!dragSvc) return;
        const preventScroll = (e)=>{
            if (dragSvc.dragging) {
                if (e.cancelable) e.preventDefault();
            }
        };
        this.eContainer.addEventListener("touchmove", preventScroll, {
            passive: false
        });
        this.addDestroyFunc(()=>this.eContainer.removeEventListener("touchmove", preventScroll));
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged(afterScroll = false) {
        const scrollWidth = this.getCenterWidth();
        const scrollPosition = this.getCenterViewportScrollLeft();
        this.beans.colViewport.setScrollPosition(scrollWidth, scrollPosition, afterScroll);
    }
    hasHorizontalScrollGap() {
        return this.eContainer.clientWidth - this.eViewport.clientWidth < 0;
    }
    hasVerticalScrollGap() {
        return this.eContainer.clientHeight - this.eViewport.clientHeight < 0;
    }
    getCenterWidth() {
        return $437b23f6a393c3bf$export$cc615e4191ec3e0c(this.eViewport);
    }
    getCenterViewportScrollLeft() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    registerViewportResizeListener(listener) {
        const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eViewport, listener);
        this.addDestroyFunc(()=>unsubscribeFromResize());
    }
    isViewportInTheDOMTree() {
        return $437b23f6a393c3bf$var$_isInDOM(this.eViewport);
    }
    getViewportScrollLeft() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    isHorizontalScrollShowing() {
        const isAlwaysShowHorizontalScroll = this.gos.get("alwaysShowHorizontalScroll");
        return isAlwaysShowHorizontalScroll || $437b23f6a393c3bf$var$_isHorizontalScrollShowing(this.eViewport);
    }
    setHorizontalScroll(offset) {
        this.comp.setHorizontalScroll(offset);
    }
    getHScrollPosition() {
        const res = {
            left: this.eViewport.scrollLeft,
            right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
        };
        return res;
    }
    setCenterViewportScrollLeft(value) {
        $437b23f6a393c3bf$var$_setScrollLeft(this.eViewport, value, this.enableRtl);
    }
    isContainerVisible() {
        const pinned = this.options.pinnedType != null;
        return !pinned || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
    }
    onPinnedWidthChanged() {
        const visible = this.isContainerVisible();
        if (this.visible != visible) {
            this.visible = visible;
            this.onDisplayedRowsChanged();
        }
    }
    onDisplayedRowsChanged(afterScroll = false) {
        const rows = this.options.getRowCtrls(this.beans.rowRenderer);
        if (!this.visible || rows.length === 0) {
            this.comp.setRowCtrls({
                rowCtrls: this.EMPTY_CTRLS
            });
            return;
        }
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const embedFullWidthRows = this.gos.get("embedFullWidthRows");
        const embedFW = embedFullWidthRows || printLayout;
        const rowsThisContainer = rows.filter((rowCtrl)=>{
            const fullWidthRow = rowCtrl.isFullWidth();
            const match = this.options.fullWidth ? !embedFW && fullWidthRow : embedFW || !fullWidthRow;
            return match;
        });
        this.comp.setRowCtrls({
            rowCtrls: rowsThisContainer,
            useFlushSync: afterScroll
        });
    }
};
// packages/ag-grid-community/src/gridBodyComp/gridBodyCtrl.ts
var $437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL = "ag-force-vertical-scroll";
var $437b23f6a393c3bf$var$CSS_CLASS_CELL_SELECTABLE = "ag-selectable";
var $437b23f6a393c3bf$var$CSS_CLASS_COLUMN_MOVING = "ag-column-moving";
var $437b23f6a393c3bf$export$8bebc3145b40d221 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.stickyTopHeight = 0;
        this.stickyBottomHeight = 0;
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.colModel = beans.colModel;
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
        this.pinnedRowModel = beans.pinnedRowModel;
        this.filterManager = beans.filterManager;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
    }
    setComp(comp, eGridBody, eBodyViewport, eTop, eBottom, eStickyTop, eStickyBottom) {
        this.comp = comp;
        this.eGridBody = eGridBody;
        this.eBodyViewport = eBodyViewport;
        this.eTop = eTop;
        this.eBottom = eBottom;
        this.eStickyTop = eStickyTop;
        this.eStickyBottom = eStickyBottom;
        this.eCenterColsViewport = eBodyViewport.querySelector(`.${$437b23f6a393c3bf$export$65619730ec980d6a("center")}`);
        this.eFullWidthContainer = eBodyViewport.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("fullWidth")}`);
        this.eStickyTopFullWidthContainer = eStickyTop.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("stickyTopFullWidth")}`);
        this.eStickyBottomFullWidthContainer = eStickyBottom.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("stickyBottomFullWidth")}`);
        this.setCellTextSelection(this.gos.get("enableCellTextSelection"));
        this.addManagedPropertyListener("enableCellTextSelection", (props)=>this.setCellTextSelection(props.currentValue));
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this.comp));
        this.scrollFeature = this.createManagedBean(new $437b23f6a393c3bf$var$GridBodyScrollFeature(eBodyViewport));
        this.beans.rowDragSvc?.setupRowDrag(eBodyViewport, this);
        this.setupRowAnimationCssClass();
        this.addEventListeners();
        this.addFocusListeners([
            eTop,
            eBodyViewport,
            eBottom,
            eStickyTop,
            eStickyBottom
        ]);
        this.setGridRootRole();
        this.onGridColumnsChanged();
        this.addBodyViewportListener();
        this.setFloatingHeights();
        this.disableBrowserDragging();
        this.addStopEditingWhenGridLosesFocus();
        this.updateScrollingClasses();
        this.filterManager?.setupAdvFilterHeaderComp(eTop);
        this.ctrlsSvc.register("gridBodyCtrl", this);
    }
    addEventListeners() {
        const setFloatingHeights = this.setFloatingHeights.bind(this);
        const setGridRootRole = this.setGridRootRole.bind(this);
        const toggleRowResizeStyle = this.toggleRowResizeStyles.bind(this);
        this.addManagedEventListeners({
            gridColumnsChanged: this.onGridColumnsChanged.bind(this),
            scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this),
            scrollGapChanged: this.updateScrollingClasses.bind(this),
            pinnedRowDataChanged: setFloatingHeights,
            pinnedHeightChanged: setFloatingHeights,
            pinnedRowsChanged: setFloatingHeights,
            headerHeightChanged: this.setStickyTopOffsetTop.bind(this),
            columnRowGroupChanged: setGridRootRole,
            columnPivotChanged: setGridRootRole,
            rowResizeStarted: toggleRowResizeStyle,
            rowResizeEnded: toggleRowResizeStyle
        });
        this.addManagedPropertyListener("treeData", setGridRootRole);
    }
    toggleRowResizeStyles(params) {
        const isResizingRow = params.type === "rowResizeStarted";
        this.eBodyViewport.classList.toggle("ag-prevent-animation", isResizingRow);
    }
    onGridColumnsChanged() {
        const columns = this.beans.colModel.getCols();
        this.comp.setColumnCount(columns.length);
    }
    onScrollVisibilityChanged() {
        const { scrollVisibleSvc: scrollVisibleSvc } = this;
        const visible = scrollVisibleSvc.verticalScrollShowing;
        this.setVerticalScrollPaddingVisible(visible);
        this.setStickyWidth(visible);
        this.setStickyBottomOffsetBottom();
        const scrollbarWidth = visible ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const pad = $437b23f6a393c3bf$var$_isInvisibleScrollbar() ? 16 : 0;
        const width = `calc(100% + ${scrollbarWidth + pad}px)`;
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>this.comp.setBodyViewportWidth(width));
        this.updateScrollingClasses();
    }
    setGridRootRole() {
        const { rowGroupColsSvc: rowGroupColsSvc, colModel: colModel, gos: gos } = this;
        let isTreeGrid = gos.get("treeData");
        if (!isTreeGrid) {
            const isPivotActive = colModel.isPivotMode();
            const rowGroupColumnLen = !rowGroupColsSvc ? 0 : rowGroupColsSvc.columns.length;
            const columnsNeededForGrouping = isPivotActive ? 2 : 1;
            isTreeGrid = rowGroupColumnLen >= columnsNeededForGrouping;
        }
        this.comp.setGridRootRole(isTreeGrid ? "treegrid" : "grid");
    }
    addFocusListeners(elements) {
        for (const element of elements)this.addManagedElementListeners(element, {
            focusin: (e)=>{
                const { target: target } = e;
                const isFocusedElementNested = $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-root", element);
                element.classList.toggle("ag-has-focus", !isFocusedElementNested);
            },
            focusout: (e)=>{
                const { target: target, relatedTarget: relatedTarget } = e;
                const gridContainRelatedTarget = element.contains(relatedTarget);
                const isNestedRelatedTarget = $437b23f6a393c3bf$var$_isElementChildOfClass(relatedTarget, "ag-root", element);
                const isNestedTarget = $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-root", element);
                if (isNestedTarget) return;
                if (!gridContainRelatedTarget || isNestedRelatedTarget) element.classList.remove("ag-has-focus");
            }
        });
    }
    // used by ColumnAnimationService
    setColumnMovingCss(moving) {
        this.comp.setColumnMovingCss($437b23f6a393c3bf$var$CSS_CLASS_COLUMN_MOVING, moving);
    }
    setCellTextSelection(selectable = false) {
        this.comp.setCellSelectableCss($437b23f6a393c3bf$var$CSS_CLASS_CELL_SELECTABLE, selectable);
    }
    updateScrollingClasses() {
        const { eGridBody: { classList: classList }, scrollVisibleSvc: scrollVisibleSvc } = this;
        classList.toggle("ag-body-vertical-content-no-gap", !scrollVisibleSvc.verticalScrollGap);
        classList.toggle("ag-body-horizontal-content-no-gap", !scrollVisibleSvc.horizontalScrollGap);
    }
    // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
    disableBrowserDragging() {
        this.addManagedElementListeners(this.eGridBody, {
            dragstart: (event)=>{
                if (event.target instanceof HTMLImageElement) {
                    event.preventDefault();
                    return false;
                }
            }
        });
    }
    addStopEditingWhenGridLosesFocus() {
        this.beans.editSvc?.addStopEditingWhenGridLosesFocus([
            this.eBodyViewport,
            this.eBottom,
            this.eTop,
            this.eStickyTop,
            this.eStickyBottom
        ]);
    }
    updateRowCount() {
        const headerCount = (this.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0) + (this.filterManager?.getHeaderRowCount() ?? 0);
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.isLastRowIndexKnown() ? rowModel.getRowCount() : -1;
        const total = rowCount === -1 ? -1 : headerCount + rowCount;
        this.comp.setRowCount(total);
    }
    registerBodyViewportResizeListener(listener) {
        this.comp.registerBodyViewportResizeListener(listener);
    }
    setVerticalScrollPaddingVisible(visible) {
        const overflowY = visible ? "scroll" : "hidden";
        this.comp.setPinnedTopBottomOverflowY(overflowY);
    }
    isVerticalScrollShowing() {
        const show = this.gos.get("alwaysShowVerticalScroll");
        const cssClass = show ? $437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL : null;
        const allowVerticalScroll = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        this.comp.setAlwaysVerticalScrollClass(cssClass, show);
        return show || allowVerticalScroll && $437b23f6a393c3bf$var$_isVerticalScrollShowing(this.eBodyViewport);
    }
    setupRowAnimationCssClass() {
        const { rowContainerHeight: rowContainerHeight, environment: environment } = this.beans;
        let initialSizeMeasurementComplete = environment.sizesMeasured;
        const updateAnimationClass = ()=>{
            const animateRows = initialSizeMeasurementComplete && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos) && !rowContainerHeight.stretching;
            const animateRowsCssClass = animateRows ? "ag-row-animation" : "ag-row-no-animation";
            this.comp.setRowAnimationCssOnBodyViewport(animateRowsCssClass, animateRows);
        };
        updateAnimationClass();
        this.addManagedEventListeners({
            heightScaleChanged: updateAnimationClass
        });
        this.addManagedPropertyListener("animateRows", updateAnimationClass);
        this.addManagedEventListeners({
            stylesChanged: ()=>{
                if (!initialSizeMeasurementComplete && environment.sizesMeasured) {
                    initialSizeMeasurementComplete = true;
                    updateAnimationClass();
                }
            }
        });
    }
    addBodyViewportListener() {
        const { eBodyViewport: eBodyViewport, eStickyTop: eStickyTop, eStickyBottom: eStickyBottom, eTop: eTop, eBottom: eBottom, beans: { popupSvc: popupSvc, touchSvc: touchSvc } } = this;
        const listener = this.onBodyViewportContextMenu.bind(this);
        this.addManagedElementListeners(eBodyViewport, {
            contextmenu: listener
        });
        touchSvc?.mockBodyContextMenu(this, listener);
        this.addManagedElementListeners(eBodyViewport, {
            wheel: this.onBodyViewportWheel.bind(this, popupSvc)
        });
        const onStickyWheel = this.onStickyWheel.bind(this);
        for (const container of [
            eStickyTop,
            eStickyBottom,
            eTop,
            eBottom
        ])this.addManagedElementListeners(container, {
            wheel: onStickyWheel
        });
        const onHorizontalWheel = this.onHorizontalWheel.bind(this);
        for (const container of [
            "left",
            "right",
            "topLeft",
            "topRight",
            "bottomLeft",
            "bottomRight"
        ])this.addManagedElementListeners(this.ctrlsSvc.get(container).eContainer, {
            wheel: onHorizontalWheel
        });
        this.addFullWidthContainerWheelListener();
    }
    addFullWidthContainerWheelListener() {
        this.addManagedElementListeners(this.eFullWidthContainer, {
            wheel: (e)=>this.onFullWidthContainerWheel(e)
        });
    }
    onFullWidthContainerWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey } = e;
        const isHorizontalScroll = shiftKey || Math.abs(deltaX) > Math.abs(deltaY);
        if (isHorizontalScroll && $437b23f6a393c3bf$var$_isEventFromThisInstance(this.beans, e)) this.scrollGridBodyToMatchEvent(e);
    }
    onStickyWheel(e) {
        const { deltaY: deltaY } = e;
        const scrolled = this.scrollVertically(deltaY);
        if (scrolled > 0) e.preventDefault();
    }
    onHorizontalWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey } = e;
        const isHorizontalScroll = shiftKey || Math.abs(deltaX) > Math.abs(deltaY);
        if (!isHorizontalScroll) return;
        this.scrollGridBodyToMatchEvent(e);
    }
    scrollGridBodyToMatchEvent(e) {
        const { deltaX: deltaX, deltaY: deltaY } = e;
        e.preventDefault();
        this.eCenterColsViewport.scrollBy({
            left: deltaX || deltaY
        });
    }
    onBodyViewportContextMenu(mouseEvent, touch, touchEvent) {
        if (!mouseEvent && !touchEvent) return;
        if (this.gos.get("preventDefaultOnContextMenu")) {
            const event = mouseEvent || touchEvent;
            event.preventDefault();
        }
        const { target: target } = mouseEvent || touch;
        if (target === this.eBodyViewport || target === this.ctrlsSvc.get("center").eViewport) this.beans.contextMenuSvc?.showContextMenu({
            mouseEvent: mouseEvent,
            touchEvent: touchEvent,
            value: null,
            anchorToElement: this.eGridBody,
            source: "ui"
        });
    }
    onBodyViewportWheel(popupSvc, e) {
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) return;
        if (popupSvc?.hasAnchoredPopup()) e.preventDefault();
    }
    // called by rowDragFeature
    scrollVertically(pixels) {
        const oldScrollPosition = this.eBodyViewport.scrollTop;
        this.scrollFeature.setVerticalScrollPosition(oldScrollPosition + pixels);
        return this.eBodyViewport.scrollTop - oldScrollPosition;
    }
    setFloatingHeights() {
        const { pinnedRowModel: pinnedRowModel, beans: { environment: environment } } = this;
        const floatingTopHeight = pinnedRowModel?.getPinnedTopTotalHeight();
        const floatingBottomHeight = pinnedRowModel?.getPinnedBottomTotalHeight();
        const pinnedBorderWidth = environment.getPinnedRowBorderWidth();
        const rowBorderWidth = environment.getRowBorderWidth();
        const additionalHeight = pinnedBorderWidth - rowBorderWidth;
        const normalisedFloatingTopHeight = !floatingTopHeight ? 0 : additionalHeight + floatingTopHeight;
        const normalisedFloatingBottomHeight = !floatingBottomHeight ? 0 : additionalHeight + floatingBottomHeight;
        this.comp.setTopHeight(normalisedFloatingTopHeight);
        this.comp.setBottomHeight(normalisedFloatingBottomHeight);
        this.comp.setTopInvisible(normalisedFloatingTopHeight <= 0);
        this.comp.setBottomInvisible(normalisedFloatingBottomHeight <= 0);
        this.setStickyTopOffsetTop();
        this.setStickyBottomOffsetBottom();
    }
    setStickyTopHeight(height = 0) {
        this.comp.setStickyTopHeight(`${height}px`);
        this.stickyTopHeight = height;
    }
    setStickyBottomHeight(height = 0) {
        this.comp.setStickyBottomHeight(`${height}px`);
        this.stickyBottomHeight = height;
    }
    setStickyWidth(vScrollVisible) {
        if (!vScrollVisible) {
            this.comp.setStickyTopWidth("100%");
            this.comp.setStickyBottomWidth("100%");
        } else {
            const scrollbarWidth = this.scrollVisibleSvc.getScrollbarWidth();
            this.comp.setStickyTopWidth(`calc(100% - ${scrollbarWidth}px)`);
            this.comp.setStickyBottomWidth(`calc(100% - ${scrollbarWidth}px)`);
        }
    }
    setStickyTopOffsetTop() {
        const headerCtrl = this.ctrlsSvc.get("gridHeaderCtrl");
        const headerHeight = headerCtrl.headerHeight + (this.filterManager?.getHeaderHeight() ?? 0);
        const pinnedTopHeight = this.pinnedRowModel?.getPinnedTopTotalHeight() ?? 0;
        let height = 0;
        if (headerHeight > 0) height += headerHeight;
        if (pinnedTopHeight > 0) height += pinnedTopHeight;
        if (height > 0) height += 1;
        this.comp.setStickyTopTop(`${height}px`);
    }
    setStickyBottomOffsetBottom() {
        const { pinnedRowModel: pinnedRowModel, scrollVisibleSvc: scrollVisibleSvc, comp: comp } = this;
        const pinnedBottomHeight = pinnedRowModel?.getPinnedBottomTotalHeight() ?? 0;
        const hScrollShowing = scrollVisibleSvc.horizontalScrollShowing;
        const scrollbarWidth = hScrollShowing ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const height = pinnedBottomHeight + scrollbarWidth;
        comp.setStickyBottomBottom(`${height}px`);
    }
};
// packages/ag-grid-community/src/gridBodyComp/mouseEventUtils.ts
function $437b23f6a393c3bf$export$d85fcb0e6e51242(gos, event) {
    return $437b23f6a393c3bf$export$b5bf61dcea514250(gos, event.target)?.getFocusedCellPosition() ?? null;
}
function $437b23f6a393c3bf$export$530c24bdfacb8cd1(beans, event) {
    const gridPanelHasScrolls = $437b23f6a393c3bf$export$aa3ea9d0da61306f(beans.gos, "normal");
    const e = event;
    let x;
    let y;
    if (e.clientX != null || e.clientY != null) {
        x = e.clientX;
        y = e.clientY;
    } else {
        x = e.x;
        y = e.y;
    }
    const { pageFirstPixel: pageFirstPixel } = beans.pageBounds.getCurrentPagePixelRange();
    y += pageFirstPixel;
    if (gridPanelHasScrolls) {
        const scrollFeature = beans.ctrlsSvc.getScrollFeature();
        const vRange = scrollFeature.getVScrollPosition();
        const hRange = scrollFeature.getHScrollPosition();
        x += hRange.left;
        y += vRange.top;
    }
    return {
        x: x,
        y: y
    };
}
// packages/ag-grid-community/src/gridBodyComp/abstractFakeScrollComp.ts
var $437b23f6a393c3bf$var$AbstractFakeScrollComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(template, direction){
        super();
        this.direction = direction;
        this.eViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.hideTimeout = 0;
        this.setTemplate(template);
    }
    postConstruct() {
        this.addManagedEventListeners({
            scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this)
        });
        this.onScrollVisibilityChanged();
        this.toggleCss("ag-apple-scrollbar", $437b23f6a393c3bf$var$_isMacOsUserAgent() || $437b23f6a393c3bf$export$6b6034a68325bd8a());
    }
    destroy() {
        super.destroy();
        window.clearTimeout(this.hideTimeout);
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.invisibleScrollbar = $437b23f6a393c3bf$var$_isInvisibleScrollbar();
        if (this.invisibleScrollbar) {
            this.hideAndShowInvisibleScrollAsNeeded();
            this.addActiveListenerToggles();
        }
    }
    addActiveListenerToggles() {
        const eGui = this.getGui();
        const onActivate = ()=>this.toggleCss("ag-scrollbar-active", true);
        const onDeactivate = ()=>this.toggleCss("ag-scrollbar-active", false);
        this.addManagedListeners(eGui, {
            mouseenter: onActivate,
            mousedown: onActivate,
            touchstart: onActivate,
            mouseleave: onDeactivate,
            touchend: onDeactivate
        });
    }
    onScrollVisibilityChanged() {
        if (this.invisibleScrollbar === void 0) this.initialiseInvisibleScrollbar();
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>this.setScrollVisible());
    }
    hideAndShowInvisibleScrollAsNeeded() {
        this.addManagedEventListeners({
            bodyScroll: (params)=>{
                if (params.direction === this.direction) {
                    if (this.hideTimeout) {
                        window.clearTimeout(this.hideTimeout);
                        this.hideTimeout = 0;
                    }
                    this.toggleCss("ag-scrollbar-scrolling", true);
                }
            },
            bodyScrollEnd: ()=>{
                this.hideTimeout = window.setTimeout(()=>{
                    this.toggleCss("ag-scrollbar-scrolling", false);
                    this.hideTimeout = 0;
                }, 400);
            }
        });
    }
    attemptSettingScrollPosition(value) {
        const viewport = this.eViewport;
        $437b23f6a393c3bf$export$b863e7aac7884b8(this, ()=>$437b23f6a393c3bf$export$2badf4aa566524cb(viewport), ()=>this.setScrollPosition(value), 100);
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
};
// packages/ag-grid-community/src/gridBodyComp/fakeHScrollComp.ts
var $437b23f6a393c3bf$var$FakeHScrollElement = {
    tag: "div",
    cls: "ag-body-horizontal-scroll",
    attrs: {
        "aria-hidden": "true"
    },
    children: [
        {
            tag: "div",
            ref: "eLeftSpacer",
            cls: "ag-horizontal-left-spacer"
        },
        {
            tag: "div",
            ref: "eViewport",
            cls: "ag-body-horizontal-scroll-viewport",
            children: [
                {
                    tag: "div",
                    ref: "eContainer",
                    cls: "ag-body-horizontal-scroll-container"
                }
            ]
        },
        {
            tag: "div",
            ref: "eRightSpacer",
            cls: "ag-horizontal-right-spacer"
        }
    ]
};
var $437b23f6a393c3bf$export$8f252e09ef6be2d3 = class extends $437b23f6a393c3bf$var$AbstractFakeScrollComp {
    constructor(){
        super($437b23f6a393c3bf$var$FakeHScrollElement, "horizontal");
        this.eLeftSpacer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eRightSpacer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.setScrollVisibleDebounce = 0;
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
    }
    postConstruct() {
        super.postConstruct();
        const spacerWidthsListener = this.setFakeHScrollSpacerWidths.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: spacerWidthsListener,
            displayedColumnsWidthChanged: spacerWidthsListener,
            pinnedRowDataChanged: this.refreshCompBottom.bind(this)
        });
        this.addManagedPropertyListener("domLayout", spacerWidthsListener);
        this.beans.ctrlsSvc.register("fakeHScrollComp", this);
        this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.eContainer.style.width = `${width}px`));
        this.addManagedPropertyListeners([
            "suppressHorizontalScroll"
        ], this.onScrollVisibilityChanged.bind(this));
    }
    destroy() {
        window.clearTimeout(this.setScrollVisibleDebounce);
        super.destroy();
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.enableRtl = this.gos.get("enableRtl");
        super.initialiseInvisibleScrollbar();
        if (this.invisibleScrollbar) this.refreshCompBottom();
    }
    refreshCompBottom() {
        if (!this.invisibleScrollbar) return;
        const bottomPinnedHeight = this.beans.pinnedRowModel?.getPinnedBottomTotalHeight() ?? 0;
        this.getGui().style.bottom = `${bottomPinnedHeight}px`;
    }
    onScrollVisibilityChanged() {
        super.onScrollVisibilityChanged();
        this.setFakeHScrollSpacerWidths();
    }
    setFakeHScrollSpacerWidths() {
        const vScrollShowing = this.scrollVisibleSvc.verticalScrollShowing;
        let rightSpacing = this.visibleCols.getDisplayedColumnsRightWidth();
        const scrollOnRight = !this.enableRtl && vScrollShowing;
        const scrollbarWidth = this.scrollVisibleSvc.getScrollbarWidth();
        if (scrollOnRight) rightSpacing += scrollbarWidth;
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eRightSpacer, rightSpacing);
        this.eRightSpacer.classList.toggle("ag-scroller-corner", rightSpacing <= scrollbarWidth);
        let leftSpacing = this.visibleCols.getColsLeftWidth();
        const scrollOnLeft = this.enableRtl && vScrollShowing;
        if (scrollOnLeft) leftSpacing += scrollbarWidth;
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eLeftSpacer, leftSpacing);
        this.eLeftSpacer.classList.toggle("ag-scroller-corner", leftSpacing <= scrollbarWidth);
    }
    setScrollVisible() {
        const hScrollShowing = this.scrollVisibleSvc.horizontalScrollShowing;
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const isSuppressHorizontalScroll = this.gos.get("suppressHorizontalScroll");
        const scrollbarWidth = hScrollShowing ? this.scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        const scrollContainerSize = !isSuppressHorizontalScroll ? adjustedScrollbarWidth : 0;
        const apply = ()=>{
            this.setScrollVisibleDebounce = 0;
            this.toggleCss("ag-scrollbar-invisible", invisibleScrollbar2);
            $437b23f6a393c3bf$var$_setFixedHeight(this.getGui(), scrollContainerSize);
            $437b23f6a393c3bf$var$_setFixedHeight(this.eViewport, scrollContainerSize);
            $437b23f6a393c3bf$var$_setFixedHeight(this.eContainer, scrollContainerSize);
            if (!scrollContainerSize) this.eContainer.style.setProperty("min-height", "1px");
            this.setVisible(hScrollShowing, {
                skipAriaHidden: true
            });
        };
        window.clearTimeout(this.setScrollVisibleDebounce);
        if (!hScrollShowing) apply();
        else this.setScrollVisibleDebounce = window.setTimeout(apply, 100);
    }
    getScrollPosition() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    setScrollPosition(value) {
        if (!$437b23f6a393c3bf$export$2badf4aa566524cb(this.eViewport)) this.attemptSettingScrollPosition(value);
        $437b23f6a393c3bf$var$_setScrollLeft(this.eViewport, value, this.enableRtl);
    }
};
var $437b23f6a393c3bf$var$FakeHScrollSelector = {
    selector: "AG-FAKE-HORIZONTAL-SCROLL",
    component: $437b23f6a393c3bf$export$8f252e09ef6be2d3
};
// packages/ag-grid-community/src/gridBodyComp/fakeVScrollComp.ts
var $437b23f6a393c3bf$var$FakeVScrollElement = {
    tag: "div",
    cls: "ag-body-vertical-scroll",
    attrs: {
        "aria-hidden": "true"
    },
    children: [
        {
            tag: "div",
            ref: "eViewport",
            cls: "ag-body-vertical-scroll-viewport",
            children: [
                {
                    tag: "div",
                    ref: "eContainer",
                    cls: "ag-body-vertical-scroll-container"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$export$f496fc30dbebdfa3 = class extends $437b23f6a393c3bf$var$AbstractFakeScrollComp {
    constructor(){
        super($437b23f6a393c3bf$var$FakeVScrollElement, "vertical");
    }
    postConstruct() {
        super.postConstruct();
        this.createManagedBean(new $437b23f6a393c3bf$var$SetHeightFeature(this.eContainer));
        const { ctrlsSvc: ctrlsSvc } = this.beans;
        ctrlsSvc.register("fakeVScrollComp", this);
        this.addManagedEventListeners({
            rowContainerHeightChanged: this.onRowContainerHeightChanged.bind(this, ctrlsSvc)
        });
    }
    setScrollVisible() {
        const { scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        const vScrollShowing = scrollVisibleSvc.verticalScrollShowing;
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const scrollbarWidth = vScrollShowing ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        this.toggleCss("ag-scrollbar-invisible", invisibleScrollbar2);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.getGui(), adjustedScrollbarWidth);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eViewport, adjustedScrollbarWidth);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eContainer, adjustedScrollbarWidth);
        this.setDisplayed(vScrollShowing, {
            skipAriaHidden: true
        });
    }
    onRowContainerHeightChanged(ctrlsSvc) {
        const gridBodyCtrl = ctrlsSvc.getGridBodyCtrl();
        const gridBodyViewportEl = gridBodyCtrl.eBodyViewport;
        const eViewportScrollTop = this.getScrollPosition();
        const gridBodyViewportScrollTop = gridBodyViewportEl.scrollTop;
        if (eViewportScrollTop != gridBodyViewportScrollTop) this.setScrollPosition(gridBodyViewportScrollTop, true);
    }
    getScrollPosition() {
        return this.eViewport.scrollTop;
    }
    setScrollPosition(value, force) {
        if (!force && !$437b23f6a393c3bf$export$2badf4aa566524cb(this.eViewport)) this.attemptSettingScrollPosition(value);
        this.eViewport.scrollTop = value;
    }
};
var $437b23f6a393c3bf$var$FakeVScrollSelector = {
    selector: "AG-FAKE-VERTICAL-SCROLL",
    component: $437b23f6a393c3bf$export$f496fc30dbebdfa3
};
// packages/ag-grid-community/src/headerRendering/cells/cssClassApplier.ts
var $437b23f6a393c3bf$var$CSS_FIRST_COLUMN = "ag-column-first";
var $437b23f6a393c3bf$var$CSS_LAST_COLUMN = "ag-column-last";
function $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(abstractColDef)) return [];
    return $437b23f6a393c3bf$var$getColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, gos, column, columnGroup);
}
function $437b23f6a393c3bf$export$1784132bab54c462(abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(abstractColDef)) return [];
    return $437b23f6a393c3bf$var$getColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, gos, column, columnGroup);
}
function $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, presentedColsService) {
    comp.toggleCss($437b23f6a393c3bf$var$CSS_FIRST_COLUMN, presentedColsService.isColAtEdge(column, "first"));
    comp.toggleCss($437b23f6a393c3bf$var$CSS_LAST_COLUMN, presentedColsService.isColAtEdge(column, "last"));
}
function $437b23f6a393c3bf$var$getClassParams(abstractColDef, gos, column, columnGroup) {
    return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        // bad naming, as colDef here can be a group or a column,
        // however most people won't appreciate the difference,
        // so keeping it as colDef to avoid confusion.
        colDef: abstractColDef,
        column: column,
        columnGroup: columnGroup
    });
}
function $437b23f6a393c3bf$var$getColumnClassesFromCollDef(classesOrFunc, abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(classesOrFunc)) return [];
    let classToUse;
    if (typeof classesOrFunc === "function") {
        const params = $437b23f6a393c3bf$var$getClassParams(abstractColDef, gos, column, columnGroup);
        classToUse = classesOrFunc(params);
    } else classToUse = classesOrFunc;
    if (typeof classToUse === "string") return [
        classToUse
    ];
    if (Array.isArray(classToUse)) return [
        ...classToUse
    ];
    return [];
}
// packages/ag-grid-community/src/entities/positionUtils.ts
function $437b23f6a393c3bf$export$c0c5a5ba9327269f(cellPosition) {
    const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = cellPosition;
    return `${rowIndex}.${rowPinned == null ? "null" : rowPinned}.${column.getId()}`;
}
function $437b23f6a393c3bf$export$be3973033c2c5267(cellA, cellB) {
    const colsMatch = cellA.column === cellB.column;
    const floatingMatch = cellA.rowPinned === cellB.rowPinned;
    const indexMatch = cellA.rowIndex === cellB.rowIndex;
    return colsMatch && floatingMatch && indexMatch;
}
function $437b23f6a393c3bf$export$6cce97428a227a31(rowA, rowB) {
    switch(rowA.rowPinned){
        case "top":
            if (rowB.rowPinned !== "top") return true;
            break;
        case "bottom":
            if (rowB.rowPinned !== "bottom") return false;
            break;
        default:
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowB.rowPinned)) return rowB.rowPinned !== "top";
            break;
    }
    return rowA.rowIndex < rowB.rowIndex;
}
function $437b23f6a393c3bf$export$de6f9fa10e9f4188(rowA, rowB) {
    if (!rowA && !rowB) return true;
    if (!rowA || !rowB) return false;
    return rowA.rowIndex === rowB.rowIndex && rowA.rowPinned == rowB.rowPinned;
}
function $437b23f6a393c3bf$export$124b4386b662b699(beans) {
    let rowIndex = 0;
    let rowPinned;
    const { pinnedRowModel: pinnedRowModel, rowModel: rowModel, pageBounds: pageBounds } = beans;
    if (pinnedRowModel?.getPinnedTopRowCount()) rowPinned = "top";
    else if (rowModel.getRowCount()) {
        rowPinned = null;
        rowIndex = pageBounds.getFirstRow();
    } else if (pinnedRowModel?.getPinnedBottomRowCount()) rowPinned = "bottom";
    return rowPinned === void 0 ? null : {
        rowIndex: rowIndex,
        rowPinned: rowPinned
    };
}
function $437b23f6a393c3bf$export$a1449222017e428(beans) {
    let rowIndex;
    let rowPinned = null;
    const { pinnedRowModel: pinnedRowModel, pageBounds: pageBounds } = beans;
    const pinnedBottomCount = pinnedRowModel?.getPinnedBottomRowCount();
    const pinnedTopCount = pinnedRowModel?.getPinnedTopRowCount();
    if (pinnedBottomCount) {
        rowPinned = "bottom";
        rowIndex = pinnedBottomCount - 1;
    } else if (beans.rowModel.getRowCount()) rowIndex = pageBounds.getLastRow();
    else if (pinnedTopCount) {
        rowPinned = "top";
        rowIndex = pinnedTopCount - 1;
    }
    return rowIndex === void 0 ? null : {
        rowIndex: rowIndex,
        rowPinned: rowPinned
    };
}
function $437b23f6a393c3bf$export$d4675a60917db7b0(beans, gridRow) {
    switch(gridRow.rowPinned){
        case "top":
            return beans.pinnedRowModel?.getPinnedTopRow(gridRow.rowIndex);
        case "bottom":
            return beans.pinnedRowModel?.getPinnedBottomRow(gridRow.rowIndex);
        default:
            return beans.rowModel.getRow(gridRow.rowIndex);
    }
}
function $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, cellPosition) {
    const spannedCellCtrl = beans.spannedRowRenderer?.getCellByPosition(cellPosition);
    if (spannedCellCtrl) return spannedCellCtrl;
    const rowCtrl = beans.rowRenderer.getRowByPosition(cellPosition);
    if (!rowCtrl) return null;
    return rowCtrl.getCellCtrl(cellPosition.column);
}
function $437b23f6a393c3bf$var$_getRowById(beans, rowId, rowPinned) {
    const { rowModel: rm, pinnedRowModel: prm } = beans;
    let node;
    node ?? (node = rm?.getRowNode(rowId));
    if (rowPinned) node ?? (node = prm?.getPinnedRowById(rowId, rowPinned));
    else {
        node ?? (node = prm?.getPinnedRowById(rowId, "top"));
        node ?? (node = prm?.getPinnedRowById(rowId, "bottom"));
    }
    return node;
}
function $437b23f6a393c3bf$export$b36b14fdaf41f4d8(beans, rowPosition, checkSticky = false) {
    const { rowIndex: index, rowPinned: pinned } = rowPosition;
    const { pageBounds: pageBounds, pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    if (index === 0) {
        if (pinned === "top") return null;
        if (pinned === "bottom" && rowModel.isRowsToRender()) return {
            rowIndex: pageBounds.getLastRow(),
            rowPinned: null
        };
        return pinnedRowModel?.isRowsToRender("top") ? {
            rowIndex: pinnedRowModel.getPinnedTopRowCount() - 1,
            rowPinned: "top"
        } : null;
    }
    if (checkSticky) {
        const rowNode = pinned ? void 0 : rowModel.getRow(index);
        return $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode, true) ?? {
            rowIndex: index - 1,
            rowPinned: pinned
        };
    }
    return {
        rowIndex: index - 1,
        rowPinned: pinned
    };
}
function $437b23f6a393c3bf$export$5d5d8b440c4b4c91(beans, rowPosition) {
    const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    const pinnedTopRowCount = pinnedRowModel?.getPinnedTopRowCount() ?? 0;
    const unpinnedRowCount = rowModel.getRowCount();
    const { rowPinned: rowPinned, rowIndex: rowIndex } = rowPosition;
    if (rowPinned === "top") return rowIndex;
    if (rowPinned === "bottom") return pinnedTopRowCount + unpinnedRowCount + rowIndex;
    return pinnedTopRowCount + rowIndex;
}
function $437b23f6a393c3bf$export$3077f3bcabdc5ad1(beans, rowPosition, checkSticky = false) {
    const { rowIndex: index, rowPinned: pinned } = rowPosition;
    const { pageBounds: pageBounds, pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    if ($437b23f6a393c3bf$var$isLastRowInContainer(beans, rowPosition)) {
        if (pinned === "bottom") return null;
        if (pinned === "top" && rowModel.isRowsToRender()) return {
            rowIndex: pageBounds.getFirstRow(),
            rowPinned: null
        };
        return pinnedRowModel?.isRowsToRender("bottom") ? {
            rowIndex: 0,
            rowPinned: "bottom"
        } : null;
    }
    if (checkSticky) {
        const rowNode = pinned ? void 0 : rowModel.getRow(index);
        return $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode) ?? {
            rowIndex: index + 1,
            rowPinned: pinned
        };
    }
    return {
        rowIndex: index + 1,
        rowPinned: pinned
    };
}
function $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode, up = false) {
    const { gos: gos, rowRenderer: rowRenderer } = beans;
    if (!rowNode?.sticky || !$437b23f6a393c3bf$export$d5f33aacea6a0849(gos)) return;
    const stickyTopCtrls = rowRenderer.getStickyTopRowCtrls();
    const stickyBottomCtrls = rowRenderer.getStickyBottomRowCtrls();
    const isStickyTop = !stickyBottomCtrls.some((ctrl)=>ctrl.rowNode.rowIndex === rowNode.rowIndex);
    const stickyRowCtrls = isStickyTop ? stickyTopCtrls : stickyBottomCtrls;
    const increment = (up ? -1 : 1) * (isStickyTop ? -1 : 1);
    let nextCtrl;
    for(let i = 0; i < stickyRowCtrls.length; i++)if (stickyRowCtrls[i].rowNode.rowIndex === rowNode.rowIndex) {
        nextCtrl = stickyRowCtrls[i + increment];
        break;
    }
    return nextCtrl ? {
        rowIndex: nextCtrl.rowNode.rowIndex,
        rowPinned: null
    } : void 0;
}
function $437b23f6a393c3bf$var$isLastRowInContainer(beans, rowPosition) {
    const { rowPinned: rowPinned, rowIndex: rowIndex } = rowPosition;
    const { pinnedRowModel: pinnedRowModel, pageBounds: pageBounds } = beans;
    if (rowPinned === "top") {
        const lastTopIndex = (pinnedRowModel?.getPinnedTopRowCount() ?? 0) - 1;
        return lastTopIndex <= rowIndex;
    }
    if (rowPinned === "bottom") {
        const lastBottomIndex = (pinnedRowModel?.getPinnedBottomRowCount() ?? 0) - 1;
        return lastBottomIndex <= rowIndex;
    }
    const lastBodyIndex = pageBounds.getLastRow();
    return lastBodyIndex <= rowIndex;
}
// packages/ag-grid-community/src/utils/gridFocus.ts
function $437b23f6a393c3bf$export$8865b8c867776648(beans, comp, eGui) {
    comp.addManagedElementListeners(eGui, {
        keydown: (e)=>{
            if (!e.defaultPrevented && e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) {
                const backwards = e.shiftKey;
                if (!$437b23f6a393c3bf$export$83fc12531358bd28(beans, eGui, false, backwards)) {
                    if ($437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards)) e.preventDefault();
                }
            }
        }
    });
}
function $437b23f6a393c3bf$export$b3beea4db79d8bb3(beans, fromBottom) {
    return beans.ctrlsSvc.get("gridCtrl").focusInnerElement(fromBottom);
}
function $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans) {
    return beans.gos.get("suppressHeaderFocus") || !!beans.overlays?.exclusive;
}
function $437b23f6a393c3bf$var$_isCellFocusSuppressed(beans) {
    return beans.gos.get("suppressCellFocus") || !!beans.overlays?.exclusive;
}
function $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards, forceOut = false) {
    const gridCtrl = beans.ctrlsSvc.get("gridCtrl");
    if (!forceOut && gridCtrl.focusNextInnerContainer(backwards)) return true;
    if (forceOut || !backwards && !gridCtrl.isDetailGrid()) gridCtrl.forceFocusOutOfContainer(backwards);
    return false;
}
function $437b23f6a393c3bf$export$d43227ca3cbe63fa(beans, focusedCell) {
    const focusSvc = beans.focusSvc;
    const currentFocusedCell = focusSvc.getFocusedCell();
    if (currentFocusedCell && focusedCell && $437b23f6a393c3bf$export$be3973033c2c5267(currentFocusedCell, focusedCell)) {
        const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = focusedCell;
        if ($437b23f6a393c3bf$export$8ff9eef09a45371f(beans)) focusSvc.setFocusedCell({
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: !$437b23f6a393c3bf$export$e4c8c227337b7f23()
        });
    }
}
// packages/ag-grid-community/src/headerRendering/headerUtils.ts
function $437b23f6a393c3bf$export$4861f2356b3fc2d7(colModel) {
    if (!colModel.cols) return -1;
    return colModel.cols.treeDepth + 1;
}
function $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans) {
    return beans.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getGroupRowsHeight(beans) {
    const heights = [];
    const headerRowContainerCtrls = beans.ctrlsSvc.getHeaderRowContainerCtrls();
    for (const headerRowContainerCtrl of headerRowContainerCtrls){
        if (!headerRowContainerCtrl) continue;
        const groupRowCount = headerRowContainerCtrl.getGroupRowCount() || 0;
        for(let i = 0; i < groupRowCount; i++){
            const headerRowCtrl = headerRowContainerCtrl.getGroupRowCtrlAtIndex(i);
            const currentHeightAtPos = heights[i];
            if (headerRowCtrl) {
                const newHeight = $437b23f6a393c3bf$var$getColumnGroupHeaderRowHeight(beans, headerRowCtrl);
                if (currentHeightAtPos == null || newHeight > currentHeightAtPos) heights[i] = newHeight;
            }
        }
    }
    return heights;
}
function $437b23f6a393c3bf$var$getColumnGroupHeaderRowHeight(beans, headerRowCtrl) {
    const defaultHeight = beans.colModel.isPivotMode() ? $437b23f6a393c3bf$var$getPivotGroupHeaderHeight(beans) : $437b23f6a393c3bf$var$getGroupHeaderHeight(beans);
    let maxDisplayedHeight = defaultHeight;
    const headerRowCellCtrls = headerRowCtrl.getHeaderCellCtrls();
    for (const headerCellCtrl of headerRowCellCtrls){
        const { column: column } = headerCellCtrl;
        const height = column.getAutoHeaderHeight();
        if (height != null && height > maxDisplayedHeight && column.isAutoHeaderHeight()) maxDisplayedHeight = height;
    }
    return maxDisplayedHeight;
}
function $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans) {
    const defaultHeight = beans.colModel.isPivotMode() ? $437b23f6a393c3bf$var$getPivotHeaderHeight(beans) : $437b23f6a393c3bf$var$getHeaderHeight(beans);
    let maxDisplayedHeight = defaultHeight;
    beans.colModel.forAllCols((col)=>{
        const height = col.getAutoHeaderHeight();
        if (height != null && height > maxDisplayedHeight && col.isAutoHeaderHeight()) maxDisplayedHeight = height;
    });
    return maxDisplayedHeight;
}
function $437b23f6a393c3bf$var$getHeaderHeight(beans) {
    return beans.gos.get("headerHeight") ?? beans.environment.getDefaultHeaderHeight();
}
function $437b23f6a393c3bf$export$b52d5533bf5be44(beans) {
    return beans.gos.get("floatingFiltersHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getGroupHeaderHeight(beans) {
    return beans.gos.get("groupHeaderHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getPivotHeaderHeight(beans) {
    return beans.gos.get("pivotHeaderHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getPivotGroupHeaderHeight(beans) {
    return beans.gos.get("pivotGroupHeaderHeight") ?? $437b23f6a393c3bf$var$getGroupHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$isHeaderPositionEqual(headerPosA, headerPosB) {
    return headerPosA.headerRowIndex === headerPosB.headerRowIndex && headerPosA.column === headerPosB.column;
}
// packages/ag-grid-community/src/headerRendering/gridHeaderCtrl.ts
var $437b23f6a393c3bf$export$20b300eb69ca4d09 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    setComp(comp, eGui, eFocusableElement) {
        this.comp = comp;
        this.eGui = eGui;
        const { beans: beans } = this;
        const { headerNavigation: headerNavigation, touchSvc: touchSvc, ctrlsSvc: ctrlsSvc } = beans;
        if (headerNavigation) this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eFocusableElement, {
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addManagedEventListeners({
            columnPivotModeChanged: this.onPivotModeChanged.bind(this, beans),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this, beans)
        });
        this.onPivotModeChanged(beans);
        this.setupHeaderHeight();
        const listener = this.onHeaderContextMenu.bind(this);
        this.addManagedElementListeners(this.eGui, {
            contextmenu: listener
        });
        touchSvc?.mockHeaderContextMenu(this, listener);
        ctrlsSvc.register("gridHeaderCtrl", this);
    }
    setupHeaderHeight() {
        const listener = this.setHeaderHeight.bind(this);
        listener();
        this.addManagedPropertyListeners([
            "headerHeight",
            "pivotHeaderHeight",
            "groupHeaderHeight",
            "pivotGroupHeaderHeight",
            "floatingFiltersHeight"
        ], listener);
        this.addManagedEventListeners({
            headerRowsChanged: listener,
            columnHeaderHeightChanged: listener,
            // add this to the animation frame to avoid a feedback loop
            columnGroupHeaderHeightChanged: ()=>$437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>listener()),
            stylesChanged: listener,
            advancedFilterEnabledChanged: listener
        });
    }
    setHeaderHeight() {
        const { beans: beans } = this;
        let totalHeaderHeight = 0;
        const groupHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(beans).reduce((prev, curr)=>prev + curr, 0);
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans);
        if (beans.filterManager?.hasFloatingFilters()) totalHeaderHeight += $437b23f6a393c3bf$export$b52d5533bf5be44(beans);
        totalHeaderHeight += groupHeight;
        totalHeaderHeight += headerHeight;
        if (this.headerHeight === totalHeaderHeight) return;
        this.headerHeight = totalHeaderHeight;
        const px = `${totalHeaderHeight + 1}px`;
        this.comp.setHeightAndMinHeight(px);
        this.eventSvc.dispatchEvent({
            type: "headerHeightChanged"
        });
    }
    onPivotModeChanged(beans) {
        const pivotMode = beans.colModel.isPivotMode();
        this.comp.toggleCss("ag-pivot-on", pivotMode);
        this.comp.toggleCss("ag-pivot-off", !pivotMode);
    }
    onDisplayedColumnsChanged(beans) {
        const columns = beans.visibleCols.allCols;
        const shouldAllowOverflow = columns.some((col)=>col.isSpanHeaderHeight());
        this.comp.toggleCss("ag-header-allow-overflow", shouldAllowOverflow);
    }
    onTabKeyDown(e) {
        const isRtl = this.gos.get("enableRtl");
        const backwards = e.shiftKey;
        const direction = backwards !== isRtl ? "LEFT" : "RIGHT";
        const { beans: beans } = this;
        const { headerNavigation: headerNavigation, focusSvc: focusSvc } = beans;
        if (headerNavigation.navigateHorizontally(direction, true, e) || !backwards && focusSvc.focusOverlay(false) || $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards, true)) e.preventDefault();
    }
    handleKeyDown(e) {
        let direction = null;
        const { headerNavigation: headerNavigation } = this.beans;
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                direction = "LEFT";
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(direction)) direction = "RIGHT";
                if (headerNavigation.navigateHorizontally(direction, false, e)) e.preventDefault();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                direction = "UP";
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(direction)) direction = "DOWN";
                if (headerNavigation.navigateVertically(direction, e)) e.preventDefault();
                break;
            default:
                return;
        }
    }
    onFocusOut(e) {
        const { relatedTarget: relatedTarget } = e;
        const { eGui: eGui, beans: beans } = this;
        if (!relatedTarget && eGui.contains($437b23f6a393c3bf$export$16bc98d422315038(beans))) return;
        if (!eGui.contains(relatedTarget)) beans.focusSvc.focusedHeader = null;
    }
    onHeaderContextMenu(mouseEvent, touch, touchEvent) {
        const { menuSvc: menuSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        if (!mouseEvent && !touchEvent || !menuSvc?.isHeaderContextMenuEnabled()) return;
        const { target: target } = mouseEvent ?? touch;
        if (target === this.eGui || target === ctrlsSvc.getHeaderRowContainerCtrl()?.eViewport) menuSvc.showHeaderContextMenu(void 0, mouseEvent, touchEvent);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/abstractCell/abstractHeaderCellComp.ts
var $437b23f6a393c3bf$var$AbstractHeaderCellComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(template, ctrl){
        super(template);
        this.ctrl = ctrl;
    }
    getCtrl() {
        return this.ctrl;
    }
};
// packages/ag-grid-community/src/headerRendering/cells/column/headerCellComp.ts
var $437b23f6a393c3bf$var$HeaderCellElement = {
    tag: "div",
    cls: "ag-header-cell",
    role: "columnheader",
    children: [
        {
            tag: "div",
            ref: "eResize",
            cls: "ag-header-cell-resize",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eHeaderCompWrapper",
            cls: "ag-header-cell-comp-wrapper",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderCellElement, ctrl);
        this.eResize = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eHeaderCompWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.headerCompVersion = 0;
    }
    postConstruct() {
        const eGui = this.getGui();
        const refreshSelectAllGui = ()=>{
            const selectAllGui = this.ctrl.getSelectAllGui();
            if (selectAllGui) {
                this.eResize.insertAdjacentElement("afterend", selectAllGui);
                this.addDestroyFunc(()=>selectAllGui.remove());
            }
        };
        const compProxy = {
            setWidth: (width)=>eGui.style.width = width,
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            setAriaSort: (sort)=>sort ? $437b23f6a393c3bf$export$c8dd030b968c6fd2(eGui, sort) : $437b23f6a393c3bf$export$26c7aa61eda05134(eGui),
            setUserCompDetails: (compDetails)=>this.setUserCompDetails(compDetails),
            getUserCompInstance: ()=>this.headerComp,
            refreshSelectAllGui: refreshSelectAllGui,
            removeSelectAllGui: ()=>this.ctrl.getSelectAllGui()?.remove()
        };
        this.ctrl.setComp(compProxy, this.getGui(), this.eResize, this.eHeaderCompWrapper, void 0);
        refreshSelectAllGui();
    }
    destroy() {
        this.destroyHeaderComp();
        super.destroy();
    }
    destroyHeaderComp() {
        if (this.headerComp) {
            this.headerCompGui?.remove();
            this.headerComp = this.destroyBean(this.headerComp);
            this.headerCompGui = void 0;
        }
    }
    setUserCompDetails(compDetails) {
        this.headerCompVersion++;
        const versionCopy = this.headerCompVersion;
        compDetails.newAgStackInstance().then((comp)=>this.afterCompCreated(versionCopy, comp));
    }
    afterCompCreated(version, headerComp) {
        if (version != this.headerCompVersion || !this.isAlive()) {
            this.destroyBean(headerComp);
            return;
        }
        this.destroyHeaderComp();
        this.headerComp = headerComp;
        this.headerCompGui = headerComp.getGui();
        this.eHeaderCompWrapper.appendChild(this.headerCompGui);
        this.ctrl.setDragSource(this.getGui());
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupCellComp.ts
var $437b23f6a393c3bf$var$HeaderGroupCellCompElement = {
    tag: "div",
    cls: "ag-header-group-cell",
    role: "columnheader",
    children: [
        {
            tag: "div",
            ref: "eHeaderCompWrapper",
            cls: "ag-header-cell-comp-wrapper",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eResize",
            cls: "ag-header-cell-resize",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderGroupCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderGroupCellCompElement, ctrl);
        this.eResize = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eHeaderCompWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const eGui = this.getGui();
        const setAttribute = (key, value)=>value != void 0 ? eGui.setAttribute(key, value) : eGui.removeAttribute(key);
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            setHeaderWrapperHidden: (hidden)=>{
                if (hidden) this.eHeaderCompWrapper.style.setProperty("display", "none");
                else this.eHeaderCompWrapper.style.removeProperty("display");
            },
            setHeaderWrapperMaxHeight: (value)=>{
                if (value != null) this.eHeaderCompWrapper.style.setProperty("max-height", `${value}px`);
                else this.eHeaderCompWrapper.style.removeProperty("max-height");
                this.eHeaderCompWrapper.classList.toggle("ag-header-cell-comp-wrapper-limited-height", value != null);
            },
            setResizableDisplayed: (displayed)=>$437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eResize, displayed),
            setWidth: (width)=>eGui.style.width = width,
            setAriaExpanded: (expanded)=>setAttribute("aria-expanded", expanded),
            setUserCompDetails: (details)=>this.setUserCompDetails(details),
            getUserCompInstance: ()=>this.headerGroupComp
        };
        this.ctrl.setComp(compProxy, eGui, this.eResize, this.eHeaderCompWrapper, void 0);
    }
    setUserCompDetails(details) {
        details.newAgStackInstance().then((comp)=>this.afterHeaderCompCreated(comp));
    }
    afterHeaderCompCreated(headerGroupComp) {
        const destroyFunc = ()=>this.destroyBean(headerGroupComp);
        if (!this.isAlive()) {
            destroyFunc();
            return;
        }
        const eGui = this.getGui();
        const eHeaderGroupGui = headerGroupComp.getGui();
        this.eHeaderCompWrapper.appendChild(eHeaderGroupGui);
        this.addDestroyFunc(destroyFunc);
        this.headerGroupComp = headerGroupComp;
        this.ctrl.setDragSource(eGui);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/floatingFilter/headerFilterCellComp.ts
var $437b23f6a393c3bf$var$HeaderFilterCellCompElement = {
    tag: "div",
    cls: "ag-header-cell ag-floating-filter",
    role: "gridcell",
    children: [
        {
            tag: "div",
            ref: "eFloatingFilterBody",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eButtonWrapper",
            cls: "ag-floating-filter-button ag-hidden",
            role: "presentation",
            children: [
                {
                    tag: "button",
                    ref: "eButtonShowMainFilter",
                    cls: "ag-button ag-floating-filter-button-button",
                    attrs: {
                        type: "button",
                        tabindex: "-1"
                    }
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderFilterCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderFilterCellCompElement, ctrl);
        this.eFloatingFilterBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eButtonWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eButtonShowMainFilter = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const eGui = this.getGui();
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            addOrRemoveBodyCssClass: (cssClassName, on)=>this.eFloatingFilterBody.classList.toggle(cssClassName, on),
            setButtonWrapperDisplayed: (displayed)=>$437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eButtonWrapper, displayed),
            setCompDetails: (compDetails)=>this.setCompDetails(compDetails),
            getFloatingFilterComp: ()=>this.compPromise,
            setWidth: (width)=>eGui.style.width = width,
            setMenuIcon: (eIcon)=>this.eButtonShowMainFilter.appendChild(eIcon)
        };
        this.ctrl.setComp(compProxy, eGui, this.eButtonShowMainFilter, this.eFloatingFilterBody, void 0);
    }
    setCompDetails(compDetails) {
        if (!compDetails) {
            this.destroyFloatingFilterComp();
            this.compPromise = null;
            return;
        }
        this.compPromise = compDetails.newAgStackInstance();
        this.compPromise.then((comp)=>this.afterCompCreated(comp));
    }
    destroy() {
        this.destroyFloatingFilterComp();
        super.destroy();
    }
    destroyFloatingFilterComp() {
        this.floatingFilterComp?.getGui().remove();
        this.floatingFilterComp = this.destroyBean(this.floatingFilterComp);
    }
    afterCompCreated(comp) {
        if (!comp) return;
        if (!this.isAlive()) {
            this.destroyBean(comp);
            return;
        }
        this.destroyFloatingFilterComp();
        this.floatingFilterComp = comp;
        this.eFloatingFilterBody.appendChild(comp.getGui());
        comp.afterGuiAttached?.();
    }
};
// packages/ag-grid-community/src/headerRendering/row/headerRowComp.ts
var $437b23f6a393c3bf$var$HeaderRowComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(ctrl){
        super({
            tag: "div",
            cls: ctrl.headerRowClass,
            role: "row"
        });
        this.ctrl = ctrl;
        this.headerComps = {};
    }
    postConstruct() {
        const eGui = this.getGui();
        eGui.setAttribute("tabindex", String(this.gos.get("tabIndex")));
        $437b23f6a393c3bf$export$ba731dedf9d88615(this.getGui(), this.ctrl.getAriaRowIndex());
        const compProxy = {
            setHeight: (height)=>this.getGui().style.height = height,
            setTop: (top)=>this.getGui().style.top = top,
            setHeaderCtrls: (ctrls, forceOrder)=>this.setHeaderCtrls(ctrls, forceOrder),
            setWidth: (width)=>this.getGui().style.width = width,
            setRowIndex: (rowIndex)=>$437b23f6a393c3bf$export$ba731dedf9d88615(this.getGui(), rowIndex)
        };
        this.ctrl.setComp(compProxy, void 0);
    }
    destroy() {
        this.setHeaderCtrls([], false);
        super.destroy();
    }
    setHeaderCtrls(ctrls, forceOrder) {
        if (!this.isAlive()) return;
        const oldComps = this.headerComps;
        this.headerComps = {};
        for (const ctrl of ctrls){
            const id = ctrl.instanceId;
            let comp = oldComps[id];
            delete oldComps[id];
            if (comp == null) {
                comp = this.createHeaderComp(ctrl);
                this.getGui().appendChild(comp.getGui());
            }
            this.headerComps[id] = comp;
        }
        Object.values(oldComps).forEach((comp)=>{
            comp.getGui().remove();
            this.destroyBean(comp);
        });
        if (forceOrder) {
            const comps = Object.values(this.headerComps);
            comps.sort((a, b)=>{
                const leftA = a.getCtrl().column.getLeft();
                const leftB = b.getCtrl().column.getLeft();
                return leftA - leftB;
            });
            const elementsInOrder = comps.map((c)=>c.getGui());
            $437b23f6a393c3bf$var$_setDomChildOrder(this.getGui(), elementsInOrder);
        }
    }
    createHeaderComp(headerCtrl) {
        let result;
        switch(this.ctrl.type){
            case "group":
                result = new $437b23f6a393c3bf$var$HeaderGroupCellComp(headerCtrl);
                break;
            case "filter":
                result = new $437b23f6a393c3bf$var$HeaderFilterCellComp(headerCtrl);
                break;
            default:
                result = new $437b23f6a393c3bf$var$HeaderCellComp(headerCtrl);
                break;
        }
        this.createBean(result);
        result.setParentComponent(this);
        return result;
    }
};
// packages/ag-grid-community/src/rendering/features/setLeftFeature.ts
var $437b23f6a393c3bf$var$SetLeftFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(columnOrGroup, eCell, beans, colsSpanning){
        super();
        this.columnOrGroup = columnOrGroup;
        this.eCell = eCell;
        this.colsSpanning = colsSpanning;
        this.columnOrGroup = columnOrGroup;
        this.ariaEl = eCell.querySelector("[role=columnheader]") || eCell;
        this.beans = beans;
    }
    setColsSpanning(colsSpanning) {
        this.colsSpanning = colsSpanning;
        this.onLeftChanged();
    }
    getColumnOrGroup() {
        const { beans: beans, colsSpanning: colsSpanning } = this;
        if (beans.gos.get("enableRtl") && colsSpanning) return $437b23f6a393c3bf$export$236389741107357f(colsSpanning);
        return this.columnOrGroup;
    }
    postConstruct() {
        const onLeftChanged = this.onLeftChanged.bind(this);
        this.addManagedListeners(this.columnOrGroup, {
            leftChanged: onLeftChanged
        });
        this.setLeftFirstTime();
        this.addManagedEventListeners({
            displayedColumnsWidthChanged: onLeftChanged
        });
        this.addManagedPropertyListener("domLayout", onLeftChanged);
    }
    setLeftFirstTime() {
        const { gos: gos, colAnimation: colAnimation } = this.beans;
        const suppressMoveAnimation = gos.get("suppressColumnMoveAnimation");
        const oldLeftExists = $437b23f6a393c3bf$export$25d27f17d3af40f7(this.columnOrGroup.getOldLeft());
        const animateColumnMove = colAnimation?.isActive() && oldLeftExists && !suppressMoveAnimation;
        if (animateColumnMove) this.animateInLeft();
        else this.onLeftChanged();
    }
    animateInLeft() {
        const colOrGroup = this.getColumnOrGroup();
        const oldActualLeft = this.modifyLeftForPrintLayout(colOrGroup, colOrGroup.getOldLeft());
        const actualLeft = this.modifyLeftForPrintLayout(colOrGroup, colOrGroup.getLeft());
        this.setLeft(oldActualLeft);
        this.actualLeft = actualLeft;
        this.beans.colAnimation.executeNextVMTurn(()=>{
            if (this.actualLeft === actualLeft) this.setLeft(actualLeft);
        });
    }
    onLeftChanged() {
        const colOrGroup = this.getColumnOrGroup();
        const left = colOrGroup.getLeft();
        this.actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
        this.setLeft(this.actualLeft);
    }
    modifyLeftForPrintLayout(colOrGroup, leftPosition) {
        const { gos: gos, visibleCols: visibleCols } = this.beans;
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        if (!printLayout) return leftPosition;
        if (colOrGroup.getPinned() === "left") return leftPosition;
        const leftWidth = visibleCols.getColsLeftWidth();
        if (colOrGroup.getPinned() === "right") {
            const bodyWidth = visibleCols.bodyWidth;
            return leftWidth + bodyWidth + leftPosition;
        }
        return leftWidth + leftPosition;
    }
    setLeft(value) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) this.eCell.style.left = `${value}px`;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(this.columnOrGroup)) {
            const children = this.columnOrGroup.getLeafColumns();
            if (!children.length) return;
            if (children.length > 1) $437b23f6a393c3bf$export$371d80f0281454ce(this.ariaEl, children.length);
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/abstractCell/abstractHeaderCellCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence2 = 0;
var $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL = "headerCtrl";
var $437b23f6a393c3bf$var$AbstractHeaderCellCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column, rowCtrl){
        super();
        this.column = column;
        this.rowCtrl = rowCtrl;
        this.resizeToggleTimeout = 0;
        this.resizeMultiplier = 1;
        this.resizeFeature = null;
        this.lastFocusEvent = null;
        this.dragSource = null;
        this.reAttemptToFocus = false;
        this.instanceId = column.getUniqueId() + "-" + $437b23f6a393c3bf$var$instanceIdSequence2++;
    }
    postConstruct() {
        const refreshTabIndex = this.refreshTabIndex.bind(this);
        this.addManagedPropertyListeners([
            "suppressHeaderFocus"
        ], refreshTabIndex);
        this.addManagedEventListeners({
            overlayExclusiveChanged: refreshTabIndex
        });
    }
    setComp(comp, eGui, eResize, eHeaderCompWrapper, compBean) {
        eGui.setAttribute("col-id", this.column.colIdSanitised);
        this.wireComp(comp, eGui, eResize, eHeaderCompWrapper, compBean);
        if (this.reAttemptToFocus) {
            this.reAttemptToFocus = false;
            this.focus(this.lastFocusEvent ?? void 0);
        }
    }
    shouldStopEventPropagation(event) {
        const { headerRowIndex: headerRowIndex, column: column } = this.beans.focusSvc.focusedHeader;
        const colDef = column.getDefinition();
        const colDefFunc = colDef?.suppressHeaderKeyboardEvent;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(colDefFunc)) return false;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            colDef: colDef,
            column: column,
            headerRowIndex: headerRowIndex,
            event: event
        });
        return !!colDefFunc(params);
    }
    getWrapperHasFocus() {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return activeEl === this.eGui;
    }
    setGui(eGui, compBean) {
        this.eGui = eGui;
        this.addDomData(compBean);
        compBean.addManagedListeners(this.beans.eventSvc, {
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this)
        });
        compBean.addManagedElementListeners(this.eGui, {
            focus: this.onGuiFocus.bind(this)
        });
        this.onDisplayedColumnsChanged();
        this.refreshTabIndex();
    }
    refreshHeaderStyles() {
        const colDef = this.column.getDefinition();
        if (!colDef) return;
        const { headerStyle: headerStyle } = colDef;
        let styles;
        if (typeof headerStyle === "function") {
            const cellStyleParams = this.getHeaderClassParams();
            styles = headerStyle(cellStyleParams);
        } else styles = headerStyle;
        if (styles) this.comp.setUserStyles(styles);
    }
    onGuiFocus() {
        this.eventSvc.dispatchEvent({
            type: "headerFocused",
            column: this.column
        });
    }
    setupAutoHeight(params) {
        const { wrapperElement: wrapperElement, checkMeasuringCallback: checkMeasuringCallback, compBean: compBean } = params;
        const { beans: beans } = this;
        const measureHeight = (timesCalled)=>{
            if (!this.isAlive() || !compBean.isAlive()) return;
            const { paddingTop: paddingTop, paddingBottom: paddingBottom, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth } = $437b23f6a393c3bf$var$_getElementSize(this.eGui);
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = wrapperElement.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
                const notYetInDom = !doc?.contains(wrapperElement);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    $437b23f6a393c3bf$export$8ea55376d0d59592(()=>measureHeight(timesCalled + 1), "raf", beans);
                    return;
                }
            }
            this.setColHeaderHeight(this.column, autoHeight);
        };
        let isMeasuring = false;
        let stopResizeObserver;
        const checkMeasuring = ()=>{
            const newValue = this.column.isAutoHeaderHeight();
            if (newValue && !isMeasuring) startMeasuring();
            if (!newValue && isMeasuring) stopMeasuring();
        };
        const startMeasuring = ()=>{
            isMeasuring = true;
            this.comp.toggleCss("ag-header-cell-auto-height", true);
            measureHeight(0);
            stopResizeObserver = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, wrapperElement, ()=>measureHeight(0));
        };
        const stopMeasuring = ()=>{
            isMeasuring = false;
            if (stopResizeObserver) stopResizeObserver();
            this.comp.toggleCss("ag-header-cell-auto-height", false);
            stopResizeObserver = void 0;
        };
        checkMeasuring();
        compBean.addDestroyFunc(()=>stopMeasuring());
        compBean.addManagedListeners(this.column, {
            widthChanged: ()=>isMeasuring && measureHeight(0)
        });
        compBean.addManagedEventListeners({
            sortChanged: ()=>{
                if (isMeasuring) window.setTimeout(()=>measureHeight(0));
            }
        });
        if (checkMeasuringCallback) checkMeasuringCallback(checkMeasuring);
    }
    onDisplayedColumnsChanged() {
        const { comp: comp, column: column, beans: beans, eGui: eGui } = this;
        if (!comp || !column || !eGui) return;
        $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, beans.visibleCols);
        $437b23f6a393c3bf$export$84b73ecd0b234e89(eGui, beans.visibleCols.getAriaColIndex(column));
    }
    addResizeAndMoveKeyboardListeners(compBean) {
        compBean.addManagedListeners(this.eGui, {
            keydown: this.onGuiKeyDown.bind(this),
            keyup: this.onGuiKeyUp.bind(this)
        });
    }
    refreshTabIndex() {
        const suppressHeaderFocus = $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans);
        if (this.eGui) $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eGui, "tabindex", suppressHeaderFocus ? null : "-1");
    }
    onGuiKeyDown(e) {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        const isLeftOrRight = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT;
        if (this.isResizing) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (// if elements within the header are focused, we don't process the event
        activeEl !== this.eGui || // if shiftKey, ctrlKey, metaKey and altKey are not pressed, it's cell navigation so we don't process the event
        !e.shiftKey && !e.altKey && !e.ctrlKey && !e.metaKey) return;
        if (this.isResizing || isLeftOrRight) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        const isCopy = (e.ctrlKey || e.metaKey) && $437b23f6a393c3bf$var$_normaliseQwertyAzerty(e) === $437b23f6a393c3bf$export$e9e0d96f49f57c33.C;
        if (isCopy) return this.beans.clipboardSvc?.copyToClipboard();
        if (!isLeftOrRight) return;
        const isLeft = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT !== this.gos.get("enableRtl");
        const direction = isLeft ? "left" : "right";
        if (e.altKey) {
            this.isResizing = true;
            this.resizeMultiplier += 1;
            const diff = this.getViewportAdjustedResizeDiff(e);
            this.resizeHeader(diff, e.shiftKey);
            this.resizeFeature?.toggleColumnResizing(true);
        } else this.moveHeader(direction);
    }
    moveHeader(hDirection) {
        this.beans.colMoves?.moveHeader(hDirection, this.eGui, this.column, this.rowCtrl.pinned, this);
    }
    getViewportAdjustedResizeDiff(e) {
        const diff = this.getResizeDiff(e);
        const { pinnedCols: pinnedCols } = this.beans;
        return pinnedCols ? pinnedCols.getHeaderResizeDiff(diff, this.column) : diff;
    }
    getResizeDiff(e) {
        const { gos: gos, column: column } = this;
        let isLeft = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT !== gos.get("enableRtl");
        const pinned = column.getPinned();
        const isRtl = gos.get("enableRtl");
        if (pinned) {
            if (isRtl !== (pinned === "right")) isLeft = !isLeft;
        }
        return (isLeft ? -1 : 1) * this.resizeMultiplier;
    }
    onGuiKeyUp() {
        if (!this.isResizing) return;
        if (this.resizeToggleTimeout) {
            window.clearTimeout(this.resizeToggleTimeout);
            this.resizeToggleTimeout = 0;
        }
        this.isResizing = false;
        this.resizeMultiplier = 1;
        this.resizeToggleTimeout = window.setTimeout(()=>{
            this.resizeFeature?.toggleColumnResizing(false);
        }, 150);
    }
    handleKeyDown(e) {
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                if (wrapperHasFocus) e.preventDefault();
        }
    }
    addDomData(compBean) {
        const key = $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL;
        const { eGui: eGui, gos: gos } = this;
        $437b23f6a393c3bf$var$_setDomData(gos, eGui, key, this);
        compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(gos, eGui, key, null));
    }
    focus(event) {
        if (!this.isAlive()) return false;
        const { eGui: eGui } = this;
        if (!eGui) this.reAttemptToFocus = true;
        else {
            this.lastFocusEvent = event || null;
            eGui.focus();
        }
        return true;
    }
    focusThis() {
        this.beans.focusSvc.focusedHeader = {
            headerRowIndex: this.rowCtrl.rowIndex,
            column: this.column
        };
    }
    removeDragSource() {
        if (this.dragSource) {
            this.beans.dragAndDrop?.removeDragSource(this.dragSource);
            this.dragSource = null;
        }
    }
    handleContextMenuMouseEvent(mouseEvent, touchEvent, column) {
        const event = mouseEvent ?? touchEvent;
        const { menuSvc: menuSvc, gos: gos } = this.beans;
        if (gos.get("preventDefaultOnContextMenu")) event.preventDefault();
        if (menuSvc?.isHeaderContextMenuEnabled(column)) menuSvc.showHeaderContextMenu(column, mouseEvent, touchEvent);
        this.dispatchColumnMouseEvent("columnHeaderContextMenu", column);
    }
    dispatchColumnMouseEvent(eventType, column) {
        this.eventSvc.dispatchEvent({
            type: eventType,
            column: column
        });
    }
    setColHeaderHeight(col, height) {
        if (!col.setAutoHeaderHeight(height)) return;
        const { eventSvc: eventSvc } = this;
        if (col.isColumn) eventSvc.dispatchEvent({
            type: "columnHeaderHeightChanged",
            column: col,
            columns: [
                col
            ],
            source: "autosizeColumnHeaderHeight"
        });
        else eventSvc.dispatchEvent({
            type: "columnGroupHeaderHeightChanged",
            columnGroup: col,
            source: "autosizeColumnGroupHeaderHeight"
        });
    }
    clearComponent() {
        this.removeDragSource();
        this.resizeFeature = null;
        this.comp = null;
        this.eGui = null;
    }
    destroy() {
        super.destroy();
        this.column = null;
        this.lastFocusEvent = null;
        this.rowCtrl = null;
    }
};
// packages/ag-grid-community/src/headerRendering/cells/column/headerCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.refreshFunctions = {};
        this.userHeaderClasses = /* @__PURE__ */ new Set();
        this.ariaDescriptionProperties = /* @__PURE__ */ new Map();
    }
    wireComp(comp, eGui, eResize, eHeaderCompWrapper, compBeanInput) {
        this.comp = comp;
        const { rowCtrl: rowCtrl, column: column, beans: beans } = this;
        const { colResize: colResize, context: context, colHover: colHover, rangeSvc: rangeSvc } = beans;
        const compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBeanInput);
        this.setGui(eGui, compBean);
        this.updateState();
        this.setupWidth(compBean);
        this.setupMovingCss(compBean);
        this.setupMenuClass(compBean);
        this.setupSortableClass(compBean);
        this.setupWrapTextClass();
        this.refreshSpanHeaderHeight();
        this.setupAutoHeight({
            wrapperElement: eHeaderCompWrapper,
            checkMeasuringCallback: (checkMeasuring)=>this.setRefreshFunction("measuring", checkMeasuring),
            compBean: compBean
        });
        this.addColumnHoverListener(compBean);
        this.setupFilterClass(compBean);
        this.setupStylesFromColDef();
        this.setupClassesFromColDef();
        this.setupTooltip();
        this.addActiveHeaderMouseListeners(compBean);
        this.setupSelectAll(compBean);
        this.setupUserComp();
        this.refreshAria();
        if (colResize) this.resizeFeature = compBean.createManagedBean(colResize.createResizeFeature(rowCtrl.pinned, column, eResize, comp, this));
        else $437b23f6a393c3bf$export$9405f1cbb4e2383f(eResize, false);
        colHover?.createHoverFeature(compBean, [
            column
        ], eGui);
        rangeSvc?.createRangeHighlightFeature(compBean, column, comp);
        compBean.createManagedBean(new $437b23f6a393c3bf$var$SetLeftFeature(column, eGui, beans));
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eGui, {
            shouldStopEventPropagation: (e)=>this.shouldStopEventPropagation(e),
            onTabKeyDown: ()=>null,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addResizeAndMoveKeyboardListeners(compBean);
        compBean.addManagedPropertyListeners([
            "suppressMovableColumns",
            "suppressMenuHide",
            "suppressAggFuncInHeader",
            "enableAdvancedFilter"
        ], ()=>this.refresh());
        compBean.addManagedListeners(column, {
            colDefChanged: ()=>this.refresh(),
            formulaRefChanged: ()=>this.refresh(),
            headerHighlightChanged: this.onHeaderHighlightChanged.bind(this)
        });
        const listener = ()=>this.checkDisplayName();
        compBean.addManagedEventListeners({
            columnValueChanged: listener,
            columnRowGroupChanged: listener,
            columnPivotChanged: listener,
            headerHeightChanged: this.onHeaderHeightChanged.bind(this)
        });
        compBean.addDestroyFunc(()=>{
            this.refreshFunctions = {};
            this.selectAllFeature = null;
            this.dragSourceElement = void 0;
            this.userCompDetails = null;
            this.userHeaderClasses.clear();
            this.ariaDescriptionProperties.clear();
            this.clearComponent();
        });
    }
    resizeHeader(delta, shiftKey) {
        this.beans.colResize?.resizeHeader(this.column, delta, shiftKey);
    }
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.colDef;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            column: column,
            floatingFilter: false
        });
    }
    setupUserComp() {
        const compDetails = this.lookupUserCompDetails();
        if (compDetails) this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setUserCompDetails(compDetails);
    }
    lookupUserCompDetails() {
        const params = this.createParams();
        const colDef = this.column.getColDef();
        return $437b23f6a393c3bf$var$_getHeaderCompDetails(this.beans.userCompFactory, colDef, params);
    }
    createParams() {
        const { menuSvc: menuSvc, sortSvc: sortSvc, colFilter: colFilter, gos: gos } = this.beans;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            column: this.column,
            displayName: this.displayName,
            enableSorting: this.column.isSortable(),
            enableMenu: this.menuEnabled,
            enableFilterButton: this.openFilterEnabled && !!menuSvc?.isHeaderFilterButtonEnabled(this.column),
            enableFilterIcon: !!colFilter && (!this.openFilterEnabled || $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos)),
            showColumnMenu: (buttonElement, onClosedCallback)=>{
                menuSvc?.showColumnMenu({
                    column: this.column,
                    buttonElement: buttonElement,
                    positionBy: "button",
                    onClosedCallback: onClosedCallback
                });
            },
            showColumnMenuAfterMouseClick: (mouseEvent, onClosedCallback)=>{
                menuSvc?.showColumnMenu({
                    column: this.column,
                    mouseEvent: mouseEvent,
                    positionBy: "mouse",
                    onClosedCallback: onClosedCallback
                });
            },
            showFilter: (buttonElement)=>{
                menuSvc?.showFilterMenu({
                    column: this.column,
                    buttonElement: buttonElement,
                    containerType: "columnFilter",
                    positionBy: "button"
                });
            },
            progressSort: (multiSort)=>{
                sortSvc?.progressSort(this.column, !!multiSort, "uiColumnSorted");
            },
            setSort: (sort, multiSort)=>{
                sortSvc?.setSortForColumn(this.column, $437b23f6a393c3bf$export$2a92f4fc1f337c5a(sort), !!multiSort, "uiColumnSorted");
            },
            eGridHeader: this.eGui,
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.setupTooltip(value, shouldDisplayTooltip);
            }
        });
        return params;
    }
    setupSelectAll(compBean) {
        const { selectionSvc: selectionSvc } = this.beans;
        if (!selectionSvc) return;
        this.selectAllFeature = compBean.createOptionalManagedBean(selectionSvc.createSelectAllFeature(this.column));
        this.selectAllFeature?.setComp(this);
        compBean.addManagedPropertyListener("rowSelection", ()=>{
            const selectAllFeature = selectionSvc.createSelectAllFeature(this.column);
            if (selectAllFeature && !this.selectAllFeature) {
                this.selectAllFeature = compBean.createManagedBean(selectAllFeature);
                this.selectAllFeature?.setComp(this);
                this.comp.refreshSelectAllGui();
            } else if (this.selectAllFeature && !selectAllFeature) {
                this.comp.removeSelectAllGui();
                this.selectAllFeature = this.destroyBean(this.selectAllFeature);
            }
        });
    }
    getSelectAllGui() {
        return this.selectAllFeature?.getCheckboxGui();
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) this.selectAllFeature?.onSpaceKeyDown(e);
        else if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) this.onEnterKeyDown(e);
        else if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN && e.altKey) this.showMenuOnKeyPress(e, false);
    }
    onEnterKeyDown(e) {
        const { column: column, gos: gos, sortable: sortable, beans: beans } = this;
        let actioned = false;
        if (e.ctrlKey || e.metaKey) actioned = this.showMenuOnKeyPress(e, true);
        if (!actioned) {
            if (!e.altKey && $437b23f6a393c3bf$export$8242077b143dbc86(gos)) beans.rangeSvc?.handleColumnSelection(column, e);
            else if (sortable) beans.sortSvc?.progressSort(column, e.shiftKey, "uiColumnSorted");
        }
    }
    showMenuOnKeyPress(e, isFilterShortcut) {
        const headerComp = this.comp.getUserCompInstance();
        if (!$437b23f6a393c3bf$var$isHeaderComp(headerComp)) return false;
        if (headerComp.onMenuKeyboardShortcut(isFilterShortcut)) {
            e.preventDefault();
            return true;
        }
        return false;
    }
    onFocusIn(e) {
        if (!this.eGui.contains(e.relatedTarget)) {
            this.focusThis();
            this.announceAriaDescription();
        }
        if ($437b23f6a393c3bf$export$e4c8c227337b7f23()) this.setActiveHeader(true);
    }
    onFocusOut(e) {
        if (this.eGui.contains(e.relatedTarget)) return;
        this.setActiveHeader(false);
    }
    setupTooltip(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.setupHeaderTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    setupStylesFromColDef() {
        this.setRefreshFunction("headerStyles", this.refreshHeaderStyles.bind(this));
        this.refreshHeaderStyles();
    }
    setupClassesFromColDef() {
        const refreshHeaderClasses = ()=>{
            const colDef = this.column.getColDef();
            const classes = $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(colDef, this.gos, this.column, null);
            const oldClasses = this.userHeaderClasses;
            this.userHeaderClasses = new Set(classes);
            for (const c of classes)if (oldClasses.has(c)) oldClasses.delete(c);
            else this.comp.toggleCss(c, true);
            for (const c of oldClasses)this.comp.toggleCss(c, false);
        };
        this.setRefreshFunction("headerClasses", refreshHeaderClasses);
        refreshHeaderClasses();
    }
    setDragSource(eSource) {
        this.dragSourceElement = eSource;
        this.removeDragSource();
        if (!eSource || !this.draggable) return;
        this.dragSource = this.beans.colMoves?.setDragSourceForHeader(eSource, this.column, this.displayName) ?? null;
    }
    updateState() {
        const { menuSvc: menuSvc } = this.beans;
        this.menuEnabled = !!menuSvc?.isColumnMenuInHeaderEnabled(this.column);
        this.openFilterEnabled = !!menuSvc?.isFilterMenuInHeaderEnabled(this.column);
        this.sortable = this.column.isSortable();
        this.displayName = this.calculateDisplayName();
        this.draggable = this.workOutDraggable();
    }
    setRefreshFunction(name, func) {
        this.refreshFunctions[name] = func;
    }
    refresh() {
        this.updateState();
        this.refreshHeaderComp();
        this.refreshAria();
        for (const f of Object.values(this.refreshFunctions))f();
    }
    refreshHeaderComp() {
        const newCompDetails = this.lookupUserCompDetails();
        if (!newCompDetails) return;
        const compInstance = this.comp.getUserCompInstance();
        const attemptRefresh = compInstance != null && this.userCompDetails.componentClass == newCompDetails.componentClass;
        const headerCompRefreshed = attemptRefresh ? this.attemptHeaderCompRefresh(newCompDetails.params) : false;
        if (headerCompRefreshed) this.setDragSource(this.dragSourceElement);
        else this.setCompDetails(newCompDetails);
    }
    attemptHeaderCompRefresh(params) {
        const headerComp = this.comp.getUserCompInstance();
        if (!headerComp) return false;
        if (!headerComp.refresh) return false;
        const res = headerComp.refresh(params);
        return res;
    }
    calculateDisplayName() {
        return this.beans.colNames.getDisplayNameForColumn(this.column, "header", true);
    }
    checkDisplayName() {
        if (this.displayName !== this.calculateDisplayName()) this.refresh();
    }
    workOutDraggable() {
        const colDef = this.column.getColDef();
        const isSuppressMovableColumns = this.gos.get("suppressMovableColumns");
        const colCanMove = !isSuppressMovableColumns && !colDef.suppressMovable && !colDef.lockPosition;
        return !!colCanMove || !!colDef.enableRowGroup || !!colDef.enablePivot;
    }
    setupWidth(compBean) {
        const listener = ()=>{
            const columnWidth = this.column.getActualWidth();
            this.comp.setWidth(`${columnWidth}px`);
        };
        compBean.addManagedListeners(this.column, {
            widthChanged: listener
        });
        listener();
    }
    setupMovingCss(compBean) {
        const listener = ()=>{
            this.comp.toggleCss("ag-header-cell-moving", this.column.isMoving());
        };
        compBean.addManagedListeners(this.column, {
            movingChanged: listener
        });
        listener();
    }
    setupMenuClass(compBean) {
        const listener = ()=>{
            this.comp?.toggleCss("ag-column-menu-visible", this.column.isMenuVisible());
        };
        compBean.addManagedListeners(this.column, {
            menuVisibleChanged: listener
        });
        listener();
    }
    setupSortableClass(compBean) {
        const updateSortableCssClass = ()=>{
            this.comp.toggleCss("ag-header-cell-sortable", !!this.sortable);
        };
        updateSortableCssClass();
        this.setRefreshFunction("updateSortable", updateSortableCssClass);
        compBean.addManagedEventListeners({
            sortChanged: this.refreshAriaSort.bind(this)
        });
    }
    setupFilterClass(compBean) {
        const listener = ()=>{
            const isFilterActive = this.column.isFilterActive();
            this.comp.toggleCss("ag-header-cell-filtered", isFilterActive);
            this.refreshAria();
        };
        compBean.addManagedListeners(this.column, {
            filterActiveChanged: listener
        });
        listener();
    }
    setupWrapTextClass() {
        const listener = ()=>{
            const wrapText = !!this.column.getColDef().wrapHeaderText;
            this.comp.toggleCss("ag-header-cell-wrap-text", wrapText);
        };
        listener();
        this.setRefreshFunction("wrapText", listener);
    }
    onHeaderHighlightChanged() {
        const highlighted = this.column.getHighlighted();
        const beforeOn = highlighted === 0 /* Before */ ;
        const afterOn = highlighted === 1 /* After */ ;
        this.comp.toggleCss("ag-header-highlight-before", beforeOn);
        this.comp.toggleCss("ag-header-highlight-after", afterOn);
    }
    onDisplayedColumnsChanged() {
        super.onDisplayedColumnsChanged();
        if (!this.isAlive()) return;
        this.onHeaderHeightChanged();
    }
    onHeaderHeightChanged() {
        this.refreshSpanHeaderHeight();
    }
    refreshSpanHeaderHeight() {
        const { eGui: eGui, column: column, comp: comp, beans: beans } = this;
        const groupHeaderHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(this.beans);
        const isZeroGroupHeight = groupHeaderHeight.reduce((total, next)=>total + next, 0) === 0;
        comp.toggleCss("ag-header-parent-hidden", isZeroGroupHeight);
        if (!column.isSpanHeaderHeight()) {
            eGui.style.removeProperty("top");
            eGui.style.removeProperty("height");
            comp.toggleCss("ag-header-span-height", false);
            comp.toggleCss("ag-header-span-total", false);
            return;
        }
        const { numberOfParents: numberOfParents, isSpanningTotal: isSpanningTotal } = this.column.getColumnGroupPaddingInfo();
        comp.toggleCss("ag-header-span-height", numberOfParents > 0);
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans);
        if (numberOfParents === 0) {
            comp.toggleCss("ag-header-span-total", false);
            eGui.style.setProperty("top", `0px`);
            eGui.style.setProperty("height", `${headerHeight}px`);
            return;
        }
        comp.toggleCss("ag-header-span-total", isSpanningTotal);
        const indexToStartSpanning = (this.column.getFirstRealParent()?.getLevel() ?? -1) + 1;
        const rowsToSpan = groupHeaderHeight.length - indexToStartSpanning;
        let extraHeight = 0;
        for(let i = 0; i < rowsToSpan; i++)extraHeight += groupHeaderHeight[groupHeaderHeight.length - 1 - i];
        eGui.style.setProperty("top", `${-extraHeight}px`);
        eGui.style.setProperty("height", `${headerHeight + extraHeight}px`);
    }
    refreshAriaSort() {
        let description = null;
        const { beans: beans, column: column, comp: comp, sortable: sortable } = this;
        if (sortable) {
            const translate = this.getLocaleTextFunc();
            const sortDef = beans.sortSvc?.getDisplaySortForColumn(column) ?? null;
            comp.setAriaSort($437b23f6a393c3bf$var$_getAriaSortState(sortDef));
            description = translate("ariaSortableColumn", "Press ENTER to sort");
        } else comp.setAriaSort();
        this.setAriaDescriptionProperty("sort", description);
    }
    refreshAriaMenu() {
        let description = null;
        if (this.menuEnabled) {
            const translate = this.getLocaleTextFunc();
            description = translate("ariaMenuColumn", "Press ALT DOWN to open column menu");
        }
        this.setAriaDescriptionProperty("menu", description);
    }
    refreshAriaFilterButton() {
        let description = null;
        const { openFilterEnabled: openFilterEnabled, gos: gos } = this;
        if (openFilterEnabled && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos)) {
            const translate = this.getLocaleTextFunc();
            description = translate("ariaFilterColumn", "Press CTRL ENTER to open filter");
        }
        this.setAriaDescriptionProperty("filterButton", description);
    }
    refreshAriaFiltered() {
        let description = null;
        if (this.column.isFilterActive()) {
            const translate = this.getLocaleTextFunc();
            description = translate("ariaColumnFiltered", "Column Filtered");
        }
        this.setAriaDescriptionProperty("filter", description);
    }
    refreshAriaCellSelection() {
        let description = null;
        const { gos: gos, column: column, beans: beans } = this;
        const enableColumnSelection = $437b23f6a393c3bf$export$8242077b143dbc86(gos);
        if (enableColumnSelection) {
            const translate = this.getLocaleTextFunc();
            const colSelected = beans.rangeSvc?.isColumnInAnyRange(column);
            description = translate("ariaColumnCellSelection", `Press CTRL+SPACE to ${colSelected ? "de" : ""}select all visible cells in this column`);
        }
        this.setAriaDescriptionProperty("cellSelection", description);
    }
    setAriaDescriptionProperty(property, value) {
        const props = this.ariaDescriptionProperties;
        if (value != null) props.set(property, value);
        else props.delete(property);
    }
    announceAriaDescription() {
        const { beans: beans, eGui: eGui, ariaDescriptionProperties: ariaDescriptionProperties } = this;
        if (!eGui.contains($437b23f6a393c3bf$export$16bc98d422315038(beans))) return;
        const ariaDescription = Array.from(ariaDescriptionProperties.keys()).sort((a, b)=>a === "filter" ? -1 : b.charCodeAt(0) - a.charCodeAt(0)).map((key)=>ariaDescriptionProperties.get(key)).join(". ");
        beans.ariaAnnounce?.announceValue(ariaDescription, "columnHeader");
    }
    refreshAria() {
        this.refreshAriaSort();
        this.refreshAriaMenu();
        this.refreshAriaFilterButton();
        this.refreshAriaFiltered();
        this.refreshAriaCellSelection();
    }
    addColumnHoverListener(compBean) {
        this.beans.colHover?.addHeaderColumnHoverListener(compBean, this.comp, this.column);
    }
    addActiveHeaderMouseListeners(compBean) {
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>{
            this.setActiveHeader(true);
            this.dispatchColumnMouseEvent("columnHeaderClicked", this.column);
        };
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, this.column);
        compBean.addManagedListeners(this.eGui, {
            mouseenter: listener,
            mouseleave: listener,
            click: clickListener,
            contextmenu: contextMenuListener
        });
    }
    handleMouseOverChange(isMouseOver) {
        this.setActiveHeader(isMouseOver);
        this.eventSvc.dispatchEvent({
            type: isMouseOver ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
            column: this.column
        });
    }
    setActiveHeader(active) {
        this.comp.toggleCss("ag-header-active", active);
    }
    getAnchorElementForMenu(isFilter) {
        const headerComp = this.comp.getUserCompInstance();
        if ($437b23f6a393c3bf$var$isHeaderComp(headerComp)) return headerComp.getAnchorElementForMenu(isFilter);
        return this.eGui;
    }
    destroy() {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$isHeaderComp(headerComp) {
    return typeof headerComp?.getAnchorElementForMenu === "function" && typeof headerComp.onMenuKeyboardShortcut === "function";
}
// packages/ag-grid-community/src/headerRendering/row/headerRowCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence3 = 0;
var $437b23f6a393c3bf$var$HeaderRowCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowIndex, pinned, type){
        super();
        this.rowIndex = rowIndex;
        this.pinned = pinned;
        this.type = type;
        this.instanceId = $437b23f6a393c3bf$var$instanceIdSequence3++;
        this.comp = null;
        this.allCtrls = [];
        let typeClass = "ag-header-row-column";
        if (type === "group") typeClass = "ag-header-row-group";
        else if (type === "filter") typeClass = "ag-header-row-filter";
        this.headerRowClass = `ag-header-row ${typeClass}`;
    }
    setRowIndex(rowIndex) {
        this.rowIndex = rowIndex;
        this.comp?.setRowIndex(this.getAriaRowIndex());
        this.onRowHeightChanged();
    }
    postConstruct() {
        this.isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
    }
    /** Checks that every header cell that is currently visible has been rendered.
   * Can only be false under some circumstances when using React
   */ areCellsRendered() {
        if (!this.comp) return false;
        return this.allCtrls.every((ctrl)=>ctrl.eGui != null);
    }
    /**
   *
   * @param comp Proxy to the actual component
   * @param initCompState Should the component be initialised with the current state of the controller. Default: true
   */ setComp(comp, compBean, initCompState = true) {
        this.comp = comp;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, this.beans.context, compBean);
        if (initCompState) {
            this.setRowIndex(this.rowIndex);
            this.onVirtualColumnsChanged();
        }
        this.setWidth();
        this.addEventListeners(compBean);
    }
    getAriaRowIndex() {
        return this.rowIndex + 1;
    }
    addEventListeners(compBean) {
        const onHeightChanged = this.onRowHeightChanged.bind(this);
        const onDisplayedColumnsChanged = this.onDisplayedColumnsChanged.bind(this);
        compBean.addManagedEventListeners({
            columnResized: this.setWidth.bind(this),
            displayedColumnsChanged: onDisplayedColumnsChanged,
            virtualColumnsChanged: (params)=>this.onVirtualColumnsChanged(params.afterScroll),
            columnGroupHeaderHeightChanged: onHeightChanged,
            columnHeaderHeightChanged: onHeightChanged,
            stylesChanged: onHeightChanged,
            advancedFilterEnabledChanged: onHeightChanged
        });
        compBean.addManagedPropertyListener("domLayout", onDisplayedColumnsChanged);
        compBean.addManagedPropertyListener("ensureDomOrder", (e)=>this.isEnsureDomOrder = e.currentValue);
        compBean.addManagedPropertyListeners([
            "headerHeight",
            "pivotHeaderHeight",
            "groupHeaderHeight",
            "pivotGroupHeaderHeight",
            "floatingFiltersHeight"
        ], onHeightChanged);
    }
    onDisplayedColumnsChanged() {
        this.isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        this.onVirtualColumnsChanged();
        this.setWidth();
        this.onRowHeightChanged();
    }
    setWidth() {
        if (!this.comp) return;
        const width = this.getWidthForRow();
        this.comp.setWidth(`${width}px`);
    }
    getWidthForRow() {
        const { visibleCols: visibleCols } = this.beans;
        if (this.isPrintLayout) {
            const pinned = this.pinned != null;
            if (pinned) return 0;
            return visibleCols.getContainerWidth("right") + visibleCols.getContainerWidth("left") + visibleCols.getContainerWidth(null);
        }
        return visibleCols.getContainerWidth(this.pinned);
    }
    onRowHeightChanged() {
        if (!this.comp) return;
        const { topOffset: topOffset, rowHeight: rowHeight } = this.getTopAndHeight();
        this.comp.setTop(topOffset + "px");
        this.comp.setHeight(rowHeight + "px");
    }
    getTopAndHeight() {
        let topOffset = 0;
        const groupHeadersHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(this.beans);
        for(let i = 0; i < groupHeadersHeight.length; i++){
            if (i === this.rowIndex && this.type === "group") return {
                topOffset: topOffset,
                rowHeight: groupHeadersHeight[i]
            };
            topOffset += groupHeadersHeight[i];
        }
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(this.beans);
        if (this.type === "column") return {
            topOffset: topOffset,
            rowHeight: headerHeight
        };
        topOffset += headerHeight;
        const filterHeight = $437b23f6a393c3bf$export$b52d5533bf5be44(this.beans);
        return {
            topOffset: topOffset,
            rowHeight: filterHeight
        };
    }
    onVirtualColumnsChanged(afterScroll = false) {
        if (!this.comp) return;
        const ctrlsToDisplay = this.getUpdatedHeaderCtrls();
        const forceOrder = this.isEnsureDomOrder || this.isPrintLayout;
        this.comp.setHeaderCtrls(ctrlsToDisplay, forceOrder, afterScroll);
    }
    /**
   * Recycles the header cell ctrls and creates new ones for the columns in the viewport
   * @returns The updated header cell ctrls
   */ getUpdatedHeaderCtrls() {
        const oldCtrls = this.ctrlsById;
        this.ctrlsById = /* @__PURE__ */ new Map();
        const columns = this.getColumnsInViewport();
        for (const child of columns)this.recycleAndCreateHeaderCtrls(child, this.ctrlsById, oldCtrls);
        const isFocusedAndDisplayed = (ctrl)=>{
            const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
            const isFocused = focusSvc.isHeaderWrapperFocused(ctrl);
            if (!isFocused) return false;
            const isDisplayed = visibleCols.isVisible(ctrl.column);
            return isDisplayed;
        };
        if (oldCtrls) for (const [id, oldCtrl] of oldCtrls){
            const keepCtrl = isFocusedAndDisplayed(oldCtrl);
            if (keepCtrl) this.ctrlsById.set(id, oldCtrl);
            else this.destroyBean(oldCtrl);
        }
        this.allCtrls = Array.from(this.ctrlsById.values());
        return this.allCtrls;
    }
    /** Get the current header cell ctrls */ getHeaderCellCtrls() {
        return this.allCtrls;
    }
    recycleAndCreateHeaderCtrls(headerColumn, currCtrls, oldCtrls) {
        if (headerColumn.isEmptyGroup()) return;
        const idOfChild = headerColumn.getUniqueId();
        let headerCtrl;
        if (oldCtrls) {
            headerCtrl = oldCtrls.get(idOfChild);
            oldCtrls.delete(idOfChild);
        }
        const forOldColumn = headerCtrl && headerCtrl.column != headerColumn;
        if (forOldColumn) {
            this.destroyBean(headerCtrl);
            headerCtrl = void 0;
        }
        if (headerCtrl == null) switch(this.type){
            case "filter":
                headerCtrl = this.createBean(this.beans.registry.createDynamicBean("headerFilterCellCtrl", true, headerColumn, this));
                break;
            case "group":
                headerCtrl = this.createBean(this.beans.registry.createDynamicBean("headerGroupCellCtrl", true, headerColumn, this));
                break;
            default:
                headerCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderCellCtrl(headerColumn, this));
                break;
        }
        currCtrls.set(idOfChild, headerCtrl);
    }
    getColumnsInViewport() {
        if (!this.isPrintLayout) return this.getComponentsToRender();
        if (this.pinned) return [];
        const viewportColumns = [];
        for (const pinned of [
            "left",
            null,
            "right"
        ])viewportColumns.push(...this.getComponentsToRender(pinned));
        return viewportColumns;
    }
    getComponentsToRender(pinned = this.pinned) {
        if (this.type === "group") return this.beans.colViewport.getHeadersToRender(pinned, this.rowIndex);
        return this.beans.colViewport.getColumnHeadersToRender(pinned);
    }
    focusHeader(column, event) {
        const ctrl = this.allCtrls.find((ctrl2)=>ctrl2.column == column);
        if (!ctrl) return false;
        const focused = ctrl.focus(event);
        return focused;
    }
    destroy() {
        this.allCtrls = this.destroyBeans(this.allCtrls);
        this.ctrlsById = void 0;
        this.comp = null;
        super.destroy();
    }
};
// packages/ag-grid-community/src/headerRendering/rowContainer/headerRowContainerCtrl.ts
var $437b23f6a393c3bf$export$1e864ee88f54e7b = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.hidden = false;
        this.includeFloatingFilter = false;
        this.groupsRowCtrls = [];
    }
    setComp(comp, eGui) {
        this.comp = comp;
        this.eViewport = eGui;
        const { pinnedCols: pinnedCols, ctrlsSvc: ctrlsSvc, colModel: colModel, colMoves: colMoves } = this.beans;
        this.setupCenterWidth();
        pinnedCols?.setupHeaderPinnedWidth(this);
        this.setupDragAndDrop(colMoves, this.eViewport);
        const onDisplayedColsChanged = this.refresh.bind(this, true);
        this.addManagedEventListeners({
            displayedColumnsChanged: onDisplayedColsChanged,
            advancedFilterEnabledChanged: onDisplayedColsChanged
        });
        const headerType = `${typeof this.pinned === "string" ? this.pinned : "center"}Header`;
        ctrlsSvc.register(headerType, this);
        if (colModel.ready) this.refresh();
    }
    getAllCtrls() {
        const res = [
            ...this.groupsRowCtrls
        ];
        if (this.columnsRowCtrl) res.push(this.columnsRowCtrl);
        if (this.filtersRowCtrl) res.push(this.filtersRowCtrl);
        return res;
    }
    refresh(keepColumns = false) {
        const { focusSvc: focusSvc, filterManager: filterManager, visibleCols: visibleCols } = this.beans;
        let sequence = 0;
        const focusedHeaderPosition = focusSvc.getFocusHeaderToUseAfterRefresh();
        const refreshColumnGroups = ()=>{
            const groupRowCount = visibleCols.headerGroupRowCount;
            sequence = groupRowCount;
            if (!keepColumns) this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
            const currentGroupCount = this.groupsRowCtrls.length;
            if (currentGroupCount === groupRowCount) return;
            if (currentGroupCount > groupRowCount) {
                for(let i = groupRowCount; i < currentGroupCount; i++)this.destroyBean(this.groupsRowCtrls[i]);
                this.groupsRowCtrls.length = groupRowCount;
                return;
            }
            for(let i = currentGroupCount; i < groupRowCount; i++){
                const ctrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(i, this.pinned, "group"));
                this.groupsRowCtrls.push(ctrl);
            }
        };
        const refreshColumns = ()=>{
            const rowIndex = sequence++;
            if (this.hidden) {
                this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
                return;
            }
            if (this.columnsRowCtrl == null || !keepColumns) {
                this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
                this.columnsRowCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(rowIndex, this.pinned, "column"));
            } else if (this.columnsRowCtrl.rowIndex !== rowIndex) this.columnsRowCtrl.setRowIndex(rowIndex);
        };
        const refreshFilters = ()=>{
            this.includeFloatingFilter = !!filterManager?.hasFloatingFilters() && !this.hidden;
            const destroyPreviousComp = ()=>{
                this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
            };
            if (!this.includeFloatingFilter) {
                destroyPreviousComp();
                return;
            }
            if (!keepColumns) destroyPreviousComp();
            const rowIndex = sequence++;
            if (this.filtersRowCtrl) {
                const rowIndexMismatch = this.filtersRowCtrl.rowIndex !== rowIndex;
                if (rowIndexMismatch) this.filtersRowCtrl.setRowIndex(rowIndex);
            } else this.filtersRowCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(rowIndex, this.pinned, "filter"));
        };
        const oldCtrls = this.getAllCtrls();
        refreshColumnGroups();
        refreshColumns();
        refreshFilters();
        const allCtrls = this.getAllCtrls();
        this.comp.setCtrls(allCtrls);
        this.restoreFocusOnHeader(focusSvc, focusedHeaderPosition);
        if (oldCtrls.length !== allCtrls.length) this.beans.eventSvc.dispatchEvent({
            type: "headerRowsChanged"
        });
    }
    getHeaderCtrlForColumn(column) {
        const findCtrl = (ctrl)=>ctrl?.getHeaderCellCtrls().find((ctrl2)=>ctrl2.column === column);
        if ($437b23f6a393c3bf$export$891484e65a02ec71(column)) return findCtrl(this.columnsRowCtrl);
        if (this.groupsRowCtrls.length === 0) return;
        for(let i = 0; i < this.groupsRowCtrls.length; i++){
            const ctrl = findCtrl(this.groupsRowCtrls[i]);
            if (ctrl) return ctrl;
        }
    }
    getHtmlElementForColumnHeader(column) {
        return this.getHeaderCtrlForColumn(column)?.eGui ?? null;
    }
    getRowType(rowIndex) {
        return this.getAllCtrls()[rowIndex]?.type;
    }
    focusHeader(rowIndex, column, event) {
        const allCtrls = this.getAllCtrls();
        const ctrl = allCtrls[rowIndex];
        if (!ctrl) return false;
        return ctrl.focusHeader(column, event);
    }
    getGroupRowCount() {
        return this.groupsRowCtrls.length;
    }
    getGroupRowCtrlAtIndex(index) {
        return this.groupsRowCtrls[index];
    }
    getRowCount() {
        return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
    }
    setHorizontalScroll(offset) {
        this.comp.setViewportScrollLeft(offset);
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
    destroy() {
        this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
        this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
        this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
        super.destroy();
    }
    setupDragAndDrop(colMoves, dropContainer) {
        const bodyDropTarget = colMoves?.createBodyDropTarget(this.pinned, dropContainer);
        if (bodyDropTarget) this.createManagedBean(bodyDropTarget);
    }
    restoreFocusOnHeader(focusSvc, position) {
        if (!position) return;
        const { column: column } = position;
        if (column.getPinned() != this.pinned) return;
        focusSvc.focusHeaderPosition({
            headerPosition: position,
            scroll: false
        });
    }
    setupCenterWidth() {
        if (this.pinned != null) return;
        this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.comp.setCenterWidth(`${width}px`), true));
    }
};
// packages/ag-grid-community/src/misc/menu/menuService.ts
var $437b23f6a393c3bf$var$MenuService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "menuSvc";
    }
    postConstruct() {
        const { enterpriseMenuFactory: enterpriseMenuFactory, filterMenuFactory: filterMenuFactory } = this.beans;
        this.activeMenuFactory = enterpriseMenuFactory ?? filterMenuFactory;
    }
    showColumnMenu(params) {
        this.showColumnMenuCommon(this.activeMenuFactory, params, "columnMenu");
    }
    showFilterMenu(params) {
        this.showColumnMenuCommon($437b23f6a393c3bf$var$getFilterMenuFactory(this.beans), params, params.containerType, true);
    }
    showHeaderContextMenu(column, mouseEvent, touchEvent) {
        this.activeMenuFactory?.showMenuAfterContextMenuEvent(column, mouseEvent, touchEvent);
    }
    hidePopupMenu() {
        this.beans.contextMenuSvc?.hideActiveMenu();
        this.activeMenuFactory?.hideActiveMenu();
    }
    hideFilterMenu() {
        $437b23f6a393c3bf$var$getFilterMenuFactory(this.beans)?.hideActiveMenu();
    }
    isColumnMenuInHeaderEnabled(column) {
        const { suppressHeaderMenuButton: suppressHeaderMenuButton } = column.getColDef();
        return !suppressHeaderMenuButton && !!this.activeMenuFactory?.isMenuEnabled(column) && ($437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) || !!this.beans.enterpriseMenuFactory);
    }
    isFilterMenuInHeaderEnabled(column) {
        return !column.getColDef().suppressHeaderFilterButton && !!this.beans.filterManager?.isFilterAllowed(column);
    }
    isHeaderContextMenuEnabled(column) {
        const colDef = column && $437b23f6a393c3bf$export$891484e65a02ec71(column) ? column.getColDef() : column?.getColGroupDef();
        return !colDef?.suppressHeaderContextMenu && this.gos.get("columnMenu") === "new";
    }
    isHeaderMenuButtonAlwaysShowEnabled() {
        return this.isSuppressMenuHide();
    }
    isHeaderMenuButtonEnabled() {
        const menuHides = !this.isSuppressMenuHide();
        const onIpadAndMenuHides = $437b23f6a393c3bf$export$6b6034a68325bd8a() && menuHides;
        return !onIpadAndMenuHides;
    }
    isHeaderFilterButtonEnabled(column) {
        return this.isFilterMenuInHeaderEnabled(column) && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) && !this.isFloatingFilterButtonDisplayed(column);
    }
    isFilterMenuItemEnabled(column) {
        return !!this.beans.filterManager?.isFilterAllowed(column) && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) && !this.isFilterMenuInHeaderEnabled(column) && !this.isFloatingFilterButtonDisplayed(column);
    }
    isFloatingFilterButtonEnabled(column) {
        return !column.getColDef().suppressFloatingFilterButton;
    }
    isFloatingFilterButtonDisplayed(column) {
        return !!column.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(column);
    }
    isSuppressMenuHide() {
        const gos = this.gos;
        const suppressMenuHide = gos.get("suppressMenuHide");
        if ($437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos)) return gos.exists("suppressMenuHide") ? suppressMenuHide : false;
        return suppressMenuHide;
    }
    showColumnMenuCommon(menuFactory, params, containerType, filtersOnly) {
        const { positionBy: positionBy, onClosedCallback: onClosedCallback } = params;
        const column = params.column;
        if (positionBy === "button") {
            const { buttonElement: buttonElement } = params;
            menuFactory?.showMenuAfterButtonClick(column, buttonElement, containerType, onClosedCallback, filtersOnly);
        } else if (positionBy === "mouse") {
            const { mouseEvent: mouseEvent } = params;
            menuFactory?.showMenuAfterMouseEvent(column, mouseEvent, containerType, onClosedCallback, filtersOnly);
        } else if (column) {
            const beans = this.beans;
            const ctrlsSvc = beans.ctrlsSvc;
            ctrlsSvc.getScrollFeature().ensureColumnVisible(column, "auto");
            $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>{
                const headerCellCtrl = ctrlsSvc.getHeaderRowContainerCtrl(column.getPinned())?.getHeaderCtrlForColumn(column);
                if (headerCellCtrl) menuFactory?.showMenuAfterButtonClick(column, headerCellCtrl.getAnchorElementForMenu(filtersOnly), containerType, onClosedCallback, filtersOnly);
            });
        }
    }
};
function $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, visible, source) {
    if (column.menuVisible !== visible) {
        column.menuVisible = visible;
        column.dispatchColEvent("menuVisibleChanged", source);
    }
}
function $437b23f6a393c3bf$var$getFilterMenuFactory(beans) {
    const { enterpriseMenuFactory: enterpriseMenuFactory, filterMenuFactory: filterMenuFactory, gos: gos } = beans;
    return enterpriseMenuFactory && $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos) ? enterpriseMenuFactory : filterMenuFactory;
}
// packages/ag-grid-community/src/edit/cellEditors/agAbstractCellEditor.ts
var $437b23f6a393c3bf$export$803b08aecd9af1a9 = class extends $437b23f6a393c3bf$export$acd471c9223f27ae {
    constructor(){
        super(...arguments);
        this.errorMessages = null;
    }
    init(params) {
        this.params = params;
        this.initialiseEditor(params);
        this.eEditor.onValueChange(()=>params.validate());
    }
    destroy() {
        this.errorMessages = null;
    }
};
// packages/ag-grid-community/src/rendering/overlays/overlayComponent.ts
var $437b23f6a393c3bf$var$OverlayComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
    }
};
// packages/ag-grid-community/src/utils/icon.ts
function $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1(iconName, beans, column) {
    const iconContents = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, beans, column);
    if (iconContents) {
        const { className: className } = iconContents;
        if (typeof className === "string" && className.includes("ag-icon") || typeof className === "object" && className["ag-icon"]) return iconContents;
    }
    const eResult = $437b23f6a393c3bf$export$a232bb0480ae674a({
        tag: "span"
    });
    eResult.appendChild(iconContents);
    return eResult;
}
function $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, beans, column) {
    let userProvidedIcon = null;
    if (iconName === "smallDown") $437b23f6a393c3bf$export$545083624300f13d(262);
    else if (iconName === "smallLeft") $437b23f6a393c3bf$export$545083624300f13d(263);
    else if (iconName === "smallRight") $437b23f6a393c3bf$export$545083624300f13d(264);
    const icons = column?.getColDef().icons;
    if (icons) userProvidedIcon = icons[iconName];
    if (beans.gos && !userProvidedIcon) {
        const optionsIcons = beans.gos.get("icons");
        if (optionsIcons) userProvidedIcon = optionsIcons[iconName];
    }
    if (userProvidedIcon) {
        let rendererResult;
        if (typeof userProvidedIcon === "function") rendererResult = userProvidedIcon();
        else if (typeof userProvidedIcon === "string") rendererResult = userProvidedIcon;
        else {
            $437b23f6a393c3bf$export$545083624300f13d(38, {
                iconName: iconName
            });
            return void 0;
        }
        if (typeof rendererResult === "string") return $437b23f6a393c3bf$export$b1f57d075ca6d5fb(rendererResult);
        if ($437b23f6a393c3bf$export$6e6303ef478b0c94(rendererResult)) return rendererResult;
        $437b23f6a393c3bf$export$545083624300f13d(133, {
            iconName: iconName
        });
        return void 0;
    } else {
        const iconValue = beans.registry.getIcon(iconName);
        if (!iconValue) beans.validation?.validateIcon(iconName);
        return $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "span",
            cls: `ag-icon ag-icon-${iconValue ?? iconName}`,
            role: "presentation",
            attrs: {
                unselectable: "on"
            }
        });
    }
}
// packages/ag-grid-community/src/rendering/overlays/loadingOverlayComponent.ts
var $437b23f6a393c3bf$var$LoadingOverlayElement = {
    tag: "div",
    cls: "ag-overlay-loading-center",
    children: [
        {
            tag: "span",
            ref: "eLoadingIcon",
            cls: "ag-loading-icon"
        },
        {
            tag: "span",
            ref: "eLoadingText",
            cls: "ag-loading-text"
        }
    ]
};
var $437b23f6a393c3bf$var$LoadingOverlayComponent = class extends $437b23f6a393c3bf$var$OverlayComponent {
    constructor(){
        super(...arguments);
        this.eLoadingIcon = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eLoadingText = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    init(params) {
        const { beans: beans, gos: gos } = this;
        const customTemplate = $437b23f6a393c3bf$export$4978424c4f7b5fc0(gos.get("overlayLoadingTemplate")?.trim());
        this.setTemplate(customTemplate ?? $437b23f6a393c3bf$var$LoadingOverlayElement);
        if (!customTemplate) {
            const eLoadingIcon = $437b23f6a393c3bf$export$d8feba07bf373edb("overlayLoading", beans, null);
            if (eLoadingIcon) this.eLoadingIcon.appendChild(eLoadingIcon);
            const loadingText = params.loading?.overlayText ?? this.getLocaleTextFunc()("loadingOoo", "Loading...");
            this.eLoadingText.textContent = loadingText;
            beans.ariaAnnounce.announceValue(loadingText, "overlay");
        }
    }
};
// packages/ag-grid-community/src/rendering/overlays/exportingOverlayComponent.ts
var $437b23f6a393c3bf$var$ExportingOverlayElement = {
    tag: "div",
    cls: "ag-overlay-exporting-center",
    children: [
        {
            tag: "span",
            ref: "eExportingIcon",
            cls: "ag-loading-icon"
        },
        {
            tag: "span",
            ref: "eExportingText",
            cls: "ag-exporting-text"
        }
    ]
};
var $437b23f6a393c3bf$var$ExportingOverlayComponent = class extends $437b23f6a393c3bf$var$OverlayComponent {
    constructor(){
        super(...arguments);
        this.eExportingIcon = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eExportingText = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    init(params) {
        const { beans: beans } = this;
        this.setTemplate($437b23f6a393c3bf$var$ExportingOverlayElement);
        const eExportingIcon = $437b23f6a393c3bf$export$d8feba07bf373edb("overlayExporting", beans, null);
        if (eExportingIcon) this.eExportingIcon.appendChild(eExportingIcon);
        const exportingText = params.exporting?.overlayText ?? this.getLocaleTextFunc()("exportingOoo", "Exporting...");
        this.eExportingText.textContent = exportingText;
        beans.ariaAnnounce.announceValue(exportingText, "overlay");
    }
};
// packages/ag-grid-community/src/rendering/overlays/noRowsOverlayComponent.ts
var $437b23f6a393c3bf$var$NoRowsOverlayElement = {
    tag: "span",
    cls: "ag-overlay-no-rows-center"
};
var $437b23f6a393c3bf$var$NoRowsOverlayComponent = class extends $437b23f6a393c3bf$var$OverlayComponent {
    init(params) {
        const { beans: beans, gos: gos } = this;
        const customTemplate = $437b23f6a393c3bf$export$4978424c4f7b5fc0(gos.get("overlayNoRowsTemplate")?.trim());
        this.setTemplate(customTemplate ?? $437b23f6a393c3bf$var$NoRowsOverlayElement);
        if (!customTemplate) {
            const noRowsText = params.noRows?.overlayText ?? this.getLocaleTextFunc()("noRowsToShow", "No Rows To Show");
            this.getGui().textContent = noRowsText;
            beans.ariaAnnounce.announceValue(noRowsText, "overlay");
        }
    }
};
// packages/ag-grid-community/src/rendering/overlays/noMatchingRowsOverlayComponent.ts
var $437b23f6a393c3bf$var$NoMatchingRowsOverlayElement = {
    tag: "span",
    cls: "ag-overlay-no-matching-rows-center"
};
var $437b23f6a393c3bf$var$NoMatchingRowsOverlayComponent = class extends $437b23f6a393c3bf$var$OverlayComponent {
    init(params) {
        const { beans: beans } = this;
        this.setTemplate($437b23f6a393c3bf$var$NoMatchingRowsOverlayElement);
        const noRowsText = params.noMatchingRows?.overlayText ?? this.getLocaleTextFunc()("noMatchingRows", "No Matching Rows");
        this.getGui().textContent = noRowsText;
        beans.ariaAnnounce.announceValue(noRowsText, "overlay");
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragAndDropImageComponent.css-GENERATED.ts
var $437b23f6a393c3bf$var$dragAndDropImageComponentCSS = /*css*/ `.ag-dnd-ghost{align-items:center;background-color:var(--ag-drag-and-drop-image-background-color);border:var(--ag-drag-and-drop-image-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-drag-and-drop-image-shadow);color:var(--ag-text-color);cursor:move;display:flex;font-weight:500;gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding);text-overflow:ellipsis;transform:translateY(calc(var(--ag-spacing)*2));white-space:nowrap}.ag-dnd-ghost-not-allowed{border:var(--ag-drag-and-drop-image-not-allowed-border)}`;
// packages/ag-grid-community/src/dragAndDrop/dragAndDropImageComponent.ts
var $437b23f6a393c3bf$var$DragAndDropElement = {
    tag: "div",
    children: [
        {
            tag: "div",
            ref: "eGhost",
            cls: "ag-dnd-ghost ag-unselectable",
            children: [
                {
                    tag: "span",
                    ref: "eIcon",
                    cls: "ag-dnd-ghost-icon ag-shake-left-to-right"
                },
                {
                    tag: "div",
                    ref: "eLabel",
                    cls: "ag-dnd-ghost-label"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$DragAndDropImageComponent2 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
        this.dragSource = null;
        this.eIcon = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eGhost = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$dragAndDropImageComponentCSS);
    }
    postConstruct() {
        const create = (iconName)=>$437b23f6a393c3bf$export$f4e9fbdaadc5e5c1(iconName, this.beans, null);
        this.dropIconMap = {
            pinned: create("columnMovePin"),
            hide: create("columnMoveHide"),
            move: create("columnMoveMove"),
            left: create("columnMoveLeft"),
            right: create("columnMoveRight"),
            group: create("columnMoveGroup"),
            aggregate: create("columnMoveValue"),
            pivot: create("columnMovePivot"),
            notAllowed: create("dropNotAllowed")
        };
    }
    init(params) {
        this.dragSource = params.dragSource;
        this.setTemplate($437b23f6a393c3bf$var$DragAndDropElement);
        this.beans.environment.applyThemeClasses(this.eGhost);
    }
    destroy() {
        this.dragSource = null;
        super.destroy();
    }
    setIcon(iconName, shake) {
        const { eGhost: eGhost, eIcon: eIcon, dragSource: dragSource, dropIconMap: dropIconMap, gos: gos } = this;
        $437b23f6a393c3bf$export$69e6e10709eabd91(eIcon);
        let eIconChild = null;
        if (!iconName) iconName = dragSource?.getDefaultIconName ? dragSource.getDefaultIconName() : "notAllowed";
        eIconChild = dropIconMap[iconName];
        eGhost.classList.toggle("ag-dnd-ghost-not-allowed", iconName === "notAllowed");
        eIcon.classList.toggle("ag-shake-left-to-right", shake);
        if (eIconChild === dropIconMap["hide"] && gos.get("suppressDragLeaveHidesColumns")) return;
        if (eIconChild) eIcon.appendChild(eIconChild);
    }
    setLabel(label) {
        this.eLabel.textContent = label;
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/checkboxCellRenderer.css-GENERATED.ts
var $437b23f6a393c3bf$var$checkboxCellRendererCSS = /*css*/ `.ag-checkbox-cell{height:100%}`;
// packages/ag-grid-community/src/rendering/cellRenderers/checkboxCellRenderer.ts
var $437b23f6a393c3bf$var$CheckboxCellRendererElement = {
    tag: "div",
    cls: "ag-cell-wrapper ag-checkbox-cell",
    role: "presentation",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxCellRendererElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eCheckbox = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$checkboxCellRendererCSS);
    }
    init(params) {
        this.refresh(params);
        const { eCheckbox: eCheckbox, beans: beans } = this;
        const inputEl = eCheckbox.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        $437b23f6a393c3bf$var$_setAriaLive(inputEl, "polite");
        this.addManagedListeners(inputEl, {
            click: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
                if (eCheckbox.isDisabled()) return;
                const isSelected = eCheckbox.getValue();
                this.onCheckboxChanged(isSelected);
            },
            dblclick: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
            }
        });
        this.addManagedElementListeners(params.eGridCell, {
            keydown: (event)=>{
                if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE && !eCheckbox.isDisabled()) {
                    if (params.eGridCell === $437b23f6a393c3bf$export$16bc98d422315038(beans)) eCheckbox.toggle();
                    const isSelected = eCheckbox.getValue();
                    this.onCheckboxChanged(isSelected);
                    event.preventDefault();
                }
            }
        });
    }
    refresh(params) {
        this.params = params;
        this.updateCheckbox(params);
        return true;
    }
    updateCheckbox(params) {
        let isSelected;
        let displayed = true;
        const { value: value, column: column, node: node } = params;
        if (node.group && column) {
            if (typeof value === "boolean") isSelected = value;
            else {
                const colId = column.getColId();
                if (colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6)) isSelected = value == null || value === "" ? void 0 : value === "true";
                else if (node.aggData && node.aggData[colId] !== void 0) isSelected = value ?? void 0;
                else if (node.sourceRowIndex >= 0) isSelected = value ?? void 0;
                else displayed = false;
            }
        } else isSelected = value ?? void 0;
        const { eCheckbox: eCheckbox } = this;
        if (!displayed) {
            eCheckbox.setDisplayed(false);
            return;
        }
        eCheckbox.setValue(isSelected);
        const disabled = params.disabled ?? !column?.isCellEditable(node);
        eCheckbox.setDisabled(disabled);
        const translate = this.getLocaleTextFunc();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = disabled ? stateName : `${translate("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${stateName})`;
        eCheckbox.setInputAriaLabel(ariaLabel);
    }
    onCheckboxChanged(isSelected) {
        const { params: params } = this;
        const { column: column, node: node, value: oldValue } = params;
        const { editSvc: editSvc } = this.beans;
        if (!column) return;
        const position = {
            rowNode: node,
            column: column
        };
        editSvc?.dispatchCellEvent(position, null, "cellEditingStarted", {
            value: oldValue
        });
        const valueChanged = node.setDataValue(column, isSelected, "ui");
        editSvc?.dispatchCellEvent(position, null, "cellEditingStopped", {
            oldValue: oldValue,
            newValue: isSelected,
            valueChanged: valueChanged
        });
        if (!valueChanged) this.updateCheckbox(params);
    }
};
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRowUtils.ts
var $437b23f6a393c3bf$var$PinnedRows = class {
    constructor(beans, floating){
        this.beans = beans;
        this.floating = floating;
        /** Canonical set of pinned nodes */ this.all = /* @__PURE__ */ new Set();
        /**
     * Set of nodes that should currently be visible given the context of the grid.
     * This is currently used for hiding leaf nodes in pivot mode and filtered nodes.
     */ this.visible = /* @__PURE__ */ new Set();
        /** Ordering of nodes in the pinned area */ this.order = [];
        /** IDs of nodes that need to be pinned once they are available from the row model (SSRM) */ this.queued = /* @__PURE__ */ new Set();
    }
    size() {
        return this.visible.size;
    }
    add(node) {
        const { all: all, visible: visible, order: order } = this;
        if (all.has(node)) return;
        all.add(node);
        visible.add(node);
        order.push(node);
        this.sort();
    }
    delete(item) {
        this.all.delete(item);
        this.visible.delete(item);
        this.queued.delete(item.id);
        $437b23f6a393c3bf$export$83a881c8b5120679(this.order, item);
    }
    has(item) {
        return this.visible.has(item);
    }
    forEach(fn) {
        this.order.forEach(fn);
    }
    getByIndex(i) {
        return this.order[i];
    }
    getById(id) {
        for (const node of this.visible){
            if (node.id == id) return node;
        }
    }
    clear() {
        const { all: all, visible: visible, order: order, queued: queued } = this;
        all.clear();
        queued.clear();
        visible.clear();
        order.length = 0;
    }
    sort() {
        const { sortSvc: sortSvc, rowNodeSorter: rowNodeSorter, gos: gos } = this.beans;
        const sortOptions = sortSvc?.getSortOptions() ?? [];
        const order = this.order;
        const grandTotalNode = $437b23f6a393c3bf$var$_removeGrandTotalRow(order);
        order.sort((a, b)=>rowNodeSorter?.compareRowNodes(sortOptions, a, b) || (a.pinnedSibling?.rowIndex ?? 0) - (b.pinnedSibling?.rowIndex ?? 0));
        if (!grandTotalNode) return;
        const grandTotalRow = $437b23f6a393c3bf$export$c6fad27ed643a862(gos);
        if (grandTotalRow === "bottom" || grandTotalRow === "pinnedBottom") this.order.push(grandTotalNode);
        else this.order.unshift(grandTotalNode);
    }
    hide(shouldHide) {
        const { all: all, visible: visible } = this;
        const sizeBefore = visible.size;
        all.forEach((node)=>shouldHide(node) ? visible.delete(node) : visible.add(node));
        this.order = Array.from(visible);
        this.sort();
        return sizeBefore != visible.size;
    }
    queue(id) {
        this.queued.add(id);
    }
    unqueue(id) {
        this.queued.delete(id);
    }
    forEachQueued(fn) {
        this.queued.forEach(fn);
    }
};
function $437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(node) {
    if (node.level === -1) return true;
    const parent = node.parent;
    if (parent?.childrenAfterSort?.some((child)=>child == node)) return $437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(parent);
    return false;
}
function $437b23f6a393c3bf$var$_shouldHidePinnedRows(beans, node) {
    const { gos: gos, rowModel: rowModel, filterManager: filterManager } = beans;
    if ($437b23f6a393c3bf$export$cf1bac0013650216(gos, rowModel)) return !rowModel.getRowNode(node.id);
    if (filterManager?.isAnyFilterPresent()) return !$437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(node);
    if (gos.get("pivotMode")) return !node.group;
    return false;
}
function $437b23f6a393c3bf$var$_isNodeGrandTotal(node) {
    return !!node.footer && node.level === -1;
}
function $437b23f6a393c3bf$var$_isPinnedNodeGrandTotal(node) {
    return !!node.pinnedSibling && $437b23f6a393c3bf$var$_isNodeGrandTotal(node.pinnedSibling);
}
function $437b23f6a393c3bf$var$_removeGrandTotalRow(order) {
    const index = order.findIndex($437b23f6a393c3bf$var$_isPinnedNodeGrandTotal);
    if (index > -1) return order.splice(index, 1)?.[0];
}
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRowModel.ts
var $437b23f6a393c3bf$var$ManualPinnedRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        const { gos: gos, beans: beans } = this;
        this.top = new $437b23f6a393c3bf$var$PinnedRows(beans, "top");
        this.bottom = new $437b23f6a393c3bf$var$PinnedRows(beans, "bottom");
        const shouldHide = (node)=>$437b23f6a393c3bf$var$_shouldHidePinnedRows(beans, node.pinnedSibling);
        const runIsRowPinned = ()=>{
            const isRowPinned = gos.get("isRowPinned");
            if (isRowPinned && gos.get("enableRowPinning")) beans.rowModel.forEachNode((node)=>this.pinRow(node, isRowPinned(node)), true);
            this.refreshRowPositions();
            this.dispatchRowPinnedEvents();
        };
        this.addManagedEventListeners({
            stylesChanged: this.onGridStylesChanges.bind(this),
            modelUpdated: ({ keepRenderedRows: keepRenderedRows })=>{
                this.tryToEmptyQueues();
                this.pinGrandTotalRow();
                let visibilityChanged = false;
                this.forContainers((container)=>{
                    visibilityChanged || (visibilityChanged = container.hide(shouldHide));
                });
                const positionsChanged = this.refreshRowPositions();
                if (!keepRenderedRows || positionsChanged || visibilityChanged) this.dispatchRowPinnedEvents();
            },
            columnRowGroupChanged: ()=>{
                this.forContainers($437b23f6a393c3bf$var$removeGroupRows);
                this.refreshRowPositions();
            },
            rowNodeDataChanged: ({ node: node })=>{
                const isRowPinnable = gos.get("isRowPinnable");
                const pinnable = isRowPinnable?.(node) ?? true;
                if (!pinnable) this.pinRow(node, null);
            },
            firstDataRendered: runIsRowPinned
        });
        this.addManagedPropertyListener("pivotMode", ()=>{
            this.forContainers((container)=>container.hide(shouldHide));
            this.dispatchRowPinnedEvents();
        });
        this.addManagedPropertyListener("grandTotalRow", ({ currentValue: currentValue })=>{
            this._grandTotalPinned = currentValue === "pinnedBottom" ? "bottom" : currentValue === "pinnedTop" ? "top" : null;
        });
        this.addManagedPropertyListener("isRowPinned", runIsRowPinned);
    }
    destroy() {
        this.reset(false);
        super.destroy();
    }
    reset(dispatch = true) {
        this.forContainers((container)=>{
            const nodesToUnpin = [];
            container.forEach((n)=>nodesToUnpin.push(n));
            nodesToUnpin.forEach((n)=>this.pinRow(n, null));
            container.clear();
        });
        if (dispatch) this.dispatchRowPinnedEvents();
    }
    pinRow(rowNode, float, column) {
        if (rowNode.footer && rowNode.level > -1) return;
        if (rowNode.footer && rowNode.level === -1) {
            this._grandTotalPinned = float;
            $437b23f6a393c3bf$var$refreshCSRM(this.beans);
            return;
        }
        const currentFloat = rowNode.rowPinned ?? rowNode.pinnedSibling?.rowPinned;
        const switching = currentFloat != null && float != null && float != currentFloat;
        if (switching) {
            const pinned = rowNode.rowPinned ? rowNode : rowNode.pinnedSibling;
            const source = rowNode.rowPinned ? rowNode.pinnedSibling : rowNode;
            this.pinRow(pinned, null, column);
            this.pinRow(source, float, column);
            return;
        }
        const spannedRows = column && $437b23f6a393c3bf$var$getSpannedRows(this.beans, rowNode, column);
        if (spannedRows) {
            spannedRows.forEach((node)=>this.pinRow(node, float));
            return;
        }
        if (float == null) {
            const node = rowNode.rowPinned ? rowNode : rowNode.pinnedSibling;
            const found = this.findPinnedRowNode(node);
            if (!found) return;
            found.delete(node);
            const source = node.pinnedSibling;
            $437b23f6a393c3bf$var$_destroyRowNodeSibling(node);
            this.refreshRowPositions(float);
            this.dispatchRowPinnedEvents(source);
        } else {
            const sibling = $437b23f6a393c3bf$var$_createPinnedSibling(this.beans, rowNode, float);
            const container = this.getContainer(float);
            container.add(sibling);
            if ($437b23f6a393c3bf$var$_shouldHidePinnedRows(this.beans, rowNode)) container.hide((node)=>$437b23f6a393c3bf$var$_shouldHidePinnedRows(this.beans, node.pinnedSibling));
            this.refreshRowPositions(float);
            this.dispatchRowPinnedEvents(rowNode);
        }
    }
    isManual() {
        return true;
    }
    isEmpty(floating) {
        return this.getContainer(floating).size() === 0;
    }
    isRowsToRender(floating) {
        return !this.isEmpty(floating);
    }
    ensureRowHeightsValid() {
        let anyChange = false;
        let rowTop = 0;
        const updateRowHeight = (rowNode)=>{
            if (rowNode.rowHeightEstimated) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                rowNode.setRowTop(rowTop);
                rowNode.setRowHeight(rowHeight.height);
                rowTop += rowHeight.height;
                anyChange = true;
            }
        };
        this.bottom.forEach(updateRowHeight);
        rowTop = 0;
        this.top.forEach(updateRowHeight);
        this.eventSvc.dispatchEvent({
            type: "pinnedHeightChanged"
        });
        return anyChange;
    }
    getPinnedTopTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight(this.top);
    }
    getPinnedBottomTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight(this.bottom);
    }
    getPinnedTopRowCount() {
        return this.top.size();
    }
    getPinnedBottomRowCount() {
        return this.bottom.size();
    }
    getPinnedTopRow(index) {
        return this.top.getByIndex(index);
    }
    getPinnedBottomRow(index) {
        return this.bottom.getByIndex(index);
    }
    getPinnedRowById(id, floating) {
        return this.getContainer(floating).getById(id);
    }
    forEachPinnedRow(floating, callback) {
        this.getContainer(floating).forEach(callback);
    }
    getPinnedState() {
        const buildState = (floating)=>{
            const list = [];
            this.forEachPinnedRow(floating, (node)=>list.push(node.pinnedSibling.id));
            return list;
        };
        return {
            top: buildState("top"),
            bottom: buildState("bottom")
        };
    }
    setPinnedState(state) {
        this.forContainers((pinned, floating)=>{
            for (const id of state[floating]){
                const node = this.beans.rowModel.getRowNode(id);
                if (node) this.pinRow(node, floating);
                else pinned.queue(id);
            }
        });
    }
    getGrandTotalPinned() {
        return this._grandTotalPinned;
    }
    setGrandTotalPinned(value) {
        this._grandTotalPinned = value;
    }
    tryToEmptyQueues() {
        this.forContainers((pinned, container)=>{
            const nodesToPin = /* @__PURE__ */ new Set();
            pinned.forEachQueued((id)=>{
                const node = this.beans.rowModel.getRowNode(id);
                if (node) nodesToPin.add(node);
            });
            for (const node of nodesToPin){
                pinned.unqueue(node.id);
                this.pinRow(node, container);
            }
        });
    }
    pinGrandTotalRow() {
        const { gos: gos, beans: beans, _grandTotalPinned: float } = this;
        const rowModel = beans.rowModel;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) return;
        const sibling = rowModel.rootNode?.sibling;
        if (!sibling) return;
        const pinnedSibling = sibling.pinnedSibling;
        const container = pinnedSibling && this.findPinnedRowNode(pinnedSibling);
        if (!float) {
            if (!container) return;
            container.delete(pinnedSibling);
            $437b23f6a393c3bf$var$_destroyRowNodeSibling(pinnedSibling);
        } else {
            if (container && container.floating !== float) {
                container.delete(pinnedSibling);
                $437b23f6a393c3bf$var$_destroyRowNodeSibling(pinnedSibling);
            }
            if (!container || container.floating !== float) {
                const newPinnedSibling = $437b23f6a393c3bf$var$_createPinnedSibling(beans, sibling, float);
                this.getContainer(float).add(newPinnedSibling);
            }
        }
    }
    onGridStylesChanges(e) {
        if (e.rowHeightChanged) this.forContainers((container)=>container.forEach((rowNode)=>rowNode.setRowHeight(rowNode.rowHeight, true)));
    }
    getContainer(floating) {
        return floating === "top" ? this.top : this.bottom;
    }
    findPinnedRowNode(node) {
        if (this.top.has(node)) return this.top;
        if (this.bottom.has(node)) return this.bottom;
    }
    refreshRowPositions(floating) {
        const refreshAll = (pinned)=>$437b23f6a393c3bf$var$refreshRowPositions(this.beans, pinned);
        if (floating) return refreshAll(this.getContainer(floating));
        let changed = false;
        this.forContainers((container)=>{
            const updated = refreshAll(container);
            changed || (changed = updated);
        });
        return changed;
    }
    forContainers(fn) {
        fn(this.top, "top");
        fn(this.bottom, "bottom");
    }
    dispatchRowPinnedEvents(node) {
        this.eventSvc.dispatchEvent({
            type: "pinnedRowsChanged"
        });
        node?.dispatchRowEvent("rowPinned");
    }
};
function $437b23f6a393c3bf$var$refreshRowPositions(beans, container) {
    let rowTop = 0;
    let changed = false;
    container.forEach((node, index)=>{
        changed || (changed = node.rowTop !== rowTop);
        node.setRowTop(rowTop);
        if (node.rowHeightEstimated || node.rowHeight == null) {
            const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, node).height;
            changed || (changed = node.rowHeight !== rowHeight);
            node.setRowHeight(rowHeight);
        }
        node.setRowIndex(index);
        rowTop += node.rowHeight;
    });
    return changed;
}
function $437b23f6a393c3bf$var$_createPinnedSibling(beans, rowNode, floating) {
    if (rowNode.pinnedSibling) return rowNode.pinnedSibling;
    const sibling = $437b23f6a393c3bf$export$48fabbbfcde9fe36(rowNode, beans);
    sibling.setRowTop(null);
    sibling.setRowIndex(null);
    sibling.rowPinned = floating;
    const prefix = floating === "top" ? $437b23f6a393c3bf$export$27b0e4a919abc336 : $437b23f6a393c3bf$export$5f755686e611c1ea;
    sibling.id = `${prefix}${floating}-${rowNode.id}`;
    sibling.pinnedSibling = rowNode;
    rowNode.pinnedSibling = sibling;
    return sibling;
}
function $437b23f6a393c3bf$var$_destroyRowNodeSibling(rowNode) {
    if (!rowNode.pinnedSibling) return;
    rowNode.rowPinned = null;
    rowNode._destroy(false);
    const mainNode = rowNode.pinnedSibling;
    rowNode.pinnedSibling = void 0;
    if (mainNode) {
        mainNode.pinnedSibling = void 0;
        mainNode.rowPinned = null;
    }
}
function $437b23f6a393c3bf$var$removeGroupRows(set) {
    const rowsToRemove = /* @__PURE__ */ new Set();
    set.forEach((node)=>{
        if (node.group) rowsToRemove.add(node);
    });
    rowsToRemove.forEach((node)=>set.delete(node));
}
function $437b23f6a393c3bf$var$getSpannedRows(beans, rowNode, column) {
    const { rowSpanSvc: rowSpanSvc } = beans;
    const isCellSpanning = (column && rowSpanSvc?.isCellSpanning(column, rowNode)) ?? false;
    if (column && isCellSpanning) return rowSpanSvc?.getCellSpan(column, rowNode)?.spannedNodes;
}
function $437b23f6a393c3bf$var$getTotalHeight(container) {
    const size = container.size();
    if (size === 0) return 0;
    const node = container.getByIndex(size - 1);
    if (node === void 0) return 0;
    return node.rowTop + node.rowHeight;
}
function $437b23f6a393c3bf$var$refreshCSRM({ gos: gos, rowModel: rowModel }) {
    if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) rowModel.refreshModel({
        step: "map"
    });
}
// packages/ag-grid-community/src/pinnedRowModel/staticPinnedRowModel.ts
var $437b23f6a393c3bf$var$StaticPinnedRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.nextId = 0;
        this.pinnedTopRows = {
            cache: {},
            order: []
        };
        this.pinnedBottomRows = {
            cache: {},
            order: []
        };
    }
    postConstruct() {
        const gos = this.gos;
        this.setPinnedRowData(gos.get("pinnedTopRowData"), "top");
        this.setPinnedRowData(gos.get("pinnedBottomRowData"), "bottom");
        this.addManagedPropertyListener("pinnedTopRowData", (e)=>this.setPinnedRowData(e.currentValue, "top"));
        this.addManagedPropertyListener("pinnedBottomRowData", (e)=>this.setPinnedRowData(e.currentValue, "bottom"));
        this.addManagedEventListeners({
            stylesChanged: this.onGridStylesChanges.bind(this)
        });
    }
    reset() {}
    isEmpty(floating) {
        return this.getCache(floating).order.length === 0;
    }
    isRowsToRender(floating) {
        return !this.isEmpty(floating);
    }
    isManual() {
        return false;
    }
    pinRow(_node, _container) {}
    onGridStylesChanges(e) {
        if (e.rowHeightChanged) {
            const estimateRowHeight = (rowNode)=>{
                rowNode.setRowHeight(rowNode.rowHeight, true);
            };
            $437b23f6a393c3bf$var$forEach(this.pinnedBottomRows, estimateRowHeight);
            $437b23f6a393c3bf$var$forEach(this.pinnedTopRows, estimateRowHeight);
        }
    }
    ensureRowHeightsValid() {
        let anyChange = false;
        let rowTop = 0;
        const updateRowHeight = (rowNode)=>{
            if (rowNode.rowHeightEstimated) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                rowNode.setRowTop(rowTop);
                rowNode.setRowHeight(rowHeight.height);
                rowTop += rowHeight.height;
                anyChange = true;
            }
        };
        $437b23f6a393c3bf$var$forEach(this.pinnedBottomRows, updateRowHeight);
        rowTop = 0;
        $437b23f6a393c3bf$var$forEach(this.pinnedTopRows, updateRowHeight);
        this.eventSvc.dispatchEvent({
            type: "pinnedHeightChanged"
        });
        return anyChange;
    }
    setPinnedRowData(rowData, floating) {
        this.updateNodesFromRowData(rowData, floating);
        this.eventSvc.dispatchEvent({
            type: "pinnedRowDataChanged"
        });
    }
    /**
   * Updates existing RowNode instances and creates new ones if necessary
   *
   * Setting data as `undefined` will clear row nodes
   */ updateNodesFromRowData(allData, floating) {
        const nodes = this.getCache(floating);
        if (allData === void 0) {
            nodes.order.length = 0;
            nodes.cache = {};
            return;
        }
        const getRowId = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const idPrefix = floating === "top" ? $437b23f6a393c3bf$export$27b0e4a919abc336 : $437b23f6a393c3bf$export$5f755686e611c1ea;
        const nodesToRemove = new Set(nodes.order);
        const newOrder = [];
        const dataIds = /* @__PURE__ */ new Set();
        let nextRowTop = 0;
        let i = -1;
        for (const data of allData){
            const id = getRowId?.({
                data: data,
                level: 0,
                rowPinned: floating
            }) ?? idPrefix + this.nextId++;
            if (dataIds.has(id)) {
                $437b23f6a393c3bf$export$545083624300f13d(96, {
                    id: id,
                    data: data
                });
                continue;
            }
            i++;
            dataIds.add(id);
            newOrder.push(id);
            const existingNode = $437b23f6a393c3bf$var$getById(nodes, id);
            if (existingNode !== void 0) {
                if (existingNode.data !== data) existingNode.updateData(data);
                nextRowTop += this.setRowTopAndRowIndex(existingNode, nextRowTop, i);
                nodesToRemove.delete(id);
            } else {
                const rowNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
                rowNode.id = id;
                rowNode.data = data;
                rowNode.rowPinned = floating;
                nextRowTop += this.setRowTopAndRowIndex(rowNode, nextRowTop, i);
                nodes.cache[id] = rowNode;
                nodes.order.push(id);
            }
        }
        for (const id of nodesToRemove){
            $437b23f6a393c3bf$var$getById(nodes, id)?.clearRowTopAndRowIndex();
            delete nodes.cache[id];
        }
        nodes.order = newOrder;
    }
    setRowTopAndRowIndex(rowNode, rowTop, rowIndex) {
        rowNode.setRowTop(rowTop);
        rowNode.setRowHeight($437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode).height);
        rowNode.setRowIndex(rowIndex);
        return rowNode.rowHeight;
    }
    getPinnedTopTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight2(this.pinnedTopRows);
    }
    getPinnedBottomTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight2(this.pinnedBottomRows);
    }
    getPinnedTopRowCount() {
        return $437b23f6a393c3bf$var$getSize(this.pinnedTopRows);
    }
    getPinnedBottomRowCount() {
        return $437b23f6a393c3bf$var$getSize(this.pinnedBottomRows);
    }
    getPinnedTopRow(index) {
        return $437b23f6a393c3bf$var$getByIndex(this.pinnedTopRows, index);
    }
    getPinnedBottomRow(index) {
        return $437b23f6a393c3bf$var$getByIndex(this.pinnedBottomRows, index);
    }
    getPinnedRowById(id, floating) {
        return $437b23f6a393c3bf$var$getById(this.getCache(floating), id);
    }
    forEachPinnedRow(floating, callback) {
        return $437b23f6a393c3bf$var$forEach(this.getCache(floating), callback);
    }
    getCache(floating) {
        return floating === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
    }
    getPinnedState() {
        return {
            top: [],
            bottom: []
        };
    }
    setPinnedState() {}
    getGrandTotalPinned() {
        return;
    }
    setGrandTotalPinned() {}
};
function $437b23f6a393c3bf$var$getTotalHeight2(rowNodes) {
    const size = $437b23f6a393c3bf$var$getSize(rowNodes);
    if (size === 0) return 0;
    const node = $437b23f6a393c3bf$var$getByIndex(rowNodes, size - 1);
    if (node === void 0) return 0;
    return node.rowTop + node.rowHeight;
}
function $437b23f6a393c3bf$var$getById(cache, id) {
    return cache.cache[id];
}
function $437b23f6a393c3bf$var$getByIndex(cache, i) {
    return $437b23f6a393c3bf$var$getById(cache, cache.order[i]);
}
function $437b23f6a393c3bf$var$forEach(cache, callback) {
    cache.order.forEach((id, index)=>{
        const node = $437b23f6a393c3bf$var$getById(cache, id);
        node && callback(node, index);
    });
}
function $437b23f6a393c3bf$var$getSize(cache) {
    return cache.order.length;
}
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowModel.ts
var $437b23f6a393c3bf$export$d44126a5f53c99d9 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pinnedRowModel";
    }
    postConstruct() {
        const { gos: gos } = this;
        const initialiseRowModel = ()=>{
            const enableRowPinning = gos.get("enableRowPinning");
            const grandTotalRow = $437b23f6a393c3bf$export$c6fad27ed643a862(gos);
            const isGrandTotalRowPinned = grandTotalRow === "pinnedBottom" || grandTotalRow === "pinnedTop";
            const useManualPinnedRowModel = !!enableRowPinning || isGrandTotalRowPinned;
            const shouldDestroy = useManualPinnedRowModel ? this.inner instanceof $437b23f6a393c3bf$var$StaticPinnedRowModel : this.inner instanceof $437b23f6a393c3bf$var$ManualPinnedRowModel;
            if (this.inner && shouldDestroy) this.destroyBean(this.inner);
            if (shouldDestroy || !this.inner) this.inner = this.createManagedBean(useManualPinnedRowModel ? new $437b23f6a393c3bf$var$ManualPinnedRowModel() : new $437b23f6a393c3bf$var$StaticPinnedRowModel());
        };
        this.addManagedPropertyListeners([
            "enableRowPinning",
            "grandTotalRow"
        ], initialiseRowModel);
        initialiseRowModel();
    }
    reset() {
        return this.inner.reset();
    }
    isEmpty(container) {
        return this.inner.isEmpty(container);
    }
    isManual() {
        return this.inner.isManual();
    }
    isRowsToRender(container) {
        return this.inner.isRowsToRender(container);
    }
    pinRow(node, container, column) {
        return this.inner.pinRow(node, container, column);
    }
    ensureRowHeightsValid() {
        return this.inner.ensureRowHeightsValid();
    }
    getPinnedRowById(id, container) {
        return this.inner.getPinnedRowById(id, container);
    }
    getPinnedTopTotalHeight() {
        return this.inner.getPinnedTopTotalHeight();
    }
    getPinnedBottomTotalHeight() {
        return this.inner.getPinnedBottomTotalHeight();
    }
    getPinnedTopRowCount() {
        return this.inner.getPinnedTopRowCount();
    }
    getPinnedBottomRowCount() {
        return this.inner.getPinnedBottomRowCount();
    }
    getPinnedTopRow(index) {
        return this.inner.getPinnedTopRow(index);
    }
    getPinnedBottomRow(index) {
        return this.inner.getPinnedBottomRow(index);
    }
    forEachPinnedRow(container, callback) {
        return this.inner.forEachPinnedRow(container, callback);
    }
    getPinnedState() {
        return this.inner.getPinnedState();
    }
    setPinnedState(state) {
        return this.inner.setPinnedState(state);
    }
    setGrandTotalPinned(value) {
        return this.inner.setGrandTotalPinned(value);
    }
    getGrandTotalPinned() {
        return this.inner.getGrandTotalPinned();
    }
};
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModelUtils.ts
var $437b23f6a393c3bf$export$600fb6a3864e66ca = (node)=>{
    let childrenAfterGroup = node.childrenAfterGroup;
    while(childrenAfterGroup?.length){
        const child = childrenAfterGroup[0];
        if (child.sourceRowIndex >= 0) return child;
        childrenAfterGroup = child.childrenAfterGroup;
    }
};
var $437b23f6a393c3bf$export$bdac36eff8582fbb = (allLeafs, leafsToMove, target, above)=>{
    if (!leafsToMove.size || !allLeafs) return false;
    let orderChanged = false;
    const allLeafsLen = allLeafs.length ?? 0;
    let targetPositionIdx = -1;
    if (target) {
        targetPositionIdx = target.sourceRowIndex;
        target = targetPositionIdx < 0 ? $437b23f6a393c3bf$export$600fb6a3864e66ca(target) : null;
        if (target) targetPositionIdx = target.sourceRowIndex;
    }
    if (targetPositionIdx < 0 || targetPositionIdx >= allLeafsLen) targetPositionIdx = allLeafsLen;
    else if (!above) ++targetPositionIdx;
    let firstAffectedLeafIdx = targetPositionIdx;
    let lastAffectedLeafIndex = Math.min(targetPositionIdx, allLeafsLen - 1);
    for (const row of leafsToMove){
        const sourceRowIndex = row.sourceRowIndex;
        if (sourceRowIndex < firstAffectedLeafIdx) firstAffectedLeafIdx = sourceRowIndex;
        if (sourceRowIndex > lastAffectedLeafIndex) lastAffectedLeafIndex = sourceRowIndex;
    }
    let writeIdxLeft = firstAffectedLeafIdx;
    for(let readIdx = firstAffectedLeafIdx; readIdx < targetPositionIdx; ++readIdx){
        const row = allLeafs[readIdx];
        if (leafsToMove.has(row)) continue;
        if (row.sourceRowIndex !== writeIdxLeft) {
            row.sourceRowIndex = writeIdxLeft;
            allLeafs[writeIdxLeft] = row;
            orderChanged = true;
        }
        ++writeIdxLeft;
    }
    let writeIdxRight = lastAffectedLeafIndex;
    for(let readIdx = lastAffectedLeafIndex; readIdx >= targetPositionIdx; --readIdx){
        const row = allLeafs[readIdx];
        if (leafsToMove.has(row)) continue;
        if (row.sourceRowIndex !== writeIdxRight) {
            row.sourceRowIndex = writeIdxRight;
            allLeafs[writeIdxRight] = row;
            orderChanged = true;
        }
        --writeIdxRight;
    }
    for (const row of leafsToMove){
        if (row.sourceRowIndex !== writeIdxLeft) {
            row.sourceRowIndex = writeIdxLeft;
            allLeafs[writeIdxLeft] = row;
            orderChanged = true;
        }
        ++writeIdxLeft;
    }
    return orderChanged;
};
// packages/ag-grid-community/src/clientSideRowModel/changedRowNodes.ts
var $437b23f6a393c3bf$export$31d871bfcf904e4b = class {
    constructor(){
        this.reordered = false;
        this.removals = [];
        this.updates = /* @__PURE__ */ new Set();
        this.adds = /* @__PURE__ */ new Set();
    }
};
// packages/ag-grid-community/src/interfaces/serverSideTransaction.ts
var $437b23f6a393c3bf$export$58e95be8934cbc38 = /* @__PURE__ */ ((ServerSideTransactionResultStatus2)=>{
    ServerSideTransactionResultStatus2["Applied"] = "Applied";
    ServerSideTransactionResultStatus2["StoreNotFound"] = "StoreNotFound";
    ServerSideTransactionResultStatus2["StoreLoading"] = "StoreLoading";
    ServerSideTransactionResultStatus2["StoreWaitingToLoad"] = "StoreWaitingToLoad";
    ServerSideTransactionResultStatus2["StoreLoadingFailed"] = "StoreLoadingFailed";
    ServerSideTransactionResultStatus2["StoreWrongType"] = "StoreWrongType";
    ServerSideTransactionResultStatus2["Cancelled"] = "Cancelled";
    ServerSideTransactionResultStatus2["StoreNotStarted"] = "StoreNotStarted";
    return ServerSideTransactionResultStatus2;
})($437b23f6a393c3bf$export$58e95be8934cbc38 || {});
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowUtils.ts
function $437b23f6a393c3bf$var$_isManualPinnedRow(rowNode) {
    return !!(rowNode.rowPinned && rowNode.pinnedSibling);
}
function $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, start, end) {
    const isTop = float === "top";
    if (!start) return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, isTop ? rowModel.getPinnedTopRow(0) : rowModel.getPinnedBottomRow(0), end);
    if (!end) {
        const count = isTop ? rowModel.getPinnedTopRowCount() : rowModel.getPinnedBottomRowCount();
        return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, start, isTop ? rowModel.getPinnedTopRow(count - 1) : rowModel.getPinnedBottomRow(count - 1));
    }
    let started = false;
    let finished = false;
    const range = [];
    rowModel.forEachPinnedRow(float, (node)=>{
        if (node === start && !started) {
            started = true;
            range.push(node);
            return;
        }
        if (started && node === end) {
            finished = true;
            range.push(node);
            return;
        }
        if (started && !finished) range.push(node);
    });
    return range;
}
// packages/ag-grid-community/src/selection/checkboxSelectionComponent.ts
var $437b23f6a393c3bf$var$CheckboxSelectionComponentElement = {
    tag: "div",
    cls: "ag-selection-checkbox",
    role: "presentation",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxSelectionComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxSelectionComponentElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eCheckbox = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        this.eCheckbox.setPassive(true);
    }
    onDataChanged() {
        this.onSelectionChanged();
    }
    onSelectableChanged() {
        this.showOrHideSelect();
    }
    onSelectionChanged() {
        const translate = this.getLocaleTextFunc();
        const { rowNode: rowNode, eCheckbox: eCheckbox } = this;
        const state = rowNode.isSelected();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, state);
        const [ariaKey, ariaLabel] = rowNode.selectable ? [
            "ariaRowToggleSelection",
            "Press Space to toggle row selection"
        ] : [
            "ariaRowSelectionDisabled",
            "Row Selection is disabled for this row"
        ];
        const translatedLabel = translate(ariaKey, ariaLabel);
        eCheckbox.setValue(state, true);
        eCheckbox.setInputAriaLabel(`${translatedLabel} (${stateName})`);
    }
    init(params) {
        this.rowNode = params.rowNode;
        this.column = params.column;
        this.overrides = params.overrides;
        this.onSelectionChanged();
        this.addManagedListeners(this.eCheckbox.getWrapperElement(), {
            // we don't want double click on this icon to open a group
            dblclick: $437b23f6a393c3bf$export$456c40e80134d72a,
            click: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
                if (this.eCheckbox.isDisabled()) return;
                this.beans.selectionSvc?.handleSelectionEvent(event, this.rowNode, "checkboxSelected");
            }
        });
        this.addManagedListeners(this.rowNode, {
            rowSelected: this.onSelectionChanged.bind(this),
            dataChanged: this.onDataChanged.bind(this),
            selectableChanged: this.onSelectableChanged.bind(this)
        });
        this.addManagedPropertyListener("rowSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            const curr = typeof currentValue === "object" ? $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(currentValue) : void 0;
            const prev = typeof previousValue === "object" ? $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(previousValue) : void 0;
            if (curr !== prev) this.onSelectableChanged();
        });
        const isRowSelectableFunc = $437b23f6a393c3bf$export$351959be716b3b33(this.gos);
        const checkboxVisibleIsDynamic = isRowSelectableFunc || typeof this.getIsVisible() === "function";
        if (checkboxVisibleIsDynamic) {
            const showOrHideSelectListener = this.showOrHideSelect.bind(this);
            this.addManagedEventListeners({
                displayedColumnsChanged: showOrHideSelectListener
            });
            this.addManagedListeners(this.rowNode, {
                dataChanged: showOrHideSelectListener,
                cellChanged: showOrHideSelectListener
            });
            this.showOrHideSelect();
        }
        this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
    }
    showOrHideSelect() {
        const { column: column, rowNode: rowNode, overrides: overrides, gos: gos } = this;
        const selectable = rowNode.selectable;
        const isVisible = this.getIsVisible();
        let checkboxes = void 0;
        if (typeof isVisible === "function") {
            const extraParams = overrides?.callbackParams;
            if (!column) checkboxes = isVisible({
                ...extraParams,
                node: rowNode,
                data: rowNode.data
            });
            else {
                const params = column.createColumnFunctionCallbackParams(rowNode);
                checkboxes = isVisible({
                    ...extraParams,
                    ...params
                });
            }
        } else checkboxes = isVisible ?? false;
        const disabled = selectable && !checkboxes || !selectable && checkboxes;
        const visible = selectable || checkboxes;
        const so = gos.get("rowSelection");
        const showDisabledCheckboxes = so && typeof so !== "string" ? !$437b23f6a393c3bf$var$_getHideDisabledCheckboxes(so) : !!column?.getColDef().showDisabledCheckboxes;
        this.setVisible(visible && (disabled ? showDisabledCheckboxes : true));
        this.setDisplayed(visible && (disabled ? showDisabledCheckboxes : true));
        if (visible) this.eCheckbox.setDisabled(disabled);
        if (overrides?.removeHidden) this.setDisplayed(visible);
    }
    getIsVisible() {
        const overrides = this.overrides;
        if (overrides) return overrides.isVisible;
        const so = this.gos.get("rowSelection");
        if (so && typeof so !== "string") return $437b23f6a393c3bf$export$6df3a55606bca6ae(so);
        return this.column?.getColDef()?.checkboxSelection;
    }
};
// packages/ag-grid-community/src/selection/rowRangeSelectionContext.ts
var $437b23f6a393c3bf$var$RowRangeSelectionContext = class {
    constructor(rowModel, pinnedRowModel){
        this.rowModel = rowModel;
        this.pinnedRowModel = pinnedRowModel;
        /** Whether the user is currently selecting all nodes either via the header checkbox or API */ this.selectAll = false;
        this.rootId = null;
        /**
     * Note that the "end" `RowNode` may come before or after the "root" `RowNode` in the
     * actual grid.
     */ this.endId = null;
        this.cachedRange = [];
    }
    reset() {
        this.rootId = null;
        this.endId = null;
        this.cachedRange.length = 0;
    }
    setRoot(node) {
        this.rootId = node.id;
        this.endId = null;
        this.cachedRange.length = 0;
    }
    setEndRange(end) {
        this.endId = end.id;
        this.cachedRange.length = 0;
    }
    getRange() {
        if (this.cachedRange.length === 0) {
            const root = this.getRoot();
            const end = this.getEnd();
            if (root == null || end == null) return this.cachedRange;
            this.cachedRange = this.getNodesInRange(root, end) ?? [];
        }
        return this.cachedRange;
    }
    isInRange(node) {
        if (this.rootId === null) return false;
        return this.getRange().some((nodeInRange)=>nodeInRange.id === node.id);
    }
    getRoot(fallback) {
        if (this.rootId) return this.getRowNode(this.rootId);
        if (fallback) {
            this.setRoot(fallback);
            return fallback;
        }
    }
    getEnd() {
        if (this.endId) return this.getRowNode(this.endId);
    }
    getRowNode(id) {
        let node;
        const { rowModel: rowModel, pinnedRowModel: pinnedRowModel } = this;
        node ?? (node = rowModel.getRowNode(id));
        if (pinnedRowModel?.isManual()) {
            node ?? (node = pinnedRowModel.getPinnedRowById(id, "top"));
            node ?? (node = pinnedRowModel.getPinnedRowById(id, "bottom"));
        }
        return node;
    }
    /**
   * Truncates the range to the given node (assumed to be within the current range).
   * Returns nodes that remain in the current range and those that should be removed
   *
   * @param node - Node at which to truncate the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */ truncate(node) {
        const range = this.getRange();
        if (range.length === 0) return {
            keep: [],
            discard: []
        };
        const discardAfter = range[0].id === this.rootId;
        const idx = range.findIndex((rowNode)=>rowNode.id === node.id);
        if (idx > -1) {
            const above = range.slice(0, idx);
            const below = range.slice(idx + 1);
            this.setEndRange(node);
            return discardAfter ? {
                keep: above,
                discard: below
            } : {
                keep: below,
                discard: above
            };
        } else return {
            keep: range,
            discard: []
        };
    }
    /**
   * Extends the range to the given node. Returns nodes that remain in the current range
   * and those that should be removed.
   *
   * @param node - Node marking the new end of the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */ extend(node, groupSelectsChildren = false) {
        const root = this.getRoot();
        if (root == null) {
            const keep = this.getRange().slice();
            if (groupSelectsChildren) node.depthFirstSearch((node2)=>!node2.group && keep.push(node2));
            keep.push(node);
            this.setRoot(node);
            return {
                keep: keep,
                discard: []
            };
        }
        const newRange = this.getNodesInRange(root, node);
        if (!newRange) {
            this.setRoot(node);
            return {
                keep: [
                    node
                ],
                discard: []
            };
        }
        if (newRange.find((newRangeNode)=>newRangeNode.id === this.endId)) {
            this.setEndRange(node);
            return {
                keep: this.getRange(),
                discard: []
            };
        } else {
            const discard = this.getRange().slice();
            this.setEndRange(node);
            return {
                keep: this.getRange(),
                discard: discard
            };
        }
    }
    getNodesInRange(start, end) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this;
        if (!pinnedRowModel?.isManual()) return rowModel.getNodesInRangeForSelection(start, end);
        if (start.rowPinned === "top" && !end.rowPinned) {
            const pinnedRange = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, void 0);
            return pinnedRange.concat(rowModel.getNodesInRangeForSelection(rowModel.getRow(0), end) ?? []);
        }
        if (start.rowPinned === "bottom" && !end.rowPinned) {
            const pinnedRange = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, start);
            const count = rowModel.getRowCount();
            const lastMain = rowModel.getRow(count - 1);
            return (rowModel.getNodesInRangeForSelection(end, lastMain) ?? []).concat(pinnedRange);
        }
        if (!start.rowPinned && !end.rowPinned) return rowModel.getNodesInRangeForSelection(start, end);
        if (start.rowPinned === "top" && end.rowPinned === "top") return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, end);
        if (start.rowPinned === "bottom" && end.rowPinned === "top") {
            const top = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", end, void 0);
            const bottom = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, start);
            const first = rowModel.getRow(0);
            const last = rowModel.getRow(rowModel.getRowCount() - 1);
            return top.concat(rowModel.getNodesInRangeForSelection(first, last) ?? []).concat(bottom);
        }
        if (!start.rowPinned && end.rowPinned === "top") {
            const pinned = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", end, void 0);
            return pinned.concat(rowModel.getNodesInRangeForSelection(rowModel.getRow(0), start) ?? []);
        }
        if (start.rowPinned === "top" && end.rowPinned === "bottom") {
            const top = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, void 0);
            const bottom = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, end);
            const first = rowModel.getRow(0);
            const last = rowModel.getRow(rowModel.getRowCount() - 1);
            return top.concat(rowModel.getNodesInRangeForSelection(first, last) ?? []).concat(bottom);
        }
        if (start.rowPinned === "bottom" && end.rowPinned === "bottom") return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", start, end);
        if (!start.rowPinned && end.rowPinned === "bottom") {
            const pinned = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, end);
            const last = rowModel.getRow(rowModel.getRowCount());
            return (rowModel.getNodesInRangeForSelection(start, last) ?? []).concat(pinned);
        }
        return null;
    }
};
// packages/ag-grid-community/src/selection/selectAllFeature.ts
var $437b23f6a393c3bf$var$SelectAllFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column){
        super();
        this.column = column;
        this.cbSelectAllVisible = false;
        this.processingEventFromCheckbox = false;
    }
    onSpaceKeyDown(e) {
        const checkbox = this.cbSelectAll;
        if (checkbox.isDisplayed() && !checkbox.getGui().contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) {
            e.preventDefault();
            checkbox.setValue(!checkbox.getValue());
        }
    }
    getCheckboxGui() {
        return this.cbSelectAll.getGui();
    }
    setComp(ctrl) {
        this.headerCellCtrl = ctrl;
        const cbSelectAll = this.createManagedBean(new $437b23f6a393c3bf$export$b00c508c1ae18d07());
        this.cbSelectAll = cbSelectAll;
        cbSelectAll.addCss("ag-header-select-all");
        $437b23f6a393c3bf$export$f8d01fa01787902(cbSelectAll.getGui(), "presentation");
        this.showOrHideSelectAll();
        const updateStateOfCheckbox = this.updateStateOfCheckbox.bind(this);
        this.addManagedEventListeners({
            newColumnsLoaded: ()=>this.showOrHideSelectAll(),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            selectionChanged: updateStateOfCheckbox,
            paginationChanged: updateStateOfCheckbox,
            modelUpdated: updateStateOfCheckbox
        });
        this.addManagedPropertyListener("rowSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            const getSelectAll = (rowSelection)=>typeof rowSelection === "string" || !rowSelection || rowSelection.mode === "singleRow" ? void 0 : rowSelection.selectAll;
            if (getSelectAll(currentValue) !== getSelectAll(previousValue)) this.showOrHideSelectAll();
            this.updateStateOfCheckbox();
        });
        this.addManagedListeners(cbSelectAll, {
            fieldValueChanged: this.onCbSelectAll.bind(this)
        });
        cbSelectAll.getInputElement().setAttribute("tabindex", "-1");
        this.refreshSelectAllLabel();
    }
    onDisplayedColumnsChanged(e) {
        if (!this.isAlive()) return;
        this.showOrHideSelectAll(e.source === "uiColumnMoved");
    }
    showOrHideSelectAll(fromColumnMoved = false) {
        const cbSelectAllVisible = this.isCheckboxSelection();
        this.cbSelectAllVisible = cbSelectAllVisible;
        this.cbSelectAll.setDisplayed(cbSelectAllVisible);
        if (cbSelectAllVisible) {
            this.checkRightRowModelType("selectAllCheckbox");
            this.checkSelectionType("selectAllCheckbox");
            this.updateStateOfCheckbox();
        }
        this.refreshSelectAllLabel(fromColumnMoved);
    }
    updateStateOfCheckbox() {
        if (!this.cbSelectAllVisible || this.processingEventFromCheckbox) return;
        this.processingEventFromCheckbox = true;
        const selectAllMode = this.getSelectAllMode();
        const selectionSvc = this.beans.selectionSvc;
        const cbSelectAll = this.cbSelectAll;
        const allSelected = selectionSvc.getSelectAllState(selectAllMode);
        cbSelectAll.setValue(allSelected);
        const hasNodesToSelect = selectionSvc.hasNodesToSelect(selectAllMode);
        cbSelectAll.setDisabled(!hasNodesToSelect);
        this.refreshSelectAllLabel();
        this.processingEventFromCheckbox = false;
    }
    refreshSelectAllLabel(fromColumnMoved = false) {
        const translate = this.getLocaleTextFunc();
        const { headerCellCtrl: headerCellCtrl, cbSelectAll: cbSelectAll, cbSelectAllVisible: cbSelectAllVisible } = this;
        const checked = cbSelectAll.getValue();
        const ariaStatus = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, checked);
        const ariaLabel = translate("ariaRowSelectAll", "Press Space to toggle all rows selection");
        headerCellCtrl.setAriaDescriptionProperty("selectAll", cbSelectAllVisible ? `${ariaLabel} (${ariaStatus})` : null);
        cbSelectAll.setInputAriaLabel(translate("ariaHeaderSelection", "Column with Header Selection"));
        if (!fromColumnMoved) headerCellCtrl.announceAriaDescription();
    }
    checkSelectionType(feature) {
        const isMultiSelect = $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos);
        if (!isMultiSelect) {
            $437b23f6a393c3bf$export$545083624300f13d(128, {
                feature: feature
            });
            return false;
        }
        return true;
    }
    checkRightRowModelType(feature) {
        const { gos: gos, rowModel: rowModel } = this.beans;
        const rowModelMatches = $437b23f6a393c3bf$export$9f182d9ca737e15(gos) || $437b23f6a393c3bf$export$cf1bac0013650216(gos);
        if (!rowModelMatches) {
            $437b23f6a393c3bf$export$545083624300f13d(129, {
                feature: feature,
                rowModel: rowModel.getType()
            });
            return false;
        }
        return true;
    }
    onCbSelectAll() {
        if (this.processingEventFromCheckbox) return;
        if (!this.cbSelectAllVisible) return;
        const value = this.cbSelectAll.getValue();
        const selectAll2 = this.getSelectAllMode();
        let source = "uiSelectAll";
        if (selectAll2 === "currentPage") source = "uiSelectAllCurrentPage";
        else if (selectAll2 === "filtered") source = "uiSelectAllFiltered";
        const params = {
            source: source,
            selectAll: selectAll2
        };
        const selectionSvc = this.beans.selectionSvc;
        if (value) selectionSvc.selectAllRowNodes(params);
        else selectionSvc.deselectAllRowNodes(params);
    }
    /**
   * Checkbox is enabled when either the `headerCheckbox` option is enabled in the new selection API
   * or `headerCheckboxSelection` is enabled in the legacy API.
   */ isCheckboxSelection() {
        const { column: column, gos: gos, beans: beans } = this;
        const rowSelection = gos.get("rowSelection");
        const newHeaderCheckbox = typeof rowSelection === "object";
        const featureName = newHeaderCheckbox ? "headerCheckbox" : "headerCheckboxSelection";
        return $437b23f6a393c3bf$var$isCheckboxSelection(beans, column) && this.checkRightRowModelType(featureName) && this.checkSelectionType(featureName);
    }
    getSelectAllMode() {
        const selectAll2 = $437b23f6a393c3bf$var$_getSelectAll(this.gos, false);
        if (selectAll2) return selectAll2;
        const { headerCheckboxSelectionCurrentPageOnly: headerCheckboxSelectionCurrentPageOnly, headerCheckboxSelectionFilteredOnly: headerCheckboxSelectionFilteredOnly } = this.column.getColDef();
        if (headerCheckboxSelectionCurrentPageOnly) return "currentPage";
        if (headerCheckboxSelectionFilteredOnly) return "filtered";
        return "all";
    }
    destroy() {
        super.destroy();
        this.cbSelectAll = void 0;
        this.headerCellCtrl = void 0;
    }
};
function $437b23f6a393c3bf$var$isCheckboxSelection({ gos: gos, selectionColSvc: selectionColSvc }, column) {
    const rowSelection = gos.get("rowSelection");
    const colDef = column.getColDef();
    const { headerCheckboxSelection: headerCheckboxSelection } = colDef;
    let result = false;
    const newHeaderCheckbox = typeof rowSelection === "object";
    if (newHeaderCheckbox) {
        const isSelectionCol = $437b23f6a393c3bf$export$f6074a9792015c5d(column);
        const isAutoCol = $437b23f6a393c3bf$export$61b34611dc010a97(column);
        const location = $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection);
        if (location === "autoGroupColumn" && isAutoCol || isSelectionCol && selectionColSvc?.isSelectionColumnEnabled()) result = $437b23f6a393c3bf$export$e92e75627785d7a4(rowSelection);
    } else if (typeof headerCheckboxSelection === "function") result = headerCheckboxSelection($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        column: column,
        colDef: colDef
    }));
    else result = !!headerCheckboxSelection;
    return result;
}
// packages/ag-grid-community/src/selection/baseSelectionService.ts
var $437b23f6a393c3bf$export$3d7b168c0c9c2a78 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        const { gos: gos, beans: beans } = this;
        this.selectionCtx = new $437b23f6a393c3bf$var$RowRangeSelectionContext(beans.rowModel, beans.pinnedRowModel);
        this.addManagedPropertyListeners([
            "isRowSelectable",
            "rowSelection"
        ], ()=>{
            const callback = $437b23f6a393c3bf$export$351959be716b3b33(gos);
            if (callback !== this.isRowSelectable) {
                this.isRowSelectable = callback;
                this.updateSelectable();
            }
        });
        this.isRowSelectable = $437b23f6a393c3bf$export$351959be716b3b33(gos);
        this.addManagedEventListeners({
            cellValueChanged: (e)=>this.updateRowSelectable(e.node),
            rowNodeDataChanged: (e)=>this.updateRowSelectable(e.node)
        });
    }
    destroy() {
        super.destroy();
        this.selectionCtx.reset();
    }
    createCheckboxSelectionComponent() {
        return new $437b23f6a393c3bf$var$CheckboxSelectionComponent();
    }
    createSelectAllFeature(column) {
        if ($437b23f6a393c3bf$var$isCheckboxSelection(this.beans, column)) return new $437b23f6a393c3bf$var$SelectAllFeature(column);
    }
    isMultiSelect() {
        return $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos);
    }
    onRowCtrlSelected(rowCtrl, hasFocusFunc, gui) {
        const selected = !!rowCtrl.rowNode.isSelected();
        rowCtrl.forEachGui(gui, (gui2)=>{
            gui2.rowComp.toggleCss("ag-row-selected", selected);
            const element = gui2.element;
            $437b23f6a393c3bf$export$c22e3722e8a33469(element, selected);
            const hasFocus = element.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans));
            if (hasFocus) hasFocusFunc(gui2);
        });
    }
    announceAriaRowSelection(rowNode) {
        if (this.isRowSelectionBlocked(rowNode)) return;
        const selected = rowNode.isSelected();
        const isEditing2 = this.beans.editSvc?.isEditing({
            rowNode: rowNode
        });
        if (!rowNode.selectable || isEditing2) return;
        const translate = this.getLocaleTextFunc();
        const label = translate(selected ? "ariaRowDeselect" : "ariaRowSelect", `Press SPACE to ${selected ? "deselect" : "select"} this row`);
        this.beans.ariaAnnounce?.announceValue(label, "rowSelection");
    }
    isRowSelectionBlocked(rowNode) {
        return !rowNode.selectable || rowNode.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(rowNode) || !$437b23f6a393c3bf$export$5d5fd838f5df1dd2(this.gos);
    }
    updateRowSelectable(rowNode, suppressSelectionUpdate) {
        const selectable = rowNode.rowPinned && rowNode.pinnedSibling ? // If row node is pinned sibling, copy selectable status over from sibling row node
        rowNode.pinnedSibling.selectable : // otherwise calculate selectable state directly
        this.isRowSelectable?.(rowNode) ?? true;
        this.setRowSelectable(rowNode, selectable, suppressSelectionUpdate);
        return selectable;
    }
    setRowSelectable(rowNode, newVal, suppressSelectionUpdate) {
        if (rowNode.selectable !== newVal) {
            rowNode.selectable = newVal;
            rowNode.dispatchRowEvent("selectableChanged");
            if (suppressSelectionUpdate) return;
            const isGroupSelectsChildren = $437b23f6a393c3bf$export$460e5745f0e6a40d(this.gos);
            if (isGroupSelectsChildren) {
                const selected = this.calculateSelectedFromChildren(rowNode);
                this.setNodesSelected({
                    nodes: [
                        rowNode
                    ],
                    newValue: selected ?? false,
                    source: "selectableChanged"
                });
                return;
            }
            if (rowNode.isSelected() && !rowNode.selectable) this.setNodesSelected({
                nodes: [
                    rowNode
                ],
                newValue: false,
                source: "selectableChanged"
            });
        }
    }
    calculateSelectedFromChildren(rowNode) {
        let atLeastOneSelected = false;
        let atLeastOneDeSelected = false;
        if (!rowNode.childrenAfterGroup?.length) return rowNode.selectable ? rowNode.__selected : null;
        for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
            const child = rowNode.childrenAfterGroup[i];
            let childState = child.isSelected();
            if (!child.selectable) {
                const selectable = this.calculateSelectedFromChildren(child);
                if (selectable === null) continue;
                childState = selectable;
            }
            switch(childState){
                case true:
                    atLeastOneSelected = true;
                    break;
                case false:
                    atLeastOneDeSelected = true;
                    break;
                default:
                    return void 0;
            }
        }
        if (atLeastOneSelected && atLeastOneDeSelected) return void 0;
        if (atLeastOneSelected) return true;
        if (atLeastOneDeSelected) return false;
        if (!rowNode.selectable) return null;
        return rowNode.__selected;
    }
    selectRowNode(rowNode, newValue, e, source = "api") {
        if (newValue && rowNode.destroyed) return false;
        const selectionNotAllowed = !rowNode.selectable && newValue;
        const selectionNotChanged = rowNode.__selected === newValue;
        if (selectionNotAllowed || selectionNotChanged) return false;
        rowNode.__selected = newValue;
        rowNode.dispatchRowEvent("rowSelected");
        const sibling = rowNode.sibling;
        if (sibling && sibling.footer && sibling.__localEventService) sibling.dispatchRowEvent("rowSelected");
        const pinnedSibling = rowNode.pinnedSibling;
        if (pinnedSibling?.rowPinned && pinnedSibling.__localEventService) pinnedSibling.dispatchRowEvent("rowSelected");
        this.eventSvc.dispatchEvent({
            ...$437b23f6a393c3bf$export$5c5bd6257397e1bc(rowNode, this.gos, "rowSelected"),
            event: e || null,
            source: source
        });
        return true;
    }
    isCellCheckboxSelection(column, rowNode) {
        const so = this.gos.get("rowSelection");
        if (so && typeof so !== "string") {
            const checkbox = $437b23f6a393c3bf$export$f6074a9792015c5d(column) && $437b23f6a393c3bf$export$6df3a55606bca6ae(so);
            return column.isColumnFunc(rowNode, checkbox);
        } else return column.isColumnFunc(rowNode, column.colDef.checkboxSelection);
    }
    inferNodeSelections(node, shiftKey, metaKey, source) {
        const { gos: gos, selectionCtx: selectionCtx } = this;
        const currentSelection = node.isSelected();
        const groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
        const enableClickSelection = $437b23f6a393c3bf$var$_getEnableSelection(gos);
        const enableDeselection = $437b23f6a393c3bf$var$_getEnableDeselection(gos);
        const isMultiSelect = this.isMultiSelect();
        const isRowClicked = source === "rowClicked";
        if (isRowClicked && !(enableClickSelection || enableDeselection)) return null;
        if (shiftKey && metaKey && isMultiSelect) {
            const root = selectionCtx.getRoot();
            if (!root) return null;
            else if (!root.isSelected()) {
                const partition = selectionCtx.extend(node, groupSelectsDescendants);
                return {
                    select: [],
                    deselect: partition.keep,
                    reset: false
                };
            } else {
                const partition = selectionCtx.isInRange(node) ? selectionCtx.truncate(node) : selectionCtx.extend(node, groupSelectsDescendants);
                return {
                    deselect: partition.discard,
                    select: partition.keep,
                    reset: false
                };
            }
        } else if (shiftKey && isMultiSelect) {
            const fallback = selectionCtx.selectAll ? this.beans.rowModel.getRow(0) : void 0;
            const root = selectionCtx.getRoot(fallback);
            const partition = selectionCtx.isInRange(node) ? selectionCtx.truncate(node) : selectionCtx.extend(node, groupSelectsDescendants);
            return {
                select: partition.keep,
                deselect: partition.discard,
                reset: selectionCtx.selectAll || !!(root && !root.isSelected())
            };
        } else if (metaKey) {
            if (isRowClicked) {
                const newValue = !currentSelection;
                const selectingWhenDisabled = newValue && !enableClickSelection;
                const deselectingWhenDisabled = !newValue && !enableDeselection;
                if (selectingWhenDisabled || deselectingWhenDisabled) return null;
                selectionCtx.setRoot(node);
                return {
                    node: node,
                    newValue: newValue,
                    clearSelection: false
                };
            }
            selectionCtx.setRoot(node);
            return {
                node: node,
                newValue: !currentSelection,
                clearSelection: !isMultiSelect
            };
        } else {
            selectionCtx.setRoot(node);
            const enableSelectionWithoutKeys = $437b23f6a393c3bf$var$_getEnableSelectionWithoutKeys(gos);
            const groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
            const shouldClear = isRowClicked && (!enableSelectionWithoutKeys || !enableClickSelection);
            if (groupSelectsFiltered && currentSelection === void 0 && $437b23f6a393c3bf$export$9f182d9ca737e15(gos)) return {
                node: node,
                newValue: false,
                checkFilteredNodes: true,
                clearSelection: !isMultiSelect || shouldClear
            };
            if (isRowClicked) {
                const newValue = currentSelection ? !enableSelectionWithoutKeys : enableClickSelection;
                const selectingWhenDisabled = newValue && !enableClickSelection;
                const deselectingWhenDisabled = !newValue && !enableDeselection;
                const wouldStateBeUnchanged = newValue === currentSelection && !shouldClear;
                if (wouldStateBeUnchanged || selectingWhenDisabled || deselectingWhenDisabled) return null;
                return {
                    node: node,
                    newValue: newValue,
                    clearSelection: !isMultiSelect || shouldClear,
                    keepDescendants: node.group && groupSelectsDescendants
                };
            }
            return {
                node: node,
                newValue: !currentSelection,
                clearSelection: !isMultiSelect || shouldClear
            };
        }
    }
};
// packages/ag-grid-community/src/widgets/tabGuardComp.ts
var $437b23f6a393c3bf$export$5a26e3abd1c845b6 = class extends $437b23f6a393c3bf$export$d62d00723c2ea1b5 {
    initialiseTabGuard(params) {
        super.initialiseTabGuard(params, $437b23f6a393c3bf$export$24fcbcdf47263033);
    }
};
// packages/ag-grid-community/src/widgets/tabGuard.ts
var $437b23f6a393c3bf$export$3074753638c3772c = class extends $437b23f6a393c3bf$var$AgTabGuardCtrl {
    constructor(params){
        super(params, $437b23f6a393c3bf$export$24fcbcdf47263033);
    }
};
var $437b23f6a393c3bf$export$299cbf451479e921 = class extends $437b23f6a393c3bf$export$63dba2ace36fd065 {
    constructor(comp){
        super(comp, $437b23f6a393c3bf$export$24fcbcdf47263033);
    }
};
// packages/ag-grid-community/src/widgets/touchListener.ts
var $437b23f6a393c3bf$var$DOUBLE_TAP_MILLISECONDS = 500;
var $437b23f6a393c3bf$var$LONG_PRESS_MILLISECONDS = 550;
var $437b23f6a393c3bf$var$handledTouchEvents;
var $437b23f6a393c3bf$var$addHandledTouchEvent = (event)=>{
    if (!$437b23f6a393c3bf$var$handledTouchEvents) $437b23f6a393c3bf$var$handledTouchEvents = /* @__PURE__ */ new WeakSet();
    else if ($437b23f6a393c3bf$var$handledTouchEvents.has(event)) return false;
    $437b23f6a393c3bf$var$handledTouchEvents.add(event);
    return true;
};
var $437b23f6a393c3bf$export$7b2e93987414b382 = class {
    constructor(eElement, preventClick = false){
        this.eElement = eElement;
        this.preventClick = preventClick;
        this.startListener = null;
        this.handlers = [];
        this.eventSvc = void 0;
        this.touchStart = null;
        this.lastTapTime = null;
        this.longPressTimer = 0;
        this.moved = false;
    }
    addEventListener(eventType, listener) {
        let eventSvc = this.eventSvc;
        if (!eventSvc) {
            if (eventSvc === null) return;
            this.eventSvc = eventSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
            const startListener = this.onTouchStart.bind(this);
            this.startListener = startListener;
            this.eElement.addEventListener("touchstart", startListener, {
                passive: true
            });
        }
        eventSvc.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.eventSvc?.removeEventListener(eventType, listener);
    }
    onTouchStart(touchEvent) {
        if (this.touchStart || !$437b23f6a393c3bf$var$addHandledTouchEvent(touchEvent)) return;
        const touchStart = touchEvent.touches[0];
        this.touchStart = touchStart;
        const handlers = this.handlers;
        if (!handlers.length) {
            const eElement = this.eElement;
            const doc = eElement.ownerDocument;
            const touchMove = this.onTouchMove.bind(this);
            const touchEnd = this.onTouchEnd.bind(this);
            const touchCancel = this.onTouchCancel.bind(this);
            const passiveTrue = {
                passive: true
            };
            const passiveFalse = {
                passive: false
            };
            $437b23f6a393c3bf$var$addTempEventHandlers(handlers, [
                eElement,
                "touchmove",
                touchMove,
                passiveTrue
            ], [
                doc,
                "touchcancel",
                touchCancel,
                passiveTrue
            ], // we set passive=false, as we want to prevent default on this event
            [
                doc,
                "touchend",
                touchEnd,
                passiveFalse
            ], [
                doc,
                "contextmenu",
                $437b23f6a393c3bf$var$preventEventDefault,
                passiveFalse
            ]);
        }
        this.clearLongPress();
        this.longPressTimer = window.setTimeout(()=>{
            this.longPressTimer = 0;
            if (this.touchStart === touchStart && !this.moved) {
                this.moved = true;
                this.eventSvc?.dispatchEvent({
                    type: "longTap",
                    touchStart: touchStart,
                    touchEvent: touchEvent
                });
            }
        }, $437b23f6a393c3bf$var$LONG_PRESS_MILLISECONDS);
    }
    onTouchMove(touchEvent) {
        const { moved: moved, touchStart: touchStart } = this;
        if (!moved && touchStart) {
            const touch = $437b23f6a393c3bf$var$_getFirstActiveTouch(touchStart, touchEvent.touches);
            const eventIsFarAway = touch && !$437b23f6a393c3bf$var$_areEventsNear(touch, touchStart, 4);
            if (eventIsFarAway) {
                this.clearLongPress();
                this.moved = true;
            }
        }
    }
    onTouchEnd(touchEvent) {
        const touchStart = this.touchStart;
        if (!touchStart || !$437b23f6a393c3bf$var$_getFirstActiveTouch(touchStart, touchEvent.changedTouches)) return;
        if (!this.moved) {
            this.eventSvc?.dispatchEvent({
                type: "tap",
                touchStart: touchStart
            });
            this.checkDoubleTap(touchStart);
        }
        if (this.preventClick) $437b23f6a393c3bf$var$preventEventDefault(touchEvent);
        this.cancel();
    }
    onTouchCancel(touchEvent) {
        const touchStart = this.touchStart;
        if (!touchStart || !$437b23f6a393c3bf$var$_getFirstActiveTouch(touchStart, touchEvent.changedTouches)) return;
        this.lastTapTime = null;
        this.cancel();
    }
    checkDoubleTap(touchStart) {
        let now = Date.now();
        const lastTapTime = this.lastTapTime;
        if (lastTapTime) {
            const interval = now - lastTapTime;
            if (interval > $437b23f6a393c3bf$var$DOUBLE_TAP_MILLISECONDS) {
                this.eventSvc?.dispatchEvent({
                    type: "doubleTap",
                    touchStart: touchStart
                });
                now = null;
            }
        }
        this.lastTapTime = now;
    }
    cancel() {
        this.clearLongPress();
        $437b23f6a393c3bf$var$clearTempEventHandlers(this.handlers);
        this.touchStart = null;
    }
    clearLongPress() {
        window.clearTimeout(this.longPressTimer);
        this.longPressTimer = 0;
        this.moved = false;
    }
    destroy() {
        const startListener = this.startListener;
        if (startListener) {
            this.startListener = null;
            this.eElement.removeEventListener("touchstart", startListener);
        }
        this.cancel();
        this.eElement = null;
        this.eventSvc = null;
    }
};
// packages/ag-grid-community/src/interfaces/IRangeService.ts
var $437b23f6a393c3bf$export$162bc75b85f28397 = /* @__PURE__ */ ((CellRangeType2)=>{
    CellRangeType2[CellRangeType2["VALUE"] = 0] = "VALUE";
    CellRangeType2[CellRangeType2["DIMENSION"] = 1] = "DIMENSION";
    return CellRangeType2;
})($437b23f6a393c3bf$export$162bc75b85f28397 || {});
// packages/ag-grid-community/src/vanillaFrameworkOverrides.ts
var $437b23f6a393c3bf$export$8174ad74937c6482 = class {
    constructor(frameworkName = "javascript"){
        this.frameworkName = frameworkName;
        this.renderingEngine = "vanilla";
        this.batchFrameworkComps = false;
        this.wrapIncoming = (callback)=>callback();
        this.wrapOutgoing = (callback)=>callback();
        this.baseDocLink = `${$437b23f6a393c3bf$var$BASE_URL}/${this.frameworkName}-data-grid`;
        $437b23f6a393c3bf$var$setValidationDocLink(this.baseDocLink);
    }
    frameworkComponent(_) {
        return null;
    }
    isFrameworkComponent(_) {
        return false;
    }
    getDocLink(path) {
        return this.baseDocLink + (path ? "/" + path : "");
    }
};
// packages/ag-grid-community/src/api/apiUtils.ts
function $437b23f6a393c3bf$var$createGridApi(context) {
    return {
        beanName: "gridApi",
        bean: context.getBean("apiFunctionSvc").api
    };
}
// packages/ag-grid-community/src/context/gridBeanComparator.ts
var $437b23f6a393c3bf$var$orderedCoreBeans = [
    // Validate license first
    "licenseManager",
    // core beans only
    "environment",
    "eventSvc",
    "gos",
    "paginationAutoPageSizeSvc",
    "apiFunctionSvc",
    "gridApi",
    "registry",
    "agCompUtils",
    "userCompFactory",
    "rowContainerHeight",
    "horizontalResizeSvc",
    "localeSvc",
    "pinnedRowModel",
    "dragSvc",
    "colGroupSvc",
    "visibleCols",
    "popupSvc",
    "selectionSvc",
    "colFilter",
    "quickFilter",
    "filterManager",
    "colModel",
    "headerNavigation",
    "pageBounds",
    "pagination",
    "pageBoundsListener",
    "rowSpanSvc",
    "stickyRowSvc",
    "rowRenderer",
    "expressionSvc",
    "alignedGridsSvc",
    "navigation",
    "valueCache",
    "valueSvc",
    "autoWidthCalc",
    "filterMenuFactory",
    "dragAndDrop",
    "focusSvc",
    "cellNavigation",
    "cellStyles",
    "scrollVisibleSvc",
    "sortSvc",
    "colHover",
    "colAnimation",
    "autoColSvc",
    "selectionColSvc",
    "changeDetectionSvc",
    "animationFrameSvc",
    "undoRedo",
    "colDefFactory",
    "rowStyleSvc",
    "rowNodeBlockLoader",
    "rowNodeSorter",
    "ctrlsSvc",
    "pinnedCols",
    "dataTypeSvc",
    "syncSvc",
    "overlays",
    "stateSvc",
    "expansionSvc",
    "apiEventSvc",
    "ariaAnnounce",
    "menuSvc",
    "colMoves",
    "colAutosize",
    "colFlex",
    "colResize",
    "pivotColsSvc",
    "valueColsSvc",
    "rowGroupColsSvc",
    "colNames",
    "colViewport",
    "pivotResultCols",
    "showRowGroupCols",
    "validation"
];
var $437b23f6a393c3bf$var$beanNamePosition = Object.fromEntries($437b23f6a393c3bf$var$orderedCoreBeans.map((beanName, index)=>[
        beanName,
        index
    ]));
function $437b23f6a393c3bf$var$gridBeanInitComparator(bean1, bean2) {
    const index1 = (bean1.beanName ? $437b23f6a393c3bf$var$beanNamePosition[bean1.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
    const index2 = (bean2.beanName ? $437b23f6a393c3bf$var$beanNamePosition[bean2.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
    return index1 - index2;
}
function $437b23f6a393c3bf$var$gridBeanDestroyComparator(bean1, bean2) {
    if (bean1?.beanName === "gridDestroySvc") return -1;
    if (bean2?.beanName === "gridDestroySvc") return 1;
    return 0;
}
// packages/ag-grid-community/src/headerRendering/rowContainer/headerRowContainerComp.ts
var $437b23f6a393c3bf$var$PinnedLeftElement = {
    tag: "div",
    cls: "ag-pinned-left-header",
    role: "rowgroup"
};
var $437b23f6a393c3bf$var$PinnedRightElement = {
    tag: "div",
    cls: "ag-pinned-right-header",
    role: "rowgroup"
};
var $437b23f6a393c3bf$var$CenterElement = {
    tag: "div",
    cls: "ag-header-viewport",
    role: "rowgroup",
    attrs: {
        tabindex: "-1"
    },
    children: [
        {
            tag: "div",
            ref: "eCenterContainer",
            cls: "ag-header-container",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderRowContainerComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(pinned){
        super();
        this.eCenterContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.headerRowComps = {};
        this.rowCompsList = [];
        this.pinned = pinned;
    }
    postConstruct() {
        this.selectAndSetTemplate();
        const compProxy = {
            setDisplayed: (displayed)=>this.setDisplayed(displayed),
            setCtrls: (ctrls)=>this.setCtrls(ctrls),
            // only gets called for center section
            setCenterWidth: (width)=>this.eCenterContainer.style.width = width,
            setViewportScrollLeft: (left)=>this.getGui().scrollLeft = left,
            // only gets called for pinned sections
            setPinnedContainerWidth: (width)=>{
                const eGui = this.getGui();
                eGui.style.width = width;
                eGui.style.maxWidth = width;
                eGui.style.minWidth = width;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$1e864ee88f54e7b(this.pinned));
        ctrl.setComp(compProxy, this.getGui());
    }
    selectAndSetTemplate() {
        const pinnedLeft = this.pinned == "left";
        const pinnedRight = this.pinned == "right";
        const template = pinnedLeft ? $437b23f6a393c3bf$var$PinnedLeftElement : pinnedRight ? $437b23f6a393c3bf$var$PinnedRightElement : $437b23f6a393c3bf$var$CenterElement;
        this.setTemplate(template);
        this.eRowContainer = this.eCenterContainer !== $437b23f6a393c3bf$export$6c811454646ed8be ? this.eCenterContainer : this.getGui();
    }
    destroy() {
        this.setCtrls([]);
        super.destroy();
    }
    destroyRowComp(rowComp) {
        this.destroyBean(rowComp);
        rowComp.getGui().remove();
    }
    setCtrls(ctrls) {
        const oldRowComps = this.headerRowComps;
        this.headerRowComps = {};
        this.rowCompsList = [];
        let prevGui;
        const appendEnsuringDomOrder = (rowComp)=>{
            const eGui = rowComp.getGui();
            const notAlreadyIn = eGui.parentElement != this.eRowContainer;
            if (notAlreadyIn) this.eRowContainer.appendChild(eGui);
            if (prevGui) $437b23f6a393c3bf$var$_ensureDomOrder(this.eRowContainer, eGui, prevGui);
            prevGui = eGui;
        };
        for (const ctrl of ctrls){
            const ctrlId = ctrl.instanceId;
            const existingComp = oldRowComps[ctrlId];
            delete oldRowComps[ctrlId];
            const rowComp = existingComp ? existingComp : this.createBean(new $437b23f6a393c3bf$var$HeaderRowComp(ctrl));
            this.headerRowComps[ctrlId] = rowComp;
            this.rowCompsList.push(rowComp);
            appendEnsuringDomOrder(rowComp);
        }
        for (const c of Object.values(oldRowComps))this.destroyRowComp(c);
    }
};
// packages/ag-grid-community/src/headerRendering/gridHeaderComp.ts
var $437b23f6a393c3bf$var$GridHeaderElement = {
    tag: "div",
    cls: "ag-header",
    role: "presentation"
};
var $437b23f6a393c3bf$var$GridHeaderComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$GridHeaderElement);
    }
    postConstruct() {
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setHeightAndMinHeight: (height)=>{
                this.getGui().style.height = height;
                this.getGui().style.minHeight = height;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$20b300eb69ca4d09());
        ctrl.setComp(compProxy, this.getGui(), this.getFocusableElement());
        const addContainer = (container)=>{
            this.createManagedBean(container);
            this.appendChild(container);
        };
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp("left"));
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp(null));
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp("right"));
    }
};
var $437b23f6a393c3bf$var$GridHeaderSelector = {
    selector: "AG-HEADER-ROOT",
    component: $437b23f6a393c3bf$var$GridHeaderComp
};
// packages/ag-grid-community/src/rendering/cell/cellComp.ts
var $437b23f6a393c3bf$var$CellComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(beans, cellCtrl, printLayout, eRow, editingCell){
        super();
        this.cellCtrl = cellCtrl;
        // every time we go into edit mode, or back again, this gets incremented.
        // it's the components way of dealing with the async nature of framework components,
        // so if a framework component takes a while to be created, we know if the object
        // is still relevant when creating is finished. eg we could click edit / un-edit 20
        // times before the first React edit component comes back - we should discard
        // the first 19.
        this.rendererVersion = 0;
        this.editorVersion = 0;
        this.beans = beans;
        this.gos = beans.gos;
        this.column = cellCtrl.column;
        this.rowNode = cellCtrl.rowNode;
        this.eRow = eRow;
        const cellDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            role: cellCtrl.getCellAriaRole(),
            attrs: {
                "comp-id": `${this.getCompId()}`,
                "col-id": cellCtrl.column.colIdSanitised
            }
        });
        this.eCell = cellDiv;
        let wrapperDiv;
        if (cellCtrl.isCellSpanning()) {
            wrapperDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-spanned-cell-wrapper",
                role: "presentation"
            });
            wrapperDiv.appendChild(cellDiv);
            this.setTemplateFromElement(wrapperDiv);
        } else this.setTemplateFromElement(cellDiv);
        this.cellCssManager = new $437b23f6a393c3bf$export$a7053cb7eb605bd2(()=>cellDiv);
        this.forceWrapper = cellCtrl.isForceWrapper();
        this.refreshWrapper(false);
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.cellCssManager.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(cellDiv, styles),
            getFocusableElement: ()=>cellDiv,
            setIncludeSelection: (include)=>this.includeSelection = include,
            setIncludeRowDrag: (include)=>this.includeRowDrag = include,
            setIncludeDndSource: (include)=>this.includeDndSource = include,
            setRenderDetails: (compDetails, valueToDisplay, force)=>this.setRenderDetails(compDetails, valueToDisplay, force),
            setEditDetails: (compDetails, popup, position)=>this.setEditDetails(compDetails, popup, position),
            getCellEditor: ()=>this.cellEditor || null,
            getCellRenderer: ()=>this.cellRenderer || null,
            getParentOfValue: ()=>this.getParentOfValue(),
            refreshEditStyles: (editing, isPopup)=>this.refreshEditStyles(editing, isPopup)
        };
        cellCtrl.setComp(compProxy, cellDiv, wrapperDiv, this.eCellWrapper, printLayout, editingCell, void 0);
    }
    getParentOfValue() {
        return this.eCellValue ?? this.eCellWrapper ?? this.eCell;
    }
    setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance) {
        const isInlineEditing = this.cellEditor && !this.cellEditorPopupWrapper;
        if (isInlineEditing) return;
        this.firstRender = this.firstRender == null;
        const controlWrapperChanged = this.refreshWrapper(false);
        this.refreshEditStyles(false);
        if (compDetails) {
            const neverRefresh = forceNewCellRendererInstance || controlWrapperChanged;
            const cellRendererRefreshSuccessful = neverRefresh ? false : this.refreshCellRenderer(compDetails);
            if (!cellRendererRefreshSuccessful) {
                this.destroyRenderer();
                this.createCellRendererInstance(compDetails);
            }
        } else {
            this.destroyRenderer();
            this.insertValueWithoutCellRenderer(valueToDisplay);
        }
        this.rowDraggingComp?.refreshVisibility();
    }
    setEditDetails(compDetails, popup, position) {
        if (compDetails) this.createCellEditorInstance(compDetails, popup, position);
        else this.destroyEditor();
    }
    removeControls() {
        const context = this.beans.context;
        this.checkboxSelectionComp = context.destroyBean(this.checkboxSelectionComp);
        this.dndSourceComp = context.destroyBean(this.dndSourceComp);
        this.rowDraggingComp = context.destroyBean(this.rowDraggingComp);
    }
    // returns true if wrapper was changed
    refreshWrapper(editing) {
        const providingControls = this.includeRowDrag || this.includeDndSource || this.includeSelection;
        const usingWrapper = providingControls || this.forceWrapper;
        const putWrapperIn = usingWrapper && this.eCellWrapper == null;
        if (putWrapperIn) {
            this.eCellWrapper = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-cell-wrapper",
                role: "presentation"
            });
            this.eCell.appendChild(this.eCellWrapper);
        }
        const takeWrapperOut = !usingWrapper && this.eCellWrapper != null;
        if (takeWrapperOut) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eCellWrapper);
            this.eCellWrapper = void 0;
        }
        this.cellCssManager.toggleCss("ag-cell-value", !usingWrapper);
        const usingCellValue = !editing && usingWrapper;
        const putCellValueIn = usingCellValue && this.eCellValue == null;
        if (putCellValueIn) {
            const cls = this.cellCtrl.getCellValueClass();
            this.eCellValue = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "span",
                cls: cls,
                role: "presentation"
            });
            this.eCellWrapper.appendChild(this.eCellValue);
        }
        const takeCellValueOut = !usingCellValue && this.eCellValue != null;
        if (takeCellValueOut) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eCellValue);
            this.eCellValue = void 0;
        }
        const templateChanged = putWrapperIn || takeWrapperOut || putCellValueIn || takeCellValueOut;
        if (templateChanged) this.removeControls();
        if (!editing && providingControls) this.addControls();
        return templateChanged;
    }
    addControls() {
        const { cellCtrl: cellCtrl, eCellWrapper: eCellWrapper, eCellValue: eCellValue, includeRowDrag: includeRowDrag, includeDndSource: includeDndSource, includeSelection: includeSelection } = this;
        const insertBefore = (comp)=>{
            if (comp) eCellWrapper.insertBefore(comp.getGui(), eCellValue);
        };
        if (includeRowDrag && this.rowDraggingComp == null) {
            this.rowDraggingComp = cellCtrl.createRowDragComp();
            insertBefore(this.rowDraggingComp);
        }
        if (includeDndSource && this.dndSourceComp == null) {
            this.dndSourceComp = cellCtrl.createDndSource();
            insertBefore(this.dndSourceComp);
        }
        if (includeSelection && this.checkboxSelectionComp == null) {
            this.checkboxSelectionComp = cellCtrl.createSelectionCheckbox();
            insertBefore(this.checkboxSelectionComp);
        }
    }
    createCellEditorInstance(compDetails, popup, position) {
        const versionCopy = this.editorVersion;
        const cellEditorPromise = compDetails.newAgStackInstance();
        const { params: params } = compDetails;
        cellEditorPromise.then((c)=>this.afterCellEditorCreated(versionCopy, c, params, popup, position));
        const cellEditorAsync = $437b23f6a393c3bf$export$672d9e47bc342bac(this.cellEditor);
        if (cellEditorAsync && params.cellStartedEdit) this.cellCtrl.focusCell(true);
    }
    insertValueWithoutCellRenderer(valueToDisplay) {
        const eParent = this.getParentOfValue();
        $437b23f6a393c3bf$export$69e6e10709eabd91(eParent);
        const escapedValue = $437b23f6a393c3bf$export$a16cfb6652fe466f(valueToDisplay);
        if (escapedValue != null) eParent.textContent = escapedValue;
    }
    destroyRenderer() {
        const { context: context } = this.beans;
        this.cellRenderer = context.destroyBean(this.cellRenderer);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.cellRendererGui);
        this.cellRendererGui = null;
        this.rendererVersion++;
    }
    destroyEditor() {
        const { context: context } = this.beans;
        const recoverFocus = this.cellEditorPopupWrapper?.getGui().contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans)) || this.cellCtrl.hasBrowserFocus();
        if (recoverFocus) this.eCell.focus({
            preventScroll: true
        });
        this.hideEditorPopup?.();
        this.hideEditorPopup = void 0;
        this.cellEditor = context.destroyBean(this.cellEditor);
        this.cellEditorPopupWrapper = context.destroyBean(this.cellEditorPopupWrapper);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.cellEditorGui);
        this.cellCtrl.disableEditorTooltipFeature();
        this.cellEditorGui = null;
        this.editorVersion++;
    }
    refreshCellRenderer(compClassAndParams) {
        if (this.cellRenderer?.refresh == null) return false;
        if (this.cellRendererClass !== compClassAndParams.componentClass) return false;
        const result = this.cellRenderer.refresh(compClassAndParams.params);
        return result === true || result === void 0;
    }
    createCellRendererInstance(compDetails) {
        const displayComponentVersionCopy = this.rendererVersion;
        const createCellRendererFunc = (details)=>(_)=>{
                const staleTask = this.rendererVersion !== displayComponentVersionCopy || !this.isAlive();
                if (staleTask) return;
                const componentPromise = details.newAgStackInstance();
                const callback = this.afterCellRendererCreated.bind(this, displayComponentVersionCopy, details.componentClass);
                componentPromise?.then(callback);
            };
        const { animationFrameSvc: animationFrameSvc } = this.beans;
        let createTask;
        if (animationFrameSvc?.active && this.firstRender) createTask = (details, isDeferred = false)=>{
            animationFrameSvc.createTask(createCellRendererFunc(details), this.rowNode.rowIndex, "p2", details.componentFromFramework, isDeferred);
        };
        else createTask = (details)=>createCellRendererFunc(details)();
        if (compDetails.params?.deferRender && !this.cellCtrl.rowNode.group) {
            const { loadingComp: loadingComp, onReady: onReady } = this.cellCtrl.getDeferLoadingCellRenderer();
            if (loadingComp) {
                createTask(loadingComp);
                onReady.then(()=>createTask(compDetails, true));
            }
        } else createTask(compDetails);
    }
    afterCellRendererCreated(cellRendererVersion, cellRendererClass, cellRenderer) {
        const staleTask = !this.isAlive() || cellRendererVersion !== this.rendererVersion;
        if (staleTask) {
            this.beans.context.destroyBean(cellRenderer);
            return;
        }
        this.cellRenderer = cellRenderer;
        this.cellRendererClass = cellRendererClass;
        const cellGui = cellRenderer.getGui();
        this.cellRendererGui = cellGui;
        if (cellGui != null) {
            const eParent = this.getParentOfValue();
            $437b23f6a393c3bf$export$69e6e10709eabd91(eParent);
            eParent.appendChild(cellGui);
        }
    }
    afterCellEditorCreated(requestVersion, cellEditor, params, popup, position) {
        const staleComp = requestVersion !== this.editorVersion;
        const { context: context } = this.beans;
        if (staleComp) {
            context.destroyBean(cellEditor);
            return;
        }
        const editingCancelledByUserComp = cellEditor.isCancelBeforeStart?.();
        if (editingCancelledByUserComp) {
            context.destroyBean(cellEditor);
            this.cellCtrl.stopEditing(true);
            return;
        }
        if (!cellEditor.getGui) {
            $437b23f6a393c3bf$export$545083624300f13d(97, {
                colId: this.column.getId()
            });
            context.destroyBean(cellEditor);
            return;
        }
        this.cellEditor = cellEditor;
        this.cellEditorGui = cellEditor.getGui();
        const cellEditorInPopup = popup || cellEditor.isPopup?.();
        if (cellEditorInPopup) this.addPopupCellEditor(params, position);
        else this.addInCellEditor();
        this.refreshEditStyles(true, cellEditorInPopup);
        cellEditor.afterGuiAttached?.();
        this.cellCtrl.enableEditorTooltipFeature(cellEditor);
        this.cellCtrl.cellEditorAttached();
    }
    refreshEditStyles(editing, isPopup) {
        const { cellCssManager: cellCssManager } = this;
        cellCssManager.toggleCss("ag-cell-inline-editing", editing && !isPopup);
        cellCssManager.toggleCss("ag-cell-popup-editing", editing && !!isPopup);
        cellCssManager.toggleCss("ag-cell-not-inline-editing", !editing || !!isPopup);
    }
    addInCellEditor() {
        const { eCell: eCell } = this;
        if (eCell.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) eCell.focus();
        this.destroyRenderer();
        this.refreshWrapper(true);
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.getParentOfValue());
        if (this.cellEditorGui) {
            const eParent = this.getParentOfValue();
            eParent.appendChild(this.cellEditorGui);
        }
    }
    addPopupCellEditor(params, position) {
        const { gos: gos, context: context, popupSvc: popupSvc, editSvc: editSvc } = this.beans;
        if (gos.get("editType") === "fullRow") $437b23f6a393c3bf$export$545083624300f13d(98);
        const cellEditorPopupWrapper = this.cellEditorPopupWrapper = context.createBean(editSvc.createPopupEditorWrapper(params));
        const { cellEditor: cellEditor, cellEditorGui: cellEditorGui, eCell: eCell, rowNode: rowNode, column: column, cellCtrl: cellCtrl } = this;
        const ePopupGui = cellEditorPopupWrapper.getGui();
        if (cellEditorGui) ePopupGui.appendChild(cellEditorGui);
        const useModelPopup = gos.get("stopEditingWhenCellsLoseFocus");
        const positionToUse = position != null ? position : cellEditor.getPopupPosition?.() ?? "over";
        const isRtl = gos.get("enableRtl");
        const positionParams = {
            ePopup: ePopupGui,
            additionalParams: {
                column: column,
                rowNode: rowNode
            },
            type: "popupCellEditor",
            eventSource: eCell,
            position: positionToUse,
            alignSide: isRtl ? "right" : "left",
            keepWithinBounds: true
        };
        const positionCallback = popupSvc.positionPopupByComponent.bind(popupSvc, positionParams);
        const addPopupRes = popupSvc.addPopup({
            modal: useModelPopup,
            eChild: ePopupGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                cellCtrl.onPopupEditorClosed();
            },
            anchorToElement: eCell,
            positionCallback: positionCallback,
            ariaOwns: eCell
        });
        if (addPopupRes) this.hideEditorPopup = addPopupRes.hideFunc;
    }
    detach() {
        this.getGui().remove();
    }
    // if the row is also getting destroyed, then we don't need to remove from dom,
    // as the row will also get removed, so no need to take out the cells from the row
    // if the row is going (removing is an expensive operation, so only need to remove
    // the top part)
    //
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroy() {
        this.destroyRenderer();
        this.destroyEditor();
        this.removeControls();
        super.destroy();
    }
};
// packages/ag-grid-community/src/rendering/row/rowComp.ts
var $437b23f6a393c3bf$var$RowComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(ctrl, beans, containerType){
        super();
        this.cellComps = /* @__PURE__ */ new Map();
        this.beans = beans;
        this.rowCtrl = ctrl;
        const rowDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            role: "row",
            attrs: {
                "comp-id": `${this.getCompId()}`
            }
        });
        this.setInitialStyle(rowDiv, containerType);
        this.setTemplateFromElement(rowDiv);
        const style = rowDiv.style;
        this.domOrder = this.rowCtrl.getDomOrder();
        const compProxy = {
            setDomOrder: (domOrder)=>this.domOrder = domOrder,
            setCellCtrls: (cellCtrls)=>this.setCellCtrls(cellCtrls),
            showFullWidth: (compDetails)=>this.showFullWidth(compDetails),
            getFullWidthCellRenderer: ()=>this.fullWidthCellRenderer,
            getFullWidthCellRendererParams: ()=>this.fullWidthCellRendererParams,
            toggleCss: (name, on)=>this.toggleCss(name, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(rowDiv, styles),
            setTop: (top)=>style.top = top,
            setTransform: (transform)=>style.transform = transform,
            setRowIndex: (rowIndex)=>rowDiv.setAttribute("row-index", rowIndex),
            setRowId: (rowId)=>rowDiv.setAttribute("row-id", rowId),
            setRowBusinessKey: (businessKey)=>rowDiv.setAttribute("row-business-key", businessKey),
            refreshFullWidth: (getUpdatedParams)=>{
                const params = getUpdatedParams();
                this.fullWidthCellRendererParams = params;
                return this.fullWidthCellRenderer?.refresh?.(params) ?? false;
            }
        };
        ctrl.setComp(compProxy, this.getGui(), containerType, void 0);
        this.addDestroyFunc(()=>{
            ctrl.unsetComp(containerType);
        });
    }
    setInitialStyle(container, containerType) {
        const transform = this.rowCtrl.getInitialTransform(containerType);
        if (transform) container.style.setProperty("transform", transform);
        else {
            const top = this.rowCtrl.getInitialRowTop(containerType);
            if (top) container.style.setProperty("top", top);
        }
    }
    showFullWidth(compDetails) {
        const callback = (cellRenderer)=>{
            if (this.isAlive()) {
                const eGui = cellRenderer.getGui();
                this.getGui().appendChild(eGui);
                this.rowCtrl.setupDetailRowAutoHeight(eGui);
                this.setFullWidthRowComp(cellRenderer, compDetails.params);
            } else this.beans.context.destroyBean(cellRenderer);
        };
        const res = compDetails.newAgStackInstance();
        res.then(callback);
    }
    setCellCtrls(cellCtrls) {
        const cellsToRemove = new Map(this.cellComps);
        for (const cellCtrl of cellCtrls){
            const key = cellCtrl.instanceId;
            if (!this.cellComps.has(key)) this.newCellComp(cellCtrl);
            else cellsToRemove.delete(key);
        }
        this.destroyCells(cellsToRemove);
        this.ensureDomOrder(cellCtrls);
    }
    ensureDomOrder(cellCtrls) {
        if (!this.domOrder) return;
        const elementsInOrder = [];
        for (const cellCtrl of cellCtrls){
            const cellComp = this.cellComps.get(cellCtrl.instanceId);
            if (cellComp) elementsInOrder.push(cellComp.getGui());
        }
        $437b23f6a393c3bf$var$_setDomChildOrder(this.getGui(), elementsInOrder);
    }
    newCellComp(cellCtrl) {
        const editing = this.beans.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        }) ?? false;
        const cellComp = new $437b23f6a393c3bf$var$CellComp(this.beans, cellCtrl, this.rowCtrl.printLayout, this.getGui(), editing);
        this.cellComps.set(cellCtrl.instanceId, cellComp);
        this.getGui().appendChild(cellComp.getGui());
    }
    destroy() {
        super.destroy();
        this.destroyCells(this.cellComps);
    }
    setFullWidthRowComp(fullWidthRowComponent, params) {
        this.fullWidthCellRenderer = fullWidthRowComponent;
        this.fullWidthCellRendererParams = params;
        this.addDestroyFunc(()=>{
            this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer);
            this.fullWidthCellRendererParams = void 0;
        });
    }
    destroyCells(cellComps) {
        for (const cellComp of cellComps.values()){
            if (!cellComp) return;
            const instanceId = cellComp.cellCtrl.instanceId;
            if (this.cellComps.get(instanceId) !== cellComp) return;
            cellComp.detach();
            cellComp.destroy();
            this.cellComps.delete(instanceId);
        }
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerComp.ts
function $437b23f6a393c3bf$var$getElementParams(name, options, beans) {
    const isCellSpanning = !!beans.gos.get("enableCellSpan") && !!options.getSpannedRowCtrls;
    const eContainerElement = {
        tag: "div",
        ref: "eContainer",
        cls: $437b23f6a393c3bf$export$35e1b2dddf7fc6e9(name),
        role: "rowgroup"
    };
    if (options.type === "center" || isCellSpanning) {
        const eSpannedContainerElement = {
            tag: "div",
            ref: "eSpannedContainer",
            cls: `ag-spanning-container ${$437b23f6a393c3bf$export$cd6b90bdf6c4fcfd(name)}`,
            role: "presentation"
        };
        eContainerElement.role = "presentation";
        return {
            tag: "div",
            ref: "eViewport",
            cls: `ag-viewport ${$437b23f6a393c3bf$export$65619730ec980d6a(name)}`,
            role: "rowgroup",
            children: [
                eContainerElement,
                isCellSpanning ? eSpannedContainerElement : null
            ]
        };
    }
    return eContainerElement;
}
var $437b23f6a393c3bf$var$RowContainerComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(params){
        super();
        this.eViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSpannedContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.rowCompsNoSpan = {};
        this.rowCompsWithSpan = {};
        this.name = params?.name;
        this.options = $437b23f6a393c3bf$export$a46aad9f8c79261f(this.name);
    }
    postConstruct() {
        this.setTemplate($437b23f6a393c3bf$var$getElementParams(this.name, this.options, this.beans));
        const compProxy = {
            setHorizontalScroll: (offset)=>this.eViewport.scrollLeft = offset,
            setViewportHeight: (height)=>this.eViewport.style.height = height,
            setRowCtrls: ({ rowCtrls: rowCtrls })=>this.setRowCtrls(rowCtrls),
            setSpannedRowCtrls: (rowCtrls)=>this.setRowCtrls(rowCtrls, true),
            setDomOrder: (domOrder)=>{
                this.domOrder = domOrder;
            },
            setContainerWidth: (width)=>{
                this.eContainer.style.width = width;
                if (this.eSpannedContainer) this.eSpannedContainer.style.width = width;
            },
            setOffsetTop: (offset)=>{
                const top = `translateY(${offset})`;
                this.eContainer.style.transform = top;
                if (this.eSpannedContainer) this.eSpannedContainer.style.transform = top;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$2d4385f6f566fe5e(this.name));
        ctrl.setComp(compProxy, this.eContainer, this.eSpannedContainer, this.eViewport);
    }
    destroy() {
        this.setRowCtrls([]);
        this.setRowCtrls([], true);
        super.destroy();
        this.lastPlacedElement = null;
    }
    setRowCtrls(rowCtrls, spanContainer) {
        const { beans: beans, options: options } = this;
        const container = spanContainer ? this.eSpannedContainer : this.eContainer;
        const oldRows = spanContainer ? {
            ...this.rowCompsWithSpan
        } : {
            ...this.rowCompsNoSpan
        };
        const newComps = {};
        if (spanContainer) this.rowCompsWithSpan = newComps;
        else this.rowCompsNoSpan = newComps;
        this.lastPlacedElement = null;
        const orderedRows = [];
        for (const rowCtrl of rowCtrls){
            const instanceId = rowCtrl.instanceId;
            const existingRowComp = oldRows[instanceId];
            let rowComp;
            if (existingRowComp) {
                rowComp = existingRowComp;
                delete oldRows[instanceId];
            } else {
                if (!rowCtrl.rowNode.displayed) continue;
                rowComp = new $437b23f6a393c3bf$var$RowComp(rowCtrl, beans, options.type);
            }
            newComps[instanceId] = rowComp;
            orderedRows.push([
                rowComp,
                !existingRowComp
            ]);
        }
        this.removeOldRows(Object.values(oldRows));
        this.addRowNodes(orderedRows, container);
    }
    addRowNodes(rows, container) {
        const { domOrder: domOrder } = this;
        for (const [rowComp, isNew] of rows){
            const eGui = rowComp.getGui();
            if (!domOrder) {
                if (isNew) container.appendChild(eGui);
            } else this.ensureDomOrder(eGui, container);
        }
    }
    removeOldRows(rowComps) {
        for (const oldRowComp of rowComps){
            oldRowComp.getGui().remove();
            oldRowComp.destroy();
        }
    }
    ensureDomOrder(eRow, container) {
        $437b23f6a393c3bf$var$_ensureDomOrder(container, eRow, this.lastPlacedElement);
        this.lastPlacedElement = eRow;
    }
};
var $437b23f6a393c3bf$var$RowContainerSelector = {
    selector: "AG-ROW-CONTAINER",
    component: $437b23f6a393c3bf$var$RowContainerComp
};
// packages/ag-grid-community/src/gridBodyComp/gridBodyComp.ts
function $437b23f6a393c3bf$var$makeRowContainers(paramsMap, names) {
    return names.map((name)=>{
        const refName = `e${name[0].toUpperCase() + name.substring(1)}RowContainer`;
        paramsMap[refName] = {
            name: name
        };
        return {
            tag: "ag-row-container",
            ref: refName,
            attrs: {
                name: name
            }
        };
    });
}
function $437b23f6a393c3bf$var$getGridBodyTemplate(includeOverlay) {
    const paramsMap = {};
    const elementParams = {
        tag: "div",
        ref: "eGridRoot",
        cls: "ag-root ag-unselectable",
        children: [
            {
                tag: "ag-header-root"
            },
            {
                tag: "div",
                ref: "eTop",
                cls: "ag-floating-top",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "topLeft",
                    "topCenter",
                    "topRight",
                    "topFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eBody",
                cls: "ag-body",
                role: "presentation",
                children: [
                    {
                        tag: "div",
                        ref: "eBodyViewport",
                        cls: "ag-body-viewport",
                        role: "presentation",
                        children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                            "left",
                            "center",
                            "right",
                            "fullWidth"
                        ])
                    },
                    {
                        tag: "ag-fake-vertical-scroll"
                    }
                ]
            },
            {
                tag: "div",
                ref: "eStickyTop",
                cls: "ag-sticky-top",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "stickyTopLeft",
                    "stickyTopCenter",
                    "stickyTopRight",
                    "stickyTopFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eStickyBottom",
                cls: "ag-sticky-bottom",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "stickyBottomLeft",
                    "stickyBottomCenter",
                    "stickyBottomRight",
                    "stickyBottomFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eBottom",
                cls: "ag-floating-bottom",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "bottomLeft",
                    "bottomCenter",
                    "bottomRight",
                    "bottomFullWidth"
                ])
            },
            {
                tag: "ag-fake-horizontal-scroll"
            },
            includeOverlay ? {
                tag: "ag-overlay-wrapper"
            } : null
        ]
    };
    return {
        paramsMap: paramsMap,
        elementParams: elementParams
    };
}
var $437b23f6a393c3bf$var$GridBodyComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        this.eGridRoot = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBodyViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eStickyTop = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eStickyBottom = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eTop = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBottom = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBody = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const { overlays: overlays, rangeSvc: rangeSvc } = this.beans;
        const overlaySelector = overlays?.getOverlayWrapperSelector();
        const { paramsMap: paramsMap, elementParams: elementParams } = $437b23f6a393c3bf$var$getGridBodyTemplate(!!overlaySelector);
        this.setTemplate(elementParams, [
            ...overlaySelector ? [
                overlaySelector
            ] : [],
            $437b23f6a393c3bf$var$FakeHScrollSelector,
            $437b23f6a393c3bf$var$FakeVScrollSelector,
            $437b23f6a393c3bf$var$GridHeaderSelector,
            $437b23f6a393c3bf$var$RowContainerSelector
        ], paramsMap);
        const setHeight = (height, element)=>{
            const heightString = `${height}px`;
            element.style.minHeight = heightString;
            element.style.height = heightString;
        };
        const compProxy = {
            setRowAnimationCssOnBodyViewport: (cssClass, animate)=>this.setRowAnimationCssOnBodyViewport(cssClass, animate),
            setColumnCount: (count)=>$437b23f6a393c3bf$export$56744a26086b5898(this.getGui(), count),
            setRowCount: (count)=>$437b23f6a393c3bf$export$1ad8496b26b660f8(this.getGui(), count),
            setTopHeight: (height)=>setHeight(height, this.eTop),
            setBottomHeight: (height)=>setHeight(height, this.eBottom),
            setTopInvisible: (invisible)=>this.eTop.classList.toggle("ag-invisible", invisible),
            setBottomInvisible: (invisible)=>this.eBottom.classList.toggle("ag-invisible", invisible),
            setStickyTopHeight: (height)=>this.eStickyTop.style.height = height,
            setStickyTopTop: (top)=>this.eStickyTop.style.top = top,
            setStickyTopWidth: (width)=>this.eStickyTop.style.width = width,
            setStickyBottomHeight: (height)=>{
                this.eStickyBottom.style.height = height;
                this.eStickyBottom.classList.toggle("ag-invisible", height === "0px");
            },
            setStickyBottomBottom: (bottom)=>this.eStickyBottom.style.bottom = bottom,
            setStickyBottomWidth: (width)=>this.eStickyBottom.style.width = width,
            setColumnMovingCss: (cssClass, flag)=>this.toggleCss(cssClass, flag),
            updateLayoutClasses: (cssClass, params)=>{
                const classLists = [
                    this.eBodyViewport.classList,
                    this.eBody.classList
                ];
                for (const classList of classLists){
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.NORMAL, params.normal);
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.PRINT, params.print);
                }
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.NORMAL, params.normal);
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.PRINT, params.print);
            },
            setAlwaysVerticalScrollClass: (cssClass, on)=>this.eBodyViewport.classList.toggle($437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL, on),
            registerBodyViewportResizeListener: (listener)=>{
                const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eBodyViewport, listener);
                this.addDestroyFunc(()=>unsubscribeFromResize());
            },
            setPinnedTopBottomOverflowY: (overflow)=>this.eTop.style.overflowY = this.eBottom.style.overflowY = overflow,
            setCellSelectableCss: (cssClass, selectable)=>{
                for (const ct of [
                    this.eTop,
                    this.eBodyViewport,
                    this.eBottom
                ])ct.classList.toggle(cssClass, selectable);
            },
            setBodyViewportWidth: (width)=>this.eBodyViewport.style.width = width,
            setGridRootRole: (role)=>$437b23f6a393c3bf$export$f8d01fa01787902(this.eGridRoot, role)
        };
        this.ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$8bebc3145b40d221());
        this.ctrl.setComp(compProxy, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom, this.eStickyTop, this.eStickyBottom);
        if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos) || $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos)) $437b23f6a393c3bf$var$_setAriaMultiSelectable(this.getGui(), true);
    }
    setRowAnimationCssOnBodyViewport(cssClass, animateRows) {
        const bodyViewportClassList = this.eBodyViewport.classList;
        bodyViewportClassList.toggle("ag-row-animation", animateRows);
        bodyViewportClassList.toggle("ag-row-no-animation", !animateRows);
    }
};
var $437b23f6a393c3bf$var$GridBodySelector = {
    selector: "AG-GRID-BODY",
    component: $437b23f6a393c3bf$var$GridBodyComp
};
// packages/ag-grid-community/src/gridComp/gridCtrl.ts
var $437b23f6a393c3bf$export$f3c741dac0be9745 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.additionalFocusableContainers = /* @__PURE__ */ new Set();
    }
    setComp(view, eGridDiv, eGui) {
        this.view = view;
        this.eGridHostDiv = eGridDiv;
        this.eGui = eGui;
        this.eGui.setAttribute("grid-id", this.beans.context.getId());
        const { dragAndDrop: dragAndDrop, ctrlsSvc: ctrlsSvc } = this.beans;
        dragAndDrop?.registerGridDropTarget(()=>this.eGui, this);
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this.view));
        this.view.setRtlClass(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
        const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eGridHostDiv, this.onGridSizeChanged.bind(this));
        this.addDestroyFunc(()=>unsubscribeFromResize());
        ctrlsSvc.register("gridCtrl", this);
    }
    isDetailGrid() {
        const el = $437b23f6a393c3bf$export$c4c49c776025d475(this.getGui());
        return el?.getAttribute("row-id")?.startsWith("detail") || false;
    }
    getOptionalSelectors() {
        const beans = this.beans;
        return {
            paginationSelector: beans.pagination?.getPaginationSelector(),
            gridHeaderDropZonesSelector: beans.registry?.getSelector("AG-GRID-HEADER-DROP-ZONES"),
            sideBarSelector: beans.sideBar?.getSelector(),
            statusBarSelector: beans.registry?.getSelector("AG-STATUS-BAR"),
            watermarkSelector: beans.licenseManager?.getWatermarkSelector()
        };
    }
    onGridSizeChanged() {
        this.eventSvc.dispatchEvent({
            type: "gridSizeChanged",
            clientWidth: this.eGridHostDiv.clientWidth,
            clientHeight: this.eGridHostDiv.clientHeight
        });
    }
    destroyGridUi() {
        this.view.destroyGridUi();
    }
    getGui() {
        return this.eGui;
    }
    setResizeCursor(direction) {
        const { view: view } = this;
        if (direction === false) view.setCursor(null);
        else {
            const cursor = direction === 1 /* Horizontal */  ? "ew-resize" : "ns-resize";
            view.setCursor(cursor);
        }
    }
    disableUserSelect(on) {
        this.view.setUserSelect(on ? "none" : null);
    }
    focusNextInnerContainer(backwards) {
        const focusableContainers = this.getFocusableContainers();
        const { indexWithFocus: indexWithFocus, nextIndex: nextIndex } = this.getNextFocusableIndex(focusableContainers, backwards);
        if (nextIndex < 0 || nextIndex >= focusableContainers.length) return false;
        if (nextIndex === 0) {
            if (indexWithFocus > 0) {
                const { visibleCols: visibleCols, focusSvc: focusSvc } = this.beans;
                const allColumns = visibleCols.allCols;
                const lastColumn = $437b23f6a393c3bf$export$236389741107357f(allColumns);
                if (focusSvc.focusGridView({
                    column: lastColumn,
                    backwards: true
                })) return true;
            }
            return false;
        }
        return this.focusContainer(focusableContainers[nextIndex], backwards);
    }
    focusInnerElement(fromBottom) {
        const userCallbackFunction = this.gos.getCallback("focusGridInnerElement");
        if (userCallbackFunction?.({
            fromBottom: !!fromBottom
        })) return true;
        const focusableContainers = this.getFocusableContainers();
        const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
        const allColumns = visibleCols.allCols;
        if (fromBottom) {
            if (focusableContainers.length > 1) return this.focusContainer($437b23f6a393c3bf$export$236389741107357f(focusableContainers), fromBottom);
            const lastColumn = $437b23f6a393c3bf$export$236389741107357f(allColumns);
            if (focusSvc.focusGridView({
                column: lastColumn,
                backwards: fromBottom
            })) return true;
        }
        if (this.gos.get("headerHeight") === 0 || $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) {
            if (focusSvc.focusGridView({
                column: allColumns[0],
                backwards: fromBottom
            })) return true;
            for(let i = 1; i < focusableContainers.length; i++){
                if ($437b23f6a393c3bf$export$8598088d375f416f(focusableContainers[i].getGui(), fromBottom)) return true;
            }
            return false;
        }
        return focusSvc.focusFirstHeader();
    }
    forceFocusOutOfContainer(up = false) {
        this.view.forceFocusOutOfContainer(up);
    }
    addFocusableContainer(container) {
        this.additionalFocusableContainers.add(container);
    }
    removeFocusableContainer(container) {
        this.additionalFocusableContainers.delete(container);
    }
    allowFocusForNextCoreContainer(up) {
        const coreContainers = this.view.getFocusableContainers();
        const { nextIndex: nextIndex } = this.getNextFocusableIndex(coreContainers, up);
        const comp = coreContainers[nextIndex];
        if (comp) this.focusContainer(comp);
        else this.forceFocusOutOfContainer(up);
    }
    isFocusable() {
        const beans = this.beans;
        return !$437b23f6a393c3bf$var$_isCellFocusSuppressed(beans) || !$437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans) || !!beans.sideBar?.comp?.isDisplayed();
    }
    getNextFocusableIndex(focusableContainers, backwards) {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        const indexWithFocus = focusableContainers.findIndex((container)=>container.getGui().contains(activeEl));
        const nextIndex = indexWithFocus + (backwards ? -1 : 1);
        return {
            indexWithFocus: indexWithFocus,
            nextIndex: nextIndex
        };
    }
    focusContainer(comp, up) {
        comp.setAllowFocus?.(true);
        const result = $437b23f6a393c3bf$export$8598088d375f416f(comp.getGui(), up, false, true);
        comp.setAllowFocus?.(false);
        return result;
    }
    getFocusableContainers() {
        return [
            ...this.view.getFocusableContainers(),
            ...this.additionalFocusableContainers
        ];
    }
    destroy() {
        this.additionalFocusableContainers.clear();
        super.destroy();
    }
};
// packages/ag-grid-community/src/gridComp/gridComp.ts
var $437b23f6a393c3bf$var$GridComp = class extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(eGridDiv){
        super();
        this.gridBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.sideBar = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.pagination = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.rootWrapperBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eGridDiv = eGridDiv;
    }
    postConstruct() {
        const compProxy = {
            destroyGridUi: ()=>this.destroyBean(this),
            setRtlClass: (cssClass)=>this.addCss(cssClass),
            forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
            updateLayoutClasses: this.updateLayoutClasses.bind(this),
            getFocusableContainers: this.getFocusableContainers.bind(this),
            setUserSelect: (value)=>{
                this.getGui().style.userSelect = value != null ? value : "";
                this.getGui().style.webkitUserSelect = value != null ? value : "";
            },
            setCursor: (value)=>{
                this.getGui().style.cursor = value != null ? value : "";
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$f3c741dac0be9745());
        const comps = ctrl.getOptionalSelectors();
        const template = this.createTemplate(comps);
        const requiredComps = [
            $437b23f6a393c3bf$var$GridBodySelector,
            ...Object.values(comps).filter((c)=>!!c)
        ];
        this.setTemplate(template, requiredComps);
        ctrl.setComp(compProxy, this.eGridDiv, this.getGui());
        this.insertGridIntoDom();
        this.initialiseTabGuard({
            // we want to override the default behaviour to do nothing for onTabKeyDown
            onTabKeyDown: ()=>void 0,
            focusInnerElement: (fromBottom)=>ctrl.focusInnerElement(fromBottom),
            forceFocusOutWhenTabGuardsAreEmpty: true,
            isEmpty: ()=>!ctrl.isFocusable()
        });
    }
    insertGridIntoDom() {
        const eGui = this.getGui();
        this.eGridDiv.appendChild(eGui);
        this.addDestroyFunc(()=>{
            eGui.remove();
            $437b23f6a393c3bf$var$_logIfDebug(this.gos, "Grid removed from DOM");
        });
    }
    updateLayoutClasses(cssClass, params) {
        const eRootWrapperBodyClassList = this.rootWrapperBody.classList;
        const { AUTO_HEIGHT: AUTO_HEIGHT, NORMAL: NORMAL, PRINT: PRINT } = $437b23f6a393c3bf$var$LayoutCssClasses;
        const { autoHeight: autoHeight, normal: normal, print: print } = params;
        eRootWrapperBodyClassList.toggle(AUTO_HEIGHT, autoHeight);
        eRootWrapperBodyClassList.toggle(NORMAL, normal);
        eRootWrapperBodyClassList.toggle(PRINT, print);
        this.toggleCss(AUTO_HEIGHT, autoHeight);
        this.toggleCss(NORMAL, normal);
        this.toggleCss(PRINT, print);
    }
    createTemplate(params) {
        const dropZones = params.gridHeaderDropZonesSelector ? {
            tag: "ag-grid-header-drop-zones"
        } : null;
        const sideBar = params.sideBarSelector ? {
            tag: "ag-side-bar",
            ref: "sideBar"
        } : null;
        const statusBar = params.statusBarSelector ? {
            tag: "ag-status-bar"
        } : null;
        const watermark = params.watermarkSelector ? {
            tag: "ag-watermark"
        } : null;
        const pagination = params.paginationSelector ? {
            tag: "ag-pagination",
            ref: "pagination"
        } : null;
        return {
            tag: "div",
            cls: "ag-root-wrapper",
            role: "presentation",
            children: [
                dropZones,
                {
                    tag: "div",
                    ref: "rootWrapperBody",
                    cls: "ag-root-wrapper-body",
                    role: "presentation",
                    children: [
                        {
                            tag: "ag-grid-body",
                            ref: "gridBody"
                        },
                        sideBar
                    ]
                },
                statusBar,
                pagination,
                watermark
            ]
        };
    }
    getFocusableElement() {
        return this.rootWrapperBody;
    }
    forceFocusOutOfContainer(up = false) {
        if (!up && this.pagination?.isDisplayed()) {
            this.pagination.forceFocusOutOfContainer(up);
            return;
        }
        super.forceFocusOutOfContainer(up);
    }
    getFocusableContainers() {
        const focusableContainers = [
            this.gridBody
        ];
        for (const comp of [
            this.sideBar,
            this.pagination
        ])if (comp) focusableContainers.push(comp);
        return focusableContainers.filter((el)=>$437b23f6a393c3bf$export$2badf4aa566524cb(el.getGui()));
    }
};
// packages/ag-grid-community/src/api/gridApiFunctions.ts
var $437b23f6a393c3bf$var$mod = (moduleName, input)=>{
    for (const key of Object.keys(input))input[key] = moduleName;
    return input;
};
var $437b23f6a393c3bf$var$gridApiFunctionsMap = {
    dispatchEvent: "CommunityCore",
    // this is always registered
    ...$437b23f6a393c3bf$var$mod("CommunityCore", {
        destroy: 0,
        getGridId: 0,
        getGridOption: 0,
        isDestroyed: 0,
        setGridOption: 0,
        updateGridOptions: 0,
        isModuleRegistered: 0
    }),
    ...$437b23f6a393c3bf$var$mod("GridState", {
        getState: 0,
        setState: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedRowSelection", {
        setNodesSelected: 0,
        selectAll: 0,
        deselectAll: 0,
        selectAllFiltered: 0,
        deselectAllFiltered: 0,
        selectAllOnCurrentPage: 0,
        deselectAllOnCurrentPage: 0,
        getSelectedNodes: 0,
        getSelectedRows: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RowApi", {
        redrawRows: 0,
        setRowNodeExpanded: 0,
        getRowNode: 0,
        addRenderedRowListener: 0,
        getRenderedNodes: 0,
        forEachNode: 0,
        getFirstDisplayedRowIndex: 0,
        getLastDisplayedRowIndex: 0,
        getDisplayedRowAtIndex: 0,
        getDisplayedRowCount: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ScrollApi", {
        getVerticalPixelRange: 0,
        getHorizontalPixelRange: 0,
        ensureColumnVisible: 0,
        ensureIndexVisible: 0,
        ensureNodeVisible: 0
    }),
    ...$437b23f6a393c3bf$var$mod("KeyboardNavigation", {
        getFocusedCell: 0,
        clearFocusedCell: 0,
        setFocusedCell: 0,
        tabToNextCell: 0,
        tabToPreviousCell: 0,
        setFocusedHeader: 0
    }),
    ...$437b23f6a393c3bf$var$mod("EventApi", {
        addEventListener: 0,
        addGlobalListener: 0,
        removeEventListener: 0,
        removeGlobalListener: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ValueCache", {
        expireValueCache: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CellApi", {
        getCellValue: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedMenu", {
        showColumnMenu: 0,
        hidePopupMenu: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Sort", {
        onSortChanged: 0
    }),
    ...$437b23f6a393c3bf$var$mod("PinnedRow", {
        getPinnedTopRowCount: 0,
        getPinnedBottomRowCount: 0,
        getPinnedTopRow: 0,
        getPinnedBottomRow: 0,
        forEachPinnedRow: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Overlay", {
        showLoadingOverlay: 0,
        showNoRowsOverlay: 0,
        hideOverlay: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RenderApi", {
        setGridAriaProperty: 0,
        refreshCells: 0,
        refreshHeader: 0,
        isAnimationFrameQueueEmpty: 0,
        flushAllAnimationFrames: 0,
        getSizesForCurrentTheme: 0,
        getCellRendererInstances: 0
    }),
    ...$437b23f6a393c3bf$var$mod("HighlightChanges", {
        flashCells: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RowDrag", {
        addRowDropZone: 0,
        removeRowDropZone: 0,
        getRowDropZoneParams: 0,
        getRowDropPositionIndicator: 0,
        setRowDropPositionIndicator: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnApi", {
        getColumnDefs: 0,
        getColumnDef: 0,
        getDisplayNameForColumn: 0,
        getColumn: 0,
        getColumns: 0,
        applyColumnState: 0,
        getColumnState: 0,
        resetColumnState: 0,
        isPinning: 0,
        isPinningLeft: 0,
        isPinningRight: 0,
        getDisplayedColAfter: 0,
        getDisplayedColBefore: 0,
        setColumnsVisible: 0,
        setColumnsPinned: 0,
        getAllGridColumns: 0,
        getDisplayedLeftColumns: 0,
        getDisplayedCenterColumns: 0,
        getDisplayedRightColumns: 0,
        getAllDisplayedColumns: 0,
        getAllDisplayedVirtualColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnAutoSize", {
        sizeColumnsToFit: 0,
        autoSizeColumns: 0,
        autoSizeAllColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnGroup", {
        setColumnGroupOpened: 0,
        getColumnGroup: 0,
        getProvidedColumnGroup: 0,
        getDisplayNameForColumnGroup: 0,
        getColumnGroupState: 0,
        setColumnGroupState: 0,
        resetColumnGroupState: 0,
        getLeftDisplayedColumnGroups: 0,
        getCenterDisplayedColumnGroups: 0,
        getRightDisplayedColumnGroups: 0,
        getAllDisplayedColumnGroups: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnMove", {
        moveColumnByIndex: 0,
        moveColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnResize", {
        setColumnWidths: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnHover", {
        isColumnHovered: 0
    }),
    ...$437b23f6a393c3bf$var$mod("EditCore", {
        getCellEditorInstances: 0,
        getEditingCells: 0,
        getEditRowValues: 0,
        stopEditing: 0,
        startEditingCell: 0,
        isEditing: 0,
        validateEdit: 0
    }),
    ...$437b23f6a393c3bf$var$mod("BatchEdit", {
        startBatchEdit: 0,
        cancelBatchEdit: 0,
        commitBatchEdit: 0,
        isBatchEditing: 0
    }),
    ...$437b23f6a393c3bf$var$mod("UndoRedoEdit", {
        undoCellEditing: 0,
        redoCellEditing: 0,
        getCurrentUndoSize: 0,
        getCurrentRedoSize: 0
    }),
    ...$437b23f6a393c3bf$var$mod("FilterCore", {
        isAnyFilterPresent: 0,
        onFilterChanged: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnFilter", {
        isColumnFilterPresent: 0,
        getColumnFilterInstance: 0,
        destroyFilter: 0,
        setFilterModel: 0,
        getFilterModel: 0,
        getColumnFilterModel: 0,
        setColumnFilterModel: 0,
        showColumnFilter: 0,
        hideColumnFilter: 0,
        getColumnFilterHandler: 0,
        doFilterAction: 0
    }),
    ...$437b23f6a393c3bf$var$mod("QuickFilter", {
        isQuickFilterPresent: 0,
        getQuickFilter: 0,
        resetQuickFilter: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Find", {
        findGetActiveMatch: 0,
        findGetTotalMatches: 0,
        findGoTo: 0,
        findNext: 0,
        findPrevious: 0,
        findGetNumMatches: 0,
        findGetParts: 0,
        findClearActive: 0,
        findRefresh: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Pagination", {
        paginationIsLastPageFound: 0,
        paginationGetPageSize: 0,
        paginationGetCurrentPage: 0,
        paginationGetTotalPages: 0,
        paginationGetRowCount: 0,
        paginationGoToNextPage: 0,
        paginationGoToPreviousPage: 0,
        paginationGoToFirstPage: 0,
        paginationGoToLastPage: 0,
        paginationGoToPage: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CsrmSsrmSharedApi", {
        expandAll: 0,
        collapseAll: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SsrmInfiniteSharedApi", {
        setRowCount: 0,
        getCacheBlockState: 0,
        isLastRowIndexKnown: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ClientSideRowModelApi", {
        onGroupExpandedOrCollapsed: 0,
        refreshClientSideRowModel: 0,
        isRowDataEmpty: 0,
        forEachLeafNode: 0,
        forEachNodeAfterFilter: 0,
        forEachNodeAfterFilterAndSort: 0,
        applyTransaction: 0,
        applyTransactionAsync: 0,
        flushAsyncTransactions: 0,
        getBestCostNodeSelection: 0,
        onRowHeightChanged: 0,
        resetRowHeights: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CsvExport", {
        getDataAsCsv: 0,
        exportDataAsCsv: 0
    }),
    ...$437b23f6a393c3bf$var$mod("InfiniteRowModel", {
        refreshInfiniteCache: 0,
        purgeInfiniteCache: 0,
        getInfiniteRowCount: 0
    }),
    ...$437b23f6a393c3bf$var$mod("AdvancedFilter", {
        getAdvancedFilterModel: 0,
        setAdvancedFilterModel: 0,
        showAdvancedFilterBuilder: 0,
        hideAdvancedFilterBuilder: 0
    }),
    ...$437b23f6a393c3bf$var$mod("IntegratedCharts", {
        getChartModels: 0,
        getChartRef: 0,
        getChartImageDataURL: 0,
        downloadChart: 0,
        openChartToolPanel: 0,
        closeChartToolPanel: 0,
        createRangeChart: 0,
        createPivotChart: 0,
        createCrossFilterChart: 0,
        updateChart: 0,
        restoreChart: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Clipboard", {
        copyToClipboard: 0,
        cutToClipboard: 0,
        copySelectedRowsToClipboard: 0,
        copySelectedRangeToClipboard: 0,
        copySelectedRangeDown: 0,
        pasteFromClipboard: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ExcelExport", {
        getDataAsExcel: 0,
        exportDataAsExcel: 0,
        getSheetDataForExcel: 0,
        getMultipleSheetsAsExcel: 0,
        exportMultipleSheetsAsExcel: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedMasterDetail", {
        addDetailGridInfo: 0,
        removeDetailGridInfo: 0,
        getDetailGridInfo: 0,
        forEachDetailGridInfo: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ContextMenu", {
        showContextMenu: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnMenu", {
        showColumnChooser: 0,
        hideColumnChooser: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CellSelection", {
        getCellRanges: 0,
        addCellRange: 0,
        clearRangeSelection: 0,
        clearCellSelection: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedRowGrouping", {
        setRowGroupColumns: 0,
        removeRowGroupColumns: 0,
        addRowGroupColumns: 0,
        getRowGroupColumns: 0,
        moveRowGroupColumn: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedAggregation", {
        addAggFuncs: 0,
        clearAggFuncs: 0,
        setColumnAggFunc: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedPivot", {
        isPivotMode: 0,
        getPivotResultColumn: 0,
        setValueColumns: 0,
        getValueColumns: 0,
        removeValueColumns: 0,
        addValueColumns: 0,
        setPivotColumns: 0,
        removePivotColumns: 0,
        addPivotColumns: 0,
        getPivotColumns: 0,
        setPivotResultColumns: 0,
        getPivotResultColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ServerSideRowModelApi", {
        getServerSideSelectionState: 0,
        setServerSideSelectionState: 0,
        applyServerSideTransaction: 0,
        applyServerSideTransactionAsync: 0,
        applyServerSideRowData: 0,
        retryServerSideLoads: 0,
        flushServerSideAsyncTransactions: 0,
        refreshServerSide: 0,
        getServerSideGroupLevelState: 0,
        onRowHeightChanged: 0,
        resetRowHeights: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SideBar", {
        isSideBarVisible: 0,
        setSideBarVisible: 0,
        setSideBarPosition: 0,
        openToolPanel: 0,
        closeToolPanel: 0,
        getOpenedToolPanel: 0,
        refreshToolPanel: 0,
        isToolPanelShowing: 0,
        getToolPanelInstance: 0,
        getSideBar: 0
    }),
    ...$437b23f6a393c3bf$var$mod("StatusBar", {
        getStatusPanel: 0
    }),
    ...$437b23f6a393c3bf$var$mod("AiToolkit", {
        getStructuredSchema: 0
    })
};
// packages/ag-grid-community/src/api/apiFunctionService.ts
var $437b23f6a393c3bf$var$defaultFns = {
    isDestroyed: ()=>true,
    destroy () {},
    preConstruct () {},
    postConstruct () {},
    preWireBeans () {},
    wireBeans () {}
};
var $437b23f6a393c3bf$var$dispatchEvent = (beans, event)=>beans.eventSvc.dispatchEvent(event);
var $437b23f6a393c3bf$var$GridApiClass = class {
};
Reflect.defineProperty($437b23f6a393c3bf$var$GridApiClass, "name", {
    value: "GridApi"
});
var $437b23f6a393c3bf$var$ApiFunctionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.beanName = "apiFunctionSvc";
        this.api = new $437b23f6a393c3bf$var$GridApiClass();
        this.fns = {
            ...$437b23f6a393c3bf$var$defaultFns,
            dispatchEvent: // dispatchEvent is used by frameworks, also used by aligned grids to identify a grid api instance
            $437b23f6a393c3bf$var$dispatchEvent
        };
        this.preDestroyLink = "";
        const { api: api } = this;
        for (const key of Object.keys($437b23f6a393c3bf$var$gridApiFunctionsMap))api[key] = this.makeApi(key)[key];
    }
    postConstruct() {
        this.preDestroyLink = this.beans.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed");
    }
    addFunction(functionName, func) {
        const { fns: fns, beans: beans } = this;
        if (fns !== $437b23f6a393c3bf$var$defaultFns) fns[functionName] = beans?.validation?.validateApiFunction(functionName, func) ?? func;
    }
    makeApi(apiName) {
        return {
            [apiName]: (...args)=>{
                const { beans: beans, fns: { [apiName]: fn } } = this;
                return fn ? fn(beans, ...args) : this.apiNotFound(apiName);
            }
        };
    }
    apiNotFound(fnName) {
        const { beans: beans, gos: gos, preDestroyLink: preDestroyLink } = this;
        if (!beans) $437b23f6a393c3bf$export$545083624300f13d(26, {
            fnName: fnName,
            preDestroyLink: preDestroyLink
        });
        else {
            const module = $437b23f6a393c3bf$var$gridApiFunctionsMap[fnName];
            if (gos.assertModuleRegistered(module, `api.${fnName}`)) $437b23f6a393c3bf$export$545083624300f13d(27, {
                fnName: fnName,
                module: module
            });
        }
    }
    destroy() {
        super.destroy();
        this.fns = $437b23f6a393c3bf$var$defaultFns;
        this.beans = null;
    }
};
// packages/ag-grid-community/src/api/coreApi.ts
function $437b23f6a393c3bf$var$getGridId(beans) {
    return beans.context.getId();
}
function $437b23f6a393c3bf$var$destroy(beans) {
    beans.gridDestroySvc.destroy();
}
function $437b23f6a393c3bf$var$isDestroyed(beans) {
    return beans.gridDestroySvc.destroyCalled;
}
function $437b23f6a393c3bf$var$getGridOption(beans, key) {
    return beans.gos.get(key);
}
function $437b23f6a393c3bf$var$setGridOption(beans, key, value) {
    $437b23f6a393c3bf$var$updateGridOptions(beans, {
        [key]: value
    });
}
function $437b23f6a393c3bf$var$updateGridOptions(beans, options) {
    beans.gos.updateGridOptions({
        options: options
    });
}
function $437b23f6a393c3bf$var$isModuleRegistered(beans, moduleName) {
    const withoutSuffix = moduleName.replace(/Module$/, "");
    return beans.gos.isModuleRegistered(withoutSuffix);
}
// packages/ag-grid-community/src/rendering/dndSourceComp.ts
var $437b23f6a393c3bf$var$DndSourceElement = {
    tag: "div",
    cls: "ag-drag-handle ag-row-drag",
    attrs: {
        draggable: "true"
    }
};
var $437b23f6a393c3bf$var$DndSourceComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(rowNode, column, eCell){
        super($437b23f6a393c3bf$var$DndSourceElement);
        this.rowNode = rowNode;
        this.column = column;
        this.eCell = eCell;
    }
    postConstruct() {
        const eGui = this.getGui();
        eGui.appendChild($437b23f6a393c3bf$export$d8feba07bf373edb("rowDrag", this.beans, null));
        this.addGuiEventListener("mousedown", (e)=>{
            e.stopPropagation();
        });
        this.addDragSource();
        this.checkVisibility();
    }
    addDragSource() {
        this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
    }
    onDragStart(dragEvent) {
        const { rowNode: rowNode, column: column, eCell: eCell, gos: gos } = this;
        const providedOnRowDrag = column.getColDef().dndSourceOnRowDrag;
        const dataTransfer = dragEvent.dataTransfer;
        dataTransfer.setDragImage(eCell, 0, 0);
        if (providedOnRowDrag) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                rowNode: rowNode,
                dragEvent: dragEvent
            });
            providedOnRowDrag(params);
        } else try {
            const jsonData = JSON.stringify(rowNode.data);
            dataTransfer.setData("application/json", jsonData);
            dataTransfer.setData("text/plain", jsonData);
        } catch (e) {}
    }
    checkVisibility() {
        const visible = this.column.isDndSource(this.rowNode);
        this.setDisplayed(visible);
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragApi.ts
function $437b23f6a393c3bf$var$addRowDropZone(beans, params) {
    beans.rowDragSvc?.rowDragFeature?.addRowDropZone(params);
}
function $437b23f6a393c3bf$var$removeRowDropZone(beans, params) {
    const activeDropTarget = beans.dragAndDrop?.findExternalZone(params.getContainer());
    if (activeDropTarget) beans.dragAndDrop?.removeDropTarget(activeDropTarget);
}
function $437b23f6a393c3bf$var$getRowDropZoneParams(beans, events) {
    return beans.rowDragSvc?.rowDragFeature?.getRowDropZone(events);
}
function $437b23f6a393c3bf$var$getRowDropPositionIndicator(beans) {
    const rowDropHighlightSvc = beans.rowDropHighlightSvc;
    return rowDropHighlightSvc ? {
        row: rowDropHighlightSvc.row,
        dropIndicatorPosition: rowDropHighlightSvc.position
    } : {
        row: null,
        dropIndicatorPosition: "none"
    };
}
function $437b23f6a393c3bf$var$setRowDropPositionIndicator(beans, params) {
    const rowDropHighlightSvc = beans.rowDropHighlightSvc;
    if (!rowDropHighlightSvc) return;
    const rowNode = params?.row;
    let position = params?.dropIndicatorPosition;
    if (position !== "above" && position !== "below" && position !== "inside") position = "none";
    const rowIndex = rowNode?.rowIndex;
    if (rowIndex === null || rowIndex === void 0 || position === "none") rowDropHighlightSvc.clear();
    else rowDropHighlightSvc.set(rowNode, position);
}
// packages/ag-grid-community/src/dragAndDrop/dragService.ts
var $437b23f6a393c3bf$var$DragService = class extends $437b23f6a393c3bf$export$746301531a60a666 {
    shouldPreventMouseEvent(mouseEvent) {
        const isEnableCellTextSelect = this.gos.get("enableCellTextSelection");
        return isEnableCellTextSelect && super.shouldPreventMouseEvent(mouseEvent);
    }
};
// packages/ag-grid-community/src/dragAndDrop/horizontalResizeService.ts
var $437b23f6a393c3bf$var$HorizontalResizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "horizontalResizeSvc";
    }
    addResizeBar(params) {
        const dragSource = {
            dragStartPixels: params.dragStartPixels || 0,
            eElement: params.eResizeBar,
            onDragStart: this.onDragStart.bind(this, params),
            onDragStop: this.onDragStop.bind(this, params),
            onDragging: this.onDragging.bind(this, params),
            onDragCancel: this.onDragStop.bind(this, params),
            includeTouch: true,
            stopPropagationForTouch: true
        };
        const { dragSvc: dragSvc } = this.beans;
        dragSvc.addDragSource(dragSource);
        const finishedWithResizeFunc = ()=>dragSvc.removeDragSource(dragSource);
        return finishedWithResizeFunc;
    }
    onDragStart(params, mouseEvent) {
        this.dragStartX = mouseEvent.clientX;
        this.setResizeIcons();
        const shiftKey = mouseEvent instanceof MouseEvent && mouseEvent.shiftKey === true;
        params.onResizeStart(shiftKey);
    }
    setResizeIcons() {
        const ctrl = this.beans.ctrlsSvc.get("gridCtrl");
        ctrl.setResizeCursor(1 /* Horizontal */ );
        ctrl.disableUserSelect(true);
    }
    onDragStop(params) {
        params.onResizeEnd(this.resizeAmount);
        this.resetIcons();
    }
    resetIcons() {
        const ctrl = this.beans.ctrlsSvc.get("gridCtrl");
        ctrl.setResizeCursor(false);
        ctrl.disableUserSelect(false);
    }
    onDragging(params, mouseEvent) {
        this.resizeAmount = mouseEvent.clientX - this.dragStartX;
        params.onResizing(this.resizeAmount);
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDragComp.ts
var $437b23f6a393c3bf$var$RowDragElement = {
    tag: "div",
    cls: "ag-drag-handle ag-row-drag",
    attrs: {
        "aria-hidden": "true"
    }
};
var $437b23f6a393c3bf$var$SKIP_ARIA_HIDDEN = {
    skipAriaHidden: true
};
var $437b23f6a393c3bf$var$RowDragComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(cellValueFn, rowNode, column, customGui, dragStartPixels, alwaysVisible = false){
        super();
        this.cellValueFn = cellValueFn;
        this.rowNode = rowNode;
        this.column = column;
        this.customGui = customGui;
        this.dragStartPixels = dragStartPixels;
        this.alwaysVisible = alwaysVisible;
        this.dragSource = null;
        this.disabled = false;
    }
    isCustomGui() {
        return this.customGui != null;
    }
    postConstruct() {
        const { beans: beans, customGui: customGui } = this;
        if (customGui) this.setDragElement(customGui, this.dragStartPixels);
        else {
            this.setTemplate($437b23f6a393c3bf$var$RowDragElement);
            this.getGui().appendChild($437b23f6a393c3bf$export$d8feba07bf373edb("rowDrag", beans, null));
            this.addDragSource();
        }
        if (!this.alwaysVisible) this.initCellDrag();
    }
    initCellDrag() {
        const { beans: beans, rowNode: rowNode } = this;
        const refreshVisibility = this.refreshVisibility.bind(this);
        this.addManagedListeners(beans.eventSvc, {
            rowDragVisibilityChanged: refreshVisibility
        });
        this.addManagedListeners(rowNode, {
            dataChanged: refreshVisibility,
            cellChanged: refreshVisibility
        });
        this.refreshVisibility();
    }
    setDragElement(dragElement, dragStartPixels) {
        this.setTemplateFromElement(dragElement, void 0, void 0, true);
        this.addDragSource(dragStartPixels);
    }
    refreshVisibility() {
        if (this.alwaysVisible) return;
        const { beans: beans, column: column, rowNode: rowNode } = this;
        const { gos: gos, dragAndDrop: dragAndDrop, rowDragSvc: rowDragSvc } = beans;
        const visibility = rowDragSvc?.visibility;
        const hide = visibility === "suppress" || visibility === "hidden" && !dragAndDrop?.hasExternalDropZones();
        let displayed = !hide;
        let visible = displayed;
        if (displayed && !this.isCustomGui() && column) {
            const rowDragProp = column.getColDef().rowDrag;
            if (rowDragProp === false) displayed = false;
            else {
                const shownSometimes = typeof rowDragProp === "function";
                visible = column.isRowDrag(rowNode);
                displayed = shownSometimes || visible;
            }
        }
        if (displayed && visible && rowNode.footer && gos.get("rowDragManaged")) {
            visible = false;
            displayed = true;
        }
        visible && (visible = displayed);
        if (!displayed) this.setDisplayed(displayed, $437b23f6a393c3bf$var$SKIP_ARIA_HIDDEN);
        if (!visible) this.setVisible(visible, $437b23f6a393c3bf$var$SKIP_ARIA_HIDDEN);
        this.setDisabled(!visible || visibility === "disabled" && !dragAndDrop?.hasExternalDropZones());
        if (displayed) this.setDisplayed(displayed, $437b23f6a393c3bf$var$SKIP_ARIA_HIDDEN);
        if (visible) this.setVisible(visible, $437b23f6a393c3bf$var$SKIP_ARIA_HIDDEN);
    }
    setDisabled(disabled) {
        if (disabled !== this.disabled) {
            this.disabled = disabled;
            this.getGui()?.classList?.toggle("ag-drag-handle-disabled", disabled);
        }
    }
    getSelectedNodes() {
        const rowNode = this.rowNode;
        const isRowDragMultiRow = this.gos.get("rowDragMultiRow");
        if (!isRowDragMultiRow) return [
            rowNode
        ];
        const selection = this.beans.selectionSvc?.getSelectedNodes() ?? [];
        return selection.indexOf(rowNode) !== -1 ? selection : [
            rowNode
        ];
    }
    getDragItem() {
        const { column: column, rowNode: rowNode } = this;
        return {
            rowNode: rowNode,
            rowNodes: this.getSelectedNodes(),
            columns: column ? [
                column
            ] : void 0,
            defaultTextValue: this.cellValueFn()
        };
    }
    addDragSource(dragStartPixels = 4) {
        if (this.dragSource) this.removeDragSource();
        if (this.gos.get("rowDragManaged") && this.rowNode.footer) return;
        const eGui = this.getGui();
        if (this.gos.get("enableCellTextSelection")) {
            this.removeMouseDownListener();
            this.mouseDownListener = this.addManagedElementListeners(eGui, {
                mousedown: (e)=>{
                    e?.preventDefault();
                }
            })[0];
        }
        const translate = this.getLocaleTextFunc();
        this.dragSource = {
            type: 2 /* RowDrag */ ,
            eElement: eGui,
            dragItemName: (draggingEvent)=>this.getDragItemName(draggingEvent, translate),
            getDragItem: ()=>this.getDragItem(),
            dragStartPixels: dragStartPixels,
            dragSourceDomDataKey: this.gos.getDomDataKey()
        };
        this.beans.dragAndDrop.addDragSource(this.dragSource, true);
    }
    getDragItemName(draggingEvent, translate) {
        const dragItem = draggingEvent?.dragItem || this.getDragItem();
        const dragItemCount = (draggingEvent?.dropTarget?.rows.length ?? dragItem.rowNodes?.length) || 1;
        const rowDragTextGetter = this.column?.getColDef()?.rowDragText ?? this.gos.get("rowDragText");
        if (rowDragTextGetter) return rowDragTextGetter(dragItem, dragItemCount);
        if (dragItemCount !== 1) return `${dragItemCount} ${translate("rowDragRows", "rows")}`;
        const value = this.cellValueFn();
        if (value) return value;
        return `1 ${translate("rowDragRow", "rows")}`;
    }
    destroy() {
        this.removeDragSource();
        this.removeMouseDownListener();
        super.destroy();
    }
    removeDragSource() {
        if (!this.dragSource) return;
        this.beans.dragAndDrop.removeDragSource(this.dragSource);
        this.dragSource = null;
    }
    removeMouseDownListener() {
        if (!this.mouseDownListener) return;
        this.mouseDownListener();
        this.mouseDownListener = void 0;
    }
};
// packages/ag-grid-community/src/utils/changedPath.ts
var $437b23f6a393c3bf$export$cb4d9114a9732e85 = class {
    constructor(keepingColumns, rootNode){
        // whether changed path is active of not. it is active when a) doing
        // a transaction update or b) doing change detection. if we are doing
        // a CSRM refresh for other reasons (after sort or filter, or user calling
        // setRowData() without delta mode) then we are not active. we are also
        // marked as not active if secondary columns change in pivot (as this impacts
        // aggregations).
        // can be set inactive by:
        // a) ClientSideRowModel, if no transactions or
        // b) PivotService, if secondary columns changed
        this.active = true;
        // for each node in the change path, we also store which columns need
        // to be re-aggregated.
        this.nodeIdsToColumns = {};
        // for quick lookup, all items in the change path are mapped by nodeId
        this.mapToItems = {};
        this.keepingColumns = keepingColumns;
        this.pathRoot = {
            rowNode: rootNode,
            children: null
        };
        this.mapToItems[rootNode.id] = this.pathRoot;
    }
    depthFirstSearchChangedPath(pathItem, callback) {
        const { rowNode: rowNode, children: children } = pathItem;
        if (children) for(let i = 0; i < children.length; ++i)this.depthFirstSearchChangedPath(children[i], callback);
        callback(rowNode);
    }
    depthFirstSearchEverything(rowNode, callback, traverseEverything) {
        const childrenAfterGroup = rowNode.childrenAfterGroup;
        if (childrenAfterGroup) for(let i = 0, len = childrenAfterGroup.length; i < len; ++i){
            const childNode = childrenAfterGroup[i];
            if (childNode.childrenAfterGroup) this.depthFirstSearchEverything(childNode, callback, traverseEverything);
            else if (traverseEverything) callback(childNode);
        }
        callback(rowNode);
    }
    // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
    // will be called for child nodes in addition to parent nodes.
    forEachChangedNodeDepthFirst(callback, traverseLeafNodes = false, includeUnchangedNodes = false) {
        if (this.active && !includeUnchangedNodes) this.depthFirstSearchChangedPath(this.pathRoot, callback);
        else this.depthFirstSearchEverything(this.pathRoot.rowNode, callback, traverseLeafNodes);
    }
    executeFromRootNode(callback) {
        callback(this.pathRoot.rowNode);
    }
    createPathItems(rowNode) {
        let pointer = rowNode;
        let newEntryCount = 0;
        while(!this.mapToItems[pointer.id]){
            const newEntry = {
                rowNode: pointer,
                children: null
            };
            this.mapToItems[pointer.id] = newEntry;
            newEntryCount++;
            pointer = pointer.parent;
        }
        return newEntryCount;
    }
    populateColumnsMap(rowNode, columns) {
        if (!this.keepingColumns || !columns) return;
        let pointer = rowNode;
        while(pointer){
            if (!this.nodeIdsToColumns[pointer.id]) this.nodeIdsToColumns[pointer.id] = {};
            for (const col of columns)this.nodeIdsToColumns[pointer.id][col.getId()] = true;
            pointer = pointer.parent;
        }
    }
    linkPathItems(rowNode, newEntryCount) {
        let pointer = rowNode;
        for(let i = 0; i < newEntryCount; i++){
            const thisItem = this.mapToItems[pointer.id];
            const parentItem = this.mapToItems[pointer.parent.id];
            if (!parentItem.children) parentItem.children = [];
            parentItem.children.push(thisItem);
            pointer = pointer.parent;
        }
    }
    // called by
    // 1) change detection (provides cols) and
    // 2) groupStage if doing transaction update (doesn't provide cols)
    addParentNode(rowNode, columns) {
        if (!rowNode || rowNode.isRowPinned()) return;
        const newEntryCount = this.createPathItems(rowNode);
        this.linkPathItems(rowNode, newEntryCount);
        this.populateColumnsMap(rowNode, columns);
    }
    canSkip(rowNode) {
        return this.active && !this.mapToItems[rowNode.id];
    }
    getValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return valueColumns;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>colsForThisNode[col.getId()]);
        return result;
    }
    getNotValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return null;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>!colsForThisNode[col.getId()]);
        return result;
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDragFeature.ts
var $437b23f6a393c3bf$var$POINTER_INSIDE_THRESHOLD = 0.25;
var $437b23f6a393c3bf$var$RowDragFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eContainer){
        super();
        this.eContainer = eContainer;
        this.lastDraggingEvent = null;
        this.autoScroll = null;
        this.autoScrollChanged = false;
        this.autoScrollChanging = false;
        this.autoScrollOldV = null;
    }
    postConstruct() {
        const beans = this.beans;
        beans.ctrlsSvc.whenReady(this, (p)=>{
            const getScrollY = ()=>p.gridBodyCtrl.scrollFeature.getVScrollPosition().top;
            const autoScroll = new $437b23f6a393c3bf$export$c66bdc3d55a4f95({
                scrollContainer: p.gridBodyCtrl.eBodyViewport,
                scrollAxis: "y",
                getVerticalPosition: getScrollY,
                setVerticalPosition: (position)=>p.gridBodyCtrl.scrollFeature.setVerticalScrollPosition(position),
                onScrollCallback: ()=>{
                    const newVScroll = getScrollY();
                    if (this.autoScrollOldV !== newVScroll) {
                        this.autoScrollOldV = newVScroll;
                        this.autoScrollChanging = true;
                        return;
                    }
                    const changed = this.autoScrollChanging;
                    this.autoScrollChanged = changed;
                    this.autoScrollChanging = false;
                    if (changed) {
                        beans.dragAndDrop?.nudge();
                        this.autoScrollChanged = false;
                    }
                }
            });
            this.autoScroll = autoScroll;
            this.clearAutoScroll();
        });
    }
    destroy() {
        super.destroy();
        this.clearAutoScroll();
        this.autoScroll = null;
        this.lastDraggingEvent = null;
        this.eContainer = null;
    }
    getContainer() {
        return this.eContainer;
    }
    isInterestedIn(type) {
        return type === 2 /* RowDrag */ ;
    }
    getIconName(draggingEvent) {
        if (draggingEvent?.dropTarget?.allowed === false) return "notAllowed";
        if (this.beans.rowDragSvc.visibility !== "visible") return "notAllowed";
        return "move";
    }
    getRowNodes(draggingEvent) {
        if (!this.isFromThisGrid(draggingEvent)) return draggingEvent.dragItem.rowNodes || [];
        const currentNode = draggingEvent.dragItem.rowNode;
        if (this.gos.get("rowDragMultiRow")) {
            const selectedNodes = this.beans.selectionSvc?.getSelectedNodes();
            if (selectedNodes && selectedNodes.indexOf(currentNode) >= 0) return selectedNodes.slice().sort($437b23f6a393c3bf$var$compareRowIndex);
        }
        return [
            currentNode
        ];
    }
    onDragEnter(draggingEvent) {
        this.dragging(draggingEvent, true);
    }
    onDragging(draggingEvent) {
        this.dragging(draggingEvent, false);
    }
    dragging(draggingEvent, enter) {
        const { lastDraggingEvent: lastDraggingEvent, beans: beans } = this;
        if (enter) {
            const rowNodes = this.getRowNodes(draggingEvent);
            draggingEvent.dragItem.rowNodes = rowNodes;
            $437b23f6a393c3bf$var$setRowNodesDragging(rowNodes, true);
        }
        this.lastDraggingEvent = draggingEvent;
        const fromNudge = draggingEvent.fromNudge;
        const rowsDrop = this.makeRowsDrop(lastDraggingEvent, draggingEvent, fromNudge, false);
        beans.rowDropHighlightSvc?.fromDrag(draggingEvent);
        if (enter) this.dispatchGridEvent("rowDragEnter", draggingEvent);
        this.dispatchGridEvent("rowDragMove", draggingEvent);
        const autoScroll = this.autoScroll;
        if (rowsDrop?.rowDragManaged && rowsDrop.moved && rowsDrop.allowed && rowsDrop.sameGrid && !rowsDrop.suppressMoveWhenRowDragging && // Avoid flickering by only dropping while auto-scrolling is not happening
        (!fromNudge && !autoScroll?.scrolling || this.autoScrollChanged)) this.dropRows(rowsDrop);
        autoScroll?.check(draggingEvent.event);
    }
    isFromThisGrid(draggingEvent) {
        return draggingEvent.dragSource.dragSourceDomDataKey === this.gos.getDomDataKey();
    }
    makeRowsDrop(lastDraggingEvent, draggingEvent, fromNudge, dropping) {
        const { beans: beans, gos: gos } = this;
        const rowsDrop = this.newRowsDrop(draggingEvent, dropping);
        const rowModel = beans.rowModel;
        draggingEvent.dropTarget = rowsDrop;
        draggingEvent.changed = false;
        if (!rowsDrop) return null;
        let { sameGrid: sameGrid, rootNode: rootNode, source: source, target: target } = rowsDrop;
        target ?? (target = rowModel.getRow(rowModel.getRowCount() - 1) ?? null);
        const groupEditSvc = this.beans.groupEditSvc;
        const canSetParent = !!groupEditSvc?.canSetParent(rowsDrop);
        let newParent = null;
        if (target?.footer) {
            const found = $437b23f6a393c3bf$export$c2c097fde6ba0eab(rowModel, -1, target) ?? $437b23f6a393c3bf$export$c2c097fde6ba0eab(rowModel, 1, target);
            if (canSetParent) newParent = target.sibling ?? rootNode;
            target = found ?? null;
        }
        if (target?.detail) target = target.parent;
        rowsDrop.moved && (rowsDrop.moved = source !== target);
        let yDelta = 0.5;
        if (target) {
            if (sameGrid && rowsDrop.moved && (newParent || !canSetParent)) yDelta = source.rowIndex > target.rowIndex ? -0.5 : 0.5;
            else yDelta = (rowsDrop.y - target.rowTop - target.rowHeight / 2) / target.rowHeight || 0;
        }
        if (!canSetParent && sameGrid && target && rowsDrop.moved && $437b23f6a393c3bf$export$9f182d9ca737e15(gos)) {
            const newTarget = $437b23f6a393c3bf$var$deltaDraggingTarget(rowModel, rowsDrop);
            if (newTarget) {
                yDelta = source.rowIndex > newTarget.rowIndex ? -0.5 : 0.5;
                target = newTarget;
                rowsDrop.moved && (rowsDrop.moved = source !== target);
            }
        }
        rowsDrop.target = target;
        rowsDrop.newParent = newParent;
        rowsDrop.pointerPos = $437b23f6a393c3bf$var$computePointerPos(target, rowsDrop.y);
        rowsDrop.yDelta = yDelta;
        groupEditSvc?.fixRowsDrop(rowsDrop, canSetParent, fromNudge, yDelta);
        this.validateRowsDrop(rowsDrop, canSetParent, dropping);
        draggingEvent.changed || (draggingEvent.changed = $437b23f6a393c3bf$var$rowsDropChanged(lastDraggingEvent?.dropTarget, rowsDrop));
        return rowsDrop;
    }
    newRowsDrop(draggingEvent, dropping) {
        const { beans: beans, gos: gos } = this;
        const rootNode = beans.rowModel.rootNode;
        const rowDragManaged = $437b23f6a393c3bf$export$9f182d9ca737e15(gos) ? gos.get("rowDragManaged") : false;
        const suppressMoveWhenRowDragging = gos.get("suppressMoveWhenRowDragging");
        const sameGrid = this.isFromThisGrid(draggingEvent);
        let { rowNode: source, rowNodes: rows } = draggingEvent.dragItem;
        rows || (rows = source ? [
            source
        ] : []);
        source || (source = rows[0]);
        if (!source || !rootNode) return null;
        const withinGrid = this.beans.dragAndDrop.isDropZoneWithinThisGrid(draggingEvent);
        let allowed = true;
        if (rowDragManaged && (!rows.length || beans.rowDragSvc.visibility !== "visible" || (suppressMoveWhenRowDragging || !sameGrid) && !withinGrid)) allowed = false;
        const y = $437b23f6a393c3bf$export$530c24bdfacb8cd1(beans, draggingEvent).y;
        const overNode = this.getOverNode(y);
        return {
            api: beans.gridApi,
            context: beans.gridOptions.context,
            draggingEvent: draggingEvent,
            rowDragManaged: rowDragManaged,
            suppressMoveWhenRowDragging: suppressMoveWhenRowDragging,
            sameGrid: sameGrid,
            withinGrid: withinGrid,
            treeData: false,
            rootNode: rootNode,
            moved: source !== overNode,
            y: y,
            overNode: overNode,
            overIndex: overNode?.rowIndex ?? -1,
            pointerPos: "none",
            position: "none",
            source: source,
            target: overNode ?? null,
            newParent: null,
            rows: rows,
            allowed: allowed,
            highlight: !dropping && rowDragManaged && suppressMoveWhenRowDragging && (withinGrid || !sameGrid),
            yDelta: 0,
            inside: false,
            droppedManaged: false
        };
    }
    validateRowsDrop(rowsDrop, canSetParent, dropping) {
        const { source: source, target: target, yDelta: yDelta, inside: inside, moved: moved, rowDragManaged: rowDragManaged, suppressMoveWhenRowDragging: suppressMoveWhenRowDragging } = rowsDrop;
        rowsDrop.moved && (rowsDrop.moved = source !== target);
        const { position: position, fallbackPosition: fallbackPosition } = this.computeDropPosition(moved, inside, yDelta);
        rowsDrop.position = position;
        if (!canSetParent) rowsDrop.newParent = null;
        this.enforceSuppressMoveWhenRowDragging(rowsDrop, suppressMoveWhenRowDragging, "initial");
        const isRowValidDropPosition = (!rowDragManaged || rowsDrop.allowed) && this.gos.get("isRowValidDropPosition");
        if (isRowValidDropPosition) this.applyDropValidator(rowsDrop, canSetParent, dropping, rowDragManaged, isRowValidDropPosition);
        if (rowDragManaged) rowsDrop.rows = this.filterRows(rowsDrop);
        this.beans.groupEditSvc?.clearNewSameParent(rowsDrop, canSetParent);
        this.enforceSuppressMoveWhenRowDragging(rowsDrop, suppressMoveWhenRowDragging, "final");
        if (rowsDrop.position === "inside" && (!rowsDrop.allowed || !rowsDrop.newParent)) rowsDrop.position = fallbackPosition;
    }
    computeDropPosition(moved, inside, yDelta) {
        const fallbackPosition = yDelta < 0 ? "above" : "below";
        if (!moved) return {
            position: "none",
            fallbackPosition: fallbackPosition
        };
        return {
            position: inside ? "inside" : fallbackPosition,
            fallbackPosition: fallbackPosition
        };
    }
    enforceSuppressMoveWhenRowDragging(rowsDrop, suppress, stage) {
        if (!suppress) return;
        if (stage === "initial") {
            if (!rowsDrop.moved) rowsDrop.allowed = false;
            return;
        }
        if (!rowsDrop.rows.length || rowsDrop.position === "none") rowsDrop.allowed = false;
    }
    applyDropValidator(rowsDrop, canSetParent, dropping, rowDragManaged, validator) {
        this.beans.groupEditSvc?.clearNewSameParent(rowsDrop, canSetParent);
        const result = validator(rowsDrop);
        if (!result) {
            rowsDrop.allowed = false;
            return;
        }
        if (typeof result !== "object") return;
        if (result.rows !== void 0) rowsDrop.rows = result.rows ?? [];
        if (canSetParent && result.newParent !== void 0) rowsDrop.newParent = result.newParent;
        if (result.target !== void 0) rowsDrop.target = result.target;
        if (result.position) rowsDrop.position = result.position;
        if (result.allowed !== void 0) rowsDrop.allowed = result.allowed;
        else if (!rowDragManaged) rowsDrop.allowed = true;
        const draggingEvent = rowsDrop.draggingEvent;
        if (result.changed && draggingEvent) draggingEvent.changed = true;
        if (!dropping && result.highlight !== void 0) rowsDrop.highlight = result.highlight;
    }
    addRowDropZone(params) {
        if (!params.getContainer()) {
            $437b23f6a393c3bf$export$545083624300f13d(55);
            return;
        }
        const dragAndDrop = this.beans.dragAndDrop;
        if (dragAndDrop.findExternalZone(params.getContainer())) {
            $437b23f6a393c3bf$export$545083624300f13d(56);
            return;
        }
        const processedParams = params.fromGrid ? params : {
            getContainer: params.getContainer,
            onDragEnter: params.onDragEnter && ((e)=>params.onDragEnter(this.rowDragEvent("rowDragEnter", e))),
            onDragLeave: params.onDragLeave && ((e)=>params.onDragLeave(this.rowDragEvent("rowDragLeave", e))),
            onDragging: params.onDragging && ((e)=>params.onDragging(this.rowDragEvent("rowDragMove", e))),
            onDragStop: params.onDragStop && ((e)=>params.onDragStop(this.rowDragEvent("rowDragEnd", e))),
            onDragCancel: params.onDragCancel && ((e)=>params.onDragCancel(this.rowDragEvent("rowDragCancel", e)))
        };
        const dropTarget = {
            isInterestedIn: (type)=>type === 2 /* RowDrag */ ,
            getIconName: ()=>"move",
            external: true,
            ...processedParams
        };
        dragAndDrop.addDropTarget(dropTarget);
        this.addDestroyFunc(()=>dragAndDrop.removeDropTarget(dropTarget));
    }
    getRowDropZone(events) {
        const result = {
            getContainer: this.getContainer.bind(this),
            onDragEnter: (e)=>{
                this.onDragEnter(e);
                events?.onDragEnter?.(this.rowDragEvent("rowDragEnter", e));
            },
            onDragLeave: (e)=>{
                this.onDragLeave(e);
                events?.onDragLeave?.(this.rowDragEvent("rowDragLeave", e));
            },
            onDragging: (e)=>{
                this.onDragging(e);
                events?.onDragging?.(this.rowDragEvent("rowDragMove", e));
            },
            onDragStop: (e)=>{
                this.onDragStop(e);
                events?.onDragStop?.(this.rowDragEvent("rowDragEnd", e));
            },
            onDragCancel: (e)=>{
                this.onDragCancel(e);
                events?.onDragCancel?.(this.rowDragEvent("rowDragCancel", e));
            },
            fromGrid: true
        };
        return result;
    }
    getOverNode(y) {
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const mouseIsPastLastRow = y > pageBounds.getCurrentPagePixelRange().pageLastPixel;
        const overIndex = mouseIsPastLastRow ? -1 : rowModel.getRowIndexAtPixel(y);
        return overIndex >= 0 ? rowModel.getRow(overIndex) : void 0;
    }
    rowDragEvent(type, draggingEvent) {
        const beans = this.beans;
        const { dragItem: dragItem, dropTarget: rowsDrop, event: event, vDirection: vDirection } = draggingEvent;
        const withRowsDrop = rowsDrop?.rootNode === beans.rowModel.rootNode;
        const y = withRowsDrop ? rowsDrop.y : $437b23f6a393c3bf$export$530c24bdfacb8cd1(beans, draggingEvent).y;
        const overNode = withRowsDrop ? rowsDrop.overNode : this.getOverNode(y);
        const overIndex = withRowsDrop ? rowsDrop.overIndex : overNode?.rowIndex ?? -1;
        return {
            api: beans.gridApi,
            context: beans.gridOptions.context,
            type: type,
            event: event,
            node: dragItem.rowNode,
            nodes: dragItem.rowNodes,
            overIndex: overIndex,
            overNode: overNode,
            y: y,
            vDirection: vDirection,
            rowsDrop: rowsDrop
        };
    }
    dispatchGridEvent(type, draggingEvent) {
        const event = this.rowDragEvent(type, draggingEvent);
        this.eventSvc.dispatchEvent(event);
    }
    onDragLeave(draggingEvent) {
        this.dispatchGridEvent("rowDragLeave", draggingEvent);
        this.stopDragging(draggingEvent, false);
    }
    onDragStop(draggingEvent) {
        const previousRowsDrop = this.lastDraggingEvent?.dropTarget ?? null;
        const rowsDrop = this.makeRowsDrop(this.lastDraggingEvent, draggingEvent, false, true);
        this.dispatchGridEvent("rowDragEnd", draggingEvent);
        if (rowsDrop?.allowed && rowsDrop.rowDragManaged && (!previousRowsDrop?.droppedManaged || $437b23f6a393c3bf$var$rowsDropChanged(previousRowsDrop, rowsDrop))) this.dropRows(rowsDrop);
        this.stopDragging(draggingEvent, true);
    }
    onDragCancel(draggingEvent) {
        this.dispatchGridEvent("rowDragCancel", draggingEvent);
        this.stopDragging(draggingEvent, true);
    }
    stopDragging(draggingEvent, final) {
        this.clearAutoScroll();
        this.beans.groupEditSvc?.stopDragging(final);
        this.beans.rowDropHighlightSvc?.fromDrag(null);
        $437b23f6a393c3bf$var$setRowNodesDragging(draggingEvent.dragItem.rowNodes, false);
        this.lastDraggingEvent = null;
    }
    clearAutoScroll() {
        this.autoScroll?.ensureCleared();
        this.autoScrollChanged = false;
        this.autoScrollChanging = false;
        this.autoScrollOldV = null;
    }
    /** Drag and drop. Returns false if at least a row was moved, otherwise true */ dropRows(rowsDrop) {
        rowsDrop.droppedManaged = true;
        return rowsDrop.sameGrid ? this.csrmMoveRows(rowsDrop) : this.csrmAddRows(rowsDrop);
    }
    csrmAddRows({ position: position, target: target, rows: rows }) {
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const clientSideRowModel = this.beans.rowModel;
        const add = rows.filter(({ data: data, rowPinned: rowPinned })=>!clientSideRowModel.getRowNode(getRowIdFunc?.({
                data: data,
                level: 0,
                rowPinned: rowPinned
            }) ?? data.id)).map(({ data: data })=>data);
        if (add.length === 0) return false;
        let addIndex;
        if (target) {
            const leaf = target.sourceRowIndex >= 0 ? target : $437b23f6a393c3bf$export$600fb6a3864e66ca(target);
            if (leaf) addIndex = leaf.sourceRowIndex + (position === "above" ? 0 : 1);
        }
        clientSideRowModel.updateRowData({
            add: add,
            addIndex: addIndex
        });
        return true;
    }
    filterRows(rowsDrop) {
        const { groupEditSvc: groupEditSvc } = this.beans;
        const { rows: rows, sameGrid: sameGrid } = rowsDrop;
        let filtered;
        for(let i = 0, len = rows.length; i < len; ++i){
            let valid = true;
            const row = rows[i];
            if (!row || row.footer || sameGrid && row.destroyed && !row.group || !this.csrmGetLeaf(row)) valid = false;
            if (valid && groupEditSvc && !groupEditSvc.canDropRow(row, rowsDrop)) valid = false;
            if (valid) filtered?.push(row);
            else filtered ?? (filtered = rows.slice(0, i));
        }
        return filtered ?? rows;
    }
    csrmMoveRows(rowsDrop) {
        const groupEditSvc = this.beans.groupEditSvc;
        if (groupEditSvc?.isGroupingDrop(rowsDrop)) return groupEditSvc.dropGroupEdit(rowsDrop);
        return this.csrmMoveRowsReorder(rowsDrop);
    }
    csrmMoveRowsReorder({ position: position, target: target, rows: rows, newParent: newParent, rootNode: rootNode }) {
        let changed = false;
        const leafs = /* @__PURE__ */ new Set();
        for (const row of rows){
            if (newParent && row.parent !== newParent) {
                row.treeParent = newParent;
                changed = true;
            }
            const leafRow = this.csrmGetLeaf(row);
            if (leafRow) leafs.add(leafRow);
        }
        if (!changed && leafs.size === 0) return false;
        const focusSvc = this.beans.focusSvc;
        const cellPosition = focusSvc.getFocusedCell();
        const cellCtrl = cellPosition && $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cellPosition);
        if (leafs.size && $437b23f6a393c3bf$export$bdac36eff8582fbb(rootNode._leafs, leafs, target, position === "above")) changed = true;
        if (!changed) return false;
        const clientSideRowModel = this.beans.rowModel;
        const changedRowNodes = new $437b23f6a393c3bf$export$31d871bfcf904e4b();
        changedRowNodes.reordered = true;
        clientSideRowModel.refreshModel({
            step: "group",
            keepRenderedRows: true,
            animate: !this.gos.get("suppressAnimationFrame"),
            changedPath: new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, rootNode),
            changedRowNodes: changedRowNodes
        });
        if (cellCtrl) cellCtrl.focusCell();
        else focusSvc.clearFocusedCell();
        return true;
    }
    csrmGetLeaf(row) {
        if (row.sourceRowIndex >= 0) return row.destroyed ? void 0 : row;
        const groupEditSvc = this.beans.groupEditSvc;
        if (groupEditSvc) return groupEditSvc.csrmFirstLeaf(row);
        return $437b23f6a393c3bf$export$600fb6a3864e66ca(row);
    }
};
var $437b23f6a393c3bf$var$rowsDropChanged = (a, b)=>a !== b && (!a || a.sameGrid !== b.sameGrid || a.allowed !== b.allowed || a.position !== b.position || a.target !== b.target || a.source !== b.source || a.newParent !== b.newParent || !$437b23f6a393c3bf$export$893967cdb9833fdd(a.rows, b.rows));
var $437b23f6a393c3bf$var$compareRowIndex = ({ rowIndex: a }, { rowIndex: b })=>a !== null && b !== null ? a - b : 0;
var $437b23f6a393c3bf$var$setRowNodesDragging = (rowNodes, dragging)=>{
    for(let i = 0, len = rowNodes?.length || 0; i < len; ++i){
        const rowNode = rowNodes[i];
        if (rowNode.dragging !== dragging) {
            rowNode.dragging = dragging;
            rowNode.dispatchRowEvent("draggingChanged");
        }
    }
};
var $437b23f6a393c3bf$var$deltaDraggingTarget = (rowModel, rowsDrop)=>{
    let bestTarget = null;
    let current = rowsDrop.target;
    if (current && rowsDrop.rows.indexOf(current) < 0) return null;
    const source = rowsDrop.source;
    if (!current || !source) return null;
    let count = current.rowIndex - source.rowIndex;
    const increment = count < 0 ? -1 : 1;
    count = rowsDrop.suppressMoveWhenRowDragging ? Math.abs(count) : 1;
    const rowsSet = new Set(rowsDrop.rows);
    do {
        const candidate = $437b23f6a393c3bf$export$c2c097fde6ba0eab(rowModel, increment, current);
        if (!candidate) break;
        if (!rowsSet.has(candidate)) {
            bestTarget = candidate;
            --count;
        }
        current = candidate;
    }while (count > 0);
    return bestTarget;
};
var $437b23f6a393c3bf$var$computePointerPos = (overNode, pointerY)=>{
    const rowTop = overNode?.rowTop;
    const rowHeight = overNode?.rowHeight ?? 0;
    if (rowTop == null || !rowHeight || rowHeight <= 0) return "none";
    const offset = pointerY - rowTop;
    const thresholdPx = rowHeight * $437b23f6a393c3bf$var$POINTER_INSIDE_THRESHOLD;
    if (offset <= thresholdPx) return "above";
    if (offset >= rowHeight - thresholdPx) return "below";
    return "inside";
};
// packages/ag-grid-community/src/dragAndDrop/rowDragService.ts
var $437b23f6a393c3bf$var$RowDragService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowDragSvc";
        this.rowDragFeature = null;
        this.visibility = "suppress";
    }
    setupRowDrag(element, ctrl) {
        const rowDragFeature = ctrl.createManagedBean(new $437b23f6a393c3bf$var$RowDragFeature(element));
        const dragAndDrop = this.beans.dragAndDrop;
        dragAndDrop.addDropTarget(rowDragFeature);
        ctrl.addDestroyFunc(()=>dragAndDrop.removeDropTarget(rowDragFeature));
        this.rowDragFeature = rowDragFeature;
        const refreshVisibility = ()=>this.refreshVisibility();
        this.addManagedPropertyListeners([
            "rowDragManaged",
            "suppressRowDrag",
            "refreshAfterGroupEdit"
        ], refreshVisibility);
        this.addManagedEventListeners({
            newColumnsLoaded: refreshVisibility,
            columnRowGroupChanged: refreshVisibility,
            columnPivotModeChanged: refreshVisibility,
            sortChanged: refreshVisibility,
            filterChanged: refreshVisibility
        });
        this.visibility = this.computeVisibility();
    }
    createRowDragComp(cellValueFn, rowNode, column, customGui, dragStartPixels, alwaysVisible) {
        return new $437b23f6a393c3bf$var$RowDragComp(cellValueFn, rowNode, column, customGui, dragStartPixels, alwaysVisible);
    }
    createRowDragCompForRow(rowNode, element) {
        if ($437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos)) return void 0;
        const translate = this.getLocaleTextFunc();
        return this.createRowDragComp(()=>`1 ${translate("rowDragRow", "row")}`, rowNode, void 0, element, void 0, true);
    }
    createRowDragCompForCell(rowNode, column, cellValueFn, element, dragStartPixels, alwaysVisible) {
        const gos = this.gos;
        if (gos.get("rowDragManaged")) {
            if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos) || gos.get("pagination")) return void 0;
        }
        const rowDragComp = this.createRowDragComp(cellValueFn, rowNode, column, element, dragStartPixels, alwaysVisible);
        return rowDragComp;
    }
    cancelRowDrag() {
        if (this.rowDragFeature?.lastDraggingEvent) this.beans.dragSvc?.cancelDrag();
    }
    computeVisibility() {
        const beans = this.beans;
        const gos = beans.gos;
        if (gos.get("suppressRowDrag")) return "suppress";
        const rowDragManaged = gos.get("rowDragManaged");
        if (!rowDragManaged) return "visible";
        const pivoting = beans.colModel.isPivotMode();
        if ((pivoting || beans.rowGroupColsSvc?.columns?.length) && !gos.get("refreshAfterGroupEdit")) return "hidden";
        if (pivoting) return "disabled";
        if (beans.filterManager?.isAnyFilterPresent()) return "disabled";
        if (beans.sortSvc?.isSortActive()) return "disabled";
        return "visible";
    }
    refreshVisibility() {
        const previousVisibility = this.visibility;
        const newVisibility = this.computeVisibility();
        if (previousVisibility !== newVisibility) {
            this.visibility = newVisibility;
            this.eventSvc?.dispatchEvent({
                type: "rowDragVisibilityChanged"
            });
        }
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDropHighlightService.ts
var $437b23f6a393c3bf$var$RowDropHighlightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowDropHighlightSvc";
        this.uiLevel = 0;
        this.dragging = false;
        this.row = null;
        this.position = "none";
    }
    postConstruct() {
        this.addManagedEventListeners({
            modelUpdated: this.onModelUpdated.bind(this)
        });
    }
    onModelUpdated() {
        const row = this.row;
        const oldDragging = this.dragging;
        if (!row || row?.rowIndex === null || this.position === "none") this.clear();
        else this.set(row, this.position);
        this.dragging = oldDragging;
    }
    destroy() {
        this.clear();
        super.destroy();
    }
    clear() {
        const last = this.row;
        this.dragging = false;
        if (last) {
            this.uiLevel = 0;
            this.position = "none";
            this.row = null;
            last.dispatchRowEvent("rowHighlightChanged");
        }
    }
    set(row, dropIndicatorPosition) {
        const nodeChanged = row !== this.row;
        const uiLevel = row.uiLevel;
        const highlightChanged = dropIndicatorPosition !== this.position;
        const uiLevelChanged = uiLevel !== this.uiLevel;
        this.dragging = false;
        if (nodeChanged || highlightChanged || uiLevelChanged) {
            if (nodeChanged) this.clear();
            this.uiLevel = uiLevel;
            this.position = dropIndicatorPosition;
            this.row = row;
            row.dispatchRowEvent("rowHighlightChanged");
        }
    }
    fromDrag(draggingEvent) {
        const rowsDrop = draggingEvent?.dropTarget;
        if (rowsDrop) {
            const { highlight: highlight, target: target, position: position } = rowsDrop;
            if (highlight && target && position !== "none") {
                this.set(target, position);
                this.dragging = true;
                return;
            }
        }
        if (this.dragging) this.clear();
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragModule.ts
var $437b23f6a393c3bf$export$e88a21946d283d22 = {
    moduleName: "Drag",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DragService
    ]
};
var $437b23f6a393c3bf$export$b9bac28848e60126 = {
    moduleName: "DragAndDrop",
    version: $437b23f6a393c3bf$var$VERSION,
    dynamicBeans: {
        dndSourceComp: $437b23f6a393c3bf$var$DndSourceComp
    },
    icons: {
        // drag handle used to pick up draggable rows
        rowDrag: "grip"
    }
};
var $437b23f6a393c3bf$export$4ad116d131ade5b4 = {
    moduleName: "SharedDragAndDrop",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DragAndDropService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$e88a21946d283d22
    ],
    userComponents: {
        agDragAndDropImage: $437b23f6a393c3bf$var$DragAndDropImageComponent2
    },
    icons: {
        // shown on drag and drop image component icon while dragging column to the side of the grid to pin
        columnMovePin: "pin",
        // shown on drag and drop image component icon while dragging over part of the page that is not a drop zone
        columnMoveHide: "eye-slash",
        // shown on drag and drop image component icon while dragging columns to reorder
        columnMoveMove: "arrows",
        // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
        columnMoveLeft: "left",
        // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
        columnMoveRight: "right",
        // shown on drag and drop image component icon while dragging over Row Groups drop zone
        columnMoveGroup: "group",
        // shown on drag and drop image component icon while dragging over Values drop zone
        columnMoveValue: "aggregation",
        // shown on drag and drop image component icon while dragging over pivot drop zone
        columnMovePivot: "pivot",
        // shown on drag and drop image component icon while dragging over drop zone that doesn't support it, e.g.
        // string column over aggregation drop zone
        dropNotAllowed: "not-allowed",
        // drag handle used to pick up draggable rows
        rowDrag: "grip"
    }
};
var $437b23f6a393c3bf$export$49c914873cdbe391 = {
    moduleName: "RowDrag",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowDropHighlightService,
        $437b23f6a393c3bf$var$RowDragService
    ],
    apiFunctions: {
        addRowDropZone: $437b23f6a393c3bf$var$addRowDropZone,
        removeRowDropZone: $437b23f6a393c3bf$var$removeRowDropZone,
        getRowDropZoneParams: $437b23f6a393c3bf$var$getRowDropZoneParams,
        getRowDropPositionIndicator: $437b23f6a393c3bf$var$getRowDropPositionIndicator,
        setRowDropPositionIndicator: $437b23f6a393c3bf$var$setRowDropPositionIndicator
    },
    dependsOn: [
        $437b23f6a393c3bf$export$4ad116d131ade5b4
    ]
};
var $437b23f6a393c3bf$export$57b5b4ab4a8a663e = {
    moduleName: "HorizontalResize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$HorizontalResizeService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$e88a21946d283d22
    ]
};
// packages/ag-grid-community/src/columnMove/column-moving.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnMovingCSS = /*css*/ `:where(.ag-ltr) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:left .2s}.ag-header-group-cell{transition:left .2s,width .2s}}:where(.ag-rtl) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:right .2s}.ag-header-group-cell{transition:right .2s,width .2s}}`;
// packages/ag-grid-community/src/columnMove/columnAnimationService.ts
var $437b23f6a393c3bf$var$ColumnAnimationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colAnimation";
        this.executeNextFuncs = [];
        this.executeLaterFuncs = [];
        this.active = false;
        // activeNext starts with active but it is reset earlier after the nextFuncs are cleared
        // to prevent calls made to executeNextVMTurn from queuing functions after executeNextFuncs has already been flushed,
        this.activeNext = false;
        this.suppressAnimation = false;
        this.animationThreadCount = 0;
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>this.gridBodyCtrl = p.gridBodyCtrl);
    }
    isActive() {
        return this.active && !this.suppressAnimation;
    }
    setSuppressAnimation(suppress) {
        this.suppressAnimation = suppress;
    }
    start() {
        if (this.active) return;
        const { gos: gos } = this;
        if (gos.get("suppressColumnMoveAnimation")) return;
        if (gos.get("enableRtl")) return;
        this.ensureAnimationCssClassPresent();
        this.active = true;
        this.activeNext = true;
    }
    finish() {
        if (!this.active) return;
        this.flush(()=>this.activeNext = false, ()=>this.active = false);
    }
    executeNextVMTurn(func) {
        if (this.activeNext) this.executeNextFuncs.push(func);
        else func();
    }
    executeLaterVMTurn(func) {
        if (this.active) this.executeLaterFuncs.push(func);
        else func();
    }
    ensureAnimationCssClassPresent() {
        this.animationThreadCount++;
        const animationThreadCountCopy = this.animationThreadCount;
        const { gridBodyCtrl: gridBodyCtrl } = this;
        gridBodyCtrl.setColumnMovingCss(true);
        this.executeLaterFuncs.push(()=>{
            if (this.animationThreadCount === animationThreadCountCopy) gridBodyCtrl.setColumnMovingCss(false);
        });
    }
    flush(callbackNext, callbackLater) {
        const { executeNextFuncs: executeNextFuncs, executeLaterFuncs: executeLaterFuncs } = this;
        if (executeNextFuncs.length === 0 && executeLaterFuncs.length === 0) {
            callbackNext();
            callbackLater();
            return;
        }
        const runFuncs = (queue)=>{
            while(queue.length){
                const func = queue.pop();
                if (func) func();
            }
        };
        this.beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                callbackNext();
                runFuncs(executeNextFuncs);
            }, 0);
            window.setTimeout(()=>{
                callbackLater();
                runFuncs(executeLaterFuncs);
            }, 200);
        });
    }
};
// packages/ag-grid-community/src/columnMove/columnMoveApi.ts
function $437b23f6a393c3bf$var$moveColumnByIndex(beans, fromIndex, toIndex) {
    beans.colMoves?.moveColumnByIndex(fromIndex, toIndex, "api");
}
function $437b23f6a393c3bf$var$moveColumns(beans, columnsToMoveKeys, toIndex) {
    beans.colMoves?.moveColumns(columnsToMoveKeys, toIndex, "api");
}
// packages/ag-grid-community/src/columnMove/columnDrag/bodyDropPivotTarget.ts
var $437b23f6a393c3bf$var$BodyDropPivotTarget = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.columnsToAggregate = [];
        this.columnsToGroup = [];
        this.columnsToPivot = [];
    }
    /** Callback for when drag enters */ onDragEnter(draggingEvent) {
        this.clearColumnsList();
        if (this.gos.get("functionsReadOnly")) return;
        const dragColumns = draggingEvent.dragItem.columns;
        if (!dragColumns) return;
        for (const column of dragColumns){
            if (!column.isPrimary()) continue;
            if (column.isAnyFunctionActive()) continue;
            if (column.isAllowValue()) this.columnsToAggregate.push(column);
            else if (column.isAllowRowGroup()) this.columnsToGroup.push(column);
            else if (column.isAllowPivot()) this.columnsToPivot.push(column);
        }
    }
    getIconName() {
        const totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
        if (totalColumns > 0) return this.pinned ? "pinned" : "move";
        return null;
    }
    /** Callback for when drag leaves */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragLeave(draggingEvent) {
        this.clearColumnsList();
    }
    clearColumnsList() {
        this.columnsToAggregate.length = 0;
        this.columnsToGroup.length = 0;
        this.columnsToPivot.length = 0;
    }
    /** Callback for when dragging */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragging(draggingEvent) {}
    /** Callback for when drag stops */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragStop(draggingEvent) {
        const { valueColsSvc: valueColsSvc, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = this.beans;
        if (this.columnsToAggregate.length > 0) valueColsSvc?.addColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
        if (this.columnsToGroup.length > 0) rowGroupColsSvc?.addColumns(this.columnsToGroup, "toolPanelDragAndDrop");
        if (this.columnsToPivot.length > 0) pivotColsSvc?.addColumns(this.columnsToPivot, "toolPanelDragAndDrop");
    }
    onDragCancel() {
        this.clearColumnsList();
    }
};
// packages/ag-grid-community/src/columnMove/internalColumnMoveUtils.ts
function $437b23f6a393c3bf$var$sortColsLikeCols(colsList, cols) {
    if (!cols || cols.length <= 1) return;
    const notAllColsPresent = cols.filter((c)=>colsList.indexOf(c) < 0).length > 0;
    if (notAllColsPresent) return;
    cols.sort((a, b)=>{
        const indexA = colsList.indexOf(a);
        const indexB = colsList.indexOf(b);
        return indexA - indexB;
    });
}
function $437b23f6a393c3bf$var$getColsToMove(allMovingColumns) {
    const newCols = [
        ...allMovingColumns
    ];
    for (const col of allMovingColumns){
        let movingGroup = null;
        let parent = col.getParent();
        while(parent != null && parent.getDisplayedLeafColumns().length === 1){
            movingGroup = parent;
            parent = parent.getParent();
        }
        if (movingGroup != null) {
            const isMarryChildren = !!movingGroup.getColGroupDef()?.marryChildren;
            const columnsToMove = isMarryChildren ? // when marry children is true, we also have to move hidden
            // columns within the group, so grab them from the `providedColumnGroup`
            movingGroup.getProvidedColumnGroup().getLeafColumns() : movingGroup.getLeafColumns();
            for (const newCol of columnsToMove)if (!newCols.includes(newCol)) newCols.push(newCol);
        }
    }
    return newCols;
}
function $437b23f6a393c3bf$var$getLowestFragMove(validMoves, allMovingColumnsOrdered, colMoves, visibleCols) {
    const displayedCols = visibleCols.allCols;
    let lowestFragMove = null;
    let targetOrder = null;
    for(let i = 0; i < validMoves.length; i++){
        const move = validMoves[i];
        const order = colMoves.getProposedColumnOrder(allMovingColumnsOrdered, move);
        if (!colMoves.doesOrderPassRules(order)) continue;
        const displayedOrder = order.filter((col)=>displayedCols.includes(col));
        if (targetOrder === null) targetOrder = displayedOrder;
        else if (!$437b23f6a393c3bf$export$893967cdb9833fdd(displayedOrder, targetOrder)) break;
        const fragCount = $437b23f6a393c3bf$var$groupFragCount(order);
        if (lowestFragMove === null || fragCount < lowestFragMove.fragCount) lowestFragMove = {
            move: move,
            fragCount: fragCount
        };
    }
    return lowestFragMove;
}
function $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(params) {
    const { isFromHeader: isFromHeader, fromLeft: fromLeft, xPosition: xPosition, fromEnter: fromEnter, fakeEvent: fakeEvent, pinned: pinned, gos: gos, colModel: colModel, colMoves: colMoves, visibleCols: visibleCols } = params;
    let { allMovingColumns: allMovingColumns } = params;
    if (isFromHeader) allMovingColumns = $437b23f6a393c3bf$var$getColsToMove(allMovingColumns);
    const allMovingColumnsOrdered = allMovingColumns.slice();
    $437b23f6a393c3bf$var$sortColsLikeCols(colModel.getCols(), allMovingColumnsOrdered);
    const validMoves = $437b23f6a393c3bf$var$calculateValidMoves({
        movingCols: allMovingColumnsOrdered,
        draggingRight: fromLeft,
        xPosition: xPosition,
        pinned: pinned,
        gos: gos,
        colModel: colModel,
        visibleCols: visibleCols
    });
    const oldIndex = $437b23f6a393c3bf$var$calculateOldIndex(allMovingColumnsOrdered, colModel);
    if (validMoves.length === 0) return;
    const firstValidMove = validMoves[0];
    const constrainDirection = oldIndex !== null && (isFromHeader || !fromEnter);
    if (constrainDirection && !fakeEvent) {
        if (!fromLeft && firstValidMove >= oldIndex) return;
        if (fromLeft && firstValidMove <= oldIndex) return;
    }
    const lowestFragMove = $437b23f6a393c3bf$var$getLowestFragMove(validMoves, allMovingColumnsOrdered, colMoves, visibleCols);
    if (!lowestFragMove) return;
    const toIndex = lowestFragMove.move;
    if (toIndex > colModel.getCols().length - allMovingColumnsOrdered.length) return;
    return {
        columns: allMovingColumnsOrdered,
        toIndex: toIndex
    };
}
function $437b23f6a393c3bf$var$attemptMoveColumns(params) {
    const { columns: columns, toIndex: toIndex } = $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(params) || {};
    const { finished: finished, colMoves: colMoves } = params;
    if (!columns || toIndex == null) return null;
    colMoves.moveColumns(columns, toIndex, "uiColumnMoved", finished);
    return finished ? null : {
        columns: columns,
        toIndex: toIndex
    };
}
function $437b23f6a393c3bf$var$calculateOldIndex(movingCols, colModel) {
    const gridCols = colModel.getCols();
    const indexes = movingCols.map((col)=>gridCols.indexOf(col)).sort((a, b)=>a - b);
    const firstIndex = indexes[0];
    const lastIndex = $437b23f6a393c3bf$export$236389741107357f(indexes);
    const spread = lastIndex - firstIndex;
    const gapsExist = spread !== indexes.length - 1;
    return gapsExist ? null : firstIndex;
}
function $437b23f6a393c3bf$var$groupFragCount(columns) {
    function parents(col) {
        const result = [];
        let parent = col.getOriginalParent();
        while(parent != null){
            result.push(parent);
            parent = parent.getOriginalParent();
        }
        return result;
    }
    let count = 0;
    for(let i = 0; i < columns.length - 1; i++){
        let a = parents(columns[i]);
        let b = parents(columns[i + 1]);
        [a, b] = a.length > b.length ? [
            a,
            b
        ] : [
            b,
            a
        ];
        for (const parent of a)if (b.indexOf(parent) === -1) count++;
    }
    return count;
}
function $437b23f6a393c3bf$var$getDisplayedColumns(visibleCols, type) {
    switch(type){
        case "left":
            return visibleCols.leftCols;
        case "right":
            return visibleCols.rightCols;
        default:
            return visibleCols.centerCols;
    }
}
function $437b23f6a393c3bf$var$calculateValidMoves(params) {
    const { movingCols: movingCols, draggingRight: draggingRight, xPosition: xPosition, pinned: pinned, gos: gos, colModel: colModel, visibleCols: visibleCols } = params;
    const isMoveBlocked = gos.get("suppressMovableColumns") || movingCols.some((col)=>col.getColDef().suppressMovable);
    if (isMoveBlocked) return [];
    const allDisplayedCols = $437b23f6a393c3bf$var$getDisplayedColumns(visibleCols, pinned);
    const allGridCols = colModel.getCols();
    const movingDisplayedCols = allDisplayedCols.filter((col)=>movingCols.includes(col));
    const otherDisplayedCols = allDisplayedCols.filter((col)=>!movingCols.includes(col));
    const otherGridCols = allGridCols.filter((col)=>!movingCols.includes(col));
    let displayIndex = 0;
    let availableWidth = xPosition;
    if (draggingRight) {
        let widthOfMovingDisplayedCols = 0;
        for (const col of movingDisplayedCols)widthOfMovingDisplayedCols += col.getActualWidth();
        availableWidth -= widthOfMovingDisplayedCols;
    }
    if (availableWidth > 0) {
        for(let i = 0; i < otherDisplayedCols.length; i++){
            const col = otherDisplayedCols[i];
            availableWidth -= col.getActualWidth();
            if (availableWidth < 0) break;
            displayIndex++;
        }
        if (draggingRight) displayIndex++;
    }
    let firstValidMove;
    if (displayIndex > 0) {
        const leftColumn = otherDisplayedCols[displayIndex - 1];
        firstValidMove = otherGridCols.indexOf(leftColumn) + 1;
    } else {
        firstValidMove = otherGridCols.indexOf(otherDisplayedCols[0]);
        if (firstValidMove === -1) firstValidMove = 0;
    }
    const validMoves = [
        firstValidMove
    ];
    const numberComparator = (a, b)=>a - b;
    if (draggingRight) {
        let pointer = firstValidMove + 1;
        const lastIndex = allGridCols.length - 1;
        while(pointer <= lastIndex){
            validMoves.push(pointer);
            pointer++;
        }
        validMoves.sort(numberComparator);
    } else {
        let pointer = firstValidMove;
        const lastIndex = allGridCols.length - 1;
        let displacedCol = allGridCols[pointer];
        while(pointer <= lastIndex && allDisplayedCols.indexOf(displacedCol) < 0){
            pointer++;
            validMoves.push(pointer);
            displacedCol = allGridCols[pointer];
        }
        pointer = firstValidMove - 1;
        const firstDisplayIndex = 0;
        while(pointer >= firstDisplayIndex){
            validMoves.push(pointer);
            pointer--;
        }
        validMoves.sort(numberComparator).reverse();
    }
    return validMoves;
}
function $437b23f6a393c3bf$var$normaliseX(params) {
    const { pinned: pinned, fromKeyboard: fromKeyboard, gos: gos, ctrlsSvc: ctrlsSvc, useHeaderRow: useHeaderRow, skipScrollPadding: skipScrollPadding } = params;
    let eViewport = ctrlsSvc.getHeaderRowContainerCtrl(pinned)?.eViewport;
    let { x: x } = params;
    if (!eViewport) return 0;
    if (fromKeyboard) x -= eViewport.getBoundingClientRect().left;
    if (gos.get("enableRtl")) {
        if (useHeaderRow) eViewport = eViewport.querySelector(".ag-header-row");
        x = eViewport.clientWidth - x;
    }
    if (pinned == null && !skipScrollPadding) x += ctrlsSvc.get("center").getCenterViewportScrollLeft();
    return x;
}
function $437b23f6a393c3bf$var$setColumnsMoving(columns, isMoving) {
    for (const column of columns){
        column.moving = isMoving;
        column.dispatchColEvent("movingChanged", "uiColumnMoved");
    }
}
// packages/ag-grid-community/src/columnMove/columnDrag/moveColumnFeature.ts
var $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD = 7;
var $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH = 100;
var $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE = $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH / 2;
var $437b23f6a393c3bf$var$SCROLL_ACCELERATION_RATE = 5;
var $437b23f6a393c3bf$var$SCROLL_TIME_INTERVAL = 100;
var $437b23f6a393c3bf$var$MoveColumnFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.needToMoveLeft = false;
        this.needToMoveRight = false;
        this.lastMovedInfo = null;
        this.isCenterContainer = !$437b23f6a393c3bf$export$25d27f17d3af40f7(pinned);
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    getIconName() {
        const { pinned: pinned, lastDraggingEvent: lastDraggingEvent } = this;
        const { dragItem: dragItem } = lastDraggingEvent || {};
        const columns = dragItem?.columns ?? [];
        for (const col of columns){
            const colPinned = col.getPinned();
            if (col.getColDef().lockPinned) {
                if (colPinned == pinned) return "move";
                continue;
            }
            const initialPinnedState = dragItem?.containerType;
            if (initialPinnedState === pinned || !pinned) return "move";
            if (pinned && (!colPinned || initialPinnedState !== pinned)) return "pinned";
        }
        return "notAllowed";
    }
    onDragEnter(draggingEvent) {
        const dragItem = draggingEvent.dragItem;
        const columns = dragItem.columns;
        const dragCameFromToolPanel = draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
        if (dragCameFromToolPanel) this.setColumnsVisible(columns, true, "uiColumnDragged");
        else {
            const visibleState = dragItem.visibleState;
            const visibleColumns = (columns || []).filter((column)=>visibleState[column.getId()] && !column.isVisible());
            this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
        }
        if (!this.gos.get("suppressMoveWhenColumnDragging")) this.attemptToPinColumns(columns, this.pinned);
        this.onDragging(draggingEvent, true, true);
    }
    onDragging(draggingEvent = this.lastDraggingEvent, fromEnter = false, fakeEvent = false, finished = false) {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        const isSuppressMoveWhenDragging = gos.get("suppressMoveWhenColumnDragging");
        if (finished && !isSuppressMoveWhenDragging) {
            this.finishColumnMoving();
            return;
        }
        this.lastDraggingEvent = draggingEvent;
        if (!draggingEvent || !finished && $437b23f6a393c3bf$export$672d9e47bc342bac(draggingEvent.hDirection)) return;
        const mouseX = $437b23f6a393c3bf$var$normaliseX({
            x: draggingEvent.x,
            pinned: this.pinned,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
        if (!fromEnter) this.checkCenterForScrolling(mouseX);
        if (isSuppressMoveWhenDragging) this.handleColumnDragWhileSuppressingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished);
        else this.handleColumnDragWhileAllowingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished);
    }
    onDragLeave() {
        this.ensureIntervalCleared();
        this.clearHighlighted();
        this.updateDragItemContainerType();
        this.lastMovedInfo = null;
    }
    onDragStop() {
        this.onDragging(this.lastDraggingEvent, false, true, true);
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    onDragCancel() {
        this.clearHighlighted();
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    setColumnsVisible(columns, visible, source) {
        if (!columns?.length) return;
        const allowedCols = columns.filter((c)=>!c.getColDef().lockVisible);
        if (!allowedCols.length) return;
        this.beans.colModel.setColsVisible(allowedCols, visible, source);
    }
    finishColumnMoving() {
        this.clearHighlighted();
        const lastMovedInfo = this.lastMovedInfo;
        if (!lastMovedInfo) return;
        const { columns: columns, toIndex: toIndex } = lastMovedInfo;
        this.beans.colMoves.moveColumns(columns, toIndex, "uiColumnMoved", true);
    }
    updateDragItemContainerType() {
        const { lastDraggingEvent: lastDraggingEvent } = this;
        if (this.gos.get("suppressMoveWhenColumnDragging") || !lastDraggingEvent) return;
        const dragItem = lastDraggingEvent.dragItem;
        if (!dragItem) return;
        dragItem.containerType = this.pinned;
    }
    handleColumnDragWhileSuppressingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished) {
        const allMovingColumns = this.getAllMovingColumns(draggingEvent, true);
        if (finished) {
            const isAttemptingToPin = this.isAttemptingToPin(allMovingColumns);
            if (isAttemptingToPin) this.attemptToPinColumns(allMovingColumns, void 0, true);
            const { fromLeft: fromLeft, xPosition: xPosition } = this.getNormalisedXPositionInfo(allMovingColumns, isAttemptingToPin) || {};
            if (fromLeft == null || xPosition == null) {
                this.finishColumnMoving();
                return;
            }
            this.moveColumnsAfterHighlight({
                allMovingColumns: allMovingColumns,
                xPosition: xPosition,
                fromEnter: fromEnter,
                fakeEvent: fakeEvent,
                fromLeft: fromLeft
            });
        } else {
            if (!this.beans.dragAndDrop.isDropZoneWithinThisGrid(draggingEvent)) return;
            this.highlightHoveredColumn(allMovingColumns, mouseX);
        }
    }
    handleColumnDragWhileAllowingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished) {
        const allMovingColumns = this.getAllMovingColumns(draggingEvent);
        const fromLeft = this.normaliseDirection(draggingEvent.hDirection) === "right";
        const isFromHeader = draggingEvent.dragSource.type === 1 /* HeaderCell */ ;
        const params = this.getMoveColumnParams({
            allMovingColumns: allMovingColumns,
            isFromHeader: isFromHeader,
            xPosition: mouseX,
            fromLeft: fromLeft,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent
        });
        const lastMovedInfo = $437b23f6a393c3bf$var$attemptMoveColumns({
            ...params,
            finished: finished
        });
        if (lastMovedInfo) this.lastMovedInfo = lastMovedInfo;
    }
    getAllMovingColumns(draggingEvent, useSplit = false) {
        const dragItem = draggingEvent.dragSource.getDragItem();
        let columns = null;
        if (useSplit) {
            columns = dragItem.columnsInSplit;
            if (!columns) columns = dragItem.columns;
        } else columns = dragItem.columns;
        const conditionCallback = (col)=>col.getColDef().lockPinned ? col.getPinned() == this.pinned : true;
        if (!columns) return [];
        return columns.filter(conditionCallback);
    }
    getMoveColumnParams(params) {
        const { allMovingColumns: allMovingColumns, isFromHeader: isFromHeader, xPosition: xPosition, fromLeft: fromLeft, fromEnter: fromEnter, fakeEvent: fakeEvent } = params;
        const { gos: gos, colModel: colModel, colMoves: colMoves, visibleCols: visibleCols } = this.beans;
        return {
            allMovingColumns: allMovingColumns,
            isFromHeader: isFromHeader,
            fromLeft: fromLeft,
            xPosition: xPosition,
            pinned: this.pinned,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent,
            gos: gos,
            colModel: colModel,
            colMoves: colMoves,
            visibleCols: visibleCols
        };
    }
    highlightHoveredColumn(movingColumns, mouseX) {
        const { gos: gos, colModel: colModel } = this.beans;
        const isRtl = gos.get("enableRtl");
        const consideredColumns = colModel.getCols().filter((col)=>col.isVisible() && col.getPinned() === this.pinned);
        let start = null;
        let width = null;
        let targetColumn = null;
        for (const col of consideredColumns){
            width = col.getActualWidth();
            start = this.getNormalisedColumnLeft(col, 0, isRtl);
            if (start != null) {
                const end = start + width;
                if (start <= mouseX && end >= mouseX) {
                    targetColumn = col;
                    break;
                }
            }
            start = null;
            width = null;
        }
        if (!targetColumn) {
            for(let i = consideredColumns.length - 1; i >= 0; i--){
                const currentColumn = consideredColumns[i];
                const parent = consideredColumns[i].getParent();
                if (!parent) {
                    targetColumn = currentColumn;
                    break;
                }
                const leafDisplayedCols = parent?.getDisplayedLeafColumns();
                if (leafDisplayedCols.length) {
                    targetColumn = $437b23f6a393c3bf$export$236389741107357f(leafDisplayedCols);
                    break;
                }
            }
            if (!targetColumn) return;
            start = this.getNormalisedColumnLeft(targetColumn, 0, isRtl);
            width = targetColumn.getActualWidth();
        } else if (movingColumns.indexOf(targetColumn) !== -1) targetColumn = null;
        if (this.lastHighlightedColumn?.column !== targetColumn) this.clearHighlighted();
        if (targetColumn == null || start == null || width == null) return;
        let position;
        if (mouseX - start < width / 2) position = 0 /* Before */ ;
        else position = 1 /* After */ ;
        $437b23f6a393c3bf$var$setColumnHighlighted(targetColumn, position);
        this.lastHighlightedColumn = {
            column: targetColumn,
            position: position
        };
    }
    getNormalisedXPositionInfo(allMovingColumns, isAttemptingToPin) {
        const { gos: gos, visibleCols: visibleCols } = this.beans;
        const isRtl = gos.get("enableRtl");
        const { firstMovingCol: firstMovingCol, column: column, position: position } = this.getColumnMoveAndTargetInfo(allMovingColumns, isAttemptingToPin, isRtl);
        if (!firstMovingCol || !column || position == null) return;
        const visibleColumns = visibleCols.allCols;
        const movingColIndex = visibleColumns.indexOf(firstMovingCol);
        const targetIndex = visibleColumns.indexOf(column);
        const isBefore = position === 0 /* Before */ ;
        const fromLeft = movingColIndex < targetIndex || movingColIndex === targetIndex && !isBefore;
        let diff = 0;
        if (isBefore) {
            if (fromLeft) diff -= 1;
        } else if (!fromLeft) diff += 1;
        if (targetIndex + diff === movingColIndex) return;
        const targetColumn = visibleColumns[targetIndex + diff];
        if (!targetColumn) return;
        const xPosition = this.getNormalisedColumnLeft(targetColumn, 20, isRtl);
        return {
            fromLeft: fromLeft,
            xPosition: xPosition
        };
    }
    getColumnMoveAndTargetInfo(allMovingColumns, isAttemptingToPin, isRtl) {
        const lastHighlightedColumn = this.lastHighlightedColumn || {};
        const { firstMovingCol: firstMovingCol, lastMovingCol: lastMovingCol } = $437b23f6a393c3bf$var$findFirstAndLastMovingColumns(allMovingColumns);
        if (!firstMovingCol || !lastMovingCol || lastHighlightedColumn.column || !isAttemptingToPin) return {
            firstMovingCol: firstMovingCol,
            ...lastHighlightedColumn
        };
        const pinned = this.getPinDirection();
        const isLeft = pinned === "left";
        return {
            firstMovingCol: firstMovingCol,
            position: isLeft ? 1 /* After */  : 0 /* Before */ ,
            column: isLeft !== isRtl ? firstMovingCol : lastMovingCol
        };
    }
    normaliseDirection(hDirection) {
        if (this.gos.get("enableRtl")) switch(hDirection){
            case "left":
                return "right";
            case "right":
                return "left";
        }
        return hDirection;
    }
    getNormalisedColumnLeft(col, padding, isRtl) {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        const left = col.getLeft();
        if (left == null) return null;
        const width = col.getActualWidth();
        return $437b23f6a393c3bf$var$normaliseX({
            x: isRtl ? left + width - padding : left + padding,
            pinned: col.getPinned(),
            useHeaderRow: isRtl,
            skipScrollPadding: true,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
    }
    isAttemptingToPin(columns) {
        const isMovingHorizontally = this.needToMoveLeft || this.needToMoveRight;
        const isFailedMoreThanThreshold = this.failedMoveAttempts > $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD;
        return isMovingHorizontally && isFailedMoreThanThreshold || columns.some((col)=>col.getPinned() !== this.pinned);
    }
    moveColumnsAfterHighlight(params) {
        const { allMovingColumns: allMovingColumns, xPosition: xPosition, fromEnter: fromEnter, fakeEvent: fakeEvent, fromLeft: fromLeft } = params;
        const columnMoveParams = this.getMoveColumnParams({
            allMovingColumns: allMovingColumns,
            isFromHeader: true,
            xPosition: xPosition,
            fromLeft: fromLeft,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent
        });
        const { columns: columns, toIndex: toIndex } = $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(columnMoveParams) || {};
        if (columns && toIndex != null) this.lastMovedInfo = {
            columns: columns,
            toIndex: toIndex
        };
        this.finishColumnMoving();
    }
    clearHighlighted() {
        const { lastHighlightedColumn: lastHighlightedColumn } = this;
        if (!lastHighlightedColumn) return;
        $437b23f6a393c3bf$var$setColumnHighlighted(lastHighlightedColumn.column, null);
        this.lastHighlightedColumn = null;
    }
    checkCenterForScrolling(xAdjustedForScroll) {
        if (!this.isCenterContainer) return;
        const centerCtrl = this.beans.ctrlsSvc.get("center");
        const firstVisiblePixel = centerCtrl.getCenterViewportScrollLeft();
        const lastVisiblePixel = firstVisiblePixel + centerCtrl.getCenterWidth();
        let needToMoveRight;
        let needToMoveLeft;
        if (this.gos.get("enableRtl")) {
            needToMoveRight = xAdjustedForScroll < firstVisiblePixel + $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
            needToMoveLeft = xAdjustedForScroll > lastVisiblePixel - $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
        } else {
            needToMoveLeft = xAdjustedForScroll < firstVisiblePixel + $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
            needToMoveRight = xAdjustedForScroll > lastVisiblePixel - $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
        }
        this.needToMoveRight = needToMoveRight;
        this.needToMoveLeft = needToMoveLeft;
        if (needToMoveLeft || needToMoveRight) this.ensureIntervalStarted();
        else this.ensureIntervalCleared();
    }
    ensureIntervalStarted() {
        if (this.movingIntervalId) return;
        this.intervalCount = 0;
        this.failedMoveAttempts = 0;
        this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), $437b23f6a393c3bf$var$SCROLL_TIME_INTERVAL);
        this.beans.dragAndDrop.setDragImageCompIcon(this.needToMoveLeft ? "left" : "right", true);
    }
    ensureIntervalCleared() {
        if (!this.movingIntervalId) return;
        window.clearInterval(this.movingIntervalId);
        this.movingIntervalId = null;
        this.failedMoveAttempts = 0;
        this.beans.dragAndDrop.setDragImageCompIcon(this.getIconName());
    }
    moveInterval() {
        let pixelsToMove;
        this.intervalCount++;
        pixelsToMove = 10 + this.intervalCount * $437b23f6a393c3bf$var$SCROLL_ACCELERATION_RATE;
        if (pixelsToMove > $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH) pixelsToMove = $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH;
        let pixelsMoved = null;
        const scrollFeature = this.gridBodyCon.scrollFeature;
        if (this.needToMoveLeft) pixelsMoved = scrollFeature.scrollHorizontally(-pixelsToMove);
        else if (this.needToMoveRight) pixelsMoved = scrollFeature.scrollHorizontally(pixelsToMove);
        if (pixelsMoved !== 0) {
            this.onDragging(this.lastDraggingEvent);
            this.failedMoveAttempts = 0;
        } else {
            this.failedMoveAttempts++;
            const { pinnedCols: pinnedCols, dragAndDrop: dragAndDrop, gos: gos } = this.beans;
            if (this.failedMoveAttempts <= $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD + 1 || !pinnedCols) return;
            dragAndDrop.setDragImageCompIcon("pinned");
            if (!gos.get("suppressMoveWhenColumnDragging")) {
                const columns = this.lastDraggingEvent?.dragItem.columns;
                this.attemptToPinColumns(columns, void 0, true);
            }
        }
    }
    getPinDirection() {
        if (this.needToMoveLeft || this.pinned === "left") return "left";
        if (this.needToMoveRight || this.pinned === "right") return "right";
    }
    attemptToPinColumns(columns, pinned, fromMoving = false) {
        const allowedCols = (columns || []).filter((c)=>!c.getColDef().lockPinned);
        if (!allowedCols.length) return 0;
        if (fromMoving) pinned = this.getPinDirection();
        const { pinnedCols: pinnedCols, dragAndDrop: dragAndDrop } = this.beans;
        pinnedCols?.setColsPinned(allowedCols, pinned, "uiColumnDragged");
        if (fromMoving) dragAndDrop.nudge();
        return allowedCols.length;
    }
    destroy() {
        super.destroy();
        this.lastDraggingEvent = null;
        this.clearHighlighted();
        this.lastMovedInfo = null;
    }
};
function $437b23f6a393c3bf$var$setColumnHighlighted(column, highlighted) {
    if (column.highlighted === highlighted) return;
    column.highlighted = highlighted;
    column.dispatchColEvent("headerHighlightChanged", "uiColumnMoved");
}
function $437b23f6a393c3bf$var$findFirstAndLastMovingColumns(allMovingColumns) {
    const moveLen = allMovingColumns.length;
    let firstMovingCol;
    let lastMovingCol;
    for(let i = 0; i < moveLen; i++){
        if (!firstMovingCol) {
            const leftCol = allMovingColumns[i];
            if (leftCol.getLeft() != null) firstMovingCol = leftCol;
        }
        if (!lastMovingCol) {
            const rightCol = allMovingColumns[moveLen - 1 - i];
            if (rightCol.getLeft() != null) lastMovingCol = rightCol;
        }
        if (firstMovingCol && lastMovingCol) break;
    }
    return {
        firstMovingCol: firstMovingCol,
        lastMovingCol: lastMovingCol
    };
}
// packages/ag-grid-community/src/columnMove/columnDrag/bodyDropTarget.ts
var $437b23f6a393c3bf$var$BodyDropTarget = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned, eContainer){
        super();
        this.pinned = pinned;
        this.eContainer = eContainer;
    }
    postConstruct() {
        const { ctrlsSvc: ctrlsSvc, dragAndDrop: dragAndDrop } = this.beans;
        const pinned = this.pinned;
        ctrlsSvc.whenReady(this, (p)=>{
            let eSecondaryContainers;
            const eBodyViewport = p.gridBodyCtrl.eBodyViewport;
            switch(pinned){
                case "left":
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.left.eContainer
                        ],
                        [
                            p.bottomLeft.eContainer
                        ],
                        [
                            p.topLeft.eContainer
                        ]
                    ];
                    break;
                case "right":
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.right.eContainer
                        ],
                        [
                            p.bottomRight.eContainer
                        ],
                        [
                            p.topRight.eContainer
                        ]
                    ];
                    break;
                default:
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.center.eViewport
                        ],
                        [
                            p.bottomCenter.eViewport
                        ],
                        [
                            p.topCenter.eViewport
                        ]
                    ];
                    break;
            }
            this.eSecondaryContainers = eSecondaryContainers;
        });
        this.moveColumnFeature = this.createManagedBean(new $437b23f6a393c3bf$var$MoveColumnFeature(pinned));
        this.bodyDropPivotTarget = this.createManagedBean(new $437b23f6a393c3bf$var$BodyDropPivotTarget(pinned));
        dragAndDrop.addDropTarget(this);
        this.addDestroyFunc(()=>dragAndDrop.removeDropTarget(this));
    }
    isInterestedIn(type) {
        return type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */  && this.gos.get("allowDragFromColumnsToolPanel");
    }
    getSecondaryContainers() {
        return this.eSecondaryContainers;
    }
    getContainer() {
        return this.eContainer;
    }
    getIconName() {
        return this.currentDropListener.getIconName();
    }
    // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
    // dropped into the grid's body.
    isDropColumnInPivotMode(draggingEvent) {
        return this.beans.colModel.isPivotMode() && draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
    }
    onDragEnter(draggingEvent) {
        this.currentDropListener = this.isDropColumnInPivotMode(draggingEvent) ? this.bodyDropPivotTarget : this.moveColumnFeature;
        this.currentDropListener.onDragEnter(draggingEvent);
    }
    onDragLeave(params) {
        this.currentDropListener.onDragLeave(params);
    }
    onDragging(params) {
        this.currentDropListener.onDragging(params);
    }
    onDragStop(params) {
        this.currentDropListener.onDragStop(params);
    }
    onDragCancel() {
        this.currentDropListener.onDragCancel();
    }
};
// packages/ag-grid-community/src/columnMove/columnMoveService.ts
var $437b23f6a393c3bf$var$ColumnMoveService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colMoves";
    }
    moveColumnByIndex(fromIndex, toIndex, source) {
        const gridColumns = this.beans.colModel.getCols();
        if (!gridColumns) return;
        const column = gridColumns[fromIndex];
        this.moveColumns([
            column
        ], toIndex, source);
    }
    moveColumns(columnsToMoveKeys, toIndex, source, finished = true) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const gridColumns = colModel.getCols();
        if (!gridColumns) return;
        if (toIndex > gridColumns.length - columnsToMoveKeys.length) {
            $437b23f6a393c3bf$export$545083624300f13d(30, {
                toIndex: toIndex
            });
            return;
        }
        colAnimation?.start();
        const movedColumns = colModel.getColsForKeys(columnsToMoveKeys);
        if (this.doesMovePassRules(movedColumns, toIndex)) {
            $437b23f6a393c3bf$var$_moveInArray(colModel.getCols(), movedColumns, toIndex);
            visibleCols.refresh(source);
            eventSvc.dispatchEvent({
                type: "columnMoved",
                columns: movedColumns,
                column: movedColumns.length === 1 ? movedColumns[0] : null,
                toIndex: toIndex,
                finished: finished,
                source: source
            });
        }
        colAnimation?.finish();
    }
    doesMovePassRules(columnsToMove, toIndex) {
        const proposedColumnOrder = this.getProposedColumnOrder(columnsToMove, toIndex);
        return this.doesOrderPassRules(proposedColumnOrder);
    }
    doesOrderPassRules(gridOrder) {
        const { colModel: colModel, gos: gos } = this.beans;
        if (!$437b23f6a393c3bf$var$doesMovePassMarryChildren(gridOrder, colModel.getColTree())) return false;
        const doesMovePassLockedPositions = (proposedColumnOrder)=>{
            const lockPositionToPlacement = (position)=>{
                if (!position) return 0 /* NONE */ ;
                return position === "left" || position === true ? -1 /* LEFT */  : 1 /* RIGHT */ ;
            };
            const isRtl = gos.get("enableRtl");
            let lastPlacement = isRtl ? 1 /* RIGHT */  : -1 /* LEFT */ ;
            let rulePassed = true;
            for (const col of proposedColumnOrder){
                const placement = lockPositionToPlacement(col.getColDef().lockPosition);
                if (isRtl) {
                    if (placement > lastPlacement) rulePassed = false;
                } else if (placement < lastPlacement) rulePassed = false;
                lastPlacement = placement;
            }
            return rulePassed;
        };
        if (!doesMovePassLockedPositions(gridOrder)) return false;
        return true;
    }
    getProposedColumnOrder(columnsToMove, toIndex) {
        const gridColumns = this.beans.colModel.getCols();
        const proposedColumnOrder = gridColumns.slice();
        $437b23f6a393c3bf$var$_moveInArray(proposedColumnOrder, columnsToMove, toIndex);
        return proposedColumnOrder;
    }
    createBodyDropTarget(pinned, dropContainer) {
        return new $437b23f6a393c3bf$var$BodyDropTarget(pinned, dropContainer);
    }
    moveHeader(hDirection, eGui, column, pinned, bean) {
        const { ctrlsSvc: ctrlsSvc, gos: gos, colModel: colModel, visibleCols: visibleCols, focusSvc: focusSvc } = this.beans;
        const rect = eGui.getBoundingClientRect();
        const left = rect.left;
        const isGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(column);
        const width = isGroup ? rect.width : column.getActualWidth();
        const isLeft = hDirection === "left" !== gos.get("enableRtl");
        const xPosition = $437b23f6a393c3bf$var$normaliseX({
            x: isLeft ? left - 20 : left + width + 20,
            pinned: pinned,
            fromKeyboard: true,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
        const headerPosition = focusSvc.focusedHeader;
        $437b23f6a393c3bf$var$attemptMoveColumns({
            allMovingColumns: isGroup ? column.getLeafColumns() : [
                column
            ],
            isFromHeader: true,
            fromLeft: hDirection === "right",
            xPosition: xPosition,
            pinned: pinned,
            fromEnter: false,
            fakeEvent: false,
            gos: gos,
            colModel: colModel,
            colMoves: this,
            visibleCols: visibleCols,
            finished: true
        });
        let targetColumn;
        if (isGroup) {
            const displayedLeafColumns = column.getDisplayedLeafColumns();
            targetColumn = isLeft ? displayedLeafColumns[0] : $437b23f6a393c3bf$export$236389741107357f(displayedLeafColumns);
        } else targetColumn = column;
        ctrlsSvc.getScrollFeature().ensureColumnVisible(targetColumn, "auto");
        if ((!bean.isAlive() || gos.get("ensureDomOrder")) && headerPosition) {
            let restoreFocusColumn;
            if (isGroup) {
                const groupId = column.getGroupId();
                const leafCols = column.getLeafColumns();
                if (!leafCols.length) return;
                const parent = leafCols[0].getParent();
                if (!parent) return;
                restoreFocusColumn = $437b23f6a393c3bf$var$findGroupWidthId(parent, groupId);
            } else restoreFocusColumn = column;
            if (restoreFocusColumn) focusSvc.focusHeaderPosition({
                headerPosition: {
                    ...headerPosition,
                    column: restoreFocusColumn
                }
            });
        }
    }
    setDragSourceForHeader(eSource, column, displayName) {
        const { gos: gos, colModel: colModel, dragAndDrop: dragAndDrop, visibleCols: visibleCols } = this.beans;
        let hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
        const isGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(column);
        const columns = isGroup ? column.getProvidedColumnGroup().getLeafColumns() : [
            column
        ];
        const getDragItem = isGroup ? ()=>$437b23f6a393c3bf$var$createDragItemForGroup(column, visibleCols.allCols) : ()=>$437b23f6a393c3bf$var$createDragItem(column);
        const dragSource = {
            type: 1 /* HeaderCell */ ,
            eElement: eSource,
            getDefaultIconName: ()=>hideColumnOnExit ? "hide" : "notAllowed",
            getDragItem: getDragItem,
            dragItemName: displayName,
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                $437b23f6a393c3bf$var$setColumnsMoving(columns, true);
            },
            onDragStopped: ()=>$437b23f6a393c3bf$var$setColumnsMoving(columns, false),
            onDragCancelled: ()=>$437b23f6a393c3bf$var$setColumnsMoving(columns, false),
            onGridEnter: (dragItem)=>{
                if (hideColumnOnExit) {
                    const { columns: columns2 = [], visibleState: visibleState } = dragItem ?? {};
                    const hasVisibleState = isGroup ? (col)=>!visibleState || visibleState[col.getColId()] : ()=>true;
                    const unlockedColumns = columns2.filter((col)=>!col.getColDef().lockVisible && hasVisibleState(col));
                    colModel.setColsVisible(unlockedColumns, true, "uiColumnMoved");
                }
            },
            onGridExit: (dragItem)=>{
                if (hideColumnOnExit) {
                    const unlockedColumns = dragItem?.columns?.filter((col)=>!col.getColDef().lockVisible) || [];
                    colModel.setColsVisible(unlockedColumns, false, "uiColumnMoved");
                }
            }
        };
        dragAndDrop.addDragSource(dragSource, true);
        return dragSource;
    }
};
function $437b23f6a393c3bf$var$findGroupWidthId(columnGroup, id) {
    while(columnGroup){
        if (columnGroup.getGroupId() === id) return columnGroup;
        columnGroup = columnGroup.getParent();
    }
    return void 0;
}
function $437b23f6a393c3bf$var$createDragItem(column) {
    const visibleState = {};
    visibleState[column.getId()] = column.isVisible();
    return {
        columns: [
            column
        ],
        visibleState: visibleState,
        containerType: column.pinned
    };
}
function $437b23f6a393c3bf$var$createDragItemForGroup(columnGroup, allCols) {
    const allColumnsOriginalOrder = columnGroup.getProvidedColumnGroup().getLeafColumns();
    const visibleState = {};
    for (const column of allColumnsOriginalOrder)visibleState[column.getId()] = column.isVisible();
    const allColumnsCurrentOrder = [];
    for (const column of allCols)if (allColumnsOriginalOrder.indexOf(column) >= 0) {
        allColumnsCurrentOrder.push(column);
        $437b23f6a393c3bf$export$83a881c8b5120679(allColumnsOriginalOrder, column);
    }
    for (const column of allColumnsOriginalOrder)allColumnsCurrentOrder.push(column);
    const columnsInSplit = [];
    const columnGroupColumns = columnGroup.getLeafColumns();
    for (const col of allColumnsCurrentOrder)if (columnGroupColumns.indexOf(col) !== -1) columnsInSplit.push(col);
    return {
        columns: allColumnsCurrentOrder,
        columnsInSplit: columnsInSplit,
        visibleState: visibleState,
        containerType: columnsInSplit[0]?.pinned
    };
}
// packages/ag-grid-community/src/columnMove/columnMoveModule.ts
var $437b23f6a393c3bf$export$1458fbffed29c925 = {
    moduleName: "ColumnMove",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnMoveService,
        $437b23f6a393c3bf$var$ColumnAnimationService
    ],
    apiFunctions: {
        moveColumnByIndex: $437b23f6a393c3bf$var$moveColumnByIndex,
        moveColumns: $437b23f6a393c3bf$var$moveColumns
    },
    dependsOn: [
        $437b23f6a393c3bf$export$4ad116d131ade5b4
    ],
    css: [
        $437b23f6a393c3bf$var$columnMovingCSS
    ]
};
// packages/ag-grid-community/src/rendering/autoWidthCalculator.ts
var $437b23f6a393c3bf$var$AutoWidthCalculator = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "autoWidthCalc";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowContainerCtrl = p.center;
        });
    }
    // this is the trick: we create a dummy container and clone all the cells
    // into the dummy, then check the dummy's width. then destroy the dummy
    // as we don't need it any more.
    // drawback: only the cells visible on the screen are considered
    getPreferredWidthForColumn(column, skipHeader) {
        const eHeaderCell = this.getHeaderCellForColumn(column);
        if (!eHeaderCell) return -1;
        const elements = this.beans.rowRenderer.getAllCellsNotSpanningForColumn(column);
        if (!skipHeader) elements.push(eHeaderCell);
        return this.getPreferredWidthForElements(elements);
    }
    getPreferredWidthForColumnGroup(columnGroup) {
        const eHeaderCell = this.getHeaderCellForColumn(columnGroup);
        if (!eHeaderCell) return -1;
        return this.getPreferredWidthForElements([
            eHeaderCell
        ]);
    }
    getPreferredWidthForElements(elements, extraPadding) {
        const eDummyContainer = document.createElement("form");
        eDummyContainer.style.position = "fixed";
        const eBodyContainer = this.centerRowContainerCtrl.eContainer;
        for (const el of elements)this.cloneItemIntoDummy(el, eDummyContainer);
        eBodyContainer.appendChild(eDummyContainer);
        const dummyContainerWidth = eDummyContainer.offsetWidth;
        eDummyContainer.remove();
        extraPadding = extraPadding ?? this.gos.get("autoSizePadding");
        return dummyContainerWidth + extraPadding;
    }
    getHeaderCellForColumn(column) {
        let element = null;
        for (const container of this.beans.ctrlsSvc.getHeaderRowContainerCtrls()){
            const res = container.getHtmlElementForColumnHeader(column);
            if (res != null) element = res;
        }
        return element;
    }
    cloneItemIntoDummy(eCell, eDummyContainer) {
        const eCellClone = eCell.cloneNode(true);
        eCellClone.style.width = "";
        eCellClone.style.position = "static";
        eCellClone.style.left = "";
        const eCloneParent = document.createElement("div");
        const eCloneParentClassList = eCloneParent.classList;
        const isHeader = [
            "ag-header-cell",
            "ag-header-group-cell"
        ].some((cls)=>eCellClone.classList.contains(cls));
        if (isHeader) {
            eCloneParentClassList.add("ag-header", "ag-header-row");
            eCloneParent.style.position = "static";
        } else eCloneParentClassList.add("ag-row");
        let pointer = eCell.parentElement;
        while(pointer){
            const isRow = [
                "ag-header-row",
                "ag-row"
            ].some((cls)=>pointer.classList.contains(cls));
            if (isRow) {
                for(let i = 0; i < pointer.classList.length; i++){
                    const item = pointer.classList[i];
                    if (item != "ag-row-position-absolute") eCloneParentClassList.add(item);
                }
                break;
            }
            pointer = pointer.parentElement;
        }
        eCloneParent.appendChild(eCellClone);
        eDummyContainer.appendChild(eCloneParent);
    }
};
// packages/ag-grid-community/src/rendering/autoWidthModule.ts
var $437b23f6a393c3bf$var$AutoWidthModule = {
    moduleName: "AutoWidth",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AutoWidthCalculator
    ]
};
// packages/ag-grid-community/src/columnResize/columnResizeApi.ts
function $437b23f6a393c3bf$var$setColumnWidths(beans, columnWidths, finished = true, source = "api") {
    beans.colResize?.setColumnWidths(columnWidths, false, finished, source);
}
// packages/ag-grid-community/src/columnResize/groupResizeFeature.ts
var $437b23f6a393c3bf$var$GroupResizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp, eResize, pinned, columnGroup){
        super();
        this.comp = comp;
        this.eResize = eResize;
        this.pinned = pinned;
        this.columnGroup = columnGroup;
    }
    postConstruct() {
        if (!this.columnGroup.isResizable()) {
            this.comp.setResizableDisplayed(false);
            return;
        }
        const { horizontalResizeSvc: horizontalResizeSvc, gos: gos, colAutosize: colAutosize } = this.beans;
        const finishedWithResizeFunc = horizontalResizeSvc.addResizeBar({
            eResizeBar: this.eResize,
            onResizeStart: this.onResizeStart.bind(this),
            onResizing: this.onResizing.bind(this, false),
            onResizeEnd: this.onResizing.bind(this, true)
        });
        this.addDestroyFunc(finishedWithResizeFunc);
        if (!gos.get("suppressAutoSize") && colAutosize) this.addDestroyFunc(colAutosize.addColumnGroupResize(this.eResize, this.columnGroup, ()=>this.resizeLeafColumnsToFit("uiColumnResized")));
    }
    onResizeStart(shiftKey) {
        const { columnsToResize: columnsToResize, resizeStartWidth: resizeStartWidth, resizeRatios: resizeRatios, groupAfterColumns: groupAfterColumns, groupAfterStartWidth: groupAfterStartWidth, groupAfterRatios: groupAfterRatios } = this.getInitialValues(shiftKey);
        this.resizeCols = columnsToResize;
        this.resizeStartWidth = resizeStartWidth;
        this.resizeRatios = resizeRatios;
        this.resizeTakeFromCols = groupAfterColumns;
        this.resizeTakeFromStartWidth = groupAfterStartWidth;
        this.resizeTakeFromRatios = groupAfterRatios;
        this.toggleColumnResizing(true);
    }
    onResizing(finished, resizeAmount, source = "uiColumnResized") {
        const resizeAmountNormalised = this.normaliseDragChange(resizeAmount);
        const width = this.resizeStartWidth + resizeAmountNormalised;
        this.resizeColumnsFromLocalValues(width, source, finished);
    }
    getInitialValues(shiftKey) {
        const getInitialSizeOfColumns = (columns)=>columns.reduce((totalWidth, column)=>totalWidth + column.getActualWidth(), 0);
        const getSizeRatiosOfColumns = (columns, initialSizeOfColumns)=>columns.map((column)=>column.getActualWidth() / initialSizeOfColumns);
        const columnsToResize = this.getColumnsToResize();
        const resizeStartWidth = getInitialSizeOfColumns(columnsToResize);
        const resizeRatios = getSizeRatiosOfColumns(columnsToResize, resizeStartWidth);
        const columnSizeAndRatios = {
            columnsToResize: columnsToResize,
            resizeStartWidth: resizeStartWidth,
            resizeRatios: resizeRatios
        };
        let groupAfter = null;
        if (shiftKey) groupAfter = this.beans.colGroupSvc?.getGroupAtDirection(this.columnGroup, "After") ?? null;
        if (groupAfter) {
            const takeFromLeafCols = groupAfter.getDisplayedLeafColumns();
            const groupAfterColumns = columnSizeAndRatios.groupAfterColumns = takeFromLeafCols.filter((col)=>col.isResizable());
            const groupAfterStartWidth = columnSizeAndRatios.groupAfterStartWidth = getInitialSizeOfColumns(groupAfterColumns);
            columnSizeAndRatios.groupAfterRatios = getSizeRatiosOfColumns(groupAfterColumns, groupAfterStartWidth);
        } else {
            columnSizeAndRatios.groupAfterColumns = void 0;
            columnSizeAndRatios.groupAfterStartWidth = void 0;
            columnSizeAndRatios.groupAfterRatios = void 0;
        }
        return columnSizeAndRatios;
    }
    resizeLeafColumnsToFit(source) {
        const preferredSize = this.beans.autoWidthCalc.getPreferredWidthForColumnGroup(this.columnGroup);
        const initialValues = this.getInitialValues();
        if (preferredSize > initialValues.resizeStartWidth) this.resizeColumns(initialValues, preferredSize, source, true);
    }
    resizeColumnsFromLocalValues(totalWidth, source, finished = true) {
        if (!this.resizeCols || !this.resizeRatios) return;
        const initialValues = {
            columnsToResize: this.resizeCols,
            resizeStartWidth: this.resizeStartWidth,
            resizeRatios: this.resizeRatios,
            groupAfterColumns: this.resizeTakeFromCols,
            groupAfterStartWidth: this.resizeTakeFromStartWidth,
            groupAfterRatios: this.resizeTakeFromRatios
        };
        this.resizeColumns(initialValues, totalWidth, source, finished);
    }
    resizeColumns(initialValues, totalWidth, source, finished = true) {
        const { columnsToResize: columnsToResize, resizeStartWidth: resizeStartWidth, resizeRatios: resizeRatios, groupAfterColumns: groupAfterColumns, groupAfterStartWidth: groupAfterStartWidth, groupAfterRatios: groupAfterRatios } = initialValues;
        const resizeSets = [];
        resizeSets.push({
            columns: columnsToResize,
            ratios: resizeRatios,
            width: totalWidth
        });
        if (groupAfterColumns) {
            const diff = totalWidth - resizeStartWidth;
            resizeSets.push({
                columns: groupAfterColumns,
                ratios: groupAfterRatios,
                width: groupAfterStartWidth - diff
            });
        }
        this.beans.colResize?.resizeColumnSets({
            resizeSets: resizeSets,
            finished: finished,
            source: source
        });
        if (finished) this.toggleColumnResizing(false);
    }
    toggleColumnResizing(resizing) {
        this.comp.toggleCss("ag-column-resizing", resizing);
    }
    getColumnsToResize() {
        const leafCols = this.columnGroup.getDisplayedLeafColumns();
        return leafCols.filter((col)=>col.isResizable());
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderCell - should refactor out?
    normaliseDragChange(dragChange) {
        let result = dragChange;
        if (this.gos.get("enableRtl")) {
            if (this.pinned !== "left") result *= -1;
        } else if (this.pinned === "right") result *= -1;
        return result;
    }
    destroy() {
        super.destroy();
        this.resizeCols = void 0;
        this.resizeRatios = void 0;
        this.resizeTakeFromCols = void 0;
        this.resizeTakeFromRatios = void 0;
    }
};
// packages/ag-grid-community/src/columnResize/resizeFeature.ts
var $437b23f6a393c3bf$var$ResizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned, column, eResize, comp, ctrl){
        super();
        this.pinned = pinned;
        this.column = column;
        this.eResize = eResize;
        this.comp = comp;
        this.ctrl = ctrl;
    }
    postConstruct() {
        const destroyResizeFuncs = [];
        let canResize;
        let canAutosize;
        const addResize = ()=>{
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eResize, canResize);
            if (!canResize) return;
            const { horizontalResizeSvc: horizontalResizeSvc, colAutosize: colAutosize } = this.beans;
            const finishedWithResizeFunc = horizontalResizeSvc.addResizeBar({
                eResizeBar: this.eResize,
                onResizeStart: this.onResizeStart.bind(this),
                onResizing: this.onResizing.bind(this, false),
                onResizeEnd: this.onResizing.bind(this, true)
            });
            destroyResizeFuncs.push(finishedWithResizeFunc);
            if (canAutosize && colAutosize) destroyResizeFuncs.push(colAutosize.addColumnAutosizeListeners(this.eResize, this.column));
        };
        const removeResize = ()=>{
            for (const f of destroyResizeFuncs)f();
            destroyResizeFuncs.length = 0;
        };
        const refresh = ()=>{
            const resize = this.column.isResizable();
            const autoSize = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
            const propertyChange = resize !== canResize || autoSize !== canAutosize;
            if (propertyChange) {
                canResize = resize;
                canAutosize = autoSize;
                removeResize();
                addResize();
            }
        };
        refresh();
        this.addDestroyFunc(removeResize);
        this.ctrl.setRefreshFunction("resize", refresh);
    }
    onResizing(finished, resizeAmount) {
        const { column: key, lastResizeAmount: lastResizeAmount, resizeStartWidth: resizeStartWidth, beans: beans } = this;
        const resizeAmountNormalised = this.normaliseResizeAmount(resizeAmount);
        const newWidth = resizeStartWidth + resizeAmountNormalised;
        const columnWidths = [
            {
                key: key,
                newWidth: newWidth
            }
        ];
        const { pinnedCols: pinnedCols, ctrlsSvc: ctrlsSvc, colResize: colResize } = beans;
        if (this.column.getPinned()) {
            const leftWidth = pinnedCols?.leftWidth ?? 0;
            const rightWidth = pinnedCols?.rightWidth ?? 0;
            const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
            if (leftWidth + rightWidth + (resizeAmountNormalised - lastResizeAmount) > bodyWidth) return;
        }
        this.lastResizeAmount = resizeAmountNormalised;
        colResize?.setColumnWidths(columnWidths, this.resizeWithShiftKey, finished, "uiColumnResized");
        if (finished) this.toggleColumnResizing(false);
    }
    onResizeStart(shiftKey) {
        this.resizeStartWidth = this.column.getActualWidth();
        this.lastResizeAmount = 0;
        this.resizeWithShiftKey = shiftKey;
        this.toggleColumnResizing(true);
    }
    toggleColumnResizing(resizing) {
        this.column.resizing = resizing;
        this.comp.toggleCss("ag-column-resizing", resizing);
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
    normaliseResizeAmount(dragChange) {
        let result = dragChange;
        const notPinningLeft = this.pinned !== "left";
        const pinningRight = this.pinned === "right";
        if (this.gos.get("enableRtl")) {
            if (notPinningLeft) result *= -1;
        } else if (pinningRight) result *= -1;
        return result;
    }
};
// packages/ag-grid-community/src/columnResize/columnResizeService.ts
var $437b23f6a393c3bf$var$ColumnResizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colResize";
    }
    setColumnWidths(columnWidths, shiftKey, finished, source) {
        const sets = [];
        const { colModel: colModel, gos: gos, visibleCols: visibleCols } = this.beans;
        for (const columnWidth of columnWidths){
            const col = colModel.getColDefCol(columnWidth.key) || colModel.getCol(columnWidth.key);
            if (!col) continue;
            sets.push({
                width: columnWidth.newWidth,
                ratios: [
                    1
                ],
                columns: [
                    col
                ]
            });
            const defaultIsShift = gos.get("colResizeDefault") === "shift";
            if (defaultIsShift) shiftKey = !shiftKey;
            if (shiftKey) {
                const otherCol = visibleCols.getColAfter(col);
                if (!otherCol) continue;
                const widthDiff = col.getActualWidth() - columnWidth.newWidth;
                const otherColWidth = otherCol.getActualWidth() + widthDiff;
                sets.push({
                    width: otherColWidth,
                    ratios: [
                        1
                    ],
                    columns: [
                        otherCol
                    ]
                });
            }
        }
        if (sets.length === 0) return;
        this.resizeColumnSets({
            resizeSets: sets,
            finished: finished,
            source: source
        });
    }
    // method takes sets of columns and resizes them. either all sets will be resized, or nothing
    // be resized. this is used for example when user tries to resize a group and holds shift key,
    // then both the current group (grows), and the adjacent group (shrinks), will get resized,
    // so that's two sets for this method.
    resizeColumnSets(params) {
        const { resizeSets: resizeSets, finished: finished, source: source } = params;
        const passMinMaxCheck = !resizeSets || resizeSets.every((columnResizeSet)=>$437b23f6a393c3bf$var$checkMinAndMaxWidthsForSet(columnResizeSet));
        if (!passMinMaxCheck) {
            if (finished) {
                const columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
                $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, columns, finished, source);
            }
            return;
        }
        const changedCols = [];
        const allResizedCols = [];
        for (const set of resizeSets){
            const { width: width, columns: columns, ratios: ratios } = set;
            const newWidths = {};
            const finishedCols = {};
            for (const col of columns)allResizedCols.push(col);
            let finishedColsGrew = true;
            let loopCount = 0;
            while(finishedColsGrew){
                loopCount++;
                if (loopCount > 1e3) {
                    $437b23f6a393c3bf$export$a20c7248650823a9(31);
                    break;
                }
                finishedColsGrew = false;
                const subsetCols = [];
                let subsetRatioTotal = 0;
                let pixelsToDistribute = width;
                columns.forEach((col, index)=>{
                    const thisColFinished = finishedCols[col.getId()];
                    if (thisColFinished) pixelsToDistribute -= newWidths[col.getId()];
                    else {
                        subsetCols.push(col);
                        const ratioThisCol = ratios[index];
                        subsetRatioTotal += ratioThisCol;
                    }
                });
                const ratioScale = 1 / subsetRatioTotal;
                subsetCols.forEach((col, index)=>{
                    const lastCol = index === subsetCols.length - 1;
                    let colNewWidth;
                    if (lastCol) colNewWidth = pixelsToDistribute;
                    else {
                        colNewWidth = Math.round(ratios[index] * width * ratioScale);
                        pixelsToDistribute -= colNewWidth;
                    }
                    const minWidth = col.getMinWidth();
                    const maxWidth = col.getMaxWidth();
                    if (colNewWidth < minWidth) {
                        colNewWidth = minWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    } else if (maxWidth > 0 && colNewWidth > maxWidth) {
                        colNewWidth = maxWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    }
                    newWidths[col.getId()] = colNewWidth;
                });
            }
            for (const col of columns){
                const newWidth = newWidths[col.getId()];
                const actualWidth = col.getActualWidth();
                if (actualWidth !== newWidth) {
                    col.setActualWidth(newWidth, source);
                    changedCols.push(col);
                }
            }
        }
        const atLeastOneColChanged = changedCols.length > 0;
        let flexedCols = [];
        if (atLeastOneColChanged) {
            const { colFlex: colFlex, visibleCols: visibleCols, colViewport: colViewport } = this.beans;
            flexedCols = colFlex?.refreshFlexedColumns({
                resizingCols: allResizedCols,
                skipSetLeft: true
            }) ?? [];
            visibleCols.setLeftValues(source);
            visibleCols.updateBodyWidths();
            colViewport.checkViewportColumns();
        }
        const colsForEvent = allResizedCols.concat(flexedCols);
        if (atLeastOneColChanged || finished) $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, colsForEvent, finished, source, flexedCols);
    }
    resizeHeader(column, delta, shiftKey) {
        if (!column.isResizable()) return;
        const actualWidth = column.getActualWidth();
        const minWidth = column.getMinWidth();
        const maxWidth = column.getMaxWidth();
        const newWidth = Math.min(Math.max(actualWidth + delta, minWidth), maxWidth);
        this.setColumnWidths([
            {
                key: column,
                newWidth: newWidth
            }
        ], shiftKey, true, "uiColumnResized");
    }
    createResizeFeature(pinned, column, eResize, comp, ctrl) {
        return new $437b23f6a393c3bf$var$ResizeFeature(pinned, column, eResize, comp, ctrl);
    }
    createGroupResizeFeature(comp, eResize, pinned, columnGroup) {
        return new $437b23f6a393c3bf$var$GroupResizeFeature(comp, eResize, pinned, columnGroup);
    }
};
function $437b23f6a393c3bf$var$checkMinAndMaxWidthsForSet(columnResizeSet) {
    const { columns: columns, width: width } = columnResizeSet;
    let minWidthAccumulated = 0;
    let maxWidthAccumulated = 0;
    let maxWidthActive = true;
    for (const col of columns){
        const minWidth = col.getMinWidth();
        minWidthAccumulated += minWidth || 0;
        const maxWidth = col.getMaxWidth();
        if (maxWidth > 0) maxWidthAccumulated += maxWidth;
        else maxWidthActive = false;
    }
    const minWidthPasses = width >= minWidthAccumulated;
    const maxWidthPasses = !maxWidthActive || width <= maxWidthAccumulated;
    return minWidthPasses && maxWidthPasses;
}
// packages/ag-grid-community/src/columnResize/columnResizeModule.ts
var $437b23f6a393c3bf$var$ColumnResizeModule = {
    moduleName: "ColumnResize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnResizeService
    ],
    apiFunctions: {
        setColumnWidths: $437b23f6a393c3bf$var$setColumnWidths
    },
    dependsOn: [
        $437b23f6a393c3bf$export$57b5b4ab4a8a663e,
        $437b23f6a393c3bf$var$AutoWidthModule
    ]
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/groupWidthFeature.ts
var $437b23f6a393c3bf$var$GroupWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp, columnGroup){
        super();
        // the children can change, we keep destroy functions related to listening to the children here
        this.removeChildListenersFuncs = [];
        this.columnGroup = columnGroup;
        this.comp = comp;
    }
    postConstruct() {
        this.addListenersToChildrenColumns();
        this.addManagedListeners(this.columnGroup, {
            displayedChildrenChanged: this.onDisplayedChildrenChanged.bind(this)
        });
        this.onWidthChanged();
        this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
    }
    addListenersToChildrenColumns() {
        this.removeListenersOnChildrenColumns();
        const widthChangedListener = this.onWidthChanged.bind(this);
        for (const column of this.columnGroup.getLeafColumns()){
            column.__addEventListener("widthChanged", widthChangedListener);
            column.__addEventListener("visibleChanged", widthChangedListener);
            this.removeChildListenersFuncs.push(()=>{
                column.__removeEventListener("widthChanged", widthChangedListener);
                column.__removeEventListener("visibleChanged", widthChangedListener);
            });
        }
    }
    removeListenersOnChildrenColumns() {
        for (const func of this.removeChildListenersFuncs)func();
        this.removeChildListenersFuncs = [];
    }
    onDisplayedChildrenChanged() {
        this.addListenersToChildrenColumns();
        this.onWidthChanged();
    }
    onWidthChanged() {
        const columnWidth = this.columnGroup.getActualWidth();
        this.comp.setWidth(`${columnWidth}px`);
        this.comp.toggleCss("ag-hidden", columnWidth === 0);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderGroupCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.onSuppressColMoveChange = ()=>{
            if (!this.isAlive() || this.isSuppressMoving()) this.removeDragSource();
            else if (!this.dragSource) this.setDragSource(this.eGui);
        };
    }
    wireComp(comp, eGui, eResize, eHeaderCompWrapper, compBean) {
        const { column: column, beans: beans } = this;
        const { context: context, colNames: colNames, colHover: colHover, rangeSvc: rangeSvc, colResize: colResize } = beans;
        this.comp = comp;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBean);
        this.setGui(eGui, compBean);
        this.displayName = colNames.getDisplayNameForColumnGroup(column, "header");
        this.refreshHeaderStyles();
        this.addClasses();
        this.setupMovingCss(compBean);
        this.setupExpandable(compBean);
        this.setupTooltip();
        this.refreshAnnouncement();
        this.setupAutoHeight({
            wrapperElement: eHeaderCompWrapper,
            compBean: compBean
        });
        this.setupUserComp();
        this.addHeaderMouseListeners(compBean, eHeaderCompWrapper);
        this.addManagedPropertyListener("groupHeaderHeight", this.refreshMaxHeaderHeight.bind(this));
        this.refreshMaxHeaderHeight();
        const pinned = this.rowCtrl.pinned;
        const leafCols = column.getProvidedColumnGroup().getLeafColumns();
        colHover?.createHoverFeature(compBean, leafCols, eGui);
        rangeSvc?.createRangeHighlightFeature(compBean, column, comp);
        compBean.createManagedBean(new $437b23f6a393c3bf$var$SetLeftFeature(column, eGui, beans));
        compBean.createManagedBean(new $437b23f6a393c3bf$var$GroupWidthFeature(comp, column));
        if (colResize) this.resizeFeature = compBean.createManagedBean(colResize.createGroupResizeFeature(comp, eResize, pinned, column));
        else comp.setResizableDisplayed(false);
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: ()=>void 0,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
        this.addHighlightListeners(compBean, leafCols);
        this.addManagedEventListeners({
            cellSelectionChanged: ()=>this.refreshAnnouncement()
        });
        compBean.addManagedPropertyListener("suppressMovableColumns", this.onSuppressColMoveChange);
        this.addResizeAndMoveKeyboardListeners(compBean);
        compBean.addDestroyFunc(()=>this.clearComponent());
    }
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.getDefinition();
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            columnGroup: column,
            floatingFilter: false
        });
    }
    refreshMaxHeaderHeight() {
        const { gos: gos, comp: comp } = this;
        const groupHeaderHeight = gos.get("groupHeaderHeight");
        if (groupHeaderHeight != null) {
            if (groupHeaderHeight === 0) comp.setHeaderWrapperHidden(true);
            else comp.setHeaderWrapperMaxHeight(groupHeaderHeight);
        } else {
            comp.setHeaderWrapperHidden(false);
            comp.setHeaderWrapperMaxHeight(null);
        }
    }
    addHighlightListeners(compBean, columns) {
        if (!this.beans.gos.get("suppressMoveWhenColumnDragging")) return;
        for (const column of columns)compBean.addManagedListeners(column, {
            headerHighlightChanged: this.onLeafColumnHighlightChanged.bind(this, column)
        });
    }
    onLeafColumnHighlightChanged(column) {
        const displayedColumns = this.column.getDisplayedLeafColumns();
        const isFirst = displayedColumns[0] === column;
        const isLast = $437b23f6a393c3bf$export$236389741107357f(displayedColumns) === column;
        if (!isFirst && !isLast) return;
        const highlighted = column.getHighlighted();
        const isColumnMoveAtThisLevel = !!this.rowCtrl.getHeaderCellCtrls().find((ctrl)=>{
            return ctrl.column.isMoving();
        });
        let beforeOn = false;
        let afterOn = false;
        if (isColumnMoveAtThisLevel) {
            const isRtl = this.beans.gos.get("enableRtl");
            const isHighlightAfter = highlighted === 1 /* After */ ;
            const isHighlightBefore = highlighted === 0 /* Before */ ;
            if (isFirst) {
                if (isRtl) afterOn = isHighlightAfter;
                else beforeOn = isHighlightBefore;
            }
            if (isLast) {
                if (isRtl) beforeOn = isHighlightBefore;
                else afterOn = isHighlightAfter;
            }
        }
        this.comp.toggleCss("ag-header-highlight-before", beforeOn);
        this.comp.toggleCss("ag-header-highlight-after", afterOn);
    }
    resizeHeader(delta, shiftKey) {
        const { resizeFeature: resizeFeature } = this;
        if (!resizeFeature) return;
        const initialValues = resizeFeature.getInitialValues(shiftKey);
        resizeFeature.resizeColumns(initialValues, initialValues.resizeStartWidth + delta, "uiColumnResized", true);
    }
    resizeLeafColumnsToFit(source) {
        this.resizeFeature?.resizeLeafColumnsToFit(source);
    }
    setupUserComp() {
        const { colGroupSvc: colGroupSvc, userCompFactory: userCompFactory, gos: gos, enterpriseMenuFactory: enterpriseMenuFactory } = this.beans;
        const columnGroup = this.column;
        const providedColumnGroup = columnGroup.getProvidedColumnGroup();
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            displayName: this.displayName,
            columnGroup: columnGroup,
            setExpanded: (expanded)=>{
                colGroupSvc.setColumnGroupOpened(providedColumnGroup, expanded, "gridInitializing");
            },
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.setupTooltip(value, shouldDisplayTooltip);
            },
            showColumnMenu: (buttonElement, onClosedCallback)=>enterpriseMenuFactory?.showMenuAfterButtonClick(providedColumnGroup, buttonElement, "columnMenu", onClosedCallback),
            showColumnMenuAfterMouseClick: (mouseEvent, onClosedCallback)=>enterpriseMenuFactory?.showMenuAfterMouseEvent(providedColumnGroup, mouseEvent, "columnMenu", onClosedCallback),
            eGridHeader: this.eGui
        });
        const compDetails = $437b23f6a393c3bf$var$_getHeaderGroupCompDetails(userCompFactory, params);
        if (compDetails) this.comp.setUserCompDetails(compDetails);
    }
    addHeaderMouseListeners(compBean, eHeaderCompWrapper) {
        const { column: column, comp: comp, beans: { rangeSvc: rangeSvc }, gos: gos } = this;
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>this.dispatchColumnMouseEvent("columnHeaderClicked", column.getProvidedColumnGroup());
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, column.getProvidedColumnGroup());
        compBean.addManagedListeners(this.eGui, {
            mouseenter: listener,
            mouseleave: listener,
            click: clickListener,
            contextmenu: contextMenuListener
        });
        comp.toggleCss("ag-header-group-cell-selectable", $437b23f6a393c3bf$export$8242077b143dbc86(gos));
        const mouseListener = rangeSvc?.createHeaderGroupCellMouseListenerFeature(this.column, eHeaderCompWrapper);
        if (mouseListener) this.createManagedBean(mouseListener);
    }
    handleMouseOverChange(isMouseOver) {
        this.eventSvc.dispatchEvent({
            type: isMouseOver ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
            column: this.column.getProvidedColumnGroup()
        });
    }
    setupTooltip(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.setupHeaderGroupTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    setupExpandable(compBean) {
        const providedColGroup = this.column.getProvidedColumnGroup();
        this.refreshExpanded();
        const listener = this.refreshExpanded.bind(this);
        compBean.addManagedListeners(providedColGroup, {
            expandedChanged: listener,
            expandableChanged: listener
        });
    }
    refreshExpanded() {
        const { column: column } = this;
        this.expandable = column.isExpandable();
        const expanded = column.isExpanded();
        if (this.expandable) this.comp.setAriaExpanded(expanded ? "true" : "false");
        else this.comp.setAriaExpanded(void 0);
        this.refreshHeaderStyles();
    }
    addClasses() {
        const { column: column } = this;
        const colGroupDef = column.getColGroupDef();
        const classes = $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(colGroupDef, this.gos, null, column);
        if (column.isPadding()) {
            classes.push("ag-header-group-cell-no-group");
            const leafCols = column.getLeafColumns();
            if (leafCols.every((col)=>col.isSpanHeaderHeight())) classes.push("ag-header-span-height");
        } else {
            classes.push("ag-header-group-cell-with-group");
            if (colGroupDef?.wrapHeaderText) classes.push("ag-header-cell-wrap-text");
        }
        for (const c of classes)this.comp.toggleCss(c, true);
    }
    setupMovingCss(compBean) {
        const { column: column } = this;
        const providedColumnGroup = column.getProvidedColumnGroup();
        const leafColumns = providedColumnGroup.getLeafColumns();
        const listener = ()=>this.comp.toggleCss("ag-header-cell-moving", column.isMoving());
        for (const col of leafColumns)compBean.addManagedListeners(col, {
            movingChanged: listener
        });
        listener();
    }
    onFocusIn(e) {
        if (!this.eGui.contains(e.relatedTarget)) {
            this.focusThis();
            this.announceAriaDescription();
        }
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        if (!wrapperHasFocus) return;
        const { column: column, expandable: expandable, gos: gos, beans: beans } = this;
        const enableColumnSelection = $437b23f6a393c3bf$export$8242077b143dbc86(gos);
        if (e.key != $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) return;
        if (enableColumnSelection && !e.altKey) beans.rangeSvc?.handleColumnSelection(column, e);
        else if (expandable) {
            const newExpandedValue = !column.isExpanded();
            beans.colGroupSvc.setColumnGroupOpened(column.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        }
    }
    refreshAnnouncement() {
        let description;
        const { gos: gos, column: column, beans: beans } = this;
        const enableColumnSelection = $437b23f6a393c3bf$export$8242077b143dbc86(gos);
        if (enableColumnSelection) {
            const translate = this.getLocaleTextFunc();
            const colSelected = beans.rangeSvc?.isColumnInAnyRange(column);
            description = translate("ariaColumnCellSelection", `Press CTRL+SPACE to ${colSelected ? "de" : ""}select all visible cells in this column group`);
        }
        this.ariaAnnouncement = description;
    }
    announceAriaDescription() {
        const { beans: beans, eGui: eGui, ariaAnnouncement: ariaAnnouncement } = this;
        if (!ariaAnnouncement || !eGui.contains($437b23f6a393c3bf$export$16bc98d422315038(beans))) return;
        beans.ariaAnnounce?.announceValue(ariaAnnouncement, "columnHeader");
    }
    // unlike columns, this will only get called once, as we don't react on props on column groups
    // (we will always destroy and recreate this comp if something changes)
    setDragSource(eHeaderGroup) {
        if (!this.isAlive() || this.isSuppressMoving()) return;
        this.removeDragSource();
        if (!eHeaderGroup) return;
        this.dragSource = this.beans.colMoves?.setDragSourceForHeader(eHeaderGroup, this.column, this.displayName) ?? null;
    }
    isSuppressMoving() {
        return this.gos.get("suppressMovableColumns") || this.column.getLeafColumns().some((column)=>column.getColDef().suppressMovable || column.getColDef().lockPosition);
    }
    destroy() {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        super.destroy();
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupApi.ts
function $437b23f6a393c3bf$var$setColumnGroupOpened(beans, group, newValue) {
    beans.colGroupSvc?.setColumnGroupOpened(group, newValue, "api");
}
function $437b23f6a393c3bf$var$getColumnGroup(beans, name, instanceId) {
    return beans.colGroupSvc?.getColumnGroup(name, instanceId) ?? null;
}
function $437b23f6a393c3bf$var$getProvidedColumnGroup(beans, name) {
    return beans.colGroupSvc?.getProvidedColGroup(name) ?? null;
}
function $437b23f6a393c3bf$var$getDisplayNameForColumnGroup(beans, columnGroup, location) {
    return beans.colNames.getDisplayNameForColumnGroup(columnGroup, location) || "";
}
function $437b23f6a393c3bf$var$getColumnGroupState(beans) {
    return beans.colGroupSvc?.getColumnGroupState() ?? [];
}
function $437b23f6a393c3bf$var$setColumnGroupState(beans, stateItems) {
    beans.colGroupSvc?.setColumnGroupState(stateItems, "api");
}
function $437b23f6a393c3bf$var$resetColumnGroupState(beans) {
    beans.colGroupSvc?.resetColumnGroupState("api");
}
function $437b23f6a393c3bf$var$getLeftDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeLeft;
}
function $437b23f6a393c3bf$var$getCenterDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeCenter;
}
function $437b23f6a393c3bf$var$getRightDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeRight;
}
function $437b23f6a393c3bf$var$getAllDisplayedColumnGroups(beans) {
    return beans.visibleCols.getAllTrees();
}
// packages/ag-grid-community/src/columns/visibleColsService.ts
function $437b23f6a393c3bf$var$_removeAllFromUnorderedArray(array, toRemove) {
    for(let i = 0; i < toRemove.length; i++){
        const index = array.indexOf(toRemove[i]);
        if (index >= 0) {
            array[index] = array[array.length - 1];
            array.pop();
        }
    }
}
var $437b23f6a393c3bf$var$VisibleColsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "visibleCols";
        // for fast lookup, to see if a column or group is still visible
        this.colsAndGroupsMap = {};
        // leave level columns of the displayed trees
        this.leftCols = [];
        this.rightCols = [];
        this.centerCols = [];
        // all three lists above combined
        this.allCols = [];
        this.headerGroupRowCount = 0;
        // used by:
        // + angularGrid -> for setting body width
        // + rowController -> setting main row widths (when inserting and resizing)
        // need to cache this
        this.bodyWidth = 0;
        this.leftWidth = 0;
        this.rightWidth = 0;
        this.isBodyWidthDirty = true;
    }
    refresh(source, skipTreeBuild = false) {
        const { colFlex: colFlex, colModel: colModel, colGroupSvc: colGroupSvc, colViewport: colViewport, selectionColSvc: selectionColSvc } = this.beans;
        if (!skipTreeBuild) this.buildTrees(colModel, colGroupSvc);
        colGroupSvc?.updateOpenClosedVisibility();
        this.leftCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeLeft);
        this.centerCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeCenter);
        this.rightCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeRight);
        selectionColSvc?.refreshVisibility(this.leftCols, this.centerCols, this.rightCols);
        this.joinColsAriaOrder(colModel);
        this.joinCols();
        this.headerGroupRowCount = this.getHeaderRowCount();
        this.setLeftValues(source);
        this.autoHeightCols = this.allCols.filter((col)=>col.isAutoHeight());
        colFlex?.refreshFlexedColumns();
        this.updateBodyWidths();
        this.setFirstRightAndLastLeftPinned(colModel, this.leftCols, this.rightCols, source);
        colViewport.checkViewportColumns(false);
        this.eventSvc.dispatchEvent({
            type: "displayedColumnsChanged",
            source: source
        });
    }
    getHeaderRowCount() {
        if (!this.gos.get("hidePaddedHeaderRows")) return this.beans.colModel.cols.treeDepth;
        let headerGroupRowCount = 0;
        for (const col of this.allCols){
            let parent = col.getParent();
            while(parent){
                if (!parent.isPadding()) {
                    const level = parent.getProvidedColumnGroup().getLevel() + 1;
                    if (level > headerGroupRowCount) headerGroupRowCount = level;
                    break;
                }
                parent = parent.getParent();
            }
        }
        return headerGroupRowCount;
    }
    // after setColumnWidth or updateGroupsAndPresentedCols
    updateBodyWidths() {
        const newBodyWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.centerCols);
        const newLeftWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.leftCols);
        const newRightWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.rightCols);
        this.isBodyWidthDirty = this.bodyWidth !== newBodyWidth;
        const atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
        if (atLeastOneChanged) {
            this.bodyWidth = newBodyWidth;
            this.leftWidth = newLeftWidth;
            this.rightWidth = newRightWidth;
            this.eventSvc.dispatchEvent({
                type: "columnContainerWidthChanged"
            });
            this.eventSvc.dispatchEvent({
                type: "displayedColumnsWidthChanged"
            });
        }
    }
    // sets the left pixel position of each column
    setLeftValues(source) {
        this.setLeftValuesOfCols(source);
        this.setLeftValuesOfGroups();
    }
    setFirstRightAndLastLeftPinned(colModel, leftCols, rightCols, source) {
        let lastLeft;
        let firstRight;
        if (this.gos.get("enableRtl")) {
            lastLeft = leftCols ? leftCols[0] : null;
            firstRight = rightCols ? $437b23f6a393c3bf$export$236389741107357f(rightCols) : null;
        } else {
            lastLeft = leftCols ? $437b23f6a393c3bf$export$236389741107357f(leftCols) : null;
            firstRight = rightCols ? rightCols[0] : null;
        }
        for (const col of colModel.getCols()){
            col.setLastLeftPinned(col === lastLeft, source);
            col.setFirstRightPinned(col === firstRight, source);
        }
    }
    buildTrees(colModel, columnGroupSvc) {
        const cols = colModel.getColsToShow();
        const leftCols = cols.filter((col)=>col.getPinned() == "left");
        const rightCols = cols.filter((col)=>col.getPinned() == "right");
        const centerCols = cols.filter((col)=>col.getPinned() != "left" && col.getPinned() != "right");
        const idCreator = new $437b23f6a393c3bf$export$b3b24737a74261fb();
        const createGroups = (params)=>{
            return columnGroupSvc ? columnGroupSvc.createColumnGroups(params) : params.columns;
        };
        this.treeLeft = createGroups({
            columns: leftCols,
            idCreator: idCreator,
            pinned: "left",
            oldDisplayedGroups: this.treeLeft
        });
        this.treeRight = createGroups({
            columns: rightCols,
            idCreator: idCreator,
            pinned: "right",
            oldDisplayedGroups: this.treeRight
        });
        this.treeCenter = createGroups({
            columns: centerCols,
            idCreator: idCreator,
            pinned: null,
            oldDisplayedGroups: this.treeCenter
        });
        this.updateColsAndGroupsMap();
    }
    clear() {
        this.leftCols = [];
        this.rightCols = [];
        this.centerCols = [];
        this.allCols = [];
        this.ariaOrderColumns = [];
    }
    joinColsAriaOrder(colModel) {
        const allColumns = colModel.getCols();
        const pinnedLeft = [];
        const center = [];
        const pinnedRight = [];
        for (const col of allColumns){
            const pinned = col.getPinned();
            if (!pinned) center.push(col);
            else if (pinned === true || pinned === "left") pinnedLeft.push(col);
            else pinnedRight.push(col);
        }
        this.ariaOrderColumns = pinnedLeft.concat(center).concat(pinnedRight);
    }
    getAriaColIndex(colOrGroup) {
        let col;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(colOrGroup)) col = colOrGroup.getLeafColumns()[0];
        else col = colOrGroup;
        return this.ariaOrderColumns.indexOf(col) + 1;
    }
    setLeftValuesOfGroups() {
        for (const columns of [
            this.treeLeft,
            this.treeRight,
            this.treeCenter
        ]){
            for (const column of columns)if ($437b23f6a393c3bf$export$1f44a60fc23f9028(column)) {
                const columnGroup = column;
                columnGroup.checkLeft();
            }
        }
    }
    setLeftValuesOfCols(source) {
        const { colModel: colModel } = this.beans;
        const primaryCols = colModel.getColDefCols();
        if (!primaryCols) return;
        const allColumns = colModel.getCols().slice(0);
        const doingRtl = this.gos.get("enableRtl");
        for (const columns of [
            this.leftCols,
            this.rightCols,
            this.centerCols
        ]){
            if (doingRtl) {
                let left = $437b23f6a393c3bf$var$getWidthOfColsInList(columns);
                for (const column of columns){
                    left -= column.getActualWidth();
                    column.setLeft(left, source);
                }
            } else {
                let left = 0;
                for (const column of columns){
                    column.setLeft(left, source);
                    left += column.getActualWidth();
                }
            }
            $437b23f6a393c3bf$var$_removeAllFromUnorderedArray(allColumns, columns);
        }
        for (const column of allColumns)column.setLeft(null, source);
    }
    joinCols() {
        if (this.gos.get("enableRtl")) this.allCols = this.rightCols.concat(this.centerCols).concat(this.leftCols);
        else this.allCols = this.leftCols.concat(this.centerCols).concat(this.rightCols);
    }
    getAllTrees() {
        if (this.treeLeft && this.treeRight && this.treeCenter) return this.treeLeft.concat(this.treeCenter).concat(this.treeRight);
        return null;
    }
    // gridPanel -> ensureColumnVisible
    isColDisplayed(column) {
        return this.allCols.indexOf(column) >= 0;
    }
    getLeftColsForRow(rowNode) {
        const { leftCols: leftCols, beans: { colModel: colModel } } = this;
        const colSpanActive = colModel.colSpanActive;
        if (!colSpanActive) return leftCols;
        return this.getColsForRow(rowNode, leftCols);
    }
    getRightColsForRow(rowNode) {
        const { rightCols: rightCols, beans: { colModel: colModel } } = this;
        const colSpanActive = colModel.colSpanActive;
        if (!colSpanActive) return rightCols;
        return this.getColsForRow(rowNode, rightCols);
    }
    getColsForRow(rowNode, displayedColumns, filterCallback, emptySpaceBeforeColumn) {
        const result = [];
        let lastConsideredCol = null;
        for(let i = 0; i < displayedColumns.length; i++){
            const col = displayedColumns[i];
            const maxAllowedColSpan = displayedColumns.length - i;
            const colSpan = Math.min(col.getColSpan(rowNode), maxAllowedColSpan);
            const columnsToCheckFilter = [
                col
            ];
            if (colSpan > 1) {
                const colsToRemove = colSpan - 1;
                for(let j = 1; j <= colsToRemove; j++)columnsToCheckFilter.push(displayedColumns[i + j]);
                i += colsToRemove;
            }
            let filterPasses;
            if (filterCallback) {
                filterPasses = false;
                for (const colForFilter of columnsToCheckFilter)if (filterCallback(colForFilter)) filterPasses = true;
            } else filterPasses = true;
            if (filterPasses) {
                if (result.length === 0 && lastConsideredCol) {
                    const gapBeforeColumn = emptySpaceBeforeColumn ? emptySpaceBeforeColumn(col) : false;
                    if (gapBeforeColumn) result.push(lastConsideredCol);
                }
                result.push(col);
            }
            lastConsideredCol = col;
        }
        return result;
    }
    getContainerWidth(pinned) {
        switch(pinned){
            case "left":
                return this.leftWidth;
            case "right":
                return this.rightWidth;
            default:
                return this.bodyWidth;
        }
    }
    getColBefore(col) {
        const allDisplayedColumns = this.allCols;
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex > 0) return allDisplayedColumns[oldIndex - 1];
        return null;
    }
    isPinningLeft() {
        return this.leftCols.length > 0;
    }
    isPinningRight() {
        return this.rightCols.length > 0;
    }
    updateColsAndGroupsMap() {
        this.colsAndGroupsMap = {};
        const func = (child)=>{
            this.colsAndGroupsMap[child.getUniqueId()] = child;
        };
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeCenter, false, func);
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeLeft, false, func);
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeRight, false, func);
    }
    isVisible(item) {
        const fromMap = this.colsAndGroupsMap[item.getUniqueId()];
        return fromMap === item;
    }
    getFirstColumn() {
        const isRtl = this.gos.get("enableRtl");
        const queryOrder = [
            "leftCols",
            "centerCols",
            "rightCols"
        ];
        if (isRtl) queryOrder.reverse();
        for(let i = 0; i < queryOrder.length; i++){
            const container = this[queryOrder[i]];
            if (container.length) return isRtl ? $437b23f6a393c3bf$export$236389741107357f(container) : container[0];
        }
        return null;
    }
    // used by:
    // + rowRenderer -> for navigation
    getColAfter(col) {
        const allDisplayedColumns = this.allCols;
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex < allDisplayedColumns.length - 1) return allDisplayedColumns[oldIndex + 1];
        return null;
    }
    // used by:
    // + angularGrid -> setting pinned body width
    // note: this should be cached
    getColsLeftWidth() {
        return $437b23f6a393c3bf$var$getWidthOfColsInList(this.leftCols);
    }
    // note: this should be cached
    getDisplayedColumnsRightWidth() {
        return $437b23f6a393c3bf$var$getWidthOfColsInList(this.rightCols);
    }
    isColAtEdge(col, edge) {
        const allColumns = this.allCols;
        if (!allColumns.length) return false;
        const isFirst = edge === "first";
        let columnToCompare;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(col)) {
            const leafColumns = col.getDisplayedLeafColumns();
            if (!leafColumns.length) return false;
            columnToCompare = isFirst ? leafColumns[0] : $437b23f6a393c3bf$export$236389741107357f(leafColumns);
        } else columnToCompare = col;
        return (isFirst ? allColumns[0] : $437b23f6a393c3bf$export$236389741107357f(allColumns)) === columnToCompare;
    }
};
function $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(tree, useDisplayedChildren, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) {
            const childTree = useDisplayedChildren ? child.getDisplayedChildren() : child.getChildren();
            $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(childTree, useDisplayedChildren, callback);
        }
        callback(child);
    }
}
function $437b23f6a393c3bf$var$pickDisplayedCols(tree) {
    const res = [];
    $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(tree, true, (child)=>{
        if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) res.push(child);
    });
    return res;
}
// packages/ag-grid-community/src/columns/columnGroups/columnGroupService.ts
var $437b23f6a393c3bf$var$ColumnGroupService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colGroupSvc";
    }
    getColumnGroupState() {
        const columnGroupState = [];
        const gridBalancedTree = this.beans.colModel.getColTree();
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, gridBalancedTree, (node)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(node)) columnGroupState.push({
                groupId: node.getGroupId(),
                open: node.isExpanded()
            });
        });
        return columnGroupState;
    }
    resetColumnGroupState(source) {
        const primaryColumnTree = this.beans.colModel.getColDefColTree();
        if (!primaryColumnTree) return;
        const stateItems = [];
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, primaryColumnTree, (child)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) {
                const colGroupDef = child.getColGroupDef();
                const groupState = {
                    groupId: child.getGroupId(),
                    open: !colGroupDef ? void 0 : colGroupDef.openByDefault
                };
                stateItems.push(groupState);
            }
        });
        this.setColumnGroupState(stateItems, source);
    }
    setColumnGroupState(stateItems, source) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const gridBalancedTree = colModel.getColTree();
        if (!gridBalancedTree.length) return;
        colAnimation?.start();
        const impactedGroups = [];
        for (const stateItem of stateItems){
            const groupKey = stateItem.groupId;
            const newValue = stateItem.open;
            const providedColumnGroup = this.getProvidedColGroup(groupKey);
            if (!providedColumnGroup) continue;
            if (providedColumnGroup.isExpanded() === newValue) continue;
            providedColumnGroup.setExpanded(newValue);
            impactedGroups.push(providedColumnGroup);
        }
        visibleCols.refresh(source, true);
        if (impactedGroups.length) eventSvc.dispatchEvent({
            type: "columnGroupOpened",
            columnGroup: impactedGroups.length === 1 ? impactedGroups[0] : void 0,
            columnGroups: impactedGroups
        });
        colAnimation?.finish();
    }
    // called by headerRenderer - when a header is opened or closed
    setColumnGroupOpened(key, newValue, source) {
        let keyAsString;
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(key)) keyAsString = key.getId();
        else keyAsString = key || "";
        this.setColumnGroupState([
            {
                groupId: keyAsString,
                open: newValue
            }
        ], source);
    }
    getProvidedColGroup(key) {
        let res = null;
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, this.beans.colModel.getColTree(), (node)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(node)) {
                if (node.getId() === key) res = node;
            }
        });
        return res;
    }
    getGroupAtDirection(columnGroup, direction) {
        const requiredLevel = columnGroup.getProvidedColumnGroup().getLevel() + columnGroup.getPaddingLevel();
        const colGroupLeafColumns = columnGroup.getDisplayedLeafColumns();
        const col = direction === "After" ? $437b23f6a393c3bf$export$236389741107357f(colGroupLeafColumns) : colGroupLeafColumns[0];
        const getDisplayColMethod = `getCol${direction}`;
        while(true){
            const column = this.beans.visibleCols[getDisplayColMethod](col);
            if (!column) return null;
            const groupPointer = this.getColGroupAtLevel(column, requiredLevel);
            if (groupPointer !== columnGroup) return groupPointer;
        }
    }
    getColGroupAtLevel(column, level) {
        let groupPointer = column.getParent();
        let originalGroupLevel;
        let groupPointerLevel;
        while(true){
            const groupPointerProvidedColumnGroup = groupPointer.getProvidedColumnGroup();
            originalGroupLevel = groupPointerProvidedColumnGroup.getLevel();
            groupPointerLevel = groupPointer.getPaddingLevel();
            if (originalGroupLevel + groupPointerLevel <= level) break;
            groupPointer = groupPointer.getParent();
        }
        return groupPointer;
    }
    updateOpenClosedVisibility() {
        const allColumnGroups = this.beans.visibleCols.getAllTrees();
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.calculateDisplayedColumns();
        });
    }
    // returns the group with matching colId and instanceId. If instanceId is missing,
    // matches only on the colId.
    getColumnGroup(colId, partId) {
        if (!colId) return null;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(colId)) return colId;
        const allColumnGroups = this.beans.visibleCols.getAllTrees();
        const checkPartId = typeof partId === "number";
        let result = null;
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) {
                const columnGroup = child;
                let matched;
                if (checkPartId) matched = colId === columnGroup.getGroupId() && partId === columnGroup.getPartId();
                else matched = colId === columnGroup.getGroupId();
                if (matched) result = columnGroup;
            }
        });
        return result;
    }
    createColumnGroups(params) {
        const { columns: columns, idCreator: idCreator, pinned: pinned, oldDisplayedGroups: oldDisplayedGroups, isStandaloneStructure: isStandaloneStructure } = params;
        const oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
        const topLevelResultCols = [];
        let groupsOrColsAtCurrentLevel = columns;
        while(groupsOrColsAtCurrentLevel.length){
            const currentlyIterating = groupsOrColsAtCurrentLevel;
            groupsOrColsAtCurrentLevel = [];
            let lastGroupedColIdx = 0;
            const createGroupToIndex = (to)=>{
                const from = lastGroupedColIdx;
                lastGroupedColIdx = to;
                const previousNode = currentlyIterating[from];
                const previousNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(previousNode) ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (previousNodeParent == null) {
                    for(let i = from; i < to; i++)topLevelResultCols.push(currentlyIterating[i]);
                    return;
                }
                const newGroup = this.createColumnGroup(previousNodeParent, idCreator, oldColumnsMapped, pinned, isStandaloneStructure);
                for(let i = from; i < to; i++)newGroup.addChild(currentlyIterating[i]);
                groupsOrColsAtCurrentLevel.push(newGroup);
            };
            for(let i = 1; i < currentlyIterating.length; i++){
                const thisNode = currentlyIterating[i];
                const thisNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(thisNode) ? thisNode.getProvidedColumnGroup() : thisNode;
                const thisNodeParent = thisNodeProvided.getOriginalParent();
                const previousNode = currentlyIterating[lastGroupedColIdx];
                const previousNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(previousNode) ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (thisNodeParent !== previousNodeParent) createGroupToIndex(i);
            }
            if (lastGroupedColIdx < currentlyIterating.length) createGroupToIndex(currentlyIterating.length);
        }
        if (!isStandaloneStructure) this.setupParentsIntoCols(topLevelResultCols, null);
        return topLevelResultCols;
    }
    createProvidedColumnGroup(primaryColumns, colGroupDef, level, existingColumns, columnKeyCreator, existingGroups, source) {
        const groupId = columnKeyCreator.getUniqueKey(colGroupDef.groupId || null, null);
        const colGroupDefMerged = $437b23f6a393c3bf$var$createMergedColGroupDef(this.beans, colGroupDef, groupId);
        const providedGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDefMerged, groupId, false, level);
        this.createBean(providedGroup);
        const existingGroupAndIndex = this.findExistingGroup(colGroupDef, existingGroups);
        if (existingGroupAndIndex) existingGroups.splice(existingGroupAndIndex.idx, 1);
        const existingGroup = existingGroupAndIndex?.group;
        if (existingGroup) providedGroup.setExpanded(existingGroup.isExpanded());
        const children = $437b23f6a393c3bf$var$_recursivelyCreateColumns(this.beans, colGroupDefMerged.children, level + 1, primaryColumns, existingColumns, columnKeyCreator, existingGroups, source);
        providedGroup.setChildren(children);
        return providedGroup;
    }
    balanceColumnTree(unbalancedTree, currentDepth, columnDepth, columnKeyCreator) {
        const result = [];
        for(let i = 0; i < unbalancedTree.length; i++){
            const child = unbalancedTree[i];
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) {
                const originalGroup = child;
                const newChildren = this.balanceColumnTree(originalGroup.getChildren(), currentDepth + 1, columnDepth, columnKeyCreator);
                originalGroup.setChildren(newChildren);
                result.push(originalGroup);
            } else {
                let firstPaddedGroup;
                let currentPaddedGroup;
                for(let j = currentDepth; j < columnDepth; j++){
                    const newColId = columnKeyCreator.getUniqueKey(null, null);
                    const colGroupDefMerged = $437b23f6a393c3bf$var$createMergedColGroupDef(this.beans, null, newColId);
                    const paddedGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDefMerged, newColId, true, j);
                    this.createBean(paddedGroup);
                    if (currentPaddedGroup) currentPaddedGroup.setChildren([
                        paddedGroup
                    ]);
                    currentPaddedGroup = paddedGroup;
                    if (!firstPaddedGroup) firstPaddedGroup = currentPaddedGroup;
                }
                if (firstPaddedGroup && currentPaddedGroup) {
                    result.push(firstPaddedGroup);
                    const hasGroups = unbalancedTree.some((leaf)=>$437b23f6a393c3bf$export$bb4bfad2b594b78e(leaf));
                    if (hasGroups) {
                        currentPaddedGroup.setChildren([
                            child
                        ]);
                        continue;
                    } else {
                        currentPaddedGroup.setChildren(unbalancedTree);
                        break;
                    }
                }
                result.push(child);
            }
        }
        return result;
    }
    findDepth(balancedColumnTree) {
        let depth = 0;
        let pointer = balancedColumnTree;
        while(pointer?.[0] && $437b23f6a393c3bf$export$bb4bfad2b594b78e(pointer[0])){
            depth++;
            pointer = pointer[0].getChildren();
        }
        return depth;
    }
    findMaxDepth(treeChildren, depth) {
        let maxDepthThisLevel = depth;
        for(let i = 0; i < treeChildren.length; i++){
            const abstractColumn = treeChildren[i];
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(abstractColumn)) {
                const originalGroup = abstractColumn;
                const newDepth = this.findMaxDepth(originalGroup.getChildren(), depth + 1);
                if (maxDepthThisLevel < newDepth) maxDepthThisLevel = newDepth;
            }
        }
        return maxDepthThisLevel;
    }
    /**
   * Inserts dummy group columns in the hierarchy above auto-generated columns
   * in order to ensure auto-generated columns are leaf nodes (and therefore are
   * displayed correctly)
   */ balanceTreeForAutoCols(autoCols, depth) {
        const tree = [];
        for (const col of autoCols){
            let nextChild = col;
            for(let i = depth - 1; i >= 0; i--){
                const autoGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(null, `FAKE_PATH_${col.getId()}}_${i}`, true, i);
                this.createBean(autoGroup);
                autoGroup.setChildren([
                    nextChild
                ]);
                nextChild.originalParent = autoGroup;
                nextChild = autoGroup;
            }
            if (depth === 0) col.originalParent = null;
            tree.push(nextChild);
        }
        return tree;
    }
    findExistingGroup(newGroupDef, existingGroups) {
        const newHasId = newGroupDef.groupId != null;
        if (!newHasId) return void 0;
        for(let i = 0; i < existingGroups.length; i++){
            const existingGroup = existingGroups[i];
            const existingDef = existingGroup.getColGroupDef();
            if (!existingDef) continue;
            if (existingGroup.getId() === newGroupDef.groupId) return {
                idx: i,
                group: existingGroup
            };
        }
        return void 0;
    }
    createColumnGroup(providedGroup, groupInstanceIdCreator, oldColumnsMapped, pinned, isStandaloneStructure) {
        const groupId = providedGroup.getGroupId();
        const instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
        const uniqueId = $437b23f6a393c3bf$var$createUniqueColumnGroupId(groupId, instanceId);
        let columnGroup = oldColumnsMapped[uniqueId];
        if (columnGroup && columnGroup.getProvidedColumnGroup() !== providedGroup) columnGroup = null;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(columnGroup)) columnGroup.reset();
        else {
            columnGroup = new $437b23f6a393c3bf$export$273c80940a54c770(providedGroup, groupId, instanceId, pinned);
            if (!isStandaloneStructure) this.createBean(columnGroup);
        }
        return columnGroup;
    }
    // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
    mapOldGroupsById(displayedGroups) {
        const result = {};
        const recursive = (columnsOrGroups)=>{
            for (const columnOrGroup of columnsOrGroups)if ($437b23f6a393c3bf$export$1f44a60fc23f9028(columnOrGroup)) {
                const columnGroup = columnOrGroup;
                result[columnOrGroup.getUniqueId()] = columnGroup;
                recursive(columnGroup.getChildren());
            }
        };
        if (displayedGroups) recursive(displayedGroups);
        return result;
    }
    setupParentsIntoCols(columnsOrGroups, parent) {
        for (const columnsOrGroup of columnsOrGroups ?? []){
            if (columnsOrGroup.parent !== parent) this.beans.colViewport.colsWithinViewportHash = "";
            columnsOrGroup.parent = parent;
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(columnsOrGroup)) {
                const columnGroup = columnsOrGroup;
                this.setupParentsIntoCols(columnGroup.getChildren(), columnGroup);
            }
        }
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupModule.ts
var $437b23f6a393c3bf$export$922da35340a6d14e = {
    moduleName: "ColumnGroup",
    version: $437b23f6a393c3bf$var$VERSION,
    dynamicBeans: {
        headerGroupCellCtrl: $437b23f6a393c3bf$var$HeaderGroupCellCtrl
    },
    beans: [
        $437b23f6a393c3bf$var$ColumnGroupService
    ],
    apiFunctions: {
        getAllDisplayedColumnGroups: $437b23f6a393c3bf$var$getAllDisplayedColumnGroups,
        getCenterDisplayedColumnGroups: $437b23f6a393c3bf$var$getCenterDisplayedColumnGroups,
        getColumnGroup: $437b23f6a393c3bf$var$getColumnGroup,
        getColumnGroupState: $437b23f6a393c3bf$var$getColumnGroupState,
        getDisplayNameForColumnGroup: $437b23f6a393c3bf$var$getDisplayNameForColumnGroup,
        getLeftDisplayedColumnGroups: $437b23f6a393c3bf$var$getLeftDisplayedColumnGroups,
        getProvidedColumnGroup: $437b23f6a393c3bf$var$getProvidedColumnGroup,
        getRightDisplayedColumnGroups: $437b23f6a393c3bf$var$getRightDisplayedColumnGroups,
        resetColumnGroupState: $437b23f6a393c3bf$var$resetColumnGroupState,
        setColumnGroupOpened: $437b23f6a393c3bf$var$setColumnGroupOpened,
        setColumnGroupState: $437b23f6a393c3bf$var$setColumnGroupState
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/skeletonCellRenderer.ts
var $437b23f6a393c3bf$var$SkeletonCellRendererElement = {
    tag: "div",
    cls: "ag-skeleton-container"
};
var $437b23f6a393c3bf$var$SkeletonCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$SkeletonCellRendererElement);
    }
    init(params) {
        const id = `ag-cell-skeleton-renderer-${this.getCompId()}`;
        this.getGui().setAttribute("id", id);
        this.addDestroyFunc(()=>$437b23f6a393c3bf$export$84233c40c4c74001(params.eParentOfValue));
        $437b23f6a393c3bf$export$84233c40c4c74001(params.eParentOfValue, id);
        if (params.deferRender) this.setupLoading(params);
        else params.node.failedLoad ? this.setupFailed() : this.setupLoading(params);
    }
    setupFailed() {
        const localeTextFunc = this.getLocaleTextFunc();
        this.getGui().textContent = localeTextFunc("loadingError", "ERR");
        const ariaFailed = localeTextFunc("ariaSkeletonCellLoadingFailed", "Row failed to load");
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.getGui(), ariaFailed);
    }
    setupLoading(params) {
        const skeletonEffect = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-skeleton-effect"
        });
        const rowIndex = params.node.rowIndex;
        if (rowIndex != null) {
            const width = 75 + 25 * (rowIndex % 2 === 0 ? Math.sin(rowIndex) : Math.cos(rowIndex));
            skeletonEffect.style.width = `${width}%`;
        }
        this.getGui().appendChild(skeletonEffect);
        const localeTextFunc = this.getLocaleTextFunc();
        const ariaLoading = params.deferRender ? localeTextFunc("ariaDeferSkeletonCellLoading", "Cell is loading") : localeTextFunc("ariaSkeletonCellLoading", "Row data is loading");
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.getGui(), ariaLoading);
    }
    refresh(_params) {
        return false;
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/cellRendererModule.ts
var $437b23f6a393c3bf$var$CheckboxCellRendererModule = {
    moduleName: "CheckboxCellRenderer",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCheckboxCellRenderer: $437b23f6a393c3bf$var$CheckboxCellRenderer
    }
};
var $437b23f6a393c3bf$var$SkeletonCellRendererModule = {
    moduleName: "SkeletonCellRenderer",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agSkeletonCellRenderer: $437b23f6a393c3bf$var$SkeletonCellRenderer
    }
};
// packages/ag-grid-community/src/columns/columnApi.ts
function $437b23f6a393c3bf$var$getColumnDef(beans, key) {
    const column = beans.colModel.getColDefCol(key);
    if (column) return column.getColDef();
    return null;
}
function $437b23f6a393c3bf$var$getColumnDefs(beans) {
    return beans.colModel.getColumnDefs(true);
}
function $437b23f6a393c3bf$var$getDisplayNameForColumn(beans, column, location) {
    return beans.colNames.getDisplayNameForColumn(column, location) || "";
}
function $437b23f6a393c3bf$var$getColumn(beans, key) {
    return beans.colModel.getColDefCol(key);
}
function $437b23f6a393c3bf$var$getColumns(beans) {
    return beans.colModel.getColDefCols();
}
function $437b23f6a393c3bf$var$applyColumnState(beans, params) {
    return $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, params, "api");
}
function $437b23f6a393c3bf$var$getColumnState(beans) {
    return $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
}
function $437b23f6a393c3bf$var$resetColumnState(beans) {
    $437b23f6a393c3bf$export$96a6cbc000255060(beans, "api");
}
function $437b23f6a393c3bf$var$isPinning(beans) {
    return beans.visibleCols.isPinningLeft() || beans.visibleCols.isPinningRight();
}
function $437b23f6a393c3bf$var$isPinningLeft(beans) {
    return beans.visibleCols.isPinningLeft();
}
function $437b23f6a393c3bf$var$isPinningRight(beans) {
    return beans.visibleCols.isPinningRight();
}
function $437b23f6a393c3bf$var$getDisplayedColAfter(beans, col) {
    return beans.visibleCols.getColAfter(col);
}
function $437b23f6a393c3bf$var$getDisplayedColBefore(beans, col) {
    return beans.visibleCols.getColBefore(col);
}
function $437b23f6a393c3bf$var$setColumnsVisible(beans, keys, visible) {
    beans.colModel.setColsVisible(keys, visible, "api");
}
function $437b23f6a393c3bf$var$setColumnsPinned(beans, keys, pinned) {
    beans.pinnedCols?.setColsPinned(keys, pinned, "api");
}
function $437b23f6a393c3bf$var$getAllGridColumns(beans) {
    return beans.colModel.getCols();
}
function $437b23f6a393c3bf$var$getDisplayedLeftColumns(beans) {
    return beans.visibleCols.leftCols;
}
function $437b23f6a393c3bf$var$getDisplayedCenterColumns(beans) {
    return beans.visibleCols.centerCols;
}
function $437b23f6a393c3bf$var$getDisplayedRightColumns(beans) {
    return beans.visibleCols.rightCols;
}
function $437b23f6a393c3bf$var$getAllDisplayedColumns(beans) {
    return beans.visibleCols.allCols;
}
function $437b23f6a393c3bf$var$getAllDisplayedVirtualColumns(beans) {
    return beans.colViewport.getViewportColumns();
}
// packages/ag-grid-community/src/columns/columnDefFactory.ts
function $437b23f6a393c3bf$var$_deepCloneDefinition(object, keysToSkip) {
    if (!object) return;
    const obj = object;
    const res = {};
    for (const key of Object.keys(obj)){
        if (keysToSkip && keysToSkip.indexOf(key) >= 0 || $437b23f6a393c3bf$var$SKIP_JS_BUILTINS.has(key)) continue;
        const value = obj[key];
        const sourceIsSimpleObject = typeof value === "object" && value !== null && value.constructor === Object;
        if (sourceIsSimpleObject) res[key] = $437b23f6a393c3bf$var$_deepCloneDefinition(value);
        else res[key] = value;
    }
    return res;
}
var $437b23f6a393c3bf$var$ColumnDefFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colDefFactory";
    }
    wireBeans(beans) {
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.pivotColsSvc = beans.pivotColsSvc;
    }
    getColumnDefs(colDefColsList, showingPivotResult, lastOrder, colsList, sorted = false) {
        const cols = colDefColsList.slice();
        if (showingPivotResult) cols.sort((a, b)=>lastOrder.indexOf(a) - lastOrder.indexOf(b));
        else if (lastOrder || sorted) cols.sort((a, b)=>colsList.indexOf(a) - colsList.indexOf(b));
        const rowGroupColumns = this.rowGroupColsSvc?.columns;
        const pivotColumns = this.pivotColsSvc?.columns;
        return this.buildColumnDefs(cols, rowGroupColumns, pivotColumns);
    }
    buildColumnDefs(cols, rowGroupColumns = [], pivotColumns = []) {
        const res = [];
        const colGroupDefs = {};
        for (const col of cols){
            const colDef = this.createDefFromColumn(col, rowGroupColumns, pivotColumns);
            let addToResult = true;
            let childDef = colDef;
            let pointer = col.getOriginalParent();
            let lastPointer = null;
            while(pointer){
                let parentDef = null;
                if (pointer.isPadding()) {
                    pointer = pointer.getOriginalParent();
                    continue;
                }
                const existingParentDef = colGroupDefs[pointer.getGroupId()];
                if (existingParentDef) {
                    existingParentDef.children.push(childDef);
                    addToResult = false;
                    break;
                }
                parentDef = this.createDefFromGroup(pointer);
                if (parentDef) {
                    parentDef.children = [
                        childDef
                    ];
                    colGroupDefs[parentDef.groupId] = parentDef;
                    childDef = parentDef;
                    pointer = pointer.getOriginalParent();
                }
                if (pointer != null && lastPointer === pointer) {
                    addToResult = false;
                    break;
                }
                lastPointer = pointer;
            }
            if (addToResult) res.push(childDef);
        }
        return res;
    }
    createDefFromGroup(group) {
        const defCloned = $437b23f6a393c3bf$var$_deepCloneDefinition(group.getColGroupDef(), [
            "children"
        ]);
        if (defCloned) defCloned.groupId = group.getGroupId();
        return defCloned;
    }
    createDefFromColumn(col, rowGroupColumns, pivotColumns) {
        const colDefCloned = $437b23f6a393c3bf$var$_deepCloneDefinition(col.getColDef());
        colDefCloned.colId = col.getColId();
        colDefCloned.width = col.getActualWidth();
        colDefCloned.rowGroup = col.isRowGroupActive();
        colDefCloned.rowGroupIndex = col.isRowGroupActive() ? rowGroupColumns.indexOf(col) : null;
        colDefCloned.pivot = col.isPivotActive();
        colDefCloned.pivotIndex = col.isPivotActive() ? pivotColumns.indexOf(col) : null;
        colDefCloned.aggFunc = col.isValueActive() ? col.getAggFunc() : null;
        colDefCloned.hide = col.isVisible() ? void 0 : true;
        colDefCloned.pinned = col.isPinned() ? col.getPinned() : null;
        colDefCloned.sort = col.getSortDef();
        colDefCloned.sortIndex = col.getSortIndex() != null ? col.getSortIndex() : null;
        return colDefCloned;
    }
};
// packages/ag-grid-community/src/columns/columnFlexService.ts
var $437b23f6a393c3bf$var$ColumnFlexService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colFlex";
        this.columnsHidden = false;
    }
    refreshFlexedColumns(params = {}) {
        const source = params.source ?? "flex";
        if (params.viewportWidth != null) this.flexViewportWidth = params.viewportWidth;
        const totalSpace = this.flexViewportWidth;
        const { visibleCols: visibleCols, colDelayRenderSvc: colDelayRenderSvc } = this.beans;
        const visibleCenterCols = visibleCols.centerCols;
        let flexAfterDisplayIndex = -1;
        if (params.resizingCols) {
            const allResizingCols = new Set(params.resizingCols);
            for(let i = visibleCenterCols.length - 1; i >= 0; i--)if (allResizingCols.has(visibleCenterCols[i])) {
                flexAfterDisplayIndex = i;
                break;
            }
        }
        let hasFlexItems = false;
        const items = visibleCenterCols.map((col, i)=>{
            const flex = col.getFlex();
            const isFlex = flex != null && flex > 0 && i > flexAfterDisplayIndex;
            hasFlexItems || (hasFlexItems = isFlex);
            return {
                col: col,
                isFlex: isFlex,
                flex: Math.max(0, flex ?? 0),
                initialSize: col.getActualWidth(),
                min: col.getMinWidth(),
                max: col.getMaxWidth(),
                targetSize: 0
            };
        });
        if (hasFlexItems) {
            colDelayRenderSvc?.hideColumns("colFlex");
            this.columnsHidden = true;
        } else if (this.columnsHidden) this.revealColumns(colDelayRenderSvc);
        if (!totalSpace || !hasFlexItems) return [];
        let unfrozenItemCount = items.length;
        let unfrozenFlex = items.reduce((acc, item)=>acc + item.flex, 0);
        let unfrozenSpace = totalSpace;
        const freeze = (item, width)=>{
            item.frozenSize = width;
            item.col.setActualWidth(width, source);
            unfrozenSpace -= width;
            unfrozenFlex -= item.flex;
            unfrozenItemCount -= 1;
        };
        const isFrozen = (item)=>item.frozenSize != null;
        for (const item of items)if (!item.isFlex) freeze(item, item.initialSize);
        while(unfrozenItemCount > 0){
            const spaceToFill = Math.round(unfrozenFlex < 1 ? unfrozenSpace * unfrozenFlex : unfrozenSpace);
            let lastUnfrozenItem;
            let actualLeft = 0;
            let idealRight = 0;
            for (const item of items){
                if (isFrozen(item)) continue;
                lastUnfrozenItem = item;
                idealRight += spaceToFill * (item.flex / unfrozenFlex);
                const idealSize = idealRight - actualLeft;
                const roundedSize = Math.round(idealSize);
                item.targetSize = roundedSize;
                actualLeft += roundedSize;
            }
            if (lastUnfrozenItem) lastUnfrozenItem.targetSize += spaceToFill - actualLeft;
            let totalViolation = 0;
            for (const item of items){
                if (isFrozen(item)) continue;
                const unclampedSize = item.targetSize;
                const clampedSize = Math.min(Math.max(unclampedSize, item.min), item.max);
                totalViolation += clampedSize - unclampedSize;
                item.violationType = clampedSize === unclampedSize ? void 0 : clampedSize < unclampedSize ? "max" : "min";
                item.targetSize = clampedSize;
            }
            const freezeType = totalViolation === 0 ? "all" : totalViolation > 0 ? "min" : "max";
            for (const item of items){
                if (isFrozen(item)) continue;
                if (freezeType === "all" || item.violationType === freezeType) freeze(item, item.targetSize);
            }
        }
        if (!params.skipSetLeft) visibleCols.setLeftValues(source);
        if (params.updateBodyWidths) visibleCols.updateBodyWidths();
        const unconstrainedFlexColumns = items.filter((item)=>item.isFlex && !item.violationType).map((item)=>item.col);
        if (params.fireResizedEvent) {
            const changedColumns = items.filter((item)=>item.initialSize !== item.frozenSize).map((item)=>item.col);
            const flexingColumns = items.filter((item)=>item.flex).map((item)=>item.col);
            $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, changedColumns, true, source, flexingColumns);
        }
        this.revealColumns(colDelayRenderSvc);
        return unconstrainedFlexColumns;
    }
    revealColumns(colDelayRenderSvc) {
        if (this.columnsHidden) {
            colDelayRenderSvc?.revealColumns("colFlex");
            this.columnsHidden = false;
        }
    }
    initCol(column) {
        const { flex: flex, initialFlex: initialFlex } = column.colDef;
        if (flex !== void 0) column.flex = flex;
        else if (initialFlex !== void 0) column.flex = initialFlex;
    }
    // this method should only be used by the colModel to
    // change flex when required by the applyColumnState method.
    setColFlex(column, flex) {
        column.flex = flex ?? null;
        column.dispatchStateUpdatedEvent("flex");
    }
};
// packages/ag-grid-community/src/agStack/utils/value.ts
function $437b23f6a393c3bf$var$_getValueUsingField(data, field, fieldContainsDots) {
    if (!field || !data) return;
    if (!fieldContainsDots) return data[field];
    const fields = field.split(".");
    let currentObject = data;
    for(let i = 0; i < fields.length; i++){
        if (currentObject == null) return void 0;
        currentObject = currentObject[fields[i]];
    }
    return currentObject;
}
// packages/ag-grid-community/src/columns/dataTypeService.ts
var $437b23f6a393c3bf$var$SORTED_CELL_DATA_TYPES_FOR_MATCHING = [
    "dateTimeString",
    "dateString",
    "text",
    "number",
    "boolean",
    "date"
];
var $437b23f6a393c3bf$var$DataTypeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "dataTypeSvc";
        this.dataTypeDefinitions = {};
        this.isPendingInference = false;
        this.isColumnTypeOverrideInDataTypeDefinitions = false;
        // keep track of any column state updates whilst waiting for data types to be inferred
        this.columnStateUpdatesPendingInference = {};
        this.columnStateUpdateListenerDestroyFuncs = [];
        // using an object here to enforce dev to not forget to implement new types as they are added
        this.columnDefinitionPropsPerDataType = {
            number () {
                return {
                    cellEditor: "agNumberCellEditor"
                };
            },
            boolean () {
                return {
                    cellEditor: "agCheckboxCellEditor",
                    cellRenderer: "agCheckboxCellRenderer",
                    getFindText: ()=>null,
                    suppressKeyboardEvent: (params)=>!!params.colDef.editable && params.event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE
                };
            },
            date ({ formatValue: formatValue }) {
                return {
                    cellEditor: "agDateCellEditor",
                    keyCreator: formatValue
                };
            },
            dateString ({ formatValue: formatValue }) {
                return {
                    cellEditor: "agDateStringCellEditor",
                    keyCreator: formatValue
                };
            },
            dateTime (args) {
                return this.date(args);
            },
            dateTimeString (args) {
                return this.dateString(args);
            },
            object ({ formatValue: formatValue, colModel: colModel, colId: colId }) {
                return {
                    cellEditorParams: {
                        useFormatter: true
                    },
                    comparator: (a, b)=>{
                        const column = colModel.getColDefCol(colId);
                        const colDef = column?.getColDef();
                        if (!column || !colDef) return 0;
                        const valA = a == null ? "" : formatValue({
                            column: column,
                            node: null,
                            value: a
                        });
                        const valB = b == null ? "" : formatValue({
                            column: column,
                            node: null,
                            value: b
                        });
                        if (valA === valB) return 0;
                        return valA > valB ? 1 : -1;
                    },
                    keyCreator: formatValue
                };
            },
            text () {
                return {};
            }
        };
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
    }
    postConstruct() {
        this.processDataTypeDefinitions();
        this.addManagedPropertyListener("dataTypeDefinitions", (event)=>{
            this.processDataTypeDefinitions();
            this.colModel.recreateColumnDefs(event);
        });
    }
    processDataTypeDefinitions() {
        const defaultDataTypes = this.getDefaultDataTypes();
        const newDataTypeDefinitions = {};
        const newFormatValueFuncs = {};
        const generateFormatValueFunc = (dataTypeDefinition)=>{
            return (params)=>{
                const { column: column, node: node, value: value } = params;
                let valueFormatter = column.getColDef().valueFormatter;
                if (valueFormatter === dataTypeDefinition.groupSafeValueFormatter) valueFormatter = dataTypeDefinition.valueFormatter;
                return this.beans.valueSvc.formatValue(column, node, value, valueFormatter);
            };
        };
        for (const cellDataType of Object.keys(defaultDataTypes)){
            const defaultDataTypeDef = defaultDataTypes[cellDataType];
            const mergedDataTypeDefinition = {
                ...defaultDataTypeDef,
                groupSafeValueFormatter: $437b23f6a393c3bf$var$createGroupSafeValueFormatter(defaultDataTypeDef, this.gos)
            };
            newDataTypeDefinitions[cellDataType] = mergedDataTypeDefinition;
            newFormatValueFuncs[cellDataType] = generateFormatValueFunc(mergedDataTypeDefinition);
        }
        const userDataTypeDefs = this.gos.get("dataTypeDefinitions") ?? {};
        const newDataTypeMatchers = {};
        for (const cellDataType of Object.keys(userDataTypeDefs)){
            const userDataTypeDef = userDataTypeDefs[cellDataType];
            const mergedDataTypeDefinition = this.processDataTypeDefinition(userDataTypeDef, userDataTypeDefs, [
                cellDataType
            ], defaultDataTypes);
            if (mergedDataTypeDefinition) {
                newDataTypeDefinitions[cellDataType] = mergedDataTypeDefinition;
                if (userDataTypeDef.dataTypeMatcher) newDataTypeMatchers[cellDataType] = userDataTypeDef.dataTypeMatcher;
                newFormatValueFuncs[cellDataType] = generateFormatValueFunc(mergedDataTypeDefinition);
            }
        }
        const { valueParser: defaultValueParser, valueFormatter: defaultValueFormatter } = defaultDataTypes.object;
        const { valueParser: userValueParser, valueFormatter: userValueFormatter } = newDataTypeDefinitions.object;
        this.hasObjectValueParser = userValueParser !== defaultValueParser;
        this.hasObjectValueFormatter = userValueFormatter !== defaultValueFormatter;
        this.formatValueFuncs = newFormatValueFuncs;
        this.dataTypeDefinitions = newDataTypeDefinitions;
        this.dataTypeMatchers = this.sortKeysInMatchers(newDataTypeMatchers, defaultDataTypes);
    }
    /**
   * Sorts the keys in the matchers object.
   * Does not mutate the original object, creates a copy of it with sorted keys instead.
   */ sortKeysInMatchers(matchers, dataTypes) {
        const sortedMatchers = {
            ...matchers
        };
        for (const cellDataType of $437b23f6a393c3bf$var$SORTED_CELL_DATA_TYPES_FOR_MATCHING){
            delete sortedMatchers[cellDataType];
            sortedMatchers[cellDataType] = matchers[cellDataType] ?? dataTypes[cellDataType].dataTypeMatcher;
        }
        return sortedMatchers;
    }
    processDataTypeDefinition(userDataTypeDef, userDataTypeDefs, alreadyProcessedDataTypes, defaultDataTypes) {
        let mergedDataTypeDefinition;
        const extendsCellDataType = userDataTypeDef.extendsDataType;
        if (userDataTypeDef.columnTypes) this.isColumnTypeOverrideInDataTypeDefinitions = true;
        if (userDataTypeDef.extendsDataType === userDataTypeDef.baseDataType) {
            let baseDataTypeDefinition = defaultDataTypes[extendsCellDataType];
            const overriddenBaseDataTypeDefinition = userDataTypeDefs[extendsCellDataType];
            if (baseDataTypeDefinition && overriddenBaseDataTypeDefinition) baseDataTypeDefinition = overriddenBaseDataTypeDefinition;
            if (!$437b23f6a393c3bf$var$validateDataTypeDefinition(userDataTypeDef, baseDataTypeDefinition, extendsCellDataType)) return void 0;
            mergedDataTypeDefinition = $437b23f6a393c3bf$var$mergeDataTypeDefinitions(baseDataTypeDefinition, userDataTypeDef);
        } else {
            if (alreadyProcessedDataTypes.includes(extendsCellDataType)) {
                $437b23f6a393c3bf$export$545083624300f13d(44);
                return void 0;
            }
            const extendedDataTypeDefinition = userDataTypeDefs[extendsCellDataType];
            if (!$437b23f6a393c3bf$var$validateDataTypeDefinition(userDataTypeDef, extendedDataTypeDefinition, extendsCellDataType)) return void 0;
            const mergedExtendedDataTypeDefinition = this.processDataTypeDefinition(extendedDataTypeDefinition, userDataTypeDefs, [
                ...alreadyProcessedDataTypes,
                extendsCellDataType
            ], defaultDataTypes);
            if (!mergedExtendedDataTypeDefinition) return void 0;
            mergedDataTypeDefinition = $437b23f6a393c3bf$var$mergeDataTypeDefinitions(mergedExtendedDataTypeDefinition, userDataTypeDef);
        }
        return {
            ...mergedDataTypeDefinition,
            groupSafeValueFormatter: $437b23f6a393c3bf$var$createGroupSafeValueFormatter(mergedDataTypeDefinition, this.gos)
        };
    }
    updateColDefAndGetColumnType(colDef, userColDef, colId) {
        let { cellDataType: cellDataType } = userColDef;
        const { field: field } = userColDef;
        if (cellDataType === void 0) cellDataType = colDef.cellDataType;
        if (cellDataType == null || cellDataType === true) cellDataType = this.canInferCellDataType(colDef, userColDef) ? this.inferCellDataType(field, colId) : false;
        if (!cellDataType) {
            colDef.cellDataType = false;
            return void 0;
        }
        const dataTypeDefinition = this.dataTypeDefinitions[cellDataType];
        if (!dataTypeDefinition) {
            $437b23f6a393c3bf$export$545083624300f13d(47, {
                cellDataType: cellDataType
            });
            return void 0;
        }
        colDef.cellDataType = cellDataType;
        if (dataTypeDefinition.groupSafeValueFormatter) colDef.valueFormatter = dataTypeDefinition.groupSafeValueFormatter;
        if (dataTypeDefinition.valueParser) colDef.valueParser = dataTypeDefinition.valueParser;
        if (!dataTypeDefinition.suppressDefaultProperties) this.setColDefPropertiesForBaseDataType(colDef, cellDataType, dataTypeDefinition, colId);
        return dataTypeDefinition.columnTypes;
    }
    addColumnListeners(column) {
        if (!this.isPendingInference) return;
        const columnStateUpdates = this.columnStateUpdatesPendingInference[column.getColId()];
        if (!columnStateUpdates) return;
        const columnListener = (event)=>{
            columnStateUpdates.add(event.key);
        };
        column.__addEventListener("columnStateUpdated", columnListener);
        this.columnStateUpdateListenerDestroyFuncs.push(()=>column.__removeEventListener("columnStateUpdated", columnListener));
    }
    canInferCellDataType(colDef, userColDef) {
        const { gos: gos } = this;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos)) return false;
        const propsToCheckForInference = {
            cellRenderer: true,
            valueGetter: true,
            valueParser: true,
            refData: true
        };
        if ($437b23f6a393c3bf$var$doColDefPropsPreventInference(userColDef, propsToCheckForInference)) return false;
        const columnTypes = userColDef.type === null ? colDef.type : userColDef.type;
        if (columnTypes) {
            const columnTypeDefs = gos.get("columnTypes") ?? {};
            const hasPropsPreventingInference = $437b23f6a393c3bf$var$convertColumnTypes(columnTypes).some((columnType)=>{
                const columnTypeDef = columnTypeDefs[columnType.trim()];
                return columnTypeDef && $437b23f6a393c3bf$var$doColDefPropsPreventInference(columnTypeDef, propsToCheckForInference);
            });
            if (hasPropsPreventingInference) return false;
        }
        return !$437b23f6a393c3bf$var$doColDefPropsPreventInference(colDef, propsToCheckForInference);
    }
    inferCellDataType(field, colId) {
        if (!field) return void 0;
        let value;
        const initialData = this.getInitialData();
        if (initialData) {
            const fieldContainsDots = field.includes(".") && !this.gos.get("suppressFieldDotNotation");
            value = $437b23f6a393c3bf$var$_getValueUsingField(initialData, field, fieldContainsDots);
        } else this.initWaitForRowData(colId);
        if (value == null) return void 0;
        const matchedType = Object.keys(this.dataTypeMatchers).find((_cellDataType)=>this.dataTypeMatchers[_cellDataType](value));
        return matchedType ?? "object";
    }
    getInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData?.length) return rowData[0];
        else if (this.initialData) return this.initialData;
        else {
            const rowNodes = this.beans.rowModel.rootNode?._leafs;
            if (rowNodes?.length) return rowNodes[0].data;
        }
        return null;
    }
    initWaitForRowData(colId) {
        this.columnStateUpdatesPendingInference[colId] = /* @__PURE__ */ new Set();
        if (this.isPendingInference) return;
        this.isPendingInference = true;
        const columnTypeOverridesExist = this.isColumnTypeOverrideInDataTypeDefinitions;
        const { colAutosize: colAutosize, eventSvc: eventSvc } = this.beans;
        if (columnTypeOverridesExist && colAutosize) colAutosize.shouldQueueResizeOperations = true;
        const [destroyFunc] = this.addManagedEventListeners({
            rowDataUpdateStarted: (event)=>{
                const { firstRowData: firstRowData } = event;
                if (!firstRowData) return;
                destroyFunc?.();
                this.isPendingInference = false;
                this.processColumnsPendingInference(firstRowData, columnTypeOverridesExist);
                this.columnStateUpdatesPendingInference = {};
                if (columnTypeOverridesExist) colAutosize?.processResizeOperations();
                eventSvc.dispatchEvent({
                    type: "dataTypesInferred"
                });
            }
        });
    }
    processColumnsPendingInference(firstRowData, columnTypeOverridesExist) {
        this.initialData = firstRowData;
        const state = [];
        this.destroyColumnStateUpdateListeners();
        const newRowGroupColumnStateWithoutIndex = {};
        const newPivotColumnStateWithoutIndex = {};
        for (const colId of Object.keys(this.columnStateUpdatesPendingInference)){
            const columnStateUpdates = this.columnStateUpdatesPendingInference[colId];
            const column = this.colModel.getCol(colId);
            if (!column) return;
            const oldColDef = column.getColDef();
            if (!this.resetColDefIntoCol(column, "cellDataTypeInferred")) return;
            const newColDef = column.getColDef();
            if (columnTypeOverridesExist && newColDef.type && newColDef.type !== oldColDef.type) {
                const updatedColumnState = $437b23f6a393c3bf$var$getUpdatedColumnState(column, columnStateUpdates);
                if (updatedColumnState.rowGroup && updatedColumnState.rowGroupIndex == null) newRowGroupColumnStateWithoutIndex[colId] = updatedColumnState;
                if (updatedColumnState.pivot && updatedColumnState.pivotIndex == null) newPivotColumnStateWithoutIndex[colId] = updatedColumnState;
                state.push(updatedColumnState);
            }
        }
        if (columnTypeOverridesExist) state.push(...this.generateColumnStateForRowGroupAndPivotIndexes(newRowGroupColumnStateWithoutIndex, newPivotColumnStateWithoutIndex));
        if (state.length) $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
            state: state
        }, "cellDataTypeInferred");
        this.initialData = null;
    }
    generateColumnStateForRowGroupAndPivotIndexes(updatedRowGroupColumnState, updatedPivotColumnState) {
        const existingColumnStateUpdates = {};
        const { rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = this.beans;
        rowGroupColsSvc?.restoreColumnOrder(existingColumnStateUpdates, updatedRowGroupColumnState);
        pivotColsSvc?.restoreColumnOrder(existingColumnStateUpdates, updatedPivotColumnState);
        return Object.values(existingColumnStateUpdates);
    }
    resetColDefIntoCol(column, source) {
        const userColDef = column.getUserProvidedColDef();
        if (!userColDef) return false;
        const newColDef = $437b23f6a393c3bf$export$310bdd432cb2279e(this.beans, userColDef, column.getColId());
        column.setColDef(newColDef, userColDef, source);
        return true;
    }
    getDateStringTypeDefinition(column) {
        const { dateString: dateString } = this.dataTypeDefinitions;
        if (!column) return dateString;
        return this.getDataTypeDefinition(column) ?? dateString;
    }
    getDateParserFunction(column) {
        return this.getDateStringTypeDefinition(column).dateParser;
    }
    getDateFormatterFunction(column) {
        return this.getDateStringTypeDefinition(column).dateFormatter;
    }
    getDateIncludesTimeFlag(cellDataType) {
        return cellDataType === "dateTime" || cellDataType === "dateTimeString";
    }
    getDataTypeDefinition(column) {
        const colDef = column.getColDef();
        if (!colDef.cellDataType) return void 0;
        return this.dataTypeDefinitions[colDef.cellDataType];
    }
    getBaseDataType(column) {
        return this.getDataTypeDefinition(column)?.baseDataType;
    }
    checkType(column, value) {
        if (value == null) return true;
        const dataTypeMatcher = this.getDataTypeDefinition(column)?.dataTypeMatcher;
        if (!dataTypeMatcher) return true;
        if (column.getColDef().allowFormula && this.beans.formula?.isFormula(value)) return true;
        return dataTypeMatcher(value);
    }
    validateColDef(colDef) {
        const warning = (property)=>$437b23f6a393c3bf$export$545083624300f13d(48, {
                property: property
            });
        if (colDef.cellDataType === "object") {
            const { object: object } = this.dataTypeDefinitions;
            if (colDef.valueFormatter === object.groupSafeValueFormatter && !this.hasObjectValueFormatter) warning("Formatter");
            if (colDef.editable && colDef.valueParser === object.valueParser && !this.hasObjectValueParser) warning("Parser");
        }
    }
    postProcess(colDef) {
        const cellDataType = colDef.cellDataType;
        if (!cellDataType || typeof cellDataType !== "string") return;
        const { dataTypeDefinitions: dataTypeDefinitions, beans: beans, formatValueFuncs: formatValueFuncs } = this;
        const dataTypeDefinition = dataTypeDefinitions[cellDataType];
        if (!dataTypeDefinition) return;
        beans.colFilter?.setColDefPropsForDataType(colDef, dataTypeDefinition, formatValueFuncs[cellDataType]);
    }
    // noinspection JSUnusedGlobalSymbols
    getFormatValue(cellDataType) {
        return this.formatValueFuncs[cellDataType];
    }
    isColPendingInference(colId) {
        return this.isPendingInference && !!this.columnStateUpdatesPendingInference[colId];
    }
    setColDefPropertiesForBaseDataType(colDef, cellDataType, dataTypeDefinition, colId) {
        const formatValue = this.formatValueFuncs[cellDataType];
        const partialColDef = this.columnDefinitionPropsPerDataType[dataTypeDefinition.baseDataType]({
            colDef: colDef,
            cellDataType: cellDataType,
            colModel: this.colModel,
            dataTypeDefinition: dataTypeDefinition,
            colId: colId,
            formatValue: formatValue
        });
        Object.assign(colDef, partialColDef);
    }
    getDateObjectTypeDef(baseDataType) {
        const translate = this.getLocaleTextFunc();
        const includeTime = this.getDateIncludesTimeFlag(baseDataType);
        return {
            baseDataType: baseDataType,
            valueParser: (params)=>$437b23f6a393c3bf$export$26ded2d88c01b527(params.newValue && String(params.newValue)),
            valueFormatter: (params)=>{
                if (params.value == null) return "";
                if (!(params.value instanceof Date) || isNaN(params.value.getTime())) return translate("invalidDate", "Invalid Date");
                return $437b23f6a393c3bf$export$3d7fedfb21962874(params.value, includeTime) ?? "";
            },
            dataTypeMatcher: (value)=>value instanceof Date
        };
    }
    getDateStringTypeDef(baseDataType) {
        const includeTime = this.getDateIncludesTimeFlag(baseDataType);
        return {
            baseDataType: baseDataType,
            dateParser: (value)=>$437b23f6a393c3bf$export$26ded2d88c01b527(value) ?? void 0,
            dateFormatter: (value)=>$437b23f6a393c3bf$export$3d7fedfb21962874(value ?? null, includeTime) ?? void 0,
            valueParser: (params)=>$437b23f6a393c3bf$var$_isValidDate(String(params.newValue)) ? params.newValue : null,
            valueFormatter: (params)=>$437b23f6a393c3bf$var$_isValidDate(String(params.value)) ? String(params.value) : "",
            dataTypeMatcher: (value)=>typeof value === "string" && $437b23f6a393c3bf$var$_isValidDate(value)
        };
    }
    getDefaultDataTypes() {
        const translate = this.getLocaleTextFunc();
        return {
            number: {
                baseDataType: "number",
                // can be empty space with legacy copy
                valueParser: (params)=>params.newValue?.trim?.() === "" ? null : Number(params.newValue),
                valueFormatter: (params)=>{
                    if (params.value == null) return "";
                    if (typeof params.value !== "number" || isNaN(params.value)) return translate("invalidNumber", "Invalid Number");
                    return String(params.value);
                },
                dataTypeMatcher: (value)=>typeof value === "number"
            },
            text: {
                baseDataType: "text",
                valueParser: (params)=>params.newValue === "" ? null : $437b23f6a393c3bf$export$2a74c29220d5c88e(params.newValue),
                dataTypeMatcher: (value)=>typeof value === "string"
            },
            boolean: {
                baseDataType: "boolean",
                valueParser: (params)=>{
                    if (params.newValue == null) return params.newValue;
                    return params.newValue?.trim?.() === "" ? null : String(params.newValue).toLowerCase() === "true";
                },
                valueFormatter: (params)=>params.value == null ? "" : String(params.value),
                dataTypeMatcher: (value)=>typeof value === "boolean"
            },
            date: this.getDateObjectTypeDef("date"),
            dateString: this.getDateStringTypeDef("dateString"),
            dateTime: this.getDateObjectTypeDef("dateTime"),
            dateTimeString: {
                ...this.getDateStringTypeDef("dateTimeString"),
                dataTypeMatcher: (value)=>typeof value === "string" && $437b23f6a393c3bf$var$_isValidDateTime(value)
            },
            object: {
                baseDataType: "object",
                valueParser: ()=>null,
                valueFormatter: (params)=>$437b23f6a393c3bf$export$2a74c29220d5c88e(params.value) ?? ""
            }
        };
    }
    destroyColumnStateUpdateListeners() {
        for (const destroyFunc of this.columnStateUpdateListenerDestroyFuncs)destroyFunc();
        this.columnStateUpdateListenerDestroyFuncs = [];
    }
    destroy() {
        this.dataTypeDefinitions = {};
        this.dataTypeMatchers = {};
        this.formatValueFuncs = {};
        this.columnStateUpdatesPendingInference = {};
        this.destroyColumnStateUpdateListeners();
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$mergeDataTypeDefinitions(parentDataTypeDefinition, childDataTypeDefinition) {
    const mergedDataTypeDefinition = {
        ...parentDataTypeDefinition,
        ...childDataTypeDefinition
    };
    if (parentDataTypeDefinition.columnTypes && childDataTypeDefinition.columnTypes && childDataTypeDefinition.appendColumnTypes) mergedDataTypeDefinition.columnTypes = [
        ...$437b23f6a393c3bf$var$convertColumnTypes(parentDataTypeDefinition.columnTypes),
        ...$437b23f6a393c3bf$var$convertColumnTypes(childDataTypeDefinition.columnTypes)
    ];
    return mergedDataTypeDefinition;
}
function $437b23f6a393c3bf$var$validateDataTypeDefinition(dataTypeDefinition, parentDataTypeDefinition, parentCellDataType) {
    if (!parentDataTypeDefinition) {
        $437b23f6a393c3bf$export$545083624300f13d(45, {
            parentCellDataType: parentCellDataType
        });
        return false;
    }
    if (parentDataTypeDefinition.baseDataType !== dataTypeDefinition.baseDataType) {
        $437b23f6a393c3bf$export$545083624300f13d(46);
        return false;
    }
    return true;
}
function $437b23f6a393c3bf$var$createGroupSafeValueFormatter(dataTypeDefinition, gos) {
    if (!dataTypeDefinition.valueFormatter) return void 0;
    return (params)=>{
        if (params.node?.group) {
            const aggFunc = (params.colDef.pivotValueColumn ?? params.column).getAggFunc();
            if (aggFunc) {
                if (aggFunc === "first" || aggFunc === "last") return dataTypeDefinition.valueFormatter(params);
                if (dataTypeDefinition.baseDataType === "number" && aggFunc !== "count") {
                    if (typeof params.value === "number") return dataTypeDefinition.valueFormatter(params);
                    if (typeof params.value === "object") {
                        if (!params.value) return void 0;
                        if ("toNumber" in params.value) return dataTypeDefinition.valueFormatter({
                            ...params,
                            value: params.value.toNumber()
                        });
                        if ("value" in params.value) return dataTypeDefinition.valueFormatter({
                            ...params,
                            value: params.value.value
                        });
                    }
                }
                return void 0;
            }
        } else if (gos.get("groupHideOpenParents") && params.column.isRowGroupActive()) {
            if (typeof params.value === "string" && !dataTypeDefinition.dataTypeMatcher?.(params.value)) return void 0;
        }
        return dataTypeDefinition.valueFormatter(params);
    };
}
function $437b23f6a393c3bf$var$doesColDefPropPreventInference(colDef, checkProps, prop, comparisonValue) {
    if (!checkProps[prop]) return false;
    const value = colDef[prop];
    if (value === null) {
        checkProps[prop] = false;
        return false;
    } else return comparisonValue === void 0 ? !!value : value === comparisonValue;
}
function $437b23f6a393c3bf$var$doColDefPropsPreventInference(colDef, propsToCheckForInference) {
    return [
        [
            "cellRenderer",
            "agSparklineCellRenderer"
        ],
        [
            "valueGetter",
            void 0
        ],
        [
            "valueParser",
            void 0
        ],
        [
            "refData",
            void 0
        ]
    ].some(([prop, comparisonValue])=>$437b23f6a393c3bf$var$doesColDefPropPreventInference(colDef, propsToCheckForInference, prop, comparisonValue));
}
function $437b23f6a393c3bf$var$getUpdatedColumnState(column, columnStateUpdates) {
    const columnState = $437b23f6a393c3bf$var$getColumnStateFromColDef(column);
    for (const key of columnStateUpdates){
        delete columnState[key];
        if (key === "rowGroup") delete columnState.rowGroupIndex;
        else if (key === "pivot") delete columnState.pivotIndex;
    }
    return columnState;
}
// packages/ag-grid-community/src/columns/columnModule.ts
var $437b23f6a393c3bf$var$DataTypeModule = {
    moduleName: "DataType",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DataTypeService
    ],
    dependsOn: [
        $437b23f6a393c3bf$var$CheckboxCellRendererModule
    ]
};
var $437b23f6a393c3bf$var$ColumnFlexModule = {
    moduleName: "ColumnFlex",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnFlexService
    ]
};
var $437b23f6a393c3bf$export$5c4abee658e86c68 = {
    moduleName: "ColumnApi",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnDefFactory
    ],
    apiFunctions: {
        getColumnDef: $437b23f6a393c3bf$var$getColumnDef,
        getDisplayNameForColumn: $437b23f6a393c3bf$var$getDisplayNameForColumn,
        getColumn: $437b23f6a393c3bf$var$getColumn,
        getColumns: $437b23f6a393c3bf$var$getColumns,
        applyColumnState: $437b23f6a393c3bf$var$applyColumnState,
        getColumnState: $437b23f6a393c3bf$var$getColumnState,
        resetColumnState: $437b23f6a393c3bf$var$resetColumnState,
        isPinning: $437b23f6a393c3bf$var$isPinning,
        isPinningLeft: $437b23f6a393c3bf$var$isPinningLeft,
        isPinningRight: $437b23f6a393c3bf$var$isPinningRight,
        getDisplayedColAfter: $437b23f6a393c3bf$var$getDisplayedColAfter,
        getDisplayedColBefore: $437b23f6a393c3bf$var$getDisplayedColBefore,
        setColumnsVisible: $437b23f6a393c3bf$var$setColumnsVisible,
        setColumnsPinned: $437b23f6a393c3bf$var$setColumnsPinned,
        getAllGridColumns: $437b23f6a393c3bf$var$getAllGridColumns,
        getDisplayedLeftColumns: $437b23f6a393c3bf$var$getDisplayedLeftColumns,
        getDisplayedCenterColumns: $437b23f6a393c3bf$var$getDisplayedCenterColumns,
        getDisplayedRightColumns: $437b23f6a393c3bf$var$getDisplayedRightColumns,
        getAllDisplayedColumns: $437b23f6a393c3bf$var$getAllDisplayedColumns,
        getAllDisplayedVirtualColumns: $437b23f6a393c3bf$var$getAllDisplayedVirtualColumns,
        getColumnDefs: $437b23f6a393c3bf$var$getColumnDefs
    }
};
// packages/ag-grid-community/src/columns/columnNameService.ts
function $437b23f6a393c3bf$var$_camelCaseToHumanText(camelCase) {
    if (!camelCase || camelCase == null) return null;
    const rex = /([a-z])([A-Z])/g;
    const rexCaps = /([A-Z]+)([A-Z])([a-z])/g;
    const words = camelCase.replace(rex, "$1 $2").replace(rexCaps, "$1 $2$3").replace(/\./g, " ").split(" ");
    return words.map((word)=>word.substring(0, 1).toUpperCase() + (word.length > 1 ? word.substring(1, word.length) : "")).join(" ");
}
var $437b23f6a393c3bf$var$ColumnNameService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colNames";
    }
    getDisplayNameForColumn(column, location, includeAggFunc = false) {
        if (!column) return null;
        const headerName = this.getHeaderName(column.getColDef(), column, null, null, location);
        const { aggColNameSvc: aggColNameSvc } = this.beans;
        if (includeAggFunc && aggColNameSvc) return aggColNameSvc.getHeaderName(column, headerName);
        return headerName;
    }
    getDisplayNameForProvidedColumnGroup(columnGroup, providedColumnGroup, location) {
        const colGroupDef = providedColumnGroup?.getColGroupDef();
        if (colGroupDef) return this.getHeaderName(colGroupDef, null, columnGroup, providedColumnGroup, location);
        return null;
    }
    getDisplayNameForColumnGroup(columnGroup, location) {
        return this.getDisplayNameForProvidedColumnGroup(columnGroup, columnGroup.getProvidedColumnGroup(), location);
    }
    // location is where the column is going to appear, ie who is calling us
    getHeaderName(colDef, column, columnGroup, providedColumnGroup, location) {
        const headerValueGetter = colDef.headerValueGetter;
        if (headerValueGetter) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                colDef: colDef,
                column: column,
                columnGroup: columnGroup,
                providedColumnGroup: providedColumnGroup,
                location: location
            });
            if (typeof headerValueGetter === "function") return headerValueGetter(params);
            else if (typeof headerValueGetter === "string") return this.beans.expressionSvc?.evaluate(headerValueGetter, params) ?? null;
            return "";
        } else if (colDef.headerName != null) return colDef.headerName;
        else if (colDef.field) return $437b23f6a393c3bf$var$_camelCaseToHumanText(colDef.field);
        return "";
    }
};
// packages/ag-grid-community/src/columns/columnViewportService.ts
var $437b23f6a393c3bf$var$ColumnViewportService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colViewport";
        // cols in center that are in the viewport
        this.colsWithinViewport = [];
        // same as colsWithinViewport, except we always include columns with headerAutoHeight
        this.headerColsWithinViewport = [];
        // A hash key to keep track of changes in viewport columns
        this.colsWithinViewportHash = "";
        // all columns & groups to be rendered, index by row.
        // used by header rows to get all items to render for that row.
        this.rowsOfHeadersToRenderLeft = {};
        this.rowsOfHeadersToRenderRight = {};
        this.rowsOfHeadersToRenderCenter = {};
        this.columnsToRenderLeft = [];
        this.columnsToRenderRight = [];
        this.columnsToRenderCenter = [];
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.colModel = beans.colModel;
    }
    postConstruct() {
        this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
    }
    setScrollPosition(scrollWidth, scrollPosition, afterScroll = false) {
        const { visibleCols: visibleCols } = this;
        const bodyWidthDirty = visibleCols.isBodyWidthDirty;
        const noChange = scrollWidth === this.scrollWidth && scrollPosition === this.scrollPosition && !bodyWidthDirty;
        if (noChange) return;
        this.scrollWidth = scrollWidth;
        this.scrollPosition = scrollPosition;
        visibleCols.isBodyWidthDirty = true;
        if (this.gos.get("enableRtl")) {
            const bodyWidth = visibleCols.bodyWidth;
            this.viewportLeft = bodyWidth - scrollPosition - scrollWidth;
            this.viewportRight = bodyWidth - scrollPosition;
        } else {
            this.viewportLeft = scrollPosition;
            this.viewportRight = scrollWidth + scrollPosition;
        }
        if (this.colModel.ready) this.checkViewportColumns(afterScroll);
    }
    /**
   * Returns the columns that are currently rendered in the viewport.
   */ getColumnHeadersToRender(type) {
        switch(type){
            case "left":
                return this.columnsToRenderLeft;
            case "right":
                return this.columnsToRenderRight;
            default:
                return this.columnsToRenderCenter;
        }
    }
    /**
   * Returns the column groups that are currently rendered in the viewport at a specific header row index.
   */ getHeadersToRender(type, depth) {
        let result;
        switch(type){
            case "left":
                result = this.rowsOfHeadersToRenderLeft[depth];
                break;
            case "right":
                result = this.rowsOfHeadersToRenderRight[depth];
                break;
            default:
                result = this.rowsOfHeadersToRenderCenter[depth];
                break;
        }
        return result ?? [];
    }
    extractViewportColumns() {
        const displayedColumnsCenter = this.visibleCols.centerCols;
        if (this.isColumnVirtualisationSuppressed()) {
            this.colsWithinViewport = displayedColumnsCenter;
            this.headerColsWithinViewport = displayedColumnsCenter;
        } else {
            this.colsWithinViewport = displayedColumnsCenter.filter(this.isColumnInRowViewport.bind(this));
            this.headerColsWithinViewport = displayedColumnsCenter.filter(this.isColumnInHeaderViewport.bind(this));
        }
    }
    isColumnVirtualisationSuppressed() {
        return this.suppressColumnVirtualisation || this.viewportRight === 0;
    }
    clear() {
        this.rowsOfHeadersToRenderLeft = {};
        this.rowsOfHeadersToRenderRight = {};
        this.rowsOfHeadersToRenderCenter = {};
        this.colsWithinViewportHash = "";
    }
    isColumnInHeaderViewport(col) {
        if (col.isAutoHeaderHeight() || $437b23f6a393c3bf$var$isAnyParentAutoHeaderHeight(col)) return true;
        return this.isColumnInRowViewport(col);
    }
    isColumnInRowViewport(col) {
        if (col.isAutoHeight()) return true;
        const columnLeft = col.getLeft() || 0;
        const columnRight = columnLeft + col.getActualWidth();
        const leftBounds = this.viewportLeft - 200;
        const rightBounds = this.viewportRight + 200;
        const columnToMuchLeft = columnLeft < leftBounds && columnRight < leftBounds;
        const columnToMuchRight = columnLeft > rightBounds && columnRight > rightBounds;
        return !columnToMuchLeft && !columnToMuchRight;
    }
    // used by Grid API only
    getViewportColumns() {
        const { leftCols: leftCols, rightCols: rightCols } = this.visibleCols;
        const res = this.colsWithinViewport.concat(leftCols).concat(rightCols);
        return res;
    }
    // + rowRenderer
    // if we are not column spanning, this just returns back the virtual centre columns,
    // however if we are column spanning, then different rows can have different virtual
    // columns, so we have to work out the list for each individual row.
    getColsWithinViewport(rowNode) {
        if (!this.colModel.colSpanActive) return this.colsWithinViewport;
        const emptySpaceBeforeColumn = (col)=>{
            const left = col.getLeft();
            return $437b23f6a393c3bf$export$25d27f17d3af40f7(left) && left > this.viewportLeft;
        };
        const inViewportCallback = this.isColumnVirtualisationSuppressed() ? void 0 : this.isColumnInRowViewport.bind(this);
        const { visibleCols: visibleCols } = this;
        const displayedColumnsCenter = visibleCols.centerCols;
        return visibleCols.getColsForRow(rowNode, displayedColumnsCenter, inViewportCallback, emptySpaceBeforeColumn);
    }
    // checks what columns are currently displayed due to column virtualisation. dispatches an event
    // if the list of columns has changed.
    // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
    checkViewportColumns(afterScroll = false) {
        const viewportColumnsChanged = this.extractViewport();
        if (viewportColumnsChanged) this.eventSvc.dispatchEvent({
            type: "virtualColumnsChanged",
            afterScroll: afterScroll
        });
    }
    calculateHeaderRows() {
        const { leftCols: leftCols, rightCols: rightCols } = this.visibleCols;
        this.columnsToRenderLeft = leftCols;
        this.columnsToRenderRight = rightCols;
        this.columnsToRenderCenter = this.colsWithinViewport;
        const workOutGroupsToRender = (cols)=>{
            const groupsToRenderSet = /* @__PURE__ */ new Set();
            const groupsToRender = {};
            for (const col of cols){
                let group = col.getParent();
                const skipFillers = col.isSpanHeaderHeight();
                while(group){
                    if (groupsToRenderSet.has(group)) break;
                    const skipFillerGroup = skipFillers && group.isPadding();
                    if (skipFillerGroup) {
                        group = group.getParent();
                        continue;
                    }
                    const level = group.getProvidedColumnGroup().getLevel();
                    groupsToRender[level] ?? (groupsToRender[level] = []);
                    groupsToRender[level].push(group);
                    groupsToRenderSet.add(group);
                    group = group.getParent();
                }
            }
            return groupsToRender;
        };
        this.rowsOfHeadersToRenderLeft = workOutGroupsToRender(leftCols);
        this.rowsOfHeadersToRenderRight = workOutGroupsToRender(rightCols);
        this.rowsOfHeadersToRenderCenter = workOutGroupsToRender(this.headerColsWithinViewport);
    }
    extractViewport() {
        const hashColumn = (c)=>`${c.getId()}-${c.getPinned() || "normal"}`;
        this.extractViewportColumns();
        const newHash = this.getViewportColumns().map(hashColumn).join("#");
        const changed = this.colsWithinViewportHash !== newHash;
        if (changed) {
            this.colsWithinViewportHash = newHash;
            this.calculateHeaderRows();
        }
        return changed;
    }
};
function $437b23f6a393c3bf$var$isAnyParentAutoHeaderHeight(col) {
    while(col){
        if (col.isAutoHeaderHeight()) return true;
        col = col.getParent();
    }
    return false;
}
// packages/ag-grid-community/src/components/framework/agComponentUtils.ts
var $437b23f6a393c3bf$var$AgComponentUtils = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "agCompUtils";
    }
    adaptFunction(type, jsCompFunc) {
        if (!type.cellRenderer) return null;
        class Adapter {
            refresh() {
                return false;
            }
            getGui() {
                return this.eGui;
            }
            init(params) {
                const callbackResult = jsCompFunc(params);
                const type2 = typeof callbackResult;
                if (type2 === "string" || type2 === "number" || type2 === "boolean") {
                    this.eGui = $437b23f6a393c3bf$export$b1f57d075ca6d5fb("<span>" + callbackResult + "</span>");
                    return;
                }
                if (callbackResult == null) {
                    this.eGui = $437b23f6a393c3bf$export$a232bb0480ae674a({
                        tag: "span"
                    });
                    return;
                }
                this.eGui = callbackResult;
            }
        }
        return Adapter;
    }
};
// packages/ag-grid-community/src/components/framework/cellRendererFunctionModule.ts
var $437b23f6a393c3bf$var$CellRendererFunctionModule = {
    moduleName: "CellRendererFunction",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AgComponentUtils
    ]
};
// packages/ag-grid-community/src/components/framework/registry.ts
var $437b23f6a393c3bf$var$Registry = class extends $437b23f6a393c3bf$export$95e025d9098f4893 {
    constructor(){
        super(...arguments);
        this.agGridDefaults = {};
        this.agGridDefaultOverrides = {};
        this.jsComps = {};
        this.selectors = {};
        this.icons = {};
    }
    postConstruct() {
        const comps = this.gos.get("components");
        if (comps != null) for (const key of Object.keys(comps))this.jsComps[key] = comps[key];
    }
    registerModule(module) {
        const { icons: icons, userComponents: userComponents, dynamicBeans: dynamicBeans, selectors: selectors } = module;
        if (userComponents) {
            const registerUserComponent = (name, component, params, processParams)=>{
                this.agGridDefaults[name] = component;
                if (params || processParams) this.agGridDefaultOverrides[name] = {
                    params: params,
                    processParams: processParams
                };
            };
            for (const name of Object.keys(userComponents)){
                let comp = userComponents[name];
                if ($437b23f6a393c3bf$var$isComponentMetaFunc(comp)) comp = comp.getComp(this.beans);
                if (typeof comp === "object") {
                    const { classImp: classImp, params: params, processParams: processParams } = comp;
                    registerUserComponent(name, classImp, params, processParams);
                } else registerUserComponent(name, comp);
            }
        }
        this.registerDynamicBeans(dynamicBeans);
        for (const selector of selectors ?? [])this.selectors[selector.selector] = selector;
        if (icons) for (const name of Object.keys(icons))this.icons[name] = icons[name];
    }
    getUserComponent(propertyName, name) {
        const createResult = (component, componentFromFramework, params, processParams)=>({
                componentFromFramework: componentFromFramework,
                component: component,
                params: params,
                processParams: processParams
            });
        const { frameworkOverrides: frameworkOverrides } = this.beans;
        const registeredViaFrameworkComp = frameworkOverrides.frameworkComponent(name, this.gos.get("components"));
        if (registeredViaFrameworkComp != null) return createResult(registeredViaFrameworkComp, true);
        const jsComponent = this.jsComps[name];
        if (jsComponent) {
            const isFwkComp = frameworkOverrides.isFrameworkComponent(jsComponent);
            return createResult(jsComponent, isFwkComp);
        }
        const defaultComponent = this.agGridDefaults[name];
        if (defaultComponent) {
            const overrides = this.agGridDefaultOverrides[name];
            return createResult(defaultComponent, false, overrides?.params, overrides?.processParams);
        }
        this.beans.validation?.missingUserComponent(propertyName, name, this.agGridDefaults, this.jsComps);
        return null;
    }
    getSelector(name) {
        return this.selectors[name];
    }
    getIcon(name) {
        return this.icons[name];
    }
    getDynamicError(name, init) {
        if (init) return $437b23f6a393c3bf$export$680bb5102fca525e(279, {
            name: name
        });
        return this.beans.validation?.missingDynamicBean(name) ?? $437b23f6a393c3bf$export$680bb5102fca525e(256);
    }
};
// packages/ag-grid-community/src/ctrlsService.ts
var $437b23f6a393c3bf$var$NUM_CTRLS = 23;
var $437b23f6a393c3bf$var$CtrlsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "ctrlsSvc";
        this.params = {};
        this.ready = false;
        this.readyCallbacks = [];
    }
    postConstruct() {
        this.addEventListener("ready", ()=>{
            this.updateReady();
            if (this.ready) {
                for (const callback of this.readyCallbacks)callback(this.params);
                this.readyCallbacks.length = 0;
            }
        }, this.beans.frameworkOverrides.runWhenReadyAsync?.() ?? false);
    }
    updateReady() {
        const values = Object.values(this.params);
        this.ready = values.length === $437b23f6a393c3bf$var$NUM_CTRLS && values.every((ctrl)=>{
            return ctrl?.isAlive() ?? false;
        });
    }
    whenReady(caller, callback) {
        if (this.ready) callback(this.params);
        else this.readyCallbacks.push(callback);
        caller.addDestroyFunc(()=>{
            const index = this.readyCallbacks.indexOf(callback);
            if (index >= 0) this.readyCallbacks.splice(index, 1);
        });
    }
    register(ctrlType, ctrl) {
        this.params[ctrlType] = ctrl;
        this.updateReady();
        if (this.ready) this.dispatchLocalEvent({
            type: "ready"
        });
        ctrl.addDestroyFunc(()=>{
            this.updateReady();
        });
    }
    get(ctrlType) {
        return this.params[ctrlType];
    }
    getGridBodyCtrl() {
        return this.params.gridBodyCtrl;
    }
    getHeaderRowContainerCtrls() {
        const { leftHeader: leftHeader, centerHeader: centerHeader, rightHeader: rightHeader } = this.params;
        return [
            leftHeader,
            rightHeader,
            centerHeader
        ];
    }
    getHeaderRowContainerCtrl(pinned) {
        const params = this.params;
        switch(pinned){
            case "left":
                return params.leftHeader;
            case "right":
                return params.rightHeader;
            default:
                return params.centerHeader;
        }
    }
    getScrollFeature() {
        return this.getGridBodyCtrl().scrollFeature;
    }
};
// packages/ag-grid-community/src/theming/core/core.css-GENERATED.ts
var $437b23f6a393c3bf$var$coreCSS = /*css*/ `.ag-aria-description-container{border:0;z-index:9999;clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.ag-unselectable{-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-selectable{-webkit-user-select:text;-moz-user-select:text;user-select:text}.ag-shake-left-to-right{animation-direction:alternate;animation-duration:.2s;animation-iteration-count:infinite;animation-name:ag-shake-left-to-right}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.ag-body-horizontal-scroll-viewport,.ag-body-vertical-scroll-viewport,.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport{flex:1 1 auto;height:100%;min-width:0;overflow:hidden;position:relative}.ag-viewport{position:relative}.ag-spanning-container{position:absolute;top:0;z-index:1}.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport{overflow-x:auto;-ms-overflow-style:none!important;scrollbar-width:none!important;&::-webkit-scrollbar{display:none!important}}.ag-body-viewport{display:flex;overflow-x:hidden;&:where(.ag-layout-normal){overflow-y:auto;-webkit-overflow-scrolling:touch}}.ag-floating-bottom-container,.ag-floating-top-container,.ag-sticky-bottom-container,.ag-sticky-top-container{min-height:1px}.ag-center-cols-viewport{min-height:100%;width:100%}.ag-body-horizontal-scroll-viewport{overflow-x:scroll}.ag-body-vertical-scroll-viewport{overflow-y:scroll}.ag-body-container,.ag-body-horizontal-scroll-container,.ag-body-vertical-scroll-container,.ag-center-cols-container,.ag-floating-bottom-container,.ag-floating-bottom-full-width-container,.ag-floating-top-container,.ag-full-width-container,.ag-header-container,.ag-pinned-left-cols-container,.ag-pinned-right-cols-container,.ag-sticky-bottom-container,.ag-sticky-top-container{position:relative}.ag-floating-bottom-container,.ag-floating-top-container,.ag-header-container,.ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top,.ag-sticky-bottom-container,.ag-sticky-top-container{height:100%;white-space:nowrap}.ag-center-cols-container,.ag-pinned-right-cols-container{display:block}.ag-body-horizontal-scroll-container{height:100%}.ag-body-vertical-scroll-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container,.ag-full-width-container,.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{pointer-events:none;position:absolute;top:0}:where(.ag-ltr) .ag-floating-bottom-full-width-container,:where(.ag-ltr) .ag-floating-top-full-width-container,:where(.ag-ltr) .ag-full-width-container,:where(.ag-ltr) .ag-sticky-bottom-full-width-container,:where(.ag-ltr) .ag-sticky-top-full-width-container{left:0}:where(.ag-rtl) .ag-floating-bottom-full-width-container,:where(.ag-rtl) .ag-floating-top-full-width-container,:where(.ag-rtl) .ag-full-width-container,:where(.ag-rtl) .ag-sticky-bottom-full-width-container,:where(.ag-rtl) .ag-sticky-top-full-width-container{right:0}.ag-full-width-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{display:inline-block;height:100%;overflow:hidden;width:100%}.ag-body{display:flex;flex:1 1 auto;flex-direction:row!important;min-height:0;position:relative}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:flex;min-height:0;min-width:0;position:relative;&:where(.ag-scrollbar-invisible){bottom:0;position:absolute;&:where(.ag-apple-scrollbar){opacity:0;transition:opacity .4s;visibility:hidden;&:where(.ag-scrollbar-scrolling,.ag-scrollbar-active){opacity:1;visibility:visible}}}}.ag-body-horizontal-scroll{width:100%;&:where(.ag-scrollbar-invisible){left:0;right:0}}.ag-body-vertical-scroll{height:100%;&:where(.ag-scrollbar-invisible){top:0;z-index:10}}:where(.ag-ltr) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){right:0}}:where(.ag-rtl) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){left:0}}.ag-force-vertical-scroll{overflow-y:scroll!important}.ag-horizontal-left-spacer,.ag-horizontal-right-spacer{height:100%;min-width:0;overflow-x:scroll;&:where(.ag-scroller-corner){overflow-x:hidden}}:where(.ag-row-animation) .ag-row{transition:transform .4s,top .4s,opacity .2s;&:where(.ag-after-created){transition:transform .4s,top .4s,height .4s,opacity .2s}}:where(.ag-row-animation.ag-prevent-animation) .ag-row{transition:none!important;&:where(.ag-row.ag-after-created){transition:none!important}}:where(.ag-row-no-animation) .ag-row{transition:none}.ag-row-loading{align-items:center;display:flex}.ag-row-position-absolute{position:absolute}.ag-row-position-relative{position:relative}.ag-full-width-row{overflow:hidden;pointer-events:all}.ag-row-inline-editing{z-index:1}.ag-row-dragging{z-index:2}.ag-stub-cell{align-items:center;display:flex}.ag-cell{display:inline-block;height:100%;position:absolute;white-space:nowrap;&:focus-visible{box-shadow:none}}.ag-cell-value{flex:1 1 auto}.ag-cell-value:not(.ag-allow-overflow),.ag-group-value{overflow:hidden;text-overflow:ellipsis}.ag-cell-wrap-text{white-space:normal;word-break:break-word}:where(.ag-cell) .ag-icon{display:inline-block;vertical-align:middle}.ag-floating-top{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-top:not(.ag-invisible)){border-bottom:var(--ag-pinned-row-border)}.ag-floating-bottom{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-bottom:not(.ag-invisible)){border-top:var(--ag-pinned-row-border)}.ag-sticky-bottom,.ag-sticky-top{background-color:var(--ag-data-background-color);display:flex;height:0;overflow:hidden;position:absolute;width:100%;z-index:1}.ag-opacity-zero{opacity:0!important}.ag-cell-label-container{align-items:center;display:flex;flex-direction:row-reverse;height:100%;justify-content:space-between;width:100%}:where(.ag-right-aligned-header){.ag-cell-label-container{flex-direction:row}.ag-header-cell-text{text-align:end}}.ag-column-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr){direction:ltr;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row}}:where(.ag-rtl){direction:rtl;text-align:right;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row-reverse}.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{display:block}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(180deg)}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(-180deg)}}:where(.ag-ltr) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}:where(.ag-rtl) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}:where(.ag-ltr) .ag-row-group-leaf-indent{margin-left:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}:where(.ag-rtl) .ag-row-group-leaf-indent{margin-right:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}.ag-value-change-delta{padding:0 2px}.ag-value-change-delta-up{color:var(--ag-value-change-delta-up-color)}.ag-value-change-delta-down{color:var(--ag-value-change-delta-down-color)}.ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.ag-value-change-value-highlight{background-color:var(--ag-value-change-value-highlight-background-color);transition:background-color .1s}.ag-cell-data-changed{background-color:var(--ag-value-change-value-highlight-background-color)!important}.ag-cell-data-changed-animation{background-color:transparent}.ag-cell-highlight{background-color:var(--ag-range-selection-highlight-color)!important}.ag-row,.ag-spanned-row{color:var(--ag-cell-text-color);font-family:var(--ag-cell-font-family);font-size:var(--ag-data-font-size);white-space:nowrap;--ag-internal-content-line-height:calc(min(var(--ag-row-height), var(--ag-line-height, 1000px)) - var(--ag-internal-row-border-width, 1px) - 2px)}.ag-row{background-color:var(--ag-data-background-color);border-bottom:var(--ag-row-border);height:var(--ag-row-height);width:100%;&.ag-row-editing-invalid{background-color:var(--ag-full-row-edit-invalid-background-color)}}:where(.ag-body-vertical-content-no-gap>div>div>div,.ag-body-vertical-content-no-gap>div>div>div>div)>.ag-row-last{border-bottom-color:transparent}.ag-sticky-bottom{border-top:var(--ag-row-border);box-sizing:content-box!important}.ag-group-contracted,.ag-group-expanded{cursor:pointer}.ag-cell,.ag-full-width-row .ag-cell-wrapper.ag-row-group{border:1px solid transparent;line-height:var(--ag-internal-content-line-height);-webkit-font-smoothing:subpixel-antialiased}:where(.ag-ltr) .ag-cell{border-right:var(--ag-column-border)}:where(.ag-rtl) .ag-cell{border-left:var(--ag-column-border)}.ag-spanned-cell-wrapper{background-color:var(--ag-data-background-color);position:absolute}.ag-spanned-cell-wrapper>.ag-spanned-cell{display:block;position:relative}:where(.ag-ltr) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-right-color:transparent}:where(.ag-rtl) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-left-color:transparent}.ag-cell-wrapper{align-items:center;display:flex;>:where(:not(.ag-cell-value,.ag-group-value)){align-items:center;display:flex;height:var(--ag-internal-content-line-height)}&:where(.ag-row-group){align-items:flex-start}:where(.ag-full-width-row) &:where(.ag-row-group){align-items:center;height:100%}}:where(.ag-ltr) .ag-cell-wrapper{padding-left:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-rtl) .ag-cell-wrapper{padding-right:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-cell-wrap-text:not(.ag-cell-auto-height)) .ag-cell-wrapper{align-items:normal;height:100%;:where(.ag-cell-value){height:100%}}:where(.ag-ltr) .ag-row>.ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}:where(.ag-rtl) .ag-row>.ag-cell-wrapper.ag-row-group{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-cell-range-single-cell,.ag-cell-range-single-cell.ag-cell-range-handle,.ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-context-menu-open .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group{border:1px solid;border-color:var(--ag-range-selection-border-color);border-style:var(--ag-range-selection-border-style);outline:initial}.ag-full-width-row.ag-row-focus:focus{box-shadow:none}:where(.ag-ltr) .ag-group-contracted,:where(.ag-ltr) .ag-group-expanded,:where(.ag-ltr) .ag-row-drag,:where(.ag-ltr) .ag-selection-checkbox{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-contracted,:where(.ag-rtl) .ag-group-expanded,:where(.ag-rtl) .ag-row-drag,:where(.ag-rtl) .ag-selection-checkbox{margin-left:var(--ag-cell-widget-spacing)}.ag-drag-handle-disabled{opacity:.35;pointer-events:none}:where(.ag-ltr) .ag-group-child-count{margin-left:3px}:where(.ag-rtl) .ag-group-child-count{margin-right:3px}.ag-row-highlight-above:after,.ag-row-highlight-below:after,.ag-row-highlight-inside:after{background-color:var(--ag-row-drag-indicator-color);border-radius:calc(var(--ag-row-drag-indicator-width)/2);content:"";height:var(--ag-row-drag-indicator-width);pointer-events:none;position:absolute;width:calc(100% - 1px)}:where(.ag-ltr) .ag-row-highlight-above:after,:where(.ag-ltr) .ag-row-highlight-below:after,:where(.ag-ltr) .ag-row-highlight-inside:after{left:1px}:where(.ag-rtl) .ag-row-highlight-above:after,:where(.ag-rtl) .ag-row-highlight-below:after,:where(.ag-rtl) .ag-row-highlight-inside:after{right:1px}.ag-row-highlight-above:after{top:0}.ag-row-highlight-below:after{bottom:0}.ag-row-highlight-indent:after{display:block;width:auto}:where(.ag-ltr) .ag-row-highlight-indent:after{left:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size));right:1px}:where(.ag-rtl) .ag-row-highlight-indent:after{left:1px;right:calc((var(--ag-cell-widget-spacing) + var(--ag-icon-size))*2 + var(--ag-cell-horizontal-padding) + var(--ag-row-highlight-level)*var(--ag-row-group-indent-size))}.ag-row-highlight-inside:after{background-color:var(--ag-selected-row-background-color);border:1px solid var(--ag-range-selection-border-color);display:block;height:auto;inset:0;width:auto}.ag-body,.ag-floating-bottom,.ag-floating-top{background-color:var(--ag-data-background-color)}.ag-row-odd{background-color:var(--ag-odd-row-background-color)}.ag-row-selected:before{background-color:var(--ag-selected-row-background-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-full-width-row.ag-row-group:before,.ag-row-hover:not(.ag-full-width-row):before{background-color:var(--ag-row-hover-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-row-selected:before{background-color:var(--ag-row-hover-color);background-image:linear-gradient(var(--ag-selected-row-background-color),var(--ag-selected-row-background-color))}.ag-row.ag-full-width-row.ag-row-group>*{position:relative}.ag-column-hover{background-color:var(--ag-column-hover-color)}.ag-header-range-highlight{background-color:var(--ag-range-header-highlight-color)}.ag-right-aligned-cell{font-variant-numeric:tabular-nums}:where(.ag-ltr) .ag-right-aligned-cell{text-align:right}:where(.ag-rtl) .ag-right-aligned-cell{text-align:left}.ag-right-aligned-cell .ag-cell-value,.ag-right-aligned-cell .ag-group-value{margin-left:auto}:where(.ag-ltr) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-ltr) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level));padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}:where(.ag-rtl) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-rtl) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-row>.ag-cell-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}.ag-row-dragging{cursor:move;opacity:.5}.ag-details-row{background-color:var(--ag-data-background-color);padding:calc(var(--ag-spacing)*3.75)}.ag-layout-auto-height,.ag-layout-print{.ag-center-cols-container,.ag-center-cols-viewport{min-height:150px}}.ag-overlay-exporting-wrapper,.ag-overlay-loading-wrapper,.ag-overlay-modal-wrapper{background-color:var(--ag-modal-overlay-background-color)}.ag-skeleton-container{align-content:center;height:100%;width:100%}.ag-skeleton-effect{animation:ag-skeleton-loading 1.5s ease-in-out .5s infinite;background-color:var(--ag-row-loading-skeleton-effect-color);border-radius:.25rem;height:1em;width:100%}:where(.ag-ltr) .ag-right-aligned-cell .ag-skeleton-effect{margin-left:auto}:where(.ag-rtl) .ag-right-aligned-cell .ag-skeleton-effect{margin-right:auto}@keyframes ag-skeleton-loading{0%{background-color:var(--ag-row-loading-skeleton-effect-color)}50%{background-color:color-mix(in srgb,transparent,var(--ag-row-loading-skeleton-effect-color) 40%)}to{background-color:var(--ag-row-loading-skeleton-effect-color)}}.ag-loading{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-loading{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-loading{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-ltr) .ag-loading-icon{padding-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-loading-icon{padding-left:var(--ag-cell-widget-spacing)}.ag-icon-loading{animation-duration:1s;animation-iteration-count:infinite;animation-name:spin;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.ag-header{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);color:var(--ag-header-text-color);display:flex;font-family:var(--ag-header-font-family);font-size:var(--ag-header-font-size);font-weight:var(--ag-header-font-weight);overflow:hidden;white-space:nowrap;width:100%}.ag-header-row{height:var(--ag-header-height);position:absolute}.ag-floating-filter-button-button,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,:where(.ag-header-cell-sortable) .ag-header-cell-label,:where(.ag-header-group-cell-selectable) .ag-header-cell-comp-wrapper{cursor:pointer}:where(.ag-ltr) .ag-header-expand-icon{margin-left:4px}:where(.ag-rtl) .ag-header-expand-icon{margin-right:4px}.ag-header-row:where(:not(:first-child)){:where(.ag-header-cell:not(.ag-header-span-height.ag-header-span-total,.ag-header-parent-hidden),.ag-header-group-cell.ag-header-group-cell-with-group){border-top:var(--ag-header-row-border)}}.ag-header-row:where(:not(.ag-header-row-column-group)){overflow:hidden}:where(.ag-header.ag-header-allow-overflow) .ag-header-row{overflow:visible}.ag-header-cell{display:inline-flex;overflow:hidden}.ag-header-group-cell{contain:paint;display:flex}.ag-header-cell,.ag-header-group-cell{align-items:center;gap:var(--ag-cell-widget-spacing);height:100%;padding:0 var(--ag-cell-horizontal-padding);position:absolute}@property --ag-internal-moving-color{syntax:"<color>";inherits:false;initial-value:transparent}@property --ag-internal-hover-color{syntax:"<color>";inherits:false;initial-value:transparent}.ag-header-cell:where(:not(.ag-floating-filter)),.ag-header-group-cell{&:before{background-image:linear-gradient(var(--ag-internal-hover-color),var(--ag-internal-hover-color)),linear-gradient(var(--ag-internal-moving-color),var(--ag-internal-moving-color));content:"";inset:0;position:absolute;--ag-internal-moving-color:transparent;--ag-internal-hover-color:transparent;transition:--ag-internal-moving-color var(--ag-header-cell-background-transition-duration),--ag-internal-hover-color var(--ag-header-cell-background-transition-duration)}&:where(:hover):before{--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}&:where(.ag-header-cell-moving):before{--ag-internal-moving-color:var(--ag-header-cell-moving-background-color);--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}}:where(.ag-header-cell:not(.ag-floating-filter) *,.ag-header-group-cell *){position:relative;z-index:1}.ag-header-cell-menu-button:where(:not(.ag-header-menu-always-show)){opacity:0;transition:opacity .2s}.ag-header-cell-filter-button,:where(.ag-header-cell.ag-header-active) .ag-header-cell-menu-button{opacity:1}.ag-header-cell-label,.ag-header-group-cell-label{align-items:center;align-self:stretch;display:flex;flex:1 1 auto;overflow:hidden;padding:5px 0}:where(.ag-ltr) .ag-sort-indicator-icon{padding-left:var(--ag-spacing)}:where(.ag-rtl) .ag-sort-indicator-icon{padding-right:var(--ag-spacing)}.ag-header-cell-label{text-overflow:ellipsis}.ag-header-group-cell-label.ag-sticky-label{flex:none;max-width:100%;overflow:visible;position:sticky}:where(.ag-ltr) .ag-header-group-cell-label.ag-sticky-label{left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-header-group-cell-label.ag-sticky-label{right:var(--ag-cell-horizontal-padding)}.ag-header-cell-text,.ag-header-group-text{overflow:hidden;text-overflow:ellipsis}.ag-header-cell-text{word-break:break-word}.ag-header-cell-comp-wrapper{width:100%}:where(.ag-header-group-cell) .ag-header-cell-comp-wrapper{display:flex}:where(.ag-header-cell:not(.ag-header-cell-auto-height)) .ag-header-cell-comp-wrapper{align-items:center;display:flex;height:100%}.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper{white-space:normal}.ag-header-cell-comp-wrapper-limited-height>*{overflow:hidden}:where(.ag-right-aligned-header) .ag-header-cell-label{flex-direction:row-reverse}:where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-col-ref{color:var(--ag-subtle-text-color)}}:where(.ag-ltr) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-col-ref{margin-right:var(--ag-spacing)}.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-col-ref{margin-left:var(--ag-spacing)}.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-header-cell.ag-right-aligned-header){.ag-header-col-ref{color:var(--ag-subtle-text-color)}}:where(.ag-ltr) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-col-ref{margin-left:var(--ag-spacing)}.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-col-ref{margin-right:var(--ag-spacing)}.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}.ag-header-cell:after,.ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{content:"";height:var(--ag-header-column-border-height);position:absolute;top:calc(50% - var(--ag-header-column-border-height)*.5);z-index:1}:where(.ag-ltr) .ag-header-cell:after,:where(.ag-ltr) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-right:var(--ag-header-column-border);right:0}:where(.ag-rtl) .ag-header-cell:after,:where(.ag-rtl) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-left:var(--ag-header-column-border);left:0}.ag-header-highlight-after:after,.ag-header-highlight-before:after{background-color:var(--ag-column-drag-indicator-color);border-radius:calc(var(--ag-column-drag-indicator-width)/2);content:"";height:100%;position:absolute;top:0;width:var(--ag-column-drag-indicator-width)}:where(.ag-ltr) .ag-header-highlight-before:after{left:0}:where(.ag-rtl) .ag-header-highlight-before:after{right:0}:where(.ag-ltr) .ag-header-highlight-after:after{right:0;:where(.ag-pinned-left-header) &{right:1px}}:where(.ag-rtl) .ag-header-highlight-after:after{left:0;:where(.ag-pinned-left-header) &{left:1px}}.ag-header-cell-resize{align-items:center;cursor:ew-resize;display:flex;height:100%;position:absolute;top:0;width:8px;z-index:2;&:after{background-color:var(--ag-header-column-resize-handle-color);content:"";height:var(--ag-header-column-resize-handle-height);position:absolute;top:calc(50% - var(--ag-header-column-resize-handle-height)*.5);width:var(--ag-header-column-resize-handle-width);z-index:1}}:where(.ag-ltr) .ag-header-cell-resize{right:-3px;&:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-rtl) .ag-header-cell-resize{left:-3px;&:after{right:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-header-cell.ag-header-span-height) .ag-header-cell-resize:after{height:calc(100% - var(--ag-spacing)*4);top:calc(var(--ag-spacing)*2)}.ag-header-group-cell-no-group:where(.ag-header-span-height){display:none}.ag-sort-indicator-container{display:flex;gap:var(--ag-spacing)}.ag-layout-print{&.ag-body{display:block;height:unset}&.ag-root-wrapper{display:inline-block}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:none}&.ag-force-vertical-scroll{overflow-y:visible!important}}@media print{.ag-root-wrapper.ag-layout-print{display:table;.ag-body-horizontal-scroll-viewport,.ag-body-viewport,.ag-center-cols-container,.ag-center-cols-viewport,.ag-root,.ag-root-wrapper-body,.ag-virtual-list-viewport{display:block!important;height:auto!important;overflow:hidden!important}.ag-cell,.ag-row{-moz-column-break-inside:avoid;break-inside:avoid}}}ag-grid,ag-grid-angular{display:block}.ag-root-wrapper{border:var(--ag-wrapper-border);border-radius:var(--ag-wrapper-border-radius);display:flex;flex-direction:column;overflow:hidden;position:relative;&.ag-layout-normal{height:100%}}.ag-root-wrapper-body{display:flex;flex-direction:row;&.ag-layout-normal{flex:1 1 auto;height:0;min-height:0}}.ag-root{display:flex;flex-direction:column;position:relative;&.ag-layout-auto-height,&.ag-layout-normal{flex:1 1 auto;overflow:hidden;width:0}&.ag-layout-normal{height:100%}}.ag-drag-handle{color:var(--ag-drag-handle-color);cursor:grab;:where(.ag-icon){color:var(--ag-drag-handle-color)}}.ag-chart-menu-icon,.ag-chart-settings-next,.ag-chart-settings-prev,.ag-column-group-icons,.ag-column-select-header-icon,.ag-filter-toolpanel-expand,.ag-floating-filter-button-button,.ag-group-title-bar-icon,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,.ag-panel-title-bar-button-icon,.ag-set-filter-group-icons,:where(.ag-group-contracted) .ag-icon,:where(.ag-group-expanded) .ag-icon{background-color:var(--ag-icon-button-background-color);border-radius:var(--ag-icon-button-border-radius);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-background-color);color:var(--ag-icon-button-color);&:hover{background-color:var(--ag-icon-button-hover-background-color);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-hover-background-color);color:var(--ag-icon-button-hover-color)}}:where(.ag-filter-active,.ag-filter-toolpanel-group-instance-header-icon,.ag-filter-toolpanel-instance-header-icon){position:relative;&:after{background-color:var(--ag-icon-button-active-indicator-color);border-radius:50%;content:"";height:6px;position:absolute;top:-1px;width:6px}}:where(.ag-ltr) :where(.ag-filter-active,.ag-filter-toolpanel-group-instance-header-icon,.ag-filter-toolpanel-instance-header-icon){&:after{right:-1px}}:where(.ag-rtl) :where(.ag-filter-active,.ag-filter-toolpanel-group-instance-header-icon,.ag-filter-toolpanel-instance-header-icon){&:after{left:-1px}}.ag-filter-active{background-image:linear-gradient(var(--ag-icon-button-active-background-color),var(--ag-icon-button-active-background-color));border-radius:1px;outline:solid var(--ag-icon-button-background-spread) var(--ag-icon-button-active-background-color);:where(.ag-icon-filter){clip-path:path("M8,0C8,4.415 11.585,8 16,8L16,16L0,16L0,0L8,0Z");color:var(--ag-icon-button-active-color)}}.ag-menu{background-color:var(--ag-menu-background-color);border:var(--ag-menu-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-menu-shadow);color:var(--ag-menu-text-color);max-height:100%;overflow-y:auto;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}`;
// packages/ag-grid-community/src/theming/core/core-css.ts
var $437b23f6a393c3bf$var$coreDefaults = {
    wrapperBorder: true,
    rowBorder: true,
    headerRowBorder: true,
    footerRowBorder: {
        ref: "rowBorder"
    },
    columnBorder: {
        style: "solid",
        width: 1,
        color: "transparent"
    },
    headerColumnBorder: false,
    headerColumnBorderHeight: "100%",
    pinnedColumnBorder: true,
    pinnedRowBorder: true,
    sidePanelBorder: true,
    sideBarPanelWidth: 250,
    sideBarBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    sideButtonBarBackgroundColor: {
        ref: "sideBarBackgroundColor"
    },
    sideButtonBarTopPadding: 0,
    sideButtonSelectedUnderlineWidth: 2,
    sideButtonSelectedUnderlineColor: "transparent",
    sideButtonSelectedUnderlineTransitionDuration: 0,
    sideButtonBackgroundColor: "transparent",
    sideButtonTextColor: {
        ref: "textColor"
    },
    sideButtonHoverBackgroundColor: {
        ref: "sideButtonBackgroundColor"
    },
    sideButtonHoverTextColor: {
        ref: "sideButtonTextColor"
    },
    sideButtonSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    sideButtonSelectedTextColor: {
        ref: "sideButtonTextColor"
    },
    sideButtonBorder: "solid 1px transparent",
    sideButtonSelectedBorder: true,
    sideButtonLeftPadding: {
        ref: "spacing"
    },
    sideButtonRightPadding: {
        ref: "spacing"
    },
    sideButtonVerticalPadding: {
        calc: "spacing * 3"
    },
    headerBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    headerFontFamily: {
        ref: "fontFamily"
    },
    cellFontFamily: {
        ref: "fontFamily"
    },
    headerFontWeight: 500,
    headerFontSize: {
        ref: "fontSize"
    },
    dataFontSize: {
        ref: "fontSize"
    },
    headerTextColor: {
        ref: "textColor"
    },
    headerCellHoverBackgroundColor: "transparent",
    headerCellMovingBackgroundColor: {
        ref: "headerCellHoverBackgroundColor"
    },
    headerCellBackgroundTransitionDuration: "0.2s",
    cellTextColor: {
        ref: "textColor"
    },
    rangeSelectionBorderStyle: "solid",
    rangeSelectionBorderColor: $437b23f6a393c3bf$var$accentColor,
    rangeSelectionBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.2),
    rangeSelectionChartBackgroundColor: "#0058FF1A",
    rangeSelectionChartCategoryBackgroundColor: "#00FF841A",
    rangeSelectionHighlightColor: $437b23f6a393c3bf$var$accentMix(0.5),
    rangeHeaderHighlightColor: $437b23f6a393c3bf$var$foregroundHeaderBackgroundMix(0.08),
    rowNumbersSelectedColor: $437b23f6a393c3bf$var$accentMix(0.5),
    rowHoverColor: $437b23f6a393c3bf$var$accentMix(0.08),
    columnHoverColor: $437b23f6a393c3bf$var$accentMix(0.05),
    selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.12),
    modalOverlayBackgroundColor: {
        ref: "backgroundColor",
        mix: 0.66
    },
    dataBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    oddRowBackgroundColor: {
        ref: "dataBackgroundColor"
    },
    wrapperBorderRadius: 8,
    cellHorizontalPadding: {
        calc: "spacing * 2 * cellHorizontalPaddingScale"
    },
    cellWidgetSpacing: {
        calc: "spacing * 1.5"
    },
    cellHorizontalPaddingScale: 1,
    rowGroupIndentSize: {
        calc: "cellWidgetSpacing + iconSize"
    },
    valueChangeDeltaUpColor: "#43a047",
    valueChangeDeltaDownColor: "#e53935",
    valueChangeValueHighlightBackgroundColor: "#16a08580",
    rowHeight: {
        calc: "max(iconSize, dataFontSize) + spacing * 3.25 * rowVerticalPaddingScale"
    },
    rowVerticalPaddingScale: 1,
    headerHeight: {
        calc: "max(iconSize, dataFontSize) + spacing * 4 * headerVerticalPaddingScale"
    },
    headerVerticalPaddingScale: 1,
    paginationPanelHeight: {
        ref: "rowHeight",
        calc: "max(rowHeight, 22px)"
    },
    dragHandleColor: $437b23f6a393c3bf$var$foregroundMix(0.7),
    headerColumnResizeHandleHeight: "30%",
    headerColumnResizeHandleWidth: 2,
    headerColumnResizeHandleColor: {
        ref: "borderColor"
    },
    widgetContainerHorizontalPadding: {
        calc: "spacing * 1.5"
    },
    widgetContainerVerticalPadding: {
        calc: "spacing * 1.5"
    },
    widgetHorizontalSpacing: {
        calc: "spacing * 1.5"
    },
    widgetVerticalSpacing: {
        ref: "spacing"
    },
    iconButtonColor: {
        ref: "iconColor"
    },
    iconButtonBackgroundColor: "transparent",
    iconButtonBackgroundSpread: 4,
    iconButtonBorderRadius: 1,
    iconButtonHoverColor: {
        ref: "iconButtonColor"
    },
    iconButtonHoverBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.1),
    iconButtonActiveColor: $437b23f6a393c3bf$var$accentColor,
    iconButtonActiveBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.28),
    iconButtonActiveIndicatorColor: $437b23f6a393c3bf$var$accentColor,
    menuBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.2)
    },
    menuBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.03),
    menuTextColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.95),
    menuShadow: {
        ref: "popupShadow"
    },
    menuSeparatorColor: {
        ref: "borderColor"
    },
    setFilterIndentSize: {
        ref: "iconSize"
    },
    chartMenuPanelWidth: 260,
    chartMenuLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.8),
    dialogShadow: {
        ref: "popupShadow"
    },
    cellEditingBorder: {
        color: $437b23f6a393c3bf$var$accentColor
    },
    cellEditingShadow: {
        ref: "cardShadow"
    },
    fullRowEditInvalidBackgroundColor: {
        ref: "invalidColor",
        onto: "backgroundColor",
        mix: 0.25
    },
    dialogBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.2)
    },
    panelBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    panelTitleBarHeight: {
        ref: "headerHeight"
    },
    panelTitleBarBackgroundColor: {
        ref: "headerBackgroundColor"
    },
    panelTitleBarIconColor: {
        ref: "headerTextColor"
    },
    panelTitleBarTextColor: {
        ref: "headerTextColor"
    },
    panelTitleBarFontWeight: {
        ref: "headerFontWeight"
    },
    panelTitleBarBorder: true,
    columnSelectIndentSize: {
        ref: "iconSize"
    },
    toolPanelSeparatorBorder: true,
    columnDropCellBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.07),
    columnDropCellTextColor: {
        ref: "textColor"
    },
    columnDropCellDragHandleColor: {
        ref: "textColor"
    },
    columnDropCellBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.13)
    },
    selectCellBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.07),
    selectCellBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.13)
    },
    advancedFilterBuilderButtonBarBorder: true,
    advancedFilterBuilderIndentSize: {
        calc: "spacing * 2 + iconSize"
    },
    advancedFilterBuilderJoinPillColor: "#f08e8d",
    advancedFilterBuilderColumnPillColor: "#a6e194",
    advancedFilterBuilderOptionPillColor: "#f3c08b",
    advancedFilterBuilderValuePillColor: "#85c0e4",
    filterPanelApplyButtonColor: $437b23f6a393c3bf$var$backgroundColor,
    filterPanelApplyButtonBackgroundColor: $437b23f6a393c3bf$var$accentColor,
    filterPanelCardSubtleColor: {
        ref: "textColor",
        mix: 0.7
    },
    filterPanelCardSubtleHoverColor: {
        ref: "textColor"
    },
    findMatchColor: $437b23f6a393c3bf$var$foregroundColor,
    findMatchBackgroundColor: "#ffff00",
    findActiveMatchColor: $437b23f6a393c3bf$var$foregroundColor,
    findActiveMatchBackgroundColor: "#ffa500",
    filterToolPanelGroupIndent: {
        ref: "spacing"
    },
    rowLoadingSkeletonEffectColor: $437b23f6a393c3bf$var$foregroundMix(0.15),
    statusBarLabelColor: $437b23f6a393c3bf$var$foregroundColor,
    statusBarLabelFontWeight: 500,
    statusBarValueColor: $437b23f6a393c3bf$var$foregroundColor,
    statusBarValueFontWeight: 500,
    pinnedSourceRowTextColor: {
        ref: "textColor"
    },
    pinnedSourceRowBackgroundColor: {
        ref: "dataBackgroundColor"
    },
    pinnedSourceRowFontWeight: 600,
    pinnedRowFontWeight: 600,
    pinnedRowBackgroundColor: {
        ref: "dataBackgroundColor"
    },
    pinnedRowTextColor: {
        ref: "textColor"
    },
    rowDragIndicatorColor: {
        ref: "rangeSelectionBorderColor"
    },
    rowDragIndicatorWidth: 2,
    columnDragIndicatorColor: {
        ref: "accentColor"
    },
    columnDragIndicatorWidth: 2
};
// packages/ag-grid-community/src/theming/parts/batch-edit/batch-edit-style-default.css-GENERATED.ts
var $437b23f6a393c3bf$var$batchEditStyleDefaultCSS = /*css*/ `.ag-cell-batch-edit{background-color:var(--ag-cell-batch-edit-background-color);color:var(--ag-cell-batch-edit-text-color);display:inherit}.ag-row-batch-edit{background-color:var(--ag-row-batch-edit-background-color);color:var(--ag-row-batch-edit-text-color)}`;
// packages/ag-grid-community/src/theming/parts/batch-edit/batch-edit-styles.ts
var $437b23f6a393c3bf$var$baseParams = {
    cellBatchEditBackgroundColor: "rgba(220 181 139 / 16%)",
    cellBatchEditTextColor: "#422f00",
    rowBatchEditBackgroundColor: {
        ref: "cellBatchEditBackgroundColor"
    },
    rowBatchEditTextColor: {
        ref: "cellBatchEditTextColor"
    }
};
var $437b23f6a393c3bf$var$baseDarkBatchEditParams = {
    ...$437b23f6a393c3bf$var$baseParams,
    cellBatchEditTextColor: "#f3d0b3"
};
var $437b23f6a393c3bf$var$makeBatchEditStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "batchEditStyle",
        params: $437b23f6a393c3bf$var$baseParams,
        css: $437b23f6a393c3bf$var$batchEditStyleDefaultCSS
    });
var $437b23f6a393c3bf$var$batchEditStyleBase = /* @__PURE__ */ $437b23f6a393c3bf$var$makeBatchEditStyleBaseTreeShakeable();
// packages/ag-grid-community/src/theming/parts/button-style/button-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$buttonStyleBaseCSS = /*css*/ `:where(.ag-button){background:none;border:none;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0;text-indent:inherit;text-shadow:inherit;text-transform:inherit;word-spacing:inherit;&:disabled{cursor:default}&:focus-visible{box-shadow:var(--ag-focus-shadow);outline:none}}.ag-standard-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--ag-button-background-color);border:var(--ag-button-border);border-radius:var(--ag-button-border-radius);color:var(--ag-button-text-color);cursor:pointer;font-weight:var(--ag-button-font-weight);padding:var(--ag-button-vertical-padding) var(--ag-button-horizontal-padding);&:hover{background-color:var(--ag-button-hover-background-color);border:var(--ag-button-hover-border);color:var(--ag-button-hover-text-color)}&:active{background-color:var(--ag-button-active-background-color);border:var(--ag-button-active-border);color:var(--ag-button-active-text-color)}&:disabled{background-color:var(--ag-button-disabled-background-color);border:var(--ag-button-disabled-border);color:var(--ag-button-disabled-text-color)}}`;
// packages/ag-grid-community/src/theming/parts/button-style/button-styles.ts
var $437b23f6a393c3bf$var$baseParams2 = {
    buttonTextColor: "inherit",
    buttonFontWeight: "normal",
    buttonBackgroundColor: "transparent",
    buttonBorder: false,
    buttonBorderRadius: {
        ref: "borderRadius"
    },
    buttonHorizontalPadding: {
        calc: "spacing * 2"
    },
    buttonVerticalPadding: {
        ref: "spacing"
    },
    buttonHoverTextColor: {
        ref: "buttonTextColor"
    },
    buttonHoverBackgroundColor: {
        ref: "buttonBackgroundColor"
    },
    buttonHoverBorder: {
        ref: "buttonBorder"
    },
    buttonActiveTextColor: {
        ref: "buttonHoverTextColor"
    },
    buttonActiveBackgroundColor: {
        ref: "buttonHoverBackgroundColor"
    },
    buttonActiveBorder: {
        ref: "buttonHoverBorder"
    },
    buttonDisabledTextColor: {
        ref: "inputDisabledTextColor"
    },
    buttonDisabledBackgroundColor: {
        ref: "inputDisabledBackgroundColor"
    },
    buttonDisabledBorder: {
        ref: "inputDisabledBorder"
    }
};
var $437b23f6a393c3bf$var$makeButtonStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: $437b23f6a393c3bf$var$baseParams2,
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$ac3227978dde8e12 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams2,
            buttonBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonBorder: true,
            buttonHoverBackgroundColor: {
                ref: "rowHoverColor"
            },
            buttonActiveBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            }
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$a70529c52057ad6a = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams2,
            buttonBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            },
            buttonFontWeight: 600,
            buttonTextColor: $437b23f6a393c3bf$var$accentColor,
            buttonHoverBackgroundColor: {
                ref: "rowHoverColor"
            },
            buttonActiveBackgroundColor: $437b23f6a393c3bf$var$accentColor,
            buttonActiveTextColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$c5a38eb31ae86567 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleBalhamTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams2,
            buttonBorder: {
                color: $437b23f6a393c3bf$var$foregroundColor,
                width: 2,
                style: "outset"
            },
            buttonActiveBorder: {
                color: $437b23f6a393c3bf$var$foregroundColor,
                width: 2,
                style: "inset"
            },
            buttonBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.07),
            buttonHoverBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonVerticalPadding: {
                calc: "spacing * 0.5"
            }
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$effe67f8e12191d5 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleBalhamTreeShakeable();
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-style-bordered.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnDropStyleBorderedCSS = /*css*/ `.ag-column-drop-vertical-empty-message{align-items:center;border:dashed var(--ag-border-width);border-color:var(--ag-border-color);display:flex;inset:0;justify-content:center;margin:calc(var(--ag-spacing)*1.5) calc(var(--ag-spacing)*2);overflow:hidden;padding:calc(var(--ag-spacing)*2);position:absolute}`;
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-style-plain.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnDropStylePlainCSS = /*css*/ `.ag-column-drop-vertical-empty-message{color:var(--ag-subtle-text-color);font-size:calc(var(--ag-font-size) - 1px);font-weight:600;padding-top:var(--ag-spacing)}:where(.ag-ltr) .ag-column-drop-vertical-empty-message{padding-left:calc(var(--ag-icon-size) + var(--ag-spacing) + var(--ag-widget-horizontal-spacing));padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-column-drop-vertical-empty-message{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-icon-size) + var(--ag-spacing) + var(--ag-widget-horizontal-spacing))}`;
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-styles.ts
var $437b23f6a393c3bf$var$makeColumnDropStyleBorderedTreeShakeable = ()=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "columnDropStyle",
        css: $437b23f6a393c3bf$var$columnDropStyleBorderedCSS
    });
};
var $437b23f6a393c3bf$export$9dd26d60e574ec0 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColumnDropStyleBorderedTreeShakeable();
var $437b23f6a393c3bf$var$makeColumnDropStylePlainTreeShakeable = ()=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "columnDropStyle",
        css: $437b23f6a393c3bf$var$columnDropStylePlainCSS
    });
};
var $437b23f6a393c3bf$export$9eadc93b54e4a807 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColumnDropStylePlainTreeShakeable();
// packages/ag-grid-community/src/theming/createTheme.ts
var $437b23f6a393c3bf$var$gridThemeLogger = {
    warn: (...args)=>{
        $437b23f6a393c3bf$export$545083624300f13d(args[0], args[1]);
    },
    error: (...args)=>{
        $437b23f6a393c3bf$export$a20c7248650823a9(args[0], args[1]);
    },
    preInitErr: (...args)=>{
        $437b23f6a393c3bf$var$_logPreInitErr(args[0], args[2], args[1]);
    }
};
var $437b23f6a393c3bf$export$25d302a5b900a763 = ()=>$437b23f6a393c3bf$var$createSharedTheme($437b23f6a393c3bf$var$gridThemeLogger).withParams($437b23f6a393c3bf$var$coreDefaults).withPart($437b23f6a393c3bf$export$a70529c52057ad6a).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0).withPart($437b23f6a393c3bf$var$batchEditStyleBase);
// packages/ag-grid-community/src/theming/parts/checkbox-style/checkbox-style-default.css-GENERATED.ts
var $437b23f6a393c3bf$var$checkboxStyleDefaultCSS = /*css*/ `.ag-checkbox-input-wrapper,.ag-radio-button-input-wrapper{background-color:var(--ag-checkbox-unchecked-background-color);border:solid var(--ag-checkbox-border-width) var(--ag-checkbox-unchecked-border-color);flex:none;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);:where(input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-icon-size);margin:0;opacity:0;width:var(--ag-icon-size)}&:after{content:"";display:block;inset:0;-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;pointer-events:none;position:absolute}&:where(.ag-checked){background-color:var(--ag-checkbox-checked-background-color);border-color:var(--ag-checkbox-checked-border-color);&:after{background-color:var(--ag-checkbox-checked-shape-color)}}&:where(:focus-within,:active){box-shadow:var(--ag-focus-shadow)}&:where(.ag-disabled){filter:grayscale();opacity:.5}}.ag-checkbox-input-wrapper{border-radius:var(--ag-checkbox-border-radius);&:where(.ag-checked):after{-webkit-mask-image:var(--ag-checkbox-checked-shape-image);mask-image:var(--ag-checkbox-checked-shape-image)}&:where(.ag-indeterminate){background-color:var(--ag-checkbox-indeterminate-background-color);border-color:var(--ag-checkbox-indeterminate-border-color);&:after{background-color:var(--ag-checkbox-indeterminate-shape-color);-webkit-mask-image:var(--ag-checkbox-indeterminate-shape-image);mask-image:var(--ag-checkbox-indeterminate-shape-image)}}}.ag-cell-editing-error .ag-checkbox-input-wrapper:focus-within{box-shadow:var(--ag-focus-error-shadow)}.ag-radio-button-input-wrapper{border-radius:100%;&:where(.ag-checked):after{-webkit-mask-image:var(--ag-radio-checked-shape-image);mask-image:var(--ag-radio-checked-shape-image)}}`;
// packages/ag-grid-community/src/theming/parts/checkbox-style/checkbox-styles.ts
var $437b23f6a393c3bf$var$makeCheckboxStyleDefaultTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "checkboxStyle",
        params: {
            checkboxBorderWidth: 1,
            checkboxBorderRadius: {
                ref: "borderRadius"
            },
            checkboxUncheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
            checkboxCheckedBackgroundColor: $437b23f6a393c3bf$var$accentColor,
            checkboxCheckedBorderColor: {
                ref: "checkboxCheckedBackgroundColor"
            },
            checkboxCheckedShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M1 3.5 3.5 6l5-5"/></svg>'
            },
            checkboxCheckedShapeColor: $437b23f6a393c3bf$var$backgroundColor,
            checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
            checkboxIndeterminateBorderColor: {
                ref: "checkboxIndeterminateBackgroundColor"
            },
            checkboxIndeterminateShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" fill="none"><rect width="10" height="2" fill="#000" rx="1"/></svg>'
            },
            checkboxIndeterminateShapeColor: $437b23f6a393c3bf$var$backgroundColor,
            radioCheckedShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" fill="none"><circle cx="3" cy="3" r="3" fill="#000"/></svg>'
            }
        },
        css: $437b23f6a393c3bf$var$checkboxStyleDefaultCSS
    });
var $437b23f6a393c3bf$export$cb8a4bb75f2f86bb = /* @__PURE__ */ $437b23f6a393c3bf$var$makeCheckboxStyleDefaultTreeShakeable();
// packages/ag-grid-community/src/theming/parts/color-scheme/color-schemes.ts
var $437b23f6a393c3bf$var$makeColorSchemeLightTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$defaultLightColorSchemeParams
    });
var $437b23f6a393c3bf$export$a116df924b17ca5b = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeLightWarmTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            foregroundColor: "#000000de",
            borderColor: "#60300026",
            chromeBackgroundColor: "#60300005"
        }
    });
var $437b23f6a393c3bf$export$57dc871710981584 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightWarmTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeLightColdTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            foregroundColor: "#000",
            chromeBackgroundColor: "#f3f8f8"
        }
    });
var $437b23f6a393c3bf$export$4cac94f49a02889d = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightColdTreeShakeable();
var $437b23f6a393c3bf$var$darkParams = ()=>({
        ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
        ...$437b23f6a393c3bf$var$baseDarkBatchEditParams,
        backgroundColor: "hsl(217, 0%, 17%)",
        foregroundColor: "#FFF",
        chromeBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.05),
        rowHoverColor: $437b23f6a393c3bf$var$accentMix(0.15),
        selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.2),
        menuBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.1),
        browserColorScheme: "dark",
        popupShadow: "0 0px 20px #000A",
        cardShadow: "0 1px 4px 1px #000A",
        advancedFilterBuilderJoinPillColor: "#7a3a37",
        advancedFilterBuilderColumnPillColor: "#355f2d",
        advancedFilterBuilderOptionPillColor: "#5a3168",
        advancedFilterBuilderValuePillColor: "#374c86",
        filterPanelApplyButtonColor: $437b23f6a393c3bf$var$foregroundColor,
        findMatchColor: $437b23f6a393c3bf$var$backgroundColor,
        findActiveMatchColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.4),
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.4),
        rowBatchEditBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.1)
    });
var $437b23f6a393c3bf$var$makeColorSchemeDarkTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$darkParams()
    });
var $437b23f6a393c3bf$export$cd586495722a2c01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeDarkWarmTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            backgroundColor: "hsl(29, 10%, 17%)",
            foregroundColor: "#FFF",
            browserColorScheme: "dark"
        }
    });
var $437b23f6a393c3bf$var$darkBlueParams = ()=>({
        ...$437b23f6a393c3bf$var$darkParams(),
        backgroundColor: "#1f2836"
    });
var $437b23f6a393c3bf$export$cd0e0dbae95c289b = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkWarmTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeDarkBlueTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$darkBlueParams()
    });
var $437b23f6a393c3bf$export$55741f191f921eee = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkBlueTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeVariableTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$defaultLightColorSchemeParams,
        modeParams: {
            light: $437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            dark: $437b23f6a393c3bf$var$darkParams(),
            "dark-blue": $437b23f6a393c3bf$var$darkBlueParams()
        }
    });
var $437b23f6a393c3bf$export$e4400993032942f7 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeVariableTreeShakeable();
// packages/ag-grid-community/src/theming/parts/icon-set/balham/icon-set-balham.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetBalhamCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eaggregation%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0M7.006 4c-1.57.02-2.946 1.348-3.004 2.922-.078 6.078-.23 12.16.002 18.234.094 1.484 1.354 2.746 2.84 2.84 6.1.232 12.212.232 18.312 0 1.48-.094 2.746-1.35 2.84-2.84.232-6.1.232-12.212 0-18.312-.094-1.48-1.35-2.746-2.84-2.84C19.11 3.774 13.056 4 7.006 4M22 12h-2v-2h-8v.092c.056 1.352 3.426 2.598 4.472 4.404.682 1.174.438 2.754-.572 3.72C14.29 19.618 12 20.924 12 22h8v-2h2v4H10c0-1.586-.098-3.304 1.016-4.314 1.904-1.632 4.89-3.108 3.54-4.42-1.918-1.68-4.464-2.936-4.554-5.12L10 8h12z'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Earrows%3C/title%3E%3Cpath d='m6.414 17 2.294 2.292-1.416 1.416L2.586 16l4.706-4.708 1.416 1.416L6.414 15H15V6.414l-2.292 2.294-1.416-1.416L16 2.586l4.708 4.706-1.416 1.416L17 6.414V15h8.586l-2.294-2.292 1.416-1.416L29.414 16l-4.706 4.708-1.416-1.416L25.586 17H17v8.586l2.292-2.294 1.416 1.416L16 29.414l-4.708-4.706 1.416-1.416L15 25.586V17z'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m15 10.621-4.292 4.294-1.416-1.416L16 6.793l6.708 6.706-1.416 1.416L17 10.621v14.586h-2z'/%3E%3C/svg%3E")}.ag-icon-aasc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='%23000' d='M13.201 8.08q.65 0 1.135.222.487.222.759.618.27.396.279.919H14.19a.72.72 0 0 0-.293-.536q-.26-.191-.705-.192-.302.001-.51.086a.7.7 0 0 0-.32.23.56.56 0 0 0-.108.338.5.5 0 0 0 .065.273.7.7 0 0 0 .204.203q.127.083.295.146.168.06.36.102l.525.125q.382.086.701.229.32.143.554.35.234.21.362.49.131.284.134.648a1.6 1.6 0 0 1-.273.93q-.27.391-.777.608-.504.214-1.217.214-.708 0-1.232-.217a1.8 1.8 0 0 1-.816-.642q-.29-.428-.305-1.058h1.194q.02.294.17.49.15.195.402.294.253.097.573.097.313 0 .544-.09a.84.84 0 0 0 .362-.255.6.6 0 0 0 .129-.374q0-.195-.117-.33a.9.9 0 0 0-.337-.228 3.4 3.4 0 0 0-.54-.171l-.635-.16q-.738-.18-1.166-.562t-.426-1.03a1.53 1.53 0 0 1 .284-.927q.287-.396.79-.618a2.8 2.8 0 0 1 1.14-.223'/%3E%3Cpath fill='%23000' fill-rule='evenodd' d='M5.813 14H4.489l-.432-1.332H1.948L1.515 14H.19l2.017-5.84h1.592zm-3.551-2.296h1.481l-.718-2.21H2.98zM8.452 8.16q.645 0 1.075.19.43.191.648.531a1.4 1.4 0 0 1 .217.775q0 .343-.137.602-.137.256-.376.422a1.6 1.6 0 0 1-.542.231v.057q.333.015.624.188.294.175.476.489.183.31.183.74 0 .466-.231.831a1.56 1.56 0 0 1-.676.573Q9.265 14 8.609 14H6.114V8.16zM7.35 12.99h1.006q.517 0 .753-.196a.66.66 0 0 0 .237-.531.8.8 0 0 0-.116-.428.8.8 0 0 0-.334-.29 1.15 1.15 0 0 0-.511-.106H7.349zm0-2.386h.916q.254 0 .45-.09a.75.75 0 0 0 .313-.256.67.67 0 0 0 .118-.396.64.64 0 0 0-.226-.511q-.223-.195-.633-.194H7.35z' clip-rule='evenodd'/%3E%3Cpath fill='%23000' d='M7.166.377a.75.75 0 0 1 .919.066l3.333 3a.75.75 0 0 1-1.003 1.115L7.609 2.033 5.113 4.53a.75.75 0 0 1-1.06-1.06l3-3z'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecancel%3C/title%3E%3Cpath d='M16 4C9.378 4 4 9.378 4 16s5.378 12 12 12 12-5.378 12-12S22.622 4 16 4m0 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S6 21.52 6 16 10.48 6 16 6m0 8.586 5.292-5.294 1.416 1.416L17.414 16l5.294 5.292-1.416 1.416L16 17.414l-5.292 5.294-1.416-1.416L14.586 16l-5.294-5.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cpath d='M6.667 12.267h4v13.067h-4zm7.466-5.6h3.733v18.667h-3.733zM21.6 17.333h3.733v8H21.6z'/%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolor-picker%3C/title%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387H7.361zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolumns%3C/title%3E%3Cpath d='M14 25h-2V7h2zm6 0h-2V7h2zm6 0h-2V7h2zM8 25H6V7h2z'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Econtracted%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecopy%3C/title%3E%3Cpath d='M21.929 27.999h-7.828a5.09 5.09 0 0 1-5.086-5.086v-9.812a5.087 5.087 0 0 1 5.086-5.086h7.828a5.09 5.09 0 0 1 5.086 5.086v9.812a5.087 5.087 0 0 1-5.086 5.086m.16-17.984h-8.088a2.94 2.94 0 0 0-2.938 2.938v10.132a2.94 2.94 0 0 0 2.938 2.938h8.088a2.94 2.94 0 0 0 2.936-2.938V12.953a2.94 2.94 0 0 0-2.936-2.938M7.041 26.013h-2.05a4 4 0 0 1-.006-.228V9.065a5.07 5.07 0 0 1 5.064-5.064h12.812q.069 0 .134.002v2.012H9.915a2.876 2.876 0 0 0-2.874 2.874z'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='4 4 24 24'%3E%3Ctitle%3Ecross%3C/title%3E%3Cpath d='m16 14.586 5.292-5.294 1.416 1.416L17.414 16l5.294 5.292-1.416 1.416L16 17.414l-5.292 5.294-1.416-1.416L14.586 16l-5.294-5.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14.703 15.096 6.215 4.719a1 1 0 1 1 1.548-1.267l13.058 15.965A5.001 5.001 0 0 1 28 23.916a5 5 0 0 1-4.999 4.999 5 5 0 0 1-4.999-4.999 4.98 4.98 0 0 1 1.23-3.283l-3.238-3.958-3.272 4.001a4.98 4.98 0 0 1 1.265 3.323 5 5 0 0 1-4.999 4.999 5 5 0 0 1-4.999-4.999 5 5 0 0 1 7.13-4.522zM8.991 20.8a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1M23 20.8a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1m-5.723-8.852 1.292 1.579 7.205-8.808a1 1 0 0 0-1.548-1.267z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-desc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Edesc%3C/title%3E%3Cpath d='m17 21.379 4.292-4.294 1.416 1.416L16 25.207l-6.708-6.706 1.416-1.416L15 21.379V6.793h2z'/%3E%3C/svg%3E")}.ag-icon-adesc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='%23000' d='M10.387 11.47a.75.75 0 0 1 1.06 1.06l-3 3-.113.093a.75.75 0 0 1-.919-.065l-3.333-3a.75.75 0 0 1 1.003-1.116l2.806 2.525zM13.201 3.08q.65 0 1.135.222.487.223.759.619.27.396.279.918H14.19a.72.72 0 0 0-.293-.536q-.26-.192-.705-.192-.302.001-.51.086a.7.7 0 0 0-.32.23.56.56 0 0 0-.108.338.5.5 0 0 0 .065.273.7.7 0 0 0 .204.203q.127.083.295.146.168.06.36.102l.525.125a3.7 3.7 0 0 1 .701.229q.32.143.554.35.234.21.362.492.131.282.134.647a1.6 1.6 0 0 1-.273.93 1.74 1.74 0 0 1-.777.607q-.504.214-1.217.214-.708 0-1.232-.217a1.8 1.8 0 0 1-.816-.641q-.29-.429-.305-1.059h1.194q.02.294.17.49.15.195.402.294.253.098.573.098.313 0 .544-.092a.84.84 0 0 0 .362-.254.6.6 0 0 0 .129-.373.5.5 0 0 0-.117-.33.9.9 0 0 0-.337-.23 3.4 3.4 0 0 0-.54-.17l-.635-.16q-.738-.18-1.166-.562t-.426-1.03a1.53 1.53 0 0 1 .284-.926q.287-.396.79-.62a2.8 2.8 0 0 1 1.14-.222'/%3E%3Cpath fill='%23000' fill-rule='evenodd' d='M5.813 9H4.489l-.432-1.332H1.948L1.515 9H.19l2.017-5.84h1.592zM2.262 6.704h1.481l-.718-2.21H2.98zM8.452 3.16q.645 0 1.075.19.43.192.648.53a1.4 1.4 0 0 1 .217.776q0 .342-.137.602a1.2 1.2 0 0 1-.376.423 1.6 1.6 0 0 1-.542.23v.058q.333.014.624.187.294.175.476.489.183.31.183.74 0 .465-.231.83a1.56 1.56 0 0 1-.676.574Q9.265 9 8.609 9H6.114V3.16zM7.35 7.99h1.006q.517 0 .753-.196a.66.66 0 0 0 .237-.531.8.8 0 0 0-.116-.428.8.8 0 0 0-.334-.291 1.15 1.15 0 0 0-.511-.106H7.349zm0-2.386h.916q.254 0 .45-.09a.75.75 0 0 0 .313-.256.67.67 0 0 0 .118-.397.64.64 0 0 0-.226-.51q-.223-.194-.633-.194H7.35z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Edesc%3C/title%3E%3Cpath d='m17 21.379 4.292-4.294 1.416 1.416L16 25.207l-6.708-6.706 1.416-1.416L15 21.379V6.793h2z'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eexpanded%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath d='M9.304 7.89a15.2 15.2 0 0 1 6.404-1.638c.294-.002.292-.002.584 0 5.956.174 11.328 4.088 13.62 9.748 0 0-1.318 3.178-3.224 5.174a13.6 13.6 0 0 1-2.226 1.874L26.414 25 25 26.414l-2.336-2.336C17.866 26.396 11.776 26.15 7.36 22.96a14.9 14.9 0 0 1-4.168-4.612c-.41-.71-.694-1.336-1.104-2.348 0 0 .898-2.218 2.002-3.718a14.6 14.6 0 0 1 3.442-3.334L5.586 7 7 5.586zm-.3 2.528c-2.038 1.344-3.708 3.246-4.724 5.508L4.248 16c2.46 5.762 9.622 9.064 15.63 7.15q.688-.219 1.342-.516l-.912-.912a6.96 6.96 0 0 1-4.19 1.394c-3.862 0-7-3.136-7-7 0-1.57.52-3.022 1.394-4.19zm14.032 11.204a13.25 13.25 0 0 0 4.684-5.548l.032-.074c-1.984-4.646-6.834-7.798-12.006-7.748-1.712.05-3.386.458-4.922 1.158l1.102 1.102a6.97 6.97 0 0 1 4.192-1.396 7.003 7.003 0 0 1 5.606 11.192zm-11.09-8.262a5.003 5.003 0 0 0 6.928 6.928zm8.342 5.514a5.002 5.002 0 0 0-6.928-6.928z'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye%3C/title%3E%3Cpath d='M16.292 6.32c5.956.174 11.328 4.086 13.62 9.746 0 0-1.318 3.18-3.224 5.176-4.862 5.088-13.534 5.97-19.328 1.784a14.9 14.9 0 0 1-4.168-4.612c-.41-.71-.694-1.336-1.104-2.348 0 0 .898-2.216 2.002-3.716 2.678-3.64 7.03-5.896 11.618-6.03.294-.004.292-.004.584 0m-.546 2c-4.896.142-9.458 3.202-11.466 7.672l-.032.074c2.46 5.762 9.622 9.066 15.63 7.152 3.458-1.102 6.342-3.738 7.842-7.076l.032-.076C25.768 11.42 20.918 8.27 15.746 8.32m.254.946c3.754 0 6.8 3.048 6.8 6.8 0 3.754-3.046 6.8-6.8 6.8s-6.8-3.046-6.8-6.8c0-3.752 3.046-6.8 6.8-6.8m5 6.768V16c0-2.76-2.24-5-5-5s-5 2.24-5 5v.066c0 2.76 2.24 5 5 5s5-2.24 5-5z'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efilter%3C/title%3E%3Cpath d='M26 8.184c-.066 2.658-4.058 5.154-6.742 7.974a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h20zM8 8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.066-2.658 4.058-5.154 6.742-7.974.198-.23.258-.538.258-.842z'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efirst%3C/title%3E%3Cpath d='M24.354 8.708 17.06 16l7.294 7.292-1.416 1.416L14.232 16l8.706-8.708zM9.646 8v16h-2V8z'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egroup%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0M7.006 4c-1.57.02-2.946 1.348-3.004 2.922-.078 6.078-.23 12.16.002 18.234.094 1.484 1.354 2.746 2.84 2.84 6.1.232 12.212.232 18.312 0 1.48-.094 2.746-1.35 2.84-2.84.232-6.1.232-12.212 0-18.312-.094-1.48-1.35-2.746-2.84-2.84C19.11 3.774 13.056 4 7.006 4M14 21h-4v-2h4zm12 0H16v-2h10zm-12-4h-4v-2h4zm12 0H16v-2h10zm-16-4H6v-2h4zm16 0H12v-2h14z'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elast%3C/title%3E%3Cpath d='m17.768 16-8.706 8.708-1.416-1.416L14.94 16 7.646 8.708l1.416-1.416zm6.586 8h-2V8h2z'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eleft%3C/title%3E%3Cpath d='m17.621 11-2 2h12.586v6H15.621l2 2-4.414 4.414L3.793 16l9.414-9.414zm-11 5 6.586 6.586L14.793 21l-4-4h15.414v-2H10.793l4-4-1.586-1.586z'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elinked%3C/title%3E%3Cpath d='M17.138 13.418a1.03 1.03 0 0 0-.298.658s.125.096.226.178c1.372 1.114 2.033 3.039 1.582 4.796a4.7 4.7 0 0 1-1.205 2.123c-1.145 1.151-2.296 2.294-3.445 3.441-1.241 1.232-3.185 1.691-4.864 1.105-1.546-.54-2.756-1.938-3.048-3.572-.267-1.496.246-3.108 1.319-4.186l.578-.578-.03-.092a10.5 10.5 0 0 1-.452-2.3v-.005c-.776.775-1.621 1.489-2.275 2.396-1.817 2.522-1.643 6.323.706 8.669 1.813 1.811 4.708 2.462 7.171 1.517a6.75 6.75 0 0 0 2.336-1.518l3.427-3.424c1.939-1.954 2.533-5.126 1.294-7.674a6.8 6.8 0 0 0-2.071-2.481l-.003-.002zM21.265 4a6.8 6.8 0 0 0-4.734 1.964l-3.427 3.424c-1.961 1.977-2.52 5.092-1.32 7.619a6.8 6.8 0 0 0 2.098 2.537l.003.002c.32-.32.643-.637.96-.96.167-.172.27-.401.286-.64l-.204-.167c-1.603-1.287-2.215-3.68-1.316-5.616a4.7 4.7 0 0 1 .918-1.32c1.145-1.151 2.296-2.294 3.445-3.441 1.239-1.23 3.178-1.694 4.864-1.105 1.83.639 3.16 2.498 3.12 4.493a4.8 4.8 0 0 1-1.391 3.265l-.578.578.03.092c.235.743.387 1.519.452 2.3v.005c.732-.731 1.521-1.406 2.162-2.244 1.192-1.559 1.643-3.651 1.204-5.575a6.8 6.8 0 0 0-3.98-4.703 6.8 6.8 0 0 0-2.529-.506h-.061z'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eloading%3C/title%3E%3Cpath d='M17 29h-2v-8h2zm-3.586-9L7 26.414 5.586 25 12 18.586zm13 5L25 26.414 18.586 20 20 18.586zM29 17h-8v-2h8zm-18 0H3v-2h8zm2.414-5L12 13.414 5.586 7 7 5.586zm13-5L20 13.414 18.586 12 25 5.586zM17 11h-2V3h2z'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='3 3 26 26'%3E%3Ctitle%3Emaximize%3C/title%3E%3Cpath d='m7.54 17.4.1 6.98 6.96.1-2.24-2.24L16 18.6 13.4 16l-3.64 3.64zm16.92-2.8-.1-6.98-6.96-.1 2.24 2.24L16 13.4l2.6 2.6 3.64-3.64z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emenu%3C/title%3E%3Cpath d='M26 23H6v-2h20zm0-6H6v-2h20zm0-6H6V9h20z'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none'%3E%3Cpath fill='%23000' d='M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='3 3 26 26'%3E%3Ctitle%3Eminimize%3C/title%3E%3Cpath d='m14.8 24.26-.1-6.96-6.96-.1 2.24 2.24-3.64 3.64 2.6 2.6 3.64-3.64zm2.4-16.52.1 6.96 6.96.1-2.24-2.24 3.64-3.64-2.6-2.6-3.64 3.64z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 7.515c-4.683 4.682-4.683 12.288 0 16.97 4.682 4.683 12.288 4.683 16.97 0 4.683-4.682 4.683-12.288 0-16.97-4.682-4.683-12.288-4.683-16.97 0m1.414 1.414c3.903-3.903 10.239-3.903 14.142 0s3.903 10.239 0 14.142-10.239 3.903-14.142 0-3.903-10.239 0-14.142m-1.414 6.07h16.97v2.002H7.515z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enext%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cpath d='m10.044 21.258 4.478-4.198L16 18.444 9 25l-7-6.556 1.478-1.384 4.478 4.198V7h2.088zm14 3.742h-2.088V10.742l-4.478 4.198L16 13.556 23 7q3.5 3.28 7 6.556l-1.478 1.384-4.478-4.198z'/%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enot-allowed%3C/title%3E%3Cpath d='M16.186 3.646c8.188.154 14.898 9.796 11.17 17.78-3.298 7.066-13.932 9.374-19.848 3.87-3.9-3.632-5.076-9.896-2.684-14.708 2.082-4.19 6.588-6.974 11.362-6.942m-.298 1.998c-6.922.132-12.578 8.308-9.33 15.052 3.342 6.934 15.246 7.646 18.932 0 3.076-6.386-1.988-15.1-9.602-15.052m7.596 6.422c2.864 5.33-1.744 13.186-8.306 12.536a8.6 8.6 0 0 1-3.232-.998l-1.266-.706L22.778 10.8q.351.633.706 1.266m-9.422 10.276c3.296 1.028 7.246-1.006 8.216-4.418a6.6 6.6 0 0 0-.056-3.742zm2.104-14.696a8.8 8.8 0 0 1 3.936 1.038l1.266.706L9.27 21.488c-3.018-5.41-.99-13.37 6.318-13.834q.289-.01.578-.008m-.31 2c-4.06.154-7.23 4.614-6.03 8.46l8.16-8.16a6.8 6.8 0 0 0-2.13-.3'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epaste%3C/title%3E%3Cpath d='M20 6.5c0-1-1-3-4-3s-4 2-4 3H8c-2.21 0-4 1.79-4 4v14c0 2.21 1.79 4 4 4h16c2.21 0 4-1.79 4-4v-14c0-2.21-1.79-4-4-4zm-4 .546c.734 0 1.334.572 1.334 1.272S16.734 9.59 16 9.59s-1.334-.572-1.334-1.272.6-1.272 1.334-1.272M24 26.5H8a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h2v4h12v-4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epin%3C/title%3E%3Cpath d='m10.78 19.777-4.668-4.666s.032-1 .67-1.87c1.366-1.86 4.052-1.96 6.056-1.572l3.158-3.108c-.7-2.342 3.352-5.046 3.352-5.046l9.166 9.168q-.334.447-.67.894c-1.074 1.426-2.538 2.63-4.272 2.338l-3.32 3.218c.046.344.042.03.118 1.152.144 2.13-.64 4.324-2.632 5.34l-.746.364-4.798-4.798-7.292 7.294-1.416-1.416zm8.24-13.672c-.688.568-1.416 1.45-1.024 2.072l.49.722-4.986 4.988c-1.988-.506-4.346-.636-5.156.614l9.02 9.032q.14-.099.272-.21c1.226-1.08.764-3.04.498-4.9l4.79-4.79s1.47.938 2.936-.776l-6.79-6.79q-.026.019-.05.038'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epivot%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0m2.966 7.954H9.892v18.136c5.086.13 10.18.098 15.264-.096 1.48-.094 2.746-1.35 2.84-2.84.192-5.064.226-10.134.098-15.2M3.968 24.1q.015.528.036 1.056c.094 1.484 1.354 2.746 2.84 2.84l1.012.036V24.1zM22 15.414l-.292.294-1.416-1.416L23 11.586l2.708 2.706-1.416 1.416-.292-.294v3.592c-.032 2.604-2.246 4.892-4.872 4.992L15.414 24l.294.292-1.416 1.416L11.586 23l2.706-2.708 1.416 1.416-.322.32c3.372.03 6.578-.164 6.614-3.034zM3.88 18.038c.002 1.346.012 2.694.038 4.04h3.938v-4.04zm.05-6.062a681 681 0 0 0-.044 4.042h3.97v-4.042zm5.962-7.99Q8.449 3.999 7.006 4c-1.57.02-2.946 1.348-3.004 2.922q-.02 1.517-.042 3.034h3.896v-2.02h2.036zm14.244-.016v3.966h3.898q-.017-.546-.038-1.092c-.094-1.48-1.35-2.746-2.84-2.84q-.51-.019-1.02-.034m-8.14-.054q-2.035.022-4.07.048v3.972h4.07zm6.106.008c-1.358-.022-2.714-.026-4.07-.022v4.034h4.07z'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 7.515c-4.683 4.682-4.683 12.288 0 16.97 4.682 4.683 12.288 4.683 16.97 0 4.683-4.682 4.683-12.288 0-16.97-4.682-4.683-12.288-4.683-16.97 0m1.414 1.414c3.903-3.903 10.239-3.903 14.142 0s3.903 10.239 0 14.142-10.239 3.903-14.142 0-3.903-10.239 0-14.142M15 15l-.001-7.485h2.002L17 15l7.485-.001v2.002L17 17l.001 7.485h-2.002L15 17l-7.485.001v-2.002z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eprevious%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eright%3C/title%3E%3Cpath d='m28.207 16-9.414 9.414L14.379 21l2-2H3.793v-6h12.586l-2-2 4.414-4.414zm-11-5 4 4H5.793v2h15.414l-4 4 1.586 1.586L25.379 16l-6.586-6.586z'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esave%3C/title%3E%3Cpath d='M25.333 16v9.333H6.666V16H3.999v9.333C3.999 26.8 5.199 28 6.666 28h18.667C26.8 28 28 26.8 28 25.333V16zm-8 .893 3.453-3.44 1.88 1.88L15.999 22l-6.667-6.667 1.88-1.88 3.453 3.44V4h2.667v12.893z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-down%3C/title%3E%3Cpath d='M24.708 12.355 16 21.061l-8.708-8.706 1.416-1.416L16 18.233l7.292-7.294z'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-left%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-right%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-up%3C/title%3E%3Cpath d='m24.708 19.645-1.416 1.416L16 13.767l-7.292 7.294-1.416-1.416L16 10.939z'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etick%3C/title%3E%3Cpath d='M24.708 10.855 13 22.561l-5.708-5.706 1.416-1.416L13 19.733 23.292 9.439z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-closed%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-indeterminate%3C/title%3E%3Cpath d='M6 15h20v2H6z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-open%3C/title%3E%3Cpath d='M24.708 12.355 16 21.061l-8.708-8.706 1.416-1.416L16 18.233l7.292-7.294z'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eunlinked%3C/title%3E%3Cpath d='M5.35 3.999a.2.2 0 0 0-.14.058c-.388.38-.768.768-1.152 1.152a.21.21 0 0 0-.002.288c7.459 7.506 14.965 14.965 22.447 22.447a.21.21 0 0 0 .288.002q.576-.574 1.151-1.151a.21.21 0 0 0 .002-.288C20.484 19.002 12.979 11.542 5.497 4.06a.2.2 0 0 0-.146-.061zm.611 12.548c-1.933 1.939-2.538 5.119-1.289 7.688a6.79 6.79 0 0 0 4.891 3.672 6.82 6.82 0 0 0 5.893-1.866l1.984-1.984-1.438-1.438-1.986 1.986c-1.486 1.476-3.993 1.81-5.834.629a4.73 4.73 0 0 1-2.024-2.853 4.76 4.76 0 0 1 1.241-4.393l1.986-1.986-1.438-1.438-1.984 1.984zM21.273 3.999a6.78 6.78 0 0 0-4.727 1.963l-1.984 1.984L16 9.384l1.985-1.985a4.74 4.74 0 0 1 2.776-1.338c1.974-.224 4.045.926 4.845 2.834.712 1.699.329 3.778-1.004 5.12L22.616 16l1.439 1.438q1-1 2-2c2.012-2.031 2.557-5.368 1.112-7.982-1.144-2.07-3.432-3.441-5.834-3.459h-.061z'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m15 10.621-4.292 4.294-1.416-1.416L16 6.793l6.708 6.706-1.416 1.416L17 10.621v14.586h-2z'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egrip%3C/title%3E%3Cpath d='M8 24H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 18H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 12H6V8h2zm6 0h-2V8h2zm6 0h-2V8h2zm6 0h-2V8h2z'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='m6.112 15.111 3.272 3.271 1.436-1.402-2.476-2.479c.81-1.25 3.168-1.12 5.156-.614l4.986-4.988-.49-.722c-.392-.622.336-1.504 1.024-2.072l.008-.007.01-.006.032-.025 1.447 1.447 1.432-1.397-2.601-2.602s-4.052 2.704-3.352 5.046l-3.158 3.108c-2.004-.388-4.69-.288-6.056 1.572-.638.87-.67 1.87-.67 1.87m.581 11.582.014.014 5.502-5.501 4.783 4.783.746-.364c1.992-1.016 2.776-3.21 2.632-5.34-.055-.805-.068-.87-.088-.97-.008-.04-.017-.085-.03-.182l3.32-3.218c1.734.292 3.198-.912 4.272-2.338q.337-.447.67-.894l-.001-.001-.007-.007-.007-.007-.007-.007-3.87-3.87 1.585-1.584-1.414-1.414-14.381 14.38-1.237 1.209-5.69 5.687 1.417 1.416zM23.21 10.206l2.65 2.651c-1.465 1.714-2.935.776-2.935.776l-4.79 4.79q.041.291.087.583c.257 1.676.513 3.35-.585 4.317a4 4 0 0 1-.272.21l-3.739-3.744z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='m16.708 10.878 8.708 8.706L24 21l-6.292-6.294V27h-2V14.706L9.416 21 8 19.584q4.348-4.344 8.691-8.69zM25 6H8v2h17z'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M16.708 22.122 8 13.416 9.416 12l6.292 6.294V6h2v12.294L24 12l1.416 1.416-8.691 8.69zM7.416 28h17v-2h-17z'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M19.834 8H8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.056-2.267 2.968-4.417 5.49-6.75v3.087c-1.081.974-2.245 1.968-3.232 3.005a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h13.834z'/%3E%3Cpath fill='currentColor' d='M26 6h2.946v2.002H26v3.313h-2.002V8.002h-2.946V6h2.946V3.04H26z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M23.182 5a3.82 3.82 0 0 1 2.83 6.383l-.131.137-2.09 2.088a1 1 0 0 1-.084.099 1 1 0 0 1-.098.084L12.533 24.869a3 3 0 0 1-1.245.746l-4.353 1.32-.003.002a1.5 1.5 0 0 1-1.87-1.867l.003-.004 1.32-4.352v-.003l.06-.174c.13-.344.321-.661.565-.936l.126-.135L18.209 8.39a1 1 0 0 1 .18-.181l2.092-2.09.137-.132A3.82 3.82 0 0 1 23.182 5M8.548 20.883a1 1 0 0 0-.25.415l-1.049 3.451 3.457-1.048.114-.042q.17-.076.301-.206l10.458-10.46-2.572-2.572zM23.182 7c-.482 0-.946.19-1.287.531v.001l-1.474 1.475 2.572 2.572 1.474-1.474.121-.133A1.82 1.82 0 0 0 23.182 7'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/balham/icon-set-balham.ts
var $437b23f6a393c3bf$var$iconSetBalham = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetBalhamCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/alpine/icon-set-alpine.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetAlpineCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24 6H8v2l8 8-8 8v2h16v-2H11l8-8-8-8h13z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 11.171 2.687 16l4.828 4.829-1.414 1.414L-.142 16l6.243-6.243zm16.97 0 1.414-1.414L32.142 16l-6.243 6.243-1.414-1.414L29.313 16zM16.028 13.2l2.829 2.828-2.829 2.829-2.828-2.829zm-4.857 11.285L16 29.313l4.829-4.828 1.414 1.414L16 32.142l-6.243-6.243zm0-16.97L9.757 6.101 16-.142l6.243 6.243-1.414 1.414L16 2.687z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-aasc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='%23000' d='M13.201 8.08q.65 0 1.135.222.487.222.759.618.27.396.279.919H14.19a.72.72 0 0 0-.293-.536q-.26-.191-.705-.192-.302.001-.51.086a.7.7 0 0 0-.32.23.56.56 0 0 0-.108.338.5.5 0 0 0 .065.273.7.7 0 0 0 .204.203q.127.083.295.146.168.06.36.102l.525.125q.382.086.701.229.32.143.554.35.234.21.362.49.131.284.134.648a1.6 1.6 0 0 1-.273.93q-.27.391-.777.608-.504.214-1.217.214-.708 0-1.232-.217a1.8 1.8 0 0 1-.816-.642q-.29-.428-.305-1.058h1.194q.02.294.17.49.15.195.402.294.253.097.573.097.313 0 .544-.09a.84.84 0 0 0 .362-.255.6.6 0 0 0 .129-.374q0-.195-.117-.33a.9.9 0 0 0-.337-.228 3.4 3.4 0 0 0-.54-.171l-.635-.16q-.738-.18-1.166-.562t-.426-1.03a1.53 1.53 0 0 1 .284-.927q.287-.396.79-.618a2.8 2.8 0 0 1 1.14-.223'/%3E%3Cpath fill='%23000' fill-rule='evenodd' d='M5.813 14H4.489l-.432-1.332H1.948L1.515 14H.19l2.017-5.84h1.592zm-3.551-2.296h1.481l-.718-2.21H2.98zM8.452 8.16q.645 0 1.075.19.43.191.648.531a1.4 1.4 0 0 1 .217.775q0 .343-.137.602-.137.256-.376.422a1.6 1.6 0 0 1-.542.231v.057q.333.015.624.188.294.175.476.489.183.31.183.74 0 .466-.231.831a1.56 1.56 0 0 1-.676.573Q9.265 14 8.609 14H6.114V8.16zM7.35 12.99h1.006q.517 0 .753-.196a.66.66 0 0 0 .237-.531.8.8 0 0 0-.116-.428.8.8 0 0 0-.334-.29 1.15 1.15 0 0 0-.511-.106H7.349zm0-2.386h.916q.254 0 .45-.09a.75.75 0 0 0 .313-.256.67.67 0 0 0 .118-.396.64.64 0 0 0-.226-.511q-.223-.195-.633-.194H7.35z' clip-rule='evenodd'/%3E%3Cpath fill='%23000' d='M7.166.377a.75.75 0 0 1 .919.066l3.333 3a.75.75 0 0 1-1.003 1.115L7.609 2.033 5.113 4.53a.75.75 0 0 1-1.06-1.06l3-3z'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667A13.32 13.32 0 0 0 2.667 16c0 7.373 5.96 13.333 13.333 13.333S29.333 23.373 29.333 16 23.373 2.667 16 2.667m6.667 18.12-1.88 1.88L16 17.88l-4.787 4.787-1.88-1.88L14.12 16l-4.787-4.787 1.88-1.88L16 14.12l4.787-4.787 1.88 1.88L17.88 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M14 7h4v18h-4zM8 17h4v8H8zM20 13h4v12h-4z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26 25H6V7h20zM12 11H8v12h4zm6 0h-4v12h4zm6 12V11h-4v12z' style='fill-rule:nonzero' transform='translate(0 -1)'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m12 6 10 10-10 10-2-2 8-8-8-8z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22 1.333H6A2.675 2.675 0 0 0 3.333 4v18.667H6V4h16zm4 5.334H11.333a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667H26c1.467 0 2.667-1.2 2.667-2.667V9.334c0-1.467-1.2-2.667-2.667-2.667M26 28H11.333V9.333H26z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.984 13.894 27.05 2.828l2.122 2.122-11.066 11.066 11.066 11.066-2.122 2.12-11.066-11.066L4.918 29.202l-2.12-2.12 11.066-11.066L2.798 4.95l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M13.775 15.198 3.835 2.945a1.501 1.501 0 0 1 2.33-1.89l14.997 18.488A6.003 6.003 0 0 1 29.657 25c0 3.311-2.688 6-6 6s-6-2.689-6-6c0-1.335.437-2.569 1.176-3.566l-3.127-3.855-3.001 3.7A5.97 5.97 0 0 1 14 25c0 3.311-2.689 6-6 6s-6-2.689-6-6a6.003 6.003 0 0 1 8.315-5.536zm9.882 6.702a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1M8 21.95a3.05 3.05 0 1 0 .001 6.101A3.05 3.05 0 0 0 8 21.95m9.63-11.505 1.932 2.381 8.015-9.881a1.5 1.5 0 0 0-2.329-1.89z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-desc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-adesc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='%23000' d='M10.387 11.47a.75.75 0 0 1 1.06 1.06l-3 3-.113.093a.75.75 0 0 1-.919-.065l-3.333-3a.75.75 0 0 1 1.003-1.116l2.806 2.525zM13.201 3.08q.65 0 1.135.222.487.223.759.619.27.396.279.918H14.19a.72.72 0 0 0-.293-.536q-.26-.192-.705-.192-.302.001-.51.086a.7.7 0 0 0-.32.23.56.56 0 0 0-.108.338.5.5 0 0 0 .065.273.7.7 0 0 0 .204.203q.127.083.295.146.168.06.36.102l.525.125a3.7 3.7 0 0 1 .701.229q.32.143.554.35.234.21.362.492.131.282.134.647a1.6 1.6 0 0 1-.273.93 1.74 1.74 0 0 1-.777.607q-.504.214-1.217.214-.708 0-1.232-.217a1.8 1.8 0 0 1-.816-.641q-.29-.429-.305-1.059h1.194q.02.294.17.49.15.195.402.294.253.098.573.098.313 0 .544-.092a.84.84 0 0 0 .362-.254.6.6 0 0 0 .129-.373.5.5 0 0 0-.117-.33.9.9 0 0 0-.337-.23 3.4 3.4 0 0 0-.54-.17l-.635-.16q-.738-.18-1.166-.562t-.426-1.03a1.53 1.53 0 0 1 .284-.926q.287-.396.79-.62a2.8 2.8 0 0 1 1.14-.222'/%3E%3Cpath fill='%23000' fill-rule='evenodd' d='M5.813 9H4.489l-.432-1.332H1.948L1.515 9H.19l2.017-5.84h1.592zM2.262 6.704h1.481l-.718-2.21H2.98zM8.452 3.16q.645 0 1.075.19.43.192.648.53a1.4 1.4 0 0 1 .217.776q0 .342-.137.602a1.2 1.2 0 0 1-.376.423 1.6 1.6 0 0 1-.542.23v.058q.333.014.624.187.294.175.476.489.183.31.183.74 0 .465-.231.83a1.56 1.56 0 0 1-.676.574Q9.265 9 8.609 9H6.114V3.16zM7.35 7.99h1.006q.517 0 .753-.196a.66.66 0 0 0 .237-.531.8.8 0 0 0-.116-.428.8.8 0 0 0-.334-.291 1.15 1.15 0 0 0-.511-.106H7.349zm0-2.386h.916q.254 0 .45-.09a.75.75 0 0 0 .313-.256.67.67 0 0 0 .118-.397.64.64 0 0 0-.226-.51q-.223-.194-.633-.194H7.35z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 26 10 16 20 6l2 2-8 8 8 8z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath fill='%23000' fill-rule='nonzero' d='M8.95 10.364 7 8.414 8.414 7l2.32 2.32A13.2 13.2 0 0 1 16.5 8c5.608 0 10.542 3.515 12.381 8.667L29 17l-.119.333a13 13 0 0 1-4.255 5.879l1.466 1.466-1.414 1.414-1.754-1.753A13.2 13.2 0 0 1 16.5 26c-5.608 0-10.542-3.515-12.381-8.667L4 17l.119-.333a13 13 0 0 1 4.83-6.303m1.445 1.445A11.02 11.02 0 0 0 6.148 17c1.646 4.177 5.728 7 10.352 7 1.76 0 3.441-.409 4.94-1.146l-1.878-1.878A5.06 5.06 0 0 1 16.5 22c-2.789 0-5.05-2.239-5.05-5 0-1.158.398-2.223 1.065-3.07zm1.855-.974 1.794 1.795A5.07 5.07 0 0 1 16.5 12c2.789 0 5.05 2.239 5.05 5 0 .9-.24 1.745-.661 2.474l2.305 2.306A11 11 0 0 0 26.852 17c-1.646-4.177-5.728-7-10.352-7-1.495 0-2.933.295-4.25.835'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16.5 23c4.624 0 8.706-2.823 10.352-7-1.646-4.177-5.728-7-10.352-7s-8.706 2.823-10.352 7c1.646 4.177 5.728 7 10.352 7M4.119 15.667C5.958 10.515 10.892 7 16.5 7s10.542 3.515 12.381 8.667L29 16l-.119.333C27.042 21.485 22.108 25 16.5 25S5.958 21.485 4.119 16.333L4 16zM16.5 21c2.789 0 5.049-2.239 5.049-5s-2.26-5-5.049-5-5.049 2.239-5.049 5 2.26 5 5.049 5' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m28 8-8 8v5l-6 6V16L6 8V6h22zM9 8l7 7v7l2-2v-5l7-7z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.273 22.12 18.153 16l6.12-6.12L22.393 8l-8 8 8 8zM7.727 8h2.667v16H7.727z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 7v1H9V7zm0-3v1H5.001V4zm-7 7H5v-1h2zm0-3H5V7h2zM3 5H1V4h2zm11 5v1H9v-1zm-7 4H5v-1h2zm7-1v1H9v-1z' style='fill-rule:nonzero' transform='matrix(2 0 0 2 0 -2)'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m7.727 9.88 6.12 6.12-6.12 6.12L9.607 24l8-8-8-8zM21.607 8h2.667v16h-2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26.667 14.667H10.44l7.453-7.453L16 5.334 5.333 16.001 16 26.668l1.88-1.88-7.44-7.453h16.227z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M5.2 16a4.136 4.136 0 0 1 4.133-4.133h5.333V9.334H9.333a6.67 6.67 0 0 0-6.667 6.667 6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.333A4.136 4.136 0 0 1 5.2 16.002zm5.467 1.333h10.667v-2.667H10.667zm12-8h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133 4.136 4.136 0 0 1-4.133 4.133h-5.333v2.533h5.333a6.67 6.67 0 0 0 6.667-6.667 6.67 6.67 0 0 0-6.667-6.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M17 29h-2v-8h2zm-3.586-9L7 26.414 5.586 25 12 18.586zm13 5L25 26.414 18.586 20 20 18.586zM29 17h-8v-2h8zm-18 0H3v-2h8zm2.414-5L12 13.414 5.586 7 7 5.586zm13-5L20 13.414 18.586 12 25 5.586zM17 11h-2V3h2z' style='fill-rule:nonzero' transform='translate(-3.692 -3.692)scale(1.23077)'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 30H2V18h2.828v7.05l8.254-8.252 2.12 2.12-8.252 8.254H14zm4-28h12v12h-2.828V6.95l-8.254 8.252-2.12-2.12 8.252-8.254H18z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 13H0v-2h20zm0-6H0V5h20zm0-6H0v-2h20z' style='fill-rule:nonzero' transform='translate(6 9)'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M16 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 27a3 3 0 1 0 0-6 3 3 0 0 0 0 6'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M2 18h12v12h-2.828v-7.05l-8.254 8.252-2.12-2.12 8.252-8.254H2zm28-4H18V2h2.828v7.05L29.082.798l2.12 2.12-8.252 8.254H30z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658H7.901v-2.658z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.94 6 9.06 7.88 17.167 16 9.06 24.12 10.94 26l10-10z' style='fill-rule:nonzero' transform='translate(1)'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M23.708 14.645 16 6.939l-7.708 7.706 1.416 1.416L16 9.767l6.292 6.294zM23.708 20.355 16 28.061l-7.708-7.706 1.416-1.416L16 25.233l6.292-6.294z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667M5.333 16c0-5.893 4.773-10.667 10.667-10.667 2.467 0 4.733.84 6.533 2.253L7.586 22.533A10.54 10.54 0 0 1 5.333 16M16 26.667c-2.467 0-4.733-.84-6.533-2.253L24.414 9.467A10.54 10.54 0 0 1 26.667 16c0 5.893-4.773 10.667-10.667 10.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.334 4H19.76C19.2 2.453 17.733 1.333 16 1.333S12.8 2.453 12.24 4H6.667A2.675 2.675 0 0 0 4 6.667V28c0 1.467 1.2 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667V6.667C28.001 5.2 26.801 4 25.334 4M16 4c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333S15.267 4 16 4m9.333 24H6.666V6.667h2.667v4h13.333v-4h2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m10.78 19.777-4.668-4.666s.032-1 .67-1.87c1.366-1.86 4.052-1.96 6.056-1.572l3.158-3.108c-.7-2.342 3.352-5.046 3.352-5.046l9.166 9.168q-.334.447-.67.894c-1.074 1.426-2.538 2.63-4.272 2.338l-3.32 3.218c.046.344.042.03.118 1.152.144 2.13-.64 4.324-2.632 5.34l-.746.364-4.798-4.798-7.292 7.294-1.416-1.416zm8.24-13.672c-.688.568-1.416 1.45-1.024 2.072l.49.722-4.986 4.988c-1.988-.506-4.346-.636-5.156.614l9.02 9.032q.14-.099.272-.21c1.226-1.08.764-3.04.498-4.9l4.79-4.79s1.47.938 2.936-.776l-6.79-6.79q-.026.019-.05.038' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0m2.966 7.954H9.892v18.136c5.086.13 10.18.098 15.264-.096 1.48-.094 2.746-1.35 2.84-2.84.192-5.064.226-10.134.098-15.2M3.968 24.1q.015.528.036 1.056c.094 1.484 1.354 2.746 2.84 2.84l1.012.036V24.1zM22 15.414l-.292.294-1.416-1.416L23 11.586l2.708 2.706-1.416 1.416-.292-.294v3.592c-.032 2.604-2.246 4.892-4.872 4.992L15.414 24l.294.292-1.416 1.416L11.586 23l2.706-2.708 1.416 1.416-.322.32c3.372.03 6.578-.164 6.614-3.034zM3.88 18.038c.002 1.346.012 2.694.038 4.04h3.938v-4.04zm.05-6.062a681 681 0 0 0-.044 4.042h3.97v-4.042zm5.962-7.99Q8.449 3.999 7.006 4c-1.57.02-2.946 1.348-3.004 2.922q-.02 1.517-.042 3.034h3.896v-2.02h2.036zm14.244-.016v3.966h3.898q-.017-.546-.038-1.092c-.094-1.48-1.35-2.746-2.84-2.84q-.51-.019-1.02-.034m-8.14-.054q-2.035.022-4.07.048v3.972h4.07zm6.106.008a213 213 0 0 0-4.07-.022v4.034h4.07z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658h-6.77v6.77h-2.658v-6.77h-6.77v-2.658h6.77v-6.77h2.658v6.77z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.94 7.88 20.06 6l-10 10 10 10 1.88-1.88L13.833 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m16 5.333-1.88 1.88 7.44 7.453H5.333v2.667H21.56l-7.44 7.453 1.88 1.88 10.667-10.667L16 5.332z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.708 2.355 8 10.061.292 2.355 1.708.939 8 7.233 14.292.939z' style='fill-rule:nonzero' transform='translate(8 14)'/%3E%3Cpath d='M5 26h22v2H5zM15 4h2v18h-2z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 10.667 16 21.334l8.667-10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.333 7.334 10.666 16l10.667 8.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.667 24.666 21.334 16 10.667 7.333z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 21.333 16 10.666l8.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M11.586 22.96 27.718 6.828 29.84 8.95 11.586 27.202 2.4 18.016l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m11.94 6-1.88 1.88L18.167 16l-8.107 8.12L11.94 26l10-10z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6 13.5h20v3H6z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.12 9.06 16 17.167 7.88 9.06 6 10.94l10 10 10-10z' style='fill-rule:nonzero' transform='translate(0 1)'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22.667 9.333h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133c0 1.907-1.307 3.507-3.08 3.973l1.947 1.947c2.173-1.107 3.667-3.32 3.667-5.92a6.67 6.67 0 0 0-6.667-6.667zm-1.334 5.334h-2.92l2.667 2.667h.253zM2.667 5.693 6.814 9.84A6.65 6.65 0 0 0 2.667 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.334a4.136 4.136 0 0 1-4.133-4.133c0-2.12 1.613-3.867 3.68-4.093l2.76 2.76h-.973v2.667h3.64l3.027 3.027v2.307h2.307l5.347 5.333 1.68-1.68L4.362 4.002 2.669 5.695z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M8 24H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 18H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 12H6V8h2zm6 0h-2V8h2zm6 0h-2V8h2zm6 0h-2V8h2z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='m6.112 15.111 3.272 3.271 1.436-1.402-2.476-2.479c.81-1.25 3.168-1.12 5.156-.614l4.986-4.988-.49-.722c-.392-.622.336-1.504 1.024-2.072l.008-.007.01-.006.032-.025 1.447 1.447 1.432-1.397-2.601-2.602s-4.052 2.704-3.352 5.046l-3.158 3.108c-2.004-.388-4.69-.288-6.056 1.572-.638.87-.67 1.87-.67 1.87m.581 11.582.014.014 5.502-5.501 4.783 4.783.746-.364c1.992-1.016 2.776-3.21 2.632-5.34-.055-.805-.068-.87-.088-.97-.008-.04-.017-.085-.03-.182l3.32-3.218c1.734.292 3.198-.912 4.272-2.338q.337-.447.67-.894l-.001-.001-.007-.007-.007-.007-.007-.007-3.87-3.87 1.585-1.584-1.414-1.414-14.381 14.38-1.237 1.209-5.69 5.687 1.417 1.416zM23.21 10.206l2.65 2.651c-1.465 1.714-2.935.776-2.935.776l-4.79 4.79q.041.291.087.583c.257 1.676.513 3.35-.585 4.317a4 4 0 0 1-.272.21l-3.739-3.744z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='m16.708 10.878 8.708 8.706L24 21l-6.292-6.294V27h-2V14.706L9.416 21 8 19.584q4.348-4.344 8.691-8.69zM25 6H8v2h17z'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M16.708 22.122 8 13.416 9.416 12l6.292 6.294V6h2v12.294L24 12l1.416 1.416-8.691 8.69zM7.416 28h17v-2h-17z'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M19.834 8H8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.056-2.267 2.968-4.417 5.49-6.75v3.087c-1.081.974-2.245 1.968-3.232 3.005a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h13.834z'/%3E%3Cpath fill='currentColor' d='M26 6h2.946v2.002H26v3.313h-2.002V8.002h-2.946V6h2.946V3.04H26z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M6.222 25.778h1.611l14.834-14.811-1.611-1.611-14.834 14.81zM4 28v-4.733L22.644 4.656a2.26 2.26 0 0 1 1.567-.634q.423 0 .833.167.412.166.734.478l1.589 1.6q.333.322.483.733t.15.822q0 .423-.161.839-.162.416-.472.728L8.733 28zm17.856-17.833-.8-.811 1.61 1.61z'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/alpine/icon-set-alpine.ts
var $437b23f6a393c3bf$export$9bb4a1bee1653083 = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetAlpineCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/material/icon-set-material.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetMaterialCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eaggregation%3C/title%3E%3Cpath d='M24 5.333H8V8l8.667 8L8 24v2.667h16v-4h-9.333L21.334 16l-6.667-6.667H24z'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Earrows%3C/title%3E%3Cpath d='M13.333 11.556h5.333V8h3.556L16 1.778 9.778 8h3.556zm-1.777 1.777H8V9.777l-6.222 6.222L8 22.221v-3.556h3.556zM30.222 16 24 9.778v3.556h-3.556v5.333H24v3.556l6.222-6.222zm-11.555 4.444h-5.333V24H9.778L16 30.222 22.222 24h-3.556z'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333z'/%3E%3C/svg%3E")}.ag-icon-aasc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='%23000' d='M13.201 8.08q.65 0 1.135.222.487.222.759.618.27.396.279.919H14.19a.72.72 0 0 0-.293-.536q-.26-.191-.705-.192-.302.001-.51.086a.7.7 0 0 0-.32.23.56.56 0 0 0-.108.338.5.5 0 0 0 .065.273.7.7 0 0 0 .204.203q.127.083.295.146.168.06.36.102l.525.125q.382.086.701.229.32.143.554.35.234.21.362.49.131.284.134.648a1.6 1.6 0 0 1-.273.93q-.27.391-.777.608-.504.214-1.217.214-.708 0-1.232-.217a1.8 1.8 0 0 1-.816-.642q-.29-.428-.305-1.058h1.194q.02.294.17.49.15.195.402.294.253.097.573.097.313 0 .544-.09a.84.84 0 0 0 .362-.255.6.6 0 0 0 .129-.374q0-.195-.117-.33a.9.9 0 0 0-.337-.228 3.4 3.4 0 0 0-.54-.171l-.635-.16q-.738-.18-1.166-.562t-.426-1.03a1.53 1.53 0 0 1 .284-.927q.287-.396.79-.618a2.8 2.8 0 0 1 1.14-.223'/%3E%3Cpath fill='%23000' fill-rule='evenodd' d='M5.813 14H4.489l-.432-1.332H1.948L1.515 14H.19l2.017-5.84h1.592zm-3.551-2.296h1.481l-.718-2.21H2.98zM8.452 8.16q.645 0 1.075.19.43.191.648.531a1.4 1.4 0 0 1 .217.775q0 .343-.137.602-.137.256-.376.422a1.6 1.6 0 0 1-.542.231v.057q.333.015.624.188.294.175.476.489.183.31.183.74 0 .466-.231.831a1.56 1.56 0 0 1-.676.573Q9.265 14 8.609 14H6.114V8.16zM7.35 12.99h1.006q.517 0 .753-.196a.66.66 0 0 0 .237-.531.8.8 0 0 0-.116-.428.8.8 0 0 0-.334-.29 1.15 1.15 0 0 0-.511-.106H7.349zm0-2.386h.916q.254 0 .45-.09a.75.75 0 0 0 .313-.256.67.67 0 0 0 .118-.396.64.64 0 0 0-.226-.511q-.223-.195-.633-.194H7.35z' clip-rule='evenodd'/%3E%3Cpath fill='%23000' d='M7.166.377a.75.75 0 0 1 .919.066l3.333 3a.75.75 0 0 1-1.003 1.115L7.609 2.033 5.113 4.53a.75.75 0 0 1-1.06-1.06l3-3z'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecancel%3C/title%3E%3Cpath d='M16 2.667C8.627 2.667 2.667 8.627 2.667 16S8.627 29.333 16 29.333 29.333 23.373 29.333 16 23.373 2.667 16 2.667m6.667 18.12-1.88 1.88L16 17.88l-4.787 4.787-1.88-1.88L14.12 16l-4.787-4.787 1.88-1.88L16 14.12l4.787-4.787 1.88 1.88L17.88 16z'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cpath d='M6.667 12.267h4v13.067h-4zm7.466-5.6h3.733v18.667h-3.733zM21.6 17.333h3.733v8H21.6z'/%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolor-picker%3C/title%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387H7.361zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolumns%3C/title%3E%3Cpath d='M5.333 10.667h5.333V5.334H5.333zm8 16h5.333v-5.333h-5.333zm-8 0h5.333v-5.333H5.333zm0-8h5.333v-5.333H5.333zm8 0h5.333v-5.333h-5.333zm8-13.334v5.333h5.333V5.333zm-8 5.334h5.333V5.334h-5.333zm8 8h5.333v-5.333h-5.333zm0 8h5.333v-5.333h-5.333z'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Econtracted%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecopy%3C/title%3E%3Cpath d='M22 1.333H6A2.675 2.675 0 0 0 3.333 4v18.667H6V4h16zm4 5.334H11.333a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667H26c1.467 0 2.667-1.2 2.667-2.667V9.334c0-1.467-1.2-2.667-2.667-2.667M26 28H11.333V9.333H26z'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecross%3C/title%3E%3Cpath d='m25.333 8.547-1.88-1.88L16 14.12 8.547 6.667l-1.88 1.88L14.12 16l-7.453 7.453 1.88 1.88L16 17.88l7.453 7.453 1.88-1.88L17.88 16z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m19 3-6 6 2 2 7-7V3m-10 9.5a.503.503 0 0 1-.5-.5c0-.274.226-.5.5-.5s.5.226.5.5-.226.5-.5.5M6 20c-1.097 0-2-.903-2-2a2 2 0 0 1 2-2c1.097 0 2 .903 2 2a2 2 0 0 1-2 2M6 8c-1.097 0-2-.903-2-2a2 2 0 0 1 2-2c1.097 0 2 .903 2 2a2 2 0 0 1-2 2m3.64-.36c.23-.5.36-1.05.36-1.64 0-2.194-1.806-4-4-4S2 3.806 2 6s1.806 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.194 0-4 1.806-4 4s1.806 4 4 4 4-1.806 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1z' style='fill-rule:nonzero' transform='translate(4 4)'/%3E%3C/svg%3E")}.ag-icon-desc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Edesc%3C/title%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667L26.668 16z'/%3E%3C/svg%3E")}.ag-icon-adesc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='%23000' d='M10.387 11.47a.75.75 0 0 1 1.06 1.06l-3 3-.113.093a.75.75 0 0 1-.919-.065l-3.333-3a.75.75 0 0 1 1.003-1.116l2.806 2.525zM13.201 3.08q.65 0 1.135.222.487.223.759.619.27.396.279.918H14.19a.72.72 0 0 0-.293-.536q-.26-.192-.705-.192-.302.001-.51.086a.7.7 0 0 0-.32.23.56.56 0 0 0-.108.338.5.5 0 0 0 .065.273.7.7 0 0 0 .204.203q.127.083.295.146.168.06.36.102l.525.125a3.7 3.7 0 0 1 .701.229q.32.143.554.35.234.21.362.492.131.282.134.647a1.6 1.6 0 0 1-.273.93 1.74 1.74 0 0 1-.777.607q-.504.214-1.217.214-.708 0-1.232-.217a1.8 1.8 0 0 1-.816-.641q-.29-.429-.305-1.059h1.194q.02.294.17.49.15.195.402.294.253.098.573.098.313 0 .544-.092a.84.84 0 0 0 .362-.254.6.6 0 0 0 .129-.373.5.5 0 0 0-.117-.33.9.9 0 0 0-.337-.23 3.4 3.4 0 0 0-.54-.17l-.635-.16q-.738-.18-1.166-.562t-.426-1.03a1.53 1.53 0 0 1 .284-.926q.287-.396.79-.62a2.8 2.8 0 0 1 1.14-.222'/%3E%3Cpath fill='%23000' fill-rule='evenodd' d='M5.813 9H4.489l-.432-1.332H1.948L1.515 9H.19l2.017-5.84h1.592zM2.262 6.704h1.481l-.718-2.21H2.98zM8.452 3.16q.645 0 1.075.19.43.192.648.53a1.4 1.4 0 0 1 .217.776q0 .342-.137.602a1.2 1.2 0 0 1-.376.423 1.6 1.6 0 0 1-.542.23v.058q.333.014.624.187.294.175.476.489.183.31.183.74 0 .465-.231.83a1.56 1.56 0 0 1-.676.574Q9.265 9 8.609 9H6.114V3.16zM7.35 7.99h1.006q.517 0 .753-.196a.66.66 0 0 0 .237-.531.8.8 0 0 0-.116-.428.8.8 0 0 0-.334-.291 1.15 1.15 0 0 0-.511-.106H7.349zm0-2.386h.916q.254 0 .45-.09a.75.75 0 0 0 .313-.256.67.67 0 0 0 .118-.397.64.64 0 0 0-.226-.51q-.223-.194-.633-.194H7.35z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Edesc%3C/title%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667L26.668 16z'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='translate(3.934 -.054)scale(.06285)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eexpanded%3C/title%3E%3Cpath d='M20.94 9.88 19.06 8l-8 8 8 8 1.88-1.88L14.833 16z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath d='M21.106 15.088A5.19 5.19 0 0 0 16 10.814a5.17 5.17 0 0 0-3.668 1.522L9.866 9.868a12.2 12.2 0 0 1 6.133-1.646c5.186 0 9.614 3.225 11.408 7.778a12.34 12.34 0 0 1-5.276 6.133l-2.468-2.466a5.17 5.17 0 0 0 1.449-2.802h-2.123c-.148.508-.42.964-.782 1.33l-1.33-1.33h-2.514l2.196 2.196q-.272.049-.56.05a3.11 3.11 0 0 1-2.99-2.245h-2.123a5.19 5.19 0 0 0 7.3 3.836l2.247 2.247a12.2 12.2 0 0 1-4.434.828c-5.186 0-9.614-3.225-11.408-7.778a12.3 12.3 0 0 1 3.781-5.111l2.924 2.924a5.1 5.1 0 0 0-.404 1.275h4.206l-1.296-1.296a3.1 3.1 0 0 1 2.196-.903c1.404 0 2.587.924 2.976 2.199h2.13z'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye%3C/title%3E%3Cpath d='M16 8.222c-5.186 0-9.614 3.225-11.408 7.778 1.794 4.553 6.222 7.778 11.408 7.778S25.614 20.553 27.408 16C25.614 11.447 21.186 8.222 16 8.222m0 12.964c-2.862 0-5.186-2.324-5.186-5.186s2.324-5.186 5.186-5.186 5.186 2.324 5.186 5.186-2.324 5.186-5.186 5.186m0-8.297c-1.721 0-3.111 1.39-3.111 3.111s1.39 3.111 3.111 3.111 3.111-1.39 3.111-3.111-1.39-3.111-3.111-3.111'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efilter%3C/title%3E%3Cpath d='M13.333 24h5.333v-2.667h-5.333zM4 8v2.667h24V8zm4 9.333h16v-2.667H8z'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efirst%3C/title%3E%3Cpath d='M24.273 22.12 18.153 16l6.12-6.12L22.393 8l-8 8 8 8zM7.727 8h2.667v16H7.727z'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egroup%3C/title%3E%3Cpath d='M18.667 21.333h8.889A3.555 3.555 0 0 1 24 24.889h-5.333zm8.888-7.111v3.556h-8.889v-3.556zM24 7.111a3.555 3.555 0 0 1 3.556 3.556h-16V7.111zm-8.889 17.778h-3.556v-3.556h3.556zm0-7.111h-3.556v-3.556h3.556zM8 10.667H4.444A3.555 3.555 0 0 1 8 7.111z'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elast%3C/title%3E%3Cpath d='m7.727 9.88 6.12 6.12-6.12 6.12L9.607 24l8-8-8-8zM21.607 8h2.667v16h-2.667z'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eleft%3C/title%3E%3Cpath d='M26.667 14.667H10.44l7.453-7.453L16 5.334 5.333 16.001 16 26.668l1.88-1.88-7.44-7.453h16.227v-2.667z'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elinked%3C/title%3E%3Cpath d='M5.2 16a4.136 4.136 0 0 1 4.133-4.133h5.333V9.334H9.333c-3.68 0-6.667 2.987-6.667 6.667s2.987 6.667 6.667 6.667h5.333v-2.533H9.333A4.136 4.136 0 0 1 5.2 16.002zm5.467 1.333h10.667v-2.667H10.667zm12-8h-5.333v2.533h5.333c2.28 0 4.133 1.853 4.133 4.133s-1.853 4.133-4.133 4.133h-5.333v2.533h5.333c3.68 0 6.667-2.987 6.667-6.667s-2.987-6.667-6.667-6.667z'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eloading%3C/title%3E%3Cpath d='m17.778 11.708 3.25-3.251 2.516 2.516-3.251 3.25h4.597v3.556h-4.597l3.251 3.25-2.516 2.516-3.25-3.251v4.597h-3.556v-4.597l-3.25 3.251-2.516-2.516 3.251-3.25H7.11v-3.556h4.597l-3.251-3.25 2.516-2.516 3.25 3.251V7.111h3.556zm-3.251 7.847h2.944l2.084-2.084v-2.944l-2.084-2.084h-2.944l-2.084 2.084v2.944z'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emaximize%3C/title%3E%3Cpath d='M4 4h24v2.667H4z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emenu%3C/title%3E%3Cpath d='M4 24h24v-2.667H4zm0-6.667h24v-2.667H4zM4 8v2.667h24V8z'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M16 26.667a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 24q0-1.1.784-1.883A2.57 2.57 0 0 1 16 21.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784m0-8a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 16q0-1.1.784-1.883A2.57 2.57 0 0 1 16 13.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784m0-8a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 8q0-1.1.784-1.883A2.57 2.57 0 0 1 16 5.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eminimize%3C/title%3E%3Cpath d='M8 25.333h16V28H8z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658H7.901v-2.658z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enext%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cpath d='M4 24h16v-2.667H4zM4 8v2.667h24V8zm0 9.333h24v-2.667H4z'/%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enot-allowed%3C/title%3E%3Cpath d='M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667M5.333 16c0-5.893 4.773-10.667 10.667-10.667 2.467 0 4.733.84 6.533 2.253L7.586 22.533A10.54 10.54 0 0 1 5.333 16M16 26.667c-2.467 0-4.733-.84-6.533-2.253L24.414 9.467A10.54 10.54 0 0 1 26.667 16c0 5.893-4.773 10.667-10.667 10.667'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epaste%3C/title%3E%3Cpath d='M25.333 4H19.76C19.2 2.453 17.733 1.333 16 1.333S12.8 2.453 12.24 4H6.667A2.675 2.675 0 0 0 4 6.667V28c0 1.467 1.2 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667V6.667C28.001 5.2 26.801 4 25.334 4zM16 4c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333S15.267 4 16 4m9.333 24H6.666V6.667h2.667v4h13.333v-4h2.667z'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epin%3C/title%3E%3Cpath d='m11.106 22.093-4.444 4.444-1.259-1.259 4.444-4.444zm5.872-16.63 9.618 9.62-.962.962-.962-.962-7.694 3.847 1.924 1.924-2.74 2.74-7.696-7.696 2.741-2.74 1.924 1.925 3.847-7.696-.962-.962z'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epivot%3C/title%3E%3Cpath d='M26.667 30.223H5.334a3.556 3.556 0 0 1-3.556-3.556V5.334a3.556 3.556 0 0 1 3.556-3.556h21.333a3.556 3.556 0 0 1 3.556 3.556v21.333a3.556 3.556 0 0 1-3.556 3.556m-16-8.89H5.334v5.333h5.333zm16-7.11H12.444v12.444h14.223zm-9.15 6.85-2.039 2.037 2.039 2.039-1.257 1.257-3.295-3.296 3.295-3.295q.63.628 1.257 1.257zm-6.85-6.85H5.334v5.333h5.333zm15.74 3.816-1.257 1.256-2.039-2.037-2.037 2.037-1.257-1.256 3.295-3.296zM10.667 5.333H5.334v5.333h5.333zm8.889 0h-7.112v5.333h7.112zm7.111 0h-5.333v5.333h5.333z'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658h-6.77v6.77h-2.658v-6.77h-6.77v-2.658h6.77v-6.77h2.658v6.77z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eprevious%3C/title%3E%3Cpath d='M20.94 9.88 19.06 8l-8 8 8 8 1.88-1.88L14.833 16z'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eright%3C/title%3E%3Cpath d='m16 5.333-1.88 1.88 7.44 7.453H5.333v2.667H21.56l-7.44 7.453 1.88 1.88 10.667-10.667L16 5.332z'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esave%3C/title%3E%3Cpath d='M25.333 16v9.333H6.666V16H3.999v9.333C3.999 26.8 5.199 28 6.666 28h18.667C26.8 28 28 26.8 28 25.333V16zm-8 .893 3.453-3.44 1.88 1.88L15.999 22l-6.667-6.667 1.88-1.88 3.453 3.44V4h2.667v12.893z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-down%3C/title%3E%3Cpath d='M9.333 12.667 16 19.334l6.667-6.667H9.334z'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-left%3C/title%3E%3Cpath d='M19.333 9.333 12.666 16l6.667 6.667V9.334z'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-right%3C/title%3E%3Cpath d='M12.667 22.667 19.334 16l-6.667-6.667v13.333z'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-up%3C/title%3E%3Cpath d='M9.333 19.333 16 12.666l6.667 6.667H9.334z'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etick%3C/title%3E%3Cpath d='m11.727 21.167-5.56-5.56-1.893 1.88 7.453 7.453 16-16-1.88-1.88z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-closed%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-indeterminate%3C/title%3E%3Cpath d='M6.667 14.667h18.667v2.667H6.667z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-open%3C/title%3E%3Cpath d='M22.12 11.06 16 17.167 9.88 11.06 8 12.94l8 8 8-8z'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eunlinked%3C/title%3E%3Cpath d='M22.667 9.333h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133c0 1.907-1.307 3.507-3.08 3.973l1.947 1.947c2.173-1.107 3.667-3.32 3.667-5.92a6.67 6.67 0 0 0-6.667-6.667zm-1.334 5.334h-2.92l2.667 2.667h.253zM2.667 5.693 6.814 9.84A6.65 6.65 0 0 0 2.667 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.334a4.136 4.136 0 0 1-4.133-4.133c0-2.12 1.613-3.867 3.68-4.093l2.76 2.76h-.973v2.667h3.64l3.027 3.027v2.307h2.307l5.347 5.333 1.68-1.68L4.362 4.002 2.669 5.695z'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333z'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egrip%3C/title%3E%3Cpath d='M26.667 12H5.334v2.667h21.333zM5.333 20h21.333v-2.667H5.333z'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M8 11a.75.75 0 0 0-.75.75v3.333a.75.75 0 1 0 1.5 0V11.75A.75.75 0 0 0 8 11'/%3E%3Cpath fill='currentColor' d='M13.11 1.436a.75.75 0 0 0-1.22-.872l-10 14a.75.75 0 1 0 1.22.872L5.207 12.5h7.376a.75.75 0 0 0 .75-.75v-1.174a2.08 2.08 0 0 0-1.153-1.863l-1.185-.599-.005-.002a.58.58 0 0 1-.323-.522V5.165a2.083 2.083 0 0 0 1.854-2.904zm-3.943 5.52v.634a2.08 2.08 0 0 0 1.153 1.863l1.185.6.005.002a.58.58 0 0 1 .323.522V11H6.28zM9.277 1H5.25a2.084 2.084 0 0 0-.083 4.165v1.676l1.5-2.132v-.292a.75.75 0 0 0-.75-.75H5.25a.584.584 0 0 1 0-1.167h2.972z'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M12.53 3.72A.75.75 0 0 1 12 5H4a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 .53.22M3.269 10.744a.75.75 0 0 1 .2-.524l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8.75 8.56V14a.75.75 0 0 1-1.5 0V8.56l-2.72 2.72a.75.75 0 0 1-1.26-.536'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M3.47 12.28A.75.75 0 0 1 4 11h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.53-.22M12.731 5.256a.75.75 0 0 1-.2.524l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 0 1 1.5 0v5.44l2.72-2.72a.75.75 0 0 1 1.26.536'/%3E%3C/svg%3E")}.ag-icon-chevron-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M3.479 10.521a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M12.521 5.461a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 0' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M10.53 12.512a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06l-3.47 3.47 3.47 3.47a.75.75 0 0 1 0 1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-chevron-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M5.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L8.94 8 5.47 4.53a.75.75 0 0 1 0-1.06' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-filter-add:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M18.666 24h-5.333v-2.667h5.333zM24 17.333H8v-2.667h16zm3.59-9.344h3.221v2.657h-3.22v3.22h-2.656v-3.22h-3.221V7.989h3.22V4.77h2.657zm-8.582 2.678H4V8h15.008z'/%3E%3C/svg%3E")}.ag-icon-edit:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M6.222 25.778h1.611l14.834-14.811-1.611-1.611-14.834 14.81zM4 28v-4.733L22.644 4.656a2.26 2.26 0 0 1 1.567-.634q.423 0 .833.167.412.166.734.478l1.589 1.6q.333.322.483.733t.15.822q0 .423-.161.839-.162.416-.472.728L8.733 28zm17.856-17.833-.8-.811 1.61 1.61z'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/material/icon-set-material.ts
var $437b23f6a393c3bf$export$e9404e008fead04f = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetMaterialCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/overrides/icon-overrides.ts
var $437b23f6a393c3bf$export$32f04c7493939075 = (args)=>{
    const cssParts = [];
    if (args.type === "image") {
        const { icons: icons, mask: mask } = args;
        for (const key of Object.keys(icons)){
            const imageCssValue = $437b23f6a393c3bf$var$imageValueToCss(icons[key]);
            if (mask) cssParts.push(`.ag-icon-${key}::before { mask-image: ${imageCssValue}; }`);
            else cssParts.push(`.ag-icon-${key}::before { background-image: ${imageCssValue}; ${$437b23f6a393c3bf$var$unsetMaskIcon} }`);
        }
    }
    if (args.type === "font") {
        const { family: family, weight: weight, color: color, icons: icons } = args;
        let properties = $437b23f6a393c3bf$var$unsetMaskIcon;
        if (family) properties += ` font-family: ${$437b23f6a393c3bf$var$fontFamilyValueToCss(family)};`;
        if (weight) properties += ` font-weight: ${$437b23f6a393c3bf$var$fontWeightValueToCss(weight)};`;
        if (color) properties += ` color: ${$437b23f6a393c3bf$var$colorValueToCss(color)};`;
        for (const key of Object.keys(icons))cssParts.push(`.ag-icon-${key}::before { content: ${JSON.stringify(icons[key])}; ${properties} }`);
    }
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        css: cssParts.join(";\n"),
        cssImports: args.cssImports
    });
};
var $437b23f6a393c3bf$var$unsetMaskIcon = `background-color: unset; mask-image: unset; -webkit-mask-image: unset;`;
// packages/ag-grid-community/src/theming/parts/icon-set/quartz/quartz-icon-data.ts
var $437b23f6a393c3bf$var$iconNameToSvgFragment = {
    aggregation: '<path d="M18 7V4H6l6 8-6 8h12v-3"/>',
    arrows: '<polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="22"/>',
    asc: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
    cancel: '<path d="m18 6-12 12"/><path d="m6 6 12 12"/>',
    chart: '<line x1="18" x2="18" y1="20" y2="10"/><line x1="12" x2="12" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="14"/>',
    "color-picker": '<path d="m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z"/><path d="m5 2 5 5"/><path d="M2 13h15"/><path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"/>',
    columns: '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>',
    contracted: '<path d="m9 18 6-6-6-6"/>',
    copy: '<rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>',
    cross: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    csv: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
    cut: '<circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/>',
    desc: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
    down: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
    excel: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
    expanded: '<path d="m15 18-6-6 6-6"/>',
    eye: '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
    "eye-slash": '<path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" x2="22" y1="2" y2="22"/>',
    filter: '<path d="M3 6h18"/><path d="M7 12h10"/><path d="M10 18h4"/>',
    first: '<path d="m17 18-6-6 6-6"/><path d="M7 6v12"/>',
    grip: '<circle cx="5" cy="8" r="0.5"/><circle cx="12" cy="8" r="0.5"/><circle cx="19" cy="8" r="0.5"/><circle cx="5" cy="16" r="0.5"/><circle cx="12" cy="16" r="0.5"/><circle cx="19" cy="16" r="0.5"/><g stroke="none" fill="currentColor"><circle cx="5" cy="8" r="1"/><circle cx="12" cy="8" r="1"/><circle cx="19" cy="8" r="1"/><circle cx="5" cy="16" r="1"/><circle cx="12" cy="16" r="1"/><circle cx="19" cy="16" r="1"/></g>',
    group: '<path d="M16 12H3"/><path d="M16 18H3"/><path d="M10 6H3"/><path d="M21 18V8a2 2 0 0 0-2-2h-5"/><path d="m16 8-2-2 2-2"/>',
    last: '<path d="m7 18 6-6-6-6"/><path d="M17 6v12"/>',
    left: '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',
    linked: '<path d="M9 17H7A5 5 0 0 1 7 7h2"/><path d="M15 7h2a5 5 0 1 1 0 10h-2"/><line x1="8" x2="16" y1="12" y2="12"/>',
    loading: '<line x1="12" x2="12" y1="2" y2="6"/><line x1="12" x2="12" y1="18" y2="22"/><line x1="4.93" x2="7.76" y1="4.93" y2="7.76"/><line x1="16.24" x2="19.07" y1="16.24" y2="19.07"/><line x1="2" x2="6" y1="12" y2="12"/><line x1="18" x2="22" y1="12" y2="12"/><line x1="4.93" x2="7.76" y1="19.07" y2="16.24"/><line x1="16.24" x2="19.07" y1="7.76" y2="4.93"/>',
    maximize: '<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" x2="14" y1="3" y2="10"/><line x1="3" x2="10" y1="21" y2="14"/>',
    menu: '<line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/>',
    "menu-alt": '<circle cx="12" cy="5" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="12" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="19" r="0.75" fill="#D9D9D9"/>',
    minimize: '<polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" x2="21" y1="10" y2="3"/><line x1="3" x2="10" y1="21" y2="14"/>',
    minus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/>',
    next: '<path d="m9 18 6-6-6-6"/>',
    none: '<path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/>',
    "not-allowed": '<circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/>',
    paste: '<path d="M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"/><path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"/><path d="m17 10 4 4-4 4"/>',
    pin: '<line x1="12" x2="12" y1="17" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>',
    pivot: '<path d="M15 3v18"/><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M21 9H3"/><path d="M21 15H3"/>',
    plus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/>',
    previous: '<path d="m15 18-6-6 6-6"/>',
    right: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    save: '<path d="M12 17V3"/><path d="m6 11 6 6 6-6"/><path d="M19 21H5"/>',
    settings: '<path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/>',
    "small-left": '<path d="m15 18-6-6 6-6"/>',
    "small-right": '<path d="m9 18 6-6-6-6"/>',
    tick: '<path d="M20 6 9 17l-5-5"/>',
    "tree-closed": '<path d="m9 18 6-6-6-6"/>',
    "tree-indeterminate": '<path d="M5 12h14"/>',
    "tree-open": '<path d="m6 9 6 6 6-6"/>',
    unlinked: '<path d="M9 17H7A5 5 0 0 1 7 7"/><path d="M15 7h2a5 5 0 0 1 4 8"/><line x1="8" x2="12" y1="12" y2="12"/><line x1="2" x2="22" y1="2" y2="22"/>',
    up: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>'
};
var $437b23f6a393c3bf$var$iconNameToFullSvg = {
    aasc: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2012 8.07928C13.6346 8.0793 14.0128 8.15365 14.3359 8.30193C14.6609 8.45018 14.9141 8.65595 15.0947 8.9201C15.2754 9.18439 15.3683 9.49109 15.374 9.83904H14.1904C14.1676 9.60898 14.0695 9.4303 13.8965 9.30291C13.7235 9.1756 13.4889 9.1115 13.1924 9.1115C12.9909 9.1115 12.8204 9.1404 12.6816 9.19744C12.543 9.25255 12.4364 9.32917 12.3623 9.42791C12.2901 9.52678 12.2539 9.63933 12.2539 9.76482C12.2501 9.8692 12.272 9.9604 12.3193 10.0383C12.3688 10.1162 12.4369 10.1843 12.5225 10.2414C12.6079 10.2964 12.7064 10.3451 12.8184 10.3869C12.9304 10.4268 13.0505 10.4609 13.1777 10.4894L13.7031 10.6144C13.9578 10.6715 14.1914 10.7479 14.4043 10.8429C14.6173 10.938 14.8021 11.0547 14.958 11.1935C15.1138 11.3323 15.2348 11.4957 15.3203 11.6838C15.4077 11.8719 15.4522 12.088 15.4541 12.3312C15.4522 12.6885 15.3611 12.9986 15.1807 13.2609C15.0019 13.5214 14.7427 13.7248 14.4043 13.8693C14.0678 14.0118 13.6617 14.0832 13.1865 14.0832C12.7153 14.0832 12.3048 14.0107 11.9551 13.8664C11.6071 13.7219 11.3345 13.5071 11.1387 13.2238C10.9449 12.9387 10.8435 12.5862 10.834 12.1662H12.0283C12.0416 12.362 12.0984 12.5252 12.1973 12.6564C12.298 12.7857 12.4323 12.8838 12.5996 12.9504C12.7688 13.0149 12.96 13.047 13.1729 13.047C13.3817 13.047 13.563 13.0169 13.7168 12.9562C13.8727 12.8954 13.9935 12.8106 14.0791 12.7023C14.1647 12.5939 14.208 12.469 14.208 12.3283C14.2079 12.1974 14.1686 12.0875 14.0908 11.9982C14.0148 11.9089 13.9022 11.8324 13.7539 11.7697C13.6076 11.707 13.4276 11.6501 13.2148 11.5988L12.5791 11.4387C12.0869 11.3189 11.6982 11.1318 11.4131 10.8771C11.128 10.6224 10.9855 10.2793 10.9873 9.84783C10.9854 9.49418 11.0804 9.18439 11.2705 8.9201C11.4625 8.65603 11.7261 8.45015 12.0605 8.30193C12.3951 8.15369 12.7754 8.07928 13.2012 8.07928Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.8125 14.0002H4.48926L4.05664 12.6681H1.94824L1.51465 14.0002H0.19043L2.20703 8.15935H3.79883L5.8125 14.0002ZM2.26172 11.7043H3.74316L3.02539 9.49334H2.98047L2.26172 11.7043Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.45215 8.15935C8.88165 8.15935 9.24031 8.22251 9.52734 8.34978C9.81445 8.47717 10.0303 8.65477 10.1748 8.88103C10.3192 9.10536 10.3916 9.36368 10.3916 9.65642C10.3916 9.88452 10.3461 10.085 10.2549 10.258C10.1637 10.4289 10.0384 10.5696 9.87891 10.6799C9.72117 10.7882 9.54024 10.8657 9.33691 10.9113V10.9679C9.55917 10.9775 9.76716 11.0406 9.96094 11.1564C10.1568 11.2724 10.3158 11.4356 10.4375 11.6447C10.5591 11.8519 10.6201 12.099 10.6201 12.3859C10.6201 12.6958 10.5427 12.9727 10.3887 13.216C10.2366 13.4573 10.0113 13.6486 9.71289 13.7892C9.41443 13.9299 9.04655 14.0002 8.60938 14.0002H6.11426V8.15935H8.45215ZM7.34863 12.9904H8.35547C8.69943 12.9904 8.95057 12.9252 9.1084 12.7941C9.26621 12.661 9.34473 12.4834 9.34473 12.2629C9.34468 12.1014 9.30643 11.9587 9.22852 11.8351C9.15056 11.7116 9.03903 11.6145 8.89453 11.5441C8.75195 11.4738 8.58148 11.4387 8.38379 11.4387H7.34863V12.9904ZM7.34863 10.6037H8.26465C8.43369 10.6036 8.58376 10.5737 8.71484 10.5148C8.84793 10.454 8.95227 10.3683 9.02832 10.258C9.10628 10.1477 9.14551 10.0155 9.14551 9.8615C9.14546 9.65055 9.07008 9.48001 8.91992 9.35076C8.77165 9.22169 8.56064 9.15741 8.28711 9.1574H7.34863V10.6037Z" fill="black"/><path d="M7.16602 0.377127C7.44584 0.189493 7.82551 0.20905 8.08496 0.442557L11.418 3.44256C11.7257 3.71966 11.7507 4.19428 11.4736 4.50213C11.1966 4.80961 10.7228 4.83441 10.415 4.55779L7.60938 2.03338L5.11328 4.53045C4.82042 4.82326 4.34562 4.82322 4.05273 4.53045C3.75986 4.23757 3.75989 3.7628 4.05273 3.4699L7.05273 0.4699L7.16602 0.377127Z" fill="black"/></svg>`,
    adesc: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.3867 11.4697C10.6796 11.1771 11.1544 11.1769 11.4473 11.4697C11.7399 11.7626 11.7399 12.2374 11.4473 12.5303L8.44727 15.5303L8.33398 15.623C8.05425 15.8106 7.67449 15.7909 7.41504 15.5576L4.08203 12.5576C3.77415 12.2805 3.74927 11.8059 4.02637 11.498C4.30342 11.1907 4.77722 11.1657 5.08496 11.4424L7.89062 13.9668L10.3867 11.4697Z" fill="black"/><path d="M13.2012 3.0791C13.6346 3.07912 14.0128 3.1535 14.3359 3.30176C14.6611 3.45006 14.9141 3.65661 15.0947 3.9209C15.2752 4.18513 15.3683 4.49104 15.374 4.83887H14.1904C14.1676 4.60882 14.0695 4.43012 13.8965 4.30273C13.7235 4.17546 13.4889 4.11133 13.1924 4.11133C12.9909 4.11133 12.8204 4.14023 12.6816 4.19727C12.5431 4.25236 12.4364 4.32902 12.3623 4.42773C12.2901 4.52659 12.2539 4.63919 12.2539 4.76465C12.2501 4.86901 12.272 4.96023 12.3193 5.03809C12.3688 5.11604 12.4369 5.18417 12.5225 5.24121C12.6079 5.29623 12.7064 5.34496 12.8184 5.38672C12.9304 5.42661 13.0505 5.46075 13.1777 5.48926L13.7031 5.61426C13.9578 5.67128 14.1914 5.74776 14.4043 5.84277C14.6172 5.93784 14.8021 6.05457 14.958 6.19336C15.1139 6.33216 15.2348 6.49633 15.3203 6.68457C15.4076 6.8727 15.4522 7.08885 15.4541 7.33203C15.4521 7.68929 15.3612 7.99944 15.1807 8.26172C15.0019 8.52216 14.7427 8.72465 14.4043 8.86914C14.0678 9.01165 13.6617 9.08301 13.1865 9.08301C12.7153 9.08299 12.3048 9.01057 11.9551 8.86621C11.6072 8.72173 11.3345 8.50786 11.1387 8.22461C10.9447 7.9394 10.8435 7.58622 10.834 7.16602H12.0283C12.0416 7.36176 12.0985 7.52509 12.1973 7.65625C12.298 7.78554 12.4323 7.88365 12.5996 7.9502C12.7688 8.01477 12.96 8.04785 13.1729 8.04785C13.3817 8.04781 13.5629 8.01678 13.7168 7.95605C13.8727 7.89522 13.9935 7.81051 14.0791 7.70215C14.1646 7.59387 14.2079 7.46965 14.208 7.3291C14.208 7.19796 14.1687 7.08739 14.0908 6.99805C14.0148 6.90868 13.9022 6.83228 13.7539 6.76953C13.6076 6.70685 13.4276 6.64993 13.2148 6.59863L12.5791 6.43848C12.0868 6.31871 11.6982 6.13163 11.4131 5.87695C11.1279 5.62221 10.9855 5.27916 10.9873 4.84766C10.9854 4.49404 11.0804 4.18517 11.2705 3.9209C11.4625 3.65661 11.7259 3.45006 12.0605 3.30176C12.3951 3.15353 12.7754 3.0791 13.2012 3.0791Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.8125 9H4.48926L4.05664 7.66797H1.94824L1.51465 9H0.19043L2.20703 3.15918H3.79883L5.8125 9ZM2.26172 6.7041H3.74316L3.02539 4.49414H2.98047L2.26172 6.7041Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.45215 3.15918C8.88181 3.15918 9.24025 3.22322 9.52734 3.35059C9.81445 3.47798 10.0303 3.6546 10.1748 3.88086C10.3193 4.10518 10.3916 4.36351 10.3916 4.65625C10.3916 4.88432 10.3461 5.08484 10.2549 5.25781C10.1636 5.4289 10.0386 5.57039 9.87891 5.68066C9.72118 5.78898 9.54022 5.86549 9.33691 5.91113V5.96875C9.55913 5.9783 9.76719 6.04044 9.96094 6.15625C10.1568 6.27223 10.3158 6.43538 10.4375 6.64453C10.5591 6.85173 10.6201 7.09875 10.6201 7.38574C10.6201 7.69567 10.5427 7.97245 10.3887 8.21582C10.2366 8.45719 10.0113 8.64841 9.71289 8.78906C9.41442 8.9297 9.04658 8.99999 8.60938 9H6.11426V3.15918H8.45215ZM7.34863 7.99023H8.35547C8.69948 7.99023 8.95057 7.92504 9.1084 7.79395C9.26621 7.66085 9.34473 7.48325 9.34473 7.2627C9.34466 7.10125 9.3064 6.95844 9.22852 6.83496C9.15056 6.71143 9.03899 6.61427 8.89453 6.54395C8.75196 6.47365 8.58145 6.43848 8.38379 6.43848H7.34863V7.99023ZM7.34863 5.60352H8.26465C8.43369 5.60347 8.58376 5.57354 8.71484 5.51465C8.84791 5.45381 8.95228 5.36807 9.02832 5.25781C9.10623 5.14755 9.14551 5.01529 9.14551 4.86133C9.14542 4.65046 9.07002 4.48078 8.91992 4.35156C8.77163 4.22228 8.56087 4.15724 8.28711 4.15723H7.34863V5.60352Z" fill="black"/></svg>`,
    "chevron-down": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6L8 10L4 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "chevron-left": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "chevron-right": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "chevron-up": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 10L8 6L12 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    "column-arrow": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 26C0 28.2092 1.79086 30 4 30H14C16.2091 30 18 28.2092 18 26V15H25.8786L24.4394 16.4393C23.8536 17.0251 23.8536 17.9749 24.4394 18.5607C25.0252 19.1464 25.9748 19.1464 26.5606 18.5607L30.5606 14.5607C31.1464 13.9749 31.1464 13.0251 30.5606 12.4393L26.5606 8.43934C25.9748 7.85356 25.0252 7.85356 24.4394 8.43934C23.8536 9.02512 23.8536 9.97488 24.4394 10.5607L25.8786 12H18V6C18 3.79086 16.2091 2 14 2H4C1.79086 2 0 3.79086 0 6V26ZM14 5H10.5V12H15V6C15 5.44772 14.5523 5 14 5ZM4 5H7.5V12H3V6C3 5.44772 3.44772 5 4 5ZM10.5 15H15V26C15 26.5522 14.5523 27 14 27H10.5V15ZM4 27H7.5V15H3V26C3 26.5522 3.44772 27 4 27Z" fill="currentColor"/></svg>',
    edit: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 10.6262V12.5012H5.375L10.905 6.97122L9.03 5.09622L3.5 10.6262ZM12.355 5.52122C12.4014 5.47497 12.4381 5.42002 12.4632 5.35953C12.4883 5.29905 12.5012 5.23421 12.5012 5.16872C12.5012 5.10324 12.4883 5.0384 12.4632 4.97791C12.4381 4.91742 12.4014 4.86248 12.355 4.81622L11.185 3.64622C11.1387 3.59987 11.0838 3.5631 11.0233 3.53801C10.9628 3.51291 10.898 3.5 10.8325 3.5C10.767 3.5 10.7022 3.51291 10.6417 3.53801C10.5812 3.5631 10.5263 3.59987 10.48 3.64622L9.565 4.56122L11.44 6.43622L12.355 5.52122Z" fill="currentColor"/></svg>',
    "filter-add": '<svg width="16" height="16" viewBox="0 0 16 16" class="ag-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.12126 7.75L10.8517 7.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M6.65934 11.748L9.32778 11.748" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M12.2943 1.04872V6.19184M14.9886 3.74341H9.68478" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M8.25488 3C8.04799 3.18323 7.91706 3.45099 7.91699 3.74902C7.91713 4.04868 8.04988 4.31681 8.25879 4.5H2C1.58579 4.5 1.25 4.16421 1.25 3.75C1.25 3.33579 1.58579 3 2 3H8.25488Z" fill="currentColor"/></svg>',
    "pinned-bottom": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M3.47 12.28A.75.75 0 0 1 4 11h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.53-.22ZM12.731 5.256a.75.75 0 0 1-.2.524l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 0 1 1.5 0v5.44l2.72-2.72a.75.75 0 0 1 1.26.536Z"/></svg>',
    "pinned-top": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.53 3.72A.75.75 0 0 1 12 5H4a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 .53.22ZM3.269 10.744a.75.75 0 0 1 .2-.524l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8.75 8.56V14a.75.75 0 0 1-1.5 0V8.56l-2.72 2.72a.75.75 0 0 1-1.26-.536Z"/></svg>',
    "small-down": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 10.667 16 21.334l8.667-10.667H7.334Z"/></svg>',
    "small-up": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 21.333 16 10.666l8.667 10.667H7.334Z"/></svg>',
    "un-pin": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M8 11a.75.75 0 0 0-.75.75v3.333a.75.75 0 1 0 1.5 0V11.75A.75.75 0 0 0 8 11Z"/><path fill="currentColor" d="M13.11 1.436a.75.75 0 0 0-1.22-.872l-10 14a.75.75 0 1 0 1.22.872L5.207 12.5h7.376a.75.75 0 0 0 .75-.75v-1.174a2.08 2.08 0 0 0-1.153-1.863l-1.185-.599-.005-.002a.58.58 0 0 1-.323-.522V5.165a2.083 2.083 0 0 0 1.854-2.904l.589-.825Zm-3.943 5.52v.634a2.08 2.08 0 0 0 1.153 1.863l1.185.6.005.002a.58.58 0 0 1 .323.522V11H6.28l2.887-4.044ZM9.277 1H5.25a2.084 2.084 0 0 0-.083 4.165v1.676l1.5-2.132v-.292a.75.75 0 0 0-.75-.75H5.25a.584.584 0 0 1 0-1.167h2.972L9.277 1Z"/></svg>'
};
var $437b23f6a393c3bf$var$getQuartzIconsCss = (args = {})=>{
    let result = "";
    for (const iconName of [
        ...Object.keys($437b23f6a393c3bf$var$iconNameToSvgFragment),
        ...Object.keys($437b23f6a393c3bf$var$iconNameToFullSvg)
    ]){
        const iconSvg = $437b23f6a393c3bf$var$quartzIconSvg(iconName, args.strokeWidth);
        result += `.ag-icon-${iconName}::before { mask-image: url('data:image/svg+xml,${encodeURIComponent(iconSvg)}'); }
`;
    }
    return result;
};
var $437b23f6a393c3bf$var$quartzIconSvg = (name, strokeWidth = 1.5)=>{
    const fullSVG = $437b23f6a393c3bf$var$iconNameToFullSvg[name];
    if (fullSVG) return fullSVG;
    const svgFragment = $437b23f6a393c3bf$var$iconNameToSvgFragment[name];
    if (!svgFragment) throw new Error(`Missing icon data for ${name}`);
    return `<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="black" stroke-width="${strokeWidth}" viewBox="0 0 24 24"><style>* { vector-effect: non-scaling-stroke; }</style>` + svgFragment + "</svg>";
};
// packages/ag-grid-community/src/theming/parts/icon-set/quartz/icon-set-quartz.ts
var $437b23f6a393c3bf$export$d2d85e4420173ddb = (args = {})=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "iconSet",
        css: ()=>$437b23f6a393c3bf$var$getQuartzIconsCss(args)
    });
};
var $437b23f6a393c3bf$export$3147a7744202f5a7 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb({
    strokeWidth: 1
});
var $437b23f6a393c3bf$export$b60dff12ba08ba55 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb();
var $437b23f6a393c3bf$export$3a4c15e55a998025 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb({
    strokeWidth: 2
});
// packages/ag-grid-community/src/theming/parts/input-style/input-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleBaseCSS = /*css*/ `:where(.ag-input-field-input[type=number]:not(.ag-number-field-input-stepper)){-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}}.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){background-color:var(--ag-input-background-color);border:var(--ag-input-border);border-radius:var(--ag-input-border-radius);color:var(--ag-input-text-color);font-family:inherit;font-size:inherit;line-height:inherit;margin:0;min-height:var(--ag-input-height);padding:0;&:where(:disabled){background-color:var(--ag-input-disabled-background-color);border:var(--ag-input-disabled-border);color:var(--ag-input-disabled-text-color)}&:where(:focus){background-color:var(--ag-input-focus-background-color);border:var(--ag-input-focus-border);box-shadow:var(--ag-input-focus-shadow);color:var(--ag-input-focus-text-color);outline:none}&:where(:invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&::-moz-placeholder{color:var(--ag-input-placeholder-text-color)}&::placeholder{color:var(--ag-input-placeholder-text-color)}}:where(.ag-ltr) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-left:var(--ag-input-padding-start)}:where(.ag-rtl) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-right:var(--ag-input-padding-start)}:where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select,.ag-floating-filter-search-icon){.ag-input-wrapper:before{background-color:currentcolor;color:var(--ag-input-icon-color);content:"";display:block;height:12px;-webkit-mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;opacity:.5;position:absolute;width:12px}}:where(.ag-ltr) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select,.ag-floating-filter-search-icon){.ag-input-wrapper:before{margin-left:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-left:calc(var(--ag-spacing)*1.5 + 12px)}}:where(.ag-rtl) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter,.ag-filter-add-select,.ag-floating-filter-search-icon){.ag-input-wrapper:before{margin-right:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-right:calc(var(--ag-spacing)*1.5 + 12px)}}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-style-bordered.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleBorderedCSS = /*css*/ `.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){&:focus{box-shadow:var(--ag-focus-shadow);&:where(.invalid),&:where(:invalid){box-shadow:var(--ag-focus-error-shadow)}}}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-style-underlined.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleUnderlinedCSS = /*css*/ `.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){border-left:none;border-right:none;border-top:none}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-styles.ts
var $437b23f6a393c3bf$var$baseParams3 = {
    inputBackgroundColor: "transparent",
    inputBorder: false,
    inputBorderRadius: 0,
    inputTextColor: {
        ref: "textColor"
    },
    inputPlaceholderTextColor: {
        ref: "inputTextColor",
        mix: 0.5
    },
    inputPaddingStart: 0,
    inputHeight: {
        calc: "max(iconSize, fontSize) + spacing * 2"
    },
    inputFocusBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputFocusBorder: {
        ref: "inputBorder"
    },
    inputFocusShadow: "none",
    inputFocusTextColor: {
        ref: "inputTextColor"
    },
    inputDisabledBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputDisabledBorder: {
        ref: "inputBorder"
    },
    inputDisabledTextColor: {
        ref: "inputTextColor"
    },
    inputInvalidBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputInvalidBorder: {
        ref: "inputBorder"
    },
    inputInvalidTextColor: {
        ref: "inputTextColor"
    },
    inputIconColor: {
        ref: "inputTextColor"
    },
    pickerButtonBorder: false,
    pickerButtonFocusBorder: {
        ref: "inputFocusBorder"
    },
    pickerButtonBackgroundColor: {
        ref: "backgroundColor"
    },
    pickerButtonFocusBackgroundColor: {
        ref: "backgroundColor"
    },
    pickerListBorder: false,
    pickerListBackgroundColor: {
        ref: "backgroundColor"
    },
    colorPickerThumbSize: 18,
    colorPickerTrackSize: 12,
    colorPickerThumbBorderWidth: 3,
    colorPickerTrackBorderRadius: 12,
    colorPickerColorBorderRadius: 4
};
var $437b23f6a393c3bf$var$makeInputStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: $437b23f6a393c3bf$var$baseParams3,
        css: $437b23f6a393c3bf$var$inputStyleBaseCSS
    });
var $437b23f6a393c3bf$export$2c8ad0489069516 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeInputStyleBorderedTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams3,
            inputBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            inputBorder: true,
            inputBorderRadius: {
                ref: "borderRadius"
            },
            inputPaddingStart: {
                ref: "spacing"
            },
            inputFocusBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            },
            inputFocusShadow: {
                ref: "focusShadow"
            },
            inputDisabledBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.06),
            inputDisabledTextColor: {
                ref: "textColor",
                mix: 0.5
            },
            inputInvalidBorder: {
                color: {
                    ref: "invalidColor"
                }
            },
            pickerButtonBorder: true,
            pickerListBorder: true
        },
        css: ()=>$437b23f6a393c3bf$var$inputStyleBaseCSS + $437b23f6a393c3bf$var$inputStyleBorderedCSS
    });
var $437b23f6a393c3bf$export$df11db3e1948ad10 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleBorderedTreeShakeable();
var $437b23f6a393c3bf$var$makeInputStyleUnderlinedTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams3,
            inputBackgroundColor: "transparent",
            inputBorder: {
                width: 2,
                color: $437b23f6a393c3bf$var$foregroundMix(0.3)
            },
            inputPaddingStart: {
                ref: "spacing"
            },
            inputFocusBorder: "solid 2px var(--ag-accent-color)",
            inputDisabledTextColor: {
                ref: "textColor",
                mix: 0.5
            },
            inputDisabledBorder: "solid 1px var(--ag-border-color)",
            inputInvalidBorder: {
                width: 2,
                color: {
                    ref: "invalidColor",
                    mix: 0.3
                }
            }
        },
        css: ()=>$437b23f6a393c3bf$var$inputStyleBaseCSS + $437b23f6a393c3bf$var$inputStyleUnderlinedCSS
    });
var $437b23f6a393c3bf$export$c9667c02da45fcf0 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleUnderlinedTreeShakeable();
// packages/ag-grid-community/src/theming/parts/tab-style/tab-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$tabStyleBaseCSS = /*css*/ `.ag-tabs-header{background-color:var(--ag-tab-bar-background-color);border-bottom:var(--ag-tab-bar-border);display:flex;flex:1;gap:var(--ag-tab-spacing);padding:var(--ag-tab-bar-top-padding) var(--ag-tab-bar-horizontal-padding) 0}.ag-tabs-header-wrapper{display:flex}.ag-tabs-close-button-wrapper{align-items:center;border:0;display:flex;padding:var(--ag-spacing)}:where(.ag-ltr) .ag-tabs-close-button-wrapper{border-right:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-tabs-close-button-wrapper{border-left:solid var(--ag-border-width) var(--ag-border-color)}.ag-tabs-close-button{background-color:unset;border:0;cursor:pointer;padding:0}.ag-tab{align-items:center;background-color:var(--ag-tab-background-color);border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;color:var(--ag-tab-text-color);cursor:pointer;display:flex;flex:1;justify-content:center;padding:var(--ag-tab-top-padding) var(--ag-tab-horizontal-padding) var(--ag-tab-bottom-padding);position:relative;&:hover{background-color:var(--ag-tab-hover-background-color);color:var(--ag-tab-hover-text-color)}&.ag-tab-selected{background-color:var(--ag-tab-selected-background-color);color:var(--ag-tab-selected-text-color)}&:after{background-color:var(--ag-tab-selected-underline-color);bottom:0;content:"";display:block;height:var(--ag-tab-selected-underline-width);left:0;opacity:0;position:absolute;right:0;transition:opacity var(--ag-tab-selected-underline-transition-duration)}&.ag-tab-selected:after{opacity:1}}:where(.ag-ltr) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-left-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-right-color:var(--ag-tab-selected-border-color)}}}:where(.ag-rtl) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-right-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-left-color:var(--ag-tab-selected-border-color)}}}`;
// packages/ag-grid-community/src/theming/parts/tab-style/tab-style-rolodex.css-GENERATED.ts
var $437b23f6a393c3bf$var$tabStyleRolodexCSS = /*css*/ `.ag-tab{border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;border-top:var(--ag-tab-selected-border-width) solid transparent;flex:none;&.ag-tab-selected{border-left-color:var(--ag-tab-selected-border-color);border-right-color:var(--ag-tab-selected-border-color);border-top-color:var(--ag-tab-selected-border-color);margin-bottom:-1px;padding-bottom:calc(var(--ag-tab-bottom-padding) + 1px)}}`;
// packages/ag-grid-community/src/theming/parts/tab-style/tab-styles.ts
var $437b23f6a393c3bf$var$baseParams4 = {
    tabBarBackgroundColor: "transparent",
    tabBarHorizontalPadding: 0,
    tabBarTopPadding: 0,
    tabBackgroundColor: "transparent",
    tabTextColor: {
        ref: "textColor"
    },
    tabHorizontalPadding: {
        ref: "spacing"
    },
    tabTopPadding: {
        ref: "spacing"
    },
    tabBottomPadding: {
        ref: "spacing"
    },
    tabSpacing: "0",
    tabHoverBackgroundColor: {
        ref: "tabBackgroundColor"
    },
    tabHoverTextColor: {
        ref: "tabTextColor"
    },
    tabSelectedBackgroundColor: {
        ref: "tabBackgroundColor"
    },
    tabSelectedTextColor: {
        ref: "tabTextColor"
    },
    tabSelectedBorderWidth: {
        ref: "borderWidth"
    },
    tabSelectedBorderColor: "transparent",
    tabSelectedUnderlineColor: "transparent",
    tabSelectedUnderlineWidth: 0,
    tabSelectedUnderlineTransitionDuration: 0,
    tabBarBorder: false
};
var $437b23f6a393c3bf$var$makeTabStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: $437b23f6a393c3bf$var$baseParams4,
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$7e3279c3902732ba = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBorder: true,
            tabBarBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.05),
            tabTextColor: {
                ref: "textColor",
                mix: 0.7
            },
            tabSelectedTextColor: {
                ref: "textColor"
            },
            tabHoverTextColor: {
                ref: "textColor"
            },
            tabSelectedBorderColor: {
                ref: "borderColor"
            },
            tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$7ad22b51edfdfcfe = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleMaterialTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabSelectedUnderlineColor: {
                ref: "primaryColor"
            },
            tabSelectedUnderlineWidth: 2,
            tabSelectedUnderlineTransitionDuration: 0
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$4c07fbd6ebedeb01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleMaterialTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBorder: true,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabHoverTextColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedTextColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedUnderlineWidth: 2,
            tabSelectedUnderlineTransitionDuration: "0.3s"
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$e3b539837601fcda = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleRolodexTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams4,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabBarHorizontalPadding: {
                ref: "spacing"
            },
            tabBarTopPadding: {
                ref: "spacing"
            },
            tabBarBorder: true,
            tabHorizontalPadding: {
                calc: "spacing * 2"
            },
            tabTopPadding: {
                ref: "spacing"
            },
            tabBottomPadding: {
                ref: "spacing"
            },
            tabSpacing: {
                ref: "spacing"
            },
            tabSelectedBorderColor: {
                ref: "borderColor"
            },
            tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: ()=>$437b23f6a393c3bf$var$tabStyleBaseCSS + $437b23f6a393c3bf$var$tabStyleRolodexCSS
    });
var $437b23f6a393c3bf$export$5c4a9ec5ca09df01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleRolodexTreeShakeable();
// packages/ag-grid-community/src/theming/parts/theme/material-adjustments.css-GENERATED.ts
var $437b23f6a393c3bf$var$materialAdjustmentsCSS = /*css*/ `.ag-dnd-ghost,.ag-filter-toolpanel-header,.ag-filter-toolpanel-search,.ag-multi-filter-group-title-bar,.ag-panel-title-bar-title,.ag-status-bar{color:var(--ag-header-text-color);font-size:calc(var(--ag-font-size) - 1px);font-weight:600}.ag-column-drop-horizontal{background-color:color-mix(in srgb,var(--ag-background-color),var(--ag-foreground-color) 8%)}.ag-cell.ag-cell-inline-editing{background-color:var(--ag-background-color);background-image:linear-gradient(0deg,var(--ag-input-background-color),var(--ag-input-background-color));border:var(--ag-input-border)!important;border-width:1px!important;height:calc(var(--ag-row-height) + var(--ag-spacing)*3);padding:var(--ag-spacing);:where(.ag-row-last:not(.ag-row-first)) &{bottom:0}:where(.ag-has-focus) &{border:var(--ag-input-focus-border)!important;border-width:1px!important}}.ag-advanced-filter-builder-button,.ag-standard-button{text-transform:uppercase}.ag-status-bar{border:solid var(--ag-border-width) var(--ag-border-color)}.ag-list-item-hovered:after{background-color:var(--ag-primary-color)}.ag-pill-button:hover{color:var(--ag-primary-color)}.ag-filter-add-button,.ag-filter-add-button:hover{border-bottom:2px solid var(--ag-primary-color)}`;
// packages/ag-grid-community/src/theming/parts/theme/themes.ts
var $437b23f6a393c3bf$var$makeThemeQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$b60dff12ba08ba55).withPart($437b23f6a393c3bf$export$7ad22b51edfdfcfe).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0).withParams({
        fontFamily: [
            {
                googleFont: "IBM Plex Sans"
            },
            "-apple-system",
            "BlinkMacSystemFont",
            "Segoe UI",
            "Roboto",
            "Oxygen-Sans",
            "Ubuntu"
        ]
    });
var $437b23f6a393c3bf$export$495b90cf446940a1 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$c5a38eb31ae86567).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$9bb4a1bee1653083).withPart($437b23f6a393c3bf$export$e3b539837601fcda).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0).withParams({
        accentColor: "#2196f3",
        selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.3),
        inputFocusBorder: {
            color: $437b23f6a393c3bf$var$accentMix(0.4)
        },
        focusShadow: {
            radius: 2,
            spread: 1.6,
            color: $437b23f6a393c3bf$var$accentMix(0.4)
        },
        iconButtonHoverBackgroundColor: "transparent",
        iconButtonActiveBackgroundColor: "transparent",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxIndeterminateBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxBorderWidth: 2,
        checkboxBorderRadius: 2,
        fontSize: 13,
        dataFontSize: 14,
        headerFontWeight: 700,
        borderRadius: 3,
        wrapperBorderRadius: 3,
        tabSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
        tabSelectedBorderWidth: 0,
        tabSelectedUnderlineTransitionDuration: 0.3,
        sideButtonSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
        sideButtonSelectedUnderlineWidth: 2,
        sideButtonSelectedUnderlineTransitionDuration: 0.3,
        sideButtonBorder: false,
        sideButtonSelectedBorder: false,
        sideButtonBarTopPadding: {
            calc: "spacing * 3"
        },
        sideButtonSelectedBackgroundColor: "transparent",
        sideButtonHoverTextColor: $437b23f6a393c3bf$var$accentColor,
        iconButtonHoverColor: $437b23f6a393c3bf$var$accentColor,
        toggleButtonWidth: 28,
        toggleButtonHeight: 18,
        toggleButtonSwitchInset: 1,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        colorPickerThumbSize: 13,
        colorPickerTrackSize: 11,
        colorPickerThumbBorderWidth: 2,
        colorPickerTrackBorderRadius: 2,
        colorPickerColorBorderRadius: 2
    });
var $437b23f6a393c3bf$export$dfd7728c5c3233e9 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeBalhamTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$effe67f8e12191d5).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$var$iconSetBalham).withPart($437b23f6a393c3bf$export$5c4a9ec5ca09df01).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9eadc93b54e4a807).withParams({
        accentColor: "#0091ea",
        borderColor: $437b23f6a393c3bf$var$foregroundMix(0.2),
        spacing: 4,
        widgetVerticalSpacing: {
            calc: "max(8px, spacing)"
        },
        borderRadius: 2,
        wrapperBorderRadius: 2,
        headerColumnResizeHandleColor: "transparent",
        headerColumnBorder: true,
        headerColumnBorderHeight: "50%",
        oddRowBackgroundColor: {
            ref: "chromeBackgroundColor",
            mix: 0.5
        },
        checkboxBorderRadius: 2,
        checkboxBorderWidth: 1,
        checkboxUncheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxCheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxCheckedBorderColor: $437b23f6a393c3bf$var$accentColor,
        checkboxCheckedShapeColor: $437b23f6a393c3bf$var$accentColor,
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxIndeterminateBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxIndeterminateShapeColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        focusShadow: {
            radius: 2,
            spread: 1,
            color: $437b23f6a393c3bf$var$accentColor
        },
        headerTextColor: $437b23f6a393c3bf$var$foregroundMix(0.6),
        iconButtonHoverBackgroundColor: "transparent",
        iconButtonActiveBackgroundColor: "transparent",
        fontSize: 12,
        tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        headerFontWeight: "bold",
        toggleButtonWidth: 32,
        toggleButtonHeight: 16,
        toggleButtonSwitchInset: 1,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        sideButtonBorder: true,
        sideButtonBarTopPadding: {
            calc: "spacing * 4"
        },
        popupShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)",
        statusBarLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.54),
        statusBarLabelFontWeight: 600,
        statusBarValueFontWeight: 600,
        panelTitleBarIconColor: $437b23f6a393c3bf$var$foregroundColor,
        colorPickerThumbSize: 13,
        colorPickerTrackSize: 11,
        colorPickerThumbBorderWidth: 2,
        colorPickerTrackBorderRadius: 2,
        colorPickerColorBorderRadius: 2
    });
var $437b23f6a393c3bf$export$679a577f1afc49d7 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeBalhamTreeShakeable();
var $437b23f6a393c3bf$var$makeStyleMaterialTreeShakeable = ()=>{
    const sharedParams = {
        tabSelectedUnderlineColor: {
            ref: "primaryColor"
        },
        sideButtonSelectedUnderlineColor: {
            ref: "primaryColor"
        },
        buttonTextColor: {
            ref: "primaryColor"
        },
        rangeSelectionBackgroundColor: {
            ref: "primaryColor",
            mix: 0.2
        },
        rangeSelectionBorderColor: {
            ref: "primaryColor"
        },
        rangeSelectionHighlightColor: {
            ref: "primaryColor",
            mix: 0.5
        },
        rangeHeaderHighlightColor: {
            ref: "foregroundColor",
            mix: 0.08
        },
        rowNumbersSelectedColor: {
            ref: "primaryColor",
            mix: 0.5
        },
        inputFocusBorder: {
            width: 2,
            color: {
                ref: "primaryColor"
            }
        },
        pickerButtonFocusBorder: {
            width: 1,
            color: {
                ref: "primaryColor"
            }
        },
        cellEditingBorder: {
            color: {
                ref: "primaryColor"
            }
        },
        menuBackgroundColor: {
            ref: "backgroundColor"
        },
        sideButtonBarBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        sideButtonSelectedBackgroundColor: "transparent",
        sideButtonBarTopPadding: {
            calc: "spacing * 4"
        },
        headerColumnResizeHandleColor: "none",
        headerBackgroundColor: {
            ref: "backgroundColor"
        },
        rowHoverColor: $437b23f6a393c3bf$var$foregroundMix(0.08),
        columnHoverColor: $437b23f6a393c3bf$var$foregroundMix(0.08),
        headerCellHoverBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.05),
        statusBarLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.63),
        statusBarLabelFontWeight: 600,
        statusBarValueFontWeight: 600,
        valueChangeValueHighlightBackgroundColor: "#00acc1",
        panelTitleBarIconColor: $437b23f6a393c3bf$var$foregroundColor,
        advancedFilterBuilderButtonBarBorder: false,
        filterPanelApplyButtonColor: {
            ref: "buttonTextColor"
        },
        filterPanelApplyButtonBackgroundColor: {
            ref: "buttonBackgroundColor"
        },
        colorPickerThumbSize: 13,
        colorPickerTrackSize: 11,
        colorPickerThumbBorderWidth: 2,
        colorPickerTrackBorderRadius: 2,
        colorPickerColorBorderRadius: 2,
        rowDragIndicatorColor: {
            ref: "primaryColor"
        },
        columnDragIndicatorColor: {
            ref: "primaryColor"
        }
    };
    const lightParams = {
        ...sharedParams,
        primaryColor: "#3f51b5",
        foregroundColor: "#000D",
        headerTextColor: "#0008",
        accentColor: "#ff4081",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundColor,
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundColor,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundColor,
        selectedRowBackgroundColor: "rgba(33, 150, 243, 0.3)"
    };
    const darkParams2 = {
        ...sharedParams,
        primaryColor: "#3f51b5",
        foregroundColor: "#fffD",
        headerTextColor: "#fff8",
        accentColor: "#bb86fc",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        selectedRowBackgroundColor: "#bb86fc33"
    };
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "styleMaterial",
        css: $437b23f6a393c3bf$var$materialAdjustmentsCSS,
        params: lightParams,
        modeParams: {
            light: lightParams,
            dark: darkParams2,
            "dark-blue": darkParams2
        }
    });
};
var $437b23f6a393c3bf$export$5fe7e1ddfe58a67 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeStyleMaterialTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeMaterialTreeShakeable = ()=>/* @__PURE__ */ $437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$ac3227978dde8e12).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$e9404e008fead04f).withPart($437b23f6a393c3bf$export$4c07fbd6ebedeb01).withPart($437b23f6a393c3bf$export$c9667c02da45fcf0).withPart($437b23f6a393c3bf$export$9eadc93b54e4a807).withPart($437b23f6a393c3bf$export$5fe7e1ddfe58a67).withParams({
        rowHeight: {
            calc: "max(iconSize, dataFontSize) + spacing * 3.75 * rowVerticalPaddingScale"
        },
        headerHeight: {
            calc: "max(iconSize, dataFontSize) + spacing * 4.75 * headerVerticalPaddingScale"
        },
        widgetVerticalSpacing: {
            calc: "spacing * 1.75"
        },
        cellHorizontalPadding: {
            calc: "spacing * 3"
        },
        buttonHorizontalPadding: {
            ref: "spacing"
        },
        widgetContainerHorizontalPadding: {
            calc: "spacing * 1.5"
        },
        widgetContainerVerticalPadding: {
            calc: "spacing * 2"
        },
        fontSize: 13,
        iconSize: 18,
        borderRadius: 0,
        wrapperBorderRadius: 0,
        wrapperBorder: false,
        menuBorder: false,
        dialogBorder: false,
        panelTitleBarBorder: false,
        tabSelectedBorderWidth: 0,
        tabSelectedUnderlineTransitionDuration: 0.3,
        sidePanelBorder: false,
        sideButtonSelectedBorder: false,
        sideButtonSelectedUnderlineWidth: 2,
        sideButtonSelectedUnderlineTransitionDuration: 0.3,
        sideButtonBorder: false,
        buttonBorder: false,
        buttonDisabledBorder: false,
        focusShadow: {
            spread: 4,
            color: $437b23f6a393c3bf$var$foregroundMix(0.16)
        },
        fontFamily: [
            {
                googleFont: "Roboto"
            },
            "-apple-system",
            "BlinkMacSystemFont",
            "Segoe UI",
            "Oxygen-Sans",
            "Ubuntu",
            "Cantarell",
            "Helvetica Neue",
            "sans-serif"
        ],
        inputHeight: {
            calc: "max(iconSize, fontSize) + spacing * 3"
        },
        pickerButtonBorder: {
            width: 1,
            color: "transparent"
        },
        headerFontWeight: 600,
        headerFontSize: {
            calc: "fontSize - 1px"
        },
        checkboxBorderWidth: 2,
        checkboxBorderRadius: 2,
        toggleButtonWidth: 34,
        toggleButtonSwitchInset: 1,
        cardShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
        popupShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)"
    });
var $437b23f6a393c3bf$export$55ff169dc6a8025a = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeMaterialTreeShakeable();
// packages/ag-grid-community/src/environment.ts
var $437b23f6a393c3bf$var$CELL_HORIZONTAL_PADDING = {
    cssName: "--ag-cell-horizontal-padding",
    changeKey: "cellHorizontalPaddingChanged",
    defaultValue: 16
};
var $437b23f6a393c3bf$var$INDENTATION_LEVEL = {
    cssName: "--ag-indentation-level",
    changeKey: "indentationLevelChanged",
    defaultValue: 0,
    noWarn: true,
    cacheDefault: true
};
var $437b23f6a393c3bf$var$ROW_GROUP_INDENT_SIZE = {
    cssName: "--ag-row-group-indent-size",
    changeKey: "rowGroupIndentSizeChanged",
    defaultValue: 0
};
var $437b23f6a393c3bf$var$ROW_HEIGHT = {
    cssName: "--ag-row-height",
    changeKey: "rowHeightChanged",
    defaultValue: 42
};
var $437b23f6a393c3bf$var$HEADER_HEIGHT = {
    cssName: "--ag-header-height",
    changeKey: "headerHeightChanged",
    defaultValue: 48
};
var $437b23f6a393c3bf$var$ROW_BORDER_WIDTH = {
    cssName: "--ag-row-border",
    changeKey: "rowBorderWidthChanged",
    defaultValue: 1,
    border: true
};
var $437b23f6a393c3bf$var$PINNED_BORDER_WIDTH = {
    cssName: "--ag-pinned-row-border",
    changeKey: "pinnedRowBorderWidthChanged",
    defaultValue: 1,
    border: true
};
function $437b23f6a393c3bf$export$950282e49bfaca2e(cssMap, modules) {
    for (const module of modules.sort((a, b)=>a.moduleName.localeCompare(b.moduleName))){
        const moduleCss = module.css;
        if (moduleCss) cssMap.set(`module-${module.moduleName}`, moduleCss);
    }
}
var $437b23f6a393c3bf$var$Environment = class extends $437b23f6a393c3bf$export$13d30f6a265c57c6 {
    initVariables() {
        this.addManagedPropertyListener("rowHeight", ()=>this.refreshRowHeightVariable());
        this.getSizeEl($437b23f6a393c3bf$var$ROW_HEIGHT);
        this.getSizeEl($437b23f6a393c3bf$var$HEADER_HEIGHT);
        this.getSizeEl($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
        this.getSizeEl($437b23f6a393c3bf$var$PINNED_BORDER_WIDTH);
        this.refreshRowBorderWidthVariable();
    }
    getPinnedRowBorderWidth() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$PINNED_BORDER_WIDTH);
    }
    getRowBorderWidth() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
    }
    getDefaultRowHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_HEIGHT);
    }
    getDefaultHeaderHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$HEADER_HEIGHT);
    }
    getDefaultCellHorizontalPadding() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$CELL_HORIZONTAL_PADDING);
    }
    getCellPaddingLeft() {
        const cellHorizontalPadding = this.getDefaultCellHorizontalPadding();
        const indentationLevel = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$INDENTATION_LEVEL);
        const rowGroupIndentSize = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_GROUP_INDENT_SIZE);
        return cellHorizontalPadding - 1 + rowGroupIndentSize * indentationLevel;
    }
    getCellPadding() {
        const cellPaddingRight = this.getDefaultCellHorizontalPadding() - 1;
        return this.getCellPaddingLeft() + cellPaddingRight;
    }
    getDefaultColumnMinWidth() {
        return Math.min(36, this.getDefaultRowHeight());
    }
    refreshRowHeightVariable() {
        const { eRootDiv: eRootDiv } = this;
        const oldRowHeight = eRootDiv.style.getPropertyValue("--ag-line-height").trim();
        const height = this.gos.get("rowHeight");
        if (height == null || isNaN(height) || !isFinite(height)) {
            if (oldRowHeight !== null) eRootDiv.style.setProperty("--ag-line-height", null);
            return -1;
        }
        const newRowHeight = `${height}px`;
        if (oldRowHeight != newRowHeight) {
            eRootDiv.style.setProperty("--ag-line-height", newRowHeight);
            return height;
        }
        return oldRowHeight != "" ? Number.parseFloat(oldRowHeight) : -1;
    }
    fireStylesChangedEvent(change) {
        if (change === "rowBorderWidthChanged") this.refreshRowBorderWidthVariable();
        super.fireStylesChangedEvent(change);
    }
    refreshRowBorderWidthVariable() {
        const width = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
        this.eRootDiv.style.setProperty("--ag-internal-row-border-width", `${width}px`);
    }
    postProcessThemeChange(newGridTheme, themeGridOption) {
        if (newGridTheme && getComputedStyle(this.getMeasurementContainer()).getPropertyValue("--ag-legacy-styles-loaded")) {
            if (themeGridOption) $437b23f6a393c3bf$export$a20c7248650823a9(106);
            else $437b23f6a393c3bf$export$a20c7248650823a9(239);
        }
    }
    getAdditionalCss() {
        const additionalCss = /* @__PURE__ */ new Map();
        additionalCss.set("core", [
            $437b23f6a393c3bf$var$coreCSS
        ]);
        $437b23f6a393c3bf$export$950282e49bfaca2e(additionalCss, Array.from($437b23f6a393c3bf$var$_getAllRegisteredModules()));
        return additionalCss;
    }
    getDefaultTheme() {
        return $437b23f6a393c3bf$export$495b90cf446940a1;
    }
    varError(variable) {
        $437b23f6a393c3bf$export$545083624300f13d(9, {
            variable: variable
        });
    }
    themeError(theme) {
        $437b23f6a393c3bf$export$a20c7248650823a9(240, {
            theme: theme
        });
    }
    shadowRootError() {
        $437b23f6a393c3bf$export$a20c7248650823a9(293);
    }
};
// packages/ag-grid-community/src/eventService.ts
var $437b23f6a393c3bf$var$EventService = class extends $437b23f6a393c3bf$export$495c88faa5a4d068 {
    postConstruct() {
        const { globalListener: globalListener, globalSyncListener: globalSyncListener } = this.beans;
        if (globalListener) this.addGlobalListener(globalListener, true);
        if (globalSyncListener) this.addGlobalListener(globalSyncListener, false);
    }
};
// packages/ag-grid-community/src/navigation/headerNavigationService.ts
function $437b23f6a393c3bf$var$getHeaderIndexToFocus(beans, column, level) {
    const columnRowIndex = beans.visibleCols.headerGroupRowCount;
    if (level >= columnRowIndex) return {
        column: column,
        headerRowIndex: level
    };
    let parent = column.getParent();
    while(parent && parent.getProvidedColumnGroup().getLevel() > level)parent = parent.getParent();
    const isColSpanning = column.isSpanHeaderHeight();
    if (!parent || isColSpanning && parent.isPadding()) return {
        column: column,
        headerRowIndex: columnRowIndex
    };
    return {
        column: parent,
        headerRowIndex: parent.getProvidedColumnGroup().getLevel()
    };
}
var $437b23f6a393c3bf$var$HeaderNavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "headerNavigation";
        this.currentHeaderRowWithoutSpan = -1;
    }
    postConstruct() {
        const beans = this.beans;
        beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        this.addManagedElementListeners(eDocument, {
            mousedown: ()=>{
                this.currentHeaderRowWithoutSpan = -1;
            }
        });
    }
    getHeaderPositionForColumn(colKey, floatingFilter) {
        let column;
        const { colModel: colModel, colGroupSvc: colGroupSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        if (typeof colKey === "string") {
            column = colModel.getCol(colKey);
            if (!column) column = colGroupSvc?.getColumnGroup(colKey) ?? null;
        } else column = colKey;
        if (!column) return null;
        const centerHeaderContainer = ctrlsSvc.getHeaderRowContainerCtrl();
        const allCtrls = centerHeaderContainer?.getAllCtrls();
        const isFloatingFilterVisible = $437b23f6a393c3bf$export$236389741107357f(allCtrls || []).type === "filter";
        const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1;
        let row = -1;
        let col = column;
        while(col){
            row++;
            col = col.getParent();
        }
        let headerRowIndex = row;
        if (floatingFilter && isFloatingFilterVisible && headerRowIndex === headerRowCount - 1) headerRowIndex++;
        return headerRowIndex === -1 ? null : {
            headerRowIndex: headerRowIndex,
            column: column
        };
    }
    /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateVertically(direction, event) {
        const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
        const { focusedHeader: focusedHeader } = focusSvc;
        if (!focusedHeader) return false;
        const { headerRowIndex: headerRowIndex } = focusedHeader;
        const column = focusedHeader.column;
        const rowLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
        const currentRowType = this.getHeaderRowType(headerRowIndex);
        const columnHeaderRowIndex = visibleCols.headerGroupRowCount;
        let { headerRowIndex: nextRow, column: nextFocusColumn, headerRowIndexWithoutSpan: headerRowIndexWithoutSpan } = direction === "UP" ? $437b23f6a393c3bf$var$getColumnVisibleParent(currentRowType, column, headerRowIndex) : $437b23f6a393c3bf$var$getColumnVisibleChild(column, headerRowIndex, columnHeaderRowIndex);
        let skipColumn = false;
        if (nextRow < 0) {
            nextRow = 0;
            nextFocusColumn = column;
            skipColumn = true;
        }
        if (nextRow >= rowLen) {
            nextRow = -1;
            this.currentHeaderRowWithoutSpan = -1;
        } else if (headerRowIndexWithoutSpan !== void 0) this.currentHeaderRowWithoutSpan = headerRowIndexWithoutSpan;
        if (!skipColumn && !nextFocusColumn) return false;
        return focusSvc.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: nextRow,
                column: nextFocusColumn
            },
            allowUserOverride: true,
            event: event
        });
    }
    /*
   * This method navigates grid header horizontally
   * @returns {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateHorizontally(direction, fromTab = false, event) {
        const { focusSvc: focusSvc, gos: gos } = this.beans;
        const focusedHeader = {
            ...focusSvc.focusedHeader
        };
        let nextHeader;
        let normalisedDirection;
        if (this.currentHeaderRowWithoutSpan !== -1) focusedHeader.headerRowIndex = this.currentHeaderRowWithoutSpan;
        else this.currentHeaderRowWithoutSpan = focusedHeader.headerRowIndex;
        if (direction === "LEFT" !== gos.get("enableRtl")) {
            normalisedDirection = "Before";
            nextHeader = this.findHeader(focusedHeader, normalisedDirection);
        } else {
            normalisedDirection = "After";
            nextHeader = this.findHeader(focusedHeader, normalisedDirection);
        }
        const userFunc = gos.getCallback("tabToNextHeader");
        if (fromTab && userFunc) {
            const wasFocusedFromUserFunc = focusSvc.focusHeaderPositionFromUserFunc({
                userFunc: userFunc,
                headerPosition: nextHeader,
                direction: normalisedDirection
            });
            if (wasFocusedFromUserFunc) {
                const { headerRowIndex: headerRowIndex } = focusSvc.focusedHeader || {};
                if (headerRowIndex != null && headerRowIndex != focusedHeader.headerRowIndex) this.currentHeaderRowWithoutSpan = headerRowIndex;
            }
            return wasFocusedFromUserFunc;
        }
        if (nextHeader || !fromTab) return focusSvc.focusHeaderPosition({
            headerPosition: nextHeader,
            direction: normalisedDirection,
            fromTab: fromTab,
            allowUserOverride: true,
            event: event
        });
        return this.focusNextHeaderRow(focusedHeader, normalisedDirection, event);
    }
    focusNextHeaderRow(focusedHeader, direction, event) {
        const beans = this.beans;
        const currentIndex = focusedHeader.headerRowIndex;
        let nextFocusedCol = null;
        let nextRowIndex;
        const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans);
        const allVisibleCols = this.beans.visibleCols.allCols;
        if (direction === "Before") {
            if (currentIndex <= 0) return false;
            nextFocusedCol = $437b23f6a393c3bf$export$236389741107357f(allVisibleCols);
            nextRowIndex = currentIndex - 1;
            this.currentHeaderRowWithoutSpan -= 1;
        } else {
            nextFocusedCol = allVisibleCols[0];
            nextRowIndex = currentIndex + 1;
            if (this.currentHeaderRowWithoutSpan < headerRowCount) this.currentHeaderRowWithoutSpan += 1;
            else this.currentHeaderRowWithoutSpan = -1;
        }
        let { column: column, headerRowIndex: headerRowIndex } = $437b23f6a393c3bf$var$getHeaderIndexToFocus(this.beans, nextFocusedCol, nextRowIndex);
        if (headerRowIndex >= headerRowCount) headerRowIndex = -1;
        return beans.focusSvc.focusHeaderPosition({
            headerPosition: {
                column: column,
                headerRowIndex: headerRowIndex
            },
            direction: direction,
            fromTab: true,
            allowUserOverride: true,
            event: event
        });
    }
    scrollToColumn(column, direction = "After") {
        if (column.getPinned()) return;
        let columnToScrollTo;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(column)) {
            const columns = column.getDisplayedLeafColumns();
            columnToScrollTo = direction === "Before" ? $437b23f6a393c3bf$export$236389741107357f(columns) : columns[0];
        } else columnToScrollTo = column;
        this.gridBodyCon.scrollFeature.ensureColumnVisible(columnToScrollTo);
    }
    findHeader(focusedHeader, direction) {
        const { colGroupSvc: colGroupSvc, visibleCols: visibleCols } = this.beans;
        let currentFocusedColumn = focusedHeader.column;
        if (currentFocusedColumn instanceof $437b23f6a393c3bf$export$273c80940a54c770) {
            const leafChildren = currentFocusedColumn.getDisplayedLeafColumns();
            currentFocusedColumn = direction === "Before" ? leafChildren[0] : leafChildren[leafChildren.length - 1];
        }
        const nextFocusedCol = direction === "Before" ? visibleCols.getColBefore(currentFocusedColumn) : visibleCols.getColAfter(currentFocusedColumn);
        if (!nextFocusedCol) return void 0;
        const headerGroupRowIndex = visibleCols.headerGroupRowCount;
        if (focusedHeader.headerRowIndex >= headerGroupRowIndex) return {
            headerRowIndex: focusedHeader.headerRowIndex,
            column: nextFocusedCol
        };
        const groupAtLevel = colGroupSvc?.getColGroupAtLevel(nextFocusedCol, focusedHeader.headerRowIndex);
        if (!groupAtLevel) {
            const isSpanningCol = nextFocusedCol instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 && nextFocusedCol.isSpanHeaderHeight();
            return {
                headerRowIndex: isSpanningCol ? visibleCols.headerGroupRowCount : focusedHeader.headerRowIndex,
                column: nextFocusedCol
            };
        }
        if (groupAtLevel.isPadding() && nextFocusedCol.isSpanHeaderHeight()) return {
            headerRowIndex: visibleCols.headerGroupRowCount,
            column: nextFocusedCol
        };
        return {
            headerRowIndex: focusedHeader.headerRowIndex,
            column: groupAtLevel ?? nextFocusedCol
        };
    }
    getHeaderRowType(rowIndex) {
        const centerHeaderContainer = this.beans.ctrlsSvc.getHeaderRowContainerCtrl();
        if (centerHeaderContainer) return centerHeaderContainer.getRowType(rowIndex);
    }
};
function $437b23f6a393c3bf$var$getColumnVisibleParent(currentRowType, currentColumn, currentIndex) {
    const optimisticNextIndex = currentIndex - 1;
    if (currentRowType !== "filter") {
        const isSpanningCol = currentColumn instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 && currentColumn.isSpanHeaderHeight();
        let nextVisibleParent = currentColumn.getParent();
        while(nextVisibleParent && // skip if row isn't visible or col is padding and spanned
        (nextVisibleParent.getProvidedColumnGroup().getLevel() > optimisticNextIndex || isSpanningCol && nextVisibleParent.isPadding()))nextVisibleParent = nextVisibleParent.getParent();
        if (nextVisibleParent) {
            if (isSpanningCol) return {
                column: nextVisibleParent,
                headerRowIndex: nextVisibleParent.getProvidedColumnGroup().getLevel(),
                headerRowIndexWithoutSpan: optimisticNextIndex
            };
            else return {
                column: nextVisibleParent,
                headerRowIndex: optimisticNextIndex,
                headerRowIndexWithoutSpan: optimisticNextIndex
            };
        }
    }
    return {
        column: currentColumn,
        headerRowIndex: optimisticNextIndex,
        headerRowIndexWithoutSpan: optimisticNextIndex
    };
}
function $437b23f6a393c3bf$var$getColumnVisibleChild(column, currentIndex, columnHeaderRowIndex) {
    const optimisticNextIndex = currentIndex + 1;
    const result = {
        column: column,
        headerRowIndex: optimisticNextIndex,
        headerRowIndexWithoutSpan: optimisticNextIndex
    };
    if (column instanceof $437b23f6a393c3bf$export$273c80940a54c770) {
        if (optimisticNextIndex >= columnHeaderRowIndex) return {
            column: column.getDisplayedLeafColumns()[0],
            headerRowIndex: columnHeaderRowIndex,
            headerRowIndexWithoutSpan: optimisticNextIndex
        };
        const children = column.getDisplayedChildren();
        let firstChild = children[0];
        if (firstChild instanceof $437b23f6a393c3bf$export$273c80940a54c770 && firstChild.isPadding()) {
            const firstCol = firstChild.getDisplayedLeafColumns()[0];
            if (firstCol.isSpanHeaderHeight()) firstChild = firstCol;
        }
        result.column = firstChild;
        const isSpanningCol = firstChild instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 && firstChild.isSpanHeaderHeight();
        if (isSpanningCol) {
            result.headerRowIndex = columnHeaderRowIndex;
            result.headerRowIndexWithoutSpan = optimisticNextIndex;
        }
    }
    return result;
}
// packages/ag-grid-community/src/focusService.ts
var $437b23f6a393c3bf$var$FocusService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "focusSvc";
        /** If a cell was destroyed that previously had focus, focus needs restored when the cell reappears */ this.focusFallbackTimeout = null;
        this.needsFocusRestored = false;
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.visibleCols = beans.visibleCols;
        this.rowRenderer = beans.rowRenderer;
        this.navigation = beans.navigation;
        this.filterManager = beans.filterManager;
        this.overlays = beans.overlays;
    }
    postConstruct() {
        const clearFocusedCellListener = this.clearFocusedCell.bind(this);
        this.addManagedEventListeners({
            columnPivotModeChanged: clearFocusedCellListener,
            newColumnsLoaded: this.onColumnEverythingChanged.bind(this),
            columnGroupOpened: clearFocusedCellListener,
            columnRowGroupChanged: clearFocusedCellListener
        });
        this.addDestroyFunc($437b23f6a393c3bf$var$_registerKeyboardFocusEvents(this.beans));
    }
    attemptToRecoverFocus() {
        this.needsFocusRestored = true;
        if (this.focusFallbackTimeout != null) clearTimeout(this.focusFallbackTimeout);
        this.focusFallbackTimeout = window.setTimeout(this.setFocusRecovered.bind(this), 100);
    }
    setFocusRecovered() {
        this.needsFocusRestored = false;
        if (this.focusFallbackTimeout != null) {
            clearTimeout(this.focusFallbackTimeout);
            this.focusFallbackTimeout = null;
        }
    }
    /**
   * Specifies whether to take focus, as grid either already has focus, or lost it due
   * to a destroyed cell
   * @returns true if the grid should re-take focus, otherwise false
   */ shouldTakeFocus() {
        if (this.gos.get("suppressFocusAfterRefresh")) {
            this.setFocusRecovered();
            return false;
        }
        if (this.needsFocusRestored) {
            this.setFocusRecovered();
            return true;
        }
        return this.doesRowOrCellHaveBrowserFocus();
    }
    onColumnEverythingChanged() {
        if (!this.focusedCell) return;
        const col = this.focusedCell.column;
        const colFromColumnModel = this.colModel.getCol(col.getId());
        if (col !== colFromColumnModel) this.clearFocusedCell();
    }
    // we check if the browser is focusing something, and if it is, and
    // it's the cell we think is focused, then return the cell. so this
    // methods returns the cell if a) we think it has focus and b) the
    // browser thinks it has focus. this then returns nothing if we
    // first focus a cell, then second click outside the grid, as then the
    // grid cell will still be focused as far as the grid is concerned,
    // however the browser focus will have moved somewhere else.
    getFocusCellToUseAfterRefresh() {
        const { gos: gos, focusedCell: focusedCell } = this;
        if (gos.get("suppressFocusAfterRefresh") || gos.get("suppressCellFocus") || !focusedCell) return null;
        if (!this.doesRowOrCellHaveBrowserFocus()) return null;
        return focusedCell;
    }
    getFocusHeaderToUseAfterRefresh() {
        if (this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeader) return null;
        if (!this.isDomDataPresentInHierarchy($437b23f6a393c3bf$export$16bc98d422315038(this.beans), $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL)) return null;
        return this.focusedHeader;
    }
    /**
   * Check for both cells and rows, as a row might be destroyed and the dom data removed before the cell if the
   * row is animating out.
   */ doesRowOrCellHaveBrowserFocus() {
        const activeElement = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        if (this.isDomDataPresentInHierarchy(activeElement, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL)) return true;
        return this.isDomDataPresentInHierarchy(activeElement, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL);
    }
    isDomDataPresentInHierarchy(eBrowserCell, key) {
        let ePointer = eBrowserCell;
        while(ePointer){
            const data = $437b23f6a393c3bf$var$_getDomData(this.gos, ePointer, key);
            if (data) return true;
            ePointer = ePointer.parentNode;
        }
        return false;
    }
    getFocusedCell() {
        return this.focusedCell;
    }
    getFocusEventParams(focusedCellPosition) {
        const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = focusedCellPosition;
        const params = {
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column,
            isFullWidthCell: false
        };
        const rowCtrl = this.rowRenderer.getRowByPosition({
            rowIndex: rowIndex,
            rowPinned: rowPinned
        });
        if (rowCtrl) params.isFullWidthCell = rowCtrl.isFullWidth();
        return params;
    }
    clearFocusedCell() {
        if (this.focusedCell == null) return;
        const focusEventParams = this.getFocusEventParams(this.focusedCell);
        this.focusedCell = null;
        this.eventSvc.dispatchEvent({
            type: "cellFocusCleared",
            ...focusEventParams
        });
    }
    setFocusedCell(params) {
        this.setFocusRecovered();
        const { column: column, rowIndex: rowIndex, rowPinned: rowPinned, forceBrowserFocus: forceBrowserFocus = false, preventScrollOnBrowserFocus: preventScrollOnBrowserFocus = false, sourceEvent: sourceEvent } = params;
        const gridColumn = this.colModel.getCol(column);
        if (!gridColumn) {
            this.focusedCell = null;
            return;
        }
        this.focusedCell = {
            rowIndex: rowIndex,
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
            column: gridColumn
        };
        const focusEventParams = this.getFocusEventParams(this.focusedCell);
        this.eventSvc.dispatchEvent({
            type: "cellFocused",
            ...focusEventParams,
            ...this.previousCellFocusParams && {
                previousParams: this.previousCellFocusParams
            },
            forceBrowserFocus: forceBrowserFocus,
            preventScrollOnBrowserFocus: preventScrollOnBrowserFocus,
            sourceEvent: sourceEvent
        });
        this.previousCellFocusParams = focusEventParams;
    }
    isCellFocused(cellPosition) {
        if (this.focusedCell == null) return false;
        return $437b23f6a393c3bf$export$be3973033c2c5267(cellPosition, this.focusedCell);
    }
    isHeaderWrapperFocused(headerCtrl) {
        if (this.focusedHeader == null) return false;
        const { column: column, rowCtrl: { rowIndex: headerRowIndex, pinned: pinned } } = headerCtrl;
        const { column: focusedColumn, headerRowIndex: focusedHeaderRowIndex } = this.focusedHeader;
        return column === focusedColumn && headerRowIndex === focusedHeaderRowIndex && pinned == focusedColumn.getPinned();
    }
    focusHeaderPosition(params) {
        this.setFocusRecovered();
        if ($437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return false;
        const { direction: direction, fromTab: fromTab, allowUserOverride: allowUserOverride, event: event, fromCell: fromCell, rowWithoutSpanValue: rowWithoutSpanValue, scroll: scroll = true } = params;
        let { headerPosition: headerPosition } = params;
        if (fromCell && this.filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
        if (allowUserOverride) {
            const currentPosition = this.focusedHeader;
            const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
            if (fromTab) {
                const userFunc = this.gos.getCallback("tabToNextHeader");
                if (userFunc) headerPosition = this.getHeaderPositionFromUserFunc({
                    userFunc: userFunc,
                    direction: direction,
                    currentPosition: currentPosition,
                    headerPosition: headerPosition,
                    headerRowCount: headerRowCount
                });
            } else {
                const userFunc = this.gos.getCallback("navigateToNextHeader");
                if (userFunc && event) {
                    const params2 = {
                        key: event.key,
                        previousHeaderPosition: currentPosition,
                        nextHeaderPosition: headerPosition,
                        headerRowCount: headerRowCount,
                        event: event
                    };
                    headerPosition = userFunc(params2);
                }
            }
        }
        if (!headerPosition) return false;
        return this.focusProvidedHeaderPosition({
            headerPosition: headerPosition,
            direction: direction,
            event: event,
            fromCell: fromCell,
            rowWithoutSpanValue: rowWithoutSpanValue,
            scroll: scroll
        });
    }
    focusHeaderPositionFromUserFunc(params) {
        if ($437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return false;
        const { userFunc: userFunc, headerPosition: headerPosition, direction: direction, event: event } = params;
        const currentPosition = this.focusedHeader;
        const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
        const newHeaderPosition = this.getHeaderPositionFromUserFunc({
            userFunc: userFunc,
            direction: direction,
            currentPosition: currentPosition,
            headerPosition: headerPosition,
            headerRowCount: headerRowCount
        });
        return !!newHeaderPosition && this.focusProvidedHeaderPosition({
            headerPosition: newHeaderPosition,
            direction: direction,
            event: event
        });
    }
    getHeaderPositionFromUserFunc(params) {
        const { userFunc: userFunc, direction: direction, currentPosition: currentPosition, headerPosition: headerPosition, headerRowCount: headerRowCount } = params;
        const userFuncParams = {
            backwards: direction === "Before",
            previousHeaderPosition: currentPosition,
            nextHeaderPosition: headerPosition,
            headerRowCount: headerRowCount
        };
        const userResult = userFunc(userFuncParams);
        if (userResult === true) return currentPosition;
        if (userResult === false) return null;
        return userResult;
    }
    focusProvidedHeaderPosition(params) {
        const { headerPosition: headerPosition, direction: direction, fromCell: fromCell, rowWithoutSpanValue: rowWithoutSpanValue, event: event, scroll: scroll = true } = params;
        const { column: column, headerRowIndex: headerRowIndex } = headerPosition;
        const { filterManager: filterManager, ctrlsSvc: ctrlsSvc, headerNavigation: headerNavigation } = this.beans;
        if (this.focusedHeader && $437b23f6a393c3bf$var$isHeaderPositionEqual(params.headerPosition, this.focusedHeader)) return false;
        if (headerRowIndex === -1) {
            if (filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
            return this.focusGridView({
                column: column,
                event: event
            });
        }
        if (scroll) headerNavigation?.scrollToColumn(column, direction);
        const headerRowContainerCtrl = ctrlsSvc.getHeaderRowContainerCtrl(column.getPinned());
        const focusSuccess = headerRowContainerCtrl?.focusHeader(headerPosition.headerRowIndex, column, event) || false;
        if (headerNavigation && focusSuccess && (rowWithoutSpanValue != null || fromCell)) headerNavigation.currentHeaderRowWithoutSpan = rowWithoutSpanValue ?? -1;
        return focusSuccess;
    }
    focusFirstHeader() {
        if (this.overlays?.exclusive && this.focusOverlay()) return true;
        const firstColumn = this.visibleCols.allCols[0];
        if (!firstColumn) return false;
        const headerPosition = $437b23f6a393c3bf$var$getHeaderIndexToFocus(this.beans, firstColumn, 0);
        return this.focusHeaderPosition({
            headerPosition: headerPosition,
            rowWithoutSpanValue: 0
        });
    }
    focusLastHeader(event) {
        if (this.overlays?.exclusive && this.focusOverlay(true)) return true;
        const headerRowIndex = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1;
        const column = $437b23f6a393c3bf$export$236389741107357f(this.visibleCols.allCols);
        return this.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: headerRowIndex,
                column: column
            },
            rowWithoutSpanValue: -1,
            event: event
        });
    }
    focusPreviousFromFirstCell(event) {
        if (this.filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(null);
        return this.focusLastHeader(event);
    }
    isAnyCellFocused() {
        return !!this.focusedCell;
    }
    isRowFocused(rowIndex, rowPinnedType) {
        if (this.focusedCell == null) return false;
        return this.focusedCell.rowIndex === rowIndex && this.focusedCell.rowPinned === $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinnedType);
    }
    focusOverlay(backwards) {
        const overlayGui = this.overlays?.isVisible() && this.overlays.eWrapper?.getGui();
        return !!overlayGui && $437b23f6a393c3bf$export$8598088d375f416f(overlayGui, backwards);
    }
    focusGridView(params) {
        const { backwards: backwards = false, canFocusOverlay: canFocusOverlay = true, event: event } = params;
        if (this.overlays?.exclusive) return canFocusOverlay && this.focusOverlay(backwards);
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(this.beans)) {
            if (backwards) {
                if (!$437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return this.focusLastHeader();
            }
            if (canFocusOverlay && this.focusOverlay(backwards)) return true;
            if (backwards) return false;
            return $437b23f6a393c3bf$export$987f3c95dc941f0c(this.beans, backwards);
        }
        const nextRow = backwards ? $437b23f6a393c3bf$export$a1449222017e428(this.beans) : $437b23f6a393c3bf$export$124b4386b662b699(this.beans);
        if (nextRow) {
            const column = params.column ?? this.focusedHeader?.column;
            const { rowIndex: rowIndex, rowPinned: rowPinned } = nextRow;
            const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, nextRow);
            if (!column || !rowNode || rowIndex == null) return false;
            if (column.isSuppressNavigable(rowNode)) {
                const isRtl = this.gos.get("enableRtl");
                let key;
                if (!event || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) key = isRtl ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT : $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT;
                else key = event.key;
                this.beans.navigation?.navigateToNextCell(null, key, {
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned || null
                }, true);
                return true;
            }
            this.navigation?.ensureCellVisible({
                rowIndex: rowIndex,
                column: column,
                rowPinned: rowPinned
            });
            if (backwards) {
                const rowCtrl = this.rowRenderer.getRowByPosition(nextRow);
                if (rowCtrl?.isFullWidth() && this.navigation?.tryToFocusFullWidthRow(nextRow, backwards)) return true;
            }
            this.setFocusedCell({
                rowIndex: rowIndex,
                column: column,
                rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
                forceBrowserFocus: true
            });
            this.beans.rangeSvc?.setRangeToCell({
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                column: column
            });
            return true;
        }
        if (canFocusOverlay && this.focusOverlay(backwards)) return true;
        if (backwards && this.focusLastHeader()) return true;
        return false;
    }
    focusAdvancedFilter(position) {
        this.advFilterFocusColumn = position?.column;
        return this.beans.advancedFilter?.getCtrl().focusHeaderComp() ?? false;
    }
    focusNextFromAdvancedFilter(backwards, forceFirstColumn) {
        const column = (forceFirstColumn ? void 0 : this.advFilterFocusColumn) ?? this.visibleCols.allCols?.[0];
        if (backwards) return this.focusHeaderPosition({
            headerPosition: {
                column: column,
                headerRowIndex: $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1
            }
        });
        else return this.focusGridView({
            column: column
        });
    }
    clearAdvancedFilterColumn() {
        this.advFilterFocusColumn = void 0;
    }
};
// packages/ag-grid-community/src/gridBodyComp/scrollVisibleService.ts
var $437b23f6a393c3bf$var$ScrollVisibleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "scrollVisibleSvc";
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.colAnimation = beans.colAnimation;
    }
    postConstruct() {
        this.horizontalScrollShowing = this.gos.get("alwaysShowHorizontalScroll") === true;
        this.verticalScrollShowing = this.gos.get("alwaysShowVerticalScroll") === true;
        this.getScrollbarWidth();
        this.addManagedEventListeners({
            displayedColumnsChanged: this.updateScrollVisible.bind(this),
            displayedColumnsWidthChanged: this.updateScrollVisible.bind(this)
        });
    }
    updateScrollVisible() {
        const { colAnimation: colAnimation } = this;
        if (colAnimation?.isActive()) colAnimation.executeLaterVMTurn(()=>{
            colAnimation.executeLaterVMTurn(()=>this.updateScrollVisibleImpl());
        });
        else this.updateScrollVisibleImpl();
    }
    updateScrollVisibleImpl() {
        const centerRowCtrl = this.ctrlsSvc.get("center");
        if (!centerRowCtrl || this.colAnimation?.isActive()) return;
        const params = {
            horizontalScrollShowing: centerRowCtrl.isHorizontalScrollShowing(),
            verticalScrollShowing: this.verticalScrollShowing
        };
        this.setScrollsVisible(params);
        this.updateScrollGap();
    }
    updateScrollGap() {
        const centerRowCtrl = this.ctrlsSvc.get("center");
        const horizontalGap = centerRowCtrl.hasHorizontalScrollGap();
        const verticalGap = centerRowCtrl.hasVerticalScrollGap();
        const atLeastOneDifferent = this.horizontalScrollGap !== horizontalGap || this.verticalScrollGap !== verticalGap;
        if (atLeastOneDifferent) {
            this.horizontalScrollGap = horizontalGap;
            this.verticalScrollGap = verticalGap;
            this.eventSvc.dispatchEvent({
                type: "scrollGapChanged"
            });
        }
    }
    setScrollsVisible(params) {
        const atLeastOneDifferent = this.horizontalScrollShowing !== params.horizontalScrollShowing || this.verticalScrollShowing !== params.verticalScrollShowing;
        if (atLeastOneDifferent) {
            this.horizontalScrollShowing = params.horizontalScrollShowing;
            this.verticalScrollShowing = params.verticalScrollShowing;
            this.eventSvc.dispatchEvent({
                type: "scrollVisibilityChanged"
            });
        }
    }
    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
    // allow the user to provide the scroll width before we work it out.
    getScrollbarWidth() {
        if (this.scrollbarWidth == null) {
            const gridOptionsScrollbarWidth = this.gos.get("scrollbarWidth");
            const useGridOptions = typeof gridOptionsScrollbarWidth === "number" && gridOptionsScrollbarWidth >= 0;
            const scrollbarWidth = useGridOptions ? gridOptionsScrollbarWidth : $437b23f6a393c3bf$var$_getScrollbarWidth();
            if (scrollbarWidth != null) {
                this.scrollbarWidth = scrollbarWidth;
                this.eventSvc.dispatchEvent({
                    type: "scrollbarWidthChanged"
                });
            }
        }
        return this.scrollbarWidth;
    }
};
// packages/ag-grid-community/src/gridDestroyService.ts
var $437b23f6a393c3bf$var$GridDestroyService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gridDestroySvc";
        this.destroyCalled = false;
    }
    destroy() {
        if (this.destroyCalled) return;
        const { stateSvc: stateSvc, ctrlsSvc: ctrlsSvc, context: context } = this.beans;
        this.eventSvc.dispatchEvent({
            type: "gridPreDestroyed",
            state: stateSvc?.getState() ?? {}
        });
        this.destroyCalled = true;
        ctrlsSvc.get("gridCtrl")?.destroyGridUi();
        context.destroy();
        super.destroy();
    }
};
// packages/ag-grid-community/src/events.ts
var $437b23f6a393c3bf$export$12e4e9a3cbd0ec07 = /* @__PURE__ */ new Set([
    "gridPreDestroyed",
    "fillStart",
    "pasteStart"
]);
// packages/ag-grid-community/src/eventTypes.ts
var $437b23f6a393c3bf$export$e9c8ffb796317123 = [
    "columnEverythingChanged",
    "newColumnsLoaded",
    "columnPivotModeChanged",
    "pivotMaxColumnsExceeded",
    "columnRowGroupChanged",
    "expandOrCollapseAll",
    "columnPivotChanged",
    "gridColumnsChanged",
    "columnValueChanged",
    "columnMoved",
    "columnVisible",
    "columnPinned",
    "columnGroupOpened",
    "columnResized",
    "displayedColumnsChanged",
    "virtualColumnsChanged",
    "columnHeaderMouseOver",
    "columnHeaderMouseLeave",
    "columnHeaderClicked",
    "columnHeaderContextMenu",
    "asyncTransactionsFlushed",
    "rowGroupOpened",
    "rowDataUpdated",
    "pinnedRowDataChanged",
    "pinnedRowsChanged",
    "rangeSelectionChanged",
    "cellSelectionChanged",
    "chartCreated",
    "chartRangeSelectionChanged",
    "chartOptionsChanged",
    "chartDestroyed",
    "toolPanelVisibleChanged",
    "toolPanelSizeChanged",
    "modelUpdated",
    "cutStart",
    "cutEnd",
    "pasteStart",
    "pasteEnd",
    "fillStart",
    "fillEnd",
    "cellSelectionDeleteStart",
    "cellSelectionDeleteEnd",
    "rangeDeleteStart",
    "rangeDeleteEnd",
    "undoStarted",
    "undoEnded",
    "redoStarted",
    "redoEnded",
    "cellClicked",
    "cellDoubleClicked",
    "cellMouseDown",
    "cellContextMenu",
    "cellValueChanged",
    "cellEditRequest",
    "rowValueChanged",
    "headerFocused",
    "cellFocused",
    "rowSelected",
    "selectionChanged",
    "tooltipShow",
    "tooltipHide",
    "cellKeyDown",
    "cellMouseOver",
    "cellMouseOut",
    "filterChanged",
    "filterModified",
    "filterUiChanged",
    "filterOpened",
    "floatingFilterUiChanged",
    "advancedFilterBuilderVisibleChanged",
    "sortChanged",
    "virtualRowRemoved",
    "rowClicked",
    "rowDoubleClicked",
    "gridReady",
    "gridPreDestroyed",
    "gridSizeChanged",
    "viewportChanged",
    "firstDataRendered",
    "dragStarted",
    "dragStopped",
    "dragCancelled",
    "rowEditingStarted",
    "rowEditingStopped",
    "cellEditingStarted",
    "cellEditingStopped",
    "bodyScroll",
    "bodyScrollEnd",
    "paginationChanged",
    "componentStateChanged",
    "storeRefreshed",
    "stateUpdated",
    "columnMenuVisibleChanged",
    "contextMenuVisibleChanged",
    "rowDragEnter",
    "rowDragMove",
    "rowDragLeave",
    "rowDragEnd",
    "rowDragCancel",
    "findChanged",
    "rowResizeStarted",
    "rowResizeEnded",
    "columnsReset",
    "bulkEditingStarted",
    "bulkEditingStopped",
    "batchEditingStarted",
    "batchEditingStopped"
];
var $437b23f6a393c3bf$var$_INTERNAL_EVENTS = [
    "scrollbarWidthChanged",
    "keyShortcutChangedCellStart",
    "keyShortcutChangedCellEnd",
    "pinnedHeightChanged",
    "cellFocusCleared",
    "fullWidthRowFocused",
    "checkboxChanged",
    "heightScaleChanged",
    "suppressMovableColumns",
    "suppressMenuHide",
    "suppressFieldDotNotation",
    "columnPanelItemDragStart",
    "columnPanelItemDragEnd",
    "bodyHeightChanged",
    "columnContainerWidthChanged",
    "displayedColumnsWidthChanged",
    "scrollVisibilityChanged",
    "scrollGapChanged",
    "columnHoverChanged",
    "flashCells",
    "rowDragVisibilityChanged",
    "paginationPixelOffsetChanged",
    "displayedRowsChanged",
    "leftPinnedWidthChanged",
    "rightPinnedWidthChanged",
    "rowContainerHeightChanged",
    "headerHeightChanged",
    "columnGroupHeaderHeightChanged",
    "columnHeaderHeightChanged",
    "stylesChanged",
    "storeUpdated",
    "filterDestroyed",
    "filterHandlerDestroyed",
    "rowDataUpdateStarted",
    "rowCountReady",
    "advancedFilterEnabledChanged",
    "dataTypesInferred",
    "fieldValueChanged",
    "fieldPickerValueSelected",
    "richSelectListRowSelected",
    "sideBarUpdated",
    "alignedGridScroll",
    "alignedGridColumn",
    "gridOptionsChanged",
    "chartTitleEdit",
    "recalculateRowBounds",
    "stickyTopOffsetChanged",
    "overlayExclusiveChanged",
    "rowNodeDataChanged",
    "cellEditValuesChanged",
    "filterSwitched",
    "filterClosed",
    "headerRowsChanged",
    "rowExpansionStateChanged",
    "showRowGroupColsSetChanged"
];
var $437b23f6a393c3bf$export$a4bee1102f884a4d = ()=>[
        ...$437b23f6a393c3bf$export$e9c8ffb796317123,
        ...$437b23f6a393c3bf$var$_INTERNAL_EVENTS
    ];
// packages/ag-grid-community/src/publicEventHandlersMap.ts
var $437b23f6a393c3bf$export$85716710781d6a6b = $437b23f6a393c3bf$export$e9c8ffb796317123.reduce((mem, ev)=>{
    mem[ev] = $437b23f6a393c3bf$export$2badf35af69344c1(ev);
    return mem;
}, {});
// packages/ag-grid-community/src/validation/rules/userCompValidations.ts
var $437b23f6a393c3bf$var$USER_COMP_MODULES = {
    agSetColumnFilter: "SetFilter",
    agSetColumnFloatingFilter: "SetFilter",
    agMultiColumnFilter: "MultiFilter",
    agMultiColumnFloatingFilter: "MultiFilter",
    agGroupColumnFilter: "GroupFilter",
    agGroupColumnFloatingFilter: "GroupFilter",
    agGroupCellRenderer: "GroupCellRenderer",
    agGroupRowRenderer: "GroupCellRenderer",
    agRichSelect: "RichSelect",
    agRichSelectCellEditor: "RichSelect",
    agDetailCellRenderer: "SharedMasterDetail",
    agSparklineCellRenderer: "Sparklines",
    agDragAndDropImage: "SharedDragAndDrop",
    agColumnHeader: "ColumnHeaderComp",
    agColumnGroupHeader: "ColumnGroupHeaderComp",
    agSortIndicator: "Sort",
    agAnimateShowChangeCellRenderer: "HighlightChanges",
    agAnimateSlideCellRenderer: "HighlightChanges",
    agLoadingCellRenderer: "LoadingCellRenderer",
    agSkeletonCellRenderer: "SkeletonCellRenderer",
    agCheckboxCellRenderer: "CheckboxCellRenderer",
    agLoadingOverlay: "Overlay",
    agExportingOverlay: "Overlay",
    agNoRowsOverlay: "Overlay",
    agNoMatchingRowsOverlay: "Overlay",
    agTooltipComponent: "Tooltip",
    agReadOnlyFloatingFilter: "CustomFilter",
    agTextColumnFilter: "TextFilter",
    agNumberColumnFilter: "NumberFilter",
    agDateColumnFilter: "DateFilter",
    agDateInput: "DateFilter",
    agTextColumnFloatingFilter: "TextFilter",
    agNumberColumnFloatingFilter: "NumberFilter",
    agDateColumnFloatingFilter: "DateFilter",
    agCellEditor: "TextEditor",
    agSelectCellEditor: "SelectEditor",
    agTextCellEditor: "TextEditor",
    agNumberCellEditor: "NumberEditor",
    agDateCellEditor: "DateEditor",
    agDateStringCellEditor: "DateEditor",
    agCheckboxCellEditor: "CheckboxEditor",
    agLargeTextCellEditor: "LargeTextEditor",
    agMenuItem: "MenuItem",
    agColumnsToolPanel: "ColumnsToolPanel",
    agFiltersToolPanel: "FiltersToolPanel",
    agNewFiltersToolPanel: "NewFiltersToolPanel",
    agAggregationComponent: "StatusBar",
    agSelectedRowCountComponent: "StatusBar",
    agTotalRowCountComponent: "StatusBar",
    agFilteredRowCountComponent: "StatusBar",
    agTotalAndFilteredRowCountComponent: "StatusBar",
    agFindCellRenderer: "Find"
};
// packages/ag-grid-community/src/validation/rules/colDefValidations.ts
function $437b23f6a393c3bf$var$quote(s) {
    return `"${s}"`;
}
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_DEPRECATIONS = ()=>({
        checkboxSelection: {
            version: "32.2",
            message: "Use `rowSelection.checkboxes` in `GridOptions` instead."
        },
        headerCheckboxSelection: {
            version: "32.2",
            message: "Use `rowSelection.headerCheckbox = true` in `GridOptions` instead."
        },
        headerCheckboxSelectionFilteredOnly: {
            version: "32.2",
            message: 'Use `rowSelection.selectAll = "filtered"` in `GridOptions` instead.'
        },
        headerCheckboxSelectionCurrentPageOnly: {
            version: "32.2",
            message: 'Use `rowSelection.selectAll = "currentPage"` in `GridOptions` instead.'
        },
        showDisabledCheckboxes: {
            version: "32.2",
            message: "Use `rowSelection.hideDisabledCheckboxes = true` in `GridOptions` instead."
        },
        rowGroupingHierarchy: {
            version: "34.3",
            message: "Use `colDef.groupHierarchy` instead."
        }
    });
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_MOD_VALIDATIONS = {
    allowFormula: "Formula",
    aggFunc: "SharedAggregation",
    autoHeight: "RowAutoHeight",
    cellClass: "CellStyle",
    cellClassRules: "CellStyle",
    cellEditor: ({ cellEditor: cellEditor, editable: editable })=>{
        if (!editable) return null;
        if (typeof cellEditor === "string") return $437b23f6a393c3bf$var$USER_COMP_MODULES[cellEditor] ?? "CustomEditor";
        return "CustomEditor";
    },
    cellRenderer: ({ cellRenderer: cellRenderer })=>{
        if (typeof cellRenderer !== "string") return null;
        return $437b23f6a393c3bf$var$USER_COMP_MODULES[cellRenderer];
    },
    cellStyle: "CellStyle",
    columnChooserParams: "ColumnMenu",
    contextMenuItems: "ContextMenu",
    dndSource: "DragAndDrop",
    dndSourceOnRowDrag: "DragAndDrop",
    editable: ({ editable: editable, cellEditor: cellEditor })=>{
        if (editable && !cellEditor) return "TextEditor";
        return null;
    },
    enableCellChangeFlash: "HighlightChanges",
    enablePivot: "SharedPivot",
    enableRowGroup: "SharedRowGrouping",
    enableValue: "SharedAggregation",
    filter: ({ filter: filter })=>{
        if (filter && typeof filter !== "string" && typeof filter !== "boolean") return "CustomFilter";
        if (typeof filter === "string") return $437b23f6a393c3bf$var$USER_COMP_MODULES[filter] ?? "ColumnFilter";
        return "ColumnFilter";
    },
    floatingFilter: "ColumnFilter",
    getQuickFilterText: "QuickFilter",
    headerTooltip: "Tooltip",
    headerTooltipValueGetter: "Tooltip",
    mainMenuItems: "ColumnMenu",
    menuTabs: (options)=>{
        const enterpriseMenuTabs = [
            "columnsMenuTab",
            "generalMenuTab"
        ];
        if (options.menuTabs?.some((tab)=>enterpriseMenuTabs.includes(tab))) return "ColumnMenu";
        return null;
    },
    pivot: "SharedPivot",
    pivotIndex: "SharedPivot",
    rowDrag: "RowDrag",
    rowGroup: "SharedRowGrouping",
    rowGroupIndex: "SharedRowGrouping",
    tooltipField: "Tooltip",
    tooltipValueGetter: "Tooltip",
    tooltipComponentSelector: "Tooltip",
    spanRows: "CellSpan",
    groupHierarchy: "SharedRowGrouping"
};
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_VALIDATIONS = ()=>{
    const validations = {
        autoHeight: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (_colDef, { paginationAutoPageSize: paginationAutoPageSize })=>{
                if (paginationAutoPageSize) return "colDef.autoHeight is not supported with paginationAutoPageSize.";
                return null;
            }
        },
        allowFormula: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        cellRendererParams: {
            validate: (colDef)=>{
                const groupColumn = colDef.rowGroup != null || colDef.rowGroupIndex != null || colDef.cellRenderer === "agGroupCellRenderer";
                if (groupColumn && "checkbox" in colDef.cellRendererParams) return 'Since v33.0, `cellRendererParams.checkbox` has been deprecated. Use `rowSelection.checkboxLocation = "autoGroupColumn"` instead.';
                return null;
            }
        },
        flex: {
            validate: (_options, gridOptions)=>{
                if (gridOptions.autoSizeStrategy) return "colDef.flex is not supported with gridOptions.autoSizeStrategy";
                return null;
            }
        },
        headerCheckboxSelection: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple"
        },
        headerCheckboxSelectionCurrentPageOnly: {
            supportedRowModels: [
                "clientSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple"
        },
        headerCheckboxSelectionFilteredOnly: {
            supportedRowModels: [
                "clientSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple"
        },
        headerValueGetter: {
            validate: (_options)=>{
                const headerValueGetter = _options.headerValueGetter;
                if (typeof headerValueGetter === "function" || typeof headerValueGetter === "string") return null;
                return "headerValueGetter must be a function or a valid string expression";
            }
        },
        icons: {
            validate: ({ icons: icons })=>{
                if (icons) {
                    if (icons["smallDown"]) return $437b23f6a393c3bf$export$680bb5102fca525e(262);
                    if (icons["smallLeft"]) return $437b23f6a393c3bf$export$680bb5102fca525e(263);
                    if (icons["smallRight"]) return $437b23f6a393c3bf$export$680bb5102fca525e(264);
                }
                return null;
            }
        },
        sort: {
            validate: (_options)=>{
                if ($437b23f6a393c3bf$var$_isSortDefValid(_options.sort) || $437b23f6a393c3bf$export$12c7f6d8339d30ad(_options.sort)) return null;
                return `sort must be of type (SortDirection | SortDef), currently it is ${typeof _options.sort === "object" ? JSON.stringify(_options.sort) : $437b23f6a393c3bf$var$toStringWithNullUndefined(_options.sort)}`;
            }
        },
        initialSort: {
            validate: (_options)=>{
                if ($437b23f6a393c3bf$var$_isSortDefValid(_options.initialSort) || $437b23f6a393c3bf$export$12c7f6d8339d30ad(_options.initialSort)) return null;
                return `initialSort must be of non-null type (SortDirection | SortDef), currently it is ${typeof _options.initialSort === "object" ? JSON.stringify(_options.initialSort) : $437b23f6a393c3bf$var$toStringWithNullUndefined(_options.initialSort)}`;
            }
        },
        sortingOrder: {
            validate: (_options)=>{
                const sortingOrder = _options.sortingOrder;
                if (Array.isArray(sortingOrder) && sortingOrder.length > 0) {
                    const invalidItems = sortingOrder.filter((a)=>{
                        return !($437b23f6a393c3bf$var$_isSortDefValid(a) || $437b23f6a393c3bf$export$12c7f6d8339d30ad(a));
                    });
                    if (invalidItems.length > 0) return `sortingOrder must be an array of type non-null (SortDirection | SortDef)[], incorrect items are: [${invalidItems.map((item)=>typeof item === "string" || item == null ? $437b23f6a393c3bf$var$toStringWithNullUndefined(item) : JSON.stringify(item)).join(", ")}]`;
                } else if (!Array.isArray(sortingOrder) || !sortingOrder.length) return `sortingOrder must be an array with at least one element, currently it is [${sortingOrder}]`;
                return null;
            }
        },
        type: {
            validate: (_options)=>{
                const type = _options.type;
                if (type instanceof Array) {
                    const invalidArray = type.some((a)=>typeof a !== "string");
                    if (invalidArray) return "if colDef.type is supplied an array it should be of type 'string[]'";
                    return null;
                }
                if (typeof type === "string") return null;
                return "colDef.type should be of type 'string' | 'string[]'";
            }
        },
        rowSpan: {
            validate: (_options, { suppressRowTransform: suppressRowTransform })=>{
                if (!suppressRowTransform) return "colDef.rowSpan requires suppressRowTransform to be enabled.";
                return null;
            }
        },
        spanRows: {
            dependencies: {
                editable: {
                    required: [
                        false,
                        void 0
                    ]
                },
                rowDrag: {
                    required: [
                        false,
                        void 0
                    ]
                },
                colSpan: {
                    required: [
                        void 0
                    ]
                },
                rowSpan: {
                    required: [
                        void 0
                    ]
                }
            },
            validate: (_options, { rowSelection: rowSelection, cellSelection: cellSelection, suppressRowTransform: suppressRowTransform, enableCellSpan: enableCellSpan, rowDragEntireRow: rowDragEntireRow, enableCellTextSelection: enableCellTextSelection })=>{
                if (typeof rowSelection === "object") {
                    if (rowSelection?.mode === "singleRow" && rowSelection?.enableClickSelection) return "colDef.spanRows is not supported with rowSelection.clickSelection";
                }
                if (cellSelection) return "colDef.spanRows is not supported with cellSelection.";
                if (suppressRowTransform) return "colDef.spanRows is not supported with suppressRowTransform.";
                if (!enableCellSpan) return "colDef.spanRows requires enableCellSpan to be enabled.";
                if (rowDragEntireRow) return "colDef.spanRows is not supported with rowDragEntireRow.";
                if (enableCellTextSelection) return "colDef.spanRows is not supported with enableCellTextSelection.";
                return null;
            }
        },
        groupHierarchy: {
            validate (options, { groupHierarchyConfig: groupHierarchyConfig = {} }, beans) {
                const GROUP_HIERARCHY_PARTS = /* @__PURE__ */ new Set([
                    "year",
                    "quarter",
                    "month",
                    "formattedMonth",
                    "day",
                    "hour",
                    "minute",
                    "second"
                ]);
                const unrecognisedParts = [];
                for (const part of options.groupHierarchy ?? []){
                    if (typeof part === "object") {
                        beans.validation?.validateColDef(part);
                        continue;
                    }
                    if (!GROUP_HIERARCHY_PARTS.has(part) && !(part in groupHierarchyConfig)) unrecognisedParts.push($437b23f6a393c3bf$var$quote(part));
                }
                if (unrecognisedParts.length > 0) {
                    const warning = `The following parts of colDef.groupHierarchy are not recognised: ${unrecognisedParts.join(", ")}.`;
                    const suggestions = `Choose one of ${[
                        ...GROUP_HIERARCHY_PARTS
                    ].map($437b23f6a393c3bf$var$quote).join(", ")}, or define your own parts in gridOptions.groupHierarchyConfig.`;
                    return `${warning}
${suggestions}`;
                }
                return null;
            }
        }
    };
    return validations;
};
var $437b23f6a393c3bf$var$colDefPropertyMap = {
    headerName: void 0,
    columnGroupShow: void 0,
    headerStyle: void 0,
    headerClass: void 0,
    toolPanelClass: void 0,
    headerValueGetter: void 0,
    pivotKeys: void 0,
    groupId: void 0,
    colId: void 0,
    sort: void 0,
    initialSort: void 0,
    field: void 0,
    type: void 0,
    cellDataType: void 0,
    tooltipComponent: void 0,
    tooltipField: void 0,
    headerTooltip: void 0,
    headerTooltipValueGetter: void 0,
    cellClass: void 0,
    showRowGroup: void 0,
    filter: void 0,
    initialAggFunc: void 0,
    defaultAggFunc: void 0,
    aggFunc: void 0,
    pinned: void 0,
    initialPinned: void 0,
    chartDataType: void 0,
    cellAriaRole: void 0,
    cellEditorPopupPosition: void 0,
    headerGroupComponent: void 0,
    headerGroupComponentParams: void 0,
    cellStyle: void 0,
    cellRenderer: void 0,
    cellRendererParams: void 0,
    cellEditor: void 0,
    cellEditorParams: void 0,
    filterParams: void 0,
    pivotValueColumn: void 0,
    headerComponent: void 0,
    headerComponentParams: void 0,
    floatingFilterComponent: void 0,
    floatingFilterComponentParams: void 0,
    tooltipComponentParams: void 0,
    refData: void 0,
    columnChooserParams: void 0,
    children: void 0,
    sortingOrder: void 0,
    allowedAggFuncs: void 0,
    menuTabs: void 0,
    pivotTotalColumnIds: void 0,
    cellClassRules: void 0,
    icons: void 0,
    sortIndex: void 0,
    initialSortIndex: void 0,
    flex: void 0,
    initialFlex: void 0,
    width: void 0,
    initialWidth: void 0,
    minWidth: void 0,
    maxWidth: void 0,
    rowGroupIndex: void 0,
    initialRowGroupIndex: void 0,
    pivotIndex: void 0,
    initialPivotIndex: void 0,
    suppressColumnsToolPanel: void 0,
    suppressFiltersToolPanel: void 0,
    openByDefault: void 0,
    marryChildren: void 0,
    suppressStickyLabel: void 0,
    hide: void 0,
    initialHide: void 0,
    rowGroup: void 0,
    initialRowGroup: void 0,
    pivot: void 0,
    initialPivot: void 0,
    checkboxSelection: void 0,
    showDisabledCheckboxes: void 0,
    headerCheckboxSelection: void 0,
    headerCheckboxSelectionFilteredOnly: void 0,
    headerCheckboxSelectionCurrentPageOnly: void 0,
    suppressHeaderMenuButton: void 0,
    suppressMovable: void 0,
    lockPosition: void 0,
    lockVisible: void 0,
    lockPinned: void 0,
    unSortIcon: void 0,
    suppressSizeToFit: void 0,
    suppressAutoSize: void 0,
    enableRowGroup: void 0,
    enablePivot: void 0,
    enableValue: void 0,
    editable: void 0,
    suppressPaste: void 0,
    suppressNavigable: void 0,
    enableCellChangeFlash: void 0,
    rowDrag: void 0,
    dndSource: void 0,
    autoHeight: void 0,
    wrapText: void 0,
    sortable: void 0,
    resizable: void 0,
    singleClickEdit: void 0,
    floatingFilter: void 0,
    cellEditorPopup: void 0,
    suppressFillHandle: void 0,
    wrapHeaderText: void 0,
    autoHeaderHeight: void 0,
    dndSourceOnRowDrag: void 0,
    valueGetter: void 0,
    valueSetter: void 0,
    filterValueGetter: void 0,
    keyCreator: void 0,
    valueFormatter: void 0,
    valueParser: void 0,
    comparator: void 0,
    equals: void 0,
    pivotComparator: void 0,
    suppressKeyboardEvent: void 0,
    suppressHeaderKeyboardEvent: void 0,
    colSpan: void 0,
    rowSpan: void 0,
    spanRows: void 0,
    getQuickFilterText: void 0,
    onCellValueChanged: void 0,
    onCellClicked: void 0,
    onCellDoubleClicked: void 0,
    onCellContextMenu: void 0,
    rowDragText: void 0,
    tooltipValueGetter: void 0,
    tooltipComponentSelector: void 0,
    cellRendererSelector: void 0,
    cellEditorSelector: void 0,
    suppressSpanHeaderHeight: void 0,
    useValueFormatterForExport: void 0,
    useValueParserForImport: void 0,
    mainMenuItems: void 0,
    contextMenuItems: void 0,
    suppressFloatingFilterButton: void 0,
    suppressHeaderFilterButton: void 0,
    suppressHeaderContextMenu: void 0,
    loadingCellRenderer: void 0,
    loadingCellRendererParams: void 0,
    loadingCellRendererSelector: void 0,
    context: void 0,
    dateComponent: void 0,
    dateComponentParams: void 0,
    getFindText: void 0,
    rowGroupingHierarchy: void 0,
    groupHierarchy: void 0,
    allowFormula: void 0
};
var $437b23f6a393c3bf$var$ALL_PROPERTIES = ()=>Object.keys($437b23f6a393c3bf$var$colDefPropertyMap);
var $437b23f6a393c3bf$var$COL_DEF_VALIDATORS = ()=>({
        objectName: "colDef",
        allProperties: $437b23f6a393c3bf$var$ALL_PROPERTIES(),
        docsUrl: "column-properties/",
        deprecations: $437b23f6a393c3bf$var$COLUMN_DEFINITION_DEPRECATIONS(),
        validations: $437b23f6a393c3bf$var$COLUMN_DEFINITION_VALIDATIONS()
    });
// packages/ag-grid-community/src/propertyKeys.ts
var $437b23f6a393c3bf$var$STRING_GRID_OPTIONS = [
    "overlayLoadingTemplate",
    "overlayNoRowsTemplate",
    "gridId",
    "quickFilterText",
    "rowModelType",
    "editType",
    "domLayout",
    "clipboardDelimiter",
    "rowGroupPanelShow",
    "multiSortKey",
    "pivotColumnGroupTotals",
    "pivotRowTotals",
    "pivotPanelShow",
    "fillHandleDirection",
    "groupDisplayType",
    "treeDataDisplayType",
    "treeDataChildrenField",
    "treeDataParentIdField",
    "colResizeDefault",
    "tooltipTrigger",
    "serverSidePivotResultFieldSeparator",
    "columnMenu",
    "tooltipShowMode",
    "invalidEditValueMode",
    "grandTotalRow",
    "themeCssLayer",
    "findSearchValue",
    "styleNonce",
    "renderingMode"
];
var $437b23f6a393c3bf$var$OBJECT_GRID_OPTIONS = [
    "components",
    "rowStyle",
    "context",
    "autoGroupColumnDef",
    "localeText",
    "icons",
    "datasource",
    "dragAndDropImageComponentParams",
    "serverSideDatasource",
    "viewportDatasource",
    "groupRowRendererParams",
    "aggFuncs",
    "fullWidthCellRendererParams",
    "defaultColGroupDef",
    "defaultColDef",
    "defaultCsvExportParams",
    "defaultExcelExportParams",
    "columnTypes",
    "rowClassRules",
    "detailCellRendererParams",
    "loadingCellRendererParams",
    "overlayComponentParams",
    "loadingOverlayComponentParams",
    "noRowsOverlayComponentParams",
    "activeOverlayParams",
    "popupParent",
    "themeStyleContainer",
    "statusBar",
    "chartThemeOverrides",
    "customChartThemes",
    "chartToolPanelsDef",
    "dataTypeDefinitions",
    "advancedFilterParent",
    "advancedFilterBuilderParams",
    "advancedFilterParams",
    "formulaDataSource",
    "formulaFuncs",
    "initialState",
    "autoSizeStrategy",
    "selectionColumnDef",
    "findOptions",
    "filterHandlers",
    "groupHierarchyConfig"
];
var $437b23f6a393c3bf$var$ARRAY_GRID_OPTIONS = [
    "sortingOrder",
    "alignedGrids",
    "rowData",
    "columnDefs",
    "excelStyles",
    "pinnedTopRowData",
    "pinnedBottomRowData",
    "chartThemes",
    "rowClass",
    "paginationPageSizeSelector",
    "suppressOverlays"
];
var $437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS = [
    "rowHeight",
    "detailRowHeight",
    "rowBuffer",
    "headerHeight",
    "groupHeaderHeight",
    "groupLockGroupColumns",
    "floatingFiltersHeight",
    "pivotHeaderHeight",
    "pivotGroupHeaderHeight",
    "groupDefaultExpanded",
    "pivotDefaultExpanded",
    "viewportRowModelPageSize",
    "viewportRowModelBufferSize",
    "autoSizePadding",
    "maxBlocksInCache",
    "maxConcurrentDatasourceRequests",
    "tooltipShowDelay",
    "tooltipHideDelay",
    "cacheOverflowSize",
    "paginationPageSize",
    "cacheBlockSize",
    "infiniteInitialRowCount",
    "serverSideInitialRowCount",
    "scrollbarWidth",
    "asyncTransactionWaitMillis",
    "blockLoadDebounceMillis",
    "keepDetailRowsCount",
    "undoRedoCellEditingLimit",
    "cellFlashDuration",
    "cellFadeDuration",
    "tabIndex",
    "pivotMaxGeneratedColumns",
    "rowDragInsertDelay"
];
var $437b23f6a393c3bf$var$OTHER_GRID_OPTIONS = [
    "theme",
    "rowSelection"
];
var $437b23f6a393c3bf$export$fb22311288c545c2 = [
    "cellSelection",
    "sideBar",
    "rowNumbers",
    "suppressGroupChangesColumnVisibility",
    "groupAggFiltering",
    "suppressStickyTotalRow",
    "groupHideParentOfSingleChild",
    "enableRowPinning"
];
var $437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS = [
    "loadThemeGoogleFonts",
    "suppressMakeColumnVisibleAfterUnGroup",
    "suppressRowClickSelection",
    "suppressCellFocus",
    "suppressHeaderFocus",
    "suppressHorizontalScroll",
    "groupSelectsChildren",
    "alwaysShowHorizontalScroll",
    "alwaysShowVerticalScroll",
    "debug",
    "enableBrowserTooltips",
    "enableCellExpressions",
    "groupSuppressBlankHeader",
    "suppressMenuHide",
    "suppressRowDeselection",
    "unSortIcon",
    "suppressMultiSort",
    "alwaysMultiSort",
    "singleClickEdit",
    "suppressLoadingOverlay",
    "suppressNoRowsOverlay",
    "suppressAutoSize",
    "skipHeaderOnAutoSize",
    "suppressColumnMoveAnimation",
    "suppressMoveWhenColumnDragging",
    "suppressMovableColumns",
    "suppressFieldDotNotation",
    "enableRangeSelection",
    "enableRangeHandle",
    "enableFillHandle",
    "suppressClearOnFillReduction",
    "deltaSort",
    "suppressTouch",
    "allowContextMenuWithControlKey",
    "suppressContextMenu",
    "suppressDragLeaveHidesColumns",
    "suppressRowGroupHidesColumns",
    "suppressMiddleClickScrolls",
    "suppressPreventDefaultOnMouseWheel",
    "suppressCopyRowsToClipboard",
    "copyHeadersToClipboard",
    "copyGroupHeadersToClipboard",
    "pivotMode",
    "suppressAggFuncInHeader",
    "suppressColumnVirtualisation",
    "alwaysAggregateAtRootLevel",
    "suppressFocusAfterRefresh",
    "functionsReadOnly",
    "animateRows",
    "groupSelectsFiltered",
    "groupRemoveSingleChildren",
    "groupRemoveLowestSingleChildren",
    "enableRtl",
    "enableCellSpan",
    "suppressClickEdit",
    "rowDragEntireRow",
    "rowDragManaged",
    "refreshAfterGroupEdit",
    "suppressRowDrag",
    "suppressMoveWhenRowDragging",
    "rowDragMultiRow",
    "enableGroupEdit",
    "embedFullWidthRows",
    "suppressPaginationPanel",
    "groupHideOpenParents",
    "groupAllowUnbalanced",
    "pagination",
    "paginationAutoPageSize",
    "suppressScrollOnNewData",
    "suppressScrollWhenPopupsAreOpen",
    "purgeClosedRowNodes",
    "cacheQuickFilter",
    "includeHiddenColumnsInQuickFilter",
    "ensureDomOrder",
    "accentedSort",
    "suppressChangeDetection",
    "valueCache",
    "valueCacheNeverExpires",
    "aggregateOnlyChangedColumns",
    "suppressAnimationFrame",
    "suppressExcelExport",
    "suppressCsvExport",
    "includeHiddenColumnsInAdvancedFilter",
    "suppressMultiRangeSelection",
    "enterNavigatesVerticallyAfterEdit",
    "enterNavigatesVertically",
    "suppressPropertyNamesCheck",
    "rowMultiSelectWithClick",
    "suppressRowHoverHighlight",
    "suppressRowTransform",
    "suppressClipboardPaste",
    "suppressLastEmptyLineOnPaste",
    "enableCharts",
    "suppressMaintainUnsortedOrder",
    "enableCellTextSelection",
    "suppressBrowserResizeObserver",
    "suppressMaxRenderedRowRestriction",
    "excludeChildrenWhenTreeDataFiltering",
    "tooltipMouseTrack",
    "tooltipInteraction",
    "keepDetailRows",
    "paginateChildRows",
    "preventDefaultOnContextMenu",
    "undoRedoCellEditing",
    "allowDragFromColumnsToolPanel",
    "pivotSuppressAutoColumn",
    "suppressExpandablePivotGroups",
    "debounceVerticalScrollbar",
    "detailRowAutoHeight",
    "serverSideSortAllLevels",
    "serverSideEnableClientSideSort",
    "serverSideOnlyRefreshFilteredGroups",
    "suppressAggFilteredOnly",
    "showOpenedGroup",
    "suppressClipboardApi",
    "suppressModelUpdateAfterUpdateTransaction",
    "stopEditingWhenCellsLoseFocus",
    "groupMaintainOrder",
    "columnHoverHighlight",
    "readOnlyEdit",
    "suppressRowVirtualisation",
    "enableCellEditingOnBackspace",
    "resetRowDataOnUpdate",
    "removePivotHeaderRowWhenSingleValueColumn",
    "suppressCopySingleCellRanges",
    "suppressGroupRowsSticky",
    "suppressCutToClipboard",
    "rowGroupPanelSuppressSort",
    "allowShowChangeAfterFilter",
    "enableAdvancedFilter",
    "masterDetail",
    "treeData",
    "reactiveCustomComponents",
    "applyQuickFilterBeforePivotOrAgg",
    "suppressServerSideFullWidthLoadingRow",
    "suppressAdvancedFilterEval",
    "loading",
    "maintainColumnOrder",
    "enableStrictPivotColumnOrder",
    "suppressSetFilterByDefault",
    "enableFilterHandlers",
    "suppressStartEditOnTab",
    "hidePaddedHeaderRows",
    "ssrmExpandAllAffectsAllRows",
    "animateColumnResizing"
];
var $437b23f6a393c3bf$var$_FUNCTION_GRID_OPTIONS = [
    "doesExternalFilterPass",
    "processPivotResultColDef",
    "processPivotResultColGroupDef",
    "getBusinessKeyForNode",
    "isRowSelectable",
    "rowDragText",
    "groupRowRenderer",
    "dragAndDropImageComponent",
    "fullWidthCellRenderer",
    "loadingCellRenderer",
    "overlayComponent",
    "loadingOverlayComponent",
    "noRowsOverlayComponent",
    "overlayComponentSelector",
    "activeOverlay",
    "detailCellRenderer",
    "quickFilterParser",
    "quickFilterMatcher",
    "getLocaleText",
    "isExternalFilterPresent",
    "getRowHeight",
    "getRowClass",
    "getRowStyle",
    "getFullRowEditValidationErrors",
    "getContextMenuItems",
    "getMainMenuItems",
    "processRowPostCreate",
    "processCellForClipboard",
    "getGroupRowAgg",
    "isFullWidthRow",
    "sendToClipboard",
    "focusGridInnerElement",
    "navigateToNextHeader",
    "tabToNextHeader",
    "navigateToNextCell",
    "tabToNextCell",
    "processCellFromClipboard",
    "getDocument",
    "postProcessPopup",
    "getChildCount",
    "getDataPath",
    "isRowMaster",
    "postSortRows",
    "processHeaderForClipboard",
    "processUnpinnedColumns",
    "processGroupHeaderForClipboard",
    "paginationNumberFormatter",
    "processDataFromClipboard",
    "getServerSideGroupKey",
    "isServerSideGroup",
    "createChartContainer",
    "getChartToolbarItems",
    "fillOperation",
    "isApplyServerSideTransaction",
    "getServerSideGroupLevelParams",
    "isServerSideGroupOpenByDefault",
    "isGroupOpenByDefault",
    "initialGroupOrderComparator",
    "loadingCellRendererSelector",
    "getRowId",
    "chartMenuItems",
    "groupTotalRow",
    "alwaysPassFilter",
    "isRowPinnable",
    "isRowPinned",
    "isRowValidDropPosition"
];
var $437b23f6a393c3bf$export$a827a39ae0574df3 = ()=>[
        ...$437b23f6a393c3bf$var$ARRAY_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$OBJECT_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$STRING_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_FUNCTION_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS,
        ...$437b23f6a393c3bf$export$fb22311288c545c2,
        ...$437b23f6a393c3bf$var$OTHER_GRID_OPTIONS
    ];
// packages/ag-grid-community/src/validation/rules/gridOptionsValidations.ts
var $437b23f6a393c3bf$var$GRID_OPTION_DEPRECATIONS = ()=>({
        suppressLoadingOverlay: {
            version: "32",
            message: "Use `loading`=false instead."
        },
        enableFillHandle: {
            version: "32.2",
            message: "Use `cellSelection.handle` instead."
        },
        enableRangeHandle: {
            version: "32.2",
            message: "Use `cellSelection.handle` instead."
        },
        enableRangeSelection: {
            version: "32.2",
            message: "Use `cellSelection = true` instead."
        },
        suppressMultiRangeSelection: {
            version: "32.2",
            message: "Use `cellSelection.suppressMultiRanges` instead."
        },
        suppressClearOnFillReduction: {
            version: "32.2",
            message: "Use `cellSelection.handle.suppressClearOnFillReduction` instead."
        },
        fillHandleDirection: {
            version: "32.2",
            message: "Use `cellSelection.handle.direction` instead."
        },
        fillOperation: {
            version: "32.2",
            message: "Use `cellSelection.handle.setFillValue` instead."
        },
        suppressRowClickSelection: {
            version: "32.2",
            message: "Use `rowSelection.enableClickSelection` instead."
        },
        suppressRowDeselection: {
            version: "32.2",
            message: "Use `rowSelection.enableClickSelection` instead."
        },
        rowMultiSelectWithClick: {
            version: "32.2",
            message: "Use `rowSelection.enableSelectionWithoutKeys` instead."
        },
        groupSelectsChildren: {
            version: "32.2",
            message: 'Use `rowSelection.groupSelects = "descendants"` instead.'
        },
        groupSelectsFiltered: {
            version: "32.2",
            message: 'Use `rowSelection.groupSelects = "filteredDescendants"` instead.'
        },
        isRowSelectable: {
            version: "32.2",
            message: "Use `selectionOptions.isRowSelectable` instead."
        },
        suppressCopySingleCellRanges: {
            version: "32.2",
            message: "Use `rowSelection.copySelectedRows` instead."
        },
        suppressCopyRowsToClipboard: {
            version: "32.2",
            message: "Use `rowSelection.copySelectedRows` instead."
        },
        onRangeSelectionChanged: {
            version: "32.2",
            message: "Use `onCellSelectionChanged` instead."
        },
        onRangeDeleteStart: {
            version: "32.2",
            message: "Use `onCellSelectionDeleteStart` instead."
        },
        onRangeDeleteEnd: {
            version: "32.2",
            message: "Use `onCellSelectionDeleteEnd` instead."
        },
        suppressBrowserResizeObserver: {
            version: "32.2",
            message: "The grid always uses the browser's ResizeObserver, this grid option has no effect."
        },
        onColumnEverythingChanged: {
            version: "32.2",
            message: "Either use `onDisplayedColumnsChanged` which is fired at the same time, or use one of the more specific column events."
        },
        groupRemoveSingleChildren: {
            version: "33",
            message: "Use `groupHideParentOfSingleChild` instead."
        },
        groupRemoveLowestSingleChildren: {
            version: "33",
            message: 'Use `groupHideParentOfSingleChild: "leafGroupsOnly"` instead.'
        },
        suppressRowGroupHidesColumns: {
            version: "33",
            message: 'Use `suppressGroupChangesColumnVisibility: "suppressHideOnGroup"` instead.'
        },
        suppressMakeColumnVisibleAfterUnGroup: {
            version: "33",
            message: 'Use `suppressGroupChangesColumnVisibility: "suppressShowOnUngroup"` instead.'
        },
        unSortIcon: {
            version: "33",
            message: "Use `defaultColDef.unSortIcon` instead."
        },
        sortingOrder: {
            version: "33",
            message: "Use `defaultColDef.sortingOrder` instead."
        },
        suppressPropertyNamesCheck: {
            version: "33",
            message: "`gridOptions` and `columnDefs` both have a `context` property that should be used for arbitrary user data. This means that column definitions and gridOptions should only contain valid properties making this property redundant."
        },
        suppressAdvancedFilterEval: {
            version: "34",
            message: "Advanced filter no longer uses function evaluation, so this option has no effect."
        }
    });
function $437b23f6a393c3bf$var$toConstrainedNum(key, value, min) {
    if (typeof value === "number" || value == null) {
        if (value == null) return null;
        return value >= min ? null : `${key}: value should be greater than or equal to ${min}`;
    }
    return `${key}: value should be a number`;
}
var $437b23f6a393c3bf$var$GRID_OPTIONS_MODULES = {
    alignedGrids: "AlignedGrids",
    allowContextMenuWithControlKey: "ContextMenu",
    autoSizeStrategy: "ColumnAutoSize",
    cellSelection: "CellSelection",
    columnHoverHighlight: "ColumnHover",
    datasource: "InfiniteRowModel",
    doesExternalFilterPass: "ExternalFilter",
    editType: "EditCore",
    invalidEditValueMode: "EditCore",
    enableAdvancedFilter: "AdvancedFilter",
    enableCellSpan: "CellSpan",
    enableCharts: "IntegratedCharts",
    enableRangeSelection: "CellSelection",
    enableRowPinning: "PinnedRow",
    findSearchValue: "Find",
    getFullRowEditValidationErrors: "EditCore",
    getContextMenuItems: "ContextMenu",
    getLocaleText: "Locale",
    getMainMenuItems: "ColumnMenu",
    getRowClass: "RowStyle",
    getRowStyle: "RowStyle",
    groupTotalRow: "SharedRowGrouping",
    grandTotalRow: "ClientSideRowModelHierarchy",
    initialState: "GridState",
    isExternalFilterPresent: "ExternalFilter",
    isRowPinnable: "PinnedRow",
    isRowPinned: "PinnedRow",
    localeText: "Locale",
    masterDetail: "SharedMasterDetail",
    pagination: "Pagination",
    pinnedBottomRowData: "PinnedRow",
    pinnedTopRowData: "PinnedRow",
    pivotMode: "SharedPivot",
    pivotPanelShow: "RowGroupingPanel",
    quickFilterText: "QuickFilter",
    rowClass: "RowStyle",
    rowClassRules: "RowStyle",
    rowData: "ClientSideRowModel",
    rowDragManaged: "RowDrag",
    refreshAfterGroupEdit: [
        "RowGrouping",
        "TreeData"
    ],
    rowGroupPanelShow: "RowGroupingPanel",
    rowNumbers: "RowNumbers",
    rowSelection: "SharedRowSelection",
    rowStyle: "RowStyle",
    serverSideDatasource: "ServerSideRowModel",
    sideBar: "SideBar",
    statusBar: "StatusBar",
    treeData: "SharedTreeData",
    undoRedoCellEditing: "UndoRedoEdit",
    valueCache: "ValueCache",
    viewportDatasource: "ViewportRowModel"
};
var $437b23f6a393c3bf$var$GRID_OPTION_VALIDATIONS = ()=>{
    const definedValidations = {
        autoSizePadding: {
            validate ({ autoSizePadding: autoSizePadding }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("autoSizePadding", autoSizePadding, 0);
            }
        },
        cacheBlockSize: {
            supportedRowModels: [
                "serverSide",
                "infinite"
            ],
            validate ({ cacheBlockSize: cacheBlockSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("cacheBlockSize", cacheBlockSize, 1);
            }
        },
        cacheOverflowSize: {
            validate ({ cacheOverflowSize: cacheOverflowSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("cacheOverflowSize", cacheOverflowSize, 1);
            }
        },
        datasource: {
            supportedRowModels: [
                "infinite"
            ]
        },
        domLayout: {
            validate: (options)=>{
                const domLayout = options.domLayout;
                const validLayouts = [
                    "autoHeight",
                    "normal",
                    "print"
                ];
                if (domLayout && !validLayouts.includes(domLayout)) return `domLayout must be one of [${validLayouts.join()}], currently it's ${domLayout}`;
                return null;
            }
        },
        enableFillHandle: {
            dependencies: {
                enableRangeSelection: {
                    required: [
                        true
                    ]
                }
            }
        },
        enableRangeHandle: {
            dependencies: {
                enableRangeSelection: {
                    required: [
                        true
                    ]
                }
            }
        },
        enableRangeSelection: {
            dependencies: {
                rowDragEntireRow: {
                    required: [
                        false,
                        void 0
                    ]
                }
            }
        },
        enableRowPinning: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ enableRowPinning: enableRowPinning, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (enableRowPinning && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either set `enableRowPinning` to `false`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                return null;
            }
        },
        isRowPinnable: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ enableRowPinning: enableRowPinning, isRowPinnable: isRowPinnable, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (isRowPinnable && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinnable`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                if (!enableRowPinning && isRowPinnable) return "`isRowPinnable` requires `enableRowPinning` to be set.";
                return null;
            }
        },
        isRowPinned: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ enableRowPinning: enableRowPinning, isRowPinned: isRowPinned, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (isRowPinned && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinned`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                if (!enableRowPinning && isRowPinned) return "`isRowPinned` requires `enableRowPinning` to be set.";
                return null;
            }
        },
        groupDefaultExpanded: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        groupHideOpenParents: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            dependencies: {
                groupTotalRow: {
                    required: [
                        void 0,
                        "bottom"
                    ]
                },
                treeData: {
                    required: [
                        void 0,
                        false
                    ],
                    reason: "Tree Data has values at the group level so it doesn't make sense to hide them."
                }
            }
        },
        groupHideParentOfSingleChild: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupRemoveLowestSingleChildren: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                },
                groupRemoveSingleChildren: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupRemoveSingleChildren: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                },
                groupRemoveLowestSingleChildren: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupSelectsChildren: {
            dependencies: {
                rowSelection: {
                    required: [
                        "multiple"
                    ]
                }
            }
        },
        groupHierarchyConfig: {
            validate ({ groupHierarchyConfig: groupHierarchyConfig = {} }, gridOptions, beans) {
                for (const k of Object.keys(groupHierarchyConfig))beans.validation?.validateColDef(groupHierarchyConfig[k]);
                return null;
            }
        },
        icons: {
            validate: ({ icons: icons })=>{
                if (icons) {
                    if (icons["smallDown"]) return $437b23f6a393c3bf$export$680bb5102fca525e(262);
                    if (icons["smallLeft"]) return $437b23f6a393c3bf$export$680bb5102fca525e(263);
                    if (icons["smallRight"]) return $437b23f6a393c3bf$export$680bb5102fca525e(264);
                }
                return null;
            }
        },
        infiniteInitialRowCount: {
            validate ({ infiniteInitialRowCount: infiniteInitialRowCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("infiniteInitialRowCount", infiniteInitialRowCount, 1);
            }
        },
        initialGroupOrderComparator: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        ssrmExpandAllAffectsAllRows: {
            validate: (options)=>{
                if (typeof options.ssrmExpandAllAffectsAllRows === "boolean") {
                    if (options.rowModelType !== "serverSide") return "'ssrmExpandAllAffectsAllRows' is only supported with the Server Side Row Model.";
                    if (options.ssrmExpandAllAffectsAllRows && typeof options.getRowId !== "function") return `'getRowId' callback must be provided for Server Side Row Model grouping to work correctly.`;
                }
                return null;
            }
        },
        keepDetailRowsCount: {
            validate ({ keepDetailRowsCount: keepDetailRowsCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("keepDetailRowsCount", keepDetailRowsCount, 1);
            }
        },
        paginationPageSize: {
            validate ({ paginationPageSize: paginationPageSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("paginationPageSize", paginationPageSize, 1);
            }
        },
        paginationPageSizeSelector: {
            validate: (options)=>{
                const values = options.paginationPageSizeSelector;
                if (typeof values === "boolean" || values == null) return null;
                if (!values.length) return `'paginationPageSizeSelector' cannot be an empty array.
                    If you want to hide the page size selector, set paginationPageSizeSelector to false.`;
                return null;
            }
        },
        pivotMode: {
            dependencies: {
                treeData: {
                    required: [
                        false,
                        void 0
                    ],
                    reason: "Pivot Mode is not supported with Tree Data."
                }
            }
        },
        quickFilterText: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        rowBuffer: {
            validate ({ rowBuffer: rowBuffer }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("rowBuffer", rowBuffer, 0);
            }
        },
        rowClass: {
            validate: (options)=>{
                const rowClass = options.rowClass;
                if (typeof rowClass === "function") return "rowClass should not be a function, please use getRowClass instead";
                return null;
            }
        },
        rowData: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        rowDragManaged: {
            supportedRowModels: [
                "clientSide"
            ],
            dependencies: {
                pagination: {
                    required: [
                        false,
                        void 0
                    ]
                }
            }
        },
        rowSelection: {
            validate ({ rowSelection: rowSelection }) {
                if (rowSelection && typeof rowSelection === "string") return 'As of version 32.2.1, using `rowSelection` with the values "single" or "multiple" has been deprecated. Use the object value instead.';
                if (rowSelection && typeof rowSelection !== "object") return "Expected `RowSelectionOptions` object for the `rowSelection` property.";
                if (rowSelection && rowSelection.mode !== "multiRow" && rowSelection.mode !== "singleRow") return `Selection mode "${rowSelection.mode}" is invalid. Use one of 'singleRow' or 'multiRow'.`;
                return null;
            }
        },
        rowStyle: {
            validate: (options)=>{
                const rowStyle = options.rowStyle;
                if (rowStyle && typeof rowStyle === "function") return "rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead";
                return null;
            }
        },
        serverSideDatasource: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        serverSideInitialRowCount: {
            supportedRowModels: [
                "serverSide"
            ],
            validate ({ serverSideInitialRowCount: serverSideInitialRowCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("serverSideInitialRowCount", serverSideInitialRowCount, 1);
            }
        },
        serverSideOnlyRefreshFilteredGroups: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        serverSideSortAllLevels: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        sortingOrder: {
            validate: (_options)=>{
                const sortingOrder = _options.sortingOrder;
                if (Array.isArray(sortingOrder) && sortingOrder.length > 0) {
                    const invalidItems = sortingOrder.filter((a)=>!$437b23f6a393c3bf$export$2a92f4fc1f337c5a(a));
                    if (invalidItems.length > 0) return `sortingOrder must be an array of type (SortDirection | SortDef)[], incorrect items are: ${invalidItems.map((item)=>typeof item === "string" || item == null ? $437b23f6a393c3bf$var$toStringWithNullUndefined(item) : JSON.stringify(item))}]`;
                } else if (!Array.isArray(sortingOrder) || !sortingOrder.length) return `sortingOrder must be an array with at least one element, currently it's ${sortingOrder}`;
                return null;
            }
        },
        tooltipHideDelay: {
            validate: (options)=>{
                if (options.tooltipHideDelay && options.tooltipHideDelay < 0) return "tooltipHideDelay should not be lower than 0";
                return null;
            }
        },
        tooltipShowDelay: {
            validate: (options)=>{
                if (options.tooltipShowDelay && options.tooltipShowDelay < 0) return "tooltipShowDelay should not be lower than 0";
                return null;
            }
        },
        treeData: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (options)=>{
                const rowModel = options.rowModelType ?? "clientSide";
                switch(rowModel){
                    case "clientSide":
                        {
                            const { treeDataChildrenField: treeDataChildrenField, treeDataParentIdField: treeDataParentIdField, getDataPath: getDataPath, getRowId: getRowId } = options;
                            if (!treeDataChildrenField && !treeDataParentIdField && !getDataPath) return "treeData requires either 'treeDataChildrenField' or 'treeDataParentIdField' or 'getDataPath' in the clientSide row model.";
                            if (treeDataChildrenField) {
                                if (getDataPath) return "Cannot use both 'treeDataChildrenField' and 'getDataPath' at the same time.";
                                if (treeDataParentIdField) return "Cannot use both 'treeDataChildrenField' and 'treeDataParentIdField' at the same time.";
                            }
                            if (treeDataParentIdField) {
                                if (!getRowId) return "getRowId callback not provided, tree data with parent id cannot be built.";
                                if (getDataPath) return "Cannot use both 'treeDataParentIdField' and 'getDataPath' at the same time.";
                            }
                            return null;
                        }
                    case "serverSide":
                        {
                            const ssrmWarning = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${rowModel} row model.`;
                            return options.isServerSideGroup && options.getServerSideGroupKey ? null : ssrmWarning;
                        }
                }
                return null;
            }
        },
        viewportDatasource: {
            supportedRowModels: [
                "viewport"
            ]
        },
        viewportRowModelBufferSize: {
            validate ({ viewportRowModelBufferSize: viewportRowModelBufferSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("viewportRowModelBufferSize", viewportRowModelBufferSize, 0);
            }
        },
        viewportRowModelPageSize: {
            validate ({ viewportRowModelPageSize: viewportRowModelPageSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("viewportRowModelPageSize", viewportRowModelPageSize, 1);
            }
        },
        rowDragEntireRow: {
            dependencies: {
                cellSelection: {
                    required: [
                        void 0
                    ]
                }
            }
        },
        autoGroupColumnDef: {
            validate ({ autoGroupColumnDef: autoGroupColumnDef, showOpenedGroup: showOpenedGroup }) {
                if (autoGroupColumnDef?.field && showOpenedGroup) return "autoGroupColumnDef.field and showOpenedGroup are not supported when used together.";
                if (autoGroupColumnDef?.valueGetter && showOpenedGroup) return "autoGroupColumnDef.valueGetter and showOpenedGroup are not supported when used together.";
                return null;
            }
        },
        renderingMode: {
            validate: (options)=>{
                const renderingMode = options.renderingMode;
                const validModes = [
                    "default",
                    "legacy"
                ];
                if (renderingMode && !validModes.includes(renderingMode)) return `renderingMode must be one of [${validModes.join()}], currently it's ${renderingMode}`;
                return null;
            }
        },
        autoSizeStrategy: {
            validate: ({ autoSizeStrategy: autoSizeStrategy })=>{
                if (!autoSizeStrategy) return null;
                const validModes = [
                    "fitCellContents",
                    "fitGridWidth",
                    "fitProvidedWidth"
                ];
                const type = autoSizeStrategy.type;
                if (type !== "fitCellContents" && type !== "fitGridWidth" && type !== "fitProvidedWidth") return `Invalid Auto-size strategy. \`autoSizeStrategy\` must be one of ${validModes.map((m)=>'"' + m + '"').join(", ")}, currently it's ${type}`;
                if (type === "fitProvidedWidth" && typeof autoSizeStrategy.width != "number") return `When using the 'fitProvidedWidth' auto-size strategy, must provide a numeric \`width\`. You provided ${autoSizeStrategy.width}`;
                return null;
            }
        }
    };
    const validations = {};
    for (const key of $437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS)validations[key] = {
        expectedType: "boolean"
    };
    for (const key of $437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS)validations[key] = {
        expectedType: "number"
    };
    $437b23f6a393c3bf$export$8ade6bd474fcde42(validations, definedValidations);
    return validations;
};
var $437b23f6a393c3bf$var$GRID_OPTIONS_VALIDATORS = ()=>({
        objectName: "gridOptions",
        allProperties: [
            ...$437b23f6a393c3bf$export$a827a39ae0574df3(),
            ...Object.values($437b23f6a393c3bf$export$85716710781d6a6b)
        ],
        propertyExceptions: [
            "api"
        ],
        docsUrl: "grid-options/",
        deprecations: $437b23f6a393c3bf$var$GRID_OPTION_DEPRECATIONS(),
        validations: $437b23f6a393c3bf$var$GRID_OPTION_VALIDATIONS()
    });
// packages/ag-grid-community/src/gridOptionsService.ts
var $437b23f6a393c3bf$var$changeSetId = 0;
var $437b23f6a393c3bf$var$gridInstanceSequence = 0;
var $437b23f6a393c3bf$var$GRID_DOM_KEY = "__ag_grid_instance";
var $437b23f6a393c3bf$var$GridOptionsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gos";
        this.domDataKey = "__AG_" + Math.random().toString();
        /** This is only used for the main DOM element */ this.instanceId = $437b23f6a393c3bf$var$gridInstanceSequence++;
        // Used to hold user events until the grid is ready
        // Required to support React 19 StrictMode. See IFrameworkOverrides.runWhenReadyAsync but also is likely a good idea that onGridReady is the first event fired.
        this.gridReadyFired = false;
        this.queueEvents = [];
        this.propEventSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
        // responsible for calling the onXXX functions on gridOptions
        // It forces events defined in GridOptionsService.alwaysSyncGlobalEvents to be fired synchronously.
        // This is required for events such as GridPreDestroyed.
        // Other events can be fired asynchronously or synchronously depending on config.
        this.globalEventHandlerFactory = (restrictToSyncOnly)=>{
            return (eventName, event)=>{
                if (!this.isAlive()) return;
                const alwaysSync = $437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventName);
                if (alwaysSync && !restrictToSyncOnly || !alwaysSync && restrictToSyncOnly) return;
                if (!$437b23f6a393c3bf$var$isPublicEventHandler(eventName)) return;
                const fireEvent = (name, e)=>{
                    const eventHandlerName = $437b23f6a393c3bf$export$85716710781d6a6b[name];
                    const eventHandler = this.gridOptions[eventHandlerName];
                    if (typeof eventHandler === "function") this.beans.frameworkOverrides.wrapOutgoing(()=>eventHandler(e));
                };
                if (this.gridReadyFired) fireEvent(eventName, event);
                else if (eventName === "gridReady") {
                    fireEvent(eventName, event);
                    this.gridReadyFired = true;
                    for (const q of this.queueEvents)fireEvent(q.eventName, q.event);
                    this.queueEvents = [];
                } else this.queueEvents.push({
                    eventName: eventName,
                    event: event
                });
            };
        };
    }
    wireBeans(beans) {
        this.gridOptions = beans.gridOptions;
        this.validation = beans.validation;
        this.api = beans.gridApi;
        this.gridId = beans.context.getId();
    }
    // This is quicker then having code call gridOptionsService.get('context')
    get gridOptionsContext() {
        return this.gridOptions["context"];
    }
    postConstruct() {
        this.validateGridOptions(this.gridOptions);
        this.eventSvc.addGlobalListener(this.globalEventHandlerFactory().bind(this), true);
        this.eventSvc.addGlobalListener(this.globalEventHandlerFactory(true).bind(this), false);
        this.propEventSvc.setFrameworkOverrides(this.beans.frameworkOverrides);
        this.addManagedEventListeners({
            gridOptionsChanged: ({ options: options })=>{
                this.updateGridOptions({
                    options: options,
                    force: true,
                    source: "optionsUpdated"
                });
            }
        });
    }
    destroy() {
        super.destroy();
        this.queueEvents = [];
    }
    /**
   * Get the raw value of the GridOptions property provided.
   * @param property
   */ get(property) {
        return this.gridOptions[property] ?? $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS[property];
    }
    /**
   * Get the GridOption callback but wrapped so that the common params of api and context are automatically applied to the params.
   * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
   */ getCallback(property) {
        return this.mergeGridCommonParams(this.gridOptions[property]);
    }
    /**
   * Returns `true` if a value has been specified for this GridOption.
   * @param property GridOption property
   */ exists(property) {
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(this.gridOptions[property]);
    }
    /**
   * Wrap the user callback and attach the api and context to the params object on the way through.
   * @param callback User provided callback
   * @returns Wrapped callback where the params object not require api and context
   */ mergeGridCommonParams(callback) {
        if (callback) {
            const wrapped = (callbackParams)=>{
                return callback(this.addCommon(callbackParams));
            };
            return wrapped;
        }
        return callback;
    }
    updateGridOptions({ options: options, force: force, source: source = "api" }) {
        const changeSet = {
            id: $437b23f6a393c3bf$var$changeSetId++,
            properties: []
        };
        const events = [];
        const { gridOptions: gridOptions, validation: validation } = this;
        for (const key of Object.keys(options)){
            const value = $437b23f6a393c3bf$var$GlobalGridOptions.applyGlobalGridOption(key, options[key]);
            validation?.warnOnInitialPropertyUpdate(source, key);
            const shouldForce = force || typeof value === "object" && source === "api";
            const previousValue = gridOptions[key];
            if (shouldForce || previousValue !== value) {
                gridOptions[key] = value;
                const event = {
                    type: key,
                    currentValue: value,
                    previousValue: previousValue,
                    changeSet: changeSet,
                    source: source
                };
                events.push(event);
            }
        }
        this.validateGridOptions(this.gridOptions);
        changeSet.properties = events.map((event)=>event.type);
        for (const event of events){
            $437b23f6a393c3bf$var$_logIfDebug(this, `Updated property ${event.type} from`, event.previousValue, ` to `, event.currentValue);
            this.propEventSvc.dispatchEvent(event);
        }
    }
    addPropertyEventListener(key, listener) {
        this.propEventSvc.addEventListener(key, listener);
    }
    removePropertyEventListener(key, listener) {
        this.propEventSvc.removeEventListener(key, listener);
    }
    getDomDataKey() {
        return this.domDataKey;
    }
    /** Prefer _addGridCommonParams from gridOptionsUtils for bundle size savings */ addCommon(params) {
        params.api = this.api;
        params.context = this.gridOptionsContext;
        return params;
    }
    validateOptions(options, modValidations) {
        for (const key of Object.keys(options)){
            const value = options[key];
            if (value == null || value === false) continue;
            let moduleToCheck = modValidations[key];
            if (typeof moduleToCheck === "function") moduleToCheck = moduleToCheck(options, this.gridOptions, this.beans);
            if (moduleToCheck) this.assertModuleRegistered(moduleToCheck, key);
        }
    }
    validateGridOptions(gridOptions) {
        this.validateOptions(gridOptions, $437b23f6a393c3bf$var$GRID_OPTIONS_MODULES);
        this.validation?.processGridOptions(gridOptions);
    }
    validateColDef(colDef, colId, skipInferenceCheck) {
        if (skipInferenceCheck || !this.beans.dataTypeSvc?.isColPendingInference(colId)) {
            this.validateOptions(colDef, $437b23f6a393c3bf$var$COLUMN_DEFINITION_MOD_VALIDATIONS);
            this.validation?.validateColDef(colDef);
        }
    }
    assertModuleRegistered(moduleName, reasonOrId) {
        const registered = Array.isArray(moduleName) ? moduleName.some((modName)=>this.isModuleRegistered(modName)) : this.isModuleRegistered(moduleName);
        if (!registered) $437b23f6a393c3bf$export$a20c7248650823a9(200, {
            ...this.getModuleErrorParams(),
            moduleName: moduleName,
            reasonOrId: reasonOrId
        });
        return registered;
    }
    getModuleErrorParams() {
        return {
            gridId: this.gridId,
            gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
            rowModelType: this.get("rowModelType"),
            isUmd: $437b23f6a393c3bf$var$_isUmd()
        };
    }
    isModuleRegistered(moduleName) {
        return $437b23f6a393c3bf$var$_isModuleRegistered(moduleName, this.gridId, this.get("rowModelType"));
    }
    setInstanceDomData(element) {
        element[$437b23f6a393c3bf$var$GRID_DOM_KEY] = this.instanceId;
    }
    isElementInThisInstance(element) {
        let pointer = element;
        while(pointer){
            const instanceId = pointer[$437b23f6a393c3bf$var$GRID_DOM_KEY];
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(instanceId)) {
                const eventFromThisGrid = instanceId === this.instanceId;
                return eventFromThisGrid;
            }
            pointer = pointer.parentElement;
        }
        return false;
    }
};
function $437b23f6a393c3bf$var$isPublicEventHandler(eventName) {
    return !!$437b23f6a393c3bf$export$85716710781d6a6b[eventName];
}
// packages/ag-grid-community/src/headerRendering/cells/column/headerCellMouseListenerFeature.ts
var $437b23f6a393c3bf$var$HeaderCellMouseListenerFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column, eGui){
        super();
        this.column = column;
        this.eGui = eGui;
        this.lastMovingChanged = 0;
    }
    postConstruct() {
        this.addManagedElementListeners(this.eGui, {
            click: (e)=>e && this.onClick(e)
        });
        this.addManagedListeners(this.column, {
            movingChanged: ()=>{
                this.lastMovingChanged = Date.now();
            }
        });
    }
    onClick(event) {
        const { sortSvc: sortSvc, rangeSvc: rangeSvc, gos: gos } = this.beans;
        const sortFromClick = $437b23f6a393c3bf$export$8242077b143dbc86(gos) ? event.altKey : true;
        if (!sortFromClick) rangeSvc?.handleColumnSelection(this.column, event);
        else if (this.column.isSortable()) {
            const moving = this.column.isMoving();
            const nowTime = Date.now();
            const movedRecently = nowTime - this.lastMovingChanged < 50;
            const columnMoving = moving || movedRecently;
            if (!columnMoving) sortSvc?.progressSortFromEvent(this.column, event);
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/column/headerComp.ts
function $437b23f6a393c3bf$var$getHeaderCompElementParams(includeColumnRefIndicator, includeSortIndicator) {
    const hiddenAttrs = {
        "aria-hidden": "true"
    };
    return {
        tag: "div",
        cls: "ag-cell-label-container",
        role: "presentation",
        children: [
            {
                tag: "span",
                ref: "eMenu",
                cls: "ag-header-icon ag-header-cell-menu-button",
                attrs: hiddenAttrs
            },
            {
                tag: "span",
                ref: "eFilterButton",
                cls: "ag-header-icon ag-header-cell-filter-button",
                attrs: hiddenAttrs
            },
            {
                tag: "div",
                ref: "eLabel",
                cls: "ag-header-cell-label",
                role: "presentation",
                children: [
                    includeColumnRefIndicator ? {
                        tag: "span",
                        ref: "eColRef",
                        cls: "ag-header-col-ref"
                    } : null,
                    {
                        tag: "span",
                        ref: "eText",
                        cls: "ag-header-cell-text"
                    },
                    {
                        tag: "span",
                        ref: "eFilter",
                        cls: "ag-header-icon ag-header-label-icon ag-filter-icon",
                        attrs: hiddenAttrs
                    },
                    includeSortIndicator ? {
                        tag: "ag-sort-indicator",
                        ref: "eSortIndicator"
                    } : null
                ]
            }
        ]
    };
}
var $437b23f6a393c3bf$export$266cd3930df0b35d = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        // All the elements are optional, as they are not guaranteed to be present if the user provides a custom template
        this.eFilter = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eFilterButton = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortIndicator = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eMenu = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eText = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eColRef = $437b23f6a393c3bf$export$6c811454646ed8be;
        /**
     * Selectors for custom headers templates, i.e when the ag-sort-indicator is not present.
     */ this.eSortOrder = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAsc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortDesc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortMixed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortNone = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAbsoluteAsc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAbsoluteDesc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isLoadingInnerComponent = false;
    }
    refresh(params) {
        const oldParams = this.params;
        this.params = params;
        if (this.workOutTemplate(params, !!this.beans?.sortSvc) != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || params.enableSorting != this.currentSort || params.column.formulaRef != this.currentRef || this.currentSuppressMenuHide != null && this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || oldParams.enableFilterButton != params.enableFilterButton || oldParams.enableFilterIcon != params.enableFilterIcon) return false;
        if (this.innerHeaderComponent) {
            const mergedParams = {
                ...params
            };
            $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedParams, params.innerHeaderComponentParams);
            this.innerHeaderComponent.refresh?.(mergedParams);
        } else this.setDisplayName(params);
        return true;
    }
    workOutTemplate(params, isSorting) {
        const { formula: formula } = this.beans;
        const paramsTemplate = params.template;
        if (paramsTemplate) return paramsTemplate?.trim ? paramsTemplate.trim() : paramsTemplate;
        return $437b23f6a393c3bf$var$getHeaderCompElementParams(!!formula?.active, isSorting);
    }
    init(params) {
        this.params = params;
        const { sortSvc: sortSvc, touchSvc: touchSvc, rowNumbersSvc: rowNumbersSvc, userCompFactory: userCompFactory } = this.beans;
        const sortComp = sortSvc?.getSortIndicatorSelector();
        this.currentTemplate = this.workOutTemplate(params, !!sortComp);
        this.setTemplate(this.currentTemplate, sortComp ? [
            sortComp
        ] : void 0);
        if (this.eLabel) this.mouseListener ?? (this.mouseListener = this.createManagedBean(new $437b23f6a393c3bf$var$HeaderCellMouseListenerFeature(params.column, this.eLabel)));
        touchSvc?.setupForHeader(this);
        this.setMenu();
        this.setupSort();
        this.setupColumnRefIndicator();
        rowNumbersSvc?.setupForHeader(this);
        this.setupFilterIcon();
        this.setupFilterButton();
        this.workOutInnerHeaderComponent(userCompFactory, params);
        this.setDisplayName(params);
    }
    workOutInnerHeaderComponent(userCompFactory, params) {
        const userCompDetails = $437b23f6a393c3bf$var$_getInnerHeaderCompDetails(userCompFactory, params, params);
        if (!userCompDetails) return;
        this.isLoadingInnerComponent = true;
        userCompDetails.newAgStackInstance().then((comp)=>{
            this.isLoadingInnerComponent = false;
            if (!comp) return;
            if (this.isAlive()) {
                this.innerHeaderComponent = comp;
                if (this.eText) this.eText.appendChild(comp.getGui());
            } else this.destroyBean(comp);
        });
    }
    setDisplayName(params) {
        const { displayName: displayName } = params;
        const oldDisplayName = this.currentDisplayName;
        this.currentDisplayName = displayName;
        if (!this.eText || oldDisplayName === displayName || this.innerHeaderComponent || this.isLoadingInnerComponent) return;
        this.eText.textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(displayName);
    }
    addInIcon(iconName, eParent, column) {
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    workOutShowMenu() {
        return this.params.enableMenu && !!this.beans.menuSvc?.isHeaderMenuButtonEnabled();
    }
    shouldSuppressMenuHide() {
        return !!this.beans.menuSvc?.isHeaderMenuButtonAlwaysShowEnabled();
    }
    setMenu() {
        if (!this.eMenu) return;
        this.currentShowMenu = this.workOutShowMenu();
        if (!this.currentShowMenu) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eMenu);
            this.eMenu = void 0;
            return;
        }
        const { gos: gos, eMenu: eMenu, params: params } = this;
        const isLegacyMenu = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
        this.addInIcon(isLegacyMenu ? "menu" : "menuAlt", eMenu, params.column);
        eMenu.classList.toggle("ag-header-menu-icon", !isLegacyMenu);
        const currentSuppressMenuHide = this.shouldSuppressMenuHide();
        this.currentSuppressMenuHide = currentSuppressMenuHide;
        this.addManagedElementListeners(eMenu, {
            click: ()=>this.showColumnMenu(this.eMenu)
        });
        this.toggleMenuAlwaysShow(currentSuppressMenuHide);
    }
    toggleMenuAlwaysShow(alwaysShow) {
        this.eMenu?.classList.toggle("ag-header-menu-always-show", alwaysShow);
    }
    showColumnMenu(element) {
        const { currentSuppressMenuHide: currentSuppressMenuHide, params: params } = this;
        if (!currentSuppressMenuHide) this.toggleMenuAlwaysShow(true);
        params.showColumnMenu(element, ()=>{
            if (!currentSuppressMenuHide) this.toggleMenuAlwaysShow(false);
        });
    }
    onMenuKeyboardShortcut(isFilterShortcut) {
        const { params: params, gos: gos, beans: beans, eMenu: eMenu, eFilterButton: eFilterButton } = this;
        const column = params.column;
        const isLegacyMenuEnabled = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
        if (isFilterShortcut && !isLegacyMenuEnabled) {
            if (beans.menuSvc?.isFilterMenuInHeaderEnabled(column)) {
                params.showFilter(eFilterButton ?? eMenu ?? this.getGui());
                return true;
            }
        } else if (params.enableMenu) {
            this.showColumnMenu(eMenu ?? eFilterButton ?? this.getGui());
            return true;
        }
        return false;
    }
    setupSort() {
        const { sortSvc: sortSvc } = this.beans;
        if (!sortSvc) return;
        const { enableSorting: enableSorting, column: column } = this.params;
        this.currentSort = enableSorting;
        if (!this.eSortIndicator) {
            this.eSortIndicator = this.createBean(sortSvc.createSortIndicator(true));
            const { eSortIndicator: eSortIndicator, eSortOrder: eSortOrder, eSortAsc: eSortAsc, eSortDesc: eSortDesc, eSortMixed: eSortMixed, eSortNone: eSortNone, eSortAbsoluteAsc: eSortAbsoluteAsc, eSortAbsoluteDesc: eSortAbsoluteDesc } = this;
            eSortIndicator.attachCustomElements(eSortOrder, eSortAsc, eSortDesc, eSortMixed, eSortNone, eSortAbsoluteAsc, eSortAbsoluteDesc);
        }
        this.eSortIndicator.setupSort(column);
        if (!this.currentSort) return;
        sortSvc.setupHeader(this, column);
    }
    setupColumnRefIndicator() {
        const { eColRef: eColRef, beans: { editModelSvc: editModelSvc }, params: params } = this;
        if (!eColRef) return;
        this.currentRef = params.column.formulaRef;
        eColRef.textContent = this.currentRef;
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(eColRef, false);
        this.addManagedEventListeners({
            cellEditingStarted: ()=>{
                const editPositions = editModelSvc?.getEditPositions();
                const shouldDisplay = !!this.currentRef && !!editPositions?.some((position)=>position.column.isAllowFormula());
                $437b23f6a393c3bf$export$9405f1cbb4e2383f(eColRef, shouldDisplay);
            },
            cellEditingStopped: ()=>{
                $437b23f6a393c3bf$export$9405f1cbb4e2383f(eColRef, false);
            }
        });
    }
    setupFilterIcon() {
        const { eFilter: eFilter, params: params } = this;
        if (!eFilter) return;
        const onFilterChangedIcon = ()=>{
            const filterPresent = params.column.isFilterActive();
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eFilter, filterPresent, {
                skipAriaHidden: true
            });
        };
        this.configureFilter(params.enableFilterIcon, eFilter, onFilterChangedIcon, "filterActive");
    }
    setupFilterButton() {
        const { eFilterButton: eFilterButton, params: params } = this;
        if (!eFilterButton) return;
        const configured = this.configureFilter(params.enableFilterButton, eFilterButton, this.onFilterChangedButton.bind(this), "filter");
        if (configured) this.addManagedElementListeners(eFilterButton, {
            click: ()=>params.showFilter(eFilterButton)
        });
        else this.eFilterButton = void 0;
    }
    configureFilter(enabled, element, filterChangedCallback, icon) {
        if (!enabled) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(element);
            return false;
        }
        const column = this.params.column;
        this.addInIcon(icon, element, column);
        this.addManagedListeners(column, {
            filterChanged: filterChangedCallback
        });
        filterChangedCallback();
        return true;
    }
    onFilterChangedButton() {
        const filterPresent = this.params.column.isFilterActive();
        this.eFilterButton.classList.toggle("ag-filter-active", filterPresent);
    }
    getAnchorElementForMenu(isFilter) {
        const { eFilterButton: eFilterButton, eMenu: eMenu } = this;
        if (isFilter) return eFilterButton ?? eMenu ?? this.getGui();
        return eMenu ?? eFilterButton ?? this.getGui();
    }
    destroy() {
        super.destroy();
        this.innerHeaderComponent = this.destroyBean(this.innerHeaderComponent);
        this.mouseListener = this.destroyBean(this.mouseListener);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupComp.ts
var $437b23f6a393c3bf$var$HeaderGroupCompElement = {
    tag: "div",
    cls: "ag-header-group-cell-label",
    role: "presentation",
    children: [
        {
            tag: "span",
            ref: "agLabel",
            cls: "ag-header-group-text",
            role: "presentation"
        },
        {
            tag: "span",
            ref: "agOpened",
            cls: `ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded`
        },
        {
            tag: "span",
            ref: "agClosed",
            cls: `ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed`
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderGroupComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$HeaderGroupCompElement);
        this.agOpened = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.agClosed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.agLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isLoadingInnerComponent = false;
    }
    init(params) {
        const { userCompFactory: userCompFactory, touchSvc: touchSvc } = this.beans;
        this.params = params;
        this.checkWarnings();
        this.workOutInnerHeaderGroupComponent(userCompFactory, params);
        this.setupLabel(params);
        this.addGroupExpandIcon(params);
        this.setupExpandIcons();
        touchSvc?.setupForHeaderGroup(this);
    }
    checkWarnings() {
        const paramsAny = this.params;
        if (paramsAny.template) $437b23f6a393c3bf$export$545083624300f13d(89);
    }
    workOutInnerHeaderGroupComponent(userCompFactory, params) {
        const userCompDetails = $437b23f6a393c3bf$var$_getInnerHeaderGroupCompDetails(userCompFactory, params, params);
        if (!userCompDetails) return;
        this.isLoadingInnerComponent = true;
        userCompDetails.newAgStackInstance().then((comp)=>{
            this.isLoadingInnerComponent = false;
            if (!comp) return;
            if (this.isAlive()) {
                this.innerHeaderGroupComponent = comp;
                this.agLabel.appendChild(comp.getGui());
            } else this.destroyBean(comp);
        });
    }
    setupExpandIcons() {
        const { agOpened: agOpened, agClosed: agClosed, params: { columnGroup: columnGroup }, beans: { colGroupSvc: colGroupSvc } } = this;
        this.addInIcon("columnGroupOpened", agOpened);
        this.addInIcon("columnGroupClosed", agClosed);
        const expandAction = (event)=>{
            if ($437b23f6a393c3bf$export$9a48e23524c6d58(event)) return;
            const newExpandedValue = !columnGroup.isExpanded();
            colGroupSvc.setColumnGroupOpened(columnGroup.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        };
        this.addTouchAndClickListeners(agClosed, expandAction);
        this.addTouchAndClickListeners(agOpened, expandAction);
        const stopPropagationAction = (event)=>{
            $437b23f6a393c3bf$export$456c40e80134d72a(event);
        };
        this.addManagedElementListeners(agClosed, {
            dblclick: stopPropagationAction
        });
        this.addManagedElementListeners(agOpened, {
            dblclick: stopPropagationAction
        });
        this.addManagedElementListeners(this.getGui(), {
            dblclick: expandAction
        });
        this.updateIconVisibility();
        const providedColumnGroup = columnGroup.getProvidedColumnGroup();
        const updateIcon = this.updateIconVisibility.bind(this);
        this.addManagedListeners(providedColumnGroup, {
            expandedChanged: updateIcon,
            expandableChanged: updateIcon
        });
    }
    addTouchAndClickListeners(eElement, action) {
        this.beans.touchSvc?.setupForHeaderGroupElement(this, eElement, action);
        this.addManagedElementListeners(eElement, {
            click: action
        });
    }
    updateIconVisibility() {
        const { agOpened: agOpened, agClosed: agClosed, params: { columnGroup: columnGroup } } = this;
        if (columnGroup.isExpandable()) {
            const expanded = columnGroup.isExpanded();
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, expanded);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, !expanded);
        } else {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, false);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, false);
        }
    }
    addInIcon(iconName, element) {
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, null);
        if (eIcon) element.appendChild(eIcon);
    }
    addGroupExpandIcon(params) {
        if (!params.columnGroup.isExpandable()) {
            const { agOpened: agOpened, agClosed: agClosed } = this;
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, false);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, false);
        }
    }
    setupLabel(params) {
        const { displayName: displayName, columnGroup: columnGroup } = params;
        const { innerHeaderGroupComponent: innerHeaderGroupComponent, isLoadingInnerComponent: isLoadingInnerComponent } = this;
        const hasInnerComponent = innerHeaderGroupComponent || isLoadingInnerComponent;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(displayName) && !hasInnerComponent) this.agLabel.textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(displayName);
        this.toggleCss("ag-sticky-label", !columnGroup.getColGroupDef()?.suppressStickyLabel);
    }
    destroy() {
        super.destroy();
        if (this.innerHeaderGroupComponent) {
            this.destroyBean(this.innerHeaderGroupComponent);
            this.innerHeaderGroupComponent = void 0;
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/headerModule.ts
var $437b23f6a393c3bf$var$ColumnHeaderCompModule = {
    moduleName: "ColumnHeaderComp",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agColumnHeader: $437b23f6a393c3bf$export$266cd3930df0b35d
    },
    icons: {
        // button to launch legacy column menu
        menu: "menu",
        // button to launch new enterprise column menu
        menuAlt: "menu-alt"
    }
};
var $437b23f6a393c3bf$var$ColumnGroupHeaderCompModule = {
    moduleName: "ColumnGroupHeaderComp",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agColumnGroupHeader: $437b23f6a393c3bf$var$HeaderGroupComp
    },
    icons: {
        // header column group shown when expanded (click to contract)
        columnGroupOpened: "expanded",
        // header column group shown when contracted (click to expand)
        columnGroupClosed: "contracted"
    }
};
// packages/ag-grid-community/src/misc/animationFrameService.ts
var $437b23f6a393c3bf$var$AnimationFrameService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "animationFrameSvc";
        // p1 and p2 are create tasks are to do with row and cell creation.
        // for them we want to execute according to row order, so we use
        // TaskItem so we know what index the item is for.
        this.p1 = {
            list: [],
            sorted: false
        };
        // eg drawing back-ground of rows
        this.p2 = {
            list: [],
            sorted: false
        };
        // eg cell renderers, adding hover functionality
        this.f1 = {
            list: [],
            sorted: false
        };
        // eg framework cell renderers
        // destroy tasks are to do with row removal. they are done after row creation as the user will need to see new
        // rows first (as blank is scrolled into view), when we remove the old rows (no longer in view) is not as
        // important.
        this.destroyTasks = [];
        this.ticking = false;
        // we need to know direction of scroll, to build up rows in the direction of
        // the scroll. eg if user scrolls down, we extend the rows by building down.
        this.scrollGoingDown = true;
        this.lastScrollTop = 0;
        this.taskCount = 0;
    }
    setScrollTop(scrollTop) {
        this.scrollGoingDown = scrollTop >= this.lastScrollTop;
        if (scrollTop === 0) this.scrollGoingDown = true;
        this.lastScrollTop = scrollTop;
    }
    postConstruct() {
        this.active = !this.gos.get("suppressAnimationFrame");
        this.batchFrameworkComps = this.beans.frameworkOverrides.batchFrameworkComps;
    }
    // this method is for our AG Grid sanity only - if animation frames are turned off,
    // then no place in the code should be looking to add any work to be done in animation
    // frames. this stops bugs - where some code is asking for a frame to be executed
    // when it should not.
    verify() {
        if (this.active === false) $437b23f6a393c3bf$export$545083624300f13d(92);
    }
    createTask(task, index, list, isFramework, isDeferred = false) {
        this.verify();
        let taskList = list;
        if (isFramework && this.batchFrameworkComps) taskList = "f1";
        const taskItem = {
            task: task,
            index: index,
            createOrder: ++this.taskCount,
            deferred: isDeferred
        };
        this.addTaskToList(this[taskList], taskItem);
        this.schedule();
    }
    addTaskToList(taskList, task) {
        taskList.list.push(task);
        taskList.sorted = false;
    }
    sortTaskList(taskList) {
        if (taskList.sorted) return;
        const sortDirection = this.scrollGoingDown ? 1 : -1;
        taskList.list.sort((a, b)=>{
            if (a.deferred !== b.deferred) return a.deferred ? -1 : 1;
            if (a.index !== b.index) return sortDirection * (b.index - a.index);
            return b.createOrder - a.createOrder;
        });
        taskList.sorted = true;
    }
    addDestroyTask(task) {
        this.verify();
        this.destroyTasks.push(task);
        this.schedule();
    }
    executeFrame(millis) {
        const { p1: p1, p2: p2, f1: f1, destroyTasks: destroyTasks, beans: beans } = this;
        const { ctrlsSvc: ctrlsSvc, frameworkOverrides: frameworkOverrides } = beans;
        const p1Tasks = p1.list;
        const p2Tasks = p2.list;
        const f1Tasks = f1.list;
        const frameStart = Date.now();
        let duration = 0;
        const noMaxMillis = millis <= 0;
        const scrollFeature = ctrlsSvc.getScrollFeature();
        while(noMaxMillis || duration < millis){
            const gridBodyDidSomething = scrollFeature.scrollGridIfNeeded();
            if (!gridBodyDidSomething) {
                let task;
                if (p1Tasks.length) {
                    this.sortTaskList(p1);
                    task = p1Tasks.pop().task;
                } else if (p2Tasks.length) {
                    this.sortTaskList(p2);
                    task = p2Tasks.pop().task;
                } else if (f1Tasks.length) {
                    frameworkOverrides.wrapOutgoing(()=>{
                        while(noMaxMillis || duration < millis){
                            const gridBodyDidSomething2 = scrollFeature.scrollGridIfNeeded();
                            if (!gridBodyDidSomething2) {
                                if (f1Tasks.length) {
                                    this.sortTaskList(f1);
                                    task = f1Tasks.pop().task;
                                    task();
                                } else break;
                            } else break;
                            duration = Date.now() - frameStart;
                        }
                    });
                    task = ()=>{};
                } else if (destroyTasks.length) task = destroyTasks.pop();
                else break;
                task();
            }
            duration = Date.now() - frameStart;
        }
        if (p1Tasks.length || p2Tasks.length || f1Tasks.length || destroyTasks.length) this.requestFrame();
        else this.ticking = false;
    }
    flushAllFrames() {
        if (!this.active) return;
        this.executeFrame(-1);
    }
    schedule() {
        if (!this.active) return;
        if (!this.ticking) {
            this.ticking = true;
            this.requestFrame();
        }
    }
    requestFrame() {
        const callback = this.executeFrame.bind(this, 60);
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, callback);
    }
    isQueueEmpty() {
        return !this.ticking;
    }
};
// packages/ag-grid-community/src/misc/animationFrameModule.ts
var $437b23f6a393c3bf$var$AnimationFrameModule = {
    moduleName: "AnimationFrame",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AnimationFrameService
    ]
};
// packages/ag-grid-community/src/misc/iconService.ts
var $437b23f6a393c3bf$var$IconService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "iconSvc";
    }
    createIconNoSpan(iconName, params) {
        return $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, params?.column);
    }
};
// packages/ag-grid-community/src/misc/touchService.ts
var $437b23f6a393c3bf$var$TouchService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "touchSvc";
    }
    mockBodyContextMenu(ctrl, listener) {
        this.mockContextMenu(ctrl, ctrl.eBodyViewport, listener);
    }
    mockHeaderContextMenu(ctrl, listener) {
        this.mockContextMenu(ctrl, ctrl.eGui, listener);
    }
    mockRowContextMenu(ctrl) {
        if (!$437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        const listener = (mouseListener, touch, touchEvent)=>{
            const { rowCtrl: rowCtrl, cellCtrl: cellCtrl } = ctrl.getControlsForEventTarget(touchEvent?.target ?? null);
            if (cellCtrl?.column) cellCtrl.dispatchCellContextMenuEvent(touchEvent ?? null);
            this.beans.contextMenuSvc?.handleContextMenuMouseEvent(void 0, touchEvent, rowCtrl, cellCtrl);
        };
        this.mockContextMenu(ctrl, ctrl.element, listener);
    }
    handleCellDoubleClick(ctrl, mouseEvent) {
        const isDoubleClickOnIPad = ()=>{
            if (!$437b23f6a393c3bf$export$6b6034a68325bd8a() || $437b23f6a393c3bf$var$_isEventSupported("dblclick")) return false;
            const nowMillis = Date.now();
            const res = nowMillis - ctrl.lastIPadMouseClickEvent < 200;
            ctrl.lastIPadMouseClickEvent = nowMillis;
            return res;
        };
        if (isDoubleClickOnIPad()) {
            ctrl.onCellDoubleClicked(mouseEvent);
            mouseEvent.preventDefault();
            return true;
        }
        return false;
    }
    setupForHeader(comp) {
        const { gos: gos, sortSvc: sortSvc, menuSvc: menuSvc } = this.beans;
        if (gos.get("suppressTouch")) return;
        const { params: params, eMenu: eMenu, eFilterButton: eFilterButton } = comp;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(comp.getGui(), true);
        comp.addDestroyFunc(()=>touchListener.destroy());
        const suppressMenuHide = comp.shouldSuppressMenuHide();
        const tapMenuButton = suppressMenuHide && $437b23f6a393c3bf$export$25d27f17d3af40f7(eMenu) && params.enableMenu;
        let menuTouchListener = touchListener;
        if (tapMenuButton) {
            menuTouchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(eMenu, true);
            comp.addDestroyFunc(()=>menuTouchListener.destroy());
        }
        if (params.enableMenu || menuSvc?.isHeaderContextMenuEnabled(params.column)) {
            const eventType = tapMenuButton ? "tap" : "longTap";
            const showMenuFn = (event)=>params.showColumnMenuAfterMouseClick(event.touchStart);
            comp.addManagedListeners(menuTouchListener, {
                [eventType]: showMenuFn
            });
            comp.addManagedListeners(touchListener, {
                longTap: showMenuFn
            });
        }
        if (params.enableSorting) {
            const tapListener = (event)=>{
                const target = event.touchStart.target;
                if (suppressMenuHide && (eMenu?.contains(target) || eFilterButton?.contains(target))) return;
                sortSvc?.progressSort(params.column, false, "uiColumnSorted");
            };
            comp.addManagedListeners(touchListener, {
                tap: tapListener
            });
        }
        if (params.enableFilterButton && eFilterButton) {
            const filterButtonTouchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(eFilterButton, true);
            comp.addManagedListeners(filterButtonTouchListener, {
                tap: ()=>params.showFilter(eFilterButton)
            });
            comp.addDestroyFunc(()=>filterButtonTouchListener.destroy());
        }
    }
    setupForHeaderGroup(comp) {
        const params = comp.params;
        if (this.beans.menuSvc?.isHeaderContextMenuEnabled(params.columnGroup.getProvidedColumnGroup())) {
            const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(params.eGridHeader, true);
            const showMenuFn = (event)=>params.showColumnMenuAfterMouseClick(event.touchStart);
            comp.addManagedListeners(touchListener, {
                longTap: showMenuFn
            });
            comp.addDestroyFunc(()=>touchListener.destroy());
        }
    }
    setupForHeaderGroupElement(comp, eElement, action) {
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(eElement, true);
        comp.addManagedListeners(touchListener, {
            tap: action
        });
        comp.addDestroyFunc(()=>touchListener.destroy());
    }
    mockContextMenu(ctrl, element, listener) {
        if (!$437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(element);
        const longTapListener = (event)=>{
            if (!$437b23f6a393c3bf$var$_isEventFromThisInstance(this.beans, event.touchEvent)) return;
            listener(void 0, event.touchStart, event.touchEvent);
        };
        ctrl.addManagedListeners(touchListener, {
            longTap: longTapListener
        });
        ctrl.addDestroyFunc(()=>touchListener.destroy());
    }
};
// packages/ag-grid-community/src/misc/touchModule.ts
var $437b23f6a393c3bf$var$TouchModule = {
    moduleName: "Touch",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$TouchService
    ]
};
// packages/ag-grid-community/src/navigation/cellNavigationService.ts
var $437b23f6a393c3bf$var$CellNavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellNavigation";
    }
    wireBeans(beans) {
        this.rowSpanSvc = beans.rowSpanSvc;
    }
    // returns null if no cell to focus on, ie at the end of the grid
    getNextCellToFocus(key, focusedCell, ctrlPressed = false) {
        if (ctrlPressed) return this.getNextCellToFocusWithCtrlPressed(key, focusedCell);
        return this.getNextCellToFocusWithoutCtrlPressed(key, focusedCell);
    }
    getNextCellToFocusWithCtrlPressed(key, focusedCell) {
        const upKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP;
        const downKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        const leftKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT;
        let column;
        let rowIndex;
        const { pageBounds: pageBounds, gos: gos, visibleCols: visibleCols, pinnedRowModel: pinnedRowModel } = this.beans;
        const { rowPinned: rowPinned } = focusedCell;
        if (upKey || downKey) {
            if (rowPinned && pinnedRowModel) {
                if (upKey) rowIndex = 0;
                else rowIndex = rowPinned === "top" ? pinnedRowModel.getPinnedTopRowCount() - 1 : pinnedRowModel.getPinnedBottomRowCount() - 1;
            } else rowIndex = upKey ? pageBounds.getFirstRow() : pageBounds.getLastRow();
            column = focusedCell.column;
        } else {
            const isRtl = gos.get("enableRtl");
            rowIndex = focusedCell.rowIndex;
            const allColumns = leftKey !== isRtl ? visibleCols.allCols : [
                ...visibleCols.allCols
            ].reverse();
            column = allColumns.find((col)=>this.isCellGoodToFocusOn({
                    rowIndex: rowIndex,
                    rowPinned: null,
                    column: col
                }));
        }
        return column ? {
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column
        } : null;
    }
    getNextCellToFocusWithoutCtrlPressed(key, focusedCell) {
        let pointer = focusedCell;
        let finished = false;
        while(!finished){
            switch(key){
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                    pointer = this.getCellAbove(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                    pointer = this.getCellBelow(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                    pointer = this.gos.get("enableRtl") ? this.getCellToLeft(pointer) : this.getCellToRight(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                    pointer = this.gos.get("enableRtl") ? this.getCellToRight(pointer) : this.getCellToLeft(pointer);
                    break;
                default:
                    pointer = null;
                    $437b23f6a393c3bf$export$545083624300f13d(8, {
                        key: key
                    });
                    break;
            }
            if (pointer) finished = this.isCellGoodToFocusOn(pointer);
            else finished = true;
        }
        return pointer;
    }
    isCellGoodToFocusOn(gridCell) {
        const column = gridCell.column;
        let rowNode;
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        switch(gridCell.rowPinned){
            case "top":
                rowNode = pinnedRowModel?.getPinnedTopRow(gridCell.rowIndex);
                break;
            case "bottom":
                rowNode = pinnedRowModel?.getPinnedBottomRow(gridCell.rowIndex);
                break;
            default:
                rowNode = rowModel.getRow(gridCell.rowIndex);
                break;
        }
        if (!rowNode) return false;
        const suppressNavigable = this.isSuppressNavigable(column, rowNode);
        return !suppressNavigable;
    }
    getCellToLeft(lastCell) {
        if (!lastCell) return null;
        const colToLeft = this.beans.visibleCols.getColBefore(lastCell.column);
        if (!colToLeft) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToLeft,
            rowPinned: lastCell.rowPinned
        };
    }
    getCellToRight(lastCell) {
        if (!lastCell) return null;
        const colToRight = this.beans.visibleCols.getColAfter(lastCell.column);
        if (!colToRight) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToRight,
            rowPinned: lastCell.rowPinned
        };
    }
    getCellBelow(lastCell) {
        if (!lastCell) return null;
        const adjustedLastCell = this.rowSpanSvc?.getCellEnd(lastCell) ?? lastCell;
        const rowBelow = $437b23f6a393c3bf$export$3077f3bcabdc5ad1(this.beans, adjustedLastCell, true);
        if (rowBelow) return {
            rowIndex: rowBelow.rowIndex,
            column: lastCell.column,
            rowPinned: rowBelow.rowPinned
        };
        return null;
    }
    getCellAbove(lastCell) {
        if (!lastCell) return null;
        const adjustedLastCell = this.rowSpanSvc?.getCellStart(lastCell) ?? lastCell;
        const rowAbove = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, {
            rowIndex: adjustedLastCell.rowIndex,
            rowPinned: adjustedLastCell.rowPinned
        }, true);
        if (rowAbove) return {
            rowIndex: rowAbove.rowIndex,
            column: lastCell.column,
            rowPinned: rowAbove.rowPinned
        };
        return null;
    }
    getNextTabbedCell(gridCell, backwards) {
        if (backwards) return this.getNextTabbedCellBackwards(gridCell);
        return this.getNextTabbedCellForwards(gridCell);
    }
    getNextTabbedCellForwards(gridCell) {
        const { visibleCols: visibleCols, pagination: pagination } = this.beans;
        const displayedColumns = visibleCols.allCols;
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = visibleCols.getColAfter(gridCell.column);
        if (!newColumn) {
            newColumn = displayedColumns[0];
            const rowBelow = $437b23f6a393c3bf$export$3077f3bcabdc5ad1(this.beans, gridCell, true);
            if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowBelow)) return null;
            if (!rowBelow.rowPinned && !(pagination?.isRowInPage(rowBelow.rowIndex) ?? true)) return null;
            newRowIndex = rowBelow ? rowBelow.rowIndex : null;
            newFloating = rowBelow ? rowBelow.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
    getNextTabbedCellBackwards(gridCell) {
        const { beans: beans } = this;
        const { visibleCols: visibleCols, pagination: pagination } = beans;
        const displayedColumns = visibleCols.allCols;
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = visibleCols.getColBefore(gridCell.column);
        if (!newColumn) {
            newColumn = $437b23f6a393c3bf$export$236389741107357f(displayedColumns);
            const rowAbove = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(beans, {
                rowIndex: gridCell.rowIndex,
                rowPinned: gridCell.rowPinned
            }, true);
            if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowAbove)) return null;
            if (!rowAbove.rowPinned && !(pagination?.isRowInPage(rowAbove.rowIndex) ?? true)) return null;
            newRowIndex = rowAbove ? rowAbove.rowIndex : null;
            newFloating = rowAbove ? rowAbove.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
    isSuppressNavigable(column, rowNode) {
        const { suppressNavigable: suppressNavigable } = column.colDef;
        if (typeof suppressNavigable === "boolean") return suppressNavigable;
        if (typeof suppressNavigable === "function") {
            const params = column.createColumnFunctionCallbackParams(rowNode);
            const userFunc = suppressNavigable;
            return userFunc(params);
        }
        return false;
    }
};
// packages/ag-grid-community/src/navigation/navigationApi.ts
function $437b23f6a393c3bf$var$getFocusedCell(beans) {
    return beans.focusSvc.getFocusedCell();
}
function $437b23f6a393c3bf$var$clearFocusedCell(beans) {
    return beans.focusSvc.clearFocusedCell();
}
function $437b23f6a393c3bf$var$setFocusedCell(beans, rowIndex, colKey, rowPinned) {
    beans.focusSvc.setFocusedCell({
        rowIndex: rowIndex,
        column: colKey,
        rowPinned: rowPinned,
        forceBrowserFocus: true
    });
}
function $437b23f6a393c3bf$var$tabToNextCell(beans, event) {
    return beans.navigation?.tabToNextCell(false, event) ?? false;
}
function $437b23f6a393c3bf$var$tabToPreviousCell(beans, event) {
    return beans.navigation?.tabToNextCell(true, event) ?? false;
}
function $437b23f6a393c3bf$var$setFocusedHeader(beans, colKey, floatingFilter = false) {
    const headerPosition = beans.headerNavigation?.getHeaderPositionForColumn(colKey, floatingFilter);
    if (!headerPosition) return;
    beans.focusSvc.focusHeaderPosition({
        headerPosition: headerPosition
    });
}
// packages/ag-grid-community/src/edit/editModelService.ts
var $437b23f6a393c3bf$var$EditModelService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "editModelSvc";
        this.edits = /* @__PURE__ */ new Map();
        this.cellValidations = new $437b23f6a393c3bf$var$EditCellValidationModel();
        this.rowValidations = new $437b23f6a393c3bf$var$EditRowValidationModel();
        // during some operations, we want to always return false from `hasEdits`
        this.suspendEdits = false;
    }
    suspend(suspend) {
        this.suspendEdits = suspend;
    }
    removeEdits({ rowNode: rowNode, column: column }) {
        if (!this.hasEdits({
            rowNode: rowNode
        }) || !rowNode) return;
        const editRow = this.getEditRow(rowNode);
        if (column) editRow.delete(column);
        else editRow.clear();
        if (editRow.size === 0) this.edits.delete(rowNode);
    }
    getEditRow(rowNode, params = {}) {
        if (this.suspendEdits) return void 0;
        if (this.edits.size === 0) return void 0;
        const edits = rowNode && this.edits.get(rowNode);
        if (edits) return edits;
        if (params.checkSiblings) {
            const pinnedSibling = rowNode.pinnedSibling;
            if (pinnedSibling) return this.getEditRow(pinnedSibling);
        }
        return void 0;
    }
    getEditRowDataValue(rowNode, { checkSiblings: checkSiblings } = {}) {
        if (!rowNode || this.edits.size === 0) return void 0;
        const editRow = this.getEditRow(rowNode);
        const pinnedSibling = rowNode.pinnedSibling;
        const siblingRow = checkSiblings && pinnedSibling && this.getEditRow(pinnedSibling);
        if (!editRow && !siblingRow) return void 0;
        const data = Object.assign({}, rowNode.data);
        const applyEdits = (edits, data2)=>edits.forEach(({ pendingValue: pendingValue }, column)=>{
                if (pendingValue !== $437b23f6a393c3bf$var$UNEDITED) data2[column.getColId()] = pendingValue;
            });
        if (editRow) applyEdits(editRow, data);
        if (siblingRow) applyEdits(siblingRow, data);
        return data;
    }
    getEdit(position, copy) {
        const edit = this._getEdit(position);
        return copy && edit ? {
            ...edit
        } : edit;
    }
    _getEdit(position) {
        if (this.suspendEdits) return void 0;
        if (this.edits.size === 0) return void 0;
        return position.rowNode && position.column && this.getEditRow(position.rowNode)?.get(position.column);
    }
    getEditMap(copy = true) {
        if (this.suspendEdits || this.edits.size === 0) return /* @__PURE__ */ new Map();
        if (!copy) return this.edits;
        const map = /* @__PURE__ */ new Map();
        this.edits.forEach((editRow, rowNode)=>{
            const newEditRow = /* @__PURE__ */ new Map();
            editRow.forEach(({ editorState: _, ...cellData }, column)=>// Ensure we copy the cell data to avoid reference issues
                newEditRow.set(column, {
                    ...cellData
                }));
            map.set(rowNode, newEditRow);
        });
        return map;
    }
    setEditMap(newEdits) {
        this.edits.clear();
        newEdits.forEach((editRow, rowNode)=>{
            const newRow = /* @__PURE__ */ new Map();
            editRow.forEach((cellData, column)=>// Ensure we copy the cell data to avoid reference issues
                newRow.set(column, {
                    ...cellData
                }));
            this.edits.set(rowNode, newRow);
        });
    }
    setEdit(position, edit) {
        (this.edits.size === 0 || !this.edits.has(position.rowNode)) && this.edits.set(position.rowNode, /* @__PURE__ */ new Map());
        const currentEdit = this._getEdit(position);
        const updatedEdit = Object.assign({
            editorState: {
                isCancelAfterEnd: void 0,
                isCancelBeforeStart: void 0
            },
            ...currentEdit,
            ...edit
        });
        this.getEditRow(position.rowNode).set(position.column, updatedEdit);
        return updatedEdit;
    }
    clearEditValue(position) {
        const { rowNode: rowNode, column: column } = position;
        if (rowNode) {
            if (column) {
                const edit = this._getEdit(position);
                if (edit) {
                    edit.editorValue = void 0;
                    edit.pendingValue = edit.sourceValue;
                    edit.state = "changed";
                }
            } else this.getEditRow(rowNode)?.forEach((cellData)=>{
                cellData.editorValue = void 0;
                cellData.pendingValue = cellData.sourceValue;
                cellData.state = "changed";
            });
        }
    }
    getState(position) {
        if (this.suspendEdits) return void 0;
        return this.getEdit(position)?.state;
    }
    getEditPositions(editMap) {
        if (this.suspendEdits || (editMap ?? this.edits).size === 0) return [];
        const positions = [];
        (editMap ?? this.edits).forEach((editRow, rowNode)=>{
            for (const column of editRow.keys()){
                const { editorState: _, ...rest } = editRow.get(column);
                positions.push({
                    rowNode: rowNode,
                    column: column,
                    ...rest
                });
            }
        });
        return positions;
    }
    hasRowEdits(rowNode, params) {
        if (this.suspendEdits) return false;
        if (this.edits.size === 0) return false;
        const rowEdits = this.getEditRow(rowNode, params);
        return !!rowEdits;
    }
    hasEdits(position = {}, params = {}) {
        if (this.suspendEdits) return false;
        if (this.edits.size === 0) return false;
        const { rowNode: rowNode, column: column } = position;
        const { withOpenEditor: withOpenEditor } = params;
        if (rowNode) {
            const rowEdits = this.getEditRow(rowNode, params);
            if (!rowEdits) return false;
            if (column) {
                if (withOpenEditor) return this.getEdit(position)?.state === "editing";
                return rowEdits.has(column) ?? false;
            }
            if (rowEdits.size !== 0) {
                if (withOpenEditor) return Array.from(rowEdits.values()).some(({ state: state })=>state === "editing");
                return true;
            }
            return false;
        }
        if (withOpenEditor) return this.getEditPositions().some(({ state: state })=>state === "editing");
        return this.edits.size > 0;
    }
    start(position) {
        const map = this.getEditRow(position.rowNode) ?? /* @__PURE__ */ new Map();
        const { rowNode: rowNode, column: column } = position;
        if (column && !map.has(column)) map.set(column, {
            editorValue: void 0,
            pendingValue: $437b23f6a393c3bf$var$UNEDITED,
            sourceValue: this.beans.valueSvc.getValue(column, rowNode, false, "api"),
            state: "editing",
            editorState: {
                isCancelAfterEnd: void 0,
                isCancelBeforeStart: void 0
            }
        });
        this.edits.set(rowNode, map);
    }
    stop(position) {
        if (!this.hasEdits(position)) return;
        if (position) this.removeEdits(position);
        else this.clear();
    }
    clear() {
        for (const pendingRowEdits of this.edits.values())pendingRowEdits.clear();
        this.edits.clear();
    }
    getCellValidationModel() {
        return this.cellValidations;
    }
    getRowValidationModel() {
        return this.rowValidations;
    }
    setCellValidationModel(model) {
        this.cellValidations = model;
    }
    setRowValidationModel(model) {
        this.rowValidations = model;
    }
    destroy() {
        super.destroy();
        this.clear();
    }
};
var $437b23f6a393c3bf$var$EditCellValidationModel = class {
    constructor(){
        this.cellValidations = /* @__PURE__ */ new Map();
    }
    getCellValidation(position) {
        const { rowNode: rowNode, column: column } = position || {};
        return this.cellValidations?.get(rowNode)?.get(column);
    }
    hasCellValidation(position) {
        if (!position?.rowNode || !position.column) return this.cellValidations.size > 0;
        return !!this.getCellValidation(position);
    }
    setCellValidation(position, validation) {
        const { rowNode: rowNode, column: column } = position;
        if (!this.cellValidations.has(rowNode)) this.cellValidations.set(rowNode, /* @__PURE__ */ new Map());
        this.cellValidations.get(rowNode).set(column, validation);
    }
    clearCellValidation(position) {
        const { rowNode: rowNode, column: column } = position;
        this.cellValidations.get(rowNode)?.delete(column);
    }
    setCellValidationMap(validationMap) {
        this.cellValidations = validationMap;
    }
    getCellValidationMap() {
        return this.cellValidations;
    }
    clearCellValidationMap() {
        this.cellValidations.clear();
    }
};
var $437b23f6a393c3bf$var$EditRowValidationModel = class {
    constructor(){
        this.rowValidations = /* @__PURE__ */ new Map();
    }
    getRowValidation(position) {
        const { rowNode: rowNode } = position || {};
        return this.rowValidations.get(rowNode);
    }
    hasRowValidation(position) {
        if (!position?.rowNode) return this.rowValidations.size > 0;
        return !!this.getRowValidation(position);
    }
    setRowValidation({ rowNode: rowNode }, rowValidation) {
        this.rowValidations.set(rowNode, rowValidation);
    }
    clearRowValidation({ rowNode: rowNode }) {
        this.rowValidations.delete(rowNode);
    }
    setRowValidationMap(validationMap) {
        this.rowValidations = validationMap;
    }
    getRowValidationMap() {
        return this.rowValidations;
    }
    clearRowValidationMap() {
        this.rowValidations.clear();
    }
};
// packages/ag-grid-community/src/edit/utils/controllers.ts
function $437b23f6a393c3bf$var$_getRowCtrl(beans, inputs = {}) {
    const { rowIndex: rowIndex, rowId: rowId, rowCtrl: rowCtrl, rowPinned: rowPinned } = inputs;
    if (rowCtrl) return rowCtrl;
    const { rowModel: rowModel, rowRenderer: rowRenderer } = beans;
    let { rowNode: rowNode } = inputs;
    if (!rowNode) {
        if (rowId) rowNode = $437b23f6a393c3bf$var$_getRowById(beans, rowId, rowPinned);
        else if (rowIndex != null) rowNode = rowModel.getRow(rowIndex);
    }
    return rowRenderer.getRowCtrls(rowNode ? [
        rowNode
    ] : [])?.[0];
}
function $437b23f6a393c3bf$var$_getCellCtrl(beans, inputs = {}) {
    const { cellCtrl: cellCtrl, colId: colId, columnId: columnId, column: column } = inputs;
    if (cellCtrl) return cellCtrl;
    const actualColumn = beans.colModel.getCol(colId ?? columnId ?? $437b23f6a393c3bf$var$_getColId(column));
    const rowCtrl = inputs.rowCtrl ?? $437b23f6a393c3bf$var$_getRowCtrl(beans, inputs);
    const result = rowCtrl?.getCellCtrl(actualColumn) ?? void 0;
    if (result) return result;
    const rowNode = inputs.rowNode ?? rowCtrl?.rowNode;
    if (rowNode) return beans.rowRenderer.getCellCtrls([
        rowNode
    ], [
        actualColumn
    ])?.[0];
    return void 0;
}
function $437b23f6a393c3bf$var$_stopEditing(beans) {
    const { editSvc: editSvc } = beans;
    if (editSvc?.isBatchEditing()) {
        $437b23f6a393c3bf$var$_syncFromEditors(beans, {
            persist: true
        });
        $437b23f6a393c3bf$var$_destroyEditors(beans);
    } else editSvc?.stopEditing(void 0, {
        source: "api"
    });
}
function $437b23f6a393c3bf$var$_addStopEditingWhenGridLosesFocus(bean, beans, viewports) {
    const { gos: gos, popupSvc: popupSvc } = beans;
    if (!gos.get("stopEditingWhenCellsLoseFocus")) return;
    const focusOutListener = (event)=>{
        const elementWithFocus = event.relatedTarget;
        if ($437b23f6a393c3bf$var$_getTabIndex(elementWithFocus) === null) {
            $437b23f6a393c3bf$var$_stopEditing(beans);
            return;
        }
        let clickInsideGrid = // see if click came from inside the viewports
        viewports.some((viewport)=>viewport.contains(elementWithFocus)) && // and also that it's not from a detail grid
        gos.isElementInThisInstance(elementWithFocus);
        if (!clickInsideGrid) clickInsideGrid = !!popupSvc && (popupSvc.getActivePopups().some((popup)=>popup.contains(elementWithFocus)) || popupSvc.isElementWithinCustomPopup(elementWithFocus));
        if (!clickInsideGrid) $437b23f6a393c3bf$var$_stopEditing(beans);
    };
    for (const viewport of viewports)bean.addManagedElementListeners(viewport, {
        focusout: focusOutListener
    });
}
function $437b23f6a393c3bf$var$_getColId(column) {
    if (!column) return void 0;
    if (typeof column === "string") return column;
    return column.getColId();
}
// packages/ag-grid-community/src/edit/utils/editors.ts
var $437b23f6a393c3bf$var$UNEDITED = Symbol("unedited");
function $437b23f6a393c3bf$var$getCellEditorInstanceMap(beans, params = {}) {
    const res = [];
    const ctrls = beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns);
    for (const ctrl of ctrls){
        const cellEditor = ctrl.comp?.getCellEditor();
        if (cellEditor) res.push({
            ctrl: ctrl,
            editor: $437b23f6a393c3bf$export$213d4c63c3df47e4(cellEditor)
        });
    }
    return res;
}
var $437b23f6a393c3bf$var$getCellEditorInstances = (beans, params = {})=>$437b23f6a393c3bf$var$getCellEditorInstanceMap(beans, params).map((res)=>res.editor);
function $437b23f6a393c3bf$var$_setupEditors(beans, editingCells, position, key, event, cellStartedEdit) {
    if (editingCells.length === 0 && position?.rowNode && position?.column) $437b23f6a393c3bf$var$_setupEditor(beans, position, {
        key: key,
        event: event,
        cellStartedEdit: cellStartedEdit
    });
    const { valueSvc: valueSvc, editSvc: editSvc, editModelSvc: editModelSvc } = beans;
    const { rowNode: rowNode, column: column } = position ?? {};
    for (const cellPosition of editingCells){
        const { rowNode: cellRowNode, column: cellColumn } = cellPosition;
        const curCellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, cellPosition);
        if (!curCellCtrl) {
            if (cellRowNode && cellColumn) {
                const oldValue = valueSvc.getValue(cellColumn, cellRowNode, void 0, "api");
                const isNewValueCell = position?.rowNode === cellRowNode && position?.column === cellColumn;
                const cellStartValue = isNewValueCell && key || void 0;
                const newValue = cellStartValue ?? editSvc?.getCellDataValue(cellPosition, false) ?? valueSvc.getValueForDisplay({
                    column: cellColumn,
                    node: cellRowNode
                })?.value ?? oldValue ?? $437b23f6a393c3bf$var$UNEDITED;
                editModelSvc?.setEdit(cellPosition, {
                    pendingValue: $437b23f6a393c3bf$var$getNormalisedFormula(beans, newValue, false, cellColumn),
                    sourceValue: oldValue,
                    state: "editing"
                });
            }
            continue;
        }
        const shouldStartEditing2 = cellStartedEdit && rowNode === curCellCtrl.rowNode && curCellCtrl.column === column;
        $437b23f6a393c3bf$var$_setupEditor(beans, {
            rowNode: rowNode,
            column: curCellCtrl.column
        }, {
            key: shouldStartEditing2 ? key : null,
            event: shouldStartEditing2 ? event : null,
            cellStartedEdit: shouldStartEditing2 && cellStartedEdit
        });
    }
}
function $437b23f6a393c3bf$var$_sourceAndPendingDiffer({ pendingValue: pendingValue, sourceValue: sourceValue }) {
    if (pendingValue === $437b23f6a393c3bf$var$UNEDITED) pendingValue = sourceValue;
    return pendingValue !== sourceValue;
}
function $437b23f6a393c3bf$var$_setupEditor(beans, position, params) {
    const { key: key, event: event, cellStartedEdit: cellStartedEdit, silent: silent } = params ?? {};
    const { editModelSvc: editModelSvc, editSvc: editSvc, gos: gos, userCompFactory: userCompFactory } = beans;
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
    const editorComp = cellCtrl?.comp?.getCellEditor();
    const editorParams = $437b23f6a393c3bf$var$_createEditorParams(beans, position, key, cellStartedEdit && !silent);
    const isAllowFormula = position.column.isAllowFormula();
    const previousEdit = editModelSvc?.getEdit(position);
    const newValue = editorParams.value ?? previousEdit?.sourceValue;
    if (editorComp) {
        editModelSvc?.setEdit(position, {
            editorValue: $437b23f6a393c3bf$var$getNormalisedFormula(beans, newValue, true, position.column),
            state: "editing"
        });
        editorComp.refresh?.(editorParams);
        return;
    }
    const colDef = position.column.getColDef();
    const compDetails = $437b23f6a393c3bf$var$_getCellEditorDetails(userCompFactory, isAllowFormula ? {
        ...colDef,
        cellEditor: "agTextCellEditor"
    } : colDef, editorParams);
    if (!compDetails) return;
    const { popupFromSelector: popupFromSelector, popupPositionFromSelector: popupPositionFromSelector } = compDetails;
    const popup = popupFromSelector ?? !!colDef.cellEditorPopup;
    const popupLocation = popupPositionFromSelector ?? colDef.cellEditorPopupPosition;
    $437b23f6a393c3bf$var$checkAndPreventDefault(compDetails.params, event);
    if (!cellCtrl) return;
    const { rangeFeature: rangeFeature, rowCtrl: rowCtrl, comp: comp, onEditorAttachedFuncs: onEditorAttachedFuncs } = cellCtrl;
    editModelSvc?.setEdit(position, {
        editorValue: $437b23f6a393c3bf$var$getNormalisedFormula(beans, newValue, true, position.column),
        state: "editing"
    });
    cellCtrl.editCompDetails = compDetails;
    onEditorAttachedFuncs.push(()=>rangeFeature?.unsetComp());
    comp?.setEditDetails(compDetails, popup, popupLocation, gos.get("reactiveCustomComponents"));
    rowCtrl?.refreshRow({
        suppressFlash: true
    });
    const edit = editModelSvc?.getEdit(position, true);
    if (!silent && !edit?.editorState?.cellStartedEditing) {
        editSvc?.dispatchCellEvent(position, event, "cellEditingStarted", {
            value: newValue
        });
        editModelSvc?.setEdit(position, {
            editorState: {
                cellStartedEditing: true
            }
        });
    }
}
function $437b23f6a393c3bf$var$_valueFromEditor(beans, cellEditor, params) {
    const noValueResult = {
        editorValueExists: false
    };
    if ($437b23f6a393c3bf$var$_hasValidationRules(beans)) {
        const validationErrors = cellEditor.getValidationErrors?.();
        if ((validationErrors?.length ?? 0) > 0) return noValueResult;
    }
    if (params?.isCancelling) return noValueResult;
    if (params?.isStopping) {
        const isCancelAfterEnd = cellEditor?.isCancelAfterEnd?.();
        if (isCancelAfterEnd) return {
            ...noValueResult,
            isCancelAfterEnd: isCancelAfterEnd
        };
    }
    const editorValue = cellEditor.getValue();
    return {
        editorValue: editorValue,
        editorValueExists: true
    };
}
function $437b23f6a393c3bf$var$_createEditorParams(beans, position, key, cellStartedEdit) {
    const { valueSvc: valueSvc, gos: gos, editSvc: editSvc } = beans;
    const enableGroupEditing = beans.gos.get("enableGroupEdit");
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position);
    const rowIndex = position.rowNode?.rowIndex ?? void 0;
    const batchEdit = editSvc?.isBatchEditing();
    const agColumn = beans.colModel.getCol(position.column.getId());
    const { rowNode: rowNode, column: column } = position;
    const editor = cellCtrl.comp?.getCellEditor();
    const cellDataValue = editSvc?.getCellDataValue(position, false);
    const initialNewValue = cellDataValue === void 0 ? editor ? $437b23f6a393c3bf$var$_valueFromEditor(beans, editor)?.editorValue : void 0 : cellDataValue;
    const value = initialNewValue === $437b23f6a393c3bf$var$UNEDITED ? valueSvc.getValueForDisplay({
        column: agColumn,
        node: rowNode
    })?.value : initialNewValue;
    let paramsValue = enableGroupEditing ? initialNewValue : value;
    if (column.isAllowFormula() && beans.formula?.isFormula(paramsValue)) paramsValue = beans.formula?.normaliseFormula(paramsValue, true) ?? paramsValue;
    return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        value: paramsValue,
        eventKey: key ?? null,
        column: column,
        colDef: column.getColDef(),
        rowIndex: rowIndex,
        node: rowNode,
        data: rowNode.data,
        cellStartedEdit: cellStartedEdit ?? false,
        onKeyDown: cellCtrl?.onKeyDown.bind(cellCtrl),
        stopEditing: (suppressNavigateAfterEdit)=>{
            editSvc.stopEditing(position, {
                source: batchEdit ? "ui" : "api",
                suppressNavigateAfterEdit: suppressNavigateAfterEdit
            });
            $437b23f6a393c3bf$var$_destroyEditor(beans, position);
        },
        eGridCell: cellCtrl?.eGui,
        parseValue: (newValue)=>valueSvc.parseValue(agColumn, rowNode, newValue, cellCtrl?.value),
        formatValue: cellCtrl?.formatValue.bind(cellCtrl),
        validate: ()=>{
            editSvc?.validateEdit();
        }
    });
}
function $437b23f6a393c3bf$var$_purgeUnchangedEdits(beans, includeEditing) {
    const { editModelSvc: editModelSvc } = beans;
    editModelSvc?.getEditMap().forEach((editRow, rowNode)=>{
        editRow.forEach((edit, column)=>{
            if (!includeEditing && (edit.state === "editing" || edit.pendingValue === $437b23f6a393c3bf$var$UNEDITED)) return;
            if (!$437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit) && (edit.state !== "editing" || includeEditing)) editModelSvc?.removeEdits({
                rowNode: rowNode,
                column: column
            });
        });
    });
}
function $437b23f6a393c3bf$var$_refreshEditorOnColDefChanged(beans, cellCtrl) {
    const editor = cellCtrl.comp?.getCellEditor();
    if (!editor?.refresh) return;
    const { eventKey: eventKey, cellStartedEdit: cellStartedEdit } = cellCtrl.editCompDetails.params;
    const { column: column } = cellCtrl;
    const editorParams = $437b23f6a393c3bf$var$_createEditorParams(beans, cellCtrl, eventKey, cellStartedEdit);
    const colDef = column.getColDef();
    const compDetails = $437b23f6a393c3bf$var$_getCellEditorDetails(beans.userCompFactory, colDef, editorParams);
    editor.refresh($437b23f6a393c3bf$var$checkAndPreventDefault(compDetails.params, eventKey));
}
function $437b23f6a393c3bf$var$checkAndPreventDefault(params, event) {
    if (event instanceof KeyboardEvent && params.column.getColDef().cellEditor === "agNumberCellEditor") params.suppressPreventDefault = [
        "-",
        "+",
        ".",
        "e"
    ].includes(event?.key ?? "") || params.suppressPreventDefault;
    else event?.preventDefault?.();
    return params;
}
function $437b23f6a393c3bf$var$_syncFromEditors(beans, params) {
    for (const cellId of beans.editModelSvc?.getEditPositions() ?? []){
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, cellId);
        if (!cellCtrl) continue;
        const editor = cellCtrl.comp?.getCellEditor();
        if (!editor) continue;
        const { editorValue: editorValue, editorValueExists: editorValueExists, isCancelAfterEnd: isCancelAfterEnd } = $437b23f6a393c3bf$var$_valueFromEditor(beans, editor, params);
        if (isCancelAfterEnd) beans.editModelSvc?.setEdit(cellId, {
            editorState: {
                isCancelAfterEnd: isCancelAfterEnd
            }
        });
        $437b23f6a393c3bf$var$_syncFromEditor(beans, cellId, editorValue, void 0, !editorValueExists, params);
    }
}
function $437b23f6a393c3bf$var$_syncFromEditor(beans, position, editorValue, _source, valueSameAsSource, params) {
    const { editModelSvc: editModelSvc, valueSvc: valueSvc } = beans;
    if (!editModelSvc) return;
    const { rowNode: rowNode, column: column } = position;
    if (!(rowNode && column)) return;
    let edit = editModelSvc.getEdit(position, true);
    if (!edit?.sourceValue) {
        const editValue = {
            sourceValue: valueSvc.getValue(column, rowNode, void 0, "api"),
            pendingValue: edit ? $437b23f6a393c3bf$var$getNormalisedFormula(beans, edit.editorValue, false, column) : $437b23f6a393c3bf$var$UNEDITED
        };
        if (params?.persist) editValue.state = "changed";
        edit = editModelSvc.setEdit(position, editValue);
    }
    editModelSvc.setEdit(position, {
        editorValue: valueSameAsSource ? $437b23f6a393c3bf$var$getNormalisedFormula(beans, edit.sourceValue, true, column) : editorValue
    });
    if (params?.persist) $437b23f6a393c3bf$var$_persistEditorValue(beans, position);
}
function $437b23f6a393c3bf$var$getNormalisedFormula(beans, value, forEditing, column) {
    const { formula: formula } = beans;
    if (column.isAllowFormula() && formula?.isFormula(value)) return formula?.normaliseFormula(value, forEditing) ?? value;
    return value;
}
function $437b23f6a393c3bf$var$_persistEditorValue(beans, position) {
    const { editModelSvc: editModelSvc } = beans;
    const edit = editModelSvc?.getEdit(position, true);
    editModelSvc?.setEdit(position, {
        pendingValue: $437b23f6a393c3bf$var$getNormalisedFormula(beans, edit?.editorValue, false, position.column)
    });
}
function $437b23f6a393c3bf$var$_destroyEditors(beans, edits, params) {
    if (!edits) edits = beans.editModelSvc?.getEditPositions();
    for (const cellPosition of edits ?? [])$437b23f6a393c3bf$var$_destroyEditor(beans, cellPosition, params);
}
function $437b23f6a393c3bf$var$_destroyEditor(beans, position, params, cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, position)) {
    const enableGroupEditing = beans.gos.get("enableGroupEdit");
    const editModelSvc = beans.editModelSvc;
    const edit = editModelSvc?.getEdit(position, true);
    if (!cellCtrl) {
        if (edit) editModelSvc?.setEdit(position, {
            state: "changed"
        });
        return;
    }
    const comp = cellCtrl.comp;
    const cellEditor = comp?.getCellEditor();
    if (comp && !cellEditor) {
        cellCtrl?.refreshCell();
        if (edit) {
            editModelSvc?.setEdit(position, {
                state: "changed"
            });
            const args = enableGroupEditing ? $437b23f6a393c3bf$var$groupEditOverrides(params, edit) : {
                valueChanged: false,
                newValue: void 0,
                oldValue: edit.sourceValue
            };
            $437b23f6a393c3bf$var$dispatchEditingStopped(beans, position, args, params);
        }
        return;
    }
    if ($437b23f6a393c3bf$var$_hasValidationRules(beans)) {
        const errorMessages = edit && cellEditor?.getValidationErrors?.();
        const cellValidationModel = editModelSvc?.getCellValidationModel();
        if (errorMessages?.length) cellValidationModel?.setCellValidation(position, {
            errorMessages: errorMessages
        });
        else cellValidationModel?.clearCellValidation(position);
    }
    if (edit) editModelSvc?.setEdit(position, {
        state: "changed"
    });
    comp?.setEditDetails();
    comp?.refreshEditStyles(false, false);
    cellCtrl?.refreshCell({
        force: true,
        suppressFlash: true
    });
    const latest = editModelSvc?.getEdit(position);
    if (latest && latest.state === "changed") {
        const args = enableGroupEditing ? $437b23f6a393c3bf$var$groupEditOverrides(params, latest) : {
            valueChanged: $437b23f6a393c3bf$var$_sourceAndPendingDiffer(latest) && !params?.cancel,
            newValue: params?.cancel || latest.editorState.isCancelAfterEnd ? void 0 : latest?.editorValue ?? edit?.pendingValue,
            oldValue: latest?.sourceValue
        };
        $437b23f6a393c3bf$var$dispatchEditingStopped(beans, position, args, params);
    }
}
function $437b23f6a393c3bf$var$groupEditOverrides(params, latest) {
    return params?.cancel ? {
        valueChanged: false,
        oldValue: latest.sourceValue,
        newValue: void 0,
        value: latest.sourceValue
    } : {
        valueChanged: $437b23f6a393c3bf$var$_sourceAndPendingDiffer(latest),
        oldValue: latest.sourceValue,
        newValue: latest.pendingValue,
        value: latest.sourceValue
    };
}
function $437b23f6a393c3bf$var$dispatchEditingStopped(beans, position, args, { silent: silent, event: event } = {}) {
    const { editSvc: editSvc, editModelSvc: editModelSvc } = beans;
    const latest = editModelSvc?.getEdit(position);
    const { editorState: editorState } = latest || {};
    const { isCancelBeforeStart: isCancelBeforeStart } = editorState || {};
    if (!silent && !isCancelBeforeStart) {
        editSvc?.dispatchCellEvent(position, event, "cellEditingStopped", args);
        editModelSvc?.setEdit(position, {
            editorState: {
                cellStoppedEditing: true
            }
        });
    }
}
function $437b23f6a393c3bf$var$_hasValidationRules(beans) {
    const { gos: gos, colModel: colModel } = beans;
    const getFullRowEditValidationErrors = !!gos.get("getFullRowEditValidationErrors");
    const columnsHaveRules = colModel.getColumnDefs()?.filter((c)=>c.editable).some(({ cellEditorParams: cellEditorParams })=>{
        const { minLength: minLength, maxLength: maxLength, getValidationErrors: getValidationErrors, min: min, max: max } = cellEditorParams || {};
        return minLength !== void 0 || maxLength !== void 0 || getValidationErrors !== void 0 || min !== void 0 || max !== void 0;
    });
    const editorsHaveRules = beans.gridApi.getCellEditorInstances().some((editor)=>editor.getValidationElement || editor.getValidationErrors);
    return columnsHaveRules || getFullRowEditValidationErrors || editorsHaveRules;
}
function $437b23f6a393c3bf$var$_populateModelValidationErrors(beans, force) {
    if (!(force || $437b23f6a393c3bf$var$_hasValidationRules(beans))) return;
    const mappedEditors = $437b23f6a393c3bf$var$getCellEditorInstanceMap(beans);
    const cellValidationModel = new $437b23f6a393c3bf$var$EditCellValidationModel();
    const { ariaAnnounce: ariaAnnounce, localeSvc: localeSvc, editModelSvc: editModelSvc, gos: gos } = beans;
    const includeRows = gos.get("editType") === "fullRow";
    const translate = $437b23f6a393c3bf$export$cc0bf4adff5b95e7(localeSvc);
    const ariaValidationErrorPrefix = translate("ariaValidationErrorPrefix", "Cell Editor Validation");
    for (const mappedEditor of mappedEditors){
        const { ctrl: ctrl, editor: editor } = mappedEditor;
        const { rowNode: rowNode, column: column } = ctrl;
        const errorMessages = editor.getValidationErrors?.() ?? [];
        const el = editor.getValidationElement?.(false) || !editor.isPopup?.() && ctrl.eGui;
        if (el) {
            const isInvalid = errorMessages != null && errorMessages.length > 0;
            const invalidMessage = isInvalid ? errorMessages.join(". ") : "";
            $437b23f6a393c3bf$export$fd1450327e6900f2(el, isInvalid);
            if (isInvalid) ariaAnnounce.announceValue(`${ariaValidationErrorPrefix} ${errorMessages}`, "editorValidation");
            if (el instanceof HTMLInputElement) el.setCustomValidity(invalidMessage);
            else el.classList.toggle("invalid", isInvalid);
        }
        if (errorMessages?.length > 0) cellValidationModel.setCellValidation({
            rowNode: rowNode,
            column: column
        }, {
            errorMessages: errorMessages
        });
    }
    $437b23f6a393c3bf$var$_syncFromEditors(beans, {
        persist: false
    });
    editModelSvc?.setCellValidationModel(cellValidationModel);
    const rowCtrlSet = /* @__PURE__ */ new Set();
    for (const { ctrl: ctrl } of mappedEditors)rowCtrlSet.add(ctrl.rowCtrl);
    if (includeRows) {
        const rowValidations = $437b23f6a393c3bf$var$_generateRowValidationErrors(beans);
        editModelSvc?.setRowValidationModel(rowValidations);
    }
    for (const rowCtrl of rowCtrlSet.values()){
        rowCtrl.rowEditStyleFeature?.applyRowStyles();
        for (const cellCtrl of rowCtrl.getAllCellCtrls()){
            cellCtrl.tooltipFeature?.refreshTooltip(true);
            cellCtrl.editorTooltipFeature?.refreshTooltip(true);
            cellCtrl.editStyleFeature?.applyCellStyles?.();
        }
    }
}
var $437b23f6a393c3bf$var$_generateRowValidationErrors = (beans)=>{
    const rowValidationModel = new $437b23f6a393c3bf$var$EditRowValidationModel();
    const getFullRowEditValidationErrors = beans.gos.get("getFullRowEditValidationErrors");
    const editMap = beans.editModelSvc?.getEditMap();
    if (!editMap) return rowValidationModel;
    for (const rowNode of editMap.keys()){
        const rowEditMap = editMap.get(rowNode);
        if (!rowEditMap) continue;
        const editorsState = [];
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode;
        for (const column of rowEditMap.keys()){
            const editValue = rowEditMap.get(column);
            if (!editValue) continue;
            const { editorValue: editorValue, pendingValue: pendingValue, sourceValue: sourceValue } = editValue;
            const newValue = editorValue ?? (pendingValue === $437b23f6a393c3bf$var$UNEDITED ? void 0 : pendingValue) ?? sourceValue;
            editorsState.push({
                column: column,
                colId: column.getColId(),
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                oldValue: sourceValue,
                newValue: newValue
            });
        }
        const errorMessages = getFullRowEditValidationErrors?.({
            editorsState: editorsState
        }) ?? [];
        if (errorMessages.length > 0) rowValidationModel.setRowValidation({
            rowNode: rowNode
        }, {
            errorMessages: errorMessages
        });
    }
    return rowValidationModel;
};
function $437b23f6a393c3bf$var$_validateEdit(beans) {
    $437b23f6a393c3bf$var$_populateModelValidationErrors(beans, true);
    const map = beans.editModelSvc?.getCellValidationModel().getCellValidationMap();
    if (!map) return null;
    const validations = [];
    map.forEach((rowValidations, rowNode)=>{
        rowValidations.forEach(({ errorMessages: errorMessages }, column)=>{
            validations.push({
                column: column,
                rowIndex: rowNode.rowIndex,
                rowPinned: rowNode.rowPinned,
                messages: errorMessages ?? null
            });
        });
    });
    return validations;
}
// packages/ag-grid-community/src/rendering/cell/cellEvent.ts
function $437b23f6a393c3bf$var$_createCellEvent(beans, domEvent, eventType, { rowNode: rowNode, column: column }, value) {
    const event = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
        type: eventType,
        node: rowNode,
        data: rowNode.data,
        value: value,
        column: column,
        colDef: column.getColDef(),
        rowPinned: rowNode.rowPinned,
        event: domEvent,
        rowIndex: rowNode.rowIndex
    });
    return event;
}
// packages/ag-grid-community/src/rendering/cell/cellKeyboardListenerFeature.ts
function $437b23f6a393c3bf$var$_isDeleteKey(key, alwaysReturnFalseOnBackspace = false) {
    if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) return true;
    if (!alwaysReturnFalseOnBackspace && key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE) return $437b23f6a393c3bf$var$_isMacOsUserAgent();
    return false;
}
var $437b23f6a393c3bf$var$CellKeyboardListenerFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans, rowNode, rowCtrl){
        super();
        this.cellCtrl = cellCtrl;
        this.rowNode = rowNode;
        this.rowCtrl = rowCtrl;
        this.beans = beans;
    }
    init() {
        this.eGui = this.cellCtrl.eGui;
    }
    onKeyDown(event) {
        const key = event.key;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                this.onEnterKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2:
                this.onF2KeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                this.onEscapeKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                this.onTabKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE:
                this.onBackspaceOrDeleteKeyDown(key, event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                this.onNavigationKeyDown(event, key);
                break;
        }
    }
    onNavigationKeyDown(event, key) {
        const { cellCtrl: cellCtrl, beans: beans } = this;
        if (beans.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        if (event.shiftKey && cellCtrl.isRangeSelectionEnabled()) this.onShiftRangeSelect(event);
        else {
            const currentCellPosition = cellCtrl.getFocusedCellPosition();
            beans.navigation?.navigateToNextCell(event, key, currentCellPosition, true);
        }
        event.preventDefault();
    }
    onShiftRangeSelect(event) {
        const { rangeSvc: rangeSvc, navigation: navigation } = this.beans;
        if (!rangeSvc) return;
        const endCell = rangeSvc.extendLatestRangeInDirection(event);
        if (!endCell) return;
        if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT) navigation?.ensureColumnVisible(endCell.column);
        else navigation?.ensureRowVisible(endCell.rowIndex);
    }
    onTabKeyDown(event) {
        this.beans.navigation?.onTabKeyDown(this.cellCtrl, event);
    }
    onBackspaceOrDeleteKeyDown(key, event) {
        const { cellCtrl: cellCtrl, beans: beans, rowNode: rowNode } = this;
        const { gos: gos, rangeSvc: rangeSvc, eventSvc: eventSvc, editSvc: editSvc } = beans;
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellStart"
        });
        if ($437b23f6a393c3bf$var$_isDeleteKey(key, gos.get("enableCellEditingOnBackspace")) && !editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) {
            if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos)) rangeSvc.clearCellRangeCellValues({
                dispatchWrapperEvents: true,
                wrapperEventSource: "deleteKey"
            });
            else if (cellCtrl.isCellEditable()) {
                const { column: column } = cellCtrl;
                const emptyValue = this.beans.valueSvc.getDeleteValue(column, rowNode);
                rowNode.setDataValue(column, emptyValue, "cellClear");
            }
        } else if (!editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) beans.editSvc?.startEditing(cellCtrl, {
            startedEdit: true,
            event: event
        });
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellEnd"
        });
    }
    onEnterKeyDown(event) {
        const { cellCtrl: cellCtrl, beans: beans } = this;
        const { editSvc: editSvc, navigation: navigation } = beans;
        const cellEditing = editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        });
        const rowNode = cellCtrl.rowNode;
        const rowEditing = editSvc?.isRowEditing(rowNode, {
            withOpenEditor: true
        });
        const startEditingAction = (cellCtrl2)=>{
            const started = editSvc?.startEditing(cellCtrl2, {
                startedEdit: true,
                event: event,
                source: "edit"
            });
            if (started) event.preventDefault();
        };
        if (cellEditing || rowEditing) {
            if (this.isCtrlEnter(event)) {
                editSvc?.applyBulkEdit(cellCtrl, beans?.rangeSvc?.getCellRanges() || []);
                return;
            }
            $437b23f6a393c3bf$var$_populateModelValidationErrors(beans);
            if (editSvc?.checkNavWithValidation(void 0, event) === "block-stop") return;
            if (editSvc?.isEditing(cellCtrl, {
                withOpenEditor: true
            })) editSvc?.stopEditing(cellCtrl, {
                event: event,
                source: "edit"
            });
            else if (rowEditing && !cellCtrl.isCellEditable()) editSvc?.stopEditing({
                rowNode: rowNode
            }, {
                event: event,
                source: "edit"
            });
            else startEditingAction(cellCtrl);
        } else if (beans.gos.get("enterNavigatesVertically")) {
            const key = event.shiftKey ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP : $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
            navigation?.navigateToNextCell(null, key, cellCtrl.cellPosition, false);
        } else {
            if (editSvc?.hasValidationErrors()) return;
            if (editSvc?.hasValidationErrors(cellCtrl)) editSvc.revertSingleCellEdit(cellCtrl, true);
            startEditingAction(cellCtrl);
        }
    }
    isCtrlEnter(e) {
        return (e.ctrlKey || e.metaKey) && e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
    }
    onF2KeyDown(event) {
        const { cellCtrl: cellCtrl, beans: { editSvc: editSvc } } = this;
        const editing = editSvc?.isEditing();
        if (editing) {
            $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
            if (editSvc?.checkNavWithValidation(void 0, event) === "block-stop") return;
        }
        editSvc?.startEditing(cellCtrl, {
            startedEdit: true,
            event: event
        });
    }
    onEscapeKeyDown(event) {
        const { cellCtrl: cellCtrl, beans: { editSvc: editSvc } } = this;
        if (editSvc?.checkNavWithValidation(cellCtrl, event) === "block-stop") editSvc.revertSingleCellEdit(cellCtrl);
        setTimeout(()=>{
            editSvc?.stopEditing(cellCtrl, {
                event: event,
                cancel: true
            });
        });
    }
    processCharacter(event) {
        const eventTarget = event.target;
        const eventOnChildComponent = eventTarget !== this.eGui;
        const { beans: { editSvc: editSvc }, cellCtrl: cellCtrl } = this;
        if (eventOnChildComponent) return;
        if (editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        })) return;
        const key = event.key;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) this.onSpaceKeyDown(event);
        else if (editSvc?.isCellEditable(cellCtrl, "ui")) {
            if (editSvc?.hasValidationErrors() && !editSvc?.hasValidationErrors(cellCtrl)) return;
            editSvc?.startEditing(cellCtrl, {
                startedEdit: true,
                event: event,
                source: "api"
            });
            const compDetails = cellCtrl.editCompDetails;
            const shouldPreventDefault = !compDetails?.params?.suppressPreventDefault;
            if (shouldPreventDefault) event.preventDefault();
        }
    }
    onSpaceKeyDown(event) {
        const { gos: gos, editSvc: editSvc } = this.beans;
        const { rowNode: rowNode } = this.cellCtrl;
        if (!editSvc?.isEditing(this.cellCtrl, {
            withOpenEditor: true
        }) && $437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) this.beans.selectionSvc?.handleSelectionEvent(event, rowNode, "spaceKey");
        event.preventDefault();
    }
};
// packages/ag-grid-community/src/rendering/cell/cellMouseListenerFeature.ts
var $437b23f6a393c3bf$var$CellMouseListenerFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans, column){
        super();
        this.cellCtrl = cellCtrl;
        this.column = column;
        this.beans = beans;
    }
    onMouseEvent(eventName, mouseEvent) {
        if ($437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        switch(eventName){
            case "click":
                this.onCellClicked(mouseEvent);
                break;
            case "mousedown":
            case "touchstart":
                this.onMouseDown(mouseEvent);
                break;
            case "dblclick":
                this.onCellDoubleClicked(mouseEvent);
                break;
            case "mouseout":
                this.onMouseOut(mouseEvent);
                break;
            case "mouseover":
                this.onMouseOver(mouseEvent);
                break;
        }
    }
    onCellClicked(event) {
        if (this.beans.touchSvc?.handleCellDoubleClick(this, event)) return;
        const { eventSvc: eventSvc, rangeSvc: rangeSvc, editSvc: editSvc, editModelSvc: editModelSvc, frameworkOverrides: frameworkOverrides, gos: gos } = this.beans;
        const isMultiKey = event.ctrlKey || event.metaKey;
        const { cellCtrl: cellCtrl } = this;
        const { column: column, cellPosition: cellPosition, rowNode: rowNode } = cellCtrl;
        const suppressMouseEvent2 = $437b23f6a393c3bf$export$d7866551eadae1d3(gos, column, rowNode, event);
        if (rangeSvc && isMultiKey && !suppressMouseEvent2) {
            if (rangeSvc.getCellRangeCount(cellPosition) > 1) rangeSvc.intersectLastRange(true);
        }
        const cellClickedEvent = cellCtrl.createEvent(event, "cellClicked");
        cellClickedEvent.isEventHandlingSuppressed = suppressMouseEvent2;
        eventSvc.dispatchEvent(cellClickedEvent);
        const colDef = column.getColDef();
        if (colDef.onCellClicked) window.setTimeout(()=>{
            frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellClicked(cellClickedEvent);
            });
        }, 0);
        if (suppressMouseEvent2) return;
        if (editModelSvc?.getState(cellCtrl) !== "editing") {
            const editing = editSvc?.isEditing();
            const cellValidations = editModelSvc?.getCellValidationModel().getCellValidationMap().size ?? 0;
            const rowValidations = editModelSvc?.getRowValidationModel().getRowValidationMap().size ?? 0;
            if (editing && (cellValidations > 0 || rowValidations > 0)) return;
            if (editSvc?.shouldStartEditing(cellCtrl, event)) editSvc?.startEditing(cellCtrl, {
                event: event
            });
            else if (editSvc?.shouldStopEditing(cellCtrl, event)) {
                if (this.beans.gos.get("editType") === "fullRow") editSvc?.stopEditing(cellCtrl, {
                    event: event,
                    source: "edit"
                });
                else editSvc?.stopEditing(void 0, {
                    event: event,
                    source: "edit"
                });
            }
        }
    }
    onCellDoubleClicked(event) {
        const { column: column, beans: beans, cellCtrl: cellCtrl } = this;
        const { eventSvc: eventSvc, frameworkOverrides: frameworkOverrides, editSvc: editSvc, editModelSvc: editModelSvc, gos: gos } = beans;
        const suppressMouseEvent2 = $437b23f6a393c3bf$export$d7866551eadae1d3(gos, cellCtrl.column, cellCtrl.rowNode, event);
        const colDef = column.getColDef();
        const cellDoubleClickedEvent = cellCtrl.createEvent(event, "cellDoubleClicked");
        cellDoubleClickedEvent.isEventHandlingSuppressed = suppressMouseEvent2;
        eventSvc.dispatchEvent(cellDoubleClickedEvent);
        if (typeof colDef.onCellDoubleClicked === "function") window.setTimeout(()=>{
            frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellDoubleClicked(cellDoubleClickedEvent);
            });
        }, 0);
        if (suppressMouseEvent2) return;
        if (editSvc?.shouldStartEditing(cellCtrl, event) && editModelSvc?.getState(cellCtrl) !== "editing") {
            const editing = editSvc?.isEditing();
            const cellValidations = editModelSvc?.getCellValidationModel().getCellValidationMap().size ?? 0;
            const rowValidations = editModelSvc?.getRowValidationModel().getRowValidationMap().size ?? 0;
            if (editing && (cellValidations > 0 || rowValidations > 0)) return;
            editSvc?.startEditing(cellCtrl, {
                event: event
            });
        }
    }
    onMouseDown(mouseEvent) {
        const { shiftKey: shiftKey } = mouseEvent;
        const target = mouseEvent.target;
        const { cellCtrl: cellCtrl, beans: beans } = this;
        const { eventSvc: eventSvc, rangeSvc: rangeSvc, rowNumbersSvc: rowNumbersSvc, focusSvc: focusSvc, gos: gos, editSvc: editSvc } = beans;
        const { column: column, rowNode: rowNode, cellPosition: cellPosition } = cellCtrl;
        const suppressMouseEvent2 = $437b23f6a393c3bf$export$d7866551eadae1d3(gos, column, rowNode, mouseEvent);
        const fireMouseDownEvent = ()=>{
            const cellMouseDownEvent = cellCtrl.createEvent(mouseEvent, "cellMouseDown");
            cellMouseDownEvent.isEventHandlingSuppressed = suppressMouseEvent2;
            eventSvc.dispatchEvent(cellMouseDownEvent);
        };
        if (suppressMouseEvent2) {
            fireMouseDownEvent();
            return;
        }
        if (this.isRightClickInExistingRange(mouseEvent)) return;
        const hasRanges = rangeSvc && !rangeSvc.isEmpty();
        const containsWidget = this.containsWidget(target);
        const isRowNumberColumn = $437b23f6a393c3bf$export$3d3e7d751f0445eb(column);
        if (rowNumbersSvc && isRowNumberColumn && !rowNumbersSvc.handleMouseDownOnCell(cellPosition, mouseEvent)) return;
        if (!shiftKey || !hasRanges) {
            const editing = editSvc?.isEditing(cellCtrl);
            const isEnableCellTextSelection = gos.get("enableCellTextSelection");
            const shouldFocus = isEnableCellTextSelection && mouseEvent.defaultPrevented;
            const forceBrowserFocus = ($437b23f6a393c3bf$export$8caf403dacd36a68() || shouldFocus) && !editing && !$437b23f6a393c3bf$var$_isFocusableFormField(target) && !containsWidget;
            cellCtrl.focusCell(forceBrowserFocus, mouseEvent);
        }
        if (shiftKey && hasRanges && !focusSvc.isCellFocused(cellPosition)) {
            mouseEvent.preventDefault();
            const focusedCell = focusSvc.getFocusedCell();
            if (focusedCell) {
                const { column: column2, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCell;
                if (editSvc?.isEditing(focusedCell)) editSvc?.stopEditing(focusedCell);
                focusSvc.setFocusedCell({
                    column: column2,
                    rowIndex: rowIndex,
                    rowPinned: rowPinned,
                    forceBrowserFocus: true,
                    preventScrollOnBrowserFocus: true,
                    sourceEvent: mouseEvent
                });
            }
        }
        if (containsWidget) return;
        rangeSvc?.handleCellMouseDown(mouseEvent, cellPosition);
        fireMouseDownEvent();
    }
    isRightClickInExistingRange(mouseEvent) {
        const { rangeSvc: rangeSvc } = this.beans;
        if (rangeSvc) {
            const cellInRange = rangeSvc.isCellInAnyRange(this.cellCtrl.cellPosition);
            const isRightClick = $437b23f6a393c3bf$export$f8093014f10b296a(this.beans, mouseEvent);
            if (cellInRange && isRightClick) return true;
        }
        return false;
    }
    containsWidget(target) {
        return $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-selection-checkbox", 3) || $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-drag-handle", 3);
    }
    onMouseOut(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const { eventSvc: eventSvc, colHover: colHover } = this.beans;
        eventSvc.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, "cellMouseOut"));
        colHover?.clearMouseOver();
    }
    onMouseOver(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const { eventSvc: eventSvc, colHover: colHover } = this.beans;
        eventSvc.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, "cellMouseOver"));
        colHover?.setMouseOver([
            this.column
        ]);
    }
    mouseStayingInsideCell(e) {
        if (!e.target || !e.relatedTarget) return false;
        const eCell = this.cellCtrl.eGui;
        const cellContainsTarget = eCell.contains(e.target);
        const cellContainsRelatedTarget = eCell.contains(e.relatedTarget);
        return cellContainsTarget && cellContainsRelatedTarget;
    }
};
// packages/ag-grid-community/src/rendering/cell/cellPositionFeature.ts
var $437b23f6a393c3bf$var$CellPositionFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans){
        super();
        this.cellCtrl = cellCtrl;
        this.beans = beans;
        this.column = cellCtrl.column;
        this.rowNode = cellCtrl.rowNode;
    }
    setupRowSpan() {
        this.rowSpan = this.column.getRowSpan(this.rowNode);
        this.addManagedListeners(this.beans.eventSvc, {
            newColumnsLoaded: ()=>this.onNewColumnsLoaded()
        });
    }
    init() {
        this.eSetLeft = this.cellCtrl.getRootElement();
        this.eContent = this.cellCtrl.eGui;
        const cellSpan = this.cellCtrl.getCellSpan();
        if (!cellSpan) {
            this.setupColSpan();
            this.setupRowSpan();
        }
        this.onLeftChanged();
        this.onWidthChanged();
        if (!cellSpan) this._legacyApplyRowSpan();
        if (cellSpan) {
            const refreshSpanHeight = this.refreshSpanHeight.bind(this, cellSpan);
            refreshSpanHeight();
            this.addManagedListeners(this.beans.eventSvc, {
                paginationChanged: refreshSpanHeight,
                recalculateRowBounds: refreshSpanHeight,
                pinnedHeightChanged: refreshSpanHeight
            });
        }
    }
    refreshSpanHeight(cellSpan) {
        const spanHeight = cellSpan.getCellHeight();
        if (spanHeight != null) this.eContent.style.height = `${spanHeight}px`;
    }
    onNewColumnsLoaded() {
        const rowSpan = this.column.getRowSpan(this.rowNode);
        if (this.rowSpan === rowSpan) return;
        this.rowSpan = rowSpan;
        this._legacyApplyRowSpan(true);
    }
    onDisplayColumnsChanged() {
        const colsSpanning = this.getColSpanningList();
        if (!$437b23f6a393c3bf$export$893967cdb9833fdd(this.colsSpanning, colsSpanning)) {
            this.colsSpanning = colsSpanning;
            this.onWidthChanged();
            this.onLeftChanged();
        }
    }
    setupColSpan() {
        if (this.column.getColDef().colSpan == null) return;
        this.colsSpanning = this.getColSpanningList();
        this.addManagedListeners(this.beans.eventSvc, {
            // because we are col spanning, a reorder of the cols can change what cols we are spanning over
            displayedColumnsChanged: this.onDisplayColumnsChanged.bind(this),
            // because we are spanning over multiple cols, we check for width any time any cols width changes.
            // this is expensive - really we should be explicitly checking only the cols we are spanning over
            // instead of every col, however it would be tricky code to track the cols we are spanning over, so
            // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
            displayedColumnsWidthChanged: this.onWidthChanged.bind(this)
        });
    }
    onWidthChanged() {
        if (!this.eContent) return;
        const width = this.getCellWidth();
        this.eContent.style.width = `${width}px`;
    }
    getCellWidth() {
        if (!this.colsSpanning) return this.column.getActualWidth();
        return this.colsSpanning.reduce((width, col)=>width + col.getActualWidth(), 0);
    }
    getColSpanningList() {
        const { column: column, rowNode: rowNode } = this;
        const colSpan = column.getColSpan(rowNode);
        const colsSpanning = [];
        if (colSpan === 1) colsSpanning.push(column);
        else {
            let pointer = column;
            const pinned = column.getPinned();
            for(let i = 0; pointer && i < colSpan; i++){
                colsSpanning.push(pointer);
                pointer = this.beans.visibleCols.getColAfter(pointer);
                if (!pointer || $437b23f6a393c3bf$export$672d9e47bc342bac(pointer)) break;
                if (pinned !== pointer.getPinned()) break;
            }
        }
        return colsSpanning;
    }
    onLeftChanged() {
        if (!this.eSetLeft) return;
        const left = this.modifyLeftForPrintLayout(this.getCellLeft());
        this.eSetLeft.style.left = left + "px";
    }
    getCellLeft() {
        let mostLeftCol;
        if (this.beans.gos.get("enableRtl") && this.colsSpanning) mostLeftCol = $437b23f6a393c3bf$export$236389741107357f(this.colsSpanning);
        else mostLeftCol = this.column;
        return mostLeftCol.getLeft();
    }
    modifyLeftForPrintLayout(leftPosition) {
        if (!this.cellCtrl.printLayout || this.column.getPinned() === "left") return leftPosition;
        const { visibleCols: visibleCols } = this.beans;
        const leftWidth = visibleCols.getColsLeftWidth();
        if (this.column.getPinned() === "right") {
            const bodyWidth = visibleCols.bodyWidth;
            return leftWidth + bodyWidth + (leftPosition || 0);
        }
        return leftWidth + (leftPosition || 0);
    }
    _legacyApplyRowSpan(force) {
        if (this.rowSpan === 1 && !force) return;
        const singleRowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
        const totalRowHeight = singleRowHeight * this.rowSpan;
        this.eContent.style.height = `${totalRowHeight}px`;
        this.eContent.style.zIndex = "1";
    }
    // overriding to make public, as we don't dispose this bean via context
    destroy() {
        super.destroy();
    }
};
// packages/ag-grid-community/src/rendering/cell/cellCtrl.ts
var $437b23f6a393c3bf$var$CSS_CELL = "ag-cell";
var $437b23f6a393c3bf$var$CSS_AUTO_HEIGHT = "ag-cell-auto-height";
var $437b23f6a393c3bf$var$CSS_NORMAL_HEIGHT = "ag-cell-normal-height";
var $437b23f6a393c3bf$var$CSS_CELL_FOCUS = "ag-cell-focus";
var $437b23f6a393c3bf$var$CSS_CELL_FIRST_RIGHT_PINNED = "ag-cell-first-right-pinned";
var $437b23f6a393c3bf$var$CSS_CELL_LAST_LEFT_PINNED = "ag-cell-last-left-pinned";
var $437b23f6a393c3bf$var$CSS_CELL_NOT_INLINE_EDITING = "ag-cell-not-inline-editing";
var $437b23f6a393c3bf$var$CSS_CELL_WRAP_TEXT = "ag-cell-wrap-text";
var $437b23f6a393c3bf$var$instanceIdSequence4 = 0;
var $437b23f6a393c3bf$var$CellCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column, rowNode, beans, rowCtrl){
        super();
        this.column = column;
        this.rowNode = rowNode;
        this.rowCtrl = rowCtrl;
        this.rangeFeature = void 0;
        this.rowResizeFeature = void 0;
        this.positionFeature = void 0;
        this.customStyleFeature = void 0;
        this.editStyleFeature = void 0;
        this.mouseListener = void 0;
        this.keyboardListener = void 0;
        this.suppressRefreshCell = false;
        this.onCompAttachedFuncs = [];
        this.onEditorAttachedFuncs = [];
        this.focusEventWhileNotReady = null;
        // if cell has been focused, check if it's focused when destroyed
        this.hasBeenFocused = false;
        this.hasEdit = false;
        this.tooltipFeature = void 0;
        this.editorTooltipFeature = void 0;
        this.formulaTooltipFeature = void 0;
        this.beans = beans;
        this.gos = beans.gos;
        this.editSvc = beans.editSvc;
        this.hasEdit = !!beans.editSvc;
        const { colId: colId } = column;
        this.instanceId = colId + "-" + $437b23f6a393c3bf$var$instanceIdSequence4++;
        this.createCellPosition();
        this.updateAndFormatValue(false);
    }
    addFeatures() {
        const { beans: beans } = this;
        this.positionFeature = new $437b23f6a393c3bf$var$CellPositionFeature(this, beans);
        this.customStyleFeature = beans.cellStyles?.createCellCustomStyleFeature(this);
        this.editStyleFeature = beans.editSvc?.createCellStyleFeature(this);
        this.mouseListener = new $437b23f6a393c3bf$var$CellMouseListenerFeature(this, beans, this.column);
        this.keyboardListener = new $437b23f6a393c3bf$var$CellKeyboardListenerFeature(this, beans, this.rowNode, this.rowCtrl);
        this.enableTooltipFeature();
        this.enableFormulaTooltipFeature();
        const { rangeSvc: rangeSvc } = beans;
        const cellSelectionEnabled = rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(beans.gos);
        if (cellSelectionEnabled) this.rangeFeature = rangeSvc.createCellRangeFeature(this);
        if ($437b23f6a393c3bf$export$3d3e7d751f0445eb(this.column)) this.rowResizeFeature = this.beans.rowNumbersSvc.createRowNumbersRowResizerFeature(this);
    }
    isCellSpanning() {
        return false;
    }
    getCellSpan() {
        return void 0;
    }
    removeFeatures() {
        const context = this.beans.context;
        this.positionFeature = context.destroyBean(this.positionFeature);
        this.editorTooltipFeature = context.destroyBean(this.editorTooltipFeature);
        this.customStyleFeature = context.destroyBean(this.customStyleFeature);
        this.editStyleFeature = context.destroyBean(this.editStyleFeature);
        this.mouseListener = context.destroyBean(this.mouseListener);
        this.keyboardListener = context.destroyBean(this.keyboardListener);
        this.rangeFeature = context.destroyBean(this.rangeFeature);
        this.rowResizeFeature = context.destroyBean(this.rowResizeFeature);
        this.disableTooltipFeature();
        this.disableFormulaTooltipFeature();
    }
    enableTooltipFeature(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.enableCellTooltipFeature(this, value, shouldDisplayTooltip);
    }
    enableFormulaTooltipFeature() {
        this.formulaTooltipFeature = this.beans.tooltipSvc?.setupFormulaTooltip(this);
    }
    disableTooltipFeature() {
        this.tooltipFeature = this.beans.context.destroyBean(this.tooltipFeature);
    }
    disableFormulaTooltipFeature() {
        this.formulaTooltipFeature = this.beans.context.destroyBean(this.formulaTooltipFeature);
    }
    enableEditorTooltipFeature(editor) {
        if (this.editorTooltipFeature) this.disableEditorTooltipFeature();
        this.editorTooltipFeature = this.beans.tooltipSvc?.setupCellEditorTooltip(this, editor);
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
    }
    disableEditorTooltipFeature() {
        this.editorTooltipFeature = this.beans.context.destroyBean(this.editorTooltipFeature);
    }
    setComp(comp, eCell, _eWrapper, eCellWrapper, printLayout, startEditing, compBean) {
        this.comp = comp;
        this.eGui = eCell;
        this.printLayout = printLayout;
        compBean ?? (compBean = this);
        this.addDomData(compBean);
        this.addFeatures();
        compBean.addDestroyFunc(()=>this.removeFeatures());
        this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus"));
        this.setupFocus();
        this.applyStaticCssClasses();
        this.setWrapText();
        this.onFirstRightPinnedChanged();
        this.onLastLeftPinnedChanged();
        this.onColumnHover();
        this.setupControlComps();
        this.setupAutoHeight(eCellWrapper, compBean);
        this.refreshFirstAndLastStyles();
        this.checkFormulaError();
        this.refreshAriaColIndex();
        this.positionFeature?.init();
        this.customStyleFeature?.setComp(comp);
        this.editStyleFeature?.setComp(comp);
        this.tooltipFeature?.refreshTooltip();
        this.keyboardListener?.init();
        this.rangeFeature?.setComp(comp);
        this.rowResizeFeature?.refreshRowResizer();
        if (startEditing && this.isCellEditable() || this.hasEdit && this.editSvc?.isEditing(this, {
            withOpenEditor: true
        })) this.editSvc?.startEditing(this, {
            startedEdit: false,
            source: "api",
            silent: true,
            continueEditing: true
        });
        else this.showValue(false, true);
        if (this.onCompAttachedFuncs.length) {
            for (const func of this.onCompAttachedFuncs)func();
            this.onCompAttachedFuncs = [];
        }
    }
    checkFormulaError() {
        const isFormulaError = !!this.beans.formula?.getFormulaError(this.column, this.rowNode);
        this.eGui.classList.toggle("formula-error", isFormulaError);
        this.formulaTooltipFeature?.refreshTooltip();
        if (isFormulaError) this.disableTooltipFeature();
        else this.enableTooltipFeature();
    }
    setupAutoHeight(eCellWrapper, compBean) {
        this.isAutoHeight = this.beans.rowAutoHeight?.setupCellAutoHeight(this, eCellWrapper, compBean) ?? false;
    }
    getCellAriaRole() {
        return this.column.getColDef().cellAriaRole ?? "gridcell";
    }
    isCellRenderer() {
        const colDef = this.column.getColDef();
        return colDef.cellRenderer != null || colDef.cellRendererSelector != null;
    }
    getValueToDisplay() {
        return this.valueFormatted ?? this.value;
    }
    getDeferLoadingCellRenderer() {
        const { beans: beans, column: column } = this;
        const { userCompFactory: userCompFactory, ctrlsSvc: ctrlsSvc, eventSvc: eventSvc } = beans;
        const colDef = column.getColDef();
        const params = this.createCellRendererParams();
        params.deferRender = true;
        const loadingDetails = $437b23f6a393c3bf$var$_getLoadingCellRendererDetails(userCompFactory, colDef, params);
        if (ctrlsSvc.getGridBodyCtrl()?.scrollFeature?.isScrolling()) {
            let resolver;
            const onReady = new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
                resolver = resolve;
            });
            const [removeBodyScrollEnd] = this.addManagedListeners(eventSvc, {
                bodyScrollEnd: ()=>{
                    resolver();
                    removeBodyScrollEnd();
                }
            });
            return {
                loadingComp: loadingDetails,
                onReady: onReady
            };
        }
        return {
            loadingComp: loadingDetails,
            onReady: $437b23f6a393c3bf$export$30ec7836a4847721.resolve()
        };
    }
    showValue(forceNewCellRendererInstance, skipRangeHandleRefresh) {
        const { beans: beans, column: column, rowNode: rowNode, rangeFeature: rangeFeature } = this;
        const { userCompFactory: userCompFactory } = beans;
        let valueToDisplay = this.getValueToDisplay();
        let compDetails;
        const isSsrmLoading = rowNode.stub && rowNode.groupData?.[column.getId()] == null;
        const colDef = column.getColDef();
        if (isSsrmLoading || this.isCellRenderer()) {
            const params = this.createCellRendererParams();
            if (!isSsrmLoading || $437b23f6a393c3bf$export$3d3e7d751f0445eb(column)) compDetails = $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, colDef, params);
            else compDetails = $437b23f6a393c3bf$var$_getLoadingCellRendererDetails(userCompFactory, colDef, params);
        }
        if (!compDetails && !isSsrmLoading && beans.findSvc?.isMatch(rowNode, column)) {
            const params = this.createCellRendererParams();
            compDetails = $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, {
                ...column.getColDef(),
                cellRenderer: "agFindCellRenderer"
            }, params);
        }
        if (this.hasEdit && this.editSvc.isBatchEditing() && this.editSvc.isRowEditing(rowNode, {
            checkSiblings: true
        })) {
            const result = this.editSvc.prepDetailsDuringBatch(this, {
                compDetails: compDetails,
                valueToDisplay: valueToDisplay
            });
            if (result) {
                if (result.compDetails) compDetails = result.compDetails;
                else if (result.valueToDisplay) valueToDisplay = result.valueToDisplay;
            }
        }
        this.comp.setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance);
        this.customRowDragComp?.refreshVisibility();
        if (!skipRangeHandleRefresh && rangeFeature) $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>rangeFeature?.refreshHandle());
        this.rowResizeFeature?.refreshRowResizer();
    }
    setupControlComps() {
        const colDef = this.column.getColDef();
        this.includeSelection = this.isIncludeControl(this.isCheckboxSelection(colDef), true);
        this.includeRowDrag = this.isIncludeControl(colDef.rowDrag);
        this.includeDndSource = this.isIncludeControl(colDef.dndSource);
        this.comp.setIncludeSelection(this.includeSelection);
        this.comp.setIncludeDndSource(this.includeDndSource);
        this.comp.setIncludeRowDrag(this.includeRowDrag);
    }
    isForceWrapper() {
        return this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
    }
    getCellValueClass() {
        const prefix = "ag-cell-value";
        const isCheckboxRenderer = this.column.getColDef().cellRenderer === "agCheckboxCellRenderer";
        let suffix = "";
        if (isCheckboxRenderer) suffix = " ag-allow-overflow";
        return `${prefix}${suffix}`;
    }
    /**
   * Wrapper providing general conditions under which control elements (e.g. checkboxes and drag handles)
   * are rendered for a particular cell.
   * @param value Whether to render the control in the specific context of the caller
   * @param allowManuallyPinned Whether manually pinned rows are permitted this form of control element
   */ // eslint-disable-next-line @typescript-eslint/ban-types
    isIncludeControl(value, allowManuallyPinned = false) {
        const rowUnpinned = this.rowNode.rowPinned == null;
        return (rowUnpinned || allowManuallyPinned && $437b23f6a393c3bf$var$_isManualPinnedRow(this.rowNode)) && !!value;
    }
    isCheckboxSelection(colDef) {
        const { rowSelection: rowSelection, groupDisplayType: groupDisplayType } = this.beans.gridOptions;
        const checkboxLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection);
        const isSelectionColumn = $437b23f6a393c3bf$export$f6074a9792015c5d(this.column);
        if (groupDisplayType === "custom" && checkboxLocation !== "selectionColumn" && isSelectionColumn) return false;
        return colDef.checkboxSelection || isSelectionColumn && typeof rowSelection === "object" && $437b23f6a393c3bf$export$6df3a55606bca6ae(rowSelection);
    }
    refreshShouldDestroy() {
        const colDef = this.column.getColDef();
        const selectionChanged = this.includeSelection != this.isIncludeControl(this.isCheckboxSelection(colDef), true);
        const rowDragChanged = this.includeRowDrag != this.isIncludeControl(colDef.rowDrag);
        const dndSourceChanged = this.includeDndSource != this.isIncludeControl(colDef.dndSource);
        const autoHeightChanged = this.isAutoHeight != this.column.isAutoHeight();
        return selectionChanged || rowDragChanged || dndSourceChanged || autoHeightChanged;
    }
    onPopupEditorClosed() {
        const { editSvc: editSvc } = this.beans;
        if (!editSvc?.isEditing(this, {
            withOpenEditor: true
        })) return;
        editSvc?.stopEditing(this, {
            source: editSvc?.isBatchEditing() ? "ui" : "api"
        });
    }
    /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */ stopEditing(cancel = false) {
        const { editSvc: editSvc } = this.beans;
        return editSvc?.stopEditing(this, {
            cancel: cancel,
            source: editSvc?.isBatchEditing() ? "ui" : "api"
        }) ?? false;
    }
    createCellRendererParams() {
        const { value: value, valueFormatted: valueFormatted, column: column, rowNode: rowNode, comp: comp, eGui: eGui, beans: { valueSvc: valueSvc, gos: gos, editSvc: editSvc } } = this;
        const res = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            value: value,
            valueFormatted: valueFormatted,
            getValue: ()=>valueSvc.getValueForDisplay({
                    column: column,
                    node: rowNode
                }).value,
            setValue: (value2)=>editSvc?.setDataValue({
                    rowNode: rowNode,
                    column: column
                }, value2) || rowNode.setDataValue(column, value2),
            formatValue: this.formatValue.bind(this),
            data: rowNode.data,
            node: rowNode,
            pinned: column.getPinned(),
            colDef: column.getColDef(),
            column: column,
            refreshCell: this.refreshCell.bind(this),
            eGridCell: eGui,
            eParentOfValue: comp.getParentOfValue(),
            registerRowDragger: (rowDraggerElement, dragStartPixels, value2, suppressVisibilityChange)=>this.registerRowDragger(rowDraggerElement, dragStartPixels, suppressVisibilityChange),
            setTooltip: (value2, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                if (this.tooltipFeature) this.disableTooltipFeature();
                this.enableTooltipFeature(value2, shouldDisplayTooltip);
                this.tooltipFeature?.refreshTooltip();
            }
        });
        return res;
    }
    onCellChanged(event) {
        const eventImpactsThisCell = event.column === this.column;
        if (eventImpactsThisCell) this.refreshCell({});
    }
    refreshOrDestroyCell(params) {
        if (this.refreshShouldDestroy()) this.rowCtrl?.recreateCell(this);
        else this.refreshCell(params);
        if (this.hasEdit && this.editCompDetails) {
            const { editSvc: editSvc, comp: comp } = this;
            if (!comp?.getCellEditor() && editSvc.isEditing(this, {
                withOpenEditor: true
            })) editSvc.startEditing(this, {
                startedEdit: false,
                source: "api",
                silent: true
            });
        }
    }
    // + stop editing {force: true, suppressFlash: true}
    // + event cellChanged {}
    // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
    // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
    // + rowCtrl: api refreshCells() {animate: true/false}
    // + rowRenderer: api softRefreshView() {}
    refreshCell({ force: force, suppressFlash: suppressFlash, newData: newData } = {}) {
        const { editStyleFeature: editStyleFeature, customStyleFeature: customStyleFeature, rowCtrl: { rowEditStyleFeature: rowEditStyleFeature }, beans: { cellFlashSvc: cellFlashSvc, filterManager: filterManager }, column: column, comp: comp, suppressRefreshCell: suppressRefreshCell, tooltipFeature: tooltipFeature } = this;
        if (suppressRefreshCell) return;
        const { field: field, valueGetter: valueGetter, showRowGroup: showRowGroup, enableCellChangeFlash: enableCellChangeFlash } = column.getColDef();
        const noValueProvided = field == null && valueGetter == null && showRowGroup == null;
        const forceRefresh = force || noValueProvided || newData;
        const isCellCompReady = !!comp;
        const valuesDifferent = this.updateAndFormatValue(isCellCompReady);
        const dataNeedsUpdating = forceRefresh || valuesDifferent;
        if (!isCellCompReady) return;
        if (dataNeedsUpdating) {
            this.showValue(!!newData, false);
            const processingFilterChange = filterManager?.isSuppressFlashingCellsBecauseFiltering();
            const flashCell = !suppressFlash && !processingFilterChange && enableCellChangeFlash;
            if (flashCell) cellFlashSvc?.flashCell(this);
            editStyleFeature?.applyCellStyles?.();
            customStyleFeature?.applyUserStyles();
            customStyleFeature?.applyClassesFromColDef();
            rowEditStyleFeature?.applyRowStyles();
            this.checkFormulaError();
        }
        tooltipFeature?.refreshTooltip();
        customStyleFeature?.applyCellClassRules();
    }
    isCellEditable() {
        return this.column.isCellEditable(this.rowNode);
    }
    formatValue(value) {
        return this.callValueFormatter(value) ?? value;
    }
    callValueFormatter(value) {
        return this.beans.valueSvc.formatValue(this.column, this.rowNode, value);
    }
    updateAndFormatValue(compareValues) {
        const oldValue = this.value;
        const oldValueFormatted = this.valueFormatted;
        const { value: value, valueFormatted: valueFormatted } = this.beans.valueSvc.getValueForDisplay({
            column: this.column,
            node: this.rowNode,
            includeValueFormatted: true
        });
        this.value = value;
        this.valueFormatted = valueFormatted;
        if (compareValues) return !this.valuesAreEqual(oldValue, this.value) || this.valueFormatted != oldValueFormatted;
        return true;
    }
    valuesAreEqual(val1, val2) {
        const colDef = this.column.getColDef();
        return colDef.equals ? colDef.equals(val1, val2) : val1 === val2;
    }
    addDomData(compBean) {
        const element = this.eGui;
        $437b23f6a393c3bf$var$_setDomData(this.beans.gos, element, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL, this);
        compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(this.beans.gos, element, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL, null));
    }
    createEvent(domEvent, eventType) {
        const { rowNode: rowNode, column: column, value: value, beans: beans } = this;
        return $437b23f6a393c3bf$var$_createCellEvent(beans, domEvent, eventType, {
            rowNode: rowNode,
            column: column
        }, value);
    }
    processCharacter(event) {
        this.keyboardListener?.processCharacter(event);
    }
    onKeyDown(event) {
        this.keyboardListener?.onKeyDown(event);
    }
    onMouseEvent(eventName, mouseEvent) {
        this.mouseListener?.onMouseEvent(eventName, mouseEvent);
    }
    getColSpanningList() {
        return this.positionFeature?.getColSpanningList() ?? [];
    }
    onLeftChanged() {
        if (!this.comp) return;
        this.positionFeature?.onLeftChanged();
    }
    onDisplayedColumnsChanged() {
        if (!this.eGui) return;
        this.refreshAriaColIndex();
        this.refreshFirstAndLastStyles();
    }
    refreshFirstAndLastStyles() {
        const { comp: comp, column: column, beans: beans } = this;
        $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, beans.visibleCols);
    }
    refreshAriaColIndex() {
        const colIdx = this.beans.visibleCols.getAriaColIndex(this.column);
        $437b23f6a393c3bf$export$84b73ecd0b234e89(this.eGui, colIdx);
    }
    onWidthChanged() {
        return this.positionFeature?.onWidthChanged();
    }
    getRowPosition() {
        const { rowIndex: rowIndex, rowPinned: rowPinned } = this.cellPosition;
        return {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
    }
    updateRangeBordersIfRangeCount() {
        if (!this.comp) return;
        this.rangeFeature?.updateRangeBordersIfRangeCount();
    }
    onCellSelectionChanged() {
        if (!this.comp) return;
        this.rangeFeature?.onCellSelectionChanged();
    }
    isRangeSelectionEnabled() {
        return this.rangeFeature != null;
    }
    focusCell(forceBrowserFocus = false, sourceEvent) {
        const allowedTarget = this.editSvc?.allowedFocusTargetOnValidation(this);
        if (allowedTarget && allowedTarget !== this) return;
        this.beans.focusSvc.setFocusedCell({
            ...this.getFocusedCellPosition(),
            forceBrowserFocus: forceBrowserFocus,
            sourceEvent: sourceEvent
        });
    }
    /**
   * Restores focus to the cell, if it should have it
   * @param waitForRender if the cell has just setComp, it may not be rendered yet, so we wait for the next render
   */ restoreFocus(waitForRender = false) {
        const { beans: { editSvc: editSvc, focusSvc: focusSvc }, comp: comp } = this;
        if (!comp || editSvc?.isEditing(this) || !this.isCellFocused() || !focusSvc.shouldTakeFocus()) return;
        const focus = ()=>{
            if (!this.isAlive()) return;
            const focusableElement = comp.getFocusableElement();
            if (this.isCellFocused()) focusableElement.focus({
                preventScroll: true
            });
        };
        if (waitForRender) {
            setTimeout(focus, 0);
            return;
        }
        focus();
    }
    onRowIndexChanged() {
        this.createCellPosition();
        this.onCellFocused();
        this.restoreFocus();
        this.rangeFeature?.onCellSelectionChanged();
        this.rowResizeFeature?.refreshRowResizer();
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        const element = this.eGui;
        if (!element) return;
        if ($437b23f6a393c3bf$export$3d3e7d751f0445eb(this.column)) suppressCellFocus = true;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(element, "tabindex", suppressCellFocus ? void 0 : -1);
    }
    onFirstRightPinnedChanged() {
        if (!this.comp) return;
        const firstRightPinned = this.column.isFirstRightPinned();
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_FIRST_RIGHT_PINNED, firstRightPinned);
    }
    onLastLeftPinnedChanged() {
        if (!this.comp) return;
        const lastLeftPinned = this.column.isLastLeftPinned();
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_LAST_LEFT_PINNED, lastLeftPinned);
    }
    /**
   * Returns whether cell is focused by the focusSvc, overridden by spannedCellCtrl
   */ checkCellFocused() {
        return this.beans.focusSvc.isCellFocused(this.cellPosition);
    }
    isCellFocused() {
        const isFocused = this.checkCellFocused();
        this.hasBeenFocused || (this.hasBeenFocused = isFocused);
        return isFocused;
    }
    setupFocus() {
        this.restoreFocus(true);
        this.onCellFocused(this.focusEventWhileNotReady ?? void 0);
    }
    onCellFocused(event) {
        const { beans: beans } = this;
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(beans)) return;
        if (!this.comp) {
            if (event) this.focusEventWhileNotReady = event;
            return;
        }
        const cellFocused = this.isCellFocused();
        const editing = beans.editSvc?.isEditing(this) ?? false;
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_FOCUS, cellFocused);
        if (cellFocused && event?.forceBrowserFocus) {
            let focusEl = this.comp.getFocusableElement();
            if (editing) {
                const focusableEls = $437b23f6a393c3bf$export$7acf44f59625b1f6(focusEl, null, true);
                if (focusableEls.length) focusEl = focusableEls[0];
            }
            focusEl.focus({
                preventScroll: !!event.preventScrollOnBrowserFocus
            });
        }
        if (cellFocused && event) this.rowCtrl.announceDescription();
    }
    createCellPosition() {
        const { rowIndex: rowIndex, rowPinned: rowPinned } = this.rowNode;
        this.cellPosition = {
            rowIndex: rowIndex,
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
            column: this.column
        };
    }
    // CSS Classes that only get applied once, they never change
    applyStaticCssClasses() {
        const { comp: comp } = this;
        comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL, true);
        comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_NOT_INLINE_EDITING, true);
        const autoHeight = this.column.isAutoHeight() == true;
        comp.toggleCss($437b23f6a393c3bf$var$CSS_AUTO_HEIGHT, autoHeight);
        comp.toggleCss($437b23f6a393c3bf$var$CSS_NORMAL_HEIGHT, !autoHeight);
    }
    onColumnHover() {
        this.beans.colHover?.onCellColumnHover(this.column, this.comp);
    }
    onColDefChanged() {
        if (!this.comp) return;
        if (this.column.isTooltipEnabled()) {
            this.disableTooltipFeature();
            this.enableTooltipFeature();
        } else this.disableTooltipFeature();
        this.setWrapText();
        if (this.editSvc?.isEditing(this)) this.editSvc?.handleColDefChanged(this);
        else this.refreshOrDestroyCell({
            force: true,
            suppressFlash: true
        });
    }
    setWrapText() {
        const value = this.column.getColDef().wrapText == true;
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_WRAP_TEXT, value);
    }
    dispatchCellContextMenuEvent(event) {
        const colDef = this.column.getColDef();
        const cellContextMenuEvent = this.createEvent(event, "cellContextMenu");
        const { beans: beans } = this;
        beans.eventSvc.dispatchEvent(cellContextMenuEvent);
        if (colDef.onCellContextMenu) window.setTimeout(()=>{
            beans.frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellContextMenu(cellContextMenuEvent);
            });
        }, 0);
    }
    getCellRenderer() {
        return this.comp?.getCellRenderer() ?? null;
    }
    destroy() {
        this.onCompAttachedFuncs = [];
        this.onEditorAttachedFuncs = [];
        if (this.isCellFocused() && this.hasBrowserFocus()) this.beans.focusSvc.attemptToRecoverFocus();
        super.destroy();
    }
    hasBrowserFocus() {
        return this.eGui?.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans)) ?? false;
    }
    createSelectionCheckbox() {
        const cbSelectionComponent = this.beans.selectionSvc?.createCheckboxSelectionComponent();
        if (!cbSelectionComponent) return void 0;
        this.beans.context.createBean(cbSelectionComponent);
        cbSelectionComponent.init({
            rowNode: this.rowNode,
            column: this.column
        });
        return cbSelectionComponent;
    }
    createDndSource() {
        const dndSourceComp = this.beans.registry.createDynamicBean("dndSourceComp", false, this.rowNode, this.column, this.eGui);
        if (dndSourceComp) this.beans.context.createBean(dndSourceComp);
        return dndSourceComp;
    }
    registerRowDragger(customElement, dragStartPixels, alwaysVisible) {
        if (this.customRowDragComp) {
            this.customRowDragComp.setDragElement(customElement, dragStartPixels);
            return;
        }
        const newComp = this.createRowDragComp(customElement, dragStartPixels, alwaysVisible);
        if (newComp) {
            this.customRowDragComp = newComp;
            this.addDestroyFunc(()=>{
                this.beans.context.destroyBean(newComp);
                this.customRowDragComp = null;
            });
            newComp.refreshVisibility();
        }
    }
    createRowDragComp(customElement, dragStartPixels, alwaysVisible) {
        const rowDragComp = this.beans.rowDragSvc?.createRowDragCompForCell(this.rowNode, this.column, ()=>this.value, customElement, dragStartPixels, alwaysVisible);
        if (!rowDragComp) return void 0;
        this.beans.context.createBean(rowDragComp);
        return rowDragComp;
    }
    cellEditorAttached() {
        for (const func of this.onEditorAttachedFuncs)func();
        this.onEditorAttachedFuncs = [];
    }
    setFocusedCellPosition(_cellPosition) {}
    getFocusedCellPosition() {
        return this.cellPosition;
    }
    // used by spannedCellCtrl
    refreshAriaRowIndex() {}
    /**
   * Returns the root element of the cell, could be a span container rather than the cell element.
   * @returns The root element of the cell.
   */ getRootElement() {
        return this.eGui;
    }
};
// packages/ag-grid-community/src/styling/stylingUtils.ts
function $437b23f6a393c3bf$var$processClassRules(expressionSvc, previousClassRules, classRules, params, onApplicableClass, onNotApplicableClass) {
    if (classRules == null && previousClassRules == null) return;
    const classesToApply = {};
    const classesToRemove = {};
    const forEachSingleClass = (className, callback)=>{
        for (const singleClass of className.split(" ")){
            if (singleClass.trim() == "") continue;
            callback(singleClass);
        }
    };
    if (classRules) {
        const classNames = Object.keys(classRules);
        for(let i = 0; i < classNames.length; i++){
            const className = classNames[i];
            const rule = classRules[className];
            let resultOfRule;
            if (typeof rule === "string") resultOfRule = expressionSvc ? expressionSvc.evaluate(rule, params) : true;
            else if (typeof rule === "function") resultOfRule = rule(params);
            forEachSingleClass(className, (singleClass)=>{
                resultOfRule ? classesToApply[singleClass] = true : classesToRemove[singleClass] = true;
            });
        }
    }
    if (previousClassRules && onNotApplicableClass) for (const className of Object.keys(previousClassRules))forEachSingleClass(className, (singleClass)=>{
        if (!classesToApply[singleClass]) classesToRemove[singleClass] = true;
    });
    if (onNotApplicableClass) Object.keys(classesToRemove).forEach(onNotApplicableClass);
    Object.keys(classesToApply).forEach(onApplicableClass);
}
// packages/ag-grid-community/src/styling/rowStyleService.ts
function $437b23f6a393c3bf$var$calculateRowLevel(rowNode) {
    if (rowNode.group) return rowNode.level;
    const parent = rowNode.parent;
    return parent ? parent.level + 1 : 0;
}
var $437b23f6a393c3bf$var$RowStyleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowStyleSvc";
    }
    processClassesFromGridOptions(classes, rowNode) {
        const gos = this.gos;
        const process = (rowCls)=>{
            if (typeof rowCls === "string") classes.push(rowCls);
            else if (Array.isArray(rowCls)) for (const e of rowCls)classes.push(e);
        };
        const rowClass = gos.get("rowClass");
        if (rowClass) process(rowClass);
        const rowClassFunc = gos.getCallback("getRowClass");
        if (rowClassFunc) {
            const params = {
                data: rowNode.data,
                node: rowNode,
                rowIndex: rowNode.rowIndex
            };
            const rowClassFuncResult = rowClassFunc(params);
            process(rowClassFuncResult);
        }
    }
    preProcessRowClassRules(classes, rowNode) {
        this.processRowClassRules(rowNode, (className)=>{
            classes.push(className);
        }, ()=>{});
    }
    processRowClassRules(rowNode, onApplicableClass, onNotApplicableClass) {
        const { gos: gos, expressionSvc: expressionSvc } = this.beans;
        const rowClassParams = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            data: rowNode.data,
            node: rowNode,
            rowIndex: rowNode.rowIndex
        });
        $437b23f6a393c3bf$var$processClassRules(expressionSvc, void 0, gos.get("rowClassRules"), rowClassParams, onApplicableClass, onNotApplicableClass);
    }
    processStylesFromGridOptions(rowNode) {
        const gos = this.gos;
        const rowStyle = gos.get("rowStyle");
        const rowStyleFunc = gos.getCallback("getRowStyle");
        let rowStyleFuncResult;
        if (rowStyleFunc) {
            const params = {
                data: rowNode.data,
                node: rowNode,
                rowIndex: rowNode.rowIndex
            };
            rowStyleFuncResult = rowStyleFunc(params);
        }
        if (rowStyleFuncResult || rowStyle) return Object.assign({}, rowStyle, rowStyleFuncResult);
        return void 0;
    }
};
// packages/ag-grid-community/src/rendering/row/rowCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence5 = 0;
var $437b23f6a393c3bf$var$RowCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowNode, beans, animateIn, useAnimationFrameForCreate, printLayout){
        super();
        this.rowNode = rowNode;
        this.useAnimationFrameForCreate = useAnimationFrameForCreate;
        this.printLayout = printLayout;
        this.allRowGuis = [];
        this.active = true;
        this.centerCellCtrls = {
            list: [],
            map: {}
        };
        this.leftCellCtrls = {
            list: [],
            map: {}
        };
        this.rightCellCtrls = {
            list: [],
            map: {}
        };
        this.slideInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.fadeInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.rowDragComps = [];
        this.lastMouseDownOnDragger = false;
        this.emptyStyle = {};
        this.updateColumnListsPending = false;
        this.rowId = null;
        /** sanitised */ this.businessKey = null;
        this.beans = beans;
        this.gos = beans.gos;
        this.paginationPage = beans.pagination?.getCurrentPage() ?? 0;
        this.suppressRowTransform = this.gos.get("suppressRowTransform");
        this.instanceId = rowNode.id + "-" + $437b23f6a393c3bf$var$instanceIdSequence5++;
        this.rowId = $437b23f6a393c3bf$export$3df06b741968da82(rowNode.id);
        this.initRowBusinessKey();
        this.rowFocused = beans.focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        this.rowLevel = $437b23f6a393c3bf$var$calculateRowLevel(this.rowNode);
        this.setRowType();
        this.setAnimateFlags(animateIn);
        this.rowStyles = this.processStylesFromGridOptions();
        this.rowEditStyleFeature = beans.editSvc?.createRowStyleFeature(this);
        this.addListeners();
    }
    initRowBusinessKey() {
        this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode");
        this.updateRowBusinessKey();
    }
    updateRowBusinessKey() {
        if (typeof this.businessKeyForNodeFunc !== "function") return;
        const businessKey = this.businessKeyForNodeFunc(this.rowNode);
        this.businessKey = $437b23f6a393c3bf$export$3df06b741968da82(businessKey);
    }
    updateGui(containerType, gui) {
        if (containerType === "left") this.leftGui = gui;
        else if (containerType === "right") this.rightGui = gui;
        else if (containerType === "fullWidth") this.fullWidthGui = gui;
        else this.centerGui = gui;
    }
    setComp(rowComp, element, containerType, compBean) {
        const { context: context, focusSvc: focusSvc } = this.beans;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBean);
        const gui = {
            rowComp: rowComp,
            element: element,
            containerType: containerType,
            compBean: compBean
        };
        this.allRowGuis.push(gui);
        this.updateGui(containerType, gui);
        this.initialiseRowComp(gui);
        const rowNode = this.rowNode;
        const isSsrmLoadingRow = this.rowType === "FullWidthLoading" || rowNode.stub;
        const isIrmLoadingRow = !rowNode.data && this.beans.rowModel.getType() === "infinite";
        if (!isSsrmLoadingRow && !isIrmLoadingRow && !rowNode.rowPinned) this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
        const focusableElement = this.fullWidthGui?.element;
        if (focusableElement) {
            const editing = this.beans.editSvc?.isEditing(this);
            if (!editing && focusSvc.isRowFocused(rowNode.rowIndex, rowNode.rowPinned) && focusSvc.shouldTakeFocus()) setTimeout(()=>focusableElement.focus({
                    preventScroll: true
                }), 0);
        }
    }
    unsetComp(containerType) {
        this.allRowGuis = this.allRowGuis.filter((rowGui)=>rowGui.containerType !== containerType);
        this.updateGui(containerType, void 0);
    }
    isCacheable() {
        return this.rowType === "FullWidthDetail" && this.gos.get("keepDetailRows");
    }
    setCached(cached) {
        const displayValue = cached ? "none" : "";
        for (const rg of this.allRowGuis)rg.element.style.display = displayValue;
    }
    initialiseRowComp(gui) {
        const gos = this.gos;
        this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus"));
        this.listenOnDomOrder(gui);
        this.onRowHeightChanged(gui);
        this.updateRowIndexes(gui);
        this.setFocusedClasses(gui);
        this.setStylesFromGridOptions(false, gui);
        if ($437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos) && this.rowNode.selectable) this.onRowSelected(gui);
        this.updateColumnLists(!this.useAnimationFrameForCreate);
        const comp = gui.rowComp;
        const initialRowClasses = this.getInitialRowClasses(gui.containerType);
        for (const name of initialRowClasses)comp.toggleCss(name, true);
        this.executeSlideAndFadeAnimations(gui);
        if (this.rowNode.group) $437b23f6a393c3bf$export$3ad3518dddf15485(gui.element, this.rowNode.expanded == true);
        this.setRowCompRowId(comp);
        this.setRowCompRowBusinessKey(comp);
        $437b23f6a393c3bf$var$_setDomData(gos, gui.element, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL, this);
        gui.compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(gos, gui.element, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL, null));
        if (this.useAnimationFrameForCreate) this.beans.animationFrameSvc.createTask(this.addHoverFunctionality.bind(this, gui), this.rowNode.rowIndex, "p2", false);
        else this.addHoverFunctionality(gui);
        if (this.isFullWidth()) this.setupFullWidth(gui);
        if (gos.get("rowDragEntireRow")) this.addRowDraggerToRow(gui);
        if (this.useAnimationFrameForCreate) this.beans.animationFrameSvc.addDestroyTask(()=>{
            if (!this.isAlive()) return;
            gui.rowComp.toggleCss("ag-after-created", true);
        });
        this.executeProcessRowPostCreateFunc();
    }
    setRowCompRowBusinessKey(comp) {
        if (this.businessKey == null) return;
        comp.setRowBusinessKey(this.businessKey);
    }
    setRowCompRowId(comp) {
        const rowId = $437b23f6a393c3bf$export$3df06b741968da82(this.rowNode.id);
        this.rowId = rowId;
        if (rowId == null) return;
        comp.setRowId(rowId);
    }
    executeSlideAndFadeAnimations(gui) {
        const { containerType: containerType } = gui;
        const shouldSlide = this.slideInAnimation[containerType];
        if (shouldSlide) {
            $437b23f6a393c3bf$export$8ea55376d0d59592(()=>{
                this.onTopChanged();
            });
            this.slideInAnimation[containerType] = false;
        }
        const shouldFade = this.fadeInAnimation[containerType];
        if (shouldFade) {
            $437b23f6a393c3bf$export$8ea55376d0d59592(()=>{
                gui.rowComp.toggleCss("ag-opacity-zero", false);
            });
            this.fadeInAnimation[containerType] = false;
        }
    }
    addRowDraggerToRow(gui) {
        const rowDragComp = this.beans.rowDragSvc?.createRowDragCompForRow(this.rowNode, gui.element);
        if (!rowDragComp) return;
        const rowDragBean = this.createBean(rowDragComp, this.beans.context);
        this.rowDragComps.push(rowDragBean);
        gui.compBean.addDestroyFunc(()=>{
            this.rowDragComps = this.rowDragComps.filter((r)=>r !== rowDragBean);
            this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, this.beans.context);
            this.destroyBean(rowDragBean, this.beans.context);
        });
    }
    setupFullWidth(gui) {
        const pinned = this.getPinnedForContainer(gui.containerType);
        const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
        gui.rowComp.showFullWidth(compDetails);
    }
    getFullWidthCellRenderers() {
        if (this.gos.get("embedFullWidthRows")) return this.allRowGuis.map((gui)=>gui?.rowComp?.getFullWidthCellRenderer());
        return [
            this.fullWidthGui?.rowComp?.getFullWidthCellRenderer()
        ];
    }
    executeProcessRowPostCreateFunc() {
        const func = this.gos.getCallback("processRowPostCreate");
        if (!func || !this.areAllContainersReady()) return;
        const params = {
            // areAllContainersReady asserts that centerGui is not null
            eRow: this.centerGui.element,
            ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
            ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
            node: this.rowNode,
            rowIndex: this.rowNode.rowIndex,
            addRenderedRowListener: this.addEventListener.bind(this)
        };
        func(params);
    }
    areAllContainersReady() {
        const { leftGui: leftGui, centerGui: centerGui, rightGui: rightGui, beans: { visibleCols: visibleCols } } = this;
        const isLeftReady = !!leftGui || !visibleCols.isPinningLeft();
        const isCenterReady = !!centerGui;
        const isRightReady = !!rightGui || !visibleCols.isPinningRight();
        return isLeftReady && isCenterReady && isRightReady;
    }
    isNodeFullWidthCell() {
        if (this.rowNode.detail) return true;
        const isFullWidthCellFunc = this.beans.gos.getCallback("isFullWidthRow");
        return isFullWidthCellFunc ? isFullWidthCellFunc({
            rowNode: this.rowNode
        }) : false;
    }
    setRowType() {
        const { rowNode: rowNode, gos: gos, beans: { colModel: colModel } } = this;
        const isStub = rowNode.stub && !gos.get("suppressServerSideFullWidthLoadingRow") && !gos.get("groupHideOpenParents");
        const isFullWidthCell = this.isNodeFullWidthCell();
        const isDetailCell = gos.get("masterDetail") && rowNode.detail;
        const pivotMode = colModel.isPivotMode();
        const isFullWidthGroup = $437b23f6a393c3bf$export$410912a9c501b8cc(gos, rowNode, pivotMode);
        if (isStub) this.rowType = "FullWidthLoading";
        else if (isDetailCell) this.rowType = "FullWidthDetail";
        else if (isFullWidthCell) this.rowType = "FullWidth";
        else if (isFullWidthGroup) this.rowType = "FullWidthGroup";
        else this.rowType = "Normal";
    }
    updateColumnLists(suppressAnimationFrame = false, useFlushSync = false) {
        if (this.isFullWidth()) return;
        const { animationFrameSvc: animationFrameSvc } = this.beans;
        const noAnimation = !animationFrameSvc?.active || suppressAnimationFrame || this.printLayout;
        if (noAnimation) {
            this.updateColumnListsImpl(useFlushSync);
            return;
        }
        if (this.updateColumnListsPending) return;
        animationFrameSvc.createTask(()=>{
            if (!this.active) return;
            this.updateColumnListsImpl(true);
        }, this.rowNode.rowIndex, "p1", false);
        this.updateColumnListsPending = true;
    }
    /**
   * Overridden by SpannedRowCtrl
   */ getNewCellCtrl(col) {
        const isCellSpan = this.beans.rowSpanSvc?.isCellSpanning(col, this.rowNode);
        if (isCellSpan) return void 0;
        return new $437b23f6a393c3bf$var$CellCtrl(col, this.rowNode, this.beans, this);
    }
    /**
   * Overridden by SpannedRowCtrl, if span context changes cell needs rebuilt
   */ isCorrectCtrlForSpan(cell) {
        return !this.beans.rowSpanSvc?.isCellSpanning(cell.column, this.rowNode);
    }
    createCellCtrls(prev, cols, pinned = null) {
        const res = {
            list: [],
            map: {}
        };
        const addCell = (colInstanceId, cellCtrl, index)=>{
            if (index != null) res.list.splice(index, 0, cellCtrl);
            else res.list.push(cellCtrl);
            res.map[colInstanceId] = cellCtrl;
        };
        const colsFromPrev = [];
        for (const col of cols){
            const colInstanceId = col.getInstanceId();
            let cellCtrl = prev.map[colInstanceId];
            if (cellCtrl && !this.isCorrectCtrlForSpan(cellCtrl)) {
                cellCtrl.destroy();
                cellCtrl = void 0;
            }
            if (!cellCtrl) cellCtrl = this.getNewCellCtrl(col);
            if (!cellCtrl) continue;
            addCell(colInstanceId, cellCtrl);
        }
        for (const prevCellCtrl of prev.list){
            const colInstanceId = prevCellCtrl.column.getInstanceId();
            const cellInResult = res.map[colInstanceId] != null;
            if (cellInResult) continue;
            const keepCell = !this.isCellEligibleToBeRemoved(prevCellCtrl, pinned);
            if (keepCell) colsFromPrev.push([
                colInstanceId,
                prevCellCtrl
            ]);
            else prevCellCtrl.destroy();
        }
        if (colsFromPrev.length) for (const [colInstanceId, cellCtrl] of colsFromPrev){
            const index = res.list.findIndex((ctrl)=>ctrl.column.getLeft() > cellCtrl.column.getLeft());
            const normalisedIndex = index === -1 ? void 0 : Math.max(index - 1, 0);
            addCell(colInstanceId, cellCtrl, normalisedIndex);
        }
        const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (focusedCell && focusedCell.column.getPinned() == pinned) {
            const focusedColInstanceId = focusedCell.column.getInstanceId();
            const focusedCellCtrl = res.map[focusedColInstanceId];
            if (!focusedCellCtrl && visibleCols.allCols.includes(focusedCell.column)) {
                const cellCtrl = this.createFocusedCellCtrl();
                if (cellCtrl) {
                    const index = res.list.findIndex((ctrl)=>ctrl.column.getLeft() > cellCtrl.column.getLeft());
                    const normalisedIndex = index === -1 ? void 0 : Math.max(index - 1, 0);
                    addCell(focusedColInstanceId, cellCtrl, normalisedIndex);
                }
            }
        }
        return res;
    }
    /**
   * Creates a new cell ctrl for the focused cell, if this is the correct row ctrl.
   * @returns a CellCtrl for the focused cell, if required.
   */ createFocusedCellCtrl() {
        const { focusSvc: focusSvc, rowSpanSvc: rowSpanSvc } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (!focusedCell) return void 0;
        const focusedSpan = rowSpanSvc?.getCellSpan(focusedCell.column, this.rowNode);
        if (focusedSpan) {
            if (focusedSpan.firstNode !== this.rowNode || !focusedSpan.doesSpanContain(focusedCell)) return void 0;
        } else if (!focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned)) return void 0;
        return this.getNewCellCtrl(focusedCell.column);
    }
    updateColumnListsImpl(useFlushSync) {
        this.updateColumnListsPending = false;
        this.createAllCellCtrls();
        this.setCellCtrls(useFlushSync);
    }
    setCellCtrls(useFlushSync) {
        for (const item of this.allRowGuis){
            const cellControls = this.getCellCtrlsForContainer(item.containerType);
            item.rowComp.setCellCtrls(cellControls, useFlushSync);
        }
    }
    getCellCtrlsForContainer(containerType) {
        switch(containerType){
            case "left":
                return this.leftCellCtrls.list;
            case "right":
                return this.rightCellCtrls.list;
            case "fullWidth":
                return [];
            case "center":
                return this.centerCellCtrls.list;
        }
    }
    createAllCellCtrls() {
        const colViewport = this.beans.colViewport;
        const presentedColsService = this.beans.visibleCols;
        if (this.printLayout) {
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, presentedColsService.allCols);
            this.leftCellCtrls = {
                list: [],
                map: {}
            };
            this.rightCellCtrls = {
                list: [],
                map: {}
            };
        } else {
            const centerCols = colViewport.getColsWithinViewport(this.rowNode);
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, centerCols);
            const leftCols = presentedColsService.getLeftColsForRow(this.rowNode);
            this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, leftCols, "left");
            const rightCols = presentedColsService.getRightColsForRow(this.rowNode);
            this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, rightCols, "right");
        }
    }
    isCellEligibleToBeRemoved(cellCtrl, nextContainerPinned) {
        const REMOVE_CELL = true;
        const KEEP_CELL = false;
        const { column: column } = cellCtrl;
        if (column.getPinned() != nextContainerPinned) return REMOVE_CELL;
        if (!this.isCorrectCtrlForSpan(cellCtrl)) return REMOVE_CELL;
        const { visibleCols: visibleCols, editSvc: editSvc } = this.beans;
        const editing = editSvc?.isEditing(cellCtrl);
        const focused = cellCtrl.isCellFocused();
        const mightWantToKeepCell = editing || focused;
        if (mightWantToKeepCell) {
            const displayedColumns = visibleCols.allCols;
            const cellStillDisplayed = displayedColumns.indexOf(column) >= 0;
            return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
        }
        return REMOVE_CELL;
    }
    getDomOrder() {
        const isEnsureDomOrder = this.gos.get("ensureDomOrder");
        return isEnsureDomOrder || $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
    }
    listenOnDomOrder(gui) {
        const listener = ()=>{
            gui.rowComp.setDomOrder(this.getDomOrder());
        };
        gui.compBean.addManagedPropertyListeners([
            "domLayout",
            "ensureDomOrder"
        ], listener);
    }
    setAnimateFlags(animateIn) {
        if (this.rowNode.sticky || !animateIn) return;
        const oldRowTopExists = $437b23f6a393c3bf$export$25d27f17d3af40f7(this.rowNode.oldRowTop);
        const { visibleCols: visibleCols } = this.beans;
        const pinningLeft = visibleCols.isPinningLeft();
        const pinningRight = visibleCols.isPinningRight();
        if (oldRowTopExists) {
            const { slideInAnimation: slideInAnimation } = this;
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                slideInAnimation.fullWidth = true;
                return;
            }
            slideInAnimation.center = true;
            slideInAnimation.left = pinningLeft;
            slideInAnimation.right = pinningRight;
        } else {
            const { fadeInAnimation: fadeInAnimation } = this;
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                fadeInAnimation.fullWidth = true;
                return;
            }
            fadeInAnimation.center = true;
            fadeInAnimation.left = pinningLeft;
            fadeInAnimation.right = pinningRight;
        }
    }
    isFullWidth() {
        return this.rowType !== "Normal";
    }
    refreshFullWidth() {
        const tryRefresh = (gui, pinned)=>{
            if (!gui) return true;
            return gui.rowComp.refreshFullWidth(()=>{
                const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
                return compDetails.params;
            });
        };
        const fullWidthSuccess = tryRefresh(this.fullWidthGui, null);
        const centerSuccess = tryRefresh(this.centerGui, null);
        const leftSuccess = tryRefresh(this.leftGui, "left");
        const rightSuccess = tryRefresh(this.rightGui, "right");
        const allFullWidthRowsRefreshed = fullWidthSuccess && centerSuccess && leftSuccess && rightSuccess;
        return allFullWidthRowsRefreshed;
    }
    addListeners() {
        const { beans: beans, gos: gos, rowNode: rowNode } = this;
        const { expansionSvc: expansionSvc, eventSvc: eventSvc, context: context, rowSpanSvc: rowSpanSvc } = beans;
        this.addManagedListeners(this.rowNode, {
            heightChanged: ()=>this.onRowHeightChanged(),
            rowSelected: ()=>this.onRowSelected(),
            rowIndexChanged: this.onRowIndexChanged.bind(this),
            topChanged: this.onTopChanged.bind(this),
            ...expansionSvc?.getRowExpandedListeners(this) ?? {}
        });
        if (rowNode.detail) this.addManagedListeners(rowNode.parent, {
            dataChanged: this.onRowNodeDataChanged.bind(this)
        });
        this.addManagedListeners(rowNode, {
            dataChanged: this.onRowNodeDataChanged.bind(this),
            cellChanged: this.postProcessCss.bind(this),
            rowHighlightChanged: this.onRowNodeHighlightChanged.bind(this),
            draggingChanged: this.postProcessRowDragging.bind(this),
            uiLevelChanged: this.onUiLevelChanged.bind(this),
            rowPinned: this.onRowPinned.bind(this)
        });
        this.addManagedListeners(eventSvc, {
            paginationPixelOffsetChanged: this.onPaginationPixelOffsetChanged.bind(this),
            heightScaleChanged: this.onTopChanged.bind(this),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            virtualColumnsChanged: this.onVirtualColumnsChanged.bind(this),
            cellFocused: this.onCellFocusChanged.bind(this),
            cellFocusCleared: this.onCellFocusChanged.bind(this),
            paginationChanged: this.onPaginationChanged.bind(this),
            modelUpdated: this.refreshFirstAndLastRowStyles.bind(this),
            columnMoved: ()=>this.updateColumnLists()
        });
        if (rowSpanSvc) this.addManagedListeners(rowSpanSvc, {
            spannedCellsUpdated: ({ pinned: pinned })=>{
                if (pinned && !rowNode.rowPinned) return;
                this.updateColumnLists();
            }
        });
        this.addDestroyFunc(()=>{
            this.rowDragComps = this.destroyBeans(this.rowDragComps, context);
            this.tooltipFeature = this.destroyBean(this.tooltipFeature, context);
            this.rowEditStyleFeature = this.destroyBean(this.rowEditStyleFeature, context);
        });
        this.addManagedPropertyListeners([
            "rowStyle",
            "getRowStyle",
            "rowClass",
            "getRowClass",
            "rowClassRules"
        ], this.postProcessCss.bind(this));
        this.addManagedPropertyListener("rowDragEntireRow", ()=>{
            const useRowDragEntireRow = gos.get("rowDragEntireRow");
            if (useRowDragEntireRow) {
                for (const gui of this.allRowGuis)this.addRowDraggerToRow(gui);
                return;
            }
            this.rowDragComps = this.destroyBeans(this.rowDragComps, context);
        });
        this.addListenersForCellComps();
    }
    addListenersForCellComps() {
        this.addManagedListeners(this.rowNode, {
            rowIndexChanged: ()=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onRowIndexChanged();
            },
            cellChanged: (event)=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onCellChanged(event);
            }
        });
    }
    /** Should only ever be triggered on source rows (i.e. not on pinned siblings) */ onRowPinned() {
        for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-row-pinned-source", !!this.rowNode.pinnedSibling);
    }
    onRowNodeDataChanged(event) {
        this.refreshRow({
            suppressFlash: !event.update,
            newData: !event.update
        });
    }
    refreshRow(params) {
        const fullWidthChanged = this.isFullWidth() !== !!this.isNodeFullWidthCell();
        if (fullWidthChanged) {
            this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        if (this.isFullWidth()) {
            const refresh = this.refreshFullWidth();
            if (!refresh) this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        for (const cellCtrl of this.getAllCellCtrls())cellCtrl.refreshCell(params);
        for (const gui of this.allRowGuis){
            this.setRowCompRowId(gui.rowComp);
            this.updateRowBusinessKey();
            this.setRowCompRowBusinessKey(gui.rowComp);
        }
        this.onRowSelected();
        this.postProcessCss();
    }
    postProcessCss() {
        this.setStylesFromGridOptions(true);
        this.postProcessClassesFromGridOptions();
        this.postProcessRowClassRules();
        this.rowEditStyleFeature?.applyRowStyles();
        this.postProcessRowDragging();
    }
    onRowNodeHighlightChanged() {
        const rowDropHighlightSvc = this.beans.rowDropHighlightSvc;
        const highlighted = rowDropHighlightSvc?.row === this.rowNode ? rowDropHighlightSvc.position : "none";
        const aboveOn = highlighted === "above";
        const insideOn = highlighted === "inside";
        const belowOn = highlighted === "below";
        const highlightActive = highlighted !== "none";
        const dropEdge = aboveOn || belowOn;
        const uiLevel = this.rowNode.uiLevel;
        const shouldIndent = dropEdge && uiLevel > 0;
        const highlightLevel = shouldIndent ? uiLevel.toString() : "0";
        for (const gui of this.allRowGuis){
            const rowComp = gui.rowComp;
            rowComp.toggleCss("ag-row-highlight-above", aboveOn);
            rowComp.toggleCss("ag-row-highlight-inside", insideOn);
            rowComp.toggleCss("ag-row-highlight-below", belowOn);
            rowComp.toggleCss("ag-row-highlight-indent", shouldIndent);
            if (highlightActive) gui.element.style.setProperty("--ag-row-highlight-level", highlightLevel);
            else gui.element.style.removeProperty("--ag-row-highlight-level");
        }
    }
    postProcessRowDragging() {
        const dragging = this.rowNode.dragging;
        for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-row-dragging", dragging);
    }
    onDisplayedColumnsChanged() {
        this.updateColumnLists(true);
        this.beans.rowAutoHeight?.requestCheckAutoHeight();
    }
    onVirtualColumnsChanged() {
        this.updateColumnLists(false, true);
    }
    getRowPosition() {
        return {
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(this.rowNode.rowPinned),
            rowIndex: this.rowNode.rowIndex
        };
    }
    onKeyboardNavigate(keyboardEvent) {
        const groupInfo = this.findFullWidthInfoForEvent(keyboardEvent);
        if (!groupInfo) return;
        const { rowGui: rowGui, column: column } = groupInfo;
        const currentFullWidthContainer = rowGui.element;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        if (!isFullWidthContainerFocused) return;
        const node = this.rowNode;
        const { focusSvc: focusSvc, navigation: navigation } = this.beans;
        const lastFocusedCell = focusSvc.getFocusedCell();
        const cellPosition = {
            rowIndex: node.rowIndex,
            rowPinned: node.rowPinned,
            column: lastFocusedCell?.column ?? column
        };
        navigation?.navigateToNextCell(keyboardEvent, keyboardEvent.key, cellPosition, true);
        keyboardEvent.preventDefault();
    }
    onTabKeyDown(keyboardEvent) {
        if (keyboardEvent.defaultPrevented || $437b23f6a393c3bf$export$9a48e23524c6d58(keyboardEvent)) return;
        const currentFullWidthComp = this.allRowGuis.find((c)=>c.element.contains(keyboardEvent.target));
        const currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        let isDetailGridCellFocused = false;
        if (currentFullWidthContainer && activeEl) isDetailGridCellFocused = currentFullWidthContainer.contains(activeEl) && activeEl.classList.contains("ag-cell");
        let nextEl = null;
        if (!isFullWidthContainerFocused && !isDetailGridCellFocused) nextEl = $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, currentFullWidthContainer, false, keyboardEvent.shiftKey);
        if (this.isFullWidth() && isFullWidthContainerFocused || !nextEl) this.beans.navigation?.onTabKeyDown(this, keyboardEvent);
    }
    getFullWidthElement() {
        if (this.fullWidthGui) return this.fullWidthGui.element;
        return null;
    }
    getRowYPosition() {
        const displayedEl = this.allRowGuis.find((el)=>$437b23f6a393c3bf$export$2badf4aa566524cb(el.element))?.element;
        if (displayedEl) return displayedEl.getBoundingClientRect().top;
        return 0;
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        const tabIndex = this.isFullWidth() && suppressCellFocus ? void 0 : this.gos.get("tabIndex");
        for (const gui of this.allRowGuis)$437b23f6a393c3bf$var$_addOrRemoveAttribute(gui.element, "tabindex", tabIndex);
    }
    onFullWidthRowFocused(event) {
        const node = this.rowNode;
        const isFocused = !event ? false : this.isFullWidth() && event.rowIndex === node.rowIndex && event.rowPinned == node.rowPinned;
        let element;
        if (this.fullWidthGui) element = this.fullWidthGui.element;
        else {
            const column = this.beans.colModel.getCol(event?.column);
            const pinned = column?.pinned;
            if (pinned) element = pinned === "right" ? this.rightGui?.element : this.leftGui?.element;
            else element = this.centerGui?.element;
        }
        if (!element) return;
        element.classList.toggle("ag-full-width-focus", isFocused);
        if (isFocused && event?.forceBrowserFocus) element.focus({
            preventScroll: true
        });
    }
    recreateCell(cellCtrl) {
        this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, cellCtrl);
        this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, cellCtrl);
        this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, cellCtrl);
        cellCtrl.destroy();
        this.updateColumnLists();
    }
    removeCellCtrl(prev, cellCtrlToRemove) {
        const res = {
            list: [],
            map: {}
        };
        for (const cellCtrl of prev.list){
            if (cellCtrl === cellCtrlToRemove) continue;
            res.list.push(cellCtrl);
            res.map[cellCtrl.column.getInstanceId()] = cellCtrl;
        }
        return res;
    }
    onMouseEvent(eventName, mouseEvent) {
        switch(eventName){
            case "dblclick":
                this.onRowDblClick(mouseEvent);
                break;
            case "click":
                this.onRowClick(mouseEvent);
                break;
            case "touchstart":
            case "mousedown":
                this.onRowMouseDown(mouseEvent);
                break;
        }
    }
    createRowEvent(type, domEvent) {
        const { rowNode: rowNode } = this;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            type: type,
            node: rowNode,
            data: rowNode.data,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned,
            event: domEvent
        });
    }
    createRowEventWithSource(type, domEvent) {
        const event = this.createRowEvent(type, domEvent);
        event.source = this;
        return event;
    }
    onRowDblClick(mouseEvent) {
        if ($437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        const rowEvent = this.createRowEventWithSource("rowDoubleClicked", mouseEvent);
        rowEvent.isEventHandlingSuppressed = this.isSuppressMouseEvent(mouseEvent);
        this.beans.eventSvc.dispatchEvent(rowEvent);
    }
    findFullWidthInfoForEvent(event) {
        if (!event) return;
        const rowGui = this.findFullWidthRowGui(event.target);
        const column = this.getColumnForFullWidth(rowGui);
        if (!rowGui || !column) return;
        return {
            rowGui: rowGui,
            column: column
        };
    }
    findFullWidthRowGui(target) {
        return this.allRowGuis.find((c)=>c.element.contains(target));
    }
    getColumnForFullWidth(fullWidthRowGui) {
        const { visibleCols: visibleCols } = this.beans;
        switch(fullWidthRowGui?.containerType){
            case "center":
                return visibleCols.centerCols[0];
            case "left":
                return visibleCols.leftCols[0];
            case "right":
                return visibleCols.rightCols[0];
            default:
                return visibleCols.allCols[0];
        }
    }
    onRowMouseDown(mouseEvent) {
        this.lastMouseDownOnDragger = $437b23f6a393c3bf$var$_isElementChildOfClass(mouseEvent.target, "ag-row-drag", 3);
        if (!this.isFullWidth() || this.isSuppressMouseEvent(mouseEvent)) return;
        const { rangeSvc: rangeSvc, focusSvc: focusSvc } = this.beans;
        rangeSvc?.removeAllCellRanges();
        const groupInfo = this.findFullWidthInfoForEvent(mouseEvent);
        if (!groupInfo) return;
        const { rowGui: rowGui, column: column } = groupInfo;
        const element = rowGui.element;
        const target = mouseEvent.target;
        const node = this.rowNode;
        let forceBrowserFocus = mouseEvent.defaultPrevented || $437b23f6a393c3bf$export$8caf403dacd36a68();
        if (element && element.contains(target) && $437b23f6a393c3bf$var$_isFocusableFormField(target)) forceBrowserFocus = false;
        focusSvc.setFocusedCell({
            rowIndex: node.rowIndex,
            column: column,
            rowPinned: node.rowPinned,
            forceBrowserFocus: forceBrowserFocus
        });
    }
    isSuppressMouseEvent(mouseEvent) {
        const { gos: gos, rowNode: rowNode } = this;
        if (this.isFullWidth()) {
            const fullWidthRowGui = this.findFullWidthRowGui(mouseEvent.target);
            return $437b23f6a393c3bf$var$_suppressFullWidthMouseEvent(gos, fullWidthRowGui?.rowComp.getFullWidthCellRendererParams(), rowNode, mouseEvent);
        }
        const cellCtrl = $437b23f6a393c3bf$export$b5bf61dcea514250(gos, mouseEvent.target);
        return cellCtrl != null && $437b23f6a393c3bf$export$d7866551eadae1d3(gos, cellCtrl.column, rowNode, mouseEvent);
    }
    onRowClick(mouseEvent) {
        const stop = $437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent) || this.lastMouseDownOnDragger;
        if (stop) return;
        const isSuppressMouseEvent = this.isSuppressMouseEvent(mouseEvent);
        const { eventSvc: eventSvc, selectionSvc: selectionSvc } = this.beans;
        const rowEvent = this.createRowEventWithSource("rowClicked", mouseEvent);
        rowEvent.isEventHandlingSuppressed = isSuppressMouseEvent;
        eventSvc.dispatchEvent(rowEvent);
        if (isSuppressMouseEvent) return;
        selectionSvc?.handleSelectionEvent(mouseEvent, this.rowNode, "rowClicked");
    }
    setupDetailRowAutoHeight(eDetailGui) {
        if (this.rowType !== "FullWidthDetail") return;
        this.beans.masterDetailSvc?.setupDetailRowAutoHeight(this, eDetailGui);
    }
    createFullWidthCompDetails(eRow, pinned) {
        const { gos: gos, rowNode: rowNode } = this;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            fullWidth: true,
            data: rowNode.data,
            node: rowNode,
            value: rowNode.key,
            valueFormatted: rowNode.key,
            // these need to be taken out, as part of 'afterAttached' now
            eGridCell: eRow,
            eParentOfValue: eRow,
            pinned: pinned,
            addRenderedRowListener: this.addEventListener.bind(this),
            // This is not on the type of ICellRendererParams
            registerRowDragger: (rowDraggerElement, dragStartPixels, value, rowDragEntireRow)=>this.addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value, rowDragEntireRow),
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.setupFullWidthRowTooltip(value, shouldDisplayTooltip);
            }
        });
        const compFactory = this.beans.userCompFactory;
        switch(this.rowType){
            case "FullWidthDetail":
                return $437b23f6a393c3bf$var$_getFullWidthDetailCellRendererDetails(compFactory, params);
            case "FullWidthGroup":
                {
                    const { value: value, valueFormatted: valueFormatted } = this.beans.valueSvc.getValueForDisplay({
                        node: this.rowNode,
                        includeValueFormatted: true
                    });
                    params.value = value;
                    params.valueFormatted = valueFormatted;
                    return $437b23f6a393c3bf$var$_getFullWidthGroupCellRendererDetails(compFactory, params);
                }
            case "FullWidthLoading":
                return $437b23f6a393c3bf$var$_getFullWidthLoadingCellRendererDetails(compFactory, params);
            default:
                return $437b23f6a393c3bf$var$_getFullWidthCellRendererDetails(compFactory, params);
        }
    }
    setupFullWidthRowTooltip(value, shouldDisplayTooltip) {
        if (!this.fullWidthGui) return;
        this.tooltipFeature = this.beans.tooltipSvc?.setupFullWidthRowTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value = "", alwaysVisible) {
        const { rowDragSvc: rowDragSvc, context: context } = this.beans;
        if (!rowDragSvc || !this.isFullWidth()) return;
        const rowDragComp = rowDragSvc.createRowDragComp(()=>value, this.rowNode, void 0, rowDraggerElement, dragStartPixels, alwaysVisible);
        this.createBean(rowDragComp, context);
        this.addDestroyFunc(()=>{
            this.destroyBean(rowDragComp, context);
        });
    }
    onUiLevelChanged() {
        const newLevel = $437b23f6a393c3bf$var$calculateRowLevel(this.rowNode);
        if (this.rowLevel != newLevel) {
            const classToAdd = "ag-row-level-" + newLevel;
            const classToRemove = "ag-row-level-" + this.rowLevel;
            for (const gui of this.allRowGuis){
                gui.rowComp.toggleCss(classToAdd, true);
                gui.rowComp.toggleCss(classToRemove, false);
            }
        }
        this.rowLevel = newLevel;
    }
    isFirstRowOnPage() {
        return this.rowNode.rowIndex === this.beans.pageBounds.getFirstRow();
    }
    isLastRowOnPage() {
        return this.rowNode.rowIndex === this.beans.pageBounds.getLastRow();
    }
    refreshFirstAndLastRowStyles() {
        const newFirst = this.isFirstRowOnPage();
        const newLast = this.isLastRowOnPage();
        if (this.firstRowOnPage !== newFirst) {
            this.firstRowOnPage = newFirst;
            for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-row-first", newFirst);
        }
        if (this.lastRowOnPage !== newLast) {
            this.lastRowOnPage = newLast;
            for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-row-last", newLast);
        }
    }
    getAllCellCtrls() {
        if (this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0) return this.centerCellCtrls.list;
        const res = [
            ...this.centerCellCtrls.list,
            ...this.leftCellCtrls.list,
            ...this.rightCellCtrls.list
        ];
        return res;
    }
    postProcessClassesFromGridOptions() {
        const cssClasses = [];
        this.beans.rowStyleSvc?.processClassesFromGridOptions(cssClasses, this.rowNode);
        if (!cssClasses.length) return;
        for (const classStr of cssClasses)for (const c of this.allRowGuis)c.rowComp.toggleCss(classStr, true);
    }
    postProcessRowClassRules() {
        this.beans.rowStyleSvc?.processRowClassRules(this.rowNode, (className)=>{
            for (const gui of this.allRowGuis)gui.rowComp.toggleCss(className, true);
        }, (className)=>{
            for (const gui of this.allRowGuis)gui.rowComp.toggleCss(className, false);
        });
    }
    setStylesFromGridOptions(updateStyles, gui) {
        if (updateStyles) this.rowStyles = this.processStylesFromGridOptions();
        this.forEachGui(gui, (gui2)=>gui2.rowComp.setUserStyles(this.rowStyles));
    }
    getPinnedForContainer(rowContainerType) {
        if (rowContainerType === "left" || rowContainerType === "right") return rowContainerType;
        return null;
    }
    getInitialRowClasses(rowContainerType) {
        const pinned = this.getPinnedForContainer(rowContainerType);
        const fullWidthRow = this.isFullWidth();
        const { rowNode: rowNode, beans: beans } = this;
        const classes = [];
        classes.push("ag-row");
        classes.push(this.rowFocused ? "ag-row-focus" : "ag-row-no-focus");
        if (this.fadeInAnimation[rowContainerType]) classes.push("ag-opacity-zero");
        classes.push(rowNode.rowIndex % 2 === 0 ? "ag-row-even" : "ag-row-odd");
        if (rowNode.isRowPinned()) {
            classes.push("ag-row-pinned");
            if (beans.pinnedRowModel?.isManual()) classes.push("ag-row-pinned-manual");
        }
        if (!rowNode.isRowPinned() && rowNode.pinnedSibling) classes.push("ag-row-pinned-source");
        if (rowNode.isSelected()) classes.push("ag-row-selected");
        if (rowNode.footer) classes.push("ag-row-footer");
        classes.push("ag-row-level-" + this.rowLevel);
        if (rowNode.stub) classes.push("ag-row-loading");
        if (fullWidthRow) classes.push("ag-full-width-row");
        beans.expansionSvc?.addExpandedCss(classes, rowNode);
        if (rowNode.dragging) classes.push("ag-row-dragging");
        const { rowStyleSvc: rowStyleSvc } = beans;
        if (rowStyleSvc) {
            rowStyleSvc.processClassesFromGridOptions(classes, rowNode);
            rowStyleSvc.preProcessRowClassRules(classes, rowNode);
        }
        classes.push(this.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute");
        if (this.isFirstRowOnPage()) classes.push("ag-row-first");
        if (this.isLastRowOnPage()) classes.push("ag-row-last");
        if (fullWidthRow) {
            if (pinned === "left") classes.push("ag-cell-last-left-pinned");
            if (pinned === "right") classes.push("ag-cell-first-right-pinned");
        }
        return classes;
    }
    processStylesFromGridOptions() {
        return this.beans.rowStyleSvc?.processStylesFromGridOptions(this.rowNode) ?? this.emptyStyle;
    }
    onRowSelected(gui) {
        this.beans.selectionSvc?.onRowCtrlSelected(this, (gui2)=>{
            if (gui2 === this.centerGui || gui2 === this.fullWidthGui) this.announceDescription();
        }, gui);
    }
    announceDescription() {
        this.beans.selectionSvc?.announceAriaRowSelection(this.rowNode);
    }
    addHoverFunctionality(eGui) {
        if (!this.active) return;
        const { element: element, compBean: compBean } = eGui;
        const { rowNode: rowNode, beans: beans, gos: gos } = this;
        compBean.addManagedListeners(element, {
            // We use pointer events here instead of mouse events, as pointer events
            // are more reliable for hover detection, especially with touch devices
            // or hybrid touch + mouse devices.
            pointerenter: (e)=>{
                if (e.pointerType === "mouse") rowNode.dispatchRowEvent("mouseEnter");
            },
            pointerleave: (e)=>{
                if (e.pointerType === "mouse") rowNode.dispatchRowEvent("mouseLeave");
            }
        });
        compBean.addManagedListeners(rowNode, {
            mouseEnter: ()=>{
                if (!beans.dragSvc?.dragging && !gos.get("suppressRowHoverHighlight")) {
                    element.classList.add("ag-row-hover");
                    rowNode.setHovered(true);
                }
            },
            mouseLeave: ()=>{
                this.resetHoveredStatus(element);
            }
        });
    }
    resetHoveredStatus(el) {
        const elements = el ? [
            el
        ] : this.allRowGuis.map((gui)=>gui.element);
        for (const element of elements)element.classList.remove("ag-row-hover");
        this.rowNode.setHovered(false);
    }
    // for animation, we don't want to animate entry or exit to a very far away pixel,
    // otherwise the row would move so fast, it would appear to disappear. so this method
    // moves the row closer to the viewport if it is far away, so the row slide in / out
    // at a speed the user can see.
    roundRowTopToBounds(rowTop) {
        const range = this.beans.ctrlsSvc.getScrollFeature().getApproximateVScollPosition();
        const minPixel = this.applyPaginationOffset(range.top, true) - 100;
        const maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
        return Math.min(Math.max(minPixel, rowTop), maxPixel);
    }
    forEachGui(gui, callback) {
        if (gui) callback(gui);
        else for (const gui2 of this.allRowGuis)callback(gui2);
    }
    isRowRendered() {
        return this.allRowGuis.length > 0;
    }
    onRowHeightChanged(gui) {
        if (this.rowNode.rowHeight == null) return;
        const rowHeight = this.rowNode.rowHeight;
        const defaultRowHeight = this.beans.environment.getDefaultRowHeight();
        const isHeightFromFunc = $437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(this.gos);
        const heightFromFunc = isHeightFromFunc ? $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, this.rowNode).height : void 0;
        const lineHeight = heightFromFunc ? `${Math.min(defaultRowHeight, heightFromFunc) - 2}px` : void 0;
        this.forEachGui(gui, (gui2)=>{
            gui2.element.style.height = `${rowHeight}px`;
            if (lineHeight) gui2.element.style.setProperty("--ag-line-height", lineHeight);
        });
    }
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroyFirstPass(suppressAnimation = false) {
        this.active = false;
        const { rowNode: rowNode } = this;
        if (!suppressAnimation && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos) && !rowNode.sticky) {
            const rowStillVisibleJustNotInViewport = rowNode.rowTop != null;
            if (rowStillVisibleJustNotInViewport) {
                const rowTop = this.roundRowTopToBounds(rowNode.rowTop);
                this.setRowTop(rowTop);
            } else for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-opacity-zero", true);
        }
        if (this.fullWidthGui?.element.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) this.beans.focusSvc.attemptToRecoverFocus();
        rowNode.setHovered(false);
        const event = this.createRowEvent("virtualRowRemoved");
        this.dispatchLocalEvent(event);
        this.beans.eventSvc.dispatchEvent(event);
        super.destroy();
    }
    destroySecondPass() {
        this.allRowGuis.length = 0;
        const destroyCellCtrls = (ctrls)=>{
            for (const c of ctrls.list)c.destroy();
            return {
                list: [],
                map: {}
            };
        };
        this.centerCellCtrls = destroyCellCtrls(this.centerCellCtrls);
        this.leftCellCtrls = destroyCellCtrls(this.leftCellCtrls);
        this.rightCellCtrls = destroyCellCtrls(this.rightCellCtrls);
    }
    setFocusedClasses(gui) {
        this.forEachGui(gui, (gui2)=>{
            gui2.rowComp.toggleCss("ag-row-focus", this.rowFocused);
            gui2.rowComp.toggleCss("ag-row-no-focus", !this.rowFocused);
        });
    }
    onCellFocusChanged() {
        const { focusSvc: focusSvc } = this.beans;
        const rowFocused = focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        if (rowFocused !== this.rowFocused) {
            this.rowFocused = rowFocused;
            this.setFocusedClasses();
        }
    }
    onPaginationChanged() {
        const currentPage = this.beans.pagination?.getCurrentPage() ?? 0;
        if (this.paginationPage !== currentPage) {
            this.paginationPage = currentPage;
            this.onTopChanged();
        }
        this.refreshFirstAndLastRowStyles();
    }
    onTopChanged() {
        this.setRowTop(this.rowNode.rowTop);
    }
    onPaginationPixelOffsetChanged() {
        this.onTopChanged();
    }
    // applies pagination offset, eg if on second page, and page height is 500px, then removes
    // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
    // reverse will take the offset away rather than add.
    applyPaginationOffset(topPx, reverse = false) {
        if (this.rowNode.isRowPinned() || this.rowNode.sticky) return topPx;
        const pixelOffset = this.beans.pageBounds.getPixelOffset();
        const multiplier = reverse ? 1 : -1;
        return topPx + pixelOffset * multiplier;
    }
    setRowTop(pixels) {
        if (this.printLayout) return;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(pixels)) {
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            const skipScaling = this.rowNode.isRowPinned() || this.rowNode.sticky;
            const afterScalingPixels = skipScaling ? afterPaginationPixels : this.beans.rowContainerHeight.getRealPixelPosition(afterPaginationPixels);
            const topPx = `${afterScalingPixels}px`;
            this.setRowTopStyle(topPx);
        }
    }
    // the top needs to be set into the DOM element when the element is created, not updated afterwards.
    // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
    // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
    // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
    // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
    // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
    // time, the row would animate down (ie from position zero).
    getInitialRowTop(rowContainerType) {
        return this.suppressRowTransform ? this.getInitialRowTopShared(rowContainerType) : void 0;
    }
    getInitialTransform(rowContainerType) {
        return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(rowContainerType)})`;
    }
    getInitialRowTopShared(rowContainerType) {
        if (this.printLayout) return "";
        const rowNode = this.rowNode;
        let rowTop;
        if (rowNode.sticky) rowTop = rowNode.stickyRowTop;
        else {
            const pixels = this.slideInAnimation[rowContainerType] ? this.roundRowTopToBounds(rowNode.oldRowTop) : rowNode.rowTop;
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            rowTop = rowNode.isRowPinned() ? afterPaginationPixels : this.beans.rowContainerHeight.getRealPixelPosition(afterPaginationPixels);
        }
        return rowTop + "px";
    }
    setRowTopStyle(topPx) {
        for (const gui of this.allRowGuis)this.suppressRowTransform ? gui.rowComp.setTop(topPx) : gui.rowComp.setTransform(`translateY(${topPx})`);
    }
    getCellCtrl(column, skipColSpanSearch = false) {
        let res = null;
        for (const cellCtrl of this.getAllCellCtrls())if (cellCtrl.column == column) res = cellCtrl;
        if (res != null || skipColSpanSearch) return res;
        for (const cellCtrl of this.getAllCellCtrls())if (cellCtrl?.getColSpanningList().indexOf(column) >= 0) res = cellCtrl;
        return res;
    }
    onRowIndexChanged() {
        if (this.rowNode.rowIndex != null) {
            this.onCellFocusChanged();
            this.updateRowIndexes();
            this.postProcessCss();
        }
    }
    updateRowIndexes(gui) {
        const rowIndexStr = this.rowNode.getRowIndexString();
        if (rowIndexStr === null) return;
        const headerRowCount = (this.beans.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0) + (this.beans.filterManager?.getHeaderRowCount() ?? 0);
        const rowIsEven = this.rowNode.rowIndex % 2 === 0;
        const ariaRowIndex = headerRowCount + this.rowNode.rowIndex + 1;
        this.forEachGui(gui, (c)=>{
            c.rowComp.setRowIndex(rowIndexStr);
            c.rowComp.toggleCss("ag-row-even", rowIsEven);
            c.rowComp.toggleCss("ag-row-odd", !rowIsEven);
            $437b23f6a393c3bf$export$ba731dedf9d88615(c.element, ariaRowIndex);
        });
    }
};
// packages/ag-grid-community/src/navigation/navigationService.ts
var $437b23f6a393c3bf$var$NavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.beanName = "navigation";
        this.onPageDown = $437b23f6a393c3bf$var$_throttle(this.onPageDown, 100);
        this.onPageUp = $437b23f6a393c3bf$var$_throttle(this.onPageUp, 100);
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    handlePageScrollingKey(event, fromFullWidth = false) {
        const key = event.key;
        const alt = event.altKey;
        const ctrl = event.ctrlKey || event.metaKey;
        const rangeServiceShouldHandleShift = !!this.beans.rangeSvc && event.shiftKey;
        const currentCell = $437b23f6a393c3bf$export$d85fcb0e6e51242(this.gos, event);
        let processed = false;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                if (!ctrl && !alt) {
                    this.onHomeOrEndKey(key);
                    processed = true;
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (!currentCell) return false;
                if (ctrl && !alt && !rangeServiceShouldHandleShift) {
                    this.onCtrlUpDownLeftRight(key, currentCell);
                    processed = true;
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
                if (!ctrl && !alt) processed = this.handlePageUpDown(key, currentCell, fromFullWidth);
                break;
        }
        if (processed) event.preventDefault();
        return processed;
    }
    handlePageUpDown(key, currentCell, fromFullWidth) {
        if (fromFullWidth) currentCell = this.beans.focusSvc.getFocusedCell();
        if (!currentCell) return false;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP) this.onPageUp(currentCell);
        else this.onPageDown(currentCell);
        return true;
    }
    navigateTo({ scrollIndex: scrollIndex, scrollType: scrollType, scrollColumn: scrollColumn, focusIndex: focusIndex, focusColumn: focusColumn, isAsync: isAsync, rowPinned: rowPinned }) {
        const { scrollFeature: scrollFeature } = this.gridBodyCon;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(scrollColumn) && !scrollColumn.isPinned()) scrollFeature.ensureColumnVisible(scrollColumn);
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(scrollIndex)) scrollFeature.ensureIndexVisible(scrollIndex, scrollType);
        if (!isAsync) scrollFeature.ensureIndexVisible(focusIndex);
        const { focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        focusSvc.setFocusedCell({
            rowIndex: focusIndex,
            column: focusColumn,
            rowPinned: rowPinned,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell({
            rowIndex: focusIndex,
            rowPinned: rowPinned,
            column: focusColumn
        });
    }
    // this method is throttled, see the `constructor`
    onPageDown(gridCell) {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const pixelsInOnePage = this.getViewportHeight();
        const { pageBounds: pageBounds, rowModel: rowModel, rowAutoHeight: rowAutoHeight } = beans;
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentPageBottomPixel = scrollPosition.top + pixelsInOnePage;
        const currentPageBottomRow = rowModel.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);
        if (rowAutoHeight?.active) this.navigateToNextPageWithAutoHeight(gridCell, currentPageBottomRow);
        else this.navigateToNextPage(gridCell, currentPageBottomRow);
    }
    // this method is throttled, see the `constructor`
    onPageUp(gridCell) {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const { pageBounds: pageBounds, rowModel: rowModel, rowAutoHeight: rowAutoHeight } = beans;
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentPageTopPixel = scrollPosition.top;
        const currentPageTopRow = rowModel.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);
        if (rowAutoHeight?.active) this.navigateToNextPageWithAutoHeight(gridCell, currentPageTopRow, true);
        else this.navigateToNextPage(gridCell, currentPageTopRow, true);
    }
    navigateToNextPage(gridCell, scrollIndex, up = false) {
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const pixelsInOnePage = this.getViewportHeight();
        const firstRow = pageBounds.getFirstRow();
        const lastRow = pageBounds.getLastRow();
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentRowNode = rowModel.getRow(gridCell.rowIndex);
        const rowPixelDiff = up ? // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
        currentRowNode?.rowHeight - pixelsInOnePage - pagingPixelOffset : pixelsInOnePage - pagingPixelOffset;
        const nextCellPixel = currentRowNode?.rowTop + rowPixelDiff;
        let focusIndex = rowModel.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
        if (focusIndex === gridCell.rowIndex) {
            const diff = up ? -1 : 1;
            scrollIndex = focusIndex = gridCell.rowIndex + diff;
        }
        let scrollType;
        if (up) {
            scrollType = "bottom";
            if (focusIndex < firstRow) focusIndex = firstRow;
            if (scrollIndex < firstRow) scrollIndex = firstRow;
        } else {
            scrollType = "top";
            if (focusIndex > lastRow) focusIndex = lastRow;
            if (scrollIndex > lastRow) scrollIndex = lastRow;
        }
        if (this.isRowTallerThanView(rowModel.getRow(focusIndex))) {
            scrollIndex = focusIndex;
            scrollType = "top";
        }
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: scrollType,
            scrollColumn: null,
            focusIndex: focusIndex,
            focusColumn: gridCell.column
        });
    }
    navigateToNextPageWithAutoHeight(gridCell, scrollIndex, up = false) {
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: up ? "bottom" : "top",
            scrollColumn: null,
            focusIndex: scrollIndex,
            focusColumn: gridCell.column
        });
        setTimeout(()=>{
            const focusIndex = this.getNextFocusIndexForAutoHeight(gridCell, up);
            this.navigateTo({
                scrollIndex: scrollIndex,
                scrollType: up ? "bottom" : "top",
                scrollColumn: null,
                focusIndex: focusIndex,
                focusColumn: gridCell.column,
                isAsync: true
            });
        }, 50);
    }
    getNextFocusIndexForAutoHeight(gridCell, up = false) {
        const step = up ? -1 : 1;
        const pixelsInOnePage = this.getViewportHeight();
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const lastRowIndex = pageBounds.getLastRow();
        let pixelSum = 0;
        let currentIndex = gridCell.rowIndex;
        while(currentIndex >= 0 && currentIndex <= lastRowIndex){
            const currentCell = rowModel.getRow(currentIndex);
            if (currentCell) {
                const currentCellHeight = currentCell.rowHeight ?? 0;
                if (pixelSum + currentCellHeight > pixelsInOnePage) break;
                pixelSum += currentCellHeight;
            }
            currentIndex += step;
        }
        return Math.max(0, Math.min(currentIndex, lastRowIndex));
    }
    getViewportHeight() {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const scrollbarWidth = this.beans.scrollVisibleSvc.getScrollbarWidth();
        let pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
        if (beans.ctrlsSvc.get("center").isHorizontalScrollShowing()) pixelsInOnePage -= scrollbarWidth;
        return pixelsInOnePage;
    }
    isRowTallerThanView(rowNode) {
        if (!rowNode) return false;
        const rowHeight = rowNode.rowHeight;
        if (typeof rowHeight !== "number") return false;
        return rowHeight > this.getViewportHeight();
    }
    onCtrlUpDownLeftRight(key, gridCell) {
        const cellToFocus = this.beans.cellNavigation.getNextCellToFocus(key, gridCell, true);
        const normalisedPosition = this.getNormalisedPosition(cellToFocus);
        const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = normalisedPosition ?? cellToFocus;
        const col = column;
        this.navigateTo({
            scrollIndex: rowIndex,
            scrollType: null,
            scrollColumn: col,
            focusIndex: rowIndex,
            focusColumn: col,
            rowPinned: rowPinned
        });
    }
    // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
    // same cell into view (which means either scroll all the way up, or all the way down).
    onHomeOrEndKey(key) {
        const homeKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME;
        const { visibleCols: visibleCols, pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const allColumns = visibleCols.allCols;
        const scrollIndex = homeKey ? pageBounds.getFirstRow() : pageBounds.getLastRow();
        const rowNode = rowModel.getRow(scrollIndex);
        if (!rowNode) return;
        const columnToSelect = (homeKey ? allColumns : [
            ...allColumns
        ].reverse()).find((col)=>!col.isSuppressNavigable(rowNode));
        if (!columnToSelect) return;
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: null,
            scrollColumn: columnToSelect,
            focusIndex: scrollIndex,
            focusColumn: columnToSelect
        });
    }
    // result of keyboard event
    onTabKeyDown(previous, keyboardEvent) {
        const backwards = keyboardEvent.shiftKey;
        const movedToNextCell = this.tabToNextCellCommon(previous, backwards, keyboardEvent);
        const beans = this.beans;
        const { ctrlsSvc: ctrlsSvc, pageBounds: pageBounds, focusSvc: focusSvc, gos: gos } = beans;
        if (movedToNextCell !== false) {
            if (movedToNextCell) keyboardEvent.preventDefault();
            else if (movedToNextCell === null) ctrlsSvc.get("gridCtrl").allowFocusForNextCoreContainer(backwards);
            return;
        }
        if (backwards) {
            const { rowIndex: rowIndex, rowPinned: rowPinned } = previous.getRowPosition();
            const firstRow = rowPinned ? rowIndex === 0 : rowIndex === pageBounds.getFirstRow();
            if (firstRow) {
                if (gos.get("headerHeight") === 0 || $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans)) $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, true, true);
                else {
                    keyboardEvent.preventDefault();
                    focusSvc.focusPreviousFromFirstCell(keyboardEvent);
                }
            }
        } else {
            if (previous instanceof $437b23f6a393c3bf$var$CellCtrl) previous.focusCell(true);
            if (focusSvc.focusOverlay(false) || $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards)) keyboardEvent.preventDefault();
        }
    }
    // comes from API
    tabToNextCell(backwards, event) {
        const beans = this.beans;
        const { focusSvc: focusSvc, rowRenderer: rowRenderer } = beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (!focusedCell) return false;
        let cellOrRow = $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, focusedCell);
        if (!cellOrRow) {
            cellOrRow = rowRenderer.getRowByPosition(focusedCell);
            if (!cellOrRow?.isFullWidth()) return false;
        }
        return !!this.tabToNextCellCommon(cellOrRow, backwards, event, "api");
    }
    tabToNextCellCommon(previous, backwards, event, source = "ui") {
        const { editSvc: editSvc, focusSvc: focusSvc } = this.beans;
        let res = void 0;
        const cellCtrl = previous instanceof $437b23f6a393c3bf$var$CellCtrl ? previous : previous.getAllCellCtrls()?.[0];
        if (editSvc?.isEditing()) res = editSvc?.moveToNextCell(cellCtrl, backwards, event, source);
        else res = this.moveToNextCellNotEditing(previous, backwards, event);
        if (res === null) return res;
        return res || !!focusSvc.focusedHeader;
    }
    // returns null if no navigation should be performed
    moveToNextCellNotEditing(previousCell, backwards, event) {
        const displayedColumns = this.beans.visibleCols.allCols;
        let cellPos;
        if (previousCell instanceof $437b23f6a393c3bf$var$RowCtrl) {
            cellPos = {
                ...previousCell.getRowPosition(),
                column: backwards ? displayedColumns[0] : $437b23f6a393c3bf$export$236389741107357f(displayedColumns)
            };
            if (this.gos.get("embedFullWidthRows") && event) {
                const focusedContainer = previousCell.findFullWidthInfoForEvent(event);
                if (focusedContainer) cellPos.column = focusedContainer.column;
            }
        } else cellPos = previousCell.getFocusedCellPosition();
        const nextCell = this.findNextCellToFocusOn(cellPos, {
            backwards: backwards,
            startEditing: false
        });
        if (nextCell === false) return null;
        if (nextCell instanceof $437b23f6a393c3bf$var$CellCtrl) nextCell.focusCell(true);
        else if (nextCell) return this.tryToFocusFullWidthRow(nextCell, backwards);
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(nextCell);
    }
    /**
   * called by the cell, when tab is pressed while editing.
   * @returns RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
   */ findNextCellToFocusOn(previousPosition, { backwards: backwards, startEditing: startEditing, skipToNextEditableCell: skipToNextEditableCell }) {
        let nextPosition = previousPosition;
        const beans = this.beans;
        const { cellNavigation: cellNavigation, gos: gos, focusSvc: focusSvc, rowRenderer: rowRenderer, rangeSvc: rangeSvc } = beans;
        while(true){
            if (previousPosition !== nextPosition) previousPosition = nextPosition;
            if (!backwards) nextPosition = this.getLastCellOfColSpan(nextPosition);
            nextPosition = cellNavigation.getNextTabbedCell(nextPosition, backwards);
            const userFunc = gos.getCallback("tabToNextCell");
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userFunc)) {
                const params = {
                    backwards: backwards,
                    editing: startEditing,
                    previousCellPosition: previousPosition,
                    nextCellPosition: nextPosition ? nextPosition : null
                };
                const userResult = userFunc(params);
                if (userResult === true) nextPosition = previousPosition;
                else if (userResult === false) return false;
                else nextPosition = {
                    rowIndex: userResult.rowIndex,
                    column: userResult.column,
                    rowPinned: userResult.rowPinned
                };
            }
            if (!nextPosition) return null;
            if (nextPosition.rowIndex < 0) {
                const headerLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans);
                focusSvc.focusHeaderPosition({
                    headerPosition: {
                        headerRowIndex: headerLen + nextPosition.rowIndex,
                        column: nextPosition.column
                    },
                    fromCell: true
                });
                return null;
            }
            const fullRowEdit = gos.get("editType") === "fullRow";
            if (startEditing && (!fullRowEdit || skipToNextEditableCell)) {
                const cellIsEditable = this.isCellEditable(nextPosition);
                if (!cellIsEditable) continue;
            }
            this.ensureCellVisible(nextPosition);
            const nextCell = $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, nextPosition);
            if (!nextCell) {
                const row = rowRenderer.getRowByPosition(nextPosition);
                if (!row || !row.isFullWidth() || startEditing) continue;
                return {
                    ...row.getRowPosition(),
                    column: nextPosition?.column
                };
            }
            if (cellNavigation.isSuppressNavigable(nextCell.column, nextCell.rowNode)) continue;
            nextCell.setFocusedCellPosition(nextPosition);
            rangeSvc?.setRangeToCell(nextPosition);
            return nextCell;
        }
    }
    isCellEditable(cell) {
        const rowNode = this.lookupRowNodeForCell(cell);
        if (rowNode) return cell.column.isCellEditable(rowNode);
        return false;
    }
    lookupRowNodeForCell({ rowIndex: rowIndex, rowPinned: rowPinned }) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        if (rowPinned === "top") return pinnedRowModel?.getPinnedTopRow(rowIndex);
        if (rowPinned === "bottom") return pinnedRowModel?.getPinnedBottomRow(rowIndex);
        return rowModel.getRow(rowIndex);
    }
    // we use index for rows, but column object for columns, as the next column (by index) might not
    // be visible (header grouping) so it's not reliable, so using the column object instead.
    navigateToNextCell(event, key, currentCell, allowUserOverride) {
        let nextCell = currentCell;
        let hitEdgeOfGrid = false;
        const beans = this.beans;
        const { cellNavigation: cellNavigation, focusSvc: focusSvc, gos: gos } = beans;
        while(nextCell && (nextCell === currentCell || !this.isValidNavigateCell(nextCell))){
            if (gos.get("enableRtl")) {
                if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT) nextCell = this.getLastCellOfColSpan(nextCell);
            } else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT) nextCell = this.getLastCellOfColSpan(nextCell);
            nextCell = cellNavigation.getNextCellToFocus(key, nextCell);
            hitEdgeOfGrid = $437b23f6a393c3bf$export$672d9e47bc342bac(nextCell);
        }
        if (hitEdgeOfGrid && event && event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP) nextCell = {
            rowIndex: -1,
            rowPinned: null,
            column: currentCell.column
        };
        if (allowUserOverride) {
            const userFunc = gos.getCallback("navigateToNextCell");
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userFunc)) {
                const params = {
                    key: key,
                    previousCellPosition: currentCell,
                    nextCellPosition: nextCell ? nextCell : null,
                    event: event
                };
                const userCell = userFunc(params);
                if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userCell)) nextCell = {
                    rowPinned: userCell.rowPinned,
                    rowIndex: userCell.rowIndex,
                    column: userCell.column
                };
                else nextCell = null;
            }
        }
        if (!nextCell) return;
        if (nextCell.rowIndex < 0) {
            const headerLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans);
            focusSvc.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: headerLen + nextCell.rowIndex,
                    column: currentCell.column
                },
                event: event || void 0,
                fromCell: true
            });
            return;
        }
        const normalisedPosition = this.getNormalisedPosition(nextCell);
        if (normalisedPosition) this.focusPosition(normalisedPosition);
        else this.tryToFocusFullWidthRow(nextCell);
    }
    getNormalisedPosition(cellPosition) {
        const isSpannedCell = !!this.beans.spannedRowRenderer?.getCellByPosition(cellPosition);
        if (isSpannedCell) return cellPosition;
        this.ensureCellVisible(cellPosition);
        const cellCtrl = $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cellPosition);
        if (!cellCtrl) return null;
        cellPosition = cellCtrl.getFocusedCellPosition();
        this.ensureCellVisible(cellPosition);
        return cellPosition;
    }
    tryToFocusFullWidthRow(position, backwards) {
        const { visibleCols: visibleCols, rowRenderer: rowRenderer, focusSvc: focusSvc, eventSvc: eventSvc } = this.beans;
        const displayedColumns = visibleCols.allCols;
        const rowComp = rowRenderer.getRowByPosition(position);
        if (!rowComp?.isFullWidth()) return false;
        const currentCellFocused = focusSvc.getFocusedCell();
        const cellPosition = {
            rowIndex: position.rowIndex,
            rowPinned: position.rowPinned,
            column: position.column || (backwards ? $437b23f6a393c3bf$export$236389741107357f(displayedColumns) : displayedColumns[0])
        };
        this.focusPosition(cellPosition);
        const fromBelow = backwards == null ? currentCellFocused != null && $437b23f6a393c3bf$export$6cce97428a227a31(cellPosition, currentCellFocused) : backwards;
        eventSvc.dispatchEvent({
            type: "fullWidthRowFocused",
            rowIndex: cellPosition.rowIndex,
            rowPinned: cellPosition.rowPinned,
            column: cellPosition.column,
            isFullWidthCell: true,
            fromBelow: fromBelow
        });
        return true;
    }
    focusPosition(cellPosition) {
        const { focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        focusSvc.setFocusedCell({
            rowIndex: cellPosition.rowIndex,
            column: cellPosition.column,
            rowPinned: cellPosition.rowPinned,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell(cellPosition);
    }
    isValidNavigateCell(cell) {
        const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, cell);
        return !!rowNode;
    }
    getLastCellOfColSpan(cell) {
        const cellCtrl = $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cell);
        if (!cellCtrl) return cell;
        const colSpanningList = cellCtrl.getColSpanningList();
        if (colSpanningList.length === 1) return cell;
        return {
            rowIndex: cell.rowIndex,
            column: $437b23f6a393c3bf$export$236389741107357f(colSpanningList),
            rowPinned: cell.rowPinned
        };
    }
    ensureCellVisible(gridCell) {
        const isGroupStickyEnabled = $437b23f6a393c3bf$export$d5f33aacea6a0849(this.gos);
        const rowNode = this.beans.rowModel.getRow(gridCell.rowIndex);
        const skipScrollToRow = isGroupStickyEnabled && rowNode?.sticky;
        const { scrollFeature: scrollFeature } = this.gridBodyCon;
        if (!skipScrollToRow && $437b23f6a393c3bf$export$672d9e47bc342bac(gridCell.rowPinned)) scrollFeature.ensureIndexVisible(gridCell.rowIndex);
        if (!gridCell.column.isPinned()) scrollFeature.ensureColumnVisible(gridCell.column);
    }
    ensureColumnVisible(column) {
        const scrollFeature = this.gridBodyCon.scrollFeature;
        if (!column.isPinned()) scrollFeature.ensureColumnVisible(column);
    }
    ensureRowVisible(rowIndex) {
        const scrollFeature = this.gridBodyCon.scrollFeature;
        scrollFeature.ensureIndexVisible(rowIndex);
    }
};
function $437b23f6a393c3bf$var$getVScroll(beans) {
    return beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
// packages/ag-grid-community/src/navigation/navigationModule.ts
var $437b23f6a393c3bf$export$44f04c51d8088336 = {
    moduleName: "KeyboardNavigation",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$NavigationService,
        $437b23f6a393c3bf$var$CellNavigationService,
        $437b23f6a393c3bf$var$HeaderNavigationService
    ],
    apiFunctions: {
        getFocusedCell: $437b23f6a393c3bf$var$getFocusedCell,
        clearFocusedCell: $437b23f6a393c3bf$var$clearFocusedCell,
        setFocusedCell: $437b23f6a393c3bf$var$setFocusedCell,
        setFocusedHeader: $437b23f6a393c3bf$var$setFocusedHeader,
        tabToNextCell: $437b23f6a393c3bf$var$tabToNextCell,
        tabToPreviousCell: $437b23f6a393c3bf$var$tabToPreviousCell
    }
};
// packages/ag-grid-community/src/pagination/pageBoundsListener.ts
var $437b23f6a393c3bf$var$PageBoundsListener = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pageBoundsListener";
    }
    postConstruct() {
        this.addManagedEventListeners({
            modelUpdated: this.onModelUpdated.bind(this),
            recalculateRowBounds: this.calculatePages.bind(this)
        });
        this.onModelUpdated();
    }
    onModelUpdated(modelUpdatedEvent) {
        this.calculatePages();
        this.eventSvc.dispatchEvent({
            type: "paginationChanged",
            animate: modelUpdatedEvent?.animate ?? false,
            newData: modelUpdatedEvent?.newData ?? false,
            newPage: modelUpdatedEvent?.newPage ?? false,
            newPageSize: modelUpdatedEvent?.newPageSize ?? false,
            keepRenderedRows: modelUpdatedEvent?.keepRenderedRows ?? false
        });
    }
    calculatePages() {
        const { pageBounds: pageBounds, pagination: pagination, rowModel: rowModel } = this.beans;
        if (pagination) pagination.calculatePages();
        else pageBounds.calculateBounds(0, rowModel.getRowCount() - 1);
    }
};
// packages/ag-grid-community/src/pagination/pageBoundsService.ts
var $437b23f6a393c3bf$var$PageBoundsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pageBounds";
        this.pixelOffset = 0;
    }
    getFirstRow() {
        return this.topRowBounds?.rowIndex ?? -1;
    }
    getLastRow() {
        return this.bottomRowBounds?.rowIndex ?? -1;
    }
    getCurrentPageHeight() {
        const { topRowBounds: topRowBounds, bottomRowBounds: bottomRowBounds } = this;
        if (!topRowBounds || !bottomRowBounds) return 0;
        return Math.max(bottomRowBounds.rowTop + bottomRowBounds.rowHeight - topRowBounds.rowTop, 0);
    }
    getCurrentPagePixelRange() {
        const { topRowBounds: topRowBounds, bottomRowBounds: bottomRowBounds } = this;
        const pageFirstPixel = topRowBounds?.rowTop ?? 0;
        const pageLastPixel = bottomRowBounds ? bottomRowBounds.rowTop + bottomRowBounds.rowHeight : 0;
        return {
            pageFirstPixel: pageFirstPixel,
            pageLastPixel: pageLastPixel
        };
    }
    calculateBounds(topDisplayedRowIndex, bottomDisplayedRowIndex) {
        const { rowModel: rowModel } = this.beans;
        const topRowBounds = rowModel.getRowBounds(topDisplayedRowIndex);
        if (topRowBounds) topRowBounds.rowIndex = topDisplayedRowIndex;
        this.topRowBounds = topRowBounds;
        const bottomRowBounds = rowModel.getRowBounds(bottomDisplayedRowIndex);
        if (bottomRowBounds) bottomRowBounds.rowIndex = bottomDisplayedRowIndex;
        this.bottomRowBounds = bottomRowBounds;
        this.calculatePixelOffset();
    }
    getPixelOffset() {
        return this.pixelOffset;
    }
    calculatePixelOffset() {
        const value = this.topRowBounds?.rowTop ?? 0;
        if (this.pixelOffset === value) return;
        this.pixelOffset = value;
        this.eventSvc.dispatchEvent({
            type: "paginationPixelOffsetChanged"
        });
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnModule.css-GENERATED.ts
var $437b23f6a393c3bf$var$pinnedColumnModuleCSS = /*css*/ `.ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top{min-width:0;overflow:hidden;position:relative}.ag-pinned-left-sticky-top,.ag-pinned-right-sticky-top{height:100%;overflow:hidden;position:relative}.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{height:100%;overflow:hidden;width:100%}.ag-pinned-left-header,.ag-pinned-right-header{display:inline-block;height:100%;overflow:hidden;position:relative}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible){.ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:var(--ag-pinned-column-border)}.ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:var(--ag-pinned-column-border)}}.ag-pinned-right-header{border-left:var(--ag-pinned-column-border)}.ag-pinned-left-header{border-right:var(--ag-pinned-column-border)}.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-left:var(--ag-pinned-column-border)}.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-right:var(--ag-pinned-column-border)}.ag-pinned-left-header .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-right-header .ag-header-cell-resize:after{left:50%}.ag-pinned-left-header .ag-header-cell-resize{right:-3px}.ag-pinned-right-header .ag-header-cell-resize{left:-3px}`;
// packages/ag-grid-community/src/gridBodyComp/rowContainer/setPinnedWidthFeature.ts
var $437b23f6a393c3bf$var$SetPinnedWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(isLeft, elements){
        super();
        this.isLeft = isLeft;
        this.elements = elements;
        this.getWidth = isLeft ? ()=>this.beans.pinnedCols.leftWidth : ()=>this.beans.pinnedCols.rightWidth;
    }
    postConstruct() {
        this.addManagedEventListeners({
            [`${this.isLeft ? "left" : "right"}PinnedWidthChanged`]: this.onPinnedWidthChanged.bind(this)
        });
    }
    onPinnedWidthChanged() {
        const width = this.getWidth();
        const displayed = width > 0;
        for (const element of this.elements)if (element) {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, displayed);
            $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width);
        }
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnService.ts
var $437b23f6a393c3bf$var$PinnedColumnService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pinnedCols";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
        const listener = this.checkContainerWidths.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: listener,
            displayedColumnsWidthChanged: listener
        });
        this.addManagedPropertyListener("domLayout", listener);
    }
    checkContainerWidths() {
        const { gos: gos, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        const newLeftWidth = printLayout ? 0 : visibleCols.getColsLeftWidth();
        const newRightWidth = printLayout ? 0 : visibleCols.getDisplayedColumnsRightWidth();
        if (newLeftWidth != this.leftWidth) {
            this.leftWidth = newLeftWidth;
            eventSvc.dispatchEvent({
                type: "leftPinnedWidthChanged"
            });
        }
        if (newRightWidth != this.rightWidth) {
            this.rightWidth = newRightWidth;
            eventSvc.dispatchEvent({
                type: "rightPinnedWidthChanged"
            });
        }
    }
    keepPinnedColumnsNarrowerThanViewport() {
        const eBodyViewport = this.gridBodyCtrl.eBodyViewport;
        const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(eBodyViewport);
        if (bodyWidth <= 50) return;
        const processedColumnsToRemove = this.getPinnedColumnsOverflowingViewport(bodyWidth - 50);
        const processUnpinnedColumns = this.gos.getCallback("processUnpinnedColumns");
        const { columns: columns, hasLockedPinned: hasLockedPinned } = processedColumnsToRemove;
        let columnsToRemove = columns;
        if (!columnsToRemove.length && !hasLockedPinned) return;
        if (processUnpinnedColumns) {
            const params = {
                columns: columnsToRemove,
                viewportWidth: bodyWidth
            };
            columnsToRemove = processUnpinnedColumns(params);
        }
        if (!columnsToRemove?.length) return;
        columnsToRemove = columnsToRemove.filter((col)=>!$437b23f6a393c3bf$export$3d3e7d751f0445eb(col));
        this.setColsPinned(columnsToRemove, null, "viewportSizeFeature");
    }
    createPinnedWidthFeature(isLeft, ...elements) {
        return new $437b23f6a393c3bf$var$SetPinnedWidthFeature(isLeft, elements);
    }
    setColsPinned(keys, pinned, source) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, gos: gos } = this.beans;
        if (!colModel.cols) return;
        if (!keys?.length) return;
        if ($437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print")) {
            $437b23f6a393c3bf$export$545083624300f13d(37);
            return;
        }
        colAnimation?.start();
        let actualPinned;
        if (pinned === true || pinned === "left") actualPinned = "left";
        else if (pinned === "right") actualPinned = "right";
        else actualPinned = null;
        const updatedCols = [];
        for (const key of keys){
            if (!key) continue;
            const column = colModel.getCol(key);
            if (!column) continue;
            if (column.getPinned() !== actualPinned) {
                this.setColPinned(column, actualPinned);
                updatedCols.push(column);
            }
        }
        if (updatedCols.length) {
            visibleCols.refresh(source);
            $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(this.eventSvc, updatedCols, source);
        }
        colAnimation?.finish();
    }
    initCol(column) {
        const { pinned: pinned, initialPinned: initialPinned } = column.colDef;
        if (pinned !== void 0) this.setColPinned(column, pinned);
        else this.setColPinned(column, initialPinned);
    }
    setColPinned(column, pinned) {
        if (pinned === true || pinned === "left") column.pinned = "left";
        else if (pinned === "right") column.pinned = "right";
        else column.pinned = null;
        column.dispatchStateUpdatedEvent("pinned");
    }
    setupHeaderPinnedWidth(ctrl) {
        const { scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        if (ctrl.pinned == null) return;
        const pinningLeft = ctrl.pinned === "left";
        const pinningRight = ctrl.pinned === "right";
        ctrl.hidden = true;
        const listener = ()=>{
            const width = pinningLeft ? this.leftWidth : this.rightWidth;
            if (width == null) return;
            const hidden = width == 0;
            const hiddenChanged = ctrl.hidden !== hidden;
            const isRtl = this.gos.get("enableRtl");
            const scrollbarWidth = scrollVisibleSvc.getScrollbarWidth();
            const addPaddingForScrollbar = scrollVisibleSvc.verticalScrollShowing && (isRtl && pinningLeft || !isRtl && pinningRight);
            const widthWithPadding = addPaddingForScrollbar ? width + scrollbarWidth : width;
            ctrl.comp.setPinnedContainerWidth(`${widthWithPadding}px`);
            ctrl.comp.setDisplayed(!hidden);
            if (hiddenChanged) {
                ctrl.hidden = hidden;
                ctrl.refresh();
            }
        };
        ctrl.addManagedEventListeners({
            leftPinnedWidthChanged: listener,
            rightPinnedWidthChanged: listener,
            scrollVisibilityChanged: listener,
            scrollbarWidthChanged: listener
        });
    }
    getHeaderResizeDiff(diff, column) {
        const pinned = column.getPinned();
        if (pinned) {
            const { leftWidth: leftWidth, rightWidth: rightWidth } = this;
            const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(this.beans.ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
            if (leftWidth + rightWidth + diff > bodyWidth) {
                if (bodyWidth > leftWidth + rightWidth) diff = bodyWidth - leftWidth - rightWidth;
                else return 0;
            }
        }
        return diff;
    }
    getPinnedColumnsOverflowingViewport(viewportWidth) {
        const pinnedRightWidth = this.rightWidth ?? 0;
        const pinnedLeftWidth = this.leftWidth ?? 0;
        const totalPinnedWidth = pinnedRightWidth + pinnedLeftWidth;
        let hasLockedPinned = false;
        if (totalPinnedWidth < viewportWidth) return {
            columns: [],
            hasLockedPinned: hasLockedPinned
        };
        const { visibleCols: visibleCols } = this.beans;
        const pinnedLeftColumns = [
            ...visibleCols.leftCols
        ];
        const pinnedRightColumns = [
            ...visibleCols.rightCols
        ];
        let indexRight = 0;
        let indexLeft = 0;
        const totalWidthRemoved = 0;
        const columnsToRemove = [];
        let spaceNecessary = totalPinnedWidth - totalWidthRemoved - viewportWidth;
        while((indexLeft < pinnedLeftColumns.length || indexRight < pinnedRightColumns.length) && spaceNecessary > 0){
            if (indexRight < pinnedRightColumns.length) {
                const currentColumn = pinnedRightColumns[indexRight++];
                if (currentColumn.colDef.lockPinned) {
                    hasLockedPinned = true;
                    continue;
                }
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
            if (indexLeft < pinnedLeftColumns.length && spaceNecessary > 0) {
                const currentColumn = pinnedLeftColumns[indexLeft++];
                if (currentColumn.colDef.lockPinned) {
                    hasLockedPinned = true;
                    continue;
                }
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
        }
        return {
            columns: columnsToRemove,
            hasLockedPinned: hasLockedPinned
        };
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnModule.ts
var $437b23f6a393c3bf$var$PinnedColumnModule = {
    moduleName: "PinnedColumn",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PinnedColumnService
    ],
    css: [
        $437b23f6a393c3bf$var$pinnedColumnModuleCSS
    ]
};
// packages/ag-grid-community/src/agStack/core/baseAriaAnnouncementService.ts
var $437b23f6a393c3bf$var$BaseAriaAnnouncementService = class extends $437b23f6a393c3bf$export$347db2b30d253083 {
    constructor(){
        super();
        this.beanName = "ariaAnnounce";
        this.descriptionContainer = null;
        this.pendingAnnouncements = /* @__PURE__ */ new Map();
        this.lastAnnouncement = "";
        this.updateAnnouncement = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.updateAnnouncement.bind(this), 200);
    }
    postConstruct() {
        const beans = this.beans;
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        const div = this.descriptionContainer = eDocument.createElement("div");
        div.classList.add("ag-aria-description-container");
        $437b23f6a393c3bf$var$_setAriaLive(div, "polite");
        $437b23f6a393c3bf$var$_setAriaRelevant(div, "additions text");
        $437b23f6a393c3bf$var$_setAriaAtomic(div, true);
        beans.eRootDiv.appendChild(div);
    }
    /**
   * @param key used for debouncing calls
   */ announceValue(value, key) {
        this.pendingAnnouncements.set(key, value);
        this.updateAnnouncement();
    }
    updateAnnouncement() {
        if (!this.descriptionContainer) return;
        const value = Array.from(this.pendingAnnouncements.values()).join(". ");
        this.pendingAnnouncements.clear();
        this.descriptionContainer.textContent = "";
        setTimeout(()=>{
            this.handleAnnouncementUpdate(value);
        }, 50);
    }
    handleAnnouncementUpdate(value) {
        if (!this.isAlive() || !this.descriptionContainer) return;
        let valueToAnnounce = value;
        if (valueToAnnounce == null || valueToAnnounce.replace(/[ .]/g, "") == "") {
            this.lastAnnouncement = "";
            return;
        }
        if (this.lastAnnouncement === valueToAnnounce) valueToAnnounce = `${valueToAnnounce}\u200B`;
        this.lastAnnouncement = valueToAnnounce;
        this.descriptionContainer.textContent = valueToAnnounce;
    }
    destroy() {
        super.destroy();
        const { descriptionContainer: descriptionContainer } = this;
        if (descriptionContainer) {
            $437b23f6a393c3bf$export$69e6e10709eabd91(descriptionContainer);
            descriptionContainer.remove();
        }
        this.descriptionContainer = null;
        this.pendingAnnouncements.clear();
    }
};
// packages/ag-grid-community/src/rendering/ariaAnnouncementService.ts
var $437b23f6a393c3bf$var$AriaAnnouncementService = class extends $437b23f6a393c3bf$var$BaseAriaAnnouncementService {
};
// packages/ag-grid-community/src/rendering/ariaModule.ts
var $437b23f6a393c3bf$var$AriaModule = {
    moduleName: "Aria",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AriaAnnouncementService
    ]
};
// packages/ag-grid-community/src/rendering/column-delay-render.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnDelayRenderCSS = /*css*/ `:where(.ag-delay-render){.ag-cell,.ag-header-cell,.ag-header-group-cell,.ag-row,.ag-spanned-cell-wrapper{visibility:hidden}}`;
// packages/ag-grid-community/src/rendering/columnDelayRenderService.ts
var $437b23f6a393c3bf$var$HideClass = "ag-delay-render";
var $437b23f6a393c3bf$var$ColumnDelayRenderService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colDelayRenderSvc";
        this.hideRequested = false;
        this.alreadyRevealed = false;
        this.timesRetried = 0;
        this.requesters = /* @__PURE__ */ new Set();
    }
    hideColumns(key) {
        if (this.alreadyRevealed || this.requesters.has(key)) return;
        this.requesters.add(key);
        if (!this.hideRequested) {
            this.beans.ctrlsSvc.whenReady(this, (p)=>{
                p.gridBodyCtrl.eGridBody.classList.add($437b23f6a393c3bf$var$HideClass);
            });
            this.hideRequested = true;
        }
    }
    revealColumns(key) {
        if (this.alreadyRevealed || !this.isAlive()) return;
        this.requesters.delete(key);
        if (this.requesters.size > 0) return;
        const { renderStatus: renderStatus, ctrlsSvc: ctrlsSvc } = this.beans;
        if (renderStatus) {
            if (!renderStatus.areHeaderCellsRendered() && this.timesRetried < 5) {
                this.timesRetried++;
                setTimeout(()=>this.revealColumns(key));
                return;
            }
            this.timesRetried = 0;
        }
        ctrlsSvc.getGridBodyCtrl().eGridBody.classList.remove($437b23f6a393c3bf$var$HideClass);
        this.alreadyRevealed = true;
    }
};
var $437b23f6a393c3bf$var$ColumnDelayRenderModule = {
    moduleName: "ColumnDelayRender",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnDelayRenderService
    ],
    css: [
        $437b23f6a393c3bf$var$columnDelayRenderCSS
    ]
};
// packages/ag-grid-community/src/rendering/overlays/overlayApi.ts
function $437b23f6a393c3bf$var$showLoadingOverlay(beans) {
    beans.overlays?.showLoadingOverlay();
}
function $437b23f6a393c3bf$var$showNoRowsOverlay(beans) {
    beans.overlays?.showNoRowsOverlay();
}
function $437b23f6a393c3bf$var$hideOverlay(beans) {
    beans.overlays?.hideOverlay();
}
// packages/ag-grid-community/src/rendering/overlays/overlayWrapperComponent.css-GENERATED.ts
var $437b23f6a393c3bf$var$overlayWrapperComponentCSS = /*css*/ `.ag-overlay{inset:0;pointer-events:none;position:absolute;z-index:2}.ag-overlay-panel,.ag-overlay-wrapper{display:flex;height:100%;width:100%}.ag-overlay-wrapper{align-items:center;flex:none;justify-content:center;text-align:center}.ag-overlay-exporting-wrapper,.ag-overlay-loading-wrapper,.ag-overlay-modal-wrapper{pointer-events:all}.ag-overlay-exporting-center,.ag-overlay-loading-center{background:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-popup-shadow);display:flex;padding:var(--ag-spacing)}`;
// packages/ag-grid-community/src/rendering/overlays/overlayWrapperComponent.ts
var $437b23f6a393c3bf$var$OverlayWrapperElement = {
    tag: "div",
    cls: "ag-overlay",
    role: "presentation",
    children: [
        {
            tag: "div",
            cls: "ag-overlay-panel",
            role: "presentation",
            children: [
                {
                    tag: "div",
                    ref: "eOverlayWrapper",
                    cls: "ag-overlay-wrapper",
                    role: "presentation"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$OverlayWrapperComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$OverlayWrapperElement);
        this.eOverlayWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.activeOverlay = null;
        this.activePromise = null;
        this.activeCssClass = null;
        this.elToFocusAfter = null;
        this.overlayExclusive = false;
        this.oldWrapperPadding = null;
        this.registerCSS($437b23f6a393c3bf$var$overlayWrapperComponentCSS);
    }
    handleKeyDown(e) {
        if (e.key !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || e.defaultPrevented || $437b23f6a393c3bf$export$9a48e23524c6d58(e)) return;
        const { beans: beans, eOverlayWrapper: eOverlayWrapper } = this;
        const nextEl = eOverlayWrapper && $437b23f6a393c3bf$export$83fc12531358bd28(beans, eOverlayWrapper, false, e.shiftKey);
        if (nextEl) return;
        let isFocused = false;
        if (e.shiftKey) isFocused = beans.focusSvc.focusGridView({
            column: $437b23f6a393c3bf$export$236389741107357f(beans.visibleCols.allCols),
            backwards: true,
            canFocusOverlay: false
        });
        else isFocused = $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, false);
        if (isFocused) e.preventDefault();
    }
    updateLayoutClasses(cssClass, params) {
        const eOverlayWrapper = this.eOverlayWrapper;
        if (!eOverlayWrapper) return;
        const overlayWrapperClassList = eOverlayWrapper.classList;
        const { AUTO_HEIGHT: AUTO_HEIGHT, NORMAL: NORMAL, PRINT: PRINT } = $437b23f6a393c3bf$var$LayoutCssClasses;
        overlayWrapperClassList.toggle(AUTO_HEIGHT, params.autoHeight);
        overlayWrapperClassList.toggle(NORMAL, params.normal);
        overlayWrapperClassList.toggle(PRINT, params.print);
    }
    postConstruct() {
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this));
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
        this.beans.overlays.setWrapperComp(this, false);
        this.addManagedElementListeners(this.getFocusableElement(), {
            keydown: this.handleKeyDown.bind(this)
        });
        this.addManagedEventListeners({
            gridSizeChanged: this.refreshWrapperPadding.bind(this)
        });
    }
    setWrapperTypeClass(overlayWrapperCssClass) {
        const overlayWrapperClassList = this.eOverlayWrapper?.classList;
        if (!overlayWrapperClassList) {
            this.activeCssClass = null;
            return;
        }
        if (this.activeCssClass) overlayWrapperClassList.toggle(this.activeCssClass, false);
        this.activeCssClass = overlayWrapperCssClass;
        overlayWrapperClassList.toggle(overlayWrapperCssClass, true);
    }
    showOverlay(overlayComponentPromise, overlayWrapperCssClass, exclusive) {
        this.destroyActiveOverlay();
        this.elToFocusAfter = null;
        this.activePromise = overlayComponentPromise;
        this.overlayExclusive = exclusive;
        if (!overlayComponentPromise) {
            this.refreshWrapperPadding();
            return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
        }
        this.setWrapperTypeClass(overlayWrapperCssClass);
        this.setDisplayed(true, {
            skipAriaHidden: true
        });
        this.refreshWrapperPadding();
        if (exclusive && this.isGridFocused()) {
            const activeElement = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
            if (activeElement && !$437b23f6a393c3bf$export$8ff9eef09a45371f(this.beans)) this.elToFocusAfter = activeElement;
        }
        overlayComponentPromise.then((comp)=>{
            const eOverlayWrapper = this.eOverlayWrapper;
            if (!eOverlayWrapper) {
                this.destroyBean(comp);
                return;
            }
            if (this.activePromise !== overlayComponentPromise) {
                if (this.activeOverlay !== comp) {
                    this.destroyBean(comp);
                    comp = null;
                }
                return;
            }
            this.activePromise = null;
            if (!comp) return;
            if (this.activeOverlay !== comp) {
                eOverlayWrapper.appendChild(comp.getGui());
                this.activeOverlay = comp;
            }
            if (exclusive && this.isGridFocused()) $437b23f6a393c3bf$export$8598088d375f416f(eOverlayWrapper);
        });
        return overlayComponentPromise;
    }
    refreshWrapperPadding() {
        if (!this.eOverlayWrapper) {
            this.oldWrapperPadding = null;
            return;
        }
        const overlayActive = !!this.activeOverlay || !!this.activePromise;
        let padding = 0;
        if (overlayActive && !this.overlayExclusive) padding = this.beans.ctrlsSvc.get("gridHeaderCtrl")?.headerHeight || 0;
        if (padding !== this.oldWrapperPadding) {
            this.oldWrapperPadding = padding;
            this.eOverlayWrapper.style.setProperty("padding-top", `${padding}px`);
        }
    }
    destroyActiveOverlay() {
        this.activePromise = null;
        const activeOverlay = this.activeOverlay;
        if (!activeOverlay) {
            this.overlayExclusive = false;
            this.elToFocusAfter = null;
            this.refreshWrapperPadding();
            return;
        }
        let elementToFocus = this.elToFocusAfter;
        this.elToFocusAfter = null;
        this.activeOverlay = null;
        this.overlayExclusive = false;
        if (elementToFocus && !this.isGridFocused()) elementToFocus = null;
        this.destroyBean(activeOverlay);
        const eOverlayWrapper = this.eOverlayWrapper;
        if (eOverlayWrapper) $437b23f6a393c3bf$export$69e6e10709eabd91(eOverlayWrapper);
        elementToFocus?.focus?.({
            preventScroll: true
        });
        this.refreshWrapperPadding();
    }
    hideOverlay() {
        this.destroyActiveOverlay();
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
    }
    isGridFocused() {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return !!activeEl && this.beans.eGridDiv.contains(activeEl);
    }
    destroy() {
        this.elToFocusAfter = null;
        this.destroyActiveOverlay();
        this.beans.overlays.setWrapperComp(this, true);
        super.destroy();
        this.eOverlayWrapper = null;
    }
};
var $437b23f6a393c3bf$var$OverlayWrapperSelector = {
    selector: "AG-OVERLAY-WRAPPER",
    component: $437b23f6a393c3bf$var$OverlayWrapperComponent
};
// packages/ag-grid-community/src/rendering/overlays/overlayService.ts
var $437b23f6a393c3bf$var$overlayCompTypeOptionalMethods = [
    "refresh"
];
var $437b23f6a393c3bf$var$overlayCompType = (name)=>({
        name: name,
        optionalMethods: $437b23f6a393c3bf$var$overlayCompTypeOptionalMethods
    });
var $437b23f6a393c3bf$var$LoadingOverlayDef = {
    id: "agLoadingOverlay",
    overlayType: "loading",
    comp: $437b23f6a393c3bf$var$overlayCompType("loadingOverlayComponent"),
    wrapperCls: "ag-overlay-loading-wrapper",
    exclusive: true,
    compKey: "loadingOverlayComponent",
    paramsKey: "loadingOverlayComponentParams",
    isSuppressed: (gos)=>{
        const isLoading = gos.get("loading");
        return isLoading === false || gos.get("suppressLoadingOverlay") === true && isLoading !== true;
    }
};
var $437b23f6a393c3bf$var$NoRowsOverlayDef = {
    id: "agNoRowsOverlay",
    overlayType: "noRows",
    comp: $437b23f6a393c3bf$var$overlayCompType("noRowsOverlayComponent"),
    wrapperCls: "ag-overlay-no-rows-wrapper",
    compKey: "noRowsOverlayComponent",
    paramsKey: "noRowsOverlayComponentParams",
    isSuppressed: (gos)=>gos.get("suppressNoRowsOverlay")
};
var $437b23f6a393c3bf$var$NoMatchingRowsOverlayDef = {
    id: "agNoMatchingRowsOverlay",
    overlayType: "noMatchingRows",
    comp: $437b23f6a393c3bf$var$overlayCompType("noMatchingRowsOverlayComponent"),
    wrapperCls: "ag-overlay-no-matching-rows-wrapper"
};
var $437b23f6a393c3bf$var$ExportingOverlayDef = {
    id: "agExportingOverlay",
    overlayType: "exporting",
    comp: $437b23f6a393c3bf$var$overlayCompType("exportingOverlayComponent"),
    wrapperCls: "ag-overlay-exporting-wrapper",
    exclusive: true
};
var $437b23f6a393c3bf$var$CustomOverlayDef = {
    id: "activeOverlay",
    comp: $437b23f6a393c3bf$var$overlayCompType("activeOverlay"),
    wrapperCls: "ag-overlay-modal-wrapper",
    exclusive: true
};
var $437b23f6a393c3bf$var$getActiveOverlayDef = (activeOverlay)=>{
    if (!activeOverlay) return null;
    return ({
        agLoadingOverlay: $437b23f6a393c3bf$var$LoadingOverlayDef,
        agNoRowsOverlay: $437b23f6a393c3bf$var$NoRowsOverlayDef,
        agNoMatchingRowsOverlay: $437b23f6a393c3bf$var$NoMatchingRowsOverlayDef,
        agExportingOverlay: $437b23f6a393c3bf$var$ExportingOverlayDef
    })[activeOverlay] ?? $437b23f6a393c3bf$var$CustomOverlayDef;
};
var $437b23f6a393c3bf$var$getOverlayDefForType = (overlayType)=>{
    if (!overlayType) return null;
    return ({
        loading: $437b23f6a393c3bf$var$LoadingOverlayDef,
        noRows: $437b23f6a393c3bf$var$NoRowsOverlayDef,
        noMatchingRows: $437b23f6a393c3bf$var$NoMatchingRowsOverlayDef,
        exporting: $437b23f6a393c3bf$var$ExportingOverlayDef
    })[overlayType];
};
var $437b23f6a393c3bf$var$OverlayService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "overlays";
        this.eWrapper = void 0;
        this.exclusive = false;
        this.oldExclusive = false;
        this.currentDef = null;
        this.showInitialOverlay = true;
        this.userForcedNoRows = false;
        this.exportsInProgress = 0;
        this.newColumnsLoadedCleanup = null;
    }
    postConstruct() {
        const gos = this.gos;
        this.showInitialOverlay = $437b23f6a393c3bf$export$9f182d9ca737e15(gos);
        const updateOverlayVisibility = ()=>{
            if (this.userForcedNoRows) return;
            this.updateOverlay(false);
        };
        const [newColumnsLoadedCleanup, rowCountReadyCleanup, _, __] = this.addManagedEventListeners({
            newColumnsLoaded: updateOverlayVisibility,
            rowCountReady: ()=>{
                this.disableInitialOverlay();
                updateOverlayVisibility();
                rowCountReadyCleanup();
            },
            rowDataUpdated: updateOverlayVisibility,
            modelUpdated: updateOverlayVisibility
        });
        this.newColumnsLoadedCleanup = newColumnsLoadedCleanup;
        this.addManagedPropertyListeners([
            "loading",
            "activeOverlay",
            "activeOverlayParams",
            "overlayComponentParams",
            "loadingOverlayComponentParams",
            "noRowsOverlayComponentParams"
        ], (params)=>this.onPropChange(new Set(params.changeSet?.properties)));
    }
    destroy() {
        this.doHideOverlay();
        super.destroy();
        this.eWrapper = void 0;
    }
    setWrapperComp(overlayWrapperComp, destroyed) {
        if (!this.isAlive()) return;
        if (!destroyed) this.eWrapper = overlayWrapperComp;
        else if (this.eWrapper === overlayWrapperComp) this.eWrapper = void 0;
        this.updateOverlay(false);
    }
    /** Returns true if the overlay is visible. */ isVisible() {
        return !!this.currentDef;
    }
    showLoadingOverlay() {
        this.showInitialOverlay = false;
        const gos = this.gos;
        if (!this.eWrapper || gos.get("activeOverlay")) return;
        if (this.isDisabled($437b23f6a393c3bf$var$LoadingOverlayDef)) return;
        const loading = gos.get("loading");
        if (!loading && loading !== void 0) return;
        this.doShowOverlay($437b23f6a393c3bf$var$LoadingOverlayDef);
    }
    showNoRowsOverlay() {
        this.showInitialOverlay = false;
        const gos = this.gos;
        if (!this.eWrapper || gos.get("activeOverlay") || gos.get("loading") || this.isDisabled($437b23f6a393c3bf$var$NoRowsOverlayDef)) return;
        this.userForcedNoRows = true;
        this.doShowOverlay($437b23f6a393c3bf$var$NoRowsOverlayDef);
    }
    async showExportOverlay(heavyOperation) {
        const { gos: gos, beans: beans } = this;
        if (!this.eWrapper || gos.get("activeOverlay") || gos.get("loading") || this.isDisabled($437b23f6a393c3bf$var$ExportingOverlayDef) || this.userForcedNoRows && this.currentDef === $437b23f6a393c3bf$var$NoRowsOverlayDef) {
            heavyOperation();
            return;
        }
        const desiredDef = this.getDesiredDefWithOverride($437b23f6a393c3bf$var$ExportingOverlayDef);
        if (!desiredDef) {
            heavyOperation();
            return;
        }
        this.exportsInProgress++;
        this.focusedCell = beans.focusSvc.getFocusedCell();
        await this.doShowOverlay(desiredDef);
        await new Promise((resolve)=>setTimeout(()=>resolve()));
        const shownAt = Date.now();
        try {
            heavyOperation();
        } finally{
            const elapsed = Date.now() - shownAt;
            const remaining = Math.max(0, 300 - elapsed);
            const clearExportOverlay = ()=>{
                this.exportsInProgress--;
                if (this.exportsInProgress === 0) {
                    this.updateOverlay(false);
                    $437b23f6a393c3bf$export$d43227ca3cbe63fa(beans, this.focusedCell);
                    this.focusedCell = null;
                }
            };
            if (remaining > 0) setTimeout(()=>clearExportOverlay(), remaining);
            else clearExportOverlay();
        }
    }
    hideOverlay() {
        const gos = this.gos;
        this.showInitialOverlay = false;
        const userHadForced = this.userForcedNoRows;
        this.userForcedNoRows = false;
        if (gos.get("loading")) {
            $437b23f6a393c3bf$export$545083624300f13d(99);
            return;
        }
        if (gos.get("activeOverlay")) {
            $437b23f6a393c3bf$export$545083624300f13d(296);
            return;
        }
        if (this.currentDef === $437b23f6a393c3bf$var$NoMatchingRowsOverlayDef) {
            $437b23f6a393c3bf$export$545083624300f13d(297);
            return;
        }
        this.doHideOverlay();
        if (userHadForced) {
            if (this.getOverlayDef() !== $437b23f6a393c3bf$var$NoRowsOverlayDef) this.updateOverlay(false);
        }
    }
    getOverlayWrapperSelector() {
        return $437b23f6a393c3bf$var$OverlayWrapperSelector;
    }
    getOverlayWrapperCompClass() {
        return $437b23f6a393c3bf$var$OverlayWrapperComponent;
    }
    onPropChange(changedProps) {
        const activeOverlayChanged = changedProps.has("activeOverlay");
        if (activeOverlayChanged || changedProps.has("loading")) {
            if (this.updateOverlay(activeOverlayChanged)) return;
        }
        const currentDef = this.currentDef;
        const currOverlayComp = this.eWrapper?.activeOverlay;
        if (currOverlayComp && currentDef) {
            const activeOverlayParamsChanged = changedProps.has("activeOverlayParams");
            if (currentDef === $437b23f6a393c3bf$var$CustomOverlayDef) {
                if (activeOverlayParamsChanged) currOverlayComp.refresh?.(this.makeCompParams(true));
            } else {
                const paramsKey = currentDef.paramsKey;
                if (changedProps.has("overlayComponentParams") || paramsKey && changedProps.has(paramsKey)) currOverlayComp.refresh?.(this.makeCompParams(false, paramsKey, currentDef.overlayType));
            }
        }
    }
    updateOverlay(activeOverlayChanged) {
        const eWrapper = this.eWrapper;
        if (!eWrapper) {
            this.currentDef = null;
            return false;
        }
        const desiredDef = this.getDesiredDefWithOverride();
        const currentDef = this.currentDef;
        const shouldReload = desiredDef === $437b23f6a393c3bf$var$CustomOverlayDef && activeOverlayChanged;
        if (desiredDef !== currentDef) {
            if (!desiredDef) {
                this.disableInitialOverlay();
                return this.doHideOverlay();
            }
            this.doShowOverlay(desiredDef);
            return true;
        }
        if (shouldReload && desiredDef) {
            eWrapper.hideOverlay();
            this.doShowOverlay(desiredDef);
            return true;
        }
        if (!desiredDef) this.disableInitialOverlay();
        return false;
    }
    getDesiredDefWithOverride(defaultDef) {
        const { gos: gos } = this;
        let desiredDef = $437b23f6a393c3bf$var$getActiveOverlayDef(gos.get("activeOverlay"));
        if (!desiredDef) {
            desiredDef = defaultDef ?? this.getOverlayDef();
            if (desiredDef && this.isDisabled(desiredDef)) desiredDef = null;
        }
        return desiredDef;
    }
    getOverlayDef() {
        const { gos: gos, beans: beans } = this;
        const { colModel: colModel, rowModel: rowModel } = beans;
        const loading = gos.get("loading");
        const loadingDefined = loading !== void 0;
        if (loadingDefined) {
            this.disableInitialOverlay();
            if (loading) return $437b23f6a393c3bf$var$LoadingOverlayDef;
        } else if (this.showInitialOverlay) {
            if (!this.isDisabled($437b23f6a393c3bf$var$LoadingOverlayDef) && (!gos.get("columnDefs") || !colModel.ready || !gos.get("rowData"))) return $437b23f6a393c3bf$var$LoadingOverlayDef;
            this.disableInitialOverlay();
        } else this.disableInitialOverlay();
        const overlayType = rowModel.getOverlayType();
        return $437b23f6a393c3bf$var$getOverlayDefForType(overlayType);
    }
    disableInitialOverlay() {
        this.showInitialOverlay = false;
        this.newColumnsLoadedCleanup?.();
        this.newColumnsLoadedCleanup = null;
    }
    /**
   * Show an overlay requested by name or by built-in types.
   * This single function replaces the previous three helpers and handles
   * param selection and wrapper class choice for loading / no-rows and custom overlays.
   */ doShowOverlay(componentDef) {
        const { gos: gos, beans: beans } = this;
        const { userCompFactory: userCompFactory } = beans;
        this.currentDef = componentDef;
        const isProvidedOverlay = componentDef !== $437b23f6a393c3bf$var$CustomOverlayDef;
        const exclusive = !!componentDef.exclusive;
        this.exclusive = exclusive;
        let legacyParamsKey;
        if (componentDef.paramsKey && gos.get(componentDef.paramsKey) || componentDef.compKey && gos.get(componentDef.compKey)) legacyParamsKey = componentDef.paramsKey;
        let compDetails = void 0;
        if (isProvidedOverlay) {
            if (gos.get("overlayComponent") || gos.get("overlayComponentSelector")) compDetails = userCompFactory.getCompDetailsFromGridOptions({
                name: "overlayComponent",
                optionalMethods: [
                    "refresh"
                ]
            }, void 0, this.makeCompParams(false, componentDef.paramsKey, componentDef.overlayType));
        }
        compDetails ?? (compDetails = userCompFactory.getCompDetailsFromGridOptions(componentDef.comp, isProvidedOverlay ? componentDef.id : void 0, this.makeCompParams(!isProvidedOverlay, legacyParamsKey, componentDef.overlayType), false));
        const promise = compDetails?.newAgStackInstance() ?? null;
        const mountedPromise = this.eWrapper ? this.eWrapper.showOverlay(promise, componentDef.wrapperCls, exclusive) : $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
        this.eWrapper?.refreshWrapperPadding();
        this.setExclusive(exclusive);
        return mountedPromise;
    }
    makeCompParams(includeActiveOverlayParams, legacyParamsKey, overlayType) {
        const { gos: gos } = this;
        const params = includeActiveOverlayParams ? gos.get("activeOverlayParams") : {
            ...gos.get("overlayComponentParams"),
            ...legacyParamsKey && gos.get(legacyParamsKey) || null,
            overlayType: overlayType
        };
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, params ?? {});
    }
    doHideOverlay() {
        let changed = false;
        if (this.currentDef) {
            this.currentDef = null;
            changed = true;
        }
        this.exclusive = false;
        const eWrapper = this.eWrapper;
        if (eWrapper) {
            eWrapper.hideOverlay();
            eWrapper.refreshWrapperPadding();
            this.setExclusive(false);
        }
        return changed;
    }
    setExclusive(exclusive) {
        if (this.oldExclusive !== exclusive) {
            this.oldExclusive = exclusive;
            this.eventSvc.dispatchEvent({
                type: "overlayExclusiveChanged"
            });
        }
    }
    isDisabled(def) {
        const { gos: gos } = this;
        return def.overlayType && gos.get("suppressOverlays")?.includes(def.overlayType) || def.isSuppressed?.(gos) === true;
    }
};
// packages/ag-grid-community/src/rendering/overlays/overlayModule.ts
var $437b23f6a393c3bf$var$OverlayModule = {
    moduleName: "Overlay",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agLoadingOverlay: $437b23f6a393c3bf$var$LoadingOverlayComponent,
        agNoRowsOverlay: $437b23f6a393c3bf$var$NoRowsOverlayComponent,
        agNoMatchingRowsOverlay: $437b23f6a393c3bf$var$NoMatchingRowsOverlayComponent,
        agExportingOverlay: $437b23f6a393c3bf$var$ExportingOverlayComponent
    },
    apiFunctions: {
        showLoadingOverlay: $437b23f6a393c3bf$var$showLoadingOverlay,
        showNoRowsOverlay: $437b23f6a393c3bf$var$showNoRowsOverlay,
        hideOverlay: $437b23f6a393c3bf$var$hideOverlay
    },
    icons: {
        // rotating spinner shown by the loading overlay
        overlayLoading: "loading",
        overlayExporting: "loading"
    },
    beans: [
        $437b23f6a393c3bf$var$OverlayService
    ]
};
// packages/ag-grid-community/src/rendering/rowContainerHeightService.ts
var $437b23f6a393c3bf$var$RowContainerHeightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowContainerHeight";
        // the scrollY position
        this.scrollY = 0;
        // how tall the body is
        this.uiBodyHeight = 0;
    }
    postConstruct() {
        this.addManagedEventListeners({
            bodyHeightChanged: this.updateOffset.bind(this)
        });
        this.maxDivHeight = $437b23f6a393c3bf$var$_getMaxDivHeight();
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, "RowContainerHeightService - maxDivHeight = " + this.maxDivHeight);
    }
    updateOffset() {
        if (!this.stretching) return;
        const newScrollY = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition().top;
        const newBodyHeight = this.getUiBodyHeight();
        const atLeastOneChanged = newScrollY !== this.scrollY || newBodyHeight !== this.uiBodyHeight;
        if (atLeastOneChanged) {
            this.scrollY = newScrollY;
            this.uiBodyHeight = newBodyHeight;
            this.calculateOffset();
        }
    }
    calculateOffset() {
        this.setUiContainerHeight(this.maxDivHeight);
        this.pixelsToShave = this.modelHeight - this.uiContainerHeight;
        this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
        const scrollPercent = this.scrollY / this.maxScrollY;
        const divStretchOffset = scrollPercent * this.pixelsToShave;
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowContainerHeightService - Div Stretch Offset = ${divStretchOffset} (${this.pixelsToShave} * ${scrollPercent})`);
        this.setDivStretchOffset(divStretchOffset);
    }
    setUiContainerHeight(height) {
        if (height !== this.uiContainerHeight) {
            this.uiContainerHeight = height;
            this.eventSvc.dispatchEvent({
                type: "rowContainerHeightChanged"
            });
        }
    }
    clearOffset() {
        this.setUiContainerHeight(this.modelHeight);
        this.pixelsToShave = 0;
        this.setDivStretchOffset(0);
    }
    setDivStretchOffset(newOffset) {
        const newOffsetFloor = typeof newOffset === "number" ? Math.floor(newOffset) : null;
        if (this.divStretchOffset === newOffsetFloor) return;
        this.divStretchOffset = newOffsetFloor;
        this.eventSvc.dispatchEvent({
            type: "heightScaleChanged"
        });
    }
    setModelHeight(modelHeight) {
        this.modelHeight = modelHeight;
        this.stretching = modelHeight != null && // null happens when in print layout
        this.maxDivHeight > 0 && modelHeight > this.maxDivHeight;
        if (this.stretching) this.calculateOffset();
        else this.clearOffset();
    }
    getRealPixelPosition(modelPixel) {
        return modelPixel - this.divStretchOffset;
    }
    getUiBodyHeight() {
        const pos = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
        return pos.bottom - pos.top;
    }
    getScrollPositionForPixel(rowTop) {
        if (this.pixelsToShave <= 0) return rowTop;
        const modelMaxScroll = this.modelHeight - this.getUiBodyHeight();
        const scrollPercent = rowTop / modelMaxScroll;
        const scrollPixel = this.maxScrollY * scrollPercent;
        return scrollPixel;
    }
};
// packages/ag-grid-community/src/rendering/rowRenderer.ts
var $437b23f6a393c3bf$var$ROW_ANIMATION_TIMEOUT = 400;
var $437b23f6a393c3bf$var$RowRenderer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowRenderer";
        this.destroyFuncsForColumnListeners = [];
        // map of row ids to row objects. keeps track of which elements
        // are rendered for which rows in the dom.
        this.rowCtrlsByRowIndex = {};
        this.zombieRowCtrls = {};
        this.allRowCtrls = [];
        this.topRowCtrls = [];
        this.bottomRowCtrls = [];
        // we only allow one refresh at a time, otherwise the internal memory structure here
        // will get messed up. this can happen if the user has a cellRenderer, and inside the
        // renderer they call an API method that results in another pass of the refresh,
        // then it will be trying to draw rows in the middle of a refresh.
        this.refreshInProgress = false;
        this.dataFirstRenderedFired = false;
        this.setupRangeSelectionListeners = ()=>{
            const onCellSelectionChanged = ()=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onCellSelectionChanged();
            };
            const onColumnMovedPinnedVisible = ()=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.updateRangeBordersIfRangeCount();
            };
            const addCellSelectionListeners = ()=>{
                this.eventSvc.addListener("cellSelectionChanged", onCellSelectionChanged);
                this.eventSvc.addListener("columnMoved", onColumnMovedPinnedVisible);
                this.eventSvc.addListener("columnPinned", onColumnMovedPinnedVisible);
                this.eventSvc.addListener("columnVisible", onColumnMovedPinnedVisible);
            };
            const removeCellSelectionListeners = ()=>{
                this.eventSvc.removeListener("cellSelectionChanged", onCellSelectionChanged);
                this.eventSvc.removeListener("columnMoved", onColumnMovedPinnedVisible);
                this.eventSvc.removeListener("columnPinned", onColumnMovedPinnedVisible);
                this.eventSvc.removeListener("columnVisible", onColumnMovedPinnedVisible);
            };
            this.addDestroyFunc(()=>removeCellSelectionListeners());
            this.addManagedPropertyListeners([
                "enableRangeSelection",
                "cellSelection"
            ], ()=>{
                const isEnabled = $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos);
                if (isEnabled) addCellSelectionListeners();
                else removeCellSelectionListeners();
            });
            const cellSelectionEnabled = $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos);
            if (cellSelectionEnabled) addCellSelectionListeners();
        };
    }
    wireBeans(beans) {
        this.pageBounds = beans.pageBounds;
        this.colModel = beans.colModel;
        this.pinnedRowModel = beans.pinnedRowModel;
        this.rowModel = beans.rowModel;
        this.focusSvc = beans.focusSvc;
        this.rowContainerHeight = beans.rowContainerHeight;
        this.ctrlsSvc = beans.ctrlsSvc;
        this.editSvc = beans.editSvc;
    }
    postConstruct() {
        this.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.initialise();
        });
    }
    initialise() {
        this.addManagedEventListeners({
            paginationChanged: this.onPageLoaded.bind(this),
            pinnedRowDataChanged: this.onPinnedRowDataChanged.bind(this),
            pinnedRowsChanged: this.onPinnedRowsChanged.bind(this),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            bodyScroll: this.onBodyScroll.bind(this),
            bodyHeightChanged: this.redraw.bind(this, {})
        });
        this.addManagedPropertyListeners([
            "domLayout",
            "embedFullWidthRows"
        ], ()=>this.onDomLayoutChanged());
        this.addManagedPropertyListeners([
            "suppressMaxRenderedRowRestriction",
            "rowBuffer"
        ], ()=>this.redraw());
        this.addManagedPropertyListener("suppressCellFocus", (e)=>this.onSuppressCellFocusChanged(e.currentValue));
        this.addManagedPropertyListeners([
            "groupSuppressBlankHeader",
            "getBusinessKeyForNode",
            "fullWidthCellRenderer",
            "fullWidthCellRendererParams",
            "suppressStickyTotalRow",
            "groupRowRenderer",
            "groupRowRendererParams",
            // maybe only needs to refresh FW rows...
            "loadingCellRenderer",
            "loadingCellRendererParams",
            "detailCellRenderer",
            "detailCellRendererParams",
            "enableRangeSelection",
            "enableCellTextSelection"
        ], ()=>this.redrawRows());
        this.addManagedPropertyListener("cellSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            if (!previousValue && currentValue || previousValue && !currentValue) this.redrawRows();
        });
        const { stickyRowSvc: stickyRowSvc, gos: gos, showRowGroupCols: showRowGroupCols } = this.beans;
        if (showRowGroupCols) this.addManagedPropertyListener("showOpenedGroup", ()=>{
            const columns = showRowGroupCols.columns;
            if (columns.length) this.refreshCells({
                columns: columns,
                force: true
            });
        });
        if (stickyRowSvc) this.stickyRowFeature = stickyRowSvc.createStickyRowFeature(this, this.createRowCon.bind(this), this.destroyRowCtrls.bind(this));
        else {
            const gridBodyCtrl = this.gridBodyCtrl;
            gridBodyCtrl.setStickyTopHeight(0);
            gridBodyCtrl.setStickyBottomHeight(0);
        }
        this.registerCellEventListeners();
        this.initialiseCache();
        this.printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        this.embedFullWidthRows = this.printLayout || gos.get("embedFullWidthRows");
        this.redrawAfterModelUpdate();
    }
    initialiseCache() {
        if (this.gos.get("keepDetailRows")) {
            const countProp = this.getKeepDetailRowsCount();
            const count = countProp != null ? countProp : 3;
            this.cachedRowCtrls = new $437b23f6a393c3bf$var$RowCtrlCache(count);
        }
    }
    getKeepDetailRowsCount() {
        return this.gos.get("keepDetailRowsCount");
    }
    getStickyTopRowCtrls() {
        return this.stickyRowFeature?.stickyTopRowCtrls ?? [];
    }
    getStickyBottomRowCtrls() {
        return this.stickyRowFeature?.stickyBottomRowCtrls ?? [];
    }
    updateAllRowCtrls() {
        const liveList = Object.values(this.rowCtrlsByRowIndex);
        const zombieList = Object.values(this.zombieRowCtrls);
        const cachedList = this.cachedRowCtrls?.getEntries() ?? [];
        if (zombieList.length > 0 || cachedList.length > 0) this.allRowCtrls = [
            ...liveList,
            ...zombieList,
            ...cachedList
        ];
        else this.allRowCtrls = liveList;
    }
    /**
   * Checks if the cell is rendered or not. Also returns true if row ctrl is present but has not rendered
   * cells yet.
   * @returns true if cellCtrl is present, or if the row is present but has not rendered rows yet
   */ isCellBeingRendered(rowIndex, column) {
        const rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
        if (!column || !rowCtrl) return !!rowCtrl;
        if (rowCtrl.isFullWidth()) return true;
        const spannedCell = this.beans.spannedRowRenderer?.getCellByPosition({
            rowIndex: rowIndex,
            column: column,
            rowPinned: null
        });
        return !!spannedCell || !!rowCtrl.getCellCtrl(column) || !rowCtrl.isRowRendered();
    }
    /**
   * Notifies all row and cell controls of any change in focused cell.
   * @param event cell focused event
   */ updateCellFocus(event) {
        for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onCellFocused(event);
        for (const rowCtrl of this.getFullWidthRowCtrls())rowCtrl.onFullWidthRowFocused(event);
    }
    /**
   * Called when a new cell is focused in the grid
   * - if the focused cell isn't rendered; re-draw rows to dry to render it
   * - subsequently updates all cell and row controls with the new focused cell
   * @param event cell focused event
   */ onCellFocusChanged(event) {
        if (event?.rowIndex != null && !event.rowPinned) {
            const col = this.beans.colModel.getCol(event.column) ?? void 0;
            if (!this.isCellBeingRendered(event.rowIndex, col)) this.redraw();
        }
        this.updateCellFocus(event);
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onSuppressCellFocusChanged(suppressCellFocus);
        for (const rowCtrl of this.getFullWidthRowCtrls())rowCtrl.onSuppressCellFocusChanged(suppressCellFocus);
    }
    // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
    // registering and de-registering for events is a performance bottleneck. so we register here once and inform
    // all active cells.
    registerCellEventListeners() {
        this.addManagedEventListeners({
            cellFocused: (event)=>this.onCellFocusChanged(event),
            cellFocusCleared: ()=>this.updateCellFocus(),
            flashCells: (event)=>{
                const { cellFlashSvc: cellFlashSvc } = this.beans;
                if (cellFlashSvc) for (const cellCtrl of this.getAllCellCtrls())cellFlashSvc.onFlashCells(cellCtrl, event);
            },
            columnHoverChanged: ()=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onColumnHover();
            },
            displayedColumnsChanged: ()=>{
                for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onDisplayedColumnsChanged();
            },
            displayedColumnsWidthChanged: ()=>{
                if (this.printLayout) for (const cellCtrl of this.getAllCellCtrls())cellCtrl.onLeftChanged();
            }
        });
        this.setupRangeSelectionListeners();
        this.refreshListenersToColumnsForCellComps();
        this.addManagedEventListeners({
            gridColumnsChanged: this.refreshListenersToColumnsForCellComps.bind(this)
        });
        this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
    }
    // executes all functions in destroyFuncsForColumnListeners and then clears the list
    removeGridColumnListeners() {
        for (const func of this.destroyFuncsForColumnListeners)func();
        this.destroyFuncsForColumnListeners.length = 0;
    }
    // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
    // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
    // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
    // once instead.
    refreshListenersToColumnsForCellComps() {
        this.removeGridColumnListeners();
        const cols = this.colModel.getCols();
        for (const col of cols){
            const forEachCellWithThisCol = (callback)=>{
                for (const cellCtrl of this.getAllCellCtrls())if (cellCtrl.column === col) callback(cellCtrl);
            };
            const leftChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLeftChanged());
            };
            const widthChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onWidthChanged());
            };
            const firstRightPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onFirstRightPinnedChanged());
            };
            const lastLeftPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLastLeftPinnedChanged());
            };
            const colDefChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onColDefChanged());
            };
            col.__addEventListener("leftChanged", leftChangedListener);
            col.__addEventListener("widthChanged", widthChangedListener);
            col.__addEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
            col.__addEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
            col.__addEventListener("colDefChanged", colDefChangedListener);
            this.destroyFuncsForColumnListeners.push(()=>{
                col.__removeEventListener("leftChanged", leftChangedListener);
                col.__removeEventListener("widthChanged", widthChangedListener);
                col.__removeEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
                col.__removeEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
                col.__removeEventListener("colDefChanged", colDefChangedListener);
            });
        }
    }
    onDomLayoutChanged() {
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const embedFullWidthRows = printLayout || this.gos.get("embedFullWidthRows");
        const destroyRows = embedFullWidthRows !== this.embedFullWidthRows || this.printLayout !== printLayout;
        this.printLayout = printLayout;
        this.embedFullWidthRows = embedFullWidthRows;
        if (destroyRows) this.redrawAfterModelUpdate({
            domLayoutChanged: true
        });
    }
    // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
    // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
    datasourceChanged() {
        this.firstRenderedRow = 0;
        this.lastRenderedRow = -1;
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove);
    }
    onPageLoaded(event) {
        const params = {
            recycleRows: event.keepRenderedRows,
            animate: event.animate,
            newData: event.newData,
            newPage: event.newPage,
            // because this is a model updated event (not pinned rows), we
            // can skip updating the pinned rows. this is needed so that if user
            // is doing transaction updates, the pinned rows are not getting constantly
            // trashed - or editing cells in pinned rows are not refreshed and put into read mode
            onlyBody: true
        };
        this.redrawAfterModelUpdate(params);
    }
    /**
   * @param column AgColumn
   * @returns An array with HTMLElement for every cell of the column passed as param.
   * If the cell is spanning across multiple columns, it only returns the html element
   * if the column passed is the first column of the span (used for auto width calculation).
   */ getAllCellsNotSpanningForColumn(column) {
        const res = [];
        for (const rowCtrl of this.getAllRowCtrls()){
            const eCell = rowCtrl.getCellCtrl(column, true)?.eGui;
            if (eCell) res.push(eCell);
        }
        return res;
    }
    refreshFloatingRowComps(recycleRows = true) {
        this.refreshFloatingRows(this.topRowCtrls, "top", recycleRows);
        this.refreshFloatingRows(this.bottomRowCtrls, "bottom", recycleRows);
    }
    /**
   * Determines which row controllers need to be destroyed and re-created vs which ones can
   * be re-used.
   *
   * This is operation is to pinned/floating rows as `this.recycleRows` is to normal/body rows.
   *
   * All `RowCtrl` instances in `rowCtrls` that don't correspond to `RowNode` instances in `rowNodes` are destroyed.
   * All `RowNode` instances in `rowNodes` that don't correspond to `RowCtrl` instances in `rowCtrls` are created.
   * All instances in `rowCtrls` must be in the same order as their corresponding nodes in `rowNodes`.
   *
   * @param rowCtrls The list of existing row controllers
   * @param rowNodes The canonical list of row nodes that should have associated controllers
   */ refreshFloatingRows(rowCtrls, floating, recycleRows) {
        const { pinnedRowModel: pinnedRowModel, beans: beans, printLayout: printLayout } = this;
        const rowCtrlMap = Object.fromEntries(rowCtrls.map((ctrl)=>[
                ctrl.rowNode.id,
                ctrl
            ]));
        pinnedRowModel?.forEachPinnedRow(floating, (node, i)=>{
            const rowCtrl = rowCtrls[i];
            const rowCtrlDoesNotExist = rowCtrl && pinnedRowModel.getPinnedRowById(rowCtrl.rowNode.id, floating) === void 0;
            if (rowCtrlDoesNotExist) {
                rowCtrl.destroyFirstPass();
                rowCtrl.destroySecondPass();
            }
            if (node.id in rowCtrlMap && recycleRows) {
                rowCtrls[i] = rowCtrlMap[node.id];
                delete rowCtrlMap[node.id];
            } else rowCtrls[i] = new $437b23f6a393c3bf$var$RowCtrl(node, beans, false, false, printLayout);
        });
        const rowNodeCount = (floating === "top" ? pinnedRowModel?.getPinnedTopRowCount() : pinnedRowModel?.getPinnedBottomRowCount()) ?? 0;
        rowCtrls.length = rowNodeCount;
    }
    onPinnedRowDataChanged() {
        const params = {
            recycleRows: true
        };
        this.redrawAfterModelUpdate(params);
    }
    onPinnedRowsChanged() {
        this.redrawAfterModelUpdate({
            recycleRows: true
        });
    }
    redrawRow(rowNode, suppressEvent = false) {
        if (rowNode.sticky) this.stickyRowFeature?.refreshStickyNode(rowNode);
        else if (this.cachedRowCtrls?.has(rowNode)) {
            this.cachedRowCtrls.removeRow(rowNode);
            return;
        } else {
            const destroyAndRecreateCtrl = (dataStruct)=>{
                const ctrl = dataStruct[rowNode.rowIndex];
                if (!ctrl) return;
                if (ctrl.rowNode !== rowNode) return;
                ctrl.destroyFirstPass();
                ctrl.destroySecondPass();
                dataStruct[rowNode.rowIndex] = this.createRowCon(rowNode, false, false);
            };
            switch(rowNode.rowPinned){
                case "top":
                    destroyAndRecreateCtrl(this.topRowCtrls);
                    break;
                case "bottom":
                    destroyAndRecreateCtrl(this.bottomRowCtrls);
                    break;
                default:
                    destroyAndRecreateCtrl(this.rowCtrlsByRowIndex);
                    this.updateAllRowCtrls();
            }
        }
        if (!suppressEvent) this.dispatchDisplayedRowsChanged(false);
    }
    redrawRows(rowNodes) {
        const { editSvc: editSvc } = this.beans;
        if (editSvc?.isEditing()) {
            if (editSvc.isBatchEditing()) editSvc.cleanupEditors();
            else editSvc.stopEditing(void 0, {
                source: "api"
            });
        }
        const partialRefresh = rowNodes != null;
        if (partialRefresh) {
            for (const node of rowNodes ?? [])this.redrawRow(node, true);
            this.dispatchDisplayedRowsChanged(false);
            return;
        }
        this.redrawAfterModelUpdate();
    }
    // gets called from:
    // +) initialisation (in registerGridComp) params = null
    // +) onDomLayoutChanged, params = null
    // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
    // +) onPinnedRowDataChanged, recycleRows = true
    // +) redrawRows (from Grid API), recycleRows = true/false
    redrawAfterModelUpdate(params = {}) {
        this.getLockOnRefresh();
        const focusedCell = this.beans.focusSvc?.getFocusCellToUseAfterRefresh();
        this.updateContainerHeights();
        this.scrollToTopIfNewData(params);
        const recycleRows = !params.domLayoutChanged && !!params.recycleRows;
        const animate = params.animate && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos);
        const rowsToRecycle = recycleRows ? this.getRowsToRecycle() : null;
        if (!recycleRows) this.removeAllRowComps();
        this.workOutFirstAndLastRowsToRender();
        const { stickyRowFeature: stickyRowFeature, gos: gos } = this;
        if (stickyRowFeature) {
            stickyRowFeature.checkStickyRows();
            const extraHeight = stickyRowFeature.extraTopHeight + stickyRowFeature.extraBottomHeight;
            if (extraHeight) this.updateContainerHeights(extraHeight);
        }
        this.recycleRows(rowsToRecycle, animate);
        this.gridBodyCtrl.updateRowCount();
        if (!params.onlyBody) this.refreshFloatingRowComps(gos.get("enableRowPinning") ? recycleRows : void 0);
        this.dispatchDisplayedRowsChanged();
        if (focusedCell != null) this.restoreFocusedCell(focusedCell);
        this.releaseLockOnRefresh();
    }
    scrollToTopIfNewData(params) {
        const scrollToTop = params.newData || params.newPage;
        const suppressScrollToTop = this.gos.get("suppressScrollOnNewData");
        if (scrollToTop && !suppressScrollToTop) {
            this.gridBodyCtrl.scrollFeature.scrollToTop();
            this.stickyRowFeature?.resetOffsets();
        }
    }
    updateContainerHeights(additionalHeight = 0) {
        const { rowContainerHeight: rowContainerHeight } = this;
        if (this.printLayout) {
            rowContainerHeight.setModelHeight(null);
            return;
        }
        let containerHeight = this.pageBounds.getCurrentPageHeight();
        if (containerHeight === 0) containerHeight = 1;
        rowContainerHeight.setModelHeight(containerHeight + additionalHeight);
    }
    getLockOnRefresh() {
        if (this.refreshInProgress) throw new Error($437b23f6a393c3bf$export$680bb5102fca525e(252));
        this.refreshInProgress = true;
        this.beans.frameworkOverrides.getLockOnRefresh?.();
    }
    releaseLockOnRefresh() {
        this.refreshInProgress = false;
        this.beans.frameworkOverrides.releaseLockOnRefresh?.();
    }
    isRefreshInProgress() {
        return this.refreshInProgress;
    }
    // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
    // edited cell).
    restoreFocusedCell(cellPosition) {
        if (!cellPosition) return;
        const focusSvc = this.beans.focusSvc;
        const cellToFocus = this.findPositionToFocus(cellPosition);
        if (!cellToFocus) {
            focusSvc.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1,
                    column: cellPosition.column
                }
            });
            return;
        }
        if (cellPosition.rowIndex !== cellToFocus.rowIndex || cellPosition.rowPinned != cellToFocus.rowPinned) {
            focusSvc.setFocusedCell({
                ...cellToFocus,
                preventScrollOnBrowserFocus: true,
                forceBrowserFocus: true
            });
            return;
        }
        if (!focusSvc.doesRowOrCellHaveBrowserFocus()) this.updateCellFocus($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            ...cellToFocus,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true,
            type: "cellFocused"
        }));
    }
    findPositionToFocus(cellPosition) {
        const { pagination: pagination, pageBounds: pageBounds } = this.beans;
        let rowPosition = cellPosition;
        if (rowPosition.rowPinned == null && pagination && pageBounds && !pagination.isRowInPage(rowPosition.rowIndex)) rowPosition = {
            rowPinned: null,
            rowIndex: pageBounds.getFirstRow()
        };
        while(rowPosition){
            if (rowPosition.rowPinned == null && pageBounds) {
                if (rowPosition.rowIndex < pageBounds.getFirstRow()) {
                    rowPosition = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, {
                        rowPinned: null,
                        rowIndex: 0
                    });
                    if (!rowPosition) return null;
                } else if (rowPosition.rowIndex > pageBounds.getLastRow()) rowPosition = {
                    rowPinned: null,
                    rowIndex: pageBounds.getLastRow()
                };
            }
            const row = this.getRowByPosition(rowPosition);
            if (row?.isAlive()) return {
                ...row.getRowPosition(),
                column: cellPosition.column
            };
            rowPosition = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, rowPosition);
        }
        return null;
    }
    getAllCellCtrls() {
        const res = [];
        const rowCtrls = this.getAllRowCtrls();
        const rowCtrlsLength = rowCtrls.length;
        for(let i = 0; i < rowCtrlsLength; i++){
            const cellCtrls = rowCtrls[i].getAllCellCtrls();
            const cellCtrlsLength = cellCtrls.length;
            for(let j = 0; j < cellCtrlsLength; j++)res.push(cellCtrls[j]);
        }
        return res;
    }
    getAllRowCtrls() {
        const { spannedRowRenderer: spannedRowRenderer } = this.beans;
        const stickyTopRowCtrls = this.getStickyTopRowCtrls();
        const stickyBottomRowCtrls = this.getStickyBottomRowCtrls();
        const res = [
            ...this.topRowCtrls,
            ...this.bottomRowCtrls,
            ...stickyTopRowCtrls,
            ...stickyBottomRowCtrls,
            ...spannedRowRenderer?.getCtrls("top") ?? [],
            ...spannedRowRenderer?.getCtrls("bottom") ?? [],
            ...spannedRowRenderer?.getCtrls("center") ?? [],
            ...Object.values(this.rowCtrlsByRowIndex)
        ];
        return res;
    }
    addRenderedRowListener(eventName, rowIndex, callback) {
        const rowComp = this.rowCtrlsByRowIndex[rowIndex];
        if (rowComp) rowComp.addEventListener(eventName, callback);
    }
    refreshCells({ rowNodes: rowNodes, columns: columns, force: force, suppressFlash: suppressFlash } = {}) {
        const refreshCellParams = {
            force: force,
            newData: false,
            suppressFlash: suppressFlash
        };
        for (const cellCtrl of this.getCellCtrls(rowNodes, columns))cellCtrl.refreshOrDestroyCell(refreshCellParams);
        this.refreshFullWidth(rowNodes);
    }
    refreshRows(params = {}) {
        for (const rowCtrl of this.getRowCtrls(params.rowNodes))rowCtrl.refreshRow(params);
        this.refreshFullWidth(params.rowNodes);
    }
    refreshFullWidth(rowNodes) {
        if (!rowNodes) return;
        let rowRedrawn = false;
        for (const rowCtrl of this.getRowCtrls(rowNodes)){
            if (!rowCtrl.isFullWidth()) continue;
            const refreshed = rowCtrl.refreshFullWidth();
            if (!refreshed) {
                rowRedrawn = true;
                this.redrawRow(rowCtrl.rowNode, true);
            }
        }
        if (rowRedrawn) this.dispatchDisplayedRowsChanged(false);
    }
    /**
   * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
   */ getRowCtrls(rowNodes) {
        const rowIdsMap = $437b23f6a393c3bf$var$mapRowNodes(rowNodes);
        const allRowCtrls = this.getAllRowCtrls();
        if (!rowNodes || !rowIdsMap) return allRowCtrls;
        return allRowCtrls.filter((rowCtrl)=>{
            const rowNode = rowCtrl.rowNode;
            return $437b23f6a393c3bf$var$isRowInMap(rowNode, rowIdsMap);
        });
    }
    // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
    // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
    getCellCtrls(rowNodes, columns) {
        let colIdsMap;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(columns)) {
            colIdsMap = {};
            columns.forEach((colKey)=>{
                const column = this.colModel.getCol(colKey);
                if ($437b23f6a393c3bf$export$25d27f17d3af40f7(column)) colIdsMap[column.getId()] = true;
            });
        }
        const res = [];
        for (const rowCtrl of this.getRowCtrls(rowNodes))for (const cellCtrl of rowCtrl.getAllCellCtrls()){
            const colId = cellCtrl.column.getId();
            const excludeColFromRefresh = colIdsMap && !colIdsMap[colId];
            if (excludeColFromRefresh) continue;
            res.push(cellCtrl);
        }
        return res;
    }
    destroy() {
        this.removeAllRowComps(true);
        super.destroy();
    }
    removeAllRowComps(suppressAnimation = false) {
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove, suppressAnimation);
        this.stickyRowFeature?.destroyStickyCtrls();
    }
    getRowsToRecycle() {
        const stubNodeIndexes = [];
        for (const index of Object.keys(this.rowCtrlsByRowIndex)){
            const rowCtrl = this.rowCtrlsByRowIndex[index];
            const stubNode = rowCtrl.rowNode.id == null;
            if (stubNode) stubNodeIndexes.push(index);
        }
        this.removeRowCtrls(stubNodeIndexes);
        const ctrlsByIdMap = {};
        for (const rowCtrl of Object.values(this.rowCtrlsByRowIndex)){
            const rowNode = rowCtrl.rowNode;
            ctrlsByIdMap[rowNode.id] = rowCtrl;
        }
        this.rowCtrlsByRowIndex = {};
        return ctrlsByIdMap;
    }
    // takes array of row indexes
    removeRowCtrls(rowsToRemove, suppressAnimation = false) {
        for (const indexToRemove of rowsToRemove){
            const rowCtrl = this.rowCtrlsByRowIndex[indexToRemove];
            if (rowCtrl) {
                rowCtrl.destroyFirstPass(suppressAnimation);
                rowCtrl.destroySecondPass();
            }
            delete this.rowCtrlsByRowIndex[indexToRemove];
        }
    }
    onBodyScroll(e) {
        if (e.direction !== "vertical") return;
        this.redraw({
            afterScroll: true
        });
    }
    // gets called when rows don't change, but viewport does, so after:
    // 1) height of grid body changes, ie number of displayed rows has changed
    // 2) grid scrolled to new position
    // 3) ensure index visible (which is a scroll)
    redraw(params = {}) {
        const { focusSvc: focusSvc, animationFrameSvc: animationFrameSvc } = this.beans;
        const { afterScroll: afterScroll } = params;
        let cellFocused;
        const stickyRowFeature = this.stickyRowFeature;
        if (stickyRowFeature) cellFocused = focusSvc?.getFocusCellToUseAfterRefresh() || void 0;
        const oldFirstRow = this.firstRenderedRow;
        const oldLastRow = this.lastRenderedRow;
        this.workOutFirstAndLastRowsToRender();
        let hasStickyRowChanges = false;
        if (stickyRowFeature) {
            hasStickyRowChanges = stickyRowFeature.checkStickyRows();
            const extraHeight = stickyRowFeature.extraTopHeight + stickyRowFeature.extraBottomHeight;
            if (extraHeight) this.updateContainerHeights(extraHeight);
        }
        const rangeChanged = this.firstRenderedRow !== oldFirstRow || this.lastRenderedRow !== oldLastRow;
        if (afterScroll && !hasStickyRowChanges && !rangeChanged) return;
        this.getLockOnRefresh();
        this.recycleRows(null, false, afterScroll);
        this.releaseLockOnRefresh();
        this.dispatchDisplayedRowsChanged(afterScroll && !hasStickyRowChanges);
        if (cellFocused != null) {
            const newFocusedCell = focusSvc?.getFocusCellToUseAfterRefresh();
            if (cellFocused != null && newFocusedCell == null) {
                animationFrameSvc?.flushAllFrames();
                this.restoreFocusedCell(cellFocused);
            }
        }
    }
    removeRowCompsNotToDraw(indexesToDraw, suppressAnimation) {
        const indexesToDrawMap = {};
        for (const index of indexesToDraw)indexesToDrawMap[index] = true;
        const existingIndexes = Object.keys(this.rowCtrlsByRowIndex);
        const indexesNotToDraw = existingIndexes.filter((index)=>!indexesToDrawMap[index]);
        this.removeRowCtrls(indexesNotToDraw, suppressAnimation);
    }
    calculateIndexesToDraw(rowsToRecycle) {
        const indexesToDraw = [];
        for(let i = this.firstRenderedRow; i <= this.lastRenderedRow; i++)indexesToDraw.push(i);
        const pagination = this.beans.pagination;
        const focusedRowIndex = this.beans.focusSvc?.getFocusedCell()?.rowIndex;
        if (focusedRowIndex != null && (focusedRowIndex < this.firstRenderedRow || focusedRowIndex > this.lastRenderedRow) && (!pagination || pagination.isRowInPage(focusedRowIndex)) && focusedRowIndex < this.rowModel.getRowCount()) indexesToDraw.push(focusedRowIndex);
        const checkRowToDraw = (rowComp)=>{
            const index = rowComp.rowNode.rowIndex;
            if (index == null || index === focusedRowIndex) return;
            if (index < this.firstRenderedRow || index > this.lastRenderedRow) {
                if (this.doNotUnVirtualiseRow(rowComp)) indexesToDraw.push(index);
            }
        };
        for (const rowCtrl of Object.values(this.rowCtrlsByRowIndex))checkRowToDraw(rowCtrl);
        if (rowsToRecycle) for (const rowCtrl of Object.values(rowsToRecycle))checkRowToDraw(rowCtrl);
        indexesToDraw.sort((a, b)=>a - b);
        const ret = [];
        for(let i = 0; i < indexesToDraw.length; i++){
            const currRow = indexesToDraw[i];
            const rowNode = this.rowModel.getRow(currRow);
            if (rowNode && !rowNode.sticky) ret.push(currRow);
        }
        return ret;
    }
    recycleRows(rowsToRecycle, animate = false, afterScroll = false) {
        const indexesToDraw = this.calculateIndexesToDraw(rowsToRecycle);
        if (this.printLayout || afterScroll) animate = false;
        this.removeRowCompsNotToDraw(indexesToDraw, !animate);
        for (const rowIndex of indexesToDraw)this.createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll);
        if (rowsToRecycle) {
            const { animationFrameSvc: animationFrameSvc } = this.beans;
            const useAnimationFrame = animationFrameSvc?.active && afterScroll && !this.printLayout;
            if (useAnimationFrame) animationFrameSvc.addDestroyTask(()=>{
                this.destroyRowCtrls(rowsToRecycle, animate);
                this.updateAllRowCtrls();
                this.dispatchDisplayedRowsChanged();
            });
            else this.destroyRowCtrls(rowsToRecycle, animate);
        }
        this.updateAllRowCtrls();
    }
    dispatchDisplayedRowsChanged(afterScroll = false) {
        this.eventSvc.dispatchEvent({
            type: "displayedRowsChanged",
            afterScroll: afterScroll
        });
    }
    onDisplayedColumnsChanged() {
        const { visibleCols: visibleCols } = this.beans;
        const pinningLeft = visibleCols.isPinningLeft();
        const pinningRight = visibleCols.isPinningRight();
        const atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;
        if (atLeastOneChanged) {
            this.pinningLeft = pinningLeft;
            this.pinningRight = pinningRight;
            if (this.embedFullWidthRows) this.redrawFullWidthEmbeddedRows();
        }
    }
    // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
    // then it should go into the pinned left area if pinning left, or the center area if not pinning.
    redrawFullWidthEmbeddedRows() {
        const rowsToRemove = [];
        for (const fullWidthCtrl of this.getFullWidthRowCtrls()){
            const rowIndex = fullWidthCtrl.rowNode.rowIndex;
            rowsToRemove.push(rowIndex.toString());
        }
        this.refreshFloatingRowComps();
        this.removeRowCtrls(rowsToRemove);
        this.redraw({
            afterScroll: true
        });
    }
    getFullWidthRowCtrls(rowNodes) {
        const rowNodesMap = $437b23f6a393c3bf$var$mapRowNodes(rowNodes);
        return this.getAllRowCtrls().filter((rowCtrl)=>{
            if (!rowCtrl.isFullWidth()) return false;
            const rowNode = rowCtrl.rowNode;
            if (rowNodesMap != null && !$437b23f6a393c3bf$var$isRowInMap(rowNode, rowNodesMap)) return false;
            return true;
        });
    }
    createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll) {
        let rowNode;
        let rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
        if (!rowCtrl) {
            rowNode = this.rowModel.getRow(rowIndex);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowNode) && $437b23f6a393c3bf$export$25d27f17d3af40f7(rowsToRecycle) && rowsToRecycle[rowNode.id] && rowNode.alreadyRendered) {
                rowCtrl = rowsToRecycle[rowNode.id];
                rowsToRecycle[rowNode.id] = null;
            }
        }
        const creatingNewRowCtrl = !rowCtrl;
        if (creatingNewRowCtrl) {
            if (!rowNode) rowNode = this.rowModel.getRow(rowIndex);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowNode)) rowCtrl = this.createRowCon(rowNode, animate, afterScroll);
            else return;
        }
        if (rowNode) rowNode.alreadyRendered = true;
        this.rowCtrlsByRowIndex[rowIndex] = rowCtrl;
    }
    destroyRowCtrls(rowCtrlsMap, animate) {
        const executeInAWhileFuncs = [];
        if (rowCtrlsMap) for (const rowCtrl of Object.values(rowCtrlsMap)){
            if (!rowCtrl) continue;
            if (this.cachedRowCtrls && rowCtrl.isCacheable()) {
                this.cachedRowCtrls.addRow(rowCtrl);
                continue;
            }
            rowCtrl.destroyFirstPass(!animate);
            if (animate) {
                const instanceId = rowCtrl.instanceId;
                this.zombieRowCtrls[instanceId] = rowCtrl;
                executeInAWhileFuncs.push(()=>{
                    rowCtrl.destroySecondPass();
                    delete this.zombieRowCtrls[instanceId];
                });
            } else rowCtrl.destroySecondPass();
        }
        if (animate) {
            executeInAWhileFuncs.push(()=>{
                if (this.isAlive()) {
                    this.updateAllRowCtrls();
                    this.dispatchDisplayedRowsChanged();
                }
            });
            window.setTimeout(()=>{
                for (const func of executeInAWhileFuncs)func();
            }, $437b23f6a393c3bf$var$ROW_ANIMATION_TIMEOUT);
        }
    }
    getRowBuffer() {
        return this.gos.get("rowBuffer");
    }
    getRowBufferInPixels() {
        const rowsToBuffer = this.getRowBuffer();
        const defaultRowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
        return rowsToBuffer * defaultRowHeight;
    }
    workOutFirstAndLastRowsToRender() {
        const { rowContainerHeight: rowContainerHeight, pageBounds: pageBounds, rowModel: rowModel } = this;
        rowContainerHeight.updateOffset();
        let newFirst;
        let newLast;
        if (!rowModel.isRowsToRender()) {
            newFirst = 0;
            newLast = -1;
        } else if (this.printLayout) {
            this.beans.environment.refreshRowHeightVariable();
            newFirst = pageBounds.getFirstRow();
            newLast = pageBounds.getLastRow();
        } else {
            const bufferPixels = this.getRowBufferInPixels();
            const scrollFeature = this.ctrlsSvc.getScrollFeature();
            const suppressRowVirtualisation = this.gos.get("suppressRowVirtualisation");
            let rowHeightsChanged = false;
            let firstPixel;
            let lastPixel;
            do {
                const paginationOffset = pageBounds.getPixelOffset();
                const { pageFirstPixel: pageFirstPixel, pageLastPixel: pageLastPixel } = pageBounds.getCurrentPagePixelRange();
                const divStretchOffset = rowContainerHeight.divStretchOffset;
                const bodyVRange = scrollFeature.getVScrollPosition();
                const bodyTopPixel = bodyVRange.top;
                const bodyBottomPixel = bodyVRange.bottom;
                if (suppressRowVirtualisation) {
                    firstPixel = pageFirstPixel + divStretchOffset;
                    lastPixel = pageLastPixel + divStretchOffset;
                } else {
                    firstPixel = Math.max(bodyTopPixel + paginationOffset - bufferPixels, pageFirstPixel) + divStretchOffset;
                    lastPixel = Math.min(bodyBottomPixel + paginationOffset + bufferPixels, pageLastPixel) + divStretchOffset;
                }
                this.firstVisibleVPixel = Math.max(bodyTopPixel + paginationOffset, pageFirstPixel) + divStretchOffset;
                this.lastVisibleVPixel = Math.min(bodyBottomPixel + paginationOffset, pageLastPixel) + divStretchOffset;
                rowHeightsChanged = this.ensureAllRowsInRangeHaveHeightsCalculated(firstPixel, lastPixel);
            }while (rowHeightsChanged);
            let firstRowIndex = rowModel.getRowIndexAtPixel(firstPixel);
            let lastRowIndex = rowModel.getRowIndexAtPixel(lastPixel);
            const pageFirstRow = pageBounds.getFirstRow();
            const pageLastRow = pageBounds.getLastRow();
            if (firstRowIndex < pageFirstRow) firstRowIndex = pageFirstRow;
            if (lastRowIndex > pageLastRow) lastRowIndex = pageLastRow;
            newFirst = firstRowIndex;
            newLast = lastRowIndex;
        }
        const rowLayoutNormal = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        const suppressRowCountRestriction = this.gos.get("suppressMaxRenderedRowRestriction");
        const rowBufferMaxSize = Math.max(this.getRowBuffer(), 500);
        if (rowLayoutNormal && !suppressRowCountRestriction) {
            if (newLast - newFirst > rowBufferMaxSize) newLast = newFirst + rowBufferMaxSize;
        }
        const firstDiffers = newFirst !== this.firstRenderedRow;
        const lastDiffers = newLast !== this.lastRenderedRow;
        if (firstDiffers || lastDiffers) {
            this.firstRenderedRow = newFirst;
            this.lastRenderedRow = newLast;
            this.eventSvc.dispatchEvent({
                type: "viewportChanged",
                firstRow: newFirst,
                lastRow: newLast
            });
        }
    }
    /**
   * This event will only be fired once, and is queued until after the browser next renders.
   * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
   * but not execute the event until all of the data has finished being rendered to the dom.
   */ dispatchFirstDataRenderedEvent() {
        if (this.dataFirstRenderedFired) return;
        this.dataFirstRenderedFired = true;
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>{
            this.beans.eventSvc.dispatchEvent({
                type: "firstDataRendered",
                firstRow: this.firstRenderedRow,
                lastRow: this.lastRenderedRow
            });
        });
    }
    ensureAllRowsInRangeHaveHeightsCalculated(topPixel, bottomPixel) {
        const pinnedRowHeightsChanged = this.pinnedRowModel?.ensureRowHeightsValid();
        const stickyHeightsChanged = this.stickyRowFeature?.ensureRowHeightsValid();
        const { pageBounds: pageBounds, rowModel: rowModel } = this;
        const rowModelHeightsChanged = rowModel.ensureRowHeightsValid(topPixel, bottomPixel, pageBounds.getFirstRow(), pageBounds.getLastRow());
        if (rowModelHeightsChanged || stickyHeightsChanged) this.eventSvc.dispatchEvent({
            type: "recalculateRowBounds"
        });
        if (stickyHeightsChanged || rowModelHeightsChanged || pinnedRowHeightsChanged) {
            this.updateContainerHeights();
            return true;
        }
        return false;
    }
    // check that none of the rows to remove are editing or focused as:
    // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
    //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
    //    the edit is reset - so we want to keep it rendered.
    // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
    //    otherwise the user can range select and drag (with focus cell going out of the viewport)
    //    and then ctrl+c, nothing will happen if cell is removed from dom.
    // c) if detail record of master detail, as users complained that the context of detail rows
    //    was getting lost when detail row out of view. eg user expands to show detail row,
    //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
    //    after detail panel is scrolled out of / into view.
    doNotUnVirtualiseRow(rowCtrl) {
        const REMOVE_ROW = false;
        const KEEP_ROW = true;
        const rowNode = rowCtrl.rowNode;
        const rowHasFocus = this.focusSvc.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
        const rowIsEditing = this.editSvc?.isEditing(rowCtrl);
        const rowIsDetail = rowNode.detail;
        const mightWantToKeepRow = rowHasFocus || rowIsEditing || rowIsDetail;
        if (!mightWantToKeepRow) return REMOVE_ROW;
        const rowNodePresent = this.isRowPresent(rowNode);
        return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
    }
    isRowPresent(rowNode) {
        if (!this.rowModel.isRowPresent(rowNode)) return false;
        return this.beans.pagination?.isRowInPage(rowNode.rowIndex) ?? true;
    }
    createRowCon(rowNode, animate, afterScroll) {
        const rowCtrlFromCache = this.cachedRowCtrls?.getRow(rowNode) ?? null;
        if (rowCtrlFromCache) return rowCtrlFromCache;
        const useAnimationFrameForCreate = afterScroll && !this.printLayout && !!this.beans.animationFrameSvc?.active;
        const res = new $437b23f6a393c3bf$var$RowCtrl(rowNode, this.beans, animate, useAnimationFrameForCreate, this.printLayout);
        return res;
    }
    getRenderedNodes() {
        const viewportRows = Object.values(this.rowCtrlsByRowIndex).map((rowCtrl)=>rowCtrl.rowNode);
        const stickyTopRows = this.getStickyTopRowCtrls().map((rowCtrl)=>rowCtrl.rowNode);
        const stickyBottomRows = this.getStickyBottomRowCtrls().map((rowCtrl)=>rowCtrl.rowNode);
        return [
            ...stickyTopRows,
            ...viewportRows,
            ...stickyBottomRows
        ];
    }
    getRowByPosition(rowPosition) {
        let rowCtrl;
        const { rowIndex: rowIndex } = rowPosition;
        switch(rowPosition.rowPinned){
            case "top":
                rowCtrl = this.topRowCtrls[rowIndex];
                break;
            case "bottom":
                rowCtrl = this.bottomRowCtrls[rowIndex];
                break;
            default:
                rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
                if (!rowCtrl) {
                    rowCtrl = this.getStickyTopRowCtrls().find((ctrl)=>ctrl.rowNode.rowIndex === rowIndex) || null;
                    if (!rowCtrl) rowCtrl = this.getStickyBottomRowCtrls().find((ctrl)=>ctrl.rowNode.rowIndex === rowIndex) || null;
                }
                break;
        }
        return rowCtrl;
    }
    // returns true if any row between startIndex and endIndex is rendered. used by
    // SSRM or IRM, as they don't want to purge visible blocks from cache.
    isRangeInRenderedViewport(startIndex, endIndex) {
        const parentClosed = startIndex == null || endIndex == null;
        if (parentClosed) return false;
        const blockAfterViewport = startIndex > this.lastRenderedRow;
        const blockBeforeViewport = endIndex < this.firstRenderedRow;
        const blockInsideViewport = !blockBeforeViewport && !blockAfterViewport;
        return blockInsideViewport;
    }
};
var $437b23f6a393c3bf$var$RowCtrlCache = class {
    constructor(maxCount){
        // map for fast access
        this.entriesMap = {};
        // list for keeping order
        this.entriesList = [];
        this.maxCount = maxCount;
    }
    addRow(rowCtrl) {
        this.entriesMap[rowCtrl.rowNode.id] = rowCtrl;
        this.entriesList.push(rowCtrl);
        rowCtrl.setCached(true);
        if (this.entriesList.length > this.maxCount) {
            const rowCtrlToDestroy = this.entriesList[0];
            rowCtrlToDestroy.destroyFirstPass();
            rowCtrlToDestroy.destroySecondPass();
            this.removeFromCache(rowCtrlToDestroy);
        }
    }
    getRow(rowNode) {
        if (rowNode?.id == null) return null;
        const res = this.entriesMap[rowNode.id];
        if (!res) return null;
        this.removeFromCache(res);
        res.setCached(false);
        const rowNodeMismatch = res.rowNode != rowNode;
        return rowNodeMismatch ? null : res;
    }
    has(rowNode) {
        return this.entriesMap[rowNode.id] != null;
    }
    removeRow(rowNode) {
        const rowNodeId = rowNode.id;
        const ctrl = this.entriesMap[rowNodeId];
        delete this.entriesMap[rowNodeId];
        $437b23f6a393c3bf$export$83a881c8b5120679(this.entriesList, ctrl);
    }
    removeFromCache(rowCtrl) {
        const rowNodeId = rowCtrl.rowNode.id;
        delete this.entriesMap[rowNodeId];
        $437b23f6a393c3bf$export$83a881c8b5120679(this.entriesList, rowCtrl);
    }
    getEntries() {
        return this.entriesList;
    }
};
function $437b23f6a393c3bf$var$mapRowNodes(rowNodes) {
    if (!rowNodes) return;
    const res = {
        top: {},
        bottom: {},
        normal: {}
    };
    for (const rowNode of rowNodes){
        const id = rowNode.id;
        switch(rowNode.rowPinned){
            case "top":
                res.top[id] = rowNode;
                break;
            case "bottom":
                res.bottom[id] = rowNode;
                break;
            default:
                res.normal[id] = rowNode;
                break;
        }
    }
    return res;
}
function $437b23f6a393c3bf$var$isRowInMap(rowNode, rowIdsMap) {
    const id = rowNode.id;
    const floating = rowNode.rowPinned;
    switch(floating){
        case "top":
            return rowIdsMap.top[id] != null;
        case "bottom":
            return rowIdsMap.bottom[id] != null;
        default:
            return rowIdsMap.normal[id] != null;
    }
}
// packages/ag-grid-community/src/sort/rowNodeSorter.ts
var $437b23f6a393c3bf$var$RowNodeSorter = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowNodeSorter";
        this.accentedSort = false;
        this.primaryColumnsSortGroups = false;
        this.pivotActive = false;
    }
    postConstruct() {
        this.firstLeaf = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos) ? $437b23f6a393c3bf$export$600fb6a3864e66ca : $437b23f6a393c3bf$var$defaultGetLeaf;
        this.addManagedPropertyListeners([
            "accentedSort",
            "autoGroupColumnDef",
            "treeData"
        ], this.updateOptions.bind(this));
        const updatePivotModeState = this.updatePivotModeState.bind(this);
        this.addManagedEventListeners({
            columnPivotModeChanged: updatePivotModeState,
            columnPivotChanged: updatePivotModeState
        });
        this.updateOptions();
        updatePivotModeState();
    }
    updateOptions() {
        this.accentedSort = !!this.gos.get("accentedSort");
        this.primaryColumnsSortGroups = $437b23f6a393c3bf$export$96c51c2547b81aed(this.gos);
    }
    updatePivotModeState() {
        this.pivotActive = this.beans.colModel.isPivotActive();
    }
    doFullSortInPlace(rowNodes, sortOptions) {
        return rowNodes.sort((a, b)=>this.compareRowNodes(sortOptions, a, b));
    }
    compareRowNodes(sortOptions, nodeA, nodeB) {
        if (nodeA === nodeB) return 0;
        const accentedCompare = this.accentedSort;
        for(let i = 0, len = sortOptions.length; i < len; ++i){
            const sortOption = sortOptions[i];
            const isDescending = sortOption.sort === "desc";
            let valueA = this.getValue(nodeA, sortOption.column);
            let valueB = this.getValue(nodeB, sortOption.column);
            let comparatorResult;
            const providedComparator = this.getComparator(sortOption, nodeA);
            if (providedComparator) comparatorResult = providedComparator(valueA, valueB, nodeA, nodeB, isDescending);
            else {
                if (sortOption.type === "absolute") {
                    valueA = $437b23f6a393c3bf$var$absoluteValueTransformer(valueA);
                    valueB = $437b23f6a393c3bf$var$absoluteValueTransformer(valueB);
                }
                comparatorResult = $437b23f6a393c3bf$export$b0cca9f3c87c8df8(valueA, valueB, accentedCompare);
            }
            if (comparatorResult) return sortOption.sort === "asc" ? comparatorResult : -comparatorResult;
        }
        return 0;
    }
    /**
   * if user defines a comparator as a function then use that.
   * if user defines a dictionary of comparators, then use the one matching the sort type.
   * if no comparator provided, or no matching comparator found in dictionary, then return undefined.
   *
   * grid checks later if undefined is returned here and falls back to a default comparator corresponding to sort type on the coldef.
   * @private
   */ getComparator(sortOption, rowNode) {
        const colDef = sortOption.column.getColDef();
        const comparatorOnCol = this.getComparatorFromColDef(colDef, sortOption);
        if (comparatorOnCol) return comparatorOnCol;
        if (!colDef.showRowGroup) return;
        const groupLeafField = !rowNode.group && colDef.field;
        if (!groupLeafField) return;
        const primaryColumn = this.beans.colModel.getColDefCol(groupLeafField);
        if (!primaryColumn) return;
        return this.getComparatorFromColDef(primaryColumn.getColDef(), sortOption);
    }
    getComparatorFromColDef(colDef, sortOption) {
        const comparator = colDef.comparator;
        if (comparator == null) return;
        if (typeof comparator === "object") return comparator[$437b23f6a393c3bf$export$fb66185d3079b298(sortOption.type)];
        return comparator;
    }
    getValue(node, column) {
        const beans = this.beans;
        if (this.primaryColumnsSortGroups) {
            if (node.rowGroupColumn === column) return this.getGroupDataValue(node, column);
            if (node.group && column.getColDef().showRowGroup) return void 0;
        }
        const value = beans.valueSvc.getValue(column, node, false, "api");
        if (column.isAllowFormula()) {
            const formula = beans.formula;
            if (formula?.isFormula(value)) return formula.resolveValue(column, node);
        }
        return value;
    }
    getGroupDataValue(node, column) {
        if ($437b23f6a393c3bf$export$b911c5b172d227b4(this.gos, this.pivotActive)) {
            const leafChild = this.firstLeaf(node);
            return leafChild && this.beans.valueSvc.getValue(column, leafChild, false, "api");
        }
        const displayCol = this.beans.showRowGroupCols?.getShowRowGroupCol(column.getId());
        return displayCol ? node.groupData?.[displayCol.getId()] : void 0;
    }
};
var $437b23f6a393c3bf$var$defaultGetLeaf = (row)=>{
    if (row.data) return row;
    let childrenAfterGroup = row.childrenAfterGroup;
    while(childrenAfterGroup?.length){
        const node = childrenAfterGroup[0];
        if (node.data) return node;
        childrenAfterGroup = node.childrenAfterGroup;
    }
};
var $437b23f6a393c3bf$var$absoluteValueTransformer = (value)=>{
    if (!value) return value;
    const numberValue = Number(value);
    return isNaN(numberValue) ? value : Math.abs(numberValue);
};
// packages/ag-grid-community/src/sort/sortApi.ts
function $437b23f6a393c3bf$var$onSortChanged(beans) {
    beans.sortSvc?.onSortChanged("api");
}
// packages/ag-grid-community/src/sort/sortIndicatorComp.ts
var $437b23f6a393c3bf$var$makeIconParams = (dataRefSuffix, classSuffix)=>({
        tag: "span",
        ref: `eSort${dataRefSuffix}`,
        cls: `ag-sort-indicator-icon ag-sort-${classSuffix} ag-hidden`,
        attrs: {
            "aria-hidden": "true"
        }
    });
var $437b23f6a393c3bf$var$SortIndicatorElement = {
    tag: "span",
    cls: "ag-sort-indicator-container",
    children: [
        $437b23f6a393c3bf$var$makeIconParams("Order", "order"),
        $437b23f6a393c3bf$var$makeIconParams("Asc", "ascending-icon"),
        $437b23f6a393c3bf$var$makeIconParams("Desc", "descending-icon"),
        $437b23f6a393c3bf$var$makeIconParams("Mixed", "mixed-icon"),
        $437b23f6a393c3bf$var$makeIconParams("AbsoluteAsc", "absolute-ascending-icon"),
        $437b23f6a393c3bf$var$makeIconParams("AbsoluteDesc", "absolute-descending-icon"),
        $437b23f6a393c3bf$var$makeIconParams("None", "none-icon")
    ]
};
var $437b23f6a393c3bf$var$SortIndicatorComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(skipTemplate){
        super();
        // Elements might by undefined when the user provides a custom template
        this.eSortOrder = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAsc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortDesc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortMixed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortNone = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAbsoluteAsc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAbsoluteDesc = $437b23f6a393c3bf$export$6c811454646ed8be;
        if (!skipTemplate) this.setTemplate($437b23f6a393c3bf$var$SortIndicatorElement);
    }
    attachCustomElements(eSortOrder, eSortAsc, eSortDesc, eSortMixed, eSortNone, eSortAbsoluteAsc, eSortAbsoluteDesc) {
        this.eSortOrder = eSortOrder;
        this.eSortAsc = eSortAsc;
        this.eSortDesc = eSortDesc;
        this.eSortMixed = eSortMixed;
        this.eSortNone = eSortNone;
        this.eSortAbsoluteAsc = eSortAbsoluteAsc;
        this.eSortAbsoluteDesc = eSortAbsoluteDesc;
    }
    setupSort(column, suppressOrder = false) {
        this.column = column;
        this.suppressOrder = suppressOrder;
        this.setupMultiSortIndicator();
        if (!column.isSortable() && !column.getColDef().showRowGroup) return;
        this.addInIcon("sortAscending", this.eSortAsc, column);
        this.addInIcon("sortDescending", this.eSortDesc, column);
        this.addInIcon("sortUnSort", this.eSortNone, column);
        this.addInIcon("sortAbsoluteAscending", this.eSortAbsoluteAsc, column);
        this.addInIcon("sortAbsoluteDescending", this.eSortAbsoluteDesc, column);
        const updateIcons = this.updateIcons.bind(this);
        const sortUpdated = this.onSortChanged.bind(this);
        this.addManagedPropertyListener("unSortIcon", updateIcons);
        this.addManagedEventListeners({
            newColumnsLoaded: updateIcons,
            // Watch global events, as row group columns can effect their display column.
            sortChanged: sortUpdated,
            // when grouping changes so can sort indexes and icons
            columnRowGroupChanged: sortUpdated
        });
        this.onSortChanged();
    }
    addInIcon(iconName, eParent, column) {
        if (eParent == null) return;
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    onSortChanged() {
        this.updateIcons();
        if (!this.suppressOrder) this.updateSortOrder();
    }
    updateIcons() {
        const { eSortAsc: eSortAsc, eSortDesc: eSortDesc, eSortAbsoluteAsc: eSortAbsoluteAsc, eSortAbsoluteDesc: eSortAbsoluteDesc, eSortNone: eSortNone, column: column, gos: gos, beans: beans } = this;
        const sortDef = beans.sortSvc.getDisplaySortForColumn(column);
        const type = $437b23f6a393c3bf$export$fb66185d3079b298(sortDef?.type);
        const direction = $437b23f6a393c3bf$export$b26b2467cef719c1(sortDef?.direction);
        const allowedSortTypes = column.getAvailableSortTypes();
        const isDefaultSortAllowed = allowedSortTypes.has("default");
        const isAbsoluteSortAllowed = allowedSortTypes.has("absolute");
        const isAbsoluteSort = type === "absolute";
        const isDefaultSort = type === "default";
        const isAscending = direction === "asc";
        const isDescending = direction === "desc";
        if (eSortAsc) $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortAsc, isAscending && isDefaultSort && isDefaultSortAllowed, {
            skipAriaHidden: true
        });
        if (eSortDesc) $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortDesc, isDescending && isDefaultSort && isDefaultSortAllowed, {
            skipAriaHidden: true
        });
        if (eSortNone) {
            const alwaysHideNoSort = !column.getColDef().unSortIcon && !gos.get("unSortIcon");
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortNone, !alwaysHideNoSort && !direction, {
                skipAriaHidden: true
            });
        }
        if (eSortAbsoluteAsc) $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortAbsoluteAsc, isAscending && isAbsoluteSort && isAbsoluteSortAllowed, {
            skipAriaHidden: true
        });
        if (eSortAbsoluteDesc) $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortAbsoluteDesc, isDescending && isAbsoluteSort && isAbsoluteSortAllowed, {
            skipAriaHidden: true
        });
    }
    setupMultiSortIndicator() {
        const { eSortMixed: eSortMixed, column: column, gos: gos } = this;
        this.addInIcon("sortUnSort", eSortMixed, column);
        const isColumnShowingRowGroup = column.getColDef().showRowGroup;
        const areGroupsCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        if (areGroupsCoupled && isColumnShowingRowGroup) {
            this.addManagedEventListeners({
                // Watch global events, as row group columns can effect their display column.
                sortChanged: this.updateMultiSortIndicator.bind(this),
                // when grouping changes so can sort indexes and icons
                columnRowGroupChanged: this.updateMultiSortIndicator.bind(this)
            });
            this.updateMultiSortIndicator();
        }
    }
    updateMultiSortIndicator() {
        const { eSortMixed: eSortMixed, beans: beans, column: column } = this;
        if (eSortMixed) {
            const isMixedSort = beans.sortSvc.getDisplaySortForColumn(column)?.direction === "mixed";
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortMixed, isMixedSort, {
                skipAriaHidden: true
            });
        }
    }
    // we listen here for global sort events, NOT column sort events, as we want to do this
    // when sorting has been set on all column (if we listened just for our col (where we
    // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
    updateSortOrder() {
        const { eSortOrder: eSortOrder, column: column, beans: { sortSvc: sortSvc } } = this;
        if (!eSortOrder) return;
        const allColumnsWithSorting = sortSvc.getColumnsWithSortingOrdered();
        const indexThisCol = sortSvc.getDisplaySortIndexForColumn(column) ?? -1;
        const moreThanOneColSorting = allColumnsWithSorting.some((col)=>sortSvc.getDisplaySortIndexForColumn(col) ?? false);
        const showIndex = indexThisCol >= 0 && moreThanOneColSorting;
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortOrder, showIndex, {
            skipAriaHidden: true
        });
        if (indexThisCol >= 0) eSortOrder.textContent = (indexThisCol + 1).toString();
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eSortOrder);
    }
};
var $437b23f6a393c3bf$var$SortIndicatorSelector = {
    selector: "AG-SORT-INDICATOR",
    component: $437b23f6a393c3bf$var$SortIndicatorComp
};
// packages/ag-grid-community/src/sort/sortService.ts
var $437b23f6a393c3bf$var$SortService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "sortSvc";
    }
    progressSort(column, multiSort, source) {
        const nextDirection = this.getNextSortDirection(column);
        this.setSortForColumn(column, nextDirection, multiSort, source);
    }
    progressSortFromEvent(column, event) {
        const sortUsingCtrl = this.gos.get("multiSortKey") === "ctrl";
        const multiSort = sortUsingCtrl ? event.ctrlKey || event.metaKey : event.shiftKey;
        this.progressSort(column, multiSort, "uiColumnSorted");
    }
    setSortForColumn(column, sortDef, multiSort, source) {
        const { gos: gos, showRowGroupCols: showRowGroupCols } = this.beans;
        const isColumnsSortingCoupledToGroup = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        let columnsToUpdate = [
            column
        ];
        if (isColumnsSortingCoupledToGroup) {
            if (column.getColDef().showRowGroup) {
                const rowGroupColumns = showRowGroupCols?.getSourceColumnsForGroupColumn?.(column);
                const sortableRowGroupColumns = rowGroupColumns?.filter((col)=>col.isSortable());
                if (sortableRowGroupColumns) columnsToUpdate = [
                    column,
                    ...sortableRowGroupColumns
                ];
            }
        }
        for (const col of columnsToUpdate)this.setColSort(col, sortDef, source);
        const doingMultiSort = (multiSort || gos.get("alwaysMultiSort")) && !gos.get("suppressMultiSort");
        const updatedColumns = [];
        if (!doingMultiSort) {
            const clearedColumns = this.clearSortBarTheseColumns(columnsToUpdate, source);
            updatedColumns.push(...clearedColumns);
        }
        this.updateSortIndex(column);
        updatedColumns.push(...columnsToUpdate);
        this.dispatchSortChangedEvents(source, updatedColumns);
    }
    updateSortIndex(lastColToChange) {
        const { gos: gos, colModel: colModel, showRowGroupCols: showRowGroupCols } = this.beans;
        const isCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        const groupParent = showRowGroupCols?.getShowRowGroupCol(lastColToChange.getId());
        const lastSortIndexCol = isCoupled ? groupParent || lastColToChange : lastColToChange;
        const allSortedCols = this.getColumnsWithSortingOrdered();
        colModel.forAllCols((col)=>this.setColSortIndex(col, null));
        const allSortedColsWithoutChangesOrGroups = allSortedCols.filter((col)=>{
            if (isCoupled && col.getColDef().showRowGroup) return false;
            return col !== lastSortIndexCol;
        });
        const sortedColsWithIndices = lastSortIndexCol.getSortDef() ? [
            ...allSortedColsWithoutChangesOrGroups,
            lastSortIndexCol
        ] : allSortedColsWithoutChangesOrGroups;
        sortedColsWithIndices.forEach((col, idx)=>this.setColSortIndex(col, idx));
    }
    // gets called by API, so if data changes, use can call this, which will end up
    // working out the sort order again of the rows.
    onSortChanged(source, columns) {
        this.dispatchSortChangedEvents(source, columns);
    }
    isSortActive() {
        let isSorting = false;
        this.beans.colModel.forAllCols((col)=>{
            if (col.getSortDef()) {
                isSorting = true;
                return true;
            }
        });
        return isSorting;
    }
    dispatchSortChangedEvents(source, columns) {
        const event = {
            type: "sortChanged",
            source: source
        };
        if (columns) event.columns = columns;
        this.eventSvc.dispatchEvent(event);
    }
    clearSortBarTheseColumns(columnsToSkip, source) {
        const clearedColumns = [];
        this.beans.colModel.forAllCols((columnToClear)=>{
            if (!columnsToSkip.includes(columnToClear)) {
                if (columnToClear.getSortDef()) clearedColumns.push(columnToClear);
                this.setColSort(columnToClear, void 0, source);
            }
        });
        return clearedColumns;
    }
    getNextSortDirection(column) {
        const sortingOrder = column.getSortingOrder();
        const currentSortDef = column.getSortDef();
        const currentIndex = sortingOrder.findIndex((e)=>$437b23f6a393c3bf$export$1d4824b7d3b8a5c8(e, currentSortDef));
        let nextIndex = currentIndex + 1;
        if (nextIndex >= sortingOrder.length) nextIndex = 0;
        return $437b23f6a393c3bf$export$2a92f4fc1f337c5a(sortingOrder[nextIndex]);
    }
    /**
   * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
   */ getIndexedSortMap() {
        const { gos: gos, colModel: colModel, showRowGroupCols: showRowGroupCols, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        let allSortedCols = [];
        colModel.forAllCols((col)=>{
            if (col.getSortDef()) allSortedCols.push(col);
        });
        if (colModel.isPivotMode()) {
            const isSortingLinked = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
            allSortedCols = allSortedCols.filter((col)=>{
                const isAggregated = !!col.getAggFunc();
                const isSecondary = !col.isPrimary();
                const isGroup = isSortingLinked ? showRowGroupCols?.getShowRowGroupCol(col.getId()) : col.getColDef().showRowGroup;
                return isAggregated || isSecondary || isGroup;
            });
        }
        const sortedRowGroupCols = rowGroupColsSvc?.columns.filter((col)=>!!col.getSortDef()) ?? [];
        const allColsIndexes = {};
        allSortedCols.forEach((col, index)=>allColsIndexes[col.getId()] = index);
        allSortedCols.sort((a, b)=>{
            const iA = a.getSortIndex();
            const iB = b.getSortIndex();
            if (iA != null && iB != null) return iA - iB;
            else if (iA == null && iB == null) {
                const posA = allColsIndexes[a.getId()];
                const posB = allColsIndexes[b.getId()];
                return posA > posB ? 1 : -1;
            } else if (iB == null) return -1;
            else return 1;
        });
        const isSortLinked = $437b23f6a393c3bf$export$96c51c2547b81aed(gos) && !!sortedRowGroupCols.length;
        if (isSortLinked) allSortedCols = [
            ...new Set(// if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
            allSortedCols.map((col)=>showRowGroupCols?.getShowRowGroupCol(col.getId()) ?? col))
        ];
        const indexMap = /* @__PURE__ */ new Map();
        allSortedCols.forEach((col, idx)=>indexMap.set(col, idx));
        if (isSortLinked) for (const col of sortedRowGroupCols){
            const groupDisplayCol = showRowGroupCols.getShowRowGroupCol(col.getId());
            indexMap.set(col, indexMap.get(groupDisplayCol));
        }
        return indexMap;
    }
    getColumnsWithSortingOrdered() {
        return [
            ...this.getIndexedSortMap().entries()
        ].sort(([, idx1], [, idx2])=>idx1 - idx2).map(([col])=>col);
    }
    /**
   * Util method to collect sort items by going through sorted columns once.
   */ collectSortItems(asSortModel = false) {
        const sortItems = [];
        const columnsWithSortingOrdered = this.getColumnsWithSortingOrdered();
        for (const column of columnsWithSortingOrdered){
            const sort = column.getSortDef()?.direction;
            if (!sort) continue;
            const type = $437b23f6a393c3bf$export$fb66185d3079b298(column.getSortDef()?.type);
            const sortItem = {
                sort: sort,
                type: type
            };
            if (asSortModel) sortItem.colId = column.getId();
            else sortItem.column = column;
            sortItems.push(sortItem);
        }
        return sortItems;
    }
    // used by server side row models, to send sort to server
    getSortModel() {
        return this.collectSortItems(true);
    }
    getSortOptions() {
        return this.collectSortItems();
    }
    canColumnDisplayMixedSort(column) {
        const isColumnSortCouplingActive = $437b23f6a393c3bf$export$96c51c2547b81aed(this.gos);
        const isGroupDisplayColumn = !!column.getColDef().showRowGroup;
        return isColumnSortCouplingActive && isGroupDisplayColumn;
    }
    getDisplaySortForColumn(column) {
        const linkedColumns = this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(column);
        if (!this.canColumnDisplayMixedSort(column) || !linkedColumns?.length) return column.getSortDef();
        const columnHasUniqueData = column.getColDef().field != null || !!column.getColDef().valueGetter;
        const sortableColumns = columnHasUniqueData ? [
            column,
            ...linkedColumns
        ] : linkedColumns;
        const firstSort = sortableColumns[0].getSortDef();
        const allMatch = sortableColumns.every((col)=>$437b23f6a393c3bf$export$1d4824b7d3b8a5c8(col.getSortDef(), firstSort));
        if (!allMatch) return {
            type: $437b23f6a393c3bf$export$fb66185d3079b298(column.getSortDef()?.type),
            direction: "mixed"
        };
        return firstSort;
    }
    getDisplaySortIndexForColumn(column) {
        return this.getIndexedSortMap().get(column);
    }
    setupHeader(comp, column) {
        const onSortingChanged = ()=>{
            const { type: type, direction: direction } = $437b23f6a393c3bf$export$2a92f4fc1f337c5a(column.getSortDef());
            comp.toggleCss("ag-header-cell-sorted-asc", direction === "asc");
            comp.toggleCss("ag-header-cell-sorted-desc", direction === "desc");
            comp.toggleCss("ag-header-cell-sorted-abs-asc", type === "absolute" && direction === "asc");
            comp.toggleCss("ag-header-cell-sorted-abs-desc", type === "absolute" && direction === "desc");
            comp.toggleCss("ag-header-cell-sorted-none", !direction);
            if (column.getColDef().showRowGroup) {
                const sourceColumns = this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(column);
                const sortDirectionsMatch = sourceColumns?.every((sourceCol)=>direction == sourceCol.getSortDef()?.direction);
                const isMultiSorting = !sortDirectionsMatch;
                comp.toggleCss("ag-header-cell-sorted-mixed", isMultiSorting);
            }
        };
        comp.addManagedEventListeners({
            sortChanged: onSortingChanged,
            columnRowGroupChanged: onSortingChanged
        });
    }
    initCol(column) {
        const { sortIndex: sortIndex, initialSortIndex: initialSortIndex } = column.colDef;
        const sortDef = $437b23f6a393c3bf$export$f24a224f07655b28(column.colDef);
        if (sortDef) column.setSortDef(sortDef, true);
        if (sortIndex !== void 0) {
            if (sortIndex !== null) column.sortIndex = sortIndex;
        } else if (initialSortIndex !== null) column.sortIndex = initialSortIndex;
    }
    /**
   * Update a column's sort state from a sort definition.
   * If `sortDefOrDirection` is `undefined`, the call is a no-op (no change).
   */ updateColSort(column, sortDefOrDirection, source) {
        if (sortDefOrDirection === void 0) return;
        this.setColSort(column, $437b23f6a393c3bf$export$2a92f4fc1f337c5a(sortDefOrDirection), source);
    }
    setColSort(column, sort, source) {
        if (!$437b23f6a393c3bf$export$1d4824b7d3b8a5c8(column.getSortDef(), sort)) {
            column.setSortDef($437b23f6a393c3bf$export$2a92f4fc1f337c5a(sort), sort === void 0);
            column.dispatchColEvent("sortChanged", source);
        }
        column.dispatchStateUpdatedEvent("sort");
    }
    setColSortIndex(column, sortOrder) {
        column.sortIndex = sortOrder;
        column.dispatchStateUpdatedEvent("sortIndex");
    }
    createSortIndicator(skipTemplate) {
        return new $437b23f6a393c3bf$var$SortIndicatorComp(skipTemplate);
    }
    getSortIndicatorSelector() {
        return $437b23f6a393c3bf$var$SortIndicatorSelector;
    }
};
// packages/ag-grid-community/src/sort/sortModule.ts
var $437b23f6a393c3bf$export$1a6625c5691649e8 = {
    moduleName: "Sort",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$SortService,
        $437b23f6a393c3bf$var$RowNodeSorter
    ],
    apiFunctions: {
        onSortChanged: $437b23f6a393c3bf$var$onSortChanged
    },
    userComponents: {
        agSortIndicator: $437b23f6a393c3bf$var$SortIndicatorComp
    },
    icons: {
        // show on column header when column is sorted ascending
        sortAscending: "asc",
        // show on column header when column is sorted descending
        sortDescending: "desc",
        // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
        sortUnSort: "none",
        // show on column header when column is sorted absolute ascending
        sortAbsoluteAscending: "aasc",
        // show on column header when column is sorted absolute descending
        sortAbsoluteDescending: "adesc"
    }
};
// packages/ag-grid-community/src/syncService.ts
var $437b23f6a393c3bf$var$SyncService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "syncSvc";
        this.waitingForColumns = false;
    }
    postConstruct() {
        this.addManagedPropertyListener("columnDefs", (event)=>this.setColumnDefs(event));
    }
    start() {
        this.beans.ctrlsSvc.whenReady(this, ()=>{
            const columnDefs = this.gos.get("columnDefs");
            if (columnDefs) this.setColumnsAndData(columnDefs);
            else this.waitingForColumns = true;
            this.gridReady();
        });
    }
    setColumnsAndData(columnDefs) {
        const { colModel: colModel, rowModel: rowModel } = this.beans;
        colModel.setColumnDefs(columnDefs ?? [], "gridInitializing");
        rowModel.start();
    }
    gridReady() {
        const { eventSvc: eventSvc, gos: gos } = this;
        eventSvc.dispatchEvent({
            type: "gridReady"
        });
        $437b23f6a393c3bf$var$_logIfDebug(gos, `initialised successfully, enterprise = ${gos.isModuleRegistered("EnterpriseCore")}`);
    }
    setColumnDefs(event) {
        const columnDefs = this.gos.get("columnDefs");
        if (!columnDefs) return;
        if (this.waitingForColumns) {
            this.waitingForColumns = false;
            this.setColumnsAndData(columnDefs);
            return;
        }
        this.beans.colModel.setColumnDefs(columnDefs, $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source));
    }
};
// packages/ag-grid-community/src/valueService/cellApi.ts
function $437b23f6a393c3bf$var$expireValueCache(beans) {
    beans.valueCache?.expire();
}
function $437b23f6a393c3bf$var$getCellValue(beans, params) {
    const { colKey: colKey, rowNode: rowNode, useFormatter: useFormatter } = params;
    const column = beans.colModel.getColDefCol(colKey) ?? beans.colModel.getCol(colKey);
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(column)) return null;
    const result = beans.valueSvc.getValueForDisplay({
        column: column,
        node: rowNode,
        includeValueFormatted: useFormatter
    });
    if (useFormatter) return result.valueFormatted ?? $437b23f6a393c3bf$export$a16cfb6652fe466f(result.value);
    return result.value;
}
// packages/ag-grid-community/src/valueService/changeDetectionService.ts
var $437b23f6a393c3bf$var$SOURCE_PASTE = "paste";
var $437b23f6a393c3bf$var$ChangeDetectionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "changeDetectionSvc";
        this.clientSideRowModel = null;
    }
    postConstruct() {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) this.clientSideRowModel = rowModel;
        this.addManagedEventListeners({
            cellValueChanged: this.onCellValueChanged.bind(this)
        });
    }
    onCellValueChanged(event) {
        const { gos: gos, rowRenderer: rowRenderer } = this.beans;
        if (event.source === $437b23f6a393c3bf$var$SOURCE_PASTE || gos.get("suppressChangeDetection")) return;
        const rowNode = event.node;
        const nodesToRefresh = [
            rowNode
        ];
        const clientSideRowModel = this.clientSideRowModel;
        const rootNode = clientSideRowModel?.rootNode;
        if (rootNode && !rowNode.isRowPinned()) {
            const onlyChangedColumns = gos.get("aggregateOnlyChangedColumns");
            const changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(onlyChangedColumns, rootNode);
            changedPath.addParentNode(rowNode.parent, [
                event.column
            ]);
            clientSideRowModel.doAggregate(changedPath);
            changedPath.forEachChangedNodeDepthFirst((rowNode2)=>{
                nodesToRefresh.push(rowNode2);
                if (rowNode2.sibling) nodesToRefresh.push(rowNode2.sibling);
            });
        }
        rowRenderer.refreshCells({
            rowNodes: nodesToRefresh
        });
    }
};
// packages/ag-grid-community/src/valueService/expressionService.ts
var $437b23f6a393c3bf$var$ExpressionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "expressionSvc";
        this.cache = {};
    }
    evaluate(expression, params) {
        if (typeof expression === "string") return this.evaluateExpression(expression, params);
        else $437b23f6a393c3bf$export$a20c7248650823a9(15, {
            expression: expression
        });
    }
    evaluateExpression(expression, params) {
        try {
            const javaScriptFunction = this.createExpressionFunction(expression);
            const result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.getValue, params.column, params.columnGroup);
            return result;
        } catch (e) {
            $437b23f6a393c3bf$export$a20c7248650823a9(16, {
                expression: expression,
                params: params,
                e: e
            });
            return null;
        }
    }
    createExpressionFunction(expression) {
        const expressionToFunctionCache = this.cache;
        if (expressionToFunctionCache[expression]) return expressionToFunctionCache[expression];
        const functionBody = this.createFunctionBody(expression);
        const theFunction = new Function("x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, getValue, column, columnGroup", functionBody);
        expressionToFunctionCache[expression] = theFunction;
        return theFunction;
    }
    createFunctionBody(expression) {
        if (expression.includes("return")) return expression;
        else return "return " + expression + ";";
    }
};
// packages/ag-grid-community/src/valueService/valueCache.ts
var $437b23f6a393c3bf$var$ValueCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "valueCache";
        this.cacheVersion = 0;
    }
    postConstruct() {
        const gos = this.gos;
        this.active = gos.get("valueCache");
        this.neverExpires = gos.get("valueCacheNeverExpires");
    }
    onDataChanged() {
        if (this.neverExpires) return;
        this.expire();
    }
    expire() {
        this.cacheVersion++;
    }
    setValue(rowNode, colId, value) {
        if (this.active) {
            const cacheVersion = this.cacheVersion;
            if (rowNode.__cacheVersion !== cacheVersion) {
                rowNode.__cacheVersion = cacheVersion;
                rowNode.__cacheData = {};
            }
            rowNode.__cacheData[colId] = value;
        }
    }
    getValue(rowNode, colId) {
        if (!this.active || rowNode.__cacheVersion !== this.cacheVersion) return void 0;
        return rowNode.__cacheData[colId];
    }
};
// packages/ag-grid-community/src/valueService/valueModule.ts
var $437b23f6a393c3bf$export$3110fedd6be63d8e = {
    moduleName: "ValueCache",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ValueCache
    ],
    apiFunctions: {
        expireValueCache: $437b23f6a393c3bf$var$expireValueCache
    }
};
var $437b23f6a393c3bf$var$ExpressionModule = {
    moduleName: "Expression",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ExpressionService
    ]
};
var $437b23f6a393c3bf$var$ChangeDetectionModule = {
    moduleName: "ChangeDetection",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ChangeDetectionService
    ]
};
var $437b23f6a393c3bf$export$d7a9d7f5c41fb970 = {
    moduleName: "CellApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        getCellValue: $437b23f6a393c3bf$var$getCellValue
    }
};
// packages/ag-grid-community/src/valueService/valueService.ts
var $437b23f6a393c3bf$var$ValueService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "valueSvc";
        this.hasEditSvc = false;
        this.initialised = false;
        this.isSsrm = false;
    }
    wireBeans(beans) {
        this.expressionSvc = beans.expressionSvc;
        this.colModel = beans.colModel;
        this.valueCache = beans.valueCache;
        this.dataTypeSvc = beans.dataTypeSvc;
        this.editSvc = beans.editSvc;
        this.hasEditSvc = !!beans.editSvc;
        this.formulaDataSvc = beans.formulaDataSvc;
    }
    postConstruct() {
        if (!this.initialised) this.init();
    }
    init() {
        const { gos: gos, valueCache: valueCache } = this;
        this.executeValueGetter = valueCache ? this.executeValueGetterWithValueCache.bind(this) : this.executeValueGetterWithoutValueCache.bind(this);
        this.isSsrm = $437b23f6a393c3bf$export$cf1bac0013650216(gos);
        this.cellExpressions = gos.get("enableCellExpressions");
        this.isTreeData = gos.get("treeData");
        this.initialised = true;
        const listener = (event)=>this.callColumnCellValueChangedHandler(event);
        this.eventSvc.addListener("cellValueChanged", listener, true);
        this.addDestroyFunc(()=>this.eventSvc.removeListener("cellValueChanged", listener, true));
        this.addManagedPropertyListener("treeData", (propChange)=>this.isTreeData = propChange.currentValue);
    }
    /**
   * Use this function to get a displayable cell value.
   * The values from this function are not used for sorting, filtering, or aggregation purposes.
   * Handles: groupHideOpenParents, showOpenedGroup and groupSuppressBlankHeader behaviours
   */ getValueForDisplay(params) {
        const { column: column, node: node, includeValueFormatted: includeValueFormatted, useRawFormula: useRawFormula, exporting: exporting, source: source = "ui" } = params;
        const { showRowGroupColValueSvc: showRowGroupColValueSvc } = this.beans;
        const isFullWidthGroup = !column && node.group;
        const isGroupCol = column?.colDef.showRowGroup;
        const processTreeDataAsGroup = !this.isTreeData || node.footer;
        if (showRowGroupColValueSvc && processTreeDataAsGroup && (isFullWidthGroup || isGroupCol)) {
            const groupValue = showRowGroupColValueSvc.getGroupValue(node, column);
            if (groupValue == null) return {
                value: null,
                valueFormatted: null
            };
            if (!includeValueFormatted) return {
                value: groupValue.value,
                valueFormatted: null
            };
            const valueFormatted = showRowGroupColValueSvc.formatAndPrefixGroupColValue(groupValue, column, exporting);
            return {
                value: groupValue.value,
                valueFormatted: valueFormatted
            };
        }
        if (!column) return {
            value: node.key,
            valueFormatted: null
        };
        const isPivotLeaf = node.leafGroup && this.colModel.isPivotMode();
        const isOpenedGroup = node.group && node.expanded && !node.footer && !isPivotLeaf;
        const groupShowsAggData = this.gos.get("groupSuppressBlankHeader") || !node.sibling;
        const ignoreAggData = isOpenedGroup && !groupShowsAggData;
        let value = this.getValue(column, node, ignoreAggData, source);
        let valueToFormat = value;
        const { formula: formula } = this.beans;
        const format = includeValueFormatted && !(exporting && column.colDef.useValueFormatterForExport === false);
        if (column.isAllowFormula() && formula?.isFormula(value)) {
            if (useRawFormula) {
                value = formula.normaliseFormula(value, true);
                valueToFormat = formula.resolveValue(column, node);
            } else {
                value = formula.resolveValue(column, node);
                valueToFormat = value;
            }
        }
        return {
            value: value,
            valueFormatted: format ? this.formatValue(column, node, valueToFormat) : null
        };
    }
    getValue(column, rowNode, ignoreAggData = false, source = "ui") {
        if (!this.initialised) this.init();
        if (!rowNode) return;
        if (this.hasEditSvc && source === "ui") {
            const editSvc = this.editSvc;
            if (editSvc.isEditing()) {
                const newValue = editSvc.getCellDataValue({
                    rowNode: rowNode,
                    column: column
                }, true);
                if (newValue !== void 0) return newValue;
            }
        }
        const colDef = column.getColDef();
        const rowGroupColId = colDef.showRowGroup;
        if (typeof rowGroupColId === "string") {
            const colRowGroupIndex = this.beans.rowGroupColsSvc?.getColumnIndex(rowGroupColId) ?? -1;
            if (colRowGroupIndex > rowNode.level) return null;
        }
        let result = this.resolveValue(column, rowNode, ignoreAggData);
        if (this.cellExpressions && $437b23f6a393c3bf$export$8e19bf64bae2d78a(result)) {
            const cellValueGetter = result.substring(1);
            result = this.executeValueGetter(cellValueGetter, rowNode.data, column, rowNode);
        }
        return result;
    }
    getFormulaFromDataSource(column, rowNode) {
        const dataSource = this.formulaDataSvc;
        if (!dataSource?.hasDataSource() || !column.isAllowFormula()) return void 0;
        const formula = dataSource.getFormula({
            column: column,
            rowNode: rowNode
        });
        return $437b23f6a393c3bf$export$8e19bf64bae2d78a(formula) ? formula : void 0;
    }
    resolveValue(column, rowNode, ignoreAggData) {
        const colDef = column.getColDef();
        const colId = column.getColId();
        const isTreeData = this.isTreeData;
        const dataSourceFormula = this.getFormulaFromDataSource(column, rowNode);
        if (dataSourceFormula !== void 0) return dataSourceFormula;
        const aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== void 0;
        if (isTreeData && aggDataExists) return rowNode.aggData[colId];
        const data = rowNode.data;
        const field = colDef.field;
        if (isTreeData && colDef.valueGetter) return this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        if (isTreeData && field && data) return $437b23f6a393c3bf$var$_getValueUsingField(data, field, column.isFieldContainsDots());
        const groupData = rowNode.groupData;
        const groupDataExists = groupData && colId in groupData;
        if (groupDataExists) return rowNode.groupData[colId];
        if (aggDataExists) return rowNode.aggData[colId];
        const rowGroupColId = colDef.showRowGroup;
        const allowUserValuesForCell = typeof rowGroupColId !== "string" || !rowNode.group;
        const ignoreSsrmAggData = this.isSsrm && ignoreAggData && !!colDef.aggFunc;
        const ssrmFooterGroupCol = this.isSsrm && rowNode.footer && rowNode.field && (rowGroupColId === true || rowGroupColId === rowNode.field);
        if (colDef.valueGetter && !ignoreSsrmAggData) {
            if (!allowUserValuesForCell) return void 0;
            return this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        }
        if (ssrmFooterGroupCol) return $437b23f6a393c3bf$var$_getValueUsingField(data, rowNode.field, column.isFieldContainsDots());
        if (field && data && !ignoreSsrmAggData) {
            if (!allowUserValuesForCell) return void 0;
            return $437b23f6a393c3bf$var$_getValueUsingField(data, field, column.isFieldContainsDots());
        }
        return void 0;
    }
    parseValue(column, rowNode, newValue, oldValue) {
        const colDef = column.getColDef();
        if (colDef.allowFormula && this.beans.formula?.isFormula(newValue)) return newValue;
        const valueParser = colDef.valueParser;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueParser)) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                node: rowNode,
                data: rowNode?.data,
                oldValue: oldValue,
                newValue: newValue,
                colDef: colDef,
                column: column
            });
            if (typeof valueParser === "function") return valueParser(params);
            return this.expressionSvc?.evaluate(valueParser, params);
        }
        return newValue;
    }
    getDeleteValue(column, rowNode) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(column.getColDef().valueParser)) return this.parseValue(column, rowNode, "", this.getValueForDisplay({
            column: column,
            node: rowNode
        }).value) ?? null;
        return null;
    }
    formatValue(column, node, value, suppliedFormatter, useFormatterFromColumn = true) {
        const { expressionSvc: expressionSvc } = this.beans;
        let result = null;
        let formatter;
        const colDef = column.getColDef();
        if (suppliedFormatter) formatter = suppliedFormatter;
        else if (useFormatterFromColumn) formatter = colDef.valueFormatter;
        if (formatter) {
            const data = node ? node.data : null;
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                node: node,
                data: data,
                colDef: colDef,
                column: column
            });
            if (typeof formatter === "function") result = formatter(params);
            else result = expressionSvc ? expressionSvc.evaluate(formatter, params) : null;
        } else if (colDef.refData) return colDef.refData[value] || "";
        if (result == null && Array.isArray(value)) result = value.join(", ");
        return result;
    }
    /**
   * Sets the value of a GridCell
   * @param rowNode The `RowNode` to be updated
   * @param colKey The `Column` to be updated
   * @param newValue The new value to be set
   * @param eventSource The event source
   * @returns `True` if the value has been updated, otherwise`False`.
   */ setValue(rowNode, colKey, newValue, eventSource) {
        const column = this.colModel.getColDefCol(colKey);
        if (!rowNode || !column) return false;
        this.ensureRowData(rowNode);
        const colDef = column.getColDef();
        if (!this.isSetValueSupported({
            column: column,
            newValue: newValue,
            colDef: colDef
        })) return false;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            oldValue: this.getValue(column, rowNode, void 0, eventSource),
            newValue: newValue,
            colDef: colDef,
            column: column
        });
        params.newValue = newValue;
        const externalFormulaResult = this.handleExternalFormulaChange({
            column: column,
            eventSource: eventSource,
            newValue: newValue,
            setterParams: params,
            rowNode: rowNode
        });
        if (externalFormulaResult !== null) return externalFormulaResult;
        let valueWasDifferent = this.computeValueChange({
            column: column,
            newValue: newValue,
            params: params,
            rowData: rowNode.data,
            valueSetter: colDef.valueSetter,
            field: colDef.field
        });
        if (valueWasDifferent === void 0) valueWasDifferent = true;
        if (!valueWasDifferent) return false;
        return this.finishValueChange(rowNode, column, params, eventSource);
    }
    finishValueChange(rowNode, column, params, eventSource) {
        rowNode.resetQuickFilterAggregateText();
        this.valueCache?.onDataChanged();
        const savedValue = this.getValue(column, rowNode);
        this.dispatchCellValueChangedEvent(rowNode, params, savedValue, eventSource);
        if (rowNode.pinnedSibling) this.dispatchCellValueChangedEvent(rowNode.pinnedSibling, params, savedValue, eventSource);
        return true;
    }
    ensureRowData(rowNode) {
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowNode.data)) rowNode.data = {};
    }
    isSetValueSupported(params) {
        const { column: column, newValue: newValue, colDef: colDef } = params;
        const { field: field, valueSetter: valueSetter } = colDef;
        const formulaSvc = this.beans.formula;
        const isFormulaValue = column.isAllowFormula() && formulaSvc?.isFormula(newValue);
        const hasExternalFormulaData = !!this.formulaDataSvc?.hasDataSource();
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(field) && $437b23f6a393c3bf$export$672d9e47bc342bac(valueSetter) && !(hasExternalFormulaData && isFormulaValue)) {
            $437b23f6a393c3bf$export$545083624300f13d(17);
            return false;
        }
        if (this.dataTypeSvc && !this.dataTypeSvc.checkType(column, newValue)) {
            $437b23f6a393c3bf$export$545083624300f13d(135);
            return false;
        }
        return true;
    }
    handleExternalFormulaChange(args) {
        const { column: column, rowNode: rowNode, newValue: newValue, eventSource: eventSource, setterParams: setterParams } = args;
        const formulaSvc = this.beans.formula;
        const formulaDataSvc = this.formulaDataSvc;
        if (!formulaDataSvc?.hasDataSource() || !column.isAllowFormula()) return null;
        const isFormulaValue = formulaSvc?.isFormula(newValue);
        const existingFormula = formulaDataSvc.getFormula({
            column: column,
            rowNode: rowNode
        });
        if (isFormulaValue) {
            const valueWasDifferent = existingFormula !== newValue;
            if (!valueWasDifferent) return false;
            formulaDataSvc.setFormula({
                column: column,
                rowNode: rowNode,
                formula: newValue
            });
            const computedValue = formulaSvc?.resolveValue(column, rowNode);
            const colDef = column.getColDef();
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.valueSetter) || !$437b23f6a393c3bf$export$672d9e47bc342bac(colDef.field)) {
                const computedParams = {
                    ...setterParams,
                    newValue: computedValue
                };
                this.computeValueChange({
                    column: column,
                    newValue: computedValue,
                    params: computedParams,
                    rowData: rowNode.data,
                    valueSetter: colDef.valueSetter,
                    field: colDef.field
                });
            }
            return this.finishValueChange(rowNode, column, setterParams, eventSource);
        }
        if (existingFormula !== void 0) formulaDataSvc.setFormula({
            column: column,
            rowNode: rowNode,
            formula: void 0
        });
        return null;
    }
    computeValueChange(params) {
        const { valueSetter: valueSetter, params: setterParams, rowData: rowData, field: field, column: column, newValue: newValue } = params;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueSetter)) {
            if (typeof valueSetter === "function") return valueSetter(setterParams);
            return this.expressionSvc?.evaluate(valueSetter, setterParams);
        }
        return this.setValueUsingField(rowData, field, newValue, column.isFieldContainsDots());
    }
    dispatchCellValueChangedEvent(rowNode, params, value, source) {
        this.eventSvc.dispatchEvent({
            type: "cellValueChanged",
            event: null,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned,
            column: params.column,
            colDef: params.colDef,
            data: rowNode.data,
            node: rowNode,
            oldValue: params.oldValue,
            newValue: value,
            value: value,
            source: source
        });
    }
    callColumnCellValueChangedHandler(event) {
        const onCellValueChanged = event.colDef.onCellValueChanged;
        if (typeof onCellValueChanged === "function") this.beans.frameworkOverrides.wrapOutgoing(()=>{
            onCellValueChanged({
                node: event.node,
                data: event.data,
                oldValue: event.oldValue,
                newValue: event.newValue,
                colDef: event.colDef,
                column: event.column,
                api: event.api,
                context: event.context
            });
        });
    }
    setValueUsingField(data, field, newValue, isFieldContainsDots) {
        if (!field) return false;
        let valuesAreSame = false;
        if (!isFieldContainsDots) {
            valuesAreSame = data[field] === newValue;
            if (!valuesAreSame) data[field] = newValue;
        } else {
            const fieldPieces = field.split(".");
            let currentObject = data;
            while(fieldPieces.length > 0 && currentObject){
                const fieldPiece = fieldPieces.shift();
                if (fieldPieces.length === 0) {
                    valuesAreSame = currentObject[fieldPiece] === newValue;
                    if (!valuesAreSame) currentObject[fieldPiece] = newValue;
                } else currentObject = currentObject[fieldPiece];
            }
        }
        return !valuesAreSame;
    }
    executeValueGetterWithValueCache(valueGetter, data, column, rowNode) {
        const colId = column.getColId();
        const valueFromCache = this.valueCache.getValue(rowNode, colId);
        if (valueFromCache !== void 0) return valueFromCache;
        const result = this.executeValueGetterWithoutValueCache(valueGetter, data, column, rowNode);
        this.valueCache.setValue(rowNode, colId, result);
        return result;
    }
    executeValueGetterWithoutValueCache(valueGetter, data, column, rowNode) {
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            data: data,
            node: rowNode,
            column: column,
            colDef: column.getColDef(),
            getValue: this.getValueCallback.bind(this, rowNode)
        });
        let result;
        if (typeof valueGetter === "function") result = valueGetter(params);
        else result = this.expressionSvc?.evaluate(valueGetter, params);
        return result;
    }
    getValueCallback(node, field) {
        const otherColumn = this.colModel.getColDefCol(field);
        if (otherColumn) return this.getValue(otherColumn, node);
        return null;
    }
    // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
    getKeyForNode(col, rowNode) {
        const value = this.getValue(col, rowNode);
        const keyCreator = col.getColDef().keyCreator;
        let result = value;
        if (keyCreator) {
            const keyParams = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                colDef: col.getColDef(),
                column: col,
                node: rowNode,
                data: rowNode.data
            });
            result = keyCreator(keyParams);
        }
        if (typeof result === "string" || result == null) return result;
        result = String(result);
        if (result === "[object Object]") $437b23f6a393c3bf$export$545083624300f13d(121);
        return result;
    }
};
// packages/ag-grid-community/src/gridCoreModule.ts
var $437b23f6a393c3bf$var$CommunityCoreModule = {
    moduleName: "CommunityCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$GridDestroyService,
        $437b23f6a393c3bf$var$ApiFunctionService,
        $437b23f6a393c3bf$var$Registry,
        $437b23f6a393c3bf$var$UserComponentFactory,
        $437b23f6a393c3bf$var$RowContainerHeightService,
        $437b23f6a393c3bf$var$VisibleColsService,
        $437b23f6a393c3bf$var$EventService,
        $437b23f6a393c3bf$var$GridOptionsService,
        $437b23f6a393c3bf$var$ColumnModel,
        $437b23f6a393c3bf$var$PageBoundsService,
        $437b23f6a393c3bf$var$PageBoundsListener,
        $437b23f6a393c3bf$var$RowRenderer,
        $437b23f6a393c3bf$var$ValueService,
        $437b23f6a393c3bf$var$FocusService,
        $437b23f6a393c3bf$var$Environment,
        $437b23f6a393c3bf$var$ScrollVisibleService,
        $437b23f6a393c3bf$var$CtrlsService,
        $437b23f6a393c3bf$var$SyncService,
        $437b23f6a393c3bf$var$ColumnNameService,
        $437b23f6a393c3bf$var$ColumnViewportService,
        $437b23f6a393c3bf$var$IconService
    ],
    icons: {
        // icon on select dropdowns (select cell editor, charts tool panels)
        selectOpen: "small-down",
        /** @deprecated v33 */ smallDown: "small-down",
        /** @deprecated v33 */ colorPicker: "color-picker",
        /** @deprecated v33 */ smallUp: "small-up",
        /** @deprecated v33 */ checkboxChecked: "small-up",
        /** @deprecated v33 */ checkboxIndeterminate: "checkbox-indeterminate",
        /** @deprecated v33 */ checkboxUnchecked: "checkbox-unchecked",
        /** @deprecated v33 */ radioButtonOn: "radio-button-on",
        /** @deprecated v33 */ radioButtonOff: "radio-button-off",
        /** @deprecated v33 */ smallLeft: "small-left",
        /** @deprecated v33 */ smallRight: "small-right"
    },
    apiFunctions: {
        getGridId: $437b23f6a393c3bf$var$getGridId,
        destroy: $437b23f6a393c3bf$var$destroy,
        isDestroyed: $437b23f6a393c3bf$var$isDestroyed,
        getGridOption: $437b23f6a393c3bf$var$getGridOption,
        setGridOption: $437b23f6a393c3bf$var$setGridOption,
        updateGridOptions: $437b23f6a393c3bf$var$updateGridOptions,
        isModuleRegistered: $437b23f6a393c3bf$var$isModuleRegistered
    },
    dependsOn: [
        $437b23f6a393c3bf$var$DataTypeModule,
        $437b23f6a393c3bf$export$1458fbffed29c925,
        $437b23f6a393c3bf$var$ColumnResizeModule,
        $437b23f6a393c3bf$export$1a6625c5691649e8,
        $437b23f6a393c3bf$var$ColumnHeaderCompModule,
        $437b23f6a393c3bf$export$922da35340a6d14e,
        $437b23f6a393c3bf$var$ColumnGroupHeaderCompModule,
        $437b23f6a393c3bf$var$OverlayModule,
        $437b23f6a393c3bf$var$ChangeDetectionModule,
        $437b23f6a393c3bf$var$AnimationFrameModule,
        $437b23f6a393c3bf$export$44f04c51d8088336,
        $437b23f6a393c3bf$var$PinnedColumnModule,
        $437b23f6a393c3bf$var$AriaModule,
        $437b23f6a393c3bf$var$TouchModule,
        $437b23f6a393c3bf$var$CellRendererFunctionModule,
        $437b23f6a393c3bf$var$ColumnFlexModule,
        $437b23f6a393c3bf$var$ExpressionModule,
        $437b23f6a393c3bf$var$SkeletonCellRendererModule,
        $437b23f6a393c3bf$var$ColumnDelayRenderModule
    ]
};
// packages/ag-grid-community/src/validation/enterpriseModuleNames.ts
var $437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES = {
    AdvancedFilter: 1,
    AiToolkit: 1,
    AllEnterprise: 1,
    BatchEdit: 1,
    CellSelection: 1,
    Clipboard: 1,
    ColumnMenu: 1,
    ColumnsToolPanel: 1,
    ContextMenu: 1,
    ExcelExport: 1,
    FiltersToolPanel: 1,
    Find: 1,
    GridCharts: 1,
    IntegratedCharts: 1,
    GroupFilter: 1,
    MasterDetail: 1,
    Menu: 1,
    MultiFilter: 1,
    NewFiltersToolPanel: 1,
    Pivot: 1,
    RangeSelection: 1,
    RichSelect: 1,
    RowNumbers: 1,
    RowGrouping: 1,
    RowGroupingPanel: 1,
    ServerSideRowModelApi: 1,
    ServerSideRowModel: 1,
    SetFilter: 1,
    SideBar: 1,
    Sparklines: 1,
    StatusBar: 1,
    TreeData: 1,
    ViewportRowModel: 1,
    Formula: 1
};
// packages/ag-grid-community/src/validation/resolvableModuleNames.ts
var $437b23f6a393c3bf$var$ALL_COLUMN_FILTERS = [
    "TextFilter",
    "NumberFilter",
    "DateFilter",
    "SetFilter",
    "MultiFilter",
    "GroupFilter",
    "CustomFilter"
];
var $437b23f6a393c3bf$var$RESOLVABLE_MODULE_NAMES = {
    EditCore: [
        "TextEditor",
        "NumberEditor",
        "DateEditor",
        "CheckboxEditor",
        "LargeTextEditor",
        "SelectEditor",
        "RichSelect",
        "CustomEditor"
    ],
    CheckboxCellRenderer: [
        "AllCommunity"
    ],
    ClientSideRowModelHierarchy: [
        "RowGrouping",
        "Pivot",
        "TreeData"
    ],
    ColumnFilter: $437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
    ColumnGroupHeaderComp: [
        "AllCommunity"
    ],
    ColumnGroup: [
        "AllCommunity"
    ],
    ColumnHeaderComp: [
        "AllCommunity"
    ],
    ColumnMove: [
        "AllCommunity"
    ],
    ColumnResize: [
        "AllCommunity"
    ],
    CommunityCore: [
        "AllCommunity"
    ],
    CsrmSsrmSharedApi: [
        "ClientSideRowModelApi",
        "ServerSideRowModelApi"
    ],
    RowModelSharedApi: [
        "ClientSideRowModelApi",
        "ServerSideRowModelApi"
    ],
    EnterpriseCore: [
        "AllEnterprise"
    ],
    FilterCore: [
        ...$437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
        "QuickFilter",
        "ExternalFilter",
        "AdvancedFilter"
    ],
    GroupCellRenderer: [
        "RowGrouping",
        "Pivot",
        "TreeData",
        "MasterDetail",
        "ServerSideRowModel"
    ],
    KeyboardNavigation: [
        "AllCommunity"
    ],
    LoadingCellRenderer: [
        "ServerSideRowModel"
    ],
    MenuCore: [
        "ColumnMenu",
        "ContextMenu"
    ],
    MenuItem: [
        "ColumnMenu",
        "ContextMenu",
        "MultiFilter",
        "IntegratedCharts",
        "ColumnsToolPanel"
    ],
    Overlay: [
        "AllCommunity"
    ],
    PinnedColumn: [
        "AllCommunity"
    ],
    SharedAggregation: [
        "RowGrouping",
        "Pivot",
        "TreeData",
        "ServerSideRowModel"
    ],
    SharedDragAndDrop: [
        "AllCommunity"
    ],
    SharedMasterDetail: [
        "MasterDetail",
        "ServerSideRowModel"
    ],
    SharedMenu: [
        ...$437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
        "ColumnMenu",
        "ContextMenu"
    ],
    SharedPivot: [
        "Pivot",
        "ServerSideRowModel"
    ],
    SharedRowGrouping: [
        "RowGrouping",
        "ServerSideRowModel"
    ],
    SharedRowSelection: [
        "RowSelection",
        "ServerSideRowModel"
    ],
    SkeletonCellRenderer: [
        "ServerSideRowModel"
    ],
    Sort: [
        "AllCommunity"
    ],
    SsrmInfiniteSharedApi: [
        "InfiniteRowModel",
        "ServerSideRowModelApi"
    ],
    SharedTreeData: [
        "TreeData",
        "ServerSideRowModel"
    ]
};
var $437b23f6a393c3bf$var$MODULES_FOR_ROW_MODELS = {
    InfiniteRowModel: "infinite",
    ClientSideRowModelApi: "clientSide",
    ClientSideRowModel: "clientSide",
    ServerSideRowModelApi: "serverSide",
    ServerSideRowModel: "serverSide",
    ViewportRowModel: "viewport"
};
function $437b23f6a393c3bf$var$resolveModuleNames(moduleName, rowModelType) {
    const resolvedModuleNames = [];
    for (const modName of Array.isArray(moduleName) ? moduleName : [
        moduleName
    ]){
        const resolved = $437b23f6a393c3bf$var$RESOLVABLE_MODULE_NAMES[modName];
        if (resolved) for (const resolvedModName of resolved){
            const rowModelForModule = $437b23f6a393c3bf$var$MODULES_FOR_ROW_MODELS[resolvedModName];
            if (!rowModelForModule || rowModelForModule === rowModelType) resolvedModuleNames.push(resolvedModName);
        }
        else resolvedModuleNames.push(modName);
    }
    return resolvedModuleNames;
}
// packages/ag-grid-community/src/validation/errorMessages/errorText.ts
var $437b23f6a393c3bf$var$NoModulesRegisteredError = ()=>`No AG Grid modules are registered! It is recommended to start with all Community features via the AllCommunityModule:
                    
    import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
    
    ModuleRegistry.registerModules([ AllCommunityModule ]);
    `;
var $437b23f6a393c3bf$var$moduleImportMsg = (moduleNames)=>{
    const imports = moduleNames.map((moduleName)=>`import { ${$437b23f6a393c3bf$var$convertToUserModuleName(moduleName)} } from '${$437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES[moduleName] ? "ag-grid-enterprise" : "ag-grid-community"}';`);
    const includeCharts = moduleNames.some((m)=>m === "IntegratedCharts" || m === "Sparklines");
    if (includeCharts) {
        const chartImport = `import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';`;
        imports.push(chartImport);
    }
    return `import { ModuleRegistry } from 'ag-grid-community'; 
${imports.join(" \n")} 

ModuleRegistry.registerModules([ ${moduleNames.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m, true)).join(", ")} ]); 

For more info see: ${$437b23f6a393c3bf$var$baseDocLink}/modules/`;
};
function $437b23f6a393c3bf$var$convertToUserModuleName(moduleName, inModuleRegistration = false) {
    if (inModuleRegistration && (moduleName === "IntegratedCharts" || moduleName === "Sparklines")) return `${moduleName}Module.with(AgChartsEnterpriseModule)`;
    return `${moduleName}Module`;
}
function $437b23f6a393c3bf$var$umdMissingModule(reasonOrId, moduleNames) {
    const chartModules = moduleNames.filter((m)=>m === "IntegratedCharts" || m === "Sparklines");
    let message = "";
    const agChartsDynamic = globalThis?.agCharts;
    if (!agChartsDynamic && chartModules.length > 0) message = `Unable to use ${reasonOrId} as either the ag-charts-community or ag-charts-enterprise script needs to be included alongside ag-grid-enterprise.
`;
    else if (moduleNames.some((m)=>$437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES[m])) message = message + `Unable to use ${reasonOrId} as that requires the ag-grid-enterprise script to be included.
`;
    return message;
}
function $437b23f6a393c3bf$var$missingRowModelTypeError({ moduleName: moduleName, rowModelType: rowModelType }) {
    return `To use the ${moduleName}Module you must set the gridOption "rowModelType='${rowModelType}'"`;
}
var $437b23f6a393c3bf$var$missingModule = ({ reasonOrId: reasonOrId, moduleName: moduleName, gridScoped: gridScoped, gridId: gridId, rowModelType: rowModelType, additionalText: additionalText, isUmd: isUmd2 })=>{
    const resolvedModuleNames = $437b23f6a393c3bf$var$resolveModuleNames(moduleName, rowModelType);
    const reason = typeof reasonOrId === "string" ? reasonOrId : $437b23f6a393c3bf$var$MISSING_MODULE_REASONS[reasonOrId];
    if (isUmd2) return $437b23f6a393c3bf$var$umdMissingModule(reason, resolvedModuleNames);
    const chartModules = resolvedModuleNames.filter((m)=>m === "IntegratedCharts" || m === "Sparklines");
    const chartImportRequired = chartModules.length > 0 ? `${chartModules.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m)).join()} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.` : "";
    const explanation = `Unable to use ${reason} as ${resolvedModuleNames.length > 1 ? "one of " + resolvedModuleNames.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m)).join(", ") : $437b23f6a393c3bf$var$convertToUserModuleName(resolvedModuleNames[0])} is not registered${gridScoped ? " for gridId: " + gridId : ""}. ${chartImportRequired} Check if you have registered the module:
`;
    return `${explanation}
${$437b23f6a393c3bf$var$moduleImportMsg(resolvedModuleNames)}` + (additionalText ? ` 

${additionalText}` : "");
};
var $437b23f6a393c3bf$var$missingChartsWithModule = (gridModule)=>{
    return `${gridModule} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.

import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { ${gridModule} } from 'ag-grid-enterprise';
    
ModuleRegistry.registerModules([${gridModule}.with(AgChartsEnterpriseModule)]);
    `;
};
var $437b23f6a393c3bf$var$clipboardApiError = (method)=>`AG Grid: Unable to use the Clipboard API (navigator.clipboard.${method}()). The reason why it could not be used has been logged in the previous line. For this reason the grid has defaulted to using a workaround which doesn't perform as well. Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API.`;
var $437b23f6a393c3bf$var$AG_GRID_ERRORS = {
    1: ()=>"`rowData` must be an array",
    2: ({ nodeId: nodeId })=>`Duplicate node id '${nodeId}' detected from getRowId callback, this could cause issues in your grid.`,
    3: ()=>"Calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.",
    4: ({ id: id })=>`Could not find row id=${id}, data item was not found for this id`,
    5: ({ data: data })=>[
            `Could not find data item as object was not found.`,
            data,
            " Consider using getRowId to help the Grid find matching row data"
        ],
    6: ()=>`'groupHideOpenParents' only works when specifying specific columns for 'colDef.showRowGroup'`,
    7: ()=>"Pivoting is not supported with aligned grids as it may produce different columns in each grid.",
    8: ({ key: key })=>`Unknown key for navigation ${key}`,
    9: ({ variable: variable })=>`No value for ${variable?.cssName}. This usually means that the grid has been initialised before styles have been loaded. The default value of ${variable?.defaultValue} will be used and updated when styles load.`,
    10: ({ eventType: eventType })=>`As of v33, the '${eventType}' event is deprecated. Use the global 'modelUpdated' event to determine when row children have changed.`,
    11: ()=>"No gridOptions provided to createGrid",
    12: ({ colKey: colKey })=>[
            "column ",
            colKey,
            " not found"
        ],
    13: ()=>"Could not find rowIndex, this means tasks are being executed on a rowNode that has been removed from the grid.",
    14: ({ groupPrefix: groupPrefix })=>`Row IDs cannot start with ${groupPrefix}, this is a reserved prefix for AG Grid's row grouping feature.`,
    15: ({ expression: expression })=>[
            "value should be either a string or a function",
            expression
        ],
    16: ({ expression: expression, params: params, e: e })=>[
            "Processing of the expression failed",
            "Expression = ",
            expression,
            "Params = ",
            params,
            "Exception = ",
            e
        ],
    17: ()=>"you need either field or valueSetter set on colDef for editing to work",
    18: ()=>`alignedGrids contains an undefined option.`,
    19: ()=>`alignedGrids - No api found on the linked grid.`,
    20: ()=>`You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`,
    21: ()=>"pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.",
    22: ({ key: key })=>`${key} is an initial property and cannot be updated.`,
    23: ()=>"The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.",
    24: ()=>"row height must be a number if not using standard row model",
    25: ({ id: id })=>[
            `The getRowId callback must return a string. The ID `,
            id,
            ` is being cast to a string.`
        ],
    26: ({ fnName: fnName, preDestroyLink: preDestroyLink })=>{
        return `Grid API function ${fnName}() cannot be called as the grid has been destroyed.
 Either clear local references to the grid api, when it is destroyed, or check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
 To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${preDestroyLink}`;
    },
    27: ({ fnName: fnName, module: module })=>`API function '${fnName}' not registered to module '${module}'`,
    28: ()=>"setRowCount cannot be used while using row grouping.",
    29: ()=>"tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?",
    30: ({ toIndex: toIndex })=>[
            "tried to insert columns in invalid location, toIndex = ",
            toIndex,
            "remember that you should not count the moving columns when calculating the new index"
        ],
    31: ()=>"infinite loop in resizeColumnSets",
    32: ()=>"applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.",
    33: ()=>"stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON.",
    34: ({ key: key })=>`the column type '${key}' is a default column type and cannot be overridden.`,
    35: ()=>`Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type.`,
    36: ({ t: t })=>"colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes",
    37: ()=>`Changing the column pinning status is not allowed with domLayout='print'`,
    38: ({ iconName: iconName })=>`provided icon '${iconName}' needs to be a string or a function`,
    39: ()=>"Applying column order broke a group where columns should be married together. Applying new order has been discarded.",
    40: ({ e: e, method: method })=>`${e}
${$437b23f6a393c3bf$var$clipboardApiError(method)}`,
    41: ()=>"Browser did not allow document.execCommand('copy'). Ensure 'api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise the browser will prevent it for security reasons.",
    42: ()=>"Browser does not support document.execCommand('copy') for clipboard operations",
    43: ({ iconName: iconName })=>`As of v33, icon '${iconName}' is deprecated. Use the icon CSS name instead.`,
    44: ()=>'Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.',
    45: ({ parentCellDataType: parentCellDataType })=>`The data type definition ${parentCellDataType} does not exist.`,
    46: ()=>'The "baseDataType" property of a data type definition must match that of its parent.',
    47: ({ cellDataType: cellDataType })=>`Missing data type definition - "${cellDataType}"`,
    48: ({ property: property })=>`Cell data type is "object" but no Value ${property} has been provided. Please either provide an object data type definition with a Value ${property}, or set "colDef.value${property}"`,
    49: ({ methodName: methodName })=>`Framework component is missing the method ${methodName}()`,
    50: ({ compName: compName })=>`Could not find component ${compName}, did you forget to configure this component?`,
    51: ()=>`Export cancelled. Export is not allowed as per your configuration.`,
    52: ()=>"There is no `window` associated with the current `document`",
    53: ()=>`unknown value type during csv conversion`,
    54: ()=>"Could not find document body, it is needed for drag and drop and context menu.",
    55: ()=>"addRowDropZone - A container target needs to be provided",
    56: ()=>"addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.",
    57: ()=>"unable to show popup filter, filter instantiation failed",
    58: ()=>"no values found for select cellEditor",
    59: ()=>"cannot select pinned rows",
    60: ()=>"cannot select node until it has finished loading",
    61: ()=>"since version v32.2.0, rowNode.isFullWidthCell() has been deprecated. Instead check `rowNode.detail` followed by the user provided `isFullWidthRow` grid option.",
    62: ({ colId: colId })=>`setFilterModel() - no column found for colId: ${colId}`,
    63: ({ colId: colId })=>`setFilterModel() - unable to fully apply model, filtering disabled for colId: ${colId}`,
    64: ({ colId: colId })=>`setFilterModel() - unable to fully apply model, unable to create filter for colId: ${colId}`,
    65: ()=>"filter missing setModel method, which is needed for setFilterModel",
    66: ()=>"filter API missing getModel method, which is needed for getFilterModel",
    67: ()=>"Filter is missing isFilterActive() method",
    68: ()=>"Column Filter API methods have been disabled as Advanced Filters are enabled.",
    69: ({ guiFromFilter: guiFromFilter })=>`getGui method from filter returned ${guiFromFilter}; it should be a DOM element.`,
    70: ({ newFilter: newFilter })=>`Grid option quickFilterText only supports string inputs, received: ${typeof newFilter}`,
    71: ()=>"debounceMs is ignored when apply button is present",
    72: ({ keys: keys })=>[
            `ignoring FilterOptionDef as it doesn't contain one of `,
            keys
        ],
    73: ()=>`invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'`,
    74: ()=>"no filter options for filter",
    75: ()=>"Unknown button type specified",
    76: ({ filterModelType: filterModelType })=>[
            'Unexpected type of filter "',
            filterModelType,
            '", it looks like the filter was configured with incorrect Filter Options'
        ],
    77: ()=>`Filter model is missing 'conditions'`,
    78: ()=>'Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.',
    79: ()=>'"filterParams.maxNumConditions" must be greater than or equal to zero.',
    80: ()=>'"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.',
    81: ()=>'"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".',
    82: ({ param: param })=>`DateFilter ${param} is not a number`,
    83: ()=>`DateFilter minValidYear should be <= maxValidYear`,
    84: ()=>`DateFilter minValidDate should be <= maxValidDate`,
    85: ()=>"DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored.",
    86: ()=>"DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored.",
    87: ()=>"DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.",
    88: ({ index: index })=>`Invalid row index for ensureIndexVisible: ${index}`,
    89: ()=>`A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)`,
    90: ()=>`datasource is missing getRows method`,
    91: ()=>"Filter is missing method doesFilterPass",
    92: ()=>`AnimationFrameService called but animation frames are off`,
    93: ()=>"cannot add multiple ranges when `cellSelection.suppressMultiRanges = true`",
    94: ({ paginationPageSizeOption: paginationPageSizeOption, pageSizeSet: pageSizeSet, pageSizesSet: pageSizesSet, pageSizeOptions: pageSizeOptions })=>`'paginationPageSize=${paginationPageSizeOption}'${pageSizeSet ? "" : " (default value)"}, but ${paginationPageSizeOption} is not included in${pageSizesSet ? "" : " the default"} paginationPageSizeSelector=[${pageSizeOptions?.join(", ")}].`,
    95: ({ paginationPageSizeOption: paginationPageSizeOption, paginationPageSizeSelector: paginationPageSizeSelector2 })=>`Either set '${paginationPageSizeSelector2}' to an array that includes ${paginationPageSizeOption} or to 'false' to disable the page size selector.`,
    96: ({ id: id, data: data })=>[
            "Duplicate ID",
            id,
            "found for pinned row with data",
            data,
            "When `getRowId` is defined, it must return unique IDs for all pinned rows. Use the `rowPinned` parameter."
        ],
    97: ({ colId: colId })=>`cellEditor for column ${colId} is missing getGui() method`,
    98: ()=>"popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.",
    99: ()=>"Since v32, `api.hideOverlay()` does not hide the loading overlay when `loading=true`. Set `loading=false` instead.",
    // 100: ({ rowModelType }: { rowModelType: RowModelType }) =>
    //     `selectAll only available when rowModelType='clientSide', ie not ${rowModelType}` as const,
    101: ({ propertyName: propertyName, componentName: componentName, agGridDefaults: agGridDefaults, jsComps: jsComps })=>{
        const textOutput = [];
        const validComponents = [
            // Don't include the old names / internals in potential suggestions
            ...Object.keys(agGridDefaults ?? []).filter((k)=>![
                    "agCellEditor",
                    "agGroupRowRenderer",
                    "agSortIndicator"
                ].includes(k)),
            ...Object.keys(jsComps ?? []).filter((k)=>!!jsComps[k])
        ];
        const suggestions = $437b23f6a393c3bf$export$85cab1b5a4aa292c({
            inputValue: componentName,
            allSuggestions: validComponents,
            hideIrrelevant: true,
            filterByPercentageOfBestMatch: 0.8
        }).values;
        textOutput.push(`Could not find '${componentName}' component. It was configured as "${propertyName}: '${componentName}'" but it wasn't found in the list of registered components.
`);
        if (suggestions.length > 0) textOutput.push(`         Did you mean: [${suggestions.slice(0, 3)}]?
`);
        textOutput.push(`If using a custom component check it has been registered correctly.`);
        return textOutput;
    },
    102: ()=>"selectAll: 'filtered' only works when gridOptions.rowModelType='clientSide'",
    103: ()=>"Invalid selection state. When using client-side row model, the state must conform to `string[]`.",
    104: ({ value: value, param: param })=>`Numeric value ${value} passed to ${param} param will be interpreted as ${value} seconds. If this is intentional use "${value}s" to silence this warning.`,
    105: ({ e: e })=>[
            `chart rendering failed`,
            e
        ],
    106: ()=>`Theming API and Legacy Themes are both used in the same page. A Theming API theme has been provided to the 'theme' grid option, but the file (ag-grid.css) is also included and will cause styling issues. Remove ag-grid.css from the page. See the migration guide: ${$437b23f6a393c3bf$var$baseDocLink}/theming-migration/`,
    107: ({ key: key, value: value })=>`Invalid value for theme param ${key} - ${value}`,
    108: ({ e: e })=>[
            "chart update failed",
            e
        ],
    109: ({ inputValue: inputValue, allSuggestions: allSuggestions })=>{
        const suggestions = $437b23f6a393c3bf$export$85cab1b5a4aa292c({
            inputValue: inputValue,
            allSuggestions: allSuggestions,
            hideIrrelevant: true,
            filterByPercentageOfBestMatch: 0.8
        }).values;
        return [
            `Could not find '${inputValue}' aggregate function. It was configured as "aggFunc: '${inputValue}'" but it wasn't found in the list of registered aggregations.`,
            suggestions.length > 0 ? `         Did you mean: [${suggestions.slice(0, 3)}]?` : "",
            `If using a custom aggregation function check it has been registered correctly.`
        ].join("\n");
    },
    110: ()=>"groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup",
    111: ()=>"Invalid selection state. When `groupSelects` is enabled, the state must conform to `IServerSideGroupSelectionState`.",
    113: ()=>"Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values",
    114: ({ component: component })=>`Could not find component with name of ${component}. Is it in Vue.components?`,
    // 115: () => 'The provided selection state should be an object.' as const,
    116: ()=>"Invalid selection state. The state must conform to `IServerSideSelectionState`.",
    117: ()=>"selectAll must be of boolean type.",
    118: ()=>"Infinite scrolling must be enabled in order to set the row count.",
    119: ()=>"Unable to instantiate filter",
    120: ()=>"MultiFloatingFilterComp expects MultiFilter as its parent",
    121: ()=>"a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (see AG Grid docs) or b) to toString() on the object to return a key",
    122: ()=>"could not find the document, document is empty",
    123: ()=>"Advanced Filter is only supported with the Client-Side Row Model or Server-Side Row Model.",
    124: ()=>"No active charts to update.",
    125: ({ chartId: chartId })=>`Unable to update chart. No active chart found with ID: ${chartId}.`,
    126: ()=>"unable to restore chart as no chart model is provided",
    127: ({ allRange: allRange })=>`unable to create chart as ${allRange ? "there are no columns in the grid" : "no range is selected"}.`,
    128: ({ feature: feature })=>`${feature} is only available if using 'multiRow' selection mode.`,
    129: ({ feature: feature, rowModel: rowModel })=>`${feature} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${rowModel}.`,
    130: ()=>'cannot multi select unless selection mode is "multiRow"',
    // 131: () => 'cannot range select while selecting multiple rows' as const,
    132: ()=>"Row selection features are not available unless `rowSelection` is enabled.",
    133: ({ iconName: iconName })=>`icon '${iconName}' function should return back a string or a dom object`,
    134: ({ iconName: iconName })=>`Did not find icon '${iconName}'`,
    135: ()=>`Data type of the new value does not match the cell data type of the column`,
    136: ()=>`Unable to update chart as the 'type' is missing. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.`,
    137: ({ type: type, currentChartType: currentChartType })=>`Unable to update chart as a '${type}' update type is not permitted on a ${currentChartType}.`,
    138: ({ chartType: chartType })=>`invalid chart type supplied: ${chartType}`,
    139: ({ customThemeName: customThemeName })=>`a custom chart theme with the name ${customThemeName} has been supplied but not added to the 'chartThemes' list`,
    140: ({ name: name })=>`no stock theme exists with the name '${name}' and no custom chart theme with that name was supplied to 'customChartThemes'`,
    141: ()=>"cross filtering with row grouping is not supported.",
    142: ()=>"cross filtering is only supported in the client side row model.",
    143: ({ panel: panel })=>`'${panel}' is not a valid Chart Tool Panel name`,
    144: ({ type: type })=>`Invalid charts data panel group name supplied: '${type}'`,
    145: ({ group: group })=>`As of v32, only one charts customize panel group can be expanded at a time. '${group}' will not be expanded.`,
    146: ({ comp: comp })=>`Unable to instantiate component '${comp}' as its module hasn't been loaded. Add 'ValidationModule' to see which module is required.`,
    147: ({ group: group })=>`Invalid charts customize panel group name supplied: '${group}'`,
    148: ({ group: group })=>`invalid chartGroupsDef config '${group}'`,
    149: ({ group: group, chartType: chartType })=>`invalid chartGroupsDef config '${group}.${chartType}'`,
    150: ()=>`'seriesChartTypes' are required when the 'customCombo' chart type is specified.`,
    151: ({ chartType: chartType })=>`invalid chartType '${chartType}' supplied in 'seriesChartTypes', converting to 'line' instead.`,
    152: ({ colId: colId })=>`no 'seriesChartType' found for colId = '${colId}', defaulting to 'line'.`,
    153: ({ chartDataType: chartDataType })=>`unexpected chartDataType value '${chartDataType}' supplied, instead use 'category', 'series' or 'excluded'`,
    154: ({ colId: colId })=>`cross filtering requires a 'agSetColumnFilter' or 'agMultiColumnFilter' to be defined on the column with id: ${colId}`,
    155: ({ option: option })=>`'${option}' is not a valid Chart Toolbar Option`,
    156: ({ panel: panel })=>`Invalid panel in chartToolPanelsDef.panels: '${panel}'`,
    157: ({ unrecognisedGroupIds: unrecognisedGroupIds })=>[
            "unable to find group(s) for supplied groupIds:",
            unrecognisedGroupIds
        ],
    158: ()=>"can not expand a column item that does not represent a column group header",
    159: ()=>"Invalid params supplied to createExcelFileForExcel() - `ExcelExportParams.data` is empty.",
    160: ()=>`Export cancelled. Export is not allowed as per your configuration.`,
    161: ()=>"The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'",
    162: ({ id: id, dataType: dataType })=>`Unrecognized data type for excel export [${id}.dataType=${dataType}]`,
    163: ({ featureName: featureName })=>`Excel table export does not work with ${featureName}. The exported Excel file will not contain any Excel tables.
 Please turn off ${featureName} to enable Excel table exports.`,
    164: ()=>"Unable to add data table to Excel sheet: A table already exists.",
    165: ()=>"Unable to add data table to Excel sheet: Missing required parameters.",
    166: ({ unrecognisedGroupIds: unrecognisedGroupIds })=>[
            "unable to find groups for these supplied groupIds:",
            unrecognisedGroupIds
        ],
    167: ({ unrecognisedColIds: unrecognisedColIds })=>[
            "unable to find columns for these supplied colIds:",
            unrecognisedColIds
        ],
    168: ()=>"detailCellRendererParams.template should be function or string",
    169: ()=>'Reference to eDetailGrid was missing from the details template. Please add data-ref="eDetailGrid" to the template.',
    170: ({ providedStrategy: providedStrategy })=>`invalid cellRendererParams.refreshStrategy = ${providedStrategy} supplied, defaulting to refreshStrategy = 'rows'.`,
    171: ()=>"could not find detail grid options for master detail, please set gridOptions.detailCellRendererParams.detailGridOptions",
    172: ()=>"could not find getDetailRowData for master / detail, please set gridOptions.detailCellRendererParams.getDetailRowData",
    173: ({ group: group })=>`invalid chartGroupsDef config '${group}'`,
    174: ({ group: group, chartType: chartType })=>`invalid chartGroupsDef config '${group}.${chartType}'`,
    175: ({ menuTabName: menuTabName, itemsToConsider: itemsToConsider })=>[
            `Trying to render an invalid menu item '${menuTabName}'. Check that your 'menuTabs' contains one of `,
            itemsToConsider
        ],
    176: ({ key: key })=>`unknown menu item type ${key}`,
    177: ()=>`valid values for cellSelection.handle.direction are 'x', 'y' and 'xy'. Default to 'xy'.`,
    178: ({ colId: colId })=>`column ${colId} is not visible`,
    179: ()=>"totalValueGetter should be either a function or a string (expression)",
    180: ()=>"agRichSelectCellEditor requires cellEditorParams.values to be set",
    181: ()=>"agRichSelectCellEditor cannot have `multiSelect` and `allowTyping` set to `true`. AllowTyping has been turned off.",
    182: ()=>'you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data',
    183: ()=>"Group Column Filter only works on group columns. Please use a different filter.",
    184: ({ parentGroupData: parentGroupData, childNodeData: childNodeData })=>[
            `duplicate group keys for row data, keys should be unique`,
            [
                parentGroupData,
                childNodeData
            ]
        ],
    185: ({ data: data })=>[
            `getDataPath() should not return an empty path`,
            [
                data
            ]
        ],
    186: ({ rowId: rowId, rowData: rowData, duplicateRowsData: duplicateRowsData })=>[
            `duplicate group keys for row data, keys should be unique`,
            rowId,
            rowData,
            ...duplicateRowsData ?? []
        ],
    187: ({ rowId: rowId, firstData: firstData, secondData: secondData })=>[
            `Duplicate node id ${rowId}. Row IDs are provided via the getRowId() callback. Please modify the getRowId() callback code to provide unique row id values.`,
            "first instance",
            firstData,
            "second instance",
            secondData
        ],
    188: (props)=>`getRowId callback must be provided for Server Side Row Model ${props?.feature || "selection"} to work correctly.`,
    189: ({ startRow: startRow })=>`invalid value ${startRow} for startRow, the value should be >= 0`,
    190: ({ rowGroupId: rowGroupId, data: data })=>[
            `null and undefined values are not allowed for server side row model keys`,
            rowGroupId ? `column = ${rowGroupId}` : ``,
            `data is `,
            data
        ],
    // 191: () => `cannot multi select unless selection mode is 'multiRow'` as const,
    // 192: () => `cannot use range selection when multi selecting rows` as const,
    // 193: () => "cannot multi select unless selection mode is 'multiRow'" as const,
    194: ({ method: method })=>`calling gridApi.${method}() is only possible when using rowModelType=\`clientSide\`.`,
    195: ({ justCurrentPage: justCurrentPage })=>`selecting just ${justCurrentPage ? "current page" : "filtered"} only works when gridOptions.rowModelType='clientSide'`,
    196: ({ key: key })=>`Provided ids must be of string type. Invalid id provided: ${key}`,
    197: ()=>"`toggledNodes` must be an array of string ids.",
    // 198: () => `cannot multi select unless selection mode is 'multiRow'` as const,
    199: ()=>`getSelectedNodes and getSelectedRows functions cannot be used with select all functionality with the server-side row model. Use \`api.getServerSideSelectionState()\` instead.`,
    200: $437b23f6a393c3bf$var$missingModule,
    201: ({ rowModelType: rowModelType })=>`Could not find row model for rowModelType = ${rowModelType}`,
    202: ()=>`\`getSelectedNodes\` and \`getSelectedRows\` functions cannot be used with \`groupSelectsChildren\` and the server-side row model. Use \`api.getServerSideSelectionState()\` instead.`,
    203: ()=>"Server Side Row Model does not support Dynamic Row Height and Cache Purging. Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.",
    204: ()=>"Server Side Row Model does not support Auto Row Height and Cache Purging. Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.",
    205: ({ duplicateIdText: duplicateIdText })=>`Unable to display rows as duplicate row ids (${duplicateIdText}) were returned by the getRowId callback. Please modify the getRowId callback to provide unique ids.`,
    206: ()=>"getRowId callback must be implemented for transactions to work. Transaction was ignored.",
    207: ()=>'The Set Filter Parameter "defaultToNothingSelected" value was ignored because it does not work when "excelMode" is used.',
    208: ()=>`Set Filter Value Formatter must return string values. Please ensure the Set Filter Value Formatter returns string values for complex objects.`,
    209: ()=>`Set Filter Key Creator is returning null for provided values and provided values are primitives. Please provide complex objects. See ${$437b23f6a393c3bf$var$baseDocLink}/filter-set-filter-list/#filter-value-types`,
    210: ()=>"Set Filter has a Key Creator, but provided values are primitives. Did you mean to provide complex objects?",
    211: ()=>"property treeList=true for Set Filter params, but you did not provide a treeListPathGetter or values of type Date.",
    212: ()=>`please review all your toolPanel components, it seems like at least one of them doesn't have an id`,
    213: ()=>"Advanced Filter does not work with Filters Tool Panel. Filters Tool Panel has been disabled.",
    214: ({ key: key })=>`unable to lookup Tool Panel as invalid key supplied: ${key}`,
    215: ({ key: key, defaultByKey: defaultByKey })=>`the key ${key} is not a valid key for specifying a tool panel, valid keys are: ${Object.keys(defaultByKey ?? {}).join(",")}`,
    216: ({ name: name })=>`Missing component for '${name}'`,
    217: ({ invalidColIds: invalidColIds })=>[
            "unable to find grid columns for the supplied colDef(s):",
            invalidColIds
        ],
    218: ({ property: property, defaultOffset: defaultOffset })=>`${property} must be a number, the value you provided is not a valid number. Using the default of ${defaultOffset}px.`,
    219: ({ property: property })=>`Property ${property} does not exist on the target object.`,
    220: ({ lineDash: lineDash })=>`'${lineDash}' is not a valid 'lineDash' option.`,
    221: ()=>`agAggregationComponent should only be used with the client and server side row model.`,
    222: ()=>`agFilteredRowCountComponent should only be used with the client side row model.`,
    223: ()=>`agSelectedRowCountComponent should only be used with the client and server side row model.`,
    224: ()=>`agTotalAndFilteredRowCountComponent should only be used with the client side row model.`,
    225: ()=>"agTotalRowCountComponent should only be used with the client side row model.",
    226: ()=>"viewport is missing init method.",
    227: ()=>"menu item icon must be DOM node or string",
    228: ({ menuItemOrString: menuItemOrString })=>`unrecognised menu item ${menuItemOrString}`,
    // 229: ({ index }: { index: number }) => ['invalid row index for ensureIndexVisible: ', index] as const,
    230: ()=>"detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://www.ag-grid.com/react-data-grid/master-detail-custom-detail/",
    // @deprecated v32 mark for removal as part of v32 deprecated features
    231: ()=>"As of v32, using custom components with `reactiveCustomComponents = false` is deprecated.",
    232: ()=>"Using both rowData and v-model. rowData will be ignored.",
    233: ({ methodName: methodName })=>`Framework component is missing the method ${methodName}()`,
    234: ()=>'Group Column Filter does not work with the colDef property "field". This property will be ignored.',
    235: ()=>'Group Column Filter does not work with the colDef property "filterValueGetter". This property will be ignored.',
    236: ()=>'Group Column Filter does not work with the colDef property "filterParams". This property will be ignored.',
    237: ()=>"Group Column Filter does not work with Tree Data enabled. Please disable Tree Data, or use a different filter.",
    238: ()=>"setRowCount can only accept a positive row count.",
    239: ()=>'Theming API and CSS File Themes are both used in the same page. In v33 we released the Theming API as the new default method of styling the grid. See the migration docs https://www.ag-grid.com/react-data-grid/theming-migration/. Because no value was provided to the `theme` grid option it defaulted to themeQuartz. But the file (ag-grid.css) is also included and will cause styling issues. Either pass the string "legacy" to the theme grid option to use v32 style themes, or remove ag-grid.css from the page to use Theming API.',
    240: ({ theme: theme })=>`theme grid option must be a Theming API theme object or the string "legacy", received: ${theme}`,
    // 241: () => `cannot select multiple rows when rowSelection.mode is set to 'singleRow'` as const,
    // 242: () => 'cannot select multiple rows when using rangeSelect' as const,
    243: ()=>"Failed to deserialize state - each provided state object must be an object.",
    244: ()=>"Failed to deserialize state - `selectAllChildren` must be a boolean value or undefined.",
    245: ()=>"Failed to deserialize state - `toggledNodes` must be an array.",
    246: ()=>"Failed to deserialize state - Every `toggledNode` requires an associated string id.",
    247: ()=>`Row selection state could not be parsed due to invalid data. Ensure all child state has toggledNodes or does not conform with the parent rule. 
Please rebuild the selection state and reapply it.`,
    248: ()=>"SetFloatingFilter expects SetFilter as its parent",
    249: ()=>"Must supply a Value Formatter in Set Filter params when using a Key Creator",
    250: ()=>"Must supply a Key Creator in Set Filter params when `treeList = true` on a group column, and Tree Data or Row Grouping is enabled.",
    251: ({ chartType: chartType })=>`AG Grid: Unable to create chart as an invalid chartType = '${chartType}' was supplied.`,
    252: ()=>"cannot get grid to draw rows when it is in the middle of drawing rows. \nYour code probably called a grid API method while the grid was in the render stage. \nTo overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). \nTo see what part of your code that caused the refresh check this stacktrace.",
    253: ({ version: version })=>[
            "Illegal version string: ",
            version
        ],
    254: ()=>"Cannot create chart: no chart themes available.",
    255: ({ point: point })=>`Lone surrogate U+${point?.toString(16).toUpperCase()} is not a scalar value`,
    256: ()=>"Unable to initialise. See validation error, or load ValidationModule if missing.",
    257: ()=>$437b23f6a393c3bf$var$missingChartsWithModule("IntegratedChartsModule"),
    258: ()=>$437b23f6a393c3bf$var$missingChartsWithModule("SparklinesModule"),
    259: ({ part: part })=>`the argument to theme.withPart must be a Theming API part object, received: ${part}`,
    260: ({ propName: propName, compName: compName, gridScoped: gridScoped, gridId: gridId, rowModelType: rowModelType })=>$437b23f6a393c3bf$var$missingModule({
            reasonOrId: `AG Grid '${propName}' component: ${compName}`,
            moduleName: $437b23f6a393c3bf$var$USER_COMP_MODULES[compName],
            gridId: gridId,
            gridScoped: gridScoped,
            rowModelType: rowModelType
        }),
    261: ()=>"As of v33, `column.isHovered()` is deprecated. Use `api.isColumnHovered(column)` instead.",
    262: ()=>'As of v33, icon key "smallDown" is deprecated. Use "advancedFilterBuilderSelect" for Advanced Filter Builder dropdown, "selectOpen" for Select cell editor and dropdowns (e.g. Integrated Charts menu), "richSelectOpen" for Rich Select cell editor.',
    263: ()=>'As of v33, icon key "smallLeft" is deprecated. Use "panelDelimiterRtl" for Row Group Panel / Pivot Panel, "subMenuOpenRtl" for sub-menus.',
    264: ()=>'As of v33, icon key "smallRight" is deprecated. Use "panelDelimiter" for Row Group Panel / Pivot Panel, "subMenuOpen" for sub-menus.',
    265: ({ colId: colId })=>`Unable to infer chart data type for column '${colId}' if first data entry is null. Please specify "chartDataType", or a "cellDataType" in the column definition. For more information, see ${$437b23f6a393c3bf$var$baseDocLink}/integrated-charts-range-chart#coldefchartdatatype .`,
    266: ()=>'As of v33.1, using "keyCreator" with the Rich Select Editor has been deprecated. It now requires the "formatValue" callback to convert complex data to strings.',
    267: ()=>"Detail grids can not use a different theme to the master grid, the `theme` detail grid option will be ignored.",
    268: ()=>"Transactions aren't supported with tree data when using treeDataChildrenField",
    269: ()=>"When `masterSelects: 'detail'`, detail grids must be configured with multi-row selection",
    270: ({ id: id, parentId: parentId })=>`Cycle detected for row with id='${id}' and parent id='${parentId}'. Resetting the parent for row with id='${id}' and showing it as a root-level node.`,
    271: ({ id: id, parentId: parentId })=>`Parent row not found for row with id='${id}' and parent id='${parentId}'. Showing row with id='${id}' as a root-level node.`,
    272: ()=>$437b23f6a393c3bf$var$NoModulesRegisteredError(),
    273: ({ providedId: providedId, usedId: usedId })=>`Provided column id '${providedId}' was already in use, ensure all column and group ids are unique. Using '${usedId}' instead.`,
    274: ({ prop: prop })=>{
        let msg = `Since v33, ${prop} has been deprecated.`;
        switch(prop){
            case "maxComponentCreationTimeMs":
                msg += " This property is no longer required and so will be removed in a future version.";
                break;
            case "setGridApi":
                msg += ` This method is not called by AG Grid. To access the GridApi see: https://ag-grid.com/react-data-grid/grid-interface/#grid-api `;
                break;
            case "children":
                msg += ` For multiple versions AgGridReact does not support children.`;
                break;
        }
        return msg;
    },
    275: $437b23f6a393c3bf$var$missingRowModelTypeError,
    276: ()=>"Row Numbers Row Resizer cannot be used when Grid Columns have `autoHeight` enabled.",
    277: ({ colId: colId })=>`'enableFilterHandlers' is set to true, but column '${colId}' does not have 'filter.doesFilterPass' or 'filter.handler' set.`,
    278: ({ colId: colId })=>`Unable to create filter handler for column '${colId}'`,
    279: (_)=>{},
    // `Unable to create dynamic bean '${name}' during module init lifecycle, dynamic beans must be initialised on first use.` as const,
    280: ({ colId: colId })=>`'name' must be provided for custom filter components for column '${colId}`,
    281: ({ colId: colId })=>`Filter for column '${colId}' does not have 'filterParams.buttons', but the new Filters Tool Panel has buttons configured. Either configure buttons for the filter, or disable buttons on the Filters Tool Panel.`,
    282: ()=>"New filter tool panel requires `enableFilterHandlers: true`.",
    283: ()=>"As of v34, use the same method on the filter handler (`api.getColumnFilterHandler(colKey)`) instead.",
    284: ()=>"As of v34, filters are active when they have a model. Use `api.getColumnFilterModel()` instead.",
    285: ()=>"As of v34, use (`api.getColumnFilterModel()`) instead.",
    286: ()=>"As of v34, use (`api.setColumnFilterModel()`) instead.",
    287: ()=>"`api.doFilterAction()` requires `enableFilterHandlers = true",
    288: ()=>"`api.getColumnFilterModel(key, true)` requires `enableFilterHandlers = true",
    289: ({ rowModelType: rowModelType })=>`Row Model '${rowModelType}' is not supported with Batch Editing`,
    290: ({ rowIndex: rowIndex, rowPinned: rowPinned })=>`Row with index '${rowIndex}' and pinned state '${rowPinned}' not found`,
    291: ()=>"License Key being set multiple times with different values. This can result in an incorrect license key being used,",
    292: ({ colId: colId })=>`The Multi Filter for column '${colId}' has buttons configured against the child filters. When 'enableFilterHandlers=true', buttons must instead be provided against the parent Multi Filter params. The child filter buttons will be ignored.`,
    293: ()=>`The grid was initialised detached from the DOM and was then inserted into a Shadow Root. Theme styles are probably broken. Pass the themeStyleContainer grid option to let the grid know where in the document to insert theme CSS.`,
    294: ()=>`When using the \`agRichSelectCellEditor\` setting \`filterListAsync = true\` requires \`allowTyping = true\` and the \`values()\` callback must return a Promise of filtered values.`,
    295: ({ blockedService: blockedService })=>`colDef.allowFormula is not supported with ${blockedService}. Formulas has been turned off.`,
    296: ()=>"Since v35, `api.hideOverlay()` does not hide the overlay when `activeOverlay` is set. Set `activeOverlay=null` instead.",
    297: ()=>'`api.hideOverlay()` does not hide the no matching rows overlay as it is only controlled by grid state. Set `suppressOverlays=["noMatchingRows"] to not show it.'
};
function $437b23f6a393c3bf$var$getError(errorId, args) {
    const msgOrFunc = $437b23f6a393c3bf$var$AG_GRID_ERRORS[errorId];
    if (!msgOrFunc) return [
        `Missing error text for error id ${errorId}!`
    ];
    const errorBody = msgOrFunc(args);
    const errorLink = $437b23f6a393c3bf$var$getErrorLink(errorId, args);
    const errorSuffix = `
See ${errorLink}`;
    return Array.isArray(errorBody) ? errorBody.concat(errorSuffix) : [
        errorBody,
        errorSuffix
    ];
}
var $437b23f6a393c3bf$var$MISSING_MODULE_REASONS = {
    1: "Charting Aggregation",
    2: "pivotResultFields",
    3: "setTooltip"
};
// packages/ag-grid-community/src/grid.ts
var $437b23f6a393c3bf$var$_gridApiCache = /* @__PURE__ */ new WeakMap();
var $437b23f6a393c3bf$var$_gridElementCache = /* @__PURE__ */ new WeakMap();
function $437b23f6a393c3bf$export$fce123c48a7b4eae(eGridDiv, gridOptions, params) {
    if (!gridOptions) {
        $437b23f6a393c3bf$export$a20c7248650823a9(11);
        return {};
    }
    const gridParams = params;
    let destroyCallback;
    if (!gridParams?.setThemeOnGridDiv) {
        const newGridDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div"
        });
        newGridDiv.style.height = "100%";
        eGridDiv.appendChild(newGridDiv);
        eGridDiv = newGridDiv;
        destroyCallback = ()=>eGridDiv.remove();
    }
    const api = new $437b23f6a393c3bf$export$7759b93c6200a2f9().create(eGridDiv, gridOptions, (context)=>{
        const gridComp = new $437b23f6a393c3bf$var$GridComp(eGridDiv);
        context.createBean(gridComp);
    }, void 0, params, destroyCallback);
    return api;
}
var $437b23f6a393c3bf$var$nextGridId = 1;
var $437b23f6a393c3bf$export$7759b93c6200a2f9 = class {
    create(eGridDiv, providedOptions, createUi, acceptChanges, params, _destroyCallback) {
        const gridOptions = $437b23f6a393c3bf$var$GlobalGridOptions.applyGlobalGridOptions(providedOptions);
        const gridId = gridOptions.gridId ?? String($437b23f6a393c3bf$var$nextGridId++);
        const registeredModules = this.getRegisteredModules(params, gridId, gridOptions.rowModelType);
        const beanClasses = this.createBeansList(gridOptions.rowModelType, registeredModules, gridId);
        const providedBeanInstances = this.createProvidedBeans(eGridDiv, gridOptions, params);
        if (!beanClasses) return void 0;
        const destroyCallback = ()=>{
            $437b23f6a393c3bf$var$_gridElementCache.delete(api);
            $437b23f6a393c3bf$var$_gridApiCache.delete(eGridDiv);
            $437b23f6a393c3bf$var$_unRegisterGridModules(gridId);
            _destroyCallback?.();
        };
        const contextParams = {
            providedBeanInstances: providedBeanInstances,
            beanClasses: beanClasses,
            id: gridId,
            beanInitComparator: $437b23f6a393c3bf$var$gridBeanInitComparator,
            beanDestroyComparator: $437b23f6a393c3bf$var$gridBeanDestroyComparator,
            derivedBeans: [
                $437b23f6a393c3bf$var$createGridApi
            ],
            destroyCallback: destroyCallback
        };
        const context = new $437b23f6a393c3bf$export$1e4aca051de0f84c(contextParams);
        this.registerModuleFeatures(context, registeredModules);
        createUi(context);
        context.getBean("syncSvc").start();
        acceptChanges?.(context);
        const api = context.getBean("gridApi");
        $437b23f6a393c3bf$var$_gridApiCache.set(eGridDiv, api);
        $437b23f6a393c3bf$var$_gridElementCache.set(api, eGridDiv);
        return api;
    }
    getRegisteredModules(params, gridId, rowModelType) {
        $437b23f6a393c3bf$export$d0b008fbcc09e577($437b23f6a393c3bf$var$CommunityCoreModule, void 0, true);
        params?.modules?.forEach((m)=>$437b23f6a393c3bf$export$d0b008fbcc09e577(m, gridId));
        return $437b23f6a393c3bf$var$_getRegisteredModules(gridId, $437b23f6a393c3bf$var$getDefaultRowModelType(rowModelType));
    }
    registerModuleFeatures(context, registeredModules) {
        const registry = context.getBean("registry");
        const apiFunctionSvc = context.getBean("apiFunctionSvc");
        for (const module of registeredModules){
            registry.registerModule(module);
            const apiFunctions = module.apiFunctions;
            if (apiFunctions) {
                const names = Object.keys(apiFunctions);
                for (const name of names)apiFunctionSvc?.addFunction(name, apiFunctions[name]);
            }
        }
    }
    createProvidedBeans(eGridDiv, gridOptions, params) {
        let frameworkOverrides = params ? params.frameworkOverrides : null;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(frameworkOverrides)) frameworkOverrides = new $437b23f6a393c3bf$export$8174ad74937c6482();
        const seed = {
            gridOptions: gridOptions,
            eGridDiv: eGridDiv,
            eRootDiv: eGridDiv,
            globalListener: params ? params.globalListener : null,
            globalSyncListener: params ? params.globalSyncListener : null,
            frameworkOverrides: frameworkOverrides
        };
        if (params?.providedBeanInstances) Object.assign(seed, params.providedBeanInstances);
        return seed;
    }
    createBeansList(userProvidedRowModelType, registeredModules, gridId) {
        const rowModelModuleNames = {
            clientSide: "ClientSideRowModel",
            infinite: "InfiniteRowModel",
            serverSide: "ServerSideRowModel",
            viewport: "ViewportRowModel"
        };
        const rowModelType = $437b23f6a393c3bf$var$getDefaultRowModelType(userProvidedRowModelType);
        const rowModuleModelName = rowModelModuleNames[rowModelType];
        if (!rowModuleModelName) {
            $437b23f6a393c3bf$var$_logPreInitErr(201, {
                rowModelType: rowModelType
            }, `Unknown rowModelType ${rowModelType}.`);
            return;
        }
        if (!$437b23f6a393c3bf$var$_hasUserRegistered()) {
            $437b23f6a393c3bf$var$_logPreInitErr(272, void 0, $437b23f6a393c3bf$var$NoModulesRegisteredError());
            return;
        }
        if (!userProvidedRowModelType) {
            const registeredRowModelModules = Object.entries(rowModelModuleNames).filter(([rowModelType2, module])=>$437b23f6a393c3bf$var$_isModuleRegistered(module, gridId, rowModelType2));
            if (registeredRowModelModules.length == 1) {
                const [userRowModelType, moduleName] = registeredRowModelModules[0];
                if (userRowModelType !== rowModelType) {
                    const params = {
                        moduleName: moduleName,
                        rowModelType: userRowModelType
                    };
                    $437b23f6a393c3bf$var$_logPreInitErr(275, params, $437b23f6a393c3bf$var$missingRowModelTypeError(params));
                    return;
                }
            }
        }
        if (!$437b23f6a393c3bf$var$_isModuleRegistered(rowModuleModelName, gridId, rowModelType)) {
            const isUmd2 = $437b23f6a393c3bf$var$_isUmd();
            const reasonOrId = `rowModelType = '${rowModelType}'`;
            const message = isUmd2 ? `Unable to use ${reasonOrId} as that requires the ag-grid-enterprise script to be included.
` : `Missing module ${rowModuleModelName}Module for rowModelType ${rowModelType}.`;
            $437b23f6a393c3bf$var$_logPreInitErr(200, {
                reasonOrId: reasonOrId,
                moduleName: rowModuleModelName,
                gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
                gridId: gridId,
                rowModelType: rowModelType,
                isUmd: isUmd2
            }, message);
            return;
        }
        const beans = /* @__PURE__ */ new Set();
        for (const module of registeredModules)for (const bean of module.beans ?? [])beans.add(bean);
        return Array.from(beans);
    }
};
function $437b23f6a393c3bf$var$getDefaultRowModelType(passedRowModelType) {
    return passedRowModelType ?? "clientSide";
}
function $437b23f6a393c3bf$export$23a926ae0d6d33d3(gridElement) {
    if (typeof gridElement === "string") try {
        gridElement = document.querySelector(`[grid-id="${gridElement}"]`)?.parentElement ?? document.querySelector(gridElement)?.firstElementChild ?? document.getElementById(gridElement)?.firstElementChild;
    } catch  {
        gridElement = null;
    }
    return gridElement ? $437b23f6a393c3bf$var$_gridApiCache.get(gridElement) : void 0;
}
function $437b23f6a393c3bf$export$dbd289bae768c48d(api) {
    return $437b23f6a393c3bf$var$_gridElementCache.get(api);
}
// packages/ag-grid-community/src/api/rowModelApiUtils.ts
function $437b23f6a393c3bf$export$f5285e6f27a03f95(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "clientSide" ? rowModel : void 0;
}
function $437b23f6a393c3bf$var$_getInfiniteRowModel(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "infinite" ? rowModel : void 0;
}
function $437b23f6a393c3bf$export$aada92189a74e985(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "serverSide" ? rowModel : void 0;
}
function $437b23f6a393c3bf$export$78d50ab577b1d84b(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "viewport" ? rowModel : void 0;
}
// packages/ag-grid-community/src/misc/locale/localeService.ts
var $437b23f6a393c3bf$export$f325e19d05d9c36d = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "localeSvc";
    }
    getLocaleTextFunc() {
        const gos = this.gos;
        const getLocaleText = gos.getCallback("getLocaleText");
        if (getLocaleText) return $437b23f6a393c3bf$export$b2a251dd30f2791(getLocaleText);
        return $437b23f6a393c3bf$export$5a79576e712817ac(gos.get("localeText"));
    }
};
// packages/ag-grid-community/src/misc/state/stateUtils.ts
function $437b23f6a393c3bf$export$9453e80be74134db(columnState, enablePivotMode = false) {
    const sortColumns = [];
    const groupColIds = [];
    const aggregationColumns = [];
    const pivotColIds = [];
    const leftColIds = [];
    const rightColIds = [];
    const hiddenColIds = [];
    const columnSizes = [];
    const columns = [];
    let defaultSortIndex = 0;
    for(let i = 0; i < columnState.length; i++){
        const { colId: colId, sort: sort, sortType: sortType, sortIndex: sortIndex, rowGroup: rowGroup, rowGroupIndex: rowGroupIndex, aggFunc: aggFunc, pivot: pivot, pivotIndex: pivotIndex, pinned: pinned, hide: hide, width: width, flex: flex } = columnState[i];
        columns.push(colId);
        if (sort) sortColumns[sortIndex ?? defaultSortIndex++] = {
            colId: colId,
            sort: sort,
            type: sortType
        };
        if (rowGroup) groupColIds[rowGroupIndex ?? 0] = colId;
        if (typeof aggFunc === "string") aggregationColumns.push({
            colId: colId,
            aggFunc: aggFunc
        });
        if (pivot) pivotColIds[pivotIndex ?? 0] = colId;
        if (pinned) (pinned === "right" ? rightColIds : leftColIds).push(colId);
        if (hide) hiddenColIds.push(colId);
        if (flex != null || width) columnSizes.push({
            colId: colId,
            flex: flex ?? void 0,
            width: width === null ? void 0 : width
        });
    }
    return {
        sort: sortColumns.length ? {
            sortModel: $437b23f6a393c3bf$var$_removeEmptyValues(sortColumns)
        } : void 0,
        rowGroup: groupColIds.length ? {
            groupColIds: $437b23f6a393c3bf$var$_removeEmptyValues(groupColIds)
        } : void 0,
        aggregation: aggregationColumns.length ? {
            aggregationModel: aggregationColumns
        } : void 0,
        pivot: pivotColIds.length || enablePivotMode ? {
            pivotMode: enablePivotMode,
            pivotColIds: $437b23f6a393c3bf$var$_removeEmptyValues(pivotColIds)
        } : void 0,
        columnPinning: leftColIds.length || rightColIds.length ? {
            leftColIds: leftColIds,
            rightColIds: rightColIds
        } : void 0,
        columnVisibility: hiddenColIds.length ? {
            hiddenColIds: hiddenColIds
        } : void 0,
        columnSizing: columnSizes.length ? {
            columnSizingModel: columnSizes
        } : void 0,
        columnOrder: columns.length ? {
            orderedColIds: columns
        } : void 0
    };
}
function $437b23f6a393c3bf$var$_removeEmptyValues(array) {
    return array.filter((a)=>a != void 0);
}
function $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState) {
    const openColumnGroups = [];
    for (const { groupId: groupId, open: open } of columnGroupState)if (open) openColumnGroups.push(groupId);
    return openColumnGroups.length ? {
        openColumnGroupIds: openColumnGroups
    } : void 0;
}
function $437b23f6a393c3bf$export$e5b0fd7258628d55(columnGroupState) {
    return {
        columnGroup: $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState)
    };
}
// packages/ag-grid-community/src/components/framework/frameworkComponentWrapper.ts
var $437b23f6a393c3bf$export$157f014d661b6f19 = class {
    wrap(OriginalConstructor, mandatoryMethods, optionalMethods, componentType) {
        const wrapper = this.createWrapper(OriginalConstructor, componentType);
        for (const methodName of mandatoryMethods ?? [])this.createMethod(wrapper, methodName, true);
        for (const methodName of optionalMethods ?? [])this.createMethod(wrapper, methodName, false);
        return wrapper;
    }
    createMethod(wrapper, methodName, mandatory) {
        wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
    }
    createMethodProxy(wrapper, methodName, mandatory) {
        return function() {
            if (wrapper.hasMethod(methodName)) return wrapper.callMethod(methodName, arguments);
            if (mandatory) $437b23f6a393c3bf$export$545083624300f13d(49, {
                methodName: methodName
            });
            return null;
        };
    }
};
// packages/ag-grid-community/src/tooltip/tooltipFeature.ts
function $437b23f6a393c3bf$export$58660753196c7cdf(gos) {
    return gos.get("tooltipShowMode") === "whenTruncated";
}
function $437b23f6a393c3bf$export$75f51ed61a5271e6(gos, getElement2) {
    return $437b23f6a393c3bf$export$58660753196c7cdf(gos) ? $437b23f6a393c3bf$export$8980540b0a37a11d(getElement2) : void 0;
}
// packages/ag-grid-community/src/utils/number.ts
function $437b23f6a393c3bf$export$c8980add4a69422e(value, getLocaleTextFunc) {
    if (typeof value !== "number") return "";
    const localeTextFunc = getLocaleTextFunc();
    const thousandSeparator = localeTextFunc("thousandSeparator", ",");
    const decimalSeparator = localeTextFunc("decimalSeparator", ".");
    return value.toString().replace(".", decimalSeparator).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`);
}
// packages/ag-grid-community/src/export/baseCreator.ts
var $437b23f6a393c3bf$export$b335f23c5aead909 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    getFileName(fileName) {
        const extension = this.getDefaultFileExtension();
        if (!fileName?.length) fileName = this.getDefaultFileName();
        return fileName.includes(".") ? fileName : `${fileName}.${extension}`;
    }
    getData(params) {
        return this.beans.gridSerializer.serialize(this.createSerializingSession(params), params);
    }
    getDefaultFileName() {
        return `export.${this.getDefaultFileExtension()}`;
    }
};
// packages/ag-grid-community/src/export/baseGridSerializingSession.ts
var $437b23f6a393c3bf$export$5018ab277b833b61 = class {
    constructor(config){
        const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, colNames: colNames, valueSvc: valueSvc, gos: gos, processCellCallback: processCellCallback, processHeaderCallback: processHeaderCallback, processGroupHeaderCallback: processGroupHeaderCallback, processRowGroupCallback: processRowGroupCallback } = config;
        this.colModel = colModel;
        this.rowGroupColsSvc = rowGroupColsSvc;
        this.colNames = colNames;
        this.valueSvc = valueSvc;
        this.gos = gos;
        this.processCellCallback = processCellCallback;
        this.processHeaderCallback = processHeaderCallback;
        this.processGroupHeaderCallback = processGroupHeaderCallback;
        this.processRowGroupCallback = processRowGroupCallback;
    }
    prepare(_columnsToExport) {}
    extractHeaderValue(column) {
        const value = this.getHeaderName(this.processHeaderCallback, column);
        return value ?? "";
    }
    extractRowCellValue(params) {
        const { column: column, node: node, currentColumnIndex: currentColumnIndex, accumulatedRowIndex: accumulatedRowIndex, type: type, useRawFormula: useRawFormula } = params;
        const isFullWidthGroup = currentColumnIndex === 0 && $437b23f6a393c3bf$export$410912a9c501b8cc(this.gos, node, this.colModel.isPivotMode());
        if (this.processRowGroupCallback && (this.gos.get("treeData") || node.group) && (column.isRowGroupDisplayed(node.rowGroupColumn?.getColId() ?? "") || isFullWidthGroup)) return {
            value: this.processRowGroupCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                column: column,
                node: node
            })) ?? ""
        };
        if (this.processCellCallback) return {
            value: this.processCellCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                accumulatedRowIndex: accumulatedRowIndex,
                column: column,
                node: node,
                value: this.valueSvc.getValueForDisplay({
                    column: column,
                    node: node
                }).value,
                type: type,
                parseValue: (valueToParse)=>this.valueSvc.parseValue(column, node, valueToParse, this.valueSvc.getValue(column, node, void 0)),
                formatValue: (valueToFormat)=>this.valueSvc.formatValue(column, node, valueToFormat) ?? valueToFormat
            })) ?? ""
        };
        const isTreeData = this.gos.get("treeData");
        const valueService = this.valueSvc;
        const isGrandTotalRow = node.level === -1 && node.footer;
        const isMultiAutoCol = column.colDef.showRowGroup === true && (node.group || isTreeData);
        if (!isGrandTotalRow && (isFullWidthGroup || isMultiAutoCol)) {
            let concatenatedGroupValue = "";
            let pointer = node;
            while(pointer && pointer.level !== -1){
                const { value: value2, valueFormatted: valueFormatted2 } = valueService.getValueForDisplay({
                    column: isFullWidthGroup ? void 0 : column,
                    // full width group doesn't have a column
                    node: pointer,
                    includeValueFormatted: true,
                    exporting: true
                });
                concatenatedGroupValue = ` -> ${valueFormatted2 ?? value2 ?? ""}${concatenatedGroupValue}`;
                pointer = pointer.parent;
            }
            return {
                value: concatenatedGroupValue,
                // don't return the unformatted value; as if the grid detects number it'll not use the concatenated string
                valueFormatted: concatenatedGroupValue
            };
        }
        const { value: value, valueFormatted: valueFormatted } = valueService.getValueForDisplay({
            column: column,
            node: node,
            includeValueFormatted: true,
            exporting: true,
            useRawFormula: useRawFormula
        });
        return {
            value: value ?? "",
            valueFormatted: valueFormatted
        };
    }
    getHeaderName(callback, column) {
        if (callback) return callback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column
        }));
        return this.colNames.getDisplayNameForColumn(column, "csv", true);
    }
};
// packages/ag-grid-community/src/export/downloader.ts
function $437b23f6a393c3bf$export$97aef6bcdc3f7ef5(fileName, content) {
    const win = document.defaultView || window;
    if (!win) {
        $437b23f6a393c3bf$export$545083624300f13d(52);
        return;
    }
    const element = document.createElement("a");
    const url = win.URL.createObjectURL(content);
    element.setAttribute("href", url);
    element.setAttribute("download", fileName);
    element.style.display = "none";
    document.body.appendChild(element);
    element.dispatchEvent(new MouseEvent("click", {
        bubbles: false,
        cancelable: true,
        view: win
    }));
    element.remove();
    win.setTimeout(()=>{
        win.URL.revokeObjectURL(url);
    }, 0);
}
// packages/ag-grid-community/src/gridOptionsInitial.ts
var $437b23f6a393c3bf$var$INITIAL_GRID_OPTION_KEYS = {
    enableBrowserTooltips: true,
    tooltipTrigger: true,
    tooltipMouseTrack: true,
    tooltipShowMode: true,
    tooltipInteraction: true,
    defaultColGroupDef: true,
    suppressAutoSize: true,
    skipHeaderOnAutoSize: true,
    autoSizeStrategy: true,
    components: true,
    stopEditingWhenCellsLoseFocus: true,
    undoRedoCellEditing: true,
    undoRedoCellEditingLimit: true,
    excelStyles: true,
    cacheQuickFilter: true,
    customChartThemes: true,
    chartThemeOverrides: true,
    chartToolPanelsDef: true,
    loadingCellRendererSelector: true,
    localeText: true,
    keepDetailRows: true,
    keepDetailRowsCount: true,
    detailRowHeight: true,
    detailRowAutoHeight: true,
    tabIndex: true,
    valueCache: true,
    valueCacheNeverExpires: true,
    enableCellExpressions: true,
    suppressTouch: true,
    suppressBrowserResizeObserver: true,
    suppressPropertyNamesCheck: true,
    debug: true,
    dragAndDropImageComponent: true,
    overlayComponent: true,
    suppressOverlays: true,
    loadingOverlayComponent: true,
    suppressLoadingOverlay: true,
    noRowsOverlayComponent: true,
    paginationPageSizeSelector: true,
    paginateChildRows: true,
    pivotPanelShow: true,
    pivotSuppressAutoColumn: true,
    suppressExpandablePivotGroups: true,
    aggFuncs: true,
    allowShowChangeAfterFilter: true,
    ensureDomOrder: true,
    enableRtl: true,
    suppressColumnVirtualisation: true,
    suppressMaxRenderedRowRestriction: true,
    suppressRowVirtualisation: true,
    rowDragText: true,
    groupLockGroupColumns: true,
    suppressGroupRowsSticky: true,
    rowModelType: true,
    cacheOverflowSize: true,
    infiniteInitialRowCount: true,
    serverSideInitialRowCount: true,
    maxBlocksInCache: true,
    maxConcurrentDatasourceRequests: true,
    blockLoadDebounceMillis: true,
    serverSideOnlyRefreshFilteredGroups: true,
    serverSidePivotResultFieldSeparator: true,
    viewportRowModelPageSize: true,
    viewportRowModelBufferSize: true,
    debounceVerticalScrollbar: true,
    suppressAnimationFrame: true,
    suppressPreventDefaultOnMouseWheel: true,
    scrollbarWidth: true,
    icons: true,
    suppressRowTransform: true,
    gridId: true,
    enableGroupEdit: true,
    initialState: true,
    processUnpinnedColumns: true,
    createChartContainer: true,
    getLocaleText: true,
    getRowId: true,
    reactiveCustomComponents: true,
    renderingMode: true,
    columnMenu: true,
    suppressSetFilterByDefault: true,
    getDataPath: true,
    enableCellSpan: true,
    enableFilterHandlers: true,
    filterHandlers: true
};
// packages/ag-grid-community/src/validation/apiFunctionValidator.ts
var $437b23f6a393c3bf$var$clientSide = "clientSide";
var $437b23f6a393c3bf$var$serverSide = "serverSide";
var $437b23f6a393c3bf$var$infinite = "infinite";
var $437b23f6a393c3bf$var$functionRowModels = {
    onGroupExpandedOrCollapsed: [
        $437b23f6a393c3bf$var$clientSide
    ],
    refreshClientSideRowModel: [
        $437b23f6a393c3bf$var$clientSide
    ],
    isRowDataEmpty: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachLeafNode: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachNodeAfterFilter: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachNodeAfterFilterAndSort: [
        $437b23f6a393c3bf$var$clientSide
    ],
    resetRowHeights: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    applyTransaction: [
        $437b23f6a393c3bf$var$clientSide
    ],
    applyTransactionAsync: [
        $437b23f6a393c3bf$var$clientSide
    ],
    flushAsyncTransactions: [
        $437b23f6a393c3bf$var$clientSide
    ],
    getBestCostNodeSelection: [
        $437b23f6a393c3bf$var$clientSide
    ],
    getServerSideSelectionState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    setServerSideSelectionState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideTransaction: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideTransactionAsync: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideRowData: [
        $437b23f6a393c3bf$var$serverSide
    ],
    retryServerSideLoads: [
        $437b23f6a393c3bf$var$serverSide
    ],
    flushServerSideAsyncTransactions: [
        $437b23f6a393c3bf$var$serverSide
    ],
    refreshServerSide: [
        $437b23f6a393c3bf$var$serverSide
    ],
    getServerSideGroupLevelState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    refreshInfiniteCache: [
        $437b23f6a393c3bf$var$infinite
    ],
    purgeInfiniteCache: [
        $437b23f6a393c3bf$var$infinite
    ],
    getInfiniteRowCount: [
        $437b23f6a393c3bf$var$infinite
    ],
    isLastRowIndexKnown: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ],
    expandAll: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    collapseAll: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    onRowHeightChanged: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    setRowCount: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ],
    getCacheBlockState: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ]
};
var $437b23f6a393c3bf$var$deprecatedFunctions = {
    showLoadingOverlay: {
        version: "v32",
        message: '`showLoadingOverlay` is deprecated. Use the grid option "loading"=true instead or setGridOption("loading", true).'
    },
    clearRangeSelection: {
        version: "v32.2",
        message: "Use `clearCellSelection` instead."
    },
    getInfiniteRowCount: {
        version: "v32.2",
        old: "getInfiniteRowCount()",
        new: "getDisplayedRowCount()"
    },
    selectAllFiltered: {
        version: "v33",
        old: "selectAllFiltered()",
        new: 'selectAll("filtered")'
    },
    deselectAllFiltered: {
        version: "v33",
        old: "deselectAllFiltered()",
        new: 'deselectAll("filtered")'
    },
    selectAllOnCurrentPage: {
        version: "v33",
        old: "selectAllOnCurrentPage()",
        new: 'selectAll("currentPage")'
    },
    deselectAllOnCurrentPage: {
        version: "v33",
        old: "deselectAllOnCurrentPage()",
        new: 'deselectAll("currentPage")'
    }
};
function $437b23f6a393c3bf$var$validateApiFunction(functionName, apiFunction, beans) {
    const deprecation = $437b23f6a393c3bf$var$deprecatedFunctions[functionName];
    if (deprecation) {
        const { version: version, new: replacement, old: old, message: message } = deprecation;
        const apiMethod = old ?? functionName;
        return (...args)=>{
            const replacementMessage = replacement ? `Please use ${replacement} instead. ` : "";
            $437b23f6a393c3bf$export$2cf41453020eef66(`Since ${version} api.${apiMethod} is deprecated. ${replacementMessage}${message ?? ""}`);
            return apiFunction.apply(apiFunction, args);
        };
    }
    const rowModels = $437b23f6a393c3bf$var$functionRowModels[functionName];
    if (rowModels) return (...args)=>{
        const rowModel = beans.rowModel.getType();
        if (!rowModels.includes(rowModel)) {
            $437b23f6a393c3bf$var$_errorOnce(`api.${functionName} can only be called when gridOptions.rowModelType is ${rowModels.join(" or ")}`);
            return void 0;
        }
        return apiFunction.apply(apiFunction, args);
    };
    return apiFunction;
}
// packages/ag-grid-community/src/validation/rules/dynamicBeanValidations.ts
var $437b23f6a393c3bf$var$DYNAMIC_BEAN_MODULES = {
    detailCellRendererCtrl: "SharedMasterDetail",
    dndSourceComp: "DragAndDrop",
    fillHandle: "CellSelection",
    groupCellRendererCtrl: "GroupCellRenderer",
    headerFilterCellCtrl: "ColumnFilter",
    headerGroupCellCtrl: "ColumnGroup",
    rangeHandle: "CellSelection",
    tooltipFeature: "Tooltip",
    highlightTooltipFeature: "Tooltip",
    tooltipStateManager: "Tooltip",
    groupStrategy: "RowGrouping",
    treeGroupStrategy: "TreeData",
    rowNumberRowResizer: "RowNumbers",
    singleCell: "EditCore",
    fullRow: "EditCore",
    agSetColumnFilterHandler: "SetFilter",
    agMultiColumnFilterHandler: "MultiFilter",
    agGroupColumnFilterHandler: "GroupFilter",
    agNumberColumnFilterHandler: "NumberFilter",
    agDateColumnFilterHandler: "DateFilter",
    agTextColumnFilterHandler: "TextFilter"
};
// packages/ag-grid-community/src/validation/rules/iconValidations.ts
var $437b23f6a393c3bf$var$ICON_VALUES = {
    expanded: 1,
    contracted: 1,
    "tree-closed": 1,
    "tree-open": 1,
    "tree-indeterminate": 1,
    pin: 1,
    "eye-slash": 1,
    arrows: 1,
    left: 1,
    right: 1,
    group: 1,
    aggregation: 1,
    pivot: 1,
    "not-allowed": 1,
    chart: 1,
    cross: 1,
    cancel: 1,
    tick: 1,
    first: 1,
    previous: 1,
    next: 1,
    last: 1,
    linked: 1,
    unlinked: 1,
    "color-picker": 1,
    loading: 1,
    menu: 1,
    "menu-alt": 1,
    filter: 1,
    "filter-add": 1,
    columns: 1,
    maximize: 1,
    minimize: 1,
    copy: 1,
    cut: 1,
    paste: 1,
    grip: 1,
    save: 1,
    csv: 1,
    excel: 1,
    "small-down": 1,
    "small-left": 1,
    "small-right": 1,
    "small-up": 1,
    asc: 1,
    desc: 1,
    aasc: 1,
    adesc: 1,
    none: 1,
    up: 1,
    down: 1,
    plus: 1,
    minus: 1,
    settings: 1,
    "checkbox-checked": 1,
    "checkbox-indeterminate": 1,
    "checkbox-unchecked": 1,
    "radio-button-on": 1,
    "radio-button-off": 1,
    eye: 1,
    "column-arrow": 1,
    "un-pin": 1,
    "pinned-top": 1,
    "pinned-bottom": 1,
    "chevron-up": 1,
    "chevron-down": 1,
    "chevron-left": 1,
    "chevron-right": 1,
    edit: 1
};
var $437b23f6a393c3bf$var$ICON_MODULES = {
    chart: "MenuCore",
    cancel: "EnterpriseCore",
    first: "Pagination",
    previous: "Pagination",
    next: "Pagination",
    last: "Pagination",
    linked: "IntegratedCharts",
    loadingMenuItems: "MenuCore",
    unlinked: "IntegratedCharts",
    menu: "ColumnHeaderComp",
    legacyMenu: "ColumnMenu",
    filter: "ColumnFilter",
    filterActive: "ColumnFilter",
    filterAdd: "NewFiltersToolPanel",
    filterCardCollapse: "NewFiltersToolPanel",
    filterCardExpand: "NewFiltersToolPanel",
    filterCardEditing: "NewFiltersToolPanel",
    filterTab: "ColumnMenu",
    filtersToolPanel: "FiltersToolPanel",
    columns: [
        "MenuCore"
    ],
    columnsToolPanel: [
        "ColumnsToolPanel"
    ],
    maximize: "EnterpriseCore",
    minimize: "EnterpriseCore",
    save: "MenuCore",
    columnGroupOpened: "ColumnGroupHeaderComp",
    columnGroupClosed: "ColumnGroupHeaderComp",
    accordionOpen: "EnterpriseCore",
    accordionClosed: "EnterpriseCore",
    accordionIndeterminate: "EnterpriseCore",
    columnSelectClosed: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnSelectOpen: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnSelectIndeterminate: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnMovePin: "SharedDragAndDrop",
    columnMoveHide: "SharedDragAndDrop",
    columnMoveMove: "SharedDragAndDrop",
    columnMoveLeft: "SharedDragAndDrop",
    columnMoveRight: "SharedDragAndDrop",
    columnMoveGroup: "SharedDragAndDrop",
    columnMoveValue: "SharedDragAndDrop",
    columnMovePivot: "SharedDragAndDrop",
    dropNotAllowed: "SharedDragAndDrop",
    ensureColumnVisible: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    groupContracted: "GroupCellRenderer",
    groupExpanded: "GroupCellRenderer",
    setFilterGroupClosed: "SetFilter",
    setFilterGroupOpen: "SetFilter",
    setFilterGroupIndeterminate: "SetFilter",
    setFilterLoading: "SetFilter",
    close: "EnterpriseCore",
    check: "MenuItem",
    colorPicker: "CommunityCore",
    groupLoading: "LoadingCellRenderer",
    overlayLoading: "Overlay",
    overlayExporting: "Overlay",
    menuAlt: "ColumnHeaderComp",
    menuPin: "MenuCore",
    menuValue: "MenuCore",
    menuAddRowGroup: [
        "MenuCore",
        "ColumnsToolPanel"
    ],
    menuRemoveRowGroup: [
        "MenuCore",
        "ColumnsToolPanel"
    ],
    clipboardCopy: "MenuCore",
    clipboardCut: "MenuCore",
    clipboardPaste: "MenuCore",
    pivotPanel: [
        "ColumnsToolPanel",
        "RowGroupingPanel"
    ],
    rowGroupPanel: [
        "ColumnsToolPanel",
        "RowGroupingPanel"
    ],
    valuePanel: "ColumnsToolPanel",
    columnDrag: "EnterpriseCore",
    rowDrag: [
        "RowDrag",
        "DragAndDrop"
    ],
    csvExport: "MenuCore",
    excelExport: "MenuCore",
    smallDown: "CommunityCore",
    selectOpen: "CommunityCore",
    richSelectOpen: "RichSelect",
    richSelectRemove: "RichSelect",
    richSelectLoading: "RichSelect",
    smallLeft: "CommunityCore",
    smallRight: "CommunityCore",
    subMenuOpen: "MenuItem",
    subMenuOpenRtl: "MenuItem",
    panelDelimiter: "RowGroupingPanel",
    panelDelimiterRtl: "RowGroupingPanel",
    smallUp: "CommunityCore",
    sortAscending: [
        "MenuCore",
        "Sort"
    ],
    sortDescending: [
        "MenuCore",
        "Sort"
    ],
    sortAbsoluteAscending: [
        "MenuCore",
        "Sort"
    ],
    sortAbsoluteDescending: [
        "MenuCore",
        "Sort"
    ],
    sortUnSort: [
        "MenuCore",
        "Sort"
    ],
    advancedFilterBuilder: "AdvancedFilter",
    advancedFilterBuilderDrag: "AdvancedFilter",
    advancedFilterBuilderInvalid: "AdvancedFilter",
    advancedFilterBuilderMoveUp: "AdvancedFilter",
    advancedFilterBuilderMoveDown: "AdvancedFilter",
    advancedFilterBuilderAdd: "AdvancedFilter",
    advancedFilterBuilderRemove: "AdvancedFilter",
    advancedFilterBuilderSelectOpen: "AdvancedFilter",
    chartsMenu: "IntegratedCharts",
    chartsMenuEdit: "IntegratedCharts",
    chartsMenuAdvancedSettings: "IntegratedCharts",
    chartsMenuAdd: "IntegratedCharts",
    chartsColorPicker: "IntegratedCharts",
    chartsThemePrevious: "IntegratedCharts",
    chartsThemeNext: "IntegratedCharts",
    chartsDownload: "IntegratedCharts",
    checkboxChecked: "CommunityCore",
    checkboxIndeterminate: "CommunityCore",
    checkboxUnchecked: "CommunityCore",
    radioButtonOn: "CommunityCore",
    radioButtonOff: "CommunityCore",
    rowPin: "PinnedRow",
    rowUnpin: "PinnedRow",
    rowPinBottom: "PinnedRow",
    rowPinTop: "PinnedRow"
};
var $437b23f6a393c3bf$var$DEPRECATED_ICONS_V33 = /* @__PURE__ */ new Set([
    "colorPicker",
    "smallUp",
    "checkboxChecked",
    "checkboxIndeterminate",
    "checkboxUnchecked",
    "radioButtonOn",
    "radioButtonOff",
    "smallDown",
    "smallLeft",
    "smallRight"
]);
// packages/ag-grid-community/src/validation/validationService.ts
var $437b23f6a393c3bf$var$ValidationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "validation";
    }
    wireBeans(beans) {
        this.gridOptions = beans.gridOptions;
        $437b23f6a393c3bf$var$provideValidationServiceLogger($437b23f6a393c3bf$var$getError);
    }
    warnOnInitialPropertyUpdate(source, key) {
        if (source === "api" && $437b23f6a393c3bf$var$INITIAL_GRID_OPTION_KEYS[key]) $437b23f6a393c3bf$export$545083624300f13d(22, {
            key: key
        });
    }
    processGridOptions(options) {
        this.processOptions(options, $437b23f6a393c3bf$var$GRID_OPTIONS_VALIDATORS());
    }
    validateApiFunction(functionName, apiFunction) {
        return $437b23f6a393c3bf$var$validateApiFunction(functionName, apiFunction, this.beans);
    }
    missingUserComponent(propertyName, componentName, agGridDefaults, jsComps) {
        const moduleForComponent = $437b23f6a393c3bf$var$USER_COMP_MODULES[componentName];
        if (moduleForComponent) this.gos.assertModuleRegistered(moduleForComponent, `AG Grid '${propertyName}' component: ${componentName}`);
        else $437b23f6a393c3bf$export$545083624300f13d(101, {
            propertyName: propertyName,
            componentName: componentName,
            agGridDefaults: agGridDefaults,
            jsComps: jsComps
        });
    }
    missingDynamicBean(beanName) {
        const moduleName = $437b23f6a393c3bf$var$DYNAMIC_BEAN_MODULES[beanName];
        return moduleName ? $437b23f6a393c3bf$export$680bb5102fca525e(200, {
            ...this.gos.getModuleErrorParams(),
            moduleName: moduleName,
            reasonOrId: beanName
        }) : void 0;
    }
    checkRowEvents(eventType) {
        if ($437b23f6a393c3bf$var$DEPRECATED_ROW_NODE_EVENTS.has(eventType)) $437b23f6a393c3bf$export$545083624300f13d(10, {
            eventType: eventType
        });
    }
    validateIcon(iconName) {
        if ($437b23f6a393c3bf$var$DEPRECATED_ICONS_V33.has(iconName)) $437b23f6a393c3bf$export$545083624300f13d(43, {
            iconName: iconName
        });
        if ($437b23f6a393c3bf$var$ICON_VALUES[iconName]) return;
        const moduleName = $437b23f6a393c3bf$var$ICON_MODULES[iconName];
        if (moduleName) {
            $437b23f6a393c3bf$export$a20c7248650823a9(200, {
                reasonOrId: `icon '${iconName}'`,
                moduleName: moduleName,
                gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
                gridId: this.beans.context.getId(),
                rowModelType: this.gos.get("rowModelType"),
                additionalText: "Alternatively, use the CSS icon name directly."
            });
            return;
        }
        $437b23f6a393c3bf$export$545083624300f13d(134, {
            iconName: iconName
        });
    }
    isProvidedUserComp(compName) {
        return !!$437b23f6a393c3bf$var$USER_COMP_MODULES[compName];
    }
    /** Should only be called via the GridOptionsService */ validateColDef(colDef) {
        this.processOptions(colDef, $437b23f6a393c3bf$var$COL_DEF_VALIDATORS());
    }
    processOptions(options, validator) {
        const { validations: validations, deprecations: deprecations, allProperties: allProperties, propertyExceptions: propertyExceptions, objectName: objectName, docsUrl: docsUrl } = validator;
        if (allProperties && this.gridOptions.suppressPropertyNamesCheck !== true) this.checkProperties(options, [
            ...propertyExceptions ?? [],
            ...Object.keys(deprecations)
        ], allProperties, objectName, docsUrl);
        const warnings = /* @__PURE__ */ new Set();
        const optionKeys = Object.keys(options);
        optionKeys.forEach((key)=>{
            const deprecation = deprecations[key];
            if (deprecation) {
                const { message: message, version: version } = deprecation;
                warnings.add(`As of v${version}, ${String(key)} is deprecated. ${message ?? ""}`);
            }
            const value = options[key];
            if (value == null || value === false) return;
            const rules = validations[key];
            if (!rules) return;
            const { dependencies: dependencies, validate: validate, supportedRowModels: supportedRowModels, expectedType: expectedType } = rules;
            if (expectedType) {
                const actualType = typeof value;
                if (actualType !== expectedType) {
                    warnings.add(`${String(key)} should be of type '${expectedType}' but received '${actualType}' (${value}).`);
                    return;
                }
            }
            if (supportedRowModels) {
                const rowModel = this.gridOptions.rowModelType ?? "clientSide";
                if (!supportedRowModels.includes(rowModel)) {
                    warnings.add(`${String(key)} is not supported with the '${rowModel}' row model. It is only valid with: ${supportedRowModels.join(", ")}.`);
                    return;
                }
            }
            if (dependencies) {
                const warning = this.checkForRequiredDependencies(key, dependencies, options);
                if (warning) {
                    warnings.add(warning);
                    return;
                }
            }
            if (validate) {
                const warning = validate(options, this.gridOptions, this.beans);
                if (warning) {
                    warnings.add(warning);
                    return;
                }
            }
        });
        if (warnings.size > 0) for (const warning of warnings)$437b23f6a393c3bf$export$2cf41453020eef66(warning);
    }
    checkForRequiredDependencies(key, validator, options) {
        const optionEntries = Object.entries(validator);
        const failedOptions = optionEntries.filter(([key2, value])=>{
            const gridOptionValue = options[key2];
            return !value.required.includes(gridOptionValue);
        });
        if (failedOptions.length === 0) return null;
        return failedOptions.map(([failedKey, possibleOptions])=>`'${String(key)}' requires '${failedKey}' to be one of [${possibleOptions.required.map((o)=>{
                if (o === null) return "null";
                else if (o === void 0) return "undefined";
                return o;
            }).join(", ")}]. ${possibleOptions.reason ?? ""}`).join("\n           ");
    }
    checkProperties(object, exceptions, validProperties, containerName, docsUrl) {
        const VUE_FRAMEWORK_PROPS = [
            "__ob__",
            "__v_skip",
            "__metadata__"
        ];
        const invalidProperties = $437b23f6a393c3bf$var$_fuzzyCheckStrings(Object.getOwnPropertyNames(object), [
            ...VUE_FRAMEWORK_PROPS,
            ...exceptions,
            ...validProperties
        ], validProperties);
        const invalidPropertiesKeys = Object.keys(invalidProperties);
        for (const key of invalidPropertiesKeys){
            const value = invalidProperties[key];
            let message = `invalid ${containerName} property '${key}' did you mean any of these: ${value.slice(0, 8).join(", ")}.`;
            if (validProperties.includes("context")) message += `
If you are trying to annotate ${containerName} with application data, use the '${containerName}.context' property instead.`;
            $437b23f6a393c3bf$export$2cf41453020eef66(message);
        }
        if (invalidPropertiesKeys.length > 0 && docsUrl) {
            const url = this.beans.frameworkOverrides.getDocLink(docsUrl);
            $437b23f6a393c3bf$export$2cf41453020eef66(`to see all the valid ${containerName} properties please check: ${url}`);
        }
    }
};
function $437b23f6a393c3bf$var$_fuzzyCheckStrings(inputValues, validValues, allSuggestions) {
    const fuzzyMatches = {};
    const invalidInputs = inputValues.filter((inputValue)=>!validValues.some((validValue)=>validValue === inputValue));
    if (invalidInputs.length > 0) for (const invalidInput of invalidInputs)fuzzyMatches[invalidInput] = $437b23f6a393c3bf$export$85cab1b5a4aa292c({
        inputValue: invalidInput,
        allSuggestions: allSuggestions
    }).values;
    return fuzzyMatches;
}
var $437b23f6a393c3bf$var$DEPRECATED_ROW_NODE_EVENTS = /* @__PURE__ */ new Set([
    "firstChildChanged",
    "lastChildChanged",
    "childIndexChanged"
]);
// packages/ag-grid-community/src/validation/validationModule.ts
var $437b23f6a393c3bf$export$798770a8f68ba4e7 = {
    moduleName: "Validation",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ValidationService
    ]
};
// packages/ag-grid-community/src/clientSideRowModel/filterStage.ts
function $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode) {
    const sibling = rowNode.sibling;
    if (sibling) sibling.childrenAfterFilter = rowNode.childrenAfterFilter;
}
var $437b23f6a393c3bf$var$FilterStage = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterStage";
        this.step = "filter";
        this.refreshProps = [
            "excludeChildrenWhenTreeDataFiltering"
        ];
    }
    wireBeans(beans) {
        this.filterManager = beans.filterManager;
    }
    execute(changedPath) {
        const filterActive = !!this.filterManager?.isChildFilterPresent();
        if (this.beans.formula?.active) this.softFilter(filterActive, changedPath);
        else this.filterNodes(filterActive, changedPath);
    }
    filterNodes(filterActive, changedPath) {
        const filterCallback = (rowNode, includeChildNodes)=>{
            if (rowNode.hasChildren()) {
                if (filterActive && !includeChildNodes) rowNode.childrenAfterFilter = rowNode.childrenAfterGroup.filter((childNode)=>{
                    const passBecauseChildren = childNode.childrenAfterFilter && childNode.childrenAfterFilter.length > 0;
                    const passBecauseDataPasses = childNode.data && this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    return passBecauseChildren || passBecauseDataPasses;
                });
                else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            } else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode);
        };
        if (this.doingTreeDataFiltering()) {
            const treeDataDepthFirstFilter = (rowNode, alreadyFoundInParent)=>{
                if (rowNode.childrenAfterGroup) for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
                    const childNode = rowNode.childrenAfterGroup[i];
                    const foundInParent = alreadyFoundInParent || this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    if (childNode.childrenAfterGroup) treeDataDepthFirstFilter(rowNode.childrenAfterGroup[i], foundInParent);
                    else filterCallback(childNode, foundInParent);
                }
                filterCallback(rowNode, alreadyFoundInParent);
            };
            const treeDataFilterCallback = (rowNode)=>treeDataDepthFirstFilter(rowNode, false);
            changedPath.executeFromRootNode(treeDataFilterCallback);
        } else {
            const defaultFilterCallback = (rowNode)=>filterCallback(rowNode, false);
            changedPath.forEachChangedNodeDepthFirst(defaultFilterCallback, true);
        }
    }
    softFilter(filterActive, changedPath) {
        const filterCallback = (rowNode)=>{
            rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            if (rowNode.hasChildren()) for (const childNode of rowNode.childrenAfterGroup)childNode.softFiltered = filterActive && !(childNode.data && this.filterManager.doesRowPassFilter({
                rowNode: childNode
            }));
            $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode);
        };
        changedPath.forEachChangedNodeDepthFirst(filterCallback, true);
    }
    doingTreeDataFiltering() {
        const { gos: gos } = this;
        return gos.get("treeData") && !gos.get("excludeChildrenWhenTreeDataFiltering");
    }
};
// packages/ag-grid-community/src/headerRendering/cells/floatingFilter/headerFilterCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderFilterCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.iconCreated = false;
    }
    wireComp(comp, eGui, eButtonShowMainFilter, eFloatingFilterBody, compBeanInput) {
        this.comp = comp;
        const compBean = $437b23f6a393c3bf$var$setupCompBean(this, this.beans.context, compBeanInput);
        this.eButtonShowMainFilter = eButtonShowMainFilter;
        this.eFloatingFilterBody = eFloatingFilterBody;
        this.setGui(eGui, compBean);
        this.setupActive();
        this.refreshHeaderStyles();
        this.setupWidth(compBean);
        this.setupLeft(compBean);
        this.setupHover(compBean);
        this.setupFocus(compBean);
        this.setupAria();
        this.setupFilterButton();
        this.setupUserComp();
        this.setupSyncWithFilter(compBean);
        this.setupUi();
        compBean.addManagedElementListeners(this.eButtonShowMainFilter, {
            click: this.showParentFilter.bind(this)
        });
        this.setupFilterChangedListener(compBean);
        const colDefChanged = ()=>this.onColDefChanged(compBean);
        compBean.addManagedListeners(this.column, {
            colDefChanged: colDefChanged
        });
        compBean.addManagedEventListeners({
            filterSwitched: ({ column: column })=>{
                if (column === this.column) colDefChanged();
            }
        });
        compBean.addDestroyFunc(()=>{
            this.eButtonShowMainFilter = null;
            this.eFloatingFilterBody = null;
            this.userCompDetails = null;
            this.clearComponent();
        });
    }
    // empty abstract method
    resizeHeader() {}
    moveHeader() {}
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.colDef;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            column: column,
            floatingFilter: true
        });
    }
    setupActive() {
        const colDef = this.column.getColDef();
        const filterExists = !!colDef.filter;
        const floatingFilterExists = !!colDef.floatingFilter;
        this.active = filterExists && floatingFilterExists;
    }
    setupUi() {
        this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton);
        if (!this.active || this.iconCreated) return;
        const eMenuIcon = $437b23f6a393c3bf$export$d8feba07bf373edb("filter", this.beans, this.column);
        if (eMenuIcon) {
            this.iconCreated = true;
            this.eButtonShowMainFilter.appendChild(eMenuIcon);
        }
    }
    setupFocus(compBean) {
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
    }
    setupAria() {
        const localeTextFunc = this.getLocaleTextFunc();
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.eButtonShowMainFilter, localeTextFunc("ariaFilterMenuOpen", "Open Filter Menu"));
    }
    onTabKeyDown(e) {
        const { beans: beans } = this;
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
        const wrapperHasFocus = activeEl === this.eGui;
        if (wrapperHasFocus) return;
        const nextFocusableEl = $437b23f6a393c3bf$export$83fc12531358bd28(beans, this.eGui, null, e.shiftKey);
        if (nextFocusableEl) {
            beans.headerNavigation?.scrollToColumn(this.column);
            e.preventDefault();
            nextFocusableEl.focus();
            return;
        }
        const nextFocusableColumn = this.findNextColumnWithFloatingFilter(e.shiftKey);
        if (!nextFocusableColumn) return;
        if (beans.focusSvc.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: this.rowCtrl.rowIndex,
                column: nextFocusableColumn
            },
            event: e
        })) e.preventDefault();
    }
    findNextColumnWithFloatingFilter(backwards) {
        const presentedColsService = this.beans.visibleCols;
        let nextCol = this.column;
        do {
            nextCol = backwards ? presentedColsService.getColBefore(nextCol) : presentedColsService.getColAfter(nextCol);
            if (!nextCol) break;
        }while (!nextCol.getColDef().filter || !nextCol.getColDef().floatingFilter);
        return nextCol;
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                if (wrapperHasFocus) return;
                $437b23f6a393c3bf$export$456c40e80134d72a(e);
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                if (wrapperHasFocus) {
                    if ($437b23f6a393c3bf$export$8598088d375f416f(this.eGui)) e.preventDefault();
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (!wrapperHasFocus) this.eGui.focus();
        }
    }
    onFocusIn(e) {
        const isRelatedWithin = this.eGui.contains(e.relatedTarget);
        if (isRelatedWithin) return;
        const notFromHeaderWrapper = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter");
        const fromWithinHeader = !!e.relatedTarget && $437b23f6a393c3bf$var$_isElementChildOfClass(e.relatedTarget, "ag-floating-filter");
        if (notFromHeaderWrapper && fromWithinHeader && e.target === this.eGui) {
            const lastFocusEvent = this.lastFocusEvent;
            const fromTab = !!(lastFocusEvent && lastFocusEvent.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB);
            if (lastFocusEvent && fromTab) {
                const shouldFocusLast = lastFocusEvent.shiftKey;
                $437b23f6a393c3bf$export$8598088d375f416f(this.eGui, shouldFocusLast);
            }
        }
        this.focusThis();
    }
    setupHover(compBean) {
        this.beans.colHover?.addHeaderFilterColumnHoverListener(compBean, this.comp, this.column, this.eGui);
    }
    setupLeft(compBean) {
        const setLeftFeature = new $437b23f6a393c3bf$var$SetLeftFeature(this.column, this.eGui, this.beans);
        compBean.createManagedBean(setLeftFeature);
    }
    setupFilterButton() {
        this.suppressFilterButton = !this.beans.menuSvc?.isFloatingFilterButtonEnabled(this.column);
        this.highlightFilterButtonWhenActive = !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos);
    }
    setupUserComp() {
        if (!this.active) return;
        const compDetails = this.beans.colFilter?.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter());
        if (compDetails) this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setCompDetails(compDetails);
    }
    showParentFilter() {
        const eventSource = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
        this.beans.menuSvc?.showFilterMenu({
            column: this.column,
            buttonElement: eventSource,
            containerType: "floatingFilter",
            positionBy: "button"
        });
    }
    setupSyncWithFilter(compBean) {
        if (!this.active) return;
        const { beans: { colFilter: colFilter }, column: column, gos: gos } = this;
        const syncWithFilter = (event)=>{
            if (event?.source === "filterDestroyed" && (!this.isAlive() || !colFilter?.isAlive())) return;
            const compPromise = this.comp.getFloatingFilterComp();
            if (!compPromise) return;
            compPromise.then((comp)=>{
                if (comp) {
                    if (gos.get("enableFilterHandlers")) {
                        const eventWithParams = event;
                        let source = "filter";
                        if (eventWithParams?.afterFloatingFilter) source = "ui";
                        else if (eventWithParams?.afterDataChange) source = "dataChanged";
                        else if (event?.source === "api") source = "api";
                        this.updateFloatingFilterParams(this.userCompDetails, source);
                        return;
                    }
                    const parentModel = colFilter?.getCurrentFloatingFilterParentModel(column);
                    const filterChangedEvent = event ? {
                        // event can have additional params like `afterDataChange` which need to be passed through
                        ...event,
                        columns: event.columns ?? [],
                        source: event.source === "api" ? "api" : "columnFilter"
                    } : null;
                    comp.onParentModelChanged(parentModel, filterChangedEvent);
                }
            });
        };
        [this.destroySyncListener] = compBean.addManagedListeners(column, {
            filterChanged: syncWithFilter
        });
        if (colFilter?.isFilterActive(column)) syncWithFilter(null);
    }
    setupWidth(compBean) {
        const listener = ()=>{
            const width = `${this.column.getActualWidth()}px`;
            this.comp.setWidth(width);
        };
        compBean.addManagedListeners(this.column, {
            widthChanged: listener
        });
        listener();
    }
    setupFilterChangedListener(compBean) {
        if (this.active) {
            [this.destroyFilterChangedListener] = compBean.addManagedListeners(this.column, {
                filterChanged: this.updateFilterButton.bind(this)
            });
            this.updateFilterButton();
        }
    }
    updateFilterButton() {
        if (!this.suppressFilterButton && this.comp) {
            const isFilterAllowed = !!this.beans.filterManager?.isFilterAllowed(this.column);
            this.comp.setButtonWrapperDisplayed(isFilterAllowed);
            if (this.highlightFilterButtonWhenActive && isFilterAllowed) this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
        }
    }
    onColDefChanged(compBean) {
        const wasActive = this.active;
        this.setupActive();
        const becomeActive = !wasActive && this.active;
        if (wasActive && !this.active) {
            this.destroySyncListener();
            this.destroyFilterChangedListener();
        }
        const colFilter = this.beans.colFilter;
        const newCompDetails = this.active ? colFilter?.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter()) : null;
        const compPromise = this.comp.getFloatingFilterComp();
        if (!compPromise || !newCompDetails) this.updateCompDetails(compBean, newCompDetails, becomeActive);
        else compPromise.then((compInstance)=>{
            if (!compInstance || colFilter?.areFilterCompsDifferent(this.userCompDetails ?? null, newCompDetails)) this.updateCompDetails(compBean, newCompDetails, becomeActive);
            else this.updateFloatingFilterParams(newCompDetails, "colDef");
        });
    }
    updateCompDetails(compBean, compDetails, becomeActive) {
        if (!this.isAlive()) return;
        this.setCompDetails(compDetails);
        this.setupFilterButton();
        this.setupUi();
        if (becomeActive) {
            this.setupSyncWithFilter(compBean);
            this.setupFilterChangedListener(compBean);
        }
    }
    updateFloatingFilterParams(userCompDetails, source) {
        if (!userCompDetails) return;
        let params = userCompDetails.params;
        this.comp.getFloatingFilterComp()?.then((floatingFilter)=>{
            if (typeof floatingFilter?.refresh === "function") {
                if (this.gos.get("enableFilterHandlers")) params = {
                    ...params,
                    model: $437b23f6a393c3bf$export$8981db65da4532f2(this.beans.colFilter?.model ?? {}, this.column.getColId()),
                    source: source
                };
                floatingFilter.refresh(params);
            }
        });
    }
    addResizeAndMoveKeyboardListeners() {}
    destroy() {
        super.destroy();
        this.destroySyncListener = null;
        this.destroyFilterChangedListener = null;
    }
};
// packages/ag-grid-community/src/misc/menu/menuApi.ts
function $437b23f6a393c3bf$var$showColumnMenu(beans, colKey) {
    const column = beans.colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$a20c7248650823a9(12, {
            colKey: colKey
        });
        return;
    }
    beans.menuSvc?.showColumnMenu({
        column: column,
        positionBy: "auto"
    });
}
function $437b23f6a393c3bf$var$hidePopupMenu(beans) {
    beans.menuSvc?.hidePopupMenu();
}
// packages/ag-grid-community/src/misc/menu/sharedMenuModule.ts
var $437b23f6a393c3bf$export$b0ea578339daf1f7 = {
    moduleName: "SharedMenu",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$MenuService
    ],
    apiFunctions: {
        showColumnMenu: $437b23f6a393c3bf$var$showColumnMenu,
        hidePopupMenu: $437b23f6a393c3bf$var$hidePopupMenu
    }
};
// packages/ag-grid-community/src/widgets/popupService.ts
var $437b23f6a393c3bf$var$PopupService = class extends $437b23f6a393c3bf$export$a5869429525f9944 {
    getDefaultPopupParent() {
        return this.beans.ctrlsSvc.get("gridCtrl").getGui();
    }
    callPostProcessPopup(params, type, ePopup, eventSource, mouseEvent) {
        const callback = this.gos.getCallback("postProcessPopup");
        if (callback) {
            const { column: column, rowNode: rowNode } = params ?? {};
            const postProcessParams = {
                column: column,
                rowNode: rowNode,
                ePopup: ePopup,
                type: type,
                eventSource: eventSource,
                mouseEvent: mouseEvent
            };
            callback(postProcessParams);
        }
    }
    getActivePopups() {
        return this.popupList.map((popup)=>popup.element);
    }
    hasAnchoredPopup() {
        return this.popupList.some((popup)=>popup.isAnchored);
    }
    isStopPropagation(event) {
        return $437b23f6a393c3bf$export$9a48e23524c6d58(event);
    }
};
// packages/ag-grid-community/src/widgets/popupModule.ts
var $437b23f6a393c3bf$export$da5c9bb998e6c24d = {
    moduleName: "Popup",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PopupService
    ]
};
// packages/ag-grid-community/src/filter/column-filters.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnFiltersCSS = /*css*/ `.ag-set-filter{--ag-indentation-level:0}.ag-set-filter-item{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-set-filter-item{padding-left:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}:where(.ag-rtl) .ag-set-filter-item{padding-right:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}.ag-set-filter-item-checkbox{display:flex;height:100%;width:100%}.ag-set-filter-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr) .ag-set-filter-group-icons{margin-right:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-set-filter-group-icons{margin-left:var(--ag-widget-container-horizontal-padding)}.ag-filter-body-wrapper{display:flex;flex-direction:column}:where(.ag-menu:not(.ag-tabs) .ag-filter) .ag-filter-body-wrapper,:where(.ag-menu:not(.ag-tabs) .ag-filter)>:not(.ag-filter-wrapper){min-width:180px}.ag-filter-filter{flex:1 1 0px}.ag-filter-condition{display:flex;justify-content:center}.ag-floating-filter-body{display:flex;flex:1 1 auto;height:100%;position:relative}.ag-floating-filter-full-body{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;width:100%}:where(.ag-floating-filter-full-body)>div{flex:1 1 auto}.ag-floating-filter-input{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}:where(.ag-input-field-input[type=date]),:where(.ag-input-field-input[type=datetime-local]){width:1px}}.ag-floating-filter-button{display:flex;flex:none}.ag-date-floating-filter-wrapper{display:flex}.ag-set-floating-filter-input :where(input)[disabled]{pointer-events:none}.ag-floating-filter-button-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;height:var(--ag-icon-size);width:var(--ag-icon-size)}.ag-filter-loading{align-items:unset;background-color:var(--ag-chrome-background-color);height:100%;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;width:100%;z-index:1;:where(.ag-menu) &{background-color:var(--ag-menu-background-color)}}.ag-filter-separator{border-top:solid var(--ag-border-width) var(--menu-separator-color)}:where(.ag-filter-select) .ag-picker-field-wrapper{width:0}.ag-filter-condition-operator{height:17px}:where(.ag-ltr) .ag-filter-condition-operator-or{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-condition-operator-or{margin-right:calc(var(--ag-spacing)*2)}.ag-set-filter-select-all{padding-top:var(--ag-widget-container-vertical-padding)}.ag-filter-no-matches,.ag-set-filter-list{height:calc(var(--ag-list-item-height)*6)}.ag-filter-no-matches{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}.ag-set-filter-tree-list{height:calc(var(--ag-list-item-height)*10)}.ag-set-filter-filter{margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding);margin-top:var(--ag-widget-container-vertical-padding)}.ag-filter-to{margin-top:var(--ag-widget-vertical-spacing)}.ag-mini-filter{margin:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-set-filter-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-rtl) .ag-set-filter-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-filter-menu) .ag-set-filter-list{min-width:200px}.ag-filter-virtual-list-item:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-filter-apply-panel{display:flex;justify-content:flex-end;overflow:hidden;padding:var(--ag-widget-vertical-spacing) var(--ag-widget-container-horizontal-padding) var(--ag-widget-container-vertical-padding)}.ag-filter-apply-panel-button{line-height:1.5}:where(.ag-ltr) .ag-filter-apply-panel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-apply-panel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-simple-filter-body-wrapper{display:flex;flex-direction:column;min-height:calc(var(--ag-list-item-height) + var(--ag-widget-container-vertical-padding) + var(--ag-widget-vertical-spacing));overflow-y:auto;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));&>*{margin-bottom:var(--ag-widget-vertical-spacing)}:where(.ag-resizer-wrapper){margin:0}}.ag-multi-filter-menu-item{margin:var(--ag-spacing) 0}.ag-multi-filter-group-title-bar{background-color:transparent;color:var(--ag-header-text-color);font-weight:500;padding:calc(var(--ag-spacing)*1.5) var(--ag-spacing)}.ag-group-filter-field-select-wrapper{display:flex;flex-direction:column;gap:var(--ag-widget-vertical-spacing);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}`;
// packages/ag-grid-community/src/filter/columnFilterApi.ts
function $437b23f6a393c3bf$var$isColumnFilterPresent(beans) {
    const filterManager = beans.filterManager;
    return !!filterManager?.isColumnFilterPresent() || !!filterManager?.isAggregateFilterPresent();
}
function $437b23f6a393c3bf$var$getColumnFilterInstance(beans, key) {
    return beans.filterManager?.getColumnFilterInstance(key) ?? Promise.resolve(void 0);
}
function $437b23f6a393c3bf$var$destroyFilter(beans, key) {
    const column = beans.colModel.getColDefCol(key);
    if (column) return beans.colFilter?.destroyFilter(column, "api");
}
function $437b23f6a393c3bf$var$setFilterModel(beans, model) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.filterManager?.setFilterModel(model));
}
function $437b23f6a393c3bf$var$getFilterModel(beans) {
    return beans.filterManager?.getFilterModel() ?? {};
}
function $437b23f6a393c3bf$var$getColumnFilterModel(beans, key, useUnapplied) {
    const { gos: gos, colModel: colModel, colFilter: colFilter } = beans;
    if (useUnapplied && !gos.get("enableFilterHandlers")) {
        $437b23f6a393c3bf$export$545083624300f13d(288);
        useUnapplied = false;
    }
    const column = colModel.getColDefCol(key);
    return column ? colFilter?.getModelForColumn(column, useUnapplied) ?? null : null;
}
function $437b23f6a393c3bf$var$setColumnFilterModel(beans, column, model) {
    return beans.filterManager?.setColumnFilterModel(column, model) ?? Promise.resolve();
}
function $437b23f6a393c3bf$var$showColumnFilter(beans, colKey) {
    const column = beans.colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$a20c7248650823a9(12, {
            colKey: colKey
        });
        return;
    }
    beans.menuSvc?.showFilterMenu({
        column: column,
        containerType: "columnFilter",
        positionBy: "auto"
    });
}
function $437b23f6a393c3bf$var$hideColumnFilter(beans) {
    beans.menuSvc?.hideFilterMenu();
}
function $437b23f6a393c3bf$var$getColumnFilterHandler(beans, colKey) {
    const column = beans.colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$a20c7248650823a9(12, {
            colKey: colKey
        });
        return void 0;
    }
    return beans.colFilter?.getHandler(column, true);
}
function $437b23f6a393c3bf$var$doFilterAction(beans, params) {
    const { colModel: colModel, colFilter: colFilter, gos: gos } = beans;
    if (!gos.get("enableFilterHandlers")) {
        $437b23f6a393c3bf$export$545083624300f13d(287);
        return;
    }
    const { colId: colId, action: action } = params;
    if (colId) {
        const column = colModel.getColById(colId);
        if (column) colFilter?.updateModel(column, action);
    } else colFilter?.updateAllModels(action);
}
// packages/ag-grid-community/src/filter/columnFilterService.ts
var $437b23f6a393c3bf$var$DUMMY_HANDLER = {
    filterHandler: ()=>({
            doesFilterPass: ()=>true
        })
};
var $437b23f6a393c3bf$var$ColumnFilterService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colFilter";
        this.allColumnFilters = /* @__PURE__ */ new Map();
        this.allColumnListeners = /* @__PURE__ */ new Map();
        this.activeAggregateFilters = [];
        this.activeColumnFilters = [];
        // this is true when the grid is processing the filter change. this is used by the cell comps, so that they
        // don't flash when data changes due to filter changes. there is no need to flash when filter changes as the
        // user is in control, so doesn't make sense to show flashing changes. for example, go to main demo where
        // this feature is turned off (hack code to always return false for isSuppressFlashingCellsBecauseFiltering(), put in)
        // 100,000 rows and group by country. then do some filtering. all the cells flash, which is silly.
        this.processingFilterChange = false;
        // when we're waiting for cell data types to be inferred, we need to defer filter model updates
        this.modelUpdates = [];
        this.columnModelUpdates = [];
        /** This contains the UI state for handler columns */ this.state = /* @__PURE__ */ new Map();
        this.handlerMap = {
            ...$437b23f6a393c3bf$var$FILTER_HANDLER_MAP
        };
        this.isGlobalButtons = false;
        this.activeFilterComps = /* @__PURE__ */ new Set();
    }
    postConstruct() {
        this.addManagedEventListeners({
            gridColumnsChanged: this.onColumnsChanged.bind(this),
            dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
        });
        const gos = this.gos;
        const initialFilterModel = {
            ...gos.get("initialState")?.filter?.filterModel ?? {}
        };
        this.initialModel = initialFilterModel;
        this.model = {
            ...initialFilterModel
        };
        if (!gos.get("enableFilterHandlers")) delete this.handlerMap["agMultiColumnFilter"];
    }
    refreshModel() {
        this.onNewRowsLoaded("rowDataUpdated");
    }
    setModel(model, source = "api", forceUpdateActive) {
        const { colModel: colModel, dataTypeSvc: dataTypeSvc, filterManager: filterManager } = this.beans;
        if (dataTypeSvc?.isPendingInference) {
            this.modelUpdates.push({
                model: model,
                source: source
            });
            return;
        }
        const allPromises = [];
        const previousModel = this.getModel(true);
        if (model) {
            const modelKeys = new Set(Object.keys(model));
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const newModel = model[colId];
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper, newModel));
                modelKeys.delete(colId);
            });
            modelKeys.forEach((colId)=>{
                const column = colModel.getColDefCol(colId) || colModel.getCol(colId);
                if (!column) {
                    $437b23f6a393c3bf$export$545083624300f13d(62, {
                        colId: colId
                    });
                    return;
                }
                if (!column.isFilterAllowed()) {
                    $437b23f6a393c3bf$export$545083624300f13d(63, {
                        colId: colId
                    });
                    return;
                }
                const filterWrapper = this.getOrCreateFilterWrapper(column, true);
                if (!filterWrapper) {
                    $437b23f6a393c3bf$export$545083624300f13d(64, {
                        colId: colId
                    });
                    return;
                }
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper, model[colId], true));
            });
        } else {
            this.model = {};
            this.allColumnFilters.forEach((filterWrapper)=>{
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper, null));
            });
        }
        $437b23f6a393c3bf$export$30ec7836a4847721.all(allPromises).then(()=>{
            const currentModel = this.getModel(true);
            const columns = [];
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const before = previousModel ? previousModel[colId] : null;
                const after = currentModel ? currentModel[colId] : null;
                if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(before, after)) columns.push(filterWrapper.column);
            });
            if (columns.length > 0) filterManager?.onFilterChanged({
                columns: columns,
                source: source
            });
            else if (forceUpdateActive) this.updateActive("filterChanged");
        });
    }
    getModel(excludeInitialState) {
        const result = {};
        const { allColumnFilters: allColumnFilters, initialModel: initialModel, beans: { colModel: colModel } } = this;
        allColumnFilters.forEach((filterWrapper, key)=>{
            const model = this.getModelFromFilterWrapper(filterWrapper);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(model)) result[key] = model;
        });
        if (!excludeInitialState) for (const colId of Object.keys(initialModel)){
            const model = initialModel[colId];
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(model) && !allColumnFilters.has(colId) && colModel.getCol(colId)?.isFilterAllowed()) result[colId] = model;
        }
        return result;
    }
    setState(model, state, source = "api") {
        this.state.clear();
        if (state) for (const colId of Object.keys(state)){
            const newState = state[colId];
            this.state.set(colId, {
                model: $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId),
                state: newState
            });
        }
        this.setModel(model, source, true);
    }
    getState() {
        const state = this.state;
        if (!state.size) return void 0;
        const newState = {};
        let hasNewState = false;
        state.forEach((colState, colId)=>{
            const actualState = colState.state;
            if (actualState != null) {
                hasNewState = true;
                newState[colId] = actualState;
            }
        });
        return hasNewState ? newState : void 0;
    }
    getModelFromFilterWrapper(filterWrapper) {
        const column = filterWrapper.column;
        const colId = column.getColId();
        if (filterWrapper.isHandler) return $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
        const filter = filterWrapper.filter;
        if (filter) {
            if (typeof filter.getModel !== "function") {
                $437b23f6a393c3bf$export$545083624300f13d(66);
                return null;
            }
            return filter.getModel();
        }
        return $437b23f6a393c3bf$export$8981db65da4532f2(this.initialModel, colId);
    }
    isFilterPresent() {
        return this.activeColumnFilters.length > 0;
    }
    isAggFilterPresent() {
        return !!this.activeAggregateFilters.length;
    }
    disableFilters() {
        this.initialModel = {};
        const { allColumnFilters: allColumnFilters } = this;
        if (allColumnFilters.size) {
            allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "advancedFilterEnabled"));
            return true;
        }
        return false;
    }
    updateActiveFilters() {
        const isFilterActive = (filter)=>{
            if (!filter) return false;
            if (!filter.isFilterActive) {
                $437b23f6a393c3bf$export$545083624300f13d(67);
                return false;
            }
            return filter.isFilterActive();
        };
        const { colModel: colModel, gos: gos } = this.beans;
        const groupFilterEnabled = !!$437b23f6a393c3bf$export$3708afee0330994(gos);
        const isAggFilter = (column)=>{
            const isSecondary = !column.isPrimary();
            if (isSecondary) return true;
            const isShowingPrimaryColumns = !colModel.isPivotActive();
            const isValueActive = column.isValueActive();
            if (!isValueActive || !isShowingPrimaryColumns) return false;
            if (colModel.isPivotMode()) return true;
            return groupFilterEnabled;
        };
        const activeAggregateFilters = [];
        const activeColumnFilters = [];
        const addFilter = (column, filterActive, doesFilterPassWrapper)=>{
            if (filterActive) {
                if (isAggFilter(column)) activeAggregateFilters.push(doesFilterPassWrapper);
                else activeColumnFilters.push(doesFilterPassWrapper);
            }
        };
        const promises = [];
        this.allColumnFilters.forEach((filterWrapper)=>{
            const column = filterWrapper.column;
            const colId = column.getColId();
            if (filterWrapper.isHandler) promises.push($437b23f6a393c3bf$export$30ec7836a4847721.resolve().then(()=>{
                addFilter(column, this.isHandlerActive(column), {
                    colId: colId,
                    isHandler: true,
                    handler: filterWrapper.handler,
                    handlerParams: filterWrapper.handlerParams
                });
            }));
            else {
                const promise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
                if (promise) promises.push(promise.then((filter)=>{
                    addFilter(column, isFilterActive(filter), {
                        colId: colId,
                        isHandler: false,
                        comp: filter
                    });
                }));
            }
        });
        return $437b23f6a393c3bf$export$30ec7836a4847721.all(promises).then(()=>{
            this.activeAggregateFilters = activeAggregateFilters;
            this.activeColumnFilters = activeColumnFilters;
        });
    }
    updateFilterFlagInColumns(source, additionalEventAttributes) {
        const promises = [];
        this.allColumnFilters.forEach((filterWrapper)=>{
            const column = filterWrapper.column;
            if (filterWrapper.isHandler) promises.push($437b23f6a393c3bf$export$30ec7836a4847721.resolve().then(()=>{
                this.setColFilterActive(column, this.isHandlerActive(column), source, additionalEventAttributes);
            }));
            else {
                const promise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
                if (promise) promises.push(promise.then((filter)=>{
                    this.setColFilterActive(column, filter.isFilterActive(), source, additionalEventAttributes);
                }));
            }
        });
        this.beans.groupFilter?.updateFilterFlags(source, additionalEventAttributes);
        return $437b23f6a393c3bf$export$30ec7836a4847721.all(promises);
    }
    doFiltersPass(node, colIdToSkip, targetAggregates) {
        const { data: data, aggData: aggData } = node;
        const targetedFilters = targetAggregates ? this.activeAggregateFilters : this.activeColumnFilters;
        const targetedData = targetAggregates ? aggData : data;
        const model = this.model;
        for(let i = 0; i < targetedFilters.length; i++){
            const filter = targetedFilters[i];
            const { colId: colId, isHandler: isHandler } = filter;
            if (colId === colIdToSkip) continue;
            if (isHandler) {
                const { handler: handler, handlerParams: handlerParams } = filter;
                if (!handler.doesFilterPass({
                    node: node,
                    data: targetedData,
                    model: $437b23f6a393c3bf$export$8981db65da4532f2(model, colId),
                    handlerParams: handlerParams
                })) return false;
            } else {
                const comp = filter.comp;
                if (typeof comp.doesFilterPass !== "function") {
                    $437b23f6a393c3bf$export$a20c7248650823a9(91);
                    continue;
                }
                if (!comp.doesFilterPass({
                    node: node,
                    data: targetedData
                })) return false;
            }
        }
        return true;
    }
    getHandlerParams(column) {
        const wrapper = this.allColumnFilters.get(column.getColId());
        return wrapper?.isHandler ? wrapper.handlerParams : void 0;
    }
    // sometimes (especially in React) the filter can call onFilterChanged when we are in the middle
    // of a render cycle. this would be bad, so we wait for render cycle to complete when this happens.
    // this happens in react when we change React State in the grid (eg setting RowCtrl's in RowContainer)
    // which results in React State getting applied in the main application, triggering a useEffect() to
    // be kicked off adn then the application calling the grid's API. in AG-6554, the custom filter was
    // getting it's useEffect() triggered in this way.
    callOnFilterChangedOutsideRenderCycle(params) {
        const { rowRenderer: rowRenderer, filterManager: filterManager } = this.beans;
        const action = ()=>{
            if (this.isAlive()) filterManager?.onFilterChanged(params);
        };
        if (rowRenderer.isRefreshInProgress()) setTimeout(action, 0);
        else action();
    }
    updateBeforeFilterChanged(params = {}) {
        const { column: column, additionalEventAttributes: additionalEventAttributes } = params;
        const colId = column?.getColId();
        return this.updateActiveFilters().then(()=>this.updateFilterFlagInColumns("filterChanged", additionalEventAttributes).then(()=>{
                this.allColumnFilters.forEach((filterWrapper)=>{
                    const { column: filterColumn, isHandler: isHandler } = filterWrapper;
                    if (colId === filterColumn.getColId()) return;
                    if (isHandler) filterWrapper.handler.onAnyFilterChanged?.();
                    $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, isHandler)?.then((filter)=>{
                        if (typeof filter?.onAnyFilterChanged === "function") filter.onAnyFilterChanged();
                    });
                });
                this.processingFilterChange = true;
            }));
    }
    updateAfterFilterChanged() {
        this.processingFilterChange = false;
    }
    isSuppressFlashingCellsBecauseFiltering() {
        const allowShowChangeAfterFilter = this.gos.get("allowShowChangeAfterFilter") ?? false;
        return !allowShowChangeAfterFilter && this.processingFilterChange;
    }
    onNewRowsLoaded(source) {
        const promises = [];
        this.allColumnFilters.forEach((filterWrapper)=>{
            const isHandler = filterWrapper.isHandler;
            if (isHandler) filterWrapper.handler.onNewRowsLoaded?.();
            const promise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, isHandler);
            if (promise) promises.push(promise.then((filter)=>{
                filter.onNewRowsLoaded?.();
            }));
        });
        $437b23f6a393c3bf$export$30ec7836a4847721.all(promises).then(()=>this.updateActive(source, {
                afterDataChange: true
            }));
    }
    updateActive(source, additionalEventAttributes) {
        this.updateFilterFlagInColumns(source, additionalEventAttributes).then(()=>this.updateActiveFilters());
    }
    createGetValue(filterColumn, filterValueGetterOverride) {
        const { filterValueSvc: filterValueSvc, colModel: colModel } = this.beans;
        return (rowNode, column)=>{
            const columnToUse = column ? colModel.getCol(column) : filterColumn;
            return columnToUse ? filterValueSvc.getValue(columnToUse, rowNode, filterValueGetterOverride) : void 0;
        };
    }
    isFilterActive(column) {
        const filterWrapper = this.cachedFilter(column);
        if (filterWrapper?.isHandler) return this.isHandlerActive(column);
        const filter = filterWrapper?.filter;
        if (filter) return filter.isFilterActive();
        return $437b23f6a393c3bf$export$8981db65da4532f2(this.initialModel, column.getColId()) != null;
    }
    isHandlerActive(column) {
        const active = $437b23f6a393c3bf$export$25d27f17d3af40f7($437b23f6a393c3bf$export$8981db65da4532f2(this.model, column.getColId()));
        if (active) return active;
        const groupFilter = this.beans.groupFilter;
        return groupFilter?.isGroupFilter(column) ? groupFilter.isFilterActive(column) : false;
    }
    getOrCreateFilterUi(column) {
        const filterWrapper = this.getOrCreateFilterWrapper(column, true);
        return filterWrapper ? $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper) : null;
    }
    getFilterUiForDisplay(column) {
        const filterWrapper = this.getOrCreateFilterWrapper(column, true);
        if (!filterWrapper) return null;
        const compPromise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
        if (!compPromise) return null;
        return compPromise.then((comp)=>({
                comp: comp,
                params: filterWrapper.filterUi.filterParams,
                isHandler: filterWrapper.isHandler
            }));
    }
    getHandler(column, createIfMissing) {
        const filterWrapper = this.getOrCreateFilterWrapper(column, createIfMissing);
        return filterWrapper?.isHandler ? filterWrapper.handler : void 0;
    }
    getOrCreateFilterWrapper(column, createIfMissing) {
        if (!column.isFilterAllowed()) return void 0;
        let filterWrapper = this.cachedFilter(column);
        if (!filterWrapper && createIfMissing) {
            filterWrapper = this.createFilterWrapper(column);
            this.setColumnFilterWrapper(column, filterWrapper);
        }
        return filterWrapper;
    }
    cachedFilter(column) {
        return this.allColumnFilters.get(column.getColId());
    }
    getDefaultFilter(column, isFloating = false) {
        return this.getDefaultFilterFromDataType(()=>this.beans.dataTypeSvc?.getBaseDataType(column), isFloating);
    }
    getDefaultFilterFromDataType(getCellDataType, isFloating = false) {
        if ($437b23f6a393c3bf$export$b68e6345dc6b83fa(this.gos)) return isFloating ? "agSetColumnFloatingFilter" : "agSetColumnFilter";
        return $437b23f6a393c3bf$export$4a4e3cf6acc7e93(getCellDataType(), isFloating);
    }
    getDefaultFloatingFilter(column) {
        return this.getDefaultFilter(column, true);
    }
    createFilterComp(column, filterDef, defaultFilter, getFilterParams, isHandler, source) {
        const createFilterCompDetails = ()=>{
            const params = this.createFilterCompParams(column, isHandler, source);
            const updatedParams = getFilterParams(params, isHandler);
            return $437b23f6a393c3bf$export$e6db9a2d59456da0(this.beans.userCompFactory, filterDef, updatedParams, defaultFilter);
        };
        const compDetails = createFilterCompDetails();
        if (!compDetails) return null;
        const createFilterUi = (update)=>{
            return (update ? createFilterCompDetails() : compDetails).newAgStackInstance();
        };
        return {
            compDetails: compDetails,
            createFilterUi: createFilterUi
        };
    }
    createFilterInstance(column, filterDef, defaultFilter, getFilterParams) {
        const selectableFilter = this.beans.selectableFilter;
        if (selectableFilter?.isSelectable(filterDef)) filterDef = selectableFilter.getFilterDef(column, filterDef);
        const { handler: handler, handlerParams: handlerParams, handlerGenerator: handlerGenerator } = this.createHandler(column, filterDef, defaultFilter) ?? {};
        const filterCompDetails = this.createFilterComp(column, filterDef, defaultFilter, getFilterParams, !!handler, "init");
        if (!filterCompDetails) return {
            compDetails: null,
            createFilterUi: null,
            handler: handler,
            handlerGenerator: handlerGenerator,
            handlerParams: handlerParams
        };
        const { compDetails: compDetails, createFilterUi: createFilterUi } = filterCompDetails;
        if (this.isGlobalButtons) {
            const hasLocalButtons = !!compDetails.params?.buttons?.length;
            if (!hasLocalButtons) $437b23f6a393c3bf$export$545083624300f13d(281, {
                colId: column.getColId()
            });
        }
        return {
            compDetails: compDetails,
            handler: handler,
            handlerGenerator: handlerGenerator,
            handlerParams: handlerParams,
            createFilterUi: createFilterUi
        };
    }
    createBaseFilterParams(column, forFloatingFilter) {
        const { filterManager: filterManager, rowModel: rowModel } = this.beans;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column,
            colDef: column.getColDef(),
            getValue: this.createGetValue(column),
            doesRowPassOtherFilter: forFloatingFilter ? ()=>true : (node)=>filterManager?.doesRowPassOtherFilters(column.getColId(), node) ?? true,
            rowModel: // to avoid breaking changes to `filterParams` defined as functions
            // we need to provide the below options even though they are not valid for handlers
            rowModel
        });
    }
    createFilterCompParams(column, useHandler, source, forFloatingFilter) {
        const filterChangedCallback = this.filterChangedCallbackFactory(column);
        const params = this.createBaseFilterParams(column, forFloatingFilter);
        params.filterChangedCallback = filterChangedCallback;
        params.filterModifiedCallback = forFloatingFilter ? ()=>{} : (additionalEventAttributes)=>this.filterModified(column, additionalEventAttributes);
        if (useHandler) {
            const displayParams = params;
            const colId = column.getColId();
            const model = $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
            displayParams.model = model;
            displayParams.state = this.state.get(colId) ?? {
                model: model
            };
            displayParams.onModelChange = (model2, additionalEventAttributes)=>{
                this.updateStoredModel(colId, model2);
                this.refreshHandlerAndUi(column, model2, "ui", false, additionalEventAttributes).then(()=>{
                    filterChangedCallback({
                        ...additionalEventAttributes,
                        source: "columnFilter"
                    });
                });
            };
            displayParams.onStateChange = (state)=>{
                this.updateState(column, state);
                this.updateOrRefreshFilterUi(column);
            };
            displayParams.onAction = (action, additionalEventAttributes, event)=>{
                this.updateModel(column, action, additionalEventAttributes);
                this.dispatchLocalEvent({
                    type: "filterAction",
                    column: column,
                    action: action,
                    event: event
                });
            };
            displayParams.getHandler = ()=>this.getHandler(column, true);
            displayParams.onUiChange = (additionalEventAttributes)=>this.filterUiChanged(column, additionalEventAttributes);
            displayParams.source = source;
        }
        return params;
    }
    createFilterUiForHandler(compDetails, createFilterUi) {
        return createFilterUi ? {
            created: false,
            create: createFilterUi,
            filterParams: compDetails.params,
            compDetails: compDetails
        } : null;
    }
    createFilterUiLegacy(compDetails, createFilterUi, updateInstanceCallback) {
        const promise = createFilterUi();
        const filterUi = {
            created: true,
            create: createFilterUi,
            filterParams: compDetails.params,
            compDetails: compDetails,
            promise: promise
        };
        promise.then(updateInstanceCallback);
        return filterUi;
    }
    createFilterWrapper(column) {
        const { compDetails: compDetails, handler: handler, handlerGenerator: handlerGenerator, handlerParams: handlerParams, createFilterUi: createFilterUi } = this.createFilterInstance(column, column.getColDef(), this.getDefaultFilter(column), (params)=>params);
        const colId = column.getColId();
        if (handler) {
            delete this.initialModel[colId];
            handler.init?.({
                ...handlerParams,
                source: "init",
                model: $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId)
            });
            return {
                column: column,
                isHandler: true,
                handler: handler,
                handlerGenerator: handlerGenerator,
                handlerParams: handlerParams,
                filterUi: this.createFilterUiForHandler(compDetails, createFilterUi)
            };
        }
        if (createFilterUi) {
            const filterWrapper = {
                column: column,
                filterUi: null,
                isHandler: false
            };
            filterWrapper.filterUi = this.createFilterUiLegacy(compDetails, createFilterUi, (filterComp)=>{
                filterWrapper.filter = filterComp ?? void 0;
            });
            return filterWrapper;
        }
        return {
            column: column,
            filterUi: null,
            isHandler: false
        };
    }
    createHandlerFunc(column, filterDef, defaultFilter) {
        const { gos: gos, frameworkOverrides: frameworkOverrides, registry: registry } = this.beans;
        let doesFilterPass;
        const getFilterHandlerFromDef = (filterDef2)=>{
            const filter = filterDef2.filter;
            if ($437b23f6a393c3bf$var$isColumnFilterComp(filter)) {
                const handler = filter.handler;
                if (handler) return handler;
                doesFilterPass = filter.doesFilterPass;
                if (doesFilterPass) return ()=>({
                        doesFilterPass: doesFilterPass
                    });
                return void 0;
            }
            return typeof filter === "string" ? filter : void 0;
        };
        const enableFilterHandlers = gos.get("enableFilterHandlers");
        const providedFilterHandler = enableFilterHandlers ? getFilterHandlerFromDef(filterDef) : void 0;
        const resolveProvidedFilterHandler = (handlerName2)=>()=>this.createBean(registry.createDynamicBean(handlerName2, true));
        let filterHandler;
        let handlerName;
        if (typeof providedFilterHandler === "string") {
            const userFilterHandler = gos.get("filterHandlers")?.[providedFilterHandler];
            if (userFilterHandler != null) filterHandler = userFilterHandler;
            else if ($437b23f6a393c3bf$var$FILTER_HANDLERS.has(providedFilterHandler)) {
                filterHandler = resolveProvidedFilterHandler(providedFilterHandler);
                handlerName = providedFilterHandler;
            }
        } else filterHandler = providedFilterHandler;
        if (!filterHandler) {
            let filterName;
            const { compName: compName, jsComp: jsComp, fwComp: fwComp } = $437b23f6a393c3bf$var$_getFilterCompKeys(frameworkOverrides, filterDef);
            if (compName) filterName = compName;
            else {
                const usingDefaultFilter = jsComp == null && fwComp == null && filterDef.filter === true;
                if (usingDefaultFilter) filterName = defaultFilter;
            }
            handlerName = this.handlerMap[filterName];
            if (handlerName) filterHandler = resolveProvidedFilterHandler(handlerName);
        }
        if (!filterHandler) {
            if (!enableFilterHandlers) return void 0;
            if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos)) $437b23f6a393c3bf$export$545083624300f13d(277, {
                colId: column.getColId()
            });
            return $437b23f6a393c3bf$var$DUMMY_HANDLER;
        }
        return {
            filterHandler: filterHandler,
            handlerNameOrCallback: doesFilterPass ?? handlerName
        };
    }
    createHandler(column, filterDef, defaultFilter) {
        const handlerFunc = this.createHandlerFunc(column, filterDef, defaultFilter);
        if (!handlerFunc) return void 0;
        const filterParams = $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(this.beans.userCompFactory, filterDef, this.createFilterCompParams(column, true, "init"));
        const { handlerNameOrCallback: handlerNameOrCallback, filterHandler: filterHandler } = handlerFunc;
        const { handler: handler, handlerParams: handlerParams } = this.createHandlerFromFunc(column, filterHandler, filterParams);
        return {
            handler: handler,
            handlerParams: handlerParams,
            handlerGenerator: handlerNameOrCallback ?? filterHandler
        };
    }
    createHandlerFromFunc(column, filterHandler, filterParams) {
        const colDef = column.getColDef();
        const handler = filterHandler($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column,
            colDef: colDef
        }));
        const handlerParams = this.createHandlerParams(column, filterParams);
        return {
            handler: handler,
            handlerParams: handlerParams
        };
    }
    createHandlerParams(column, filterParams) {
        const colDef = column.getColDef();
        const colId = column.getColId();
        const filterChangedCallback = this.filterChangedCallbackFactory(column);
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            colDef: colDef,
            column: column,
            getValue: this.createGetValue(column),
            doesRowPassOtherFilter: (node)=>this.beans.filterManager?.doesRowPassOtherFilters(colId, node) ?? true,
            onModelChange: (newModel, additionalEventAttributes)=>{
                this.updateStoredModel(colId, newModel);
                this.refreshHandlerAndUi(column, newModel, "handler", false, additionalEventAttributes).then(()=>{
                    filterChangedCallback({
                        ...additionalEventAttributes,
                        source: "columnFilter"
                    });
                });
            },
            filterParams: filterParams
        });
    }
    onColumnsChanged() {
        const columns = [];
        const { colModel: colModel, filterManager: filterManager, groupFilter: groupFilter } = this.beans;
        this.allColumnFilters.forEach((wrapper, colId)=>{
            let currentColumn;
            if (wrapper.column.isPrimary()) currentColumn = colModel.getColDefCol(colId);
            else currentColumn = colModel.getCol(colId);
            if (currentColumn && currentColumn === wrapper.column) return;
            columns.push(wrapper.column);
            this.disposeFilterWrapper(wrapper, "columnChanged");
            this.disposeColumnListener(colId);
        });
        const allFiltersAreGroupFilters = groupFilter && columns.every((col)=>groupFilter.isGroupFilter(col));
        if (columns.length > 0 && !allFiltersAreGroupFilters) filterManager?.onFilterChanged({
            columns: columns,
            source: "api"
        });
    }
    isFilterAllowed(column) {
        const isFilterAllowed = column.isFilterAllowed();
        if (!isFilterAllowed) return false;
        const groupFilter = this.beans.groupFilter;
        if (groupFilter?.isGroupFilter(column)) return groupFilter.isFilterAllowed(column);
        return true;
    }
    getFloatingFilterCompDetails(column, showParentFilter) {
        const { userCompFactory: userCompFactory, frameworkOverrides: frameworkOverrides, selectableFilter: selectableFilter, gos: gos } = this.beans;
        const parentFilterInstance = (callback)=>{
            const filterComponent = this.getOrCreateFilterUi(column);
            filterComponent?.then((instance)=>{
                callback($437b23f6a393c3bf$export$213d4c63c3df47e4(instance));
            });
        };
        const colDef = column.getColDef();
        const filterDef = selectableFilter?.isSelectable(colDef) ? selectableFilter.getFilterDef(column, colDef) : colDef;
        const defaultFloatingFilterType = $437b23f6a393c3bf$export$47072b32bdaf5d61(frameworkOverrides, filterDef, ()=>this.getDefaultFloatingFilter(column)) ?? "agReadOnlyFloatingFilter";
        const isReactive = gos.get("enableFilterHandlers");
        const filterParams = $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(userCompFactory, filterDef, this.createFilterCompParams(column, isReactive, "init", true));
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            column: column,
            filterParams: filterParams,
            currentParentModel: ()=>this.getCurrentFloatingFilterParentModel(column),
            parentFilterInstance: parentFilterInstance,
            showParentFilter: showParentFilter
        });
        if (isReactive) {
            const displayParams = params;
            const colId = column.getColId();
            const filterChangedCallback = this.filterChangedCallbackFactory(column);
            displayParams.onUiChange = (additionalEventAttributes)=>this.floatingFilterUiChanged(column, additionalEventAttributes);
            displayParams.model = $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
            displayParams.onModelChange = (model, additionalEventAttributes)=>{
                this.updateStoredModel(colId, model);
                this.refreshHandlerAndUi(column, model, "floating", true, additionalEventAttributes).then(()=>{
                    filterChangedCallback({
                        ...additionalEventAttributes,
                        source: "columnFilter"
                    });
                });
            };
            displayParams.getHandler = ()=>this.getHandler(column, true);
            displayParams.source = "init";
        }
        return $437b23f6a393c3bf$export$14d0998f093f007e(userCompFactory, colDef, params, defaultFloatingFilterType);
    }
    getCurrentFloatingFilterParentModel(column) {
        return this.getModelFromFilterWrapper(this.cachedFilter(column) ?? {
            column: column
        });
    }
    destroyFilterUi(filterWrapper, column, compDetails, createFilterUi) {
        const source = "paramsUpdated";
        if (filterWrapper.isHandler) {
            const colId = column.getColId();
            delete this.initialModel[colId];
            this.state.delete(colId);
            const filterUi = filterWrapper.filterUi;
            const newFilterUi = this.createFilterUiForHandler(compDetails, createFilterUi);
            filterWrapper.filterUi = newFilterUi;
            const eventSvc = this.eventSvc;
            if (filterUi?.created) filterUi.promise.then((filter)=>{
                this.destroyBean(filter);
                eventSvc.dispatchEvent({
                    type: "filterDestroyed",
                    source: source,
                    column: column
                });
            });
            else eventSvc.dispatchEvent({
                type: "filterHandlerDestroyed",
                source: source,
                column: column
            });
        } else this.destroyFilter(column, source);
    }
    // destroys the filter, so it no longer takes part
    destroyFilter(column, source = "api") {
        const colId = column.getColId();
        const filterWrapper = this.allColumnFilters.get(colId);
        this.disposeColumnListener(colId);
        delete this.initialModel[colId];
        if (filterWrapper) this.disposeFilterWrapper(filterWrapper, source).then((wasActive)=>{
            if (wasActive && this.isAlive()) this.beans.filterManager?.onFilterChanged({
                columns: [
                    column
                ],
                source: "api"
            });
        });
    }
    disposeColumnListener(colId) {
        const columnListener = this.allColumnListeners.get(colId);
        if (columnListener) {
            this.allColumnListeners.delete(colId);
            columnListener();
        }
    }
    disposeFilterWrapper(filterWrapper, source) {
        let isActive = false;
        const { column: column, isHandler: isHandler, filterUi: filterUi } = filterWrapper;
        const colId = column.getColId();
        if (isHandler) {
            isActive = this.isHandlerActive(column);
            this.destroyBean(filterWrapper.handler);
            delete this.model[colId];
            this.state.delete(colId);
        }
        const removeFilter = ()=>{
            this.setColFilterActive(column, false, "filterDestroyed");
            this.allColumnFilters.delete(colId);
            this.eventSvc.dispatchEvent({
                type: "filterDestroyed",
                source: source,
                column: column
            });
        };
        if (filterUi) {
            if (filterUi.created) return filterUi.promise.then((filter)=>{
                isActive = isHandler ? isActive : !!filter?.isFilterActive();
                this.destroyBean(filter);
                removeFilter();
                return isActive;
            });
            else removeFilter();
        }
        return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(isActive);
    }
    filterChangedCallbackFactory(column) {
        return (additionalEventAttributes)=>{
            this.callOnFilterChangedOutsideRenderCycle({
                additionalEventAttributes: additionalEventAttributes,
                columns: [
                    column
                ],
                column: column,
                source: additionalEventAttributes?.source ?? "columnFilter"
            });
        };
    }
    filterParamsChanged(colId, source = "api") {
        const filterWrapper = this.allColumnFilters.get(colId);
        if (!filterWrapper) return;
        const beans = this.beans;
        const column = filterWrapper.column;
        const colDef = column.getColDef();
        const isFilterAllowed = column.isFilterAllowed();
        const defaultFilter = this.getDefaultFilter(column);
        const selectableFilter = beans.selectableFilter;
        const filterDef = selectableFilter?.isSelectable(colDef) ? selectableFilter.getFilterDef(column, colDef) : colDef;
        const handlerFunc = isFilterAllowed ? this.createHandlerFunc(column, filterDef, this.getDefaultFilter(column)) : void 0;
        const isHandler = !!handlerFunc;
        const wasHandler = filterWrapper.isHandler;
        if (wasHandler != isHandler) {
            this.destroyFilter(column, "paramsUpdated");
            return;
        }
        const { compDetails: compDetails, createFilterUi: createFilterUi } = (isFilterAllowed ? this.createFilterComp(column, filterDef, defaultFilter, (params)=>params, isHandler, "colDef") : null) ?? {
            compDetails: null,
            createFilterUi: null
        };
        const newFilterParams = compDetails?.params ?? $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(beans.userCompFactory, filterDef, this.createFilterCompParams(column, isHandler, "colDef"));
        if (wasHandler) {
            const handlerGenerator = handlerFunc?.handlerNameOrCallback ?? handlerFunc?.filterHandler;
            const existingModel = $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId);
            if (filterWrapper.handlerGenerator != handlerGenerator) {
                const oldHandler = filterWrapper.handler;
                const { handler: handler, handlerParams: handlerParams } = this.createHandlerFromFunc(column, handlerFunc.filterHandler, newFilterParams);
                filterWrapper.handler = handler;
                filterWrapper.handlerParams = handlerParams;
                filterWrapper.handlerGenerator = handlerGenerator;
                delete this.model[colId];
                handler.init?.({
                    ...handlerParams,
                    source: "init",
                    model: null
                });
                this.destroyBean(oldHandler);
                if (existingModel != null) this.beans.filterManager?.onFilterChanged({
                    columns: [
                        column
                    ],
                    source: source
                });
            } else {
                const handlerParams = this.createHandlerParams(column, compDetails?.params);
                filterWrapper.handlerParams = handlerParams;
                filterWrapper.handler.refresh?.({
                    ...handlerParams,
                    source: "colDef",
                    model: existingModel
                });
            }
        }
        if (this.areFilterCompsDifferent(filterWrapper.filterUi?.compDetails ?? null, compDetails) || !filterWrapper.filterUi || !compDetails) {
            this.destroyFilterUi(filterWrapper, column, compDetails, createFilterUi);
            return;
        }
        filterWrapper.filterUi.filterParams = newFilterParams;
        $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper, wasHandler)?.then((filter)=>{
            const shouldRefreshFilter = filter?.refresh ? filter.refresh(newFilterParams) : true;
            if (shouldRefreshFilter === false) this.destroyFilterUi(filterWrapper, column, compDetails, createFilterUi);
            else this.dispatchLocalEvent({
                type: "filterParamsChanged",
                column: column,
                params: newFilterParams
            });
        });
    }
    refreshHandlerAndUi(column, model, source, createIfMissing, additionalEventAttributes) {
        const filterWrapper = this.cachedFilter(column);
        if (!filterWrapper) {
            if (createIfMissing) this.getOrCreateFilterWrapper(column, true);
            return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
        }
        if (!filterWrapper.isHandler) return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
        const { filterUi: filterUi, handler: handler, handlerParams: handlerParams } = filterWrapper;
        return $437b23f6a393c3bf$export$1fc9ad198b29415d(()=>{
            if (filterUi) {
                const { created: created, filterParams: filterParams } = filterUi;
                if (created) return filterUi.promise.then((filter)=>{
                    return filter ? {
                        filter: filter,
                        filterParams: filterParams
                    } : void 0;
                });
                else filterUi.refreshed = true;
            }
            return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(void 0);
        }, handler, handlerParams, model, this.state.get(column.getColId()) ?? {
            model: model
        }, source, additionalEventAttributes);
    }
    setColumnFilterWrapper(column, filterWrapper) {
        const colId = column.getColId();
        this.allColumnFilters.set(colId, filterWrapper);
        this.allColumnListeners.set(colId, this.addManagedListeners(column, {
            colDefChanged: ()=>this.filterParamsChanged(colId)
        })[0]);
    }
    areFilterCompsDifferent(oldCompDetails, newCompDetails) {
        if (!newCompDetails || !oldCompDetails) return true;
        const { componentClass: oldComponentClass } = oldCompDetails;
        const { componentClass: newComponentClass } = newCompDetails;
        const isSameComponentClass = oldComponentClass === newComponentClass || // react hooks returns new wrappers, so check nested render method
        oldComponentClass?.render && newComponentClass?.render && oldComponentClass.render === newComponentClass.render;
        return !isSameComponentClass;
    }
    hasFloatingFilters() {
        const gridColumns = this.beans.colModel.getCols();
        return gridColumns.some((col)=>col.getColDef().floatingFilter);
    }
    getFilterInstance(key) {
        const column = this.beans.colModel.getColDefCol(key);
        if (!column) return Promise.resolve(void 0);
        const filterPromise = this.getOrCreateFilterUi(column);
        if (!filterPromise) return Promise.resolve(null);
        return new Promise((resolve)=>{
            filterPromise.then((filter)=>{
                resolve($437b23f6a393c3bf$export$213d4c63c3df47e4(filter));
            });
        });
    }
    processFilterModelUpdateQueue() {
        this.modelUpdates.forEach(({ model: model, source: source })=>this.setModel(model, source));
        this.modelUpdates = [];
        this.columnModelUpdates.forEach(({ key: key, model: model, resolve: resolve })=>{
            this.setModelForColumn(key, model).then(()=>resolve());
        });
        this.columnModelUpdates = [];
    }
    getModelForColumn(column, useUnapplied) {
        if (useUnapplied) {
            const { state: state, model: model } = this;
            const colId = column.getColId();
            const colState = state.get(colId);
            if (colState) return colState.model ?? null;
            return $437b23f6a393c3bf$export$8981db65da4532f2(model, colId);
        }
        const filterWrapper = this.cachedFilter(column);
        return filterWrapper ? this.getModelFromFilterWrapper(filterWrapper) : null;
    }
    setModelForColumn(key, model) {
        if (this.beans.dataTypeSvc?.isPendingInference) {
            let resolve = ()=>{};
            const promise = new Promise((res)=>{
                resolve = res;
            });
            this.columnModelUpdates.push({
                key: key,
                model: model,
                resolve: resolve
            });
            return promise;
        }
        return new Promise((resolve)=>{
            this.setModelForColumnLegacy(key, model).then((result)=>resolve(result));
        });
    }
    getStateForColumn(colId) {
        return this.state.get(colId) ?? {
            model: $437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId)
        };
    }
    setModelForColumnLegacy(key, model) {
        const column = this.beans.colModel.getColDefCol(key);
        const filterWrapper = column ? this.getOrCreateFilterWrapper(column, true) : null;
        return filterWrapper ? this.setModelOnFilterWrapper(filterWrapper, model) : $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    setColDefPropsForDataType(colDef, dataTypeDefinition, formatValue) {
        const providedFilter = colDef.filter;
        const filter = providedFilter === true ? this.getDefaultFilterFromDataType(()=>dataTypeDefinition.baseDataType) : providedFilter;
        if (typeof filter !== "string") return;
        let filterParams;
        let filterValueGetter;
        const beans = this.beans;
        const { filterParams: colDefFilterParams, filterValueGetter: colDefFilterValueGetter } = colDef;
        if (filter === "agMultiColumnFilter") ({ filterParams: filterParams, filterValueGetter: filterValueGetter } = beans.multiFilter?.getParamsForDataType(colDefFilterParams, colDefFilterValueGetter, dataTypeDefinition, formatValue) ?? {});
        else ({ filterParams: filterParams, filterValueGetter: filterValueGetter } = $437b23f6a393c3bf$export$4a99b58ce484acc(filter, colDefFilterParams, colDefFilterValueGetter, dataTypeDefinition, formatValue, beans, this.getLocaleTextFunc()));
        colDef.filterParams = filterParams;
        if (filterValueGetter) colDef.filterValueGetter = filterValueGetter;
    }
    // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
    setColFilterActive(column, active, source, additionalEventAttributes) {
        if (column.filterActive !== active) {
            column.filterActive = active;
            column.dispatchColEvent("filterActiveChanged", source);
        }
        column.dispatchColEvent("filterChanged", source, additionalEventAttributes);
    }
    setModelOnFilterWrapper(filterWrapper, newModel, justCreated) {
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            if (filterWrapper.isHandler) {
                const column = filterWrapper.column;
                const colId = column.getColId();
                const existingModel = this.model[colId];
                this.updateStoredModel(colId, newModel);
                if (justCreated && newModel === existingModel) {
                    resolve();
                    return;
                }
                this.refreshHandlerAndUi(column, newModel, "api").then(()=>resolve());
                return;
            }
            const uiPromise = $437b23f6a393c3bf$var$getFilterUiFromWrapper(filterWrapper);
            if (uiPromise) {
                uiPromise.then((filter)=>{
                    if (typeof filter?.setModel !== "function") {
                        $437b23f6a393c3bf$export$545083624300f13d(65);
                        resolve();
                        return;
                    }
                    (filter.setModel(newModel) || $437b23f6a393c3bf$export$30ec7836a4847721.resolve()).then(()=>resolve());
                });
                return;
            }
            resolve();
        });
    }
    /** for handlers only */ updateStoredModel(colId, model) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(model)) this.model[colId] = model;
        else delete this.model[colId];
        const oldState = this.state.get(colId);
        const newState = {
            model: model,
            state: oldState?.state
        };
        this.state.set(colId, newState);
    }
    filterModified(column, additionalEventAttributes) {
        this.getOrCreateFilterUi(column)?.then((filterInstance)=>{
            this.eventSvc.dispatchEvent({
                type: "filterModified",
                column: column,
                filterInstance: filterInstance,
                ...additionalEventAttributes
            });
        });
    }
    filterUiChanged(column, additionalEventAttributes) {
        if (this.gos.get("enableFilterHandlers")) this.eventSvc.dispatchEvent({
            type: "filterUiChanged",
            column: column,
            ...additionalEventAttributes
        });
    }
    floatingFilterUiChanged(column, additionalEventAttributes) {
        if (this.gos.get("enableFilterHandlers")) this.eventSvc.dispatchEvent({
            type: "floatingFilterUiChanged",
            column: column,
            ...additionalEventAttributes
        });
    }
    updateModel(column, action, additionalEventAttributes) {
        const colId = column.getColId();
        const filterWrapper = this.cachedFilter(column);
        const getFilterUi = ()=>filterWrapper?.filterUi;
        $437b23f6a393c3bf$export$3305e8c6f4c8572a({
            action: action,
            filterParams: filterWrapper?.filterUi?.filterParams,
            getFilterUi: getFilterUi,
            getModel: ()=>$437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId),
            getState: ()=>this.state.get(colId),
            updateState: (state)=>this.updateState(column, state),
            updateModel: (model)=>getFilterUi()?.filterParams?.onModelChange(model, {
                    ...additionalEventAttributes,
                    fromAction: action
                }),
            processModelToApply: filterWrapper?.isHandler ? filterWrapper.handler.processModelToApply?.bind(filterWrapper.handler) : void 0
        });
    }
    updateAllModels(action, additionalEventAttributes) {
        const promises = [];
        this.allColumnFilters.forEach((filter, colId)=>{
            const column = this.beans.colModel.getColDefCol(colId);
            if (column) $437b23f6a393c3bf$export$3305e8c6f4c8572a({
                action: action,
                filterParams: filter.filterUi?.filterParams,
                getFilterUi: ()=>filter.filterUi,
                getModel: ()=>$437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId),
                getState: ()=>this.state.get(colId),
                updateState: (state)=>this.updateState(column, state),
                updateModel: (model)=>{
                    this.updateStoredModel(colId, model);
                    this.dispatchLocalEvent({
                        type: "filterAction",
                        column: column,
                        action: action
                    });
                    promises.push(this.refreshHandlerAndUi(column, model, "ui"));
                },
                processModelToApply: filter?.isHandler ? filter.handler.processModelToApply?.bind(filter.handler) : void 0
            });
        });
        if (promises.length) $437b23f6a393c3bf$export$30ec7836a4847721.all(promises).then(()=>{
            this.callOnFilterChangedOutsideRenderCycle({
                source: "columnFilter",
                additionalEventAttributes: additionalEventAttributes,
                columns: []
            });
        });
    }
    updateOrRefreshFilterUi(column) {
        const colId = column.getColId();
        $437b23f6a393c3bf$var$getAndRefreshFilterUi(()=>this.cachedFilter(column)?.filterUi, ()=>$437b23f6a393c3bf$export$8981db65da4532f2(this.model, colId), ()=>this.state.get(colId));
    }
    updateState(column, state) {
        this.state.set(column.getColId(), state);
        this.dispatchLocalEvent({
            type: "filterStateChanged",
            column: column,
            state: state
        });
    }
    // for tool panel only
    canApplyAll() {
        const { state: state, model: model, activeFilterComps: activeFilterComps } = this;
        for (const comp of activeFilterComps){
            if (comp.source === "COLUMN_MENU") return false;
        }
        let hasChanges = false;
        for (const colId of state.keys()){
            const colState = state.get(colId);
            if (colState.valid === false) return false;
            if ((colState.model ?? null) !== $437b23f6a393c3bf$export$8981db65da4532f2(model, colId)) hasChanges = true;
        }
        return hasChanges;
    }
    hasUnappliedModel(colId) {
        const { model: model, state: state } = this;
        return (state.get(colId)?.model ?? null) !== $437b23f6a393c3bf$export$8981db65da4532f2(model, colId);
    }
    setGlobalButtons(isGlobal) {
        this.isGlobalButtons = isGlobal;
        this.dispatchLocalEvent({
            type: "filterGlobalButtons",
            isGlobal: isGlobal
        });
    }
    shouldKeepStateOnDetach(column, lastContainerType) {
        if (lastContainerType === "newFiltersToolPanel") return true;
        const filterPanelSvc = this.beans.filterPanelSvc;
        if (filterPanelSvc?.isActive) return !!filterPanelSvc.getState(column.getColId());
        return false;
    }
    destroy() {
        super.destroy();
        this.allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "gridDestroyed"));
        this.allColumnListeners.clear();
        this.state.clear();
        this.activeFilterComps.clear();
    }
};
// packages/ag-grid-community/src/filter/filterApi.ts
function $437b23f6a393c3bf$var$isAnyFilterPresent(beans) {
    return !!beans.filterManager?.isAnyFilterPresent();
}
function $437b23f6a393c3bf$var$onFilterChanged(beans, source = "api") {
    beans.filterManager?.onFilterChanged({
        source: source
    });
}
// packages/ag-grid-community/src/filter/filterManager.ts
var $437b23f6a393c3bf$var$FilterManager = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterManager";
        // when we're waiting for cell data types to be inferred, we need to defer filter model updates
        this.advFilterModelUpdateQueue = [];
    }
    wireBeans(beans) {
        this.quickFilter = beans.quickFilter;
        this.advancedFilter = beans.advancedFilter;
        this.colFilter = beans.colFilter;
    }
    postConstruct() {
        const refreshFiltersForAggregations = this.refreshFiltersForAggregations.bind(this);
        const updateAdvFilterColumns = this.updateAdvFilterColumns.bind(this);
        this.addManagedEventListeners({
            columnValueChanged: refreshFiltersForAggregations,
            columnPivotChanged: refreshFiltersForAggregations,
            columnPivotModeChanged: refreshFiltersForAggregations,
            newColumnsLoaded: updateAdvFilterColumns,
            columnVisible: updateAdvFilterColumns,
            advancedFilterEnabledChanged: ({ enabled: enabled })=>this.onAdvFilterEnabledChanged(enabled),
            dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
        });
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        this.addManagedPropertyListeners([
            "isExternalFilterPresent",
            "doesExternalFilterPass"
        ], ()=>{
            this.onFilterChanged({
                source: "api"
            });
        });
        this.updateAggFiltering();
        this.addManagedPropertyListener("groupAggFiltering", ()=>{
            this.updateAggFiltering();
            this.onFilterChanged();
        });
        if (this.quickFilter) this.addManagedListeners(this.quickFilter, {
            quickFilterChanged: ()=>this.onFilterChanged({
                    source: "quickFilter"
                })
        });
        const { gos: gos } = this;
        this.alwaysPassFilter = gos.get("alwaysPassFilter");
        this.addManagedPropertyListener("alwaysPassFilter", ()=>{
            this.alwaysPassFilter = gos.get("alwaysPassFilter");
            this.onFilterChanged({
                source: "api"
            });
        });
    }
    isExternalFilterPresentCallback() {
        const isFilterPresent = this.gos.getCallback("isExternalFilterPresent");
        return typeof isFilterPresent === "function" && isFilterPresent({});
    }
    doesExternalFilterPass(node) {
        const doesFilterPass = this.gos.get("doesExternalFilterPass");
        return typeof doesFilterPass === "function" && doesFilterPass(node);
    }
    setFilterState(model, state, source = "api") {
        if (this.isAdvFilterEnabled()) return;
        this.colFilter?.setState(model, state, source);
    }
    setFilterModel(model, source = "api", skipWarning) {
        if (this.isAdvFilterEnabled()) {
            if (!skipWarning) this.warnAdvFilters();
            return;
        }
        this.colFilter?.setModel(model, source);
    }
    getFilterModel() {
        return this.colFilter?.getModel() ?? {};
    }
    getFilterState() {
        return this.colFilter?.getState();
    }
    isColumnFilterPresent() {
        return !!this.colFilter?.isFilterPresent();
    }
    isAggregateFilterPresent() {
        return !!this.colFilter?.isAggFilterPresent();
    }
    isChildFilterPresent() {
        return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.externalFilterPresent || this.isAdvFilterPresent();
    }
    isAnyFilterPresent() {
        return this.isChildFilterPresent() || this.isAggregateFilterPresent();
    }
    isAdvFilterPresent() {
        return this.isAdvFilterEnabled() && this.advancedFilter.isFilterPresent();
    }
    onAdvFilterEnabledChanged(enabled) {
        if (enabled) {
            if (this.colFilter?.disableFilters()) this.onFilterChanged({
                source: "advancedFilter"
            });
        } else if (this.advancedFilter?.isFilterPresent()) {
            this.advancedFilter.setModel(null);
            this.onFilterChanged({
                source: "advancedFilter"
            });
        }
    }
    isAdvFilterEnabled() {
        return !!this.advancedFilter?.isEnabled();
    }
    isAdvFilterHeaderActive() {
        return this.isAdvFilterEnabled() && this.advancedFilter.isHeaderActive();
    }
    refreshFiltersForAggregations() {
        if ($437b23f6a393c3bf$export$3708afee0330994(this.gos) && this.isAnyFilterPresent()) this.onFilterChanged();
    }
    onFilterChanged(params = {}) {
        const { source: source, additionalEventAttributes: additionalEventAttributes, columns: columns = [] } = params;
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        (this.colFilter ? this.colFilter.updateBeforeFilterChanged(params) : $437b23f6a393c3bf$export$30ec7836a4847721.resolve()).then(()=>{
            const filterChangedEvent = {
                source: source,
                type: "filterChanged",
                columns: columns
            };
            if (additionalEventAttributes) $437b23f6a393c3bf$export$8ade6bd474fcde42(filterChangedEvent, additionalEventAttributes);
            this.eventSvc.dispatchEvent(filterChangedEvent);
            this.colFilter?.updateAfterFilterChanged();
        });
    }
    isSuppressFlashingCellsBecauseFiltering() {
        return !!this.colFilter?.isSuppressFlashingCellsBecauseFiltering();
    }
    isQuickFilterPresent() {
        return !!this.quickFilter?.isFilterPresent();
    }
    updateAggFiltering() {
        this.aggFiltering = !!$437b23f6a393c3bf$export$3708afee0330994(this.gos);
    }
    isAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
    }
    isNonAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
    }
    shouldApplyQuickFilterAfterAgg() {
        return (this.aggFiltering || this.beans.colModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
    }
    doesRowPassOtherFilters(colIdToSkip, rowNode) {
        return this.doesRowPassFilter({
            rowNode: rowNode,
            colIdToSkip: colIdToSkip
        });
    }
    doesRowPassAggregateFilters(params) {
        const { rowNode: rowNode } = params;
        if (this.alwaysPassFilter?.(rowNode)) return true;
        if (this.isAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(rowNode)) return false;
        if (this.isAggregateFilterPresent() && !this.colFilter.doFiltersPass(rowNode, params.colIdToSkip, true)) return false;
        return true;
    }
    doesRowPassFilter(params) {
        const { rowNode: rowNode } = params;
        if (this.alwaysPassFilter?.(rowNode)) return true;
        if (this.isNonAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(rowNode)) return false;
        if (this.externalFilterPresent && !this.doesExternalFilterPass(rowNode)) return false;
        if (this.isColumnFilterPresent() && !this.colFilter.doFiltersPass(rowNode, params.colIdToSkip)) return false;
        if (this.isAdvFilterPresent() && !this.advancedFilter.doesFilterPass(rowNode)) return false;
        return true;
    }
    // for group filters, can change dynamically whether they are allowed or not
    isFilterAllowed(column) {
        if (this.isAdvFilterEnabled()) return false;
        return !!this.colFilter?.isFilterAllowed(column);
    }
    getAdvFilterModel() {
        return this.isAdvFilterEnabled() ? this.advancedFilter.getModel() : null;
    }
    setAdvFilterModel(expression, source = "api") {
        if (!this.isAdvFilterEnabled()) return;
        if (this.beans.dataTypeSvc?.isPendingInference) {
            this.advFilterModelUpdateQueue.push(expression);
            return;
        }
        this.advancedFilter.setModel(expression ?? null);
        this.onFilterChanged({
            source: source
        });
    }
    toggleAdvFilterBuilder(show, source) {
        if (!this.isAdvFilterEnabled()) return;
        this.advancedFilter.getCtrl().toggleFilterBuilder({
            source: source,
            force: show
        });
    }
    updateAdvFilterColumns() {
        if (!this.isAdvFilterEnabled()) return;
        if (this.advancedFilter.updateValidity()) this.onFilterChanged({
            source: "advancedFilter"
        });
    }
    hasFloatingFilters() {
        if (this.isAdvFilterEnabled()) return false;
        return !!this.colFilter?.hasFloatingFilters();
    }
    getColumnFilterInstance(key) {
        if (this.isAdvFilterEnabled()) {
            this.warnAdvFilters();
            return Promise.resolve(void 0);
        }
        return this.colFilter?.getFilterInstance(key) ?? Promise.resolve(void 0);
    }
    warnAdvFilters() {
        $437b23f6a393c3bf$export$545083624300f13d(68);
    }
    setupAdvFilterHeaderComp(eCompToInsertBefore) {
        this.advancedFilter?.getCtrl().setupHeaderComp(eCompToInsertBefore);
    }
    getHeaderRowCount() {
        return this.isAdvFilterHeaderActive() ? 1 : 0;
    }
    getHeaderHeight() {
        return this.isAdvFilterHeaderActive() ? this.advancedFilter.getCtrl().getHeaderHeight() : 0;
    }
    processFilterModelUpdateQueue() {
        for (const model of this.advFilterModelUpdateQueue)this.setAdvFilterModel(model);
        this.advFilterModelUpdateQueue = [];
    }
    setColumnFilterModel(key, model) {
        if (this.isAdvFilterEnabled()) {
            this.warnAdvFilters();
            return Promise.resolve();
        }
        return this.colFilter?.setModelForColumn(key, model) ?? Promise.resolve();
    }
};
// packages/ag-grid-community/src/filter/filterMenuFactory.ts
var $437b23f6a393c3bf$var$FilterMenuFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterMenuFactory";
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
    }
    hideActiveMenu() {
        this.hidePopup?.();
    }
    showMenuAfterMouseEvent(column, mouseEvent, containerType, onClosedCallback) {
        if (column && !column.isColumn) return;
        this.showPopup(column, (eMenu)=>{
            this.popupSvc?.positionPopupUnderMouseEvent({
                additionalParams: {
                    column: column
                },
                type: containerType,
                mouseEvent: mouseEvent,
                ePopup: eMenu
            });
        }, containerType, mouseEvent.target, $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos), onClosedCallback);
    }
    showMenuAfterButtonClick(column, eventSource, containerType, onClosedCallback) {
        if (column && !column.isColumn) return;
        let multiplier = -1;
        let alignSide = "left";
        const isLegacyMenuEnabled = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos);
        if (!isLegacyMenuEnabled && this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        const nudgeX = isLegacyMenuEnabled ? void 0 : 4 * multiplier;
        const nudgeY = isLegacyMenuEnabled ? void 0 : 4;
        this.showPopup(column, (eMenu)=>{
            this.popupSvc?.positionPopupByComponent({
                type: containerType,
                eventSource: eventSource,
                ePopup: eMenu,
                nudgeX: nudgeX,
                nudgeY: nudgeY,
                alignSide: alignSide,
                keepWithinBounds: true,
                position: "under",
                additionalParams: {
                    column: column
                }
            });
        }, containerType, eventSource, isLegacyMenuEnabled, onClosedCallback);
    }
    showPopup(column, positionCallback, containerType, eventSource, isLegacyMenuEnabled, onClosedCallback) {
        const comp = column ? this.createBean(new $437b23f6a393c3bf$export$7db6d402989d8b90(column, "COLUMN_MENU")) : void 0;
        this.activeMenu = comp;
        if (!comp?.hasFilter() || !column) {
            $437b23f6a393c3bf$export$a20c7248650823a9(57);
            return;
        }
        const eMenu = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: `ag-menu${!isLegacyMenuEnabled ? " ag-filter-menu" : ""}`,
            role: "presentation"
        });
        [this.tabListener] = this.addManagedElementListeners(eMenu, {
            keydown: (e)=>this.trapFocusWithin(e, eMenu)
        });
        eMenu.appendChild(comp?.getGui());
        let hidePopup;
        const afterGuiDetached = ()=>comp?.afterGuiDetached();
        const anchorToElement = $437b23f6a393c3bf$export$cfe4cf52f3717a7b(this.gos) ? eventSource ?? this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody : void 0;
        const closedCallback = (e)=>{
            $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, false, "contextMenu");
            const isKeyboardEvent = e instanceof KeyboardEvent;
            if (this.tabListener) this.tabListener = this.tabListener();
            if (isKeyboardEvent && eventSource && $437b23f6a393c3bf$export$2badf4aa566524cb(eventSource)) {
                const focusableEl = $437b23f6a393c3bf$export$c4c49c776025d475(eventSource);
                focusableEl?.focus({
                    preventScroll: true
                });
            }
            afterGuiDetached();
            this.destroyBean(this.activeMenu);
            this.dispatchVisibleChangedEvent(false, containerType, column);
            onClosedCallback?.();
        };
        const translate = this.getLocaleTextFunc();
        const ariaLabel = isLegacyMenuEnabled && containerType !== "columnFilter" ? translate("ariaLabelColumnMenu", "Column Menu") : translate("ariaLabelColumnFilter", "Column Filter");
        const addPopupRes = this.popupSvc?.addPopup({
            modal: true,
            eChild: eMenu,
            closeOnEsc: true,
            closedCallback: closedCallback,
            positionCallback: ()=>positionCallback(eMenu),
            anchorToElement: anchorToElement,
            ariaLabel: ariaLabel
        });
        if (addPopupRes) this.hidePopup = hidePopup = addPopupRes.hideFunc;
        comp.afterInit().then(()=>{
            positionCallback(eMenu);
            comp.afterGuiAttached({
                container: containerType,
                hidePopup: hidePopup
            });
        });
        $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, true, "contextMenu");
        this.dispatchVisibleChangedEvent(true, containerType, column);
    }
    trapFocusWithin(e, menu) {
        if (e.key !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || e.defaultPrevented || $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, menu, false, e.shiftKey)) return;
        e.preventDefault();
        $437b23f6a393c3bf$export$8598088d375f416f(menu, e.shiftKey);
    }
    dispatchVisibleChangedEvent(visible, containerType, column) {
        this.eventSvc.dispatchEvent({
            type: "columnMenuVisibleChanged",
            visible: visible,
            switchingTab: false,
            key: containerType,
            column: column ?? null,
            columnGroup: null
        });
    }
    isMenuEnabled(column) {
        return column.isFilterAllowed() && (column.getColDef().menuTabs ?? [
            "filterMenuTab"
        ]).includes("filterMenuTab");
    }
    showMenuAfterContextMenuEvent() {}
    destroy() {
        this.destroyBean(this.activeMenu);
        super.destroy();
    }
};
// packages/ag-grid-community/src/filter/filterValueService.ts
var $437b23f6a393c3bf$var$FilterValueService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterValueSvc";
    }
    getValue(column, rowNode, filterValueGetterOverride) {
        if (!rowNode) return;
        const colDef = column.getColDef();
        const { selectableFilter: selectableFilter, valueSvc: valueSvc, formula: formula } = this.beans;
        const filterValueGetter = filterValueGetterOverride ?? selectableFilter?.getFilterValueGetter(column.getColId()) ?? colDef.filterValueGetter;
        if (filterValueGetter) return this.executeFilterValueGetter(filterValueGetter, rowNode.data, column, rowNode, colDef);
        const value = valueSvc.getValue(column, rowNode);
        if (column.isAllowFormula() && formula?.isFormula(value)) return formula.resolveValue(column, rowNode);
        return value;
    }
    executeFilterValueGetter(valueGetter, data, column, node, colDef) {
        const { expressionSvc: expressionSvc, valueSvc: valueSvc } = this.beans;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            data: data,
            node: node,
            column: column,
            colDef: colDef,
            getValue: valueSvc.getValueCallback.bind(valueSvc, node)
        });
        if (typeof valueGetter === "function") return valueGetter(params);
        return expressionSvc?.evaluate(valueGetter, params);
    }
};
// packages/ag-grid-community/src/filter/floating/provided/readOnlyFloatingFilter.ts
var $437b23f6a393c3bf$var$ReadOnlyFloatingFilterElement = {
    tag: "div",
    cls: "ag-floating-filter-input",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eFloatingFilterText"
        }
    ]
};
var $437b23f6a393c3bf$var$ReadOnlyFloatingFilter = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$ReadOnlyFloatingFilterElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eFloatingFilterText = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    init(params) {
        this.params = params;
        const displayName = this.beans.colNames.getDisplayNameForColumn(params.column, "header", true);
        this.eFloatingFilterText.setDisabled(true).setInputAriaLabel(`${displayName} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`);
        if (this.gos.get("enableFilterHandlers")) {
            const reactiveParams = params;
            const handler = reactiveParams.getHandler();
            if (handler.getModelAsString) {
                const modelAsString = handler.getModelAsString(reactiveParams.model);
                this.eFloatingFilterText.setValue(modelAsString);
            }
        }
    }
    onParentModelChanged(parentModel) {
        if (parentModel == null) {
            this.eFloatingFilterText.setValue("");
            return;
        }
        this.params.parentFilterInstance((filterInstance)=>{
            if (filterInstance.getModelAsString) {
                const modelAsString = filterInstance.getModelAsString(parentModel);
                this.eFloatingFilterText.setValue(modelAsString);
            }
        });
    }
    refresh(params) {
        this.init(params);
    }
};
// packages/ag-grid-community/src/filter/provided/optionsFactory.ts
var $437b23f6a393c3bf$var$OptionsFactory = class {
    constructor(){
        this.customFilterOptions = {};
    }
    init(params, defaultOptions) {
        this.filterOptions = params.filterOptions ?? defaultOptions;
        this.mapCustomOptions();
        this.defaultOption = this.getDefaultItem(params.defaultOption);
    }
    refresh(params, defaultOptions) {
        const filterOptions = params.filterOptions ?? defaultOptions;
        if (this.filterOptions !== filterOptions) {
            this.filterOptions = filterOptions;
            this.customFilterOptions = {};
            this.mapCustomOptions();
        }
        this.defaultOption = this.getDefaultItem(params.defaultOption);
    }
    mapCustomOptions() {
        const { filterOptions: filterOptions } = this;
        if (!filterOptions) return;
        for (const filterOption of filterOptions){
            if (typeof filterOption === "string") continue;
            const requiredProperties = [
                [
                    "displayKey"
                ],
                [
                    "displayName"
                ],
                [
                    "predicate",
                    "test"
                ]
            ];
            const propertyCheck = (keys)=>{
                if (!keys.some((key)=>filterOption[key] != null)) {
                    $437b23f6a393c3bf$export$545083624300f13d(72, {
                        keys: keys
                    });
                    return false;
                }
                return true;
            };
            if (!requiredProperties.every(propertyCheck)) {
                this.filterOptions = filterOptions.filter((v)=>v === filterOption) || [];
                continue;
            }
            this.customFilterOptions[filterOption.displayKey] = filterOption;
        }
    }
    getDefaultItem(defaultOption) {
        const { filterOptions: filterOptions } = this;
        if (defaultOption) return defaultOption;
        else if (filterOptions.length >= 1) {
            const firstFilterOption = filterOptions[0];
            if (typeof firstFilterOption === "string") return firstFilterOption;
            else if (firstFilterOption.displayKey) return firstFilterOption.displayKey;
            else $437b23f6a393c3bf$export$545083624300f13d(73);
        } else $437b23f6a393c3bf$export$545083624300f13d(74);
        return void 0;
    }
    getCustomOption(name) {
        return this.customFilterOptions[name];
    }
};
// packages/ag-grid-community/src/filter/provided/simpleFilterUtils.ts
function $437b23f6a393c3bf$var$removeItems(items, startPosition, deleteCount) {
    return deleteCount == null ? items.splice(startPosition) : items.splice(startPosition, deleteCount);
}
function $437b23f6a393c3bf$var$isBlank(cellValue) {
    return cellValue == null || typeof cellValue === "string" && cellValue.trim().length === 0;
}
function $437b23f6a393c3bf$var$getDefaultJoinOperator(defaultJoinOperator) {
    return defaultJoinOperator === "AND" || defaultJoinOperator === "OR" ? defaultJoinOperator : "AND";
}
function $437b23f6a393c3bf$var$evaluateCustomFilter(customFilterOption, values, cellValue) {
    if (customFilterOption == null) return;
    const { predicate: predicate } = customFilterOption;
    if (predicate != null && !values.some((v)=>v == null)) return predicate(values, cellValue);
}
function $437b23f6a393c3bf$var$validateAndUpdateConditions(conditions, maxNumConditions) {
    let numConditions = conditions.length;
    if (numConditions > maxNumConditions) {
        conditions.splice(maxNumConditions);
        $437b23f6a393c3bf$export$545083624300f13d(78);
        numConditions = maxNumConditions;
    }
    return numConditions;
}
function $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory) {
    const customOpts = optionsFactory.getCustomOption(type);
    if (customOpts) {
        const { numberOfInputs: numberOfInputs } = customOpts;
        return numberOfInputs != null ? numberOfInputs : 1;
    }
    const zeroInputTypes = [
        "empty",
        "notBlank",
        "blank"
    ];
    if (type && zeroInputTypes.indexOf(type) >= 0) return 0;
    else if (type === "inRange") return 2;
    return 1;
}
// packages/ag-grid-community/src/filter/provided/simpleFilter.ts
var $437b23f6a393c3bf$var$SimpleFilter = class extends $437b23f6a393c3bf$export$a927a1327c2cc7f0 {
    constructor(filterNameKey, mapValuesFromModel, defaultOptions){
        super(filterNameKey, "simple-filter");
        this.mapValuesFromModel = mapValuesFromModel;
        this.defaultOptions = defaultOptions;
        this.eTypes = [];
        this.eJoinPanels = [];
        this.eJoinAnds = [];
        this.eJoinOrs = [];
        this.eConditionBodies = [];
        this.listener = ()=>this.onUiChanged();
        this.lastUiCompletePosition = null;
        this.joinOperatorId = 0;
    }
    setParams(params) {
        super.setParams(params);
        const optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory = optionsFactory;
        optionsFactory.init(params, this.defaultOptions);
        this.commonUpdateSimpleParams(params);
        this.createOption();
        this.createMissingConditionsAndOperators();
    }
    updateParams(newParams, oldParams) {
        this.optionsFactory.refresh(newParams, this.defaultOptions);
        super.updateParams(newParams, oldParams);
        this.commonUpdateSimpleParams(newParams);
    }
    commonUpdateSimpleParams(params) {
        this.setNumConditions(params);
        this.defaultJoinOperator = $437b23f6a393c3bf$var$getDefaultJoinOperator(params.defaultJoinOperator);
        this.filterPlaceholder = params.filterPlaceholder;
        this.createFilterListOptions();
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.getGui(), "tabindex", this.isReadOnly() ? "-1" : null);
    }
    // floating filter calls this when user applies filter from floating filter
    onFloatingFilterChanged(type, value) {
        this.setTypeFromFloatingFilter(type);
        this.setValueFromFloatingFilter(value);
        this.onUiChanged("immediately", true);
    }
    setTypeFromFloatingFilter(type) {
        this.eTypes.forEach((eType, position)=>{
            const value = position === 0 ? type : this.optionsFactory.defaultOption;
            eType.setValue(value, true);
        });
    }
    getModelFromUi() {
        const conditions = this.getUiCompleteConditions();
        if (conditions.length === 0) return null;
        if (this.maxNumConditions > 1 && conditions.length > 1) return {
            filterType: this.filterType,
            operator: this.getJoinOperator(),
            conditions: conditions
        };
        return conditions[0];
    }
    getConditionTypes() {
        return this.eTypes.map((eType)=>eType.getValue());
    }
    getConditionType(position) {
        return this.eTypes[position].getValue();
    }
    getJoinOperator() {
        const { eJoinOrs: eJoinOperatorsOr, defaultJoinOperator: defaultJoinOperator } = this;
        return eJoinOperatorsOr.length === 0 ? defaultJoinOperator : eJoinOperatorsOr[0].getValue() === true ? "OR" : "AND";
    }
    areNonNullModelsEqual(a, b) {
        const aIsSimple = !a.operator;
        const bIsSimple = !b.operator;
        const oneSimpleOneCombined = !aIsSimple && bIsSimple || aIsSimple && !bIsSimple;
        if (oneSimpleOneCombined) return false;
        let res;
        if (aIsSimple) {
            const aSimple = a;
            const bSimple = b;
            res = this.areSimpleModelsEqual(aSimple, bSimple);
        } else {
            const aCombined = a;
            const bCombined = b;
            res = aCombined.operator === bCombined.operator && $437b23f6a393c3bf$export$893967cdb9833fdd(aCombined.conditions, bCombined.conditions, (aModel, bModel)=>this.areSimpleModelsEqual(aModel, bModel));
        }
        return res;
    }
    setModelIntoUi(model, isInitialLoad) {
        if (model == null) {
            this.resetUiToDefaults(isInitialLoad);
            return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
        }
        const isCombined = model.operator;
        if (isCombined) {
            const combinedModel = model;
            let conditions = combinedModel.conditions;
            if (conditions == null) {
                conditions = [];
                $437b23f6a393c3bf$export$545083624300f13d(77);
            }
            const numConditions = $437b23f6a393c3bf$var$validateAndUpdateConditions(conditions, this.maxNumConditions);
            const numPrevConditions = this.getNumConditions();
            if (numConditions < numPrevConditions) this.removeConditionsAndOperators(numConditions);
            else if (numConditions > numPrevConditions) for(let i = numPrevConditions; i < numConditions; i++){
                this.createJoinOperatorPanel();
                this.createOption();
            }
            const orChecked = combinedModel.operator === "OR";
            this.eJoinAnds.forEach((eJoinOperatorAnd)=>eJoinOperatorAnd.setValue(!orChecked, true));
            this.eJoinOrs.forEach((eJoinOperatorOr)=>eJoinOperatorOr.setValue(orChecked, true));
            conditions.forEach((condition, position)=>{
                this.eTypes[position].setValue(condition.type, true);
                this.setConditionIntoUi(condition, position);
            });
        } else {
            const simpleModel = model;
            if (this.getNumConditions() > 1) this.removeConditionsAndOperators(1);
            this.eTypes[0].setValue(simpleModel.type, true);
            this.setConditionIntoUi(simpleModel, 0);
        }
        this.lastUiCompletePosition = this.getNumConditions() - 1;
        this.createMissingConditionsAndOperators();
        this.updateUiVisibility();
        if (!isInitialLoad) this.params.onUiChange(this.getUiChangeEventParams());
        return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    setNumConditions(params) {
        let maxNumConditions = params.maxNumConditions ?? 2;
        if (maxNumConditions < 1) {
            $437b23f6a393c3bf$export$545083624300f13d(79);
            maxNumConditions = 1;
        }
        this.maxNumConditions = maxNumConditions;
        let numAlwaysVisibleConditions = params.numAlwaysVisibleConditions ?? 1;
        if (numAlwaysVisibleConditions < 1) {
            $437b23f6a393c3bf$export$545083624300f13d(80);
            numAlwaysVisibleConditions = 1;
        }
        if (numAlwaysVisibleConditions > maxNumConditions) {
            $437b23f6a393c3bf$export$545083624300f13d(81);
            numAlwaysVisibleConditions = maxNumConditions;
        }
        this.numAlwaysVisibleConditions = numAlwaysVisibleConditions;
    }
    createOption() {
        const eGui = this.getGui();
        const eType = this.createManagedBean(new $437b23f6a393c3bf$export$6f9c460854d56032());
        this.eTypes.push(eType);
        eType.addCss("ag-filter-select");
        eGui.appendChild(eType.getGui());
        const eConditionBody = this.createEValue();
        this.eConditionBodies.push(eConditionBody);
        eGui.appendChild(eConditionBody);
        this.putOptionsIntoDropdown(eType);
        this.resetType(eType);
        const position = this.getNumConditions() - 1;
        this.forEachPositionInput(position, (element)=>this.resetInput(element));
        this.addChangedListeners(eType, position);
    }
    createJoinOperatorPanel() {
        const eJoinOperatorPanel = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-condition"
        });
        this.eJoinPanels.push(eJoinOperatorPanel);
        const eJoinOperatorAnd = this.createJoinOperator(this.eJoinAnds, eJoinOperatorPanel, "and");
        const eJoinOperatorOr = this.createJoinOperator(this.eJoinOrs, eJoinOperatorPanel, "or");
        this.getGui().appendChild(eJoinOperatorPanel);
        const index = this.eJoinPanels.length - 1;
        const uniqueGroupId = this.joinOperatorId++;
        this.resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId);
        this.resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId);
        if (!this.isReadOnly()) {
            eJoinOperatorAnd.onValueChange(this.listener);
            eJoinOperatorOr.onValueChange(this.listener);
        }
    }
    createJoinOperator(eJoinOperators, eJoinOperatorPanel, andOr) {
        const eJoinOperator = this.createManagedBean(new $437b23f6a393c3bf$export$5caa9ea96bbb722());
        eJoinOperators.push(eJoinOperator);
        const baseClass = "ag-filter-condition-operator";
        eJoinOperator.addCss(baseClass);
        eJoinOperator.addCss(`${baseClass}-${andOr}`);
        eJoinOperatorPanel.appendChild(eJoinOperator.getGui());
        return eJoinOperator;
    }
    createFilterListOptions() {
        this.filterListOptions = this.optionsFactory.filterOptions.map((option)=>typeof option === "string" ? this.createBoilerplateListOption(option) : this.createCustomListOption(option));
    }
    putOptionsIntoDropdown(eType) {
        const { filterListOptions: filterListOptions } = this;
        for (const listOption of filterListOptions)eType.addOption(listOption);
        eType.setDisabled(filterListOptions.length <= 1);
    }
    createBoilerplateListOption(option) {
        return {
            value: option,
            text: this.translate(option)
        };
    }
    createCustomListOption(option) {
        const { displayKey: displayKey } = option;
        const customOption = this.optionsFactory.getCustomOption(option.displayKey);
        return {
            value: displayKey,
            text: customOption ? this.getLocaleTextFunc()(customOption.displayKey, customOption.displayName) : this.translate(displayKey)
        };
    }
    createBodyTemplate() {
        return null;
    }
    getAgComponents() {
        return [];
    }
    updateUiVisibility() {
        const joinOperator = this.getJoinOperator();
        this.updateNumConditions();
        this.updateConditionStatusesAndValues(this.lastUiCompletePosition, joinOperator);
    }
    updateNumConditions() {
        let lastUiCompletePosition = -1;
        let areAllConditionsUiComplete = true;
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) lastUiCompletePosition = position;
        else areAllConditionsUiComplete = false;
        if (this.shouldAddNewConditionAtEnd(areAllConditionsUiComplete)) {
            this.createJoinOperatorPanel();
            this.createOption();
        } else {
            const activePosition = this.lastUiCompletePosition ?? this.getNumConditions() - 2;
            if (lastUiCompletePosition < activePosition) {
                this.removeConditionsAndOperators(activePosition + 1);
                const removeStartPosition = lastUiCompletePosition + 1;
                const numConditionsToRemove = activePosition - removeStartPosition;
                if (numConditionsToRemove > 0) this.removeConditionsAndOperators(removeStartPosition, numConditionsToRemove);
                this.createMissingConditionsAndOperators();
            }
        }
        this.lastUiCompletePosition = lastUiCompletePosition;
    }
    updateConditionStatusesAndValues(lastUiCompletePosition, joinOperator) {
        this.eTypes.forEach((eType, position)=>{
            const disabled = this.isConditionDisabled(position, lastUiCompletePosition);
            eType.setDisabled(disabled || this.filterListOptions.length <= 1);
            if (position === 1) {
                $437b23f6a393c3bf$export$b6b4f08392e9bfaf(this.eJoinPanels[0], disabled);
                this.eJoinAnds[0].setDisabled(disabled);
                this.eJoinOrs[0].setDisabled(disabled);
            }
        });
        this.eConditionBodies.forEach((element, index)=>{
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, this.isConditionBodyVisible(index));
        });
        const orChecked = (joinOperator ?? this.getJoinOperator()) === "OR";
        for (const eJoinOperatorAnd of this.eJoinAnds)eJoinOperatorAnd.setValue(!orChecked, true);
        for (const eJoinOperatorOr of this.eJoinOrs)eJoinOperatorOr.setValue(orChecked, true);
        this.forEachInput((element, index, position, numberOfInputs)=>{
            this.setElementDisplayed(element, index < numberOfInputs);
            this.setElementDisabled(element, this.isConditionDisabled(position, lastUiCompletePosition));
        });
        this.resetPlaceholder();
    }
    shouldAddNewConditionAtEnd(areAllConditionsUiComplete) {
        return areAllConditionsUiComplete && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
    }
    removeConditionsAndOperators(startPosition, deleteCount) {
        if (startPosition >= this.getNumConditions()) return;
        const { eTypes: eTypes, eConditionBodies: eConditionBodies, eJoinPanels: eJoinOperatorPanels, eJoinAnds: eJoinOperatorsAnd, eJoinOrs: eJoinOperatorsOr } = this;
        this.removeComponents(eTypes, startPosition, deleteCount);
        this.removeElements(eConditionBodies, startPosition, deleteCount);
        this.removeEValues(startPosition, deleteCount);
        const joinOperatorIndex = Math.max(startPosition - 1, 0);
        this.removeElements(eJoinOperatorPanels, joinOperatorIndex, deleteCount);
        this.removeComponents(eJoinOperatorsAnd, joinOperatorIndex, deleteCount);
        this.removeComponents(eJoinOperatorsOr, joinOperatorIndex, deleteCount);
    }
    removeElements(elements, startPosition, deleteCount) {
        const removedElements = $437b23f6a393c3bf$var$removeItems(elements, startPosition, deleteCount);
        for (const element of removedElements)$437b23f6a393c3bf$export$dd4d52e41fb4cef5(element);
    }
    removeComponents(components, startPosition, deleteCount) {
        const removedComponents = $437b23f6a393c3bf$var$removeItems(components, startPosition, deleteCount);
        for (const comp of removedComponents){
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(comp.getGui());
            this.destroyBean(comp);
        }
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.resetPlaceholder();
        if (!params?.suppressFocus) {
            let elementToFocus;
            if (!this.isReadOnly()) {
                const firstInput = this.getInputs(0)[0];
                if (firstInput instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3 && this.isConditionBodyVisible(0)) elementToFocus = firstInput.getInputElement();
                else elementToFocus = this.eTypes[0]?.getFocusableElement();
            }
            (elementToFocus ?? this.getGui()).focus({
                preventScroll: true
            });
        }
    }
    shouldKeepInvalidInputState() {
        return false;
    }
    afterGuiDetached() {
        super.afterGuiDetached();
        const params = this.params;
        if (this.beans.colFilter?.shouldKeepStateOnDetach(params.column) || this.shouldKeepInvalidInputState()) return;
        params.onStateChange({
            model: params.model
        });
        let lastUiCompletePosition = -1;
        let updatedLastUiCompletePosition = -1;
        let conditionsRemoved = false;
        const joinOperator = this.getJoinOperator();
        for(let position = this.getNumConditions() - 1; position >= 0; position--){
            if (this.isConditionUiComplete(position)) {
                if (lastUiCompletePosition === -1) {
                    lastUiCompletePosition = position;
                    updatedLastUiCompletePosition = position;
                }
            } else {
                const shouldRemovePositionAtEnd = position >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(position - 1);
                const positionBeforeLastUiCompletePosition = position < lastUiCompletePosition;
                if (shouldRemovePositionAtEnd || positionBeforeLastUiCompletePosition) {
                    this.removeConditionsAndOperators(position, 1);
                    conditionsRemoved = true;
                    if (positionBeforeLastUiCompletePosition) updatedLastUiCompletePosition--;
                }
            }
        }
        let shouldUpdateConditionStatusesAndValues = false;
        if (this.getNumConditions() < this.numAlwaysVisibleConditions) {
            this.createMissingConditionsAndOperators();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (this.shouldAddNewConditionAtEnd(updatedLastUiCompletePosition === this.getNumConditions() - 1)) {
            this.createJoinOperatorPanel();
            this.createOption();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (shouldUpdateConditionStatusesAndValues) this.updateConditionStatusesAndValues(updatedLastUiCompletePosition, joinOperator);
        if (conditionsRemoved) this.updateJoinOperatorsDisabled();
        this.lastUiCompletePosition = updatedLastUiCompletePosition;
    }
    getModelAsString(model) {
        return this.params.getHandler()?.getModelAsString?.(model) ?? "";
    }
    // allow sub-classes to reset HTML placeholders after UI update.
    resetPlaceholder() {
        const globalTranslate = this.getLocaleTextFunc();
        const { filterPlaceholder: filterPlaceholder, eTypes: eTypes } = this;
        this.forEachInput((element, index, position, numberOfInputs)=>{
            if (!(element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3)) return;
            const placeholderKey = index === 0 && numberOfInputs > 1 ? "inRangeStart" : index === 0 ? "filterOoo" : "inRangeEnd";
            const ariaLabel = index === 0 && numberOfInputs > 1 ? globalTranslate("ariaFilterFromValue", "Filter from value") : index === 0 ? globalTranslate("ariaFilterValue", "Filter Value") : globalTranslate("ariaFilterToValue", "Filter to Value");
            const filterOptionKey = eTypes[position].getValue();
            const placeholderText = $437b23f6a393c3bf$var$getPlaceholderText(this, filterPlaceholder, placeholderKey, filterOptionKey);
            element.setInputPlaceholder(placeholderText);
            element.setInputAriaLabel(ariaLabel);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setElementValue(element, value, fromFloatingFilter) {
        if (element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3) element.setValue(value != null ? String(value) : null, true);
    }
    setElementDisplayed(element, displayed) {
        if ($437b23f6a393c3bf$export$e9be47ed2688240e(element)) $437b23f6a393c3bf$export$9405f1cbb4e2383f(element.getGui(), displayed);
    }
    setElementDisabled(element, disabled) {
        if ($437b23f6a393c3bf$export$e9be47ed2688240e(element)) $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element.getGui(), disabled);
    }
    attachElementOnChange(element, listener) {
        if (element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3) element.onValueChange(listener);
    }
    forEachInput(cb) {
        this.getConditionTypes().forEach((type, position)=>{
            this.forEachPositionTypeInput(position, type, cb);
        });
    }
    forEachPositionInput(position, cb) {
        const type = this.getConditionType(position);
        this.forEachPositionTypeInput(position, type, cb);
    }
    forEachPositionTypeInput(position, type, cb) {
        const numberOfInputs = $437b23f6a393c3bf$var$getNumberOfInputs(type, this.optionsFactory);
        const inputs = this.getInputs(position);
        for(let index = 0; index < inputs.length; index++){
            const input = inputs[index];
            if (input != null) cb(input, index, position, numberOfInputs);
        }
    }
    isConditionDisabled(position, lastUiCompletePosition) {
        if (this.isReadOnly()) return true;
        if (position === 0) return false;
        return position > lastUiCompletePosition + 1;
    }
    isConditionBodyVisible(position) {
        const type = this.getConditionType(position);
        const numberOfInputs = $437b23f6a393c3bf$var$getNumberOfInputs(type, this.optionsFactory);
        return numberOfInputs > 0;
    }
    // returns true if the UI represents a working filter, eg all parts are filled out.
    // eg if text filter and textfield blank then returns false.
    isConditionUiComplete(position) {
        if (position >= this.getNumConditions()) return false;
        const type = this.getConditionType(position);
        if (type === "empty") return false;
        if (this.getValues(position).some((v)=>v == null)) return false;
        if (this.positionHasInvalidInputs(position)) return false;
        return true;
    }
    getNumConditions() {
        return this.eTypes.length;
    }
    getUiCompleteConditions() {
        const conditions = [];
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) conditions.push(this.createCondition(position));
        return conditions;
    }
    createMissingConditionsAndOperators() {
        if (this.isReadOnly()) return;
        for(let i = this.getNumConditions(); i < this.numAlwaysVisibleConditions; i++){
            this.createJoinOperatorPanel();
            this.createOption();
        }
    }
    resetUiToDefaults(silent) {
        this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions);
        this.eTypes.forEach((eType)=>this.resetType(eType));
        this.eJoinAnds.forEach((eJoinOperatorAnd, index)=>this.resetJoinOperatorAnd(eJoinOperatorAnd, index, this.joinOperatorId + index));
        this.eJoinOrs.forEach((eJoinOperatorOr, index)=>this.resetJoinOperatorOr(eJoinOperatorOr, index, this.joinOperatorId + index));
        this.joinOperatorId++;
        this.forEachInput((element)=>this.resetInput(element));
        this.resetPlaceholder();
        this.createMissingConditionsAndOperators();
        this.lastUiCompletePosition = null;
        this.updateUiVisibility();
        if (!silent) this.params.onUiChange(this.getUiChangeEventParams());
    }
    resetType(eType) {
        const translate = this.getLocaleTextFunc();
        const filteringLabel = translate("ariaFilteringOperator", "Filtering operator");
        eType.setValue(this.optionsFactory.defaultOption, true).setAriaLabel(filteringLabel).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
    }
    resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorAnd, index, this.defaultJoinOperator === "AND", this.translate("andCondition"), uniqueGroupId);
    }
    resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorOr, index, this.defaultJoinOperator === "OR", this.translate("orCondition"), uniqueGroupId);
    }
    resetJoinOperator(eJoinOperator, index, value, label, uniqueGroupId) {
        this.updateJoinOperatorDisabled(eJoinOperator.setValue(value, true).setName(`ag-simple-filter-and-or-${this.getCompId()}-${uniqueGroupId}`).setLabel(label), index);
    }
    updateJoinOperatorsDisabled() {
        const updater = (eJoinOperator, index)=>this.updateJoinOperatorDisabled(eJoinOperator, index);
        this.eJoinAnds.forEach(updater);
        this.eJoinOrs.forEach(updater);
    }
    updateJoinOperatorDisabled(eJoinOperator, index) {
        eJoinOperator.setDisabled(this.isReadOnly() || index > 0);
    }
    resetInput(element) {
        this.setElementValue(element, null);
        this.setElementDisabled(element, this.isReadOnly());
    }
    // puts model values into the UI
    setConditionIntoUi(model, position) {
        const values = this.mapValuesFromModel(model, this.optionsFactory);
        this.forEachInput((element, index, elPosition)=>{
            if (elPosition !== position) return;
            this.setElementValue(element, values[index] != null ? values[index] : null);
        });
    }
    // after floating filter changes, this sets the 'value' section. this is implemented by the base class
    // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.
    setValueFromFloatingFilter(value) {
        this.forEachInput((element, index, position)=>{
            this.setElementValue(element, index === 0 && position === 0 ? value : null, true);
        });
    }
    addChangedListeners(eType, position) {
        if (this.isReadOnly()) return;
        eType.onValueChange(this.listener);
        this.forEachPositionInput(position, (element)=>{
            this.attachElementOnChange(element, this.listener);
        });
    }
    hasInvalidInputs() {
        return false;
    }
    positionHasInvalidInputs(_position) {
        return false;
    }
    isReadOnly() {
        return !!this.params.readOnly;
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateCompWrapper.ts
var $437b23f6a393c3bf$var$CLASS_INPUT_FIELD = ".ag-input-field-input";
var $437b23f6a393c3bf$var$DateCompWrapper = class {
    constructor(context, userCompFactory, colDef, dateComponentParams, eParent, onReady){
        this.context = context;
        this.eParent = eParent;
        this.alive = true;
        this.debouncedReport = $437b23f6a393c3bf$export$cf7e39bfb94de6e({
            isAlive: ()=>this.alive
        }, $437b23f6a393c3bf$var$reportValidity, 500);
        this.timeoutHandle = null;
        const compDetails = $437b23f6a393c3bf$var$_getDateCompDetails(userCompFactory, colDef, dateComponentParams);
        compDetails?.newAgStackInstance().then((dateComp)=>{
            if (!this.alive) {
                context.destroyBean(dateComp);
                return;
            }
            this.dateComp = dateComp;
            if (!dateComp) return;
            eParent.appendChild(dateComp.getGui());
            dateComp?.afterGuiAttached?.();
            const { tempValue: tempValue, disabled: disabled } = this;
            if (tempValue) dateComp.setDate(tempValue);
            if (disabled != null) dateComp.setDisabled?.(disabled);
            onReady?.(this);
        });
    }
    destroy() {
        this.alive = false;
        this.dateComp = this.context.destroyBean(this.dateComp);
    }
    getDate() {
        return this.dateComp ? this.dateComp.getDate() : this.tempValue;
    }
    setDate(value) {
        const dateComp = this.dateComp;
        if (dateComp) dateComp.setDate(value);
        else this.tempValue = value;
    }
    setDisabled(disabled) {
        const dateComp = this.dateComp;
        if (dateComp) dateComp.setDisabled?.(disabled);
        else this.disabled = disabled;
    }
    setDisplayed(displayed) {
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eParent, displayed);
    }
    setInputPlaceholder(placeholder) {
        this.dateComp?.setInputPlaceholder?.(placeholder);
    }
    setInputAriaLabel(label) {
        this.dateComp?.setInputAriaLabel?.(label);
    }
    afterGuiAttached(params) {
        this.dateComp?.afterGuiAttached?.(params);
    }
    updateParams(params) {
        this.dateComp?.refresh?.(params);
    }
    setCustomValidity(message, defer = false) {
        const eInput = this.dateComp?.getGui().querySelector($437b23f6a393c3bf$var$CLASS_INPUT_FIELD);
        if (eInput && "setCustomValidity" in eInput) {
            const isInvalid = message.length > 0;
            eInput.setCustomValidity(message);
            if (isInvalid) {
                if (defer) this.timeoutHandle = this.debouncedReport(eInput);
                else $437b23f6a393c3bf$var$reportValidity(eInput);
            } else if (this.timeoutHandle) window.clearTimeout(this.timeoutHandle);
            $437b23f6a393c3bf$export$fd1450327e6900f2(eInput, isInvalid);
        }
    }
    getValidity() {
        return this.dateComp?.getGui().querySelector($437b23f6a393c3bf$var$CLASS_INPUT_FIELD)?.validity;
    }
};
function $437b23f6a393c3bf$var$reportValidity(eInput) {
    eInput.reportValidity();
}
// packages/ag-grid-community/src/filter/provided/date/dateFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS = [
    "equals",
    "notEqual",
    "lessThan",
    "greaterThan",
    "inRange",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/date/dateFilterUtils.ts
function $437b23f6a393c3bf$var$mapValuesFromDateFilterModel(filterModel, optionsFactory) {
    const { dateFrom: dateFrom, dateTo: dateTo, type: type } = filterModel || {};
    return [
        dateFrom && $437b23f6a393c3bf$export$26ded2d88c01b527(dateFrom, void 0, true) || null,
        dateTo && $437b23f6a393c3bf$export$26ded2d88c01b527(dateTo, void 0, true) || null
    ].slice(0, $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory));
}
// packages/ag-grid-community/src/filter/provided/date/dateFilter.ts
var $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR = 1e3;
var $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR = Infinity;
var $437b23f6a393c3bf$var$DateFilter = class extends $437b23f6a393c3bf$var$SimpleFilter {
    constructor(){
        super("dateFilter", $437b23f6a393c3bf$var$mapValuesFromDateFilterModel, $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS);
        this.eConditionPanelsFrom = [];
        this.eConditionPanelsTo = [];
        this.dateConditionFromComps = [];
        this.dateConditionToComps = [];
        this.minValidYear = $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR;
        this.maxValidYear = $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR;
        this.minValidDate = null;
        this.maxValidDate = null;
        this.filterType = "date";
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.dateConditionFromComps[0].afterGuiAttached(params);
        this.refreshInputValidation();
    }
    shouldKeepInvalidInputState() {
        return !$437b23f6a393c3bf$export$ca98fb7c82ac5538() && this.hasInvalidInputs() && this.getConditionTypes().includes("inRange");
    }
    commonUpdateSimpleParams(params) {
        super.commonUpdateSimpleParams(params);
        const yearParser = (param, fallback)=>{
            const value = params[param];
            if (value != null) {
                if (!isNaN(value)) return value == null ? fallback : Number(value);
                else $437b23f6a393c3bf$export$545083624300f13d(82, {
                    param: param
                });
            }
            return fallback;
        };
        const minValidYear = yearParser("minValidYear", $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR);
        const maxValidYear = yearParser("maxValidYear", $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR);
        this.minValidYear = minValidYear;
        this.maxValidYear = maxValidYear;
        if (minValidYear > maxValidYear) $437b23f6a393c3bf$export$545083624300f13d(83);
        const { minValidDate: minValidDate, maxValidDate: maxValidDate } = params;
        const parsedMinValidDate = minValidDate instanceof Date ? minValidDate : $437b23f6a393c3bf$export$26ded2d88c01b527(minValidDate);
        this.minValidDate = parsedMinValidDate;
        const parsedMaxValidDate = maxValidDate instanceof Date ? maxValidDate : $437b23f6a393c3bf$export$26ded2d88c01b527(maxValidDate);
        this.maxValidDate = parsedMaxValidDate;
        if (parsedMinValidDate && parsedMaxValidDate && parsedMinValidDate > parsedMaxValidDate) $437b23f6a393c3bf$export$545083624300f13d(84);
    }
    refreshInputValidation() {
        for(let i = 0; i < this.dateConditionFromComps.length; i++)this.refreshInputPairValidation(i, false, true);
    }
    refreshInputPairValidation(position, isFrom = false, forceImmediate = false) {
        const { dateConditionFromComps: dateConditionFromComps, dateConditionToComps: dateConditionToComps, beans: beans } = this;
        const from = dateConditionFromComps[position];
        const to = dateConditionToComps[position];
        const fromDate = from.getDate();
        const toDate = to.getDate();
        const localeKey = $437b23f6a393c3bf$var$getValidityMessageKey(fromDate, toDate, isFrom);
        const message = localeKey ? this.translate(localeKey, [
            String(isFrom ? toDate : fromDate)
        ]) : "";
        const shouldDebounceReport = !$437b23f6a393c3bf$export$ca98fb7c82ac5538() && !forceImmediate;
        (isFrom ? from : to).setCustomValidity(message, shouldDebounceReport);
        (isFrom ? to : from).setCustomValidity("", shouldDebounceReport);
        if (message.length > 0) beans.ariaAnnounce.announceValue(message, "dateFilter");
    }
    createDateCompWrapper(element, position, fromTo) {
        const { beans: { userCompFactory: userCompFactory, context: context, gos: gos }, params: params } = this;
        const isFrom = fromTo === "from";
        const dateCompWrapper = new $437b23f6a393c3bf$var$DateCompWrapper(context, userCompFactory, params.colDef, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            onDateChanged: ()=>{
                this.refreshInputPairValidation(position, isFrom);
                this.onUiChanged();
            },
            onFocusIn: ()=>this.refreshInputPairValidation(position, isFrom),
            filterParams: params,
            location: "filter"
        }), element);
        this.addDestroyFunc(()=>dateCompWrapper.destroy());
        return dateCompWrapper;
    }
    getState() {
        return {
            isInvalid: this.hasInvalidInputs()
        };
    }
    areStatesEqual(stateA, stateB) {
        return (stateA?.isInvalid ?? false) === (stateB?.isInvalid ?? false);
    }
    setElementValue(element, value) {
        element.setDate(value);
        if (!value) element.setCustomValidity("");
    }
    setElementDisplayed(element, displayed) {
        element.setDisplayed(displayed);
    }
    setElementDisabled(element, disabled) {
        element.setDisabled(disabled);
    }
    createEValue() {
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body"
        });
        this.createFromToElement(eCondition, this.eConditionPanelsFrom, this.dateConditionFromComps, "from");
        this.createFromToElement(eCondition, this.eConditionPanelsTo, this.dateConditionToComps, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eConditionPanels, dateConditionComps, fromTo) {
        const eConditionPanel = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: `ag-filter-${fromTo} ag-filter-date-${fromTo}`
        });
        eConditionPanels.push(eConditionPanel);
        eCondition.appendChild(eConditionPanel);
        dateConditionComps.push(this.createDateCompWrapper(eConditionPanel, eConditionPanels.length - 1, fromTo));
    }
    removeEValues(startPosition, deleteCount) {
        this.removeDateComps(this.dateConditionFromComps, startPosition, deleteCount);
        this.removeDateComps(this.dateConditionToComps, startPosition, deleteCount);
        $437b23f6a393c3bf$var$removeItems(this.eConditionPanelsFrom, startPosition, deleteCount);
        $437b23f6a393c3bf$var$removeItems(this.eConditionPanelsTo, startPosition, deleteCount);
    }
    removeDateComps(components, startPosition, deleteCount) {
        const removedComponents = $437b23f6a393c3bf$var$removeItems(components, startPosition, deleteCount);
        for (const comp of removedComponents)comp.destroy();
    }
    isValidDateValue(value) {
        if (value === null) return false;
        const { minValidDate: minValidDate, maxValidDate: maxValidDate, minValidYear: minValidYear, maxValidYear: maxValidYear } = this;
        if (minValidDate) {
            if (value < minValidDate) return false;
        } else if (value.getUTCFullYear() < minValidYear) return false;
        if (maxValidDate) {
            if (value > maxValidDate) return false;
        } else if (value.getUTCFullYear() > maxValidYear) return false;
        return true;
    }
    hasInvalidInputs() {
        let invalidInputs = false;
        this.forEachInput((element)=>invalidInputs || (invalidInputs = element.getDate() != null && !(element.getValidity()?.valid ?? true)));
        return invalidInputs;
    }
    positionHasInvalidInputs(position) {
        let invalidInputs = false;
        this.forEachPositionInput(position, (element)=>invalidInputs || (invalidInputs = !(element.getValidity()?.valid ?? true)));
        return invalidInputs;
    }
    canApply(_model) {
        return !this.hasInvalidInputs();
    }
    isConditionUiComplete(position) {
        if (!super.isConditionUiComplete(position)) return false;
        let valid = true;
        this.forEachPositionInput(position, (element, index, _pos, numberOfInputs)=>{
            if (!valid || index >= numberOfInputs) return;
            valid && (valid = this.isValidDateValue(element.getDate()));
        });
        return valid;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.dateFrom === bSimple.dateFrom && aSimple.dateTo === bSimple.dateTo && aSimple.type === bSimple.type;
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {};
        const values = this.getValues(position);
        const separator = this.params.useIsoSeparator ? "T" : " ";
        if (values.length > 0) model.dateFrom = $437b23f6a393c3bf$export$3d7fedfb21962874(values[0], true, separator);
        if (values.length > 1) model.dateTo = $437b23f6a393c3bf$export$3d7fedfb21962874(values[1], true, separator);
        return {
            dateFrom: null,
            dateTo: null,
            filterType: this.filterType,
            type: type,
            ...model
        };
    }
    removeConditionsAndOperators(startPosition, deleteCount) {
        if (this.hasInvalidInputs()) return;
        return super.removeConditionsAndOperators(startPosition, deleteCount);
    }
    resetPlaceholder() {
        const globalTranslate = this.getLocaleTextFunc();
        const placeholder = this.translate("dateFormatOoo");
        const ariaLabel = globalTranslate("ariaFilterValue", "Filter Value");
        this.forEachInput((element)=>{
            element.setInputPlaceholder(placeholder);
            element.setInputAriaLabel(ariaLabel);
        });
    }
    getInputs(position) {
        const { dateConditionFromComps: dateConditionFromComps, dateConditionToComps: dateConditionToComps } = this;
        if (position >= dateConditionFromComps.length) return [
            null,
            null
        ];
        return [
            dateConditionFromComps[position],
            dateConditionToComps[position]
        ];
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push(element.getDate());
        });
        return result;
    }
    translate(key, variableValues) {
        let normalisedKey = key;
        if (key === "lessThan") normalisedKey = "before";
        else if (key === "greaterThan") normalisedKey = "after";
        return super.translate(normalisedKey, variableValues);
    }
};
function $437b23f6a393c3bf$var$getValidityMessageKey(fromDate, toDate, isFrom) {
    const isInvalid = fromDate != null && toDate != null && fromDate >= toDate;
    if (!isInvalid) return null;
    return `${isFrom ? "max" : "min"}DateValidation`;
}
// packages/ag-grid-community/src/filter/provided/simpleFilterHandler.ts
var $437b23f6a393c3bf$var$SimpleFilterHandler = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(mapValuesFromModel, defaultOptions){
        super();
        this.mapValuesFromModel = mapValuesFromModel;
        this.defaultOptions = defaultOptions;
    }
    init(params) {
        const filterParams = params.filterParams;
        const optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory = optionsFactory;
        optionsFactory.init(filterParams, this.defaultOptions);
        this.filterModelFormatter = this.createManagedBean(new this.FilterModelFormatterClass(optionsFactory, filterParams));
        this.updateParams(params);
        this.validateModel(params);
    }
    refresh(params) {
        if (params.source === "colDef") {
            const filterParams = params.filterParams;
            const optionsFactory = this.optionsFactory;
            optionsFactory.refresh(filterParams, this.defaultOptions);
            this.filterModelFormatter.updateParams({
                optionsFactory: optionsFactory,
                filterParams: filterParams
            });
            this.updateParams(params);
        }
        this.validateModel(params);
    }
    updateParams(params) {
        this.params = params;
    }
    doesFilterPass(params) {
        const model = params.model;
        if (model == null) return true;
        const { operator: operator } = model;
        const models = [];
        if (operator) {
            const combinedModel = model;
            models.push(...combinedModel.conditions ?? []);
        } else models.push(model);
        const combineFunction = operator && operator === "OR" ? "some" : "every";
        const cellValue = this.params.getValue(params.node);
        return models[combineFunction]((m)=>this.individualConditionPasses(params, m, cellValue));
    }
    getModelAsString(model, source) {
        return this.filterModelFormatter.getModelAsString(model, source) ?? "";
    }
    validateModel(params) {
        const { model: model, filterParams: { filterOptions: filterOptions, maxNumConditions: maxNumConditions } } = params;
        if (model == null) return;
        const isCombined = $437b23f6a393c3bf$export$a3f343af66a0c1bd(model);
        let conditions = isCombined ? model.conditions : [
            model
        ];
        const newOptionsList = filterOptions?.map((option)=>typeof option === "string" ? option : option.displayKey) ?? this.defaultOptions;
        const allConditionsExistInNewOptionsList = !conditions || conditions.every((condition)=>newOptionsList.find((option)=>option === condition.type) !== void 0);
        if (!allConditionsExistInNewOptionsList) {
            this.params = {
                ...params,
                model: null
            };
            params.onModelChange(null);
            return;
        }
        let needsUpdate = false;
        const filterType = this.filterType;
        if (conditions && !conditions.every((condition)=>condition.filterType === filterType) || model.filterType !== filterType) {
            conditions = conditions.map((condition)=>({
                    ...condition,
                    filterType: filterType
                }));
            needsUpdate = true;
        }
        if (typeof maxNumConditions === "number" && conditions && conditions.length > maxNumConditions) {
            conditions = conditions.slice(0, maxNumConditions);
            needsUpdate = true;
        }
        if (needsUpdate) {
            const updatedModel = conditions.length > 1 ? {
                ...model,
                filterType: filterType,
                conditions: conditions
            } : {
                ...conditions[0],
                filterType: filterType
            };
            this.params = {
                ...params,
                model: updatedModel
            };
            params.onModelChange(updatedModel);
        }
    }
    /** returns true if the row passes the said condition */ individualConditionPasses(params, filterModel, cellValue) {
        const optionsFactory = this.optionsFactory;
        const values = this.mapValuesFromModel(filterModel, optionsFactory);
        const customFilterOption = optionsFactory.getCustomOption(filterModel.type);
        const customFilterResult = $437b23f6a393c3bf$var$evaluateCustomFilter(customFilterOption, values, cellValue);
        if (customFilterResult != null) return customFilterResult;
        if (cellValue == null) return this.evaluateNullValue(filterModel.type);
        return this.evaluateNonNullValue(values, cellValue, filterModel, params);
    }
};
// packages/ag-grid-community/src/filter/provided/scalarFilterHandler.ts
var $437b23f6a393c3bf$var$ScalarFilterHandler = class extends $437b23f6a393c3bf$var$SimpleFilterHandler {
    evaluateNullValue(filterType) {
        const { includeBlanksInEquals: includeBlanksInEquals, includeBlanksInNotEqual: includeBlanksInNotEqual, includeBlanksInGreaterThan: includeBlanksInGreaterThan, includeBlanksInLessThan: includeBlanksInLessThan, includeBlanksInRange: includeBlanksInRange } = this.params.filterParams;
        switch(filterType){
            case "equals":
                if (includeBlanksInEquals) return true;
                break;
            case "notEqual":
                if (includeBlanksInNotEqual) return true;
                break;
            case "greaterThan":
            case "greaterThanOrEqual":
                if (includeBlanksInGreaterThan) return true;
                break;
            case "lessThan":
            case "lessThanOrEqual":
                if (includeBlanksInLessThan) return true;
                break;
            case "inRange":
                if (includeBlanksInRange) return true;
                break;
            case "blank":
                return true;
            case "notBlank":
                return false;
        }
        return false;
    }
    evaluateNonNullValue(values, cellValue, filterModel) {
        const type = filterModel.type;
        if (!this.isValid(cellValue)) return type === "notEqual" || type === "notBlank";
        const comparator = this.comparator();
        const compareResult = values[0] != null ? comparator(values[0], cellValue) : 0;
        switch(type){
            case "equals":
                return compareResult === 0;
            case "notEqual":
                return compareResult !== 0;
            case "greaterThan":
                return compareResult > 0;
            case "greaterThanOrEqual":
                return compareResult >= 0;
            case "lessThan":
                return compareResult < 0;
            case "lessThanOrEqual":
                return compareResult <= 0;
            case "inRange":
                {
                    const compareToResult = comparator(values[1], cellValue);
                    return this.params.filterParams.inRangeInclusive ? compareResult >= 0 && compareToResult <= 0 : compareResult > 0 && compareToResult < 0;
                }
            case "blank":
                return $437b23f6a393c3bf$var$isBlank(cellValue);
            case "notBlank":
                return !$437b23f6a393c3bf$var$isBlank(cellValue);
            default:
                $437b23f6a393c3bf$export$545083624300f13d(76, {
                    filterModelType: type
                });
                return true;
        }
    }
};
// packages/ag-grid-community/src/filter/provided/simpleFilterModelFormatter.ts
var $437b23f6a393c3bf$var$SCALAR_FILTER_TYPE_KEYS = {
    equals: "Equals",
    notEqual: "NotEqual",
    greaterThan: "GreaterThan",
    greaterThanOrEqual: "GreaterThanOrEqual",
    lessThan: "LessThan",
    lessThanOrEqual: "LessThanOrEqual",
    inRange: "InRange"
};
var $437b23f6a393c3bf$var$TEXT_FILTER_TYPE_KEYS = {
    contains: "Contains",
    notContains: "NotContains",
    equals: "TextEquals",
    notEqual: "TextNotEqual",
    startsWith: "StartsWith",
    endsWith: "EndsWith",
    inRange: "InRange"
};
var $437b23f6a393c3bf$var$SimpleFilterModelFormatter = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(optionsFactory, filterParams, valueFormatter){
        super();
        this.optionsFactory = optionsFactory;
        this.filterParams = filterParams;
        this.valueFormatter = valueFormatter;
    }
    // used by:
    // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
    // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
    getModelAsString(model, source) {
        const translate = this.getLocaleTextFunc();
        const forToolPanel = source === "filterToolPanel";
        if (!model) return forToolPanel ? $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, "filterSummaryInactive") : null;
        const isCombined = model.operator != null;
        if (isCombined) {
            const combinedModel = model;
            const conditions = combinedModel.conditions ?? [];
            const customOptions = conditions.map((condition)=>this.getModelAsString(condition, source));
            const joinOperatorTranslateKey = combinedModel.operator === "AND" ? "andCondition" : "orCondition";
            return customOptions.join(` ${$437b23f6a393c3bf$export$e2a0ae4af921fff8(this, joinOperatorTranslateKey)} `);
        } else if (model.type === "blank" || model.type === "notBlank") return forToolPanel ? $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, model.type === "blank" ? "filterSummaryBlank" : "filterSummaryNotBlank") : translate(model.type, model.type);
        else {
            const condition = model;
            const customOption = this.optionsFactory.getCustomOption(condition.type);
            const { displayKey: displayKey, displayName: displayName, numberOfInputs: numberOfInputs } = customOption || {};
            if (displayKey && displayName && numberOfInputs === 0) return translate(displayKey, displayName);
            return this.conditionToString(condition, forToolPanel, condition.type === "inRange" || numberOfInputs === 2, displayKey, displayName);
        }
    }
    updateParams(params) {
        const { optionsFactory: optionsFactory, filterParams: filterParams } = params;
        this.optionsFactory = optionsFactory;
        this.filterParams = filterParams;
    }
    conditionForToolPanel(type, isRange, getFilter, getFilterTo, customDisplayKey, customDisplayName) {
        let typeValue;
        const typeKey = this.getTypeKey(type);
        if (typeKey) typeValue = $437b23f6a393c3bf$export$e2a0ae4af921fff8(this, typeKey);
        if (customDisplayKey && customDisplayName) typeValue = this.getLocaleTextFunc()(customDisplayKey, customDisplayName);
        if (typeValue != null) {
            if (isRange) return `${typeValue} ${$437b23f6a393c3bf$export$e2a0ae4af921fff8(this, "filterSummaryInRangeValues", [
                getFilter(),
                getFilterTo()
            ])}`;
            else return `${typeValue} ${getFilter()}`;
        }
        return null;
    }
    getTypeKey(type) {
        const suffix = this.filterTypeKeys[type];
        return suffix ? `filterSummary${suffix}` : null;
    }
    formatValue(value) {
        const valueFormatter = this.valueFormatter;
        return valueFormatter ? valueFormatter(value ?? null) ?? "" : String(value);
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFilterModelFormatter.ts
var $437b23f6a393c3bf$var$DateFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    constructor(optionsFactory, filterParams){
        super(optionsFactory, filterParams, (value)=>{
            const { dataTypeSvc: dataTypeSvc, valueSvc: valueSvc } = this.beans;
            const column = filterParams.column;
            const dateFormatFn = dataTypeSvc?.getDateFormatterFunction(column);
            const valueToFormat = dateFormatFn ? dateFormatFn(value ?? void 0) : value;
            return valueSvc.formatValue(column, null, valueToFormat);
        });
        this.filterTypeKeys = $437b23f6a393c3bf$var$SCALAR_FILTER_TYPE_KEYS;
    }
    conditionToString(condition, forToolPanel, isRange, customDisplayKey, customDisplayName) {
        const { type: type } = condition;
        const dateFrom = $437b23f6a393c3bf$export$26ded2d88c01b527(condition.dateFrom);
        const dateTo = $437b23f6a393c3bf$export$26ded2d88c01b527(condition.dateTo);
        const format = this.filterParams.inRangeFloatingFilterDateFormat;
        const formatDate = forToolPanel ? this.formatValue.bind(this) : (value)=>$437b23f6a393c3bf$var$_dateToFormattedString(value, format);
        const formattedFrom = ()=>dateFrom !== null ? formatDate(dateFrom) : "null";
        const formattedTo = ()=>dateTo !== null ? formatDate(dateTo) : "null";
        if (forToolPanel) {
            const valueForToolPanel = this.conditionForToolPanel(type, isRange, formattedFrom, formattedTo, customDisplayKey, customDisplayName);
            if (valueForToolPanel != null) return valueForToolPanel;
        }
        if (isRange) return `${formattedFrom()}-${formattedTo()}`;
        if (dateFrom != null) return formatDate(dateFrom);
        return `${type}`;
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFilterHandler.ts
function $437b23f6a393c3bf$var$defaultDateComparator(filterDate, cellValue) {
    const cellAsDate = cellValue;
    if (cellAsDate < filterDate) return -1;
    if (cellAsDate > filterDate) return 1;
    return 0;
}
var $437b23f6a393c3bf$var$DateFilterHandler = class extends $437b23f6a393c3bf$var$ScalarFilterHandler {
    constructor(){
        super($437b23f6a393c3bf$var$mapValuesFromDateFilterModel, $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS);
        this.filterType = "date";
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$DateFilterModelFormatter;
    }
    comparator() {
        return this.params.filterParams.comparator ?? $437b23f6a393c3bf$var$defaultDateComparator;
    }
    isValid(value) {
        const isValidDate2 = this.params.filterParams.isValidDate;
        return !isValidDate2 || isValidDate2(value);
    }
};
// packages/ag-grid-community/src/filter/floating/provided/simpleFloatingFilter.ts
var $437b23f6a393c3bf$var$SimpleFloatingFilter = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        this.defaultDebounceMs = 0;
    }
    setLastTypeFromModel(model) {
        if (!model) {
            this.lastType = this.optionsFactory.defaultOption;
            return;
        }
        const isCombined = model.operator;
        let condition;
        if (isCombined) {
            const combinedModel = model;
            condition = combinedModel.conditions[0];
        } else condition = model;
        this.lastType = condition.type;
    }
    canWeEditAfterModelFromParentFilter(model) {
        if (!model) return this.isTypeEditable(this.lastType);
        const isCombined = model.operator;
        if (isCombined) return false;
        const simpleModel = model;
        return this.isTypeEditable(simpleModel.type);
    }
    init(params) {
        this.params = params;
        const reactive = this.gos.get("enableFilterHandlers");
        this.reactive = reactive;
        this.setParams(params);
        if (reactive) {
            const reactiveParams = params;
            this.onModelUpdated(reactiveParams.model);
        }
    }
    setParams(params) {
        const optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory = optionsFactory;
        optionsFactory.init(params.filterParams, this.defaultOptions);
        this.filterModelFormatter = this.createManagedBean(new this.FilterModelFormatterClass(optionsFactory, params.filterParams));
        this.setSimpleParams(params, false);
    }
    setSimpleParams(params, update = true) {
        const defaultOption = this.optionsFactory.defaultOption;
        if (!update) this.lastType = defaultOption;
        this.readOnly = !!params.filterParams.readOnly;
        const editable = this.isTypeEditable(defaultOption);
        this.setEditable(editable);
    }
    refresh(params) {
        this.params = params;
        const reactiveParams = params;
        const reactive = this.reactive;
        if (!reactive || reactiveParams.source === "colDef") this.updateParams(params);
        if (reactive) {
            const { source: source, model: model } = reactiveParams;
            if (source === "dataChanged" || source === "ui") return;
            this.onModelUpdated(model);
        }
    }
    updateParams(params) {
        const optionsFactory = this.optionsFactory;
        optionsFactory.refresh(params.filterParams, this.defaultOptions);
        this.setSimpleParams(params);
        this.filterModelFormatter.updateParams({
            optionsFactory: optionsFactory,
            filterParams: params.filterParams
        });
    }
    onParentModelChanged(model, event) {
        if (event?.afterFloatingFilter || event?.afterDataChange) return;
        this.onModelUpdated(model);
    }
    hasSingleInput(filterType) {
        const numberOfInputs = this.optionsFactory.getCustomOption(filterType)?.numberOfInputs;
        return numberOfInputs == null || numberOfInputs == 1;
    }
    isTypeEditable(type) {
        const uneditableTypes = [
            "inRange",
            "empty",
            "blank",
            "notBlank"
        ];
        return !!type && !this.readOnly && this.hasSingleInput(type) && uneditableTypes.indexOf(type) < 0;
    }
    getAriaLabel(column) {
        const displayName = this.beans.colNames.getDisplayNameForColumn(column, "header", true);
        return `${displayName} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`;
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFloatingFilter.ts
var $437b23f6a393c3bf$var$DateFloatingFilterElement = {
    tag: "div",
    cls: "ag-floating-filter-input",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eReadOnlyText"
        },
        {
            tag: "div",
            ref: "eDateWrapper",
            cls: "ag-date-floating-filter-wrapper"
        }
    ]
};
var $437b23f6a393c3bf$var$DateFloatingFilter = class extends $437b23f6a393c3bf$var$SimpleFloatingFilter {
    constructor(){
        super($437b23f6a393c3bf$var$DateFloatingFilterElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eReadOnlyText = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDateWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$DateFilterModelFormatter;
        this.filterType = "date";
        this.defaultOptions = $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS;
    }
    setParams(params) {
        super.setParams(params);
        this.createDateComponent();
        const translate = this.getLocaleTextFunc();
        this.eReadOnlyText.setDisabled(true).setInputAriaLabel(translate("ariaDateFilterInput", "Date Filter Input"));
    }
    updateParams(params) {
        super.updateParams(params);
        this.dateComp.updateParams(this.getDateComponentParams());
        this.updateCompOnModelChange(params.currentParentModel());
    }
    updateCompOnModelChange(model) {
        const allowEditing = !this.readOnly && this.canWeEditAfterModelFromParentFilter(model);
        this.setEditable(allowEditing);
        if (allowEditing) {
            const dateModel = model ? $437b23f6a393c3bf$export$26ded2d88c01b527(model.dateFrom) : null;
            this.dateComp.setDate(dateModel);
            this.eReadOnlyText.setValue("");
        } else {
            this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(model));
            this.dateComp.setDate(null);
        }
    }
    setEditable(editable) {
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eDateWrapper, editable);
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eReadOnlyText.getGui(), !editable);
    }
    onModelUpdated(model) {
        super.setLastTypeFromModel(model);
        this.updateCompOnModelChange(model);
    }
    onDateChanged() {
        const filterValueDate = this.dateComp.getDate();
        if (this.reactive) {
            const reactiveParams = this.params;
            reactiveParams.onUiChange();
            const model = reactiveParams.model;
            const filterValueText = $437b23f6a393c3bf$export$3d7fedfb21962874(filterValueDate);
            const newModel = filterValueText == null ? null : {
                ...model ?? {
                    filterType: this.filterType,
                    type: this.lastType ?? this.optionsFactory.defaultOption
                },
                dateFrom: filterValueText
            };
            reactiveParams.onModelChange(newModel, {
                afterFloatingFilter: true
            });
        } else this.params.parentFilterInstance((filterInstance)=>{
            filterInstance?.onFloatingFilterChanged(this.lastType || null, filterValueDate);
        });
    }
    getDateComponentParams() {
        const { filterParams: filterParams } = this.params;
        const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(filterParams, this.defaultDebounceMs);
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            onDateChanged: $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onDateChanged.bind(this), debounceMs),
            filterParams: filterParams,
            location: "floatingFilter"
        });
    }
    createDateComponent() {
        const { beans: { context: context, userCompFactory: userCompFactory }, eDateWrapper: eDateWrapper, params: { column: column } } = this;
        this.dateComp = new $437b23f6a393c3bf$var$DateCompWrapper(context, userCompFactory, column.getColDef(), this.getDateComponentParams(), eDateWrapper, (dateComp)=>{
            dateComp.setInputAriaLabel(this.getAriaLabel(column));
        });
        this.addDestroyFunc(()=>this.dateComp.destroy());
    }
};
// packages/ag-grid-community/src/filter/provided/date/defaultDateComponent.ts
var $437b23f6a393c3bf$var$DefaultDateElement = {
    tag: "div",
    cls: "ag-filter-filter",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eDateInput",
            cls: "ag-date-filter"
        }
    ]
};
var $437b23f6a393c3bf$var$DefaultDateComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$DefaultDateElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eDateInput = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isApply = false;
        this.applyOnFocusOut = false;
    }
    init(params) {
        this.params = params;
        this.setParams(params);
        const inputElement = this.eDateInput.getInputElement();
        this.addManagedListeners(inputElement, {
            // ensures that the input element is focussed when a clear button is clicked,
            // unless using safari as there is no clear button and focus does not work properly
            mouseDown: ()=>{
                if (this.eDateInput.isDisabled() || this.usingSafariDatePicker) return;
                inputElement.focus({
                    preventScroll: true
                });
            },
            input: this.handleInput.bind(this, false),
            change: this.handleInput.bind(this, true),
            focusout: this.handleFocusOut.bind(this),
            focusin: this.handleFocusIn.bind(this)
        });
    }
    handleInput(isChange) {
        if (this.eDateInput.isDisabled()) return;
        if (this.isApply) {
            this.applyOnFocusOut = !isChange;
            if (isChange) this.params.onDateChanged();
            return;
        }
        if (!isChange) this.params.onDateChanged();
    }
    handleFocusOut() {
        if (this.applyOnFocusOut) {
            this.applyOnFocusOut = false;
            this.params.onDateChanged();
        }
    }
    handleFocusIn() {
        this.params.onFocusIn?.();
    }
    setParams(params) {
        const inputElement = this.eDateInput.getInputElement();
        const shouldUseBrowserDatePicker = this.shouldUseBrowserDatePicker(params);
        this.usingSafariDatePicker = shouldUseBrowserDatePicker && $437b23f6a393c3bf$export$8caf403dacd36a68();
        const { minValidYear: minValidYear, maxValidYear: maxValidYear, minValidDate: minValidDate, maxValidDate: maxValidDate, buttons: buttons, includeTime: includeTime, colDef: colDef } = params.filterParams || {};
        const dataTypeSvc = this.beans.dataTypeSvc;
        const shouldUseDateTimeLocal = includeTime ?? dataTypeSvc?.getDateIncludesTimeFlag?.(colDef.cellDataType) ?? false;
        if (shouldUseBrowserDatePicker) {
            if (shouldUseDateTimeLocal) {
                inputElement.type = "datetime-local";
                inputElement.step = "1";
            } else inputElement.type = "date";
        } else inputElement.type = "text";
        if (minValidDate && minValidYear) $437b23f6a393c3bf$export$545083624300f13d(85);
        if (maxValidDate && maxValidYear) $437b23f6a393c3bf$export$545083624300f13d(86);
        if (minValidDate && maxValidDate) {
            const [parsedMinValidDate, parsedMaxValidDate] = [
                minValidDate,
                maxValidDate
            ].map((v)=>v instanceof Date ? v : $437b23f6a393c3bf$export$26ded2d88c01b527(v));
            if (parsedMinValidDate && parsedMaxValidDate && parsedMinValidDate.getTime() > parsedMaxValidDate.getTime()) $437b23f6a393c3bf$export$545083624300f13d(87);
        }
        if (minValidDate) {
            if (minValidDate instanceof Date) inputElement.min = $437b23f6a393c3bf$var$_dateToFormattedString(minValidDate);
            else inputElement.min = minValidDate;
        } else if (minValidYear) inputElement.min = `${minValidYear}-01-01`;
        if (maxValidDate) {
            if (maxValidDate instanceof Date) inputElement.max = $437b23f6a393c3bf$var$_dateToFormattedString(maxValidDate);
            else inputElement.max = maxValidDate;
        } else if (maxValidYear) inputElement.max = `${maxValidYear}-12-31`;
        this.isApply = params.location === "floatingFilter" && !!buttons?.includes("apply");
    }
    refresh(params) {
        this.params = params;
        this.setParams(params);
    }
    getDate() {
        return $437b23f6a393c3bf$export$26ded2d88c01b527(this.eDateInput.getValue());
    }
    setDate(date) {
        const colType = this.params.filterParams.colDef.cellDataType;
        const includeTime = this.beans.dataTypeSvc?.getDateIncludesTimeFlag(colType) ?? false;
        this.eDateInput.setValue($437b23f6a393c3bf$export$3d7fedfb21962874(date, includeTime));
    }
    setInputPlaceholder(placeholder) {
        this.eDateInput.setInputPlaceholder(placeholder);
    }
    setInputAriaLabel(ariaLabel) {
        this.eDateInput.setAriaLabel(ariaLabel);
    }
    setDisabled(disabled) {
        this.eDateInput.setDisabled(disabled);
    }
    afterGuiAttached(params) {
        if (!params?.suppressFocus) this.eDateInput.getInputElement().focus({
            preventScroll: true
        });
    }
    shouldUseBrowserDatePicker(params) {
        return params?.filterParams?.browserDatePicker ?? true;
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS = [
    "equals",
    "notEqual",
    "greaterThan",
    "greaterThanOrEqual",
    "lessThan",
    "lessThanOrEqual",
    "inRange",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/number/numberFilterUtils.ts
function $437b23f6a393c3bf$var$getAllowedCharPattern(filterParams) {
    return filterParams?.allowedCharPattern ?? null;
}
function $437b23f6a393c3bf$var$processNumberFilterValue(value) {
    if (value == null) return null;
    return isNaN(value) ? null : value;
}
function $437b23f6a393c3bf$var$mapValuesFromNumberFilterModel(filterModel, optionsFactory) {
    const { filter: filter, filterTo: filterTo, type: type } = filterModel || {};
    return [
        $437b23f6a393c3bf$var$processNumberFilterValue(filter),
        $437b23f6a393c3bf$var$processNumberFilterValue(filterTo)
    ].slice(0, $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory));
}
// packages/ag-grid-community/src/filter/provided/number/numberFilter.ts
var $437b23f6a393c3bf$var$NumberFilter = class extends $437b23f6a393c3bf$var$SimpleFilter {
    constructor(){
        super("numberFilter", $437b23f6a393c3bf$var$mapValuesFromNumberFilterModel, $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS);
        this.eValuesFrom = [];
        this.eValuesTo = [];
        this.filterType = "number";
        this.defaultDebounceMs = 500;
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.refreshInputValidation();
    }
    shouldKeepInvalidInputState() {
        return !$437b23f6a393c3bf$export$ca98fb7c82ac5538() && this.hasInvalidInputs() && this.getConditionTypes().includes("inRange");
    }
    refreshInputValidation() {
        for(let i = 0; i < this.eValuesFrom.length; i++){
            const from = this.eValuesFrom[i];
            const to = this.eValuesTo[i];
            this.refreshInputPairValidation(from, to);
        }
    }
    refreshInputPairValidation(from, to, isFrom = false) {
        const parser = this.params.numberParser;
        const fromValue = $437b23f6a393c3bf$var$getNormalisedValue(parser, from);
        const toValue = $437b23f6a393c3bf$var$getNormalisedValue(parser, to);
        const localeKey = $437b23f6a393c3bf$var$getValidityMessageKey2(fromValue, toValue, isFrom);
        const validityMessage = localeKey ? this.translate(localeKey, [
            String(isFrom ? toValue : fromValue)
        ]) : "";
        (isFrom ? from : to).setCustomValidity(validityMessage);
        (isFrom ? to : from).setCustomValidity("");
        if (validityMessage.length > 0) this.beans.ariaAnnounce.announceValue(validityMessage, "dateFilter");
    }
    getState() {
        return {
            isInvalid: this.hasInvalidInputs()
        };
    }
    areStatesEqual(stateA, stateB) {
        return (stateA?.isInvalid ?? false) === (stateB?.isInvalid ?? false);
    }
    refresh(legacyNewParams) {
        const result = super.refresh(legacyNewParams);
        const { state: newState, additionalEventAttributes: additionalEventAttributes } = legacyNewParams;
        const oldState = this.state;
        const fromAction = additionalEventAttributes?.fromAction;
        const forceRefreshValidation = fromAction && fromAction != "apply";
        if (forceRefreshValidation || newState.model !== oldState.model || !this.areStatesEqual(newState.state, oldState.state)) this.refreshInputValidation();
        return result;
    }
    setElementValue(element, value, fromFloatingFilter) {
        const { numberFormatter: numberFormatter } = this.params;
        const valueToSet = !fromFloatingFilter && numberFormatter ? numberFormatter(value ?? null) : value;
        super.setElementValue(element, valueToSet);
        if (valueToSet === null) element.setCustomValidity("");
    }
    createEValue() {
        const { params: params, eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        const allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(params);
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body",
            role: "presentation"
        });
        const from = this.createFromToElement(eCondition, eValuesFrom, "from", allowedCharPattern);
        const to = this.createFromToElement(eCondition, eValuesTo, "to", allowedCharPattern);
        const getFieldChangedListener = (from2, to2, isFrom)=>()=>this.refreshInputPairValidation(from2, to2, isFrom);
        const fromListener = getFieldChangedListener(from, to, true);
        from.onValueChange(fromListener);
        from.addGuiEventListener("focusin", fromListener);
        const toListener = getFieldChangedListener(from, to, false);
        to.onValueChange(toListener);
        to.addGuiEventListener("focusin", toListener);
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo, allowedCharPattern) {
        const eValue = this.createManagedBean(allowedCharPattern ? new $437b23f6a393c3bf$export$8c027679838afd47({
            allowedCharPattern: allowedCharPattern
        }) : new $437b23f6a393c3bf$export$c8aa0be99738aee());
        eValue.addCss(`ag-filter-${fromTo}`);
        eValue.addCss("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
        return eValue;
    }
    removeEValues(startPosition, deleteCount) {
        const removeComps = (eGui)=>this.removeComponents(eGui, startPosition, deleteCount);
        removeComps(this.eValuesFrom);
        removeComps(this.eValuesTo);
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push($437b23f6a393c3bf$var$processNumberFilterValue($437b23f6a393c3bf$var$stringToFloat(this.params.numberParser, element.getValue())));
        });
        return result;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.filterType,
            type: type
        };
        const values = this.getValues(position);
        if (values.length > 0) model.filter = values[0];
        if (values.length > 1) model.filterTo = values[1];
        return model;
    }
    removeConditionsAndOperators(startPosition, deleteCount) {
        if (this.hasInvalidInputs()) return;
        return super.removeConditionsAndOperators(startPosition, deleteCount);
    }
    getInputs(position) {
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        if (position >= eValuesFrom.length) return [
            null,
            null
        ];
        return [
            eValuesFrom[position],
            eValuesTo[position]
        ];
    }
    hasInvalidInputs() {
        let invalidInputs = false;
        this.forEachInput((element)=>invalidInputs || (invalidInputs = !element.getInputElement().validity.valid));
        return invalidInputs;
    }
    positionHasInvalidInputs(position) {
        let invalidInputs = false;
        this.forEachPositionInput(position, (element)=>invalidInputs || (invalidInputs = !element.getInputElement().validity.valid));
        return invalidInputs;
    }
    canApply(_model) {
        return !this.hasInvalidInputs();
    }
};
function $437b23f6a393c3bf$var$stringToFloat(numberParser, value) {
    if (typeof value === "number") return value;
    let filterText = $437b23f6a393c3bf$export$4978424c4f7b5fc0(value);
    if (filterText != null && filterText.trim() === "") filterText = null;
    if (numberParser) return numberParser(filterText);
    return filterText == null || filterText.trim() === "-" ? null : Number.parseFloat(filterText);
}
function $437b23f6a393c3bf$var$getNormalisedValue(numberParser, input) {
    return $437b23f6a393c3bf$var$processNumberFilterValue($437b23f6a393c3bf$var$stringToFloat(numberParser, input.getValue(true)));
}
function $437b23f6a393c3bf$var$getValidityMessageKey2(fromValue, toValue, isFrom) {
    const isInvalid = fromValue != null && toValue != null && fromValue >= toValue;
    if (!isInvalid) return null;
    return `strict${isFrom ? "Max" : "Min"}ValueValidation`;
}
// packages/ag-grid-community/src/filter/provided/number/numberFilterModelFormatter.ts
var $437b23f6a393c3bf$var$NumberFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    constructor(optionsFactory, filterParams){
        super(optionsFactory, filterParams, filterParams.numberFormatter);
        this.filterTypeKeys = $437b23f6a393c3bf$var$SCALAR_FILTER_TYPE_KEYS;
    }
    conditionToString(condition, forToolPanel, isRange, customDisplayKey, customDisplayName) {
        const { filter: filter, filterTo: filterTo, type: type } = condition;
        const formatValue = this.formatValue.bind(this);
        if (forToolPanel) {
            const valueForToolPanel = this.conditionForToolPanel(type, isRange, ()=>formatValue(filter), ()=>formatValue(filterTo), customDisplayKey, customDisplayName);
            if (valueForToolPanel != null) return valueForToolPanel;
        }
        if (isRange) return `${formatValue(filter)}-${formatValue(filterTo)}`;
        if (filter != null) return formatValue(filter);
        return `${type}`;
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFilterHandler.ts
var $437b23f6a393c3bf$var$NumberFilterHandler = class extends $437b23f6a393c3bf$var$ScalarFilterHandler {
    constructor(){
        super($437b23f6a393c3bf$var$mapValuesFromNumberFilterModel, $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS);
        this.filterType = "number";
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$NumberFilterModelFormatter;
    }
    comparator() {
        return (left, right)=>{
            if (left === right) return 0;
            return left < right ? 1 : -1;
        };
    }
    isValid(value) {
        return !isNaN(value);
    }
};
// packages/ag-grid-community/src/filter/floating/provided/floatingFilterTextInputService.ts
var $437b23f6a393c3bf$var$FloatingFilterTextInputService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.params = params;
        this.eInput = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.onValueChanged = ()=>{};
    }
    setupGui(parentElement) {
        this.eInput = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47(this.params?.config));
        const eInput = this.eInput.getGui();
        parentElement.appendChild(eInput);
        const listener = (e)=>this.onValueChanged(e);
        this.addManagedListeners(eInput, {
            input: listener,
            keydown: listener
        });
    }
    setEditable(editable) {
        this.eInput.setDisabled(!editable);
    }
    getValue() {
        return this.eInput.getValue();
    }
    setValue(value, silent) {
        this.eInput.setValue(value, silent);
    }
    setValueChangedListener(listener) {
        this.onValueChanged = listener;
    }
    setParams({ ariaLabel: ariaLabel, autoComplete: autoComplete, placeholder: placeholder }) {
        const { eInput: eInput } = this;
        eInput.setInputAriaLabel(ariaLabel);
        if (autoComplete !== void 0) eInput.setAutoComplete(autoComplete);
        eInput.toggleCss("ag-floating-filter-search-icon", !!placeholder);
        eInput.setInputPlaceholder(placeholder);
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterUtils.ts
function $437b23f6a393c3bf$var$trimInputForFilter(value) {
    const trimmedInput = value?.trim();
    return trimmedInput === "" ? value : trimmedInput;
}
function $437b23f6a393c3bf$var$mapValuesFromTextFilterModel(filterModel, optionsFactory) {
    const { filter: filter, filterTo: filterTo, type: type } = filterModel || {};
    return [
        filter || null,
        filterTo || null
    ].slice(0, $437b23f6a393c3bf$var$getNumberOfInputs(type, optionsFactory));
}
// packages/ag-grid-community/src/filter/floating/provided/textInputFloatingFilter.ts
var $437b23f6a393c3bf$var$TextInputFloatingFilterElement = {
    tag: "div",
    ref: "eFloatingFilterInputContainer",
    cls: "ag-floating-filter-input",
    role: "presentation"
};
var $437b23f6a393c3bf$var$TextInputFloatingFilter = class extends $437b23f6a393c3bf$var$SimpleFloatingFilter {
    constructor(){
        super(...arguments);
        this.eFloatingFilterInputContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.defaultDebounceMs = 500;
    }
    postConstruct() {
        this.setTemplate($437b23f6a393c3bf$var$TextInputFloatingFilterElement);
    }
    onModelUpdated(model) {
        this.setLastTypeFromModel(model);
        this.setEditable(this.canWeEditAfterModelFromParentFilter(model));
        this.inputSvc.setValue(this.filterModelFormatter.getModelAsString(model));
    }
    setParams(params) {
        this.setupFloatingFilterInputService(params);
        super.setParams(params);
        this.setTextInputParams(params);
    }
    setupFloatingFilterInputService(params) {
        this.inputSvc = this.createFloatingFilterInputService(params);
        this.inputSvc.setupGui(this.eFloatingFilterInputContainer);
    }
    setTextInputParams(params) {
        const { inputSvc: inputSvc, defaultDebounceMs: defaultDebounceMs, readOnly: readOnly } = this;
        const { filterPlaceholder: filterPlaceholder, column: column, browserAutoComplete: browserAutoComplete, filterParams: filterParams } = params;
        const filterOptionKey = this.lastType ?? this.optionsFactory.defaultOption;
        const parentFilterPlaceholder = params.filterParams.filterPlaceholder;
        const placeholder = filterPlaceholder === true ? $437b23f6a393c3bf$var$getPlaceholderText(this, parentFilterPlaceholder, "filterOoo", filterOptionKey) : filterPlaceholder || void 0;
        inputSvc.setParams({
            ariaLabel: this.getAriaLabel(column),
            autoComplete: browserAutoComplete ?? false,
            placeholder: placeholder
        });
        this.applyActive = $437b23f6a393c3bf$export$527c1b777ebd9069(filterParams);
        if (!readOnly) {
            const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(filterParams, defaultDebounceMs);
            inputSvc.setValueChangedListener($437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.syncUpWithParentFilter.bind(this), debounceMs));
        }
    }
    updateParams(params) {
        super.updateParams(params);
        this.setTextInputParams(params);
    }
    recreateFloatingFilterInputService(params) {
        const { inputSvc: inputSvc } = this;
        const value = inputSvc.getValue();
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.eFloatingFilterInputContainer);
        this.destroyBean(inputSvc);
        this.setupFloatingFilterInputService(params);
        inputSvc.setValue(value, true);
    }
    syncUpWithParentFilter(e) {
        const isEnterKey = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
        const reactive = this.reactive;
        if (reactive) {
            const reactiveParams = this.params;
            reactiveParams.onUiChange();
        }
        if (this.applyActive && !isEnterKey) return;
        const { inputSvc: inputSvc, params: params, lastType: lastType } = this;
        let value = inputSvc.getValue();
        if (params.filterParams.trimInput) {
            value = $437b23f6a393c3bf$var$trimInputForFilter(value);
            inputSvc.setValue(value, true);
        }
        if (reactive) {
            const reactiveParams = params;
            const model = reactiveParams.model;
            const parsedValue = this.convertValue(value);
            const newModel = parsedValue == null ? null : {
                ...model ?? {
                    filterType: this.filterType,
                    type: lastType ?? this.optionsFactory.defaultOption
                },
                filter: parsedValue
            };
            reactiveParams.onModelChange(newModel, {
                afterFloatingFilter: true
            });
        } else params.parentFilterInstance((filterInstance)=>{
            filterInstance?.onFloatingFilterChanged(lastType || null, value || null);
        });
    }
    convertValue(value) {
        return value || null;
    }
    setEditable(editable) {
        this.inputSvc.setEditable(editable);
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFloatingFilter.ts
var $437b23f6a393c3bf$var$FloatingFilterNumberInputService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.onValueChanged = ()=>{};
        this.numberInputActive = true;
    }
    setupGui(parentElement) {
        this.eNumberInput = this.createManagedBean(new $437b23f6a393c3bf$export$c8aa0be99738aee());
        this.eTextInput = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47());
        this.eTextInput.setDisabled(true);
        const eNumberInput = this.eNumberInput.getGui();
        const eTextInput = this.eTextInput.getGui();
        parentElement.appendChild(eNumberInput);
        parentElement.appendChild(eTextInput);
        this.setupListeners(eNumberInput, (e)=>this.onValueChanged(e));
        this.setupListeners(eTextInput, (e)=>this.onValueChanged(e));
    }
    setEditable(editable) {
        this.numberInputActive = editable;
        this.eNumberInput.setDisplayed(this.numberInputActive);
        this.eTextInput.setDisplayed(!this.numberInputActive);
    }
    setAutoComplete(autoComplete) {
        this.eNumberInput.setAutoComplete(autoComplete);
        this.eTextInput.setAutoComplete(autoComplete);
    }
    getValue() {
        return this.getActiveInputElement().getValue();
    }
    setValue(value, silent) {
        this.getActiveInputElement().setValue(value, silent);
    }
    getActiveInputElement() {
        return this.numberInputActive ? this.eNumberInput : this.eTextInput;
    }
    setValueChangedListener(listener) {
        this.onValueChanged = listener;
    }
    setupListeners(element, listener) {
        this.addManagedListeners(element, {
            input: listener,
            keydown: listener
        });
    }
    setParams({ ariaLabel: ariaLabel, autoComplete: autoComplete, placeholder: placeholder }) {
        this.setAriaLabel(ariaLabel);
        if (autoComplete !== void 0) this.setAutoComplete(autoComplete);
        this.setPlaceholder(this.eNumberInput, placeholder);
        this.setPlaceholder(this.eTextInput, placeholder);
    }
    setPlaceholder(input, placeholder) {
        input.toggleCss("ag-floating-filter-search-icon", !!placeholder);
        input.setInputPlaceholder(placeholder);
    }
    setAriaLabel(ariaLabel) {
        this.eNumberInput.setInputAriaLabel(ariaLabel);
        this.eTextInput.setInputAriaLabel(ariaLabel);
    }
};
var $437b23f6a393c3bf$var$NumberFloatingFilter = class extends $437b23f6a393c3bf$var$TextInputFloatingFilter {
    constructor(){
        super(...arguments);
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$NumberFilterModelFormatter;
        this.filterType = "number";
        this.defaultOptions = $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS;
    }
    updateParams(params) {
        const allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(params.filterParams);
        if (allowedCharPattern !== this.allowedCharPattern) this.recreateFloatingFilterInputService(params);
        super.updateParams(params);
    }
    createFloatingFilterInputService(params) {
        this.allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(params.filterParams);
        if (this.allowedCharPattern) return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterTextInputService({
            config: {
                allowedCharPattern: this.allowedCharPattern
            }
        }));
        return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterNumberInputService());
    }
    convertValue(value) {
        return value ? Number(value) : null;
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS = [
    "contains",
    "notContains",
    "equals",
    "notEqual",
    "startsWith",
    "endsWith",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/text/textFilter.ts
var $437b23f6a393c3bf$var$TextFilter = class extends $437b23f6a393c3bf$var$SimpleFilter {
    constructor(){
        super("textFilter", $437b23f6a393c3bf$var$mapValuesFromTextFilterModel, $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS);
        this.filterType = "text";
        this.eValuesFrom = [];
        this.eValuesTo = [];
        this.defaultDebounceMs = 500;
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.filterType,
            type: type
        };
        const values = this.getValues(position);
        if (values.length > 0) model.filter = values[0];
        if (values.length > 1) model.filterTo = values[1];
        return model;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    getInputs(position) {
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        if (position >= eValuesFrom.length) return [
            null,
            null
        ];
        return [
            eValuesFrom[position],
            eValuesTo[position]
        ];
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push($437b23f6a393c3bf$export$4978424c4f7b5fc0(element.getValue()));
        });
        return result;
    }
    createEValue() {
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body",
            role: "presentation"
        });
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        this.createFromToElement(eCondition, eValuesFrom, "from");
        this.createFromToElement(eCondition, eValuesTo, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo) {
        const eValue = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47());
        eValue.addCss(`ag-filter-${fromTo}`);
        eValue.addCss("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
    }
    removeEValues(startPosition, deleteCount) {
        const removeComps = (eGui)=>this.removeComponents(eGui, startPosition, deleteCount);
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        removeComps(eValuesFrom);
        removeComps(eValuesTo);
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterModelFormatter.ts
var $437b23f6a393c3bf$var$TextFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    constructor(){
        super(...arguments);
        this.filterTypeKeys = $437b23f6a393c3bf$var$TEXT_FILTER_TYPE_KEYS;
    }
    conditionToString(condition, forToolPanel, isRange, customDisplayKey, customDisplayName) {
        const { filter: filter, filterTo: filterTo, type: type } = condition;
        if (forToolPanel) {
            const getValueFunc = (value)=>()=>$437b23f6a393c3bf$export$e2a0ae4af921fff8(this, "filterSummaryTextQuote", [
                        value
                    ]);
            const valueForToolPanel = this.conditionForToolPanel(type, isRange, getValueFunc(filter), getValueFunc(filterTo), customDisplayKey, customDisplayName);
            if (valueForToolPanel != null) return valueForToolPanel;
        }
        if (isRange) return `${filter}-${filterTo}`;
        if (filter != null) return `${filter}`;
        return `${type}`;
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterHandler.ts
var $437b23f6a393c3bf$var$defaultMatcher = ({ filterOption: filterOption, value: value, filterText: filterText })=>{
    if (filterText == null) return false;
    switch(filterOption){
        case "contains":
            return value.includes(filterText);
        case "notContains":
            return !value.includes(filterText);
        case "equals":
            return value === filterText;
        case "notEqual":
            return value != filterText;
        case "startsWith":
            return value.indexOf(filterText) === 0;
        case "endsWith":
            {
                const index = value.lastIndexOf(filterText);
                return index >= 0 && index === value.length - filterText.length;
            }
        default:
            return false;
    }
};
var $437b23f6a393c3bf$var$defaultFormatter = (from)=>from;
var $437b23f6a393c3bf$var$defaultLowercaseFormatter = (from)=>from == null ? null : from.toString().toLowerCase();
var $437b23f6a393c3bf$var$TextFilterHandler = class extends $437b23f6a393c3bf$var$SimpleFilterHandler {
    constructor(){
        super($437b23f6a393c3bf$var$mapValuesFromTextFilterModel, $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS);
        this.filterType = "text";
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$TextFilterModelFormatter;
    }
    updateParams(params) {
        super.updateParams(params);
        const filterParams = params.filterParams;
        this.matcher = filterParams.textMatcher ?? $437b23f6a393c3bf$var$defaultMatcher;
        this.formatter = filterParams.textFormatter ?? (filterParams.caseSensitive ? $437b23f6a393c3bf$var$defaultFormatter : $437b23f6a393c3bf$var$defaultLowercaseFormatter);
    }
    evaluateNullValue(filterType) {
        const filterTypesAllowNulls = [
            "notEqual",
            "notContains",
            "blank"
        ];
        return filterType ? filterTypesAllowNulls.indexOf(filterType) >= 0 : false;
    }
    evaluateNonNullValue(values, cellValue, filterModel, params) {
        const formattedValues = values.map((v)=>this.formatter(v)) || [];
        const cellValueFormatted = this.formatter(cellValue);
        const { api: api, colDef: colDef, column: column, context: context, filterParams: { textFormatter: textFormatter } } = this.params;
        if (filterModel.type === "blank") return $437b23f6a393c3bf$var$isBlank(cellValue);
        else if (filterModel.type === "notBlank") return !$437b23f6a393c3bf$var$isBlank(cellValue);
        const matcherParams = {
            api: api,
            colDef: colDef,
            column: column,
            context: context,
            node: params.node,
            data: params.data,
            filterOption: filterModel.type,
            value: cellValueFormatted,
            textFormatter: textFormatter
        };
        return formattedValues.some((v)=>this.matcher({
                ...matcherParams,
                filterText: v
            }));
    }
    processModelToApply(model) {
        if (model && this.params.filterParams.trimInput) {
            const processCondition = (condition)=>{
                const newCondition = {
                    ...condition
                };
                const { filter: filter, filterTo: filterTo } = condition;
                if (filter) newCondition.filter = $437b23f6a393c3bf$var$trimInputForFilter(filter) ?? null;
                if (filterTo) newCondition.filterTo = $437b23f6a393c3bf$var$trimInputForFilter(filterTo) ?? null;
                return newCondition;
            };
            if ($437b23f6a393c3bf$export$a3f343af66a0c1bd(model)) return {
                ...model,
                conditions: model.conditions.map(processCondition)
            };
            return processCondition(model);
        }
        return model;
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFloatingFilter.ts
var $437b23f6a393c3bf$var$TextFloatingFilter = class extends $437b23f6a393c3bf$var$TextInputFloatingFilter {
    constructor(){
        super(...arguments);
        this.FilterModelFormatterClass = $437b23f6a393c3bf$var$TextFilterModelFormatter;
        this.filterType = "text";
        this.defaultOptions = $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS;
    }
    createFloatingFilterInputService() {
        return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterTextInputService());
    }
};
// packages/ag-grid-community/src/filter/quickFilterApi.ts
function $437b23f6a393c3bf$var$isQuickFilterPresent(beans) {
    return !!beans.quickFilter?.isFilterPresent();
}
function $437b23f6a393c3bf$var$getQuickFilter(beans) {
    return beans.quickFilter?.getText();
}
function $437b23f6a393c3bf$var$resetQuickFilter(beans) {
    beans.quickFilter?.resetCache();
}
// packages/ag-grid-community/src/filter/quickFilterService.ts
var $437b23f6a393c3bf$var$QuickFilterService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "quickFilter";
        this.quickFilter = null;
        this.quickFilterParts = null;
    }
    postConstruct() {
        const resetListener = this.resetCache.bind(this);
        const gos = this.gos;
        this.addManagedEventListeners({
            columnPivotModeChanged: resetListener,
            newColumnsLoaded: resetListener,
            columnRowGroupChanged: resetListener,
            columnVisible: ()=>{
                if (!gos.get("includeHiddenColumnsInQuickFilter")) this.resetCache();
            }
        });
        this.addManagedPropertyListener("quickFilterText", (e)=>this.setFilter(e.currentValue));
        this.addManagedPropertyListeners([
            "includeHiddenColumnsInQuickFilter",
            "applyQuickFilterBeforePivotOrAgg"
        ], ()=>this.onColumnConfigChanged());
        this.quickFilter = this.parseFilter(gos.get("quickFilterText"));
        this.parser = gos.get("quickFilterParser");
        this.matcher = gos.get("quickFilterMatcher");
        this.setFilterParts();
        this.addManagedPropertyListeners([
            "quickFilterMatcher",
            "quickFilterParser"
        ], ()=>this.setParserAndMatcher());
    }
    // if we are using autoGroupCols, then they should be included for quick filter. this covers the
    // following scenarios:
    // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
    // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
    //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
    refreshCols() {
        const { autoColSvc: autoColSvc, colModel: colModel, gos: gos, pivotResultCols: pivotResultCols } = this.beans;
        const pivotMode = colModel.isPivotMode();
        const groupAutoCols = autoColSvc?.getColumns();
        const providedCols = colModel.getColDefCols();
        let columnsForQuickFilter = (pivotMode && !gos.get("applyQuickFilterBeforePivotOrAgg") ? pivotResultCols?.getPivotResultCols()?.list : providedCols) ?? [];
        if (groupAutoCols) columnsForQuickFilter = columnsForQuickFilter.concat(groupAutoCols);
        this.colsToUse = gos.get("includeHiddenColumnsInQuickFilter") ? columnsForQuickFilter : columnsForQuickFilter.filter((col)=>col.isVisible() || col.isRowGroupActive());
    }
    isFilterPresent() {
        return this.quickFilter !== null;
    }
    doesRowPass(node) {
        const usingCache = this.gos.get("cacheQuickFilter");
        if (this.matcher) return this.doesRowPassMatcher(usingCache, node);
        return this.quickFilterParts.every((part)=>usingCache ? this.doesRowPassCache(node, part) : this.doesRowPassNoCache(node, part));
    }
    resetCache() {
        this.beans.rowModel.forEachNode((node)=>node.quickFilterAggregateText = null);
    }
    getText() {
        return this.gos.get("quickFilterText");
    }
    setFilterParts() {
        const { quickFilter: quickFilter, parser: parser } = this;
        if (quickFilter) this.quickFilterParts = parser ? parser(quickFilter) : quickFilter.split(" ");
        else this.quickFilterParts = null;
    }
    parseFilter(newFilter) {
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(newFilter)) return null;
        return newFilter.toUpperCase();
    }
    setFilter(newFilter) {
        if (newFilter != null && typeof newFilter !== "string") {
            $437b23f6a393c3bf$export$545083624300f13d(70, {
                newFilter: newFilter
            });
            return;
        }
        const parsedFilter = this.parseFilter(newFilter);
        if (this.quickFilter !== parsedFilter) {
            this.quickFilter = parsedFilter;
            this.setFilterParts();
            this.dispatchLocalEvent({
                type: "quickFilterChanged"
            });
        }
    }
    setParserAndMatcher() {
        const parser = this.gos.get("quickFilterParser");
        const matcher = this.gos.get("quickFilterMatcher");
        const hasChanged = parser !== this.parser || matcher !== this.matcher;
        this.parser = parser;
        this.matcher = matcher;
        if (hasChanged) {
            this.setFilterParts();
            this.dispatchLocalEvent({
                type: "quickFilterChanged"
            });
        }
    }
    onColumnConfigChanged() {
        this.refreshCols();
        this.resetCache();
        if (this.isFilterPresent()) this.dispatchLocalEvent({
            type: "quickFilterChanged"
        });
    }
    doesRowPassNoCache(node, filterPart) {
        return this.colsToUse.some((column)=>{
            const part = this.getTextForColumn(column, node);
            return $437b23f6a393c3bf$export$25d27f17d3af40f7(part) && part.includes(filterPart);
        });
    }
    doesRowPassCache(node, filterPart) {
        this.checkGenerateAggText(node);
        return node.quickFilterAggregateText.includes(filterPart);
    }
    doesRowPassMatcher(usingCache, node) {
        let quickFilterAggregateText;
        if (usingCache) {
            this.checkGenerateAggText(node);
            quickFilterAggregateText = node.quickFilterAggregateText;
        } else quickFilterAggregateText = this.getAggText(node);
        const { quickFilterParts: quickFilterParts, matcher: matcher } = this;
        return matcher(quickFilterParts, quickFilterAggregateText);
    }
    checkGenerateAggText(node) {
        if (!node.quickFilterAggregateText) node.quickFilterAggregateText = this.getAggText(node);
    }
    getTextForColumn(column, node) {
        let value = this.beans.filterValueSvc.getValue(column, node);
        const colDef = column.getColDef();
        if (colDef.getQuickFilterText) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                node: node,
                data: node.data,
                column: column,
                colDef: colDef
            });
            value = colDef.getQuickFilterText(params);
        }
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(value) ? value.toString().toUpperCase() : null;
    }
    getAggText(node) {
        const stringParts = [];
        for (const column of this.colsToUse){
            const part = this.getTextForColumn(column, node);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(part)) stringParts.push(part);
        }
        return stringParts.join("\n");
    }
};
// packages/ag-grid-community/src/filter/filterModule.ts
var $437b23f6a393c3bf$var$ClientSideRowModelFilterModule = {
    moduleName: "ClientSideRowModelFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$FilterStage
    ]
};
var $437b23f6a393c3bf$export$b8779358eaaabc87 = {
    moduleName: "FilterCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$FilterManager
    ],
    apiFunctions: {
        isAnyFilterPresent: $437b23f6a393c3bf$var$isAnyFilterPresent,
        onFilterChanged: $437b23f6a393c3bf$var$onFilterChanged
    },
    css: [
        $437b23f6a393c3bf$var$columnFiltersCSS
    ],
    dependsOn: [
        $437b23f6a393c3bf$var$ClientSideRowModelFilterModule
    ]
};
var $437b23f6a393c3bf$export$55e846ac25ec4cc0 = {
    moduleName: "FilterValue",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$FilterValueService
    ]
};
var $437b23f6a393c3bf$export$bee7a6b8183a1c61 = {
    moduleName: "ColumnFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnFilterService,
        $437b23f6a393c3bf$var$FilterMenuFactory
    ],
    dynamicBeans: {
        headerFilterCellCtrl: $437b23f6a393c3bf$var$HeaderFilterCellCtrl
    },
    icons: {
        // open filter button - header, floating filter, menu
        filter: "filter",
        // filter is applied - header (legacy column menu), filter tool panel
        filterActive: "filter"
    },
    apiFunctions: {
        isColumnFilterPresent: $437b23f6a393c3bf$var$isColumnFilterPresent,
        getColumnFilterInstance: $437b23f6a393c3bf$var$getColumnFilterInstance,
        destroyFilter: $437b23f6a393c3bf$var$destroyFilter,
        setFilterModel: $437b23f6a393c3bf$var$setFilterModel,
        getFilterModel: $437b23f6a393c3bf$var$getFilterModel,
        getColumnFilterModel: $437b23f6a393c3bf$var$getColumnFilterModel,
        setColumnFilterModel: $437b23f6a393c3bf$var$setColumnFilterModel,
        showColumnFilter: $437b23f6a393c3bf$var$showColumnFilter,
        hideColumnFilter: $437b23f6a393c3bf$var$hideColumnFilter,
        getColumnFilterHandler: $437b23f6a393c3bf$var$getColumnFilterHandler,
        doFilterAction: $437b23f6a393c3bf$var$doFilterAction
    },
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87,
        $437b23f6a393c3bf$export$da5c9bb998e6c24d,
        $437b23f6a393c3bf$export$55e846ac25ec4cc0,
        $437b23f6a393c3bf$export$b0ea578339daf1f7
    ]
};
var $437b23f6a393c3bf$export$c992812899d813d0 = {
    moduleName: "CustomFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agReadOnlyFloatingFilter: $437b23f6a393c3bf$var$ReadOnlyFloatingFilter
    },
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ]
};
var $437b23f6a393c3bf$export$5ce3e57cec1fecc9 = {
    moduleName: "TextFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agTextColumnFilter: {
            classImp: $437b23f6a393c3bf$var$TextFilter,
            params: {
                useForm: true
            }
        },
        agTextColumnFloatingFilter: $437b23f6a393c3bf$var$TextFloatingFilter
    },
    dynamicBeans: {
        agTextColumnFilterHandler: $437b23f6a393c3bf$var$TextFilterHandler
    }
};
var $437b23f6a393c3bf$export$aabcd4399b0469bb = {
    moduleName: "NumberFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agNumberColumnFilter: {
            classImp: $437b23f6a393c3bf$var$NumberFilter,
            params: {
                useForm: true
            }
        },
        agNumberColumnFloatingFilter: $437b23f6a393c3bf$var$NumberFloatingFilter
    },
    dynamicBeans: {
        agNumberColumnFilterHandler: $437b23f6a393c3bf$var$NumberFilterHandler
    }
};
var $437b23f6a393c3bf$export$2a2721fe06c4c013 = {
    moduleName: "DateFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agDateColumnFilter: {
            classImp: $437b23f6a393c3bf$var$DateFilter,
            params: {
                useForm: true
            }
        },
        agDateInput: $437b23f6a393c3bf$var$DefaultDateComponent,
        agDateColumnFloatingFilter: $437b23f6a393c3bf$var$DateFloatingFilter
    },
    dynamicBeans: {
        agDateColumnFilterHandler: $437b23f6a393c3bf$var$DateFilterHandler
    }
};
var $437b23f6a393c3bf$var$QuickFilterCoreModule = {
    moduleName: "QuickFilterCore",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$QuickFilterService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87,
        $437b23f6a393c3bf$export$55e846ac25ec4cc0
    ]
};
var $437b23f6a393c3bf$export$7e8079ed742f8307 = {
    moduleName: "QuickFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        isQuickFilterPresent: $437b23f6a393c3bf$var$isQuickFilterPresent,
        getQuickFilter: $437b23f6a393c3bf$var$getQuickFilter,
        resetQuickFilter: $437b23f6a393c3bf$var$resetQuickFilter
    },
    dependsOn: [
        $437b23f6a393c3bf$var$QuickFilterCoreModule
    ]
};
var $437b23f6a393c3bf$export$fc403e59f6fc67b = {
    moduleName: "ExternalFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87
    ]
};
// packages/ag-grid-community/src/agStack/tooltip/tooltip.css-GENERATED.ts
var $437b23f6a393c3bf$var$tooltipCSS = /*css*/ `.ag-tooltip{background-color:var(--ag-tooltip-background-color);border:var(--ag-tooltip-border);border-radius:var(--ag-border-radius);color:var(--ag-tooltip-text-color);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;white-space:normal;z-index:99999;&:where(.ag-cell-editor-tooltip),&:where(.ag-cell-formula-tooltip){background-color:var(--ag-tooltip-error-background-color);border:var(--ag-tooltip-error-border);color:var(--ag-tooltip-error-text-color);font-weight:500}}.ag-tooltip-custom{position:absolute;z-index:99999}.ag-tooltip-custom:where(:not(.ag-tooltip-interactive)),.ag-tooltip:where(:not(.ag-tooltip-interactive)){pointer-events:none}.ag-tooltip-animate{transition:opacity 1s;&:where(.ag-tooltip-hiding){opacity:0}}`;
// packages/ag-grid-community/src/tooltip/tooltipService.ts
var $437b23f6a393c3bf$var$getEditErrorsForPosition = (beans, cellCtrl, translate)=>{
    const { editModelSvc: editModelSvc } = beans;
    const cellValidationErrors = editModelSvc?.getCellValidationModel()?.getCellValidation(cellCtrl)?.errorMessages;
    const rowValidationErrors = editModelSvc?.getRowValidationModel().getRowValidation(cellCtrl)?.errorMessages;
    const errors = cellValidationErrors || rowValidationErrors;
    return errors?.length ? errors.join(translate("tooltipValidationErrorSeparator", ". ")) : void 0;
};
var $437b23f6a393c3bf$var$TooltipService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "tooltipSvc";
    }
    setupHeaderTooltip(existingTooltipFeature, ctrl, passedValue, shouldDisplayTooltip) {
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature);
        const gos = this.gos;
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(gos);
        const { column: column, eGui: eGui } = ctrl;
        const colDef = column.getColDef();
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !colDef.headerComponent) shouldDisplayTooltip = $437b23f6a393c3bf$export$8980540b0a37a11d(()=>eGui.querySelector(".ag-header-cell-text"));
        const location = "header";
        const headerLocation = "header";
        const valueFormatted = this.beans.colNames.getDisplayNameForColumn(column, headerLocation, true);
        const value = passedValue ?? valueFormatted;
        const tooltipCtrl = {
            getGui: ()=>eGui,
            getLocation: ()=>location,
            getTooltipValue: ()=>passedValue ?? colDef?.headerTooltipValueGetter?.($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                    location: location,
                    colDef: colDef,
                    column: column,
                    value: value,
                    valueFormatted: valueFormatted
                })) ?? colDef?.headerTooltip,
            shouldDisplayTooltip: shouldDisplayTooltip,
            getAdditionalParams: ()=>({
                    column: column,
                    colDef: column.getColDef()
                })
        };
        let tooltipFeature = this.createTooltipFeature(tooltipCtrl);
        if (tooltipFeature) {
            tooltipFeature = ctrl.createBean(tooltipFeature);
            ctrl.setRefreshFunction("tooltip", ()=>tooltipFeature.refreshTooltip());
        }
        return tooltipFeature;
    }
    setupHeaderGroupTooltip(existingTooltipFeature, ctrl, passedValue, shouldDisplayTooltip) {
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature);
        const gos = this.gos;
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(gos);
        const { column: column, eGui: eGui } = ctrl;
        const colDef = column.getColGroupDef();
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !colDef?.headerGroupComponent) shouldDisplayTooltip = $437b23f6a393c3bf$export$8980540b0a37a11d(()=>eGui.querySelector(".ag-header-group-text"));
        const location = "headerGroup";
        const headerLocation = "header";
        const valueFormatted = this.beans.colNames.getDisplayNameForColumnGroup(column, headerLocation);
        const value = passedValue ?? valueFormatted;
        const tooltipCtrl = {
            getGui: ()=>eGui,
            getLocation: ()=>location,
            getTooltipValue: ()=>passedValue ?? colDef?.headerTooltipValueGetter?.($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                    location: location,
                    colDef: colDef,
                    column: column,
                    value: value,
                    valueFormatted: valueFormatted
                })) ?? colDef?.headerTooltip,
            shouldDisplayTooltip: shouldDisplayTooltip,
            getAdditionalParams: ()=>{
                const additionalParams = {
                    column: column
                };
                if (colDef) additionalParams.colDef = colDef;
                return additionalParams;
            }
        };
        const tooltipFeature = this.createTooltipFeature(tooltipCtrl);
        return tooltipFeature ? ctrl.createBean(tooltipFeature) : tooltipFeature;
    }
    enableCellTooltipFeature(ctrl, value, shouldDisplayTooltip) {
        const { beans: beans } = this;
        const { gos: gos, editSvc: editSvc } = beans;
        const { column: column, rowNode: rowNode } = ctrl;
        let location = "cell";
        const getTooltipValue = ()=>{
            const isEditing2 = !!editSvc?.isEditing(ctrl);
            const errorMessages = !isEditing2 && $437b23f6a393c3bf$var$getEditErrorsForPosition(beans, ctrl, this.getLocaleTextFunc());
            if (errorMessages) {
                location = "cellEditor";
                return errorMessages;
            }
            location = "cell";
            const colDef = column.getColDef();
            const data = rowNode.data;
            if (colDef.tooltipField && $437b23f6a393c3bf$export$25d27f17d3af40f7(data)) return $437b23f6a393c3bf$var$_getValueUsingField(data, colDef.tooltipField, column.isTooltipFieldContainsDots());
            const valueGetter = colDef.tooltipValueGetter;
            if (valueGetter) return valueGetter($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                location: "cell",
                colDef: column.getColDef(),
                column: column,
                rowIndex: ctrl.cellPosition.rowIndex,
                node: rowNode,
                data: rowNode.data,
                value: ctrl.value,
                valueFormatted: ctrl.valueFormatted
            }));
            return null;
        };
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(gos);
        if (!shouldDisplayTooltip) {
            if (isTooltipWhenTruncated && !ctrl.isCellRenderer()) shouldDisplayTooltip = ()=>{
                const isEditing2 = !!editSvc?.isEditing(ctrl);
                const errorMessages = !isEditing2 && $437b23f6a393c3bf$var$getEditErrorsForPosition(beans, ctrl, this.getLocaleTextFunc());
                if (errorMessages) return true;
                const isTooltipEnabled = column.isTooltipEnabled();
                if (!isTooltipEnabled) return false;
                const isElementOverflowing = $437b23f6a393c3bf$export$8980540b0a37a11d(()=>{
                    const eCell = ctrl.eGui;
                    return eCell.children.length === 0 ? eCell : eCell.querySelector(".ag-cell-value");
                });
                return !isEditing2 && isElementOverflowing();
            };
            else shouldDisplayTooltip = ()=>!editSvc?.isEditing(ctrl);
        }
        const tooltipCtrl = {
            getGui: ()=>ctrl.eGui,
            getLocation: ()=>location,
            getTooltipValue: value != null ? ()=>value : getTooltipValue,
            shouldDisplayTooltip: shouldDisplayTooltip,
            getAdditionalParams: ()=>({
                    column: column,
                    colDef: column.getColDef(),
                    rowIndex: ctrl.cellPosition.rowIndex,
                    node: rowNode,
                    data: rowNode.data,
                    valueFormatted: ctrl.valueFormatted
                })
        };
        return this.createTooltipFeature(tooltipCtrl, beans);
    }
    setupFullWidthRowTooltip(existingTooltipFeature, ctrl, value, shouldDisplayTooltip) {
        const tooltipParams = {
            getGui: ()=>ctrl.getFullWidthElement(),
            getTooltipValue: ()=>value,
            getLocation: ()=>"fullWidthRow",
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        const beans = this.beans;
        const context = beans.context;
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature, context);
        const tooltipFeature = this.createTooltipFeature(tooltipParams, beans);
        if (!tooltipFeature) return;
        return ctrl.createBean(tooltipFeature, context);
    }
    setupFormulaTooltip(cellCtrl) {
        const { beans: beans } = this;
        const { context: context, formula: formula } = beans;
        if (!this.beans.formula?.active || !cellCtrl.column.isAllowFormula()) return;
        const tooltipParams = {
            getGui: ()=>cellCtrl.eGui,
            getTooltipValue: ()=>{
                const error = formula?.getFormulaError(cellCtrl.column, cellCtrl.rowNode);
                return error ? error.message : void 0;
            },
            getLocation: ()=>"cellFormula",
            shouldDisplayTooltip: ()=>{
                const error = formula?.getFormulaError(cellCtrl.column, cellCtrl.rowNode);
                return !!error;
            }
        };
        const tooltipFeature = this.createTooltipFeature(tooltipParams, beans);
        if (!tooltipFeature) return;
        return cellCtrl.createBean(tooltipFeature, context);
    }
    setupCellEditorTooltip(cellCtrl, editor) {
        const { beans: beans } = this;
        const { context: context } = beans;
        const el = editor.getValidationElement?.(true) || !editor.isPopup?.() && cellCtrl.eGui;
        if (!el) return;
        const tooltipParams = {
            getGui: ()=>el,
            getTooltipValue: ()=>$437b23f6a393c3bf$var$getEditErrorsForPosition(beans, cellCtrl, this.getLocaleTextFunc()),
            getLocation: ()=>"cellEditor",
            shouldDisplayTooltip: ()=>{
                const { editModelSvc: editModelSvc } = beans;
                const rowValidationMap = editModelSvc?.getRowValidationModel()?.getRowValidationMap();
                const cellValidationMap = editModelSvc?.getCellValidationModel()?.getCellValidationMap();
                const hasRowValidationErrors = !!rowValidationMap && rowValidationMap.size > 0;
                const hasCellValidationErrors = !!cellValidationMap && cellValidationMap.size > 0;
                return hasRowValidationErrors || hasCellValidationErrors;
            }
        };
        const tooltipFeature = this.createTooltipFeature(tooltipParams, beans);
        if (!tooltipFeature) return;
        return cellCtrl.createBean(tooltipFeature, context);
    }
    initCol(column) {
        const { colDef: colDef } = column;
        column.tooltipEnabled = $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipField) || $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipValueGetter) || $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipComponent);
    }
    createTooltipFeature(tooltipCtrl, beans) {
        return this.beans.registry.createDynamicBean("tooltipFeature", false, tooltipCtrl, beans);
    }
};
// packages/ag-grid-community/src/tooltip/tooltipStateManager.ts
var $437b23f6a393c3bf$var$TooltipStateManager = class extends $437b23f6a393c3bf$export$96f12f5ea073bed1 {
    createTooltipComp(params, callback) {
        const userDetails = $437b23f6a393c3bf$var$_getTooltipCompDetails(this.beans.userCompFactory, params);
        userDetails?.newAgStackInstance().then(callback);
    }
    setEventHandlers(listener) {
        [this.onColumnMovedEventCallback] = this.addManagedEventListeners({
            columnMoved: listener
        });
    }
    clearEventHandlers() {
        this.onColumnMovedEventCallback?.();
        this.onColumnMovedEventCallback = void 0;
    }
};
// packages/ag-grid-community/src/tooltip/tooltipModule.ts
var $437b23f6a393c3bf$export$d0c662c133b8814e = {
    moduleName: "Tooltip",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$TooltipService
    ],
    dynamicBeans: {
        tooltipFeature: $437b23f6a393c3bf$export$e72bd8c9b85d3e72,
        highlightTooltipFeature: $437b23f6a393c3bf$var$AgHighlightTooltipFeature,
        tooltipStateManager: $437b23f6a393c3bf$var$TooltipStateManager
    },
    userComponents: {
        agTooltipComponent: $437b23f6a393c3bf$export$7347ac91f8ec5988
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d
    ],
    css: [
        $437b23f6a393c3bf$var$tooltipCSS
    ]
};
// packages/ag-grid-community/src/undoRedo/undoRedoStack.ts
var $437b23f6a393c3bf$var$UndoRedoAction = class {
    constructor(cellValueChanges){
        this.cellValueChanges = cellValueChanges;
    }
};
var $437b23f6a393c3bf$var$RangeUndoRedoAction = class extends $437b23f6a393c3bf$var$UndoRedoAction {
    constructor(cellValueChanges, initialRange, finalRange, ranges){
        super(cellValueChanges);
        this.initialRange = initialRange;
        this.finalRange = finalRange;
        this.ranges = ranges;
    }
};
var $437b23f6a393c3bf$var$DEFAULT_STACK_SIZE = 10;
var $437b23f6a393c3bf$var$UndoRedoStack = class {
    constructor(maxStackSize){
        this.actionStack = [];
        this.maxStackSize = maxStackSize ? maxStackSize : $437b23f6a393c3bf$var$DEFAULT_STACK_SIZE;
        this.actionStack = new Array(this.maxStackSize);
    }
    pop() {
        return this.actionStack.pop();
    }
    push(item) {
        const shouldAddActions = item.cellValueChanges && item.cellValueChanges.length > 0;
        if (!shouldAddActions) return;
        if (this.actionStack.length === this.maxStackSize) this.actionStack.shift();
        this.actionStack.push(item);
    }
    clear() {
        this.actionStack = [];
    }
    getCurrentStackSize() {
        return this.actionStack.length;
    }
};
// packages/ag-grid-community/src/undoRedo/undoRedoService.ts
var $437b23f6a393c3bf$var$UndoRedoService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "undoRedo";
        this.cellValueChanges = [];
        this.activeCellEdit = null;
        this.activeRowEdit = null;
        this.isPasting = false;
        this.isRangeInAction = false;
        this.batchEditing = false;
        this.bulkEditing = false;
        this.onCellValueChanged = (event)=>{
            const eventCell = {
                column: event.column,
                rowIndex: event.rowIndex,
                rowPinned: event.rowPinned
            };
            const isCellEditing = this.activeCellEdit !== null && $437b23f6a393c3bf$export$be3973033c2c5267(this.activeCellEdit, eventCell);
            const isRowEditing = this.activeRowEdit !== null && $437b23f6a393c3bf$export$de6f9fa10e9f4188(this.activeRowEdit, eventCell);
            const shouldCaptureAction = isCellEditing || isRowEditing || this.isPasting || this.isRangeInAction;
            if (!shouldCaptureAction) return;
            const { rowPinned: rowPinned, rowIndex: rowIndex, column: column, oldValue: oldValue, value: value } = event;
            const cellValueChange = {
                rowPinned: rowPinned,
                rowIndex: rowIndex,
                columnId: column.getColId(),
                newValue: value,
                oldValue: oldValue
            };
            this.cellValueChanges.push(cellValueChange);
        };
        this.clearStacks = ()=>{
            this.undoStack.clear();
            this.redoStack.clear();
        };
    }
    postConstruct() {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        if (!gos.get("undoRedoCellEditing")) return;
        const undoRedoLimit = gos.get("undoRedoCellEditingLimit");
        if (undoRedoLimit <= 0) return;
        this.undoStack = new $437b23f6a393c3bf$var$UndoRedoStack(undoRedoLimit);
        this.redoStack = new $437b23f6a393c3bf$var$UndoRedoStack(undoRedoLimit);
        this.addListeners();
        const listener = this.clearStacks.bind(this);
        this.addManagedEventListeners({
            cellValueChanged: this.onCellValueChanged.bind(this),
            // undo / redo is restricted to actual editing so we clear the stacks when other operations are
            // performed that change the order of the row / cols.
            modelUpdated: (e)=>{
                if (!e.keepUndoRedoStack) this.clearStacks();
            },
            columnPivotModeChanged: listener,
            newColumnsLoaded: listener,
            columnGroupOpened: listener,
            columnRowGroupChanged: listener,
            columnMoved: listener,
            columnPinned: listener,
            columnVisible: listener,
            rowDragEnd: listener
        });
        ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
    }
    getCurrentUndoStackSize() {
        return this.undoStack?.getCurrentStackSize() ?? 0;
    }
    getCurrentRedoStackSize() {
        return this.redoStack?.getCurrentStackSize() ?? 0;
    }
    undo(source) {
        const { eventSvc: eventSvc, undoStack: undoStack, redoStack: redoStack } = this;
        eventSvc.dispatchEvent({
            type: "undoStarted",
            source: source
        });
        const operationPerformed = this.undoRedo(undoStack, redoStack, "initialRange", "oldValue", "undo");
        eventSvc.dispatchEvent({
            type: "undoEnded",
            source: source,
            operationPerformed: operationPerformed
        });
    }
    redo(source) {
        const { eventSvc: eventSvc, undoStack: undoStack, redoStack: redoStack } = this;
        eventSvc.dispatchEvent({
            type: "redoStarted",
            source: source
        });
        const operationPerformed = this.undoRedo(redoStack, undoStack, "finalRange", "newValue", "redo");
        eventSvc.dispatchEvent({
            type: "redoEnded",
            source: source,
            operationPerformed: operationPerformed
        });
    }
    undoRedo(undoRedoStack, opposingUndoRedoStack, rangeProperty, cellValueChangeProperty, source) {
        if (!undoRedoStack) return false;
        const undoRedoAction = undoRedoStack.pop();
        if (!undoRedoAction?.cellValueChanges) return false;
        this.processAction(undoRedoAction, (cellValueChange)=>cellValueChange[cellValueChangeProperty], source);
        if (undoRedoAction instanceof $437b23f6a393c3bf$var$RangeUndoRedoAction) this.processRange(undoRedoAction.ranges || [
            undoRedoAction[rangeProperty]
        ]);
        else this.processCell(undoRedoAction.cellValueChanges);
        opposingUndoRedoStack.push(undoRedoAction);
        return true;
    }
    processAction(action, valueExtractor, source) {
        for (const cellValueChange of action.cellValueChanges){
            const { rowIndex: rowIndex, rowPinned: rowPinned, columnId: columnId } = cellValueChange;
            const rowPosition = {
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
            const currentRow = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, rowPosition);
            if (!currentRow.displayed) continue;
            currentRow.setDataValue(columnId, valueExtractor(cellValueChange), source);
        }
    }
    processRange(ranges) {
        let lastFocusedCell;
        const rangeSvc = this.beans.rangeSvc;
        rangeSvc.removeAllCellRanges(true);
        ranges.forEach((range, idx)=>{
            if (!range) return;
            const startRow = range.startRow;
            const endRow = range.endRow;
            if (idx === ranges.length - 1) {
                lastFocusedCell = {
                    rowPinned: startRow.rowPinned,
                    rowIndex: startRow.rowIndex,
                    columnId: range.startColumn.getColId()
                };
                this.setLastFocusedCell(lastFocusedCell);
            }
            const cellRangeParams = {
                rowStartIndex: startRow.rowIndex,
                rowStartPinned: startRow.rowPinned,
                rowEndIndex: endRow.rowIndex,
                rowEndPinned: endRow.rowPinned,
                columnStart: range.startColumn,
                columns: range.columns
            };
            rangeSvc.addCellRange(cellRangeParams);
        });
    }
    processCell(cellValueChanges) {
        const cellValueChange = cellValueChanges[0];
        const { rowIndex: rowIndex, rowPinned: rowPinned } = cellValueChange;
        const rowPosition = {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
        const row = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, rowPosition);
        const lastFocusedCell = {
            rowPinned: cellValueChange.rowPinned,
            rowIndex: row.rowIndex,
            columnId: cellValueChange.columnId
        };
        this.setLastFocusedCell(lastFocusedCell);
    }
    setLastFocusedCell(lastFocusedCell) {
        const { rowIndex: rowIndex, columnId: columnId, rowPinned: rowPinned } = lastFocusedCell;
        const { colModel: colModel, focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        const column = colModel.getCol(columnId);
        if (!column) return;
        const { scrollFeature: scrollFeature } = this.gridBodyCtrl;
        scrollFeature.ensureIndexVisible(rowIndex);
        scrollFeature.ensureColumnVisible(column);
        const cellPosition = {
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned
        };
        focusSvc.setFocusedCell({
            ...cellPosition,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell(cellPosition);
    }
    addListeners() {
        this.addManagedEventListeners({
            rowEditingStarted: (e)=>{
                this.activeRowEdit = {
                    rowIndex: e.rowIndex,
                    rowPinned: e.rowPinned
                };
            },
            rowEditingStopped: ()=>{
                const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.activeRowEdit = null;
            },
            cellEditingStarted: (e)=>{
                this.activeCellEdit = {
                    column: e.column,
                    rowIndex: e.rowIndex,
                    rowPinned: e.rowPinned
                };
            },
            cellEditingStopped: (e)=>{
                this.activeCellEdit = null;
                const shouldPushAction = e.valueChanged && !this.activeRowEdit && !this.isPasting && !this.isRangeInAction;
                if (shouldPushAction) {
                    const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                    this.pushActionsToUndoStack(action);
                }
            },
            pasteStart: ()=>{
                this.isPasting = true;
            },
            pasteEnd: ()=>{
                const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.isPasting = false;
            },
            fillStart: ()=>{
                this.isRangeInAction = true;
            },
            fillEnd: (event)=>{
                const action = new $437b23f6a393c3bf$var$RangeUndoRedoAction(this.cellValueChanges, event.initialRange, event.finalRange);
                this.pushActionsToUndoStack(action);
                this.isRangeInAction = false;
            },
            keyShortcutChangedCellStart: ()=>{
                this.isRangeInAction = true;
            },
            keyShortcutChangedCellEnd: ()=>{
                let action;
                const { rangeSvc: rangeSvc, gos: gos } = this.beans;
                if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos)) action = new $437b23f6a393c3bf$var$RangeUndoRedoAction(this.cellValueChanges, void 0, void 0, [
                    ...rangeSvc.getCellRanges()
                ]);
                else action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.isRangeInAction = false;
            },
            batchEditingStarted: ()=>this.startBigChange("batchEditing"),
            batchEditingStopped: ({ changes: changes })=>this.stopBigChange("batchEditing", changes),
            bulkEditingStarted: ()=>this.startBigChange("bulkEditing"),
            bulkEditingStopped: ({ changes: changes })=>this.stopBigChange("bulkEditing", changes)
        });
    }
    startBigChange(key) {
        this.updateBigChange(key, true);
    }
    updateBigChange(key, value) {
        if (key === "bulkEditing") this.bulkEditing = value;
        else this.batchEditing = value;
    }
    stopBigChange(key, changes) {
        if (key === "bulkEditing" && !this.bulkEditing || key === "batchEditing" && !this.batchEditing) return;
        this.updateBigChange(key, false);
        if (changes?.length === 0) return;
        const action = new $437b23f6a393c3bf$var$UndoRedoAction(changes ?? []);
        this.pushActionsToUndoStack(action);
        this.cellValueChanges = [];
    }
    pushActionsToUndoStack(action) {
        this.undoStack.push(action);
        this.cellValueChanges = [];
        this.redoStack.clear();
    }
};
// packages/ag-grid-community/src/edit/cell-editing.css-GENERATED.ts
var $437b23f6a393c3bf$var$cellEditingCSS = /*css*/ `.ag-cell-inline-editing{border:var(--ag-cell-editing-border)!important;border-radius:var(--ag-border-radius);box-shadow:var(--ag-cell-editing-shadow);padding:0;z-index:1;.ag-cell-edit-wrapper,.ag-cell-editor,.ag-cell-wrapper,:where(.ag-cell-editor) .ag-input-field-input,:where(.ag-cell-editor) .ag-wrapper{height:100%;line-height:normal;min-height:100%;width:100%}&.ag-cell-editing-error{border-color:var(--ag-invalid-color)!important}}:where(.ag-popup-editor) .ag-large-text{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0}.ag-large-text-input{display:block;height:auto;padding:var(--ag-cell-horizontal-padding)}:where(.ag-rtl .ag-large-text-input) textarea{resize:none}:where(.ag-ltr) .ag-checkbox-edit{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-checkbox-edit{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-row.ag-row-editing-invalid .ag-cell-inline-editing){opacity:.8}.ag-popup-editor{position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}`;
// packages/ag-grid-community/src/edit/cellEditors/checkboxCellEditor.ts
var $437b23f6a393c3bf$var$CheckboxCellEditorElement = {
    tag: "div",
    cls: "ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eEditor",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxCellEditorElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    initialiseEditor(params) {
        const isSelected = params.value ?? void 0;
        const eEditor = this.eEditor;
        eEditor.setValue(isSelected);
        const inputEl = eEditor.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        this.setAriaLabel(isSelected);
        this.addManagedListeners(eEditor, {
            fieldValueChanged: (event)=>this.setAriaLabel(event.selected)
        });
    }
    getValue() {
        return this.eEditor.getValue();
    }
    focusIn() {
        this.eEditor.getFocusableElement().focus();
    }
    afterGuiAttached() {
        if (this.params.cellStartedEdit) this.focusIn();
    }
    isPopup() {
        return false;
    }
    setAriaLabel(isSelected) {
        const translate = this.getLocaleTextFunc();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = translate("ariaToggleCellValue", "Press SPACE to toggle cell value");
        this.eEditor.setInputAriaLabel(`${ariaLabel} (${stateName})`);
    }
    getValidationElement(tooltip) {
        return tooltip ? this.params.eGridCell : this.eEditor.getInputElement();
    }
    getValidationErrors() {
        const { params: params } = this;
        const { getValidationErrors: getValidationErrors } = params;
        const value = this.getValue();
        if (!getValidationErrors) return null;
        return getValidationErrors({
            value: value,
            internalErrors: null,
            cellEditorParams: params
        });
    }
};
// packages/ag-grid-community/src/edit/cellEditors/simpleCellEditor.ts
var $437b23f6a393c3bf$var$SimpleCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(cellEditorInput){
        super();
        this.cellEditorInput = cellEditorInput;
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    initialiseEditor(params) {
        const { cellEditorInput: cellEditorInput } = this;
        this.setTemplate({
            tag: "div",
            cls: "ag-cell-edit-wrapper",
            children: [
                cellEditorInput.getTemplate()
            ]
        }, cellEditorInput.getAgComponents());
        const { eEditor: eEditor } = this;
        const { cellStartedEdit: cellStartedEdit, eventKey: eventKey, suppressPreventDefault: suppressPreventDefault } = params;
        eEditor.getInputElement().setAttribute("title", "");
        cellEditorInput.init(eEditor, params);
        let startValue;
        let shouldSetStartValue = true;
        if (cellStartedEdit) {
            this.focusAfterAttached = true;
            if (eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE || eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) startValue = "";
            else if (eventKey && eventKey.length === 1) {
                if (suppressPreventDefault) shouldSetStartValue = false;
                else startValue = eventKey;
            } else {
                startValue = cellEditorInput.getStartValue();
                if (eventKey !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2) this.highlightAllOnFocus = true;
            }
        } else {
            this.focusAfterAttached = false;
            startValue = cellEditorInput.getStartValue();
        }
        if (shouldSetStartValue && startValue != null) eEditor.setStartValue(startValue);
        this.addGuiEventListener("keydown", (event)=>{
            const { key: key } = event;
            if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN) event.preventDefault();
        });
    }
    afterGuiAttached() {
        const translate = this.getLocaleTextFunc();
        const eInput = this.eEditor;
        eInput.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (!this.focusAfterAttached) return;
        if (!$437b23f6a393c3bf$export$8caf403dacd36a68()) eInput.getFocusableElement().focus();
        const inputEl = eInput.getInputElement();
        if (this.highlightAllOnFocus) inputEl.select();
        else this.cellEditorInput.setCaret?.();
    }
    // gets called when tabbing through cells and in full row edit mode
    focusIn() {
        const { eEditor: eEditor } = this;
        const focusEl = eEditor.getFocusableElement();
        const inputEl = eEditor.getInputElement();
        focusEl.focus();
        inputEl.select();
    }
    getValue() {
        return this.cellEditorInput.getValue();
    }
    isPopup() {
        return false;
    }
    getValidationElement() {
        return this.eEditor.getInputElement();
    }
    getValidationErrors() {
        return this.cellEditorInput.getValidationErrors();
    }
};
// packages/ag-grid-community/src/edit/cellEditors/dateCellEditor.ts
var $437b23f6a393c3bf$var$DateCellElement = {
    tag: "ag-input-date-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$DateCellEditorInput = class {
    constructor(getDataTypeService, getLocaleTextFunc){
        this.getDataTypeService = getDataTypeService;
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$DateCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$var$AgInputDateFieldSelector
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const { min: min, max: max, step: step, colDef: colDef } = params;
        if (min != null) eEditor.setMin(min);
        if (max != null) eEditor.setMax(max);
        if (step != null) eEditor.setStep(step);
        this.includeTime = params.includeTime ?? this.getDataTypeService()?.getDateIncludesTimeFlag?.(colDef.cellDataType);
        if (this.includeTime != null) eEditor.setIncludeTime(this.includeTime);
    }
    getValidationErrors() {
        const eInput = this.eEditor.getInputElement();
        const value = eInput.valueAsDate;
        const { params: params } = this;
        const { min: min, max: max, getValidationErrors: getValidationErrors } = params;
        let internalErrors = [];
        const translate = this.getLocaleTextFunc();
        if (value instanceof Date && !isNaN(value.getTime())) {
            if (min) {
                const minValue = min instanceof Date ? min : new Date(min);
                if (value < minValue) {
                    const minDateString = minValue.toLocaleDateString();
                    internalErrors.push(translate("minDateValidation", `Date must be after ${minDateString}`, [
                        minDateString
                    ]));
                }
            }
            if (max) {
                const maxValue = max instanceof Date ? max : new Date(max);
                if (value > maxValue) {
                    const maxDateString = maxValue.toLocaleDateString();
                    internalErrors.push(translate("maxDateValidation", `Date must be before ${maxDateString}`, [
                        maxDateString
                    ]));
                }
            }
        }
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const value = eEditor.getDate();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return value ?? null;
    }
    getStartValue() {
        const { value: value } = this.params;
        if (!(value instanceof Date)) return void 0;
        return $437b23f6a393c3bf$export$3d7fedfb21962874(value, this.includeTime ?? false);
    }
};
var $437b23f6a393c3bf$var$DateCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$DateCellEditorInput(()=>this.beans.dataTypeSvc, ()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/edit/cellEditors/dateStringCellEditor.ts
var $437b23f6a393c3bf$var$DateStringCellElement = {
    tag: "ag-input-date-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$DateStringCellEditorInput = class {
    constructor(getDataTypeService, getLocaleTextFunc){
        this.getDataTypeService = getDataTypeService;
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$DateStringCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$var$AgInputDateFieldSelector
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const { min: min, max: max, step: step, colDef: colDef } = params;
        if (min != null) eEditor.setMin(min);
        if (max != null) eEditor.setMax(max);
        if (step != null) eEditor.setStep(step);
        this.includeTime = params.includeTime ?? this.getDataTypeService()?.getDateIncludesTimeFlag?.(colDef.cellDataType);
        if (this.includeTime != null) eEditor.setIncludeTime(this.includeTime);
    }
    getValidationErrors() {
        const { eEditor: eEditor, params: params } = this;
        const raw = eEditor.getInputElement().value;
        const value = this.formatDate(this.parseDate(raw ?? void 0));
        const { min: min, max: max, getValidationErrors: getValidationErrors } = params;
        let internalErrors = [];
        if (value) {
            const date = new Date(value);
            const translate = this.getLocaleTextFunc();
            if (min) {
                const minDate = new Date(min);
                if (date < minDate) {
                    const minDateString = minDate.toLocaleDateString();
                    internalErrors.push(translate("minDateValidation", `Date must be after ${minDateString}`, [
                        minDateString
                    ]));
                }
            }
            if (max) {
                const maxDate = new Date(max);
                if (date > maxDate) {
                    const maxDateString = maxDate.toLocaleDateString();
                    internalErrors.push(translate("maxDateValidation", `Date must be before ${maxDateString}`, [
                        maxDateString
                    ]));
                }
            }
        }
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: this.getValue(),
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    getValue() {
        const { params: params, eEditor: eEditor } = this;
        const value = this.formatDate(eEditor.getDate());
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return params.parseValue(value ?? "");
    }
    getStartValue() {
        return $437b23f6a393c3bf$export$3d7fedfb21962874(this.parseDate(this.params.value ?? void 0) ?? null, this.includeTime ?? false);
    }
    parseDate(value) {
        const dataTypeSvc = this.getDataTypeService();
        return dataTypeSvc ? dataTypeSvc.getDateParserFunction(this.params.column)(value) : $437b23f6a393c3bf$export$26ded2d88c01b527(value) ?? void 0;
    }
    formatDate(value) {
        const dataTypeSvc = this.getDataTypeService();
        return dataTypeSvc ? dataTypeSvc.getDateFormatterFunction(this.params.column)(value) : $437b23f6a393c3bf$export$3d7fedfb21962874(value ?? null, this.includeTime ?? false) ?? void 0;
    }
};
var $437b23f6a393c3bf$var$DateStringCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$DateStringCellEditorInput(()=>this.beans.dataTypeSvc, ()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/edit/cellEditors/largeTextCellEditor.ts
var $437b23f6a393c3bf$var$LargeTextCellElement = {
    tag: "div",
    cls: "ag-large-text",
    children: [
        {
            tag: "ag-input-text-area",
            ref: "eEditor",
            cls: "ag-large-text-input"
        }
    ]
};
var $437b23f6a393c3bf$var$LargeTextCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(){
        super($437b23f6a393c3bf$var$LargeTextCellElement, [
            $437b23f6a393c3bf$var$AgInputTextAreaSelector
        ]);
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    initialiseEditor(params) {
        const { eEditor: eEditor } = this;
        const { cellStartedEdit: cellStartedEdit, eventKey: eventKey, maxLength: maxLength, cols: cols, rows: rows } = params;
        this.focusAfterAttached = cellStartedEdit;
        eEditor.getInputElement().setAttribute("title", "");
        eEditor.setMaxLength(maxLength || 200).setCols(cols || 60).setRows(rows || 10);
        let startValue;
        if (cellStartedEdit) {
            this.focusAfterAttached = true;
            if (eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE || eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) startValue = "";
            else if (eventKey && eventKey.length === 1) startValue = eventKey;
            else {
                startValue = this.getStartValue(params);
                if (eventKey !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2) this.highlightAllOnFocus = true;
            }
        } else {
            this.focusAfterAttached = false;
            startValue = this.getStartValue(params);
        }
        if (startValue != null) eEditor.setValue(startValue, true);
        this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
        this.activateTabIndex();
    }
    getStartValue(params) {
        const { value: value } = params;
        return value?.toString() ?? value;
    }
    onKeyDown(event) {
        const key = event.key;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN || event.shiftKey && key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) event.stopPropagation();
    }
    afterGuiAttached() {
        const { eEditor: eEditor, focusAfterAttached: focusAfterAttached, highlightAllOnFocus: highlightAllOnFocus } = this;
        const translate = this.getLocaleTextFunc();
        eEditor.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (focusAfterAttached) {
            eEditor.getFocusableElement().focus();
            if (highlightAllOnFocus) eEditor.getInputElement().select();
        }
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const { value: value } = params;
        const editorValue = eEditor.getValue();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(editorValue) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(value)) return value;
        return params.parseValue(editorValue);
    }
    getValidationElement() {
        return this.eEditor.getInputElement();
    }
    getValidationErrors() {
        const { params: params } = this;
        const { maxLength: maxLength, getValidationErrors: getValidationErrors } = params;
        const translate = this.getLocaleTextFunc();
        const value = this.getValue();
        let internalErrors = [];
        if (typeof value === "string" && maxLength != null && value.length > maxLength) internalErrors.push(translate("maxLengthValidation", `Must be ${maxLength} characters or fewer.`, [
            String(maxLength)
        ]));
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            internalErrors: internalErrors,
            cellEditorParams: params
        });
        return internalErrors;
    }
};
// packages/ag-grid-community/src/edit/cellEditors/numberCellEditor.ts
var $437b23f6a393c3bf$var$NumberCellElement = {
    tag: "ag-input-number-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$NumberCellEditorInput = class {
    constructor(getLocaleTextFunc){
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$NumberCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$export$c18153c9c909b7d7
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const { max: max, min: min, precision: precision, step: step } = params;
        if (max != null) eEditor.setMax(max);
        if (min != null) eEditor.setMin(min);
        if (precision != null) eEditor.setPrecision(precision);
        if (step != null) eEditor.setStep(step);
        const editorEl = eEditor.getInputElement();
        if (params.preventStepping) eEditor.addManagedElementListeners(editorEl, {
            keydown: this.preventStepping
        });
        else if (params.showStepperButtons) editorEl.classList.add("ag-number-field-input-stepper");
    }
    getValidationErrors() {
        const { params: params } = this;
        const { min: min, max: max, getValidationErrors: getValidationErrors } = params;
        const eInput = this.eEditor.getInputElement();
        const value = eInput.valueAsNumber;
        const translate = this.getLocaleTextFunc();
        let internalErrors = [];
        if (typeof value === "number") {
            if (min != null && value < min) internalErrors.push(translate("minValueValidation", `Must be greater than or equal to ${min}.`, [
                String(min)
            ]));
            if (max != null && value > max) internalErrors.push(translate("maxValueValidation", `Must be less than or equal to ${max}.`, [
                String(max)
            ]));
        }
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    preventStepping(e) {
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN) e.preventDefault();
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const value = eEditor.getValue();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        let parsedValue = params.parseValue(value);
        if (parsedValue == null) return parsedValue;
        if (typeof parsedValue === "string") {
            if (parsedValue === "") return null;
            parsedValue = Number(parsedValue);
        }
        return isNaN(parsedValue) ? null : parsedValue;
    }
    getStartValue() {
        return this.params.value;
    }
    setCaret() {
        if ($437b23f6a393c3bf$export$8caf403dacd36a68()) this.eEditor.getInputElement().focus({
            preventScroll: true
        });
    }
};
var $437b23f6a393c3bf$var$NumberCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$NumberCellEditorInput(()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/edit/cellEditors/selectCellEditor.ts
var $437b23f6a393c3bf$var$SelectCellElement = {
    tag: "div",
    cls: "ag-cell-edit-wrapper",
    children: [
        {
            tag: "ag-select",
            ref: "eEditor",
            cls: "ag-cell-editor"
        }
    ]
};
var $437b23f6a393c3bf$var$SelectCellEditor = class extends $437b23f6a393c3bf$export$803b08aecd9af1a9 {
    constructor(){
        super($437b23f6a393c3bf$var$SelectCellElement, [
            $437b23f6a393c3bf$export$e32612175ad118ef
        ]);
        this.eEditor = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.startedByEnter = false;
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
    }
    initialiseEditor(params) {
        this.focusAfterAttached = params.cellStartedEdit;
        const { eEditor: eEditor, valueSvc: valueSvc, gos: gos } = this;
        const { values: values, value: value, eventKey: eventKey } = params;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(values)) {
            $437b23f6a393c3bf$export$545083624300f13d(58);
            return;
        }
        this.startedByEnter = eventKey != null ? eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER : false;
        let hasValue = false;
        values.forEach((currentValue)=>{
            const option = {
                value: currentValue
            };
            const valueFormatted = valueSvc.formatValue(params.column, null, currentValue);
            const valueFormattedExits = valueFormatted !== null && valueFormatted !== void 0;
            option.text = valueFormattedExits ? valueFormatted : currentValue;
            eEditor.addOption(option);
            hasValue = hasValue || value === currentValue;
        });
        if (hasValue) eEditor.setValue(params.value, true);
        else if (params.values.length) eEditor.setValue(params.values[0], true);
        const { valueListGap: valueListGap, valueListMaxWidth: valueListMaxWidth, valueListMaxHeight: valueListMaxHeight } = params;
        if (valueListGap != null) eEditor.setPickerGap(valueListGap);
        if (valueListMaxHeight != null) eEditor.setPickerMaxHeight(valueListMaxHeight);
        if (valueListMaxWidth != null) eEditor.setPickerMaxWidth(valueListMaxWidth);
        if (gos.get("editType") !== "fullRow") this.addManagedListeners(this.eEditor, {
            selectedItem: ()=>params.stopEditing()
        });
    }
    afterGuiAttached() {
        if (this.focusAfterAttached) this.eEditor.getFocusableElement().focus();
        if (this.startedByEnter) setTimeout(()=>{
            if (this.isAlive()) this.eEditor.showPicker();
        });
    }
    focusIn() {
        this.eEditor.getFocusableElement().focus();
    }
    getValue() {
        return this.eEditor.getValue();
    }
    isPopup() {
        return false;
    }
    getValidationElement() {
        return this.eEditor.getAriaElement();
    }
    getValidationErrors() {
        const { params: params } = this;
        const { values: values, getValidationErrors: getValidationErrors } = params;
        const value = this.getValue();
        let internalErrors = [];
        if (values && !values.includes(value)) {
            const translate = this.getLocaleTextFunc();
            internalErrors.push(translate("invalidSelectionValidation", "Invalid selection."));
        } else internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            internalErrors: internalErrors,
            cellEditorParams: params
        });
        return internalErrors;
    }
};
// packages/ag-grid-community/src/edit/cellEditors/textCellEditor.ts
var $437b23f6a393c3bf$var$TextCellEditorElement = {
    tag: "ag-input-text-field",
    ref: "eEditor",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$TextCellEditorInput = class {
    constructor(getLocaleTextFunc){
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$TextCellEditorElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ];
    }
    init(eEditor, params) {
        this.eEditor = eEditor;
        this.params = params;
        const maxLength = params.maxLength;
        if (maxLength != null) eEditor.setMaxLength(maxLength);
    }
    getValidationErrors() {
        const { params: params } = this;
        const { maxLength: maxLength, getValidationErrors: getValidationErrors } = params;
        const value = this.getValue();
        const translate = this.getLocaleTextFunc();
        let internalErrors = [];
        if (maxLength != null && typeof value === "string" && value.length > maxLength) internalErrors.push(translate("maxLengthValidation", `Must be ${maxLength} characters or fewer.`, [
            String(maxLength)
        ]));
        if (!internalErrors.length) internalErrors = null;
        if (getValidationErrors) return getValidationErrors({
            value: value,
            cellEditorParams: params,
            internalErrors: internalErrors
        });
        return internalErrors;
    }
    getValue() {
        const { eEditor: eEditor, params: params } = this;
        const value = eEditor.getValue();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return params.parseValue(value);
    }
    getStartValue() {
        const params = this.params;
        const formatValue = params.useFormatter || params.column.getColDef().refData;
        return formatValue ? params.formatValue(params.value) : params.value;
    }
    setCaret() {
        if ($437b23f6a393c3bf$export$8caf403dacd36a68()) this.eEditor.getInputElement().focus({
            preventScroll: true
        });
        const eInput = this.eEditor;
        const value = eInput.getValue();
        const len = $437b23f6a393c3bf$export$25d27f17d3af40f7(value) && value.length || 0;
        if (len) eInput.getInputElement().setSelectionRange(len, len);
    }
};
var $437b23f6a393c3bf$var$TextCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$TextCellEditorInput(()=>this.getLocaleTextFunc()));
    }
};
// packages/ag-grid-community/src/api/scrollApi.ts
function $437b23f6a393c3bf$var$getVerticalPixelRange(beans) {
    return beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
function $437b23f6a393c3bf$var$getHorizontalPixelRange(beans) {
    return beans.ctrlsSvc.getScrollFeature().getHScrollPosition();
}
function $437b23f6a393c3bf$var$ensureColumnVisible(beans, key, position = "auto") {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureColumnVisible(key, position), "ensureVisible");
}
function $437b23f6a393c3bf$var$ensureIndexVisible(beans, index, position) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureIndexVisible(index, position), "ensureVisible");
}
function $437b23f6a393c3bf$var$ensureNodeVisible(beans, nodeSelector, position = null) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureNodeVisible(nodeSelector, position), "ensureVisible");
}
// packages/ag-grid-community/src/edit/editApi.ts
function $437b23f6a393c3bf$var$undoCellEditing(beans) {
    beans.undoRedo?.undo("api");
}
function $437b23f6a393c3bf$var$redoCellEditing(beans) {
    beans.undoRedo?.redo("api");
}
function $437b23f6a393c3bf$var$getEditRowValues(beans, rowNode) {
    return beans.editModelSvc?.getEditRowDataValue(rowNode, {
        checkSiblings: true
    });
}
function $437b23f6a393c3bf$var$getEditingCells(beans) {
    const edits = beans.editModelSvc?.getEditMap();
    const positions = [];
    edits?.forEach((editRow, rowNode)=>{
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode;
        editRow.forEach((editValue, column)=>{
            const { editorValue: editorValue, pendingValue: pendingValue, sourceValue: oldValue, state: state } = editValue;
            const diff = $437b23f6a393c3bf$var$_sourceAndPendingDiffer(editValue);
            let newValue = editorValue ?? pendingValue;
            if (newValue === $437b23f6a393c3bf$var$UNEDITED) newValue = void 0;
            const edit = {
                newValue: newValue,
                oldValue: oldValue,
                state: state,
                column: column,
                colId: column.getColId(),
                colKey: column.getColId(),
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
            const changed = state === "changed" && diff;
            const editing = state === "editing";
            if (editing || changed) positions.push(edit);
        });
    });
    return positions;
}
function $437b23f6a393c3bf$var$stopEditing(beans, cancel = false) {
    const { editSvc: editSvc } = beans;
    if (editSvc?.isBatchEditing()) {
        if (cancel) {
            for (const cellPosition of beans.editModelSvc?.getEditPositions() ?? [])if (cellPosition.state === "editing") editSvc.revertSingleCellEdit(cellPosition);
        } else $437b23f6a393c3bf$var$_syncFromEditors(beans, {
            persist: true
        });
        $437b23f6a393c3bf$var$_destroyEditors(beans, void 0, {
            cancel: cancel
        });
    } else editSvc?.stopEditing(void 0, {
        cancel: cancel,
        source: "edit",
        forceStop: !cancel,
        forceCancel: cancel
    });
}
function $437b23f6a393c3bf$var$isEditing(beans, cellPosition) {
    const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, cellPosition);
    return beans.editSvc?.isEditing(cellCtrl) ?? false;
}
function $437b23f6a393c3bf$var$startEditingCell(beans, params) {
    const { key: key, colKey: colKey, rowIndex: rowIndex, rowPinned: rowPinned } = params;
    const { editSvc: editSvc, colModel: colModel } = beans;
    const column = colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$545083624300f13d(12, {
            colKey: colKey
        });
        return;
    }
    const cellPosition = {
        rowIndex: rowIndex,
        rowPinned: rowPinned || null,
        column: column
    };
    const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(beans, cellPosition);
    if (!rowNode) {
        $437b23f6a393c3bf$export$545083624300f13d(290, {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        });
        return;
    }
    if (!editSvc?.isCellEditable({
        rowNode: rowNode,
        column: column
    }, "api")) return;
    const notPinned = rowPinned == null;
    if (notPinned) $437b23f6a393c3bf$var$ensureIndexVisible(beans, rowIndex);
    $437b23f6a393c3bf$var$ensureColumnVisible(beans, colKey);
    editSvc?.startEditing({
        rowNode: rowNode,
        column: column
    }, {
        event: key ? new KeyboardEvent("keydown", {
            key: key
        }) : void 0,
        source: "api"
    });
}
function $437b23f6a393c3bf$var$validateEdit(beans) {
    return beans.editSvc?.validateEdit() || null;
}
function $437b23f6a393c3bf$var$getCurrentUndoSize(beans) {
    return beans.undoRedo?.getCurrentUndoStackSize() ?? 0;
}
function $437b23f6a393c3bf$var$getCurrentRedoSize(beans) {
    return beans.undoRedo?.getCurrentRedoStackSize() ?? 0;
}
// packages/ag-grid-community/src/edit/cellEditors/popupEditorWrapper.ts
var $437b23f6a393c3bf$var$PopupEditorElement = {
    tag: "div",
    cls: "ag-popup-editor",
    attrs: {
        tabindex: "-1"
    }
};
var $437b23f6a393c3bf$var$PopupEditorWrapper = class extends $437b23f6a393c3bf$export$acd471c9223f27ae {
    constructor(params){
        super($437b23f6a393c3bf$var$PopupEditorElement);
        this.params = params;
    }
    postConstruct() {
        $437b23f6a393c3bf$var$_setDomData(this.gos, this.getGui(), "popupEditorWrapper", true);
        this.addKeyDownListener();
    }
    addKeyDownListener() {
        const eGui = this.getGui();
        const params = this.params;
        const listener = (event)=>{
            if (!$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, event, params.node, params.column, true)) params.onKeyDown(event);
        };
        this.addManagedElementListeners(eGui, {
            keydown: listener
        });
    }
};
// packages/ag-grid-community/src/edit/strategy/strategyUtils.ts
function $437b23f6a393c3bf$var$shouldStartEditing(beans, { column: column }, event, cellStartedEdit, source = "ui") {
    if (event instanceof KeyboardEvent && (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2 || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE && cellStartedEdit)) return true;
    const extendingRange = event?.shiftKey && beans.rangeSvc?.getCellRanges().length != 0;
    if (extendingRange) return false;
    const colDef = column?.getColDef();
    const clickCount = $437b23f6a393c3bf$var$deriveClickCount(beans.gos, colDef);
    const type = event?.type;
    if (type === "click" && event?.detail === 1 && clickCount === 1) return true;
    if (type === "dblclick" && event?.detail === 2 && clickCount === 2) return true;
    if (source === "api") return cellStartedEdit ?? false;
    return false;
}
function $437b23f6a393c3bf$var$deriveClickCount(gos, colDef) {
    if (gos.get("suppressClickEdit") === true) return 0;
    if (gos.get("singleClickEdit") === true) return 1;
    if (colDef?.singleClickEdit) return 1;
    return 2;
}
function $437b23f6a393c3bf$var$isCellEditable(beans, { rowNode: rowNode, column: column }, _source = "ui") {
    const editable = column.getColDef().editable;
    const editModelSvc = beans.editModelSvc;
    return column.isColumnFunc(rowNode, editable) || !!editModelSvc && editModelSvc.hasEdits({
        rowNode: rowNode,
        column: column
    }, {
        withOpenEditor: true
    });
}
function $437b23f6a393c3bf$var$isFullRowCellEditable(beans, position, source = "ui") {
    const editable = $437b23f6a393c3bf$var$isCellEditable(beans, position, source);
    if (editable === true || source === "ui") return editable;
    const columns = beans.colModel.getCols();
    return columns.some((col)=>$437b23f6a393c3bf$var$isCellEditable(beans, {
            rowNode: position.rowNode,
            column: col
        }, source));
}
// packages/ag-grid-community/src/edit/styles/style-utils.ts
var $437b23f6a393c3bf$var$editHighlightFn = (edit, includeEditing = false)=>{
    if (edit !== void 0) return $437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit) || includeEditing && edit.state === "editing";
};
function $437b23f6a393c3bf$var$_hasEdits(beans, position, includeEditing = false) {
    return $437b23f6a393c3bf$var$editHighlightFn(beans.editModelSvc?.getEdit(position), includeEditing);
}
var $437b23f6a393c3bf$var$nodeHasLeafEdit = (children, editModelSvc, column)=>{
    if (!children) return;
    for(let i = 0, len = children.length; i < len; ++i){
        const child = children[i];
        if (child.data) {
            const highlight = $437b23f6a393c3bf$var$editHighlightFn(editModelSvc?.getEdit({
                rowNode: child,
                column: column
            })) || $437b23f6a393c3bf$var$editHighlightFn(editModelSvc?.getEdit({
                rowNode: child.pinnedSibling,
                column: column
            }));
            if (highlight) return true;
        }
        if ($437b23f6a393c3bf$var$nodeHasLeafEdit(child.childrenAfterGroup, editModelSvc, column)) return true;
    }
};
function $437b23f6a393c3bf$var$_hasLeafEdits(beans, position) {
    const { column: column, rowNode: rowNode } = position;
    if (beans.gos.get("groupTotalRow") && !rowNode?.footer) return false;
    return $437b23f6a393c3bf$var$nodeHasLeafEdit(rowNode?.childrenAfterGroup, beans.editModelSvc, column);
}
function $437b23f6a393c3bf$var$_hasPinnedEdits(beans, { rowNode: rowNode, column: column }) {
    rowNode = rowNode.pinnedSibling;
    if (!rowNode) return;
    return $437b23f6a393c3bf$var$editHighlightFn(beans.editModelSvc?.getEdit({
        rowNode: rowNode,
        column: column
    }));
}
// packages/ag-grid-community/src/edit/styles/cellEditStyleFeature.ts
var $437b23f6a393c3bf$var$CellEditStyleFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans){
        super();
        this.cellCtrl = cellCtrl;
        this.beans = beans;
        this.editSvc = beans.editSvc;
        this.editModelSvc = beans.editModelSvc;
    }
    setComp(comp) {
        this.cellComp = comp;
        this.applyCellStyles();
    }
    applyCellStyles() {
        const { cellCtrl: cellCtrl, editSvc: editSvc, beans: beans } = this;
        if (editSvc?.isBatchEditing() && editSvc.isEditing()) {
            const state = $437b23f6a393c3bf$var$_hasEdits(beans, cellCtrl) || $437b23f6a393c3bf$var$_hasLeafEdits(beans, cellCtrl) || $437b23f6a393c3bf$var$_hasPinnedEdits(beans, cellCtrl);
            this.applyBatchingStyle(state);
        } else this.applyBatchingStyle(false);
        const hasErrors = !!this.editModelSvc?.getCellValidationModel().hasCellValidation(this.cellCtrl);
        this.cellComp.toggleCss("ag-cell-editing-error", hasErrors);
    }
    applyBatchingStyle(newState) {
        this.cellComp.toggleCss("ag-cell-editing", newState ?? false);
        this.cellComp.toggleCss("ag-cell-batch-edit", (newState && this.editSvc?.isBatchEditing()) ?? false);
    }
};
// packages/ag-grid-community/src/edit/styles/rowEditStyleFeature.ts
var $437b23f6a393c3bf$var$RowEditStyleFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowCtrl, beans){
        super();
        this.rowCtrl = rowCtrl;
        this.beans = beans;
        this.gos = beans.gos;
        this.editSvc = beans.editSvc;
        this.editModelSvc = beans.editModelSvc;
    }
    applyRowStyles() {
        const { rowCtrl: rowCtrl, editModelSvc: editModelSvc, beans: beans } = this;
        let rowNode = rowCtrl.rowNode;
        let edits = editModelSvc?.getEditRow(rowNode);
        const hasErrors = this.editModelSvc?.getRowValidationModel().hasRowValidation({
            rowNode: rowNode
        });
        if (!edits && rowNode.pinnedSibling) {
            rowNode = rowNode.pinnedSibling;
            edits = editModelSvc?.getEditRow(rowNode);
        }
        if (edits) {
            const editing = Array.from(edits.keys()).some((column)=>{
                const position = {
                    rowNode: rowNode,
                    column: column
                };
                return $437b23f6a393c3bf$var$_hasEdits(beans, position, true) || $437b23f6a393c3bf$var$_hasLeafEdits(beans, position) || $437b23f6a393c3bf$var$_hasPinnedEdits(beans, position);
            });
            this.applyStyle(hasErrors, editing);
            return;
        }
        this.applyStyle(hasErrors);
    }
    applyStyle(hasErrors = false, editing = false) {
        const batchEdit = this.editSvc?.isBatchEditing() ?? false;
        const fullRow = this.gos.get("editType") === "fullRow";
        this.rowCtrl?.forEachGui(void 0, ({ rowComp: rowComp })=>{
            rowComp.toggleCss("ag-row-editing", fullRow && editing);
            rowComp.toggleCss("ag-row-batch-edit", fullRow && editing && batchEdit);
            rowComp.toggleCss("ag-row-inline-editing", editing);
            rowComp.toggleCss("ag-row-not-inline-editing", !editing);
            rowComp.toggleCss("ag-row-editing-invalid", fullRow && editing && hasErrors);
        });
    }
};
// packages/ag-grid-community/src/edit/utils/refresh.ts
var $437b23f6a393c3bf$var$purgeRows = ({ rowModel: rowModel, pinnedRowModel: pinnedRowModel, editModelSvc: editModelSvc }, rowNodes)=>{
    const found = /* @__PURE__ */ new Set();
    rowModel.forEachNode((node)=>rowNodes.has(node) && found.add(node));
    pinnedRowModel?.forEachPinnedRow("top", (node)=>rowNodes.has(node) && found.add(node));
    pinnedRowModel?.forEachPinnedRow("bottom", (node)=>rowNodes.has(node) && found.add(node));
    for (const rowNode of rowNodes)if (!found.has(rowNode)) editModelSvc.removeEdits({
        rowNode: rowNode
    });
    return found;
};
var $437b23f6a393c3bf$var$purgeCells = ({ editModelSvc: editModelSvc }, rowNodes, columns)=>{
    for (const rowNode of rowNodes)editModelSvc?.getEditRow(rowNode)?.forEach((_, column)=>!columns.has(column) && editModelSvc.removeEdits({
            rowNode: rowNode,
            column: column
        }));
};
var $437b23f6a393c3bf$var$_refreshEditCells = (beans)=>()=>{
        const columns = new Set(beans.colModel.getCols());
        const updates = beans.editModelSvc.getEditMap(true);
        const rowNodes = new Set(updates.keys());
        $437b23f6a393c3bf$var$purgeCells(beans, $437b23f6a393c3bf$var$purgeRows(beans, rowNodes), columns);
    };
// packages/ag-grid-community/src/edit/editService.ts
var $437b23f6a393c3bf$var$KEEP_EDITOR_SOURCES = /* @__PURE__ */ new Set([
    "undo",
    "redo",
    "paste",
    "bulk",
    "rangeSvc"
]);
var $437b23f6a393c3bf$var$INTERNAL_EDITOR_SOURCES = /* @__PURE__ */ new Set([
    "ui",
    "api"
]);
var $437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM = {
    paste: "api",
    rangeSvc: "api",
    fillHandle: "api",
    cellClear: "api",
    bulk: "api"
};
var $437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM_KEYS = new Set(Object.keys($437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM));
var $437b23f6a393c3bf$var$SET_DATA_SOURCE_AS_API = /* @__PURE__ */ new Set([
    "paste",
    "rangeSvc",
    "cellClear",
    "redo",
    "undo"
]);
var $437b23f6a393c3bf$var$CANCEL_PARAMS = {
    cancel: true,
    source: "api"
};
var $437b23f6a393c3bf$var$COMMIT_PARAMS = {
    cancel: false,
    source: "api"
};
var $437b23f6a393c3bf$var$CHECK_SIBLING = {
    checkSiblings: true
};
var $437b23f6a393c3bf$var$FORCE_REFRESH = {
    force: true,
    suppressFlash: true
};
var $437b23f6a393c3bf$var$EditService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "editSvc";
        this.batch = false;
        this.stopping = false;
        this.committing = false;
    }
    postConstruct() {
        const { beans: beans } = this;
        this.model = beans.editModelSvc;
        this.valueSvc = beans.valueSvc;
        this.rangeSvc = beans.rangeSvc;
        this.addManagedPropertyListener("editType", ({ currentValue: currentValue })=>{
            this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
            this.createStrategy(currentValue);
        });
        const handler = $437b23f6a393c3bf$var$_refreshEditCells(beans);
        const stopInvalidEdits = ()=>{
            const hasCellValidation = this.model.getCellValidationModel().getCellValidationMap().size > 0;
            const hasRowValidation = this.model.getRowValidationModel().getRowValidationMap().size > 0;
            if (hasCellValidation || hasRowValidation) this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
            else if (this.isEditing()) {
                if (this.batch) $437b23f6a393c3bf$var$_destroyEditors(beans, this.model.getEditPositions());
                else this.stopEditing(void 0, $437b23f6a393c3bf$var$COMMIT_PARAMS);
            }
            return false;
        };
        this.addManagedEventListeners({
            columnPinned: handler,
            columnVisible: handler,
            columnRowGroupChanged: handler,
            rowExpansionStateChanged: handler,
            pinnedRowsChanged: handler,
            displayedRowsChanged: handler,
            sortChanged: stopInvalidEdits,
            filterChanged: stopInvalidEdits,
            cellFocused: this.onCellFocused.bind(this)
        });
    }
    isBatchEditing() {
        return this.batch;
    }
    setBatchEditing(enabled) {
        if (enabled) {
            this.batch = true;
            this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
        } else {
            this.stopEditing(void 0, $437b23f6a393c3bf$var$CANCEL_PARAMS);
            this.batch = false;
        }
    }
    createStrategy(editType) {
        const { beans: beans, gos: gos, strategy: strategy } = this;
        const name = $437b23f6a393c3bf$var$getEditType(gos, editType);
        if (strategy) {
            if (strategy.beanName === name) return strategy;
            this.destroyStrategy();
        }
        return this.strategy = this.createOptionalManagedBean(beans.registry.createDynamicBean(name, true));
    }
    destroyStrategy() {
        if (!this.strategy) return;
        this.strategy.destroy();
        this.strategy = this.destroyBean(this.strategy);
    }
    shouldStartEditing(position, event, cellStartedEdit, source = "ui") {
        const shouldStart = $437b23f6a393c3bf$var$shouldStartEditing(this.beans, position, event, cellStartedEdit, source);
        if (shouldStart) this.strategy ?? (this.strategy = this.createStrategy());
        return shouldStart;
    }
    shouldStopEditing(position, event, source = "ui") {
        return this.strategy?.shouldStop(position, event, source) ?? null;
    }
    shouldCancelEditing(position, event, source = "ui") {
        return this.strategy?.shouldCancel(position, event, source) ?? null;
    }
    validateEdit() {
        return $437b23f6a393c3bf$var$_validateEdit(this.beans);
    }
    isEditing(position, params) {
        return this.model.hasEdits(position, params ?? $437b23f6a393c3bf$var$CHECK_SIBLING);
    }
    isRowEditing(rowNode, params) {
        return (rowNode && this.model.hasRowEdits(rowNode, params)) ?? false;
    }
    /** @returns whether to prevent default on event */ startEditing(position, params) {
        const { startedEdit: startedEdit = true, event: event = null, source: source = "ui", ignoreEventKey: ignoreEventKey = false, silent: silent } = params;
        this.strategy ?? (this.strategy = this.createStrategy());
        if (!this.isCellEditable(position, "api")) return;
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
        if (cellCtrl && !cellCtrl.comp) {
            cellCtrl.onCompAttachedFuncs.push(()=>this.startEditing(position, params));
            return;
        }
        const res = this.shouldStartEditing(position, event, startedEdit, source);
        if (res === false && source !== "api") {
            this.isEditing(position) && this.stopEditing();
            return;
        }
        if (!this.batch && this.shouldStopEditing(position, void 0, source) && !params.continueEditing) this.stopEditing(void 0, {
            source: source
        });
        if (res && this.batch) this.dispatchBatchEvent("batchEditingStarted", /* @__PURE__ */ new Map());
        this.strategy.start({
            position: position,
            event: event,
            source: source,
            ignoreEventKey: ignoreEventKey,
            startedEdit: startedEdit,
            silent: silent
        });
    }
    stopEditing(position, params) {
        const context = this.prepareStopContext(position, params);
        if (!context) return false;
        this.stopping = true;
        let res = false;
        let { edits: edits } = context;
        try {
            const outcome = this.processStopRequest(context);
            res || (res = outcome.res);
            edits = outcome.edits;
            this.finishStopEditing({
                ...context,
                edits: edits,
                params: params,
                position: position,
                res: res
            });
            return res;
        } finally{
            this.stopping = false;
        }
    }
    prepareStopContext(position, params) {
        const { event: event, cancel: cancel, source: source = "ui", forceCancel: forceCancel, forceStop: forceStop } = params || {};
        if ($437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM_KEYS.has(source) && this.batch) {
            this.bulkRefresh(position);
            return null;
        }
        const treatAsSource = this.committing ? $437b23f6a393c3bf$var$STOP_EDIT_SOURCE_TRANSFORM[source] : source;
        const isEditingOrBatchWithEdits = this.committing || this.isEditing(position) || this.batch && this.model.hasEdits(position, $437b23f6a393c3bf$var$CHECK_SIBLING);
        if (!isEditingOrBatchWithEdits || !this.strategy || this.stopping) return null;
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
        if (cellCtrl) cellCtrl.onEditorAttachedFuncs = [];
        const willStop = !cancel && (!!this.shouldStopEditing(position, event, treatAsSource) || (this.committing || source === "paste") && !this.batch) || (forceStop ?? false);
        const willCancel = cancel && !!this.shouldCancelEditing(position, event, treatAsSource) || (forceCancel ?? false);
        return {
            cancel: cancel,
            cellCtrl: cellCtrl ?? void 0,
            edits: this.model.getEditMap(true),
            event: event,
            forceCancel: forceCancel,
            forceStop: forceStop,
            position: position,
            source: source,
            treatAsSource: treatAsSource,
            willCancel: willCancel,
            willStop: willStop
        };
    }
    processStopRequest(context) {
        const { event: event, position: position, willCancel: willCancel, willStop: willStop } = context;
        if (willStop || willCancel) return this.handleStopOrCancel(context);
        if (this.shouldHandleMidBatchKey(event, position)) return {
            res: false,
            edits: this.handleMidBatchKey(event, position, context)
        };
        $437b23f6a393c3bf$var$_syncFromEditors(this.beans, {
            persist: true
        });
        if (this.batch) this.strategy?.cleanupEditors(position);
        return {
            res: false,
            edits: this.model.getEditMap()
        };
    }
    handleStopOrCancel(context) {
        const { beans: beans, model: model } = this;
        const { cancel: cancel, edits: edits, event: event, source: source, willCancel: willCancel, willStop: willStop } = context;
        $437b23f6a393c3bf$var$_syncFromEditors(beans, {
            persist: true,
            isCancelling: willCancel || cancel,
            isStopping: willStop
        });
        const freshEdits = model.getEditMap();
        const editsToDelete = this.processEdits(freshEdits, cancel, source);
        this.strategy?.stop(cancel, event);
        this.clearValidationIfNoOpenEditors();
        for (const position of editsToDelete)model.clearEditValue(position);
        this.bulkRefresh(void 0, edits);
        for (const pos of model.getEditPositions(freshEdits)){
            const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, pos);
            const valueChanged = $437b23f6a393c3bf$var$_sourceAndPendingDiffer(pos);
            cellCtrl?.refreshCell({
                force: true,
                suppressFlash: !valueChanged
            });
        }
        return {
            res: willStop,
            edits: freshEdits
        };
    }
    shouldHandleMidBatchKey(event, position) {
        return event instanceof KeyboardEvent && this.batch && !!this.strategy?.midBatchInputsAllowed(position) && this.isEditing(position, {
            withOpenEditor: true
        });
    }
    handleMidBatchKey(event, position, context) {
        const { beans: beans, model: model } = this;
        const { cellCtrl: cellCtrl, edits: edits } = context;
        const { key: key } = event;
        const isEnter = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
        const isEscape = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE;
        const isTab = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB;
        if (isEnter || isTab || isEscape) {
            if (isEnter || isTab) $437b23f6a393c3bf$var$_syncFromEditors(beans, {
                persist: true
            });
            else if (isEscape) this.revertSingleCellEdit(cellCtrl);
            if (this.batch) this.strategy?.cleanupEditors();
            else $437b23f6a393c3bf$var$_destroyEditors(beans, model.getEditPositions(), {
                event: event,
                cancel: isEscape
            });
            event.preventDefault();
            this.bulkRefresh(position, edits, {
                suppressFlash: true
            });
            return model.getEditMap();
        }
        return edits;
    }
    finishStopEditing({ cellCtrl: cellCtrl, edits: edits, params: params, position: position, res: res, willCancel: willCancel, willStop: willStop }) {
        const beans = this.beans;
        if (res && position) this.model.removeEdits(position);
        this.navigateAfterEdit(params, cellCtrl?.cellPosition);
        $437b23f6a393c3bf$var$_purgeUnchangedEdits(beans);
        this.clearValidationIfNoOpenEditors();
        this.bulkRefresh();
        const { rowRenderer: rowRenderer, formula: formula } = beans;
        if (willCancel) rowRenderer.refreshRows({
            rowNodes: Array.from(edits.keys())
        });
        if (this.batch) {
            if (formula) formula.refreshFormulas(true);
            else rowRenderer.refreshRows({
                suppressFlash: true,
                force: true
            });
            if (res && willStop) this.dispatchBatchEvent("batchEditingStopped", edits);
        }
    }
    clearValidationIfNoOpenEditors() {
        const hasOpenEditors = this.model.hasEdits(void 0, {
            withOpenEditor: true
        });
        if (!hasOpenEditors) {
            this.model.getCellValidationModel().clearCellValidationMap();
            this.model.getRowValidationModel().clearRowValidationMap();
        }
    }
    navigateAfterEdit(params, cellPosition) {
        if (!params || !cellPosition) return;
        const { event: event, suppressNavigateAfterEdit: suppressNavigateAfterEdit } = params;
        const isKeyBoardEvent = event instanceof KeyboardEvent;
        if (!isKeyBoardEvent || suppressNavigateAfterEdit) return;
        const { key: key, shiftKey: shiftKey } = event;
        const navAfterEdit = this.gos.get("enterNavigatesVerticallyAfterEdit");
        if (key !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || !navAfterEdit) return;
        const direction = shiftKey ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP : $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        this.beans.navigation?.navigateToNextCell(null, direction, cellPosition, false);
    }
    processEdits(edits, cancel = false, source) {
        const rowNodes = Array.from(edits.keys());
        const hasValidationErrors = this.model.getCellValidationModel().getCellValidationMap().size > 0 || this.model.getRowValidationModel().getRowValidationMap().size > 0;
        const editsToDelete = [];
        for (const rowNode of rowNodes){
            const editRow = edits.get(rowNode);
            for (const column of editRow.keys()){
                const editValue = editRow.get(column);
                const position = {
                    rowNode: rowNode,
                    column: column
                };
                const valueChanged = $437b23f6a393c3bf$var$_sourceAndPendingDiffer(editValue);
                if (!cancel && valueChanged && !hasValidationErrors) {
                    const success = this.setNodeDataValue(rowNode, column, editValue.pendingValue, void 0, source);
                    if (!success) editsToDelete.push(position);
                }
            }
        }
        return editsToDelete;
    }
    setNodeDataValue(rowNode, column, newValue, refreshCell, originalSource = "edit") {
        const { beans: beans } = this;
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, {
            rowNode: rowNode,
            column: column
        });
        const translatedSource = $437b23f6a393c3bf$var$INTERNAL_EDITOR_SOURCES.has(originalSource) ? "edit" : originalSource;
        if (cellCtrl) cellCtrl.suppressRefreshCell = true;
        this.committing = true;
        const success = rowNode.setDataValue(column, newValue, translatedSource);
        this.committing = false;
        if (cellCtrl) cellCtrl.suppressRefreshCell = false;
        if (refreshCell) cellCtrl?.refreshCell($437b23f6a393c3bf$var$FORCE_REFRESH);
        return success;
    }
    setEditMap(edits, params) {
        this.strategy ?? (this.strategy = this.createStrategy());
        this.strategy?.setEditMap(edits, params);
        this.bulkRefresh();
        let refreshParams = $437b23f6a393c3bf$var$FORCE_REFRESH;
        if (params?.forceRefreshOfEditCellsOnly) refreshParams = {
            ...$437b23f6a393c3bf$var$getRowColumnsFromMap(edits),
            ...$437b23f6a393c3bf$var$FORCE_REFRESH
        };
        this.beans.rowRenderer.refreshCells(refreshParams);
    }
    dispatchEditValuesChanged({ rowNode: rowNode, column: column }, edit = {}) {
        if (!rowNode || !column || !edit) return;
        const { pendingValue: pendingValue, sourceValue: sourceValue } = edit;
        const { rowIndex: rowIndex, rowPinned: rowPinned, data: data } = rowNode;
        this.beans.eventSvc.dispatchEvent({
            type: "cellEditValuesChanged",
            node: rowNode,
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column,
            source: "api",
            data: data,
            newValue: pendingValue,
            oldValue: sourceValue,
            value: pendingValue,
            colDef: column.getColDef()
        });
    }
    bulkRefresh(position = {}, editMap, params = {}) {
        const { beans: beans, gos: gos } = this;
        const { editModelSvc: editModelSvc, rowModel: rowModel } = beans;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) {
            if (position.rowNode && position.column) this.refCell(position, this.model.getEdit(position), params);
            else if (editMap) editModelSvc?.getEditMap(false)?.forEach((editRow, rowNode)=>{
                for (const column of editRow.keys())this.refCell({
                    rowNode: rowNode,
                    column: column
                }, editRow.get(column), params);
            });
        }
    }
    refCell({ rowNode: rowNode, column: column }, edit, params = {}) {
        const { beans: beans, gos: gos } = this;
        const updatedNodes = /* @__PURE__ */ new Set([
            rowNode
        ]);
        const refreshNodes = /* @__PURE__ */ new Set();
        const pinnedSibling = rowNode.pinnedSibling;
        if (pinnedSibling) updatedNodes.add(pinnedSibling);
        const sibling = rowNode.sibling;
        if (sibling) refreshNodes.add(sibling);
        let parent = rowNode.parent;
        while(parent){
            if (parent.sibling?.footer && gos.get("groupTotalRow")) refreshNodes.add(parent.sibling);
            else if (!parent.parent && parent.sibling && gos.get("grandTotalRow")) refreshNodes.add(parent.sibling);
            else refreshNodes.add(parent);
            parent = parent.parent;
        }
        for (const node of updatedNodes)this.dispatchEditValuesChanged({
            rowNode: node,
            column: column
        }, edit);
        for (const node of updatedNodes)$437b23f6a393c3bf$var$_getCellCtrl(beans, {
            rowNode: node,
            column: column
        })?.refreshCell(params);
        for (const node of refreshNodes)$437b23f6a393c3bf$var$_getCellCtrl(beans, {
            rowNode: node,
            column: column
        })?.refreshCell(params);
    }
    stopAllEditing(cancel = false, source = "ui") {
        if (this.isEditing()) this.stopEditing(void 0, {
            cancel: cancel,
            source: source
        });
    }
    isCellEditable(position, source = "ui") {
        const { rowNode: rowNode } = position;
        const { gos: gos, beans: beans } = this;
        if (rowNode.group) {
            if (gos.get("treeData")) {
                if (!rowNode.data && !gos.get("enableGroupEdit")) return false;
            } else if (!gos.get("enableGroupEdit")) return false;
        }
        const isEditable = $437b23f6a393c3bf$var$getEditType(gos) === "fullRow" ? $437b23f6a393c3bf$var$isFullRowCellEditable(beans, position, source) : $437b23f6a393c3bf$var$isCellEditable(beans, position, source);
        if (isEditable) this.strategy ?? (this.strategy = this.createStrategy());
        return isEditable;
    }
    cellEditingInvalidCommitBlocks() {
        return this.gos.get("invalidEditValueMode") === "block";
    }
    checkNavWithValidation(position, event, focus = true) {
        if (this.hasValidationErrors(position)) {
            const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
            if (this.cellEditingInvalidCommitBlocks()) {
                event?.preventDefault?.();
                if (focus) {
                    !cellCtrl?.hasBrowserFocus() && cellCtrl?.focusCell();
                    cellCtrl?.comp?.getCellEditor()?.focusIn?.();
                }
                return "block-stop";
            }
            cellCtrl && this.revertSingleCellEdit(cellCtrl);
            return "revert-continue";
        }
        return "continue";
    }
    revertSingleCellEdit(cellPosition, focus = false) {
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, cellPosition);
        if (!cellCtrl?.comp?.getCellEditor()) return;
        $437b23f6a393c3bf$var$_destroyEditors(this.beans, [
            cellPosition
        ], {
            silent: true
        });
        this.model.clearEditValue(cellPosition);
        $437b23f6a393c3bf$var$_setupEditor(this.beans, cellPosition, {
            silent: true
        });
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
        cellCtrl?.refreshCell($437b23f6a393c3bf$var$FORCE_REFRESH);
        if (!focus) return;
        cellCtrl?.focusCell();
        cellCtrl?.comp?.getCellEditor()?.focusIn?.();
    }
    hasValidationErrors(position) {
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
        if (cellCtrl) {
            cellCtrl.refreshCell($437b23f6a393c3bf$var$FORCE_REFRESH);
            cellCtrl.rowCtrl.rowEditStyleFeature?.applyRowStyles();
        }
        let invalid = false;
        if (position?.rowNode) {
            invalid || (invalid = this.model.getRowValidationModel().hasRowValidation({
                rowNode: position.rowNode
            }));
            if (position.column) invalid || (invalid = this.model.getCellValidationModel().hasCellValidation({
                rowNode: position.rowNode,
                column: position.column
            }));
        } else {
            invalid || (invalid = this.model.getCellValidationModel().getCellValidationMap().size > 0);
            invalid || (invalid = this.model.getRowValidationModel().getRowValidationMap().size > 0);
        }
        return invalid;
    }
    moveToNextCell(prev, backwards, event, source = "ui") {
        let res;
        const editing = this.isEditing();
        const preventNavigation = editing && this.checkNavWithValidation(void 0, event) === "block-stop";
        if (prev instanceof $437b23f6a393c3bf$var$CellCtrl && editing) res = this.strategy?.moveToNextEditingCell(prev, backwards, event, source, preventNavigation);
        if (res === null) return res;
        res = res || !!this.beans.focusSvc.focusedHeader;
        if (res === false && !preventNavigation) this.stopEditing();
        return res;
    }
    getCellDataValue({ rowNode: rowNode, column: column }, preferEditor = true) {
        if (!rowNode || !column) return void 0;
        let edit = this.model.getEdit({
            rowNode: rowNode,
            column: column
        });
        const pinnedSibling = rowNode.pinnedSibling;
        if (pinnedSibling) {
            const siblingEdit = this.model.getEdit({
                rowNode: pinnedSibling,
                column: column
            });
            if (siblingEdit) edit = siblingEdit;
        }
        const newValue = preferEditor ? edit?.editorValue ?? edit?.pendingValue : edit?.pendingValue;
        return newValue === $437b23f6a393c3bf$var$UNEDITED || !edit ? edit?.sourceValue ?? this.valueSvc.getValue(column, rowNode, false, "api") : newValue;
    }
    addStopEditingWhenGridLosesFocus(viewports) {
        $437b23f6a393c3bf$var$_addStopEditingWhenGridLosesFocus(this, this.beans, viewports);
    }
    createPopupEditorWrapper(params) {
        return new $437b23f6a393c3bf$var$PopupEditorWrapper(params);
    }
    setDataValue(position, newValue, eventSource) {
        try {
            if ((!this.isEditing() || this.committing) && !$437b23f6a393c3bf$var$SET_DATA_SOURCE_AS_API.has(eventSource)) return;
            const { beans: beans } = this;
            this.strategy ?? (this.strategy = this.createStrategy());
            const source = this.batch ? "ui" : this.committing ? eventSource ?? "api" : "api";
            if (!eventSource || $437b23f6a393c3bf$var$KEEP_EDITOR_SOURCES.has(eventSource)) {
                $437b23f6a393c3bf$var$_syncFromEditor(beans, position, newValue, eventSource, void 0, {
                    persist: true
                });
                if (this.batch) {
                    this.cleanupEditors();
                    $437b23f6a393c3bf$var$_purgeUnchangedEdits(beans);
                    this.bulkRefresh();
                    return true;
                }
                return this.setNodeDataValue(position.rowNode, position.column, newValue, true, eventSource);
            }
            const existing = this.model.getEdit(position);
            if (existing) {
                if (existing.pendingValue === newValue) return false;
                if (existing.sourceValue !== newValue) {
                    $437b23f6a393c3bf$var$_syncFromEditor(beans, position, newValue, eventSource, void 0, {
                        persist: true
                    });
                    this.stopEditing(position, {
                        source: source,
                        suppressNavigateAfterEdit: true
                    });
                    return true;
                }
                if (existing.sourceValue === newValue) {
                    beans.editModelSvc?.removeEdits(position);
                    this.dispatchEditValuesChanged(position, {
                        ...existing,
                        pendingValue: newValue
                    });
                    return true;
                }
            }
            $437b23f6a393c3bf$var$_syncFromEditor(beans, position, newValue, eventSource, void 0, {
                persist: true
            });
            this.stopEditing(position, {
                source: source,
                suppressNavigateAfterEdit: true
            });
            return true;
        } finally{
            this.committing = false;
        }
    }
    handleColDefChanged(cellCtrl) {
        $437b23f6a393c3bf$var$_refreshEditorOnColDefChanged(this.beans, cellCtrl);
    }
    destroy() {
        this.model.clear();
        this.destroyStrategy();
        super.destroy();
    }
    prepDetailsDuringBatch(position, params) {
        const { model: model } = this;
        if (!this.batch) return;
        const hasEdits = model.hasRowEdits(position.rowNode, $437b23f6a393c3bf$var$CHECK_SIBLING);
        if (!hasEdits) return;
        const { rowNode: rowNode } = position;
        const { compDetails: compDetails, valueToDisplay: valueToDisplay } = params;
        if (compDetails) {
            const { params: params2 } = compDetails;
            params2.data = model.getEditRowDataValue(rowNode, $437b23f6a393c3bf$var$CHECK_SIBLING);
            return {
                compDetails: compDetails
            };
        }
        return {
            valueToDisplay: valueToDisplay
        };
    }
    cleanupEditors() {
        this.strategy?.cleanupEditors();
    }
    dispatchCellEvent(position, event, type, payload) {
        this.strategy?.dispatchCellEvent(position, event, type, payload);
    }
    dispatchBatchEvent(type, edits) {
        this.eventSvc.dispatchEvent(this.createBatchEditEvent(type, edits));
    }
    createBatchEditEvent(type, edits) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            type: type,
            ...type === "batchEditingStopped" ? {
                changes: this.toEventChangeList(edits)
            } : {}
        });
    }
    toEventChangeList(edits) {
        return this.model.getEditPositions(edits).map((edit)=>({
                rowIndex: edit.rowNode.rowIndex,
                rowPinned: edit.rowNode.rowPinned,
                columnId: edit.column.getColId(),
                newValue: edit.pendingValue,
                oldValue: edit.sourceValue
            }));
    }
    applyBulkEdit({ rowNode: rowNode, column: column }, ranges) {
        if (!ranges || ranges.length === 0) return;
        const { beans: beans, rangeSvc: rangeSvc, valueSvc: valueSvc } = this;
        const { formula: formula } = beans;
        $437b23f6a393c3bf$var$_syncFromEditors(beans, {
            persist: true
        });
        const edits = this.model.getEditMap(true);
        let editValue = edits.get(rowNode)?.get(column)?.pendingValue;
        if (!this.batch) this.eventSvc.dispatchEvent({
            type: "bulkEditingStarted"
        });
        const isFormula = formula?.isFormula(editValue) ?? false;
        ranges.forEach((range)=>{
            const hasFormulaColumnsInRange = range.columns.some((col)=>col?.isAllowFormula());
            rangeSvc?.forEachRowInRange(range, (position)=>{
                const rowNode2 = $437b23f6a393c3bf$export$d4675a60917db7b0(beans, position);
                if (rowNode2 === void 0) return;
                const editRow = edits.get(rowNode2) ?? /* @__PURE__ */ new Map();
                let valueForColumn = editValue;
                for (const column2 of range.columns){
                    if (!column2) continue;
                    const isFormulaForColumn = !!isFormula && column2.isAllowFormula();
                    if (this.isCellEditable({
                        rowNode: rowNode2,
                        column: column2
                    }, "api")) {
                        const sourceValue = valueSvc.getValue(column2, rowNode2, true, "api");
                        let pendingValue = valueSvc.parseValue(column2, rowNode2 ?? null, valueForColumn, sourceValue);
                        if (Number.isNaN(pendingValue)) pendingValue = null;
                        editRow.set(column2, {
                            editorValue: void 0,
                            pendingValue: pendingValue,
                            sourceValue: sourceValue,
                            state: "changed",
                            editorState: {
                                isCancelAfterEnd: void 0,
                                isCancelBeforeStart: void 0
                            }
                        });
                    }
                    if (isFormulaForColumn) valueForColumn = formula?.updateFormulaByOffset({
                        value: valueForColumn,
                        columnDelta: 1
                    });
                }
                if (editRow.size > 0) edits.set(rowNode2, editRow);
                if (isFormula && hasFormulaColumnsInRange) editValue = formula?.updateFormulaByOffset({
                    value: editValue,
                    rowDelta: 1
                });
            });
            this.setEditMap(edits);
            if (this.batch) {
                this.cleanupEditors();
                $437b23f6a393c3bf$var$_purgeUnchangedEdits(beans);
                this.bulkRefresh();
                return;
            }
            this.committing = true;
            this.stopEditing(void 0, {
                source: "bulk"
            });
            this.committing = false;
            this.eventSvc.dispatchEvent({
                type: "bulkEditingStopped",
                changes: this.toEventChangeList(edits)
            });
        });
        this.bulkRefresh();
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, {
            rowNode: rowNode,
            column: column
        });
        if (cellCtrl) cellCtrl.focusCell(true);
    }
    createCellStyleFeature(cellCtrl) {
        return new $437b23f6a393c3bf$var$CellEditStyleFeature(cellCtrl, this.beans);
    }
    createRowStyleFeature(rowCtrl) {
        return new $437b23f6a393c3bf$var$RowEditStyleFeature(rowCtrl, this.beans);
    }
    setEditingCells(cells, params) {
        const { beans: beans } = this;
        const { colModel: colModel, valueSvc: valueSvc } = beans;
        const edits = /* @__PURE__ */ new Map();
        for (let { colId: colId, column: column, colKey: colKey, rowIndex: rowIndex, rowPinned: rowPinned, newValue: pendingValue, state: state } of cells){
            const col = colId ? colModel.getCol(colId) : colKey ? colModel.getCol(colKey) : column;
            if (!col) continue;
            const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(beans, {
                rowIndex: rowIndex,
                rowPinned: rowPinned
            });
            if (!rowNode) continue;
            const sourceValue = valueSvc.getValue(col, rowNode, true, "api");
            if (!params?.forceRefreshOfEditCellsOnly && !$437b23f6a393c3bf$var$_sourceAndPendingDiffer({
                pendingValue: pendingValue,
                sourceValue: sourceValue
            }) && state !== "editing") continue;
            let editRow = edits.get(rowNode);
            if (!editRow) {
                editRow = /* @__PURE__ */ new Map();
                edits.set(rowNode, editRow);
            }
            if (pendingValue === void 0) pendingValue = $437b23f6a393c3bf$var$UNEDITED;
            editRow.set(col, {
                editorValue: void 0,
                pendingValue: pendingValue,
                sourceValue: sourceValue,
                state: state ?? "changed",
                editorState: {
                    isCancelAfterEnd: void 0,
                    isCancelBeforeStart: void 0
                }
            });
        }
        this.setEditMap(edits, params);
    }
    onCellFocused(event) {
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, event);
        if (!cellCtrl || !this.isEditing(cellCtrl, $437b23f6a393c3bf$var$CHECK_SIBLING)) return;
        const edit = this.model.getEdit(cellCtrl);
        if (!edit || !$437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit)) return;
        const translate = this.getLocaleTextFunc();
        const label = translate("ariaPendingChange", "Pending Change");
        this.beans.ariaAnnounce?.announceValue(label, "pendingChange");
    }
    allowedFocusTargetOnValidation(cellPosition) {
        return $437b23f6a393c3bf$var$_getCellCtrl(this.beans, cellPosition);
    }
};
function $437b23f6a393c3bf$var$getRowColumnsFromMap(edits) {
    return {
        rowNodes: edits ? Array.from(edits.keys()) : void 0,
        columns: edits ? [
            ...new Set(Array.from(edits.values()).flatMap((er)=>Array.from(er.keys())))
        ] : void 0
    };
}
function $437b23f6a393c3bf$var$getEditType(gos, editType) {
    return editType ?? gos.get("editType") ?? "singleCell";
}
// packages/ag-grid-community/src/edit/strategy/baseEditStrategy.ts
var $437b23f6a393c3bf$var$BaseEditStrategy = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        this.model = this.beans.editModelSvc;
        this.editSvc = this.beans.editSvc;
        this.addManagedEventListeners({
            cellFocused: this.onCellFocusChanged?.bind(this),
            cellFocusCleared: this.onCellFocusChanged?.bind(this)
        });
    }
    clearEdits(position) {
        this.model.clearEditValue(position);
    }
    onCellFocusChanged(event) {
        let cellCtrl;
        const previous = event["previousParams"];
        const { editSvc: editSvc, beans: beans } = this;
        const sourceEvent = event.type === "cellFocused" ? event.sourceEvent : null;
        if (previous) cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(beans, previous);
        const { gos: gos, editModelSvc: editModelSvc } = beans;
        const isFocusCleared = event.type === "cellFocusCleared";
        if (editSvc.isEditing(void 0, {
            withOpenEditor: true
        })) {
            const { column: column, rowIndex: rowIndex, rowPinned: rowPinned } = event;
            const cellPositionFromEvent = {
                column: column,
                rowNode: $437b23f6a393c3bf$export$d4675a60917db7b0(beans, {
                    rowIndex: rowIndex,
                    rowPinned: rowPinned
                })
            };
            const isBlock = gos.get("invalidEditValueMode") === "block";
            if (isBlock) return;
            const shouldRevert = !isBlock;
            const hasError = !!editModelSvc?.getCellValidationModel().hasCellValidation(cellPositionFromEvent);
            const shouldCancel = shouldRevert && hasError;
            const result = previous || isFocusCleared ? editSvc.stopEditing(void 0, {
                cancel: shouldCancel,
                source: isFocusCleared && shouldRevert ? "api" : void 0,
                event: sourceEvent
            }) : true;
            if (!result) {
                if (editSvc.isBatchEditing()) editSvc.cleanupEditors();
                else editSvc.stopEditing(void 0, {
                    source: "api"
                });
            }
        }
        cellCtrl?.refreshCell({
            suppressFlash: true,
            force: true
        });
    }
    stop(cancel, event) {
        const editingCells = this.model.getEditPositions();
        const results = {
            all: [],
            pass: [],
            fail: []
        };
        for (const cell of editingCells){
            results.all.push(cell);
            const validation = this.model.getCellValidationModel().getCellValidation(cell);
            if ((validation?.errorMessages?.length ?? 0) > 0) {
                results.fail.push(cell);
                continue;
            }
            results.pass.push(cell);
        }
        if (cancel) for (const cell of editingCells){
            $437b23f6a393c3bf$var$_destroyEditor(this.beans, cell, {
                cancel: cancel
            });
            this.model.stop(cell);
        }
        else {
            const actions = this.processValidationResults(results);
            if (actions.destroy.length > 0) for (const cell of actions.destroy){
                $437b23f6a393c3bf$var$_destroyEditor(this.beans, cell, {
                    event: event,
                    cancel: cancel
                });
                this.model.stop(cell);
            }
            if (actions.keep.length > 0) for (const cell of actions.keep){
                const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, cell);
                if (!this.editSvc?.cellEditingInvalidCommitBlocks()) cellCtrl && this.editSvc.revertSingleCellEdit(cellCtrl);
            }
        }
        return true;
    }
    cleanupEditors({ rowNode: rowNode } = {}, includeEditing) {
        $437b23f6a393c3bf$var$_syncFromEditors(this.beans, {
            persist: false
        });
        const positions = this.model.getEditPositions();
        const discard = [];
        if (rowNode) {
            for (const pos of positions)if (pos.rowNode !== rowNode) discard.push(pos);
        } else for (const pos of positions)discard.push(pos);
        $437b23f6a393c3bf$var$_destroyEditors(this.beans, discard);
        $437b23f6a393c3bf$var$_purgeUnchangedEdits(this.beans, includeEditing);
    }
    setFocusOutOnEditor(cellCtrl) {
        cellCtrl.comp?.getCellEditor()?.focusOut?.();
    }
    setFocusInOnEditor(cellCtrl) {
        const comp = cellCtrl.comp;
        const editor = comp?.getCellEditor();
        if (editor?.focusIn) editor.focusIn();
        else {
            const isFullRow = this.beans.gos.get("editType") === "fullRow";
            cellCtrl.focusCell(isFullRow);
            cellCtrl.onEditorAttachedFuncs.push(()=>comp?.getCellEditor()?.focusIn?.());
        }
    }
    setupEditors(params) {
        const { event: event, ignoreEventKey: ignoreEventKey = false, startedEdit: startedEdit, position: position, cells: cells = this.model.getEditPositions() } = params;
        const key = event instanceof KeyboardEvent && !ignoreEventKey && event.key || void 0;
        $437b23f6a393c3bf$var$_setupEditors(this.beans, cells, position, key, event, startedEdit);
    }
    dispatchCellEvent(position, event, type, payload) {
        const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
        if (cellCtrl) this.eventSvc.dispatchEvent({
            ...cellCtrl.createEvent(event ?? null, type),
            ...payload
        });
    }
    dispatchRowEvent(position, type, silent) {
        if (silent) return;
        const rowCtrl = $437b23f6a393c3bf$var$_getRowCtrl(this.beans, position);
        if (rowCtrl) this.eventSvc.dispatchEvent(rowCtrl.createRowEvent(type));
    }
    shouldStop(_position, event, source = "ui") {
        const batch = this.editSvc.isBatchEditing();
        if (batch && source === "api") return true;
        if (batch && (source === "ui" || source === "edit")) return false;
        if (source === "api") return true;
        if (event instanceof KeyboardEvent && !batch) return event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
        return null;
    }
    shouldCancel(_position, event, source = "ui") {
        const batch = this.editSvc.isBatchEditing();
        if (event instanceof KeyboardEvent && !batch) {
            const result = event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE;
            if (result) return true;
        }
        if (batch && source === "api") return true;
        if (source === "api") return true;
        return false;
    }
    setEditMap(edits, params) {
        if (!params?.update) this.editSvc.stopEditing(void 0, {
            cancel: true,
            source: "api"
        });
        const cells = [];
        edits.forEach((editRow, rowNode)=>{
            editRow.forEach((cellData, column)=>{
                if (cellData.state === "editing") cells.push({
                    ...cellData,
                    rowNode: rowNode,
                    column: column
                });
            });
        });
        if (params?.update) edits = new Map([
            ...this.model.getEditMap(),
            ...edits
        ]);
        this.model?.setEditMap(edits);
        if (cells.length > 0) {
            const position = cells.at(-1);
            const key = position.pendingValue === $437b23f6a393c3bf$var$UNEDITED ? void 0 : position.pendingValue;
            this.start({
                position: position,
                event: new KeyboardEvent("keydown", {
                    key: key
                }),
                source: "api"
            });
            const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, position);
            if (cellCtrl) this.setFocusInOnEditor(cellCtrl);
        }
    }
    destroy() {
        this.cleanupEditors();
        super.destroy();
    }
};
// packages/ag-grid-community/src/edit/strategy/fullRowEditStrategy.ts
var $437b23f6a393c3bf$var$FullRowEditStrategy = class extends $437b23f6a393c3bf$var$BaseEditStrategy {
    constructor(){
        super(...arguments);
        this.beanName = "fullRow";
        this.startedRows = [];
    }
    shouldStop(position, event, _source = "ui") {
        const { rowNode: rowNode } = position || {};
        const oldRowCtrl = $437b23f6a393c3bf$var$_getRowCtrl(this.beans, {
            rowNode: this.rowNode
        });
        if (!oldRowCtrl) return true;
        const res = super.shouldStop({
            rowNode: this.rowNode
        }, event, _source);
        if (res !== null) return res;
        if (!this.rowNode) return false;
        return rowNode !== this.rowNode;
    }
    midBatchInputsAllowed({ rowNode: rowNode }) {
        if (!rowNode) return false;
        return this.model.hasEdits({
            rowNode: rowNode
        });
    }
    clearEdits(position) {
        this.model.clearEditValue(position);
    }
    start(params) {
        const { position: position, silent: silent, startedEdit: startedEdit, event: event, ignoreEventKey: ignoreEventKey } = params;
        const { rowNode: rowNode } = position;
        if (this.rowNode !== rowNode) super.cleanupEditors(position);
        const columns = this.beans.visibleCols.allCols;
        const cells = [];
        const editableColumns = [];
        for (const column of columns)if (column.isCellEditable(rowNode)) editableColumns.push(column);
        if (editableColumns.length == 0) return;
        this.dispatchRowEvent({
            rowNode: rowNode
        }, "rowEditingStarted", silent);
        this.startedRows.push(rowNode);
        for (const column of editableColumns){
            const position2 = {
                rowNode: rowNode,
                column: column
            };
            cells.push(position2);
            if (!this.model.hasEdits(position2)) this.model.start(position2);
        }
        this.rowNode = rowNode;
        this.setupEditors({
            cells: cells,
            position: position,
            startedEdit: startedEdit,
            event: event,
            ignoreEventKey: ignoreEventKey
        });
    }
    processValidationResults(results) {
        const anyFailed = results.fail.length > 0;
        if (anyFailed && this.editSvc.cellEditingInvalidCommitBlocks()) return {
            destroy: [],
            keep: results.all
        };
        return {
            destroy: results.all,
            keep: []
        };
    }
    stop(cancel, event) {
        const { rowNode: rowNode } = this;
        if (rowNode && !this.model.hasRowEdits(rowNode)) return false;
        const changedRows = [];
        if (!cancel) this.model.getEditMap().forEach((rowEdits, rowNode2)=>{
            if (!rowEdits || rowEdits.size === 0) return;
            for (const edit of rowEdits.values())if ($437b23f6a393c3bf$var$_sourceAndPendingDiffer(edit)) {
                changedRows.push(rowNode2);
                break;
            }
        });
        $437b23f6a393c3bf$var$_populateModelValidationErrors(this.beans);
        if (!cancel && this.editSvc?.checkNavWithValidation({
            rowNode: rowNode
        }) === "block-stop") return false;
        super.stop(cancel, event);
        for (const rowNode2 of changedRows)this.dispatchRowEvent({
            rowNode: rowNode2
        }, "rowValueChanged");
        this.cleanupEditors({
            rowNode: rowNode
        }, true);
        this.rowNode = void 0;
        return true;
    }
    onCellFocusChanged(event) {
        const { rowIndex: rowIndex } = event;
        const prev = event["previousParams"];
        if (prev?.rowIndex === rowIndex || event.sourceEvent instanceof KeyboardEvent) return;
        const prevCell = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, prev);
        const isBlock = this.gos.get("invalidEditValueMode") === "block";
        if (isBlock && prevCell && (this.model.getCellValidationModel().getCellValidation(prevCell) || this.model.getRowValidationModel().getRowValidation(prevCell))) return;
        super.onCellFocusChanged(event);
    }
    cleanupEditors(position = {}, includeEditing) {
        super.cleanupEditors(position, includeEditing);
        for (const rowNode of this.startedRows){
            this.dispatchRowEvent({
                rowNode: rowNode
            }, "rowEditingStopped");
            this.destroyEditorsForRow(rowNode);
        }
        this.startedRows.length = 0;
    }
    /**
   * Destroys all editors for a row that started full row editing, including editors
   * that are not represented in the edit model (e.g. empty/unedited editors).
   */ destroyEditorsForRow(rowNode) {
        const rowCtrl = $437b23f6a393c3bf$var$_getRowCtrl(this.beans, {
            rowNode: rowNode
        });
        if (!rowCtrl) return;
        for (const cellCtrl of rowCtrl.getAllCellCtrls())if (cellCtrl.comp?.getCellEditor()) $437b23f6a393c3bf$var$_destroyEditor(this.beans, cellCtrl, void 0, cellCtrl);
    }
    // returns null if no navigation should be performed
    moveToNextEditingCell(prevCell, backwards, event, source = "ui", preventNavigation = false) {
        const prevPos = prevCell.cellPosition;
        let nextCell;
        this.model.suspend(true);
        try {
            nextCell = this.beans.navigation?.findNextCellToFocusOn(prevPos, {
                backwards: backwards,
                startEditing: true,
                // Default behaviour for fullRow is skip to the next cell,
                // editable or not. FullRow editing might have some editable
                // and some not editable cells in the row.
                // More complex logic needed to skip to the
                // next FullRow editable cell,
                skipToNextEditableCell: false
            });
        } finally{
            this.model.suspend(false);
        }
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        const nextPos = nextCell.cellPosition;
        const prevEditable = prevCell.isCellEditable();
        const nextEditable = nextCell.isCellEditable();
        const rowsMatch = nextPos && prevPos.rowIndex === nextPos.rowIndex && prevPos.rowPinned === nextPos.rowPinned;
        if (prevEditable) this.setFocusOutOnEditor(prevCell);
        this.restoreEditors();
        const suppressStartEditOnTab = this.gos.get("suppressStartEditOnTab");
        if (nextEditable && !preventNavigation) {
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else {
                if (!nextCell.comp?.getCellEditor()) $437b23f6a393c3bf$var$_setupEditor(this.beans, nextCell, {
                    event: event,
                    cellStartedEdit: true
                });
                this.setFocusInOnEditor(nextCell);
                nextCell.focusCell(false, event);
            }
        } else {
            if (nextEditable && preventNavigation) this.setFocusInOnEditor(nextCell);
            nextCell.focusCell(true, event);
        }
        if (!rowsMatch && !preventNavigation) {
            this.editSvc?.stopEditing({
                rowNode: prevCell.rowNode
            }, {
                event: event
            });
            this.cleanupEditors(nextCell, true);
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else this.editSvc.startEditing(nextCell, {
                startedEdit: true,
                event: event,
                source: source,
                ignoreEventKey: true
            });
        }
        prevCell.rowCtrl?.refreshRow({
            suppressFlash: true,
            force: true
        });
        return true;
    }
    restoreEditors() {
        this.model.getEditMap().forEach((rowEdits, rowNode)=>rowEdits.forEach(({ state: state }, column)=>{
                if (state !== "editing") return;
                const cellCtrl = $437b23f6a393c3bf$var$_getCellCtrl(this.beans, {
                    rowNode: rowNode,
                    column: column
                });
                if (cellCtrl && !cellCtrl.comp?.getCellEditor()) $437b23f6a393c3bf$var$_setupEditor(this.beans, cellCtrl, {
                    silent: true
                });
            }));
    }
    destroy() {
        super.destroy();
        this.rowNode = void 0;
        this.startedRows.length = 0;
    }
};
// packages/ag-grid-community/src/edit/strategy/singleCellEditStrategy.ts
var $437b23f6a393c3bf$var$SingleCellEditStrategy = class extends $437b23f6a393c3bf$var$BaseEditStrategy {
    constructor(){
        super(...arguments);
        this.beanName = "singleCell";
    }
    shouldStop(position, event, source = "ui") {
        const res = super.shouldStop(position, event, source);
        if (res !== null) return res;
        const { rowNode: rowNode, column: column } = position || {};
        if ((!this.rowNode || !this.column) && rowNode && column) return null;
        return this.rowNode !== rowNode || this.column !== column;
    }
    midBatchInputsAllowed(position) {
        return this.model.hasEdits(position);
    }
    start(params) {
        const { position: position, startedEdit: startedEdit, event: event, ignoreEventKey: ignoreEventKey } = params;
        if (this.rowNode !== position.rowNode || this.column !== position.column) super.cleanupEditors();
        this.rowNode = position.rowNode;
        this.column = position.column;
        this.model.start(position);
        this.setupEditors({
            cells: [
                position
            ],
            position: position,
            startedEdit: startedEdit,
            event: event,
            ignoreEventKey: ignoreEventKey
        });
    }
    dispatchRowEvent(_position, _type, _silent) {}
    processValidationResults(results) {
        const anyFailed = results.fail.length > 0;
        if (anyFailed && this.editSvc.cellEditingInvalidCommitBlocks()) return {
            destroy: [],
            keep: results.all
        };
        return {
            destroy: results.all,
            keep: []
        };
    }
    stop(cancel, event) {
        super.stop(cancel, event);
        this.rowNode = void 0;
        this.column = void 0;
        return true;
    }
    onCellFocusChanged(event) {
        const { colModel: colModel, editSvc: editSvc } = this.beans;
        const { rowIndex: rowIndex, column: column, rowPinned: rowPinned } = event;
        const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        });
        const curColId = $437b23f6a393c3bf$var$_getColId(column);
        const curCol = colModel.getCol(curColId);
        const previous = event["previousParams"];
        if (previous) {
            const prevColId = $437b23f6a393c3bf$var$_getColId(previous.column);
            if (previous?.rowIndex === rowIndex && prevColId === curColId && previous?.rowPinned === rowPinned) return;
        }
        if (editSvc?.isEditing({
            rowNode: rowNode,
            column: curCol
        }, {
            withOpenEditor: true
        }) && event.type === "cellFocused") return;
        super.onCellFocusChanged(event);
    }
    // returns null if no navigation should be performed
    moveToNextEditingCell(prevCell, backwards, event, source = "ui", preventNavigation = false) {
        const focusedCell = this.beans.focusSvc.getFocusedCell();
        if (focusedCell) prevCell = $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, focusedCell) ?? prevCell;
        const prevPos = prevCell.cellPosition;
        let nextCell;
        const shouldSuspend = this.beans.gos.get("editType") === "fullRow";
        if (shouldSuspend) this.model.suspend(true);
        if (!preventNavigation) {
            prevCell.eGui.focus();
            this.editSvc?.stopEditing(prevCell, {
                source: this.editSvc?.isBatchEditing() ? "ui" : "api",
                event: event
            });
        }
        try {
            nextCell = this.beans.navigation?.findNextCellToFocusOn(prevPos, {
                backwards: backwards,
                startEditing: true
            });
        } finally{
            if (shouldSuspend) this.model.suspend(false);
        }
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        const nextPos = nextCell.cellPosition;
        const prevEditable = prevCell.isCellEditable();
        const nextEditable = nextCell.isCellEditable();
        const rowsMatch = nextPos && prevPos.rowIndex === nextPos.rowIndex && prevPos.rowPinned === nextPos.rowPinned;
        if (prevEditable && !preventNavigation) this.setFocusOutOnEditor(prevCell);
        const suppressStartEditOnTab = this.gos.get("suppressStartEditOnTab");
        if (!rowsMatch && !preventNavigation) {
            super.cleanupEditors(nextCell, true);
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else this.editSvc.startEditing(nextCell, {
                startedEdit: true,
                event: event,
                source: source,
                ignoreEventKey: true
            });
        }
        if (nextEditable && !preventNavigation) {
            nextCell.focusCell(false, event);
            if (suppressStartEditOnTab) nextCell.focusCell(true, event);
            else if (!nextCell.comp?.getCellEditor()) {
                const alreadyEditing = this.editSvc?.isEditing(nextCell, {
                    withOpenEditor: true
                });
                $437b23f6a393c3bf$var$_setupEditor(this.beans, nextCell, {
                    event: event,
                    cellStartedEdit: true,
                    silent: alreadyEditing
                });
                this.setFocusInOnEditor(nextCell);
                this.cleanupEditors(nextCell);
            }
        } else {
            if (nextEditable && preventNavigation) this.setFocusInOnEditor(nextCell);
            nextCell.focusCell(true, event);
        }
        prevCell.rowCtrl?.refreshRow({
            suppressFlash: true,
            force: true
        });
        return true;
    }
    destroy() {
        super.destroy();
        this.rowNode = void 0;
        this.column = void 0;
    }
};
// packages/ag-grid-community/src/edit/editModule.ts
var $437b23f6a393c3bf$export$12c61a50add34259 = {
    moduleName: "EditCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$EditModelService,
        $437b23f6a393c3bf$var$EditService
    ],
    apiFunctions: {
        getEditingCells: $437b23f6a393c3bf$var$getEditingCells,
        getEditRowValues: $437b23f6a393c3bf$var$getEditRowValues,
        getCellEditorInstances: $437b23f6a393c3bf$var$getCellEditorInstances,
        startEditingCell: $437b23f6a393c3bf$var$startEditingCell,
        stopEditing: $437b23f6a393c3bf$var$stopEditing,
        isEditing: $437b23f6a393c3bf$var$isEditing,
        validateEdit: $437b23f6a393c3bf$var$validateEdit
    },
    dynamicBeans: {
        singleCell: $437b23f6a393c3bf$var$SingleCellEditStrategy,
        fullRow: $437b23f6a393c3bf$var$FullRowEditStrategy
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d,
        $437b23f6a393c3bf$export$d0c662c133b8814e
    ],
    css: [
        $437b23f6a393c3bf$var$cellEditingCSS
    ]
};
var $437b23f6a393c3bf$export$2bb59c6ee8834731 = {
    moduleName: "UndoRedoEdit",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$UndoRedoService
    ],
    apiFunctions: {
        undoCellEditing: $437b23f6a393c3bf$var$undoCellEditing,
        redoCellEditing: $437b23f6a393c3bf$var$redoCellEditing,
        getCurrentUndoSize: $437b23f6a393c3bf$var$getCurrentUndoSize,
        getCurrentRedoSize: $437b23f6a393c3bf$var$getCurrentRedoSize
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$5e6636bea954ad4e = {
    moduleName: "TextEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCellEditor: $437b23f6a393c3bf$var$TextCellEditor,
        agTextCellEditor: $437b23f6a393c3bf$var$TextCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$9bc83f811986c4f2 = {
    moduleName: "NumberEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agNumberCellEditor: {
            classImp: $437b23f6a393c3bf$var$NumberCellEditor
        }
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$d1dd3475f4d98a27 = {
    moduleName: "DateEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agDateCellEditor: $437b23f6a393c3bf$var$DateCellEditor,
        agDateStringCellEditor: $437b23f6a393c3bf$var$DateStringCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$b6d3a45586965934 = {
    moduleName: "CheckboxEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCheckboxCellEditor: $437b23f6a393c3bf$var$CheckboxCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$ccaa44b10c75f1d = {
    moduleName: "SelectEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agSelectCellEditor: $437b23f6a393c3bf$var$SelectCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$e1b6b5aa47694f20 = {
    moduleName: "LargeTextEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agLargeTextCellEditor: $437b23f6a393c3bf$var$LargeTextCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$e1d2707568ed81f6 = {
    moduleName: "CustomEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
// packages/ag-grid-community/src/columns/selectionColService.ts
var $437b23f6a393c3bf$var$SelectionColService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "selectionColSvc";
    }
    postConstruct() {
        this.addManagedPropertyListener("rowSelection", (event)=>{
            this.onSelectionOptionsChanged(event.currentValue, event.previousValue, $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source));
        });
        this.addManagedPropertyListener("selectionColumnDef", this.updateColumns.bind(this));
    }
    addColumns(cols) {
        const selectionCols = this.columns;
        if (selectionCols == null) return;
        cols.list = selectionCols.list.concat(cols.list);
        cols.tree = selectionCols.tree.concat(cols.tree);
        $437b23f6a393c3bf$export$c82fd63ff1738bed(cols);
    }
    createColumns(cols, updateOrders) {
        const destroyCollection = ()=>{
            $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.columns?.tree);
            this.columns = null;
        };
        const newTreeDepth = cols.treeDepth;
        const oldTreeDepth = this.columns?.treeDepth ?? -1;
        const treeDepthSame = oldTreeDepth == newTreeDepth;
        const list = this.generateSelectionCols();
        const areSame = $437b23f6a393c3bf$export$f56e341a1fe35ed4(list, this.columns?.list ?? []);
        if (areSame && treeDepthSame) return;
        destroyCollection();
        const { colGroupSvc: colGroupSvc } = this.beans;
        const treeDepth = colGroupSvc?.findDepth(cols.tree) ?? 0;
        const tree = colGroupSvc?.balanceTreeForAutoCols(list, treeDepth) ?? [];
        this.columns = {
            list: list,
            tree: tree,
            treeDepth: treeDepth,
            map: {}
        };
        const putSelectionColsFirstInList = (cols2)=>{
            if (!cols2) return null;
            const colsFiltered = cols2.filter((col)=>!$437b23f6a393c3bf$export$f6074a9792015c5d(col));
            return [
                ...list,
                ...colsFiltered
            ];
        };
        updateOrders(putSelectionColsFirstInList);
    }
    updateColumns(event) {
        const source = $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source);
        const { beans: beans } = this;
        for (const col of this.columns?.list ?? []){
            const colDef = this.createSelectionColDef(event.currentValue);
            col.setColDef(colDef, null, source);
            $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                state: [
                    $437b23f6a393c3bf$export$2fd1bdef8244d93c(colDef, col.colId)
                ]
            }, source);
        }
    }
    getColumn(key) {
        return this.columns?.list.find((col)=>$437b23f6a393c3bf$export$f5687d41c39fa1b3(col, key)) ?? null;
    }
    getColumns() {
        return this.columns?.list ?? null;
    }
    isSelectionColumnEnabled() {
        const { gos: gos, beans: beans } = this;
        const rowSelection = gos.get("rowSelection");
        if (typeof rowSelection !== "object" || !$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) return false;
        const hasAutoCols = (beans.autoColSvc?.getColumns()?.length ?? 0) > 0;
        if (rowSelection.checkboxLocation === "autoGroupColumn" && hasAutoCols) return false;
        const checkboxes = !!$437b23f6a393c3bf$export$6df3a55606bca6ae(rowSelection);
        const headerCheckbox = $437b23f6a393c3bf$export$e92e75627785d7a4(rowSelection);
        return checkboxes || headerCheckbox;
    }
    createSelectionColDef(def) {
        const { gos: gos } = this;
        const selectionColumnDef = def ?? gos.get("selectionColumnDef");
        const enableRTL = gos.get("enableRtl");
        const { rowSpan: _, spanRows: __, ...filteredSelColDef } = selectionColumnDef ?? {};
        return {
            // overridable properties
            width: 50,
            resizable: false,
            suppressHeaderMenuButton: true,
            sortable: false,
            suppressMovable: true,
            lockPosition: enableRTL ? "right" : "left",
            comparator (valueA, valueB, nodeA, nodeB) {
                const aSelected = nodeA.isSelected();
                const bSelected = nodeB.isSelected();
                return aSelected === bSelected ? 0 : aSelected ? 1 : -1;
            },
            editable: false,
            suppressFillHandle: true,
            suppressAutoSize: true,
            pinned: null,
            // overrides
            ...filteredSelColDef,
            // non-overridable properties
            colId: $437b23f6a393c3bf$export$dd05e5f089eb2421,
            chartDataType: "excluded"
        };
    }
    generateSelectionCols() {
        if (!this.isSelectionColumnEnabled()) return [];
        const colDef = this.createSelectionColDef();
        const colId = colDef.colId;
        this.gos.validateColDef(colDef, colId, true);
        const col = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDef, null, colId, false);
        this.createBean(col);
        return [
            col
        ];
    }
    onSelectionOptionsChanged(current, prev, source) {
        const prevCheckbox = prev && typeof prev !== "string" ? $437b23f6a393c3bf$export$6df3a55606bca6ae(prev) : void 0;
        const currCheckbox = current && typeof current !== "string" ? $437b23f6a393c3bf$export$6df3a55606bca6ae(current) : void 0;
        const checkboxHasChanged = prevCheckbox !== currCheckbox;
        const prevHeaderCheckbox = prev && typeof prev !== "string" ? $437b23f6a393c3bf$export$e92e75627785d7a4(prev) : void 0;
        const currHeaderCheckbox = current && typeof current !== "string" ? $437b23f6a393c3bf$export$e92e75627785d7a4(current) : void 0;
        const headerCheckboxHasChanged = prevHeaderCheckbox !== currHeaderCheckbox;
        const currLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(current);
        const prevLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(prev);
        const locationChanged = currLocation !== prevLocation;
        if (checkboxHasChanged || headerCheckboxHasChanged || locationChanged) this.beans.colModel.refreshAll(source);
    }
    destroy() {
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.columns?.tree);
        super.destroy();
    }
    /**
   * Refreshes visibility of the selection column based on which columns are currently visible.
   * Called by the VisibleColsService with the columns that are currently visible in left/center/right
   * containers. This method *MUTATES* those arrays directly.
   *
   * The selection column should be visible if all of the following are true
   * - The selection column is not disabled
   * - The number of visible columns excluding the selection column and row numbers column is greater than 0
   * @param leftCols Visible columns in the left-pinned container
   * @param centerCols Visible columns in the center viewport
   * @param rightCols Visible columns in the right-pinned container
   */ refreshVisibility(leftCols, centerCols, rightCols) {
        if (!this.columns?.list.length) return;
        const numVisibleCols = leftCols.length + centerCols.length + rightCols.length;
        if (numVisibleCols === 0) return;
        const column = this.columns.list[0];
        if (!column.isVisible()) return;
        const hideSelectionCol = ()=>{
            let cols;
            switch(column.pinned){
                case "left":
                case true:
                    cols = leftCols;
                    break;
                case "right":
                    cols = rightCols;
                    break;
                default:
                    cols = centerCols;
            }
            cols && $437b23f6a393c3bf$export$83a881c8b5120679(cols, column);
        };
        const rowNumbersCol = this.beans.rowNumbersSvc?.getColumn($437b23f6a393c3bf$export$f55c01dfb205b029);
        const expectedNumCols = rowNumbersCol ? 2 : 1;
        if (expectedNumCols === numVisibleCols) hideSelectionCol();
    }
};
// packages/ag-grid-community/src/selection/rowSelection.css-GENERATED.ts
var $437b23f6a393c3bf$var$rowSelectionCSS = /*css*/ `:where(.ag-selection-checkbox) .ag-checkbox-input-wrapper{&:before{content:"";cursor:pointer;inset:-8px;position:absolute}}`;
// packages/ag-grid-community/src/selection/rowSelectionApi.ts
function $437b23f6a393c3bf$var$setNodesSelected(beans, params) {
    const allNodesValid = params.nodes.every((node)=>{
        if (node.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(node)) {
            $437b23f6a393c3bf$export$545083624300f13d(59);
            return false;
        }
        if (node.id === void 0) {
            $437b23f6a393c3bf$export$545083624300f13d(60);
            return false;
        }
        return true;
    });
    if (!allNodesValid) return;
    const { nodes: nodes, source: source, newValue: newValue } = params;
    beans.selectionSvc?.setNodesSelected({
        nodes: nodes,
        source: source ?? "api",
        newValue: newValue
    });
}
function $437b23f6a393c3bf$var$selectAll(beans, selectAll2, source = "apiSelectAll") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: selectAll2
    });
}
function $437b23f6a393c3bf$var$deselectAll(beans, selectAll2, source = "apiSelectAll") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: selectAll2
    });
}
function $437b23f6a393c3bf$var$selectAllFiltered(beans, source = "apiSelectAllFiltered") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: "filtered"
    });
}
function $437b23f6a393c3bf$var$deselectAllFiltered(beans, source = "apiSelectAllFiltered") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: "filtered"
    });
}
function $437b23f6a393c3bf$var$selectAllOnCurrentPage(beans, source = "apiSelectAllCurrentPage") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: "currentPage"
    });
}
function $437b23f6a393c3bf$var$deselectAllOnCurrentPage(beans, source = "apiSelectAllCurrentPage") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: "currentPage"
    });
}
function $437b23f6a393c3bf$var$getSelectedNodes(beans) {
    return beans.selectionSvc?.getSelectedNodes() ?? [];
}
function $437b23f6a393c3bf$var$getSelectedRows(beans) {
    return beans.selectionSvc?.getSelectedRows() ?? [];
}
// packages/ag-grid-community/src/selection/selectionService.ts
var $437b23f6a393c3bf$var$SelectionService = class extends $437b23f6a393c3bf$export$3d7b168c0c9c2a78 {
    constructor(){
        super(...arguments);
        this.beanName = "selectionSvc";
        this.selectedNodes = /* @__PURE__ */ new Map();
        /** Only used to track detail grid selection state when master/detail is enabled */ this.detailSelection = /* @__PURE__ */ new Map();
        this.masterSelectsDetail = false;
    }
    postConstruct() {
        super.postConstruct();
        const { gos: gos } = this;
        this.mode = $437b23f6a393c3bf$export$80b6607444b3274f(gos);
        this.groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
        this.groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
        this.masterSelectsDetail = $437b23f6a393c3bf$var$_getMasterSelects(gos) === "detail";
        this.addManagedPropertyListeners([
            "groupSelectsChildren",
            "groupSelectsFiltered",
            "rowSelection"
        ], ()=>{
            const groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
            const selectionMode = $437b23f6a393c3bf$export$80b6607444b3274f(gos);
            const groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
            this.masterSelectsDetail = $437b23f6a393c3bf$var$_getMasterSelects(gos) === "detail";
            if (groupSelectsDescendants !== this.groupSelectsDescendants || groupSelectsFiltered !== this.groupSelectsFiltered || selectionMode !== this.mode) {
                this.deselectAllRowNodes({
                    source: "api"
                });
                this.groupSelectsDescendants = groupSelectsDescendants;
                this.groupSelectsFiltered = groupSelectsFiltered;
                this.mode = selectionMode;
            }
        });
        this.addManagedEventListeners({
            rowSelected: this.onRowSelected.bind(this)
        });
    }
    destroy() {
        super.destroy();
        this.resetNodes();
    }
    handleSelectionEvent(event, rowNode, source) {
        if (this.isRowSelectionBlocked(rowNode)) return 0;
        const selection = this.inferNodeSelections(rowNode, event.shiftKey, event.metaKey || event.ctrlKey, source);
        if (selection == null) return 0;
        this.selectionCtx.selectAll = false;
        if ("select" in selection) {
            if (selection.reset) this.resetNodes();
            else this.selectRange(selection.deselect, false, source);
            return this.selectRange(selection.select, true, source);
        } else {
            const newValue = selection.checkFilteredNodes ? $437b23f6a393c3bf$var$recursiveCanNodesBeSelected(selection.node) : selection.newValue;
            return this.setNodesSelected({
                nodes: [
                    selection.node
                ],
                newValue: newValue,
                clearSelection: selection.clearSelection,
                keepDescendants: selection.keepDescendants,
                event: event,
                source: source
            });
        }
    }
    setNodesSelected({ newValue: newValue, clearSelection: clearSelection, suppressFinishActions: suppressFinishActions, nodes: nodes, event: event, source: source, keepDescendants: keepDescendants = false }) {
        if (nodes.length === 0) return 0;
        const { gos: gos } = this;
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos) && newValue) {
            $437b23f6a393c3bf$export$545083624300f13d(132);
            return 0;
        }
        if (nodes.length > 1 && !this.isMultiSelect()) {
            $437b23f6a393c3bf$export$545083624300f13d(130);
            return 0;
        }
        let updatedCount = 0;
        for(let i = 0; i < nodes.length; i++){
            const rowNode = nodes[i];
            const node = $437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode);
            if (node.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(node)) {
                $437b23f6a393c3bf$export$545083624300f13d(59);
                continue;
            }
            if (node.id === void 0) {
                $437b23f6a393c3bf$export$545083624300f13d(60);
                continue;
            }
            if (newValue && rowNode.destroyed) continue;
            const skipThisNode = this.groupSelectsFiltered && node.group && !gos.get("treeData");
            if (!skipThisNode) {
                const thisNodeWasSelected = this.selectRowNode(node, newValue, event, source);
                if (thisNodeWasSelected) {
                    this.detailSelection.delete(node.id);
                    updatedCount++;
                }
            }
            if (this.groupSelectsDescendants && node.childrenAfterGroup?.length) updatedCount += this.selectChildren(node, newValue, source);
        }
        if (!suppressFinishActions) {
            if (nodes.length === 1 && source === "api") this.selectionCtx.setRoot($437b23f6a393c3bf$var$_normaliseSiblingRef(nodes[0]));
            const clearOtherNodes = newValue && (clearSelection || !this.isMultiSelect());
            if (clearOtherNodes) updatedCount += this.clearOtherNodes($437b23f6a393c3bf$var$_normaliseSiblingRef(nodes[0]), keepDescendants, source);
            if (updatedCount > 0) {
                this.updateGroupsFromChildrenSelections(source);
                this.dispatchSelectionChanged(source);
            }
        }
        return updatedCount;
    }
    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
    // holding down 'shift'.
    selectRange(nodesToSelect, value, source) {
        let updatedCount = 0;
        nodesToSelect.forEach((node)=>{
            const rowNode = $437b23f6a393c3bf$var$_normaliseSiblingRef(node);
            if (rowNode.group && this.groupSelectsDescendants) return;
            const nodeWasSelected = this.selectRowNode(rowNode, value, void 0, source);
            if (nodeWasSelected) updatedCount++;
        });
        if (updatedCount > 0) {
            this.updateGroupsFromChildrenSelections(source);
            this.dispatchSelectionChanged(source);
        }
        return updatedCount;
    }
    selectChildren(node, newValue, source) {
        const children = this.groupSelectsFiltered ? node.childrenAfterAggFilter : node.childrenAfterGroup;
        if (!children) return 0;
        return this.setNodesSelected({
            newValue: newValue,
            clearSelection: false,
            suppressFinishActions: true,
            source: source,
            nodes: children
        });
    }
    getSelectedNodes() {
        return Array.from(this.selectedNodes.values());
    }
    getSelectedRows() {
        const selectedRows = [];
        this.selectedNodes.forEach((rowNode)=>rowNode.data && selectedRows.push(rowNode.data));
        return selectedRows;
    }
    getSelectionCount() {
        return this.selectedNodes.size;
    }
    /**
   * This method is used by the CSRM to remove groups which are being disposed of,
   * events do not need fired in this case
   */ filterFromSelection(predicate) {
        const newSelectedNodes = /* @__PURE__ */ new Map();
        this.selectedNodes.forEach((rowNode, key)=>{
            if (predicate(rowNode)) newSelectedNodes.set(key, rowNode);
        });
        this.selectedNodes = newSelectedNodes;
    }
    updateGroupsFromChildrenSelections(source, changedPath) {
        if (!this.groupSelectsDescendants) return false;
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) return false;
        const rootNode = rowModel.rootNode;
        if (!rootNode) return false;
        if (!changedPath) {
            changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(true, rootNode);
            changedPath.active = false;
        }
        let selectionChanged = false;
        changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            if (rowNode !== rootNode) {
                const selected = this.calculateSelectedFromChildren(rowNode);
                selectionChanged = this.selectRowNode(rowNode, selected === null ? false : selected, void 0, source) || selectionChanged;
            }
        });
        return selectionChanged;
    }
    clearOtherNodes(rowNodeToKeepSelected, keepDescendants, source) {
        const groupsToRefresh = /* @__PURE__ */ new Map();
        let updatedCount = 0;
        this.selectedNodes.forEach((otherRowNode)=>{
            const isNodeToKeep = otherRowNode.id == rowNodeToKeepSelected.id;
            const shouldClearDescendant = keepDescendants ? !$437b23f6a393c3bf$var$isDescendantOf(rowNodeToKeepSelected, otherRowNode) : true;
            if (shouldClearDescendant && !isNodeToKeep) {
                const rowNode = this.selectedNodes.get(otherRowNode.id);
                updatedCount += this.setNodesSelected({
                    nodes: [
                        rowNode
                    ],
                    newValue: false,
                    clearSelection: false,
                    suppressFinishActions: true,
                    source: source
                });
                if (this.groupSelectsDescendants && otherRowNode.parent) groupsToRefresh.set(otherRowNode.parent.id, otherRowNode.parent);
            }
        });
        groupsToRefresh.forEach((group)=>{
            const selected = this.calculateSelectedFromChildren(group);
            this.selectRowNode(group, selected === null ? false : selected, void 0, source);
        });
        return updatedCount;
    }
    onRowSelected(event) {
        const rowNode = event.node;
        if (this.groupSelectsDescendants && rowNode.group) return;
        if (rowNode.isSelected()) this.selectedNodes.set(rowNode.id, rowNode);
        else this.selectedNodes.delete(rowNode.id);
    }
    syncInRowNode(rowNode, oldNode) {
        this.syncInOldRowNode(rowNode, oldNode);
        this.syncInNewRowNode(rowNode);
    }
    createDaemonNode(rowNode) {
        if (!rowNode.id) return void 0;
        const oldNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        oldNode.id = rowNode.id;
        oldNode.data = rowNode.data;
        oldNode.__selected = rowNode.__selected;
        oldNode.level = rowNode.level;
        return oldNode;
    }
    // if the id has changed for the node, then this means the rowNode
    // is getting used for a different data item, which breaks
    // our selectedNodes, as the node now is mapped by the old id
    // which is inconsistent. so to keep the old node as selected,
    // we swap in the clone (with the old id and old data). this means
    // the oldNode is effectively a daemon we keep a reference to,
    // so if client calls api.getSelectedNodes(), it gets the daemon
    // in the result. when the client un-selects, the reference to the
    // daemon is removed. the daemon, because it's an oldNode, is not
    // used by the grid for rendering, it's a copy of what the node used
    // to be like before the id was changed.
    syncInOldRowNode(rowNode, oldNode) {
        if (oldNode && rowNode.id !== oldNode.id) {
            const oldNodeSelected = this.selectedNodes.get(oldNode.id) == rowNode;
            if (oldNodeSelected) this.selectedNodes.set(oldNode.id, oldNode);
        }
    }
    syncInNewRowNode(rowNode) {
        if (this.selectedNodes.has(rowNode.id)) {
            rowNode.__selected = true;
            this.selectedNodes.set(rowNode.id, rowNode);
        } else rowNode.__selected = false;
    }
    reset(source) {
        const selectionCount = this.getSelectionCount();
        this.resetNodes();
        if (selectionCount) this.dispatchSelectionChanged(source);
    }
    resetNodes() {
        this.selectedNodes.forEach((node)=>{
            this.selectRowNode(node, false);
        });
        this.selectedNodes.clear();
    }
    // returns a list of all nodes at 'best cost' - a feature to be used
    // with groups / trees. if a group has all it's children selected,
    // then the group appears in the result, but not the children.
    // Designed for use with 'children' as the group selection type,
    // where groups don't actually appear in the selection normally.
    getBestCostNodeSelection() {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) return;
        const topLevelNodes = rowModel.getTopLevelNodes();
        if (topLevelNodes === null) return;
        const result = [];
        function traverse(nodes) {
            for(let i = 0, l = nodes.length; i < l; i++){
                const node = nodes[i];
                if (node.isSelected()) result.push(node);
                else if (node.group && node.childrenAfterGroup) traverse(node.childrenAfterGroup);
            }
        }
        traverse(topLevelNodes);
        return result;
    }
    isEmpty() {
        return this.getSelectionCount() === 0;
    }
    deselectAllRowNodes({ source: source, selectAll: selectAll2 }) {
        const rowModelClientSide = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos);
        let updatedNodes = false;
        const callback = (rowNode)=>{
            const updated = this.selectRowNode($437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode), false, void 0, source);
            updatedNodes || (updatedNodes = updated);
        };
        if (selectAll2 === "currentPage" || selectAll2 === "filtered") {
            if (!rowModelClientSide) {
                $437b23f6a393c3bf$export$a20c7248650823a9(102);
                return;
            }
            this.getNodesToSelect(selectAll2).forEach(callback);
        } else {
            this.selectedNodes.forEach(callback);
            this.reset(source);
        }
        this.selectionCtx.selectAll = false;
        if (rowModelClientSide && this.groupSelectsDescendants) {
            const updated = this.updateGroupsFromChildrenSelections(source);
            updatedNodes || (updatedNodes = updated);
        }
        if (updatedNodes) this.dispatchSelectionChanged(source);
    }
    getSelectedCounts(selectAll2) {
        let selectedCount = 0;
        let notSelectedCount = 0;
        this.getNodesToSelect(selectAll2).forEach((node)=>{
            if (this.groupSelectsDescendants && node.group) return;
            if (node.isSelected()) selectedCount++;
            else if (node.selectable) notSelectedCount++;
        });
        return {
            selectedCount: selectedCount,
            notSelectedCount: notSelectedCount
        };
    }
    getSelectAllState(selectAll2) {
        const { selectedCount: selectedCount, notSelectedCount: notSelectedCount } = this.getSelectedCounts(selectAll2);
        return $437b23f6a393c3bf$var$_calculateSelectAllState(selectedCount, notSelectedCount) ?? null;
    }
    hasNodesToSelect(selectAll2) {
        return this.getNodesToSelect(selectAll2).filter((node)=>node.selectable).length > 0;
    }
    /**
   * @param selectAll See `MultiRowSelectionOptions.selectAll`
   * @returns all nodes including unselectable nodes which are the target of this selection attempt
   */ getNodesToSelect(selectAll2) {
        if (!this.canSelectAll()) return [];
        const nodes = [];
        const addToResult = (node)=>nodes.push(node);
        if (selectAll2 === "currentPage") {
            this.forEachNodeOnPage((node)=>{
                if (!node.group) {
                    addToResult(node);
                    return;
                }
                if (!node.expanded && !node.footer) {
                    const recursivelyAddChildren = (child)=>{
                        addToResult(child);
                        child.childrenAfterFilter?.forEach(recursivelyAddChildren);
                    };
                    recursivelyAddChildren(node);
                    return;
                }
                if (!this.groupSelectsDescendants) addToResult(node);
            });
            return nodes;
        }
        const clientSideRowModel = this.beans.rowModel;
        if (selectAll2 === "filtered") {
            clientSideRowModel.forEachNodeAfterFilter(addToResult);
            return nodes;
        }
        clientSideRowModel.forEachNode(addToResult);
        return nodes;
    }
    forEachNodeOnPage(callback) {
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const firstRow = pageBounds.getFirstRow();
        const lastRow = pageBounds.getLastRow();
        for(let i = firstRow; i <= lastRow; i++){
            const node = rowModel.getRow(i);
            if (node) callback(node);
        }
    }
    selectAllRowNodes(params) {
        const { gos: gos, selectionCtx: selectionCtx } = this;
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) {
            $437b23f6a393c3bf$export$545083624300f13d(132);
            return;
        }
        if ($437b23f6a393c3bf$export$d3c80fcacb2e2d55(gos) && !$437b23f6a393c3bf$export$7bd8c52ebc4117d6(gos)) {
            $437b23f6a393c3bf$export$545083624300f13d(130);
            return;
        }
        if (!this.canSelectAll()) return;
        const { source: source, selectAll: selectAll2 } = params;
        let updatedNodes = false;
        this.getNodesToSelect(selectAll2).forEach((rowNode)=>{
            const updated = this.selectRowNode($437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode), true, void 0, source);
            updatedNodes || (updatedNodes = updated);
        });
        selectionCtx.selectAll = true;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos) && this.groupSelectsDescendants) {
            const updated = this.updateGroupsFromChildrenSelections(source);
            updatedNodes || (updatedNodes = updated);
        }
        if (updatedNodes) this.dispatchSelectionChanged(source);
    }
    getSelectionState() {
        return this.isEmpty() ? null : Array.from(this.selectedNodes.keys());
    }
    setSelectionState(state, source, clearSelection) {
        if (!state) state = [];
        if (!Array.isArray(state)) {
            $437b23f6a393c3bf$export$a20c7248650823a9(103);
            return;
        }
        const rowIds = new Set(state);
        const nodes = [];
        this.beans.rowModel.forEachNode((node)=>{
            if (rowIds.has(node.id)) nodes.push(node);
        });
        if (clearSelection) this.resetNodes();
        this.setNodesSelected({
            newValue: true,
            nodes: nodes,
            source: source
        });
    }
    canSelectAll() {
        return $437b23f6a393c3bf$export$9f182d9ca737e15(this.beans.gos);
    }
    /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData via `updateSelectableAfterGrouping`
   */ updateSelectable(changedPath) {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) return;
        const source = "selectableChanged";
        const skipLeafNodes = changedPath !== void 0;
        const isCSRMGroupSelectsDescendants = $437b23f6a393c3bf$export$9f182d9ca737e15(gos) && this.groupSelectsDescendants;
        const nodesToDeselect = [];
        const nodeCallback = (node)=>{
            if (skipLeafNodes && !node.group) return;
            if (isCSRMGroupSelectsDescendants && node.group) {
                const hasSelectableChild = node.childrenAfterGroup?.some((rowNode)=>rowNode.selectable) ?? false;
                this.setRowSelectable(node, hasSelectableChild, true);
                return;
            }
            const rowSelectable = this.updateRowSelectable(node, true);
            if (!rowSelectable && node.isSelected()) nodesToDeselect.push(node);
        };
        if (isCSRMGroupSelectsDescendants) {
            if (changedPath === void 0) {
                const rootNode = rowModel.rootNode;
                changedPath = rootNode ? new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, rootNode) : void 0;
            }
            changedPath?.forEachChangedNodeDepthFirst(nodeCallback, !skipLeafNodes, !skipLeafNodes);
        } else rowModel.forEachNode(nodeCallback);
        if (nodesToDeselect.length) this.setNodesSelected({
            nodes: nodesToDeselect,
            newValue: false,
            source: source
        });
        if (!skipLeafNodes && isCSRMGroupSelectsDescendants) this.updateGroupsFromChildrenSelections?.(source);
    }
    // only called by CSRM
    updateSelectableAfterGrouping(changedPath) {
        this.updateSelectable(changedPath);
        if (this.groupSelectsDescendants) {
            const selectionChanged = this.updateGroupsFromChildrenSelections?.("rowGroupChanged", changedPath);
            if (selectionChanged) this.dispatchSelectionChanged("rowGroupChanged");
        }
    }
    refreshMasterNodeState(node, e) {
        if (!this.masterSelectsDetail) return;
        const detailApi = node.detailNode?.detailGridInfo?.api;
        if (!detailApi) return;
        const isSelectAll = $437b23f6a393c3bf$var$_isAllSelected(detailApi);
        const current = node.isSelected();
        if (current !== isSelectAll) {
            const selectionChanged = this.selectRowNode(node, isSelectAll, e, "masterDetail");
            if (selectionChanged) this.dispatchSelectionChanged("masterDetail");
        }
        if (!isSelectAll) {
            const detailSelected = this.detailSelection.get(node.id) ?? /* @__PURE__ */ new Set();
            for (const n of detailApi.getSelectedNodes())detailSelected.add(n.id);
            this.detailSelection.set(node.id, detailSelected);
        }
    }
    setDetailSelectionState(masterNode, detailGridOptions, detailApi) {
        if (!this.masterSelectsDetail) return;
        if (!$437b23f6a393c3bf$export$7bd8c52ebc4117d6(detailGridOptions)) {
            $437b23f6a393c3bf$export$545083624300f13d(269);
            return;
        }
        switch(masterNode.isSelected()){
            case true:
                detailApi.selectAll();
                break;
            case false:
                detailApi.deselectAll();
                break;
            case void 0:
                {
                    const selectedIds = this.detailSelection.get(masterNode.id);
                    if (selectedIds) {
                        const nodes = [];
                        for (const id of selectedIds){
                            const n = detailApi.getRowNode(id);
                            if (n) nodes.push(n);
                        }
                        detailApi.setNodesSelected({
                            nodes: nodes,
                            newValue: true,
                            source: "masterDetail"
                        });
                    }
                    break;
                }
            default:
                break;
        }
    }
    dispatchSelectionChanged(source) {
        this.eventSvc.dispatchEvent({
            type: "selectionChanged",
            source: source,
            selectedNodes: this.getSelectedNodes(),
            serverSideState: null
        });
    }
};
function $437b23f6a393c3bf$var$_normaliseSiblingRef(node) {
    return $437b23f6a393c3bf$var$_isManualPinnedRow(node) ? node.pinnedSibling : node.footer ? node.sibling : node;
}
function $437b23f6a393c3bf$var$_isAllSelected(api) {
    let selectedCount = 0;
    let notSelectedCount = 0;
    api.forEachNode((node)=>{
        if (node.isSelected()) selectedCount++;
        else if (node.selectable) notSelectedCount++;
    });
    return $437b23f6a393c3bf$var$_calculateSelectAllState(selectedCount, notSelectedCount);
}
function $437b23f6a393c3bf$var$_calculateSelectAllState(selected, notSelected) {
    if (selected === 0 && notSelected === 0) return false;
    if (selected > 0 && notSelected > 0) return;
    return selected > 0;
}
function $437b23f6a393c3bf$var$isDescendantOf(root, child) {
    let parent = child.parent;
    while(parent){
        if (parent === root) return true;
        parent = parent.parent;
    }
    return false;
}
function $437b23f6a393c3bf$var$recursiveCanNodesBeSelected(root) {
    const rootCanBeSelected = root.isSelected() === false;
    const childrenCanBeSelected = root.childrenAfterFilter?.some($437b23f6a393c3bf$var$recursiveCanNodesBeSelected) ?? false;
    return rootCanBeSelected || childrenCanBeSelected;
}
// packages/ag-grid-community/src/selection/rowSelectionModule.ts
var $437b23f6a393c3bf$export$16cbd1164b82410d = {
    moduleName: "SharedRowSelection",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$SelectionColService
    ],
    css: [
        $437b23f6a393c3bf$var$rowSelectionCSS
    ],
    apiFunctions: {
        setNodesSelected: $437b23f6a393c3bf$var$setNodesSelected,
        selectAll: $437b23f6a393c3bf$var$selectAll,
        deselectAll: $437b23f6a393c3bf$var$deselectAll,
        selectAllFiltered: $437b23f6a393c3bf$var$selectAllFiltered,
        deselectAllFiltered: $437b23f6a393c3bf$var$deselectAllFiltered,
        selectAllOnCurrentPage: $437b23f6a393c3bf$var$selectAllOnCurrentPage,
        deselectAllOnCurrentPage: $437b23f6a393c3bf$var$deselectAllOnCurrentPage,
        getSelectedNodes: $437b23f6a393c3bf$var$getSelectedNodes,
        getSelectedRows: $437b23f6a393c3bf$var$getSelectedRows
    }
};
var $437b23f6a393c3bf$export$dae0b5c1ba15d66f = {
    moduleName: "RowSelection",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide",
        "infinite",
        "viewport"
    ],
    beans: [
        $437b23f6a393c3bf$var$SelectionService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$16cbd1164b82410d
    ]
};
// packages/ag-grid-community/src/api/rowModelSharedApi.ts
function $437b23f6a393c3bf$var$expandAll(beans) {
    beans.expansionSvc?.expandAll(true);
}
function $437b23f6a393c3bf$var$collapseAll(beans) {
    beans.expansionSvc?.expandAll(false);
}
function $437b23f6a393c3bf$export$39ff1118beb20c8b(beans) {
    beans.rowModel?.onRowHeightChanged();
}
function $437b23f6a393c3bf$export$80ac5296eda53df5(beans) {
    if (beans.rowAutoHeight?.active) {
        $437b23f6a393c3bf$export$545083624300f13d(3);
        return;
    }
    beans.rowModel?.resetRowHeights();
}
// packages/ag-grid-community/src/api/ssrmInfiniteSharedApi.ts
function $437b23f6a393c3bf$var$setRowCount(beans, rowCount, maxRowFound) {
    const serverSideRowModel = $437b23f6a393c3bf$export$aada92189a74e985(beans);
    if (serverSideRowModel) {
        if (beans.rowGroupColsSvc?.columns.length === 0) {
            if (rowCount < 0) {
                $437b23f6a393c3bf$export$a20c7248650823a9(238);
                return;
            }
            serverSideRowModel.setRowCount(rowCount, maxRowFound);
            return;
        }
        $437b23f6a393c3bf$export$a20c7248650823a9(28);
        return;
    }
    $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.setRowCount(rowCount, maxRowFound);
}
function $437b23f6a393c3bf$var$getCacheBlockState(beans) {
    if ($437b23f6a393c3bf$export$cf1bac0013650216(beans.gos)) {
        const ssrm = beans.rowModel;
        return ssrm.getBlockStates();
    }
    return beans.rowNodeBlockLoader?.getBlockState() ?? {};
}
function $437b23f6a393c3bf$var$isLastRowIndexKnown(beans) {
    return beans.rowModel.isLastRowIndexKnown();
}
// packages/ag-grid-community/src/api/sharedApiModule.ts
var $437b23f6a393c3bf$export$76fb120d9e251426 = {
    moduleName: "CsrmSsrmSharedApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        expandAll: $437b23f6a393c3bf$var$expandAll,
        collapseAll: $437b23f6a393c3bf$var$collapseAll
    }
};
var $437b23f6a393c3bf$export$b36e8e3b22fa08ce = {
    moduleName: "RowModelSharedApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        onRowHeightChanged: $437b23f6a393c3bf$export$39ff1118beb20c8b,
        resetRowHeights: $437b23f6a393c3bf$export$80ac5296eda53df5
    }
};
var $437b23f6a393c3bf$export$2f6740e35dedc261 = {
    moduleName: "SsrmInfiniteSharedApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        setRowCount: $437b23f6a393c3bf$var$setRowCount,
        getCacheBlockState: $437b23f6a393c3bf$var$getCacheBlockState,
        isLastRowIndexKnown: $437b23f6a393c3bf$var$isLastRowIndexKnown
    }
};
// packages/ag-grid-community/src/alignedGrids/alignedGridsService.ts
var $437b23f6a393c3bf$var$AlignedGridsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "alignedGridsSvc";
        // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
        // while processing a master event) we mark this if consuming an event, and if we are, then
        // we don't fire back any events.
        this.consuming = false;
    }
    getAlignedGridApis() {
        let alignedGrids = this.gos.get("alignedGrids") ?? [];
        const isCallbackConfig = typeof alignedGrids === "function";
        if (typeof alignedGrids === "function") alignedGrids = alignedGrids();
        const apis = alignedGrids.map((alignedGrid)=>{
            if (!alignedGrid) {
                $437b23f6a393c3bf$export$a20c7248650823a9(18);
                if (!isCallbackConfig) $437b23f6a393c3bf$export$a20c7248650823a9(20);
                return;
            }
            if (this.isGridApi(alignedGrid)) return alignedGrid;
            const refOrComp = alignedGrid;
            if ("current" in refOrComp) return refOrComp.current?.api;
            if (!refOrComp.api) $437b23f6a393c3bf$export$a20c7248650823a9(19);
            return refOrComp.api;
        }).filter((api)=>!!api && !api.isDestroyed());
        return apis;
    }
    isGridApi(ref) {
        return !!ref && !!ref.dispatchEvent;
    }
    postConstruct() {
        const fireColumnEvent = this.fireColumnEvent.bind(this);
        this.addManagedEventListeners({
            columnMoved: fireColumnEvent,
            columnVisible: fireColumnEvent,
            columnPinned: fireColumnEvent,
            columnGroupOpened: fireColumnEvent,
            columnResized: fireColumnEvent,
            bodyScroll: this.fireScrollEvent.bind(this),
            alignedGridColumn: ({ event: event })=>this.onColumnEvent(event),
            alignedGridScroll: ({ event: event })=>this.onScrollEvent(event)
        });
    }
    // common logic across all the fire methods
    fireEvent(event) {
        if (this.consuming) return;
        for (const api of this.getAlignedGridApis()){
            if (api.isDestroyed()) continue;
            api.dispatchEvent(event);
        }
    }
    // common logic across all consume methods. very little common logic, however extracting
    // guarantees consistency across the methods.
    onEvent(callback) {
        this.consuming = true;
        callback();
        this.consuming = false;
    }
    fireColumnEvent(columnEvent) {
        this.fireEvent({
            type: "alignedGridColumn",
            event: columnEvent
        });
    }
    fireScrollEvent(scrollEvent) {
        if (scrollEvent.direction !== "horizontal") return;
        this.fireEvent({
            type: "alignedGridScroll",
            event: scrollEvent
        });
    }
    onScrollEvent(event) {
        this.onEvent(()=>{
            this.beans.ctrlsSvc.getScrollFeature().setHorizontalScrollPosition(event.left, true);
        });
    }
    extractDataFromEvent(event, func) {
        const result = [];
        if (event.columns) event.columns.forEach((column)=>{
            result.push(func(column));
        });
        else if (event.column) result.push(func(event.column));
        return result;
    }
    getMasterColumns(event) {
        return this.extractDataFromEvent(event, (col)=>col);
    }
    getColumnIds(event) {
        return this.extractDataFromEvent(event, (col)=>col.getColId());
    }
    onColumnEvent(event) {
        this.onEvent(()=>{
            switch(event.type){
                case "columnMoved":
                case "columnVisible":
                case "columnPinned":
                case "columnResized":
                    this.processColumnEvent(event);
                    break;
                case "columnGroupOpened":
                    this.processGroupOpenedEvent(event);
                    break;
                case "columnPivotChanged":
                    $437b23f6a393c3bf$export$545083624300f13d(21);
                    break;
            }
        });
    }
    processGroupOpenedEvent(groupOpenedEvent) {
        const { colGroupSvc: colGroupSvc } = this.beans;
        if (!colGroupSvc) return;
        for (const masterGroup of groupOpenedEvent.columnGroups){
            let otherColumnGroup = null;
            if (masterGroup) otherColumnGroup = colGroupSvc.getProvidedColGroup(masterGroup.getGroupId());
            if (masterGroup && !otherColumnGroup) continue;
            colGroupSvc.setColumnGroupOpened(otherColumnGroup, masterGroup.isExpanded(), "alignedGridChanged");
        }
    }
    processColumnEvent(colEvent) {
        const masterColumn = colEvent.column;
        let otherColumn = null;
        const beans = this.beans;
        const { colResize: colResize, ctrlsSvc: ctrlsSvc, colModel: colModel } = beans;
        if (masterColumn) otherColumn = colModel.getColDefCol(masterColumn.getColId());
        if (masterColumn && !otherColumn) return;
        const masterColumns = this.getMasterColumns(colEvent);
        switch(colEvent.type){
            case "columnMoved":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState,
                        applyOrder: true
                    }, "alignedGridChanged");
                }
                break;
            case "columnVisible":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            hide: s.hide
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState
                    }, "alignedGridChanged");
                }
                break;
            case "columnPinned":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            pinned: s.pinned
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState
                    }, "alignedGridChanged");
                }
                break;
            case "columnResized":
                {
                    const resizedEvent = colEvent;
                    const columnWidths = {};
                    for (const column of masterColumns)columnWidths[column.getId()] = {
                        key: column.getColId(),
                        newWidth: column.getActualWidth()
                    };
                    for (const col of resizedEvent.flexColumns ?? [])if (columnWidths[col.getId()]) delete columnWidths[col.getId()];
                    colResize?.setColumnWidths(Object.values(columnWidths), false, resizedEvent.finished, "alignedGridChanged");
                    break;
                }
        }
        const gridBodyCon = ctrlsSvc.getGridBodyCtrl();
        const isVerticalScrollShowing = gridBodyCon.isVerticalScrollShowing();
        for (const api of this.getAlignedGridApis())api.setGridOption("alwaysShowVerticalScroll", isVerticalScrollShowing);
    }
};
// packages/ag-grid-community/src/alignedGrids/alignedGridsModule.ts
var $437b23f6a393c3bf$export$a8c763073927f695 = {
    moduleName: "AlignedGrids",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AlignedGridsService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$5c4abee658e86c68
    ]
};
// packages/ag-grid-community/src/clientSideRowModel/clientSideNodeManager.ts
var $437b23f6a393c3bf$var$ClientSideNodeManager = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rootNode){
        super();
        this.rootNode = rootNode;
        this.nextId = 0;
        this.allNodesMap = {};
        $437b23f6a393c3bf$var$initRootNode(rootNode);
    }
    getRowNode(id) {
        return this.allNodesMap[id];
    }
    setNewRowData(rowData) {
        this.dispatchRowDataUpdateStarted(rowData);
        this.destroyAllNodes();
        const rootNode = $437b23f6a393c3bf$var$initRootNode(this.rootNode);
        const allLeafs = new Array(rowData.length);
        rootNode._leafs = allLeafs;
        let writeIdx = 0;
        const nestedDataGetter = this.beans.groupStage?.getNestedDataGetter();
        const processedNested = nestedDataGetter ? /* @__PURE__ */ new Set() : null;
        const processChildren = (parent, childrenData)=>{
            const level = parent.level + 1;
            for(let i = 0, len = childrenData.length; i < len; ++i){
                const data = childrenData[i];
                if (!data) continue;
                const node = this.createRowNode(data, level);
                node.sourceRowIndex = writeIdx;
                allLeafs[writeIdx++] = node;
                if (processedNested && !processedNested.has(data)) {
                    processedNested.add(data);
                    node.treeParent = parent;
                    const children = nestedDataGetter(data);
                    if (children) processChildren(node, children);
                }
            }
        };
        processChildren(rootNode, rowData);
        allLeafs.length = writeIdx;
    }
    destroyAllNodes() {
        const { selectionSvc: selectionSvc, pinnedRowModel: pinnedRowModel, groupStage: groupStage } = this.beans;
        selectionSvc?.reset("rowDataChanged");
        if (pinnedRowModel?.isManual()) pinnedRowModel.reset();
        groupStage?.clearNonLeafs();
        const existingLeafs = this.rootNode._leafs;
        if (existingLeafs) for(let i = 0, len = existingLeafs.length; i < len; ++i)existingLeafs[i]._destroy(false);
        this.allNodesMap = /* @__PURE__ */ Object.create(null);
        this.nextId = 0;
    }
    setImmutableRowData(params, rowData) {
        const { rootNode: rootNode, gos: gos } = this;
        this.dispatchRowDataUpdateStarted(rowData);
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(gos);
        const changedRowNodes = params.changedRowNodes;
        const { adds: adds, updates: updates } = changedRowNodes;
        const processedNodes = /* @__PURE__ */ new Set();
        const nodesToUnselect = [];
        const nestedDataGetter = this.beans.groupStage?.getNestedDataGetter();
        let reorder = gos.get("suppressMaintainUnsortedOrder") ? void 0 : false;
        let prevIndex = -1;
        let treeUpdated = false;
        const updateNode = (node, data)=>{
            if (!reorder && reorder !== void 0) {
                const oldIndex = node.sourceRowIndex;
                reorder = oldIndex <= prevIndex;
                prevIndex = oldIndex;
            }
            if (node.data !== data) {
                node.updateData(data);
                if (!adds.has(node)) updates.add(node);
                if (!node.selectable && node.isSelected()) nodesToUnselect.push(node);
            }
        };
        const processChildren = (parent, childrenData, level)=>{
            for(let i = 0, len = childrenData.length; i < len; ++i){
                const data = childrenData[i];
                if (!data) continue;
                let node = this.getRowNode(getRowIdFunc({
                    data: data,
                    level: level
                }));
                if (node) {
                    updateNode(node, data);
                    treeUpdated || (treeUpdated = !!nestedDataGetter && node.treeParent !== parent);
                } else {
                    node = this.createRowNode(data, level);
                    adds.add(node);
                }
                if (!nestedDataGetter || processedNodes.has(node)) {
                    processedNodes.add(node);
                    continue;
                }
                processedNodes.add(node);
                node.treeParent = parent;
                const children = nestedDataGetter(data);
                if (children) processChildren(node, children, level + 1);
            }
        };
        processChildren(rootNode, rowData, 0);
        const changed = this.deleteUnusedNodes(processedNodes, changedRowNodes, nodesToUnselect, !!params.animate) || reorder || adds.size > 0;
        if (changed) {
            const allLeafs = rootNode._leafs ?? (rootNode._leafs = []);
            if (reorder === void 0) $437b23f6a393c3bf$var$updateRootLeafsKeepOrder(allLeafs, processedNodes, changedRowNodes);
            else if ($437b23f6a393c3bf$var$updateRootLeafsOrdered(allLeafs, processedNodes)) changedRowNodes.reordered = true;
        }
        if (changed || treeUpdated || updates.size) {
            params.rowDataUpdated = true;
            this.deselect(nodesToUnselect);
        }
    }
    deleteUnusedNodes(processedNodes, { removals: removals }, nodesToUnselect, animate) {
        const allLeafs = this.rootNode._leafs;
        for(let i = 0, len = allLeafs.length; i < len; i++){
            const node = allLeafs[i];
            if (!processedNodes.has(node)) {
                if (this.destroyNode(node, animate)) {
                    removals.push(node);
                    if (node.isSelected()) nodesToUnselect.push(node);
                }
            }
        }
        return removals.length > 0;
    }
    updateRowData(rowDataTran, changedRowNodes, animate) {
        this.dispatchRowDataUpdateStarted(rowDataTran.add);
        if (this.beans.groupStage?.getNestedDataGetter()) {
            $437b23f6a393c3bf$export$545083624300f13d(268);
            return {
                remove: [],
                update: [],
                add: []
            };
        }
        const nodesToUnselect = [];
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const remove = this.executeRemove(getRowIdFunc, rowDataTran, changedRowNodes, nodesToUnselect, animate);
        const update = this.executeUpdate(getRowIdFunc, rowDataTran, changedRowNodes, nodesToUnselect);
        const add = this.executeAdd(rowDataTran, changedRowNodes);
        this.deselect(nodesToUnselect);
        return {
            remove: remove,
            update: update,
            add: add
        };
    }
    executeRemove(getRowIdFunc, { remove: remove }, { adds: adds, updates: updates, removals: removals }, nodesToUnselect, animate) {
        const allLeafs = this.rootNode._leafs;
        const allLeafsLen = allLeafs?.length;
        const removeLen = remove?.length;
        if (!removeLen || !allLeafsLen) return [];
        let removeCount = 0;
        let filterIdx = allLeafsLen;
        let filterEndIdx = 0;
        const removedResult = new Array(removeLen);
        for(let i = 0; i < removeLen; ++i){
            const rowNode = this.lookupNode(getRowIdFunc, remove[i]);
            if (!rowNode) continue;
            const sourceRowIndex = rowNode.sourceRowIndex;
            if (sourceRowIndex < filterIdx) filterIdx = sourceRowIndex;
            if (sourceRowIndex > filterEndIdx) filterEndIdx = sourceRowIndex;
            removedResult[removeCount++] = rowNode;
            if (!this.destroyNode(rowNode, animate)) continue;
            if (rowNode.isSelected()) nodesToUnselect.push(rowNode);
            if (!adds.delete(rowNode)) {
                updates.delete(rowNode);
                removals.push(rowNode);
            }
        }
        removedResult.length = removeCount;
        if (removeCount) $437b23f6a393c3bf$var$filterRemovedRowNodes(allLeafs, filterIdx, filterEndIdx);
        return removedResult;
    }
    executeUpdate(getRowIdFunc, { update: update }, { adds: adds, updates: updates }, nodesToUnselect) {
        const updateLen = update?.length;
        if (!updateLen) return [];
        const updateResult = new Array(updateLen);
        let writeIdx = 0;
        for(let i = 0; i < updateLen; i++){
            const item = update[i];
            const rowNode = this.lookupNode(getRowIdFunc, item);
            if (rowNode) {
                rowNode.updateData(item);
                if (!rowNode.selectable && rowNode.isSelected()) nodesToUnselect.push(rowNode);
                updateResult[writeIdx++] = rowNode;
                if (!adds.has(rowNode)) updates.add(rowNode);
            }
        }
        updateResult.length = writeIdx;
        return updateResult;
    }
    executeAdd(rowDataTran, changedRowNodes) {
        var _a2;
        const allLeafs = (_a2 = this.rootNode)._leafs ?? (_a2._leafs = []);
        const allLeafsLen = allLeafs.length;
        const add = rowDataTran.add;
        const addLength = add?.length;
        if (!addLength) return [];
        const newLen = allLeafsLen + addLength;
        let addIndex = this.sanitizeAddIndex(allLeafs, rowDataTran.addIndex);
        if (addIndex < allLeafsLen) {
            for(let readIdx = allLeafsLen - 1, writeIdx = newLen - 1; readIdx >= addIndex; --readIdx){
                const node = allLeafs[readIdx];
                node.sourceRowIndex = writeIdx;
                allLeafs[writeIdx--] = node;
            }
            changedRowNodes.reordered = true;
        }
        allLeafs.length = newLen;
        const addedNodes = new Array(addLength);
        const adds = changedRowNodes.adds;
        for(let i = 0; i < addLength; i++){
            const node = this.createRowNode(add[i], 0);
            adds.add(node);
            node.sourceRowIndex = addIndex;
            allLeafs[addIndex] = node;
            addedNodes[i] = node;
            addIndex++;
        }
        return addedNodes;
    }
    dispatchRowDataUpdateStarted(data) {
        this.eventSvc.dispatchEvent({
            type: "rowDataUpdateStarted",
            firstRowData: data?.length ? data[0] : null
        });
    }
    deselect(nodes) {
        const source = "rowDataChanged";
        const selectionSvc = this.beans.selectionSvc;
        if (nodes.length) selectionSvc?.setNodesSelected({
            newValue: false,
            nodes: nodes,
            suppressFinishActions: true,
            source: source
        });
        selectionSvc?.updateGroupsFromChildrenSelections?.(source);
        if (nodes.length) this.eventSvc.dispatchEvent({
            type: "selectionChanged",
            source: source,
            selectedNodes: selectionSvc?.getSelectedNodes() ?? null,
            serverSideState: null
        });
    }
    createRowNode(data, level) {
        const node = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        node.parent = this.rootNode;
        node.level = level;
        node.group = false;
        node.expanded = false;
        node.setDataAndId(data, String(this.nextId++));
        const id = node.id;
        const allNodesMap = this.allNodesMap;
        if (allNodesMap[id]) $437b23f6a393c3bf$export$545083624300f13d(2, {
            nodeId: id
        });
        allNodesMap[id] = node;
        return node;
    }
    /** Called when a node needs to be deleted */ destroyNode(node, animate) {
        if (!node._destroy(animate)) return false;
        const id = node.id;
        const allNodesMap = this.allNodesMap;
        if (allNodesMap[id] === node) delete allNodesMap[id];
        const pinnedSibling = node.pinnedSibling;
        if (pinnedSibling) this.beans.pinnedRowModel?.pinRow(pinnedSibling, null);
        return true;
    }
    lookupNode(getRowIdFunc, data) {
        if (!getRowIdFunc) return $437b23f6a393c3bf$var$lookupNodeByData(this.rootNode._leafs, data);
        const id = getRowIdFunc({
            data: data,
            level: 0
        });
        const rowNode = this.allNodesMap[id];
        if (!rowNode) {
            $437b23f6a393c3bf$export$a20c7248650823a9(4, {
                id: id
            });
            return null;
        }
        return rowNode;
    }
    sanitizeAddIndex(allLeafs, addIndex) {
        const allLeafsLen = allLeafs.length;
        if (typeof addIndex !== "number") return allLeafsLen;
        if (addIndex < 0 || addIndex >= allLeafsLen || Number.isNaN(addIndex)) return allLeafsLen;
        addIndex = Math.ceil(addIndex);
        const gos = this.gos;
        if (addIndex > 0 && gos.get("treeData") && gos.get("getDataPath")) addIndex = $437b23f6a393c3bf$var$adjustAddIndexForDataPath(allLeafs, addIndex);
        return addIndex;
    }
};
var $437b23f6a393c3bf$var$adjustAddIndexForDataPath = (allLeafs, addIndex)=>{
    for(let i = 0, len = allLeafs.length; i < len; i++){
        const node = allLeafs[i];
        if (node?.rowIndex == addIndex - 1) return i + 1;
    }
    return addIndex;
};
var $437b23f6a393c3bf$var$initRootNode = (rootNode)=>{
    rootNode.group = true;
    rootNode.level = -1;
    rootNode.id = "ROOT_NODE_ID";
    if (rootNode._leafs?.length !== 0) rootNode._leafs = [];
    const childrenAfterGroup = [];
    const childrenAfterSort = [];
    const childrenAfterAggFilter = [];
    const childrenAfterFilter = [];
    rootNode.childrenAfterGroup = childrenAfterGroup;
    rootNode.childrenAfterSort = childrenAfterSort;
    rootNode.childrenAfterAggFilter = childrenAfterAggFilter;
    rootNode.childrenAfterFilter = childrenAfterFilter;
    const sibling = rootNode.sibling;
    if (sibling) {
        sibling.childrenAfterGroup = childrenAfterGroup;
        sibling.childrenAfterSort = childrenAfterSort;
        sibling.childrenAfterAggFilter = childrenAfterAggFilter;
        sibling.childrenAfterFilter = childrenAfterFilter;
        sibling.childrenMapped = rootNode.childrenMapped;
    }
    rootNode.updateHasChildren();
    return rootNode;
};
var $437b23f6a393c3bf$var$lookupNodeByData = (nodes, data)=>{
    if (nodes) for(let i = 0, len = nodes.length; i < len; i++){
        const node = nodes[i];
        if (node.data === data) return node;
    }
    $437b23f6a393c3bf$export$a20c7248650823a9(5, {
        data: data
    });
    return null;
};
var $437b23f6a393c3bf$var$filterRemovedRowNodes = (allLeafs, filterIdx, filterEndIdx)=>{
    filterIdx = Math.max(0, filterIdx);
    for(let readIdx = filterIdx, len = allLeafs.length; readIdx < len; ++readIdx){
        const node = allLeafs[readIdx];
        if (readIdx <= filterEndIdx && node.destroyed) continue;
        node.sourceRowIndex = filterIdx;
        allLeafs[filterIdx++] = node;
    }
    allLeafs.length = filterIdx;
};
var $437b23f6a393c3bf$var$updateRootLeafsOrdered = (allLeafs, processedNodes)=>{
    const newSize = processedNodes.size;
    allLeafs.length = newSize;
    let writeIdx = 0;
    let added = false;
    let reordered = false;
    for (const node of processedNodes){
        const sourceRowIndex = node.sourceRowIndex;
        if (sourceRowIndex === writeIdx) reordered || (reordered = added);
        else {
            if (sourceRowIndex >= 0) reordered = true;
            else added = true;
            node.sourceRowIndex = writeIdx;
            allLeafs[writeIdx] = node;
        }
        ++writeIdx;
    }
    return reordered;
};
var $437b23f6a393c3bf$var$updateRootLeafsKeepOrder = (allLeafs, processedNodes, { adds: adds })=>{
    const allLeafsLen = allLeafs.length;
    const newAllLeafsLen = processedNodes.size;
    if (newAllLeafsLen > allLeafsLen) allLeafs.length = newAllLeafsLen;
    let writeIdx = 0;
    for(let readIdx = 0; readIdx < allLeafsLen; ++readIdx){
        const node = allLeafs[readIdx];
        if (!node.destroyed) {
            if (writeIdx !== readIdx) {
                node.sourceRowIndex = writeIdx;
                allLeafs[writeIdx] = node;
            }
            ++writeIdx;
        }
    }
    for (const node of adds)if (node.sourceRowIndex < 0) {
        node.sourceRowIndex = writeIdx;
        allLeafs[writeIdx++] = node;
    }
    allLeafs.length = writeIdx;
};
// packages/ag-grid-community/src/clientSideRowModel/deltaSort.ts
var $437b23f6a393c3bf$var$MIN_DELTA_SORT_ROWS = 4;
var $437b23f6a393c3bf$var$doDeltaSort = (rowNodeSorter, rowNode, changedRowNodes, changedPath, sortOptions)=>{
    const oldSortedRows = rowNode.childrenAfterSort;
    const unsortedRows = rowNode.childrenAfterAggFilter;
    if (!unsortedRows) return oldSortedRows && oldSortedRows.length > 0 ? oldSortedRows : [];
    const unsortedRowsLen = unsortedRows.length;
    if (unsortedRowsLen <= 1) {
        if (oldSortedRows?.length === unsortedRowsLen && (unsortedRowsLen === 0 || oldSortedRows[0] === unsortedRows[0])) return oldSortedRows;
        return unsortedRows.slice();
    }
    if (!oldSortedRows || unsortedRowsLen <= $437b23f6a393c3bf$var$MIN_DELTA_SORT_ROWS) return rowNodeSorter.doFullSortInPlace(unsortedRows.slice(), sortOptions);
    const indexByNode = /* @__PURE__ */ new Map();
    const { updates: updates, adds: adds } = changedRowNodes;
    const touchedRows = [];
    for(let i = 0; i < unsortedRowsLen; ++i){
        const node = unsortedRows[i];
        if (updates.has(node) || adds.has(node) || !changedPath.canSkip(node)) {
            indexByNode.set(node, ~i);
            touchedRows.push(node);
        } else indexByNode.set(node, i);
    }
    const touchedRowsLen = touchedRows.length;
    if (touchedRowsLen === 0) return unsortedRowsLen === oldSortedRows.length ? oldSortedRows : $437b23f6a393c3bf$var$filterRemovedNodes(oldSortedRows, indexByNode, touchedRows);
    touchedRows.sort((a, b)=>rowNodeSorter.compareRowNodes(sortOptions, a, b) || ~indexByNode.get(a) - ~indexByNode.get(b));
    if (touchedRowsLen === unsortedRowsLen) return touchedRows;
    return $437b23f6a393c3bf$var$mergeDeltaSortedArrays(rowNodeSorter, sortOptions, touchedRows, oldSortedRows, indexByNode, unsortedRowsLen);
};
var $437b23f6a393c3bf$var$mergeDeltaSortedArrays = (rowNodeSorter, sortOptions, touchedRows, oldSortedRows, indexByNode, resultSize)=>{
    const result = new Array(resultSize);
    let touchedIdx = 0;
    let touchedNode = touchedRows[touchedIdx];
    let untouchedNode;
    let untouchedIdx = -1;
    let oldIdx = 0;
    let resultIdx = 0;
    const touchedLength = touchedRows.length;
    const oldSortedLength = oldSortedRows.length;
    while(true){
        if (untouchedIdx < 0) {
            if (oldIdx >= oldSortedLength) break;
            untouchedNode = oldSortedRows[oldIdx++];
            untouchedIdx = indexByNode.get(untouchedNode) ?? -1;
            if (untouchedIdx < 0) continue;
        }
        const orderDelta = rowNodeSorter.compareRowNodes(sortOptions, touchedNode, untouchedNode) || ~indexByNode.get(touchedNode) - untouchedIdx;
        if (orderDelta < 0) {
            result[resultIdx++] = touchedNode;
            if (++touchedIdx >= touchedLength) break;
            touchedNode = touchedRows[touchedIdx];
        } else {
            result[resultIdx++] = untouchedNode;
            untouchedIdx = -1;
        }
    }
    while(touchedIdx < touchedLength)result[resultIdx++] = touchedRows[touchedIdx++];
    if (untouchedIdx < 0) return result;
    result[resultIdx++] = untouchedNode;
    while(oldIdx < oldSortedLength){
        const node = oldSortedRows[oldIdx++];
        if (indexByNode.get(node) >= 0) result[resultIdx++] = node;
    }
    return result;
};
var $437b23f6a393c3bf$var$filterRemovedNodes = (rows, map, result)=>{
    let count = 0;
    result.length = map.size;
    for(let i = 0, len = rows.length; i < len; ++i){
        const node = rows[i];
        if (map.has(node)) result[count++] = node;
    }
    result.length = count;
    return result;
};
// packages/ag-grid-community/src/clientSideRowModel/sortStage.ts
var $437b23f6a393c3bf$var$updateRowNodeAfterSort = (rowNode)=>{
    const childrenAfterSort = rowNode.childrenAfterSort;
    const sibling = rowNode.sibling;
    if (sibling) sibling.childrenAfterSort = childrenAfterSort;
    if (!childrenAfterSort) return;
    for(let i = 0, lastIdx = childrenAfterSort.length - 1; i <= lastIdx; i++){
        const child = childrenAfterSort[i];
        const first = i === 0;
        const last = i === lastIdx;
        if (child.firstChild !== first) {
            child.firstChild = first;
            child.dispatchRowEvent("firstChildChanged");
        }
        if (child.lastChild !== last) {
            child.lastChild = last;
            child.dispatchRowEvent("lastChildChanged");
        }
        if (child.childIndex !== i) {
            child.childIndex = i;
            child.dispatchRowEvent("childIndexChanged");
        }
    }
};
var $437b23f6a393c3bf$var$SortStage = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "sortStage";
        this.step = "sort";
        this.refreshProps = [
            "postSortRows",
            "groupDisplayType",
            "accentedSort"
        ];
    }
    execute(changedPath, changedRowNodes) {
        const sortOptions = this.beans.sortSvc.getSortOptions();
        const useDeltaSort = sortOptions.length > 0 && !!changedRowNodes && // in time we can remove this check, so that delta sort is always
        // on if transactions are present. it's off for now so that we can
        // selectively turn it on and test it with some select users before
        // rolling out to everyone.
        this.gos.get("deltaSort");
        const { gos: gos, colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, rowNodeSorter: rowNodeSorter, rowRenderer: rowRenderer, showRowGroupCols: showRowGroupCols } = this.beans;
        const groupMaintainOrder = gos.get("groupMaintainOrder");
        const groupColumnsPresent = colModel.getCols().some((c)=>c.isRowGroupActive());
        const groupCols = rowGroupColsSvc?.columns;
        const isPivotMode = colModel.isPivotMode();
        const postSortFunc = gos.getCallback("postSortRows");
        let hasAnyFirstChildChanged = false;
        let sortContainsGroupColumns;
        const callback = (rowNode)=>{
            const skipSortingPivotLeafs = isPivotMode && rowNode.leafGroup;
            let skipSortingGroups = groupMaintainOrder && groupColumnsPresent && !rowNode.leafGroup;
            if (skipSortingGroups) {
                sortContainsGroupColumns ?? (sortContainsGroupColumns = this.shouldSortContainsGroupCols(sortOptions));
                skipSortingGroups && (skipSortingGroups = !sortContainsGroupColumns);
            }
            let newChildrenAfterSort = null;
            if (skipSortingGroups) {
                let wasSortExplicitlyRemoved = false;
                if (groupCols) {
                    const nextGroupIndex = rowNode.level + 1;
                    if (nextGroupIndex < groupCols.length) wasSortExplicitlyRemoved = groupCols[nextGroupIndex].wasSortExplicitlyRemoved;
                }
                if (!wasSortExplicitlyRemoved) newChildrenAfterSort = $437b23f6a393c3bf$var$preserveGroupOrder(rowNode);
            } else if (!sortOptions.length || skipSortingPivotLeafs) ;
            else if (useDeltaSort && changedRowNodes) newChildrenAfterSort = $437b23f6a393c3bf$var$doDeltaSort(rowNodeSorter, rowNode, changedRowNodes, changedPath, sortOptions);
            else newChildrenAfterSort = rowNodeSorter.doFullSortInPlace(rowNode.childrenAfterAggFilter.slice(), sortOptions);
            newChildrenAfterSort || (newChildrenAfterSort = rowNode.childrenAfterAggFilter?.slice() ?? []);
            hasAnyFirstChildChanged || (hasAnyFirstChildChanged = rowNode.childrenAfterSort?.[0] !== newChildrenAfterSort[0]);
            rowNode.childrenAfterSort = newChildrenAfterSort;
            $437b23f6a393c3bf$var$updateRowNodeAfterSort(rowNode);
            if (postSortFunc) {
                const params = {
                    nodes: rowNode.childrenAfterSort
                };
                postSortFunc(params);
            }
        };
        changedPath?.forEachChangedNodeDepthFirst(callback);
        if (hasAnyFirstChildChanged && gos.get("groupHideOpenParents")) {
            const columns = showRowGroupCols?.columns;
            if (columns?.length) rowRenderer.refreshCells({
                columns: columns,
                force: true
            });
        }
    }
    shouldSortContainsGroupCols(sortOptions) {
        const sortOptionsLen = sortOptions.length;
        if (!sortOptionsLen) return false;
        if ($437b23f6a393c3bf$export$96c51c2547b81aed(this.gos)) {
            for(let i = 0; i < sortOptionsLen; ++i){
                const column = sortOptions[i].column;
                if (column.isPrimary() && column.isRowGroupActive()) return true;
            }
            return false;
        }
        for(let i = 0; i < sortOptionsLen; ++i){
            if (sortOptions[i].column.getColDef().showRowGroup) return true;
        }
        return false;
    }
};
var $437b23f6a393c3bf$var$preserveGroupOrder = (node)=>{
    const childrenAfterSort = node.childrenAfterSort;
    const childrenAfterAggFilter = node.childrenAfterAggFilter;
    const childrenAfterSortLen = childrenAfterSort?.length;
    const childrenAfterAggFilterLen = childrenAfterAggFilter?.length;
    if (!childrenAfterSortLen || !childrenAfterAggFilterLen) return null;
    const result = new Array(childrenAfterAggFilterLen);
    const processed = /* @__PURE__ */ new Set();
    for(let i = 0; i < childrenAfterAggFilterLen; ++i)processed.add(childrenAfterAggFilter[i]);
    let writeIdx = 0;
    for(let i = 0; i < childrenAfterSortLen; ++i){
        const node2 = childrenAfterSort[i];
        if (processed.delete(node2)) result[writeIdx++] = node2;
    }
    if (processed.size === 0 && writeIdx === childrenAfterSortLen) return childrenAfterSort;
    for (const newNode of processed)result[writeIdx++] = newNode;
    result.length = writeIdx;
    return result;
};
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModel.ts
var $437b23f6a393c3bf$var$ClientSideRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
        // top most node of the tree. the children are the user provided data.
        this.rootNode = null;
        this.rowCountReady = false;
        this.nodeManager = void 0;
        this.rowsToDisplay = [];
        // the rows mapped to rows to display
        this.formulaRows = [];
        /** Keep track if row data was updated. Important with suppressModelUpdateAfterUpdateTransaction and refreshModel api is called  */ this.rowDataUpdatedPending = false;
        this.asyncTransactions = null;
        this.asyncTransactionsTimer = 0;
        /** Has the start method been called */ this.started = false;
        /**
     * This is to prevent refresh model being called when it's already being called.
     * E.g. the group stage can trigger initial state filter model to be applied. This fires onFilterChanged,
     * which then triggers the listener here that calls refresh model again but at the filter stage
     * (which is about to be run by the original call).
     */ this.refreshingModel = false;
        this.rowNodesCountReady = false;
        this.stages = null;
        /** Maps a property name to the index in this.stages array */ this.stagesRefreshProps = /* @__PURE__ */ new Map();
        this.onRowHeightChanged_debounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onRowHeightChanged.bind(this), 100);
    }
    postConstruct() {
        const beans = this.beans;
        const rootNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
        this.rootNode = rootNode;
        this.nodeManager = this.createBean(new $437b23f6a393c3bf$var$ClientSideNodeManager(rootNode));
        const onColumnsChanged = ()=>{
            this.beans.groupStage?.invalidateGroupCols();
            this.refreshModel({
                step: "group",
                afterColumnsChanged: true,
                keepRenderedRows: true,
                animate: !this.gos.get("suppressAnimationFrame")
            });
        };
        this.addManagedEventListeners({
            newColumnsLoaded: onColumnsChanged,
            columnRowGroupChanged: onColumnsChanged,
            columnValueChanged: this.onValueChanged.bind(this),
            columnPivotChanged: ()=>this.refreshModel({
                    step: "pivot"
                }),
            columnPivotModeChanged: ()=>this.refreshModel({
                    step: "group"
                }),
            filterChanged: this.onFilterChanged.bind(this),
            sortChanged: this.onSortChanged.bind(this),
            stylesChanged: this.onGridStylesChanges.bind(this),
            gridReady: this.onGridReady.bind(this),
            rowExpansionStateChanged: this.onRowGroupOpened.bind(this)
        });
        this.addPropertyListeners();
    }
    addPropertyListeners() {
        const { beans: beans, stagesRefreshProps: stagesRefreshProps } = this;
        const orderedStages = [
            beans.groupStage,
            beans.filterStage,
            beans.pivotStage,
            beans.aggStage,
            beans.sortStage,
            beans.filterAggStage,
            beans.flattenStage
        ].filter((stage)=>!!stage);
        this.stages = orderedStages;
        for(let i = orderedStages.length - 1; i >= 0; --i){
            const stage = orderedStages[i];
            for (const prop of stage.refreshProps)stagesRefreshProps.set(prop, i);
        }
        this.addManagedPropertyListeners([
            ...stagesRefreshProps.keys(),
            "rowData"
        ], (params)=>{
            const properties = params.changeSet?.properties;
            if (properties) this.onPropChange(properties);
        });
        this.addManagedPropertyListener("rowHeight", ()=>this.resetRowHeights());
    }
    start() {
        this.started = true;
        if (this.rowNodesCountReady) this.refreshModel({
            step: "group",
            rowDataUpdated: true,
            newData: true
        });
        else this.setInitialData();
    }
    setInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData) this.onPropChange([
            "rowData"
        ]);
    }
    ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
        let atLeastOneChange;
        let res = false;
        do {
            atLeastOneChange = false;
            const rowAtStartPixel = this.getRowIndexAtPixel(startPixel);
            const rowAtEndPixel = this.getRowIndexAtPixel(endPixel);
            const firstRow = Math.max(rowAtStartPixel, startLimitIndex);
            const lastRow = Math.min(rowAtEndPixel, endLimitIndex);
            for(let rowIndex = firstRow; rowIndex <= lastRow; rowIndex++){
                const rowNode = this.getRow(rowIndex);
                if (rowNode.rowHeightEstimated) {
                    const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                    rowNode.setRowHeight(rowHeight.height);
                    atLeastOneChange = true;
                    res = true;
                }
            }
            if (atLeastOneChange) this.setRowTopAndRowIndex();
        }while (atLeastOneChange);
        return res;
    }
    onPropChange(properties) {
        const { nodeManager: nodeManager, gos: gos, beans: beans } = this;
        const groupStage = beans.groupStage;
        if (!nodeManager) return;
        const changedProps = new Set(properties);
        const extractData = groupStage?.onPropChange(changedProps);
        let newRowData;
        if (changedProps.has("rowData")) newRowData = gos.get("rowData");
        else if (extractData) newRowData = groupStage?.extractData();
        if (newRowData && !Array.isArray(newRowData)) {
            newRowData = null;
            $437b23f6a393c3bf$export$545083624300f13d(1);
        }
        const params = {
            step: "nothing",
            changedProps: changedProps
        };
        if (newRowData) {
            const immutable = !extractData && !this.isEmpty() && newRowData.length > 0 && gos.exists("getRowId") && // backward compatibility - for who want old behaviour of Row IDs but NOT Immutable Data.
            !gos.get("resetRowDataOnUpdate");
            if (immutable) {
                params.keepRenderedRows = true;
                params.animate = !gos.get("suppressAnimationFrame");
                params.changedRowNodes = new $437b23f6a393c3bf$export$31d871bfcf904e4b();
                nodeManager.setImmutableRowData(params, newRowData);
            } else {
                params.rowDataUpdated = true;
                params.newData = true;
                nodeManager.setNewRowData(newRowData);
                this.rowNodesCountReady = true;
            }
        }
        const step = params.rowDataUpdated ? "group" : this.getRefreshedStage(properties);
        if (step) {
            params.step = step;
            this.refreshModel(params);
        }
    }
    getRefreshedStage(properties) {
        const { stages: stages, stagesRefreshProps: stagesRefreshProps } = this;
        if (!stages) return null;
        const stagesLen = stages.length;
        let minIndex = stagesLen;
        for(let i = 0, len = properties.length; i < len && minIndex; ++i)minIndex = Math.min(minIndex, stagesRefreshProps.get(properties[i]) ?? minIndex);
        return minIndex < stagesLen ? stages[minIndex].step : null;
    }
    setRowTopAndRowIndex(outputDisplayedRowsMapped) {
        const { beans: beans, rowsToDisplay: rowsToDisplay } = this;
        const defaultRowHeight = beans.environment.getDefaultRowHeight();
        let nextRowTop = 0;
        const allowEstimate = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        for(let i = 0, len = rowsToDisplay.length; i < len; ++i){
            const rowNode = rowsToDisplay[i];
            const id = rowNode.id;
            if (id != null) outputDisplayedRowsMapped?.add(id);
            if (rowNode.rowHeight == null) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, rowNode, allowEstimate, defaultRowHeight);
                rowNode.setRowHeight(rowHeight.height, rowHeight.estimated);
            }
            rowNode.setRowTop(nextRowTop);
            rowNode.setRowIndex(i);
            nextRowTop += rowNode.rowHeight;
        }
        if (this.beans.formula?.active) {
            const formulaRows = this.formulaRows;
            for(let i = 0, len = formulaRows.length; i < len; ++i){
                const rowNode = formulaRows[i];
                rowNode.formulaRowIndex = i;
            }
        }
    }
    clearRowTopAndRowIndex(changedPath, displayedRowsMapped) {
        const changedPathActive = changedPath.active;
        const clearIfNotDisplayed = (rowNode)=>{
            if (rowNode?.id != null && !displayedRowsMapped.has(rowNode.id)) rowNode.clearRowTopAndRowIndex();
        };
        const recurse = (rowNode)=>{
            clearIfNotDisplayed(rowNode);
            clearIfNotDisplayed(rowNode.detailNode);
            clearIfNotDisplayed(rowNode.sibling);
            const childrenAfterGroup = rowNode.childrenAfterGroup;
            if (!rowNode.hasChildren() || !childrenAfterGroup) return;
            const isRootNode = rowNode.level == -1;
            const skipChildren = changedPathActive && !isRootNode && !rowNode.expanded;
            if (skipChildren) return;
            for(let i = 0, len = childrenAfterGroup.length; i < len; ++i)recurse(childrenAfterGroup[i]);
        };
        const rootNode = this.rootNode;
        if (rootNode) recurse(rootNode);
    }
    isLastRowIndexKnown() {
        return true;
    }
    getRowCount() {
        return this.rowsToDisplay.length;
    }
    /**
   * Returns the number of rows with level === 1
   */ getTopLevelRowCount() {
        const { rootNode: rootNode, rowsToDisplay: rowsToDisplay } = this;
        if (!rootNode || !rowsToDisplay.length) return 0;
        const showingRootNode = rowsToDisplay[0] === rootNode;
        if (showingRootNode) return 1;
        const totalFooterInc = rootNode.sibling?.displayed ? 1 : 0;
        return (rootNode.childrenAfterSort?.length ?? 0) + totalFooterInc;
    }
    /**
   * Get the row display index by the top level index
   * top level index is the index of rows with level === 1
   */ getTopLevelRowDisplayedIndex(topLevelIndex) {
        const { beans: beans, rootNode: rootNode, rowsToDisplay: rowsToDisplay } = this;
        const showingRootNode = !rootNode || !rowsToDisplay.length || rowsToDisplay[0] === rootNode;
        if (showingRootNode) return topLevelIndex;
        const childrenAfterSort = rootNode.childrenAfterSort;
        const getDefaultIndex = (adjustedIndex)=>{
            let rowNode = childrenAfterSort[adjustedIndex];
            if (this.gos.get("groupHideOpenParents")) while(rowNode.expanded && rowNode.childrenAfterSort && rowNode.childrenAfterSort.length > 0)rowNode = rowNode.childrenAfterSort[0];
            return rowNode.rowIndex;
        };
        const footerSvc = beans.footerSvc;
        if (footerSvc) return footerSvc?.getTopDisplayIndex(rowsToDisplay, topLevelIndex, childrenAfterSort, getDefaultIndex);
        return getDefaultIndex(topLevelIndex);
    }
    /**
   * The opposite of `getTopLevelRowDisplayedIndex`
   */ getTopLevelIndexFromDisplayedIndex(displayedIndex) {
        const { rootNode: rootNode, rowsToDisplay: rowsToDisplay } = this;
        const showingRootNode = !rootNode || !rowsToDisplay.length || rowsToDisplay[0] === rootNode;
        if (showingRootNode) return displayedIndex;
        let node = this.getRow(displayedIndex);
        if (node.footer) node = node.sibling;
        let parent = node.parent;
        while(parent && parent !== rootNode){
            node = parent;
            parent = node.parent;
        }
        const topLevelIndex = rootNode.childrenAfterSort?.indexOf(node) ?? -1;
        return topLevelIndex >= 0 ? topLevelIndex : displayedIndex;
    }
    getRowBounds(index) {
        const rowNode = this.rowsToDisplay[index];
        return rowNode ? {
            rowTop: rowNode.rowTop,
            rowHeight: rowNode.rowHeight
        } : null;
    }
    onRowGroupOpened() {
        this.refreshModel({
            step: "map",
            keepRenderedRows: true,
            animate: $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos)
        });
    }
    onFilterChanged({ afterDataChange: afterDataChange, columns: columns }) {
        if (!afterDataChange) {
            const primaryOrQuickFilterChanged = columns.length === 0 || columns.some((col)=>col.isPrimary());
            const step = primaryOrQuickFilterChanged ? "filter" : "filter_aggregates";
            this.refreshModel({
                step: step,
                keepRenderedRows: true,
                animate: $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos)
            });
        }
    }
    onSortChanged() {
        this.refreshModel({
            step: "sort",
            keepRenderedRows: true,
            animate: $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos)
        });
    }
    getType() {
        return "clientSide";
    }
    onValueChanged() {
        this.refreshModel({
            step: this.beans.colModel.isPivotActive() ? "pivot" : "aggregate"
        });
    }
    createChangePath(enabled) {
        const changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, this.rootNode);
        changedPath.active = enabled;
        return changedPath;
    }
    isSuppressModelUpdateAfterUpdateTransaction(params) {
        if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction")) return false;
        const { changedRowNodes: changedRowNodes, newData: newData, rowDataUpdated: rowDataUpdated } = params;
        if (!changedRowNodes || newData || !rowDataUpdated) return false;
        if (changedRowNodes.removals.length || changedRowNodes.adds.size) return false;
        return true;
    }
    refreshModel(params) {
        const { nodeManager: nodeManager, beans: beans, eventSvc: eventSvc, started: started, refreshingModel: refreshingModel } = this;
        if (!nodeManager) return;
        const rowDataUpdated = !!params.rowDataUpdated;
        const changedPath = params.changedPath ?? (params.changedPath = this.createChangePath(!params.newData && rowDataUpdated));
        if (started && rowDataUpdated) eventSvc.dispatchEvent({
            type: "rowDataUpdated"
        });
        if (!started || refreshingModel || beans.colModel.changeEventsDispatching || this.isSuppressModelUpdateAfterUpdateTransaction(params)) {
            this.rowDataUpdatedPending || (this.rowDataUpdatedPending = rowDataUpdated);
            return;
        }
        if (this.rowDataUpdatedPending) {
            this.rowDataUpdatedPending = false;
            params.step = "group";
        }
        this.refreshingModel = true;
        beans.masterDetailSvc?.refreshModel(params);
        if (rowDataUpdated && params.step !== "group") beans.colFilter?.refreshModel();
        switch(params.step){
            case "group":
                this.doGrouping(params);
            case "filter":
                this.doFilter(changedPath);
            case "pivot":
                this.doPivot(changedPath);
            case "aggregate":
                this.doAggregate(changedPath);
            case "filter_aggregates":
                this.doFilterAggregates(changedPath);
            case "sort":
                this.doSort(changedPath, params.changedRowNodes);
            case "map":
                this.doRowsToDisplay();
        }
        const displayedNodesMapped = /* @__PURE__ */ new Set();
        this.setRowTopAndRowIndex(displayedNodesMapped);
        this.clearRowTopAndRowIndex(changedPath, displayedNodesMapped);
        this.refreshingModel = false;
        eventSvc.dispatchEvent({
            type: "modelUpdated",
            animate: params.animate,
            keepRenderedRows: params.keepRenderedRows,
            newData: params.newData,
            newPage: false,
            keepUndoRedoStack: params.keepUndoRedoStack
        });
    }
    isEmpty() {
        return !this.rootNode?._leafs?.length || !this.beans.colModel?.ready;
    }
    isRowsToRender() {
        return this.rowsToDisplay.length > 0;
    }
    getOverlayType() {
        if (this.isEmpty()) return "noRows";
        if (this.beans.filterManager?.isAnyFilterPresent() && this.getRowCount() === 0) return "noMatchingRows";
        return null;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        let started = false;
        let finished = false;
        const result = [];
        const groupsSelectChildren = $437b23f6a393c3bf$export$460e5745f0e6a40d(this.gos);
        this.forEachNodeAfterFilterAndSort((rowNode)=>{
            if (finished) return;
            if (started) {
                if (rowNode === lastInRange || rowNode === firstInRange) {
                    finished = true;
                    if (groupsSelectChildren && rowNode.group) {
                        $437b23f6a393c3bf$var$addAllLeafs(result, rowNode);
                        return;
                    }
                }
            }
            if (!started) {
                if (rowNode !== lastInRange && rowNode !== firstInRange) return;
                started = true;
                if (lastInRange === firstInRange) finished = true;
            }
            const includeThisNode = !rowNode.group || !groupsSelectChildren;
            if (includeThisNode) result.push(rowNode);
        });
        return result;
    }
    getTopLevelNodes() {
        return this.rootNode?.childrenAfterGroup ?? null;
    }
    getRow(index) {
        return this.rowsToDisplay[index];
    }
    getFormulaRow(index) {
        return this.formulaRows[index];
    }
    isRowPresent(rowNode) {
        return this.rowsToDisplay.indexOf(rowNode) >= 0;
    }
    getRowIndexAtPixel(pixelToMatch) {
        const rowsToDisplay = this.rowsToDisplay;
        const rowsToDisplayLen = rowsToDisplay.length;
        if (this.isEmpty() || rowsToDisplayLen === 0) return -1;
        let bottomPointer = 0;
        let topPointer = rowsToDisplayLen - 1;
        if (pixelToMatch <= 0) return 0;
        const lastNode = rowsToDisplay[topPointer];
        if (lastNode.rowTop <= pixelToMatch) return topPointer;
        let oldBottomPointer = -1;
        let oldTopPointer = -1;
        while(true){
            const midPointer = Math.floor((bottomPointer + topPointer) / 2);
            const currentRowNode = rowsToDisplay[midPointer];
            if (this.isRowInPixel(currentRowNode, pixelToMatch)) return midPointer;
            if (currentRowNode.rowTop < pixelToMatch) bottomPointer = midPointer + 1;
            else if (currentRowNode.rowTop > pixelToMatch) topPointer = midPointer - 1;
            const caughtInInfiniteLoop = oldBottomPointer === bottomPointer && oldTopPointer === topPointer;
            if (caughtInInfiniteLoop) return midPointer;
            oldBottomPointer = bottomPointer;
            oldTopPointer = topPointer;
        }
    }
    isRowInPixel(rowNode, pixelToMatch) {
        const topPixel = rowNode.rowTop;
        const bottomPixel = topPixel + rowNode.rowHeight;
        return topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
    }
    forEachLeafNode(callback) {
        const allLeafs = this.rootNode?._leafs;
        if (allLeafs) for(let i = 0, len = allLeafs.length; i < len; ++i)callback(allLeafs[i], i);
    }
    forEachNode(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes);
    }
    forEachDisplayedNode(callback) {
        const rowsToDisplay = this.rowsToDisplay;
        for(let i = 0, len = rowsToDisplay.length; i < len; ++i)callback(rowsToDisplay[i], i);
    }
    forEachNodeAfterFilter(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>node.childrenAfterAggFilter);
    }
    forEachNodeAfterFilterAndSort(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>node.childrenAfterSort);
    }
    forEachPivotNode(callback, includeFooterNodes, afterSort) {
        const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        if (!colModel.isPivotMode()) return;
        if (!rowGroupColsSvc?.columns.length) {
            callback(this.rootNode, 0);
            return;
        }
        const childrenField = afterSort ? "childrenAfterSort" : "childrenAfterGroup";
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>!node.leafGroup ? node[childrenField] : null);
    }
    /**
   * Iterate through each node and all of its children
   * @param callback the function to execute for each node
   * @param includeFooterNodes whether to also iterate over footer nodes
   * @param nodes the nodes to start iterating over
   * @param getChildren a function to determine the recursion strategy
   * @param startIndex the index to start from
   * @returns the index ended at
   */ depthFirstSearchRowNodes(callback, includeFooterNodes = false, getChildren = (node2)=>node2.childrenAfterGroup, node = this.rootNode, startIndex = 0) {
        let index = startIndex;
        if (!node) return index;
        const isRootNode = node === this.rootNode;
        if (!isRootNode) callback(node, index++);
        if (node.hasChildren() && !node.footer) {
            const children = getChildren(node);
            if (children) {
                const footerSvc = this.beans.footerSvc;
                index = footerSvc?.addTotalRows(index, node, callback, includeFooterNodes, isRootNode, "top") ?? index;
                for (const node2 of children)index = this.depthFirstSearchRowNodes(callback, includeFooterNodes, getChildren, node2, index);
                return footerSvc?.addTotalRows(index, node, callback, includeFooterNodes, isRootNode, "bottom") ?? index;
            }
        }
        return index;
    }
    // it's possible to recompute the aggregate without doing the other parts + api.refreshClientSideRowModel('aggregate')
    doAggregate(changedPath) {
        const rootNode = this.rootNode;
        if (rootNode) this.beans.aggStage?.execute(changedPath);
    }
    doFilterAggregates(changedPath) {
        const rootNode = this.rootNode;
        const filterAggStage = this.beans.filterAggStage;
        if (filterAggStage) {
            filterAggStage.execute(changedPath);
            return;
        }
        rootNode.childrenAfterAggFilter = rootNode.childrenAfterFilter;
    }
    doSort(changedPath, changedRowNodes) {
        const sortStage = this.beans.sortStage;
        if (sortStage) {
            sortStage.execute(changedPath, changedRowNodes);
            return;
        }
        changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            rowNode.childrenAfterSort = rowNode.childrenAfterAggFilter.slice(0);
            $437b23f6a393c3bf$var$updateRowNodeAfterSort(rowNode);
        });
    }
    doGrouping(params) {
        const rootNode = this.rootNode;
        if (!rootNode) return;
        const groupStage = this.beans.groupStage;
        const groupingChanged = groupStage?.execute(params);
        if (groupingChanged === void 0) {
            const allLeafs = rootNode._leafs;
            rootNode.childrenAfterGroup = allLeafs;
            rootNode.updateHasChildren();
            const sibling = rootNode.sibling;
            if (sibling) sibling.childrenAfterGroup = allLeafs;
        }
        if (groupingChanged || params.rowDataUpdated) this.beans.colFilter?.refreshModel();
        if (!this.rowCountReady && this.rowNodesCountReady) {
            this.rowCountReady = true;
            this.eventSvc.dispatchEventOnce({
                type: "rowCountReady"
            });
        }
    }
    doFilter(changedPath) {
        const filterStage = this.beans.filterStage;
        if (filterStage) {
            filterStage.execute(changedPath);
            return;
        }
        changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode);
        }, true);
    }
    doPivot(changedPath) {
        this.beans.pivotStage?.execute(changedPath);
    }
    getRowNode(id) {
        const found = this.nodeManager?.getRowNode(id);
        if (typeof found === "object") return found;
        return this.beans.groupStage?.getNonLeaf(id);
    }
    batchUpdateRowData(rowDataTransaction, callback) {
        if (!this.asyncTransactionsTimer) {
            this.asyncTransactions = [];
            const waitMilliseconds = this.gos.get("asyncTransactionWaitMillis");
            this.asyncTransactionsTimer = setTimeout(()=>this.executeBatchUpdateRowData(), waitMilliseconds);
        }
        this.asyncTransactions.push({
            rowDataTransaction: rowDataTransaction,
            callback: callback
        });
    }
    flushAsyncTransactions() {
        const asyncTransactionsTimer = this.asyncTransactionsTimer;
        if (asyncTransactionsTimer) {
            clearTimeout(asyncTransactionsTimer);
            this.executeBatchUpdateRowData();
        }
    }
    executeBatchUpdateRowData() {
        const { nodeManager: nodeManager, beans: beans, eventSvc: eventSvc, asyncTransactions: asyncTransactions } = this;
        if (!nodeManager) return;
        beans.valueCache?.onDataChanged();
        const rowNodeTrans = [];
        const callbackFuncsBound = [];
        const changedRowNodes = new $437b23f6a393c3bf$export$31d871bfcf904e4b();
        const animate = !this.gos.get("suppressAnimationFrame");
        for (const { rowDataTransaction: rowDataTransaction, callback: callback } of asyncTransactions ?? []){
            this.rowNodesCountReady = true;
            const rowNodeTransaction = nodeManager.updateRowData(rowDataTransaction, changedRowNodes, animate);
            rowNodeTrans.push(rowNodeTransaction);
            if (callback) callbackFuncsBound.push(callback.bind(null, rowNodeTransaction));
        }
        this.commitTransactions(changedRowNodes, animate);
        if (callbackFuncsBound.length > 0) setTimeout(()=>{
            for(let i = 0, len = callbackFuncsBound.length; i < len; i++)callbackFuncsBound[i]();
        }, 0);
        if (rowNodeTrans.length > 0) eventSvc.dispatchEvent({
            type: "asyncTransactionsFlushed",
            results: rowNodeTrans
        });
        this.asyncTransactionsTimer = 0;
        this.asyncTransactions = null;
    }
    /**
   * Used to apply transaction changes.
   * Called by gridApi & rowDragFeature
   */ updateRowData(rowDataTran) {
        const nodeManager = this.nodeManager;
        if (!nodeManager) return null;
        this.beans.valueCache?.onDataChanged();
        this.rowNodesCountReady = true;
        const changedRowNodes = new $437b23f6a393c3bf$export$31d871bfcf904e4b();
        const animate = !this.gos.get("suppressAnimationFrame");
        const rowNodeTransaction = nodeManager.updateRowData(rowDataTran, changedRowNodes, animate);
        this.commitTransactions(changedRowNodes, animate);
        return rowNodeTransaction;
    }
    /**
   * Common to:
   * - executeBatchUpdateRowData (batch transactions)
   * - updateRowData (single transaction)
   * - setImmutableRowData (generated transaction)
   *
   * @param rowNodeTrans - the transactions to apply
   * @param orderChanged - whether the order of the rows has changed, either via generated transaction or user provided addIndex
   */ commitTransactions(changedRowNodes, animate) {
        this.refreshModel({
            step: "group",
            rowDataUpdated: true,
            keepRenderedRows: true,
            animate: animate,
            changedRowNodes: changedRowNodes,
            changedPath: this.createChangePath(true)
        });
    }
    doRowsToDisplay() {
        const { rootNode: rootNode, beans: beans } = this;
        if (beans.formula?.active) {
            const unfilteredRows = rootNode?.childrenAfterSort ?? [];
            this.formulaRows = unfilteredRows;
            this.rowsToDisplay = unfilteredRows.filter((row)=>!row.softFiltered);
            for (const row of this.rowsToDisplay)row.setUiLevel(0);
            return;
        }
        const flattenStage = beans.flattenStage;
        if (flattenStage) {
            this.rowsToDisplay = flattenStage.execute();
            return;
        }
        const rowsToDisplay = this.rootNode.childrenAfterSort ?? [];
        for (const row of rowsToDisplay)row.setUiLevel(0);
        this.rowsToDisplay = rowsToDisplay;
    }
    onRowHeightChanged() {
        this.refreshModel({
            step: "map",
            keepRenderedRows: true,
            keepUndoRedoStack: true
        });
    }
    resetRowHeights() {
        const rootNode = this.rootNode;
        if (!rootNode) return;
        const atLeastOne = this.resetRowHeightsForAllRowNodes();
        rootNode.setRowHeight(rootNode.rowHeight, true);
        const sibling = rootNode.sibling;
        sibling?.setRowHeight(sibling.rowHeight, true);
        if (atLeastOne) this.onRowHeightChanged();
    }
    resetRowHeightsForAllRowNodes() {
        let atLeastOne = false;
        this.forEachNode((rowNode)=>{
            rowNode.setRowHeight(rowNode.rowHeight, true);
            const detailNode = rowNode.detailNode;
            detailNode?.setRowHeight(detailNode.rowHeight, true);
            const sibling = rowNode.sibling;
            sibling?.setRowHeight(sibling.rowHeight, true);
            atLeastOne = true;
        });
        return atLeastOne;
    }
    onGridStylesChanges(e) {
        if (e.rowHeightChanged && !this.beans.rowAutoHeight?.active) this.resetRowHeights();
    }
    onGridReady() {
        if (!this.started) this.setInitialData();
    }
    destroy() {
        super.destroy();
        this.nodeManager = this.destroyBean(this.nodeManager);
        this.started = false;
        this.rootNode = null;
        this.rowsToDisplay = [];
        this.asyncTransactions = null;
        this.stages = null;
        this.stagesRefreshProps.clear();
        clearTimeout(this.asyncTransactionsTimer);
    }
    /**
   * @deprecated v33.1
   */ onRowHeightChangedDebounced() {
        this.onRowHeightChanged_debounced();
    }
};
var $437b23f6a393c3bf$var$addAllLeafs = (result, node)=>{
    const childrenAfterGroup = node.childrenAfterGroup;
    if (childrenAfterGroup) for(let i = 0, len = childrenAfterGroup.length; i < len; ++i){
        const child = childrenAfterGroup[i];
        if (child.data) result.push(child);
        if (child.group) $437b23f6a393c3bf$var$addAllLeafs(result, child);
    }
};
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModelApi.ts
function $437b23f6a393c3bf$var$onGroupExpandedOrCollapsed(beans) {
    beans.expansionSvc?.onGroupExpandedOrCollapsed();
}
function $437b23f6a393c3bf$var$refreshClientSideRowModel(beans, step) {
    const clientSideRowModel = $437b23f6a393c3bf$export$f5285e6f27a03f95(beans);
    if (clientSideRowModel) {
        if (!step || step === "everything") step = "group";
        clientSideRowModel.refreshModel({
            step: step,
            keepRenderedRows: true,
            animate: !beans.gos.get("suppressAnimationFrame")
        });
    }
}
function $437b23f6a393c3bf$var$isRowDataEmpty(beans) {
    return $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.isEmpty() ?? true;
}
function $437b23f6a393c3bf$var$forEachLeafNode(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachLeafNode(callback);
}
function $437b23f6a393c3bf$var$forEachNodeAfterFilter(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachNodeAfterFilter(callback);
}
function $437b23f6a393c3bf$var$forEachNodeAfterFilterAndSort(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachNodeAfterFilterAndSort(callback);
}
function $437b23f6a393c3bf$var$applyTransaction(beans, rowDataTransaction) {
    return beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.updateRowData(rowDataTransaction));
}
function $437b23f6a393c3bf$var$applyTransactionAsync(beans, rowDataTransaction, callback) {
    beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.batchUpdateRowData(rowDataTransaction, callback));
}
function $437b23f6a393c3bf$var$flushAsyncTransactions(beans) {
    beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.flushAsyncTransactions());
}
function $437b23f6a393c3bf$var$getBestCostNodeSelection(beans) {
    return beans.selectionSvc?.getBestCostNodeSelection();
}
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModelModule.ts
var $437b23f6a393c3bf$export$4c74201d5a94c8e5 = {
    moduleName: "ClientSideRowModel",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$ClientSideRowModel,
        $437b23f6a393c3bf$var$SortStage
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$1a6625c5691649e8
    ]
};
var $437b23f6a393c3bf$export$15323dcce1401b05 = {
    moduleName: "ClientSideRowModelApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        onGroupExpandedOrCollapsed: $437b23f6a393c3bf$var$onGroupExpandedOrCollapsed,
        refreshClientSideRowModel: $437b23f6a393c3bf$var$refreshClientSideRowModel,
        isRowDataEmpty: $437b23f6a393c3bf$var$isRowDataEmpty,
        forEachLeafNode: $437b23f6a393c3bf$var$forEachLeafNode,
        forEachNodeAfterFilter: $437b23f6a393c3bf$var$forEachNodeAfterFilter,
        forEachNodeAfterFilterAndSort: $437b23f6a393c3bf$var$forEachNodeAfterFilterAndSort,
        applyTransaction: $437b23f6a393c3bf$var$applyTransaction,
        applyTransactionAsync: $437b23f6a393c3bf$var$applyTransactionAsync,
        flushAsyncTransactions: $437b23f6a393c3bf$var$flushAsyncTransactions,
        getBestCostNodeSelection: $437b23f6a393c3bf$var$getBestCostNodeSelection,
        resetRowHeights: $437b23f6a393c3bf$export$80ac5296eda53df5,
        onRowHeightChanged: $437b23f6a393c3bf$export$39ff1118beb20c8b
    },
    dependsOn: [
        $437b23f6a393c3bf$export$76fb120d9e251426,
        $437b23f6a393c3bf$export$b36e8e3b22fa08ce
    ]
};
// packages/ag-grid-community/src/export/gridSerializer.ts
var $437b23f6a393c3bf$var$GridSerializer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gridSerializer";
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.colModel = beans.colModel;
        this.rowModel = beans.rowModel;
        this.pinnedRowModel = beans.pinnedRowModel;
    }
    serialize(gridSerializingSession, params = {}) {
        const { allColumns: allColumns, columnKeys: columnKeys, skipRowGroups: skipRowGroups, exportRowNumbers: exportRowNumbers } = params;
        const columnsToExport = this.getColumnsToExport({
            allColumns: allColumns,
            skipRowGroups: skipRowGroups,
            columnKeys: columnKeys,
            exportRowNumbers: exportRowNumbers
        });
        return [
            // first pass, put in the header names of the cols
            this.prepareSession(columnsToExport),
            this.prependContent(params),
            this.exportColumnGroups(params, columnsToExport),
            this.exportHeaders(params, columnsToExport),
            this.processPinnedTopRows(params, columnsToExport),
            this.processRows(params, columnsToExport),
            this.processPinnedBottomRows(params, columnsToExport),
            this.appendContent(params)
        ].reduce((composed, f)=>f(composed), gridSerializingSession).parse();
    }
    processRow(gridSerializingSession, params, columnsToExport, node) {
        const rowSkipper = params.shouldRowBeSkipped || (()=>false);
        const isClipboardExport = params.rowPositions != null;
        const isExplicitExportSelection = isClipboardExport || !!params.onlySelected;
        const hideOpenParents = this.gos.get("groupHideOpenParents") && !isExplicitExportSelection;
        const isLeafNode = this.colModel.isPivotMode() ? node.leafGroup : !node.group;
        const isFooter = !!node.footer;
        const shouldSkipCurrentGroup = node.allChildrenCount === 1 && node.childrenAfterGroup?.length === 1 && $437b23f6a393c3bf$export$2f5892ff24cc879d(this.gos, node);
        if (!isLeafNode && !isFooter && (params.skipRowGroups || shouldSkipCurrentGroup || hideOpenParents) || params.onlySelected && !node.isSelected() || params.skipPinnedTop && node.rowPinned === "top" || params.skipPinnedBottom && node.rowPinned === "bottom" || node.stub) return;
        const nodeIsRootNode = node.level === -1;
        if (nodeIsRootNode && !isLeafNode && !isFooter) return;
        const shouldRowBeSkipped = rowSkipper($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: node
        }));
        if (shouldRowBeSkipped) return;
        const rowAccumulator = gridSerializingSession.onNewBodyRow(node);
        columnsToExport.forEach((column, index)=>{
            rowAccumulator.onColumn(column, index, node);
        });
        if (params.getCustomContentBelowRow) {
            const content = params.getCustomContentBelowRow($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                node: node
            }));
            if (content) gridSerializingSession.addCustomContent(content);
        }
    }
    appendContent(params) {
        return (gridSerializingSession)=>{
            const appendContent = params.appendContent;
            if (appendContent) gridSerializingSession.addCustomContent(appendContent);
            return gridSerializingSession;
        };
    }
    prependContent(params) {
        return (gridSerializingSession)=>{
            const prependContent = params.prependContent;
            if (prependContent) gridSerializingSession.addCustomContent(prependContent);
            return gridSerializingSession;
        };
    }
    prepareSession(columnsToExport) {
        return (gridSerializingSession)=>{
            gridSerializingSession.prepare(columnsToExport);
            return gridSerializingSession;
        };
    }
    exportColumnGroups(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnGroupHeaders) {
                const idCreator = new $437b23f6a393c3bf$export$b3b24737a74261fb();
                const { colGroupSvc: colGroupSvc } = this.beans;
                const displayedGroups = colGroupSvc ? colGroupSvc.createColumnGroups({
                    columns: columnsToExport,
                    idCreator: idCreator,
                    pinned: null,
                    isStandaloneStructure: true
                }) : columnsToExport;
                this.recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, params.processGroupHeaderCallback);
            }
            return gridSerializingSession;
        };
    }
    exportHeaders(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnHeaders) {
                const gridRowIterator = gridSerializingSession.onNewHeaderRow();
                columnsToExport.forEach((column, index)=>{
                    gridRowIterator.onColumn(column, index, void 0);
                });
            }
            return gridSerializingSession;
        };
    }
    processPinnedTopRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "top").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel?.getPinnedTopRow(position.rowIndex)).forEach(processRow);
            else if (!this.pinnedRowModel?.isManual()) this.pinnedRowModel?.forEachPinnedRow("top", processRow);
            return gridSerializingSession;
        };
    }
    processRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const rowModel = this.rowModel;
            const usingCsrm = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos, rowModel);
            const usingSsrm = $437b23f6a393c3bf$export$cf1bac0013650216(this.gos, rowModel);
            const onlySelectedNonStandardModel = !usingCsrm && params.onlySelected;
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            const { exportedRows: exportedRows = "filteredAndSorted" } = params;
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned == null).sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>rowModel.getRow(position.rowIndex)).forEach(processRow);
            else if (this.colModel.isPivotMode()) {
                if (usingCsrm) rowModel.forEachPivotNode(processRow, true, exportedRows === "filteredAndSorted");
                else if (usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else rowModel.forEachNode(processRow);
            } else if (params.onlySelectedAllPages || onlySelectedNonStandardModel) {
                const selectedNodes = this.beans.selectionSvc?.getSelectedNodes() ?? [];
                this.replicateSortedOrder(selectedNodes);
                selectedNodes.forEach(processRow);
            } else if (exportedRows === "all") rowModel.forEachNode(processRow);
            else if (usingCsrm || usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
            else rowModel.forEachNode(processRow);
            return gridSerializingSession;
        };
    }
    replicateSortedOrder(rows) {
        const { sortSvc: sortSvc, rowNodeSorter: rowNodeSorter } = this.beans;
        if (!sortSvc || !rowNodeSorter) return;
        const sortOptions = sortSvc.getSortOptions();
        const compareNodes = (rowA, rowB)=>{
            if (rowA.rowIndex != null && rowB.rowIndex != null) return rowA.rowIndex - rowB.rowIndex;
            if (rowA.level === rowB.level) {
                if (rowA.parent?.id === rowB.parent?.id) return rowNodeSorter.compareRowNodes(sortOptions, rowA, rowB) || (rowA.rowIndex ?? -1) - (rowB.rowIndex ?? -1);
                return compareNodes(rowA.parent, rowB.parent);
            }
            if (rowA.level > rowB.level) return compareNodes(rowA.parent, rowB);
            return compareNodes(rowA, rowB.parent);
        };
        rows.sort(compareNodes);
    }
    processPinnedBottomRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "bottom").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel?.getPinnedBottomRow(position.rowIndex)).forEach(processRow);
            else if (!this.pinnedRowModel?.isManual()) this.pinnedRowModel?.forEachPinnedRow("bottom", processRow);
            return gridSerializingSession;
        };
    }
    getColumnsToExport(params) {
        const { allColumns: allColumns = false, skipRowGroups: skipRowGroups = false, exportRowNumbers: exportRowNumbers = false, columnKeys: columnKeys } = params;
        const { colModel: colModel, gos: gos, visibleCols: visibleCols } = this;
        const isPivotMode = colModel.isPivotMode();
        const filterSpecialColumns = (col)=>{
            if ($437b23f6a393c3bf$export$f6074a9792015c5d(col)) return false;
            return !$437b23f6a393c3bf$export$3d3e7d751f0445eb(col) || exportRowNumbers;
        };
        if (columnKeys?.length) return colModel.getColsForKeys(columnKeys).filter(filterSpecialColumns);
        const isTreeData = gos.get("treeData");
        let columnsToExport = [];
        if (allColumns && !isPivotMode) columnsToExport = colModel.getCols();
        else columnsToExport = visibleCols.allCols;
        columnsToExport = columnsToExport.filter((column)=>filterSpecialColumns(column) && (skipRowGroups && !isTreeData ? !$437b23f6a393c3bf$export$61b34611dc010a97(column) : true));
        return columnsToExport;
    }
    recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, processGroupHeaderCallback) {
        const directChildrenHeaderGroups = [];
        for (const columnGroupChild of displayedGroups){
            const columnGroup = columnGroupChild;
            if (!columnGroup.getChildren) continue;
            for (const it of columnGroup.getChildren() ?? [])directChildrenHeaderGroups.push(it);
        }
        if (displayedGroups.length > 0 && $437b23f6a393c3bf$export$1f44a60fc23f9028(displayedGroups[0])) this.doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback);
        if (directChildrenHeaderGroups && directChildrenHeaderGroups.length > 0) this.recursivelyAddHeaderGroups(directChildrenHeaderGroups, gridSerializingSession, processGroupHeaderCallback);
    }
    doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback) {
        const gridRowIterator = gridSerializingSession.onNewHeaderGroupingRow();
        let columnIndex = 0;
        for (const columnGroupChild of displayedGroups){
            const columnGroup = columnGroupChild;
            let name;
            if (processGroupHeaderCallback) name = processGroupHeaderCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                columnGroup: columnGroup
            }));
            else name = this.beans.colNames.getDisplayNameForColumnGroup(columnGroup, "header");
            const columnsToCalculateRange = columnGroup.isExpandable() ? columnGroup.getLeafColumns() : [];
            const collapsibleGroupRanges = columnsToCalculateRange.reduce((collapsibleGroups, currentColumn, currentIdx, arr)=>{
                let lastGroup = $437b23f6a393c3bf$export$236389741107357f(collapsibleGroups);
                const groupShow = currentColumn.getColumnGroupShow() === "open";
                if (!groupShow) {
                    if (lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx - 1;
                } else if (!lastGroup || lastGroup[1] != null) {
                    lastGroup = [
                        currentIdx
                    ];
                    collapsibleGroups.push(lastGroup);
                }
                if (currentIdx === arr.length - 1 && lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx;
                return collapsibleGroups;
            }, []);
            gridRowIterator.onColumn(columnGroup, name || "", columnIndex++, columnGroup.getLeafColumns().length - 1, collapsibleGroupRanges);
        }
    }
};
// packages/ag-grid-community/src/export/exportModule.ts
var $437b23f6a393c3bf$export$e6030935e93fda2b = {
    moduleName: "SharedExport",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$GridSerializer
    ]
};
// packages/ag-grid-community/src/csvExport/csvSerializingSession.ts
var $437b23f6a393c3bf$var$LINE_SEPARATOR = "\r\n";
var $437b23f6a393c3bf$var$CsvSerializingSession = class extends $437b23f6a393c3bf$export$5018ab277b833b61 {
    constructor(config){
        super(config);
        this.config = config;
        this.isFirstLine = true;
        this.result = "";
        const { suppressQuotes: suppressQuotes, columnSeparator: columnSeparator } = config;
        this.suppressQuotes = suppressQuotes;
        this.columnSeparator = columnSeparator;
    }
    addCustomContent(content) {
        if (!content) return;
        if (typeof content === "string") {
            if (!/^\s*\n/.test(content)) this.beginNewLine();
            content = content.replace(/\r?\n/g, $437b23f6a393c3bf$var$LINE_SEPARATOR);
            this.result += content;
        } else content.forEach((row)=>{
            this.beginNewLine();
            row.forEach((cell, index)=>{
                if (index !== 0) this.result += this.columnSeparator;
                this.result += this.putInQuotes(cell.data.value || "");
                if (cell.mergeAcross) this.appendEmptyCells(cell.mergeAcross);
            });
        });
    }
    onNewHeaderGroupingRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
        };
    }
    onNewHeaderGroupingRowColumn(columnGroup, header, index, span) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(header);
        this.appendEmptyCells(span);
    }
    appendEmptyCells(count) {
        for(let i = 1; i <= count; i++)this.result += this.columnSeparator + this.putInQuotes("");
    }
    onNewHeaderRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderRowColumn.bind(this)
        };
    }
    onNewHeaderRowColumn(column, index) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(this.extractHeaderValue(column));
    }
    onNewBodyRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewBodyRowColumn.bind(this)
        };
    }
    onNewBodyRowColumn(column, index, node) {
        if (index != 0) this.result += this.columnSeparator;
        const rowCellValue = this.extractRowCellValue({
            column: column,
            node: node,
            currentColumnIndex: index,
            accumulatedRowIndex: index,
            type: "csv",
            useRawFormula: false
        });
        this.result += this.putInQuotes(rowCellValue.valueFormatted ?? rowCellValue.value);
    }
    putInQuotes(value) {
        if (this.suppressQuotes) return value;
        if (value === null || value === void 0) return '""';
        let stringValue;
        if (typeof value === "string") stringValue = value;
        else if (typeof value.toString === "function") stringValue = value.toString();
        else {
            $437b23f6a393c3bf$export$545083624300f13d(53);
            stringValue = "";
        }
        const valueEscaped = stringValue.replace(/"/g, '""');
        return '"' + valueEscaped + '"';
    }
    parse() {
        return this.result;
    }
    beginNewLine() {
        if (!this.isFirstLine) this.result += $437b23f6a393c3bf$var$LINE_SEPARATOR;
        this.isFirstLine = false;
    }
};
// packages/ag-grid-community/src/csvExport/csvCreator.ts
var $437b23f6a393c3bf$var$CsvCreator = class extends $437b23f6a393c3bf$export$b335f23c5aead909 {
    constructor(){
        super(...arguments);
        this.beanName = "csvCreator";
    }
    getMergedParams(params) {
        const baseParams5 = this.gos.get("defaultCsvExportParams");
        return Object.assign({}, baseParams5, params);
    }
    export(userParams) {
        if (this.isExportSuppressed()) {
            $437b23f6a393c3bf$export$545083624300f13d(51);
            return;
        }
        const exportFunc = ()=>{
            const mergedParams = this.getMergedParams(userParams);
            const data = this.getData(mergedParams);
            const packagedFile = new Blob([
                "\uFEFF",
                data
            ], {
                type: "text/plain"
            });
            const fileNameParams = mergedParams.fileName;
            const fileName = typeof fileNameParams === "function" ? fileNameParams($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {})) : fileNameParams;
            $437b23f6a393c3bf$export$97aef6bcdc3f7ef5(this.getFileName(fileName), packagedFile);
        };
        const { overlays: overlays } = this.beans;
        if (overlays) overlays.showExportOverlay(exportFunc);
        else exportFunc();
    }
    exportDataAsCsv(params) {
        this.export(params);
    }
    getDataAsCsv(params, skipDefaultParams = false) {
        const mergedParams = skipDefaultParams ? Object.assign({}, params) : this.getMergedParams(params);
        return this.getData(mergedParams);
    }
    getDefaultFileExtension() {
        return "csv";
    }
    createSerializingSession(params) {
        const { colModel: colModel, colNames: colNames, rowGroupColsSvc: rowGroupColsSvc, valueSvc: valueSvc, gos: gos } = this.beans;
        const { processCellCallback: processCellCallback, processHeaderCallback: processHeaderCallback, processGroupHeaderCallback: processGroupHeaderCallback, processRowGroupCallback: processRowGroupCallback, suppressQuotes: suppressQuotes, columnSeparator: columnSeparator } = params;
        return new $437b23f6a393c3bf$var$CsvSerializingSession({
            colModel: colModel,
            colNames: colNames,
            valueSvc: valueSvc,
            gos: gos,
            processCellCallback: processCellCallback || void 0,
            processHeaderCallback: processHeaderCallback || void 0,
            processGroupHeaderCallback: processGroupHeaderCallback || void 0,
            processRowGroupCallback: processRowGroupCallback || void 0,
            suppressQuotes: suppressQuotes || false,
            columnSeparator: columnSeparator || ",",
            rowGroupColsSvc: rowGroupColsSvc
        });
    }
    isExportSuppressed() {
        return this.gos.get("suppressCsvExport");
    }
};
// packages/ag-grid-community/src/csvExport/csvExportApi.ts
function $437b23f6a393c3bf$var$getDataAsCsv(beans, params) {
    return beans.csvCreator?.getDataAsCsv(params);
}
function $437b23f6a393c3bf$var$exportDataAsCsv(beans, params) {
    beans.csvCreator?.exportDataAsCsv(params);
}
// packages/ag-grid-community/src/csvExport/csvExportModule.ts
var $437b23f6a393c3bf$export$f744275d8b795fc2 = {
    moduleName: "CsvExport",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CsvCreator
    ],
    apiFunctions: {
        getDataAsCsv: $437b23f6a393c3bf$var$getDataAsCsv,
        exportDataAsCsv: $437b23f6a393c3bf$var$exportDataAsCsv
    },
    dependsOn: [
        $437b23f6a393c3bf$export$e6030935e93fda2b
    ]
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteBlock.ts
var $437b23f6a393c3bf$var$InfiniteBlock = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(id, parentCache, params){
        super();
        this.id = id;
        this.parentCache = parentCache;
        this.params = params;
        this.state = "needsLoading";
        this.version = 0;
        this.startRow = id * params.blockSize;
        this.endRow = this.startRow + params.blockSize;
    }
    load() {
        this.state = "loading";
        this.loadFromDatasource();
    }
    setStateWaitingToLoad() {
        this.version++;
        this.state = "needsLoading";
    }
    pageLoadFailed(version) {
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) this.state = "failed";
        this.dispatchLocalEvent({
            type: "loadComplete"
        });
    }
    pageLoaded(version, rows, lastRow) {
        this.successCommon(version, {
            rowData: rows,
            rowCount: lastRow
        });
    }
    isRequestMostRecentAndLive(version) {
        const thisIsMostRecentRequest = version === this.version;
        const weAreNotDestroyed = this.isAlive();
        return thisIsMostRecentRequest && weAreNotDestroyed;
    }
    successCommon(version, params) {
        this.dispatchLocalEvent({
            type: "loadComplete"
        });
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) {
            this.state = "loaded";
            this.processServerResult(params);
        }
    }
    postConstruct() {
        this.rowNodes = [];
        const { params: { blockSize: blockSize, rowHeight: rowHeight }, startRow: startRow, beans: beans, rowNodes: rowNodes } = this;
        for(let i = 0; i < blockSize; i++){
            const rowIndex = startRow + i;
            const rowNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
            rowNode.setRowHeight(rowHeight);
            rowNode.uiLevel = 0;
            rowNode.setRowIndex(rowIndex);
            rowNode.setRowTop(rowHeight * rowIndex);
            rowNodes.push(rowNode);
        }
    }
    getBlockStateJson() {
        const { id: id, startRow: startRow, endRow: endRow, state: pageStatus } = this;
        return {
            id: "" + id,
            state: {
                blockNumber: id,
                startRow: startRow,
                endRow: endRow,
                pageStatus: pageStatus
            }
        };
    }
    setDataAndId(rowNode, data, index) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(data)) rowNode.setDataAndId(data, index.toString());
        else rowNode.setDataAndId(void 0, void 0);
    }
    loadFromDatasource() {
        const params = this.createLoadParams();
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.params.datasource.getRows)) {
            $437b23f6a393c3bf$export$545083624300f13d(90);
            return;
        }
        window.setTimeout(()=>{
            this.params.datasource.getRows(params);
        }, 0);
    }
    createLoadParams() {
        const { startRow: startRow, endRow: endRow, version: version, params: { sortModel: sortModel, filterModel: filterModel }, gos: gos } = this;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            startRow: startRow,
            endRow: endRow,
            successCallback: this.pageLoaded.bind(this, version),
            failCallback: this.pageLoadFailed.bind(this, version),
            sortModel: sortModel,
            filterModel: filterModel
        });
        return params;
    }
    forEachNode(callback, sequence, rowCount) {
        this.rowNodes.forEach((rowNode, index)=>{
            const rowIndex = this.startRow + index;
            if (rowIndex < rowCount) callback(rowNode, sequence.value++);
        });
    }
    getRow(rowIndex, dontTouchLastAccessed = false) {
        if (!dontTouchLastAccessed) this.lastAccessed = this.params.lastAccessedSequence.value++;
        const localIndex = rowIndex - this.startRow;
        return this.rowNodes[localIndex];
    }
    processServerResult(params) {
        const { rowNodes: rowNodes, beans: beans } = this;
        rowNodes.forEach((rowNode, index)=>{
            const data = params.rowData ? params.rowData[index] : void 0;
            if (!rowNode.id && rowNode.alreadyRendered && data) {
                rowNodes[index] = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
                rowNodes[index].setRowIndex(rowNode.rowIndex);
                rowNodes[index].setRowTop(rowNode.rowTop);
                rowNodes[index].setRowHeight(rowNode.rowHeight);
                rowNode._destroy(true);
            }
            this.setDataAndId(rowNodes[index], data, this.startRow + index);
        });
        const finalRowCount = params.rowCount != null && params.rowCount >= 0 ? params.rowCount : void 0;
        this.parentCache.pageLoaded(this, finalRowCount);
    }
    destroy() {
        const rowNodes = this.rowNodes;
        for(let i = 0, len = rowNodes.length; i < len; i++)rowNodes[i]._destroy(false);
        rowNodes.length = 0;
        super.destroy();
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteCache.ts
var $437b23f6a393c3bf$var$MAX_EMPTY_BLOCKS_TO_KEEP = 2;
var $437b23f6a393c3bf$var$InfiniteCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.params = params;
        this.lastRowIndexKnown = false;
        this.blocks = {};
        this.blockCount = 0;
        this.rowCount = params.initialRowCount;
    }
    // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
    // it will want new pages in the cache as it asks for rows. only when we are inserting /
    // removing rows via the api is dontCreatePage set, where we move rows between the pages.
    getRow(rowIndex, dontCreatePage = false) {
        const blockId = Math.floor(rowIndex / this.params.blockSize);
        let block = this.blocks[blockId];
        if (!block) {
            if (dontCreatePage) return void 0;
            block = this.createBlock(blockId);
        }
        return block.getRow(rowIndex);
    }
    createBlock(blockNumber) {
        const params = this.params;
        const newBlock = this.createBean(new $437b23f6a393c3bf$var$InfiniteBlock(blockNumber, this, params));
        this.blocks[newBlock.id] = newBlock;
        this.blockCount++;
        this.purgeBlocksIfNeeded(newBlock);
        params.rowNodeBlockLoader.addBlock(newBlock);
        return newBlock;
    }
    // we have this on infinite row model only, not server side row model,
    // because for server side, it would leave the children in inconsistent
    // state - eg if a node had children, but after the refresh it had data
    // for a different row, then the children would be with the wrong row node.
    refreshCache() {
        const nothingToRefresh = this.blockCount == 0;
        if (nothingToRefresh) {
            this.purgeCache();
            return;
        }
        for (const block of this.getBlocksInOrder())block.setStateWaitingToLoad();
        this.params.rowNodeBlockLoader.checkBlockToLoad();
    }
    destroy() {
        for (const block of this.getBlocksInOrder())this.destroyBlock(block);
        super.destroy();
    }
    getRowCount() {
        return this.rowCount;
    }
    isLastRowIndexKnown() {
        return this.lastRowIndexKnown;
    }
    // block calls this, when page loaded
    pageLoaded(block, lastRow) {
        if (!this.isAlive()) return;
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `InfiniteCache - onPageLoaded: page = ${block.id}, lastRow = ${lastRow}`);
        this.checkRowCount(block, lastRow);
        this.onCacheUpdated();
    }
    purgeBlocksIfNeeded(blockToExclude) {
        const blocksForPurging = this.getBlocksInOrder().filter((b)=>b != blockToExclude);
        const lastAccessedComparator = (a, b)=>b.lastAccessed - a.lastAccessed;
        blocksForPurging.sort(lastAccessedComparator);
        const maxBlocksProvided = this.params.maxBlocksInCache > 0;
        const blocksToKeep = maxBlocksProvided ? this.params.maxBlocksInCache - 1 : null;
        const emptyBlocksToKeep = $437b23f6a393c3bf$var$MAX_EMPTY_BLOCKS_TO_KEEP - 1;
        blocksForPurging.forEach((block, index)=>{
            const purgeBecauseBlockEmpty = block.state === "needsLoading" && index >= emptyBlocksToKeep;
            const purgeBecauseCacheFull = maxBlocksProvided ? index >= blocksToKeep : false;
            if (purgeBecauseBlockEmpty || purgeBecauseCacheFull) {
                if (this.isBlockCurrentlyDisplayed(block)) return;
                if (this.isBlockFocused(block)) return;
                this.removeBlockFromCache(block);
            }
        });
    }
    isBlockFocused(block) {
        const focusedCell = this.beans.focusSvc.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const { startRow: startRow, endRow: endRow } = block;
        const hasFocus = focusedCell.rowIndex >= startRow && focusedCell.rowIndex < endRow;
        return hasFocus;
    }
    isBlockCurrentlyDisplayed(block) {
        const { startRow: startRow, endRow: endRow } = block;
        return this.beans.rowRenderer.isRangeInRenderedViewport(startRow, endRow - 1);
    }
    removeBlockFromCache(blockToRemove) {
        if (!blockToRemove) return;
        this.destroyBlock(blockToRemove);
    }
    checkRowCount(block, lastRow) {
        if (typeof lastRow === "number" && lastRow >= 0) {
            this.rowCount = lastRow;
            this.lastRowIndexKnown = true;
        } else if (!this.lastRowIndexKnown) {
            const { blockSize: blockSize, overflowSize: overflowSize } = this.params;
            const lastRowIndex = (block.id + 1) * blockSize;
            const lastRowIndexPlusOverflow = lastRowIndex + overflowSize;
            if (this.rowCount < lastRowIndexPlusOverflow) this.rowCount = lastRowIndexPlusOverflow;
        }
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        this.rowCount = rowCount;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(lastRowIndexKnown)) this.lastRowIndexKnown = lastRowIndexKnown;
        if (!this.lastRowIndexKnown) {
            if (this.rowCount % this.params.blockSize === 0) this.rowCount++;
        }
        this.onCacheUpdated();
    }
    forEachNodeDeep(callback) {
        const sequence = {
            value: 0
        };
        for (const block of this.getBlocksInOrder())block.forEachNode(callback, sequence, this.rowCount);
    }
    getBlocksInOrder() {
        const blockComparator = (a, b)=>a.id - b.id;
        const blocks = Object.values(this.blocks).sort(blockComparator);
        return blocks;
    }
    destroyBlock(block) {
        delete this.blocks[block.id];
        this.destroyBean(block);
        this.blockCount--;
        this.params.rowNodeBlockLoader.removeBlock(block);
    }
    // gets called 1) row count changed 2) cache purged 3) items inserted
    onCacheUpdated() {
        if (this.isAlive()) {
            this.destroyAllBlocksPastVirtualRowCount();
            this.eventSvc.dispatchEvent({
                type: "storeUpdated"
            });
        }
    }
    destroyAllBlocksPastVirtualRowCount() {
        const blocksToDestroy = [];
        for (const block of this.getBlocksInOrder()){
            const startRow = block.id * this.params.blockSize;
            if (startRow >= this.rowCount) blocksToDestroy.push(block);
        }
        if (blocksToDestroy.length > 0) for (const block of blocksToDestroy)this.destroyBlock(block);
    }
    purgeCache() {
        for (const block of this.getBlocksInOrder())this.removeBlockFromCache(block);
        this.lastRowIndexKnown = false;
        if (this.rowCount === 0) this.rowCount = this.params.initialRowCount;
        this.onCacheUpdated();
    }
    getRowNodesInRange(firstInRange, lastInRange) {
        const result = [];
        let lastBlockId = -1;
        let inActiveRange = false;
        const numberSequence = {
            value: 0
        };
        let foundGapInSelection = false;
        for (const block of this.getBlocksInOrder()){
            if (foundGapInSelection) continue;
            if (inActiveRange && lastBlockId + 1 !== block.id) {
                foundGapInSelection = true;
                continue;
            }
            lastBlockId = block.id;
            block.forEachNode((rowNode)=>{
                const hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
                if (inActiveRange || hitFirstOrLast) result.push(rowNode);
                if (hitFirstOrLast) inActiveRange = !inActiveRange;
            }, numberSequence, this.rowCount);
        }
        const invalidRange = foundGapInSelection || inActiveRange;
        return invalidRange ? [] : result;
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModel.ts
var $437b23f6a393c3bf$var$InfiniteRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
        /** Dummy root node */ this.rootNode = null;
    }
    getRowBounds(index) {
        return {
            rowHeight: this.rowHeight,
            rowTop: this.rowHeight * index
        };
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid() {
        return false;
    }
    postConstruct() {
        if (this.gos.get("rowModelType") !== "infinite") return;
        const beans = this.beans;
        const rootNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
        this.rootNode = rootNode;
        rootNode.level = -1;
        this.rowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(beans);
        this.addEventListeners();
        this.addDestroyFunc(()=>this.destroyCache());
    }
    start() {
        this.setDatasource(this.gos.get("datasource"));
    }
    destroy() {
        this.destroyDatasource();
        super.destroy();
        this.rootNode = null;
    }
    destroyDatasource() {
        if (this.datasource) {
            this.destroyBean(this.datasource);
            this.beans.rowRenderer.datasourceChanged();
            this.datasource = null;
        }
    }
    addEventListeners() {
        this.addManagedEventListeners({
            filterChanged: this.reset.bind(this),
            sortChanged: this.reset.bind(this),
            newColumnsLoaded: this.onColumnEverything.bind(this),
            storeUpdated: this.dispatchModelUpdatedEvent.bind(this)
        });
        this.addManagedPropertyListener("datasource", ()=>this.setDatasource(this.gos.get("datasource")));
        this.addManagedPropertyListener("cacheBlockSize", ()=>this.resetCache());
        this.addManagedPropertyListener("rowHeight", ()=>{
            this.rowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
            this.cacheParams.rowHeight = this.rowHeight;
            this.updateRowHeights();
        });
    }
    onColumnEverything() {
        let resetRequired;
        if (this.cacheParams) resetRequired = !$437b23f6a393c3bf$export$dbc2068cc90f5875(this.cacheParams.sortModel, this.beans.sortSvc?.getSortModel() ?? []);
        else resetRequired = true;
        if (resetRequired) this.reset();
    }
    getType() {
        return "infinite";
    }
    setDatasource(datasource) {
        this.destroyDatasource();
        this.datasource = datasource;
        if (datasource) this.reset();
    }
    isEmpty() {
        return !this.infiniteCache;
    }
    isRowsToRender() {
        return !!this.infiniteCache;
    }
    getOverlayType() {
        const cache = this.infiniteCache;
        if (cache?.getRowCount() === 0) return this.beans.filterManager?.isAnyFilterPresent() ? "noMatchingRows" : "noRows";
        return null;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        return this.infiniteCache?.getRowNodesInRange(firstInRange, lastInRange) ?? [];
    }
    reset() {
        if (!this.datasource) return;
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const userGeneratingIds = getRowIdFunc != null;
        if (!userGeneratingIds) this.beans.selectionSvc?.reset("rowDataChanged");
        this.resetCache();
    }
    dispatchModelUpdatedEvent() {
        this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            // not sure if these should all be false - noticed if after implementing,
            // maybe they should be true?
            newPage: false,
            newPageSize: false,
            newData: false,
            keepRenderedRows: true,
            animate: false
        });
    }
    resetCache() {
        this.destroyCache();
        const beans = this.beans;
        const { filterManager: filterManager, sortSvc: sortSvc, rowNodeBlockLoader: rowNodeBlockLoader, eventSvc: eventSvc, gos: gos } = beans;
        this.cacheParams = {
            // the user provided datasource
            datasource: this.datasource,
            // sort and filter model
            filterModel: filterManager?.getFilterModel() ?? {},
            sortModel: sortSvc?.getSortModel() ?? [],
            rowNodeBlockLoader: rowNodeBlockLoader,
            // properties - this way we take a snapshot of them, so if user changes any, they will be
            // used next time we create a new cache, which is generally after a filter or sort change,
            // or a new datasource is set
            initialRowCount: gos.get("infiniteInitialRowCount"),
            maxBlocksInCache: gos.get("maxBlocksInCache"),
            rowHeight: $437b23f6a393c3bf$export$8966875adec41e5b(beans),
            // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
            // the current page and request first row of next page
            overflowSize: gos.get("cacheOverflowSize"),
            // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
            // server for one page at a time. so the default if not specified is 100.
            blockSize: gos.get("cacheBlockSize"),
            // the cache could create this, however it is also used by the pages, so handy to create it
            // here as the settings are also passed to the pages
            lastAccessedSequence: {
                value: 0
            }
        };
        this.infiniteCache = this.createBean(new $437b23f6a393c3bf$var$InfiniteCache(this.cacheParams));
        eventSvc.dispatchEventOnce({
            type: "rowCountReady"
        });
        this.dispatchModelUpdatedEvent();
    }
    updateRowHeights() {
        this.forEachNode((node)=>{
            node.setRowHeight(this.rowHeight);
            node.setRowTop(this.rowHeight * node.rowIndex);
        });
        this.dispatchModelUpdatedEvent();
    }
    destroyCache() {
        this.infiniteCache = this.destroyBean(this.infiniteCache);
    }
    getRow(rowIndex) {
        const infiniteCache = this.infiniteCache;
        if (!infiniteCache) return void 0;
        if (rowIndex >= infiniteCache.getRowCount()) return void 0;
        return infiniteCache.getRow(rowIndex);
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
        });
        return result;
    }
    forEachNode(callback) {
        this.infiniteCache?.forEachNodeDeep(callback);
    }
    getTopLevelRowCount() {
        return this.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        return topLevelIndex;
    }
    getRowIndexAtPixel(pixel) {
        if (this.rowHeight !== 0) {
            const rowIndexForPixel = Math.floor(pixel / this.rowHeight);
            const lastRowIndex = this.getRowCount() - 1;
            if (rowIndexForPixel > lastRowIndex) return lastRowIndex;
            return rowIndexForPixel;
        }
        return 0;
    }
    getRowCount() {
        return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
    }
    isRowPresent(rowNode) {
        return !!this.getRowNode(rowNode.id);
    }
    refreshCache() {
        this.infiniteCache?.refreshCache();
    }
    purgeCache() {
        this.infiniteCache?.purgeCache();
    }
    // for iRowModel
    isLastRowIndexKnown() {
        return this.infiniteCache?.isLastRowIndexKnown() ?? false;
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        this.infiniteCache?.setRowCount(rowCount, lastRowIndexKnown);
    }
    resetRowHeights() {}
    onRowHeightChanged() {}
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModelApi.ts
function $437b23f6a393c3bf$var$refreshInfiniteCache(beans) {
    $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.refreshCache();
}
function $437b23f6a393c3bf$var$purgeInfiniteCache(beans) {
    $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.purgeCache();
}
function $437b23f6a393c3bf$var$getInfiniteRowCount(beans) {
    return $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.getRowCount();
}
// packages/ag-grid-community/src/infiniteRowModel/rowNodeBlockLoader.ts
var $437b23f6a393c3bf$var$RowNodeBlockLoader = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowNodeBlockLoader";
        this.activeBlockLoadsCount = 0;
        this.blocks = [];
        this.active = true;
    }
    postConstruct() {
        this.maxConcurrentRequests = $437b23f6a393c3bf$export$efae4c751fa7cc4d(this.gos);
        const blockLoadDebounceMillis = this.gos.get("blockLoadDebounceMillis");
        if (blockLoadDebounceMillis && blockLoadDebounceMillis > 0) this.checkBlockToLoadDebounce = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.performCheckBlocksToLoad.bind(this), blockLoadDebounceMillis);
    }
    addBlock(block) {
        this.blocks.push(block);
        block.addEventListener("loadComplete", this.loadComplete.bind(this));
        this.checkBlockToLoad();
    }
    removeBlock(block) {
        $437b23f6a393c3bf$export$83a881c8b5120679(this.blocks, block);
    }
    destroy() {
        super.destroy();
        this.active = false;
    }
    loadComplete() {
        this.activeBlockLoadsCount--;
        this.checkBlockToLoad();
    }
    checkBlockToLoad() {
        if (this.checkBlockToLoadDebounce) this.checkBlockToLoadDebounce();
        else this.performCheckBlocksToLoad();
    }
    performCheckBlocksToLoad() {
        if (!this.active) return;
        this.printCacheStatus();
        if (this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
            $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowNodeBlockLoader - checkBlockToLoad: max loads exceeded`);
            return;
        }
        const loadAvailability = this.maxConcurrentRequests != null ? this.maxConcurrentRequests - this.activeBlockLoadsCount : 1;
        const blocksToLoad = this.blocks.filter((block)=>block.state === "needsLoading").slice(0, loadAvailability);
        this.activeBlockLoadsCount += blocksToLoad.length;
        for (const block of blocksToLoad)block.load();
        this.printCacheStatus();
    }
    getBlockState() {
        const result = {};
        this.blocks.forEach((block)=>{
            const { id: id, state: state } = block.getBlockStateJson();
            result[id] = state;
        });
        return result;
    }
    printCacheStatus() {
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowNodeBlockLoader - printCacheStatus: activePageLoadsCount = ${this.activeBlockLoadsCount}, blocks = ${JSON.stringify(this.getBlockState())}`);
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModelModule.ts
var $437b23f6a393c3bf$var$InfiniteRowModelCoreModule = {
    moduleName: "InfiniteRowModelCore",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "infinite"
    ],
    beans: [
        $437b23f6a393c3bf$var$InfiniteRowModel,
        $437b23f6a393c3bf$var$RowNodeBlockLoader
    ]
};
var $437b23f6a393c3bf$export$ca8341149bdd39bc = {
    moduleName: "InfiniteRowModel",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        refreshInfiniteCache: $437b23f6a393c3bf$var$refreshInfiniteCache,
        purgeInfiniteCache: $437b23f6a393c3bf$var$purgeInfiniteCache,
        getInfiniteRowCount: $437b23f6a393c3bf$var$getInfiniteRowCount
    },
    dependsOn: [
        $437b23f6a393c3bf$var$InfiniteRowModelCoreModule,
        $437b23f6a393c3bf$export$2f6740e35dedc261
    ]
};
// packages/ag-grid-community/src/rendering/cellRenderers/animateShowChangeCellRenderer.ts
var $437b23f6a393c3bf$var$ARROW_UP = "\u2191";
var $437b23f6a393c3bf$var$ARROW_DOWN = "\u2193";
var $437b23f6a393c3bf$var$AnimateShowChangeCellRendererElement = {
    tag: "span",
    children: [
        {
            tag: "span",
            ref: "eDelta",
            cls: "ag-value-change-delta"
        },
        {
            tag: "span",
            ref: "eValue",
            cls: "ag-value-change-value"
        }
    ]
};
var $437b23f6a393c3bf$var$AnimateShowChangeCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$AnimateShowChangeCellRendererElement);
        this.eValue = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDelta = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.refreshCount = 0;
    }
    init(params) {
        this.refresh(params, true);
    }
    showDelta(params, delta) {
        const absDelta = Math.abs(delta);
        const valueFormatted = params.formatValue(absDelta);
        const valueToUse = $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : absDelta;
        const deltaUp = delta >= 0;
        const eDelta = this.eDelta;
        if (deltaUp) eDelta.textContent = $437b23f6a393c3bf$var$ARROW_UP + valueToUse;
        else eDelta.textContent = $437b23f6a393c3bf$var$ARROW_DOWN + valueToUse;
        eDelta.classList.toggle("ag-value-change-delta-up", deltaUp);
        eDelta.classList.toggle("ag-value-change-delta-down", !deltaUp);
    }
    setTimerToRemoveDelta() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        this.beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy === this.refreshCount) this.hideDeltaValue();
            }, 2e3);
        });
    }
    hideDeltaValue() {
        this.eValue.classList.remove("ag-value-change-value-highlight");
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.eDelta);
    }
    refresh(params, isInitialRender = false) {
        const { value: value, valueFormatted: valueFormatted } = params;
        const { eValue: eValue, lastValue: lastValue, beans: beans } = this;
        if (value === lastValue) return false;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted)) eValue.textContent = valueFormatted;
        else if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) eValue.textContent = value;
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eValue);
        if (beans.filterManager?.isSuppressFlashingCellsBecauseFiltering()) return false;
        const numericValue = value && typeof value === "object" && "toNumber" in value ? value.toNumber() : value;
        const numericLastValue = lastValue && typeof lastValue === "object" && "toNumber" in lastValue ? lastValue.toNumber() : lastValue;
        if (numericValue === numericLastValue) return false;
        if (typeof numericValue === "number" && typeof numericLastValue === "number") {
            const delta = numericValue - numericLastValue;
            this.showDelta(params, delta);
        }
        if (lastValue) eValue.classList.add("ag-value-change-value-highlight");
        if (!isInitialRender) this.setTimerToRemoveDelta();
        this.lastValue = value;
        return true;
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/animateSlideCellRenderer.css-GENERATED.ts
var $437b23f6a393c3bf$var$animateSlideCellRendererCSS = /*css*/ `.ag-value-slide-out{opacity:1}:where(.ag-ltr) .ag-value-slide-out{margin-right:5px;transition:opacity 3s,margin-right 3s}:where(.ag-rtl) .ag-value-slide-out{margin-left:5px;transition:opacity 3s,margin-left 3s}:where(.ag-ltr,.ag-rtl) .ag-value-slide-out{transition-timing-function:linear}.ag-value-slide-out-end{opacity:0}:where(.ag-ltr) .ag-value-slide-out-end{margin-right:10px}:where(.ag-rtl) .ag-value-slide-out-end{margin-left:10px}`;
// packages/ag-grid-community/src/rendering/cellRenderers/animateSlideCellRenderer.ts
var $437b23f6a393c3bf$var$AnimateSlideCellRendererElement = {
    tag: "span",
    children: [
        {
            tag: "span",
            ref: "eCurrent",
            cls: "ag-value-slide-current"
        }
    ]
};
var $437b23f6a393c3bf$var$AnimateSlideCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$AnimateSlideCellRendererElement);
        this.eCurrent = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.refreshCount = 0;
        this.registerCSS($437b23f6a393c3bf$var$animateSlideCellRendererCSS);
    }
    init(params) {
        this.refresh(params, true);
    }
    addSlideAnimation() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        this.ePrevious?.remove();
        const { beans: beans, eCurrent: eCurrent } = this;
        const prevElement = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "span",
            cls: "ag-value-slide-previous ag-value-slide-out"
        });
        this.ePrevious = prevElement;
        prevElement.textContent = eCurrent.textContent;
        this.getGui().insertBefore(prevElement, eCurrent);
        beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.ePrevious.classList.add("ag-value-slide-out-end");
            }, 50);
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.ePrevious?.remove();
                this.ePrevious = null;
            }, 3e3);
        });
    }
    refresh(params, isInitialRender = false) {
        let value = params.value;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(value)) value = "";
        if (value === this.lastValue) return false;
        if (this.beans.filterManager?.isSuppressFlashingCellsBecauseFiltering()) return false;
        if (!isInitialRender) this.addSlideAnimation();
        this.lastValue = value;
        const eCurrent = this.eCurrent;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(params.valueFormatted)) eCurrent.textContent = params.valueFormatted;
        else if ($437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) eCurrent.textContent = value;
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eCurrent);
        return true;
    }
};
// packages/ag-grid-community/src/rendering/cell/cellFlashService.ts
var $437b23f6a393c3bf$var$CellFlashService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellFlashSvc";
        this.nextAnimationTime = null;
        this.nextAnimationCycle = null;
        this.animations = {
            highlight: /* @__PURE__ */ new Map(),
            "data-changed": /* @__PURE__ */ new Map()
        };
    }
    animateCell(cellCtrl, cssName, flashDuration = this.beans.gos.get("cellFlashDuration"), fadeDuration = this.beans.gos.get("cellFadeDuration")) {
        const animations = this.animations[cssName];
        animations.delete(cellCtrl);
        const time = Date.now();
        const flashEndTime = time + flashDuration;
        const fadeEndTime = time + flashDuration + fadeDuration;
        const animState = {
            phase: "flash",
            flashEndTime: flashEndTime,
            fadeEndTime: fadeEndTime
        };
        animations.set(cellCtrl, animState);
        const cssBase = `ag-cell-${cssName}`;
        const cssAnimation = `${cssBase}-animation`;
        const { comp: comp, eGui: { style: style } } = cellCtrl;
        comp.toggleCss(cssBase, true);
        comp.toggleCss(cssAnimation, false);
        style.removeProperty("transition");
        style.removeProperty("transition-delay");
        if (this.nextAnimationTime && flashEndTime + 15 < this.nextAnimationTime) {
            clearTimeout(this.nextAnimationCycle);
            this.nextAnimationCycle = null;
            this.nextAnimationTime = null;
        }
        if (!this.nextAnimationCycle) {
            this.beans.frameworkOverrides.wrapIncoming(()=>{
                this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), flashDuration);
            });
            this.nextAnimationTime = flashEndTime;
        }
    }
    advanceAnimations() {
        const time = Date.now();
        let nextAnimationTime = null;
        for (const cssName of Object.keys(this.animations)){
            const animations = this.animations[cssName];
            const cssBase = `ag-cell-${cssName}`;
            const cssAnimation = `${cssBase}-animation`;
            for (const [cell, animState] of animations){
                if (!cell.isAlive() || !cell.comp) {
                    animations.delete(cell);
                    continue;
                }
                const { phase: phase, flashEndTime: flashEndTime, fadeEndTime: fadeEndTime } = animState;
                const nextActionableTime = phase === "flash" ? flashEndTime : fadeEndTime;
                const requiresAction = time + 15 >= nextActionableTime;
                if (!requiresAction) {
                    nextAnimationTime = Math.min(nextActionableTime, nextAnimationTime ?? Infinity);
                    continue;
                }
                const { comp: comp, eGui: { style: style } } = cell;
                switch(phase){
                    case "flash":
                        comp.toggleCss(cssBase, false);
                        comp.toggleCss(cssAnimation, true);
                        style.transition = `background-color ${fadeEndTime - flashEndTime}ms`;
                        style.transitionDelay = `${flashEndTime - time}ms`;
                        nextAnimationTime = Math.min(fadeEndTime, nextAnimationTime ?? Infinity);
                        animState.phase = "fade";
                        break;
                    case "fade":
                        comp.toggleCss(cssBase, false);
                        comp.toggleCss(cssAnimation, false);
                        style.removeProperty("transition");
                        style.removeProperty("transition-delay");
                        animations.delete(cell);
                        break;
                }
            }
        }
        if (nextAnimationTime == null) {
            this.nextAnimationTime = null;
            this.nextAnimationCycle = null;
        } else if (nextAnimationTime) {
            this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), nextAnimationTime - time);
            this.nextAnimationTime = nextAnimationTime;
        }
    }
    onFlashCells(cellCtrl, event) {
        if (!cellCtrl.comp) return;
        const cellId = $437b23f6a393c3bf$export$c0c5a5ba9327269f(cellCtrl.cellPosition);
        const shouldFlash = event.cells[cellId];
        if (shouldFlash) this.animateCell(cellCtrl, "highlight");
    }
    flashCell(cellCtrl, delays) {
        this.animateCell(cellCtrl, "data-changed", delays?.flashDuration, delays?.fadeDuration);
    }
    destroy() {
        for (const cssName of Object.keys(this.animations)){
            const animations = this.animations[cssName];
            animations.clear();
        }
    }
};
// packages/ag-grid-community/src/rendering/cell/highlightChangesApi.ts
function $437b23f6a393c3bf$var$flashCells(beans, params = {}) {
    const { cellFlashSvc: cellFlashSvc } = beans;
    if (!cellFlashSvc) return;
    beans.frameworkOverrides.wrapIncoming(()=>{
        for (const cellCtrl of beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns))cellFlashSvc.flashCell(cellCtrl, params);
    });
}
// packages/ag-grid-community/src/rendering/cell/highlightChangesModule.ts
var $437b23f6a393c3bf$export$98e8472b11750a07 = {
    moduleName: "HighlightChanges",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CellFlashService
    ],
    userComponents: {
        agAnimateShowChangeCellRenderer: $437b23f6a393c3bf$var$AnimateShowChangeCellRenderer,
        agAnimateSlideCellRenderer: $437b23f6a393c3bf$var$AnimateSlideCellRenderer
    },
    apiFunctions: {
        flashCells: $437b23f6a393c3bf$var$flashCells
    }
};
// packages/ag-grid-community/src/misc/state/stateApi.ts
function $437b23f6a393c3bf$var$getState(beans) {
    return beans.stateSvc?.getState() ?? {};
}
function $437b23f6a393c3bf$var$setState(beans, state, propertiesToIgnore) {
    return beans.stateSvc?.setState(state, propertiesToIgnore);
}
// packages/ag-grid-community/src/misc/state/stateModelMigration.ts
function $437b23f6a393c3bf$var$migrateGridStateModel(state) {
    state = {
        ...state
    };
    if (!state.version) state.version = "32.1.0";
    if (state.version === "32.1.0") state = $437b23f6a393c3bf$var$migrateV32_1(state);
    state.version = $437b23f6a393c3bf$var$VERSION;
    return state;
}
function $437b23f6a393c3bf$var$migrateV32_1(state) {
    state.cellSelection = $437b23f6a393c3bf$var$jsonGet(state, "rangeSelection");
    return state;
}
function $437b23f6a393c3bf$var$jsonGet(json, key) {
    if (json && typeof json === "object") return json[key];
}
// packages/ag-grid-community/src/misc/state/stateService.ts
var $437b23f6a393c3bf$var$StateService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "stateSvc";
        this.updateRowGroupExpansionStateTimer = 0;
        this.suppressEvents = true;
        this.queuedUpdateSources = /* @__PURE__ */ new Set();
        this.dispatchStateUpdateEventDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.dispatchQueuedStateUpdateEvents(), 0);
        // If user is doing a manual expand all node by node, we don't want to process one at a time.
        // EVENT_ROW_GROUP_OPENED is already async, so no impact of making the state async here.
        this.onRowGroupOpenedDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>{
            if (this.beans.gos.get("ssrmExpandAllAffectsAllRows")) {
                this.updateCachedState("ssrmRowGroupExpansion", this.getRowGroupExpansionState());
                this.updateCachedState("rowGroupExpansion", void 0);
            } else {
                this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
                this.updateCachedState("ssrmRowGroupExpansion", void 0);
            }
        }, 0);
        // similar to row expansion, want to debounce. However, selection is synchronous, so need to mark as stale in case `getState` is called.
        this.onRowSelectedDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>{
            this.staleStateKeys.delete("rowSelection");
            this.updateCachedState("rowSelection", this.getRowSelectionState());
        }, 0);
        this.staleStateKeys = /* @__PURE__ */ new Set();
    }
    postConstruct() {
        const { gos: gos, ctrlsSvc: ctrlsSvc, colDelayRenderSvc: colDelayRenderSvc } = this.beans;
        this.isClientSideRowModel = $437b23f6a393c3bf$export$9f182d9ca737e15(gos);
        const initialState = $437b23f6a393c3bf$var$migrateGridStateModel(gos.get("initialState") ?? {});
        const partialColumnState = initialState.partialColumnState;
        delete initialState.partialColumnState;
        this.cachedState = initialState;
        const suppressEventsAndDispatchInitEvent = this.suppressEventsAndDispatchInitEvent.bind(this);
        ctrlsSvc.whenReady(this, ()=>suppressEventsAndDispatchInitEvent(()=>this.setupStateOnGridReady(initialState)));
        if (initialState.columnOrder || initialState.columnVisibility || initialState.columnSizing || initialState.columnPinning || initialState.columnGroup) colDelayRenderSvc?.hideColumns("columnState");
        const [newColumnsLoadedDestroyFunc, rowCountReadyDestroyFunc, firstDataRenderedDestroyFunc] = this.addManagedEventListeners({
            newColumnsLoaded: ({ source: source })=>{
                if (source === "gridInitializing") {
                    newColumnsLoadedDestroyFunc();
                    suppressEventsAndDispatchInitEvent(()=>{
                        this.setupStateOnColumnsInitialised(initialState, !!partialColumnState);
                        colDelayRenderSvc?.revealColumns("columnState");
                    });
                }
            },
            rowCountReady: ()=>{
                rowCountReadyDestroyFunc?.();
                suppressEventsAndDispatchInitEvent(()=>this.setupStateOnRowCountReady(initialState));
            },
            firstDataRendered: ()=>{
                firstDataRenderedDestroyFunc?.();
                suppressEventsAndDispatchInitEvent(()=>this.setupStateOnFirstDataRendered(initialState));
            }
        });
    }
    destroy() {
        super.destroy();
        clearTimeout(this.updateRowGroupExpansionStateTimer);
        this.queuedUpdateSources.clear();
    }
    getState() {
        if (this.staleStateKeys.size) this.refreshStaleState();
        return this.cachedState;
    }
    setState(providedState, propertiesToIgnore) {
        const state = $437b23f6a393c3bf$var$migrateGridStateModel(providedState);
        delete state.partialColumnState;
        this.cachedState = state;
        this.startSuppressEvents();
        const source = "api";
        const ignoreSet = propertiesToIgnore ? new Set(propertiesToIgnore) : void 0;
        this.setGridReadyState(state, source, ignoreSet);
        this.setColumnsInitialisedState(state, source, !!ignoreSet, ignoreSet);
        this.setRowCountState(state, source, ignoreSet);
        setTimeout(()=>{
            if (this.isAlive()) this.setFirstDataRenderedState(state, source, ignoreSet);
            this.stopSuppressEvents(source);
        });
    }
    setGridReadyState(state, source, ignoreSet) {
        if (source === "api" && !ignoreSet?.has("sideBar")) this.beans.sideBar?.comp?.setState(state.sideBar);
        this.updateCachedState("sideBar", this.getSideBarState());
    }
    setupStateOnGridReady(initialState) {
        this.setGridReadyState(initialState, "gridInitializing");
        const stateUpdater = ()=>this.updateCachedState("sideBar", this.getSideBarState());
        this.addManagedEventListeners({
            toolPanelVisibleChanged: stateUpdater,
            sideBarUpdated: stateUpdater
        });
    }
    updateColumnAndGroupState() {
        this.updateColumnState([
            "aggregation",
            "columnOrder",
            "columnPinning",
            "columnSizing",
            "columnVisibility",
            "pivot",
            "rowGroup",
            "sort"
        ]);
        this.updateCachedState("columnGroup", this.getColumnGroupState());
    }
    setColumnsInitialisedState(state, source, partialColumnState, ignoreSet) {
        this.setColumnState(state, source, partialColumnState, ignoreSet);
        this.setColumnGroupState(state, source, ignoreSet);
        this.updateColumnAndGroupState();
    }
    setupStateOnColumnsInitialised(initialState, partialColumnState) {
        this.setColumnsInitialisedState(initialState, "gridInitializing", partialColumnState);
        const onUpdate = (state)=>()=>this.updateColumnState([
                    state
                ]);
        this.addManagedEventListeners({
            columnValueChanged: onUpdate("aggregation"),
            columnMoved: onUpdate("columnOrder"),
            columnPinned: onUpdate("columnPinning"),
            columnResized: onUpdate("columnSizing"),
            columnVisible: onUpdate("columnVisibility"),
            columnPivotChanged: onUpdate("pivot"),
            columnPivotModeChanged: onUpdate("pivot"),
            columnRowGroupChanged: onUpdate("rowGroup"),
            sortChanged: onUpdate("sort"),
            newColumnsLoaded: this.updateColumnAndGroupState.bind(this),
            columnGroupOpened: ()=>this.updateCachedState("columnGroup", this.getColumnGroupState())
        });
    }
    setRowCountState(state, source, ignoreSet) {
        const { filter: filterState, rowGroupExpansion: rowGroupExpansionState, ssrmRowGroupExpansion: ssrmRowGroupExpansion, rowSelection: rowSelectionState, pagination: paginationState, rowPinning: rowPinning } = state;
        const shouldSetState = (prop, propState)=>!ignoreSet?.has(prop) && (propState || source === "api");
        if (shouldSetState("filter", filterState)) this.setFilterState(filterState);
        if (shouldSetState("rowGroupExpansion", rowGroupExpansionState)) this.setRowGroupExpansionState(ssrmRowGroupExpansion, rowGroupExpansionState, source);
        if (shouldSetState("rowSelection", rowSelectionState)) this.setRowSelectionState(rowSelectionState, source);
        if (shouldSetState("pagination", paginationState)) this.setPaginationState(paginationState, source);
        if (shouldSetState("rowPinning", rowPinning)) this.setRowPinningState(rowPinning);
        const updateCachedState = this.updateCachedState.bind(this);
        updateCachedState("filter", this.getFilterState());
        if (this.beans.gos.get("ssrmExpandAllAffectsAllRows")) {
            updateCachedState("ssrmRowGroupExpansion", this.getRowGroupExpansionState());
            updateCachedState("rowGroupExpansion", void 0);
        } else {
            updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
            updateCachedState("ssrmRowGroupExpansion", void 0);
        }
        updateCachedState("rowSelection", this.getRowSelectionState());
        updateCachedState("pagination", this.getPaginationState());
    }
    setupStateOnRowCountReady(initialState) {
        this.setRowCountState(initialState, "gridInitializing");
        const updateCachedState = this.updateCachedState.bind(this);
        const updateRowGroupExpansionState = ()=>{
            this.updateRowGroupExpansionStateTimer = 0;
            if (this.beans.gos.get("ssrmExpandAllAffectsAllRows")) {
                updateCachedState("ssrmRowGroupExpansion", this.getRowGroupExpansionState());
                updateCachedState("rowGroupExpansion", void 0);
            } else {
                updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
                updateCachedState("ssrmRowGroupExpansion", void 0);
            }
        };
        const updateFilterState = ()=>updateCachedState("filter", this.getFilterState());
        const { gos: gos, colFilter: colFilter, selectableFilter: selectableFilter } = this.beans;
        this.addManagedEventListeners({
            filterChanged: updateFilterState,
            rowExpansionStateChanged: this.onRowGroupOpenedDebounced,
            expandOrCollapseAll: updateRowGroupExpansionState,
            // `groupDefaultExpanded`/`isGroupOpenByDefault` updates expansion state without an expansion event
            columnRowGroupChanged: updateRowGroupExpansionState,
            rowDataUpdated: ()=>{
                if (gos.get("groupDefaultExpanded") !== 0 || gos.get("isGroupOpenByDefault")) this.updateRowGroupExpansionStateTimer || (this.updateRowGroupExpansionStateTimer = setTimeout(updateRowGroupExpansionState));
            },
            selectionChanged: ()=>{
                this.staleStateKeys.add("rowSelection");
                this.onRowSelectedDebounced();
            },
            paginationChanged: (event)=>{
                if (event.newPage || event.newPageSize) updateCachedState("pagination", this.getPaginationState());
            },
            pinnedRowsChanged: ()=>updateCachedState("rowPinning", this.getRowPinningState())
        });
        if (colFilter) this.addManagedListeners(colFilter, {
            filterStateChanged: updateFilterState
        });
        if (selectableFilter) this.addManagedListeners(selectableFilter, {
            selectedFilterChanged: updateFilterState
        });
    }
    setFirstDataRenderedState(state, source, ignoreSet) {
        const { scroll: scrollState, cellSelection: cellSelectionState, focusedCell: focusedCellState, columnOrder: columnOrderState } = state;
        const shouldSetState = (prop, propState)=>!ignoreSet?.has(prop) && (propState || source === "api");
        if (shouldSetState("focusedCell", focusedCellState)) this.setFocusedCellState(focusedCellState);
        if (shouldSetState("cellSelection", cellSelectionState)) this.setCellSelectionState(cellSelectionState);
        if (shouldSetState("scroll", scrollState)) this.setScrollState(scrollState);
        this.setColumnPivotState(!!columnOrderState?.orderedColIds, source);
        const updateCachedState = this.updateCachedState.bind(this);
        updateCachedState("sideBar", this.getSideBarState());
        updateCachedState("focusedCell", this.getFocusedCellState());
        const cellSelection = this.getRangeSelectionState();
        updateCachedState("rangeSelection", cellSelection);
        updateCachedState("cellSelection", cellSelection);
        updateCachedState("scroll", this.getScrollState());
    }
    setupStateOnFirstDataRendered(initialState) {
        this.setFirstDataRenderedState(initialState, "gridInitializing");
        const updateCachedState = this.updateCachedState.bind(this);
        const updateFocusState = ()=>updateCachedState("focusedCell", this.getFocusedCellState());
        this.addManagedEventListeners({
            cellFocused: updateFocusState,
            cellFocusCleared: updateFocusState,
            cellSelectionChanged: (event)=>{
                if (event.finished) {
                    const cellSelection = this.getRangeSelectionState();
                    updateCachedState("rangeSelection", cellSelection);
                    updateCachedState("cellSelection", cellSelection);
                }
            },
            bodyScrollEnd: ()=>updateCachedState("scroll", this.getScrollState())
        });
    }
    getColumnState() {
        const beans = this.beans;
        return $437b23f6a393c3bf$export$9453e80be74134db($437b23f6a393c3bf$export$e7d9af1fb362df7b(beans), beans.colModel.isPivotMode());
    }
    setColumnState(state, source, partialColumnState, ignoreSet) {
        const { sort: sortState, rowGroup: groupState, aggregation: aggregationState, pivot: pivotState, columnPinning: columnPinningState, columnVisibility: columnVisibilityState, columnSizing: columnSizingState, columnOrder: columnOrderState } = state;
        let forceSetState = false;
        const shouldSetState = (prop, propState)=>{
            const shouldSet = !ignoreSet?.has(prop) && !!(propState || source === "api");
            forceSetState || (forceSetState = shouldSet);
            return shouldSet;
        };
        const columnStateMap = {};
        const getColumnState2 = (colId)=>{
            let columnState = columnStateMap[colId];
            if (columnState) return columnState;
            columnState = {
                colId: colId
            };
            columnStateMap[colId] = columnState;
            return columnState;
        };
        const defaultState = {};
        const shouldSetSortState = shouldSetState("sort", sortState);
        if (shouldSetSortState) sortState?.sortModel.forEach(({ colId: colId, sort: sort }, sortIndex)=>{
            const columnState = getColumnState2(colId);
            columnState.sort = sort;
            columnState.sortIndex = sortIndex;
        });
        if (shouldSetSortState || !partialColumnState) {
            defaultState.sort = null;
            defaultState.sortIndex = null;
        }
        const shouldSetGroupState = shouldSetState("rowGroup", groupState);
        if (shouldSetGroupState) groupState?.groupColIds.forEach((colId, rowGroupIndex)=>{
            const columnState = getColumnState2(colId);
            columnState.rowGroup = true;
            columnState.rowGroupIndex = rowGroupIndex;
        });
        if (shouldSetGroupState || !partialColumnState) {
            defaultState.rowGroup = null;
            defaultState.rowGroupIndex = null;
        }
        const shouldSetAggregationState = shouldSetState("aggregation", aggregationState);
        if (shouldSetAggregationState) aggregationState?.aggregationModel.forEach(({ colId: colId, aggFunc: aggFunc })=>{
            getColumnState2(colId).aggFunc = aggFunc;
        });
        if (shouldSetAggregationState || !partialColumnState) defaultState.aggFunc = null;
        const shouldSetPivotState = shouldSetState("pivot", pivotState);
        if (shouldSetPivotState) {
            pivotState?.pivotColIds.forEach((colId, pivotIndex)=>{
                const columnState = getColumnState2(colId);
                columnState.pivot = true;
                columnState.pivotIndex = pivotIndex;
            });
            this.gos.updateGridOptions({
                options: {
                    pivotMode: !!pivotState?.pivotMode
                },
                source: source
            });
        }
        if (shouldSetPivotState || !partialColumnState) {
            defaultState.pivot = null;
            defaultState.pivotIndex = null;
        }
        const shouldSetColumnPinningState = shouldSetState("columnPinning", columnPinningState);
        if (shouldSetColumnPinningState) {
            for (const colId of columnPinningState?.leftColIds ?? [])getColumnState2(colId).pinned = "left";
            for (const colId of columnPinningState?.rightColIds ?? [])getColumnState2(colId).pinned = "right";
        }
        if (shouldSetColumnPinningState || !partialColumnState) defaultState.pinned = null;
        const shouldSetColumnVisibilityState = shouldSetState("columnVisibility", columnVisibilityState);
        if (shouldSetColumnVisibilityState) for (const colId of columnVisibilityState?.hiddenColIds ?? [])getColumnState2(colId).hide = true;
        if (shouldSetColumnVisibilityState || !partialColumnState) defaultState.hide = null;
        const shouldSetColumnSizingState = shouldSetState("columnSizing", columnSizingState);
        if (shouldSetColumnSizingState) for (const { colId: colId, flex: flex, width: width } of columnSizingState?.columnSizingModel ?? []){
            const columnState = getColumnState2(colId);
            columnState.flex = flex ?? null;
            columnState.width = width;
        }
        if (shouldSetColumnSizingState || !partialColumnState) defaultState.flex = null;
        const columns = columnOrderState?.orderedColIds;
        const applyOrder = !!columns?.length && !ignoreSet?.has("columnOrder");
        const columnStates = applyOrder ? columns.map((colId)=>getColumnState2(colId)) : Object.values(columnStateMap);
        if (columnStates.length || forceSetState) {
            this.columnStates = columnStates;
            $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
                state: columnStates,
                applyOrder: applyOrder,
                defaultState: defaultState
            }, source);
        }
    }
    setColumnPivotState(applyOrder, source) {
        const columnStates = this.columnStates;
        this.columnStates = void 0;
        const columnGroupStates = this.columnGroupStates;
        this.columnGroupStates = void 0;
        const beans = this.beans;
        const { pivotResultCols: pivotResultCols, colGroupSvc: colGroupSvc } = beans;
        if (!pivotResultCols?.isPivotResultColsPresent()) return;
        if (columnStates) {
            const secondaryColumnStates = [];
            for (const columnState of columnStates)if (pivotResultCols.getPivotResultCol(columnState.colId)) secondaryColumnStates.push(columnState);
            $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                state: secondaryColumnStates,
                applyOrder: applyOrder
            }, source);
        }
        if (columnGroupStates) colGroupSvc?.setColumnGroupState(columnGroupStates, source);
    }
    getColumnGroupState() {
        const colGroupSvc = this.beans.colGroupSvc;
        if (!colGroupSvc) return void 0;
        const columnGroupState = colGroupSvc.getColumnGroupState();
        return $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState);
    }
    setColumnGroupState(state, source, ignoreSet) {
        const colGroupSvc = this.beans.colGroupSvc;
        if (!colGroupSvc || ignoreSet?.has("columnGroup") || source !== "api" && !Object.prototype.hasOwnProperty.call(state, "columnGroup")) return;
        const openColumnGroups = new Set(state.columnGroup?.openColumnGroupIds);
        const existingColumnGroupState = colGroupSvc.getColumnGroupState();
        const stateItems = existingColumnGroupState.map(({ groupId: groupId })=>{
            const open = openColumnGroups.has(groupId);
            if (open) openColumnGroups.delete(groupId);
            return {
                groupId: groupId,
                open: open
            };
        });
        for (const groupId of openColumnGroups)stateItems.push({
            groupId: groupId,
            open: true
        });
        if (stateItems.length) this.columnGroupStates = stateItems;
        colGroupSvc.setColumnGroupState(stateItems, source);
    }
    getFilterState() {
        const { filterManager: filterManager, selectableFilter: selectableFilter } = this.beans;
        let filterModel = filterManager?.getFilterModel();
        if (filterModel && Object.keys(filterModel).length === 0) filterModel = void 0;
        const columnFilterState = filterManager?.getFilterState();
        const advancedFilterModel = filterManager?.getAdvFilterModel() ?? void 0;
        const selectableFilters = selectableFilter?.getState();
        return filterModel || advancedFilterModel || columnFilterState || selectableFilters ? {
            filterModel: filterModel,
            columnFilterState: columnFilterState,
            advancedFilterModel: advancedFilterModel,
            selectableFilters: selectableFilters
        } : void 0;
    }
    setFilterState(filterState) {
        const { filterManager: filterManager, selectableFilter: selectableFilter } = this.beans;
        const { filterModel: filterModel, columnFilterState: columnFilterState, advancedFilterModel: advancedFilterModel, selectableFilters: selectableFilters } = filterState ?? {
            filterModel: null,
            columnFilterState: null,
            advancedFilterModel: null
        };
        if (selectableFilters !== void 0) selectableFilter?.setState(selectableFilters ?? {});
        if (filterModel !== void 0 || columnFilterState !== void 0) filterManager?.setFilterState(filterModel ?? null, columnFilterState ?? null, "columnFilter");
        if (advancedFilterModel !== void 0) filterManager?.setAdvFilterModel(advancedFilterModel ?? null, "advancedFilter");
    }
    getRangeSelectionState() {
        const cellRanges = this.beans.rangeSvc?.getCellRanges().map((cellRange)=>{
            const { id: id, type: type, startRow: startRow, endRow: endRow, columns: columns, startColumn: startColumn } = cellRange;
            return {
                id: id,
                type: type,
                startRow: startRow,
                endRow: endRow,
                colIds: columns.map((column)=>column.getColId()),
                startColId: startColumn.getColId()
            };
        });
        return cellRanges?.length ? {
            cellRanges: cellRanges
        } : void 0;
    }
    setCellSelectionState(cellSelectionState) {
        const { gos: gos, rangeSvc: rangeSvc, colModel: colModel, visibleCols: visibleCols } = this.beans;
        if (!$437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) || !rangeSvc) return;
        const cellRanges = [];
        for (const cellRange of cellSelectionState?.cellRanges ?? []){
            const columns = [];
            for (const colId of cellRange.colIds){
                const column = colModel.getCol(colId);
                if (column) columns.push(column);
            }
            if (!columns.length) continue;
            let startColumn = colModel.getCol(cellRange.startColId);
            if (!startColumn) {
                const allColumns = visibleCols.allCols;
                const columnSet = new Set(columns);
                startColumn = allColumns.find((column)=>columnSet.has(column));
            }
            cellRanges.push({
                ...cellRange,
                columns: columns,
                startColumn: startColumn
            });
        }
        rangeSvc.setCellRanges(cellRanges);
    }
    getScrollState() {
        if (!this.isClientSideRowModel) return void 0;
        const scrollFeature = this.beans.ctrlsSvc.getScrollFeature();
        const { left: left } = scrollFeature?.getHScrollPosition() ?? {
            left: 0
        };
        const { top: top } = scrollFeature?.getVScrollPosition() ?? {
            top: 0
        };
        return top || left ? {
            top: top,
            left: left
        } : void 0;
    }
    setScrollState(scrollState) {
        if (!this.isClientSideRowModel) return;
        const { top: top, left: left } = scrollState ?? {
            top: 0,
            left: 0
        };
        const { frameworkOverrides: frameworkOverrides, rowRenderer: rowRenderer, animationFrameSvc: animationFrameSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        frameworkOverrides.wrapIncoming(()=>{
            ctrlsSvc.get("center").setCenterViewportScrollLeft(left);
            ctrlsSvc.getScrollFeature()?.setVerticalScrollPosition(top);
            rowRenderer.redraw({
                afterScroll: true
            });
            animationFrameSvc?.flushAllFrames();
        });
    }
    getSideBarState() {
        return this.beans.sideBar?.comp?.getState();
    }
    getFocusedCellState() {
        if (!this.isClientSideRowModel) return void 0;
        const focusedCell = this.beans.focusSvc.getFocusedCell();
        if (focusedCell) {
            const { column: column, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCell;
            return {
                colId: column.getColId(),
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
        }
        return void 0;
    }
    setFocusedCellState(focusedCellState) {
        if (!this.isClientSideRowModel) return;
        const { focusSvc: focusSvc, colModel: colModel } = this.beans;
        if (!focusedCellState) {
            focusSvc.clearFocusedCell();
            return;
        }
        const { colId: colId, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCellState;
        focusSvc.setFocusedCell({
            column: colModel.getCol(colId),
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true
        });
    }
    getPaginationState() {
        const { pagination: pagination, gos: gos } = this.beans;
        if (!pagination) return void 0;
        const page = pagination.getCurrentPage();
        const pageSize = !gos.get("paginationAutoPageSize") ? pagination.getPageSize() : void 0;
        if (!page && !pageSize) return;
        return {
            page: page,
            pageSize: pageSize
        };
    }
    setPaginationState(paginationState, source) {
        const { pagination: pagination, gos: gos } = this.beans;
        if (!pagination) return;
        const { pageSize: pageSize, page: page } = paginationState ?? {
            page: 0,
            pageSize: gos.get("paginationPageSize")
        };
        const isInit = source === "gridInitializing";
        if (pageSize && !gos.get("paginationAutoPageSize")) pagination.setPageSize(pageSize, isInit ? "initialState" : "pageSizeSelector");
        if (typeof page === "number") {
            if (isInit) pagination.setPage(page);
            else pagination.goToPage(page);
        }
    }
    getRowSelectionState() {
        const selectionSvc = this.beans.selectionSvc;
        if (!selectionSvc) return void 0;
        const selectionState = selectionSvc.getSelectionState();
        const noSelections = !selectionState || !Array.isArray(selectionState) && (selectionState.selectAll === false || selectionState.selectAllChildren === false) && !selectionState?.toggledNodes?.length;
        return noSelections ? void 0 : selectionState;
    }
    setRowSelectionState(rowSelectionState, source) {
        this.beans.selectionSvc?.setSelectionState(rowSelectionState, source, source === "api");
    }
    getRowGroupExpansionState() {
        const { expansionSvc: expansionSvc } = this.beans;
        if (!expansionSvc) return void 0;
        return expansionSvc.getExpansionState();
    }
    getRowPinningState() {
        return this.beans.pinnedRowModel?.getPinnedState();
    }
    setRowPinningState(state) {
        const pinnedRowModel = this.beans.pinnedRowModel;
        if (state) pinnedRowModel?.setPinnedState(state);
        else pinnedRowModel?.reset();
    }
    setRowGroupExpansionState(ssrmRowGroupExpansionState, rowGroupExpansionState, source) {
        const expansionSvc = this.beans.expansionSvc;
        if (!expansionSvc) return;
        const newExpansionState = rowGroupExpansionState ?? {
            expandedRowGroupIds: [],
            collapsedRowGroupIds: []
        };
        expansionSvc.setExpansionState(newExpansionState, source);
    }
    updateColumnState(features) {
        const newColumnState = this.getColumnState();
        let hasChanged = false;
        const cachedState = this.cachedState;
        for (const key of Object.keys(newColumnState)){
            const value = newColumnState[key];
            if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(value, cachedState[key])) hasChanged = true;
        }
        this.cachedState = {
            ...cachedState,
            ...newColumnState
        };
        if (hasChanged) this.dispatchStateUpdateEvent(features);
    }
    updateCachedState(key, value) {
        const existingValue = this.cachedState[key];
        this.setCachedStateValue(key, value);
        if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(value, existingValue)) this.dispatchStateUpdateEvent([
            key
        ]);
    }
    setCachedStateValue(key, value) {
        this.cachedState = {
            ...this.cachedState,
            [key]: value
        };
    }
    refreshStaleState() {
        const staleStateKeys = this.staleStateKeys;
        for (const key of staleStateKeys)if (key === "rowSelection") this.setCachedStateValue(key, this.getRowSelectionState());
        staleStateKeys.clear();
    }
    dispatchStateUpdateEvent(sources) {
        if (this.suppressEvents) return;
        for (const source of sources)this.queuedUpdateSources.add(source);
        this.dispatchStateUpdateEventDebounced();
    }
    dispatchQueuedStateUpdateEvents() {
        const queuedUpdateSources = this.queuedUpdateSources;
        const sources = Array.from(queuedUpdateSources);
        queuedUpdateSources.clear();
        this.eventSvc.dispatchEvent({
            type: "stateUpdated",
            sources: sources,
            state: this.cachedState
        });
    }
    startSuppressEvents() {
        this.suppressEvents = true;
        this.beans.colAnimation?.setSuppressAnimation(true);
    }
    stopSuppressEvents(source) {
        setTimeout(()=>{
            this.suppressEvents = false;
            this.queuedUpdateSources.clear();
            if (!this.isAlive()) return;
            this.beans.colAnimation?.setSuppressAnimation(false);
            this.dispatchStateUpdateEvent([
                source
            ]);
        });
    }
    suppressEventsAndDispatchInitEvent(updateFunc) {
        this.startSuppressEvents();
        updateFunc();
        this.stopSuppressEvents("gridInitializing");
    }
};
// packages/ag-grid-community/src/misc/state/stateModule.ts
var $437b23f6a393c3bf$export$3402149dbbda9537 = {
    moduleName: "GridState",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$StateService
    ],
    apiFunctions: {
        getState: $437b23f6a393c3bf$var$getState,
        setState: $437b23f6a393c3bf$var$setState
    }
};
// packages/ag-grid-community/src/pagination/paginationApi.ts
function $437b23f6a393c3bf$var$paginationIsLastPageFound(beans) {
    return beans.rowModel.isLastRowIndexKnown();
}
function $437b23f6a393c3bf$var$paginationGetPageSize(beans) {
    return beans.pagination?.getPageSize() ?? 100;
}
function $437b23f6a393c3bf$var$paginationGetCurrentPage(beans) {
    return beans.pagination?.getCurrentPage() ?? 0;
}
function $437b23f6a393c3bf$var$paginationGetTotalPages(beans) {
    return beans.pagination?.getTotalPages() ?? 1;
}
function $437b23f6a393c3bf$var$paginationGetRowCount(beans) {
    return beans.pagination ? beans.pagination.getMasterRowCount() : beans.rowModel.getRowCount();
}
function $437b23f6a393c3bf$var$paginationGoToNextPage(beans) {
    beans.pagination?.goToNextPage();
}
function $437b23f6a393c3bf$var$paginationGoToPreviousPage(beans) {
    beans.pagination?.goToPreviousPage();
}
function $437b23f6a393c3bf$var$paginationGoToFirstPage(beans) {
    beans.pagination?.goToFirstPage();
}
function $437b23f6a393c3bf$var$paginationGoToLastPage(beans) {
    beans.pagination?.goToLastPage();
}
function $437b23f6a393c3bf$var$paginationGoToPage(beans, page) {
    beans.pagination?.goToPage(page);
}
// packages/ag-grid-community/src/pagination/paginationAutoPageSizeService.ts
var $437b23f6a393c3bf$var$PaginationAutoPageSizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "paginationAutoPageSizeSvc";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowsCtrl = p.center;
            const listener = this.checkPageSize.bind(this);
            this.addManagedEventListeners({
                bodyHeightChanged: listener,
                scrollVisibilityChanged: listener
            });
            this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this));
            this.checkPageSize();
        });
    }
    notActive() {
        return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
    }
    onPaginationAutoSizeChanged() {
        if (this.notActive()) this.beans.pagination.unsetAutoCalculatedPageSize();
        else this.checkPageSize();
    }
    checkPageSize() {
        if (this.notActive()) return;
        const bodyHeight = this.centerRowsCtrl.viewportSizeFeature.getBodyHeight();
        if (bodyHeight > 0) {
            const beans = this.beans;
            const update = ()=>{
                const rowHeight = Math.max($437b23f6a393c3bf$export$8966875adec41e5b(beans), 1);
                const newPageSize = Math.floor(bodyHeight / rowHeight);
                beans.pagination.setPageSize(newPageSize, "autoCalculated");
            };
            if (!this.isBodyRendered) {
                update();
                this.isBodyRendered = true;
            } else $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, update, 50)();
        } else this.isBodyRendered = false;
    }
};
// packages/ag-grid-community/src/pagination/pageSizeSelector/pageSizeSelectorComp.ts
var $437b23f6a393c3bf$var$paginationPageSizeSelector = "paginationPageSizeSelector";
var $437b23f6a393c3bf$var$PageSizeSelectorCompElement = {
    tag: "span",
    cls: "ag-paging-page-size"
};
var $437b23f6a393c3bf$var$PageSizeSelectorComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$PageSizeSelectorCompElement);
        this.hasEmptyOption = false;
        this.handlePageSizeItemSelected = ()=>{
            if (!this.selectPageSizeComp) return;
            const newValue = this.selectPageSizeComp.getValue();
            if (!newValue) return;
            const paginationPageSize = Number(newValue);
            if (isNaN(paginationPageSize) || paginationPageSize < 1 || paginationPageSize === this.pagination.getPageSize()) return;
            this.pagination.setPageSize(paginationPageSize, "pageSizeSelector");
            if (this.hasEmptyOption) this.toggleSelectDisplay(true);
            this.selectPageSizeComp.getFocusableElement().focus();
        };
    }
    wireBeans(beans) {
        this.pagination = beans.pagination;
    }
    postConstruct() {
        this.addManagedPropertyListener($437b23f6a393c3bf$var$paginationPageSizeSelector, ()=>{
            this.onPageSizeSelectorValuesChange();
        });
        this.addManagedEventListeners({
            paginationChanged: (event)=>this.handlePaginationChanged(event)
        });
    }
    handlePaginationChanged(paginationChangedEvent) {
        if (!this.selectPageSizeComp || !paginationChangedEvent?.newPageSize) return;
        const paginationPageSize = this.pagination.getPageSize();
        if (this.getPageSizeSelectorValues().includes(paginationPageSize)) this.selectPageSizeComp.setValue(paginationPageSize.toString());
        else if (this.hasEmptyOption) this.selectPageSizeComp.setValue("");
        else this.toggleSelectDisplay(true);
    }
    toggleSelectDisplay(show) {
        if (this.selectPageSizeComp && !show) this.reset();
        if (!show) return;
        this.reloadPageSizesSelector();
        if (!this.selectPageSizeComp) return;
    }
    reset() {
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.getGui());
        if (!this.selectPageSizeComp) return;
        this.selectPageSizeComp = this.destroyBean(this.selectPageSizeComp);
    }
    onPageSizeSelectorValuesChange() {
        if (!this.selectPageSizeComp) return;
        if (this.shouldShowPageSizeSelector()) this.reloadPageSizesSelector();
    }
    shouldShowPageSizeSelector() {
        return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector) !== false;
    }
    reloadPageSizesSelector() {
        const pageSizeOptions = this.getPageSizeSelectorValues();
        const paginationPageSizeOption = this.pagination.getPageSize();
        const shouldAddAndSelectEmptyOption = !paginationPageSizeOption || !pageSizeOptions.includes(paginationPageSizeOption);
        if (shouldAddAndSelectEmptyOption) {
            const pageSizeSet = this.gos.exists("paginationPageSize");
            const pageSizesSet = this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector) !== true;
            $437b23f6a393c3bf$export$545083624300f13d(94, {
                pageSizeSet: pageSizeSet,
                pageSizesSet: pageSizesSet,
                pageSizeOptions: pageSizeOptions,
                paginationPageSizeOption: paginationPageSizeOption
            });
            if (!pageSizesSet) $437b23f6a393c3bf$export$545083624300f13d(95, {
                paginationPageSizeOption: paginationPageSizeOption,
                paginationPageSizeSelector: $437b23f6a393c3bf$var$paginationPageSizeSelector
            });
            pageSizeOptions.unshift("");
        }
        const value = String(shouldAddAndSelectEmptyOption ? "" : paginationPageSizeOption);
        if (this.selectPageSizeComp) {
            if (!$437b23f6a393c3bf$export$893967cdb9833fdd(this.pageSizeOptions, pageSizeOptions)) {
                this.selectPageSizeComp.clearOptions().addOptions(this.createPageSizeSelectOptions(pageSizeOptions));
                this.pageSizeOptions = pageSizeOptions;
            }
            this.selectPageSizeComp.setValue(value, true);
        } else this.createPageSizeSelectorComp(pageSizeOptions, value);
        this.hasEmptyOption = shouldAddAndSelectEmptyOption;
    }
    createPageSizeSelectOptions(pageSizeOptions) {
        return pageSizeOptions.map((value)=>({
                value: String(value)
            }));
    }
    createPageSizeSelectorComp(pageSizeOptions, value) {
        const localeTextFunc = this.getLocaleTextFunc();
        const localisedLabel = localeTextFunc("pageSizeSelectorLabel", "Page Size:");
        const localisedAriaLabel = localeTextFunc("ariaPageSizeSelectorLabel", "Page Size");
        this.selectPageSizeComp = this.createManagedBean(new $437b23f6a393c3bf$export$6f9c460854d56032()).addOptions(this.createPageSizeSelectOptions(pageSizeOptions)).setValue(value).setAriaLabel(localisedAriaLabel).setLabel(localisedLabel).onValueChange(()=>this.handlePageSizeItemSelected());
        this.appendChild(this.selectPageSizeComp);
    }
    getPageSizeSelectorValues() {
        const defaultValues = [
            20,
            50,
            100
        ];
        const paginationPageSizeSelectorValues = this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector);
        if (!Array.isArray(paginationPageSizeSelectorValues) || !paginationPageSizeSelectorValues?.length) return defaultValues;
        return [
            ...paginationPageSizeSelectorValues
        ].sort((a, b)=>a - b);
    }
    destroy() {
        this.toggleSelectDisplay(false);
        super.destroy();
    }
};
var $437b23f6a393c3bf$var$PageSizeSelectorSelector = {
    selector: "AG-PAGE-SIZE-SELECTOR",
    component: $437b23f6a393c3bf$var$PageSizeSelectorComp
};
// packages/ag-grid-community/src/pagination/paginationComp.css-GENERATED.ts
var $437b23f6a393c3bf$var$paginationCompCSS = /*css*/ `.ag-paging-panel{align-items:center;border-top:var(--ag-footer-row-border);display:flex;gap:calc(var(--ag-spacing)*4);height:var(--ag-pagination-panel-height);justify-content:flex-end;padding:0 var(--ag-cell-horizontal-padding)}:where(.ag-paging-page-size) .ag-wrapper{min-width:50px}.ag-paging-page-summary-panel{align-items:center;display:flex;gap:var(--ag-cell-widget-spacing);.ag-disabled &{pointer-events:none}}.ag-paging-button{cursor:pointer;position:relative;&.ag-disabled{cursor:default;opacity:.5}}.ag-paging-number,.ag-paging-row-summary-panel-number{font-weight:500}`;
// packages/ag-grid-community/src/pagination/paginationComp.ts
var $437b23f6a393c3bf$var$PaginationComp = class extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(){
        super();
        this.btFirst = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btPrevious = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btNext = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btLast = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbRecordCount = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbFirstRowOnPage = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbLastRowOnPage = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbCurrent = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbTotal = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.pageSizeComp = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.previousAndFirstButtonsDisabled = false;
        this.nextButtonDisabled = false;
        this.lastButtonDisabled = false;
        this.areListenersSetup = false;
        this.allowFocusInnerElement = false;
        this.registerCSS($437b23f6a393c3bf$var$paginationCompCSS);
    }
    wireBeans(beans) {
        this.rowModel = beans.rowModel;
        this.pagination = beans.pagination;
        this.ariaAnnounce = beans.ariaAnnounce;
    }
    postConstruct() {
        const isRtl = this.gos.get("enableRtl");
        this.setTemplate(this.getTemplate(), [
            $437b23f6a393c3bf$var$PageSizeSelectorSelector
        ]);
        const { btFirst: btFirst, btPrevious: btPrevious, btNext: btNext, btLast: btLast } = this;
        this.activateTabIndex([
            btFirst,
            btPrevious,
            btNext,
            btLast
        ]);
        btFirst.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "last" : "first", this.beans));
        btPrevious.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "next" : "previous", this.beans));
        btNext.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "previous" : "next", this.beans));
        btLast.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "first" : "last", this.beans));
        this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListeners([
            "paginationPageSizeSelector",
            "paginationAutoPageSize",
            "suppressPaginationPanel"
        ], ()=>this.onPageSizeRelatedOptionsChange());
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
        this.initialiseTabGuard({
            // prevent tab guard default logic
            onTabKeyDown: ()=>{},
            focusInnerElement: (fromBottom)=>{
                if (this.allowFocusInnerElement) return this.tabGuardFeature.getTabGuardCtrl().focusInnerElement(fromBottom);
                else return $437b23f6a393c3bf$export$b3beea4db79d8bb3(this.beans, fromBottom);
            },
            forceFocusOutWhenTabGuardsAreEmpty: true
        });
        this.onPaginationChanged();
    }
    setAllowFocus(allowFocus) {
        this.allowFocusInnerElement = allowFocus;
    }
    onPaginationChanged() {
        const isPaging = this.gos.get("pagination");
        const paginationPanelEnabled = isPaging && !this.gos.get("suppressPaginationPanel");
        this.setDisplayed(paginationPanelEnabled);
        if (!paginationPanelEnabled) return;
        this.setupListeners();
        this.enableOrDisableButtons();
        this.updateLabels();
        this.onPageSizeRelatedOptionsChange();
    }
    onPageSizeRelatedOptionsChange() {
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
    }
    setupListeners() {
        if (!this.areListenersSetup) {
            this.addManagedEventListeners({
                paginationChanged: this.onPaginationChanged.bind(this)
            });
            for (const item of [
                {
                    el: this.btFirst,
                    fn: this.onBtFirst.bind(this)
                },
                {
                    el: this.btPrevious,
                    fn: this.onBtPrevious.bind(this)
                },
                {
                    el: this.btNext,
                    fn: this.onBtNext.bind(this)
                },
                {
                    el: this.btLast,
                    fn: this.onBtLast.bind(this)
                }
            ]){
                const { el: el, fn: fn } = item;
                this.addManagedListeners(el, {
                    click: fn,
                    keydown: (e)=>{
                        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) {
                            e.preventDefault();
                            fn();
                        }
                    }
                });
            }
            $437b23f6a393c3bf$export$8865b8c867776648(this.beans, this, this.getGui());
            this.areListenersSetup = true;
        }
    }
    onBtFirst() {
        if (!this.previousAndFirstButtonsDisabled) this.pagination.goToFirstPage();
    }
    formatNumber(value) {
        const userFunc = this.gos.getCallback("paginationNumberFormatter");
        if (userFunc) {
            const params = {
                value: value
            };
            return userFunc(params);
        }
        return $437b23f6a393c3bf$export$c8980add4a69422e(value, this.getLocaleTextFunc.bind(this));
    }
    getTemplate() {
        const localeTextFunc = this.getLocaleTextFunc();
        const idPrefix = `ag-${this.getCompId()}`;
        return {
            tag: "div",
            cls: "ag-paging-panel ag-unselectable",
            attrs: {
                id: `${idPrefix}`
            },
            children: [
                {
                    tag: "ag-page-size-selector",
                    ref: "pageSizeComp"
                },
                {
                    tag: "span",
                    cls: "ag-paging-row-summary-panel",
                    children: [
                        {
                            tag: "span",
                            ref: "lbFirstRowOnPage",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-first-row`
                            }
                        },
                        {
                            tag: "span",
                            attrs: {
                                id: `${idPrefix}-to`
                            },
                            children: localeTextFunc("to", "to")
                        },
                        {
                            tag: "span",
                            ref: "lbLastRowOnPage",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-last-row`
                            }
                        },
                        {
                            tag: "span",
                            attrs: {
                                id: `${idPrefix}-of`
                            },
                            children: localeTextFunc("of", "of")
                        },
                        {
                            tag: "span",
                            ref: "lbRecordCount",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-row-count`
                            }
                        }
                    ]
                },
                {
                    tag: "span",
                    cls: "ag-paging-page-summary-panel",
                    role: "presentation",
                    children: [
                        {
                            tag: "div",
                            ref: "btFirst",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("firstPage", "First Page")
                            }
                        },
                        {
                            tag: "div",
                            ref: "btPrevious",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("previousPage", "Previous Page")
                            }
                        },
                        {
                            tag: "span",
                            cls: "ag-paging-description",
                            children: [
                                {
                                    tag: "span",
                                    attrs: {
                                        id: `${idPrefix}-start-page`
                                    },
                                    children: localeTextFunc("page", "Page")
                                },
                                {
                                    tag: "span",
                                    ref: "lbCurrent",
                                    cls: "ag-paging-number",
                                    attrs: {
                                        id: `${idPrefix}-start-page-number`
                                    }
                                },
                                {
                                    tag: "span",
                                    attrs: {
                                        id: `${idPrefix}-of-page`
                                    },
                                    children: localeTextFunc("of", "of")
                                },
                                {
                                    tag: "span",
                                    ref: "lbTotal",
                                    cls: "ag-paging-number",
                                    attrs: {
                                        id: `${idPrefix}-of-page-number`
                                    }
                                }
                            ]
                        },
                        {
                            tag: "div",
                            ref: "btNext",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("nextPage", "Next Page")
                            }
                        },
                        {
                            tag: "div",
                            ref: "btLast",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("lastPage", "Last Page")
                            }
                        }
                    ]
                }
            ]
        };
    }
    onBtNext() {
        if (!this.nextButtonDisabled) this.pagination.goToNextPage();
    }
    onBtPrevious() {
        if (!this.previousAndFirstButtonsDisabled) this.pagination.goToPreviousPage();
    }
    onBtLast() {
        if (!this.lastButtonDisabled) this.pagination.goToLastPage();
    }
    enableOrDisableButtons() {
        const currentPage = this.pagination.getCurrentPage();
        const maxRowFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        this.previousAndFirstButtonsDisabled = currentPage === 0;
        this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled);
        this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
        const zeroPagesToDisplay = this.isZeroPagesToDisplay();
        const onLastPage = currentPage === totalPages - 1;
        this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
        this.lastButtonDisabled = !maxRowFound || zeroPagesToDisplay || currentPage === totalPages - 1;
        this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled);
        this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
    }
    toggleButtonDisabled(button, disabled) {
        $437b23f6a393c3bf$export$7ed376f43c6f2bbd(button, disabled);
        button.classList.toggle("ag-disabled", disabled);
    }
    isZeroPagesToDisplay() {
        const maxRowFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        return maxRowFound && totalPages === 0;
    }
    updateLabels() {
        const lastPageFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        const masterRowCount = this.pagination.getMasterRowCount();
        const rowCount = lastPageFound ? masterRowCount : null;
        const currentPage = this.pagination.getCurrentPage();
        const pageSize = this.pagination.getPageSize();
        let startRow;
        let endRow;
        if (this.isZeroPagesToDisplay()) startRow = endRow = 0;
        else {
            startRow = pageSize * currentPage + 1;
            endRow = startRow + pageSize - 1;
            if (lastPageFound && endRow > rowCount) endRow = rowCount;
        }
        const theoreticalEndRow = startRow + pageSize - 1;
        const isLoadingPageSize = !lastPageFound && masterRowCount < theoreticalEndRow;
        const lbFirstRowOnPage = this.formatNumber(startRow);
        this.lbFirstRowOnPage.textContent = lbFirstRowOnPage;
        let lbLastRowOnPage;
        const localeTextFunc = this.getLocaleTextFunc();
        if (isLoadingPageSize) lbLastRowOnPage = localeTextFunc("pageLastRowUnknown", "?");
        else lbLastRowOnPage = this.formatNumber(endRow);
        this.lbLastRowOnPage.textContent = lbLastRowOnPage;
        const pagesExist = totalPages > 0;
        const toDisplay = pagesExist ? currentPage + 1 : 0;
        const lbCurrent = this.formatNumber(toDisplay);
        this.lbCurrent.textContent = lbCurrent;
        let lbTotal;
        let lbRecordCount;
        if (lastPageFound) {
            lbTotal = this.formatNumber(totalPages);
            lbRecordCount = this.formatNumber(rowCount);
        } else {
            const moreText = localeTextFunc("more", "more");
            lbTotal = moreText;
            lbRecordCount = moreText;
        }
        this.lbTotal.textContent = lbTotal;
        this.lbRecordCount.textContent = lbRecordCount;
        this.announceAriaStatus(lbFirstRowOnPage, lbLastRowOnPage, lbRecordCount, lbCurrent, lbTotal);
    }
    announceAriaStatus(lbFirstRowOnPage, lbLastRowOnPage, lbRecordCount, lbCurrent, lbTotal) {
        const localeTextFunc = this.getLocaleTextFunc();
        const strPage = localeTextFunc("page", "Page");
        const strTo = localeTextFunc("to", "to");
        const strOf = localeTextFunc("of", "of");
        const ariaRowStatus = `${lbFirstRowOnPage} ${strTo} ${lbLastRowOnPage} ${strOf} ${lbRecordCount}`;
        const ariaPageStatus = `${strPage} ${lbCurrent} ${strOf} ${lbTotal}`;
        if (ariaRowStatus !== this.ariaRowStatus) {
            this.ariaRowStatus = ariaRowStatus;
            this.ariaAnnounce?.announceValue(ariaRowStatus, "paginationRow");
        }
        if (ariaPageStatus !== this.ariaPageStatus) {
            this.ariaPageStatus = ariaPageStatus;
            this.ariaAnnounce?.announceValue(ariaPageStatus, "paginationPage");
        }
    }
};
var $437b23f6a393c3bf$var$PaginationSelector = {
    selector: "AG-PAGINATION",
    component: $437b23f6a393c3bf$var$PaginationComp
};
// packages/ag-grid-community/src/pagination/paginationService.ts
var $437b23f6a393c3bf$var$PaginationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pagination";
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = 0;
        this.masterRowCount = 0;
    }
    postConstruct() {
        const gos = this.gos;
        this.active = gos.get("pagination");
        this.pageSizeFromGridOptions = gos.get("paginationPageSize");
        this.paginateChildRows = this.isPaginateChildRows();
        this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this));
        this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
    }
    getPaginationSelector() {
        return $437b23f6a393c3bf$var$PaginationSelector;
    }
    isPaginateChildRows() {
        const gos = this.gos;
        const shouldPaginate = gos.get("groupHideParentOfSingleChild") || // following two properties deprecated v32.3.0
        gos.get("groupRemoveSingleChildren") || gos.get("groupRemoveLowestSingleChildren");
        if (shouldPaginate) return true;
        return gos.get("paginateChildRows");
    }
    onPaginationGridOptionChanged() {
        this.active = this.gos.get("pagination");
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            keepRenderedRows: true
        });
    }
    onPageSizeGridOptionChanged() {
        this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
    }
    goToPage(page) {
        const currentPage = this.currentPage;
        if (!this.active || currentPage === page || typeof currentPage !== "number") return;
        const { editSvc: editSvc } = this.beans;
        if (editSvc?.isEditing()) {
            if (editSvc.isBatchEditing()) editSvc.cleanupEditors();
            else editSvc.stopEditing(void 0, {
                source: "api"
            });
        }
        this.currentPage = page;
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            newPage: true
        });
    }
    goToPageWithIndex(index) {
        if (!this.active) return;
        let adjustedIndex = index;
        if (!this.paginateChildRows) adjustedIndex = this.beans.rowModel.getTopLevelIndexFromDisplayedIndex?.(index) ?? index;
        this.goToPage(Math.floor(adjustedIndex / this.pageSize));
    }
    isRowInPage(rowIndex) {
        if (!this.active) return true;
        return rowIndex >= this.topDisplayedRowIndex && rowIndex <= this.bottomDisplayedRowIndex;
    }
    getCurrentPage() {
        return this.currentPage;
    }
    goToNextPage() {
        this.goToPage(this.currentPage + 1);
    }
    goToPreviousPage() {
        this.goToPage(this.currentPage - 1);
    }
    goToFirstPage() {
        this.goToPage(0);
    }
    goToLastPage() {
        const rowCount = this.beans.rowModel.getRowCount();
        const lastPage = Math.floor(rowCount / this.pageSize);
        this.goToPage(lastPage);
    }
    getPageSize() {
        return this.pageSize;
    }
    getTotalPages() {
        return this.totalPages;
    }
    /** This is only for state setting before data has been loaded */ setPage(page) {
        this.currentPage = page;
    }
    get pageSize() {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeAutoCalculated) && this.gos.get("paginationAutoPageSize")) return this.pageSizeAutoCalculated;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromPageSizeSelector)) return this.pageSizeFromPageSizeSelector;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromInitialState)) return this.pageSizeFromInitialState;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromGridOptions)) return this.pageSizeFromGridOptions;
        return this.defaultPageSize;
    }
    calculatePages() {
        if (this.active) {
            if (this.paginateChildRows) this.calculatePagesAllRows();
            else this.calculatePagesMasterRowsOnly();
        } else this.calculatedPagesNotActive();
        this.beans.pageBounds.calculateBounds(this.topDisplayedRowIndex, this.bottomDisplayedRowIndex);
    }
    unsetAutoCalculatedPageSize() {
        if (this.pageSizeAutoCalculated === void 0) return;
        const oldPageSize = this.pageSizeAutoCalculated;
        this.pageSizeAutoCalculated = void 0;
        if (this.pageSize === oldPageSize) return;
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            newPageSize: true
        });
    }
    setPageSize(size, source) {
        const currentSize = this.pageSize;
        switch(source){
            case "autoCalculated":
                this.pageSizeAutoCalculated = size;
                break;
            case "pageSizeSelector":
                this.pageSizeFromPageSizeSelector = size;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
            case "initialState":
                this.pageSizeFromInitialState = size;
                break;
            case "gridOptions":
                this.pageSizeFromGridOptions = size;
                this.pageSizeFromInitialState = void 0;
                this.pageSizeFromPageSizeSelector = void 0;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
        }
        if (currentSize !== this.pageSize) {
            this.calculatePages();
            this.dispatchPaginationChangedEvent({
                newPageSize: true,
                keepRenderedRows: true
            });
        }
    }
    setZeroRows() {
        this.masterRowCount = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = -1;
        this.currentPage = 0;
        this.totalPages = 0;
    }
    adjustCurrentPageIfInvalid() {
        const totalPages = this.totalPages;
        if (this.currentPage >= totalPages) this.currentPage = totalPages - 1;
        const currentPage = this.currentPage;
        if (!isFinite(currentPage) || isNaN(currentPage) || currentPage < 0) this.currentPage = 0;
    }
    calculatePagesMasterRowsOnly() {
        const rowModel = this.beans.rowModel;
        const masterRowCount = rowModel.getTopLevelRowCount();
        this.masterRowCount = masterRowCount;
        if (masterRowCount <= 0) {
            this.setZeroRows();
            return;
        }
        const pageSize = this.pageSize;
        const masterLastRowIndex = masterRowCount - 1;
        this.totalPages = Math.floor(masterLastRowIndex / pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        const currentPage = this.currentPage;
        const masterPageStartIndex = pageSize * currentPage;
        let masterPageEndIndex = pageSize * (currentPage + 1) - 1;
        if (masterPageEndIndex > masterLastRowIndex) masterPageEndIndex = masterLastRowIndex;
        this.topDisplayedRowIndex = rowModel.getTopLevelRowDisplayedIndex(masterPageStartIndex);
        if (masterPageEndIndex === masterLastRowIndex) this.bottomDisplayedRowIndex = rowModel.getRowCount() - 1;
        else {
            const firstIndexNotToShow = rowModel.getTopLevelRowDisplayedIndex(masterPageEndIndex + 1);
            this.bottomDisplayedRowIndex = firstIndexNotToShow - 1;
        }
    }
    getMasterRowCount() {
        return this.masterRowCount;
    }
    calculatePagesAllRows() {
        const masterRowCount = this.beans.rowModel.getRowCount();
        this.masterRowCount = masterRowCount;
        if (masterRowCount === 0) {
            this.setZeroRows();
            return;
        }
        const { pageSize: pageSize, currentPage: currentPage } = this;
        const maxRowIndex = masterRowCount - 1;
        this.totalPages = Math.floor(maxRowIndex / pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        this.topDisplayedRowIndex = pageSize * currentPage;
        this.bottomDisplayedRowIndex = pageSize * (currentPage + 1) - 1;
        if (this.bottomDisplayedRowIndex > maxRowIndex) this.bottomDisplayedRowIndex = maxRowIndex;
    }
    calculatedPagesNotActive() {
        this.setPageSize(void 0, "autoCalculated");
        this.totalPages = 1;
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = this.beans.rowModel.getRowCount() - 1;
    }
    dispatchPaginationChangedEvent(params) {
        const { keepRenderedRows: keepRenderedRows = false, newPage: newPage = false, newPageSize: newPageSize = false } = params;
        this.eventSvc.dispatchEvent({
            type: "paginationChanged",
            animate: false,
            newData: false,
            newPage: newPage,
            newPageSize: newPageSize,
            keepRenderedRows: keepRenderedRows
        });
    }
};
// packages/ag-grid-community/src/pagination/paginationModule.ts
var $437b23f6a393c3bf$export$a57c5ed18afb0c4 = {
    moduleName: "Pagination",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PaginationService,
        $437b23f6a393c3bf$var$PaginationAutoPageSizeService
    ],
    icons: {
        // "go to first" button in pagination controls
        first: "first",
        // "go to previous" button in pagination controls
        previous: "previous",
        // "go to next" button in pagination controls
        next: "next",
        // "go to last" button in pagination controls
        last: "last"
    },
    apiFunctions: {
        paginationIsLastPageFound: $437b23f6a393c3bf$var$paginationIsLastPageFound,
        paginationGetPageSize: $437b23f6a393c3bf$var$paginationGetPageSize,
        paginationGetCurrentPage: $437b23f6a393c3bf$var$paginationGetCurrentPage,
        paginationGetTotalPages: $437b23f6a393c3bf$var$paginationGetTotalPages,
        paginationGetRowCount: $437b23f6a393c3bf$var$paginationGetRowCount,
        paginationGoToNextPage: $437b23f6a393c3bf$var$paginationGoToNextPage,
        paginationGoToPreviousPage: $437b23f6a393c3bf$var$paginationGoToPreviousPage,
        paginationGoToFirstPage: $437b23f6a393c3bf$var$paginationGoToFirstPage,
        paginationGoToLastPage: $437b23f6a393c3bf$var$paginationGoToLastPage,
        paginationGoToPage: $437b23f6a393c3bf$var$paginationGoToPage
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d
    ]
};
// packages/ag-grid-community/src/api/rowApi.ts
function $437b23f6a393c3bf$var$redrawRows(beans, params = {}) {
    const rowNodes = params ? params.rowNodes : void 0;
    beans.frameworkOverrides.wrapIncoming(()=>beans.rowRenderer.redrawRows(rowNodes));
}
function $437b23f6a393c3bf$var$setRowNodeExpanded(beans, rowNode, expanded, expandParents, forceSync) {
    if (rowNode) {
        if (expandParents && rowNode.parent && rowNode.parent.level !== -1) $437b23f6a393c3bf$var$setRowNodeExpanded(beans, rowNode.parent, expanded, expandParents, forceSync);
        rowNode.setExpanded(expanded, void 0, forceSync);
    }
}
function $437b23f6a393c3bf$var$getRowNode(beans, id) {
    return beans.rowModel.getRowNode(id);
}
function $437b23f6a393c3bf$var$addRenderedRowListener(beans, eventName, rowIndex, callback) {
    beans.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
}
function $437b23f6a393c3bf$var$getRenderedNodes(beans) {
    return beans.rowRenderer.getRenderedNodes();
}
function $437b23f6a393c3bf$var$forEachNode(beans, callback, includeFooterNodes) {
    beans.rowModel.forEachNode(callback, includeFooterNodes);
}
function $437b23f6a393c3bf$var$getFirstDisplayedRowIndex(beans) {
    return beans.rowRenderer.firstRenderedRow;
}
function $437b23f6a393c3bf$var$getLastDisplayedRowIndex(beans) {
    return beans.rowRenderer.lastRenderedRow;
}
function $437b23f6a393c3bf$var$getDisplayedRowAtIndex(beans, index) {
    return beans.rowModel.getRow(index);
}
function $437b23f6a393c3bf$var$getDisplayedRowCount(beans) {
    return beans.rowModel.getRowCount();
}
// packages/ag-grid-community/src/api/apiModule.ts
var $437b23f6a393c3bf$export$12e9d7df2a270583 = {
    moduleName: "RowApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        redrawRows: $437b23f6a393c3bf$var$redrawRows,
        setRowNodeExpanded: $437b23f6a393c3bf$var$setRowNodeExpanded,
        getRowNode: $437b23f6a393c3bf$var$getRowNode,
        addRenderedRowListener: $437b23f6a393c3bf$var$addRenderedRowListener,
        getRenderedNodes: $437b23f6a393c3bf$var$getRenderedNodes,
        forEachNode: $437b23f6a393c3bf$var$forEachNode,
        getFirstDisplayedRowIndex: $437b23f6a393c3bf$var$getFirstDisplayedRowIndex,
        getLastDisplayedRowIndex: $437b23f6a393c3bf$var$getLastDisplayedRowIndex,
        getDisplayedRowAtIndex: $437b23f6a393c3bf$var$getDisplayedRowAtIndex,
        getDisplayedRowCount: $437b23f6a393c3bf$var$getDisplayedRowCount
    }
};
var $437b23f6a393c3bf$export$351f260d7f887abc = {
    moduleName: "ScrollApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        getVerticalPixelRange: $437b23f6a393c3bf$var$getVerticalPixelRange,
        getHorizontalPixelRange: $437b23f6a393c3bf$var$getHorizontalPixelRange,
        ensureColumnVisible: $437b23f6a393c3bf$var$ensureColumnVisible,
        ensureIndexVisible: $437b23f6a393c3bf$var$ensureIndexVisible,
        ensureNodeVisible: $437b23f6a393c3bf$var$ensureNodeVisible
    }
};
// packages/ag-grid-community/src/rendering/renderApi.ts
function $437b23f6a393c3bf$var$setGridAriaProperty(beans, property, value) {
    if (!property) return;
    const eGrid = beans.ctrlsSvc.getGridBodyCtrl().eGridBody;
    const ariaProperty = `aria-${property}`;
    if (value === null) eGrid.removeAttribute(ariaProperty);
    else eGrid.setAttribute(ariaProperty, value);
}
function $437b23f6a393c3bf$var$refreshCells(beans, params = {}) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.rowRenderer.refreshCells(params));
}
function $437b23f6a393c3bf$var$refreshHeader(beans) {
    beans.frameworkOverrides.wrapIncoming(()=>{
        for (const c of beans.ctrlsSvc.getHeaderRowContainerCtrls())c.refresh();
    });
}
function $437b23f6a393c3bf$var$isAnimationFrameQueueEmpty(beans) {
    return beans.animationFrameSvc?.isQueueEmpty() ?? true;
}
function $437b23f6a393c3bf$var$flushAllAnimationFrames(beans) {
    beans.animationFrameSvc?.flushAllFrames();
}
function $437b23f6a393c3bf$var$getSizesForCurrentTheme(beans) {
    return {
        rowHeight: $437b23f6a393c3bf$export$8966875adec41e5b(beans),
        headerHeight: $437b23f6a393c3bf$var$getHeaderHeight(beans)
    };
}
function $437b23f6a393c3bf$var$getCellRendererInstances(beans, params = {}) {
    const cellRenderers = [];
    for (const cellCtrl of beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns)){
        const cellRenderer = cellCtrl.getCellRenderer();
        if (cellRenderer != null) cellRenderers.push($437b23f6a393c3bf$export$213d4c63c3df47e4(cellRenderer));
    }
    if (params.columns?.length) return cellRenderers;
    const fullWidthRenderers = [];
    const rowIdMap = $437b23f6a393c3bf$var$mapRowNodes(params.rowNodes);
    for (const rowCtrl of beans.rowRenderer.getAllRowCtrls()){
        if (rowIdMap && !$437b23f6a393c3bf$var$isRowInMap(rowCtrl.rowNode, rowIdMap)) continue;
        if (!rowCtrl.isFullWidth()) continue;
        const renderers = rowCtrl.getFullWidthCellRenderers();
        for(let i = 0; i < renderers.length; i++){
            const renderer = renderers[i];
            if (renderer != null) fullWidthRenderers.push($437b23f6a393c3bf$export$213d4c63c3df47e4(renderer));
        }
    }
    return [
        ...fullWidthRenderers,
        ...cellRenderers
    ];
}
// packages/ag-grid-community/src/rendering/renderModule.ts
var $437b23f6a393c3bf$export$b67b27f72da743ce = {
    moduleName: "RenderApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        setGridAriaProperty: $437b23f6a393c3bf$var$setGridAriaProperty,
        refreshCells: $437b23f6a393c3bf$var$refreshCells,
        refreshHeader: $437b23f6a393c3bf$var$refreshHeader,
        isAnimationFrameQueueEmpty: $437b23f6a393c3bf$var$isAnimationFrameQueueEmpty,
        flushAllAnimationFrames: $437b23f6a393c3bf$var$flushAllAnimationFrames,
        getSizesForCurrentTheme: $437b23f6a393c3bf$var$getSizesForCurrentTheme,
        getCellRendererInstances: $437b23f6a393c3bf$var$getCellRendererInstances
    }
};
// packages/ag-grid-community/src/columnAutosize/columnAutoSize.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnAutoSizeCSS = /*css*/ `:where(.ag-ltr) :where(.ag-animate-autosize){.ag-cell,.ag-header-cell,.ag-header-group-cell{transition:width .2s ease-in-out,left .2s ease-in-out}}:where(.ag-rtl) :where(.ag-animate-autosize){.ag-cell,.ag-header-cell,.ag-header-group-cell{transition:width .2s ease-in-out,right .2s ease-in-out}}`;
// packages/ag-grid-community/src/columnAutosize/columnAutosizeApi.ts
function $437b23f6a393c3bf$var$sizeColumnsToFit(beans, paramsOrGridWidth) {
    if (typeof paramsOrGridWidth === "number") beans.colAutosize?.sizeColumnsToFit(paramsOrGridWidth, "api");
    else beans.colAutosize?.sizeColumnsToFitGridBody(paramsOrGridWidth);
}
function $437b23f6a393c3bf$var$autoSizeColumns({ colAutosize: colAutosize, visibleCols: visibleCols }, keysOrParams, skipHeader) {
    if (Array.isArray(keysOrParams)) colAutosize?.autoSizeCols({
        colKeys: keysOrParams,
        skipHeader: skipHeader,
        source: "api"
    });
    else colAutosize?.autoSizeCols({
        ...keysOrParams,
        colKeys: keysOrParams.colIds ?? visibleCols.allCols,
        source: "api"
    });
}
function $437b23f6a393c3bf$var$autoSizeAllColumns(beans, paramsOrSkipHeader) {
    if (paramsOrSkipHeader && typeof paramsOrSkipHeader === "object") $437b23f6a393c3bf$var$autoSizeColumns(beans, paramsOrSkipHeader);
    else beans.colAutosize?.autoSizeAllColumns({
        source: "api",
        skipHeader: paramsOrSkipHeader
    });
}
// packages/ag-grid-community/src/columnAutosize/columnAutosizeService.ts
var $437b23f6a393c3bf$var$ColumnAutosizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colAutosize";
        this.timesDelayed = 0;
        /** when we're waiting for cell data types to be inferred, we need to defer column resizing */ this.shouldQueueResizeOperations = false;
        this.resizeOperationQueue = [];
    }
    postConstruct() {
        const { gos: gos } = this;
        const autoSizeStrategy = gos.get("autoSizeStrategy");
        if (autoSizeStrategy) {
            let shouldHideColumns = false;
            const type = autoSizeStrategy.type;
            if (type === "fitGridWidth" || type === "fitProvidedWidth") shouldHideColumns = true;
            else if (type === "fitCellContents") {
                this.addManagedEventListeners({
                    firstDataRendered: ()=>this.onFirstDataRendered(autoSizeStrategy)
                });
                const rowData = gos.get("rowData");
                shouldHideColumns = rowData != null && rowData.length > 0 && $437b23f6a393c3bf$export$9f182d9ca737e15(gos);
            }
            if (shouldHideColumns) this.beans.colDelayRenderSvc?.hideColumns(type);
        }
    }
    autoSizeCols(params) {
        const { eventSvc: eventSvc, visibleCols: visibleCols, colModel: colModel } = this.beans;
        $437b23f6a393c3bf$var$setWidthAnimation(this.beans, true);
        this.innerAutoSizeCols(params).then((columnsAutoSized)=>{
            const dispatch = (cols)=>$437b23f6a393c3bf$var$dispatchColumnResizedEvent(eventSvc, Array.from(cols), true, "autosizeColumns");
            if (!params.scaleUpToFitGridWidth) {
                $437b23f6a393c3bf$var$setWidthAnimation(this.beans, false);
                return dispatch(columnsAutoSized);
            }
            const availableGridWidth = $437b23f6a393c3bf$var$getAvailableWidth(this.beans);
            const isLeftCol = (col)=>visibleCols.leftCols.some((leftCol)=>$437b23f6a393c3bf$export$f5687d41c39fa1b3(leftCol, col));
            const isRightCol = (col)=>visibleCols.rightCols.some((rightCol)=>$437b23f6a393c3bf$export$f5687d41c39fa1b3(rightCol, col));
            const colKeys = params.colKeys.filter((col)=>{
                const allowAutoSize = !colModel.getCol(col)?.getColDef().suppressAutoSize;
                return allowAutoSize && !$437b23f6a393c3bf$export$3d3e7d751f0445eb(col) && !isLeftCol(col) && !isRightCol(col);
            });
            this.sizeColumnsToFit(availableGridWidth, params.source, true, {
                defaultMaxWidth: params.defaultMaxWidth,
                defaultMinWidth: params.defaultMinWidth,
                columnLimits: params.columnLimits?.map((limit)=>({
                        ...limit,
                        key: limit.colId
                    })),
                colKeys: colKeys,
                onlyScaleUp: true,
                animate: false
            });
            $437b23f6a393c3bf$var$setWidthAnimation(this.beans, false);
            dispatch(columnsAutoSized);
        });
    }
    innerAutoSizeCols(params) {
        return new Promise((resolve, reject)=>{
            if (this.shouldQueueResizeOperations) return this.pushResizeOperation(()=>this.innerAutoSizeCols(params).then(resolve, reject));
            const { colKeys: colKeys, skipHeader: skipHeader, skipHeaderGroups: skipHeaderGroups, stopAtGroup: stopAtGroup, defaultMaxWidth: defaultMaxWidth, defaultMinWidth: defaultMinWidth, columnLimits: columnLimits = [], source: source = "api" } = params;
            const { animationFrameSvc: animationFrameSvc, renderStatus: renderStatus, colModel: colModel, autoWidthCalc: autoWidthCalc, visibleCols: visibleCols } = this.beans;
            animationFrameSvc?.flushAllFrames();
            if (this.timesDelayed < 5 && renderStatus && (!renderStatus.areHeaderCellsRendered() || !renderStatus.areCellsRendered())) {
                this.timesDelayed++;
                setTimeout(()=>{
                    if (this.isAlive()) this.innerAutoSizeCols(params).then(resolve, reject);
                });
                return;
            }
            this.timesDelayed = 0;
            const columnsAutoSized = /* @__PURE__ */ new Set();
            let changesThisTimeAround = -1;
            const columnLimitsIndex = Object.fromEntries(columnLimits.map(({ colId: colId, ...dimensions })=>[
                    colId,
                    dimensions
                ]));
            const shouldSkipHeader = skipHeader ?? this.gos.get("skipHeaderOnAutoSize");
            const shouldSkipHeaderGroups = skipHeaderGroups ?? shouldSkipHeader;
            while(changesThisTimeAround !== 0){
                changesThisTimeAround = 0;
                const updatedColumns = [];
                for (const key of colKeys){
                    if (!key || $437b23f6a393c3bf$export$ee97d5717f8d44ec(key)) continue;
                    const column = colModel.getCol(key);
                    if (!column || columnsAutoSized.has(column) || column.getColDef().suppressAutoSize) continue;
                    const preferredWidth = autoWidthCalc.getPreferredWidthForColumn(column, shouldSkipHeader);
                    if (preferredWidth > 0) {
                        const columnLimit = columnLimitsIndex[column.colId] ?? {};
                        columnLimit.minWidth ?? (columnLimit.minWidth = defaultMinWidth);
                        columnLimit.maxWidth ?? (columnLimit.maxWidth = defaultMaxWidth);
                        const newWidth = $437b23f6a393c3bf$var$normaliseColumnWidth(column, preferredWidth, columnLimit);
                        column.setActualWidth(newWidth, source);
                        columnsAutoSized.add(column);
                        changesThisTimeAround++;
                    }
                    updatedColumns.push(column);
                }
                if (updatedColumns.length) visibleCols.refresh(source);
            }
            if (!shouldSkipHeaderGroups) this.autoSizeColumnGroupsByColumns(colKeys, source, stopAtGroup);
            resolve(columnsAutoSized);
        });
    }
    autoSizeColumn(key, source, skipHeader) {
        this.autoSizeCols({
            colKeys: [
                key
            ],
            skipHeader: skipHeader,
            skipHeaderGroups: true,
            source: source
        });
    }
    autoSizeColumnGroupsByColumns(keys, source, stopAtGroup) {
        const { colModel: colModel, ctrlsSvc: ctrlsSvc } = this.beans;
        const columnGroups = /* @__PURE__ */ new Set();
        const columns = colModel.getColsForKeys(keys);
        for (const col of columns){
            let parent = col.getParent();
            while(parent && parent != stopAtGroup){
                if (!parent.isPadding()) columnGroups.add(parent);
                parent = parent.getParent();
            }
        }
        let headerGroupCtrl;
        for (const columnGroup of columnGroups){
            for (const headerContainerCtrl of ctrlsSvc.getHeaderRowContainerCtrls()){
                headerGroupCtrl = headerContainerCtrl.getHeaderCtrlForColumn(columnGroup);
                if (headerGroupCtrl) break;
            }
            headerGroupCtrl?.resizeLeafColumnsToFit(source);
        }
    }
    autoSizeAllColumns(params) {
        if (this.shouldQueueResizeOperations) {
            this.pushResizeOperation(()=>this.autoSizeAllColumns(params));
            return;
        }
        this.autoSizeCols({
            colKeys: this.beans.visibleCols.allCols,
            ...params
        });
    }
    addColumnAutosizeListeners(element, column) {
        const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
        const autoSizeColListener = ()=>{
            this.autoSizeColumn(column, "uiColumnResized", skipHeaderOnAutoSize);
        };
        element.addEventListener("dblclick", autoSizeColListener);
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(element);
        touchListener.addEventListener("doubleTap", autoSizeColListener);
        return ()=>{
            element.removeEventListener("dblclick", autoSizeColListener);
            touchListener.destroy();
        };
    }
    addColumnGroupResize(element, columnGroup, callback) {
        const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
        const listener = ()=>{
            const keys = [];
            const leafCols = columnGroup.getDisplayedLeafColumns();
            for (const column of leafCols)if (!column.getColDef().suppressAutoSize) keys.push(column.getColId());
            if (keys.length > 0) this.autoSizeCols({
                colKeys: keys,
                skipHeader: skipHeaderOnAutoSize,
                stopAtGroup: columnGroup,
                source: "uiColumnResized"
            });
            callback();
        };
        element.addEventListener("dblclick", listener);
        return ()=>element.removeEventListener("dblclick", listener);
    }
    // method will call itself if no available width. this covers if the grid
    // isn't visible, but is just about to be visible.
    sizeColumnsToFitGridBody(params, nextTimeout) {
        if (!this.isAlive()) return;
        const availableWidth = $437b23f6a393c3bf$var$getAvailableWidth(this.beans);
        if (availableWidth > 0) {
            this.sizeColumnsToFit(availableWidth, "sizeColumnsToFit", false, params);
            return;
        }
        if (nextTimeout === void 0) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, 100);
        }, 0);
        else if (nextTimeout === 100) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, 500);
        }, 100);
        else if (nextTimeout === 500) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, -1);
        }, 500);
        else $437b23f6a393c3bf$export$545083624300f13d(29);
    }
    // called from api
    sizeColumnsToFit(gridWidth, source = "sizeColumnsToFit", silent, params) {
        if (this.shouldQueueResizeOperations) {
            this.pushResizeOperation(()=>this.sizeColumnsToFit(gridWidth, source, silent, params));
            return;
        }
        const { beans: beans } = this;
        const animate = params?.animate ?? true;
        if (animate) $437b23f6a393c3bf$var$setWidthAnimation(beans, true);
        const limitsMap = {};
        for (const { key: key, ...dimensions } of params?.columnLimits ?? [])limitsMap[typeof key === "string" ? key : key.getColId()] = dimensions;
        const allDisplayedColumns = beans.visibleCols.allCols;
        if (gridWidth <= 0 || !allDisplayedColumns.length) return;
        const currentTotalColumnWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(allDisplayedColumns);
        if (params?.onlyScaleUp && currentTotalColumnWidth > gridWidth) return;
        const doColumnsAlreadyFit = gridWidth === currentTotalColumnWidth;
        if (doColumnsAlreadyFit) {
            const doAllColumnsSatisfyConstraints = allDisplayedColumns.every((column)=>{
                if (column.colDef.suppressSizeToFit) return true;
                const widthOverride = limitsMap?.[column.getId()];
                const minWidth = widthOverride?.minWidth ?? params?.defaultMinWidth;
                const maxWidth = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
                const colWidth = column.getActualWidth();
                return (minWidth == null || colWidth >= minWidth) && (maxWidth == null || colWidth <= maxWidth);
            });
            if (doAllColumnsSatisfyConstraints) return;
        }
        const colsToSpread = [];
        const colsToNotSpread = [];
        for (const column of allDisplayedColumns){
            const isIncluded = params?.colKeys?.some((key)=>$437b23f6a393c3bf$export$f5687d41c39fa1b3(column, key)) ?? true;
            if (column.getColDef().suppressSizeToFit || !isIncluded) colsToNotSpread.push(column);
            else colsToSpread.push(column);
        }
        const colsToDispatchEventFor = colsToSpread.slice(0);
        let finishedResizing = false;
        const moveToNotSpread = (column)=>{
            $437b23f6a393c3bf$export$83a881c8b5120679(colsToSpread, column);
            colsToNotSpread.push(column);
        };
        for (const column of colsToSpread){
            column.resetActualWidth(source);
            const widthOverride = limitsMap?.[column.getId()];
            const minOverride = widthOverride?.minWidth ?? params?.defaultMinWidth;
            const maxOverride = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
            const colWidth = column.getActualWidth();
            if (typeof minOverride === "number" && colWidth < minOverride) column.setActualWidth(minOverride, source, true);
            else if (typeof maxOverride === "number" && colWidth > maxOverride) column.setActualWidth(maxOverride, source, true);
        }
        while(!finishedResizing){
            finishedResizing = true;
            const availablePixels = gridWidth - $437b23f6a393c3bf$var$getWidthOfColsInList(colsToNotSpread);
            if (availablePixels <= 0) for (const column of colsToSpread){
                const newWidth = limitsMap?.[column.getId()]?.minWidth ?? params?.defaultMinWidth ?? column.minWidth;
                column.setActualWidth(newWidth, source, true);
            }
            else {
                const scale = availablePixels / $437b23f6a393c3bf$var$getWidthOfColsInList(colsToSpread);
                let pixelsForLastCol = availablePixels;
                for(let i = colsToSpread.length - 1; i >= 0; i--){
                    const column = colsToSpread[i];
                    const widthOverride = limitsMap?.[column.getId()];
                    const minOverride = widthOverride?.minWidth ?? params?.defaultMinWidth;
                    const maxOverride = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
                    const colMinWidth = column.getMinWidth();
                    const colMaxWidth = column.getMaxWidth();
                    const minWidth = typeof minOverride === "number" && minOverride > colMinWidth ? minOverride : colMinWidth;
                    const maxWidth = typeof maxOverride === "number" && maxOverride < colMaxWidth ? maxOverride : colMaxWidth;
                    let newWidth = Math.round(column.getActualWidth() * scale);
                    if (newWidth < minWidth) {
                        newWidth = minWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if (newWidth > maxWidth) {
                        newWidth = maxWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if (i === 0) newWidth = pixelsForLastCol;
                    column.setActualWidth(newWidth, source, true);
                    pixelsForLastCol -= newWidth;
                }
            }
        }
        for (const col of colsToDispatchEventFor)col.fireColumnWidthChangedEvent(source);
        const visibleCols = beans.visibleCols;
        visibleCols.setLeftValues(source);
        visibleCols.updateBodyWidths();
        if (silent) return;
        $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, colsToDispatchEventFor, true, source);
        if (animate) $437b23f6a393c3bf$var$setWidthAnimation(beans, false);
    }
    applyAutosizeStrategy() {
        const { gos: gos, colDelayRenderSvc: colDelayRenderSvc } = this.beans;
        const autoSizeStrategy = gos.get("autoSizeStrategy");
        if (autoSizeStrategy?.type !== "fitGridWidth" && autoSizeStrategy?.type !== "fitProvidedWidth") return;
        setTimeout(()=>{
            if (!this.isAlive()) return;
            const type = autoSizeStrategy.type;
            if (type === "fitGridWidth") {
                const { columnLimits: propColumnLimits, defaultMinWidth: defaultMinWidth, defaultMaxWidth: defaultMaxWidth } = autoSizeStrategy;
                const columnLimits = propColumnLimits?.map(({ colId: key, minWidth: minWidth, maxWidth: maxWidth })=>({
                        key: key,
                        minWidth: minWidth,
                        maxWidth: maxWidth
                    }));
                this.sizeColumnsToFitGridBody({
                    defaultMinWidth: defaultMinWidth,
                    defaultMaxWidth: defaultMaxWidth,
                    columnLimits: columnLimits
                });
            } else if (type === "fitProvidedWidth") this.sizeColumnsToFit(autoSizeStrategy.width, "sizeColumnsToFit");
            colDelayRenderSvc?.revealColumns(type);
        });
    }
    onFirstDataRendered({ colIds: colKeys, ...params }) {
        setTimeout(()=>{
            if (!this.isAlive()) return;
            const source = "autosizeColumns";
            if (colKeys) this.autoSizeCols({
                ...params,
                source: source,
                colKeys: colKeys
            });
            else this.autoSizeAllColumns({
                ...params,
                source: source
            });
            this.beans.colDelayRenderSvc?.revealColumns(params.type);
        });
    }
    processResizeOperations() {
        this.shouldQueueResizeOperations = false;
        for (const resizeOperation of this.resizeOperationQueue)resizeOperation();
        this.resizeOperationQueue = [];
    }
    pushResizeOperation(func) {
        this.resizeOperationQueue.push(func);
    }
    destroy() {
        this.resizeOperationQueue.length = 0;
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$normaliseColumnWidth(column, newWidth, limits = {}) {
    const minWidth = limits.minWidth ?? column.getMinWidth();
    if (newWidth < minWidth) newWidth = minWidth;
    const maxWidth = limits.maxWidth ?? column.getMaxWidth();
    if (newWidth > maxWidth) newWidth = maxWidth;
    return newWidth;
}
function $437b23f6a393c3bf$var$getAvailableWidth({ ctrlsSvc: ctrlsSvc, scrollVisibleSvc: scrollVisibleSvc }) {
    const gridBodyCtrl = ctrlsSvc.getGridBodyCtrl();
    const removeScrollWidth = gridBodyCtrl.isVerticalScrollShowing();
    const scrollWidthToRemove = removeScrollWidth ? scrollVisibleSvc.getScrollbarWidth() : 0;
    const bodyViewportWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(gridBodyCtrl.eGridBody);
    return bodyViewportWidth - scrollWidthToRemove;
}
var $437b23f6a393c3bf$var$WIDTH_ANIMATION_CLASS = "ag-animate-autosize";
function $437b23f6a393c3bf$var$setWidthAnimation({ ctrlsSvc: ctrlsSvc, gos: gos }, enable) {
    if (!gos.get("animateColumnResizing") || gos.get("enableRtl") || !ctrlsSvc.isAlive()) return;
    const classList = ctrlsSvc.getGridBodyCtrl().eGridBody.classList;
    if (enable) classList.add($437b23f6a393c3bf$var$WIDTH_ANIMATION_CLASS);
    else classList.remove($437b23f6a393c3bf$var$WIDTH_ANIMATION_CLASS);
}
// packages/ag-grid-community/src/columnAutosize/columnAutosizeModule.ts
var $437b23f6a393c3bf$export$baf19ca56ec781d2 = {
    moduleName: "ColumnAutoSize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnAutosizeService
    ],
    apiFunctions: {
        sizeColumnsToFit: $437b23f6a393c3bf$var$sizeColumnsToFit,
        autoSizeColumns: $437b23f6a393c3bf$var$autoSizeColumns,
        autoSizeAllColumns: $437b23f6a393c3bf$var$autoSizeAllColumns
    },
    dependsOn: [
        $437b23f6a393c3bf$var$AutoWidthModule
    ],
    css: [
        $437b23f6a393c3bf$var$columnAutoSizeCSS
    ]
};
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRow.css-GENERATED.ts
var $437b23f6a393c3bf$var$manualPinnedRowCSS = /*css*/ `.ag-row-pinned-source{background-color:var(--ag-pinned-source-row-background-color);color:var(--ag-pinned-source-row-text-color);font-weight:var(--ag-pinned-source-row-font-weight)}.ag-row-pinned-manual{background-color:var(--ag-pinned-row-background-color);color:var(--ag-pinned-row-text-color);font-weight:var(--ag-pinned-row-font-weight)}`;
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowApi.ts
function $437b23f6a393c3bf$var$getPinnedTopRowCount(beans) {
    return beans.pinnedRowModel?.getPinnedTopRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getPinnedBottomRowCount(beans) {
    return beans.pinnedRowModel?.getPinnedBottomRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getPinnedTopRow(beans, index) {
    return beans.pinnedRowModel?.getPinnedTopRow(index);
}
function $437b23f6a393c3bf$var$getPinnedBottomRow(beans, index) {
    return beans.pinnedRowModel?.getPinnedBottomRow(index);
}
function $437b23f6a393c3bf$var$forEachPinnedRow(beans, floating, callback) {
    return beans.pinnedRowModel?.forEachPinnedRow(floating, callback);
}
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowModule.ts
var $437b23f6a393c3bf$export$b6e84cdeabbb116a = {
    moduleName: "PinnedRow",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$export$d44126a5f53c99d9
    ],
    css: [
        $437b23f6a393c3bf$var$manualPinnedRowCSS
    ],
    apiFunctions: {
        getPinnedTopRowCount: $437b23f6a393c3bf$var$getPinnedTopRowCount,
        getPinnedBottomRowCount: $437b23f6a393c3bf$var$getPinnedBottomRowCount,
        getPinnedTopRow: $437b23f6a393c3bf$var$getPinnedTopRow,
        getPinnedBottomRow: $437b23f6a393c3bf$var$getPinnedBottomRow,
        forEachPinnedRow: $437b23f6a393c3bf$var$forEachPinnedRow
    },
    icons: {
        rowPin: "pin",
        rowPinTop: "pinned-top",
        rowPinBottom: "pinned-bottom",
        rowUnpin: "un-pin"
    }
};
// packages/ag-grid-community/src/rendering/spanning/rowSpanCache.ts
var $437b23f6a393c3bf$var$CellSpan = class {
    constructor(col, firstNode){
        this.col = col;
        this.firstNode = firstNode;
        // used for distinguishing between types
        this.cellSpan = true;
        this.spannedNodes = /* @__PURE__ */ new Set();
        this.addSpannedNode(firstNode);
    }
    /**
   * Reset the span leaving only the head.
   * Head is used as a comparison as this is the row used to render this cell
   * Even if the row data changes, the cell will properly reflect the correct value.
   */ reset() {
        this.spannedNodes.clear();
        this.addSpannedNode(this.firstNode);
    }
    addSpannedNode(node) {
        this.spannedNodes.add(node);
        this.lastNode = node;
    }
    getLastNode() {
        return this.lastNode;
    }
    getCellHeight() {
        return this.lastNode.rowTop + this.lastNode.rowHeight - this.firstNode.rowTop - 1;
    }
    doesSpanContain(cellPosition) {
        if (cellPosition.column !== this.col) return false;
        if (cellPosition.rowPinned != this.firstNode.rowPinned) return false;
        return this.firstNode.rowIndex <= cellPosition.rowIndex && cellPosition.rowIndex <= this.lastNode.rowIndex;
    }
    /**
   * Gets the auto height value for last node in the spanned cell.
   * The first node is used to store the auto height for the cell, but the additional height for this cell
   * needs applied to the last row in the span.
   */ getLastNodeAutoHeight() {
        const autoHeight = this.firstNode.__autoHeights?.[this.col.getColId()];
        if (autoHeight == null) return void 0;
        let allButLastHeights = 0;
        for (const node of this.spannedNodes){
            if (node === this.lastNode) continue;
            allButLastHeights += node.rowHeight;
        }
        return autoHeight - allButLastHeights;
    }
};
var $437b23f6a393c3bf$var$RowSpanCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column){
        super();
        this.column = column;
    }
    buildCache(pinned) {
        const { column: column, beans: { gos: gos, pinnedRowModel: pinnedRowModel, rowModel: rowModel, valueSvc: valueSvc, pagination: pagination } } = this;
        const { colDef: colDef } = column;
        const oldMap = this.getNodeMap(pinned);
        const newMap = /* @__PURE__ */ new Map();
        const isFullWidthCellFunc = gos.getCallback("isFullWidthRow");
        const equalsFnc = colDef.equals;
        const customCompare = colDef.spanRows;
        const isCustomCompare = typeof customCompare === "function";
        let lastNode = null;
        let spanData = null;
        let lastValue;
        const setNewHead = (node, value)=>{
            lastNode = node;
            spanData = null;
            lastValue = value;
        };
        const checkNodeForCache = (node)=>{
            const doesNodeSupportSpanning = !node.isExpandable() && !node.group && !node.detail && (isFullWidthCellFunc ? !isFullWidthCellFunc({
                rowNode: node
            }) : true);
            if (node.rowIndex == null || !doesNodeSupportSpanning) {
                setNewHead(null, null);
                return;
            }
            if (lastNode == null || node.level !== lastNode.level || // no span across groups
            node.footer || spanData && node.rowIndex - 1 !== spanData?.getLastNode().rowIndex) {
                setNewHead(node, valueSvc.getValue(column, node));
                return;
            }
            const value = valueSvc.getValue(column, node);
            if (isCustomCompare) {
                const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                    valueA: lastValue,
                    nodeA: lastNode,
                    valueB: value,
                    nodeB: node,
                    column: column,
                    colDef: colDef
                });
                if (!customCompare(params)) {
                    setNewHead(node, value);
                    return;
                }
            } else if (equalsFnc ? !equalsFnc(lastValue, value) : lastValue !== value) {
                setNewHead(node, value);
                return;
            }
            if (!spanData) {
                const oldSpan = oldMap?.get(lastNode);
                if (oldSpan?.firstNode === lastNode) {
                    oldSpan.reset();
                    spanData = oldSpan;
                } else spanData = new $437b23f6a393c3bf$var$CellSpan(column, lastNode);
                newMap.set(lastNode, spanData);
            }
            spanData.addSpannedNode(node);
            newMap.set(node, spanData);
        };
        switch(pinned){
            case "center":
                rowModel.forEachDisplayedNode?.((node)=>{
                    const isNodeInPage = !pagination || pagination.isRowInPage(node.rowIndex);
                    if (!isNodeInPage) return;
                    checkNodeForCache(node);
                });
                this.centerValueNodeMap = newMap;
                break;
            case "top":
                pinnedRowModel?.forEachPinnedRow("top", checkNodeForCache);
                this.topValueNodeMap = newMap;
                break;
            case "bottom":
                pinnedRowModel?.forEachPinnedRow("bottom", checkNodeForCache);
                this.bottomValueNodeMap = newMap;
                break;
        }
    }
    isCellSpanning(node) {
        return !!this.getCellSpan(node);
    }
    getCellSpan(node) {
        return this.getNodeMap(node.rowPinned).get(node);
    }
    getNodeMap(container) {
        switch(container){
            case "top":
                return this.topValueNodeMap;
            case "bottom":
                return this.bottomValueNodeMap;
            default:
                return this.centerValueNodeMap;
        }
    }
};
// packages/ag-grid-community/src/rendering/spanning/rowSpanService.ts
var $437b23f6a393c3bf$var$RowSpanService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowSpanSvc";
        this.spanningColumns = /* @__PURE__ */ new Map();
        // debounced to allow spannedRowRenderer to run first, removing any old spanned rows
        this.debouncePinnedEvent = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.dispatchCellsUpdatedEvent.bind(this, true), 0);
        this.debounceModelEvent = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.dispatchCellsUpdatedEvent.bind(this, false), 0);
        this.pinnedTimeout = null;
        this.modelTimeout = null;
    }
    postConstruct() {
        const onRowDataUpdated = this.onRowDataUpdated.bind(this);
        const buildPinnedCaches = this.buildPinnedCaches.bind(this);
        this.addManagedEventListeners({
            paginationChanged: this.buildModelCaches.bind(this),
            pinnedRowDataChanged: buildPinnedCaches,
            pinnedRowsChanged: buildPinnedCaches,
            rowNodeDataChanged: onRowDataUpdated,
            cellValueChanged: onRowDataUpdated
        });
    }
    /**
   * When a new column is created with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */ register(column) {
        const { gos: gos } = this.beans;
        if (!gos.get("enableCellSpan")) return;
        if (this.spanningColumns.has(column)) return;
        const cache = this.createManagedBean(new $437b23f6a393c3bf$var$RowSpanCache(column));
        this.spanningColumns.set(column, cache);
        cache.buildCache("top");
        cache.buildCache("bottom");
        cache.buildCache("center");
        this.debouncePinnedEvent();
        this.debounceModelEvent();
    }
    dispatchCellsUpdatedEvent(pinned) {
        this.dispatchLocalEvent({
            type: "spannedCellsUpdated",
            pinned: pinned
        });
    }
    /**
   * When a new column is destroyed with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */ deregister(column) {
        this.spanningColumns.delete(column);
    }
    // called when data changes, as this could be a hot path it's debounced
    // it uses timeouts instead of debounce so that it can be cancelled by `modelUpdated`
    // which is expected to run immediately (to exec before the rowRenderer)
    onRowDataUpdated({ node: node }) {
        const { spannedRowRenderer: spannedRowRenderer } = this.beans;
        if (node.rowPinned) {
            if (this.pinnedTimeout != null) return;
            this.pinnedTimeout = window.setTimeout(()=>{
                this.pinnedTimeout = null;
                this.buildPinnedCaches();
                spannedRowRenderer?.createCtrls("top");
                spannedRowRenderer?.createCtrls("bottom");
            }, 0);
            return;
        }
        if (this.modelTimeout != null) return;
        this.modelTimeout = window.setTimeout(()=>{
            this.modelTimeout = null;
            this.buildModelCaches();
            spannedRowRenderer?.createCtrls("center");
        }, 0);
    }
    buildModelCaches() {
        if (this.modelTimeout != null) clearTimeout(this.modelTimeout);
        this.spanningColumns.forEach((cache)=>cache.buildCache("center"));
        this.debounceModelEvent();
    }
    buildPinnedCaches() {
        if (this.pinnedTimeout != null) clearTimeout(this.pinnedTimeout);
        this.spanningColumns.forEach((cache)=>{
            cache.buildCache("top");
            cache.buildCache("bottom");
        });
        this.debouncePinnedEvent();
    }
    isCellSpanning(col, rowNode) {
        const cache = this.spanningColumns.get(col);
        if (!cache) return false;
        return cache.isCellSpanning(rowNode);
    }
    getCellSpanByPosition(position) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        const col = position.column;
        const index = position.rowIndex;
        const cache = this.spanningColumns.get(col);
        if (!cache) return void 0;
        let node;
        switch(position.rowPinned){
            case "top":
                node = pinnedRowModel?.getPinnedTopRow(index);
                break;
            case "bottom":
                node = pinnedRowModel?.getPinnedBottomRow(index);
                break;
            default:
                node = rowModel.getRow(index);
        }
        if (!node) return void 0;
        return cache.getCellSpan(node);
    }
    getCellStart(position) {
        const span = this.getCellSpanByPosition(position);
        if (!span) return position;
        return {
            ...position,
            rowIndex: span.firstNode.rowIndex
        };
    }
    getCellEnd(position) {
        const span = this.getCellSpanByPosition(position);
        if (!span) return position;
        return {
            ...position,
            rowIndex: span.getLastNode().rowIndex
        };
    }
    /**
   * Look-up a spanned cell given a col and node as position indicators
   *
   * @param col a column to lookup a span at this position
   * @param rowNode a node that may be spanned at this position
   * @returns the CellSpan object if one exists
   */ getCellSpan(col, rowNode) {
        const cache = this.spanningColumns.get(col);
        if (!cache) return void 0;
        return cache.getCellSpan(rowNode);
    }
    forEachSpannedColumn(rowNode, callback) {
        for (const [col, cache] of this.spanningColumns)if (cache.isCellSpanning(rowNode)) {
            const spanningNode = cache.getCellSpan(rowNode);
            callback(col, spanningNode);
        }
    }
    destroy() {
        super.destroy();
        this.spanningColumns.clear();
    }
};
// packages/ag-grid-community/src/rendering/spanning/spannedCellCtrl.ts
var $437b23f6a393c3bf$var$SpannedCellCtrl = class extends $437b23f6a393c3bf$var$CellCtrl {
    constructor(cellSpan, rowCtrl, beans){
        super(cellSpan.col, cellSpan.firstNode, beans, rowCtrl);
        this.cellSpan = cellSpan;
        this.SPANNED_CELL_CSS_CLASS = "ag-spanned-cell";
    }
    setComp(comp, eCell, eWrapper, eCellWrapper, printLayout, startEditing, compBean) {
        this.eWrapper = eWrapper;
        super.setComp(comp, eCell, eWrapper, eCellWrapper, printLayout, startEditing, compBean);
        this.setAriaRowSpan();
        this.refreshAriaRowIndex();
    }
    isCellSpanning() {
        return true;
    }
    getCellSpan() {
        return this.cellSpan;
    }
    /**
   * When cell is spanning, ensure row index is also available on the cell
   */ refreshAriaRowIndex() {
        const { eGui: eGui, rowNode: rowNode } = this;
        if (!eGui || rowNode.rowIndex == null) return;
        $437b23f6a393c3bf$export$ba731dedf9d88615(eGui, rowNode.rowIndex);
    }
    /**
   * When cell is spanning, ensure row index is also available on the cell
   */ setAriaRowSpan() {
        $437b23f6a393c3bf$var$_setAriaRowSpan(this.eGui, this.cellSpan.spannedNodes.size);
    }
    // not ideal, for tabbing need to force the focused position
    setFocusedCellPosition(cellPos) {
        this.focusedCellPosition = cellPos;
    }
    getFocusedCellPosition() {
        return this.focusedCellPosition ?? this.cellPosition;
    }
    checkCellFocused() {
        const focusedCell = this.beans.focusSvc.getFocusedCell();
        return !!focusedCell && this.cellSpan.doesSpanContain(focusedCell);
    }
    applyStaticCssClasses() {
        super.applyStaticCssClasses();
        this.comp.toggleCss(this.SPANNED_CELL_CSS_CLASS, true);
    }
    onCellFocused(event) {
        const { beans: beans } = this;
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(beans)) {
            this.focusedCellPosition = void 0;
            return;
        }
        const cellFocused = this.isCellFocused();
        if (!cellFocused) this.focusedCellPosition = void 0;
        if (event && cellFocused) this.focusedCellPosition = {
            rowIndex: event.rowIndex,
            rowPinned: event.rowPinned,
            column: event.column
        };
        super.onCellFocused(event);
    }
    getRootElement() {
        return this.eWrapper;
    }
};
// packages/ag-grid-community/src/rendering/spanning/spannedRowCtrl.ts
var $437b23f6a393c3bf$var$SpannedRowCtrl = class extends $437b23f6a393c3bf$var$RowCtrl {
    onRowIndexChanged() {
        super.onRowIndexChanged();
        for (const c of this.getAllCellCtrls())c.refreshAriaRowIndex();
    }
    getInitialRowClasses(_rowContainerType) {
        return [
            "ag-spanned-row"
        ];
    }
    getNewCellCtrl(col) {
        const cellSpan = this.beans.rowSpanSvc?.getCellSpan(col, this.rowNode);
        if (!cellSpan) return;
        const firstRowOfSpan = cellSpan.firstNode !== this.rowNode;
        if (firstRowOfSpan) return;
        return new $437b23f6a393c3bf$var$SpannedCellCtrl(cellSpan, this, this.beans);
    }
    isCorrectCtrlForSpan(cell) {
        const cellSpan = this.beans.rowSpanSvc?.getCellSpan(cell.column, this.rowNode);
        if (!cellSpan) return false;
        const firstRowOfSpan = cellSpan.firstNode !== this.rowNode;
        if (firstRowOfSpan) return false;
        return cell.getCellSpan() === cellSpan;
    }
    /**
   * Below overrides are explicitly disabling styling and other unwanted behaviours for spannedRowCtrl
   */ // row height should be 0 in spanned row - they're only included for purpose of aria
    onRowHeightChanged() {}
    // no styling spanned rows
    refreshFirstAndLastRowStyles() {}
    // no hover functionality for spanned rows
    addHoverFunctionality() {}
    resetHoveredStatus() {}
};
// packages/ag-grid-community/src/rendering/spanning/spannedRowRenderer.ts
var $437b23f6a393c3bf$var$SpannedRowRenderer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "spannedRowRenderer";
        this.topCtrls = /* @__PURE__ */ new Map();
        this.bottomCtrls = /* @__PURE__ */ new Map();
        this.centerCtrls = /* @__PURE__ */ new Map();
    }
    postConstruct() {
        this.addManagedEventListeners({
            displayedRowsChanged: this.createAllCtrls.bind(this)
        });
    }
    createAllCtrls() {
        this.createCtrls("top");
        this.createCtrls("bottom");
        this.createCtrls("center");
    }
    /**
   * When displayed rows or cols change, the spanned cell ctrls need to update
   */ createCtrls(ctrlsKey) {
        const { rowSpanSvc: rowSpanSvc } = this.beans;
        const previousCtrls = this.getCtrlsMap(ctrlsKey);
        const previousCtrlsSize = previousCtrls.size;
        const rowCtrls = this.getAllRelevantRowControls(ctrlsKey);
        const newRowCtrls = /* @__PURE__ */ new Map();
        let hasNewSpans = false;
        for (const ctrl of rowCtrls){
            if (!ctrl.isAlive()) continue;
            rowSpanSvc?.forEachSpannedColumn(ctrl.rowNode, (col, cellSpan)=>{
                if (newRowCtrls.has(cellSpan.firstNode)) return;
                const existingCtrl = previousCtrls.get(cellSpan.firstNode);
                if (existingCtrl) {
                    newRowCtrls.set(cellSpan.firstNode, existingCtrl);
                    previousCtrls.delete(cellSpan.firstNode);
                    return;
                }
                hasNewSpans = true;
                const newCtrl = new $437b23f6a393c3bf$var$SpannedRowCtrl(cellSpan.firstNode, this.beans, false, false, false);
                newRowCtrls.set(cellSpan.firstNode, newCtrl);
            });
        }
        this.setCtrlsMap(ctrlsKey, newRowCtrls);
        const sameCount = newRowCtrls.size === previousCtrlsSize;
        if (!hasNewSpans && sameCount) return;
        for (const oldCtrl of previousCtrls.values()){
            oldCtrl.destroyFirstPass(true);
            oldCtrl.destroySecondPass();
        }
        this.dispatchLocalEvent({
            type: `spannedRowsUpdated`,
            ctrlsKey: ctrlsKey
        });
    }
    // cannot use getAllRowCtrls as it returns this services row ctrls.
    getAllRelevantRowControls(ctrlsKey) {
        const { rowRenderer: rowRenderer } = this.beans;
        switch(ctrlsKey){
            case "top":
                return rowRenderer.topRowCtrls;
            case "bottom":
                return rowRenderer.bottomRowCtrls;
            case "center":
                return rowRenderer.allRowCtrls;
        }
    }
    getCellByPosition(cellPosition) {
        const { rowSpanSvc: rowSpanSvc } = this.beans;
        const cellSpan = rowSpanSvc?.getCellSpanByPosition(cellPosition);
        if (!cellSpan) return void 0;
        const ctrl = this.getCtrlsMap(cellPosition.rowPinned).get(cellSpan.firstNode);
        if (!ctrl) return void 0;
        return ctrl.getAllCellCtrls().find((cellCtrl)=>cellCtrl.column === cellPosition.column);
    }
    getCtrls(container) {
        return [
            ...this.getCtrlsMap(container).values()
        ];
    }
    destroyRowCtrls(container) {
        for (const ctrl of this.getCtrlsMap(container).values()){
            ctrl.destroyFirstPass(true);
            ctrl.destroySecondPass();
        }
        this.setCtrlsMap(container, /* @__PURE__ */ new Map());
    }
    getCtrlsMap(container) {
        switch(container){
            case "top":
                return this.topCtrls;
            case "bottom":
                return this.bottomCtrls;
            default:
                return this.centerCtrls;
        }
    }
    setCtrlsMap(container, map) {
        switch(container){
            case "top":
                this.topCtrls = map;
                break;
            case "bottom":
                this.bottomCtrls = map;
                break;
            default:
                this.centerCtrls = map;
                break;
        }
    }
    destroy() {
        super.destroy();
        this.destroyRowCtrls("top");
        this.destroyRowCtrls("bottom");
        this.destroyRowCtrls("center");
    }
};
// packages/ag-grid-community/src/rendering/spanning/cellSpanModule.ts
var $437b23f6a393c3bf$export$b7ca1fc11bfe19c3 = {
    moduleName: "CellSpan",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowSpanService,
        $437b23f6a393c3bf$var$SpannedRowRenderer
    ]
};
// packages/ag-grid-community/src/styling/cellCustomStyleFeature.ts
var $437b23f6a393c3bf$var$CellCustomStyleFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans){
        super();
        this.cellCtrl = cellCtrl;
        this.staticClasses = [];
        this.beans = beans;
        this.column = cellCtrl.column;
    }
    setComp(comp) {
        this.cellComp = comp;
        this.applyUserStyles();
        this.applyCellClassRules();
        this.applyClassesFromColDef();
    }
    applyCellClassRules() {
        const { column: column, cellComp: cellComp } = this;
        const colDef = column.colDef;
        const cellClassRules = colDef.cellClassRules;
        const cellClassParams = this.getCellClassParams(column, colDef);
        $437b23f6a393c3bf$var$processClassRules(this.beans.expressionSvc, // if current was previous, skip
        cellClassRules === this.cellClassRules ? void 0 : this.cellClassRules, cellClassRules, cellClassParams, (className)=>cellComp.toggleCss(className, true), (className)=>cellComp.toggleCss(className, false));
        this.cellClassRules = cellClassRules;
    }
    applyUserStyles() {
        const column = this.column;
        const colDef = column.colDef;
        const cellStyle = colDef.cellStyle;
        if (!cellStyle) return;
        let styles;
        if (typeof cellStyle === "function") {
            const cellStyleParams = this.getCellClassParams(column, colDef);
            styles = cellStyle(cellStyleParams);
        } else styles = cellStyle;
        if (styles) this.cellComp.setUserStyles(styles);
    }
    applyClassesFromColDef() {
        const { column: column, cellComp: cellComp } = this;
        const colDef = column.colDef;
        const cellClassParams = this.getCellClassParams(column, colDef);
        for (const className of this.staticClasses)cellComp.toggleCss(className, false);
        const newStaticClasses = this.beans.cellStyles.getStaticCellClasses(colDef, cellClassParams);
        this.staticClasses = newStaticClasses;
        for (const className of newStaticClasses)cellComp.toggleCss(className, true);
    }
    getCellClassParams(column, colDef) {
        const { value: value, rowNode: rowNode } = this.cellCtrl;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.beans.gos, {
            value: value,
            data: rowNode.data,
            node: rowNode,
            colDef: colDef,
            column: column,
            rowIndex: rowNode.rowIndex
        });
    }
};
// packages/ag-grid-community/src/styling/cellStyleService.ts
var $437b23f6a393c3bf$var$CellStyleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellStyles";
    }
    processAllCellClasses(colDef, params, onApplicableClass, onNotApplicableClass) {
        $437b23f6a393c3bf$var$processClassRules(this.beans.expressionSvc, void 0, colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
        this.processStaticCellClasses(colDef, params, onApplicableClass);
    }
    getStaticCellClasses(colDef, params) {
        const { cellClass: cellClass } = colDef;
        if (!cellClass) return [];
        let classOrClasses;
        if (typeof cellClass === "function") {
            const cellClassFunc = cellClass;
            classOrClasses = cellClassFunc(params);
        } else classOrClasses = cellClass;
        if (typeof classOrClasses === "string") classOrClasses = [
            classOrClasses
        ];
        return classOrClasses || [];
    }
    createCellCustomStyleFeature(ctrl) {
        return new $437b23f6a393c3bf$var$CellCustomStyleFeature(ctrl, this.beans);
    }
    processStaticCellClasses(colDef, params, onApplicableClass) {
        const classOrClasses = this.getStaticCellClasses(colDef, params);
        classOrClasses.forEach((cssClassItem)=>{
            onApplicableClass(cssClassItem);
        });
    }
};
// packages/ag-grid-community/src/styling/stylingModule.ts
var $437b23f6a393c3bf$export$be75c2ed74fb2144 = {
    moduleName: "CellStyle",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CellStyleService
    ]
};
var $437b23f6a393c3bf$export$dbb09c7a8266fd30 = {
    moduleName: "RowStyle",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowStyleService
    ]
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverApi.ts
function $437b23f6a393c3bf$var$isColumnHovered(beans, column) {
    return !!beans.colHover?.isHovered(column);
}
// packages/ag-grid-community/src/columns/columnHover/hoverFeature.ts
var $437b23f6a393c3bf$var$HoverFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(columns, element){
        super();
        this.columns = columns;
        this.element = element;
        this.destroyManagedListeners = [];
        this.enableFeature = (enabled)=>{
            const { beans: beans, gos: gos, element: element, columns: columns } = this;
            const colHover = beans.colHover;
            const active = enabled ?? !!gos.get("columnHoverHighlight");
            if (active) this.destroyManagedListeners = this.addManagedElementListeners(element, {
                mouseover: colHover.setMouseOver.bind(colHover, columns),
                mouseout: colHover.clearMouseOver.bind(colHover)
            });
            else {
                for (const fn of this.destroyManagedListeners)fn();
                this.destroyManagedListeners = [];
            }
        };
    }
    postConstruct() {
        this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: currentValue })=>{
            this.enableFeature(currentValue);
        });
        this.enableFeature();
    }
    destroy() {
        super.destroy();
        this.destroyManagedListeners = null;
    }
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverService.ts
var $437b23f6a393c3bf$var$CSS_COLUMN_HOVER = "ag-column-hover";
var $437b23f6a393c3bf$var$ColumnHoverService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colHover";
    }
    postConstruct() {
        this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: currentValue })=>{
            if (!currentValue) this.clearMouseOver();
        });
    }
    setMouseOver(columns) {
        this.updateState(columns);
    }
    clearMouseOver() {
        this.updateState(null);
    }
    isHovered(column) {
        if (!this.gos.get("columnHoverHighlight")) return false;
        const selectedColumns = this.selectedColumns;
        return !!selectedColumns && selectedColumns.indexOf(column) >= 0;
    }
    addHeaderColumnHoverListener(compBean, comp, column) {
        const listener = ()=>{
            const isHovered = this.isHovered(column);
            comp.toggleCss("ag-column-hover", isHovered);
        };
        compBean.addManagedEventListeners({
            columnHoverChanged: listener
        });
        listener();
    }
    onCellColumnHover(column, cellComp) {
        if (!cellComp) return;
        const isHovered = this.isHovered(column);
        cellComp.toggleCss($437b23f6a393c3bf$var$CSS_COLUMN_HOVER, isHovered);
    }
    addHeaderFilterColumnHoverListener(compBean, comp, column, eGui) {
        this.createHoverFeature(compBean, [
            column
        ], eGui);
        const listener = ()=>{
            const hovered = this.isHovered(column);
            comp.toggleCss("ag-column-hover", hovered);
        };
        compBean.addManagedEventListeners({
            columnHoverChanged: listener
        });
        listener();
    }
    createHoverFeature(compBean, columns, eGui) {
        compBean.createManagedBean(new $437b23f6a393c3bf$var$HoverFeature(columns, eGui));
    }
    updateState(columns) {
        this.selectedColumns = columns;
        this.eventSvc.dispatchEvent({
            type: "columnHoverChanged"
        });
    }
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverModule.ts
var $437b23f6a393c3bf$export$ca683b579c0df457 = {
    moduleName: "ColumnHover",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnHoverService
    ],
    apiFunctions: {
        isColumnHovered: $437b23f6a393c3bf$var$isColumnHovered
    }
};
// packages/ag-grid-community/src/misc/apiEvents/apiEventService.ts
var $437b23f6a393c3bf$var$ApiEventService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "apiEventSvc";
        this.syncListeners = /* @__PURE__ */ new Map();
        this.asyncListeners = /* @__PURE__ */ new Map();
        this.syncGlobalListeners = /* @__PURE__ */ new Set();
        this.globalListenerPairs = /* @__PURE__ */ new Map();
    }
    postConstruct() {
        this.wrapSvc = this.beans.frameworkOverrides.createGlobalEventListenerWrapper?.();
    }
    addListener(eventType, userListener) {
        const listener = this.wrapSvc?.wrap(eventType, userListener) ?? userListener;
        const async = !$437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType);
        const listeners = async ? this.asyncListeners : this.syncListeners;
        if (!listeners.has(eventType)) listeners.set(eventType, /* @__PURE__ */ new Set());
        listeners.get(eventType).add(listener);
        this.eventSvc.addListener(eventType, listener, async);
    }
    removeListener(eventType, userListener) {
        const listener = this.wrapSvc?.unwrap(eventType, userListener) ?? userListener;
        const asyncListeners = this.asyncListeners.get(eventType);
        const hasAsync = !!asyncListeners?.delete(listener);
        if (!hasAsync) this.syncListeners.get(eventType)?.delete(listener);
        this.eventSvc.removeListener(eventType, listener, hasAsync);
    }
    addGlobalListener(userListener) {
        const listener = this.wrapSvc?.wrapGlobal(userListener) ?? userListener;
        const syncListener = (eventType, event)=>{
            if ($437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType)) listener(eventType, event);
        };
        const asyncListener = (eventType, event)=>{
            if (!$437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType)) listener(eventType, event);
        };
        this.globalListenerPairs.set(userListener, {
            syncListener: syncListener,
            asyncListener: asyncListener
        });
        const eventSvc = this.eventSvc;
        eventSvc.addGlobalListener(syncListener, false);
        eventSvc.addGlobalListener(asyncListener, true);
    }
    removeGlobalListener(userListener) {
        const { eventSvc: eventSvc, wrapSvc: wrapSvc, globalListenerPairs: globalListenerPairs } = this;
        const listener = wrapSvc?.unwrapGlobal(userListener) ?? userListener;
        const hasAsync = globalListenerPairs.has(listener);
        if (hasAsync) {
            const { syncListener: syncListener, asyncListener: asyncListener } = globalListenerPairs.get(listener);
            eventSvc.removeGlobalListener(syncListener, false);
            eventSvc.removeGlobalListener(asyncListener, true);
            globalListenerPairs.delete(userListener);
        } else {
            this.syncGlobalListeners.delete(listener);
            eventSvc.removeGlobalListener(listener, false);
        }
    }
    destroyEventListeners(map, async) {
        map.forEach((listeners, eventType)=>{
            listeners.forEach((listener)=>this.eventSvc.removeListener(eventType, listener, async));
            listeners.clear();
        });
        map.clear();
    }
    destroyGlobalListeners(set, async) {
        for (const listener of set)this.eventSvc.removeGlobalListener(listener, async);
        set.clear();
    }
    destroy() {
        super.destroy();
        this.destroyEventListeners(this.syncListeners, false);
        this.destroyEventListeners(this.asyncListeners, true);
        this.destroyGlobalListeners(this.syncGlobalListeners, false);
        const { globalListenerPairs: globalListenerPairs, eventSvc: eventSvc } = this;
        globalListenerPairs.forEach(({ syncListener: syncListener, asyncListener: asyncListener })=>{
            eventSvc.removeGlobalListener(syncListener, false);
            eventSvc.removeGlobalListener(asyncListener, true);
        });
        globalListenerPairs.clear();
    }
};
// packages/ag-grid-community/src/misc/apiEvents/eventApi.ts
function $437b23f6a393c3bf$var$addEventListener(beans, eventType, listener) {
    beans.apiEventSvc?.addListener(eventType, listener);
}
function $437b23f6a393c3bf$var$removeEventListener(beans, eventType, listener) {
    beans.apiEventSvc?.removeListener(eventType, listener);
}
function $437b23f6a393c3bf$var$addGlobalListener(beans, listener) {
    beans.apiEventSvc?.addGlobalListener(listener);
}
function $437b23f6a393c3bf$var$removeGlobalListener(beans, listener) {
    beans.apiEventSvc?.removeGlobalListener(listener);
}
// packages/ag-grid-community/src/misc/apiEvents/apiEventModule.ts
var $437b23f6a393c3bf$export$d20c5df25778eac8 = {
    moduleName: "EventApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        addEventListener: $437b23f6a393c3bf$var$addEventListener,
        addGlobalListener: $437b23f6a393c3bf$var$addGlobalListener,
        removeEventListener: $437b23f6a393c3bf$var$removeEventListener,
        removeGlobalListener: $437b23f6a393c3bf$var$removeGlobalListener
    },
    beans: [
        $437b23f6a393c3bf$var$ApiEventService
    ]
};
// packages/ag-grid-community/src/misc/locale/localeModule.ts
var $437b23f6a393c3bf$export$77471a542fe056d = {
    moduleName: "Locale",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$export$f325e19d05d9c36d
    ]
};
// packages/ag-grid-community/src/rendering/row/rowAutoHeightService.ts
var $437b23f6a393c3bf$var$RowAutoHeightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowAutoHeight";
        this.wasEverActive = false;
        this._debouncedCalculateRowHeights = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.calculateRowHeights.bind(this), 1);
    }
    /**
   * If row height has been active, request a refresh of the row heights.
   */ requestCheckAutoHeight() {
        if (!this.wasEverActive) return;
        this._debouncedCalculateRowHeights();
    }
    calculateRowHeights() {
        const { visibleCols: visibleCols, rowModel: rowModel, rowSpanSvc: rowSpanSvc, pinnedRowModel: pinnedRowModel } = this.beans;
        const displayedAutoHeightCols = visibleCols.autoHeightCols;
        let anyNodeChanged = false;
        const updateDisplayedRowHeights = (row)=>{
            const autoHeights = row.__autoHeights;
            let newRowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, row).height;
            for (const col of displayedAutoHeightCols){
                let cellHeight = autoHeights?.[col.getColId()];
                const spannedCell = rowSpanSvc?.getCellSpan(col, row);
                if (spannedCell) {
                    if (spannedCell.getLastNode() !== row) continue;
                    cellHeight = rowSpanSvc?.getCellSpan(col, row)?.getLastNodeAutoHeight();
                    if (!cellHeight) return;
                }
                if (cellHeight == null) {
                    if (this.colSpanSkipCell(col, row)) continue;
                    return;
                }
                newRowHeight = Math.max(cellHeight, newRowHeight);
            }
            if (newRowHeight !== row.rowHeight) {
                row.setRowHeight(newRowHeight);
                anyNodeChanged = true;
            }
        };
        pinnedRowModel?.forEachPinnedRow?.("top", updateDisplayedRowHeights);
        pinnedRowModel?.forEachPinnedRow?.("bottom", updateDisplayedRowHeights);
        rowModel.forEachDisplayedNode?.(updateDisplayedRowHeights);
        if (anyNodeChanged) rowModel.onRowHeightChanged?.();
    }
    /**
   * Set the cell height into the row node, and request a refresh of the row heights if there's been a change.
   * @param rowNode the node to set the auto height on
   * @param cellHeight the height to set, undefined if the cell has just been destroyed
   * @param column the column of the cell
   */ setRowAutoHeight(rowNode, cellHeight, column) {
        rowNode.__autoHeights ?? (rowNode.__autoHeights = {});
        if (cellHeight == void 0) {
            delete rowNode.__autoHeights[column.getId()];
            return;
        }
        const previousCellHeight = rowNode.__autoHeights[column.getId()];
        rowNode.__autoHeights[column.getId()] = cellHeight;
        if (previousCellHeight !== cellHeight) this.requestCheckAutoHeight();
    }
    /**
   * If using col span, then cells which have been spanned over do not need an auto height value
   * @param col the column of the cell
   * @param node the node of the cell
   * @returns whether the row needs auto height value for that column
   */ colSpanSkipCell(col, node) {
        const { colModel: colModel, colViewport: colViewport, visibleCols: visibleCols } = this.beans;
        if (!colModel.colSpanActive) return false;
        let activeColsForRow = [];
        switch(col.getPinned()){
            case "left":
                activeColsForRow = visibleCols.getLeftColsForRow(node);
                break;
            case "right":
                activeColsForRow = visibleCols.getRightColsForRow(node);
                break;
            case null:
                activeColsForRow = colViewport.getColsWithinViewport(node);
                break;
        }
        return !activeColsForRow.includes(col);
    }
    /**
   * If required, sets up observers to continuously measure changes in the cell height.
   * @param cellCtrl the cellCtrl of the cell
   * @param eCellWrapper the HTMLElement to track the height of
   * @param compBean the component bean to add the destroy/cleanup function to
   * @returns whether or not auto height has been set up on this cell
   */ setupCellAutoHeight(cellCtrl, eCellWrapper, compBean) {
        if (!cellCtrl.column.isAutoHeight() || !eCellWrapper) return false;
        this.wasEverActive = true;
        const eParentCell = eCellWrapper.parentElement;
        const { rowNode: rowNode, column: column } = cellCtrl;
        const beans = this.beans;
        const measureHeight = (timesCalled)=>{
            if (this.beans.editSvc?.isEditing(cellCtrl)) return;
            if (!cellCtrl.isAlive() || !compBean.isAlive()) return;
            const { paddingTop: paddingTop, paddingBottom: paddingBottom, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth } = $437b23f6a393c3bf$var$_getElementSize(eParentCell);
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = eCellWrapper.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
                const notYetInDom = !doc?.contains(eCellWrapper);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    window.setTimeout(()=>measureHeight(timesCalled + 1), 0);
                    return;
                }
            }
            this.setRowAutoHeight(rowNode, autoHeight, column);
        };
        const listener = ()=>measureHeight(0);
        listener();
        const destroyResizeObserver = $437b23f6a393c3bf$export$9aef8476630687be(beans, eCellWrapper, listener);
        compBean.addDestroyFunc(()=>{
            destroyResizeObserver();
            this.setRowAutoHeight(rowNode, void 0, column);
        });
        return true;
    }
    setAutoHeightActive(cols) {
        this.active = cols.list.some((col)=>col.isVisible() && col.isAutoHeight());
    }
    /**
   * Determines if the row auto height service has cells to grow.
   * @returns true if all of the rendered rows are at least as tall as their rendered cells.
   */ areRowsMeasured() {
        if (!this.active) return true;
        const rowCtrls = this.beans.rowRenderer.getAllRowCtrls();
        let renderedAutoHeightCols = null;
        for (const { rowNode: rowNode } of rowCtrls){
            if (!renderedAutoHeightCols || this.beans.colModel.colSpanActive) {
                const renderedCols = this.beans.colViewport.getColsWithinViewport(rowNode);
                renderedAutoHeightCols = renderedCols.filter((col)=>col.isAutoHeight());
            }
            if (renderedAutoHeightCols.length === 0) continue;
            if (!rowNode.__autoHeights) return false;
            for (const col of renderedAutoHeightCols){
                const cellHeight = rowNode.__autoHeights[col.getColId()];
                if (!cellHeight || rowNode.rowHeight < cellHeight) return false;
            }
        }
        return true;
    }
};
// packages/ag-grid-community/src/rendering/row/rowAutoHeightModule.ts
var $437b23f6a393c3bf$export$dd3171a7609a981f = {
    moduleName: "RowAutoHeight",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowAutoHeightService
    ]
};
// packages/ag-grid-community/src/allCommunityModule.ts
var $437b23f6a393c3bf$export$526323caf9d1af13 = {
    moduleName: "AllCommunity",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$4c74201d5a94c8e5,
        $437b23f6a393c3bf$export$f744275d8b795fc2,
        $437b23f6a393c3bf$export$ca8341149bdd39bc,
        $437b23f6a393c3bf$export$798770a8f68ba4e7,
        $437b23f6a393c3bf$export$5e6636bea954ad4e,
        $437b23f6a393c3bf$export$9bc83f811986c4f2,
        $437b23f6a393c3bf$export$d1dd3475f4d98a27,
        $437b23f6a393c3bf$export$b6d3a45586965934,
        $437b23f6a393c3bf$export$ccaa44b10c75f1d,
        $437b23f6a393c3bf$export$e1b6b5aa47694f20,
        $437b23f6a393c3bf$export$e1d2707568ed81f6,
        $437b23f6a393c3bf$export$2bb59c6ee8834731,
        $437b23f6a393c3bf$export$5ce3e57cec1fecc9,
        $437b23f6a393c3bf$export$aabcd4399b0469bb,
        $437b23f6a393c3bf$export$2a2721fe06c4c013,
        $437b23f6a393c3bf$export$c992812899d813d0,
        $437b23f6a393c3bf$export$7e8079ed742f8307,
        $437b23f6a393c3bf$export$fc403e59f6fc67b,
        $437b23f6a393c3bf$export$3402149dbbda9537,
        $437b23f6a393c3bf$export$a8c763073927f695,
        $437b23f6a393c3bf$export$a57c5ed18afb0c4,
        $437b23f6a393c3bf$export$5c4abee658e86c68,
        $437b23f6a393c3bf$export$12e9d7df2a270583,
        $437b23f6a393c3bf$export$351f260d7f887abc,
        $437b23f6a393c3bf$export$b67b27f72da743ce,
        $437b23f6a393c3bf$export$baf19ca56ec781d2,
        $437b23f6a393c3bf$export$49c914873cdbe391,
        $437b23f6a393c3bf$export$b6e84cdeabbb116a,
        $437b23f6a393c3bf$export$dae0b5c1ba15d66f,
        $437b23f6a393c3bf$export$3110fedd6be63d8e,
        $437b23f6a393c3bf$export$be75c2ed74fb2144,
        $437b23f6a393c3bf$export$ca683b579c0df457,
        $437b23f6a393c3bf$export$dbb09c7a8266fd30,
        $437b23f6a393c3bf$export$d20c5df25778eac8,
        $437b23f6a393c3bf$export$d7a9d7f5c41fb970,
        $437b23f6a393c3bf$export$98e8472b11750a07,
        $437b23f6a393c3bf$export$d0c662c133b8814e,
        $437b23f6a393c3bf$export$77471a542fe056d,
        $437b23f6a393c3bf$export$dd3171a7609a981f,
        $437b23f6a393c3bf$export$b9bac28848e60126,
        $437b23f6a393c3bf$export$15323dcce1401b05,
        $437b23f6a393c3bf$export$b7ca1fc11bfe19c3
    ]
};
// packages/ag-grid-community/src/testing/testIdUtils.ts
function $437b23f6a393c3bf$var$formatTestId(name, attributes = {}) {
    const params = Object.keys(attributes).map((k)=>{
        const v = attributes[k];
        return v != null ? `${k}=${v}` : null;
    }).filter(Boolean).join(";");
    return [
        name,
        params
    ].filter((s)=>s.length > 0).join(":");
}
var $437b23f6a393c3bf$export$11b44e0a72aa6bc3 = {
    grid (gridId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-grid-root", {
            gridId: gridId
        });
    },
    /** Headers */ headerGroupCell (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-group-cell", {
            colId: colId
        });
    },
    headerCell (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell", {
            colId: colId
        });
    },
    headerCheckbox (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-selection-checkbox", {
            colId: colId
        });
    },
    headerFilterButton (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell-filter-button", {
            colId: colId
        });
    },
    floatingFilter (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-floating-filter", {
            colId: colId
        });
    },
    floatingFilterButton (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-floating-filter-button", {
            colId: colId
        });
    },
    headerCellMenuButton (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell-menu-button", {
            colId: colId
        });
    },
    headerResizeHandle (colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-header-cell-resize", {
            colId: colId
        });
    },
    /** Column Filters */ filterInstancePickerDisplay (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-picker-display`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    numberFilterInstanceInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-number-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    textFilterInstanceInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-text-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    dateFilterInstanceInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-date-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    setFilterInstanceMiniFilterInput (spec) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-set-filter-mini-filter-input`, spec.source === "filter-toolpanel" ? {
            label: spec.colLabel
        } : {
            colId: spec.colId
        });
    },
    setFilterInstanceItem (spec, itemLabel) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-set-filter-item`, spec.source === "filter-toolpanel" ? {
            colLabel: spec.colLabel,
            itemLabel: itemLabel
        } : {
            colId: spec.colId,
            itemLabel: itemLabel
        });
    },
    setFilterApplyPanelButton (spec, buttonLabel) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-set-filter-apply-panel-button`, spec.source === "filter-toolpanel" ? {
            colLabel: spec.colLabel,
            buttonLabel: buttonLabel
        } : {
            colId: spec.colId,
            buttonLabel: buttonLabel
        });
    },
    filterConditionRadioButton (spec, buttonLabel) {
        return $437b23f6a393c3bf$var$formatTestId(`ag-${spec.source}-filter-condition-radio-button`, spec.source === "filter-toolpanel" ? {
            colLabel: spec.colLabel,
            buttonLabel: buttonLabel
        } : {
            colId: spec.colId,
            buttonLabel: buttonLabel
        });
    },
    /** Advanced Filter */ advancedFilterInput () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-input");
    },
    advancedFilterButton (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-button", {
            label: label
        });
    },
    advancedFilterBuilderButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-button");
    },
    advancedFilterPanelMaximiseButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-panel-maximise");
    },
    advancedFilterPanelCloseButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-panel-close");
    },
    advancedFilterPill (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-pill", {
            label: label
        });
    },
    advancedFilterBuilderAddItemButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-advanced-filter-builder-add-item-button");
    },
    /** Rows */ rowNode (rowId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-row", {
            ["row-id"]: rowId
        });
    },
    /** Cells */ cell (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-cell", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    autoGroupCell (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.cell(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    checkbox (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-selection-checkbox", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    selectionColumnCheckbox (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.checkbox(rowId, $437b23f6a393c3bf$export$dd05e5f089eb2421);
    },
    autoGroupColumnCheckbox (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.checkbox(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    dragHandle (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-drag-handle", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    groupContracted (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-group-contracted", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    groupExpanded (rowId, colId) {
        return $437b23f6a393c3bf$var$formatTestId("ag-group-expanded", {
            ["row-id"]: rowId,
            colId: colId
        });
    },
    autoGroupContracted (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupContracted(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    autoGroupExpanded (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupExpanded(rowId, $437b23f6a393c3bf$export$a7016588c430dba6);
    },
    rowNumber (rowId) {
        return $437b23f6a393c3bf$export$11b44e0a72aa6bc3.cell(rowId, $437b23f6a393c3bf$export$f55c01dfb205b029);
    },
    /** Menu */ menu () {
        return $437b23f6a393c3bf$var$formatTestId("ag-menu");
    },
    menuOption (option) {
        return $437b23f6a393c3bf$var$formatTestId("ag-menu-option", {
            ["option"]: option
        });
    },
    /** SideBar */ sideBar () {
        return $437b23f6a393c3bf$var$formatTestId("ag-side-bar");
    },
    sideBarButton (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-side-button", {
            label: label
        });
    },
    /** Column Tool Panel */ columnToolPanel () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-panel");
    },
    pivotModeSelect () {
        return $437b23f6a393c3bf$var$formatTestId("ag-pivot-mode-select");
    },
    columnPanelSelectHeaderCheckbox () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-panel-select-header-checkbox");
    },
    columnPanelSelectHeaderFilter () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-panel-select-header-filter");
    },
    columnSelectListItemGroupClosedIcon (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-select-list-item-group-closed-icon", {
            label: label
        });
    },
    columnSelectListItemCheckbox (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-select-list-item-checkbox", {
            label: label
        });
    },
    columnSelectListItemDragHandle (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-select-list-item-drag-handle", {
            label: label
        });
    },
    columnDropCellDragHandle (source, area, label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-drop-cell-drag-handle", {
            source: source,
            area: area,
            label: label
        });
    },
    columnDropCellCancelButton (source, area, label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-drop-cell-cancel", {
            source: source,
            area: area,
            label: label
        });
    },
    columnDropArea (source, name) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-drop-area", {
            source: source,
            name: name
        });
    },
    /** Filter Tool Panel (New) */ filterToolPanel () {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-panel");
    },
    filterToolPanelAddFilterButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-panel-add-filter-button");
    },
    filterToolPanelFilterTypeSelector (colLabel) {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-panel-filter-type-selector", {
            colLabel: colLabel
        });
    },
    /** Filter Tool Panel (Old) */ filterToolPanelSearchInput () {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-toolpanel-search-input");
    },
    filterToolPanelGroup (title) {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-toolpanel-group", {
            title: title
        });
    },
    filterToolPanelGroupCollapsedIcon (title) {
        return $437b23f6a393c3bf$var$formatTestId("ag-filter-toolpanel-group-collapsed-icon", {
            title: title
        });
    },
    /** Status Bar */ statusBarTotalAndFilteredRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-total-and-filtered-row-count");
    },
    statusBarTotalRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-total-row-count");
    },
    statusBarFilteredRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-filtered-row-count");
    },
    statusBarSelectedRowCount () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-selected-row-count");
    },
    statusBarAggregations () {
        return $437b23f6a393c3bf$var$formatTestId("ag-status-bar-aggregations");
    },
    /** Pagination */ paginationPanelSizePickerDisplay (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-pagination-page-size-picker-field-display", {
            value: value
        });
    },
    paginationPanelFirstRowOnPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-row-summary-panel-first-row-on-page", {
            value: value
        });
    },
    paginationPanelLastRowOnPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-row-summary-panel-last-row-on-page", {
            value: value
        });
    },
    paginationPanelRecordCount (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-row-summary-panel-record-count", {
            value: value
        });
    },
    paginationSummaryPanelButton (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-page-summary-panel-btn", {
            label: label
        });
    },
    paginationSummaryPanelCurrentPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-page-summary-panel-current-page", {
            value: value
        });
    },
    paginationSummaryPanelTotalPage (value) {
        return $437b23f6a393c3bf$var$formatTestId("ag-paging-page-summary-panel-total-page", {
            value: value
        });
    },
    /** Fill Handle */ fillHandle () {
        return $437b23f6a393c3bf$var$formatTestId("ag-fill-handle");
    },
    /** Column Chooser */ columnChooserCloseButton () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-close-button");
    },
    columnChooserSearchBarCheckbox () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-header-checkbox");
    },
    columnChooserSearchBarFilter () {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-searchbar-filter");
    },
    columnChooserListItemGroupClosedIcon (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-list-item-group-closed-icon", {
            label: label
        });
    },
    columnChooserListItemCheckbox (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-list-item-checkbox", {
            label: label
        });
    },
    columnChooserListItemDragHandle (label) {
        return $437b23f6a393c3bf$var$formatTestId("ag-column-chooser-list-item-drag-handle", {
            label: label
        });
    },
    /** Overlay */ overlay () {
        return $437b23f6a393c3bf$var$formatTestId("ag-overlay");
    }
};
var $437b23f6a393c3bf$export$387ead18f69f83ca = (fn)=>{
    const locators = {};
    const keys = Object.keys($437b23f6a393c3bf$export$11b44e0a72aa6bc3);
    for (const k of keys)locators[k] = (...args)=>{
        return fn($437b23f6a393c3bf$export$11b44e0a72aa6bc3[k](...args));
    };
    return locators;
};
// packages/ag-grid-community/src/testing/testIdService.ts
var $437b23f6a393c3bf$var$TEST_ID_ATTR = "data-testid";
function $437b23f6a393c3bf$var$setTestId(element, testId) {
    element?.setAttribute($437b23f6a393c3bf$var$TEST_ID_ATTR, testId);
}
function $437b23f6a393c3bf$var$setTestIdAttribute(attr) {
    $437b23f6a393c3bf$var$TEST_ID_ATTR = attr;
}
var $437b23f6a393c3bf$var$TestIdService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "testIdSvc";
    }
    postConstruct() {
        const delayedDebounce = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.setupAllTestIds(), 500);
        const setup = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>{
            this.setupAllTestIds();
            delayedDebounce();
        }, 0);
        this.addManagedEventListeners({
            firstDataRendered: setup,
            displayedRowsChanged: setup,
            displayedColumnsChanged: setup,
            displayedColumnsWidthChanged: setup,
            virtualColumnsChanged: setup,
            columnMenuVisibleChanged: setup,
            contextMenuVisibleChanged: setup,
            advancedFilterBuilderVisibleChanged: setup,
            fieldPickerValueSelected: setup,
            modelUpdated: setup,
            sideBarUpdated: setup,
            pinnedHeightChanged: setup,
            gridReady: setup,
            overlayExclusiveChanged: setup,
            rowGroupOpened: setup,
            scrollVisibilityChanged: setup,
            gridSizeChanged: setup,
            filterOpened: setup,
            filterChanged: setup,
            cellSelectionChanged: setup
        });
    }
    setupAllTestIds() {
        const root = $437b23f6a393c3bf$export$1911dd00c79744c0(this.beans);
        const gridId = $437b23f6a393c3bf$var$getGridId(this.beans);
        const gridWrapper = root.querySelector(`[grid-id="${gridId}"]`);
        $437b23f6a393c3bf$var$setTestId(gridWrapper, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.grid(gridId));
        root.querySelectorAll(".ag-header-group-cell").forEach((groupCell)=>{
            $437b23f6a393c3bf$var$setTestId(groupCell, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerGroupCell(groupCell.getAttribute("col-id")));
        });
        root.querySelectorAll(".ag-header-cell").forEach((cell)=>{
            const colId = cell.getAttribute("col-id");
            const isFloatingFilter = cell.classList.contains("ag-floating-filter");
            const headerCellId = isFloatingFilter ? $437b23f6a393c3bf$export$11b44e0a72aa6bc3.floatingFilter(colId) : $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerCell(colId);
            $437b23f6a393c3bf$var$setTestId(cell, headerCellId);
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-header-cell-filter-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerFilterButton(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-header-cell-menu-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerCellMenuButton(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-header-cell-resize"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerResizeHandle(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.headerCheckbox(colId));
            $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-floating-filter-button button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.floatingFilterButton(colId));
            this.setupFilterInstance(cell.querySelector(".ag-floating-filter-body"), {
                source: "floating-filter",
                colId: colId
            });
        });
        const filterMenu = root.querySelector(".ag-filter-menu");
        this.setupFilterInstance(filterMenu, {
            source: "column-filter"
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-advanced-filter input[type=text]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterInput());
        root.querySelectorAll(".ag-advanced-filter-buttons button").forEach((button)=>{
            $437b23f6a393c3bf$var$setTestId(button, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterButton(button.textContent));
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector("button.ag-advanced-filter-builder-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterBuilderButton());
        root.querySelectorAll('.ag-panel[aria-label="Advanced Filter"] .ag-panel-title-bar-button').forEach((button, i)=>{
            $437b23f6a393c3bf$var$setTestId(button, i === 0 ? $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterPanelMaximiseButton() : $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterPanelCloseButton());
        });
        root.querySelectorAll('.ag-panel[aria-lable="Advanced Filter"] .ag-advanced-filter-builder-pill').forEach((pill)=>{
            $437b23f6a393c3bf$var$setTestId(pill, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterPill(pill.querySelector(".ag-picker-field-display")?.textContent));
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector('.ag-panel[aria-label="Advanced Filter"] .ag-advanced-filter-builder-item-button'), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.advancedFilterBuilderAddItemButton());
        root.querySelectorAll(".ag-row").forEach((row)=>{
            const rowId = row.getAttribute("row-id");
            $437b23f6a393c3bf$var$setTestId(row, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.rowNode(rowId));
            row.querySelectorAll(".ag-cell").forEach((cell)=>{
                const colId = cell.getAttribute("col-id");
                $437b23f6a393c3bf$var$setTestId(cell, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.cell(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-selection-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.checkbox(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.dragHandle(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-group-contracted"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupContracted(rowId, colId));
                $437b23f6a393c3bf$var$setTestId(cell.querySelector(".ag-group-expanded"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.groupExpanded(rowId, colId));
            });
        });
        root.querySelectorAll(".ag-menu-list").forEach((menu)=>{
            $437b23f6a393c3bf$var$setTestId(menu, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.menu());
            menu.querySelectorAll(".ag-menu-option").forEach((option)=>{
                $437b23f6a393c3bf$var$setTestId(option, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.menuOption(option.querySelector(".ag-menu-option-text")?.textContent));
            });
        });
        root.querySelectorAll(".ag-side-bar").forEach((sideBar)=>{
            $437b23f6a393c3bf$var$setTestId(sideBar, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.sideBar());
            sideBar.querySelectorAll(".ag-side-button button").forEach((button)=>{
                $437b23f6a393c3bf$var$setTestId(button, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.sideBarButton(button.querySelector(".ag-side-button-label")?.textContent));
            });
            sideBar.querySelectorAll(".ag-column-panel").forEach((panel)=>{
                $437b23f6a393c3bf$var$setTestId(panel, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnToolPanel());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-pivot-mode-select input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.pivotModeSelect());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-column-select-header-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnPanelSelectHeaderCheckbox());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-column-select-header-filter-wrapper input[type=text]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnPanelSelectHeaderFilter());
                panel.querySelectorAll(".ag-column-select-list").forEach((list)=>{
                    list.querySelectorAll(".ag-column-select-virtual-list-item").forEach((item)=>{
                        const label = item.getAttribute("aria-label");
                        $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-group-closed-icon"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnSelectListItemGroupClosedIcon(label));
                        $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-select-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnSelectListItemCheckbox(label));
                        $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnSelectListItemDragHandle(label));
                    });
                });
                this.setupColumnDropArea(panel, "toolbar");
            });
            sideBar.querySelectorAll(".ag-filter-panel").forEach((panel)=>{
                $437b23f6a393c3bf$var$setTestId(panel, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanel());
                $437b23f6a393c3bf$var$setTestId(panel.querySelector("button.ag-filter-add-button"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelAddFilterButton());
                panel.querySelectorAll(".ag-filter-card").forEach((filterCard)=>{
                    const colLabel = filterCard.querySelector(".ag-filter-card-title")?.textContent;
                    const typeSelector = filterCard.querySelector(".ag-filter-type-select");
                    $437b23f6a393c3bf$var$setTestId(typeSelector, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelFilterTypeSelector(colLabel));
                    filterCard.querySelectorAll(".ag-filter").forEach((filter)=>this.setupFilterInstance(filter, {
                            source: "filter-toolpanel",
                            colLabel: colLabel
                        }));
                });
            });
            sideBar.querySelectorAll(".ag-filter-toolpanel").forEach((panel)=>{
                $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-filter-toolpanel-search-input input[type=text]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelSearchInput());
                panel.querySelectorAll(".ag-filter-toolpanel-group").forEach((group)=>{
                    const title = group.querySelector(".ag-filter-toolpanel-group-title")?.textContent;
                    $437b23f6a393c3bf$var$setTestId(group, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelGroup(title));
                    $437b23f6a393c3bf$var$setTestId(group.querySelector(".ag-filter-toolpanel-group-title-bar-icon .ag-icon-tree-closed"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterToolPanelGroupCollapsedIcon(title));
                    const filterRoot = group.querySelector(".ag-filter-toolpanel-instance-filter");
                    if (filterRoot) this.setupFilterInstance(filterRoot, {
                        source: "filter-toolpanel",
                        colLabel: title
                    });
                });
            });
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-total-and-filtered-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarTotalAndFilteredRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-total-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarTotalRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-filtered-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarFilteredRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-selected-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarSelectedRowCount());
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-status-bar .ag-status-panel-filtered-row-count"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.statusBarAggregations());
        root.querySelectorAll(".ag-paging-panel").forEach((pagingPanel)=>{
            $437b23f6a393c3bf$var$setTestId(pagingPanel.querySelector(".ag-paging-page-size .ag-picker-field-display"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelSizePickerDisplay(pagingPanel.querySelector(".ag-paging-page-size .ag-picker-field-display")?.textContent));
            pagingPanel.querySelectorAll(".ag-paging-row-summary-panel-number").forEach((panelNumber)=>{
                const dataRef = panelNumber.getAttribute("data-ref");
                switch(dataRef){
                    case "lbFirstRowOnPage":
                        $437b23f6a393c3bf$var$setTestId(panelNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelFirstRowOnPage(panelNumber.textContent));
                        break;
                    case "lbLastRowOnPage":
                        $437b23f6a393c3bf$var$setTestId(panelNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelLastRowOnPage(panelNumber.textContent));
                        break;
                    case "lbRecordCount":
                        $437b23f6a393c3bf$var$setTestId(panelNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationPanelRecordCount(panelNumber.textContent));
                        break;
                }
            });
            pagingPanel.querySelectorAll(".ag-paging-page-summary-panel .ag-button").forEach((pagingButton)=>{
                $437b23f6a393c3bf$var$setTestId(pagingButton, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationSummaryPanelButton(pagingButton.getAttribute("aria-label")?.toLowerCase()));
            });
            pagingPanel.querySelectorAll(".ag-paging-page-summary-panel .ag-paging-number").forEach((pagingNumber)=>{
                const dataRef = pagingNumber.getAttribute("data-ref");
                switch(dataRef){
                    case "lbCurrent":
                        $437b23f6a393c3bf$var$setTestId(pagingNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationSummaryPanelCurrentPage(pagingNumber.textContent));
                        break;
                    case "lbTotal":
                        $437b23f6a393c3bf$var$setTestId(pagingNumber, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.paginationSummaryPanelTotalPage(pagingNumber.textContent));
                        break;
                }
            });
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-fill-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.fillHandle());
        root.querySelectorAll('.ag-panel[aria-label="Choose Columns"]').forEach((panel)=>{
            $437b23f6a393c3bf$var$setTestId(panel.querySelector(".ag-panel-title-bar-button-icon"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserCloseButton());
            $437b23f6a393c3bf$var$setTestId(panel.querySelector('.ag-column-select-header-checkbox input[type="checkbox"]'), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserSearchBarCheckbox());
            $437b23f6a393c3bf$var$setTestId(panel.querySelector('.ag-column-select-header-filter-wrapper input[type="text"]'), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserSearchBarFilter());
            panel.querySelectorAll(".ag-column-select-list").forEach((list)=>{
                list.querySelectorAll(".ag-column-select-virtual-list-item").forEach((item)=>{
                    const label = item.getAttribute("aria-label");
                    $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-group-closed-icon"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserListItemGroupClosedIcon(label));
                    $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-column-select-checkbox input[type=checkbox]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserListItemCheckbox(label));
                    $437b23f6a393c3bf$var$setTestId(item.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnChooserListItemDragHandle(label));
                });
            });
        });
        $437b23f6a393c3bf$var$setTestId(root.querySelector(".ag-overlay-wrapper"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.overlay());
        const rowGroupPanelWrapper = root.querySelector(".ag-column-drop-wrapper");
        if (rowGroupPanelWrapper) this.setupColumnDropArea(rowGroupPanelWrapper, "panel");
    }
    setupFilterInstance(filterRoot, spec) {
        if (!filterRoot) return;
        filterRoot.querySelectorAll(".ag-filter-select .ag-picker-field-display").forEach((fieldDisplay)=>{
            $437b23f6a393c3bf$var$setTestId(fieldDisplay, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterInstancePickerDisplay(spec));
        });
        const filterClass = spec.source === "floating-filter" ? ".ag-floating-filter-body" : ".ag-filter-body";
        const numberInput = filterRoot.querySelector(`${filterClass} input[type="number"]`);
        $437b23f6a393c3bf$var$setTestId(numberInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.numberFilterInstanceInput(spec));
        const textInput = filterRoot.querySelector(`${filterClass} input[type="text"]`);
        $437b23f6a393c3bf$var$setTestId(textInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.textFilterInstanceInput(spec));
        const dateInput = filterRoot.querySelector(`${filterClass} input[type="date"]`);
        $437b23f6a393c3bf$var$setTestId(dateInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.dateFilterInstanceInput(spec));
        const setMiniFilterInput = filterRoot.querySelector('.ag-mini-filter input[type="text"]');
        $437b23f6a393c3bf$var$setTestId(setMiniFilterInput, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.setFilterInstanceMiniFilterInput(spec));
        filterRoot.querySelectorAll(".ag-set-filter-list .ag-set-filter-item").forEach((item)=>{
            const label = item.querySelector(".ag-checkbox-label")?.textContent;
            const checkbox = item.querySelector('input[type="checkbox"]');
            $437b23f6a393c3bf$var$setTestId(checkbox, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.setFilterInstanceItem(spec, label));
        });
        filterRoot.querySelectorAll(".ag-filter-apply-panel button").forEach((button)=>{
            $437b23f6a393c3bf$var$setTestId(button, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.setFilterApplyPanelButton(spec, button.textContent));
        });
        filterRoot.querySelectorAll(".ag-filter-condition .ag-radio-button").forEach((radioButton)=>{
            const label = radioButton.querySelector(".ag-radio-button-label")?.textContent;
            $437b23f6a393c3bf$var$setTestId(radioButton.querySelector("input[type=radio]"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.filterConditionRadioButton(spec, label));
        });
    }
    setupColumnDropArea(root, source) {
        root.querySelectorAll(".ag-column-drop").forEach((columnDrop)=>{
            const dropAreaName = columnDrop.querySelector(".ag-column-drop-list")?.getAttribute("aria-label");
            $437b23f6a393c3bf$var$setTestId(columnDrop, $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnDropArea(source, dropAreaName));
            columnDrop.querySelectorAll(".ag-column-drop-cell").forEach((columnDropCell)=>{
                const label = columnDropCell.querySelector(".ag-column-drop-cell-text")?.textContent;
                $437b23f6a393c3bf$var$setTestId(columnDropCell.querySelector(".ag-drag-handle"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnDropCellDragHandle(source, dropAreaName, label));
                $437b23f6a393c3bf$var$setTestId(columnDropCell.querySelector(".ag-column-drop-cell-button .ag-icon-cancel"), $437b23f6a393c3bf$export$11b44e0a72aa6bc3.columnDropCellCancelButton(source, dropAreaName, label));
            });
        });
    }
};
// packages/ag-grid-community/src/testing/testingModule.ts
var $437b23f6a393c3bf$var$TestingModule = {
    moduleName: "Testing",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$TestIdService
    ]
};
function $437b23f6a393c3bf$export$a2068793f28bf00e({ testIdAttribute: testIdAttribute } = {}) {
    if (testIdAttribute) $437b23f6a393c3bf$var$setTestIdAttribute(testIdAttribute);
    $437b23f6a393c3bf$export$dc053975cc7f6c11.registerModules([
        $437b23f6a393c3bf$var$TestingModule
    ]);
}





var $9OAZF = parcelRequire("9OAZF");
/** based on emittery npm package, which is MIT */ const $7ddf72f79776fa87$var$anyMap = new WeakMap();
const $7ddf72f79776fa87$var$eventsMap = new WeakMap();
const $7ddf72f79776fa87$var$triggeredMap = new WeakMap();
const $7ddf72f79776fa87$var$resolvedPromise = Promise.resolve();
//type EmitterCallback = (data?: any) => any;
function $7ddf72f79776fa87$var$assertEventName(eventName) {
    if (typeof eventName !== 'string') throw new TypeError('eventName must be a string');
}
function $7ddf72f79776fa87$var$assertListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('listener must be a function');
}
function $7ddf72f79776fa87$var$getListeners(instance, eventName) {
    const events = $7ddf72f79776fa87$var$eventsMap.get(instance);
    if (!events) // we're hitting this case only when calling `off` after the instance has been destroyed (so extremely rarely)
    // so we want to return an empty set in order not to make the code throw an error
    return new Set();
    if (!events.has(eventName)) events.set(eventName, new Set());
    return events.get(eventName);
}
function $7ddf72f79776fa87$var$defaultMethodNamesOrAssert(methodNames) {
    if (methodNames === undefined) return $7ddf72f79776fa87$var$allEmitteryMethods;
    if (!Array.isArray(methodNames)) throw new TypeError('`methodNames` must be an array of strings');
    for (const methodName of methodNames)if (!$7ddf72f79776fa87$var$allEmitteryMethods.includes(methodName)) {
        if (typeof methodName !== 'string') throw new TypeError('`methodNames` element must be a string');
        throw new Error(`${methodName} is not Emittery method`);
    }
    return methodNames;
}
class $7ddf72f79776fa87$var$Emittery {
    static mixin(emitteryPropertyName, methodNames) {
        methodNames = $7ddf72f79776fa87$var$defaultMethodNamesOrAssert(methodNames);
        return (target)=>{
            if (typeof target !== 'function') throw new TypeError('`target` must be function');
            for (const methodName of methodNames){
                if (target.prototype[methodName] !== undefined) throw new Error(`The property \`${methodName}\` already exists on \`target\``);
            }
            function getEmitteryProperty() {
                Object.defineProperty(this, emitteryPropertyName, {
                    enumerable: false,
                    value: new $7ddf72f79776fa87$var$Emittery()
                });
                return this[emitteryPropertyName];
            }
            Object.defineProperty(target.prototype, emitteryPropertyName, {
                enumerable: false,
                get: getEmitteryProperty
            });
            const emitteryMethodCaller = (methodName)=>function(...args) {
                    return this[emitteryPropertyName][methodName](...args);
                };
            for (const methodName of methodNames)Object.defineProperty(target.prototype, methodName, {
                enumerable: false,
                value: emitteryMethodCaller(methodName)
            });
            return target;
        };
    }
    constructor(){
        $7ddf72f79776fa87$var$anyMap.set(this, new Set());
        $7ddf72f79776fa87$var$eventsMap.set(this, new Map());
        $7ddf72f79776fa87$var$triggeredMap.set(this, new Map());
    }
    destroy() {
        this.clearListeners();
        // should not be needed, since those maps are weak
        // but let's do it anyway - some of our users suggested this Emitter class
        // could be a source of memory leaks, so let's clean this up
        $7ddf72f79776fa87$var$anyMap.delete(this);
        $7ddf72f79776fa87$var$eventsMap.delete(this);
        $7ddf72f79776fa87$var$triggeredMap.delete(this);
    }
    on(eventName, listener) {
        $7ddf72f79776fa87$var$assertEventName(eventName);
        $7ddf72f79776fa87$var$assertListener(listener);
        $7ddf72f79776fa87$var$getListeners(this, eventName).add(listener);
        return this.off.bind(this, eventName, listener);
    }
    off(eventName, listener) {
        $7ddf72f79776fa87$var$assertEventName(eventName);
        $7ddf72f79776fa87$var$assertListener(listener);
        $7ddf72f79776fa87$var$getListeners(this, eventName).delete(listener);
    }
    once(eventName) {
        return new Promise((resolve)=>{
            $7ddf72f79776fa87$var$assertEventName(eventName);
            const off = this.on(eventName, (data)=>{
                off();
                resolve(data);
            });
        });
    }
    onIncludeFiredOnce(eventName) {
        const triggeredEventsMap = $7ddf72f79776fa87$var$triggeredMap.get(this);
        const eventInfo = triggeredEventsMap.get(eventName);
        if (eventInfo) return Promise.resolve(eventInfo.data);
        return this.once(eventName);
    }
    onIncludeFired(eventName, listener) {
        const triggeredEventsMap = $7ddf72f79776fa87$var$triggeredMap.get(this);
        const eventInfo = triggeredEventsMap.get(eventName);
        if (eventInfo) listener(eventInfo.data);
        return this.on(eventName, listener);
    }
    async emit(eventName, eventData) {
        $7ddf72f79776fa87$var$assertEventName(eventName);
        const listeners = $7ddf72f79776fa87$var$getListeners(this, eventName);
        const triggeredEventsMap = $7ddf72f79776fa87$var$triggeredMap.get(this);
        const anyListeners = $7ddf72f79776fa87$var$anyMap.get(this);
        const staticListeners = [
            ...listeners
        ];
        const staticAnyListeners = [
            ...anyListeners
        ];
        triggeredEventsMap.set(eventName, {
            data: eventData
        });
        await $7ddf72f79776fa87$var$resolvedPromise;
        return Promise.all([
            ...staticListeners.map(async (listener)=>{
                if (listeners.has(listener)) return listener(eventData);
            }),
            ...staticAnyListeners.map(async (listener)=>{
                if (anyListeners.has(listener)) return listener(eventName, eventData);
            })
        ]);
    }
    emitSync(eventName, eventData) {
        $7ddf72f79776fa87$var$assertEventName(eventName);
        const listeners = $7ddf72f79776fa87$var$getListeners(this, eventName);
        const triggeredEventsMap = $7ddf72f79776fa87$var$triggeredMap.get(this);
        const anyListeners = $7ddf72f79776fa87$var$anyMap.get(this);
        const staticListeners = [
            ...listeners
        ];
        const staticAnyListeners = [
            ...anyListeners
        ];
        triggeredEventsMap.set(eventName, {
            data: eventData
        });
        return [
            ...staticListeners.map((listener)=>{
                if (listeners.has(listener)) return listener(eventData);
            }),
            ...staticAnyListeners.map((listener)=>{
                if (anyListeners.has(listener)) return listener(eventName, eventData);
            })
        ];
    }
    async emitSerial(eventName, eventData) {
        $7ddf72f79776fa87$var$assertEventName(eventName);
        const listeners = $7ddf72f79776fa87$var$getListeners(this, eventName);
        const anyListeners = $7ddf72f79776fa87$var$anyMap.get(this);
        const staticListeners = [
            ...listeners
        ];
        const staticAnyListeners = [
            ...anyListeners
        ];
        await $7ddf72f79776fa87$var$resolvedPromise;
        /* eslint-disable no-await-in-loop */ for (const listener of staticListeners)if (listeners.has(listener)) await listener(eventData);
        for (const listener of staticAnyListeners)if (anyListeners.has(listener)) await listener(eventName, eventData);
    /* eslint-enable no-await-in-loop */ }
    onAny(listener) {
        $7ddf72f79776fa87$var$assertListener(listener);
        $7ddf72f79776fa87$var$anyMap.get(this).add(listener);
        return this.offAny.bind(this, listener);
    }
    offAny(listener) {
        $7ddf72f79776fa87$var$assertListener(listener);
        $7ddf72f79776fa87$var$anyMap.get(this).delete(listener);
    }
    clearListeners(eventName) {
        if (typeof eventName === 'string') $7ddf72f79776fa87$var$getListeners(this, eventName).clear();
        else {
            $7ddf72f79776fa87$var$anyMap.get(this).clear();
            for (const listeners of $7ddf72f79776fa87$var$eventsMap.get(this).values())listeners.clear();
        }
    }
    listenerCount(eventName) {
        if (typeof eventName === 'string') return $7ddf72f79776fa87$var$anyMap.get(this).size + $7ddf72f79776fa87$var$getListeners(this, eventName).size;
        if (typeof eventName !== 'undefined') $7ddf72f79776fa87$var$assertEventName(eventName);
        let count = $7ddf72f79776fa87$var$anyMap.get(this).size;
        for (const value of $7ddf72f79776fa87$var$eventsMap.get(this).values())count += value.size;
        return count;
    }
    bindMethods(target, methodNames) {
        if (typeof target !== 'object' || target === null) throw new TypeError('`target` must be an object');
        methodNames = $7ddf72f79776fa87$var$defaultMethodNamesOrAssert(methodNames);
        for (const methodName of methodNames){
            if (target[methodName] !== undefined) throw new Error(`The property \`${methodName}\` already exists on \`target\``);
            Object.defineProperty(target, methodName, {
                enumerable: false,
                value: this[methodName].bind(this)
            });
        }
    }
}
const $7ddf72f79776fa87$var$allEmitteryMethods = Object.getOwnPropertyNames($7ddf72f79776fa87$var$Emittery.prototype).filter((v)=>v !== 'constructor');
var $7ddf72f79776fa87$export$2e2bcd8739ae039 = $7ddf72f79776fa87$var$Emittery;


const $dba0ee26b73908a4$export$453fc3fd17cf05a5 = (layout)=>{
    return layout && 'PivotColumns' in layout;
};


const $9399b0c19bfb07a7$export$b9ed909d42ef1a59 = 'ag-Grid-AutoColumn';
const $9399b0c19bfb07a7$export$652eb7684b734a42 = 'ag-Grid-AutoColumn-';
function $9399b0c19bfb07a7$export$dd21133fd9f15048(layout, options) {
    if (!layout) return;
    layout = structuredClone(layout);
    if (!layout.ColumnVisibility) layout.ColumnVisibility = {};
    if (!layout.TableAggregationColumns) layout.TableAggregationColumns = [];
    if (!layout.Ignore_ColumnFilters) layout.Ignore_ColumnFilters = [];
    if (!layout.ColumnSorts) layout.ColumnSorts = [];
    if (!layout.ColumnPinning) layout.ColumnPinning = {};
    if (!layout.ColumnSizing) layout.ColumnSizing = {};
    if (!layout.RowGroupedColumns) layout.RowGroupedColumns = [];
    if (!('SuppressAggFuncInHeader' in layout)) // make it an own property
    layout.SuppressAggFuncInHeader = undefined;
    if (!('GrandTotalRow' in layout)) // make it an own property
    layout.GrandTotalRow = undefined;
    const ColumnOrderSet = new Set(layout.TableColumns);
    if (layout.RowGroupedColumns && layout.RowGroupedColumns.length && layout.TableColumns) {
        // the layout.TableColumns might not include the group columns
        //
        // but we want to include those columnIds in the TableColumns
        // so the layout is properly specified
        let displayType = layout.RowGroupDisplayType;
        if (!displayType) {
            layout.TableColumns.some((columnId)=>{
                if (columnId === $9399b0c19bfb07a7$export$b9ed909d42ef1a59) {
                    displayType = 'single';
                    return true;
                } else if (columnId.startsWith($9399b0c19bfb07a7$export$652eb7684b734a42)) {
                    displayType = 'multi';
                    return true;
                }
            });
            displayType = displayType || 'single';
            layout.RowGroupDisplayType = displayType;
        }
        if (displayType === 'single') {
            if (!ColumnOrderSet.has($9399b0c19bfb07a7$export$b9ed909d42ef1a59)) layout.TableColumns = [
                $9399b0c19bfb07a7$export$b9ed909d42ef1a59,
                ...layout.TableColumns
            ];
        } else {
            const GroupedCols = new Set(layout.RowGroupedColumns);
            [
                ...layout.RowGroupedColumns
            ].reverse().forEach((colId)=>{
                const groupColId = `${$9399b0c19bfb07a7$export$652eb7684b734a42}${colId}`;
                if (!ColumnOrderSet.has(groupColId) && !ColumnOrderSet.has(colId)) {
                    // add the col to the beginning of the layout.OrderedColumns
                    layout.TableColumns.unshift(colId);
                    ColumnOrderSet.add(colId);
                // the .flatMap below will handle the rest
                }
            });
            const MappedColumnOrder = layout.TableColumns.flatMap((colId)=>{
                if (GroupedCols.has(colId)) {
                    // if the column is grouped by
                    const groupColId = `${$9399b0c19bfb07a7$export$652eb7684b734a42}${colId}`;
                    // but there's no column for this group in the layout
                    if (!ColumnOrderSet.has(groupColId)) {
                        // then we assume that the current column is basically the group column
                        // so we return both the group column and the current column
                        // but make the current column hidden
                        layout.ColumnVisibility[colId] = false;
                        return [
                            groupColId,
                            colId
                        ];
                    }
                }
                // if this is a group column
                if (colId.startsWith($9399b0c19bfb07a7$export$652eb7684b734a42)) {
                    const simpleColId = colId.replace($9399b0c19bfb07a7$export$652eb7684b734a42, '');
                    // but the corresponding simple column is not in the layout
                    // then let's include it, with visibility set to false
                    if (!ColumnOrderSet.has(simpleColId)) {
                        layout.ColumnVisibility[simpleColId] = false;
                        return [
                            colId,
                            simpleColId
                        ];
                    }
                }
                return colId;
            });
            layout.TableColumns = [
                ...MappedColumnOrder
            ];
        }
        if (layout.RowGroupedColumns && layout.RowGroupedColumns.length && !layout.RowGroupValues) layout.RowGroupValues = {
            RowGroupDisplay: 'always-collapsed'
        };
    }
    // there might be a case where there are we have an RowGroupedColumns array, but it's empty (or it's inexistent altogether)
    // and there is no display type specified - so default it to single
    if (!layout.RowGroupDisplayType && layout.TableColumns) layout.RowGroupDisplayType = 'single';
    if (options?.isTree && !layout.TableColumns.includes($9399b0c19bfb07a7$export$b9ed909d42ef1a59)) layout.TableColumns.unshift($9399b0c19bfb07a7$export$b9ed909d42ef1a59);
    return layout;
}
function $9399b0c19bfb07a7$export$ba8b5004731f7e8a(layout) {
    layout = structuredClone(layout);
    if (!layout.ColumnVisibility) layout.ColumnVisibility = {};
    if (!layout.Ignore_ColumnFilters) layout.Ignore_ColumnFilters = [];
    if (!layout.PivotAggregationColumns) layout.PivotAggregationColumns = [];
    if (!layout.ColumnSorts) layout.ColumnSorts = [];
    if (!layout.ColumnPinning) layout.ColumnPinning = {};
    if (!layout.PivotResultColumnsOrder) layout.PivotResultColumnsOrder = false;
    if (!layout.ColumnSizing) layout.ColumnSizing = {};
    if (!layout.PivotGroupedColumns) layout.PivotGroupedColumns = [];
    if (layout.PivotExpandLevel === undefined) layout.PivotExpandLevel = -1;
    if (!layout.PivotColumns) layout.PivotColumns = [];
    if (!layout.RowGroupValues) layout.RowGroupValues = {
        RowGroupDisplay: 'always-collapsed'
    };
    if (!('SuppressAggFuncInHeader' in layout)) // make it an own property
    layout.SuppressAggFuncInHeader = undefined;
    if (!('GrandTotalRow' in layout)) // make it an own property
    layout.GrandTotalRow = undefined;
    if (!('PivotGrandTotal' in layout)) // make it an own property
    layout.PivotGrandTotal = undefined;
    if (!('PivotColumnTotal' in layout)) // make it an own property
    layout.PivotColumnTotal = undefined;
    // if (layout.PivotGroupedColumns && layout.PivotGroupedColumns.length) {
    layout.RowGroupDisplayType = layout.RowGroupDisplayType || 'single';
    // }
    return layout;
}
function $9399b0c19bfb07a7$export$36a34ee1a372c2b0(layout, options) {
    if ((0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(layout)) return $9399b0c19bfb07a7$export$ba8b5004731f7e8a(layout);
    return $9399b0c19bfb07a7$export$dd21133fd9f15048(layout, options);
}
//@ts-ignore
globalThis.normalizeTableLayoutModel = $9399b0c19bfb07a7$export$dd21133fd9f15048;


const $58846ea7f4156db7$export$a1806c9475ecdc0 = '__ADAPTABLE_PK__';
const $58846ea7f4156db7$export$682d840a57d492f3 = ' [MISSING]';
const $58846ea7f4156db7$export$ee8dd85a2e01b86f = 'light';
const $58846ea7f4156db7$export$84426164da6cf571 = 'dark';
const $58846ea7f4156db7$export$9fa5d5f0144954cb = 'os';
const $58846ea7f4156db7$export$2657cb1ad92c69eb = {
    Name: 'Layout Error - No Layout Defined',
    TableColumns: []
};
const $58846ea7f4156db7$export$15c400f7cef9b84d = 'AdapTable';
const $58846ea7f4156db7$export$4241be43e8a445e5 = 'adaptable_id';
const $58846ea7f4156db7$export$f5231957f9b36e9c = 'adaptable';
const $58846ea7f4156db7$export$3d55de7351197e08 = 'AdaptableToolPanel';
const $58846ea7f4156db7$export$2c23aaff732b6533 = 'filters';
const $58846ea7f4156db7$export$2a33b96a8c752891 = 'columns';
const $58846ea7f4156db7$export$2c59109bdd218c0 = 'ab_readonly';
const $58846ea7f4156db7$export$8d34a8e2e1d6bcc1 = '';
const $58846ea7f4156db7$export$2c66e96878bf4792 = [];
const $58846ea7f4156db7$export$3b574867feb0ac0a = 500;
const $58846ea7f4156db7$export$a507d980baa6b21f = 250;
const $58846ea7f4156db7$export$5018118ad9245c30 = '/';
const $58846ea7f4156db7$export$1fadf36dae8ed962 = (0, $9399b0c19bfb07a7$export$b9ed909d42ef1a59);
const $58846ea7f4156db7$export$8866fbaadb96699c = 'ag-Grid-SelectionColumn';
const $58846ea7f4156db7$export$4dc11daf036118a4 = 'pivot_';
const $58846ea7f4156db7$export$56a650b3b733ebf1 = 'PivotRowTotal_pivot_';
const $58846ea7f4156db7$export$2c93b592c78f216f = 'AG Grid Window';
const $58846ea7f4156db7$export$e090b1dbb8c13c1b = 'rowGroupFooter_ROOT_NODE_ID';
const $58846ea7f4156db7$export$1c47315f3c982417 = '(FDC3ActionColumn)';
const $58846ea7f4156db7$export$b51de3416397241 = 'dd-MM-yyyy';
const $58846ea7f4156db7$export$360edfea94c9af92 = 'dd-MM-yyyy HH:mm:ss';
const $58846ea7f4156db7$export$74c5c370dcf447e = 'Hello World';
const $58846ea7f4156db7$export$43dc5821ce3a3e46 = 12345;
const $58846ea7f4156db7$export$548d79e01aaf6256 = 12345.6789;
const $58846ea7f4156db7$export$243785e1cb1b9e1a = 350;
const $58846ea7f4156db7$export$86c4217d77f432b7 = '-';
const $58846ea7f4156db7$export$aa2a8da74cb7a351 = 2000;
const $58846ea7f4156db7$export$b58ad781082208e8 = 'Server Validation Message';
const $58846ea7f4156db7$export$6c22698d5e37fb5a = 'Info';
const $58846ea7f4156db7$export$e03caa2bde42f4d1 = 'All Data';
const $58846ea7f4156db7$export$dfa63c611421858 = 'Current Layout';
const $58846ea7f4156db7$export$4c13590ee8958b49 = 'Selected Data';
const $58846ea7f4156db7$export$ca0f2ab5ee3c7523 = [
    $58846ea7f4156db7$export$dfa63c611421858,
    $58846ea7f4156db7$export$e03caa2bde42f4d1,
    $58846ea7f4156db7$export$4c13590ee8958b49
];
const $58846ea7f4156db7$export$745123b1958123f3 = 'Excel';
const $58846ea7f4156db7$export$15faa0ba423089e1 = 'VisualExcel';
const $58846ea7f4156db7$export$f93e787f53d85c7e = 'CSV';
const $58846ea7f4156db7$export$46455959fb42d124 = 'JSON';
const $58846ea7f4156db7$export$55741d64ab494b05 = [
    $58846ea7f4156db7$export$745123b1958123f3,
    $58846ea7f4156db7$export$15faa0ba423089e1,
    $58846ea7f4156db7$export$f93e787f53d85c7e,
    $58846ea7f4156db7$export$46455959fb42d124
];
const $58846ea7f4156db7$export$84d2b57a65e345bb = 'Select Report';
const $58846ea7f4156db7$export$6e64515c51de32a1 = 'Select Format';
const $58846ea7f4156db7$export$2bb87b5d4746f1a4 = 'Download';
const $58846ea7f4156db7$export$c0901bc9360026b6 = 'Clipboard';
const $58846ea7f4156db7$export$8803ddc1a816b6d0 = [
    $58846ea7f4156db7$export$2bb87b5d4746f1a4,
    $58846ea7f4156db7$export$c0901bc9360026b6
];
const $58846ea7f4156db7$export$2918e1c8357d59c9 = `ab--theme-`;
const $58846ea7f4156db7$export$462d169daa5b4858 = 'Create a new Table Layout';
const $58846ea7f4156db7$export$93c335dc8ccc925 = 'Create a new Pivot Layout';
const $58846ea7f4156db7$export$676359c448a5b42f = 'Create a new Layout';
const $58846ea7f4156db7$export$e32c7bc05d6f5e6d = 'Save Changes to Current Layout';
const $58846ea7f4156db7$export$dd6e5189d7d26f8e = 'Edit Layout';
const $58846ea7f4156db7$export$e8d786c594bb1b7e = 'Clone Layout';
const $58846ea7f4156db7$export$36d56111919541aa = 'Delete Layout';
const $58846ea7f4156db7$export$ed82a232da5d8bc7 = [
    'BulkUpdate',
    'SmartEdit',
    'CellSummary'
];
const $58846ea7f4156db7$export$91649df232e67626 = 'ROW_ADDED';
const $58846ea7f4156db7$export$b6627549cf8ad25d = 'ROW_REMOVED';



var $5aWMQ = parcelRequire("5aWMQ");
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $8540a44f59a4af84$export$dfd9b671c89acc8e = 7;
const $8540a44f59a4af84$export$3913210603d8e9ae = 365.2425;
const $8540a44f59a4af84$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $8540a44f59a4af84$export$4dec998e48f9c246 = -$8540a44f59a4af84$export$81caae6e1cc7a622;
const $8540a44f59a4af84$export$4fad13613e88edc8 = 604800000;
const $8540a44f59a4af84$export$b76b1809a2898f9a = 86400000;
const $8540a44f59a4af84$export$91246f0b9bd9beff = 60000;
const $8540a44f59a4af84$export$7f72910d6dfd237a = 3600000;
const $8540a44f59a4af84$export$397c2d5776aa9055 = 1000;
const $8540a44f59a4af84$export$3633035e63cee86a = 525600;
const $8540a44f59a4af84$export$ab7da2ccd1075c38 = 43200;
const $8540a44f59a4af84$export$2423174df8cd3cd2 = 1440;
const $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = 60;
const $8540a44f59a4af84$export$3c58128db900d44e = 3;
const $8540a44f59a4af84$export$80d7e435f744f319 = 12;
const $8540a44f59a4af84$export$4db7641526e3241f = 4;
const $8540a44f59a4af84$export$698aec755e92c695 = 3600;
const $8540a44f59a4af84$export$a77c1a7ebebe2a5a = 60;
const $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$export$698aec755e92c695 * 24;
const $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$export$815a9362476d2fe3 * 7;
const $8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$export$815a9362476d2fe3 * $8540a44f59a4af84$export$3913210603d8e9ae;
const $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$export$7271e9e3478110d1 / 12;
const $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$export$8e6600bbdee7dabb * 3;
const $8540a44f59a4af84$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $abb9adbdb26342b3$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $8540a44f59a4af84$export$2a7b97929c48d47d) in date) return date[0, $8540a44f59a4af84$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$abb9adbdb26342b3$export$2e2bcd8739ae039 = $abb9adbdb26342b3$export$ead8a1812b171991;


function $231bfb8d72679740$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$231bfb8d72679740$export$2e2bcd8739ae039 = $231bfb8d72679740$export$e67a095c620b86fe;


function $7c47abeb099a42c0$export$e4de839670987035(date, dateToCompare) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) > +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$7c47abeb099a42c0$export$2e2bcd8739ae039 = $7c47abeb099a42c0$export$e4de839670987035;


function $d2aab93838002ade$export$5c007e10c6929c95(date, dateToCompare) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) < +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$d2aab93838002ade$export$2e2bcd8739ae039 = $d2aab93838002ade$export$5c007e10c6929c95;


function $7a7e68b5aa0b9077$export$248d38f6296296c5(leftDate, rightDate) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(leftDate) === +(0, $231bfb8d72679740$export$e67a095c620b86fe)(rightDate);
}
var // Fallback for modularized imports:
$7a7e68b5aa0b9077$export$2e2bcd8739ae039 = $7a7e68b5aa0b9077$export$248d38f6296296c5;


function $a96d25a4d70c8926$export$2baac2df6018cd7(date) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) > Date.now();
}
var // Fallback for modularized imports:
$a96d25a4d70c8926$export$2e2bcd8739ae039 = $a96d25a4d70c8926$export$2baac2df6018cd7;


function $957ff381b38ac7b6$export$fc5014aa3db48558(date) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) < Date.now();
}
var // Fallback for modularized imports:
$957ff381b38ac7b6$export$2e2bcd8739ae039 = $957ff381b38ac7b6$export$fc5014aa3db48558;


function $002c8181c95d5119$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $abb9adbdb26342b3$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}



function $b6caff0bf13dcaf5$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$b6caff0bf13dcaf5$export$2e2bcd8739ae039 = $b6caff0bf13dcaf5$export$63fa379ae8a9ba2;


function $27a7db21eafd685b$export$ea39ec197993aef0(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return +(0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateLeft_) === +(0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateRight_);
}
var // Fallback for modularized imports:
$27a7db21eafd685b$export$2e2bcd8739ae039 = $27a7db21eafd685b$export$ea39ec197993aef0;



function $d8623e255497753b$export$18c3c6510fb97afc(date) {
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, Date.now());
}
var // Fallback for modularized imports:
$d8623e255497753b$export$2e2bcd8739ae039 = $d8623e255497753b$export$18c3c6510fb97afc;



function $06e3609fc2fbc2e2$export$a18c89cbd24170ff(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}
var // Fallback for modularized imports:
$06e3609fc2fbc2e2$export$2e2bcd8739ae039 = $06e3609fc2fbc2e2$export$a18c89cbd24170ff;


function $a513a065f29b721f$export$173f1e1d92847276(date, options) {
    return (0, $06e3609fc2fbc2e2$export$a18c89cbd24170ff)((0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, date), (0, $d8623e255497753b$export$18c3c6510fb97afc)(options?.in || date));
}
var // Fallback for modularized imports:
$a513a065f29b721f$export$2e2bcd8739ae039 = $a513a065f29b721f$export$173f1e1d92847276;





function $c922a15e7d8774a7$export$69be7267a042ecb3(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$c922a15e7d8774a7$export$2e2bcd8739ae039 = $c922a15e7d8774a7$export$69be7267a042ecb3;


function $b059a7637303f908$export$5c60e4190867161c(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return +(0, $c922a15e7d8774a7$export$69be7267a042ecb3)(dateLeft_) === +(0, $c922a15e7d8774a7$export$69be7267a042ecb3)(dateRight_);
}
var // Fallback for modularized imports:
$b059a7637303f908$export$2e2bcd8739ae039 = $b059a7637303f908$export$5c60e4190867161c;


function $7b97fc1be12623a5$export$3d88fd18ab599ccc(date, options) {
    return (0, $b059a7637303f908$export$5c60e4190867161c)((0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, date), (0, $d8623e255497753b$export$18c3c6510fb97afc)(options?.in || date));
}
var // Fallback for modularized imports:
$7b97fc1be12623a5$export$2e2bcd8739ae039 = $7b97fc1be12623a5$export$3d88fd18ab599ccc;




let $39440020b58e1ef8$var$defaultOptions = {};
function $39440020b58e1ef8$export$430a3269e24b912e() {
    return $39440020b58e1ef8$var$defaultOptions;
}
function $39440020b58e1ef8$export$95365be1b0704abc(newOptions) {
    $39440020b58e1ef8$var$defaultOptions = newOptions;
}



function $61f11f7a26b3ab78$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$61f11f7a26b3ab78$export$2e2bcd8739ae039 = $61f11f7a26b3ab78$export$42c81a444fbfb5d4;


function $4398e052cc63a087$export$6ea683876c36b8d2(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return +(0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(laterDate_, options) === +(0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(earlierDate_, options);
}
var // Fallback for modularized imports:
$4398e052cc63a087$export$2e2bcd8739ae039 = $4398e052cc63a087$export$6ea683876c36b8d2;


function $def5a9154a6fce3c$export$cfe4b66a69cdd8a(date, options) {
    return (0, $4398e052cc63a087$export$6ea683876c36b8d2)((0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, date), (0, $d8623e255497753b$export$18c3c6510fb97afc)(options?.in || date), options);
}
var // Fallback for modularized imports:
$def5a9154a6fce3c$export$2e2bcd8739ae039 = $def5a9154a6fce3c$export$cfe4b66a69cdd8a;




function $a4f3c61641c4093b$export$5841f9eb9773f25f(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$a4f3c61641c4093b$export$2e2bcd8739ae039 = $a4f3c61641c4093b$export$5841f9eb9773f25f;


function $0a1172148c7ecca3$export$a28c94941893a5ac(date, options) {
    return (0, $a4f3c61641c4093b$export$5841f9eb9773f25f)((0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, date), (0, $d8623e255497753b$export$18c3c6510fb97afc)(options?.in || date));
}
var // Fallback for modularized imports:
$0a1172148c7ecca3$export$2e2bcd8739ae039 = $0a1172148c7ecca3$export$a28c94941893a5ac;




function $f574f3f9c5879b15$export$629b0a497aa65267(date, options) {
    return (0, $27a7db21eafd685b$export$ea39ec197993aef0)((0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, date), (0, $d8623e255497753b$export$18c3c6510fb97afc)(options?.in || date));
}
var // Fallback for modularized imports:
$f574f3f9c5879b15$export$2e2bcd8739ae039 = $f574f3f9c5879b15$export$629b0a497aa65267;



function $a351150ce2eb3ddb$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$a351150ce2eb3ddb$export$2e2bcd8739ae039 = $a351150ce2eb3ddb$export$dd412b56f1e4d8aa;




function $85ced2fb3637e354$export$d6365ba92f0647f1(date, options) {
    return (0, $27a7db21eafd685b$export$ea39ec197993aef0)(date, (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)((0, $d8623e255497753b$export$18c3c6510fb97afc)(options?.in || date), 1), options);
}
var // Fallback for modularized imports:
$85ced2fb3637e354$export$2e2bcd8739ae039 = $85ced2fb3637e354$export$d6365ba92f0647f1;





function $43790e1a97254ab3$export$70823084e2deb1ea(date, amount, options) {
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date, -amount, options);
}
var // Fallback for modularized imports:
$43790e1a97254ab3$export$2e2bcd8739ae039 = $43790e1a97254ab3$export$70823084e2deb1ea;


function $01ed96ff4a2923d1$export$221990270ebfe867(date, options) {
    return (0, $27a7db21eafd685b$export$ea39ec197993aef0)((0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, date), (0, $43790e1a97254ab3$export$70823084e2deb1ea)((0, $d8623e255497753b$export$18c3c6510fb97afc)(options?.in || date), 1));
}
var // Fallback for modularized imports:
$01ed96ff4a2923d1$export$2e2bcd8739ae039 = $01ed96ff4a2923d1$export$221990270ebfe867;



var $9OAZF = parcelRequire("9OAZF");
const $0bc92389da5ca8f2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $0bc92389da5ca8f2$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $0bc92389da5ca8f2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $46af55383084911e$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $63c01f9040a729a9$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $63c01f9040a729a9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $63c01f9040a729a9$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $63c01f9040a729a9$export$cbf60ecb96cbb82f = {
    date: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $f529b3bee3f6d835$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $f529b3bee3f6d835$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$f529b3bee3f6d835$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $39a1e2b6239b09b3$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $eb9cac2ee97a0b54$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $eb9cac2ee97a0b54$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $eb9cac2ee97a0b54$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $eb9cac2ee97a0b54$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $eb9cac2ee97a0b54$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $eb9cac2ee97a0b54$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $eb9cac2ee97a0b54$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $eb9cac2ee97a0b54$var$ordinalNumber,
    era: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $eb9cac2ee97a0b54$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $e4df69a5a2d494a3$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $e4df69a5a2d494a3$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $e4df69a5a2d494a3$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e4df69a5a2d494a3$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e4df69a5a2d494a3$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $2594a2c0202dabc6$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $d2fa28259adb3ab1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d2fa28259adb3ab1$var$parseOrdinalNumberPattern = /\d+/i;
const $d2fa28259adb3ab1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d2fa28259adb3ab1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d2fa28259adb3ab1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d2fa28259adb3ab1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d2fa28259adb3ab1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d2fa28259adb3ab1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d2fa28259adb3ab1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d2fa28259adb3ab1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d2fa28259adb3ab1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $2594a2c0202dabc6$export$fdaf2fd6d7edde95)({
        matchPattern: $d2fa28259adb3ab1$var$matchOrdinalNumberPattern,
        parsePattern: $d2fa28259adb3ab1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $cd0c27002eb93234$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $0bc92389da5ca8f2$export$2c14ff85d6318973),
    formatLong: (0, $63c01f9040a729a9$export$cbf60ecb96cbb82f),
    formatRelative: (0, $f529b3bee3f6d835$export$8fbbfd65594f46a0),
    localize: (0, $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63),
    match: (0, $d2fa28259adb3ab1$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$cd0c27002eb93234$export$2e2bcd8739ae039 = $cd0c27002eb93234$export$137380d9ce54f7f;


const $54cd66db3e5e74df$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $54cd66db3e5e74df$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $54cd66db3e5e74df$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $54cd66db3e5e74df$var$timeLongFormatter(timePattern, formatLong));
};
const $54cd66db3e5e74df$export$70cc8fd02856fd58 = {
    p: $54cd66db3e5e74df$var$timeLongFormatter,
    P: $54cd66db3e5e74df$var$dateTimeLongFormatter
};


const $7e8a5b0b77bf77b9$var$dayOfYearTokenRE = /^D+$/;
const $7e8a5b0b77bf77b9$var$weekYearTokenRE = /^Y+$/;
const $7e8a5b0b77bf77b9$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7e8a5b0b77bf77b9$export$c6cc36aa33304772(token) {
    return $7e8a5b0b77bf77b9$var$dayOfYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1(token) {
    return $7e8a5b0b77bf77b9$var$weekYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $7e8a5b0b77bf77b9$var$message(token, format, input);
    console.warn(_message);
    if ($7e8a5b0b77bf77b9$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7e8a5b0b77bf77b9$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}




function $f3e2f0f906df8397$export$430a3269e24b912e() {
    return Object.assign({}, (0, $39440020b58e1ef8$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$f3e2f0f906df8397$export$2e2bcd8739ae039 = $f3e2f0f906df8397$export$430a3269e24b912e;





function $59425df5ba0b4bea$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $59425df5ba0b4bea$var$isConstructor(constructor) ? new constructor(0) : (0, $abb9adbdb26342b3$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $59425df5ba0b4bea$var$isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
var // Fallback for modularized imports:
$59425df5ba0b4bea$export$2e2bcd8739ae039 = $59425df5ba0b4bea$export$9cb09a71b7d66923;


const $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY = 10;
class $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 extends $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $2c074b7ab8cd2d6d$export$8be15fe85ad72f86 extends $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    priority = $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, $abb9adbdb26342b3$export$ead8a1812b171991)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, (0, $59425df5ba0b4bea$export$9cb09a71b7d66923)(date, this.context));
    }
}



class $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $db0c34f9a22bf78d$export$8e5a1d3f85a9688 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}




const $90ea69bf2b625c49$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $90ea69bf2b625c49$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $7caea2161b2082cf$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7caea2161b2082cf$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $8540a44f59a4af84$export$7f72910d6dfd237a) + minutes * (0, $8540a44f59a4af84$export$91246f0b9bd9beff) + seconds * (0, $8540a44f59a4af84$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$export$d931c43c4608a164(dateString) {
    return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $7caea2161b2082cf$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $7caea2161b2082cf$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7caea2161b2082cf$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $66195bae0f19f15a$export$48d352de7cd4a988 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}






function $0170e230c8468ebb$export$12d572480ceb6e58(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$0170e230c8468ebb$export$2e2bcd8739ae039 = $0170e230c8468ebb$export$12d572480ceb6e58;





class $9fda39b31cab7345$export$b8ef38dfcf05d5db extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}



function $1c9d32c6cb108460$export$6173213f95a4431e(date, options) {
    return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$1c9d32c6cb108460$export$2e2bcd8739ae039 = $1c9d32c6cb108460$export$6173213f95a4431e;





class $1a189db5f2a1065c$export$951d1df011fde06f extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $c3854b7a937037cd$export$bad9d2ea38e8f1a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $d1988bf983127f3e$export$5cb0f701186dde1d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $62b79555ac1f33b0$export$300c0c2990e20e6d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $44a198f4e488a239$export$400dd8b40ef138a3 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}





class $f7643ab884280f91$export$1d7eaa53eaa5deba extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}








function $ac7640a7ade5a435$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$ac7640a7ade5a435$export$2e2bcd8739ae039 = $ac7640a7ade5a435$export$bb7b45bb8e74da0f;



function $11b38d723fd57381$export$efe19b760242b2fc(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(_date, options) - +(0, $ac7640a7ade5a435$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $8540a44f59a4af84$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$11b38d723fd57381$export$2e2bcd8739ae039 = $11b38d723fd57381$export$efe19b760242b2fc;



function $66c7729eb95aa501$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $11b38d723fd57381$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date_, options?.in);
}
var // Fallback for modularized imports:
$66c7729eb95aa501$export$2e2bcd8739ae039 = $66c7729eb95aa501$export$4b3066ce4afafd88;






class $0da9b6c0b13ee7fd$export$c4005ffc174e07c0 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)((0, $66c7729eb95aa501$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}








function $c95dff76bf2f692a$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$c95dff76bf2f692a$export$2e2bcd8739ae039 = $c95dff76bf2f692a$export$3dbc52535f6f8fcc;



function $3b2e6199275b27d6$export$236bdfa374eb69a9(date, options) {
    const year = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$3b2e6199275b27d6$export$2e2bcd8739ae039 = $3b2e6199275b27d6$export$236bdfa374eb69a9;



function $83e11b0db4cec366$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $1c9d32c6cb108460$export$6173213f95a4431e)(_date) - +(0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $8540a44f59a4af84$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$83e11b0db4cec366$export$2e2bcd8739ae039 = $83e11b0db4cec366$export$7cabdc5698b63e2f;



function $d0815b4ed45bc80a$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$d0815b4ed45bc80a$export$2e2bcd8739ae039 = $d0815b4ed45bc80a$export$6542bebf6be94082;






class $6803ee1ef2b46eaa$export$6fc8dbedd560a6af extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)((0, $d0815b4ed45bc80a$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}





const $e06f3f7fc9153746$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $e06f3f7fc9153746$export$e8d4b28a20981dd2 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $6b2b75646543924f$export$6cfe0d613455f615 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





function $13939a537621d91b$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$13939a537621d91b$export$2e2bcd8739ae039 = $13939a537621d91b$export$b04fdcda82decc6c;



class $9c29ecc5d15fe12f$export$1b03c8b76262f7bd extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $fff6beaa36b4d0e5$export$44d1c127ab42c480 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}





class $1516c9543f7b6045$export$e447a647caaaec1d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}




function $6f80ca66d6710e40$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$6f80ca66d6710e40$export$2e2bcd8739ae039 = $6f80ca66d6710e40$export$c514f4c1a8ed5e9e;



function $87a68208fbd57247$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = (0, $6f80ca66d6710e40$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$87a68208fbd57247$export$2e2bcd8739ae039 = $87a68208fbd57247$export$1fd9df65adb0d1aa;




class $6410865f895f2a05$export$693fb1e525095b2a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $87a68208fbd57247$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $d5f00db985cb1985$export$8d1e08492351df91 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $40ef93898dc5fd94$export$73ca2bd0a17d273 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $74a8f7a92cf7f4b7$export$bb9212adf05373db extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}





class $c4e91a5550a4af76$export$8a04050a727a1756 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $04e380d05021e0e6$export$e56f4dea2c3e56dd extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $b7df994bc976acad$export$cbbe855312f87d77 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}





class $2a786c11f89b58f4$export$6008046d2b34b6a5 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}





class $fccac2a30b38ae4c$export$2b52670d9e2be53 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}





class $1cf805ecbd4f0c4e$export$94d46d540cf1366a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




class $93458d2bd887c060$export$b8e6f8b2d70893b1 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




function $92dc0740ffabe180$export$113002b5eff6e430(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}





class $8e1ac7071c05f7b7$export$104d901d49fea29b extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}







class $817e75c4dd06b66a$export$12910e5204b52b9 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}





class $a7e39061a4ba0a45$export$2cd8bf877a05e96 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 40;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}





class $dff03ff1496c0b81$export$6d8f69c6906d6368 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 20;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}


const $5cf2b811a6ff5b69$export$19131010e7fd8373 = {
    G: new (0, $db0c34f9a22bf78d$export$8e5a1d3f85a9688)(),
    y: new (0, $66195bae0f19f15a$export$48d352de7cd4a988)(),
    Y: new (0, $9fda39b31cab7345$export$b8ef38dfcf05d5db)(),
    R: new (0, $1a189db5f2a1065c$export$951d1df011fde06f)(),
    u: new (0, $c3854b7a937037cd$export$bad9d2ea38e8f1a)(),
    Q: new (0, $d1988bf983127f3e$export$5cb0f701186dde1d)(),
    q: new (0, $62b79555ac1f33b0$export$300c0c2990e20e6d)(),
    M: new (0, $44a198f4e488a239$export$400dd8b40ef138a3)(),
    L: new (0, $f7643ab884280f91$export$1d7eaa53eaa5deba)(),
    w: new (0, $0da9b6c0b13ee7fd$export$c4005ffc174e07c0)(),
    I: new (0, $6803ee1ef2b46eaa$export$6fc8dbedd560a6af)(),
    d: new (0, $e06f3f7fc9153746$export$e8d4b28a20981dd2)(),
    D: new (0, $6b2b75646543924f$export$6cfe0d613455f615)(),
    E: new (0, $9c29ecc5d15fe12f$export$1b03c8b76262f7bd)(),
    e: new (0, $fff6beaa36b4d0e5$export$44d1c127ab42c480)(),
    c: new (0, $1516c9543f7b6045$export$e447a647caaaec1d)(),
    i: new (0, $6410865f895f2a05$export$693fb1e525095b2a)(),
    a: new (0, $d5f00db985cb1985$export$8d1e08492351df91)(),
    b: new (0, $40ef93898dc5fd94$export$73ca2bd0a17d273)(),
    B: new (0, $74a8f7a92cf7f4b7$export$bb9212adf05373db)(),
    h: new (0, $c4e91a5550a4af76$export$8a04050a727a1756)(),
    H: new (0, $04e380d05021e0e6$export$e56f4dea2c3e56dd)(),
    K: new (0, $b7df994bc976acad$export$cbbe855312f87d77)(),
    k: new (0, $2a786c11f89b58f4$export$6008046d2b34b6a5)(),
    m: new (0, $fccac2a30b38ae4c$export$2b52670d9e2be53)(),
    s: new (0, $1cf805ecbd4f0c4e$export$94d46d540cf1366a)(),
    S: new (0, $93458d2bd887c060$export$b8e6f8b2d70893b1)(),
    X: new (0, $8e1ac7071c05f7b7$export$104d901d49fea29b)(),
    x: new (0, $817e75c4dd06b66a$export$12910e5204b52b9)(),
    t: new (0, $a7e39061a4ba0a45$export$2cd8bf877a05e96)(),
    T: new (0, $dff03ff1496c0b81$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $8abb93379891fb3e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $8abb93379891fb3e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $8abb93379891fb3e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $8abb93379891fb3e$var$doubleQuoteRegExp = /''/g;
const $8abb93379891fb3e$var$notWhitespaceRegExp = /\S/;
const $8abb93379891fb3e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $8abb93379891fb3e$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, $f3e2f0f906df8397$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $cd0c27002eb93234$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $2c074b7ab8cd2d6d$export$8be15fe85ad72f86)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match($8abb93379891fb3e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($8abb93379891fb3e$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $5cf2b811a6ff5b69$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($8abb93379891fb3e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $8abb93379891fb3e$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $8abb93379891fb3e$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $8abb93379891fb3e$var$cleanEscapedString(input) {
    return input.match($8abb93379891fb3e$var$escapedStringRegExp)[1].replace($8abb93379891fb3e$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$8abb93379891fb3e$export$2e2bcd8739ae039 = $8abb93379891fb3e$export$98e6a39c04603d36;




function $a92bacc669eda25d$export$4393d2ccbbedb219(argument, options) {
    const invalidDate = ()=>(0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in, NaN);
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $a92bacc669eda25d$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $a92bacc669eda25d$var$parseYear(dateStrings.date, additionalDigits);
        date = $a92bacc669eda25d$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    const timestamp = +date;
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $a92bacc669eda25d$var$parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = $a92bacc669eda25d$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        const tmpDate = new Date(timestamp + time);
        const result = (0, $231bfb8d72679740$export$e67a095c620b86fe)(0, options?.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(timestamp + time + offset, options?.in);
}
const $a92bacc669eda25d$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $a92bacc669eda25d$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $a92bacc669eda25d$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $a92bacc669eda25d$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $a92bacc669eda25d$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($a92bacc669eda25d$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($a92bacc669eda25d$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($a92bacc669eda25d$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $a92bacc669eda25d$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $a92bacc669eda25d$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $a92bacc669eda25d$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($a92bacc669eda25d$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $a92bacc669eda25d$var$parseDateUnit(captures[1]);
    const month = $a92bacc669eda25d$var$parseDateUnit(captures[2]) - 1;
    const day = $a92bacc669eda25d$var$parseDateUnit(captures[3]);
    const week = $a92bacc669eda25d$var$parseDateUnit(captures[4]);
    const dayOfWeek = $a92bacc669eda25d$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$a92bacc669eda25d$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $a92bacc669eda25d$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$a92bacc669eda25d$var$validateDate(year, month, day) || !$a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $a92bacc669eda25d$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $a92bacc669eda25d$var$parseTime(timeString) {
    const captures = timeString.match($a92bacc669eda25d$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $a92bacc669eda25d$var$parseTimeUnit(captures[1]);
    const minutes = $a92bacc669eda25d$var$parseTimeUnit(captures[2]);
    const seconds = $a92bacc669eda25d$var$parseTimeUnit(captures[3]);
    if (!$a92bacc669eda25d$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $8540a44f59a4af84$export$7f72910d6dfd237a) + minutes * (0, $8540a44f59a4af84$export$91246f0b9bd9beff) + seconds * 1000;
}
function $a92bacc669eda25d$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $a92bacc669eda25d$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($a92bacc669eda25d$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$a92bacc669eda25d$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $8540a44f59a4af84$export$7f72910d6dfd237a) + minutes * (0, $8540a44f59a4af84$export$91246f0b9bd9beff));
}
function $a92bacc669eda25d$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $a92bacc669eda25d$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $a92bacc669eda25d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $a92bacc669eda25d$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($a92bacc669eda25d$var$daysInMonths[month] || ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 29 : 28));
}
function $a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 366 : 365);
}
function $a92bacc669eda25d$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $a92bacc669eda25d$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $a92bacc669eda25d$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$a92bacc669eda25d$export$2e2bcd8739ae039 = $a92bacc669eda25d$export$4393d2ccbbedb219;


// TODO inspect why the following is erroring on angular build






function $737f54e9ffaddc15$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $92dc0740ffabe180$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $92dc0740ffabe180$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $8540a44f59a4af84$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$737f54e9ffaddc15$export$2e2bcd8739ae039 = $737f54e9ffaddc15$export$4a02e9c37dab4871;



function $29cc086f79701cd9$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$29cc086f79701cd9$export$2e2bcd8739ae039 = $29cc086f79701cd9$export$f91e89d3d0406102;



function $306b88ce50904f9c$export$d3b42cd8452deec(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, (0, $29cc086f79701cd9$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$306b88ce50904f9c$export$2e2bcd8739ae039 = $306b88ce50904f9c$export$d3b42cd8452deec;






function $03d75ed55eeb99fa$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $71a5e81f1193b7a8$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $008fe800ab658844$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $008fe800ab658844$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $11b38d723fd57381$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $306b88ce50904f9c$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $008fe800ab658844$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(minutes, 2);
}
function $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $008fe800ab658844$var$formatTimezone(offset, delimiter);
}
function $008fe800ab658844$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}




/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $1896b5e28554d57b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$1896b5e28554d57b$export$2e2bcd8739ae039 = $1896b5e28554d57b$export$871608497c498473;



function $f2a682b251363bc2$export$1ea939691cdc45b8(date) {
    return !(!(0, $1896b5e28554d57b$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $231bfb8d72679740$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$f2a682b251363bc2$export$2e2bcd8739ae039 = $f2a682b251363bc2$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $303ba10db2c74ab4$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $303ba10db2c74ab4$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $303ba10db2c74ab4$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $303ba10db2c74ab4$var$doubleQuoteRegExp = /''/g;
const $303ba10db2c74ab4$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $303ba10db2c74ab4$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $cd0c27002eb93234$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($303ba10db2c74ab4$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($303ba10db2c74ab4$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $303ba10db2c74ab4$var$cleanEscapedString(substring)
        };
        if ((0, $008fe800ab658844$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($303ba10db2c74ab4$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $008fe800ab658844$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $303ba10db2c74ab4$var$cleanEscapedString(input) {
    const matched = input.match($303ba10db2c74ab4$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($303ba10db2c74ab4$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$303ba10db2c74ab4$export$2e2bcd8739ae039 = $303ba10db2c74ab4$export$d9468344d3651243;


/**
 * Converts string to Sentence case.
 * Splits on camelCase, PascalCase, dots, underscores, hyphens, and non-alphanumeric characters.
 * Drop-in replacement for the sentence-case package.
 */ 
var $9CW7w = parcelRequire("9CW7w");
function $eba08d324485aa80$export$2e2bcd8739ae039(input) {
    const parts = (0, $9CW7w.default)(input);
    if (parts.length === 0) return '';
    return parts.map((w, i)=>i === 0 ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w.toLowerCase()).join(' ');
}




var $9OAZF = parcelRequire("9OAZF");

function $f5fc3c9fe698fd70$export$208b568bb1fb5718(item) {
    return item != null && item != undefined;
}
function $f5fc3c9fe698fd70$export$8d730750d37d5632(item) {
    return !$f5fc3c9fe698fd70$export$208b568bb1fb5718(item);
}
function $f5fc3c9fe698fd70$export$f6de9748f8da7bed(item) {
    return Object.keys(item).length > 0;
}
function $f5fc3c9fe698fd70$export$6ee53d8de046ff63(event) {
    if (event.key == null) return event.char; // IE
    return event.key;
}
function $f5fc3c9fe698fd70$export$d30aea6baca0538b(obj) {
    return JSON.parse(JSON.stringify(obj));
}
const $f5fc3c9fe698fd70$export$cc9ece9e5ecc9b05 = (arr)=>{
    const defaultAccumulator = {};
    if (!arr || !Array.isArray(arr)) return defaultAccumulator;
    return arr.reduce((acc, key)=>{
        acc[key] = true;
        return acc;
    }, defaultAccumulator);
};
function $f5fc3c9fe698fd70$export$22d91702eb01c721(array, separator = " ' ") {
    let csvContent = '';
    array.forEach((infoArray, index)=>{
        let line = [];
        let item;
        let i;
        for(i = 0; i < infoArray.length; ++i){
            item = infoArray[i];
            if (separator == ',') {
                if (item != null && item != undefined) {
                    if (typeof item === 'string' || item instanceof String) {
                        if (item.indexOf(',') !== -1 || item.indexOf('"') !== -1) item = `"${item.replace(/"/g, '""')}"`;
                        // bit of a hack but we have a user where they have "+2502+S" as a value which Excel then thinks is a formula
                        if (item.indexOf('+') == 0) item = `'${item}'`;
                    }
                }
            }
            line.push(item);
        }
        csvContent += line.join(separator) + (index != array.length - 1 ? '\n' : '');
    });
    return csvContent;
}
function $f5fc3c9fe698fd70$export$c1f7e596c96fce33(content, fileName, mimeType) {
    const win = document.defaultView || window;
    if (!win) {
        console.error('No window found, cannot download file');
        return;
    }
    const a = document.createElement('a');
    mimeType = mimeType || 'application/octet-stream';
    if (URL && 'download' in a) {
        // html5 A[download]
        a.href = URL.createObjectURL(new Blob([
            content
        ], {
            type: mimeType
        }));
        a.setAttribute('download', fileName);
        document.body.appendChild(a);
        a.dispatchEvent(new MouseEvent('click', {
            bubbles: false,
            cancelable: true,
            view: win
        }));
        document.body.removeChild(a);
    } else location.href = `data:application/octet-stream,${encodeURIComponent(content)}`; // only this mime type is supported
}
async function $f5fc3c9fe698fd70$export$2cdf1b96a9f86d16(text) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (ex) {
        return $f5fc3c9fe698fd70$var$copyToClipboardForOldBrowsers(text);
    }
}
function $f5fc3c9fe698fd70$var$copyToClipboardForOldBrowsers(text) {
    if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
        let textarea = document.createElement('textarea');
        textarea.textContent = text;
        textarea.style.width = '1px';
        textarea.style.height = '1px';
        textarea.style.top = '0px';
        textarea.style.left = '0px';
        textarea.style.position = 'absolute';
        textarea.style.opacity = '0.0';
        document.body.appendChild(textarea);
        textarea.select();
        textarea.focus();
        try {
            return document.execCommand('copy'); // Security exception may be thrown by some browsers.
        } catch (ex) {
            (0, $10f858c943b30cc8$export$a58502b374804b0f).consoleErrorBase('Copy to clipboard failed.', ex);
            return false;
        } finally{
            document.body.removeChild(textarea);
        }
    }
}
function $f5fc3c9fe698fd70$export$d860ca7e9a905f88(items, itemName) {
    if (items.length == 0) return `No ${itemName}s`;
    return items.length == 1 ? `1 ${itemName}` : `${items.length} ${itemName}s`;
}
function $f5fc3c9fe698fd70$export$79d793ed837e2148(itemToCheck) {
    if (itemToCheck == 'Invalid Date ') return true;
    if (typeof itemToCheck === 'string') return (0, $9OAZF.StringExtensions).IsNullOrEmpty(itemToCheck);
    if (typeof itemToCheck === 'number') return (0, $9OAZF.StringExtensions).IsNullOrEmpty(itemToCheck.toString());
    if (itemToCheck instanceof Date) return (0, $9OAZF.StringExtensions).IsNullOrEmpty(itemToCheck.toString());
    return itemToCheck == null;
}
function $f5fc3c9fe698fd70$export$e07c18d6e1ebff89(itemToCheck) {
    return !$f5fc3c9fe698fd70$export$79d793ed837e2148(itemToCheck);
}
function $f5fc3c9fe698fd70$export$a3992db8dd0fd9e6(numberToRound, decimalPlaces) {
    switch(decimalPlaces){
        case 1:
            return Math.round(numberToRound * 10) / 10;
        case 2:
            return Math.round(numberToRound * 100) / 100;
        case 3:
            return Math.round(numberToRound * 1000) / 1000;
        case 4:
            return Math.round(numberToRound * 10000) / 10000;
        case 5:
            return Math.round(numberToRound * 100000) / 100000;
        case 6:
            return Math.round(numberToRound * 1000000) / 1000000;
    }
}
function $f5fc3c9fe698fd70$export$5643dc4971881fc0(numberToRound) {
    return $f5fc3c9fe698fd70$export$a3992db8dd0fd9e6(numberToRound, 4);
}
function $f5fc3c9fe698fd70$export$7d15b64cf5a3a4c4(value, boundOne, boundTwo) {
    if (!boundTwo) return Math.max(value, boundOne) === boundOne ? value : boundOne;
    else if (Math.min(value, boundOne) === value) return boundOne;
    else if (Math.max(value, boundTwo) === value) return boundTwo;
    return value;
}
function $f5fc3c9fe698fd70$export$13975875619e81d0(text) {
    // rowData.columnName => columnName
    const regex = /\[rowData\.(.*?)\]/g;
    let m;
    const cols = [];
    while((m = regex.exec(text)) !== null)cols.push(m[1]);
    return cols;
}
function $f5fc3c9fe698fd70$export$b8b3234b4edfc4c2(text, toReplace, replaceWith) {
    if (!text) return text;
    // fails for []
    toReplace = toReplace.replace('[', '\\[').replace(']', '\\]');
    return text.replace(new RegExp(toReplace, 'g'), replaceWith);
}
function $f5fc3c9fe698fd70$export$1d3bb0f517de50f9(text) {
    // context.columnName => columnName
    const regex = /\[context\.(.*?)\]/g;
    let m;
    const contextKeys = [];
    while((m = regex.exec(text)) !== null)contextKeys.push(m[1]);
    return contextKeys;
}
const $f5fc3c9fe698fd70$export$37ddbc38b6af2a38 = {
    objectExists: $f5fc3c9fe698fd70$export$208b568bb1fb5718,
    objectNotExists: $f5fc3c9fe698fd70$export$8d730750d37d5632,
    objectHasKeys: $f5fc3c9fe698fd70$export$f6de9748f8da7bed,
    getStringRepresentionFromKey: $f5fc3c9fe698fd70$export$6ee53d8de046ff63,
    cloneObject: $f5fc3c9fe698fd70$export$d30aea6baca0538b,
    convertArrayToCsv: $f5fc3c9fe698fd70$export$22d91702eb01c721,
    createDownloadedFile: $f5fc3c9fe698fd70$export$c1f7e596c96fce33,
    copyToClipboard: $f5fc3c9fe698fd70$export$2cdf1b96a9f86d16,
    returnItemCount: $f5fc3c9fe698fd70$export$d860ca7e9a905f88,
    isInputNullOrEmpty: $f5fc3c9fe698fd70$export$79d793ed837e2148,
    isInputNotNullOrEmpty: $f5fc3c9fe698fd70$export$e07c18d6e1ebff89,
    roundNumber: $f5fc3c9fe698fd70$export$a3992db8dd0fd9e6,
    roundNumberTo4dp: $f5fc3c9fe698fd70$export$5643dc4971881fc0,
    clamp: $f5fc3c9fe698fd70$export$7d15b64cf5a3a4c4,
    extractColsFromText: $f5fc3c9fe698fd70$export$13975875619e81d0,
    replaceAll: $f5fc3c9fe698fd70$export$b8b3234b4edfc4c2,
    extractContextKeysFromText: $f5fc3c9fe698fd70$export$1d3bb0f517de50f9
};
var $f5fc3c9fe698fd70$export$2e2bcd8739ae039 = $f5fc3c9fe698fd70$export$37ddbc38b6af2a38;



var $9OAZF = parcelRequire("9OAZF");
function $1fe81e1078ace264$export$cc77c4ff7e8673c5(input, options = {}, rowNode, column, api) {
    let preparedInput;
    if (options.Content) {
        const context = {
            column: column,
            rowNode: rowNode,
            input: input,
            api: api
        };
        preparedInput = $1fe81e1078ace264$var$formatPlaceholder(options.Content.toString(), context);
    } else preparedInput = input;
    if (preparedInput == null || preparedInput == undefined) return undefined;
    if (typeof preparedInput === 'string') return preparedInput;
    let n = Number(preparedInput);
    if (isNaN(n)) return preparedInput.toString();
    let multiplier = options.Multiplier ? options.Multiplier : 1;
    if (options.Multiplier !== undefined) {
        n *= multiplier;
        n = parseFloat(n.toFixed(12));
    }
    // Set Integer and Fraction Digits to a max of 20
    if (options.IntegerDigits > 20) options.IntegerDigits = 20;
    if (options.FractionDigits > 20) options.FractionDigits = 20;
    if (options.Parentheses === true && preparedInput < 0) {
        n *= -1;
        n = parseFloat(n.toFixed(12));
    }
    if (options.Abs) n = Math.abs(n);
    if (options.Truncate) n = Math.trunc(n);
    if (options.Ceiling) n = Math.ceil(n);
    if (options.Round) n = Math.round(n);
    if (options.Floor) n = Math.floor(n);
    if (options.Empty) return ' ';
    let s;
    let digitsToUse;
    const fractionsSepatator = options.FractionSeparator ?? '.';
    if (options.Truncate || options.Ceiling || options.Round || options.Floor) digitsToUse = 0;
    else if (options.FractionDigits != null) digitsToUse = options.FractionDigits;
    else {
        let decimalCount = Math.floor(n) === n ? 0 : n.toString().split(fractionsSepatator)[1]?.length || 0;
        digitsToUse = decimalCount;
    }
    s = n.toLocaleString('en-US', {
        minimumIntegerDigits: options.IntegerDigits || undefined,
        minimumFractionDigits: digitsToUse,
        maximumFractionDigits: digitsToUse
    });
    if (options.FractionSeparator !== undefined) s = s.replace(/\./g, options.FractionSeparator);
    if (options.IntegerSeparator !== undefined) {
        // if fraction separator is not a comma then simply replace all instances
        if (options.FractionSeparator !== ',') s = s.replace(/\,/g, options.IntegerSeparator);
        else // otherwise don't replace the last instance
        s = (0, $9OAZF.default).ReplaceAllOccurencesExceptLastOne(s, ',', options.IntegerSeparator);
    }
    s = (options.Prefix || '') + s + (options.Suffix || '');
    if (options.Parentheses === true && preparedInput < 0) s = '(' + s + ')';
    return s;
}
function $1fe81e1078ace264$export$ad991b66133851cf(input, options, strictFormatting = false) {
    if (input == null || input == undefined || input == 'Invalid Date') return undefined;
    try {
        if (typeof input === 'string') {
            // Remove timezone info (e.g., Z or +02:00) using regex
            const cleanDateString = input.replace(/([+-]\d{2}:\d{2}|Z)$/, '');
            input = new Date(cleanDateString);
        }
        return (0, $303ba10db2c74ab4$export$d9468344d3651243)(input, options?.Pattern || (0, $58846ea7f4156db7$export$b51de3416397241));
    } catch (error) {
        if (strictFormatting) return `Invalid date formatting pattern`;
        if (typeof input !== 'string') return String(input);
        return input;
    }
}
function $1fe81e1078ace264$export$5a7f7b467323cd66(input, options = {}, rowNode, column, api) {
    let normalisedTextInput = input;
    if (input != undefined && typeof input !== 'string') {
        const warningMessage = column ? `StringFormatter: input '${input}' from column ${column.columnId} (${column.dataType}) is not a string, but a ${typeof input}` : `StringFormatter: input '${input}' is not a string, received ${typeof input}`;
        if (api) api.logWarn(warningMessage);
        else console.warn(warningMessage);
        normalisedTextInput = `${input}`;
    }
    let preparedInput;
    if (options.Content) {
        const context = {
            column: column,
            rowNode: rowNode,
            input: normalisedTextInput,
            api: api
        };
        preparedInput = $1fe81e1078ace264$var$formatPlaceholder(options.Content, context);
    } else preparedInput = normalisedTextInput;
    if ((0, $9OAZF.default).IsNullOrEmptyOrWhiteSpace(preparedInput)) return undefined;
    if (options.Empty) return ' ';
    let s = preparedInput;
    if (options.Prefix !== undefined) s = options.Prefix + s;
    if (options.Suffix !== undefined) s = s + options.Suffix;
    if (options.Case !== undefined) {
        if (options.Case == 'Lower') s = s.toLowerCase();
        else if (options.Case == 'Upper') s = s.toUpperCase();
        else if (options.Case == 'Sentence') s = (0, $eba08d324485aa80$export$2e2bcd8739ae039)(s);
    }
    if (options.Trim !== undefined && options.Trim == true) s = s.trim();
    return s;
}
function $1fe81e1078ace264$var$formatPlaceholder(text, context) {
    if (!text) return text;
    if (!context) return text;
    if (context?.input) text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, '[value]', context.input);
    if (context?.column) text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, '[column]', context.api.columnApi.getFriendlyNameForColumnId(context.column.columnId));
    if (context?.rowNode) {
        const columns = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).extractColsFromText(text);
        for (const column of columns)if (context.api.columnApi.getColumnWithColumnId(column)) text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, `[rowData.${column}]`, context.api.gridApi.getRawValueFromRowNode(context.rowNode, column));
    }
    return text;
}
var $1fe81e1078ace264$export$2e2bcd8739ae039 = {
    NumberFormatter: $1fe81e1078ace264$export$cc77c4ff7e8673c5,
    DateFormatter: $1fe81e1078ace264$export$ad991b66133851cf,
    StringFormatter: $1fe81e1078ace264$export$5a7f7b467323cd66
};



const $eccba2ee7b674d85$export$c03bb0116ee09d4b = (date)=>{
    return date instanceof Date && !isNaN(date.getTime());
};
const $eccba2ee7b674d85$export$155a8c53826313d9 = (data)=>{
    if (!data || typeof data === 'boolean') return false;
    const date = new Date(data);
    return !isNaN(date.getTime());
};
const $eccba2ee7b674d85$export$c25903b08840222a = (date)=>{
    return (0, $1fe81e1078ace264$export$ad991b66133851cf)(date, {
        Pattern: 'yyyy-MM-dd'
    });
};
const $eccba2ee7b674d85$export$53b52b78a0e685f9 = (date, dateFormat)=>{
    const dateInstance = $eccba2ee7b674d85$export$220ff045e4b830ec(date, dateFormat);
    return $eccba2ee7b674d85$export$c03bb0116ee09d4b(dateInstance) ? $eccba2ee7b674d85$export$c25903b08840222a(dateInstance) : '';
};
const $eccba2ee7b674d85$export$220ff045e4b830ec = (dateValue, dateFormat)=>{
    if (dateValue == undefined || typeof dateValue === 'string' && dateValue.trim() === '') return undefined;
    if (dateValue instanceof Date) return !isNaN(dateValue.getTime()) ? dateValue : undefined;
    try {
        let dateInstance;
        if (typeof dateValue === 'number') dateInstance = new Date(dateValue);
        else {
            // typeof dateValue === 'string'
            if (dateFormat) dateInstance = (0, $8abb93379891fb3e$export$98e6a39c04603d36)(dateValue, dateFormat, new Date());
            else dateInstance = (0, $a92bacc669eda25d$export$4393d2ccbbedb219)(dateValue);
            if (!$eccba2ee7b674d85$export$c03bb0116ee09d4b(dateInstance)) // last chance: try to use the native Date.parse(), https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse
            dateInstance = new Date(Date.parse(dateValue));
        }
        if (!$eccba2ee7b674d85$export$c03bb0116ee09d4b(dateInstance)) {
            (0, $10f858c943b30cc8$export$a58502b374804b0f).consoleWarnBase(`Invalid date value "${dateValue}" - cannot be converted to a Date instance. Please make sure you specify adaptableOptions.userInterfaceOptions.dateInputOptions.dateFormat correctly.`);
            dateInstance = undefined;
        }
        return dateInstance;
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        const errorStack = error instanceof Error ? error.stack : undefined;
        (0, $10f858c943b30cc8$export$a58502b374804b0f).consoleErrorBase(`Error parsing date value "${dateValue}": ${errorMessage}`, {
            stack: errorStack,
            originalError: error
        });
    }
};




function $ee11103a2ae7ed45$var$getGroupValuesForNode(config) {
    const { node: node, value: value } = config;
    const groupValues = node.group ? [] : /*for the leaf node, also use its value*/ value != null ? [
        value
    ] : [];
    let currentNode = node.group ? node : node.parent;
    while(currentNode && currentNode.groupData && Object.keys(currentNode.groupData).length > 0){
        if (currentNode.treeParent && !currentNode.data) ;
        else groupValues.unshift(currentNode.groupData[0, $58846ea7f4156db7$export$1fadf36dae8ed962]);
        currentNode = currentNode.parent;
    }
    return groupValues;
}
const $ee11103a2ae7ed45$export$93bfa1f66bce6e38 = [
    {
        id: 'In',
        label: 'In',
        icon: {
            text: 'IN'
        },
        columnScope: {
            DataTypes: [
                'text',
                'number',
                'date',
                'textArray',
                'numberArray'
            ],
            ColumnIds: [
                (0, $58846ea7f4156db7$export$1fadf36dae8ed962)
            ]
        },
        moduleScope: [
            'columnFilter',
            'flashingcell',
            'formatColumn',
            'alert',
            'badgeStyle'
        ],
        handler: (context)=>{
            const { inputs: inputs = [], column: column, value: value, adaptableApi: adaptableApi } = context;
            const predicateInputs = (context.inputs || []).map((input)=>{
                const predicateInput = adaptableApi.predicateApi.getPredicateDefById(input);
                if (!predicateInput) return;
                // make sure that the input Predicate  is included in the 'In' Predicate
                if (adaptableApi.columnScopeApi.scopeIsAll(predicateInput.columnScope) || adaptableApi.columnScopeApi.isScopeInScope(predicateInput.columnScope, // 'In' ColumnScope
                {
                    DataTypes: [
                        'text',
                        'number',
                        'date',
                        'textArray',
                        'numberArray'
                    ]
                })) return predicateInput;
            }).filter(Boolean);
            if (predicateInputs.length) {
                const nestedContext = {
                    ...context
                };
                delete nestedContext.inputs;
                const predicateResult = predicateInputs.some((predicate)=>{
                    return adaptableApi.predicateApi.handlePredicate({
                        PredicateId: predicate.id
                    }, nestedContext, false);
                });
                if (predicateResult) // We want to use the only true values, to allow for multiple predicates to be used
                return predicateResult;
            }
            if (inputs.length === 0) return true;
            if (column.columnId === (0, $58846ea7f4156db7$export$1fadf36dae8ed962)) {
                const { node: node, treeSelectionState: treeSelectionState } = context;
                const groupValues = $ee11103a2ae7ed45$var$getGroupValuesForNode({
                    node: node,
                    value: value
                });
                // for non-trees, this line is reached for every leaf-row
                // so for 2 levels-deep, groupValues is an array of ['level1-value','level2-value','leaf-value']
                // but for trees, the groupValues is first an array with only
                // one value, the current branch root - and if we go via the treeSelectionState
                // that root might have a leaf selected, but if we return true here
                // ag grid would include all rows of that branch - which is not what we want
                // so we want to enter the `if` block and use the startsWith check
                if (column.isTreeColumn || !treeSelectionState) {
                    // in case we don't have treeSelectionState
                    // this is another possible implementation
                    // though it won't be as performant as using the treeSelectionState
                    const currentValues = (groupValues ?? []).join('#');
                    return inputs.some((values)=>{
                        const valuesString = values.join('#');
                        return currentValues.startsWith(valuesString);
                    });
                }
                const result = groupValues ? treeSelectionState.isNodeSelected(groupValues) : false;
                // console.log('filter', groupValues, 'pass', result, treeSelectionState.getState());
                return result;
            }
            if (column.dataType === 'date') return inputs.some((input)=>{
                if (adaptableApi.predicateApi.internalApi.shouldEvaluateInPredicateUsingTime(column.columnId)) return (0, $7a7e68b5aa0b9077$export$248d38f6296296c5)(input, value);
                else return (0, $27a7db21eafd685b$export$ea39ec197993aef0)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(input), (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value));
            });
            if (column.dataType === 'number') return inputs.includes(value);
            if (column.dataType === 'numberArray') {
                const arrayValue = Array.isArray(value) ? value : [
                    value
                ];
                return inputs.some((input)=>{
                    return arrayValue.includes(input);
                });
            }
            const useCaseSensitivity = adaptableApi.predicateApi.useCaseSensitivity(column.columnId);
            if (column.dataType === 'text') return useCaseSensitivity ? inputs.map((i)=>{
                return i?.toLocaleLowerCase();
            }).includes(value?.toLocaleLowerCase()) : inputs.includes(value);
            if (column.dataType === 'textArray') {
                const arrayValue = Array.isArray(value) ? value : [
                    value
                ];
                return inputs.some((input)=>{
                    return useCaseSensitivity ? arrayValue.map((v)=>v?.toLocaleLowerCase()).includes(input?.toLocaleLowerCase()) : arrayValue.includes(input);
                });
            }
            return true;
        },
        toString: ({ inputs: inputs })=>`IN (${inputs.join(', ')})`,
        shortcuts: [
            '#',
            '['
        ]
    },
    // {
    //   id: 'Tree',
    //   label: 'Tree',
    //   icon: { text: 'Tree' },
    //   columnScope: { DataTypes: ['date'] },
    //   moduleScope: ['columnFilter', 'flashingcell', 'formatColumn', 'alert'],
    //   handler: (context) => {
    //     const { inputs = [], column, value, adaptableApi } = context;
    //     const predicateInputs = (context.inputs || []).reduce<AdaptablePredicateDef[]>(
    //       (acc, input) => {
    //         const predicate = adaptableApi.predicateApi.getPredicateDefById(input);
    //         if (predicate) {
    //           acc.push(predicate);
    //         }
    //         return acc;
    //       },
    //       []
    //     );
    //     if (predicateInputs.length) {
    //       const nestedContext = { ...context };
    //       delete nestedContext.inputs;
    //       const predicateResult = predicateInputs.some((predicate) => {
    //         return adaptableApi.predicateApi.handlePredicate(
    //           {
    //             PredicateId: predicate.id,
    //           },
    //           nestedContext,
    //           false
    //         );
    //       });
    //       if (predicateResult) {
    //         // We want to use the only true values, to allow for multiple predicates to be used
    //         return predicateResult;
    //       }
    //     }
    //     if (inputs.length === 0) {
    //       return true;
    //     }
    //     if (column.dataType === 'date') {
    //       const treeSelectionState = new TreeSelectionState(
    //         {
    //           defaultSelection: false,
    //           // make sure something like
    //           // Predicates: [{ PredicateId: 'Tree', Inputs: [['2021', '2'], ['2022']] }],
    //           // is always converted to numbers
    //           selectedPaths: inputs
    //             .map((array) => {
    //               if (!Array.isArray(array)) {
    //                 return null;
    //               }
    //               return array.map(Number);
    //             })
    //             .filter(Boolean),
    //         },
    //         () => {
    //           return {
    //             treeDeepMap: new DeepMap<string, any>(),
    //             treePaths: new DeepMap<string, any>(),
    //           };
    //         }
    //       );
    //       const currrentDate = parseDateValue(value);
    //       const currentYear = currrentDate.getFullYear();
    //       const currentMonth = currrentDate.getMonth() + 1;
    //       const currentDay = currrentDate.getDate();
    //       const result = treeSelectionState.isNodeSelected([currentYear, currentMonth, currentDay]);
    //       // console.log({ currentYear, currentMonth, currentDay, result, inputs: inputs.join('-') });
    //       return result;
    //     }
    //     return true;
    //   },
    //   toString: ({ inputs }) => `IN Tree (${inputs.join(', ')})`,
    //   shortcuts: ['#', '['],
    // },
    {
        id: 'NotIn',
        label: 'Not In',
        icon: {
            text: '!IN'
        },
        columnScope: {
            DataTypes: [
                'text',
                'number',
                'date',
                'textArray',
                'numberArray'
            ]
        },
        moduleScope: [
            'columnFilter',
            'flashingcell',
            'formatColumn',
            'alert',
            'badgeStyle'
        ],
        handler: (context)=>{
            const { inputs: inputs, column: column, value: value, adaptableApi: adaptableApi } = context;
            const predicateInputs = (context.inputs || []).map((input)=>{
                const predicateInput = adaptableApi.predicateApi.getPredicateDefById(input);
                if (!predicateInput) return;
                // make sure that the input Predicate  is included in the 'NotIn' Predicate
                if (adaptableApi.columnScopeApi.scopeIsAll(predicateInput.columnScope) || adaptableApi.columnScopeApi.isScopeInScope(predicateInput.columnScope, // 'NotIn' ColumnScope
                {
                    DataTypes: [
                        'text',
                        'number',
                        'date',
                        'textArray',
                        'numberArray'
                    ]
                })) return predicateInput;
            }).filter(Boolean);
            if (predicateInputs.length) {
                const nestedContext = {
                    ...context
                };
                delete nestedContext.inputs;
                const predicateResult = predicateInputs.every((predicate)=>{
                    const res = adaptableApi.predicateApi.handlePredicate({
                        PredicateId: predicate.id
                    }, nestedContext, false);
                    return res === false;
                });
                if (!predicateResult) // We want to use the only true values, to allow for multiple predicates to be used
                return false;
            }
            // basically negation of IN
            if (inputs.length === 0) return true;
            if (column.dataType === 'date') {
                if (adaptableApi.predicateApi.useCaseSensitivity(column.columnId)) return inputs.every((input)=>{
                    return !(0, $7a7e68b5aa0b9077$export$248d38f6296296c5)(input, value);
                });
                else return inputs.every((input)=>{
                    return !(0, $27a7db21eafd685b$export$ea39ec197993aef0)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(input), (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value));
                });
            }
            if (column.dataType === 'number') return !inputs.includes(value);
            if (column.dataType === 'numberArray') {
                const arrayValue = Array.isArray(value) ? value : [
                    value
                ];
                return inputs.every((input)=>{
                    return !arrayValue.includes(input);
                });
            }
            if (column.dataType === 'text') return adaptableApi.predicateApi.useCaseSensitivity(column.columnId) ? !inputs.map((i)=>{
                return i?.toLocaleLowerCase();
            }).includes(value?.toLocaleLowerCase()) : !inputs.includes(value);
            if (column.dataType === 'textArray') {
                const arrayValue = Array.isArray(value) ? value : [
                    value
                ];
                return inputs.every((input)=>{
                    return adaptableApi.predicateApi.useCaseSensitivity(column.columnId) ? !arrayValue.map((v)=>v?.toLocaleLowerCase()).includes(input?.toLocaleLowerCase()) : !arrayValue.includes(input);
                });
            }
            return true;
        },
        toString: ({ inputs: inputs })=>`Exclude (${inputs.join(', ')})`
    },
    {
        id: 'Blanks',
        label: 'Blanks',
        icon: {
            name: 'unfilled-circle'
        },
        columnScope: {
            All: true
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        handler: ({ value: value, column: column, adaptableApi: adaptableApi })=>{
            if (adaptableApi.columnApi.internalApi.hasArrayDataType(column)) return value == undefined || value.length === 0;
            return (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).isInputNullOrEmpty(value);
        }
    },
    {
        id: 'NonBlanks',
        label: 'Non Blanks',
        icon: {
            name: 'filled-circle'
        },
        columnScope: {
            All: true
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        handler: ({ value: value, column: column, adaptableApi: adaptableApi })=>{
            if (adaptableApi.columnApi.internalApi.hasArrayDataType(column)) return value == undefined || value.length === 0;
            return (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).isInputNotNullOrEmpty(value);
        }
    },
    // Numeric System Filters
    {
        id: 'GreaterThan',
        label: 'Greater Than',
        icon: {
            name: 'greater-than'
        },
        columnScope: {
            DataTypes: [
                'number'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'number'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>Number(value) > Number(inputs[0]),
        toString: ({ inputs: inputs })=>`> ${inputs[0] ?? ''}`,
        shortcuts: [
            '>'
        ]
    },
    {
        id: 'LessThan',
        label: 'Less Than',
        icon: {
            name: 'less-than'
        },
        columnScope: {
            DataTypes: [
                'number'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'number'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>Number(value) < Number(inputs[0]),
        toString: ({ inputs: inputs })=>`< ${inputs[0] ?? ''}`,
        shortcuts: [
            '<'
        ]
    },
    {
        id: 'Positive',
        label: 'Positive',
        icon: {
            text: '>0'
        },
        columnScope: {
            DataTypes: [
                'number'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        handler: ({ value: value })=>Number(value) > 0
    },
    {
        id: 'Negative',
        label: 'Negative',
        icon: {
            text: '<0'
        },
        columnScope: {
            DataTypes: [
                'number'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        handler: ({ value: value })=>Number(value) < 0
    },
    {
        id: 'Zero',
        label: 'Zero',
        icon: {
            text: '=0'
        },
        columnScope: {
            DataTypes: [
                'number'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        handler: ({ value: value })=>{
            if (typeof value === 'string' && !(0, $9OAZF.default).IsNumeric(value)) return false;
            if ((0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).objectNotExists(value)) return false;
            return Number(value) === 0;
        }
    },
    {
        id: 'Equals',
        label: 'Equals',
        icon: {
            name: 'equals'
        },
        columnScope: {
            DataTypes: [
                'number'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'number'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>{
            const input = inputs[0];
            if (typeof value === 'string' && !(0, $9OAZF.default).IsNumeric(value) || typeof input === 'string' && !(0, $9OAZF.default).IsNumeric(input)) return false;
            return Number(value) === Number(inputs[0]);
        },
        toString: ({ inputs: inputs })=>`= ${inputs[0] ?? ''}`,
        shortcuts: [
            '='
        ]
    },
    {
        id: 'NotEquals',
        label: 'Not Equals',
        icon: {
            name: 'not-equal'
        },
        columnScope: {
            DataTypes: [
                'number'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'number'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>{
            const input = inputs[0];
            if (typeof value === 'string' && !(0, $9OAZF.default).IsNumeric(value) || typeof input === 'string' && !(0, $9OAZF.default).IsNumeric(input)) return false;
            return Number(value) !== Number(inputs[0]);
        },
        toString: ({ inputs: inputs })=>`!= ${inputs[0] ?? ''}`,
        shortcuts: [
            '!='
        ]
    },
    {
        id: 'Between',
        label: 'Between',
        icon: {
            text: 'BE'
        },
        columnScope: {
            DataTypes: [
                'number'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'number'
            },
            {
                type: 'number'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>Number(value) >= Number(inputs[0]) && Number(value) <= Number(inputs[1]),
        toString: ({ inputs: inputs })=>`Between ${inputs[0] ?? ''}:${inputs[1]}`,
        shortcuts: [
            ':'
        ]
    },
    {
        id: 'NotBetween',
        label: 'Not Between',
        icon: {
            text: '!BE'
        },
        columnScope: {
            DataTypes: [
                'number'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'number'
            },
            {
                type: 'number'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>Number(value) < Number(inputs[0]) || Number(value) > Number(inputs[1]),
        toString: ({ inputs: inputs })=>`Not Between ${inputs[0] ?? ''}:${inputs[1]}`,
        shortcuts: [
            '!:'
        ]
    },
    // String System Filters
    {
        id: 'Is',
        label: 'Equals',
        icon: {
            name: 'equals'
        },
        columnScope: {
            DataTypes: [
                'text'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'text'
            }
        ],
        handler: ({ value: value, inputs: inputs, adaptableApi: adaptableApi, column: column })=>{
            if (!value) return false;
            const ignoreCase = !adaptableApi.predicateApi.internalApi.shouldUseCaseSensitivePredicates(column);
            const v = ignoreCase ? String(value).toLocaleLowerCase() : String(value);
            const i = ignoreCase ? String(inputs[0]).toLocaleLowerCase() : String(inputs[0]);
            return v == i;
        },
        toString: ({ inputs: inputs })=>`= ${inputs[0] ?? ''}`,
        shortcuts: [
            '='
        ]
    },
    {
        id: 'IsNot',
        label: 'Not Equals',
        icon: {
            name: 'not-equal'
        },
        columnScope: {
            DataTypes: [
                'text'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'text'
            }
        ],
        handler: ({ value: value, inputs: inputs, adaptableApi: adaptableApi, column: column })=>{
            if (!value) return true;
            const ignoreCase = !adaptableApi.predicateApi.internalApi.shouldUseCaseSensitivePredicates(column);
            const v = ignoreCase ? String(value).toLocaleLowerCase() : String(value);
            const i = ignoreCase ? String(inputs[0]).toLocaleLowerCase() : String(inputs[0]);
            return v != i;
        },
        toString: ({ inputs: inputs })=>`!= ${inputs[0] ?? ''}`,
        shortcuts: [
            '!='
        ]
    },
    {
        id: 'Contains',
        label: 'Contains',
        icon: {
            name: 'contains'
        },
        columnScope: {
            DataTypes: [
                'text'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'text'
            }
        ],
        handler: ({ value: value, inputs: inputs, adaptableApi: adaptableApi, column: column })=>{
            if (!value) return false;
            const ignoreCase = !adaptableApi.predicateApi.internalApi.shouldUseCaseSensitivePredicates(column);
            const v = ignoreCase ? String(value).toLocaleLowerCase() : String(value);
            const i = ignoreCase ? String(inputs[0]).toLocaleLowerCase() : String(inputs[0]);
            return v.indexOf(i) !== -1;
        },
        toString: ({ inputs: inputs })=>`Contains ${inputs[0] ?? ''}`
    },
    {
        id: 'NotContains',
        label: 'Not Contains',
        icon: {
            name: 'not-contains'
        },
        columnScope: {
            DataTypes: [
                'text'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'text'
            }
        ],
        handler: ({ value: value, inputs: inputs, adaptableApi: adaptableApi, column: column })=>{
            if (!value) return true;
            const ignoreCase = !adaptableApi.predicateApi.internalApi.shouldUseCaseSensitivePredicates(column);
            const v = ignoreCase ? String(value).toLocaleLowerCase() : String(value);
            const i = ignoreCase ? String(inputs[0]).toLocaleLowerCase() : String(inputs[0]);
            return v.indexOf(i) === -1;
        },
        toString: ({ inputs: inputs })=>`Not Contains ${inputs[0] ?? ''}`
    },
    {
        id: 'StartsWith',
        label: 'Starts With',
        icon: {
            name: 'starts-with'
        },
        columnScope: {
            DataTypes: [
                'text'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'text'
            }
        ],
        handler: ({ value: value, inputs: inputs, adaptableApi: adaptableApi, column: column })=>{
            if (!value) return false;
            const ignoreCase = !adaptableApi.predicateApi.internalApi.shouldUseCaseSensitivePredicates(column);
            const v = ignoreCase ? String(value).toLocaleLowerCase() : String(value);
            const i = ignoreCase ? String(inputs[0]).toLocaleLowerCase() : String(inputs[0]);
            return v.startsWith(i);
        },
        toString: ({ inputs: inputs })=>`Starts With ${inputs[0] ?? ''}`
    },
    {
        id: 'EndsWith',
        label: 'Ends With',
        icon: {
            name: 'ends-with'
        },
        columnScope: {
            DataTypes: [
                'text'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'text'
            }
        ],
        handler: ({ value: value, inputs: inputs, adaptableApi: adaptableApi, column: column })=>{
            if (!value) return false;
            const ignoreCase = !adaptableApi.predicateApi.internalApi.shouldUseCaseSensitivePredicates(column);
            const v = ignoreCase ? String(value).toLocaleLowerCase() : String(value);
            const i = ignoreCase ? String(inputs[0]).toLocaleLowerCase() : String(inputs[0]);
            return v.endsWith(i);
        },
        toString: ({ inputs: inputs })=>`Ends With ${inputs[0] ?? ''}`
    },
    {
        id: 'Regex',
        label: 'Regex',
        icon: {
            name: 'regex'
        },
        columnScope: {
            DataTypes: [
                'text'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn',
            'badgeStyle'
        ],
        inputs: [
            {
                type: 'text'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>new RegExp(inputs[0]).test(value),
        toString: ({ inputs: inputs })=>`Regex ${inputs[0] ?? ''}`
    },
    // Date System Filters
    {
        id: 'Today',
        label: 'Today',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value })=>(0, $f574f3f9c5879b15$export$629b0a497aa65267)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value))
    },
    {
        id: 'Yesterday',
        label: 'Yesterday',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value })=>(0, $01ed96ff4a2923d1$export$221990270ebfe867)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value))
    },
    {
        id: 'Tomorrow',
        label: 'Tomorrow',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value })=>(0, $85ced2fb3637e354$export$d6365ba92f0647f1)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value))
    },
    {
        id: 'ThisWeek',
        label: 'This Week',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value })=>(0, $def5a9154a6fce3c$export$cfe4b66a69cdd8a)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value))
    },
    {
        id: 'ThisMonth',
        label: 'This Month',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value })=>(0, $a513a065f29b721f$export$173f1e1d92847276)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value))
    },
    {
        id: 'ThisQuarter',
        label: 'This Quarter',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value })=>(0, $7b97fc1be12623a5$export$3d88fd18ab599ccc)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value))
    },
    {
        id: 'ThisYear',
        label: 'This Year',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value })=>(0, $0a1172148c7ecca3$export$a28c94941893a5ac)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value))
    },
    {
        id: 'InPast',
        label: 'In Past',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value })=>(0, $957ff381b38ac7b6$export$fc5014aa3db48558)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value))
    },
    {
        id: 'InFuture',
        label: 'In Future',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value })=>(0, $a96d25a4d70c8926$export$2baac2df6018cd7)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value))
    },
    {
        id: 'After',
        label: 'After',
        icon: {
            name: 'greater-than'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        inputs: [
            {
                type: 'date'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>(0, $7c47abeb099a42c0$export$e4de839670987035)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value), (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(inputs[0])),
        toString: ({ inputs: inputs })=>`> ${inputs[0] ?? ''}`
    },
    {
        id: 'Before',
        label: 'Before',
        icon: {
            name: 'less-than'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        inputs: [
            {
                type: 'date'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>(0, $d2aab93838002ade$export$5c007e10c6929c95)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value), (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(inputs[0])),
        toString: ({ inputs: inputs })=>`< ${inputs[0] ?? ''}`
    },
    {
        id: 'On',
        label: 'Equals',
        icon: {
            name: 'equals'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        inputs: [
            {
                type: 'date'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>(0, $27a7db21eafd685b$export$ea39ec197993aef0)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value), (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(inputs[0])),
        toString: ({ inputs: inputs })=>`= ${inputs[0] ?? ''}`
    },
    {
        id: 'NotOn',
        label: 'NotEquals',
        icon: {
            name: 'not-equal'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        inputs: [
            {
                type: 'date'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>!(0, $27a7db21eafd685b$export$ea39ec197993aef0)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value), (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(inputs[0])),
        toString: ({ inputs: inputs })=>`!= ${inputs[0] ?? ''}`
    },
    {
        id: 'NextWorkDay',
        label: 'Next Work Day',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value, adaptableApi: adaptableApi })=>(0, $27a7db21eafd685b$export$ea39ec197993aef0)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value), adaptableApi.calendarApi.getNextWorkingDay())
    },
    {
        id: 'LastWorkDay',
        label: 'Last Work Day',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value, adaptableApi: adaptableApi })=>(0, $27a7db21eafd685b$export$ea39ec197993aef0)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value), adaptableApi.calendarApi.getPreviousWorkingDay())
    },
    {
        id: 'WorkDay',
        label: 'Working Day',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value, adaptableApi: adaptableApi })=>adaptableApi.calendarApi.isWorkingDay(value)
    },
    {
        id: 'Holiday',
        label: 'Holiday',
        icon: {
            name: 'calendar'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value, adaptableApi: adaptableApi })=>adaptableApi.calendarApi.isHoliday(value)
    },
    {
        id: 'InRange',
        label: 'Range',
        icon: {
            name: 'date-range'
        },
        columnScope: {
            DataTypes: [
                'date'
            ]
        },
        moduleScope: [
            'columnFilter'
        ],
        inputs: [
            {
                type: 'date'
            },
            {
                type: 'date'
            }
        ],
        handler: ({ value: value, inputs: inputs })=>new Date(value) >= new Date(inputs[0]) && new Date(value) <= new Date(inputs[1])
    },
    // Boolean System Filters
    {
        id: 'True',
        label: 'True',
        icon: {
            text: 'T'
        },
        columnScope: {
            DataTypes: [
                'boolean'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value })=>Boolean(value) === true
    },
    {
        id: 'False',
        label: 'False',
        icon: {
            text: 'F'
        },
        columnScope: {
            DataTypes: [
                'boolean'
            ]
        },
        moduleScope: [
            'columnFilter',
            'alert',
            'flashingcell',
            'formatColumn'
        ],
        handler: ({ value: value })=>Boolean(value) === false
    },
    {
        id: 'BooleanToggle',
        label: 'BooleanToggle',
        icon: {
            name: 'boolean-list'
        },
        columnScope: {
            DataTypes: [
                'boolean'
            ]
        },
        moduleScope: [
            'columnFilter'
        ],
        inputs: [
            {
                type: 'boolean'
            }
        ],
        // working with string aliases instead of booleans because the ColumnFilterAPI cannot handle falsy filter values (it ignores them)
        handler: ({ value: value, inputs: inputs })=>{
            if (inputs[0] == 'all') // if it's indeterminate, all values (true&false) are matched
            return true;
            const booleanInputValue = inputs[0] === 'checked' ? true : false;
            return Boolean(value) === Boolean(booleanInputValue);
        }
    },
    // Other System Filters
    {
        id: 'AnyChange',
        label: 'Any Change',
        columnScope: {
            All: true
        },
        moduleScope: [
            'alert',
            'flashingcell'
        ],
        handler: ({ value: value, oldValue: oldValue })=>value !== oldValue
    },
    {
        id: 'PercentChange',
        label: 'Percent Change',
        columnScope: {
            DataTypes: [
                'number'
            ]
        },
        moduleScope: [
            'alert',
            'flashingcell'
        ],
        inputs: [
            {
                type: 'number'
            }
        ],
        handler: ({ value: value, oldValue: oldValue, inputs: inputs })=>{
            const change = Math.abs(Number(value) - Number(oldValue));
            const base = Math.min(Number(value), Number(oldValue));
            const threshold = Number(inputs[0]);
            return change / base * 100 > threshold;
        }
    }
];
const $ee11103a2ae7ed45$export$cd3969b0c9618f5c = $ee11103a2ae7ed45$export$93bfa1f66bce6e38.filter((p)=>p.moduleScope.includes('columnFilter')).map((p)=>p.id);
const $ee11103a2ae7ed45$export$b6f9455a69b5d7ef = $ee11103a2ae7ed45$export$93bfa1f66bce6e38.filter((p)=>p.moduleScope.includes('alert')).map((p)=>p.id);
const $ee11103a2ae7ed45$export$b75e99777b7e1c05 = $ee11103a2ae7ed45$export$93bfa1f66bce6e38.filter((p)=>p.moduleScope.includes('formatColumn')).map((p)=>p.id);
const $ee11103a2ae7ed45$export$806b23bc2d17144 = $ee11103a2ae7ed45$export$93bfa1f66bce6e38.filter((p)=>p.moduleScope.includes('flashingcell')).map((p)=>p.id);
const $ee11103a2ae7ed45$export$1bb72837b2449eef = $ee11103a2ae7ed45$export$93bfa1f66bce6e38.filter((p)=>p.moduleScope.includes('badgeStyle')).map((p)=>p.id);


const $42e863194fcb493f$export$40024cb74c2bb550 = 'Alert';
const $42e863194fcb493f$export$f97c8e368b37bea9 = 'Alert';
const $42e863194fcb493f$export$bc824d5002237871 = 'BulkUpdate';
const $42e863194fcb493f$export$ecc9b5cef2a93a9e = 'Bulk Update';
const $42e863194fcb493f$export$6619e71706e8514a = 'CalculatedColumn';
const $42e863194fcb493f$export$b25bd921e0e8a1d8 = 'Calculated Column';
const $42e863194fcb493f$export$bbf6ee8f129590d = 'CellSummary';
const $42e863194fcb493f$export$a00f65970079ad19 = 'Cell Summary';
const $42e863194fcb493f$export$a3fc1172140ca1e4 = 'Charting';
const $42e863194fcb493f$export$5d318d257a911a98 = 'Charts';
const $42e863194fcb493f$export$edfe19743c8e0917 = 'ColumnFilter';
const $42e863194fcb493f$export$482638e9e23a2018 = 'Column Filter';
const $42e863194fcb493f$export$59d09157d833a722 = 'ColumnInfo';
const $42e863194fcb493f$export$9b1f81b08128de98 = 'Column Info';
const $42e863194fcb493f$export$8d2ece562190bba1 = 'Comment';
const $42e863194fcb493f$export$397530e166563a3b = 'Comment';
const $42e863194fcb493f$export$efdce168daed1549 = 'CustomSort';
const $42e863194fcb493f$export$100c6fbbb6898dd8 = 'Custom Sort';
const $42e863194fcb493f$export$b74b667f10548947 = 'Dashboard';
const $42e863194fcb493f$export$9db043cbf8b89a1 = 'Dashboard';
const $42e863194fcb493f$export$376343cd8119f6bf = 'DataChangeHistory';
const $42e863194fcb493f$export$d473711913a228c6 = 'Data Changes';
const $42e863194fcb493f$export$65414e618c4e5904 = 'DataImport';
const $42e863194fcb493f$export$80fb306a63e8f7ae = 'Data Import';
const $42e863194fcb493f$export$b0d2488aa9d7ee1f = 'DataSet';
const $42e863194fcb493f$export$c95954131c91bff1 = 'Data Set';
const $42e863194fcb493f$export$2bc329d2b6ae03ac = 'Export';
const $42e863194fcb493f$export$c4352660356f52c7 = 'Export';
const $42e863194fcb493f$export$2cb53cfc1e4dddff = 'Fdc3';
const $42e863194fcb493f$export$3a62051e066152dc = 'FDC3';
const $42e863194fcb493f$export$fc2170ec34a40864 = 'FlashingCell';
const $42e863194fcb493f$export$1a465913ec780572 = 'Flashing Cell';
const $42e863194fcb493f$export$7b96a9104aea727f = 'FormatColumn';
const $42e863194fcb493f$export$9b82031e9014074c = 'Format Column';
const $42e863194fcb493f$export$7a2c7140815c0686 = 'FreeTextColumn';
const $42e863194fcb493f$export$45a38c01050861ce = 'Free Text Column';
const $42e863194fcb493f$export$4908330cb20abb96 = 'GridFilter';
const $42e863194fcb493f$export$e3b58083525a6d40 = 'Grid Filter';
const $42e863194fcb493f$export$1ec41f9c955a8b42 = 'GridInfo';
const $42e863194fcb493f$export$334ea6dd049bd035 = 'Grid Info';
const $42e863194fcb493f$export$d7882f1fbc82745 = 'IPushPull';
const $42e863194fcb493f$export$7ad4202aa4f871ad = 'IPushPull';
const $42e863194fcb493f$export$802bb096eb63f491 = 'Layout';
const $42e863194fcb493f$export$ffe377bba9205e92 = 'Layout';
const $42e863194fcb493f$export$97c45942f844607e = 'NamedQuery';
const $42e863194fcb493f$export$4857fd59919baf59 = 'Named Query';
const $42e863194fcb493f$export$7e30a30684cd1b52 = 'Note';
const $42e863194fcb493f$export$43aefa97b142d9fb = 'Note';
const $42e863194fcb493f$export$fad51b7f4f4d5858 = 'OpenFin';
const $42e863194fcb493f$export$d69815e22a22b523 = 'OpenFin';
const $42e863194fcb493f$export$1d33a3a77a9299ff = 'PlusMinus';
const $42e863194fcb493f$export$f518c662fee2c31a = 'Plus Minus';
const $42e863194fcb493f$export$cf7621e489e71e3c = 'QuickSearch';
const $42e863194fcb493f$export$e226d3e36d512400 = 'Quick Search';
const $42e863194fcb493f$export$5dd6e67bf681ede8 = 'Schedule';
const $42e863194fcb493f$export$42a87414a14312dc = 'Schedule';
const $42e863194fcb493f$export$79267ef32fe02008 = 'SettingsPanel';
const $42e863194fcb493f$export$f9512fbf4310c0fb = 'Settings Panel';
const $42e863194fcb493f$export$ef61c24f038f357f = 'Shortcut';
const $42e863194fcb493f$export$60ad68ab2ff295ef = 'Shortcut';
const $42e863194fcb493f$export$3fb170c57e2678e6 = 'SmartEdit';
const $42e863194fcb493f$export$98c9ce2425ae8ca1 = 'Smart Edit';
const $42e863194fcb493f$export$273162015487179c = 'StatusBar';
const $42e863194fcb493f$export$68c6891398a23f02 = 'Status Bar';
const $42e863194fcb493f$export$7d380408a8ffe7db = 'StyledColumn';
const $42e863194fcb493f$export$c8dc099205b274b7 = 'Styled Column';
const $42e863194fcb493f$export$826ed58486b36acd = 'StateManagement';
const $42e863194fcb493f$export$d3066b78c0fe60e = 'Manage State';
const $42e863194fcb493f$export$49045387ac7420d5 = 'SystemStatus';
const $42e863194fcb493f$export$7eabab1cd8af1687 = 'System Status';
const $42e863194fcb493f$export$ecef34e06f3704d9 = 'TeamSharing';
const $42e863194fcb493f$export$9a5ef319e3555d1f = 'Team Sharing';
const $42e863194fcb493f$export$ebf1703e41256059 = 'Theme';
const $42e863194fcb493f$export$7f02dc9df35b5d62 = 'Theme';
const $42e863194fcb493f$export$6444167a07daa102 = 'ToolPanel';
const $42e863194fcb493f$export$2caa0aaffe7bbab6 = 'Tool Panel';
const $42e863194fcb493f$export$d4f7ec57c355ff81 = {
    [$42e863194fcb493f$export$40024cb74c2bb550]: $42e863194fcb493f$export$f97c8e368b37bea9,
    [$42e863194fcb493f$export$bc824d5002237871]: $42e863194fcb493f$export$ecc9b5cef2a93a9e,
    [$42e863194fcb493f$export$6619e71706e8514a]: $42e863194fcb493f$export$b25bd921e0e8a1d8,
    [$42e863194fcb493f$export$bbf6ee8f129590d]: $42e863194fcb493f$export$a00f65970079ad19,
    [$42e863194fcb493f$export$a3fc1172140ca1e4]: $42e863194fcb493f$export$5d318d257a911a98,
    [$42e863194fcb493f$export$edfe19743c8e0917]: $42e863194fcb493f$export$482638e9e23a2018,
    [$42e863194fcb493f$export$59d09157d833a722]: $42e863194fcb493f$export$9b1f81b08128de98,
    [$42e863194fcb493f$export$8d2ece562190bba1]: $42e863194fcb493f$export$397530e166563a3b,
    [$42e863194fcb493f$export$efdce168daed1549]: $42e863194fcb493f$export$100c6fbbb6898dd8,
    [$42e863194fcb493f$export$b74b667f10548947]: $42e863194fcb493f$export$9db043cbf8b89a1,
    [$42e863194fcb493f$export$376343cd8119f6bf]: $42e863194fcb493f$export$d473711913a228c6,
    [$42e863194fcb493f$export$65414e618c4e5904]: $42e863194fcb493f$export$80fb306a63e8f7ae,
    [$42e863194fcb493f$export$b0d2488aa9d7ee1f]: $42e863194fcb493f$export$c95954131c91bff1,
    [$42e863194fcb493f$export$2bc329d2b6ae03ac]: $42e863194fcb493f$export$c4352660356f52c7,
    [$42e863194fcb493f$export$2cb53cfc1e4dddff]: $42e863194fcb493f$export$3a62051e066152dc,
    [$42e863194fcb493f$export$fc2170ec34a40864]: $42e863194fcb493f$export$1a465913ec780572,
    [$42e863194fcb493f$export$7b96a9104aea727f]: $42e863194fcb493f$export$9b82031e9014074c,
    [$42e863194fcb493f$export$7a2c7140815c0686]: $42e863194fcb493f$export$45a38c01050861ce,
    [$42e863194fcb493f$export$4908330cb20abb96]: $42e863194fcb493f$export$e3b58083525a6d40,
    [$42e863194fcb493f$export$1ec41f9c955a8b42]: $42e863194fcb493f$export$334ea6dd049bd035,
    [$42e863194fcb493f$export$d7882f1fbc82745]: $42e863194fcb493f$export$7ad4202aa4f871ad,
    [$42e863194fcb493f$export$802bb096eb63f491]: $42e863194fcb493f$export$ffe377bba9205e92,
    [$42e863194fcb493f$export$97c45942f844607e]: $42e863194fcb493f$export$4857fd59919baf59,
    [$42e863194fcb493f$export$7e30a30684cd1b52]: $42e863194fcb493f$export$43aefa97b142d9fb,
    [$42e863194fcb493f$export$fad51b7f4f4d5858]: $42e863194fcb493f$export$d69815e22a22b523,
    [$42e863194fcb493f$export$1d33a3a77a9299ff]: $42e863194fcb493f$export$f518c662fee2c31a,
    [$42e863194fcb493f$export$cf7621e489e71e3c]: $42e863194fcb493f$export$e226d3e36d512400,
    [$42e863194fcb493f$export$5dd6e67bf681ede8]: $42e863194fcb493f$export$42a87414a14312dc,
    [$42e863194fcb493f$export$ef61c24f038f357f]: $42e863194fcb493f$export$60ad68ab2ff295ef,
    [$42e863194fcb493f$export$3fb170c57e2678e6]: $42e863194fcb493f$export$98c9ce2425ae8ca1,
    [$42e863194fcb493f$export$7d380408a8ffe7db]: $42e863194fcb493f$export$c8dc099205b274b7,
    [$42e863194fcb493f$export$826ed58486b36acd]: $42e863194fcb493f$export$d3066b78c0fe60e,
    [$42e863194fcb493f$export$49045387ac7420d5]: $42e863194fcb493f$export$7eabab1cd8af1687,
    [$42e863194fcb493f$export$ecef34e06f3704d9]: $42e863194fcb493f$export$9a5ef319e3555d1f,
    [$42e863194fcb493f$export$ebf1703e41256059]: $42e863194fcb493f$export$7f02dc9df35b5d62,
    [$42e863194fcb493f$export$6444167a07daa102]: $42e863194fcb493f$export$2caa0aaffe7bbab6,
    [$42e863194fcb493f$export$79267ef32fe02008]: $42e863194fcb493f$export$f9512fbf4310c0fb,
    [$42e863194fcb493f$export$273162015487179c]: $42e863194fcb493f$export$68c6891398a23f02
};


/**
 * This method is like `cloneDeep` except that it accepts customizer which
 * is invoked to produce the cloned value. If customizer returns undefined,
 * cloning is handled by the method instead.
 * Drop-in replacement for lodash/cloneDeepWith.
 */ function $bb4f50f99c2d0774$var$baseCloneDeep(value, customizer, seen) {
    // Invoke customizer first
    const customResult = customizer(value);
    if (customResult !== undefined) return customResult;
    // Primitives
    if (value === null || typeof value !== 'object') return value;
    // Circular reference detection
    if (seen.has(value)) return seen.get(value);
    // Date
    if (value instanceof Date) return new Date(value.getTime());
    // RegExp
    if (value instanceof RegExp) return new RegExp(value.source, value.flags);
    // Map
    if (value instanceof Map) {
        const cloned = new Map();
        seen.set(value, cloned);
        value.forEach((v, k)=>{
            cloned.set($bb4f50f99c2d0774$var$baseCloneDeep(k, customizer, seen), $bb4f50f99c2d0774$var$baseCloneDeep(v, customizer, seen));
        });
        return cloned;
    }
    // Set
    if (value instanceof Set) {
        const cloned = new Set();
        seen.set(value, cloned);
        value.forEach((v)=>{
            cloned.add($bb4f50f99c2d0774$var$baseCloneDeep(v, customizer, seen));
        });
        return cloned;
    }
    // Arrays
    if (Array.isArray(value)) {
        const cloned = [];
        seen.set(value, cloned);
        for(let i = 0; i < value.length; i++)cloned[i] = $bb4f50f99c2d0774$var$baseCloneDeep(value[i], customizer, seen);
        return cloned;
    }
    // Plain objects and others
    const cloned = Object.create(Object.getPrototypeOf(value));
    seen.set(value, cloned);
    const keys = Object.keys(value);
    for (const key of keys)cloned[key] = $bb4f50f99c2d0774$var$baseCloneDeep(value[key], customizer, seen);
    return cloned;
}
function $bb4f50f99c2d0774$export$2e2bcd8739ae039(value, customizer) {
    return $bb4f50f99c2d0774$var$baseCloneDeep(value, customizer, new Map());
}


/**
 * Checks if value is a plain object, that is, an object created by the
 * Object constructor or one with a [[Prototype]] of null.
 * Drop-in replacement for lodash/isPlainObject.
 */ function $9dc80662ca8a355b$export$2e2bcd8739ae039(value) {
    if (value === null || value === undefined || typeof value !== 'object') return false;
    const proto = Object.getPrototypeOf(value);
    // Object.create(null)
    if (proto === null) return true;
    // Normal plain objects
    return proto === Object.prototype;
}


const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


const $d7790b1d1a829cfc$export$10a020066a0f444a = ()=>(0, $3fa3ae484854b431$export$2e2bcd8739ae039)();


var $c0db9ead212244f8$exports = {};
$c0db9ead212244f8$exports = JSON.parse("{\"name\":\"@adaptabletools/adaptable\",\"version\":\"22.0.3\",\"description\":\"Powerful data-agnostic HTML5 AG Grid extension which provides advanced, cutting-edge functionality to meet all DataGrid requirements\",\"keywords\":[\"web-components\",\"datagrid\",\"fintech\",\"fdc3\",\"interop.io\",\"grid\",\"data\",\"table\",\"data-table\",\"openfin\",\"ag-grid\",\"infinite-table\",\"adaptable\",\"blotter\",\"data-visualisation\",\"react\",\"angular\",\"react-component\",\"angular-component\"],\"homepage\":\"http://www.adaptabletools.com/\",\"license\":\"contact sales@adaptabletools.com for details\",\"author\":{\"name\":\"Jonny Wolfson\",\"email\":\"jonny.wolfson@adaptabletools.com\"},\"maintainers\":[{\"name\":\"JonnyAdaptableTools\",\"email\":\"jonny.wolfson@adaptabletools.com\"}],\"typings\":\"index.d.ts\",\"dependencies\":{\"@adaptabletools/react-beautiful-dnd\":\"14.0.8\",\"@finos/fdc3\":\"2.1.0\",\"@infinite-table/infinite-react\":\"7.5.1\",\"clsx\":\"^2.1.1\",\"date-fns\":\"^4.1.0\",\"normalize.css\":\"^8.0.1\",\"re-resizable\":\"6.10.3\",\"react\":\"^18.0.0 || ^19.0.0\",\"react-day-picker\":\"9.5.1\",\"react-dom\":\"^18.0.0 || ^19.0.0\",\"react-redux\":\"9.2.0\",\"react-remove-scroll\":\"2.6.3\",\"react-select\":\"5.10.1\",\"react-toastify\":\"9.1.3\",\"redux\":\"^5.0.1\",\"rxjs\":\"^7.4.0\",\"tailwind-merge\":\"^3.3.1\",\"tinycolor2\":\"^1.4.2\",\"tslib\":\"^2.8.1\",\"udsv\":\"0.6.0\",\"uuid\":\"9.0.1\"},\"peerDependencies\":{\"ag-grid-enterprise\":\">=35.0.0\"},\"publishTimestamp\":0,\"type\":\"module\",\"module\":\"index.js\"}");


const $792d5f2a0e72dfac$var$GET_CURRENT_VERSION = ()=>{
    const globalObject = typeof globalThis !== 'undefined' ? globalThis : window;
    return (typeof globalObject['GET_CURRENT_ADAPTABLE_VERSION'] === 'function' ? globalObject['GET_CURRENT_ADAPTABLE_VERSION']() : (0, (/*@__PURE__*/$parcel$interopDefault($c0db9ead212244f8$exports))).version) ?? (0, (/*@__PURE__*/$parcel$interopDefault($c0db9ead212244f8$exports))).version;
};
function $792d5f2a0e72dfac$export$94a55da6558d0ee0(initialState) {
    const customizer = (value)=>{
        // so whenever we clone a plain object,
        // we add a Uuid property
        // jw added 9/8/20: unless there is on there already
        if ((0, $9dc80662ca8a355b$export$2e2bcd8739ae039)(value) && value != initialState) {
            if (value.Uuid == null || value.Uuid == undefined) value.Uuid = (0, $d7790b1d1a829cfc$export$10a020066a0f444a)();
            if (value.AdaptableVersion == null) value.AdaptableVersion = $792d5f2a0e72dfac$var$GET_CURRENT_VERSION();
        }
    };
    return (0, $bb4f50f99c2d0774$export$2e2bcd8739ae039)(initialState, customizer);
}
function $792d5f2a0e72dfac$export$1cfd109f7705a424(adaptableObject, moduleAccessLevel) {
    // we always return the Module Access Level unless the following condition is met:
    // the object prpoerty has been set and set to true and the Module entitlement is full
    if (moduleAccessLevel == 'Full' && adaptableObject && adaptableObject.IsReadOnly && adaptableObject.IsReadOnly == true) return 'ReadOnly';
    return moduleAccessLevel;
}
function $792d5f2a0e72dfac$export$db112cd1b47e86d5(adaptableObject) {
    if (!adaptableObject.Uuid) adaptableObject.Uuid = (0, $d7790b1d1a829cfc$export$10a020066a0f444a)();
    adaptableObject.Source = 'User';
    adaptableObject.AdaptableVersion = $792d5f2a0e72dfac$var$GET_CURRENT_VERSION();
    return adaptableObject;
}
function $792d5f2a0e72dfac$export$c6d9bd35e7cf8d09(target) {
    if (!target) return target;
    if (Array.isArray(target)) {
        target.forEach($792d5f2a0e72dfac$export$c6d9bd35e7cf8d09);
        return target;
    }
    if (typeof target !== 'object') return target;
    delete target.Source;
    delete target.Uuid;
    delete target.AdaptableVersion;
    for(const key in target)$792d5f2a0e72dfac$export$c6d9bd35e7cf8d09(target[key]);
    return target;
}
function $792d5f2a0e72dfac$export$4816991dccd6dd7c(target) {
    if (!target) return target;
    if (Array.isArray(target)) {
        target.forEach($792d5f2a0e72dfac$export$4816991dccd6dd7c);
        return target;
    }
    if (typeof target !== 'object') return target;
    delete target.Source;
    delete target.Uuid;
    delete target.AdaptableVersion;
    return target;
}
function $792d5f2a0e72dfac$export$912f7ac962dd695c(adaptableObject) {
    const clonedObject = structuredClone(adaptableObject);
    const sanitiseObject = (object)=>{
        for(const key in object){
            if (key === 'Source' || key === 'Uuid' || key === 'AdaptableVersion') delete object[key];
            else if (Array.isArray(object[key])) object[key].forEach((item)=>sanitiseObject(item));
            else if (typeof object[key] === 'object') sanitiseObject(object[key]);
        }
    };
    sanitiseObject(clonedObject);
    return clonedObject;
}
function $792d5f2a0e72dfac$export$89aa5e6577339899(object) {
    return object != undefined && typeof object['Uuid'] === 'string';
}
const $792d5f2a0e72dfac$export$497fb46ca5a98a2f = {
    addUuidsToInitialState: $792d5f2a0e72dfac$export$94a55da6558d0ee0,
    getAccessLevelForObject: $792d5f2a0e72dfac$export$1cfd109f7705a424,
    addAdaptableObjectPrimitives: $792d5f2a0e72dfac$export$db112cd1b47e86d5,
    removeAdaptableObjectPrimitives: $792d5f2a0e72dfac$export$912f7ac962dd695c,
    removeAdaptableObjectPrimitivesInline: $792d5f2a0e72dfac$export$4816991dccd6dd7c,
    removeAdaptableObjectPrimitivesInlineDeep: $792d5f2a0e72dfac$export$c6d9bd35e7cf8d09,
    isAdaptableObject: $792d5f2a0e72dfac$export$89aa5e6577339899
};
var $792d5f2a0e72dfac$export$2e2bcd8739ae039 = $792d5f2a0e72dfac$export$497fb46ca5a98a2f;


const $b7240075c75a7844$var$DefaultAdaptableOptions = {
    adaptableId: $58846ea7f4156db7$export$4241be43e8a445e5,
    adaptableStateKey: undefined,
    primaryKey: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
    autogeneratePrimaryKey: false,
    userName: 'anonymous',
    initialState: undefined,
    adaptableContext: {},
    actionColumnOptions: {
        actionColumns: undefined
    },
    alertOptions: {
        alertForms: undefined,
        maxAlertsInStore: 20,
        cellHighlightDuration: 2000,
        rowHighlightDuration: 4000,
        statusbarHighlightDuration: 2000,
        dataChangeDetectionPolicy: 'rawValue',
        commandHandlers: undefined,
        alertMessageText: undefined,
        showMissingPrimaryKeyAlert: false
    },
    calendarOptions: {
        holidays: undefined
    },
    cellSummaryOptions: {
        customCellSummaryOperations: undefined,
        numericDisplayFormat: {
            FractionDigits: 2
        }
    },
    chartingOptions: {
        saveChartBehaviour: 'none',
        agGridContainerName: $58846ea7f4156db7$export$2c93b592c78f216f,
        externalChartingOptions: {}
    },
    columnOptions: {
        columnFriendlyName: undefined,
        columnTypes: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
        showMissingColumnsWarning: true,
        addColumnGroupToColumnFriendlyName: false
    },
    columnMenuOptions: {
        customColumnMenu: undefined
    },
    commentOptions: {
        showPopupCloseButton: true,
        dateFormat: (0, $58846ea7f4156db7$export$360edfea94c9af92)
    },
    containerOptions: {
        adaptableContainer: 'adaptable',
        agGridContainer: 'grid',
        modalContainer: undefined,
        systemStatusContainer: undefined,
        alertContainer: undefined
    },
    contextMenuOptions: {
        customContextMenu: undefined
    },
    customSortOptions: {
        customSortComparers: undefined
    },
    dashboardOptions: {
        canFloat: true,
        showQuickSearchInHeader: true,
        customDashboardButtons: undefined,
        customToolbars: undefined,
        buttonsLocation: 'right'
    },
    dataChangeHistoryOptions: {
        activeByDefault: false,
        showDataChange: undefined,
        changeHistoryButton: undefined,
        showLastDataChangeOnly: true
    },
    dataImportOptions: {
        fileHandlers: undefined
    },
    dataSetOptions: {
        dataSets: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
    },
    editOptions: {
        validateOnServer: undefined,
        displayServerValidationMessages: true,
        isCellEditable: undefined,
        smartEditCustomOperations: undefined,
        customEditColumnValues: undefined
    },
    entitlementOptions: {
        defaultAccessLevel: 'Full',
        moduleEntitlements: undefined
    },
    exportOptions: {
        exportDataFormat: 'rawValue',
        exportDateFormat: undefined,
        customDestinations: undefined,
        processExport: undefined,
        appendFileTimestamp: false,
        systemReportNames: (0, $58846ea7f4156db7$export$ca0f2ab5ee3c7523),
        systemReportFormats: (0, $58846ea7f4156db7$export$55741d64ab494b05),
        systemExportDestinations: (0, $58846ea7f4156db7$export$8803ddc1a816b6d0),
        reportFilename: undefined,
        csvSeparator: ',',
        skipColumnHeaders: false,
        excelSheetName: 'Sheet 1'
    },
    expressionOptions: {
        evaluateAdaptableQLExternally: undefined,
        displayColumnFriendlyNamesForExpressions: true,
        systemBooleanFunctions: undefined,
        systemScalarFunctions: undefined,
        systemObservableFunctions: undefined,
        systemAggregatedBooleanFunctions: undefined,
        systemAggregatedScalarFunctions: undefined,
        moduleExpressionFunctions: undefined,
        performExpressionValidation: true,
        maxTimeframeSize: 28800000,
        caseSensitiveExpressions: false
    },
    fdc3Options: {
        enableLogging: false,
        actionColumnDefaultConfiguration: {
            columnId: 'fdc3ActionColumn',
            headerName: 'FDC3 Actions',
            width: 200,
            resizable: true,
            movable: false,
            rowScope: {
                ExcludeDataRows: false,
                ExcludeGroupRows: true,
                ExcludeSummaryRows: true,
                ExcludeTotalRows: true
            }
        },
        uiControlsDefaultConfiguration: {
            // default config is set in FDC3 Service, to make it easier to overview
            contexts: {},
            intents: {}
        }
    },
    filterOptions: {
        filterActionOnDataChange: {
            applyFilter: 'Always',
            throttleDelay: 0
        },
        clearFiltersOnStartUp: false,
        enableFilterOnSpecialColumns: true,
        useAdaptableFiltering: true,
        showDatePicker: true,
        columnFilterOptions: {
            indicateFilteredColumns: true,
            manuallyApplyColumnFilter: false,
            defaultNumericColumnFilter: 'Equals',
            defaultTextColumnFilter: 'Contains',
            defaultDateColumnFilter: 'On',
            defaultArrayColumnFilter: 'In',
            hideQuickFilterDropdown: undefined,
            hideQuickFilterInput: undefined,
            quickFilterDebounce: 250,
            quickFilterHeight: null,
            showQuickFilter: true,
            quickFilterWildcards: {}
        },
        gridFilterOptions: {
            availableFilterEditors: [
                'ExpressionEditor',
                'QueryBuilder'
            ]
        }
    },
    flashingCellOptions: {
        defaultFlashDuration: 500,
        defaultFlashTarget: 'cell',
        defaultDownChangeStyle: {
            BackColor: (0, $5aWMQ.getHexForName)((0, $5aWMQ.RED))
        },
        defaultUpChangeStyle: {
            BackColor: (0, $5aWMQ.getHexForName)((0, $5aWMQ.GREEN))
        },
        defaultNeutralChangeStyle: {
            BackColor: (0, $5aWMQ.getHexForName)((0, $5aWMQ.GRAY))
        }
    },
    formatColumnOptions: {
        customDisplayFormatters: undefined
    },
    layoutOptions: {
        layoutViewOptions: {
            maxColumnsToDisplay: 10
        },
        layoutTagOptions: {
            autoGenerateTagsForLayouts: false,
            isObjectExtendedInLayout: undefined,
            autoCheckTagsForLayouts: false
        }
    },
    noteOptions: {
        showPopupCloseButton: true,
        dateFormat: (0, $58846ea7f4156db7$export$360edfea94c9af92)
    },
    notificationsOptions: {
        maxNotifications: 3,
        position: 'BottomRight',
        duration: 3000,
        showProgressBar: false,
        closeWhenClicked: false,
        pauseWhenHovering: false,
        isDraggable: false,
        transition: 'Slide',
        showApplicationIcon: false,
        showSystemStatusMessageNotifications: false,
        maxSystemMessagesInStore: 100
    },
    predicateOptions: {
        customPredicateDefs: [],
        systemFilterPredicates: (0, $ee11103a2ae7ed45$export$cd3969b0c9618f5c),
        systemAlertPredicates: (0, $ee11103a2ae7ed45$export$b6f9455a69b5d7ef),
        systemFormatColumnPredicates: (0, $ee11103a2ae7ed45$export$b75e99777b7e1c05),
        systemFlashingCellPredicates: (0, $ee11103a2ae7ed45$export$806b23bc2d17144),
        systemBadgeStylePredicates: (0, $ee11103a2ae7ed45$export$1bb72837b2449eef),
        caseSensitivePredicates: false,
        evaluateInPredicateUsingTime: false
    },
    quickSearchOptions: {
        clearQuickSearchOnStartUp: false,
        quickSearchPlaceholder: 'Search',
        filterGridAfterQuickSearch: false,
        isQuickSearchCaseSensitive: false,
        getCellSearchText: undefined
    },
    rowFormOptions: {
        autoHandle: true,
        disableInlineEditing: false,
        setPrimaryKeyValue: undefined,
        rowFormTitle: undefined,
        rowFormDescription: undefined,
        rowFormFieldLabel: undefined,
        rowFormButtons: undefined,
        onRowFormSubmit: undefined,
        includeColumnInRowForm: undefined
    },
    settingsPanelOptions: {
        popupType: 'modal',
        title: $42e863194fcb493f$export$f9512fbf4310c0fb,
        icon: 'ConfigurationIcon',
        navigation: {},
        alwaysShowInDashboard: false,
        alwaysShowInToolPanel: false,
        showModuleIcons: true
    },
    stateOptions: {
        debounceStateDelay: 400,
        applyState: (state)=>state,
        saveState: (state)=>state,
        loadState: undefined,
        persistState: undefined,
        clearState: undefined,
        autoMigrateState: true
    },
    teamSharingOptions: {
        enableTeamSharing: false,
        persistSharedEntities: undefined,
        loadSharedEntities: undefined,
        applySharedEntities: (sharedEntities)=>sharedEntities,
        saveSharedEntities: (sharedEntities)=>sharedEntities,
        updateInterval: 0,
        updateNotification: undefined,
        suppressOverrideConfigWarning: false,
        showUpdateNotificationOncePerUpdate: false
    },
    toolPanelOptions: {
        showToolPanelsDropdown: true,
        customButtons: undefined,
        customToolPanels: undefined
    },
    userInterfaceOptions: {
        alternativeModuleNames: undefined,
        applicationIcon: undefined,
        useCustomMacLikeScrollbars: false,
        loadingScreenOptions: {
            showLoadingScreen: true,
            loadingScreenDelay: 200,
            loadingScreenTitle: 'Initialising Grid',
            loadingScreenText: 'Retrieving your settings and setting up the grid...'
        },
        englishVariant: 'GB',
        disableDeleteConfirmation: false,
        dateInputOptions: {
            useNativeInput: false,
            dateFormat: 'yyyy-MM-dd',
            // locale is not explicitly defaulted to 'en-US' as this is already done by the react-day-picker
            showWeekNumber: false,
            showOutsideDays: true,
            datepickerButtons: [
                'close',
                'today'
            ]
        },
        colorPalette: (0, $5aWMQ.default).getDefaultColors(),
        editableCellStyle: undefined,
        readOnlyCellStyle: undefined,
        editedCellStyle: undefined,
        styleClassNames: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
        showDocumentationLinks: true,
        showAdapTableVersion: true,
        showAgGridVersion: true
    }
};
function $b7240075c75a7844$export$38d7e410c90a5f7e(adaptableOptions) {
    const adaptableOptsWithDefaults = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions, adaptableOptions);
    adaptableOptsWithDefaults.adaptableStateKey = adaptableOptsWithDefaults.adaptableStateKey ?? adaptableOptsWithDefaults.adaptableId;
    // action column options
    adaptableOptsWithDefaults.actionColumnOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.actionColumnOptions, adaptableOptions.actionColumnOptions);
    // action column options
    adaptableOptsWithDefaults.rowFormOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.rowFormOptions, adaptableOptions.rowFormOptions);
    // alert options
    adaptableOptsWithDefaults.alertOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.alertOptions, adaptableOptions.alertOptions);
    // calendar options
    adaptableOptsWithDefaults.calendarOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.calendarOptions, adaptableOptions.calendarOptions);
    // cell summary options
    adaptableOptsWithDefaults.cellSummaryOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.cellSummaryOptions, adaptableOptions.cellSummaryOptions);
    // charting options
    adaptableOptsWithDefaults.chartingOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.chartingOptions, adaptableOptions.chartingOptions);
    adaptableOptsWithDefaults.chartingOptions.externalChartingOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.chartingOptions.externalChartingOptions, adaptableOptsWithDefaults.chartingOptions.externalChartingOptions);
    // column options
    adaptableOptsWithDefaults.columnOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.columnOptions, adaptableOptions.columnOptions);
    // TEMP filter options
    adaptableOptsWithDefaults.filterOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.filterOptions, adaptableOptions.filterOptions);
    adaptableOptsWithDefaults.filterOptions.columnFilterOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.filterOptions.columnFilterOptions, adaptableOptsWithDefaults.filterOptions.columnFilterOptions);
    adaptableOptsWithDefaults.filterOptions.gridFilterOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.filterOptions.gridFilterOptions, adaptableOptsWithDefaults.filterOptions.gridFilterOptions);
    // column menu options
    adaptableOptsWithDefaults.columnMenuOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.columnMenuOptions, adaptableOptions.columnMenuOptions);
    // comment options
    adaptableOptsWithDefaults.commentOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.commentOptions, adaptableOptions.commentOptions);
    // container options
    adaptableOptsWithDefaults.containerOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.containerOptions, adaptableOptions.containerOptions);
    // context menu options
    adaptableOptsWithDefaults.contextMenuOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.contextMenuOptions, adaptableOptions.contextMenuOptions);
    // custom sort options
    adaptableOptsWithDefaults.customSortOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.customSortOptions, adaptableOptions.customSortOptions);
    // dashboard options
    adaptableOptsWithDefaults.dashboardOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.dashboardOptions, adaptableOptions.dashboardOptions);
    // data import options
    adaptableOptsWithDefaults.dataImportOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.dataImportOptions, adaptableOptions.dataImportOptions);
    // data change history options
    adaptableOptsWithDefaults.dataChangeHistoryOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.dataChangeHistoryOptions, adaptableOptions.dataChangeHistoryOptions);
    // data set options
    adaptableOptsWithDefaults.dataSetOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.dataSetOptions, adaptableOptions.dataSetOptions);
    // edit options
    adaptableOptsWithDefaults.editOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.editOptions, adaptableOptions.editOptions);
    // entitlement options
    adaptableOptsWithDefaults.entitlementOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.entitlementOptions, adaptableOptions.entitlementOptions);
    // export options
    adaptableOptsWithDefaults.exportOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.exportOptions, adaptableOptions.exportOptions);
    // expression options
    adaptableOptsWithDefaults.expressionOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.expressionOptions, adaptableOptions.expressionOptions);
    // fdc3 options
    adaptableOptsWithDefaults.fdc3Options = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.fdc3Options, adaptableOptions.fdc3Options);
    adaptableOptsWithDefaults.fdc3Options.actionColumnDefaultConfiguration = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.fdc3Options.actionColumnDefaultConfiguration, adaptableOptsWithDefaults.fdc3Options.actionColumnDefaultConfiguration);
    adaptableOptsWithDefaults.fdc3Options.uiControlsDefaultConfiguration = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.fdc3Options.uiControlsDefaultConfiguration, adaptableOptsWithDefaults.fdc3Options.uiControlsDefaultConfiguration);
    // flashing cell options
    adaptableOptsWithDefaults.flashingCellOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.flashingCellOptions, adaptableOptions.flashingCellOptions);
    // format column options
    adaptableOptsWithDefaults.formatColumnOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.formatColumnOptions, adaptableOptions.formatColumnOptions);
    // layout options
    adaptableOptsWithDefaults.layoutOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.layoutOptions, adaptableOptions.layoutOptions);
    adaptableOptsWithDefaults.layoutOptions.layoutTagOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.layoutOptions.layoutTagOptions, adaptableOptsWithDefaults.layoutOptions.layoutTagOptions);
    adaptableOptsWithDefaults.layoutOptions.layoutViewOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.layoutOptions.layoutViewOptions, adaptableOptsWithDefaults.layoutOptions.layoutViewOptions);
    // note options
    adaptableOptsWithDefaults.noteOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.noteOptions, adaptableOptions.noteOptions);
    // notification options
    adaptableOptsWithDefaults.notificationsOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.notificationsOptions, adaptableOptions.notificationsOptions);
    // predicate options
    adaptableOptsWithDefaults.predicateOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.predicateOptions, adaptableOptsWithDefaults.predicateOptions);
    // quick search options
    adaptableOptsWithDefaults.quickSearchOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.quickSearchOptions, adaptableOptions.quickSearchOptions);
    // settings panel options
    adaptableOptsWithDefaults.settingsPanelOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.settingsPanelOptions, adaptableOptions.settingsPanelOptions);
    // state optoins
    adaptableOptsWithDefaults.stateOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.stateOptions, adaptableOptions.stateOptions);
    // team sharing options
    adaptableOptsWithDefaults.teamSharingOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.teamSharingOptions, adaptableOptions.teamSharingOptions);
    // tool panel
    adaptableOptsWithDefaults.toolPanelOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.toolPanelOptions, adaptableOptions.toolPanelOptions);
    // user interface options
    adaptableOptsWithDefaults.userInterfaceOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.userInterfaceOptions, adaptableOptions.userInterfaceOptions);
    adaptableOptsWithDefaults.userInterfaceOptions.loadingScreenOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.userInterfaceOptions.loadingScreenOptions, adaptableOptsWithDefaults.userInterfaceOptions.loadingScreenOptions);
    adaptableOptsWithDefaults.userInterfaceOptions.dateInputOptions = Object.assign({}, $b7240075c75a7844$var$DefaultAdaptableOptions.userInterfaceOptions.dateInputOptions, adaptableOptsWithDefaults.userInterfaceOptions.dateInputOptions);
    const { initialState: initialState } = adaptableOptsWithDefaults;
    adaptableOptsWithDefaults.initialState = (0, $792d5f2a0e72dfac$export$94a55da6558d0ee0)(initialState);
    return adaptableOptsWithDefaults;
}
const $b7240075c75a7844$export$ae6abdb725d7cdd7 = ()=>$b7240075c75a7844$var$DefaultAdaptableOptions;



var $9AsCL = parcelRequire("9AsCL");




const $3349f69c368cd68a$var$performanceTime = (previousTime)=>{
    const now = performance.now();
    return Math.round(previousTime ? now - previousTime : now);
};
class $3349f69c368cd68a$export$ee9c80f530753f99 {
    debugger;
    infoLogger;
    successLogger;
    warnLogger;
    errorLogger;
    perfLogger;
    debugId;
    constructor(options){
        this.debugId = options.debugId;
        this.debugger = (0, $88ab1a78ec8ca4b4$export$1c9f709888824e05)(this.debugId ? `LayoutManager:${this.debugId}` : 'LayoutManager');
        this.infoLogger = this.debugger.extend(`info`);
        this.infoLogger.logFn = console.info.bind(console);
        this.successLogger = this.debugger.extend(`success`);
        this.successLogger.logFn = console.log.bind(console);
        this.warnLogger = this.debugger.extend(`warn`);
        this.warnLogger.logFn = console.warn.bind(console);
        this.errorLogger = this.debugger.extend(`error`);
        this.errorLogger.logFn = console.error.bind(console);
        this.perfLogger = this.debugger.extend(`perf`);
        this.perfLogger.logFn = console.info.bind(console);
    }
    beginPerf(sectionName) {
        this.perfLogger(`[BEGIN] - ${sectionName}`);
        const startTime = $3349f69c368cd68a$var$performanceTime();
        return {
            end: (additionalComment)=>{
                this.perfLogger(`[END]   - ${sectionName} ${additionalComment ? `(${additionalComment})` : ''} :: [delta +${$3349f69c368cd68a$var$performanceTime(startTime)}ms]`);
            }
        };
    }
    info(message, ...optionalParams) {
        if (optionalParams?.length) this.infoLogger(message, ...optionalParams);
        else this.infoLogger(message);
    }
    success(message, ...optionalParams) {
        if (optionalParams?.length) this.successLogger(message, ...optionalParams);
        else this.successLogger(message);
    }
    warn(message, ...optionalParams) {
        if (optionalParams?.length) this.warnLogger(message, ...optionalParams);
        else this.warnLogger(message);
    }
    error(message, ...optionalParams) {
        if (optionalParams?.length) this.errorLogger(message, ...optionalParams);
        else this.errorLogger(message);
    }
}


function $c45620437be4c7ed$var$x(a, b) {}
const $c45620437be4c7ed$var$xtype = [
    1,
    '2'
];
class $c45620437be4c7ed$export$6378f8209ec376df extends (0, $3349f69c368cd68a$export$ee9c80f530753f99) {
    destroyed = false;
    suspended = false;
    constructor(options){
        super(options);
    }
    /**
     * For each supported event, we have a Set that holds all the callbacks that should be executed
     * when the event is triggered.
     */ eventSets = {
        gridLayoutChanged: new Set(),
        columnDefsChanged: new Set(),
        rowModelUpdated: new Set()
    };
    on(event, callback) {
        this.eventSets[event].add(callback);
        return ()=>{
            this.eventSets[event].delete(callback);
        };
    }
    suspend() {
        this.suspended = true;
    }
    resume() {
        this.suspended = false;
    }
    emitSync(event, ...args) {
        if (this.destroyed) return;
        if (this.suspended) return;
        const set = this.eventSets[event];
        set.forEach((callback)=>{
            if (this.destroyed) return;
            // @ts-ignore
            callback(...args);
        });
    }
    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        Object.values(this.eventSets).forEach((set)=>{
            set.clear();
        });
    }
}



/**
 * Performs a deep comparison between two values to determine if they are equivalent.
 * Drop-in replacement for lodash/isEqual.
 */ function $f94a32af7542d5ef$var$baseIsEqual(a, b, seen) {
    // Identical references or primitives
    if (a === b) return true;
    // NaN check
    if (a !== a && b !== b) return true;
    // Null/undefined/primitive mismatch
    if (a == null || b == null) return false;
    const typeA = typeof a;
    const typeB = typeof b;
    if (typeA !== typeB) return false;
    if (typeA !== 'object') return false;
    // Date
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    // RegExp
    if (a instanceof RegExp && b instanceof RegExp) return a.source === b.source && a.flags === b.flags;
    // One is Date/RegExp but the other is not
    if (a instanceof Date !== b instanceof Date) return false;
    if (a instanceof RegExp !== b instanceof RegExp) return false;
    // Circular reference detection
    if (seen.has(a)) return seen.get(a) === b;
    seen.set(a, b);
    // Arrays
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$f94a32af7542d5ef$var$baseIsEqual(a[i], b[i], seen)) return false;
        }
        return true;
    }
    if (Array.isArray(b)) return false;
    // Map
    if (a instanceof Map && b instanceof Map) {
        if (a.size !== b.size) return false;
        for (const [key, val] of a){
            if (!b.has(key) || !$f94a32af7542d5ef$var$baseIsEqual(val, b.get(key), seen)) return false;
        }
        return true;
    }
    // Set (unordered deep comparison, matching lodash behavior)
    if (a instanceof Set && b instanceof Set) {
        if (a.size !== b.size) return false;
        for (const valA of a){
            let found = false;
            for (const valB of b)if ($f94a32af7542d5ef$var$baseIsEqual(valA, valB, new Map(seen))) {
                found = true;
                break;
            }
            if (!found) return false;
        }
        return true;
    }
    // ArrayBuffer / TypedArray
    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
        const viewA = a;
        const viewB = b;
        if (viewA.length !== viewB.length) return false;
        for(let i = 0; i < viewA.length; i++){
            if (viewA[i] !== viewB[i]) return false;
        }
        return true;
    }
    // Plain objects
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (!$f94a32af7542d5ef$var$baseIsEqual(a[key], b[key], seen)) return false;
    }
    return true;
}
function $f94a32af7542d5ef$export$2e2bcd8739ae039(value, other) {
    return $f94a32af7542d5ef$var$baseIsEqual(value, other, new Map());
}





const $61699e324df75e87$var$logger = (0, $88ab1a78ec8ca4b4$export$1c9f709888824e05)(`LayoutManager:Diffing`);
const $61699e324df75e87$export$db14845dcbb6e6df = (l1, l2)=>{
    if (!l1 || typeof l1 !== 'object' || !l2 || typeof l2 !== 'object') return [
        {
            key: 'missing',
            value1: l1,
            value2: l2
        }
    ];
    const k1 = Object.keys(l1);
    const k2 = Object.keys(l2);
    const allKeys = new Set([
        ...k1,
        ...k2
    ]);
    const changes = [];
    for (const key of allKeys)if (!(0, $f94a32af7542d5ef$export$2e2bcd8739ae039)(l1[key], l2[key])) changes.push({
        key: key,
        value1: l1[key],
        value2: l2[key]
    });
    return changes;
};
const $61699e324df75e87$export$148be03fd99a6f44 = (l1, l2, log)=>{
    log = log || $61699e324df75e87$var$logger;
    const changes = $61699e324df75e87$export$db14845dcbb6e6df(l1, l2);
    log('---');
    log('Layouts are not equal.');
    log('Layout 1', l1);
    log('Layout 2', l2);
    log('Differences:', changes);
    log('---');
};
function $61699e324df75e87$export$9cf1159da69b7cbf(l1, l2) {
    l1 = (0, $9399b0c19bfb07a7$export$dd21133fd9f15048)(l1);
    l2 = (0, $9399b0c19bfb07a7$export$dd21133fd9f15048)(l2);
    $61699e324df75e87$var$clearIgnoredProperties(l1);
    $61699e324df75e87$var$clearIgnoredProperties(l2);
    const res = (0, $f94a32af7542d5ef$export$2e2bcd8739ae039)(l1, l2);
    if (!res) $61699e324df75e87$export$148be03fd99a6f44(l1, l2);
    return res;
}
//#clearIgnoredProperties
function $61699e324df75e87$var$clearIgnoredProperties(layout) {
    delete layout.Ignore_GridFilter;
    delete layout.Ignore_ColumnFilters;
    delete layout.Ignore_ColumnHeaders;
    delete layout.Ignore_AutoSizeColumns;
    delete layout.Ignore_RowSummaries;
    delete layout.Ignore_IsReadOnly;
    delete layout.Ignore_Tags;
    delete layout.Ignore_Source;
    delete layout.Ignore_Metadata;
    delete layout.Ignore_AdaptableVersion;
    delete layout.Ignore_Uuid;
}
function $61699e324df75e87$export$4af8615675c52c6c(l1, l2) {
    l1 = (0, $9399b0c19bfb07a7$export$ba8b5004731f7e8a)(l1);
    l2 = (0, $9399b0c19bfb07a7$export$ba8b5004731f7e8a)(l2);
    $61699e324df75e87$var$clearIgnoredProperties(l1);
    $61699e324df75e87$var$clearIgnoredProperties(l2);
    const res = (0, $f94a32af7542d5ef$export$2e2bcd8739ae039)(l1, l2);
    if (!res) $61699e324df75e87$export$148be03fd99a6f44(l1, l2);
    return res;
}
function $61699e324df75e87$export$2bd574e05880992d(l1, l2) {
    if ((0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(l1) != (0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(l2)) return false;
    if ((0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(l1) && (0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(l2)) return $61699e324df75e87$export$4af8615675c52c6c(l1, l2);
    if (!(0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(l1) && !(0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(l2)) return $61699e324df75e87$export$9cf1159da69b7cbf(l1, l2);
    return false;
}




function $09992080550de2e8$export$751775fc0da97049(layout) {
    layout = structuredClone(layout);
    if (layout.ColumnVisibility && !Object.keys(layout.ColumnVisibility).length) delete layout.ColumnVisibility;
    if (layout.ColumnSizing && !Object.keys(layout.ColumnSizing).length) delete layout.ColumnSizing;
    if (layout.ColumnSorts && !layout.ColumnSorts.length) delete layout.ColumnSorts;
    if (layout.Ignore_ColumnFilters && !layout.Ignore_ColumnFilters) delete layout.Ignore_ColumnFilters;
    if (layout.RowGroupedColumns && !layout.RowGroupedColumns.length) delete layout.RowGroupedColumns;
    !layout.RowGroupedColumns && layout.RowGroupValues;
    if (!layout.SuppressAggFuncInHeader) delete layout.SuppressAggFuncInHeader;
    // this is the default value
    // if (layout.RowGroupValues && layout.RowGroupValues.RowGroupDisplay === 'always-collapsed') {
    //   delete layout.RowGroupValues;
    // }
    // if it's a property, but is undefined
    // make sure we delete it
    if (!layout.RowGroupValues && Object.prototype.hasOwnProperty.call(layout, 'RowGroupValues')) delete layout.RowGroupValues;
    // if it's a property, but is undefined
    // make sure we delete it
    if (!layout.ColumnGroupValues && Object.prototype.hasOwnProperty.call(layout, 'ColumnGroupValues')) delete layout.ColumnGroupValues;
    if (layout.TableAggregationColumns && !layout.TableAggregationColumns.length) delete layout.TableAggregationColumns;
    if (layout.ColumnPinning && !Object.keys(layout.ColumnPinning).length) delete layout.ColumnPinning;
    if (!layout.RowGroupDisplayType && layout.TableColumns && layout.TableColumns.length && layout.RowGroupedColumns && layout.RowGroupedColumns.length) {
        let displayType = 'single';
        layout.TableColumns.some((columnId)=>{
            if (columnId === (0, $9399b0c19bfb07a7$export$b9ed909d42ef1a59)) {
                displayType = 'single';
                return true;
            } else if (columnId.startsWith((0, $9399b0c19bfb07a7$export$652eb7684b734a42))) {
                displayType = 'multi';
                return true;
            }
        });
        layout.RowGroupDisplayType = displayType;
    }
    if (layout.GrandTotalRow === undefined) delete layout.GrandTotalRow;
    return layout;
}
function $09992080550de2e8$export$a987b87147cf5c85(layout) {
    layout = structuredClone(layout);
    if (layout.ColumnSizing && !Object.keys(layout.ColumnSizing).length) delete layout.ColumnSizing;
    if (!layout.SuppressAggFuncInHeader) delete layout.SuppressAggFuncInHeader;
    if (layout.PivotAggregationColumns && !layout.PivotAggregationColumns.length) delete layout.PivotAggregationColumns;
    if (layout.ColumnSorts && !layout.ColumnSorts.length) delete layout.ColumnSorts;
    if (layout.GrandTotalRow === undefined) delete layout.GrandTotalRow;
    if (layout.PivotColumnTotal === undefined) delete layout.PivotColumnTotal;
    if (layout.PivotGrandTotal === undefined) delete layout.PivotGrandTotal;
    // if it's a property, but is undefined
    // make sure we delete it
    if (!layout.ColumnGroupValues && Object.prototype.hasOwnProperty.call(layout, 'ColumnGroupValues')) delete layout.ColumnGroupValues;
    return layout;
}
function $09992080550de2e8$export$d55781a89e41ea43(layout) {
    if ((0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(layout)) return $09992080550de2e8$export$a987b87147cf5c85(layout);
    return $09992080550de2e8$export$751775fc0da97049(layout);
}


function $098fa86aabe6d330$var$insertAtCorrectIndex(result, colId, visibleColumnsIndexes, hiddenColIds, offset = 0, lastVisibleOffset = 0) {
    const prevColId = result[result.length - 1 - offset];
    if (!prevColId) {
        result.splice(result.length - lastVisibleOffset, 0, colId);
        return;
    }
    if (hiddenColIds.has(prevColId)) {
        $098fa86aabe6d330$var$insertAtCorrectIndex(result, colId, visibleColumnsIndexes, hiddenColIds, offset + 1, /* do not advance this as, as we've encountered a hidden column*/ lastVisibleOffset);
        return;
    }
    const prevCol_visibilityIndex = visibleColumnsIndexes[prevColId];
    const currentCol_visibilityIndex = visibleColumnsIndexes[colId];
    if (currentCol_visibilityIndex < prevCol_visibilityIndex) $098fa86aabe6d330$var$insertAtCorrectIndex(result, colId, visibleColumnsIndexes, hiddenColIds, offset + 1, /*make sure we sync with the normal offset, as we've hit a visible col*/ offset + 1);
    else result.splice(result.length - lastVisibleOffset, 0, colId);
}
const $098fa86aabe6d330$var$ALLOW_MISSING_COLUMNS = true;
function $098fa86aabe6d330$export$c2cd5eccc0f0183b(columnIds, desiredColumnOrder) {
    const desiredColumnOrderSet = new Set(desiredColumnOrder);
    const columnIdsSet = new Set(columnIds);
    const hiddenColIds = new Set(columnIds.filter((colId)=>!desiredColumnOrderSet.has(colId)));
    const visibleColumnsIndexes = desiredColumnOrder.reduce((acc, colId, index)=>{
        acc[colId] = index;
        return acc;
    }, {});
    let result = [];
    for(let i = 0, len = columnIds.length; i < len; i++){
        const colId = columnIds[i];
        const colVisible = visibleColumnsIndexes[colId] != null;
        if (!colVisible) {
            // for cols not present in this layout, we keep them
            // where they are
            result.push(colId);
            continue;
        }
        $098fa86aabe6d330$var$insertAtCorrectIndex(result, colId, visibleColumnsIndexes, hiddenColIds);
    }
    if ($098fa86aabe6d330$var$ALLOW_MISSING_COLUMNS) {
        const missingColIdInsertionMapBefore = new Map();
        desiredColumnOrder.forEach((colId, index, arr)=>{
            if (!columnIdsSet.has(colId)) {
                let nextColId = null;
                // look for the next colId that is in the columnIdsSet
                for(let i = index + 1; i < arr.length; i++)if (columnIdsSet.has(arr[i])) {
                    nextColId = arr[i];
                    break;
                }
                if (nextColId === null || columnIdsSet.has(nextColId)) {
                    const beforeColIds = missingColIdInsertionMapBefore.get(nextColId) || [];
                    missingColIdInsertionMapBefore.set(nextColId, [
                        ...beforeColIds,
                        colId
                    ]);
                }
            }
        });
        if (missingColIdInsertionMapBefore.size > 0) {
            result = result.flatMap((colId)=>{
                const beforeColIds = missingColIdInsertionMapBefore.get(colId) || [];
                return [
                    ...beforeColIds,
                    colId
                ];
            });
            if (missingColIdInsertionMapBefore.has(null)) {
                const beforeColIds = missingColIdInsertionMapBefore.get(null) || [];
                result = [
                    ...result,
                    ...beforeColIds
                ];
            }
        }
    }
    return result;
}
function $098fa86aabe6d330$export$ce5b26ee82fe311c(x, sortIndexes) {
    if (x.length !== sortIndexes.length) throw new Error('x and sortIndexes must be the same length');
    return sortIndexes.map((index)=>x[index]);
}


// supports only pivotTotalColumns (aggregation total) and pivotGroupTotal
// AG Grid builds the ID as: `pivot_${pivotCols.join('-')}_${pivotKeys.join('-')}_${measureColumnId}`
// see https://github.com/ag-grid/ag-grid/blob/e0cfe533b55b75cdc148cdfb1a4e977731dc0712/packages/ag-grid-enterprise/src/pivot/pivotColDefService.ts#L454C16-L454C88
function $cd4621bade181468$export$152454e54408b5ae(colDef, currentModel, logWarning) {
    const { colId: colId } = colDef;
    // Basic validation
    if (!colId?.startsWith('pivot_')) {
        logWarning(`Column id must start with 'pivot_': ${colId}`);
        return '!unknown!';
    }
    const hasSpecialChars = (arr)=>arr.some((str)=>str.includes('-') || str.includes('_'));
    // AG Grid uses _ and - as delimiters
    // if we have these special characters in the column IDs, we need to parse them differently
    const colIdsOrKeysContainSpecialChars = hasSpecialChars(currentModel.pivotColIds) || hasSpecialChars(currentModel.aggColIds) || hasSpecialChars(colDef.pivotKeys || []);
    // Fast path - no special characters
    if (!colIdsOrKeysContainSpecialChars) {
        // Split by underscore to get 4 parts
        const parts = colId.split('_');
        if (parts.length !== 4) {
            logWarning(`Unsupported format of pivot total column id: ${colId}`);
            return '!unknown!';
        }
        const [_pivotPrefix, pivotColsTxt, pivotKeysTxt, aggregationColumnId] = parts;
        const pivotColumnIds = pivotColsTxt.split('-');
        const pivotKeys = pivotKeysTxt.split('-');
        const pivotColumnId = pivotColumnIds[pivotKeys.length - 1];
        if (aggregationColumnId !== '' && !currentModel.aggColIds.includes(aggregationColumnId)) {
            logWarning(`Unknown aggregation column: ${aggregationColumnId}`);
            return '!unknown!';
        }
        return {
            pivotColumnIds: pivotColumnIds,
            pivotKeys: pivotKeys,
            pivotColumnId: pivotColumnId,
            aggregationColumnId: aggregationColumnId !== '' ? aggregationColumnId : undefined
        };
    }
    // the complex path, where we have to handle the special characters
    // Remove 'pivot_' prefix
    const withoutPrefix = colId.slice(6);
    // Check if it's a pivot group total
    const isPivotGroupTotal = withoutPrefix.endsWith('_');
    // Get pivot keys from colDef (more reliable than string parsing)
    const pivotKeys = colDef.pivotKeys || [];
    if (isPivotGroupTotal) {
        // Remove trailing underscore for pivot group totals
        const content = withoutPrefix.slice(0, -1);
        // The remaining content should be the pivot columns
        const pivotColumnIds = currentModel.pivotColIds.filter((id)=>content.includes(id));
        if (!pivotColumnIds.length) {
            logWarning(`Could not identify pivot columns in: ${content}`);
            return '!unknown!';
        }
        return {
            pivotColumnIds: pivotColumnIds,
            pivotKeys: pivotKeys,
            pivotColumnId: pivotColumnIds[pivotKeys.length - 1]
        };
    }
    // For regular pivot columns, work backwards to find aggregation column.
    // Check if the full string ends with _${aggColId} rather than splitting by _,
    // since agg column IDs may themselves contain underscores (e.g. github_stars).
    // Sort by length descending so the longest match wins.
    const aggregationColumnId = [
        ...currentModel.aggColIds
    ].sort((a, b)=>b.length - a.length).find((aggId)=>withoutPrefix.endsWith('_' + aggId));
    if (!aggregationColumnId) {
        logWarning(`Could not identify aggregation column in: ${withoutPrefix}`);
        return '!unknown!';
    }
    // Remove aggregation part and get pivot columns
    const withoutAgg = withoutPrefix.slice(0, -(aggregationColumnId.length + 1));
    const pivotColumnIds = currentModel.pivotColIds.filter((id)=>withoutAgg.includes(id));
    if (!pivotColumnIds.length) {
        logWarning(`Could not identify pivot columns in: ${withoutAgg}`);
        return '!unknown!';
    }
    return {
        pivotColumnIds: pivotColumnIds,
        pivotKeys: pivotKeys,
        pivotColumnId: pivotColumnIds[pivotKeys.length - 1],
        aggregationColumnId: aggregationColumnId
    };
}


function $abd79289c75d3093$export$605b4a9c6ba8ba9a(colDef) {
    return !!colDef.pivotTotalColumnIds?.length;
}


function $4de552a4ad6e0c97$export$5bd0e023a792f54b(colDef) {
    return colDef?.colId?.startsWith('PivotRowTotal_pivot_');
}


function $1d01f71c6f4ca9d9$export$e8f3ce9d27d3bb8f(colId) {
    // pivot group total are spanning cross all aggregations
    // therefore the last part of the colId is empty (hence the "dangling" underscore)
    return colId?.startsWith('pivot_') && colId?.endsWith('_');
}



const $d11443acac25ae35$export$764ffb89dcd82963 = {
    Init: {
        track: 'Initialisation',
        labels: {
            Init: 'Init',
            InitStore: 'Init store',
            LoadStore: 'Loading store',
            InitAGGrid: 'AG Grid init'
        }
    },
    LayoutManager: {
        track: 'Layout Manager',
        labels: {
            SetLayout: 'Setting layout',
            ApplyPivotLayout: 'Apply pivot layout',
            ApplyTableLayout: 'Apply table layout'
        }
    },
    Runtime: {
        track: 'Runtime',
        labels: {
            SetLayout: 'Setting layout'
        }
    },
    Redux: {
        track: 'Redux',
        labels: {
            Action: 'Action'
        }
    }
};


const $640f77453ad4a03c$var$AVAILABLE_COLORS = [
    'primary',
    'primary-light',
    'primary-dark',
    'secondary',
    'secondary-light',
    'secondary-dark',
    'tertiary',
    'tertiary-light',
    'tertiary-dark'
];
const $640f77453ad4a03c$var$colorMap = new Map();
function $640f77453ad4a03c$var$getColor(identifier) {
    if ($640f77453ad4a03c$var$colorMap.has(identifier)) return $640f77453ad4a03c$var$colorMap.get(identifier);
    const color = $640f77453ad4a03c$var$AVAILABLE_COLORS[$640f77453ad4a03c$var$colorMap.size % $640f77453ad4a03c$var$AVAILABLE_COLORS.length];
    $640f77453ad4a03c$var$colorMap.set(identifier, color);
    return color;
}
class $640f77453ad4a03c$export$a18bfee2d21f9928 {
    adaptableId;
    static create(adaptableId) {
        return new $640f77453ad4a03c$export$a18bfee2d21f9928(adaptableId);
    }
    markerDetails = {
        label: '',
        track: '',
        trackGroup: undefined,
        color: undefined,
        details: [],
        tooltip: undefined
    };
    stopped = false;
    constructor(adaptableId){
        this.adaptableId = adaptableId;
        this.adaptableId = adaptableId;
    }
    start = (startDetails)=>{
        if (this.markerDetails.startTs) return this;
        const start = performance.now();
        this.markerDetails.details = startDetails?.details ?? [];
        this.markerDetails.startTs = start;
        return this;
    };
    get startTimestamp() {
        return this.markerDetails.startTs;
    }
    get track() {
        const self = this;
        return Object.keys((0, $d11443acac25ae35$export$764ffb89dcd82963)).reduce((acc, track)=>{
            const trackObj = {
                start: self.start,
                end: (markerDetails)=>{
                    return self.end({
                        ...markerDetails,
                        track: (0, $d11443acac25ae35$export$764ffb89dcd82963)[track].track,
                        label: markerDetails.label
                    });
                },
                get label () {
                    const currentTrack = (0, $d11443acac25ae35$export$764ffb89dcd82963)[track];
                    return Object.keys(currentTrack.labels).reduce((labelAcc, label)=>{
                        const labelObj = {
                            start: self.start,
                            end: (markerDetails)=>{
                                return self.end({
                                    ...markerDetails,
                                    track: currentTrack.track,
                                    label: currentTrack.labels[label]
                                });
                            }
                        };
                        Object.defineProperty(labelAcc, label, {
                            get: ()=>{
                                self.markerDetails.label = currentTrack.labels[label];
                                return labelObj;
                            }
                        });
                        return labelAcc;
                    }, {});
                }
            };
            Object.defineProperty(acc, track, {
                get: ()=>{
                    const currentTrack = (0, $d11443acac25ae35$export$764ffb89dcd82963)[track];
                    self.markerDetails.track = currentTrack.track;
                    return trackObj;
                }
            });
            return acc;
        }, {});
    }
    end = (markerDetails = {})=>{
        if (this.stopped) return this;
        this.stopped = true;
        const start = markerDetails.startTs ?? this.markerDetails.startTs;
        const end = markerDetails.endTs ?? this.markerDetails.endTs ?? performance.now();
        let color = markerDetails.color || this.markerDetails.color || '';
        const trackGroup = markerDetails.trackGroup || this.markerDetails.trackGroup || `AdapTable (${this.adaptableId})`;
        const details = [
            ...this.markerDetails.details || [],
            ...markerDetails.details || []
        ];
        const tooltip = markerDetails.tooltip || this.markerDetails.tooltip;
        const label = markerDetails.label || this.markerDetails.label || 'Unknown';
        const track = markerDetails.track || this.markerDetails.track || 'Unknown';
        if (!color) {
            const identifier = `${trackGroup}:${track}:${label}`;
            color = $640f77453ad4a03c$var$getColor(identifier);
        }
        performance.measure(label, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    dataType: 'track-entry',
                    trackGroup: trackGroup,
                    track: track,
                    color: color || 'primary',
                    properties: details.length > 0 ? details.map((detail)=>[
                            detail.name,
                            detail.value
                        ]) : undefined,
                    tooltipText: tooltip
                }
            }
        });
        return this;
    };
}
function $640f77453ad4a03c$export$375cebbcaf1ca382(adaptableId) {
    const trakcsSupported = typeof performance !== 'undefined' && typeof performance.now === 'function' && typeof performance.measure === 'function';
    if (!trakcsSupported) return false;
    if (typeof localStorage !== 'undefined' && (0, $88ab1a78ec8ca4b4$export$1c9f709888824e05).isChannelEnabled(adaptableId ? `Adaptable:${adaptableId}:perf` : 'Adaptable:*:perf', typeof localStorage !== 'undefined' ? localStorage.debug || '' : '')) return true;
    if (typeof localStorage !== 'undefined' && localStorage.adaptableProfileTracks == 'true') return true;
    return false;
}
function $640f77453ad4a03c$export$cd7dd5b5380f942f(adaptableId) {
    const enabled = $640f77453ad4a03c$export$375cebbcaf1ca382(adaptableId);
    const marker = $640f77453ad4a03c$export$a18bfee2d21f9928.create(adaptableId);
    if (!enabled) {
        marker.start = ()=>marker;
        marker.end = ()=>marker;
    }
    return marker;
}


const $34e0a646a54b76b6$export$f5db7d5592212d77 = 'pivotAnyTotal';
const $34e0a646a54b76b6$export$317c4ed011433b68 = 'pivotGrandTotal';
const $34e0a646a54b76b6$export$445f227fdcc241e3 = 'pivotColumnTotal';
const $34e0a646a54b76b6$export$57ab19c32215f85f = 'pivotAggregationTotal';
function $34e0a646a54b76b6$var$mapColDefs(colDefs, mapFn) {
    const iteration = (c)=>{
        if (c.children) return {
            ...c,
            children: $34e0a646a54b76b6$var$mapColDefs(c.children, mapFn)
        };
        const colDef = c;
        return mapFn(colDef);
    };
    return colDefs.map(iteration);
}
function $34e0a646a54b76b6$var$flattenColDefs(colDefs) {
    const res = [];
    const iteration = (c)=>{
        if (c.children) {
            c.children.forEach(iteration);
            return;
        }
        const colDef = c;
        res.push(colDef);
    };
    colDefs.forEach(iteration);
    return res;
}
function $34e0a646a54b76b6$var$findInColDefs(colDefs, callback) {
    function iteration(colDefs) {
        for (const c of colDefs)if (c.children) {
            const res = iteration(c.children);
            if (res) return res;
        } else {
            const colDef = c;
            if (callback(colDef)) return colDef;
        }
    }
    return iteration(colDefs);
}
const $34e0a646a54b76b6$var$DEFAULT_COLUMN_WIDTH = 200;
const $34e0a646a54b76b6$var$DEFAULT_AGG_FUNC = 'sum';
/**
 *
 * @param columnIds the column ids that we want to be in the order
 * @param colDefs all the colDefs in the grid
 * @returns the array of the given column ids, but also any other column id that is not in the given column ids, but
 * has a column definition
 */ function $34e0a646a54b76b6$var$getColumnOrderIdsForAllColDefs(columnIds = [], colDefs) {
    const flatColDefs = $34e0a646a54b76b6$var$flattenColDefs(colDefs);
    const flatColIds = flatColDefs.map((c)=>c.colId ?? c.field);
    if (columnIds.length === 0) return flatColIds;
    const sortedColIds = (0, $098fa86aabe6d330$export$c2cd5eccc0f0183b)(flatColIds, columnIds);
    return sortedColIds;
}
const $34e0a646a54b76b6$var$EXPAND_COLLAPSE_EVENTS = {
    expandOrCollapseAll: true,
    rowGroupOpened: true
};
const $34e0a646a54b76b6$var$COLUMN_EVENTS_THAT_TRIGGERS_AUTO_LAYOUT_SAVE = {
    displayedColumnsChanged: true,
    columnResized: true,
    sortChanged: true,
    columnRowGroupChanged: true,
    ...$34e0a646a54b76b6$var$EXPAND_COLLAPSE_EVENTS
};
function $34e0a646a54b76b6$var$isGridLayoutSame(options) {
    const { layoutFromGrid: gridLayout, layoutFromModel: layout } = options;
    if (!!gridLayout != !!layout) return false;
    return (0, $61699e324df75e87$export$2bd574e05880992d)((0, $9399b0c19bfb07a7$export$36a34ee1a372c2b0)(gridLayout), (0, $9399b0c19bfb07a7$export$36a34ee1a372c2b0)(layout));
}
function $34e0a646a54b76b6$var$getDefaultColumnSizeStateForColDef(colId, colDef, options) {
    if (!colDef) {
        colDef = $34e0a646a54b76b6$var$findInColDefs(options?.columnDefs || [], (colDef)=>colDef.colId ? colDef.colId === colId : colDef.field === colId);
        if (!colDef) return undefined;
    }
    let propsFromColType = {
        ...options?.defaultColDef
    };
    if (options?.colTypes) {
        // for col sizing, we want the columns sized as flex via col.type and defaultColDef
        // to be sized as flex, even if they are not in the layout.ColumnSizing object
        let colType = colDef?.type;
        if (colType && !Array.isArray(colType)) colType = colType.split(',');
        if (Array.isArray(colType) && colType.length) propsFromColType = colType.reduce((acc, type)=>{
            const props = options.colTypes[type];
            if (props) return {
                ...acc,
                ...props
            };
            return acc;
        }, {});
    }
    if (propsFromColType.flex) return {
        colId: colId,
        flex: propsFromColType.flex
    };
    if (propsFromColType.width) return {
        colId: colId,
        width: propsFromColType.width
    };
    return undefined;
}
class $34e0a646a54b76b6$export$4a04ad01c410b415 extends (0, $c45620437be4c7ed$export$6378f8209ec376df) {
    gridApi;
    fieldsToIds = {};
    idsToFields = {};
    idsToColDefs = {};
    initialColumnWidths = {};
    currentLayout = null;
    layoutChangeDebounce;
    _prevFiredLayout;
    setGridOption_default;
    suppressGlobalAgGridEventListener = false;
    supressGlobalAgGridEventTimeoutId = null;
    layoutManagerDebugId;
    constructor(options){
        super({
            debugId: options.debugId
        });
        this.layoutChangeDebounce = options.layoutChangeDebounce ?? 0;
        if (this.layoutChangeDebounce) this.onGridLayoutChanged = (0, $88ab1a78ec8ca4b4$export$61fc7d43ac8f84b0)(this.onGridLayoutChanged, {
            wait: this.layoutChangeDebounce
        }).bind(this);
        this.setOptions(options);
        // this ensures the grand total columns are positioned correctly (before/after) even when changed at runtime
        // see https://www.ag-grid.com/react-data-grid/pivoting-column-groups/#changing-data-filters-and-configurations
        this.gridApi.setGridOption('enableStrictPivotColumnOrder', true);
        this.setupEvents();
        this.indexColumns();
        this.setupPivotTotals();
    // (globalThis as any).layoutManager = this;
    }
    destroy() {
        if (this.destroyed) return;
        super.destroy();
        if (this.setGridOption_default) this.gridApi.setGridOption = this.setGridOption_default;
        if (!this.gridApi.isDestroyed()) this.gridApi.removeGlobalListener(this.globalAgGridEventListener);
        this.gridApi = null;
    }
    setupEvents() {
        this.setupSetColumnDefs();
        this.gridApi.addGlobalListener(this.globalAgGridEventListener);
    }
    setupSetColumnDefs() {
        const setGridOption_default = this.gridApi.setGridOption;
        const self = this;
        this.setGridOption_default = setGridOption_default;
        const setGridOption = (key, value)=>{
            let defaultSuppressColumnMoveAnimation = this.gridApi.getGridOption('suppressColumnMoveAnimation');
            if (key === 'columnDefs') {
                if (!defaultSuppressColumnMoveAnimation) setGridOption_default.call(this.gridApi, 'suppressColumnMoveAnimation', true);
            }
            const res = setGridOption_default.call(this.gridApi, key, value);
            if (key === 'columnDefs') {
                if (!defaultSuppressColumnMoveAnimation) this.gridApi.setGridOption('suppressColumnMoveAnimation', false);
                self.columnDefsChanged(value);
            }
            return res;
        };
        this.gridApi.setGridOption = setGridOption;
    }
    globalAgGridEventListener = (type, event)=>{
        if (this.destroyed || this.suppressGlobalAgGridEventListener) return;
        if (type in $34e0a646a54b76b6$var$COLUMN_EVENTS_THAT_TRIGGERS_AUTO_LAYOUT_SAVE) {
            if (type === 'columnResized' && !event.finished) return;
            // called while dragging a column from the sidebar, to the row groups panel
            if (type === 'displayedColumnsChanged' && event.source === 'uiColumnDragged') return;
            this.warn(`globalAgGridEventListener-${type}`, event);
            if (!this.currentLayout) {
                const gridLayout = this.getLayoutModelFromGrid();
                // if there's no layout set currently in AG Grid
                // then emit the gridLayoutChanged event directly
                // as we don't have a current layout to compare to
                this.onGridLayoutChanged(gridLayout);
                return;
            }
            const gridLayout = this.getLayoutModelFromGrid();
            // but if we do have a current layout set
            // then only emit the event if the layout has changed
            if (!$34e0a646a54b76b6$var$isGridLayoutSame({
                layoutFromGrid: gridLayout,
                layoutFromModel: this.currentLayout
            })) {
                this.onGridLayoutChanged(gridLayout);
                return;
            }
        }
    };
    columnDefsChanged = (colDefs)=>{
        if (this.suppressGlobalAgGridEventListener) return;
        this.warn('onColumnDefsChanged');
        this.indexColumns();
        if (this.currentLayout) this.applyLayout(this.currentLayout);
        this.emitSync('columnDefsChanged', colDefs);
    };
    indexColumns() {
        const colDefs = this.gridApi.getColumnDefs();
        this.fieldsToIds = {};
        this.idsToFields = {};
        this.idsToColDefs = {};
        const iteration = (c)=>{
            if (c.children) {
                c.children.forEach(iteration);
                return;
            }
            const colDef = c;
            const colId = colDef.colId ?? colDef.field;
            const field = colDef.field;
            if (field) {
                this.fieldsToIds[field] = colId;
                this.idsToFields[colId] = field;
            }
            this.idsToColDefs[colId] = colDef;
            // const col = this.gridApi.getColumn(colId);
            // this.initialColumnWidths[colId] = colDef.width ?? colDef.initialWidth ?? DEFAULT_COLUMN_WIDTH; // this.gridApi.getColumn(colId).getActualWidth();
            // this.initialColumnWidths[colId] = col.getActualWidth();
            this.initialColumnWidths[colId] = this.getDefaultColumnWidthForCol(colId, colDef);
            const rowGroupColumns = this.gridApi.getRowGroupColumns() ?? [];
            rowGroupColumns.forEach((column)=>{
                const colId = column.getColId();
                // const col = this.gridApi.getColumn(colId);
                // const colDef = col.getColDef();
                this.initialColumnWidths[colId] = this.getDefaultColumnWidthForCol(colId);
            // colDef.width ?? colDef.initialWidth ?? DEFAULT_COLUMN_WIDTH;
            });
        };
        colDefs.forEach(iteration);
    }
    onGridLayoutChanged(layout) {
        // we want to have this check, since onGridLayoutChanged might be triggered
        // by some AG Grid actions we're not interested - eg: filter changed
        // and the state of which is not captured by the Layout Model
        // so it would result in a layout object that's similar to the previous one
        // that we fired
        // hence we need this check here as well
        if (this._prevFiredLayout && (0, $61699e324df75e87$export$2bd574e05880992d)(layout, this._prevFiredLayout)) return;
        this.triggerGridLayoutChange(layout);
    }
    triggerGridLayoutChange(layout, prevLayout = this._prevFiredLayout, options) {
        layout = (0, $09992080550de2e8$export$d55781a89e41ea43)(layout);
        prevLayout = prevLayout ? (0, $09992080550de2e8$export$d55781a89e41ea43)(prevLayout) : undefined;
        const shouldSkipTriggerChange = options?.skipTriggerChange === true;
        this._prevFiredLayout = layout;
        this.currentLayout = layout;
        if (layout.RowGroupedColumns && layout.RowGroupedColumns.length > 0 && (prevLayout?.RowGroupedColumns || []).join(',') !== layout.RowGroupedColumns.join(',') && layout.RowGroupValues) {
            // most likely the user has changed grouping via some AG Grid action
            // and we need to make sure the expand/collapse state is applied
            // but we want to suspend the listener
            // as it would re-trigger another change
            const unsupress = this.suspendAgGridListener();
            this.applyRowGroupValues(layout.RowGroupValues, layout.RowGroupedColumns);
            unsupress();
        }
        if (!shouldSkipTriggerChange) {
            // emit an event that the layout has changed from the grid
            this.emitSync('gridLayoutChanged', layout);
            const log = this.debugger.extend('gridLayoutChanged');
            const changes = (0, $61699e324df75e87$export$db14845dcbb6e6df)((0, $9399b0c19bfb07a7$export$36a34ee1a372c2b0)(prevLayout), (0, $9399b0c19bfb07a7$export$36a34ee1a372c2b0)(layout));
            log('current grid layout:', JSON.stringify(layout, null, 2), '\nprev layout:\n', prevLayout ? JSON.stringify(prevLayout, null, 2) : 'no prev layout', '\nchanges from prev to current:\n', changes);
        }
    }
    onChange(fn) {
        return this.on('gridLayoutChanged', fn);
    }
    onColumnDefsChanged(fn) {
        return this.on('columnDefsChanged', fn);
    }
    setOptions(options) {
        this.gridApi = options.gridApi;
        this.layoutManagerDebugId = options.debugId;
    }
    getLayoutModelFromGrid() {
        return this.isInPivotMode() ? this.getPivotLayoutModelFromGrid() : this.getTableLayoutModelFromGrid();
    }
    getPivotLayoutModelFromGrid() {
        const pivotResultColumns = this.gridApi.getPivotResultColumns() || [];
        const pivotResultColumnsSet = new Set(pivotResultColumns.map((col)=>col.getColId()));
        const prevLayout = this.currentLayout;
        const columnState = this.gridApi.getColumnState().filter((col)=>!pivotResultColumnsSet.has(col.colId));
        const PivotColumns = this.gridApi.getPivotColumns().map((col)=>col.getColId());
        const layout = this.getUndecidedLayoutModelFromGrid(columnState);
        let ColumnSizing = layout.ColumnSizing || {};
        let ColumnVisibility = {
            ...layout.ColumnVisibility
        };
        const storePivotResultColumns = !!prevLayout?.PivotResultColumnsOrder;
        //let's also include the column widths of the pivotResult columns
        pivotResultColumns.forEach((col)=>{
            const colId = col.getColId();
            const Width = col.getActualWidth();
            const initialWidth = this.initialColumnWidths[colId] ?? $34e0a646a54b76b6$var$DEFAULT_COLUMN_WIDTH;
            // but if the width is the initial/default width, don't include it in the ColumnSizing
            if (Width !== initialWidth) ColumnSizing[colId] = {
                Width: Width
            };
        });
        if (!Object.keys(ColumnSizing).length) ColumnSizing = undefined;
        // from column visibility, let's remove all columns that are not actually in the pivot layout
        // since having normal table columns here will break the equality check
        // so we only want to keep the group columns and the pivot result columns
        Object.keys(ColumnVisibility).forEach((colId)=>{
            const isInLayout = pivotResultColumnsSet.has(colId) || colId.startsWith((0, $9399b0c19bfb07a7$export$b9ed909d42ef1a59));
            if (!isInLayout) delete ColumnVisibility[colId];
        });
        if (!Object.keys(ColumnVisibility).length) ColumnVisibility = undefined;
        delete layout.TableColumns;
        const pivotLayout = {
            Name: layout.Name,
            Ignore_GridFilter: layout.Ignore_GridFilter,
            Ignore_ColumnFilters: layout.Ignore_ColumnFilters,
            Ignore_ColumnHeaders: layout.Ignore_ColumnHeaders,
            Ignore_AutoSizeColumns: layout.Ignore_AutoSizeColumns,
            Ignore_RowSummaries: layout.Ignore_RowSummaries,
            Ignore_IsReadOnly: layout.Ignore_IsReadOnly,
            Ignore_Tags: layout.Ignore_Tags,
            Ignore_Metadata: layout.Ignore_Metadata,
            Ignore_Source: layout.Ignore_Source,
            Ignore_AdaptableVersion: layout.Ignore_AdaptableVersion,
            Ignore_Uuid: layout.Ignore_Uuid,
            PivotColumns: PivotColumns,
            ColumnPinning: layout.ColumnPinning,
            ColumnSorts: layout.ColumnSorts,
            ColumnSizing: ColumnSizing,
            ColumnVisibility: ColumnVisibility,
            RowGroupValues: layout.RowGroupValues,
            ColumnGroupValues: layout.ColumnGroupValues,
            PivotGroupedColumns: layout.RowGroupedColumns,
            PivotAggregationColumns: layout.TableAggregationColumns,
            GrandTotalRow: layout.GrandTotalRow,
            PivotExpandLevel: prevLayout?.PivotExpandLevel ?? -1
        };
        if (storePivotResultColumns) {
            // Save all pivot result columns (including hidden ones from collapsed
            // groups) in their current order, so the order is fully preserved.
            const allPivotResultColumnsInOrder = this.gridApi.getColumnState().filter((col)=>pivotResultColumnsSet.has(col.colId));
            pivotLayout.PivotResultColumnsOrder = allPivotResultColumnsInOrder.map((col)=>col.colId);
        }
        if (layout.SuppressAggFuncInHeader) pivotLayout.SuppressAggFuncInHeader = layout.SuppressAggFuncInHeader;
        const pivotGrandTotal = this.gridApi.getGridOption('pivotRowTotals');
        if (pivotGrandTotal) pivotLayout.PivotGrandTotal = pivotGrandTotal;
        const pivotColumnTotal = this.gridApi.getGridOption('pivotColumnGroupTotals');
        if (pivotColumnTotal) pivotLayout.PivotColumnTotal = pivotColumnTotal;
        return (0, $09992080550de2e8$export$a987b87147cf5c85)(pivotLayout);
    }
    getTableLayoutModelFromGrid() {
        return this.getUndecidedLayoutModelFromGrid(this.gridApi.getColumnState());
    }
    isTreeMode() {
        return this.gridApi.getGridOption('treeData');
    }
    getUndecidedLayoutModelFromGrid(columnState) {
        let TableColumns = columnState.map((c)=>c.colId);
        // .filter((colId) => colId !== 'ag-Grid-SelectionColumn');
        let ColumnSorts = [];
        const RowGroupedColumns = [];
        let RowGroupValues = undefined;
        let ColumnGroupValues = undefined;
        let TableAggregationColumns = [];
        const ColumnPinning = {};
        const gridState = this.gridApi.getState();
        const prevLayout = this.currentLayout;
        const prevAggColumns = prevLayout?.TableAggregationColumns ?? prevLayout?.PivotAggregationColumns;
        const ColumnSizing = {
            ...prevLayout?.ColumnSizing
        };
        const prevAggColumnsMap = prevAggColumns?.reduce((acc, agg)=>{
            acc[agg.ColumnId] = agg;
            return acc;
        }, {});
        const ColumnVisibility = columnState.reduce((acc, colState)=>{
            const colId = colState.colId;
            // normally we take the initial width from this object
            let initialWidth = this.initialColumnWidths[colId];
            // but if this is a group column
            // we try to infer it from the default width (when display type is single)
            // or from the respective group column (when display type is multi)
            if (initialWidth === undefined) {
                if (colId === (0, $9399b0c19bfb07a7$export$b9ed909d42ef1a59)) {
                    const groupByColId = this.gridApi.getRowGroupColumns()[0]?.getColId();
                    initialWidth = this.initialColumnWidths[colId] || this.initialColumnWidths[groupByColId];
                } else if (colId.startsWith((0, $9399b0c19bfb07a7$export$652eb7684b734a42))) initialWidth = this.initialColumnWidths[colId.replace((0, $9399b0c19bfb07a7$export$652eb7684b734a42), '')];
            }
            if (colState.flex != undefined) {
                const colSizing = {
                    ...ColumnSizing[colId]
                };
                delete colSizing.Width;
                colSizing.Flex = colState.flex;
                ColumnSizing[colId] = colSizing;
            } else if (colState.width && initialWidth != colState.width) {
                const colSizing = {
                    ...ColumnSizing[colId]
                };
                delete colSizing.Flex;
                colSizing.Width = colState.width;
                ColumnSizing[colId] = colSizing;
            }
            if (colState.hide) acc[colId] = false;
            if (colState.sort != undefined) ColumnSorts[colState.sortIndex] = {
                ColumnId: colId,
                SortOrder: colState.sort === 'asc' ? 'Asc' : 'Desc'
            };
            if (colState.rowGroupIndex != null) RowGroupedColumns[colState.rowGroupIndex] = colId;
            if (colState.pinned) ColumnPinning[colId] = colState.pinned === true ? 'left' : colState.pinned;
            return acc;
        }, {});
        if (gridState.pivot?.pivotMode && gridState.sort?.sortModel) // for pivot mode, we can't simply take the current sort from the ColumnState
        // but we have to go via the sortModel from the grid state
        ColumnSorts = gridState.sort.sortModel.map((sort)=>{
            return {
                ColumnId: sort.colId,
                SortOrder: sort.sort === 'asc' ? 'Asc' : 'Desc'
            };
        });
        if (gridState.aggregation) TableAggregationColumns = gridState.aggregation.aggregationModel.map((agg)=>{
            const prevAggForColumn = prevAggColumnsMap?.[agg.colId];
            if (prevAggForColumn && prevAggForColumn.AggFunc.aggFunc === agg.aggFunc) return prevAggForColumn;
            return {
                ColumnId: agg.colId,
                AggFunc: {
                    aggFunc: agg.aggFunc
                }
            };
        });
        // if there's a current layout set
        // we want to only return the AG Grid columns that are also in the current layout
        if (this.currentLayout && this.currentLayout.TableColumns && this.currentLayout.TableColumns.length > 0) {
            const colsInLayout = new Set(this.currentLayout.TableColumns);
            if (this.currentLayout.RowGroupedColumns?.length) {
                const groupDisplayType = this.gridApi.getGridOption('groupDisplayType');
                if (groupDisplayType === 'singleColumn') colsInLayout.add((0, $9399b0c19bfb07a7$export$b9ed909d42ef1a59));
                else this.currentLayout.RowGroupedColumns.forEach((colId)=>{
                    colsInLayout.add(`${(0, $9399b0c19bfb07a7$export$652eb7684b734a42)}${colId}`);
                });
            }
            // if (this.isTreeMode()) {
            //   // colsInLayout.add(GROUP_COLUMN_ID__SINGLE);
            // }
            TableColumns = TableColumns.filter((colId)=>{
                if (colsInLayout.has(colId)) return true;
                // we might hit an edge case where we ungroup one of the 2+ group cols
                // in the current layout - in which case in the prev state of the current layout
                // we had the group column
                // but now we will need to include the current column
                if (colsInLayout.has(`${(0, $9399b0c19bfb07a7$export$652eb7684b734a42)}${colId}`)) // ColumnVisibility[colId] = false;
                return true;
                const col = this.gridApi.getColumn(colId);
                if (!col) return false;
                return col.isVisible();
            });
            const columnOrderSet = new Set(TableColumns);
            Object.keys(ColumnSizing).forEach((colId)=>{
                if (!columnOrderSet.has(colId)) delete ColumnSizing[colId];
            });
            Object.keys(ColumnVisibility).forEach((colId)=>{
                if (!columnOrderSet.has(colId)) delete ColumnVisibility[colId];
            });
            TableAggregationColumns = TableAggregationColumns.filter((agg)=>{
                if (columnOrderSet.has(agg.ColumnId)) return true;
                return false;
            });
            Object.keys(ColumnPinning).forEach((colId)=>{
                if (!columnOrderSet.has(colId)) delete ColumnPinning[colId];
            });
        }
        if (RowGroupedColumns && RowGroupedColumns.length) {
            const LayoutRowGroupedColumns = this.currentLayout?.RowGroupedColumns || this.currentLayout?.PivotGroupedColumns || [];
            // if it's a new grouping, try and take it
            const isGroupingNew = RowGroupedColumns && RowGroupedColumns.join(',') !== LayoutRowGroupedColumns.join(',');
            if (this.currentLayout?.RowGroupValues) {
                const currentRowGroupValues = this.currentLayout.RowGroupValues;
                let currentRowGroupValuesGroupKeys = [];
                if (currentRowGroupValues.RowGroupDisplay === 'expanded' || currentRowGroupValues.RowGroupDisplay === 'collapsed') {
                    if (Array.isArray(currentRowGroupValues.GroupKeys)) currentRowGroupValuesGroupKeys = currentRowGroupValues.GroupKeys.find((item)=>{
                        return (item.RowGroupedColumns || []).join(',') === (RowGroupedColumns || []).join(',');
                    })?.Values || [];
                    else currentRowGroupValuesGroupKeys = currentRowGroupValues.Values || [];
                }
                if (currentRowGroupValues.RowGroupDisplay === 'always-collapsed') RowGroupValues = {
                    RowGroupDisplay: 'always-collapsed'
                };
                else if (currentRowGroupValues.RowGroupDisplay === 'always-expanded') RowGroupValues = {
                    RowGroupDisplay: 'always-expanded'
                };
                else if (currentRowGroupValues.RowGroupDisplay === 'collapsed') {
                    const ExpandedValues = isGroupingNew ? currentRowGroupValuesGroupKeys || [] : this.getRowGroupNodePathsAs({
                        expanded: true
                    });
                    if (Array.isArray(currentRowGroupValues.GroupKeys)) RowGroupValues = {
                        RowGroupDisplay: 'collapsed',
                        GroupKeys: currentRowGroupValues.GroupKeys.map((item)=>{
                            if ((item.RowGroupedColumns || []).join(',') === (RowGroupedColumns || []).join(',')) return {
                                RowGroupedColumns: item.RowGroupedColumns,
                                Values: ExpandedValues
                            };
                            return item;
                        })
                    };
                    else RowGroupValues = {
                        RowGroupDisplay: 'collapsed',
                        Values: ExpandedValues
                    };
                } else if (currentRowGroupValues.RowGroupDisplay === 'expanded') {
                    const CollapsedValues = isGroupingNew ? currentRowGroupValuesGroupKeys || [] : this.getRowGroupNodePathsAs({
                        expanded: false
                    });
                    if (Array.isArray(currentRowGroupValues.GroupKeys)) RowGroupValues = {
                        RowGroupDisplay: 'expanded',
                        GroupKeys: currentRowGroupValues.GroupKeys.map((item)=>{
                            if ((item.RowGroupedColumns || []).join(',') === (RowGroupedColumns || []).join(',')) return {
                                RowGroupedColumns: item.RowGroupedColumns,
                                Values: CollapsedValues
                            };
                            return item;
                        })
                    };
                    else RowGroupValues = {
                        RowGroupDisplay: 'expanded',
                        Values: CollapsedValues
                    };
                }
            }
        } else if (this.currentLayout?.RowGroupValues) RowGroupValues = this.currentLayout.RowGroupValues;
        if (this.currentLayout?.ColumnGroupValues) {
            const currentColumnGroupValues = this.currentLayout.ColumnGroupValues;
            if (currentColumnGroupValues.ColumnGroupDisplay === 'always-expanded') ColumnGroupValues = {
                ColumnGroupDisplay: 'always-expanded'
            };
            else if (currentColumnGroupValues.ColumnGroupDisplay === 'always-collapsed') ColumnGroupValues = {
                ColumnGroupDisplay: 'always-collapsed'
            };
            else if (currentColumnGroupValues.ColumnGroupDisplay === 'expanded' || currentColumnGroupValues.ColumnGroupDisplay === 'collapsed') {
                const isPivot = this.isCurrentLayoutPivot();
                const currentColumnGroupState = this.gridApi.getColumnGroupState()// if we're in a pivot layout, only include groups that are pivot groups
                // as there are other fake groups in the grid as well
                .filter((state)=>isPivot ? state.groupId.startsWith('pivotGroup_') : true);
                if (currentColumnGroupValues.ColumnGroupDisplay === 'expanded') {
                    const collapsedGroupIds = currentColumnGroupState.filter((state)=>{
                        return state.open === false;
                    }).map((state)=>state.groupId);
                    ColumnGroupValues = {
                        ColumnGroupDisplay: 'expanded',
                        Values: collapsedGroupIds
                    };
                } else if (currentColumnGroupValues.ColumnGroupDisplay === 'collapsed') {
                    const expandedGroupIds = currentColumnGroupState.filter((state)=>{
                        return state.open === true;
                    }).map((state)=>state.groupId);
                    ColumnGroupValues = {
                        ColumnGroupDisplay: 'collapsed',
                        Values: expandedGroupIds
                    };
                }
            }
        }
        const layout = (0, $09992080550de2e8$export$751775fc0da97049)({
            Name: this.currentLayout?.Name || 'Default',
            Ignore_GridFilter: this.currentLayout?.Ignore_GridFilter,
            Ignore_ColumnFilters: this.currentLayout?.Ignore_ColumnFilters,
            Ignore_ColumnHeaders: this.currentLayout?.Ignore_ColumnHeaders,
            Ignore_AutoSizeColumns: this.currentLayout?.Ignore_AutoSizeColumns,
            Ignore_RowSummaries: this.currentLayout?.Ignore_RowSummaries,
            Ignore_IsReadOnly: this.currentLayout?.Ignore_IsReadOnly,
            Ignore_Tags: this.currentLayout?.Ignore_Tags,
            Ignore_Metadata: this.currentLayout?.Ignore_Metadata,
            Ignore_Source: this.currentLayout?.Ignore_Source,
            Ignore_AdaptableVersion: this.currentLayout?.Ignore_AdaptableVersion,
            Ignore_Uuid: this.currentLayout?.Ignore_Uuid,
            TableColumns: TableColumns,
            ColumnVisibility: ColumnVisibility,
            ColumnSizing: ColumnSizing,
            ColumnSorts: ColumnSorts,
            RowGroupedColumns: RowGroupedColumns,
            TableAggregationColumns: TableAggregationColumns,
            ColumnPinning: ColumnPinning,
            RowGroupValues: RowGroupValues,
            ColumnGroupValues: ColumnGroupValues,
            GrandTotalRow: this.gridApi.getGridOption('grandTotalRow'),
            SuppressAggFuncInHeader: this.gridApi.getGridOption('suppressAggFuncInHeader'),
            RowGroupDisplayType: this.gridApi.getGridOption('groupDisplayType') === 'multipleColumns' ? 'multi' : 'single'
        });
        return layout;
    }
    static getColumnDefsChangesForLayout(layout, colDefs) {
        const columnSizing = layout.ColumnSizing || {};
        const flatColDefs = $34e0a646a54b76b6$var$flattenColDefs(colDefs);
        const changedColDefs = new Map();
        flatColDefs.forEach((colDef)=>{
            const colId = colDef.colId ?? colDef.field;
            const colSizing = columnSizing[colId] || {};
            if (colDef) {
                let changed = false;
                if (colSizing.MinWidth != undefined && colSizing.MinWidth != colDef.minWidth) {
                    colDef = {
                        ...colDef,
                        minWidth: colSizing.MinWidth
                    };
                    changed = true;
                }
                if (colSizing.MaxWidth != undefined && colSizing.MaxWidth != colDef.maxWidth) {
                    colDef = {
                        ...colDef,
                        maxWidth: colSizing.MaxWidth
                    };
                    changed = true;
                }
                // this (width and flex) shouldn't be needed theoretically, as applyColumnState will apply sizing
                // using the newly computed column state
                // but for whatever reason, this is needed here, for some edge cases
                // eg: when a layout has a column width a width and minWidth
                // and then we create a new layout with a different width and different min width
                // then if we don't have this code, the new layout might wrongly apply the previous
                // minWidth as the current column width
                // see #edge-case-min-width-width-mismatch
                if (colSizing.Width !== undefined && colSizing.Width !== colDef.width) colDef = {
                    ...colDef,
                    width: colSizing.Width
                };
                if (colSizing.Flex !== undefined && colSizing.Flex !== colDef.flex) {
                    colDef = {
                        ...colDef,
                        flex: colSizing.Flex
                    };
                    changed = true;
                }
                if (changed) changedColDefs.set(colId, colDef);
            }
        });
        if (changedColDefs.size) return $34e0a646a54b76b6$var$mapColDefs(colDefs, (colDef)=>{
            const changedColDef = changedColDefs.get(colDef.colId);
            if (changedColDef) return changedColDef;
            return colDef;
        });
        return null;
    }
    static getAGGridInitialStateForLayout(layout, colDefs, options) {
        if ((0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(layout)) return $34e0a646a54b76b6$export$4a04ad01c410b415.getAGGridInitialStateForPivotLayout(layout, colDefs);
        return $34e0a646a54b76b6$export$4a04ad01c410b415.getAGGridInitialStateForTableLayout(layout, colDefs, options);
    }
    static getAGGridInitialStateForTableLayout(layout, colDefs, _options) {
        if (!layout.TableColumns) {
            console.error(`TableColumns property is missing in table layout: `, layout);
            console.warn('Setting TableColumns to empty array.');
            layout.TableColumns = [];
        }
        // just in case the enduser provided falsy colIds, it will crash AG Grid internals
        layout.TableColumns = layout.TableColumns.filter((colId)=>colId != undefined);
        layout = (0, $9399b0c19bfb07a7$export$dd21133fd9f15048)(layout, {
            isTree: _options?.isTree ?? false
        });
        const agGridState = {};
        const columnIds = $34e0a646a54b76b6$var$getColumnOrderIdsForAllColDefs(layout.TableColumns, colDefs);
        agGridState.columnOrder = {
            orderedColIds: columnIds
        };
        const flatColDefs = $34e0a646a54b76b6$var$flattenColDefs(colDefs);
        const colDefsById = new Map(flatColDefs.map((colDef)=>[
                colDef.colId ?? colDef.field,
                colDef
            ]));
        const getColDef = (colId)=>colDefsById.get(colId);
        agGridState.columnVisibility = {
            hiddenColIds: flatColDefs.filter((colDef)=>{
                const colId = colDef.colId ?? colDef.field;
                return layout.ColumnVisibility?.[colId] === false || !layout.TableColumns.includes(colId) || colDef.type === 'hiddenColumn' || Array.isArray(colDef.type) && colDef.type.includes('hiddenColumn');
            }).map((colDef)=>colDef.colId ?? colDef.field)
        };
        if (layout.ColumnSizing) {
            const colsInColumnSizingModel = new Set();
            const columnSizingModel = Object.keys(layout.ColumnSizing).map((colId)=>{
                const colSizing = layout.ColumnSizing[colId];
                if (colSizing.Flex != undefined) {
                    colsInColumnSizingModel.add(colId);
                    return {
                        colId: colId,
                        flex: colSizing.Flex
                    };
                }
                if (colSizing.Width != undefined) {
                    colsInColumnSizingModel.add(colId);
                    return {
                        colId: colId,
                        width: colSizing.Width ?? $34e0a646a54b76b6$var$DEFAULT_COLUMN_WIDTH
                    };
                }
            }).filter(Boolean);
            const options = {
                ..._options,
                columnDefs: colDefs
            };
            columnIds.forEach((colId)=>{
                if (!colsInColumnSizingModel.has(colId)) {
                    const colDef = getColDef(colId);
                    const colSizeState = $34e0a646a54b76b6$var$getDefaultColumnSizeStateForColDef(colId, colDef, options);
                    if (colSizeState) columnSizingModel.push(colSizeState);
                }
            });
            agGridState.columnSizing = {
                columnSizingModel: columnSizingModel
            };
        }
        if (layout.ColumnSorts) agGridState.sort = {
            sortModel: layout.ColumnSorts.map((columnSort)=>{
                return {
                    colId: columnSort.ColumnId,
                    sort: columnSort.SortOrder === 'Asc' ? 'asc' : 'desc'
                };
            })
        };
        if (layout.RowGroupedColumns) agGridState.rowGroup = {
            groupColIds: layout.RowGroupedColumns
        };
        if (layout.ColumnPinning) {
            const columnPinning = {
                leftColIds: [],
                rightColIds: []
            };
            Object.keys(layout.ColumnPinning).forEach((colId)=>{
                const pinned = layout.ColumnPinning[colId];
                if (pinned === 'left') columnPinning.leftColIds.push(colId);
                else if (pinned === 'right') columnPinning.rightColIds.push(colId);
            });
            agGridState.columnPinning = columnPinning;
        }
        const TableAggregationColumns = (layout.TableAggregationColumns ?? []).map(({ ColumnId: ColumnId, AggFunc: AggFunc })=>({
                colId: ColumnId,
                aggFunc: AggFunc.aggFunc
            }));
        if (TableAggregationColumns.length) agGridState.aggregation = {
            aggregationModel: TableAggregationColumns.map(({ colId: colId, aggFunc: aggFunc })=>{
                if (aggFunc === true) {
                    const colDef = getColDef(colId);
                    // fallback to SUM if no defaultAggFunc is defined
                    aggFunc = colDef?.defaultAggFunc || $34e0a646a54b76b6$var$DEFAULT_AGG_FUNC;
                }
                return {
                    colId: colId,
                    aggFunc: aggFunc
                };
            })
        };
        return agGridState;
    }
    static getAGGridInitialStateForPivotLayout(layout, colDefs) {
        layout = (0, $9399b0c19bfb07a7$export$ba8b5004731f7e8a)(layout);
        const agGridState = {};
        // const columnIds = getColumnOrderIdsForAllColDefs([], colDefs);
        // agGridState.columnOrder = {
        //   orderedColIds: columnIds,
        // };
        const flatColDefs = $34e0a646a54b76b6$var$flattenColDefs(colDefs);
        const colDefsById = new Map(flatColDefs.map((colDef)=>[
                colDef.colId ?? colDef.field,
                colDef
            ]));
        const getColDef = (colId)=>colDefsById.get(colId);
        // agGridState.columnVisibility = {
        //   hiddenColIds: flatColDefs
        //     .filter((colDef) => {
        //       const colId = colDef.colId ?? colDef.field;
        //       return (
        //         layout.ColumnVisibility?.[colId] === false ||
        //         !layout.OrderedColumns.includes(colId) ||
        //         colDef.hide ||
        //         colDef.initialHide
        //       );
        //     })
        //     .map((colDef) => colDef.colId ?? colDef.field),
        // };
        agGridState.pivot = {
            pivotMode: true,
            pivotColIds: layout.PivotColumns
        };
        if (layout.ColumnSizing) {
            const columnSizingModel = Object.keys(layout.ColumnSizing).map((colId)=>{
                const colSizing = layout.ColumnSizing[colId];
                if (colSizing.Flex != undefined) return {
                    colId: colId,
                    flex: colSizing.Flex
                };
                return {
                    colId: colId,
                    width: colSizing.Width ?? $34e0a646a54b76b6$var$DEFAULT_COLUMN_WIDTH
                };
            }).filter(Boolean);
            agGridState.columnSizing = {
                columnSizingModel: columnSizingModel
            };
        }
        if (layout.ColumnSorts) agGridState.sort = {
            sortModel: layout.ColumnSorts.map((columnSort)=>{
                return {
                    colId: columnSort.ColumnId,
                    sort: columnSort.SortOrder === 'Asc' ? 'asc' : 'desc'
                };
            })
        };
        if (layout.PivotGroupedColumns) agGridState.rowGroup = {
            groupColIds: layout.PivotGroupedColumns
        };
        if (layout.ColumnPinning) {
            const columnPinning = {
                leftColIds: [],
                rightColIds: []
            };
            Object.keys(layout.ColumnPinning).forEach((colId)=>{
                const pinned = layout.ColumnPinning[colId];
                if (pinned === 'left') columnPinning.leftColIds.push(colId);
                else if (pinned === 'right') columnPinning.rightColIds.push(colId);
            });
            agGridState.columnPinning = columnPinning;
        }
        const PivotAggregationColumns = (layout.PivotAggregationColumns || []).map(({ ColumnId: ColumnId, AggFunc: AggFunc })=>{
            const aggFunc = AggFunc.aggFunc;
            return {
                colId: ColumnId,
                aggFunc: aggFunc
            };
        });
        if (PivotAggregationColumns.length) agGridState.aggregation = {
            aggregationModel: PivotAggregationColumns.map(({ colId: colId, aggFunc: aggFunc })=>{
                if (aggFunc === true) {
                    const colDef = getColDef(colId);
                    // fallback to SUM if no defaultAggFunc is defined
                    aggFunc = colDef?.defaultAggFunc || $34e0a646a54b76b6$var$DEFAULT_AGG_FUNC;
                }
                return {
                    colId: colId,
                    aggFunc: aggFunc
                };
            })
        };
        return agGridState;
    }
    silentSetCurrentLayout(layout, options) {
        if (options?.normalize) layout = (0, $9399b0c19bfb07a7$export$36a34ee1a372c2b0)(layout, {
            isTree: this.isTreeMode()
        });
        this.currentLayout = layout;
        // we do this in order to avoid firing the `gridLayoutChanged` event
        // when actually applying the layout
        this._prevFiredLayout = layout;
    }
    setLayout(layout, options) {
        layout = (0, $9399b0c19bfb07a7$export$36a34ee1a372c2b0)(layout, {
            isTree: this.isTreeMode()
        });
        const shouldSkipTriggerChange = options?.skipTriggerChange === true;
        const shouldSkipEqualityCheck = options?.force === true;
        if (!shouldSkipEqualityCheck && (0, $61699e324df75e87$export$2bd574e05880992d)(this.currentLayout, layout)) return false;
        const prevCurrent = this.currentLayout;
        this.silentSetCurrentLayout(layout);
        this.applyLayout(layout, options);
        this.triggerGridLayoutChange(layout, prevCurrent, {
            skipTriggerChange: shouldSkipTriggerChange
        });
        return true;
    }
    isCurrentLayoutPivot() {
        return this.currentLayout && (0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(this.currentLayout);
    }
    suspendAgGridListener() {
        if (this.supressGlobalAgGridEventTimeoutId) {
            clearTimeout(this.supressGlobalAgGridEventTimeoutId);
            this.supressGlobalAgGridEventTimeoutId = null;
        }
        this.suppressGlobalAgGridEventListener = true;
        return ()=>this.resumeAgGridListener();
    }
    resumeAgGridListener(options) {
        if (options?.immediate) {
            this.suppressGlobalAgGridEventListener = false;
            return;
        }
        this.supressGlobalAgGridEventTimeoutId = setTimeout(()=>{
            this.suppressGlobalAgGridEventListener = false;
        }, 0);
    }
    applyLayout(layout, options) {
        this.warn('applyLayout', layout);
        // we want to do this supress/unsupress thing
        // as otherwise, our applyLayout will trigger an onChange event
        // which could trigger another setLayout
        // yes, we do check for same layout and bail out if it is the same
        // but we still want to avoid this unnecessary initial loop
        // which may cause more adaptable work
        const resume = this.suspendAgGridListener();
        const pivotMode = this.isInPivotMode();
        if (!!layout.SuppressAggFuncInHeader !== !!this.gridApi.getGridOption('suppressAggFuncInHeader')) this.gridApi.setGridOption('suppressAggFuncInHeader', !!layout.SuppressAggFuncInHeader);
        if (layout.GrandTotalRow) {
            let grandTotalRow = null;
            if (layout.GrandTotalRow === true) grandTotalRow = 'top';
            else if (typeof layout.GrandTotalRow === 'string') switch(layout.GrandTotalRow){
                case 'top':
                case 'bottom':
                case 'pinnedTop':
                case 'pinnedBottom':
                    grandTotalRow = layout.GrandTotalRow;
                    break;
                default:
                    grandTotalRow = null;
            }
            this.gridApi.setGridOption('grandTotalRow', grandTotalRow);
        } else this.gridApi.setGridOption('grandTotalRow', null);
        this.applyColumnDefsChanges(layout);
        if ((0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(layout)) {
            try {
                const marker = (0, $640f77453ad4a03c$export$cd7dd5b5380f942f)(this.layoutManagerDebugId).track.LayoutManager.label.ApplyPivotLayout.start();
                const perfApplyPivot = this.beginPerf('applyLayout:pivot');
                this.gridApi.setGridOption('pivotMode', true);
                this.applyPivotLayout(layout, options);
                perfApplyPivot.end();
                marker.end({
                    details: this.getLayoutDetailsAsString(layout)
                });
            } finally{
                resume();
            }
            return;
        }
        try {
            const marker = (0, $640f77453ad4a03c$export$cd7dd5b5380f942f)(this.layoutManagerDebugId).track.LayoutManager.label.ApplyTableLayout.start();
            const perfApplyTable = this.beginPerf('applyLayout:table');
            if (pivotMode) this.gridApi.setGridOption('pivotMode', false);
            this.applyTableLayout(layout, options);
            perfApplyTable.end();
            marker.end({
                details: this.getLayoutDetailsAsString(layout)
            });
        } finally{
            resume();
        }
    }
    getLayoutDetailsAsString(layout) {
        return Object.keys(layout).map((key)=>{
            if (key.startsWith('Ignore_')) return null;
            return {
                name: key,
                value: JSON.stringify(layout[key], null, 2)
            };
        }).filter(Boolean);
    }
    applyColumnDefsChanges(layout) {
        return this.applyColumnSizingColumnDefsChanges(layout);
    }
    applyColumnSizingColumnDefsChanges(layout) {
        const newColDefs = $34e0a646a54b76b6$export$4a04ad01c410b415.getColumnDefsChangesForLayout(layout, this.gridApi.getColumnDefs());
        if (newColDefs) {
            this.gridApi.setGridOption('columnDefs', newColDefs);
            return true;
        }
        return false;
    }
    applyTableLayout(layout, options) {
        this.withSuppressColumnAnimation(()=>{
            // if we apply the state here, before calling setGridOption for groupDisplayType
            // the order is not always correctly applied
            // this.gridApi.applyColumnState(state);
            const hasGroupedColumns = layout.RowGroupedColumns && layout.RowGroupedColumns.length;
            if (hasGroupedColumns) {
                const displayTypeFromLayout = layout.RowGroupDisplayType === 'multi' ? 'multipleColumns' : 'singleColumn';
                const groupDisplayType = this.gridApi.getGridOption('groupDisplayType');
                if (groupDisplayType !== displayTypeFromLayout) this.gridApi.setGridOption('groupDisplayType', displayTypeFromLayout);
            }
            // so we apply the state at the end
            this.gridApi.applyColumnState(this.computeColumnStateForTableLayout(layout));
            // but also let's not forget to apply the row group values
            if (hasGroupedColumns && layout.RowGroupValues && !options?.skipApplyRowGroupsExpandedState) this.applyRowGroupValues(layout.RowGroupValues, layout.RowGroupedColumns);
            this.applyColumnGroupCollapseExpandState(layout);
        });
    }
    getRowGroupNodePathsAs(options) {
        const expanded = options.expanded === true;
        const result = [];
        this.gridApi.forEachNode((node)=>{
            if (node.group) {
                const nodeExpanded = !!node.expanded;
                if (expanded === nodeExpanded) {
                    const nodePath = [];
                    let currentNode = node;
                    do {
                        nodePath.unshift(currentNode.key);
                        currentNode = currentNode.parent;
                    }while (currentNode.parent);
                    result.push(nodePath);
                }
            }
        });
        return result;
    }
    applyRowGroupValues(RowGroupValues, rowGroupedColumns) {
        if (!RowGroupValues) return;
        if (RowGroupValues.RowGroupDisplay === 'always-expanded') {
            this.gridApi.expandAll();
            return;
        }
        if (RowGroupValues.RowGroupDisplay === 'always-collapsed') {
            this.gridApi.collapseAll();
            return;
        }
        const defaultExpanded = RowGroupValues.RowGroupDisplay === 'expanded';
        let currentRowGroupedValues = RowGroupValues.Values;
        if (RowGroupValues.GroupKeys) {
            const matchingRowGroupColumnValues = RowGroupValues.GroupKeys.find((item)=>{
                return (item.RowGroupedColumns || []).join(',') === (rowGroupedColumns || []).join(',');
            });
            if (matchingRowGroupColumnValues) currentRowGroupedValues = matchingRowGroupColumnValues.Values;
            else currentRowGroupedValues = [];
        }
        if (currentRowGroupedValues) {
            const deepMap = new (0, $88ab1a78ec8ca4b4$export$1c737028a0cb2e00)();
            currentRowGroupedValues.forEach((rowGroupValue)=>{
                deepMap.set(rowGroupValue, true);
            });
            this.gridApi.forEachNode((node)=>{
                if (!node.group) return;
                if (node.group) {
                    const nodePath = [];
                    let currentNode = node;
                    do {
                        nodePath.unshift(currentNode.key);
                        currentNode = currentNode.parent;
                    }while (currentNode.parent);
                    const shouldBeExpanded = defaultExpanded ? // but this node should be expanded if it is not in the map
                    !deepMap.has(nodePath) : // but this node should be expanded if it is in the map
                    deepMap.has(nodePath);
                    node.expanded = shouldBeExpanded;
                }
            });
            this.gridApi.onGroupExpandedOrCollapsed();
        }
    }
    computeColumnStateForPivotLayout(layout) {
        const columnState = {};
        const pivotColumnsToIndexes = (layout.PivotColumns || []).reduce((acc, colId, index)=>{
            acc[colId] = index;
            return acc;
        }, {});
        const rowGroupColumnIndexes = (layout.PivotGroupedColumns || []).reduce((acc, colId, index)=>{
            acc[colId] = index;
            return acc;
        }, {});
        // having this set to true will change pivot column order when there is sorting
        // and we don't want that to happen #keep-sorted-columns-in-same-order-as-unsorted
        // columnState.applyOrder = true;
        const columnIds = $34e0a646a54b76b6$var$getColumnOrderIdsForAllColDefs([
            ...layout.PivotColumns,
            ...(layout.PivotAggregationColumns || []).map((col)=>col.ColumnId)
        ], this.gridApi.getColumnDefs());
        columnState.state = columnIds.map((columnId)=>{
            const pivotIndex = pivotColumnsToIndexes[columnId];
            const rowGroupIndex = rowGroupColumnIndexes[columnId];
            return {
                colId: columnId,
                pivot: pivotIndex != undefined,
                pivotIndex: pivotIndex ?? null,
                rowGroupIndex: rowGroupIndex ?? null,
                rowGroup: rowGroupIndex != null
            };
        });
        this.computeColumnSizing(layout, columnState);
        this.computeColumnSorts(layout, columnState);
        this.computePinnedColumns(layout, columnState);
        this.computePivotAggregations(layout, columnState);
        // Add pivot result columns to the state for ordering (will be applied with applyOrder: true later)
        if (Array.isArray(layout.PivotResultColumnsOrder)) layout.PivotResultColumnsOrder.forEach((colId)=>{
            columnState.state.push({
                colId: colId
            });
        });
        return columnState;
    }
    computePivotAggregations(layout, columnState) {
        const PivotAggregationColumns = layout.PivotAggregationColumns || [];
        const pivotAggsToIndexes = PivotAggregationColumns.reduce((acc, { ColumnId: ColumnId }, index)=>{
            acc[ColumnId] = index;
            return acc;
        }, {});
        columnState.state = columnState.state.map((colState)=>{
            const columnId = colState.colId;
            const aggIndex = pivotAggsToIndexes[columnId];
            const aggFunc = aggIndex != null ? PivotAggregationColumns[aggIndex].AggFunc.aggFunc : null;
            return {
                ...colState,
                aggFunc: aggIndex != null ? aggFunc === true ? $34e0a646a54b76b6$var$DEFAULT_AGG_FUNC : aggFunc : null
            };
        });
    }
    computeColumnStateForTableLayout(layout) {
        const columnState = {};
        this.computeColumnOrderAndVisibility(layout, columnState);
        this.computeColumnSizing(layout, columnState);
        this.computeColumnSorts(layout, columnState);
        this.computeRowGrouping(layout, columnState);
        this.computeAggregations(layout, columnState);
        this.computePinnedColumns(layout, columnState);
        return columnState;
    }
    computePinnedColumns(layout, columnState) {
        const pinnedColumns = layout.ColumnPinning;
        if (!pinnedColumns || !Object.keys(pinnedColumns).length) {
            columnState.state.forEach((colState)=>{
                colState.pinned = null;
            });
            return;
        }
        columnState.state.forEach((colState)=>{
            const pinnedSide = pinnedColumns[colState.colId];
            if (pinnedSide) colState.pinned = pinnedSide;
            else colState.pinned = null;
        });
    }
    computeAggregations(layout, columnState) {
        const aggregations = layout.TableAggregationColumns;
        if (!aggregations || !aggregations.length) {
            columnState.state.forEach((colState)=>{
                colState.aggFunc = null;
            });
            return;
        }
        const aggsMap = new Map(aggregations.map((agg)=>[
                agg.ColumnId,
                agg
            ]));
        columnState.state.forEach((colState)=>{
            const agg = aggsMap.get(colState.colId)?.AggFunc;
            if (agg) colState.aggFunc = agg.aggFunc === true ? 'sum' : agg.aggFunc;
            else colState.aggFunc = null;
        });
    }
    computeRowGrouping(layout, columnState) {
        const rowGroupedColumns = layout.RowGroupedColumns || [];
        if (!rowGroupedColumns.length) {
            columnState.state.forEach((colState)=>{
                colState.rowGroupIndex = null;
                colState.rowGroup = false;
            });
            return;
        }
        const rowGroupsToIndexes = rowGroupedColumns.reduce((acc, colId, index)=>{
            acc[colId] = index;
            return acc;
        }, {});
        columnState.state.forEach((colState)=>{
            if (rowGroupsToIndexes[colState.colId] != undefined) colState.rowGroupIndex = rowGroupsToIndexes[colState.colId];
            else {
                colState.rowGroupIndex = null;
                colState.rowGroup = false;
            }
        });
    }
    computeColumnSorts(layout, columnState) {
        const sorts = layout.ColumnSorts || [];
        if (!sorts.length) {
            columnState.state.forEach((colState)=>{
                colState.sort = null;
                colState.sortIndex = null;
            });
            return;
        }
        const sortsToIndexes = sorts.reduce((acc, sort, index)=>{
            acc[sort.ColumnId] = index;
            return acc;
        }, {});
        columnState.state.forEach((colState)=>{
            const colSortIndex = sortsToIndexes[colState.colId];
            // we delete them just to know if there are any left
            // after the forEach is done
            delete sortsToIndexes[colState.colId];
            const colSort = sorts[colSortIndex];
            if (colSort != undefined) {
                colState.sort = colSort.SortOrder === 'Asc' ? 'asc' : 'desc';
                colState.sortIndex = colSortIndex;
            } else {
                colState.sort = null;
                colState.sortIndex = null;
            }
        });
        if (Object.keys(sortsToIndexes).length) // if there are some sorts left which were not applied to the columnState
        // probably those are for pivot result columns, so we need to apply them as well
        Object.keys(sortsToIndexes).forEach((colId)=>{
            const colSortIndex = sortsToIndexes[colId];
            const colSort = sorts[colSortIndex];
            if (colSort != undefined) columnState.state.push({
                colId: colId,
                sort: colSort.SortOrder === 'Asc' ? 'asc' : 'desc',
                sortIndex: colSortIndex
            });
        });
    }
    getDefaultColumnWidthForCol(colId, colDef) {
        colDef = colDef ?? this.gridApi.getColumnDef(colId);
        return colDef?.width ?? $34e0a646a54b76b6$var$DEFAULT_COLUMN_WIDTH;
    }
    computeColumnSizing(layout, columnState) {
        const ColumnSizing = layout.ColumnSizing || {};
        const colDefs = this.gridApi.getColumnDefs();
        const options = {
            columnDefs: colDefs,
            colTypes: this.gridApi.getGridOption('columnTypes'),
            defaultColDef: this.gridApi.getGridOption('defaultColDef')
        };
        columnState.state.forEach((colState)=>{
            const colSizing = ColumnSizing[colState.colId];
            if (colSizing) {
                if (colSizing.Width != undefined) colState.width = colSizing.Width;
                else if (colSizing.Flex != undefined) colState.flex = colSizing.Flex;
            } else {
                let defaultColState;
                if (!colState.flex) {
                    defaultColState = $34e0a646a54b76b6$var$getDefaultColumnSizeStateForColDef(colState.colId, undefined, options);
                    if (defaultColState?.flex) colState.flex = defaultColState.flex;
                }
                if (!colState.flex) colState.width = colState.width ?? defaultColState?.width ?? this.getDefaultColumnWidthForCol(colState.colId);
            }
        });
    }
    computeColumnOrderAndVisibility(layout, columnState) {
        const visibility = layout.ColumnVisibility || {};
        const columnOrderSet = new Set(layout.TableColumns);
        const isColHidden = (colId)=>visibility[colId] === false || !columnOrderSet.has(colId);
        columnState = columnState ?? {};
        columnState.applyOrder = true;
        const columnIds = $34e0a646a54b76b6$var$getColumnOrderIdsForAllColDefs(layout.TableColumns, this.gridApi.getColumnDefs());
        columnState.state = columnIds.map((columnId)=>{
            return {
                colId: columnId,
                hide: isColHidden(columnId),
                pivot: false,
                // @ts-ignore
                pivotIndex: null
            };
        });
        return columnState;
    }
    autoSizeColumns(columnIds) {
        const { currentLayout: currentLayout } = this;
        let tableColumns = [];
        if (currentLayout) {
            tableColumns = currentLayout.TableColumns;
            if (currentLayout.ColumnVisibility) // dont auto size hidden columns
            tableColumns = tableColumns.filter((colId)=>!currentLayout.ColumnVisibility[colId]);
            if (currentLayout.ColumnSizing) // dont auto size columns with a set sizing
            tableColumns = tableColumns.filter((colId)=>!currentLayout.ColumnSizing[colId]);
        }
        columnIds = columnIds ?? tableColumns;
        if (!columnIds.length) return false;
        this.gridApi.autoSizeColumns(columnIds);
        return columnIds;
    }
    applyPivotLayout(layout, options) {
        this.withSuppressColumnAnimation(()=>{
            this.applyPivotTotals(layout);
            const hasGroupedColumns = layout.PivotGroupedColumns && !!layout.PivotGroupedColumns.length;
            if (hasGroupedColumns) {
                const displayTypeFromLayout = layout.RowGroupDisplayType === 'multi' ? 'multipleColumns' : 'singleColumn';
                const groupDisplayType = this.gridApi.getGridOption('groupDisplayType');
                if (groupDisplayType !== displayTypeFromLayout) this.gridApi.setGridOption('groupDisplayType', displayTypeFromLayout);
            }
            const columnState = this.computeColumnStateForPivotLayout(layout);
            // by simply calling this.gridApi.applyColumnState(columnState)
            // the order of aggregations is not preserved/guaranteed by ag-grid
            // so we want to apply multiple states - adding aggregations one by one
            // first: no aggregation
            // second: [agg[0]]
            // third: [agg[0], agg[1]]
            // fourth: ...etc
            // so we apply the states for all aggregations except the last one
            //
            const aggregationsMapForOrder = (layout.PivotAggregationColumns || []).map((_, index)=>layout.PivotAggregationColumns.slice(0, index));
            aggregationsMapForOrder.forEach((agg)=>{
                // we're mutating the columnState here
                this.computePivotAggregations({
                    ...layout,
                    PivotAggregationColumns: agg
                }, columnState);
                // and apply the state
                this.gridApi.applyColumnState(columnState);
            });
            // now recompute and apply the last one
            this.computePivotAggregations(layout, columnState);
            // Apply order only on the final call when PivotResultColumns is specified
            if (Array.isArray(layout.PivotResultColumnsOrder)) columnState.applyOrder = true;
            this.gridApi.applyColumnState(columnState);
            // let's also include the column widths of the pivotResult columns
            // we can't simply include those in the columnState because the columnState will also apply order
            // but we don't want to affect the order of the pivotResult columns
            // so we'll do it manually, and apply the widths after the columnState
            // by using the gridApi.setColumnWidths method
            if (layout.ColumnSizing) {
                const colWidthForPivotResultColumns = [];
                (this.gridApi.getPivotResultColumns() || []).forEach((col)=>{
                    const colId = col.getColId();
                    if (layout.ColumnSizing[colId]?.Width != undefined) colWidthForPivotResultColumns.push({
                        key: colId,
                        newWidth: layout.ColumnSizing[colId].Width ?? $34e0a646a54b76b6$var$DEFAULT_COLUMN_WIDTH
                    });
                });
                if (colWidthForPivotResultColumns.length) this.gridApi.setColumnWidths(colWidthForPivotResultColumns);
            }
            this.applyColumnGroupCollapseExpandState(layout);
            // but also let's not forget to apply the row group values
            if (hasGroupedColumns && layout.RowGroupValues && !options?.skipApplyRowGroupsExpandedState) this.applyRowGroupValues(layout.RowGroupValues, layout.PivotGroupedColumns);
        });
    }
    applyPivotTotals(layout) {
        /**
         * GrandTotalRow
         */ // is common to both Table and Pivot and is applied in applyLayout()
        /**
         * PivotGrandTotal
         */ if (layout.PivotGrandTotal) {
            const pivotGrandTotal = layout.PivotGrandTotal === true || layout.PivotGrandTotal === 'before' ? 'before' : layout.PivotGrandTotal === 'after' ? 'after' : null;
            this.gridApi.setGridOption('pivotRowTotals', pivotGrandTotal);
        } else this.gridApi.setGridOption('pivotRowTotals', null);
        /**
         * PivotColumnTotal
         */ if (layout.PivotColumnTotal) {
            const pivotColumnTotal = layout.PivotColumnTotal === true || layout.PivotColumnTotal === 'before' ? 'before' : layout.PivotColumnTotal === 'after' ? 'after' : null;
            this.gridApi.setGridOption('pivotColumnGroupTotals', pivotColumnTotal);
        } else this.gridApi.setGridOption('pivotColumnGroupTotals', null);
    }
    applyColumnGroupCollapseExpandState(layout) {
        const IsPivotLayout = (0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(layout);
        const allDisplayedColumnGroups = this.gridApi.getAllDisplayedColumnGroups();
        let PivotExpandLevel = layout.PivotExpandLevel;
        const ColumnGroupValues = layout.ColumnGroupValues;
        if (IsPivotLayout && !ColumnGroupValues && PivotExpandLevel === undefined) PivotExpandLevel = -1;
        const colGroupDefs = allDisplayedColumnGroups.map((colGroup)=>colGroup.getDefinition())// we need to filter because there are some fake groups as well, no idea what for
        .filter(Boolean);
        const colGroupState = [];
        const columnGroupExceptions = ColumnGroupValues?.ColumnGroupDisplay === 'collapsed' || ColumnGroupValues?.ColumnGroupDisplay === 'expanded' ? new Set(ColumnGroupValues.Values) : new Set();
        const processColGroupDefs = (colGroupDefs, currentLevel)=>{
            colGroupDefs.forEach((colGroupDef)=>{
                if ('children' in colGroupDef && colGroupDef.children) {
                    let open;
                    if (IsPivotLayout && !ColumnGroupValues) open = PivotExpandLevel === -1 ? true : colGroupDef.pivotKeys?.length <= PivotExpandLevel;
                    if (ColumnGroupValues) {
                        if (ColumnGroupValues.ColumnGroupDisplay === 'always-expanded') open = true;
                        else if (ColumnGroupValues.ColumnGroupDisplay === 'always-collapsed') open = false;
                        else if (ColumnGroupValues.ColumnGroupDisplay === 'expanded') open = !columnGroupExceptions.has(colGroupDef.groupId);
                        else if (ColumnGroupValues.ColumnGroupDisplay === 'collapsed') open = columnGroupExceptions.has(colGroupDef.groupId);
                    }
                    colGroupState.push({
                        groupId: colGroupDef.groupId,
                        open: open
                    });
                    processColGroupDefs(colGroupDef.children, currentLevel + 1);
                }
            });
        };
        processColGroupDefs(colGroupDefs, 1);
        if (colGroupState.length > 0) this.gridApi.setColumnGroupState(colGroupState);
    }
    withSuppressColumnAnimation(fn) {
        const suppressColumnMoveAnimation = this.gridApi.getGridOption('suppressColumnMoveAnimation');
        if (!suppressColumnMoveAnimation) this.gridApi.setGridOption('suppressColumnMoveAnimation', true);
        const res = fn();
        if (!suppressColumnMoveAnimation) this.gridApi.setGridOption('suppressColumnMoveAnimation', false);
        return res;
    }
    withSuppressRowAnimation(fn) {
        const animateRows = this.gridApi.getGridOption('animateRows');
        if (animateRows) this.gridApi.setGridOption('animateRows', false);
        const res = fn();
        if (animateRows) this.gridApi.setGridOption('animateRows', true);
        return res;
    }
    /**
     * Refreshes the sort order by refreshing the client side row model.
     * This is useful when custom sort comparers are defined and the sort needs to be re-applied after filtering.
     */ refreshSort() {
        this.withSuppressRowAnimation(()=>{
            this.gridApi.refreshClientSideRowModel('sort');
        });
    }
    patchColDefType(colDef, colTypes) {
        const originalTypes = colDef.type == undefined ? [] : Array.isArray(colDef.type) ? colDef.type : [
            colDef.type
        ];
        const columnTypes = new Set(originalTypes);
        colTypes.forEach((colType)=>{
            columnTypes.add(colType);
        });
        colDef.type = Array.from(columnTypes);
    }
    setupPivotTotals() {
        const _original_processPivotResultColDef = this.gridApi.getGridOption('processPivotResultColDef');
        this.gridApi.setGridOption('processPivotResultColDef', (colDef)=>{
            _original_processPivotResultColDef?.(colDef);
            if (!(0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(this.currentLayout)) return;
            if ((0, $4de552a4ad6e0c97$export$5bd0e023a792f54b)(colDef)) this.patchColDefType(colDef, [
                $34e0a646a54b76b6$export$f5db7d5592212d77,
                $34e0a646a54b76b6$export$317c4ed011433b68
            ]);
            if ((0, $1d01f71c6f4ca9d9$export$e8f3ce9d27d3bb8f)(colDef.colId)) this.patchColDefType(colDef, [
                $34e0a646a54b76b6$export$f5db7d5592212d77,
                $34e0a646a54b76b6$export$445f227fdcc241e3
            ]);
        });
        const _original_processPivotResultColGroupDef = this.gridApi.getGridOption('processPivotResultColGroupDef');
        this.gridApi.setGridOption('processPivotResultColGroupDef', (colGroupDef)=>{
            _original_processPivotResultColGroupDef?.(colGroupDef);
            if (!(0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(this.currentLayout)) return;
            this.patchPivotAggregationTotal(colGroupDef);
        });
    }
    patchPivotAggregationTotal(colGroupDef) {
        const hasPivotAggTotals = (pivotLayout)=>{
            return pivotLayout.PivotAggregationColumns?.some((aggCol)=>!!aggCol.Total);
        };
        if (!(0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(this.currentLayout) || !hasPivotAggTotals(this.currentLayout)) return;
        const pivotGrandTotalsBefore = [];
        const pivotGrandTotalsAfter = [];
        const pivotAggTotalsBefore = [];
        const pivotAggTotalsAfter = [];
        const normalColDefs = [];
        colGroupDef.children.forEach((colDef)=>{
            if ((0, $4de552a4ad6e0c97$export$5bd0e023a792f54b)(colDef)) {
                if (this.gridApi.getGridOption('pivotRowTotals') === 'after') pivotGrandTotalsAfter.push(colDef);
                else pivotGrandTotalsBefore.push(colDef);
                return;
            }
            if ((0, $abd79289c75d3093$export$605b4a9c6ba8ba9a)(colDef)) {
                if (!colDef.colId.startsWith('pivot_')) {
                    this.warn(`Pivot total column ${colDef.colId} is not prefixed with 'pivot_', skipping...`);
                    return;
                }
                this.patchColDefType(colDef, [
                    $34e0a646a54b76b6$export$f5db7d5592212d77,
                    $34e0a646a54b76b6$export$57ab19c32215f85f
                ]);
                // we do this for all total cols, but we will hide the ones that are not visible
                colDef.columnGroupShow = undefined;
                const totalColConfig = this.getPivotTotalColumnConfig(colDef, this.currentLayout);
                if (!totalColConfig.visible) colDef.hide = true;
                else if (totalColConfig.position === 'after') pivotAggTotalsAfter.push(colDef);
                else pivotAggTotalsBefore.push(colDef);
            } else normalColDefs.push(colDef);
        });
        colGroupDef.children = [
            ...pivotGrandTotalsBefore,
            ...pivotAggTotalsBefore,
            ...normalColDefs,
            ...pivotAggTotalsAfter,
            ...pivotGrandTotalsAfter
        ];
    }
    getPivotTotalColumnConfig(colDef, currentPivotLayout) {
        const defaultHiddenConfig = {
            visible: false
        };
        const colIdInfo = (0, $cd4621bade181468$export$152454e54408b5ae)(colDef, {
            pivotColIds: this.currentLayout.PivotColumns,
            aggColIds: (this.currentLayout.PivotAggregationColumns || []).map((col)=>col.ColumnId)
        }, (message)=>this.warn(message));
        if (colIdInfo === '!unknown!') return defaultHiddenConfig;
        const { pivotColumnId: pivotColumnId, aggregationColumnId: aggregationColumnId } = colIdInfo;
        const layoutAggCol = currentPivotLayout.PivotAggregationColumns?.find((col)=>col.ColumnId === aggregationColumnId);
        if (!layoutAggCol) {
            this.warn(`Pivot Totals: could NOT find aggregation(value) column with id ${aggregationColumnId}`);
            return defaultHiddenConfig;
        }
        const layoutPivotTotalColumn = layoutAggCol.Total;
        if (!layoutPivotTotalColumn) return defaultHiddenConfig;
        if (Array.isArray(layoutPivotTotalColumn)) {
            const pivotSpecificConfig = layoutPivotTotalColumn.find((config)=>config.PivotColumnId === pivotColumnId);
            return {
                visible: pivotSpecificConfig && pivotSpecificConfig.ShowTotal !== false,
                position: pivotSpecificConfig?.ShowTotal === 'after' ? 'after' : 'before'
            };
        } else return {
            visible: !!layoutPivotTotalColumn,
            position: layoutPivotTotalColumn === 'after' ? 'after' : 'before'
        };
    }
    isInPivotMode() {
        // SSRM comes with its own pivot module implementation
        // see #ssrm_pivot_module
        const isModuleRegistered = this.gridApi.isModuleRegistered('PivotModule') || this.gridApi.isModuleRegistered('ServerSideRowModelModule');
        return isModuleRegistered && this.gridApi.isPivotMode();
    }
}


const $b0d14b794bdca4f2$export$24fbfbd19a58a666 = 'hiddenColumn';
const $b0d14b794bdca4f2$export$95c5db576df1e7e6 = {
    initialHide: true,
    hide: true,
    lockVisible: true,
    suppressColumnsToolPanel: true
};
const $b0d14b794bdca4f2$export$8e5ee678cfc318c5 = 'calculatedColumn';
const $b0d14b794bdca4f2$export$2460c0dec1fc4d43 = 'freeTextColumn';
const $b0d14b794bdca4f2$export$bc60d51b21bb9885 = 'actionColumn';
const $b0d14b794bdca4f2$export$aee5eaf013923665 = 'fdc3Column';
const $b0d14b794bdca4f2$export$afddfaff376a8546 = (0, $34e0a646a54b76b6$export$f5db7d5592212d77);
const $b0d14b794bdca4f2$export$f744fcf34ea00f2c = (0, $34e0a646a54b76b6$export$317c4ed011433b68);
const $b0d14b794bdca4f2$export$9a588f369e2c5bd7 = (0, $34e0a646a54b76b6$export$445f227fdcc241e3);
const $b0d14b794bdca4f2$export$77dcda55adab6007 = (0, $34e0a646a54b76b6$export$57ab19c32215f85f);
function $b0d14b794bdca4f2$export$8c479b03614a2754(columnType) {
    switch(columnType){
        case $b0d14b794bdca4f2$export$8e5ee678cfc318c5:
            return 'Calculated Column';
        case $b0d14b794bdca4f2$export$2460c0dec1fc4d43:
            return 'Free Text Column';
        case $b0d14b794bdca4f2$export$bc60d51b21bb9885:
            return 'Action Column';
        case $b0d14b794bdca4f2$export$aee5eaf013923665:
            return 'FDC3 Column';
        case $b0d14b794bdca4f2$export$afddfaff376a8546:
            return 'Pivot Total (any total type)';
        case $b0d14b794bdca4f2$export$f744fcf34ea00f2c:
            return 'Pivot Grand Total';
        case $b0d14b794bdca4f2$export$9a588f369e2c5bd7:
            return 'Pivot Column Total';
        case $b0d14b794bdca4f2$export$77dcda55adab6007:
            return 'Pivot Aggregation Total';
        default:
            return columnType;
    }
}
const $b0d14b794bdca4f2$export$29b8313004691c1e = ({ oldColumns: oldColumns, newColumns: newColumns })=>{
    const getGroups = (columns)=>{
        let prevGroup = '';
        let count = 0;
        columns.forEach((column)=>{
            if (column && column.columnGroup && column.columnGroup.groupCount > 1 && !column.columnGroup.allowGroupSplit) {
                if (prevGroup !== column.columnGroup.columnGroupId) count++;
            }
            prevGroup = column?.columnGroup?.columnGroupId ?? '';
        });
        return count;
    };
    if (getGroups(oldColumns) != getGroups(newColumns)) return false;
    return true;
};





var $9g4SS = parcelRequire("9g4SS");

const $66ac1c1926a7c094$export$3811ce2dd9855f1 = 'textArray';
const $66ac1c1926a7c094$export$cb8d66df0041d6ee = 'numberArray';
const $66ac1c1926a7c094$export$f91839d355e47aad = 'tupleArray';
const $66ac1c1926a7c094$export$3ca3fd143cf67276 = 'objectArray';
const $66ac1c1926a7c094$export$a57edebad87b3bdd = [
    'text',
    'number',
    'boolean',
    'date',
    'object',
    $66ac1c1926a7c094$export$3811ce2dd9855f1,
    $66ac1c1926a7c094$export$cb8d66df0041d6ee,
    $66ac1c1926a7c094$export$f91839d355e47aad,
    $66ac1c1926a7c094$export$3ca3fd143cf67276,
    'unknown'
];
const $66ac1c1926a7c094$export$4b0da9e77110f922 = {
    // AG Grid default types
    number: {
        baseDataType: 'number',
        extendsDataType: 'number',
        // suppress AG Grid editor, we provide our own
        suppressDefaultProperties: true
    },
    date: {
        baseDataType: 'date',
        extendsDataType: 'date',
        valueParser: null,
        valueFormatter: null,
        suppressDefaultProperties: true
    },
    // dateString is force-cast to date in AdapTable, see #data_type_dateString
    // text: is kept as is
    // boolean: is kept as is
    // object: is kept as is
    // Adaptable specific types
    [$66ac1c1926a7c094$export$3811ce2dd9855f1]: {
        baseDataType: 'text',
        extendsDataType: 'text',
        dataTypeMatcher: (value)=>{
            return Array.isArray(value) && value.every((v)=>typeof v === 'string');
        }
    },
    [$66ac1c1926a7c094$export$cb8d66df0041d6ee]: {
        baseDataType: 'number',
        extendsDataType: 'number',
        dataTypeMatcher: (value)=>{
            return Array.isArray(value) && value.every((v)=>typeof v === 'number');
        }
    },
    [$66ac1c1926a7c094$export$f91839d355e47aad]: {
        baseDataType: 'object',
        extendsDataType: 'object',
        dataTypeMatcher: (value)=>{
            return Array.isArray(value) && value.every((v)=>Array.isArray(v));
        }
    },
    [$66ac1c1926a7c094$export$3ca3fd143cf67276]: {
        baseDataType: 'object',
        extendsDataType: 'object',
        dataTypeMatcher: (value)=>{
            return Array.isArray(value) && value.every((v)=>typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length >= 2);
        }
    }
};




class $0805c8271aca8a4c$export$4e7c329e089d8cc5 {
    _adaptable;
    /**
     * Constructor for all the api classes which simply takes and assigns an instance of Adaptable
     * @param _adaptable core IAdaptable object - for INTERNAL USE ONLY and not part of public API
     */ constructor(_adaptable){
        this._adaptable = _adaptable;
    }
    getAdatableLogger() {
        return this._adaptable.logger;
    }
    logInfo(message, ...optionalParams) {
        this._adaptable.logger.info(message, ...optionalParams);
    }
    logSuccess(message, ...optionalParams) {
        this._adaptable.logger.success(message, ...optionalParams);
    }
    logWarn(message, ...optionalParams) {
        this._adaptable.logger.warn(message, ...optionalParams);
    }
    logError(message, ...optionalParams) {
        this._adaptable.logger.error(message, ...optionalParams);
    }
    getAdaptableVariant() {
        return this._adaptable.variant;
    }
    isAdapTableReady() {
        return this._adaptable.isReady;
    }
    /**
     * Base api helper method which ensure that Adaptable Object being used in the function is not null or undefined
     *
     * If it does not exist then we log an error and the api method should stop
     * @param item AdaptableObject being checked
     * @param name the name of the object if it has one (e.g. if its a search)
     * @param type the actual type of the object being checked
     */ checkItemExists(item, name, type) {
        if ((0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).objectNotExists(item)) {
            this.logError(`No ${type} found with the name: ${name}`);
            return false;
        }
        return true;
    }
    checkArrayExists(array) {
        if (!Array.isArray(array)) {
            this.logError(`Item passed to Api function was not an array`);
            return false;
        }
        return true;
    }
    handleLayoutExtensionObjects(objectList = [], module, config) {
        if (config?.includeLayoutNotExtendedObjects) return objectList;
        const extendedLayout = config?.extendedLayoutName ? this.getLayoutApi().getLayoutByName(config.extendedLayoutName) : this.getLayoutApi().getCurrentLayout();
        return objectList.filter((objectItem)=>this.getLayoutApi().internalApi.isObjectExtendedInLayout(objectItem, module, extendedLayout));
    }
    /**
     * Base api Helper method that dispatches a *Redux Action* to the Store
     * @param action the Redux Action to be dispatched
     */ dispatchAction(action) {
        if (this._adaptable.isDestroyed) return;
        this._adaptable.adaptableStore.TheStore.dispatch(action);
    }
    /**
     * Returns the entire State from the Store
     *
     * This is a simple *getState()* call
     */ getAdaptableState() {
        return this.getAdaptableStore().TheStore.getState();
    }
    getAdaptableStore() {
        return this._adaptable.adaptableStore;
    }
    // Add the Uuid to the object if not present;
    // It's generally done in Redux also but no harm checking in Api also in case we missed it.
    addUidToAdaptableObject(adaptableObject) {
        if (!adaptableObject.Uuid) adaptableObject.Uuid = (0, $d7790b1d1a829cfc$export$10a020066a0f444a)();
    }
    getModuleInfoByModuleId(module) {
        return this._adaptable.ModuleService.getModuleInfoByModule(module);
    }
    showModulePopup(module, moduleParams) {
        let moduleInfo = this.getModuleInfoByModuleId(module);
        if (moduleInfo) this._adaptable.api.internalApi.showPopupScreen(moduleInfo.ModuleName, moduleInfo.Popup, moduleParams);
    }
    getOptions() {
        return this._adaptable.adaptableOptions;
    }
    getActionColumnOptions() {
        return this.getOptions().actionColumnOptions;
    }
    getRowFormOptions() {
        return this.getOptions().rowFormOptions;
    }
    getColumnOptions() {
        return this.getOptions().columnOptions;
    }
    getCommentOptions() {
        return this.getOptions().commentOptions;
    }
    getNoteOptions() {
        return this.getOptions().noteOptions;
    }
    getCustomSortOptions() {
        return this.getOptions().customSortOptions;
    }
    getDataSetOptions() {
        return this.getOptions().dataSetOptions;
    }
    getCalendarOptions() {
        return this.getOptions().calendarOptions;
    }
    getCellSummaryOptions() {
        return this.getOptions().cellSummaryOptions;
    }
    getContainerOptions() {
        return this.getOptions().containerOptions;
    }
    getNotificationsOptions() {
        return this.getOptions().notificationsOptions;
    }
    getAlertOptions() {
        return this.getOptions().alertOptions;
    }
    getDashboardOptions() {
        return this.getOptions().dashboardOptions;
    }
    getEditOptions() {
        return this.getOptions().editOptions;
    }
    getExportOptions() {
        return this.getOptions().exportOptions;
    }
    getLayoutOptions() {
        return this.getOptions().layoutOptions;
    }
    getColumnMenuOptions() {
        return this.getOptions().columnMenuOptions;
    }
    getContextMenuOptions() {
        return this.getOptions().contextMenuOptions;
    }
    getFilterOptions() {
        return this.getOptions().filterOptions;
    }
    getExpressionOptions() {
        return this.getOptions().expressionOptions;
    }
    getPredicateOptions() {
        return this.getOptions().predicateOptions;
    }
    getQuickSearchOptions() {
        return this.getOptions().quickSearchOptions;
    }
    getFormatColumnOptions() {
        return this.getOptions().formatColumnOptions;
    }
    getStateOptions() {
        return this.getOptions().stateOptions;
    }
    getTeamSharingOptions() {
        return this.getOptions().teamSharingOptions;
    }
    getUserInterfaceOptions() {
        return this.getOptions().userInterfaceOptions;
    }
    getToolPanelOptions() {
        return this.getOptions().toolPanelOptions;
    }
    getChartingOptions() {
        return this.getOptions().chartingOptions;
    }
    getDataChangeHistoryOptions() {
        return this.getOptions().dataChangeHistoryOptions;
    }
    getEntitlementOptions() {
        return this.getOptions().entitlementOptions;
    }
    getFlashingCellOptions() {
        return this.getOptions().flashingCellOptions;
    }
    getSettingsPanelOptions() {
        return this.getOptions().settingsPanelOptions;
    }
    getFdc3Options() {
        return this.getOptions().fdc3Options;
    }
    getAdaptableApi() {
        return this._adaptable.api;
    }
    getAgGridApi() {
        return this.getAdaptableApi().agGridApi;
    }
    getAdaptableInternalApi() {
        return this.getAdaptableApi().internalApi;
    }
    getActionColumnApi() {
        return this.getAdaptableApi().actionColumnApi;
    }
    getApplicationApi() {
        return this.getAdaptableApi().applicationApi;
    }
    getAlertApi() {
        return this.getAdaptableApi().alertApi;
    }
    getFlashingCellApi() {
        return this.getAdaptableApi().flashingCellApi;
    }
    getPredicateApi() {
        return this.getAdaptableApi().predicateApi;
    }
    getBulkUpdateApi() {
        return this.getAdaptableApi().bulkUpdateApi;
    }
    getCalendarApi() {
        return this.getAdaptableApi().calendarApi;
    }
    getCalculatedColumnApi() {
        return this.getAdaptableApi().calculatedColumnApi;
    }
    getCellSummaryApi() {
        return this.getAdaptableApi().cellSummaryApi;
    }
    getColumnApi() {
        return this.getAdaptableApi().columnApi;
    }
    getStateApi() {
        return this.getAdaptableApi().stateApi;
    }
    getCustomSortApi() {
        return this.getAdaptableApi().customSortApi;
    }
    getDashboardApi() {
        return this.getAdaptableApi().dashboardApi;
    }
    getDataSetApi() {
        return this.getAdaptableApi().dataSetApi;
    }
    getEntitlementApi() {
        return this.getAdaptableApi().entitlementApi;
    }
    getEventApi() {
        return this.getAdaptableApi().eventApi;
    }
    getExportApi() {
        return this.getAdaptableApi().exportApi;
    }
    getFormatColumnApi() {
        return this.getAdaptableApi().formatColumnApi;
    }
    getFreeTextColumnApi() {
        return this.getAdaptableApi().freeTextColumnApi;
    }
    getGridApi() {
        return this.getAdaptableApi().gridApi;
    }
    getLayoutApi() {
        return this.getAdaptableApi().layoutApi;
    }
    getGridFilterApi() {
        return this.getAdaptableApi().filterApi.gridFilterApi;
    }
    getColumnFilterApi() {
        return this.getAdaptableApi().filterApi.columnFilterApi;
    }
    getFilterApi() {
        return this.getAdaptableApi().filterApi;
    }
    getRowFormApi() {
        return this.getAdaptableApi().rowFormApi;
    }
    getPlusMinusApi() {
        return this.getAdaptableApi().plusMinusApi;
    }
    getQuickSearchApi() {
        return this.getAdaptableApi().quickSearchApi;
    }
    getScheduleApi() {
        return this.getAdaptableApi().scheduleApi;
    }
    getShortcutApi() {
        return this.getAdaptableApi().shortcutApi;
    }
    getSmartEditApi() {
        return this.getAdaptableApi().smartEditApi;
    }
    getSystemStatusApi() {
        return this.getAdaptableApi().systemStatusApi;
    }
    getThemeApi() {
        return this.getAdaptableApi().themeApi;
    }
    getUserInterfaceApi() {
        return this.getAdaptableApi().userInterfaceApi;
    }
    getNamedQueryApi() {
        return this.getAdaptableApi().namedQueryApi;
    }
    getExpressionApi() {
        return this.getAdaptableApi().expressionApi;
    }
    getPluginsApi() {
        return this.getAdaptableApi().pluginsApi;
    }
    getSettingsPanelApi() {
        return this.getAdaptableApi().settingsPanelApi;
    }
    getStyledColumnApi() {
        return this.getAdaptableApi().styledColumnApi;
    }
    getToolPanelApi() {
        return this.getAdaptableApi().toolPanelApi;
    }
    getTeamSharingApi() {
        return this.getAdaptableApi().teamSharingApi;
    }
    getColumnScopeApi() {
        return this.getAdaptableApi().columnScopeApi;
    }
    getDataChangeHistoryApi() {
        return this.getAdaptableApi().dataChangeHistoryApi;
    }
    getChartingApi() {
        return this.getAdaptableApi().chartingApi;
    }
    getStatusBarApi() {
        return this.getAdaptableApi().statusBarApi;
    }
    getFdc3Api() {
        return this.getAdaptableApi().fdc3Api;
    }
    getOptionsApi() {
        return this.getAdaptableApi().optionsApi;
    }
    destroy() {
        delete this._adaptable;
    }
}






/**
 * Creates a duplicate-free version of an array, using SameValueZero for equality comparisons,
 * in which only the first occurrence of each element is kept. The order of result values is
 * determined by the order they occur in the array.
 * Drop-in replacement for lodash/uniq.
 */ function $aac165a6c1a53427$export$2e2bcd8739ae039(array) {
    return [
        ...new Set(array)
    ];
}



var $9OAZF = parcelRequire("9OAZF");





function $fbcfcd6d50cfea93$export$6ad7023509a87dbf(columnId) {
    return `${0, $58846ea7f4156db7$export$1fadf36dae8ed962}-${columnId}`;
}
class $fbcfcd6d50cfea93$export$5b948b53734a7ea2 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Retrieves 'ColumnType' property for a given Column
     *   isCumulativeAggregate(input: string): boolean {
     *     return !!this.getNodesFromExpression(input, 'CUMUL')?.length;
     *   }
     * @param columnId Column to use
     */ getAgGridColumnType(columnId) {
        return this._adaptable.getAgGridColumnType(columnId);
    }
    getAllAgGridColumnTypes() {
        let colTypes = [];
        this.getColumnApi().getColumns().forEach((c)=>{
            const agGridColType = this.getAgGridColumnType(c.columnId);
            if (Array.isArray(agGridColType)) colTypes.push(...agGridColType);
            else colTypes.push(agGridColType);
        });
        return (0, $aac165a6c1a53427$export$2e2bcd8739ae039)(colTypes).filter((c)=>(0, $9OAZF.default).IsNotNullOrEmptyOrWhiteSpace(c));
    }
    /**
     * Retrieves a list providing the Friendly Name / Caption for all columns
     */ getAllColumnFriendlyNames() {
        return this.getColumnApi().getColumns().map((c)=>{
            return c.friendlyName;
        });
    }
    getAutoRowGroupColumnIdFor(columnId) {
        return $fbcfcd6d50cfea93$export$6ad7023509a87dbf(columnId);
    }
    /**
     * Retrieves AG Grid's field property for the column
     * @param columnId columnId to look up
     */ getAgGridColumnFieldForAdaptableColumn(columnId) {
        const agGridColumn = this.getAgGridColumnForAdaptableColumn(columnId);
        return agGridColumn.getColDef().field || '';
    }
    /**
     * Retrieves AG Grid's column for an Adaptable column
     * @param columnId columnId to look up
     */ getAgGridColumnForAdaptableColumn(columnId) {
        return this._adaptable.getAgGridColumnForColumnId(columnId);
    }
    isSpecialColumn(columnId, column = null) {
        if (column) return column.isCalculatedColumn || column.isFreeTextColumn || column.isActionColumn;
        else return this.getColumnApi().isCalculatedColumn(columnId) || this.getColumnApi().isFreeTextColumn(columnId) || this.getColumnApi().isActionColumn(columnId) || this.getColumnApi().isFdc3Column(columnId);
    }
    getColumnHeaderName(params) {
        // this is the same object, but casting it makes it easier to work with
        const isColumn = !params.columnGroup;
        const columnParams = params;
        const isColumnGroup = !!params.columnGroup;
        const columnGroupParams = params;
        const defaultHeaderName = params.colDef?.headerName ?? (isColumn ? (0, $9OAZF.default).CamelCaseToHumanText(columnParams.colDef?.field) : '') ?? '';
        // for now we override ONLY the header names
        if (params.location !== 'header') return defaultHeaderName;
        // 1. Layout specific header has the highest priority
        const layoutSpecificCustomHeader = this.getLayoutApi().getCurrentLayout().ColumnHeaders?.[isColumn ? columnParams.column.getColId() : columnGroupParams.columnGroup.getGroupId()];
        if (layoutSpecificCustomHeader) return layoutSpecificCustomHeader;
        // 2. check for custom ColumnOptions.columnHeader
        if (typeof this.getColumnOptions().columnHeader === 'function') {
            const columnHeaderContext = this.buildColumnHeaderContext(params, defaultHeaderName);
            if (columnHeaderContext === 'skip') return defaultHeaderName;
            const customHeader = this.getColumnOptions().columnHeader(columnHeaderContext);
            return customHeader;
        }
        // 3. fallback to default header name
        return defaultHeaderName;
    }
    buildColumnHeaderContext(params, defaultHeaderName) {
        const currentLayoutType = this.getLayoutApi().isCurrentLayoutPivot() ? 'pivot' : 'table';
        const currentLayout = this.getLayoutApi().getCurrentLayout();
        const baseContext = {
            ...this.getAdaptableApi().internalApi.buildBaseContext(),
            defaultHeaderName: defaultHeaderName,
            currentLayout: currentLayout,
            currentLayoutName: currentLayout.Name,
            currentLayoutType: currentLayoutType
        };
        // makes it easier to work with
        const currentTableLayout = currentLayout;
        const currentPivotLayout = currentLayout;
        if (params.column?.getColId() === (0, $58846ea7f4156db7$export$1fadf36dae8ed962)) {
            const columnType = 'autoGroupColumn';
            return {
                ...baseContext,
                columnType: columnType,
                columnId: params.column.getColId(),
                groupedColumnIds: currentLayoutType === 'table' ? currentTableLayout.RowGroupedColumns ?? [] : currentPivotLayout.PivotGroupedColumns ?? []
            };
        }
        if (params.column?.getColId().startsWith(`${(0, $58846ea7f4156db7$export$1fadf36dae8ed962)}-`)) {
            const columnType = 'rowGroupColumn';
            const columnId = params.column.getColId();
            // remove `${AG_GRID_GROUPED_COLUMN}-` from beginning of columnId
            const groupColumnId = columnId.substring(`${(0, $58846ea7f4156db7$export$1fadf36dae8ed962)}-`.length);
            return {
                ...baseContext,
                columnType: columnType,
                columnId: columnId,
                groupColumnId: groupColumnId
            };
        }
        if (baseContext.currentLayoutType === 'table') {
            if (params.columnGroup) {
                const columnType = 'tableColumnGroup';
                if (!params.colDef?.children) // AG Grid created virtual column groups for all columns
                // we want to skip those
                return 'skip';
                return {
                    ...baseContext,
                    columnType: columnType,
                    groupId: params.columnGroup?.getGroupId(),
                    childrenColumnIds: params.columnGroup?.getChildren().map((col)=>{
                        if (col.isColumn) return col.getColId();
                    }).filter(Boolean),
                    state: params.columnGroup?.isExpandable() && !params.columnGroup?.isExpanded() ? 'collapsed' : 'expanded'
                };
            }
            if (params.column) {
                const columnType = 'tableColumn';
                return {
                    ...baseContext,
                    columnType: columnType,
                    columnId: params.column?.getColId(),
                    aggregation: params.column.getAggFunc()
                };
            }
        }
        if (baseContext.currentLayoutType === 'pivot') {
            if (params.columnGroup) {
                if (!params.colDef?.pivotKeys) // we might have user defined colGroups, but we are not interested in them in pivot mode
                return 'skip';
                const columnType = 'pivotColumnGroup';
                return {
                    ...baseContext,
                    columnType: columnType,
                    groupId: params.columnGroup?.getGroupId(),
                    pivotKeys: params.colDef.pivotKeys,
                    state: params.columnGroup?.isExpandable() && !params.columnGroup?.isExpanded() ? 'collapsed' : 'expanded'
                };
            }
            if (params.column) {
                let columnId = params.column.getColId();
                if ((0, $49746e7bf2cf87d5$export$5bd0e023a792f54b)(columnId)) {
                    const columnType = 'pivotGrandTotal';
                    const pivotValueCol = params.colDef.pivotValueColumn;
                    const aggregatedColumnId = pivotValueCol?.getColId();
                    const currentLayoutAggCols = currentPivotLayout.PivotAggregationColumns?.map((col)=>col.ColumnId);
                    if (!currentLayoutAggCols?.includes(aggregatedColumnId)) // this column is not an aggregation column
                    return 'skip';
                    return {
                        ...baseContext,
                        columnType: columnType,
                        aggregatedColumnId: aggregatedColumnId,
                        aggregation: pivotValueCol.getAggFunc()
                    };
                }
                if ((0, $1d01f71c6f4ca9d9$export$e8f3ce9d27d3bb8f)(params.colDef?.colId)) {
                    const columnType = 'pivotColumnTotal';
                    const pivotColInfo = (0, $cd4621bade181468$export$152454e54408b5ae)(params.colDef, {
                        pivotColIds: currentPivotLayout.PivotColumns,
                        aggColIds: currentPivotLayout.PivotAggregationColumns.map((col)=>col.ColumnId)
                    }, (message)=>this.logWarn(message));
                    if (pivotColInfo === '!unknown!') return 'skip';
                    const pivotKey = pivotColInfo.pivotKeys[pivotColInfo.pivotKeys.length - 1];
                    return {
                        ...baseContext,
                        columnType: columnType,
                        pivotKey: pivotKey,
                        pivotColumnId: pivotColInfo.pivotColumnId,
                        aggregation: params.colDef?.pivotValueColumn?.getAggFunc()
                    };
                }
                if ((0, $abd79289c75d3093$export$605b4a9c6ba8ba9a)(params.colDef)) {
                    const columnType = 'pivotAggregationTotal';
                    const pivotValueCol = params.colDef.pivotValueColumn;
                    const pivotColInfo = (0, $cd4621bade181468$export$152454e54408b5ae)(params.colDef, {
                        pivotColIds: currentPivotLayout.PivotColumns,
                        aggColIds: currentPivotLayout.PivotAggregationColumns.map((col)=>col.ColumnId)
                    }, (message)=>this.logWarn(message));
                    if (pivotColInfo === '!unknown!') return 'skip';
                    const pivotKey = pivotColInfo.pivotKeys[pivotColInfo.pivotKeys.length - 1];
                    return {
                        ...baseContext,
                        columnType: columnType,
                        aggregatedColumnId: pivotValueCol?.getColId(),
                        aggregation: pivotValueCol.getAggFunc(),
                        pivotColumnId: pivotColInfo.pivotColumnId,
                        pivotKey: pivotKey
                    };
                }
                if ((0, $49746e7bf2cf87d5$export$12bf2038a59d2cca)(columnId)) {
                    const columnType = 'pivotResultColumn';
                    const pivotValueCol = params.colDef.pivotValueColumn;
                    const aggregatedColumnId = pivotValueCol?.getColId();
                    const currentLayoutAggCols = currentPivotLayout.PivotAggregationColumns?.map((col)=>col.ColumnId);
                    if (!currentLayoutAggCols?.includes(aggregatedColumnId)) // this column is not an aggregation column
                    return 'skip';
                    return {
                        ...baseContext,
                        columnType: columnType,
                        columnId: columnId,
                        pivotKeys: params.colDef.pivotKeys,
                        aggregatedColumnId: aggregatedColumnId,
                        aggregation: pivotValueCol.getAggFunc()
                    };
                }
            }
        }
        // if nothing matched, we skip this column[group]
        return 'skip';
    }
    hasArrayDataType(column) {
        return [
            'textArray',
            'numberArray',
            'tupleArray',
            'objectArray'
        ].includes(column.dataType);
    }
    getQueryableColumnsForUIEditor() {
        return this.getColumnApi().getQueryableColumns().filter((column)=>!column.isGeneratedPivotResultColumn && !column.isGeneratedRowGroupColumn && !column.isGeneratedSelectionColumn);
    }
    isColumnUIHidden(columnIdentifier) {
        return this.getColumnApi().hasColumnType(columnIdentifier, (0, $b0d14b794bdca4f2$export$24fbfbd19a58a666));
    }
    getColumnDateTypes() {
        // this is required because Adaptable uses 'date' type for all AG Grid date types: 'date', 'dateString'
        return [
            'date'
        ];
    }
}




var $9g4SS = parcelRequire("9g4SS");





const $8b34480a73f8989d$export$cddc429232233701 = 'weightedAvg';
const $8b34480a73f8989d$export$2a68a8b27a7ccde7 = 'only';
const $8b34480a73f8989d$export$baafdf6332da7837 = (aggFunc)=>{
    return aggFunc === $8b34480a73f8989d$export$cddc429232233701;
};
const $8b34480a73f8989d$export$d08dce3816d26cf = (aggFunc)=>{
    return aggFunc?.type === 'weightedAverage';
};
const $8b34480a73f8989d$export$b0a792687abe260d = (aggFunc)=>{
    if ($8b34480a73f8989d$export$d08dce3816d26cf(aggFunc)) return $8b34480a73f8989d$export$cddc429232233701;
    else if (typeof aggFunc === 'string') return aggFunc;
    else return aggFunc;
};



function $702a77ed6db22640$export$22a158c5774ce85f(columnWidths) {
    if (!columnWidths) return undefined;
    return Object.keys(columnWidths).reduce((acc, colId)=>{
        acc[colId] = {
            Width: columnWidths[colId]
        };
        return acc;
    }, {});
}
const $702a77ed6db22640$export$3732e731bff1a886 = (layout)=>{
    if ($702a77ed6db22640$export$db5fe50348e92ffe(layout)) return $702a77ed6db22640$export$61ae259916de4c79(layout);
    return $702a77ed6db22640$export$615c008db309d924(layout);
};
const $702a77ed6db22640$export$538c1d9eb946f389 = (layoutModel)=>{
    if ((0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(layoutModel)) return $702a77ed6db22640$export$42c864acb19f035c(layoutModel);
    return $702a77ed6db22640$export$535131aa438f4a5d(layoutModel);
};
function $702a77ed6db22640$var$cleanupAdaptableObjectPrimitives(layout) {
    const l = layout;
    for(const key in l){
        if (key === 'ColumnFilters') {
            // we don't want to cleanup ColumnFilters
            // as we rely on the Uuids for identifying the filters
            if (Array.isArray(l[key])) l[key].forEach((item)=>{
                if (typeof item === 'object') {
                    // but we do want to cleanup further down - eg: predicates in the filter
                    for(const k in item)if (typeof item[k] === 'object') (0, $792d5f2a0e72dfac$export$c6d9bd35e7cf8d09)(item[k]);
                }
            });
            continue;
        }
        if (typeof l[key] === 'object') (0, $792d5f2a0e72dfac$export$c6d9bd35e7cf8d09)(l[key]);
    }
}
const $702a77ed6db22640$export$896875e1f4ecfbd7 = (layout1, layout2)=>{
    if (!layout1 && !layout2) return true;
    if (!layout1 || !layout2) return false;
    return (0, $f94a32af7542d5ef$export$2e2bcd8739ae039)($702a77ed6db22640$export$d859d72b10c9a984(layout1), $702a77ed6db22640$export$d859d72b10c9a984(layout2));
};
const $702a77ed6db22640$export$d859d72b10c9a984 = (layout, options)=>{
    if ($702a77ed6db22640$export$db5fe50348e92ffe(layout)) return $702a77ed6db22640$export$1bc7836e67f1691(layout);
    return $702a77ed6db22640$export$b2a3d5aff99c1edc(layout, options);
};
const $702a77ed6db22640$export$b2a3d5aff99c1edc = (tableLayout, options)=>{
    let model = $702a77ed6db22640$export$615c008db309d924(tableLayout);
    model = (0, $9399b0c19bfb07a7$export$dd21133fd9f15048)(model, options);
    tableLayout = $702a77ed6db22640$export$535131aa438f4a5d(model);
    return tableLayout;
};
const $702a77ed6db22640$export$1bc7836e67f1691 = (pivotLayout)=>{
    let model = $702a77ed6db22640$export$61ae259916de4c79(pivotLayout);
    model = (0, $9399b0c19bfb07a7$export$ba8b5004731f7e8a)(model);
    pivotLayout = $702a77ed6db22640$export$42c864acb19f035c(model);
    return pivotLayout;
};
const $702a77ed6db22640$var$errorOnceMessages = new Map();
const $702a77ed6db22640$var$errorOnce = (message)=>{
    if ($702a77ed6db22640$var$errorOnceMessages.get(message)) return;
    console.error(message);
    $702a77ed6db22640$var$errorOnceMessages.set(message, true);
};
const $702a77ed6db22640$export$5cdc7948b93f9a16 = (layout)=>{
    if (!layout.RowGroupValues) return [];
    if (layout.RowGroupValues?.RowGroupDefaultBehavior === 'always-collapsed') return [];
    if (layout.RowGroupValues?.RowGroupDefaultBehavior === 'always-expanded') return [];
    if (Array.isArray(layout.RowGroupValues?.GroupKeys)) {
        const currentGroupedColumns = (layout.RowGroupedColumns || []).join(',');
        const matchingGroupKeys = layout.RowGroupValues.GroupKeys.find(({ RowGroupedColumns: RowGroupedColumns })=>{
            return RowGroupedColumns.join(',') === currentGroupedColumns;
        });
        if (matchingGroupKeys) return matchingGroupKeys.ExceptionGroupKeys;
    }
    return layout.RowGroupValues.ExceptionGroupKeys || [];
};
const $702a77ed6db22640$export$d0aad1143d337594 = (rowGroupValuesModel)=>{
    if (!rowGroupValuesModel) return undefined;
    const rowGroupValuesState = {
        RowGroupDefaultBehavior: rowGroupValuesModel.RowGroupDisplay
    };
    if (rowGroupValuesModel.RowGroupDisplay === 'collapsed' || rowGroupValuesModel.RowGroupDisplay === 'expanded') {
        if (rowGroupValuesModel.GroupKeys) rowGroupValuesState.GroupKeys = rowGroupValuesModel.GroupKeys.map(({ RowGroupedColumns: RowGroupedColumns, Values: Values })=>{
            return {
                RowGroupedColumns: RowGroupedColumns,
                ExceptionGroupKeys: Values
            };
        });
        else rowGroupValuesState.ExceptionGroupKeys = rowGroupValuesModel.Values;
    }
    return rowGroupValuesState;
};
const $702a77ed6db22640$export$999c2c6299c8166a = (rowGroupValuesState)=>{
    if (!rowGroupValuesState) return undefined;
    if (rowGroupValuesState.RowGroupDefaultBehavior === 'always-collapsed' || rowGroupValuesState.RowGroupDefaultBehavior === 'always-expanded') return {
        RowGroupDisplay: rowGroupValuesState.RowGroupDefaultBehavior
    };
    if (rowGroupValuesState.GroupKeys) return {
        RowGroupDisplay: rowGroupValuesState.RowGroupDefaultBehavior,
        GroupKeys: rowGroupValuesState.GroupKeys.map(({ RowGroupedColumns: RowGroupedColumns, ExceptionGroupKeys: ExceptionGroupKeys })=>{
            return {
                RowGroupedColumns: RowGroupedColumns,
                Values: ExceptionGroupKeys
            };
        })
    };
    return {
        RowGroupDisplay: rowGroupValuesState.RowGroupDefaultBehavior,
        Values: rowGroupValuesState.ExceptionGroupKeys || []
    };
};
const $702a77ed6db22640$export$88f5e04cb6a7b262 = (layout)=>{
    if (layout.TableColumns) {
        const set = new Set(layout.TableColumns);
        if (set.size !== layout.TableColumns.length) layout.TableColumns.reduce((acc, col)=>{
            acc[col] = (acc[col] || 0) + 1;
            if (acc[col] > 1) // if you change this message, make sure you also update the associated test error-on-duplicate-column.spec.ts
            $702a77ed6db22640$var$errorOnce(`Duplicate column "${col}" in layout "${layout.Name}"!`);
            return acc;
        }, {});
    }
};
const $702a77ed6db22640$export$615c008db309d924 = (tableLayout)=>{
    tableLayout = structuredClone(tableLayout);
    tableLayout.ColumnSizing = tableLayout.ColumnSizing ?? $702a77ed6db22640$export$22a158c5774ce85f(tableLayout.ColumnWidths);
    $702a77ed6db22640$var$cleanupAdaptableObjectPrimitives(tableLayout);
    const TableAggregationColumns = (tableLayout.TableAggregationColumns || []).map(({ ColumnId: ColumnId, AggFunc: AggFunc })=>{
        return {
            ColumnId: ColumnId,
            AggFunc: $702a77ed6db22640$var$toAggFunc(AggFunc)
        };
    });
    const result = (0, $09992080550de2e8$export$751775fc0da97049)({
        Name: tableLayout.Name,
        SuppressAggFuncInHeader: tableLayout.SuppressAggFuncInHeader,
        TableColumns: tableLayout.TableColumns,
        ColumnSizing: tableLayout.ColumnSizing,
        ColumnVisibility: tableLayout.ColumnVisibility,
        ColumnSorts: tableLayout.ColumnSorts,
        RowGroupedColumns: tableLayout.RowGroupedColumns,
        ColumnPinning: tableLayout.ColumnPinning,
        RowGroupValues: $702a77ed6db22640$export$999c2c6299c8166a(tableLayout.RowGroupValues),
        ColumnGroupValues: tableLayout.ColumnGroupValues ? tableLayout.ColumnGroupValues.ColumnGroupDefaultBehavior === 'always-expanded' || tableLayout.ColumnGroupValues.ColumnGroupDefaultBehavior === 'always-collapsed' ? {
            ColumnGroupDisplay: tableLayout.ColumnGroupValues.ColumnGroupDefaultBehavior
        } : {
            ColumnGroupDisplay: tableLayout.ColumnGroupValues.ColumnGroupDefaultBehavior,
            Values: tableLayout.ColumnGroupValues.ExceptionGroupKeys || []
        } : undefined,
        TableAggregationColumns: TableAggregationColumns,
        GrandTotalRow: tableLayout.GrandTotalRow
    });
    if (tableLayout.RowGroupDisplayType) result.RowGroupDisplayType = tableLayout.RowGroupDisplayType;
    if (tableLayout.ColumnFilters) result.Ignore_ColumnFilters = tableLayout.ColumnFilters;
    if (tableLayout.GridFilter) result.Ignore_GridFilter = tableLayout.GridFilter;
    if (tableLayout.ColumnHeaders) result.Ignore_ColumnHeaders = tableLayout.ColumnHeaders;
    if (tableLayout.AutoSizeColumns != null) result.Ignore_AutoSizeColumns = tableLayout.AutoSizeColumns;
    if (tableLayout.IsReadOnly != null) result.Ignore_IsReadOnly = tableLayout.IsReadOnly;
    if (tableLayout.Tags) result.Ignore_Tags = tableLayout.Tags;
    if (tableLayout.Source) result.Ignore_Source = tableLayout.Source;
    if (tableLayout.AdaptableVersion) result.Ignore_AdaptableVersion = tableLayout.AdaptableVersion;
    if (tableLayout.Uuid) result.Ignore_Uuid = tableLayout.Uuid;
    if (tableLayout.Metadata) result.Ignore_Metadata = tableLayout.Metadata;
    if (tableLayout.RowSummaries != null) result.Ignore_RowSummaries = tableLayout.RowSummaries;
    return result;
};
const $702a77ed6db22640$export$61ae259916de4c79 = (pivotLayout)=>{
    pivotLayout = structuredClone(pivotLayout);
    pivotLayout.ColumnSizing = pivotLayout.ColumnSizing ?? $702a77ed6db22640$export$22a158c5774ce85f(pivotLayout.ColumnWidths);
    $702a77ed6db22640$var$cleanupAdaptableObjectPrimitives(pivotLayout);
    const result = (0, $09992080550de2e8$export$a987b87147cf5c85)({
        Name: pivotLayout.Name,
        SuppressAggFuncInHeader: pivotLayout.SuppressAggFuncInHeader,
        ColumnSizing: pivotLayout.ColumnSizing,
        ColumnSorts: pivotLayout.ColumnSorts,
        PivotGroupedColumns: pivotLayout.PivotGroupedColumns,
        ColumnPinning: pivotLayout.ColumnPinning,
        PivotColumns: pivotLayout.PivotColumns,
        PivotExpandLevel: pivotLayout.PivotExpandLevel,
        PivotAggregationColumns: (pivotLayout.PivotAggregationColumns || []).map(({ ColumnId: ColumnId, AggFunc: AggFunc, Total: Total })=>{
            return {
                ColumnId: ColumnId,
                AggFunc: $702a77ed6db22640$var$toAggFunc(AggFunc),
                Total: Total
            };
        }),
        GrandTotalRow: pivotLayout.GrandTotalRow,
        PivotGrandTotal: pivotLayout.PivotGrandTotal,
        PivotColumnTotal: pivotLayout.PivotColumnTotal,
        PivotResultColumnsOrder: pivotLayout.PivotResultColumnsOrder,
        RowGroupValues: $702a77ed6db22640$export$999c2c6299c8166a(pivotLayout.RowGroupValues),
        ColumnGroupValues: pivotLayout.ColumnGroupValues ? pivotLayout.ColumnGroupValues.ColumnGroupDefaultBehavior === 'always-expanded' || pivotLayout.ColumnGroupValues.ColumnGroupDefaultBehavior === 'always-collapsed' ? {
            ColumnGroupDisplay: pivotLayout.ColumnGroupValues.ColumnGroupDefaultBehavior
        } : {
            ColumnGroupDisplay: pivotLayout.ColumnGroupValues.ColumnGroupDefaultBehavior,
            Values: pivotLayout.ColumnGroupValues.ExceptionGroupKeys || []
        } : undefined
    });
    if (pivotLayout.RowGroupDisplayType) result.RowGroupDisplayType = pivotLayout.RowGroupDisplayType;
    if (pivotLayout.ColumnFilters) result.Ignore_ColumnFilters = pivotLayout.ColumnFilters;
    if (pivotLayout.GridFilter) result.Ignore_GridFilter = pivotLayout.GridFilter;
    if (pivotLayout.ColumnHeaders) result.Ignore_ColumnHeaders = pivotLayout.ColumnHeaders;
    if (pivotLayout.IsReadOnly != null) result.Ignore_IsReadOnly = pivotLayout.IsReadOnly;
    if (pivotLayout.Tags) result.Ignore_Tags = pivotLayout.Tags;
    if (pivotLayout.AutoSizeColumns != null) result.Ignore_AutoSizeColumns = pivotLayout.AutoSizeColumns;
    if (pivotLayout.Source) result.Ignore_Source = pivotLayout.Source;
    if (pivotLayout.AdaptableVersion) result.Ignore_AdaptableVersion = pivotLayout.AdaptableVersion;
    if (pivotLayout.Uuid) result.Ignore_Uuid = pivotLayout.Uuid;
    if (pivotLayout.Metadata) result.Ignore_Metadata = pivotLayout.Metadata;
    return result;
};
function $702a77ed6db22640$var$toAggFunc(aggFunc) {
    if ((0, $8b34480a73f8989d$export$d08dce3816d26cf)(aggFunc)) return {
        aggFunc: (0, $8b34480a73f8989d$export$cddc429232233701),
        weightedColumnId: aggFunc.weightedColumnId
    };
    return {
        aggFunc: aggFunc
    };
}
const $702a77ed6db22640$export$535131aa438f4a5d = (layoutModel)=>{
    const tableLayout = {
        Name: layoutModel.Name,
        TableColumns: layoutModel.TableColumns,
        ColumnSizing: layoutModel.ColumnSizing,
        ColumnVisibility: layoutModel.ColumnVisibility,
        ColumnSorts: layoutModel.ColumnSorts
    };
    if (layoutModel.SuppressAggFuncInHeader) tableLayout.SuppressAggFuncInHeader = layoutModel.SuppressAggFuncInHeader;
    if (layoutModel.Ignore_GridFilter) tableLayout.GridFilter = layoutModel.Ignore_GridFilter;
    if (layoutModel.Ignore_ColumnFilters) tableLayout.ColumnFilters = layoutModel.Ignore_ColumnFilters;
    if (layoutModel.Ignore_ColumnHeaders) tableLayout.ColumnHeaders = layoutModel.Ignore_ColumnHeaders;
    if (layoutModel.Ignore_AutoSizeColumns != null) tableLayout.AutoSizeColumns = layoutModel.Ignore_AutoSizeColumns;
    if (layoutModel.Ignore_RowSummaries) tableLayout.RowSummaries = layoutModel.Ignore_RowSummaries;
    if (layoutModel.Ignore_IsReadOnly != null) tableLayout.IsReadOnly = layoutModel.Ignore_IsReadOnly;
    if (layoutModel.Ignore_Tags) tableLayout.Tags = layoutModel.Ignore_Tags;
    if (layoutModel.Ignore_Source) tableLayout.Source = layoutModel.Ignore_Source;
    if (layoutModel.Ignore_AdaptableVersion) tableLayout.AdaptableVersion = layoutModel.Ignore_AdaptableVersion;
    if (layoutModel.Ignore_Uuid) tableLayout.Uuid = layoutModel.Ignore_Uuid;
    if (layoutModel.Ignore_Metadata) tableLayout.Metadata = layoutModel.Ignore_Metadata;
    // if (layoutModel.RowGroupDisplayType) {
    tableLayout.RowGroupDisplayType = layoutModel.RowGroupDisplayType ?? 'single';
    // }
    if (layoutModel.RowGroupedColumns) tableLayout.RowGroupedColumns = layoutModel.RowGroupedColumns;
    else delete tableLayout.RowGroupedColumns;
    if (layoutModel.ColumnPinning) tableLayout.ColumnPinning = layoutModel.ColumnPinning;
    else delete tableLayout.ColumnPinning;
    if (layoutModel.RowGroupValues) tableLayout.RowGroupValues = $702a77ed6db22640$export$d0aad1143d337594(layoutModel.RowGroupValues);
    else delete tableLayout.RowGroupValues;
    if (layoutModel.ColumnGroupValues) {
        tableLayout.ColumnGroupValues = {
            ColumnGroupDefaultBehavior: layoutModel.ColumnGroupValues.ColumnGroupDisplay
        };
        if ((layoutModel.ColumnGroupValues.ColumnGroupDisplay === 'collapsed' || layoutModel.ColumnGroupValues.ColumnGroupDisplay === 'expanded') && layoutModel.ColumnGroupValues.Values) // @ts-ignore
        tableLayout.ColumnGroupValues.ExceptionGroupKeys = layoutModel.ColumnGroupValues.Values;
    }
    if (layoutModel.TableAggregationColumns) tableLayout.TableAggregationColumns = layoutModel.TableAggregationColumns.map(({ ColumnId: ColumnId, AggFunc: AggFunc })=>{
        return {
            ColumnId: ColumnId,
            AggFunc: $702a77ed6db22640$var$toAggregationColumnValue(AggFunc)
        };
    });
    else delete tableLayout.TableAggregationColumns;
    if (layoutModel.GrandTotalRow) tableLayout.GrandTotalRow = layoutModel.GrandTotalRow;
    else delete tableLayout.GrandTotalRow;
    $702a77ed6db22640$var$cleanupAdaptableObjectPrimitives(tableLayout);
    return tableLayout;
};
function $702a77ed6db22640$var$toAggregationColumnValue(columnAggregationModel) {
    return columnAggregationModel && typeof columnAggregationModel.aggFunc === 'string' && (0, $8b34480a73f8989d$export$baafdf6332da7837)(columnAggregationModel.aggFunc) ? {
        type: 'weightedAverage',
        weightedColumnId: columnAggregationModel.weightedColumnId
    } : columnAggregationModel.aggFunc;
}
const $702a77ed6db22640$export$42c864acb19f035c = (layoutModel)=>{
    const pivotLayout = {
        Name: layoutModel.Name,
        PivotColumns: layoutModel.PivotColumns,
        TableColumns: layoutModel.TableColumns,
        ColumnSizing: layoutModel.ColumnSizing,
        ColumnSorts: layoutModel.ColumnSorts,
        ColumnPinning: layoutModel.ColumnPinning,
        PivotExpandLevel: layoutModel.PivotExpandLevel
    };
    if (layoutModel.SuppressAggFuncInHeader) pivotLayout.SuppressAggFuncInHeader = layoutModel.SuppressAggFuncInHeader;
    if (layoutModel.Ignore_GridFilter) pivotLayout.GridFilter = layoutModel.Ignore_GridFilter;
    if (layoutModel.Ignore_ColumnFilters) pivotLayout.ColumnFilters = layoutModel.Ignore_ColumnFilters;
    if (layoutModel.Ignore_ColumnHeaders) pivotLayout.ColumnHeaders = layoutModel.Ignore_ColumnHeaders;
    if (layoutModel.Ignore_AutoSizeColumns != null) pivotLayout.AutoSizeColumns = layoutModel.Ignore_AutoSizeColumns;
    if (layoutModel.Ignore_IsReadOnly != null) pivotLayout.IsReadOnly = layoutModel.Ignore_IsReadOnly;
    if (layoutModel.Ignore_Tags) pivotLayout.Tags = layoutModel.Ignore_Tags;
    if (layoutModel.Ignore_Source) pivotLayout.Source = layoutModel.Ignore_Source;
    if (layoutModel.Ignore_AdaptableVersion) pivotLayout.AdaptableVersion = layoutModel.Ignore_AdaptableVersion;
    if (layoutModel.Ignore_Uuid) pivotLayout.Uuid = layoutModel.Ignore_Uuid;
    if (layoutModel.Ignore_Metadata) pivotLayout.Metadata = layoutModel.Ignore_Metadata;
    if (layoutModel.PivotGroupedColumns) pivotLayout.PivotGroupedColumns = layoutModel.PivotGroupedColumns;
    else delete pivotLayout.PivotGroupedColumns;
    if (layoutModel.RowGroupValues) pivotLayout.RowGroupValues = $702a77ed6db22640$export$d0aad1143d337594(layoutModel.RowGroupValues);
    else delete pivotLayout.RowGroupValues;
    if (layoutModel.GrandTotalRow != null) pivotLayout.GrandTotalRow = layoutModel.GrandTotalRow;
    else delete pivotLayout.GrandTotalRow;
    if (layoutModel.PivotGrandTotal != null) pivotLayout.PivotGrandTotal = layoutModel.PivotGrandTotal;
    else delete pivotLayout.PivotGrandTotal;
    if (layoutModel.PivotColumnTotal != null) pivotLayout.PivotColumnTotal = layoutModel.PivotColumnTotal;
    else delete pivotLayout.PivotColumnTotal;
    if (layoutModel.PivotResultColumnsOrder != null) pivotLayout.PivotResultColumnsOrder = layoutModel.PivotResultColumnsOrder;
    else delete pivotLayout.PivotResultColumnsOrder;
    if (layoutModel.PivotAggregationColumns) pivotLayout.PivotAggregationColumns = (layoutModel.PivotAggregationColumns || []).map(({ ColumnId: ColumnId, AggFunc: AggFunc, Total: Total })=>({
            ColumnId: ColumnId,
            AggFunc: $702a77ed6db22640$var$toAggregationColumnValue(AggFunc),
            Total: Total
        }));
    else delete pivotLayout.PivotAggregationColumns;
    if (layoutModel.ColumnGroupValues) {
        pivotLayout.ColumnGroupValues = {
            ColumnGroupDefaultBehavior: layoutModel.ColumnGroupValues.ColumnGroupDisplay
        };
        if ((layoutModel.ColumnGroupValues.ColumnGroupDisplay === 'collapsed' || layoutModel.ColumnGroupValues.ColumnGroupDisplay === 'expanded') && layoutModel.ColumnGroupValues.Values) // @ts-ignore
        pivotLayout.ColumnGroupValues.ExceptionGroupKeys = layoutModel.ColumnGroupValues.Values;
    }
    // if (layoutModel.RowGroupDisplayType) {
    pivotLayout.RowGroupDisplayType = layoutModel.RowGroupDisplayType ?? 'single';
    // }
    return pivotLayout;
};
const $702a77ed6db22640$export$db5fe50348e92ffe = (layout)=>Array.isArray(layout.PivotColumns);


const $49746e7bf2cf87d5$var$ROW_GROUP_COLUMN_DEFAULTS = {
    columnId: '',
    isTreeColumn: false,
    friendlyName: 'Group',
    isPrimaryKey: false,
    readOnly: false,
    resizable: true,
    visible: true,
    isUIHiddenColumn: false,
    fieldOnly: false,
    queryable: false,
    sortable: false,
    filterable: false,
    groupable: false,
    pivotable: false,
    aggregatable: false,
    moveable: true,
    hideable: false,
    exportable: true,
    isGrouped: true,
    isGeneratedRowGroupColumn: true,
    isGeneratedPivotResultColumn: false,
    isGeneratedSelectionColumn: false,
    isFixed: false,
    pinned: null,
    isSparkline: false,
    dataType: 'text',
    isCalculatedColumn: false,
    isFreeTextColumn: false,
    isActionColumn: false,
    isPivotTotalColumn: false
};
function $49746e7bf2cf87d5$export$862c4c411407056(columnId) {
    return $49746e7bf2cf87d5$export$89beaf667964347d(columnId) || $49746e7bf2cf87d5$export$331345f90095528a(columnId);
}
function $49746e7bf2cf87d5$export$89beaf667964347d(columnId) {
    return columnId === (0, $9399b0c19bfb07a7$export$b9ed909d42ef1a59);
}
function $49746e7bf2cf87d5$export$331345f90095528a(columnId) {
    return columnId.startsWith((0, $9399b0c19bfb07a7$export$652eb7684b734a42));
}
function $49746e7bf2cf87d5$export$2a4c43a0a47efea8() {
    return {
        ...$49746e7bf2cf87d5$var$ROW_GROUP_COLUMN_DEFAULTS,
        columnId: (0, $9399b0c19bfb07a7$export$b9ed909d42ef1a59)
    };
}
const $49746e7bf2cf87d5$var$TREE_COLUMN_FRIENDLY_NAME = '[Tree Column]';
function $49746e7bf2cf87d5$export$b855ba22978bfa2d() {
    return {
        ...$49746e7bf2cf87d5$var$ROW_GROUP_COLUMN_DEFAULTS,
        columnId: (0, $9399b0c19bfb07a7$export$b9ed909d42ef1a59),
        isTreeColumn: true,
        friendlyName: $49746e7bf2cf87d5$var$TREE_COLUMN_FRIENDLY_NAME
    };
}
function $49746e7bf2cf87d5$export$526dfbcccf2f7c0(column) {
    return {
        ...$49746e7bf2cf87d5$var$ROW_GROUP_COLUMN_DEFAULTS,
        columnId: (0, $9399b0c19bfb07a7$export$652eb7684b734a42) + column.columnId,
        friendlyName: column.friendlyName,
        dataType: column.dataType
    };
}
function $49746e7bf2cf87d5$export$eac612f12283c3c1(columnId, agGridApi) {
    if ($49746e7bf2cf87d5$export$5bd0e023a792f54b(columnId)) return `[Grand Total] ${columnId.split('_').slice(2).map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`;
    if ((0, $1d01f71c6f4ca9d9$export$e8f3ce9d27d3bb8f)(columnId)) return `[Group Total] ${columnId.split('_').slice(2).map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`;
    // is quite consuming on performance
    // we don't need it anyway because currently (20.0.7) we don't display Pivot Totals at all
    // if (isPivotAggregationTotalColumn(columnId, agGridApi)) {
    //   return `[Aggregation Total] ${columnId
    //     .split('_')
    //     .slice(2)
    //     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    //     .join(' ')}`;
    // }
    return `[Pivot] ${columnId.split('_').slice(1).map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`;
}
function $49746e7bf2cf87d5$export$12bf2038a59d2cca(columnId) {
    // put this here as there might be other indicators we are not aware of?
    return columnId?.startsWith($58846ea7f4156db7$export$4dc11daf036118a4);
}
function $49746e7bf2cf87d5$export$5bd0e023a792f54b(columnId) {
    return columnId?.startsWith($58846ea7f4156db7$export$56a650b3b733ebf1);
}
class $49746e7bf2cf87d5$export$3c91042823dcf745 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $fbcfcd6d50cfea93$export$5b948b53734a7ea2)(_adaptable);
    }
    getColumns() {
        return this.getGridApi().getInternalState().Columns ?? [];
    }
    getUIAvailableColumns() {
        return this.getColumns().filter((c)=>!c.isUIHiddenColumn && !c.isGeneratedSelectionColumn && // currently (20.0.7) we don't display Pivot Totals in UI
            !c.isPivotTotalColumn);
    }
    getSpecialColumns() {
        const cols = this.getUIAvailableColumns()?.filter((c)=>this.internalApi.isSpecialColumn(c.columnId, c));
        return cols ?? [];
    }
    getNonSpecialColumns() {
        const cols = this.getUIAvailableColumns()?.filter((c)=>!this.internalApi.isSpecialColumn(c.columnId, c));
        return cols ?? [];
    }
    getVisibleColumns() {
        const layout = this.getLayoutApi().getCurrentLayout();
        const allcols = this.getUIAvailableColumns();
        if ((0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)) return allcols;
        const visibleCols = layout.TableColumns.reduce((acc, colId)=>{
            if (layout.ColumnVisibility?.[colId] !== false) acc.add(colId);
            return acc;
        }, new Set());
        return allcols.filter((c)=>visibleCols.has(c.columnId));
    }
    selectColumn(columnId) {
        this._adaptable.selectColumn(columnId);
    }
    selectColumns(columnIds) {
        this._adaptable.selectColumns(columnIds);
    }
    addColumnToSelection(columnId) {
        this._adaptable.selectColumn(columnId, {
            keepExistingSelection: true
        });
    }
    addColumnsToSelection(columnIds) {
        this._adaptable.selectColumns(columnIds, {
            keepExistingSelection: true
        });
    }
    selectAllColumns() {
        this._adaptable.selectAll();
    }
    autosizeColumn(columnId) {
        this._adaptable.autoSizeColumn(columnId);
    }
    autosizeColumns(columnIds) {
        this._adaptable.autoSizeColumns(columnIds);
    }
    autosizeAllColumns() {
        this._adaptable.autoSizeAllColumns();
    }
    hideColumn(columnId) {
        this._adaptable.hideColumn(columnId);
    }
    showColumn(columnId) {
        this._adaptable.showColumn(columnId);
    }
    isPivotResultColumn(columnId) {
        return $49746e7bf2cf87d5$export$12bf2038a59d2cca(columnId) || $49746e7bf2cf87d5$export$5bd0e023a792f54b(columnId);
    }
    isPivotAggColumnWithNoPivotColumns(columnId) {
        const currentLayout = this.getLayoutApi().getCurrentLayout();
        if (!(0, $702a77ed6db22640$export$db5fe50348e92ffe)(currentLayout)) return false;
        // When PivotColumns is empty, agg columns keep their original IDs
        if (currentLayout.PivotColumns?.length === 0) return currentLayout.PivotAggregationColumns?.some((agg)=>agg.ColumnId === columnId) ?? false;
        return false;
    }
    isSelectionColumn(columnId) {
        return columnId === (0, $58846ea7f4156db7$export$8866fbaadb96699c);
    }
    isAutoRowGroupColumn(columnId) {
        return $49746e7bf2cf87d5$export$862c4c411407056(columnId);
    }
    isAutoRowGroupColumnForSingle(columnId) {
        return $49746e7bf2cf87d5$export$89beaf667964347d(columnId);
    }
    isAutoRowGroupColumnForMulti(columnId) {
        return $49746e7bf2cf87d5$export$331345f90095528a(columnId);
    }
    isSpecialColumn(columnId) {
        return this.isCalculatedColumn(columnId) || this.isFreeTextColumn(columnId) || this.isActionColumn(columnId) || this.isFdc3Column(columnId);
    }
    isCalculatedColumn(columnId) {
        return this.getCalculatedColumnApi().getCalculatedColumns().find((cc)=>cc.ColumnId == columnId) != null;
    }
    isFreeTextColumn(columnId) {
        return this.getFreeTextColumnApi().getFreeTextColumns().find((cc)=>cc.ColumnId == columnId) != null;
    }
    isActionColumn(columnId) {
        return this.getActionColumnApi().getActionColumns()?.find((cc)=>cc.columnId == columnId) != null;
    }
    isFdc3Column(columnId) {
        return this.getFdc3Api().internalApi.getFdc3ColumnIds().includes(columnId);
    }
    getColumnWithColumnId(columnId, logWarning) {
        if (columnId == undefined) return;
        // just return null if no columns rather than logging a warning - otherwise get lots at startup
        if ((0, $9g4SS.default).IsNullOrEmpty(this.getColumns())) return;
        const foundColumn = this.getColumns().find((c)=>c.columnId == columnId);
        if (foundColumn) return foundColumn;
        if (logWarning) this.logMissingColumnWarning(columnId);
        return undefined;
    }
    hasNumberDataType(columnId) {
        const column = this.getColumnWithColumnId(columnId);
        if (!column) return false;
        return column?.dataType == 'number';
    }
    hasBooleanDataType(columnId) {
        const column = this.getColumnWithColumnId(columnId);
        if (!column) return false;
        return column?.dataType == 'boolean';
    }
    hasArrayDataType(columnId) {
        return this.hasTextArrayDataType(columnId) || this.hasNumericArrayDataType(columnId);
    }
    hasTextArrayDataType(columnId) {
        const column = this.getColumnWithColumnId(columnId);
        if (!column) return false;
        return column?.dataType === 'textArray';
    }
    hasNumericArrayDataType(columnId) {
        const column = this.getColumnWithColumnId(columnId);
        if (!column) return false;
        return column?.dataType === 'numberArray' || column?.dataType === 'tupleArray' || column?.dataType === 'objectArray';
    }
    hasDateDataType(columnId) {
        const column = this.getColumnWithColumnId(columnId);
        if (!column) return false;
        return this.internalApi.getColumnDateTypes().includes(column?.dataType);
    }
    getColumnDataTypeForColumnId(columnId) {
        const column = this.getColumnWithColumnId(columnId);
        if (!column) return undefined;
        return column.dataType;
    }
    getFriendlyNameForColumnId(columnId, layout) {
        if (this.isPivotResultColumn(columnId)) return $49746e7bf2cf87d5$export$eac612f12283c3c1(columnId, this.getAgGridApi());
        const foundColumn = this.getColumns().find((c)=>c.columnId === columnId);
        const isRowGroupColumn = this.isAutoRowGroupColumn(columnId);
        if (foundColumn && foundColumn.friendlyName && !foundColumn.friendlyName.includes($58846ea7f4156db7$export$682d840a57d492f3) && !isRowGroupColumn) return foundColumn.friendlyName;
        if (foundColumn?.isTreeColumn && isRowGroupColumn) return foundColumn.friendlyName;
        let result = columnId + $58846ea7f4156db7$export$682d840a57d492f3;
        if (this.isAutoRowGroupColumn(columnId)) {
            if (this.getGridApi().isTreeDataGrid()) return $49746e7bf2cf87d5$var$TREE_COLUMN_FRIENDLY_NAME;
            const currentLayout = layout ?? this.getLayoutApi().getCurrentLayout();
            const groupColumns = currentLayout?.RowGroupedColumns ?? currentLayout?.PivotGroupedColumns ?? [];
            if (groupColumns.length) {
                const groupedByLabel = this.isAutoRowGroupColumnForSingle(columnId) ? groupColumns.map((colId)=>this.getFriendlyNameForColumnId(colId, layout)).join(', ') : this.getFriendlyNameForColumnId(columnId.replace((0, $9399b0c19bfb07a7$export$652eb7684b734a42), ''), layout);
                result = `[Grouped Column: ${groupedByLabel}]`;
                return result;
            }
        }
        this.logMissingColumnWarning(columnId);
        return result;
    }
    doesColumnExist(columnId) {
        const foundColumn = this.getColumns().find((c)=>c.columnId === columnId);
        return foundColumn ? true : false;
    }
    getFriendlyNamesForColumnIds(columnIds) {
        const friendlyNames = [];
        if ((0, $9g4SS.default).IsNullOrEmpty(columnIds)) return friendlyNames;
        columnIds.forEach((c)=>{
            friendlyNames.push(this.getFriendlyNameForColumnId(c));
        });
        return friendlyNames;
    }
    getColumnIdForFriendlyName(friendlyName) {
        if (friendlyName.includes($58846ea7f4156db7$export$682d840a57d492f3)) return friendlyName.replace($58846ea7f4156db7$export$682d840a57d492f3, ''); // Ids should stay "pure"
        const foundColumn = this.getColumns().find((c)=>c.friendlyName === friendlyName);
        if (foundColumn) return foundColumn.columnId;
        this.logMissingColumnWarning(friendlyName);
        return friendlyName + $58846ea7f4156db7$export$682d840a57d492f3;
    }
    getColumnIdsForFriendlyNames(friendlyNames) {
        const columnIds = [];
        if ((0, $9g4SS.default).IsNullOrEmpty(friendlyNames)) return columnIds;
        friendlyNames.forEach((c)=>{
            columnIds.push(this.getColumnIdForFriendlyName(c));
        });
        return columnIds;
    }
    getColumnsWithFriendlyNames(friendlyNames) {
        return friendlyNames.map((friendlyName)=>this.getColumns().find((x)=>x.friendlyName === friendlyName)).filter(Boolean);
    }
    getColumnsWithColumnIds(columnIds, logWarning = true) {
        let returnCols = [];
        columnIds.forEach((c)=>{
            const column = this.getColumnWithColumnId(c, logWarning);
            if (column) returnCols.push(column);
        });
        return returnCols;
    }
    isColumnInGrid(columnId) {
        return !!this.getColumnWithColumnId(columnId, false);
    }
    getColumnWithFriendlyName(columnFriendlyName, logWarning = true) {
        // just return null if no columns rather than logging a warning - otherwise get lots at startup
        if ((0, $9g4SS.default).IsNullOrEmpty(this.getColumns())) return null;
        const foundColumn = this.getColumns().find((c)=>c.friendlyName === columnFriendlyName);
        if (foundColumn) return foundColumn;
        if (logWarning) this.logMissingColumnWarning(columnFriendlyName);
        return null;
    }
    getColumnsWithDataType(dataType) {
        switch(dataType){
            case 'boolean':
                return this.getBooleanColumns();
            case 'date':
                return this.getDateColumns();
            case 'number':
                return this.getNumericColumns();
            case 'text':
                return this.getTextColumns();
            case 'textArray':
                return this.getTextArrayColumns();
            case 'numberArray':
                return this.getNumberArrayColumns();
            case 'objectArray':
                return this.getObjectNumberArrayColumns();
            case 'tupleArray':
                return this.getTupleNumberArrayColumns();
            default:
                return this.getUIAvailableColumns();
        }
    }
    getNumericColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.dataType === 'number');
    }
    getNumericArrayColumns() {
        return this.getNumberArrayColumns().concat(this.getTupleNumberArrayColumns()).concat(this.getObjectNumberArrayColumns());
    }
    getNumberArrayColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.dataType === 'numberArray');
    }
    getTupleNumberArrayColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.dataType === 'tupleArray');
    }
    getObjectNumberArrayColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.dataType === 'objectArray');
    }
    getTextColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.dataType === 'text');
    }
    getTextArrayColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.dataType === 'textArray');
    }
    getDateColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.dataType === 'date');
    }
    getBooleanColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.dataType === 'boolean');
    }
    getArrayColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.dataType === 'numberArray' || c.dataType === 'tupleArray' || c.dataType === 'objectArray' || c.dataType === 'textArray');
    }
    getSortableColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.sortable);
    }
    getFilterableColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.filterable);
    }
    getGroupableColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.groupable);
    }
    getPivotableColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.pivotable);
    }
    getAggregatableColumns() {
        return this.getUIAvailableColumns().filter((c)=>c.aggregatable && c.dataType === 'number');
    }
    getQueryableColumns() {
        return this.getColumns().filter((c)=>c.queryable);
    }
    getExportableColumns() {
        return this.getColumns().filter((c)=>c.exportable);
    }
    getUIHiddenColumns() {
        return this.getColumns().filter((c)=>c.isUIHiddenColumn);
    }
    logMissingColumnWarning(columnId) {
        if (this.getColumnOptions().showMissingColumnsWarning === true) {
            if (!this.isAutoRowGroupColumn(columnId) && !this.isSpecialColumn(columnId)) this.logWarn(`No column found named '${columnId}'`);
        }
    }
    getPrimaryKeyColumn() {
        return this.getColumnWithColumnId(this.getOptions().primaryKey);
    }
    getDefaultAggFunc(columnId) {
        const abColumn = this.getColumnWithColumnId(columnId);
        const availableAggregationFunctions = abColumn.availableAggregationFunctions;
        const agColumn = this.internalApi.getAgGridColumnForAdaptableColumn(columnId)?.getColDef?.();
        return agColumn?.defaultAggFunc ?? availableAggregationFunctions[0];
    }
    openColumnInfoSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$59d09157d833a722);
    }
    getColumnTypes() {
        const columnTypes = this.getOptions().columnOptions.columnTypes;
        if (typeof columnTypes === 'function') {
            const types = this.internalApi.getAllAgGridColumnTypes();
            const columnTypesContext = {
                types: types,
                ...this.getAdaptableInternalApi().buildBaseContext()
            };
            return columnTypes(columnTypesContext);
        } else return columnTypes;
    }
    getColumnsByColumnType(columnType) {
        const abColumns = this.getColumns();
        return abColumns.filter((c)=>{
            return (c.columnTypes ?? []).includes(columnType);
        });
    }
    getRowGroupedColumns() {
        return this.getLayoutApi().getCurrentRowGroupsColumnIds()?.map((n)=>{
            return this.getColumnWithColumnId(n);
        });
    }
    setColumnCaption(columnId, caption) {
        return this.getLayoutApi().setColumnCaption(columnId, caption);
    }
    getAGGridColDefForColumnId(columnId) {
        return this.getAgGridApi().getColumnDef(columnId);
    }
    getAGGridColumnForColumnId(columnId) {
        return this.getAgGridApi().getColumn(columnId);
    }
    hasColumnType(columnIdentifier, columnType) {
        if (!columnIdentifier) return false;
        const colDef = typeof columnIdentifier === 'string' ? this.getAgGridApi().getColumnDef(columnIdentifier) : columnIdentifier;
        if (!colDef?.type) return false;
        if (Array.isArray(colDef.type)) return colDef.type.includes(columnType);
        else return colDef.type === columnType;
    }
    getColumnSummaryForColumnId(columnId) {
        const column = this.getColumnWithColumnId(columnId);
        if (!column) return undefined;
        const gridCellsWithCount = this._adaptable.getDistinctGridCellsForColumn(column);
        const columnFilter = this.getColumnFilterApi().getColumnFilterForColumn(column.columnId);
        const uniqueGridCells = gridCellsWithCount.map((gcWithCount)=>{
            return {
                rawValue: gcWithCount.rawValue,
                normalisedValue: gcWithCount.normalisedValue,
                displayValue: gcWithCount.displayValue,
                visible: gcWithCount.visible,
                count: gcWithCount.count,
                visibleCount: gcWithCount.visibleCount
            };
        });
        return {
            column: column,
            columnFilter: columnFilter,
            uniqueGridCells: uniqueGridCells
        };
    }
    isAgGridGeneratedColumn(columnId) {
        const column = this.getColumnWithColumnId(columnId);
        if (!column) return true;
        return column.isGeneratedRowGroupColumn || column.isGeneratedSelectionColumn || column.isGeneratedPivotResultColumn;
    }
}





// AG GRID obfuscates its internals, this is (currently) the best way to get hold of its internal services
const $45759c221bd07273$var$DANGER_AG_GRID_BEANS_MAP = {};
const $45759c221bd07273$var$getColumnApiModule = ()=>(0, $437b23f6a393c3bf$export$5c4abee658e86c68);
class $45759c221bd07273$export$787bb8cf103677e0 {
    _adaptableInstance;
    DANGER_USE_GETTER_gridApi;
    DANGER_gridApi_from_args;
    // see #gridOpts_monkey_patch
    DANGER_updateGridOptionsMonkeyPatcher;
    // see #aggColumnFilters_monkey_patch
    DANGER_doFiltersPassMonkeyPatcher;
    DANGER_isAggFilterPresentMonkeyPatcher;
    activePivotColumnFilters_MEMO = new WeakMap();
    initialGridOptions;
    _agGridId;
    constructor(_adaptableInstance, config){
        this._adaptableInstance = _adaptableInstance;
        const columnApiModuleReference = config?.getAgGridColumnApiModuleReference?.() ?? $45759c221bd07273$var$getColumnApiModule();
        const ColumnDefFactory_Prototype = columnApiModuleReference?.beans?.[0]?.prototype;
        if (!ColumnDefFactory_Prototype) console.error(`CRITICAL: could not get hold of AG Grid beans, this should never happen!`);
        else {
            const ColumnDefFactory_Prototye_preWireBeans = ColumnDefFactory_Prototype.preWireBeans;
            ColumnDefFactory_Prototype.preWireBeans = function(beans) {
                ColumnDefFactory_Prototye_preWireBeans?.apply(this, arguments);
                const gridId = beans?.context?.getId();
                if (!gridId) console.error('CRITICAL: No gridId found in beans, this should never happen!');
                $45759c221bd07273$var$DANGER_AG_GRID_BEANS_MAP[gridId] = beans;
            };
        }
    }
    destroy() {
        delete $45759c221bd07273$var$DANGER_AG_GRID_BEANS_MAP[this._agGridId];
        this.initialGridOptions = null;
        this.DANGER_gridApi_from_args = null;
        this.DANGER_USE_GETTER_gridApi = null;
        this.DANGER_updateGridOptionsMonkeyPatcher = null;
        this.DANGER_doFiltersPassMonkeyPatcher = null;
        this.DANGER_isAggFilterPresentMonkeyPatcher = null;
        this.activePivotColumnFilters_MEMO = null;
        this._adaptableInstance = null;
    }
    get adaptableOptions() {
        return this._adaptableInstance.adaptableOptions;
    }
    get adaptableApi() {
        return this._adaptableInstance.api;
    }
    get logger() {
        return this._adaptableInstance.logger;
    }
    getActivePivotColumnFilters() {
        // we memoize based on layout column filters object reference
        // this method is called for each row during filtering so we need to optimize it
        const layoutColumnFilters = this.adaptableApi.layoutApi.internalApi.getCurrentLayout_perfOptimized()?.ColumnFilters;
        if (!layoutColumnFilters) return [];
        const memoizedColumnFilters = this.activePivotColumnFilters_MEMO.get(layoutColumnFilters);
        if (memoizedColumnFilters) return memoizedColumnFilters;
        const pivotColumnFilters = this.adaptableApi.filterApi.columnFilterApi.getActiveColumnFilters().filter((columnFilter)=>this.adaptableApi.columnApi.isPivotResultColumn(columnFilter.ColumnId) || this.adaptableApi.columnApi.isAutoRowGroupColumnForSingle(columnFilter.ColumnId) || this.adaptableApi.columnApi.isPivotAggColumnWithNoPivotColumns(columnFilter.ColumnId)).filter((columnFilter)=>this.adaptableApi.filterApi.columnFilterApi.isColumnFilterActive(columnFilter)).filter((columnFilter)=>this.adaptableApi.expressionApi.internalApi.shouldEvaluatePredicatesInAdaptableQL('ColumnFilter', columnFilter, columnFilter.Predicates));
        this.activePivotColumnFilters_MEMO.set(layoutColumnFilters, pivotColumnFilters);
        return pivotColumnFilters;
    }
    get agGridOptionsService() {
        return this._adaptableInstance.agGridOptionsService;
    }
    setAgGridId(agGridId) {
        this._agGridId = agGridId;
    }
    setAgGridApi(gridApi) {
        this.DANGER_USE_GETTER_gridApi = gridApi;
    }
    getAgGridApi(skipLogging) {
        if (this.DANGER_USE_GETTER_gridApi) return this.DANGER_USE_GETTER_gridApi;
        if (this.DANGER_gridApi_from_args) return this.DANGER_gridApi_from_args;
        if (!skipLogging) console.error('AgGridApi is not available yet');
    }
    // #gridOpts_monkey_patch
    // we need to intercept some of the GridOptions updates and refresh the Adaptable state
    monkeyPatchingGridOptionsUpdates() {
        const agGridOptionsService = this.DANGER_getPrivateAgGridBeans()?.gos;
        if (!agGridOptionsService) return;
        const agGridOptionsServicePrototype = Object.getPrototypeOf(agGridOptionsService);
        const GridOptionsService_updateGridOptions = agGridOptionsServicePrototype.updateGridOptions;
        const self = this;
        this.DANGER_updateGridOptionsMonkeyPatcher = function({ options: options, force: force, source: source = 'api' }) {
            const passedColumnDefs = options.columnDefs;
            if (passedColumnDefs) {
                const colDefsWithSpecialColumns = self.getColumnDefinitionsInclSpecialColumns(passedColumnDefs);
                const allDisplayedColIds = self.getAgGridApi().getAllDisplayedColumns().map((col)=>col.getColId());
                // mark as hidden the colDefs of special columns which are not visible
                self.patchColDefs(colDefsWithSpecialColumns, (colDef)=>{
                    if (self.adaptableApi.columnApi.internalApi.isSpecialColumn(colDef.colId)) colDef.hide = !allDisplayedColIds.includes(colDef.colId);
                });
                // for pre-existing ColDefs, keep the filter property from the previous one
                if (self.adaptableApi.optionsApi.getFilterOptions().useAdaptableFiltering) {
                    const hasActiveFilters = self.adaptableApi.filterApi.columnFilterApi.getActiveColumnFilters().length;
                    // theoretically we should always update the filter property
                    // practically, only do it if there are active filters to avoid unnecessary processing
                    if (hasActiveFilters) self.patchColDefs(colDefsWithSpecialColumns, (colDef)=>{
                        if (colDef.filter !== false) {
                            const originalColDef = self.getAgGridApi().getColumnDef(colDef.colId);
                            if (originalColDef) colDef.filter = originalColDef.filter;
                        }
                    });
                }
                options['columnDefs'] = colDefsWithSpecialColumns;
                self.logger.info(`Added special columns on GridOptions.columnDefs update (source="${source}").`);
            }
            // `context`
            const passedContext = options.context;
            if (passedContext) {
                passedContext['__adaptable'] = self._adaptableInstance;
                passedContext['adaptableApi'] = self.adaptableApi;
            }
            // we mutated the options array, so it's OK to use the 'arguments' object
            GridOptionsService_updateGridOptions.apply(this, arguments);
        };
        agGridOptionsService.updateGridOptions = this.DANGER_updateGridOptionsMonkeyPatcher;
    }
    monkeyPatchingAggColumnFilters() {
        if (!this.adaptableApi.optionsApi.getFilterOptions().useAdaptableFiltering) // monkey patching is only needed if Adaptable is used for filtering
        return;
        const agGridColumnFilterService = this.DANGER_getPrivateAgGridBeans()?.colFilter;
        if (!agGridColumnFilterService) {
            this.logger.consoleError('Failed to initialize ColumnFilterService. Filtering and related features will not function correctly.');
            return;
        }
        const self = this;
        // https://github.com/ag-grid/ag-grid/blob/8409e99c8010473356a878e9bdfb836a5ea16718/packages/ag-grid-community/src/filter/columnFilterService.ts#L240
        // monkey patch ColumnFilterService.doAggregateFiltersPass because currently Adaptable does NOT override the ColumnFilters
        // (it uses the `doesExternalFilterPass` to evaluate the filters on the client side)
        // #doAggregateFiltersPassMonkeyPatcher
        const original_doFilterPass = agGridColumnFilterService.doFiltersPass;
        this.DANGER_doFiltersPassMonkeyPatcher = function(rowNode, colIdToSkip, targetAggregates) {
            if (!targetAggregates) // if targetAggregates is not set, we are not in the aggregation phase
            // so we can use the original doFiltersPass
            return original_doFilterPass.call(this, rowNode, colIdToSkip);
            if (!self.adaptableApi.layoutApi.isCurrentLayoutPivot()) // should NEVER happen
            return true;
            const pivotColumnFilters = self.getActivePivotColumnFilters();
            try {
                if (pivotColumnFilters.length > 0) for (const columnFilter of pivotColumnFilters){
                    const columnFilterEvaluationResult = self.adaptableApi.filterApi.columnFilterApi.internalApi.evaluateColumnFilter(columnFilter, rowNode);
                    if (!columnFilterEvaluationResult) return false;
                // else continue to next filter
                }
            } catch (ex) {
                self.logger.error(ex);
                return true;
            }
            return true;
        };
        agGridColumnFilterService.doFiltersPass = this.DANGER_doFiltersPassMonkeyPatcher;
        this.DANGER_isAggFilterPresentMonkeyPatcher = function() {
            return self.getActivePivotColumnFilters().length > 0;
        };
        agGridColumnFilterService.isAggFilterPresent = this.DANGER_isAggFilterPresentMonkeyPatcher;
    }
    DANGER_getPrivateAgGridBeans() {
        const beans = $45759c221bd07273$var$DANGER_AG_GRID_BEANS_MAP[this._agGridId];
        if (!beans) this.logger.consoleError('Failed to access AG Grid internal beans. Adaptable will not function correctly.');
        return beans;
    }
    DANGER_getLiveGridOptions() {
        return this.DANGER_getPrivateAgGridBeans()?.gridOptions;
    }
    getAgGridRootElement() {
        return this.DANGER_getPrivateAgGridBeans()?.eGridDiv;
    }
    /**
     * When AG Grid is rendered the first time, the AG GridApi is not yet set in the Adaptable context (as it's set only AFTER the grid is fully initialised)
     * yet we need it when evaluating custom GridOptions properties on the first render.
     * to handle this edge case, we try to extract the AG GridApi from the invocation arguments
     */ grabAgGridApiOnTheFly(args) {
        if (this.DANGER_USE_GETTER_gridApi || this.DANGER_gridApi_from_args) return;
        if (Array.isArray(args) && args[0] && typeof args[0].api === 'object' && // can't ise instanceof operator because gridApi is exported as interface
        typeof args[0].api?.getGridId === 'function') this.DANGER_gridApi_from_args = args[0].api;
    }
    updateGridOptions(options) {
        if (this.getAgGridApi()?.isDestroyed()) return;
        this.getAgGridApi()?.updateGridOptions(options);
    }
    getGridOption(key) {
        if (this.getAgGridApi()?.isDestroyed()) return;
        return this.getAgGridApi()?.getGridOption(key);
    }
    setGridOption(key, value) {
        if (this.getAgGridApi()?.isDestroyed()) return;
        this.getAgGridApi()?.setGridOption(key, value);
    }
    getUserGridOptionsProperty(propertyName) {
        return this.agGridOptionsService.getUserGridOptionsProperty(propertyName);
    }
    getColumnDefinitionsInclSpecialColumns(agGridColDefs) {
        const allColDefs = this.enhanceColDefsWithSpecialColumns(agGridColDefs ?? this.getAgGridApi().getColumnDefs());
        return allColDefs;
    }
    enhanceColDefsWithSpecialColumns(agGridColDefs) {
        this.assignColumnIdsToColDefs(agGridColDefs);
        const specialColDefs = this.getSpecialColDefs();
        const isSpecialColDef = (colDef)=>{
            const { type: type } = colDef;
            const colTypes = Array.isArray(type) ? type : [
                type
            ];
            return colTypes.some((colType)=>[
                    (0, $b0d14b794bdca4f2$export$bc60d51b21bb9885),
                    (0, $b0d14b794bdca4f2$export$8e5ee678cfc318c5),
                    (0, $b0d14b794bdca4f2$export$2460c0dec1fc4d43),
                    (0, $b0d14b794bdca4f2$export$aee5eaf013923665)
                ].includes(colType));
        };
        const processedSpecialColDefIds = [];
        const mapColDefs = (colDefs)=>{
            return colDefs.map((colDef)=>{
                if (this._adaptableInstance.agGridColumnAdapter.isColGroupDef(colDef)) {
                    // if it's a group column, recursively map its children
                    colDef.children = mapColDefs(colDef.children);
                    return colDef;
                } else {
                    if (!isSpecialColDef(colDef)) // if it's not a special column, return it as is
                    // without a minWidth, columns in details grid are VERY wide
                    // so the line below fixes https://github.com/AdaptableTools/adaptable/issues/2559
                    return {
                        minWidth: 10,
                        ...colDef
                    };
                    const newlyCreatedSpecialColDef = specialColDefs.find((specialColDef)=>specialColDef.colId === colDef.colId);
                    if (newlyCreatedSpecialColDef) {
                        // if it's a special column and we have a special col def for it, return the special col def
                        processedSpecialColDefIds.push(colDef.colId);
                        // merge the user defined colDef with the special col def
                        // this way the user may provide some custom settings for the special col def (tooltip, etc)
                        const mergedColDef = {
                            // see above comment for minWidth
                            minWidth: 10,
                            ...colDef,
                            ...newlyCreatedSpecialColDef
                        };
                        return mergedColDef;
                    } else // otherwise, return the original col def
                    return colDef;
                }
            });
        };
        let resultColDefs = mapColDefs(agGridColDefs);
        // check if there are any special colDefs that were not processed
        // in that case, add them to the end of the colDefs
        specialColDefs.forEach((specialColDef)=>{
            if (!processedSpecialColDefIds.includes(specialColDef.colId)) resultColDefs.push(specialColDef);
        });
        // remove special column that are no longer defined
        resultColDefs = resultColDefs.filter((colDef)=>{
            if (isSpecialColDef(colDef)) // must be in specialColDefs
            return specialColDefs.some((specialColDef)=>specialColDef.colId === colDef.colId);
            return true;
        });
        return resultColDefs;
    }
    getSpecialColDefs() {
        const specialColDefs = [
            ...this.adaptableApi.calculatedColumnApi.internalApi.getColDefsForCalculatedColumns(),
            ...this.adaptableApi.actionColumnApi.internalApi.getColDefsForActionColumns(),
            ...this.adaptableApi.freeTextColumnApi.internalApi.getColDefsForFreeTextColumns(),
            ...this.adaptableApi.fdc3Api.internalApi.getFdc3ActionColDefs()
        ];
        this.assignColumnIdsToColDefs(specialColDefs);
        return specialColDefs;
    }
    deriveSelectedCellInfoFromAgGrid() {
        const selected = this.getAgGridApi().getCellRanges();
        const columns = [];
        const gridCells = [];
        // we iterate for each ranges
        selected.forEach((rangeSelection)=>{
            let shouldIncludeRange = true;
            if (rangeSelection.startRow && rangeSelection.endRow) {
                let isStartRowPin = rangeSelection.startRow.rowPinned != null;
                let isEndRowPin = rangeSelection.endRow.rowPinned != null;
                // Warn user if trying to select pinned rows and if only selecting them, stop
                if (isStartRowPin) {
                    if (isEndRowPin) shouldIncludeRange = false;
                    this.logger.consoleWarn('Pinned rows cannot be selected in AG Grid.');
                }
                if (shouldIncludeRange) {
                    const y1 = Math.min(rangeSelection.startRow.rowIndex, rangeSelection.endRow.rowIndex);
                    const y2 = Math.max(rangeSelection.startRow.rowIndex, rangeSelection.endRow.rowIndex);
                    for (const column of rangeSelection.columns)if (column != null) {
                        const colId = column.getColId();
                        const selectedColumn = this.adaptableApi.columnApi.getColumnWithColumnId(colId);
                        if (selectedColumn && !columns.includes(selectedColumn)) columns.push(selectedColumn);
                        for(let rowIndex = y1; rowIndex <= y2; rowIndex++){
                            const rowNode = this.getAgGridApi().getDisplayedRowAtIndex(rowIndex);
                            // we used NOT to return grouped rows but I think that was wrong - if someone wants to return them then that is up to them...
                            // we definitely dont return pinned rows as they cannot be selected
                            if (rowNode && !this.isPinnedRowNode(rowNode)) {
                                const selectedCell = this.adaptableApi.gridApi.getGridCellFromRowNode(rowNode, colId);
                                gridCells.push(selectedCell);
                            }
                        }
                    }
                }
            }
        });
        const selectedCellInfo = {
            columns: columns,
            gridCells: gridCells
        };
        return selectedCellInfo;
    }
    deriveSelectedRowInfoFromAgGrid() {
        const nodes = this.getAgGridApi().getSelectedNodes();
        const selectedRows = [];
        if (this._adaptableInstance.isInPivotMode()) //  dont perform row selection in pivot mode
        return undefined;
        if ((0, $9g4SS.default).IsNotNullOrEmpty(nodes)) nodes.forEach((node)=>{
            const rowInfo = {
                isMaster: !!(node.master != null && node.master == true),
                isExpanded: !!(node.expanded != null && node.expanded == true),
                isGroup: !!(node.group != null && node.group == true),
                isSelected: true,
                isDisplayed: node.displayed == true,
                rowGroupLevel: node.level
            };
            const gridRow = {
                primaryKeyValue: this.adaptableApi.gridApi.getPrimaryKeyValueForRowNode(node),
                rowData: node.data,
                rowNode: node,
                rowInfo: rowInfo
            };
            selectedRows.push(gridRow);
        });
        return {
            gridRows: selectedRows
        };
    }
    isPinnedRowNode(rowNode) {
        if (!rowNode) return false;
        if (rowNode.isRowPinned()) return true;
        return false;
    }
    createAdaptableColumnFromAgGridColumn(agGridColumn, colsToGroups) {
        const colId = agGridColumn.getColId();
        const colDef = agGridColumn.getColDef();
        const { columnApi: columnApi } = this.adaptableApi;
        const ColumnId = colId;
        const pkColumn = this.adaptableOptions.primaryKey;
        const ColumnGroup = colsToGroups?.[ColumnId];
        const isRealColumnGroup = ColumnGroup ? ColumnGroup.columnGroupId !== ColumnGroup.friendlyName : false;
        const isFdc3MainActionColumn = this.adaptableApi.fdc3Api.internalApi.isFdc3MainActionColumn(colId);
        let friendlyName;
        const isGeneratedRowGroupColumn = columnApi.isAutoRowGroupColumn(ColumnId);
        const isGeneratedSelectionColumn = columnApi.isSelectionColumn(ColumnId);
        const isGeneratedPivotResultColumn = columnApi.isPivotResultColumn(ColumnId) && !agGridColumn.isPrimary();
        const colExists = columnApi.doesColumnExist(ColumnId) || isGeneratedRowGroupColumn || isGeneratedPivotResultColumn;
        if (colExists) friendlyName = columnApi.getFriendlyNameForColumnId(ColumnId);
        else {
            const displayName = this.getAgGridApi().getDisplayNameForColumn(agGridColumn, 'header');
            const columnFriendlyName = this.adaptableOptions.columnOptions.columnFriendlyName;
            const customFriendlyName = typeof columnFriendlyName === 'function' ? columnFriendlyName({
                colId: colId,
                agColumn: agGridColumn,
                columnGroup: isRealColumnGroup ? ColumnGroup : undefined,
                displayName: displayName,
                ...this.adaptableApi.internalApi.buildBaseContext()
            }) : null;
            friendlyName = customFriendlyName ?? (isFdc3MainActionColumn ? (0, $58846ea7f4156db7$export$1c47315f3c982417) : displayName);
            // Add Column Group;s friendlyname to the Column Friendly Name if its in a legitimate Column Group
            if (this.adaptableOptions.columnOptions.addColumnGroupToColumnFriendlyName && ColumnGroup && ColumnGroup.columnGroupId !== ColumnGroup.friendlyName) friendlyName += ' [' + ColumnGroup.friendlyName + ']';
        }
        const dataType = isGeneratedPivotResultColumn ? 'number' : this.deriveAdaptableColumnDataType(agGridColumn, false);
        const isTreeColumn = this.isTreeColumn(isGeneratedRowGroupColumn);
        const isUIHiddenColumn = this.adaptableApi.columnApi.internalApi.isColumnUIHidden(colDef);
        const visible = !isUIHiddenColumn || agGridColumn.isVisible();
        const isGenerated = isGeneratedRowGroupColumn || isGeneratedPivotResultColumn || isGeneratedSelectionColumn;
        const abColumn = {
            Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
            isTreeColumn: isTreeColumn,
            columnId: ColumnId,
            field: colDef.field,
            resizable: colDef.resizable !== false,
            friendlyName: friendlyName,
            isPrimaryKey: ColumnId === pkColumn,
            dataType: dataType,
            visible: visible,
            isUIHiddenColumn: isUIHiddenColumn,
            readOnly: this.isColumnReadonly(colDef),
            columnGroup: ColumnGroup,
            fieldOnly: isGenerated ? false : this.isColumnFieldonly(colDef),
            sortable: isGenerated ? false : this.isColumnSortable(colDef),
            filterable: this.isColumnFilterable(colDef),
            queryable: true,
            exportable: true,
            groupable: isGenerated ? false : this.isColumnRowGroupable(colDef),
            pivotable: isGenerated ? false : this.isColumnPivotable(colDef),
            aggregatable: isGenerated ? false : this.isColumnAggregetable(colDef),
            availableAggregationFunctions: null,
            aggregationFunction: null,
            moveable: this.isColumnMoveable(colDef),
            hideable: this.isColumnHideable(colDef),
            isGrouped: isGenerated ? false : this.isColumnRowGrouped(colDef),
            isGeneratedRowGroupColumn: isGeneratedRowGroupColumn,
            isGeneratedSelectionColumn: isGeneratedSelectionColumn,
            isGeneratedPivotResultColumn: isGeneratedPivotResultColumn,
            isFixed: this.isColumnFixed(colDef),
            pinned: this.getColumnPinnedPosition(colDef),
            columnTypes: this.getColumnTypes(colDef),
            isSparkline: this.isColumnSparkline(colDef),
            isCalculatedColumn: this.isCalculatedColumn(colDef),
            isFreeTextColumn: this.isFreeTextColumn(colDef),
            isActionColumn: this.isActionColumn(colDef),
            isPivotTotalColumn: this.isPivotTotalColumn(colDef)
        };
        abColumn.queryable = this.isColumnQueryable(abColumn);
        abColumn.exportable = this.isColumnExportable(abColumn);
        if (abColumn.aggregatable) {
            abColumn.availableAggregationFunctions = this.getColumnAggregationFunctions(colDef);
            if (typeof colDef.aggFunc === 'string') abColumn.aggregationFunction = colDef.aggFunc;
        }
        return abColumn;
    }
    deriveAdaptableColumnDataType(agColumn, logWarning = true) {
        // Some columns can have no ID or Title. we return string as a consequence but it needs testing
        if (!agColumn) {
            this.logger.warn('Column is undefined. Defaulting data type to "text".');
            return 'text';
        }
        if (this.adaptableApi.columnApi.isAutoRowGroupColumnForSingle(agColumn.getId())) return 'groupColumn';
        if (this.adaptableApi.columnApi.isSelectionColumn(agColumn.getId())) return 'unknown';
        if (this.adaptableApi.columnApi.isAutoRowGroupColumnForMulti(agColumn.getId())) {
            const rowGroupKey = agColumn.getColDef().showRowGroup;
            if (typeof rowGroupKey !== 'string') return 'unknown';
            const groupedColumn = this.adaptableApi.agGridApi.getColumn(rowGroupKey);
            if (!groupedColumn) return 'unknown';
            return this.deriveAdaptableColumnDataType(groupedColumn, logWarning);
        }
        const colDefType = [].concat(agColumn.getColDef()?.type || []).filter(Boolean);
        const skippedSpecialCols = [
            'actionColumn',
            'fdc3Column'
        ];
        if (skippedSpecialCols.some((specialColType)=>colDefType.includes(specialColType))) return 'unknown';
        let dataType = 'unknown';
        // get the column type if already in store (and not unknown)
        const existingColumn = this.adaptableApi.columnApi.getColumnWithColumnId(agColumn.getId(), logWarning);
        if (existingColumn && existingColumn.dataType !== 'unknown') return existingColumn.dataType;
        // check for colDef dataType
        const colDefDataType = agColumn.getColDef().cellDataType;
        if (typeof colDefDataType === 'string' && (0, $66ac1c1926a7c094$export$a57edebad87b3bdd).includes(colDefDataType)) return colDefDataType;
        // see #agGridDataTypeDefinitions
        // theoretically, if AG Grid was not able to infer the type, we should not be able to either
        // but we give it a try, AG Grid is limited when the colDef has a valueGetter, valueParser, etc
        // see https://www.ag-grid.com/javascript-data-grid/cell-data-types/#inferring-data-types
        let row = this.getAgGridApi().getDisplayedRowAtIndex(0);
        if (row == null) {
            // possible that there will be no data.
            this.logger.consoleError(`No data in grid. Returning type "unknown" for column "${agColumn.getColId()}". This will affect features such as Filters and Column Formats.`);
            return 'unknown';
        }
        // // if it's a group we need the content of the group
        // if (row.group) {
        //   const childNodes = row.childrenAfterGroup;
        //   if (ArrayExtensions.IsNullOrEmpty(childNodes)) {
        //     this.logger.consoleError(
        //       `No data in grid, returning type "unknown" for Column: "${agColumn.getColId()}". This will impact several Adaptable features, such as Filters and ColumnFormats.`
        //     );
        //     return 'unknown';
        //   }
        //   row = childNodes[0];
        // }
        const value = this._agGridApi_getValue(agColumn, row);
        switch(typeof value){
            case 'string':
                dataType = 'text';
                break;
            case 'number':
                dataType = 'number';
                break;
            case 'boolean':
                dataType = 'boolean';
                break;
            case 'object':
                dataType = 'object';
                break;
        }
        if (value instanceof Date) dataType = 'date';
        else if (Array.isArray(value)) {
            const arrayDataType = (0, $66ac1c1926a7c094$export$a57edebad87b3bdd).find((arrayType)=>{
                const dataTypeDefinition = (0, $66ac1c1926a7c094$export$4b0da9e77110f922)[arrayType];
                const dataTypeMatching = dataTypeDefinition?.dataTypeMatcher?.(value);
                return dataTypeMatching;
            });
            if (arrayDataType) dataType = arrayDataType;
        }
        this.logger.consoleWarn(`No explicit type for column "${agColumn.getColId()}". Inferred type from first row value: "${dataType}".`);
        return dataType;
    }
    isColumnReadonly(colDef) {
        if (!colDef) return true;
        // if the column has conditional/dynamic editability, we assume some rows may be editable
        if (typeof colDef.editable === 'function') return false;
        // otherwise we evaluate the colDef.editable property (columns are NOT editable by default)
        return !colDef.editable;
    }
    isColumnFieldonly(colDef) {
        if (colDef.hide == true && colDef.initialHide == true && colDef.lockVisible == true) return true;
        return false;
    }
    isColumnSortable(colDef) {
        if (colDef) return colDef.sortable ?? true;
        return false;
    }
    isColumnRowGroupable(colDef) {
        if (colDef && colDef.enableRowGroup != null) return colDef.enableRowGroup;
        return false;
    }
    isColumnPivotable(colDef) {
        if (colDef && colDef.enablePivot != null) return colDef.enablePivot;
        return false;
    }
    isColumnAggregetable(colDef) {
        if (colDef && colDef.enableValue != null) return colDef.enableValue;
        return false;
    }
    getColumnAggregationFunctions(colDef) {
        let result = [].concat(colDef.allowedAggFuncs || [
            'sum',
            'min',
            'max',
            'count',
            'avg',
            'first',
            'last'
        ]); // those are the default fns aggrid supports out-of-the-box
        const gridOptionsAggFuncs = this.adaptableApi.agGridApi.getGridOption('aggFuncs') || {};
        result.push(...Object.keys(gridOptionsAggFuncs));
        result = result.filter((func)=>!(0, $8b34480a73f8989d$export$baafdf6332da7837)(func));
        return [
            ...new Set(result)
        ];
    }
    isTreeColumn(isGeneratedRowGroupColumn) {
        return this.adaptableApi.gridApi.isTreeDataGrid() ? isGeneratedRowGroupColumn : false;
    }
    isColumnMoveable(colDef) {
        if (!colDef) return false;
        if (colDef.suppressMovable != null && colDef.suppressMovable == true) return false;
        if (this.isColumnFixed(colDef)) return false;
        return true;
    }
    isColumnQueryable(abColumn) {
        return(// !this.adaptableApi.columnApi.isPivotResultColumn(abColumn.columnId) &&
        this.adaptableApi.expressionApi.isColumnQueryable(abColumn));
    }
    isColumnExportable(abColumn) {
        return this.adaptableApi.exportApi.isColumnExportable(abColumn);
    }
    isColumnHideable(colDef) {
        if (!colDef) return false;
        if (this.adaptableApi.gridApi.isTreeDataGrid() && this.adaptableApi.columnApi.isAutoRowGroupColumn(colDef.colId)) return false;
        if (this.adaptableApi.columnApi.isSelectionColumn(colDef.colId)) return false;
        if (colDef.lockVisible != null && colDef.lockVisible == true) return false;
        return true;
    }
    isCalculatedColumn(colDef) {
        return this.adaptableApi.calculatedColumnApi.getCalculatedColumnForColumnId(colDef.colId) != null;
    }
    isFreeTextColumn(colDef) {
        return this.adaptableApi.freeTextColumnApi.getFreeTextColumnForColumnId(colDef.colId) != null;
    }
    isActionColumn(colDef) {
        return this.adaptableApi.actionColumnApi.getActionColumnForColumnId(colDef.colId) != null;
    }
    isPivotTotalColumn(colDef) {
        return (0, $49746e7bf2cf87d5$export$5bd0e023a792f54b)(colDef.colId) || (0, $1d01f71c6f4ca9d9$export$e8f3ce9d27d3bb8f)(colDef.colId) || (0, $abd79289c75d3093$export$605b4a9c6ba8ba9a)(colDef);
    }
    isColumnFilterable(colDef) {
        // follow agGrid logic which is that ONLY filterable if explicitly set
        if (this.adaptableApi.entitlementApi.getEntitlementAccessLevelForModule($42e863194fcb493f$export$edfe19743c8e0917) == 'Hidden') return false;
        return colDef != null && colDef.filter != null && colDef.filter != false;
    }
    getColumnTypes(colDef) {
        if (!colDef.type) return [];
        const allTypes = typeof colDef.type === 'string' ? [
            colDef.type
        ] : colDef.type;
        return allTypes;
    }
    getColumnPinnedPosition(colDef) {
        return colDef.pinned ? colDef.pinned === 'left' || colDef.pinned === true ? 'left' : 'right' : false;
    }
    // used for AG Grid when the column is FixedPinned, meaning it should never be unpinned
    isColumnFixed(colDef) {
        if (!colDef) return false;
        if (colDef.lockPosition != null && colDef.lockPosition == true) return true;
        if (colDef.lockPinned != null && colDef.lockPinned == true) return true;
        return false;
    }
    isColumnRowGrouped(colDef) {
        if (!colDef) return false;
        if (colDef.rowGroup != null && colDef.rowGroup == true) return true;
        if (colDef.rowGroupIndex != null) return true;
        return false;
    }
    isColumnSparkline(colDef) {
        // see https://www.ag-grid.com/javascript-data-grid/sparklines-overview/#enabling-sparklines
        return colDef?.cellRenderer === 'agSparklineCellRenderer';
    }
    isVisibleNode(rowNode) {
        const foundNode = this.getAgGridApi()?.getRenderedNodes().find((n)=>n.id == rowNode.id);
        return foundNode != null;
    }
    getFlattenedColDefs(colDefs = []) {
        const flattenedColDefs = [];
        colDefs.forEach((colDef)=>{
            if (colDef.children) flattenedColDefs.push(...this.getFlattenedColDefs(colDef.children));
            else flattenedColDefs.push(colDef);
        });
        this.assignColumnIdsToColDefs(flattenedColDefs);
        return flattenedColDefs;
    }
    /**
     * Mutates the colDefs to ensure that each column has a colId
     */ assignColumnIdsToColDefs(colDefs = []) {
        const assignColId = (colDef)=>{
            if (!colDef) return;
            if (colDef.field && !colDef.colId) colDef.colId = colDef.field;
            if (!colDef.colId) this.logger.warn('Column definition is missing colId. Provide either a "field" or "colId" property.', colDef);
        };
        this.patchColDefs(colDefs, assignColId);
    }
    patchColDefs(colDefs = [], patchFn) {
        const applyPatch = (colDef)=>{
            if (!colDef) return;
            if (!colDef.children) patchFn(colDef);
            if (colDef.children) colDef.children.forEach((childColDef)=>applyPatch(childColDef));
        };
        colDefs.forEach((colDef)=>applyPatch(colDef));
    }
    traverseColDefs(colDefs, modifyFn) {
        const applyModification = (colDef)=>{
            if ('children' in colDef) {
                const updatedChildren = colDef.children.map(applyModification).filter(Boolean);
                return {
                    ...colDef,
                    children: updatedChildren
                };
            } else return modifyFn(colDef);
        };
        return colDefs.map(applyModification).filter(Boolean);
    }
    getDefaultColumnDefinition() {
        // for early init phase, gridApi might not be ready yet
        return this.getAgGridApi(true)?.getGridOption('defaultColDef') ?? {};
    }
    _agGridApi_getValue(colKey, rowNode, gridApi) {
        gridApi = gridApi || this.getAgGridApi();
        return gridApi.getCellValue({
            colKey: colKey,
            rowNode: rowNode
        });
    }
}




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}




function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});


function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34)) errors = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(errors)), (0, $5c96a02c592fcff1$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f587043ffd615a90$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && 'closed' in value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.remove) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.add) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $528e75db69787807$export$8793edee2d425525() {}


var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}


var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8343668acd7c4a9b$export$f55210826850c514));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $92213d3dd6a83b5d$export$3e205fbb5df021e0)(error);
    else (0, $18eb28ff53cc4943$export$ebf645db02d3e99f)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $528e75db69787807$export$8793edee2d425525),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $528e75db69787807$export$8793edee2d425525)
};



var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();


function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}


function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7569c528cdd9d182$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0f1e8e2d1fe93adf$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.next) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.error) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $cf8ce74b80455e9f$export$60959659b2c22881) || $4f562137a990678a$var$isObserver(value) && (0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(value);
}




var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});




var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $43504509ae7aa03d$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $4f562137a990678a$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);



// ~ 8 hours
const $52eb362f093aaad8$var$MAX_TIMEFRAME_SIZE = 86400000;
class $52eb362f093aaad8$export$7f2f61054d5119ac {
    adaptable;
    emitter;
    cellDataChangeLogSubject$;
    cellDataChangeLog$;
    rowDataChangeLogSubject$;
    rowDataChangeLog$;
    undoChangeLog;
    undoChangeTimers;
    constructor(adaptable){
        this.adaptable = adaptable;
        this.adaptable = adaptable;
        this.emitter = new (0, $7ddf72f79776fa87$export$2e2bcd8739ae039)();
        this.cellDataChangeLogSubject$ = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
        this.cellDataChangeLog$ = this.cellDataChangeLogSubject$.asObservable();
        this.rowDataChangeLogSubject$ = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
        this.rowDataChangeLog$ = this.rowDataChangeLogSubject$.asObservable();
        this.undoChangeLog = new Map();
        this.undoChangeTimers = new Map();
    }
    destroy() {
        this.emitter.destroy();
        this.emitter = null;
        this.cellDataChangeLogSubject$.complete();
        this.cellDataChangeLogSubject$ = null;
        this.cellDataChangeLog$ = null;
        this.rowDataChangeLogSubject$.complete();
        this.rowDataChangeLogSubject$ = null;
        this.rowDataChangeLog$ = null;
        this.undoChangeLog.clear();
        this.undoChangeLog = null;
        this.undoChangeTimers.clear();
        this.undoChangeTimers = null;
    }
    on = (eventName, callback)=>this.emitter.on(eventName, callback);
    emit = (eventName, data)=>this.emitter.emit(eventName, data);
    CreateCellDataChangedEvent(cellDataChangedInfo) {
        if (cellDataChangedInfo.newValue != cellDataChangedInfo.oldValue) {
            this.emitter.emitSync('CellDataChanged', cellDataChangedInfo);
            this.adaptable.api.eventApi.internalApi.fireCellChangedEvent(cellDataChangedInfo);
            const dataChangeLogEntry = this.extractDataChangeLogEntry(cellDataChangedInfo);
            this.cellDataChangeLogSubject$.next(dataChangeLogEntry);
        }
    }
    CreateRowDataChangedEvent(rowDataChangedInfo) {
        this.emitter.emitSync('RowDataChanged', rowDataChangedInfo);
        this.adaptable.api.eventApi.internalApi.fireRowChangedEvent(rowDataChangedInfo);
        this.rowDataChangeLogSubject$.next(rowDataChangedInfo);
    }
    // we need this temporary "shared memory" because the value change and the AG Grid cellChanged event are asynchronous
    // in the first phase we keep the undone change
    logUndoChange(change) {
        const { primaryKeyValue: primaryKeyValue, column: column, oldValue: oldValue, newValue: newValue } = change;
        const undoChangeKey = this.getUndoChangeKey(primaryKeyValue, column.columnId, oldValue, newValue);
        this.undoChangeLog.set(undoChangeKey, change);
        // normally the extractUndoChange() should be executed right after this method
        // just to be sure that no 'zombie' undo change remains here (if something goes wrong with the undo value change)
        // we manually extract the change after a 2 seconds
        // why 2 and not 3 or 1? no good reason, only seems like a reasonable waiting time :)
        const UNDO_WAIT = 2000;
        const timeoutId = setTimeout(()=>{
            this.adaptable.logger.warn(`Undo change was not handled within timeout: column="${change.column}", primaryKey="${change.primaryKeyValue}", from=${change.newValue} to=${change.oldValue}.`);
            this.extractUndoChange(change);
        }, UNDO_WAIT);
        this.undoChangeTimers.set(undoChangeKey, timeoutId);
    }
    // in the second phase, when AG-Grid triggers the cellChange event, we check if it corresponds to an undone change
    extractUndoChange(change) {
        const { primaryKeyValue: primaryKeyValue, column: column, oldValue: oldValue, newValue: newValue } = change;
        // this is post-undo, so we have to swap the new & old values
        const undoChangeKey = this.getUndoChangeKey(primaryKeyValue, column.columnId, newValue, oldValue);
        const result = this.undoChangeLog.get(undoChangeKey);
        this.undoChangeLog.delete(undoChangeKey);
        const timeoutId = this.undoChangeTimers.get(undoChangeKey);
        if (timeoutId) clearTimeout(timeoutId);
        return result;
    }
    getUndoChangeKey(primaryKeyValue, columnId, previousValue, newValue) {
        return JSON.stringify({
            primaryKeyValue: primaryKeyValue,
            columnId: columnId,
            previousValue: previousValue,
            newValue: newValue
        });
    }
    extractDataChangeLogEntry(cellDataChangedInfo) {
        // create rowData snapshot
        const rowData = cellDataChangedInfo.rowData ? (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).cloneObject(cellDataChangedInfo.rowData) : null;
        // strip down rowNode properties as it is pretty "heavy" on the memory
        const rowNode = rowData ? {
            data: rowData
        } : null;
        return {
            ...cellDataChangedInfo,
            rowNode: rowNode,
            rowData: rowData
        };
    }
}


// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


/**
 * @ReduxAction Plugins have been instantiated
 */ const $b332b9d7a4fcbf15$export$83a189a0bfc0e957 = 'PLUGINS_SET_PLUGIN_STATE';
const $b332b9d7a4fcbf15$export$bf8267dee15d27a1 = 'IPUSHPULL_SET_THROTTLE_TIME';
const $b332b9d7a4fcbf15$export$5cf68f01567f5ed0 = 'IPUSHPULL_SEND_SNAPSHOT';
const $b332b9d7a4fcbf15$export$7de6969e817347b8 = 'IPUSHPULL_REPORT_SELECT';
const $b332b9d7a4fcbf15$export$823995ecb5bf874d = 'IPUSHPULL_START_LIVE_DATA';
const $b332b9d7a4fcbf15$export$18523e8ab138b69e = 'IPUSHPULL_STOP_LIVE_DATA';
const $b332b9d7a4fcbf15$export$719706ab038ecef2 = 'IPUSHPULL_ADD_PAGE';
const $b332b9d7a4fcbf15$export$97611c4cb3a0ddd = 'IPUSHPULL_LOGIN';
const $b332b9d7a4fcbf15$export$ee380c94afcad085 = 'IPUSHPULL_LOGOUT';
const $b332b9d7a4fcbf15$export$1e66daa4a0883a40 = 'IPUSHPULL_SET_LOGIN_ERROR_MESSAGE';
const $b332b9d7a4fcbf15$export$1cc9a47c9c4d4576 = 'IPUSHPULL_SET_LOGIN_DETAILS';
const $b332b9d7a4fcbf15$export$326dcf8038b1f6b4 = 'IPUSHPULL_SET_AVAILABLE_ON';
const $b332b9d7a4fcbf15$export$c355a1c1eba845f = 'SET_IPUSHPULL_AVAILABLE_OFF';
const $b332b9d7a4fcbf15$export$ff61e0626166116d = 'IPUSHPULL_SET_RUNNING_ON';
const $b332b9d7a4fcbf15$export$4da857739f70194b = 'IPUSHPULL_SET_RUNNING_OFF';
const $b332b9d7a4fcbf15$export$517a85d932dcb8ac = 'IPUSHPULL_LIVE_REPORT_SET';
const $b332b9d7a4fcbf15$export$929ea367be1723ce = 'IPUSHPULL_LIVE_REPORT_CLEAR';
const $b332b9d7a4fcbf15$export$90fd41a2d8f80c6d = 'IPUSHPULL_DOMAIN_PAGES_SET';
const $b332b9d7a4fcbf15$export$a4523662c2a48494 = 'IPUSHPULL_DOMAIN_PAGES_CLEAR';
const $b332b9d7a4fcbf15$export$724fba4549257566 = 'IPUSHPULL_SET_CURRENT_REPORTNAME';
const $b332b9d7a4fcbf15$export$91291e6c6b03ce02 = 'IPUSHPULL_SET_CURRENT_FOLDER';
const $b332b9d7a4fcbf15$export$1fc55e03b87b7d30 = 'IPUSHPULL_SET_CURRENT_PAGE';
const $b332b9d7a4fcbf15$export$68fb732f543467a4 = 'IPUSHPULL_SET_AVAILABLE_PAGES';
const $b332b9d7a4fcbf15$export$911e8a97e3c61662 = 'OPENFIN_START_LIVE_DATA';
const $b332b9d7a4fcbf15$export$310dafd5f2fc4cb5 = 'OPENFIN_STOP_LIVE_DATA';
const $b332b9d7a4fcbf15$export$efeef044f2baa275 = 'OPENFIN_LIVE_REPORT_SET';
const $b332b9d7a4fcbf15$export$27d7cdd79117496e = 'OPENFIN_LIVE_REPORT_CLEAR';
const $b332b9d7a4fcbf15$export$c7274308189b07f5 = 'OPENFIN_SET_AVAILABLE_ON';
const $b332b9d7a4fcbf15$export$8aeb12ba9830deb7 = 'OPENFIN_SET_AVAILABLE_OFF';
const $b332b9d7a4fcbf15$export$4416203eb6e8f2b8 = 'OPENFIN_SET_RUNNING_ON';
const $b332b9d7a4fcbf15$export$81b8b0390db8dd6c = 'OPENFIN_SET_RUNNING_OFF';
const $b332b9d7a4fcbf15$export$611caa734cf3a8b1 = 'OPENFIN_SET_CURRENT_REPORTNAME';
const $b332b9d7a4fcbf15$export$9f87e8ba2c44ce84 = (pluginId, pluginState)=>({
        type: $b332b9d7a4fcbf15$export$83a189a0bfc0e957,
        pluginId: pluginId,
        pluginState: pluginState
    });
const $b332b9d7a4fcbf15$var$initialState = {};
const $b332b9d7a4fcbf15$export$4fb339c0e4751e8 = (state = $b332b9d7a4fcbf15$var$initialState, action)=>{
    switch(action.type){
        case $b332b9d7a4fcbf15$export$83a189a0bfc0e957:
            return {
                ...state,
                [action.pluginId]: action.pluginState
            };
        default:
            return state;
    }
};


const $dc56b6267ce4d0bb$export$c47d8ce909cf8380 = 'POPUP_SHOW_SCREEN';
const $dc56b6267ce4d0bb$export$cf163d70893aafb9 = 'POPUP_HIDE_SCREEN';
const $dc56b6267ce4d0bb$export$5c7f6607ec0d5b0e = 'POPUP_SHOW_ALERT';
const $dc56b6267ce4d0bb$export$f2b1b520172ffba6 = 'POPUP_SHOW_PROMPT';
const $dc56b6267ce4d0bb$export$74b4a9b72993a69b = 'POPUP_HIDE_PROMPT';
const $dc56b6267ce4d0bb$export$94afeca3afd2a2dd = 'POPUP_CONFIRM_PROMPT';
const $dc56b6267ce4d0bb$export$c3a6482c41ff8ccc = 'POPUP_SHOW_CONFIRMATION';
const $dc56b6267ce4d0bb$export$29f8bf18949d1efd = 'POPUP_CONFIRM_CONFIRMATION';
const $dc56b6267ce4d0bb$export$41a7351cd798b67f = 'POPUP_CANCEL_CONFIRMATION';
const $dc56b6267ce4d0bb$export$9bacfe07872f36f5 = 'POPUP_CLEAR_PARAM';
const $dc56b6267ce4d0bb$export$7a5783c59b91d2db = 'POPUP_SHOW_WINDOW';
const $dc56b6267ce4d0bb$export$271b2d3a7487d81a = 'POPUP_HIDE_WINDOW';
const $dc56b6267ce4d0bb$export$328ba7c39b4bde23 = 'POPUP_SHOW_FORM';
const $dc56b6267ce4d0bb$export$f6e86df071485d13 = 'POPUP_FORM_HIDE';
const $dc56b6267ce4d0bb$export$fc9ecba5bc6311f7 = 'PROGRESS_INDICATOR_SHOW';
const $dc56b6267ce4d0bb$export$ff1a8469042a7d31 = 'PROGRESS_INDICATOR_HIDE';
const $dc56b6267ce4d0bb$export$e2d5bba0b444685d = (componentModule, componentName, params, popupProps)=>({
        type: $dc56b6267ce4d0bb$export$c47d8ce909cf8380,
        ComponentModule: componentModule,
        ComponentName: componentName,
        Params: params,
        PopupProps: popupProps
    });
const $dc56b6267ce4d0bb$export$b591761538bae019 = ()=>({
        type: $dc56b6267ce4d0bb$export$cf163d70893aafb9
    });
const $dc56b6267ce4d0bb$export$b67e0d4344a1d3c5 = (config)=>({
        type: $dc56b6267ce4d0bb$export$7a5783c59b91d2db,
        Id: config.Id,
        Title: config.Title,
        PopupProps: config.PopupProps,
        FactoryId: config.FactoryId,
        Icon: config.Icon
    });
const $dc56b6267ce4d0bb$export$b142f1ca754367a7 = (id)=>({
        type: $dc56b6267ce4d0bb$export$271b2d3a7487d81a,
        Id: id
    });
const $dc56b6267ce4d0bb$export$16bbb31452c12825 = (config)=>({
        type: $dc56b6267ce4d0bb$export$328ba7c39b4bde23,
        Id: config.Id,
        Form: config.Form,
        FormProps: config.FormProps,
        prepareContext: config.prepareContext
    });
const $dc56b6267ce4d0bb$export$7429bcb1fd685d4f = (id)=>({
        type: $dc56b6267ce4d0bb$export$f6e86df071485d13,
        Id: id
    });
const $dc56b6267ce4d0bb$export$1f102b51d7fb4f69 = (alert)=>{
    return {
        type: $dc56b6267ce4d0bb$export$5c7f6607ec0d5b0e,
        alert: alert
    };
};
const $dc56b6267ce4d0bb$export$7e320e36addbb3a3 = (prompt)=>({
        type: $dc56b6267ce4d0bb$export$f2b1b520172ffba6,
        prompt: prompt
    });
const $dc56b6267ce4d0bb$export$7218cbaa092452b4 = ()=>({
        type: $dc56b6267ce4d0bb$export$74b4a9b72993a69b
    });
const $dc56b6267ce4d0bb$export$83efedeed0717f26 = (inputText)=>({
        type: $dc56b6267ce4d0bb$export$94afeca3afd2a2dd,
        InputText: inputText
    });
const $dc56b6267ce4d0bb$export$93a4701be822446e = (confirmation)=>({
        type: $dc56b6267ce4d0bb$export$c3a6482c41ff8ccc,
        confirmation: confirmation
    });
const $dc56b6267ce4d0bb$export$1e1f0cada24ded37 = (comment)=>({
        type: $dc56b6267ce4d0bb$export$29f8bf18949d1efd,
        comment: comment
    });
const $dc56b6267ce4d0bb$export$4a108f1b63094f83 = ()=>({
        type: $dc56b6267ce4d0bb$export$41a7351cd798b67f
    });
const $dc56b6267ce4d0bb$export$da35e74a9cc56e38 = ()=>({
        type: $dc56b6267ce4d0bb$export$9bacfe07872f36f5
    });
const $dc56b6267ce4d0bb$export$39707e86e75b7399 = (progressIndicatorConfig)=>({
        type: $dc56b6267ce4d0bb$export$fc9ecba5bc6311f7,
        progressIndicatorConfig: progressIndicatorConfig
    });
const $dc56b6267ce4d0bb$export$64e48e6d146f50a4 = ()=>({
        type: $dc56b6267ce4d0bb$export$ff1a8469042a7d31
    });
const $dc56b6267ce4d0bb$var$initialState = {
    ScreenPopup: {
        ShowScreenPopup: false,
        ComponentModule: undefined,
        ComponentName: '',
        Params: null
    },
    ConfirmationPopup: {
        ShowConfirmationPopup: false,
        Msg: '',
        Header: '',
        ConfirmButtonText: '',
        CancelButtonText: '',
        CancelAction: null,
        ConfirmAction: null,
        ShowInputBox: false,
        ConfirmationComment: null,
        MessageType: 'Info'
    },
    PromptPopup: {
        ShowPromptPopup: false,
        Header: '',
        Message: '',
        ConfirmAction: null
    },
    WindowPopup: {
        PopupList: []
    },
    FormPopup: {
        FormList: []
    },
    ProgressIndicator: {
        active: false,
        text: ''
    }
};
const $dc56b6267ce4d0bb$export$84403e5d7b9a413c = (state = $dc56b6267ce4d0bb$var$initialState, action)=>{
    switch(action.type){
        case $dc56b6267ce4d0bb$export$c47d8ce909cf8380:
            {
                let actionTypedShowPopup = action;
                let newScreenPopup = {
                    ShowScreenPopup: true,
                    ComponentModule: actionTypedShowPopup.ComponentModule,
                    ComponentName: actionTypedShowPopup.ComponentName,
                    Params: actionTypedShowPopup.Params,
                    PopupProps: actionTypedShowPopup.PopupProps
                };
                return Object.assign({}, state, {
                    ScreenPopup: newScreenPopup
                });
            }
        case $dc56b6267ce4d0bb$export$cf163d70893aafb9:
            {
                let newScreenPopup = {
                    ShowScreenPopup: false,
                    ComponentModule: undefined,
                    ComponentName: '',
                    Params: null
                };
                return Object.assign({}, state, {
                    ScreenPopup: newScreenPopup
                });
            }
        case $dc56b6267ce4d0bb$export$f2b1b520172ffba6:
            {
                let actionTyped = action;
                let newPromptPopup = {
                    ShowPromptPopup: true,
                    Header: actionTyped.prompt.Header,
                    Message: actionTyped.prompt.Msg,
                    ConfirmAction: actionTyped.prompt.ConfirmAction,
                    ConfirmActionCreator: actionTyped.prompt.ConfirmActionCreator,
                    DefaultValue: actionTyped.prompt.DefaultValue
                };
                return Object.assign({}, state, {
                    PromptPopup: newPromptPopup
                });
            }
        case $dc56b6267ce4d0bb$export$74b4a9b72993a69b:
            {
                let newPromptPopup = {
                    ShowPromptPopup: false,
                    Header: '',
                    Message: '',
                    ConfirmAction: null,
                    ConfirmActionCreator: null,
                    DefaultValue: ''
                };
                return Object.assign({}, state, {
                    PromptPopup: newPromptPopup
                });
            }
        case $dc56b6267ce4d0bb$export$94afeca3afd2a2dd:
            {
                //we dispatch the Action of ConfirmAction in the middelware in order to keep the reducer pure
                let newPromptPopup = {
                    ShowPromptPopup: false,
                    Header: '',
                    Message: '',
                    ConfirmAction: null
                };
                return Object.assign({}, state, {
                    PromptPopup: newPromptPopup
                });
            }
        case $dc56b6267ce4d0bb$export$c3a6482c41ff8ccc:
            {
                let actionTyped = action;
                let newConfirmationPopup = {
                    ShowConfirmationPopup: true,
                    Msg: actionTyped.confirmation.Msg,
                    Header: actionTyped.confirmation.Header,
                    ConfirmButtonText: actionTyped.confirmation.ConfirmButtonText,
                    CancelButtonText: actionTyped.confirmation.CancelButtonText,
                    ConfirmAction: actionTyped.confirmation.ConfirmAction,
                    CancelAction: actionTyped.confirmation.CancelAction,
                    ShowInputBox: actionTyped.confirmation.ShowInputBox,
                    ConfirmationComment: null,
                    MessageType: actionTyped.confirmation.MessageType
                };
                return Object.assign({}, state, {
                    ConfirmationPopup: newConfirmationPopup
                });
            }
        case $dc56b6267ce4d0bb$export$29f8bf18949d1efd:
            {
                let actionTyped = action;
                //we dispatch the Action of ConfirmAction in the middelware in order to keep the reducer pure
                let newConfirmationPopup = {
                    ShowConfirmationPopup: false,
                    Msg: '',
                    Header: '',
                    ConfirmButtonText: '',
                    CancelButtonText: '',
                    ConfirmAction: null,
                    CancelAction: null,
                    ShowInputBox: false,
                    ConfirmationComment: actionTyped.comment,
                    MessageType: null
                };
                return Object.assign({}, state, {
                    ConfirmationPopup: newConfirmationPopup
                });
            }
        case $dc56b6267ce4d0bb$export$41a7351cd798b67f:
            {
                //we dispatch the Action of CancelAction in the middleware in order to keep the reducer pure
                let newConfirmationPopup = {
                    ShowConfirmationPopup: false,
                    Msg: '',
                    Header: '',
                    ConfirmButtonText: '',
                    CancelButtonText: '',
                    ConfirmAction: null,
                    CancelAction: null,
                    ShowInputBox: false,
                    ConfirmationComment: null,
                    MessageType: null
                };
                return Object.assign({}, state, {
                    ConfirmationPopup: newConfirmationPopup
                });
            }
        case $dc56b6267ce4d0bb$export$9bacfe07872f36f5:
            {
                let newScreenPopup = {
                    ShowScreenPopup: state.ScreenPopup.ShowScreenPopup,
                    ComponentModule: state.ScreenPopup.ComponentModule,
                    ComponentName: state.ScreenPopup.ComponentName,
                    Params: null
                };
                return Object.assign({}, state, {
                    ScreenPopup: newScreenPopup
                });
            }
        case $dc56b6267ce4d0bb$export$7a5783c59b91d2db:
            {
                const showWindowAction = action;
                const windowSettings = {
                    Id: showWindowAction.Id,
                    Icon: showWindowAction.Icon,
                    Title: showWindowAction.Title,
                    PopupProps: showWindowAction.PopupProps,
                    FactoryId: showWindowAction.FactoryId
                };
                let PopupList = [
                    ...state.WindowPopup.PopupList
                ];
                // Prevent opening the same popup twice
                if (state.WindowPopup.PopupList.some((windowPopup)=>windowPopup.Id === windowSettings.Id)) PopupList = PopupList.map((windowPopup)=>{
                    if (windowPopup.Id !== windowSettings.Id) return windowPopup;
                    return {
                        ...windowPopup,
                        ...windowSettings
                    };
                });
                else PopupList = [
                    ...PopupList,
                    windowSettings
                ];
                return {
                    ...state,
                    WindowPopup: {
                        ...state.WindowPopup,
                        PopupList: PopupList
                    }
                };
            }
        case $dc56b6267ce4d0bb$export$271b2d3a7487d81a:
            {
                const PopupList = state.WindowPopup.PopupList.filter((windowPopup)=>windowPopup.Id !== action.Id);
                return {
                    ...state,
                    WindowPopup: {
                        ...state.WindowPopup,
                        PopupList: PopupList
                    }
                };
            }
        case $dc56b6267ce4d0bb$export$328ba7c39b4bde23:
            {
                const showWindowAction = action;
                const windowSettings = {
                    Id: showWindowAction.Id,
                    FormProps: showWindowAction.FormProps,
                    Form: showWindowAction.Form,
                    prepareContext: showWindowAction.prepareContext
                };
                if (state.FormPopup.FormList.some((windowPopup)=>windowPopup.Id === windowSettings.Id)) return state;
                const FormList = [
                    ...state.FormPopup.FormList,
                    windowSettings
                ];
                return {
                    ...state,
                    FormPopup: {
                        ...state.WindowPopup,
                        FormList: FormList
                    }
                };
            }
        case $dc56b6267ce4d0bb$export$f6e86df071485d13:
            {
                const FormList = state.FormPopup.FormList.filter((form)=>form.Id !== action.Id);
                return {
                    ...state,
                    FormPopup: {
                        ...state.WindowPopup,
                        FormList: FormList
                    }
                };
            }
        case $dc56b6267ce4d0bb$export$fc9ecba5bc6311f7:
            {
                const actionTypedAdd = action;
                const updatedState = {
                    ProgressIndicator: {
                        active: true,
                        text: actionTypedAdd.progressIndicatorConfig.text,
                        render: actionTypedAdd.progressIndicatorConfig.render,
                        frameworkComponent: actionTypedAdd.progressIndicatorConfig.frameworkComponent,
                        renderMode: actionTypedAdd.progressIndicatorConfig.renderMode
                    }
                };
                return Object.assign({}, state, updatedState);
            }
        case $dc56b6267ce4d0bb$export$ff1a8469042a7d31:
            {
                const updatedState = {
                    ProgressIndicator: {
                        active: false
                    }
                };
                return Object.assign({}, state, updatedState);
            }
        default:
            return state;
    }
};



/**
 * This method is like `merge` except that it accepts customizer which is
 * invoked to produce the merged values of the destination and source properties.
 * If customizer returns undefined, merging is handled by the method instead.
 * Drop-in replacement for lodash/mergeWith.
 */ 
function $95d27726641185c2$var$baseMergeWith(target, source, customizer) {
    if (source == null) return target;
    const keys = Object.keys(source);
    for (const key of keys){
        const srcValue = source[key];
        const tgtValue = target[key];
        const customResult = customizer(tgtValue, srcValue, key, target, source);
        if (customResult !== undefined) target[key] = customResult;
        else if (Array.isArray(srcValue)) {
            if (!Array.isArray(tgtValue)) target[key] = [];
            $95d27726641185c2$var$baseMergeWith(target[key], srcValue, customizer);
        } else if ((0, $9dc80662ca8a355b$export$2e2bcd8739ae039)(srcValue)) {
            if (!(0, $9dc80662ca8a355b$export$2e2bcd8739ae039)(tgtValue)) target[key] = {};
            $95d27726641185c2$var$baseMergeWith(target[key], srcValue, customizer);
        } else if (srcValue !== undefined) target[key] = srcValue;
    }
    return target;
}
function $95d27726641185c2$export$2e2bcd8739ae039(target, ...args) {
    // The last argument is the customizer function
    const customizer = args[args.length - 1];
    const sources = args.slice(0, -1);
    for (const source of sources)$95d27726641185c2$var$baseMergeWith(target, source, customizer);
    return target;
}


/**
 * Recursively merges own enumerable string keyed properties of source objects into
 * the destination object. Source properties that resolve to undefined are skipped if
 * a destination value exists. Array and plain object properties are merged recursively.
 * Other objects and value types are overridden by assignment.
 * Drop-in replacement for lodash/merge.
 */ 
function $88a6c58c74f77d1a$var$baseMerge(target, source) {
    if (source == null) return target;
    const keys = Object.keys(source);
    for (const key of keys){
        const srcValue = source[key];
        const tgtValue = target[key];
        if (Array.isArray(srcValue)) {
            if (!Array.isArray(tgtValue)) target[key] = [];
            $88a6c58c74f77d1a$var$baseMerge(target[key], srcValue);
        } else if ((0, $9dc80662ca8a355b$export$2e2bcd8739ae039)(srcValue)) {
            if (!(0, $9dc80662ca8a355b$export$2e2bcd8739ae039)(tgtValue)) target[key] = {};
            $88a6c58c74f77d1a$var$baseMerge(target[key], srcValue);
        } else if (srcValue !== undefined) target[key] = srcValue;
    }
    return target;
}
function $88a6c58c74f77d1a$export$2e2bcd8739ae039(target, ...sources) {
    for (const source of sources)$88a6c58c74f77d1a$var$baseMerge(target, source);
    return target;
}


/**
 * Checks if value is classified as an Array object.
 * Drop-in replacement for lodash/isArray.
 */ const $33c007de644dd40d$var$isArray = Array.isArray;
var $33c007de644dd40d$export$2e2bcd8739ae039 = $33c007de644dd40d$var$isArray;


/**
 * Checks if value is the language type of Object.
 * (e.g. arrays, functions, objects, regexes, new Number(0), and new String(''))
 * Drop-in replacement for lodash/isObject.
 */ function $97d9ab40dce3cff0$export$2e2bcd8739ae039(value) {
    const type = typeof value;
    return value != null && (type === 'object' || type === 'function');
}




function $4a1e94af0f77684f$var$customizer(objValue, srcValue) {
    if ((0, $33c007de644dd40d$export$2e2bcd8739ae039)(objValue)) {
        if (!Array.isArray(srcValue)) // TODO AFL: clarify if this is still relevant, after the state & options refactoring
        /**
             * the new value might be a function: eg: UserInterface.ContextMenuItems defaults to an array
             * in the redux state, while the user might provide a function
             * so in this case, make the user provided value win
             */ return srcValue;
        const length = srcValue ? srcValue.length : null;
        const result = (0, $95d27726641185c2$export$2e2bcd8739ae039)(objValue, srcValue, $4a1e94af0f77684f$var$customizer);
        if (length != null) // when merging arrays, lodash result has the length of the
        // longest array, but we don't want that to happen
        // so we restrict to the current length
        result.length = length;
        return result;
    }
}
function $4a1e94af0f77684f$export$c27403fa5b2847d4(stateObject = {}, source) {
    const traverseStateObject = (object)=>{
        Object.values(object).forEach((value)=>{
            // add a Source only to AdaptableObjects which do NOT already have a source defined
            if ((0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).isAdaptableObject(value) && value.Source == null) value.Source = source;
            if (value !== null && typeof value === 'object') traverseStateObject(value);
        });
    };
    traverseStateObject(stateObject);
    return stateObject;
}
function $4a1e94af0f77684f$export$1140e640eee92d28(configState, currentUserState) {
    const traverseStateObject = (configObject, stateObject)=>{
        Object.entries(configObject).forEach(([key, configValue])=>{
            const stateValue = stateObject[key];
            if (Array.isArray(configValue) && Array.isArray(stateValue)) {
                const userDefinedItems = stateValue.filter((item)=>{
                    return (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).isAdaptableObject(item) && item.Source !== 'InitialState';
                });
                configObject[key] = configValue.concat(userDefinedItems);
            // we probably don't need to call traverseStateObject on the array as well,
            // so we do the traversing on the else branch only
            } else if (configValue !== null && typeof configValue === 'object' && typeof stateValue === 'object') traverseStateObject(configValue, stateValue);
        });
    };
    traverseStateObject(configState, currentUserState);
    return configState;
}
function $4a1e94af0f77684f$var$deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function $4a1e94af0f77684f$export$36d39beb6c519c21(oldState, newState) {
    // return MergeState(oldState, newState);
    if (newState === '') newState = {};
    // add source 'InitialState' only to initial state objects
    const initialState = $4a1e94af0f77684f$export$c27403fa5b2847d4(oldState, 'InitialState');
    // source 'User' will be added to all other objects, after the merge (see bottom of this function)
    let state = newState;
    if (!state || typeof state !== 'object') {
        // in case loadState returns something different than an empty object
        (0, $10f858c943b30cc8$export$a58502b374804b0f).consoleWarnBase('State is something different than expected; expected an object, but received: ', state);
        state = {};
    }
    // any Module in config that doesn't exist in state will be added
    for(const initialStateModuleName in initialState)state[initialStateModuleName] = state[initialStateModuleName] ?? initialState[initialStateModuleName];
    // any Module in state that has an older revision than the config will be replaced
    for(const stateModuleName in state)if (initialState[stateModuleName] != undefined) {
        // explicitly use double equals, as we want to avoid null as well
        const stateRevision = state[stateModuleName].Revision ?? 0;
        const initialStateRevision = initialState[stateModuleName].Revision ?? 0;
        const stateRevisionKey = typeof stateRevision === 'object' ? stateRevision.Key : stateRevision;
        const initialStateRevisionBehaviour = typeof initialStateRevision === 'object' ? initialStateRevision.Behavior : 'Override';
        const initialStateRevisionKey = typeof initialStateRevision === 'object' ? initialStateRevision.Key : initialStateRevision;
        if (initialStateRevisionKey > stateRevisionKey) {
            if (initialStateRevisionBehaviour === 'Override') state[stateModuleName] = initialState[stateModuleName];
            else state[stateModuleName] = $4a1e94af0f77684f$export$1140e640eee92d28($4a1e94af0f77684f$var$deepClone(initialState[stateModuleName]), state[stateModuleName]);
        }
    }
    // add 'User' source to all state objects which do NOT have 'InitialState'
    const finalState = $4a1e94af0f77684f$export$c27403fa5b2847d4(state, 'User');
    return finalState;
}
function $4a1e94af0f77684f$export$d43dedc9f8ac227c(oldState, newState) {
    const result = Object.assign({}, oldState);
    for(const key in newState){
        if (!newState.hasOwnProperty(key)) continue;
        const value = newState[key];
        // Assign if we don't need to merge at all
        if (!result.hasOwnProperty(key)) {
            result[key] = (0, $97d9ab40dce3cff0$export$2e2bcd8739ae039)(value) && !Array.isArray(value) ? (0, $88a6c58c74f77d1a$export$2e2bcd8739ae039)({}, value) : value;
            continue;
        }
        const oldValue = result[key];
        if ((0, $97d9ab40dce3cff0$export$2e2bcd8739ae039)(value) && !Array.isArray(value)) // use both lodash functions so that we can merge from State onto Initial Adaptable State where it exists but from the former where it doesnt.
        result[key] = (0, $95d27726641185c2$export$2e2bcd8739ae039)({}, oldValue, value, $4a1e94af0f77684f$var$customizer);
        else result[key] = value;
    }
    return result;
}
let $4a1e94af0f77684f$var$initialState;
const $4a1e94af0f77684f$export$7a419cba89232acd = (rootReducer, LOAD_STATE_TYPE)=>{
    let finalReducer = rootReducer;
    finalReducer = (state, action)=>{
        if (action.type === LOAD_STATE_TYPE) {
            $4a1e94af0f77684f$var$initialState = $4a1e94af0f77684f$var$initialState ?? state;
            state = $4a1e94af0f77684f$export$d43dedc9f8ac227c($4a1e94af0f77684f$var$initialState, action.State);
            // put this new state on the action, since the root reducer further copies
            // keys from action.State to the new state
            action.State = state;
        }
        return rootReducer(state, action);
    };
    return finalReducer;
};



function $84331a0549ebfeb9$export$91a43078b1cf7697(adaptable) {
    return {
        adaptableId: adaptable.adaptableOptions.adaptableId,
        adaptableStateKey: adaptable.adaptableOptions.adaptableStateKey,
        userName: adaptable.adaptableOptions.userName,
        adaptableApi: adaptable.api,
        adaptableContext: adaptable.api?.optionsApi?.getAdaptableContext()
    };
}


const $1a574cfd3e51bf62$var$checkStatus = (response)=>{
    const error = new Error(response.statusText);
    if (response.status >= 200 && response.status < 300) return response;
    throw error;
};
const $1a574cfd3e51bf62$var$persistState = (state, config)=>{
    return new Promise((resolve, reject)=>{
        try {
            localStorage.setItem(config.adaptableStateKey, JSON.stringify(state));
            resolve();
        } catch (ex) {
            reject(ex);
        }
    });
};
const $1a574cfd3e51bf62$var$loadState = ({ adaptableId: adaptableId, adaptableStateKey: adaptableStateKey })=>{
    const jsonState = localStorage.getItem(adaptableStateKey);
    const parsedJsonState = JSON.parse(jsonState) || {};
    return Promise.resolve(parsedJsonState);
};
class $1a574cfd3e51bf62$var$AdaptableReduxLocalStorageEngine {
    adaptableId;
    adaptableStateKey;
    userName;
    initialState;
    loadState;
    persistState;
    constructor(config){
        this.adaptableId = config.adaptableId;
        this.adaptableStateKey = config.adaptableStateKey;
        this.userName = config.userName;
        this.initialState = config.initialState;
        this.loadState = config.loadState;
        this.persistState = config.persistState;
        this.save = config.debounceStateDelay > 0 ? (0, $c34d1d35432b7498$export$2e2bcd8739ae039)(this.save, config.debounceStateDelay, {
            maxWait: 1000
        }) : this.save;
    }
    setStateKey(adaptableStateKey) {
        this.adaptableStateKey = adaptableStateKey;
    }
    load(adaptableInstance, initialState = this.initialState) {
        return (this.loadState || $1a574cfd3e51bf62$var$loadState)((0, $84331a0549ebfeb9$export$91a43078b1cf7697)(adaptableInstance)).then((parsedJsonState)=>{
            // we need to merge the Initial Adaptable State
            return Promise.resolve(initialState).then((parsedInitialState)=>{
                return (0, $4a1e94af0f77684f$export$36d39beb6c519c21)(parsedInitialState, parsedJsonState);
            }).catch((err)=>(0, $10f858c943b30cc8$export$a58502b374804b0f).consoleErrorBase(`AdaptableId: ${this.adaptableId}`, err));
        });
    }
    save(adaptableInstance, state, actionName) {
        if (!adaptableInstance || adaptableInstance.isDestroyed) return Promise.resolve();
        return this.saveNow(adaptableInstance, state, actionName);
    }
    saveNow(adaptableInstance, state, actionName) {
        const config = (0, $84331a0549ebfeb9$export$91a43078b1cf7697)(adaptableInstance);
        config.actionName = actionName;
        config.previousState = adaptableInstance.adaptableStore.getPreviousStorageState() || null;
        let stateObject = structuredClone(state);
        const getTransformedState = adaptableInstance.adaptableOptions.stateOptions.saveState;
        if (getTransformedState) stateObject = getTransformedState(stateObject, config);
        const promise = (this.persistState || $1a574cfd3e51bf62$var$persistState)(stateObject, config)?.catch($1a574cfd3e51bf62$var$rejectWithMessage);
        if (!(promise instanceof Promise)) (0, $10f858c943b30cc8$export$a58502b374804b0f).consoleWarnBase(`AdaptableId: ${this.adaptableId}`, 'stateOptions.persistState should return a promise, it returned', 'Error', promise);
        return promise;
    }
}
function $1a574cfd3e51bf62$var$rejectWithMessage(error) {
    return Promise.reject(error.message);
}
function $1a574cfd3e51bf62$export$3f0b0800cb866b8e(config) {
    return new $1a574cfd3e51bf62$var$AdaptableReduxLocalStorageEngine(config);
}



const $f4d8c497686c0f4a$export$ad5de0913e0a99e1 = (alert)=>{
    return alert.alertType === 'cellChanged';
};
const $f4d8c497686c0f4a$export$c51f434865bcd0f0 = (alert)=>{
    return alert.alertType === 'rowChanged';
};






var $9OAZF = parcelRequire("9OAZF");

var $9OAZF = parcelRequire("9OAZF");
function $ffbf29d095efdf81$export$2e4af2fd9216aa7f(previewResults) {
    let hasAnyValidation = false;
    let hasAllValidation = true;
    previewResults.forEach((previewResult)=>{
        const hasValidationErrors = previewResult.validationRules.length > 0;
        if (hasValidationErrors) hasAnyValidation = true;
        else hasAllValidation = false;
    });
    return {
        validationResult: hasAnyValidation ? hasAllValidation ? 'All' : 'Some' : 'None'
    };
}
function $ffbf29d095efdf81$export$c41786842a91925d(previewInfo, newValue) {
    if (previewInfo && (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(newValue)) {
        let previewValidationSummary = previewInfo.previewValidationSummary;
        if (previewValidationSummary.validationResult == 'All') return 'All proposed edits have failed validation (see Preview for details).';
        else if (previewValidationSummary.validationResult == 'Some') return 'Some proposed edits have failed validatio (see Preview for details).\nThese updates will be ignored.';
    }
    return '';
}
function $ffbf29d095efdf81$export$96a3aab8ac290a37(previewInfo, bypassValidationWarnings) {
    let newValues = [];
    if (bypassValidationWarnings) {
        for (let previewResult of previewInfo.previewResults)if (previewResult.validationRules.length == 0) newValues.push({
            primaryKeyValue: previewResult.id,
            rawValue: previewResult.computedValue,
            displayValue: previewResult.computedValue,
            normalisedValue: previewResult.computedValue,
            rowNode: previewResult.rowNode,
            column: previewInfo.column,
            isPivotCell: false,
            isRowGroupCell: false
        });
    } else previewInfo.previewResults.filter((p)=>p.validationRules.length == 0).forEach((pr)=>{
        newValues.push({
            primaryKeyValue: pr.id,
            column: previewInfo.column,
            rawValue: pr.computedValue,
            displayValue: pr.computedValue,
            normalisedValue: pr.computedValue,
            rowNode: pr.rowNode,
            isPivotCell: false,
            isRowGroupCell: false
        });
    });
    return newValues;
}
function $ffbf29d095efdf81$export$62ee18d5dec056bf(previewInfo, bypassValidationWarnings) {
    let newValues = [];
    if (bypassValidationWarnings) {
        for (let previewResult of previewInfo.previewResults)if (previewResult.validationRules.length == 0) newValues.push({
            primaryKeyValue: previewResult.id,
            newValue: previewResult.computedValue,
            rowNode: previewResult.rowNode,
            columnId: previewInfo.column.columnId
        });
    } else previewInfo.previewResults.filter((p)=>p.validationRules.length == 0).forEach((pr)=>{
        newValues.push({
            primaryKeyValue: pr.id,
            columnId: previewInfo.column.columnId,
            newValue: pr.computedValue,
            rowNode: pr.rowNode
        });
    });
    return newValues;
}
const $ffbf29d095efdf81$export$69a3593e4bb2f3c1 = {
    GetPreviewValidationSummary: $ffbf29d095efdf81$export$2e4af2fd9216aa7f,
    GetValidationMessage: $ffbf29d095efdf81$export$c41786842a91925d,
    GetCellInfosFromPreview: $ffbf29d095efdf81$export$96a3aab8ac290a37,
    GetCellUpdateRequestsFromPreview: $ffbf29d095efdf81$export$62ee18d5dec056bf
};
var $ffbf29d095efdf81$export$2e2bcd8739ae039 = $ffbf29d095efdf81$export$69a3593e4bb2f3c1;



var $hrtGQ = parcelRequire("hrtGQ");


/**
 * Object Factory
 */ const $c6e8cf0de7823bb0$export$a45ad0ab4ee2200a = 1;
const $c6e8cf0de7823bb0$export$6a864bfd495b17de = 'Error';
const $c6e8cf0de7823bb0$export$5c85bd7d3cf4c56a = true;



var $acw62 = parcelRequire("acw62");
function $7226a27888f47128$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $7226a27888f47128$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $7226a27888f47128$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $7226a27888f47128$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7226a27888f47128$export$2e2bcd8739ae039 = $7226a27888f47128$export$4f5d2d50c9deca37;


'use client';
const $ad26fe773541dcd3$var$u = (t)=>"number" == typeof t && !isNaN(t), $ad26fe773541dcd3$var$d = (t)=>"string" == typeof t, $ad26fe773541dcd3$var$p = (t)=>"function" == typeof t, $ad26fe773541dcd3$var$m = (t)=>$ad26fe773541dcd3$var$d(t) || $ad26fe773541dcd3$var$p(t) ? t : null, $ad26fe773541dcd3$var$f = (t)=>(0, $acw62.isValidElement)(t) || $ad26fe773541dcd3$var$d(t) || $ad26fe773541dcd3$var$p(t) || $ad26fe773541dcd3$var$u(t);
function $ad26fe773541dcd3$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $ad26fe773541dcd3$export$3ff7dc44d332d222(e) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = e;
    return function(e) {
        let { children: u, position: d, preventExitTransition: p, done: m, nodeRef: f, isIn: h } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $acw62.useRef)(0);
        return (0, $acw62.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $acw62.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $ad26fe773541dcd3$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, u);
    };
}
function $ad26fe773541dcd3$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
const $ad26fe773541dcd3$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $ad26fe773541dcd3$var$T = (e)=>{
    let { theme: n, type: o, ...s } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...s
    });
}, $ad26fe773541dcd3$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $ad26fe773541dcd3$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $acw62.useReducer)((t)=>t + 1, 0), [l, c] = (0, $acw62.useState)([]), g = (0, $acw62.useRef)(null), h = (0, $acw62.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $acw62.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e } = t;
        const { limit: n } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t, toastProps: e, staleId: n } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s, staleId: r, ...i } = n;
        if (!$ad26fe773541dcd3$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l, updateId: c, data: T } = i, { props: b } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = {
            ...b,
            style: b.toastStyle,
            key: C.toastKey++,
            ...Object.fromEntries(Object.entries(i).filter((t)=>{
                let [e, n] = t;
                return null != n;
            })),
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $ad26fe773541dcd3$var$m(i.className || b.toastClassName),
            bodyClassName: $ad26fe773541dcd3$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $ad26fe773541dcd3$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $ad26fe773541dcd3$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $ad26fe773541dcd3$var$y(h.get(l), "removed");
                h.delete(l), $ad26fe773541dcd3$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        };
        var R, w;
        M.iconOut = function(t) {
            let { theme: n, type: o, isLoading: s, icon: r } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($ad26fe773541dcd3$var$p(r) ? i = r(l) : (0, $acw62.isValidElement)(r) ? i = (0, $acw62.cloneElement)(r, l) : $ad26fe773541dcd3$var$d(r) || $ad26fe773541dcd3$var$u(r) ? i = r : s ? i = $ad26fe773541dcd3$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $ad26fe773541dcd3$export$4f13f83fd8bb1dac)(o) && (i = $ad26fe773541dcd3$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $ad26fe773541dcd3$var$p(i.onOpen) && (M.onOpen = i.onOpen), $ad26fe773541dcd3$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $ad26fe773541dcd3$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$ad26fe773541dcd3$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $acw62.isValidElement)(t) && !$ad26fe773541dcd3$var$d(t.type) ? x = (0, $acw62.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $ad26fe773541dcd3$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $ad26fe773541dcd3$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $ad26fe773541dcd3$var$v.emit(4, $ad26fe773541dcd3$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $acw62.useEffect)(()=>(C.containerId = t.containerId, $ad26fe773541dcd3$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $ad26fe773541dcd3$var$v.emit(3, C);
        }), []), (0, $acw62.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $ad26fe773541dcd3$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $ad26fe773541dcd3$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $ad26fe773541dcd3$export$a407b657d3044108(t) {
    const [o, a] = (0, $acw62.useState)(!1), [r, l] = (0, $acw62.useState)(!1), c = (0, $acw62.useRef)(null), u = (0, $acw62.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $acw62.useRef)(t), { autoClose: m, pauseOnHover: f, closeToast: g, onClick: h, closeOnClick: y } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $ad26fe773541dcd3$var$b(e.nativeEvent), u.y = $ad26fe773541dcd3$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n, bottom: o, left: s, right: a } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $ad26fe773541dcd3$var$b(e), u.y = $ad26fe773541dcd3$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $acw62.useEffect)(()=>{
        d.current = t;
    }), (0, $acw62.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $ad26fe773541dcd3$var$p(t.onOpen) && t.onOpen((0, $acw62.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $ad26fe773541dcd3$var$p(t.onClose) && t.onClose((0, $acw62.isValidElement)(t.children) && t.children.props);
        }), []), (0, $acw62.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $ad26fe773541dcd3$var$L(e) {
    let { closeToast: n, theme: o, ariaLabel: s = "close" } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $ad26fe773541dcd3$var$O(e) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: l, controlledProgress: u, progress: d, rtl: m, isIn: f, theme: g } = e;
    const h = r || u && 0 === d, y = {
        ...l,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    };
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $7226a27888f47128$export$2e2bcd8739ae039)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $ad26fe773541dcd3$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $7226a27888f47128$export$2e2bcd8739ae039)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $ad26fe773541dcd3$var$N = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i } = $ad26fe773541dcd3$export$a407b657d3044108(n), { closeButton: l, children: u, autoClose: d, onClick: m, type: f, hideProgressBar: g, closeToast: h, transition: y, position: v, className: T, style: E, bodyClassName: C, bodyStyle: b, progressClassName: I, progressStyle: N, updateId: M, role: R, progress: w, rtl: x, toastId: $, deleteToast: k, isIn: P, isLoading: B, iconOut: D, closeOnClick: A, theme: z } = n, F = (0, $7226a27888f47128$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $ad26fe773541dcd3$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $7226a27888f47128$export$2e2bcd8739ae039)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $ad26fe773541dcd3$var$p(l) ? l(q) : (0, $acw62.isValidElement)(l) ? (0, $acw62.cloneElement)(l, q) : $ad26fe773541dcd3$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: $,
        onClick: m,
        className: H,
        ...i,
        style: E,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...P && {
            role: R
        },
        className: $ad26fe773541dcd3$var$p(C) ? C({
            type: f
        }) : (0, $7226a27888f47128$export$2e2bcd8739ae039)("Toastify__toast-body", C),
        style: b
    }, null != D && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7226a27888f47128$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$O, {
        ...M && !S ? {
            key: `pb-${M}`
        } : {},
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    })));
}, $ad26fe773541dcd3$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $ad26fe773541dcd3$export$d20e79fdc3899e95 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("bounce", !0)), $ad26fe773541dcd3$export$d8dc01b5c85a37b9 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("slide", !0)), $ad26fe773541dcd3$export$65cfd44a2050f99 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("zoom")), $ad26fe773541dcd3$export$4d2fae537bd90431 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("flip")), $ad26fe773541dcd3$export$f2815235e76a62b9 = (0, $acw62.forwardRef)((e, n)=>{
    const { getToastToRender: o, containerRef: a, isToastActive: r } = $ad26fe773541dcd3$export$b262e13ca2dd2381(e), { className: i, style: l, rtl: u, containerId: d } = e;
    function f(t) {
        const e = (0, $7226a27888f47128$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $ad26fe773541dcd3$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $7226a27888f47128$export$2e2bcd8739ae039)(e, $ad26fe773541dcd3$var$m(i));
    }
    return (0, $acw62.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? {
            ...l
        } : {
            ...l,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s, props: a } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$N, {
                ...a,
                isIn: r(a.toastId),
                style: {
                    ...a.style,
                    "--nth": o + 1,
                    "--len": n.length
                },
                key: `toast-${a.key}`
            }, s);
        }));
    }));
});
$ad26fe773541dcd3$export$f2815235e76a62b9.displayName = "ToastContainer", $ad26fe773541dcd3$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $ad26fe773541dcd3$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $ad26fe773541dcd3$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $ad26fe773541dcd3$var$P, $ad26fe773541dcd3$var$B = new Map, $ad26fe773541dcd3$var$D = [], $ad26fe773541dcd3$var$A = 1;
function $ad26fe773541dcd3$var$z() {
    return "" + $ad26fe773541dcd3$var$A++;
}
function $ad26fe773541dcd3$var$F(t) {
    return t && ($ad26fe773541dcd3$var$d(t.toastId) || $ad26fe773541dcd3$var$u(t.toastId)) ? t.toastId : $ad26fe773541dcd3$var$z();
}
function $ad26fe773541dcd3$var$H(t, e) {
    return $ad26fe773541dcd3$var$B.size > 0 ? $ad26fe773541dcd3$var$v.emit(0, t, e) : $ad26fe773541dcd3$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $ad26fe773541dcd3$var$S(t, e) {
    return {
        ...e,
        type: e && e.type || t,
        toastId: $ad26fe773541dcd3$var$F(e)
    };
}
function $ad26fe773541dcd3$var$q(t) {
    return (e, n)=>$ad26fe773541dcd3$var$H(e, $ad26fe773541dcd3$var$S(t, n));
}
function $ad26fe773541dcd3$export$b410431fab84fa58(t, e) {
    return $ad26fe773541dcd3$var$H(t, $ad26fe773541dcd3$var$S("default", e));
}
$ad26fe773541dcd3$export$b410431fab84fa58.loading = (t, e)=>$ad26fe773541dcd3$var$H(t, $ad26fe773541dcd3$var$S("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e
    })), $ad26fe773541dcd3$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s, error: a, success: r } = e;
    s && (o = $ad26fe773541dcd3$var$d(s) ? $ad26fe773541dcd3$export$b410431fab84fa58.loading(s, n) : $ad26fe773541dcd3$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $ad26fe773541dcd3$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: t,
            ...i,
            ...n,
            data: s
        }, r = $ad26fe773541dcd3$var$d(e) ? {
            render: e
        } : e;
        return o ? $ad26fe773541dcd3$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $ad26fe773541dcd3$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $ad26fe773541dcd3$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $ad26fe773541dcd3$export$b410431fab84fa58.success = $ad26fe773541dcd3$var$q("success"), $ad26fe773541dcd3$export$b410431fab84fa58.info = $ad26fe773541dcd3$var$q("info"), $ad26fe773541dcd3$export$b410431fab84fa58.error = $ad26fe773541dcd3$var$q("error"), $ad26fe773541dcd3$export$b410431fab84fa58.warning = $ad26fe773541dcd3$var$q("warning"), $ad26fe773541dcd3$export$b410431fab84fa58.warn = $ad26fe773541dcd3$export$b410431fab84fa58.warning, $ad26fe773541dcd3$export$b410431fab84fa58.dark = (t, e)=>$ad26fe773541dcd3$var$H(t, $ad26fe773541dcd3$var$S("default", {
        theme: "dark",
        ...e
    })), $ad26fe773541dcd3$export$b410431fab84fa58.dismiss = (t)=>{
    $ad26fe773541dcd3$var$B.size > 0 ? $ad26fe773541dcd3$var$v.emit(1, t) : $ad26fe773541dcd3$var$D = $ad26fe773541dcd3$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $ad26fe773541dcd3$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $ad26fe773541dcd3$var$v.emit(5, t);
}, $ad26fe773541dcd3$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $ad26fe773541dcd3$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $ad26fe773541dcd3$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n } = e;
            const o = $ad26fe773541dcd3$var$B.get(n || $ad26fe773541dcd3$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o, content: s } = n, a = {
                delay: 100,
                ...o,
                ...e,
                toastId: e.toastId || t,
                updateId: $ad26fe773541dcd3$var$z()
            };
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $ad26fe773541dcd3$var$H(r, a);
        }
    }, 0);
}, $ad26fe773541dcd3$export$b410431fab84fa58.done = (t)=>{
    $ad26fe773541dcd3$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $ad26fe773541dcd3$export$b410431fab84fa58.onChange = (t)=>($ad26fe773541dcd3$var$v.on(4, t), ()=>{
        $ad26fe773541dcd3$var$v.off(4, t);
    }), $ad26fe773541dcd3$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $ad26fe773541dcd3$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $ad26fe773541dcd3$var$v.on(2, (t)=>{
    $ad26fe773541dcd3$var$P = t.containerId || t, $ad26fe773541dcd3$var$B.set($ad26fe773541dcd3$var$P, t), $ad26fe773541dcd3$var$D.forEach((t)=>{
        $ad26fe773541dcd3$var$v.emit(0, t.content, t.options);
    }), $ad26fe773541dcd3$var$D = [];
}).on(3, (t)=>{
    $ad26fe773541dcd3$var$B.delete(t.containerId || t), 0 === $ad26fe773541dcd3$var$B.size && $ad26fe773541dcd3$var$v.off(0).off(1).off(5);
});





var $5aWMQ = parcelRequire("5aWMQ");

function $c94ad2cb10a8d2c3$export$55b8d90095c68d05() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        ColumnId: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        SortedValues: []
    };
}
function $c94ad2cb10a8d2c3$export$e3dd66a05aa9a59d(text, api) {
    const comment = {
        Value: text,
        AdaptableId: api.optionsApi.getAdaptableId(),
        Author: {
            UserName: api.optionsApi.getUserName()
        },
        Timestamp: Date.now(),
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)()
    };
    return comment;
}
function $c94ad2cb10a8d2c3$export$61a9b10f852e2b3c(defaultSpecialColumnSettings) {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        ColumnId: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        Query: {
            ScalarExpression: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1)
        },
        // need to create some defaults - which we will change later
        CalculatedColumnSettings: {
            ...defaultSpecialColumnSettings,
            DataType: undefined
        }
    };
}
function $c94ad2cb10a8d2c3$export$1817e31c6092a141(expression) {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        BooleanExpression: expression || (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1)
    };
}
function $c94ad2cb10a8d2c3$export$16309c956bffdbbe() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        Scope: undefined,
        Rule: undefined,
        NudgeValue: (0, $c6e8cf0de7823bb0$export$a45ad0ab4ee2200a)
    };
}
function $c94ad2cb10a8d2c3$export$44e2e6cec28169e8(alertHeader, alertMessage, alertDefinition) {
    return {
        alertType: 'generic',
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        header: alertHeader,
        message: alertMessage,
        alertDefinition: alertDefinition
    };
}
function $c94ad2cb10a8d2c3$export$1f041886127886f6(alertHeader, alertMessage, alertDefinition, cellDataChangedInfo) {
    return {
        alertType: 'cellChanged',
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        header: alertHeader,
        message: alertMessage,
        alertDefinition: alertDefinition,
        cellDataChangedInfo: cellDataChangedInfo
    };
}
function $c94ad2cb10a8d2c3$export$aecbe19aee860072(alertHeader, alertMessage, alertDefinition, rowDataChangedInfo) {
    return {
        alertType: 'rowChanged',
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        header: alertHeader,
        message: alertMessage,
        alertDefinition: alertDefinition,
        rowDataChangedInfo: rowDataChangedInfo
    };
}
function $c94ad2cb10a8d2c3$export$4e07140022b060b8() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        Scope: {
            All: true
        },
        Rule: {
            Predicates: []
        },
        MessageType: (0, $c6e8cf0de7823bb0$export$6a864bfd495b17de),
        AlertProperties: {}
    };
}
function $c94ad2cb10a8d2c3$export$d780401ef304db91() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        Scope: {
            ColumnIds: []
        },
        Rule: {
            Predicates: [
                {
                    PredicateId: 'AnyChange'
                }
            ]
        }
    };
}
function $c94ad2cb10a8d2c3$export$f424fc4672cf17b8(messageType, alertProperties) {
    alertProperties = alertProperties ?? {
        DisplayNotification: (0, $c6e8cf0de7823bb0$export$5c85bd7d3cf4c56a)
    };
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        Scope: undefined,
        Rule: {
            Predicates: []
        },
        MessageType: messageType,
        AlertProperties: alertProperties
    };
}
function $c94ad2cb10a8d2c3$export$60b9cf2b4fe08149() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        Scope: undefined,
        ReportColumnScope: 'AllColumns',
        ReportRowScope: 'AllRows',
        Query: undefined
    };
}
function $c94ad2cb10a8d2c3$export$fe2d3fc41213cb06(scheduleType) {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        ScheduleType: scheduleType,
        Schedule: $c94ad2cb10a8d2c3$export$7e647e1c69035602()
    };
}
function $c94ad2cb10a8d2c3$export$93b773f742ea13c6() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        ScheduleType: (0, $hrtGQ.ScheduleType).Reminder,
        Schedule: $c94ad2cb10a8d2c3$export$7e647e1c69035602(),
        Header: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        Message: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        MessageType: 'Info',
        DisplayNotification: true,
        DisplaySystemStatusMessage: false
    };
}
function $c94ad2cb10a8d2c3$export$43d396436eebdca8() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        ScheduleType: (0, $hrtGQ.ScheduleType).Report,
        Schedule: $c94ad2cb10a8d2c3$export$7e647e1c69035602(),
        ReportName: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        ReportFormat: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        ExportDestination: 'Download'
    };
}
function $c94ad2cb10a8d2c3$export$e85b1ca2f11ba5d6() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        ReportName: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        Folder: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        Page: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1)
    };
}
function $c94ad2cb10a8d2c3$export$3a76026e5a788919() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        ReportName: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1)
    };
}
function $c94ad2cb10a8d2c3$export$6987c10139dbfcda() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        ScheduleType: (0, $hrtGQ.ScheduleType).ipushpull,
        Schedule: $c94ad2cb10a8d2c3$export$7e647e1c69035602(),
        IPushPullReport: $c94ad2cb10a8d2c3$export$e85b1ca2f11ba5d6(),
        Transmission: 'Snapshot'
    };
}
function $c94ad2cb10a8d2c3$export$a4a8be6215938b96() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        ScheduleType: (0, $hrtGQ.ScheduleType).OpenFin,
        Schedule: $c94ad2cb10a8d2c3$export$7e647e1c69035602(),
        OpenFinReport: $c94ad2cb10a8d2c3$export$3a76026e5a788919(),
        Transmission: 'Live Data'
    };
}
function $c94ad2cb10a8d2c3$export$bb0ba2a61c04d741(iPushPullReport) {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        ScheduleType: (0, $hrtGQ.ScheduleType).ipushpull,
        Schedule: $c94ad2cb10a8d2c3$export$7e647e1c69035602(),
        IPushPullReport: iPushPullReport,
        Transmission: 'Snapshot'
    };
}
function $c94ad2cb10a8d2c3$export$594166ed8ed62cbf(reportName, reportFormat) {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        ScheduleType: (0, $hrtGQ.ScheduleType).Report,
        Schedule: $c94ad2cb10a8d2c3$export$7e647e1c69035602(),
        ReportName: reportName,
        ReportFormat: reportFormat
    };
}
function $c94ad2cb10a8d2c3$export$7e647e1c69035602() {
    return {
        OneOffDate: undefined,
        DaysOfWeek: [],
        Hour: 0,
        Minute: 0
    };
}
function $c94ad2cb10a8d2c3$export$bdf48500e8d75eb2() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        Scope: undefined,
        ShortcutKey: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        ShortcutValue: undefined,
        ShortcutOperation: (0, $hrtGQ.MathOperation).Multiply
    };
}
function $c94ad2cb10a8d2c3$export$6c3af6e435f0094c() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        Scope: undefined,
        Style: $c94ad2cb10a8d2c3$export$b37cca6cc8ab1323(),
        DisplayFormat: undefined,
        RowScope: undefined,
        Target: 'cell'
    };
}
function $c94ad2cb10a8d2c3$export$91f0cae9ac0ed243(defaultSpecialColumnSettings) {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        ColumnId: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        DefaultValue: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
        FreeTextStoredValues: [],
        TextEditor: 'Inline',
        FreeTextColumnSettings: {
            ...defaultSpecialColumnSettings,
            DataType: 'text'
        }
    };
}
function $c94ad2cb10a8d2c3$export$a5b0cd85e06f353e(pivotLayout) {
    const result = {
        ...pivotLayout,
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        ColumnSizing: pivotLayout.ColumnSizing || {},
        ColumnHeaders: pivotLayout.ColumnHeaders || {},
        ColumnPinning: pivotLayout.ColumnPinning || {},
        ColumnSorts: pivotLayout.ColumnSorts || [],
        ColumnFilters: pivotLayout.ColumnFilters || [],
        PivotColumns: pivotLayout.PivotColumns || [],
        PivotAggregationColumns: pivotLayout.PivotAggregationColumns || [],
        PivotGroupedColumns: pivotLayout.PivotGroupedColumns || []
    };
    return result;
}
function $c94ad2cb10a8d2c3$export$bdf49dd96d1a1fab(tableLayout) {
    const result = {
        ...tableLayout,
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        ColumnSizing: tableLayout.ColumnSizing || {},
        ColumnHeaders: tableLayout.ColumnHeaders || {},
        ColumnPinning: tableLayout.ColumnPinning || {},
        ColumnSorts: tableLayout.ColumnSorts || [],
        ColumnFilters: tableLayout.ColumnFilters || [],
        TableColumns: tableLayout.TableColumns || [],
        RowGroupedColumns: tableLayout.RowGroupedColumns || []
    };
    return result;
}
function $c94ad2cb10a8d2c3$export$460162a8b587165d(layout) {
    if ((0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)) return $c94ad2cb10a8d2c3$export$a5b0cd85e06f353e(layout);
    else return $c94ad2cb10a8d2c3$export$bdf49dd96d1a1fab(layout);
}
function $c94ad2cb10a8d2c3$export$b37cca6cc8ab1323() {
    return {
        BackColor: undefined,
        ForeColor: undefined,
        BorderColor: undefined,
        FontWeight: undefined,
        FontStyle: undefined,
        FontSize: undefined,
        ClassName: undefined,
        Alignment: undefined
    };
}
function $c94ad2cb10a8d2c3$export$cfcb1b5f6f291e9d(message, type, furtherInfo) {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        statusMessage: message,
        statusFurtherInformation: furtherInfo,
        statusType: type,
        timestamp: new Date()
    };
}
function $c94ad2cb10a8d2c3$export$3a8a4e4dd5b9a7ed() {
    return {
        Sum: undefined,
        Average: undefined,
        Median: undefined,
        Mode: undefined,
        Distinct: undefined,
        Max: undefined,
        Min: undefined,
        Count: undefined,
        Std_Deviation: undefined,
        Only: undefined
    };
}
function $c94ad2cb10a8d2c3$export$3c0070b428df06e1(ColumnId, PredicateId, Inputs) {
    return {
        ColumnId: ColumnId,
        Predicates: [
            {
                PredicateId: PredicateId,
                Inputs: Inputs
            }
        ]
    };
}
function $c94ad2cb10a8d2c3$export$fd604649bc30a33() {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        ColumnId: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1)
    };
}
function $c94ad2cb10a8d2c3$export$b4097515ddc74c05() {
    return {
        Style: {
            BackColor: (0, $5aWMQ.getHexForName)((0, $5aWMQ.LIGHT_GRAY)),
            ForeColor: (0, $5aWMQ.getHexForName)((0, $5aWMQ.BLACK)),
            BorderRadius: 6
        }
    };
}
function $c94ad2cb10a8d2c3$export$5a36a3e858dda692(chartDefinition) {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        ...chartDefinition
    };
}
function $c94ad2cb10a8d2c3$export$d56a7c3a67093fad(value, node, abColumn, api) {
    return {
        adaptableColumn: abColumn,
        cellValue: value,
        rowNode: node,
        ...api.internalApi.buildBaseContext()
    };
}
function $c94ad2cb10a8d2c3$export$1592e3065f894adc(name) {
    return {
        Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
        Name: name || 'Custom Theme',
        Description: name || 'Custom Theme'
    };
}
function $c94ad2cb10a8d2c3$export$ab64b8963b3264a5(cellAddress) {
    return {
        ...cellAddress,
        Comments: []
    };
}
function $c94ad2cb10a8d2c3$var$getToastPosition(position) {
    switch(position){
        case 'BottomLeft':
            return 'bottom-left';
        case 'BottomCenter':
            return 'bottom-center';
        case 'BottomRight':
            return 'bottom-right';
        case 'TopLeft':
            return 'top-left';
        case 'TopCenter':
            return 'top-center';
        case 'TopRight':
            return 'top-right';
    }
}
function $c94ad2cb10a8d2c3$var$getToastTransition(transition) {
    switch(transition){
        case 'Bounce':
            return 0, $ad26fe773541dcd3$export$d20e79fdc3899e95;
        case 'Slide':
            return 0, $ad26fe773541dcd3$export$d8dc01b5c85a37b9;
        case 'Zoom':
            return 0, $ad26fe773541dcd3$export$65cfd44a2050f99;
        case 'Flip':
            return 0, $ad26fe773541dcd3$export$4d2fae537bd90431;
        default:
            return 0, $ad26fe773541dcd3$export$d20e79fdc3899e95;
    }
}
function $c94ad2cb10a8d2c3$export$b5a4e6de92cd2749(notificationsOptions, { onClose: onClose, containerId: containerId }, overides) {
    const adaptableToastPosition = notificationsOptions.position;
    const position = $c94ad2cb10a8d2c3$var$getToastPosition(adaptableToastPosition);
    const duration = overides.duration ?? notificationsOptions.duration;
    const showProgressBar = notificationsOptions.showProgressBar;
    const closeWhenClicked = notificationsOptions.closeWhenClicked;
    const pauseWhenHovering = notificationsOptions.pauseWhenHovering;
    const isDraggable = notificationsOptions.isDraggable;
    const transition = $c94ad2cb10a8d2c3$var$getToastTransition(notificationsOptions.transition);
    const toastProps = {
        containerId: containerId,
        position: position,
        autoClose: duration == 'always' ? false : duration,
        hideProgressBar: !showProgressBar,
        closeOnClick: closeWhenClicked,
        pauseOnHover: pauseWhenHovering,
        draggable: isDraggable,
        transition: transition,
        draggablePercent: 75,
        onClose: onClose
    };
    return toastProps;
}
const $c94ad2cb10a8d2c3$export$7694cf1e73d40929 = {
    CreateEmptyCustomSort: $c94ad2cb10a8d2c3$export$55b8d90095c68d05,
    CreateEmptyCalculatedColumn: $c94ad2cb10a8d2c3$export$61a9b10f852e2b3c,
    CreateEmptyNamedQuery: $c94ad2cb10a8d2c3$export$1817e31c6092a141,
    CreateEmptyPlusMinusNudge: $c94ad2cb10a8d2c3$export$16309c956bffdbbe,
    CreateGenericAlert: $c94ad2cb10a8d2c3$export$44e2e6cec28169e8,
    CreateCellChangedAlert: $c94ad2cb10a8d2c3$export$1f041886127886f6,
    CreateRowChangedAlert: $c94ad2cb10a8d2c3$export$aecbe19aee860072,
    CreateEmptyAlertDefinition: $c94ad2cb10a8d2c3$export$4e07140022b060b8,
    CreateEmptyFlashingCellDefinition: $c94ad2cb10a8d2c3$export$d780401ef304db91,
    CreateInternalAlertDefinitionForMessages: $c94ad2cb10a8d2c3$export$f424fc4672cf17b8,
    CreateEmptyReport: $c94ad2cb10a8d2c3$export$60b9cf2b4fe08149,
    CreateEmptyBaseSchedule: $c94ad2cb10a8d2c3$export$fe2d3fc41213cb06,
    CreateEmptyReminderSchedule: $c94ad2cb10a8d2c3$export$93b773f742ea13c6,
    CreateEmptyReportSchedule: $c94ad2cb10a8d2c3$export$43d396436eebdca8,
    CreateEmptyIPushPullSchedule: $c94ad2cb10a8d2c3$export$6987c10139dbfcda,
    CreateEmptyIPushPullReport: $c94ad2cb10a8d2c3$export$e85b1ca2f11ba5d6,
    CreateIPushPullSchedule: $c94ad2cb10a8d2c3$export$bb0ba2a61c04d741,
    CreateReportSchedule: $c94ad2cb10a8d2c3$export$594166ed8ed62cbf,
    CreateEmptyOpenFinReport: $c94ad2cb10a8d2c3$export$3a76026e5a788919,
    CreateEmptyOpenFinSchedule: $c94ad2cb10a8d2c3$export$a4a8be6215938b96,
    CreateEmptySchedule: $c94ad2cb10a8d2c3$export$7e647e1c69035602,
    CreateEmptyShortcut: $c94ad2cb10a8d2c3$export$bdf48500e8d75eb2,
    CreateEmptyFormatColumn: $c94ad2cb10a8d2c3$export$6c3af6e435f0094c,
    CreateEmptyFreeTextColumn: $c94ad2cb10a8d2c3$export$91f0cae9ac0ed243,
    CreateEmptyLayout: $c94ad2cb10a8d2c3$export$460162a8b587165d,
    CreateEmptyPivotLayout: $c94ad2cb10a8d2c3$export$a5b0cd85e06f353e,
    CreateEmptyTableLayout: $c94ad2cb10a8d2c3$export$bdf49dd96d1a1fab,
    CreateColumnFilter: $c94ad2cb10a8d2c3$export$3c0070b428df06e1,
    CreateEmptyStyle: $c94ad2cb10a8d2c3$export$b37cca6cc8ab1323,
    CreateEmptyCellSummmary: $c94ad2cb10a8d2c3$export$3a8a4e4dd5b9a7ed,
    CreateSystemStatusMessageInfo: $c94ad2cb10a8d2c3$export$cfcb1b5f6f291e9d,
    CreateToastOptions: $c94ad2cb10a8d2c3$export$b5a4e6de92cd2749,
    CreateCustomDisplayFormatterContext: $c94ad2cb10a8d2c3$export$d56a7c3a67093fad,
    CreateEmptyStyledColumn: $c94ad2cb10a8d2c3$export$fd604649bc30a33,
    CreateDefaultStyledColumnBadge: $c94ad2cb10a8d2c3$export$b4097515ddc74c05,
    CreateEmptyChartDefinition: $c94ad2cb10a8d2c3$export$5a36a3e858dda692,
    CreateEmptyTheme: $c94ad2cb10a8d2c3$export$1592e3065f894adc,
    CreateEmptyCommentThread: $c94ad2cb10a8d2c3$export$ab64b8963b3264a5,
    CreateAdaptableComment: $c94ad2cb10a8d2c3$export$e3dd66a05aa9a59d
};
var $c94ad2cb10a8d2c3$export$2e2bcd8739ae039 = $c94ad2cb10a8d2c3$export$7694cf1e73d40929;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;



var $acw62 = parcelRequire("acw62");

var $85fc2fe65ff21506$exports = {};
'use strict';
Object.defineProperty($85fc2fe65ff21506$exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Concatenates two arrays faster than the array spread operator.
 */ const $85fc2fe65ff21506$var$concatArrays = (array1, array2)=>{
    // Pre-allocate for better V8 optimization
    const combinedArray = new Array(array1.length + array2.length);
    for(let i = 0; i < array1.length; i++)combinedArray[i] = array1[i];
    for(let i = 0; i < array2.length; i++)combinedArray[array1.length + i] = array2[i];
    return combinedArray;
};
// Factory function ensures consistent object shapes
const $85fc2fe65ff21506$var$createClassValidatorObject = (classGroupId, validator)=>({
        classGroupId: classGroupId,
        validator: validator
    });
// Factory ensures consistent ClassPartObject shape
const $85fc2fe65ff21506$var$createClassPartObject = (nextPart = new Map(), validators = null, classGroupId)=>({
        nextPart: nextPart,
        validators: validators,
        classGroupId: classGroupId
    });
const $85fc2fe65ff21506$var$CLASS_PART_SEPARATOR = '-';
const $85fc2fe65ff21506$var$EMPTY_CONFLICTS = [];
// I use two dots here because one dot is used as prefix for class groups in plugins
const $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX = 'arbitrary..';
const $85fc2fe65ff21506$var$createClassGroupUtils = (config)=>{
    const classMap = $85fc2fe65ff21506$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        if (className.startsWith('[') && className.endsWith(']')) return $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty(className);
        const classParts = className.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and skip it.
        const startIndex = classParts[0] === '' && classParts.length > 1 ? 1 : 0;
        return $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex, classMap);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        if (hasPostfixModifier) {
            const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
            const baseConflicts = conflictingClassGroups[classGroupId];
            if (modifierConflicts) {
                if (baseConflicts) // Merge base conflicts with modifier conflicts
                return $85fc2fe65ff21506$var$concatArrays(baseConflicts, modifierConflicts);
                // Only modifier conflicts
                return modifierConflicts;
            }
            // Fall back to without postfix if no modifier conflicts
            return baseConflicts || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
        }
        return conflictingClassGroups[classGroupId] || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $85fc2fe65ff21506$var$getGroupRecursive = (classParts, startIndex, classPartObject)=>{
    const classPathsLength = classParts.length - startIndex;
    if (classPathsLength === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[startIndex];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    if (nextClassPartObject) {
        const result = $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
        if (result) return result;
    }
    const validators = classPartObject.validators;
    if (validators === null) return undefined;
    // Build classRest string efficiently by joining from startIndex onwards
    const classRest = startIndex === 0 ? classParts.join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const validatorsLength = validators.length;
    for(let i = 0; i < validatorsLength; i++){
        const validatorObj = validators[i];
        if (validatorObj.validator(classRest)) return validatorObj.classGroupId;
    }
    return undefined;
};
/**
 * Get the class group ID for an arbitrary property.
 *
 * @param className - The class name to get the group ID for. Is expected to be string starting with `[` and ending with `]`.
 */ const $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty = (className)=>className.slice(1, -1).indexOf(':') === -1 ? undefined : (()=>{
        const content = className.slice(1, -1);
        const colonIndex = content.indexOf(':');
        const property = content.slice(0, colonIndex);
        return property ? $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX + property : undefined;
    })();
/**
 * Exported for testing only
 */ const $85fc2fe65ff21506$var$createClassMap = (config)=>{
    const { theme: theme, classGroups: classGroups } = config;
    return $85fc2fe65ff21506$var$processClassGroups(classGroups, theme);
};
// Split into separate functions to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassGroups = (classGroups, theme)=>{
    const classMap = $85fc2fe65ff21506$var$createClassPartObject();
    for(const classGroupId in classGroups){
        const group = classGroups[classGroupId];
        $85fc2fe65ff21506$var$processClassesRecursively(group, classMap, classGroupId, theme);
    }
    return classMap;
};
const $85fc2fe65ff21506$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    const len = classGroup.length;
    for(let i = 0; i < len; i++){
        const classDefinition = classGroup[i];
        $85fc2fe65ff21506$var$processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
    }
};
// Split into separate functions for each type to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if (typeof classDefinition === 'string') {
        $85fc2fe65ff21506$var$processStringDefinition(classDefinition, classPartObject, classGroupId);
        return;
    }
    if (typeof classDefinition === 'function') {
        $85fc2fe65ff21506$var$processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
        return;
    }
    $85fc2fe65ff21506$var$processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
const $85fc2fe65ff21506$var$processStringDefinition = (classDefinition, classPartObject, classGroupId)=>{
    const classPartObjectToEdit = classDefinition === '' ? classPartObject : $85fc2fe65ff21506$var$getPart(classPartObject, classDefinition);
    classPartObjectToEdit.classGroupId = classGroupId;
};
const $85fc2fe65ff21506$var$processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if ($85fc2fe65ff21506$var$isThemeGetter(classDefinition)) {
        $85fc2fe65ff21506$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
    }
    if (classPartObject.validators === null) classPartObject.validators = [];
    classPartObject.validators.push($85fc2fe65ff21506$var$createClassValidatorObject(classGroupId, classDefinition));
};
const $85fc2fe65ff21506$var$processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    const entries = Object.entries(classDefinition);
    const len = entries.length;
    for(let i = 0; i < len; i++){
        const [key, value] = entries[i];
        $85fc2fe65ff21506$var$processClassesRecursively(value, $85fc2fe65ff21506$var$getPart(classPartObject, key), classGroupId, theme);
    }
};
const $85fc2fe65ff21506$var$getPart = (classPartObject, path)=>{
    let current = classPartObject;
    const parts = path.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const len = parts.length;
    for(let i = 0; i < len; i++){
        const part = parts[i];
        let next = current.nextPart.get(part);
        if (!next) {
            next = $85fc2fe65ff21506$var$createClassPartObject();
            current.nextPart.set(part, next);
        }
        current = next;
    }
    return current;
};
// Type guard maintains monomorphic check
const $85fc2fe65ff21506$var$isThemeGetter = (func)=>'isThemeGetter' in func && func.isThemeGetter === true;
// LRU cache implementation using plain objects for simplicity
const $85fc2fe65ff21506$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = Object.create(null);
    let previousCache = Object.create(null);
    const update = (key, value)=>{
        cache[key] = value;
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = Object.create(null);
        }
    };
    return {
        get (key) {
            let value = cache[key];
            if (value !== undefined) return value;
            if ((value = previousCache[key]) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (key in cache) cache[key] = value;
            else update(key, value);
        }
    };
};
const $85fc2fe65ff21506$var$IMPORTANT_MODIFIER = '!';
const $85fc2fe65ff21506$var$MODIFIER_SEPARATOR = ':';
const $85fc2fe65ff21506$var$EMPTY_MODIFIERS = [];
// Pre-allocated result object shape for consistency
const $85fc2fe65ff21506$var$createResultObject = (modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal)=>({
        modifiers: modifiers,
        hasImportantModifier: hasImportantModifier,
        baseClassName: baseClassName,
        maybePostfixModifierPosition: maybePostfixModifierPosition,
        isExternal: isExternal
    });
const $85fc2fe65ff21506$var$createParseClassName = (config)=>{
    const { prefix: prefix, experimentalParseClassName: experimentalParseClassName } = config;
    /**
   * Parse class name into parts.
   *
   * Inspired by `splitAtTopLevelOnly` used in Tailwind CSS
   * @see https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
   */ let parseClassName = (className)=>{
        // Use simple array with push for better performance
        const modifiers = [];
        let bracketDepth = 0;
        let parenDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        const len = className.length;
        for(let index = 0; index < len; index++){
            const currentCharacter = className[index];
            if (bracketDepth === 0 && parenDepth === 0) {
                if (currentCharacter === $85fc2fe65ff21506$var$MODIFIER_SEPARATOR) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + 1;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
            else if (currentCharacter === '(') parenDepth++;
            else if (currentCharacter === ')') parenDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
        // Inline important modifier check
        let baseClassName = baseClassNameWithImportantModifier;
        let hasImportantModifier = false;
        if (baseClassNameWithImportantModifier.endsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
            hasImportantModifier = true;
        } else if (/**
     * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
     * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
     */ baseClassNameWithImportantModifier.startsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(1);
            hasImportantModifier = true;
        }
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return $85fc2fe65ff21506$var$createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
    };
    if (prefix) {
        const fullPrefix = prefix + $85fc2fe65ff21506$var$MODIFIER_SEPARATOR;
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : $85fc2fe65ff21506$var$createResultObject($85fc2fe65ff21506$var$EMPTY_MODIFIERS, false, className, undefined, true);
    }
    if (experimentalParseClassName) {
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>experimentalParseClassName({
                className: className,
                parseClassName: parseClassNameOriginal
            });
    }
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $85fc2fe65ff21506$var$createSortModifiers = (config)=>{
    // Pre-compute weights for all known modifiers for O(1) comparison
    const modifierWeights = new Map();
    // Assign weights to sensitive modifiers (highest priority, but preserve order)
    config.orderSensitiveModifiers.forEach((mod, index)=>{
        modifierWeights.set(mod, 1000000 + index); // High weights for sensitive mods
    });
    return (modifiers)=>{
        const result = [];
        let currentSegment = [];
        // Process modifiers in one pass
        for(let i = 0; i < modifiers.length; i++){
            const modifier = modifiers[i];
            // Check if modifier is sensitive (starts with '[' or in orderSensitiveModifiers)
            const isArbitrary = modifier[0] === '[';
            const isOrderSensitive = modifierWeights.has(modifier);
            if (isArbitrary || isOrderSensitive) {
                // Sort and flush current segment alphabetically
                if (currentSegment.length > 0) {
                    currentSegment.sort();
                    result.push(...currentSegment);
                    currentSegment = [];
                }
                result.push(modifier);
            } else // Regular modifier - add to current segment for batch sorting
            currentSegment.push(modifier);
        }
        // Sort and add any remaining segment items
        if (currentSegment.length > 0) {
            currentSegment.sort();
            result.push(...currentSegment);
        }
        return result;
    };
};
const $85fc2fe65ff21506$var$createConfigUtils = (config)=>({
        cache: $85fc2fe65ff21506$var$createLruCache(config.cacheSize),
        parseClassName: $85fc2fe65ff21506$var$createParseClassName(config),
        sortModifiers: $85fc2fe65ff21506$var$createSortModifiers(config),
        ...$85fc2fe65ff21506$var$createClassGroupUtils(config)
    });
const $85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX = /\s+/;
const $85fc2fe65ff21506$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds, sortModifiers: sortModifiers } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX);
    let result = '';
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { isExternal: isExternal, modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        if (isExternal) {
            result = originalClassName + (result.length > 0 ? ' ' + result : result);
            continue;
        }
        let hasPostfixModifier = !!maybePostfixModifierPosition;
        let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        // Fast path: skip sorting for empty or single modifier
        const variantModifier = modifiers.length === 0 ? '' : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + $85fc2fe65ff21506$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.indexOf(classId) > -1) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ const $85fc2fe65ff21506$var$twJoin = (...classLists)=>{
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < classLists.length){
        if (argument = classLists[index++]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$toValue = (mix)=>{
    // Fast path for strings
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$createTailwindMerge = (createConfigFirst, ...createConfigRest)=>{
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall;
    const initTailwindMerge = (classList)=>{
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $85fc2fe65ff21506$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    const tailwindMerge = (classList)=>{
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $85fc2fe65ff21506$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    functionToCall = initTailwindMerge;
    return (...args)=>functionToCall($85fc2fe65ff21506$var$twJoin(...args));
};
const $85fc2fe65ff21506$var$fallbackThemeArr = [];
const $85fc2fe65ff21506$var$fromTheme = (key)=>{
    const themeGetter = (theme)=>theme[key] || $85fc2fe65ff21506$var$fallbackThemeArr;
    themeGetter.isThemeGetter = true;
    return themeGetter;
};
const $85fc2fe65ff21506$var$arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const $85fc2fe65ff21506$var$arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const $85fc2fe65ff21506$var$fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
const $85fc2fe65ff21506$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $85fc2fe65ff21506$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $85fc2fe65ff21506$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $85fc2fe65ff21506$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $85fc2fe65ff21506$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $85fc2fe65ff21506$var$isFraction = (value)=>$85fc2fe65ff21506$var$fractionRegex.test(value);
const $85fc2fe65ff21506$var$isNumber = (value)=>!!value && !Number.isNaN(Number(value));
const $85fc2fe65ff21506$var$isInteger = (value)=>!!value && Number.isInteger(Number(value));
const $85fc2fe65ff21506$var$isPercent = (value)=>value.endsWith('%') && $85fc2fe65ff21506$var$isNumber(value.slice(0, -1));
const $85fc2fe65ff21506$var$isTshirtSize = (value)=>$85fc2fe65ff21506$var$tshirtUnitRegex.test(value);
const $85fc2fe65ff21506$var$isAny = ()=>true;
const $85fc2fe65ff21506$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $85fc2fe65ff21506$var$lengthUnitRegex.test(value) && !$85fc2fe65ff21506$var$colorFunctionRegex.test(value);
const $85fc2fe65ff21506$var$isNever = ()=>false;
const $85fc2fe65ff21506$var$isShadow = (value)=>$85fc2fe65ff21506$var$shadowRegex.test(value);
const $85fc2fe65ff21506$var$isImage = (value)=>$85fc2fe65ff21506$var$imageRegex.test(value);
const $85fc2fe65ff21506$var$isAnyNonArbitrary = (value)=>!$85fc2fe65ff21506$var$isArbitraryValue(value) && !$85fc2fe65ff21506$var$isArbitraryVariable(value);
const $85fc2fe65ff21506$var$isArbitrarySize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelSize, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryValue = (value)=>$85fc2fe65ff21506$var$arbitraryValueRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelLength, $85fc2fe65ff21506$var$isLengthOnly);
const $85fc2fe65ff21506$var$isArbitraryNumber = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelNumber, $85fc2fe65ff21506$var$isNumber);
const $85fc2fe65ff21506$var$isArbitraryWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelWeight, $85fc2fe65ff21506$var$isAny);
const $85fc2fe65ff21506$var$isArbitraryFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelFamilyName, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryPosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelPosition, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelImage, $85fc2fe65ff21506$var$isImage);
const $85fc2fe65ff21506$var$isArbitraryShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelShadow, $85fc2fe65ff21506$var$isShadow);
const $85fc2fe65ff21506$var$isArbitraryVariable = (value)=>$85fc2fe65ff21506$var$arbitraryVariableRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryVariableLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelLength);
const $85fc2fe65ff21506$var$isArbitraryVariableFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelFamilyName);
const $85fc2fe65ff21506$var$isArbitraryVariablePosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelPosition);
const $85fc2fe65ff21506$var$isArbitraryVariableSize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelSize);
const $85fc2fe65ff21506$var$isArbitraryVariableImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelImage);
const $85fc2fe65ff21506$var$isArbitraryVariableShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelShadow, true);
const $85fc2fe65ff21506$var$isArbitraryVariableWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelWeight, true);
// Helpers
const $85fc2fe65ff21506$var$getIsArbitraryValue = (value, testLabel, testValue)=>{
    const result = $85fc2fe65ff21506$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $85fc2fe65ff21506$var$getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false)=>{
    const result = $85fc2fe65ff21506$var$arbitraryVariableRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return shouldMatchNoLabel;
    }
    return false;
};
// Labels
const $85fc2fe65ff21506$var$isLabelPosition = (label)=>label === 'position' || label === 'percentage';
const $85fc2fe65ff21506$var$isLabelImage = (label)=>label === 'image' || label === 'url';
const $85fc2fe65ff21506$var$isLabelSize = (label)=>label === 'length' || label === 'size' || label === 'bg-size';
const $85fc2fe65ff21506$var$isLabelLength = (label)=>label === 'length';
const $85fc2fe65ff21506$var$isLabelNumber = (label)=>label === 'number';
const $85fc2fe65ff21506$var$isLabelFamilyName = (label)=>label === 'family-name';
const $85fc2fe65ff21506$var$isLabelWeight = (label)=>label === 'number' || label === 'weight';
const $85fc2fe65ff21506$var$isLabelShadow = (label)=>label === 'shadow';
const $85fc2fe65ff21506$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $85fc2fe65ff21506$var$isAny,
    isAnyNonArbitrary: $85fc2fe65ff21506$var$isAnyNonArbitrary,
    isArbitraryFamilyName: $85fc2fe65ff21506$var$isArbitraryFamilyName,
    isArbitraryImage: $85fc2fe65ff21506$var$isArbitraryImage,
    isArbitraryLength: $85fc2fe65ff21506$var$isArbitraryLength,
    isArbitraryNumber: $85fc2fe65ff21506$var$isArbitraryNumber,
    isArbitraryPosition: $85fc2fe65ff21506$var$isArbitraryPosition,
    isArbitraryShadow: $85fc2fe65ff21506$var$isArbitraryShadow,
    isArbitrarySize: $85fc2fe65ff21506$var$isArbitrarySize,
    isArbitraryValue: $85fc2fe65ff21506$var$isArbitraryValue,
    isArbitraryVariable: $85fc2fe65ff21506$var$isArbitraryVariable,
    isArbitraryVariableFamilyName: $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
    isArbitraryVariableImage: $85fc2fe65ff21506$var$isArbitraryVariableImage,
    isArbitraryVariableLength: $85fc2fe65ff21506$var$isArbitraryVariableLength,
    isArbitraryVariablePosition: $85fc2fe65ff21506$var$isArbitraryVariablePosition,
    isArbitraryVariableShadow: $85fc2fe65ff21506$var$isArbitraryVariableShadow,
    isArbitraryVariableSize: $85fc2fe65ff21506$var$isArbitraryVariableSize,
    isArbitraryVariableWeight: $85fc2fe65ff21506$var$isArbitraryVariableWeight,
    isArbitraryWeight: $85fc2fe65ff21506$var$isArbitraryWeight,
    isFraction: $85fc2fe65ff21506$var$isFraction,
    isInteger: $85fc2fe65ff21506$var$isInteger,
    isNumber: $85fc2fe65ff21506$var$isNumber,
    isPercent: $85fc2fe65ff21506$var$isPercent,
    isTshirtSize: $85fc2fe65ff21506$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
const $85fc2fe65ff21506$var$getDefaultConfig = ()=>{
    /**
   * Theme getters for theme variable namespaces
   * @see https://tailwindcss.com/docs/theme#theme-variable-namespaces
   */ /***/ const themeColor = $85fc2fe65ff21506$var$fromTheme('color');
    const themeFont = $85fc2fe65ff21506$var$fromTheme('font');
    const themeText = $85fc2fe65ff21506$var$fromTheme('text');
    const themeFontWeight = $85fc2fe65ff21506$var$fromTheme('font-weight');
    const themeTracking = $85fc2fe65ff21506$var$fromTheme('tracking');
    const themeLeading = $85fc2fe65ff21506$var$fromTheme('leading');
    const themeBreakpoint = $85fc2fe65ff21506$var$fromTheme('breakpoint');
    const themeContainer = $85fc2fe65ff21506$var$fromTheme('container');
    const themeSpacing = $85fc2fe65ff21506$var$fromTheme('spacing');
    const themeRadius = $85fc2fe65ff21506$var$fromTheme('radius');
    const themeShadow = $85fc2fe65ff21506$var$fromTheme('shadow');
    const themeInsetShadow = $85fc2fe65ff21506$var$fromTheme('inset-shadow');
    const themeTextShadow = $85fc2fe65ff21506$var$fromTheme('text-shadow');
    const themeDropShadow = $85fc2fe65ff21506$var$fromTheme('drop-shadow');
    const themeBlur = $85fc2fe65ff21506$var$fromTheme('blur');
    const themePerspective = $85fc2fe65ff21506$var$fromTheme('perspective');
    const themeAspect = $85fc2fe65ff21506$var$fromTheme('aspect');
    const themeEase = $85fc2fe65ff21506$var$fromTheme('ease');
    const themeAnimate = $85fc2fe65ff21506$var$fromTheme('animate');
    /**
   * Helpers to avoid repeating the same scales
   *
   * We use functions that create a new array every time they're called instead of static arrays.
   * This ensures that users who modify any scale by mutating the array (e.g. with `array.push(element)`) don't accidentally mutate arrays in other parts of the config.
   */ /***/ const scaleBreak = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const scalePosition = ()=>[
            'center',
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-top',
            'top-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-top',
            'bottom-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-bottom',
            'bottom-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-bottom'
        ];
    const scalePositionWithArbitrary = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const scaleOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const scaleUnambiguousSpacing = ()=>[
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue,
            themeSpacing
        ];
    const scaleInset = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleGridTemplateColsRows = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'none',
            'subgrid',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartAndEnd = ()=>[
            'auto',
            {
                span: [
                    'full',
                    $85fc2fe65ff21506$var$isInteger,
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            },
            $85fc2fe65ff21506$var$isInteger,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartOrEnd = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'auto',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridAutoColsRows = ()=>[
            'auto',
            'min',
            'max',
            'fr',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleAlignPrimaryAxis = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch',
            'baseline',
            'center-safe',
            'end-safe'
        ];
    const scaleAlignSecondaryAxis = ()=>[
            'start',
            'end',
            'center',
            'stretch',
            'center-safe',
            'end-safe'
        ];
    const scaleMargin = ()=>[
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizing = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'auto',
            'full',
            'dvw',
            'dvh',
            'lvw',
            'lvh',
            'svw',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingInline = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'dvw',
            'lvw',
            'svw',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingBlock = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'lh',
            'dvh',
            'lvh',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleColor = ()=>[
            themeColor,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBgPosition = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition,
            {
                position: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleBgRepeat = ()=>[
            'no-repeat',
            {
                repeat: [
                    '',
                    'x',
                    'y',
                    'space',
                    'round'
                ]
            }
        ];
    const scaleBgSize = ()=>[
            'auto',
            'cover',
            'contain',
            $85fc2fe65ff21506$var$isArbitraryVariableSize,
            $85fc2fe65ff21506$var$isArbitrarySize,
            {
                size: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleGradientStopPosition = ()=>[
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleRadius = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            'full',
            themeRadius,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBorderWidth = ()=>[
            '',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleLineStyle = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double'
        ];
    const scaleBlendMode = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const scaleMaskImagePosition = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition
        ];
    const scaleBlur = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            themeBlur,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleRotate = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleScale = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleSkew = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleTranslate = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            ...scaleUnambiguousSpacing()
        ];
    return {
        cacheSize: 500,
        theme: {
            animate: [
                'spin',
                'ping',
                'pulse',
                'bounce'
            ],
            aspect: [
                'video'
            ],
            blur: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            breakpoint: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            color: [
                $85fc2fe65ff21506$var$isAny
            ],
            container: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'drop-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            ease: [
                'in',
                'out',
                'in-out'
            ],
            font: [
                $85fc2fe65ff21506$var$isAnyNonArbitrary
            ],
            'font-weight': [
                'thin',
                'extralight',
                'light',
                'normal',
                'medium',
                'semibold',
                'bold',
                'extrabold',
                'black'
            ],
            'inset-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            leading: [
                'none',
                'tight',
                'snug',
                'normal',
                'relaxed',
                'loose'
            ],
            perspective: [
                'dramatic',
                'near',
                'normal',
                'midrange',
                'distant',
                'none'
            ],
            radius: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            shadow: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            spacing: [
                'px',
                $85fc2fe65ff21506$var$isNumber
            ],
            text: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'text-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            tracking: [
                'tighter',
                'tight',
                'normal',
                'wide',
                'wider',
                'widest'
            ]
        },
        classGroups: {
            // --------------
            // --- Layout ---
            // --------------
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        $85fc2fe65ff21506$var$isFraction,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeAspect
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */ container: [
                'container'
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeContainer
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': scaleBreak()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': scaleBreak()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: scalePositionWithArbitrary()
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: scaleOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': scaleOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': scaleOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': scaleOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: scaleInset()
                }
            ],
            /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': scaleInset()
                }
            ],
            /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': scaleInset()
                }
            ],
            /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */ start: [
                {
                    'inset-s': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ start: scaleInset()
                }
            ],
            /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */ end: [
                {
                    'inset-e': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ end: scaleInset()
                }
            ],
            /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-bs': [
                {
                    'inset-bs': scaleInset()
                }
            ],
            /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-be': [
                {
                    'inset-be': scaleInset()
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: scaleInset()
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: scaleInset()
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: scaleInset()
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: scaleInset()
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        $85fc2fe65ff21506$var$isInteger,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------------
            // --- Flexbox and Grid ---
            // ------------------------
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: [
                        $85fc2fe65ff21506$var$isFraction,
                        'full',
                        'auto',
                        themeContainer,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'nowrap',
                        'wrap',
                        'wrap-reverse'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isFraction,
                        'auto',
                        'initial',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        $85fc2fe65ff21506$var$isInteger,
                        'first',
                        'last',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': scaleGridAutoColsRows()
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': scaleGridAutoColsRows()
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        ...scaleAlignPrimaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        ...scaleAlignSecondaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...scaleAlignPrimaryAxis()
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': scaleAlignPrimaryAxis()
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        ...scaleAlignSecondaryAxis(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */ pbs: [
                {
                    pbs: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */ pbe: [
                {
                    pbe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: scaleMargin()
                }
            ],
            /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: scaleMargin()
                }
            ],
            /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: scaleMargin()
                }
            ],
            /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: scaleMargin()
                }
            ],
            /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: scaleMargin()
                }
            ],
            /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */ mbs: [
                {
                    mbs: scaleMargin()
                }
            ],
            /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */ mbe: [
                {
                    mbe: scaleMargin()
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: scaleMargin()
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: scaleMargin()
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: scaleMargin()
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: scaleMargin()
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x': [
                {
                    'space-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y': [
                {
                    'space-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // --------------
            // --- Sizing ---
            // --------------
            /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */ size: [
                {
                    size: scaleSizing()
                }
            ],
            /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */ 'inline-size': [
                {
                    inline: [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-inline-size': [
                {
                    'min-inline': [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-inline-size': [
                {
                    'max-inline': [
                        'none',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */ 'block-size': [
                {
                    block: [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-block-size': [
                {
                    'min-block': [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-block-size': [
                {
                    'max-block': [
                        'none',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        themeContainer,
                        'screen',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        themeContainer,
                        'screen',
                        /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        themeContainer,
                        'screen',
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'prose',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ {
                            screen: [
                                themeBreakpoint
                            ]
                        },
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            // ------------------
            // --- Typography ---
            // ------------------
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        themeText,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        themeFontWeight,
                        $85fc2fe65ff21506$var$isArbitraryVariableWeight,
                        $85fc2fe65ff21506$var$isArbitraryWeight
                    ]
                }
            ],
            /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */ 'font-stretch': [
                {
                    'font-stretch': [
                        'ultra-condensed',
                        'extra-condensed',
                        'condensed',
                        'semi-condensed',
                        'normal',
                        'semi-expanded',
                        'expanded',
                        'extra-expanded',
                        'ultra-expanded',
                        $85fc2fe65ff21506$var$isPercent,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
                        $85fc2fe65ff21506$var$isArbitraryFamilyName,
                        themeFont
                    ]
                }
            ],
            /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */ 'font-features': [
                {
                    'font-features': [
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        themeTracking,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        $85fc2fe65ff21506$var$isNumber,
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ themeLeading,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'disc',
                        'decimal',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: scaleColor()
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: scaleColor()
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...scaleLineStyle(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'from-font',
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: scaleColor()
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */ wrap: [
                {
                    wrap: [
                        'break-word',
                        'anywhere',
                        'normal'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -------------------
            // --- Backgrounds ---
            // -------------------
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: scaleBgPosition()
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: scaleBgRepeat()
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: scaleBgSize()
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            linear: [
                                {
                                    to: [
                                        't',
                                        'tr',
                                        'r',
                                        'br',
                                        'b',
                                        'bl',
                                        'l',
                                        'tl'
                                    ]
                                },
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            radial: [
                                '',
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            conic: [
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ]
                        },
                        $85fc2fe65ff21506$var$isArbitraryVariableImage,
                        $85fc2fe65ff21506$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: scaleColor()
                }
            ],
            // ---------------
            // --- Borders ---
            // ---------------
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: scaleRadius()
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': scaleRadius()
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': scaleRadius()
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': scaleRadius()
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': scaleRadius()
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': scaleRadius()
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': scaleRadius()
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': scaleRadius()
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': scaleRadius()
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': scaleRadius()
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-bs': [
                {
                    'border-bs': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-be': [
                {
                    'border-be': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x': [
                {
                    'divide-x': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y': [
                {
                    'divide-y': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */ 'divide-style': [
                {
                    divide: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: scaleColor()
                }
            ],
            /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': scaleColor()
                }
            ],
            /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': scaleColor()
                }
            ],
            /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': scaleColor()
                }
            ],
            /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': scaleColor()
                }
            ],
            /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-bs': [
                {
                    'border-bs': scaleColor()
                }
            ],
            /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-be': [
                {
                    'border-be': scaleColor()
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': scaleColor()
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': scaleColor()
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': scaleColor()
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': scaleColor()
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: scaleColor()
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        ...scaleLineStyle(),
                        'none',
                        'hidden'
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: scaleColor()
                }
            ],
            // ---------------
            // --- Effects ---
            // ---------------
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */ 'shadow-color': [
                {
                    shadow: scaleColor()
                }
            ],
            /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */ 'inset-shadow': [
                {
                    'inset-shadow': [
                        'none',
                        themeInsetShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */ 'inset-shadow-color': [
                {
                    'inset-shadow': scaleColor()
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */ 'ring-w': [
                {
                    ring: scaleBorderWidth()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */ 'ring-color': [
                {
                    ring: scaleColor()
                }
            ],
            /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-color': [
                {
                    'ring-offset': scaleColor()
                }
            ],
            /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */ 'inset-ring-w': [
                {
                    'inset-ring': scaleBorderWidth()
                }
            ],
            /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */ 'inset-ring-color': [
                {
                    'inset-ring': scaleColor()
                }
            ],
            /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */ 'text-shadow': [
                {
                    'text-shadow': [
                        'none',
                        themeTextShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */ 'text-shadow-color': [
                {
                    'text-shadow': scaleColor()
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...scaleBlendMode(),
                        'plus-darker',
                        'plus-lighter'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': scaleBlendMode()
                }
            ],
            /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */ 'mask-clip': [
                {
                    'mask-clip': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                },
                'mask-no-clip'
            ],
            /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */ 'mask-composite': [
                {
                    mask: [
                        'add',
                        'subtract',
                        'intersect',
                        'exclude'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image-linear-pos': [
                {
                    'mask-linear': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-linear-from-pos': [
                {
                    'mask-linear-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-to-pos': [
                {
                    'mask-linear-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-from-color': [
                {
                    'mask-linear-from': scaleColor()
                }
            ],
            'mask-image-linear-to-color': [
                {
                    'mask-linear-to': scaleColor()
                }
            ],
            'mask-image-t-from-pos': [
                {
                    'mask-t-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-to-pos': [
                {
                    'mask-t-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-from-color': [
                {
                    'mask-t-from': scaleColor()
                }
            ],
            'mask-image-t-to-color': [
                {
                    'mask-t-to': scaleColor()
                }
            ],
            'mask-image-r-from-pos': [
                {
                    'mask-r-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-to-pos': [
                {
                    'mask-r-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-from-color': [
                {
                    'mask-r-from': scaleColor()
                }
            ],
            'mask-image-r-to-color': [
                {
                    'mask-r-to': scaleColor()
                }
            ],
            'mask-image-b-from-pos': [
                {
                    'mask-b-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-to-pos': [
                {
                    'mask-b-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-from-color': [
                {
                    'mask-b-from': scaleColor()
                }
            ],
            'mask-image-b-to-color': [
                {
                    'mask-b-to': scaleColor()
                }
            ],
            'mask-image-l-from-pos': [
                {
                    'mask-l-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-to-pos': [
                {
                    'mask-l-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-from-color': [
                {
                    'mask-l-from': scaleColor()
                }
            ],
            'mask-image-l-to-color': [
                {
                    'mask-l-to': scaleColor()
                }
            ],
            'mask-image-x-from-pos': [
                {
                    'mask-x-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-to-pos': [
                {
                    'mask-x-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-from-color': [
                {
                    'mask-x-from': scaleColor()
                }
            ],
            'mask-image-x-to-color': [
                {
                    'mask-x-to': scaleColor()
                }
            ],
            'mask-image-y-from-pos': [
                {
                    'mask-y-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-to-pos': [
                {
                    'mask-y-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-from-color': [
                {
                    'mask-y-from': scaleColor()
                }
            ],
            'mask-image-y-to-color': [
                {
                    'mask-y-to': scaleColor()
                }
            ],
            'mask-image-radial': [
                {
                    'mask-radial': [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            'mask-image-radial-from-pos': [
                {
                    'mask-radial-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-to-pos': [
                {
                    'mask-radial-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-from-color': [
                {
                    'mask-radial-from': scaleColor()
                }
            ],
            'mask-image-radial-to-color': [
                {
                    'mask-radial-to': scaleColor()
                }
            ],
            'mask-image-radial-shape': [
                {
                    'mask-radial': [
                        'circle',
                        'ellipse'
                    ]
                }
            ],
            'mask-image-radial-size': [
                {
                    'mask-radial': [
                        {
                            closest: [
                                'side',
                                'corner'
                            ],
                            farthest: [
                                'side',
                                'corner'
                            ]
                        }
                    ]
                }
            ],
            'mask-image-radial-pos': [
                {
                    'mask-radial-at': scalePosition()
                }
            ],
            'mask-image-conic-pos': [
                {
                    'mask-conic': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-conic-from-pos': [
                {
                    'mask-conic-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-to-pos': [
                {
                    'mask-conic-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-from-color': [
                {
                    'mask-conic-from': scaleColor()
                }
            ],
            'mask-image-conic-to-color': [
                {
                    'mask-conic-to': scaleColor()
                }
            ],
            /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */ 'mask-mode': [
                {
                    mask: [
                        'alpha',
                        'luminance',
                        'match'
                    ]
                }
            ],
            /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */ 'mask-origin': [
                {
                    'mask-origin': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                }
            ],
            /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */ 'mask-position': [
                {
                    mask: scaleBgPosition()
                }
            ],
            /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */ 'mask-repeat': [
                {
                    mask: scaleBgRepeat()
                }
            ],
            /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */ 'mask-size': [
                {
                    mask: scaleBgSize()
                }
            ],
            /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */ 'mask-type': [
                {
                    'mask-type': [
                        'alpha',
                        'luminance'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image': [
                {
                    mask: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------
            // --- Filters ---
            // ---------------
            /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: scaleBlur()
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeDropShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */ 'drop-shadow-color': [
                {
                    'drop-shadow': scaleColor()
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': scaleBlur()
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // --------------
            // --- Tables ---
            // --------------
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // ---------------------------------
            // --- Transitions and Animation ---
            // ---------------------------------
            /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        '',
                        'all',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */ 'transition-behavior': [
                {
                    transition: [
                        'normal',
                        'discrete'
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'initial',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'initial',
                        themeEase,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        themeAnimate,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------
            // --- Transforms ---
            // ------------------
            /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */ backface: [
                {
                    backface: [
                        'hidden',
                        'visible'
                    ]
                }
            ],
            /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */ perspective: [
                {
                    perspective: [
                        themePerspective,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */ 'perspective-origin': [
                {
                    'perspective-origin': scalePositionWithArbitrary()
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: scaleRotate()
                }
            ],
            /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-x': [
                {
                    'rotate-x': scaleRotate()
                }
            ],
            /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-y': [
                {
                    'rotate-y': scaleRotate()
                }
            ],
            /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-z': [
                {
                    'rotate-z': scaleRotate()
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: scaleScale()
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': scaleScale()
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': scaleScale()
                }
            ],
            /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-z': [
                {
                    'scale-z': scaleScale()
                }
            ],
            /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-3d': [
                'scale-3d'
            ],
            /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */ skew: [
                {
                    skew: scaleSkew()
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': scaleSkew()
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': scaleSkew()
                }
            ],
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        '',
                        'none',
                        'gpu',
                        'cpu'
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: scalePositionWithArbitrary()
                }
            ],
            /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */ 'transform-style': [
                {
                    transform: [
                        '3d',
                        'flat'
                    ]
                }
            ],
            /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */ translate: [
                {
                    translate: scaleTranslate()
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': scaleTranslate()
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': scaleTranslate()
                }
            ],
            /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-z': [
                {
                    'translate-z': scaleTranslate()
                }
            ],
            /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-none': [
                'translate-none'
            ],
            // ---------------------
            // --- Interactivity ---
            // ---------------------
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: scaleColor()
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: scaleColor()
                }
            ],
            /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */ 'color-scheme': [
                {
                    scheme: [
                        'normal',
                        'dark',
                        'light',
                        'light-dark',
                        'only-dark',
                        'only-light'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */ 'field-sizing': [
                {
                    'field-sizing': [
                        'fixed',
                        'content'
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'auto',
                        'none'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        '',
                        'y',
                        'x'
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbs': [
                {
                    'scroll-mbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbe': [
                {
                    'scroll-mbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbs': [
                {
                    'scroll-pbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbe': [
                {
                    'scroll-pbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -----------
            // --- SVG ---
            // -----------
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            // ---------------------
            // --- Accessibility ---
            // ---------------------
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'inset-bs',
                'inset-be',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'right',
                'left'
            ],
            'inset-y': [
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pbs',
                'pbe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'pr',
                'pl'
            ],
            py: [
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mbs',
                'mbe',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'mr',
                'ml'
            ],
            my: [
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-x',
                'border-w-y',
                'border-w-s',
                'border-w-e',
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-x',
                'border-color-y',
                'border-color-s',
                'border-color-e',
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-t',
                'border-color-b'
            ],
            translate: [
                'translate-x',
                'translate-y',
                'translate-none'
            ],
            'translate-none': [
                'translate',
                'translate-x',
                'translate-y',
                'translate-z'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        },
        orderSensitiveModifiers: [
            '*',
            '**',
            'after',
            'backdrop',
            'before',
            'details-content',
            'file',
            'first-letter',
            'first-line',
            'marker',
            'placeholder',
            'selection'
        ]
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $85fc2fe65ff21506$var$mergeConfigs = (baseConfig, { cacheSize: cacheSize, prefix: prefix, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'prefix', prefix);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.theme, override.theme);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.classGroups, override.classGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'orderSensitiveModifiers', override.orderSensitiveModifiers);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.theme, extend.theme);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'orderSensitiveModifiers');
    return baseConfig;
};
const $85fc2fe65ff21506$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $85fc2fe65ff21506$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$85fc2fe65ff21506$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $85fc2fe65ff21506$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject)$85fc2fe65ff21506$var$mergeArrayProperties(baseObject, mergeObject, key);
};
const $85fc2fe65ff21506$var$mergeArrayProperties = (baseObject, mergeObject, key)=>{
    const mergeValue = mergeObject[key];
    if (mergeValue !== undefined) baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
};
const $85fc2fe65ff21506$var$extendTailwindMerge = (configExtension, ...createConfig)=>typeof configExtension === 'function' ? $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig, configExtension, ...createConfig) : $85fc2fe65ff21506$var$createTailwindMerge(()=>$85fc2fe65ff21506$var$mergeConfigs($85fc2fe65ff21506$var$getDefaultConfig(), configExtension), ...createConfig);
const $85fc2fe65ff21506$var$twMerge = /*#__PURE__*/ $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig);
$85fc2fe65ff21506$exports.createTailwindMerge = $85fc2fe65ff21506$var$createTailwindMerge;
$85fc2fe65ff21506$exports.extendTailwindMerge = $85fc2fe65ff21506$var$extendTailwindMerge;
$85fc2fe65ff21506$exports.fromTheme = $85fc2fe65ff21506$var$fromTheme;
$85fc2fe65ff21506$exports.getDefaultConfig = $85fc2fe65ff21506$var$getDefaultConfig;
$85fc2fe65ff21506$exports.mergeConfigs = $85fc2fe65ff21506$var$mergeConfigs;
$85fc2fe65ff21506$exports.twJoin = $85fc2fe65ff21506$var$twJoin;
$85fc2fe65ff21506$exports.twMerge = $85fc2fe65ff21506$var$twMerge;
$85fc2fe65ff21506$exports.validators = $85fc2fe65ff21506$var$validators;


const $a59241ddd28bd42d$export$b4660bb6000dfbc9 = (0, $85fc2fe65ff21506$exports.extendTailwindMerge)({
    prefix: 'twa',
    extend: {
        theme: {
            // ↓ `text` is the key of the namespace `--text-*`
            text: [
                '0',
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7'
            ],
            radius: [
                'none',
                'standard',
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                '2xl',
                '3xl',
                '4xl',
                'full'
            ]
        }
    }
});


const $82c87f52da9ba110$var$ALIGN_ITEMS_MAP = {
    center: 'twa:items-center',
    'flex-start': 'twa:items-start',
    start: 'twa:items-start',
    'flex-end': 'twa:items-end',
    end: 'twa:items-end',
    stretch: 'twa:items-stretch',
    baseline: 'twa:items-baseline'
};
const $82c87f52da9ba110$var$FLEX_DIRECTION_MAP = {
    row: 'twa:flex-row',
    column: 'twa:flex-col'
};
const $82c87f52da9ba110$var$JUSTIFY_CONTENT_MAP = {
    'space-between': 'twa:justify-between',
    'space-around': 'twa:justify-around',
    'space-evenly': 'twa:justify-evenly',
    'space-start': 'twa:justify-start',
    'space-end': 'twa:justify-end',
    center: 'twa:justify-center'
};
const $82c87f52da9ba110$var$FLEX_WRAP_MAP = {
    wrap: 'twa:flex-wrap',
    nowrap: 'twa:flex-nowrap',
    'wrap-reverse': 'twa:flex-wrap-reverse'
};
const $82c87f52da9ba110$export$f51f4c4ede09e011 = $acw62.forwardRef((props, ref)=>{
    const { className: _, flexDirection: flexDirection, alignItems: alignItems, justifyContent: justifyContent, flexWrap: flexWrap, as: as, ...domProps } = props;
    const className = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:flex', 'twa:box-border', $82c87f52da9ba110$var$FLEX_DIRECTION_MAP[flexDirection], $82c87f52da9ba110$var$ALIGN_ITEMS_MAP[alignItems], $82c87f52da9ba110$var$JUSTIFY_CONTENT_MAP[justifyContent], $82c87f52da9ba110$var$FLEX_WRAP_MAP[flexWrap]);
    const Cmp = as || 'div';
    return $acw62.createElement(Cmp, {
        ref: ref,
        ...domProps,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(className, props.className)
    });
});
const $82c87f52da9ba110$export$e71c4d32a2263218 = $acw62.forwardRef((props, ref)=>{
    const { className: className, as: as, ...domProps } = props;
    const Cmp = as || 'div';
    return $acw62.createElement(Cmp, {
        ref: ref,
        ...domProps,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:box-border', className)
    });
});



const $6fe0561618a75b4b$export$e0e193db4cb7689a = 'ab-Panel';
const $6fe0561618a75b4b$var$DEFAULT_BODY_CLS = 'twa:relative twa:flex-1 twa:p-2 twa:bg-defaultbackground twa:text-text-on-defaultbackground';
const $6fe0561618a75b4b$var$Header = ({ children: children, variant: variant = 'default', className: className, style: style, onClick: onClick, ...flexProps })=>{
    if (!children) return null;
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        alignItems: "center",
        style: {
            ...style
        },
        onClick: onClick,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(`${$6fe0561618a75b4b$export$e0e193db4cb7689a}__header ${$6fe0561618a75b4b$export$e0e193db4cb7689a}__header--variant-${variant}`, className),
        ...flexProps
    }, children);
};
const $6fe0561618a75b4b$var$Body = ({ children: children, bodyScroll: bodyScroll, variant: variant, className: className, style: style })=>{
    if (!children) return null;
    if (bodyScroll === true) bodyScroll = 'auto';
    const bodyCls = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($6fe0561618a75b4b$var$DEFAULT_BODY_CLS, `${$6fe0561618a75b4b$export$e0e193db4cb7689a}__body`, variant && `${$6fe0561618a75b4b$export$e0e193db4cb7689a}__body--variant-${variant}`, bodyScroll ? `twa:overflow-auto` : null, {
        'twa:bg-primarylight twa:text-text-on-primary twa:border-0': variant === 'modern'
    }, className);
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        style: style,
        className: bodyCls
    }, children);
};
const $6fe0561618a75b4b$var$PlainHeader = ({ children: children, className: className })=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`${$6fe0561618a75b4b$export$e0e193db4cb7689a}__header`, `${$6fe0561618a75b4b$export$e0e193db4cb7689a}__header--variant-plain`, className)
    }, children);
};
const $6fe0561618a75b4b$var$FlexBody = ({ children: children, className: className })=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($6fe0561618a75b4b$var$DEFAULT_BODY_CLS, `${$6fe0561618a75b4b$export$e0e193db4cb7689a}__body`, `${$6fe0561618a75b4b$export$e0e193db4cb7689a}__body--variant-flex`, 'twa:overflow-auto twa:min-h-0', 'twa:flex-1 twa:flex twa:flex-col', className)
    }, children);
};
const $6fe0561618a75b4b$var$Panel = (props)=>{
    const { border: border, className: className, header: header, children: children, headerProps: headerProps, bodyProps: bodyProps, bodyScroll: bodyScroll, variant: variant = 'default', ...boxProps } = props;
    const style = {};
    const headerStyle = {
        border: border,
        ...headerProps ? headerProps.style : null
    };
    const bodyStyle = {
        border: border,
        ...bodyProps ? bodyProps.style : null
    };
    const cls = (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)((0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($6fe0561618a75b4b$export$e0e193db4cb7689a, `${$6fe0561618a75b4b$export$e0e193db4cb7689a}--variant-${variant}`, !header ? `${$6fe0561618a75b4b$export$e0e193db4cb7689a}--no-header` : `${$6fe0561618a75b4b$export$e0e193db4cb7689a}--with-header`, 'twa:rounded-standard', 'twa:flex twa:flex-col'), className);
    let headerCls = headerProps?.className;
    if (cls.includes('twa:rounded-none')) headerCls = (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(headerCls, 'twa:rounded-none');
    let bodyCls = bodyProps?.className;
    if (cls.includes('twa:rounded-none')) bodyCls = (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(bodyCls, 'twa:rounded-none');
    if (cls.includes('twa:border-none')) bodyCls = (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(bodyCls, 'twa:border-none');
    let childrenArr = $acw62.Children.toArray(children);
    let theBody;
    let theHeader;
    childrenArr.forEach((child)=>{
        if ($acw62.isValidElement(child) && child.type === $6fe0561618a75b4b$var$FlexBody) theBody = child;
        else if ($acw62.isValidElement(child) && child.type === $6fe0561618a75b4b$var$PlainHeader) theHeader = child;
    });
    if (theHeader) {
        childrenArr = childrenArr.filter((child)=>child !== theHeader);
        theHeader = $acw62.createElement($6fe0561618a75b4b$var$PlainHeader, {
            ...theHeader.props,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(headerCls, theHeader.props.className ?? '')
        });
    }
    if (theBody) theBody = $acw62.createElement($6fe0561618a75b4b$var$FlexBody, {
        ...theBody.props,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(bodyCls, theBody.props.className ?? '')
    });
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...boxProps,
        style: {
            ...style,
            ...boxProps.style
        },
        className: cls
    }, theHeader ?? $acw62.createElement($6fe0561618a75b4b$var$Header, {
        ...headerProps,
        style: headerStyle,
        variant: variant,
        className: headerCls
    }, header), theBody ?? (childrenArr.length > 0 ? $acw62.createElement($6fe0561618a75b4b$var$Body, {
        ...bodyProps,
        style: bodyStyle,
        bodyScroll: bodyScroll,
        variant: variant,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(bodyCls)
    }, childrenArr) : null));
};
$6fe0561618a75b4b$var$Panel.PlainHeader = $6fe0561618a75b4b$var$PlainHeader;
$6fe0561618a75b4b$var$Panel.FlexBody = $6fe0561618a75b4b$var$FlexBody;
var $6fe0561618a75b4b$export$2e2bcd8739ae039 = $6fe0561618a75b4b$var$Panel;



var $acw62 = parcelRequire("acw62");
var $f46ed4009cb9c1cd$export$83d89fbfd8236492;
var $f46ed4009cb9c1cd$export$80e7718417253a51;
var $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51;
var $f46ed4009cb9c1cd$export$7020a3240b287705;
var $f46ed4009cb9c1cd$export$fbb4d68fe60c1629;
'use strict';
var $f46ed4009cb9c1cd$var$l, $f46ed4009cb9c1cd$var$s;

$f46ed4009cb9c1cd$var$l = (parcelRequire("8m4NT"));

$f46ed4009cb9c1cd$var$s = (parcelRequire("3AwCA"));
$f46ed4009cb9c1cd$export$83d89fbfd8236492 = $f46ed4009cb9c1cd$var$l.version;
$f46ed4009cb9c1cd$export$80e7718417253a51 = $f46ed4009cb9c1cd$var$l.renderToString;
$f46ed4009cb9c1cd$export$eb3a06aef9e6ee51 = $f46ed4009cb9c1cd$var$l.renderToStaticMarkup;
$f46ed4009cb9c1cd$export$7020a3240b287705 = $f46ed4009cb9c1cd$var$s.renderToReadableStream;
$f46ed4009cb9c1cd$export$fbb4d68fe60c1629 = $f46ed4009cb9c1cd$var$s.resume;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $c72009da7485afc2$var$join = (...args)=>args.filter((x)=>!!x).join(' ');
var $c72009da7485afc2$export$2e2bcd8739ae039 = $c72009da7485afc2$var$join;


const $f23ad61ef39bcee3$var$DEFAULT_SIZE = 20;
var $f23ad61ef39bcee3$export$2e2bcd8739ae039 = ({ children: children, size: size = $f23ad61ef39bcee3$var$DEFAULT_SIZE, name: name, tabIndex: tabIndex, color: color, ...props })=>{
    return $acw62.createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        tabIndex: tabIndex,
        "data-id": name,
        "data-name": "AdaptableIcon",
        ...props,
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(props.className, `ab-Icon ab-Icon--${name}`),
        style: {
            verticalAlign: 'middle',
            fill: color ?? 'currentColor',
            ...props.style
        }
    }, children);
};


var $7a2b2b638d7ff370$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
    }));



var $acw62 = parcelRequire("acw62");

var $377b9b9d6324ef73$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
    }));



var $acw62 = parcelRequire("acw62");

var $f1d7447992737013$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
    }));



var $acw62 = parcelRequire("acw62");

var $53e810c8a3ef5b54$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11 22V5.825L6.4 10.4 5 9l7-7 7 7-1.4 1.425-4.6-4.6V22Z"
    }));



var $acw62 = parcelRequire("acw62");

var $4c163f4ed4dadf32$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "m12 22-7-7 1.4-1.425 4.6 4.6V2h2v16.175l4.6-4.575L19 15Z"
    }));



var $acw62 = parcelRequire("acw62");

var $a3d717be74d2f204$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }), ";");



var $acw62 = parcelRequire("acw62");

var $d810c9e743ce619c$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M7 14l5-5 5 5z"
    }));



var $acw62 = parcelRequire("acw62");

var $d9cda10fc777df0e$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M7 10l5 5 5-5z"
    }));



var $acw62 = parcelRequire("acw62");

var $b609955ddc27feb5$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    }));



var $acw62 = parcelRequire("acw62");

var $6670356033251d4c$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
    }), $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }));



var $acw62 = parcelRequire("acw62");

var $df2af6cf7b2aa402$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
    }));



var $acw62 = parcelRequire("acw62");

var $12a30d4bb1271575$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    }));



var $acw62 = parcelRequire("acw62");

var $90d54f085d552a2b$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11,17H4A2,2 0 0,1 2,15V3A2,2 0 0,1 4,1H16V3H4V15H11V13L15,16L11,19V17M19,21V7H8V13H6V7A2,2 0 0,1 8,5H19A2,2 0 0,1 21,7V21A2,2 0 0,1 19,23H8A2,2 0 0,1 6,21V19H8V21H19Z"
    }));



var $acw62 = parcelRequire("acw62");

var $9d680960d9c80086$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $fc2bac91f1e01fd6$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }));



var $acw62 = parcelRequire("acw62");

var $064eb0f0e6bb973a$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }));



var $acw62 = parcelRequire("acw62");

var $378710245fa31c26$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2V8h2v4zm-1 10c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2z"
    }));



var $acw62 = parcelRequire("acw62");

var $63fbc0c475ebd422$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"
    }));



var $acw62 = parcelRequire("acw62");

var $a8fd8f9ecd8302a2$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
    }));



var $acw62 = parcelRequire("acw62");

var $fb8ef4543ae1e6ce$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"
    }));



var $acw62 = parcelRequire("acw62");

var $d6c68ad00030f92d$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
    }));



var $acw62 = parcelRequire("acw62");

var $ccac1c561e5bb44d$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
    }));



var $acw62 = parcelRequire("acw62");

var $9b7bc1c7996b4ee4$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M8,12H17.76L15.26,9.5L16.67,8.08L21.59,13L16.67,17.92L15.26,16.5L17.76,14H8V12M19,3C20.11,3 21,3.9 21,5V9.67L19,7.67V7H5V19H19V18.33L21,16.33V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H19Z"
    }));



var $acw62 = parcelRequire("acw62");

var $711f35f47d16e5ee$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 0 612 792"
    }, $acw62.createElement("path", {
        d: "M545.58,533.27V271.23L334.25,393.24c0.13,1.11,0.65,2.07,0.65,3.22c0,13.13-8.85,23.8-20.8,27.43v243.03   L545.58,533.27L545.58,533.27z"
    }), $acw62.createElement("path", {
        d: "M328.46,378.97l208.38-120.31v-0.65L305.79,126L74.74,258.01v0.65l208.38,120.31   c5.32-6.89,13.29-11.62,22.67-11.62C315.17,367.34,323.14,372.08,328.46,378.97L328.46,378.97z"
    }), $acw62.createElement("path", {
        d: "M277.33,393.24L66,271.23v262.04l231.48,133.64V423.88c-11.94-3.63-20.8-14.3-20.8-27.43   C276.68,395.31,277.2,394.35,277.33,393.24L277.33,393.24z"
    }));



var $acw62 = parcelRequire("acw62");

var $dfdbb65600ffa9bf$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"
    }));



var $acw62 = parcelRequire("acw62");

var $234cb8536e80a6bb$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        clipRule: "evenodd",
        fill: "none",
        d: "M0 0h24v24H0z"
    }), $acw62.createElement("path", {
        d: "M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
    }));



var $acw62 = parcelRequire("acw62");

var $af8b77bc3714a1f7$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
    }));



var $acw62 = parcelRequire("acw62");

var $7b41e1096b0ae452$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
    }));



var $acw62 = parcelRequire("acw62");

var $7864da92970e6ab6$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
    }));



var $acw62 = parcelRequire("acw62");

var $3cec3f7a2bf3472f$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
    }));



var $acw62 = parcelRequire("acw62");

var $58a7638b2eab106c$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
    }));



var $acw62 = parcelRequire("acw62");

var $49fccddc86aa6b2f$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("g", {
        transform: "scale(0.021 0.021)"
    }, $acw62.createElement("path", {
        d: "M320 768v-768h-128v768h-160l224 224 224-224h-160z"
    }), $acw62.createElement("path", {
        d: "M928 1024h-256c-11.8 0-22.644-6.496-28.214-16.9-5.566-10.404-4.958-23.030 1.59-32.85l222.832-334.25h-196.208c-17.672 0-32-14.328-32-32s14.328-32 32-32h256c11.8 0 22.644 6.496 28.214 16.9 5.566 10.404 4.958 23.030-1.59 32.85l-222.83 334.25h196.206c17.672 0 32 14.328 32 32s-14.328 32-32 32z"
    }), $acw62.createElement("path", {
        d: "M1020.622 401.686l-192.002-384c-5.42-10.842-16.502-17.69-28.622-17.69-12.122 0-23.202 6.848-28.624 17.69l-191.996 384c-7.904 15.806-1.496 35.030 14.31 42.932 4.594 2.296 9.476 3.386 14.288 3.386 11.736 0 23.040-6.484 28.644-17.698l55.156-110.31h216.446l55.156 110.31c7.902 15.806 27.124 22.21 42.932 14.31 15.808-7.902 22.216-27.124 14.312-42.93zM723.778 255.996l76.22-152.446 76.224 152.446h-152.444z"
    })));



var $acw62 = parcelRequire("acw62");

var $70affbd03aa2c241$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("g", {
        transform: "scale(0.021 0.021)"
    }, $acw62.createElement("path", {
        d: "M320 768v-768h-128v768h-160l224 224 224-224h-160z"
    }), $acw62.createElement("path", {
        d: "M928 448h-256c-11.8 0-22.644-6.496-28.214-16.9-5.566-10.406-4.958-23.030 1.59-32.85l222.832-334.25h-196.208c-17.672 0-32-14.328-32-32s14.328-32 32-32h256c11.8 0 22.644 6.496 28.214 16.9 5.566 10.406 4.958 23.030-1.59 32.85l-222.83 334.25h196.206c17.672 0 32 14.328 32 32s-14.328 32-32 32z"
    }), $acw62.createElement("path", {
        d: "M1020.622 977.69l-192.002-384c-5.42-10.842-16.502-17.69-28.622-17.69-12.122 0-23.202 6.848-28.624 17.69l-191.996 384c-7.904 15.806-1.496 35.030 14.31 42.932 4.594 2.296 9.476 3.386 14.288 3.386 11.736 0 23.040-6.484 28.644-17.698l55.158-110.31h216.446l55.156 110.31c7.902 15.806 27.124 22.21 42.932 14.31 15.806-7.902 22.214-27.124 14.31-42.93zM723.778 832l76.22-152.446 76.226 152.446h-152.446z"
    })));



var $acw62 = parcelRequire("acw62");

var $28483e7bc21b1fc1$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z"
    }));



var $acw62 = parcelRequire("acw62");

var $2b88e17dee640615$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
    }));



var $acw62 = parcelRequire("acw62");

var $a2c3655ce25d00c5$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M230-360h120v-60H250v-120h100v-60H230q-17 0-28.5 11.5T190-560v160q0 17 11.5 28.5T230-360Zm156 0h120q17 0 28.5-11.5T546-400v-60q0-17-11.5-31.5T506-506h-60v-34h100v-60H426q-17 0-28.5 11.5T386-560v60q0 17 11.5 30.5T426-456h60v36H386v60Zm264 0h60l70-240h-60l-40 138-40-138h-60l70 240ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z"
    }));



var $acw62 = parcelRequire("acw62");

var $257760179399e0ea$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M200-200h80v-80h-80v80Zm160 0h80v-80h-80v80Zm160 0h80v-80h-80v80Zm160 0h80v-80h-80v80ZM200-680h80v-80h-80v80Zm0 160h80v-80h-80v80Zm0 160h80v-80h-80v80Zm160-320h80v-80h-80v80Zm0 160h80v-80h-80v80Zm0 160h80v-80h-80v80Zm160-320h80v-80h-80v80Zm0 160h80v-80h-80v80Zm0 160h80v-80h-80v80Zm160-320h80v-80h-80v80Zm0 160h80v-80h-80v80Zm0 160h80v-80h-80v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $c277b276430a0d7f$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }));



var $acw62 = parcelRequire("acw62");

var $c910ade791439b50$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
    }));



var $acw62 = parcelRequire("acw62");

var $598c66af91e1d580$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
    }));



var $acw62 = parcelRequire("acw62");

var $76c10d88fcbefd87$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"
    }));



var $acw62 = parcelRequire("acw62");

var $e338ac1aa4d8c6d9$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
    }));



var $acw62 = parcelRequire("acw62");

var $ba73129c41aa73c5$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M21.7,13.35L20.7,14.35L18.65,12.3L19.65,11.3C19.86,11.08 20.21,11.08 20.42,11.3L21.7,12.58C21.92,12.79 21.92,13.14 21.7,13.35M12,18.94L18.07,12.88L20.12,14.93L14.06,21H12V18.94M4,2H18A2,2 0 0,1 20,4V8.17L16.17,12H12V16.17L10.17,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M4,6V10H10V6H4M12,6V10H18V6H12M4,12V16H10V12H4Z"
    }));



var $acw62 = parcelRequire("acw62");

var $cc903d575882a5d2$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
    }));



var $acw62 = parcelRequire("acw62");

var $9519188063d211b5$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M440-200h80v-167l64 64 56-57-160-160-160 160 57 56 63-63v167ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"
    }));



var $acw62 = parcelRequire("acw62");

var $fa52066f23591b26$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M14.67 14.4337V21.7831H9.33V14.4337H14.67ZM15.67 21.7831L20.9277 21.8072V14.4337H15.67V21.7831ZM8.33 21.7831V2.14458H3V21.7831H8.33Z"
    }), $acw62.createElement("path", {
        d: "M19.6426 2H10.6466C9.93976 2 9.36145 2.57831 9.36145 3.28514V12.2811C9.36145 12.988 9.93976 13.5663 10.6466 13.5663H19.6426C20.3494 13.5663 20.9277 12.988 20.9277 12.2811V3.28514C20.9277 2.57831 20.3494 2 19.6426 2ZM15.8064 4.60884L16.4876 3.92771L17.3936 4.83373L18.2996 3.92771L18.9807 4.60884L18.0747 5.51486L18.9807 6.42088L18.2996 7.10201L17.3936 6.20241L16.4876 7.10843L15.8064 6.42731L16.7124 5.52128L15.8064 4.60884ZM11.4498 5.03293H14.6627V5.99679H11.4498V5.03293ZM14.8233 10.3534H13.5382V11.6386H12.5743V10.3534H11.2892V9.38956H12.5743V8.10442H13.5382V9.38956H14.8233V10.3534ZM19 11.1566H15.7871V10.1928H19V11.1566ZM19 9.5502H15.7871V8.58635H19V9.5502Z"
    }));



var $acw62 = parcelRequire("acw62");

var $ec2f1d2953eba046$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
    }));



var $acw62 = parcelRequire("acw62");

var $cc09c97c81449a44$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z"
    }));



var $acw62 = parcelRequire("acw62");

var $1ca50c8469527acb$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("g", {
        transform: "matrix(0.966625, 0, 0, 0.966625, -161.245651, -58.219734)"
    }, $acw62.createElement("g", {
        transform: "matrix(1, 0, 0, 1, 167.951233, 60.368694)"
    }, $acw62.createElement("path", {
        d: "M 14.67 5 L 14.67 19 L 9.33 19 L 9.33 5 L 14.67 5 Z M 15.67 19 L 21 19 L 20.99 11.456 L 15.67 11.459 L 15.67 19 Z M 8.33 19 L 8.33 5 L 3 5 L 3 19 L 8.33 19 Z"
    })), $acw62.createElement("path", {
        d: "M 188.844 62.299 L 186.844 62.299 L 186.844 65.299 L 183.844 65.299 C 183.854 65.309 183.844 67.299 183.844 67.299 L 186.844 67.299 L 186.844 70.289 C 186.854 70.299 188.844 70.289 188.844 70.289 L 188.844 67.299 L 191.844 67.299 L 191.844 65.299 L 188.844 65.299 L 188.844 62.299 Z"
    })));



var $acw62 = parcelRequire("acw62");

var $788b064d936d6fc3$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
    }));



var $acw62 = parcelRequire("acw62");

var $68c9ea43e5e61dde$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
    }));



var $acw62 = parcelRequire("acw62");

var $44ed8cd21b6ba7ef$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M121-280v-400q0-33 23.5-56.5T201-760h559q33 0 56.5 23.5T840-680v400q0 33-23.5 56.5T760-200H201q-33 0-56.5-23.5T121-280Zm79 0h133v-400H200v400Zm213 0h133v-400H413v400Zm213 0h133v-400H626v400Z"
    }));



var $acw62 = parcelRequire("acw62");

var $b60b7fb8b61f5652$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z"
    }));



var $acw62 = parcelRequire("acw62");

var $981d92db13bb4893$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z"
    }));



var $acw62 = parcelRequire("acw62");

var $f8d9ded1f872fe1e$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M560-160v-80h120q17 0 28.5-11.5T720-280v-80q0-38 22-69t58-44v-14q-36-13-58-44t-22-69v-80q0-17-11.5-28.5T680-720H560v-80h120q50 0 85 35t35 85v80q0 17 11.5 28.5T840-560h40v160h-40q-17 0-28.5 11.5T800-360v80q0 50-35 85t-85 35H560Zm-280 0q-50 0-85-35t-35-85v-80q0-17-11.5-28.5T120-400H80v-160h40q17 0 28.5-11.5T160-600v-80q0-50 35-85t85-35h120v80H280q-17 0-28.5 11.5T240-680v80q0 38-22 69t-58 44v14q36 13 58 44t22 69v80q0 17 11.5 28.5T280-240h120v80H280Z"
    }));



var $acw62 = parcelRequire("acw62");

var $fe0ba94ee3c1ba8a$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M7 2v11h3v9l7-12h-4l4-8z"
    }));



var $acw62 = parcelRequire("acw62");

var $c6829e30776312ac$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
    }));



var $acw62 = parcelRequire("acw62");

var $f1ab39095a75520b$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z"
    }));



var $acw62 = parcelRequire("acw62");

var $8e9fe5aefba788f4$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
    }));



var $acw62 = parcelRequire("acw62");

var $81deb6752ec37474$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4M19.44 21V19H15.44V17H19.44V15L22.44 18L19.44 21"
    }));



var $acw62 = parcelRequire("acw62");

var $0f47472a0a60869c$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("defs", null, $acw62.createElement("path", {
        id: "a",
        d: "M0 0h24v24H0V0z"
    })), $acw62.createElement("clipPath", {
        id: "b"
    }, $acw62.createElement("use", {
        xlinkHref: "#a",
        overflow: "visible"
    })), $acw62.createElement("path", {
        d: "M4 9h16v2H4zm0 4h10v2H4z",
        clipPath: "url(#b)"
    }));



var $acw62 = parcelRequire("acw62");

var $d6e0e4fc7cbd4848$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
    }));



var $acw62 = parcelRequire("acw62");

var $edad434078b5000b$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
    }));



var $acw62 = parcelRequire("acw62");

var $a3b1b8effc2ab4e2$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
    }));



var $acw62 = parcelRequire("acw62");

var $1a79154f3233f096$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
    }));



var $acw62 = parcelRequire("acw62");

var $3d118f0fa4bbe146$export$2e2bcd8739ae039 // M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z
 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("defs", null, $acw62.createElement("path", {
        id: "a",
        d: "M0 0h24v24H0V0z"
    })), $acw62.createElement("clipPath", {
        id: "b"
    }, $acw62.createElement("use", {
        xlinkHref: "#a",
        overflow: "visible"
    })), $acw62.createElement("path", {
        clipPath: "url(#b)",
        d: "M17.63 5.84C17.27 5.33 16.67 5 16 5H5C3.9 5 3 5.9 3 7V17C3 18.11 3.9 19 5 19H16C16.67 19 17.27 18.66 17.63 18.15L22 12L17.63 5.84M8.45 8.03C9.23 8.03 9.87 8.67 9.87 9.45S9.23 10.87 8.45 10.87 7.03 10.23 7.03 9.45 7.67 8.03 8.45 8.03M13.55 15.97C12.77 15.97 12.13 15.33 12.13 14.55S12.77 13.13 13.55 13.13 14.97 13.77 14.97 14.55 14.33 15.97 13.55 15.97M8.2 16L7 14.8L13.8 8L15 9.2L8.2 16Z"
    }));



var $acw62 = parcelRequire("acw62");

var $719c37ece08f60c3$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
    }));



var $acw62 = parcelRequire("acw62");

var $21df90a3e941ef24$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M240-240v-480h80v480h-80Zm160 0 400-240-400-240v480Zm80-141v-198l165 99-165 99Zm0-99Z"
    }));



var $acw62 = parcelRequire("acw62");

var $ca45ea8d09f5d0b1$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"
    }));



var $acw62 = parcelRequire("acw62");

var $5bfa436c0bcf135c$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
    }));



var $acw62 = parcelRequire("acw62");

var $c6baaaaa224c29d0$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19.3,17.89C20.62,15.79 20,13 17.89,11.68C15.79,10.36 13,11 11.68,13.09C10.36,15.2 11,18 13.09,19.3C14.56,20.22 16.42,20.22 17.89,19.3L21,22.39L22.39,21L19.3,17.89M17.3,17.27C16.32,18.25 14.74,18.24 13.76,17.27C12.79,16.29 12.79,14.71 13.77,13.73C14.74,12.76 16.32,12.76 17.3,13.73C18.26,14.72 18.25,16.3 17.27,17.27H17.3M19,4H5A2,2 0 0,0 3,6V18A2,2 0 0,0 5,20H10.81C10.25,19.42 9.8,18.74 9.5,18H5V14H9.18C9.34,13.29 9.61,12.61 10,12H5V8H11V10.81C11.58,10.25 12.26,9.8 13,9.5V8H19V10C19.4,10.25 19.77,10.55 20.1,10.88C20.44,11.22 20.74,11.59 21,12V6A2,2 0 0,0 19,4Z"
    }));



var $acw62 = parcelRequire("acw62");

var $a5d90be476625ff4$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z"
    }));



var $acw62 = parcelRequire("acw62");

var $a3bb79cb65c35d20$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }), $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $8bb6fd8e38295fcb$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z"
    }), $acw62.createElement("path", {
        d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6"
    }));



var $acw62 = parcelRequire("acw62");

var $5ca3aabd52f0e60b$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
    }));



var $acw62 = parcelRequire("acw62");

var $6830419e99ce6556$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"
    }));



var $acw62 = parcelRequire("acw62");

var $30756f606e804c07$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }));



var $acw62 = parcelRequire("acw62");

var $7ed66726208c6963$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"
    }), $acw62.createElement("path", {
        fillOpacity: ".36",
        d: "M0 20h24v4H0z"
    }));



var $acw62 = parcelRequire("acw62");

var $7a708e40088d471a$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    }));



var $acw62 = parcelRequire("acw62");

var $3d475b057175fafa$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }));



var $acw62 = parcelRequire("acw62");

var $333cf5e8a19b6c34$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        fill: "currentColor",
        d: "M4 13C2.89 13 2 13.89 2 15V19C2 20.11 2.89 21 4 21H8C9.11 21 10 20.11 10 19V15C10 13.89 9.11 13 8 13M8.2 14.5L9.26 15.55L5.27 19.5L2.74 16.95L3.81 15.9L5.28 17.39M4 3C2.89 3 2 3.89 2 5V9C2 10.11 2.89 11 4 11H8C9.11 11 10 10.11 10 9V5C10 3.89 9.11 3 8 3M4 5H8V9H4M12 5H22V7H12M12 19V17H22V19M12 11H22V13H12Z"
    }));



var $acw62 = parcelRequire("acw62");

var $44cf1fce55850a1f$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
    }));



var $acw62 = parcelRequire("acw62");

var $d7e37ed7684f50fe$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
    }));



var $acw62 = parcelRequire("acw62");

var $e56ee60dedcdd40c$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M5,20h14v-2H5V20z M5,10h4v6h6v-6h4l-7-7L5,10z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $6e8b87c43ddb366c$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $e0d8eb269f133840$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H19A2,2 0 0,1 21,8H21L4,8V18L6.14,10H23.21L20.93,18.5C20.7,19.37 19.92,20 19,20Z"
    }));



var $acw62 = parcelRequire("acw62");

var $b5c32813b0d2d729$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h7v2H5v14h14v-7h2v7q0 .825-.587 1.413Q19.825 21 19 21Zm4.7-5.3-1.4-1.4L17.6 5H14V3h7v7h-2V6.4Z"
    }));



var $acw62 = parcelRequire("acw62");

var $c5d7fb1e47248a04$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
    }));



var $acw62 = parcelRequire("acw62");

var $4c1e6ce3ded8ea79$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z"
    }));



var $acw62 = parcelRequire("acw62");

var $4c56b35e840a57c6$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M8 5v14l11-7z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $d63931991552af20$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M6 6h12v12H6z"
    }));



var $acw62 = parcelRequire("acw62");

var $846b58a747e7b125$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    }));



var $acw62 = parcelRequire("acw62");

var $a56874cf4f9df297$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"
    }));



var $acw62 = parcelRequire("acw62");

var $38e0a22f99b8a5aa$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M7,19V17H9V19H7M11,19V17H13V19H11M15,19V17H17V19H15M7,15V13H9V15H7M11,15V13H13V15H11M15,15V13H17V15H15M7,11V9H9V11H7M11,11V9H13V11H11M15,11V9H17V11H15M7,7V5H9V7H7M11,7V5H13V7H11M15,7V5H17V7H15Z"
    }));



var $acw62 = parcelRequire("acw62");

var $33c565ac75895a4d$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
    }));



var $acw62 = parcelRequire("acw62");

var $c5abaf0836f56e34$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
    }));



var $acw62 = parcelRequire("acw62");

var $bb1cd949d428f763$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
    }));



var $acw62 = parcelRequire("acw62");

var $9aaddcb1acd1b9e3$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
    }));



var $acw62 = parcelRequire("acw62");

var $5370a27b42625517$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M18 18V20H4A2 2 0 0 1 2 18V8H4V18M22 6V14A2 2 0 0 1 20 16H8A2 2 0 0 1 6 14V6A2 2 0 0 1 8 4H20A2 2 0 0 1 22 6M20 6H8V14H20Z"
    }));



var $acw62 = parcelRequire("acw62");

var $23ebb56d3543230e$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M16.59,5.41L15.17,4L12,7.17L8.83,4L7.41,5.41L12,10M7.41,18.59L8.83,20L12,16.83L15.17,20L16.58,18.59L12,14L7.41,18.59Z"
    }));



var $acw62 = parcelRequire("acw62");

var $7cc0d514e5df668c$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
    }));



var $acw62 = parcelRequire("acw62");

var $4dfd1e7ed13282f4$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M10 21v-2H6.41l4.5-4.5l-1.41-1.41l-4.5 4.5V14H3v7h7m4.5-10.09l4.5-4.5V10h2V3h-7v2h3.59l-4.5 4.5l1.41 1.41z"
    }));



var $acw62 = parcelRequire("acw62");

var $311f931a0f9662e9$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
    }));



var $acw62 = parcelRequire("acw62");

var $2f0400f9032d0d21$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M15,19.88C15.04,20.18 14.94,20.5 14.71,20.71C14.32,21.1 13.69,21.1 13.3,20.71L9.29,16.7C9.06,16.47 8.96,16.16 9,15.87V10.75L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L15,10.75V19.88M7.04,5L11,10.06V15.58L13,17.58V10.05L16.96,5H7.04Z"
    }));



var $acw62 = parcelRequire("acw62");

var $4c0c6b13b7f5a605$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "m592-481-57-57 143-182H353l-80-80h487q25 0 36 22t-4 42L592-481ZM791-56 560-287v87q0 17-11.5 28.5T520-160h-80q-17 0-28.5-11.5T400-200v-247L56-791l56-57 736 736-57 56ZM535-538Z"
    }));



var $acw62 = parcelRequire("acw62");

var $de99b8960bf95ff2$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z"
    }));



var $acw62 = parcelRequire("acw62");

var $08bf4dd129469ba9$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M15.6,5.29C14.5,5.19 13.53,6 13.43,7.11L13.18,10H16V12H13L12.56,17.07C12.37,19.27 10.43,20.9 8.23,20.7C6.92,20.59 5.82,19.86 5.17,18.83L6.67,17.33C6.91,18.07 7.57,18.64 8.4,18.71C9.5,18.81 10.47,18 10.57,16.89L11,12H8V10H11.17L11.44,6.93C11.63,4.73 13.57,3.1 15.77,3.3C17.08,3.41 18.18,4.14 18.83,5.17L17.33,6.67C17.09,5.93 16.43,5.36 15.6,5.29Z"
    }));



var $acw62 = parcelRequire("acw62");

var $da5a9c9ac97f3652$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M6.5,2.27L20,10.14L6.5,18L5.5,16.27L16.03,10.14L5.5,4L6.5,2.27M20,20V22H5V20H20Z"
    }));



var $acw62 = parcelRequire("acw62");

var $58cb18c3bbbbff2a$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M5.5,4.14L4.5,5.86L15,12L4.5,18.14L5.5,19.86L19,12L5.5,4.14Z"
    }));



var $acw62 = parcelRequire("acw62");

var $a21b9e4578e89ced$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M18.5,2.27L5,10.14L18.5,18L19.5,16.27L8.97,10.14L19.5,4L18.5,2.27M5,20V22H20V20H5Z"
    }));



var $acw62 = parcelRequire("acw62");

var $86a0cf0b1345181d$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M18.5,4.14L19.5,5.86L8.97,12L19.5,18.14L18.5,19.86L5,12L18.5,4.14Z"
    }));



var $acw62 = parcelRequire("acw62");

var $070c9e172ac5f93d$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19,13H5V11H19V13Z"
    }));



var $acw62 = parcelRequire("acw62");

var $221c7399d3901136$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11,3H13V10.27L19.29,6.64L20.29,8.37L14,12L20.3,15.64L19.3,17.37L13,13.72V21H11V13.73L4.69,17.36L3.69,15.63L10,12L3.72,8.36L4.72,6.63L11,10.26V3Z"
    }));



var $acw62 = parcelRequire("acw62");

var $882d123a536fda91$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19,13H5V11H19V13M12,5A2,2 0 0,1 14,7A2,2 0 0,1 12,9A2,2 0 0,1 10,7A2,2 0 0,1 12,5M12,15A2,2 0 0,1 14,17A2,2 0 0,1 12,19A2,2 0 0,1 10,17A2,2 0 0,1 12,15Z"
    }));



var $acw62 = parcelRequire("acw62");

var $a875de95859c47cb$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M18.5,3.5L3.5,18.5L5.5,20.5L20.5,5.5M7,4A3,3 0 0,0 4,7A3,3 0 0,0 7,10A3,3 0 0,0 10,7A3,3 0 0,0 7,4M17,14A3,3 0 0,0 14,17A3,3 0 0,0 17,20A3,3 0 0,0 20,17A3,3 0 0,0 17,14Z"
    }));



var $acw62 = parcelRequire("acw62");

var $b4209a4929d257ff$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M15.38,3L17.77,8.75C17.55,9.68 17.27,10.32 17,10.7C16.67,11.18 16.44,11.25 16.19,11.25V12.75C16.94,12.75 17.74,12.35 18.24,11.56C19.87,8.94 22,3 22,3H20.38L18.69,7.05L17,3H15.38M3.42,8.59L2,10L6.79,14.79L2,19.59L3.41,21L8.21,16.21L13,21L14.41,19.59L9.62,14.79L14.41,10L13,8.59L8.21,13.38L3.41,8.59H3.42Z"
    }));



var $acw62 = parcelRequire("acw62");

var $e68dcb4d2c5fa8a2$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M19,10H5V8H19V10M19,16H5V14H19V16Z"
    }));



var $acw62 = parcelRequire("acw62");

var $806c358661385ccd$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M21,10H9V8H21V10M21,16H9V14H21V16M4,5H6V16H4V5M6,18V20H4V18H6Z"
    }));



var $acw62 = parcelRequire("acw62");

var $48a8821e178d9536$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4M12 6.29L14.03 11.71H9.96M20 14V18H2V20H22V14Z"
    }));



var $acw62 = parcelRequire("acw62");

var $be91be067019bff7$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4M12 6.29L14.03 11.71H9.96M4 18V15H2V20H22V18Z"
    }));



var $acw62 = parcelRequire("acw62");

var $987ca9b8e63086dc$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
    }));



var $acw62 = parcelRequire("acw62");

var $a329a2b7cb354a64$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
    }));



var $acw62 = parcelRequire("acw62");

var $468990a47323e77d$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4M12 6.29L14.03 11.71H9.96M20 14V18H4V15H2V20H22V14Z"
    }));



var $acw62 = parcelRequire("acw62");

var $4b439bffa3aab518$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11.14 11.71H9.96M20 14V18H4V15H2V20H22V14Z"
    }));



var $acw62 = parcelRequire("acw62");

var $8b861ac9a9925f5d$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M16,16.92C15.67,16.97 15.34,17 15,17C14.66,17 14.33,16.97 14,16.92V13.41L11.5,15.89C11,15.5 10.5,15 10.11,14.5L12.59,12H9.08C9.03,11.67 9,11.34 9,11C9,10.66 9.03,10.33 9.08,10H12.59L10.11,7.5C10.3,7.25 10.5,7 10.76,6.76V6.76C11,6.5 11.25,6.3 11.5,6.11L14,8.59V5.08C14.33,5.03 14.66,5 15,5C15.34,5 15.67,5.03 16,5.08V8.59L18.5,6.11C19,6.5 19.5,7 19.89,7.5L17.41,10H20.92C20.97,10.33 21,10.66 21,11C21,11.34 20.97,11.67 20.92,12H17.41L19.89,14.5C19.7,14.75 19.5,15 19.24,15.24V15.24C19,15.5 18.75,15.7 18.5,15.89L16,13.41V16.92H16V16.92M5,19A2,2 0 0,1 7,17A2,2 0 0,1 9,19A2,2 0 0,1 7,21A2,2 0 0,1 5,19H5Z"
    }));



var $acw62 = parcelRequire("acw62");

var $ec697d444ace1f5b$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
    }));



var $acw62 = parcelRequire("acw62");

var $2d61e26ae080e693$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    }));



var $acw62 = parcelRequire("acw62");

var $db2d8410769f149a$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
    }), $acw62.createElement("path", {
        d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 15h14v3H5z"
    }));



var $acw62 = parcelRequire("acw62");

var $3f53a0a0ce07b81e$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M11 18H13V15H16V13H13V10H11V13H8V15H11ZM18 22H6Q5.175 22 4.588 21.413Q4 20.825 4 20V4Q4 3.175 4.588 2.587Q5.175 2 6 2H14L20 8V20Q20 20.825 19.413 21.413Q18.825 22 18 22ZM13 9V4H6Q6 4 6 4Q6 4 6 4V20Q6 20 6 20Q6 20 6 20H18Q18 20 18 20Q18 20 18 20V9ZM6 4V9V4V9V20Q6 20 6 20Q6 20 6 20Q6 20 6 20Q6 20 6 20V4Q6 4 6 4Q6 4 6 4Z"
    }));



var $acw62 = parcelRequire("acw62");

var $ef02b6922df81992$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M6 21q-1.125 0-2.225-.55T2 19q.65 0 1.325-.512Q4 17.975 4 17q0-1.25.875-2.125T7 14q1.25 0 2.125.875T10 17q0 1.65-1.175 2.825Q7.65 21 6 21Zm0-2q.825 0 1.412-.587Q8 17.825 8 17q0-.425-.287-.712Q7.425 16 7 16t-.713.288Q6 16.575 6 17q0 .575-.137 1.05-.138.475-.363.9.125.05.25.05H6Zm5.75-4L9 12.25l8.95-8.95q.275-.275.688-.288.412-.012.712.288l1.35 1.35q.3.3.3.7 0 .4-.3.7ZM7 17Z"
    }));



var $acw62 = parcelRequire("acw62");

var $92408934b49bab72$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 96 960 960"
    }, $acw62.createElement("path", {
        d: "M440 616v-80h80v80h-80Zm-80 80v-80h80v80h-80Zm160 0v-80h80v80h-80Zm80-80v-80h80v80h-80Zm-320 0v-80h80v80h-80Zm-80 320q-33 0-56.5-23.5T120 856V296q0-33 23.5-56.5T200 216h560q33 0 56.5 23.5T840 296v560q0 33-23.5 56.5T760 936H200Zm80-80h80v-80h-80v80Zm160 0h80v-80h-80v80Zm320 0v-80 80Zm-560-80h80v-80h80v80h80v-80h80v80h80v-80h80v80h80v-80h-80v-80h80V296H200v320h80v80h-80v80Zm0 80V296v560Zm560-240v80-80ZM600 776v80h80v-80h-80Z"
    }));



var $acw62 = parcelRequire("acw62");

var $cca3478c2f02cd20$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 96 960 960"
    }, $acw62.createElement("path", {
        d: "M160 976q-33 0-56.5-23.5T80 896V456q0-33 23.5-56.5T160 376h200V256q0-33 23.5-56.5T440 176h80q33 0 56.5 23.5T600 256v120h200q33 0 56.5 23.5T880 456v440q0 33-23.5 56.5T800 976H160Zm0-80h640V456H600q0 33-23.5 56.5T520 536h-80q-33 0-56.5-23.5T360 456H160v440Zm80-80h240v-18q0-17-9.5-31.5T444 744q-20-9-40.5-13.5T360 726q-23 0-43.5 4.5T276 744q-17 8-26.5 22.5T240 798v18Zm320-60h160v-60H560v60Zm-200-60q25 0 42.5-17.5T420 636q0-25-17.5-42.5T360 576q-25 0-42.5 17.5T300 636q0 25 17.5 42.5T360 696Zm200-60h160v-60H560v60ZM440 456h80V256h-80v200Zm40 220Z"
    }));



var $acw62 = parcelRequire("acw62");

var $b94e50129e73ecea$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 96 960 960"
    }, $acw62.createElement("path", {
        xmlns: "http://www.w3.org/2000/svg",
        d: "M200 856V756h160l120-360H320V296h400v100H580L460 756h140v100H200Z"
    }));



var $acw62 = parcelRequire("acw62");

var $a9088d9326032807$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 96 960 960"
    }, $acw62.createElement("path", {
        d: "M272 856V296h221q65 0 120 40t55 111q0 51-23 78.5T602 565q25 11 55.5 41t30.5 90q0 89-65 124.5T501 856H272Zm121-112h104q48 0 58.5-24.5T566 684q0-11-10.5-35.5T494 624H393v120Zm0-228h93q33 0 48-17t15-38q0-24-17-39t-44-15h-95v109Z"
    }));



var $acw62 = parcelRequire("acw62");

var $a75723d5241007bf$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 96 960 960"
    }, $acw62.createElement("path", {
        d: "M120 936v-80h720v80H120Zm0-160v-80h480v80H120Zm0-160v-80h720v80H120Zm0-160v-80h480v80H120Zm0-160v-80h720v80H120Z"
    }));



var $acw62 = parcelRequire("acw62");

var $3377e23b3aaf241b$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 96 960 960"
    }, $acw62.createElement("path", {
        d: "M120 936v-80h720v80H120Zm240-160v-80h480v80H360ZM120 616v-80h720v80H120Zm240-160v-80h480v80H360ZM120 296v-80h720v80H120Z"
    }));



var $acw62 = parcelRequire("acw62");

var $9cbddd4e0bf196c0$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 96 960 960"
    }, $acw62.createElement("path", {
        d: "M120 936v-80h720v80H120Zm160-160v-80h400v80H280ZM120 616v-80h720v80H120Zm160-160v-80h400v80H280ZM120 296v-80h720v80H120Z"
    }));



var $acw62 = parcelRequire("acw62");

var $dbbe9dff0b578652$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 96 960 960"
    }, $acw62.createElement("path", {
        d: "M200 296v-80h560v80H200Zm280 640q-117 0-198.5-81.5T200 656q0-117 81.5-198.5T480 376q117 0 198.5 81.5T760 656q0 117-81.5 198.5T480 936Zm0-100q75 0 127.5-52.5T660 656q0-75-52.5-127.5T480 476q-75 0-127.5 52.5T300 656q0 75 52.5 127.5T480 836Z"
    }));



var $acw62 = parcelRequire("acw62");

var $f75fd4bf485b899b$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 96 960 960"
    }, $acw62.createElement("path", {
        d: "M200 936v-80h560v80H200Zm280-160q-101 0-157-63t-56-167V216h103v336q0 56 28 91t82 35q54 0 82-35t28-91V216h103v330q0 104-56 167t-157 63Z"
    }));



var $acw62 = parcelRequire("acw62");

var $7c1b04fc741fd717$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 96 960 960"
    }, $acw62.createElement("path", {
        d: "M486 896q-76 0-135-45t-85-123l88-38q14 48 48.5 79t85.5 31q42 0 76-20t34-64q0-18-7-33t-19-27h112q5 14 7.5 28.5T694 716q0 86-61.5 133T486 896ZM80 576v-80h800v80H80Zm402-326q66 0 115.5 32.5T674 382l-88 39q-9-29-33.5-52T484 346q-41 0-68 18.5T386 416h-96q2-69 54.5-117.5T482 250Z"
    }));



var $acw62 = parcelRequire("acw62");

var $020292bdd17f8746$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 0 15 15"
    }, $acw62.createElement("path", {
        d: "M3.69899 5.20703C2.05823 5.20703 0.809204 6.68569 0.809204 8.60972C0.809204 10.6337 2.15823 12.0124 3.69899 12.0124C4.52126 12.0124 5.37402 11.6693 5.9539 11.0223V11.53C5.9539 11.7785 6.15537 11.98 6.4039 11.98C6.65243 11.98 6.8539 11.7785 6.8539 11.53V5.72001C6.8539 5.47149 6.65243 5.27001 6.4039 5.27001C6.15537 5.27001 5.9539 5.47149 5.9539 5.72001V6.22269C5.40506 5.60075 4.59218 5.20703 3.69899 5.20703ZM5.9539 9.799V7.30117C5.56339 6.58064 4.74118 6.05757 3.8868 6.05757C2.9089 6.05757 1.83508 6.96581 1.83508 8.60955C1.83508 10.1533 2.80889 11.1615 3.8868 11.1615C4.76984 11.1615 5.57141 10.4957 5.9539 9.799ZM10.799 5.20703C9.15823 5.20703 7.9092 6.68569 7.9092 8.60972C7.9092 10.6337 9.25823 12.0124 10.799 12.0124C11.6215 12.0124 12.4744 11.6692 13.0543 11.0218V11.53C13.0543 11.7785 13.2558 11.98 13.5043 11.98C13.7529 11.98 13.9543 11.7785 13.9543 11.53V5.72C13.9543 5.47147 13.7529 5.27 13.5043 5.27C13.2558 5.27 13.0543 5.47147 13.0543 5.72V6.22318C12.5055 5.60095 11.6924 5.20703 10.799 5.20703ZM13.0543 9.79822V7.30196C12.664 6.58102 11.8415 6.05757 10.9868 6.05757C10.0089 6.05757 8.93508 6.96581 8.93508 8.60955C8.93508 10.1533 9.90889 11.1615 10.9868 11.1615C11.8702 11.1615 12.672 10.4952 13.0543 9.79822Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));



var $acw62 = parcelRequire("acw62");

var $04078a52cbddd68d$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 0 15 15"
    }, $acw62.createElement("path", {
        d: "M3.6255 2.75C3.83478 2.75 4.02192 2.88034 4.09448 3.07664L7.16985 11.3962C7.2656 11.6552 7.13324 11.9428 6.87423 12.0386C6.61522 12.1343 6.32763 12.002 6.23188 11.7429L5.22387 9.01603H2.02712L1.01911 11.7429C0.923362 12.002 0.635774 12.1343 0.376762 12.0386C0.117749 11.9428 -0.0146052 11.6552 0.0811401 11.3962L3.15651 3.07664C3.22908 2.88034 3.41621 2.75 3.6255 2.75ZM3.6255 4.69207L4.90966 8.16603H2.34133L3.6255 4.69207ZM11.3719 2.75C11.5811 2.75 11.7683 2.88034 11.8408 3.07664L14.9162 11.3962C15.012 11.6552 14.8796 11.9428 14.6206 12.0386C14.3616 12.1343 14.074 12.002 13.9782 11.7429L12.9702 9.01603H9.77348L8.76547 11.7429C8.66972 12.002 8.38213 12.1343 8.12312 12.0386C7.86411 11.9428 7.73175 11.6552 7.8275 11.3962L10.9029 3.07664C10.9754 2.88034 11.1626 2.75 11.3719 2.75ZM11.3719 4.69207L12.656 8.16603H10.0877L11.3719 4.69207Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));



var $acw62 = parcelRequire("acw62");

var $c302803b35f1e282$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 0 17 17"
    }, $acw62.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.10889 3.11667C4.34607 3.11667 4.55816 3.26439 4.6404 3.48686L8.12582 12.9157C8.23433 13.2092 8.08433 13.5352 7.79078 13.6437C7.49724 13.7522 7.1713 13.6023 7.06279 13.3086L5.92037 10.2182H2.29739L1.15498 13.3086C1.04646 13.6023 0.720532 13.7522 0.426985 13.6437C0.133437 13.5352 -0.0165648 13.2092 0.0919466 12.9157L3.57737 3.48686C3.65961 3.26439 3.87169 3.11667 4.10889 3.11667ZM4.10889 5.31768L5.56427 9.25484H2.6535L4.10889 5.31768Z"
    }), $acw62.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.2389 5.90131C10.3793 5.90131 8.96375 7.57712 8.96375 9.75769C8.96375 12.0515 10.4926 13.6141 12.2389 13.6141C13.171 13.6141 14.1376 13.2251 14.7949 12.4914V13.0673C14.7949 13.349 15.0232 13.5773 15.3049 13.5773C15.5866 13.5773 15.8149 13.349 15.8149 13.0673V6.48267C15.8149 6.201 15.5866 5.97267 15.3049 5.97267C15.0232 5.97267 14.7949 6.201 14.7949 6.48267V7.05294C14.1729 6.34775 13.2514 5.90131 12.2389 5.90131ZM14.7949 11.1047V8.27556C14.3525 7.4585 13.4204 6.86525 12.4517 6.86525C11.3434 6.86525 10.1264 7.89459 10.1264 9.7575C10.1264 11.5071 11.2301 12.6497 12.4517 12.6497C13.4529 12.6497 14.3616 11.8946 14.7949 11.1047Z"
    }));



var $acw62 = parcelRequire("acw62");

var $8141779d7ca21254$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M450-420q38 0 64-26t26-64q0-38-26-64t-64-26q-38 0-64 26t-26 64q0 38 26 64t64 26Zm193 160L538-365q-20 13-42.5 19t-45.5 6q-71 0-120.5-49.5T280-510q0-71 49.5-120.5T450-680q71 0 120.5 49.5T620-510q0 23-6.5 45.5T594-422l106 106-57 56ZM200-120q-33 0-56.5-23.5T120-200v-160h80v160h160v80H200Zm400 0v-80h160v-160h80v160q0 33-23.5 56.5T760-120H600ZM120-600v-160q0-33 23.5-56.5T200-840h160v80H200v160h-80Zm640 0v-160H600v-80h160q33 0 56.5 23.5T840-760v160h-80Z"
    }));



var $acw62 = parcelRequire("acw62");

var $534c858af9da1e19$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M143-192v-72h432v72H143Zm480.774-240Q544-432 488-488.226t-56-136Q432-704 488.226-760t136-56Q704-816 760-759.774t56 136Q816-544 759.774-488t-136 56ZM143-492v-72h224q5 20 12 37.5t17 34.5H143Zm0 150v-72h322q24.227 18.242 51.613 30.621Q544-371 575-365v23H143Zm457-186h48v-96h-48v96Zm24-144q9.6 0 16.8-7.2 7.2-7.2 7.2-16.8 0-9.6-7.2-16.8-7.2-7.2-16.8-7.2-9.6 0-16.8 7.2-7.2 7.2-7.2 16.8 0 9.6 7.2 16.8 7.2 7.2 16.8 7.2Z"
    }));



var $acw62 = parcelRequire("acw62");

var $8e76d2d1a91dddf6$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M760-200v-120H200v120h560Zm0-200v-160H200v160h560Zm0-240v-120H200v120h560ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Z"
    }));



var $acw62 = parcelRequire("acw62");

var $8c6e2a8512adc2e4$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M444-192h72v-48h12q20.4 0 34.2-13.8Q576-267.6 576-288v-72q0-20.4-13.8-34.2Q548.4-408 528-408h-96v-72h144v-48h-60v-48h-72v48h-12q-20.4 0-34.2 13.8Q384-500.4 384-480v72q0 20.4 13.8 34.2Q411.6-360 432-360h96v72H384v48h60v48ZM263.717-96Q234-96 213-117.15T192-168v-624q0-29.7 21.15-50.85Q234.3-864 264-864h312l192 192v504q0 29.7-21.162 50.85Q725.676-96 695.96-96H263.717ZM528-624v-168H264v624h432v-456H528ZM264-792v189-189 624-624Z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $9fff6799e8cd9ae4$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M16,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V8L16,3z M19,19H5V5h10v4h4V19z M7,17h10v-2H7V17z M12,7H7 v2h5V7z M7,13h10v-2H7V13z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $9d508a99779f26a8$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M15.82,7.22l-1,0.4c-0.21-0.16-0.43-0.29-0.67-0.39L14,6.17C13.98,6.07,13.9,6,13.8,6h-1.6c-0.1,0-0.18,0.07-0.19,0.17 l-0.15,1.06c-0.24,0.1-0.47,0.23-0.67,0.39l-1-0.4c-0.09-0.03-0.2,0-0.24,0.09l-0.8,1.38c-0.05,0.09-0.03,0.2,0.05,0.26l0.85,0.66 C10.02,9.73,10,9.87,10,10c0,0.13,0.01,0.26,0.03,0.39l-0.84,0.66c-0.08,0.06-0.1,0.17-0.05,0.25l0.8,1.39 c0.05,0.09,0.15,0.12,0.25,0.09l0.99-0.4c0.21,0.16,0.43,0.29,0.68,0.39L12,13.83c0.02,0.1,0.1,0.17,0.2,0.17h1.6 c0.1,0,0.18-0.07,0.2-0.17l0.15-1.06c0.24-0.1,0.47-0.23,0.67-0.39l0.99,0.4c0.09,0.04,0.2,0,0.24-0.09l0.8-1.39 c0.05-0.09,0.03-0.19-0.05-0.25l-0.83-0.66C15.99,10.26,16,10.13,16,10c0-0.14-0.01-0.27-0.03-0.39l0.85-0.66 c0.08-0.06,0.1-0.17,0.05-0.26l-0.8-1.38C16.02,7.22,15.91,7.19,15.82,7.22z M13,11.43c-0.79,0-1.43-0.64-1.43-1.43 S12.21,8.57,13,8.57s1.43,0.64,1.43,1.43S13.79,11.43,13,11.43z"
    }), $acw62.createElement("path", {
        d: "M19.94,9.06c-0.43-3.27-3.23-5.86-6.53-6.05C13.27,3,13.14,3,13,3C9.47,3,6.57,5.61,6.08,9l-1.93,3.48 C3.74,13.14,4.22,14,5,14h1v2c0,1.1,0.9,2,2,2h1v3h7v-4.68C18.62,15.07,20.35,12.24,19.94,9.06z M14.89,14.63L14,15.05V19h-3v-3H8 v-4H6.7l1.33-2.33C8.21,7.06,10.35,5,13,5c2.76,0,5,2.24,5,5C18,12.09,16.71,13.88,14.89,14.63z"
    }));



var $acw62 = parcelRequire("acw62");

var $d37a7c971ea0d5a7$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-6.74L16.71 6H6.29l5.21-2.74m0-2.26L2 6v2h19V6l-9.5-5z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $5b281d3e4cf5a51f$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M12 16q1.875 0 3.188-1.312Q16.5 13.375 16.5 11.5q0-1.875-1.312-3.188Q13.875 7 12 7q-1.875 0-3.188 1.312Q7.5 9.625 7.5 11.5q0 1.875 1.312 3.188Q10.125 16 12 16Zm0-1.8q-1.125 0-1.912-.788Q9.3 12.625 9.3 11.5t.788-1.913Q10.875 8.8 12 8.8t1.913.787q.787.788.787 1.913t-.787 1.912q-.788.788-1.913.788Zm0 4.8q-3.65 0-6.65-2.038-3-2.037-4.35-5.462 1.35-3.425 4.35-5.463Q8.35 4 12 4q3.65 0 6.65 2.037 3 2.038 4.35 5.463-1.35 3.425-4.35 5.462Q15.65 19 12 19Zm0-7.5Zm0 5.5q2.825 0 5.188-1.488Q19.55 14.025 20.8 11.5q-1.25-2.525-3.612-4.013Q14.825 6 12 6 9.175 6 6.812 7.487 4.45 8.975 3.2 11.5q1.25 2.525 3.612 4.012Q9.175 17 12 17Z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $8a09ffe4b0b3cdfd$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "m16.1 13.3-1.45-1.45q.225-1.175-.675-2.2-.9-1.025-2.325-.8L10.2 7.4q.425-.2.862-.3Q11.5 7 12 7q1.875 0 3.188 1.312Q16.5 9.625 16.5 11.5q0 .5-.1.938-.1.437-.3.862Zm3.2 3.15-1.45-1.4q.95-.725 1.688-1.588.737-.862 1.262-1.962-1.25-2.525-3.588-4.013Q14.875 6 12 6q-.725 0-1.425.1-.7.1-1.375.3L7.65 4.85q1.025-.425 2.1-.638Q10.825 4 12 4q3.775 0 6.725 2.087Q21.675 8.175 23 11.5q-.575 1.475-1.512 2.738Q20.55 15.5 19.3 16.45Zm.5 6.15-4.2-4.15q-.875.275-1.762.413Q12.95 19 12 19q-3.775 0-6.725-2.087Q2.325 14.825 1 11.5q.525-1.325 1.325-2.463Q3.125 7.9 4.15 7L1.4 4.2l1.4-1.4 18.4 18.4ZM5.55 8.4q-.725.65-1.325 1.425T3.2 11.5q1.25 2.525 3.587 4.012Q9.125 17 12 17q.5 0 .975-.062.475-.063.975-.138l-.9-.95q-.275.075-.525.112Q12.275 16 12 16q-1.875 0-3.188-1.312Q7.5 13.375 7.5 11.5q0-.275.037-.525.038-.25.113-.525Zm7.975 2.325ZM9.75 12.6Z"
    }));



var $acw62 = parcelRequire("acw62");

var $bea798acd08d9395$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
    }));



var $acw62 = parcelRequire("acw62");

var $d1b976370a1c8c66$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M444-144v-80q-51-11-87.5-46T305-357l74-30q8 36 40.5 64.5T487-294q39 0 64-20t25-52q0-30-22.5-50T474-456q-78-28-114-61.5T324-604q0-50 32.5-86t87.5-47v-79h72v79q72 12 96.5 55t25.5 45l-70 29q-8-26-32-43t-53-17q-35 0-58 18t-23 44q0 26 25 44.5t93 41.5q70 23 102 60t32 94q0 57-37 96t-101 49v77h-72Z"
    }));



var $acw62 = parcelRequire("acw62");

var $906574715d8e943a$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M80-120v-720h390v165h410v555H80Zm60-60h270v-105H140v105Zm0-165h270v-105H140v105Zm0-165h270v-105H140v105Zm0-165h270v-105H140v105Zm330 495h350v-435H470v435Zm80-270v-60h165v60H550Zm0 165v-60h165v60H550Z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $2afecf14f1aeb60d$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M216-144q-46 0-66-40.5t8.976-75.714L360-504v-240h-35.789Q309-744 298.5-754.289q-10.5-10.29-10.5-25.5Q288-795 298.35-805.5 308.7-816 324-816h312q15.3 0 25.65 10.289 10.35 10.29 10.35 25.5Q672-765 661.65-754.5 651.3-744 636-744h-36v240l201 244q28 35 8 75.5T744-144H216Zm0-72h528L528-480v-264h-96v264L216-216Zm265-264Z"
    }));



var $acw62 = parcelRequire("acw62");

var $0a8b73f4d6289b4b$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M246-160q-24 0-42-18t-18-42v-406L47-800h773q24 0 42 18t18 42v520q0 24-18 42t-42 18H246Zm0-580v520h574v-520H246Zm284 471 43-43-63-61h206v-60H364l166 164ZM364-527h352L550-690l-43 42 63 61H364v60ZM246-740v520-520Z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $c49ebc7da8467e29$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M602-319h131q12.75 0 21.375-8.625T763-349v-262q0-12.75-8.625-21.375T733-641H602q-12.75 0-21.375 8.625T572-611v262q0 12.75 8.625 21.375T602-319Zm30-60v-202h71v202h-71Zm-278 60h126q12.75 0 21.375-8.625T510-349v-262q0-12.75-8.625-21.375T480-641H354q-12.75 0-21.375 8.625T324-611v262q0 12.75 8.625 21.375T354-319Zm30-60v-202h66v202h-66Zm-187 60h60v-322h-60v322ZM80-160v-640h800v640H80Zm60-580v520-520Zm0 520h680v-520H140v520Z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $78450b5f61366b29$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "m704-139 139-138-42-42-97 95-39-39-42 43 81 81ZM240-620h480v-60H240v60ZM732.5-41Q655-41 600-96.5T545-228q0-78.435 54.99-133.717Q654.98-417 733-417q77 0 132.5 55.283Q921-306.435 921-228q0 76-55.5 131.5T732.5-41ZM120-81v-699q0-24.75 17.625-42.375T180-840h600q24.75 0 42.375 17.625T840-780v327q-14.169-6.857-29.085-11.429Q796-469 780-472v-308H180v599h310q2.885 18.172 8.942 34.586Q505-130 513-114l-33 33-60-60-60 60-60-60-60 60-60-60-60 60Zm120-199h252.272q3.728-16 8.228-31t12.5-29H240v60Zm0-170h384q22-11 46-17.5t50-8.5v-34H240v60Zm-60 269v-599 599Z"
    }));



var $acw62 = parcelRequire("acw62");

var $2a03b7511a9251d3$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M144-40v-60h672v60H144Zm0-820v-60h672v60H144Zm336 416q50 0 84-34t34-84q0-50-34-84t-84-34q-50 0-84 34t-34 84q0 50 34 84t84 34ZM132-160q-24 0-42-18t-18-42v-520q0-26 18-43t42-17h696q24 0 42 18t18 42v520q0 24-18 42t-42 18H132Zm88-60q51-63 121-94.5T479.5-346q68.5 0 140 31.5T740-220h88v-520H132v520h88Zm94 0h334q-31-30-72.5-48T480-286q-54 0-94.5 18T314-220Zm166.158-284Q456-504 439.5-521T423-562q0-24 16.342-41t40.5-17Q504-620 520.5-603t16.5 41q0 24-16.342 41t-40.5 17ZM480-480Z"
    }), ' ');



var $acw62 = parcelRequire("acw62");

var $afc0b241ca2f37cd$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z"
    }));



var $acw62 = parcelRequire("acw62");

var $f803fcc7f8e57695$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M280-240q-17 0-28.5-11.5T240-280v-80h520v-360h80q17 0 28.5 11.5T880-680v600L720-240H280ZM80-280v-560q0-17 11.5-28.5T120-880h520q17 0 28.5 11.5T680-840v360q0 17-11.5 28.5T640-440H240L80-280Zm520-240v-280H160v280h440Zm-440 0v-280 280Z"
    }));



var $acw62 = parcelRequire("acw62");

var $ca700cfb3c771a7e$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M280-280v-400h400v400H280Zm80-80h240v-240H360v240ZM200-200v80q-33 0-56.5-23.5T120-200h80Zm-80-80v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm80-160h-80q0-33 23.5-56.5T200-840v80Zm80 640v-80h80v80h-80Zm0-640v-80h80v80h-80Zm160 640v-80h80v80h-80Zm0-640v-80h80v80h-80Zm160 640v-80h80v80h-80Zm0-640v-80h80v80h-80Zm160 640v-80h80q0 33-23.5 56.5T760-120Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80h80v80h-80Zm0-160v-80q33 0 56.5 23.5T840-760h-80Z"
    }));



var $acw62 = parcelRequire("acw62");

var $6b0c188d2194bdde$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "m507-144-51-51 129.053-129.053L456-453.106 506.894-504l129.053 129.053L765-504l51 51-129.053 129.053L816-194.894 765.106-144 636.053-273.053 507-144Zm-213 0v-72h72v72h-72Zm-78-600h-72q0-29.7 21.15-50.85Q186.3-816 216-816v72Zm78 0v-72h72v72h-72Zm150 0v-72h72v72h-72Zm150 0v-72h72v72h-72Zm150 0v-72q29.7 0 50.85 21.15Q816-773.7 816-744h-72ZM216-216v72q-29.7 0-50.85-21.15Q144-186.3 144-216h72Zm-72-78v-72h72v72h-72Zm0-150v-72h72v72h-72Zm0-150v-72h72v72h-72Zm600 0v-72h72v72h-72Z"
    }));



var $acw62 = parcelRequire("acw62");

var $c16ad02806d4cd0d$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "m672-336-51-51 57-57H432v-72h246l-57-57 51-51 144 144-144 144ZM216-216h78v-528h-78v528Zm-72 72v-672h222v672H144Zm300 0v-72h72v72h-72Zm0-600v-72h72v72h-72Zm150 600v-72h72v72h-72Zm0-600v-72h72v72h-72Zm150 600v-72h72v72h-72Zm0-600v-72h72v72h-72ZM216-216h78-78Z"
    }));



var $acw62 = parcelRequire("acw62");

var $45b85e7aa61dc06d$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"
    }));



var $acw62 = parcelRequire("acw62");

var $8e82c8526a54cadc$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M480-80 240-320l57-57 183 183 183-183 57 57L480-80ZM298-584l-58-56 240-240 240 240-58 56-182-182-182 182Z"
    }));



var $acw62 = parcelRequire("acw62");

var $c50e693d91e8d6ff$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "m296-80-56-56 240-240 240 240-56 56-184-184L296-80Zm184-504L240-824l56-56 184 184 184-184 56 56-240 240Z"
    }));



var $acw62 = parcelRequire("acw62");

var $59d168720c8d70ad$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props,
        viewBox: "0 -960 960 960"
    }, $acw62.createElement("path", {
        d: "M280-120 80-320l200-200 57 56-104 104h607v80H233l104 104-57 56Zm400-320-57-56 104-104H120v-80h607L623-784l57-56 200 200-200 200Z"
    }));



var $acw62 = parcelRequire("acw62");

var $d2a9b6cc89f4f0c4$export$2e2bcd8739ae039 = (props)=>$acw62.createElement((0, $f23ad61ef39bcee3$export$2e2bcd8739ae039), {
        ...props
    }, $acw62.createElement("path", {
        d: "M4,2H18A2,2 0 0,1 20,4V8.17L16.17,12H12V16.17L10.17,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M4,6V10H10V6H4M12,6V10H18V6H12M4,12V16H10V12H4Z"
    }), $acw62.createElement("path", {
        transform: "scale(0.5) translate(24, 24)",
        d: "M6 21q-1.125 0-2.225-.55T2 19q.65 0 1.325-.512Q4 17.975 4 17q0-1.25.875-2.125T7 14q1.25 0 2.125.875T10 17q0 1.65-1.175 2.825Q7.65 21 6 21Zm0-2q.825 0 1.412-.587Q8 17.825 8 17q0-.425-.287-.712Q7.425 16 7 16t-.713.288Q6 16.575 6 17q0 .575-.137 1.05-.138.475-.363.9.125.05.25.05H6Zm5.75-4L9 12.25l8.95-8.95q.275-.275.688-.288.412-.012.712.288l1.35 1.35q.3.3.3.7 0 .4-.3.7ZM7 17Z"
    }));



var $acw62 = parcelRequire("acw62");


const $9200d8ae4e589d35$export$f508444e7933c2b1 = (props)=>{
    const { icon: icon, iconClassName: iconClassName } = props;
    if (!icon) return null;
    const className = !$9200d8ae4e589d35$export$369455ce906a0ef2(icon) ? (0, $c72009da7485afc2$export$2e2bcd8739ae039)(icon.className, iconClassName) : iconClassName;
    const divRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        let htmlElement;
        if ($9200d8ae4e589d35$export$369455ce906a0ef2(icon)) {
            if (typeof icon.element === 'string') {
                const domParser = new DOMParser();
                htmlElement = domParser.parseFromString(icon.element, 'text/html').body.firstChild;
            } else {
                htmlElement = icon.element;
                // THe element neets to be cloned.
                // when it is used in more than one plce the element is removed from the DOM
                htmlElement = htmlElement.cloneNode(true);
            }
            divRef.current.insertAdjacentElement('afterend', htmlElement);
        }
        return ()=>{
            if ($9200d8ae4e589d35$export$369455ce906a0ef2(icon)) htmlElement?.remove();
        };
    }, [
        icon
    ]);
    if ($9200d8ae4e589d35$export$dff472f8017c5d8b(icon) && icon.name in (0, $124c9aa27215a392$export$6aa6ecf6e8a98784)) return $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        "aria-hidden": "true",
        name: icon.name,
        size: icon.size,
        style: icon.style,
        className: className
    });
    if ($9200d8ae4e589d35$export$276cfd3daee350b9(icon)) {
        let width = icon.style?.width ?? 'var(--ab-cmp-icon__width)';
        let height = icon.style?.height ?? 'var(--ab-cmp-icon__height)';
        const iconStyle = icon.style ?? {};
        return $acw62.createElement("img", {
            src: icon.src,
            className: className,
            style: {
                height: height,
                width: width,
                ...iconStyle
            }
        });
    }
    if ($9200d8ae4e589d35$export$369455ce906a0ef2(icon)) return $acw62.createElement("span", {
        ref: divRef,
        style: {
            display: 'none'
        },
        "data-name": "adaptable-icon-placeholder"
    });
    return null;
};
const $9200d8ae4e589d35$export$dff472f8017c5d8b = (icon)=>{
    return typeof icon?.name === 'string';
};
const $9200d8ae4e589d35$export$276cfd3daee350b9 = (icon)=>{
    return typeof icon?.src === 'string';
};
const $9200d8ae4e589d35$export$369455ce906a0ef2 = (icon)=>{
    return typeof HTMLElement === 'function' && icon?.element instanceof HTMLElement || typeof icon?.element === 'string';
};
const $9200d8ae4e589d35$export$1e5112454390929b = (icon)=>{
    return $9200d8ae4e589d35$export$dff472f8017c5d8b(icon) || $9200d8ae4e589d35$export$276cfd3daee350b9(icon) || $9200d8ae4e589d35$export$369455ce906a0ef2(icon);
};



const $124c9aa27215a392$export$6aa6ecf6e8a98784 = {
    search: (0, $fc2bac91f1e01fd6$export$2e2bcd8739ae039),
    grid: (0, $edad434078b5000b$export$2e2bcd8739ae039),
    cells: (0, $ec2f1d2953eba046$export$2e2bcd8739ae039),
    columns: (0, $cc09c97c81449a44$export$2e2bcd8739ae039),
    copy: (0, $45b85e7aa61dc06d$export$2e2bcd8739ae039),
    'calculated-column': (0, $fa52066f23591b26$export$2e2bcd8739ae039),
    laptop: (0, $e338ac1aa4d8c6d9$export$2e2bcd8739ae039),
    alert: (0, $378710245fa31c26$export$2e2bcd8739ae039),
    building: (0, $d37a7c971ea0d5a7$export$2e2bcd8739ae039),
    'edit-table': (0, $ba73129c41aa73c5$export$2e2bcd8739ae039),
    chart: (0, $76c10d88fcbefd87$export$2e2bcd8739ae039),
    'column-add': (0, $1ca50c8469527acb$export$2e2bcd8739ae039),
    person: (0, $12a30d4bb1271575$export$2e2bcd8739ae039),
    quote: (0, $8c6e2a8512adc2e4$export$2e2bcd8739ae039),
    call: (0, $fb8ef4543ae1e6ce$export$2e2bcd8739ae039),
    news: (0, $9fff6799e8cd9ae4$export$2e2bcd8739ae039),
    brush: (0, $ef02b6922df81992$export$2e2bcd8739ae039),
    'data-set': (0, $981d92db13bb4893$export$2e2bcd8739ae039),
    excel: (0, $257760179399e0ea$export$2e2bcd8739ae039),
    json: (0, $f8d9ded1f872fe1e$export$2e2bcd8739ae039),
    export: (0, $9b7bc1c7996b4ee4$export$2e2bcd8739ae039),
    broadcast: (0, $dfdbb65600ffa9bf$export$2e2bcd8739ae039),
    theme: (0, $7ed66726208c6963$export$2e2bcd8739ae039),
    brain: (0, $9d508a99779f26a8$export$2e2bcd8739ae039),
    calendar: (0, $28483e7bc21b1fc1$export$2e2bcd8739ae039),
    chat: (0, $9d680960d9c80086$export$2e2bcd8739ae039),
    'filter-list': (0, $68c9ea43e5e61dde$export$2e2bcd8739ae039),
    'column-outline': (0, $44ed8cd21b6ba7ef$export$2e2bcd8739ae039),
    'grid-filter': (0, $8141779d7ca21254$export$2e2bcd8739ae039),
    'grid-info': (0, $534c858af9da1e19$export$2e2bcd8739ae039),
    filter: (0, $2f0400f9032d0d21$export$2e2bcd8739ae039),
    'filter-off': (0, $4c0c6b13b7f5a605$export$2e2bcd8739ae039),
    'search-table': (0, $c6baaaaa224c29d0$export$2e2bcd8739ae039),
    lightning: (0, $fe0ba94ee3c1ba8a$export$2e2bcd8739ae039),
    'color-palette': (0, $8e9fe5aefba788f4$export$2e2bcd8739ae039),
    'export-data': (0, $81deb6752ec37474$export$2e2bcd8739ae039),
    'horizontal-lines': (0, $0f47472a0a60869c$export$2e2bcd8739ae039),
    'percent-tag': (0, $3d118f0fa4bbe146$export$2e2bcd8739ae039),
    'spark-line': (0, $719c37ece08f60c3$export$2e2bcd8739ae039),
    resume: (0, $21df90a3e941ef24$export$2e2bcd8739ae039),
    csv: (0, $a2c3655ce25d00c5$export$2e2bcd8739ae039),
    'pie-chart': (0, $ca45ea8d09f5d0b1$export$2e2bcd8739ae039),
    'add-circle': (0, $5bfa436c0bcf135c$export$2e2bcd8739ae039),
    reminder: (0, $a5d90be476625ff4$export$2e2bcd8739ae039),
    schedule: (0, $a3bb79cb65c35d20$export$2e2bcd8739ae039),
    link: (0, $5ca3aabd52f0e60b$export$2e2bcd8739ae039),
    assignment: (0, $a3b1b8effc2ab4e2$export$2e2bcd8739ae039),
    clipboard: (0, $1a79154f3233f096$export$2e2bcd8739ae039),
    'traffic-lights': (0, $b60b7fb8b61f5652$export$2e2bcd8739ae039),
    add: (0, $3f53a0a0ce07b81e$export$2e2bcd8739ae039),
    downloaded: (0, $6830419e99ce6556$export$2e2bcd8739ae039),
    // others
    edit: (0, $c6829e30776312ac$export$2e2bcd8739ae039),
    undo: (0, $7864da92970e6ab6$export$2e2bcd8739ae039),
    clone: (0, $90d54f085d552a2b$export$2e2bcd8739ae039),
    save: (0, $598c66af91e1d580$export$2e2bcd8739ae039),
    refresh: (0, $c910ade791439b50$export$2e2bcd8739ae039),
    delete: (0, $2b88e17dee640615$export$2e2bcd8739ae039),
    'tab-unselected': (0, $44cf1fce55850a1f$export$2e2bcd8739ae039),
    'select-all': (0, $ca700cfb3c771a7e$export$2e2bcd8739ae039),
    'select-off': (0, $6b0c188d2194bdde$export$2e2bcd8739ae039),
    'select-fwd': (0, $c16ad02806d4cd0d$export$2e2bcd8739ae039),
    checked: (0, $7a708e40088d471a$export$2e2bcd8739ae039),
    unchecked: (0, $3d475b057175fafa$export$2e2bcd8739ae039),
    'boolean-list': (0, $333cf5e8a19b6c34$export$2e2bcd8739ae039),
    'arrow-right': (0, $7a2b2b638d7ff370$export$2e2bcd8739ae039),
    'arrow-left': (0, $a3d717be74d2f204$export$2e2bcd8739ae039),
    'arrow-up': (0, $f1d7447992737013$export$2e2bcd8739ae039),
    'arrow-down': (0, $377b9b9d6324ef73$export$2e2bcd8739ae039),
    'arrow-up-long': (0, $53e810c8a3ef5b54$export$2e2bcd8739ae039),
    'arrow-down-long': (0, $4c163f4ed4dadf32$export$2e2bcd8739ae039),
    'triangle-up': (0, $d810c9e743ce619c$export$2e2bcd8739ae039),
    'triangle-down': (0, $d9cda10fc777df0e$export$2e2bcd8739ae039),
    'check-circle': (0, $c277b276430a0d7f$export$2e2bcd8739ae039),
    comment: $d6e0e4fc7cbd4848$export$2e2bcd8739ae039,
    list: (0, $63fbc0c475ebd422$export$2e2bcd8739ae039),
    spanner: (0, $234cb8536e80a6bb$export$2e2bcd8739ae039),
    error: (0, $ccac1c561e5bb44d$export$2e2bcd8739ae039),
    play: (0, $4c56b35e840a57c6$export$2e2bcd8739ae039),
    stop: (0, $d63931991552af20$export$2e2bcd8739ae039),
    pause: (0, $846b58a747e7b125$export$2e2bcd8739ae039),
    'fast-forward': (0, $3cec3f7a2bf3472f$export$2e2bcd8739ae039),
    'fast-backward': (0, $58a7638b2eab106c$export$2e2bcd8739ae039),
    warning: (0, $af8b77bc3714a1f7$export$2e2bcd8739ae039),
    check: (0, $b609955ddc27feb5$export$2e2bcd8739ae039),
    'open-in-new': (0, $b5c32813b0d2d729$export$2e2bcd8739ae039),
    home: (0, $a8fd8f9ecd8302a2$export$2e2bcd8739ae039),
    'sort-asc': (0, $49fccddc86aa6b2f$export$2e2bcd8739ae039),
    'sort-desc': (0, $70affbd03aa2c241$export$2e2bcd8739ae039),
    logout: (0, $30756f606e804c07$export$2e2bcd8739ae039),
    'import-export': (0, $cc903d575882a5d2$export$2e2bcd8739ae039),
    import: (0, $9519188063d211b5$export$2e2bcd8739ae039),
    inspector: (0, $8bb6fd8e38295fcb$export$2e2bcd8739ae039),
    paperclip: (0, $6670356033251d4c$export$2e2bcd8739ae039),
    info: (0, $064eb0f0e6bb973a$export$2e2bcd8739ae039),
    'cloud-upload': (0, $d7e37ed7684f50fe$export$2e2bcd8739ae039),
    upload: (0, $e56ee60dedcdd40c$export$2e2bcd8739ae039),
    download: (0, $6e8b87c43ddb366c$export$2e2bcd8739ae039),
    'folder-open': (0, $e0d8eb269f133840$export$2e2bcd8739ae039),
    'folder-shared': (0, $4c1e6ce3ded8ea79$export$2e2bcd8739ae039),
    folder: (0, $c5d7fb1e47248a04$export$2e2bcd8739ae039),
    newpage: (0, $a56874cf4f9df297$export$2e2bcd8739ae039),
    drag: (0, $38e0a22f99b8a5aa$export$2e2bcd8739ae039),
    'date-range': (0, $bb1cd949d428f763$export$2e2bcd8739ae039),
    settings: (0, $9aaddcb1acd1b9e3$export$2e2bcd8739ae039),
    dock: (0, $5370a27b42625517$export$2e2bcd8739ae039),
    collapse: (0, $23ebb56d3543230e$export$2e2bcd8739ae039),
    expand: (0, $7cc0d514e5df668c$export$2e2bcd8739ae039),
    'arrow-expand': (0, $4dfd1e7ed13282f4$export$2e2bcd8739ae039),
    history: (0, $311f931a0f9662e9$export$2e2bcd8739ae039),
    close: (0, $de99b8960bf95ff2$export$2e2bcd8739ae039),
    function: (0, $08bf4dd129469ba9$export$2e2bcd8739ae039),
    equation: (0, $f1ab39095a75520b$export$2e2bcd8739ae039),
    equals: (0, $e68dcb4d2c5fa8a2$export$2e2bcd8739ae039),
    'not-equal': (0, $806c358661385ccd$export$2e2bcd8739ae039),
    'greater-than-or-equal': (0, $da5a9c9ac97f3652$export$2e2bcd8739ae039),
    'greater-than': (0, $58cb18c3bbbbff2a$export$2e2bcd8739ae039),
    'less-than-or-equal': (0, $a21b9e4578e89ced$export$2e2bcd8739ae039),
    'less-than': (0, $86a0cf0b1345181d$export$2e2bcd8739ae039),
    plus: (0, $df2af6cf7b2aa402$export$2e2bcd8739ae039),
    minus: (0, $070c9e172ac5f93d$export$2e2bcd8739ae039),
    multiplication: (0, $221c7399d3901136$export$2e2bcd8739ae039),
    division: (0, $882d123a536fda91$export$2e2bcd8739ae039),
    percent: (0, $a875de95859c47cb$export$2e2bcd8739ae039),
    exponent: (0, $b4209a4929d257ff$export$2e2bcd8739ae039),
    'ends-with': (0, $48a8821e178d9536$export$2e2bcd8739ae039),
    'starts-with': (0, $be91be067019bff7$export$2e2bcd8739ae039),
    'unfilled-circle': (0, $987ca9b8e63086dc$export$2e2bcd8739ae039),
    'filled-circle': (0, $a329a2b7cb354a64$export$2e2bcd8739ae039),
    'not-contains': (0, $4b439bffa3aab518$export$2e2bcd8739ae039),
    contains: (0, $468990a47323e77d$export$2e2bcd8739ae039),
    regex: (0, $8b861ac9a9925f5d$export$2e2bcd8739ae039),
    target: (0, $ec697d444ace1f5b$export$2e2bcd8739ae039),
    menu: (0, $2d61e26ae080e693$export$2e2bcd8739ae039),
    statusbar: (0, $db2d8410769f149a$export$2e2bcd8739ae039),
    dashboard: (0, $7b41e1096b0ae452$export$2e2bcd8739ae039),
    'visibility-on': (0, $5b281d3e4cf5a51f$export$2e2bcd8739ae039),
    'visibility-off': (0, $8a09ffe4b0b3cdfd$export$2e2bcd8739ae039),
    'visibility-off-bold': (0, $33c565ac75895a4d$export$2e2bcd8739ae039),
    'visibility-on-bold': (0, $c5abaf0836f56e34$export$2e2bcd8739ae039),
    gradient: (0, $92408934b49bab72$export$2e2bcd8739ae039),
    badge: (0, $cca3478c2f02cd20$export$2e2bcd8739ae039),
    bold: (0, $a9088d9326032807$export$2e2bcd8739ae039),
    italic: (0, $b94e50129e73ecea$export$2e2bcd8739ae039),
    'align-left': (0, $a75723d5241007bf$export$2e2bcd8739ae039),
    'align-right': (0, $3377e23b3aaf241b$export$2e2bcd8739ae039),
    'align-center': (0, $9cbddd4e0bf196c0$export$2e2bcd8739ae039),
    'align-justify': (0, $d6c68ad00030f92d$export$2e2bcd8739ae039),
    underline: (0, $f75fd4bf485b899b$export$2e2bcd8739ae039),
    overline: (0, $dbbe9dff0b578652$export$2e2bcd8739ae039),
    strikethrough: (0, $7c1b04fc741fd717$export$2e2bcd8739ae039),
    'case-lower': (0, $020292bdd17f8746$export$2e2bcd8739ae039),
    'case-upper': (0, $04078a52cbddd68d$export$2e2bcd8739ae039),
    'case-sentence': (0, $c302803b35f1e282$export$2e2bcd8739ae039),
    flag: (0, $788b064d936d6fc3$export$2e2bcd8739ae039),
    fdc3: (0, $711f35f47d16e5ee$export$2e2bcd8739ae039),
    mail: (0, $bea798acd08d9395$export$2e2bcd8739ae039),
    dollar: (0, $d1b976370a1c8c66$export$2e2bcd8739ae039),
    organisation: (0, $906574715d8e943a$export$2e2bcd8739ae039),
    science: (0, $2afecf14f1aeb60d$export$2e2bcd8739ae039),
    interactions: (0, $0a8b73f4d6289b4b$export$2e2bcd8739ae039),
    money: (0, $c49ebc7da8467e29$export$2e2bcd8739ae039),
    order: (0, $78450b5f61366b29$export$2e2bcd8739ae039),
    contact: (0, $2a03b7511a9251d3$export$2e2bcd8739ae039),
    note: (0, $afc0b241ca2f37cd$export$2e2bcd8739ae039),
    comments: (0, $f803fcc7f8e57695$export$2e2bcd8739ae039),
    rows: (0, $8e76d2d1a91dddf6$export$2e2bcd8739ae039),
    'expand-all': (0, $8e82c8526a54cadc$export$2e2bcd8739ae039),
    'collapse-all': (0, $c50e693d91e8d6ff$export$2e2bcd8739ae039),
    sync: (0, $59d168720c8d70ad$export$2e2bcd8739ae039),
    'styled-grid': (0, $d2a9b6cc89f4f0c4$export$2e2bcd8739ae039)
};
Object.keys($124c9aa27215a392$export$6aa6ecf6e8a98784).forEach((name)=>{
    const ReactCmp = $124c9aa27215a392$export$6aa6ecf6e8a98784[name];
    $124c9aa27215a392$export$6aa6ecf6e8a98784[name] = (props)=>$acw62.createElement(ReactCmp, {
            ...props,
            name: name
        });
});
const $124c9aa27215a392$export$f04a61298a47a40f = ({ name: name, style: style, className: className, tabIndex: tabIndex, ...props })=>{
    const IconCmp = $124c9aa27215a392$export$6aa6ecf6e8a98784[name] || null;
    if (!IconCmp) {
        (0, $10f858c943b30cc8$export$a58502b374804b0f).consoleWarnBase('NO icon found for ' + name);
        return $acw62.createElement("svg", {
            height: "17",
            width: "17"
        });
    }
    return $acw62.createElement(IconCmp, {
        tabIndex: tabIndex,
        ...props,
        style: style,
        name: name,
        className: className
    });
};
const $124c9aa27215a392$export$9965b2ecc258c4a1 = (props)=>{
    return $acw62.createElement($124c9aa27215a392$export$f04a61298a47a40f, {
        ...props,
        size: '1.5em',
        style: {
            marginTop: '-0.125em',
            ...props.style
        }
    });
};
const $124c9aa27215a392$export$4ddaa9e47cfc2631 = (icon, style)=>{
    if (!icon) return;
    return $f46ed4009cb9c1cd$export$80e7718417253a51($acw62.createElement((0, $9200d8ae4e589d35$export$f508444e7933c2b1), {
        icon: {
            ...icon,
            style: {
                ...icon.style,
                ...style
            }
        }
    }));
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $1u0KT = parcelRequire("1u0KT");
const $3001385880d93cc1$var$BatchUpdate = (fn)=>{
    let fns = [];
    if (fn) fns.push(fn);
    const didCommit = false;
    const queue = (fn)=>{
        fns.push(fn);
    };
    queue.commit = (lastFn)=>{
        if (didCommit) return;
        if (lastFn) fns.push(lastFn);
        (0, $1u0KT.unstable_batchedUpdates)(()=>{
            fns.forEach((fn)=>fn());
            fns = undefined;
        });
    };
    return queue;
};
var $3001385880d93cc1$export$2e2bcd8739ae039 = $3001385880d93cc1$var$BatchUpdate;


'use strict';
var $2a7346d2e6abfd3f$var$proto = typeof Element === 'undefined' ? {} : Element.prototype;
var $2a7346d2e6abfd3f$var$nativeMatches = $2a7346d2e6abfd3f$var$proto.matches || $2a7346d2e6abfd3f$var$proto.mozMatchesSelector || $2a7346d2e6abfd3f$var$proto.msMatchesSelector || $2a7346d2e6abfd3f$var$proto.oMatchesSelector || $2a7346d2e6abfd3f$var$proto.webkitMatchesSelector;
var $2a7346d2e6abfd3f$export$2e2bcd8739ae039 = $2a7346d2e6abfd3f$var$nativeMatches;


var $4dec3fc2732b7def$export$2e2bcd8739ae039 = (selector, node)=>{
    if (!node) return null;
    while(node = node.parentElement){
        if ((0, $2a7346d2e6abfd3f$export$2e2bcd8739ae039).call(node, selector)) return node;
    }
    return null;
};



var $acw62 = parcelRequire("acw62");
const $c1d95a30df368692$var$toUpperFirst = (str)=>`${str.charAt(0).toUpperCase()}${str.substring(1)}`;
const $c1d95a30df368692$var$isControlled = (value)=>value !== undefined;
const $c1d95a30df368692$var$emptyFn = ()=>{};
/**
 *
 * useProperty can be used to easily manage a given prop - especially when you want to support both the controlled and the uncontrolled behviour.
 *
 * @param props - the props of the component
 * @param propName - the name of the property to manage
 * @param defaultValue? - a default value for the prop - especially useful when the prop you're targeting via `propName` is uncontrolled
 * @param config.onChange? - defaults to `props.on${PropName}Change` - useful when you want to be notified of when the property is changed - via the returned setter.
 * config.onChange is called for both controlled and uncontrolled prop.
 *
 * If the prop is uncontrolled, when the returned propSetter is called, the useProperty hook will update the state internally - you can be notified of this via config.onChange.
 *
 * If you don't have config.onChange specified, the useProperty hook will try to call `props.on${PropName}Change` if it's defined.
 *
 * So even for a controlled prop, if you respect this convention and have this pair `${propName}` + `on${PropName}Change` - useProperty will do all the work and call the "event" handler prop for you.
 *
 * Returns [propValue, propSetterFunction] - the value of the prop and a setter function
 */ const $c1d95a30df368692$var$useProperty = (props, propName, defaultValue, config)=>{
    const PropName = $c1d95a30df368692$var$toUpperFirst(propName);
    const defaultValueFromProps = props[`default${PropName}`];
    defaultValue = defaultValueFromProps === undefined ? defaultValue : defaultValueFromProps;
    const [stateValue, setStateProperty] = (0, $acw62.useState)(defaultValue);
    let value = props[propName];
    const controlled = $c1d95a30df368692$var$isControlled(value);
    const onChange = config && config.onChange ? config.onChange : props[`on${PropName}Change`] || $c1d95a30df368692$var$emptyFn;
    const setter = (value, ...args)=>{
        if (value instanceof Function) value = value(valueRef.current);
        if (!controlled) setStateProperty(value);
        onChange(value, ...args);
    };
    if (!controlled) value = stateValue;
    const valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return [
        value,
        setter
    ];
};
var $c1d95a30df368692$export$2e2bcd8739ae039 = $c1d95a30df368692$var$useProperty;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $013bfe010f8c54af$var$usePrevious = (value, initialValue)=>{
    const ref = (0, $acw62.useRef)(initialValue);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $013bfe010f8c54af$export$2e2bcd8739ae039 = $013bfe010f8c54af$var$usePrevious;


const $200eb22f36a82268$export$51fab111ee90cd8d = ()=>{
    const [x, update] = (0, $acw62.useState)(0);
    return ()=>{
        update(x + 1);
    };
};
const $200eb22f36a82268$var$Overlay = $acw62.forwardRef((props, ref)=>{
    const { visible: visible, ...domProps } = props;
    const domRef = (0, $acw62.useRef)(null);
    const setRef = (node)=>{
        domRef.current = node;
        if (ref && typeof ref === 'function') ref(node);
    };
    const [opacity, setOpacity] = (0, $acw62.useState)(0);
    const transitionInProgressRef = (0, $acw62.useRef)(false);
    const prevVisible = (0, $013bfe010f8c54af$export$2e2bcd8739ae039)(visible, visible);
    const prevOpacity = (0, $013bfe010f8c54af$export$2e2bcd8739ae039)(opacity, opacity);
    const refresh = $200eb22f36a82268$export$51fab111ee90cd8d();
    (0, $acw62.useEffect)(()=>{
        (0, $3001385880d93cc1$export$2e2bcd8739ae039)(()=>{
            transitionInProgressRef.current = true;
            setOpacity(props.visible ? 1 : 0);
        }).commit();
    }, [
        visible
    ]);
    if (prevVisible && !visible) transitionInProgressRef.current = true;
    const onTransitionEnd = ()=>{
        transitionInProgressRef.current = false;
        refresh();
        props?.onTransitionEnd?.();
    };
    const renderTime = Date.now();
    const renderTimeRef = (0, $acw62.useRef)(renderTime);
    renderTimeRef.current = renderTime;
    (0, $acw62.useEffect)(()=>{
        let timeoutId;
        if (prevOpacity && !opacity) timeoutId = setTimeout(()=>{
            if (renderTimeRef.current != renderTime) //we had other renders, so dont do anything - bail out
            return;
            if (!visible) onTransitionEnd();
        }, 1500);
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        opacity,
        prevOpacity,
        renderTime
    ]);
    const transitionInProgress = transitionInProgressRef.current;
    if (!visible && !transitionInProgress) return null;
    return $acw62.createElement("div", {
        ...domProps,
        ref: setRef,
        style: {
            ...props.style,
            opacity: opacity
        },
        onTransitionEnd: onTransitionEnd
    });
});
var $200eb22f36a82268$export$2e2bcd8739ae039 = $200eb22f36a82268$var$Overlay;




const $2c56c77c53b8e90d$export$4b834cebd9e5cebe = (node, offset = 0)=>{
    const rect = node.getBoundingClientRect();
    return {
        top: rect.top - offset,
        left: rect.left,
        bottom: rect.bottom + offset,
        right: rect.right,
        width: rect.width,
        height: rect.height + offset
    };
};
const $2c56c77c53b8e90d$export$37403b8a0c2fea03 = ()=>{
    const docRect = {
        width: window.innerWidth,
        right: window.innerWidth,
        height: window.innerHeight,
        bottom: window.innerHeight,
        left: 0,
        top: 0
    };
    return docRect;
};
const $2c56c77c53b8e90d$export$72209efa88586d42 = (rect1, rect2)=>{
    const left = Math.max(rect1.left, rect2.left);
    const top = Math.max(rect1.top, rect2.top);
    const right = Math.min(rect1.right, rect2.right);
    const bottom = Math.min(rect1.bottom, rect2.bottom);
    const width = right - left;
    const height = bottom - top;
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $4f57eeaf0bf16291$var$AdaptableContext = $acw62.createContext(null);
var $4f57eeaf0bf16291$export$2e2bcd8739ae039 = $4f57eeaf0bf16291$var$AdaptableContext;
const $4f57eeaf0bf16291$export$4f8242d5bf1189fc = ()=>{
    const context = $acw62.useContext($4f57eeaf0bf16291$var$AdaptableContext);
    return context;
};


const $64f91904e9865f68$var$useAgGridClassName = (deps = [])=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    return (0, $acw62.useMemo)(()=>{
        if (adaptable) return adaptable.agGridThemeAdapter.getAgGridCurrentThemeClassNames();
        return '';
    }, deps);
};
var $64f91904e9865f68$export$2e2bcd8739ae039 = $64f91904e9865f68$var$useAgGridClassName;


const $a651380741b279ec$var$DOCUMENT_POSITION_CONTAINED_BY = 16;
function $a651380741b279ec$export$2e2bcd8739ae039(container, elem) {
    if (container === elem) return true;
    if (container.contains) return container.contains(elem);
    let comparison = container.compareDocumentPosition(elem);
    return comparison === 0 || comparison & $a651380741b279ec$var$DOCUMENT_POSITION_CONTAINED_BY;
}



var $5aWMQ = parcelRequire("5aWMQ");

var $4b1b642de375664e$export$2e2bcd8739ae039 = {
    NEXT_PUBLIC_INFINITE_TABLE_LICENSE_KEY: "StartDate=2021-06-29|EndDate=2030-01-01|Owner=Adaptable|Type=distribution|TS=1624971462479|C=137829811,1004007071,2756196225,1839832928,3994409405,636616862",
    PUBLISH_TIMESTAMP: 1773422081358,
    VERSION: "22.0.3"
};


const $5729c20ddc89490c$export$175d6ab8087f9060 = (0, $4b1b642de375664e$export$2e2bcd8739ae039).VERSION;
const $5729c20ddc89490c$export$b2e35ef07067ff16 = (0, $4b1b642de375664e$export$2e2bcd8739ae039).PUBLISH_TIMESTAMP;
const $5729c20ddc89490c$export$b92c624345f52ee5 = (0, $4b1b642de375664e$export$2e2bcd8739ae039).NEXT_PUBLIC_INFINITE_TABLE_LICENSE_KEY;



var $acw62 = parcelRequire("acw62");
function $81462d2b980242cc$export$ce138889c9c682e8(props) {
    return $acw62.createElement((0, $88ab1a78ec8ca4b4$export$6f97e3045480ac8c), {
        sortable: false,
        rowHeight: '--ab-grid-row-height',
        draggableColumns: false,
        keyboardNavigation: false,
        ...props,
        licenseKey: (0, $5729c20ddc89490c$export$b92c624345f52ee5)
    });
}
(0, $88ab1a78ec8ca4b4$export$6f97e3045480ac8c).licenseKey = (0, $5729c20ddc89490c$export$b92c624345f52ee5);



const $3cab1dbb36a6d771$export$57fa910eee730f3b = 9999999;


const $c9ce1fb924ab724e$var$DATA_NAME_OVERLAY_TRIGGER = 'OverlayTrigger';
const $c9ce1fb924ab724e$export$425b752698dfb21d = (target, constrainTo)=>{
    let el = null;
    if (typeof constrainTo === 'string') el = (0, $4dec3fc2732b7def$export$2e2bcd8739ae039)(constrainTo, target);
    if (typeof constrainTo === 'function') el = constrainTo(target);
    return el;
};
const $c9ce1fb924ab724e$export$a0155fc0e7646aa4 = (target, constrainTo)=>{
    let el = $c9ce1fb924ab724e$export$425b752698dfb21d(target, constrainTo);
    if (el && el.tagName) return (0, $2c56c77c53b8e90d$export$4b834cebd9e5cebe)(el);
    return (0, $2c56c77c53b8e90d$export$37403b8a0c2fea03)();
};
let $c9ce1fb924ab724e$var$portalElement;
const $c9ce1fb924ab724e$var$OVERLAY_TRIGGER_Z_INDEX = (0, $3cab1dbb36a6d771$export$57fa910eee730f3b);
const $c9ce1fb924ab724e$export$8fdff8edfcdcc4a8 = ()=>{
    if (!(0, $5aWMQ.isBrowserDocumentAvailable)()) return;
    if ($c9ce1fb924ab724e$var$portalElement) return $c9ce1fb924ab724e$var$portalElement;
    $c9ce1fb924ab724e$var$portalElement = document.createElement('div');
    $c9ce1fb924ab724e$var$portalElement.style.position = 'absolute';
    $c9ce1fb924ab724e$var$portalElement.style.zIndex = $c9ce1fb924ab724e$var$OVERLAY_TRIGGER_Z_INDEX.toString();
    $c9ce1fb924ab724e$var$portalElement.style.top = '0px';
    $c9ce1fb924ab724e$var$portalElement.style.left = '0px';
    $c9ce1fb924ab724e$var$portalElement.dataset.name = 'OverlayTriggerPortal';
    document.body.appendChild($c9ce1fb924ab724e$var$portalElement);
    return $c9ce1fb924ab724e$var$portalElement;
};
const $c9ce1fb924ab724e$var$defaultProps = {
    showEvent: 'mouseenter',
    hideEvent: 'mouseleave',
    anchor: 'vertical',
    targetOffset: 10,
    opacityTransitionDuration: '250ms'
};
const $c9ce1fb924ab724e$var$OverlayTrigger = $acw62.forwardRef((givenProps, ref)=>{
    const props = {
        ...$c9ce1fb924ab724e$var$defaultProps,
        ...givenProps
    };
    $c9ce1fb924ab724e$export$8fdff8edfcdcc4a8();
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    let { visible: _, showTriangle: showTriangle, showEvent: showEvent, hideEvent: hideEvent, render: render, targetOffset: targetOffset, preventPortalEventPropagation: preventPortalEventPropagation = false, anchor: anchor, hideDelay: hideDelay = 0, opacityTransitionDuration: opacityTransitionDuration, onVisibleChange: onVisibleChange, alignPosition: alignPosition = [
        // overlay - target
        [
            'TopLeft',
            'BottomLeft'
        ],
        [
            'TopRight',
            'BottomRight'
        ],
        [
            'TopCenter',
            'BottomCenter'
        ],
        [
            'BottomCenter',
            'TopCenter'
        ],
        [
            'TopRight',
            'BottomCenter'
        ],
        [
            'TopRight',
            'BottomLeft'
        ],
        [
            'TopRight',
            'BottomLeft'
        ],
        [
            'BottomLeft',
            'TopLeft'
        ],
        [
            'BottomRight',
            'TopRight'
        ],
        [
            'BottomRight',
            'TopCenter'
        ],
        [
            'BottomRight',
            'TopLeft'
        ],
        [
            'TopRight',
            'CenterLeft'
        ],
        [
            'TopRight',
            'TopLeft'
        ],
        [
            'TopLeft',
            'TopRight'
        ],
        [
            'CenterRight',
            'CenterLeft'
        ],
        [
            'CenterLeft',
            'CenterRight'
        ]
    ], constrainTo: constrainTo, target: targetProp, ...domProps } = props;
    const { showOverlay: showOverlay, clearAll: clearAllOverlays, hideOverlay: hideOverlay, portal: portal } = (0, $88ab1a78ec8ca4b4$export$ea8f71083e90600f)({
        portalContainer: $c9ce1fb924ab724e$var$portalElement
    });
    const domRef = (0, $acw62.useRef)(null);
    const targetRef = (0, $acw62.useRef)(null);
    const overlayRef = (0, $acw62.useRef)(null);
    const [visible, doSetVisible] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'visible', false);
    const hideTimeoutRef = (0, $acw62.useRef)(null);
    const setVisible = $acw62.useCallback(// visible state may quickly change from true -> false -> true
    // when moving the mouse cursor from the trigger to the overlay
    // for this case we debounce the visible change for a very small amount of time
    (0, $c34d1d35432b7498$export$2e2bcd8739ae039)((visible)=>{
        // if (!visible) {
        //   return;
        // }
        onVisibleChange?.(visible);
        if (!visible) {
            hideTimeoutRef.current = setTimeout(()=>{
                hideTimeoutRef.current = null;
                doSetVisible(false);
            }, hideDelay);
            return;
        }
        if (hideTimeoutRef.current) {
            clearTimeout(hideTimeoutRef.current);
            hideTimeoutRef.current = null;
        }
        doSetVisible(true);
    }, 50), []);
    const prevVisible = (0, $013bfe010f8c54af$export$2e2bcd8739ae039)(visible, false);
    const onShow = $acw62.useCallback((event)=>{
        const target = targetRef.current;
        if (event && preventPortalEventPropagation && !(0, $a651380741b279ec$export$2e2bcd8739ae039)(target, event.target)) // because of how React portals behave - see https://github.com/facebook/react/issues/11387
        // after the portal is rendered, even though an item is in a separate dom parent, if it's in the portal,
        // events from it are propagated to the components in the portal and thus break some stuff
        return;
        (0, $3001385880d93cc1$export$2e2bcd8739ae039)(()=>{
            setVisible(true);
        }).commit();
    }, [
        constrainTo,
        preventPortalEventPropagation
    ]);
    const onHide = $acw62.useCallback((_event)=>{
        const shouldHide = props.shouldHide ? props.shouldHide(_event) : true;
        if (shouldHide) setVisible(false);
    }, [
        setVisible
    ]);
    (0, $acw62.useEffect)(()=>{
        if (ref) {
            const api = {
                show: onShow,
                hide: onHide
            };
            if (typeof ref === 'function') ref(api);
            else ref.current = api;
        }
    }, [
        ref
    ]);
    (0, $acw62.useEffect)(()=>{
        let target = domRef.current.previousSibling;
        while(target && target.dataset.name === $c9ce1fb924ab724e$var$DATA_NAME_OVERLAY_TRIGGER)target = target.previousSibling;
        if (targetProp) target = targetProp(target);
        if (!target) {
            adaptable.logger.warn('OverlayTrigger target not found. Ensure a child element is rendered inside the OverlayTrigger component.');
            return;
        }
        targetRef.current = target;
        let attached = false;
        let onShowFn = onShow;
        let onHideFn = onHide;
        if (props.visible === undefined) {
            attached = true;
            target.addEventListener(showEvent, onShowFn);
            target.addEventListener(hideEvent, onHideFn);
        }
        if (props.visible && !prevVisible) onShowFn();
        return ()=>{
            if (attached) {
                target.removeEventListener(showEvent, onShowFn);
                target.removeEventListener(hideEvent, onHideFn);
            }
        };
    }, [
        props.visible,
        showEvent,
        hideEvent,
        onShow,
        onHide
    ]);
    $acw62.useEffect(()=>{
        const target = targetRef.current;
        if (!target) return;
        const targetWidth = target.getBoundingClientRect().width;
        if (prevVisible && !visible || visible) {
            const overlayContent = $acw62.createElement((0, $200eb22f36a82268$export$2e2bcd8739ae039), {
                ...domProps,
                ref: (node)=>{
                    if (overlayRef.current && overlayRef.current != node) {
                        overlayRef.current.removeEventListener(showEvent, onShow);
                        overlayRef.current.removeEventListener(hideEvent, onHide);
                    }
                    overlayRef.current = node;
                    if (node) {
                        node.addEventListener(showEvent, onShow);
                        node.addEventListener(hideEvent, onHide);
                    }
                },
                className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)('ab-Overlay', showTriangle ? 'ab-Overlay--show-triangle' : '', agGridClassName, domProps.className),
                style: {
                    transition: `opacity ${opacityTransitionDuration}`
                },
                visible: visible,
                onTransitionEnd: ()=>{
                    if (!visible) {
                        clearAllOverlays();
                        hideOverlay('overlay-trigger');
                    }
                }
            }, props.render({
                targetWidth: targetWidth
            }));
            let preparedConstrainTo;
            if (constrainTo) preparedConstrainTo = $c9ce1fb924ab724e$export$425b752698dfb21d(targetRef.current, constrainTo);
            // show only if visible or if it was visible and now it is invisible
            const alignToRect = (0, $2c56c77c53b8e90d$export$4b834cebd9e5cebe)(target, targetOffset ?? 0);
            const showOverlayOptions = {
                id: 'overlay-trigger',
                alignPosition: alignPosition,
                constrainTo: preparedConstrainTo?.getBoundingClientRect?.() ?? true,
                alignTo: alignToRect
            };
            showOverlay(()=>overlayContent, showOverlayOptions);
        } else clearAllOverlays();
    }, [
        visible,
        props.render
    ]);
    const agGridClassName = (0, $64f91904e9865f68$export$2e2bcd8739ae039)([
        visible
    ]);
    return $acw62.createElement($acw62.Fragment, null, $acw62.Children.only(props.children), $acw62.createElement("div", {
        "data-name": $c9ce1fb924ab724e$var$DATA_NAME_OVERLAY_TRIGGER,
        "data-visible": visible,
        ref: domRef,
        style: {
            visibility: 'hidden',
            flex: 'none',
            width: 0,
            height: 0,
            pointerEvents: 'none',
            display: 'inline-flex'
        }
    }), portal);
});
var $c9ce1fb924ab724e$export$2e2bcd8739ae039 = $c9ce1fb924ab724e$var$OverlayTrigger;


const $0735c2b2ea9ec97d$var$Tooltip = ({ label: label, children: children })=>{
    return $acw62.createElement((0, $c9ce1fb924ab724e$export$2e2bcd8739ae039), {
        className: "ab-Tooltip",
        render: ()=>label
    }, children);
};
var $0735c2b2ea9ec97d$export$2e2bcd8739ae039 = $0735c2b2ea9ec97d$var$Tooltip;





const $c1f662de8a4d1882$export$39b0426676282ece = {
    focusOutline: // 'twa:outline-0 twa:focus:outline-2 twa:focus:outline-offset-1 twa:focus:outline-accent',
    'twa:outline-0 twa:focus:shadow-(--ab-focus__box-shadow)',
    focusWithinOutline: // 'twa:outline-0 twa:focus-within:outline-2 twa:focus-within:outline-offset-1 twa:focus-within:outline-accent',
    'twa:outline-0 twa:focus-within:shadow-(--ab-focus__box-shadow)'
};
const $c1f662de8a4d1882$export$ffffc4387efdabc8 = {
    focusWithinOutline: // 'twa:*:outline-0 twa:*:focus-within:outline-2 twa:*:focus-within:outline-offset-1 twa:*:focus-within:outline-accent',
    'twa:*:outline-0 twa:*:focus-within:shadow-(--ab-focus__box-shadow)'
};


const $306da9675b57419a$export$e0e193db4cb7689a = 'ab-SimpleButton';
const $306da9675b57419a$var$SimpleButton = $acw62.forwardRef((givenProps, theRef)=>{
    const props = {
        ...givenProps
    };
    let { children: children, disabled: disabled, variant: variant = 'outlined', tone: tone = 'neutral', iconPosition: iconPosition = 'start', iconSize: iconSize, className: className, icon: icon, tooltip: tooltip, accessLevel: accessLevel, type: type, ...buttonProps } = props;
    let adaptableSystemIcon;
    if ((0, $9200d8ae4e589d35$export$dff472f8017c5d8b)(icon)) adaptableSystemIcon = icon;
    if (typeof icon === 'string' && (0, $124c9aa27215a392$export$6aa6ecf6e8a98784)[icon]) adaptableSystemIcon = {
        name: icon
    };
    if (adaptableSystemIcon) {
        const iconProps = {
            icon: adaptableSystemIcon
        };
        if (iconSize) iconProps.icon = {
            ...iconProps.icon,
            size: iconSize
        };
        if (typeof buttonProps.color === 'string') iconProps.icon = {
            ...iconProps.icon,
            style: {
                color: buttonProps.color
            }
        };
        icon = $acw62.createElement((0, $9200d8ae4e589d35$export$f508444e7933c2b1), {
            ...iconProps
        });
    }
    if ((0, $9200d8ae4e589d35$export$276cfd3daee350b9)(icon) || (0, $9200d8ae4e589d35$export$369455ce906a0ef2)(icon)) icon = $acw62.createElement((0, $9200d8ae4e589d35$export$f508444e7933c2b1), {
        icon: icon
    });
    if (icon) children = iconPosition === 'start' ? $acw62.createElement($acw62.Fragment, null, icon, children) : $acw62.createElement($acw62.Fragment, null, children, icon);
    if (buttonProps.as == 'div') {
        // we have some cases when we want to nest a SimpleButton inside an html Button
        // so the SimpleButton cannot render a <button> tag
        // so we want it to be a DIV tag
        // but still keep the same keyboard accessibility
        buttonProps.tabIndex = buttonProps.tabIndex === undefined ? 0 : buttonProps.tabIndex;
        buttonProps.role = buttonProps.role || 'button';
        const onKeyDown = buttonProps.onKeyDown;
        buttonProps.onKeyDown = (e)=>{
            const key = e.key;
            if (buttonProps.onClick && key === 'Enter') buttonProps.onClick(e);
            if (onKeyDown) onKeyDown(e);
        };
    }
    if (!buttonProps.as || buttonProps.as === 'button') {
        buttonProps.type = type ? type : 'button';
        buttonProps.as = 'button';
    }
    if (accessLevel === 'Hidden') return null;
    if (accessLevel === 'ReadOnly') disabled = true;
    const ariaLabel = buttonProps['aria-label'] || buttonProps.label || tooltip || buttonProps.title || `${buttonProps.key}`;
    const extraButtonProps = {};
    if (ariaLabel != null && ariaLabel !== '') extraButtonProps['aria-label'] = ariaLabel;
    const btn = $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...buttonProps,
        ...extraButtonProps,
        as: buttonProps.as || 'button',
        disabled: disabled,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($306da9675b57419a$export$e0e193db4cb7689a, 'twa:p-1', 'twa:rounded-standard', 'twa:inline-flex twa:flex-row twa:flex-none twa:items-center', 'twa:fill-current', 'twa:overflow-hidden twa:relative twa:align-middle', // direct children should be above the before pseudo element
        'twa:*:z-1', // all svgs inside should be aligned middle
        'twa:[&_svg]:align-middle', // 'twa:text-text-on-primary',
        // the text variant has the background applied on the before pseudo element
        // so let's configure the before pseudo element for all buttons here
        'twa:before:content-[""] twa:before:absolute twa:before:inset-0 twa:before:block', 'twa:before:z-0 twa:before:pointer-events-none twa:before:rounded-[inherit]', // focus shadow
        (0, $c1f662de8a4d1882$export$39b0426676282ece).focusOutline, disabled ? `${$306da9675b57419a$export$e0e193db4cb7689a}--disabled` : '', `${$306da9675b57419a$export$e0e193db4cb7689a}--variant-${variant}`, `${$306da9675b57419a$export$e0e193db4cb7689a}--tone-${tone}`, 'twa:transition-opacity twa:duration-200', {
            'twa:text-text-on-primary': tone == 'neutral',
            'twa:text-inherit': tone === 'none',
            'twa:text-success': tone === 'success',
            'twa:text-accent': tone === 'accent',
            'twa:text-error': tone === 'error',
            'twa:text-warn': tone === 'warning',
            'twa:text-info': tone === 'info'
        }, variant === 'text' ? 'twa:bg-transparent' : '', variant === 'outlined' ? 'twa:bg-defaultbackground twa:border-inputborder twa:border' : '', variant === 'raised' ? {
            'twa:text-text-on-primary twa:shadow-(--ab-cmp-simple-button__box-shadow) twa:hover:not-disabled:shadow-(--ab-cmp-simple-button__hover-box-shadow) twa:transition-(--ab-cmp-simple-button__transition) twa:duration-200 twa:focus:shadow-(--ab-focus__box-shadow)': true,
            'twa:bg-success twa:text-text-on-success': tone == 'success',
            'twa:bg-accent twa:text-accent-foreground': tone == 'accent',
            'twa:bg-transparent': tone == 'none',
            'twa:bg-primary twa:text-text-on-primary': tone == 'neutral',
            'twa:bg-error twa:text-text-on-error': tone == 'error',
            'twa:bg-warn twa:text-text-on-warn': tone == 'warning',
            'twa:bg-info twa:text-text-on-info': tone == 'info'
        } : '', // opacity transitioning for the background applied on the before pseudo element
        variant === 'outlined' || variant === 'text' ? {
            'twa:before:opacity-0 twa:before:transition-opacity twa:before:duration-200': true,
            'twa:hover:before:opacity-15 twa:hover:before:bg-current': !disabled
        } : null, {
            'twa:cursor-pointer': !disabled,
            'twa:opacity-50': disabled
        }, className),
        ref: theRef
    }, children);
    return tooltip ? $acw62.createElement((0, $0735c2b2ea9ec97d$export$2e2bcd8739ae039), {
        label: tooltip
    }, btn) : btn;
});
var $306da9675b57419a$export$2e2bcd8739ae039 = $306da9675b57419a$var$SimpleButton;


const $00c4532606fa3d4c$export$5a2ee34a0d054ab8 = (props)=>{
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "info",
        iconSize: 20,
        icon: "info",
        variant: "raised",
        tone: "accent",
        ...props
    });
};




//We cannot destructure this.props using the react way in typescript which is a real pain as you
//need to transfer props individually as a consequence
//let { buttonContent, ...other } = this.props
class $283cf61293364231$var$PanelWithImageCmp extends $acw62.Component {
    render() {
        const IconCmp = (0, $124c9aa27215a392$export$6aa6ecf6e8a98784)[this.props.icon || this.props.glyphicon];
        const headerStyle = {};
        if (this.props.headerColor) {
            headerStyle.color = this.props.headerColor;
            headerStyle.fill = this.props.headerColor;
        }
        let headerRow = $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:flex-1"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:min-h-[15px]",
            alignItems: "center",
            style: headerStyle
        }, IconCmp ? $acw62.createElement(IconCmp, null) : null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mr-2"
        }), this.props.header ?? '', $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mr-2",
            "data-name": "space-after"
        }), this.props.infoLink != null && !this.props.infoLinkDisabled && $acw62.createElement((0, $00c4532606fa3d4c$export$5a2ee34a0d054ab8), {
            onClick: ()=>window.open(this.props.infoLink, '_blank' // <- opens the link in a new tab or window.
                )
        })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:flex-1"
        }), this.props.button && $acw62.cloneElement(this.props.button)));
        return $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
            header: headerRow,
            variant: this.props.variant,
            style: this.props.style,
            bodyScroll: this.props.bodyScroll !== undefined ? this.props.bodyScroll : true,
            className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:rounded-none twa:border-none', this.props.className),
            bodyProps: {
                ...this.props.bodyProps,
                className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:p-0', this.props.bodyProps?.className)
            }
        }, this.props.children);
    }
}
const $283cf61293364231$export$226a98817755c0cc = $283cf61293364231$var$PanelWithImageCmp;



var $5aWMQ = parcelRequire("5aWMQ");

var $acw62 = parcelRequire("acw62");

const $c129eab44be2d6af$var$selector = [
    'input:not([disabled])',
    'textarea:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([disabled])',
    'a[href]',
    'button:not([disabled])',
    'object'
].join(', ');
var $c129eab44be2d6af$export$2e2bcd8739ae039 = (node)=>{
    const children = [
        ...node.querySelectorAll($c129eab44be2d6af$var$selector)
    ];
    // ensure they are all in the dom
    return children.filter((child)=>child.offsetParent);
};


const $eacfa0f59b4520b2$var$emptyObject = {};
var $eacfa0f59b4520b2$export$2e2bcd8739ae039 = (node, event, config)=>{
    config = config || $eacfa0f59b4520b2$var$emptyObject;
    const { key: key, target: target, shiftKey: shiftKey } = event;
    if (key != 'Tab') return;
    const focusableChildren = (config.getFocusableChildren || (0, $c129eab44be2d6af$export$2e2bcd8739ae039))(node);
    const last = focusableChildren[focusableChildren.length - 1];
    const first = focusableChildren[0];
    if (target === first && first && shiftKey) {
        event.preventDefault();
        if (last && last.focus) last.focus();
        return true;
    }
    if (target === last && last && !shiftKey) {
        event.preventDefault();
        if (first && first.focus) first.focus();
        return true;
    }
};



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $acw62.createElement(Target, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowY');
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowX');
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
const $1a0fba1f59871db7$export$e0e193db4cb7689a = 'ab-Modal';
const $1a0fba1f59871db7$var$Backdrop = (props)=>{
    const { uuid: uuid, timestamp: timestamp } = props;
    const [backdropVisible, setBackdropVisible] = $acw62.useState(false);
    const [zIndex, setZIndex] = (0, $acw62.useState)(-1);
    (0, $acw62.useLayoutEffect)(()=>{
        $1a0fba1f59871db7$export$88abb2721c02246(uuid, {
            timestamp: timestamp,
            baseZIndex: props.zIndex,
            setBackdropOrder: (visible, zIndex)=>{
                (0, $1u0KT.unstable_batchedUpdates)(()=>{
                    setBackdropVisible(visible);
                    setZIndex(zIndex);
                    if (visible && props.onBringToFront) props.onBringToFront();
                });
            }
        });
        return ()=>$1a0fba1f59871db7$export$88abb2721c02246(uuid, null);
    }, []);
    return backdropVisible ? $acw62.createElement("div", {
        "data-id": uuid,
        style: {
            zIndex: zIndex
        },
        className: `${$1a0fba1f59871db7$export$e0e193db4cb7689a}-backdrop twa:fixed twa:inset-0 twa:z-900 twa:bg-(--ab-cmp-modal-backdrop__background)`
    }) : null;
};
const $1a0fba1f59871db7$var$stack = {};
const $1a0fba1f59871db7$export$88abb2721c02246 = (id, data)=>{
    $1a0fba1f59871db7$var$stack[id] = data;
    if (!data) delete $1a0fba1f59871db7$var$stack[id];
    const pairs = Object.keys($1a0fba1f59871db7$var$stack).map((key)=>{
        const data = $1a0fba1f59871db7$var$stack[key];
        return {
            key: key,
            ...data
        };
    });
    // sort pairs in ascending order
    pairs.sort((p1, p2)=>p1.timestamp - p2.timestamp);
    const last = pairs.pop();
    pairs.forEach((data)=>{
        data.setBackdropOrder(false, -1);
    });
    if (last) last.setBackdropOrder(true, last.baseZIndex);
};
var $1a0fba1f59871db7$export$2e2bcd8739ae039 = $1a0fba1f59871db7$var$Backdrop;



const $e48e47ebfd8103c5$export$10a020066a0f444a = ()=>(0, $3fa3ae484854b431$export$2e2bcd8739ae039)();



var $5aWMQ = parcelRequire("5aWMQ");

var $acw62 = parcelRequire("acw62");

const $075bd6677ee587ee$var$setZIndexMap = {};
const $075bd6677ee587ee$var$zIndexMap = [];
// starts with 3000, to be above the default zIndex of the Modal component
const $075bd6677ee587ee$var$BASE_Z_INDEX = 3000;
const $075bd6677ee587ee$var$Z_INDEX_GAP = 5;
let $075bd6677ee587ee$var$GLOBAL_COUNTER = 0;
const $075bd6677ee587ee$var$getNewOffset = ()=>{
    const counter = $075bd6677ee587ee$var$GLOBAL_COUNTER++;
    return counter * $075bd6677ee587ee$var$Z_INDEX_GAP;
};
const $075bd6677ee587ee$var$getNewZIndex = ()=>{
    return $075bd6677ee587ee$var$BASE_Z_INDEX + $075bd6677ee587ee$var$getNewOffset();
};
const $075bd6677ee587ee$export$346ea3986a1bec4e = ()=>{
    const modalZIndexId = $acw62.useMemo(()=>(0, $e48e47ebfd8103c5$export$10a020066a0f444a)(), []);
    const [zIndex, setZIndex] = $acw62.useState($075bd6677ee587ee$var$getNewZIndex);
    $acw62.useEffect(()=>{
        $075bd6677ee587ee$var$setZIndexMap[modalZIndexId] = setZIndex;
        return ()=>{
            // clean-up
            delete $075bd6677ee587ee$var$setZIndexMap[modalZIndexId];
            const indexInMap = $075bd6677ee587ee$var$zIndexMap.indexOf(modalZIndexId);
            $075bd6677ee587ee$var$zIndexMap.splice(indexInMap, 1);
        };
    }, [
        modalZIndexId
    ]);
    const bringInFront = $acw62.useCallback(()=>{
        if ($075bd6677ee587ee$var$zIndexMap.includes(modalZIndexId)) {
            const indexInMap = $075bd6677ee587ee$var$zIndexMap.indexOf(modalZIndexId);
            $075bd6677ee587ee$var$zIndexMap.splice(indexInMap, 1);
            $075bd6677ee587ee$var$zIndexMap.push(modalZIndexId);
        } else $075bd6677ee587ee$var$zIndexMap.push(modalZIndexId);
        $075bd6677ee587ee$var$zIndexMap.forEach((id)=>{
            $075bd6677ee587ee$var$setZIndexMap?.[id]?.($075bd6677ee587ee$var$getNewZIndex());
        });
    }, []);
    return {
        zIndex: zIndex,
        bringInFront: bringInFront
    };
};




let $addd0c5b92150265$var$portalElement;
let $addd0c5b92150265$var$loadingScreenPortalElement;
const $addd0c5b92150265$export$8fdff8edfcdcc4a8 = ()=>{
    if (!(0, $5aWMQ.isBrowserDocumentAvailable)()) return null;
    if ($addd0c5b92150265$var$portalElement) return $addd0c5b92150265$var$portalElement;
    $addd0c5b92150265$var$portalElement = document.createElement('div');
    document.body.appendChild($addd0c5b92150265$var$portalElement);
    return $addd0c5b92150265$var$portalElement;
};
const $addd0c5b92150265$export$1237d7d2d4232a6 = ()=>{
    if (!(0, $5aWMQ.isBrowserDocumentAvailable)()) return null;
    if ($addd0c5b92150265$var$loadingScreenPortalElement) return $addd0c5b92150265$var$loadingScreenPortalElement;
    $addd0c5b92150265$var$loadingScreenPortalElement = document.createElement('div');
    document.body.appendChild($addd0c5b92150265$var$loadingScreenPortalElement);
    return $addd0c5b92150265$var$loadingScreenPortalElement;
};
let $addd0c5b92150265$var$globalCounter = 0;
const $addd0c5b92150265$export$2b77a92f1a5ad772 = (props)=>{
    $addd0c5b92150265$export$8fdff8edfcdcc4a8();
    const { className: className, style: style, children: children, isOpen: isOpen, onBringToFront: onBringToFront, ...boxProps } = props;
    const uuid = (0, $acw62.useMemo)(()=>(0, $e48e47ebfd8103c5$export$10a020066a0f444a)(), []);
    const counter = (0, $acw62.useMemo)(()=>$addd0c5b92150265$var$globalCounter++, [
        isOpen
    ]);
    const openTimestamp = counter;
    const backdropZIndexOffset = 1;
    const stacking = (0, $075bd6677ee587ee$export$346ea3986a1bec4e)();
    const zIndex = stacking.zIndex;
    return (0, $1u0KT.createPortal)(isOpen ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $1a0fba1f59871db7$export$2e2bcd8739ae039), {
        timestamp: openTimestamp,
        uuid: uuid,
        zIndex: zIndex - backdropZIndexOffset,
        onBringToFront: onBringToFront
    }), $acw62.createElement((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        ...boxProps,
        style: {
            zIndex: zIndex,
            ...style
        },
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:fixed twa:inset-0 twa:z-1000 twa:font-(family-name:--ab__font-family)', (0, $1a0fba1f59871db7$export$e0e193db4cb7689a), className)
    }, children))) : null, $addd0c5b92150265$var$portalElement);
};



var $23f91ba6757703e7$export$2e2bcd8739ae039 = (props)=>{
    return (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'isOpen', true, {
        onChange: (isOpen)=>{
            if (!isOpen && props.onDismiss) props.onDismiss();
        }
    });
};



var $acw62 = parcelRequire("acw62");

const $29ac83f9193fceba$var$useAutoFocus = (props, focusElementRef)=>{
    const autoFocus = props.autoFocus === undefined ? true : props.autoFocus;
    const prevAutoFocus = (0, $013bfe010f8c54af$export$2e2bcd8739ae039)(props.previous ? props.previous({
        autoFocus: autoFocus
    }) : autoFocus, undefined);
    (0, $acw62.useEffect)(()=>{
        if (focusElementRef.current && focusElementRef.current.focus && autoFocus && (props.shouldFocus ? props.shouldFocus({
            autoFocus: autoFocus
        }) : true) && (prevAutoFocus === undefined || prevAutoFocus !== autoFocus)) focusElementRef.current.focus();
    }, [
        autoFocus,
        prevAutoFocus,
        props.isOpen
    ]);
};
var $29ac83f9193fceba$export$2e2bcd8739ae039 = $29ac83f9193fceba$var$useAutoFocus;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
var $3bbbc1a58466d5d4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3bbbc1a58466d5d4$var$__assign = undefined && undefined.__assign || function() {
    $3bbbc1a58466d5d4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3bbbc1a58466d5d4$var$__assign.apply(this, arguments);
};
var $3bbbc1a58466d5d4$var$rowSizeBase = {
    width: '100%',
    height: '10px',
    top: '0px',
    left: '0px',
    cursor: 'row-resize'
};
var $3bbbc1a58466d5d4$var$colSizeBase = {
    width: '10px',
    height: '100%',
    top: '0px',
    left: '0px',
    cursor: 'col-resize'
};
var $3bbbc1a58466d5d4$var$edgeBase = {
    width: '20px',
    height: '20px',
    position: 'absolute'
};
var $3bbbc1a58466d5d4$var$styles = {
    top: $3bbbc1a58466d5d4$var$__assign($3bbbc1a58466d5d4$var$__assign({}, $3bbbc1a58466d5d4$var$rowSizeBase), {
        top: '-5px'
    }),
    right: $3bbbc1a58466d5d4$var$__assign($3bbbc1a58466d5d4$var$__assign({}, $3bbbc1a58466d5d4$var$colSizeBase), {
        left: undefined,
        right: '-5px'
    }),
    bottom: $3bbbc1a58466d5d4$var$__assign($3bbbc1a58466d5d4$var$__assign({}, $3bbbc1a58466d5d4$var$rowSizeBase), {
        top: undefined,
        bottom: '-5px'
    }),
    left: $3bbbc1a58466d5d4$var$__assign($3bbbc1a58466d5d4$var$__assign({}, $3bbbc1a58466d5d4$var$colSizeBase), {
        left: '-5px'
    }),
    topRight: $3bbbc1a58466d5d4$var$__assign($3bbbc1a58466d5d4$var$__assign({}, $3bbbc1a58466d5d4$var$edgeBase), {
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    }),
    bottomRight: $3bbbc1a58466d5d4$var$__assign($3bbbc1a58466d5d4$var$__assign({}, $3bbbc1a58466d5d4$var$edgeBase), {
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    }),
    bottomLeft: $3bbbc1a58466d5d4$var$__assign($3bbbc1a58466d5d4$var$__assign({}, $3bbbc1a58466d5d4$var$edgeBase), {
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    }),
    topLeft: $3bbbc1a58466d5d4$var$__assign($3bbbc1a58466d5d4$var$__assign({}, $3bbbc1a58466d5d4$var$edgeBase), {
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    })
};
var $3bbbc1a58466d5d4$export$48a76196cafe3b93 = /** @class */ function(_super) {
    $3bbbc1a58466d5d4$var$__extends(Resizer, _super);
    function Resizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseDown = function(e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        _this.onTouchStart = function(e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        return _this;
    }
    Resizer.prototype.render = function() {
        return $acw62.createElement("div", {
            className: this.props.className || '',
            style: $3bbbc1a58466d5d4$var$__assign($3bbbc1a58466d5d4$var$__assign({
                position: 'absolute',
                userSelect: 'none'
            }, $3bbbc1a58466d5d4$var$styles[this.props.direction]), this.props.replaceStyles || {}),
            onMouseDown: this.onMouseDown,
            onTouchStart: this.onTouchStart
        }, this.props.children);
    };
    return Resizer;
}($acw62.PureComponent);


var $7b0f618bf8d2ec2e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7b0f618bf8d2ec2e$var$__assign = undefined && undefined.__assign || function() {
    $7b0f618bf8d2ec2e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7b0f618bf8d2ec2e$var$__assign.apply(this, arguments);
};
var $7b0f618bf8d2ec2e$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $7b0f618bf8d2ec2e$var$clamp = function(n, min, max) {
    return Math.max(Math.min(n, max), min);
};
var $7b0f618bf8d2ec2e$var$snap = function(n, size, gridGap) {
    var v = Math.round(n / size);
    return v * size + gridGap * (v - 1);
};
var $7b0f618bf8d2ec2e$var$hasDirection = function(dir, target) {
    return new RegExp(dir, 'i').test(target);
};
// INFO: In case of window is a Proxy and does not porxy Events correctly, use isTouchEvent & isMouseEvent to distinguish event type instead of `instanceof`.
var $7b0f618bf8d2ec2e$var$isTouchEvent = function(event) {
    return Boolean(event.touches && event.touches.length);
};
var $7b0f618bf8d2ec2e$var$isMouseEvent = function(event) {
    return Boolean((event.clientX || event.clientX === 0) && (event.clientY || event.clientY === 0));
};
var $7b0f618bf8d2ec2e$var$findClosestSnap = function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
};
var $7b0f618bf8d2ec2e$var$getStringSize = function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if (n.endsWith('px')) return n;
    if (n.endsWith('%')) return n;
    if (n.endsWith('vh')) return n;
    if (n.endsWith('vw')) return n;
    if (n.endsWith('vmax')) return n;
    if (n.endsWith('vmin')) return n;
    return n + "px";
};
var $7b0f618bf8d2ec2e$var$getPixelSize = function(size, parentSize, innerWidth, innerHeight) {
    if (size && typeof size === 'string') {
        if (size.endsWith('px')) return Number(size.replace('px', ''));
        if (size.endsWith('%')) {
            var ratio = Number(size.replace('%', '')) / 100;
            return parentSize * ratio;
        }
        if (size.endsWith('vw')) {
            var ratio = Number(size.replace('vw', '')) / 100;
            return innerWidth * ratio;
        }
        if (size.endsWith('vh')) {
            var ratio = Number(size.replace('vh', '')) / 100;
            return innerHeight * ratio;
        }
    }
    return size;
};
var $7b0f618bf8d2ec2e$var$calculateNewMax = function(parentSize, innerWidth, innerHeight, maxWidth, maxHeight, minWidth, minHeight) {
    maxWidth = $7b0f618bf8d2ec2e$var$getPixelSize(maxWidth, parentSize.width, innerWidth, innerHeight);
    maxHeight = $7b0f618bf8d2ec2e$var$getPixelSize(maxHeight, parentSize.height, innerWidth, innerHeight);
    minWidth = $7b0f618bf8d2ec2e$var$getPixelSize(minWidth, parentSize.width, innerWidth, innerHeight);
    minHeight = $7b0f618bf8d2ec2e$var$getPixelSize(minHeight, parentSize.height, innerWidth, innerHeight);
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
};
/**
 * transform T | [T, T] to [T, T]
 * @param val
 * @returns
 */ // tslint:disable-next-line
var $7b0f618bf8d2ec2e$var$normalizeToPair = function(val) {
    return Array.isArray(val) ? val : [
        val,
        val
    ];
};
var $7b0f618bf8d2ec2e$var$definedProps = [
    'as',
    'ref',
    'style',
    'className',
    'grid',
    'gridGap',
    'snap',
    'bounds',
    'boundsByDirection',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $7b0f618bf8d2ec2e$var$baseClassName = '__resizable_base__';
var $7b0f618bf8d2ec2e$export$e82068809229c83c = /** @class */ function(_super) {
    $7b0f618bf8d2ec2e$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _a, _b, _c, _d;
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableRight = 0;
        _this.resizableTop = 0;
        _this.resizableBottom = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.appendBase = function() {
            if (!_this.resizable || !_this.window) return null;
            var parent = _this.parentNode;
            if (!parent) return null;
            var element = _this.window.document.createElement('div');
            element.style.width = '100%';
            element.style.height = '100%';
            element.style.position = 'absolute';
            element.style.transform = 'scale(0, 0)';
            element.style.left = '0';
            element.style.flex = '0 0 100%';
            if (element.classList) element.classList.add($7b0f618bf8d2ec2e$var$baseClassName);
            else element.className += $7b0f618bf8d2ec2e$var$baseClassName;
            parent.appendChild(element);
            return element;
        };
        _this.removeBase = function(base) {
            var parent = _this.parentNode;
            if (!parent) return;
            parent.removeChild(base);
        };
        _this.state = {
            isResizing: false,
            width: (_b = (_a = _this.propsSize) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 'auto',
            height: (_d = (_c = _this.propsSize) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : 'auto',
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            },
            backgroundStyle: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: 'auto',
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            },
            flexBasis: undefined
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "window", {
        get: function() {
            if (!this.resizable) return null;
            if (!this.resizable.ownerDocument) return null;
            return this.resizable.ownerDocument.defaultView;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $7b0f618bf8d2ec2e$var$DEFAULT_SIZE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (this.resizable && this.window) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                var _a;
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && ((_a = _this.propsSize[key]) === null || _a === void 0 ? void 0 : _a.toString().endsWith('%'))) {
                    if (_this.state[key].toString().endsWith('%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $7b0f618bf8d2ec2e$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $7b0f618bf8d2ec2e$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $7b0f618bf8d2ec2e$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.parentNode) {
            if (!this.window) return {
                width: 0,
                height: 0
            };
            return {
                width: this.window.innerWidth,
                height: this.window.innerHeight
            };
        }
        var base = this.appendBase();
        if (!base) return {
            width: 0,
            height: 0
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        base.style.position = 'relative';
        base.style.minWidth = '100%';
        base.style.minHeight = '100%';
        var size = {
            width: base.offsetWidth,
            height: base.offsetHeight
        };
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.removeBase(base);
        return size;
    };
    Resizable.prototype.bindEvents = function() {
        if (this.window) {
            this.window.addEventListener('mouseup', this.onMouseUp);
            this.window.addEventListener('mousemove', this.onMouseMove);
            this.window.addEventListener('mouseleave', this.onMouseUp);
            this.window.addEventListener('touchmove', this.onMouseMove, {
                capture: true,
                passive: false
            });
            this.window.addEventListener('touchend', this.onMouseUp);
        }
    };
    Resizable.prototype.unbindEvents = function() {
        if (this.window) {
            this.window.removeEventListener('mouseup', this.onMouseUp);
            this.window.removeEventListener('mousemove', this.onMouseMove);
            this.window.removeEventListener('mouseleave', this.onMouseUp);
            this.window.removeEventListener('touchmove', this.onMouseMove, true);
            this.window.removeEventListener('touchend', this.onMouseUp);
        }
    };
    Resizable.prototype.componentDidMount = function() {
        if (!this.resizable || !this.window) return;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height,
            flexBasis: computedStyle.flexBasis !== 'auto' ? computedStyle.flexBasis : undefined
        });
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (this.window) this.unbindEvents();
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        var boundsByDirection = this.props.boundsByDirection;
        var direction = this.state.direction;
        var widthByDirection = boundsByDirection && $7b0f618bf8d2ec2e$var$hasDirection('left', direction);
        var heightByDirection = boundsByDirection && $7b0f618bf8d2ec2e$var$hasDirection('top', direction);
        var boundWidth;
        var boundHeight;
        if (this.props.bounds === 'parent') {
            var parent_1 = this.parentNode;
            if (parent_1) {
                boundWidth = widthByDirection ? this.resizableRight - this.parentLeft : parent_1.offsetWidth + (this.parentLeft - this.resizableLeft);
                boundHeight = heightByDirection ? this.resizableBottom - this.parentTop : parent_1.offsetHeight + (this.parentTop - this.resizableTop);
            }
        } else if (this.props.bounds === 'window') {
            if (this.window) {
                boundWidth = widthByDirection ? this.resizableRight : this.window.innerWidth - this.resizableLeft;
                boundHeight = heightByDirection ? this.resizableBottom : this.window.innerHeight - this.resizableTop;
            }
        } else if (this.props.bounds) {
            boundWidth = widthByDirection ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            boundHeight = heightByDirection ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
        }
        if (boundWidth && Number.isFinite(boundWidth)) maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
        if (boundHeight && Number.isFinite(boundHeight)) maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var _a = $7b0f618bf8d2ec2e$var$normalizeToPair(this.props.resizeRatio || 1), resizeRatioX = _a[0], resizeRatioY = _a[1];
        var _b = this.state, direction = _b.direction, original = _b.original;
        var _c = this.props, lockAspectRatio = _c.lockAspectRatio, lockAspectRatioExtraHeight = _c.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _c.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($7b0f618bf8d2ec2e$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatioX / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($7b0f618bf8d2ec2e$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatioX / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($7b0f618bf8d2ec2e$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatioY / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($7b0f618bf8d2ec2e$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatioY / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $7b0f618bf8d2ec2e$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $7b0f618bf8d2ec2e$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $7b0f618bf8d2ec2e$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $7b0f618bf8d2ec2e$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        var adjustedScale = 1 / (this.props.scale || 1);
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2) {
                var parentRect = parent_2.getBoundingClientRect();
                this.parentLeft = parentRect.left * adjustedScale;
                this.parentTop = parentRect.top * adjustedScale;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds && typeof this.props.bounds !== 'string') {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left * adjustedScale;
            this.targetTop = targetRect.top * adjustedScale;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top, right = _a.right, bottom = _a.bottom;
            this.resizableLeft = left * adjustedScale;
            this.resizableRight = right * adjustedScale;
            this.resizableTop = top_1 * adjustedScale;
            this.resizableBottom = bottom * adjustedScale;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        if (!this.resizable || !this.window) return;
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent && $7b0f618bf8d2ec2e$var$isMouseEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
        } else if (event.nativeEvent && $7b0f618bf8d2ec2e$var$isTouchEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var flexBasis;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        if (computedStyle.flexBasis !== 'auto') {
            var parent_3 = this.parentNode;
            if (parent_3) {
                var dir = this.window.getComputedStyle(parent_3).flexDirection;
                this.flexDir = dir.startsWith('row') ? 'row' : 'column';
                flexBasis = computedStyle.flexBasis;
            }
        }
        // For boundary
        this.setBoundingClientRect();
        this.bindEvents();
        var state = {
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            backgroundStyle: $7b0f618bf8d2ec2e$var$__assign($7b0f618bf8d2ec2e$var$__assign({}, this.state.backgroundStyle), {
                cursor: this.window.getComputedStyle(event.target).cursor || 'auto'
            }),
            direction: direction,
            flexBasis: flexBasis
        };
        this.setState(state);
    };
    Resizable.prototype.onMouseMove = function(event) {
        var _this = this;
        if (!this.state.isResizing || !this.resizable || !this.window) return;
        if (this.window.TouchEvent && $7b0f618bf8d2ec2e$var$isTouchEvent(event)) try {
            event.preventDefault();
            event.stopPropagation();
        } catch (e) {
        // Ignore on fail
        }
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = $7b0f618bf8d2ec2e$var$isTouchEvent(event) ? event.touches[0].clientX : event.clientX;
        var clientY = $7b0f618bf8d2ec2e$var$isTouchEvent(event) ? event.touches[0].clientY : event.clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $7b0f618bf8d2ec2e$var$calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        if (this.props.snap && this.props.snap.x) newWidth = $7b0f618bf8d2ec2e$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $7b0f618bf8d2ec2e$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $7b0f618bf8d2ec2e$var$snap(newWidth, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0);
            var newGridHeight = $7b0f618bf8d2ec2e$var$snap(newHeight, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0);
            var gap = this.props.snapGap || 0;
            var w = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            var h = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
            newWidth = w;
            newHeight = h;
        }
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if (width.endsWith('%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if (width.endsWith('vw')) {
                var vw = newWidth / this.window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if (width.endsWith('vh')) {
                var vh = newWidth / this.window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if (height.endsWith('%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if (height.endsWith('vw')) {
                var vw = newHeight / this.window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if (height.endsWith('vh')) {
                var vh = newHeight / this.window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        var newState = {
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        };
        if (this.flexDir === 'row') newState.flexBasis = newState.width;
        else if (this.flexDir === 'column') newState.flexBasis = newState.height;
        var widthChanged = this.state.width !== newState.width;
        var heightChanged = this.state.height !== newState.height;
        var flexBaseChanged = this.state.flexBasis !== newState.flexBasis;
        var changed = widthChanged || heightChanged || flexBaseChanged;
        if (changed) // For v18, update state sync
        (0, $1u0KT.flushSync)(function() {
            _this.setState(newState);
        });
        if (this.props.onResize) {
            if (changed) this.props.onResize(event, direction, this.resizable, delta);
        }
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a, _b;
        var _c = this.state, isResizing = _c.isResizing, direction = _c.direction, original = _c.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState({
            width: (_a = this.props.size.width) !== null && _a !== void 0 ? _a : 'auto',
            height: (_b = this.props.size.height) !== null && _b !== void 0 ? _b : 'auto'
        });
        this.unbindEvents();
        this.setState({
            isResizing: false,
            backgroundStyle: $7b0f618bf8d2ec2e$var$__assign($7b0f618bf8d2ec2e$var$__assign({}, this.state.backgroundStyle), {
                cursor: 'auto'
            })
        });
    };
    Resizable.prototype.updateSize = function(size) {
        var _a, _b;
        this.setState({
            width: (_a = size.width) !== null && _a !== void 0 ? _a : 'auto',
            height: (_b = size.height) !== null && _b !== void 0 ? _b : 'auto'
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $acw62.createElement((0, $3bbbc1a58466d5d4$export$48a76196cafe3b93), {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $acw62.createElement("div", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($7b0f618bf8d2ec2e$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        var style = $7b0f618bf8d2ec2e$var$__assign($7b0f618bf8d2ec2e$var$__assign($7b0f618bf8d2ec2e$var$__assign({
            position: 'relative',
            userSelect: this.state.isResizing ? 'none' : 'auto'
        }, this.props.style), this.sizeStyle), {
            maxWidth: this.props.maxWidth,
            maxHeight: this.props.maxHeight,
            minWidth: this.props.minWidth,
            minHeight: this.props.minHeight,
            boxSizing: 'border-box',
            flexShrink: 0
        });
        if (this.state.flexBasis) style.flexBasis = this.state.flexBasis;
        var Wrapper = this.props.as || 'div';
        return $acw62.createElement(Wrapper, $7b0f618bf8d2ec2e$var$__assign({
            style: style,
            className: this.props.className
        }, extendsProps, {
            // `ref` is after `extendsProps` to ensure this one wins over a version
            // passed in
            ref: function(c) {
                if (c) _this.resizable = c;
            }
        }), this.state.isResizing && $acw62.createElement("div", {
            style: this.state.backgroundStyle
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        as: 'div',
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        gridGap: [
            0,
            0
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($acw62.PureComponent);



var $acw62 = parcelRequire("acw62");
function $3aa7d52cc8af99a8$var$clamp(num, min, max) {
    return num <= min ? min : num >= max ? max : num;
}
function $3aa7d52cc8af99a8$export$2e2bcd8739ae039({ onMove: onMove, onDrop: onDrop, getBoundingRect: getBoundingRect = ()=>document.body.getBoundingClientRect(), handleSelector: handleSelector }) {
    const startRef = (0, $acw62.useRef)(null);
    const handleRef = (0, $acw62.useRef)(null);
    const targetRef = (0, $acw62.useRef)(null);
    const handleRefCallback = (0, $acw62.useCallback)((newNode)=>{
        const oldNode = handleRef.current;
        if (oldNode) oldNode.removeEventListener('mousedown', handleMouseDown);
        if (newNode) {
            newNode.addEventListener('mousedown', handleMouseDown);
            boundInitialPosition();
        }
        handleRef.current = newNode;
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (handleSelector) /**
             * Element may not be yet attached.
             * This gives time react to render the node handle.
             */ setTimeout(()=>{
            const node = targetRef?.current?.querySelector(handleSelector);
            node && handleRefCallback(node);
        }, 16);
    }, [
        handleSelector
    ]);
    const applyTransform = (dx, dy)=>{
        if (!targetRef.current) return;
        targetRef.current.style.transform = `translate3d(${dx}px, ${dy}px, 0)`;
    };
    const getTranslation = (event)=>{
        if (!startRef.current) return {
            dx: 0,
            dy: 0
        };
        const { pageX: pageX, pageY: pageY, bounds: bounds } = startRef.current;
        return {
            dx: $3aa7d52cc8af99a8$var$clamp(event.pageX - pageX, bounds.left, bounds.right),
            dy: $3aa7d52cc8af99a8$var$clamp(event.pageY - pageY, bounds.top, bounds.bottom)
        };
    };
    const getTranslationBounds = (targetRect, boundingRect)=>{
        const left = boundingRect.x - targetRect.x;
        const right = left + boundingRect.width - targetRect.width;
        const top = boundingRect.y - targetRect.y;
        const bottom = top + boundingRect.height - targetRect.height;
        return {
            left: left,
            right: right,
            top: top,
            bottom: bottom
        };
    };
    const handleMouseDown = (event)=>{
        if (!targetRef.current) return;
        event.preventDefault();
        document.addEventListener('mouseup', handleMouseUp);
        document.addEventListener('mousemove', handleMouseMove);
        const targetRect = targetRef.current.getBoundingClientRect();
        const boundingRect = getBoundingRect();
        startRef.current = {
            pageX: event.pageX,
            pageY: event.pageY,
            bounds: getTranslationBounds(targetRect, boundingRect)
        };
    };
    const handleMouseUp = (event)=>{
        event.preventDefault();
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('mousemove', handleMouseMove);
        const { dx: dx, dy: dy } = getTranslation(event);
        applyTransform(0, 0);
        onDrop && onDrop(dx, dy);
    };
    const handleMouseMove = (event)=>{
        event.preventDefault();
        const { dx: dx, dy: dy } = getTranslation(event);
        applyTransform(dx, dy);
        onMove && onMove(event);
    };
    const boundInitialPosition = ()=>{
        if (!targetRef.current) return;
        const targetRect = targetRef.current.getBoundingClientRect();
        const boundingRect = getBoundingRect();
        const bounds = getTranslationBounds(targetRect, boundingRect);
        const dx = $3aa7d52cc8af99a8$var$clamp(0, bounds.left, bounds.right);
        const dy = $3aa7d52cc8af99a8$var$clamp(0, bounds.top, bounds.bottom);
        if (onDrop && (dx !== 0 || dy !== 0)) onDrop(dx, dy);
    };
    return {
        handleRef: handleRefCallback,
        targetRef: targetRef,
        applyTransform: applyTransform
    };
}



var $5aWMQ = parcelRequire("5aWMQ");

var $1u0KT = parcelRequire("1u0KT");

let $26ded519eefc573c$var$portalElement;
const $26ded519eefc573c$var$ensurePortalElement = ()=>{
    if (!(0, $5aWMQ.isBrowserDocumentAvailable)()) return;
    if ($26ded519eefc573c$var$portalElement) return;
    $26ded519eefc573c$var$portalElement = document.createElement('div');
    $26ded519eefc573c$var$portalElement.classList.add('ab-cmp-modal-window');
    document.body.appendChild($26ded519eefc573c$var$portalElement);
};
const $26ded519eefc573c$var$normalizeTopLeft = (position)=>position < 0 ? 0 : position;
const $26ded519eefc573c$var$getResizePositionDelta = (direction, delta)=>{
    const positionDelta = {
        x: 0,
        y: 0
    };
    const left = -delta.width;
    const top = -delta.height;
    const directions = [
        'top',
        'left',
        'topLeft',
        'bottomLeft',
        'topRight'
    ];
    if (directions.indexOf(direction) !== -1) {
        if (direction === 'bottomLeft') positionDelta.x += left;
        else if (direction === 'topRight') positionDelta.y += top;
        else {
            positionDelta.x += left;
            positionDelta.y += top;
        }
        return positionDelta;
    }
    return null;
};
const $26ded519eefc573c$export$9ea07fa61131bea4 = (props)=>{
    $26ded519eefc573c$var$ensurePortalElement();
    const positionDeltaRef = $acw62.useRef(null);
    const normalizedPosition = {
        x: $26ded519eefc573c$var$normalizeTopLeft(props.position?.x),
        y: $26ded519eefc573c$var$normalizeTopLeft(props.position?.y)
    };
    const positionRef = $acw62.useRef(normalizedPosition);
    const stacking = (0, $075bd6677ee587ee$export$346ea3986a1bec4e)();
    /**
     * This is needed because the function called in onDrop is saved when
     * it gets attached to the DOM element event handler.
     * This handler changes only when the underlying node changes.
     */ positionRef.current = normalizedPosition;
    const style = {
        zIndex: stacking.zIndex,
        position: 'absolute',
        left: normalizedPosition.x,
        top: normalizedPosition.y
    };
    const handleDrop = (dx, dy)=>{
        const newPosition = {
            x: positionRef.current.x + dx,
            y: positionRef.current.y + dy
        };
        props.onChange({
            position: newPosition,
            size: props.size
        });
    };
    const { targetRef: targetRef, applyTransform: applyTransform } = (0, $3aa7d52cc8af99a8$export$2e2bcd8739ae039)({
        handleSelector: props.handleSelector,
        onDrop: handleDrop
    });
    const handleResizeStop = (event, direction, elementRef, delta)=>{
        let newPosition = normalizedPosition;
        if (positionDeltaRef.current) {
            newPosition = {
                x: normalizedPosition.x + positionDeltaRef.current.x,
                y: normalizedPosition.y + positionDeltaRef.current.y
            };
            positionDeltaRef.current = null;
            applyTransform(0, 0);
        }
        const newSize = {
            width: props.size.width + delta.width,
            height: props.size.height + delta.height
        };
        props.onChange({
            position: newPosition,
            size: newSize
        });
    };
    const handleResize = $acw62.useCallback((event, direction, elementRef, delta)=>{
        const positionDelta = $26ded519eefc573c$var$getResizePositionDelta(direction, delta);
        if (positionDelta) {
            positionDeltaRef.current = positionDelta;
            applyTransform(positionDelta.x, positionDelta.y);
        }
    }, []);
    const ResizableCmp = (0, $7b0f618bf8d2ec2e$export$e82068809229c83c);
    return (0, $1u0KT.createPortal)($acw62.createElement("div", {
        style: style,
        //@ts-ignore
        ref: targetRef,
        onMouseDown: stacking.bringInFront
    }, $acw62.createElement(ResizableCmp, {
        minWidth: props.minWidth,
        minHeight: props.minHeight,
        onResizeStop: handleResizeStop,
        onResize: handleResize,
        bounds: "window",
        defaultSize: {
            width: props.size.width,
            height: props.size.height
        }
    }, props.children)), $26ded519eefc573c$var$portalElement);
};







const $468c20c9461c2ca5$var$baseClassName = 'ab-Dialog';
const $468c20c9461c2ca5$export$3ddf2d174ce01153 = $acw62.forwardRef((props, dialogRef)=>{
    let { modal: modal, fixed: fixed, focusOnBrowserVisible: focusOnBrowserVisible = false, autoFocus: autoFocus = true, className: className, children: children, modalProps: modalProps, dismissOnClickOutside: dismissOnClickOutside = false, onDismiss: onDismiss, windowModal: windowModal, windowModalProps: windowModalProps, showCloseButton: showCloseButton = true, isOpen: _isOpenProp, ...boxProps } = props;
    modal = props.modal === undefined ? true : props.modal;
    fixed = props.fixed === undefined ? true : props.fixed;
    const [isOpen, setIsOpen] = (0, $23f91ba6757703e7$export$2e2bcd8739ae039)(props);
    const boxRef = (0, $acw62.useRef)(null);
    (0, $29ac83f9193fceba$export$2e2bcd8739ae039)({
        isOpen: isOpen,
        autoFocus: props.autoFocus,
        previous: ({ autoFocus: autoFocus })=>autoFocus && isOpen,
        shouldFocus: ({ autoFocus: autoFocus })=>autoFocus && isOpen
    }, boxRef);
    const onKeyDown = (e)=>{
        if (props.onKeyDown) props.onKeyDown(e);
        (0, $eacfa0f59b4520b2$export$2e2bcd8739ae039)(boxRef.current, e);
        if (e.key === 'Escape') {
            if (e.nativeEvent.anotherModalClosed) return;
            e.nativeEvent.anotherModalClosed = true;
            const activeElement = document.activeElement;
            const ignoreTags = {
                input: 1,
                a: 1,
                button: 1
            };
            if (activeElement && !!ignoreTags[activeElement.tagName]) return;
            setIsOpen(false);
        }
        (0, $eacfa0f59b4520b2$export$2e2bcd8739ae039)(boxRef.current, event);
    };
    (0, $acw62.useEffect)(()=>{
        if (dismissOnClickOutside && isOpen) {
            const dismissDialog = (e)=>{
                requestAnimationFrame(()=>{
                    if (e.preventDialogDismiss) return;
                    setIsOpen(false);
                });
            };
            document.documentElement.addEventListener('click', dismissDialog, {
                passive: true,
                capture: false
            });
            return ()=>{
                document.documentElement.removeEventListener('click', dismissDialog);
            };
        }
    }, [
        isOpen,
        dismissOnClickOutside
    ]);
    const bringToFront = $acw62.useCallback(()=>{
        if (boxRef.current && boxRef.current.focus && (!document.activeElement || !(0, $a651380741b279ec$export$2e2bcd8739ae039)(boxRef.current, document.activeElement))) boxRef.current.focus();
    }, [
        boxRef
    ]);
    $acw62.useImperativeHandle(dialogRef, ()=>({
            bringToFront: bringToFront
        }));
    (0, $acw62.useEffect)(()=>{
        let listener;
        if (focusOnBrowserVisible) {
            listener = ()=>{
                if (document.visibilityState === 'visible' && autoFocus && focusOnBrowserVisible) bringToFront();
            };
            document.addEventListener('visibilitychange', listener);
        }
        return ()=>{
            if (listener) document.removeEventListener('visibilitychange', listener);
        };
    }, [
        autoFocus,
        focusOnBrowserVisible
    ]);
    if (!isOpen) return null;
    const closeButton = showCloseButton ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        title: "Close dialog",
        onClick: ()=>setIsOpen(false),
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`${$468c20c9461c2ca5$var$baseClassName}__close-button twa:p-1`, 'twa:text-accentlight', 'twa:text-shadow-[0_1px_0_#fff]', `twa:text-3 twa:cursor-pointer twa:leading-none twa:font-bold`, 'twa:absolute twa:top-[6px] twa:right-[6px]')
    }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        size: 20,
        name: "close"
    })) : null;
    const setPreventDismissFlag = (e)=>{
        if (dismissOnClickOutside) e.nativeEvent.preventDialogDismiss = true;
    };
    const box = $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...boxProps,
        onClick: (e)=>{
            setPreventDismissFlag(e);
            if (boxProps && boxProps.onClick) boxProps.onClick(e);
        },
        onKeyDown: onKeyDown,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:relative', 'twa:bg-defaultbackground', 'twa:text-text-on-defaultbackground', 'twa:fill-text-on-defaultbackground', 'twa:rounded-standard', 'twa:flex twa:flex-col', (0, $c1f662de8a4d1882$export$39b0426676282ece).focusOutline, (0, $c1f662de8a4d1882$export$39b0426676282ece).focusWithinOutline, $468c20c9461c2ca5$var$baseClassName, modal ? `${$468c20c9461c2ca5$var$baseClassName}--modal` : `${$468c20c9461c2ca5$var$baseClassName}--not-modal`, className),
        ref: boxRef
    }, children, closeButton);
    const content = fixed ? $acw62.createElement("div", {
        onClick: setPreventDismissFlag,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`${$468c20c9461c2ca5$var$baseClassName}-fixed-wrapper`, 'twa:fixed twa:inset-0', 'twa:m-auto', 'twa:flex twa:items-center twa:justify-center')
    }, box) : box;
    if (windowModal) return $acw62.createElement((0, $26ded519eefc573c$export$9ea07fa61131bea4), {
        ...windowModalProps
    }, content);
    if (modal) return $acw62.createElement((0, $addd0c5b92150265$export$2b77a92f1a5ad772), {
        ...modalProps,
        isOpen: isOpen,
        onBringToFront: bringToFront
    }, box);
    return content;
});
var $468c20c9461c2ca5$export$2e2bcd8739ae039 = $468c20c9461c2ca5$export$3ddf2d174ce01153;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



const $6ab992db590f467f$var$FormLayoutContext = (0, $acw62.createContext)(null);
const $6ab992db590f467f$var$defaultColumns = {
    label: {
        className: 'ab-FormLayout_column--label',
        style: {
            textAlign: 'end'
        }
    }
};
const $6ab992db590f467f$var$PLACEHOLDER = $acw62.createElement("div", null);
const $6ab992db590f467f$var$FormLayout = (props)=>{
    let { placeholder: placeholder = $6ab992db590f467f$var$PLACEHOLDER, columns: columns = [
        'label',
        'children'
    ], defaultComponent: defaultComponent = (0, $82c87f52da9ba110$export$e71c4d32a2263218), sizes: sizes = [
        'auto',
        '1fr'
    ], gridColumnGap: gridColumnGap = 'calc(var(--ab-base-space) * 2)', gridRowGap: gridRowGap = 'calc(var(--ab-base-space) * 2)', style: style, childrenToColumns: childrenToColumns = true, ...boxProps } = props;
    columns = columns.map((c)=>{
        if (typeof c === 'string' || typeof c === 'number') c = {
            name: `${c}`
        };
        if ($6ab992db590f467f$var$defaultColumns[c.name]) c = (0, $88a6c58c74f77d1a$export$2e2bcd8739ae039)({}, $6ab992db590f467f$var$defaultColumns[c.name], c);
        c.component = c.component === undefined ? defaultComponent : c.component;
        return c;
    });
    const formStyle = {
        gridTemplateColumns: columns.map((column, i)=>{
            if (column.size) return `${column.size}`;
            if (sizes[i] !== undefined) return `${sizes[i]}`;
            return 'auto';
        }).join(' '),
        gridRowGap: gridRowGap,
        gridColumnGap: gridColumnGap,
        rowGap: gridRowGap,
        columnGap: gridColumnGap
    };
    return $acw62.createElement($6ab992db590f467f$var$FormLayoutContext.Provider, {
        value: {
            columns: columns,
            currentRow: 0,
            childrenToColumns: childrenToColumns
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...boxProps,
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(boxProps.className, 'ab-FormLayout'),
        style: {
            ...style,
            ...formStyle
        }
    }));
};
const $6ab992db590f467f$export$b534bc812df080fd = (props)=>{
    const ctx = (0, $acw62.useContext)($6ab992db590f467f$var$FormLayoutContext);
    const { columns: columns, placeholder: placeholder, childrenToColumns: childrenToColumns } = ctx;
    const rowIndex = ctx.currentRow;
    ctx.currentRow++;
    const children = $acw62.Children.toArray(props.children);
    const columnValues = columns.map((column, columnIndex)=>{
        const columnName = column.name;
        let item = props[columnName];
        if (item === undefined && childrenToColumns) item = children.shift();
        let value = item;
        if (item == null) value = placeholder;
        if (props.as != null || column.component != null) {
            const Cmp = column.component;
            value = $acw62.createElement(Cmp, {
                "data-name": props.dataName,
                style: {
                    ...column.style,
                    gridColumn: columnIndex + 1,
                    gridRow: rowIndex + 1
                },
                className: column.className
            }, value);
        }
        return typeof value === 'string' ? value : $acw62.cloneElement(value, {
            key: columnName
        });
    });
    return $acw62.createElement($acw62.Fragment, null, columnValues);
};
var $6ab992db590f467f$export$2e2bcd8739ae039 = $6ab992db590f467f$var$FormLayout;



var $acw62 = parcelRequire("acw62");


const $9e4562887d5c909d$export$e0e193db4cb7689a = 'ab-Input';
const $9e4562887d5c909d$var$Input = $acw62.forwardRef((props, ref)=>{
    const { disabled: disabled, className: className, ...inputProps } = props;
    let type = 'text';
    if (inputProps && inputProps.type) type = inputProps.type;
    if (type === 'string') type = 'text';
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        as: "input",
        ref: ref,
        ...inputProps,
        type: type,
        disabled: disabled,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, $9e4562887d5c909d$export$e0e193db4cb7689a, 'twa:min-h-input', type ? `${$9e4562887d5c909d$export$e0e193db4cb7689a}--type-${type}` : '', disabled ? `${$9e4562887d5c909d$export$e0e193db4cb7689a}--disabled` : '', {
            'twa:bg-(--ab-cmp-input__background)': !disabled,
            'twa:bg-(--ab-cmp-input--disabled__background)': disabled
        })
    });
});
var $9e4562887d5c909d$export$2e2bcd8739ae039 = $9e4562887d5c909d$var$Input;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $952730cad4910d4d$var$FieldWrap = (props)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        alignItems: "center",
        ...props,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-FieldWrap', props.className)
    });
};
var $952730cad4910d4d$export$2e2bcd8739ae039 = $952730cad4910d4d$var$FieldWrap;





var $acw62 = parcelRequire("acw62");
const $4ac5c79eccb33a7d$export$c06d5b9df04932bc = $acw62.createContext({
    onShow: ()=>{},
    onHide: ()=>{}
});
const $4ac5c79eccb33a7d$export$84c5c808acc282aa = ()=>{
    return $acw62.useContext($4ac5c79eccb33a7d$export$c06d5b9df04932bc);
};



var $acw62 = parcelRequire("acw62");
/**
 * The UI elements composing DayPicker. These elements are mapped to
 * {@link CustomComponents}, the {@link ClassNames} and the {@link Styles} used by
 * DayPicker.
 *
 * Some of these elements are extended by flags and modifiers.
 */ var $17d6b6ed20fdf376$export$4b08aed5f1ec6952;
(function(UI) {
    /** The root component displaying the months and the navigation bar. */ UI["Root"] = "root";
    /** The Chevron SVG element used by navigation buttons and dropdowns. */ UI["Chevron"] = "chevron";
    /**
     * The grid cell with the day's date. Extended by {@link DayFlag} and
     * {@link SelectionFlag}.
     */ UI["Day"] = "day";
    /** The button containing the formatted day's date, inside the grid cell. */ UI["DayButton"] = "day_button";
    /** The caption label of the month (when not showing the dropdown navigation). */ UI["CaptionLabel"] = "caption_label";
    /** The container of the dropdown navigation (when enabled). */ UI["Dropdowns"] = "dropdowns";
    /** The dropdown element to select for years and months. */ UI["Dropdown"] = "dropdown";
    /** The container element of the dropdown. */ UI["DropdownRoot"] = "dropdown_root";
    /** The root element of the footer. */ UI["Footer"] = "footer";
    /** The month grid. */ UI["MonthGrid"] = "month_grid";
    /** Contains the dropdown navigation or the caption label. */ UI["MonthCaption"] = "month_caption";
    /** The dropdown with the months. */ UI["MonthsDropdown"] = "months_dropdown";
    /** Wrapper of the month grid. */ UI["Month"] = "month";
    /** The container of the displayed months. */ UI["Months"] = "months";
    /** The navigation bar with the previous and next buttons. */ UI["Nav"] = "nav";
    /**
     * The next month button in the navigation. *
     *
     * @since 9.1.0
     */ UI["NextMonthButton"] = "button_next";
    /**
     * The previous month button in the navigation.
     *
     * @since 9.1.0
     */ UI["PreviousMonthButton"] = "button_previous";
    /** The row containing the week. */ UI["Week"] = "week";
    /** The group of row weeks in a month (`tbody`). */ UI["Weeks"] = "weeks";
    /** The column header with the weekday. */ UI["Weekday"] = "weekday";
    /** The row grouping the weekdays in the column headers. */ UI["Weekdays"] = "weekdays";
    /** The cell containing the week number. */ UI["WeekNumber"] = "week_number";
    /** The cell header of the week numbers column. */ UI["WeekNumberHeader"] = "week_number_header";
    /** The dropdown with the years. */ UI["YearsDropdown"] = "years_dropdown";
})($17d6b6ed20fdf376$export$4b08aed5f1ec6952 || ($17d6b6ed20fdf376$export$4b08aed5f1ec6952 = {}));
var $17d6b6ed20fdf376$export$c2fd8ae3501086f5;
(function(DayFlag) {
    /** The day is disabled. */ DayFlag["disabled"] = "disabled";
    /** The day is hidden. */ DayFlag["hidden"] = "hidden";
    /** The day is outside the current month. */ DayFlag["outside"] = "outside";
    /** The day is focused. */ DayFlag["focused"] = "focused";
    /** The day is today. */ DayFlag["today"] = "today";
})($17d6b6ed20fdf376$export$c2fd8ae3501086f5 || ($17d6b6ed20fdf376$export$c2fd8ae3501086f5 = {}));
var $17d6b6ed20fdf376$export$2255d92a85eab347;
(function(SelectionState) {
    /** The day is at the end of a selected range. */ SelectionState["range_end"] = "range_end";
    /** The day is at the middle of a selected range. */ SelectionState["range_middle"] = "range_middle";
    /** The day is at the start of a selected range. */ SelectionState["range_start"] = "range_start";
    /** The day is selected. */ SelectionState["selected"] = "selected";
})($17d6b6ed20fdf376$export$2255d92a85eab347 || ($17d6b6ed20fdf376$export$2255d92a85eab347 = {}));


/**
 * The symbol to access the `TZDate`'s function to construct a new instance from
 * the provided value. It helps date-fns to inherit the time zone.
 */ const $d9f6dfe4c932768e$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


/**
 * Time zone name format.
 */ /**
 * The function returns the time zone name for the given date in the specified
 * time zone.
 *
 * It uses the `Intl.DateTimeFormat` API and by default outputs the time zone
 * name in a long format, e.g. "Pacific Standard Time" or
 * "Singapore Standard Time".
 *
 * It is possible to specify the format as the third argument using one of the following options
 *
 * - "short": e.g. "EDT" or "GMT+8".
 * - "long": e.g. "Eastern Daylight Time".
 * - "shortGeneric": e.g. "ET" or "Singapore Time".
 * - "longGeneric": e.g. "Eastern Time" or "Singapore Standard Time".
 *
 * These options correspond to TR35 tokens `z..zzz`, `zzzz`, `v`, and `vvvv` respectively: https://www.unicode.org/reports/tr35/tr35-dates.html#dfst-zone
 *
 * @param timeZone - Time zone name (IANA or UTC offset)
 * @param date - Date object to get the time zone name for
 * @param format - Optional format of the time zone name. Defaults to "long". Can be "short", "long", "shortGeneric", or "longGeneric".
 *
 * @returns Time zone name (e.g. "Singapore Standard Time")
 */ function $a00af70fd18d46ca$export$da16a9b5e878a278(timeZone, date, format = "long") {
    return new Intl.DateTimeFormat("en-US", {
        // Enforces engine to render the time. Without the option JavaScriptCore omits it.
        hour: "numeric",
        timeZone: timeZone,
        timeZoneName: format
    }).format(date).split(/\s/g) // Format.JS uses non-breaking spaces
    .slice(2) // Skip the hour and AM/PM parts
    .join(" ");
}


const $2ef1deba6e3fd307$var$offsetFormatCache = {};
const $2ef1deba6e3fd307$var$offsetCache = {};
function $2ef1deba6e3fd307$export$9047ae35a63b6344(timeZone, date) {
    try {
        const format = $2ef1deba6e3fd307$var$offsetFormatCache[timeZone] ||= new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            timeZoneName: "longOffset"
        }).format;
        const offsetStr = format(date).split("GMT")[1];
        if (offsetStr in $2ef1deba6e3fd307$var$offsetCache) return $2ef1deba6e3fd307$var$offsetCache[offsetStr];
        return $2ef1deba6e3fd307$var$calcOffset(offsetStr, offsetStr.split(":"));
    } catch  {
        // Fallback to manual parsing if the runtime doesn't support ±HH:MM/±HHMM/±HH
        // See: https://github.com/nodejs/node/issues/53419
        if (timeZone in $2ef1deba6e3fd307$var$offsetCache) return $2ef1deba6e3fd307$var$offsetCache[timeZone];
        const captures = timeZone?.match($2ef1deba6e3fd307$var$offsetRe);
        if (captures) return $2ef1deba6e3fd307$var$calcOffset(timeZone, captures.slice(1));
        return NaN;
    }
}
const $2ef1deba6e3fd307$var$offsetRe = /([+-]\d\d):?(\d\d)?/;
function $2ef1deba6e3fd307$var$calcOffset(cacheStr, values) {
    const hours = +(values[0] || 0);
    const minutes = +(values[1] || 0);
    // Convert seconds to minutes by dividing by 60 to keep the function return in minutes.
    const seconds = +(values[2] || 0) / 60;
    return $2ef1deba6e3fd307$var$offsetCache[cacheStr] = hours * 60 + minutes > 0 ? hours * 60 + minutes + seconds : hours * 60 - minutes - seconds;
}


class $39abbb61a2af61b0$export$b6261598d9222eec extends Date {
    //#region static
    constructor(...args){
        super();
        if (args.length > 1 && typeof args[args.length - 1] === "string") this.timeZone = args.pop();
        this.internal = new Date();
        if (isNaN((0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(this.timeZone, this))) this.setTime(NaN);
        else {
            if (!args.length) this.setTime(Date.now());
            else if (typeof args[0] === "number" && (args.length === 1 || args.length === 2 && typeof args[1] !== "number")) this.setTime(args[0]);
            else if (typeof args[0] === "string") this.setTime(+new Date(args[0]));
            else if (args[0] instanceof Date) this.setTime(+args[0]);
            else {
                this.setTime(+new Date(...args));
                $39abbb61a2af61b0$var$adjustToSystemTZ(this, NaN);
                $39abbb61a2af61b0$var$syncToInternal(this);
            }
        }
    }
    static tz(tz, ...args) {
        return args.length ? new $39abbb61a2af61b0$export$b6261598d9222eec(...args, tz) : new $39abbb61a2af61b0$export$b6261598d9222eec(Date.now(), tz);
    }
    //#endregion
    //#region time zone
    withTimeZone(timeZone) {
        return new $39abbb61a2af61b0$export$b6261598d9222eec(+this, timeZone);
    }
    getTimezoneOffset() {
        const offset = -(0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(this.timeZone, this);
        // Remove the seconds offset
        // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
        return offset > 0 ? Math.floor(offset) : Math.ceil(offset);
    }
    //#endregion
    //#region time
    setTime(time) {
        Date.prototype.setTime.apply(this, arguments);
        $39abbb61a2af61b0$var$syncToInternal(this);
        return +this;
    }
    //#endregion
    //#region date-fns integration
    [Symbol.for("constructDateFrom")](date) {
        return new $39abbb61a2af61b0$export$b6261598d9222eec(+new Date(date), this.timeZone);
    }
}
// Assign getters and setters
const $39abbb61a2af61b0$var$re = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((method)=>{
    if (!$39abbb61a2af61b0$var$re.test(method)) return;
    const utcMethod = method.replace($39abbb61a2af61b0$var$re, "$1UTC");
    // Filter out methods without UTC counterparts
    if (!$39abbb61a2af61b0$export$b6261598d9222eec.prototype[utcMethod]) return;
    if (method.startsWith("get")) // Delegate to internal date's UTC method
    $39abbb61a2af61b0$export$b6261598d9222eec.prototype[method] = function() {
        return this.internal[utcMethod]();
    };
    else {
        // Assign regular setter
        $39abbb61a2af61b0$export$b6261598d9222eec.prototype[method] = function() {
            Date.prototype[utcMethod].apply(this.internal, arguments);
            $39abbb61a2af61b0$var$syncFromInternal(this);
            return +this;
        };
        // Assign UTC setter
        $39abbb61a2af61b0$export$b6261598d9222eec.prototype[utcMethod] = function() {
            Date.prototype[utcMethod].apply(this, arguments);
            $39abbb61a2af61b0$var$syncToInternal(this);
            return +this;
        };
    }
});
/**
 * Function syncs time to internal date, applying the time zone offset.
 *
 * @param {Date} date - Date to sync
 */ function $39abbb61a2af61b0$var$syncToInternal(date) {
    date.internal.setTime(+date);
    date.internal.setUTCSeconds(date.internal.getUTCSeconds() - Math.round(-(0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(date.timeZone, date) * 60));
}
/**
 * Function syncs the internal date UTC values to the date. It allows to get
 * accurate timestamp value.
 *
 * @param {Date} date - The date to sync
 */ function $39abbb61a2af61b0$var$syncFromInternal(date) {
    // First we transpose the internal values
    Date.prototype.setFullYear.call(date, date.internal.getUTCFullYear(), date.internal.getUTCMonth(), date.internal.getUTCDate());
    Date.prototype.setHours.call(date, date.internal.getUTCHours(), date.internal.getUTCMinutes(), date.internal.getUTCSeconds(), date.internal.getUTCMilliseconds());
    // Now we have to adjust the date to the system time zone
    $39abbb61a2af61b0$var$adjustToSystemTZ(date);
}
/**
 * Function adjusts the date to the system time zone. It uses the time zone
 * differences to calculate the offset and adjust the date.
 *
 * @param {Date} date - Date to adjust
 */ function $39abbb61a2af61b0$var$adjustToSystemTZ(date) {
    // Save the time zone offset before all the adjustments
    const baseOffset = (0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(date.timeZone, date);
    // Remove the seconds offset
    // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
    const offset = baseOffset > 0 ? Math.floor(baseOffset) : Math.ceil(baseOffset);
    //#region System DST adjustment
    // The biggest problem with using the system time zone is that when we create
    // a date from internal values stored in UTC, the system time zone might end
    // up on the DST hour:
    //
    //   $ TZ=America/New_York node
    //   > new Date(2020, 2, 8, 1).toString()
    //   'Sun Mar 08 2020 01:00:00 GMT-0500 (Eastern Standard Time)'
    //   > new Date(2020, 2, 8, 2).toString()
    //   'Sun Mar 08 2020 03:00:00 GMT-0400 (Eastern Daylight Time)'
    //   > new Date(2020, 2, 8, 3).toString()
    //   'Sun Mar 08 2020 03:00:00 GMT-0400 (Eastern Daylight Time)'
    //   > new Date(2020, 2, 8, 4).toString()
    //   'Sun Mar 08 2020 04:00:00 GMT-0400 (Eastern Daylight Time)'
    //
    // Here we get the same hour for both 2 and 3, because the system time zone
    // has DST beginning at 8 March 2020, 2 a.m. and jumps to 3 a.m. So we have
    // to adjust the internal date to reflect that.
    //
    // However we want to adjust only if that's the DST hour the change happenes,
    // not the hour where DST moves to.
    // We calculate the previous hour to see if the time zone offset has changed
    // and we have landed on the DST hour.
    const prevHour = new Date(+date);
    // We use UTC methods here as we don't want to land on the same hour again
    // in case of DST.
    prevHour.setUTCHours(prevHour.getUTCHours() - 1);
    // Calculate if we are on the system DST hour.
    const systemOffset = -new Date(+date).getTimezoneOffset();
    const prevHourSystemOffset = -new Date(+prevHour).getTimezoneOffset();
    const systemDSTChange = systemOffset - prevHourSystemOffset;
    // Detect the DST shift. System DST change will occur both on
    const dstShift = Date.prototype.getHours.apply(date) !== date.internal.getUTCHours();
    // Move the internal date when we are on the system DST hour.
    if (systemDSTChange && dstShift) date.internal.setUTCMinutes(date.internal.getUTCMinutes() + systemDSTChange);
    //#endregion
    //#region System diff adjustment
    // Now we need to adjust the date, since we just applied internal values.
    // We need to calculate the difference between the system and date time zones
    // and apply it to the date.
    const offsetDiff = systemOffset - offset;
    if (offsetDiff) Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetDiff);
    //#endregion
    //#region Seconds System diff adjustment
    const systemDate = new Date(+date);
    // Set the UTC seconds to 0 to isolate the timezone offset in seconds.
    systemDate.setUTCSeconds(0);
    // For negative systemOffset, invert the seconds.
    const systemSecondsOffset = systemOffset > 0 ? systemDate.getSeconds() : (systemDate.getSeconds() - 60) % 60;
    // Calculate the seconds offset based on the timezone offset.
    const secondsOffset = Math.round(-((0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(date.timeZone, date) * 60)) % 60;
    if (secondsOffset || systemSecondsOffset) {
        date.internal.setUTCSeconds(date.internal.getUTCSeconds() + secondsOffset);
        Date.prototype.setUTCSeconds.call(date, Date.prototype.getUTCSeconds.call(date) + secondsOffset + systemSecondsOffset);
    }
    //#endregion
    //#region Post-adjustment DST fix
    const postBaseOffset = (0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(date.timeZone, date);
    // Remove the seconds offset
    // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
    const postOffset = postBaseOffset > 0 ? Math.floor(postBaseOffset) : Math.ceil(postBaseOffset);
    const postSystemOffset = -new Date(+date).getTimezoneOffset();
    const postOffsetDiff = postSystemOffset - postOffset;
    const offsetChanged = postOffset !== offset;
    const postDiff = postOffsetDiff - offsetDiff;
    if (offsetChanged && postDiff) {
        Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + postDiff);
        // Now we need to check if got offset change during the post-adjustment.
        // If so, we also need both dates to reflect that.
        const newBaseOffset = (0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(date.timeZone, date);
        // Remove the seconds offset
        // use Math.floor for negative GMT timezones and Math.ceil for positive GMT timezones.
        const newOffset = newBaseOffset > 0 ? Math.floor(newBaseOffset) : Math.ceil(newBaseOffset);
        const offsetChange = postOffset - newOffset;
        if (offsetChange) {
            date.internal.setUTCMinutes(date.internal.getUTCMinutes() + offsetChange);
            Date.prototype.setUTCMinutes.call(date, Date.prototype.getUTCMinutes.call(date) + offsetChange);
        }
    }
//#endregion
}


class $fc84dc1c04363736$export$8de43e28dd4af6bd extends (0, $39abbb61a2af61b0$export$b6261598d9222eec) {
    //#region static
    static tz(tz, ...args) {
        return args.length ? new $fc84dc1c04363736$export$8de43e28dd4af6bd(...args, tz) : new $fc84dc1c04363736$export$8de43e28dd4af6bd(Date.now(), tz);
    }
    //#endregion
    //#region representation
    toISOString() {
        const [sign, hours, minutes] = this.tzComponents();
        const tz = `${sign}${hours}:${minutes}`;
        return this.internal.toISOString().slice(0, -1) + tz;
    }
    toString() {
        // "Tue Aug 13 2024 07:50:19 GMT+0800 (Singapore Standard Time)";
        return `${this.toDateString()} ${this.toTimeString()}`;
    }
    toDateString() {
        // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
        const [day, date, month, year] = this.internal.toUTCString().split(" ");
        // "Tue Aug 13 2024"
        return `${day?.slice(0, -1)} ${month} ${date} ${year}`;
    }
    toTimeString() {
        // toUTCString returns RFC 7231 ("Mon, 12 Aug 2024 23:36:08 GMT")
        const time = this.internal.toUTCString().split(" ")[4];
        const [sign, hours, minutes] = this.tzComponents();
        // "07:42:23 GMT+0800 (Singapore Standard Time)"
        return `${time} GMT${sign}${hours}${minutes} (${(0, $a00af70fd18d46ca$export$da16a9b5e878a278)(this.timeZone, this)})`;
    }
    toLocaleString(locales, options) {
        return Date.prototype.toLocaleString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    toLocaleDateString(locales, options) {
        return Date.prototype.toLocaleDateString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    toLocaleTimeString(locales, options) {
        return Date.prototype.toLocaleTimeString.call(this, locales, {
            ...options,
            timeZone: options?.timeZone || this.timeZone
        });
    }
    //#endregion
    //#region private
    tzComponents() {
        const offset = this.getTimezoneOffset();
        const sign = offset > 0 ? "-" : "+";
        const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
        const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
        return [
            sign,
            hours,
            minutes
        ];
    }
    //#endregion
    withTimeZone(timeZone) {
        return new $fc84dc1c04363736$export$8de43e28dd4af6bd(+this, timeZone);
    }
    //#region date-fns integration
    [Symbol.for("constructDateFrom")](date) {
        return new $fc84dc1c04363736$export$8de43e28dd4af6bd(+new Date(date), this.timeZone);
    }
}




const $3618baaf94ea93d8$export$566f85d6e9c9e82d = (timeZone)=>(value)=>(0, $fc84dc1c04363736$export$8de43e28dd4af6bd).tz(timeZone, +new Date(value));




function $ee4c0425c1b58806$export$ac7720f54463288a(timeZone, interval) {
    const changes = [];
    const monthDate = new Date(interval.start);
    monthDate.setUTCSeconds(0, 0);
    const endDate = new Date(interval.end);
    endDate.setUTCSeconds(0, 0);
    const endMonthTime = +endDate;
    let lastOffset = (0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(timeZone, monthDate);
    while(+monthDate < endMonthTime){
        // Month forward
        monthDate.setUTCMonth(monthDate.getUTCMonth() + 1);
        // Find the month where the offset changes
        const offset = (0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(timeZone, monthDate);
        if (offset != lastOffset) {
            // Rewind a month back to find the day where the offset changes
            const dayDate = new Date(monthDate);
            dayDate.setUTCMonth(dayDate.getUTCMonth() - 1);
            const endDayTime = +monthDate;
            lastOffset = (0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(timeZone, dayDate);
            while(+dayDate < endDayTime){
                // Day forward
                dayDate.setUTCDate(dayDate.getUTCDate() + 1);
                // Find the day where the offset changes
                const offset = (0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(timeZone, dayDate);
                if (offset != lastOffset) {
                    // Rewind a day back to find the time where the offset changes
                    const hourDate = new Date(dayDate);
                    hourDate.setUTCDate(hourDate.getUTCDate() - 1);
                    const endHourTime = +dayDate;
                    lastOffset = (0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(timeZone, hourDate);
                    while(+hourDate < endHourTime){
                        // Hour forward
                        hourDate.setUTCHours(hourDate.getUTCHours() + 1);
                        // Find the hour where the offset changes
                        const hourOffset = (0, $2ef1deba6e3fd307$export$9047ae35a63b6344)(timeZone, hourDate);
                        if (hourOffset !== lastOffset) changes.push({
                            date: new Date(hourDate),
                            change: hourOffset - lastOffset,
                            offset: hourOffset
                        });
                        lastOffset = hourOffset;
                    }
                }
                lastOffset = offset;
            }
        }
        lastOffset = offset;
    }
    return changes;
}







function $8fcd3b0bf5df7635$export$17c93e242b2d3a22(date, amount, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$8fcd3b0bf5df7635$export$2e2bcd8739ae039 = $8fcd3b0bf5df7635$export$17c93e242b2d3a22;


function $bce641bd93181421$export$ef501a2bb4f3ee6b(date, amount, options) {
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date, amount * 7, options);
}
var // Fallback for modularized imports:
$bce641bd93181421$export$2e2bcd8739ae039 = $bce641bd93181421$export$ef501a2bb4f3ee6b;


function $25460c542fb3bf74$export$3d83eec43f4ea476(date, amount, options) {
    return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, amount * 12, options);
}
var // Fallback for modularized imports:
$25460c542fb3bf74$export$2e2bcd8739ae039 = $25460c542fb3bf74$export$3d83eec43f4ea476;


function $8aa264ebd3f03841$export$489984ac7c996389(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$8aa264ebd3f03841$export$2e2bcd8739ae039 = $8aa264ebd3f03841$export$489984ac7c996389;


function $98a522fe51fb2394$export$17b5b2669f734364(context, interval) {
    const [start, end] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(context, interval.start, interval.end);
    return {
        start: start,
        end: end
    };
}



function $f17d32e46529568a$export$1c9322f2d2a5eed3(interval, options) {
    const { start: start, end: end } = (0, $98a522fe51fb2394$export$17b5b2669f734364)(options?.in, interval);
    let reversed = +start > +end;
    const endTime = reversed ? +start : +end;
    const date = reversed ? end : start;
    date.setHours(0, 0, 0, 0);
    date.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+date <= endTime){
        dates.push((0, $abb9adbdb26342b3$export$ead8a1812b171991)(start, date));
        date.setMonth(date.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}
var // Fallback for modularized imports:
$f17d32e46529568a$export$2e2bcd8739ae039 = $f17d32e46529568a$export$1c9322f2d2a5eed3;



function $d53308c42f1e4c62$export$ef8b6d9133084f4e(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$d53308c42f1e4c62$export$2e2bcd8739ae039 = $d53308c42f1e4c62$export$ef8b6d9133084f4e;


function $3505726b435bc449$export$186cd934f32084be(date, options) {
    return (0, $d53308c42f1e4c62$export$ef8b6d9133084f4e)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$3505726b435bc449$export$2e2bcd8739ae039 = $3505726b435bc449$export$186cd934f32084be;


function $e58340063d97ab50$export$a2258d9c4118825c(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$e58340063d97ab50$export$2e2bcd8739ae039 = $e58340063d97ab50$export$a2258d9c4118825c;


function $6cbfdc6d008595cd$export$8b7aa55c66d5569e(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$6cbfdc6d008595cd$export$2e2bcd8739ae039 = $6cbfdc6d008595cd$export$8b7aa55c66d5569e;


function $6f30fa731c19b802$export$6ce1b5acc29cb53b(date, options) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getMonth();
}
var // Fallback for modularized imports:
$6f30fa731c19b802$export$2e2bcd8739ae039 = $6f30fa731c19b802$export$6ce1b5acc29cb53b;


function $4189f4c9c3b9878d$export$5846dc2d57a5c860(date, options) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getFullYear();
}
var // Fallback for modularized imports:
$4189f4c9c3b9878d$export$2e2bcd8739ae039 = $4189f4c9c3b9878d$export$5846dc2d57a5c860;



function $b70baca84fc92b6d$export$8960430cfd85939f(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, $abb9adbdb26342b3$export$ead8a1812b171991).bind(null, date);
        const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, context);
        if (!result || result < date_ || isNaN(+date_)) result = date_;
    });
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$b70baca84fc92b6d$export$2e2bcd8739ae039 = $b70baca84fc92b6d$export$8960430cfd85939f;



function $5d373ce01680b655$export$96ec731ed4dcb222(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, $abb9adbdb26342b3$export$ead8a1812b171991).bind(null, date);
        const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, context);
        if (!result || result > date_ || isNaN(+date_)) result = date_;
    });
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$5d373ce01680b655$export$2e2bcd8739ae039 = $5d373ce01680b655$export$96ec731ed4dcb222;




function $57397b9e44500b87$export$f645ddd439eb259d(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(_date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
var // Fallback for modularized imports:
$57397b9e44500b87$export$2e2bcd8739ae039 = $57397b9e44500b87$export$f645ddd439eb259d;



function $16856745969af5fc$export$63264690f8e36790(date, month, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const midMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    midMonth.setFullYear(year, month, 15);
    midMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $57397b9e44500b87$export$f645ddd439eb259d)(midMonth);
    // Set the earlier date, allows to wrap Jan 31 to Feb 28
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
var // Fallback for modularized imports:
$16856745969af5fc$export$2e2bcd8739ae039 = $16856745969af5fc$export$63264690f8e36790;



function $529c31b1ede64581$export$a8408b6c5639cab7(date, year, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+date_)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, NaN);
    date_.setFullYear(year);
    return date_;
}
var // Fallback for modularized imports:
$529c31b1ede64581$export$2e2bcd8739ae039 = $529c31b1ede64581$export$a8408b6c5639cab7;


function $c0b4ec5551eca4c9$export$a5a3b454ada2268e(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$c0b4ec5551eca4c9$export$2e2bcd8739ae039 = $c0b4ec5551eca4c9$export$a5a3b454ada2268e;



const $47d0e97db9370d23$var$FIVE_WEEKS = 5;
const $47d0e97db9370d23$var$FOUR_WEEKS = 4;
function $47d0e97db9370d23$export$343e859fa2b0f8fe(month, dateLib) {
    // Get the first day of the month
    const firstDayOfMonth = dateLib.startOfMonth(month);
    // Get the day of the week for the first day of the month (1-7, where 1 is Monday)
    const firstDayOfWeek = firstDayOfMonth.getDay() > 0 ? firstDayOfMonth.getDay() : 7;
    const broadcastStartDate = dateLib.addDays(month, -firstDayOfWeek + 1);
    const lastDateOfLastWeek = dateLib.addDays(broadcastStartDate, $47d0e97db9370d23$var$FIVE_WEEKS * 7 - 1);
    const numberOfWeeks = dateLib.getMonth(month) === dateLib.getMonth(lastDateOfLastWeek) ? $47d0e97db9370d23$var$FIVE_WEEKS : $47d0e97db9370d23$var$FOUR_WEEKS;
    return numberOfWeeks;
}


/**
 * Return the start date of the week in the broadcast calendar.
 *
 * @since 9.4.0
 */ function $740a0e257df0f7cd$export$b48393ee26dd6e5b(date, dateLib) {
    const firstOfMonth = dateLib.startOfMonth(date);
    const dayOfWeek = firstOfMonth.getDay();
    if (dayOfWeek === 1) return firstOfMonth;
    else if (dayOfWeek === 0) return dateLib.addDays(firstOfMonth, -6);
    else return dateLib.addDays(firstOfMonth, -1 * (dayOfWeek - 1));
}


function $d8ced0bdbe5fc8c5$export$b29eb013c51db966(date, dateLib) {
    const startDate = (0, $740a0e257df0f7cd$export$b48393ee26dd6e5b)(date, dateLib);
    const numberOfWeeks = (0, $47d0e97db9370d23$export$343e859fa2b0f8fe)(date, dateLib);
    const endDate = dateLib.addDays(startDate, numberOfWeeks * 7 - 1);
    return endDate;
}




class $d707bba72f7c4bf9$export$87f71ed78036473c {
    /**
     * Creates an instance of DateLib.
     *
     * @param options The options for the date library.
     * @param overrides Overrides for the date library functions.
     */ constructor(options, overrides){
        /**
         * Reference to the built-in Date constructor.
         *
         * @deprecated Use `newDate()` or `today()`.
         */ this.Date = Date;
        /**
         * Creates a new date object to the today's date.
         *
         * @since 9.5.0
         * @returns The new date object.
         */ this.today = ()=>{
            if (this.overrides?.today) return this.overrides.today();
            if (this.options.timeZone) return (0, $fc84dc1c04363736$export$8de43e28dd4af6bd).tz(this.options.timeZone);
            return new this.Date();
        };
        /**
         * Creates a new date object with the specified year, month and date.
         *
         * @since 9.5.0
         * @param year The year.
         * @param monthIndex The month (0-11).
         * @param date The day of the month.
         * @returns The new date object.
         */ this.newDate = (year, monthIndex, date)=>{
            if (this.overrides?.newDate) return this.overrides.newDate(year, monthIndex, date);
            if (this.options.timeZone) return new (0, $fc84dc1c04363736$export$8de43e28dd4af6bd)(year, monthIndex, date, this.options.timeZone);
            return new Date(year, monthIndex, date);
        };
        /**
         * Adds the specified number of days to the given date.
         *
         * @param date The date to add days to.
         * @param amount The number of days to add.
         * @returns The new date with the days added.
         */ this.addDays = (date, amount)=>{
            return this.overrides?.addDays?.(date, amount) ?? (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date, amount);
        };
        /**
         * Adds the specified number of months to the given date.
         *
         * @param date The date to add months to.
         * @param amount The number of months to add.
         * @returns The new date with the months added.
         */ this.addMonths = (date, amount)=>{
            return this.overrides?.addMonths?.(date, amount) ?? (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, amount);
        };
        /**
         * Adds the specified number of weeks to the given date.
         *
         * @param date The date to add weeks to.
         * @param amount The number of weeks to add.
         * @returns The new date with the weeks added.
         */ this.addWeeks = (date, amount)=>{
            return this.overrides?.addWeeks?.(date, amount) ?? (0, $bce641bd93181421$export$ef501a2bb4f3ee6b)(date, amount);
        };
        /**
         * Adds the specified number of years to the given date.
         *
         * @param date The date to add years to.
         * @param amount The number of years to add.
         * @returns The new date with the years added.
         */ this.addYears = (date, amount)=>{
            return this.overrides?.addYears?.(date, amount) ?? (0, $25460c542fb3bf74$export$3d83eec43f4ea476)(date, amount);
        };
        /**
         * Returns the number of calendar days between the given dates.
         *
         * @param dateLeft The later date.
         * @param dateRight The earlier date.
         * @returns The number of calendar days between the dates.
         */ this.differenceInCalendarDays = (dateLeft, dateRight)=>{
            return this.overrides?.differenceInCalendarDays?.(dateLeft, dateRight) ?? (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(dateLeft, dateRight);
        };
        /**
         * Returns the number of calendar months between the given dates.
         *
         * @param dateLeft The later date.
         * @param dateRight The earlier date.
         * @returns The number of calendar months between the dates.
         */ this.differenceInCalendarMonths = (dateLeft, dateRight)=>{
            return this.overrides?.differenceInCalendarMonths?.(dateLeft, dateRight) ?? (0, $8aa264ebd3f03841$export$489984ac7c996389)(dateLeft, dateRight);
        };
        /**
         * Returns the months between the given dates.
         *
         * @param interval The interval to get the months for.
         */ this.eachMonthOfInterval = (interval)=>{
            return this.overrides?.eachMonthOfInterval?.(interval) ?? (0, $f17d32e46529568a$export$1c9322f2d2a5eed3)(interval);
        };
        /**
         * Returns the end of the broadcast week for the given date.
         *
         * @param date The original date.
         * @returns The end of the broadcast week.
         */ this.endOfBroadcastWeek = (date, dateLib)=>{
            return this.overrides?.endOfBroadcastWeek?.(date, dateLib) ?? (0, $d8ced0bdbe5fc8c5$export$b29eb013c51db966)(date, this);
        };
        /**
         * Returns the end of the ISO week for the given date.
         *
         * @param date The original date.
         * @returns The end of the ISO week.
         */ this.endOfISOWeek = (date)=>{
            return this.overrides?.endOfISOWeek?.(date) ?? (0, $3505726b435bc449$export$186cd934f32084be)(date);
        };
        /**
         * Returns the end of the month for the given date.
         *
         * @param date The original date.
         * @returns The end of the month.
         */ this.endOfMonth = (date)=>{
            return this.overrides?.endOfMonth?.(date) ?? (0, $e58340063d97ab50$export$a2258d9c4118825c)(date);
        };
        /**
         * Returns the end of the week for the given date.
         *
         * @param date The original date.
         * @returns The end of the week.
         */ this.endOfWeek = (date, options)=>{
            return this.overrides?.endOfWeek?.(date, options ?? this.options) ?? (0, $d53308c42f1e4c62$export$ef8b6d9133084f4e)(date, options ?? this.options);
        };
        /**
         * Returns the end of the year for the given date.
         *
         * @param date The original date.
         * @returns The end of the year.
         */ this.endOfYear = (date)=>{
            return this.overrides?.endOfYear?.(date) ?? (0, $6cbfdc6d008595cd$export$8b7aa55c66d5569e)(date);
        };
        /**
         * Formats the given date using the specified format string.
         *
         * @param date The date to format.
         * @param formatStr The format string.
         * @returns The formatted date string.
         */ this.format = (date, formatStr, options)=>{
            const formatted = this.overrides?.format?.(date, formatStr, options ?? this.options) ?? (0, $303ba10db2c74ab4$export$d9468344d3651243)(date, formatStr, options ?? this.options);
            if (this.options.numerals && this.options.numerals !== "latn") return this.replaceDigits(formatted);
            return formatted;
        };
        /**
         * Returns the ISO week number for the given date.
         *
         * @param date The date to get the ISO week number for.
         * @returns The ISO week number.
         */ this.getISOWeek = (date)=>{
            return this.overrides?.getISOWeek?.(date) ?? (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(date);
        };
        /**
         * Returns the month of the given date.
         *
         * @param date The date to get the month for.
         * @returns The month.
         */ this.getMonth = (date)=>{
            return this.overrides?.getMonth?.(date) ?? (0, $6f30fa731c19b802$export$6ce1b5acc29cb53b)(date);
        };
        /**
         * Returns the year of the given date.
         *
         * @param date The date to get the year for.
         * @returns The year.
         */ this.getYear = (date)=>{
            return this.overrides?.getYear?.(date) ?? (0, $4189f4c9c3b9878d$export$5846dc2d57a5c860)(date);
        };
        /**
         * Returns the local week number for the given date.
         *
         * @param date The date to get the week number for.
         * @returns The week number.
         */ this.getWeek = (date, options)=>{
            return this.overrides?.getWeek?.(date, options ?? this.options) ?? (0, $11b38d723fd57381$export$efe19b760242b2fc)(date, options ?? this.options);
        };
        /**
         * Checks if the first date is after the second date.
         *
         * @param date The date to compare.
         * @param dateToCompare The date to compare with.
         * @returns True if the first date is after the second date.
         */ this.isAfter = (date, dateToCompare)=>{
            return this.overrides?.isAfter?.(date, dateToCompare) ?? (0, $7c47abeb099a42c0$export$e4de839670987035)(date, dateToCompare);
        };
        /**
         * Checks if the first date is before the second date.
         *
         * @param date The date to compare.
         * @param dateToCompare The date to compare with.
         * @returns True if the first date is before the second date.
         */ this.isBefore = (date, dateToCompare)=>{
            return this.overrides?.isBefore?.(date, dateToCompare) ?? (0, $d2aab93838002ade$export$5c007e10c6929c95)(date, dateToCompare);
        };
        /**
         * Checks if the given value is a Date object.
         *
         * @param value The value to check.
         * @returns True if the value is a Date object.
         */ this.isDate = (value)=>{
            return this.overrides?.isDate?.(value) ?? (0, $1896b5e28554d57b$export$871608497c498473)(value);
        };
        /**
         * Checks if the given dates are on the same day.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are on the same day.
         */ this.isSameDay = (dateLeft, dateRight)=>{
            return this.overrides?.isSameDay?.(dateLeft, dateRight) ?? (0, $27a7db21eafd685b$export$ea39ec197993aef0)(dateLeft, dateRight);
        };
        /**
         * Checks if the given dates are in the same month.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are in the same month.
         */ this.isSameMonth = (dateLeft, dateRight)=>{
            return this.overrides?.isSameMonth?.(dateLeft, dateRight) ?? (0, $06e3609fc2fbc2e2$export$a18c89cbd24170ff)(dateLeft, dateRight);
        };
        /**
         * Checks if the given dates are in the same year.
         *
         * @param dateLeft The first date to compare.
         * @param dateRight The second date to compare.
         * @returns True if the dates are in the same year.
         */ this.isSameYear = (dateLeft, dateRight)=>{
            return this.overrides?.isSameYear?.(dateLeft, dateRight) ?? (0, $a4f3c61641c4093b$export$5841f9eb9773f25f)(dateLeft, dateRight);
        };
        /**
         * Returns the latest date in the given array of dates.
         *
         * @param dates The array of dates to compare.
         * @returns The latest date.
         */ this.max = (dates)=>{
            return this.overrides?.max?.(dates) ?? (0, $b70baca84fc92b6d$export$8960430cfd85939f)(dates);
        };
        /**
         * Returns the earliest date in the given array of dates.
         *
         * @param dates The array of dates to compare.
         * @returns The earliest date.
         */ this.min = (dates)=>{
            return this.overrides?.min?.(dates) ?? (0, $5d373ce01680b655$export$96ec731ed4dcb222)(dates);
        };
        /**
         * Sets the month of the given date.
         *
         * @param date The date to set the month on.
         * @param month The month to set (0-11).
         * @returns The new date with the month set.
         */ this.setMonth = (date, month)=>{
            return this.overrides?.setMonth?.(date, month) ?? (0, $16856745969af5fc$export$63264690f8e36790)(date, month);
        };
        /**
         * Sets the year of the given date.
         *
         * @param date The date to set the year on.
         * @param year The year to set.
         * @returns The new date with the year set.
         */ this.setYear = (date, year)=>{
            return this.overrides?.setYear?.(date, year) ?? (0, $529c31b1ede64581$export$a8408b6c5639cab7)(date, year);
        };
        /**
         * Returns the start of the broadcast week for the given date.
         *
         * @param date The original date.
         * @returns The start of the broadcast week.
         */ this.startOfBroadcastWeek = (date, dateLib)=>{
            return this.overrides?.startOfBroadcastWeek?.(date, dateLib ?? this) ?? (0, $740a0e257df0f7cd$export$b48393ee26dd6e5b)(date, dateLib ?? this);
        };
        /**
         * Returns the start of the day for the given date.
         *
         * @param date The original date.
         * @returns The start of the day.
         */ this.startOfDay = (date)=>{
            return this.overrides?.startOfDay?.(date) ?? (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(date);
        };
        /**
         * Returns the start of the ISO week for the given date.
         *
         * @param date The original date.
         * @returns The start of the ISO week.
         */ this.startOfISOWeek = (date)=>{
            return this.overrides?.startOfISOWeek?.(date) ?? (0, $1c9d32c6cb108460$export$6173213f95a4431e)(date);
        };
        /**
         * Returns the start of the month for the given date.
         *
         * @param date The original date.
         * @returns The start of the month.
         */ this.startOfMonth = (date)=>{
            return this.overrides?.startOfMonth?.(date) ?? (0, $c0b4ec5551eca4c9$export$a5a3b454ada2268e)(date);
        };
        /**
         * Returns the start of the week for the given date.
         *
         * @param date The original date.
         * @returns The start of the week.
         */ this.startOfWeek = (date)=>{
            return this.overrides?.startOfWeek?.(date) ?? (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, this.options);
        };
        /**
         * Returns the start of the year for the given date.
         *
         * @param date The original date.
         * @returns The start of the year.
         */ this.startOfYear = (date)=>{
            return this.overrides?.startOfYear?.(date) ?? (0, $29cc086f79701cd9$export$f91e89d3d0406102)(date);
        };
        this.options = {
            locale: (0, $cd0c27002eb93234$export$137380d9ce54f7f),
            ...options
        };
        this.overrides = overrides;
    }
    /**
     * Generate digit map dynamically using Intl.NumberFormat.
     *
     * @since 9.5.0
     */ getDigitMap() {
        const { numerals: numerals = "latn" } = this.options;
        // Use Intl.NumberFormat to create a formatter with the specified numbering system
        const formatter = new Intl.NumberFormat("en-US", {
            numberingSystem: numerals
        });
        // Map Arabic digits (0-9) to the target numerals
        const digitMap = {};
        for(let i = 0; i < 10; i++)digitMap[i.toString()] = formatter.format(i);
        return digitMap;
    }
    /**
     * Replace Arabic digits with the target numbering system digits.
     *
     * @since 9.5.0
     */ replaceDigits(input) {
        const digitMap = this.getDigitMap();
        return input.replace(/\d/g, (digit)=>digitMap[digit] || digit);
    }
    /**
     * Format number using the custom numbering system.
     *
     * @since 9.5.0
     * @param value The number to format.
     * @returns The formatted number.
     */ formatNumber(value) {
        return this.replaceDigits(value.toString());
    }
}
const $d707bba72f7c4bf9$export$6575cc37c71cbcd2 = new $d707bba72f7c4bf9$export$87f71ed78036473c();
const $d707bba72f7c4bf9$export$8299c5021a645d17 = $d707bba72f7c4bf9$export$6575cc37c71cbcd2;



function $ba569522066b98e5$export$93628caec3887c55(modifiers, classNames, modifiersClassNames = {}) {
    const modifierClassNames = Object.entries(modifiers).filter(([, active])=>active === true).reduce((previousValue, [key])=>{
        if (modifiersClassNames[key]) previousValue.push(modifiersClassNames[key]);
        else if (classNames[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5)[key]]) previousValue.push(classNames[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5)[key]]);
        else if (classNames[(0, $17d6b6ed20fdf376$export$2255d92a85eab347)[key]]) previousValue.push(classNames[(0, $17d6b6ed20fdf376$export$2255d92a85eab347)[key]]);
        return previousValue;
    }, [
        classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Day]
    ]);
    return modifierClassNames;
}


var $8fcbd16ca8b9fb19$exports = {};
var $4f01e6508f4733fe$exports = {};

$parcel$export($4f01e6508f4733fe$exports, "Button", () => $4f01e6508f4733fe$export$353f5b6fc5456de1);

var $acw62 = parcelRequire("acw62");
function $4f01e6508f4733fe$export$353f5b6fc5456de1(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...props
    });
}


var $bb66e27cc3ee226b$exports = {};

$parcel$export($bb66e27cc3ee226b$exports, "CaptionLabel", () => $bb66e27cc3ee226b$export$5b9f95302ae85eba);

var $acw62 = parcelRequire("acw62");
function $bb66e27cc3ee226b$export$5b9f95302ae85eba(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ...props
    });
}


var $f02fb57c3b023e36$exports = {};

$parcel$export($f02fb57c3b023e36$exports, "Chevron", () => $f02fb57c3b023e36$export$65be7b63f510f362);

var $acw62 = parcelRequire("acw62");
function $f02fb57c3b023e36$export$65be7b63f510f362(props) {
    const { size: size = 24, orientation: orientation = "left", className: className } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24"
    }, orientation === "up" && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
        points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28"
    }), orientation === "down" && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
        points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72"
    }), orientation === "left" && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
        points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20"
    }), orientation === "right" && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
        points: "8 18.612 14.1888889 12.5 8 6.37733333 9.91111111 4.5 18 12.5 9.91111111 20.5"
    }));
}


var $46c9e3af5765302b$exports = {};

$parcel$export($46c9e3af5765302b$exports, "Day", () => $46c9e3af5765302b$export$7a9a31a911eb9a20);

var $acw62 = parcelRequire("acw62");
function $46c9e3af5765302b$export$7a9a31a911eb9a20(props) {
    const { day: day, modifiers: modifiers, ...tdProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
        ...tdProps
    });
}


var $dc163a19a980790b$exports = {};

$parcel$export($dc163a19a980790b$exports, "DayButton", () => $dc163a19a980790b$export$162a17f4c1ec6e1e);

var $acw62 = parcelRequire("acw62");
function $dc163a19a980790b$export$162a17f4c1ec6e1e(props) {
    const { day: day, modifiers: modifiers, ...buttonProps } = props;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (modifiers.focused) ref.current?.focus();
    }, [
        modifiers.focused
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: ref,
        ...buttonProps
    });
}


var $924a35192df2ea2b$exports = {};

$parcel$export($924a35192df2ea2b$exports, "Dropdown", () => $924a35192df2ea2b$export$931cbfb6bfb85fc);

var $acw62 = parcelRequire("acw62");

function $924a35192df2ea2b$export$931cbfb6bfb85fc(props) {
    const { options: options, className: className, components: components, classNames: classNames, ...selectProps } = props;
    const cssClassSelect = [
        classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Dropdown],
        className
    ].join(" ");
    const selectedOption = options?.find(({ value: value })=>value === selectProps.value);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-disabled": selectProps.disabled,
        className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).DropdownRoot]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Select, {
        className: cssClassSelect,
        ...selectProps
    }, options?.map(({ value: value, label: label, disabled: disabled })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Option, {
            key: value,
            value: value,
            disabled: disabled
        }, label))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).CaptionLabel],
        "aria-hidden": true
    }, selectedOption?.label, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Chevron, {
        orientation: "down",
        size: 18,
        className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Chevron]
    })));
}


var $1f0dc626997d3952$exports = {};

$parcel$export($1f0dc626997d3952$exports, "DropdownNav", () => $1f0dc626997d3952$export$a76037c4c1362518);

var $acw62 = parcelRequire("acw62");
function $1f0dc626997d3952$export$a76037c4c1362518(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...props
    });
}


var $eebbd3ae47c50fa6$exports = {};

$parcel$export($eebbd3ae47c50fa6$exports, "Footer", () => $eebbd3ae47c50fa6$export$a06f1c675e846f6f);

var $acw62 = parcelRequire("acw62");
function $eebbd3ae47c50fa6$export$a06f1c675e846f6f(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...props
    });
}


var $f9ac164d05aa576f$exports = {};

$parcel$export($f9ac164d05aa576f$exports, "Month", () => $f9ac164d05aa576f$export$951c8378cdfec6e6);

var $acw62 = parcelRequire("acw62");
function $f9ac164d05aa576f$export$951c8378cdfec6e6(props) {
    const { calendarMonth: calendarMonth, displayIndex: displayIndex, ...divProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...divProps
    }, props.children);
}


var $759208f999b76c31$exports = {};

$parcel$export($759208f999b76c31$exports, "MonthCaption", () => $759208f999b76c31$export$1898376853bad7d4);

var $acw62 = parcelRequire("acw62");
function $759208f999b76c31$export$1898376853bad7d4(props) {
    const { calendarMonth: calendarMonth, displayIndex: displayIndex, ...divProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...divProps
    });
}


var $19b04bd35d57a979$exports = {};

$parcel$export($19b04bd35d57a979$exports, "MonthGrid", () => $19b04bd35d57a979$export$9be4b423b21fa82);

var $acw62 = parcelRequire("acw62");
function $19b04bd35d57a979$export$9be4b423b21fa82(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        ...props
    });
}


var $e7fd639794b10fcc$exports = {};

$parcel$export($e7fd639794b10fcc$exports, "Months", () => $e7fd639794b10fcc$export$a0ec4efdb90fa181);

var $acw62 = parcelRequire("acw62");
function $e7fd639794b10fcc$export$a0ec4efdb90fa181(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...props
    });
}


var $980508b46e20219b$exports = {};

$parcel$export($980508b46e20219b$exports, "MonthsDropdown", () => $980508b46e20219b$export$890818c4dfdc5b81);

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $edb9b04fac133fd0$export$468c0287d43ba92a = (0, $acw62.createContext)(undefined);
function $edb9b04fac133fd0$export$332e9e0d64b1f294() {
    const context = (0, $acw62.useContext)($edb9b04fac133fd0$export$468c0287d43ba92a);
    if (context === undefined) throw new Error("useDayPicker() must be used within a custom component.");
    return context;
}


function $980508b46e20219b$export$890818c4dfdc5b81(props) {
    const { components: components } = (0, $edb9b04fac133fd0$export$332e9e0d64b1f294)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Dropdown, {
        ...props
    });
}


var $aaa5c5424aeaa8c7$exports = {};

$parcel$export($aaa5c5424aeaa8c7$exports, "Nav", () => $aaa5c5424aeaa8c7$export$39140c7d8b0ba7b3);

var $acw62 = parcelRequire("acw62");


function $aaa5c5424aeaa8c7$export$39140c7d8b0ba7b3(props) {
    const { onPreviousClick: onPreviousClick, onNextClick: onNextClick, previousMonth: previousMonth, nextMonth: nextMonth, ...navProps } = props;
    const { components: components, classNames: classNames, labels: { labelPrevious: labelPrevious, labelNext: labelNext } } = (0, $edb9b04fac133fd0$export$332e9e0d64b1f294)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        ...navProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.PreviousMonthButton, {
        type: "button",
        className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).PreviousMonthButton],
        tabIndex: previousMonth ? undefined : -1,
        disabled: previousMonth ? undefined : true,
        "aria-label": labelPrevious(previousMonth),
        onClick: props.onPreviousClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Chevron, {
        disabled: previousMonth ? undefined : true,
        className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Chevron],
        orientation: "left"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.NextMonthButton, {
        type: "button",
        className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).NextMonthButton],
        tabIndex: nextMonth ? undefined : -1,
        disabled: nextMonth ? undefined : true,
        "aria-label": labelNext(nextMonth),
        onClick: props.onNextClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Chevron, {
        disabled: nextMonth ? undefined : true,
        orientation: "right",
        className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Chevron]
    })));
}


var $c28cfd95333ebe36$exports = {};

$parcel$export($c28cfd95333ebe36$exports, "NextMonthButton", () => $c28cfd95333ebe36$export$32eaef38b5dcafde);

var $acw62 = parcelRequire("acw62");

function $c28cfd95333ebe36$export$32eaef38b5dcafde(props) {
    const { components: components } = (0, $edb9b04fac133fd0$export$332e9e0d64b1f294)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Button, {
        ...props
    });
}


var $c4d6e1d44f1a243d$exports = {};

$parcel$export($c4d6e1d44f1a243d$exports, "Option", () => $c4d6e1d44f1a243d$export$36d18380658d5d20);

var $acw62 = parcelRequire("acw62");
function $c4d6e1d44f1a243d$export$36d18380658d5d20(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        ...props
    });
}


var $7c14da7786de1993$exports = {};

$parcel$export($7c14da7786de1993$exports, "PreviousMonthButton", () => $7c14da7786de1993$export$8b1a143b10000389);

var $acw62 = parcelRequire("acw62");

function $7c14da7786de1993$export$8b1a143b10000389(props) {
    const { components: components } = (0, $edb9b04fac133fd0$export$332e9e0d64b1f294)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Button, {
        ...props
    });
}


var $5d2d12db94985d42$exports = {};

$parcel$export($5d2d12db94985d42$exports, "Root", () => $5d2d12db94985d42$export$be92b6f5f03c0fe9);

var $acw62 = parcelRequire("acw62");
function $5d2d12db94985d42$export$be92b6f5f03c0fe9(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...props
    });
}


var $95cb955791e92964$exports = {};

$parcel$export($95cb955791e92964$exports, "Select", () => $95cb955791e92964$export$ef9b1a59e592288f);

var $acw62 = parcelRequire("acw62");
function $95cb955791e92964$export$ef9b1a59e592288f(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        ...props
    });
}


var $bc2fc79862fc077e$exports = {};

$parcel$export($bc2fc79862fc077e$exports, "Week", () => $bc2fc79862fc077e$export$fca4f8121099df57);

var $acw62 = parcelRequire("acw62");
function $bc2fc79862fc077e$export$fca4f8121099df57(props) {
    const { week: week, ...trProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        ...trProps
    });
}


var $4771491369cc4ed9$exports = {};

$parcel$export($4771491369cc4ed9$exports, "Weekday", () => $4771491369cc4ed9$export$94dd8a9f089c7f53);

var $acw62 = parcelRequire("acw62");
function $4771491369cc4ed9$export$94dd8a9f089c7f53(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        ...props
    });
}


var $2f96ad89636ab2bb$exports = {};

$parcel$export($2f96ad89636ab2bb$exports, "Weekdays", () => $2f96ad89636ab2bb$export$ecadcd5acd8b48a2);

var $acw62 = parcelRequire("acw62");
function $2f96ad89636ab2bb$export$ecadcd5acd8b48a2(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", {
        "aria-hidden": true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        ...props
    }));
}


var $ff0d6bc09ac14384$exports = {};

$parcel$export($ff0d6bc09ac14384$exports, "WeekNumber", () => $ff0d6bc09ac14384$export$f52f5e0fedb732da);

var $acw62 = parcelRequire("acw62");
function $ff0d6bc09ac14384$export$f52f5e0fedb732da(props) {
    const { week: week, ...thProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        ...thProps
    });
}


var $62de8acbfecfef06$exports = {};

$parcel$export($62de8acbfecfef06$exports, "WeekNumberHeader", () => $62de8acbfecfef06$export$67dc2d331c60b612);

var $acw62 = parcelRequire("acw62");
function $62de8acbfecfef06$export$67dc2d331c60b612(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        ...props
    });
}


var $ddfa9868cf2ee4a7$exports = {};

$parcel$export($ddfa9868cf2ee4a7$exports, "Weeks", () => $ddfa9868cf2ee4a7$export$cee3aa9d41feb83e);

var $acw62 = parcelRequire("acw62");
function $ddfa9868cf2ee4a7$export$cee3aa9d41feb83e(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", {
        ...props
    });
}


var $d626b67f1f81259d$exports = {};

$parcel$export($d626b67f1f81259d$exports, "YearsDropdown", () => $d626b67f1f81259d$export$cbcb737020db5a92);

var $acw62 = parcelRequire("acw62");

function $d626b67f1f81259d$export$cbcb737020db5a92(props) {
    const { components: components } = (0, $edb9b04fac133fd0$export$332e9e0d64b1f294)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Dropdown, {
        ...props
    });
}


$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $4f01e6508f4733fe$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $bb66e27cc3ee226b$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $f02fb57c3b023e36$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $46c9e3af5765302b$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $dc163a19a980790b$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $924a35192df2ea2b$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $1f0dc626997d3952$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $eebbd3ae47c50fa6$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $f9ac164d05aa576f$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $759208f999b76c31$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $19b04bd35d57a979$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $e7fd639794b10fcc$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $980508b46e20219b$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $aaa5c5424aeaa8c7$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $c28cfd95333ebe36$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $c4d6e1d44f1a243d$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $7c14da7786de1993$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $5d2d12db94985d42$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $95cb955791e92964$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $bc2fc79862fc077e$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $4771491369cc4ed9$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $2f96ad89636ab2bb$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $ff0d6bc09ac14384$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $62de8acbfecfef06$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $ddfa9868cf2ee4a7$exports);
$parcel$exportWildcard($8fcbd16ca8b9fb19$exports, $d626b67f1f81259d$exports);


function $66b91be70e710800$export$4e811121b221213b(customComponents) {
    return {
        ...$8fcbd16ca8b9fb19$exports,
        ...customComponents
    };
}


/** Return the `data-` attributes from the props. */ function $d217534d5ddf9fbd$export$e5ac556b1404ae1e(props) {
    const dataAttributes = {
        "data-mode": props.mode ?? undefined,
        "data-required": "required" in props ? props.required : undefined,
        "data-multiple-months": props.numberOfMonths && props.numberOfMonths > 1 || undefined,
        "data-week-numbers": props.showWeekNumber || undefined,
        "data-broadcast-calendar": props.broadcastCalendar || undefined
    };
    Object.entries(props).forEach(([key, val])=>{
        if (key.startsWith("data-")) dataAttributes[key] = val;
    });
    return dataAttributes;
}



function $020aa468896002d8$export$8f10228aec87fae6() {
    const classNames = {};
    for(const key in 0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952)classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952)[key]] = `rdp-${(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952)[key]}`;
    for(const key in 0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5)classNames[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5)[key]] = `rdp-${(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5)[key]}`;
    for(const key in 0, $17d6b6ed20fdf376$export$2255d92a85eab347)classNames[(0, $17d6b6ed20fdf376$export$2255d92a85eab347)[key]] = `rdp-${(0, $17d6b6ed20fdf376$export$2255d92a85eab347)[key]}`;
    return classNames;
}


var $5c81ddc7aa9d9544$exports = {};
var $bab021368a01da8c$exports = {};

$parcel$export($bab021368a01da8c$exports, "formatCaption", () => $bab021368a01da8c$export$e5fe65a0769e345a);
$parcel$export($bab021368a01da8c$exports, "formatMonthCaption", () => $bab021368a01da8c$export$2606312adebbfe2d);

function $bab021368a01da8c$export$e5fe65a0769e345a(month, options, dateLib) {
    return (dateLib ?? new (0, $d707bba72f7c4bf9$export$87f71ed78036473c)(options)).format(month, "LLLL y");
}
const $bab021368a01da8c$export$2606312adebbfe2d = $bab021368a01da8c$export$e5fe65a0769e345a;


var $b283467b22f8f173$exports = {};

$parcel$export($b283467b22f8f173$exports, "formatDay", () => $b283467b22f8f173$export$a7f242eff11c1345);

function $b283467b22f8f173$export$a7f242eff11c1345(date, options, dateLib) {
    return (dateLib ?? new (0, $d707bba72f7c4bf9$export$87f71ed78036473c)(options)).format(date, "d");
}


var $cfcf9443736cfbc7$exports = {};

$parcel$export($cfcf9443736cfbc7$exports, "formatMonthDropdown", () => $cfcf9443736cfbc7$export$13c80aa65ab48bbb);

function $cfcf9443736cfbc7$export$13c80aa65ab48bbb(month, dateLib = (0, $d707bba72f7c4bf9$export$6575cc37c71cbcd2)) {
    return dateLib.format(month, "LLLL");
}


var $aeac2fd7727d01fd$exports = {};

$parcel$export($aeac2fd7727d01fd$exports, "formatWeekNumber", () => $aeac2fd7727d01fd$export$b3488d9cee3ab7cc);
/**
 * Format the week number.
 *
 * @defaultValue `weekNumber.toLocaleString()` with a leading zero for single-digit numbers
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ function $aeac2fd7727d01fd$export$b3488d9cee3ab7cc(weekNumber) {
    if (weekNumber < 10) return `0${weekNumber.toLocaleString()}`;
    return `${weekNumber.toLocaleString()}`;
}


var $db38aa5fa629c8cd$exports = {};

$parcel$export($db38aa5fa629c8cd$exports, "formatWeekNumberHeader", () => $db38aa5fa629c8cd$export$a6eef91e1d918d7d);
/**
 * Format the week number header.
 *
 * @defaultValue `""`
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */ function $db38aa5fa629c8cd$export$a6eef91e1d918d7d() {
    return ``;
}


var $dc4de6e2fb3881c4$exports = {};

$parcel$export($dc4de6e2fb3881c4$exports, "formatWeekdayName", () => $dc4de6e2fb3881c4$export$3dc11f5aa937dc1f);

function $dc4de6e2fb3881c4$export$3dc11f5aa937dc1f(weekday, options, dateLib) {
    return (dateLib ?? new (0, $d707bba72f7c4bf9$export$87f71ed78036473c)(options)).format(weekday, "cccccc");
}


var $f65f62a4b94b0bc0$exports = {};

$parcel$export($f65f62a4b94b0bc0$exports, "formatYearDropdown", () => $f65f62a4b94b0bc0$export$d3d30ccad02af945);
$parcel$export($f65f62a4b94b0bc0$exports, "formatYearCaption", () => $f65f62a4b94b0bc0$export$8bdcc6d6d3e6799e);

function $f65f62a4b94b0bc0$export$d3d30ccad02af945(year, dateLib = (0, $d707bba72f7c4bf9$export$6575cc37c71cbcd2)) {
    return dateLib.format(year, "yyyy");
}
const $f65f62a4b94b0bc0$export$8bdcc6d6d3e6799e = $f65f62a4b94b0bc0$export$d3d30ccad02af945;


$parcel$exportWildcard($5c81ddc7aa9d9544$exports, $bab021368a01da8c$exports);
$parcel$exportWildcard($5c81ddc7aa9d9544$exports, $b283467b22f8f173$exports);
$parcel$exportWildcard($5c81ddc7aa9d9544$exports, $cfcf9443736cfbc7$exports);
$parcel$exportWildcard($5c81ddc7aa9d9544$exports, $aeac2fd7727d01fd$exports);
$parcel$exportWildcard($5c81ddc7aa9d9544$exports, $db38aa5fa629c8cd$exports);
$parcel$exportWildcard($5c81ddc7aa9d9544$exports, $dc4de6e2fb3881c4$exports);
$parcel$exportWildcard($5c81ddc7aa9d9544$exports, $f65f62a4b94b0bc0$exports);


function $413eed03be118143$export$2eec0f50813b8d07(customFormatters) {
    if (customFormatters?.formatMonthCaption && !customFormatters.formatCaption) customFormatters.formatCaption = customFormatters.formatMonthCaption;
    if (customFormatters?.formatYearCaption && !customFormatters.formatYearDropdown) customFormatters.formatYearDropdown = customFormatters.formatYearCaption;
    return {
        ...$5c81ddc7aa9d9544$exports,
        ...customFormatters
    };
}


/** Return the months to show in the dropdown. */ function $5b8d75d4f32d34c9$export$5365e964dff332d1(displayMonth, navStart, navEnd, formatters, dateLib) {
    const { startOfMonth: startOfMonth, startOfYear: startOfYear, endOfYear: endOfYear, eachMonthOfInterval: eachMonthOfInterval, getMonth: getMonth } = dateLib;
    const months = eachMonthOfInterval({
        start: startOfYear(displayMonth),
        end: endOfYear(displayMonth)
    });
    const options = months.map((month)=>{
        const label = formatters.formatMonthDropdown(month, dateLib);
        const value = getMonth(month);
        const disabled = navStart && month < startOfMonth(navStart) || navEnd && month > startOfMonth(navEnd) || false;
        return {
            value: value,
            label: label,
            disabled: disabled
        };
    });
    return options;
}



function $fdaa54127a6a9911$export$aee95183ff1527a6(dayModifiers, styles = {}, modifiersStyles = {}) {
    let style = {
        ...styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Day]
    };
    Object.entries(dayModifiers).filter(([, active])=>active === true).forEach(([modifier])=>{
        style = {
            ...style,
            ...modifiersStyles?.[modifier]
        };
    });
    return style;
}


/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */ function $10b338a72ddb13f8$export$24c38139da66592d(/** The date library. */ dateLib, /** Use ISOWeek instead of locale/ */ ISOWeek, /** @since 9.4.0 */ broadcastCalendar) {
    const today = dateLib.today();
    const start = broadcastCalendar ? dateLib.startOfBroadcastWeek(today, dateLib) : ISOWeek ? dateLib.startOfISOWeek(today) : dateLib.startOfWeek(today);
    const days = [];
    for(let i = 0; i < 7; i++){
        const day = dateLib.addDays(start, i);
        days.push(day);
    }
    return days;
}


/** Return the years to show in the dropdown. */ function $4e7154fd238c303b$export$9865296f13ed9cac(navStart, navEnd, formatters, dateLib) {
    if (!navStart) return undefined;
    if (!navEnd) return undefined;
    const { startOfYear: startOfYear, endOfYear: endOfYear, addYears: addYears, getYear: getYear, isBefore: isBefore, isSameYear: isSameYear } = dateLib;
    const firstNavYear = startOfYear(navStart);
    const lastNavYear = endOfYear(navEnd);
    const years = [];
    let year = firstNavYear;
    while(isBefore(year, lastNavYear) || isSameYear(year, lastNavYear)){
        years.push(year);
        year = addYears(year, 1);
    }
    return years.map((year)=>{
        const label = formatters.formatYearDropdown(year, dateLib);
        return {
            value: getYear(year),
            label: label,
            disabled: false
        };
    });
}


var $c205bbec0eb1beb7$exports = {};
var $2ad35e6c9f24211c$exports = {};

$parcel$export($2ad35e6c9f24211c$exports, "labelGrid", () => $2ad35e6c9f24211c$export$94d581252e061544);
$parcel$export($2ad35e6c9f24211c$exports, "labelCaption", () => $2ad35e6c9f24211c$export$248d8c0ecff1eff6);

function $2ad35e6c9f24211c$export$94d581252e061544(date, options, dateLib) {
    return (dateLib ?? new (0, $d707bba72f7c4bf9$export$87f71ed78036473c)(options)).format(date, "LLLL y");
}
const $2ad35e6c9f24211c$export$248d8c0ecff1eff6 = $2ad35e6c9f24211c$export$94d581252e061544;


var $3213686abc0ac426$exports = {};

$parcel$export($3213686abc0ac426$exports, "labelGridcell", () => $3213686abc0ac426$export$22b50784bb867133);

function $3213686abc0ac426$export$22b50784bb867133(date, /** The modifiers for the day. */ modifiers, options, dateLib) {
    let label = (dateLib ?? new (0, $d707bba72f7c4bf9$export$87f71ed78036473c)(options)).format(date, "PPPP");
    if (modifiers?.today) label = `Today, ${label}`;
    return label;
}


var $283189a8ee5040e1$exports = {};

$parcel$export($283189a8ee5040e1$exports, "labelDayButton", () => $283189a8ee5040e1$export$a170841bc3306cdb);
$parcel$export($283189a8ee5040e1$exports, "labelDay", () => $283189a8ee5040e1$export$ac7d783bfd9d7b2a);

function $283189a8ee5040e1$export$a170841bc3306cdb(date, /** The modifiers for the day. */ modifiers, options, dateLib) {
    let label = (dateLib ?? new (0, $d707bba72f7c4bf9$export$87f71ed78036473c)(options)).format(date, "PPPP");
    if (modifiers.today) label = `Today, ${label}`;
    if (modifiers.selected) label = `${label}, selected`;
    return label;
}
const $283189a8ee5040e1$export$ac7d783bfd9d7b2a = $283189a8ee5040e1$export$a170841bc3306cdb;


var $ca703a0179b93e8c$exports = {};

$parcel$export($ca703a0179b93e8c$exports, "labelNav", () => $ca703a0179b93e8c$export$49418de60e44a464);
/**
 * The ARIA label for the navigation toolbar.
 *
 * @defaultValue `""`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $ca703a0179b93e8c$export$49418de60e44a464() {
    return "";
}


var $17fff3f8565d005a$exports = {};

$parcel$export($17fff3f8565d005a$exports, "labelMonthDropdown", () => $17fff3f8565d005a$export$c8d98e15d7658afe);
/**
 * The ARIA label for the months dropdown.
 *
 * @defaultValue `"Choose the Month"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $17fff3f8565d005a$export$c8d98e15d7658afe(options) {
    return "Choose the Month";
}


var $e9e2f0c8c877c2ee$exports = {};

$parcel$export($e9e2f0c8c877c2ee$exports, "labelNext", () => $e9e2f0c8c877c2ee$export$6e2010051a8f28c0);
/**
 * The ARIA label for next month button.
 *
 * @defaultValue `"Go to the Next Month"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $e9e2f0c8c877c2ee$export$6e2010051a8f28c0(/** `undefined` where there's no next month to navigate to. */ month) {
    return "Go to the Next Month";
}


var $473afe5f8a64bf16$exports = {};

$parcel$export($473afe5f8a64bf16$exports, "labelPrevious", () => $473afe5f8a64bf16$export$e46be0cf57082a1d);
/**
 * The ARIA label for previous month button.
 *
 * @defaultValue `"Go to the Previous Month"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $473afe5f8a64bf16$export$e46be0cf57082a1d(/** Undefined where there's no previous month to navigate to. */ month) {
    return "Go to the Previous Month";
}


var $ff2ea0c05f363612$exports = {};

$parcel$export($ff2ea0c05f363612$exports, "labelWeekday", () => $ff2ea0c05f363612$export$9006638f42311a57);

function $ff2ea0c05f363612$export$9006638f42311a57(date, options, dateLib) {
    return (dateLib ?? new (0, $d707bba72f7c4bf9$export$87f71ed78036473c)(options)).format(date, "cccc");
}


var $ad145d46774e2514$exports = {};

$parcel$export($ad145d46774e2514$exports, "labelWeekNumber", () => $ad145d46774e2514$export$dbe69561a3e50132);
/**
 * The ARIA label for the week number cell (the first cell in the row).
 *
 * @defaultValue `Week ${weekNumber}`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $ad145d46774e2514$export$dbe69561a3e50132(weekNumber, options) {
    return `Week ${weekNumber}`;
}


var $eed1bf3449f82976$exports = {};

$parcel$export($eed1bf3449f82976$exports, "labelWeekNumberHeader", () => $eed1bf3449f82976$export$6d49daa26397861);
/**
 * The ARIA label for the week number header element.
 *
 * @defaultValue `"Week Number"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $eed1bf3449f82976$export$6d49daa26397861(options) {
    return "Week Number";
}


var $6b70dddd428bd14b$exports = {};

$parcel$export($6b70dddd428bd14b$exports, "labelYearDropdown", () => $6b70dddd428bd14b$export$5e631ce1249f481f);
/**
 * The ARIA label for the years dropdown.
 *
 * @defaultValue `"Choose the Year"`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */ function $6b70dddd428bd14b$export$5e631ce1249f481f(options) {
    return "Choose the Year";
}


$parcel$exportWildcard($c205bbec0eb1beb7$exports, $2ad35e6c9f24211c$exports);
$parcel$exportWildcard($c205bbec0eb1beb7$exports, $3213686abc0ac426$exports);
$parcel$exportWildcard($c205bbec0eb1beb7$exports, $283189a8ee5040e1$exports);
$parcel$exportWildcard($c205bbec0eb1beb7$exports, $ca703a0179b93e8c$exports);
$parcel$exportWildcard($c205bbec0eb1beb7$exports, $17fff3f8565d005a$exports);
$parcel$exportWildcard($c205bbec0eb1beb7$exports, $e9e2f0c8c877c2ee$exports);
$parcel$exportWildcard($c205bbec0eb1beb7$exports, $473afe5f8a64bf16$exports);
$parcel$exportWildcard($c205bbec0eb1beb7$exports, $ff2ea0c05f363612$exports);
$parcel$exportWildcard($c205bbec0eb1beb7$exports, $ad145d46774e2514$exports);
$parcel$exportWildcard($c205bbec0eb1beb7$exports, $eed1bf3449f82976$exports);
$parcel$exportWildcard($c205bbec0eb1beb7$exports, $6b70dddd428bd14b$exports);



var $acw62 = parcelRequire("acw62");
/** Return all the dates to display in the calendar. */ function $25085ae68ab97d15$export$dd09f40777b29234(displayMonths, maxDate, props, dateLib) {
    const firstMonth = displayMonths[0];
    const lastMonth = displayMonths[displayMonths.length - 1];
    const { ISOWeek: ISOWeek, fixedWeeks: fixedWeeks, broadcastCalendar: broadcastCalendar } = props ?? {};
    const { addDays: addDays, differenceInCalendarDays: differenceInCalendarDays, differenceInCalendarMonths: differenceInCalendarMonths, endOfBroadcastWeek: endOfBroadcastWeek, endOfISOWeek: endOfISOWeek, endOfMonth: endOfMonth, endOfWeek: endOfWeek, isAfter: isAfter, startOfBroadcastWeek: startOfBroadcastWeek, startOfISOWeek: startOfISOWeek, startOfWeek: startOfWeek } = dateLib;
    const startWeekFirstDate = broadcastCalendar ? startOfBroadcastWeek(firstMonth, dateLib) : ISOWeek ? startOfISOWeek(firstMonth) : startOfWeek(firstMonth);
    const endWeekLastDate = broadcastCalendar ? endOfBroadcastWeek(lastMonth, dateLib) : ISOWeek ? endOfISOWeek(endOfMonth(lastMonth)) : endOfWeek(endOfMonth(lastMonth));
    const nOfDays = differenceInCalendarDays(endWeekLastDate, startWeekFirstDate);
    const nOfMonths = differenceInCalendarMonths(lastMonth, firstMonth) + 1;
    const dates = [];
    for(let i = 0; i <= nOfDays; i++){
        const date = addDays(startWeekFirstDate, i);
        if (maxDate && isAfter(date, maxDate)) break;
        dates.push(date);
    }
    // If fixed weeks is enabled, add the extra dates to the array
    const nrOfDaysWithFixedWeeks = broadcastCalendar ? 35 : 42;
    const extraDates = nrOfDaysWithFixedWeeks * nOfMonths;
    if (fixedWeeks && dates.length < extraDates) {
        const daysToAdd = extraDates - dates.length;
        for(let i = 0; i < daysToAdd; i++){
            const date = addDays(dates[dates.length - 1], 1);
            dates.push(date);
        }
    }
    return dates;
}


/**
 * Returns all the days belonging to the calendar by merging the days in the
 * weeks for each month.
 */ function $28a35065b0e76fd8$export$5f84d4e06c0693c4(calendarMonths) {
    const initialDays = [];
    return calendarMonths.reduce((days, month)=>{
        const initialDays = [];
        const weekDays = month.weeks.reduce((weekDays, week)=>{
            return [
                ...weekDays,
                ...week.days
            ];
        }, initialDays);
        return [
            ...days,
            ...weekDays
        ];
    }, initialDays);
}


function $fc4d3f50531f0a37$export$821489a553cc3c7a(firstDisplayedMonth, calendarEndMonth, props, dateLib) {
    const { numberOfMonths: numberOfMonths = 1 } = props;
    const months = [];
    for(let i = 0; i < numberOfMonths; i++){
        const month = dateLib.addMonths(firstDisplayedMonth, i);
        if (calendarEndMonth && month > calendarEndMonth) break;
        months.push(month);
    }
    return months;
}


/** Return the start month based on the props passed to DayPicker. */ function $be175be54fb7af83$export$8093856c9cba2ab4(props, dateLib) {
    const { month: month, defaultMonth: defaultMonth, today: today = dateLib.today(), numberOfMonths: numberOfMonths = 1, endMonth: endMonth, startMonth: startMonth } = props;
    let initialMonth = month || defaultMonth || today;
    const { differenceInCalendarMonths: differenceInCalendarMonths, addMonths: addMonths, startOfMonth: startOfMonth } = dateLib;
    // Fix the initialMonth if is after the endMonth
    if (endMonth && differenceInCalendarMonths(endMonth, initialMonth) < 0) {
        const offset = -1 * (numberOfMonths - 1);
        initialMonth = addMonths(endMonth, offset);
    }
    // Fix the initialMonth if is before the startMonth
    if (startMonth && differenceInCalendarMonths(initialMonth, startMonth) < 0) initialMonth = startMonth;
    return startOfMonth(initialMonth);
}



class $b4d83bf9aea015ce$export$25888c98befaa9a2 {
    constructor(date, displayMonth, dateLib = (0, $d707bba72f7c4bf9$export$6575cc37c71cbcd2)){
        this.date = date;
        this.displayMonth = displayMonth;
        this.outside = Boolean(displayMonth && !dateLib.isSameMonth(date, displayMonth));
        this.dateLib = dateLib;
    }
    /**
     * Check if the day is the same as the given day: considering if it is in the
     * same display month.
     */ isEqualTo(day) {
        return this.dateLib.isSameDay(day.date, this.date) && this.dateLib.isSameMonth(day.displayMonth, this.displayMonth);
    }
}


/** Represent a month in a calendar year. Contains the weeks within the month. */ class $adaa664bddfaf7a7$export$26e2752316b9a375 {
    constructor(month, weeks){
        this.date = month;
        this.weeks = weeks;
    }
}


/** Represent a week in a calendar month. */ class $7d7fbf861e1ae1a7$export$adf10f8fbb88fe03 {
    constructor(weekNumber, days){
        this.days = days;
        this.weekNumber = weekNumber;
    }
}





function $f1b46a73b499e849$export$ab152e6ff2cc840e(/** The months (as dates) to display in the calendar. */ displayMonths, /** The dates to display in the calendar. */ dates, /** Options from the props context. */ props, dateLib) {
    const { addDays: addDays, endOfBroadcastWeek: endOfBroadcastWeek, endOfISOWeek: endOfISOWeek, endOfMonth: endOfMonth, endOfWeek: endOfWeek, getISOWeek: getISOWeek, getWeek: getWeek, startOfBroadcastWeek: startOfBroadcastWeek, startOfISOWeek: startOfISOWeek, startOfWeek: startOfWeek } = dateLib;
    const dayPickerMonths = displayMonths.reduce((months, month)=>{
        const firstDateOfFirstWeek = props.broadcastCalendar ? startOfBroadcastWeek(month, dateLib) : props.ISOWeek ? startOfISOWeek(month) : startOfWeek(month);
        const lastDateOfLastWeek = props.broadcastCalendar ? endOfBroadcastWeek(month, dateLib) : props.ISOWeek ? endOfISOWeek(endOfMonth(month)) : endOfWeek(endOfMonth(month));
        /** The dates to display in the month. */ const monthDates = dates.filter((date)=>{
            return date >= firstDateOfFirstWeek && date <= lastDateOfLastWeek;
        });
        const nrOfDaysWithFixedWeeks = props.broadcastCalendar ? 35 : 42;
        if (props.fixedWeeks && monthDates.length < nrOfDaysWithFixedWeeks) {
            const extraDates = dates.filter((date)=>{
                const daysToAdd = nrOfDaysWithFixedWeeks - monthDates.length;
                return date > lastDateOfLastWeek && date <= addDays(lastDateOfLastWeek, daysToAdd);
            });
            monthDates.push(...extraDates);
        }
        const weeks = monthDates.reduce((weeks, date)=>{
            const weekNumber = props.ISOWeek ? getISOWeek(date) : getWeek(date);
            const week = weeks.find((week)=>week.weekNumber === weekNumber);
            const day = new (0, $b4d83bf9aea015ce$export$25888c98befaa9a2)(date, month, dateLib);
            if (!week) weeks.push(new (0, $7d7fbf861e1ae1a7$export$adf10f8fbb88fe03)(weekNumber, [
                day
            ]));
            else week.days.push(day);
            return weeks;
        }, []);
        const dayPickerMonth = new (0, $adaa664bddfaf7a7$export$26e2752316b9a375)(month, weeks);
        months.push(dayPickerMonth);
        return months;
    }, []);
    if (!props.reverseMonths) return dayPickerMonths;
    else return dayPickerMonths.reverse();
}


/** Return the start and end months for the calendar navigation. */ function $c484fc703039ad0f$export$b6d22bad34acd54e(props, dateLib) {
    let { startMonth: startMonth, endMonth: endMonth } = props;
    const { startOfYear: startOfYear, startOfDay: startOfDay, startOfMonth: startOfMonth, endOfMonth: endOfMonth, addYears: addYears, endOfYear: endOfYear, newDate: newDate, today: today } = dateLib;
    // Handle deprecated code
    const { fromYear: fromYear, toYear: toYear, fromMonth: fromMonth, toMonth: toMonth } = props;
    if (!startMonth && fromMonth) startMonth = fromMonth;
    if (!startMonth && fromYear) startMonth = dateLib.newDate(fromYear, 0, 1);
    if (!endMonth && toMonth) endMonth = toMonth;
    if (!endMonth && toYear) endMonth = newDate(toYear, 11, 31);
    const hasYearDropdown = props.captionLayout === "dropdown" || props.captionLayout === "dropdown-years";
    if (startMonth) startMonth = startOfMonth(startMonth);
    else if (fromYear) startMonth = newDate(fromYear, 0, 1);
    else if (!startMonth && hasYearDropdown) startMonth = startOfYear(addYears(props.today ?? today(), -100));
    if (endMonth) endMonth = endOfMonth(endMonth);
    else if (toYear) endMonth = newDate(toYear, 11, 31);
    else if (!endMonth && hasYearDropdown) endMonth = endOfYear(props.today ?? today());
    return [
        startMonth ? startOfDay(startMonth) : startMonth,
        endMonth ? startOfDay(endMonth) : endMonth
    ];
}


/**
 * Return the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - If after the `calendarEndMonth` range, is `undefined`;
 * - If the navigation is paged , is the number of months displayed ahead.
 */ function $6e0654bef0a9bceb$export$336804f18a0452c1(firstDisplayedMonth, calendarEndMonth, options, dateLib) {
    if (options.disableNavigation) return undefined;
    const { pagedNavigation: pagedNavigation, numberOfMonths: numberOfMonths = 1 } = options;
    const { startOfMonth: startOfMonth, addMonths: addMonths, differenceInCalendarMonths: differenceInCalendarMonths } = dateLib;
    const offset = pagedNavigation ? numberOfMonths : 1;
    const month = startOfMonth(firstDisplayedMonth);
    if (!calendarEndMonth) return addMonths(month, offset);
    const monthsDiff = differenceInCalendarMonths(calendarEndMonth, firstDisplayedMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    // Jump forward as the number of months when paged navigation
    return addMonths(month, offset);
}


/**
 * Return the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - If before the `calendarStartMonth` date, is `undefined`;
 * - If the navigation is paged, is the number of months displayed before.
 */ function $51d1a73ad512ea06$export$dee316666c2ef75b(firstDisplayedMonth, calendarStartMonth, options, dateLib) {
    if (options.disableNavigation) return undefined;
    const { pagedNavigation: pagedNavigation, numberOfMonths: numberOfMonths } = options;
    const { startOfMonth: startOfMonth, addMonths: addMonths, differenceInCalendarMonths: differenceInCalendarMonths } = dateLib;
    const offset = pagedNavigation ? numberOfMonths ?? 1 : 1;
    const month = startOfMonth(firstDisplayedMonth);
    if (!calendarStartMonth) return addMonths(month, -offset);
    const monthsDiff = differenceInCalendarMonths(month, calendarStartMonth);
    if (monthsDiff <= 0) return undefined;
    return addMonths(month, -offset);
}


/** Returns an array of calendar weeks from an array of calendar months. */ function $375ef704020f7eeb$export$6bf1a256dbbcec82(months) {
    const initialWeeks = [];
    return months.reduce((weeks, month)=>{
        return [
            ...weeks,
            ...month.weeks
        ];
    }, initialWeeks);
}



var $acw62 = parcelRequire("acw62");
function $35bced7f7d2c59c6$export$ac06ac6808815c7c(defaultValue, controlledValue) {
    const [uncontrolledValue, setValue] = (0, $acw62.useState)(defaultValue);
    const value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}


function $f7397476098dba14$export$3ee915f8151bd4f1(props, dateLib) {
    const [navStart, navEnd] = (0, $c484fc703039ad0f$export$b6d22bad34acd54e)(props, dateLib);
    const { startOfMonth: startOfMonth, endOfMonth: endOfMonth } = dateLib;
    const initialMonth = (0, $be175be54fb7af83$export$8093856c9cba2ab4)(props, dateLib);
    const [firstMonth, setFirstMonth] = (0, $35bced7f7d2c59c6$export$ac06ac6808815c7c)(initialMonth, // initialMonth is always computed from props.month if provided
    props.month ? initialMonth : undefined);
    (0, $acw62.useEffect)(()=>{
        const newInitialMonth = (0, $be175be54fb7af83$export$8093856c9cba2ab4)(props, dateLib);
        setFirstMonth(newInitialMonth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.timeZone
    ]);
    /** The months displayed in the calendar. */ const displayMonths = (0, $fc4d3f50531f0a37$export$821489a553cc3c7a)(firstMonth, navEnd, props, dateLib);
    /** The dates displayed in the calendar. */ const dates = (0, $25085ae68ab97d15$export$dd09f40777b29234)(displayMonths, props.endMonth ? endOfMonth(props.endMonth) : undefined, props, dateLib);
    /** The Months displayed in the calendar. */ const months = (0, $f1b46a73b499e849$export$ab152e6ff2cc840e)(displayMonths, dates, props, dateLib);
    /** The Weeks displayed in the calendar. */ const weeks = (0, $375ef704020f7eeb$export$6bf1a256dbbcec82)(months);
    /** The Days displayed in the calendar. */ const days = (0, $28a35065b0e76fd8$export$5f84d4e06c0693c4)(months);
    const previousMonth = (0, $51d1a73ad512ea06$export$dee316666c2ef75b)(firstMonth, navStart, props, dateLib);
    const nextMonth = (0, $6e0654bef0a9bceb$export$336804f18a0452c1)(firstMonth, navEnd, props, dateLib);
    const { disableNavigation: disableNavigation, onMonthChange: onMonthChange } = props;
    const isDayInCalendar = (day)=>weeks.some((week)=>week.days.some((d)=>d.isEqualTo(day)));
    const goToMonth = (date)=>{
        if (disableNavigation) return;
        let newMonth = startOfMonth(date);
        // if month is before start, use the first month instead
        if (navStart && newMonth < startOfMonth(navStart)) newMonth = startOfMonth(navStart);
        // if month is after endMonth, use the last month instead
        if (navEnd && newMonth > startOfMonth(navEnd)) newMonth = startOfMonth(navEnd);
        setFirstMonth(newMonth);
        onMonthChange?.(newMonth);
    };
    const goToDay = (day)=>{
        // is this check necessary?
        if (isDayInCalendar(day)) return;
        goToMonth(day.date);
    };
    const calendar = {
        months: months,
        weeks: weeks,
        days: days,
        navStart: navStart,
        navEnd: navEnd,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        goToMonth: goToMonth,
        goToDay: goToDay
    };
    return calendar;
}




var $acw62 = parcelRequire("acw62");

function $50c3d9c4fc10c8d4$export$d1565046db0d2be9(days, getModifiers, isSelected, lastFocused) {
    let focusTarget;
    let index = 0;
    let found = false;
    while(index < days.length && !found){
        const day = days[index];
        const modifiers = getModifiers(day);
        if (!modifiers[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).disabled] && !modifiers[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).hidden] && !modifiers[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).outside]) {
            if (modifiers[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).focused]) {
                focusTarget = day;
                found = true;
            } else if (lastFocused?.isEqualTo(day)) {
                focusTarget = day;
                found = true;
            } else if (isSelected(day.date)) {
                focusTarget = day;
                found = true;
            } else if (modifiers[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).today]) {
                focusTarget = day;
                found = true;
            }
        }
        index++;
    }
    if (!focusTarget) // return the first day that is focusable
    focusTarget = days.find((day)=>{
        const m = getModifiers(day);
        return !m[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).disabled] && !m[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).hidden] && !m[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).outside];
    });
    return focusTarget;
}





function $0a8b367a8cfd1222$export$ea4b24aaa0e5da4a(range, date, /** If `true`, the ends of the range are excluded. */ excludeEnds = false, dateLib = (0, $d707bba72f7c4bf9$export$6575cc37c71cbcd2)) {
    let { from: from, to: to } = range;
    const { differenceInCalendarDays: differenceInCalendarDays, isSameDay: isSameDay } = dateLib;
    if (from && to) {
        const isRangeInverted = differenceInCalendarDays(to, from) < 0;
        if (isRangeInverted) [from, to] = [
            to,
            from
        ];
        const isInRange = differenceInCalendarDays(date, from) >= (excludeEnds ? 1 : 0) && differenceInCalendarDays(to, date) >= (excludeEnds ? 1 : 0);
        return isInRange;
    }
    if (!excludeEnds && to) return isSameDay(to, date);
    if (!excludeEnds && from) return isSameDay(from, date);
    return false;
}
const $0a8b367a8cfd1222$export$5eefd315c24a8505 = (range, date)=>$0a8b367a8cfd1222$export$ea4b24aaa0e5da4a(range, date, false, (0, $d707bba72f7c4bf9$export$6575cc37c71cbcd2));


/**
 * Returns true if `matcher` is of type {@link DateInterval}.
 *
 * @group Utilities
 */ function $b3cc505c5172e2c3$export$654311eaff47f3cd(matcher) {
    return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
function $b3cc505c5172e2c3$export$dd455b9c98fea187(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
function $b3cc505c5172e2c3$export$4760905e07020cd4(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
function $b3cc505c5172e2c3$export$a3bef2c4e855ef4e(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
function $b3cc505c5172e2c3$export$483c833837970a3(value) {
    return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
function $b3cc505c5172e2c3$export$1586b56a557d6c60(value, dateLib) {
    return Array.isArray(value) && value.every(dateLib.isDate);
}


function $799d56c37ac5f406$export$9c6809d9e0449c2e(date, matchers, dateLib = (0, $d707bba72f7c4bf9$export$6575cc37c71cbcd2)) {
    const matchersArr = !Array.isArray(matchers) ? [
        matchers
    ] : matchers;
    const { isSameDay: isSameDay, differenceInCalendarDays: differenceInCalendarDays, isAfter: isAfter } = dateLib;
    return matchersArr.some((matcher)=>{
        if (typeof matcher === "boolean") return matcher;
        if (dateLib.isDate(matcher)) return isSameDay(date, matcher);
        if ((0, $b3cc505c5172e2c3$export$1586b56a557d6c60)(matcher, dateLib)) return matcher.includes(date);
        if ((0, $b3cc505c5172e2c3$export$dd455b9c98fea187)(matcher)) return (0, $0a8b367a8cfd1222$export$ea4b24aaa0e5da4a)(matcher, date, false, dateLib);
        if ((0, $b3cc505c5172e2c3$export$483c833837970a3)(matcher)) {
            if (!Array.isArray(matcher.dayOfWeek)) return matcher.dayOfWeek === date.getDay();
            return matcher.dayOfWeek.includes(date.getDay());
        }
        if ((0, $b3cc505c5172e2c3$export$654311eaff47f3cd)(matcher)) {
            const diffBefore = differenceInCalendarDays(matcher.before, date);
            const diffAfter = differenceInCalendarDays(matcher.after, date);
            const isDayBefore = diffBefore > 0;
            const isDayAfter = diffAfter < 0;
            const isClosedInterval = isAfter(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if ((0, $b3cc505c5172e2c3$export$4760905e07020cd4)(matcher)) return differenceInCalendarDays(date, matcher.after) > 0;
        if ((0, $b3cc505c5172e2c3$export$a3bef2c4e855ef4e)(matcher)) return differenceInCalendarDays(matcher.before, date) > 0;
        if (typeof matcher === "function") return matcher(date);
        return false;
    });
}
const $799d56c37ac5f406$export$b74c33566721f70f = $799d56c37ac5f406$export$9c6809d9e0449c2e;


/** Return the next date that should be focused. */ function $84b676d5d107a16b$export$8b23062bff9cc216(moveBy, moveDir, refDate, navStart, navEnd, props, dateLib) {
    const { ISOWeek: ISOWeek, broadcastCalendar: broadcastCalendar } = props;
    const { addDays: addDays, addMonths: addMonths, addWeeks: addWeeks, addYears: addYears, endOfBroadcastWeek: endOfBroadcastWeek, endOfISOWeek: endOfISOWeek, endOfWeek: endOfWeek, max: max, min: min, startOfBroadcastWeek: startOfBroadcastWeek, startOfISOWeek: startOfISOWeek, startOfWeek: startOfWeek } = dateLib;
    const moveFns = {
        day: addDays,
        week: addWeeks,
        month: addMonths,
        year: addYears,
        startOfWeek: (date)=>broadcastCalendar ? startOfBroadcastWeek(date, dateLib) : ISOWeek ? startOfISOWeek(date) : startOfWeek(date),
        endOfWeek: (date)=>broadcastCalendar ? endOfBroadcastWeek(date, dateLib) : ISOWeek ? endOfISOWeek(date) : endOfWeek(date)
    };
    let focusableDate = moveFns[moveBy](refDate, moveDir === "after" ? 1 : -1);
    if (moveDir === "before" && navStart) focusableDate = max([
        navStart,
        focusableDate
    ]);
    else if (moveDir === "after" && navEnd) focusableDate = min([
        navEnd,
        focusableDate
    ]);
    return focusableDate;
}


function $caaae2a01844e42c$export$4465a4fc56223a7(moveBy, moveDir, /** The date that is currently focused. */ refDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt = 0) {
    if (attempt > 365) // Limit the recursion to 365 attempts
    return undefined;
    const focusableDate = (0, $84b676d5d107a16b$export$8b23062bff9cc216)(moveBy, moveDir, refDay.date, calendarStartMonth, calendarEndMonth, props, dateLib);
    const isDisabled = Boolean(props.disabled && (0, $799d56c37ac5f406$export$9c6809d9e0449c2e)(focusableDate, props.disabled, dateLib));
    const isHidden = Boolean(props.hidden && (0, $799d56c37ac5f406$export$9c6809d9e0449c2e)(focusableDate, props.hidden, dateLib));
    const targetMonth = focusableDate;
    const focusDay = new (0, $b4d83bf9aea015ce$export$25888c98befaa9a2)(focusableDate, targetMonth, dateLib);
    if (!isDisabled && !isHidden) return focusDay;
    // Recursively attempt to find the next focusable date
    return $caaae2a01844e42c$export$4465a4fc56223a7(moveBy, moveDir, focusDay, calendarStartMonth, calendarEndMonth, props, dateLib, attempt + 1);
}


function $1671297566d8c9f1$export$f8168d8dd8fd66e6(props, calendar, getModifiers, isSelected, dateLib) {
    const { autoFocus: autoFocus } = props;
    const [lastFocused, setLastFocused] = (0, $acw62.useState)();
    const focusTarget = (0, $50c3d9c4fc10c8d4$export$d1565046db0d2be9)(calendar.days, getModifiers, isSelected || (()=>false), lastFocused);
    const [focusedDay, setFocused] = (0, $acw62.useState)(autoFocus ? focusTarget : undefined);
    const blur = ()=>{
        setLastFocused(focusedDay);
        setFocused(undefined);
    };
    const moveFocus = (moveBy, moveDir)=>{
        if (!focusedDay) return;
        const nextFocus = (0, $caaae2a01844e42c$export$4465a4fc56223a7)(moveBy, moveDir, focusedDay, calendar.navStart, calendar.navEnd, props, dateLib);
        if (!nextFocus) return;
        calendar.goToDay(nextFocus);
        setFocused(nextFocus);
    };
    const isFocusTarget = (day)=>{
        return Boolean(focusTarget?.isEqualTo(day));
    };
    const useFocus = {
        isFocusTarget: isFocusTarget,
        setFocused: setFocused,
        focused: focusedDay,
        blur: blur,
        moveFocus: moveFocus
    };
    return useFocus;
}




function $3378876541ba48f2$export$1dd4f6d1180e527f(days, props, dateLib) {
    const { disabled: disabled, hidden: hidden, modifiers: modifiers, showOutsideDays: showOutsideDays, broadcastCalendar: broadcastCalendar, today: today } = props;
    const { isSameDay: isSameDay, isSameMonth: isSameMonth, startOfMonth: startOfMonth, isBefore: isBefore, endOfMonth: endOfMonth, isAfter: isAfter } = dateLib;
    const startMonth = props.startMonth && startOfMonth(props.startMonth);
    const endMonth = props.endMonth && endOfMonth(props.endMonth);
    const internalModifiersMap = {
        [(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).focused]: [],
        [(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).outside]: [],
        [(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).disabled]: [],
        [(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).hidden]: [],
        [(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).today]: []
    };
    const customModifiersMap = {};
    for (const day of days){
        const { date: date, displayMonth: displayMonth } = day;
        const isOutside = Boolean(displayMonth && !isSameMonth(date, displayMonth));
        const isBeforeStartMonth = Boolean(startMonth && isBefore(date, startMonth));
        const isAfterEndMonth = Boolean(endMonth && isAfter(date, endMonth));
        const isDisabled = Boolean(disabled && (0, $799d56c37ac5f406$export$9c6809d9e0449c2e)(date, disabled, dateLib));
        const isHidden = Boolean(hidden && (0, $799d56c37ac5f406$export$9c6809d9e0449c2e)(date, hidden, dateLib)) || isBeforeStartMonth || isAfterEndMonth || // Broadcast calendar will show outside days as default
        !broadcastCalendar && !showOutsideDays && isOutside || broadcastCalendar && showOutsideDays === false && isOutside;
        const isToday = isSameDay(date, today ?? dateLib.today());
        if (isOutside) internalModifiersMap.outside.push(day);
        if (isDisabled) internalModifiersMap.disabled.push(day);
        if (isHidden) internalModifiersMap.hidden.push(day);
        if (isToday) internalModifiersMap.today.push(day);
        // Add custom modifiers
        if (modifiers) Object.keys(modifiers).forEach((name)=>{
            const modifierValue = modifiers?.[name];
            const isMatch = modifierValue ? (0, $799d56c37ac5f406$export$9c6809d9e0449c2e)(date, modifierValue, dateLib) : false;
            if (!isMatch) return;
            if (customModifiersMap[name]) customModifiersMap[name].push(day);
            else customModifiersMap[name] = [
                day
            ];
        });
    }
    return (day)=>{
        // Initialize all the modifiers to false
        const dayFlags = {
            [(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).focused]: false,
            [(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).disabled]: false,
            [(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).hidden]: false,
            [(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).outside]: false,
            [(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).today]: false
        };
        const customModifiers = {};
        // Find the modifiers for the given day
        for(const name in internalModifiersMap){
            const days = internalModifiersMap[name];
            dayFlags[name] = days.some((d)=>d === day);
        }
        for(const name in customModifiersMap)customModifiers[name] = customModifiersMap[name].some((d)=>d === day);
        return {
            ...dayFlags,
            // custom modifiers should override all the previous ones
            ...customModifiers
        };
    };
}



function $28a997ccaef912cf$export$fe656f71238ed465(props, dateLib) {
    const { selected: initiallySelected, required: required, onSelect: onSelect } = props;
    const [internallySelected, setSelected] = (0, $35bced7f7d2c59c6$export$ac06ac6808815c7c)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const { isSameDay: isSameDay } = dateLib;
    const isSelected = (date)=>{
        return selected?.some((d)=>isSameDay(d, date)) ?? false;
    };
    const { min: min, max: max } = props;
    const select = (triggerDate, modifiers, e)=>{
        let newDates = [
            ...selected ?? []
        ];
        if (isSelected(triggerDate)) {
            if (selected?.length === min) // Min value reached, do nothing
            return;
            if (required && selected?.length === 1) // Required value already selected do nothing
            return;
            newDates = selected?.filter((d)=>!isSameDay(d, triggerDate));
        } else if (selected?.length === max) // Max value reached, reset the selection to date
        newDates = [
            triggerDate
        ];
        else // Add the date to the selection
        newDates = [
            ...newDates,
            triggerDate
        ];
        if (!onSelect) setSelected(newDates);
        onSelect?.(newDates, triggerDate, modifiers, e);
        return newDates;
    };
    return {
        selected: selected,
        select: select,
        isSelected: isSelected
    };
}




function $4c92f1711c67dd51$export$27ef550b4e6acc0c(/** The date to add to the range. */ date, /** The range where to add `date`. */ initialRange, min = 0, max = 0, required = false, /** @ignore */ dateLib = (0, $d707bba72f7c4bf9$export$6575cc37c71cbcd2)) {
    const { from: from, to: to } = initialRange || {};
    const { isSameDay: isSameDay, isAfter: isAfter, isBefore: isBefore } = dateLib;
    let range;
    if (!from && !to) // the range is empty, add the date
    range = {
        from: date,
        to: min > 0 ? undefined : date
    };
    else if (from && !to) {
        // adding date to an incomplete range
        if (isSameDay(from, date)) {
            // adding a date equal to the start of the range
            if (required) range = {
                from: from,
                to: undefined
            };
            else range = undefined;
        } else if (isBefore(date, from)) // adding a date before the start of the range
        range = {
            from: date,
            to: from
        };
        else // adding a date after the start of the range
        range = {
            from: from,
            to: date
        };
    } else if (from && to) {
        // adding date to a complete range
        if (isSameDay(from, date) && isSameDay(to, date)) {
            // adding a date that is equal to both start and end of the range
            if (required) range = {
                from: from,
                to: to
            };
            else range = undefined;
        } else if (isSameDay(from, date)) // adding a date equal to the the start of the range
        range = {
            from: from,
            to: min > 0 ? undefined : date
        };
        else if (isSameDay(to, date)) // adding a dare equal to the end of the range
        range = {
            from: date,
            to: min > 0 ? undefined : date
        };
        else if (isBefore(date, from)) // adding a date before the start of the range
        range = {
            from: date,
            to: to
        };
        else if (isAfter(date, from)) // adding a date after the start of the range
        range = {
            from: from,
            to: date
        };
        else if (isAfter(date, to)) // adding a date after the end of the range
        range = {
            from: from,
            to: date
        };
        else throw new Error("Invalid range");
    }
    // check for min / max
    if (range?.from && range?.to) {
        const diff = dateLib.differenceInCalendarDays(range.to, range.from);
        if (max > 0 && diff > max) range = {
            from: date,
            to: undefined
        };
        else if (min > 1 && diff < min) range = {
            from: date,
            to: undefined
        };
    }
    return range;
}




function $2a67a4fa5c304fe2$export$fbe8c32778db3e4c(range, dayOfWeek, dateLib = (0, $d707bba72f7c4bf9$export$6575cc37c71cbcd2)) {
    const dayOfWeekArr = !Array.isArray(dayOfWeek) ? [
        dayOfWeek
    ] : dayOfWeek;
    let date = range.from;
    const totalDays = dateLib.differenceInCalendarDays(range.to, range.from);
    // iterate at maximum one week or the total days if the range is shorter than one week
    const totalDaysLimit = Math.min(totalDays, 6);
    for(let i = 0; i <= totalDaysLimit; i++){
        if (dayOfWeekArr.includes(date.getDay())) return true;
        date = dateLib.addDays(date, 1);
    }
    return false;
}








function $10c4c225d791366f$export$255adf1d7bd005ac(rangeLeft, rangeRight, dateLib = (0, $d707bba72f7c4bf9$export$6575cc37c71cbcd2)) {
    return (0, $0a8b367a8cfd1222$export$ea4b24aaa0e5da4a)(rangeLeft, rangeRight.from, false, dateLib) || (0, $0a8b367a8cfd1222$export$ea4b24aaa0e5da4a)(rangeLeft, rangeRight.to, false, dateLib) || (0, $0a8b367a8cfd1222$export$ea4b24aaa0e5da4a)(rangeRight, rangeLeft.from, false, dateLib) || (0, $0a8b367a8cfd1222$export$ea4b24aaa0e5da4a)(rangeRight, rangeLeft.to, false, dateLib);
}



function $79ce039b462c7209$export$129e86809f92e546(range, modifiers, dateLib = (0, $d707bba72f7c4bf9$export$6575cc37c71cbcd2)) {
    const matchers = Array.isArray(modifiers) ? modifiers : [
        modifiers
    ];
    // Defer function matchers evaluation as they are the least performant.
    const nonFunctionMatchers = matchers.filter((matcher)=>typeof matcher !== "function");
    const nonFunctionMatchersResult = nonFunctionMatchers.some((matcher)=>{
        if (typeof matcher === "boolean") return matcher;
        if (dateLib.isDate(matcher)) return (0, $0a8b367a8cfd1222$export$ea4b24aaa0e5da4a)(range, matcher, false, dateLib);
        if ((0, $b3cc505c5172e2c3$export$1586b56a557d6c60)(matcher, dateLib)) return matcher.some((date)=>(0, $0a8b367a8cfd1222$export$ea4b24aaa0e5da4a)(range, date, false, dateLib));
        if ((0, $b3cc505c5172e2c3$export$dd455b9c98fea187)(matcher)) {
            if (matcher.from && matcher.to) return (0, $10c4c225d791366f$export$255adf1d7bd005ac)(range, {
                from: matcher.from,
                to: matcher.to
            }, dateLib);
            return false;
        }
        if ((0, $b3cc505c5172e2c3$export$483c833837970a3)(matcher)) return (0, $2a67a4fa5c304fe2$export$fbe8c32778db3e4c)(range, matcher.dayOfWeek, dateLib);
        if ((0, $b3cc505c5172e2c3$export$654311eaff47f3cd)(matcher)) {
            const isClosedInterval = dateLib.isAfter(matcher.before, matcher.after);
            if (isClosedInterval) return (0, $10c4c225d791366f$export$255adf1d7bd005ac)(range, {
                from: dateLib.addDays(matcher.after, 1),
                to: dateLib.addDays(matcher.before, -1)
            }, dateLib);
            return (0, $799d56c37ac5f406$export$9c6809d9e0449c2e)(range.from, matcher, dateLib) || (0, $799d56c37ac5f406$export$9c6809d9e0449c2e)(range.to, matcher, dateLib);
        }
        if ((0, $b3cc505c5172e2c3$export$4760905e07020cd4)(matcher) || (0, $b3cc505c5172e2c3$export$a3bef2c4e855ef4e)(matcher)) return (0, $799d56c37ac5f406$export$9c6809d9e0449c2e)(range.from, matcher, dateLib) || (0, $799d56c37ac5f406$export$9c6809d9e0449c2e)(range.to, matcher, dateLib);
        return false;
    });
    if (nonFunctionMatchersResult) return true;
    const functionMatchers = matchers.filter((matcher)=>typeof matcher === "function");
    if (functionMatchers.length) {
        let date = range.from;
        const totalDays = dateLib.differenceInCalendarDays(range.to, range.from);
        for(let i = 0; i <= totalDays; i++){
            if (functionMatchers.some((matcher)=>matcher(date))) return true;
            date = dateLib.addDays(date, 1);
        }
    }
    return false;
}








function $0e1370c4508b377d$export$7f6d8a9c788c158e(props, dateLib) {
    const { disabled: disabled, excludeDisabled: excludeDisabled, selected: initiallySelected, required: required, onSelect: onSelect } = props;
    const [internallySelected, setSelected] = (0, $35bced7f7d2c59c6$export$ac06ac6808815c7c)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const isSelected = (date)=>selected && (0, $0a8b367a8cfd1222$export$ea4b24aaa0e5da4a)(selected, date, false, dateLib);
    const select = (triggerDate, modifiers, e)=>{
        const { min: min, max: max } = props;
        const newRange = triggerDate ? (0, $4c92f1711c67dd51$export$27ef550b4e6acc0c)(triggerDate, selected, min, max, required, dateLib) : undefined;
        if (excludeDisabled && disabled && newRange?.from && newRange.to) {
            if ((0, $79ce039b462c7209$export$129e86809f92e546)({
                from: newRange.from,
                to: newRange.to
            }, disabled, dateLib)) {
                // if a disabled days is found, the range is reset
                newRange.from = triggerDate;
                newRange.to = undefined;
            }
        }
        if (!onSelect) setSelected(newRange);
        onSelect?.(newRange, triggerDate, modifiers, e);
        return newRange;
    };
    return {
        selected: selected,
        select: select,
        isSelected: isSelected
    };
}



function $c7265caae631f564$export$3bf0ca7eec2741(props, dateLib) {
    const { selected: initiallySelected, required: required, onSelect: onSelect } = props;
    const [internallySelected, setSelected] = (0, $35bced7f7d2c59c6$export$ac06ac6808815c7c)(initiallySelected, onSelect ? initiallySelected : undefined);
    const selected = !onSelect ? internallySelected : initiallySelected;
    const { isSameDay: isSameDay } = dateLib;
    const isSelected = (compareDate)=>{
        return selected ? isSameDay(selected, compareDate) : false;
    };
    const select = (triggerDate, modifiers, e)=>{
        let newDate = triggerDate;
        if (!required && selected && selected && isSameDay(triggerDate, selected)) // If the date is the same, clear the selection.
        newDate = undefined;
        if (!onSelect) setSelected(newDate);
        if (required) onSelect?.(newDate, triggerDate, modifiers, e);
        else onSelect?.(newDate, triggerDate, modifiers, e);
        return newDate;
    };
    return {
        selected: selected,
        select: select,
        isSelected: isSelected
    };
}


function $5577395ef13df6c5$export$a97c3cc4bf1da1ca(props, dateLib) {
    const single = (0, $c7265caae631f564$export$3bf0ca7eec2741)(props, dateLib);
    const multi = (0, $28a997ccaef912cf$export$fe656f71238ed465)(props, dateLib);
    const range = (0, $0e1370c4508b377d$export$7f6d8a9c788c158e)(props, dateLib);
    switch(props.mode){
        case "single":
            return single;
        case "multiple":
            return multi;
        case "range":
            return range;
        default:
            return undefined;
    }
}




function $afd6fbb3c426525f$export$97e6db89a86ff7ab(props) {
    const { components: components, formatters: formatters, labels: labels, dateLib: dateLib, locale: locale, classNames: classNames } = (0, $acw62.useMemo)(()=>{
        const locale = {
            ...(0, $cd0c27002eb93234$export$137380d9ce54f7f),
            ...props.locale
        };
        const dateLib = new (0, $d707bba72f7c4bf9$export$87f71ed78036473c)({
            locale: locale,
            weekStartsOn: props.broadcastCalendar ? 1 : props.weekStartsOn,
            firstWeekContainsDate: props.firstWeekContainsDate,
            useAdditionalWeekYearTokens: props.useAdditionalWeekYearTokens,
            useAdditionalDayOfYearTokens: props.useAdditionalDayOfYearTokens,
            timeZone: props.timeZone,
            numerals: props.numerals
        }, props.dateLib);
        return {
            dateLib: dateLib,
            components: (0, $66b91be70e710800$export$4e811121b221213b)(props.components),
            formatters: (0, $413eed03be118143$export$2eec0f50813b8d07)(props.formatters),
            labels: {
                ...$c205bbec0eb1beb7$exports,
                ...props.labels
            },
            locale: locale,
            classNames: {
                ...(0, $020aa468896002d8$export$8f10228aec87fae6)(),
                ...props.classNames
            }
        };
    }, [
        props.locale,
        props.broadcastCalendar,
        props.weekStartsOn,
        props.firstWeekContainsDate,
        props.useAdditionalWeekYearTokens,
        props.useAdditionalDayOfYearTokens,
        props.timeZone,
        props.numerals,
        props.dateLib,
        props.components,
        props.formatters,
        props.labels,
        props.classNames
    ]);
    const { captionLayout: captionLayout, mode: mode, onDayBlur: onDayBlur, onDayClick: onDayClick, onDayFocus: onDayFocus, onDayKeyDown: onDayKeyDown, onDayMouseEnter: onDayMouseEnter, onDayMouseLeave: onDayMouseLeave, onNextClick: onNextClick, onPrevClick: onPrevClick, showWeekNumber: showWeekNumber, styles: styles } = props;
    const { formatCaption: formatCaption, formatDay: formatDay, formatMonthDropdown: formatMonthDropdown, formatWeekNumber: formatWeekNumber, formatWeekNumberHeader: formatWeekNumberHeader, formatWeekdayName: formatWeekdayName, formatYearDropdown: formatYearDropdown } = formatters;
    const calendar = (0, $f7397476098dba14$export$3ee915f8151bd4f1)(props, dateLib);
    const { days: days, months: months, navStart: navStart, navEnd: navEnd, previousMonth: previousMonth, nextMonth: nextMonth, goToMonth: goToMonth } = calendar;
    const getModifiers = (0, $3378876541ba48f2$export$1dd4f6d1180e527f)(days, props, dateLib);
    const { isSelected: isSelected, select: select, selected: selectedValue } = (0, $5577395ef13df6c5$export$a97c3cc4bf1da1ca)(props, dateLib) ?? {};
    const { blur: blur, focused: focused, isFocusTarget: isFocusTarget, moveFocus: moveFocus, setFocused: setFocused } = (0, $1671297566d8c9f1$export$f8168d8dd8fd66e6)(props, calendar, getModifiers, isSelected ?? (()=>false), dateLib);
    const { labelDayButton: labelDayButton, labelGridcell: labelGridcell, labelGrid: labelGrid, labelMonthDropdown: labelMonthDropdown, labelNav: labelNav, labelWeekday: labelWeekday, labelWeekNumber: labelWeekNumber, labelWeekNumberHeader: labelWeekNumberHeader, labelYearDropdown: labelYearDropdown } = labels;
    const weekdays = (0, $acw62.useMemo)(()=>(0, $10b338a72ddb13f8$export$24c38139da66592d)(dateLib, props.ISOWeek), [
        dateLib,
        props.ISOWeek
    ]);
    const isInteractive = mode !== undefined || onDayClick !== undefined;
    const handlePreviousClick = (0, $acw62.useCallback)(()=>{
        if (!previousMonth) return;
        goToMonth(previousMonth);
        onPrevClick?.(previousMonth);
    }, [
        previousMonth,
        goToMonth,
        onPrevClick
    ]);
    const handleNextClick = (0, $acw62.useCallback)(()=>{
        if (!nextMonth) return;
        goToMonth(nextMonth);
        onNextClick?.(nextMonth);
    }, [
        goToMonth,
        nextMonth,
        onNextClick
    ]);
    const handleDayClick = (0, $acw62.useCallback)((day, m)=>(e)=>{
            e.preventDefault();
            e.stopPropagation();
            setFocused(day);
            select?.(day.date, m, e);
            onDayClick?.(day.date, m, e);
        }, [
        select,
        onDayClick,
        setFocused
    ]);
    const handleDayFocus = (0, $acw62.useCallback)((day, m)=>(e)=>{
            setFocused(day);
            onDayFocus?.(day.date, m, e);
        }, [
        onDayFocus,
        setFocused
    ]);
    const handleDayBlur = (0, $acw62.useCallback)((day, m)=>(e)=>{
            blur();
            onDayBlur?.(day.date, m, e);
        }, [
        blur,
        onDayBlur
    ]);
    const handleDayKeyDown = (0, $acw62.useCallback)((day, modifiers)=>(e)=>{
            const keyMap = {
                ArrowLeft: [
                    "day",
                    props.dir === "rtl" ? "after" : "before"
                ],
                ArrowRight: [
                    "day",
                    props.dir === "rtl" ? "before" : "after"
                ],
                ArrowDown: [
                    "week",
                    "after"
                ],
                ArrowUp: [
                    "week",
                    "before"
                ],
                PageUp: [
                    e.shiftKey ? "year" : "month",
                    "before"
                ],
                PageDown: [
                    e.shiftKey ? "year" : "month",
                    "after"
                ],
                Home: [
                    "startOfWeek",
                    "before"
                ],
                End: [
                    "endOfWeek",
                    "after"
                ]
            };
            if (keyMap[e.key]) {
                e.preventDefault();
                e.stopPropagation();
                const [moveBy, moveDir] = keyMap[e.key];
                moveFocus(moveBy, moveDir);
            }
            onDayKeyDown?.(day.date, modifiers, e);
        }, [
        moveFocus,
        onDayKeyDown,
        props.dir
    ]);
    const handleDayMouseEnter = (0, $acw62.useCallback)((day, modifiers)=>(e)=>{
            onDayMouseEnter?.(day.date, modifiers, e);
        }, [
        onDayMouseEnter
    ]);
    const handleDayMouseLeave = (0, $acw62.useCallback)((day, modifiers)=>(e)=>{
            onDayMouseLeave?.(day.date, modifiers, e);
        }, [
        onDayMouseLeave
    ]);
    const handleMonthChange = (0, $acw62.useCallback)((date)=>(e)=>{
            const selectedMonth = Number(e.target.value);
            const month = dateLib.setMonth(dateLib.startOfMonth(date), selectedMonth);
            goToMonth(month);
        }, [
        dateLib,
        goToMonth
    ]);
    const handleYearChange = (0, $acw62.useCallback)((date)=>(e)=>{
            const selectedYear = Number(e.target.value);
            const month = dateLib.setYear(dateLib.startOfMonth(date), selectedYear);
            goToMonth(month);
        }, [
        dateLib,
        goToMonth
    ]);
    const { className: className, style: style } = (0, $acw62.useMemo)(()=>({
            className: [
                classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Root],
                props.className
            ].filter(Boolean).join(" "),
            style: {
                ...styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Root],
                ...props.style
            }
        }), [
        classNames,
        props.className,
        props.style,
        styles
    ]);
    const dataAttributes = (0, $d217534d5ddf9fbd$export$e5ac556b1404ae1e)(props);
    const contextValue = {
        dayPickerProps: props,
        selected: selectedValue,
        select: select,
        isSelected: isSelected,
        months: months,
        nextMonth: nextMonth,
        previousMonth: previousMonth,
        goToMonth: goToMonth,
        getModifiers: getModifiers,
        components: components,
        classNames: classNames,
        styles: styles,
        labels: labels,
        formatters: formatters
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edb9b04fac133fd0$export$468c0287d43ba92a).Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Root, {
        className: className,
        style: style,
        dir: props.dir,
        id: props.id,
        lang: props.lang,
        nonce: props.nonce,
        title: props.title,
        role: props.role,
        "aria-label": props["aria-label"],
        ...dataAttributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Months, {
        className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Months],
        style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Months]
    }, !props.hideNavigation && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Nav, {
        className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Nav],
        style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Nav],
        "aria-label": labelNav(),
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick,
        previousMonth: previousMonth,
        nextMonth: nextMonth
    }), months.map((calendarMonth, displayIndex)=>{
        const dropdownMonths = (0, $5b8d75d4f32d34c9$export$5365e964dff332d1)(calendarMonth.date, navStart, navEnd, formatters, dateLib);
        const dropdownYears = (0, $4e7154fd238c303b$export$9865296f13ed9cac)(navStart, navEnd, formatters, dateLib);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Month, {
            className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Month],
            style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Month],
            key: displayIndex,
            displayIndex: displayIndex,
            calendarMonth: calendarMonth
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.MonthCaption, {
            className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).MonthCaption],
            style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).MonthCaption],
            calendarMonth: calendarMonth,
            displayIndex: displayIndex
        }, captionLayout?.startsWith("dropdown") ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.DropdownNav, {
            className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Dropdowns],
            style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Dropdowns]
        }, captionLayout === "dropdown" || captionLayout === "dropdown-months" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.MonthsDropdown, {
            className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).MonthsDropdown],
            "aria-label": labelMonthDropdown(),
            classNames: classNames,
            components: components,
            disabled: Boolean(props.disableNavigation),
            onChange: handleMonthChange(calendarMonth.date),
            options: dropdownMonths,
            style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Dropdown],
            value: dateLib.getMonth(calendarMonth.date)
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            role: "status",
            "aria-live": "polite"
        }, formatMonthDropdown(calendarMonth.date, dateLib)), captionLayout === "dropdown" || captionLayout === "dropdown-years" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.YearsDropdown, {
            className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).YearsDropdown],
            "aria-label": labelYearDropdown(dateLib.options),
            classNames: classNames,
            components: components,
            disabled: Boolean(props.disableNavigation),
            onChange: handleYearChange(calendarMonth.date),
            options: dropdownYears,
            style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Dropdown],
            value: dateLib.getYear(calendarMonth.date)
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            role: "status",
            "aria-live": "polite"
        }, formatYearDropdown(calendarMonth.date, dateLib))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.CaptionLabel, {
            className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).CaptionLabel],
            role: "status",
            "aria-live": "polite"
        }, formatCaption(calendarMonth.date, dateLib.options, dateLib))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.MonthGrid, {
            role: "grid",
            "aria-multiselectable": mode === "multiple" || mode === "range",
            "aria-label": labelGrid(calendarMonth.date, dateLib.options, dateLib) || undefined,
            className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).MonthGrid],
            style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).MonthGrid]
        }, !props.hideWeekdays && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Weekdays, {
            className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Weekdays],
            style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Weekdays]
        }, showWeekNumber && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.WeekNumberHeader, {
            "aria-label": labelWeekNumberHeader(dateLib.options),
            className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).WeekNumberHeader],
            style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).WeekNumberHeader],
            scope: "col"
        }, formatWeekNumberHeader()), weekdays.map((weekday, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Weekday, {
                "aria-label": labelWeekday(weekday, dateLib.options, dateLib),
                className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Weekday],
                key: i,
                style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Weekday],
                scope: "col"
            }, formatWeekdayName(weekday, dateLib.options, dateLib)))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Weeks, {
            className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Weeks],
            style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Weeks]
        }, calendarMonth.weeks.map((week, weekIndex)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Week, {
                className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Week],
                key: week.weekNumber,
                style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Week],
                week: week
            }, showWeekNumber && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.WeekNumber, {
                week: week,
                style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).WeekNumber],
                "aria-label": labelWeekNumber(week.weekNumber, {
                    locale: locale
                }),
                className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).WeekNumber],
                scope: "row",
                role: "rowheader"
            }, formatWeekNumber(week.weekNumber)), week.days.map((day)=>{
                const { date: date } = day;
                const modifiers = getModifiers(day);
                modifiers[(0, $17d6b6ed20fdf376$export$c2fd8ae3501086f5).focused] = !modifiers.hidden && Boolean(focused?.isEqualTo(day));
                modifiers[(0, $17d6b6ed20fdf376$export$2255d92a85eab347).selected] = !modifiers.disabled && (isSelected?.(date) || modifiers.selected);
                if ((0, $b3cc505c5172e2c3$export$dd455b9c98fea187)(selectedValue)) {
                    // add range modifiers
                    const { from: from, to: to } = selectedValue;
                    modifiers[(0, $17d6b6ed20fdf376$export$2255d92a85eab347).range_start] = Boolean(from && to && dateLib.isSameDay(date, from));
                    modifiers[(0, $17d6b6ed20fdf376$export$2255d92a85eab347).range_end] = Boolean(from && to && dateLib.isSameDay(date, to));
                    modifiers[(0, $17d6b6ed20fdf376$export$2255d92a85eab347).range_middle] = (0, $0a8b367a8cfd1222$export$ea4b24aaa0e5da4a)(selectedValue, date, true, dateLib);
                }
                const style = (0, $fdaa54127a6a9911$export$aee95183ff1527a6)(modifiers, styles, props.modifiersStyles);
                const className = (0, $ba569522066b98e5$export$93628caec3887c55)(modifiers, classNames, props.modifiersClassNames);
                const ariaLabel = !isInteractive && !modifiers.hidden ? labelGridcell(date, modifiers, dateLib.options, dateLib) : undefined;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Day, {
                    key: `${dateLib.format(date, "yyyy-MM-dd")}_${dateLib.format(day.displayMonth, "yyyy-MM")}`,
                    day: day,
                    modifiers: modifiers,
                    className: className.join(" "),
                    style: style,
                    role: "gridcell",
                    "aria-selected": modifiers.selected || undefined,
                    "aria-label": ariaLabel,
                    "data-day": dateLib.format(date, "yyyy-MM-dd"),
                    "data-month": day.outside ? dateLib.format(date, "yyyy-MM") : undefined,
                    "data-selected": modifiers.selected || undefined,
                    "data-disabled": modifiers.disabled || undefined,
                    "data-hidden": modifiers.hidden || undefined,
                    "data-outside": day.outside || undefined,
                    "data-focused": modifiers.focused || undefined,
                    "data-today": modifiers.today || undefined
                }, !modifiers.hidden && isInteractive ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.DayButton, {
                    className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).DayButton],
                    style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).DayButton],
                    type: "button",
                    day: day,
                    modifiers: modifiers,
                    disabled: modifiers.disabled || undefined,
                    tabIndex: isFocusTarget(day) ? 0 : -1,
                    "aria-label": labelDayButton(date, modifiers, dateLib.options, dateLib),
                    onClick: handleDayClick(day, modifiers),
                    onBlur: handleDayBlur(day, modifiers),
                    onFocus: handleDayFocus(day, modifiers),
                    onKeyDown: handleDayKeyDown(day, modifiers),
                    onMouseEnter: handleDayMouseEnter(day, modifiers),
                    onMouseLeave: handleDayMouseLeave(day, modifiers)
                }, formatDay(date, dateLib.options, dateLib)) : !modifiers.hidden && formatDay(day.date, dateLib.options, dateLib));
            }));
        }))));
    })), props.footer && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(components.Footer, {
        className: classNames[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Footer],
        style: styles?.[(0, $17d6b6ed20fdf376$export$4b08aed5f1ec6952).Footer],
        role: "status",
        "aria-live": "polite"
    }, props.footer)));
}





const $146d46e47fdc6710$export$32fbfacc5d962e0c = (0, $759208f999b76c31$export$1898376853bad7d4);
const $146d46e47fdc6710$export$b59bdbef9ce70de2 = (0, $bc2fc79862fc077e$export$fca4f8121099df57);
const $146d46e47fdc6710$export$d0fd4b7106de2769 = (0, $edb9b04fac133fd0$export$332e9e0d64b1f294);













// Only export helpers that can be useful to other developers.











var $acw62 = parcelRequire("acw62");



const $6e2f54bb4aae0ec6$export$8c838888ab805244 = $acw62.forwardRef((props, ref)=>{
    const [hasFocus, setHasFocus] = (0, $acw62.useState)(false);
    const dateInputOptions = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)().adaptableOptions.userInterfaceOptions.dateInputOptions;
    const dateProps = {
        format: dateInputOptions.dateFormat,
        locale: dateInputOptions.locale
    };
    const [inputValue, setInputValue] = (0, $acw62.useState)(()=>{
        return props.value;
    });
    $acw62.useEffect(()=>{
        if (hasFocus) return;
        setInputValue(props.value);
    }, [
        props.value
    ]);
    const handleInputChange = (e)=>{
        setInputValue(e.currentTarget.value);
        const date = (0, $8abb93379891fb3e$export$98e6a39c04603d36)(e.currentTarget.value, dateProps.format, new Date());
        if ((0, $f2a682b251363bc2$export$1ea939691cdc45b8)(date)) props.onChange(e.currentTarget.value);
        else props.onChange(undefined);
    };
    return $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        ...props,
        onFocus: (event)=>{
            props.onFocus?.(event);
            setHasFocus(true);
        },
        onBlur: (event)=>{
            props.onBlur?.(event);
            setHasFocus(false);
        },
        ref: ref,
        value: inputValue,
        onChange: (e)=>handleInputChange(e),
        placeholder: props.placeholder ?? dateProps.format,
        style: props.style,
        disabled: props.disabled
    });
});




function $d84241a3868bd79f$export$def9f260655b3a76(date, options) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getDay() === 6;
}
var // Fallback for modularized imports:
$d84241a3868bd79f$export$2e2bcd8739ae039 = $d84241a3868bd79f$export$def9f260655b3a76;



function $971b91a830c22187$export$70f720dfc6028987(date, options) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getDay() === 0;
}
var // Fallback for modularized imports:
$971b91a830c22187$export$2e2bcd8739ae039 = $971b91a830c22187$export$70f720dfc6028987;



function $126e0ee47695e680$export$618d60ea299da42(date, options) {
    const day = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 || day === 6;
}
var // Fallback for modularized imports:
$126e0ee47695e680$export$2e2bcd8739ae039 = $126e0ee47695e680$export$618d60ea299da42;



function $370ee6dc5d0513ee$export$f087b9ada3136ae9(date, amount, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const startedOnWeekend = (0, $126e0ee47695e680$export$618d60ea299da42)(_date, options);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $126e0ee47695e680$export$618d60ea299da42)(_date, options)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $126e0ee47695e680$export$618d60ea299da42)(_date, options) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $d84241a3868bd79f$export$def9f260655b3a76)(_date, options)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $971b91a830c22187$export$70f720dfc6028987)(_date, options)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}
var // Fallback for modularized imports:
$370ee6dc5d0513ee$export$2e2bcd8739ae039 = $370ee6dc5d0513ee$export$f087b9ada3136ae9;




var $acw62 = parcelRequire("acw62");
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}



var $acw62 = parcelRequire("acw62");
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($76500f1a9bc57c92$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function() {
    return (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
            (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $e19976245606d3d7$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $72623ab6bcb0a33b$exports = {};
'use strict';
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};


var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}



var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;


var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $76500f1a9bc57c92$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $76500f1a9bc57c92$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $794b155aeb6b00fd$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $5f1e384d41b6dbd9$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $1b59f2f50af460c0$export$db21c7ffa21794e7)(function() {
        return (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $5f1e384d41b6dbd9$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;



var $acw62 = parcelRequire("acw62");




var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    return $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;





var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $acad92301ef10c3f$export$dda1d9f60106f0e9).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $acad92301ef10c3f$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $acad92301ef10c3f$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $acad92301ef10c3f$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $acad92301ef10c3f$export$971d5caa766a69d7)));
    if (!(0, $acad92301ef10c3f$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $1b59f2f50af460c0$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $1b59f2f50af460c0$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $62578605b07c8dad$export$6321afa313b251b5)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $5f1e384d41b6dbd9$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $1b59f2f50af460c0$export$db21c7ffa21794e7)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
            if (!(0, $acad92301ef10c3f$export$23f2a1d2818174ef) && res !== undefined) rules += res;
        }
        if (!(0, $acad92301ef10c3f$export$23f2a1d2818174ef)) return rules;
    });
    if (!(0, $acad92301ef10c3f$export$23f2a1d2818174ef) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $acad92301ef10c3f$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $acad92301ef10c3f$export$407448d2b89b1813)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $5f1e384d41b6dbd9$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $acad92301ef10c3f$export$407448d2b89b1813)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $acad92301ef10c3f$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});


function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(r) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(r, e) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r, e) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $10310cf078d13212$var$lrPlacement = [
    'left',
    'right'
];
const $10310cf078d13212$var$rlPlacement = [
    'right',
    'left'
];
const $10310cf078d13212$var$tbPlacement = [
    'top',
    'bottom'
];
const $10310cf078d13212$var$btPlacement = [
    'bottom',
    'top'
];
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $10310cf078d13212$var$rlPlacement : $10310cf078d13212$var$lrPlacement;
            return isStart ? $10310cf078d13212$var$lrPlacement : $10310cf078d13212$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $10310cf078d13212$var$tbPlacement : $10310cf078d13212$var$btPlacement;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    const side = $10310cf078d13212$export$3c915306cb7fc97a(placement);
    return $10310cf078d13212$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $973e4da43f2a375d$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $973e4da43f2a375d$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $973e4da43f2a375d$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $10310cf078d13212$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $10310cf078d13212$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $973e4da43f2a375d$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $973e4da43f2a375d$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $973e4da43f2a375d$var$originSides.has((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $10310cf078d13212$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $10310cf078d13212$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $238ac70369f38756$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $238ac70369f38756$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $238ac70369f38756$var$containRe = /paint|layout|strict|content/;
const $238ac70369f38756$var$isNotNone = (value)=>!!value && value !== 'none';
let $238ac70369f38756$var$isWebKitValue;
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $238ac70369f38756$var$isNotNone(css.transform) || $238ac70369f38756$var$isNotNone(css.translate) || $238ac70369f38756$var$isNotNone(css.scale) || $238ac70369f38756$var$isNotNone(css.rotate) || $238ac70369f38756$var$isNotNone(css.perspective) || !$238ac70369f38756$export$78551043582a6a98() && ($238ac70369f38756$var$isNotNone(css.backdropFilter) || $238ac70369f38756$var$isNotNone(css.filter)) || $238ac70369f38756$var$willChangeRe.test(css.willChange || '') || $238ac70369f38756$var$containRe.test(css.contain || '');
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if ($238ac70369f38756$var$isWebKitValue == null) $238ac70369f38756$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $238ac70369f38756$var$isWebKitValue;
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $238ac70369f38756$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if (!(0, $238ac70369f38756$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $238ac70369f38756$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $238ac70369f38756$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $238ac70369f38756$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $238ac70369f38756$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $238ac70369f38756$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $238ac70369f38756$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $238ac70369f38756$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $461947879dcdbcd4$var$SCROLLBAR_MAX = 25;
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $238ac70369f38756$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $461947879dcdbcd4$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $461947879dcdbcd4$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $461947879dcdbcd4$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $461947879dcdbcd4$var$getDocumentRect((0, $238ac70369f38756$export$e495491855dc5418)(element));
    else if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(parentNode) || (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $238ac70369f38756$export$3735103072e4a80)(parentNode).position === 'fixed' || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $238ac70369f38756$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(el) && (0, $238ac70369f38756$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $238ac70369f38756$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(currentNode) && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $238ac70369f38756$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $238ac70369f38756$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $238ac70369f38756$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $238ac70369f38756$export$89e651af02346cd4)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, top);
        right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'static';
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) || (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $238ac70369f38756$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if ((0, $238ac70369f38756$export$89e651af02346cd4)(element)) return win;
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $238ac70369f38756$export$71535ffaa902797f)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $238ac70369f38756$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $238ac70369f38756$export$940d8225183e1404)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).direction === 'rtl';
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $238ac70369f38756$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $238ac70369f38756$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
function $461947879dcdbcd4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$461947879dcdbcd4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $238ac70369f38756$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $238ac70369f38756$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$461947879dcdbcd4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $973e4da43f2a375d$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $973e4da43f2a375d$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $973e4da43f2a375d$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $973e4da43f2a375d$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $973e4da43f2a375d$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $973e4da43f2a375d$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $973e4da43f2a375d$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $973e4da43f2a375d$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $973e4da43f2a375d$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = (0, $acw62.useLayoutEffect);


var $e5db4f66b3bbccc3$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e5db4f66b3bbccc3$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e5db4f66b3bbccc3$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e5db4f66b3bbccc3$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($e5db4f66b3bbccc3$var$isArray(value)) return value.filter(Boolean);
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e5db4f66b3bbccc3$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $e5db4f66b3bbccc3$var$_excluded$4);
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e5db4f66b3bbccc3$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e5db4f66b3bbccc3$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e5db4f66b3bbccc3$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e5db4f66b3bbccc3$var$normalizedHeight(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollTop(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e5db4f66b3bbccc3$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e5db4f66b3bbccc3$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e5db4f66b3bbccc3$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e5db4f66b3bbccc3$export$b4171a6734a65d42;
    var start = $e5db4f66b3bbccc3$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e5db4f66b3bbccc3$var$easeOutCubic(currentTime, start, change, duration);
        $e5db4f66b3bbccc3$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e5db4f66b3bbccc3$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e5db4f66b3bbccc3$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e5db4f66b3bbccc3$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e5db4f66b3bbccc3$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e5db4f66b3bbccc3$var$passiveOptionAccessed = false;
var $e5db4f66b3bbccc3$var$options = {
    get passive () {
        return $e5db4f66b3bbccc3$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e5db4f66b3bbccc3$var$w = typeof window !== 'undefined' ? window : {};
if ($e5db4f66b3bbccc3$var$w.addEventListener && $e5db4f66b3bbccc3$var$w.removeEventListener) {
    $e5db4f66b3bbccc3$var$w.addEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, $e5db4f66b3bbccc3$var$options);
    $e5db4f66b3bbccc3$var$w.removeEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, false);
}
var $e5db4f66b3bbccc3$export$2408f22a0fab9ae5 = $e5db4f66b3bbccc3$var$passiveOptionAccessed;
function $e5db4f66b3bbccc3$export$3466f893ebf79586(item) {
    return item != null;
}
function $e5db4f66b3bbccc3$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e5db4f66b3bbccc3$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e5db4f66b3bbccc3$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e5db4f66b3bbccc3$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e5db4f66b3bbccc3$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $e5db4f66b3bbccc3$var$_excluded$3 = [
    "children",
    "innerProps"
], $e5db4f66b3bbccc3$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $e5db4f66b3bbccc3$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e5db4f66b3bbccc3$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e5db4f66b3bbccc3$var$normalizedHeight(scrollParent);
    var scrollTop = $e5db4f66b3bbccc3$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e5db4f66b3bbccc3$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e5db4f66b3bbccc3$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e5db4f66b3bbccc3$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e5db4f66b3bbccc3$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, $e5db4f66b3bbccc3$var$alignToControl(placement), '100%'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e5db4f66b3bbccc3$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// NOTE: internal only
var $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $acw62.useContext)($e5db4f66b3bbccc3$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e5db4f66b3bbccc3$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $e5db4f66b3bbccc3$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e5db4f66b3bbccc3$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Menu$1 = $e5db4f66b3bbccc3$var$Menu;
// ==============================
// Menu List
// ==============================
var $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e5db4f66b3bbccc3$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e5db4f66b3bbccc3$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e5db4f66b3bbccc3$export$3b14a55fb2447963 = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$export$342063e11d6c3cad = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref6, $e5db4f66b3bbccc3$var$_excluded$3);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $e5db4f66b3bbccc3$var$_excluded2$1);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $e5db4f66b3bbccc3$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e5db4f66b3bbccc3$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState5 = (0, $acw62.useState)($e5db4f66b3bbccc3$var$coercePlacement(menuPlacement)), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $acw62.useState)(null), _useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e5db4f66b3bbccc3$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $461947879dcdbcd4$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e5db4f66b3bbccc3$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e5db4f66b3bbccc3$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e5db4f66b3bbccc3$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e5db4f66b3bbccc3$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e5db4f66b3bbccc3$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e5db4f66b3bbccc3$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$_templateObject;
var $e5db4f66b3bbccc3$var$_excluded$2 = [
    "size"
], $e5db4f66b3bbccc3$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $e5db4f66b3bbccc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e5db4f66b3bbccc3$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e5db4f66b3bbccc3$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $e5db4f66b3bbccc3$var$_excluded$2);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e5db4f66b3bbccc3$var$_ref2
    }, props));
};
var $e5db4f66b3bbccc3$var$CrossIcon = function CrossIcon(props) {
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e5db4f66b3bbccc3$var$DownChevron = function DownChevron(props) {
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e5db4f66b3bbccc3$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e5db4f66b3bbccc3$export$f1e1789686576879 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$DownChevron, null));
};
var $e5db4f66b3bbccc3$export$407448d2b89b1813 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e5db4f66b3bbccc3$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerProps, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e5db4f66b3bbccc3$var$loadingDotAnimations = (0, $e0f035ab0866fe47$export$d25ddfdf17c3ad3e)($e5db4f66b3bbccc3$var$_templateObject || ($e5db4f66b3bbccc3$var$_templateObject = (0, $cbe7edbf3ccb8828$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e5db4f66b3bbccc3$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $e0f035ab0866fe47$export$dbf350e5966cf602)({
            animation: "".concat($e5db4f66b3bbccc3$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e5db4f66b3bbccc3$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $e5db4f66b3bbccc3$var$_excluded2);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $e5db4f66b3bbccc3$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e5db4f66b3bbccc3$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $e5db4f66b3bbccc3$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $e5db4f66b3bbccc3$var$Control$1 = $e5db4f66b3bbccc3$var$Control;
var $e5db4f66b3bbccc3$var$_excluded$1 = [
    "data"
];
var $e5db4f66b3bbccc3$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e5db4f66b3bbccc3$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)(Heading, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", null, children));
};
var $e5db4f66b3bbccc3$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e5db4f66b3bbccc3$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded$1);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e5db4f66b3bbccc3$var$Group$1 = $e5db4f66b3bbccc3$var$Group;
var $e5db4f66b3bbccc3$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e5db4f66b3bbccc3$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e5db4f66b3bbccc3$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e5db4f66b3bbccc3$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e5db4f66b3bbccc3$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e5db4f66b3bbccc3$var$spacingStyle)
};
var $e5db4f66b3bbccc3$var$inputStyle = function inputStyle(isHidden) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e5db4f66b3bbccc3$var$spacingStyle);
};
var $e5db4f66b3bbccc3$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded);
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e5db4f66b3bbccc3$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e5db4f66b3bbccc3$var$Input$1 = $e5db4f66b3bbccc3$var$Input;
var $e5db4f66b3bbccc3$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e5db4f66b3bbccc3$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e5db4f66b3bbccc3$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $e5db4f66b3bbccc3$var$MultiValueContainer = $e5db4f66b3bbccc3$var$MultiValueGeneric;
var $e5db4f66b3bbccc3$var$MultiValueLabel = $e5db4f66b3bbccc3$var$MultiValueGeneric;
function $e5db4f66b3bbccc3$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$CrossIcon, {
        size: 14
    }));
}
var $e5db4f66b3bbccc3$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e5db4f66b3bbccc3$var$MultiValue$1 = $e5db4f66b3bbccc3$var$MultiValue;
var $e5db4f66b3bbccc3$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e5db4f66b3bbccc3$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Option$1 = $e5db4f66b3bbccc3$var$Option;
var $e5db4f66b3bbccc3$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$Placeholder$1 = $e5db4f66b3bbccc3$var$Placeholder;
var $e5db4f66b3bbccc3$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$SingleValue$1 = $e5db4f66b3bbccc3$var$SingleValue;
var $e5db4f66b3bbccc3$export$db3b6bfb95261072 = {
    ClearIndicator: $e5db4f66b3bbccc3$var$ClearIndicator,
    Control: $e5db4f66b3bbccc3$var$Control$1,
    DropdownIndicator: $e5db4f66b3bbccc3$var$DropdownIndicator,
    DownChevron: $e5db4f66b3bbccc3$var$DownChevron,
    CrossIcon: $e5db4f66b3bbccc3$var$CrossIcon,
    Group: $e5db4f66b3bbccc3$var$Group$1,
    GroupHeading: $e5db4f66b3bbccc3$var$GroupHeading,
    IndicatorsContainer: $e5db4f66b3bbccc3$var$IndicatorsContainer,
    IndicatorSeparator: $e5db4f66b3bbccc3$var$IndicatorSeparator,
    Input: $e5db4f66b3bbccc3$var$Input$1,
    LoadingIndicator: $e5db4f66b3bbccc3$var$LoadingIndicator,
    Menu: $e5db4f66b3bbccc3$var$Menu$1,
    MenuList: $e5db4f66b3bbccc3$var$MenuList,
    MenuPortal: $e5db4f66b3bbccc3$var$MenuPortal,
    LoadingMessage: $e5db4f66b3bbccc3$var$LoadingMessage,
    NoOptionsMessage: $e5db4f66b3bbccc3$var$NoOptionsMessage,
    MultiValue: $e5db4f66b3bbccc3$var$MultiValue$1,
    MultiValueContainer: $e5db4f66b3bbccc3$var$MultiValueContainer,
    MultiValueLabel: $e5db4f66b3bbccc3$var$MultiValueLabel,
    MultiValueRemove: $e5db4f66b3bbccc3$var$MultiValueRemove,
    Option: $e5db4f66b3bbccc3$var$Option$1,
    Placeholder: $e5db4f66b3bbccc3$var$Placeholder$1,
    SelectContainer: $e5db4f66b3bbccc3$var$SelectContainer,
    SingleValue: $e5db4f66b3bbccc3$var$SingleValue$1,
    ValueContainer: $e5db4f66b3bbccc3$var$ValueContainer
};
var $e5db4f66b3bbccc3$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$export$db3b6bfb95261072), props.components);
};





var $acw62 = parcelRequire("acw62");
var $9d88f0746ba78f85$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9d88f0746ba78f85$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $9d88f0746ba78f85$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $acw62 = parcelRequire("acw62");


function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, e);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(t);
}


function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $b2099f49db83e2df$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, e);
    };
}



function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(r) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(r) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");


var $3e731b8aba846199$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $3e731b8aba846199$var$isEqual(first, second) {
    if (first === second) return true;
    if ($3e731b8aba846199$var$safeIsNaN(first) && $3e731b8aba846199$var$safeIsNaN(second)) return true;
    return false;
}
function $3e731b8aba846199$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$3e731b8aba846199$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $3e731b8aba846199$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $3e731b8aba846199$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $4b23e30940068c4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $4b23e30940068c4c$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $4b23e30940068c4c$var$A11yText = function A11yText(props) {
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        css: $4b23e30940068c4c$var$_ref
    }, props));
};
var $4b23e30940068c4c$var$A11yText$1 = $4b23e30940068c4c$var$A11yText;
var $4b23e30940068c4c$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $4b23e30940068c4c$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $4b23e30940068c4c$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($4b23e30940068c4c$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)($4b23e30940068c4c$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $4b23e30940068c4c$var$LiveRegion$1 = $4b23e30940068c4c$var$LiveRegion;
var $4b23e30940068c4c$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $4b23e30940068c4c$var$anyDiacritic = new RegExp('[' + $4b23e30940068c4c$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $4b23e30940068c4c$var$diacriticToBase = {};
for(var $4b23e30940068c4c$var$i = 0; $4b23e30940068c4c$var$i < $4b23e30940068c4c$var$diacritics.length; $4b23e30940068c4c$var$i++){
    var $4b23e30940068c4c$var$diacritic = $4b23e30940068c4c$var$diacritics[$4b23e30940068c4c$var$i];
    for(var $4b23e30940068c4c$var$j = 0; $4b23e30940068c4c$var$j < $4b23e30940068c4c$var$diacritic.letters.length; $4b23e30940068c4c$var$j++)$4b23e30940068c4c$var$diacriticToBase[$4b23e30940068c4c$var$diacritic.letters[$4b23e30940068c4c$var$j]] = $4b23e30940068c4c$var$diacritic.base;
}
var $4b23e30940068c4c$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($4b23e30940068c4c$var$anyDiacritic, function(match) {
        return $4b23e30940068c4c$var$diacriticToBase[match];
    });
};
var $4b23e30940068c4c$var$memoizedStripDiacriticsForInput = (0, $3e731b8aba846199$export$2e2bcd8739ae039)($4b23e30940068c4c$var$stripDiacritics);
var $4b23e30940068c4c$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $4b23e30940068c4c$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $4b23e30940068c4c$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $4b23e30940068c4c$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $4b23e30940068c4c$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $4b23e30940068c4c$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $4b23e30940068c4c$var$memoizedStripDiacriticsForInput(input);
            candidate = $4b23e30940068c4c$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $4b23e30940068c4c$var$_excluded = [
    "innerRef"
];
function $4b23e30940068c4c$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $4b23e30940068c4c$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $e5db4f66b3bbccc3$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $e0f035ab0866fe47$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $4b23e30940068c4c$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $4b23e30940068c4c$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $4b23e30940068c4c$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $e5db4f66b3bbccc3$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $4b23e30940068c4c$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $4b23e30940068c4c$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $4b23e30940068c4c$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $4b23e30940068c4c$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $4b23e30940068c4c$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $4b23e30940068c4c$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $4b23e30940068c4c$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $4b23e30940068c4c$var$activeScrollLocks = 0;
var $4b23e30940068c4c$var$listenerOptions = {
    capture: false,
    passive: false
};
function $4b23e30940068c4c$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$4b23e30940068c4c$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $4b23e30940068c4c$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $4b23e30940068c4c$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($4b23e30940068c4c$var$LOCK_STYLES).forEach(function(key) {
                var val = $4b23e30940068c4c$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $4b23e30940068c4c$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $4b23e30940068c4c$var$preventTouchMove, $4b23e30940068c4c$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $4b23e30940068c4c$var$preventInertiaScroll, $4b23e30940068c4c$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $4b23e30940068c4c$var$allowTouchMove, $4b23e30940068c4c$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $4b23e30940068c4c$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$4b23e30940068c4c$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $4b23e30940068c4c$var$activeScrollLocks = Math.max($4b23e30940068c4c$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $4b23e30940068c4c$var$activeScrollLocks < 1) $4b23e30940068c4c$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $4b23e30940068c4c$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $4b23e30940068c4c$var$preventTouchMove, $4b23e30940068c4c$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $4b23e30940068c4c$var$preventInertiaScroll, $4b23e30940068c4c$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $4b23e30940068c4c$var$allowTouchMove, $4b23e30940068c4c$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $4b23e30940068c4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4b23e30940068c4c$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $4b23e30940068c4c$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $4b23e30940068c4c$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $4b23e30940068c4c$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $4b23e30940068c4c$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, lockEnabled && (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("div", {
        onClick: $4b23e30940068c4c$var$blurSelectInput,
        css: $4b23e30940068c4c$var$_ref2$1
    }), children(targetRef));
}
function $4b23e30940068c4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4b23e30940068c4c$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $4b23e30940068c4c$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $e0f035ab0866fe47$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $4b23e30940068c4c$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $4b23e30940068c4c$var$RequiredInput$1 = $4b23e30940068c4c$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $4b23e30940068c4c$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $4b23e30940068c4c$var$isIPhone() {
    return $4b23e30940068c4c$var$testPlatform(/^iPhone/i);
}
function $4b23e30940068c4c$var$isMac() {
    return $4b23e30940068c4c$var$testPlatform(/^Mac/i);
}
function $4b23e30940068c4c$var$isIPad() {
    return $4b23e30940068c4c$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $4b23e30940068c4c$var$isMac() && navigator.maxTouchPoints > 1;
}
function $4b23e30940068c4c$var$isIOS() {
    return $4b23e30940068c4c$var$isIPhone() || $4b23e30940068c4c$var$isIPad();
}
function $4b23e30940068c4c$var$isAppleDevice() {
    return $4b23e30940068c4c$var$isMac() || $4b23e30940068c4c$var$isIOS();
}
var $4b23e30940068c4c$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $4b23e30940068c4c$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $4b23e30940068c4c$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $4b23e30940068c4c$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $4b23e30940068c4c$var$defaultStyles = {
    clearIndicator: (0, $e5db4f66b3bbccc3$export$407448d2b89b1813),
    container: (0, $e5db4f66b3bbccc3$export$8b22cf2602fb60ce),
    control: (0, $e5db4f66b3bbccc3$export$4368d992c4eafac0),
    dropdownIndicator: (0, $e5db4f66b3bbccc3$export$f1e1789686576879),
    group: (0, $e5db4f66b3bbccc3$export$39b482c5e57630a8),
    groupHeading: (0, $e5db4f66b3bbccc3$export$2d1720544b23b823),
    indicatorsContainer: (0, $e5db4f66b3bbccc3$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $e5db4f66b3bbccc3$export$dda1d9f60106f0e9),
    input: (0, $e5db4f66b3bbccc3$export$35e795649ee09318),
    loadingIndicator: (0, $e5db4f66b3bbccc3$export$882b5998b3b9117c),
    loadingMessage: (0, $e5db4f66b3bbccc3$export$342063e11d6c3cad),
    menu: (0, $e5db4f66b3bbccc3$export$953cecd6e717a553),
    menuList: (0, $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $e5db4f66b3bbccc3$export$ae1af26003f05816),
    multiValue: (0, $e5db4f66b3bbccc3$export$ffb5f4729a158638),
    multiValueLabel: (0, $e5db4f66b3bbccc3$export$9e5f44173e64f162),
    multiValueRemove: (0, $e5db4f66b3bbccc3$export$625550452a3fa3ec),
    noOptionsMessage: (0, $e5db4f66b3bbccc3$export$3b14a55fb2447963),
    option: (0, $e5db4f66b3bbccc3$export$90a7f3efeed30595),
    placeholder: (0, $e5db4f66b3bbccc3$export$efccba1c4a2ef57b),
    singleValue: (0, $e5db4f66b3bbccc3$export$d141bba7fdc215a3),
    valueContainer: (0, $e5db4f66b3bbccc3$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $4b23e30940068c4c$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $4b23e30940068c4c$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $4b23e30940068c4c$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $4b23e30940068c4c$var$baseUnit = 4;
// The minimum height of the control
var $4b23e30940068c4c$var$controlHeight = 38;
// The amount of space between the control and menu */
var $4b23e30940068c4c$var$menuGutter = $4b23e30940068c4c$var$baseUnit * 2;
var $4b23e30940068c4c$var$spacing = {
    baseUnit: $4b23e30940068c4c$var$baseUnit,
    controlHeight: $4b23e30940068c4c$var$controlHeight,
    menuGutter: $4b23e30940068c4c$var$menuGutter
};
var $4b23e30940068c4c$export$4368d992c4eafac0 = {
    borderRadius: $4b23e30940068c4c$var$borderRadius,
    colors: $4b23e30940068c4c$var$colors,
    spacing: $4b23e30940068c4c$var$spacing
};
var $4b23e30940068c4c$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $e5db4f66b3bbccc3$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $e5db4f66b3bbccc3$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $4b23e30940068c4c$export$db3b6bfb95261072(),
    formatGroupLabel: $4b23e30940068c4c$var$formatGroupLabel,
    getOptionLabel: $4b23e30940068c4c$export$8b22cf2602fb60ce,
    getOptionValue: $4b23e30940068c4c$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $4b23e30940068c4c$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $e5db4f66b3bbccc3$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $4b23e30940068c4c$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $4b23e30940068c4c$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $4b23e30940068c4c$var$_isOptionSelected(props, option, selectValue);
    var label = $4b23e30940068c4c$var$getOptionLabel(props, option);
    var value = $4b23e30940068c4c$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $4b23e30940068c4c$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $4b23e30940068c4c$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $4b23e30940068c4c$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $4b23e30940068c4c$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $4b23e30940068c4c$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $e5db4f66b3bbccc3$export$3466f893ebf79586));
}
function $4b23e30940068c4c$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $4b23e30940068c4c$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $4b23e30940068c4c$var$buildFocusableOptions(props, selectValue) {
    return $4b23e30940068c4c$var$buildFocusableOptionsFromCategorizedOptions($4b23e30940068c4c$var$buildCategorizedOptions(props, selectValue));
}
function $4b23e30940068c4c$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$4b23e30940068c4c$var$shouldHideSelectedOptions(props) || !isSelected) && $4b23e30940068c4c$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $4b23e30940068c4c$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $4b23e30940068c4c$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $4b23e30940068c4c$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $4b23e30940068c4c$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $4b23e30940068c4c$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $4b23e30940068c4c$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $4b23e30940068c4c$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $4b23e30940068c4c$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $4b23e30940068c4c$var$getOptionValue(props, i) === candidate;
    });
}
function $4b23e30940068c4c$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $4b23e30940068c4c$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $4b23e30940068c4c$var$instanceId = 1;
var $4b23e30940068c4c$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $4b23e30940068c4c$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $e5db4f66b3bbccc3$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $e5db4f66b3bbccc3$export$ef35774e6d314e91)([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $e5db4f66b3bbccc3$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $e5db4f66b3bbccc3$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $4b23e30940068c4c$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $4b23e30940068c4c$var$buildFocusableOptionsWithIds($4b23e30940068c4c$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $4b23e30940068c4c$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $4b23e30940068c4c$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $4b23e30940068c4c$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $e5db4f66b3bbccc3$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $4b23e30940068c4c$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $4b23e30940068c4c$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $e5db4f66b3bbccc3$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $4b23e30940068c4c$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$4b23e30940068c4c$var$instanceId);
        _this.state.selectValue = (0, $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $4b23e30940068c4c$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $e5db4f66b3bbccc3$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $e5db4f66b3bbccc3$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $4b23e30940068c4c$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($4b23e30940068c4c$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $4b23e30940068c4c$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $4b23e30940068c4c$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $4b23e30940068c4c$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $4b23e30940068c4c$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$DummyInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $e5db4f66b3bbccc3$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $acw62.createElement(Input, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $acw62.createElement(Placeholder, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $acw62.createElement(MultiValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $acw62.createElement(SingleValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(ClearIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(LoadingIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $acw62.createElement(IndicatorSeparator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(DropdownIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $acw62.createElement(Option, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $acw62.createElement(Group, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $acw62.createElement((0, $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $acw62.createElement(Menu, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $acw62.createElement(MenuList, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $acw62.createElement(MenuPortal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $acw62.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $acw62.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $acw62.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$LiveRegion$1, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $acw62.createElement(SelectContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $acw62.createElement(Control, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $acw62.createElement(ValueContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $acw62.createElement(IndicatorsContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $4b23e30940068c4c$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $4b23e30940068c4c$var$buildFocusableOptionsWithIds($4b23e30940068c4c$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $4b23e30940068c4c$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $4b23e30940068c4c$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $4b23e30940068c4c$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$4b23e30940068c4c$export$25ce5a424b770e84.defaultProps = $4b23e30940068c4c$export$407448d2b89b1813;





var $8de12fa6a893dcd1$exports = {};
var $bb7ca61ce45563c4$exports = {};
var $010f4e0e13c82e16$exports = {};
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


var $010f4e0e13c82e16$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $b77c8068776c2a21$exports = {};

var $b77c8068776c2a21$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $b77c8068776c2a21$exports(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $010f4e0e13c82e16$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;


function $8de12fa6a893dcd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de12fa6a893dcd1$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bb7ca61ce45563c4$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de12fa6a893dcd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$8de12fa6a893dcd1$exports = $8de12fa6a893dcd1$var$_objectSpread2, $8de12fa6a893dcd1$exports.__esModule = true, $8de12fa6a893dcd1$exports["default"] = $8de12fa6a893dcd1$exports;


var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;


var $51f08ebed50a2438$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1e0ecff44bad0ea1$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1e0ecff44bad0ea1$exports(r, a) : void 0;
    }
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $bf2dbd940d8d1ee7$exports(r) || $efa3fde0b6100532$exports(r, e) || $51f08ebed50a2438$exports(r, e) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;


var $c5fdcdd8d5286ae7$exports = {};
var $8bc9a7bbcf9a2a3b$exports = {};
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$8bc9a7bbcf9a2a3b$exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, $8bc9a7bbcf9a2a3b$exports.__esModule = true, $8bc9a7bbcf9a2a3b$exports["default"] = $8bc9a7bbcf9a2a3b$exports;


function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $8bc9a7bbcf9a2a3b$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;


var $b45a6abf916bff88$exports = {};
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$b45a6abf916bff88$exports = $b45a6abf916bff88$var$_classCallCheck, $b45a6abf916bff88$exports.__esModule = true, $b45a6abf916bff88$exports["default"] = $b45a6abf916bff88$exports;


var $fe9438347a673ba6$exports = {};

function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $010f4e0e13c82e16$exports(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$fe9438347a673ba6$exports = $fe9438347a673ba6$var$_createClass, $fe9438347a673ba6$exports.__esModule = true, $fe9438347a673ba6$exports["default"] = $fe9438347a673ba6$exports;


var $b050fc8434f4a0e1$exports = {};
var $7b4ac2338b8e8f97$exports = {};
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return $7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
$7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports;


function $b050fc8434f4a0e1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $7b4ac2338b8e8f97$exports(t, e);
}
$b050fc8434f4a0e1$exports = $b050fc8434f4a0e1$var$_inherits, $b050fc8434f4a0e1$exports.__esModule = true, $b050fc8434f4a0e1$exports["default"] = $b050fc8434f4a0e1$exports;


var $6c89cb228f797fa5$exports = {};
var $93d4339c80153a6a$exports = {};
function $93d4339c80153a6a$var$_getPrototypeOf(t) {
    return $93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports, $93d4339c80153a6a$var$_getPrototypeOf(t);
}
$93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports;


var $426f299ee58329c3$exports = {};
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($426f299ee58329c3$exports = $426f299ee58329c3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, $426f299ee58329c3$exports.__esModule = true, $426f299ee58329c3$exports["default"] = $426f299ee58329c3$exports)();
}
$426f299ee58329c3$exports = $426f299ee58329c3$var$_isNativeReflectConstruct, $426f299ee58329c3$exports.__esModule = true, $426f299ee58329c3$exports["default"] = $426f299ee58329c3$exports;


var $ac4cd79166dac6e4$exports = {};

var $ac4cd79166dac6e4$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $4c93951af9bb8a88$exports = {};
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$4c93951af9bb8a88$exports = $4c93951af9bb8a88$var$_assertThisInitialized, $4c93951af9bb8a88$exports.__esModule = true, $4c93951af9bb8a88$exports["default"] = $4c93951af9bb8a88$exports;


function $ac4cd79166dac6e4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac4cd79166dac6e4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $4c93951af9bb8a88$exports(t);
}
$ac4cd79166dac6e4$exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, $ac4cd79166dac6e4$exports.__esModule = true, $ac4cd79166dac6e4$exports["default"] = $ac4cd79166dac6e4$exports;


function $6c89cb228f797fa5$var$_createSuper(t) {
    var r = $426f299ee58329c3$exports();
    return function() {
        var e, o = $93d4339c80153a6a$exports(t);
        if (r) {
            var s = $93d4339c80153a6a$exports(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $ac4cd79166dac6e4$exports(this, e);
    };
}
$6c89cb228f797fa5$exports = $6c89cb228f797fa5$var$_createSuper, $6c89cb228f797fa5$exports.__esModule = true, $6c89cb228f797fa5$exports["default"] = $6c89cb228f797fa5$exports;


var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};

function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $1e0ecff44bad0ea1$exports(r);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;



var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $41f5c206613f56c9$exports(r) || $cce79e023a3a67e7$exports(r) || $51f08ebed50a2438$exports(r) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;




var $c4870074adc2be76$exports = {};
function $c4870074adc2be76$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
$c4870074adc2be76$exports = $c4870074adc2be76$var$_taggedTemplateLiteral, $c4870074adc2be76$exports.__esModule = true, $c4870074adc2be76$exports["default"] = $c4870074adc2be76$exports;



parcelRequire("1u0KT");


var $7532f3e29d96fa2a$var$StateManagedSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $9d88f0746ba78f85$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $4b23e30940068c4c$export$25ce5a424b770e84), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$StateManagedSelect;
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $acw62.useMemo)(function() {
        return (0, $76500f1a9bc57c92$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $acad92301ef10c3f$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");


var $047cb63af5f7ebf6$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $047cb63af5f7ebf6$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $047cb63af5f7ebf6$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $047cb63af5f7ebf6$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $047cb63af5f7ebf6$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $047cb63af5f7ebf6$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $047cb63af5f7ebf6$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $047cb63af5f7ebf6$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $047cb63af5f7ebf6$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $047cb63af5f7ebf6$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $4b23e30940068c4c$export$39b482c5e57630a8) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $4b23e30940068c4c$export$8b22cf2602fb60ce) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $acw62.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $acw62.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(propsOptions)) : [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $acw62.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}















parcelRequire("1u0KT");



var $37d77a8e8ee24ade$var$CreatableSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var creatableProps = (0, $9d88f0746ba78f85$export$3b14a55fb2447963)(props);
    var selectProps = (0, $047cb63af5f7ebf6$export$3b14a55fb2447963)(creatableProps);
    return /*#__PURE__*/ $acw62.createElement((0, $4b23e30940068c4c$export$25ce5a424b770e84), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, selectProps));
});
var $37d77a8e8ee24ade$export$2e2bcd8739ae039 = $37d77a8e8ee24ade$var$CreatableSelect;








var $acw62 = parcelRequire("acw62");


const $40d6849704e90728$var$Square = (props)=>{
    return $acw62.createElement("div", {
        className: `ab-CheckBox__square ab-CheckBox__square--${props.type}`
    });
};
const $40d6849704e90728$export$ea5f704b89d806f6 = ({ children: children, checked: checked, onChange: onChange, value: value, name: name, disabled: disabled, readOnly: readOnly, variant: variant = 'default', gapDistance: gapDistance = 'var(--ab-base-space)', childrenPosition: childrenPosition = 'end', as: as = 'label', ...props })=>{
    const [stateChecked, setStateChecked] = (0, $acw62.useState)(false);
    const computedChecked = checked !== undefined ? checked : stateChecked;
    const onInputChange = (event)=>{
        if (readOnly) return;
        const newChecked = event.target.checked;
        if (checked === undefined) setStateChecked(newChecked);
        if (onChange) onChange(newChecked, event);
    };
    const type = computedChecked === true ? 'checked' : computedChecked === false ? 'unchecked' : 'indeterminate';
    const gap = $acw62.createElement("div", {
        style: {
            marginLeft: gapDistance,
            display: 'inline-block'
        }
    });
    children = children ? $acw62.createElement("div", {
        style: {
            display: 'inline-block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, children) : null;
    const before = childrenPosition === 'start' ? children : null;
    const beforeGap = childrenPosition === 'start' && children ? gap : null;
    const after = childrenPosition === 'end' ? children : null;
    const afterGap = childrenPosition === 'end' && children ? gap : null;
    let indeterminate = computedChecked === null;
    const checkboxRef = (0, $acw62.useRef)(null);
    $acw62.useEffect(()=>{
        checkboxRef.current.indeterminate = indeterminate;
    }, [
        indeterminate
    ]);
    let input = $acw62.createElement("input", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`ab-CheckBox-input twa:align-middle twa:opacity-0`, {
            'twa:cursor-pointer': !readOnly && !disabled
        }),
        ref: checkboxRef,
        disabled: disabled,
        readOnly: readOnly,
        checked: !!computedChecked,
        type: "checkbox",
        name: name,
        value: value,
        onChange: onInputChange
    });
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:my-2', 'ab-CheckBox', `ab-CheckBox--${type}`, `ab-CheckBox--variant-${variant}`, disabled ? 'ab-CheckBox--disabled' : '', readOnly ? 'ab-CheckBox--readonly' : '', props.className),
        style: props.style,
        as: as
    }, before, beforeGap, input, $acw62.createElement($40d6849704e90728$var$Square, {
        type: type
    }), afterGap, after);
};
const $40d6849704e90728$export$b6a68782c21a95ce = (props)=>{
    const { orientation: orientation, ...flexProps } = props;
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: `ab-CheckBoxGroup ${orientation === 'horizontal' ? 'twa:items-center' : 'twa:items-start'}`,
        flexDirection: orientation == 'horizontal' ? 'row' : 'column',
        ...flexProps
    });
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $75d3ff690e6aacd4$export$86591c89cff5b471 = ()=>{
    const globalObject = typeof globalThis !== 'undefined' ? globalThis : window;
    return globalObject.ResizeObserver;
};


const $bdba03b512251bc7$export$bea92b1591d94f51 = (node, callback)=>{
    const RO = (0, $75d3ff690e6aacd4$export$86591c89cff5b471)();
    if (!RO) return ()=>{};
    const observer = new RO((entries)=>{
        const entry = entries[0];
        let { width: width, height: height } = entry.contentRect;
        if (entry.borderBoxSize?.[0]) {
            height = entry.borderBoxSize[0].blockSize;
            width = entry.borderBoxSize[0].inlineSize;
        } else {
            // this is needed for Safari and other browsers that don't have borderBoxSize on the entry object
            const rect = node.getBoundingClientRect();
            height = rect.height;
            width = rect.width;
        }
        callback({
            width: width,
            height: height
        });
    });
    observer.observe(node);
    return ()=>{
        observer.disconnect();
    };
};
const $bdba03b512251bc7$export$683480f191c0e3ea = (ref, callback, config = {
    earlyAttach: false
})=>{
    const sizeRef = (0, $acw62.useRef)({
        width: 0,
        height: 0
    });
    const effectFn = (callback)=>{
        let disconnect;
        if (ref.current) disconnect = $bdba03b512251bc7$export$bea92b1591d94f51(ref.current, (size)=>{
            size = {
                width: Math.round(size.width),
                height: Math.round(size.height)
            };
            const prevSize = sizeRef.current;
            if (prevSize.width !== size.width || prevSize.height !== size.height) {
                sizeRef.current = size;
                callback(size);
            }
        });
        return ()=>{
            if (disconnect) disconnect();
        };
    };
    (0, $acw62.useEffect)(()=>{
        if (!config.earlyAttach) return effectFn(callback);
        return ()=>{};
    }, [
        ref.current,
        callback,
        config.earlyAttach
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (config.earlyAttach) return effectFn(callback);
        return ()=>{};
    }, [
        ref.current,
        callback,
        config.earlyAttach
    ]);
};
const $bdba03b512251bc7$export$b0ef64f51076c332 = ({ notifyOnMount: notifyOnMount = true, earlyAttach: earlyAttach = false, ...props })=>{
    const style = (0, $acw62.useMemo)(()=>({
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            boxSizing: 'border-box'
        }), []);
    const firstTime = (0, $acw62.useRef)(true);
    const ref = (0, $acw62.useRef)(null);
    const onResize = (0, $acw62.useCallback)((size)=>{
        if (firstTime.current && !notifyOnMount) {
            firstTime.current = false;
            return;
        }
        props.onResize(size);
    }, [
        props.onResize
    ]);
    $bdba03b512251bc7$export$683480f191c0e3ea(ref, onResize, {
        earlyAttach: earlyAttach || false
    });
    return $acw62.createElement("div", {
        ref: ref,
        style: style
    });
};


const $7ca46b6c13a23272$var$WRAPPER_STYLE = {
    position: 'absolute',
    pointerEvents: 'none',
    width: 0,
    height: 0,
    lineHeight: 0,
    fontSize: 0,
    overflow: 'hidden'
};
const $7ca46b6c13a23272$export$ef5fb2cddf0486c3 = (params)=>{
    const lastValueRef = (0, $acw62.useRef)(0);
    const onResize = $acw62.useCallback(({ height: height })=>{
        if (height != null && height !== lastValueRef.current) {
            lastValueRef.current = height;
            params.onChange(height);
        }
    }, [
        params.onChange
    ]);
    (0, $bdba03b512251bc7$export$683480f191c0e3ea)(params.ref, onResize, {
        earlyAttach: true
    });
    $acw62.useLayoutEffect(()=>{
        const value = params.ref.current.getBoundingClientRect().height;
        if (value != null) {
            lastValueRef.current = value;
            return params.onChange(value);
        } else console.warn(`Specified variable ${params.varName} not found or does not have a numeric value.`);
    }, []);
};
const $7ca46b6c13a23272$export$1d65a13051277e32 = (props)=>{
    const domRef = (0, $acw62.useRef)(null);
    $7ca46b6c13a23272$export$ef5fb2cddf0486c3({
        ...props,
        ref: domRef
    });
    const height = props.varName.startsWith('var(') ? props.varName : `var(${props.varName})`;
    const { allowInts: allowInts = false } = props;
    return $acw62.createElement("div", {
        "data-name": "css-variable-watcher",
        "data-var": props.varName,
        style: $7ca46b6c13a23272$var$WRAPPER_STYLE
    }, $acw62.createElement("div", {
        ref: domRef,
        style: {
            height: allowInts ? `calc(1px * ${height})` : height
        }
    }));
};



const $599140a53e2e68e7$var$computedCSSVarNames = [
    '--ab-cmp-select-menu__max-width',
    '--ab-cmp-select-menu__min-width',
    '--ab-cmp-select-menu__max-height'
];
const $599140a53e2e68e7$var$defaultValues = Object.fromEntries($599140a53e2e68e7$var$computedCSSVarNames.map((varName)=>[
        varName,
        0
    ]));
const $599140a53e2e68e7$export$9c6a32ef9614a74 = $acw62.createContext($599140a53e2e68e7$var$defaultValues);
const $599140a53e2e68e7$export$fefa09e87d1a013f = ({ children: children })=>{
    const [computedCSSVars, doSetComputedCSSVars] = $acw62.useState($599140a53e2e68e7$var$defaultValues);
    const setComputedCSSVars = (0, $acw62.useMemo)(()=>{
        return (0, $c34d1d35432b7498$export$2e2bcd8739ae039)(doSetComputedCSSVars, 300, {
            leading: false,
            trailing: true
        });
    }, [
        doSetComputedCSSVars
    ]);
    return $acw62.createElement($599140a53e2e68e7$export$9c6a32ef9614a74.Provider, {
        value: computedCSSVars
    }, children, $599140a53e2e68e7$var$computedCSSVarNames.map((varName)=>$acw62.createElement((0, $7ca46b6c13a23272$export$1d65a13051277e32), {
            key: varName,
            varName: varName,
            onChange: (value)=>{
                setComputedCSSVars((prev)=>({
                        ...prev,
                        [varName]: value
                    }));
            }
        })));
};
const $599140a53e2e68e7$export$8760aa589cf5cb86 = ()=>{
    const context = $acw62.useContext($599140a53e2e68e7$export$9c6a32ef9614a74);
    return context;
};
const $599140a53e2e68e7$export$feb532b495edc6a7 = (varName)=>{
    const context = $acw62.useContext($599140a53e2e68e7$export$9c6a32ef9614a74);
    return context?.[varName];
};




const $765350da0379ad82$var$resizableDirections = {
    right: true,
    bottom: true,
    bottomRight: true
};
const $765350da0379ad82$var$defaultResizableSize = {
    width: '100%'
};
const $765350da0379ad82$var$checkboxStyle = {
    position: 'relative',
    top: 1
};
const $765350da0379ad82$var$INFINITE_DOM_PROPS = {
    style: {
        // height: '100%',
        flex: 1,
        // maxHeight: '50vh',
        width: '100%'
    }
};
const $765350da0379ad82$var$infiniteContentValueClassName = 'InfiniteCell_content_value';
const $765350da0379ad82$var$renderValue = ({ renderBag: renderBag, data: data, value: value })=>{
    if (data.tooltip) {
        const tooltipNode = typeof data.tooltip === 'string' ? data.tooltip : value;
        return $acw62.createElement((0, $0735c2b2ea9ec97d$export$2e2bcd8739ae039), {
            label: tooltipNode
        }, $acw62.createElement("div", {
            className: $765350da0379ad82$var$infiniteContentValueClassName
        }, renderBag.value));
    }
    return $acw62.createElement("div", {
        className: $765350da0379ad82$var$infiniteContentValueClassName
    }, renderBag.value);
};
const $765350da0379ad82$var$INFINITE_COLUMNS_WITH_CHECKBOX = {
    label: {
        field: 'label',
        defaultFlex: 1,
        style: {
            lineHeight: '30px'
        },
        resizable: false,
        defaultSortable: false,
        renderSelectionCheckBox: (params)=>{
            // disable reacting to onChange
            // as we handle selection change in the onCellClick
            return $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                className: "twa:mx-1",
                checked: params.rowInfo?.rowSelected ?? false
            });
        },
        renderHeaderSelectionCheckBox: true,
        className: 'ab-Select-CheckboxColumn',
        renderValue: $765350da0379ad82$var$renderValue,
        renderHeader: (headerParams)=>{
            const selected = headerParams.allRowsSelected ? true : headerParams.someRowsSelected ? null : false;
            const { api: api } = headerParams;
            return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                className: "twa:mx-1",
                checked: selected,
                onChange: (selected)=>{
                    if (selected) api.rowSelectionApi.selectAll();
                    else api.rowSelectionApi.deselectAll();
                }
            }, headerParams.allRowsSelected ? '(Deselect All)' : '(Select All)'));
        },
        renderMenuIcon: false
    }
};
const $765350da0379ad82$var$INFINITE_COLUMNS_WITH_RADIO = {
    label: {
        field: 'label',
        defaultFlex: 1,
        renderValue: $765350da0379ad82$var$renderValue
    }
};
const $765350da0379ad82$var$isRowDisabled = ({ data: data })=>{
    return data ? !!data.isDisabled : false;
};
const $765350da0379ad82$var$rowClassName = ({ data: data })=>{
    const flags = data.isDisabled ? 'ab-Select-Row--disabled' : '';
    return `ab-Select-Row ${flags}`;
};
const $765350da0379ad82$var$fontCommonStyles = {
    fontSize: 'var(--ab-cmp-select__font-size)',
    fontFamily: 'var(--ab-cmp-select__font-family)'
};
const $765350da0379ad82$var$commonStyles = ({ isDisabled: isDisabled })=>{
    return {
        color: 'var(--ab-cmp-input__color)',
        background: isDisabled ? 'var(--ab-cmp-input--disabled__background)' : 'var(--ab-cmp-input__background)',
        ...$765350da0379ad82$var$fontCommonStyles
    };
};
const $765350da0379ad82$var$doesOptionMatchValue = function(value) {
    return (option)=>{
        if (typeof option.value === 'object' && option.value instanceof Date) return (0, $27a7db21eafd685b$export$ea39ec197993aef0)(option.value, value);
        return option.value === value;
    };
};
const $765350da0379ad82$export$ef9b1a59e592288f = function(props) {
    let maxLabelLength = 0;
    const inputId = (0, $acw62.useId)();
    const computedCSSVars = (0, $599140a53e2e68e7$export$8760aa589cf5cb86)();
    const CSS_VARS_VALUES = {
        '--ab-cmp-select-menu__max-width': computedCSSVars['--ab-cmp-select-menu__max-width'] || '60vw',
        '--ab-cmp-select-menu__min-width': computedCSSVars['--ab-cmp-select-menu__min-width'] || 150,
        '--ab-cmp-select-menu__max-height': computedCSSVars['--ab-cmp-select-menu__max-height'] || '60vh'
    };
    const searchableInMenulist = props.searchable === 'menulist';
    const searchableInline = props.searchable === 'inline';
    // relevant for menulist search only
    const menulistInputRef = $acw62.useRef(null);
    const [isSelectMenuOpen, setIsSelectMenuOpen] = (0, $acw62.useState)(false);
    const propsOnMenuOpen = props.onMenuOpen;
    const openSelectMenu = $acw62.useCallback(()=>{
        setIsSelectMenuOpen(true);
        // it's a react-select bug, onMenuOpen is not called with controlled menuIsOpen
        propsOnMenuOpen?.();
    }, [
        propsOnMenuOpen
    ]);
    const closeSelectMenu = $acw62.useCallback(()=>{
        setIsSelectMenuOpen(false);
    }, []);
    const ref = $acw62.useRef(null);
    const valueToOptionMap = new Map((props.options || []).map((opt)=>{
        let label = opt.label;
        if (typeof label === 'string' || typeof label === 'number' || typeof label === 'boolean') maxLabelLength = Math.max(maxLabelLength, `${label}`.length);
        return [
            opt.value,
            opt
        ];
    }));
    const findOptionByValue = (value)=>{
        const option = valueToOptionMap.get(value);
        if (option) return option;
        // try date comparison if the value is a date
        // or if it's a number but the options are dates
        if (typeof value === 'object' && value instanceof Date || Array.isArray(props.options) && props.options.length && typeof props.options[0] === 'object' && props.options[0].value instanceof Date) return (props.options || []).find($765350da0379ad82$var$doesOptionMatchValue(value)) ?? null;
        return null;
    };
    const renderMultipleValues = props.renderMultipleValues;
    const isMulti = props.isMulti ?? Array.isArray(props.value);
    const showHeaderSelectionCheckbox = isMulti && (props.showHeaderSelectionCheckbox ?? false);
    const skipDefaultFiltering = props.skipDefaultFiltering ?? false;
    let selectedOption = null;
    if (isMulti) selectedOption = (props.value ?? []).map((value)=>{
        const option = findOptionByValue(value);
        if (!option) return {
            value: value,
            label: value
        };
        return option;
    }) ?? null;
    else {
        selectedOption = findOptionByValue(props.value);
        if (!selectedOption && props.value !== undefined && props.value !== null && props.value !== '') selectedOption = {
            value: props.value,
            label: props.value
        };
    }
    let disabled = props.disabled ?? false;
    const accessLevel = props.accessLevel ?? 'Full';
    if (accessLevel === 'Hidden') return null;
    if (accessLevel === 'ReadOnly') disabled = true;
    /**
     * If on each render a new reference is passed, the menu will not open using the keyboard.
     */ /**
     * Use refs for isSelectMenuOpen, openSelectMenu, and closeSelectMenu so that
     * SelectContainer is stable across re-renders. If SelectContainer gets a new
     * reference when menu opens/closes, react-select recreates its internal
     * component tree, the DummyInput is removed from DOM, and focus is lost.
     */ const isSelectMenuOpenRef = $acw62.useRef(isSelectMenuOpen);
    isSelectMenuOpenRef.current = isSelectMenuOpen;
    const openSelectMenuRef = $acw62.useRef(openSelectMenu);
    openSelectMenuRef.current = openSelectMenu;
    const closeSelectMenuRef = $acw62.useRef(closeSelectMenu);
    closeSelectMenuRef.current = closeSelectMenu;
    const SelectContainer = $acw62.useMemo(()=>{
        return (selectContainerProps)=>{
            return $acw62.createElement((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).SelectContainer, {
                ...selectContainerProps,
                innerProps: {
                    // @ts-ignore
                    'data-name': props['data-name'],
                    'data-id': props['data-id'],
                    'data-test': props.searchable || false,
                    ...selectContainerProps.innerProps,
                    onMouseDown: (e)=>{
                        if (!searchableInMenulist) return;
                        if (!isSelectMenuOpenRef.current) {
                            openSelectMenuRef.current();
                            e.stopPropagation();
                            e.preventDefault();
                        }
                    },
                    onKeyDownCapture: (e)=>{
                        if (!searchableInMenulist) return;
                        if (isSelectMenuOpenRef.current) {
                            if (e.key === 'Escape') {
                                closeSelectMenuRef.current();
                                e.stopPropagation();
                                e.preventDefault();
                                e.nativeEvent.stopImmediatePropagation();
                                // we do this because the focus is lost when the menu is closed
                                // and document.body is set as the active element
                                requestAnimationFrame(()=>{
                                    document.getElementById(inputId)?.focus();
                                    // we need to do it again
                                    // also don't store a ref to the input element
                                    // but query the DOM again
                                    // as the old ref is no longer in the DOM
                                    // because of a react-select bug I presume
                                    requestAnimationFrame(()=>{
                                        document.getElementById(inputId)?.focus();
                                    });
                                });
                            }
                        } else // open the menu
                        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
                            openSelectMenuRef.current();
                            e.stopPropagation();
                            e.preventDefault();
                            e.nativeEvent.stopImmediatePropagation();
                        }
                    }
                }
            });
        };
    }, [
        searchableInMenulist
    ]);
    const resizable = props.resizable ?? false;
    const ValueContainer = $acw62.useMemo(()=>{
        return (props)=>{
            let { children: children, ...inputProps } = props;
            const initialChildren = children;
            const currentValues = inputProps.getValue();
            const customRenderValue = renderMultipleValues?.(currentValues, {
                focused: focusedRef.current,
                placeholder: props.placeholder
            });
            const title = typeof customRenderValue === 'string' ? customRenderValue : '';
            children = customRenderValue ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:flex twa:flex-row twa:flex-1 twa:flex-nowrap twa:items-center twa:overflow-hidden twa:h-full"
            }, $acw62.createElement("span", {
                title: title,
                "data-name": "multi-value-text",
                style: {
                    flex: '0 1 auto',
                    appearance: 'none',
                    border: 'none',
                    background: 'transparent',
                    outline: 'none',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }
            }, customRenderValue), initialChildren[1]) : initialChildren;
            return $acw62.createElement((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).ValueContainer, {
                ...inputProps,
                innerProps: {
                    'data-name': 'value-container',
                    ...inputProps.innerProps
                }
            }, children);
        };
    }, [
        renderMultipleValues,
        props.placeholder
    ]);
    const sizeRef = $acw62.useRef({
        ...$765350da0379ad82$var$defaultResizableSize
    });
    const MenuComponent = $acw62.useMemo(()=>{
        return (menuProps)=>{
            const { isLoading: isLoading } = menuProps;
            const theChildren = $acw62.createElement($acw62.Fragment, null, menuProps.children, $acw62.createElement("div", {
                style: {
                    display: isLoading ? 'block' : 'none',
                    position: 'absolute',
                    inset: 0,
                    background: `var(--ab-cmp-select-loading__background)`,
                    zIndex: 1
                }
            }));
            const onResizeStop = (0, $acw62.useCallback)((_e, _direction, ref)=>{
                const newSize = {
                    width: ref.style.width,
                    height: ref.style.height
                };
                sizeRef.current = newSize;
            }, []);
            return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).Menu, {
                ...menuProps,
                innerProps: {
                    // @ts-ignore
                    'data-name': 'menu-container',
                    'data-resizable': resizable,
                    ...menuProps.innerProps,
                    onBlur: (e)=>{
                        if (!searchableInMenulist) return;
                        const { relatedTarget: relatedTarget } = e;
                        const menuDOMNode = menuProps.innerRef && 'current' in menuProps.innerRef ? menuProps.innerRef.current : null;
                        if (menuDOMNode && relatedTarget == menuDOMNode || menuDOMNode?.contains(relatedTarget)) // ignore the event if the focus is still inside the menu
                        return;
                        requestAnimationFrame(()=>{
                            // wee need to wait for the single value selection to complete before closing
                            closeSelectMenu();
                        });
                    },
                    onMouseDown: (event)=>{
                        if (!props.isMulti) menuProps.innerProps?.onMouseDown?.(event);
                        if (!searchableInMenulist) return;
                        if (props.isMulti) // to avoid the menu closing when clicking inside it
                        event.stopPropagation();
                    }
                }
            }, resizable ? $acw62.createElement((0, $7b0f618bf8d2ec2e$export$e82068809229c83c), {
                className: "ab-Select-MenuContainer-Resizable",
                enable: $765350da0379ad82$var$resizableDirections,
                // ideally we wouldn't need those to be computed values
                // and instead pass the CSS var name, like `var(--ab-cmp-select-menu__min-width)`
                // to the Resizable component, but it won't respect them
                // so we needed to read the CSS variables from the DOM, using CSSNumericVariableWatch
                // and then pass the actual values to Resizable
                minWidth: CSS_VARS_VALUES['--ab-cmp-select-menu__min-width'],
                maxHeight: CSS_VARS_VALUES['--ab-cmp-select-menu__max-height'],
                maxWidth: CSS_VARS_VALUES['--ab-cmp-select-menu__max-width'],
                defaultSize: sizeRef.current,
                onResizeStop: onResizeStop,
                onResizeStart: (e)=>{
                    e.preventDefault();
                },
                handleClasses: {
                    right: 'ab-Select-resize-handle ab-Select-resize-handle--right',
                    bottom: 'ab-Select-resize-handle ab-Select-resize-handle--bottom',
                    bottomRight: 'ab-Select-resize-handle ab-Select-resize-handle--bottom-right'
                }
            }, theChildren) : theChildren));
        };
    }, [
        resizable,
        JSON.stringify(CSS_VARS_VALUES)
    ]);
    const SelectComponent = props.isCreatable ? (0, $37d77a8e8ee24ade$export$2e2bcd8739ae039) : (0, $7532f3e29d96fa2a$export$2e2bcd8739ae039);
    const ClearIndicator = $acw62.useMemo(()=>{
        return (clearIndicatorProps)=>{
            return $acw62.createElement((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).ClearIndicator, {
                ...clearIndicatorProps
            }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "close"
            }));
        };
    }, []);
    const MenuList = $acw62.useMemo(()=>{
        return (props)=>{
            const { setValue: setValue, getValue: getValue, focusedOption: focusedOption, options: options, selectProps: selectProps } = props;
            const { filterOption: filterOption, inputValue: inputValue, isLoading: isLoading } = selectProps;
            // Focus the input when MenuList mounts
            $acw62.useEffect(()=>{
                if (menulistInputRef.current) menulistInputRef.current.focus();
            }, []);
            const filterFunction = $acw62.useCallback(({ data: data })=>filterOption({
                    data: data,
                    label: `${data.label}`,
                    value: data.value
                }, inputValue), [
                filterOption,
                inputValue
            ]);
            const hasFilter = inputValue !== '' && !skipDefaultFiltering;
            const filteredOptionsValues = new Set();
            const filteredOptions = !hasFilter ? options : options.filter((data)=>{
                const included = filterOption({
                    data: data,
                    label: `${data.label}`,
                    value: data.value
                }, inputValue);
                if (included) filteredOptionsValues.add(data.value);
                return included;
            });
            const focusedOptionIndex = options.filter((option)=>filterFunction({
                    data: option
                })).indexOf(focusedOption);
            const valueStrKey = getValue()// if we simply map, then if we have [] or [''], they will map to the same value
            // but we need it to be different
            // so we can trigger a change when the value changes
            .map((option, index)=>`${index}-${option.value}`).join(',');
            const selectedRows = (0, $acw62.useMemo)(()=>{
                const selectedRows = [];
                // we build the Infinite Table selection
                getValue().forEach((option)=>{
                    // if there are no filters, include everything that is in the value
                    // but if there is a filter (which will be smaller than the current value)
                    // only include the current options that match the filter
                    if (!hasFilter || filteredOptionsValues.has(option.value)) selectedRows.push(option.value);
                });
                return selectedRows;
            }, [
                valueStrKey,
                inputValue,
                hasFilter
            ]);
            const rowSelection = $acw62.useMemo(()=>{
                return isMulti ? {
                    selectedRows: selectedRows,
                    deselectedRows: [],
                    defaultSelection: false
                } : selectedRows[0];
            }, [
                selectedRows,
                isMulti
            ]);
            const onRowSelectionChange = $acw62.useCallback((selectionParams)=>{
                let selection = [];
                const { selectedRows: selectedRows, defaultSelection: defaultSelection, deselectedRows: deselectedRows } = selectionParams;
                if (hasFilter) {
                    if (defaultSelection === true && deselectedRows.length === 0) {
                        // all selected
                        const currentValue = getValue();
                        const includedKeys = new Set();
                        // add all the options that are in the current value
                        selection = currentValue.map((option)=>{
                            includedKeys.add(option.value);
                            return option;
                        });
                        // also add all the options that match the filter
                        filteredOptions.forEach((option)=>{
                            // make sure you don't add the same option twice
                            if (!includedKeys.has(option.value)) selection.push({
                                value: option.value
                            });
                        });
                    } else if (defaultSelection === false && selectedRows.length === 0) {
                        // we need to clear the selection
                        // but we have a filter, so we need to clear only those options that are included in the filter
                        // and leave the rest
                        const currentValue = getValue();
                        selection = currentValue.filter((row)=>!filteredOptionsValues.has(row.value));
                    } else {
                        // some selected
                        const currentValue = getValue();
                        const includedKeys = new Set();
                        // start with an empty selection
                        selection = [];
                        // add those in the value that are not in the filter
                        selection = currentValue.filter((row)=>{
                            const res = !filteredOptionsValues.has(row.value);
                            if (res) includedKeys.add(row.value);
                            return res;
                        });
                        // and now also add those in the filter that are actually selected
                        selectedRows.forEach((row)=>{
                            if (!includedKeys.has(row)) selection.push({
                                value: row
                            });
                        });
                    }
                } else {
                    if (defaultSelection === true && deselectedRows.length === 0) // all selected
                    selection = options.map((option)=>{
                        return {
                            value: option.value
                        };
                    });
                    else if (defaultSelection === false && selectedRows.length === 0) // none selected
                    selection = [];
                    else // some selected
                    selection = selectedRows.map((row)=>{
                        return {
                            value: row
                        };
                    });
                }
                //@ts-ignore
                setValue(selection, 'select-option');
            }, [
                setValue,
                filterOption,
                inputValue,
                hasFilter,
                filteredOptions,
                rowSelection,
                valueStrKey
            ]);
            const onSingleRowSelectionChange = $acw62.useCallback((value)=>{
                if (value == undefined && rowSelection != undefined) return;
                //@ts-ignore
                setValue({
                    value: value
                }, 'select-option');
            }, [
                setValue
            ]);
            const onCellClick = $acw62.useCallback(({ rowIndex: rowIndex, api: api, dataSourceApi: dataSourceApi })=>{
                if (isMulti) {
                    const pk = dataSourceApi.getPrimaryKeyByIndex(rowIndex);
                    api.rowSelectionApi.toggleRowSelection(pk);
                }
                if (searchableInMenulist) requestAnimationFrame(()=>{
                    menulistInputRef.current?.focus();
                });
            }, []);
            const prevInputValueRef = $acw62.useRef('');
            return $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
                // @ts-ignore
                // data={props.options}
                // @ts-ignore
                data: filteredOptions,
                primaryKey: "value",
                selectionMode: isMulti ? 'multi-row' : 'single-row',
                // @ts-ignore
                onRowSelectionChange: isLoading ? null : isMulti ? onRowSelectionChange : onSingleRowSelectionChange,
                rowSelection: rowSelection,
                isRowDisabled: $765350da0379ad82$var$isRowDisabled
            }, searchableInMenulist && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                className: "twa:p-1 ab-Select-MenulistSearchContainer"
            }, $acw62.createElement("input", {
                ref: menulistInputRef,
                "data-name": "menulist-search-input",
                style: {
                    width: '100%'
                },
                className: 'ab-Select-MenulistSearch ab-Input ab-Input--type-text',
                autoCorrect: "off",
                autoComplete: "off",
                spellCheck: "false",
                type: "text",
                value: inputValue,
                onChange: (e)=>{
                    const currentValue = e.currentTarget.value;
                    onInputChange(currentValue, {
                        action: 'input-change',
                        prevInputValue: prevInputValueRef.current
                    });
                    prevInputValueRef.current = currentValue;
                },
                onMouseDown: (e)=>{
                    e.stopPropagation();
                    const inputElement = e.target;
                    inputElement?.focus?.();
                },
                onTouchEnd: (e)=>{
                    e.stopPropagation();
                    const inputElement = e.target;
                    inputElement?.focus?.();
                },
                placeholder: "Search..."
            })), $acw62.createElement((0, $88ab1a78ec8ca4b4$export$6f97e3045480ac8c), {
                header: isMulti && showHeaderSelectionCheckbox ? true : false,
                rowClassName: $765350da0379ad82$var$rowClassName,
                showZebraRows: false,
                rowHeight: '--ab-grid-row-height',
                onCellClick: isLoading ? null : onCellClick,
                keyboardNavigation: isLoading ? false : 'row',
                activeRowIndex: focusedOptionIndex,
                keyboardSelection: true,
                columns: isMulti ? $765350da0379ad82$var$INFINITE_COLUMNS_WITH_CHECKBOX : $765350da0379ad82$var$INFINITE_COLUMNS_WITH_RADIO,
                domProps: $765350da0379ad82$var$INFINITE_DOM_PROPS
            }));
        };
    }, [
        isMulti,
        skipDefaultFiltering,
        showHeaderSelectionCheckbox
    ]);
    const DropdownIndicator = $acw62.useMemo(()=>{
        return (dropdownIndicatorProps)=>{
            return $acw62.createElement((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).DropdownIndicator, {
                ...dropdownIndicatorProps,
                innerProps: {
                    ...dropdownIndicatorProps.innerProps
                }
            }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "triangle-down",
                style: {
                    height: 20,
                    width: 20
                }
            }));
        };
    }, []);
    const focusedRef = $acw62.useRef(false);
    const onFocus = $acw62.useCallback(()=>{
        focusedRef.current = true;
        props.onFocus?.();
    }, [
        props.onFocus
    ]);
    const onBlur = $acw62.useCallback(()=>{
        focusedRef.current = false;
        props.onBlur?.();
    }, [
        props.onBlur
    ]);
    const [inputValue, setInputValue] = $acw62.useState('');
    const onInputChange = $acw62.useCallback((value, actionMeta)=>{
        if (isMulti && actionMeta.action === 'set-value') // when selecting an option, don't clear the input filter
        return;
        setInputValue(value);
        props.onInputChange?.(value);
    }, [
        props.onInputChange,
        isMulti
    ]);
    /**
     * Use refs for selectedOption and renderSingleValue so that the
     * SingleValue component function is stable across re-renders.
     * If SingleValue gets a new reference on each render, selectComponents changes,
     * react-select recreates its internal component tree, the DummyInput is removed
     * from DOM, and focus is lost (the keyboard stops working).
     * See the comment above SelectContainer about this exact issue.
     */ const selectedOptionRef = $acw62.useRef(selectedOption);
    selectedOptionRef.current = selectedOption;
    const renderSingleValueRef = $acw62.useRef(props.renderSingleValue);
    renderSingleValueRef.current = props.renderSingleValue;
    const SingleValue = $acw62.useMemo(()=>{
        return (singleValueProps)=>{
            return $acw62.createElement((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).SingleValue, {
                ...singleValueProps
            }, renderSingleValueRef.current ? renderSingleValueRef.current(selectedOptionRef.current) : singleValueProps.children);
        };
    }, []);
    const selectComponents = (0, $acw62.useMemo)(()=>{
        return {
            SelectContainer: SelectContainer,
            ValueContainer: ValueContainer,
            Menu: MenuComponent,
            SingleValue: SingleValue,
            ClearIndicator: ClearIndicator,
            DropdownIndicator: DropdownIndicator,
            MenuList: MenuList
        };
    }, [
        SelectContainer,
        ValueContainer,
        MenuComponent,
        SingleValue,
        ClearIndicator,
        DropdownIndicator,
        MenuList
    ]);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement(SelectComponent, {
        ref: ref,
        openMenuOnClick: searchableInMenulist ? false : undefined,
        openMenuOnFocus: searchableInMenulist ? false : undefined,
        menuIsOpen: searchableInMenulist ? isSelectMenuOpen : undefined,
        isSearchable: searchableInline,
        "aria-label": props['aria-label'],
        onKeyDown: props.onKeyDown,
        inputValue: inputValue,
        inputId: inputId,
        onInputChange: onInputChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onMenuOpen: props.onMenuOpen,
        isLoading: props.isLoading,
        options: props.options,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(props.className, 'ab-Select'),
        isDisabled: disabled,
        menuPlacement: props.menuPlacement ?? 'auto',
        hideSelectedOptions: false,
        isMulti: isMulti,
        value: selectedOption,
        blurInputOnSelect: false,
        menuPosition: props.menuPosition ?? 'absolute',
        // This needed so the menu is not clipped by overflow: hidden
        menuPortalTarget: (0, $c9ce1fb924ab724e$export$8fdff8edfcdcc4a8)(),
        isClearable: props.isClearable,
        closeMenuOnSelect: props.closeMenuOnSelect,
        onChange: (option)=>{
            if (isMulti) {
                const value = option.map((x)=>x?.value);
                props.onChange(value);
            } else props.onChange(option?.value);
            if (searchableInMenulist) // ensure element keeps focus
            requestAnimationFrame(()=>{
                menulistInputRef.current?.focus();
            });
        },
        placeholder: props.placeholder,
        createOptionPosition: 'first',
        // formatCreateLabel={(inputValue) => inputValue} // can we make this auto??
        // we use this:  https://react-select.com/creatable
        components: selectComponents,
        /**
             * Using styles is the preferred way to style react-select.
             * https://react-select.com/styles#the-styles-prop
             */ styles: {
            // Typescript issue with csstype@3.1.3
            // https://github.com/JedWatson/react-select/issues/5825#issuecomment-1850472549
            // Remove
            container: (baseStyle)=>{
                return {
                    ...baseStyle,
                    ...props.style,
                    ...props.styles?.container
                };
            },
            // @ts-ignorets-ignore when fixed
            menuPortal: (baseStyle)=>{
                return {
                    ...baseStyle,
                    // needed to avoid tooltips from being displayed under this menu
                    // as otherwise react-select uses zIndex 1
                    zIndex: 'auto',
                    textAlign: 'left'
                };
            },
            // @ts-ignore
            menu: (baseStyle, state)=>{
                return {
                    ...baseStyle,
                    // needed to avoid tooltips from being displayed under this menu
                    // as otherwise react-select uses zIndex 1
                    zIndex: 'auto',
                    width: resizable ? '100%' : `${Math.max(maxLabelLength, 10)}ch`,
                    '--ab-cmp-select-menu__min-height': `min(${(props.options || []).length + (showHeaderSelectionCheckbox ? 1 : 0)} * var(--ab-grid-row-height) + ${searchableInMenulist ? 40 : 0}px, ${searchableInMenulist ? 22 : 20}rem)`,
                    maxHeight: 'var(--ab-cmp-select-menu__max-height)',
                    minWidth: 'var(--ab-cmp-select-menu__min-width)',
                    maxWidth: 'var(--ab-cmp-select-menu__max-width)',
                    ...$765350da0379ad82$var$commonStyles(state),
                    ...props.menuStyle
                };
            },
            // @ts-ignore
            option: (baseStyle, state)=>{
                const style = {
                    ...baseStyle,
                    ...$765350da0379ad82$var$commonStyles(state),
                    '&:active': {
                        background: 'var(--ab-cmp-select-option-active__background)'
                    }
                };
                if (state.isSelected) {
                    style.background = 'var(--ab-cmp-select-option-active__background)';
                    style.color = 'var(--ab-cmp-select-option-active__color)';
                }
                if (state.isFocused) style.background = 'var(--ab-cmp-select-option-focused__background)';
                return style;
            },
            // @ts-ignore
            input: (baseStyle, state)=>{
                return {
                    ...baseStyle,
                    padding: props.size === 'small' ? 0 : baseStyle.padding,
                    color: 'var(--ab-cmp-select__color)'
                };
            },
            valueContainer: (baseStyle)=>{
                return {
                    ...baseStyle,
                    padding: props.size === 'small' ? `0 var(--ab-base-space)` : baseStyle.padding,
                    ...props.styles?.valueContainer
                };
            },
            // @ts-ignore
            singleValue: (baseStyle, state)=>{
                return {
                    ...baseStyle,
                    ...$765350da0379ad82$var$commonStyles(state)
                };
            },
            // @ts-ignore
            control: (baseStyle, state)=>{
                return {
                    ...baseStyle,
                    ...$765350da0379ad82$var$commonStyles(state),
                    minHeight: props.size === 'small' ? 0 : 'var(--ab-input-height)',
                    boxShadow: state.isFocused ? 'var(--ab-cmp-select-focused__box-shadow)' : 'none',
                    outline: state.isFocused ? 'var(--ab-cmp-select-focused__outline)' : 'none',
                    border: 'var(--ab-cmp-select__border)',
                    borderRadius: 'var(--ab-cmp-select__border-radius)',
                    '&:hover': {
                        border: 'var(--ab-cmp-select__border)'
                    },
                    ...props.styles?.control
                };
            },
            // @ts-ignore
            dropdownIndicator: (baseStyle)=>{
                return {
                    ...baseStyle,
                    padding: 0,
                    ...props.styles?.dropdownIndicator
                };
            },
            // @ts-ignore
            clearIndicator: (baseStyle)=>{
                return {
                    ...baseStyle,
                    padding: '2px 3px'
                };
            },
            multiValue: (baseStyle)=>{
                return {
                    ...baseStyle,
                    color: 'var(--ab-cmp-select__color)',
                    background: 'var(--ab-cmp-select-multi-value__background)',
                    border: 'var(--ab-cmp-select__border)'
                };
            },
            multiValueLabel: (baseStyle)=>{
                return {
                    ...baseStyle,
                    ...$765350da0379ad82$var$fontCommonStyles,
                    color: 'var(--ab-cmp-select__color)'
                };
            }
        }
    }));
};






const $afafaa5c90dbf256$var$onDatePickerDropdownKeyDown = (e)=>{
    if (e.key === 'Escape' || e.key === 'Enter') e.stopPropagation();
};
const $afafaa5c90dbf256$var$DatePickerComponents = {
    YearsDropdown: (props)=>{
        const onChange = (0, $acw62.useCallback)((value)=>{
            props.onChange?.({
                target: {
                    value: value
                }
            });
        }, [
            props.onChange
        ]);
        return $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
            onKeyDown: $afafaa5c90dbf256$var$onDatePickerDropdownKeyDown,
            value: props.value,
            onChange: onChange,
            options: props.options
        });
    },
    MonthsDropdown: (props)=>{
        const onChange = (0, $acw62.useCallback)((value)=>{
            props.onChange?.({
                target: {
                    value: value
                }
            });
        }, [
            props.onChange
        ]);
        return $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
            onKeyDown: $afafaa5c90dbf256$var$onDatePickerDropdownKeyDown,
            value: `${props.value}`,
            onChange: onChange,
            options: props.options.map((option)=>{
                return {
                    label: option.label,
                    value: `${option.value}`
                };
            })
        });
    }
};
const $afafaa5c90dbf256$var$DatepickerOverlay = ({ onHide: onHide, children: children, onKeyDown: onKeyDown, onMouseDown: onMouseDown, overlayDOMRef: overlayDOMRef })=>{
    const domRef = $acw62.useRef(null);
    return $acw62.createElement("div", {
        className: "ab-Datepicker-Overlay",
        tabIndex: -1,
        ref: (el)=>{
            domRef.current = el;
            overlayDOMRef.current = el;
        },
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onBlur: (e)=>{
            const { relatedTarget: relatedTarget } = e;
            const node = domRef.current;
            // relatedTarget is the newly focused element as a result of this blur event
            // so we close the overlay when the newly focused element is outside the overlay
            if (relatedTarget == null || !node.contains?.(relatedTarget)) onHide();
        }
    }, children);
};
const $afafaa5c90dbf256$var$END_MONTH = (0, $6cbfdc6d008595cd$export$8b7aa55c66d5569e)((0, $25460c542fb3bf74$export$3d83eec43f4ea476)(new Date(), 10));
const $afafaa5c90dbf256$var$START_MONTH = (0, $29cc086f79701cd9$export$f91e89d3d0406102)((0, $25460c542fb3bf74$export$3d83eec43f4ea476)(new Date(), -50));
const $afafaa5c90dbf256$export$7235422eca03ec90 = $acw62.forwardRef((props, ref)=>{
    const { dateProps: dateProps, required: required, disabled: disabled, style: style, className: className, placeholder: placeholder, showWeekNumber: showWeekNumber, showOutsideDays: showOutsideDays, value: _, defaultValue: __, onChange: ___, datepickerButtons: datepickerButtons, showClearButton: showClearButton, autoFocus: autoFocus, ...boxProps } = props;
    const datepickerContext = (0, $4ac5c79eccb33a7d$export$84c5c808acc282aa)();
    let [value, setValue] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'value', undefined, {
        onChange: props.onChange
    });
    (0, $acw62.useEffect)(()=>{
        // when value is reset, also reset the month to the current month
        if (!value) setMonth(new Date());
    }, [
        !!value
    ]);
    const [month, setMonth] = (0, $acw62.useState)(value ?? new Date());
    const updateValue = (value)=>{
        setValue(value);
        setMonth(value ?? new Date());
    };
    const inputValue = (0, $1fe81e1078ace264$export$ad991b66133851cf)(value, {
        Pattern: dateProps.format
    }) ?? '';
    const [visible, doSetVisible] = (0, $acw62.useState)(false);
    const setVisible = (visible, keyboardEventKey)=>{
        doSetVisible(visible);
        if (!visible) datepickerContext?.onHide?.(keyboardEventKey);
        else datepickerContext?.onShow?.();
    };
    const clearValue = ()=>{
        updateValue(undefined);
    };
    const renderButton = (label, onClick)=>$acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            onClick: onClick,
            className: "twa:m-[2px]"
        }, label);
    const todayDate = new Date();
    const footerButtonsMap = {
        clear: renderButton('Clear', ()=>clearValue()),
        close: renderButton('Close', ()=>setVisible(false)),
        today: renderButton('Today', ()=>updateValue(todayDate)),
        tomorrow: renderButton('Tomorrow', ()=>updateValue((0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(todayDate, 1))),
        yesterday: renderButton('Yesterday', ()=>updateValue((0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(todayDate, -1))),
        nextWorkday: renderButton('Next Workday', ()=>updateValue((0, $370ee6dc5d0513ee$export$f087b9ada3136ae9)(todayDate, 1))),
        prevWorkday: renderButton('Prev Workday', ()=>updateValue((0, $370ee6dc5d0513ee$export$f087b9ada3136ae9)(todayDate, -1))),
        '-': $acw62.createElement("div", {
            style: {
                flex: '1 1 1%'
            }
        }),
        '|': $acw62.createElement("hr", {
            style: {
                width: '100%',
                height: 0,
                margin: 0,
                border: 'none'
            }
        })
    };
    const footerButtons = datepickerButtons.map((buttonKey, index)=>$acw62.cloneElement(footerButtonsMap[buttonKey], {
            key: index
        }));
    const clearButton = showClearButton !== false ? $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "clear",
        variant: "text",
        tooltip: "Clear",
        iconSize: 20,
        className: "twa:p-0",
        icon: "close",
        onMouseDown: (e)=>{
            e.preventDefault();
            clearValue();
        },
        accessLevel: 'Full'
    }) : null;
    const calendarButton = $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        disabled: disabled,
        variant: "text",
        icon: "calendar",
        tooltip: "Date",
        iconSize: 20,
        className: "twa:p-0",
        onClick: ()=>setVisible(true)
    });
    const overlayDOMRef = (0, $acw62.useRef)(null);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:flex-1"
    }, $acw62.createElement((0, $c9ce1fb924ab724e$export$2e2bcd8739ae039), {
        visible: visible,
        render: ()=>$acw62.createElement($afafaa5c90dbf256$var$DatepickerOverlay, {
                overlayDOMRef: overlayDOMRef,
                onMouseDown: props.onMouseDown,
                onHide: ()=>setVisible(false),
                onKeyDown: (e)=>{
                    if (e.key === 'Escape' || e.key === 'Enter') setVisible(false, e.key);
                }
            }, $acw62.createElement((0, $afd6fbb3c426525f$export$97e6db89a86ff7ab), {
                fixedWeeks: true,
                autoFocus: autoFocus ?? true,
                showWeekNumber: showWeekNumber,
                showOutsideDays: showOutsideDays,
                mode: "single",
                captionLayout: "dropdown",
                month: isNaN(+month) ? new Date() : month,
                selected: value,
                onMonthChange: setMonth,
                onSelect: updateValue,
                startMonth: $afafaa5c90dbf256$var$START_MONTH,
                endMonth: $afafaa5c90dbf256$var$END_MONTH,
                components: $afafaa5c90dbf256$var$DatePickerComponents,
                footer: $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                    justifyContent: "space-between",
                    className: "twa:mt-2",
                    flexWrap: 'wrap'
                }, footerButtons)
            }))
    }, $acw62.createElement((0, $952730cad4910d4d$export$2e2bcd8739ae039), {
        ...boxProps,
        style: {
            borderRadius: style?.borderRadius,
            width: style?.width,
            maxWidth: style?.maxWidth,
            border: style?.border
        },
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-Datepicker twa:min-h-input', className),
        onFocus: ()=>{
            if (!visible) setVisible(true);
        },
        onBlur: (e)=>{
            const { relatedTarget: relatedTarget } = e;
            const overlayDOMNode = overlayDOMRef.current;
            if (overlayDOMNode && relatedTarget == overlayDOMNode || overlayDOMNode?.contains(relatedTarget)) return;
            setVisible(false);
        }
    }, $acw62.createElement((0, $6e2f54bb4aae0ec6$export$8c838888ab805244), {
        ref: ref,
        value: inputValue,
        // We do not want to show the format when the date-picker is visible
        placeholder: placeholder ?? '',
        onChange: (value)=>{
            const date = new Date(value);
            if ((0, $f2a682b251363bc2$export$1ea939691cdc45b8)(date)) updateValue(date);
        },
        className: className?.includes('twa:w-full') ? 'twa:w-full' : '',
        style: style,
        disabled: disabled
    }), !!inputValue ? clearButton : null, calendarButton)));
});





const $0b5a07ac3edf272a$var$AdaptableDateInput = $acw62.forwardRef(function AdaptableDateInputCmp(props, ref) {
    const dateInputOptions = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)().adaptableOptions.userInterfaceOptions.dateInputOptions;
    const { value: _, defaultValue: __, onChange: onChange, required: required, disabled: disabled, showClearButton: showClearButton, ...inputProps } = props;
    const [value, setValue] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'value', undefined, {
        onChange: (dateString)=>// wrap date value in ChangeEvent in order to keep the external API unchanged
            props.onChange?.({
                target: {
                    // ALWAYS trigger onChange with the ISO format
                    value: dateString
                }
            })
    });
    const dateValue = value ? (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value) : null;
    const datepickerProps = {
        // this is OK as long as we do not support range datepicker
        value: dateValue,
        onChange: (dateValue)=>// convert to ISO8601 string format
            // see https://developer.mozilla.org/en-US/docs/Web/HTML/Date_and_time_formats#date_strings
            setValue((0, $eccba2ee7b674d85$export$c25903b08840222a)(dateValue) ?? ''),
        required: required,
        disabled: disabled,
        dateProps: {
            format: dateInputOptions.dateFormat,
            locale: dateInputOptions.locale
        },
        showWeekNumber: dateInputOptions.showWeekNumber,
        showOutsideDays: dateInputOptions.showOutsideDays,
        datepickerButtons: dateInputOptions.datepickerButtons,
        showClearButton: showClearButton,
        ...inputProps
    };
    return $acw62.createElement((0, $afafaa5c90dbf256$export$7235422eca03ec90), {
        ref: ref,
        ...datepickerProps
    });
});
var $0b5a07ac3edf272a$export$2e2bcd8739ae039 = $0b5a07ac3edf272a$var$AdaptableDateInput;


const $4bf904b9c2b894aa$var$AdaptableInput = $acw62.forwardRef((props, ref)=>{
    const useNativeInputDate = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)().adaptableOptions.userInterfaceOptions?.dateInputOptions?.useNativeInput;
    const { showClearButton: showClearButton, ...inputProps } = props;
    if (props.type === 'date' && !useNativeInputDate) // use AdapTable date input
    return $acw62.createElement((0, $0b5a07ac3edf272a$export$2e2bcd8739ae039), {
        showClearButton: showClearButton,
        ...inputProps,
        ref: ref
    });
    else // native input
    return $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        ...inputProps,
        ref: ref
    });
});
var $4bf904b9c2b894aa$export$2e2bcd8739ae039 = $4bf904b9c2b894aa$var$AdaptableInput;






function $7633ec1fcb7d68a8$export$143448c97e20c1b7({ formDef: formDef, onClick: onClick, defaultTone: defaultTone, disabledButtons: disabledButtons, api: api, context: context, focusFirstButton: focusFirstButton = true }) {
    return $acw62.createElement($acw62.Fragment, null, formDef.buttons.map((button, index)=>{
        const buttonIcon = api.internalApi.getIconForButton(button, context, {
            height: 15,
            width: 15
        });
        let buttonStyle = api.internalApi.getStyleForButton(button, context ? context : {
            ...api.internalApi.buildBaseContext()
        });
        let buttonLabel = api.internalApi.getLabelForButton(button, context ? context : {
            ...api.internalApi.buildBaseContext()
        });
        let buttonTooltip = api.internalApi.getTooltipForButton(button, context ? context : {
            ...api.internalApi.buildBaseContext()
        });
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            autoFocus: focusFirstButton && index === 0,
            disabled: disabledButtons[index],
            key: index,
            tooltip: buttonTooltip,
            icon: buttonIcon,
            tone: buttonStyle?.tone ?? defaultTone,
            variant: buttonStyle?.variant,
            "data-text": buttonLabel,
            className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(index ? 'twa:ml-2' : '', buttonStyle?.className),
            onClick: ()=>{
                onClick(button);
            }
        }, buttonLabel);
    }));
}
function $7633ec1fcb7d68a8$export$6ccc12e28078d09e({ formDef: formDef, data: data, onChange: onChange, onButtonClick: onButtonClick, displayTitle: displayTitle, api: api, context: context, focusFirstButton: focusFirstButton }) {
    const getFieldValue = (key)=>data[key];
    const setFieldValue = (key, value)=>{
        const newData = {
            ...data,
            [key]: value
        };
        onChange(newData);
    };
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const disabledButtons = (0, $acw62.useMemo)(()=>formDef.buttons?.map((button)=>{
            // defensive programming: conventionally context should ALWAYS be present for validating buttons
            const isValid = !!button.disabled && !!context ? !button.disabled(button, context) : true;
            return !isValid;
        }) ?? [], [
        data
    ]);
    const renderLabel = (field)=>{
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: 'ab-FormLayout_column--label',
            style: {
                textAlign: 'end'
            }
        }, field.label);
    };
    const renderField = (field)=>{
        const value = getFieldValue(field.name) ?? '';
        const onChange = (event)=>{
            if (field.fieldType === 'number') {
                const numberValue = Number(event.target.value);
                if (isNaN(numberValue)) setFieldValue(field.name, null);
                else setFieldValue(field.name, numberValue);
            } else setFieldValue(field.name, event.target.value);
        };
        switch(field.fieldType){
            case 'text':
            case 'number':
            case 'date':
                return $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
                    type: field.fieldType,
                    className: "twa:w-full",
                    name: field.name,
                    value: value,
                    onChange: onChange
                });
            case 'select':
                let items = field.options.map((item)=>({
                        value: item.value,
                        label: item.label,
                        onClick: ()=>setFieldValue(field.name, item.value)
                    }));
                return $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
                    style: {
                        width: '100%'
                    },
                    className: `ab-options__select`,
                    options: items,
                    onChange: (newValue)=>setFieldValue(field.name, newValue),
                    value: value
                });
            case 'checkbox':
                return $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
                    type: "checkbox",
                    name: field.name,
                    checked: value,
                    onChange: (event)=>{
                        setFieldValue(field.name, event.target.checked);
                    }
                });
            case 'textOutput':
                return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                    className: "twa:pl-2 twa:text-left"
                }, value);
            default:
                return $acw62.createElement("div", null, "Unknown field type: ", field.fieldType);
        }
    };
    // by default we have 2 columns: label & input
    const columns = formDef.config?.columns ?? [
        1,
        2
    ];
    return $acw62.createElement($acw62.Fragment, null, displayTitle && formDef.title && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "form-title",
        className: "twa:text-5 twa:mb-2 twa:font-bold"
    }, formDef.title), formDef.description && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "form-description",
        className: "twa:mb-3"
    }, formDef.description), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        onKeyDown: (event)=>{
            const target = event.target;
            const targetName = target.name;
            const field = formDef.fields.map((field)=>{
                if (Array.isArray(field)) return field.filter((f)=>f.name === targetName)[0];
                else return field.name === targetName ? field : null;
            }).filter(Boolean)[0];
            if (field && field.fieldType === 'number') {
                // for number fields
                // hook them up to the CellEditorKeyDown event
                // so Shortcuts work as expected
                const value = event.target.value;
                adaptable._emit('CellEditorKeyDown', {
                    keyDownEvent: event,
                    cellValue: value,
                    columnId: field.name,
                    updateValueCallback: (updatedValue)=>{
                        setFieldValue(field.name, updatedValue);
                    }
                });
            }
        },
        "data-name": "form-content",
        columns: columns,
        className: "twa:pr-1 twa:overflow-auto"
    }, formDef.fields?.map((field, index)=>{
        if (Array.isArray(field)) {
            const rowFields = {};
            field.map((fieldItem, index)=>{
                const rowFieldIndex = 2 * index + 1;
                rowFields[rowFieldIndex] = renderLabel(fieldItem);
                rowFields[rowFieldIndex + 1] = renderField(fieldItem);
            });
            return $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
                key: index,
                ...rowFields
            });
        } else return $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            key: field.name
        }, renderLabel(field), renderField(field));
    })), formDef.buttons ? $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        "data-name": "form-buttons",
        className: "twa:mt-3",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    }, $acw62.createElement($7633ec1fcb7d68a8$export$143448c97e20c1b7, {
        focusFirstButton: focusFirstButton,
        onClick: onButtonClick,
        disabledButtons: disabledButtons,
        defaultTone: "success",
        formDef: formDef,
        api: api,
        context: context
    })) : null);
}






var $acw62 = parcelRequire("acw62");


const $e96a6d4c830cebbf$export$9e69c21df0138642 = (icon)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    if (!icon) return icon;
    return adaptable.api.userInterfaceApi.internalApi.prepareAdaptableIconDef(icon);
};


const $1aae0b1146834d4d$export$8a2e09c1232b2f10 = (props)=>{
    const icon = (0, $e96a6d4c830cebbf$export$9e69c21df0138642)(props.icon);
    return $acw62.createElement((0, $9200d8ae4e589d35$export$f508444e7933c2b1), {
        ...props,
        icon: icon
    });
};



const $cf3a9ab64121b7b4$export$32f30a30fea9be7d = (props)=>{
    const messageType = props.adaptableAlert.alertDefinition.MessageType || 'Error';
    const msg = props.adaptableAlert.message ?? '';
    const headerColor = (0, $5aWMQ.UIHelper).getColorByMessageType(messageType);
    let header = messageType;
    const { api: api, adaptableOptions: adaptableOptions } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    if (props.adaptableAlert.header) header = `${header}: ${props.adaptableAlert.header}`;
    let glyph = (0, $5aWMQ.UIHelper).getGlyphByMessageType(messageType);
    // we still need the defauld
    const defaultForm = $acw62.useMemo(()=>{
        return api.alertApi.internalApi.getDefaultAlertNotificationForm();
    }, []);
    const [formData, setFormData] = (0, $acw62.useState)({});
    const context = $acw62.useMemo(()=>{
        return {
            alert: props.adaptableAlert,
            ...api.internalApi.buildBaseContext(),
            formData: formData
        };
    }, [
        JSON.stringify(formData),
        props.adaptableAlert
    ]);
    const adaptableForm = $acw62.useMemo(()=>{
        if (api.isDestroyed()) return null;
        return api.alertApi.internalApi.getAdaptableFormFromAlertForm(props.adaptableAlert.alertDefinition.AlertForm || defaultForm, context, messageType);
    }, [
        props.adaptableAlert.alertDefinition.AlertForm,
        defaultForm,
        messageType,
        context
    ]);
    const renderApplicationIcon = (icon)=>{
        if (!icon) return null;
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "column",
            className: "twa:self-end",
            alignItems: "end"
        }, $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
            icon: icon,
            iconClassName: 'alert-popup__application-icon'
        }));
    };
    const content = $acw62.createElement((0, $283cf61293364231$export$226a98817755c0cc), {
        header: header,
        headerColor: headerColor,
        glyphicon: glyph,
        bodyProps: {
            className: 'twa:p-2'
        }
    }, $acw62.createElement("div", null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        alignItems: "flex-start"
    }, renderApplicationIcon(adaptableOptions.notificationsOptions.showApplicationIcon && adaptableOptions.userInterfaceOptions.applicationIcon), typeof msg === 'string' ? msg.split('\n').map(function(item, index) {
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "row",
            key: index
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            key: index,
            className: "twa:m-2"
        }, item, $acw62.createElement("br", null)));
    }) : msg), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:m-2"
    }, adaptableForm ? $acw62.createElement((0, $7633ec1fcb7d68a8$export$6ccc12e28078d09e), {
        focusFirstButton: props.focusFirstButton,
        data: formData,
        formDef: adaptableForm,
        displayTitle: true,
        onChange: setFormData,
        api: api,
        context: context,
        onButtonClick: (button)=>{
            props.onClose();
            // we want to give the current popup time to close
            // and we reopen with a delay in case this button action causes another popup
            setTimeout(()=>{
                button.onClick?.(button, context);
            }, 20);
        }
    }) : null)));
    return props.headless ? content : $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
        "data-name": `alert-popup alert-popup-${messageType.toLowerCase()}`,
        showCloseButton: false,
        isOpen: true,
        onDismiss: props.onClose,
        className: "twa:min-h-auto twa:min-w-[20vw] twa:max-w-[70vw]"
    }, content);
};



const $372dcf2fc16be395$export$f6cef6fcf9ca4e17 = (props)=>{
    // we're doing this hack and not simply using props.api in order not to have a memory
    // leak where the api is still kept around in memory by the toaster
    let api = props.api;
    const off = api.eventApi.on('AdaptableDestroy', ()=>{
        (0, $ad26fe773541dcd3$export$b410431fab84fa58).dismiss();
        api = null;
    });
    const adaptableOptions = props.api.optionsApi.getAdaptableOptions();
    const toastProps = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateToastOptions(adaptableOptions.notificationsOptions, {
        containerId: `Toastify-${adaptableOptions.adaptableId}`,
        onClose: ()=>{
            off();
        }
    }, {
        duration: props.adaptableAlert.alertDefinition.AlertProperties.NotificationDuration
    });
    const content = $acw62.createElement((0, $cf3a9ab64121b7b4$export$32f30a30fea9be7d), {
        headless: true,
        adaptableAlert: props.adaptableAlert,
        onClose: ()=>{
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).dismiss(toastId);
        }
    });
    let toastId;
    switch(props.adaptableAlert.alertDefinition.MessageType){
        case 'Info':
            toastId = (0, $ad26fe773541dcd3$export$b410431fab84fa58).info(content, toastProps);
            break;
        case 'Error':
            toastId = (0, $ad26fe773541dcd3$export$b410431fab84fa58).error(content, toastProps);
            break;
        case 'Success':
            toastId = (0, $ad26fe773541dcd3$export$b410431fab84fa58).success(content, toastProps);
            break;
        case 'Warning':
            toastId = (0, $ad26fe773541dcd3$export$b410431fab84fa58).warn(content, toastProps);
            break;
    }
};




/**
 * Updates IsSuspended in a list of adaptable objects
 *
 * @param abObjectToChange object to suspend
 * @param list list of ab objects
 */ function $471c8159162519ad$export$b2dfdefaaf135198(abObjectToChange, list, IsSuspended) {
    return list.map((abObject)=>{
        if (!abObject.IsReadOnly && abObject?.Uuid === abObjectToChange?.Uuid) return {
            ...abObject,
            IsSuspended: IsSuspended
        };
        return abObject;
    });
}
function $471c8159162519ad$export$d5749a3ee2d57eaa(list) {
    return list.map((abObject)=>{
        if (!abObject.IsReadOnly) return {
            ...abObject,
            IsSuspended: true
        };
        return abObject;
    });
}
function $471c8159162519ad$export$94c949ae997a6e37(list) {
    return list.map((abObject)=>{
        if (!abObject.IsReadOnly) return {
            ...abObject,
            IsSuspended: false
        };
        return abObject;
    });
}


const $0040cfd693076bab$export$8bedfe4ad4522237 = 'ALERT_DEFINITION_ADD';
const $0040cfd693076bab$export$32efa0a201159b9d = 'ALERT_DEFINITION_EDIT';
const $0040cfd693076bab$export$b7bef988bc135839 = 'ALERT_DEFINITION_DELETE';
const $0040cfd693076bab$export$bb66c5cbd5db1838 = 'ALERT_DEFINITION_SUSPEND';
const $0040cfd693076bab$export$725641fffa449d27 = 'ALERT_DEFINITION_UNSUSPEND';
const $0040cfd693076bab$export$b7a116cc1d5d2243 = 'ALERT_DEFINITION_SUSPEND_ALL';
const $0040cfd693076bab$export$bdb8bdabbb4dda50 = 'ALERT_DEFINITION_UNSUSPEND_ALL';
const $0040cfd693076bab$export$d3c2e2e1191aec03 = 'ALERT_CLEAR_FLASHING_CELLS';
const $0040cfd693076bab$export$60938c392aa0d685 = 'ALERT_READY';
const $0040cfd693076bab$export$48fb1d70acb0b9bf = (alertDefinition)=>({
        type: $0040cfd693076bab$export$8bedfe4ad4522237,
        alertDefinition: alertDefinition
    });
const $0040cfd693076bab$export$5616824fed3efc2a = (alertDefinition)=>({
        type: $0040cfd693076bab$export$32efa0a201159b9d,
        alertDefinition: alertDefinition
    });
const $0040cfd693076bab$export$fd2daac714b8b6d3 = (alertDefinition)=>({
        type: $0040cfd693076bab$export$b7bef988bc135839,
        alertDefinition: alertDefinition
    });
const $0040cfd693076bab$export$75e27fe48d2e10dd = (alertDefinition)=>({
        type: $0040cfd693076bab$export$bb66c5cbd5db1838,
        alertDefinition: alertDefinition
    });
const $0040cfd693076bab$export$c6368f11ad411cd3 = (alertDefinition)=>({
        type: $0040cfd693076bab$export$725641fffa449d27,
        alertDefinition: alertDefinition
    });
const $0040cfd693076bab$export$1346cde2393e56e2 = ()=>({
        type: $0040cfd693076bab$export$b7a116cc1d5d2243
    });
const $0040cfd693076bab$export$b84c6136fd7a4982 = ()=>({
        type: $0040cfd693076bab$export$bdb8bdabbb4dda50
    });
const $0040cfd693076bab$export$2a23c236cc5a01a4 = (alertState)=>({
        type: $0040cfd693076bab$export$60938c392aa0d685,
        alertState: alertState
    });
const $0040cfd693076bab$export$ea937b45452d1f66 = ()=>({
        type: $0040cfd693076bab$export$d3c2e2e1191aec03
    });
const $0040cfd693076bab$var$initialState = {
    AlertDefinitions: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $0040cfd693076bab$export$339a131916a526d8 = (state = $0040cfd693076bab$var$initialState, action)=>{
    let alertDefinitions;
    switch(action.type){
        case $0040cfd693076bab$export$8bedfe4ad4522237:
            {
                const actionAlertDefinition = action.alertDefinition;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionAlertDefinition);
                alertDefinitions = [].concat(state.AlertDefinitions);
                alertDefinitions.push(actionAlertDefinition);
                return {
                    ...state,
                    AlertDefinitions: alertDefinitions
                };
            }
        case $0040cfd693076bab$export$32efa0a201159b9d:
            {
                const actionAlertDefinition = action.alertDefinition;
                return {
                    ...state,
                    AlertDefinitions: state.AlertDefinitions.map((abObject)=>abObject.Uuid === actionAlertDefinition.Uuid ? actionAlertDefinition : abObject)
                };
            }
        case $0040cfd693076bab$export$b7bef988bc135839:
            {
                const actionAlertDefinition = action.alertDefinition;
                return {
                    ...state,
                    AlertDefinitions: state.AlertDefinitions.filter((abObject)=>abObject.Uuid !== actionAlertDefinition.Uuid)
                };
            }
        case $0040cfd693076bab$export$bb66c5cbd5db1838:
            return {
                ...state,
                AlertDefinitions: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.alertDefinition, state.AlertDefinitions, true)
            };
        case $0040cfd693076bab$export$725641fffa449d27:
            return {
                ...state,
                AlertDefinitions: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.alertDefinition, state.AlertDefinitions, false)
            };
        case $0040cfd693076bab$export$b7a116cc1d5d2243:
            return {
                ...state,
                AlertDefinitions: (0, $471c8159162519ad$export$d5749a3ee2d57eaa)(state.AlertDefinitions)
            };
        case $0040cfd693076bab$export$bdb8bdabbb4dda50:
            return {
                ...state,
                AlertDefinitions: (0, $471c8159162519ad$export$94c949ae997a6e37)(state.AlertDefinitions)
            };
        case $0040cfd693076bab$export$d3c2e2e1191aec03:
            return {
                AlertDefinitions: state.AlertDefinitions
            };
        default:
            return state;
    }
};



const $74b889ddf281400d$export$72f18d16ba699ea = 'APPLICATION_DATA_ENTRY_ADD';
const $74b889ddf281400d$export$fff49d45004b7da4 = 'APPLICATION_DATA_ENTRY_EDIT';
const $74b889ddf281400d$export$f6be1bde26f84fad = 'APPLICATION_DATA_ENTRY_DELETE';
const $74b889ddf281400d$export$43a60c1dcd7079c4 = (applicationDataEntry)=>({
        type: $74b889ddf281400d$export$72f18d16ba699ea,
        applicationDataEntry: applicationDataEntry
    });
const $74b889ddf281400d$export$b25db56e14802501 = (applicationDataEntry)=>({
        type: $74b889ddf281400d$export$fff49d45004b7da4,
        applicationDataEntry: applicationDataEntry
    });
const $74b889ddf281400d$export$c46b519ec5aa9846 = (applicationDataEntry)=>({
        type: $74b889ddf281400d$export$f6be1bde26f84fad,
        applicationDataEntry: applicationDataEntry
    });
const $74b889ddf281400d$var$initialState = {
    ApplicationDataEntries: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $74b889ddf281400d$export$2ec3e40612b7679d = (state = $74b889ddf281400d$var$initialState, action)=>{
    let applicationDataEntries;
    let index;
    switch(action.type){
        case $74b889ddf281400d$export$72f18d16ba699ea:
            const actionTypedAdd = action;
            applicationDataEntries = [].concat(state.ApplicationDataEntries);
            applicationDataEntries.push(actionTypedAdd.applicationDataEntry);
            return Object.assign({}, state, {
                ApplicationDataEntries: applicationDataEntries
            });
        case $74b889ddf281400d$export$fff49d45004b7da4:
            const actionTypedUpdate = action;
            applicationDataEntries = [].concat(state.ApplicationDataEntries);
            index = applicationDataEntries.findIndex((fe)=>fe.Key == actionTypedUpdate.applicationDataEntry.Key);
            applicationDataEntries[index] = actionTypedUpdate.applicationDataEntry;
            return Object.assign({}, state, {
                ApplicationDataEntries: applicationDataEntries
            });
        case $74b889ddf281400d$export$f6be1bde26f84fad:
            const actionTypedDelete = action;
            applicationDataEntries = [].concat(state.ApplicationDataEntries);
            index = applicationDataEntries.findIndex((a)=>a.Key == actionTypedDelete.applicationDataEntry.Key);
            applicationDataEntries.splice(index, 1);
            return Object.assign({}, state, {
                ApplicationDataEntries: applicationDataEntries
            });
        default:
            return state;
    }
};


/**
 * @ReduxAction Bulk Update is being applied
 */ const $8713f41926484273$export$e604d3f304f1465b = 'BULK_UPDATE_APPLY';
const $8713f41926484273$export$80bf8a1a13ebe2f6 = 'BULK_UPDATE_READY';
const $8713f41926484273$export$95e3d38d99d65522 = (bypassValidationWarnings)=>({
        type: $8713f41926484273$export$e604d3f304f1465b,
        bypassValidationWarnings: bypassValidationWarnings
    });
const $8713f41926484273$export$ca4658681530e9d4 = ()=>({
        type: $8713f41926484273$export$80bf8a1a13ebe2f6
    });




const $754f469a84cf6e6e$export$e7c69e05c8f54d4f = 'CALCULATED_COLUMN_ADD';
const $754f469a84cf6e6e$export$90da21d938613394 = 'CALCULATED_COLUMN_EDIT';
const $754f469a84cf6e6e$export$f65f92db6093424 = 'CALCULATED_COLUMN_DELETE';
const $754f469a84cf6e6e$export$a02d7b5c1cc9c3ae = 'CALCULATED_COLUMN_READY';
const $754f469a84cf6e6e$export$b40c2dc2e1bce126 = (calculatedColumn)=>({
        type: $754f469a84cf6e6e$export$e7c69e05c8f54d4f,
        calculatedColumn: calculatedColumn
    });
const $754f469a84cf6e6e$export$f21cff55af8ea46e = (calculatedColumn)=>({
        type: $754f469a84cf6e6e$export$90da21d938613394,
        calculatedColumn: calculatedColumn
    });
const $754f469a84cf6e6e$export$8a2941134f9c2f4 = (calculatedColumn)=>({
        type: $754f469a84cf6e6e$export$f65f92db6093424,
        calculatedColumn: calculatedColumn
    });
const $754f469a84cf6e6e$export$851359d6bb162c27 = (calculatedColumnState)=>({
        type: $754f469a84cf6e6e$export$a02d7b5c1cc9c3ae,
        calculatedColumnState: calculatedColumnState
    });
const $754f469a84cf6e6e$var$initialState = {
    CalculatedColumns: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $754f469a84cf6e6e$export$3b3f0b9a6a813734 = (state = $754f469a84cf6e6e$var$initialState, action)=>{
    let calculatedColumns;
    switch(action.type){
        case $754f469a84cf6e6e$export$e7c69e05c8f54d4f:
            {
                const actionCalculatedColumn = action.calculatedColumn;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionCalculatedColumn);
                calculatedColumns = [].concat(state.CalculatedColumns);
                calculatedColumns.push(actionCalculatedColumn);
                return {
                    ...state,
                    CalculatedColumns: calculatedColumns
                };
            }
        // !! MUTABLE STATE
        case $754f469a84cf6e6e$export$90da21d938613394:
            {
                const actionCalculatedColumn = action.calculatedColumn;
                return {
                    ...state,
                    CalculatedColumns: state.CalculatedColumns.map((abObject)=>abObject.Uuid === actionCalculatedColumn.Uuid ? // in order to make working with aggrid easier, as the col getter
                        // references this object
                        Object.assign(abObject, actionCalculatedColumn) : abObject)
                };
            }
        case $754f469a84cf6e6e$export$f65f92db6093424:
            {
                const actionCalculatedColumn = action.calculatedColumn;
                return {
                    ...state,
                    CalculatedColumns: state.CalculatedColumns.filter((abObject)=>abObject.Uuid !== actionCalculatedColumn.Uuid)
                };
            }
        default:
            return state;
    }
};




const $5571bec319fd98b0$export$b487bd8e36e9ab74 = 'SET_CHARTING_CHARTS';
const $5571bec319fd98b0$export$cce99380d99e0fcc = 'CHARTING_READY';
const $5571bec319fd98b0$export$bf1821d5cecd7a31 = 'CHARTING_EDIT_CHART';
const $5571bec319fd98b0$export$9f4357ad3a0c2da4 = 'CHARTING_ADD_CHART';
const $5571bec319fd98b0$export$a4d76ae38391706 = 'CHARTING_DELETE_CHART';
const $5571bec319fd98b0$export$fc270b61373b0c8 = 'CHARTING_EDIT_EXTERNAL_CHART';
const $5571bec319fd98b0$export$b314c7cfdccb2479 = 'CHARTING_ADD_EXTERNAL_CHART';
const $5571bec319fd98b0$export$2f7927867b194687 = 'CHARTING_DELETE_EXTERNAL_CHART';
const $5571bec319fd98b0$export$811673b95e451b75 = (charts)=>({
        charts: charts,
        type: $5571bec319fd98b0$export$b487bd8e36e9ab74
    });
const $5571bec319fd98b0$export$a2186ecffe5e74da = (chartingState)=>({
        type: $5571bec319fd98b0$export$cce99380d99e0fcc,
        chartingState: chartingState
    });
const $5571bec319fd98b0$export$be4f1183e24b6d84 = (chartDefinition)=>({
        type: $5571bec319fd98b0$export$bf1821d5cecd7a31,
        chartDefinition: chartDefinition
    });
const $5571bec319fd98b0$export$f6871d811919866e = (chartDefinition)=>({
        type: $5571bec319fd98b0$export$9f4357ad3a0c2da4,
        chartDefinition: chartDefinition
    });
const $5571bec319fd98b0$export$c0a99267db1a5bfa = (chartDefinition)=>({
        type: $5571bec319fd98b0$export$a4d76ae38391706,
        chartDefinition: chartDefinition
    });
const $5571bec319fd98b0$export$ea52e494833ea893 = (chartDefinition)=>({
        type: $5571bec319fd98b0$export$fc270b61373b0c8,
        chartDefinition: chartDefinition
    });
const $5571bec319fd98b0$export$ff1ccc893f523729 = (chartDefinition)=>({
        type: $5571bec319fd98b0$export$b314c7cfdccb2479,
        chartDefinition: chartDefinition
    });
const $5571bec319fd98b0$export$32550d3e9883bb0d = (chartDefinition)=>({
        type: $5571bec319fd98b0$export$2f7927867b194687,
        chartDefinition: chartDefinition
    });
const $5571bec319fd98b0$export$d4c72bab9d6cc13a = {
    ChartDefinitions: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    ExternalChartDefinitions: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $5571bec319fd98b0$export$6fe5e0acd43ef01a = (state)=>state.Charting.ChartDefinitions ?? [];
const $5571bec319fd98b0$export$4d41f59981e35290 = (state)=>state.Charting.ExternalChartDefinitions ?? [];
const $5571bec319fd98b0$export$ffd9fc696f46ab35 = (state = $5571bec319fd98b0$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case $5571bec319fd98b0$export$b487bd8e36e9ab74:
            return {
                ...state,
                ChartDefinitions: action.charts
            };
        case $5571bec319fd98b0$export$bf1821d5cecd7a31:
            return {
                ...state,
                ChartDefinitions: state.ChartDefinitions.map((chartDefinition)=>{
                    if (chartDefinition.Uuid === action.chartDefinition.Uuid) return action.chartDefinition;
                    return chartDefinition;
                })
            };
        case $5571bec319fd98b0$export$9f4357ad3a0c2da4:
            let chartDefinition = action.chartDefinition;
            if (!('Uuid' in chartDefinition)) chartDefinition = {
                ...chartDefinition,
                Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)()
            };
            return {
                ...state,
                ChartDefinitions: [
                    ...state.ChartDefinitions,
                    chartDefinition
                ]
            };
        case $5571bec319fd98b0$export$a4d76ae38391706:
            return {
                ...state,
                ChartDefinitions: state.ChartDefinitions.filter((chartDefinition)=>chartDefinition.Name !== action.chartDefinition.Name)
            };
        case $5571bec319fd98b0$export$fc270b61373b0c8:
            return {
                ...state,
                ExternalChartDefinitions: state.ExternalChartDefinitions.map((chartDefinition)=>{
                    if (chartDefinition.Uuid === action.chartDefinition.Uuid) return action.chartDefinition;
                    return chartDefinition;
                })
            };
        case $5571bec319fd98b0$export$b314c7cfdccb2479:
            let externalChartDefinition = action.chartDefinition;
            if (!('Uuid' in externalChartDefinition)) externalChartDefinition = {
                ...externalChartDefinition,
                Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)()
            };
            return {
                ...state,
                ExternalChartDefinitions: [
                    ...state.ExternalChartDefinitions,
                    externalChartDefinition
                ]
            };
        case $5571bec319fd98b0$export$2f7927867b194687:
            return {
                ...state,
                ExternalChartDefinitions: state.ExternalChartDefinitions.filter((chartDefinition)=>chartDefinition.Name !== action.chartDefinition.Name)
            };
    }
    return state;
};






var $hrtGQ = parcelRequire("hrtGQ");

var $5aWMQ = parcelRequire("5aWMQ");

const $72a4ef37247198d5$export$b1b3cf1c1a310f9b = (0, $hrtGQ.SummaryOperation).Sum;
const $72a4ef37247198d5$export$28cc436f02e4b048 = (0, $5aWMQ.getHexForName)((0, $5aWMQ.LIGHT_YELLOW));
const $72a4ef37247198d5$export$761a302010a0d836 = (0, $5aWMQ.getHexForName)((0, $5aWMQ.BLACK));
const $72a4ef37247198d5$export$f30c621cc5df841e = [
    {
        Name: (0, $58846ea7f4156db7$export$ee8dd85a2e01b86f),
        Description: 'Light Theme'
    },
    {
        Name: (0, $58846ea7f4156db7$export$84426164da6cf571),
        Description: 'Dark Theme'
    },
    {
        Name: (0, $58846ea7f4156db7$export$9fa5d5f0144954cb),
        Description: 'OS Theme'
    }
];
const $72a4ef37247198d5$export$3aabe399552f4ef9 = (0, $58846ea7f4156db7$export$ee8dd85a2e01b86f);



var $hrtGQ = parcelRequire("hrtGQ");


const $5b564bb703f29152$export$f7b453d5c91bc422 = 'SET_COLUMNS';
const $5b564bb703f29152$export$d06ecb172ecfd9e2 = 'SET_SELECTED_CELLS';
const $5b564bb703f29152$export$f6375da530efeed = 'SET_SELECTED_ROWS';
const $5b564bb703f29152$export$bdcedad628e49b89 = 'SET_SETTINGS_PANEL_ITEMS';
const $5b564bb703f29152$export$18ae39105cf53c2f = 'SET_DASHBOARD_MODULE_BUTTONS';
const $5b564bb703f29152$export$f384c2cd8cb9fb5c = 'HIGHLIGHT_CELL_ADD';
const $5b564bb703f29152$export$f3408dd0c13097db = 'HIGHLIGHT_CELL_DELETE';
const $5b564bb703f29152$export$565d0994f34459df = 'HIGHLIGHT_CELL_DELETE_ALL';
const $5b564bb703f29152$export$17a87e5a743cea30 = 'HIGHLIGHT_COLUMN_ADD';
const $5b564bb703f29152$export$541d71e5cda0756c = 'HIGHLIGHT_COLUMN_DELETE';
const $5b564bb703f29152$export$8062ce7f7143d859 = 'HIGHLIGHT_COLUMN_DELETE_ALL';
const $5b564bb703f29152$export$7d1895646bfa0f08 = 'HIGHLIGHT_ROW_ADD';
const $5b564bb703f29152$export$fad44cf871b0d26b = 'HIGHLIGHT_ROWS_ADD';
const $5b564bb703f29152$export$2d689283eeefed87 = 'HIGHLIGHT_ROW_DELETE';
const $5b564bb703f29152$export$25d096a3d0a79afc = 'HIGHLIGHT_ROWS_DELETE';
const $5b564bb703f29152$export$6e5e141003a5370d = 'HIGHLIGHT_ROW_DELETE_ALL';
const $5b564bb703f29152$export$c16775ef924f1b9a = 'ALERT_ADD';
const $5b564bb703f29152$export$da4d4b120f90dd49 = 'ALERT_DELETE';
const $5b564bb703f29152$export$8b66681127c3e555 = 'ALERT_DELETE_ALL';
const $5b564bb703f29152$export$c68a41837441fcf7 = 'ALERT_REMOVE_CELL_HIGHLIGHT';
const $5b564bb703f29152$export$de0a34f95d27629f = 'ALERT_REMOVE_ROW_HIGHLIGHT';
const $5b564bb703f29152$export$e885ba7c056ff79b = 'SYSTEM_STATUS_MESSAGE_INFO_ADD';
const $5b564bb703f29152$export$caf13db6f812de05 = 'SYSTEM_STATUS_MESSAGE_INFO_DELETE';
const $5b564bb703f29152$export$504324ac771afe8e = 'SYSTEM_STATUS_MESSAGE_INFO_DELETE_ALL';
const $5b564bb703f29152$export$5255020d7fd8544f = 'SMARTEDIT_CHECK_CELL_SELECTION';
const $5b564bb703f29152$export$6c728ad6e80f0362 = 'SMARTEDIT_FETCH_PREVIEW';
const $5b564bb703f29152$export$88bac6f6391c31b0 = 'SMARTEDIT_SET_VALID_SELECTION';
const $5b564bb703f29152$export$632d5d227e628562 = 'SMARTEDIT_SET_PREVIEW';
const $5b564bb703f29152$export$d40c929da9e9f01a = 'SMART_EDIT_CHANGE_VALUE';
const $5b564bb703f29152$export$9f15d1006db00da7 = 'SMART_EDIT_CHANGE_OPERATION';
const $5b564bb703f29152$export$588c2d3b23d8b789 = 'BULK_UPDATE_CHECK_CELL_SELECTION';
const $5b564bb703f29152$export$9070aec57ec562d6 = 'BULK_UPDATE_SET_VALID_SELECTION';
const $5b564bb703f29152$export$148a230da3199254 = 'BULK_UPDATE_SET_PREVIEW';
const $5b564bb703f29152$export$6c538a66cf392594 = 'BULK_UPDATE_CHANGE_VALUE';
const $5b564bb703f29152$export$1625f4504a3d57ef = 'CACHED_QUERY_ADD';
const $5b564bb703f29152$export$147736b3a58c916d = 'CELL_SUMMARY_CHANGE_OPERATION';
const $5b564bb703f29152$export$1ee43196df0dcb5a = 'SET_CELL_SUMMARY_INFO';
const $5b564bb703f29152$export$e932fdb2c385fe60 = 'CREATE_CELL_SUMMARY_INFO';
const $5b564bb703f29152$export$282fb886c663088e = 'LICENSE_SHOW_WATERMARK';
const $5b564bb703f29152$export$25a55cb322dba1b7 = 'LICENSE_DISABLE_PERSISTENCE';
const $5b564bb703f29152$export$5bfd4c6440c8d5cf = 'DATA_CHANGE_HISTORY_ADD';
const $5b564bb703f29152$export$8fa42571c3ed7ce = 'DATA_CHANGE_HISTORY_UNDO';
const $5b564bb703f29152$export$2eb85b0e1a1756a9 = 'DATA_CHANGE_HISTORY_CLEAR_ROW';
const $5b564bb703f29152$export$e15fba57eed9ad7a = 'DATA_CHANGE_HISTORY_ENABLE';
const $5b564bb703f29152$export$668166beb957075b = 'DATA_CHANGE_HISTORY_DISABLE';
const $5b564bb703f29152$export$b284623f5d1e1134 = 'DATA_CHANGE_HISTORY_SUSPEND';
const $5b564bb703f29152$export$d72029662e46675c = 'DATA_CHANGE_HISTORY_RESUME';
const $5b564bb703f29152$export$3afbaff58d6503d9 = 'SETTINGS_PANEL_SET';
const $5b564bb703f29152$export$e8986ad6b988a309 = 'QUICK_FILTER_BAR_SHOW';
const $5b564bb703f29152$export$5e04390a67ecd344 = 'QUICK_FILTER_BAR_HIDE';
const $5b564bb703f29152$export$f2e8371a81441ef3 = 'DISABLE_DELETE_CONFIRMATION';
const $5b564bb703f29152$export$b2e4a9ae9dd89d14 = 'LAYOUT_SHOW_NON_EXTENDED_OBJECTS';
const $5b564bb703f29152$export$100cce0260d307a = 'DASHBOARD_REFRESH';
const $5b564bb703f29152$export$2a14b9f34817129b = 'DATA_SET_SELECT';
const $5b564bb703f29152$export$de555af7fca36001 = 'CHARTING_SET_CURRENT_CHART_MODELS';
const $5b564bb703f29152$export$7d0dd0214f487983 = 'SET_QUICK_SEARCH_FLOATING_VISIBILITY';
const $5b564bb703f29152$export$dc07b6c6c3a46f0e = 'SYSTEM_EXPORT_BEGIN';
const $5b564bb703f29152$export$9e9cc935d26629f1 = 'SYSTEM_EXPORT_END';
const $5b564bb703f29152$export$3779aee3003c0e71 = 'CELL_POPUP_SHOW';
const $5b564bb703f29152$export$7cc2778a72a3b1e3 = 'CELL_POPUP_HIDE';
const $5b564bb703f29152$export$c0741eff034775f1 = 'CELL_POPUP_EDIT_FOCUSED_ENTITY';
const $5b564bb703f29152$export$b46645b802c722c8 = 'SUMMARY_ROW_SET';
const $5b564bb703f29152$export$78a6d53726b27b1d = 'DATA_IMPORT_COMPLETED';
const $5b564bb703f29152$export$2011321d56e9cb61 = (cellHighlightInfo)=>({
        type: $5b564bb703f29152$export$f384c2cd8cb9fb5c,
        cellHighlightInfo: cellHighlightInfo
    });
const $5b564bb703f29152$export$23ee2d95cb6fc250 = (primaryKeyValue, columnId)=>({
        type: $5b564bb703f29152$export$f3408dd0c13097db,
        primaryKeyValue: primaryKeyValue,
        columnId: columnId
    });
const $5b564bb703f29152$export$e29b768e4ab19b3e = ()=>({
        type: $5b564bb703f29152$export$565d0994f34459df
    });
const $5b564bb703f29152$export$7a1b6ea0040d1206 = (columnHighlightInfo)=>({
        type: $5b564bb703f29152$export$17a87e5a743cea30,
        columnHighlightInfo: columnHighlightInfo
    });
const $5b564bb703f29152$export$37e7ff783b2c940e = (columnId)=>({
        type: $5b564bb703f29152$export$541d71e5cda0756c,
        columnId: columnId
    });
const $5b564bb703f29152$export$e010de3d94020f71 = ()=>({
        type: $5b564bb703f29152$export$8062ce7f7143d859
    });
const $5b564bb703f29152$export$3be12149c68c5f17 = (rowHighlightInfo)=>({
        type: $5b564bb703f29152$export$7d1895646bfa0f08,
        rowHighlightInfo: rowHighlightInfo
    });
const $5b564bb703f29152$export$b2ff6d69f0e262a6 = (rowsHighlightInfo)=>({
        type: $5b564bb703f29152$export$fad44cf871b0d26b,
        rowsHighlightInfo: rowsHighlightInfo
    });
const $5b564bb703f29152$export$c1756d4c088e843f = (primaryKeyValue)=>({
        type: $5b564bb703f29152$export$2d689283eeefed87,
        primaryKeyValue: primaryKeyValue
    });
const $5b564bb703f29152$export$f9e1a3d5dfadbc4a = (primaryKeyValues)=>({
        type: $5b564bb703f29152$export$25d096a3d0a79afc,
        primaryKeyValues: primaryKeyValues
    });
const $5b564bb703f29152$export$490d2d7d7f44c6be = ()=>({
        type: $5b564bb703f29152$export$6e5e141003a5370d
    });
const $5b564bb703f29152$export$4fbf83a3540ddc8d = (Columns)=>({
        type: $5b564bb703f29152$export$f7b453d5c91bc422,
        columns: Columns
    });
const $5b564bb703f29152$export$d516b7a966e54414 = (SelectedCellInfo)=>({
        type: $5b564bb703f29152$export$d06ecb172ecfd9e2,
        selectedCellInfo: SelectedCellInfo
    });
const $5b564bb703f29152$export$113fab243a5adcab = (SelectedRowInfo)=>({
        type: $5b564bb703f29152$export$f6375da530efeed,
        selectedRowInfo: SelectedRowInfo
    });
const $5b564bb703f29152$export$f9bfd99851e0c3b7 = (MenuItems)=>({
        type: $5b564bb703f29152$export$bdcedad628e49b89,
        menuItems: MenuItems
    });
const $5b564bb703f29152$export$c86ddef8bc8627b4 = (MenuItems)=>({
        type: $5b564bb703f29152$export$18ae39105cf53c2f,
        menuItems: MenuItems
    });
const $5b564bb703f29152$export$634c589236159d8d = (alert, maxAlerts)=>({
        type: $5b564bb703f29152$export$c16775ef924f1b9a,
        alert: alert,
        maxAlerts: maxAlerts
    });
const $5b564bb703f29152$export$733f39b35c905b3d = (alert)=>({
        type: $5b564bb703f29152$export$da4d4b120f90dd49,
        alert: alert
    });
const $5b564bb703f29152$export$1fa9ee6ea5769397 = (alerts)=>({
        type: $5b564bb703f29152$export$8b66681127c3e555,
        alerts: alerts
    });
const $5b564bb703f29152$export$a6d15cc74230bc85 = (alert)=>({
        type: $5b564bb703f29152$export$c68a41837441fcf7,
        alert: alert
    });
const $5b564bb703f29152$export$8f566c85fa9bb2a6 = (alert)=>({
        type: $5b564bb703f29152$export$de0a34f95d27629f,
        alert: alert
    });
const $5b564bb703f29152$export$1e02d3cd4f056ef1 = ()=>({
        type: $5b564bb703f29152$export$e932fdb2c385fe60
    });
const $5b564bb703f29152$export$9bddc310e8204949 = (CellSummary)=>({
        type: $5b564bb703f29152$export$1ee43196df0dcb5a,
        cellSummaryInfo: CellSummary
    });
const $5b564bb703f29152$export$852ef8a161eaa232 = (SystemStatusMessageInfo, MaxSystemStatusMessagesInStore)=>({
        type: $5b564bb703f29152$export$e885ba7c056ff79b,
        systemStatusMessageInfo: SystemStatusMessageInfo,
        maxSystemStatusMessagesInStore: MaxSystemStatusMessagesInStore
    });
const $5b564bb703f29152$export$1aebed191ed79234 = (SystemStatusMessageInfo)=>({
        type: $5b564bb703f29152$export$caf13db6f812de05,
        systemStatusMessageInfo: SystemStatusMessageInfo
    });
const $5b564bb703f29152$export$939ffb83766a0a85 = ()=>({
        type: $5b564bb703f29152$export$504324ac771afe8e
    });
const $5b564bb703f29152$export$c279917007950b1 = (value)=>({
        type: $5b564bb703f29152$export$d40c929da9e9f01a,
        value: value
    });
const $5b564bb703f29152$export$bfdacd6a132082c7 = (smartEditOperation)=>({
        type: $5b564bb703f29152$export$9f15d1006db00da7,
        smartEditOperation: smartEditOperation
    });
const $5b564bb703f29152$export$bd269cd9b387ea7f = ()=>({
        type: $5b564bb703f29152$export$5255020d7fd8544f
    });
const $5b564bb703f29152$export$bc1d0b606ccfb6ae = (IsValidSmartEditSelection)=>({
        type: $5b564bb703f29152$export$88bac6f6391c31b0,
        isValidSmartEditSelection: IsValidSmartEditSelection
    });
const $5b564bb703f29152$export$b7fe9fd714f0afc2 = (SmartEditPreviewInfo)=>({
        type: $5b564bb703f29152$export$632d5d227e628562,
        smartEditPreviewInfo: SmartEditPreviewInfo
    });
const $5b564bb703f29152$export$d4ac7f658a02fdce = ()=>({
        type: $5b564bb703f29152$export$588c2d3b23d8b789
    });
const $5b564bb703f29152$export$72bb87be2da22210 = (bulkUpdateValidationResult)=>({
        type: $5b564bb703f29152$export$9070aec57ec562d6,
        bulkUpdateValidationResult: bulkUpdateValidationResult
    });
const $5b564bb703f29152$export$ebc463902112910 = (BulkUpdatePreviewInfo)=>({
        type: $5b564bb703f29152$export$148a230da3199254,
        bulkUpdatePreviewInfo: BulkUpdatePreviewInfo
    });
const $5b564bb703f29152$export$eebc2801a7081e3f = (bulkUpdateValue)=>({
        type: $5b564bb703f29152$export$6c538a66cf392594,
        bulkUpdateValue: bulkUpdateValue
    });
const $5b564bb703f29152$export$e93f0b899b9e8352 = (cachedQuery)=>({
        type: $5b564bb703f29152$export$1625f4504a3d57ef,
        cachedQuery: cachedQuery
    });
const $5b564bb703f29152$export$4379228241b0773f = (cellSummaryOperation)=>({
        type: $5b564bb703f29152$export$147736b3a58c916d,
        cellSummaryOperation: cellSummaryOperation
    });
const $5b564bb703f29152$export$c12e15ae7dd00725 = (text)=>({
        type: $5b564bb703f29152$export$282fb886c663088e,
        text: text
    });
const $5b564bb703f29152$export$452013501eb4f3bf = ()=>({
        type: $5b564bb703f29152$export$25a55cb322dba1b7
    });
const $5b564bb703f29152$export$8580dc17bbdd2573 = (changeInfo, uniqueKey)=>({
        type: $5b564bb703f29152$export$5bfd4c6440c8d5cf,
        changeInfo: changeInfo,
        uniqueKey: uniqueKey
    });
const $5b564bb703f29152$export$e26ce75f14d36591 = (changeInfo, uniqueKey)=>({
        type: $5b564bb703f29152$export$8fa42571c3ed7ce,
        changeInfo: changeInfo,
        uniqueKey: uniqueKey
    });
const $5b564bb703f29152$export$6794413ec992f145 = (changeInfo, uniqueKey)=>({
        type: $5b564bb703f29152$export$2eb85b0e1a1756a9,
        changeInfo: changeInfo,
        uniqueKey: uniqueKey
    });
const $5b564bb703f29152$export$d4cbdbb82d50fbc3 = ()=>({
        type: $5b564bb703f29152$export$e15fba57eed9ad7a
    });
const $5b564bb703f29152$export$4344ed6f5015b32c = ()=>({
        type: $5b564bb703f29152$export$668166beb957075b
    });
const $5b564bb703f29152$export$89243c08c46c6822 = ()=>({
        type: $5b564bb703f29152$export$b284623f5d1e1134
    });
const $5b564bb703f29152$export$d6776ceaeb5c77dd = ()=>({
        type: $5b564bb703f29152$export$d72029662e46675c
    });
const $5b564bb703f29152$export$77fe906b2ea73993 = (name, settings)=>({
        type: $5b564bb703f29152$export$3afbaff58d6503d9,
        name: name,
        settings: settings
    });
const $5b564bb703f29152$export$c8d88f519547e598 = ()=>({
        type: $5b564bb703f29152$export$e8986ad6b988a309
    });
const $5b564bb703f29152$export$bffa6555fdf75754 = ()=>({
        type: $5b564bb703f29152$export$5e04390a67ecd344
    });
const $5b564bb703f29152$export$28b9e963338cf73b = (showNonExtendedObjects)=>({
        type: $5b564bb703f29152$export$b2e4a9ae9dd89d14,
        showNonExtendedObjects: showNonExtendedObjects
    });
const $5b564bb703f29152$export$76d0f3c2e8e44b9d = ()=>({
        type: $5b564bb703f29152$export$100cce0260d307a
    });
const $5b564bb703f29152$export$a167b5ac2f0c10f3 = (dataSet)=>({
        type: $5b564bb703f29152$export$2a14b9f34817129b,
        dataSet: dataSet
    });
const $5b564bb703f29152$export$b0b7b697aae7da85 = (chartModels)=>({
        type: $5b564bb703f29152$export$de555af7fca36001,
        chartModels: chartModels
    });
const $5b564bb703f29152$export$f4d29e2e5bc6db04 = (state)=>{
    return state.Charting.currentChartModels;
};
const $5b564bb703f29152$export$ece6b6ff8f71195d = ()=>({
        type: $5b564bb703f29152$export$f2e8371a81441ef3
    });
const $5b564bb703f29152$export$4ee1e2e608f82222 = (reportName, reportFormat, exportDestination)=>({
        type: $5b564bb703f29152$export$dc07b6c6c3a46f0e,
        reportName: reportName,
        reportFormat: reportFormat,
        exportDestination: exportDestination
    });
const $5b564bb703f29152$export$d018884df96b3a46 = ()=>({
        type: $5b564bb703f29152$export$9e9cc935d26629f1
    });
const $5b564bb703f29152$export$3b7d4806745ba450 = (visible)=>({
        type: $5b564bb703f29152$export$7d0dd0214f487983,
        visible: visible
    });
const $5b564bb703f29152$export$efbea932e5154af2 = (cellPosition, editMode)=>({
        type: $5b564bb703f29152$export$3779aee3003c0e71,
        editMode: editMode,
        cellPosition: cellPosition
    });
const $5b564bb703f29152$export$b592a2b6f55a23fb = (focusedEntity)=>({
        type: $5b564bb703f29152$export$c0741eff034775f1,
        focusedEntity: focusedEntity
    });
const $5b564bb703f29152$export$648d0c2f1b9a0347 = (rowSummaries)=>({
        type: $5b564bb703f29152$export$b46645b802c722c8,
        rowSummaries: rowSummaries
    });
const $5b564bb703f29152$export$782bdd769187d275 = ()=>({
        type: $5b564bb703f29152$export$7cc2778a72a3b1e3
    });
const $5b564bb703f29152$export$b8c502323af02429 = (state)=>{
    return state.DisableDeleteConfirmation;
};
const $5b564bb703f29152$export$df8b86410b5851e8 = (state)=>{
    return state?.QuickSearch?.floatingVisible;
};
const $5b564bb703f29152$export$7546faff8f4dea4d = (state)=>{
    return state?.NotesAndComments?.popupPosition;
};
const $5b564bb703f29152$export$8c3f353a3a9e8bd4 = (state)=>{
    return state?.NotesAndComments?.editMode;
};
const $5b564bb703f29152$export$98c64374e991cee4 = (state)=>{
    return state?.NotesAndComments?.focusedEntity;
};
const $5b564bb703f29152$export$88b2e732fada6209 = (dataImportedInfo)=>({
        type: $5b564bb703f29152$export$78a6d53726b27b1d,
        dataImportedInfo: dataImportedInfo
    });
const $5b564bb703f29152$var$initialState = {
    Columns: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    SelectedCellInfo: null,
    SelectedRowInfo: null,
    CellHighlightInfo: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    ColumnHighlightInfo: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    RowHighlightInfo: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    SettingsPanelModuleEntries: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    AdaptableAlerts: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    SystemStatusMessages: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    Dashboard: {
        DashboardModuleButtons: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
        DashboardRevision: 1
    },
    SmartEdit: {
        IsValidSmartEditSelection: false,
        SmartEditPreviewInfo: null,
        SmartEditValue: 1,
        SmartEditOperation: (0, $hrtGQ.MathOperation).Multiply
    },
    BulkUpdate: {
        BulkUpdateValidationResult: {
            IsValid: false,
            Column: null
        },
        BulkUpdatePreviewInfo: null,
        BulkUpdateValue: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1)
    },
    CachedQueries: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    CellSummary: {
        CellSummaryOperation: (0, $72a4ef37247198d5$export$b1b3cf1c1a310f9b),
        CellSummaryInfo: null
    },
    License: {
        watermark: {
            show: false,
            text: null
        },
        disablePersistence: false
    },
    DataChangeHistory: {
        logs: {},
        currentMode: 'INACTIVE',
        enableTime: null,
        suspendTime: null
    },
    SettingsPanel: {},
    IsQuickFilterVisible: true,
    CurrentDataSet: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
    Charting: {
        currentChartModels: [],
        externalChartingDefinitions: []
    },
    Layout: {
        showLayoutNonExtendedObjects: false
    },
    DisableDeleteConfirmation: false,
    Export: {
        inProgress: null
    }
};
const $5b564bb703f29152$export$776ac4e2465030a3 = (state = $5b564bb703f29152$var$initialState, action)=>{
    let alerts;
    let systemStatusMessages;
    switch(action.type){
        case $5b564bb703f29152$export$f7b453d5c91bc422:
            return Object.assign({}, state, {
                Columns: [].concat(action.columns)
            });
        case $5b564bb703f29152$export$d06ecb172ecfd9e2:
            return Object.assign({}, state, {
                SelectedCellInfo: action.selectedCellInfo
            });
        case $5b564bb703f29152$export$f6375da530efeed:
            return Object.assign({}, state, {
                SelectedRowInfo: action.selectedRowInfo
            });
        case $5b564bb703f29152$export$bdcedad628e49b89:
            {
                const actionTyped = action;
                const menuItems = actionTyped.menuItems.sort((a, b)=>a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
                return Object.assign({}, state, {
                    SettingsPanelModuleEntries: menuItems
                });
            }
        case $5b564bb703f29152$export$18ae39105cf53c2f:
            {
                const actionTyped = action;
                const menuItems = actionTyped.menuItems.sort((a, b)=>a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
                return {
                    ...state,
                    Dashboard: {
                        ...state.Dashboard,
                        DashboardModuleButtons: menuItems
                    }
                };
            }
        case $5b564bb703f29152$export$f384c2cd8cb9fb5c:
            {
                const actionTypedAdd = action;
                return Object.assign({}, state, {
                    CellHighlightInfo: [
                        ...state.CellHighlightInfo,
                        actionTypedAdd.cellHighlightInfo
                    ]
                });
            }
        case $5b564bb703f29152$export$f3408dd0c13097db:
            {
                const actionTypedDelete = action;
                const actionId = `${actionTypedDelete.columnId}-${actionTypedDelete.primaryKeyValue}`;
                return Object.assign({}, state, {
                    CellHighlightInfo: state.CellHighlightInfo.filter((celHighlightInfo)=>{
                        const id = `${celHighlightInfo.columnId}-${celHighlightInfo.primaryKeyValue}`;
                        return id !== actionId;
                    })
                });
            }
        case $5b564bb703f29152$export$565d0994f34459df:
            return Object.assign({}, state, {
                CellHighlightInfo: []
            });
        case $5b564bb703f29152$export$17a87e5a743cea30:
            {
                const actionTypedAdd = action;
                return Object.assign({}, state, {
                    ColumnHighlightInfo: [
                        ...state.ColumnHighlightInfo,
                        actionTypedAdd.columnHighlightInfo
                    ]
                });
            }
        case $5b564bb703f29152$export$541d71e5cda0756c:
            {
                const actionTypedDelete = action;
                const actionId = actionTypedDelete.columnId;
                return Object.assign({}, state, {
                    ColumnHighlightInfo: state.ColumnHighlightInfo.filter((columnHighlightInfo)=>{
                        return columnHighlightInfo.columnId !== actionId;
                    })
                });
            }
        case $5b564bb703f29152$export$8062ce7f7143d859:
            return Object.assign({}, state, {
                ColumnHighlightInfo: []
            });
        case $5b564bb703f29152$export$7d1895646bfa0f08:
            {
                const actionTypedAdd = action;
                return Object.assign({}, state, {
                    RowHighlightInfo: [
                        ...state.RowHighlightInfo,
                        actionTypedAdd.rowHighlightInfo
                    ]
                });
            }
        case $5b564bb703f29152$export$fad44cf871b0d26b:
            {
                const actionTypedAdd = action;
                const rowHighlightInfos = actionTypedAdd.rowsHighlightInfo.primaryKeyValues.map((primaryKeyValue)=>{
                    return {
                        primaryKeyValue: primaryKeyValue,
                        highlightStyle: actionTypedAdd.rowsHighlightInfo.highlightStyle,
                        timeout: actionTypedAdd.rowsHighlightInfo.timeout
                    };
                });
                return Object.assign({}, state, {
                    RowHighlightInfo: [
                        ...state.RowHighlightInfo,
                        ...rowHighlightInfos
                    ]
                });
            }
        case $5b564bb703f29152$export$2d689283eeefed87:
            {
                const actionTypedDelete = action;
                const actionId = actionTypedDelete.primaryKeyValue;
                return Object.assign({}, state, {
                    RowHighlightInfo: state.RowHighlightInfo.filter((rowHighlightInfo)=>{
                        return rowHighlightInfo.primaryKeyValue !== actionId;
                    })
                });
            }
        case $5b564bb703f29152$export$25d096a3d0a79afc:
            {
                const actionTypedDelete = action;
                return Object.assign({}, state, {
                    RowHighlightInfo: state.RowHighlightInfo.filter((rowHighlightInfo)=>{
                        return !actionTypedDelete.primaryKeyValues.includes(rowHighlightInfo.primaryKeyValue);
                    })
                });
            }
        case $5b564bb703f29152$export$6e5e141003a5370d:
            return Object.assign({}, state, {
                RowHighlightInfo: []
            });
        case $5b564bb703f29152$export$c16775ef924f1b9a:
            {
                const actionTypedAdd = action;
                alerts = [].concat(state.AdaptableAlerts);
                if (alerts.length == actionTypedAdd.maxAlerts) // we have hit the maximum so remove first item (oldest)
                alerts.splice(0, 1);
                alerts.push(actionTypedAdd.alert);
                return Object.assign({}, state, {
                    AdaptableAlerts: alerts
                });
            }
        case $5b564bb703f29152$export$da4d4b120f90dd49:
            {
                const adaptableAlert = action.alert;
                return {
                    ...state,
                    AdaptableAlerts: state.AdaptableAlerts.filter((abObject)=>abObject.Uuid !== adaptableAlert.Uuid)
                };
            }
        case $5b564bb703f29152$export$8b66681127c3e555:
            return Object.assign({}, state, {
                AdaptableAlerts: []
            });
        case $5b564bb703f29152$export$c68a41837441fcf7:
            {
                const adaptableAlert = action.alert;
                return {
                    ...state,
                    AdaptableAlerts: state.AdaptableAlerts.map((abObject)=>{
                        if (abObject.Uuid === adaptableAlert.Uuid) {
                            // AdaptableAlerts are still linked to the live AlertDefinitions, so we have to decouple them
                            const newAbObject = {
                                ...abObject
                            };
                            newAbObject.alertDefinition = (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(abObject.alertDefinition);
                            delete newAbObject.alertDefinition.AlertProperties.HighlightCell;
                            return newAbObject;
                        }
                        return abObject;
                    })
                };
            }
        case $5b564bb703f29152$export$de0a34f95d27629f:
            {
                const adaptableAlert = action.alert;
                return {
                    ...state,
                    AdaptableAlerts: state.AdaptableAlerts.map((abObject)=>{
                        if (abObject.Uuid === adaptableAlert.Uuid) {
                            // AdaptableAlerts are still linked to the live AlertDefinitions, so we have to decouple them
                            const newAbObject = {
                                ...abObject
                            };
                            newAbObject.alertDefinition = (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(abObject.alertDefinition);
                            delete newAbObject.alertDefinition.AlertProperties.HighlightRow;
                            return newAbObject;
                        }
                        return abObject;
                    })
                };
            }
        case $5b564bb703f29152$export$e885ba7c056ff79b:
            {
                const actionTypedAdd = action;
                systemStatusMessages = [].concat(state.SystemStatusMessages);
                if (systemStatusMessages.length == actionTypedAdd.maxSystemStatusMessagesInStore) // we have hit the maximum so remove first item (oldest)
                systemStatusMessages.splice(0, 1);
                systemStatusMessages.push(actionTypedAdd.systemStatusMessageInfo);
                return Object.assign({}, state, {
                    SystemStatusMessages: systemStatusMessages
                });
            }
        case $5b564bb703f29152$export$504324ac771afe8e:
            return Object.assign({}, state, {
                SystemStatusMessages: []
            });
        case $5b564bb703f29152$export$d40c929da9e9f01a:
            return {
                ...state,
                SmartEdit: {
                    ...state.SmartEdit,
                    SmartEditValue: action.value
                }
            };
        case $5b564bb703f29152$export$9f15d1006db00da7:
            return {
                ...state,
                SmartEdit: {
                    ...state.SmartEdit,
                    SmartEditOperation: action.smartEditOperation
                }
            };
        case $5b564bb703f29152$export$88bac6f6391c31b0:
            return {
                ...state,
                SmartEdit: {
                    ...state.SmartEdit,
                    IsValidSmartEditSelection: action.isValidSmartEditSelection
                }
            };
        case $5b564bb703f29152$export$632d5d227e628562:
            return {
                ...state,
                SmartEdit: {
                    ...state.SmartEdit,
                    SmartEditPreviewInfo: action.smartEditPreviewInfo
                }
            };
        case $5b564bb703f29152$export$9070aec57ec562d6:
            return {
                ...state,
                BulkUpdate: {
                    ...state.BulkUpdate,
                    BulkUpdateValidationResult: action.bulkUpdateValidationResult
                }
            };
        case $5b564bb703f29152$export$148a230da3199254:
            return {
                ...state,
                BulkUpdate: {
                    ...state.BulkUpdate,
                    BulkUpdatePreviewInfo: action.bulkUpdatePreviewInfo
                }
            };
        case $5b564bb703f29152$export$6c538a66cf392594:
            return {
                ...state,
                BulkUpdate: {
                    ...state.BulkUpdate,
                    BulkUpdateValue: action.bulkUpdateValue
                }
            };
        case $5b564bb703f29152$export$1625f4504a3d57ef:
            {
                const actionTypedAdd = action;
                let cachedQueries = [].concat(state.CachedQueries);
                let queryToAdd = actionTypedAdd.cachedQuery;
                if (queryToAdd) {
                    if (cachedQueries.length == 5) // we have hit the maximum so remove first item (oldest)
                    cachedQueries.splice(0, 1);
                    cachedQueries.push(actionTypedAdd.cachedQuery);
                }
                return Object.assign({}, state, {
                    CachedQueries: cachedQueries
                });
            }
        case $5b564bb703f29152$export$1ee43196df0dcb5a:
            return {
                ...state,
                CellSummary: {
                    ...state.CellSummary,
                    CellSummaryInfo: action.cellSummaryInfo
                }
            };
        case $5b564bb703f29152$export$147736b3a58c916d:
            return {
                ...state,
                CellSummary: {
                    ...state.CellSummary,
                    CellSummaryOperation: action.cellSummaryOperation
                }
            };
        case $5b564bb703f29152$export$282fb886c663088e:
            return {
                ...state,
                License: {
                    ...state.License,
                    watermark: {
                        show: true,
                        text: action.text
                    }
                }
            };
        case $5b564bb703f29152$export$25a55cb322dba1b7:
            return {
                ...state,
                License: {
                    ...state.License,
                    disablePersistence: true
                }
            };
        case $5b564bb703f29152$export$5bfd4c6440c8d5cf:
            {
                const actionTypedAdd = action;
                const cellDataChangedInfo = actionTypedAdd.changeInfo;
                const uniqueKey = actionTypedAdd.uniqueKey;
                const updatedDataChangeHistoryLogs = {
                    ...state.DataChangeHistory.logs
                };
                updatedDataChangeHistoryLogs[uniqueKey] = cellDataChangedInfo;
                return {
                    ...state,
                    DataChangeHistory: {
                        ...state.DataChangeHistory,
                        logs: updatedDataChangeHistoryLogs
                    }
                };
            }
        case $5b564bb703f29152$export$8fa42571c3ed7ce:
            {
                const actionTypedUndo = action;
                const cellDataChangedInfo = actionTypedUndo.changeInfo;
                const uniqueKey = actionTypedUndo.uniqueKey;
                const updatedDataChangeHistoryLogs = {
                    ...state.DataChangeHistory.logs
                };
                delete updatedDataChangeHistoryLogs[uniqueKey];
                return {
                    ...state,
                    DataChangeHistory: {
                        ...state.DataChangeHistory,
                        logs: updatedDataChangeHistoryLogs
                    }
                };
            }
        case $5b564bb703f29152$export$2eb85b0e1a1756a9:
            {
                const actionTypedClearRow = action;
                const cellDataChangedInfo = actionTypedClearRow.changeInfo;
                const uniqueKey = actionTypedClearRow.uniqueKey;
                const updatedDataChangeHistoryLogs = {
                    ...state.DataChangeHistory.logs
                };
                delete updatedDataChangeHistoryLogs[uniqueKey];
                return {
                    ...state,
                    DataChangeHistory: {
                        ...state.DataChangeHistory,
                        logs: updatedDataChangeHistoryLogs
                    }
                };
            }
        case $5b564bb703f29152$export$e15fba57eed9ad7a:
            return {
                ...state,
                DataChangeHistory: {
                    ...state.DataChangeHistory,
                    currentMode: 'ACTIVE',
                    enableTime: new Date(),
                    suspendTime: null
                }
            };
        case $5b564bb703f29152$export$668166beb957075b:
            return {
                ...state,
                DataChangeHistory: {
                    ...state.DataChangeHistory,
                    logs: {},
                    currentMode: 'INACTIVE',
                    enableTime: null,
                    suspendTime: null
                }
            };
        case $5b564bb703f29152$export$b284623f5d1e1134:
            return {
                ...state,
                DataChangeHistory: {
                    ...state.DataChangeHistory,
                    currentMode: 'SUSPENDED',
                    suspendTime: new Date()
                }
            };
        case $5b564bb703f29152$export$d72029662e46675c:
            return {
                ...state,
                DataChangeHistory: {
                    ...state.DataChangeHistory,
                    currentMode: 'ACTIVE',
                    suspendTime: null
                }
            };
        case $5b564bb703f29152$export$3afbaff58d6503d9:
            {
                const setSettingsAction = action;
                return {
                    ...state,
                    SettingsPanel: {
                        ...state?.SettingsPanel,
                        [setSettingsAction.name]: setSettingsAction.settings
                    }
                };
            }
        case $5b564bb703f29152$export$e8986ad6b988a309:
            return Object.assign({}, state, {
                IsQuickFilterVisible: true
            });
        case $5b564bb703f29152$export$5e04390a67ecd344:
            return Object.assign({}, state, {
                IsQuickFilterVisible: false
            });
        case $5b564bb703f29152$export$b2e4a9ae9dd89d14:
            {
                const typedAction = action;
                return {
                    ...state,
                    Layout: {
                        showLayoutNonExtendedObjects: typedAction.showNonExtendedObjects
                    }
                };
            }
        case $5b564bb703f29152$export$2a14b9f34817129b:
            return Object.assign({}, state, {
                CurrentDataSet: action.dataSet.name
            });
        case $5b564bb703f29152$export$100cce0260d307a:
            return {
                ...state,
                Dashboard: {
                    ...state.Dashboard,
                    DashboardRevision: state.Dashboard.DashboardRevision + 1
                }
            };
        case $5b564bb703f29152$export$de555af7fca36001:
            {
                const typedAction = action;
                return {
                    ...state,
                    Charting: {
                        ...state.Charting,
                        currentChartModels: typedAction.chartModels
                    }
                };
            }
        case $5b564bb703f29152$export$f2e8371a81441ef3:
            return {
                ...state,
                DisableDeleteConfirmation: true
            };
        case $5b564bb703f29152$export$dc07b6c6c3a46f0e:
            {
                const typedAction = action;
                return {
                    ...state,
                    Export: {
                        inProgress: {
                            reportName: typedAction.reportName,
                            reportFormat: typedAction.reportFormat,
                            exportDestination: typedAction.exportDestination
                        }
                    }
                };
            }
        case $5b564bb703f29152$export$9e9cc935d26629f1:
            return {
                ...state,
                Export: {
                    inProgress: null
                }
            };
        case $5b564bb703f29152$export$7d0dd0214f487983:
            {
                const typedAction = action;
                return {
                    ...state,
                    QuickSearch: {
                        ...state.QuickSearch,
                        floatingVisible: typedAction.visible
                    }
                };
            }
        case $5b564bb703f29152$export$3779aee3003c0e71:
            {
                const typedAction = action;
                // reuse address reference if we are editing the same cell
                let newAddress = typedAction?.cellPosition;
                const oldAddress = state?.NotesAndComments?.popupPosition;
                if ((0, $7c292221d5e0caef$export$1b7119c6164d748a).isSameAddress(oldAddress, typedAction.cellPosition)) {
                    newAddress = oldAddress;
                    // if edit mode is the same, just exist
                    if (typedAction.editMode === state.NotesAndComments.editMode) return state;
                }
                return {
                    ...state,
                    NotesAndComments: {
                        ...state.NotesAndComments,
                        editMode: typedAction.editMode,
                        popupPosition: newAddress
                    }
                };
            }
        case $5b564bb703f29152$export$c0741eff034775f1:
            {
                const typedAction = action;
                return {
                    ...state,
                    NotesAndComments: {
                        ...state.NotesAndComments,
                        focusedEntity: typedAction.focusedEntity
                    }
                };
            }
        case $5b564bb703f29152$export$7cc2778a72a3b1e3:
            return {
                ...state,
                NotesAndComments: {
                    editMode: false,
                    popupPosition: null
                }
            };
        case $5b564bb703f29152$export$b46645b802c722c8:
            {
                const typedAction = action;
                return {
                    ...state,
                    RowSummary: {
                        rowSummaries: typedAction.rowSummaries
                    }
                };
            }
        default:
            return state;
    }
};



var $9g4SS = parcelRequire("9g4SS");
class $7c292221d5e0caef$export$1b7119c6164d748a {
    api;
    adaptable;
    isListeningToEvents;
    constructor(api){
        this.api = api;
        this.isListeningToEvents = false;
        this.adaptable = api.internalApi.getAdaptableInstance();
        this.adaptable.api.eventApi.on('AdaptableReady', ()=>this.checkListenToEvents());
    }
    destroy() {}
    getAdaptableState() {
        return this.api.internalApi.getAdaptableState();
    }
    dispatchAction(action) {
        this.api.internalApi.dispatchReduxAction(action);
    }
    static isSameAddress(a, b) {
        if (!a || !b) return false;
        if (a?.ColumnId === b?.ColumnId && a?.PrimaryKeyValue === b?.PrimaryKeyValue) return true;
        // Primary keys retrieved from the grid dom are always strings, so we must also consider them strings
        if (typeof a.PrimaryKeyValue === 'number' && typeof b.PrimaryKeyValue === 'string' || typeof b.PrimaryKeyValue === 'string' && typeof a.PrimaryKeyValue === 'number') return a.PrimaryKeyValue.toString() === b.PrimaryKeyValue.toString() && a.ColumnId === b.ColumnId;
        return false;
    }
    checkListenToEvents() {
        if (!this.isListeningToEvents && this.shouldListenToEvents()) {
            this.setUpEventListeners();
            this.isListeningToEvents = true;
        }
    }
    shouldListenToEvents() {
        // Listen to events if we either have Notes in state or if Comments have been set up
        return (0, $9g4SS.default).IsNotNullOrEmpty(this.api.noteApi.getAllNotes()) || this.api.internalApi.getModuleService().isAdapTableModulePresent('Comment');
    }
    setUpEventListeners() {
        this.adaptable._on('MouseEnter', (event)=>this.handleMouseEnter(event));
        this.api.eventApi.on('CellSelectionChanged', (params)=>{
            const cells = params.selectedCellInfo.gridCells;
            if ((0, $9g4SS.default).hasOneItem(cells)) {
                const selectedCell = cells[0];
                if (selectedCell.column?.columnId && selectedCell.primaryKeyValue) {
                    const selectedCellAddress = {
                        PrimaryKeyValue: selectedCell.primaryKeyValue,
                        ColumnId: selectedCell.column.columnId
                    };
                    this.handleCellSelected(selectedCellAddress);
                }
            }
        });
    }
    getCellPositionFromEvent(event) {
        const target = event.target;
        if (!target?.classList?.contains?.('ag-cell')) return null;
        try {
            const PrimaryKeyValue = target.parentElement.getAttribute('row-id');
            return {
                PrimaryKeyValue: PrimaryKeyValue,
                ColumnId: target.getAttribute('col-id')
            };
        } catch (e) {
            return null;
        }
    }
    handleMouseEnter(event) {
        const editMode = this.getEditMode();
        if (editMode) // ignore
        return;
        const cellPosition = this.getCellPositionFromEvent(event);
        const openCellAddress = this.getOpenCellAddress();
        // Hovering over something that is not a cell and there is no open note
        if (!cellPosition && openCellAddress) {
            // need to close if the new cell does not have a note
            this.hidePopup();
            return;
        }
        // call only if cell address is different
        if ($7c292221d5e0caef$export$1b7119c6164d748a.isSameAddress(openCellAddress, cellPosition)) return;
        const cellNote = this.api.noteApi.getNoteForCell(cellPosition);
        const cellComments = this.api.commentApi.getCommentThreadForCell(cellPosition);
        if (!cellNote && !cellComments) return;
        this.showPopup(cellPosition, false);
    }
    handleCellSelected(cellAddress) {
        // if already opened - do nothing
        const openCellAddress = this.getOpenCellAddress();
        if ($7c292221d5e0caef$export$1b7119c6164d748a.isSameAddress(openCellAddress, cellAddress)) return;
        // if open but this has no note, close
        const cellNote = this.api.noteApi.getNoteForCell(cellAddress);
        const cellComments = this.api.commentApi.getCommentThreadForCell(cellAddress);
        const hasNotesOrComments = cellNote || cellComments;
        if (openCellAddress && !hasNotesOrComments) {
            // hide only if in edit mode
            // because if you select a cell and move the mouse fast over another cell
            // with a note, you do not want to close that note
            // the selection is debounced, so the moment goes over the new cell this event is triggered
            if (this.getEditMode()) this.hidePopup();
            return;
        }
        // if open but the new selection has a note open that one in edit mode (because of click)
        if (openCellAddress && hasNotesOrComments) {
            this.showPopup(cellAddress, true);
            return;
        }
    }
    getOpenCellAddress() {
        return $5b564bb703f29152$export$7546faff8f4dea4d(this.getAdaptableState().Internal);
    }
    getEditMode() {
        return $5b564bb703f29152$export$8c3f353a3a9e8bd4(this.getAdaptableState().Internal);
    }
    hidePopup() {
        this.dispatchAction($5b564bb703f29152$export$782bdd769187d275());
    }
    showPopup(cellAddress, editMode) {
        this.dispatchAction($5b564bb703f29152$export$efbea932e5154af2(cellAddress, editMode));
    }
    editFocusedEntity(entity) {
        this.dispatchAction($5b564bb703f29152$export$b592a2b6f55a23fb(entity));
    }
    getNotePopupEditMode() {
        return $5b564bb703f29152$export$8c3f353a3a9e8bd4(this.getAdaptableState().Internal);
    }
}


const $4e814d4456d3e111$export$e0ea86c1cc990e84 = 'COMMENT_ADD';
const $4e814d4456d3e111$export$8d83c99b2938b6f5 = 'COMMENT_THREAD_ADD';
const $4e814d4456d3e111$export$4e39991b17fb7f02 = 'COMMENT_THREAD_DELETE';
const $4e814d4456d3e111$export$4e1261b76c89c910 = 'COMMENT_EDIT';
const $4e814d4456d3e111$export$46603197b09023ec = 'COMMENT_DELETE';
const $4e814d4456d3e111$export$780e1e994e9a1763 = 'COMMENTS_READY';
const $4e814d4456d3e111$export$9068a450ff36a380 = 'COMMENTS_THREADS_LOAD';
const $4e814d4456d3e111$export$deb82563293619ac = ({ commentThreads: commentThreads })=>({
        type: $4e814d4456d3e111$export$9068a450ff36a380,
        commentThreads: commentThreads
    });
const $4e814d4456d3e111$export$efe3cd4a09e7630d = ({ comment: comment, cellAddress: cellAddress })=>({
        type: $4e814d4456d3e111$export$e0ea86c1cc990e84,
        comment: comment,
        cellAddress: cellAddress
    });
const $4e814d4456d3e111$export$7377931e5393aad4 = ({ commentThread: commentThread })=>({
        type: $4e814d4456d3e111$export$8d83c99b2938b6f5,
        commentThread: commentThread
    });
const $4e814d4456d3e111$export$2f0a4ff7e52f33a = ({ cellAddress: cellAddress })=>({
        type: $4e814d4456d3e111$export$4e39991b17fb7f02,
        cellAddress: cellAddress
    });
const $4e814d4456d3e111$export$aba82d4e5a4c129e = ({ comment: comment, cellAddress: cellAddress })=>({
        type: $4e814d4456d3e111$export$4e1261b76c89c910,
        comment: comment,
        cellAddress: cellAddress
    });
const $4e814d4456d3e111$export$fbe86001491d9da3 = ({ commentUuid: commentUuid, cellAddress: cellAddress })=>({
        type: $4e814d4456d3e111$export$46603197b09023ec,
        cellAddress: cellAddress,
        commentUuid: commentUuid
    });
const $4e814d4456d3e111$export$c662b749c0ef4d93 = (state, address)=>{
    if (!address) return undefined;
    return (state?.CommentThreads ?? []).find((commentThread)=>{
        return (0, $7c292221d5e0caef$export$1b7119c6164d748a).isSameAddress(commentThread, address);
    });
};
const $4e814d4456d3e111$var$initialState = {
    CommentThreads: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $4e814d4456d3e111$export$a069e6fb375b1344 = (state = $4e814d4456d3e111$var$initialState, action)=>{
    switch(action.type){
        case $4e814d4456d3e111$export$e0ea86c1cc990e84:
            {
                const addAction = action;
                const commentThread = state.CommentThreads ?? [];
                const cellCommentIndex = commentThread.findIndex((cellComments)=>{
                    return (0, $7c292221d5e0caef$export$1b7119c6164d748a).isSameAddress(cellComments, addAction.cellAddress);
                });
                let comments = [
                    ...commentThread
                ];
                if (cellCommentIndex === -1) // new comments
                comments.push({
                    ...(0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyCommentThread(addAction.cellAddress),
                    Comments: [
                        addAction.comment
                    ]
                });
                else {
                    const existing = {
                        ...commentThread[cellCommentIndex],
                        Comments: [
                            ...commentThread[cellCommentIndex].Comments,
                            addAction.comment
                        ]
                    };
                    comments[cellCommentIndex] = existing;
                }
                return {
                    ...state,
                    CommentThreads: comments
                };
            }
        case $4e814d4456d3e111$export$8d83c99b2938b6f5:
            return {
                ...state,
                CommentThreads: [
                    ...state.CommentThreads ?? [],
                    action.commentThread
                ]
            };
        case $4e814d4456d3e111$export$4e39991b17fb7f02:
            {
                const deleteAction = action;
                return {
                    ...state,
                    CommentThreads: (state.CommentThreads ?? []).filter((cellComments)=>!(0, $7c292221d5e0caef$export$1b7119c6164d748a).isSameAddress(cellComments, deleteAction.cellAddress))
                };
            }
        case $4e814d4456d3e111$export$4e1261b76c89c910:
            {
                const editAction = action;
                let edited = false;
                const adaptableCellComments = (state.CommentThreads ?? []).map((cellComments)=>{
                    if ((0, $7c292221d5e0caef$export$1b7119c6164d748a).isSameAddress(cellComments, editAction.cellAddress)) {
                        // found the place
                        edited = true;
                        return {
                            ...cellComments,
                            Comments: cellComments.Comments.map((comment)=>{
                                if (comment.Uuid === editAction.comment.Uuid) return editAction.comment;
                                return comment;
                            })
                        };
                    }
                });
                return {
                    ...state,
                    CommentThreads: adaptableCellComments
                };
            }
        case $4e814d4456d3e111$export$46603197b09023ec:
            {
                const deleteAction = action;
                const adaptableCellComments = (state.CommentThreads ?? []).map((cellComments)=>{
                    if ((0, $7c292221d5e0caef$export$1b7119c6164d748a).isSameAddress(cellComments, deleteAction.cellAddress)) {
                        // found the place
                        const newComments = cellComments.Comments.filter((comment)=>comment.Uuid !== deleteAction.commentUuid);
                        if (newComments.length === 0) return null;
                        const newCellComments = {
                            ...cellComments,
                            Comments: newComments
                        };
                        return newCellComments;
                    }
                    return cellComments;
                }).filter((cellComments)=>cellComments !== null);
                return {
                    ...state,
                    CommentThreads: adaptableCellComments
                };
            }
        case $4e814d4456d3e111$export$9068a450ff36a380:
            return {
                ...state,
                CommentThreads: action.commentThreads
            };
        default:
            return state;
    }
};





const $75a64529baee8b47$export$82d5f05636051c1f = 'CUSTOM_SORT_ADD';
const $75a64529baee8b47$export$37e3fb42a2441efe = 'CUSTOM_SORT_EDIT';
const $75a64529baee8b47$export$43c8c2949c595161 = 'CUSTOM_SORT_DELETE';
const $75a64529baee8b47$export$eb590f115bc9eaf6 = 'CUSTOM_SORT_SUSPEND';
const $75a64529baee8b47$export$d91b24db8ab03460 = 'CUSTOM_SORT_UNSUSPEND';
const $75a64529baee8b47$export$620ff7671b99bf9d = 'CUSTOM_SORT_SUSPEND_ALL';
const $75a64529baee8b47$export$9b4328f9bf0b668 = 'CUSTOM_SORT_UNSUSPEND_ALL';
const $75a64529baee8b47$export$26751ace59b1c612 = 'CUSTOM_SORT_READY';
const $75a64529baee8b47$export$9cd83b3dd04bb797 = (customSort)=>({
        type: $75a64529baee8b47$export$82d5f05636051c1f,
        customSort: customSort
    });
const $75a64529baee8b47$export$4b53156c61c1ad3d = (customSort)=>({
        type: $75a64529baee8b47$export$37e3fb42a2441efe,
        customSort: customSort
    });
const $75a64529baee8b47$export$6fc68e516c87f722 = (customSort)=>({
        type: $75a64529baee8b47$export$43c8c2949c595161,
        customSort: customSort
    });
const $75a64529baee8b47$export$259d7a681e73c8b6 = (customSort)=>({
        type: $75a64529baee8b47$export$eb590f115bc9eaf6,
        customSort: customSort
    });
const $75a64529baee8b47$export$d37aedd8579b604 = (customSort)=>({
        type: $75a64529baee8b47$export$d91b24db8ab03460,
        customSort: customSort
    });
const $75a64529baee8b47$export$20981ed2c354783f = ()=>({
        type: $75a64529baee8b47$export$620ff7671b99bf9d
    });
const $75a64529baee8b47$export$ed3948c082d4a953 = ()=>({
        type: $75a64529baee8b47$export$9b4328f9bf0b668
    });
const $75a64529baee8b47$export$c12671676901bc26 = (customSortState)=>({
        type: $75a64529baee8b47$export$26751ace59b1c612,
        customSortState: customSortState
    });
const $75a64529baee8b47$var$initialState = {
    CustomSorts: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $75a64529baee8b47$export$83be7392811f3b65 = (state = $75a64529baee8b47$var$initialState, action)=>{
    let customSorts;
    switch(action.type){
        case $75a64529baee8b47$export$82d5f05636051c1f:
            {
                const actionCustomSort = action.customSort;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionCustomSort);
                customSorts = [].concat(state.CustomSorts);
                customSorts.push(actionCustomSort);
                return {
                    ...state,
                    CustomSorts: customSorts
                };
            }
        case $75a64529baee8b47$export$37e3fb42a2441efe:
            {
                const actionCustomSort = action.customSort;
                return {
                    ...state,
                    CustomSorts: state.CustomSorts.map((abObject)=>abObject.Uuid === actionCustomSort.Uuid ? actionCustomSort : abObject)
                };
            }
        case $75a64529baee8b47$export$43c8c2949c595161:
            {
                const actionCustomSort = action.customSort;
                return {
                    ...state,
                    CustomSorts: state.CustomSorts.filter((abObject)=>abObject.Uuid !== actionCustomSort.Uuid)
                };
            }
        case $75a64529baee8b47$export$eb590f115bc9eaf6:
            return {
                ...state,
                CustomSorts: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.customSort, state.CustomSorts, true)
            };
        case $75a64529baee8b47$export$d91b24db8ab03460:
            return {
                ...state,
                CustomSorts: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.customSort, state.CustomSorts, false)
            };
        case $75a64529baee8b47$export$620ff7671b99bf9d:
            return {
                ...state,
                CustomSorts: (0, $471c8159162519ad$export$d5749a3ee2d57eaa)(state.CustomSorts)
            };
        case $75a64529baee8b47$export$9b4328f9bf0b668:
            return {
                ...state,
                CustomSorts: (0, $471c8159162519ad$export$94c949ae997a6e37)(state.CustomSorts)
            };
        default:
            return state;
    }
};



const $dc6bc6f406d56c84$export$275ed42331417618 = 'DASHBOARD_SET_MODULE_BUTTONS';
const $dc6bc6f406d56c84$export$6931bbeea6091f8c = 'DASHBOARD_ACTIVE_TAB_INDEX_CHANGE';
const $dc6bc6f406d56c84$export$b451dd41daee3965 = 'DASHBOARD_SET_IS_COLLAPSED';
const $dc6bc6f406d56c84$export$91c524c261db7e40 = 'DASHBOARD_SET_IS_FLOATING';
const $dc6bc6f406d56c84$export$461adf9e9f007a5a = 'DASHBOARD_SET_IS_INLINE';
const $dc6bc6f406d56c84$export$47b4a641ee3cc004 = 'DASHBOARD_SET_IS_HIDDEN';
const $dc6bc6f406d56c84$export$5d1d6e84259d21d8 = 'DASHBOARD_SET_FLOATING_POSITION';
const $dc6bc6f406d56c84$export$36959fe86cc6fb38 = 'DASHBOARD_SET_TABS';
const $dc6bc6f406d56c84$export$8750395074e799b0 = 'DASHBOARD_SET_PINNED_TOOLBARS';
const $dc6bc6f406d56c84$export$63e4674795a9c9b8 = 'DASHBOARD_CLOSE_TOOLBAR';
const $dc6bc6f406d56c84$export$b81e5574e6ae39a0 = 'DASHBOARD_SET_TITLE';
const $dc6bc6f406d56c84$export$b5d9a45fbd0ac6d0 = 'DASHBOARD_READY';
const $dc6bc6f406d56c84$export$159d43c9de7aed08 = (moduleButtons)=>({
        type: $dc6bc6f406d56c84$export$275ed42331417618,
        moduleButtons: moduleButtons
    });
const $dc6bc6f406d56c84$export$b0602226505423cf = (ActiveTabIndex)=>({
        type: $dc6bc6f406d56c84$export$6931bbeea6091f8c,
        ActiveTabIndex: ActiveTabIndex
    });
const $dc6bc6f406d56c84$export$4a9fdbf5568e83b6 = (IsCollapsed)=>({
        type: $dc6bc6f406d56c84$export$b451dd41daee3965,
        IsCollapsed: IsCollapsed
    });
const $dc6bc6f406d56c84$export$d83abcde9deec805 = (IsFloating)=>({
        type: $dc6bc6f406d56c84$export$91c524c261db7e40,
        IsFloating: IsFloating
    });
const $dc6bc6f406d56c84$export$b2de5be7510594c1 = (IsHidden)=>({
        type: $dc6bc6f406d56c84$export$47b4a641ee3cc004,
        IsHidden: IsHidden
    });
const $dc6bc6f406d56c84$export$1d4ea884b604317e = (IsInline)=>({
        type: $dc6bc6f406d56c84$export$461adf9e9f007a5a,
        IsInline: IsInline
    });
const $dc6bc6f406d56c84$export$dfc443e4c0b6468d = (FloatingPosition)=>({
        type: $dc6bc6f406d56c84$export$5d1d6e84259d21d8,
        FloatingPosition: FloatingPosition
    });
const $dc6bc6f406d56c84$export$a79213d66294d5b2 = (Tabs)=>({
        type: $dc6bc6f406d56c84$export$36959fe86cc6fb38,
        Tabs: Tabs
    });
const $dc6bc6f406d56c84$export$e9d8f4a531588479 = (toolbar)=>({
        toolbar: toolbar,
        type: $dc6bc6f406d56c84$export$63e4674795a9c9b8
    });
const $dc6bc6f406d56c84$export$71594d6c7c1c5baf = (title)=>({
        type: $dc6bc6f406d56c84$export$b81e5574e6ae39a0,
        title: title
    });
const $dc6bc6f406d56c84$export$2f57a1ad995fb6d8 = (dashboardState)=>({
        type: $dc6bc6f406d56c84$export$b5d9a45fbd0ac6d0,
        dashboardState: dashboardState
    });
const $dc6bc6f406d56c84$export$6f65449fc8f69bb2 = (pinnedToolbars)=>({
        type: $dc6bc6f406d56c84$export$8750395074e799b0,
        pinnedToolbars: pinnedToolbars
    });
const $dc6bc6f406d56c84$var$initialState = {
    Tabs: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    ActiveTabIndex: 0,
    IsCollapsed: false,
    IsFloating: false,
    IsHidden: false,
    IsInline: false,
    FloatingPosition: {
        x: 100,
        y: 100
    },
    ModuleButtons: [
        'SettingsPanel'
    ],
    DashboardTitle: ''
};
const $dc6bc6f406d56c84$export$8acdf620baca4d1b = (state = $dc6bc6f406d56c84$var$initialState, action)=>{
    switch(action.type){
        case $dc6bc6f406d56c84$export$275ed42331417618:
            {
                const actionTyped = action;
                const dashboardModuleButtons = actionTyped.moduleButtons;
                return Object.assign({}, state, {
                    ModuleButtons: dashboardModuleButtons,
                    VisibleButtons: undefined
                });
            }
        case $dc6bc6f406d56c84$export$6931bbeea6091f8c:
            {
                const { ActiveTabIndex: ActiveTabIndex } = action;
                return {
                    ...state,
                    ActiveTabIndex: ActiveTabIndex
                };
            }
        case $dc6bc6f406d56c84$export$b451dd41daee3965:
            {
                const { IsCollapsed: IsCollapsed } = action;
                return {
                    ...state,
                    IsCollapsed: IsCollapsed
                };
            }
        case $dc6bc6f406d56c84$export$91c524c261db7e40:
            {
                const { IsFloating: IsFloating } = action;
                return {
                    ...state,
                    IsFloating: IsFloating
                };
            }
        case $dc6bc6f406d56c84$export$47b4a641ee3cc004:
            {
                const { IsHidden: IsHidden } = action;
                return {
                    ...state,
                    IsHidden: IsHidden
                };
            }
        case $dc6bc6f406d56c84$export$461adf9e9f007a5a:
            {
                const { IsInline: IsInline } = action;
                return {
                    ...state,
                    IsInline: IsInline
                };
            }
        case $dc6bc6f406d56c84$export$5d1d6e84259d21d8:
            {
                const { FloatingPosition: FloatingPosition } = action;
                return {
                    ...state,
                    FloatingPosition: FloatingPosition
                };
            }
        case $dc6bc6f406d56c84$export$36959fe86cc6fb38:
            {
                const { Tabs: Tabs } = action;
                return {
                    ...state,
                    Tabs: Tabs
                };
            }
        case $dc6bc6f406d56c84$export$63e4674795a9c9b8:
            {
                const actionTyped = action;
                const tabs = [].concat(state.Tabs);
                const currentTab = tabs[state.ActiveTabIndex];
                if (currentTab) {
                    const toolbars = [].concat(currentTab.Toolbars);
                    const index = toolbars.findIndex((t)=>t == actionTyped.toolbar);
                    toolbars.splice(index, 1);
                    currentTab.Toolbars = toolbars;
                    return {
                        ...state,
                        Tabs: tabs
                    };
                } else return {
                    ...state
                };
            }
        case $dc6bc6f406d56c84$export$b81e5574e6ae39a0:
            {
                const actionTyped = action;
                return Object.assign({}, state, {
                    DashboardTitle: actionTyped.title
                });
            }
        case $dc6bc6f406d56c84$export$8750395074e799b0:
            {
                const actionTyped = action;
                return Object.assign({}, state, {
                    PinnedToolbars: actionTyped.pinnedToolbars
                });
            }
        default:
            return state;
    }
};




const $a3814690501f278b$export$b70aea09767f9d2f = 'REPORT_SELECT';
const $a3814690501f278b$export$dbd09e5e868cb9c4 = 'REPORT_ADD';
const $a3814690501f278b$export$5545798acf30828c = 'REPORT_EDIT';
const $a3814690501f278b$export$97446fcec9cb243f = 'REPORT_DELETE';
const $a3814690501f278b$export$3c3cf33084cef964 = 'EXPORT_READY';
const $a3814690501f278b$export$a4b2bcc55aabdbca = 'FORMAT_SELECT';
const $a3814690501f278b$export$4fed8ac69b10bc84 = (SelectedReport)=>({
        type: $a3814690501f278b$export$b70aea09767f9d2f,
        SelectedReport: SelectedReport
    });
const $a3814690501f278b$export$912b4282768b66e2 = (report)=>({
        type: $a3814690501f278b$export$dbd09e5e868cb9c4,
        report: report
    });
const $a3814690501f278b$export$93cc87a6c44ca1b = (report)=>({
        type: $a3814690501f278b$export$5545798acf30828c,
        report: report
    });
const $a3814690501f278b$export$4373a255555364a8 = (report)=>({
        type: $a3814690501f278b$export$97446fcec9cb243f,
        report: report
    });
const $a3814690501f278b$export$b7d9fd39701b9d58 = (exportState)=>({
        type: $a3814690501f278b$export$3c3cf33084cef964,
        exportState: exportState
    });
const $a3814690501f278b$export$45b3b10f3d3673c8 = (SelectedFormat)=>({
        type: $a3814690501f278b$export$a4b2bcc55aabdbca,
        SelectedFormat: SelectedFormat
    });
const $a3814690501f278b$var$initialState = {
    Reports: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $a3814690501f278b$export$d8625ffb5330d880 = (state = $a3814690501f278b$var$initialState, action)=>{
    let reports;
    switch(action.type){
        case $a3814690501f278b$export$b70aea09767f9d2f:
            return Object.assign({}, state, {
                CurrentReport: action.SelectedReport
            });
        case $a3814690501f278b$export$dbd09e5e868cb9c4:
            {
                const actionReport = action.report;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionReport);
                reports = [].concat(state.Reports);
                reports.push(actionReport);
                return {
                    ...state,
                    Reports: reports
                };
            }
        case $a3814690501f278b$export$5545798acf30828c:
            const actionReport = action.report;
            return {
                ...state,
                Reports: state.Reports.map((abObject)=>abObject.Uuid === actionReport.Uuid ? actionReport : abObject)
            };
        case $a3814690501f278b$export$97446fcec9cb243f:
            {
                const actionReport = action.report;
                return {
                    ...state,
                    Reports: state.Reports.filter((abObject)=>abObject.Uuid !== actionReport.Uuid)
                };
            }
        case $a3814690501f278b$export$a4b2bcc55aabdbca:
            return Object.assign({}, state, {
                CurrentFormat: action.SelectedFormat
            });
        default:
            return state;
    }
};




const $26ec30a4ba180d8a$export$805f35bb772015ea = 'FLASHING_CELL_DEFINITION_ADD';
const $26ec30a4ba180d8a$export$79c96b0355f197ca = 'FLASHING_CELL_DEFINITION_EDIT';
const $26ec30a4ba180d8a$export$1d3518db481297a2 = 'FLASHING_CELL_DEFINITION_DELETE';
const $26ec30a4ba180d8a$export$cb179a605c2b95a1 = 'FLASHING_CELL_DEFINITION_SUSPEND';
const $26ec30a4ba180d8a$export$2745afda6699d8b1 = 'FLASHING_CELL_DEFINITION_UNSUSPEND';
const $26ec30a4ba180d8a$export$a043ce31c00fce71 = 'FLASHING_CELL_DEFINITION_SUSPEND_ALL';
const $26ec30a4ba180d8a$export$3790814dfab55bb4 = 'FLASHING_CELL_DEFINITION_UNSUSPEND_ALL';
const $26ec30a4ba180d8a$export$110520fb391f44ef = 'FLASHING_CELL_READY';
const $26ec30a4ba180d8a$export$ba2f4ca718e6095a = 'FLASHING_CELL_DEFINITION_SET';
const $26ec30a4ba180d8a$export$a8d1d19a17affa5e = (flashingCellDefinition)=>({
        type: $26ec30a4ba180d8a$export$805f35bb772015ea,
        flashingCellDefinition: flashingCellDefinition
    });
const $26ec30a4ba180d8a$export$33d59aff38cdf86 = (flashingCellDefinitions)=>({
        type: $26ec30a4ba180d8a$export$ba2f4ca718e6095a,
        flashingCellDefinitions: flashingCellDefinitions
    });
const $26ec30a4ba180d8a$export$5927e3ffef099800 = (flashingCellDefinition)=>({
        type: $26ec30a4ba180d8a$export$79c96b0355f197ca,
        flashingCellDefinition: flashingCellDefinition
    });
const $26ec30a4ba180d8a$export$2a634d0eb40c9e99 = (flashingCellDefinition)=>({
        type: $26ec30a4ba180d8a$export$1d3518db481297a2,
        flashingCellDefinition: flashingCellDefinition
    });
const $26ec30a4ba180d8a$export$d7b5cc0486d3a052 = (flashingCellDefinition)=>({
        type: $26ec30a4ba180d8a$export$cb179a605c2b95a1,
        flashingCellDefinition: flashingCellDefinition
    });
const $26ec30a4ba180d8a$export$18482237a63d9b71 = (flashingCellDefinition)=>({
        type: $26ec30a4ba180d8a$export$2745afda6699d8b1,
        flashingCellDefinition: flashingCellDefinition
    });
const $26ec30a4ba180d8a$export$c6ef66fac999d641 = ()=>({
        type: $26ec30a4ba180d8a$export$a043ce31c00fce71
    });
const $26ec30a4ba180d8a$export$ecc232ed8e2f9f96 = ()=>({
        type: $26ec30a4ba180d8a$export$3790814dfab55bb4
    });
const $26ec30a4ba180d8a$export$b38802756856d3c1 = (alertState)=>({
        type: $26ec30a4ba180d8a$export$110520fb391f44ef,
        alertState: alertState
    });
const $26ec30a4ba180d8a$var$initialState = {
    FlashingCellDefinitions: []
};
const $26ec30a4ba180d8a$export$ccd2424f886bf649 = (state = $26ec30a4ba180d8a$var$initialState, action)=>{
    let flashingCellDefinitions;
    switch(action.type){
        case $26ec30a4ba180d8a$export$ba2f4ca718e6095a:
            {
                const actionFlashingCellDefinition = action.flashingCellDefinitions;
                return {
                    ...state,
                    FlashingCellDefinitions: actionFlashingCellDefinition
                };
            }
        case $26ec30a4ba180d8a$export$805f35bb772015ea:
            {
                const actionFlashingCellDefinition = action.flashingCellDefinition;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionFlashingCellDefinition);
                flashingCellDefinitions = [].concat(state.FlashingCellDefinitions);
                flashingCellDefinitions.push(actionFlashingCellDefinition);
                return {
                    ...state,
                    FlashingCellDefinitions: flashingCellDefinitions
                };
            }
        case $26ec30a4ba180d8a$export$79c96b0355f197ca:
            {
                const actionFlashingCellDefinition = action.flashingCellDefinition;
                return {
                    ...state,
                    FlashingCellDefinitions: state.FlashingCellDefinitions.map((abObject)=>abObject.Uuid === actionFlashingCellDefinition.Uuid ? actionFlashingCellDefinition : abObject)
                };
            }
        case $26ec30a4ba180d8a$export$1d3518db481297a2:
            {
                const actionFlashingCellDefinition = action.flashingCellDefinition;
                return {
                    ...state,
                    FlashingCellDefinitions: state.FlashingCellDefinitions.filter((abObject)=>abObject.Uuid !== actionFlashingCellDefinition.Uuid)
                };
            }
        case $26ec30a4ba180d8a$export$cb179a605c2b95a1:
            return {
                ...state,
                FlashingCellDefinitions: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.flashingCellDefinition, state.FlashingCellDefinitions, true)
            };
        case $26ec30a4ba180d8a$export$2745afda6699d8b1:
            return {
                ...state,
                FlashingCellDefinitions: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.flashingCellDefinition, state.FlashingCellDefinitions, false)
            };
        case $26ec30a4ba180d8a$export$a043ce31c00fce71:
            return {
                ...state,
                FlashingCellDefinitions: (0, $471c8159162519ad$export$d5749a3ee2d57eaa)(state.FlashingCellDefinitions)
            };
        case $26ec30a4ba180d8a$export$3790814dfab55bb4:
            return {
                ...state,
                FlashingCellDefinitions: (0, $471c8159162519ad$export$94c949ae997a6e37)(state.FlashingCellDefinitions)
            };
        default:
            return state;
    }
};





const $4a80335d87022149$export$ffb6d2c9303feec9 = 'FORMAT_COLUMN_ADD_BATCH';
const $4a80335d87022149$export$adfd77f5b0235282 = 'FORMAT_COLUMN_ADD';
const $4a80335d87022149$export$b7cb5d51e0ffb83a = 'FORMAT_COLUMN_MOVE_UP';
const $4a80335d87022149$export$cb2f47f94da9e750 = 'FORMAT_COLUMN_MOVE_DOWN';
const $4a80335d87022149$export$394b8559b8709e27 = 'FORMAT_COLUMN_EDIT';
const $4a80335d87022149$export$b6754c165aa11d2f = 'FORMAT_COLUMN_DELETE';
const $4a80335d87022149$export$3f21537021418d7 = 'FORMAT_COLUMN_DELETE_ALL';
const $4a80335d87022149$export$30a7ae47b3ae44e4 = 'FORMAT_COLUMN_READY';
const $4a80335d87022149$export$252f4fd568ae21d6 = 'FORMAT_COLUMN_SUSPEND';
const $4a80335d87022149$export$467d42e7704b7d08 = 'FORMAT_COLUMN_SUSPEND_ALL';
const $4a80335d87022149$export$ebaf6b30778dcb55 = 'FORMAT_COLUMN_UNSUSPEND';
const $4a80335d87022149$export$c10ab6feb50a850 = 'FORMAT_COLUMN_UNSUSPEND_ALL';
const $4a80335d87022149$export$2a417bad4431d29d = (formatColumns)=>({
        type: $4a80335d87022149$export$ffb6d2c9303feec9,
        formatColumns: formatColumns
    });
const $4a80335d87022149$export$f6dd745b1428a28 = (formatColumn)=>({
        type: $4a80335d87022149$export$adfd77f5b0235282,
        formatColumn: formatColumn
    });
const $4a80335d87022149$export$fab121d063a53ee9 = (formatColumn)=>({
        type: $4a80335d87022149$export$394b8559b8709e27,
        formatColumn: formatColumn
    });
const $4a80335d87022149$export$bf94c20884c4c766 = (formatColumn)=>({
        type: $4a80335d87022149$export$b6754c165aa11d2f,
        formatColumn: formatColumn
    });
const $4a80335d87022149$export$2cff6889719493e2 = ()=>({
        type: $4a80335d87022149$export$3f21537021418d7
    });
const $4a80335d87022149$export$87b5a2238e687c4b = (formatColumn)=>({
        type: $4a80335d87022149$export$b7cb5d51e0ffb83a,
        formatColumn: formatColumn
    });
const $4a80335d87022149$export$6b99718b79b178be = (formatColumn)=>({
        type: $4a80335d87022149$export$cb2f47f94da9e750,
        formatColumn: formatColumn
    });
const $4a80335d87022149$export$52a202b8aebe3f3b = (formatColumn)=>({
        type: $4a80335d87022149$export$252f4fd568ae21d6,
        formatColumn: formatColumn
    });
const $4a80335d87022149$export$6597bf75fa891de6 = (formatColumn)=>({
        type: $4a80335d87022149$export$ebaf6b30778dcb55,
        formatColumn: formatColumn
    });
const $4a80335d87022149$export$3153664dd4714fde = ()=>({
        type: $4a80335d87022149$export$467d42e7704b7d08
    });
const $4a80335d87022149$export$3de802c1f9ca8de0 = ()=>({
        type: $4a80335d87022149$export$c10ab6feb50a850
    });
const $4a80335d87022149$export$1fe738301e3bcbbc = (formatColumnState)=>({
        type: $4a80335d87022149$export$30a7ae47b3ae44e4,
        formatColumnState: formatColumnState
    });
const $4a80335d87022149$var$initialState = {
    FormatColumns: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $4a80335d87022149$export$65a302d1c7ffc34 = (state = $4a80335d87022149$var$initialState, action)=>{
    let formatColumns;
    switch(action.type){
        case $4a80335d87022149$export$ffb6d2c9303feec9:
            {
                const actionFormatColumns = action.formatColumns;
                actionFormatColumns.forEach((0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives);
                formatColumns = [].concat(state.FormatColumns);
                formatColumns.push(...actionFormatColumns);
                return {
                    ...state,
                    FormatColumns: formatColumns
                };
            }
        case $4a80335d87022149$export$adfd77f5b0235282:
            {
                const actionFormatColumn = action.formatColumn;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionFormatColumn);
                formatColumns = [].concat(state.FormatColumns);
                formatColumns.push(actionFormatColumn);
                return {
                    ...state,
                    FormatColumns: formatColumns
                };
            }
        case $4a80335d87022149$export$394b8559b8709e27:
            const actionFormatColumn = action.formatColumn;
            return {
                ...state,
                FormatColumns: state.FormatColumns.map((abObject)=>abObject.Uuid === actionFormatColumn.Uuid ? actionFormatColumn : abObject)
            };
        case $4a80335d87022149$export$b6754c165aa11d2f:
            {
                const actionFormatColumn = action.formatColumn;
                return {
                    ...state,
                    FormatColumns: state.FormatColumns.filter((abObject)=>abObject.Uuid !== actionFormatColumn.Uuid)
                };
            }
        case $4a80335d87022149$export$3f21537021418d7:
            return {
                ...state,
                FormatColumns: []
            };
        case $4a80335d87022149$export$252f4fd568ae21d6:
            return {
                ...state,
                FormatColumns: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.formatColumn, state.FormatColumns, true)
            };
        case $4a80335d87022149$export$ebaf6b30778dcb55:
            return {
                ...state,
                FormatColumns: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.formatColumn, state.FormatColumns, false)
            };
        case $4a80335d87022149$export$467d42e7704b7d08:
            return {
                ...state,
                FormatColumns: (0, $471c8159162519ad$export$d5749a3ee2d57eaa)(state.FormatColumns)
            };
        case $4a80335d87022149$export$c10ab6feb50a850:
            return {
                ...state,
                FormatColumns: (0, $471c8159162519ad$export$94c949ae997a6e37)(state.FormatColumns)
            };
        case $4a80335d87022149$export$b7cb5d51e0ffb83a:
            {
                const index = state.FormatColumns.findIndex((formatColumn)=>formatColumn.Uuid === action.formatColumn.Uuid);
                let swapIndex = index - 1;
                if (swapIndex < 0) swapIndex = state.FormatColumns.length - 1;
                const formatColumnToSwap = state.FormatColumns[swapIndex];
                const newFormatColumns = [
                    ...state.FormatColumns
                ];
                newFormatColumns[swapIndex] = state.FormatColumns[index];
                newFormatColumns[index] = formatColumnToSwap;
                return {
                    ...state,
                    FormatColumns: newFormatColumns
                };
            }
        case $4a80335d87022149$export$cb2f47f94da9e750:
            {
                const index = state.FormatColumns.findIndex((formatColumn)=>formatColumn.Uuid === action.formatColumn.Uuid);
                let swapIndex = index + 1;
                if (swapIndex > state.FormatColumns.length - 1) swapIndex = 0;
                const formatColumnToSwap = state.FormatColumns[swapIndex];
                const newFormatColumns = [
                    ...state.FormatColumns
                ];
                newFormatColumns[swapIndex] = state.FormatColumns[index];
                newFormatColumns[index] = formatColumnToSwap;
                return {
                    ...state,
                    FormatColumns: newFormatColumns
                };
            }
        default:
            return state;
    }
};




const $d8c519ae038bb984$export$6a9a507b9cd8ad46 = 'FREE_TEXT_COLUMN_ADD';
const $d8c519ae038bb984$export$5728fd58a5cf775e = 'FREE_TEXT_COLUMN_EDIT';
const $d8c519ae038bb984$export$603fcb8db0ec4ed0 = 'FREE_TEXT_COLUMN_DELETE';
const $d8c519ae038bb984$export$7d960b902e07f8d3 = 'FREE_TEXT_COLUMN_ADD_EDIT_STORED_VALUE';
const $d8c519ae038bb984$export$cc259540f684f67 = 'FREE_TEXT_COLUMN_READY';
const $d8c519ae038bb984$export$4ca8d1bea9462d79 = (freeTextColumn)=>({
        type: $d8c519ae038bb984$export$6a9a507b9cd8ad46,
        freeTextColumn: freeTextColumn
    });
const $d8c519ae038bb984$export$a83bd142017e0411 = (freeTextColumn)=>({
        type: $d8c519ae038bb984$export$5728fd58a5cf775e,
        freeTextColumn: freeTextColumn
    });
const $d8c519ae038bb984$export$9de6cb54225dd17a = (freeTextColumn)=>({
        type: $d8c519ae038bb984$export$603fcb8db0ec4ed0,
        freeTextColumn: freeTextColumn
    });
const $d8c519ae038bb984$export$fd759d45e00fce50 = (FreeTextColumn, FreeTextStoredValue)=>({
        type: $d8c519ae038bb984$export$7d960b902e07f8d3,
        FreeTextColumn: FreeTextColumn,
        FreeTextStoredValue: FreeTextStoredValue
    });
const $d8c519ae038bb984$export$de2a610be1ed0fd1 = (freeTextColumnState)=>({
        type: $d8c519ae038bb984$export$cc259540f684f67,
        freeTextColumnState: freeTextColumnState
    });
const $d8c519ae038bb984$var$initialState = {
    FreeTextColumns: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $d8c519ae038bb984$export$c4d3477b718d9e5a = (state = $d8c519ae038bb984$var$initialState, action)=>{
    // let freeTextColumns: FreeTextColumn[];
    switch(action.type){
        case $d8c519ae038bb984$export$6a9a507b9cd8ad46:
            {
                const actionFreeTextColumn = action.freeTextColumn;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionFreeTextColumn);
                const freeTextColumns = [
                    ...state.FreeTextColumns
                ];
                freeTextColumns.push(actionFreeTextColumn);
                return {
                    ...state,
                    FreeTextColumns: freeTextColumns
                };
            }
        // !! MUTABLE STATE
        case $d8c519ae038bb984$export$5728fd58a5cf775e:
            const actionFreeTextColumn = action.freeTextColumn;
            return {
                ...state,
                FreeTextColumns: state.FreeTextColumns.map((abObject)=>abObject.Uuid === actionFreeTextColumn.Uuid ? // in order to make working with aggrid easier, as the col getter
                    // references this object
                    Object.assign(abObject, actionFreeTextColumn) : abObject)
            };
        case $d8c519ae038bb984$export$603fcb8db0ec4ed0:
            {
                const actionFreeTextColumn = action.freeTextColumn;
                return {
                    ...state,
                    FreeTextColumns: state.FreeTextColumns.filter((abObject)=>abObject.Uuid !== actionFreeTextColumn.Uuid)
                };
            }
        case $d8c519ae038bb984$export$7d960b902e07f8d3:
            {
                const actionTypedAddEditStoredValue = action;
                actionTypedAddEditStoredValue.FreeTextColumn.FreeTextStoredValues = actionTypedAddEditStoredValue.FreeTextColumn.FreeTextStoredValues ?? [];
                let existingIndex = actionTypedAddEditStoredValue.FreeTextColumn.FreeTextStoredValues.findIndex((ftsv)=>ftsv.PrimaryKey == actionTypedAddEditStoredValue.FreeTextStoredValue.PrimaryKey);
                if (existingIndex != -1) actionTypedAddEditStoredValue.FreeTextColumn.FreeTextStoredValues[existingIndex] = actionTypedAddEditStoredValue.FreeTextStoredValue;
                else actionTypedAddEditStoredValue.FreeTextColumn.FreeTextStoredValues.push(actionTypedAddEditStoredValue.FreeTextStoredValue);
                const freeTextColumns = [
                    ...state.FreeTextColumns
                ];
                let index = freeTextColumns.findIndex((x)=>x.ColumnId == actionTypedAddEditStoredValue.FreeTextColumn.ColumnId);
                freeTextColumns[index] = actionTypedAddEditStoredValue.FreeTextColumn;
                return Object.assign({}, state, {
                    FreeTextColumns: freeTextColumns
                });
            }
        default:
            return state;
    }
};





const $2c155f3e4804e29e$export$66532664ad8a86d6 = 'LAYOUT_READY';
const $2c155f3e4804e29e$export$eaebc7baa579657b = 'LAYOUT_ADD';
const $2c155f3e4804e29e$export$5e441936c483de3b = 'LAYOUT_EDIT';
const $2c155f3e4804e29e$export$b98536b8d888c2d8 = 'LAYOUT_DELETE';
const $2c155f3e4804e29e$export$b79ae389bfecc801 = 'LAYOUT_SELECT';
const $2c155f3e4804e29e$export$8b6b33d09d8d1be4 = 'LAYOUT_SAVE';
const $2c155f3e4804e29e$export$dfb8d886fc62ddf9 = 'LAYOUT_COLUMN_FILTER_ADD';
const $2c155f3e4804e29e$export$e108c947785ca6ca = 'LAYOUT_COLUMN_FILTER_EDIT';
const $2c155f3e4804e29e$export$d13e0ad82ad445b3 = 'LAYOUT_COLUMN_FILTER_SET';
const $2c155f3e4804e29e$export$15be0f58f317384 = 'LAYOUT_COLUMN_FILTER_CLEAR_ALL';
const $2c155f3e4804e29e$export$c16e7bdd1b4bf32c = 'LAYOUT_COLUMN_FILTER_CLEAR';
const $2c155f3e4804e29e$export$56404215ee113fd = 'LAYOUT_COLUMN_FILTER_SUSPEND';
const $2c155f3e4804e29e$export$22f48e79a2003d4f = 'LAYOUT_COLUMN_FILTER_UNSUSPEND';
const $2c155f3e4804e29e$export$e9f77efbaf88a239 = 'LAYOUT_COLUMN_FILTER_SUSPEND_ALL';
const $2c155f3e4804e29e$export$82cd5ee5d79079a4 = 'LAYOUT_COLUMN_FILTER_UNSUSPEND_ALL';
const $2c155f3e4804e29e$export$1a594c99ac9663dc = 'LAYOUT_GRID_FILTER_SUSPEND';
const $2c155f3e4804e29e$export$41f931c7d92898d0 = 'LAYOUT_GRID_FILTER_UNSUSPEND';
const $2c155f3e4804e29e$export$6d89f5f562ded487 = 'LAYOUT_GRID_FILTER_SET';
const $2c155f3e4804e29e$export$35f3edf02b756295 = 'LAYOUT_GRID_FILTER_CLEAR';
const $2c155f3e4804e29e$export$89469bfff4112a24 = (columnFilter)=>({
        type: $2c155f3e4804e29e$export$dfb8d886fc62ddf9,
        columnFilter: columnFilter
    });
const $2c155f3e4804e29e$export$bbe8b429f447e815 = (columnFilter)=>({
        type: $2c155f3e4804e29e$export$e108c947785ca6ca,
        columnFilter: columnFilter
    });
const $2c155f3e4804e29e$export$da8b6ee930ff5718 = (columnFilter)=>({
        type: $2c155f3e4804e29e$export$d13e0ad82ad445b3,
        columnFilter: columnFilter
    });
const $2c155f3e4804e29e$export$d5958280d3901be2 = ()=>({
        type: $2c155f3e4804e29e$export$15be0f58f317384
    });
const $2c155f3e4804e29e$export$171768c99fee2ba3 = (columnId)=>({
        type: $2c155f3e4804e29e$export$c16e7bdd1b4bf32c,
        columnId: columnId
    });
const $2c155f3e4804e29e$export$6e8f0e06fbedf782 = (columnFilter)=>({
        type: $2c155f3e4804e29e$export$56404215ee113fd,
        columnFilter: columnFilter
    });
const $2c155f3e4804e29e$export$312f8e656419ed01 = (columnFilter)=>({
        type: $2c155f3e4804e29e$export$22f48e79a2003d4f,
        columnFilter: columnFilter
    });
const $2c155f3e4804e29e$export$23028bf9d635e89c = ()=>({
        type: $2c155f3e4804e29e$export$e9f77efbaf88a239
    });
const $2c155f3e4804e29e$export$3f36c0aabf72f1d2 = ()=>({
        type: $2c155f3e4804e29e$export$82cd5ee5d79079a4
    });
const $2c155f3e4804e29e$export$f079a5ac2c234fd = (gridFilter)=>({
        type: $2c155f3e4804e29e$export$6d89f5f562ded487,
        gridFilter: gridFilter
    });
const $2c155f3e4804e29e$export$4398634f52771b1c = ()=>({
        type: $2c155f3e4804e29e$export$1a594c99ac9663dc
    });
const $2c155f3e4804e29e$export$3024cdbf089cb117 = ()=>({
        type: $2c155f3e4804e29e$export$41f931c7d92898d0
    });
const $2c155f3e4804e29e$export$4ef493dc34f0b0bd = ()=>({
        type: $2c155f3e4804e29e$export$35f3edf02b756295
    });
const $2c155f3e4804e29e$export$b6d8346e3e2d65d1 = (layout)=>({
        type: $2c155f3e4804e29e$export$eaebc7baa579657b,
        layout: (0, $702a77ed6db22640$export$d859d72b10c9a984)(layout)
    });
const $2c155f3e4804e29e$export$16171190943cf4cb = (layout)=>({
        type: $2c155f3e4804e29e$export$b98536b8d888c2d8,
        layout: layout
    });
const $2c155f3e4804e29e$export$ca72012c06bdea95 = (layout)=>({
        type: $2c155f3e4804e29e$export$8b6b33d09d8d1be4,
        layout: (0, $702a77ed6db22640$export$d859d72b10c9a984)(layout)
    });
const $2c155f3e4804e29e$export$256743b3edbbec77 = (layoutName)=>({
        type: $2c155f3e4804e29e$export$b79ae389bfecc801,
        layoutName: layoutName
    });
const $2c155f3e4804e29e$export$bb817beb81db1018 = (layoutState)=>({
        type: $2c155f3e4804e29e$export$66532664ad8a86d6,
        layoutState: layoutState
    });
const $2c155f3e4804e29e$export$5decca837c0b76db = (state)=>{
    const currentLayout = $2c155f3e4804e29e$export$69cb9ed92a96b951(state);
    return currentLayout?.ColumnFilters ?? [];
};
const $2c155f3e4804e29e$export$69cb9ed92a96b951 = (state)=>{
    return state.Layout.Layouts?.find((layout)=>layout.Name === state.Layout.CurrentLayout);
};
const $2c155f3e4804e29e$export$4bb0672505871b15 = (state, columnId)=>{
    return {
        ...$2c155f3e4804e29e$export$5decca837c0b76db(state).find((cf)=>cf.ColumnId === columnId)
    };
};
const $2c155f3e4804e29e$var$initialState = {
    CurrentLayout: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
    Layouts: undefined
};
const $2c155f3e4804e29e$export$906c0f169aee7cf2 = (state = $2c155f3e4804e29e$var$initialState, action)=>{
    let layouts;
    const currentLayout = state.Layouts?.find((layout)=>layout.Name === state.CurrentLayout);
    switch(action.type){
        case $2c155f3e4804e29e$export$b79ae389bfecc801:
            {
                const newCurrentLayout = action.layoutName;
                if ((state.Layouts || []).find((l)=>l.Name === newCurrentLayout)) return Object.assign({}, state, {
                    CurrentLayout: newCurrentLayout
                });
                return state;
            }
        case $2c155f3e4804e29e$export$eaebc7baa579657b:
            {
                const actionLayout = action.layout;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionLayout);
                layouts = [].concat(state.Layouts || []);
                layouts.push(actionLayout);
                return {
                    ...state,
                    Layouts: layouts
                };
            }
        case $2c155f3e4804e29e$export$8b6b33d09d8d1be4:
            {
                const actionLayout = action.layout;
                let found = false;
                let Layouts = state.Layouts.map((abObject)=>{
                    if (found) // if already found, keep things as they were
                    return abObject;
                    found = abObject.Uuid === actionLayout.Uuid;
                    return found ? actionLayout : abObject;
                });
                if (!found) // let's try to find by name
                Layouts = state.Layouts.map((abObject)=>{
                    if (found) // if already found, keep things as they were
                    return abObject;
                    found = abObject.Name === actionLayout.Name;
                    return found ? actionLayout : abObject;
                });
                if (!found) Layouts = [
                    ...state.Layouts,
                    actionLayout
                ];
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$b98536b8d888c2d8:
            {
                const actionLayout = action.layout;
                const newLayouts = state.Layouts.filter((abObject)=>abObject.Uuid !== actionLayout.Uuid);
                return {
                    ...state,
                    CurrentLayout: state.CurrentLayout === actionLayout.Name ? newLayouts[0].Name : state.CurrentLayout,
                    Layouts: newLayouts
                };
            }
        case $2c155f3e4804e29e$export$d13e0ad82ad445b3:
            {
                let columnFilters = currentLayout.ColumnFilters ?? [];
                const columnFilterAction = action.columnFilter;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(columnFilterAction);
                columnFilters = columnFilters.filter((colFilter)=>{
                    return colFilter.ColumnId !== columnFilterAction.ColumnId;
                }).concat(columnFilterAction).map((cf)=>({
                        ...cf
                    }));
                const Layouts = state.Layouts.map((layout)=>{
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        ColumnFilters: columnFilters
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$dfb8d886fc62ddf9:
            {
                const columnFilterAction = action.columnFilter;
                let columnFilters = (currentLayout.ColumnFilters ?? []).filter(// make sure we are not adding a filter that already exists
                (cf)=>cf.ColumnId !== columnFilterAction.ColumnId);
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(columnFilterAction);
                columnFilters.push(columnFilterAction);
                const Layouts = state.Layouts.map((layout)=>{
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        ColumnFilters: columnFilters
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$e108c947785ca6ca:
            {
                const columnFilterAction = action.columnFilter;
                // it is safer to change the col id, we cannot have multiple filter on the same id
                // first we filter out other filters with the same colId, to ensure we have only one
                const cleanColumnFilters = (currentLayout.ColumnFilters ?? []).filter((cf)=>cf.ColumnId !== columnFilterAction.ColumnId);
                cleanColumnFilters.push(columnFilterAction);
                const Layouts = state.Layouts.map((layout)=>{
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        ColumnFilters: cleanColumnFilters
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$15be0f58f317384:
            {
                const Layouts = state.Layouts.map((layout)=>{
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        ColumnFilters: []
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$c16e7bdd1b4bf32c:
            {
                const actionTypedDelete = action;
                const columnFilters = (currentLayout.ColumnFilters ?? []).filter((cf)=>{
                    // make sure we are deleting all filters on the same column
                    return cf.ColumnId !== actionTypedDelete.columnId;
                });
                const Layouts = state.Layouts.map((layout)=>{
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        ColumnFilters: columnFilters
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$56404215ee113fd:
            {
                const actionTypedSuspend = action;
                const columnFilters = (currentLayout.ColumnFilters ?? []).map((abObject)=>abObject.Uuid === actionTypedSuspend.columnFilter.Uuid ? {
                        ...abObject,
                        IsSuspended: true
                    } : abObject);
                const Layouts = state.Layouts.map((layout)=>{
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        ColumnFilters: columnFilters
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$22f48e79a2003d4f:
            {
                const actionTypedSuspend = action;
                const columnFilters = (currentLayout.ColumnFilters ?? []).map((abObject)=>abObject.Uuid === actionTypedSuspend.columnFilter.Uuid ? {
                        ...abObject,
                        IsSuspended: false
                    } : abObject);
                const Layouts = state.Layouts.map((layout)=>{
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        ColumnFilters: columnFilters
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$e9f77efbaf88a239:
            {
                const columnFilters = (currentLayout.ColumnFilters ?? []).map((abObject)=>({
                        ...abObject,
                        IsSuspended: true
                    }));
                const Layouts = state.Layouts.map((layout)=>{
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        ColumnFilters: columnFilters
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$82cd5ee5d79079a4:
            {
                const columnFilters = (currentLayout.ColumnFilters ?? []).map((abObject)=>({
                        ...abObject,
                        IsSuspended: false
                    }));
                const Layouts = state.Layouts.map((layout)=>{
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        ColumnFilters: columnFilters
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$6d89f5f562ded487:
            {
                const actionTyped = action;
                return {
                    ...state,
                    Layouts: state.Layouts.map((layout)=>{
                        if (layout.Name === currentLayout.Name) return {
                            ...layout,
                            GridFilter: {
                                ...layout.GridFilter,
                                Expression: actionTyped.gridFilter
                            }
                        };
                        return layout;
                    })
                };
            }
        case $2c155f3e4804e29e$export$1a594c99ac9663dc:
            {
                const Layouts = state.Layouts.map((layout)=>{
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        GridFilter: {
                            ...layout.GridFilter,
                            IsSuspended: true
                        }
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$41f931c7d92898d0:
            {
                const Layouts = state.Layouts.map((layout)=>{
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        GridFilter: {
                            ...layout.GridFilter,
                            IsSuspended: false
                        }
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        case $2c155f3e4804e29e$export$35f3edf02b756295:
            {
                const Layouts = state.Layouts.map((layout)=>{
                    let gridFilter = currentLayout.GridFilter;
                    if (gridFilter) {
                        gridFilter.IsSuspended = false;
                        gridFilter.Expression = '';
                    }
                    if (layout.Name === currentLayout.Name) return {
                        ...layout,
                        gridFilter: gridFilter
                    };
                    return layout;
                });
                return {
                    ...state,
                    Layouts: Layouts
                };
            }
        default:
            return state;
    }
};




const $f53463061a55e5a9$export$75a4614523e40adb = 'NAMED_QUERY_READY';
const $f53463061a55e5a9$export$c2d4161a42c63a68 = 'NAMED_QUERY_ADD';
const $f53463061a55e5a9$export$92e874b4481b7886 = 'NAMED_QUERY_ADD_MULTIPLE';
const $f53463061a55e5a9$export$853430cba22da616 = 'NAMED_QUERY_EDIT';
const $f53463061a55e5a9$export$6018d1ce8f014591 = 'NAMED_QUERY_DELETE';
const $f53463061a55e5a9$export$35d9816f002a20ec = (namedQuery)=>({
        type: $f53463061a55e5a9$export$c2d4161a42c63a68,
        namedQuery: namedQuery
    });
const $f53463061a55e5a9$export$346cb5b1d18b1d0b = (namedQueries)=>({
        type: $f53463061a55e5a9$export$92e874b4481b7886,
        namedQueries: namedQueries
    });
const $f53463061a55e5a9$export$f5c14b4ee8c8e36c = (namedQuery)=>({
        type: $f53463061a55e5a9$export$853430cba22da616,
        namedQuery: namedQuery
    });
const $f53463061a55e5a9$export$7c08b0322e8d8cbb = (namedQuery)=>({
        type: $f53463061a55e5a9$export$6018d1ce8f014591,
        namedQuery: namedQuery
    });
const $f53463061a55e5a9$export$af02f94bd3114145 = (namedQueryState)=>({
        type: $f53463061a55e5a9$export$75a4614523e40adb,
        namedQueryState: namedQueryState
    });
const $f53463061a55e5a9$var$initialState = {
    NamedQueries: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $f53463061a55e5a9$export$75b16504f320dd62 = (state = $f53463061a55e5a9$var$initialState, action)=>{
    let namedQuerys;
    switch(action.type){
        case $f53463061a55e5a9$export$c2d4161a42c63a68:
            {
                const actionnamedQuery = action.namedQuery;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionnamedQuery);
                namedQuerys = [].concat(state.NamedQueries);
                namedQuerys.push(actionnamedQuery);
                return {
                    ...state,
                    NamedQueries: namedQuerys
                };
            }
        case $f53463061a55e5a9$export$92e874b4481b7886:
            {
                const actionnamedQueries = action.namedQueries;
                actionnamedQueries.forEach((namedQuery)=>{
                    (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(namedQuery);
                });
                return {
                    ...state,
                    NamedQueries: [
                        ...state.NamedQueries,
                        ...actionnamedQueries
                    ]
                };
            }
        case $f53463061a55e5a9$export$853430cba22da616:
            {
                const actionnamedQuery = action.namedQuery;
                return {
                    ...state,
                    NamedQueries: state.NamedQueries.map((abObject)=>abObject.Uuid === actionnamedQuery.Uuid ? actionnamedQuery : abObject)
                };
            }
        case $f53463061a55e5a9$export$6018d1ce8f014591:
            {
                const actionnamedQuery = action.namedQuery;
                return {
                    ...state,
                    NamedQueries: state.NamedQueries.filter((abObject)=>abObject.Uuid !== actionnamedQuery.Uuid)
                };
            }
        default:
            return state;
    }
};




const $b5b505fd5df04a9f$export$4a0a36c128089fe8 = 'NOTE_ADD';
const $b5b505fd5df04a9f$export$b862825b416d0d44 = 'NOTE_EDIT';
const $b5b505fd5df04a9f$export$1b58e272863850a1 = 'NOTE_DELETE';
const $b5b505fd5df04a9f$export$2c141bcf1c7213f9 = 'NOTE_READY';
const $b5b505fd5df04a9f$export$612fca4781b41952 = (note)=>({
        type: $b5b505fd5df04a9f$export$4a0a36c128089fe8,
        adaptableNote: note
    });
const $b5b505fd5df04a9f$export$4ea42cdbfb14947f = (note)=>({
        type: $b5b505fd5df04a9f$export$b862825b416d0d44,
        adaptableNote: note
    });
const $b5b505fd5df04a9f$export$178f4e1b750a5517 = (note)=>({
        type: $b5b505fd5df04a9f$export$1b58e272863850a1,
        adaptableNote: note
    });
const $b5b505fd5df04a9f$export$29bf01dc68be84eb = (note)=>({
        type: $b5b505fd5df04a9f$export$2c141bcf1c7213f9,
        noteState: note
    });
const $b5b505fd5df04a9f$export$c20626bfec5066b7 = (state)=>state.Notes;
const $b5b505fd5df04a9f$export$382cdf5ac6d0bf8b = (state, address)=>{
    if (!address) return null;
    return (state?.Notes ?? []).find((note)=>{
        if (note.PrimaryKeyValue === address.PrimaryKeyValue && note.ColumnId === address.ColumnId) // happy check
        return true;
        // Primary keys retrieved from the grid dom are always strings, so we must also consider them strings
        if (typeof address.PrimaryKeyValue === 'number' && typeof note.PrimaryKeyValue === 'string' || typeof address.PrimaryKeyValue === 'string' && typeof note.PrimaryKeyValue === 'number') return note.PrimaryKeyValue.toString() === address.PrimaryKeyValue.toString() && note.ColumnId === address.ColumnId;
        return false;
    });
};
const $b5b505fd5df04a9f$var$initialState = {
    Notes: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $b5b505fd5df04a9f$export$409127b9f52346c3 = (state = $b5b505fd5df04a9f$var$initialState, action)=>{
    let adaptableNotes;
    switch(action.type){
        case $b5b505fd5df04a9f$export$4a0a36c128089fe8:
            {
                const note = action.adaptableNote;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(note);
                adaptableNotes = [
                    ...state.Notes,
                    note
                ];
                return {
                    ...state,
                    Notes: adaptableNotes
                };
            }
        case $b5b505fd5df04a9f$export$b862825b416d0d44:
            {
                const note = action.adaptableNote;
                return {
                    ...state,
                    Notes: state.Notes.map((abObject)=>abObject.Uuid === note.Uuid ? note : abObject)
                };
            }
        case $b5b505fd5df04a9f$export$1b58e272863850a1:
            {
                const note = action.adaptableNote;
                return {
                    ...state,
                    Notes: state.Notes.filter((abObject)=>abObject.Uuid !== note.Uuid)
                };
            }
        default:
            return state;
    }
};





const $36058826e464bb44$export$7420c34c9c4ca99e = 'PLUS_MINUS_APPLY';
const $36058826e464bb44$export$c1e4f5fe837266a2 = 'PLUS_MINUS_RULE_ADD';
const $36058826e464bb44$export$df34a40a1e726215 = 'PLUS_MINUS_RULE_EDIT';
const $36058826e464bb44$export$4b9a17f0f1755c3f = 'PLUS_MINUS_RULE_DELETE';
const $36058826e464bb44$export$f1f31d406b437abd = 'PLUS_MINUS_RULE_SUSPEND';
const $36058826e464bb44$export$32df8d6f4232d9fd = 'PLUS_MINUS_RULE_UNSUSPEND';
const $36058826e464bb44$export$4a420fc50d95d394 = 'PLUS_MINUS_RULE_SUSPEND_ALL';
const $36058826e464bb44$export$1a129a0360012780 = 'PLUS_MINUS_RULE_UNSUSPEND_ALL';
const $36058826e464bb44$export$dea73e39e87f2dc8 = 'PLUS_MINUS_RULE_MOVE_UP';
const $36058826e464bb44$export$1c824caacb8ebdb5 = 'PLUS_MINUS_RULE_MOVE_DOWN';
const $36058826e464bb44$export$97b42381e376fced = 'PLUS_MINUS_READY';
const $36058826e464bb44$export$cd91cbe99074b1f9 = (cellUpdateRequests)=>({
        type: $36058826e464bb44$export$7420c34c9c4ca99e,
        cellUpdateRequests: cellUpdateRequests
    });
const $36058826e464bb44$export$b57847b7da91dcb4 = (plusMinusNudge)=>({
        type: $36058826e464bb44$export$c1e4f5fe837266a2,
        plusMinusNudge: plusMinusNudge
    });
const $36058826e464bb44$export$15d09d450ef43f85 = (plusMinusNudge)=>({
        type: $36058826e464bb44$export$df34a40a1e726215,
        plusMinusNudge: plusMinusNudge
    });
const $36058826e464bb44$export$94d9a67dbae3ab19 = (plusMinusNudge)=>({
        type: $36058826e464bb44$export$4b9a17f0f1755c3f,
        plusMinusNudge: plusMinusNudge
    });
const $36058826e464bb44$export$4147f49703def3fa = (plusMinusNudge)=>({
        type: $36058826e464bb44$export$f1f31d406b437abd,
        plusMinusNudge: plusMinusNudge
    });
const $36058826e464bb44$export$e1c560b2519d0821 = (plusMinusNudge)=>({
        type: $36058826e464bb44$export$32df8d6f4232d9fd,
        plusMinusNudge: plusMinusNudge
    });
const $36058826e464bb44$export$c11ea8af075e1ee0 = ()=>({
        type: $36058826e464bb44$export$4a420fc50d95d394
    });
const $36058826e464bb44$export$d6bc9564f73af63e = ()=>({
        type: $36058826e464bb44$export$1a129a0360012780
    });
const $36058826e464bb44$export$bc10974e56e9f8bb = (plusMinusNudge)=>({
        type: $36058826e464bb44$export$dea73e39e87f2dc8,
        plusMinusNudge: plusMinusNudge
    });
const $36058826e464bb44$export$a06e4608b4d07139 = (plusMinusNudge)=>({
        type: $36058826e464bb44$export$1c824caacb8ebdb5,
        plusMinusNudge: plusMinusNudge
    });
const $36058826e464bb44$export$409f62f938d0204d = (plusMinusState)=>({
        type: $36058826e464bb44$export$97b42381e376fced,
        plusMinusState: plusMinusState
    });
const $36058826e464bb44$var$initialState = {
    PlusMinusNudges: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $36058826e464bb44$export$7c558d2947cd4ff1 = (state = $36058826e464bb44$var$initialState, action)=>{
    let plusMinusNudges;
    switch(action.type){
        case $36058826e464bb44$export$7420c34c9c4ca99e:
            //we apply logic in the middleware since it's an Api call
            return Object.assign({}, state);
        case $36058826e464bb44$export$c1e4f5fe837266a2:
            {
                const actionPlusMinusNudge = action.plusMinusNudge;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionPlusMinusNudge);
                plusMinusNudges = [].concat(state.PlusMinusNudges);
                plusMinusNudges.push(actionPlusMinusNudge);
                return {
                    ...state,
                    PlusMinusNudges: plusMinusNudges
                };
            }
        case $36058826e464bb44$export$df34a40a1e726215:
            {
                const actionPlusMinusNudge = action.plusMinusNudge;
                return {
                    ...state,
                    PlusMinusNudges: state.PlusMinusNudges.map((abObject)=>abObject.Uuid === actionPlusMinusNudge.Uuid ? actionPlusMinusNudge : abObject)
                };
            }
        case $36058826e464bb44$export$4b9a17f0f1755c3f:
            {
                const actionPlusMinusNudge = action.plusMinusNudge;
                return {
                    ...state,
                    PlusMinusNudges: state.PlusMinusNudges.filter((abObject)=>abObject.Uuid !== actionPlusMinusNudge.Uuid)
                };
            }
        case $36058826e464bb44$export$4a420fc50d95d394:
            return {
                ...state,
                PlusMinusNudges: (0, $471c8159162519ad$export$d5749a3ee2d57eaa)(state.PlusMinusNudges)
            };
        case $36058826e464bb44$export$1a129a0360012780:
            return {
                ...state,
                PlusMinusNudges: (0, $471c8159162519ad$export$94c949ae997a6e37)(state.PlusMinusNudges)
            };
        case $36058826e464bb44$export$f1f31d406b437abd:
            return {
                ...state,
                PlusMinusNudges: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.plusMinusNudge, state.PlusMinusNudges, true)
            };
        case $36058826e464bb44$export$32df8d6f4232d9fd:
            return {
                ...state,
                PlusMinusNudges: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.plusMinusNudge, state.PlusMinusNudges, false)
            };
        case $36058826e464bb44$export$dea73e39e87f2dc8:
            {
                const actionPlusMinusNudge = action.plusMinusNudge;
                const plusMinusNudges = [
                    ...state.PlusMinusNudges ?? []
                ];
                const index = plusMinusNudges.findIndex((plusMinus)=>plusMinus.Uuid === actionPlusMinusNudge.Uuid);
                let swapIndex = index - 1;
                if (swapIndex < 0) swapIndex = plusMinusNudges.length - 1;
                const temp = plusMinusNudges[index];
                plusMinusNudges[index] = plusMinusNudges[swapIndex];
                plusMinusNudges[swapIndex] = temp;
                return {
                    ...state,
                    PlusMinusNudges: plusMinusNudges
                };
            }
        case $36058826e464bb44$export$1c824caacb8ebdb5:
            {
                const actionPlusMinusNudge = action.plusMinusNudge;
                const plusMinusNudges = [
                    ...state.PlusMinusNudges ?? []
                ];
                const index = plusMinusNudges.findIndex((plusMinus)=>plusMinus.Uuid === actionPlusMinusNudge.Uuid);
                let swapIndex = index + 1;
                if (swapIndex >= plusMinusNudges.length) swapIndex = 0;
                const temp = plusMinusNudges[index];
                plusMinusNudges[index] = plusMinusNudges[swapIndex];
                plusMinusNudges[swapIndex] = temp;
                return {
                    ...state,
                    PlusMinusNudges: plusMinusNudges
                };
            }
        default:
            return state;
    }
};




const $a9684a89f07662ba$export$b30fee7900c0f46f = {
    BackColor: (0, $72a4ef37247198d5$export$28cc436f02e4b048),
    ForeColor: (0, $72a4ef37247198d5$export$761a302010a0d836)
};
const $a9684a89f07662ba$export$5e9fd90a3792a3ea = 'QUICK_SEARCH_RUN';
const $a9684a89f07662ba$export$ea2c3562caec3a19 = 'QUICK_SEARCH_SET_CELL_MATCHING_STYLE';
const $a9684a89f07662ba$export$c56d21586e2dd1fe = 'QUICK_SEARCH_READY';
const $a9684a89f07662ba$export$e6464f631b683a94 = (quickSearchText)=>({
        type: $a9684a89f07662ba$export$5e9fd90a3792a3ea,
        quickSearchText: quickSearchText
    });
const $a9684a89f07662ba$export$fe53e034aaf6474a = (matchingCellStyle)=>({
        type: $a9684a89f07662ba$export$ea2c3562caec3a19,
        matchingCellStyle: matchingCellStyle
    });
const $a9684a89f07662ba$export$cb1c4cb43e5ff97a = (quickSearchState)=>({
        type: $a9684a89f07662ba$export$c56d21586e2dd1fe,
        quickSearchState: quickSearchState
    });
const $a9684a89f07662ba$var$initialState = {
    QuickSearchText: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1)
};
const $a9684a89f07662ba$export$4c3a8d9573d2240d = (state = $a9684a89f07662ba$var$initialState, action)=>{
    switch(action.type){
        case $a9684a89f07662ba$export$5e9fd90a3792a3ea:
            return Object.assign({}, state, {
                QuickSearchText: action.quickSearchText
            });
        case $a9684a89f07662ba$export$ea2c3562caec3a19:
            return Object.assign({}, state, {
                CellMatchStyle: action.matchingCellStyle
            });
        default:
            return state;
    }
};





const $bb63955874685545$export$9343eb756946666 = 'SCHEDULE_JOB_RUN';
const $bb63955874685545$export$8bd0a398d5e878c6 = 'REPORT_SCHEDULE_ADD';
const $bb63955874685545$export$cedfc702b2b90673 = 'REPORT_SCHEDULE_EDIT';
const $bb63955874685545$export$55fb49a34a3c4862 = 'REPORT_SCHEDULE_DELETE';
const $bb63955874685545$export$b9d37aaf64695063 = 'REPORT_SCHEDULE_SUSPEND';
const $bb63955874685545$export$5ddb7796cf3b52e6 = 'REPORT_SCHEDULE_UNSUSPEND';
const $bb63955874685545$export$f66a8cfe589bcb8a = 'REPORT_SCHEDULE_SUSPEND_ALL';
const $bb63955874685545$export$e276a5bef9096eed = 'REPORT_SCHEDULE_UNSUSPEND_ALL';
const $bb63955874685545$export$a980b87cdc361a36 = 'REMINDER_SCHEDULE_ADD';
const $bb63955874685545$export$58ec0bcbb480e612 = 'REMINDER_SCHEDULE_EDIT';
const $bb63955874685545$export$9f8cb78a84ec6925 = 'REMINDER_SCHEDULE_DELETE';
const $bb63955874685545$export$e187dcdde0648fea = 'REMINDER_SCHEDULE_SUSPEND';
const $bb63955874685545$export$d075fdaa06f36e3e = 'REMINDER_SCHEDULE_UNSUSPEND';
const $bb63955874685545$export$9399faf55c25dc64 = 'REMINDER_SCHEDULE_SUSPEND_ALL';
const $bb63955874685545$export$37895167f4d76838 = 'REMINDER_SCHEDULE_UNSUSPEND_ALL';
const $bb63955874685545$export$9cb6d77cb46f5866 = 'IPUSHPULL_SCHEDULE_ADD';
const $bb63955874685545$export$ad6f7fa11aa8a043 = 'IPUSHPULL_SCHEDULE_EDIT';
const $bb63955874685545$export$88c72e1edb5c2c37 = 'IPUSHPULL_SCHEDULE_DELETE';
const $bb63955874685545$export$aa7c1aee79a11c79 = 'IPUSHPULL_SCHEDULE_SUSPEND';
const $bb63955874685545$export$8cd7da7e18e1bec0 = 'IPUSHPULL_SCHEDULE_UNSUSPEND';
const $bb63955874685545$export$727470f46742b8b5 = 'IPUSHPULL_SCHEDULE_SUSPEND_ALL';
const $bb63955874685545$export$4a72c25357c0c6ac = 'IPUSHPULL_SCHEDULE_UNSUSPEND_ALL';
const $bb63955874685545$export$40cafac348921468 = 'OPENFIN_SCHEDULE_ADD';
const $bb63955874685545$export$856d9acd1b677c23 = 'OPENFIN_SCHEDULE_EDIT';
const $bb63955874685545$export$49a64f24543973d5 = 'OPENFIN_SCHEDULE_DELETE';
const $bb63955874685545$export$207e1b978297ce75 = 'OPENFIN_SCHEDULE_SUSPEND';
const $bb63955874685545$export$79548e540f38e53a = 'OPENFIN_SCHEDULE_UNSUSPEND';
const $bb63955874685545$export$37296639673c1ddd = 'OPENFIN_SCHEDULE_SUSPEND_ALL';
const $bb63955874685545$export$99df0de0feae3a9c = 'OPENFIN_SCHEDULE_UNSUSPEND_ALL';
const $bb63955874685545$export$4f7dcd18288c6767 = 'SCHEDULE_READY';
const $bb63955874685545$export$6e995036a96cd71c = (schedule, scheduleType)=>({
        type: $bb63955874685545$export$9343eb756946666,
        schedule: schedule,
        scheduleType: scheduleType
    });
const $bb63955874685545$export$e3ac9aaf65fb0b29 = (scheduleState)=>({
        type: $bb63955874685545$export$4f7dcd18288c6767,
        scheduleState: scheduleState
    });
const $bb63955874685545$export$b9fca2b9f0a6f24c = (openFinSchedule)=>({
        type: $bb63955874685545$export$40cafac348921468,
        openFinSchedule: openFinSchedule
    });
const $bb63955874685545$export$9c48a79fad9fd033 = (openFinSchedule)=>({
        type: $bb63955874685545$export$856d9acd1b677c23,
        openFinSchedule: openFinSchedule
    });
const $bb63955874685545$export$7b14e381193389a3 = (openFinSchedule)=>({
        type: $bb63955874685545$export$49a64f24543973d5,
        openFinSchedule: openFinSchedule
    });
const $bb63955874685545$export$d605754f43ab43ce = (openFinSchedule)=>({
        type: $bb63955874685545$export$207e1b978297ce75,
        openFinSchedule: openFinSchedule
    });
const $bb63955874685545$export$751f7472244e1a50 = (openFinSchedule)=>({
        type: $bb63955874685545$export$79548e540f38e53a,
        openFinSchedule: openFinSchedule
    });
const $bb63955874685545$export$141a2ecad8804432 = ()=>({
        type: $bb63955874685545$export$37296639673c1ddd
    });
const $bb63955874685545$export$bbde1d88e04e11bf = ()=>({
        type: $bb63955874685545$export$99df0de0feae3a9c
    });
const $bb63955874685545$export$4a744ac1b34f8f67 = (reportSchedule)=>({
        type: $bb63955874685545$export$8bd0a398d5e878c6,
        reportSchedule: reportSchedule
    });
const $bb63955874685545$export$c7092aaffe90ec2f = (reportSchedule)=>({
        type: $bb63955874685545$export$cedfc702b2b90673,
        reportSchedule: reportSchedule
    });
const $bb63955874685545$export$a295a95489a73dd = (reportSchedule)=>({
        type: $bb63955874685545$export$55fb49a34a3c4862,
        reportSchedule: reportSchedule
    });
const $bb63955874685545$export$d7ee5ae4dc83275e = (reportSchedule)=>({
        type: $bb63955874685545$export$b9d37aaf64695063,
        reportSchedule: reportSchedule
    });
const $bb63955874685545$export$62ab8e50b7e8ae89 = (reportSchedule)=>({
        type: $bb63955874685545$export$5ddb7796cf3b52e6,
        reportSchedule: reportSchedule
    });
const $bb63955874685545$export$3e7c54eaf1b9a22d = ()=>({
        type: $bb63955874685545$export$b9d37aaf64695063
    });
const $bb63955874685545$export$741521deda7f992e = ()=>({
        type: $bb63955874685545$export$5ddb7796cf3b52e6
    });
const $bb63955874685545$export$70bc39e24de4957e = (reminderSchedule)=>({
        type: $bb63955874685545$export$a980b87cdc361a36,
        reminderSchedule: reminderSchedule
    });
const $bb63955874685545$export$a013643dfd3ba9a6 = (reminderSchedule)=>({
        type: $bb63955874685545$export$58ec0bcbb480e612,
        reminderSchedule: reminderSchedule
    });
const $bb63955874685545$export$6039870450c4d55f = (reminderSchedule)=>({
        type: $bb63955874685545$export$9f8cb78a84ec6925,
        reminderSchedule: reminderSchedule
    });
const $bb63955874685545$export$8f8b9ba2ded34223 = (reminderSchedule)=>({
        type: $bb63955874685545$export$e187dcdde0648fea,
        reminderSchedule: reminderSchedule
    });
const $bb63955874685545$export$86f0f6bc1579d292 = (reminderSchedule)=>({
        type: $bb63955874685545$export$d075fdaa06f36e3e,
        reminderSchedule: reminderSchedule
    });
const $bb63955874685545$export$7282f5d93aaf6264 = ()=>({
        type: $bb63955874685545$export$9399faf55c25dc64
    });
const $bb63955874685545$export$aa880e328d2b6c1f = ()=>({
        type: $bb63955874685545$export$37895167f4d76838
    });
const $bb63955874685545$export$e222f78188cd2696 = (iPushPullSchedule)=>({
        type: $bb63955874685545$export$9cb6d77cb46f5866,
        iPushPullSchedule: iPushPullSchedule
    });
const $bb63955874685545$export$24a7aedf87930eef = (iPushPullSchedule)=>({
        type: $bb63955874685545$export$ad6f7fa11aa8a043,
        iPushPullSchedule: iPushPullSchedule
    });
const $bb63955874685545$export$3b36c3ae2efe31cb = (iPushPullSchedule)=>({
        type: $bb63955874685545$export$88c72e1edb5c2c37,
        iPushPullSchedule: iPushPullSchedule
    });
const $bb63955874685545$export$ea59ca87e7d93968 = (iPushPullSchedule)=>({
        type: $bb63955874685545$export$aa7c1aee79a11c79,
        iPushPullSchedule: iPushPullSchedule
    });
const $bb63955874685545$export$e680ef46686b2048 = (iPushPullSchedule)=>({
        type: $bb63955874685545$export$8cd7da7e18e1bec0,
        iPushPullSchedule: iPushPullSchedule
    });
const $bb63955874685545$export$a9fc7027c6851604 = ()=>({
        type: $bb63955874685545$export$aa7c1aee79a11c79
    });
const $bb63955874685545$export$378b02603bbd0643 = ()=>({
        type: $bb63955874685545$export$8cd7da7e18e1bec0
    });
const $bb63955874685545$var$initialState = {
    ReportSchedules: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    Reminders: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    IPushPullSchedules: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    OpenFinSchedules: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $bb63955874685545$export$a11069dc6c4000eb = (state = $bb63955874685545$var$initialState, action)=>{
    switch(action.type){
        case $bb63955874685545$export$40cafac348921468:
            {
                const actionSchedule = action.openFinSchedule;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionSchedule);
                const OpenFinSchedules = [].concat(state.OpenFinSchedules);
                OpenFinSchedules.push(actionSchedule);
                return {
                    ...state,
                    OpenFinSchedules: OpenFinSchedules
                };
            }
        case $bb63955874685545$export$856d9acd1b677c23:
            {
                const actionSchedule = action.openFinSchedule;
                return {
                    ...state,
                    OpenFinSchedules: state.OpenFinSchedules.map((abObject)=>abObject.Uuid === actionSchedule.Uuid ? actionSchedule : abObject)
                };
            }
        case $bb63955874685545$export$49a64f24543973d5:
            {
                const actionSchedule = action.openFinSchedule;
                return {
                    ...state,
                    OpenFinSchedules: state.OpenFinSchedules.filter((abObject)=>abObject.Uuid !== actionSchedule.Uuid)
                };
            }
        case $bb63955874685545$export$207e1b978297ce75:
            return {
                ...state,
                OpenFinSchedules: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.openFinSchedule, state.OpenFinSchedules, true)
            };
        case $bb63955874685545$export$79548e540f38e53a:
            return {
                ...state,
                OpenFinSchedules: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.openFinSchedule, state.OpenFinSchedules, false)
            };
        case $bb63955874685545$export$37296639673c1ddd:
            return {
                ...state,
                OpenFinSchedules: (0, $471c8159162519ad$export$d5749a3ee2d57eaa)(state.OpenFinSchedules)
            };
        case $bb63955874685545$export$99df0de0feae3a9c:
            return {
                ...state,
                OpenFinSchedules: (0, $471c8159162519ad$export$94c949ae997a6e37)(state.OpenFinSchedules)
            };
        case $bb63955874685545$export$8bd0a398d5e878c6:
            {
                const actionSchedule = action.reportSchedule;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionSchedule);
                const reportSchedules = [].concat(state.ReportSchedules);
                reportSchedules.push(actionSchedule);
                return {
                    ...state,
                    ReportSchedules: reportSchedules
                };
            }
        case $bb63955874685545$export$cedfc702b2b90673:
            {
                const actionSchedule = action.reportSchedule;
                return {
                    ...state,
                    ReportSchedules: state.ReportSchedules.map((abObject)=>abObject.Uuid === actionSchedule.Uuid ? actionSchedule : abObject)
                };
            }
        case $bb63955874685545$export$55fb49a34a3c4862:
            {
                const actionSchedule = action.reportSchedule;
                return {
                    ...state,
                    ReportSchedules: state.ReportSchedules.filter((abObject)=>abObject.Uuid !== actionSchedule.Uuid)
                };
            }
        case $bb63955874685545$export$b9d37aaf64695063:
            return {
                ...state,
                ReportSchedules: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.reportSchedule, state.ReportSchedules, true)
            };
        case $bb63955874685545$export$5ddb7796cf3b52e6:
            return {
                ...state,
                ReportSchedules: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.reportSchedule, state.ReportSchedules, false)
            };
        case $bb63955874685545$export$f66a8cfe589bcb8a:
            return {
                ...state,
                ReportSchedules: (0, $471c8159162519ad$export$d5749a3ee2d57eaa)(state.ReportSchedules)
            };
        case $bb63955874685545$export$e276a5bef9096eed:
            return {
                ...state,
                ReportSchedules: (0, $471c8159162519ad$export$94c949ae997a6e37)(state.ReportSchedules)
            };
        case $bb63955874685545$export$a980b87cdc361a36:
            {
                const actionSchedule = action.reminderSchedule;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionSchedule);
                const reminderSchedules = [].concat(state.Reminders);
                reminderSchedules.push(actionSchedule);
                return {
                    ...state,
                    Reminders: reminderSchedules
                };
            }
        case $bb63955874685545$export$58ec0bcbb480e612:
            {
                const actionSchedule = action.reminderSchedule;
                return {
                    ...state,
                    Reminders: state.Reminders.map((abObject)=>abObject.Uuid === actionSchedule.Uuid ? actionSchedule : abObject)
                };
            }
        case $bb63955874685545$export$9f8cb78a84ec6925:
            {
                const actionSchedule = action.reminderSchedule;
                return {
                    ...state,
                    Reminders: state.Reminders.filter((abObject)=>abObject.Uuid !== actionSchedule.Uuid)
                };
            }
        case $bb63955874685545$export$e187dcdde0648fea:
            return {
                ...state,
                Reminders: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.reminderSchedule, state.Reminders, true)
            };
        case $bb63955874685545$export$d075fdaa06f36e3e:
            return {
                ...state,
                Reminders: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.reminderSchedule, state.Reminders, false)
            };
        case $bb63955874685545$export$9399faf55c25dc64:
            return {
                ...state,
                Reminders: (0, $471c8159162519ad$export$d5749a3ee2d57eaa)(state.Reminders)
            };
        case $bb63955874685545$export$37895167f4d76838:
            return {
                ...state,
                Reminders: (0, $471c8159162519ad$export$94c949ae997a6e37)(state.Reminders)
            };
        case $bb63955874685545$export$9cb6d77cb46f5866:
            {
                const actionSchedule = action.iPushPullSchedule;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionSchedule);
                const iPushPullSchedules = state.IPushPullSchedules ? [
                    ...state.IPushPullSchedules
                ] : [];
                iPushPullSchedules.push(actionSchedule);
                return {
                    ...state,
                    IPushPullSchedules: iPushPullSchedules
                };
            }
        case $bb63955874685545$export$ad6f7fa11aa8a043:
            {
                const actionSchedule = action.iPushPullSchedule;
                return {
                    ...state,
                    IPushPullSchedules: (state.IPushPullSchedules || []).map((abObject)=>abObject.Uuid === actionSchedule.Uuid ? actionSchedule : abObject)
                };
            }
        case $bb63955874685545$export$88c72e1edb5c2c37:
            {
                const actionSchedule = action.iPushPullSchedule;
                return {
                    ...state,
                    IPushPullSchedules: (state.IPushPullSchedules || []).filter((abObject)=>abObject.Uuid !== actionSchedule.Uuid)
                };
            }
        case $bb63955874685545$export$aa7c1aee79a11c79:
            return {
                ...state,
                IPushPullSchedules: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.iPushPullSchedule, state.IPushPullSchedules, true)
            };
        case $bb63955874685545$export$8cd7da7e18e1bec0:
            return {
                ...state,
                IPushPullSchedules: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.iPushPullSchedule, state.IPushPullSchedules, false)
            };
        case $bb63955874685545$export$727470f46742b8b5:
            return {
                ...state,
                IPushPullSchedules: (0, $471c8159162519ad$export$d5749a3ee2d57eaa)(state.IPushPullSchedules)
            };
        case $bb63955874685545$export$4a72c25357c0c6ac:
            return {
                ...state,
                IPushPullSchedules: (0, $471c8159162519ad$export$94c949ae997a6e37)(state.IPushPullSchedules)
            };
        default:
            return state;
    }
};





const $2172826b4c3056a0$export$1c63173ca595450a = 'SHORTCUT_ADD';
const $2172826b4c3056a0$export$c4475d8e75afef42 = 'SHORTCUT_EDIT';
const $2172826b4c3056a0$export$e2722a7b3014afd = 'SHORTCUT_DELETE';
const $2172826b4c3056a0$export$4e83263cb3e9f57a = 'SHORTCUT_SUSPEND';
const $2172826b4c3056a0$export$6cec1982edce8d1c = 'SHORTCUT_UNSUSPEND';
const $2172826b4c3056a0$export$523a43274979a4a4 = 'SHORTCUT_SUSPEND_ALL';
const $2172826b4c3056a0$export$9fd397d08c2d16a8 = 'SHORTCUT_UNSUSPEND_ALL';
const $2172826b4c3056a0$export$10ad248542f8f08a = 'SHORTCUT_READY';
const $2172826b4c3056a0$export$cf28c5d1cdf589fe = (shortcut)=>({
        type: $2172826b4c3056a0$export$1c63173ca595450a,
        shortcut: shortcut
    });
const $2172826b4c3056a0$export$1382c83aa7e9dbac = (shortcut)=>({
        type: $2172826b4c3056a0$export$c4475d8e75afef42,
        shortcut: shortcut
    });
const $2172826b4c3056a0$export$a5fd989017fb8235 = (shortcut)=>({
        type: $2172826b4c3056a0$export$e2722a7b3014afd,
        shortcut: shortcut
    });
const $2172826b4c3056a0$export$22e447d5e4c01620 = (shortcut)=>({
        type: $2172826b4c3056a0$export$4e83263cb3e9f57a,
        shortcut: shortcut
    });
const $2172826b4c3056a0$export$3b0cf718b694f89b = (shortcut)=>({
        type: $2172826b4c3056a0$export$6cec1982edce8d1c,
        shortcut: shortcut
    });
const $2172826b4c3056a0$export$79ba5c952010fc13 = ()=>({
        type: $2172826b4c3056a0$export$523a43274979a4a4
    });
const $2172826b4c3056a0$export$dc49008b1a140c86 = ()=>({
        type: $2172826b4c3056a0$export$9fd397d08c2d16a8
    });
const $2172826b4c3056a0$export$ee1088b1fed7af6b = (shortcutState)=>({
        type: $2172826b4c3056a0$export$10ad248542f8f08a,
        shortcutState: shortcutState
    });
const $2172826b4c3056a0$var$initialState = {
    Shortcuts: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $2172826b4c3056a0$export$ce9a9c54dfb60d1b = (state = $2172826b4c3056a0$var$initialState, action)=>{
    let shortcuts;
    switch(action.type){
        case $2172826b4c3056a0$export$1c63173ca595450a:
            {
                const actionShortcut = action.shortcut;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionShortcut);
                shortcuts = [].concat(state.Shortcuts);
                shortcuts.push(actionShortcut);
                return {
                    ...state,
                    Shortcuts: shortcuts
                };
            }
        case $2172826b4c3056a0$export$c4475d8e75afef42:
            {
                const actionShortcut = action.shortcut;
                return {
                    ...state,
                    Shortcuts: state.Shortcuts.map((abObject)=>abObject.Uuid === actionShortcut.Uuid ? actionShortcut : abObject)
                };
            }
        case $2172826b4c3056a0$export$e2722a7b3014afd:
            {
                const actionShortcut = action.shortcut;
                return {
                    ...state,
                    Shortcuts: state.Shortcuts.filter((abObject)=>abObject.Uuid !== actionShortcut.Uuid)
                };
            }
        case $2172826b4c3056a0$export$4e83263cb3e9f57a:
            return {
                ...state,
                Shortcuts: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.shortcut, state.Shortcuts, true)
            };
        case $2172826b4c3056a0$export$6cec1982edce8d1c:
            return {
                ...state,
                Shortcuts: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.shortcut, state.Shortcuts, false)
            };
        case $2172826b4c3056a0$export$523a43274979a4a4:
            return {
                ...state,
                Shortcuts: (0, $471c8159162519ad$export$d5749a3ee2d57eaa)(state.Shortcuts)
            };
        case $2172826b4c3056a0$export$9fd397d08c2d16a8:
            return {
                ...state,
                Shortcuts: (0, $471c8159162519ad$export$94c949ae997a6e37)(state.Shortcuts)
            };
        default:
            return state;
    }
};


/**
 * @ReduxAction Smart Edit is being applied
 */ const $eeed7eb8174868ba$export$126f735137833f65 = 'SMART_EDIT_APPLY';
const $eeed7eb8174868ba$export$11e21e6a3ad56860 = 'SMART_EDIT_READY';
const $eeed7eb8174868ba$export$686758e9d668ae5c = (bypassValidationWarnings)=>({
        type: $eeed7eb8174868ba$export$126f735137833f65,
        bypassValidationWarnings: bypassValidationWarnings
    });
const $eeed7eb8174868ba$export$b389f49fc2051bb3 = ()=>({
        type: $eeed7eb8174868ba$export$11e21e6a3ad56860
    });



const $264a0e58163aefb1$export$8a4d1edf7e363c5 = 'SET_STATUS_BAR_PANELS';
const $264a0e58163aefb1$export$fce0dd4c057a916a = 'STATUS_BAR_READY';
const $264a0e58163aefb1$export$f43bbf39b910281 = (statusPanels)=>({
        statusPanels: statusPanels,
        type: $264a0e58163aefb1$export$8a4d1edf7e363c5
    });
const $264a0e58163aefb1$export$d4c72bab9d6cc13a = {
    StatusBars: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $264a0e58163aefb1$export$f3a658bc32c51d73 = (state)=>state.StatusBar.StatusBars;
const $264a0e58163aefb1$export$4bfbe5bb7028d51d = (statusBarState)=>({
        type: $264a0e58163aefb1$export$fce0dd4c057a916a,
        statusBarState: statusBarState
    });
const $264a0e58163aefb1$export$f2a6f3194b9adb15 = (state = $264a0e58163aefb1$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case $264a0e58163aefb1$export$8a4d1edf7e363c5:
            const newPanels = action.statusPanels;
            return {
                ...state,
                StatusBars: newPanels
            };
    }
    return state;
};





const $e8ca06942ba9c0b6$export$3c0e644cfb911e5c = 'STYLED_COLUMN_ADD';
const $e8ca06942ba9c0b6$export$a3ffeda234f6a66c = 'STYLED_COLUMN_EDIT';
const $e8ca06942ba9c0b6$export$2ea88f408b96c43e = 'STYLED_COLUMN_DELETE';
const $e8ca06942ba9c0b6$export$63a88b100de2b544 = 'STYLED_COLUMN_DELETE_ALL';
const $e8ca06942ba9c0b6$export$255bee253965f640 = 'STYLED_COLUMN_READY';
const $e8ca06942ba9c0b6$export$8bc31936bf7696d6 = 'STYLED_COLUMN_SUSPEND';
const $e8ca06942ba9c0b6$export$a4111c78938f3626 = 'STYLED_COLUMN_UNSUSPEND';
const $e8ca06942ba9c0b6$export$59add3f970f9bd7e = 'STYLED_COLUMN_SUSPEND_ALL';
const $e8ca06942ba9c0b6$export$eec5284c54efc89a = 'STYLED_COLUMN_UNSUSPEND_ALL';
const $e8ca06942ba9c0b6$export$292f31ea3d79c677 = (styledColumn)=>({
        type: $e8ca06942ba9c0b6$export$3c0e644cfb911e5c,
        StyledColumn: styledColumn
    });
const $e8ca06942ba9c0b6$export$bb2fbe12e4c588d7 = (styledColumn)=>({
        type: $e8ca06942ba9c0b6$export$a3ffeda234f6a66c,
        StyledColumn: styledColumn
    });
const $e8ca06942ba9c0b6$export$3dfcc5faf1946cbb = (styledColumn)=>({
        type: $e8ca06942ba9c0b6$export$2ea88f408b96c43e,
        StyledColumn: styledColumn
    });
const $e8ca06942ba9c0b6$export$8e07fce2d39db7d7 = ()=>({
        type: $e8ca06942ba9c0b6$export$63a88b100de2b544
    });
const $e8ca06942ba9c0b6$export$2c1b6bb508b3a62c = (styledColumn)=>({
        type: $e8ca06942ba9c0b6$export$8bc31936bf7696d6,
        StyledColumn: styledColumn
    });
const $e8ca06942ba9c0b6$export$a2ae8bf0128483d5 = (styledColumn)=>({
        type: $e8ca06942ba9c0b6$export$a4111c78938f3626,
        StyledColumn: styledColumn
    });
const $e8ca06942ba9c0b6$export$7b6ed1b680677da9 = ()=>({
        type: $e8ca06942ba9c0b6$export$59add3f970f9bd7e
    });
const $e8ca06942ba9c0b6$export$b6435374e77e122f = ()=>({
        type: $e8ca06942ba9c0b6$export$eec5284c54efc89a
    });
const $e8ca06942ba9c0b6$export$9dd707f74792b6bc = (styledColumnState)=>({
        type: $e8ca06942ba9c0b6$export$255bee253965f640,
        StyledColumnState: styledColumnState
    });
const $e8ca06942ba9c0b6$var$initialState = {
    StyledColumns: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $e8ca06942ba9c0b6$export$5d643c7523240ed0 = (state = $e8ca06942ba9c0b6$var$initialState, action)=>{
    let styledColumns;
    switch(action.type){
        case $e8ca06942ba9c0b6$export$3c0e644cfb911e5c:
            {
                const actionStyledColumn = action.StyledColumn;
                (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(actionStyledColumn);
                styledColumns = [].concat(state.StyledColumns);
                styledColumns.push(actionStyledColumn);
                return {
                    ...state,
                    StyledColumns: styledColumns
                };
            }
        case $e8ca06942ba9c0b6$export$a3ffeda234f6a66c:
            const actionStyledColumn = action.StyledColumn;
            return {
                ...state,
                StyledColumns: state.StyledColumns.map((abObject)=>abObject.Uuid === actionStyledColumn.Uuid ? actionStyledColumn : abObject)
            };
        case $e8ca06942ba9c0b6$export$2ea88f408b96c43e:
            {
                const actionStyledColumn = action.StyledColumn;
                return {
                    ...state,
                    StyledColumns: state.StyledColumns.filter((abObject)=>abObject.Uuid !== actionStyledColumn.Uuid)
                };
            }
        case $e8ca06942ba9c0b6$export$63a88b100de2b544:
            return {
                ...state,
                StyledColumns: []
            };
        case $e8ca06942ba9c0b6$export$8bc31936bf7696d6:
            return {
                ...state,
                StyledColumns: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.StyledColumn, state.StyledColumns, true)
            };
        case $e8ca06942ba9c0b6$export$a4111c78938f3626:
            return {
                ...state,
                StyledColumns: (0, $471c8159162519ad$export$b2dfdefaaf135198)(action.StyledColumn, state.StyledColumns, false)
            };
        case $e8ca06942ba9c0b6$export$59add3f970f9bd7e:
            return {
                ...state,
                StyledColumns: (0, $471c8159162519ad$export$d5749a3ee2d57eaa)(state.StyledColumns)
            };
        case $e8ca06942ba9c0b6$export$eec5284c54efc89a:
            return {
                ...state,
                StyledColumns: (0, $471c8159162519ad$export$94c949ae997a6e37)(state.StyledColumns)
            };
        default:
            return state;
    }
};




const $a6df66119ff073ff$export$70af566873cc6e56 = 'TEAMSHARING_GET';
const $a6df66119ff073ff$export$8eb888aade303dfa = 'TEAMSHARING_SET';
const $a6df66119ff073ff$export$e65d69fb9378122f = 'TEAMSHARING_SHARE';
const $a6df66119ff073ff$export$8324686bae8e35e7 = 'TEAMSHARING_SHARE_CUSTOM';
const $a6df66119ff073ff$export$9ce2368b2015d7d6 = 'TEAMSHARING_IMPORT_ITEM';
const $a6df66119ff073ff$export$f13fba9da03b7b6a = 'TEAMSHARING_PROCESS_IMPORT';
const $a6df66119ff073ff$export$8eca6787be88db1a = 'TEAMSHARING_COMMIT_IMPORT';
const $a6df66119ff073ff$export$205e9d2e34ac8592 = 'TEAMSHARING_REMOVE_ITEM';
const $a6df66119ff073ff$export$3c05fc7ef53a6a50 = 'TEAMSHARING_LINK_ITEM';
const $a6df66119ff073ff$export$a59df55c0577dd8c = 'TEAMSHARING_UPDATE_ITEM';
const $a6df66119ff073ff$export$bdb00257ffe7c123 = 'TEAMSHARING_CHECK_FOR_UPDATES';
const $a6df66119ff073ff$export$bfa3d118cda0ea7e = (entity, module, configuration)=>({
        type: $a6df66119ff073ff$export$e65d69fb9378122f,
        Entity: entity,
        Module: module,
        Configuration: configuration
    });
const $a6df66119ff073ff$export$66e6848ec7588b12 = (entity, configuration)=>({
        type: $a6df66119ff073ff$export$8324686bae8e35e7,
        Entity: entity,
        Configuration: configuration
    });
const $a6df66119ff073ff$export$76ebb6dc19c60348 = (Entities)=>({
        type: $a6df66119ff073ff$export$8eb888aade303dfa,
        Entities: Entities
    });
const $a6df66119ff073ff$export$bed91c72cfaa4424 = (SharedEntity)=>({
        type: $a6df66119ff073ff$export$9ce2368b2015d7d6,
        SharedEntity: SharedEntity
    });
const $a6df66119ff073ff$export$6880fa4b5e419f6b = (ImportSteps)=>({
        type: $a6df66119ff073ff$export$f13fba9da03b7b6a,
        ImportSteps: ImportSteps
    });
const $a6df66119ff073ff$export$3393dff032b18693 = ()=>({
        type: $a6df66119ff073ff$export$8eca6787be88db1a
    });
const $a6df66119ff073ff$export$d156e46d29aee999 = (Uuid)=>({
        type: $a6df66119ff073ff$export$205e9d2e34ac8592,
        Uuid: Uuid
    });
const $a6df66119ff073ff$export$418c60d5bcf62235 = ()=>({
        type: $a6df66119ff073ff$export$70af566873cc6e56
    });
const $a6df66119ff073ff$export$87aee12c8a362f5d = (...SharedEntities)=>({
        type: $a6df66119ff073ff$export$3c05fc7ef53a6a50,
        SharedEntities: SharedEntities
    });
const $a6df66119ff073ff$export$ab923fc15395daa2 = (ChangedAdaptableObject, UserName)=>({
        type: $a6df66119ff073ff$export$a59df55c0577dd8c,
        ChangedAdaptableObject: ChangedAdaptableObject,
        UserName: UserName
    });
const $a6df66119ff073ff$export$ee8a578a7894d481 = ()=>({
        type: $a6df66119ff073ff$export$bdb00257ffe7c123
    });
const $a6df66119ff073ff$var$initialTeamSharingState = {
    SharedEntities: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    ActiveSharedEntityMap: {},
    importProcessInProgress: false
};
const $a6df66119ff073ff$export$40b4c4011e575c25 = (state = $a6df66119ff073ff$var$initialTeamSharingState, action)=>{
    switch(action.type){
        case $a6df66119ff073ff$export$8eb888aade303dfa:
            {
                const actionTyped = action;
                const sharedEntities = actionTyped.Entities;
                // keep only the active entities which are still shared (some may have been removed by other users)
                const sharedEntityItemIds = sharedEntities.map((sharedEntity)=>sharedEntity.Entity.Uuid);
                const activeSharedEntityMap = {};
                Object.keys(state.ActiveSharedEntityMap).forEach((activeObjectId)=>{
                    if (sharedEntityItemIds.includes(activeObjectId)) activeSharedEntityMap[activeObjectId] = state.ActiveSharedEntityMap[activeObjectId];
                });
                return Object.assign({}, state, {
                    SharedEntities: sharedEntities,
                    ActiveSharedEntityMap: activeSharedEntityMap
                });
            }
        case $a6df66119ff073ff$export$3c05fc7ef53a6a50:
            {
                const actionTyped = action;
                const newActiveEntities = actionTyped.SharedEntities;
                const activeSharedEntityMap = {
                    ...state.ActiveSharedEntityMap
                };
                newActiveEntities.forEach((newActiveEntity)=>activeSharedEntityMap[newActiveEntity.Entity.Uuid] = newActiveEntity);
                return Object.assign({}, state, {
                    ActiveSharedEntityMap: activeSharedEntityMap
                });
            }
        case $a6df66119ff073ff$export$f13fba9da03b7b6a:
            return Object.assign({}, state, {
                importProcessInProgress: true
            });
        case $a6df66119ff073ff$export$8eca6787be88db1a:
            return Object.assign({}, state, {
                importProcessInProgress: false
            });
        default:
            return state;
    }
};




const $436d9a36bf9edcd8$export$a79f71f8fb712ec9 = 'THEME_SET_SYSTEM_THEMES';
const $436d9a36bf9edcd8$export$83bf533dc60c8894 = 'THEME_SET_USER_THEMES';
const $436d9a36bf9edcd8$export$31588330e8bf743f = 'THEME_SELECT';
const $436d9a36bf9edcd8$export$9569fa78bc1e1456 = 'THEME_READY';
const $436d9a36bf9edcd8$export$533f49a8c94f02ac = 'THEME_EDIT';
const $436d9a36bf9edcd8$export$6d5001cedb963abc = 'THEME_ADD';
const $436d9a36bf9edcd8$export$5866c1b65837aa50 = 'THEME_DELETE';
const $436d9a36bf9edcd8$export$feda9bd84e4f320c = (SystemThemes)=>({
        type: $436d9a36bf9edcd8$export$a79f71f8fb712ec9,
        SystemThemes: SystemThemes
    });
const $436d9a36bf9edcd8$export$26e2802959258c51 = (UserThemes)=>({
        type: $436d9a36bf9edcd8$export$83bf533dc60c8894,
        UserThemes: UserThemes
    });
const $436d9a36bf9edcd8$export$1b9e02e625a724dc = (Theme)=>({
        type: $436d9a36bf9edcd8$export$31588330e8bf743f,
        Theme: Theme
    });
const $436d9a36bf9edcd8$export$71022c84c51ab76a = (themeState)=>({
        type: $436d9a36bf9edcd8$export$9569fa78bc1e1456,
        themeState: themeState
    });
const $436d9a36bf9edcd8$export$6974728752898f91 = (theme)=>({
        type: $436d9a36bf9edcd8$export$533f49a8c94f02ac,
        theme: theme
    });
const $436d9a36bf9edcd8$export$cedf576ec9cfa2ac = (theme)=>({
        type: $436d9a36bf9edcd8$export$6d5001cedb963abc,
        theme: theme
    });
const $436d9a36bf9edcd8$export$2e6aad93bd77037 = (theme)=>({
        type: $436d9a36bf9edcd8$export$5866c1b65837aa50,
        theme: theme
    });
const $436d9a36bf9edcd8$var$initialState = {
    CurrentTheme: (0, $72a4ef37247198d5$export$3aabe399552f4ef9),
    SystemThemes: (0, $72a4ef37247198d5$export$f30c621cc5df841e),
    UserThemes: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $436d9a36bf9edcd8$export$3e94ceb986e6798 = (state = $436d9a36bf9edcd8$var$initialState, action)=>{
    switch(action.type){
        case $436d9a36bf9edcd8$export$a79f71f8fb712ec9:
            return Object.assign({}, state, {
                SystemThemes: action.SystemThemes
            });
        case $436d9a36bf9edcd8$export$83bf533dc60c8894:
            return Object.assign({}, state, {
                UserThemes: action.UserThemes
            });
        case $436d9a36bf9edcd8$export$31588330e8bf743f:
            return Object.assign({}, state, {
                CurrentTheme: action.Theme
            });
        case $436d9a36bf9edcd8$export$533f49a8c94f02ac:
            let newThemes = null;
            // find by UUID, or by name
            const themeToBeReplaced = action.theme;
            let replaceIndex = state.UserThemes.findIndex((theme)=>themeToBeReplaced.Uuid === theme.Uuid);
            // try by name
            if (replaceIndex === -1) replaceIndex = state.UserThemes.findIndex((theme)=>themeToBeReplaced.Name === theme.Name);
            // fond one, either by name or by uuid
            if (replaceIndex !== -1) {
                newThemes = [
                    ...state.UserThemes
                ];
                newThemes[replaceIndex] = themeToBeReplaced;
            }
            if (newThemes === null) return state;
            // if name changed, need to update the current name
            let currentTheme = state.CurrentTheme;
            if (currentTheme !== themeToBeReplaced.Name) // need to update the current theme if it name has changed
            currentTheme = themeToBeReplaced.Name;
            return Object.assign({}, state, {
                CurrentTheme: currentTheme,
                UserThemes: newThemes
            });
        case $436d9a36bf9edcd8$export$6d5001cedb963abc:
            return Object.assign({}, state, {
                UserThemes: [
                    ...state.UserThemes,
                    action.theme
                ]
            });
        case $436d9a36bf9edcd8$export$5866c1b65837aa50:
            return Object.assign({}, state, {
                UserThemes: state.UserThemes.filter((theme)=>theme.Uuid !== action.theme.Uuid)
            });
        default:
            return state;
    }
};


/**
 * @ReduxAction Tool Panels have been set in AdapTable ToolPanel Component
 */ const $297dbcf3bf27faf2$export$8b6be7ccc49edf6a = 'TOOLPANEL_SET_TOOLPANELS';
const $297dbcf3bf27faf2$export$bf5b629a53f8080e = 'TOOLPANEL_SHOW_TOOLPANEL';
const $297dbcf3bf27faf2$export$9b5626d49aceed49 = 'TOOLPANEL_HIDE_TOOLPANEL';
const $297dbcf3bf27faf2$export$7776dfa58fd59010 = 'TOOLPANEL_EXPAND_TOOLPANEL';
const $297dbcf3bf27faf2$export$5a8d90ae7e02e4ef = 'TOOLPANEL_COLLAPSE_TOOLPANEL';
const $297dbcf3bf27faf2$export$5619e08761791ee2 = 'TOOLPANEL_SET_MODULE_BUTTONS';
const $297dbcf3bf27faf2$export$8af9321f57ae73e0 = 'TOOLPANEL_READY';
const $297dbcf3bf27faf2$export$c8a6b1c32a7e4f85 = (toolPanels)=>({
        type: $297dbcf3bf27faf2$export$8b6be7ccc49edf6a,
        toolPanels: toolPanels
    });
const $297dbcf3bf27faf2$export$ae671580d1b5b91e = (toolPanel)=>({
        type: $297dbcf3bf27faf2$export$bf5b629a53f8080e,
        toolPanel: toolPanel
    });
const $297dbcf3bf27faf2$export$e7e637fbca1a6 = (toolPanel)=>({
        type: $297dbcf3bf27faf2$export$9b5626d49aceed49,
        toolPanel: toolPanel
    });
const $297dbcf3bf27faf2$export$ee3eefa58024e7e9 = (toolPanel)=>({
        type: $297dbcf3bf27faf2$export$7776dfa58fd59010,
        toolPanel: toolPanel
    });
const $297dbcf3bf27faf2$export$a5e2bec81f9383b9 = (toolPanel)=>({
        type: $297dbcf3bf27faf2$export$5a8d90ae7e02e4ef,
        toolPanel: toolPanel
    });
const $297dbcf3bf27faf2$export$2603e58d630068f9 = (moduleButtons)=>({
        type: $297dbcf3bf27faf2$export$5619e08761791ee2,
        moduleButtons: moduleButtons
    });
const $297dbcf3bf27faf2$export$8154ff15a144d54e = (toolPanelState)=>({
        type: $297dbcf3bf27faf2$export$8af9321f57ae73e0,
        toolPanelState: toolPanelState
    });
const $297dbcf3bf27faf2$var$initialState = {
    // default ToolPanels are set in ToolPanelModule.updateOldConfig() because we have to evaluate the ToolPanelOptions (for CustomToolPanel)
    ToolPanels: undefined,
    ModuleButtons: [
        'SettingsPanel'
    ]
};
const $297dbcf3bf27faf2$export$41cfc721617eeb4c = (state = $297dbcf3bf27faf2$var$initialState, action)=>{
    const setToolPanels = (state, toolPanels = [])=>{
        return {
            ...state,
            ToolPanels: [
                ...toolPanels
            ]
        };
    };
    switch(action.type){
        case $297dbcf3bf27faf2$export$8b6be7ccc49edf6a:
            {
                const actionTyped = action;
                const toolPanels = actionTyped.toolPanels;
                return setToolPanels(state, toolPanels);
            }
        case $297dbcf3bf27faf2$export$bf5b629a53f8080e:
            {
                const actionTyped = action;
                const toolPanelDefinition = {
                    Name: actionTyped.toolPanel,
                    VisibilityMode: 'collapsed'
                };
                const toolPanels = [
                    toolPanelDefinition,
                    ...state.ToolPanels ?? []
                ];
                return setToolPanels(state, toolPanels);
            }
        case $297dbcf3bf27faf2$export$9b5626d49aceed49:
            {
                const actionTyped = action;
                const toolPanels = (state.ToolPanels ?? []).filter((a)=>a.Name !== actionTyped.toolPanel);
                return setToolPanels(state, toolPanels);
            }
        case $297dbcf3bf27faf2$export$7776dfa58fd59010:
            {
                const actionTyped = action;
                const toolPanelDefinitions = state.ToolPanels?.map((toolPanelDefinition)=>toolPanelDefinition.Name === actionTyped.toolPanel ? {
                        ...toolPanelDefinition,
                        VisibilityMode: 'expanded'
                    } : toolPanelDefinition);
                return setToolPanels(state, toolPanelDefinitions);
            }
        case $297dbcf3bf27faf2$export$5a8d90ae7e02e4ef:
            {
                const actionTyped = action;
                const toolPanelDefinitions = state.ToolPanels?.map((toolPanelDefinition)=>toolPanelDefinition.Name === actionTyped.toolPanel ? {
                        ...toolPanelDefinition,
                        VisibilityMode: 'collapsed'
                    } : toolPanelDefinition);
                return setToolPanels(state, toolPanelDefinitions);
            }
        case $297dbcf3bf27faf2$export$5619e08761791ee2:
            {
                const actionTyped = action;
                const moduleButtons = actionTyped.moduleButtons;
                return Object.assign({}, state, {
                    ModuleButtons: moduleButtons
                });
            }
        default:
            return state;
    }
};


/**
 * @ReduxAction Sets whether all AdapTable UI elements are hidden
 */ const $d1ff82162d29425a$export$c4040b43dc4e2007 = 'USER_INTERFACE_SET_HIDE_ADAPTABLE_UI';
const $d1ff82162d29425a$export$be5939318a9ee8f5 = (hideAdaptableUI)=>({
        type: $d1ff82162d29425a$export$c4040b43dc4e2007,
        hideAdaptableUI: hideAdaptableUI
    });
const $d1ff82162d29425a$var$initialState = {
    HideAdaptableUI: false
};
const $d1ff82162d29425a$export$a618f0b4cf55bf74 = (state = $d1ff82162d29425a$var$initialState, action)=>{
    switch(action.type){
        case $d1ff82162d29425a$export$c4040b43dc4e2007:
            return Object.assign({}, state, {
                HideAdaptableUI: action.hideAdaptableUI
            });
        default:
            return state;
    }
};



const $652f53856d8ee82a$export$e7cf26b8bffccd2a = (entity)=>entity.EntityType === 'adaptableEntity';
const $652f53856d8ee82a$export$378092868a0e61cd = (entity)=>entity.EntityType === 'customEntity';



const $5d2a87b18b3438b7$var$INIT_STATE = 'INIT_STATE';
const $5d2a87b18b3438b7$var$LOAD_STATE = 'LOAD_STATE';
const $5d2a87b18b3438b7$var$NON_PERSIST_ACTIONS = {
    '@@INIT': true,
    '@@redux/init': true,
    [$5d2a87b18b3438b7$var$LOAD_STATE]: true,
    [$5d2a87b18b3438b7$var$INIT_STATE]: true,
    // progress indicators should NOT interfere with state management as it may lead to race conditions due to load/persist state being async
    [(0, $dc56b6267ce4d0bb$export$fc9ecba5bc6311f7)]: true,
    [(0, $dc56b6267ce4d0bb$export$ff1a8469042a7d31)]: true
};
const $5d2a87b18b3438b7$var$NON_PERSISTENT_STORE_KEYS = [
    'Internal',
    'Popup',
    'Comment',
    'Plugins'
];
const $5d2a87b18b3438b7$export$8d6594f2ef703eca = ()=>({
        type: $5d2a87b18b3438b7$var$INIT_STATE
    });
const $5d2a87b18b3438b7$export$26bba7cb707d8026 = (State)=>({
        type: $5d2a87b18b3438b7$var$LOAD_STATE,
        State: State
    });
class $5d2a87b18b3438b7$export$6c5ec8e858a8397e {
    TheStore;
    Load;
    emitter;
    beforeEmitter;
    storageEngine;
    currentStorageState;
    previousStorageState;
    loadStorageInProgress = false;
    loadStateOnStartup = true;
    on = (eventName, callback)=>{
        return this.emitter.on(eventName, callback);
    };
    onAny = (callback)=>{
        return this.emitter.onAny(callback);
    };
    onBeforeAny = (callback)=>{
        return this.beforeEmitter.onAny(callback);
    };
    emit = (eventName, data)=>{
        return this.emitter.emit(eventName, data);
    };
    /**
     *
     * @param adaptable The Adaptable instance
     * @param postLoadHook A function that hydrates the state after it has been loaded from storage
     */ constructor(adaptable){
        /*
          This is the main store for Adaptable State
        */ let rootReducerObject = {
            //  Reducers for Non-Persisted State
            Popup: $dc56b6267ce4d0bb$export$84403e5d7b9a413c,
            Internal: $5b564bb703f29152$export$776ac4e2465030a3,
            Plugins: $b332b9d7a4fcbf15$export$4fb339c0e4751e8,
            Comment: $4e814d4456d3e111$export$a069e6fb375b1344,
            // Reducers for Persisted State
            Alert: $0040cfd693076bab$export$339a131916a526d8,
            Application: $74b889ddf281400d$export$2ec3e40612b7679d,
            CalculatedColumn: $754f469a84cf6e6e$export$3b3f0b9a6a813734,
            Charting: $5571bec319fd98b0$export$ffd9fc696f46ab35,
            CustomSort: $75a64529baee8b47$export$83be7392811f3b65,
            Dashboard: $dc6bc6f406d56c84$export$8acdf620baca4d1b,
            Export: $a3814690501f278b$export$d8625ffb5330d880,
            FlashingCell: $26ec30a4ba180d8a$export$ccd2424f886bf649,
            FormatColumn: $4a80335d87022149$export$65a302d1c7ffc34,
            FreeTextColumn: $d8c519ae038bb984$export$c4d3477b718d9e5a,
            Layout: $2c155f3e4804e29e$export$906c0f169aee7cf2,
            NamedQuery: $f53463061a55e5a9$export$75b16504f320dd62,
            Note: $b5b505fd5df04a9f$export$409127b9f52346c3,
            PlusMinus: $36058826e464bb44$export$7c558d2947cd4ff1,
            QuickSearch: $a9684a89f07662ba$export$4c3a8d9573d2240d,
            Schedule: $bb63955874685545$export$a11069dc6c4000eb,
            Shortcut: $2172826b4c3056a0$export$ce9a9c54dfb60d1b,
            StatusBar: $264a0e58163aefb1$export$f2a6f3194b9adb15,
            StyledColumn: $e8ca06942ba9c0b6$export$5d643c7523240ed0,
            TeamSharing: $a6df66119ff073ff$export$40b4c4011e575c25,
            Theme: $436d9a36bf9edcd8$export$3e94ceb986e6798,
            ToolPanel: $297dbcf3bf27faf2$export$41cfc721617eeb4c,
            UserInterface: $d1ff82162d29425a$export$a618f0b4cf55bf74
        };
        // allow plugins to participate in the root reducer
        adaptable.forPlugins((plugin)=>{
            if (plugin.rootReducer) rootReducerObject = {
                ...rootReducerObject,
                ...plugin.rootReducer(rootReducerObject)
            };
        });
        const initialRootReducer = // @ts-ignore
        $d2bed10dff9b4968$export$66e4520cdb265d18(rootReducerObject);
        const rootReducerWithResetManagement = (state, action)=>{
            switch(action.type){
                case $5d2a87b18b3438b7$var$LOAD_STATE:
                    const { State: State } = action;
                    Object.keys(State).forEach((key)=>{
                        state[key] = State[key];
                    });
                    break;
            }
            return initialRootReducer(state, action);
        };
        let storageEngine;
        this.emitter = new (0, $7ddf72f79776fa87$export$2e2bcd8739ae039)();
        this.beforeEmitter = new (0, $7ddf72f79776fa87$export$2e2bcd8739ae039)();
        // If the user has remote storage set then we use Remote Engine, otherwise we use Local Enginge
        // not sure we can do this as we need to be backwardly compatible with existing users so need to stick with adaptable id (which should be unique)
        // const localStorageKey =  'adaptable-adaptable-state-' + adaptable.adaptableOptions.primaryKey;
        storageEngine = (0, $1a574cfd3e51bf62$export$3f0b0800cb866b8e)({
            adaptableId: adaptable.adaptableOptions.adaptableId,
            adaptableStateKey: adaptable.adaptableOptions.adaptableStateKey,
            userName: adaptable.adaptableOptions.userName,
            initialState: adaptable.adaptableOptions.initialState,
            loadState: adaptable.adaptableOptions.stateOptions.loadState,
            persistState: adaptable.adaptableOptions.stateOptions.persistState,
            debounceStateDelay: adaptable.adaptableOptions.stateOptions.debounceStateDelay
        });
        const didPersistentStateChange = (state, newState)=>{
            return Object.keys(newState).some((key)=>{
                if ($5d2a87b18b3438b7$var$NON_PERSISTENT_STORE_KEYS.includes(key)) return false;
                return state?.[key] !== newState?.[key];
            });
        };
        // this is now VERY BADLY NAMED!
        let rootReducer = (0, $4a1e94af0f77684f$export$7a419cba89232acd)(rootReducerWithResetManagement, $5d2a87b18b3438b7$var$LOAD_STATE);
        const composeEnhancers = (x)=>x;
        const persistedReducer = (state, action)=>{
            if (adaptable.isDestroyed) return state;
            const init = state === undefined;
            const newState = rootReducer(state, action);
            // ideally the reducer should be pure,
            // but having the emitter emit the event here
            // is really useful
            const emitterArg = {
                action: action,
                state: state,
                newState: newState
            };
            if (!$5d2a87b18b3438b7$var$NON_PERSIST_ACTIONS[action.type]) this.emitter.emit(action.type, emitterArg);
            const finalState = emitterArg.newState;
            const shouldPersist = state !== finalState && didPersistentStateChange(state, finalState) && !state?.Internal?.License?.disablePersistence && !$5d2a87b18b3438b7$var$NON_PERSIST_ACTIONS[action.type] && !init && !this.loadStorageInProgress;
            if (shouldPersist) {
                const storageState = {
                    ...finalState
                };
                $5d2a87b18b3438b7$var$NON_PERSISTENT_STORE_KEYS.forEach((key)=>{
                    delete storageState[key];
                });
                this.currentStorageState = storageState;
                this.previousStorageState = {
                    ...state
                };
                $5d2a87b18b3438b7$var$NON_PERSISTENT_STORE_KEYS.forEach((key)=>{
                    delete this.previousStorageState[key];
                });
                storageEngine.save(adaptable, storageState, action.type);
            }
            return finalState;
        };
        const beforeEmitterMiddleware = (middlewareAPI)=>(next)=>(action)=>{
                    if (!$5d2a87b18b3438b7$var$NON_PERSIST_ACTIONS[action.type]) {
                        const wasProgressActive = middlewareAPI.getState().Popup?.ProgressIndicator?.active;
                        this.beforeEmitter.emitSync(action.type, {
                            action: action,
                            state: middlewareAPI.getState()
                        });
                        const isProgressActive = middlewareAPI.getState().Popup?.ProgressIndicator?.active;
                        if (!wasProgressActive && isProgressActive) {
                            // double rAF: first frame lets React render + ProgressIndicator's
                            // useEffect schedule its own rAF for setVisible(); second frame
                            // runs after the browser has actually painted the indicator
                            // see #raf_progress_indicator
                            requestAnimationFrame(()=>{
                                requestAnimationFrame(()=>{
                                    next(action);
                                });
                            });
                            return action;
                        }
                    }
                    return next(action);
                };
        const devToolsActionMarkerMiddleware = $5d2a87b18b3438b7$var$createDevToolsActionMarkerMiddleware(adaptable);
        const pluginsMiddleware = [];
        adaptable.forPlugins((plugin)=>{
            if (plugin.reduxMiddleware) pluginsMiddleware.push(plugin.reduxMiddleware(adaptable));
        });
        const middlewares = [
            beforeEmitterMiddleware,
            devToolsActionMarkerMiddleware,
            $5d2a87b18b3438b7$var$adaptableMiddleware(adaptable),
            ...pluginsMiddleware
        ].filter(Boolean);
        //TODO: need to check if we want the storage to be done before or after
        //we enrich the state with the AB middleware
        this.TheStore = $d2bed10dff9b4968$export$f51a9068ac82ea43(persistedReducer, composeEnhancers($d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares)));
        this.storageEngine = storageEngine;
    }
    destroy() {
        this.emitter?.clearListeners();
        this.emitter = null;
        this.beforeEmitter?.clearListeners();
        this.beforeEmitter = null;
    }
    getCurrentStorageState() {
        return this.currentStorageState;
    }
    getPreviousStorageState() {
        return this.previousStorageState;
    }
    saveStateNow(adaptable) {
        const storageState = this.getCurrentStorageState();
        if (storageState) return this.storageEngine.saveNow(adaptable, storageState, 'API_CALL_SAVE_STATE');
        return Promise.resolve(true);
    }
    loadStore = (config)=>{
        const { adaptable: adaptable, adaptableStateKey: adaptableStateKey, initialState: initialState, postLoadHook: postLoadHook } = config;
        const postProcessState = postLoadHook ?? ((state)=>state);
        this.storageEngine.setStateKey(adaptableStateKey);
        // START STATE LOAD
        this.loadStorageInProgress = true;
        return this.Load = this.storageEngine.load(adaptable, initialState).then((storedState)=>{
            if (storedState && this.loadStateOnStartup) this.TheStore.dispatch($5d2a87b18b3438b7$export$26bba7cb707d8026(postProcessState(adaptable.adaptableOptions.stateOptions.applyState(storedState, (0, $84331a0549ebfeb9$export$91a43078b1cf7697)(adaptable)))));
        }).then(()=>{
            this.TheStore.dispatch($5d2a87b18b3438b7$export$8d6594f2ef703eca());
            // END STATE LOAD
            this.loadStorageInProgress = false;
        }, (e)=>{
            adaptable.api.consoleError('Failed to load saved Adaptable state.', e);
            //for now i'm still initializing Adaptable even if loading state has failed....
            //we may revisit that later
            this.TheStore.dispatch($5d2a87b18b3438b7$export$8d6594f2ef703eca());
            // END STATE LOAD
            this.loadStorageInProgress = false;
            this.TheStore.dispatch($dc56b6267ce4d0bb$export$1f102b51d7fb4f69({
                alertType: 'generic',
                header: 'Configuration',
                message: 'Failed to load your configuration: ' + e,
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$7694cf1e73d40929).CreateInternalAlertDefinitionForMessages('Error')
            }));
        });
    };
}
function $5d2a87b18b3438b7$var$createDevToolsActionMarkerMiddleware(adaptable) {
    const adaptableId = adaptable?.adaptableOptions?.adaptableId;
    if (!adaptableId) return null;
    if (!(0, $640f77453ad4a03c$export$375cebbcaf1ca382)(adaptableId)) return null;
    return (middlewareAPI)=>(next)=>(action)=>{
                if (!$5d2a87b18b3438b7$var$isTrackableReduxAction(action)) return next(action);
                const previousState = middlewareAPI.getState();
                const marker = (0, $640f77453ad4a03c$export$cd7dd5b5380f942f)(adaptableId).track.Redux.label.Action.start();
                try {
                    return next(action);
                } finally{
                    const nextState = middlewareAPI.getState();
                    const changedKeys = $5d2a87b18b3438b7$var$detectChangedAdaptableStateKeys(previousState, nextState);
                    const details = $5d2a87b18b3438b7$var$buildDevToolsActionDetails(action, changedKeys);
                    marker.end({
                        label: action.type,
                        tooltip: changedKeys?.length ? `State changes: ${changedKeys.join(', ')}` : undefined,
                        details: details.length ? details : undefined
                    });
                }
            };
}
const $5d2a87b18b3438b7$var$MAX_MARKER_DETAILS = 6;
function $5d2a87b18b3438b7$var$buildDevToolsActionDetails(action, changedKeys) {
    const details = [];
    if (changedKeys && changedKeys.length > 0) {
        const truncatedKeys = changedKeys.slice(0, $5d2a87b18b3438b7$var$MAX_MARKER_DETAILS);
        const suffix = changedKeys.length > truncatedKeys.length ? ` +${changedKeys.length - truncatedKeys.length} more` : '';
        details.push({
            name: 'State changes',
            value: `${truncatedKeys.join(', ')}${suffix}`
        });
    }
    if ($5d2a87b18b3438b7$var$isActionWithPayload(action)) {
        const entries = Object.entries(action).filter(([key])=>key !== 'type');
        for (const [key, value] of entries){
            if (details.length >= $5d2a87b18b3438b7$var$MAX_MARKER_DETAILS) break;
            details.push({
                name: `action.${key}`,
                value: $5d2a87b18b3438b7$var$coerceMarkerDetailValue(value)
            });
        }
    }
    return details;
}
function $5d2a87b18b3438b7$var$detectChangedAdaptableStateKeys(previousState, nextState) {
    if (!previousState || !nextState || previousState === nextState) return undefined;
    const previous = previousState;
    const next = nextState;
    const keys = new Set([
        ...Object.keys(previous),
        ...Object.keys(next)
    ]);
    const changed = [];
    keys.forEach((key)=>{
        if (previous[key] !== next[key]) changed.push(key);
    });
    return changed.length > 0 ? changed : undefined;
}
function $5d2a87b18b3438b7$var$isTrackableReduxAction(action) {
    return !!action && typeof action.type === 'string';
}
function $5d2a87b18b3438b7$var$isActionWithPayload(action) {
    return !!action && typeof action === 'object';
}
function $5d2a87b18b3438b7$var$coerceMarkerDetailValue(value) {
    if (value === null) return 'null';
    if (value === undefined) return 'undefined';
    const valueType = typeof value;
    if (valueType === 'string' || valueType === 'number' || valueType === 'boolean') return value;
    if (valueType === 'function') return '[function]';
    try {
        const json = JSON.stringify(value);
        if (!json) return '[empty]';
        const MAX_LENGTH = 200;
        return json.length > MAX_LENGTH ? `${json.slice(0, MAX_LENGTH - 3)}...` : json;
    } catch (err) {
        return '[unserializable]';
    }
}
// this is the main function for dealing with Redux Actions which require additional functionality to be triggered.
// Please document each use case where we have to use the Store rather than a module or a popup screen
// This should ideally be the ONLY place where we LISTEN to store changes
const $5d2a87b18b3438b7$var$adaptableMiddleware = (adaptable)=>function(middlewareAPI) {
        return function(next) {
            return function(action) {
                switch(action.type){
                    /*******************
                 * NAMED QUERY ACTIONS
                 *******************/ /**
                 * Use Case: User has deleted a Named Query
                 * Action: Check whether it is referenced elsewhere before deleting
                 */ case $f53463061a55e5a9$export$6018d1ce8f014591:
                        {
                            // check if Named Query is not referenced elsewhere
                            const actionTyped = action;
                            if (!adaptable.api.namedQueryApi.internalApi.validateDeletedNamedQuery(actionTyped.namedQuery.Name)) return;
                            const ret = next(action);
                            return ret;
                        }
                    /**
                 * Use Case: User has renamed a Named Query
                 * Action: Check whether it is referenced elsewhere before allowing rename
                 */ case $f53463061a55e5a9$export$853430cba22da616:
                        {
                            const actionTyped = action;
                            const editedNamedQuery = actionTyped.namedQuery;
                            const previousNamedQueryName = middlewareAPI.getState().NamedQuery.NamedQueries.find((namedQuery)=>namedQuery.Uuid === editedNamedQuery.Uuid)?.Name ?? '';
                            if (editedNamedQuery.Name !== previousNamedQueryName) {
                                if (!adaptable.api.namedQueryApi.internalApi.validateRenamedNamedQuery(previousNamedQueryName)) return;
                            }
                            const ret = next(action);
                            return ret;
                        }
                    /*******************
                 * System Row Summary ACTIONS
                 *******************/ case $5b564bb703f29152$export$b46645b802c722c8:
                        {
                            let nextAction = next(action);
                            adaptable.api.layoutApi.internalApi.setupRowSummaries();
                            return nextAction;
                        }
                    /*******************
                 * System Quick Filter ACTIONS
                 *******************/ case $5b564bb703f29152$export$e8986ad6b988a309:
                        {
                            let nextAction = next(action);
                            adaptable.showQuickFilter();
                            return nextAction;
                        }
                    case $5b564bb703f29152$export$5e04390a67ecd344:
                        {
                            let nextAction = next(action);
                            adaptable.hideQuickFilter();
                            return nextAction;
                        }
                    /*******************
                 * ALERT DEFINITION ACTIONS
                 *******************/ case $0040cfd693076bab$export$8bedfe4ad4522237:
                    case $0040cfd693076bab$export$32efa0a201159b9d:
                    case $0040cfd693076bab$export$b7bef988bc135839:
                    case $0040cfd693076bab$export$725641fffa449d27:
                    case $0040cfd693076bab$export$bb66c5cbd5db1838:
                    case $0040cfd693076bab$export$bdb8bdabbb4dda50:
                    case $0040cfd693076bab$export$b7a116cc1d5d2243:
                        {
                            const returnAction = next(action);
                            const alertDefinition = returnAction.alertDefinition;
                            if (returnAction.type === $0040cfd693076bab$export$8bedfe4ad4522237 || returnAction.type === $0040cfd693076bab$export$32efa0a201159b9d || returnAction.type === $0040cfd693076bab$export$725641fffa449d27) // in case of edit, the existing reactive alert will be deleted and recreated
                            adaptable.api.internalApi.getAlertService().createReactiveAlert(alertDefinition);
                            if (returnAction.type === $0040cfd693076bab$export$b7bef988bc135839 || returnAction.type === $0040cfd693076bab$export$bb66c5cbd5db1838) adaptable.api.internalApi.getAlertService().deleteReactiveAlert(alertDefinition);
                            if (returnAction.type === $0040cfd693076bab$export$b7a116cc1d5d2243) adaptable.api.internalApi.getAlertService().getReactiveActiveAlerts().forEach((alertDefinition)=>{
                                adaptable.api.internalApi.getAlertService().deleteReactiveAlert(alertDefinition);
                            });
                            if (returnAction.type === $0040cfd693076bab$export$bdb8bdabbb4dda50) adaptable.api.alertApi.internalApi.getReactiveAlertDefinitions().forEach((alertDefinition)=>{
                                if (!adaptable.api.internalApi.getAlertService().isReactiveAlertActive(alertDefinition)) adaptable.api.internalApi.getAlertService().createReactiveAlert(alertDefinition);
                            });
                            // called also for rendered column actions, see RENDERED COLUMN ACTIONS block
                            adaptable.updateColumnModelAndRefreshGrid();
                            // tell Alert Module to check if need to listen to Cell Change
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$40024cb74c2bb550);
                            if (module) module.checkListenToCellDataChanged();
                            return returnAction;
                        }
                    /*******************
                 * Flashing Cell ACTIONS
                 *******************/ case $26ec30a4ba180d8a$export$805f35bb772015ea:
                    case $26ec30a4ba180d8a$export$79c96b0355f197ca:
                    case $26ec30a4ba180d8a$export$1d3518db481297a2:
                    case $26ec30a4ba180d8a$export$2745afda6699d8b1:
                    case $26ec30a4ba180d8a$export$cb179a605c2b95a1:
                    case $26ec30a4ba180d8a$export$3790814dfab55bb4:
                    case $26ec30a4ba180d8a$export$a043ce31c00fce71:
                        {
                            const returnAction = next(action);
                            // called also for rendered column actions, see RENDERED COLUMN ACTIONS block
                            adaptable.updateColumnModelAndRefreshGrid();
                            // check if cell data change listening needs to be activated
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$fc2170ec34a40864);
                            if (module) module.checkListenToCellDataChanged();
                            return returnAction;
                        }
                    /*******************
                 * FREE TEXT COLUMN ACTIONS
                 *******************/ /**
                 * Use Case: We have added / edited / deleted a Free Text Column
                 * Actions: We check if a deleted Column has references and return if so
                 * Actions: We update the Special ColumnDefs and refresh the Layout
                 */ case $d8c519ae038bb984$export$6a9a507b9cd8ad46:
                    case $d8c519ae038bb984$export$5728fd58a5cf775e:
                    case $d8c519ae038bb984$export$603fcb8db0ec4ed0:
                        {
                            // First check to see Deleted Free Text Column is referenced elsewhwere and return if so
                            if (action.type === $d8c519ae038bb984$export$603fcb8db0ec4ed0) {
                                const actionTyped = action;
                                if (!adaptable.api.freeTextColumnApi.internalApi.validateDeletedFreeTextColumn(actionTyped.freeTextColumn)) return;
                            }
                            const returnAction = next(action);
                            // Check listen to Cell Data Changes and refresh the layout
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$7a2c7140815c0686);
                            if (module) module.checkListenToCellDataChanged();
                            adaptable.api.layoutApi.internalApi.refreshLayout();
                            return returnAction;
                        }
                    /*******************
                 * CALCULATED COLUMN ACTIONS
                 *******************/ /**
                 * Use Case: We have added / edited / deleted a Calculated Column
                 * Action: We update the Special ColumnDefs and refresh the Layout
                 */ case $754f469a84cf6e6e$export$e7c69e05c8f54d4f:
                    case $754f469a84cf6e6e$export$90da21d938613394:
                    case $754f469a84cf6e6e$export$f65f92db6093424:
                        {
                            const actionTypedCC = action;
                            const calculatedColumn = actionTypedCC.calculatedColumn;
                            // First check for Deleted Calculated Columns with references and return if found
                            if (action.type === $754f469a84cf6e6e$export$f65f92db6093424) {
                                if (!adaptable.api.calculatedColumnApi.internalApi.validateDeletedCalculatedColumn(calculatedColumn)) return;
                            }
                            const returnAction = next(action);
                            // Manage Aggregations, fire Event, set up listener and refresh Layout
                            if (action.type === $754f469a84cf6e6e$export$e7c69e05c8f54d4f || action.type === $754f469a84cf6e6e$export$90da21d938613394) adaptable.api.internalApi.getCalculatedColumnExpressionService().createAggregatedScalarLiveValue(calculatedColumn);
                            else adaptable.api.internalApi.getCalculatedColumnExpressionService().destroyAggregatedScalarLiveValue(calculatedColumn);
                            adaptable.api.eventApi.internalApi.fireCalculatedColumnChangedEvent(action.type, calculatedColumn);
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$6619e71706e8514a);
                            if (module) module.checkListenToCellDataChanged();
                            adaptable.api.layoutApi.internalApi.refreshLayout();
                            return returnAction;
                        }
                    /*******************
                 * RENDERED COLUMN ACTIONS
                 *******************/ /**
                 * Use Case: We have updated an AdapTable Module that affects rendering
                 * Action: We set up all columns again
                 */ case $a9684a89f07662ba$export$ea2c3562caec3a19:
                    case $4a80335d87022149$export$ffb6d2c9303feec9:
                    case $4a80335d87022149$export$adfd77f5b0235282:
                    case $4a80335d87022149$export$394b8559b8709e27:
                    case $4a80335d87022149$export$b6754c165aa11d2f:
                    case $4a80335d87022149$export$3f21537021418d7:
                    case $4a80335d87022149$export$cb2f47f94da9e750:
                    case $4a80335d87022149$export$b7cb5d51e0ffb83a:
                    case $4a80335d87022149$export$252f4fd568ae21d6:
                    case $4a80335d87022149$export$ebaf6b30778dcb55:
                    case $4a80335d87022149$export$467d42e7704b7d08:
                    case $4a80335d87022149$export$c10ab6feb50a850:
                    case $e8ca06942ba9c0b6$export$3c0e644cfb911e5c:
                    case $e8ca06942ba9c0b6$export$a3ffeda234f6a66c:
                    case $e8ca06942ba9c0b6$export$2ea88f408b96c43e:
                    case $e8ca06942ba9c0b6$export$8bc31936bf7696d6:
                    case $e8ca06942ba9c0b6$export$a4111c78938f3626:
                    case $e8ca06942ba9c0b6$export$59add3f970f9bd7e:
                    case $e8ca06942ba9c0b6$export$eec5284c54efc89a:
                    case $75a64529baee8b47$export$82d5f05636051c1f:
                    case $75a64529baee8b47$export$37e3fb42a2441efe:
                    case $75a64529baee8b47$export$43c8c2949c595161:
                    case $75a64529baee8b47$export$eb590f115bc9eaf6:
                    case $75a64529baee8b47$export$d91b24db8ab03460:
                    case $75a64529baee8b47$export$620ff7671b99bf9d:
                    case $75a64529baee8b47$export$9b4328f9bf0b668:
                        {
                            const returnAction = next(action);
                            // called also for alert actions, see ALERT ACTIONS block
                            adaptable.updateColumnModelAndRefreshGrid();
                            return returnAction;
                        }
                    /*******************
                 * QUICK SEARCH ACTIONS
                 *******************/ /**
                 * Use Case: User has run a Quick Search
                 * Action1: Call Adaptable to redraw body so cells can be highlighted
                 * Action2: Run Query using Quick Search text
                 */ case $a9684a89f07662ba$export$5e9fd90a3792a3ea:
                        {
                            let returnAction = next(action);
                            adaptable.api.gridApi.refreshAllCells(true);
                            const actionTyped = action;
                            const searchText = actionTyped.quickSearchText;
                            adaptable.setAgGridFindSearchValue(searchText);
                            // if set then return a query on the text
                            if (adaptable.adaptableOptions.quickSearchOptions.filterGridAfterQuickSearch) {
                                if ((0, $9OAZF.StringExtensions).IsNotNullOrEmpty(searchText)) adaptable.setAgGridQuickSearch(searchText);
                                else adaptable.clearAgGridQuickSearch();
                            }
                            return returnAction;
                        }
                    /*******************
                 * INTERNAL ACTIONS
                 *******************/ /**
                 * Use Case: User has deleted a System Alert which has a Highlight Cell or Highlight Row
                 * Action: Refresh the cell / Row (to clear the Highlight)
                 */ case $5b564bb703f29152$export$da4d4b120f90dd49:
                        {
                            const actionTyped = action;
                            let ret = next(action);
                            const adaptableAlert = actionTyped.alert;
                            if (adaptableAlert.alertDefinition.AlertProperties?.HighlightCell && (0, $f4d8c497686c0f4a$export$ad5de0913e0a99e1)(adaptableAlert) && adaptableAlert.cellDataChangedInfo) {
                                const rowNode = adaptableAlert.cellDataChangedInfo.rowNode;
                                adaptable.api.gridApi.refreshCell(rowNode, adaptableAlert.cellDataChangedInfo.column.columnId, true);
                            }
                            if (adaptableAlert.alertDefinition.AlertProperties?.HighlightRow && (0, $f4d8c497686c0f4a$export$c51f434865bcd0f0)(adaptableAlert) && adaptableAlert.rowDataChangedInfo) adaptable.api.gridApi.refreshRowNodes(adaptableAlert.rowDataChangedInfo.rowNodes);
                            return ret;
                        }
                    /**
                 * Use Case: User has deleted all System Alerts some of which have a Highlight Cell
                 * Action: Refresh the cell (to clear the style)
                 */ case $5b564bb703f29152$export$8b66681127c3e555:
                        {
                            const actionTyped = action;
                            let ret = next(action);
                            let alerts = actionTyped.alerts;
                            alerts.forEach((alert)=>{
                                if (alert.alertDefinition.AlertProperties?.HighlightCell && (0, $f4d8c497686c0f4a$export$ad5de0913e0a99e1)(alert) && alert.cellDataChangedInfo) {
                                    let rowNode = alert.cellDataChangedInfo.rowNode;
                                    adaptable.api.gridApi.refreshCell(rowNode, alert.cellDataChangedInfo.column.columnId, true);
                                }
                                if (alert.alertDefinition.AlertProperties?.HighlightRow && (0, $f4d8c497686c0f4a$export$c51f434865bcd0f0)(alert) && alert.rowDataChangedInfo) adaptable.api.gridApi.refreshRowNodes(alert.rowDataChangedInfo.rowNodes);
                            });
                            return ret;
                        }
                    /**
                 * Use Case: A System Alert had a Highlight Cell with a limited duration
                 * Action: Refresh the cell (to clear the style)
                 */ case $5b564bb703f29152$export$c68a41837441fcf7:
                        {
                            let ret = next(action);
                            const actionTyped = action;
                            const adaptableAlert = actionTyped.alert;
                            if (adaptableAlert.alertDefinition.AlertProperties?.HighlightCell) {
                                if ((0, $f4d8c497686c0f4a$export$ad5de0913e0a99e1)(adaptableAlert) && adaptableAlert.cellDataChangedInfo) {
                                    const rowNode = adaptableAlert.cellDataChangedInfo.rowNode;
                                    adaptable.api.gridApi.refreshCell(rowNode, adaptableAlert.cellDataChangedInfo.column.columnId, true);
                                }
                            }
                            return ret;
                        }
                    case $5b564bb703f29152$export$de0a34f95d27629f:
                        {
                            let ret = next(action);
                            const actionTyped = action;
                            const adaptableAlert = actionTyped.alert;
                            if (adaptableAlert.alertDefinition.AlertProperties?.HighlightRow) {
                                if ((0, $f4d8c497686c0f4a$export$ad5de0913e0a99e1)(adaptableAlert) && adaptableAlert.cellDataChangedInfo) adaptable.api.gridApi.refreshRowNodes([
                                    adaptableAlert.cellDataChangedInfo.rowNode
                                ]);
                                if ((0, $f4d8c497686c0f4a$export$c51f434865bcd0f0)(adaptableAlert) && adaptableAlert.rowDataChangedInfo) adaptable.api.gridApi.refreshRowNodes(adaptableAlert.rowDataChangedInfo.rowNodes);
                            }
                            return ret;
                        }
                    case $5b564bb703f29152$export$f384c2cd8cb9fb5c:
                        {
                            const actionTyped = action;
                            const ret = next(action);
                            const cellHighlightInfo = actionTyped.cellHighlightInfo;
                            const rowNode = adaptable.api.gridApi.getRowNodeForPrimaryKey(cellHighlightInfo.primaryKeyValue);
                            if (rowNode) adaptable.api.gridApi.refreshCell(rowNode, cellHighlightInfo.columnId, true);
                            return ret;
                        }
                    case $5b564bb703f29152$export$f3408dd0c13097db:
                        {
                            const actionTyped = action;
                            const ret = next(action);
                            const rowNode = adaptable.api.gridApi.getRowNodeForPrimaryKey(actionTyped.primaryKeyValue);
                            if (rowNode) adaptable.api.gridApi.refreshCell(rowNode, actionTyped.columnId, true);
                            return ret;
                        }
                    case $5b564bb703f29152$export$565d0994f34459df:
                        {
                            const cellHighlightInfos = middlewareAPI.getState().Internal.CellHighlightInfo;
                            const ret = next(action);
                            cellHighlightInfos.forEach((cellHighlightInfo)=>{
                                const rowNode = adaptable.api.gridApi.getRowNodeForPrimaryKey(cellHighlightInfo.primaryKeyValue);
                                if (!rowNode) return;
                                adaptable.api.gridApi.refreshCell(rowNode, cellHighlightInfo.columnId, true);
                            });
                            return ret;
                        }
                    case $5b564bb703f29152$export$17a87e5a743cea30:
                        {
                            const actionTyped = action;
                            const ret = next(action);
                            const columnHighlightInfo = actionTyped.columnHighlightInfo;
                            adaptable.api.gridApi.refreshColumn(columnHighlightInfo.columnId);
                            return ret;
                        }
                    case $5b564bb703f29152$export$541d71e5cda0756c:
                        {
                            const actionTyped = action;
                            const ret = next(action);
                            adaptable.api.gridApi.refreshColumn(actionTyped.columnId);
                            return ret;
                        }
                    case $5b564bb703f29152$export$8062ce7f7143d859:
                        {
                            const columnHighlightInfos = middlewareAPI.getState().Internal.ColumnHighlightInfo;
                            const ret = next(action);
                            columnHighlightInfos.forEach((columnHighlightInfo)=>{
                                adaptable.api.gridApi.refreshColumn(columnHighlightInfo.columnId);
                            });
                            return ret;
                        }
                    case $5b564bb703f29152$export$7d1895646bfa0f08:
                        {
                            const actionTyped = action;
                            const ret = next(action);
                            const rowHighlightInfo = actionTyped.rowHighlightInfo;
                            const rowNode = adaptable.api.gridApi.getRowNodeForPrimaryKey(rowHighlightInfo.primaryKeyValue);
                            if (rowNode) adaptable.api.gridApi.refreshRowNode(rowNode);
                            return ret;
                        }
                    case $5b564bb703f29152$export$2d689283eeefed87:
                        {
                            const actionTyped = action;
                            const ret = next(action);
                            const rowNode = adaptable.api.gridApi.getRowNodeForPrimaryKey(actionTyped.primaryKeyValue);
                            if (rowNode) adaptable.api.gridApi.refreshRowNode(rowNode);
                            return ret;
                        }
                    case $5b564bb703f29152$export$fad44cf871b0d26b:
                        {
                            const actionTyped = action;
                            const ret = next(action);
                            const rowsHighlightInfo = actionTyped.rowsHighlightInfo;
                            const rowNodes = adaptable.api.gridApi.getRowNodesForPrimaryKeys(rowsHighlightInfo.primaryKeyValues);
                            if (rowNodes.length) adaptable.api.gridApi.refreshRowNodes(rowNodes);
                            return ret;
                        }
                    case $5b564bb703f29152$export$25d096a3d0a79afc:
                        {
                            const actionTyped = action;
                            const ret = next(action);
                            const rowNodes = adaptable.api.gridApi.getRowNodesForPrimaryKeys(actionTyped.primaryKeyValues);
                            if (rowNodes.length) adaptable.api.gridApi.refreshRowNodes(rowNodes);
                            return ret;
                        }
                    case $5b564bb703f29152$export$6e5e141003a5370d:
                        {
                            const rowHighlightInfos = middlewareAPI.getState().Internal.RowHighlightInfo;
                            const ret = next(action);
                            rowHighlightInfos.forEach((rowHighlightInfo)=>{
                                const rowNode = adaptable.api.gridApi.getRowNodeForPrimaryKey(rowHighlightInfo.primaryKeyValue);
                                if (!rowNode) return;
                                adaptable.api.gridApi.refreshRowNode(rowNode);
                            });
                            return ret;
                        }
                    case $5b564bb703f29152$export$8fa42571c3ed7ce:
                        const actionTypedUndo = action;
                        const cellDataChangedInfo = actionTypedUndo.changeInfo;
                        adaptable.api.gridApi.undoCellEdit(cellDataChangedInfo);
                        return next(action);
                    case $5b564bb703f29152$export$e15fba57eed9ad7a:
                    case $5b564bb703f29152$export$668166beb957075b:
                    case $5b564bb703f29152$export$b284623f5d1e1134:
                    case $5b564bb703f29152$export$d72029662e46675c:
                        const returnAction = next(action);
                        let module = adaptable.adaptableModules.get($42e863194fcb493f$export$376343cd8119f6bf);
                        if (module) module.checkListenToCellDataChanged();
                        return returnAction;
                    case $5b564bb703f29152$export$e932fdb2c385fe60:
                        {
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$bbf6ee8f129590d);
                            let returnAction = next(action);
                            let selectedCellInfo = middlewareAPI.getState().Internal.SelectedCellInfo;
                            let apiSummaryReturn = module.createCellSummaryInfo(selectedCellInfo);
                            adaptable.api.internalApi.setCellSummaryInfo(apiSummaryReturn);
                            return returnAction;
                        }
                    /*******************
                 * DATA SOURCE ACTIONS
                 *******************/ /**
                 * Use Case: Data Sources have been amended
                 * Action1: Fire Data Source Changed event
                 * Action2: Display a DataSet form if supplied
                 */ case $5b564bb703f29152$export$2a14b9f34817129b:
                        {
                            let returnAction = next(action);
                            const dataSet = adaptable.api.dataSetApi.getCurrentDataSet();
                            adaptable.api.eventApi.internalApi.fireDataSetSelectedEvent(dataSet);
                            requestAnimationFrame(()=>{
                                adaptable.api.dataSetApi.internalApi.showDataSetForm(dataSet);
                            });
                            return returnAction;
                        }
                    /*******************
                 * THEME ACTIONS
                 *******************/ /**
                 * Use Case: Theme has changed
                 * Action: Apply new Theme
                 */ case $436d9a36bf9edcd8$export$31588330e8bf743f:
                        {
                            let returnAction = next(action);
                            adaptable.api.themeApi.applyCurrentTheme();
                            return returnAction;
                        }
                    /*******************
                 * Note ACTIONS
                 *******************/ /**
                 * Use Case: Note has been edited/deleted/added
                 * Action: Triangle can be removed/added
                 */ case $b5b505fd5df04a9f$export$4a0a36c128089fe8:
                    case $b5b505fd5df04a9f$export$b862825b416d0d44:
                    case $b5b505fd5df04a9f$export$1b58e272863850a1:
                        {
                            let returnAction = next(action);
                            adaptable.AnnotationsService.checkListenToEvents();
                            const rowNode = adaptable.api.gridApi.getRowNodeForPrimaryKey(returnAction.adaptableNote.PrimaryKeyValue);
                            adaptable.api.gridApi.refreshCell(rowNode, returnAction.adaptableNote.ColumnId, true);
                            return returnAction;
                        }
                    /*******************
                 * Comment ACTIONS
                 *******************/ /**
                 * Use Case: Comments has been edited/deleted/added
                 * Action: Triangle can be removed/added
                 */ case $4e814d4456d3e111$export$e0ea86c1cc990e84:
                    case $4e814d4456d3e111$export$4e1261b76c89c910:
                    case $4e814d4456d3e111$export$46603197b09023ec:
                    case $4e814d4456d3e111$export$4e39991b17fb7f02:
                    case $4e814d4456d3e111$export$8d83c99b2938b6f5:
                        {
                            let returnAction = next(action);
                            adaptable.AnnotationsService.checkListenToEvents();
                            let rowNode = null;
                            let columnId = null;
                            if ('cellAddress' in returnAction) {
                                rowNode = adaptable.api.gridApi.getRowNodeForPrimaryKey(returnAction.cellAddress.PrimaryKeyValue);
                                columnId = returnAction.cellAddress.ColumnId;
                            } else if ('cellComments' in returnAction) {
                                rowNode = adaptable.api.gridApi.getRowNodeForPrimaryKey(returnAction.cellComments.PrimaryKeyValue);
                                columnId = returnAction.cellComments.ColumnId;
                            }
                            if (rowNode && columnId) {
                                adaptable.api.gridApi.refreshCell(rowNode, columnId, true);
                                requestAnimationFrame(()=>{
                                    const commentThreads = adaptable.api.commentApi.getAllComments();
                                    adaptable.api.eventApi.emit('CommentChanged', commentThreads);
                                    adaptable.api.optionsApi.getCommentOptions()?.persistCommentThreads?.(commentThreads);
                                });
                            }
                            return returnAction;
                        }
                    case $4e814d4456d3e111$export$9068a450ff36a380:
                        {
                            const previousCommentThreads = adaptable.api.commentApi.getAllComments();
                            let returnAction = next(action);
                            const newCommentThreads = adaptable.api.commentApi.getAllComments() ?? [];
                            requestAnimationFrame(()=>{
                                let addedCommentThreads = [];
                                let deletedCommentThreads = [];
                                const prevCommentThreadsSet = new Set((previousCommentThreads ?? []).map((c)=>c.Uuid));
                                const newCommentThreadsSet = new Set((newCommentThreads ?? []).map((c)=>c.Uuid));
                                for (const commentThread of newCommentThreads)if (!prevCommentThreadsSet.has(commentThread.Uuid)) addedCommentThreads.push(commentThread);
                                for (const commentThread of previousCommentThreads)if (!newCommentThreadsSet.has(commentThread.Uuid)) deletedCommentThreads.push(commentThread);
                                // This cannot be called because it would trigger an infinite loop
                                // adaptable.api.eventApi.emit('CommentChanged', commentThreads);
                                // refresh all comments cells to show or hide the triangle
                                [
                                    ...addedCommentThreads,
                                    ...deletedCommentThreads
                                ].forEach((commentThread)=>{
                                    const node = adaptable.api.gridApi.getRowNodeForPrimaryKey(commentThread.PrimaryKeyValue);
                                    if (node && commentThread.ColumnId) adaptable.api.gridApi.refreshCell(node, commentThread.ColumnId, true);
                                });
                            });
                            return returnAction;
                        }
                    /*******************
                 * SCHEDULE ACTIONS
                 *******************/ /**
                 * Use Case: Schedule has changed
                 * Action: Set up ALL jobs
                 */ case $bb63955874685545$export$a980b87cdc361a36:
                    case $bb63955874685545$export$58ec0bcbb480e612:
                    case $bb63955874685545$export$9f8cb78a84ec6925:
                    case $bb63955874685545$export$d075fdaa06f36e3e:
                    case $bb63955874685545$export$e187dcdde0648fea:
                    case $bb63955874685545$export$37895167f4d76838:
                    case $bb63955874685545$export$9399faf55c25dc64:
                    case $bb63955874685545$export$8bd0a398d5e878c6:
                    case $bb63955874685545$export$cedfc702b2b90673:
                    case $bb63955874685545$export$55fb49a34a3c4862:
                    case $bb63955874685545$export$b9d37aaf64695063:
                    case $bb63955874685545$export$5ddb7796cf3b52e6:
                    case $bb63955874685545$export$f66a8cfe589bcb8a:
                    case $bb63955874685545$export$e276a5bef9096eed:
                    case $bb63955874685545$export$9cb6d77cb46f5866:
                    case $bb63955874685545$export$ad6f7fa11aa8a043:
                    case $bb63955874685545$export$88c72e1edb5c2c37:
                    case $bb63955874685545$export$aa7c1aee79a11c79:
                    case $bb63955874685545$export$8cd7da7e18e1bec0:
                    case $bb63955874685545$export$727470f46742b8b5:
                    case $bb63955874685545$export$4a72c25357c0c6ac:
                    case $bb63955874685545$export$40cafac348921468:
                    case $bb63955874685545$export$856d9acd1b677c23:
                    case $bb63955874685545$export$49a64f24543973d5:
                    case $bb63955874685545$export$207e1b978297ce75:
                    case $bb63955874685545$export$79548e540f38e53a:
                    case $bb63955874685545$export$37296639673c1ddd:
                    case $bb63955874685545$export$99df0de0feae3a9c:
                        {
                            let returnAction = next(action);
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$5dd6e67bf681ede8);
                            module.setUpScheduleJobs();
                            return returnAction;
                        }
                    /*******************
                 * USER INTERFACE ACTIONS
                 *******************/ case $d1ff82162d29425a$export$c4040b43dc4e2007:
                        {
                            const returnAction = next(action);
                            const { hideAdaptableUI: hideAdaptableUI } = action;
                            // Hide or show Dashboard
                            middlewareAPI.dispatch($dc6bc6f406d56c84$export$b2de5be7510594c1(hideAdaptableUI));
                            // Hide or show Adaptable ToolPanel in the AG Grid sidebar
                            if (hideAdaptableUI) adaptable.hideAdaptableToolPanel();
                            else adaptable.showAdaptableToolPanel();
                            // Hide or show Adaptable StatusBar panels
                            if (hideAdaptableUI) adaptable.hideAdaptableStatusBar();
                            else adaptable.showAdaptableStatusBar();
                            // Column and Context Menus are handled in the AgGridMenuAdapter
                            return returnAction;
                        }
                    /*******************
                 * DASHBOARD ACTIONS
                 *******************/ case $dc6bc6f406d56c84$export$b451dd41daee3965:
                    case $dc6bc6f406d56c84$export$275ed42331417618:
                    case $dc6bc6f406d56c84$export$6931bbeea6091f8c:
                    case $dc6bc6f406d56c84$export$91c524c261db7e40:
                    case $dc6bc6f406d56c84$export$461adf9e9f007a5a:
                    case $dc6bc6f406d56c84$export$47b4a641ee3cc004:
                    case $dc6bc6f406d56c84$export$5d1d6e84259d21d8:
                    case $dc6bc6f406d56c84$export$36959fe86cc6fb38:
                    case $dc6bc6f406d56c84$export$63e4674795a9c9b8:
                        {
                            const oldDashboardState = middlewareAPI.getState().Dashboard;
                            let returnAction = next(action);
                            const newDashboardState = middlewareAPI.getState().Dashboard;
                            adaptable.api.eventApi.internalApi.fireDashboardChangedEvent(action.type, oldDashboardState, newDashboardState);
                            return returnAction;
                        }
                    /*******************
                 * LAYOUT ACTIONS
                 *******************/ case $2c155f3e4804e29e$export$eaebc7baa579657b:
                    case $2c155f3e4804e29e$export$5e441936c483de3b:
                    case $2c155f3e4804e29e$export$8b6b33d09d8d1be4:
                    case $2c155f3e4804e29e$export$b98536b8d888c2d8:
                    case $2c155f3e4804e29e$export$b79ae389bfecc801:
                        {
                            const oldLayoutState = middlewareAPI.getState().Layout;
                            // this must be called before 'next(action)'
                            const previousLayout = adaptable.api.layoutApi.getCurrentLayout();
                            let returnAction = next(action);
                            const newLayoutState = middlewareAPI.getState().Layout;
                            adaptable.api.eventApi.internalApi.fireLayoutChangedEvent(action.type, oldLayoutState, newLayoutState);
                            const oldLayout = (oldLayoutState.Layouts || []).find((l)=>l.Name == oldLayoutState.CurrentLayout) || (0, $58846ea7f4156db7$export$2657cb1ad92c69eb);
                            const newLayout = (newLayoutState.Layouts || []).find((l)=>l.Name == newLayoutState.CurrentLayout) || newLayoutState.Layouts[0] || (0, $58846ea7f4156db7$export$2657cb1ad92c69eb);
                            if (returnAction.type == $2c155f3e4804e29e$export$b79ae389bfecc801 || returnAction.type == $2c155f3e4804e29e$export$b98536b8d888c2d8) // tell AdapTable the Layout has been selected
                            {
                                if (newLayout) adaptable.updateLayoutInManagerAfterStoreHasChanged(newLayout);
                            }
                            // !!! filter refresh has to be AFTER the layout has been set in the store
                            let refreshColumnFilters = false;
                            if (adaptable.api.filterApi.columnFilterApi.internalApi.areColumnFiltersDifferent(oldLayout.ColumnFilters, newLayout.ColumnFilters)) refreshColumnFilters = true;
                            let refreshGridFilter = false;
                            if (adaptable.api.filterApi.gridFilterApi.internalApi.isGridFilterDifferent(oldLayout.GridFilter, newLayout.GridFilter)) refreshGridFilter = true;
                            if (refreshColumnFilters || refreshGridFilter) adaptable.applyFiltering({
                                updateColumnFilterModel: refreshColumnFilters
                            });
                            // when changing current layout via the api, the layout should update
                            if (returnAction.type == $2c155f3e4804e29e$export$8b6b33d09d8d1be4) {
                                const savingLayout = returnAction.layout;
                                if (previousLayout.Name === savingLayout.Name && previousLayout !== savingLayout && // objects may have changed, but have the same contents
                                // this prevents pivot layout from infinite set-layout
                                !adaptable.api.layoutApi.internalApi.areLayoutsEqual(previousLayout, savingLayout)) adaptable.updateLayoutInManagerAfterStoreHasChanged(savingLayout);
                            }
                            return returnAction;
                        }
                    /**
                 * Use Case: Column Filters have changed
                 * Action: Apply Column Filtering and fire associated events
                 * Note: For LAYOUT_COLUMN_FILTER_EDIT we do not filter (as it seems to be already handled)
                 */ case $2c155f3e4804e29e$export$dfb8d886fc62ddf9:
                    case $2c155f3e4804e29e$export$e108c947785ca6ca:
                    case $2c155f3e4804e29e$export$d13e0ad82ad445b3:
                    case $2c155f3e4804e29e$export$c16e7bdd1b4bf32c:
                    case $2c155f3e4804e29e$export$15be0f58f317384:
                    case $2c155f3e4804e29e$export$56404215ee113fd:
                    case $2c155f3e4804e29e$export$e9f77efbaf88a239:
                    case $2c155f3e4804e29e$export$22f48e79a2003d4f:
                    case $2c155f3e4804e29e$export$82cd5ee5d79079a4:
                        {
                            let returnAction;
                            // needs to be called before 'next' so previous and next column filters are known
                            const shouldTriggerColumnFiltering = adaptable.api.filterApi.columnFilterApi.internalApi.shouldNewColumnFilterTriggerColumnFiltering(action);
                            const oldLayoutState = middlewareAPI.getState().Layout;
                            returnAction = next(action);
                            // we need to update the current layout model
                            // in the layout manager, so that onLayoutChange
                            // it will come back with the correct fields
                            adaptable.silentUpdateCurrentLayoutModel();
                            if (shouldTriggerColumnFiltering) setTimeout(()=>{
                                adaptable.applyFiltering();
                            }, 50);
                            adaptable.api.eventApi.internalApi.fireColumnFilterAppliedEvent();
                            adaptable.api.eventApi.internalApi.fireLayoutChangedEvent(action.type, oldLayoutState, middlewareAPI.getState().Layout);
                            return returnAction;
                        }
                    /**
                 * Use Case: Grid Filter has changed
                 * Action: Apply Grid Filtering and fire associated events
                 */ case $2c155f3e4804e29e$export$6d89f5f562ded487:
                    case $2c155f3e4804e29e$export$35f3edf02b756295:
                    case $2c155f3e4804e29e$export$1a594c99ac9663dc:
                    case $2c155f3e4804e29e$export$41f931c7d92898d0:
                        {
                            let returnAction = next(action);
                            adaptable.api.eventApi.internalApi.fireGridFilterAppliedEvent();
                            adaptable.api.eventApi.internalApi.fireLayoutChangedEvent(action.type, null, middlewareAPI.getState().Layout);
                            setTimeout(()=>{
                                adaptable.applyFiltering({
                                    updateColumnFilterModel: false
                                });
                            }, 5);
                            return next(returnAction);
                        }
                    /*******************
                 * SMART EDIT ACTIONS
                 *******************/ /**
                 * Use Case: User wants to perform Smart Edit and we need to check if the cell selection is valid
                 * Action (1):  Get the result from the SmartEdit module
                 * If the return is an Alert:
                 * Action (2): If there is a popup open, close it and show the Alert; otherwise just set false valid selection
                 * If the return is valid:
                 * Action (2): Set the valid selection to true
                 * Action (3): Build the Preview Values (via Smart Edit module)
                 * Action (4): Set the Preview Values (this will populate the preview screen)
                 */ case $5b564bb703f29152$export$5255020d7fd8544f:
                        {
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$3fb170c57e2678e6);
                            let state = middlewareAPI.getState();
                            let returnAction = next(action);
                            let apiReturn = module.CheckCorrectCellSelection();
                            let popup = state.Popup.ScreenPopup;
                            // this is a horrible hack and fix for a weird issue
                            // we really need to do smart edit and bulk update better
                            // but this fixes it for now
                            if (popup.ComponentName != 'LayoutPopup') {
                                if (apiReturn.Alert) {
                                    // check if Smart Edit is showing as popup and then close and show error (dont want to do that if from toolbar)
                                    if (popup.ComponentName == 'SmartEditPopup') {
                                        // We are in SmartEditPopup so let's close it
                                        adaptable.api.internalApi.hidePopupScreen();
                                        // and now show the alert Popup
                                        adaptable.api.alertApi.displayAdaptableAlertNotification(apiReturn.Alert);
                                    }
                                    middlewareAPI.dispatch($5b564bb703f29152$export$bc1d0b606ccfb6ae(false));
                                } else {
                                    middlewareAPI.dispatch($5b564bb703f29152$export$bc1d0b606ccfb6ae(true));
                                    let apiPreviewReturn = module.BuildPreviewValues(state.Internal.SmartEdit.SmartEditValue, state.Internal.SmartEdit.SmartEditOperation);
                                    middlewareAPI.dispatch($5b564bb703f29152$export$b7fe9fd714f0afc2(apiPreviewReturn));
                                }
                            }
                            return returnAction;
                        }
                    /**
                 * Use Case: User has changed a Smmart Edit property or requested a preview
                 * Action (1):  Get the new preview set from the Smart Edit module
                 * Action (2):  Set the Preview Values (this will populate the preview screen)
                 */ case $5b564bb703f29152$export$9f15d1006db00da7:
                    case $5b564bb703f29152$export$d40c929da9e9f01a:
                    case $5b564bb703f29152$export$6c728ad6e80f0362:
                        {
                            //all our logic needs to be executed AFTER the main reducers
                            //so our state is up to date which allow us not to care about the data within each different action
                            let returnAction = next(action);
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$3fb170c57e2678e6);
                            let state = middlewareAPI.getState();
                            let apiReturn = module.BuildPreviewValues(state.Internal.SmartEdit.SmartEditValue, state.Internal.SmartEdit.SmartEditOperation);
                            middlewareAPI.dispatch($5b564bb703f29152$export$b7fe9fd714f0afc2(apiReturn));
                            return returnAction;
                        }
                    /**
                 * Use Case: User has clicked 'Apply' in Smart Edit popup or toolbar
                 * Action (1): Gets the values that need to be applied from the Preview Info and passes to Preview Helper (incl. whether to bypass validation)
                 * Action (2): Sets the cell values in the Grid
                 */ case $eeed7eb8174868ba$export$126f735137833f65:
                        {
                            const actionTyped = action;
                            let thePreview = middlewareAPI.getState().Internal.SmartEdit.SmartEditPreviewInfo;
                            let newValues = (0, $ffbf29d095efdf81$export$69a3593e4bb2f3c1).GetCellUpdateRequestsFromPreview(thePreview, actionTyped.bypassValidationWarnings);
                            adaptable.api.gridApi.setCellValues(newValues);
                            adaptable.api.internalApi.hidePopupScreen();
                            return next(action);
                        }
                    /*******************
                 * BULK UPDATE ACTIONS
                 *******************/ case $5b564bb703f29152$export$588c2d3b23d8b789:
                        {
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$bc824d5002237871);
                            let state = middlewareAPI.getState();
                            let returnAction = next(action);
                            let apiReturn = module.checkCorrectCellSelection();
                            let popup = state.Popup.ScreenPopup;
                            // this is a horrible hack and fix for a weird issue
                            // we really need to do smart edit and bulk update better
                            // but this fixes it for now
                            if (popup.ComponentName != 'LayoutPopup') {
                                if (apiReturn.Alert) // check if BulkUpdate is showing as popup
                                {
                                    if (popup.ComponentName == 'BulkUpdatePopup') {
                                        //We close the BulkUpdatePopup
                                        adaptable.api.internalApi.hidePopupScreen();
                                        //We show the Error Popup -- assume that will alwasy be an Error
                                        adaptable.api.alertApi.displayAdaptableAlertNotification(apiReturn.Alert);
                                    }
                                }
                                middlewareAPI.dispatch($5b564bb703f29152$export$72bb87be2da22210(apiReturn));
                            }
                            return returnAction;
                        }
                    // Here we have all actions that triggers a refresh of the BulkUpdatePreview
                    case $5b564bb703f29152$export$6c538a66cf392594:
                        {
                            //all our logic needs to be executed AFTER the main reducers
                            //so our state is up to date which allow us not to care about the data within each different action
                            let returnAction = next(action);
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$bc824d5002237871);
                            let state = middlewareAPI.getState();
                            let apiReturn = module.buildPreviewValues(state.Internal.BulkUpdate.BulkUpdateValue);
                            middlewareAPI.dispatch($5b564bb703f29152$export$ebc463902112910(apiReturn));
                            return returnAction;
                        }
                    case $8713f41926484273$export$e604d3f304f1465b:
                        {
                            const actionTyped = action;
                            let thePreview = middlewareAPI.getState().Internal.BulkUpdate.BulkUpdatePreviewInfo;
                            let newValues = (0, $ffbf29d095efdf81$export$69a3593e4bb2f3c1).GetCellUpdateRequestsFromPreview(thePreview, actionTyped.bypassValidationWarnings);
                            adaptable.api.gridApi.setCellValues(newValues);
                            adaptable.api.internalApi.hidePopupScreen();
                            return next(action);
                        }
                    /*******************
                 * PLUS MINUS ACTIONS
                 *******************/ /**
                 * Use Case: Plus Minus Rules have changed
                 * Action: Get Plus Minus module to know if it needs to listen to keydown
                 */ case $36058826e464bb44$export$c1e4f5fe837266a2:
                    case $36058826e464bb44$export$df34a40a1e726215:
                    case $36058826e464bb44$export$4b9a17f0f1755c3f:
                        {
                            let returnAction = next(action);
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$1d33a3a77a9299ff);
                            if (module) module.checkListenToKeyDown();
                            return returnAction;
                        }
                    /**
                 * Use Case: Plus Minus has been applied
                 * Action: update the grid cells
                 */ case $36058826e464bb44$export$7420c34c9c4ca99e:
                        {
                            let returnAction = next(action);
                            const actionTyped = action;
                            adaptable.api.gridApi.setCellValues(actionTyped.cellUpdateRequests);
                            return returnAction;
                        }
                    /*******************
                 * SHORTCUT ACTIONS
                 *******************/ /**
                 * Use Case: Shortcuts have changed
                 * Action: Get Shortcut module to know if it needs to listen to keydown
                 */ case $2172826b4c3056a0$export$1c63173ca595450a:
                    case $2172826b4c3056a0$export$c4475d8e75afef42:
                    case $2172826b4c3056a0$export$e2722a7b3014afd:
                        {
                            let returnAction = next(action);
                            let module = adaptable.adaptableModules.get($42e863194fcb493f$export$ef61c24f038f357f);
                            if (module) module.checkListenToKeyDown();
                            return returnAction;
                        }
                    /*******************
                 * EXPORT ACTIONS
                 *******************/ // When selected report is undefined, clear the format
                    case $a3814690501f278b$export$b70aea09767f9d2f:
                        {
                            const actionTyped = action;
                            let returnAction = next(action);
                            const selectedReport = actionTyped.SelectedReport;
                            if (selectedReport == undefined) adaptable.api.exportApi.clearFormat();
                            return returnAction;
                        }
                    // When deleting a report, if it is currently selected clear it
                    case $a3814690501f278b$export$97446fcec9cb243f:
                        {
                            const actionTyped = action;
                            let report = actionTyped.report;
                            let currentReport = middlewareAPI.getState().Export.CurrentReport;
                            if (report && report.Name == currentReport) adaptable.api.exportApi.clearReport();
                            return next(action);
                        }
                    /*******************
                 * CHARTING ACTIONS
                 *******************/ case $5571bec319fd98b0$export$2f7927867b194687:
                        {
                            const returnAction = next(action);
                            adaptable.api.chartingApi.internalApi.onDeleteExternalChart(returnAction.chartDefinition);
                            return returnAction;
                        }
                    /*******************
                 * TEAM SHARING ACTIONS
                 *******************/ case $a6df66119ff073ff$export$70af566873cc6e56:
                        {
                            let returnAction = next(action);
                            adaptable.api.teamSharingApi.loadSharedEntities().then((sharedEntities)=>{
                                middlewareAPI.dispatch($a6df66119ff073ff$export$76ebb6dc19c60348(sharedEntities));
                            }).catch((error)=>{
                                adaptable.api.logError('TeamSharing get error : ' + error.message);
                                const alert = {
                                    alertType: 'generic',
                                    header: 'Team Sharing',
                                    message: 'Failed to retrieve shared items: ' + error.message,
                                    alertDefinition: (0, $c94ad2cb10a8d2c3$export$7694cf1e73d40929).CreateInternalAlertDefinitionForMessages('Error')
                                };
                                adaptable.api.alertApi.displayAdaptableAlertNotification(alert);
                            });
                            return returnAction;
                        }
                    case $a6df66119ff073ff$export$8324686bae8e35e7:
                        {
                            const actionTyped = action;
                            let returnAction = next(action);
                            const { Entity: Entity, Configuration: Configuration } = actionTyped;
                            let shareSuccessful;
                            // load latest state from TeamSharing server
                            adaptable.api.teamSharingApi.loadSharedEntities().then((sharedEntities)=>{
                                const customSharedEntity = adaptable.api.internalApi.getTeamSharingService().buildCustomSharedEntity(Entity, Configuration);
                                let newCustomShare = true;
                                const updatedSharedEntities = sharedEntities.map((entity)=>{
                                    // if it has the same UUID, override it
                                    if ((0, $652f53856d8ee82a$export$378092868a0e61cd)(entity) && entity.Uuid === customSharedEntity.Uuid) {
                                        newCustomShare = false;
                                        return {
                                            ...customSharedEntity,
                                            ChangedAt: Date.now(),
                                            ChangedBy: adaptable.api.optionsApi.getUserName()
                                        };
                                    }
                                    return entity;
                                });
                                if (newCustomShare) updatedSharedEntities.push(customSharedEntity);
                                middlewareAPI.dispatch($a6df66119ff073ff$export$76ebb6dc19c60348(updatedSharedEntities));
                                // update the server state
                                shareSuccessful = true;
                                return adaptable.api.teamSharingApi.persistSharedEntities(updatedSharedEntities);
                            }).then(()=>{
                                if (shareSuccessful) adaptable.api.logInfo(`Custom Shared Object '${Configuration.Name}' Shared Successfully`);
                            }).catch((error)=>{
                                adaptable.api.logError('TeamSharing share error : ' + error.message, actionTyped.Entity);
                            });
                            return returnAction;
                        }
                    // share the given AdaptableObject:
                    // - if it has dependencies, share them as well
                    // - if it's active, ensure that there is not already one present
                    // - if it's active, all the dependencies will be active as well
                    case $a6df66119ff073ff$export$e65d69fb9378122f:
                        {
                            const actionTyped = action;
                            let returnAction = next(action);
                            const { Entity: Entity, Configuration: Configuration, Module: Module } = actionTyped;
                            let shareSuccessful;
                            // load latest state from TeamSharing server
                            adaptable.api.teamSharingApi.loadSharedEntities().then((sharedEntities)=>{
                                // check if there is not already one active SharedEntity for this object
                                const existingActiveSharedEntity = Configuration.type === 'Active' && middlewareAPI.getState().TeamSharing.ActiveSharedEntityMap[Entity.Uuid];
                                if (existingActiveSharedEntity) {
                                    const alert = {
                                        alertType: 'generic',
                                        header: 'Team Sharing',
                                        message: `Cannot share ${adaptable.ModuleService.getModuleFriendlyName(Module)} \u{2014} an active share already exists: ${existingActiveSharedEntity.Description}.`,
                                        alertDefinition: (0, $c94ad2cb10a8d2c3$export$7694cf1e73d40929).CreateInternalAlertDefinitionForMessages('Error')
                                    };
                                    adaptable.api.alertApi.displayAdaptableAlertNotification(alert);
                                    shareSuccessful = false;
                                    return;
                                }
                                // build the new shared entities incl. all their dependencies
                                const newSharedEntityInclDependencies = adaptable.api.internalApi.getTeamSharingService().buildSharedEntityWithDependencies(Entity, Module, Configuration);
                                sharedEntities.push(...newSharedEntityInclDependencies);
                                // update the local state
                                middlewareAPI.dispatch($a6df66119ff073ff$export$87aee12c8a362f5d(...newSharedEntityInclDependencies.filter((sharedEntity)=>sharedEntity.Type === 'Active')));
                                middlewareAPI.dispatch($a6df66119ff073ff$export$76ebb6dc19c60348(sharedEntities));
                                // update the server state
                                shareSuccessful = true;
                                return adaptable.api.teamSharingApi.persistSharedEntities(sharedEntities);
                            }).then(()=>{
                                if (shareSuccessful) {
                                    const alert = {
                                        alertType: 'generic',
                                        header: 'Team Sharing',
                                        message: `${adaptable.ModuleService.getModuleFriendlyName(Module)} shared successfully.`,
                                        alertDefinition: (0, $c94ad2cb10a8d2c3$export$7694cf1e73d40929).CreateInternalAlertDefinitionForMessages('Success')
                                    };
                                    adaptable.api.alertApi.displayAdaptableAlertNotification(alert);
                                }
                            }).catch((error)=>{
                                adaptable.api.logError('TeamSharing share error : ' + error.message, actionTyped.Entity);
                                const alert = {
                                    alertType: 'generic',
                                    header: 'Team Sharing',
                                    message: 'Failed to share item: ' + error.message,
                                    alertDefinition: (0, $c94ad2cb10a8d2c3$export$7694cf1e73d40929).CreateInternalAlertDefinitionForMessages('Error')
                                };
                                adaptable.api.alertApi.displayAdaptableAlertNotification(alert);
                            });
                            return returnAction;
                        }
                    // remove the given shared entity:
                    // - ensure that no other shared entities depend on it
                    case $a6df66119ff073ff$export$205e9d2e34ac8592:
                        {
                            let returnAction = next(action);
                            const actionTyped = action;
                            const removedEntityId = actionTyped.Uuid;
                            // load latest state from TeamSharing server
                            adaptable.api.teamSharingApi.loadSharedEntities().then((sharedEntities)=>{
                                // ensure that no other SharedDependencies reference the to-be-deleted entity
                                const adaptableSharedEntities = sharedEntities.filter((0, $652f53856d8ee82a$export$e7cf26b8bffccd2a));
                                const sharedEntityDependants = adaptable.api.internalApi.getTeamSharingService().getSharedEntityDependants(removedEntityId, adaptableSharedEntities);
                                if (sharedEntityDependants.length) {
                                    const alert = {
                                        alertType: 'generic',
                                        header: 'Team Sharing',
                                        message: 'Cannot remove this shared item. It is referenced by: ' + sharedEntityDependants.map((sharedEntity)=>`${adaptable.ModuleService.getModuleFriendlyName(sharedEntity.Module)} ${sharedEntity.Description}`).join(', '),
                                        alertDefinition: (0, $c94ad2cb10a8d2c3$export$7694cf1e73d40929).CreateInternalAlertDefinitionForMessages('Warning')
                                    };
                                    adaptable.api.alertApi.displayAdaptableAlertNotification(alert);
                                    return;
                                }
                                // remove the deleted SharedEntity from local state
                                const newSharedEntities = sharedEntities.filter((s)=>s.Uuid !== removedEntityId);
                                middlewareAPI.dispatch($a6df66119ff073ff$export$76ebb6dc19c60348(newSharedEntities));
                                // update TeamSharing server
                                return adaptable.api.teamSharingApi.persistSharedEntities(newSharedEntities);
                            }).catch((error)=>{
                                adaptable.api.logError('TeamSharing remove error : ' + error.message);
                                const alert = {
                                    alertType: 'generic',
                                    header: 'Team Sharing',
                                    message: 'Failed to remove shared item: ' + error.message,
                                    alertDefinition: (0, $c94ad2cb10a8d2c3$export$7694cf1e73d40929).CreateInternalAlertDefinitionForMessages('Error')
                                };
                                adaptable.api.alertApi.displayAdaptableAlertNotification(alert);
                            });
                            return returnAction;
                        }
                    // Import 1. step
                    // prepare import of the given shared entity (the actual import is done in 'TEAMSHARING_PROCESS_IMPORT'):
                    // - all dependencies will be also included in the import bundle
                    // - if there is at least one local AdaptableObject which will be overwritten, display a confirmation pop
                    case $a6df66119ff073ff$export$9ce2368b2015d7d6:
                        {
                            let returnAction = next(action);
                            const actionTyped = action;
                            const [importStepActions, needsOverwriteConfirmation] = adaptable.api.internalApi.getTeamSharingService().buildSharedEntityImportActions(actionTyped.SharedEntity);
                            const processImportAction = $a6df66119ff073ff$export$6880fa4b5e419f6b(importStepActions);
                            if (needsOverwriteConfirmation && !adaptable.api.optionsApi.getTeamSharingOptions().suppressOverrideConfigWarning) {
                                let confirmation = {
                                    CancelButtonText: 'Cancel Import',
                                    Header: 'Overwrite Existing Item',
                                    Msg: 'This import will overwrite an existing item in your configuration. Do you wish to continue?',
                                    ConfirmButtonText: 'Import',
                                    CancelAction: null,
                                    ConfirmAction: processImportAction,
                                    ShowInputBox: false,
                                    MessageType: 'Warning'
                                };
                                adaptable.api.internalApi.showPopupConfirmation(confirmation);
                            } else middlewareAPI.dispatch(processImportAction);
                            return returnAction;
                        }
                    // Import 2. step
                    // import the actual AdaptableObjects (either create or update them)
                    case $a6df66119ff073ff$export$f13fba9da03b7b6a:
                        {
                            let returnAction = next(action);
                            const actionTyped = action;
                            const { ImportSteps: ImportSteps } = actionTyped;
                            const activeSharedEntities = [];
                            // iterate backwards to import the dependencies first
                            // it should work also the other way around, but nevertheless...
                            for(let i = ImportSteps.length - 1; i >= 0; i--){
                                const { sharedEntity: sharedEntity, importAction: importAction } = ImportSteps[i];
                                if (importAction) {
                                    middlewareAPI.dispatch(importAction);
                                    if (sharedEntity.Type === 'Active') activeSharedEntities.push(sharedEntity);
                                } else adaptable.api.logError('Team Sharing Import Error: Unknown item type', sharedEntity);
                            }
                            if (activeSharedEntities.length) middlewareAPI.dispatch($a6df66119ff073ff$export$87aee12c8a362f5d(...activeSharedEntities));
                            // mark the import process as ended after (we assume that) the import is finished
                            adaptable.api.teamSharingApi.internalApi.waitForTeamSharingImportEnd().then(()=>middlewareAPI.dispatch($a6df66119ff073ff$export$3393dff032b18693())).catch(()=>middlewareAPI.dispatch($a6df66119ff073ff$export$3393dff032b18693()));
                            const alert = {
                                alertType: 'generic',
                                header: 'Team Sharing',
                                message: 'Item imported successfully.',
                                alertDefinition: (0, $c94ad2cb10a8d2c3$export$7694cf1e73d40929).CreateInternalAlertDefinitionForMessages('Success')
                            };
                            adaptable.api.alertApi.displayAdaptableAlertNotification(alert);
                            return returnAction;
                        }
                    // update the active SharedEntity with the latest (updated) state of the local AdaptableObject
                    // - if the remote server already has a newer version of it, the update is skipped
                    case $a6df66119ff073ff$export$a59df55c0577dd8c:
                        {
                            const returnAction = next(action);
                            const actionTyped = action;
                            if (middlewareAPI.getState().TeamSharing.importProcessInProgress) // we are in the middle of an import process, we don't have to react to these object changes
                            return returnAction;
                            const { ChangedAdaptableObject: ChangedAdaptableObject, UserName: UserName } = actionTyped;
                            adaptable.api.teamSharingApi.loadSharedEntities().then((sharedEntities)=>{
                                const adaptableSharedEntities = sharedEntities.filter((0, $652f53856d8ee82a$export$e7cf26b8bffccd2a));
                                // check if remote server has a newer revision
                                const [localRevision, remoteRevision] = adaptable.api.internalApi.getTeamSharingService().getSharedEntityLocalAndRemoteRevisions(ChangedAdaptableObject.Uuid, adaptableSharedEntities);
                                if (remoteRevision > localRevision) // if remote has a newer version, we will NOT overwrite it
                                return;
                                const [updatedSharedEntities, newActiveEntities] = adaptable.api.internalApi.getTeamSharingService().updateActiveSharedEntity(ChangedAdaptableObject, UserName, adaptableSharedEntities);
                                middlewareAPI.dispatch($a6df66119ff073ff$export$87aee12c8a362f5d(...newActiveEntities));
                                middlewareAPI.dispatch($a6df66119ff073ff$export$76ebb6dc19c60348(updatedSharedEntities));
                                return adaptable.api.teamSharingApi.persistSharedEntities(updatedSharedEntities);
                            }).catch((error)=>{
                                adaptable.api.logError('TeamSharing update active item error : ' + error.message);
                                const alert = {
                                    alertType: 'generic',
                                    header: 'Team Sharing',
                                    message: 'Failed to update shared item: ' + error.message,
                                    alertDefinition: (0, $c94ad2cb10a8d2c3$export$7694cf1e73d40929).CreateInternalAlertDefinitionForMessages('Error')
                                };
                                adaptable.api.alertApi.displayAdaptableAlertNotification(alert);
                            });
                            return returnAction;
                        }
                    case $a6df66119ff073ff$export$bdb00257ffe7c123:
                        {
                            const returnAction = next(action);
                            adaptable.api.teamSharingApi.loadSharedEntities().then((sharedEntities)=>{
                                // update local state
                                middlewareAPI.dispatch($a6df66119ff073ff$export$76ebb6dc19c60348(sharedEntities));
                                adaptable.api.internalApi.getTeamSharingService().showUpdateNotifications();
                            }).catch((error)=>{
                                adaptable.api.logError('TeamSharing update error : ' + error.message);
                                const alert = {
                                    alertType: 'generic',
                                    header: 'Team Sharing',
                                    message: 'Failed to check for updates: ' + error.message,
                                    alertDefinition: (0, $c94ad2cb10a8d2c3$export$7694cf1e73d40929).CreateInternalAlertDefinitionForMessages('Error')
                                };
                                adaptable.api.alertApi.displayAdaptableAlertNotification(alert);
                            });
                            return returnAction;
                        }
                    /*******************
                 * POPUP (INTERNAL) ACTIONS
                 *******************/ case $dc56b6267ce4d0bb$export$5c7f6607ec0d5b0e:
                        (0, $372dcf2fc16be395$export$f6cef6fcf9ca4e17)({
                            api: adaptable.api,
                            adaptableAlert: action.alert
                        });
                        return next(action);
                    case $dc56b6267ce4d0bb$export$94afeca3afd2a2dd:
                        {
                            let promptConfirmationAction = middlewareAPI.getState().Popup.PromptPopup.ConfirmAction;
                            if (promptConfirmationAction) {
                                let inputText = action.InputText;
                                promptConfirmationAction.InputText = inputText;
                                middlewareAPI.dispatch(promptConfirmationAction);
                            }
                            return next(action);
                        }
                    case $dc56b6267ce4d0bb$export$29f8bf18949d1efd:
                        {
                            let confirmationAction = middlewareAPI.getState().Popup.ConfirmationPopup.ConfirmAction;
                            if (confirmationAction) middlewareAPI.dispatch(confirmationAction);
                            return next(action);
                        }
                    case $dc56b6267ce4d0bb$export$41a7351cd798b67f:
                        {
                            let cancelAction = middlewareAPI.getState().Popup.ConfirmationPopup.CancelAction;
                            if (cancelAction) middlewareAPI.dispatch(cancelAction);
                            return next(action);
                        }
                    /*******************
                 * MANAGING STATE ACTIONS
                 *******************/ case $5d2a87b18b3438b7$var$INIT_STATE:
                        {
                            let returnAction = next(action);
                            if (adaptable.isReady) // we need this here for when the state key is changed
                            // since we need the transient state to be restored in the same
                            // way as when Adaptable is initialised.
                            adaptable.ModuleService.createModuleUIItems();
                            return returnAction;
                        }
                    default:
                        return next(action);
                }
            };
        };
    };










var $9OAZF = parcelRequire("9OAZF");

const $83a964ed2bfe6165$export$f332236d816621e1 = (query)=>{
    return !!query.ObservableExpression;
};




var $9g4SS = parcelRequire("9g4SS");

const $d883e0ce3aff9068$export$c9a86c97b528ef9b = (value)=>{
    return typeof value.rowTrigger === 'string';
};
const $d883e0ce3aff9068$export$8e131da1934b98e3 = (value)=>{
    return !$d883e0ce3aff9068$export$c9a86c97b528ef9b(value);
};






var $9OAZF = parcelRequire("9OAZF");


class $ba74bcd35d4b59f8$export$199b81b38ffbfaf8 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getExpressionForAlertRule(alertRule) {
        var expression;
        expression = alertRule.BooleanExpression ? alertRule.BooleanExpression : alertRule.AggregatedBooleanExpression ? alertRule.AggregatedBooleanExpression : alertRule.ObservableExpression ? alertRule.ObservableExpression : undefined;
        return expression;
    }
    /**
     * Retrieves the Adaptable Form with the given name
     * @param name name of the Form
     */ getAdaptableFormByName(name) {
        const alertForms = this.getAlertOptions().alertForms || [];
        return alertForms.find((f)=>f.name === name)?.form;
    }
    /**
     * Retrieves all Alert Definitions in Alert State which are NOT Reactive (BooleanQuery)
     * @returns alert definitions
     */ getNonReactiveAlertDefinitions(config) {
        return this.getAlertApi().getAlertDefinitions(config).filter((alertDef)=>!(0, $83a964ed2bfe6165$export$f332236d816621e1)(alertDef.Rule));
    }
    /**
     * Retrieves all active (non-suspended) Alert Definitions in Alert State which are NOT Reactive (BooleanQuery)
     * @returns alert definitions
     */ getActiveNonReactiveAlertDefinitions(config) {
        return this.getNonReactiveAlertDefinitions(config).filter((alertDef)=>!alertDef.IsSuspended);
    }
    /**
     *
     * Retrieves all Alert Definitions in Alert State which are reactive (ObservableQuery & AggregationQuery)
     * @returns alert definitions
     */ getReactiveAlertDefinitions(config) {
        return this.getAlertApi().getAlertDefinitions(config).filter((alertDef)=>(0, $83a964ed2bfe6165$export$f332236d816621e1)(alertDef.Rule));
    }
    /**
     *
     * Retrieves all active (non-suspended) Alert Definitions in Alert State which are reactive (ObservableQuery & AggregationQuery)
     * @returns alert definitions
     */ getActiveReactiveAlertDefinitions() {
        return this.getReactiveAlertDefinitions().filter((alertDef)=>!alertDef.IsSuspended);
    }
    /**
     * Retrieves all Alert Definitions which prevent a Cell Edit
     * @returns alert definitions
     */ getAlertDefinitionsWithPreventEdit(config) {
        return this.getActiveNonReactiveAlertDefinitions(config).filter((a)=>a.AlertProperties != null && a.AlertProperties.PreventEdit === true);
    }
    /**
     * Retrieves all Alert Definitions which allow a Cell Edit
     *  @returns alert definitions
     */ getAlertDefinitionsWithAllowEdit(config) {
        return this.getActiveNonReactiveAlertDefinitions(config).filter((a)=>a.AlertProperties == null || a.AlertProperties.PreventEdit !== true);
    }
    /**
     * Runs after a button in an Alert Form is clicked
     */ executeAlertButton(button, context) {
        if (button.Command) {
            let commands = button.Command;
            if (typeof commands === 'function') {
                commands(context);
                return;
            }
            if (!Array.isArray(commands)) commands = [
                commands
            ];
            commands.forEach((command)=>{
                const buttonOnClick = this.getAlertOptions().commandHandlers?.find((x)=>x.name === command);
                buttonOnClick?.handler(button, context);
                this.executeAlertCommand(command, {
                    alertDefinition: context.alert.alertDefinition,
                    cellDataChangedInfo: (0, $f4d8c497686c0f4a$export$ad5de0913e0a99e1)(context.alert) ? context.alert.cellDataChangedInfo : null,
                    rowDataChangedInfo: (0, $f4d8c497686c0f4a$export$c51f434865bcd0f0)(context.alert) ? context.alert.rowDataChangedInfo : null,
                    formData: context.formData
                });
            });
        }
    }
    /**
     * Runs after an Alert Command is invoked
     * @param command Action which has been invoked
     * @param details Info about the Alert and Form
     */ executeAlertCommand(command, details) {
        const { alertDefinition: alertDefinition, cellDataChangedInfo: cellDataChangedInfo, rowDataChangedInfo: rowDataChangedInfo } = details;
        const getBackgroundColor = (alertDefinition)=>{
            const highlightType = alertDefinition.MessageType ?? 'Info';
            let backgroundColor = '';
            switch(highlightType){
                case 'Error':
                    backgroundColor = 'var(--ab-color-error)';
                    break;
                case 'Info':
                    backgroundColor = 'var(--ab-color-info)';
                    break;
                case 'Success':
                    backgroundColor = 'var(--ab-color-success)';
                    break;
                case 'Warning':
                    backgroundColor = 'var(--ab-color-warn)';
            }
            return backgroundColor;
        };
        if (command === 'highlight-cell' && cellDataChangedInfo) {
            const backgroundColor = getBackgroundColor(alertDefinition);
            this.getGridApi().highlightCell({
                columnId: cellDataChangedInfo.column.columnId,
                primaryKeyValue: cellDataChangedInfo.primaryKeyValue,
                highlightStyle: {
                    BackColor: backgroundColor
                },
                timeout: this.getAlertOptions().cellHighlightDuration
            });
        }
        if (command === 'highlight-row' && cellDataChangedInfo) {
            const rowsHighlightInfo = {
                primaryKeyValues: [
                    cellDataChangedInfo.primaryKeyValue
                ],
                highlightStyle: {
                    BackColor: getBackgroundColor(alertDefinition)
                },
                timeout: this.getAlertOptions().rowHighlightDuration
            };
            this.getGridApi().highlightRows(rowsHighlightInfo);
        }
        if (command === 'highlight-row' && rowDataChangedInfo && // no sense to highlight a deleted(non-existing) row
        rowDataChangedInfo?.rowTrigger !== 'Delete') {
            const primaryKeyValues = this.getGridApi().getPrimaryKeyValuesForRowNodes(rowDataChangedInfo.rowNodes);
            const rowsHighlightInfo = {
                primaryKeyValues: primaryKeyValues,
                highlightStyle: {
                    BackColor: getBackgroundColor(alertDefinition)
                },
                timeout: this.getAlertOptions().rowHighlightDuration
            };
            this.getGridApi().highlightRows(rowsHighlightInfo);
        }
        if (command === 'jump-to-cell' && cellDataChangedInfo) this.getGridApi().jumpToCell(cellDataChangedInfo.primaryKeyValue, cellDataChangedInfo.column.columnId, cellDataChangedInfo.rowNode);
        if (command === 'jump-to-row' && // either a cell change
        (cellDataChangedInfo || // or a grid change, but NOT row deletion
        rowDataChangedInfo && // no sense to jump to a deleted(non-existing) row
        rowDataChangedInfo?.rowTrigger !== 'Delete')) {
            const [firstRowNode] = cellDataChangedInfo ? [
                cellDataChangedInfo.rowNode
            ] : rowDataChangedInfo.rowNodes;
            const targetRowNodePrimaryKeyValue = this.getGridApi().getPrimaryKeyValueForRowNode(firstRowNode);
            if (targetRowNodePrimaryKeyValue) this.getGridApi().jumpToRow(targetRowNodePrimaryKeyValue);
        }
        if (command === 'jump-to-column' && cellDataChangedInfo) this.getGridApi().jumpToColumn(cellDataChangedInfo.column.columnId);
        if (command === 'suspend') this.getAlertApi().suspendAlertDefinition(alertDefinition);
        if (command === 'undo' && cellDataChangedInfo) this.getGridApi().undoCellEdit(cellDataChangedInfo);
    }
    /**
     * Retrieves all Predicate Defs that match given Scope
     * @param scope the Scope to check
     */ getAlertPredicateDefsForScope(scope) {
        return this.getPredicateApi().internalApi.getAlertPredicateDefs(scope).filter((predicateDef)=>this.getColumnScopeApi().isScopeInScope(scope, predicateDef.columnScope));
    }
    /**
     * Returns a description of an Alert Definition
     * @param alertDefinition Alert Definition to use
     */ getAlertDescriptionForDataChange(alertDefinition, cellDataChangedInfo) {
        let customMessage = this.getCustomAlertDescription(alertDefinition, {
            cellDataChangedInfo: cellDataChangedInfo
        });
        const anotationContext = cellDataChangedInfo ? {
            column: cellDataChangedInfo.column,
            rowNode: cellDataChangedInfo.rowNode,
            oldValue: cellDataChangedInfo.oldValue,
            newValue: cellDataChangedInfo.newValue,
            primaryKeyValue: cellDataChangedInfo.primaryKeyValue,
            timestamp: cellDataChangedInfo.changedAt,
            trigger: cellDataChangedInfo.trigger
        } : {};
        if (customMessage) {
            customMessage = cellDataChangedInfo ? this.annotateAlertText(customMessage, anotationContext) : customMessage;
            return customMessage;
        }
        if (alertDefinition.MessageText != null) {
            let alertText = alertDefinition.MessageText;
            try {
                alertText = cellDataChangedInfo ? this.annotateAlertText(alertText, anotationContext) : alertText;
                return alertText;
            } catch (e) {
                this.logError('Error in getAlertMessageHeader', e);
            }
        }
        let scopeDescription = this.getColumnScopeApi().getScopeDescription(alertDefinition.Scope);
        let ruleDescription = this.getAlertRuleDescription(alertDefinition);
        return scopeDescription + ' - ' + ruleDescription;
    }
    /**
     * Returns a description title of an Alert Definition
     * @param alertDefinition Alert Definition to use
     */ getAlertMessageHeaderForDataChange(alertDefinition, cellDataChangedInfo) {
        const anotationContext = cellDataChangedInfo ? {
            column: cellDataChangedInfo.column,
            rowNode: cellDataChangedInfo.rowNode,
            oldValue: cellDataChangedInfo.oldValue,
            newValue: cellDataChangedInfo.newValue,
            primaryKeyValue: cellDataChangedInfo.primaryKeyValue,
            timestamp: cellDataChangedInfo.changedAt,
            trigger: cellDataChangedInfo.trigger
        } : {};
        let message = this.getCustomAlertMessageHeader(alertDefinition, {
            cellDataChangedInfo: cellDataChangedInfo
        }) ?? cellDataChangedInfo?.column?.friendlyName;
        try {
            message = cellDataChangedInfo ? this.annotateAlertText(message, anotationContext) : message;
        } catch (e) {
            this.logError('Error in getAlertMessageHeader', e);
        }
        return message;
    }
    getAlertMessageForRowDataChange(alertDefinition, rowDataChangedInfo) {
        const rowAdded = rowDataChangedInfo.rowTrigger === 'Add';
        const numberOfChangedRows = rowDataChangedInfo.rowNodes.length;
        const actionName = rowAdded ? 'Added' : 'Removed';
        const defaultMessage = numberOfChangedRows > 1 ? `${numberOfChangedRows} rows were ${actionName.toLowerCase()}` : `${numberOfChangedRows} row was ${actionName.toLowerCase()}`;
        const customMessage = this.getCustomAlertDescription(alertDefinition, {
            rowDataChangedInfo: rowDataChangedInfo
        });
        let alertMessage = alertDefinition.MessageText ? alertDefinition.MessageText : customMessage ?? defaultMessage;
        try {
            alertMessage = this.annotateAlertText(alertMessage, {
                numberOfRows: numberOfChangedRows,
                timestamp: rowDataChangedInfo.changedAt,
                trigger: rowDataChangedInfo.rowTrigger
            });
        } catch (e) {
            this.logError('Error in getAlertMessageForRowDataChange', e);
        }
        return alertMessage;
    }
    getAlertHeaderForRowDataChange(alertDefinition, rowDataChangedInfo) {
        const rowAdded = rowDataChangedInfo.rowTrigger === 'Add';
        const numberOfChangedRows = rowDataChangedInfo.rowNodes.length;
        const actionName = rowAdded ? 'Added' : 'Removed';
        const customHeader = this.getCustomAlertMessageHeader(alertDefinition, {
            rowDataChangedInfo: rowDataChangedInfo
        });
        const alertHeader = numberOfChangedRows > 1 ? `${actionName} Rows` : `${actionName} Row `;
        let header = customHeader ?? alertHeader;
        try {
            header = this.annotateAlertText(header, {
                numberOfRows: numberOfChangedRows,
                timestamp: rowDataChangedInfo.changedAt,
                trigger: rowDataChangedInfo.rowTrigger
            });
        } catch (e) {
            this.logError('Error in getAlertHeaderForRowDataChange', e);
        }
        return header;
    }
    /**
     * Returns custom description for alert using the 'alertMessageText' property
     *
     * @param alertDefinition Alert Definition to use
     * @param dataChangedInfo data change info, it can be eighter grid or cell data chantged info
     */ getCustomAlertDescription(alertDefinition, dataChangedInfo) {
        const alertMessageFunction = this.getAlertOptions()?.alertMessageText;
        if (alertMessageFunction) {
            const alertMessageContext = {
                alertDefinition: alertDefinition,
                cellDataChangedInfo: dataChangedInfo.cellDataChangedInfo,
                rowDataChangedInfo: dataChangedInfo.rowDataChangedInfo
            };
            const returnText = alertMessageFunction(alertMessageContext);
            if (returnText) return returnText;
        }
        return null;
    }
    /**
     * Returns custom title defined by 'alertMessageHeader' property
     * @param alertDefinition Alert Definition to use
     * @param dataChangedInfo Data change info, it can be eighter grid or cell data chantged info
     */ getCustomAlertMessageHeader(alertDefinition, dataChangedInfo) {
        const alertMessageFunction = this.getAlertOptions()?.alertMessageHeader;
        if (alertMessageFunction) {
            const returnText = alertMessageFunction({
                alertDefinition: alertDefinition,
                cellDataChangedInfo: dataChangedInfo?.cellDataChangedInfo,
                rowDataChangedInfo: dataChangedInfo?.rowDataChangedInfo
            });
            if (returnText) return returnText;
        }
        if (alertDefinition.MessageHeader) return alertDefinition.MessageHeader;
        return null;
    }
    /**
     * Returns a description of an Alert Definition's Rule
     * @param alertDefinition Alert Definition to use
     */ getAlertRuleDescription(alertDefinition) {
        let ruleDescription = alertDefinition.Rule?.Predicates?.length ? alertDefinition.Rule?.Predicates?.map((predicate)=>this.getPredicateApi().predicateToString(predicate)).join(' AND ') : this.getAdaptableInternalApi().getAdaptableQueryExpressionText(alertDefinition.Rule);
        return ruleDescription;
    }
    /**
     * Was Adaptable Alert fired due to a Cell Change
     * @param alert AdaptableAlert to check
     */ isCellChangedAdaptableAlert(alert) {
        return alert.alertType === 'cellChanged';
    }
    /**
     * Was Adaptable Alert fired due to a Row Change
     * @param alert AdaptableAlert to check
     */ isRowChangedAdaptableAlert(alert) {
        return alert.alertType === 'rowChanged';
    }
    /**
     * Is Adaptable Alert a Generic one
     * @param alert AdaptableAlert to check
     */ isGenericAdaptableAlert(alert) {
        return alert.alertType === 'generic';
    }
    /**
     * Returns for the Alert Type for an Adaptable Alert
     * @param alert AdaptableAlert to check
     */ getAlertTypeForAdaptableAlert(alert) {
        return alert.alertType;
    }
    getAdaptableFormFromAlertForm(alertForm, context, defaultMessageType) {
        let adaptableAlertForm;
        let isActionForm = false;
        if (typeof alertForm === 'string') {
            const alertForms = this.getAlertOptions().alertForms || [];
            adaptableAlertForm = alertForms.find((f)=>f.name === alertForm)?.form;
        } else {
            adaptableAlertForm = {
                ...alertForm,
                buttons: (alertForm.Buttons || []).map((alertButton)=>{
                    return {
                        ...alertButton,
                        onClick: ()=>{
                            this.executeAlertButton(alertButton, context);
                        }
                    };
                })
            };
            isActionForm = true;
        }
        if (!adaptableAlertForm) return;
        if (adaptableAlertForm && adaptableAlertForm.buttons) {
            // dont mutate the form, but clone it
            adaptableAlertForm = {
                ...adaptableAlertForm
            };
            adaptableAlertForm.buttons = adaptableAlertForm.buttons?.map((button)=>{
                let buttonStyle = isActionForm ? button.ButtonStyle : this.getAdaptableInternalApi().getStyleForButton(button, context);
                if (defaultMessageType && !buttonStyle?.tone) // force the button tone to be the alert tone, if the tone is missing from button style (or button style non-existent)
                buttonStyle = {
                    ...buttonStyle,
                    tone: defaultMessageType.toLowerCase()
                };
                let label = isActionForm ? button.Label : this.getAdaptableInternalApi().getLabelForButton(button, context);
                return {
                    ...button,
                    buttonStyle: buttonStyle,
                    label: label
                };
            });
        }
        return adaptableAlertForm;
    }
    clearAdaptableAlerts() {
        this.dispatchAction($5b564bb703f29152$export$1fa9ee6ea5769397([]));
    }
    getAdaptableAlerts() {
        return this.getAdaptableState().Internal.AdaptableAlerts ?? [];
    }
    getAdaptableCellChangedAlerts() {
        return this.getAdaptableAlerts().filter((0, $f4d8c497686c0f4a$export$ad5de0913e0a99e1));
    }
    getAdaptableRowChangedAlerts() {
        return this.getAdaptableAlerts().filter((0, $f4d8c497686c0f4a$export$c51f434865bcd0f0));
    }
    getAdaptableAlertWithHighlightCell(columnId, rowNode) {
        // only alerts triggered by cell changes are relevant for HighlightCell actions
        return this.getAdaptableCellChangedAlerts().find((alert)=>alert.alertDefinition.AlertProperties?.HighlightCell && alert.cellDataChangedInfo?.column?.columnId === columnId && alert.cellDataChangedInfo?.rowNode === rowNode);
    }
    getAdaptableAlertWithHighlightRow(rowNode) {
        let alertWithRowHighlight;
        alertWithRowHighlight = this.getAdaptableRowChangedAlerts().find((alert)=>{
            if (alert.alertDefinition.AlertProperties?.HighlightRow) {
                if (alert.rowDataChangedInfo?.rowNodes.map((rowNode)=>rowNode.id).includes(rowNode.id)) return alert;
            }
        });
        if (alertWithRowHighlight) return alertWithRowHighlight;
        alertWithRowHighlight = this.getAdaptableCellChangedAlerts().find((alert)=>{
            if (alert.alertDefinition.AlertProperties?.HighlightRow) {
                if (alert.cellDataChangedInfo?.rowNode.id == rowNode.id) return alert;
            }
        });
        return alertWithRowHighlight;
    }
    isAlertDefinitionForAddedRowChangeEvent(alertDefinition) {
        const observableExpression = alertDefinition?.Rule?.ObservableExpression;
        if ((0, $9OAZF.default).IsNotNullOrEmpty(observableExpression)) return observableExpression.includes((0, $58846ea7f4156db7$export$91649df232e67626));
        return false;
    }
    isAlertDefinitionForRemovedRowChangeEvent(alertDefinition) {
        const observableExpression = alertDefinition?.Rule?.ObservableExpression;
        if ((0, $9OAZF.default).IsNotNullOrEmpty(observableExpression)) return observableExpression.includes((0, $58846ea7f4156db7$export$b6627549cf8ad25d));
        return false;
    }
    setUpReactiveAlerts() {
        const reactiveAlertDefinitions = this.getActiveReactiveAlertDefinitions();
        reactiveAlertDefinitions.forEach((reactiveAlertDefinition)=>this.getAdaptableInternalApi().getAlertService().createReactiveAlert(reactiveAlertDefinition));
    }
    getAlertDefinitionsForCellDataChange(dataChangedEvent) {
        const allActiveNonReactiveDefinitions = this.getActiveNonReactiveAlertDefinitions();
        let relatedAlertDefinitions = allActiveNonReactiveDefinitions.filter((v)=>this.getColumnScopeApi().isColumnInScope(dataChangedEvent.column, v.Scope)).filter((alertDefinition)=>!(0, $83a964ed2bfe6165$export$f332236d816621e1)(alertDefinition.Rule));
        let triggeredAlerts = [];
        if ((0, $9g4SS.default).IsNotNullOrEmpty(relatedAlertDefinitions)) relatedAlertDefinitions.forEach((alertDefinition)=>{
            if (alertDefinition.Rule.BooleanExpression) {
                let expression = alertDefinition.Rule.BooleanExpression;
                let rowNode = dataChangedEvent.rowNode;
                if (!rowNode) rowNode = this.getGridApi().getRowNodeForPrimaryKey(dataChangedEvent.primaryKeyValue);
                const isValidExpression = this.getExpressionApi().isValidBooleanExpression(expression, 'Alert', `Invalid Alert boolean expression '${expression}'`);
                let isSatisfiedExpression = false;
                try {
                    isSatisfiedExpression = isValidExpression && this.getAdaptableApi().internalApi.getQueryLanguageService().evaluateBooleanExpression(expression, 'Alert', rowNode, {
                        dataChangedEvent: dataChangedEvent
                    });
                } catch (error) {
                    isSatisfiedExpression = false;
                    (0, $10f858c943b30cc8$export$45c997b35cb132f6)(error.message);
                }
                if (isSatisfiedExpression) triggeredAlerts.push(alertDefinition);
            } else if (alertDefinition.Rule.AggregatedBooleanExpression) {
                const isValidExpression = this.getExpressionApi().isValidAggregatedBooleanExpression(alertDefinition.Rule.AggregatedBooleanExpression, 'Alert', `Invalid Alert boolean expression '${alertDefinition.Rule.AggregatedBooleanExpression}'`);
                const isSatisfiedExpression = isValidExpression && this.isAggregationAlertTriggered(alertDefinition, dataChangedEvent);
                if (isSatisfiedExpression) triggeredAlerts.push(alertDefinition);
            } else if (!this.isAlertDefinitionForRowChangeEvent(alertDefinition) && this.isAlertPredicateTriggered(alertDefinition, dataChangedEvent)) triggeredAlerts.push(alertDefinition);
        });
        return triggeredAlerts;
    }
    isAggregationAlertTriggered(alertDefinition, dataChangedEvent) {
        const changedColumn = dataChangedEvent.column.columnId;
        const expressionAggregationColumns = this.getExpressionApi().getColumnsFromExpression(alertDefinition.Rule.AggregatedBooleanExpression);
        if (!expressionAggregationColumns.includes(changedColumn)) return false;
        const aggregatedBooleanValue = this.getAdaptableInternalApi().getQueryLanguageService().computeAggregatedBooleanValue(alertDefinition.Rule.AggregatedBooleanExpression, (0, $42e863194fcb493f$export$40024cb74c2bb550));
        return aggregatedBooleanValue;
    }
    isAlertPredicateTriggered(alert, dataChangedEvent, defaultNoPredicateReturn = false) {
        const predicateDefHandlerContext = {
            value: dataChangedEvent.newValue,
            oldValue: dataChangedEvent.oldValue,
            rawValue: dataChangedEvent.newValue,
            displayValue: dataChangedEvent.newValue,
            node: dataChangedEvent.rowNode,
            column: dataChangedEvent.column,
            ...this.getAdaptableInternalApi().buildBaseContext()
        };
        return this.getPredicateApi().handleColumnPredicates(alert.Rule?.Predicates, predicateDefHandlerContext, defaultNoPredicateReturn);
    }
    isAlertDefinitionForRowChangeEvent(alertDefinition) {
        return this.isAlertDefinitionForAddedRowChangeEvent(alertDefinition) || this.isAlertDefinitionForRemovedRowChangeEvent(alertDefinition);
    }
    showAlertForDefinitions(dataChangedInfo, alertDefinitions = []) {
        if ((0, $d883e0ce3aff9068$export$8e131da1934b98e3)(dataChangedInfo)) alertDefinitions.forEach((alertDefinition)=>{
            if (this.shouldFireAlertOnClient(alertDefinition)) {
                const alert = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateCellChangedAlert(this.getAlertMessageHeaderForDataChange(alertDefinition, dataChangedInfo), this.getAlertDescriptionForDataChange(alertDefinition, dataChangedInfo), alertDefinition, dataChangedInfo);
                this.getAlertApi().displayAdaptableAlert(alert);
            }
        });
        else this.showAlertsForRowDataChanges(dataChangedInfo, alertDefinitions);
    }
    showAlertsForRowDataChanges(rowDataChangedInfo, alertDefinitions) {
        alertDefinitions?.forEach((alertDefinition)=>{
            if (this.shouldFireAlertOnClient(alertDefinition)) {
                const alert = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateRowChangedAlert(this.getAlertHeaderForRowDataChange(alertDefinition, rowDataChangedInfo), this.getAlertMessageForRowDataChange(alertDefinition, rowDataChangedInfo), alertDefinition, rowDataChangedInfo);
                this.getAlertApi().displayAdaptableAlert(alert);
            }
        });
    }
    shouldFireAlertOnClient(alertDefinition) {
        const rule = alertDefinition.Rule;
        if (rule) {
            if (rule.Predicates) return this.getExpressionApi().internalApi.shouldEvaluatePredicatesInAdaptableQL('Alert', alertDefinition, alertDefinition.Rule.Predicates);
            else {
                var expression = this.getExpressionForAlertRule(rule);
                return this.getExpressionApi().internalApi.evaluateExpressionInAdaptableQL('Alert', alertDefinition, expression);
            }
        }
        return true;
    }
    getDefaultAlertNotificationForm() {
        // we still need the default Notification Form  for historical reasons
        // (i.e. to be able to display the AlertForm with the default buttons when the user has not defined any buttons)
        return {
            fields: [],
            Buttons: [
                this.getDefaultButton()
            ]
        };
    }
    getDefaultButton() {
        return {
            Label: 'OK',
            ButtonStyle: {
                variant: 'raised'
            }
        };
    }
    /**
     * Supported tokens:
     * - column-that-changed-name -> [column]
     * - rowData.newValue -> [rowData.newValue]
     * - rowData.oldValue -> [rowData.oldValue]
     * - primaryKey -> [primaryKeyValue]
     * - timestamp -> [timestamp]
     * - trigger -> [trigger]
     */ annotateAlertText(text, context) {
        if (!text) return text;
        if (!context) return text;
        if (context?.newValue) text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, '[newValue]', context.newValue);
        if (context?.oldValue) text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, '[oldValue]', context.oldValue);
        if (context?.primaryKeyValue) text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, '[primaryKeyValue]', context.primaryKeyValue);
        if (context?.timestamp) text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, '[timestamp]', context.timestamp + '');
        if (context?.numberOfRows) text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, '[numberOfRows]', context.numberOfRows + '');
        if (context?.trigger) {
            const dataChangeTriggerMap = {
                edit: 'Edit',
                tick: 'Tick',
                undo: 'Undo',
                aggChange: 'AggChange'
            };
            const rowChangeTriggerMap = {
                Add: 'Added',
                Edit: 'Edited',
                Delete: 'Deleted',
                Load: 'Loaded'
            };
            const mappedTrigger = // @ts-ignore
            (dataChangeTriggerMap[context.trigger] || rowChangeTriggerMap[context.trigger]) ?? context.trigger;
            text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, '[trigger]', mappedTrigger);
        }
        if (context?.column) text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, '[column]', this.getColumnApi().getFriendlyNameForColumnId(context.column.columnId));
        if (context?.rowNode) {
            const columns = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).extractColsFromText(text);
            for (const column of columns)if (this.getColumnApi().getColumnWithColumnId(column)) text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, `[rowData.${column}]`, this.getGridApi().getRawValueFromRowNode(context.rowNode, column));
        }
        if (text.indexOf('[context') !== -1) {
            const agGridContext = this.getAdaptableInternalApi().getAgGridAdapter().getGridOption?.('context');
            const agGridContextKeys = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).extractContextKeysFromText(text);
            for (const key of agGridContextKeys)if (agGridContext[key]) text = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).replaceAll(text, `[context.${key}]`, agGridContext[key]);
        }
        return text;
    }
}



var $9AsCL = parcelRequire("9AsCL");
class $cca338f4714182be$export$1b944a52396315fe extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $ba74bcd35d4b59f8$export$199b81b38ffbfaf8)(_adaptable);
    }
    getAlertState() {
        return this.getAdaptableState().Alert;
    }
    getAlertDefinitions(config) {
        return this.handleLayoutExtensionObjects(this.getAlertState().AlertDefinitions, 'Alert', config) ?? [];
    }
    getSuspendedAlertDefinitions(config) {
        return this.getAlertDefinitions(config).filter((alertDefinition)=>alertDefinition.IsSuspended);
    }
    getActiveAlertDefinitions(config) {
        return this.getAlertDefinitions(config).filter((alertDefinition)=>!alertDefinition.IsSuspended);
    }
    deleteAlertDefinition(alertDefinition) {
        this.dispatchAction($0040cfd693076bab$export$fd2daac714b8b6d3(alertDefinition));
    }
    getAlertDefinitionById(id, config) {
        return this.getAlertDefinitions(config).find((alert)=>alert?.Uuid === id);
    }
    getAlertDefinitionByName(name) {
        return this.getAlertDefinitions().find((alertDefinition)=>alertDefinition.Name === name);
    }
    addAlertDefinition(alertDefinition) {
        this.addUidToAdaptableObject(alertDefinition);
        this.dispatchAction($0040cfd693076bab$export$48fb1d70acb0b9bf(alertDefinition));
        return this.getAlertDefinitionById(alertDefinition.Uuid);
    }
    async displayAdaptableAlert(alertToShow) {
        // There are 3 things we always do with an alert:
        // 1. Dispatch the Alert (so it appears in the toolbar)
        this.addUidToAdaptableObject(alertToShow);
        this.dispatchAction($5b564bb703f29152$export$634c589236159d8d(alertToShow, this.getAlertOptions().maxAlertsInStore));
        // 2. Publish the Alert Fired Event
        this.getEventApi().internalApi.fireAlertFiredEvent(alertToShow);
        // 3. Manage the many different possible Alert behaviours
        // Note:  alertProperties.PreventEdit is handled separately, in the Adaptable.setupColumnValueSetter() function
        if (alertToShow.alertDefinition && alertToShow.alertDefinition.AlertProperties != undefined) {
            const alertDefinition = alertToShow.alertDefinition;
            const alertProperties = alertDefinition.AlertProperties;
            // Show a Toast Popup
            if (alertProperties.DisplayNotification) this.displayAdaptableAlertNotification(alertToShow);
            // Log to console
            if (alertProperties.LogToConsole) this.getAdatableLogger().consoleLogByMessageType(alertToShow.header + ': ' + alertToShow.message, alertDefinition.MessageType);
            // Show Alert in a Div (if one has been set)
            if (alertProperties.ShowInDiv) {
                const alertDiv = (0, $9AsCL.resolveContainerElement)(this.getContainerOptions().alertContainer, this.getAdaptableInternalApi().buildBaseContext());
                if (alertDiv) {
                    let alertString = alertToShow.header + ': ' + alertToShow.message;
                    alertDiv.innerHTML = alertString;
                }
            }
            // Jump to the Cell
            if (alertProperties.JumpToCell && (0, $f4d8c497686c0f4a$export$ad5de0913e0a99e1)(alertToShow) && alertToShow.cellDataChangedInfo) this.getGridApi().jumpToCell(alertToShow.cellDataChangedInfo.primaryKeyValue, alertToShow.cellDataChangedInfo.column.columnId, alertToShow.cellDataChangedInfo.rowNode);
            else if (alertProperties.JumpToRow && (0, $f4d8c497686c0f4a$export$c51f434865bcd0f0)(alertToShow) && alertToShow.rowDataChangedInfo?.rowTrigger === 'Add') {
                const [firstRowNode] = alertToShow.rowDataChangedInfo.rowNodes;
                if (firstRowNode) this.getGridApi().jumpToRow(firstRowNode);
            }
            // For CellChanged Alerts either Highlight the cell or row
            // for former - we just refresh the cells to trigger a re-evaluation of the Adaptable.setupColumn[Style/Class]
            if ((0, $f4d8c497686c0f4a$export$ad5de0913e0a99e1)(alertToShow) && alertToShow.cellDataChangedInfo && (alertProperties.HighlightCell || alertProperties.HighlightRow)) {
                let alertNode = alertToShow.cellDataChangedInfo.rowNode;
                if (!alertNode) alertNode = this.getGridApi().getRowNodeForPrimaryKey(alertToShow.cellDataChangedInfo.primaryKeyValue);
                if (alertNode) {
                    if (alertProperties.HighlightRow) {
                        this.getGridApi().refreshRowNodes([
                            alertNode
                        ]);
                        setTimeout(()=>{
                            this.dispatchAction($5b564bb703f29152$export$8f566c85fa9bb2a6(alertToShow));
                        }, this.getAlertOptions().rowHighlightDuration);
                    }
                    if (alertProperties.HighlightCell) {
                        this.getGridApi().refreshCell(alertNode, alertToShow.cellDataChangedInfo.column.columnId);
                        setTimeout(()=>{
                            this.dispatchAction($5b564bb703f29152$export$a6d15cc74230bc85(alertToShow));
                        }, this.getAlertOptions().cellHighlightDuration);
                    }
                }
            } else if (alertProperties.HighlightRow && (0, $f4d8c497686c0f4a$export$c51f434865bcd0f0)(alertToShow) && alertToShow.rowDataChangedInfo?.rowTrigger === 'Add') {
                this.getGridApi().refreshRowNodes(alertToShow.rowDataChangedInfo.rowNodes);
                setTimeout(()=>{
                    this.dispatchAction($5b564bb703f29152$export$8f566c85fa9bb2a6(alertToShow));
                }, this.getAlertOptions().rowHighlightDuration);
            }
        }
    }
    displayAdaptableAlertNotification(alert) {
        this.dispatchAction($dc56b6267ce4d0bb$export$1f102b51d7fb4f69(alert));
    }
    async showAlert(alertHeader, alertMessage, messageType, alertProperties) {
        const alertDefinition = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages(messageType, alertProperties);
        let alertToShow = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateGenericAlert(alertHeader, alertMessage, alertDefinition);
        await this.displayAdaptableAlert(alertToShow);
    }
    async showAlertInfo(alertHeader, alertMessage, alertProperties) {
        await this.showAlert(alertHeader, alertMessage, 'Info', alertProperties);
    }
    async showAlertSuccess(alertHeader, alertMessage, alertProperties) {
        await this.showAlert(alertHeader, alertMessage, 'Success', alertProperties);
    }
    async showAlertWarning(alertHeader, alertMessage, alertProperties) {
        await this.showAlert(alertHeader, alertMessage, 'Warning', alertProperties);
    }
    async showAlertError(alertHeader, alertMessage, alertProperties) {
        await this.showAlert(alertHeader, alertMessage, 'Error', alertProperties);
    }
    openAlertSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$40024cb74c2bb550);
    }
    editAlertDefinition(alertDefinition) {
        this.dispatchAction($0040cfd693076bab$export$5616824fed3efc2a(alertDefinition));
        return this.getAlertDefinitionById(alertDefinition.Uuid);
    }
    suspendAlertDefinition(alertDefinition) {
        this.dispatchAction($0040cfd693076bab$export$75e27fe48d2e10dd(alertDefinition));
        return this.getAlertDefinitionById(alertDefinition.Uuid);
    }
    suspendAllAlertDefinition() {
        this.dispatchAction($0040cfd693076bab$export$1346cde2393e56e2());
    }
    unSuspendAllAlertDefinition() {
        this.dispatchAction($0040cfd693076bab$export$b84c6136fd7a4982());
    }
    unSuspendAlertDefinition(alertDefinition) {
        this.dispatchAction($0040cfd693076bab$export$c6368f11ad411cd3(alertDefinition));
        return this.getAlertDefinitionById(alertDefinition.Uuid);
    }
    evaluateAlertDefinitions(alertDefinitions) {
        const filterScopeAllDefinitions = (alertDefinition)=>{
            if (this.getColumnScopeApi().scopeIsAll(alertDefinition.Scope) && !this.getExpressionApi().getAdaptableQueryExpression(alertDefinition.Rule)) // we don't support scope ALL without an expression
            // the predicates for scope ALL do NOT make any sense for a programmatic evaluation
            return false;
            return true;
        };
        const relevantAlertDefinitions = alertDefinitions.filter((alertDefinition)=>filterScopeAllDefinitions(alertDefinition));
        const relevantColumnIds = new Set();
        relevantAlertDefinitions.forEach((alertDefinition)=>{
            this.getRelevantColumnIdsForAlertDefinition(alertDefinition).forEach((relevantColumnId)=>relevantColumnIds.add(relevantColumnId));
        });
        if (!relevantColumnIds.size) return;
        const cellDataChangedInfos = this.createCellDataChangeInfoStubs(Array.from(relevantColumnIds));
        cellDataChangedInfos.forEach((cellDataChangedInfo)=>{
            const alertDefinitions = this.internalApi.getAlertDefinitionsForCellDataChange(cellDataChangedInfo).filter((alertDefinition)=>filterScopeAllDefinitions(alertDefinition))// some alert definitions might NOT be relevant for the given locator
            .filter((alertDefinition)=>relevantAlertDefinitions.some((relevantAlertDefinition)=>relevantAlertDefinition.Uuid === alertDefinition.Uuid));
            this.getAlertApi().internalApi.showAlertForDefinitions(cellDataChangedInfo, alertDefinitions);
        });
    }
    findAlertDefinitions(criteria) {
        const config = {
            includeLayoutNotExtendedObjects: true
        };
        return this.getAdaptableInternalApi().findAdaptableObjectsByLookupCriteria(criteria, this.getAlertDefinitions(config));
    }
    getRelevantColumnIdsForAlertDefinition(alertDefinition) {
        //  if there is an Expression defined, extract only the columns from there (in that case the Scope would be 'All' anyway)
        // columns referenced in rule expression
        const ruleExpression = this.getExpressionApi().getAdaptableQueryExpression(alertDefinition.Rule);
        if (this.getColumnScopeApi().scopeIsAll(alertDefinition.Scope) && (0, $9OAZF.default).IsNotNullOrEmpty(ruleExpression)) {
            // return only first referenced column (otherwise we would generate multiple alerts for the same row)
            const queryColumns = this.getAdaptableInternalApi().getQueryLanguageService().getColumnsFromExpression(ruleExpression);
            return queryColumns.length > 0 ? [
                queryColumns[0]
            ] : [];
        } else // otherwise return all columns for given scope
        return this.getColumnScopeApi().getColumnsInScope(alertDefinition.Scope).map((adaptableColumn)=>adaptableColumn.columnId);
    }
    createCellDataChangeInfoStubs(relevantColumnIds) {
        const cellDataChangeInfos = [];
        //const adaptable: IAdaptable = this.getAdaptableInternalApi().getAdaptableInstance();
        const relevantColumns = this.getColumnApi().getColumnsWithColumnIds(relevantColumnIds).filter(Boolean);
        const changedAt = Date.now();
        this.getAdaptableInternalApi().forAllRowNodesDo((rowNode)=>{
            relevantColumns.forEach((column)=>{
                const cellDataChangeInfoStub = {
                    changedAt: changedAt,
                    rowNode: rowNode,
                    column: column,
                    rowData: rowNode.data,
                    oldValue: null,
                    newValue: this.getGridApi().getRawValueFromRowNode(rowNode, column.columnId),
                    primaryKeyValue: this.getGridApi().getPrimaryKeyValueForRowNode(rowNode)
                };
                cellDataChangeInfos.push(cellDataChangeInfoStub);
            });
        });
        return cellDataChangeInfos;
    }
}




class $468a3cf3cee6b319$export$c47e5ee10600a731 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getAdaptableStatusBars() {
        return (0, $264a0e58163aefb1$export$f3a658bc32c51d73)(this.getAdaptableState());
    }
    getAgGridStatusPanels() {
        return this._adaptable.getAgGridStatusPanels();
    }
    setStatusBarPanels(statusPanels) {
        this.dispatchAction((0, $264a0e58163aefb1$export$f43bbf39b910281)(statusPanels));
    }
}




var $9g4SS = parcelRequire("9g4SS");

var $9OAZF = parcelRequire("9OAZF");

class $336902fe882a3b1a$export$f09b3c9a83dae8e2 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    IsInOrNotInPredicate(predicate) {
        return predicate?.PredicateId === 'In' || predicate?.PredicateId === 'NotIn';
    }
    IsInOrNotInPredicateDef(predicateDef) {
        return predicateDef && [
            'In',
            'NotIn'
        ].includes(predicateDef.id);
    }
    /**
     * Get all Filter Predicate Definitions - System and Custom
     */ getFilterPredicateDefs(scope) {
        return this.mergeSystemAndCustomPredicates(this.getSystemFilterPredicateIds(scope)?.map((predicateId)=>this.getPredicateApi().getPredicateDefById(predicateId)), this.getPredicateApi().getCustomPredicateDefs()).filter((predicateDef)=>predicateDef.moduleScope.includes('columnFilter'));
    }
    shouldUseCaseSensitivePredicates(column) {
        const caseSensitivePredicates = this.getPredicateOptions().caseSensitivePredicates;
        if (typeof caseSensitivePredicates === 'function') return caseSensitivePredicates(this.getAdaptableInternalApi().buildAdaptableColumnContext(column));
        return caseSensitivePredicates;
    }
    shouldEvaluateInPredicateUsingTime(column) {
        const evaluateInPredicateUsingTime = this.getPredicateOptions().evaluateInPredicateUsingTime;
        if (typeof evaluateInPredicateUsingTime === 'function') return evaluateInPredicateUsingTime(this.getAdaptableInternalApi().buildAdaptableColumnContext(column));
        return evaluateInPredicateUsingTime;
    }
    getSystemFilterPredicateIds(scope) {
        const systemFilterPredicates = this.getPredicateOptions().systemFilterPredicates;
        if (typeof systemFilterPredicates === 'function') {
            const systemPredicateContext = {
                ...this.getAdaptableInternalApi().buildBaseContext(),
                systemPredicateDefs: this.getPredicateApi().getSystemPredicateDefsByModuleScope('columnFilter'),
                moduleScope: 'columnFilter',
                columnScope: scope
            };
            return systemFilterPredicates(systemPredicateContext);
        }
        return systemFilterPredicates;
    }
    /**
     * Get all Alert Predicate Definitions - System and Custom
     */ getAlertPredicateDefs(scope) {
        return this.mergeSystemAndCustomPredicates(this.getSystemAlertPredicateIds(scope)?.map((predicateId)=>this.getPredicateApi().getPredicateDefById(predicateId)), this.getPredicateApi().getCustomPredicateDefs()).filter((predicateDef)=>predicateDef.moduleScope.includes('alert'));
    }
    getSystemAlertPredicateIds(scope) {
        const systemAlertPredicates = this.getPredicateOptions().systemAlertPredicates;
        if (typeof systemAlertPredicates === 'function') {
            const systemPredicateContext = {
                ...this.getAdaptableInternalApi().buildBaseContext(),
                systemPredicateDefs: this.getPredicateApi().getSystemPredicateDefsByModuleScope('alert'),
                moduleScope: 'alert',
                columnScope: scope
            };
            return systemAlertPredicates(systemPredicateContext);
        }
        return systemAlertPredicates;
    }
    getSystemBadgeStylePredicateIds(scope) {
        const systemBadgeStylePredicates = this.getPredicateOptions().systemBadgeStylePredicates;
        if (typeof systemBadgeStylePredicates === 'function') {
            const systemPredicateContext = {
                ...this.getAdaptableInternalApi().buildBaseContext(),
                systemPredicateDefs: this.getPredicateApi().getSystemPredicateDefsByModuleScope('badgeStyle'),
                moduleScope: 'badgeStyle',
                columnScope: scope
            };
            return systemBadgeStylePredicates(systemPredicateContext);
        }
        return systemBadgeStylePredicates;
    }
    /**
     * Get all Format Column Predicate Definitions - System and Custom
     */ getFormatColumnPredicateDefs(scope) {
        return this.mergeSystemAndCustomPredicates(this.getSystemFormatColumnPredicateIds(scope)?.map((predicateId)=>this.getPredicateApi().getPredicateDefById(predicateId)), this.getPredicateApi().getCustomPredicateDefs()).filter((predicateDef)=>predicateDef.moduleScope.includes('formatColumn'));
    }
    getSystemFormatColumnPredicateIds(scope) {
        const systemFormatColumnPredicates = this.getPredicateOptions().systemFormatColumnPredicates;
        if (typeof systemFormatColumnPredicates === 'function') {
            const systemPredicateContext = {
                ...this.getAdaptableInternalApi().buildBaseContext(),
                systemPredicateDefs: this.getPredicateApi().getSystemPredicateDefsByModuleScope('formatColumn'),
                moduleScope: 'formatColumn',
                columnScope: scope
            };
            return systemFormatColumnPredicates(systemPredicateContext);
        }
        return systemFormatColumnPredicates;
    }
    /**
     * Get all Flashing Cell Predicate Definitions - System and Custom
     */ getFlashingCellPredicateDefs(scope) {
        return this.mergeSystemAndCustomPredicates(this.getSystemFlashingCellPredicateIds(scope)?.map((predicateId)=>this.getPredicateApi().getPredicateDefById(predicateId)), this.getPredicateApi().getCustomPredicateDefs()).filter((predicateDef)=>predicateDef.moduleScope.includes('flashingcell'));
    }
    getSystemFlashingCellPredicateIds(scope) {
        const systemFlashingCellPredicates = this.getPredicateOptions().systemFlashingCellPredicates;
        if (typeof systemFlashingCellPredicates === 'function') {
            const systemPredicateContext = {
                systemPredicateDefs: this.getPredicateApi().getSystemPredicateDefsByModuleScope('flashingcell'),
                moduleScope: 'flashingcell',
                columnScope: scope,
                ...this.getAdaptableInternalApi().buildBaseContext()
            };
            return systemFlashingCellPredicates(systemPredicateContext);
        }
        return systemFlashingCellPredicates;
    }
    /**
     * Gets the correct Equality-type System Predicate for a particular DataType
     * @param dataType DataType of Column
     */ getEqualityPredicateForDataType(dataType) {
        let predicateId;
        switch(dataType){
            case 'number':
                predicateId = 'Equals';
                break;
            case 'date':
                predicateId = 'On';
                break;
            case 'text':
                predicateId = 'Is';
                break;
            default:
                predicateId = 'Equals';
                break;
        }
        return predicateId;
    }
    /**
     * Get all Badge Style Predicate Definitions - System and Custom
     */ getBadgeStylePredicateDefs(scope) {
        return this.mergeSystemAndCustomPredicates(this.getSystemBadgeStylePredicateIds(scope)?.map((predicateId)=>this.getPredicateApi().getPredicateDefById(predicateId)), this.getPredicateApi().getCustomPredicateDefs()).filter((predicateDef)=>predicateDef.moduleScope.includes('badgeStyle'));
    }
    /**
     * Merges System and Custom Predicate Definitions but ensures that Custom ones take precedence
     * (i.e. if there is a Custom Predicate with the same Id as a System one, the Custom one is used)
     */ mergeSystemAndCustomPredicates(systemDefs, customDefs) {
        const systemDefsToUse = systemDefs.map((systemDef)=>{
            const customDef = customDefs.find((customDef)=>customDef.id === systemDef.id);
            return customDef ? customDef : systemDef;
        });
        const customDefsToUse = customDefs.filter((customDef)=>!systemDefsToUse.find((systemDef)=>systemDef.id === customDef.id));
        return [
            ...systemDefsToUse,
            ...customDefsToUse
        ];
    }
}





const $4d3ef767231dfbdc$var$predicateDefMap_MEMO = new Map();
const $4d3ef767231dfbdc$export$a3d8d83e3da47e22 = ()=>{
    $4d3ef767231dfbdc$var$predicateDefMap_MEMO.clear();
};
const $4d3ef767231dfbdc$var$treeSelectionStatesForPredicates = new WeakMap();
const $4d3ef767231dfbdc$export$dd68fbaa7f25f203 = (inputs, cache = $4d3ef767231dfbdc$var$treeSelectionStatesForPredicates)=>{
    const treeSelectionState = cache.get(inputs);
    if (treeSelectionState) return treeSelectionState;
    const newTreeSelectionState = new (0, $88ab1a78ec8ca4b4$export$3feed6aa923fae79)({
        defaultSelection: false,
        selectedPaths: inputs
    }, {
        treePaths: inputs,
        strictCheckPaths: false
    });
    cache.set(inputs, newTreeSelectionState);
    return newTreeSelectionState;
};
class $4d3ef767231dfbdc$export$25ea6ba48f88e141 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $336902fe882a3b1a$export$f09b3c9a83dae8e2)(_adaptable);
    }
    getPredicateDefs() {
        return this.internalApi.mergeSystemAndCustomPredicates(this.getSystemPredicateDefs(), this.getCustomPredicateDefs());
    }
    getSystemPredicateDefs() {
        return 0, $ee11103a2ae7ed45$export$93bfa1f66bce6e38;
    }
    getSystemPredicateDefsByModuleScope(moduleScope) {
        return (0, $ee11103a2ae7ed45$export$93bfa1f66bce6e38).filter((p)=>p.moduleScope.includes(moduleScope));
    }
    getCustomPredicateDefs() {
        const predicateDefsMap = new Map(this.getSystemPredicateDefs().map((p)=>[
                p.id,
                p
            ]));
        const customPredicateDefs = this.getPredicateOptions().customPredicateDefs || [];
        return customPredicateDefs.map((p)=>{
            if ('extends' in p) {
                const foundPredicateDef = predicateDefsMap.get(p.extends);
                if (!foundPredicateDef) {
                    this.logWarn(`Custom predicate with ID '${p.id}' references a missing 'extends' target '${p.extends}'. No such system or custom predicate found.`);
                    return null;
                } else {
                    const { extends: _, ...rest } = p;
                    const result = {
                        ...foundPredicateDef,
                        ...rest,
                        id: rest.id
                    };
                    predicateDefsMap.set(result.id, result);
                    return result;
                }
            }
            predicateDefsMap.set(p.id, p);
            return p;
        }).filter((p)=>p !== null);
    }
    getPredicateDefsByModuleScope(moduleScope) {
        return this.getPredicateDefs().filter((p)=>p.moduleScope.includes(moduleScope));
    }
    getPredicateDefById(predicateId) {
        return this.getPredicateDefs().find((predicateDef)=>predicateDef.id === predicateId);
    }
    getSystemPredicateDefById(predicateId) {
        return this.getSystemPredicateDefs().find((predicateDef)=>predicateDef.id === predicateId);
    }
    getCustomPredicateDefById(predicateId) {
        return this.getCustomPredicateDefs().find((predicateDef)=>predicateDef.id === predicateId);
    }
    predicateToString(predicate) {
        const predicateDef = this.getPredicateDefById(predicate.PredicateId);
        if (!predicateDef) {
            this.logWarn('Cannot find Predicate with Id:' + predicate.PredicateId);
            return '[Predicate Not found]';
        }
        let strPredicate = predicateDef.hasOwnProperty('toString') ? predicateDef.toString({
            inputs: predicate.Inputs
        }) : predicateDef.label;
        if ('ColumnId' in predicate) strPredicate = `[${predicate.ColumnId}] ${strPredicate}`;
        return strPredicate;
    }
    predicatesToString(predicates, logicalOperator = 'AND') {
        return predicates.map((predicate)=>this.predicateToString(predicate)).join(` ${logicalOperator} `);
    }
    isValidPredicate(predicate) {
        if (!predicate) return false;
        const adaptablePredicateDef = this.getPredicateDefById(predicate.PredicateId);
        if (!adaptablePredicateDef) return false;
        // not perfect but if there are no inputs - and there should be some - we treat the filter as invalid
        if (adaptablePredicateDef.inputs) {
            if ((0, $9g4SS.default).IsNullOrEmpty(predicate.Inputs) || (0, $9OAZF.default).IsNullOrEmpty(predicate.Inputs[0])) return false;
        }
        return !([
            'In',
            'NotIn'
        ].includes(predicate.PredicateId) && (0, $9g4SS.default).IsNullOrEmpty(predicate.Inputs));
    }
    isEveryPredicateValid(predicates) {
        return predicates.every((predicate)=>this.isValidPredicate(predicate));
    }
    handleColumnPredicate(predicate, context, defaultReturn) {
        if (!predicate.ColumnId) return this.handlePredicate(predicate, context, defaultReturn);
        const paramsForColumn = {
            ...context,
            column: this.getColumnApi().getColumnWithColumnId(predicate.ColumnId),
            // value: params?.node?.data?.[predicate.ColumnId],
            value: this.getGridApi().getRawValueFromRowNode(context.node, predicate.ColumnId)
        };
        if ('oldValue' in paramsForColumn) delete paramsForColumn.oldValue;
        return this.handlePredicate(predicate, paramsForColumn, defaultReturn);
    }
    handleColumnPredicates(predicates, context, defaultReturn) {
        return predicates.every((predicate)=>this.handleColumnPredicate(predicate, context, defaultReturn));
    }
    handlePredicate(predicate, context, defaultReturn) {
        if (!predicate) return defaultReturn;
        // memoization to avoid repeated lookups
        // during filtering of large datasets
        // see #column_filter_predicates_evaluation
        let predicateDef = $4d3ef767231dfbdc$var$predicateDefMap_MEMO.get(predicate.PredicateId);
        if (predicateDef === undefined) {
            predicateDef = this.getPredicateDefById(predicate.PredicateId);
            $4d3ef767231dfbdc$var$predicateDefMap_MEMO.set(predicate.PredicateId, predicateDef);
        }
        if (predicateDef === undefined) return defaultReturn;
        if (predicateDef.inputs?.some((_, i)=>predicate.Inputs?.[i] === undefined || predicate.Inputs?.[i] === '')) return defaultReturn;
        let treeSelectionState;
        if (context.column.columnId === (0, $58846ea7f4156db7$export$1fadf36dae8ed962) && predicate.PredicateId === 'In') treeSelectionState = $4d3ef767231dfbdc$export$dd68fbaa7f25f203(predicate.Inputs);
        try {
            return predicateDef.handler({
                adaptableApi: this.getAdaptableApi(),
                inputs: predicate.Inputs,
                treeSelectionState: treeSelectionState,
                ...context
            });
        } catch (error) {
            this.logError(`Error in predicate ${predicateDef.label}`, error);
            return false;
        }
    }
    handlePredicates(predicates, params, defaultReturn) {
        if (predicates === undefined || predicates === null || predicates?.length === 0) return this.handlePredicate(undefined, params, defaultReturn);
        if (predicates.length === 1) return this.handlePredicate(predicates[0], params, defaultReturn);
        if (params.predicatesOperator && params.predicatesOperator === 'OR') return predicates?.some((p)=>this.handlePredicate(p, params, defaultReturn));
        return predicates?.every((p)=>this.handlePredicate(p, params, defaultReturn));
    }
    useCaseSensitivity(columnId) {
        return this.internalApi.shouldUseCaseSensitivePredicates(columnId);
    }
}




class $7b6203c7655ccb91$export$957405a3b3e4bdc6 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getPluginsState() {
        return this.getAdaptableState().Plugins;
    }
    getPluginState(pluginId) {
        return this.getPluginsState()[pluginId];
    }
    registerPlugin(pluginId, initialPluginState) {
        this.setPluginState(pluginId, initialPluginState);
    }
    setPluginState(pluginId, newPluginState) {
        this.dispatchAction($b332b9d7a4fcbf15$export$9f87e8ba2c44ce84(pluginId, newPluginState));
    }
    getPluginApi(pluginId) {
        try {
            const api = this._adaptable.getPluginProperty(pluginId, 'api');
            if (pluginId === 'ipushpull') return api;
            if (pluginId === 'openfin') return api;
            if (pluginId === 'interopio') return api;
            return api;
        } catch (ex) {
            return null;
        }
    }
    getipushpullPluginApi() {
        return this.getPluginApi('ipushpull');
    }
    getInteropioPluginApi() {
        return this.getPluginApi('interopio');
    }
    getOpenFinPluginApi() {
        return this.getPluginApi('openfin');
    }
}




class $e29a926c2762f446$export$67aca8533a32e090 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getBulkUpdateValue() {
        return this.getAdaptableState().Internal.BulkUpdate.BulkUpdateValue;
    }
    openBulkUpdateSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$bc824d5002237871);
    }
    showBulkUpdatePopup() {
        this.openBulkUpdateSettingsPanel();
    }
}








var $9g4SS = parcelRequire("9g4SS");

var $9OAZF = parcelRequire("9OAZF");

class $167f73f5d6b1af95$export$3a12f066d04a6788 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Returns all the references in the AdaptableState of the given CalculatedColumn
     * @param calculatedColumn CalculatedColumn to be checked
     */ getCalculatedColumnModuleReferences(calculatedColumn) {
        const references = [];
        this.getAdaptableInternalApi().getModules().forEach((module)=>{
            if (module.getModuleCalculatedColumnReferences().some((moduleReference)=>moduleReference.Uuid === calculatedColumn.Uuid)) references.push(module.moduleInfo.FriendlyName);
        });
        return references;
    }
    /**
     * Returns all Calculated Columns whose Expression contains the ColumnId
     * @param columnId ColumnId to check
     */ getCalculatedColumnsReferencingColumnId(columnId) {
        const calcColumns = [];
        this.getCalculatedColumnApi().getCalculatedColumns().forEach((calculatedColumn)=>{
            if (this.getExpressionApi().internalApi.isColumnReferencedInExpression(columnId, this.getExpressionApi().getAdaptableQueryExpression(calculatedColumn.Query))) calcColumns.push(calculatedColumn);
        });
        return calcColumns;
    }
    /**
     * Gets any ColumnIds referenced in a Calculated Column
     * @param calculatedColumn Calculated Column to check
     */ getReferencedColumnIdsForCalculatedColumn(calculatedColumn) {
        const columnIds = this.getExpressionApi().getColumnsFromExpression(this.getExpressionApi().getAdaptableQueryExpression(calculatedColumn.Query));
        return columnIds;
    }
    /**
     * Gets any ColumnIds referenced in a Calculated Column
     * @param calculatedColumnId CalculatedColumnId to check
     */ getReferencedColumnIdsForCalculatedColumnId(calculatedColumnId) {
        const calculatedColumn = this.getCalculatedColumnApi().getCalculatedColumns().find((cc)=>cc.ColumnId == calculatedColumnId);
        if (calculatedColumn) return this.getReferencedColumnIdsForCalculatedColumn(calculatedColumn);
    }
    getCalculatedColumnsDependentOnColumn(column) {
        const calculatedColumns = this.getCalculatedColumnApi().getCalculatedColumns();
        return calculatedColumns.filter((calculatedColumn)=>{
            const dependentColumns = this.getReferencedColumnIdsForCalculatedColumnId(calculatedColumn.ColumnId);
            return dependentColumns.includes(column.columnId);
        }).map((calculatedColumn)=>calculatedColumn.ColumnId);
    }
    isCumulativeAggregatedExpression(input) {
        return !!this.getAdaptableApi().internalApi.getQueryLanguageService().getNodesFromExpression(input, 'CUMUL')?.length;
    }
    isQuantileAggregatedExpression(input) {
        return !!this.getAdaptableApi().internalApi.getQueryLanguageService().getNodesFromExpression(input, 'QUANT')?.length;
    }
    getExpressionFromCalculatedColumn(calculatedColumn) {
        return calculatedColumn.Query.ScalarExpression ?? calculatedColumn.Query.AggregatedScalarExpression;
    }
    getColDefsForCalculatedColumns() {
        const defaultSpecialColumnSettings = this.getGridApi().internalApi.deriveSpecialColumnSettingsFromAgGridDefaultColDef();
        const defaultCalculatedColumnSettings = (0, $c94ad2cb10a8d2c3$export$61a9b10f852e2b3c)(defaultSpecialColumnSettings).CalculatedColumnSettings;
        return this.getCalculatedColumnApi().getCalculatedColumns().map((calculatedColumn)=>{
            const calculatedColumnSettings = {
                ...defaultCalculatedColumnSettings,
                ...calculatedColumn.CalculatedColumnSettings
            };
            if (!calculatedColumnSettings.DataType) calculatedColumnSettings.DataType = this.getAdaptableInternalApi().getCalculatedColumnExpressionService().getCalculatedColumnDataType(calculatedColumn.Query);
            const columnTypes = [
                (0, $b0d14b794bdca4f2$export$8e5ee678cfc318c5)
            ];
            if ((0, $9g4SS.default).IsNotNullOrEmpty(calculatedColumnSettings.ColumnTypes)) columnTypes.push(...calculatedColumnSettings.ColumnTypes);
            const isExternalEvaluation = !this.getExpressionApi().internalApi.evaluateExpressionInAdaptableQL('CalculatedColumn', calculatedColumn, this.getExpressionApi().getAdaptableQueryExpression(calculatedColumn.Query));
            const valueGetter = (params)=>{
                if (isExternalEvaluation) return params.data?.[calculatedColumn.ColumnId];
                // if the grid data is NOT client side, we can aggregate only simple scalar expression (which depend on row data, not on other rows)
                if (this.getGridApi().getAgGridRowModelType() !== 'clientSide' && (0, $9OAZF.default).IsNotNullOrEmpty(calculatedColumn.Query.AggregatedScalarExpression)) return params.data?.[calculatedColumn.ColumnId];
                return this.getAdaptableInternalApi().getCalculatedColumnExpressionService().evaluateCalculatedColumnQuery(calculatedColumn, params.node);
            };
            const newColDef = {
                headerName: calculatedColumn.FriendlyName ? calculatedColumn.FriendlyName : calculatedColumn.ColumnId,
                colId: calculatedColumn.ColumnId,
                hide: false,
                editable: false,
                width: calculatedColumnSettings.Width,
                enableValue: calculatedColumnSettings.Aggregatable,
                filter: calculatedColumnSettings.Filterable,
                floatingFilter: calculatedColumnSettings.Filterable,
                resizable: calculatedColumnSettings.Resizable,
                enableRowGroup: calculatedColumnSettings.Groupable,
                sortable: calculatedColumnSettings.Sortable,
                enablePivot: calculatedColumnSettings.Pivotable,
                suppressHeaderMenuButton: calculatedColumnSettings.SuppressMenu,
                suppressMovable: calculatedColumnSettings.SuppressMovable,
                type: columnTypes,
                cellDataType: calculatedColumnSettings.DataType,
                valueGetter: valueGetter
            };
            if (calculatedColumnSettings.ShowToolTip != null && calculatedColumnSettings.ShowToolTip == true) newColDef.tooltipValueGetter = ()=>{
                return this.getAdaptableInternalApi().getAdaptableQueryExpressionText(calculatedColumn.Query);
            };
            if (calculatedColumnSettings.HeaderToolTip) newColDef.headerTooltip = calculatedColumnSettings.HeaderToolTip;
            this.logInfo('Setting up Calculated Column: ' + calculatedColumn.ColumnId);
            return newColDef;
        });
    }
    validateDeletedCalculatedColumn(calculatedColumn) {
        const calculatedColumnReferences = this.getCalculatedColumnModuleReferences(calculatedColumn);
        if (calculatedColumnReferences.length) {
            const alert = {
                alertType: 'generic',
                header: 'Calculated Column',
                message: `This Calculated Column cannot be deleted. It is still referenced by: ${calculatedColumnReferences.join(', ')}.`,
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$f424fc4672cf17b8)('Error')
            };
            this.getAlertApi().displayAdaptableAlertNotification(alert);
            return false;
        } else return true;
    }
}



var $9g4SS = parcelRequire("9g4SS");
class $e385f9c6f09822fb$export$5f337f2322cda760 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $167f73f5d6b1af95$export$3a12f066d04a6788)(_adaptable);
    }
    getCalculatedColumnState() {
        return this.getAdaptableState().CalculatedColumn;
    }
    getCalculatedColumns() {
        return this.getCalculatedColumnState().CalculatedColumns ?? [];
    }
    getAggregatedCalculatedColumns() {
        return this.getCalculatedColumns()?.filter((calculatedColumn)=>calculatedColumn.Query?.AggregatedScalarExpression);
    }
    getCalculatedColumnById(id) {
        return this.getCalculatedColumns().find((column)=>column?.Uuid === id);
    }
    addCalculatedColumn(calculatedColumn) {
        this.addUidToAdaptableObject(calculatedColumn);
        this.dispatchAction($754f469a84cf6e6e$export$b40c2dc2e1bce126(calculatedColumn));
        return this.getCalculatedColumnById(calculatedColumn.Uuid);
    }
    getCalculatedColumnForColumnId(columnId) {
        return this.getCalculatedColumns().find((column)=>column.ColumnId === columnId);
    }
    editCalculatedColumn(calculatedColumn) {
        this.dispatchAction($754f469a84cf6e6e$export$f21cff55af8ea46e(calculatedColumn));
        return this.getCalculatedColumnById(calculatedColumn.Uuid);
    }
    deleteCalculatedColumn(column) {
        let calcColumn = this.getCalculatedColumns().find((cc)=>cc.ColumnId == column);
        this.dispatchAction($754f469a84cf6e6e$export$8a2941134f9c2f4(calcColumn));
    }
    openCalculatedColumnSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$6619e71706e8514a);
    }
    refreshAggregatedCalculatedColumns() {
        const aggregatedCalculatedColumns = this.getAggregatedCalculatedColumns();
        if ((0, $9g4SS.default).IsNotNullOrEmpty(aggregatedCalculatedColumns)) {
            aggregatedCalculatedColumns.forEach((calculatedColumn)=>{
                this.getAdaptableInternalApi().getCalculatedColumnExpressionService().createAggregatedScalarLiveValue(calculatedColumn);
            });
            // refresh calculated columns
            const aggCalculatedColumnIds = aggregatedCalculatedColumns.map((calculatedColumn)=>calculatedColumn.ColumnId);
            if (this.getLayoutApi().internalApi.isLayoutGrouped()) this.getGridApi().refreshGroupRowNodes();
            else this.getGridApi().refreshColumns(aggCalculatedColumnIds);
        }
    }
    refreshAggregatedCalculatedColumn(columnId) {
        const aggregatedCalculatedColumn = this.getCalculatedColumnForColumnId(columnId);
        if (!aggregatedCalculatedColumn?.Query?.AggregatedScalarExpression) {
            this.logWarn(`Aggregated calculated column with ID=${columnId} was NOT found (and refreshed)!`);
            return;
        }
        this.getAdaptableInternalApi().getCalculatedColumnExpressionService().createAggregatedScalarLiveValue(aggregatedCalculatedColumn);
        this.getGridApi().refreshColumn(columnId);
        if (this.getLayoutApi().internalApi.isLayoutGrouped()) this.getGridApi().refreshGroupRowNodes();
        else this.getGridApi().refreshColumn(columnId);
    }
}






var $hrtGQ = parcelRequire("hrtGQ");
class $4b169038104877df$export$a0ef4a07d4fe454 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    openCellSummaryPopupSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$bbf6ee8f129590d);
    }
    getCurrentCellSummaryOperation() {
        return this.getAdaptableState().Internal.CellSummary.CellSummaryOperation;
    }
    getCustomCellSummaryOperations() {
        return this.getCellSummaryOptions().customCellSummaryOperations ?? [];
    }
    setCurrentCellSummaryOperation(operation) {
        this.dispatchAction($5b564bb703f29152$export$4379228241b0773f(operation));
    }
    getCellSummaryOperationValue(operation) {
        const cellSummary = this.getAdaptableState().Internal.CellSummary.CellSummaryInfo;
        if (!cellSummary) return 'N/A';
        switch(operation){
            case (0, $hrtGQ.SummaryOperation).Sum:
                return cellSummary.Sum;
            case (0, $hrtGQ.SummaryOperation).Average:
                return cellSummary.Average;
            case (0, $hrtGQ.SummaryOperation).Median:
                return cellSummary.Median;
            case (0, $hrtGQ.SummaryOperation).Mode:
                return cellSummary.Mode;
            case (0, $hrtGQ.SummaryOperation).Max:
                return cellSummary.Max;
            case (0, $hrtGQ.SummaryOperation).Min:
                return cellSummary.Min;
            case (0, $hrtGQ.SummaryOperation).Distinct:
                return cellSummary.Distinct;
            case (0, $hrtGQ.SummaryOperation).Count:
                return cellSummary.Count;
            case (0, $hrtGQ.SummaryOperation).Std_Deviation:
                return cellSummary.Std_Deviation;
            case (0, $hrtGQ.SummaryOperation).Only:
                return cellSummary.Only;
            case (0, $hrtGQ.SummaryOperation).Weighted_Average:
                return cellSummary.Weighted_Average;
            default:
                return cellSummary[operation];
        }
    }
    getCurrentCellSummaryOperationValue() {
        const cellSummaryOperation = this.getCurrentCellSummaryOperation();
        const summaryOperation = typeof cellSummaryOperation === 'string' ? cellSummaryOperation : cellSummaryOperation.operationName;
        return this.getCellSummaryOperationValue(summaryOperation);
    }
}






















/**
 * @ReduxAction A System Status Message is set
 */ const $0c72086b8e93ba39$export$78ffe08a98dd74df = 'SYSTEM_STATUS_MESSAGE_SET';
const $0c72086b8e93ba39$export$4e2f6fb9a6ff7cbe = 'SYSTEM_STATUS_READY';
const $0c72086b8e93ba39$export$a449de6be534d0c2 = (systemStatusMessageInfo)=>({
        type: $0c72086b8e93ba39$export$78ffe08a98dd74df,
        systemStatusMessageInfo: systemStatusMessageInfo
    });
const $0c72086b8e93ba39$export$ffe6e3c17a6c7153 = ()=>({
        type: $0c72086b8e93ba39$export$4e2f6fb9a6ff7cbe
    });





const $58cdac7f2ad9e749$var$doOnceFlags = {};
/**
 * If the key was passed before, then do NOT execute the func
 */ const $58cdac7f2ad9e749$var$doOnce = (func, key)=>{
    if ($58cdac7f2ad9e749$var$doOnceFlags[key]) return;
    func();
    $58cdac7f2ad9e749$var$doOnceFlags[key] = true;
};
const $58cdac7f2ad9e749$export$24dadfefe309dcd6 = (logger, typeName, oldProp, newProp, message)=>{
    const newPropMsg = newProp ? `Please use '${typeName}.${newProp}()' instead. ` : '';
    $58cdac7f2ad9e749$var$doOnce(()=>logger.consoleWarn(`${typeName}.${oldProp}() is deprecated. ${newPropMsg}${message ?? ''}`), `Deprecated_${oldProp}`);
};
const $58cdac7f2ad9e749$export$b5f6e7596f74ee1b = (logger, oldTypeName, oldProp, newTypeName, newProp, message)=>{
    const newPropMsg = newProp ? `Please use '${newTypeName}.${newProp}()' instead. ` : '';
    $58cdac7f2ad9e749$var$doOnce(()=>logger.consoleWarn(`${oldTypeName}.${oldProp}() is deprecated. ${newPropMsg}${message ?? ''}`), `Deprecated_${oldProp}`);
};
const $58cdac7f2ad9e749$export$f9234da5c5072420 = (logger, typeName, oldProp)=>{
    $58cdac7f2ad9e749$var$doOnce(()=>logger.consoleWarn(`${typeName}.${oldProp}() is deprecated and will be removed in the next major release. Contact support if you need this functionality.`), `Deprecated_${oldProp}`);
};



class $6362559a9efecb99$export$2de0c89ef75866dc extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    configInit() {
        this.dispatchAction((0, $5d2a87b18b3438b7$export$8d6594f2ef703eca)());
    }
    copyAllStateToClipboard() {
        let state = this.getAdaptableState();
        let stringifiedState = JSON.stringify(state);
        (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).copyToClipboard(stringifiedState);
    }
    copyUserStateToClipboard() {
        // This doesnt currently work...
        let state = this.getAdaptableState();
        //  let userState = state
        let stringifiedState = JSON.stringify(state);
        (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).copyToClipboard(stringifiedState);
    }
    getPredefinedConfig() {
        (0, $58cdac7f2ad9e749$export$24dadfefe309dcd6)(this.getAdatableLogger(), 'StateApi', 'getPredefinedConfig', 'getInitialState');
        return this.getInitialState();
    }
    getInitialState() {
        return this._adaptable.adaptableOptions.initialState;
    }
    reloadPredefinedConfig(newPredefinedConfig) {
        (0, $58cdac7f2ad9e749$export$24dadfefe309dcd6)(this.getAdatableLogger(), 'StateApi', 'reloadPredefinedConfig', 'reloadInitialState');
        this.reloadInitialState(newPredefinedConfig);
    }
    reloadInitialState(newInitialState) {
        const adaptableOptions = this.getOptions();
        const oldState = this.getPersistentState();
        // clearing filters so that AG Grid doesnt display the filter icon in a column header after grid reloads
        // but this is a hack so would be nicer if there was a better way to do this
        this.getGridApi().clearFiltering();
        const clearStateFn = adaptableOptions.stateOptions?.clearState || (()=>{
            localStorage.removeItem(adaptableOptions.adaptableStateKey);
            return Promise.resolve(true);
        });
        this.getAdaptableStore().saveStateNow(this._adaptable).then(()=>{
            const promise = clearStateFn((0, $84331a0549ebfeb9$export$91a43078b1cf7697)(this._adaptable));
            promise.then(()=>{
                this.setAdaptableStateKey(adaptableOptions.adaptableStateKey, {
                    initialState: newInitialState || adaptableOptions.initialState,
                    flushCurrentState: false
                }).then(()=>{
                    const newState = this.getPersistentState();
                    this.getEventApi().internalApi.fireAdaptableStateReloadedEvent(oldState, newState);
                });
            });
        });
    }
    getAllState() {
        return this.getAdaptableState();
    }
    getPersistedState() {
        (0, $58cdac7f2ad9e749$export$24dadfefe309dcd6)(this.getAdatableLogger(), 'StateApi', 'getPersistedState', 'getPersistentState');
        return this.getPersistentState();
    }
    getPersistentState() {
        return this.getAdaptableStore().getCurrentStorageState();
    }
    getAllUserState() {
        return Object.values(this.getPersistentState());
    }
    loadUserState(state) {
        this.setAdaptableStateKey(this.getOptions().adaptableStateKey, {
            initialState: state || this.getOptions().initialState,
            flushCurrentState: false
        });
    }
    getAdaptableFilterState() {
        const gridFilter = this.getGridFilterApi().getCurrentGridFilterExpression();
        const adaptableFilterState = {
            gridFilter: gridFilter,
            gridFilterAST: gridFilter ? this.getExpressionApi().getASTForExpression(gridFilter) : null,
            columnFilters: this.getColumnFilterApi().getColumnFilters(),
            columnFilterDefs: this.getColumnFilterApi().getColumnFilterDefs()
        };
        return adaptableFilterState;
    }
    getAdaptableSortState() {
        const adaptableSortState = {
            columnSorts: this.getGridApi().getColumnSorts(),
            customSorts: this.getCustomSortApi().getLiveCustomSorts(),
            customSortComparers: this.getCustomSortApi().getLiveCustomSortComparers()
        };
        return adaptableSortState;
    }
    setAdaptableStateKey(adaptableStateKey, config) {
        return new Promise((resolve, reject)=>{
            this.getAdaptableInternalApi().executeWithProgressIndicator(config?.progressIndicatorLabel ?? `Initialising...`, ()=>{
                const flushCurrentState = !config || config.flushCurrentState !== false;
                // make sure we persist any "pending" changes to state - since stateOptions.debounceStateDelay can cause
                // the state to be persisted with a delay, which we dont want in this case
                const flushStatePromise = flushCurrentState ? this.getAdaptableStore().saveStateNow(this._adaptable) : Promise.resolve(true);
                flushStatePromise.then(()=>{
                    this.getOptions().adaptableStateKey = adaptableStateKey;
                    let initialState = config?.initialState;
                    if (initialState) initialState = (0, $792d5f2a0e72dfac$export$94a55da6558d0ee0)(initialState);
                    const promise = this.getAdaptableStore().loadStore({
                        adaptable: this._adaptable,
                        adaptableStateKey: adaptableStateKey,
                        initialState: initialState,
                        postLoadHook: (state)=>{
                            const agGridOptions = {
                                columnDefs: this._adaptable.agGridAdapter.getGridOption('columnDefs'),
                                autoGroupColumnDef: this._adaptable.agGridAdapter.getGridOption('autoGroupColumnDef'),
                                rowModelType: this._adaptable.agGridAdapter.getGridOption('rowModelType'),
                                treeData: this._adaptable.agGridAdapter.getGridOption('treeData')
                            };
                            return this._adaptable.normalizeAdaptableState(state, agGridOptions);
                        }
                    });
                    promise.then(()=>{
                        this._adaptable.refreshLayout();
                    }).then(()=>{
                        // resolve main(result) promise
                        resolve();
                    }, (error)=>{
                        // reject main(result) promise
                        reject(error);
                    }).catch((e)=>{
                        this.logError('Error setting Adaptable State Key', e);
                    }).finally(()=>{
                        this.getUserInterfaceApi().hideProgressIndicator();
                    });
                });
            });
        });
    }
    async persistAdaptableState() {
        await this.getAdaptableStore().saveStateNow(this._adaptable);
        return this.getAdaptableStore().getCurrentStorageState();
    }
    getDescriptionForModule(module) {
        return this._adaptable.ModuleService.getModuleInfoByModule(module).Description;
    }
    getHelpPageForModule(module) {
        return this._adaptable.ModuleService.getModuleInfoByModule(module).HelpPage;
    }
    getUserStateByStateKey(stateKey, returnJson = false) {
        switch(stateKey){
            case 'Alert':
                return returnJson ? JSON.stringify(this.getAdaptableState().Alert) : this.getAdaptableState().Alert;
            case 'Application':
                return returnJson ? JSON.stringify(this.getAdaptableState().Application) : this.getAdaptableState().Application;
            case 'CalculatedColumn':
                return returnJson ? JSON.stringify(this.getAdaptableState().CalculatedColumn) : this.getAdaptableState().CalculatedColumn;
            case 'Charting':
                return returnJson ? JSON.stringify(this.getAdaptableState().Charting) : this.getAdaptableState().Charting;
            case 'Note':
                return returnJson ? JSON.stringify(this.getAdaptableState().Note) : this.getAdaptableState().Note;
            case 'CustomSort':
                return returnJson ? JSON.stringify(this.getAdaptableState().CustomSort) : this.getAdaptableState().CustomSort;
            case 'Dashboard':
                return returnJson ? JSON.stringify(this.getAdaptableState().Dashboard) : this.getAdaptableState().Dashboard;
            case 'Export':
                return returnJson ? JSON.stringify(this.getAdaptableState().Export) : this.getAdaptableState().Export;
            case 'FormatColumn':
                return returnJson ? JSON.stringify(this.getAdaptableState().FormatColumn) : this.getAdaptableState().FormatColumn;
            case 'FreeTextColumn':
                return returnJson ? JSON.stringify(this.getAdaptableState().FreeTextColumn) : this.getAdaptableState().FreeTextColumn;
            case 'Layout':
                return returnJson ? JSON.stringify(this.getAdaptableState().Layout) : this.getAdaptableState().Layout;
            case 'PlusMinus':
                return returnJson ? JSON.stringify(this.getAdaptableState().PlusMinus) : this.getAdaptableState().PlusMinus;
            case 'NamedQuery':
                return returnJson ? JSON.stringify(this.getAdaptableState().NamedQuery) : this.getAdaptableState().NamedQuery;
            case 'QuickSearch':
                return returnJson ? JSON.stringify(this.getAdaptableState().QuickSearch) : this.getAdaptableState().QuickSearch;
            case 'Schedule':
                return returnJson ? JSON.stringify(this.getAdaptableState().Schedule) : this.getAdaptableState().Schedule;
            case 'Shortcut':
                return returnJson ? JSON.stringify(this.getAdaptableState().Shortcut) : this.getAdaptableState().Shortcut;
            case 'Theme':
                return returnJson ? JSON.stringify(this.getAdaptableState().Theme) : this.getAdaptableState().Theme;
            case 'ToolPanel':
                return returnJson ? JSON.stringify(this.getAdaptableState().ToolPanel) : this.getAdaptableState().ToolPanel;
        }
    }
    incrementUserStateRevision(stateKey) {
        let state = this.getUserStateByStateKey(stateKey);
        if (typeof state.Revision === 'number') state.Revision += 1;
        else state.Revision.Key += 1;
    // need to save it...
    }
    getAlertState(returnJson = false) {
        return this.getUserStateByStateKey('Alert', returnJson);
    }
    getApplicationState(returnJson = false) {
        return this.getUserStateByStateKey('Application', returnJson);
    }
    getCalculatedColumnState(returnJson = false) {
        return this.getUserStateByStateKey('CalculatedColumn', returnJson);
    }
    getChartingState(returnJson = false) {
        return this.getUserStateByStateKey('Charting', returnJson);
    }
    getNoteState(returnJson = false) {
        return this.getUserStateByStateKey('Note', returnJson);
    }
    getCustomSortState(returnJson = false) {
        return this.getUserStateByStateKey('CustomSort', returnJson);
    }
    getDashboardState(returnJson = false) {
        return this.getUserStateByStateKey('Dashboard', returnJson);
    }
    getExportState(returnJson = false) {
        return this.getUserStateByStateKey('Export', returnJson);
    }
    getFreeTextColumnState(returnJson = false) {
        return this.getUserStateByStateKey('FreeTextColumn', returnJson);
    }
    getFormatColumnState(returnJson = false) {
        return this.getUserStateByStateKey('FormatColumn', returnJson);
    }
    getFlashingCellState(returnJson = false) {
        return this.getUserStateByStateKey('FlashingCell', returnJson);
    }
    getLayoutState(returnJson = false) {
        return this.getUserStateByStateKey('Layout', returnJson);
    }
    getPlusMinusState(returnJson = false) {
        return this.getUserStateByStateKey('PlusMinus', returnJson);
    }
    getNamedQueryState(returnJson = false) {
        return this.getUserStateByStateKey('NamedQuery', returnJson);
    }
    getQuickSearchState(returnJson = false) {
        return this.getUserStateByStateKey('QuickSearch', returnJson);
    }
    getScheduleState(returnJson = false) {
        return this.getUserStateByStateKey('Schedule', returnJson);
    }
    getShortcutState(returnJson = false) {
        return this.getUserStateByStateKey('Shortcut', returnJson);
    }
    getStatusBarState(returnJson = false) {
        return this.getUserStateByStateKey('StatusBar', returnJson);
    }
    getStyledColumnState(returnJson = false) {
        return this.getUserStateByStateKey('StyledColumn', returnJson);
    }
    getThemeState(returnJson = false) {
        return this.getUserStateByStateKey('Theme', returnJson);
    }
    getToolPanelState(returnJson = false) {
        return this.getUserStateByStateKey('ToolPanel', returnJson);
    }
    dispatchStateReadyAction(module) {
        switch(module){
            case 'Alert':
                this.dispatchAction($0040cfd693076bab$export$2a23c236cc5a01a4(this.getAlertState()));
                break;
            case 'BulkUpdate':
                this.dispatchAction($8713f41926484273$export$ca4658681530e9d4());
                break;
            case 'CalculatedColumn':
                this.dispatchAction($754f469a84cf6e6e$export$851359d6bb162c27(this.getCalculatedColumnState()));
                break;
            case 'Charting':
                this.dispatchAction($5571bec319fd98b0$export$a2186ecffe5e74da(this.getChartingState()));
                break;
            case 'Note':
                this.dispatchAction($b5b505fd5df04a9f$export$29bf01dc68be84eb(this.getNoteState()));
                break;
            case 'CustomSort':
                this.dispatchAction($75a64529baee8b47$export$c12671676901bc26(this.getCustomSortState()));
                break;
            case 'Dashboard':
                this.dispatchAction($dc6bc6f406d56c84$export$2f57a1ad995fb6d8(this.getDashboardState()));
                break;
            case 'Export':
                this.dispatchAction($a3814690501f278b$export$b7d9fd39701b9d58(this.getExportState()));
                break;
            case 'FormatColumn':
                this.dispatchAction($4a80335d87022149$export$1fe738301e3bcbbc(this.getFormatColumnState()));
                break;
            case 'FreeTextColumn':
                this.dispatchAction($d8c519ae038bb984$export$de2a610be1ed0fd1(this.getFreeTextColumnState()));
                break;
            case 'Layout':
                this.dispatchAction($2c155f3e4804e29e$export$bb817beb81db1018(this.getLayoutState()));
                break;
            case 'PlusMinus':
                this.dispatchAction($36058826e464bb44$export$409f62f938d0204d(this.getPlusMinusState()));
                break;
            case 'NamedQuery':
                this.dispatchAction($f53463061a55e5a9$export$af02f94bd3114145(this.getNamedQueryState()));
                break;
            case 'QuickSearch':
                this.dispatchAction($a9684a89f07662ba$export$cb1c4cb43e5ff97a(this.getQuickSearchState()));
                break;
            case 'Schedule':
                this.dispatchAction($bb63955874685545$export$e3ac9aaf65fb0b29(this.getScheduleState()));
                break;
            case 'Shortcut':
                this.dispatchAction($2172826b4c3056a0$export$ee1088b1fed7af6b(this.getShortcutState()));
                break;
            case 'SmartEdit':
                this.dispatchAction($eeed7eb8174868ba$export$b389f49fc2051bb3());
                break;
            case 'SystemStatus':
                this.dispatchAction($0c72086b8e93ba39$export$ffe6e3c17a6c7153());
                break;
            case 'Theme':
                this.dispatchAction($436d9a36bf9edcd8$export$71022c84c51ab76a(this.getThemeState()));
                break;
            case 'ToolPanel':
                this.dispatchAction($297dbcf3bf27faf2$export$8154ff15a144d54e(this.getToolPanelState()));
                break;
            case 'StatusBar':
                this.dispatchAction($297dbcf3bf27faf2$export$8154ff15a144d54e(this.getToolPanelState()));
                break;
        }
    }
}







class $7f95cd054f5836d6$export$38cfccfcfac36cca extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getCustomSortComparer(columnId) {
        const column = this.getColumnApi().getColumnWithColumnId(columnId);
        return this.getCustomSortOptions().customSortComparers?.find((csc)=>this.getColumnScopeApi().isColumnInScope(column, csc.scope));
    }
    getCustomSortValue(value, columnDataType) {
        if (value == null) return null;
        if (columnDataType === 'date') (0, $eccba2ee7b674d85$export$53b52b78a0e685f9)(value);
        if (columnDataType === 'number') return parseFloat(value);
        return `${value}`;
    }
    getDefaultCustomSortComparer(columnId, columnValues) {
        // have to return a function that may not have access to this
        const gridApi = this.getGridApi();
        const columnDataType = this.getColumnApi().getColumnDataTypeForColumnId(columnId);
        const _this = this;
        return function compareItemsOfCustomSort(valueA, valueB, nodeA, nodeB) {
            const firstRawValue = gridApi.getRawValueFromRowNode(nodeA, columnId);
            let firstCustomSortValue = _this.getCustomSortValue(firstRawValue, columnDataType) ?? valueA;
            const secondRawValue = gridApi.getRawValueFromRowNode(nodeB, columnId);
            let secondCustomSortValue = _this.getCustomSortValue(secondRawValue, columnDataType) ?? valueB;
            let indexFirstElement = columnValues.indexOf(firstCustomSortValue);
            let containsFirstElement = indexFirstElement >= 0;
            let indexSecondElement = columnValues.indexOf(secondCustomSortValue);
            let containsSecondElement = indexSecondElement >= 0;
            //if none of the element are in the list we jsut return normal compare
            if (!containsFirstElement && !containsSecondElement) {
                if (valueA == valueB) return 0;
                return valueA < valueB ? -1 : 1;
            }
            //if first item not in the list make sure we put it after the second item
            if (!containsFirstElement) return 1;
            //if second item not in the list make sure we put it after the first item
            if (!containsSecondElement) return -1;
            //return the comparison from the list if the two items are in the list
            return indexFirstElement - indexSecondElement;
        };
    }
    columnHasCustomSortComparer(columnId) {
        const columnSortComparer = this.getCustomSortComparer(columnId);
        return columnSortComparer ? true : false;
    }
}


class $786030feb0fac184$export$daae63932bb51652 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $7f95cd054f5836d6$export$38cfccfcfac36cca)(_adaptable);
    }
    getCustomSortState() {
        return this.getAdaptableState().CustomSort;
    }
    getCustomSorts(config) {
        return this.handleLayoutExtensionObjects(this.getCustomSortState().CustomSorts, 'CustomSort', config) ?? [];
    }
    getCustomSortById(id, config) {
        return this.getCustomSorts(config).find((customSort)=>customSort.Uuid === id);
    }
    getCustomSortByName(name) {
        return this.getCustomSorts().find((customSort)=>customSort.Name === name);
    }
    getLiveCustomSorts() {
        let returnVals = [];
        const sortedColIds = this.getGridApi().getColumnSorts().map((c)=>c.ColumnId);
        const activeCustomSorts = this.getActiveCustomSorts();
        if (sortedColIds == undefined || activeCustomSorts == undefined) return returnVals;
        sortedColIds.forEach((columnId)=>{
            const customSort = activeCustomSorts.find((c)=>c.ColumnId == columnId);
            if (customSort) returnVals.push(customSort);
        });
        return returnVals;
    }
    getLiveCustomSortComparers() {
        let returnComparers = [];
        const sortedColIds = this.getGridApi().getColumnSorts().map((c)=>c.ColumnId);
        const sortedCols = this.getColumnApi().getColumnsWithColumnIds(sortedColIds);
        const customSortComparers = this.getCustomSortOptions().customSortComparers;
        if (sortedColIds == undefined || customSortComparers == undefined) return returnComparers;
        const scopeApi = this.getColumnScopeApi();
        sortedCols.forEach((column)=>{
            const comparer = customSortComparers.find((acs)=>scopeApi.isColumnInScope(column, acs.scope));
            if (comparer && !returnComparers.includes(comparer)) returnComparers.push(comparer);
        });
        return returnComparers;
    }
    getActiveCustomSorts(config) {
        return this.getCustomSorts(config).filter((customSort)=>!customSort.IsSuspended);
    }
    getSuspendedCustomSorts(config) {
        return this.getCustomSorts(config).filter((customSort)=>customSort.IsSuspended);
    }
    getCustomSortByColumn(column) {
        return this.getCustomSorts().find((cs)=>cs.ColumnId == column);
    }
    getCustomSortForColumn(columnId) {
        return this.getCustomSorts().find((cs)=>cs.ColumnId == columnId);
    }
    addCustomSort(customSort) {
        this.addUidToAdaptableObject(customSort);
        this.dispatchAction($75a64529baee8b47$export$9cd83b3dd04bb797(customSort));
        return this.getCustomSortById(customSort.Uuid);
    }
    createCustomSort(params) {
        let customSort = {
            Name: params.name,
            ColumnId: params.columnId,
            SortedValues: params.values
        };
        return this.addCustomSort(customSort);
    }
    editCustomSortValues(columnId, values) {
        const previousCustomSort = this.getCustomSortForColumn(columnId);
        if (!previousCustomSort) {
            this.logWarn(`No custom sort defined for ${columnId}`);
            return;
        }
        const newCustomSort = {
            ...previousCustomSort,
            SortedValues: values
        };
        this.dispatchAction($75a64529baee8b47$export$4b53156c61c1ad3d(newCustomSort));
        return this.getCustomSortByColumn(columnId);
    }
    editCustomSort(customSort) {
        this.dispatchAction($75a64529baee8b47$export$4b53156c61c1ad3d(customSort));
        return this.getCustomSortByColumn(customSort.Uuid);
    }
    deleteCustomSort(column) {
        let customSort = this.getCustomSortForColumn(column);
        if (customSort) this.dispatchAction($75a64529baee8b47$export$6fc68e516c87f722(customSort));
    }
    suspendCustomSort(customSort) {
        this.dispatchAction($75a64529baee8b47$export$259d7a681e73c8b6(customSort));
        return this.getCustomSortById(customSort.Uuid);
    }
    unSuspendCustomSort(customSort) {
        this.dispatchAction($75a64529baee8b47$export$d37aedd8579b604(customSort));
        return this.getCustomSortById(customSort.Uuid);
    }
    suspendAllCustomSort() {
        this.dispatchAction($75a64529baee8b47$export$20981ed2c354783f());
    }
    unSuspendAllCustomSort() {
        this.dispatchAction($75a64529baee8b47$export$ed3948c082d4a953());
    }
    openCustomSortSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$efdce168daed1549);
    }
}






var $acw62 = parcelRequire("acw62");

/*
This page includes frequently used typed - particularly helpful for State and Api where we can strongly type stuff
*/ 
const $c75adffdf90b3d81$export$994701066e1fd8cd = [
    'Alert',
    'BulkUpdate',
    'CellSummary',
    'Charting',
    'DataChangeHistory',
    'DataSet',
    'Export',
    'IPushPull',
    'Layout',
    'ColumnFilter',
    'GridFilter',
    'OpenFin',
    'QuickSearch',
    'SmartEdit',
    'StateManagement',
    'SystemStatus',
    'Theme'
];
const $c75adffdf90b3d81$export$bbefa93fc7e9cd4a = [
    'Alert',
    'BulkUpdate',
    'CalculatedColumn',
    'CellSummary',
    'Comment',
    'CustomSort',
    'Charting',
    'Dashboard',
    'DataChangeHistory',
    'DataImport',
    'DataSet',
    'Export',
    'ColumnFilter',
    'GridFilter',
    'FlashingCell',
    'FormatColumn',
    'FreeTextColumn',
    'GridInfo',
    'Layout',
    'Note',
    'PlusMinus',
    'QuickSearch',
    'Schedule',
    'SettingsPanel',
    'Shortcut',
    'SmartEdit',
    'StateManagement',
    'StatusBar',
    'SystemStatus',
    'TeamSharing',
    'Theme',
    'ToolPanel'
];
const $c75adffdf90b3d81$export$d064dfbe60243148 = [
    'Alert',
    'BulkUpdate',
    'CellSummary',
    'Charting',
    'Dashboard',
    'DataChangeHistory',
    'Export',
    'ColumnFilter',
    'GridFilter',
    'IPushPull',
    'Layout',
    'OpenFin',
    'QuickSearch',
    'SmartEdit',
    'StateManagement',
    'SystemStatus',
    'Theme'
];
const $c75adffdf90b3d81$export$5d1c20aca6593e39 = [
    $42e863194fcb493f$export$40024cb74c2bb550,
    $42e863194fcb493f$export$bc824d5002237871,
    $42e863194fcb493f$export$6619e71706e8514a,
    $42e863194fcb493f$export$bbf6ee8f129590d,
    $42e863194fcb493f$export$7e30a30684cd1b52,
    $42e863194fcb493f$export$8d2ece562190bba1,
    $42e863194fcb493f$export$a3fc1172140ca1e4,
    $42e863194fcb493f$export$efdce168daed1549,
    $42e863194fcb493f$export$b74b667f10548947,
    $42e863194fcb493f$export$376343cd8119f6bf,
    $42e863194fcb493f$export$b0d2488aa9d7ee1f,
    $42e863194fcb493f$export$65414e618c4e5904,
    $42e863194fcb493f$export$2bc329d2b6ae03ac,
    $42e863194fcb493f$export$fc2170ec34a40864,
    $42e863194fcb493f$export$7b96a9104aea727f,
    $42e863194fcb493f$export$7a2c7140815c0686,
    $42e863194fcb493f$export$1ec41f9c955a8b42,
    $42e863194fcb493f$export$d7882f1fbc82745,
    $42e863194fcb493f$export$802bb096eb63f491,
    $42e863194fcb493f$export$fad51b7f4f4d5858,
    $42e863194fcb493f$export$1d33a3a77a9299ff,
    $42e863194fcb493f$export$cf7621e489e71e3c,
    $42e863194fcb493f$export$5dd6e67bf681ede8,
    $42e863194fcb493f$export$79267ef32fe02008,
    $42e863194fcb493f$export$ef61c24f038f357f,
    $42e863194fcb493f$export$3fb170c57e2678e6,
    $42e863194fcb493f$export$7d380408a8ffe7db,
    $42e863194fcb493f$export$826ed58486b36acd,
    $42e863194fcb493f$export$273162015487179c,
    $42e863194fcb493f$export$49045387ac7420d5,
    $42e863194fcb493f$export$ecef34e06f3704d9,
    $42e863194fcb493f$export$ebf1703e41256059,
    $42e863194fcb493f$export$6444167a07daa102,
    $42e863194fcb493f$export$4908330cb20abb96,
    $42e863194fcb493f$export$edfe19743c8e0917,
    $42e863194fcb493f$export$97c45942f844607e
];



class $0dfdb26dffa0bca9$export$bc1a122054af52d9 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    isToolbarInActiveTab(toolbarName, dashboardState) {
        if (!dashboardState) return false;
        const tabIndex = dashboardState.ActiveTabIndex;
        if (tabIndex != undefined) {
            if (dashboardState?.Tabs && dashboardState?.Tabs?.length > 0) {
                const newTab = dashboardState?.Tabs[tabIndex];
                if (newTab && newTab.Toolbars) return newTab.Toolbars.find((c)=>c == toolbarName) != undefined;
            }
        }
        return false;
    }
    isToolbarCustom(toolbarName) {
        return this.getAdaptableApi().dashboardApi.getCustomToolbars().some((tb)=>tb.name === toolbarName);
    }
    getCustomToolbarRenderContainerId(customToolbarName) {
        return `ab-CustomToolbar__${customToolbarName}__renderContent`;
    }
    getCustomToolbarButtonsContainerId(customToolbarName) {
        return `ab-CustomToolbar__${customToolbarName}__buttons`;
    }
    getCustomToolbarComponentContainerId(customToolbarName) {
        return `ab-CustomToolbar__${customToolbarName}__component`;
    }
    getModuleToolbars() {
        const moduleService = this.getAdaptableInternalApi().getModuleService();
        return (0, $c75adffdf90b3d81$export$994701066e1fd8cd).filter((moduleName)=>{
            return moduleService.isAdapTableModulePresent(moduleName);
        }).map((moduleName)=>{
            return {
                id: moduleName,
                friendlyName: moduleService.getModuleInfoByModule(moduleName)?.FriendlyName ?? moduleName
            };
        });
    }
}


class $d17adba74fbea2cb$export$c6bc7927c6b7b46d extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $0dfdb26dffa0bca9$export$bc1a122054af52d9)(_adaptable);
    }
    getDashboardState() {
        return this.getAdaptableState().Dashboard;
    }
    getCustomToolbars() {
        return this.getDashboardOptions().customToolbars || [];
    }
    getCustomDashboardButtons() {
        return this.getDashboardOptions().customDashboardButtons || [];
    }
    getCustomDashboardButtonByLabel(buttonLabel) {
        const dashboardContext = {
            ...this.getAdaptableInternalApi().buildBaseContext(),
            dashboardState: this.getDashboardApi().getDashboardState()
        };
        return this.getDashboardOptions().customDashboardButtons.find((cb)=>{
            this.getAdaptableInternalApi().getLabelForButton(cb, dashboardContext);
        });
    }
    setModuleButtons(moduleButtons) {
        this.dispatchAction($dc6bc6f406d56c84$export$159d43c9de7aed08(moduleButtons));
    }
    setDashboardTitle(title) {
        this.dispatchAction($dc6bc6f406d56c84$export$71594d6c7c1c5baf(title));
    }
    getCustomToolbarHTMLElement(customToolbarName) {
        let customToolbar = this.getCustomToolbarByName(customToolbarName);
        if (!customToolbar) {
            this.logWarn(`Could not find custom toolbar with name ${customToolbarName}`);
            return;
        }
        if (customToolbar.render) return document.getElementById(this.internalApi.getCustomToolbarRenderContainerId(customToolbarName));
        if (customToolbar.toolbarButtons) {
            this.logWarn(`(get/set)CustomToolbarHTMLElement(${customToolbarName}) should only be used in Vanilla AdapTable for toolbars created via a 'render' function! For React/Adaptable components let the framework renderer handle it!`);
            return document.getElementById(this.internalApi.getCustomToolbarButtonsContainerId(customToolbarName));
        }
        if (customToolbar.frameworkComponent) {
            this.logWarn(`(get/set)CustomToolbarHTMLElement(${customToolbarName}) should only be used in Vanilla AdapTable for toolbars created via a 'render' function! For React/Adaptable components let the framework renderer handle it!`);
            return document.getElementById(this.internalApi.getCustomToolbarComponentContainerId(customToolbarName));
        }
    }
    setCustomToolbarHTMLContent(customToolbarName, htmlContent) {
        let customRenderedContainer = this.getCustomToolbarHTMLElement(customToolbarName);
        if (customRenderedContainer) this._adaptable.renderReactRoot($acw62.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: htmlContent
            }
        }), customRenderedContainer);
    }
    getCustomToolbarByName(customToolbarName) {
        return this.getCustomToolbars().find((ct)=>ct.name == customToolbarName);
    }
    getTabByName(tabName) {
        return (this.getDashboardState().Tabs || []).find((tab)=>tab.Name == tabName);
    }
    collapseDashboard() {
        this.dispatchAction($dc6bc6f406d56c84$export$4a9fdbf5568e83b6(true));
    }
    expandDashboard() {
        this.dispatchAction($dc6bc6f406d56c84$export$4a9fdbf5568e83b6(false));
    }
    refreshDashboard() {
        this.dispatchAction((0, $5b564bb703f29152$export$76d0f3c2e8e44b9d)());
    }
    floatDashboard() {
        this.dispatchAction($dc6bc6f406d56c84$export$d83abcde9deec805(true));
    }
    dockDashboard() {
        this.dispatchAction($dc6bc6f406d56c84$export$d83abcde9deec805(false));
    }
    hideDashboard() {
        this.dispatchAction($dc6bc6f406d56c84$export$b2de5be7510594c1(true));
    }
    showDashboard() {
        this.dispatchAction($dc6bc6f406d56c84$export$b2de5be7510594c1(false));
    }
    getActiveTabIndex() {
        return this.getDashboardState().ActiveTabIndex;
    }
    getActiveTab() {
        return this.getDashboardState().Tabs[this.getActiveTabIndex()];
    }
    setTabs(Tabs) {
        this.dispatchAction($dc6bc6f406d56c84$export$a79213d66294d5b2(Tabs));
    }
    getTabs() {
        return this.getDashboardState().Tabs;
    }
    getModuleButtons() {
        return this.getDashboardState().ModuleButtons;
    }
    setPinnedToolbars(toolbars) {
        this.dispatchAction($dc6bc6f406d56c84$export$6f65449fc8f69bb2(toolbars));
    }
    getPinnedToolbars() {
        return this.getDashboardState().PinnedToolbars;
    }
    isToolbarVisible(toolbar) {
        return (this.getCurrentToolbars() || []).find((c)=>c == toolbar) != undefined;
    }
    setActiveTabIndex(tabIndex) {
        this.dispatchAction($dc6bc6f406d56c84$export$b0602226505423cf(tabIndex));
    }
    setActiveTab(tabName) {
        const tab = this.getTabByName(tabName);
        if (tab) {
            let tabIndex = this.getDashboardState().Tabs?.findIndex((t)=>t);
            this.setActiveTabIndex(tabIndex);
        }
    }
    getCurrentToolbars() {
        // if hidden or collapsed return fasle
        if (this.getDashboardState().IsCollapsed == true || this.getDashboardState().IsHidden == true) return [];
        const currentTab = this.getActiveTab();
        if (!currentTab) return [];
        return currentTab.Toolbars;
    }
    openDashboardSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$b74b667f10548947);
    }
    isDashboardCollapsed() {
        return this.getDashboardState().IsCollapsed;
    }
    isDashboardExpanded() {
        return !this.getDashboardState().IsCollapsed;
    }
    isDashboardFloating() {
        return this.getDashboardState().IsFloating;
    }
    isDashboardDocked() {
        return !this.getDashboardState().IsFloating;
    }
    isDashboardHidden() {
        return this.getDashboardState().IsHidden;
    }
    isDashboardVisible() {
        return !this.getDashboardState().IsHidden;
    }
}





class $4068677b5806fc16$export$c58ff0365b9e9dde extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getToolPanelState() {
        return this.getAdaptableState().ToolPanel;
    }
    showToolPanelPopup() {
        this.showModulePopup($42e863194fcb493f$export$6444167a07daa102);
    }
    openAdapTableToolPanel() {
        const agGridApi = this.getAgGridApi();
        if (agGridApi) agGridApi.openToolPanel('adaptable');
    }
    closeAdapTableToolPanel() {
        const agGridApi = this.getAgGridApi();
        if (agGridApi) agGridApi.closeToolPanel();
    }
    getCustomToolPanels() {
        return this.getToolPanelOptions().customToolPanels ?? [];
    }
    getCustomToolPanelButtons() {
        return this.getToolPanelOptions().customButtons ?? [];
    }
    getCustomToolPanelByName(name) {
        return this.getCustomToolPanels().find((customToolPanel)=>customToolPanel.name === name);
    }
    setAdaptableToolPanelVisibilityMode(adaptableToolPanel, visibilityMode) {
        if (visibilityMode === 'expanded') this.setExpandedToolPanelVisibility(adaptableToolPanel);
        else this.setCollapsedToolPanelVisibility(adaptableToolPanel);
    }
    setCustomToolPanelVisibilityMode(customToolPanelName, visibilityMode) {
        if (visibilityMode === 'expanded') this.setExpandedToolPanelVisibility(customToolPanelName);
        else this.setCollapsedToolPanelVisibility(customToolPanelName);
    }
    setModuleButtons(moduleButtons) {
        this.dispatchAction((0, $297dbcf3bf27faf2$export$2603e58d630068f9)(moduleButtons));
    }
    getModuleButtons() {
        return this.getToolPanelState()?.ModuleButtons ?? [];
    }
    setExpandedToolPanelVisibility(toolPanelName) {
        this.dispatchAction($297dbcf3bf27faf2$export$ee3eefa58024e7e9(toolPanelName));
    }
    setCollapsedToolPanelVisibility(toolPanelName) {
        this.dispatchAction($297dbcf3bf27faf2$export$a5e2bec81f9383b9(toolPanelName));
    }
}






class $5540dbd7c3561456$export$12a07269be13db79 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    showDataSetForm(dataSet) {
        if (dataSet.form) this.getAdaptableInternalApi().showPopupForm({
            Id: 'data-set-form',
            Form: dataSet.form,
            prepareContext: (context)=>{
                return new Promise((resolve)=>{
                    const preparedContext = {
                        ...context,
                        dataSet: dataSet
                    };
                    resolve(preparedContext);
                });
            }
        });
    }
}


class $036d2bff52772e1d$export$6352b8c501c22109 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $5540dbd7c3561456$export$12a07269be13db79)(_adaptable);
    }
    getDataSets() {
        return this.getDataSetOptions()?.dataSets ?? [];
    }
    getCurrentDataSet() {
        let currentDataSetName = this.getAdaptableState().Internal.CurrentDataSet;
        return this.getDataSetByName(currentDataSetName);
    }
    getDataSetByName(dataSetName) {
        return this.getDataSets().find((a)=>a.name == dataSetName);
    }
    setDataSet(dataSetName) {
        const dataSet = this.getDataSetByName(dataSetName);
        if (this.checkItemExists(dataSet, dataSetName, 'Data Source')) this.dispatchAction($5b564bb703f29152$export$a167b5ac2f0c10f3(dataSet));
    }
    clearCurrentDataSet() {
        this.dispatchAction($5b564bb703f29152$export$a167b5ac2f0c10f3(null));
    }
    openDataSetSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$b0d2488aa9d7ee1f);
    }
}






class $c4f1595681bbbd5e$export$a437c48cb95f7d32 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    fireGridSortedEvent() {
        if (this.isAdapTableReady()) setTimeout(()=>{
            const adaptableSortState = this.getStateApi().getAdaptableSortState();
            const gridSortedInfo = {
                adaptableSortState: adaptableSortState,
                ...this.getAdaptableInternalApi().buildBaseContext()
            };
            this.getEventApi().emit('GridSorted', gridSortedInfo);
        }, 50);
    }
    fireCellChangedEvent(cellDataChangedInfo) {
        if (this.isAdapTableReady()) {
            const cellChangedInfo = {
                ...this.getAdaptableInternalApi().buildBaseContext(),
                cellDataChange: cellDataChangedInfo
            };
            this.getEventApi().emit('CellChanged', cellChangedInfo);
        }
    }
    fireRowChangedEvent(rowDataChangedInfo) {
        if (this.isAdapTableReady()) {
            const rowChangedInfo = {
                ...this.getAdaptableInternalApi().buildBaseContext(),
                rowDataChange: rowDataChangedInfo
            };
            this.getEventApi().emit('RowChanged', rowChangedInfo);
        }
    }
    fireDashboardChangedEvent(trigger, oldDashboardState, newDashboardState) {
        const isToolbarStateChangedToVisible = (toolbarName)=>{
            const visibleInNewState = this.getDashboardApi().internalApi.isToolbarInActiveTab(toolbarName, newDashboardState);
            const visibleInOldState = this.getDashboardApi().internalApi.isToolbarInActiveTab(toolbarName, oldDashboardState);
            if (visibleInNewState && visibleInOldState) // check for dashboard collapse/expand/hidden changes
            return oldDashboardState.IsCollapsed && !newDashboardState.IsCollapsed || oldDashboardState.IsHidden && !newDashboardState.IsHidden;
            return visibleInNewState && !visibleInOldState;
        };
        const isToolbarStateChangedToHidden = (toolbarName)=>{
            const visibleInNewState = this.getDashboardApi().internalApi.isToolbarInActiveTab(toolbarName, newDashboardState);
            const visibleInOldState = this.getDashboardApi().internalApi.isToolbarInActiveTab(toolbarName, oldDashboardState);
            if (visibleInNewState && visibleInOldState) // check for dashboard collapse/expand/hidden changes
            return !oldDashboardState.IsCollapsed && newDashboardState.IsCollapsed || !oldDashboardState.IsHidden && newDashboardState.IsHidden;
            return visibleInOldState && !visibleInNewState;
        };
        const dashboardChangedInfo = {
            ...this.getAdaptableInternalApi().buildBaseContext(),
            actionName: trigger,
            oldDashboardState: oldDashboardState,
            newDashboardState: newDashboardState,
            isToolbarStateChangedToVisible: isToolbarStateChangedToVisible,
            isToolbarStateChangedToHidden: isToolbarStateChangedToHidden
        };
        if (!(0, $f94a32af7542d5ef$export$2e2bcd8739ae039)(oldDashboardState, newDashboardState)) setTimeout(()=>{
            const eventApi = this.getEventApi();
            if (eventApi) eventApi.emit('DashboardChanged', dashboardChangedInfo);
        });
    }
    fireAlertFiredEvent(alertToFire) {
        const alertFiredInfo = {
            alert: alertToFire,
            ...this.getAdaptableInternalApi().buildBaseContext()
        };
        this.getEventApi().emit('AlertFired', alertFiredInfo);
    }
    fireThemeChangedEvent(theme, trigger) {
        let themeChangedInfo = {
            ...this.getAdaptableInternalApi().buildBaseContext(),
            trigger: trigger,
            theme: theme
        };
        this.getEventApi().emit('ThemeChanged', themeChangedInfo);
    }
    fireLayoutChangedEvent(trigger, oldState, newState) {
        if ((0, $f94a32af7542d5ef$export$2e2bcd8739ae039)(oldState, newState)) return;
        const layoutChangedInfo = {
            actionName: trigger,
            oldLayoutState: oldState,
            newLayoutState: newState,
            ...this.getAdaptableInternalApi().buildBaseContext()
        };
        this.getEventApi().emit('LayoutChanged', layoutChangedInfo);
    }
    fireScheduleTriggeredEvent(schedule) {
        const scheduleTriggeredInfo = {
            ...this.getAdaptableInternalApi().buildBaseContext(),
            schedule: schedule
        };
        this.getEventApi().emit('ScheduleTriggered', scheduleTriggeredInfo);
    }
    fireDataSetSelectedEvent(dataSet) {
        if (this.isAdapTableReady()) {
            const dataSetSelectedInfo = {
                ...this.getAdaptableInternalApi().buildBaseContext(),
                dataSet: dataSet
            };
            this.getEventApi().emit('DataSetSelected', dataSetSelectedInfo);
        }
    }
    fireSystemStatusMessageDisplayedEvent(systemStatusMessageInfo) {
        const systemStatusMessageDisplayedInfo = {
            systemStatusMessageInfo: systemStatusMessageInfo,
            ...this.getAdaptableInternalApi().buildBaseContext()
        };
        this.getEventApi().emit('SystemStatusMessageDisplayed', systemStatusMessageDisplayedInfo);
    }
    fireDataImportedEvent(importData, addedRows, updatedRows) {
        const dataImportedInfo = {
            importData: importData,
            addedRows: addedRows,
            updatedRows: updatedRows,
            ...this.getAdaptableInternalApi().buildBaseContext()
        };
        this.getEventApi().emit('DataImported', dataImportedInfo);
        return dataImportedInfo;
    }
    fireBeforeAdaptableStateChangeEvent(action, state) {
        const beforeAdaptableStateChangeInfo = {
            actionName: action.type,
            ...this.getAdaptableInternalApi().buildBaseContext(),
            action: action,
            state: state
        };
        this.getEventApi().emitSync('BeforeAdaptableStateChange', beforeAdaptableStateChangeInfo);
    }
    fireAdaptableStateChangedEvent(action, oldState, newState) {
        const adaptableStateChangedInfo = {
            actionName: action.type,
            ...this.getAdaptableInternalApi().buildBaseContext(),
            action: action,
            oldState: oldState,
            newState: newState
        };
        this.getEventApi().emit('AdaptableStateChanged', adaptableStateChangedInfo);
    }
    fireAdaptableStateReloadedEvent(oldState, newState) {
        const stateReloadedInfo = {
            oldState: oldState,
            newState: newState,
            adaptableStateKey: this.getOptionsApi().getAdaptableStateKey(),
            ...this.getAdaptableInternalApi().buildBaseContext()
        };
        this.getEventApi().emit('AdaptableStateReloaded', stateReloadedInfo);
    }
    fireCalculatedColumnChangedEvent(trigger, calculatedColumn) {
        const calculatedColumnChangedInfo = {
            actionName: trigger,
            calculatedColumn: calculatedColumn,
            calculatedColumnExpressionAST: this.getExpressionApi().getASTForExpression(this.getCalculatedColumnApi().internalApi.getExpressionFromCalculatedColumn(calculatedColumn)),
            ...this.getAdaptableInternalApi().buildBaseContext()
        };
        this.getEventApi().emit('CalculatedColumnChanged', calculatedColumnChangedInfo);
    }
    fireColumnFilterAppliedEvent() {
        if (this.isAdapTableReady()) {
            const columnFilterAppliedInfo = {
                columnFilters: this.getColumnFilterApi().getColumnFilters(),
                ...this.getAdaptableInternalApi().buildBaseContext()
            };
            this.getEventApi().emit('ColumnFilterApplied', columnFilterAppliedInfo);
        }
    }
    fireGridFilterAppliedEvent() {
        if (this.isAdapTableReady()) {
            const currentGridFilter = this.getGridFilterApi().getCurrentGridFilter();
            const gridFilterAppliedInfo = {
                gridFilter: currentGridFilter,
                gridFilterExpressionAST: currentGridFilter ? this.getExpressionApi().getASTForExpression(currentGridFilter?.Expression) : null,
                ...this.getAdaptableInternalApi().buildBaseContext()
            };
            this.getEventApi().emit('GridFilterApplied', gridFilterAppliedInfo);
        }
    }
    fireRowFormSubmittedEvent(rowFormSubmittedInfo) {
        this.getEventApi().emit('RowFormSubmitted', rowFormSubmittedInfo);
    }
    fireTeamSharingEntityChangedEvent(sharedEntity) {
        if (this.isAdapTableReady()) {
            const teamSharingEntityChangedInfo = {
                ...this.getAdaptableInternalApi().buildBaseContext(),
                sharedEntity: sharedEntity
            };
            this.getEventApi().emit('TeamSharingEntityChanged', teamSharingEntityChangedInfo);
        }
    }
    fireFlashingCellDisplayedEvent(flashingCellToShow) {
        const flashingCellFiredInfo = {
            ...this.getAdaptableInternalApi().buildBaseContext(),
            flashingCell: flashingCellToShow
        };
        const results = this.getEventApi().emitSync('FlashingCellDisplayed', flashingCellFiredInfo);
    }
}


class $ab48c9edef6872b7$export$b8189126653a4626 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    emitter;
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.emitter = new (0, $7ddf72f79776fa87$export$2e2bcd8739ae039)();
        this.internalApi = new (0, $c4f1595681bbbd5e$export$a437c48cb95f7d32)(_adaptable);
    }
    destroy() {
        super.destroy();
        this.emitSync('AdaptableDestroy');
        this.emitter.destroy();
    }
    on = (eventName, callback)=>{
        let result;
        if (eventName === 'AdaptableReady') {
            this.emitter.onIncludeFiredOnce(eventName).then(callback);
            return ()=>{};
        } else result = this.emitter.on(eventName, callback);
        return result;
    };
    off = (eventName, callback)=>this.emitter.off(eventName, callback);
    emit = (eventName, data)=>this.emitter.emit(eventName, data);
    emitSync = (eventName, data)=>this.emitter.emitSync(eventName, data);
}










var $9OAZF = parcelRequire("9OAZF");




class $1b3c4cf83873cae9$export$95b4cf790235219d extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Value Items for Report Name Selection
     */ getAllAvailableReportNames() {
        return this.getExportApi().getAllReports().map((report)=>report.Name);
    }
    isDataChangeInReport(cellDataChangedInfo, report) {
        // for All Data Report any data change is true so get out asap
        if (report.Name == 'All Data') return true;
        // Start with the DataChanged Column and go through all possibilities
        switch(report.ReportColumnScope){
            case 'AllColumns':
                break;
            case 'ScopeColumns':
                // use the Scope object which will tell us if the Column is relevant
                if (!this.getAdaptableApi().columnScopeApi.isColumnInScopeColumns(cellDataChangedInfo.column, report.Scope)) return false;
                break;
            case 'SelectedColumns':
                let selectedCellInfo = this.getAdaptableApi().gridApi.getSelectedCellInfo();
                if (selectedCellInfo) {
                    if (selectedCellInfo.columns.find((c)=>c.columnId == cellDataChangedInfo.column.columnId) == null) return false;
                }
                break;
            case 'VisibleColumns':
                //  hope that visible column property is updated whenever the layout changes... (need to check!)
                if (!cellDataChangedInfo.column.visible) return false;
                break;
        }
        // now do rows
        switch(report.ReportRowScope){
            case 'AllRows':
                return true;
            case 'ExpressionRows':
                return true; // TODO this is the only difficult one - do we check AdapTableQL?  if we can then that is good as we can then do a delta after all...
            case 'SelectedRows':
                // CellSelection
                let selectedCellInfo1 = this.getAdaptableApi().gridApi.getSelectedCellInfo();
                if (selectedCellInfo1 && selectedCellInfo1.gridCells) {
                    if (selectedCellInfo1.gridCells.find((gc)=>gc.primaryKeyValue == cellDataChangedInfo.primaryKeyValue)) return true;
                }
                // Row Selection
                let selectedRowInfo = this.getAdaptableApi().gridApi.getSelectedRowInfo();
                if (selectedRowInfo && selectedRowInfo.gridRows) {
                    if (selectedRowInfo.gridRows.find((gr)=>gr.primaryKeyValue == cellDataChangedInfo.primaryKeyValue)) return true;
                }
                return false;
            case 'VisibleRows':
                return this.getGridApi().isVisibleRowNode(cellDataChangedInfo.rowNode);
        }
    }
    setExportInProgress(reportName, reportFormat, exportDestination) {
        this.dispatchAction((0, $5b564bb703f29152$export$4ee1e2e608f82222)(reportName, reportFormat, exportDestination));
    }
    setExportComplete() {
        this.dispatchAction((0, $5b564bb703f29152$export$d018884df96b3a46)());
    }
    isVisualDataExportInProgress() {
        return this.getAdaptableState().Internal.Export.inProgress?.reportFormat === 'VisualExcel';
    }
    isExcelExportInProgress() {
        return this.getAdaptableState().Internal.Export.inProgress?.reportFormat === 'Excel';
    }
    createSystemReport(systemReportName) {
        switch(systemReportName){
            case 0, $58846ea7f4156db7$export$e03caa2bde42f4d1:
                return {
                    Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
                    Name: (0, $58846ea7f4156db7$export$e03caa2bde42f4d1),
                    ReportColumnScope: 'AllColumns',
                    ReportRowScope: 'AllRows',
                    Query: undefined,
                    IsReadOnly: true
                };
            case 0, $58846ea7f4156db7$export$dfa63c611421858:
                return {
                    Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
                    Name: (0, $58846ea7f4156db7$export$dfa63c611421858),
                    ReportColumnScope: 'VisibleColumns',
                    ReportRowScope: 'VisibleRows',
                    Query: undefined,
                    IsReadOnly: true
                };
            case 0, $58846ea7f4156db7$export$4c13590ee8958b49:
                return {
                    Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
                    Name: (0, $58846ea7f4156db7$export$4c13590ee8958b49),
                    ReportColumnScope: 'SelectedColumns',
                    ReportRowScope: 'SelectedRows',
                    Query: undefined,
                    IsReadOnly: true
                };
        }
    }
    isSystemReport(reportName) {
        return (0, $58846ea7f4156db7$export$ca0f2ab5ee3c7523).includes(reportName);
    }
    isSystemDestination(destination) {
        return (0, $58846ea7f4156db7$export$8803ddc1a816b6d0).includes(destination);
    }
    isSystemReportActive(reportName) {
        if (reportName == (0, $58846ea7f4156db7$export$4c13590ee8958b49)) return this.getAdaptableApi().gridApi.isGridRangeSelectable() || this.getAdaptableApi().gridApi.isGridRowSelectable();
        return true;
    }
    getReportColumnScopeShortDescription(report) {
        switch(report.ReportColumnScope){
            case 'AllColumns':
                return [
                    '[All Columns]'
                ];
            case 'VisibleColumns':
                return [
                    '[Visible Columns]'
                ];
            case 'SelectedColumns':
                return [
                    '[Selected Columns]'
                ];
            case 'ScopeColumns':
                if ('ColumnIds' in report?.Scope) return report.Scope.ColumnIds.map?.((columnId)=>this.getAdaptableApi().columnApi.getFriendlyNameForColumnId(columnId) ?? columnId);
                return [
                    '[Bespoke Columns]'
                ];
        }
    }
    getReportColumnScopeLongDescription(report) {
        switch(report.ReportColumnScope){
            case 'AllColumns':
                return '[All Columns]';
            case 'VisibleColumns':
                return '[Visible Columns]';
            case 'SelectedColumns':
                return '[Selected Columns]';
            case 'ScopeColumns':
                return this.getAdaptableApi().columnScopeApi.getScopeDescription(report.Scope);
        }
    }
    getReportExpressionDescription(report, cols) {
        if (this.isSystemReport(report.Name)) return `[${report.Name}]`;
        else switch(report.ReportRowScope){
            case 'AllRows':
                return '[All Rows]';
            case 'VisibleRows':
                return '[Visible Rows]';
            case 'SelectedRows':
                return '[Selected Rows]';
            case 'ExpressionRows':
                return this.getAdaptableInternalApi().getAdaptableQueryExpressionText(report.Query);
        }
    }
    convertReportDataToArray(reportData) {
        return [
            reportData.columns.map((column)=>column.friendlyName),
            ...reportData.rows.map((row)=>reportData.columns.map((column)=>row[column.field ?? column.columnId]))
        ];
    }
    publishLiveLiveDataChangedEvent(reportDestination, liveDataTrigger, liveReport) {
        const liveDataChangedInfo = {
            ...this.getAdaptableInternalApi().buildBaseContext(),
            reportDestination: reportDestination,
            liveDataTrigger: liveDataTrigger,
            liveReport: liveReport
        };
        this.getAdaptableApi().eventApi.emit('LiveDataChanged', liveDataChangedInfo);
    }
    getReportFileName(reportName, reportFormat, destination) {
        let fileName = (0, $9OAZF.default).ReplaceEmptySpacesWithUnderscore(`${reportName}-${reportFormat}`);
        const reportFilename = this.getAdaptableApi().optionsApi.getExportOptions().reportFilename;
        if (reportFilename) {
            const reportFileNameContext = {
                fileName: fileName,
                ...this.buildBaseExportContext(reportName, reportFormat, destination)
            };
            fileName = reportFilename(reportFileNameContext);
        } else if (this.getAdaptableApi().optionsApi.getExportOptions().appendFileTimestamp) fileName = `${fileName}_${(0, $1fe81e1078ace264$export$ad991b66133851cf)(new Date(), {
            Pattern: 'yyyyMMdd_HHmmss'
        })}`;
        return fileName;
    }
    sendReportToDestination(reportResult, report, format, destination) {
        if (!reportResult?.data) {
            this.logWarn(`No report result to send to destination for report '${report.Name}, format '${format}' and destination '${destination}'`);
            return;
        }
        if (!this.getExportApi().isExportDestinationSystem(destination)) this.sendReportToCustomDestination(reportResult, report, format, destination);
        if (destination === 'Download') {
            if (reportResult.type === 'excel') (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).createDownloadedFile(reportResult.data, this.getReportFileName(report.Name, format, destination), 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            if (reportResult.type === 'csv') (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).createDownloadedFile(reportResult.data, this.getReportFileName(report.Name, format, destination), 'text/csv;encoding:utf-8');
            if (reportResult.type === 'json') (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).createDownloadedFile(JSON.stringify(reportResult.data), this.getReportFileName(report.Name, format, destination), 'application/json');
        }
        if (destination === 'Clipboard') {
            if (reportResult.type !== 'csv' && reportResult.type !== 'json') {
                this.logWarn(`Cannot copy to clipboard as report result is not a string (report '${report.Name}', format '${format}', destination '${destination}')`);
                return;
            }
            (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).copyToClipboard(reportResult.type === 'json' ? JSON.stringify(reportResult.data) : reportResult.data);
        }
    }
    sendReportToCustomDestination(reportResult, report, format, destination) {
        const customDestination = this.getExportApi().getAvailableCustomDestinations().find((cd)=>cd.name == destination);
        if (customDestination?.form) this.getAdaptableInternalApi().dispatchReduxAction($dc56b6267ce4d0bb$export$16bbb31452c12825({
            Id: 'export-destination-form',
            Form: customDestination?.form,
            prepareContext: (context)=>{
                // we want to give the current popup time to close
                // and we reopen with a delay in case this button action causes another popup
                return new Promise((resolve)=>{
                    setTimeout(()=>{
                        const preparedContext = {
                            ...context,
                            report: report,
                            customDestination: customDestination,
                            reportData: reportResult
                        };
                        resolve(preparedContext);
                    }, 20);
                });
            }
        }));
        else if (customDestination) {
            const reportContext = {
                report: report,
                reportData: reportResult,
                ...this.buildBaseExportContext(report.Name, format, destination)
            };
            customDestination.onExport(reportContext);
        }
    }
    buildBaseExportContext(reportName, reportFormat, exportDestination) {
        const report = this.getExportApi().getReportByName(reportName);
        return {
            ...this.getAdaptableInternalApi().buildBaseContext(),
            report: report,
            reportName: reportName,
            reportFormat: reportFormat,
            exportDestination: exportDestination
        };
    }
    createCellCsv(cellContent) {
        return {
            data: {
                value: cellContent != undefined ? String(cellContent) : null
            }
        };
    }
    createCellExcel(cellContent, cellType) {
        return {
            data: {
                value: cellContent != undefined ? String(cellContent) : null,
                type: cellType
            }
        };
    }
    createCellHeader(cellContent) {
        return {
            data: {
                value: cellContent != undefined ? String(cellContent) : null,
                type: 'String'
            }
        };
    }
    buildProcessExportContext(report, format, destination) {
        const { exportContext: exportContext } = this._adaptable.agGridExportAdapter.buildExportProcessData({
            report: report,
            format: format,
            destination: destination,
            showProgressIndicator: false
        });
        return {
            ...this.buildBaseExportContext(report.Name, format, destination),
            convertToExcel: this.buildExcelConverter(report.Name, format, destination),
            convertToCsv: this.buildCsvConverter(report.Name, format, destination),
            getReportColumns: ()=>exportContext.exportedColumnIds.map((colId)=>this.getAdaptableApi().columnApi.getColumnWithColumnId(colId, false)).filter(Boolean)
        };
    }
    exportAllDataInPivotMode(exportProcessData) {
        const { exportContext: exportContext, exportParams: exportParams } = exportProcessData;
        const exportedColumns = this.getColumnApi().getExportableColumns().filter((column)=>!column.isGeneratedPivotResultColumn && !column.isGeneratedRowGroupColumn);
        const exportedRowData = this.getGridApi().getGridData();
        const reportData = {
            columns: exportedColumns,
            rows: exportedRowData
        };
        const exportFormat = exportContext.format;
        if (exportFormat === 'JSON') return {
            data: reportData,
            type: 'json'
        };
        if (exportFormat === 'CSV') {
            const csvExportConverter = this.buildCsvConverter(exportContext.report.Name, exportFormat, exportContext.destination);
            const csvData = csvExportConverter(reportData);
            return {
                data: csvData,
                type: 'csv'
            };
        }
        // theoretically 'VisualExcel' is not a valid export format for this function and should be suppressed from UI
        // but just in case, we handle it here and return a "raw", unstyled Excel file
        if (exportFormat === 'Excel' || exportFormat === 'VisualExcel') {
            const excelExportConverter = this.buildExcelConverter(exportContext.report.Name, exportFormat, exportContext.destination);
            const excelData = excelExportConverter(reportData);
            return {
                data: excelData,
                type: 'excel'
            };
        }
    }
    buildExcelConverter(reportName, reportFormat, exportDestination) {
        return (reportData)=>{
            return this.executeGridExport(reportData, reportName, reportFormat, exportDestination, (gridApi, exportParams)=>gridApi.getDataAsExcel({
                    ...exportParams
                }));
        };
    }
    buildCsvConverter(reportName, reportFormat, exportDestination) {
        return (reportData)=>{
            const csvParams = this.buildCsvExportParams(reportName, reportFormat, exportDestination);
            return this.executeGridExport(reportData, reportName, reportFormat, exportDestination, (gridApi, exportParams)=>gridApi.getDataAsCsv({
                    ...exportParams,
                    ...csvParams
                }));
        };
    }
    executeGridExport(reportData, reportName, reportFormat, exportDestination, exportFn) {
        const htmlDivElement = document.createElement('div');
        let ephemeralGridApi = null;
        try {
            const columnDefs = reportData.columns.map((col)=>({
                    colId: col.columnId,
                    field: col.field ?? col.columnId,
                    headerName: col.friendlyName ?? col.columnId,
                    cellDataType: col.dataType ?? 'text'
                }));
            const gridOptions = {
                columnDefs: columnDefs,
                rowData: reportData.rows,
                theme: this.getAgGridApi().getGridOption('theme'),
                dataTypeDefinitions: this.getAgGridApi().getGridOption('dataTypeDefinitions'),
                columnTypes: this.getAgGridApi().getGridOption('columnTypes')
            };
            const gridParams = {
                modules: this.getAdaptableApi().internalApi.getAgGridModulesAdapter().getAgGridRegisteredModules()
            };
            htmlDivElement.style.display = 'none';
            document.body.appendChild(htmlDivElement);
            ephemeralGridApi = (0, $437b23f6a393c3bf$export$fce123c48a7b4eae)(htmlDivElement, gridOptions, gridParams);
            const exportParams = {
                fileName: this.getReportFileName(reportName, reportFormat, exportDestination),
                allColumns: true,
                exportedRows: 'all'
            };
            return exportFn(ephemeralGridApi, exportParams);
        } catch (error) {
            this.logWarn('Failed to export data:', error);
            return null;
        } finally{
            if (ephemeralGridApi) ephemeralGridApi.destroy();
            if (htmlDivElement?.parentNode) document.body.removeChild(htmlDivElement);
        }
    }
    buildCsvExportParams(reportName, reportFormat, exportDestination) {
        const exportOptions = this.getAdaptableApi().optionsApi.getExportOptions();
        const csvSeparator = typeof exportOptions.csvSeparator === 'function' ? exportOptions.csvSeparator(this.buildBaseExportContext(reportName, reportFormat, exportDestination)) : exportOptions.csvSeparator;
        return {
            columnSeparator: csvSeparator
        };
    }
}



class $f4688e90f61e3b27$export$3c545db55c640dbd extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $1b3c4cf83873cae9$export$95b4cf790235219d)(_adaptable);
    }
    getExportState() {
        return this.getAdaptableState().Export;
    }
    getCurrentReportName() {
        return this.getExportState().CurrentReport;
    }
    getCurrentReportFormat() {
        return this.getExportState().CurrentFormat;
    }
    getCurrentReport() {
        const reportName = this.getCurrentReportName();
        return this.getReportByName(reportName);
    }
    getReportByName(reportName) {
        // if system report then create
        if (this.internalApi.isSystemReport(reportName)) return this.internalApi.createSystemReport(reportName);
        const customReport = this.getCustomReports().find((r)=>r.Name == reportName);
        if (customReport) return customReport;
    }
    getReportById(id) {
        return this.getAllReports()?.find((report)=>report.Uuid === id);
    }
    getDestinationByName(destinationName) {
        if (this.internalApi.isSystemDestination(destinationName)) return destinationName;
        return this.getAvailableCustomDestinations().find((destination)=>destination.name === destinationName);
    }
    getAvailableSystemReports() {
        const systemReportNamesOption = this.getExportOptions().systemReportNames;
        const reportNames = typeof systemReportNamesOption === 'function' ? systemReportNamesOption({
            ...this.getAdaptableInternalApi().buildBaseContext(),
            defaultSystemReportNames: (0, $58846ea7f4156db7$export$ca0f2ab5ee3c7523),
            currentLayoutName: this.getLayoutApi().getCurrentLayoutName()
        }) : systemReportNamesOption;
        return reportNames.filter((s)=>this.internalApi.isSystemReportActive(s));
    }
    getAvailableSystemFormats() {
        const systemReportFormatsOption = this.getExportOptions().systemReportFormats;
        const reportFormats = typeof systemReportFormatsOption === 'function' ? systemReportFormatsOption({
            ...this.getAdaptableInternalApi().buildBaseContext(),
            defaultSystemReportFormats: (0, $58846ea7f4156db7$export$55741d64ab494b05),
            currentLayoutName: this.getLayoutApi().getCurrentLayoutName(),
            currentReportName: this.getExportApi().getCurrentReportName()
        }) : systemReportFormatsOption;
        return reportFormats.filter((format)=>{
            // JSON format doesn't support Master Detail Grid
            if (this.getGridApi().isMasterDetailGrid()) return format !== 'JSON';
            // PivotLayout & AllData can't be exported as VisualExcel
            if (this.getExportApi().getCurrentReportName() === (0, $58846ea7f4156db7$export$e03caa2bde42f4d1) && this.getLayoutApi().isCurrentLayoutPivot()) return format !== 'VisualExcel';
            return true;
        });
    }
    getAvailableSystemDestinations() {
        const systemExportDestinationsOption = this.getExportOptions().systemExportDestinations;
        const systemExportDestinations = typeof systemExportDestinationsOption === 'function' ? systemExportDestinationsOption({
            ...this.getAdaptableInternalApi().buildBaseContext(),
            defaultSystemExportDestinations: (0, $58846ea7f4156db7$export$8803ddc1a816b6d0),
            currentLayoutName: this.getLayoutApi().getCurrentLayoutName(),
            currentReportName: this.getExportApi().getCurrentReportName(),
            currentReportFormat: this.getExportApi().getCurrentReportFormat()
        }) : systemExportDestinationsOption;
        return systemExportDestinations;
    }
    getAvailableCustomDestinations() {
        const customDestinationsOption = this.getExportOptions().customDestinations;
        const customDestinations = typeof customDestinationsOption === 'function' ? customDestinationsOption({
            ...this.getAdaptableInternalApi().buildBaseContext(),
            currentLayoutName: this.getLayoutApi().getCurrentLayoutName(),
            currentReportName: this.getExportApi().getCurrentReportName(),
            currentReportFormat: this.getExportApi().getCurrentReportFormat()
        }) : customDestinationsOption;
        return customDestinations ?? [];
    }
    isExportDestinationSystem(destinationName) {
        return destinationName == (0, $58846ea7f4156db7$export$2bb87b5d4746f1a4) || destinationName == (0, $58846ea7f4156db7$export$c0901bc9360026b6);
    }
    getAllExportDestinations() {
        const destinationItems = [
            ...this.getAvailableSystemDestinations(),
            ...this.getAvailableCustomDestinations().map((destination)=>destination.name)
        ];
        return destinationItems;
    }
    getAllFormats() {
        // FIXME AFL: add here custom formats when available
        return this.getAvailableSystemFormats();
    }
    getAllReports() {
        const reports = this.getAvailableSystemReports().map((s)=>this.getReportByName(s)).concat(this.getExportState().Reports);
        return reports;
    }
    selectReport(reportName) {
        this.dispatchAction($a3814690501f278b$export$4fed8ac69b10bc84(reportName));
    }
    clearReport() {
        this.selectReport((0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1));
    }
    selectFormat(reportFormat) {
        this.dispatchAction($a3814690501f278b$export$45b3b10f3d3673c8(reportFormat));
    }
    clearFormat() {
        this.selectFormat(null);
    }
    getExportDestinationForm(destinationName) {
        return this.getAvailableCustomDestinations().find((destination)=>destination.name === destinationName)?.form;
    }
    canExportToExcel() {
        return this._adaptable.canExportToExcel();
    }
    canExportToCsv() {
        return this._adaptable.canExportToCsv();
    }
    openExportSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$2bc329d2b6ae03ac);
    }
    updateReport(report) {
        this.dispatchAction($a3814690501f278b$export$93cc87a6c44ca1b(report));
        return this.getReportById(report.Uuid);
    }
    updateReports(reports) {
        reports.forEach((report)=>{
            this.updateReport(report);
        });
        return reports?.map((report)=>this.getReportById(report.Uuid));
    }
    getCustomReports() {
        return this.getExportState().Reports ?? [];
    }
    isColumnExportable(adaptableColumn) {
        const isExportableFn = this.getExportOptions().isColumnExportable;
        if (typeof isExportableFn === 'function') {
            const adaptableColumnContext = {
                ...this.getAdaptableInternalApi().buildBaseContext(),
                column: adaptableColumn
            };
            return isExportableFn(adaptableColumnContext);
        }
        return true;
    }
    getSupportedExportDestinations(reportFormat) {
        if (reportFormat == undefined) return [];
        return this.getExportApi().getAllExportDestinations().filter((destination)=>{
            // can NOT export BLOBs to Clipboard
            if (reportFormat === 'Excel' || reportFormat === 'VisualExcel') return destination !== 'Clipboard';
            return true;
        });
    }
    async exportReport(reportName, format, destination = 'Download', exportConfig) {
        let report = this.getReportByName(reportName);
        if (!this.checkItemExists(report, reportName, 'Report')) return;
        this.logInfo(`Start Export of ${reportName} in format ${format} to ${destination}`);
        const processExportResult = await this.processExport(report, format, destination);
        // if FALSE, cancel export
        if (!processExportResult) {
            this.logInfo(`Cancel Export of ${reportName}`);
            return;
        }
        // if TRUE, continue with standard export
        if (processExportResult === true) {
            const exportedReport = await this._adaptable.agGridExportAdapter.exportData({
                report: report,
                format: format,
                destination: destination,
                showProgressIndicator: exportConfig?.showProgressIndicator === false ? false : true,
                customExportParams: exportConfig?.exportParams
            });
            if (!exportedReport) // for destination 'Download' and format 'Excel', 'VisualExcel' or 'Csv', AG Grid handles the download as well
            return;
            this.internalApi.sendReportToDestination(exportedReport, report, format, destination);
        } else {
            // in this case the user has returned a custom ExportResultData object
            const userProcessedExportResult = processExportResult;
            if (!userProcessedExportResult) {
                this.logWarn(`Processing of Export ${reportName} to ${destination} returned null or undefined`);
                return;
            }
            this.internalApi.sendReportToDestination(userProcessedExportResult, report, format, destination);
        }
        this.logInfo(`Finished Export of ${reportName} in format ${format} to ${destination}`);
    }
    async getReportData(reportName, format, config) {
        let report = this.getReportByName(reportName);
        if (!this.checkItemExists(report, reportName, 'Report')) return;
        this.logInfo(`Start getting Report Data for ${reportName} in format ${format}`);
        const processExportResult = await this.processExport(report, format, 'Clipboard');
        let reportData;
        // handle Export processing
        if (typeof processExportResult?.type === 'string') reportData = processExportResult;
        else reportData = await this._adaptable.agGridExportAdapter.exportData({
            report: report,
            format: format,
            destination: 'Clipboard',
            showProgressIndicator: config?.showProgressIndicator === false ? false : true,
            customExportParams: config?.exportParams
        });
        this.logInfo(`Finished getting Report Data for ${reportName} in format ${format}`);
        return reportData;
    }
    async processExport(report, format, destination) {
        const processExportFn = this.getExportOptions().processExport;
        if (!processExportFn) return true;
        this.logInfo(`Process Export of ${report.Name} in format ${format} to ${destination}`);
        const processExportContext = this.internalApi.buildProcessExportContext(report, format, destination);
        return processExportFn(processExportContext);
    }
}





var $9g4SS = parcelRequire("9g4SS");


var $9OAZF = parcelRequire("9OAZF");




function $21549e136899dc5f$var$getParentGroup(source) {
    if (!source) return undefined;
    let current = source;
    while(current.getParent()){
        current = current.getParent();
        if (!current) return undefined;
        const currentProvidedColumnGroup = current.getProvidedColumnGroup();
        // for columns that don't belong to groups or belong to a group that doesn't have full depth
        // there are artificial parent groups created by ag-grid
        // so for the current column group, lets grab the leaf columns
        // and if the only leaf column is the source column, then we can continue
        // and do another iteration where we go up one level
        if (currentProvidedColumnGroup) {
            const leafColumns = current.getLeafColumns();
            if (leafColumns.length === 1 && leafColumns[0] === source) continue;
            // otherwise, we have found the parent group corresponding to the source column
            return currentProvidedColumnGroup;
        }
    }
    return undefined;
}
class $21549e136899dc5f$export$9284f91ed5505b08 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Retrieves all Format Columns in Adaptable State with the `Style` property set
     * @returns format columns
     */ getAllFormatColumnWithStyle(config) {
        return this.getFormatColumnApi().getFormatColumns(config).filter((fc)=>fc.Style);
    }
    /**
     * Retrieves all Format Columns in Adaptable State with `DisplayFormat` property set
     * @returns format columns
     */ getAllFormatColumnWithDisplayFormat(config) {
        return this.getFormatColumnApi().getFormatColumns(config).filter((fc)=>fc.DisplayFormat);
    }
    /**
     * Get all FormatColumns which are defined for this column and have a custom AdaptableStyle
     * @param column
     * @param config
     * @returns list of FormatColumn
     */ getFormatColumnsWithStyleForColumn(column, config) {
        const formatColumns = this.getAllFormatColumnWithStyle().filter((formatColumn)=>{
            // FormatColumn default target is 'cell', so if no target is specified, we assume 'cell'
            const fcTarget = formatColumn.Target ?? 'cell';
            return fcTarget === config.target;
        }).filter((formatColumn)=>config?.includeSuspended || !formatColumn.IsSuspended);
        return this.getFormatColumnWithColumnInScope(formatColumns, column);
    }
    /**
     * Gets Format Column if any for given Column which includes Style element with ClassName
     * @param column The Column for which to retrieve the Format Column
     * @returns format columns
     */ getFormatColumnWithStyleClassNameForColumn(column, config) {
        return this.getFormatColumnsWithStyleForColumn(column, config).filter((formatColumn)=>(0, $9OAZF.default).IsNotNullOrEmpty(formatColumn?.Style?.ClassName));
    }
    getFormatColumnWithColumnInScope(formatColumns, column) {
        return this.getFormatColumnInColumnScope(formatColumns).filter((scopedFormatColumn)=>this.getColumnScopeApi().isColumnInScope(column, scopedFormatColumn.Scope));
    }
    // TODO is this really needed, I don't think it achieves anything
    getFormatColumnInColumnScope(formatColumns) {
        // we need to maintain the format columns order, therefore we will extract all 3 scope types in a single iteration
        return formatColumns.filter((fc)=>{
            return(// this.getFormatColumnsWithColumnScope(formatColumns)
            this.getColumnScopeApi().scopeHasColumns(fc.Scope) || // this.getFormatColumnsWithDataTypeScope(formatColumns)
            this.getColumnScopeApi().scopeHasDataType(fc.Scope) || // this.getFormatColumnsWithAllScope(formatColumns)
            this.getColumnScopeApi().scopeIsAll(fc.Scope) || this.getColumnScopeApi().scopeHasColumnType(fc.Scope));
        });
    }
    /**
     * Get all FormatColumns which are defined for this column and have a custom DisplayFormat
     * @param column
     * @param config
     * @returns list of FormatColumn
     */ getFormatColumnsWithDisplayFormatForColumn(column, config) {
        const formatColumns = this.getAllFormatColumnWithDisplayFormat().filter((formatColumn)=>{
            // FormatColumn default target is 'cell', so if no target is specified, we assume 'cell'
            const fcTarget = formatColumn.Target ?? 'cell';
            return fcTarget === config.target;
        }).filter((formatColumn)=>config?.includeSuspended || !formatColumn.IsSuspended);
        return this.getFormatColumnWithColumnInScope(formatColumns, column);
    }
    /**
     * Format value according to format options.
     *
     * @param customDisplayFormatterContext context that includes value to format
     * @param options formatter options
     */ getNumberFormattedValue(value, node, column, options) {
        const preparedValue = this.applyCustomFormatters(value, node, column, options);
        return (0, $1fe81e1078ace264$export$2e2bcd8739ae039).NumberFormatter(preparedValue, options, node, column, this.getAdaptableApi());
    }
    /**
     * Format value according to format options.
     *
     * @param value  context that includes value to format
     * @param options formatter options
     */ getStringFormattedValue(value, node, column, options) {
        const preparedValue = this.applyCustomFormatters(value, node, column, options);
        return (0, $1fe81e1078ace264$export$2e2bcd8739ae039).StringFormatter(preparedValue, options, node, column, this.getAdaptableApi());
    }
    /**
     * Format value according to format options.
     *
     * @param customDisplayFormatterContext  context that includes value to format
     * @param options formatter options
     */ getDateFormattedValue(value, node, abColumn, options) {
        const preparedValue = this.applyCustomFormatters(value, node, abColumn, options);
        const dateFormatterOptions = options;
        // only use DateFormatter if we have a pattern
        return dateFormatterOptions.Pattern ? (0, $1fe81e1078ace264$export$2e2bcd8739ae039).DateFormatter(preparedValue, options) : preparedValue;
    }
    applyCustomFormatters(value, node, abColumn, options) {
        const columnCustomFormatters = options?.CustomDisplayFormats ?? [];
        if (!columnCustomFormatters?.length) return value;
        const customFormattersFromOptions = this.getFormatColumnOptions()?.customDisplayFormatters ?? [];
        // formatters are applied in the order they are defined in the options
        const customFormatters = customFormattersFromOptions.filter((customFormatterOption)=>columnCustomFormatters.includes(customFormatterOption.id));
        const customDisplayFormatterContext = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateCustomDisplayFormatterContext(value, node, abColumn, this.getAdaptableApi());
        return customFormatters.reduce((context, formatter)=>{
            if (formatter && formatter.handler) return formatter.handler(context);
            return context.cellValue;
        }, customDisplayFormatterContext);
    }
    /**
     * Returns all Predicates appropriate for the given Scope
     * @param scope Scope to check
     */ getFormatColumnDefsForScope(scope) {
        return this.getAdaptableApi().predicateApi.internalApi.getFormatColumnPredicateDefs(scope).filter((predicateDef)=>this.getColumnScopeApi().isScopeInScope(scope, predicateDef.columnScope));
    }
    formatColumnWithColumnGroupScopeShouldRender(formatColumn, column) {
        if (!formatColumn.ColumnGroupScope) return true;
        const agGridApi = this.getAdaptableApi().agGridApi;
        const agGridColumn = this._adaptable.isInPivotMode() ? agGridApi.getPivotResultColumns().find((col)=>col.getColId() === column.columnId) : agGridApi.getColumn(column.columnId);
        if (!agGridColumn) return false;
        const columnGroupParentForCurrentColumn = $21549e136899dc5f$var$getParentGroup(agGridColumn);
        if (!columnGroupParentForCurrentColumn) return false;
        const columnGroupScope = columnGroupParentForCurrentColumn.isExpanded() ? 'Expanded' : 'Collapsed';
        const columnGroupLeafColumns = columnGroupParentForCurrentColumn.getLeafColumns();
        const columnIsTopLevel = columnGroupParentForCurrentColumn.getLevel() === 0 && columnGroupLeafColumns.length === 1 && columnGroupLeafColumns[0] === agGridColumn;
        if (columnIsTopLevel) // for top-level columns don't apply formatColumns that have an explicit ColumnGroupScope defined
        return false;
        if (formatColumn.ColumnGroupScope === 'Both') return true;
        return formatColumn.ColumnGroupScope === columnGroupScope;
    }
    /**
     * Checks if format column is relevant for a given cell (intersection of given AdaptableColumn and RowNode)
     *
     * @param formatColumn
     * @param column
     * @param params
     */ formatColumnShouldRenderInCell(formatColumn, column, rowNode, cellValue, pivotResultColumn) {
        // suspended is important to be first
        if (formatColumn.IsSuspended) return false;
        const isSummaryNode = this.getGridApi().isSummaryNode(rowNode);
        const isGroupedRowNode = this.getGridApi().isGroupRowNode(rowNode);
        const isGrandTotalRowNode = this.getGridApi().isGrandTotalRowNode(rowNode);
        if (isGrandTotalRowNode) {
            if (formatColumn.RowScope?.ExcludeTotalRows) return false;
        } else if (isSummaryNode) {
            if (formatColumn.RowScope?.ExcludeSummaryRows) return false;
        } else if (isGroupedRowNode) {
            if (formatColumn.RowScope?.ExcludeGroupRows) return false;
        } else {
            if (formatColumn.RowScope?.ExcludeDataRows) return false;
        }
        if (formatColumn.ColumnGroupScope && !this.formatColumnWithColumnGroupScopeShouldRender(formatColumn, column)) return false;
        if (!formatColumn.Rule) return true;
        // first run the predicate
        if (formatColumn.Rule.Predicates && formatColumn.Rule?.Predicates?.length) {
            const predicateDefHandlerContext = {
                value: cellValue,
                oldValue: null,
                rawValue: cellValue,
                displayValue: cellValue,
                node: rowNode,
                column: column,
                ...this.getAdaptableInternalApi().buildBaseContext()
            };
            return this.evaluatePredicate(formatColumn, predicateDefHandlerContext);
        } else if (formatColumn.Rule.BooleanExpression) return this.evaluateExpression(formatColumn, rowNode, pivotResultColumn);
        // nothing has passed then return false
        return false;
    }
    /**
     * Checks if format column is relevant for a given Column Header
     *
     * @param formatColumn
     * @param column
     */ formatColumnShouldRenderInHeader(formatColumn, column) {
        if (formatColumn.IsSuspended) return false;
        if (formatColumn.ColumnGroupScope && !this.getFormatColumnApi().internalApi.formatColumnWithColumnGroupScopeShouldRender(formatColumn, column)) return false;
        return true;
    }
    evaluatePredicate(formatColumn, predicateDefHandlerContext) {
        return this.getPredicateApi().handleColumnPredicates(formatColumn.Rule?.Predicates, predicateDefHandlerContext, false);
    }
    evaluateExpression(formatColumn, node, pivotResultColumn) {
        const isValidExpression = this.getExpressionApi().isValidBooleanExpression(formatColumn.Rule.BooleanExpression, $42e863194fcb493f$export$7b96a9104aea727f, `Invalid format column rule '${formatColumn.Rule.BooleanExpression}'`);
        try {
            return isValidExpression && this.getAdaptableApi().internalApi.getQueryLanguageService().evaluateBooleanExpression(formatColumn.Rule.BooleanExpression, $42e863194fcb493f$export$7b96a9104aea727f, node, {
                pivotResultColumn: pivotResultColumn
            });
        } catch (error) {
            (0, $10f858c943b30cc8$export$45c997b35cb132f6)(error.message);
            return false;
        }
    }
    /**
     * Extract from the given FormatColumns the one which is the most relevant  for a given cell (intersection of given AdaptableColumn and RowNode)
     *
     * @param formatColumns
     * @param column
     * @param params
     */ getMostRelevantFormatColumnForColumn(formatColumns, column, params) {
        return formatColumns.find((formatColumn)=>this.formatColumnShouldRenderInCell(formatColumn, column, params.node, params.value));
    }
    /**
     * Retrieves all Format Columns which have an Expression
     * @returns Format Columns with Expression
     */ getFormatColumnsWithExpression(config) {
        return this.getFormatColumnApi().getFormatColumns(config).filter((fc)=>!!fc.Rule?.BooleanExpression);
    }
    getFormatColumnsDependentOnColumns(columnSet, config) {
        return this.getFormatColumnApi().getFormatColumns(config).filter((fc)=>fc.Rule?.Predicates?.some((p)=>columnSet.has(p.ColumnId)));
    }
    /**
     * Retrieves the columns that need rerendering based on format column predicates.
     */ getFormatColumnColumnsDependentOnColumnChange(column) {
        const impactedColumnIds = new Set();
        impactedColumnIds.add(column.columnId);
        this.getCalculatedColumnApi().internalApi.getCalculatedColumnsDependentOnColumn(column).forEach((calculatedColumnId)=>{
            impactedColumnIds.add(calculatedColumnId);
        });
        const columnsThatNeedRefresh = new Set();
        this.getFormatColumnsDependentOnColumns(impactedColumnIds).forEach((formatColumn)=>{
            this.getAdaptableApi().columnScopeApi.getColumnsInScope(formatColumn.Scope).forEach((col)=>{
                columnsThatNeedRefresh.add(col.columnId);
            });
        });
        return [
            ...columnsThatNeedRefresh
        ];
    }
    formatColumnHeaderName(headerName, params) {
        // currently we only format the header name for normal columns (NOT column groups)
        if (!params.column) return headerName;
        const abColumn = this.getColumnApi().getColumnWithColumnId(params.column.getColId());
        const activeFormatColumnsWithDisplayFormat = this.getFormatColumnApi().internalApi.getFormatColumnsWithDisplayFormatForColumn(abColumn, {
            target: 'columnHeader'
        });
        if (!activeFormatColumnsWithDisplayFormat.length) return headerName;
        const mostRelevantFormatColumn = activeFormatColumnsWithDisplayFormat.find((formatColumn)=>this.formatColumnShouldRenderInHeader(formatColumn, abColumn));
        if (!mostRelevantFormatColumn) return headerName;
        if (mostRelevantFormatColumn.DisplayFormat?.Formatter !== 'StringFormatter') // headers are always strings, so we can only use StringFormatter
        return headerName;
        const formattedHeaderName = this.getFormatColumnApi().internalApi.getStringFormattedValue(headerName, null, abColumn, mostRelevantFormatColumn.DisplayFormat.Options);
        return formattedHeaderName;
    }
}



class $147b3ae9f718efe8$export$5b73a81d83fa68db extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $21549e136899dc5f$export$9284f91ed5505b08)(_adaptable);
    }
    getFormatColumnState() {
        return this.getAdaptableState().FormatColumn;
    }
    getFormatColumns(config) {
        return this.handleLayoutExtensionObjects(this.getFormatColumnState().FormatColumns, 'FormatColumn', config) ?? [];
    }
    getFormatColumnByUuId(id, config) {
        return this.getFormatColumns(config).find((formatColumn)=>formatColumn.Uuid === id);
    }
    getFormatColumnByName(name) {
        return this.getFormatColumns().find((formatColumn)=>formatColumn.Name === name);
    }
    getActiveFormatColumns(config) {
        return this.getFormatColumns(config).filter((formatColumn)=>!formatColumn.IsSuspended);
    }
    getDisplayFormatForColumn(column, config) {
        const formatColumns = this.getFormatColumnsForColumn(column, config);
        if ((0, $9g4SS.default).IsNullOrEmpty(formatColumns)) return undefined;
        const formatColumn = formatColumns.find((fc)=>fc.DisplayFormat != undefined);
        return formatColumn ? formatColumn.DisplayFormat : undefined;
    }
    getSuspendedFormatColumns(config) {
        return this.getFormatColumns(config).filter((formatColumn)=>formatColumn.IsSuspended);
    }
    addFormatColumn(formatColumn) {
        this.addUidToAdaptableObject(formatColumn);
        this.dispatchAction($4a80335d87022149$export$f6dd745b1428a28(formatColumn));
        return this.getFormatColumnByUuId(formatColumn.Uuid);
    }
    addFormatColumns(formatColumns) {
        this.dispatchAction($4a80335d87022149$export$2a417bad4431d29d(formatColumns));
        return formatColumns?.map((formatColumn)=>this.getFormatColumnByUuId(formatColumn.Uuid));
    }
    editFormatColumn(formatColumn) {
        this.dispatchAction($4a80335d87022149$export$fab121d063a53ee9(formatColumn));
        return this.getFormatColumnByUuId(formatColumn.Uuid);
    }
    addFormatColumnStyle(formatColumn, style) {
        formatColumn.Style = style;
        this.addFormatColumn(formatColumn);
    }
    updateFormatColumnStyle(formatColumn, style) {
        formatColumn.Style = style;
        this.dispatchAction($4a80335d87022149$export$fab121d063a53ee9(formatColumn));
    }
    deleteFormatColumn(formatColumn) {
        this.dispatchAction($4a80335d87022149$export$bf94c20884c4c766(formatColumn));
    }
    deleteAllFormatColumns() {
        this.dispatchAction($4a80335d87022149$export$2cff6889719493e2());
    }
    suspendFormatColumn(formatColumn) {
        this.dispatchAction($4a80335d87022149$export$52a202b8aebe3f3b(formatColumn));
        return this.getFormatColumnByUuId(formatColumn.Uuid);
    }
    unSuspendFormatColumn(formatColumn) {
        this.dispatchAction($4a80335d87022149$export$6597bf75fa891de6(formatColumn));
        return this.getFormatColumnByUuId(formatColumn.Uuid);
    }
    suspendAllFormatColumn() {
        this.dispatchAction($4a80335d87022149$export$3153664dd4714fde());
    }
    unSuspendAllFormatColumn() {
        this.dispatchAction($4a80335d87022149$export$3de802c1f9ca8de0());
    }
    getFormatColumnsForColumn(column, config) {
        const formatColumns = this.getFormatColumns(config).filter((formatColumn)=>config?.includeSuspended || !formatColumn.IsSuspended);
        return this.internalApi.getFormatColumnWithColumnInScope(formatColumns, column);
    }
    getFormatColumnsForColumnId(columnId, config) {
        const abColumn = this.getColumnApi().getColumnWithColumnId(columnId);
        if (!abColumn) return [];
        return this.getFormatColumnsForColumn(abColumn, config);
    }
    openFormatColumnSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$7b96a9104aea727f);
    }
    getFormatColumnsWithAllScope(formatColumns) {
        return formatColumns.filter((fc)=>this.getColumnScopeApi().scopeIsAll(fc.Scope));
    }
    getFormatColumnsWithDataTypeScope(formatColumns) {
        return formatColumns.filter((fc)=>this.getColumnScopeApi().scopeHasDataType(fc.Scope));
    }
    getFormatColumnsWithColumnScope(formatColumns) {
        return formatColumns.filter((fc)=>this.getColumnScopeApi().scopeHasColumns(fc.Scope));
    }
    hasCustomDisplayFormatter(formatColumn) {
        if (!formatColumn || !formatColumn.DisplayFormat || !formatColumn.DisplayFormat.Options) return false;
        const options = formatColumn.DisplayFormat.Options;
        const columnCustomFormatters = options?.CustomDisplayFormats ?? [];
        if (!columnCustomFormatters?.length) return false;
        return true;
    }
    incrementFormatColumnPrecedence(formatColumn) {
        this.dispatchAction($4a80335d87022149$export$87b5a2238e687c4b(formatColumn));
    }
    decrementFormatColumnPrecedence(formatColumn) {
        this.dispatchAction($4a80335d87022149$export$6b99718b79b178be(formatColumn));
    }
    findFormatColumns(criteria) {
        const config = {
            includeLayoutNotExtendedObjects: true
        };
        return this.getAdaptableInternalApi().findAdaptableObjectsByLookupCriteria(criteria, this.getFormatColumns(config));
    }
}






var $9g4SS = parcelRequire("9g4SS");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
'use strict';

$701b6c0516155145$exports = (parcelRequire("iZZ9K"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($55388fc2f116d4d7$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                    case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                    case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                            case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                            case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                            case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                return object;
                            case $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$IS_REACT_19 ? $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE : $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isDOM = /* @__PURE__ */ $55388fc2f116d4d7$var$canUseDOM();
var $55388fc2f116d4d7$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$isReactNative = /* @__PURE__ */ $55388fc2f116d4d7$var$isRunningInReactNative();
var $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect = ()=>$55388fc2f116d4d7$var$isDOM || $55388fc2f116d4d7$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$acw62.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/components/connect.tsx
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;




const $675a8d61c71f0ed7$export$4a37e504e8ce5970 = (children, adaptable)=>{
    return $acw62.createElement((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
        store: adaptable.adaptableStore.TheStore
    }, $acw62.createElement((0, $599140a53e2e68e7$export$fefa09e87d1a013f), null, $acw62.createElement((0, $4f57eeaf0bf16291$export$2e2bcd8739ae039).Provider, {
        value: adaptable
    }, children)));
};



var $acw62 = parcelRequire("acw62");


const $35928be3e87634f5$var$fillStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
};
const $35928be3e87634f5$var$hostStyle = {
    ...$35928be3e87634f5$var$fillStyle,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
};
const $35928be3e87634f5$var$inputStyle = {
    position: 'relative',
    background: 'transparent',
    boxSizing: 'border-box',
    minWidth: 0,
    outline: 'none',
    width: '100%',
    border: 'none'
};
const $35928be3e87634f5$var$disallowedChars = new Set([
    'e',
    'E'
]);
const $35928be3e87634f5$var$preventDisallowedChars = (e)=>{
    // prevent the user from entering the 'e' character - issue #2839
    if ($35928be3e87634f5$var$disallowedChars.has(e.key)) e.preventDefault();
};
const $35928be3e87634f5$export$1584c9b5cbc898c3 = $acw62.forwardRef(function InternalAdaptableNumberEditorFn(props, ref) {
    const inputRef = $acw62.useRef(null);
    const focus = ()=>{
        inputRef.current?.focus();
    };
    const [value, setValue] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'value', props.defaultValue, {
        onChange: (value)=>{
            if (value !== '' && value == Number(value)) value = Number(value);
            props.onValueChange?.(value);
        }
    });
    $acw62.useEffect(()=>{
        // When the editor is opened by typing, the value is not set, even if the user
        // dismisses the editing by pressing enter or clicking outside, this forces the value to be set.
        setValue(props.defaultValue);
    }, []);
    $acw62.useImperativeHandle(ref, ()=>{
        return {
            focus: focus,
            setValue: setValue
        };
    });
    const showClear = props.showClearButton && props.emptyValue != null && value != props.emptyValue;
    return $acw62.createElement("div", {
        style: $35928be3e87634f5$var$hostStyle,
        onKeyDown: (e)=>{
            if (e.key === 'Tab' && showClear && document.activeElement === inputRef.current) e.stopPropagation();
        }
    }, $acw62.createElement("input", {
        "data-name": "AdaptableNumberEditorInput",
        type: props.type ?? 'number',
        value: value,
        onKeyDown: $35928be3e87634f5$var$preventDisallowedChars,
        onChange: $acw62.useCallback((event)=>{
            setValue(event.target.value);
        }, []),
        style: $35928be3e87634f5$var$inputStyle,
        ref: inputRef
    }), showClear ? $acw62.createElement("div", {
        className: "twa:inline-block twa:mx-1",
        onClick: (e)=>{
            if (props.emptyValue != null) {
                setValue(props.emptyValue);
                e.stopPropagation();
                focus();
            }
        },
        onKeyDown: (e)=>{
            if (props.emptyValue != null && e.key === 'Enter') {
                setValue(props.emptyValue);
                e.stopPropagation();
                focus();
            }
        }
    }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        size: 15,
        name: "close",
        tabIndex: 0
    })) : null);
});



function $c3d8609e2b1c456b$var$shouldClearExistingValue(params) {
    return params.eventKey === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).BACKSPACE || params.eventKey === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DELETE;
}
function $c3d8609e2b1c456b$var$isValidChar(char) {
    // allow only digits
    return [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ].includes(char);
// we do NOT allow key shortcuts for starting non-digits (minus sign, decimal separators) as the input[number] handling is very buggy and we would open a can of worms
}
function $c3d8609e2b1c456b$export$e2d7eaa2ea5b61c4(params) {
    if ($c3d8609e2b1c456b$var$shouldClearExistingValue(params)) return '';
    if (params.eventKey && $c3d8609e2b1c456b$var$isValidChar(params.eventKey)) return Number(params.eventKey);
    return params.value;
}
const $c3d8609e2b1c456b$var$defaultValueParser = ({ newValue: newValue, oldValue: _ })=>{
    return newValue;
};
const $c3d8609e2b1c456b$var$style = {
    position: 'absolute',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px'
};
const $c3d8609e2b1c456b$export$3ea9d4b212fbd8c8 = (0, $acw62.forwardRef)((props, ref)=>{
    const [initialValue] = (0, $acw62.useState)(()=>$c3d8609e2b1c456b$export$e2d7eaa2ea5b61c4(props));
    const valueRef = (0, $acw62.useRef)(initialValue);
    const columnId = props.column.getColId();
    const adaptable = props.context.__adaptable;
    const colValueParser = props.column.getColDef().valueParser;
    const valueParser = typeof colValueParser === 'function' ? colValueParser : $c3d8609e2b1c456b$var$defaultValueParser;
    function onValueChange(value) {
        value = valueParser ? valueParser({
            ...props,
            oldValue: props.value,
            newValue: value
        }) : value;
        valueRef.current = value;
        props.onValueChange?.(value);
    }
    const editorRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return {
            focusIn () {
                editorRef.current?.focus();
            },
            // the final value to send to the grid, on completion of editing
            getValue () {
                return valueRef.current;
            }
        };
    });
    const editorElement = $acw62.createElement((0, $35928be3e87634f5$export$1584c9b5cbc898c3), {
        defaultValue: initialValue,
        showClearButton: props.showClearButton ?? true,
        emptyValue: props.emptyValue ?? '',
        onValueChange: onValueChange,
        ref: (editor)=>{
            editorRef.current = editor;
            editor?.focus();
        }
    });
    function onKeyDown(keyDownEvent) {
        adaptable._emit('CellEditorKeyDown', {
            keyDownEvent: keyDownEvent,
            cellValue: valueRef.current,
            columnId: columnId,
            updateValueCallback: (updatedValue)=>{
                editorRef.current.setValue(updatedValue);
            }
        });
    }
    return $acw62.createElement("div", {
        style: $c3d8609e2b1c456b$var$style,
        onKeyDown: onKeyDown
    }, (0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)(editorElement, adaptable));
});
$c3d8609e2b1c456b$export$3ea9d4b212fbd8c8.displayName = 'AdaptableReactNumberEditor';
class $c3d8609e2b1c456b$export$68d9a13d1f99463a {
    value;
    columnId;
    el;
    params;
    editor;
    valueParser = $c3d8609e2b1c456b$var$defaultValueParser;
    unmountReactRoot;
    init(params) {
        this.value = $c3d8609e2b1c456b$export$e2d7eaa2ea5b61c4(params);
        this.params = params;
        this.columnId = params.column.getColId();
        const { valueParser: valueParser } = params.column.getColDef();
        if (typeof valueParser === 'function') this.valueParser = valueParser;
        this.el = document.createElement('div');
        Object.keys($c3d8609e2b1c456b$var$style).forEach((key)=>{
            //@ts-ignore
            this.el.style[key] = $c3d8609e2b1c456b$var$style[key];
        });
    }
    /* Component Editor Lifecycle methods */ // gets called once when grid ready to insert the element
    getGui() {
        return this.el;
    }
    // the final value to send to the grid, on completion of editing
    getValue() {
        return this.value;
    }
    focusIn() {
        this.editor?.focus();
    }
    focusOut() {}
    // after this component has been created and inserted into the grid
    afterGuiAttached() {
        const adaptable = this.params.context.__adaptable;
        const defaultValue = this.value;
        const editorElement = $acw62.createElement((0, $35928be3e87634f5$export$1584c9b5cbc898c3), {
            defaultValue: defaultValue,
            showClearButton: this.params.showClearButton ?? true,
            emptyValue: this.params.emptyValue ?? '',
            onValueChange: this.onValueChange,
            ref: (editor)=>{
                this.editor = editor;
                editor?.focus();
            }
        });
        this.unmountReactRoot = adaptable.renderReactRoot((0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)(editorElement, adaptable), this.el);
        this.getGui().addEventListener('keydown', (keyDownEvent)=>{
            adaptable._emit('CellEditorKeyDown', {
                keyDownEvent: keyDownEvent,
                cellValue: this.value,
                columnId: this.columnId,
                updateValueCallback: (updatedValue)=>{
                    this.editor.setValue(updatedValue);
                }
            });
        });
    }
    destroy() {
        this.unmountReactRoot?.();
    }
    onValueChange = (value)=>{
        this.value = this.valueParser ? this.valueParser({
            ...this.params,
            oldValue: this.params.value,
            newValue: value
        }) : value;
    };
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





const $60ae6884fd52a41c$var$fillStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
};
const $60ae6884fd52a41c$var$hostStyle = {
    ...$60ae6884fd52a41c$var$fillStyle,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
};
const $60ae6884fd52a41c$var$inputStyle = {
    position: 'relative',
    background: 'transparent',
    boxSizing: 'border-box',
    minWidth: 0,
    outline: 'none',
    width: '100%',
    border: 'none'
};
const $60ae6884fd52a41c$export$8b253e32a7bc8254 = $acw62.forwardRef((props, ref)=>{
    const inputRef = $acw62.useRef(null);
    const focus = ()=>{
        inputRef.current?.focus();
    };
    const [value, setValue] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'value', props.defaultValue, {
        onChange: (value)=>{
            if (value === '' || value == undefined) props.onValueChange?.(null);
            else {
                const date = typeof value === 'string' ? (0, $a92bacc669eda25d$export$4393d2ccbbedb219)(value) : new Date(value);
                props.onValueChange?.(date);
            }
        }
    });
    $acw62.useImperativeHandle(ref, ()=>{
        return {
            focus: focus
        };
    });
    const stringValue = (0, $eccba2ee7b674d85$export$53b52b78a0e685f9)(value, props.dateFormat);
    const onChange = $acw62.useCallback((event)=>{
        setValue(event.target.value);
    }, []);
    return $acw62.createElement("div", {
        style: $60ae6884fd52a41c$var$hostStyle
    }, $acw62.createElement((0, $4ac5c79eccb33a7d$export$c06d5b9df04932bc).Provider, {
        value: {
            onHide: (keyboardEventKey)=>{
                props.onStopEdit?.(keyboardEventKey);
            },
            onShow: ()=>{}
        }
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        type: 'date',
        value: stringValue,
        onChange: onChange,
        style: $60ae6884fd52a41c$var$inputStyle,
        ref: inputRef
    })));
});




function $1895fb0628decee6$var$shouldClearExistingValue(params) {
    return params.eventKey === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).BACKSPACE || params.eventKey === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DELETE;
}
function $1895fb0628decee6$var$getStartValue(params) {
    return $1895fb0628decee6$var$shouldClearExistingValue(params) ? '' : params.value;
}
const $1895fb0628decee6$var$style = {
    position: 'absolute',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px'
};
const $1895fb0628decee6$var$defaultDateValueParser = ({ newValue: newValue, oldValue: oldValue, defaultParser: defaultParser })=>{
    if ((typeof oldValue === 'string' || oldValue == null) && defaultParser) return defaultParser(newValue);
    return newValue;
};
const $1895fb0628decee6$export$d2567bcbf88954a7 = (0, $acw62.forwardRef)((props, ref)=>{
    const [initialValue] = (0, $acw62.useState)(()=>$1895fb0628decee6$var$getStartValue(props));
    const valueRef = (0, $acw62.useRef)(initialValue);
    const colValueParser = props.column.getColDef().valueParser;
    const valueParser = typeof colValueParser === 'function' ? colValueParser : $1895fb0628decee6$var$defaultDateValueParser;
    const adaptable = props.context.__adaptable;
    const editorRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return {
            focusIn () {
                editorRef.current?.focus();
            },
            // the final value to send to the grid, on completion of editing
            getValue () {
                return valueRef.current;
            }
        };
    });
    const editorElement = $acw62.createElement((0, $60ae6884fd52a41c$export$8b253e32a7bc8254), {
        defaultValue: initialValue,
        dateFormat: adaptable.adaptableOptions.userInterfaceOptions.dateInputOptions.dateFormat,
        onValueChange: (value)=>{
            const invalid = isNaN(+value);
            if (valueParser) {
                const params = {
                    ...props,
                    oldValue: props.value,
                    newValue: value,
                    defaultParser: (value)=>{
                        const Pattern = adaptable.adaptableOptions.userInterfaceOptions?.dateInputOptions?.dateFormat;
                        if (!Pattern) return value;
                        return (0, $1fe81e1078ace264$export$ad991b66133851cf)(value, {
                            Pattern: Pattern
                        });
                    }
                };
                // @ts-ignore it will be fixed with https://github.com/AdaptableTools/adaptable/issues/2230
                valueRef.current = valueParser(params);
                props.onValueChange?.(valueRef.current);
            } else valueRef.current = invalid ? null : value;
            if (!invalid) requestAnimationFrame(()=>{
                props.stopEditing();
            });
        },
        onStopEdit: (keyboardEventKey)=>{
            if (keyboardEventKey === 'Escape') props.api.stopEditing(true);
            else props.stopEditing();
        },
        ref: (editor)=>{
            editorRef.current = editor;
            editor?.focus();
        }
    });
    return $acw62.createElement("div", {
        style: $1895fb0628decee6$var$style
    }, (0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)(editorElement, adaptable));
});
class $1895fb0628decee6$export$cb88f9a0542eb9dd {
    value;
    el;
    params;
    editor;
    unmountReactRoot;
    valueParser = $1895fb0628decee6$var$defaultDateValueParser;
    init(params) {
        this.value = $1895fb0628decee6$var$getStartValue(params);
        const { valueParser: valueParser } = params.column.getColDef();
        this.params = params;
        if (typeof valueParser === 'function') this.valueParser = valueParser;
        this.el = document.createElement('div');
        Object.keys($1895fb0628decee6$var$style).forEach((key)=>{
            //@ts-ignore
            this.el.style[key] = $1895fb0628decee6$var$style[key];
        });
    }
    /* Component Editor Lifecycle methods */ // gets called once when grid ready to insert the element
    getGui() {
        return this.el;
    }
    // the final value to send to the grid, on completion of editing
    getValue() {
        return this.value;
    }
    focusIn() {
        this.editor?.focus();
    }
    focusOut() {}
    getAdaptableInstance(params) {
        const adaptable = params.context.__adaptable;
        return adaptable;
    }
    // after this component has been created and inserted into the grid
    afterGuiAttached() {
        const adaptable = this.getAdaptableInstance(this.params);
        const defaultValue = $1895fb0628decee6$var$shouldClearExistingValue(this.params) ? '' : this.params.value;
        const editorElement = $acw62.createElement((0, $60ae6884fd52a41c$export$8b253e32a7bc8254), {
            defaultValue: defaultValue,
            dateFormat: adaptable.adaptableOptions.userInterfaceOptions.dateInputOptions.dateFormat,
            onValueChange: (value)=>{
                const invalid = isNaN(+value);
                if (this.valueParser) {
                    const params = {
                        ...this.params,
                        oldValue: this.params.value,
                        newValue: value,
                        defaultParser: (value)=>{
                            const Pattern = adaptable.adaptableOptions.userInterfaceOptions?.dateInputOptions?.dateFormat;
                            if (!Pattern) return value;
                            return (0, $1fe81e1078ace264$export$ad991b66133851cf)(value, {
                                Pattern: Pattern
                            });
                        }
                    };
                    // @ts-ignore it will be fixed with https://github.com/AdaptableTools/adaptable/issues/2230
                    this.value = this.valueParser(params);
                } else this.value = invalid ? null : value;
                if (!invalid) requestAnimationFrame(()=>{
                    this.params.stopEditing();
                });
            },
            onStopEdit: (keyboardEventKey)=>{
                if (keyboardEventKey === 'Escape') this.params.api.stopEditing(true);
                else this.params.stopEditing();
            },
            ref: (editor)=>{
                this.editor = editor;
                editor?.focus();
            }
        });
        this.unmountReactRoot = adaptable.renderReactRoot((0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)(editorElement, adaptable), this.el);
    }
    destroy() {
        this.unmountReactRoot?.();
    }
}



var $9g4SS = parcelRequire("9g4SS");

class $853f5601885e3a70$export$50fa1b3e7b0c3ea7 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Checks if a User Edit was in a Free Text Column
     * @param cellDataChangedInfo change to check
     */ handleFreeTextColumnDataChange(cellDataChangedInfo) {
        let freeTextColumn = this.getFreeTextColumnApi().getFreeTextColumns().find((fc)=>fc.ColumnId == cellDataChangedInfo.column.columnId);
        if (freeTextColumn) {
            let freeTextStoredValue = {
                PrimaryKey: cellDataChangedInfo.primaryKeyValue,
                FreeText: cellDataChangedInfo.newValue
            };
            this.getFreeTextColumnApi().setStoredValue(freeTextColumn.ColumnId, freeTextStoredValue);
        }
    }
    /**
     * Returns all the references in the AdaptableState of the given FreeTextColumn
     * @param freeTextColumn FreeTextColumn to be checked
     */ getFreeTextColumnModuleReferences(freeTextColumn) {
        const references = [];
        this.getAdaptableInternalApi().getModules().forEach((module)=>{
            if (module.getModuleFreeTextColumnReferences().some((moduleReference)=>moduleReference.Uuid === freeTextColumn.Uuid)) references.push(module.moduleInfo.FriendlyName);
        });
        return references;
    }
    getColDefsForFreeTextColumns() {
        const defaultSpecialColumnSettings = this.getGridApi().internalApi.deriveSpecialColumnSettingsFromAgGridDefaultColDef();
        const defaultFreeTextColumnSettings = (0, $c94ad2cb10a8d2c3$export$91f0cae9ac0ed243)(defaultSpecialColumnSettings).FreeTextColumnSettings;
        return this.getFreeTextColumnApi().getFreeTextColumns().map((freeTextColumn)=>{
            const freeTextColumnSettings = {
                ...defaultFreeTextColumnSettings,
                ...freeTextColumn.FreeTextColumnSettings
            };
            const dataTypeEditor = freeTextColumnSettings.DataType === 'number' ? (0, $c3d8609e2b1c456b$export$68d9a13d1f99463a) : freeTextColumnSettings.DataType === 'date' ? (0, $1895fb0628decee6$export$cb88f9a0542eb9dd) : null;
            const columnTypes = [
                (0, $b0d14b794bdca4f2$export$2460c0dec1fc4d43)
            ];
            if ((0, $9g4SS.default).IsNotNullOrEmpty(freeTextColumn?.FreeTextColumnSettings?.ColumnTypes)) columnTypes.push(...freeTextColumn.FreeTextColumnSettings.ColumnTypes);
            const newColDef = {
                headerName: freeTextColumn.FriendlyName || freeTextColumn.ColumnId,
                colId: freeTextColumn.ColumnId,
                editable: true,
                hide: false,
                width: freeTextColumnSettings.Width,
                enableValue: freeTextColumnSettings.Aggregatable,
                filter: freeTextColumnSettings.Filterable,
                floatingFilter: freeTextColumnSettings.Filterable,
                resizable: freeTextColumnSettings.Resizable,
                enableRowGroup: freeTextColumnSettings.Groupable,
                sortable: freeTextColumnSettings.Sortable,
                enablePivot: freeTextColumnSettings.Pivotable,
                suppressHeaderMenuButton: freeTextColumnSettings.SuppressMenu,
                suppressMovable: freeTextColumnSettings.SuppressMovable,
                cellEditor: dataTypeEditor ?? (freeTextColumn.TextEditor && freeTextColumn.TextEditor == 'Large' ? 'agLargeTextCellEditor' : 'agTextCellEditor'),
                type: columnTypes,
                valueSetter: (params)=>{
                    return params.data[freeTextColumn.ColumnId] = params.newValue;
                },
                cellDataType: freeTextColumnSettings.DataType,
                valueGetter: (params)=>this.getFreeTextColumnApi().getFreeTextColumnValueForRowNode(freeTextColumn, params.node)
            };
            if (freeTextColumnSettings.HeaderToolTip) newColDef.headerTooltip = freeTextColumnSettings.HeaderToolTip;
            this.logInfo('Setting up FreeText Column: ' + freeTextColumn.ColumnId);
            return newColDef;
        });
    }
    validateDeletedFreeTextColumn(freeTextColumn) {
        const freeTextColumnReferences = this.getFreeTextColumnModuleReferences(freeTextColumn);
        if (freeTextColumnReferences.length) {
            const alert = {
                alertType: 'generic',
                header: 'Free Text Column',
                message: `This Free Text Column cannot be deleted. It is still referenced by: ${freeTextColumnReferences.join(', ')}.`,
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
            };
            this.getAlertApi().displayAdaptableAlertNotification(alert);
            return false;
        } else return true;
    }
}


class $cd0efe97966e4d02$export$8b647f20721765b8 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $853f5601885e3a70$export$50fa1b3e7b0c3ea7)(_adaptable);
    }
    getFreeTextColumnState() {
        return this.getAdaptableState().FreeTextColumn;
    }
    getFreeTextColumns() {
        return this.getFreeTextColumnState().FreeTextColumns ?? [];
    }
    getFreeTextColumnById(technicalId) {
        return this.getFreeTextColumns().find((ftc)=>ftc.Uuid === technicalId);
    }
    getFreeTextColumnForColumnId(columnId) {
        return this.getFreeTextColumns().find((ftc)=>ftc.ColumnId === columnId);
    }
    addFreeTextColumn(freeTextColumn) {
        this.addUidToAdaptableObject(freeTextColumn);
        this.dispatchAction($d8c519ae038bb984$export$4ca8d1bea9462d79(freeTextColumn));
        return this.getFreeTextColumnById(freeTextColumn?.Uuid);
    }
    editFreeTextColumn(freeTextColumn) {
        this.dispatchAction($d8c519ae038bb984$export$a83bd142017e0411(freeTextColumn));
        return this.getFreeTextColumnById(freeTextColumn?.Uuid);
    }
    setStoredValue(columnId, storedValue) {
        const freeTextColumn = this.getFreeTextColumnForColumnId(columnId);
        if (!freeTextColumn) {
            this.logWarn(`No FreeTextColumn with columnId=${columnId} was found!`);
            return;
        }
        this.dispatchAction($d8c519ae038bb984$export$fd759d45e00fce50(freeTextColumn, storedValue));
        return this.getFreeTextColumnById(freeTextColumn?.Uuid);
    }
    setStoredValues(columnId, storedValues, replaceAction) {
        const freeTextColumn = this.getFreeTextColumnForColumnId(columnId);
        if (freeTextColumn) {
            if (replaceAction == 'All') freeTextColumn.FreeTextStoredValues = storedValues;
            else {
                const existingPKValues = (0, $9g4SS.default).IsNotNullOrEmpty(freeTextColumn.FreeTextStoredValues) ? freeTextColumn.FreeTextStoredValues.map((fts)=>{
                    return fts.PrimaryKey;
                }) : [];
                storedValues.forEach((sv)=>{
                    // do summat
                    const isExistingPKValue = existingPKValues.find((epk)=>epk == sv.PrimaryKey);
                    if (isExistingPKValue) {
                        if (replaceAction == 'Conflicting') {
                            let existingItem = freeTextColumn.FreeTextStoredValues.find((fsv)=>fsv.PrimaryKey == sv.PrimaryKey);
                            if (existingItem) existingItem.FreeText = sv.FreeText;
                        } else freeTextColumn.FreeTextStoredValues.push(sv);
                    } else // no existing value so just add it
                    freeTextColumn.FreeTextStoredValues.push(sv);
                });
            }
            this.dispatchAction($d8c519ae038bb984$export$a83bd142017e0411(freeTextColumn));
        }
    }
    deleteFreeTextColumn(columnId) {
        let freeTextColumn = this.getFreeTextColumns().find((ftc)=>ftc.ColumnId == columnId);
        if (this.checkItemExists(freeTextColumn, columnId, $42e863194fcb493f$export$7a2c7140815c0686)) this.dispatchAction($d8c519ae038bb984$export$9de6cb54225dd17a(freeTextColumn));
    }
    openFreeTextColumnSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$7a2c7140815c0686);
    }
    getFreeTextColumnValueForRowNode(freeTextColumn, rowNode) {
        try {
            if (this.getGridApi().isGroupRowNode(rowNode)) return null;
            if ((0, $9g4SS.default).IsNotNullOrEmpty(freeTextColumn.FreeTextStoredValues)) {
                let pkValue = this.getGridApi().getPrimaryKeyValueForRowNode(rowNode);
                let freeTextStoredValue = freeTextColumn.FreeTextStoredValues.find((fdx)=>fdx.PrimaryKey == pkValue);
                if (freeTextStoredValue) return freeTextStoredValue.FreeText;
            }
            return freeTextColumn.DefaultValue;
        } catch (e) {
            this.logError(e);
            return null;
        }
    }
}






var $hrtGQ = parcelRequire("hrtGQ");


var $9g4SS = parcelRequire("9g4SS");


var $hrtGQ = parcelRequire("hrtGQ");
function $3ca1f4c2b77d4ce9$export$dc8de070e3f64a1a(e) {
    const vals = Object.keys(e).map((k)=>e[k]);
    return vals.filter((v)=>typeof v === 'string');
}
function $3ca1f4c2b77d4ce9$export$90a922b35caea340(fontSize) {
    switch(fontSize){
        case (0, $hrtGQ.FontSize).XLarge:
            return 'x-large';
        case (0, $hrtGQ.FontSize).Large:
            return 'large';
        case (0, $hrtGQ.FontSize).Medium:
            return 'medium';
        case (0, $hrtGQ.FontSize).Small:
            return 'small';
        case (0, $hrtGQ.FontSize).XSmall:
            return 'x-small';
    }
}
const $3ca1f4c2b77d4ce9$export$51594d8e7854ff7d = {
    getNames: $3ca1f4c2b77d4ce9$export$dc8de070e3f64a1a,
    getCssFontSizeFromFontSizeEnum: $3ca1f4c2b77d4ce9$export$90a922b35caea340
};
var $3ca1f4c2b77d4ce9$export$2e2bcd8739ae039 = $3ca1f4c2b77d4ce9$export$51594d8e7854ff7d;


const $0f8018328b88def3$export$d84d36ac92c2421a = [
    'backgroundColor',
    'color',
    'fontWeight',
    'fontStyle',
    'fontSize',
    'borderColor',
    // needed for quick search
    // as otherwise, the currentTextMatchStyle is not removed correctly
    // from the cell when looping through the values, and the cell is no longer the current match
    '--ab-dynamic-background-color',
    '--ab-dynamic-color',
    '--ab-dynamic-font-weight',
    '--ab-dynamic-font-style',
    '--ab-dynamic-font-size',
    '--ab-dynamic-text-decoration',
    '--ab-dynamic-border-radius',
    '--ab-dynamic-border-color'
];
const $0f8018328b88def3$export$8a5809405306d9ac = (style)=>{
    const normalizedStyle = {
        ...style
    };
    $0f8018328b88def3$export$d84d36ac92c2421a.forEach((cellStylePropKey)=>{
        if (normalizedStyle[cellStylePropKey] == null) normalizedStyle[cellStylePropKey] = '';
    });
    return normalizedStyle;
};
const $0f8018328b88def3$export$2709a6cd5918a828 = (style)=>{
    const sanitizedStyle = {};
    Object.keys(style).forEach((key)=>{
        if (style[key] != null && style[key] !== '') sanitizedStyle[key] = style[key];
    });
    return sanitizedStyle;
};
const $0f8018328b88def3$export$f3ef81ff0b20b4d5 = (style)=>{
    let result = {};
    if (style.BackColor !== undefined && style.BackColor !== null) result.backgroundColor = style.BackColor;
    if (style.ForeColor !== undefined && style.ForeColor !== null) result.color = style.ForeColor;
    if (style.FontWeight !== undefined && style.FontWeight !== null) result.fontWeight = style.FontWeight.toLocaleLowerCase();
    if (style.FontStyle !== undefined && style.FontStyle !== null) result.fontStyle = style.FontStyle.toLocaleLowerCase();
    if (style.FontSize !== undefined && style.FontSize !== null) result.fontSize = (0, $3ca1f4c2b77d4ce9$export$51594d8e7854ff7d).getCssFontSizeFromFontSizeEnum(style.FontSize);
    if (style.BorderColor !== undefined && style.BorderColor !== null) result.borderColor = style.BorderColor;
    if (style.BorderRadius !== undefined && style.BorderRadius !== null) {
        const preparedRadious = typeof style.BorderRadius === 'number' ? `${style.BorderRadius}px` : style.BorderRadius;
        result.borderRadius = preparedRadious;
    }
    if (style.TextDecoration !== undefined && style.TextDecoration !== null) switch(style.TextDecoration){
        case 'None':
            break;
        case 'Underline':
            result.textDecoration = 'underline';
            break;
        case 'Overline':
            result.textDecoration = 'overline';
            break;
        case 'LineThrough':
            result.textDecoration = 'line-through';
            break;
    }
    if (style.Alignment) switch(style.Alignment){
        case 'Default':
        case 'Left':
            result.textAlign = 'left';
            break;
        case 'Right':
            result.textAlign = 'right';
            break;
        case 'Center':
            result.textAlign = 'center';
            break;
    }
    // assertion added to comply with the ag-Grid types
    return result;
};
const $0f8018328b88def3$export$c06e2b8d470b67bb = (fontSize)=>{
    switch(fontSize){
        case 'x-large':
            return 18;
        case 'large':
            return 13.5;
        case 'medium':
            return 12;
        case 'small':
            return 10;
        case 'x-small':
            return 7;
        default:
            return 12;
    }
};
const $0f8018328b88def3$export$b7b312ddf6b38c9f = (style)=>{
    return {
        ...$0f8018328b88def3$export$f3ef81ff0b20b4d5(style ?? {}),
        borderWidth: style?.BorderColor ? 2 : 0,
        borderStyle: 'solid'
    };
};
const $0f8018328b88def3$export$fb1c9088cfbed114 = (variable)=>{
    const isVariable = variable?.startsWith?.('var(');
    if (!isVariable) return variable;
    const match = /\((.+)\)/.exec(variable);
    if (!match) return variable;
    return getComputedStyle(document.documentElement).getPropertyValue(match[1]).trim();
};



var $5aWMQ = parcelRequire("5aWMQ");

class $0bcc5a009234cdaf$export$436409cfee65d88b extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Gets all distinct display values in the Column for given ColumnId
     * @param columnId Column to check
     */ getDistinctDisplayValuesForColumnOld(columnId) {
        const abColumn = this.getColumnApi().getColumnWithColumnId(columnId);
        if (abColumn == undefined) return [];
        const returnValues = this._adaptable.getDistinctGridCellsForColumn(abColumn);
        return this.sortDistinctValues(returnValues, abColumn).map((cv)=>{
            return cv.normalisedValue;
        });
    }
    /**
     * Gets all distinct Filter values for the Column with the given ColumnId
     * used for Floating Filter and Column Header filter
     * either returns a list of values or al ist a list of values with count
     *
     * This is a general method, and it is used in:
     * - Column Filters
     * - Query Builder
     * - Permitted Values
     *
     * @param columnId Column to check
     */ async getDistinctFilterDisplayValuesForColumn(options) {
        const abColumn = this.getColumnApi().getColumnWithColumnId(options.columnId);
        if (abColumn == undefined) return {
            values: []
        };
        const inFilterValues = await this._adaptable.getDistinctFilterValuesForColumn({
            column: abColumn,
            get currentSearchValue () {
                return options.currentSearchValue;
            },
            previousResult: options.previousResult
        });
        return inFilterValues || {
            values: []
        };
    }
    async getDistinctValuesForColumn(columnId) {
        const abColumn = this.getColumnApi().getColumnWithColumnId(columnId);
        if (!abColumn) return undefined;
        const gridCells = await this._adaptable.getDistinctValuesForColumn(abColumn);
        return gridCells;
    }
    async getDistinctEditDisplayValuesForColumn(options) {
        const abColumn = this.getColumnApi().getColumnWithColumnId(options.columnId);
        if (!abColumn) return undefined;
        const valueOptions = await this._adaptable.getDistinctEditValuesForColumn({
            column: abColumn,
            gridCell: options.gridCell,
            get currentSearchValue () {
                return options.currentSearchValue;
            }
        });
        return valueOptions || [];
    }
    /**
     * Gets all distinct raw values in Column. Values are sorted.
     * @param columnId Column to check
     */ getDistinctRawValuesForColumn(columnId) {
        const abColumn = this.getColumnApi().getColumnWithColumnId(columnId);
        if (abColumn == undefined) return [];
        return this.sortDistinctValues(this.getUnsortedDistinctRawValuesForColumn(columnId), abColumn).map((cv)=>{
            return cv.rawValue;
        });
    }
    /**
     * Gets all distinct raw values in Column. Values are un-sorted.
     * @param columnId Column to check
     */ getUnsortedDistinctRawValuesForColumn(columnId) {
        const abColumn = this.getColumnApi().getColumnWithColumnId(columnId);
        if (abColumn == undefined) return [];
        return this._adaptable.getDistinctGridCellsForColumn(abColumn);
    }
    getSortedRowNodesWithCurrentLayoutSortOrder(rowNodes) {
        const currentLayout = this.getLayoutApi().getCurrentLayout();
        const columnSorts = currentLayout.ColumnSorts || [];
        const columnApi = this.getColumnApi();
        const rowNodesMapToCells = new Map();
        const allRowNodes = [];
        // for each row node,let's create an object
        // with only those gridcells that are needed - meaning
        // for those column that are in the current sort
        const rowNodeCallback = (node)=>{
            allRowNodes.push(node);
            const rowNodeCells = {};
            rowNodesMapToCells.set(node, rowNodeCells);
            columnSorts.forEach((columnSort, i)=>{
                const { ColumnId: ColumnId } = columnSort;
                const gridCell = this._adaptable.getGridCellFromRowNode(node, ColumnId);
                rowNodeCells[ColumnId] = gridCell;
            });
        };
        if (rowNodes) rowNodes.forEach(rowNodeCallback);
        else this.getAgGridApi().forEachNode(rowNodeCallback);
        if (!columnSorts.length) return allRowNodes;
        const sortInfo = columnSorts.map((columnSort)=>{
            const { ColumnId: ColumnId } = columnSort;
            // NOTE: the comparator we pass to multisort should always sort in ascending order
            // that's why we pass SortOrder.Asc to the comparators
            const comparator = columnApi.hasNumberDataType(ColumnId) ? (0, $9g4SS.getNumericComparatorForGridCell)((0, $hrtGQ.SortOrder).Asc) : columnApi.hasDateDataType(ColumnId) ? (0, $9g4SS.getDateComparatorForGridCell)((0, $hrtGQ.SortOrder).Asc) : (0, $9g4SS.getGenericComparatorForGridCell)((0, $hrtGQ.SortOrder).Asc);
            return {
                // but here we pass the actual direction of the column sort
                dir: columnSort.SortOrder === 'Asc' ? 1 : -1,
                fn: (rowNodeA, rowNodeB)=>{
                    const gridCellA = rowNodesMapToCells.get(rowNodeA)?.[ColumnId];
                    const gridCellB = rowNodesMapToCells.get(rowNodeB)?.[ColumnId];
                    if (!gridCellA || !gridCellB) return 0;
                    return comparator(gridCellA, gridCellB);
                }
            };
        });
        return (0, $88ab1a78ec8ca4b4$export$4c4a0f6d9a37d837)(sortInfo, allRowNodes);
    }
    sortDistinctValues(returnValues, column) {
        // this does NOT into account Custom Sort - far too hard for now...
        let sortOrder = undefined;
        let columnSort = this.getGridApi().getColumnSortForColumn(column.columnId);
        if (columnSort && columnSort.SortOrder) sortOrder = columnSort.SortOrder === 'Asc' ? (0, $hrtGQ.SortOrder).Asc : columnSort.SortOrder === 'Desc' ? (0, $hrtGQ.SortOrder).Desc : undefined;
        if (sortOrder) {
            if (this.getColumnApi().hasNumberDataType(column?.columnId)) returnValues = (0, $9g4SS.sortCellValueArrayNumeric)(returnValues, sortOrder);
            else if (this.getColumnApi().hasDateDataType(column?.columnId)) returnValues = (0, $9g4SS.sortCellValueArrayDates)(returnValues, sortOrder);
            else returnValues = (0, $9g4SS.sortCellValueArray)(returnValues, sortOrder);
        }
        return returnValues;
    }
    setColumns(columns) {
        this.dispatchAction($5b564bb703f29152$export$4fbf83a3540ddc8d(columns));
    }
    setSelectedCells(selectedCellInfo) {
        this.dispatchAction($5b564bb703f29152$export$d516b7a966e54414(selectedCellInfo));
    }
    setSelectedRows(selectedRowInfo) {
        this.dispatchAction($5b564bb703f29152$export$113fab243a5adcab(selectedRowInfo));
    }
    buildStandaloneColumnHeader(column) {
        return this._adaptable.agGridMenuAdapter.buildStandaloneColumnHeader(column);
    }
    getRowHighlightStyle(params) {
        const primaryKeyValue = this.getGridApi().getPrimaryKeyValueForRowNode(params.node);
        const highlightRow = this.getAdaptableInternalApi().getInternalState().RowHighlightInfo?.find((highlightRow)=>{
            return highlightRow.primaryKeyValue === primaryKeyValue;
        });
        if (highlightRow) return (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(highlightRow.highlightStyle);
    }
    getAlertRowStyle(params) {
        const alert = this.getAlertApi().internalApi.getAdaptableAlertWithHighlightRow(params.node);
        const highlightRow = alert?.alertDefinition?.AlertProperties?.HighlightRow;
        if (highlightRow) return typeof highlightRow === 'object' ? (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(highlightRow) : {
            backgroundColor: (0, $5aWMQ.default).getColorByMessageType(alert.alertDefinition.MessageType)
        };
        return null;
    }
    getAlertRowClass(params) {
        const alert = this.getAlertApi().internalApi.getAdaptableAlertWithHighlightRow(params.node);
        const highlightRow = alert?.alertDefinition?.AlertProperties?.HighlightRow;
        return typeof highlightRow === 'object' && highlightRow?.ClassName ? highlightRow?.ClassName : null;
    }
    getRowHighlightClass(params) {
        const primaryKeyValue = this.getGridApi().getPrimaryKeyValueForRowNode(params.node);
        const highlightRow = this.getAdaptableInternalApi().getInternalState().RowHighlightInfo?.find((highlightRow)=>{
            return highlightRow.primaryKeyValue === primaryKeyValue;
        });
        return typeof highlightRow?.highlightStyle === 'object' ? highlightRow.highlightStyle.ClassName : null;
    }
    deriveSpecialColumnSettingsFromAgGridDefaultColDef() {
        const defaultColumnDefinition = this._adaptable.agGridAdapter.getDefaultColumnDefinition();
        return {
            Filterable: defaultColumnDefinition.filter,
            Resizable: defaultColumnDefinition.resizable,
            Groupable: defaultColumnDefinition.enableRowGroup,
            Sortable: defaultColumnDefinition.sortable,
            Pivotable: defaultColumnDefinition.enablePivot,
            Aggregatable: defaultColumnDefinition.enableValue,
            SuppressMenu: defaultColumnDefinition.suppressHeaderMenuButton,
            SuppressMovable: defaultColumnDefinition.suppressMovable,
            HeaderToolTip: defaultColumnDefinition.headerTooltip,
            Width: defaultColumnDefinition.width
        };
    }
    hasCellEditableAccordingToEditOptions() {
        return typeof this.getEditOptions()?.isCellEditable === 'function';
    }
    /**
     * Returns UNDEFINED if no EditOptions.isCellEditable is provided, otherwise returns the result of the function
     *
     * DO NOT USE THIS METHOD DIRECTLY - use `GridApi.isCellEditable` instead
     */ isCellEditableAccordingToEditOptions(gridCell, defaultColDefinitionEditableValue) {
        const cellEditable = this.getEditOptions()?.isCellEditable;
        if (cellEditable) {
            const cellEditableContext = {
                ...this.getAdaptableInternalApi().buildBaseContext(),
                gridCell: gridCell,
                defaultColDefEditableValue: defaultColDefinitionEditableValue
            };
            return cellEditable(cellEditableContext);
        }
        return undefined;
    }
    isRowFilterable(rowNode) {
        // first assess if the Row is filterable - if not, then return true so it appears in Grid
        const isRowFilterable = this.getOptionsApi().getFilterOptions().isRowFilterable;
        if (typeof isRowFilterable === 'function') {
            const rowFilterableContext = {
                ...this.getAdaptableApi().internalApi.buildBaseContext(),
                rowNode: rowNode,
                data: rowNode.data
            };
            if (!isRowFilterable(rowFilterableContext)) return false;
        }
        return true;
    }
}



var $9g4SS = parcelRequire("9g4SS");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $9g4SS = parcelRequire("9g4SS");

var $9OAZF = parcelRequire("9OAZF");




var $acw62 = parcelRequire("acw62");


const $a20f9e611d5a05eb$export$e0e193db4cb7689a = 'ab-CodeBlock';
const $a20f9e611d5a05eb$export$6c415d1fdae3dfdb = (props)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        as: "code",
        ...props,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:p-1 twa:rounded-standard twa:bg-primary twa:text-primary-foreground', $a20f9e611d5a05eb$export$e0e193db4cb7689a, props.className)
    });
};



var $acw62 = parcelRequire("acw62");


const $0b17b48a3a2d8049$export$e0e193db4cb7689a = 'ab-HelpBlock';
const $0b17b48a3a2d8049$export$34f7c7c9e4cb85e0 = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:text-2/relaxed twa:p-2 twa:rounded-standard', 'twa:bg-primarylight twa:text-primary-foreground', $0b17b48a3a2d8049$export$e0e193db4cb7689a);
const $0b17b48a3a2d8049$var$HelpBlock = (props)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($0b17b48a3a2d8049$export$34f7c7c9e4cb85e0, props.className)
    });
};
var $0b17b48a3a2d8049$export$2e2bcd8739ae039 = $0b17b48a3a2d8049$var$HelpBlock;



var $acw62 = parcelRequire("acw62");





const $33d60c54c2c535f0$var$TabContext = $acw62.createContext({
    selectedIndex: 0,
    tabCount: 0,
    setSelectedIndex: (index)=>{}
});
const $33d60c54c2c535f0$var$isTab = (c)=>{
    return c.type === $33d60c54c2c535f0$export$3e41faf802a29e71 || $33d60c54c2c535f0$export$d09123193fa03dc0.has(c.type);
};
const $33d60c54c2c535f0$var$isTabContent = (c)=>{
    return c.type === $33d60c54c2c535f0$export$7c6e2c02157bb7d2 || $33d60c54c2c535f0$export$922ba814e5931a84.has(c.type);
};
const $33d60c54c2c535f0$export$b2539bed5023c21c = (props)=>{
    const { autoFocus: autoFocus, children: children, onValueChange: _onValueChange, defaultValue: _defaultValue, value: _value, keyboardNavigation: keyboardNavigation = true, selectedIndex: _selectedIndex, defaultSelectedIndex: _defaultSelectedIndex, onSelectedIndexChange: _onSelectedIndexChange, ...boxProps } = props;
    let [selectedIndex, doSetSelectedIndex] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'selectedIndex', 0);
    const [selectedValue, setSelectedValue] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'value', 0);
    const allChildren = $acw62.Children.toArray(children);
    const values = [];
    const tabs = allChildren.filter($33d60c54c2c535f0$var$isTab).map((tab, index)=>{
        values.push(tab.props.value);
        return $acw62.cloneElement(tab, {
            index: // @ts-ignore ignore
            index,
            keyboardNavigation: keyboardNavigation,
            autoFocus: autoFocus
        });
    });
    const contents = allChildren.filter($33d60c54c2c535f0$var$isTabContent);
    const contentValues = contents.map((c)=>c.props.value);
    const shouldUseValue = (props.value !== undefined || props.defaultValue !== undefined) && props.selectedIndex === undefined && props.defaultSelectedIndex === undefined;
    if (shouldUseValue) {
        const indexOfValue = values.indexOf(selectedValue);
        if (indexOfValue > -1) selectedIndex = indexOfValue;
        const reorderContents = contentValues.filter((contentValue)=>values.indexOf(contentValue) != -1).length === tabs.length;
        if (reorderContents) contents.sort((c1, c2)=>{
            const v1 = c1.props.value;
            const v2 = c2.props.value;
            return values.indexOf(v1) - values.indexOf(v2);
        });
    }
    const setSelectedIndex = (index)=>{
        if (shouldUseValue) {
            const selectedValue = values[index];
            setSelectedValue(selectedValue);
        }
        doSetSelectedIndex(index);
    };
    const currentContent = contents[selectedIndex];
    const { value: value, ...contentProps } = currentContent?.props || {};
    const fillerClassName = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-Tabs__Filler', 'twa:bg-(--ab-cmp-tabs-strip__background)');
    return $acw62.createElement($33d60c54c2c535f0$var$TabContext.Provider, {
        value: {
            selectedIndex: selectedIndex,
            tabCount: tabs.length,
            setSelectedIndex: setSelectedIndex
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...boxProps,
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(boxProps.className, 'ab-Tabs twa:flex twa:flex-col'),
        "data-selected-index": selectedIndex
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-Tabs__Strip', 'twa:bg-(--ab-cmp-tabs-strip__background)')
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: fillerClassName
    }), tabs, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(fillerClassName, 'twa:flex-1')
    })), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...contentProps,
        className: `ab-Tabs__Body twa:p-2 twa:flex-1 ${contentProps.className || ''} `
    }, currentContent)));
};
const $33d60c54c2c535f0$export$3e41faf802a29e71 = (props)=>{
    const { index: index, autoFocus: autoFocus, keyboardNavigation: keyboardNavigation = true, className: propsClassName, ...boxProps } = props;
    const context = $acw62.useContext($33d60c54c2c535f0$var$TabContext);
    const baseClassName = 'ab-Tabs__Tab';
    const active = context.selectedIndex === props.index;
    const beforeActive = context.selectedIndex === props.index + 1;
    const className = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(baseClassName, active ? `${baseClassName}--active` : '', beforeActive ? `${baseClassName}--before-active` : '', 'twa:cursor-pointer twa:p-2', propsClassName);
    const ref = (0, $acw62.useRef)(null);
    $acw62.useEffect(()=>{
        if (active && autoFocus && keyboardNavigation) ref.current?.focus();
    }, [
        active,
        autoFocus
    ]);
    const mountedRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // don't focus initially,
        // so we don't steal focus, if autoFocus is false
        if (!mountedRef.current) return;
        if (active && keyboardNavigation) ref.current?.focus();
    }, [
        active,
        keyboardNavigation
    ]);
    $acw62.useEffect(()=>{
        mountedRef.current = true;
    }, []);
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ref: ref,
        tabIndex: active ? 0 : -1,
        ...boxProps,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:p-2', className),
        onClick: (event)=>{
            context.setSelectedIndex(props.index);
            props.onClick?.(event);
        },
        onKeyDown: (event)=>{
            if (keyboardNavigation) {
                if (event.key === 'Enter') context.setSelectedIndex(props.index);
                if (event.key === 'ArrowLeft') {
                    event.preventDefault();
                    let nextIndex = props.index - 1;
                    if (nextIndex < 0) nextIndex = context.tabCount - 1;
                    context.setSelectedIndex(nextIndex);
                }
                if (event.key === 'ArrowRight') {
                    event.preventDefault();
                    let nextIndex = props.index + 1;
                    if (nextIndex > context.tabCount - 1) nextIndex = 0;
                    context.setSelectedIndex(nextIndex);
                }
            }
            props.onKeyDown?.(event);
        }
    });
};
const $33d60c54c2c535f0$export$d09123193fa03dc0 = new Set();
$33d60c54c2c535f0$export$d09123193fa03dc0.add($33d60c54c2c535f0$export$3e41faf802a29e71);
const $33d60c54c2c535f0$export$7c6e2c02157bb7d2 = (props)=>{
    return $acw62.createElement($acw62.Fragment, null, props.children);
};
const $33d60c54c2c535f0$export$922ba814e5931a84 = new Set();
$33d60c54c2c535f0$export$922ba814e5931a84.add($33d60c54c2c535f0$export$7c6e2c02157bb7d2);
$33d60c54c2c535f0$export$b2539bed5023c21c.Tab = $33d60c54c2c535f0$export$3e41faf802a29e71;
$33d60c54c2c535f0$export$b2539bed5023c21c.Content = $33d60c54c2c535f0$export$7c6e2c02157bb7d2;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $9OAZF = parcelRequire("9OAZF");




const $0f5e3272866deca2$export$6e10b3df66bf9f52 = $acw62.forwardRef((props, ref)=>{
    let closeButtonTooltip = props.value ? 'Clear' : null;
    const inputRef = $acw62.useRef(null);
    const { focusOnClear: focusOnClear = true } = props;
    return $acw62.createElement((0, $952730cad4910d4d$export$2e2bcd8739ae039), {
        onClick: props.onClick,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:bg-defaultbackground twa:overflow-visible twa:w-full', props.className),
        style: props.style
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "aria-label": props['aria-label'],
        autoFocus: props.autoFocus,
        style: props.inputStyle,
        className: props.inputClassName,
        ref: (r)=>{
            inputRef.current = r;
            if (!ref) return;
            if (typeof ref === 'function') ref(r);
            else ref.current = r;
        },
        type: "text",
        placeholder: props.placeholder,
        value: props.value,
        onChange: (x)=>props.OnTextChange(x.target.value)
    }), props.actionTools, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        variant: "text",
        icon: "close",
        tooltip: closeButtonTooltip,
        className: "twa:mr-1 twa:p-0",
        onClick: ()=>{
            props.OnTextChange('');
            const input = inputRef.current;
            if (!focusOnClear) return;
            requestAnimationFrame(()=>{
                if (input && input.focus) input.focus();
            });
        },
        disabled: (0, $9OAZF.StringExtensions).IsNullOrEmpty(props.value.toString())
    }));
});




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $d2976bc2c0148451$export$29a956867f048fd9 = (0, $acw62.createContext)({
    textAreaRef: {
        current: null
    },
    selectedFunction: null,
    setSelectedFunction: (_fn)=>{}
});
const $d2976bc2c0148451$export$deb6ba90a7dc85f6 = ()=>{
    return (0, $acw62.useContext)($d2976bc2c0148451$export$29a956867f048fd9);
};


let $d153298de611d827$var$dragImage;
const $d153298de611d827$var$DRAG_IMAGE_SRC = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
function $d153298de611d827$var$EditorButton(props) {
    const { data: data, ...buttonProps } = props;
    const { textAreaRef: textAreaRef } = (0, $d2976bc2c0148451$export$deb6ba90a7dc85f6)();
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": 'operator-or-fn',
        variant: "text",
        draggable: true,
        onDragStart: (event)=>{
            if (!$d153298de611d827$var$dragImage) {
                // we want to lazy init the image since otherwise it fails in SSR environments if it is declared outside the cmp - ReferenceError: Image is not defined
                $d153298de611d827$var$dragImage = new Image(0, 0);
                $d153298de611d827$var$dragImage.src = $d153298de611d827$var$DRAG_IMAGE_SRC;
            }
            document.getSelection().empty();
            event.dataTransfer.setData('text', data + ' ');
            event.dataTransfer.setDragImage($d153298de611d827$var$dragImage, 0, 0);
        },
        onDragEnd: ()=>{
            try {
                document.getSelection()?.collapseToEnd();
            } catch (err) {
                console.error(err);
            }
        },
        onClick: ()=>{
            textAreaRef.current?.focus();
            try {
                document.execCommand('insertText', false, data + ' ');
                document.getSelection()?.collapseToEnd();
            } catch (err) {
                console.error(err);
            }
        },
        ...buttonProps
    });
}
var $d153298de611d827$export$2e2bcd8739ae039 = $d153298de611d827$var$EditorButton;







const $6be491887c9387cd$export$f82d7b079ca290ba = ({ fields: fields, dataFormatter: dataFormatter, data: initialData, type: type = 'column', labels: labels })=>{
    const adaptableApi = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)().api;
    const [data, setData] = $acw62.useState(initialData);
    const [showColumnIds, setShowValues] = $acw62.useState(false);
    const [searchInputValue, setSearchInputValue] = $acw62.useState('');
    const getColValue = (fieldValue)=>{
        return adaptableApi.internalApi.getValueUsingField(data, fieldValue);
    };
    const updateColValue = (rowData, fielValue, newValue)=>{
        const updatedRowData = adaptableApi.internalApi.setValueUsingField(rowData, fielValue, newValue);
        return {
            ...updatedRowData
        };
    };
    const getColDateValue = (fieldValue)=>{
        const colValue = getColValue(fieldValue);
        return colValue && (0, $eccba2ee7b674d85$export$155a8c53826313d9)(colValue) ? new Date(colValue).toISOString().substr(0, 10) : '';
    };
    const hasFriendlyNames = $acw62.useMemo(()=>{
        return fields.some((field)=>field.label !== field.value);
    }, []);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        "data-name": `expression-${type}-picker`,
        className: "twa:h-full"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: `${(0, $5e4c4ab15f4fe7da$export$e0e193db4cb7689a)}__${type}-list twa:mb-2 twa:mt-[2px]`,
        flexDirection: "column",
        alignItems: "flex-start"
    }, hasFriendlyNames && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: showColumnIds,
        onChange: (checked)=>setShowValues(checked),
        style: {
            float: 'right',
            margin: 0,
            paddingTop: 'var(--ab-base-space)',
            paddingBottom: 'var(--ab-base-space)'
        }
    }, labels?.showIds ?? 'Show Column IDs'), $acw62.createElement((0, $0f5e3272866deca2$export$6e10b3df66bf9f52), {
        value: searchInputValue,
        OnTextChange: setSearchInputValue,
        placeholder: labels?.filterPlaceholder ?? 'Filter columns...',
        style: {
            flex: 1,
            marginBottom: 3
        }
    })), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "ab-ExpressionEditor__columns",
        gridColumnGap: "var(--ab-base-space)",
        gridRowGap: "var(--ab-base-space)",
        sizes: [
            'auto',
            '1fr'
        ],
        style: {
            alignItems: 'stretch',
            overflow: 'auto'
        }
    }, fields.filter((field)=>{
        if (!searchInputValue) return true;
        return field.label.includes(searchInputValue) || field.value?.includes?.(searchInputValue);
    }).map((field)=>{
        const label = showColumnIds ? `[${field.value}]` : field.label;
        return $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            key: field.label,
            label: $acw62.createElement((0, $d153298de611d827$export$2e2bcd8739ae039), {
                className: "twa:w-full twa:h-full twa:bg-primary twa:cursor-grab twa:mr-1",
                data: dataFormatter(field.value),
                "data-name": type,
                "data-value": field.value,
                icon: "drag"
            }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                flexDirection: "column",
                alignItems: "flex-start"
            }, label))
        }, field.dataType === 'number' ? $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
            type: "number",
            "data-name": `${type}-input`,
            "data-value": field.value,
            value: getColValue(field.value) ?? '',
            onChange: (e)=>setData(updateColValue(data, field.value, Number(e.target.value))),
            className: "twa:w-full",
            disabled: field.readOnly
        }) : field.dataType === 'text' ? $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
            type: "text",
            "data-name": `${type}-input`,
            "data-value": field.value,
            value: getColValue(field.value) ?? '',
            onChange: (e)=>setData(updateColValue(data, field.value, e.target.value)),
            className: "twa:w-full",
            disabled: field.readOnly
        }) : field.dataType === 'date' ? $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
            type: "date",
            "data-name": `${type}-input`,
            "data-value": field.value,
            value: getColDateValue(field.value) ?? '',
            onChange: (e)=>{
                setData(updateColValue(data, field.value, new Date(e.target.value)));
            },
            className: "twa:w-full",
            disabled: field.readOnly
        }) : field.dataType === 'boolean' ? $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            "data-name": `${type}-input`,
            "data-value": field.value,
            checked: Boolean(getColValue(field.value)),
            onChange: (checked)=>setData(updateColValue(data, field.value, checked)),
            disabled: field.readOnly
        }) : null);
    })));
};




var $acw62 = parcelRequire("acw62");
class $b346458668d4b64c$export$6f9d4bc737e2a74f extends Error {
    expressionFnName;
    constructor(expressionFnName, message){
        super(message);
        this.expressionFnName = expressionFnName;
        this.name = 'ExpressionEvaluationError';
    }
}


function $558ccc63d44f8999$export$31d960970cb8c965(node, context) {
    if (typeof node === 'boolean' || typeof node === 'number' || typeof node === 'string' || // handles NULL literal
    node == null) return node;
    if (Array.isArray(node)) return node.map((n)=>$558ccc63d44f8999$export$31d960970cb8c965(n, context));
    const functionDef = context.functions[node.type];
    if (functionDef) {
        if (functionDef.hasEagerEvaluation) return functionDef.handler(node.args, context);
        const args = node.args.map((n)=>$558ccc63d44f8999$export$31d960970cb8c965(n, context));
        return functionDef.handler(args, context);
    } else throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('', `Function is not available in this context: "${node.type}"`);
}


//@ts-nocheck
/* parser generated by jison 0.4.18 */ /*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/ var $4d4558776f9ec89d$var$parser = function() {
    var o = function(k, v, o, l) {
        for(o = o || {}, l = k.length; l--; o[k[l]] = v);
        return o;
    }, $V0 = [
        1,
        5
    ], $V1 = [
        1,
        6
    ], $V2 = [
        1,
        7
    ], $V3 = [
        1,
        8
    ], $V4 = [
        1,
        9
    ], $V5 = [
        1,
        10
    ], $V6 = [
        1,
        14
    ], $V7 = [
        1,
        11
    ], $V8 = [
        1,
        15
    ], $V9 = [
        1,
        13
    ], $Va = [
        1,
        16
    ], $Vb = [
        4,
        7
    ], $Vc = [
        1,
        19
    ], $Vd = [
        1,
        20
    ], $Ve = [
        1,
        21
    ], $Vf = [
        1,
        22
    ], $Vg = [
        1,
        23
    ], $Vh = [
        1,
        24
    ], $Vi = [
        1,
        25
    ], $Vj = [
        1,
        26
    ], $Vk = [
        1,
        27
    ], $Vl = [
        1,
        28
    ], $Vm = [
        1,
        29
    ], $Vn = [
        1,
        30
    ], $Vo = [
        1,
        31
    ], $Vp = [
        1,
        32
    ], $Vq = [
        1,
        33
    ], $Vr = [
        1,
        34
    ], $Vs = [
        1,
        35
    ], $Vt = [
        1,
        36
    ], $Vu = [
        1,
        37
    ], $Vv = [
        1,
        38
    ], $Vw = [
        1,
        39
    ], $Vx = [
        4,
        7,
        9,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        25,
        26,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        36,
        37,
        38,
        39,
        41,
        42,
        45,
        46,
        48,
        50
    ], $Vy = [
        9,
        36
    ], $Vz = [
        2,
        6
    ], $VA = [
        4,
        7,
        9,
        16,
        17,
        22,
        23,
        25,
        26,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        36,
        37,
        38,
        39,
        41,
        42,
        45,
        46,
        48,
        50
    ], $VB = [
        4,
        7,
        9,
        16,
        17,
        18,
        19,
        20,
        22,
        23,
        25,
        26,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        36,
        37,
        38,
        39,
        41,
        42,
        45,
        46,
        48,
        50
    ], $VC = [
        4,
        7,
        9,
        22,
        23,
        25,
        26,
        36,
        42,
        45,
        46,
        48,
        50
    ], $VD = [
        4,
        7,
        9,
        22,
        23,
        25,
        26,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        36,
        37,
        38,
        39,
        41,
        42,
        45,
        46,
        48,
        50
    ], $VE = [
        1,
        77
    ], $VF = [
        45,
        48,
        50
    ];
    var parser = {
        trace: function trace() {},
        yy: {},
        symbols_: {
            error: 2,
            program: 3,
            EOF: 4,
            expressions: 5,
            e: 6,
            NEWLINE: 7,
            args: 8,
            ',': 9,
            TRUE: 10,
            FALSE: 11,
            NUMBER: 12,
            STRING: 13,
            COL: 14,
            FIELD: 15,
            '+': 16,
            '-': 17,
            '*': 18,
            '/': 19,
            '%': 20,
            '^': 21,
            '|': 22,
            '&': 23,
            '!': 24,
            '?': 25,
            ':': 26,
            case_when: 27,
            '=': 28,
            '!=': 29,
            '<': 30,
            '<=': 31,
            '>': 32,
            '>=': 33,
            BETWEEN: 34,
            '(': 35,
            ')': 36,
            STARTS_WITH: 37,
            ENDS_WITH: 38,
            CONTAINS: 39,
            FUNCTION: 40,
            IN: 41,
            WHERE: 42,
            case_expression_value: 43,
            when_then_list: 44,
            WHEN: 45,
            THEN: 46,
            case_when_else: 47,
            ELSE: 48,
            CASE: 49,
            END: 50,
            $accept: 0,
            $end: 1
        },
        terminals_: {
            2: 'error',
            4: 'EOF',
            7: 'NEWLINE',
            9: ',',
            10: 'TRUE',
            11: 'FALSE',
            12: 'NUMBER',
            13: 'STRING',
            14: 'COL',
            15: 'FIELD',
            16: '+',
            17: '-',
            18: '*',
            19: '/',
            20: '%',
            21: '^',
            22: '|',
            23: '&',
            24: '!',
            25: '?',
            26: ':',
            28: '=',
            29: '!=',
            30: '<',
            31: '<=',
            32: '>',
            33: '>=',
            34: 'BETWEEN',
            35: '(',
            36: ')',
            37: 'STARTS_WITH',
            38: 'ENDS_WITH',
            39: 'CONTAINS',
            40: 'FUNCTION',
            41: 'IN',
            42: 'WHERE',
            45: 'WHEN',
            46: 'THEN',
            48: 'ELSE',
            49: 'CASE',
            50: 'END'
        },
        productions_: [
            0,
            [
                3,
                1
            ],
            [
                3,
                2
            ],
            [
                5,
                1
            ],
            [
                5,
                2
            ],
            [
                5,
                3
            ],
            [
                8,
                0
            ],
            [
                8,
                1
            ],
            [
                8,
                3
            ],
            [
                6,
                1
            ],
            [
                6,
                1
            ],
            [
                6,
                1
            ],
            [
                6,
                1
            ],
            [
                6,
                1
            ],
            [
                6,
                1
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                2
            ],
            [
                6,
                5
            ],
            [
                6,
                1
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                5
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                6,
                4
            ],
            [
                6,
                2
            ],
            [
                6,
                5
            ],
            [
                6,
                3
            ],
            [
                6,
                3
            ],
            [
                43,
                0
            ],
            [
                43,
                1
            ],
            [
                44,
                4
            ],
            [
                44,
                5
            ],
            [
                47,
                0
            ],
            [
                47,
                2
            ],
            [
                27,
                5
            ]
        ],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */ , $$ /* vstack */ , _$ /* lstack */ ) {
            /* this == yyval */ var $0 = $$.length - 1;
            switch(yystate){
                case 1:
                    return [];
                case 2:
                    return $$[$0 - 1];
                case 3:
                case 7:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
                case 4:
                case 39:
                    this.$ = $$[$0 - 1];
                    break;
                case 5:
                case 8:
                    this.$ = $$[$0 - 2].concat([
                        $$[$0]
                    ]);
                    break;
                case 6:
                    this.$ = [];
                    break;
                case 9:
                    this.$ = true;
                    break;
                case 10:
                    this.$ = false;
                    break;
                case 11:
                    this.$ = Number($$[$0]);
                    break;
                case 12:
                    this.$ = $$[$0].slice(1, -1);
                    break;
                case 13:
                    this.$ = yy.node('COL', [
                        $$[$0].slice(1, -1)
                    ], this._$, 'VALUE_REF');
                    break;
                case 14:
                    this.$ = yy.node('FIELD', [
                        FIELD.slice(1, -1)
                    ], this._$, 'VALUE_REF');
                    break;
                case 15:
                    this.$ = yy.node('ADD', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 16:
                    this.$ = yy.node('SUB', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 17:
                    this.$ = yy.node('MUL', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 18:
                    this.$ = yy.node('DIV', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 19:
                    this.$ = yy.node('MOD', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 20:
                    this.$ = yy.node('POW', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 21:
                    this.$ = yy.node('OR', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 22:
                    this.$ = yy.node('AND', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 23:
                    this.$ = yy.node('NOT', [
                        $$[$0]
                    ], this._$, 'UNARY');
                    break;
                case 24:
                    this.$ = yy.node('IF', [
                        $$[$0 - 4],
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'CONDITIONAL');
                    break;
                case 25:
                case 42:
                case 46:
                    this.$ = $$[$0];
                    break;
                case 26:
                    this.$ = yy.node('EQ', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 27:
                    this.$ = yy.node('NEQ', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 28:
                    this.$ = yy.node('LT', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 29:
                    this.$ = yy.node('LTE', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 30:
                    this.$ = yy.node('GT', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 31:
                    this.$ = yy.node('GTE', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 32:
                    this.$ = yy.node('BETWEEN', [
                        $$[$0 - 4],
                        $$[$0 - 1]
                    ], this._$, 'INFIX');
                    break;
                case 33:
                    this.$ = yy.node('STARTS_WITH', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 34:
                    this.$ = yy.node('ENDS_WITH', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 35:
                    this.$ = yy.node('CONTAINS', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 36:
                    this.$ = yy.node($$[$0 - 3].toUpperCase(), $$[$0 - 1], this._$, 'FUNCTION');
                    break;
                case 37:
                    this.$ = -$$[$0];
                    break;
                case 38:
                    this.$ = yy.node('IN', [
                        $$[$0 - 4],
                        $$[$0 - 1]
                    ], this._$, 'INFIX');
                    break;
                case 40:
                    this.$ = yy.node('WHERE', [
                        $$[$0 - 2],
                        $$[$0]
                    ], this._$, 'INFIX');
                    break;
                case 41:
                case 45:
                    this.$ = null;
                    break;
                case 43:
                    this.$ = [
                        {
                            WHEN: $$[$0 - 2],
                            THEN: $$[$0]
                        }
                    ];
                    break;
                case 44:
                    this.$ = $$[$0 - 4];
                    this.$.push({
                        WHEN: $$[$0 - 2],
                        THEN: $$[$0]
                    });
                    break;
                case 47:
                    this.$ = yy.node('CASE', [
                        $$[$0 - 3],
                        $$[$0 - 2],
                        $$[$0 - 1]
                    ], this._$, 'CONDITIONAL');
                    break;
            }
        },
        table: [
            {
                3: 1,
                4: [
                    1,
                    2
                ],
                5: 3,
                6: 4,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                1: [
                    3
                ]
            },
            {
                1: [
                    2,
                    1
                ]
            },
            {
                4: [
                    1,
                    17
                ],
                7: [
                    1,
                    18
                ]
            },
            o($Vb, [
                2,
                3
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw
            }),
            o($Vx, [
                2,
                9
            ]),
            o($Vx, [
                2,
                10
            ]),
            o($Vx, [
                2,
                11
            ]),
            o($Vx, [
                2,
                12
            ]),
            o($Vx, [
                2,
                13
            ]),
            o($Vx, [
                2,
                14
            ]),
            {
                6: 40,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            o($Vx, [
                2,
                25
            ]),
            {
                35: [
                    1,
                    41
                ]
            },
            {
                6: 42,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 43,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 45,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                43: 44,
                45: [
                    2,
                    41
                ],
                49: $Va
            },
            {
                1: [
                    2,
                    2
                ]
            },
            o($Vb, [
                2,
                4
            ], {
                27: 12,
                6: 46,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                35: $V8,
                40: $V9,
                49: $Va
            }),
            {
                6: 47,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 48,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 49,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 50,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 51,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 52,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 53,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 54,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 55,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 56,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 57,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 58,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 59,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 60,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 61,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                35: [
                    1,
                    62
                ]
            },
            {
                6: 63,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 64,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 65,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                35: [
                    1,
                    66
                ]
            },
            {
                6: 67,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            o($Vx, [
                2,
                23
            ]),
            o($Vy, $Vz, {
                27: 12,
                8: 68,
                6: 69,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                35: $V8,
                40: $V9,
                49: $Va
            }),
            o($Vx, [
                2,
                37
            ]),
            {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                36: [
                    1,
                    70
                ],
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw
            },
            {
                44: 71,
                45: [
                    1,
                    72
                ]
            },
            {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw,
                45: [
                    2,
                    42
                ]
            },
            o($Vb, [
                2,
                5
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw
            }),
            o($VA, [
                2,
                15
            ], {
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh
            }),
            o($VA, [
                2,
                16
            ], {
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh
            }),
            o($VB, [
                2,
                17
            ], {
                21: $Vh
            }),
            o($VB, [
                2,
                18
            ], {
                21: $Vh
            }),
            o($VB, [
                2,
                19
            ], {
                21: $Vh
            }),
            o($Vx, [
                2,
                20
            ]),
            o($VC, [
                2,
                21
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv
            }),
            o($VC, [
                2,
                22
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv
            }),
            {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                26: [
                    1,
                    73
                ],
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw
            },
            o($VD, [
                2,
                26
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh
            }),
            o($VD, [
                2,
                27
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh
            }),
            o($VD, [
                2,
                28
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh
            }),
            o($VD, [
                2,
                29
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh
            }),
            o($VD, [
                2,
                30
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh
            }),
            o($VD, [
                2,
                31
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh
            }),
            o($Vy, $Vz, {
                27: 12,
                6: 69,
                8: 74,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                35: $V8,
                40: $V9,
                49: $Va
            }),
            o($VD, [
                2,
                33
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh
            }),
            o($VD, [
                2,
                34
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh
            }),
            o($VD, [
                2,
                35
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh
            }),
            o($Vy, $Vz, {
                27: 12,
                6: 69,
                8: 75,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                35: $V8,
                40: $V9,
                49: $Va
            }),
            o([
                4,
                7,
                9,
                25,
                26,
                36,
                42,
                45,
                46,
                48,
                50
            ], [
                2,
                40
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv
            }),
            {
                9: $VE,
                36: [
                    1,
                    76
                ]
            },
            o($Vy, [
                2,
                7
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw
            }),
            o($Vx, [
                2,
                39
            ]),
            {
                45: [
                    1,
                    79
                ],
                47: 78,
                48: [
                    1,
                    80
                ],
                50: [
                    2,
                    45
                ]
            },
            {
                6: 81,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 82,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                9: $VE,
                36: [
                    1,
                    83
                ]
            },
            {
                9: $VE,
                36: [
                    1,
                    84
                ]
            },
            o($Vx, [
                2,
                36
            ]),
            {
                6: 85,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                50: [
                    1,
                    86
                ]
            },
            {
                6: 87,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 88,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw,
                46: [
                    1,
                    89
                ]
            },
            o([
                4,
                7,
                9,
                26,
                36,
                45,
                46,
                48,
                50
            ], [
                2,
                24
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw
            }),
            o($Vx, [
                2,
                32
            ]),
            o($Vx, [
                2,
                38
            ]),
            o($Vy, [
                2,
                8
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw
            }),
            o($Vx, [
                2,
                47
            ]),
            {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw,
                46: [
                    1,
                    90
                ]
            },
            {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw,
                50: [
                    2,
                    46
                ]
            },
            {
                6: 91,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            {
                6: 92,
                10: $V0,
                11: $V1,
                12: $V2,
                13: $V3,
                14: $V4,
                15: $V5,
                17: $V6,
                24: $V7,
                27: 12,
                35: $V8,
                40: $V9,
                49: $Va
            },
            o($VF, [
                2,
                43
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw
            }),
            o($VF, [
                2,
                44
            ], {
                16: $Vc,
                17: $Vd,
                18: $Ve,
                19: $Vf,
                20: $Vg,
                21: $Vh,
                22: $Vi,
                23: $Vj,
                25: $Vk,
                28: $Vl,
                29: $Vm,
                30: $Vn,
                31: $Vo,
                32: $Vp,
                33: $Vq,
                34: $Vr,
                37: $Vs,
                38: $Vt,
                39: $Vu,
                41: $Vv,
                42: $Vw
            })
        ],
        defaultActions: {
            2: [
                2,
                1
            ],
            17: [
                2,
                2
            ]
        },
        parseError: function parseError(str, hash) {
            if (hash.recoverable) this.trace(str);
            else {
                var error = new Error(str);
                error.hash = hash;
                throw error;
            }
        },
        parse: function parse(input) {
            var self = this, stack = [
                0
            ], tstack = [], vstack = [
                null
            ], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            var args = lstack.slice.call(arguments, 1);
            var lexer = Object.create(this.lexer);
            var sharedState = {
                yy: {}
            };
            for(var k in this.yy)if (Object.prototype.hasOwnProperty.call(this.yy, k)) sharedState.yy[k] = this.yy[k];
            lexer.setInput(input, sharedState.yy);
            sharedState.yy.lexer = lexer;
            sharedState.yy.parser = this;
            if (typeof lexer.yylloc == 'undefined') lexer.yylloc = {};
            var yyloc = lexer.yylloc;
            lstack.push(yyloc);
            var ranges = lexer.options && lexer.options.ranges;
            if (typeof sharedState.yy.parseError === 'function') this.parseError = sharedState.yy.parseError;
            else this.parseError = Object.getPrototypeOf(this).parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            _token_stack: var lex = function() {
                var token;
                token = lexer.lex() || EOF;
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token;
            };
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while(true){
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) action = this.defaultActions[state];
                else {
                    if (symbol === null || typeof symbol == 'undefined') symbol = lex();
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === 'undefined' || !action.length || !action[0]) {
                    var errStr = '';
                    expected = [];
                    for(p in table[state])if (this.terminals_[p] && p > TERROR) expected.push("'" + this.terminals_[p] + "'");
                    if (lexer.showPosition) errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                    else errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : "'" + (this.terminals_[symbol] || symbol) + "'");
                    this.parseError(errStr, {
                        text: lexer.match,
                        token: this.terminals_[symbol] || symbol,
                        line: lexer.yylineno,
                        loc: yyloc,
                        expected: expected
                    });
                }
                if (action[0] instanceof Array && action.length > 1) throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
                switch(action[0]){
                    case 1:
                        stack.push(symbol);
                        vstack.push(lexer.yytext);
                        lstack.push(lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = lexer.yyleng;
                            yytext = lexer.yytext;
                            yylineno = lexer.yylineno;
                            yyloc = lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) yyval._$.range = [
                            lstack[lstack.length - (len || 1)].range[0],
                            lstack[lstack.length - 1].range[1]
                        ];
                        r = this.performAction.apply(yyval, [
                            yytext,
                            yyleng,
                            yylineno,
                            sharedState.yy,
                            action[1],
                            vstack,
                            lstack
                        ].concat(args));
                        if (typeof r !== 'undefined') return r;
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /* generated by jison-lex 0.3.4 */ var lexer = function() {
        var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) this.yy.parser.parseError(str, hash);
                else throw new Error(str);
            },
            // resets the lexer, sets new input
            setInput: function(input, yy) {
                this.yy = yy || this.yy || {};
                this._input = input;
                this._more = this._backtrack = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = [
                    'INITIAL'
                ];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) this.yylloc.range = [
                    0,
                    0
                ];
                this.offset = 0;
                return this;
            },
            // consumes and returns one char from the input
            input: function() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else this.yylloc.last_column++;
                if (this.options.ranges) this.yylloc.range[1]++;
                this._input = this._input.slice(1);
                return ch;
            },
            // unshifts one char (or a string) into the input
            unput: function(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };
                if (this.options.ranges) this.yylloc.range = [
                    r[0],
                    r[0] + this.yyleng - len
                ];
                this.yyleng = this.yytext.length;
                return this;
            },
            // When called from action, caches matched text and appends it on next action
            more: function() {
                this._more = true;
                return this;
            },
            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
            reject: function() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                    text: '',
                    token: null,
                    line: this.yylineno
                });
                return this;
            },
            // retain first n characters of the match
            less: function(n) {
                this.unput(this.match.slice(n));
            },
            // displays already matched input, i.e. for error messages
            pastInput: function() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, '');
            },
            // displays upcoming input, i.e. for error messages
            upcomingInput: function() {
                var next = this.match;
                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, '');
            },
            // displays the character position where the lexing error occurred, i.e. for error messages
            showPosition: function() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join('-');
                return pre + this.upcomingInput() + '\n' + c + '^';
            },
            // test the lexed token: return FALSE when not a match, otherwise return token
            test_match: function(match, indexed_rule) {
                var token, lines, backup;
                if (this.options.backtrack_lexer) {
                    // save context
                    backup = {
                        yylineno: this.yylineno,
                        yylloc: {
                            first_line: this.yylloc.first_line,
                            last_line: this.last_line,
                            first_column: this.yylloc.first_column,
                            last_column: this.yylloc.last_column
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                    };
                    if (this.options.ranges) backup.yylloc.range = this.yylloc.range.slice(0);
                }
                lines = match[0].match(/(?:\r\n?|\n).*/g);
                if (lines) this.yylineno += lines.length;
                this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
                };
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                if (this.options.ranges) this.yylloc.range = [
                    this.offset,
                    this.offset += this.yyleng
                ];
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    return false; // rule action called reject() implying the next rule should be tested instead.
                }
                return false;
            },
            // return next match in input
            next: function() {
                if (this.done) return this.EOF;
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for(var i = 0; i < rules.length; i++){
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rules[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = false;
                                continue; // rule action called reject() implying a rule MISmatch.
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rules[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (this._input === '') return this.EOF;
                else return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                    text: '',
                    token: null,
                    line: this.yylineno
                });
            },
            // return next match that has a token
            lex: function lex() {
                var r = this.next();
                if (r) return r;
                else return this.lex();
            },
            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            // pop the previously active lexer condition state off the condition stack
            popState: function popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) return this.conditionStack.pop();
                else return this.conditionStack[0];
            },
            // produce the lexer rule set which is active for the currently active lexer condition state
            _currentRules: function _currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                else return this.conditions['INITIAL'].rules;
            },
            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
            topState: function topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return 'INITIAL';
            },
            // alias for begin(condition)
            pushState: function pushState(condition) {
                this.begin(condition);
            },
            // return the number of states currently on the stack
            stateStackSize: function stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                ranges: true
            },
            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                yy.node = function(type, args, location, metaInfo) {
                    return {
                        type: type,
                        args: args,
                        range: location.range,
                        metaInfo: metaInfo
                    };
                };
                var YYSTATE = YY_START;
                switch($avoiding_name_collisions){
                    case 0:
                        return 7;
                    case 1 /* skip whitespace */ :
                        break;
                    case 2:
                        return 12;
                    case 3:
                        return 13;
                    case 4:
                        return 40;
                    case 5:
                        return 14;
                    case 6:
                        return 29;
                    case 7:
                        return 33;
                    case 8:
                        return 31;
                    case 9:
                        return 28;
                    case 10:
                        return 32;
                    case 11:
                        return 30;
                    case 12:
                        return 37;
                    case 13:
                        return 38;
                    case 14:
                        return 34;
                    case 15:
                        return 39;
                    case 16:
                        return 24;
                    case 17:
                        return 23;
                    case 18:
                        return 22;
                    case 19:
                        return 42;
                    case 20:
                        return 41;
                    case 21:
                        return 49;
                    case 22:
                        return 45;
                    case 23:
                        return 46;
                    case 24:
                        return 48;
                    case 25:
                        return 50;
                    case 26:
                        return 18;
                    case 27:
                        return 19;
                    case 28:
                        return 17;
                    case 29:
                        return 16;
                    case 30:
                        return 20;
                    case 31:
                        return 21;
                    case 32:
                        return 35;
                    case 33:
                        return 36;
                    case 34:
                        return '[';
                    case 35:
                        return ']';
                    case 36:
                        return 9;
                    case 37:
                        return 25;
                    case 38:
                        return 26;
                    case 39:
                        return 10;
                    case 40:
                        return 11;
                    case 41:
                        return 4;
                    case 42:
                        return 'INVALID';
                }
            },
            rules: [
                /^(?:(\r?\n)+\s*)/,
                /^(?:[^\S\r?\n]+)/,
                /^(?:[0-9]+(\.[0-9]+)?\b)/,
                /^(?:"[^"]*"|'[^']*')/,
                /^(?:[A-Za-z][A-Za-z_0-9\.]+(?=[(]))/,
                /^(?:\[[^[]+\])/,
                /^(?:!=)/,
                /^(?:>=)/,
                /^(?:<=)/,
                /^(?:=)/,
                /^(?:>)/,
                /^(?:<)/,
                /^(?:STARTS_WITH\b)/,
                /^(?:ENDS_WITH\b)/,
                /^(?:BETWEEN\b)/,
                /^(?:CONTAINS\b)/,
                /^(?:!|NOT\b)/,
                /^(?:&|AND\b)/,
                /^(?:\||OR\b)/,
                /^(?:WHERE\b)/,
                /^(?:IN\b)/,
                /^(?:CASE\b)/,
                /^(?:WHEN\b)/,
                /^(?:THEN\b)/,
                /^(?:ELSE\b)/,
                /^(?:END\b)/,
                /^(?:\*)/,
                /^(?:\/)/,
                /^(?:-)/,
                /^(?:\+)/,
                /^(?:%)/,
                /^(?:\^)/,
                /^(?:\()/,
                /^(?:\))/,
                /^(?:\[)/,
                /^(?:\])/,
                /^(?:,)/,
                /^(?:\?)/,
                /^(?::)/,
                /^(?:TRUE\b)/,
                /^(?:FALSE\b)/,
                /^(?:$)/,
                /^(?:.)/
            ],
            conditions: {
                INITIAL: {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        41,
                        42
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
var $4d4558776f9ec89d$export$2e2bcd8739ae039 = $4d4558776f9ec89d$var$parser;


function $31fa107e6d28a2bd$export$83679118f5ff36ac(tokens, offset) {
    return tokens.find(({ range: range })=>range[0] <= offset && range[1] > offset) || tokens.find(({ range: range })=>range[1] == offset);
}
function $31fa107e6d28a2bd$export$b8edc0373b60d044(node, callback) {
    if (node == undefined || typeof node === 'boolean' || typeof node === 'number' || typeof node === 'string') return;
    if (Array.isArray(node)) return node.map((n)=>$31fa107e6d28a2bd$export$b8edc0373b60d044(n, callback));
    // isObject
    if (node.args) {
        node.args.map((n)=>$31fa107e6d28a2bd$export$b8edc0373b60d044(n, callback));
        callback(node);
    }
}
function $31fa107e6d28a2bd$export$1bd14de2e165fd16(node, offset) {
    const path = [];
    if (offset === null) return path;
    $31fa107e6d28a2bd$export$b8edc0373b60d044(node, (node)=>{
        if (node.range[0] <= offset && node.range[1] >= offset) path.push(node);
    });
    return path;
}


const $3f77892da2e22ac4$var$getParser = ()=>{
    return 0, $4d4558776f9ec89d$export$2e2bcd8739ae039;
};
function $3f77892da2e22ac4$export$98e6a39c04603d36(input) {
    const ast = $3f77892da2e22ac4$var$getParser().parse(input.trim());
    const evaluate = (context)=>{
        const result = (0, $558ccc63d44f8999$export$31d960970cb8c965)(ast, context);
        const lastResult = result[result.length - 1];
        return lastResult;
    };
    return {
        ast: ast,
        evaluate: evaluate
    };
}
function $3f77892da2e22ac4$export$1ab6d957e7a2fb4d(input) {
    const { ast: ast } = $3f77892da2e22ac4$export$98e6a39c04603d36(input);
    return ast;
}
const $3f77892da2e22ac4$var$cache = {};
function $3f77892da2e22ac4$export$fef61f332f2c0afc(input, context) {
    $3f77892da2e22ac4$var$cache[input] = $3f77892da2e22ac4$var$cache[input] || $3f77892da2e22ac4$export$98e6a39c04603d36(input);
    return $3f77892da2e22ac4$var$cache[input].evaluate(context);
}
function $3f77892da2e22ac4$export$3846c6cc0ea43ce0(expression) {
    const { ast: ast } = $3f77892da2e22ac4$export$98e6a39c04603d36(expression);
    return ast;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $d2a0551c8cf8e625$export$e0e193db4cb7689a = 'ab-ErrorBox';
const $d2a0551c8cf8e625$var$ErrorBox = (props)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:p-3 twa:rounded-standard twa:bg-error twa:text-text-on-error', props.className, $d2a0551c8cf8e625$export$e0e193db4cb7689a)
    });
};
var $d2a0551c8cf8e625$export$2e2bcd8739ae039 = $d2a0551c8cf8e625$var$ErrorBox;



var $acw62 = parcelRequire("acw62");
function $a910069f00c5e3db$export$2e64cf2a1beda6b9() {
    const [range, setRange] = (0, $acw62.useState)([
        null,
        null
    ]);
    const onSelectionChange = ()=>{
        const isActive = ref.current === document.activeElement;
        const start = isActive ? ref.current.selectionStart : null;
        const end = isActive ? ref.current.selectionEnd : null;
        setRange([
            start,
            end
        ]);
    };
    const ref = (0, $acw62.useRef)(null);
    const refCallback = (0, $acw62.useCallback)((newNode)=>{
        const oldNode = ref.current;
        if (oldNode) document.removeEventListener('selectionchange', onSelectionChange);
        if (newNode) document.addEventListener('selectionchange', onSelectionChange);
        ref.current = newNode;
    }, []);
    return {
        ref: refCallback,
        selectionStart: range[0],
        selectionEnd: range[1]
    };
}







var $acw62 = parcelRequire("acw62");



const $d541796d86c181e1$export$e0e193db4cb7689a = 'ab-Textarea';
const $d541796d86c181e1$var$Textarea = $acw62.forwardRef((props, ref)=>{
    const internalRef = $acw62.useRef(null);
    let { disabled: disabled, autoResizeOnFocus: autoResizeOnFocus, className: className, ...textareaProps } = props;
    const initialHeight = $acw62.useRef(null);
    let type = 'text';
    if (textareaProps && textareaProps.type) type = textareaProps.type;
    if (type === 'string') type = 'text';
    const expandToFitContent = ()=>{
        if (autoResizeOnFocus && initialHeight.current !== null && internalRef.current) {
            internalRef.current.style.height = `0px`; // makes sure it shrinks when needed
            const height = internalRef.current.scrollHeight;
            internalRef.current.style.height = `${height}px`;
        }
    };
    const shrinkToInitialHeight = ()=>{
        if (autoResizeOnFocus) internalRef.current.style.height = `${initialHeight.current}px`;
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...textareaProps,
        onFocus: (e)=>{
            expandToFitContent();
            props.onFocus?.(e);
            if (internalRef.current && initialHeight.current === null) {
                const height = internalRef.current.getBoundingClientRect().height;
                initialHeight.current = height;
            }
        },
        onBlur: (e)=>{
            shrinkToInitialHeight();
            props.onBlur?.(e);
        },
        ref: (elRef)=>{
            // SAVE INITIAL HEIGHT
            // if (elRef && initialHeight.current === null) {
            //   const height = elRef.getBoundingClientRect().height;
            //   initialHeight.current = isNaN(height) ? 'auto' : height;
            // }
            // SAVE REF
            if (internalRef) internalRef.current = elRef;
            // CALL EXTERNAL REF
            if (ref) {
                if (typeof ref === 'function') ref(elRef);
                else ref.current = elRef;
            }
        },
        onChange: (e)=>{
            expandToFitContent();
            props.onChange && props.onChange(e);
        },
        as: "textarea",
        type: type,
        disabled: disabled,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)((0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($d541796d86c181e1$export$e0e193db4cb7689a, disabled ? `${$d541796d86c181e1$export$e0e193db4cb7689a}--disabled` : ''), className),
        spellCheck: false
    });
});
var $d541796d86c181e1$export$2e2bcd8739ae039 = $d541796d86c181e1$var$Textarea;









var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



const $3283d8fe16778b21$export$3288d34c523a1192 = $acw62.forwardRef((props, ref)=>$acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        ...props,
        ref: ref,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(`ab-Tag twa:bg-primary twa:text-2 twa:py-2 twa:px-2 twa:inline-flex twa:rounded-standard`, props.className),
        style: props.style
    }));
const $3283d8fe16778b21$export$cb17e1b962f1810f = (props)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:flex twa:flex-wrap twa:flex-row twa:gap-1', props.className)
    }, props.children);
};
const $3283d8fe16778b21$export$f9fef0f55402315b = (props)=>{
    return $acw62.createElement($3283d8fe16778b21$export$cb17e1b962f1810f, {
        className: props.className
    }, props.tags.map((tag, index)=>$acw62.createElement($3283d8fe16778b21$export$3288d34c523a1192, {
            key: index
        }, tag)));
};





const $61fb4e8cba4dd5db$var$signatureClassName = 'twa:m-0 twa:whitespace-pre-wrap twa:bg-primary twa:text-text-on-primary twa:rounded-standard twa:p-1 twa:inline-block';
const $61fb4e8cba4dd5db$export$c0cddb00822729da = (props)=>{
    return props.expressionFunction ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "expression-editor-documentation",
        className: "twa:my-2 twa:p-2 twa:rounded-standard twa:leading-normal"
    }, props.expressionFunction.description && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-3 twa:font-bold twa:whitespace-pre-wrap",
        "data-name": "expression-editor-documentation-description"
    }, props.expressionFunction.description), props.expressionFunction.signatures && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "expression-editor-documentation-signatures"
    }, $acw62.createElement("b", null, "Signatures"), $acw62.createElement("ul", {
        className: "twa:flex twa:flex-col twa:gap-1"
    }, props.expressionFunction.signatures.map((signature, index)=>$acw62.createElement("li", {
            key: index
        }, $acw62.createElement("pre", {
            className: $61fb4e8cba4dd5db$var$signatureClassName
        }, signature))))), props.expressionFunction.examples && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "expression-editor-documentation-examples"
    }, $acw62.createElement("b", null, "Examples"), $acw62.createElement("ul", {
        className: "twa:flex twa:flex-col twa:gap-1"
    }, props.expressionFunction.examples.map((example, index)=>$acw62.createElement("li", {
            key: index
        }, $acw62.createElement("pre", {
            className: $61fb4e8cba4dd5db$var$signatureClassName
        }, example))))), props.expressionFunction.returnType && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "expression-editor-documentation-examples"
    }, $acw62.createElement("b", null, "Return Type"), $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
        className: "twa:bg-accentlight twa:text-accent twa:ml-3 twa:rounded-full twa:py-1"
    }, props.expressionFunction.returnType))) : null;
};




var $9OAZF = parcelRequire("9OAZF");

var $acw62 = parcelRequire("acw62");





const $d6ef3253c01d4163$var$RadioContext = $acw62.createContext({
    value: null,
    name: '',
    onChange: (v)=>{},
    variant: 'default'
});
const $d6ef3253c01d4163$export$548204eb458cd606 = ()=>{
    return $acw62.useContext($d6ef3253c01d4163$var$RadioContext);
};
const $d6ef3253c01d4163$var$Radio = ({ children: children, checked: checked, onChange: onChange, value: value, name: name, gapDistance: gapDistance = 10, childrenPosition: childrenPosition = 'end', as: as = 'label', id: id, tabIndex: tabIndex, disabled: disabled, ...props })=>{
    const context = $d6ef3253c01d4163$export$548204eb458cd606();
    const { value: contextValue, onChange: contextOnChange, name: contextName, variant: variant } = context;
    const [stateChecked, setStateChecked] = (0, $acw62.useState)(false);
    const computedChecked = checked !== undefined ? checked : contextValue !== undefined ? contextValue === value : stateChecked;
    const onInputChange = (event)=>{
        const newChecked = event.target.checked;
        if (checked === undefined) setStateChecked(newChecked);
        if (onChange) onChange(newChecked, event);
        if (newChecked) contextOnChange(value);
    };
    const gap = $acw62.createElement("div", {
        style: {
            marginLeft: gapDistance,
            display: 'inline-block'
        }
    });
    const before = childrenPosition === 'start' ? children : null;
    const beforeGap = childrenPosition === 'start' ? gap : null;
    const after = childrenPosition === 'end' ? children : null;
    const afterGap = childrenPosition === 'end' ? gap : null;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(`ab-Radio twa:my-2 twa:inline-flex twa:flex-row twa:items-center twa:cursor-pointer twa:relative`, props.className),
        "data-checked": computedChecked,
        as: as
    }, before, beforeGap, $acw62.createElement("input", {
        disabled: disabled,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-Radio-input', 'twa:align-middle', 'twa:m-0', 'twa:rounded-full', 'twa:cursor-pointer', 'twa:position-relative', 'twa:w-[1rem]', 'twa:h-[1rem]', 'twa:min-w-[1rem]', 'twa:min-h-[1rem]', variant === 'default' && 'ab-Radio-input--default', variant === 'text-only' && 'ab-Radio-input--text-only twa:size-0 twa:opacity-0'),
        id: id,
        checked: computedChecked,
        type: "radio",
        name: name ?? contextName,
        value: value,
        tabIndex: tabIndex,
        onChange: onInputChange
    }), afterGap, after);
};
const $d6ef3253c01d4163$export$a98f0dcb43a68a25 = (props)=>{
    const { orientation: orientation, value: _value, name: name, onRadioChange: onRadioChange, children: children, variant: variant = 'default' } = props;
    const [value, setValue] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'value', undefined, {
        onChange: (value)=>{
            onRadioChange(value);
        }
    });
    return $acw62.createElement($d6ef3253c01d4163$var$RadioContext.Provider, {
        value: {
            value: value,
            onChange: setValue,
            name: name,
            variant: variant
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-RadioGroup', props.className),
        flexDirection: orientation == 'horizontal' ? 'row' : 'column',
        alignItems: orientation == 'horizontal' ? 'center' : 'flex-start'
    }, children));
};
const $d6ef3253c01d4163$export$38b13bf43ec3e697 = {
    horizontalTextOnly: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:bg-primarylight twa:rounded-standard twa:p-1 twa:gap-5', {
        'twa:*:flex-1 twa:*:rounded-standard twa:*:p-1 twa:*:m-0': 'default styles for all the radio buttons',
        'twa:*:data-[checked=true]:bg-accent twa:*:data-[checked=true]:text-accent-foreground': 'style the checked state',
        [(0, $c1f662de8a4d1882$export$ffffc4387efdabc8).focusWithinOutline]: 'styles for when a radio is currently focused - show a ring, so people know they can do keyboard nav with left/right arrow keys'
    })
};
var $d6ef3253c01d4163$export$2e2bcd8739ae039 = $d6ef3253c01d4163$var$Radio;





const $9a1c30cdf9b2c6ea$var$filterableCategories = [
    'dates',
    'logical',
    'maths',
    'strings',
    'changes',
    'comparison',
    'observable',
    'aggregation',
    'cumulative'
];
const $9a1c30cdf9b2c6ea$var$getCategoryOrder = (category)=>{
    const predefinedOrder = {
        special: 1,
        conditional: 2,
        logical: 3,
        comparison: 4,
        strings: 5,
        maths: 6,
        dates: 7,
        changes: 8
    };
    return predefinedOrder[category] || 0;
};
const $9a1c30cdf9b2c6ea$var$VarEditorButton = ({ className: className })=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const customQueryVariables = adaptable.api.optionsApi.getExpressionOptions()?.customQueryVariables;
    if (!customQueryVariables || Object.keys(customQueryVariables).length === 0) return $acw62.createElement($acw62.Fragment, null);
    return $acw62.createElement($acw62.Fragment, null, Object.keys(customQueryVariables).map((varOption)=>{
        const varString = `VAR('${varOption}')`;
        return $acw62.createElement((0, $d153298de611d827$export$2e2bcd8739ae039), {
            data: varString,
            key: varOption,
            className: className
        }, varString);
    }));
};
const $9a1c30cdf9b2c6ea$var$FunctionsDropdown = ({ expressionFunctions: expressionFunctions, baseClassName: baseClassName })=>{
    const [currentFunctionCategory, setCurrentFunctionCategory] = $acw62.useState('all');
    const dropdownRef = $acw62.useRef(null);
    const [overFunction, setOverFunction] = $acw62.useState();
    $acw62.useEffect(()=>{
        setOverFunction(null);
    }, [
        currentFunctionCategory
    ]);
    const groupedFunctions = $acw62.useMemo(()=>{
        return Object.keys(expressionFunctions).reduce((acc, key)=>{
            const functionDef = expressionFunctions[key];
            // filter
            if (currentFunctionCategory !== 'all' && functionDef.category !== currentFunctionCategory) return acc;
            if (functionDef.category) acc[functionDef.category] = {
                ...acc[functionDef.category],
                [key]: functionDef
            };
            else acc.noCategory[key] = functionDef;
            return acc;
        }, {
            noCategory: {}
        });
    }, [
        currentFunctionCategory
    ]);
    const orderedGroupNames = $acw62.useMemo(()=>{
        return Object.keys(groupedFunctions).sort((first, second)=>$9a1c30cdf9b2c6ea$var$getCategoryOrder(first) - $9a1c30cdf9b2c6ea$var$getCategoryOrder(second));
    }, [
        groupedFunctions
    ]);
    const handleFunctionCategoryChange = $acw62.useCallback((type)=>(event)=>{
            setCurrentFunctionCategory(type);
        }, [
        currentFunctionCategory
    ]);
    const categoryOptions = $acw62.useMemo(()=>{
        const categoryOptions = Object.keys(expressionFunctions).reduce((acc, functionName)=>{
            const functionExpression = expressionFunctions[functionName];
            if (!acc.includes(functionExpression.category)) acc.push(functionExpression.category);
            return acc;
        }, []).filter((category)=>$9a1c30cdf9b2c6ea$var$filterableCategories.includes(category)).sort((first, second)=>$9a1c30cdf9b2c6ea$var$getCategoryOrder(first) - $9a1c30cdf9b2c6ea$var$getCategoryOrder(second)).map((category)=>({
                label: (0, $9OAZF.default).Humanize(category),
                value: category
            }));
        return [
            {
                label: 'All',
                value: 'all'
            },
            ...categoryOptions
        ];
    }, [
        expressionFunctions
    ]);
    const hidePopup = ()=>{
        dropdownRef.current.hide();
        setOverFunction(null);
    };
    const [searchInputValue, setSearchInputValue] = $acw62.useState('');
    /**
     * Hide when:
     * - mouse leaves
     * - a function is inserted
     */ return $acw62.createElement((0, $c9ce1fb924ab724e$export$2e2bcd8739ae039), {
        ref: dropdownRef,
        showEvent: "mouseenter",
        hideEvent: "mouseleave",
        targetOffset: 5,
        render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                className: `${baseClassName}__dropdown-functions-list-wrapper twa:max-w-[60vw] twa:shadow-md twa:bg-defaultbackground twa:text-text-on-defaultbackground twa:text-3 twa:rounded-standard twa:p-3`,
                flexDirection: "column",
                onMouseLeave: ()=>hidePopup()
            }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                className: "twa:md:gap-3 twa:gap-2 twa:pb-2 twa:md:justify-between twa:justify-start twa:flex-wrap twa:border-b twa:border-primarydark/30 twa:mb-2"
            }, categoryOptions.map((option, index)=>{
                return $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
                    key: option.value,
                    onFocus: (event)=>{
                        event.preventDefault();
                        event.stopPropagation();
                    },
                    onClick: handleFunctionCategoryChange(option.value),
                    checked: currentFunctionCategory === option.value
                }, option.label);
            })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                className: "twa:gap-2 twa:max-h-[60vh]",
                flexDirection: "row"
            }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                flexDirection: "column",
                className: "twa:gap-2 twa:rounded-standard"
            }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $0f5e3272866deca2$export$6e10b3df66bf9f52), {
                className: "twa:w-full",
                value: searchInputValue,
                OnTextChange: setSearchInputValue,
                placeholder: "Search Functions"
            })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                className: `${baseClassName}__dropdown-functions-list twa:overflow-auto`,
                "data-name": "expression-dropdown-functions-list",
                flexDirection: "column"
            }, orderedGroupNames.filter((groupName)=>!!groupedFunctions[groupName]).map((groupName)=>{
                const functionsInGroup = Object.keys(groupedFunctions[groupName]);
                if (functionsInGroup.length === 0) return $acw62.createElement($acw62.Fragment, {
                    key: groupName
                });
                const getEditorButtonData = (functionName)=>{
                    // handle special cases
                    if (functionName === 'CASE') return `CASE <caseValue> WHEN <whenValue> THEN <thenValue> ELSE <defaultValue> END`;
                    if (functionName === 'TRUE' || functionName === 'FALSE') return functionName;
                    if (functionName === 'IF') return `<condition_expr> ? <consequent_expr> : <alternative_expr>`;
                    return `${functionName}()`;
                };
                const fns = functionsInGroup.map((functionName)=>{
                    if (searchInputValue && !functionName.toLowerCase().includes(searchInputValue.toLowerCase())) return null;
                    const buttonClassName = 'twa:mr-1 twa:hover:bg-accent twa:hover:text-accent-foreground';
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        key: functionName,
                        onMouseEnter: ()=>setOverFunction(functionName),
                        onClick: ()=>hidePopup()
                    }, functionName === 'VAR' ? $acw62.createElement($9a1c30cdf9b2c6ea$var$VarEditorButton, {
                        key: functionName,
                        className: buttonClassName
                    }) : $acw62.createElement((0, $d153298de611d827$export$2e2bcd8739ae039), {
                        data: getEditorButtonData(functionName),
                        key: functionName,
                        className: buttonClassName
                    }, functionName));
                }).filter(Boolean);
                return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:mb-2 twa:mx-1', fns.length === 0 ? 'twa:hidden' : ''),
                    key: groupName
                }, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
                    className: "twa:mb-1 twa:bg-primarylight twa:text-text-on-primary twa:w-full"
                }, (0, $9OAZF.default).Humanize(groupName)), fns);
            }))), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`${baseClassName}__dropdown-functions-description `, `twa:flex-1 twa:p-2 twa:w-[600px] twa:max-w-[60vw]`, `twa:rounded-standard twa:shadow-sm twa:overflow-auto twa:h-auto`, 'twa:bg-primarylight twa:text-primary-foreground')
            }, overFunction ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
                className: "twa:bg-accent twa:text-accent-foreground"
            }, overFunction), $acw62.createElement((0, $61fb4e8cba4dd5db$export$c0cddb00822729da), {
                expressionFunction: expressionFunctions[overFunction]
            })) : $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                className: "twa:size-full twa:items-center twa:justify-center twa:text-2 twa:italic"
            }, $acw62.createElement("ul", null, $acw62.createElement("li", null, "Hover over a Function to learn more", $acw62.createElement("br", null), $acw62.createElement("br", null)), $acw62.createElement("li", null, "Click a Function to add it to the Expression in the Editor"))))))
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "expression-dropdown",
        icon: "arrow-down",
        iconPosition: 'end',
        className: "twa:mr-1"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:mr-1 twa:text-2"
    }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "equation"
    }))));
};
function $9a1c30cdf9b2c6ea$export$224ba94407eeae79(props) {
    const { expressionFunctions: expressionFunctions, testData: testData, style: style, type: type } = props;
    const { ref: textAreaRefCallback, selectionStart: selectionStart, selectionEnd: selectionEnd } = (0, $a910069f00c5e3db$export$2e64cf2a1beda6b9)();
    const cursor = selectionStart === selectionEnd ? selectionStart : null;
    let result;
    let evaluationError;
    let expressionError;
    let selectedFunctionName;
    const baseClassName = 'ab-ExpressionEditorInput';
    const buildParserExceptionMessage = (e)=>{
        const parserExceptionSummary = 'Invalid expression is not parsable';
        if (!e.message) return parserExceptionSummary;
        const parserExceptionDetails = e.message;
        return $acw62.createElement("details", null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:mb-1",
            as: "summary"
        }, parserExceptionSummary, $acw62.createElement("i", null, " (click for more details)")), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:ml-3 twa:italic"
        }, parserExceptionDetails));
    };
    const testRowNode = (0, $acw62.useMemo)(()=>{
        const firstRowNode = props.api.gridApi.getFirstRowNode();
        if (!firstRowNode || !firstRowNode.data) return {};
        // clone the class instance to still keep the prototype methods
        return Object.assign(Object.create(Object.getPrototypeOf(firstRowNode)), firstRowNode);
    }, []);
    try {
        // explicitly parsing & evaluating the expression because we need full control of the resulted AST
        const expr = $3f77892da2e22ac4$export$98e6a39c04603d36(props.value || '');
        try {
            testRowNode.data = testData;
            // Mock datachangedevent for change-based functions e.g. PERCENT_CHANGE
            const dataChangedEvent = {
                newValue: 100,
                oldValue: 150
            };
            result = expr.evaluate({
                // we need a fully-fledged rowNode as Adaptable accesses internal methods of it
                node: testRowNode,
                functions: expressionFunctions,
                evaluateCustomQueryVariable: props.api.internalApi.getQueryLanguageService().evaluateCustomQueryVariable,
                dataChangedEvent: dataChangedEvent,
                ...props.api.internalApi.buildBaseContext()
            });
        } catch (err) {
            if (err instanceof (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)) evaluationError = err;
            else // unexpected error, pass it on to the enclosing handler
            throw err;
        }
        const path = $31fa107e6d28a2bd$export$1bd14de2e165fd16(expr.ast, cursor);
        selectedFunctionName = path[0] ? path[0].type : null;
    } catch (e) {
        // parse errors should have a hash, otherwise it's an unexpected runtime error
        const isParserException = !!e.hash;
        if (isParserException) expressionError = buildParserExceptionMessage(e);
        else props.api.logWarn(`Unexpected error while evaluating '${props.value}':
      ${e}`);
    }
    (0, $acw62.useEffect)(()=>{
        // update selected function only for focused textareas (where cursor is present)
        if (cursor != undefined) props.onSelectedFunctionChange(selectedFunctionName ? expressionFunctions[selectedFunctionName] : null);
    }, [
        selectedFunctionName
    ]);
    const operatorButtons = props.editorButtons.filter((editorButtonDef)=>!!expressionFunctions[editorButtonDef.functionName]).map((editorButtonDef)=>$acw62.createElement((0, $d153298de611d827$export$2e2bcd8739ae039), {
            key: `${editorButtonDef.functionName}-operator`,
            data: editorButtonDef.data,
            icon: editorButtonDef.icon
        }, !editorButtonDef.icon && (editorButtonDef.text || editorButtonDef.functionName)));
    const showDocumentationLink = props.api.internalApi.isDocumentationLinksDisplayed();
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        "data-name": "expression-toolbar",
        className: `${baseClassName} twa:py-2 twa:mb-2 twa:mt-2 twa:flex-wrap twa:w-full`
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:flex-1 twa:ml-1 twa:flex-wrap"
    }, $acw62.createElement($9a1c30cdf9b2c6ea$var$FunctionsDropdown, {
        expressionFunctions: expressionFunctions,
        baseClassName: baseClassName
    }), operatorButtons), showDocumentationLink && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "flex-start"
    }, $acw62.createElement((0, $00c4532606fa3d4c$export$5a2ee34a0d054ab8), {
        className: "twa:mr-2",
        tooltip: 'Learn how to use the Expression Editor',
        onClick: ()=>window.open((0, $53c62e7ff907ad8d$export$21349425a3747427), '_blank')
    }))), $acw62.createElement((0, $d541796d86c181e1$export$2e2bcd8739ae039), {
        "data-name": `expression-input-${type}`,
        ref: textAreaRefCallback,
        value: props.value || '',
        placeholder: props.placeholder || 'Create Query',
        disabled: props.disabled || false,
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)('ab-ExpressionEditor__textarea', `${baseClassName}__textarea`, 'twa:w-full twa:min-h-[100px] twa:p-2 twa:text-4 twa:resize-y twa:font-mono'),
        autoFocus: true,
        spellCheck: "false",
        onChange: (event)=>{
            props.onChange(event.target.value);
        },
        style: style
    }), props.isFullExpression !== true && $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:my-2 twa:p-2 twa:text-3"
    }, "This Expression must resolve to a ", $acw62.createElement("b", null, "boolean "), "(i.e. true / false) value"), expressionError && $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), {
        className: "twa:mt-2 twa:whitespace-pre-wrap twa:w-full"
    }, expressionError), evaluationError && $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), {
        className: "twa:mt-2 twa:whitespace-pre-wrap"
    }, `${evaluationError.expressionFnName} ${evaluationError.message}`), !props.hideResultPreview && result !== undefined && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: `${baseClassName}__editor-feedback twa:mt-2 twa:p-2 twa:rounded-standard`,
        "data-name": "expression-editor-feedback"
    }, $acw62.createElement("pre", {
        className: "twa:whitespace-pre-wrap twa:m-0"
    }, "Result (using test data):", ' ', $acw62.createElement("b", {
        className: "twa:bg-accentlight twa:text-accent twa:rounded-full twa:p-1 twa:px-2"
    }, JSON.stringify(result)))));
}


const $19a00760d53f100d$export$9f873384b4128891 = [
    {
        functionName: 'AND',
        data: 'AND'
    },
    {
        functionName: 'OR',
        data: 'OR'
    },
    {
        functionName: 'ADD',
        data: '+',
        icon: 'plus'
    },
    {
        functionName: 'SUB',
        data: '-',
        icon: 'minus'
    },
    {
        functionName: 'MUL',
        data: '*',
        icon: 'multiplication'
    },
    {
        functionName: 'DIV',
        data: '/',
        icon: 'division'
    },
    {
        functionName: 'MOD',
        data: '%',
        icon: 'percent'
    },
    {
        functionName: 'POW',
        data: '^',
        icon: 'exponent'
    },
    {
        functionName: 'EQ',
        data: '=',
        icon: 'equals'
    },
    {
        functionName: 'NEQ',
        data: '!=',
        icon: 'not-equal'
    },
    {
        functionName: 'LT',
        data: '<',
        icon: 'less-than'
    },
    {
        functionName: 'GT',
        data: '>',
        icon: 'greater-than'
    },
    {
        functionName: 'LTE',
        data: '<=',
        icon: 'less-than-or-equal'
    },
    {
        functionName: 'GTE',
        data: '>=',
        icon: 'greater-than-or-equal'
    }
];



const $e138999aa26faee4$export$1bd57f5a41ff0277 = [
    {
        functionName: 'SUM',
        data: 'SUM()',
        text: 'Sum'
    },
    {
        functionName: 'PERCENTAGE',
        data: 'PERCENTAGE()',
        text: 'Percentage'
    },
    {
        functionName: 'MIN',
        data: 'MIN()',
        text: 'Min'
    },
    {
        functionName: 'MAX',
        data: 'MAX()',
        text: 'Max'
    },
    {
        functionName: 'COUNT',
        data: 'COUNT()',
        text: 'Count'
    },
    {
        functionName: 'AVG',
        data: 'AVG()',
        text: 'Average'
    },
    {
        functionName: 'WEIGHT',
        data: 'WEIGHT()',
        text: 'Weight'
    },
    {
        functionName: 'GROUP_BY',
        data: 'GROUP_BY()',
        text: 'GroupBy'
    }
];




var $9g4SS = parcelRequire("9g4SS");
const $19aa91e82c6d8270$export$5206d47972fefe20 = (input)=>{
    return Object.keys(input);
};




var $9OAZF = parcelRequire("9OAZF");

function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}




function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $cf8ce74b80455e9f$export$60959659b2c22881));


function $98aaadcfa91e6727$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}


/**
 * Converts value to a number.
 * Drop-in replacement for lodash/toNumber.
 */ const $16335fc5a6eeb2c1$var$reTrimStart = /^\s+/;
const $16335fc5a6eeb2c1$var$reTrimEnd = /\s+$/;
const $16335fc5a6eeb2c1$var$reIsBinary = /^0b[01]+$/i;
const $16335fc5a6eeb2c1$var$reIsOctal = /^0o[0-7]+$/i;
const $16335fc5a6eeb2c1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
function $16335fc5a6eeb2c1$export$2e2bcd8739ae039(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'symbol') return NaN;
    if (typeof value === 'boolean') return value ? 1 : 0;
    if (value == null) return value === undefined ? NaN : 0;
    if (typeof value === 'string') {
        const trimmed = value.replace($16335fc5a6eeb2c1$var$reTrimStart, '').replace($16335fc5a6eeb2c1$var$reTrimEnd, '');
        if ($16335fc5a6eeb2c1$var$reIsBinary.test(trimmed)) return globalThis.parseInt(trimmed.slice(2), 2);
        if ($16335fc5a6eeb2c1$var$reIsOctal.test(trimmed)) return globalThis.parseInt(trimmed.slice(2), 8);
        if ($16335fc5a6eeb2c1$var$reIsBadHex.test(trimmed)) return NaN;
        return +trimmed;
    }
    // Objects: try valueOf
    const other = typeof value.valueOf === 'function' ? value.valueOf() : value;
    return +other;
}



const $fb3b7f5e99ab7e90$export$dc2d37c8312d2c6 = (context, ...stringArguments)=>{
    return $fb3b7f5e99ab7e90$export$ebbf16104ac722e7(context) ? stringArguments.map((string)=>string.toLowerCase()) : stringArguments;
};
const $fb3b7f5e99ab7e90$export$5da374e426806c6a = (context, stringArgument)=>{
    return $fb3b7f5e99ab7e90$export$ebbf16104ac722e7(context) ? stringArgument.toLowerCase() : stringArgument;
};
const $fb3b7f5e99ab7e90$export$ebbf16104ac722e7 = (context)=>!context.adaptableApi.expressionApi.useCaseSensitivity();
const $fb3b7f5e99ab7e90$export$2b10a53085118826 = (context, columnNameFilter)=>{
    let dataChangeLog$ = context.adaptableApi.internalApi.getDataService().cellDataChangeLog$;
    // filter only the given column changes
    dataChangeLog$ = dataChangeLog$.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)((dataChangeLog)=>dataChangeLog.column.columnId === columnNameFilter));
    // filter based on the WHERE clause
    if (context.filterFn) dataChangeLog$ = dataChangeLog$.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)((value)=>{
        return context.filterFn(value.rowNode);
    }));
    return dataChangeLog$;
};
const $fb3b7f5e99ab7e90$export$2479247589b10d17 = (context, rowChangeType)=>{
    const gridChangeLog$ = context.adaptableApi.internalApi.getDataService().rowDataChangeLog$;
    let gridChangeStream$ = gridChangeLog$.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)((rowDataChangedInfo)=>rowDataChangedInfo.rowTrigger === rowChangeType));
    // filter based on the WHERE clause
    if (context.filterFn) gridChangeStream$ = gridChangeStream$.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)((value)=>value.rowNodes.some((node)=>context.filterFn(node))));
    return gridChangeStream$;
};
const $fb3b7f5e99ab7e90$export$a22b177b601d93d2 = (args, context)=>{
    const reactiveExpressionNode = args[0];
    const whereClauseExpressionNode = args[1];
    const filterFn = (rowNode)=>{
        // whereClauseResult
        return (0, $558ccc63d44f8999$export$31d960970cb8c965)(whereClauseExpressionNode, {
            node: rowNode,
            functions: context.whereClauseFunctions,
            evaluateCustomQueryVariable: context.adaptableApi.internalApi.getQueryLanguageService().evaluateCustomQueryVariable,
            ...context.adaptableApi.internalApi.buildBaseContext()
        });
    };
    // observableExpressionResult
    return $fb3b7f5e99ab7e90$export$9c7ccef250f68ece(reactiveExpressionNode, context, filterFn);
};
const $fb3b7f5e99ab7e90$export$9c7ccef250f68ece = (expressionNode, context, filterFn = context.filterFn)=>{
    return (0, $558ccc63d44f8999$export$31d960970cb8c965)(expressionNode, {
        node: context.node,
        functions: context.functions,
        filterFn: filterFn,
        evaluateCustomQueryVariable: context.adaptableApi.internalApi.getQueryLanguageService().evaluateCustomQueryVariable,
        ...context.adaptableApi.internalApi.buildBaseContext()
    });
};
const $fb3b7f5e99ab7e90$export$32951e4da4746c73 = (consumingFunctionName, args)=>{
    return $fb3b7f5e99ab7e90$export$d6cd7b824e62471(consumingFunctionName, 'config', [
        'COL'
    ], args);
};
const $fb3b7f5e99ab7e90$export$417db24e4b34530 = (consumingFunctionName, args)=>{
    return $fb3b7f5e99ab7e90$export$c6ef2f509e1682c5(consumingFunctionName, 'config', [
        'COL'
    ], args);
};
const $fb3b7f5e99ab7e90$export$d6cd7b824e62471 = (consumingFunctionName, allowedType, allowedOperands, args, config)=>{
    const parameters = $fb3b7f5e99ab7e90$export$c6ef2f509e1682c5(consumingFunctionName, allowedType, allowedOperands, args, config);
    if (parameters == undefined) return;
    if (parameters.length > 1) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)(consumingFunctionName, `expects only 1 argument of type '${[
        ...new Set(parameters.map((op)=>op.name))
    ].join(`' / '`)}'`);
    return parameters[0];
};
const $fb3b7f5e99ab7e90$export$c6ef2f509e1682c5 = (consumingFunctionName, allowedType, allowedOperands, args, config)=>{
    const { isOptional: isOptional } = config ?? {};
    const result = args.filter((arg)=>arg?.type === allowedType && allowedOperands.includes(arg?.name));
    if (isOptional && !result.length) return;
    if (!result.length) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)(consumingFunctionName, `expects an argument of type '${allowedOperands.join(`' / '`)}'`);
    return result;
};
const $fb3b7f5e99ab7e90$export$fca3bbbb640635fc = (args, context)=>{
    if ((0, $9OAZF.default).IsNullOrEmpty(args[0])) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('COL', `no column name is provided`);
    $fb3b7f5e99ab7e90$var$validateColumnId(args[0], context.adaptableApi);
    const result = {
        type: 'config',
        name: 'COL',
        value: args[0]
    };
    return result;
};
const $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d = (input, returnRawValue)=>{
    if (typeof input === 'number') return input;
    const numericValue = (0, $16335fc5a6eeb2c1$export$2e2bcd8739ae039)(input);
    if (returnRawValue === true) return numericValue;
    return isNaN(numericValue) ? 0 : numericValue;
};
const $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5 = (columnId, validColumnTypes, consumingFunction, api)=>{
    const columnType = api.columnApi.getColumnDataTypeForColumnId(columnId);
    if (!validColumnTypes.some((validType)=>validType === columnType)) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)(consumingFunction, `expects a column of type ${validColumnTypes.join(' or ')}`);
    return columnType;
};
const $fb3b7f5e99ab7e90$var$validateColumnId = (columnId, api)=>{
    const column = api.columnApi.getColumnWithColumnId(columnId);
    if (!column) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('', `Column name "${columnId}" is not found`);
    if (!column.queryable) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('', `Column name "${columnId}" is not queryable`);
};




const $3c4f25bf4245f8cf$export$73c5bd56d38465fb = [
    'SUM',
    'PERCENTAGE',
    'MIN',
    'MAX',
    'AVG',
    'COUNT',
    'WEIGHT',
    'COL',
    'GROUP_BY',
    'MEDIAN',
    'MODE',
    'DISTINCT',
    'ONLY',
    'STD_DEVIATION',
    'PREVIOUS',
    'NEXT',
    'FIRST',
    'LAST',
    'ABSOLUTE_DIFF',
    'PERCENT_DIFF'
];
const $3c4f25bf4245f8cf$export$33e625d05e2bd1ff = [
    'CUMUL',
    'OVER',
    'SUM',
    'PERCENTAGE',
    'MIN',
    'MAX',
    'QUANT',
    'PREVIOUS',
    'NEXT',
    'FIRST',
    'LAST',
    'AVG',
    'WEIGHT',
    'COL',
    'GROUP_BY',
    'ABSOLUTE_DIFF',
    'PERCENT_DIFF'
];
const $3c4f25bf4245f8cf$export$4b7d4705b7a2e4eb = [
    'QUANT',
    'QUARTILE',
    'PERCENTILE',
    'COL',
    'GROUP_BY'
];
const $3c4f25bf4245f8cf$export$5b94276e8442c87f = {
    CUMUL: {
        handler (args, context) {
            const aggregationParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('CUMUL', 'aggregationScalar', [
                'SUM',
                'PERCENTAGE',
                'AVG',
                'MIN',
                'MAX',
                'COUNT'
            ], args);
            const overColumnParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('CUMUL', 'operand', [
                'OVER'
            ], args);
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)(aggregationParameter.name, 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            if (!!groupByParameter) // ensure the GROUP_BY is NOT on the CUMUL function
            // it should be on the AGGREGATION function
            throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('GROUP_BY', `should be passed as an argument to the '${aggregationParameter.name}' aggregation function!`);
            const cumulationExpressionEvaluation = $3c4f25bf4245f8cf$var$mapAggregationToCumulation(aggregationParameter, overColumnParameter, context);
            const result = {
                name: 'CUMUL',
                type: 'aggregationScalar',
                value: cumulationExpressionEvaluation
            };
            return result;
        },
        description: 'Performs a cumulative aggregation (running total) with the given aggregation operation over a provided column',
        signatures: [
            'CUMUL( aggregationOp: SUM|MIN|MAX, OVER( [colNameB] ))'
        ],
        examples: [
            'CUMUL( SUM([colNameA]), OVER( [colNameB] ))',
            'CUMUL( MIN([colNameA]), OVER( [colNameB] ))',
            'CUMUL( MAX([colNameA]), OVER( [colNameB] ))'
        ],
        category: 'cumulative'
    },
    SUM: {
        handler (args, context) {
            const sumColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('SUM', args);
            const sumColumnName = sumColumnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(sumColumnName, [
                'number'
            ], 'SUM', context.adaptableApi);
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('SUM', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        SUM: {
                            name: 'SUM',
                            field: sumColumnName,
                            initialValue: 0,
                            reducer: (totalSum, rowValue)=>{
                                if ($3c4f25bf4245f8cf$var$isUndefinedValue(rowValue)) return totalSum;
                                return totalSum + (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(rowValue);
                            }
                        }
                    }
                },
                rowFilterFn: context.filterFn,
                getRowNodes: context.getRowNodes,
                columnType: columnType
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'SUM',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Aggregates a column over multiple rows by summing up the column values\nOptionally the aggregation may be computed within provided individual groups',
        signatures: [
            'SUM( [colName] )',
            'SUM( COL(name: string))',
            'SUM( [colNameA], GROUP_BY( [colNameB] ))',
            'SUM( COL(nameA: string), GROUP_BY( COL(nameB: string)))'
        ],
        examples: [
            'SUM([colA])',
            'SUM([colA], GROUP_BY([colB]))'
        ],
        category: 'aggregation',
        inputs: [
            'number'
        ]
    },
    PERCENTAGE: {
        handler (args, context) {
            const percentageColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('PERCENTAGE', args);
            const percentageColumnName = percentageColumnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(percentageColumnName, [
                'number'
            ], 'PERCENTAGE', context.adaptableApi);
            const sumOperand = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('PERCENTAGE', 'aggregationScalar', [
                'SUM'
            ], args, {
                isOptional: true
            });
            const groupByOperand = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('PERCENTAGE', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            if (sumOperand && groupByOperand) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('PERCENTAGE', `expects either a SUM or a GROUP_BY argument`);
            const sumAggregationColumnName = sumOperand ? sumOperand.value.aggregationParams.reducers['SUM'].field : percentageColumnName;
            const groupByColumnNames = groupByOperand ? groupByOperand?.value : sumOperand?.value.aggregationParams.groupBy?.map((param)=>param.field);
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        PERCENTAGE: {
                            name: 'PERCENTAGE',
                            field: sumAggregationColumnName,
                            initialValue: 0,
                            reducer: (totalSum, rowValue)=>{
                                if ($3c4f25bf4245f8cf$var$isUndefinedValue(rowValue)) return totalSum;
                                return totalSum + (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(rowValue);
                            }
                        }
                    }
                },
                rowValueGetter: (rowNode, aggregationValue)=>{
                    return (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(context.adaptableApi.gridApi.getRawValueFromRowNode(rowNode, percentageColumnName)) / aggregationValue * 100;
                },
                rowFilterFn: context.filterFn,
                getRowNodes: context.getRowNodes,
                columnType: columnType
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByColumnNames, aggregationExpressionEvaluation);
            const result = {
                name: 'PERCENTAGE',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Divides each column value by the aggregated sum of a column\nThe column with the aggregated value and the column with the percentage value do not necessarily have to be identical',
        signatures: [
            'PERCENTAGE( [colName] )',
            'PERCENTAGE( [colNameA], GROUP_BY( [colNameB] ))',
            'PERCENTAGE( [colNameA], SUM ( [colNameB] ))',
            'PERCENTAGE( [colNameA], SUM ( [colNameB], GROUP_BY( [colNameC] )))'
        ],
        examples: [
            'PERCENTAGE( [colName] )',
            'PERCENTAGE( [colNameA], GROUP_BY( [colNameB] ))',
            'PERCENTAGE( [colNameA], SUM ( [colNameB] ))',
            'PERCENTAGE( [colNameA], SUM ( [colNameB], GROUP_BY( [colNameC] )))'
        ],
        category: 'aggregation'
    },
    AVG: {
        handler (args, context) {
            const avgColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('AVG', args);
            const avgColumnName = avgColumnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(avgColumnName, [
                'number'
            ], 'AVG', context.adaptableApi);
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('AVG', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const weightParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('AVG', 'operand', [
                'WEIGHT'
            ], args, {
                isOptional: true
            });
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        AVG: {
                            name: 'AVG',
                            field: avgColumnName,
                            initialValue: {
                                sumOfValues: 0,
                                numberOfValues: 0
                            },
                            reducer: (aggregatedValue, rowValue, rowNode)=>{
                                if ($3c4f25bf4245f8cf$var$isUndefinedValue(rowValue)) return aggregatedValue;
                                const numericRowValue = (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(rowValue);
                                if (weightParameter) {
                                    // weighted average
                                    const weightValue = (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(context.adaptableApi.gridApi.getRawValueFromRowNode(rowNode, weightParameter.value)) ?? 0;
                                    aggregatedValue.sumOfValues = aggregatedValue.sumOfValues + numericRowValue * weightValue;
                                    aggregatedValue.numberOfValues = aggregatedValue.numberOfValues + weightValue;
                                } else {
                                    aggregatedValue.sumOfValues = aggregatedValue.sumOfValues + numericRowValue;
                                    aggregatedValue.numberOfValues = aggregatedValue.numberOfValues + 1;
                                }
                                return aggregatedValue;
                            },
                            done: (aggregatedValue)=>{
                                if (aggregatedValue.numberOfValues === 0) return 0;
                                return aggregatedValue.sumOfValues / aggregatedValue.numberOfValues;
                            }
                        }
                    }
                },
                rowFilterFn: context.filterFn,
                getRowNodes: context.getRowNodes,
                columnType: columnType
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            if (weightParameter) aggregationExpressionEvaluation.context = {
                weightParam: weightParameter
            };
            const result = {
                name: 'AVG',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Aggregates a column over multiple rows by computing the average value (arithmetic mean) of the column values\nOptionally the aggregation may be weighted and/or grouped.',
        signatures: [
            'AVG( [colName] )',
            'AVG( COL(name: string))',
            'AVG( [colNameA], GROUP_BY( [colNameB] ))',
            'AVG( COL(nameA: string), GROUP_BY( COL(nameB: string)))'
        ],
        examples: [
            'AVG([colA])',
            'AVG([colA], GROUP_BY([colB]))',
            'AVG([colA], WEIGHT([colB]))'
        ],
        category: 'aggregation',
        inputs: [
            'number'
        ]
    },
    MEDIAN: {
        handler (args, context) {
            const medianColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('MEDIAN', args);
            const medianColumnName = medianColumnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(medianColumnName, [
                'number'
            ], 'MEDIAN', context.adaptableApi);
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('MEDIAN', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        MEDIAN: {
                            name: 'MEDIAN',
                            field: medianColumnName,
                            initialValue: [],
                            reducer: (aggregatedValue, cellValue)=>{
                                aggregatedValue.push((0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(cellValue));
                                return aggregatedValue;
                            },
                            done: (aggregatedValue)=>{
                                if (aggregatedValue.length === 0) return null;
                                if (aggregatedValue.length === 1) return aggregatedValue[0];
                                const length = aggregatedValue.length;
                                const middle = Math.floor((length - 1) / 2);
                                if (length % 2) return aggregatedValue[middle];
                                else return (aggregatedValue[middle] + aggregatedValue[middle + 1]) / 2.0;
                            }
                        }
                    }
                },
                rowFilterFn: context.filterFn,
                getRowNodes: context.getRowNodes,
                columnType: columnType
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'MEDIAN',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Aggregates a column over multiple rows by computing the median of the column values\nOptionally the aggregation may be grouped.',
        signatures: [
            'MEDIAN( [colName] )',
            'MEDIAN( COL(name: string))',
            'MEDIAN( [colNameA], GROUP_BY( [colNameB] ))',
            'MEDIAN( COL(nameA: string), GROUP_BY( COL(nameB: string)))'
        ],
        examples: [
            'MEDIAN([colA])',
            'MEDIAN([colA], GROUP_BY([colB]))'
        ],
        category: 'aggregation',
        inputs: [
            'number'
        ]
    },
    MODE: {
        handler (args, context) {
            const modeColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('mode', args);
            const modeColumnName = modeColumnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(modeColumnName, [
                'number',
                'text',
                'date'
            ], 'mode', context.adaptableApi);
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('MODE', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        MODE: {
                            name: 'MODE',
                            field: modeColumnName,
                            initialValue: new Map(),
                            reducer: (aggregatedValue, rowValue)=>{
                                if (typeof rowValue !== 'number' && typeof rowValue !== 'string') return aggregatedValue;
                                if (!aggregatedValue) return new Map();
                                aggregatedValue.set(rowValue, (aggregatedValue.get(rowValue) ?? 0) + 1);
                                return aggregatedValue;
                            },
                            done: (aggregatedValue)=>{
                                const sorted = [
                                    ...aggregatedValue.entries()
                                ].sort(([aVal, aFreq], [bVal, bFreq])=>{
                                    if (aFreq < bFreq) return 1;
                                    else if (aFreq > bFreq || aVal < bVal) return -1;
                                    else return aVal === bVal ? 0 : 1;
                                });
                                return sorted?.[0]?.[0];
                            }
                        }
                    }
                },
                rowFilterFn: context.filterFn,
                getRowNodes: context.getRowNodes,
                columnType: columnType
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'MODE',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Aggregates a column over multiple rows by computing the mode of the column values\nOptionally the aggregation may be grouped.',
        signatures: [
            'MODE( [colName] )',
            'MODE( COL(name: string))',
            'MODE( [colNameA], GROUP_BY( [colNameB] ))',
            'MODE( COL(nameA: string), GROUP_BY( COL(nameB: string)))'
        ],
        examples: [
            'MODE([colA])',
            'MODE([colA], GROUP_BY([colB]))'
        ],
        category: 'aggregation',
        inputs: [
            [
                'number'
            ],
            [
                'text'
            ],
            [
                'date'
            ]
        ]
    },
    DISTINCT: {
        handler (args, context) {
            const distinctColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('DISTINCT', args);
            const distinctColumnName = distinctColumnParameter.value;
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('MODE', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        DISTINCT: {
                            name: 'DISTINCT',
                            field: distinctColumnName,
                            initialValue: new Set(),
                            reducer: (aggregatedValue, rowValue, rowNode)=>{
                                if (typeof rowValue !== 'number' && typeof rowValue !== 'string') return aggregatedValue;
                                aggregatedValue.add(rowValue);
                                return aggregatedValue;
                            },
                            done: (aggregatedValue)=>{
                                return aggregatedValue.size;
                            }
                        }
                    }
                },
                getRowNodes: context.getRowNodes
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'DISTINCT',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Aggregates a column over multiple rows by computing the distinct number of the column values\nOptionally the aggregation may be grouped.',
        signatures: [
            'DISTINCT( [colName] )',
            'DISTINCT( COL(name: string))',
            'DISTINCT( [colNameA], GROUP_BY( [colNameB] ))',
            'DISTINCT( COL(nameA: string), GROUP_BY( COL(nameB: string)))'
        ],
        examples: [
            'DISTINCT([colA])',
            'DISTINCT([colA], GROUP_BY([colB]))'
        ],
        category: 'aggregation',
        inputs: [
            [
                'number'
            ],
            [
                'text'
            ],
            [
                'date'
            ]
        ]
    },
    ONLY: {
        handler (args, context) {
            const distinctColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('ONLY', args);
            const onlyColumnName = distinctColumnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(onlyColumnName, [
                'number',
                'text'
            ], 'ONLY', context.adaptableApi);
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('ONLY', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        ONLY: {
                            name: 'ONLY',
                            field: onlyColumnName,
                            initialValue: new Set(),
                            reducer: (aggregatedValue, rowValue, rowNode)=>{
                                if (typeof rowValue !== 'number' && typeof rowValue !== 'string') return aggregatedValue;
                                aggregatedValue.add(rowValue);
                                return aggregatedValue;
                            },
                            done: (aggregatedValue)=>{
                                return aggregatedValue.size === 1 ? aggregatedValue.values().next().value : null;
                            }
                        }
                    }
                },
                rowFilterFn: context.filterFn,
                getRowNodes: context.getRowNodes,
                columnType: columnType
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'ONLY',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Aggregates a column over multiple rows by computing to a value that is common to all rows. \nOptionally the aggregation may be grouped.',
        signatures: [
            'ONLY( [colName] )',
            'ONLY( COL(name: string))',
            'ONLY( [colNameA], GROUP_BY( [colNameB] ))',
            'ONLY( COL(nameA: string), GROUP_BY( COL(nameB: string)))'
        ],
        examples: [
            'ONLY([colA])',
            'ONLY([colA], GROUP_BY([colB]))'
        ],
        category: 'aggregation',
        inputs: [
            [
                'number'
            ],
            [
                'text'
            ],
            [
                'date'
            ]
        ]
    },
    STD_DEVIATION: {
        handler (args, context) {
            const columnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('STD_DEVIATION', args);
            const columnName = columnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(columnName, [
                'number'
            ], 'STD_DEVIATION', context.adaptableApi);
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('STD_DEVIATION', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        STD_DEVIATION: {
                            name: 'STD_DEVIATION',
                            field: columnName,
                            initialValue: {
                                sumOfValues: 0,
                                values: []
                            },
                            reducer: (aggregatedValue, rowValue, rowNode)=>{
                                // TODO: getNumericValue; allow numeric strings
                                if (typeof rowValue !== 'number' || isNaN(rowValue)) return aggregatedValue;
                                aggregatedValue.sumOfValues = aggregatedValue.sumOfValues + rowValue;
                                aggregatedValue.values.push(rowValue);
                                return aggregatedValue;
                            },
                            done: (aggregatedValue)=>{
                                const { sumOfValues: sumOfValues, values: values } = aggregatedValue;
                                if (values.length === 0) return 0;
                                const mean = sumOfValues / values.length;
                                const variance = (0, $9g4SS.SumArray)(values.map((value)=>Math.pow(value - mean, 2))) / values.length;
                                return Math.sqrt(variance);
                            }
                        }
                    }
                },
                rowFilterFn: context.filterFn,
                getRowNodes: context.getRowNodes,
                columnType: columnType
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'STD_DEVIATION',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Aggregates a column over multiple rows by computing its standard deviation.\nOptionally the aggregation may be grouped.',
        signatures: [
            'STD_DEVIATION( [colName] )',
            'STD_DEVIATION( COL(name: string))',
            'STD_DEVIATION( [colNameA], GROUP_BY( [colNameB] ))',
            'STD_DEVIATION( COL(nameA: string), GROUP_BY( COL(nameB: string)))'
        ],
        examples: [
            'STD_DEVIATION([colA])',
            'STD_DEVIATION([colA], GROUP_BY([colB]))'
        ],
        category: 'aggregation',
        inputs: [
            'number'
        ]
    },
    MIN: {
        handler (args, context) {
            const minColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('MIN', args);
            const minColumnName = minColumnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(minColumnName, [
                'number',
                'date'
            ], 'MIN', context.adaptableApi);
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('MIN', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        MIN: {
                            name: 'MIN',
                            field: minColumnName,
                            initialValue: Number.MAX_VALUE,
                            reducer: (minValue, rowValue)=>{
                                if ($3c4f25bf4245f8cf$var$isUndefinedValue(rowValue)) return minValue;
                                if (minValue === Number.MAX_VALUE) return rowValue;
                                if (columnType === 'number') {
                                    const numericRowValue = (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(rowValue);
                                    return numericRowValue < minValue ? numericRowValue : minValue;
                                } else // Date
                                return (0, $7c47abeb099a42c0$export$e4de839670987035)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(rowValue), (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(minValue)) ? minValue : rowValue;
                            },
                            done: (minValue)=>{
                                if (minValue !== Number.MAX_VALUE) return minValue;
                            }
                        }
                    }
                },
                rowFilterFn: context.filterFn,
                getRowNodes: context.getRowNodes,
                columnType: columnType
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'MIN',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Aggregates a column over multiple rows by computing the minimum of the column values\nOptionally the aggregation may be computed within provided individual groups',
        signatures: [
            'MIN( [colName] )',
            'MIN( COL(name: string))',
            'MIN( [colNameA], GROUP_BY( [colNameB] ))',
            'MIN( COL(nameA: string), GROUP_BY( COL(nameB: string)))'
        ],
        examples: [
            'MIN([colA])',
            'MIN([colA], GROUP_BY([colB]))'
        ],
        category: 'aggregation',
        inputs: [
            'number'
        ]
    },
    MAX: {
        handler (args, context) {
            const maxColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('MAX', args);
            const maxColumnName = maxColumnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(maxColumnName, [
                'number',
                'date'
            ], 'MAX', context.adaptableApi);
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('MAX', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        MAX: {
                            name: 'MAX',
                            field: maxColumnName,
                            initialValue: Number.MIN_VALUE,
                            reducer: (maxValue, rowValue)=>{
                                if ($3c4f25bf4245f8cf$var$isUndefinedValue(rowValue)) return maxValue;
                                if (maxValue === Number.MIN_VALUE) return rowValue;
                                if (columnType === 'number') {
                                    const numericRowValue = (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(rowValue);
                                    return numericRowValue > maxValue ? numericRowValue : maxValue;
                                } else // Date
                                return (0, $7c47abeb099a42c0$export$e4de839670987035)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(rowValue), (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(maxValue)) ? rowValue : maxValue;
                            },
                            done: (maxValue)=>{
                                if (maxValue !== Number.MIN_VALUE) return maxValue;
                            }
                        }
                    }
                },
                rowFilterFn: context.filterFn,
                getRowNodes: context.getRowNodes,
                columnType: columnType
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'MAX',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Aggregates a column over multiple rows by computing the maximum of the column values\nOptionally the aggregation may be computed within provided individual groups',
        signatures: [
            'MAX( [colName] )',
            'MAX( COL(name: string))',
            'MAX( [colNameA], GROUP_BY( [colNameB] ))',
            'MAX( COL(nameA: string), GROUP_BY( COL(nameB: string)))'
        ],
        examples: [
            'MAX([colA])',
            'MAX([colA], GROUP_BY([colB]))'
        ],
        category: 'aggregation',
        inputs: [
            'number'
        ]
    },
    QUANT: {
        handler (args, context) {
            const quantileColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('QUANT', args);
            const quantileColumnName = quantileColumnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(quantileColumnName, [
                'number'
            ], 'QUANT', context.adaptableApi);
            const qNumberCandidates = args.filter((arg)=>typeof arg === 'number');
            if (qNumberCandidates.length !== 1) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('QUANT', 'expects a single positive numeric argument as q-quantile');
            const qNumber = qNumberCandidates[0];
            const groupByOperand = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('QUANT', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const groupByColumnNames = groupByOperand?.value;
            let quantReducer;
            if (groupByColumnNames?.length) // do the heavy-lifting in done()
            quantReducer = {
                initialValue: {},
                reducer: (nodeValueMap, rowValue, rowNode, rowIndex)=>{
                    if ($3c4f25bf4245f8cf$var$isUndefinedValue(rowValue)) return nodeValueMap;
                    nodeValueMap[rowNode.id] = rowValue;
                    return nodeValueMap;
                },
                done: (nodeValueMap, groupItems)=>{
                    const populationSize = groupItems?.filter((rowNode)=>{
                        const rowValue = context.adaptableApi.gridApi.getRawValueFromRowNode(rowNode, quantileColumnName);
                        return $3c4f25bf4245f8cf$var$isDefinedValue(rowValue);
                    })?.length ?? 0;
                    const bucketsMap = new Map();
                    for(let step = 1; step <= qNumber; step++)bucketsMap.set(step, populationSize * (step / qNumber));
                    const indexBucketMap = new Map();
                    for(let populationIndex = 0; populationIndex < populationSize; populationIndex++)for(let quantIndex = 1; quantIndex <= qNumber; quantIndex++){
                        if (bucketsMap.get(quantIndex) < populationIndex + 1) continue;
                        else {
                            indexBucketMap.set(populationIndex, quantIndex);
                            break;
                        }
                    }
                    const groupedRowBucketMap = {};
                    groupItems.forEach((subgroupRowNode, subgroupRowIndex)=>{
                        const subgroupRowValue = nodeValueMap[subgroupRowNode.id];
                        if (subgroupRowValue) groupedRowBucketMap[subgroupRowValue] = indexBucketMap.get(subgroupRowIndex);
                    });
                    return groupedRowBucketMap;
                }
            };
            else {
                // in case of non-grouped quantiles, we are able to calculate the buckets beforehand (which is the most efficient)
                const populationSize = context.adaptableApi.gridApi.getAllRowNodes()?.filter((rowNode)=>{
                    const rowValue = context.adaptableApi.gridApi.getRawValueFromRowNode(rowNode, quantileColumnName);
                    return $3c4f25bf4245f8cf$var$isDefinedValue(rowValue);
                })?.length ?? 0;
                const bucketsMap = new Map();
                for(let step = 1; step <= qNumber; step++)bucketsMap.set(step, populationSize * (step / qNumber));
                const indexBucketMap = new Map();
                for(let populationIndex = 0; populationIndex < populationSize; populationIndex++)for(let quantIndex = 1; quantIndex <= qNumber; quantIndex++){
                    if (bucketsMap.get(quantIndex) < populationIndex + 1) continue;
                    else {
                        indexBucketMap.set(populationIndex, quantIndex);
                        break;
                    }
                }
                quantReducer = {
                    initialValue: {},
                    reducer: (rowBucketMap, rowValue, rowNode, rowIndex)=>{
                        if ($3c4f25bf4245f8cf$var$isUndefinedValue(rowValue)) return rowBucketMap;
                        rowBucketMap[rowValue] = indexBucketMap.get(rowIndex);
                        return rowBucketMap;
                    }
                };
            }
            const aggregationExpressionEvaluation = {
                sortByColumn: quantileColumnName,
                rowFilterFn: (rowNode)=>{
                    const rowValue = context.adaptableApi.gridApi.getRawValueFromRowNode(rowNode, quantileColumnName);
                    return $3c4f25bf4245f8cf$var$isDefinedValue(rowValue);
                },
                getRowNodes: context.getRowNodes,
                aggregationParams: {
                    reducers: {
                        QUANT: {
                            name: 'QUANT',
                            field: quantileColumnName,
                            ...quantReducer
                        }
                    }
                },
                rowValueGetter: (rowNode, rowBucketMap)=>{
                    const rowValue = context.adaptableApi.gridApi.getRawValueFromRowNode(rowNode, quantileColumnName);
                    if (rowValue == null) return;
                    return rowBucketMap[rowValue];
                },
                columnType: columnType
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByOperand?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'QUANT',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Calculates the q-Quantiles of the given group and displays which q-quantile the given value is in\nCommon quantiles are 4-quantile or Quartile, 5-quantile or Quintile, 10-quantile or Decile and 100-quantile or Percentile',
        signatures: [
            'QUANT( [colName], q: number)',
            'QUANT( COL(name: string), q: number)',
            'QUANT( [colName1], q: number, GROUP_BY([colName2]) )'
        ],
        examples: [
            'QUANT( [col1], 5)',
            `QUANT( COL('col1'), 100))`,
            'QUANT( [col1], 4, GROUP_BY([col2]) )'
        ],
        category: 'aggregation'
    },
    QUARTILE: {
        handler (args, context) {
            const quartileArgs = [
                ...args,
                4
            ];
            return $3c4f25bf4245f8cf$export$5b94276e8442c87f.QUANT.handler(quartileArgs, context);
        },
        description: 'Calculates the Quartiles of the given group and displays which quartile the given value is in',
        signatures: [
            'QUARTILE( [colName])',
            'QUARTILE( [colName1], GROUP_BY([colName2]) )'
        ],
        examples: [
            'QUARTILE( [col1], 5)',
            'QUARTILE( [col1], 4, GROUP_BY([col2]) )'
        ],
        category: 'aggregation'
    },
    PERCENTILE: {
        handler (args, context) {
            const quartileArgs = [
                ...args,
                100
            ];
            return $3c4f25bf4245f8cf$export$5b94276e8442c87f.QUANT.handler(quartileArgs, context);
        },
        description: 'Calculates the Percentile of the given group and displays which percentile the given value is in',
        signatures: [
            'PERCENTILE( [colName])',
            'PERCENTILE( [colName1], GROUP_BY([colName2]) )'
        ],
        examples: [
            'PERCENTILE( [col1], 5)',
            'PERCENTILE( [col1], 4, GROUP_BY([col2]) )'
        ],
        category: 'aggregation'
    },
    COUNT: {
        handler (args, context) {
            const countColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('COUNT', args);
            const countColumnName = countColumnParameter.value;
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('COUNT', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        COUNT: {
                            name: 'COUNT',
                            field: countColumnName,
                            initialValue: 0,
                            reducer: (totalSum, rowValue)=>{
                                if ($3c4f25bf4245f8cf$var$isUndefinedValue(rowValue)) return totalSum;
                                return totalSum + 1;
                            }
                        }
                    }
                },
                rowFilterFn: context.filterFn,
                getRowNodes: context.getRowNodes
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'COUNT',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Counts the number of non-null (i.e. not empty) values in a given column.\nOptionally the aggregation may be computed within provided individual groups',
        signatures: [
            'COUNT( [colName] )',
            'COUNT( COL(name: string))',
            'COUNT( [colNameA], GROUP_BY( [colNameB] ))',
            'COUNT( COL(nameA: string), GROUP_BY( COL(nameB: string)))'
        ],
        examples: [
            'COUNT([colA])',
            'COUNT([colA], GROUP_BY([colB]))'
        ],
        category: 'aggregation',
        inputs: [
            [
                'number'
            ],
            [
                'text'
            ],
            [
                'date'
            ]
        ]
    },
    OVER: {
        handler (args, context) {
            const columnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('OVER', args);
            (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(columnParameter.value, [
                'number',
                'date'
            ], 'OVER', context.adaptableApi);
            const result = {
                type: 'operand',
                name: 'OVER',
                value: columnParameter.value
            };
            return result;
        },
        description: 'Defines an accumulative dimension (order) for the enclosing cumulative aggregation',
        signatures: [
            'OVER( [colName] )',
            'OVER( COL(name: string))'
        ],
        examples: [
            'OVER( [colName] )',
            `OVER( COL('colName'))`,
            `CUMUL( SUM([colA]), OVER([colB]))`
        ],
        category: 'cumulative'
    },
    WEIGHT: {
        handler (args, context) {
            const columnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('WEIGHT', args);
            (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(columnParameter.value, [
                'number'
            ], 'WEIGHT', context.adaptableApi);
            const result = {
                type: 'operand',
                name: 'WEIGHT',
                value: columnParameter.value
            };
            return result;
        },
        description: 'Defines a weight for the enclosing AVG(Average) aggregation',
        signatures: [
            'WEIGHT( [colName] )',
            'WEIGHT( COL(name: string))'
        ],
        examples: [
            'WEIGHT( [colName] )',
            `WEIGHT( COL('colName'))`,
            `AVG( [colName1], WEIGHT([colName2]))`
        ],
        category: 'operand'
    },
    GROUP_BY: {
        handler (args, context) {
            const columnParameters = (0, $fb3b7f5e99ab7e90$export$417db24e4b34530)('GROUP_BY', args);
            const result = {
                type: 'operand',
                name: 'GROUP_BY',
                value: columnParameters.map((columnParam)=>columnParam.value)
            };
            return result;
        },
        description: 'Groups an aggregation operation within the rows that have the same value in the specified column',
        signatures: [
            'GROUP_BY( [colName] )',
            'GROUP_BY( COL(name: string))'
        ],
        examples: [
            'GROUP_BY( [colName] )',
            `GROUP_BY( COL('colName'))`
        ],
        category: 'grouping'
    },
    COL: {
        handler (args, context) {
            return (0, $fb3b7f5e99ab7e90$export$fca3bbbb640635fc)(args, context);
        },
        description: 'References a column by its unique identifier',
        signatures: [
            '[colName]',
            'COL(name: string)'
        ],
        examples: [
            '[col1]',
            'COL("col1")'
        ],
        category: 'special'
    },
    PREVIOUS: {
        handler (args, context) {
            const prevColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('PREVIOUS', args);
            const prevColumnName = prevColumnParameter.value;
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('PREVIOUS', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const overParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('PREVIOUS', 'operand', [
                'OVER'
            ], args);
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        PREVIOUS: {
                            name: 'PREVIOUS',
                            field: prevColumnName,
                            initialValue: {
                                map: {},
                                previousValue: undefined
                            },
                            reducer: (indexMapAndPrevious, rowValue, rowNode)=>{
                                if ($3c4f25bf4245f8cf$var$isDefinedValue(indexMapAndPrevious.previousValue)) indexMapAndPrevious.map[rowNode.id] = indexMapAndPrevious.previousValue;
                                indexMapAndPrevious.previousValue = rowValue;
                                return indexMapAndPrevious;
                            },
                            done: (indexMapAndPrevious)=>{
                                return indexMapAndPrevious.map;
                            }
                        }
                    }
                },
                rowValueGetter: (rowNode, indexMap)=>{
                    return indexMap[rowNode.id];
                },
                rowFilterFn: context.filterFn,
                sortByColumn: overParameter.value
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'PREVIOUS',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Returns the value of the previous element in the given column, when ordered by the second given column.\nOptionally the value may be computed within provided individual groups',
        signatures: [
            'PREVIOUS( [colNameA], OVER [colNameB] )',
            'PREVIOUS( COL(nameA: string), OVER( COL(nameB: string)))',
            'PREVIOUS( [colNameA], OVER( [colNameB] ), GROUP_BY( [colNameC] ))',
            'PREVIOUS( COL(nameA: string), OVER( COL(nameB: string)), GROUP_BY( COL(nameC: string)))'
        ],
        examples: [
            'PREVIOUS([colA], OVER[colB])',
            'PREVIOUS([colA], OVER([colB]), GROUP_BY([colC]))'
        ],
        category: 'refs'
    },
    NEXT: {
        handler (args, context) {
            const nextColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('NEXT', args);
            const nextColumnName = nextColumnParameter.value;
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('NEXT', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const overParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('NEXT', 'operand', [
                'OVER'
            ], args);
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        NEXT: {
                            name: 'NEXT',
                            field: nextColumnName,
                            initialValue: {
                                map: {},
                                previousRowNode: undefined
                            },
                            reducer: (indexMapAndPreviousRowNode, rowValue, rowNode)=>{
                                if ($3c4f25bf4245f8cf$var$isDefinedValue(rowValue) && $3c4f25bf4245f8cf$var$isDefinedValue(indexMapAndPreviousRowNode.previousRowNode)) indexMapAndPreviousRowNode.map[indexMapAndPreviousRowNode.previousRowNode.id] = rowValue;
                                indexMapAndPreviousRowNode.previousRowNode = rowNode;
                                return indexMapAndPreviousRowNode;
                            },
                            done: (indexMapAndPreviousRowNode)=>{
                                return indexMapAndPreviousRowNode.map;
                            }
                        }
                    }
                },
                rowValueGetter: (rowNode, indexMap)=>{
                    return indexMap[rowNode.id];
                },
                rowFilterFn: context.filterFn,
                sortByColumn: overParameter.value
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'NEXT',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Returns the value of the next element in the given column, when ordered by the second given column.\nOptionally the value may be computed within provided individual groups',
        signatures: [
            'NEXT( [colNameA], OVER [colNameB] )',
            'NEXT( COL(nameA: string), OVER( COL(nameB: string)))',
            'NEXT( [colNameA], OVER( [colNameB] ), GROUP_BY( [colNameC] ))',
            'NEXT( COL(nameA: string), OVER( COL(nameB: string)), GROUP_BY( COL(nameC: string)))'
        ],
        examples: [
            'NEXT([colA], OVER[colB])',
            'NEXT([colA], OVER([colB]), GROUP_BY([colC]))'
        ],
        category: 'refs'
    },
    FIRST: {
        handler (args, context) {
            const firstColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('FIRST', args);
            const firstColumnName = firstColumnParameter.value;
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('FIRST', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const overParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('FIRST', 'operand', [
                'OVER'
            ], args);
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        FIRST: {
                            name: 'FIRST',
                            field: firstColumnName,
                            initialValue: undefined,
                            reducer: (firstElement, rowValue)=>{
                                if ($3c4f25bf4245f8cf$var$isDefinedValue(firstElement)) return firstElement;
                                return rowValue;
                            }
                        }
                    }
                },
                rowFilterFn: context.filterFn,
                sortByColumn: overParameter.value
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'FIRST',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Returns the first value in the given column, when ordered by the second given column.\nOptionally the value may be computed within provided individual groups',
        signatures: [
            'FIRST( [colNameA], OVER [colNameB] )',
            'FIRST( COL(nameA: string), OVER( COL(nameB: string)))',
            'FIRST( [colNameA], OVER( [colNameB] ), GROUP_BY( [colNameC] ))',
            'FIRST( COL(nameA: string), OVER( COL(nameB: string)), GROUP_BY( COL(nameC: string)))'
        ],
        examples: [
            'FIRST([colA], OVER[colB])',
            'FIRST([colA], OVER([colB]), GROUP_BY([colC]))'
        ],
        category: 'refs'
    },
    LAST: {
        handler (args, context) {
            const lastColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('LAST', args);
            const lastColumnName = lastColumnParameter.value;
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('LAST', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            const overParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('LAST', 'operand', [
                'OVER'
            ], args);
            const aggregationExpressionEvaluation = {
                aggregationParams: {
                    reducers: {
                        LAST: {
                            name: 'LAST',
                            field: lastColumnName,
                            initialValue: undefined,
                            reducer: (lastElement, rowValue)=>{
                                if ($3c4f25bf4245f8cf$var$isDefinedValue(rowValue)) return rowValue;
                                return lastElement;
                            }
                        }
                    }
                },
                rowFilterFn: context.filterFn,
                sortByColumn: overParameter.value
            };
            $3c4f25bf4245f8cf$export$d6904cfd9385acda(groupByParameter?.value, aggregationExpressionEvaluation);
            const result = {
                name: 'LAST',
                type: 'aggregationScalar',
                value: aggregationExpressionEvaluation
            };
            return result;
        },
        description: 'Returns the last value in the given column, when ordered by the second given column.\nOptionally the value may be computed within provided individual groups',
        signatures: [
            'LAST( [colNameA], OVER [colNameB] )',
            'LAST( COL(nameA: string), OVER( COL(nameB: string)))',
            'LAST( [colNameA], OVER( [colNameB] ), GROUP_BY( [colNameC] ))',
            'LAST( COL(nameA: string), OVER( COL(nameB: string)), GROUP_BY( COL(nameC: string)))'
        ],
        examples: [
            'LAST([colA], OVER[colB])',
            'LAST([colA], OVER([colB]), GROUP_BY([colC]))'
        ],
        category: 'refs'
    },
    ABSOLUTE_DIFF: {
        handler (args, context) {
            const absoluteDiffColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('ABSOLUTE_DIFF', args);
            const absoluteDiffColumnName = absoluteDiffColumnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(absoluteDiffColumnName, [
                'number'
            ], 'ABSOLUTE_DIFF', context.adaptableApi);
            const relativeValueParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('ABSOLUTE_DIFF', 'aggregationScalar', [
                'AVG',
                'MEDIAN',
                'MODE',
                'MIN',
                'MAX',
                'PREVIOUS',
                'NEXT',
                'FIRST',
                'LAST'
            ], args);
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('ABSOLUTE_DIFF', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            if (!!groupByParameter) // ensure the GROUP_BY is NOT on the ABSOLUTE_DIFF function
            // it should be on the AGGREGATION function
            throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('GROUP_BY', `should be passed as an argument to the '${relativeValueParameter.name}' aggregation function!`);
            const absoluteDiffExpressionEvaluation = $3c4f25bf4245f8cf$var$mapWrappedAggregationToDiff(context, 'ABSOLUTE_DIFF', relativeValueParameter, absoluteDiffColumnName, columnType);
            const result = {
                name: 'ABSOLUTE_DIFF',
                type: 'aggregationScalar',
                value: absoluteDiffExpressionEvaluation
            };
            return result;
        },
        description: 'Aggregates a column over multiple rows by computing the absolute difference between the column values and the provided relative value.\nOptionally the aggregation may be computed within provided individual groups.',
        signatures: [
            'ABSOLUTE_DIFF( [colName], aggregationOp: AVG|MIN|MAX|MEDIAN|MODE )'
        ],
        examples: [
            'ABSOLUTE_DIFF([price], MAX([price]))',
            'ABSOLUTE_DIFF([price], AVG([price], GROUP_BY([currency])))'
        ],
        category: 'aggregation'
    },
    PERCENT_DIFF: {
        handler (args, context) {
            const percentDiffColumnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('PERCENT_DIFF', args);
            const percentDiffColumnName = percentDiffColumnParameter.value;
            const columnType = (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(percentDiffColumnName, [
                'number'
            ], 'PERCENT_DIFF', context.adaptableApi);
            const relativeValueParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('PERCENT_DIFF', 'aggregationScalar', [
                'AVG',
                'MEDIAN',
                'MODE',
                'MIN',
                'MAX',
                'PREVIOUS',
                'NEXT',
                'FIRST',
                'LAST'
            ], args);
            const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('PERCENT_DIFF', 'operand', [
                'GROUP_BY'
            ], args, {
                isOptional: true
            });
            if (!!groupByParameter) // ensure the GROUP_BY is NOT on the ABSOLUTE_DIFF function
            // it should be on the AGGREGATION function
            throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('GROUP_BY', `should be passed as an argument to the '${relativeValueParameter.name}' aggregation function!`);
            const percentDiffExpressionEvaluation = $3c4f25bf4245f8cf$var$mapWrappedAggregationToDiff(context, 'PERCENT_DIFF', relativeValueParameter, percentDiffColumnName, columnType);
            const result = {
                name: 'PERCENT_DIFF',
                type: 'aggregationScalar',
                value: percentDiffExpressionEvaluation
            };
            return result;
        },
        description: 'Aggregates a column over multiple rows by computing the percentage difference between the column values and the provided relative value.\nOptionally the aggregation may be computed within provided individual groups.',
        signatures: [
            'PERCENT_DIFF( [colName], aggregationOp: AVG|MIN|MAX|MEDIAN|MODE )'
        ],
        examples: [
            'PERCENT_DIFF([price], MAX([price]))',
            'PERCENT_DIFF([price], AVG([price], GROUP_BY([currency])))'
        ],
        category: 'aggregation'
    }
};
const $3c4f25bf4245f8cf$var$mapAggregationToCumulation = (aggregationParameter, overColumnParameter, context)=>{
    const aggregationEvaluation = aggregationParameter.value;
    const aggregationReducer = aggregationEvaluation.aggregationParams.reducers[aggregationParameter.name];
    const cumulationAggregationReducer = aggregationParameter.name === 'SUM' ? {
        name: 'CUMUL_SUM',
        field: aggregationReducer.field,
        initialValue: {
            currentValue: aggregationReducer.initialValue,
            cumulatedValues: {}
        },
        reducer: (cumulationBag, rowValue, rowNode)=>{
            if ($3c4f25bf4245f8cf$var$isDefinedValue(rowValue)) cumulationBag.currentValue = cumulationBag.currentValue + rowValue;
            cumulationBag.cumulatedValues[rowNode.id] = cumulationBag.currentValue;
            return cumulationBag;
        }
    } : aggregationParameter.name === 'MIN' ? {
        name: 'CUMUL_MIN',
        field: aggregationReducer.field,
        initialValue: {
            currentValue: aggregationReducer.initialValue,
            cumulatedValues: {}
        },
        reducer: (cumulationBag, rowValue, rowNode)=>{
            if ($3c4f25bf4245f8cf$var$isDefinedValue(rowValue)) {
                if (aggregationEvaluation.columnType === 'date') {
                    if (cumulationBag.currentValue === aggregationReducer.initialValue || (0, $7c47abeb099a42c0$export$e4de839670987035)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(cumulationBag.currentValue), (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(rowValue))) cumulationBag.currentValue = rowValue;
                } else if (rowValue < cumulationBag.currentValue) cumulationBag.currentValue = rowValue;
            }
            if (cumulationBag.currentValue !== aggregationReducer.initialValue) cumulationBag.cumulatedValues[rowNode.id] = cumulationBag.currentValue;
            return cumulationBag;
        }
    } : aggregationParameter.name === 'MAX' ? {
        name: 'CUMUL_MAX',
        field: aggregationReducer.field,
        initialValue: {
            currentValue: aggregationReducer.initialValue,
            cumulatedValues: {}
        },
        reducer: (cumulationBag, rowValue, rowNode)=>{
            if ($3c4f25bf4245f8cf$var$isDefinedValue(rowValue)) {
                if (aggregationEvaluation.columnType === 'date') {
                    if (cumulationBag.currentValue === aggregationReducer.initialValue || (0, $7c47abeb099a42c0$export$e4de839670987035)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(rowValue), (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(cumulationBag.currentValue))) cumulationBag.currentValue = rowValue;
                } else if (rowValue > cumulationBag.currentValue) cumulationBag.currentValue = rowValue;
            }
            if (cumulationBag.currentValue !== aggregationReducer.initialValue) cumulationBag.cumulatedValues[rowNode.id] = cumulationBag.currentValue;
            return cumulationBag;
        }
    } : aggregationParameter.name === 'AVG' ? {
        name: 'CUMUL_AVG',
        field: aggregationReducer.field,
        initialValue: {
            currentValue: 0,
            cumulatedValues: {},
            numberOfCumulatedValues: 0
        },
        reducer: (cumulationBag, rowValue, rowNode)=>{
            if ($3c4f25bf4245f8cf$var$isDefinedValue(rowValue)) {
                if (aggregationEvaluation.context?.weightParam) {
                    // weighted average
                    const weightValue = context.adaptableApi.gridApi.getRawValueFromRowNode(rowNode, aggregationEvaluation.context.weightParam.value) ?? 0;
                    cumulationBag.currentValue = cumulationBag.currentValue + rowValue * weightValue;
                    cumulationBag.numberOfCumulatedValues = cumulationBag.numberOfCumulatedValues + weightValue;
                } else {
                    cumulationBag.currentValue = cumulationBag.currentValue + rowValue;
                    cumulationBag.numberOfCumulatedValues = cumulationBag.numberOfCumulatedValues + 1;
                }
            }
            if (cumulationBag.numberOfCumulatedValues !== 0) cumulationBag.cumulatedValues[rowNode.id] = cumulationBag.currentValue / cumulationBag.numberOfCumulatedValues;
            return cumulationBag;
        }
    } : aggregationParameter.name === 'PERCENTAGE' ? {
        name: 'CUMUL_PERCENTAGE',
        field: aggregationReducer.field,
        initialValue: {
            currentValue: aggregationReducer.initialValue,
            cumulatedValues: {}
        },
        reducer: (cumulationBag, rowValue, rowNode)=>{
            if ($3c4f25bf4245f8cf$var$isDefinedValue(rowValue)) cumulationBag.currentValue = cumulationBag.currentValue + rowValue;
            cumulationBag.cumulatedValues[rowNode.id] = cumulationBag.currentValue;
            return cumulationBag;
        },
        done: (cumulationBag)=>{
            cumulationBag.totalAggregationValue = cumulationBag.currentValue;
            return cumulationBag;
        }
    } : aggregationParameter.name === 'COUNT' ? {
        name: 'CUMUL_COUNT',
        field: aggregationReducer.field,
        initialValue: {
            currentValue: aggregationReducer.initialValue,
            cumulatedValues: {}
        },
        reducer: (cumulationBag, rowValue, rowNode)=>{
            if ($3c4f25bf4245f8cf$var$isDefinedValue(rowValue)) cumulationBag.currentValue = cumulationBag.currentValue + 1;
            cumulationBag.cumulatedValues[rowNode.id] = cumulationBag.currentValue;
            return cumulationBag;
        }
    } : null;
    const rowValueGetter = aggregationParameter.name === 'PERCENTAGE' ? (rowNode, cumulationBag)=>{
        const cumulatedSum = cumulationBag.cumulatedValues[rowNode.id];
        const totalValue = cumulationBag.totalAggregationValue;
        return cumulatedSum / totalValue * 100;
    } : (rowNode, aggregatedValue)=>{
        return aggregatedValue.cumulatedValues[rowNode.id];
    };
    const cumulationExpressionEvaluation = {
        sortByColumn: overColumnParameter.value,
        aggregationParams: {
            reducers: {
                CUMUL: cumulationAggregationReducer
            },
            groupBy: aggregationEvaluation.aggregationParams.groupBy
        },
        rowValueGetter: rowValueGetter,
        rowFilterFn: aggregationEvaluation.rowFilterFn,
        getRowNodes: context.getRowNodes
    };
    return cumulationExpressionEvaluation;
};
const $3c4f25bf4245f8cf$var$mapWrappedAggregationToDiff = (context, diffWrapperFunction, aggregationParameter, columnName, columnType)=>{
    const aggregationEvaluation = aggregationParameter.value;
    const absoluteDiffExpressionEvaluation = {
        aggregationParams: aggregationEvaluation.aggregationParams,
        rowValueGetter: (rowNode, wrappedAggregatedValue)=>{
            const aggregatedValue = typeof aggregationEvaluation.rowValueGetter === 'function' ? aggregationEvaluation.rowValueGetter(rowNode, wrappedAggregatedValue) : wrappedAggregatedValue;
            const cellValue = (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(context.adaptableApi.gridApi.getRawValueFromRowNode(rowNode, columnName));
            if (cellValue == null || aggregatedValue == null) return null;
            if (diffWrapperFunction === 'ABSOLUTE_DIFF') return cellValue - aggregatedValue;
            if (diffWrapperFunction === 'PERCENT_DIFF') return (cellValue - aggregatedValue) / aggregatedValue * 100;
            // should never happen
            return null;
        },
        rowFilterFn: aggregationEvaluation.rowFilterFn,
        getRowNodes: context.getRowNodes,
        sortByColumn: aggregationEvaluation.sortByColumn,
        context: aggregationEvaluation.context,
        columnType: columnType
    };
    return absoluteDiffExpressionEvaluation;
};
const $3c4f25bf4245f8cf$export$5ce66781776cba84 = (0, $19aa91e82c6d8270$export$5206d47972fefe20)($3c4f25bf4245f8cf$export$5b94276e8442c87f);
const $3c4f25bf4245f8cf$export$d6904cfd9385acda = (groupByColumnNames, expressionEvaluation)=>{
    if (groupByColumnNames?.length) expressionEvaluation.aggregationParams.groupBy = groupByColumnNames.map((columnName)=>({
            field: columnName
        }));
};
const $3c4f25bf4245f8cf$var$isUndefinedValue = (input)=>{
    return input == undefined || typeof input === 'string' && input.trim() === '';
};
const $3c4f25bf4245f8cf$var$isDefinedValue = (input)=>{
    return !$3c4f25bf4245f8cf$var$isUndefinedValue(input);
};


const $cf8b62446e40436b$export$e73515d701c4c1aa = [
    {
        functionName: 'CUMUL',
        data: 'CUMUL()',
        text: 'Cumulate'
    },
    {
        functionName: 'OVER',
        data: 'OVER()',
        text: 'Over'
    },
    {
        functionName: 'SUM',
        data: 'SUM()',
        text: 'Sum'
    },
    {
        functionName: 'PERCENTAGE',
        data: 'PERCENTAGE()',
        text: 'Percentage'
    },
    {
        functionName: 'MIN',
        data: 'MIN()',
        text: 'Min'
    },
    {
        functionName: 'MAX',
        data: 'MAX()',
        text: 'Max'
    },
    {
        functionName: 'AVG',
        data: 'AVG()',
        text: 'Average'
    },
    {
        functionName: 'WEIGHT',
        data: 'WEIGHT()',
        text: 'Weight'
    },
    {
        functionName: 'GROUP_BY',
        data: 'GROUP_BY()',
        text: 'GroupBy'
    }
];


const $84fe65d7b8adfa2e$export$631ee1d393d455a = [
    {
        functionName: 'QUANT',
        data: 'QUANT()',
        text: 'Quantile'
    },
    {
        functionName: 'QUARTILE',
        data: 'QUARTILE()',
        text: 'Quartile'
    },
    {
        functionName: 'PERCENTILE',
        data: 'PERCENTILE()',
        text: 'Percentile'
    },
    {
        functionName: 'GROUP_BY',
        data: 'GROUP_BY()',
        text: 'GroupBy'
    }
];


function $d039fb820aeab557$var$EditorInput(props) {
    const moduleExpressionFunctions = props.api.internalApi.getQueryLanguageService().getModuleExpressionFunctionsMap(props.module);
    const getFilteredAggregatedExpressionFunctions = (availableAggregatedExpressionFunctions, type)=>{
        let filteredCollection = [];
        if (type === 'aggregatedScalar') {
            const excludeSet = new Set([
                // we cannot have a hardcodede set of functions,
                // we need to allow custom expressions
                ...(0, $3c4f25bf4245f8cf$export$33e625d05e2bd1ff),
                ...(0, $3c4f25bf4245f8cf$export$4b7d4705b7a2e4eb)
            ]);
            filteredCollection = Object.keys(availableAggregatedExpressionFunctions).filter((key)=>//  need to allow standard ones
                (0, $3c4f25bf4245f8cf$export$33e625d05e2bd1ff).includes(key) || // and anything else that is not cumul or quantile
                !excludeSet.has(key));
        } else {
            const includeExpressionFunctions = type === 'cumulativeAggregatedScalar' ? (0, $3c4f25bf4245f8cf$export$33e625d05e2bd1ff) : (0, $3c4f25bf4245f8cf$export$4b7d4705b7a2e4eb);
            filteredCollection = Object.keys(availableAggregatedExpressionFunctions).filter((key)=>includeExpressionFunctions.includes(key));
        }
        return filteredCollection.reduce((obj, key)=>{
            obj[key] = availableAggregatedExpressionFunctions[key];
            return obj;
        }, {});
    };
    const expressionFunctions = (0, $acw62.useMemo)(()=>{
        return props.type === 'aggregatedScalar' || props.type === 'cumulativeAggregatedScalar' || props.type === 'quantileAggregatedScalar' ? getFilteredAggregatedExpressionFunctions(moduleExpressionFunctions.aggregatedScalarFunctions, props.type) : {
            ...moduleExpressionFunctions.booleanFunctions,
            ...moduleExpressionFunctions.scalarFunctions
        };
    }, [
        props.type
    ]);
    const { setSelectedFunction: setSelectedFunction } = (0, $d2976bc2c0148451$export$deb6ba90a7dc85f6)();
    let queryName;
    switch(props.type){
        case 'boolean':
            queryName = 'Create an Expression that returns true / false';
            break;
        case 'scalar':
            queryName = "Create an Expression that returns a single value of any type";
            break;
        case 'aggregatedScalar':
            queryName = "Create an Expression that evaluates multiple rows and returns a value of any type";
            break;
        case 'cumulativeAggregatedScalar':
            queryName = "Create a Cumulative Expression";
            break;
        case 'quantileAggregatedScalar':
            queryName = "Create a Quantile Expression";
            break;
    }
    return $acw62.createElement((0, $9a1c30cdf9b2c6ea$export$224ba94407eeae79), {
        type: 'main',
        value: props.value,
        placeholder: queryName,
        onChange: props.onChange,
        onSelectedFunctionChange: setSelectedFunction,
        expressionFunctions: expressionFunctions,
        editorButtons: props.type === 'aggregatedScalar' ? (0, $e138999aa26faee4$export$1bd57f5a41ff0277) : props.type === 'cumulativeAggregatedScalar' ? (0, $cf8b62446e40436b$export$e73515d701c4c1aa) : props.type === 'quantileAggregatedScalar' ? (0, $84fe65d7b8adfa2e$export$631ee1d393d455a) : (0, $19a00760d53f100d$export$9f873384b4128891),
        testData: props.testData,
        isFullExpression: props.isFullExpression,
        hideResultPreview: props.type === 'aggregatedScalar' || props.type === 'cumulativeAggregatedScalar' || props.type === 'quantileAggregatedScalar',
        api: props.api
    });
}
var $d039fb820aeab557$export$2e2bcd8739ae039 = $d039fb820aeab557$var$EditorInput;



var $acw62 = parcelRequire("acw62");




var $9OAZF = parcelRequire("9OAZF");
const $1493fcb58341a26c$export$88a9728fa865abd2 = [
    {
        functionName: 'ROW_CHANGE',
        data: 'ROW_CHANGE()',
        text: 'RowChange'
    },
    {
        functionName: 'GRID_CHANGE',
        data: 'GRID_CHANGE()',
        text: 'GridChange'
    },
    {
        functionName: 'ROW_ADDED',
        data: 'ROW_ADDED()',
        text: 'RowAdded'
    },
    {
        functionName: 'ROW_REMOVED',
        data: 'ROW_REMOVED()',
        text: 'RowRemoved'
    },
    {
        functionName: 'COUNT',
        data: 'COUNT()',
        text: 'Count'
    },
    {
        functionName: 'NONE',
        data: 'NONE()',
        text: 'None'
    },
    {
        functionName: 'MIN',
        data: 'MIN()',
        text: 'Min'
    },
    {
        functionName: 'MAX',
        data: 'MAX()',
        text: 'Max'
    },
    {
        functionName: 'TIMEFRAME',
        data: 'TIMEFRAME()',
        text: 'Timeframe'
    }
];




const $ea9a70739bf0f669$export$cf2d2ea0ce14e80d = [
    {
        functionName: 'SUM',
        data: 'SUM()',
        text: 'Sum'
    },
    {
        functionName: 'MIN',
        data: 'MIN()',
        text: 'Min'
    },
    {
        functionName: 'MAX',
        data: 'MAX()',
        text: 'Max'
    },
    {
        functionName: 'AVG',
        data: 'AVG()',
        text: 'Average'
    },
    {
        functionName: 'COUNT',
        data: 'COUNT()',
        text: 'Count'
    },
    {
        functionName: 'GROUP_BY',
        data: 'GROUP_BY()',
        text: 'GroupBy'
    },
    {
        functionName: 'EQ',
        data: '=',
        icon: 'equals'
    },
    {
        functionName: 'NEQ',
        data: '!=',
        icon: 'not-equal'
    },
    {
        functionName: 'LT',
        data: '<',
        icon: 'less-than'
    },
    {
        functionName: 'GT',
        data: '>',
        icon: 'greater-than'
    },
    {
        functionName: 'LTE',
        data: '<=',
        icon: 'less-than-or-equal'
    },
    {
        functionName: 'GTE',
        data: '>=',
        icon: 'greater-than-or-equal'
    }
];



function $b953599eea340c51$var$EditorInputWithWhereClause(props) {
    const moduleExpressionFunctions = props.api.internalApi.getQueryLanguageService().getModuleExpressionFunctionsMap(props.module);
    const reactiveExpressionFns = props.type === 'observable' ? moduleExpressionFunctions.observableFunctions : moduleExpressionFunctions.aggregatedBooleanFunctions;
    const whereClauseExpressionsFns = {
        ...moduleExpressionFunctions.booleanFunctions,
        ...moduleExpressionFunctions.scalarFunctions
    };
    const [value, setValue] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'value', '', {
        onChange: props.onChange
    });
    const [reactiveValue, whereClauseValue] = value.split(' WHERE ');
    const updateReactiveValue = (value)=>{
        let fullExpressionString = value;
        if ((0, $9OAZF.IsNotNullOrEmptyOrWhiteSpace)(value) && (0, $9OAZF.IsNotNullOrEmptyOrWhiteSpace)(whereClauseValue)) fullExpressionString = `${value} WHERE ${whereClauseValue}`;
        if ((0, $9OAZF.IsNullOrEmptyOrWhiteSpace)(value)) setShowWhereClause(false);
        setValue(fullExpressionString);
    };
    const updateWhereClauseValue = (value)=>{
        if ((0, $9OAZF.IsNullOrEmptyOrWhiteSpace)(value)) setValue(reactiveValue);
        else setValue(`${reactiveValue} WHERE ${value}`);
    };
    const { setSelectedFunction: setSelectedFunction } = (0, $d2976bc2c0148451$export$deb6ba90a7dc85f6)();
    const [showWhereClause, setShowWhereClause] = (0, $acw62.useState)((0, $9OAZF.IsNotNullOrEmptyOrWhiteSpace)(whereClauseValue));
    const queryName = `${(0, $9OAZF.CapitaliseFirstLetter)(props.type)}Query`;
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        alignItems: "flex-start"
    }, $acw62.createElement((0, $9a1c30cdf9b2c6ea$export$224ba94407eeae79), {
        type: 'main',
        value: reactiveValue || '',
        placeholder: `Create ${queryName}`,
        onChange: updateReactiveValue,
        onSelectedFunctionChange: setSelectedFunction,
        expressionFunctions: reactiveExpressionFns,
        editorButtons: props.type === 'observable' ? (0, $1493fcb58341a26c$export$88a9728fa865abd2) : (0, $ea9a70739bf0f669$export$cf2d2ea0ce14e80d),
        testData: props.testData,
        isFullExpression: true,
        hideResultPreview: true,
        api: props.api,
        style: {
            height: '75px'
        }
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:mt-2 twa:pl-3"
    }, "Add a ", $acw62.createElement("i", null, "WHERE"), " Clause to narrow the scope of the Query"), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        disabled: (0, $9OAZF.IsNullOrEmptyOrWhiteSpace)(reactiveValue),
        checked: showWhereClause,
        onChange: (checked)=>{
            setShowWhereClause(checked);
            if (!checked) // reset whereClause value if textarea is hidden
            updateWhereClauseValue(null);
        },
        className: "twa:pl-3 twa:items-center"
    }, "WHERE"), showWhereClause && $acw62.createElement((0, $9a1c30cdf9b2c6ea$export$224ba94407eeae79), {
        type: 'secondary',
        disabled: (0, $9OAZF.IsNullOrEmptyOrWhiteSpace)(reactiveValue),
        value: whereClauseValue || '',
        placeholder: `Create BooleanQuery which narrows down the scope of the ${queryName}`,
        onChange: updateWhereClauseValue,
        onSelectedFunctionChange: setSelectedFunction,
        expressionFunctions: whereClauseExpressionsFns,
        editorButtons: (0, $19a00760d53f100d$export$9f873384b4128891),
        testData: props.testData,
        isFullExpression: true,
        hideResultPreview: true,
        api: props.api,
        style: {
            height: '75px'
        }
    }));
}
var $b953599eea340c51$export$2e2bcd8739ae039 = $b953599eea340c51$var$EditorInputWithWhereClause;




var $acw62 = parcelRequire("acw62");
const $52aad13a119b1140$export$8e4378d5a5cc668b = (0, $acw62.createContext)({
    namedQuery: false,
    setNamedQuery: ()=>{}
});
const $52aad13a119b1140$export$f5481b544ced1ec = ()=>{
    return (0, $acw62.useContext)($52aad13a119b1140$export$8e4378d5a5cc668b);
};



var $acw62 = parcelRequire("acw62");




const $0ddeb231b78d9e5d$export$f951ee90ca64a60 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [showColumnIds, setShowColumnIds] = $acw62.useState(false);
    const [inlineQuery, setInlineQuery] = $acw62.useState(false);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        alignItems: "flex-start",
        className: "twa:mt-[2px]"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: showColumnIds,
        onChange: (checked)=>setShowColumnIds(checked)
    }, "Show Column IDs"), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: inlineQuery,
        onChange: (checked)=>setInlineQuery(checked)
    }, "Inline Query"), props.namedQueries.map((namedQuery)=>$acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            key: namedQuery.Uuid,
            flexDirection: "column",
            alignItems: "flex-start",
            className: "twa:p-1 twa:my-2 twa:w-full twa:bg-primarylight"
        }, ' ', $acw62.createElement((0, $d153298de611d827$export$2e2bcd8739ae039), {
            className: "twa:w-full twa:h-full twa:bg-primary twa:cursor-grab",
            data: inlineQuery ? namedQuery.BooleanExpression : `QUERY("${namedQuery.Name}")`,
            "data-name": "column",
            icon: "drag"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "column",
            alignItems: "flex-start"
        }, namedQuery.Name)), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "flex-start",
            className: "twa:p-1"
        }, showColumnIds ? namedQuery.BooleanExpression : adaptable.api.expressionApi.getAdaptableQueryExpressionWithColumnFriendlyNames(namedQuery)))));
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}





var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = 'Invariant failed';
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}


var $0f2a76a440eafaaa$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $0f2a76a440eafaaa$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $0f2a76a440eafaaa$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $0f2a76a440eafaaa$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $0f2a76a440eafaaa$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $0f2a76a440eafaaa$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $0f2a76a440eafaaa$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $0f2a76a440eafaaa$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $0f2a76a440eafaaa$var$noSpacing : _ref2$padding;
    var marginBox = $0f2a76a440eafaaa$export$4b834cebd9e5cebe($0f2a76a440eafaaa$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $0f2a76a440eafaaa$export$4b834cebd9e5cebe($0f2a76a440eafaaa$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $0f2a76a440eafaaa$export$4b834cebd9e5cebe($0f2a76a440eafaaa$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $0f2a76a440eafaaa$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $0f2a76a440eafaaa$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    return result;
};
var $0f2a76a440eafaaa$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $0f2a76a440eafaaa$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $0f2a76a440eafaaa$var$shift(borderBox, change);
    return $0f2a76a440eafaaa$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $0f2a76a440eafaaa$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $0f2a76a440eafaaa$var$getWindowScroll();
    return $0f2a76a440eafaaa$export$cc800923e997bb8(original, scroll);
};
var $0f2a76a440eafaaa$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $0f2a76a440eafaaa$var$parse(styles.marginTop),
        right: $0f2a76a440eafaaa$var$parse(styles.marginRight),
        bottom: $0f2a76a440eafaaa$var$parse(styles.marginBottom),
        left: $0f2a76a440eafaaa$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $0f2a76a440eafaaa$var$parse(styles.paddingTop),
        right: $0f2a76a440eafaaa$var$parse(styles.paddingRight),
        bottom: $0f2a76a440eafaaa$var$parse(styles.paddingBottom),
        left: $0f2a76a440eafaaa$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $0f2a76a440eafaaa$var$parse(styles.borderTopWidth),
        right: $0f2a76a440eafaaa$var$parse(styles.borderRightWidth),
        bottom: $0f2a76a440eafaaa$var$parse(styles.borderBottomWidth),
        left: $0f2a76a440eafaaa$var$parse(styles.borderLeftWidth)
    };
    return $0f2a76a440eafaaa$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $0f2a76a440eafaaa$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $0f2a76a440eafaaa$export$b8dfc5d4e552b8e1(borderBox, styles);
};


var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $e111773323c0bcc0$export$2e2bcd8739ae039 = $e111773323c0bcc0$var$memoizeOne;


var $8f52a5054f09a665$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $8f52a5054f09a665$export$2e2bcd8739ae039 = $8f52a5054f09a665$var$rafSchd;



var $1u0KT = parcelRequire("1u0KT");
var $1710e65dc30c5dd1$var$isProduction = true;
var $1710e65dc30c5dd1$var$spacesAndTabs = /[ \t]{2,}/g;
var $1710e65dc30c5dd1$var$lineStartWithSpaces = /^[ \t]*/gm;
var $1710e65dc30c5dd1$var$clean = function clean(value) {
    return value.replace($1710e65dc30c5dd1$var$spacesAndTabs, ' ').replace($1710e65dc30c5dd1$var$lineStartWithSpaces, '').trim();
};
var $1710e65dc30c5dd1$var$getDevMessage = function getDevMessage(message) {
    return $1710e65dc30c5dd1$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $1710e65dc30c5dd1$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $1710e65dc30c5dd1$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $1710e65dc30c5dd1$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $1710e65dc30c5dd1$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function $1710e65dc30c5dd1$var$log(type, message) {
    var _console;
    if ($1710e65dc30c5dd1$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$1710e65dc30c5dd1$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $1710e65dc30c5dd1$var$getFormattedMessage(message));
}
var $1710e65dc30c5dd1$var$warning = $1710e65dc30c5dd1$var$log.bind(null, 'warn');
var $1710e65dc30c5dd1$var$error = $1710e65dc30c5dd1$var$log.bind(null, 'error');
function $1710e65dc30c5dd1$var$noop() {}
function $1710e65dc30c5dd1$var$getOptions(shared, fromBinding) {
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, shared, {}, fromBinding);
}
function $1710e65dc30c5dd1$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $1710e65dc30c5dd1$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $1710e65dc30c5dd1$var$isProduction$1 = true;
var $1710e65dc30c5dd1$var$prefix = 'Invariant failed';
function $1710e65dc30c5dd1$var$RbdInvariant(message) {
    this.message = message;
}
$1710e65dc30c5dd1$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $1710e65dc30c5dd1$var$invariant(condition, message) {
    if (condition) return;
    if ($1710e65dc30c5dd1$var$isProduction$1) throw new $1710e65dc30c5dd1$var$RbdInvariant($1710e65dc30c5dd1$var$prefix);
    else throw new $1710e65dc30c5dd1$var$RbdInvariant($1710e65dc30c5dd1$var$prefix + ": " + (message || ''));
}
var $1710e65dc30c5dd1$var$ErrorBoundary = function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $1710e65dc30c5dd1$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $1710e65dc30c5dd1$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $1710e65dc30c5dd1$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $1710e65dc30c5dd1$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $1710e65dc30c5dd1$var$dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
var $1710e65dc30c5dd1$var$position = function position(index) {
    return index + 1;
};
var $1710e65dc30c5dd1$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $1710e65dc30c5dd1$var$position(start.source.index) + "\n";
};
var $1710e65dc30c5dd1$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $1710e65dc30c5dd1$var$position(source.index);
    var endPosition = $1710e65dc30c5dd1$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $1710e65dc30c5dd1$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $1710e65dc30c5dd1$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $1710e65dc30c5dd1$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $1710e65dc30c5dd1$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $1710e65dc30c5dd1$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $1710e65dc30c5dd1$var$position(source.index) + "\n";
};
var $1710e65dc30c5dd1$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $1710e65dc30c5dd1$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $1710e65dc30c5dd1$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $1710e65dc30c5dd1$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $1710e65dc30c5dd1$var$returnedToStart(result.source) + "\n  ";
};
var $1710e65dc30c5dd1$var$preset = {
    dragHandleUsageInstructions: $1710e65dc30c5dd1$var$dragHandleUsageInstructions,
    onDragStart: $1710e65dc30c5dd1$var$onDragStart,
    onDragUpdate: $1710e65dc30c5dd1$var$onDragUpdate,
    onDragEnd: $1710e65dc30c5dd1$var$onDragEnd
};
function $1710e65dc30c5dd1$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $1710e65dc30c5dd1$var$useMemoOne(getResult, inputs) {
    var initial = (0, $acw62.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $acw62.useRef)(true);
    var committed = (0, $acw62.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $1710e65dc30c5dd1$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $acw62.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $1710e65dc30c5dd1$var$useCallbackOne(callback, inputs) {
    return $1710e65dc30c5dd1$var$useMemoOne(function() {
        return callback;
    }, inputs);
}
var $1710e65dc30c5dd1$var$useMemo = $1710e65dc30c5dd1$var$useMemoOne;
var $1710e65dc30c5dd1$var$useCallback = $1710e65dc30c5dd1$var$useCallbackOne;
var $1710e65dc30c5dd1$var$origin = {
    x: 0,
    y: 0
};
var $1710e65dc30c5dd1$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $1710e65dc30c5dd1$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $1710e65dc30c5dd1$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $1710e65dc30c5dd1$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $1710e65dc30c5dd1$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $1710e65dc30c5dd1$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $1710e65dc30c5dd1$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $1710e65dc30c5dd1$var$distance(target, point);
    }));
};
var $1710e65dc30c5dd1$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $1710e65dc30c5dd1$var$executeClip = function(frame, subject) {
    var result = (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $1710e65dc30c5dd1$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $1710e65dc30c5dd1$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $1710e65dc30c5dd1$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $1710e65dc30c5dd1$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $1710e65dc30c5dd1$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $1710e65dc30c5dd1$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $1710e65dc30c5dd1$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $1710e65dc30c5dd1$var$executeClip(frame.pageMarginBox, target);
    return (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)(target);
};
var $1710e65dc30c5dd1$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $1710e65dc30c5dd1$var$scroll(page.marginBox, frame);
    var increased = $1710e65dc30c5dd1$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $1710e65dc30c5dd1$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $1710e65dc30c5dd1$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $1710e65dc30c5dd1$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $1710e65dc30c5dd1$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $1710e65dc30c5dd1$var$negate(scrollDiff);
    var frame = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $1710e65dc30c5dd1$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $1710e65dc30c5dd1$var$isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function $1710e65dc30c5dd1$var$values(map) {
    if (Object.values) return Object.values(map);
    return Object.keys(map).map(function(key) {
        return map[key];
    });
}
function $1710e65dc30c5dd1$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $1710e65dc30c5dd1$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $1710e65dc30c5dd1$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $1710e65dc30c5dd1$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $1710e65dc30c5dd1$var$toDroppableMap = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $1710e65dc30c5dd1$var$toDraggableMap = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $1710e65dc30c5dd1$var$toDroppableList = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(droppables) {
    return $1710e65dc30c5dd1$var$values(droppables);
});
var $1710e65dc30c5dd1$var$toDraggableList = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(draggables) {
    return $1710e65dc30c5dd1$var$values(draggables);
});
var $1710e65dc30c5dd1$var$getDraggablesInsideDroppable = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(droppableId, draggables) {
    var result = $1710e65dc30c5dd1$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $1710e65dc30c5dd1$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $1710e65dc30c5dd1$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $1710e65dc30c5dd1$var$removeDraggableFromList = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $1710e65dc30c5dd1$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $1710e65dc30c5dd1$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $1710e65dc30c5dd1$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $1710e65dc30c5dd1$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $1710e65dc30c5dd1$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $1710e65dc30c5dd1$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $1710e65dc30c5dd1$var$noDisplacedBy = {
    point: $1710e65dc30c5dd1$var$origin,
    value: 0
};
var $1710e65dc30c5dd1$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $1710e65dc30c5dd1$var$noImpact = {
    displaced: $1710e65dc30c5dd1$var$emptyGroups,
    displacedBy: $1710e65dc30c5dd1$var$noDisplacedBy,
    at: null
};
var $1710e65dc30c5dd1$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $1710e65dc30c5dd1$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $1710e65dc30c5dd1$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $1710e65dc30c5dd1$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $1710e65dc30c5dd1$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $1710e65dc30c5dd1$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $1710e65dc30c5dd1$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $1710e65dc30c5dd1$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $1710e65dc30c5dd1$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $1710e65dc30c5dd1$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $1710e65dc30c5dd1$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $1710e65dc30c5dd1$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $1710e65dc30c5dd1$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $1710e65dc30c5dd1$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $1710e65dc30c5dd1$var$origin;
    return $1710e65dc30c5dd1$var$offsetByPosition(target, displacement);
};
var $1710e65dc30c5dd1$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $1710e65dc30c5dd1$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $1710e65dc30c5dd1$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $1710e65dc30c5dd1$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $1710e65dc30c5dd1$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $1710e65dc30c5dd1$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $1710e65dc30c5dd1$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $1710e65dc30c5dd1$var$isVisible((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $1710e65dc30c5dd1$var$isPartiallyVisibleThroughFrame
    }));
};
var $1710e65dc30c5dd1$var$isTotallyVisible = function isTotallyVisible(args) {
    return $1710e65dc30c5dd1$var$isVisible((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $1710e65dc30c5dd1$var$isTotallyVisibleThroughFrame
    }));
};
var $1710e65dc30c5dd1$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $1710e65dc30c5dd1$var$isVisible((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $1710e65dc30c5dd1$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $1710e65dc30c5dd1$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $1710e65dc30c5dd1$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)((0, $0f2a76a440eafaaa$export$9f77e0932fb78f72)(marginBox, expandBy));
}
function $1710e65dc30c5dd1$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $1710e65dc30c5dd1$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $1710e65dc30c5dd1$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $1710e65dc30c5dd1$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $1710e65dc30c5dd1$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $1710e65dc30c5dd1$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $1710e65dc30c5dd1$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $1710e65dc30c5dd1$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $1710e65dc30c5dd1$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $1710e65dc30c5dd1$var$isHomeOf(draggable, destination);
    if (index == null) return $1710e65dc30c5dd1$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $1710e65dc30c5dd1$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $1710e65dc30c5dd1$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $1710e65dc30c5dd1$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $1710e65dc30c5dd1$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $1710e65dc30c5dd1$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $1710e65dc30c5dd1$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $1710e65dc30c5dd1$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $1710e65dc30c5dd1$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $1710e65dc30c5dd1$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $1710e65dc30c5dd1$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        var _newIndex = $1710e65dc30c5dd1$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $1710e65dc30c5dd1$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $1710e65dc30c5dd1$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $1710e65dc30c5dd1$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $1710e65dc30c5dd1$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($1710e65dc30c5dd1$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $1710e65dc30c5dd1$var$origin : $1710e65dc30c5dd1$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $1710e65dc30c5dd1$var$origin;
};
var $1710e65dc30c5dd1$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $1710e65dc30c5dd1$var$tryGetCombine(impact);
    !combine && $1710e65dc30c5dd1$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $1710e65dc30c5dd1$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $1710e65dc30c5dd1$var$add(center, displaceBy);
};
var $1710e65dc30c5dd1$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $1710e65dc30c5dd1$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $1710e65dc30c5dd1$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $1710e65dc30c5dd1$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $1710e65dc30c5dd1$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $1710e65dc30c5dd1$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $1710e65dc30c5dd1$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $1710e65dc30c5dd1$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $1710e65dc30c5dd1$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $1710e65dc30c5dd1$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $1710e65dc30c5dd1$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $1710e65dc30c5dd1$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $1710e65dc30c5dd1$var$patch(axis.line, moveInto.contentBox[axis.start] + $1710e65dc30c5dd1$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $1710e65dc30c5dd1$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $1710e65dc30c5dd1$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $1710e65dc30c5dd1$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $1710e65dc30c5dd1$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($1710e65dc30c5dd1$var$didStartAfterCritical(closestAfter, afterCritical)) return $1710e65dc30c5dd1$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $0f2a76a440eafaaa$export$cc800923e997bb8)(closest.page, displacedBy.point);
        return $1710e65dc30c5dd1$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($1710e65dc30c5dd1$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $0f2a76a440eafaaa$export$cc800923e997bb8)(last.page, $1710e65dc30c5dd1$var$negate(afterCritical.displacedBy.point));
        return $1710e65dc30c5dd1$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $1710e65dc30c5dd1$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $1710e65dc30c5dd1$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $1710e65dc30c5dd1$var$add(point, frame.scroll.diff.displacement);
};
var $1710e65dc30c5dd1$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $1710e65dc30c5dd1$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $1710e65dc30c5dd1$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $1710e65dc30c5dd1$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $1710e65dc30c5dd1$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $1710e65dc30c5dd1$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $1710e65dc30c5dd1$var$scrollViewport = function(viewport, newScroll) {
    var diff = $1710e65dc30c5dd1$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $1710e65dc30c5dd1$var$negate(diff);
    var frame = (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $1710e65dc30c5dd1$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $1710e65dc30c5dd1$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $1710e65dc30c5dd1$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $1710e65dc30c5dd1$var$scrollViewport(viewport, $1710e65dc30c5dd1$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $1710e65dc30c5dd1$var$scrollDroppable(destination, $1710e65dc30c5dd1$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $1710e65dc30c5dd1$var$getDisplacementGroups({
        afterDragging: $1710e65dc30c5dd1$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $1710e65dc30c5dd1$var$getDisplacementGroups({
        afterDragging: $1710e65dc30c5dd1$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $1710e65dc30c5dd1$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $1710e65dc30c5dd1$var$withViewportDisplacement = function(viewport, point) {
    return $1710e65dc30c5dd1$var$add(viewport.scroll.diff.displacement, point);
};
var $1710e65dc30c5dd1$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $1710e65dc30c5dd1$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $1710e65dc30c5dd1$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $1710e65dc30c5dd1$var$add(draggable.client.borderBox.center, offset);
};
var $1710e65dc30c5dd1$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $1710e65dc30c5dd1$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $1710e65dc30c5dd1$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $1710e65dc30c5dd1$var$isTotallyVisibleOnAxis(args) : $1710e65dc30c5dd1$var$isTotallyVisible(args);
};
var $1710e65dc30c5dd1$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $1710e65dc30c5dd1$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $1710e65dc30c5dd1$var$isHomeOf(draggable, destination);
    var impact = $1710e65dc30c5dd1$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $1710e65dc30c5dd1$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $1710e65dc30c5dd1$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $1710e65dc30c5dd1$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $1710e65dc30c5dd1$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $1710e65dc30c5dd1$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $1710e65dc30c5dd1$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $1710e65dc30c5dd1$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $1710e65dc30c5dd1$var$invariant(false);
    return rect;
};
var $1710e65dc30c5dd1$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $1710e65dc30c5dd1$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $1710e65dc30c5dd1$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $1710e65dc30c5dd1$var$isPartiallyVisibleThroughFrame(viewport.frame)($1710e65dc30c5dd1$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $1710e65dc30c5dd1$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $1710e65dc30c5dd1$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $1710e65dc30c5dd1$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $1710e65dc30c5dd1$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $1710e65dc30c5dd1$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $1710e65dc30c5dd1$var$getKnownActive(droppable)[axis.crossAxisStart] === $1710e65dc30c5dd1$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $1710e65dc30c5dd1$var$isWithin($1710e65dc30c5dd1$var$getKnownActive(droppable)[axis.start], $1710e65dc30c5dd1$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $1710e65dc30c5dd1$var$getKnownActive(a)[axis.start] - $1710e65dc30c5dd1$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $1710e65dc30c5dd1$var$closest(pageBorderBoxCenter, $1710e65dc30c5dd1$var$getCorners($1710e65dc30c5dd1$var$getKnownActive(a)));
        var second = $1710e65dc30c5dd1$var$closest(pageBorderBoxCenter, $1710e65dc30c5dd1$var$getCorners($1710e65dc30c5dd1$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $1710e65dc30c5dd1$var$getKnownActive(a)[axis.start] - $1710e65dc30c5dd1$var$getKnownActive(b)[axis.start];
    })[0];
};
var $1710e65dc30c5dd1$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $1710e65dc30c5dd1$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $1710e65dc30c5dd1$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $1710e65dc30c5dd1$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $1710e65dc30c5dd1$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $1710e65dc30c5dd1$var$offsetByPosition(original, $1710e65dc30c5dd1$var$negate(afterCritical.displacedBy.point)) : original;
};
var $1710e65dc30c5dd1$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $1710e65dc30c5dd1$var$isTotallyVisible({
            target: $1710e65dc30c5dd1$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $1710e65dc30c5dd1$var$distance(pageBorderBoxCenter, $1710e65dc30c5dd1$var$withDroppableDisplacement(destination, $1710e65dc30c5dd1$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $1710e65dc30c5dd1$var$distance(pageBorderBoxCenter, $1710e65dc30c5dd1$var$withDroppableDisplacement(destination, $1710e65dc30c5dd1$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $1710e65dc30c5dd1$var$getDisplacedBy = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $1710e65dc30c5dd1$var$patch(axis.line, displacement)
    };
});
var $1710e65dc30c5dd1$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $1710e65dc30c5dd1$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $1710e65dc30c5dd1$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $1710e65dc30c5dd1$var$patch(axis.line, needsToGrowBy);
};
var $1710e65dc30c5dd1$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, frame, {
        scroll: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, frame.scroll, {
            max: max
        })
    });
};
var $1710e65dc30c5dd1$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$1710e65dc30c5dd1$var$isHomeOf(draggable, droppable) && $1710e65dc30c5dd1$var$invariant(false);
    !!droppable.subject.withPlaceholder && $1710e65dc30c5dd1$var$invariant(false);
    var placeholderSize = $1710e65dc30c5dd1$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $1710e65dc30c5dd1$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $1710e65dc30c5dd1$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $1710e65dc30c5dd1$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $1710e65dc30c5dd1$var$withMaxScroll(frame, maxScroll);
    var subject = $1710e65dc30c5dd1$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $1710e65dc30c5dd1$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $1710e65dc30c5dd1$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $1710e65dc30c5dd1$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $1710e65dc30c5dd1$var$invariant(false);
    var newFrame = $1710e65dc30c5dd1$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $1710e65dc30c5dd1$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $1710e65dc30c5dd1$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $1710e65dc30c5dd1$var$emptyGroups,
            displacedBy: $1710e65dc30c5dd1$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $1710e65dc30c5dd1$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $1710e65dc30c5dd1$var$isHomeOf(draggable, destination) ? destination : $1710e65dc30c5dd1$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $1710e65dc30c5dd1$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $1710e65dc30c5dd1$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $1710e65dc30c5dd1$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $1710e65dc30c5dd1$var$emptyGroups,
        index: proposedIndex
    });
};
var $1710e65dc30c5dd1$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $1710e65dc30c5dd1$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $1710e65dc30c5dd1$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $1710e65dc30c5dd1$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $1710e65dc30c5dd1$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $1710e65dc30c5dd1$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $1710e65dc30c5dd1$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $1710e65dc30c5dd1$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
var $1710e65dc30c5dd1$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $1710e65dc30c5dd1$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $1710e65dc30c5dd1$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $1710e65dc30c5dd1$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $1710e65dc30c5dd1$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $1710e65dc30c5dd1$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $1710e65dc30c5dd1$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $1710e65dc30c5dd1$var$isPositionInFrame(frame) {
    var isWithinVertical = $1710e65dc30c5dd1$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $1710e65dc30c5dd1$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $1710e65dc30c5dd1$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $1710e65dc30c5dd1$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $1710e65dc30c5dd1$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $1710e65dc30c5dd1$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $1710e65dc30c5dd1$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $1710e65dc30c5dd1$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$1710e65dc30c5dd1$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($1710e65dc30c5dd1$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $1710e65dc30c5dd1$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $1710e65dc30c5dd1$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $1710e65dc30c5dd1$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)($1710e65dc30c5dd1$var$offsetByPosition(rect, point));
};
var $1710e65dc30c5dd1$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $1710e65dc30c5dd1$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $1710e65dc30c5dd1$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $1710e65dc30c5dd1$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $1710e65dc30c5dd1$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $1710e65dc30c5dd1$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $1710e65dc30c5dd1$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $1710e65dc30c5dd1$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $1710e65dc30c5dd1$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $1710e65dc30c5dd1$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $1710e65dc30c5dd1$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $1710e65dc30c5dd1$var$isHomeOf(draggable, destination)
    });
    return $1710e65dc30c5dd1$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $1710e65dc30c5dd1$var$combineThresholdDivisor = 4;
var $1710e65dc30c5dd1$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $1710e65dc30c5dd1$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $1710e65dc30c5dd1$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $1710e65dc30c5dd1$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $1710e65dc30c5dd1$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $1710e65dc30c5dd1$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $1710e65dc30c5dd1$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $1710e65dc30c5dd1$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $1710e65dc30c5dd1$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $1710e65dc30c5dd1$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $1710e65dc30c5dd1$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $1710e65dc30c5dd1$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $1710e65dc30c5dd1$var$withDroppableScroll(destination, pageBorderBox);
    return $1710e65dc30c5dd1$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $1710e65dc30c5dd1$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $1710e65dc30c5dd1$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $1710e65dc30c5dd1$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $1710e65dc30c5dd1$var$whatIsDraggedOver(previousImpact);
    var now = $1710e65dc30c5dd1$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $1710e65dc30c5dd1$var$removePlaceholder(lastDroppable);
    return $1710e65dc30c5dd1$var$patchDroppableMap(droppables, updated);
};
var $1710e65dc30c5dd1$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $1710e65dc30c5dd1$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $1710e65dc30c5dd1$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($1710e65dc30c5dd1$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $1710e65dc30c5dd1$var$addPlaceholder(droppable, draggable, draggables);
    return $1710e65dc30c5dd1$var$patchDroppableMap(cleaned, patched);
};
var $1710e65dc30c5dd1$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $1710e65dc30c5dd1$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $1710e65dc30c5dd1$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $1710e65dc30c5dd1$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $1710e65dc30c5dd1$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $1710e65dc30c5dd1$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $1710e65dc30c5dd1$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $1710e65dc30c5dd1$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $1710e65dc30c5dd1$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $1710e65dc30c5dd1$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $1710e65dc30c5dd1$var$getDraggables$1(last.all, draggables);
    var displaced = $1710e65dc30c5dd1$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, impact, {
        displaced: displaced
    });
};
var $1710e65dc30c5dd1$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $1710e65dc30c5dd1$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $1710e65dc30c5dd1$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $1710e65dc30c5dd1$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && $1710e65dc30c5dd1$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $1710e65dc30c5dd1$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $1710e65dc30c5dd1$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $1710e65dc30c5dd1$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $1710e65dc30c5dd1$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $1710e65dc30c5dd1$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $1710e65dc30c5dd1$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $1710e65dc30c5dd1$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $1710e65dc30c5dd1$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $1710e65dc30c5dd1$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $1710e65dc30c5dd1$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $1710e65dc30c5dd1$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $1710e65dc30c5dd1$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $1710e65dc30c5dd1$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $1710e65dc30c5dd1$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $1710e65dc30c5dd1$var$start = function start(key) {};
var $1710e65dc30c5dd1$var$finish = function finish(key) {};
var $1710e65dc30c5dd1$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $0f2a76a440eafaaa$export$cc800923e997bb8)(draggable.client, offset$1);
    var page = (0, $0f2a76a440eafaaa$export$1d0caec378d7d0ae)(client, initialWindowScroll);
    var moved = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, draggable, {
        placeholder: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $1710e65dc30c5dd1$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $1710e65dc30c5dd1$var$invariant(false);
    return frame;
};
var $1710e65dc30c5dd1$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $1710e65dc30c5dd1$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $1710e65dc30c5dd1$var$add(windowScrollChange, droppableScrollChange);
        var moved = $1710e65dc30c5dd1$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $1710e65dc30c5dd1$var$publishWhileDraggingInVirtual = function(_ref) {
    var state = _ref.state, published = _ref.published;
    $1710e65dc30c5dd1$var$start();
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $1710e65dc30c5dd1$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.dimensions.droppables, {}, $1710e65dc30c5dd1$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $1710e65dc30c5dd1$var$toDraggableMap($1710e65dc30c5dd1$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.dimensions.draggables, {}, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $1710e65dc30c5dd1$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $1710e65dc30c5dd1$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $1710e65dc30c5dd1$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $1710e65dc30c5dd1$var$finish();
    var draggingState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        phase: 'DRAGGING'
    }, state, {
        phase: 'DRAGGING',
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    });
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        phase: 'DROP_PENDING'
    }, draggingState, {
        phase: 'DROP_PENDING',
        reason: state.reason,
        isWaiting: false
    });
    return dropPending;
};
var $1710e65dc30c5dd1$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $1710e65dc30c5dd1$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $1710e65dc30c5dd1$var$patchDimensionMap(state.dimensions, updated);
    if (!$1710e65dc30c5dd1$var$isSnapping(state) || isEnabledChanging) return $1710e65dc30c5dd1$var$update({
        state: state,
        dimensions: dimensions
    });
    return $1710e65dc30c5dd1$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $1710e65dc30c5dd1$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        phase: 'DRAGGING'
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $1710e65dc30c5dd1$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $1710e65dc30c5dd1$var$reducer = function(state, action) {
    if (state === void 0) state = $1710e65dc30c5dd1$var$idle;
    if (action.type === 'FLUSH') return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $1710e65dc30c5dd1$var$idle, {
        shouldFlush: true
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $1710e65dc30c5dd1$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $1710e65dc30c5dd1$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $1710e65dc30c5dd1$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $1710e65dc30c5dd1$var$add(client.selection, viewport.scroll.initial),
                offset: $1710e65dc30c5dd1$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $1710e65dc30c5dd1$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $1710e65dc30c5dd1$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $1710e65dc30c5dd1$var$invariant(false);
        var _result = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            phase: 'COLLECTING'
        }, state, {
            phase: 'COLLECTING'
        });
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $1710e65dc30c5dd1$var$invariant(false);
        return $1710e65dc30c5dd1$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$1710e65dc30c5dd1$var$isMovementAllowed(state) && $1710e65dc30c5dd1$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($1710e65dc30c5dd1$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $1710e65dc30c5dd1$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $1710e65dc30c5dd1$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $1710e65dc30c5dd1$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $1710e65dc30c5dd1$var$removeScrollJumpRequest(state);
        !$1710e65dc30c5dd1$var$isMovementAllowed(state) && $1710e65dc30c5dd1$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $1710e65dc30c5dd1$var$scrollDroppable(target, newScroll);
        return $1710e65dc30c5dd1$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$1710e65dc30c5dd1$var$isMovementAllowed(state) && $1710e65dc30c5dd1$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $1710e65dc30c5dd1$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $1710e65dc30c5dd1$var$invariant(false);
        var updated = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, _target, {
            isEnabled: isEnabled
        });
        return $1710e65dc30c5dd1$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$1710e65dc30c5dd1$var$isMovementAllowed(state) && $1710e65dc30c5dd1$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $1710e65dc30c5dd1$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $1710e65dc30c5dd1$var$invariant(false);
        var _updated = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $1710e65dc30c5dd1$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$1710e65dc30c5dd1$var$isMovementAllowed(state) && $1710e65dc30c5dd1$var$invariant(false);
        !state.isWindowScrollAllowed && $1710e65dc30c5dd1$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($1710e65dc30c5dd1$var$isEqual(state.viewport.scroll.current, _newScroll)) return $1710e65dc30c5dd1$var$removeScrollJumpRequest(state);
        var _viewport = $1710e65dc30c5dd1$var$scrollViewport(state.viewport, _newScroll);
        if ($1710e65dc30c5dd1$var$isSnapping(state)) return $1710e65dc30c5dd1$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $1710e65dc30c5dd1$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$1710e65dc30c5dd1$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($1710e65dc30c5dd1$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.viewport, {
            scroll: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $1710e65dc30c5dd1$var$invariant(false);
        var _result2 = $1710e65dc30c5dd1$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $1710e65dc30c5dd1$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $1710e65dc30c5dd1$var$invariant(false);
        var newState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            phase: 'DROP_PENDING'
        }, state, {
            phase: 'DROP_PENDING',
            isWaiting: true,
            reason: reason
        });
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $1710e65dc30c5dd1$var$invariant(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _completed = action.payload.completed;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $1710e65dc30c5dd1$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $1710e65dc30c5dd1$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $1710e65dc30c5dd1$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $1710e65dc30c5dd1$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $1710e65dc30c5dd1$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $1710e65dc30c5dd1$var$flush = function flush() {
    return {
        type: 'FLUSH',
        payload: null
    };
};
var $1710e65dc30c5dd1$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $1710e65dc30c5dd1$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
function $1710e65dc30c5dd1$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(', ');
}
function $1710e65dc30c5dd1$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $1710e65dc30c5dd1$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($1710e65dc30c5dd1$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $1710e65dc30c5dd1$var$invariant(false);
                dispatch($1710e65dc30c5dd1$var$flush());
                dispatch($1710e65dc30c5dd1$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $1710e65dc30c5dd1$var$validateDimensions(critical, dimensions);
                dispatch($1710e65dc30c5dd1$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $1710e65dc30c5dd1$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $1710e65dc30c5dd1$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $1710e65dc30c5dd1$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $1710e65dc30c5dd1$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $1710e65dc30c5dd1$var$outOfTheWayTiming = $1710e65dc30c5dd1$var$timings.outOfTheWay + "s " + $1710e65dc30c5dd1$var$curves.outOfTheWay;
var $1710e65dc30c5dd1$var$transitions = {
    fluid: "opacity " + $1710e65dc30c5dd1$var$outOfTheWayTiming,
    snap: "transform " + $1710e65dc30c5dd1$var$outOfTheWayTiming + ", opacity " + $1710e65dc30c5dd1$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $1710e65dc30c5dd1$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $1710e65dc30c5dd1$var$outOfTheWayTiming,
    placeholder: "height " + $1710e65dc30c5dd1$var$outOfTheWayTiming + ", width " + $1710e65dc30c5dd1$var$outOfTheWayTiming + ", margin " + $1710e65dc30c5dd1$var$outOfTheWayTiming
};
var $1710e65dc30c5dd1$var$moveTo = function moveTo(offset) {
    return $1710e65dc30c5dd1$var$isEqual(offset, $1710e65dc30c5dd1$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $1710e65dc30c5dd1$var$transforms = {
    moveTo: $1710e65dc30c5dd1$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $1710e65dc30c5dd1$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $1710e65dc30c5dd1$var$combine.scale.drop + ")";
    }
};
var $1710e65dc30c5dd1$var$minDropTime = $1710e65dc30c5dd1$var$timings.minDropTime, $1710e65dc30c5dd1$var$maxDropTime = $1710e65dc30c5dd1$var$timings.maxDropTime;
var $1710e65dc30c5dd1$var$dropTimeRange = $1710e65dc30c5dd1$var$maxDropTime - $1710e65dc30c5dd1$var$minDropTime;
var $1710e65dc30c5dd1$var$maxDropTimeAtDistance = 1500;
var $1710e65dc30c5dd1$var$cancelDropModifier = 0.6;
var $1710e65dc30c5dd1$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $1710e65dc30c5dd1$var$distance(current, destination);
    if (distance$1 <= 0) return $1710e65dc30c5dd1$var$minDropTime;
    if (distance$1 >= $1710e65dc30c5dd1$var$maxDropTimeAtDistance) return $1710e65dc30c5dd1$var$maxDropTime;
    var percentage = distance$1 / $1710e65dc30c5dd1$var$maxDropTimeAtDistance;
    var duration = $1710e65dc30c5dd1$var$minDropTime + $1710e65dc30c5dd1$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $1710e65dc30c5dd1$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $1710e65dc30c5dd1$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $1710e65dc30c5dd1$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $1710e65dc30c5dd1$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $1710e65dc30c5dd1$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $1710e65dc30c5dd1$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== 'DROP') {
        var recomputedHomeImpact = $1710e65dc30c5dd1$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, lastImpact, {
        displaced: $1710e65dc30c5dd1$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $1710e65dc30c5dd1$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($1710e65dc30c5dd1$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $1710e65dc30c5dd1$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $1710e65dc30c5dd1$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $1710e65dc30c5dd1$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $1710e65dc30c5dd1$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $1710e65dc30c5dd1$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $1710e65dc30c5dd1$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$1710e65dc30c5dd1$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($1710e65dc30c5dd1$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $1710e65dc30c5dd1$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($1710e65dc30c5dd1$var$animateDrop(args));
        };
    };
};
var $1710e65dc30c5dd1$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $1710e65dc30c5dd1$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $1710e65dc30c5dd1$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($1710e65dc30c5dd1$var$getWindowScroll());
    }
    var scheduled = (0, $8f52a5054f09a665$export$2e2bcd8739ae039)(updateScroll);
    var binding = $1710e65dc30c5dd1$var$getWindowScrollBinding(scheduled);
    var unbind = $1710e65dc30c5dd1$var$noop;
    function isActive() {
        return unbind !== $1710e65dc30c5dd1$var$noop;
    }
    function start() {
        !!isActive() && $1710e65dc30c5dd1$var$invariant(false);
        unbind = $1710e65dc30c5dd1$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $1710e65dc30c5dd1$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $1710e65dc30c5dd1$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $1710e65dc30c5dd1$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $1710e65dc30c5dd1$var$scrollListener = function(store) {
    var listener = $1710e65dc30c5dd1$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($1710e65dc30c5dd1$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $1710e65dc30c5dd1$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $1710e65dc30c5dd1$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $1710e65dc30c5dd1$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $1710e65dc30c5dd1$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $1710e65dc30c5dd1$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $1710e65dc30c5dd1$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $1710e65dc30c5dd1$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $1710e65dc30c5dd1$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $1710e65dc30c5dd1$var$withTimings = function withTimings(key, fn) {
    $1710e65dc30c5dd1$var$start();
    fn();
    $1710e65dc30c5dd1$var$finish();
};
var $1710e65dc30c5dd1$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $1710e65dc30c5dd1$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $1710e65dc30c5dd1$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $1710e65dc30c5dd1$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $1710e65dc30c5dd1$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $1710e65dc30c5dd1$var$invariant(false);
        $1710e65dc30c5dd1$var$withTimings('onBeforeCapture', function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $1710e65dc30c5dd1$var$invariant(false);
        $1710e65dc30c5dd1$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($1710e65dc30c5dd1$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $1710e65dc30c5dd1$var$invariant(false);
        var data = $1710e65dc30c5dd1$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $1710e65dc30c5dd1$var$withTimings('onDragStart', function() {
                return $1710e65dc30c5dd1$var$execute(getResponders().onDragStart, data, announce, $1710e65dc30c5dd1$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $1710e65dc30c5dd1$var$tryGetDestination(impact);
        var combine = $1710e65dc30c5dd1$var$tryGetCombine(impact);
        !dragging && $1710e65dc30c5dd1$var$invariant(false);
        var hasCriticalChanged = !$1710e65dc30c5dd1$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$1710e65dc30c5dd1$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$1710e65dc30c5dd1$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $1710e65dc30c5dd1$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $1710e65dc30c5dd1$var$withTimings('onDragUpdate', function() {
                return $1710e65dc30c5dd1$var$execute(getResponders().onDragUpdate, data, announce, $1710e65dc30c5dd1$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $1710e65dc30c5dd1$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $1710e65dc30c5dd1$var$invariant(false);
        dragging = null;
        $1710e65dc30c5dd1$var$withTimings('onDragEnd', function() {
            return $1710e65dc30c5dd1$var$execute(getResponders().onDragEnd, result, announce, $1710e65dc30c5dd1$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $1710e65dc30c5dd1$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $1710e65dc30c5dd1$var$responders = function(getResponders, announce) {
    var publisher = $1710e65dc30c5dd1$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $1710e65dc30c5dd1$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $1710e65dc30c5dd1$var$invariant(false);
            store.dispatch($1710e65dc30c5dd1$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $1710e65dc30c5dd1$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            var binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($1710e65dc30c5dd1$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $1710e65dc30c5dd1$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $1710e65dc30c5dd1$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $1710e65dc30c5dd1$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $1710e65dc30c5dd1$var$shouldStop = function shouldStop(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $1710e65dc30c5dd1$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($1710e65dc30c5dd1$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && $1710e65dc30c5dd1$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $1710e65dc30c5dd1$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($1710e65dc30c5dd1$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $1710e65dc30c5dd1$var$composeEnhancers = (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7);
var $1710e65dc30c5dd1$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)($1710e65dc30c5dd1$var$reducer, $1710e65dc30c5dd1$var$composeEnhancers((0, $d2bed10dff9b4968$export$9ff26e0402cc7b7)($1710e65dc30c5dd1$var$style(styleMarshal), $1710e65dc30c5dd1$var$dimensionMarshalStopper(dimensionMarshal), $1710e65dc30c5dd1$var$lift$1(dimensionMarshal), $1710e65dc30c5dd1$var$drop$1, $1710e65dc30c5dd1$var$dropAnimationFinish, $1710e65dc30c5dd1$var$dropAnimationFlushOnScroll, $1710e65dc30c5dd1$var$pendingDrop, $1710e65dc30c5dd1$var$autoScroll(autoScroller), $1710e65dc30c5dd1$var$scrollListener, $1710e65dc30c5dd1$var$focus(focusMarshal), $1710e65dc30c5dd1$var$responders(getResponders, announce))));
};
var $1710e65dc30c5dd1$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
function $1710e65dc30c5dd1$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $1710e65dc30c5dd1$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $1710e65dc30c5dd1$var$start();
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = Object.keys(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($1710e65dc30c5dd1$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = Object.keys(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $1710e65dc30c5dd1$var$clean$1();
            $1710e65dc30c5dd1$var$finish();
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $1710e65dc30c5dd1$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $1710e65dc30c5dd1$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $1710e65dc30c5dd1$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $1710e65dc30c5dd1$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $1710e65dc30c5dd1$var$invariant(false);
    return doc;
};
var $1710e65dc30c5dd1$var$getMaxWindowScroll = function() {
    var doc = $1710e65dc30c5dd1$var$getDocumentElement();
    var maxScroll = $1710e65dc30c5dd1$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $1710e65dc30c5dd1$var$getViewport = function() {
    var scroll = $1710e65dc30c5dd1$var$getWindowScroll();
    var maxScroll = $1710e65dc30c5dd1$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $1710e65dc30c5dd1$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $1710e65dc30c5dd1$var$origin,
                displacement: $1710e65dc30c5dd1$var$origin
            }
        }
    };
    return viewport;
};
var $1710e65dc30c5dd1$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    $1710e65dc30c5dd1$var$start();
    var viewport = $1710e65dc30c5dd1$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $1710e65dc30c5dd1$var$toDraggableMap(draggables),
        droppables: $1710e65dc30c5dd1$var$toDroppableMap(droppables)
    };
    $1710e65dc30c5dd1$var$finish();
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $1710e65dc30c5dd1$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $1710e65dc30c5dd1$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $1710e65dc30c5dd1$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $1710e65dc30c5dd1$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $1710e65dc30c5dd1$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $1710e65dc30c5dd1$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $1710e65dc30c5dd1$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($1710e65dc30c5dd1$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($1710e65dc30c5dd1$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $1710e65dc30c5dd1$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $1710e65dc30c5dd1$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $1710e65dc30c5dd1$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $1710e65dc30c5dd1$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $1710e65dc30c5dd1$var$getScrollableDroppables = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(droppables) {
    return $1710e65dc30c5dd1$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $1710e65dc30c5dd1$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $1710e65dc30c5dd1$var$find($1710e65dc30c5dd1$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $1710e65dc30c5dd1$var$invariant(false);
        return $1710e65dc30c5dd1$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $1710e65dc30c5dd1$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $1710e65dc30c5dd1$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $1710e65dc30c5dd1$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $1710e65dc30c5dd1$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $1710e65dc30c5dd1$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $1710e65dc30c5dd1$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $1710e65dc30c5dd1$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $1710e65dc30c5dd1$var$minScroll = 1;
var $1710e65dc30c5dd1$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $1710e65dc30c5dd1$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $1710e65dc30c5dd1$var$minScroll;
    var percentageFromMaxScrollValueAt = $1710e65dc30c5dd1$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $1710e65dc30c5dd1$var$config.maxPixelScroll * $1710e65dc30c5dd1$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $1710e65dc30c5dd1$var$accelerateAt = $1710e65dc30c5dd1$var$config.durationDampening.accelerateAt;
var $1710e65dc30c5dd1$var$stopAt = $1710e65dc30c5dd1$var$config.durationDampening.stopDampeningAt;
var $1710e65dc30c5dd1$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $1710e65dc30c5dd1$var$stopAt;
    var now = Date.now();
    var runTime = now - startOfRange;
    if (runTime >= $1710e65dc30c5dd1$var$stopAt) return proposedScroll;
    if (runTime < $1710e65dc30c5dd1$var$accelerateAt) return $1710e65dc30c5dd1$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $1710e65dc30c5dd1$var$getPercentage({
        startOfRange: $1710e65dc30c5dd1$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $1710e65dc30c5dd1$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $1710e65dc30c5dd1$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $1710e65dc30c5dd1$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($1710e65dc30c5dd1$var$dampenValueByTime(scroll, dragStartTime), $1710e65dc30c5dd1$var$minScroll);
};
var $1710e65dc30c5dd1$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $1710e65dc30c5dd1$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $1710e65dc30c5dd1$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $1710e65dc30c5dd1$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $1710e65dc30c5dd1$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $1710e65dc30c5dd1$var$clean$2 = $1710e65dc30c5dd1$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $1710e65dc30c5dd1$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $1710e65dc30c5dd1$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $1710e65dc30c5dd1$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $1710e65dc30c5dd1$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $1710e65dc30c5dd1$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $1710e65dc30c5dd1$var$clean$2({
        x: x,
        y: y
    });
    if ($1710e65dc30c5dd1$var$isEqual(required, $1710e65dc30c5dd1$var$origin)) return null;
    var limited = $1710e65dc30c5dd1$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $1710e65dc30c5dd1$var$isEqual(limited, $1710e65dc30c5dd1$var$origin) ? null : limited;
};
var $1710e65dc30c5dd1$var$smallestSigned = $1710e65dc30c5dd1$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $1710e65dc30c5dd1$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $1710e65dc30c5dd1$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($1710e65dc30c5dd1$var$isEqual(overlap, $1710e65dc30c5dd1$var$origin)) return null;
        return overlap;
    };
}();
var $1710e65dc30c5dd1$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $1710e65dc30c5dd1$var$smallestSigned(change);
    var overlap = $1710e65dc30c5dd1$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $1710e65dc30c5dd1$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $1710e65dc30c5dd1$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $1710e65dc30c5dd1$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$1710e65dc30c5dd1$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $1710e65dc30c5dd1$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $1710e65dc30c5dd1$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $1710e65dc30c5dd1$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $1710e65dc30c5dd1$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$1710e65dc30c5dd1$var$canScrollDroppable(droppable, change)) return null;
    return $1710e65dc30c5dd1$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $1710e65dc30c5dd1$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $1710e65dc30c5dd1$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $1710e65dc30c5dd1$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $1710e65dc30c5dd1$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $1710e65dc30c5dd1$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $1710e65dc30c5dd1$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $1710e65dc30c5dd1$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $1710e65dc30c5dd1$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $1710e65dc30c5dd1$var$getBestScrollableDroppable({
        center: center,
        destination: $1710e65dc30c5dd1$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $1710e65dc30c5dd1$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $1710e65dc30c5dd1$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $8f52a5054f09a665$export$2e2bcd8739ae039)(scrollWindow);
    var scheduleDroppableScroll = (0, $8f52a5054f09a665$export$2e2bcd8739ae039)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $1710e65dc30c5dd1$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $1710e65dc30c5dd1$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $1710e65dc30c5dd1$var$start();
        !!dragging && $1710e65dc30c5dd1$var$invariant(false);
        var dragStartTime = Date.now();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $1710e65dc30c5dd1$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $1710e65dc30c5dd1$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $1710e65dc30c5dd1$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $1710e65dc30c5dd1$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$1710e65dc30c5dd1$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $1710e65dc30c5dd1$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $1710e65dc30c5dd1$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $1710e65dc30c5dd1$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$1710e65dc30c5dd1$var$canScrollWindow(viewport, change)) return change;
        var overlap = $1710e65dc30c5dd1$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $1710e65dc30c5dd1$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $1710e65dc30c5dd1$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $1710e65dc30c5dd1$var$whatIsDraggedOver(state.impact);
        !destination && $1710e65dc30c5dd1$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $1710e65dc30c5dd1$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $1710e65dc30c5dd1$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $1710e65dc30c5dd1$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $1710e65dc30c5dd1$var$prefix$1 = 'data-rbd';
var $1710e65dc30c5dd1$var$dragHandle = function() {
    var base = $1710e65dc30c5dd1$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $1710e65dc30c5dd1$var$draggable = function() {
    var base = $1710e65dc30c5dd1$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $1710e65dc30c5dd1$var$droppable = function() {
    var base = $1710e65dc30c5dd1$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $1710e65dc30c5dd1$var$scrollContainer = {
    contextId: $1710e65dc30c5dd1$var$prefix$1 + "-scroll-container-context-id"
};
var $1710e65dc30c5dd1$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $1710e65dc30c5dd1$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $1710e65dc30c5dd1$var$noPointerEvents = 'pointer-events: none;';
var $1710e65dc30c5dd1$var$getStyles$1 = function(contextId) {
    var getSelector = $1710e65dc30c5dd1$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($1710e65dc30c5dd1$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $1710e65dc30c5dd1$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $1710e65dc30c5dd1$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($1710e65dc30c5dd1$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($1710e65dc30c5dd1$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $1710e65dc30c5dd1$var$getStyles(rules, 'always'),
        resting: $1710e65dc30c5dd1$var$getStyles(rules, 'resting'),
        dragging: $1710e65dc30c5dd1$var$getStyles(rules, 'dragging'),
        dropAnimating: $1710e65dc30c5dd1$var$getStyles(rules, 'dropAnimating'),
        userCancel: $1710e65dc30c5dd1$var$getStyles(rules, 'userCancel')
    };
};
var $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $1710e65dc30c5dd1$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && $1710e65dc30c5dd1$var$invariant(false);
    return head;
};
var $1710e65dc30c5dd1$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $1710e65dc30c5dd1$var$useStyleMarshal(contextId, nonce) {
    var styles = $1710e65dc30c5dd1$var$useMemo(function() {
        return $1710e65dc30c5dd1$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $acw62.useRef)(null);
    var dynamicRef = (0, $acw62.useRef)(null);
    var setDynamicStyle = $1710e65dc30c5dd1$var$useCallback((0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(proposed) {
        var el = dynamicRef.current;
        !el && $1710e65dc30c5dd1$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = $1710e65dc30c5dd1$var$useCallback(function(proposed) {
        var el = alwaysRef.current;
        !el && $1710e65dc30c5dd1$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $1710e65dc30c5dd1$var$invariant(false);
        var always = $1710e65dc30c5dd1$var$createStyleEl(nonce);
        var dynamic = $1710e65dc30c5dd1$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($1710e65dc30c5dd1$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($1710e65dc30c5dd1$var$prefix$1 + "-dynamic", contextId);
        $1710e65dc30c5dd1$var$getHead().appendChild(always);
        $1710e65dc30c5dd1$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $1710e65dc30c5dd1$var$invariant(false);
                $1710e65dc30c5dd1$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = $1710e65dc30c5dd1$var$useCallback(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = $1710e65dc30c5dd1$var$useCallback(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = $1710e65dc30c5dd1$var$useCallback(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $1710e65dc30c5dd1$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $1710e65dc30c5dd1$var$isHtmlElement(el) {
    return el instanceof $1710e65dc30c5dd1$var$getWindowFromEl(el).HTMLElement;
}
function $1710e65dc30c5dd1$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $1710e65dc30c5dd1$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    var possible = $1710e65dc30c5dd1$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $1710e65dc30c5dd1$var$find(possible, function(el) {
        return el.getAttribute($1710e65dc30c5dd1$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$1710e65dc30c5dd1$var$isHtmlElement(handle)) return null;
    return handle;
}
function $1710e65dc30c5dd1$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $acw62.useRef)({});
    var recordRef = (0, $acw62.useRef)(null);
    var restoreFocusFrameRef = (0, $acw62.useRef)(null);
    var isMountedRef = (0, $acw62.useRef)(false);
    var register = $1710e65dc30c5dd1$var$useCallback(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = $1710e65dc30c5dd1$var$useCallback(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $1710e65dc30c5dd1$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = $1710e65dc30c5dd1$var$useCallback(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = $1710e65dc30c5dd1$var$useCallback(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = $1710e65dc30c5dd1$var$useCallback(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($1710e65dc30c5dd1$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $1710e65dc30c5dd1$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $1710e65dc30c5dd1$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $1710e65dc30c5dd1$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $1710e65dc30c5dd1$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $1710e65dc30c5dd1$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $1710e65dc30c5dd1$var$useRegistry() {
    var registry = $1710e65dc30c5dd1$var$useMemo($1710e65dc30c5dd1$var$createRegistry, []);
    (0, $acw62.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $1710e65dc30c5dd1$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $1710e65dc30c5dd1$var$getBodyElement = function() {
    var body = document.body;
    !body && $1710e65dc30c5dd1$var$invariant(false);
    return body;
};
var $1710e65dc30c5dd1$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $1710e65dc30c5dd1$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $1710e65dc30c5dd1$var$useAnnouncer(contextId) {
    var id = $1710e65dc30c5dd1$var$useMemo(function() {
        return $1710e65dc30c5dd1$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function setup() {
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('aria-atomic', 'true');
        (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(el.style, $1710e65dc30c5dd1$var$visuallyHidden);
        $1710e65dc30c5dd1$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                var body = $1710e65dc30c5dd1$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = $1710e65dc30c5dd1$var$useCallback(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $1710e65dc30c5dd1$var$count = 0;
var $1710e65dc30c5dd1$var$defaults = {
    separator: '::'
};
function $1710e65dc30c5dd1$var$reset() {
    $1710e65dc30c5dd1$var$count = 0;
}
function $1710e65dc30c5dd1$var$useUniqueId(prefix, options) {
    if (options === void 0) options = $1710e65dc30c5dd1$var$defaults;
    return $1710e65dc30c5dd1$var$useMemo(function() {
        return "" + prefix + options.separator + $1710e65dc30c5dd1$var$count++;
    }, [
        options.separator,
        prefix
    ]);
}
function $1710e65dc30c5dd1$var$getElementId(_ref) {
    var contextId = _ref.contextId, uniqueId = _ref.uniqueId;
    return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function $1710e65dc30c5dd1$var$useHiddenTextElement(_ref2) {
    var contextId = _ref2.contextId, text = _ref2.text;
    var uniqueId = $1710e65dc30c5dd1$var$useUniqueId('hidden-text', {
        separator: '-'
    });
    var id = $1710e65dc30c5dd1$var$useMemo(function() {
        return $1710e65dc30c5dd1$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        });
    }, [
        uniqueId,
        contextId
    ]);
    (0, $acw62.useEffect)(function mount() {
        var el = document.createElement('div');
        el.id = id;
        el.textContent = text;
        el.style.display = 'none';
        $1710e65dc30c5dd1$var$getBodyElement().appendChild(el);
        return function unmount() {
            var body = $1710e65dc30c5dd1$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $1710e65dc30c5dd1$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $1710e65dc30c5dd1$var$peerDependencies = {
    react: "^16.8.5 || ^17.0.0 || ^18.0.0 || ^19.0.0",
    "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0 || ^19.0.0"
};
var $1710e65dc30c5dd1$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $1710e65dc30c5dd1$var$getVersion = function getVersion(value) {
    var result = $1710e65dc30c5dd1$var$semver.exec(value);
    !(result != null) && $1710e65dc30c5dd1$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $1710e65dc30c5dd1$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $1710e65dc30c5dd1$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $1710e65dc30c5dd1$var$getVersion(peerDepValue);
    var actual = $1710e65dc30c5dd1$var$getVersion(actualValue);
    if ($1710e65dc30c5dd1$var$isSatisfied(peerDep, actual)) return;
};
var $1710e65dc30c5dd1$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $1710e65dc30c5dd1$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $1710e65dc30c5dd1$var$useDev(useHook) {}
function $1710e65dc30c5dd1$var$useDevSetupWarning(fn, inputs) {
    $1710e65dc30c5dd1$var$useDev(function() {
        (0, $acw62.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $1710e65dc30c5dd1$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $1710e65dc30c5dd1$var$useStartupValidation() {
    $1710e65dc30c5dd1$var$useDevSetupWarning(function() {
        $1710e65dc30c5dd1$var$checkReactVersion($1710e65dc30c5dd1$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version);
        $1710e65dc30c5dd1$var$checkDoctype(document);
    }, []);
}
function $1710e65dc30c5dd1$var$usePrevious(current) {
    var ref = (0, $acw62.useRef)(current);
    (0, $acw62.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $1710e65dc30c5dd1$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $1710e65dc30c5dd1$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $1710e65dc30c5dd1$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $1710e65dc30c5dd1$var$tab = 9;
var $1710e65dc30c5dd1$var$enter = 13;
var $1710e65dc30c5dd1$var$escape = 27;
var $1710e65dc30c5dd1$var$space = 32;
var $1710e65dc30c5dd1$var$pageUp = 33;
var $1710e65dc30c5dd1$var$pageDown = 34;
var $1710e65dc30c5dd1$var$end = 35;
var $1710e65dc30c5dd1$var$home = 36;
var $1710e65dc30c5dd1$var$arrowLeft = 37;
var $1710e65dc30c5dd1$var$arrowUp = 38;
var $1710e65dc30c5dd1$var$arrowRight = 39;
var $1710e65dc30c5dd1$var$arrowDown = 40;
var $1710e65dc30c5dd1$var$_preventedKeys;
var $1710e65dc30c5dd1$var$preventedKeys = ($1710e65dc30c5dd1$var$_preventedKeys = {}, $1710e65dc30c5dd1$var$_preventedKeys[$1710e65dc30c5dd1$var$enter] = true, $1710e65dc30c5dd1$var$_preventedKeys[$1710e65dc30c5dd1$var$tab] = true, $1710e65dc30c5dd1$var$_preventedKeys);
var $1710e65dc30c5dd1$var$preventStandardKeyEvents = function(event) {
    if ($1710e65dc30c5dd1$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $1710e65dc30c5dd1$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $1710e65dc30c5dd1$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $1710e65dc30c5dd1$var$primaryButton = 0;
var $1710e65dc30c5dd1$var$sloppyClickThreshold = 5;
function $1710e65dc30c5dd1$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $1710e65dc30c5dd1$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $1710e65dc30c5dd1$var$sloppyClickThreshold;
}
var $1710e65dc30c5dd1$var$idle$1 = {
    type: 'IDLE'
};
function $1710e65dc30c5dd1$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: 'mousemove',
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $1710e65dc30c5dd1$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $1710e65dc30c5dd1$var$invariant(false);
                var pending = phase.point;
                if (!$1710e65dc30c5dd1$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: function fn(event) {
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $1710e65dc30c5dd1$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $1710e65dc30c5dd1$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $1710e65dc30c5dd1$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $1710e65dc30c5dd1$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $1710e65dc30c5dd1$export$2f59cd992b42195a(api) {
    var phaseRef = (0, $acw62.useRef)($1710e65dc30c5dd1$var$idle$1);
    var unbindEventsRef = (0, $acw62.useRef)($1710e65dc30c5dd1$var$noop);
    var startCaptureBinding = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $1710e65dc30c5dd1$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            eventName: 'webkitmouseforcewillbegin',
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = $1710e65dc30c5dd1$var$useCallback(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $1710e65dc30c5dd1$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = $1710e65dc30c5dd1$var$useCallback(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $1710e65dc30c5dd1$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = $1710e65dc30c5dd1$var$useCallback(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = $1710e65dc30c5dd1$var$useCallback(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $1710e65dc30c5dd1$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $1710e65dc30c5dd1$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = $1710e65dc30c5dd1$var$useCallback(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $1710e65dc30c5dd1$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $1710e65dc30c5dd1$var$_scrollJumpKeys;
function $1710e65dc30c5dd1$var$noop$1() {}
var $1710e65dc30c5dd1$var$scrollJumpKeys = ($1710e65dc30c5dd1$var$_scrollJumpKeys = {}, $1710e65dc30c5dd1$var$_scrollJumpKeys[$1710e65dc30c5dd1$var$pageDown] = true, $1710e65dc30c5dd1$var$_scrollJumpKeys[$1710e65dc30c5dd1$var$pageUp] = true, $1710e65dc30c5dd1$var$_scrollJumpKeys[$1710e65dc30c5dd1$var$home] = true, $1710e65dc30c5dd1$var$_scrollJumpKeys[$1710e65dc30c5dd1$var$end] = true, $1710e65dc30c5dd1$var$_scrollJumpKeys);
function $1710e65dc30c5dd1$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (event.keyCode === $1710e65dc30c5dd1$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $1710e65dc30c5dd1$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $1710e65dc30c5dd1$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $1710e65dc30c5dd1$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $1710e65dc30c5dd1$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $1710e65dc30c5dd1$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($1710e65dc30c5dd1$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $1710e65dc30c5dd1$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $1710e65dc30c5dd1$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $1710e65dc30c5dd1$export$42b74264faad0714(api) {
    var unbindEventsRef = (0, $acw62.useRef)($1710e65dc30c5dd1$var$noop$1);
    var startCaptureBinding = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $1710e65dc30c5dd1$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $1710e65dc30c5dd1$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $1710e65dc30c5dd1$var$bindEvents(window, $1710e65dc30c5dd1$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = $1710e65dc30c5dd1$var$useCallback(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $1710e65dc30c5dd1$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $1710e65dc30c5dd1$var$idle$2 = {
    type: 'IDLE'
};
var $1710e65dc30c5dd1$var$timeForLongPress = 120;
var $1710e65dc30c5dd1$var$forcePressThreshold = 0.15;
function $1710e65dc30c5dd1$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $1710e65dc30c5dd1$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $1710e65dc30c5dd1$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $1710e65dc30c5dd1$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $1710e65dc30c5dd1$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $1710e65dc30c5dd1$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $1710e65dc30c5dd1$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $1710e65dc30c5dd1$export$ac235fd3a7bcf7b4(api) {
    var phaseRef = (0, $acw62.useRef)($1710e65dc30c5dd1$var$idle$2);
    var unbindEventsRef = (0, $acw62.useRef)($1710e65dc30c5dd1$var$noop);
    var getPhase = $1710e65dc30c5dd1$var$useCallback(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = $1710e65dc30c5dd1$var$useCallback(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = $1710e65dc30c5dd1$var$useCallback(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $1710e65dc30c5dd1$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = $1710e65dc30c5dd1$var$useCallback(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($1710e65dc30c5dd1$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = $1710e65dc30c5dd1$var$useCallback(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = $1710e65dc30c5dd1$var$useCallback(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $1710e65dc30c5dd1$var$bindEvents(window, $1710e65dc30c5dd1$var$getHandleBindings(args), options);
        var unbindWindow = $1710e65dc30c5dd1$var$bindEvents(window, $1710e65dc30c5dd1$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = $1710e65dc30c5dd1$var$useCallback(function startDragging() {
        var phase = getPhase();
        !(phase.type === 'PENDING') && $1710e65dc30c5dd1$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = $1710e65dc30c5dd1$var$useCallback(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $1710e65dc30c5dd1$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $1710e65dc30c5dd1$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($1710e65dc30c5dd1$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $1710e65dc30c5dd1$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $1710e65dc30c5dd1$var$useValidateSensorHooks(sensorHooks) {
    $1710e65dc30c5dd1$var$useDev(function() {
        var previousRef = $1710e65dc30c5dd1$var$usePrevious(sensorHooks);
        $1710e65dc30c5dd1$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $1710e65dc30c5dd1$var$invariant(false);
        });
    });
}
var $1710e65dc30c5dd1$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $1710e65dc30c5dd1$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($1710e65dc30c5dd1$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $1710e65dc30c5dd1$var$isAnInteractiveElement(parent, current.parentElement);
}
function $1710e65dc30c5dd1$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$1710e65dc30c5dd1$var$isHtmlElement(target)) return false;
    return $1710e65dc30c5dd1$var$isAnInteractiveElement(draggable, target);
}
var $1710e65dc30c5dd1$var$getBorderBoxCenterPosition = function(el) {
    return (0, $0f2a76a440eafaaa$export$4b834cebd9e5cebe)(el.getBoundingClientRect()).center;
};
function $1710e65dc30c5dd1$var$isElement(el) {
    return el instanceof $1710e65dc30c5dd1$var$getWindowFromEl(el).Element;
}
var $1710e65dc30c5dd1$var$supportedMatchesName = function() {
    var base = 'matches';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    var value = $1710e65dc30c5dd1$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $1710e65dc30c5dd1$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$1710e65dc30c5dd1$var$supportedMatchesName](selector)) return el;
    return $1710e65dc30c5dd1$var$closestPonyfill(el.parentElement, selector);
}
function $1710e65dc30c5dd1$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $1710e65dc30c5dd1$var$closestPonyfill(el, selector);
}
function $1710e65dc30c5dd1$var$getSelector(contextId) {
    return "[" + $1710e65dc30c5dd1$var$dragHandle.contextId + "=\"" + contextId + "\"]";
}
function $1710e65dc30c5dd1$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$1710e65dc30c5dd1$var$isElement(target)) return null;
    var selector = $1710e65dc30c5dd1$var$getSelector(contextId);
    var handle = $1710e65dc30c5dd1$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$1710e65dc30c5dd1$var$isHtmlElement(handle)) return null;
    return handle;
}
function $1710e65dc30c5dd1$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $1710e65dc30c5dd1$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($1710e65dc30c5dd1$var$dragHandle.draggableId);
}
function $1710e65dc30c5dd1$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $1710e65dc30c5dd1$var$draggable.contextId + "=\"" + contextId + "\"]";
    var possible = $1710e65dc30c5dd1$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $1710e65dc30c5dd1$var$find(possible, function(el) {
        return el.getAttribute($1710e65dc30c5dd1$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$1710e65dc30c5dd1$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $1710e65dc30c5dd1$var$preventDefault(event) {
    event.preventDefault();
}
function $1710e65dc30c5dd1$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $1710e65dc30c5dd1$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$1710e65dc30c5dd1$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $1710e65dc30c5dd1$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $1710e65dc30c5dd1$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $1710e65dc30c5dd1$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $1710e65dc30c5dd1$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $1710e65dc30c5dd1$var$noop);
    var phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($1710e65dc30c5dd1$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            !(phase === 'PRE_DRAG') && $1710e65dc30c5dd1$var$invariant(false);
        }
        store.dispatch($1710e65dc30c5dd1$var$lift(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $1710e65dc30c5dd1$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $1710e65dc30c5dd1$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($1710e65dc30c5dd1$var$drop({
                reason: reason
            }));
        }
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            isActive: function isActive() {
                return $1710e65dc30c5dd1$var$_isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish('DROP', options);
            },
            cancel: function cancel(options) {
                return finish('CANCEL', options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $8f52a5054f09a665$export$2e2bcd8739ae039)(function(client) {
            tryDispatchWhenDragging(function() {
                return $1710e65dc30c5dd1$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($1710e65dc30c5dd1$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($1710e65dc30c5dd1$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($1710e65dc30c5dd1$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($1710e65dc30c5dd1$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $1710e65dc30c5dd1$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $1710e65dc30c5dd1$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $1710e65dc30c5dd1$var$_isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $1710e65dc30c5dd1$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $1710e65dc30c5dd1$var$defaultSensors = [
    $1710e65dc30c5dd1$export$2f59cd992b42195a,
    $1710e65dc30c5dd1$export$42b74264faad0714,
    $1710e65dc30c5dd1$export$ac235fd3a7bcf7b4
];
function $1710e65dc30c5dd1$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $1710e65dc30c5dd1$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $acw62.useState)(function() {
        return $1710e65dc30c5dd1$var$create();
    })[0];
    var tryAbandonLock = $1710e65dc30c5dd1$var$useCallback(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = $1710e65dc30c5dd1$var$useCallback(function(draggableId) {
        return $1710e65dc30c5dd1$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = $1710e65dc30c5dd1$var$useCallback(function(draggableId, forceStop, options) {
        return $1710e65dc30c5dd1$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = $1710e65dc30c5dd1$var$useCallback(function(event) {
        return $1710e65dc30c5dd1$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = $1710e65dc30c5dd1$var$useCallback(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = $1710e65dc30c5dd1$var$useCallback(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== 'IDLE') store.dispatch($1710e65dc30c5dd1$var$flush());
    }, [
        lockAPI,
        store
    ]);
    var isLockClaimed = $1710e65dc30c5dd1$var$useCallback(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $1710e65dc30c5dd1$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $1710e65dc30c5dd1$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $1710e65dc30c5dd1$var$getStore(lazyRef) {
    !lazyRef.current && $1710e65dc30c5dd1$var$invariant(false);
    return lazyRef.current;
}
function $1710e65dc30c5dd1$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, dragHandleUsageInstructions = props.dragHandleUsageInstructions;
    var lazyStoreRef = (0, $acw62.useRef)(null);
    $1710e65dc30c5dd1$var$useStartupValidation();
    var lastPropsRef = $1710e65dc30c5dd1$var$usePrevious(props);
    var getResponders = $1710e65dc30c5dd1$var$useCallback(function() {
        return $1710e65dc30c5dd1$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $1710e65dc30c5dd1$var$useAnnouncer(contextId);
    var dragHandleUsageInstructionsId = $1710e65dc30c5dd1$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    var styleMarshal = $1710e65dc30c5dd1$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = $1710e65dc30c5dd1$var$useCallback(function(action) {
        $1710e65dc30c5dd1$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = $1710e65dc30c5dd1$var$useMemo(function() {
        return (0, $d2bed10dff9b4968$export$aea084d96e84da92)({
            publishWhileDragging: $1710e65dc30c5dd1$var$publishWhileDragging,
            updateDroppableScroll: $1710e65dc30c5dd1$var$updateDroppableScroll,
            updateDroppableIsEnabled: $1710e65dc30c5dd1$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $1710e65dc30c5dd1$var$updateDroppableIsCombineEnabled,
            collectionStarting: $1710e65dc30c5dd1$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $1710e65dc30c5dd1$var$useRegistry();
    var dimensionMarshal = $1710e65dc30c5dd1$var$useMemo(function() {
        return $1710e65dc30c5dd1$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = $1710e65dc30c5dd1$var$useMemo(function() {
        return $1710e65dc30c5dd1$var$createAutoScroller((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            scrollWindow: $1710e65dc30c5dd1$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $d2bed10dff9b4968$export$aea084d96e84da92)({
            move: $1710e65dc30c5dd1$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $1710e65dc30c5dd1$var$useFocusMarshal(contextId);
    var store = $1710e65dc30c5dd1$var$useMemo(function() {
        return $1710e65dc30c5dd1$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = $1710e65dc30c5dd1$var$useCallback(function() {
        var current = $1710e65dc30c5dd1$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($1710e65dc30c5dd1$var$flush());
    }, []);
    var isDragging = $1710e65dc30c5dd1$var$useCallback(function() {
        var state = $1710e65dc30c5dd1$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === 'DROP_ANIMATING';
    }, []);
    var appCallbacks = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = $1710e65dc30c5dd1$var$useCallback(function(id) {
        return $1710e65dc30c5dd1$var$canStartDrag($1710e65dc30c5dd1$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = $1710e65dc30c5dd1$var$useCallback(function() {
        return $1710e65dc30c5dd1$var$isMovementAllowed($1710e65dc30c5dd1$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $1710e65dc30c5dd1$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $acw62.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1710e65dc30c5dd1$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
        context: $1710e65dc30c5dd1$var$StoreContext,
        store: store
    }, props.children));
}
var $1710e65dc30c5dd1$var$count$1 = 0;
function $1710e65dc30c5dd1$var$reset$1() {
    $1710e65dc30c5dd1$var$count$1 = 0;
}
function $1710e65dc30c5dd1$var$useInstanceCount() {
    return $1710e65dc30c5dd1$var$useMemo(function() {
        return "" + $1710e65dc30c5dd1$var$count$1++;
    }, []);
}
function $1710e65dc30c5dd1$export$2bfe52350fc0150d() {
    $1710e65dc30c5dd1$var$reset$1();
    $1710e65dc30c5dd1$var$reset();
}
function $1710e65dc30c5dd1$export$237bd83162c14364(props) {
    var contextId = $1710e65dc30c5dd1$var$useInstanceCount();
    var dragHandleUsageInstructions = props.dragHandleUsageInstructions || $1710e65dc30c5dd1$var$preset.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1710e65dc30c5dd1$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1710e65dc30c5dd1$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $1710e65dc30c5dd1$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $1710e65dc30c5dd1$var$isScroll = $1710e65dc30c5dd1$var$isEqual$1('scroll');
var $1710e65dc30c5dd1$var$isAuto = $1710e65dc30c5dd1$var$isEqual$1('auto');
var $1710e65dc30c5dd1$var$isVisible$1 = $1710e65dc30c5dd1$var$isEqual$1('visible');
var $1710e65dc30c5dd1$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $1710e65dc30c5dd1$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $1710e65dc30c5dd1$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $1710e65dc30c5dd1$var$isEither(overflow, $1710e65dc30c5dd1$var$isScroll) || $1710e65dc30c5dd1$var$isEither(overflow, $1710e65dc30c5dd1$var$isAuto);
};
var $1710e65dc30c5dd1$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $1710e65dc30c5dd1$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $1710e65dc30c5dd1$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$1710e65dc30c5dd1$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $1710e65dc30c5dd1$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $1710e65dc30c5dd1$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $1710e65dc30c5dd1$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $1710e65dc30c5dd1$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $1710e65dc30c5dd1$var$getEnv = function(start) {
    var closestScrollable = $1710e65dc30c5dd1$var$getClosestScrollable(start);
    var isFixedOnPage = $1710e65dc30c5dd1$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $1710e65dc30c5dd1$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $1710e65dc30c5dd1$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $1710e65dc30c5dd1$var$origin,
                    displacement: $1710e65dc30c5dd1$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $1710e65dc30c5dd1$var$vertical : $1710e65dc30c5dd1$var$horizontal;
    var subject = $1710e65dc30c5dd1$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $1710e65dc30c5dd1$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $0f2a76a440eafaaa$export$34928e660d2a8702)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $0f2a76a440eafaaa$export$9f77e0932fb78f72)(paddingBox, base.border);
    var client = (0, $0f2a76a440eafaaa$export$6459fc9e86be362e)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $1710e65dc30c5dd1$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $1710e65dc30c5dd1$var$getClient(ref, closestScrollable);
    var page = (0, $0f2a76a440eafaaa$export$1d0caec378d7d0ae)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $0f2a76a440eafaaa$export$34928e660d2a8702)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $0f2a76a440eafaaa$export$1d0caec378d7d0ae)(frameClient, windowScroll),
            scroll: $1710e65dc30c5dd1$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $1710e65dc30c5dd1$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $1710e65dc30c5dd1$var$immediate = {
    passive: false
};
var $1710e65dc30c5dd1$var$delayed = {
    passive: true
};
var $1710e65dc30c5dd1$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $1710e65dc30c5dd1$var$immediate : $1710e65dc30c5dd1$var$delayed;
};
function $1710e65dc30c5dd1$var$useRequiredContext(Context) {
    var result = (0, $acw62.useContext)(Context);
    !result && $1710e65dc30c5dd1$var$invariant(false);
    return result;
}
var $1710e65dc30c5dd1$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $1710e65dc30c5dd1$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $acw62.useRef)(null);
    var appContext = $1710e65dc30c5dd1$var$useRequiredContext($1710e65dc30c5dd1$var$AppContext);
    var uniqueId = $1710e65dc30c5dd1$var$useUniqueId('droppable');
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $1710e65dc30c5dd1$var$usePrevious(args);
    var descriptor = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $acw62.useRef)(descriptor);
    var memoizedUpdateScroll = $1710e65dc30c5dd1$var$useMemo(function() {
        return (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(x, y) {
            !whileDraggingRef.current && $1710e65dc30c5dd1$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = $1710e65dc30c5dd1$var$useCallback(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $1710e65dc30c5dd1$var$origin;
        return $1710e65dc30c5dd1$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = $1710e65dc30c5dd1$var$useCallback(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = $1710e65dc30c5dd1$var$useMemo(function() {
        return (0, $8f52a5054f09a665$export$2e2bcd8739ae039)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = $1710e65dc30c5dd1$var$useCallback(function() {
        var dragging = whileDraggingRef.current;
        var closest = $1710e65dc30c5dd1$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $1710e65dc30c5dd1$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = $1710e65dc30c5dd1$var$useCallback(function(windowScroll, options) {
        !!whileDraggingRef.current && $1710e65dc30c5dd1$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $1710e65dc30c5dd1$var$invariant(false);
        var env = $1710e65dc30c5dd1$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $1710e65dc30c5dd1$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($1710e65dc30c5dd1$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $1710e65dc30c5dd1$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = $1710e65dc30c5dd1$var$useCallback(function() {
        var dragging = whileDraggingRef.current;
        var closest = $1710e65dc30c5dd1$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $1710e65dc30c5dd1$var$invariant(false);
        return $1710e65dc30c5dd1$var$getScroll$1(closest);
    }, []);
    var dragStopped = $1710e65dc30c5dd1$var$useCallback(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $1710e65dc30c5dd1$var$invariant(false);
        var closest = $1710e65dc30c5dd1$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($1710e65dc30c5dd1$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $1710e65dc30c5dd1$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = $1710e65dc30c5dd1$var$useCallback(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $1710e65dc30c5dd1$var$invariant(false);
        var closest = $1710e65dc30c5dd1$var$getClosestScrollableFromDrag(dragging);
        !closest && $1710e65dc30c5dd1$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $1710e65dc30c5dd1$var$noop$2() {}
var $1710e65dc30c5dd1$var$empty = {
    width: 0,
    height: 0,
    margin: $1710e65dc30c5dd1$var$noSpacing
};
var $1710e65dc30c5dd1$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $1710e65dc30c5dd1$var$empty;
    if (animate === 'close') return $1710e65dc30c5dd1$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $1710e65dc30c5dd1$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $1710e65dc30c5dd1$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $1710e65dc30c5dd1$var$transitions.placeholder : null
    };
};
function $1710e65dc30c5dd1$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $acw62.useRef)(null);
    var tryClearAnimateOpenTimer = $1710e65dc30c5dd1$var$useCallback(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $acw62.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $acw62.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $1710e65dc30c5dd1$var$noop$2;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $1710e65dc30c5dd1$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $1710e65dc30c5dd1$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = $1710e65dc30c5dd1$var$useCallback(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $1710e65dc30c5dd1$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rbd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $1710e65dc30c5dd1$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($1710e65dc30c5dd1$var$Placeholder);
var $1710e65dc30c5dd1$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $1710e65dc30c5dd1$var$checkIsValidInnerRef(el) {
    !(el && $1710e65dc30c5dd1$var$isHtmlElement(el)) && $1710e65dc30c5dd1$var$invariant(false);
}
function $1710e65dc30c5dd1$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $1710e65dc30c5dd1$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $1710e65dc30c5dd1$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $1710e65dc30c5dd1$var$invariant(false);
        !(typeof props.droppableId === 'string') && $1710e65dc30c5dd1$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$1710e65dc30c5dd1$var$isBoolean(props.isDropDisabled) && $1710e65dc30c5dd1$var$invariant(false);
        !$1710e65dc30c5dd1$var$isBoolean(props.isCombineEnabled) && $1710e65dc30c5dd1$var$invariant(false);
        !$1710e65dc30c5dd1$var$isBoolean(props.ignoreContainerClipping) && $1710e65dc30c5dd1$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $1710e65dc30c5dd1$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $1710e65dc30c5dd1$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $1710e65dc30c5dd1$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $1710e65dc30c5dd1$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $1710e65dc30c5dd1$var$invariant(false);
    }
];
function $1710e65dc30c5dd1$var$useValidation(args) {
    $1710e65dc30c5dd1$var$useDevSetupWarning(function() {
        $1710e65dc30c5dd1$var$runChecks(args, $1710e65dc30c5dd1$var$shared);
        if (args.props.mode === 'standard') $1710e65dc30c5dd1$var$runChecks(args, $1710e65dc30c5dd1$var$standard);
        if (args.props.mode === 'virtual') $1710e65dc30c5dd1$var$runChecks(args, $1710e65dc30c5dd1$var$virtual);
    });
}
var $1710e65dc30c5dd1$var$AnimateInOut = function(_React$PureComponent) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent);
var $1710e65dc30c5dd1$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $1710e65dc30c5dd1$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $1710e65dc30c5dd1$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $1710e65dc30c5dd1$var$transitions.snap;
    return $1710e65dc30c5dd1$var$transitions.fluid;
};
var $1710e65dc30c5dd1$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $1710e65dc30c5dd1$var$combine.opacity.drop : $1710e65dc30c5dd1$var$combine.opacity.combining;
};
var $1710e65dc30c5dd1$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $1710e65dc30c5dd1$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $1710e65dc30c5dd1$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $1710e65dc30c5dd1$var$transforms.drop(offset, isCombining) : $1710e65dc30c5dd1$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $1710e65dc30c5dd1$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $1710e65dc30c5dd1$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $1710e65dc30c5dd1$var$zIndexOptions.dropAnimating : $1710e65dc30c5dd1$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $1710e65dc30c5dd1$var$getSecondaryStyle(secondary) {
    return {
        transform: $1710e65dc30c5dd1$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $1710e65dc30c5dd1$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $1710e65dc30c5dd1$var$getDraggingStyle(mapped) : $1710e65dc30c5dd1$var$getSecondaryStyle(mapped);
}
function $1710e65dc30c5dd1$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $1710e65dc30c5dd1$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $0f2a76a440eafaaa$export$b8dfc5d4e552b8e1)(borderBox, computedStyles);
    var page = (0, $0f2a76a440eafaaa$export$1d0caec378d7d0ae)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $1710e65dc30c5dd1$var$useDraggablePublisher(args) {
    var uniqueId = $1710e65dc30c5dd1$var$useUniqueId('draggable');
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = $1710e65dc30c5dd1$var$useCallback(function(windowScroll) {
        var el = getDraggableRef();
        !el && $1710e65dc30c5dd1$var$invariant(false);
        return $1710e65dc30c5dd1$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $acw62.useRef)(entry);
    var isFirstPublishRef = (0, $acw62.useRef)(true);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $1710e65dc30c5dd1$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $1710e65dc30c5dd1$var$useValidation$1(props, contextId, getRef) {
    $1710e65dc30c5dd1$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $1710e65dc30c5dd1$var$invariant(false);
        !(typeof id === 'string') && $1710e65dc30c5dd1$var$invariant(false);
        !$1710e65dc30c5dd1$var$isInteger(props.index) && $1710e65dc30c5dd1$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $1710e65dc30c5dd1$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$1710e65dc30c5dd1$var$findDragHandle(contextId, id) && $1710e65dc30c5dd1$var$invariant(false);
    });
}
function $1710e65dc30c5dd1$var$useClonePropValidation(isClone) {
    $1710e65dc30c5dd1$var$useDev(function() {
        var initialRef = (0, $acw62.useRef)(isClone);
        $1710e65dc30c5dd1$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $1710e65dc30c5dd1$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $1710e65dc30c5dd1$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $1710e65dc30c5dd1$var$Draggable(props) {
    var ref = (0, $acw62.useRef)(null);
    var setRef = $1710e65dc30c5dd1$var$useCallback(function(el) {
        ref.current = el;
    }, []);
    var getRef = $1710e65dc30c5dd1$var$useCallback(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $1710e65dc30c5dd1$var$useRequiredContext($1710e65dc30c5dd1$var$AppContext), contextId = _useRequiredContext.contextId, dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $1710e65dc30c5dd1$var$useRequiredContext($1710e65dc30c5dd1$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $1710e65dc30c5dd1$var$useValidation$1(props, contextId, getRef);
    $1710e65dc30c5dd1$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = $1710e65dc30c5dd1$var$useMemo(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $1710e65dc30c5dd1$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = $1710e65dc30c5dd1$var$useMemo(function() {
        return isEnabled ? {
            tabIndex: 0,
            role: 'button',
            'aria-describedby': dragHandleUsageInstructionsId,
            'data-rbd-drag-handle-draggable-id': draggableId,
            'data-rbd-drag-handle-context-id': contextId,
            draggable: false,
            onDragStart: $1710e65dc30c5dd1$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    var onMoveEnd = $1710e65dc30c5dd1$var$useCallback(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = $1710e65dc30c5dd1$var$useMemo(function() {
        var style = $1710e65dc30c5dd1$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-rbd-draggable-context-id': contextId,
                'data-rbd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $1710e65dc30c5dd1$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $1710e65dc30c5dd1$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $1710e65dc30c5dd1$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $1710e65dc30c5dd1$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $1710e65dc30c5dd1$var$getDraggableSelector() {
    var memoizedOffset = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $1710e65dc30c5dd1$var$whatIsDraggedOver(state.impact);
            var combineWith = $1710e65dc30c5dd1$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $1710e65dc30c5dd1$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $1710e65dc30c5dd1$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $1710e65dc30c5dd1$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $1710e65dc30c5dd1$var$combine.opacity.drop : null,
                scale: _combineWith ? $1710e65dc30c5dd1$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $1710e65dc30c5dd1$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $1710e65dc30c5dd1$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $1710e65dc30c5dd1$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $1710e65dc30c5dd1$var$getSecondarySnapshot(null)
    }
};
function $1710e65dc30c5dd1$var$getSecondarySelector() {
    var memoizedOffset = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)($1710e65dc30c5dd1$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($1710e65dc30c5dd1$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $1710e65dc30c5dd1$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $1710e65dc30c5dd1$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $1710e65dc30c5dd1$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $1710e65dc30c5dd1$var$getDraggableSelector();
    var secondarySelector = $1710e65dc30c5dd1$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $1710e65dc30c5dd1$var$atRest;
    };
    return selector;
};
var $1710e65dc30c5dd1$var$mapDispatchToProps = {
    dropAnimationFinished: $1710e65dc30c5dd1$var$dropAnimationFinished
};
var $1710e65dc30c5dd1$var$ConnectedDraggable = (0, $55388fc2f116d4d7$export$64605811ab45167f)($1710e65dc30c5dd1$var$makeMapStateToProps, $1710e65dc30c5dd1$var$mapDispatchToProps, null, {
    context: $1710e65dc30c5dd1$var$StoreContext,
    areStatePropsEqual: $1710e65dc30c5dd1$var$isStrictEqual
})($1710e65dc30c5dd1$var$Draggable);
function $1710e65dc30c5dd1$var$PrivateDraggable(props) {
    var droppableContext = $1710e65dc30c5dd1$var$useRequiredContext($1710e65dc30c5dd1$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1710e65dc30c5dd1$var$ConnectedDraggable, props);
}
function $1710e65dc30c5dd1$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1710e65dc30c5dd1$var$PrivateDraggable, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $1710e65dc30c5dd1$var$getBody() {
    !document.body && $1710e65dc30c5dd1$var$invariant(false);
    return document.body;
}
var $1710e65dc30c5dd1$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $1710e65dc30c5dd1$var$getBody
};
function $1710e65dc30c5dd1$var$Droppable(propsWithoutDefaults) {
    var props = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $1710e65dc30c5dd1$var$defaultProps, {}, propsWithoutDefaults);
    var appContext = (0, $acw62.useContext)($1710e65dc30c5dd1$var$AppContext);
    !appContext && $1710e65dc30c5dd1$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $acw62.useRef)(null);
    var placeholderRef = (0, $acw62.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = $1710e65dc30c5dd1$var$useCallback(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = $1710e65dc30c5dd1$var$useCallback(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = $1710e65dc30c5dd1$var$useCallback(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = $1710e65dc30c5dd1$var$useCallback(function(value) {
        placeholderRef.current = value;
    }, []);
    $1710e65dc30c5dd1$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = $1710e65dc30c5dd1$var$useCallback(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $1710e65dc30c5dd1$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $1710e65dc30c5dd1$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1710e65dc30c5dd1$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1710e65dc30c5dd1$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rbd-droppable-id': droppableId,
                'data-rbd-droppable-context-id': contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = $1710e65dc30c5dd1$var$useMemo(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1710e65dc30c5dd1$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1710e65dc30c5dd1$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $1710e65dc30c5dd1$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $1710e65dc30c5dd1$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $1710e65dc30c5dd1$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$1710e65dc30c5dd1$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $1710e65dc30c5dd1$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $1710e65dc30c5dd1$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$1710e65dc30c5dd1$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $1710e65dc30c5dd1$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $1710e65dc30c5dd1$var$whatIsDraggedOverFromResult(completed.result) === id, $1710e65dc30c5dd1$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$1710e65dc30c5dd1$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $1710e65dc30c5dd1$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $1710e65dc30c5dd1$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $1710e65dc30c5dd1$var$updateViewportMaxScroll
};
function $1710e65dc30c5dd1$var$getBody$1() {
    !document.body && $1710e65dc30c5dd1$var$invariant(false);
    return document.body;
}
var $1710e65dc30c5dd1$var$defaultProps$1 = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $1710e65dc30c5dd1$var$getBody$1
};
var $1710e65dc30c5dd1$export$423ec2075359570a = (0, $55388fc2f116d4d7$export$64605811ab45167f)($1710e65dc30c5dd1$var$makeMapStateToProps$1, $1710e65dc30c5dd1$var$mapDispatchToProps$1, null, {
    context: $1710e65dc30c5dd1$var$StoreContext,
    areStatePropsEqual: $1710e65dc30c5dd1$var$isStrictEqual
})($1710e65dc30c5dd1$var$Droppable);
$1710e65dc30c5dd1$export$423ec2075359570a.defaultProps = $1710e65dc30c5dd1$var$defaultProps$1;


/**
 * We're doing all this because the placeholder is not correctly displayed in react-beautiful-dnd
 * with React 19.
 * So we make sure it properly occupies the space of the dragged item, so the
 * container won't flicker when we're dragging an item (as the drag item receives
 * position: fixed while dragging, so content does not have the initial height anymore, therefore,
 * the placeholder is included, with the computed height of the dragging element)
 */ const $e52d5c02f19d68ad$export$423ec2075359570a = (props)=>{
    const children = props.children;
    const { placeholderStyle: placeholderStyle } = $acw62.useContext($e52d5c02f19d68ad$var$AdaptableDDContext);
    return $acw62.createElement((0, $1710e65dc30c5dd1$export$423ec2075359570a), {
        ...props
    }, (provided, snapshot)=>{
        provided.placeholder = $acw62.createElement("div", {
            key: "placeholder",
            style: placeholderStyle || {
                visibility: 'hidden',
                pointerEvents: 'none',
                height: 0
            }
        });
        return children(provided, snapshot);
    });
};
const $e52d5c02f19d68ad$var$queryAttr = 'data-rbd-draggable-id';
const $e52d5c02f19d68ad$var$AdaptableDDContext = $acw62.createContext({
    placeholderStyle: null
});
const $e52d5c02f19d68ad$export$237bd83162c14364 = (props)=>{
    const getDraggedDom = (draggableId)=>{
        const domQuery = `[${$e52d5c02f19d68ad$var$queryAttr}='${draggableId}']`;
        const draggedDOM = document.querySelector(domQuery);
        return draggedDOM;
    };
    const [placeholderStyle, setPlaceholderStyle] = (0, $acw62.useState)(null);
    const handleDragStart = (initial, provided)=>{
        props.onDragStart?.(initial, provided);
        const draggedDOM = getDraggedDom(initial.draggableId);
        if (!draggedDOM) return;
        const { clientHeight: clientHeight, clientWidth: clientWidth } = draggedDOM;
        const computedStyle = window.getComputedStyle(draggedDOM);
        setPlaceholderStyle({
            height: clientHeight + parseFloat(computedStyle.marginTop) + parseFloat(computedStyle.marginBottom),
            width: clientWidth
        });
    };
    const handleDragEnd = (result, provided)=>{
        props.onDragEnd?.(result, provided);
        setPlaceholderStyle(null);
    };
    return $acw62.createElement($e52d5c02f19d68ad$var$AdaptableDDContext.Provider, {
        value: {
            placeholderStyle: placeholderStyle
        }
    }, $acw62.createElement((0, $1710e65dc30c5dd1$export$237bd83162c14364), {
        ...props,
        onDragStart: handleDragStart,
        onDragEnd: handleDragEnd
    }));
};






const $5a5def29d0cbcbac$export$949ab7c957e48dcc = (args)=>{
    let [first, second] = args;
    if (typeof first === 'string') first = new Date(first);
    if (typeof second === 'string') second = new Date(second);
    return [
        first,
        second
    ];
};
const $5a5def29d0cbcbac$export$dcc1c37491c61375 = (args)=>{
    if (typeof args === 'string') args = new Date(args);
    if (typeof args === 'number') args = new Date(args);
    return args;
};
const $5a5def29d0cbcbac$export$3ae94a2503e890a1 = (date, format)=>{
    date = $5a5def29d0cbcbac$export$dcc1c37491c61375(date);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    return format.replace('DD', day.toString().padStart(2, '0')).replace('MM', month.toString().padStart(2, '0')).replace('YYYY', year.toString()).replace('HH', hour.toString().padStart(2, '0')).replace('mm', minute.toString().padStart(2, '0')).replace('ss', second.toString().padStart(2, '0'));
};


const $759293e9f6921c8e$export$147a1738bbbef892 = {
    TRUE: {
        handler: ()=>{
            return true;
        },
        description: 'Returns the boolean value TRUE',
        category: 'logical',
        returnType: 'boolean',
        signatures: [
            'TRUE'
        ],
        examples: [
            '[column] = TRUE'
        ]
    },
    FALSE: {
        handler: ()=>{
            return false;
        },
        description: 'Returns the boolean value FALSE',
        category: 'logical',
        returnType: 'boolean',
        signatures: [
            'FALSE'
        ],
        examples: [
            '[column] = FALSE'
        ]
    },
    AND: {
        handler (args) {
            return Boolean(args[0] && args[1]);
        },
        isHiddenFromMenu: true,
        category: 'logical',
        description: 'Returns true if both statements are true',
        signatures: [
            'statement AND statement'
        ],
        examples: [
            '[col1] > 5 AND [col2] > 10'
        ],
        returnType: 'boolean',
        inputs: [
            'boolean',
            'boolean'
        ]
    },
    OR: {
        handler (args) {
            return Boolean(args[0] || args[1]);
        },
        isHiddenFromMenu: true,
        category: 'logical',
        description: 'Returns true if either statement is true',
        signatures: [
            'statement OR statement'
        ],
        examples: [
            '[col1] > 5 OR [col2] > 10'
        ],
        returnType: 'boolean',
        inputs: [
            'boolean',
            'boolean'
        ]
    },
    NOT: {
        handler (args) {
            return Boolean(!args[0]);
        },
        isHiddenFromMenu: true,
        category: 'logical',
        description: 'Returns the negation of a statement',
        signatures: [
            '!statement'
        ],
        examples: [
            '!([col1] > 5 AND [col2] > 10)'
        ],
        returnType: 'boolean',
        inputs: [
            'boolean'
        ]
    },
    EQ: {
        handler (args, context) {
            if (args[0] instanceof Date && args[1] instanceof Date) return (0, $7a7e68b5aa0b9077$export$248d38f6296296c5)(args[0], args[1]);
            if (typeof args[0] === 'string' || typeof args[1] === 'string') {
                const [first, second] = (0, $fb3b7f5e99ab7e90$export$dc2d37c8312d2c6)(context, String(args[0]), String(args[1]));
                return first == second;
            }
            return args[0] == args[1];
        },
        isHiddenFromMenu: true,
        category: 'comparison',
        description: 'Returns true if the 2 (input) values are equal',
        signatures: [
            'value = value',
            'EQ(a: value, b: value)'
        ],
        examples: [
            '[col1] = 5',
            'EQ([col1], 5)'
        ],
        returnType: 'boolean',
        inputs: [
            [
                'number',
                'number'
            ],
            [
                'date',
                'date'
            ],
            [
                'text',
                'text'
            ],
            [
                'boolean',
                'boolean'
            ]
        ]
    },
    NEQ: {
        handler (args, context) {
            if (args[0] instanceof Date && args[1] instanceof Date) return !(0, $7a7e68b5aa0b9077$export$248d38f6296296c5)(args[0], args[1]);
            if (typeof args[0] === 'string' || typeof args[1] === 'string') {
                const [first, second] = (0, $fb3b7f5e99ab7e90$export$dc2d37c8312d2c6)(context, String(args[0]), String(args[1]));
                return first != second;
            }
            return args[0] != args[1];
        },
        isHiddenFromMenu: true,
        category: 'comparison',
        description: 'Returns true if the 2 (input) values are NOT equal',
        signatures: [
            'value != value',
            'NEQ(a: value, b: value)'
        ],
        examples: [
            '[col1] != 5',
            'NEQ([col1], 5)'
        ],
        returnType: 'boolean',
        inputs: [
            [
                'number',
                'number'
            ],
            [
                'date',
                'date'
            ],
            [
                'text',
                'text'
            ],
            [
                'boolean',
                'boolean'
            ]
        ]
    },
    LT: {
        handler (args, context) {
            if (args[0] instanceof Date && args[1] instanceof Date) return (0, $d2aab93838002ade$export$5c007e10c6929c95)(args[0], args[1]);
            if (typeof args[0] === 'string' || typeof args[1] === 'string') {
                const [first, second] = (0, $fb3b7f5e99ab7e90$export$dc2d37c8312d2c6)(context, String(args[0]), String(args[1]));
                return first < second;
            }
            return args[0] < args[1];
        },
        isHiddenFromMenu: true,
        category: 'comparison',
        description: 'Returns true if the 1st input is less than 2nd input',
        signatures: [
            'number < number',
            'date < date',
            'LT(a: number, b: number)',
            'LT(a: date, b: date)'
        ],
        examples: [
            '[col1] < 5',
            'LT([col1], 5)'
        ],
        returnType: 'boolean',
        inputs: [
            [
                'number',
                'number'
            ],
            [
                'date',
                'date'
            ]
        ]
    },
    LTE: {
        handler (args, context) {
            if (args[0] instanceof Date && args[1] instanceof Date) return (0, $d2aab93838002ade$export$5c007e10c6929c95)(args[0], args[1]) || (0, $7a7e68b5aa0b9077$export$248d38f6296296c5)(args[0], args[1]);
            if (typeof args[0] === 'string' || typeof args[1] === 'string') {
                const [first, second] = (0, $fb3b7f5e99ab7e90$export$dc2d37c8312d2c6)(context, String(args[0]), String(args[1]));
                return first <= second;
            }
            return args[0] <= args[1];
        },
        isHiddenFromMenu: true,
        category: 'comparison',
        description: 'Returns true if 1st input is less than or equals 2nd input',
        signatures: [
            'number <= number',
            'date <= date',
            'LTE(a: number, b: number)',
            'LTE(a: date, b: date)'
        ],
        examples: [
            '[col1] <= 5',
            'LTE([col1], 5)'
        ],
        returnType: 'boolean',
        inputs: [
            [
                'number',
                'number'
            ],
            [
                'date',
                'date'
            ]
        ]
    },
    GT: {
        handler (args, context) {
            if (args[0] instanceof Date && args[1] instanceof Date) return (0, $7c47abeb099a42c0$export$e4de839670987035)(args[0], args[1]);
            if (typeof args[0] === 'string' || typeof args[1] === 'string') {
                const [first, second] = (0, $fb3b7f5e99ab7e90$export$dc2d37c8312d2c6)(context, String(args[0]), String(args[1]));
                return first > second;
            }
            return args[0] > args[1];
        },
        isHiddenFromMenu: true,
        category: 'comparison',
        description: 'Returns true if the 1st input is greater than 2nd input',
        signatures: [
            'number > number',
            'date > date',
            'GT(a: number, b: number)',
            'GT(a: date, b: date)'
        ],
        examples: [
            '[col1] > 5',
            'GT([col1], 5)'
        ],
        returnType: 'boolean',
        inputs: [
            [
                'number',
                'number'
            ],
            [
                'date',
                'date'
            ]
        ]
    },
    GTE: {
        handler (args, context) {
            if (args[0] instanceof Date && args[1] instanceof Date) return (0, $7c47abeb099a42c0$export$e4de839670987035)(args[0], args[1]) || (0, $7a7e68b5aa0b9077$export$248d38f6296296c5)(args[0], args[1]);
            if (typeof args[0] === 'string' || typeof args[1] === 'string') {
                const [first, second] = (0, $fb3b7f5e99ab7e90$export$dc2d37c8312d2c6)(context, String(args[0]), String(args[1]));
                return first >= second;
            }
            return args[0] >= args[1];
        },
        isHiddenFromMenu: true,
        category: 'comparison',
        description: 'Returns true if 1st input is greater than or equals 2nd input',
        signatures: [
            'number >= number',
            'date >= date',
            'GTE(a: number, b: number)',
            'GTE(a: date, b: date)'
        ],
        examples: [
            '[col1] >= 5',
            'GTE([col1], 5)'
        ],
        returnType: 'boolean',
        inputs: [
            [
                'number',
                'number'
            ],
            [
                'date',
                'date'
            ]
        ]
    },
    BETWEEN: {
        handler ([input, lower, upper]) {
            if (typeof input !== 'number') throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('BETWEEN', 'arg 1 should be a number');
            return input >= lower && input <= upper;
        },
        category: 'comparison',
        description: 'Returns true if 1st input is between 2nd and 3rd inputs',
        signatures: [
            'BETWEEN(input: number, lower: number, upper: number)'
        ],
        examples: [
            'BETWEEN([col1], 10, 30)'
        ],
        returnType: 'boolean',
        inputs: [
            'number',
            'number',
            'number'
        ]
    },
    IN: {
        handler ([needle, haystack]) {
            return haystack.includes(needle);
        },
        category: 'comparison',
        description: 'Returns true if the left-hand side value is a constituent element of the right-hand side sequence',
        signatures: [
            'values IN (value, value, ...value)'
        ],
        examples: [
            '[col1] IN (5, 10, AVG([col2],[col3]))'
        ],
        returnType: 'boolean',
        inputs: [
            [
                'number',
                'number[]'
            ],
            // Date is currently not supported in select
            // ['date', 'date[]'],
            [
                'text',
                'text[]'
            ]
        ]
    },
    CONTAINS: {
        handler (args, context) {
            const [first, second] = (0, $fb3b7f5e99ab7e90$export$dc2d37c8312d2c6)(context, String(args[0]), String(args[1]));
            return first.indexOf(second) !== -1;
        },
        category: 'strings',
        description: 'Returns true if 1st input contains 2nd input',
        signatures: [
            'CONTAINS(a: string, b: string)'
        ],
        examples: [
            'CONTAINS([col1], "S")'
        ],
        returnType: 'boolean',
        inputs: [
            'text',
            'text'
        ]
    },
    STARTS_WITH: {
        handler (args, context) {
            const [first, second] = (0, $fb3b7f5e99ab7e90$export$dc2d37c8312d2c6)(context, String(args[0]), String(args[1]));
            return first.startsWith(second);
        },
        category: 'strings',
        description: 'Returns true if 1st input starts with the 2nd input',
        signatures: [
            'STARTS_WITH(a: string, b: string)'
        ],
        examples: [
            'STARTS_WITH([col1], "S")'
        ],
        returnType: 'boolean',
        inputs: [
            'text',
            'text'
        ]
    },
    ENDS_WITH: {
        handler (args, context) {
            const [first, second] = (0, $fb3b7f5e99ab7e90$export$dc2d37c8312d2c6)(context, String(args[0]), String(args[1]));
            return first.endsWith(second);
        },
        category: 'strings',
        description: 'Returns true if 1st input ends with the 2nd input',
        signatures: [
            'ENDS_WITH(a: string, b: string)'
        ],
        examples: [
            'ENDS_WITH([col1], "S")'
        ],
        returnType: 'boolean',
        inputs: [
            'text',
            'text'
        ]
    },
    ANY_CONTAINS: {
        handler (args, context) {
            const searchTerm = (0, $fb3b7f5e99ab7e90$export$5da374e426806c6a)(context, String(args[0]));
            return context.adaptableApi?.columnApi.getColumns().some((column)=>{
                const value = context.adaptableApi?.gridApi.getDisplayValueFromRowNode(context.node, column.columnId);
                const columnValue = (0, $fb3b7f5e99ab7e90$export$5da374e426806c6a)(context, String(value));
                return columnValue.indexOf(searchTerm) !== -1;
            });
        },
        category: 'strings',
        description: 'Returns true if any Column contains input',
        signatures: [
            'ANY_CONTAINS(value)'
        ],
        examples: [
            'ANY_CONTAINS("abc")'
        ],
        returnType: 'boolean'
    },
    IS_NUMERIC: {
        handler (args) {
            return !isNaN(Number(args[0]));
        },
        isHiddenFromMenu: false,
        description: 'Returns true if input is numeric',
        signatures: [
            'IS_NUMERIC(a: number)'
        ],
        examples: [
            'IS_NUMERIC([columnName])'
        ],
        category: 'maths',
        returnType: 'boolean',
        inputs: [
            'number'
        ]
    },
    REGEX: {
        handler (args) {
            // dont need context as here we always want case insenstivity in the Regex
            const firstInput = String(args[0]);
            const regex = String(args[1]);
            return RegExp(regex).test(firstInput);
        },
        isHiddenFromMenu: false,
        description: 'Returns true if Regular Expression matches',
        signatures: [
            'REGEX(a: string, b: pattern)'
        ],
        examples: [
            'REGEX([col1], "[A-Z]+")'
        ],
        inputs: [
            'text',
            'text'
        ],
        category: 'strings',
        returnType: 'boolean'
    },
    IS_HOLIDAY: {
        handler (args, context) {
            const dateToCheck = (0, $5a5def29d0cbcbac$export$dcc1c37491c61375)(args[0]);
            return context.adaptableApi.calendarApi.isHoliday(dateToCheck);
        },
        isHiddenFromMenu: false,
        description: 'Returns true if input date is a Holiday',
        signatures: [
            'IS_HOLIDAY(a: date)'
        ],
        examples: [
            'IS_HOLIDAY([columnName])'
        ],
        category: 'dates',
        returnType: 'boolean',
        inputs: [
            'date'
        ]
    },
    IS_WORKDAY: {
        handler (args, context) {
            const dateToCheck = (0, $5a5def29d0cbcbac$export$dcc1c37491c61375)(args[0]);
            return context.adaptableApi.calendarApi.isWorkingDay(dateToCheck);
        },
        isHiddenFromMenu: false,
        description: 'Returns true if input date is a Working Day',
        signatures: [
            'IS_WORKDAY(a: date)'
        ],
        examples: [
            'IS_WORKDAY([columnName])'
        ],
        category: 'dates',
        returnType: 'boolean',
        inputs: [
            'date'
        ]
    }
};
const $759293e9f6921c8e$export$7ff6566f3afad7fd = (0, $19aa91e82c6d8270$export$5206d47972fefe20)($759293e9f6921c8e$export$147a1738bbbef892);
const $759293e9f6921c8e$export$2232a2c16e0dc41a = (functionName)=>{
    return $759293e9f6921c8e$export$7ff6566f3afad7fd.includes(functionName);
};



const $7b8e7c7a6253319b$export$d7ca2e36ae751d5a = (node)=>{
    return typeof node?.type === 'string' && Array.isArray(node?.args);
};


const $caf1d59704029c8b$export$23543ecb1bb7aa64 = (operator)=>[
        'AND',
        'OR'
    ].includes(operator);


const $d0ecd1a41f6b3c39$export$56d4a4c448a55b0d = (arg)=>{
    return arg && typeof arg === 'string' && (arg.includes('[') || arg.includes('FIELD'));
};
function $d0ecd1a41f6b3c39$var$mapAstToQlPredicate(ast) {
    const operator = $d0ecd1a41f6b3c39$var$getOperatorFromAST(ast);
    if (!(0, $7b8e7c7a6253319b$export$d7ca2e36ae751d5a)(ast)) return;
    if (!operator || !(0, $759293e9f6921c8e$export$2232a2c16e0dc41a)(operator)) throw {
        errorMessage: `Only boolean functions are supported!`
    };
    const mapArgToPlArgs = (arg)=>{
        if (typeof arg === 'object' && !Array.isArray(arg) && 'type' in arg) {
            if (arg.type === 'COL') return [
                `[${arg.args[0]}]`
            ];
            // special case for FIELD
            if (arg.type === 'FIELD') // we are keeping the expression to know we are dealing with a field
            return `FIELD('${arg.args[0]}')`;
            if (arg.type === 'DATE') return `DATE("${arg.args[0]}")`;
            return $d0ecd1a41f6b3c39$var$mapAstToQlPredicate(arg);
        }
        if ([
            'string',
            'boolean',
            'number'
        ].includes(typeof arg)) return arg;
        if (arg && Array.isArray(arg)) return arg.map((a)=>mapArgToPlArgs(a)).flat();
        return null;
    };
    const args = ast.args.map(mapArgToPlArgs).filter((arg)=>arg !== null && arg !== undefined).flat();
    if (!(0, $caf1d59704029c8b$export$23543ecb1bb7aa64)(operator)) {
        // this throws
        if (!$d0ecd1a41f6b3c39$export$56d4a4c448a55b0d(args[0])) throw {
            errorMessage: 'First Argument must be an Adaptable Column or Field!'
        };
    }
    return {
        operator: operator,
        args: args
    };
}
function $d0ecd1a41f6b3c39$export$bf5e43697b4f5f9b(expression) {
    try {
        if (!expression) // return a sensible default
        return {
            operator: 'AND',
            args: []
        };
        const ast = (0, $3f77892da2e22ac4$export$1ab6d957e7a2fb4d)(expression);
        const astRootNode = ast?.[0];
        // TEST IS ROOT
        if (!astRootNode || !(0, $7b8e7c7a6253319b$export$d7ca2e36ae751d5a)(astRootNode)) throw {
            errorMessage: `Invalid expression: ${expression}`
        };
        const operator = $d0ecd1a41f6b3c39$var$getOperatorFromAST(astRootNode);
        if (!operator || !(0, $759293e9f6921c8e$export$2232a2c16e0dc41a)(operator)) return {
            errorMessage: `Only boolean functions are supported!`
        };
        const inputs = astRootNode.args;
        const qlPredicate = $d0ecd1a41f6b3c39$var$mapAstToQlPredicate(astRootNode);
        if (!(0, $caf1d59704029c8b$export$23543ecb1bb7aa64)(qlPredicate.operator)) return {
            operator: 'AND',
            args: [
                qlPredicate
            ]
        };
        else return qlPredicate;
    } catch (err) {
        return {
            errorMessage: `Query Builder does not support the expression: ${expression}`
        };
    }
}
function $d0ecd1a41f6b3c39$var$getOperatorFromAST(astRootNode) {
    if (![
        'INFIX',
        'FUNCTION',
        'VALUE_REF'
    ].includes(astRootNode.metaInfo)) return undefined;
    return astRootNode.type;
}






function $ea9af415e1458220$export$c0d18aa1f16e7003(predicate, symbolMapper = $ea9af415e1458220$export$126266305cb12b1a) {
    if (!predicate) return '';
    const predicateType = $ea9af415e1458220$var$getPredicateType(predicate.operator);
    const { operator: operator, args: args } = predicate;
    if (!args || args.length === 0) return operator;
    if (operator === null || !operator) return '';
    const operatorSymbol = symbolMapper(operator);
    // If a combinator with only one branch, remove the combinator.
    if (args.length === 1 && typeof args[0] === 'object' && (0, $caf1d59704029c8b$export$23543ecb1bb7aa64)(operator)) return $ea9af415e1458220$export$c0d18aa1f16e7003(args[0]);
    let [firstArg, ...restOfArgs] = args;
    const mappedArgs = restOfArgs.filter((arg)=>arg !== undefined).map((arg)=>{
        if (typeof arg === 'string') {
            if (arg.includes('[')) return arg;
            if (arg.includes('FIELD')) return arg;
            if (arg.includes('DATE')) return arg;
            if (arg === 'TRUE' || arg === 'FALSE') return arg;
            return `"${arg}"`;
        }
        if (arg && typeof arg === 'object' && 'operator' in arg) {
            if ((0, $caf1d59704029c8b$export$23543ecb1bb7aa64)(arg.operator)) return `(${$ea9af415e1458220$export$c0d18aa1f16e7003(arg)})`;
            return $ea9af415e1458220$export$c0d18aa1f16e7003(arg);
        }
        if (typeof arg === 'boolean') return arg ? 'TRUE' : 'FALSE';
        return arg;
    });
    if (typeof firstArg === 'object' && 'operator' in firstArg) firstArg = $ea9af415e1458220$export$c0d18aa1f16e7003(firstArg);
    if ((0, $caf1d59704029c8b$export$23543ecb1bb7aa64)(operator)) // need to compose with AND [] AND ...
    return mappedArgs.length ? `${firstArg} ${operatorSymbol} ${mappedArgs.join(` ${operatorSymbol} `)}` : `${firstArg}`;
    if (predicateType === 'INFIX') {
        if (operator === 'BETWEEN') return `${firstArg} ${operatorSymbol} (${mappedArgs})`;
        if (operator === 'IN') return `${firstArg} ${operatorSymbol} (${mappedArgs.join(', ')})`;
        return `${firstArg} ${operatorSymbol} ${mappedArgs.join(', ')}`;
    }
    if (predicateType === 'FUNCTION') return `${operatorSymbol}(${[
        firstArg,
        ...mappedArgs
    ].join(', ')})`;
    return `${operatorSymbol}(${mappedArgs.join(', ')})`;
}
function $ea9af415e1458220$export$126266305cb12b1a(predicateName) {
    switch(predicateName){
        case 'NOT':
            return '!';
        case 'EQ':
            return '=';
        case 'NEQ':
            return '!=';
        case 'LT':
            return '<';
        case 'LTE':
            return '<=';
        case 'GT':
            return '>';
        case 'GTE':
            return '>=';
        default:
            return predicateName;
    }
}
function $ea9af415e1458220$var$getPredicateType(predicateName) {
    switch(predicateName){
        case 'COL':
        case 'FIELD':
            return 'VALUE_REF';
        case 'IF':
        case 'CASE':
            return 'CONDITIONAL';
        case 'NOT':
            return 'UNARY';
        case 'ADD':
        case 'SUB':
        case 'MUL':
        case 'DIV':
        case 'MOD':
        case 'POW':
        case 'OR':
        case 'AND':
        case 'EQ':
        case 'NEQ':
        case 'LT':
        case 'LTE':
        case 'GT':
        case 'GTE':
        case 'BETWEEN':
        case 'STARTS_WITH':
        case 'ENDS_WITH':
        case 'CONTAINS':
        case 'IN':
        case 'WHERE':
            return 'INFIX';
        default:
            return 'FUNCTION';
    }
}








var $acw62 = parcelRequire("acw62");


const $515d3b24b9de8c6a$export$e0e193db4cb7689a = 'ab-WarningBox';
const $515d3b24b9de8c6a$export$5255389de52b07e9 = (props)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:p-3 twa:rounded-standard twa:bg-warn twa:text-text-on-warn', $515d3b24b9de8c6a$export$e0e193db4cb7689a, props.className)
    });
};



var $acw62 = parcelRequire("acw62");


const $47be09cb14df4bdb$export$d252517300e3b104 = (dataType)=>{
    if (dataType === 'number') return 'number';
    if (dataType === 'boolean') return 'boolean';
    if (dataType === 'text') return 'text';
    if (dataType === 'date') return 'date';
    if (dataType === 'numberArray') return 'number[]';
    if (dataType === 'textArray') return 'text[]';
    if (dataType === 'groupColumn') return 'text';
};
const $47be09cb14df4bdb$export$8f271d5f5f9ef4e2 = (type)=>{
    if (type === 'number') return 'number';
    if (type === 'boolean') return 'boolean';
    if (type === 'text') return 'text';
    if (type === 'date') return 'date';
    if (type === 'number[]') return 'numberArray';
    if (type === 'text[]') return 'textArray';
    return undefined;
};





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

const $41625a75ae496875$var$getAvailableSizeInfo = ({ targetRect: targetRect, constrainRect: constrainRect, maxSizeOffset: maxSizeOffset })=>{
    let maxHeight;
    let maxWidth;
    const topAvailableSpace = Math.round(targetRect.top - constrainRect.top);
    const leftAvailableSpace = Math.round(targetRect.left - constrainRect.left);
    const bottomAvailableSpace = Math.round(constrainRect.bottom - targetRect.bottom);
    const rightAvailableSpace = Math.round(constrainRect.right - targetRect.right);
    let horizontalPosition = 'right';
    let verticalPosition = 'bottom';
    if (leftAvailableSpace > rightAvailableSpace) {
        horizontalPosition = 'left';
        maxWidth = Math.round(targetRect.left - constrainRect.left);
    } else maxWidth = rightAvailableSpace;
    if (topAvailableSpace > bottomAvailableSpace) {
        verticalPosition = 'top';
        maxHeight = Math.round(targetRect.top - constrainRect.top);
    } else maxHeight = bottomAvailableSpace;
    if (maxSizeOffset != null) {
        maxWidth -= maxSizeOffset;
        maxHeight -= maxSizeOffset;
    }
    return {
        horizontalPosition: horizontalPosition,
        verticalPosition: verticalPosition,
        maxWidth: maxWidth,
        maxHeight: maxHeight
    };
};
var $41625a75ae496875$export$2e2bcd8739ae039 = $41625a75ae496875$var$getAvailableSizeInfo;



var $bc23564e9492cc1e$export$2e2bcd8739ae039 = (props, positionerRef)=>{
    const positionInfoRef = (0, $acw62.useRef)({
        maxHeight: '50vh',
        maxWidth: '50vw',
        verticalPosition: 'bottom',
        horizontalPosition: 'right'
    });
    const updatePosition = ()=>{
        const positionRect = positionerRef.current.getBoundingClientRect();
        positionInfoRef.current = (0, $41625a75ae496875$export$2e2bcd8739ae039)({
            constrainRect: (0, $c9ce1fb924ab724e$export$a0155fc0e7646aa4)(positionerRef.current, props.constrainTo),
            targetRect: positionRect,
            maxSizeOffset: 30
        });
    };
    const [expanded, doSetExpanded] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'expanded', false, {
        onChange: (expanded)=>{
            if (expanded) {
                if (props.onExpand) props.onExpand();
            } else if (props.onCollapse) props.onCollapse();
            if (props.onToggle) props.onToggle(expanded);
            if (props.onExpandedChange) props.onExpandedChange(expanded);
        }
    });
    const setExpanded = (newExpanded)=>{
        // if (!newExpanded) {
        //   return;
        // }
        if (!expanded && newExpanded) updatePosition();
        doSetExpanded(newExpanded);
    };
    const toggle = ()=>{
        setExpanded(!expanded);
    };
    return {
        expanded: expanded,
        setExpanded: setExpanded,
        toggle: toggle,
        positionInfo: positionInfoRef.current
    };
};



var $acw62 = parcelRequire("acw62");

var $e8c85963a256bb89$export$2e2bcd8739ae039 = ({ domProps: domProps, item: item, onItemClick: onItemClick, index: index, columns: columns, className: className, idProperty: idProperty, style: style })=>{
    const key = item[idProperty] || index;
    if (!(0, $9dc80662ca8a355b$export$2e2bcd8739ae039)(item)) return $acw62.createElement("tr", {
        onClick: onItemClick,
        key: key,
        className: className,
        ...domProps
    }, $acw62.createElement("td", {
        colSpan: columns.length,
        style: style
    }, item));
    return $acw62.createElement("tr", {
        onClick: onItemClick,
        key: key,
        className: className,
        ...domProps
    }, columns.map((col)=>{
        return $acw62.createElement("td", {
            key: col,
            style: style
        }, item[col]);
    }));
};




const $3c0be5e51ee36e80$export$808181406d6659c2 = $acw62.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 24 24"
}, $acw62.createElement("path", {
    d: "M7 10l5 5 5-5H7z"
}));
const $3c0be5e51ee36e80$var$spacer = $acw62.createElement("div", {
    className: "twa:flex-1"
});
const $3c0be5e51ee36e80$var$baseClassName = 'ab-DropdownButton';
const $3c0be5e51ee36e80$var$defaultListItemStyle = {
    padding: 'var(--ab-cmp-dropdownbutton-list-item__padding)'
};
const $3c0be5e51ee36e80$var$DropdownButton = $acw62.forwardRef((props, theRef)=>{
    let { columns: columns, overlayProps: overlayProps, listOffset: listOffset = 10, collapseOnItemClick: collapseOnItemClick = true, focusOnClear: focusOnClear = true, idProperty: idProperty = 'id', isItemDisabled: isItemDisabled, items: items, children: children, listMinWidth: listMinWidth = 100, listStyle: listStyle, listItemStyle: listItemStyle, listItemClassName: listItemClassName, constrainTo: constrainTo, showClearButton: showClearButton = false, onClear: onClear, clearButtonProps: clearButtonProps, onExpand: onExpand, onCollapse: onCollapse, showToggleIcon: showToggleIcon = true, ...domProps } = props;
    isItemDisabled = isItemDisabled || ((item)=>item.disabled);
    if (!columns) columns = [
        'icon',
        'label'
    ];
    let content;
    if (Array.isArray(items)) {
        content = items.map((item, index)=>{
            if (item.separator) return $acw62.createElement("tr", {
                className: `${$3c0be5e51ee36e80$var$baseClassName}__separator`,
                key: index
            }, $acw62.createElement("td", {
                colSpan: 2
            }));
            if (typeof listItemStyle === 'function') listItemStyle = listItemStyle(item, index);
            const disabled = isItemDisabled(item);
            const itemStyle = {
                ...$3c0be5e51ee36e80$var$defaultListItemStyle,
                ...listItemStyle
            };
            const itemClassName = (0, $c72009da7485afc2$export$2e2bcd8739ae039)(`${$3c0be5e51ee36e80$var$baseClassName}__list-item`, item.clickable === false || disabled ? `${$3c0be5e51ee36e80$var$baseClassName}__list-item--not-clickable` : `${$3c0be5e51ee36e80$var$baseClassName}__list-item--clickable`, disabled ? `${$3c0be5e51ee36e80$var$baseClassName}__list-item--disabled` : '', listItemClassName);
            const getItemHandler = (eventName)=>{
                return (e)=>{
                    if (!disabled) {
                        if (item[eventName]) item[eventName](e, item);
                    }
                    if (collapseOnItemClick) {
                        if (!disabled) setExpanded(false);
                        buttonRef.current?.focus();
                    } else e.nativeEvent.preventCollapse = true;
                };
            };
            const domProps = {};
            if (item.onChange) domProps.onChange = getItemHandler('onChange');
            const itemDataName = item['dataName'] || (typeof item['label'] === 'string' ? item['label'] : undefined);
            if (itemDataName) domProps['data-name'] = itemDataName;
            return (0, $e8c85963a256bb89$export$2e2bcd8739ae039)({
                index: index,
                idProperty: idProperty,
                onItemClick: getItemHandler('onClick'),
                domProps: domProps,
                className: itemClassName,
                style: itemStyle,
                item: item,
                columns: columns
            });
        });
        content = $acw62.createElement("table", {
            className: `${$3c0be5e51ee36e80$var$baseClassName}__content`
        }, $acw62.createElement("tbody", null, content));
    }
    const dropdownButtonClassName = props.className;
    const className = (0, $c72009da7485afc2$export$2e2bcd8739ae039)(props.className, $3c0be5e51ee36e80$var$baseClassName);
    const positionerRef = (0, $acw62.useRef)(null);
    const { expanded: expanded, toggle: toggle, setExpanded: setExpanded, positionInfo: positionInfo } = (0, $bc23564e9492cc1e$export$2e2bcd8739ae039)(props, positionerRef);
    const { maxHeight: maxListHeight, maxWidth: maxListWidth } = positionInfo;
    listStyle = {
        minWidth: typeof maxListWidth === 'number' ? Math.min(listMinWidth, maxListWidth) : listMinWidth,
        maxHeight: maxListHeight,
        maxWidth: maxListWidth,
        ...listStyle
    };
    let icon = expanded ? (0, $acw62.cloneElement)($3c0be5e51ee36e80$export$808181406d6659c2, {
        style: {
            ...$3c0be5e51ee36e80$export$808181406d6659c2.props.style,
            transform: 'rotate(180deg) translate3d(0px, -2px, 0px)'
        }
    }) : $3c0be5e51ee36e80$export$808181406d6659c2;
    const hasClearButton = onClear || showClearButton;
    const clearButton = hasClearButton ? $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        disabled: domProps.disabled,
        as: "div",
        onClick: (event)=>{
            event.stopPropagation();
            if (onClear) onClear();
            buttonRef.current?.focus();
        },
        className: "twa:ml-2 twa:p-0",
        variant: 'text',
        icon: "close",
        ...clearButtonProps,
        style: {
            ...clearButtonProps?.style,
            visibility: showClearButton ? 'visible' : 'hidden'
        }
    }) : null;
    icon = $acw62.createElement($acw62.Fragment, null, $3c0be5e51ee36e80$var$spacer, hasClearButton ? clearButton : null, icon);
    const buttonRef = (0, $acw62.useRef)(null);
    return $acw62.createElement((0, $c9ce1fb924ab724e$export$2e2bcd8739ae039), {
        visible: expanded,
        targetOffset: listOffset,
        render: ()=>{
            return $acw62.createElement("div", {
                "data-name": `${dropdownButtonClassName}`,
                style: listStyle,
                className: `${$3c0be5e51ee36e80$var$baseClassName}__list`,
                onMouseDownCapture: (e)=>{
                    /**
                     * This stops popups register clicks inside the dropdown
                     * This is needed for column filter dropdows when redenred
                     * inside ag-grid column filter
                     */ if (props.stopPropagationOnOverlay) e.stopPropagation();
                }
            }, content);
        },
        ...overlayProps
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        iconPosition: "end",
        ...showToggleIcon && {
            icon: icon
        },
        ...domProps,
        ref: (btn)=>{
            buttonRef.current = btn;
            if (!theRef) return;
            if (typeof theRef === 'function') theRef(btn);
            else theRef.current = btn;
        },
        style: domProps.style,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, {
            'twa:pr-0': showToggleIcon
        }),
        onClick: (e)=>{
            if (domProps.onClick) domProps.onClick(e);
            if (e.nativeEvent.preventCollapse && expanded) return;
            toggle();
        },
        onKeyDown: (e)=>{
            if (domProps.onKeyDown) domProps.onKeyDown(e);
            if (expanded && e.key === 'Escape') toggle();
        },
        onBlur: (e)=>{
            if (domProps.onBlur) domProps.onBlur(e);
            setExpanded(false);
        }
    }, $acw62.createElement("div", {
        ref: positionerRef,
        tabIndex: -1,
        style: {
            position: 'absolute',
            height: '100%',
            width: '100%',
            zIndex: -1,
            pointerEvents: 'none',
            opacity: 0,
            top: 0,
            left: 0
        }
    }), children));
});
var $3c0be5e51ee36e80$export$2e2bcd8739ae039 = $3c0be5e51ee36e80$var$DropdownButton;






var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


const $568d00bde2c337b2$export$e5d989eba9e871bb = function(props) {
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const columns = $acw62.useMemo(()=>{
        return api.columnApi.getColumnsWithDataType(props.type);
    }, []);
    const getColumn = (columnId)=>columns.find((c)=>c.columnId === columnId);
    const options = columns.map((column)=>{
        let label = column.friendlyName ?? column.columnId;
        if (props.renderOption) label = props.renderOption(column);
        return {
            label: label,
            value: column.columnId
        };
    }).filter((option)=>{
        if (props.filterColumn) return props.filterColumn(getColumn(option.value));
        return true;
    });
    return $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "data-name": "column-selector",
        searchable: 'inline',
        disabled: props.disabled,
        isMulti: props.isMulti,
        menuPosition: props.menuPosition,
        value: props.value,
        placeholder: props.placeholder ?? 'Select Column',
        onChange: (colId)=>{
            props.onChange(colId);
        },
        options: options
    });
};



var $acw62 = parcelRequire("acw62");


const $03a0da3a21102dc6$export$1e75f01162ffc4f1 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const fields = $acw62.useMemo(()=>{
        return api.expressionApi.internalApi.getFieldsOfType(props.type);
    }, []);
    const options = fields.map((field)=>({
            label: field.label ?? field.name,
            value: field.name
        }));
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "data-name": "column-selector",
        searchable: 'inline',
        disabled: props.disabled,
        isMulti: false,
        menuPosition: props.menuPosition,
        value: props.value || undefined,
        placeholder: props.placeholder ?? 'Select Field',
        onChange: (fieldValue)=>{
            props.onChange(fieldValue);
        },
        options: options
    }));
};



var $acw62 = parcelRequire("acw62");

/**
 * Calls the callback if the promise does not resolve in a amount of time.
 *
 * @param promise
 * @param callback Called if promise does not resolve in the time defined by 'delay'
 * @param delay Time after which if the promise was not resolved the callback (fn) is called.
 */ const $7df315338233fd60$export$c73a921563bfad03 = async (promise, callback, delay = 100)=>{
    let isFulfilled = false;
    promise?.then(()=>{
        isFulfilled = true;
    });
    (async ()=>{
        await new Promise((resolve)=>setTimeout(resolve, delay));
        if (!isFulfilled) callback();
    })();
    return promise;
};



const $280aaa838d007117$export$266b893610128c75 = function(props) {
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [refetchKey, setRefetchKey] = $acw62.useState(0);
    const [isLoading, setIsLoading] = $acw62.useState(true);
    const [options, setOptions] = $acw62.useState([]);
    const searchFilterRef = $acw62.useRef('');
    const [searchValueWasUsedWhenFiltering, setSearchValueWasUsedWhenFiltering] = $acw62.useState(false);
    const dataType = $acw62.useMemo(()=>{
        return adaptable.api.columnApi.getColumnDataTypeForColumnId(props.columnId);
    }, [
        props.columnId
    ]);
    $acw62.useEffect(()=>{
        if (!props.columnId) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        (async ()=>{
            let searchValueUsedInFilterValue = false;
            const currentSearchValue = searchFilterRef.current;
            const p = props.loadValues ? props.loadValues({
                get currentSearchValue () {
                    searchValueUsedInFilterValue = true;
                    return currentSearchValue;
                }
            }) : adaptable.api.filterApi.columnFilterApi.internalApi.getColumnFilterValues({
                columnId: props.columnId,
                get currentSearchValue () {
                    searchValueUsedInFilterValue = true;
                    return currentSearchValue;
                }
            });
            const distinctColumnValues = await (0, $7df315338233fd60$export$c73a921563bfad03)(// we are here ALWAYS getting Filter values but sometimes we want to get other things!!!
            p, ()=>{
                setIsLoading(true);
            });
            setSearchValueWasUsedWhenFiltering(searchValueUsedInFilterValue);
            setIsLoading(false);
            setOptions(Array.isArray(distinctColumnValues) ? distinctColumnValues : distinctColumnValues.values);
        })();
    }, [
        props.columnId,
        props.loadValues,
        refetchKey
    ]);
    const isCreatable = props.allowNewValues && !dataType || [
        'text',
        'number'
    ].includes(dataType);
    const handleSingleValueChange = (value)=>{
        if (isCreatable) {
            // try to convert to correct type, when there is not type, e.g. field
            if (!dataType && typeof value === 'string' && !isNaN(parseFloat(value))) props.onChange(parseFloat(value));
            else if (dataType === 'number') {
                let num = parseFloat(value);
                num = isNaN(num) ? null : num;
                props.onChange(num);
            } else props.onChange(value);
        } else props.onChange(value);
    };
    const handleMultiValueChange = (values)=>{
        if (isCreatable) {
            if (dataType === 'number') {
                const nums = values.map((v)=>parseFloat(v)).filter((v)=>!isNaN(v));
                props.onChange(nums);
            } else props.onChange(values);
        } else props.onChange(values);
    };
    const handleOnChange = (value)=>{
        // convert numbers
        if (props.isMulti) handleMultiValueChange(value);
        else handleSingleValueChange(value);
    };
    const reload = (0, $acw62.useCallback)(()=>{
        setRefetchKey((k)=>k + 1);
    }, []);
    const onInputChange = (value)=>{
        searchFilterRef.current = value;
        if (searchValueWasUsedWhenFiltering) reload();
    };
    return $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "aria-label": "Permitted Values Selector",
        searchable: props.searchable ?? 'menulist',
        size: props.size,
        isMulti: props.isMulti,
        className: props.className,
        disabled: props.disabled,
        closeMenuOnSelect: !props.isMulti,
        "data-name": "permitted-values-selector",
        placeholder: props.placeholder || (props.allowNewValues ? 'Select or type new value' : 'Select value'),
        isCreatable: isCreatable,
        isClearable: true,
        onMenuOpen: reload,
        options: options,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onChange: handleOnChange,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        value: props.value
    });
};






var $acw62 = parcelRequire("acw62");
const $bb22383ceab68e70$export$6e5a9cd40e0c9b97 = ({ Component: Component = 'div', children: children, ...rest })=>{
    const Comp = Component;
    return $acw62.createElement(Comp, {
        ...rest,
        className: `ab-cmp-input-group ${rest.className ?? ''}`
    }, children);
};









/**
 * Returns a new object with the property updated.
 * The property is identified by the path.
 *
 * @param obj Object
 * @param path path to the property
 * @param value new property value
 * @returns
 */ function $28578c992716f58c$export$5e0bd00357638445(obj, path, value) {
    if (path.length === 1) return {
        ...obj,
        [path[0]]: value
    };
    return {
        ...obj,
        [path[0]]: $28578c992716f58c$export$5e0bd00357638445(obj?.[path[0]] ?? {}, path.slice(1), value)
    };
}
function $28578c992716f58c$export$23cfe696632d10f4(obj) {
    return !obj || Object.keys(obj).length === 0;
}
const $28578c992716f58c$export$b7d58db314e0ac27 = (obj)=>{
    return JSON.parse(JSON.stringify(obj));
};
const $28578c992716f58c$export$a37e3c603d7117e5 = (obj1, obj2)=>{
    let changed = [];
    for (const key of Object.keys(obj1))if (obj1[key] !== obj2[key]) changed.push(key);
    return changed;
};


const $02574bdea1ea2a7c$export$94d0e25158ed3a03 = [
    'EQ',
    'NEQ',
    'GT',
    'LT',
    'GTE',
    'LTE',
    'BETWEEN',
    'CONTAINS',
    'STARTS_WITH',
    'ENDS_WITH',
    'IS_HOLIDAY',
    'IS_WORKDAY',
    'IN'
];


const $2298f961f09270fa$export$fc77a6137e3f91c = (predicate, from, to)=>{
    const predicateCopy = (0, $28578c992716f58c$export$b7d58db314e0ac27)(predicate);
    // we start from the root so no need to traverse first level
    const [_, ...fromPath] = from.split('/');
    const [__, ...toPath] = to.split('/');
    // remove from old position and get the item
    // path = '0/1/2'
    let itemToMove = predicateCopy;
    let prev = null;
    for (const index of fromPath){
        prev = itemToMove;
        itemToMove = itemToMove.args[parseInt(index)];
    }
    prev.args.splice(parseInt(fromPath[fromPath.length - 1]), 1);
    // find the parent into wich we want to insert the item
    let cursor = predicateCopy;
    let parent = null;
    for (const index of toPath){
        parent = cursor;
        cursor = cursor.args[parseInt(index)];
    }
    parent.args.splice(parseInt(toPath[toPath.length - 1]), 0, itemToMove);
    return predicateCopy;
};
const $2298f961f09270fa$export$f89f94ec62712b0e = (columnType, inputs, includeAllInputs = false)=>{
    if (Array.isArray(inputs[0])) {
        const matchingInput = inputs.find((input)=>input[0] === columnType);
        const [_, ...restOfArgs] = matchingInput ?? [];
        return restOfArgs;
    }
    const [_, ...restOfArgs] = inputs;
    return includeAllInputs ? inputs : restOfArgs;
};
const $2298f961f09270fa$export$f116df8bb841eabd = (dataType, availableBooleanFunctions)=>{
    const columnType = (0, $47be09cb14df4bdb$export$d252517300e3b104)(dataType);
    return (0, $02574bdea1ea2a7c$export$94d0e25158ed3a03).filter((boolFnName)=>{
        if (!availableBooleanFunctions.includes(boolFnName)) return false;
        const functionDef = (0, $759293e9f6921c8e$export$147a1738bbbef892)[boolFnName];
        const inputs = functionDef.inputs;
        let matchingInputTypes = [];
        if (inputs && Array.isArray(inputs[0])) matchingInputTypes = inputs.find((input)=>input[0] === columnType);
        else matchingInputTypes = inputs;
        return matchingInputTypes?.[0] === columnType;
    });
};
const $2298f961f09270fa$export$795e5fe51e63f57c = (predicate, context)=>{
    if (!predicate) return null;
    if (typeof predicate === 'string' && $2298f961f09270fa$export$6efd02a3dd06b3e7(predicate)) {
        const field = $2298f961f09270fa$export$15f8a217295250ab(predicate);
        if (!context.supportedFields?.some((field)=>field?.value === $2298f961f09270fa$export$15f8a217295250ab(predicate))) return `Expression uses an unregistered field: "${field}"`;
        else return null;
    }
    if (typeof predicate === 'object' && 'errorMessage' in predicate) return null;
    if (typeof predicate !== 'object' || !('operator' in predicate) || !predicate.operator) return null;
    if (!(0, $caf1d59704029c8b$export$23543ecb1bb7aa64)(predicate.operator) && !(0, $02574bdea1ea2a7c$export$94d0e25158ed3a03).includes(predicate.operator)) return `${predicate.operator} is not supported in the Query Builder`;
    if (predicate.args.length === 0) return null;
    let firstInvalidArg = null;
    for (let arg of predicate.args){
        firstInvalidArg = $2298f961f09270fa$export$795e5fe51e63f57c(arg, context);
        if (firstInvalidArg) break;
    }
    if (firstInvalidArg) return firstInvalidArg;
    return null;
};
const $2298f961f09270fa$export$c70ebdd790f5cf71 = (field)=>`FIELD('${field}')`;
const $2298f961f09270fa$export$15f8a217295250ab = (expression)=>{
    if (!expression) return '';
    try {
        return expression.match(/FIELD\(['"](.+)['"]\)/)?.[1];
    } catch (e) {
        return '';
    }
};
const $2298f961f09270fa$export$2eedb04ad3571a5c = (expression)=>{
    if (!expression) return null;
    try {
        return expression.match(/\[(.+)\]/)?.[1];
    } catch (e) {
        return expression;
    }
};
const $2298f961f09270fa$export$6efd02a3dd06b3e7 = (expression)=>{
    return typeof expression === 'string' && expression.includes('FIELD');
};



const $37dd7dc6972d9748$export$4a36de17a13d3a19 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [type, setType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        return(// default to column
        !props.fieldOrColumn || props.fieldOrColumn.includes('[') ? 'column' : 'field');
    });
    const hasFields = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return adaptable.api.expressionApi.internalApi.getAvailableFields()?.length > 0;
    }, []);
    const hasFieldsOrValueIsField = hasFields || (0, $2298f961f09270fa$export$6efd02a3dd06b3e7)(props.fieldOrColumn);
    let input = null;
    if (type === 'column') {
        const columnId = (0, $2298f961f09270fa$export$2eedb04ad3571a5c)(props.fieldOrColumn);
        input = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $568d00bde2c337b2$export$e5d989eba9e871bb), {
            value: columnId,
            type: props.type,
            onChange: (columnId)=>{
                props.onChange(`[${columnId}]`);
            }
        });
    } else input = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $03a0da3a21102dc6$export$1e75f01162ffc4f1), {
        value: (0, $2298f961f09270fa$export$15f8a217295250ab)(props.fieldOrColumn),
        type: props.type,
        onChange: (fieldValue)=>{
            props.onChange((0, $2298f961f09270fa$export$c70ebdd790f5cf71)(fieldValue));
        }
    });
    const typeOptions = [
        {
            label: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                alignItems: "center"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "grid"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:ml-2"
            }, "Column")),
            value: 'column',
            icon: 'grid'
        },
        {
            label: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                alignItems: "center"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "column-outline"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:ml-2"
            }, "Field")),
            value: 'field',
            icon: 'column-outline'
        }
    ];
    return !hasFieldsOrValueIsField || props.hideFields ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, input) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bb22383ceab68e70$export$6e5a9cd40e0c9b97), {
        Component: (0, $82c87f52da9ba110$export$f51f4c4ede09e011),
        "data-id": "query-first-arg-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        renderSingleValue: (value)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, type === 'column' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "grid"
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "column-outline"
            }));
        },
        value: type,
        options: typeOptions,
        onChange: (value)=>{
            props.onChange(null);
            setType(value);
        }
    }), input);
};
const $37dd7dc6972d9748$export$caf61155c790b8c0 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const hasFields = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return adaptable.api.expressionApi.internalApi.getAvailableFields()?.length > 0;
    }, []);
    const hasFieldsOrValueIsField = hasFields || (0, $2298f961f09270fa$export$6efd02a3dd06b3e7)(props.value);
    const [type, setType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        if (typeof props?.value === 'string' && props?.value?.includes('[')) return 'column-name';
        if (typeof props?.value === 'string' && props?.value?.includes('FIELD')) return 'field';
        return 'input-value';
    });
    const handleTypeChange = (newType)=>{
        if (type !== newType) {
            // need to reset value
            props.onChange(undefined);
            setType(newType);
        }
    };
    const getEditor = ()=>{
        const common = {
            'data-id': 'query-input'
        };
        switch(props.inputType){
            case 'boolean':
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                    ...common,
                    checked: props.value,
                    onChange: ()=>props.onChange(!props.value)
                });
            case 'number':
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
                    ...common,
                    type: "number",
                    value: props.value ?? '',
                    onChange: (event)=>{
                        const value = event.target.value;
                        if (value === '') props.onChange(undefined);
                        else props.onChange(parseFloat(value));
                    }
                });
            case 'text':
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
                    ...common,
                    type: "text",
                    value: props.value ?? '',
                    onChange: (event)=>{
                        props.onChange(event.target.value);
                    }
                });
            case 'date':
                // date format = 'DATE(2020-01-01)'
                const dateStr = typeof props.value === 'string' ? props.value.replace('DATE(', '').replace(')', '') : '';
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
                    ...common,
                    type: "date",
                    value: dateStr ?? '',
                    onChange: (event)=>{
                        const stringified = `DATE("${event.target.value}")`;
                        props.onChange(stringified);
                    }
                });
            default:
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
        }
    };
    let editor = null;
    if (type === 'column-name') {
        const abColType = (0, $47be09cb14df4bdb$export$8f271d5f5f9ef4e2)(props.inputType);
        editor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($37dd7dc6972d9748$export$4a36de17a13d3a19, {
            hideFields: true,
            fieldOrColumn: props.value,
            type: abColType,
            onChange: (columnId)=>{
                props.onChange(columnId);
            }
        });
    } else if (type === 'field') editor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $03a0da3a21102dc6$export$1e75f01162ffc4f1), {
        value: (0, $2298f961f09270fa$export$15f8a217295250ab)(props.value),
        onChange: (fieldValue)=>{
            props.onChange((0, $2298f961f09270fa$export$c70ebdd790f5cf71)(fieldValue));
        }
    });
    else if (![
        'date',
        'boolean'
    ].includes(props.inputType)) editor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $280aaa838d007117$export$266b893610128c75), {
        allowNewValues: true,
        searchable: 'menulist',
        value: props.value,
        columnId: (0, $2298f961f09270fa$export$2eedb04ad3571a5c)(props.lefthandColumnIdParam),
        onChange: (value)=>{
            props.onChange(value);
        }
    });
    else editor = getEditor();
    const options = [
        {
            label: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                alignItems: "center"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "columns"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:ml-2"
            }, "Column")),
            icon: 'columns',
            value: 'column-name'
        },
        {
            label: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                alignItems: "center"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "edit"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:ml-2"
            }, "Value")),
            icon: 'edit',
            value: 'input-value'
        }
    ];
    if (hasFieldsOrValueIsField || type === 'field') options.push({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
            name: "column-outline"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:ml-2"
        }, "Field")),
        icon: 'column-outline',
        value: 'field'
    });
    const typeOption = options.find((option)=>option.value === type);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bb22383ceab68e70$export$6e5a9cd40e0c9b97), {
        Component: (0, $82c87f52da9ba110$export$f51f4c4ede09e011),
        "data-id": "query-input-wrapper",
        className: "twa:mr-2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        renderSingleValue: (value)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeOption.value === 'column-name' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "grid"
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "edit"
            }));
        },
        value: typeOption.value,
        options: options,
        onChange: (value)=>handleTypeChange(value)
    }), editor);
};
const $37dd7dc6972d9748$export$a8b7ffabeef50918 = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $280aaa838d007117$export$266b893610128c75), {
        isMulti: true,
        allowNewValues: true,
        value: props.value,
        columnId: (0, $2298f961f09270fa$export$2eedb04ad3571a5c)(props.lefthandColumnIdParam),
        onChange: (value)=>{
            props.onChange(value);
        }
    });
};
const $37dd7dc6972d9748$var$SymbolToIcon = (props)=>{
    switch(props.symbol){
        case '=':
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "equals"
            });
        case '!=':
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "not-equal"
            });
        case '>':
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "greater-than"
            });
        case '>=':
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "greater-than-or-equal"
            });
        case '<':
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "less-than"
            });
        case '<=':
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "less-than-or-equal"
            });
        default:
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.symbol);
    }
};
const $37dd7dc6972d9748$export$c741f3ac74bd2b6e = (props)=>{
    const { getExpressions: getExpressions } = (0, $0342e7e7247dede6$export$ea4b06a5da3ad29c)();
    const expressions = props.dataType ? getExpressions(props.dataType) : [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        "data-id": "expression-selector",
        "data-value": props.value,
        variant: "raised",
        tone: 'accent',
        columns: [
            'label'
        ],
        items: expressions.map((expression)=>({
                label: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($37dd7dc6972d9748$var$SymbolToIcon, {
                    symbol: (0, $ea9af415e1458220$export$126266305cb12b1a)(expression)
                }),
                onClick: ()=>{
                    if (expression !== props.value) props.onExpressionChange(expression);
                }
            }))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($37dd7dc6972d9748$var$SymbolToIcon, {
        symbol: (0, $ea9af415e1458220$export$126266305cb12b1a)(props.value) ?? 'Select Operator'
    }));
};
const $37dd7dc6972d9748$export$c5c788863b172cf1 = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        "data-id": "combinator-selector",
        "data-value": props.value,
        columns: [
            'label'
        ],
        variant: "raised",
        tone: "accent",
        items: [
            {
                label: 'AND',
                onClick: ()=>props.onChange('AND')
            },
            {
                label: 'OR',
                onClick: ()=>props.onChange('OR')
            }
        ]
    }, props.value);
};




const $1ec1a140db4e70b1$var$ITEM_HEIGHT = 40;
const $1ec1a140db4e70b1$var$BASE_CLASS_NAME = 'ab-QueryBuilder-predicate-editor';
const $1ec1a140db4e70b1$var$Handle = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: `${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}__handle twa:mr-1`,
        style: {
            height: $1ec1a140db4e70b1$var$ITEM_HEIGHT
        },
        alignItems: "center",
        ...props
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "drag"
    }));
const $1ec1a140db4e70b1$var$QueryPredicateButtons = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !props.hideAdd && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        listMinWidth: 150,
        columns: [
            'label'
        ],
        items: [
            {
                label: 'Condition',
                onClick: ()=>props.onNewPredicate('filter')
            },
            {
                label: 'AND / OR Group',
                onClick: ()=>props.onNewPredicate('group')
            }
        ],
        variant: "text"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "plus"
    })), !props.hideDelete && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        icon: "delete",
        variant: "text",
        onClick: ()=>{
            props.onChange(null);
        }
    }));
};
const $1ec1a140db4e70b1$var$LogicalFunctionEditor = (props)=>{
    const level = props.id.split('/').length - 1;
    const className = `
    ${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}
    ${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}-level-${level}
    ${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}-combinator
    ${props.lastChild ? `${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}--last-child` : ''}
    ${props.isRoot ? `${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}--root` : `${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}--child`}
  `;
    const getCombinatorEl = (handleProps, className)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e52d5c02f19d68ad$export$423ec2075359570a), {
            droppableId: props.id,
            type: props.id
        }, (provided, snapshot)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                ...provided.droppableProps,
                ref: provided.innerRef,
                className: className
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, props.isRoot ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ec1a140db4e70b1$var$Handle, {
                ...handleProps
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                className: "twa:flex-1",
                alignItems: "center",
                height: $1ec1a140db4e70b1$var$ITEM_HEIGHT
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37dd7dc6972d9748$export$c5c788863b172cf1), {
                value: props.predicate.operator,
                onChange: (combinator)=>{
                    props.onChange({
                        ...props.predicate,
                        operator: combinator
                    });
                }
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:flex-1"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ec1a140db4e70b1$var$QueryPredicateButtons, {
                hideDelete: props.isRoot,
                hideAdd: true,
                ...props
            }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: `${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}__children-wrapper`
            }, props.predicate.args.map((arg, index)=>{
                const id = `${props.id}/${index}`;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ec1a140db4e70b1$export$3697a60278fb98b2, {
                    key: id,
                    lastChild: index === props.predicate.args.length - 1,
                    index: index,
                    id: id,
                    predicate: arg,
                    onNewPredicate: (type)=>{
                        const newPredicate = {
                            operator: type === 'filter' ? undefined : 'AND',
                            args: []
                        };
                        if (typeof arg === 'object' && 'operator' in arg && (0, $caf1d59704029c8b$export$23543ecb1bb7aa64)(arg.operator)) {
                            // add as a child
                            const newArg = {
                                ...arg,
                                args: [
                                    ...arg.args,
                                    newPredicate
                                ]
                            };
                            const args = [
                                ...props.predicate.args
                            ];
                            args[index] = newArg;
                            props.onChange({
                                ...props.predicate,
                                args: args
                            });
                        } else {
                            // add as a sibling
                            const prevArgs = [
                                ...props.predicate.args
                            ];
                            prevArgs.splice(index + 1, 0, newPredicate);
                            props.onChange({
                                ...props.predicate,
                                args: prevArgs
                            });
                        }
                    },
                    onChange: (predicate)=>{
                        const args = [
                            ...props.predicate.args
                        ];
                        if (predicate) args[index] = predicate;
                        else args.splice(index, 1);
                        props.onChange({
                            ...props.predicate,
                            args: args
                        });
                    }
                });
            }), provided.placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: `${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}__root-actions`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ec1a140db4e70b1$var$QueryPredicateButtons, {
                ...props,
                hideDelete: true
            }))));
        });
    if (props.isRoot) return getCombinatorEl({
        className: className
    });
    else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1710e65dc30c5dd1$export$f2a139e5d18b9882), {
        key: props.id,
        draggableId: props.id,
        index: props.index
    }, (provided, snapshot)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ...provided.draggableProps,
            ref: provided.innerRef,
            className: className
        }, getCombinatorEl(provided.dragHandleProps));
    });
};
const $1ec1a140db4e70b1$var$PrimitiveFunctionEditor = (props)=>{
    // [handle] [column] [operator-dropdown] [...args] [delete-button] [plus-button]
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [columnOrFieldExpression, ...restOfArgs] = props.predicate.args;
    const columnOrField = columnOrFieldExpression;
    let columnOrFieldId = null;
    let columnOrFieldDataType = null;
    let columnInputDataType = null;
    let functionInputInputDataTypes = null;
    // Thsese are the type of inputs ommiting the column
    // [[column-data-type], number, number]
    let restOfFunctionInputDataTypes = [];
    if (columnOrField) {
        if (!(0, $d0ecd1a41f6b3c39$export$56d4a4c448a55b0d)(columnOrField)) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), null, "Expression must start with a column or a filed!");
        if (columnOrField.includes('FIELD')) {
            // we let the full expression so we can difirienciate between column and field
            columnOrFieldId = columnOrField;
            const fieldValue = (0, $2298f961f09270fa$export$15f8a217295250ab)(columnOrField);
            columnOrFieldDataType = adaptable.api.expressionApi.internalApi.getFieldType(fieldValue);
        } else if (columnOrField.includes('[')) {
            columnOrFieldId = columnOrField;
            const columnId = columnOrField.replace(/[\[\]]/g, '');
            columnOrFieldDataType = adaptable.api.columnApi.getColumnDataTypeForColumnId(columnId);
        }
        columnInputDataType = (0, $47be09cb14df4bdb$export$d252517300e3b104)(columnOrFieldDataType);
        functionInputInputDataTypes = (0, $759293e9f6921c8e$export$147a1738bbbef892)[props.predicate.operator]?.inputs;
        restOfFunctionInputDataTypes = functionInputInputDataTypes ? (0, $2298f961f09270fa$export$f89f94ec62712b0e)(columnInputDataType, functionInputInputDataTypes) : [];
    }
    const level = props.id.split('/').length - 1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1710e65dc30c5dd1$export$f2a139e5d18b9882), {
        key: props.id,
        draggableId: props.id,
        index: props.index
    }, (provided)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: `twa:pb-2 ${$1ec1a140db4e70b1$var$BASE_CLASS_NAME} ${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}-level-${level} ${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}-primitive ${props.lastChild ? `${$1ec1a140db4e70b1$var$BASE_CLASS_NAME}--last-child` : ''} `,
            ref: provided.innerRef,
            ...provided.draggableProps,
            style: {
                ...provided.draggableProps.style,
                minHeight: $1ec1a140db4e70b1$var$ITEM_HEIGHT
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ec1a140db4e70b1$var$Handle, {
            ...provided.dragHandleProps
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center",
            style: {
                height: $1ec1a140db4e70b1$var$ITEM_HEIGHT
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mr-2"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37dd7dc6972d9748$export$4a36de17a13d3a19), {
            onChange: (colOrField)=>{
                props.onChange({
                    ...props.predicate,
                    args: [
                        colOrField
                    ],
                    operator: null
                });
            },
            fieldOrColumn: columnOrFieldId
        })), columnOrFieldId && columnOrFieldDataType && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37dd7dc6972d9748$export$c741f3ac74bd2b6e), {
            dataType: columnOrFieldDataType,
            onExpressionChange: (operator)=>{
                let args = [
                    props.predicate.args[0]
                ];
                if (columnOrFieldDataType === 'boolean' && operator !== 'NOT') args = [
                    props.predicate.args[0],
                    'TRUE'
                ];
                props.onChange({
                    ...props.predicate,
                    operator: operator,
                    args: // discard arguments
                    args
                });
            },
            value: props.predicate.operator
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:flex-1 twa:ml-2"
        }, restOfFunctionInputDataTypes.map((type, index)=>{
            const key = type + index;
            const commonProps = {
                lefthandColumnIdParam: columnOrFieldId,
                inputType: type
            };
            if (type.includes('[]')) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37dd7dc6972d9748$export$a8b7ffabeef50918), {
                ...commonProps,
                key: key,
                value: restOfArgs,
                onChange: (values)=>{
                    const args = [
                        ...props.predicate.args.slice(0, 1),
                        ...values
                    ];
                    props.onChange({
                        ...props.predicate,
                        args: args
                    });
                }
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37dd7dc6972d9748$export$caf61155c790b8c0), {
                ...commonProps,
                key: key,
                value: restOfArgs[index] ?? null,
                onChange: (value)=>{
                    const args = [
                        ...props.predicate.args
                    ];
                    // +1 because col is the first argument
                    args[index + 1] = value;
                    props.onChange({
                        ...props.predicate,
                        args: args
                    });
                }
            });
        }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:flex-1"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ec1a140db4e70b1$var$QueryPredicateButtons, {
            ...props
        }));
    });
};
const $1ec1a140db4e70b1$export$3697a60278fb98b2 = (props)=>{
    if ((0, $caf1d59704029c8b$export$23543ecb1bb7aa64)(props.predicate.operator)) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ec1a140db4e70b1$var$LogicalFunctionEditor, {
        ...props
    });
    else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1ec1a140db4e70b1$var$PrimitiveFunctionEditor, {
        ...props
    });
};




const $0342e7e7247dede6$var$QUERY_BUILDER_CLASSNAME = 'ab-QueryBuilder';
const $0342e7e7247dede6$var$QueryBuilderContext = $acw62.createContext(null);
function $0342e7e7247dede6$export$ea4b06a5da3ad29c() {
    const context = $acw62.useContext($0342e7e7247dede6$var$QueryBuilderContext);
    if (!context) throw new Error('useQueryBuilderContext must be used within a QueryBuilderContext');
    return context;
}
const $0342e7e7247dede6$export$d24bb501ea7ded0b = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [qlPredicate, setQlPredicate] = $acw62.useState(()=>{
        const qlPredicate = (0, $d0ecd1a41f6b3c39$export$bf5e43697b4f5f9b)(props.query);
        return qlPredicate;
    });
    const [expressionStr, setExpressionStr] = $acw62.useState(props.query);
    const handleQlPredicateChange = (qlPredicate)=>{
        setQlPredicate(qlPredicate);
        if (qlPredicate && !('errorMessage' in qlPredicate)) {
            const newQuery = (0, $ea9af415e1458220$export$c0d18aa1f16e7003)(qlPredicate);
            props.onChange(newQuery);
            setExpressionStr(newQuery);
        }
    };
    const clearExpression = ()=>{
        const predicate = (0, $d0ecd1a41f6b3c39$export$bf5e43697b4f5f9b)('');
        setQlPredicate(predicate);
        setExpressionStr('');
        props.onChange('');
    };
    const booleanExpressions = $acw62.useMemo(()=>{
        const expressionMap = adaptable.api.internalApi.getQueryLanguageService().getModuleExpressionFunctionsMap(props.module);
        const booleanExpressions = {
            ...expressionMap.booleanFunctions
        };
        const booleanExpressionsWithoutCombinators = booleanExpressions;
        delete booleanExpressionsWithoutCombinators.AND;
        delete booleanExpressionsWithoutCombinators.OR;
        return booleanExpressionsWithoutCombinators;
    }, []);
    const context = $acw62.useMemo(()=>{
        return {
            getColumns: props.getColumns,
            getFields: props.getFields,
            getExpressions: (columnType)=>{
                return booleanExpressions ? (0, $2298f961f09270fa$export$f116df8bb841eabd)(columnType, Object.keys(booleanExpressions)) : [];
            },
            onQlPredicateChange: handleQlPredicateChange
        };
    }, []);
    const clearExpressionButton = $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onClick: ()=>{
            clearExpression();
        }
    }, "Clear Expression");
    const unsupportedExpressionFunction = (0, $2298f961f09270fa$export$795e5fe51e63f57c)(qlPredicate, {
        supportedFields: props.getFields()
    });
    let errorOrEditor = null;
    if (qlPredicate && 'errorMessage' in qlPredicate) errorOrEditor = props.query?.includes?.('QUERY') ? $acw62.createElement((0, $515d3b24b9de8c6a$export$5255389de52b07e9), {
        "data-name": "unsupported-query-warning"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, "Named Queries are not supported in the Query Builder", $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }), clearExpressionButton)) : $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, qlPredicate.errorMessage, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }), clearExpressionButton));
    else if (unsupportedExpressionFunction) errorOrEditor = $acw62.createElement((0, $515d3b24b9de8c6a$export$5255389de52b07e9), {
        "data-name": "unsupported-expression-warning"
    }, unsupportedExpressionFunction);
    else if (qlPredicate && !('errorMessage' in qlPredicate)) errorOrEditor = $acw62.createElement((0, $1ec1a140db4e70b1$export$3697a60278fb98b2), {
        isRoot: true,
        index: 0,
        id: "0",
        predicate: qlPredicate,
        onNewPredicate: (type)=>{
            // add to its children
            const newPredicate = {
                operator: type === 'filter' ? undefined : 'AND',
                args: []
            };
            handleQlPredicateChange({
                ...qlPredicate,
                args: [
                    ...qlPredicate.args,
                    newPredicate
                ]
            });
        },
        onChange: (predicate)=>{
            handleQlPredicateChange(predicate);
        }
    });
    return $acw62.createElement((0, $e52d5c02f19d68ad$export$237bd83162c14364), {
        onDragEnd: (result)=>{
            if (!result.destination) return;
            const toPath = `${result.destination.droppableId}/${result.destination.index}`;
            const fromPath = result.draggableId;
            const predicate = (0, $2298f961f09270fa$export$fc77a6137e3f91c)(qlPredicate, fromPath, toPath);
            handleQlPredicateChange(predicate);
        }
    }, $acw62.createElement($0342e7e7247dede6$var$QueryBuilderContext.Provider, {
        value: context
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: $0342e7e7247dede6$var$QUERY_BUILDER_CLASSNAME
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        "data-name": "query-builder-help",
        className: "twa:my-2 twa:p-2 twa:text-3"
    }, "Build the Grid Filter by adding Column Conditions and AND / OR Groups as required"), errorOrEditor, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        "data-name": "query-builder-expression-preview",
        variant: "default",
        header: "AdapTableQL Expression",
        className: "twa:mt-3"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: `${$0342e7e7247dede6$var$QUERY_BUILDER_CLASSNAME}__expression twa:min-h-[48px] twa:my-2 twa:p-3`
    }, expressionStr || 'Output Expression will display here')))));
};






const $5e4c4ab15f4fe7da$export$e0e193db4cb7689a = `ab-ExpressionEditor`;
function $5e4c4ab15f4fe7da$export$6f88ab97c822f23a(props) {
    const { type: type, module: module } = props;
    const [selectedFunction, setSelectedFunction] = (0, $acw62.useState)(null);
    const [expressionText, setExpressionText] = (0, $acw62.useState)(props.value);
    const { namedQuery: namedQuery, setNamedQuery: setNamedQuery } = (0, $52aad13a119b1140$export$f5481b544ced1ec)();
    const textAreaRef = (0, $acw62.useRef)(null);
    const allowSaveNamedQuery = props.allowSaveNamedQuery ?? type === 'boolean';
    const editorInput = type === 'observable' || type === 'aggregatedBoolean' ? $acw62.createElement((0, $b953599eea340c51$export$2e2bcd8739ae039), {
        type: type,
        module: module,
        value: props.value,
        onChange: (value)=>{
            setExpressionText(value);
            props.onChange(value);
        },
        testData: props.initialData,
        api: props.api
    }) : // 'boolean','scalar','aggregatedScalar'/'cumulativeAggregatedScalar'/'quantileAggregatedScalar'
    $acw62.createElement((0, $d039fb820aeab557$export$2e2bcd8739ae039), {
        type: type,
        module: module,
        value: props.value,
        onChange: (value)=>{
            setExpressionText(value);
            props.onChange(value);
        },
        testData: props.initialData,
        isFullExpression: props.isFullExpression,
        api: props.api
    });
    const adaptableFields = props.api.expressionApi.internalApi.getAvailableFields();
    // currently only boolean and scalar expressions support nested calculated columns (calc cols which reference other calc cols)
    const queryableColumns = type === 'scalar' || type === 'boolean' || type === 'aggregatedScalar' ? props.columns : props.columns.filter((c)=>!c.isCalculatedColumn);
    const showDocumentationLinks = props.api.internalApi.isDocumentationLinksDisplayed();
    // @Bogdan i did this to be sure but i think we can get rid of this as the button does the same (and better IMO)
    const showNamedQueryStuff = false;
    const queryDocumentationLink = $5e4c4ab15f4fe7da$var$queryDocumentationLinks[type];
    const saveAsNamedQueryElement = allowSaveNamedQuery && props.api.internalApi.getModuleService().getModuleById((0, $42e863194fcb493f$export$97c45942f844607e)).isModuleEditable() && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        className: "twa:mb-2 twa:text-3"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: !!namedQuery,
        onChange: (checked)=>{
            if (checked) setNamedQuery({
                Name: '',
                BooleanExpression: expressionText
            });
            else setNamedQuery(false);
        },
        className: "twa:mr-2 twa:items-center"
    }, "Save as new Named Query"), namedQuery ? $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        className: "twa:flex-1",
        onChange: (event)=>{
            const { target: { value: value } } = event;
            setNamedQuery({
                Name: value,
                BooleanExpression: expressionText
            });
        }
    }) : null);
    const editorElement = $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(`${$5e4c4ab15f4fe7da$export$e0e193db4cb7689a} twa:flex-1 twa:pl-2 twa:overflow-auto`, props.className),
        "data-name": "expression-editor-wrapper",
        style: props.style
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:flex-1",
        style: {
            minHeight: 0
        },
        flexDirection: "column",
        onFocus: (event)=>{
            if (event.target.tagName === 'TEXTAREA') textAreaRef.current = event.target;
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:flex-1 twa:text-2",
        flexDirection: "row",
        "data-name": "expression-editor",
        style: {
            minHeight: 0
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:flex-1 twa:pr-2 twa:overflow-auto twa:min-h-0",
        "data-name": "expression-builder",
        flexDirection: "column"
    }, editorInput, (0, $9OAZF.default).IsNotNullOrEmpty(expressionText?.trim()) && $acw62.createElement((0, $61fb4e8cba4dd5db$export$c0cddb00822729da), {
        expressionFunction: selectedFunction
    }), /* displayed for advanced queries (observable&Aggregation) to give the users a starting point */ (0, $9OAZF.default).IsNullOrEmpty(expressionText?.trim()) && $5e4c4ab15f4fe7da$var$renderQueryHints(type), showDocumentationLinks && $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        "data-name": "query-documentation",
        className: "twa:my-2 twa:p-2 twa:text-3"
    }, $acw62.createElement((0, $00c4532606fa3d4c$export$5a2ee34a0d054ab8), {
        className: "twa:mr-2",
        onClick: ()=>window.open(queryDocumentationLink, '_blank')
    }), "See documentation for more details and examples"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }), showNamedQueryStuff && saveAsNamedQueryElement), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: `${$5e4c4ab15f4fe7da$export$e0e193db4cb7689a}__sidebar twa:pb-2 twa:px-2 twa:overflow-auto twa:h-full twa:w-[280px]`,
        "data-name": "expression-sidebar"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:h-full twa:p-2 twa:rounded-standard twa:shadow-md twa:bg-defaultbackground twa:text-text-on-defaultbackground"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "column"
    }, "Columns"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "field"
    }, "Fields"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "named-query"
    }, "Named Queries"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        className: "twa:flex-1 twa:h-full"
    }, $acw62.createElement((0, $6be491887c9387cd$export$f82d7b079ca290ba), {
        type: "column",
        dataFormatter: (value)=>`[${value}]`,
        fields: queryableColumns.map((column)=>({
                label: column.friendlyName,
                value: column.columnId,
                dataType: column.dataType,
                readOnly: column.readOnly
            })),
        data: props.initialData
    })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, adaptableFields && adaptableFields.length > 0 ? $acw62.createElement((0, $6be491887c9387cd$export$f82d7b079ca290ba), {
        type: "field",
        labels: {
            showIds: 'Show Field path',
            filterPlaceholder: 'Filter fields...'
        },
        dataFormatter: (value)=>`FIELD("${value}")`,
        data: props.initialData,
        fields: adaptableFields?.map((field)=>({
                label: field.label,
                value: field.name,
                dataType: field.dataType,
                readOnly: true
            }))
    }) : $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, "No Data Fields provided")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, (0, $9g4SS.default).IsNullOrEmpty(props.namedQueries) ? $acw62.createElement("div", null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, "No Named Queries defined"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:p-2"
    }, "Named Queries are saved Expressions which can be referenced in other Expressions using the ", $acw62.createElement("i", null, "QUERY"), " keyword", ' ')) : $acw62.createElement((0, $0ddeb231b78d9e5d$export$f951ee90ca64a60), {
        namedQueries: props.namedQueries
    }))))))));
    const queryBuilderElement = $acw62.createElement((0, $0342e7e7247dede6$export$d24bb501ea7ded0b), {
        module: module,
        query: expressionText,
        onChange: (query)=>{
            setExpressionText(query);
            props.onChange(query);
        },
        getFields: (type)=>{
            return props.fields.filter((field)=>{
                if (!type) return field.dataType === 'text' || field.dataType === 'number' || field.dataType === 'boolean' || field.dataType === 'date';
                else return field.dataType === type;
            }).map((field)=>({
                    value: field.name,
                    label: field.label,
                    type: field.dataType
                }));
        },
        getColumns: (type)=>{
            return props.columns.filter((column)=>{
                if (!type) return column.dataType === 'text' || column.dataType === 'number' || column.dataType === 'boolean' || column.dataType === 'date';
                else return column.dataType === type;
            }).map((col)=>({
                    value: col.columnId,
                    label: col.friendlyName ?? col.columnId,
                    type: col.dataType
                }));
        }
    });
    const showQueryBuilder = props.showQueryBuilder ?? false;
    const showExpressionEditor = props.showExpressionEditor ?? true;
    return $acw62.createElement((0, $d2976bc2c0148451$export$29a956867f048fd9).Provider, {
        value: {
            selectedFunction: selectedFunction,
            setSelectedFunction: setSelectedFunction,
            textAreaRef: textAreaRef
        }
    }, (()=>{
        switch(true){
            case showQueryBuilder && showExpressionEditor:
                return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
                    "data-name": "editor-selector-tabs",
                    className: "twa:mb-2 twa:p-2 twa:min-h-0 twa:flex-1"
                }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
                    value: "editor"
                }, "Expression Editor"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
                    value: "ui"
                }, "Query Builder"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, editorElement), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                    flexDirection: "column",
                    className: "twa:h-full"
                }, queryBuilderElement, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                    className: "twa:flex-1"
                }), showNamedQueryStuff && saveAsNamedQueryElement)));
            case showQueryBuilder:
                return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                    flexDirection: "column",
                    className: "twa:p-2 twa:h-full"
                }, queryBuilderElement);
            case showExpressionEditor:
                return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                    flexDirection: "column",
                    className: "twa:p-2 twa:h-full"
                }, editorElement);
            default:
                return null;
        }
    })());
}
const $5e4c4ab15f4fe7da$var$renderQueryHints = (type)=>{
    const examples = [];
    if (type === 'observable') {
        examples.push({
            code: "ROW_CHANGE( COUNT([ItemCount],3), TIMEFRAME('5m'))",
            description: 'The Item Count value in a specific Row changes 3 times within a 5 minute timeframe'
        });
        examples.push({
            code: "GRID_CHANGE( MAX([OrderCost]), TIMEFRAME('1h')) WHERE [CustomerReference] = 'TRADH'",
            description: "An Order Cost cell contains its highest value in the whole Grid within the last hour - for rows where Cust Ref is 'TRADH'"
        });
    }
    if (type === 'aggregatedBoolean') {
        examples.push({
            code: 'SUM([PnL]) > 50000000',
            description: "The sum of the 'PnL' column values in all rows is greater than 5 Million"
        });
        examples.push({
            code: "SUM([PnL]) > '5B' WHERE QUERY('CurrencyDollar')",
            description: "The sum of the 'PnL' column values in all rows where named query 'CurrencyDollar' is evaluated to TRUE is greater than 5 Billions"
        });
    }
    if (type === 'aggregatedScalar') examples.push({
        code: 'AVG([stargazers_count], GROUP_BY([language]))',
        description: 'Average popularity (number of stars) of all the Github repositories, grouped by programming language'
    }, {
        code: 'MAX([PnL]), GROUP_BY([currency], [country])',
        description: "The maximum 'PnL' value, grouped by currency and country"
    });
    if (type === 'cumulativeAggregatedScalar') examples.push({
        code: 'CUMUL(AVG([stargazers_count], GROUP_BY([language])), OVER([TradeDate]))',
        description: "The cumulative average popularity (number of stars) of all the Github repositories, grouped by programming language in the order given by the 'TradeDate' column"
    }, {
        code: 'CUMUL( SUM([PnL]), OVER([TradeDate]))',
        description: "The cumulative sum of all 'PnL' columns in the order given by the 'TradeDate' column"
    });
    return examples.length ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "expression-hints",
        className: "twa:my-2 twa:p-2 twa:bg-primary twa:rounded-standard"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-2"
    }, $acw62.createElement("b", null, "Examples"), " (click on each to see its explanation):"), examples.map((example, index)=>$acw62.createElement("details", {
            key: index,
            className: "twa:mb-2"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:mr-2 twa:rounded-standard twa:mb-1 twa:text-2",
            alignItems: "center",
            as: "summary"
        }, $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), null, " ", example.code)), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:ml-3 twa:italic twa:text-2"
        }, example.description))))) : null;
};
const $5e4c4ab15f4fe7da$var$queryDocumentationLinks = {
    boolean: (0, $53c62e7ff907ad8d$export$f5c7639fe3b50c2),
    scalar: (0, $53c62e7ff907ad8d$export$6bee4ae4ed72a3a2),
    observable: (0, $53c62e7ff907ad8d$export$cb8ecca2196c506a),
    aggregatedBoolean: (0, $53c62e7ff907ad8d$export$ca49290a085ae96f),
    aggregatedScalar: (0, $53c62e7ff907ad8d$export$3f9e7d8c07a7d633),
    cumulativeAggregatedScalar: (0, $53c62e7ff907ad8d$export$7b3f99bbf2928c),
    quantileAggregatedScalar: (0, $53c62e7ff907ad8d$export$ff649e5dcba07647)
};








var $9OAZF = parcelRequire("9OAZF");



const $2f3f4595a0bb253f$export$4fbc2a914da22bb = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const gridFilterEditors = adaptable.api.optionsApi.getFilterOptions().gridFilterOptions.availableFilterEditors;
    return {
        showQueryBuilder: gridFilterEditors.includes('QueryBuilder'),
        showExpressionEditor: gridFilterEditors.includes('ExpressionEditor')
    };
};



const $84b744eb9b252e67$export$873f26b473f275fc = (props)=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [namedQuery, setNamedQuery] = $acw62.useState(null);
    const [expression, setExpression] = $acw62.useState(props.expression);
    const isExpressionValid = api.internalApi.getQueryLanguageService().validateBoolean(expression, (0, $42e863194fcb493f$export$4908330cb20abb96)).isValid;
    const isExistingNamedQuery = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).objectExists(api.namedQueryApi.getNamedQueries().find((q)=>q.BooleanExpression == expression));
    const initialData = $acw62.useMemo(()=>api.internalApi.getQueryPreviewData(), []);
    const namedQueryValidationError = namedQuery ? api.namedQueryApi.isValidNamedQuery(namedQuery).message : '';
    const hasNamedQueryError = (0, $9OAZF.IsNotNullOrEmpty)(namedQueryValidationError);
    const onRunQuery = (expression)=>{
        api.filterApi.gridFilterApi.setGridFilterExpression(expression);
    };
    const onClearExpression = ()=>{
        setExpression('');
        api.filterApi.gridFilterApi.clearGridFilter();
    };
    const onAddNamedQuery = (namedQuery)=>dispatch($f53463061a55e5a9$export$35d9816f002a20ec(namedQuery));
    const handleSaveQuery = ()=>{
        dispatch((0, $dc56b6267ce4d0bb$export$16bbb31452c12825)({
            Id: 'save_query_form',
            Form: {
                title: 'Save as Named Query',
                fields: [
                    {
                        name: 'name',
                        label: 'Name',
                        fieldType: 'text'
                    }
                ],
                buttons: [
                    {
                        label: 'Cancel',
                        buttonStyle: {
                            variant: 'text',
                            tone: 'none'
                        }
                    },
                    {
                        label: 'Save',
                        buttonStyle: {
                            variant: 'raised',
                            tone: 'accent'
                        },
                        disabled: (button, context)=>{
                            if (context.formData.name === '') return true;
                            const testQuery = {
                                Name: context.formData.name,
                                BooleanExpression: expression
                            };
                            const namedQueryValidationResult = api.namedQueryApi.isValidNamedQuery(testQuery);
                            if (!namedQueryValidationResult.valid) return true;
                        },
                        onClick: (button, context)=>{
                            onAddNamedQuery({
                                Name: context.formData.name,
                                BooleanExpression: expression
                            });
                        }
                    }
                ]
            }
        }));
    };
    const expressionEditorProps = (0, $2f3f4595a0bb253f$export$4fbc2a914da22bb)();
    const actionsDisabled = !isExpressionValid || (0, $9OAZF.IsNullOrEmpty)(expression) || hasNamedQueryError;
    return $acw62.createElement((0, $52aad13a119b1140$export$8e4378d5a5cc668b).Provider, {
        value: {
            namedQuery: namedQuery,
            setNamedQuery: (newQuery)=>{
                setNamedQuery(newQuery);
            }
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:h-full"
    }, $acw62.createElement((0, $5e4c4ab15f4fe7da$export$6f88ab97c822f23a), {
        ...expressionEditorProps,
        type: 'boolean',
        module: (0, $42e863194fcb493f$export$4908330cb20abb96),
        value: expression,
        onChange: (expression)=>setExpression(expression),
        initialData: initialData,
        columns: api.columnApi.internalApi.getQueryableColumnsForUIEditor(),
        fields: api.expressionApi.internalApi.getAvailableFields(),
        namedQueries: api.namedQueryApi.getNamedQueries(),
        api: api
    }), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        alignItems: "center",
        className: "twa:p-1"
    }, props.onDismiss && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        className: "twa:m-1",
        variant: "text",
        "data-name": "action-close",
        onClick: ()=>{
            props.onDismiss();
        }
    }, "CLOSE"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        disabled: actionsDisabled,
        onClick: handleSaveQuery,
        icon: "save"
    }, "Save Query"), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "action-clear",
        onClick: onClearExpression,
        icon: "close",
        disabled: (0, $9OAZF.IsNullOrEmpty)(expression),
        className: "twa:ml-1"
    }, "Clear Query"), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        variant: "raised",
        tone: "accent",
        "data-name": "action-run",
        className: "twa:m-1",
        icon: "play",
        onClick: ()=>{
            if (namedQuery) onAddNamedQuery({
                Name: namedQuery.Name,
                BooleanExpression: expression
            });
            onRunQuery(expression);
            props?.onDismiss?.();
        },
        disabled: actionsDisabled
    }, "Apply Grid Filter"))));
};


const $32d6c730b6e720aa$export$17331cac31519f5e = (props)=>{
    return $acw62.createElement((0, $84b744eb9b252e67$export$873f26b473f275fc), {
        expression: props.popupProps.value,
        onDismiss: props.onDismiss
    });
};



var $acw62 = parcelRequire("acw62");


const $5ac8517c58a55b4c$var$tableDOMProps = {
    style: {
        height: '100%',
        minWidth: '10rem',
        minHeight: 300
    }
};
const $5ac8517c58a55b4c$var$columnTypes = {
    default: {
        defaultFlex: 1
    }
};
const $5ac8517c58a55b4c$export$b9c100ec6c2a13e6 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const adaptableApi = adaptable.api;
    const primaryKey = adaptableApi.optionsApi.getPrimaryKey();
    const { hasPivotValue: hasPivotValue, rows: rows, rowGroups: rowGroups, columnId: columnId, layout: layout, aggColumn: aggColumn, pivotValue: pivotValue, pivotColumnId: pivotColumnId } = props.popupProps;
    let data = rows;
    const columns = $acw62.useMemo(()=>{
        const getFriendlyName = (columnId)=>adaptableApi.columnApi.getFriendlyNameForColumnId(columnId);
        const pivotPreviewOptionColumn = adaptableApi.optionsApi.getLayoutOptions()?.pivotPreviewColumns;
        let pivotPreviewExtraColumns = [];
        if (typeof pivotPreviewOptionColumn === 'function') {
            const pivotPreviewColumnsContext = {
                layout: layout,
                columnId: columnId,
                ...adaptableApi.internalApi.buildBaseContext()
            };
            pivotPreviewExtraColumns = pivotPreviewOptionColumn(pivotPreviewColumnsContext);
        } else if (Array.isArray(pivotPreviewOptionColumn)) pivotPreviewExtraColumns = pivotPreviewOptionColumn;
        let columns = {
            [primaryKey]: {
                field: primaryKey,
                header: getFriendlyName(primaryKey)
            }
        };
        if (hasPivotValue) {
            // pivot_license_MIT License_stargazers_count
            // splitting by _ does not work
            columns = {
                ...columns,
                [aggColumn]: {
                    field: aggColumn,
                    header: getFriendlyName(aggColumn)
                },
                [pivotColumnId]: {
                    field: pivotColumnId,
                    header: getFriendlyName(pivotColumnId)
                }
            };
            data = rows.filter((row)=>row?.[pivotColumnId] === pivotValue);
        } else columns = {
            ...columns,
            [columnId]: {
                field: columnId,
                header: getFriendlyName(columnId)
            }
        };
        const extraColumns = [];
        if (Array.isArray(rowGroups) && rowGroups.length > 0) extraColumns.push(...rowGroups);
        if (Array.isArray(pivotPreviewExtraColumns) && pivotPreviewExtraColumns.length > 0) extraColumns.push(...pivotPreviewExtraColumns);
        return {
            ...columns,
            ...extraColumns.reduce((acc, colId)=>({
                    ...acc,
                    [colId]: {
                        field: colId,
                        header: getFriendlyName(colId)
                    }
                }), {})
        };
    }, [
        props.popupProps
    ]);
    return $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
        data: data,
        primaryKey: columnId
    }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
        columnTypes: $5ac8517c58a55b4c$var$columnTypes,
        domProps: $5ac8517c58a55b4c$var$tableDOMProps,
        columns: columns
    }));
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



const $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f = (props)=>{
    const baseClassName = 'ab-Adaptable-Popup__Panel';
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:flex-1 twa:flex twa:flex-col twa:gap-3 twa:p-1', props.className, baseClassName, props.scrollable === false ? 'twa:overflow-hidden' : 'twa:overflow-auto')
    }, $acw62.createElement("div", {
        className: `${baseClassName}__Header twa:flex`
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mr-0",
        "data-name": "space-before"
    }), $acw62.createElement("div", {
        className: `${baseClassName}__Header__Title`
    }, props.headerText), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mr-2",
        "data-name": "space-after"
    }), props.infoLink != null && !props.infoLinkDisabled && $acw62.createElement((0, $00c4532606fa3d4c$export$5a2ee34a0d054ab8), {
        tone: "none",
        variant: "text",
        iconSize: 24,
        onClick: ()=>window.open(props.infoLink, '_blank' // <- opens the link in a new tab or window.
            )
    })), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }), props.button), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:w-full twa:flex twa:flex-col twa:flex-1 twa:min-h-0', `${baseClassName}__Body`, props.bodyClassName)
    }, props.children));
};





var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



var $11df18e2f038bad8$exports = {};
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    $11df18e2f038bad8$exports = factory();
})($11df18e2f038bad8$exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});





const $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3 = $acw62.forwardRef((props, ref)=>{
    const ColorPalette = props.api.userInterfaceApi.getColorPalette();
    let { api: api, value: value, includeAlpha: includeAlpha = true, ...restProps } = props;
    // Create a debounced version of onChange
    // we need this because moving the mouse A LOT in the custom color picker can break the React rendering
    const debouncedOnChange = (0, $acw62.useCallback)((0, $c34d1d35432b7498$export$2e2bcd8739ae039)((color)=>{
        props.onChange(color);
    }, 30), [
        props.onChange
    ]);
    // Clean up the debounce on unmount
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            debouncedOnChange.cancel();
        };
    }, [
        debouncedOnChange
    ]);
    const optionsMap = ColorPalette.reduce((acc, colorItem)=>({
            ...acc,
            [(0, $0f8018328b88def3$export$fb1c9088cfbed114)(colorItem)]: colorItem
        }), {});
    const ABcolorChoicesOptions = Object.keys(optionsMap).map((x)=>{
        return $acw62.createElement("option", {
            key: x,
            value: x
        }, x);
    });
    const ABcolorChoices = $acw62.createElement("datalist", {
        id: 'ABcolorChoices'
    }, ABcolorChoicesOptions);
    const preparedValue = $acw62.useMemo(()=>{
        const color = (0, $0f8018328b88def3$export$fb1c9088cfbed114)(value);
        return (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(color).toHexString();
    }, [
        value
    ]);
    const preparedAlphaColor = $acw62.useMemo(()=>{
        const color = (0, $0f8018328b88def3$export$fb1c9088cfbed114)(value);
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(color).setAlpha(0).toRgbString(),
            (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(color).setAlpha(1).toRgbString()
        ];
    }, [
        value
    ]);
    const rangeBackround = `linear-gradient(90deg, ${preparedAlphaColor[0]} 0%, ${preparedAlphaColor[1]} 100%)`;
    const alpha = (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(value).getAlpha();
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ColorPicker twa:items-center twa:gap-2', {
            'twa:opacity-30': props.disabled
        }, props.className)
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        ...restProps,
        disabled: props.disabled,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:w-[70px] twa:p-0', restProps.className),
        onChange: (event)=>{
            /**
                 * The value is not in the map when the color is not in the palette.
                 */ const color = optionsMap[event.target.value] ?? event.target.value;
            debouncedOnChange(color);
        },
        value: preparedValue,
        ref: ref,
        type: "color",
        list: "ABcolorChoices",
        title: props.title
    }), ABcolorChoices, includeAlpha && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:gap-1"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, "Opacity"), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:min-h-input"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        disabled: props.disabled,
        className: "ab-ColorPicker-range",
        style: {
            background: rangeBackround
        },
        value: alpha,
        onChange: (event)=>{
            const color = (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(value).setAlpha(event.target.value).toRgbString();
            debouncedOnChange(color);
        },
        min: 0,
        max: 1,
        step: 0.01,
        type: "range"
    }))));
});






const $f503e2c084588987$export$a455218a85c89869 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    let input = null;
    let value = props.value;
    const throttledOnChange = $acw62.useMemo(()=>{
        return (0, $3a4c9a3b92c4503b$export$2e2bcd8739ae039)((value)=>{
            props.onChange(value);
        }, 300);
    }, []);
    if (value === undefined) value = (0, $0f8018328b88def3$export$fb1c9088cfbed114)(`var(${props.variable})`);
    switch(props.type){
        case 'number':
            input = $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
                disabled: props.disabled,
                type: "number",
                onChange: (event)=>throttledOnChange(event.target.value),
                value: value
            });
            break;
        case 'color':
            input = $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
                disabled: props.disabled,
                includeAlpha: false,
                api: adaptable.api,
                value: value,
                onChange: (color)=>throttledOnChange(color)
            });
            break;
    }
    return $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: props.name
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, input, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        disabled: props.value === undefined,
        onClick: ()=>props.onChange(false)
    }, "Clear")));
};



var $acw62 = parcelRequire("acw62");




const $f3777d74af4eeee6$export$867776d444e5a870 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const systemTemes = adaptable.api.themeApi.getSystemThemes().filter((theme)=>theme.Name !== (0, $58846ea7f4156db7$export$9fa5d5f0144954cb));
    const options = systemTemes.map((theme)=>({
            label: theme.Description,
            value: theme.Name,
            onClick: ()=>props.onChange(theme.Name)
        }));
    const label = props.theme.Variant ? options.find((theme)=>theme.value === props.theme.Variant)?.label : 'Select a theme';
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        className: "twa:mr-2",
        columns: [
            'label'
        ],
        items: options,
        disabled: props.disabled
    }, label), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onClick: ()=>props.onChange(null),
        disabled: !props.theme.Variant || props.disabled,
        hidden: props.disabled,
        icon: "delete"
    }));
};




const $971426e1051e57e0$var$fields = [
    {
        name: 'Primary Color',
        type: 'color',
        variable: '--ab-color-primary'
    },
    {
        name: 'Primary Dark Color',
        type: 'color',
        variable: '--ab-color-primarydark'
    },
    {
        name: 'Primary Light Color',
        type: 'color',
        variable: '--ab-color-primarylight'
    },
    {
        name: 'Text on Primary Color',
        type: 'color',
        variable: '--ab-color-text-on-primary'
    },
    {
        name: 'Text on Primary Dark Color',
        type: 'color',
        variable: '--ab-color-text-on-primarydark'
    },
    {
        name: 'Default background',
        type: 'color',
        variable: '--ab-color-defaultbackground'
    },
    {
        name: 'Text Color on Default Background',
        type: 'color',
        variable: '--ab-color-text-on-defaultbackground'
    }
];
const $971426e1051e57e0$export$1468e1fe2dcb2807 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const allThemes = adaptable.api.themeApi.getUserThemes();
    const [currentThemeObject, setCurrentThemeObject] = $acw62.useState(()=>{
        return adaptable.api.themeApi.getCurrentThemeObject();
    });
    const currentThemeAccessLevel = (0, $792d5f2a0e72dfac$export$1cfd109f7705a424)(currentThemeObject, props.accessLevel);
    const currentThemeIsReadOnly = currentThemeAccessLevel !== 'Full';
    // THEME variables
    const themeVariables = currentThemeObject?.CSSVariables;
    const valuesFromTheme = $971426e1051e57e0$var$fields.reduce((acc, field)=>{
        if (themeVariables?.[field.variable]) acc[field.variable] = themeVariables?.[field.variable];
        return acc;
    }, {});
    $acw62.useEffect(()=>{
        setCurrentThemeObject(adaptable.api.themeApi.getCurrentThemeObject());
    }, [
        props.theme
    ]);
    // This is needed when clearing variables, so the new value is pickedup up from the document
    $acw62.useEffect(()=>{
        const updateTheme = ()=>{
            const theme = adaptable.api.themeApi.getCurrentThemeObject();
            setCurrentThemeObject({
                ...theme
            });
        };
        const themeChangedUnsubscribe = adaptable.api.eventApi.on('ThemeChanged', updateTheme);
        return ()=>{
            themeChangedUnsubscribe();
        };
    }, []);
    const handleNameDescriptionChangeThrottled = $acw62.useMemo(()=>{
        return (0, $3a4c9a3b92c4503b$export$2e2bcd8739ae039)((key, value)=>{
            const theme = adaptable.api.themeApi.getCurrentThemeObject();
            const newTheme = {
                ...theme,
                [key]: value
            };
            adaptable.api.themeApi.editTheme(newTheme);
        }, 600);
    }, []);
    const handleDescriptionChange = $acw62.useCallback((key, value)=>{
        setCurrentThemeObject((prev)=>({
                ...prev,
                [key]: value
            }));
        handleNameDescriptionChangeThrottled(key, value);
    }, []);
    const handleDeleteTheme = $acw62.useCallback(()=>{
        adaptable.api.themeApi.loadLightTheme();
        adaptable.api.themeApi.deleteUserTheme(currentThemeObject);
    }, []);
    const handleSaveName = ()=>{
        const name = currentThemeObject.Name;
        setCurrentThemeObject((prev)=>({
                ...prev,
                Name: name
            }));
        handleNameDescriptionChangeThrottled('Name', name);
    };
    const handleVariantChange = (variant)=>{
        const newTheme = {
            ...currentThemeObject
        };
        if (!variant) delete newTheme.Variant;
        else newTheme.Variant = variant;
        setCurrentThemeObject(newTheme);
        adaptable.api.themeApi.editTheme(newTheme);
    };
    const nameHasChanged = currentThemeObject.Name !== props.theme;
    const nameIsNotUnique = allThemes.some((theme)=>theme.Uuid !== currentThemeObject.Uuid && currentThemeObject.Name === theme.Name);
    const saveNameDisabled = !nameHasChanged || nameIsNotUnique || currentThemeObject.Name === '';
    return $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        header: $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center",
            className: "twa:w-full"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:flex-1"
        }, " Edit Custom Theme"), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "delete",
            accessLevel: currentThemeAccessLevel,
            icon: "delete",
            onClick: handleDeleteTheme,
            variant: "text"
        }))
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Theme Name"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        disabled: currentThemeIsReadOnly,
        className: "twa:mr-2",
        onChange: (event)=>setCurrentThemeObject({
                ...currentThemeObject,
                Name: event.target.value.replace(/ /g, '-')
            }),
        value: currentThemeObject.Name ?? ''
    }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onClick: handleSaveName,
        disabled: saveNameDisabled || currentThemeIsReadOnly,
        icon: "save",
        hidden: currentThemeIsReadOnly
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:mt-1"
    }, "The name cannot contain spaces."), nameIsNotUnique && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:text-error"
    }, "Name must be unique.")), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Description"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        disabled: currentThemeIsReadOnly,
        onChange: (event)=>handleDescriptionChange('Description', event.target.value),
        value: currentThemeObject?.Description ?? ''
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Variant"
    }, $acw62.createElement((0, $f3777d74af4eeee6$export$867776d444e5a870), {
        onChange: handleVariantChange,
        theme: currentThemeObject,
        disabled: currentThemeIsReadOnly
    })), $971426e1051e57e0$var$fields.map((field)=>{
        return $acw62.createElement((0, $f503e2c084588987$export$a455218a85c89869), {
            disabled: currentThemeIsReadOnly,
            key: field.name,
            type: field.type,
            name: field.name,
            value: valuesFromTheme[field.variable],
            variable: field.variable,
            onChange: (val)=>{
                // needs a fresh copy
                const currentThemeObject = adaptable.api.themeApi.getCurrentThemeObject();
                let newTheme = null;
                if (val === false) {
                    newTheme = {
                        ...currentThemeObject,
                        CSSVariables: {
                            ...currentThemeObject?.CSSVariables
                        }
                    };
                    delete newTheme.CSSVariables[field.variable];
                } else newTheme = {
                    ...currentThemeObject,
                    CSSVariables: {
                        ...currentThemeObject?.CSSVariables,
                        [field.variable]: val
                    }
                };
                setCurrentThemeObject(newTheme);
                adaptable.api.themeApi.editTheme(newTheme);
            }
        });
    })));
};






var $acw62 = parcelRequire("acw62");





const $e4b19c37008c87ef$export$17c20d206da56716 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const availableThemes = adaptable.api.themeApi.getThemes();
    const currentTheme = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Theme.CurrentTheme);
    const disabled = adaptable.api.entitlementApi.getEntitlementAccessLevelForModule((0, $42e863194fcb493f$export$ebf1703e41256059)) === 'ReadOnly';
    const optionThemes = availableThemes.map((theme)=>{
        if (typeof theme === 'string') // protection against old state, which could be string
        theme = {
            Name: theme,
            Description: theme
        };
        return {
            value: theme.Name,
            label: theme.Description
        };
    });
    return $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "aria-label": "Select Theme",
        "data-name": "select-theme-dropdown",
        options: optionThemes,
        value: currentTheme,
        disabled: disabled,
        size: props.size,
        onChange: (themeName)=>{
            dispatch($436d9a36bf9edcd8$export$1b9e02e625a724dc(themeName));
        }
    });
};



class $b63d155c7302e57f$var$ThemePopupComponent extends $acw62.Component {
    render() {
        const isCustomTheme = this.props.api.themeApi.getUserThemes().some((theme)=>theme.Name === this.props.CurrentTheme);
        const disabled = this.props.accessLevel === 'ReadOnly';
        const newButton = $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
            className: "twa:ml-2",
            disabled: disabled,
            tone: "accent",
            variant: "raised",
            columns: [
                'label'
            ],
            items: [
                {
                    label: 'Dark',
                    onClick: ()=>this.handleCreateNewTheme('dark')
                },
                {
                    label: 'Light',
                    onClick: ()=>this.handleCreateNewTheme('light')
                }
            ]
        }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
            name: "plus"
        }), " New");
        return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
            headerText: this.props.moduleInfo.FriendlyName,
            glyphicon: this.props.moduleInfo.Glyph,
            infoLink: this.props.moduleInfo.HelpPage,
            infoLinkDisabled: !this.props.api.internalApi.isDocumentationLinksDisplayed(),
            button: $acw62.createElement($acw62.Fragment, null, !this.props.hideShowInWindow && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
                icon: "open-in-new",
                onClick: ()=>{
                    this.props.api.themeApi.internalApi.openInWindow();
                }
            }), newButton)
        }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            label: "Current Theme:"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:max-w-[150px]"
        }, $acw62.createElement((0, $e4b19c37008c87ef$export$17c20d206da56716), null)))), isCustomTheme && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mt-3"
        }, $acw62.createElement((0, $971426e1051e57e0$export$1468e1fe2dcb2807), {
            accessLevel: this.props.accessLevel,
            theme: this.props.CurrentTheme
        })));
    }
    onChangeTheme(value) {
        this.props.SelectTheme(value);
    }
    handleCreateNewTheme = (variant)=>{
        let nthItem = this.props.UserThemes.length + 1;
        let name = 'Custom-Theme-' + nthItem;
        // make sure it is unique
        while(this.props.UserThemes.some((theme)=>theme.Name === name)){
            nthItem++;
            name = 'Custom-Theme-' + nthItem;
        }
        const newTheme = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyTheme(name);
        newTheme.Variant = variant;
        this.props.api.themeApi.addUserTheme(newTheme);
        this.props.api.themeApi.loadTheme(newTheme.Name);
    };
}
function $b63d155c7302e57f$var$mapStateToProps(state, ownProps) {
    return {
        CurrentTheme: state.Theme.CurrentTheme,
        UserThemes: state.Theme.UserThemes
    };
}
function $b63d155c7302e57f$var$mapDispatchToProps(dispatch) {
    return {
        SelectTheme: (newTheme)=>dispatch($436d9a36bf9edcd8$export$1b9e02e625a724dc(newTheme))
    };
}
let $b63d155c7302e57f$export$bf2dfc01c820b299 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($b63d155c7302e57f$var$mapStateToProps, $b63d155c7302e57f$var$mapDispatchToProps)($b63d155c7302e57f$var$ThemePopupComponent);



const $8a4272ec2887a9e4$export$6f8170d9c34fb5ac = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const moduleInfo = adaptable.ModuleService.getModuleInfoByModule('Theme');
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $b63d155c7302e57f$export$bf2dfc01c820b299), {
        hideShowInWindow: true,
        moduleInfo: moduleInfo,
        api: adaptable.api
    }));
};



var $acw62 = parcelRequire("acw62");








var $9OAZF = parcelRequire("9OAZF");
const $fa18b922d2770fa3$var$ADAPTABLE_CONTAINER_ID = 'transposed-adaptable-container';
const $fa18b922d2770fa3$var$AG_GRID_CONTAINER_ID = 'transposed-adaptable-ag-grid-container';
/** Field used for the first column in transposed grid (hidden, holds column id). */ const $fa18b922d2770fa3$var$TRANSPOSED_FIRST_COLUMN_FIELD = '_transposed_column_value';
/** Header used for the first visible column in transposed grid (shows friendly name). */ const $fa18b922d2770fa3$var$TRANSPOSED_FIRST_COLUMN_HEADER = '_transposed_column_header';
function $fa18b922d2770fa3$var$buildTransposedAdaptableOptions({ hostOptions: hostOptions, transposedRowsAndColumns: transposedRowsAndColumns, currentTheme: currentTheme }) {
    return {
        primaryKey: $fa18b922d2770fa3$var$TRANSPOSED_FIRST_COLUMN_FIELD,
        licenseKey: hostOptions.licenseKey,
        userName: `${hostOptions.userName}`,
        adaptableId: `${hostOptions.adaptableId}::TransposedView`,
        containerOptions: {
            adaptableContainer: $fa18b922d2770fa3$var$ADAPTABLE_CONTAINER_ID,
            agGridContainer: $fa18b922d2770fa3$var$AG_GRID_CONTAINER_ID
        },
        entitlementOptions: {
            defaultAccessLevel: 'Hidden'
        },
        initialState: {
            Layout: {
                Revision: Date.now(),
                CurrentLayout: 'TransposedView',
                Layouts: [
                    {
                        Name: 'TransposedView',
                        TableColumns: [
                            $fa18b922d2770fa3$var$TRANSPOSED_FIRST_COLUMN_HEADER,
                            ...transposedRowsAndColumns.transposedColumns.map((c)=>c.colId)
                        ],
                        ColumnPinning: {
                            [$fa18b922d2770fa3$var$TRANSPOSED_FIRST_COLUMN_HEADER]: 'left'
                        },
                        AutoSizeColumns: true
                    }
                ]
            },
            Theme: {
                CurrentTheme: currentTheme
            }
        }
    };
}
function $fa18b922d2770fa3$var$buildTransposedGridOptions({ transposedRowsAndColumns: transposedRowsAndColumns, elevatedColumnId: elevatedColumnId, adaptableApi: adaptableApi }) {
    const firstColumn = {
        field: $fa18b922d2770fa3$var$TRANSPOSED_FIRST_COLUMN_HEADER,
        headerName: adaptableApi.columnApi.getFriendlyNameForColumnId(elevatedColumnId)
    };
    return {
        loading: false,
        defaultColDef: {
            floatingFilter: false,
            filter: false,
            sortable: true,
            resizable: true,
            enableRowGroup: false,
            editable: false,
            enablePivot: false,
            enableValue: false,
            lockPinned: true,
            menuTabs: [],
            width: 120
        },
        columnDefs: [
            {
                field: $fa18b922d2770fa3$var$TRANSPOSED_FIRST_COLUMN_FIELD,
                hide: true
            },
            firstColumn,
            ...transposedRowsAndColumns.transposedColumns.map((col)=>({
                    field: col.colId,
                    headerName: col.header
                }))
        ],
        rowData: transposedRowsAndColumns.transposedRows,
        sideBar: false
    };
}
const $fa18b922d2770fa3$export$26cfde6f6e10b593 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const primaryKey = adaptable.api.optionsApi.getPrimaryKey();
    const rawConfig = props.popupProps ?? {};
    const transposeConfig = {
        transposedColumnId: rawConfig.transposedColumnId ?? primaryKey,
        hideTransposedColumn: rawConfig.hideTransposedColumn ?? true,
        columnsToTranspose: rawConfig.columnsToTranspose,
        rowsToTranspose: rawConfig.rowsToTranspose
    };
    const rowNodes = $acw62.useMemo(()=>{
        let transposableRowNodes = [];
        const rowsToTranspose = transposeConfig.rowsToTranspose;
        if (rowsToTranspose === 'VisibleOnly') return adaptable.api.gridApi.getVisibleRowNodes();
        if (rowsToTranspose === 'All') return adaptable.api.gridApi.getAllRowNodes();
        if ((0, $9OAZF.default).IsNotNullOrEmpty(rowsToTranspose)) {
            adaptable.api.gridApi.getAllRowNodes().forEach((rn)=>{
                const shouldTransposeRow = adaptable.api.internalApi.getQueryLanguageService().evaluateBooleanExpression(rowsToTranspose, (0, $42e863194fcb493f$export$2bc329d2b6ae03ac), rn);
                if (shouldTransposeRow) transposableRowNodes.push(rn);
            });
            return transposableRowNodes;
        }
        return adaptable.api.gridApi.getAllRowNodes();
    }, [
        transposeConfig.rowsToTranspose,
        adaptable.api
    ]);
    const [elevatedColumnId, setElevatedColumnIdState] = $acw62.useState(()=>transposeConfig.transposedColumnId ?? primaryKey);
    const setElevatedColumnId = (newElevatedColumnId)=>{
        transposedAdaptableApiRef.current?.destroy({
            unmount: true,
            destroyAgGrid: true
        });
        setElevatedColumnIdState(newElevatedColumnId);
    };
    const transposedAdaptableApiRef = $acw62.useRef(null);
    const columns = $acw62.useMemo(()=>{
        const allUIColumns = adaptable.api.columnApi.getUIAvailableColumns();
        const columnsToTranspose = transposeConfig.columnsToTranspose;
        if (!columnsToTranspose) return allUIColumns;
        const columnIds = typeof columnsToTranspose === 'function' ? columnsToTranspose({
            ...adaptable.api.internalApi.buildBaseContext(),
            columns: allUIColumns
        }) : columnsToTranspose;
        return columnIds.map((c)=>adaptable.api.columnApi.getColumnWithColumnId(c)).filter((col)=>col != null);
    }, [
        transposeConfig.columnsToTranspose,
        adaptable.api
    ]);
    /**
     * Build transposed structure: original rows become columns (colId = primaryKey value),
     * original columns become rows. Each transposed row has the column id/header plus
     * one cell per original row keyed by primaryKey value.
     */ const transposedRowsAndColumns = $acw62.useMemo(()=>{
        const transposedColumns = [];
        const transposedRows = [];
        for (const row of rowNodes){
            const colId = adaptable.api.gridApi.getNormalisedValueFromRowNode(row, primaryKey) + '';
            const header = adaptable.api.gridApi.getNormalisedValueFromRowNode(row, elevatedColumnId) + '';
            transposedColumns.push({
                colId: colId,
                header: header
            });
        }
        for (const column of columns){
            if (transposeConfig.hideTransposedColumn && column.columnId === elevatedColumnId) continue;
            const transposedRow = {
                [$fa18b922d2770fa3$var$TRANSPOSED_FIRST_COLUMN_FIELD]: column.columnId,
                [$fa18b922d2770fa3$var$TRANSPOSED_FIRST_COLUMN_HEADER]: column.friendlyName
            };
            for (const row of rowNodes){
                const key = adaptable.api.gridApi.getNormalisedValueFromRowNode(row, primaryKey);
                let value = adaptable.api.gridApi.getDisplayValueFromRowNode(row, column.columnId);
                if (value instanceof Date) value = value.toLocaleString();
                transposedRow[key] = value;
            }
            transposedRows.push(transposedRow);
        }
        return {
            transposedColumns: transposedColumns,
            transposedRows: transposedRows
        };
    }, [
        rowNodes,
        primaryKey,
        elevatedColumnId,
        columns,
        transposeConfig.hideTransposedColumn,
        adaptable.api
    ]);
    $acw62.useEffect(()=>{
        const hostOptions = adaptable.adaptableOptions;
        const adaptableOptions = $fa18b922d2770fa3$var$buildTransposedAdaptableOptions({
            hostOptions: hostOptions,
            transposedRowsAndColumns: transposedRowsAndColumns,
            currentTheme: adaptable.api.themeApi.getCurrentTheme()
        });
        const gridOptions = $fa18b922d2770fa3$var$buildTransposedGridOptions({
            transposedRowsAndColumns: transposedRowsAndColumns,
            elevatedColumnId: elevatedColumnId,
            adaptableApi: adaptable.api
        });
        const modules = adaptable.agGridModulesAdapter.getAgGridRegisteredModules();
        (0, $2c60780b406d81af$export$a19c58cdd10e13f7)._initInternal({
            variant: 'vanilla',
            adaptableOptions: adaptableOptions,
            gridOptions: gridOptions,
            modules: modules
        }).then((adaptableApi)=>{
            transposedAdaptableApiRef.current = adaptableApi;
            adaptableApi.eventApi.on('ThemeChanged', (event)=>{
                transposedAdaptableApiRef.current?.themeApi.loadTheme(typeof event.theme === 'object' ? event.theme.Name : event.theme);
            });
        });
    }, [
        elevatedColumnId,
        adaptable
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            requestAnimationFrame(()=>{
                transposedAdaptableApiRef.current?.destroy({
                    unmount: true,
                    destroyAgGrid: true
                });
            });
        };
    }, []);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:w-full twa:h-full"
    }, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Elevated Column"
    }, $acw62.createElement((0, $568d00bde2c337b2$export$e5d989eba9e871bb), {
        value: elevatedColumnId,
        onChange: setElevatedColumnId
    })))), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:h-full"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        id: $fa18b922d2770fa3$var$ADAPTABLE_CONTAINER_ID
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:h-full twa:w-full",
        id: $fa18b922d2770fa3$var$AG_GRID_CONTAINER_ID
    })));
};



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
const $ecbee8ce6dd7383f$export$89f99c33853c4e80 = (operator, qlPredicateDefs)=>{
    const predicateDef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!operator) return null;
        return qlPredicateDefs.find((predicateDef)=>predicateDef.operator === operator) ?? null;
    }, [
        operator
    ]);
    return predicateDef;
};



var $acw62 = parcelRequire("acw62");






function $46949004880f344f$var$debounceOrImmediate(fn, time) {
    return time && time > 0 ? (0, $c34d1d35432b7498$export$2e2bcd8739ae039)(fn, time) : fn;
}
const $46949004880f344f$export$55a68ee1697fccf6 = (props)=>{
    const { type: type, value: value, onChange: onChangeProp, onClear: onClearProp, disabled: disabled, onKeyDown: onKeyDown, filterType: filterType, usePrimitiveInputs: usePrimitiveInputs = true, columnId: columnId } = props;
    const [liveValue, setLiveValue] = $acw62.useState(value);
    const [hasFocus, setHasFocus] = $acw62.useState(false);
    const onFocus = (0, $acw62.useCallback)(()=>{
        setHasFocus(true);
    }, []);
    const onBlur = (0, $acw62.useCallback)(()=>{
        setHasFocus(false);
    }, []);
    $acw62.useEffect(()=>{
        // only update if the input is not focused
        // eg: value coming from a sidebar filter
        // should be reflected in the input
        // but if the input is focused, it means the user is typing
        // so we don't want to update the input value from the outside (from state)
        // but we leave liveValue as is in the local component state
        if (!hasFocus) setLiveValue(value);
    }, [
        value,
        hasFocus
    ]);
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const filterOptions = adaptable.api.optionsApi.getFilterOptions();
    const debounceTime = filterOptions.columnFilterOptions.quickFilterDebounce;
    const showDatePicker = filterOptions.showDatePicker;
    const onChange = $acw62.useMemo(()=>{
        return $46949004880f344f$var$debounceOrImmediate((value)=>{
            //@ts-ignore
            onChangeProp(value);
        }, debounceTime);
    }, [
        onChangeProp,
        debounceTime
    ]);
    // the onClear needs to have the same debounce time as the onChange
    const onClear = $acw62.useMemo(()=>{
        return $46949004880f344f$var$debounceOrImmediate(()=>{
            onClearProp();
        }, debounceTime);
    }, [
        onClearProp,
        debounceTime
    ]);
    if (type === 'boolean') return $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        checked: value === 'checked' ? true : value === 'unchecked' ? false : null,
        onChange: (checked)=>{
            // sequence: 'checked' -> 'unchecked' -> 'all' -> 'checked'
            const newCheckedValue = value === 'unchecked' && checked === true ? 'all' : checked === true ? 'checked' : 'unchecked';
            onChange(newCheckedValue);
        }
    });
    const onKeyDownCapture = (e)=>{
        if (e.nativeEvent.key === 'Escape') {
            e.nativeEvent.preventDefault();
            e.nativeEvent.stopPropagation();
            onClear();
            setLiveValue('');
        }
    };
    if (type === 'date' && !showDatePicker) return $acw62.createElement((0, $6e2f54bb4aae0ec6$export$8c838888ab805244), {
        "data-name": "floating-filter-input",
        value: liveValue,
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        className: "twa:border-none twa:pr-0",
        onKeyDownCapture: onKeyDownCapture,
        onChange: (value)=>{
            onChange(value);
            setLiveValue(value);
        }
    });
    if (usePrimitiveInputs === false && (type === 'number' || type === 'text')) // we use the permitted values selector
    return $acw62.createElement((0, $280aaa838d007117$export$266b893610128c75), {
        allowNewValues: true,
        searchable: 'inline',
        value: liveValue,
        columnId: columnId,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: (value)=>{
            if (value == undefined) {
                onClear();
                setLiveValue('');
            } else {
                // @ts-ignore
                onChange(value);
                setLiveValue(value);
            }
        }
    });
    return $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        style: filterType === 'floating' ? {
            width: '100%',
            padding: 'var(--ab-base-space)',
            borderRadius: 0,
            border: 'none'
        } : {},
        "data-name": "floating-filter-input",
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: disabled,
        type: type === 'number' ? 'text' : type,
        // autoFocus has to be FALSE because if the input receives focus in the init phase,
        // it may scroll the AG Grid header viewport into view and de-synchronize it (relative to the content viewport)
        autoFocus: false,
        value: liveValue ?? '',
        onKeyDown: onKeyDown,
        showClearButton: false,
        className: "twa:flex-1",
        onChange: (e)=>{
            const prevValue = `${liveValue}`;
            const value = e.target.value;
            if (value) {
                if (type === 'number') {
                    let numericValue = parseFloat(value);
                    let liveValue = numericValue;
                    if (isNaN(numericValue)) {
                        numericValue = null;
                        liveValue = null;
                        if (value === '-') liveValue = value;
                    } else {
                        const prevValueHasSeparator = prevValue.includes('.');
                        const newValueEndsWithSeparator = value.endsWith('.');
                        const newValueStartsWithSeparator = value.startsWith('.');
                        const newValueEndsWithZero = value.endsWith('0');
                        const separatorCount = (value.match(/[.,]/g) || []).length;
                        if (prevValueHasSeparator && separatorCount > 1) // not a valid number
                        return;
                        if (newValueEndsWithSeparator) {
                            const valueWithoutLastChar = value.slice(0, -1);
                            if (numericValue === parseFloat(valueWithoutLastChar)) liveValue = value;
                        }
                        if (newValueEndsWithZero) liveValue = value;
                        if (newValueStartsWithSeparator) {
                            if (numericValue === parseFloat('0' + value)) liveValue = value;
                        }
                    }
                    onChange(numericValue);
                    setLiveValue(liveValue);
                } else {
                    onChange(value);
                    setLiveValue(value);
                }
            } else {
                onClear();
                setLiveValue('');
            }
        },
        onKeyDownCapture: onKeyDownCapture
    });
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $9OAZF = parcelRequire("9OAZF");





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



const $865d58ec90236075$var$columns = {
    label: {
        field: 'label',
        header: 'Label',
        defaultFlex: 1,
        renderTreeIcon: true,
        renderSelectionCheckBox: true,
        defaultSortable: false
    }
};
const $865d58ec90236075$var$domProps = {
    className: 'ab-TreeList twa:flex-1 twa:h-full'
};
const $865d58ec90236075$var$DEFAULT_TREE_EXPAND_STATE = {
    expandedPaths: [],
    defaultExpanded: false
};
function $865d58ec90236075$export$b47751c5f451ac82(props) {
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: 'column',
        className: "ab-TreeList twa:flex-1",
        style: props.style
    }, $acw62.createElement((0, $88ab1a78ec8ca4b4$export$d2f9abb45e45a117), {
        data: props.options,
        primaryKey: props.primaryKey ?? 'id',
        defaultTreeSelection: props.defaultTreeSelection,
        treeSelection: props.treeSelection,
        onTreeSelectionChange: props.onTreeSelectionChange,
        treeFilterFunction: props.treeFilterFunction,
        onTreeExpandStateChange: props.onTreeExpandStateChange,
        defaultTreeExpandState: props.defaultTreeExpandState ?? $865d58ec90236075$var$DEFAULT_TREE_EXPAND_STATE
    }, $acw62.createElement((0, $88ab1a78ec8ca4b4$export$8db26091c27bd60d), {
        defaultActiveRowIndex: 0,
        onReady: props.onReady,
        debugId: props.debugId,
        keyboardSelection: true,
        rowHeight: props.rowHeight ?? '--ab-grid-row-height',
        keyboardNavigation: "row",
        columnHeaderHeight: props.columnHeaderHeight,
        domProps: {
            ...$865d58ec90236075$var$domProps,
            ...props.domProps,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($865d58ec90236075$var$domProps.className, props.domProps?.className),
            style: {
                ...$865d58ec90236075$var$domProps.style,
                ...props.domProps?.style
            }
        },
        columns: props.columns ?? $865d58ec90236075$var$columns,
        showZebraRows: false
    })));
}




var $acw62 = parcelRequire("acw62");

const $6173273a15a25ee1$var$RO = (0, $75d3ff690e6aacd4$export$86591c89cff5b471)();
const $6173273a15a25ee1$var$NotifyResize = (props)=>{
    const domRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!$6173273a15a25ee1$var$RO) return;
        const ro = new $6173273a15a25ee1$var$RO((entries)=>{
            const entry = entries[0];
            if (entry) {
                const { width: width, height: height } = entry.contentRect;
                props.onResize({
                    width: width,
                    height: height
                });
            }
        });
        const domNode = domRef.current;
        ro.observe(domNode);
        return ()=>{
            if (domNode) ro.unobserve(domNode);
        };
    }, []);
    return $acw62.createElement("div", {
        ref: domRef,
        style: {
            visibility: 'hidden',
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0
        }
    });
};
var $6173273a15a25ee1$export$2e2bcd8739ae039 = $6173273a15a25ee1$var$NotifyResize;







var $acw62 = parcelRequire("acw62");
const $f6d4bee1ecdd9375$export$d4b699e2c1148419 = (value)=>{
    const ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return (0, $acw62.useCallback)(()=>ref.current, []);
};





const $079c261764928e29$var$resizableDirections = {
    right: true,
    bottom: true,
    bottomRight: true
};
function $079c261764928e29$export$fdc9b494dd0b3396(value) {
    if (!Array.isArray(value)) return `${value}`;
    return value.map((v)=>Array.isArray(v) ? v.join('-') : v).join(', ');
}
const $079c261764928e29$var$getLabelColumn = (field, { includeExpandCollapseButton: includeExpandCollapseButton })=>{
    return {
        field: field,
        defaultFlex: 1,
        renderTreeIcon: true,
        defaultSortable: false,
        resizable: false,
        renderSelectionCheckBox: ({ rowInfo: rowInfo, dataSourceApi: dataSourceApi, api: api })=>{
            if (!rowInfo.isTreeNode) return null;
            return $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                className: "twa:mx-1",
                checked: rowInfo?.rowSelected,
                onChange: (checked)=>{
                    dataSourceApi.treeApi.setNodeSelection(rowInfo.nodePath, checked);
                    api.focus();
                }
            });
        },
        renderHeader: ({ dataSourceApi: dataSourceApi, api: api, allRowsSelected: allRowsSelected, someRowsSelected: someRowsSelected })=>{
            const { treeApi: treeApi } = dataSourceApi;
            const allFirstLevelCollapsed = dataSourceApi.getOriginalDataArray().every((item)=>!treeApi.isNodeExpanded([
                    item.id
                ]));
            return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                flexDirection: 'row',
                alignItems: 'center',
                className: "twa:w-full",
                onMouseDown: (e)=>{
                    // so we can keep the focus on the Grid
                    e.preventDefault();
                }
            }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                checked: someRowsSelected && !allRowsSelected ? null : allRowsSelected,
                className: "twa:mr-2",
                onChange: ()=>{
                    if (allRowsSelected) dataSourceApi.treeApi.deselectAll();
                    else dataSourceApi.treeApi.selectAll();
                    api.focus();
                }
            }, allRowsSelected ? '(Deselect All)' : '(Select All)'), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                className: "twa:flex-1"
            }), includeExpandCollapseButton ? $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
                label: "toggle-expand-collapse",
                icon: allFirstLevelCollapsed ? 'expand-all' : 'collapse-all',
                onMouseDown: ()=>{
                    if (allFirstLevelCollapsed) dataSourceApi.treeApi.expandAll();
                    else dataSourceApi.treeApi.collapseAll();
                },
                iconPosition: "end"
            }) : null);
        }
    };
};
const $079c261764928e29$var$sizeFull = {
    width: '100%',
    height: '100%'
};
function $079c261764928e29$var$getRowCount(options) {
    return options.reduce((acc, option)=>{
        if (Array.isArray(option.children)) return acc + $079c261764928e29$var$getRowCount(option.children) + 1;
        return acc + 1;
    }, 0);
}
function $079c261764928e29$export$b696aa5026055202(props) {
    const [visible, doSetVisible] = (0, $acw62.useState)(false);
    const overlayDOMRef = (0, $acw62.useRef)(null);
    const getProps = (0, $f6d4bee1ecdd9375$export$d4b699e2c1148419)(props);
    const computedCSSVars = (0, $599140a53e2e68e7$export$8760aa589cf5cb86)();
    const [treeExpandState, setTreeExpandState] = (0, $acw62.useState)(undefined);
    const [searchValue, setSearchValue] = (0, $acw62.useState)('');
    const labelField = props.labelField ?? 'label';
    const [stateValue, setStateValue] = (0, $acw62.useState)(props.value !== undefined ? props.value : props.defaultValue || []);
    const onChange = (0, $acw62.useCallback)((value)=>{
        const paths = value instanceof (0, $88ab1a78ec8ca4b4$export$3feed6aa923fae79) ? value.getState().selectedPaths : value.selectedPaths || [];
        if (props.value === undefined) setStateValue(paths);
        props.onChange?.(paths);
    }, [
        props.onChange,
        props.value
    ]);
    const value = props.value !== undefined ? props.value : stateValue;
    const treeSelection = (0, $acw62.useMemo)(()=>{
        const selection = {
            defaultSelection: false,
            selectedPaths: value
        };
        return selection;
    }, [
        value
    ]);
    const rowCount = (0, $acw62.useMemo)(()=>{
        return $079c261764928e29$var$getRowCount(props.options);
    }, [
        props.options
    ]);
    const hasChildren = rowCount > props.options.length;
    const columns = (0, $acw62.useMemo)(()=>{
        return {
            label: $079c261764928e29$var$getLabelColumn(labelField, {
                includeExpandCollapseButton: hasChildren
            })
        };
    }, [
        labelField,
        hasChildren
    ]);
    const [size, setSize] = (0, $acw62.useState)({
        width: 0,
        height: rowCount * 35
    });
    const setHeight = (0, $acw62.useCallback)((height)=>{
        setSize((s)=>{
            return {
                ...s,
                height: height
            };
        });
    }, []);
    const setWidth = (0, $acw62.useCallback)((width)=>{
        setSize((s)=>{
            return {
                ...s,
                width: width
            };
        });
    }, []);
    const getSize = (0, $f6d4bee1ecdd9375$export$d4b699e2c1148419)(size);
    (0, $acw62.useEffect)(()=>{
        if (!getSize().height) setHeight(rowCount * 35);
    }, [
        rowCount
    ]);
    const setVisible = (visible)=>{
        if (visible) {
            const { onMenuOpen: onMenuOpen } = getProps();
            if (onMenuOpen) onMenuOpen();
            requestAnimationFrame(()=>{
                doSetVisible(visible);
            });
        } else {
            const { onMenuClose: onMenuClose } = getProps();
            if (onMenuClose) onMenuClose();
            doSetVisible(visible);
        }
    };
    const [treeListApi, setTreeListApi] = (0, $acw62.useState)(null);
    const { listSizeConstraints: listSizeConstraints } = props;
    const nodeMatches = (0, $acw62.useCallback)(({ data: data })=>{
        return !searchValue ? data : `${data[labelField]}`.toLowerCase().includes(searchValue.toLowerCase());
    }, [
        searchValue
    ]);
    const filterFunction = (0, $acw62.useCallback)(({ data: data, filterTreeNode: filterTreeNode })=>{
        if (!Array.isArray(data.children)) return nodeMatches({
            data: data
        });
        // allow non-leaf nodes to match
        if (nodeMatches({
            data: data
        })) return data;
        return filterTreeNode(data);
    }, [
        nodeMatches
    ]);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: 'row',
        className: "ab-TreeDropdown twa:w-full",
        style: props.style,
        onMouseDown: props.onMouseDown,
        onBlur: (e)=>{
            const { relatedTarget: relatedTarget } = e;
            const overlayDOMNode = overlayDOMRef.current;
            if (overlayDOMNode && relatedTarget == overlayDOMNode || overlayDOMNode?.contains(relatedTarget)) return;
            setVisible(false);
        }
    }, $acw62.createElement((0, $6173273a15a25ee1$export$2e2bcd8739ae039), {
        onResize: (newSize)=>{
            setWidth(newSize.width);
        }
    }), $acw62.createElement((0, $c9ce1fb924ab724e$export$2e2bcd8739ae039), {
        visible: visible,
        targetOffset: 20,
        alignPosition: [
            // overlay - target
            [
                'TopLeft',
                'BottomLeft'
            ],
            [
                'TopRight',
                'BottomRight'
            ],
            [
                'BottomLeft',
                'TopLeft'
            ],
            [
                'BottomRight',
                'TopRight'
            ]
        ],
        render: ()=>{
            const minWidth = listSizeConstraints?.minWidth || computedCSSVars['--ab-cmp-select-menu__min-width'] || 240;
            const maxWidth = listSizeConstraints?.maxWidth || computedCSSVars['--ab-cmp-select-menu__max-width'] || '60vw';
            const minHeight = listSizeConstraints?.minHeight || 200;
            const maxHeight = listSizeConstraints?.maxHeight || computedCSSVars['--ab-cmp-select-menu__max-height'] || '50vh';
            const resizable = getProps().resizable;
            const treeListStyle = resizable ? {
                ...$079c261764928e29$var$sizeFull
            } : {
                width: size.width,
                height: size.height,
                maxWidth: maxWidth,
                minHeight: minHeight,
                maxHeight: maxHeight,
                minWidth: minWidth
            };
            if (!hasChildren) // @ts-ignore - don't leave any space for the > expand icon, as there are no children
            treeListStyle['--infinite-group-row-column-nesting'] = 'calc(var(--ab-base-space) * 2)';
            const treeList = $acw62.createElement((0, $865d58ec90236075$export$b47751c5f451ac82), {
                primaryKey: props.primaryKey ?? 'id',
                treeFilterFunction: filterFunction,
                columnHeaderHeight: 30,
                onReady: ({ api: api })=>{
                    setTreeListApi(api);
                    api.focus();
                },
                defaultTreeExpandState: treeExpandState,
                onTreeExpandStateChange: setTreeExpandState,
                columns: columns,
                options: props.options,
                treeSelection: treeSelection,
                onTreeSelectionChange: (0, $88ab1a78ec8ca4b4$export$aa6afc0444c40e88)(onChange),
                style: treeListStyle
            });
            let children = $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                flexDirection: 'column',
                className: "twa:h-full"
            }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                className: "twa:bg-defaultbackground twa:p-1 twa:items-center twa:justify-stretch twa:justify-items-stretch"
            }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
                "data-name": "menulist-search-input",
                placeholder: "Search...",
                style: {
                    width: '100%'
                },
                value: searchValue,
                onChange: (e)=>setSearchValue(e.target.value)
            })), treeList);
            if (resizable) {
                const onResizeStop = (_e, _direction, ref)=>{
                    const newSize = {
                        width: ref.style.width,
                        height: ref.style.height
                    };
                    setSize(newSize);
                };
                children = $acw62.createElement((0, $7b0f618bf8d2ec2e$export$e82068809229c83c), {
                    enable: $079c261764928e29$var$resizableDirections,
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight,
                    defaultSize: size,
                    onResizeStop: onResizeStop,
                    onResizeStart: (e)=>{
                        // in order to prevent focus from being lost
                        e.preventDefault();
                    }
                }, children);
            }
            return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                ref: overlayDOMRef,
                className: "ab-TreeDropdownOverlay",
                "data-name": "menu-container",
                style: {
                    fontSize: 'var(--ab-cmp-select__font-size)'
                }
            }, children);
        }
    }, $acw62.createElement((0, $952730cad4910d4d$export$2e2bcd8739ae039), {
        style: props.fieldStyle,
        className: "twa:w-full"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        type: "text",
        readOnly: true,
        "data-name": "Select Values",
        "aria-expanded": visible,
        placeholder: props.placeholder ?? 'Select a value',
        className: `twa:w-full ${props.clearable ? 'twa:pr-0' : ''}`,
        value: props.toDisplayValue ? props.toDisplayValue(value) : $079c261764928e29$export$fdc9b494dd0b3396(value),
        onFocus: ()=>{
            if (!visible) setVisible(true);
            treeListApi?.focus();
        }
    }), props.clearable && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        style: {
            visibility: Array.isArray(value) && value.length > 0 ? 'visible' : 'hidden'
        },
        variant: "text",
        icon: "close",
        onClick: ()=>onChange({
                selectedPaths: []
            })
    }))));
}




const $fe8e9fe7bf831ca5$var$baseClassName = 'ab-ListBoxFilterForm';
// used for displaying the date values in the input
function $fe8e9fe7bf831ca5$var$toDateDisplayValue(values) {
    values = values.map((v)=>{
        if (!Array.isArray(v)) return v;
        return v[v.length - 1];
    });
    return (0, $079c261764928e29$export$fdc9b494dd0b3396)(values);
}
const $fe8e9fe7bf831ca5$var$dateOnChangeParser = (value)=>{
    /**
     * the value looks like this:
     * [
     *  ["2021","2021-01","2021-01-01"],
     *  ["2024","2024-02","2024-02-15T12:34:00"],
     * ]
     */ // so first need to transfor the above to this:
    /**
     * [
     *  [2023, 12, 1, 1640668800000],
     *  [2023, 12, 3, 1738377600000]
     * ]
     */ return value.map((v)=>{
        return v[v.length - 1];
    });
};
const $fe8e9fe7bf831ca5$var$EMPTY_ARRAY = [];
const $fe8e9fe7bf831ca5$export$5558c43cb64dbe0a = (props)=>{
    const column = props.column;
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    let selectedColumnValues = props.value || $fe8e9fe7bf831ca5$var$EMPTY_ARRAY;
    const optionsFromProps = Array.isArray(props.options) ? props.options : $fe8e9fe7bf831ca5$var$EMPTY_ARRAY;
    const value = [];
    if (column.dataType === 'date') {
        // we might have a use-case where users might want to get rid of a tree level
        // because it may contain only one child. currently,
        // the value is an array of strings that have this form (ISOish)
        // ["2021-01-01", "2021-10-02", "2021-01-03T12:00:00"]
        // but we want the full path to each value
        // but we can't compute that by simply splitting the strings by '-' or 'T',
        // as if we do that, then we won't support removing a tree level
        // so we have to compute the paths based on the options
        const valueToPath = (0, $acw62.useMemo)(()=>{
            const valueToPath = new Map();
            const withOption = (option, parentPath = [])=>{
                const optionPath = [
                    ...parentPath,
                    option.value
                ];
                valueToPath.set(option.value, optionPath);
                if (Array.isArray(option.children)) option.children.forEach((child)=>withOption(child, optionPath));
            };
            optionsFromProps.forEach((option)=>withOption(option, []));
            return valueToPath;
        }, [
            optionsFromProps
        ]);
        selectedColumnValues = selectedColumnValues.map((v)=>{
            return valueToPath.get(v);
        }).filter(Boolean);
    }
    const options = column.dataType === 'date' || column.columnId === (0, $58846ea7f4156db7$export$1fadf36dae8ed962) ? optionsFromProps : optionsFromProps.filter((distinctValue)=>{
        let isActive = selectedColumnValues.indexOf(distinctValue.value) >= 0;
        // special case for date objects, need to check against string values
        if (!isActive && distinctValue.value && distinctValue.value instanceof Date) isActive = selectedColumnValues.some((dateStr)=>(0, $7a7e68b5aa0b9077$export$248d38f6296296c5)((0, $eccba2ee7b674d85$export$220ff045e4b830ec)(dateStr), (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(distinctValue.value)));
        if ((0, $9OAZF.StringExtensions).IsNullOrEmpty(distinctValue.value)) return false;
        if (isActive) value.push(distinctValue.value);
        return true;
    });
    const menuStyle = $acw62.useMemo(()=>{
        return {
            minWidth: `var(--ab-cmp-select-column-menu-${column.columnId}__min-width, var(--ab-cmp-select-column-menu__min-width, 160px))`
        };
    }, [
        column.columnId
    ]);
    const component = column.dataType === 'date' || column.columnId === (0, $58846ea7f4156db7$export$1fadf36dae8ed962) ? $acw62.createElement((0, $079c261764928e29$export$b696aa5026055202), {
        style: {
            width: '100%',
            height: '100%',
            ...props.selectProps?.styles?.container
        },
        toDisplayValue: column.dataType === 'date' ? $fe8e9fe7bf831ca5$var$toDateDisplayValue : undefined,
        fieldStyle: {
            boxShadow: 'none',
            ...props.selectProps?.styles?.control
        },
        resizable: true,
        onChange: column.dataType === 'date' ? (value)=>props.onChange($fe8e9fe7bf831ca5$var$dateOnChangeParser(value)) : props.onChange,
        options: options,
        // for dates, the treeDateOptions have ids that are numbers
        // so we have to add the `toDateValue` function to convert the values to the correct format
        value: selectedColumnValues,
        primaryKey: 'value',
        onMenuOpen: props.onMenuOpen,
        onMouseDown: (e)=>e.stopPropagation()
    }) : $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        key: "select",
        isMulti: true,
        resizable: true,
        showHeaderSelectionCheckbox: true,
        searchable: 'menulist',
        closeMenuOnSelect: false,
        menuStyle: menuStyle,
        ...props.selectProps,
        onMenuOpen: props.onMenuOpen,
        options: options,
        value: value,
        isLoading: props.isLoading,
        onChange: props.onChange
    });
    return $acw62.createElement("div", {
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)($fe8e9fe7bf831ca5$var$baseClassName, props.isLoading && `${$fe8e9fe7bf831ca5$var$baseClassName}--loading`, !value.length && `${$fe8e9fe7bf831ca5$var$baseClassName}--empty`),
        onKeyDownCapture: (e)=>{
            const event = e.nativeEvent || e;
            event.stopPropagation = ()=>{
            // see #ensure-keyboard-navigation-works-in-column-values-filter
            // we want to prevent ag grid from stopping the propagation of the event
            // so that the event can be handled by the select component and thus makes keyboard navigation work
            //
            // the solution is to reassign the stopPropagation method to a function that does nothing
            };
        }
    }, component);
};



const $318e9b87498d2460$var$onceFlags = {};
const $318e9b87498d2460$var$logOnce = (message, loggingFn)=>{
    if ($318e9b87498d2460$var$onceFlags[message]) return;
    loggingFn(message);
    $318e9b87498d2460$var$onceFlags[message] = true;
};
const $318e9b87498d2460$var$renderSingleValue = (option)=>{
    return option.label;
};
const $318e9b87498d2460$var$renderMultipleValues = (values, options)=>{
    const { focused: focused, placeholder: placeholder } = options;
    const text = values.map($318e9b87498d2460$var$renderSingleValue).join(', ');
    return values.length ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement("span", {
        "data-name": "multiple-values-count"
    }, "(", values.length, ")"), " ", text) : focused ? null : placeholder ?? 'Select...';
};
function $318e9b87498d2460$export$e833de850ac6ad56(options) {
    const { columnId: columnId, searchValueRef: searchValueRef } = options;
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [valuesLoadTrigger, setValuesLoadTrigger] = $acw62.useState(0);
    const usePreviousValuesProbablyBecauseOfAGGridUnnecessaryFilterRemountRef = $acw62.useRef(false);
    const triggerValuesLoad = $acw62.useCallback((options)=>{
        usePreviousValuesProbablyBecauseOfAGGridUnnecessaryFilterRemountRef.current = !!options?.usePrevious;
        setValuesLoadTrigger((prev)=>prev + 1);
    }, []);
    const [quickFilterValues, setQuickFilterValues] = $acw62.useState({
        values: [],
        dataLoadIsComplete: false,
        skipDefaultSearch: false,
        searchValueUsedInFilterValue: false
    });
    const [isDistinctColumnValuesLoading, setIsDistinctColumnValuesLoading] = $acw62.useState(false);
    (0, $acw62.useEffect)(()=>{
        if (valuesLoadTrigger === 0) // skip the first render
        return;
        let ignore = false;
        setIsDistinctColumnValuesLoading(true);
        let searchValueUsedInFilterValue = false;
        const columnFilterInternalApi = api.filterApi.columnFilterApi.internalApi;
        let promise = undefined;
        if (usePreviousValuesProbablyBecauseOfAGGridUnnecessaryFilterRemountRef.current) {
            const previousResult = columnFilterInternalApi.getAdaptableFilterHandler(columnId)?.getLastCachedFilterDisplayValues();
            if (previousResult) promise = Promise.resolve(previousResult);
        }
        usePreviousValuesProbablyBecauseOfAGGridUnnecessaryFilterRemountRef.current = false;
        if (!promise) promise = columnFilterInternalApi.getColumnFilterValues({
            columnId: columnId,
            get currentSearchValue () {
                searchValueUsedInFilterValue = true;
                return searchValueRef ? searchValueRef.current : '';
            }
        });
        promise.then((distinctFilterDisplayValues)=>{
            if (ignore) return;
            const values = distinctFilterDisplayValues.values;
            setQuickFilterValues({
                values: values,
                dataLoadIsComplete: true,
                skipDefaultSearch: !!distinctFilterDisplayValues.skipDefaultSearch,
                searchValueUsedInFilterValue: searchValueUsedInFilterValue
            });
            setIsDistinctColumnValuesLoading(false);
        });
        return ()=>{
            ignore = true;
        };
    }, [
        valuesLoadTrigger,
        columnId
    ]);
    return {
        isDistinctColumnValuesLoading: isDistinctColumnValuesLoading,
        quickFilterValues: quickFilterValues,
        setQuickFilterValues: setQuickFilterValues,
        triggerValuesLoad: triggerValuesLoad
    };
}
const $318e9b87498d2460$export$2dda419fd76e4cf1 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    // const evaluateInPredicateUsingTime = useAdaptableOptions(
    //   (options) => options.predicateOptions.evaluateInPredicateUsingTime
    // );
    const currentColumn = api.columnApi.getColumnWithColumnId(props.columnId);
    const searchValueRef = $acw62.useRef('');
    const { isDistinctColumnValuesLoading: isDistinctColumnValuesLoading, quickFilterValues: quickFilterValues, triggerValuesLoad: triggerValuesLoad } = $318e9b87498d2460$export$e833de850ac6ad56({
        columnId: props.columnId,
        searchValueRef: searchValueRef
    });
    const valueRef = $acw62.useRef(props.value);
    (0, $acw62.useEffect)(()=>{
        // we used to load values initially on mount, without any condition
        const value = valueRef.current;
        // but we now optimize it - if there are no values to show (for which we would need a label)
        // then we skip it altogether, so we'll only load onMenuOpen
        if (!value || !Array.isArray(value) || value.length === 0) return;
        // see 😅 usePreviousValuesProbablyBecauseOfAGGridUnnecessaryFilterRemountRef 😅
        const filterHandler = api.filterApi.columnFilterApi.internalApi.getAdaptableFilterHandler(props.columnId);
        const usePrevious = filterHandler && typeof filterHandler.getLastCachedFilterDisplayValues === 'function' ? !!filterHandler.getLastCachedFilterDisplayValues() : false;
        // however, if the `value` prop is a non-empty array, we need to load the values
        // so we know which labels to show
        triggerValuesLoad({
            usePrevious: usePrevious
        });
    }, []);
    const quickFilterValuesRef = $acw62.useRef(quickFilterValues);
    quickFilterValuesRef.current = quickFilterValues;
    (0, $acw62.useEffect)(()=>{
        // since we did the optimization above,
        // we now hit a scenario where the value is set via an API method
        // so we also need to account for that - so whenever props.value changes, we need to check
        // and if we previously didn't have a valid array
        // and now we do, we need to load the values - if they are not already loaded
        if (quickFilterValuesRef.current.values.length > 0 || quickFilterValuesRef.current.dataLoadIsComplete) // values have already been loaded, so we can skip
        return;
        const currentValue = props.value;
        const prevValue = valueRef.current;
        valueRef.current = currentValue;
        const prevValid = Array.isArray(prevValue) && prevValue.length > 0;
        const currentValid = Array.isArray(currentValue) && currentValue.length > 0;
        if (!currentValid) return;
        if (!prevValid && currentValid) triggerValuesLoad();
    }, [
        props.value
    ]);
    const onMenuOpen = triggerValuesLoad;
    const onInputChange = $acw62.useCallback((value)=>{
        searchValueRef.current = value;
        const quickFilterValues = quickFilterValuesRef.current;
        if (quickFilterValues.searchValueUsedInFilterValue || quickFilterValues.skipDefaultSearch) triggerValuesLoad();
    }, []);
    const { skipDefaultSearch: skipDefaultSearch } = quickFilterValues;
    if (props.columnId === (0, $58846ea7f4156db7$export$1fadf36dae8ed962)) {
        if (Array.isArray(props.value) && !props.value.every((value)=>Array.isArray(value))) $318e9b87498d2460$var$logOnce(`All the inputs for the IN predicate for the column "${props.columnId}" need to be arrays. Example:
{
  PredicateId: 'In',
  Inputs: [
      ['United States'],
      ['Canada'],
      ['United Kingdom', 'England'],
  ]
}
`, (msg)=>console.warn(msg));
    }
    return $acw62.createElement((0, $fe8e9fe7bf831ca5$export$5558c43cb64dbe0a), {
        selectProps: props.inline ? {
            ...props.selectProps,
            'data-name': 'Select Values',
            renderMultipleValues: $318e9b87498d2460$var$renderMultipleValues,
            isClearable: false,
            skipDefaultFiltering: skipDefaultSearch,
            styles: {
                dropdownIndicator: {
                    display: 'none'
                },
                container: {
                    height: '100%',
                    fontWeight: 'normal'
                },
                control: {
                    height: '100%',
                    borderRadius: 'none',
                    border: 'none',
                    // @ts-ignore ignore
                    '&:hover': {
                        border: 'none'
                    }
                },
                ...props.value?.length ? {
                    valueContainer: {
                        fontWeight: 'var(--ab-cmp-floatingfilter-selected-options-text__font-weight)'
                    }
                } : {}
            },
            onInputChange: onInputChange
        } : {
            ...props.selectProps,
            skipDefaultFiltering: skipDefaultSearch,
            onInputChange: onInputChange
        },
        disabled: props.disabled,
        onMenuOpen: onMenuOpen,
        isLoading: isDistinctColumnValuesLoading,
        column: currentColumn,
        dataType: currentColumn.dataType,
        options: quickFilterValues.values,
        value: props.value,
        onChange: props.onChange
    });
};


const $dc383303b0d79e8d$export$aa5385cf5372fb1 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const columnType = $acw62.useMemo(()=>{
        return api.columnApi.getColumnDataTypeForColumnId(props.columnId);
    }, [
        props.columnId
    ]);
    const predicateDef = (0, $ecbee8ce6dd7383f$export$89f99c33853c4e80)(props.predicate?.operator, props.predicateDefs);
    const fnTypeInput = (0, $47be09cb14df4bdb$export$d252517300e3b104)(columnType);
    const matchingInputs = predicateDef ? (0, $2298f961f09270fa$export$f89f94ec62712b0e)(fnTypeInput, predicateDef?.inputs, true) : [];
    const debouncedPredicateChange = $acw62.useCallback((0, $c34d1d35432b7498$export$2e2bcd8739ae039)((predicate)=>{
        props.onPredicateChange(predicate);
    }, 300), [
        props.predicate,
        props.columnId
    ]);
    if ([
        'date[]',
        'number[]',
        'text[]'
    ].includes(matchingInputs[0])) return $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        bodyProps: {
            className: 'twa:p-0'
        },
        className: "twa:w-full twa:rounded-sm twa:border-none twa:p-0"
    }, $acw62.createElement((0, $318e9b87498d2460$export$2dda419fd76e4cf1), {
        inline: false,
        columnId: props.columnId,
        disabled: props.disabled,
        onClear: ()=>{
            props.onPredicateChange({
                operator: props.predicate.operator,
                args: []
            });
        },
        onChange: (inputs)=>{
            props.onPredicateChange({
                operator: props.predicate.operator,
                args: inputs
            });
        },
        value: props.predicate.args,
        // are not known ql operators for now
        // should change when porting, it has knoladge about predicates
        type: props.predicate.operator === 'In' ? 'In' : 'NotIn'
    }));
    return $acw62.createElement($acw62.Fragment, null, (matchingInputs ?? []).map((input, index)=>{
        const value = props?.predicate?.args?.[index];
        return $acw62.createElement((0, $46949004880f344f$export$55a68ee1697fccf6), {
            columnId: props.columnId,
            usePrimitiveInputs: false,
            key: index,
            disabled: props.disabled,
            type: input,
            value: value,
            onKeyDown: props.onKeyDown,
            onClear: ()=>{
                const args = [
                    ...props.predicate.args
                ];
                args.splice(index, 1);
                const newPredicate = {
                    operator: props.predicate.operator,
                    args: args
                };
                debouncedPredicateChange(newPredicate);
            },
            onChange: (value)=>{
                const newPredicate = {
                    operator: props.predicate.operator,
                    args: [
                        ...props.predicate.args
                    ]
                };
                newPredicate.args[index] = value;
                debouncedPredicateChange(newPredicate);
            }
        });
    }));
};







var $acw62 = parcelRequire("acw62");


const $5b60d09ab87a9230$export$2a3e9a3fb4fb4111 = (adaptablePredicateDef, // used to determine values type
dataType)=>{
    let icon = null;
    if ((0, $9200d8ae4e589d35$export$1e5112454390929b)(adaptablePredicateDef.icon)) icon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
        icon: adaptablePredicateDef.icon
    });
    else if (adaptablePredicateDef.icon && 'text' in adaptablePredicateDef.icon) icon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
        children: adaptablePredicateDef.icon.text
    });
    const inputs = (adaptablePredicateDef?.inputs ?? [])?.map((input)=>{
        return input.type;
    });
    if (adaptablePredicateDef.id === 'In' || adaptablePredicateDef.id === 'NotIn') {
        if ([
            'text',
            'number',
            'date'
        ].includes(dataType)) // add array type
        inputs.push(`${dataType}[]`);
        if ([
            'text[]',
            'number[]'
        ].includes(dataType)) // add array type
        inputs.push(dataType);
    }
    const qlPredicateDef = {
        operator: adaptablePredicateDef.id,
        label: adaptablePredicateDef.label ?? adaptablePredicateDef.id,
        icon: icon,
        inputs: inputs,
        toString: (params)=>adaptablePredicateDef.label
    };
    if (adaptablePredicateDef.hasOwnProperty('toString')) qlPredicateDef.toString = adaptablePredicateDef.toString;
    return qlPredicateDef;
};
const $5b60d09ab87a9230$export$eb4621c6c8be25ee = (adaptablePredicate)=>{
    return {
        operator: adaptablePredicate.PredicateId,
        args: adaptablePredicate.Inputs
    };
};
const $5b60d09ab87a9230$export$acf229288e9f8eb6 = (qlPredicate)=>{
    return {
        PredicateId: qlPredicate.operator,
        Inputs: qlPredicate.args
    };
};
const $5b60d09ab87a9230$export$d9937b4f0cd29482 = (qlPredicate, predicateDefs)=>{
    if (typeof qlPredicate === 'object' && 'operator' in qlPredicate && (qlPredicate.operator === 'AND' || qlPredicate.operator === 'OR')) // save to join args because there is no extra nesting
    return qlPredicate.args.filter((str)=>str).map((arg)=>$5b60d09ab87a9230$export$d9937b4f0cd29482(arg, predicateDefs)).join(` ${qlPredicate.operator} `);
    const predicateDef = predicateDefs.find((predicateDef)=>predicateDef.operator === qlPredicate.operator);
    if (!predicateDef) return qlPredicate.operator;
    if (!predicateDef) return qlPredicate.operator;
    if (!predicateDef.hasOwnProperty('toString')) return predicateDef.label;
    const str = predicateDef.toString({
        inputs: (qlPredicate.args || []).filter((arg)=>arg != undefined)
    });
    return str;
};
const $5b60d09ab87a9230$export$80f23550cb973ada = (predicate, predicateDef)=>{
    if (!predicateDef?.inputs || predicateDef.inputs.length === 0) return false;
    return !predicate || !predicate.args || predicate.args.length === 0 || predicate.args.every((arg)=>arg == undefined);
};
const $5b60d09ab87a9230$export$685906aad993c4d6 = (columnFilter, abColumn, qlPredicateDefs, columnFilterOptions, filterComponent, api)=>{
    const combinator = columnFilter?.PredicatesOperator ?? 'AND';
    const qlPredicate = {
        operator: combinator,
        args: (columnFilter?.Predicates ?? []).map?.($5b60d09ab87a9230$export$eb4621c6c8be25ee)
    };
    if (qlPredicate.args.length === 0) {
        // used when none is defined
        let defaultQlPredicate = null;
        switch(abColumn.dataType){
            case 'number':
                let defaultQlNumberPredicate;
                const defaultNumericColumnFilter = columnFilterOptions.defaultNumericColumnFilter;
                if (defaultNumericColumnFilter) {
                    if (typeof defaultNumericColumnFilter === 'function') {
                        const context = {
                            column: abColumn,
                            filterComponent: filterComponent,
                            ...api.internalApi.buildBaseContext()
                        };
                        defaultQlNumberPredicate = defaultNumericColumnFilter(context);
                    } else defaultQlNumberPredicate = defaultNumericColumnFilter;
                }
                defaultQlPredicate = defaultQlNumberPredicate ? {
                    operator: defaultQlNumberPredicate,
                    args: []
                } : {
                    operator: 'Equals',
                    args: []
                };
                break;
            case 'text':
                let defaultQlTextPredicate;
                const defaultTextColumnFilter = columnFilterOptions.defaultTextColumnFilter;
                if (defaultTextColumnFilter) {
                    if (typeof defaultTextColumnFilter === 'function') {
                        const context = {
                            column: abColumn,
                            filterComponent: filterComponent,
                            ...api.internalApi.buildBaseContext()
                        };
                        defaultQlTextPredicate = defaultTextColumnFilter(context);
                    } else defaultQlTextPredicate = defaultTextColumnFilter;
                }
                defaultQlPredicate = defaultQlTextPredicate ? {
                    operator: defaultQlTextPredicate,
                    args: []
                } : {
                    operator: 'Contains',
                    args: []
                };
                break;
            case 'date':
                let defaultQlDatePredicate;
                const defaultDateColumnFilter = columnFilterOptions.defaultDateColumnFilter;
                if (defaultDateColumnFilter) {
                    if (typeof defaultDateColumnFilter === 'function') {
                        const context = {
                            column: abColumn,
                            filterComponent: filterComponent,
                            ...api.internalApi.buildBaseContext()
                        };
                        defaultQlDatePredicate = defaultDateColumnFilter(context);
                    } else defaultQlDatePredicate = defaultDateColumnFilter;
                }
                defaultQlPredicate = defaultQlDatePredicate ? {
                    operator: defaultQlDatePredicate,
                    args: []
                } : {
                    operator: 'On',
                    args: []
                };
                break;
            case 'boolean':
                defaultQlPredicate = {
                    operator: 'BooleanToggle',
                    args: []
                };
                break;
            case 'textArray':
            case 'numberArray':
                let defaultQlArrayPredicate;
                const defaultArrayColumnFilter = columnFilterOptions.defaultArrayColumnFilter;
                if (defaultArrayColumnFilter) {
                    if (typeof defaultArrayColumnFilter === 'function') {
                        const context = {
                            column: abColumn,
                            filterComponent: filterComponent,
                            ...api.internalApi.buildBaseContext()
                        };
                        defaultQlArrayPredicate = defaultArrayColumnFilter(context);
                    } else defaultQlArrayPredicate = defaultArrayColumnFilter;
                }
                defaultQlPredicate = defaultQlArrayPredicate ? {
                    operator: defaultQlArrayPredicate,
                    args: []
                } : {
                    operator: 'In',
                    args: []
                };
                break;
        }
        if (defaultQlPredicate === null) // take the firstavailable one
        {
            if (qlPredicateDefs.length > 0) defaultQlPredicate = {
                operator: qlPredicateDefs[0].operator,
                args: []
            };
        }
        if (defaultQlPredicate) qlPredicate.args = [
            defaultQlPredicate
        ];
    }
    return qlPredicate;
};





const $82b30489994e43b2$var$ColumnFilterPredicateDropdown = (props)=>{
    const predicateDef = (0, $ecbee8ce6dd7383f$export$89f99c33853c4e80)(props.predicate?.operator, props.predicateDefs);
    const options = props.predicateDefs.map((predicateDef)=>{
        return {
            label: $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:flex twa:items-center"
            }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
                variant: "raised",
                className: "twa:mr-2",
                tone: "accent"
            }, predicateDef.icon), predicateDef.label),
            value: predicateDef.operator
        };
    });
    const operator = props.predicate?.operator;
    const isAndOr = operator === 'AND' || operator === 'OR';
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex twa:items-center ab-ColumnFilterPredicateDropdown",
        style: {
            //@ts-ignore ignore
            '--ab-cmp-input__background': 'var(--ab-color-primary)'
        }
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        className: predicateDef ? `twa:min-w-[10rem]` : null,
        onChange: (value)=>{
            props.onPredicateChange({
                operator: value,
                args: []
            });
        },
        options: options,
        value: isAndOr ? 'Add Condition' : props.predicate?.operator
    }));
};
const $82b30489994e43b2$var$ColumnFilterEditor = (props)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-3"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:mb-2"
    }, $acw62.createElement($82b30489994e43b2$var$ColumnFilterPredicateDropdown, {
        columnId: props.columnId,
        disabled: props.disabled,
        predicate: props.predicate,
        predicateDefs: props.predicateDefs,
        onPredicateChange: props.onPredicateChange
    }), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:ml-2"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        disabled: props.deleteDisabled,
        onClick: props.onDelete,
        variant: "text",
        icon: "delete"
    }))), $acw62.createElement((0, $dc383303b0d79e8d$export$aa5385cf5372fb1), {
        columnId: props.columnId,
        disabled: props.disabled,
        predicate: props.predicate,
        onPredicateChange: props.onPredicateChange,
        predicateDefs: props.predicateDefs
    }));
};
const $82b30489994e43b2$var$AndOrInput = (props)=>{
    return(// <Select
    //   value={props.operator}
    //   onChange={props.onChange}
    //   options={[
    //     { label: 'AND', value: 'AND' },
    //     { label: 'OR', value: 'OR' },
    //   ]}
    // />
    $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:flex-1"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:mr-2",
        onClick: ()=>props.onChange('AND'),
        checked: props.operator === 'AND'
    }, "AND"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:mr-2",
        onClick: ()=>props.onChange('OR'),
        checked: props.operator === 'OR'
    }, "OR")));
};
const $82b30489994e43b2$export$dd1ed8f779a4000b = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const manuallyApplyColumnFilter = adaptable.api.filterApi.columnFilterApi.internalApi.shouldManuallyApplyColumnFilter(props.columnId);
    const [predicateNotYetApplied, setPredicateNotYetApplied] = $acw62.useState(props.predicate);
    const applyFilter = ()=>{
        props.onPredicateChange(currentPredicateRef.current);
        setPredicateNotYetApplied(undefined);
    };
    const onPredicateChange = (predicate)=>{
        // even if manuallyApplyColumnFilter is false, when we explicitly clear the filter
        // we want to apply the filter immediately
        if (!manuallyApplyColumnFilter || !predicate) props.onPredicateChange(predicate);
        else setPredicateNotYetApplied(predicate);
    };
    const clearAllFilters = ()=>{
        props.onPredicateChange(null);
        setPredicateNotYetApplied(undefined);
    };
    const onNewPredicate = (predicateDef)=>{
        const currentPredicate = currentPredicateRef.current;
        const newPredicate = {
            ...currentPredicate,
            // @ts-ignore
            args: [
                ...currentPredicate.args,
                {
                    operator: predicateDef.operator,
                    args: []
                }
            ]
        };
        onPredicateChange(newPredicate);
    };
    const onCombineChange = (operator)=>{
        const newPredicate = {
            ...currentPredicateRef.current,
            args: currentPredicateRef.current.args || [],
            operator: operator
        };
        onPredicateChange(newPredicate);
    };
    const currentPredicate = !manuallyApplyColumnFilter ? props.predicate : predicateNotYetApplied ?? props.predicate;
    const currentPredicateRef = $acw62.useRef(currentPredicate);
    //#ref-predicate
    currentPredicateRef.current = currentPredicate;
    // Not sure how to check this but would be nice...
    const isLastPredicateValid = true;
    const filterPredicateDropdown = $acw62.createElement($82b30489994e43b2$var$ColumnFilterPredicateDropdown, {
        columnId: props.columnId,
        disabled: props.disabled,
        predicate: currentPredicate,
        predicateDefs: props.predicateDefs,
        onPredicateChange: (predicate)=>{
            const predicateDef = props.predicateDefs.find((predicateDef)=>predicateDef.operator === predicate.operator);
            onNewPredicate(predicateDef);
        },
        targetProps: {
            tone: 'neutral',
            variant: 'raised',
            children: 'Add Condition'
        }
    });
    const isAtLeastOneColumnFilterValid = (qlPredicates)=>{
        if (!qlPredicates?.length) return false;
        return qlPredicates.map((qlPredicate)=>(0, $5b60d09ab87a9230$export$acf229288e9f8eb6)(qlPredicate)).some((adaptablePredicate)=>adaptable.api.predicateApi.isValidPredicate(adaptablePredicate));
    };
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            'twa:bg-primarylight': true,
            'twa:pb-2': !props.hideActionButtons,
            'twa:mb-2': props.location === 'filterForm',
            'twa:mt-2 twa:ml-2 twa:mr-2': props.location === 'columnMenu',
            'twa:rounded-standard': true
        })
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:m-2"
    }, $acw62.createElement($82b30489994e43b2$var$AndOrInput, {
        onChange: onCombineChange,
        operator: currentPredicate.operator
    })), !props.hideActionButtons && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-ColumnFilter-actions twa:ml-2 twa:mr-2",
        justifyContent: "space-between"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-ColumnFilter-action-clearall"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "aria-label": 'Clear All Filters',
        onClick: ()=>clearAllFilters()
    }, "Clear All")), manuallyApplyColumnFilter ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1",
        "data-name": "spacer"
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-ColumnFilter-action-reset twa:mr-2"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "aria-label": 'Reset All',
        tone: "neutral",
        variant: "raised",
        onClick: ()=>{
            setPredicateNotYetApplied(props.predicate);
        }
    }, "Reset")), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-ColumnFilter-action-apply"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "aria-label": 'Apply Filter',
        tone: "accent",
        variant: "raised",
        onClick: applyFilter,
        disabled: !isAtLeastOneColumnFilterValid(predicateNotYetApplied?.args) && !isAtLeastOneColumnFilterValid(currentPredicate.args)
    }, "Apply"))) : null)), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        style: props.wrapperProps?.style,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(`ab-ColumnFilter twa:flex-1 twa:min-h-0`, props.wrapperProps?.className)
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-ColumnFilter-content twa:overflow-auto"
    }, currentPredicate.args.map((predicate, index)=>{
        return $acw62.createElement($82b30489994e43b2$var$ColumnFilterEditor, {
            deleteDisabled: currentPredicate.args.length < 2,
            onDelete: ()=>{
                const currentPredicate = currentPredicateRef.current;
                const newArgs = [
                    ...currentPredicate.args
                ];
                newArgs.splice(index, 1);
                onPredicateChange({
                    operator: currentPredicate.operator,
                    args: newArgs
                });
            },
            key: index,
            columnId: props.columnId,
            disabled: props.disabled,
            predicate: predicate,
            predicateDefs: props.predicateDefs,
            onPredicateChange: (predicate)=>{
                // #ref-predicate - for whatever reason
                // the `currentPredicate` here would be one from an old render
                // if we weren't using a ref. we're not using memo/usecallback here,
                // so I don't understand why this is happening
                const currentPredicate = currentPredicateRef.current;
                const newArgs = [
                    ...currentPredicate.args
                ];
                newArgs[index] = predicate;
                onPredicateChange({
                    operator: currentPredicate.operator,
                    args: newArgs
                });
            }
        });
    }), isLastPredicateValid && filterPredicateDropdown)));
};



var $acw62 = parcelRequire("acw62");





const $ea27eebda6956d72$export$f434b594b08f4e1d = (columnId, filterComponent, handleOnChangeOverride)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const api = adaptable.api;
    const columnType = api.columnApi.getColumnDataTypeForColumnId(columnId);
    const column = api.columnApi.getColumnWithColumnId(columnId);
    const columnFilterOptions = api.optionsApi.getFilterOptions().columnFilterOptions;
    const qlPredicateDefs = $acw62.useMemo(()=>{
        // this is NOT the ideal place to do this, but it is what it is: autoGroupCol should NOT have the 'Blanks'/'NonBlanks' predicates
        const predicateDefs = api.filterApi.columnFilterApi.getFilterPredicateDefsForColumn(column).filter((predDef)=>{
            if (api.columnApi.isAutoRowGroupColumnForSingle(column.columnId)) return predDef.id !== 'Blanks' && predDef.id !== 'NonBlanks';
            return true;
        });
        const qlDataType = (0, $47be09cb14df4bdb$export$d252517300e3b104)(columnType);
        return predicateDefs.map((predDef)=>(0, $5b60d09ab87a9230$export$2a3e9a3fb4fb4111)(predDef, qlDataType));
    }, [
        columnId
    ]);
    const currentLayout = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((0, $2c155f3e4804e29e$export$69cb9ed92a96b951));
    const columnFilter = (0, $acw62.useMemo)(()=>{
        return currentLayout?.ColumnFilters?.find((cf)=>cf.ColumnId === columnId);
    }, [
        currentLayout?.ColumnFilters,
        columnId
    ]);
    const qlPredicate = column ? (0, $5b60d09ab87a9230$export$685906aad993c4d6)(columnFilter, column, qlPredicateDefs, columnFilterOptions, filterComponent, api) : null;
    const handleOnChange = (adaptablePredicate, logic = 'AND')=>{
        // make sure we always have the latest columnFiler
        const columnFilter = adaptable.api.filterApi.columnFilterApi.getColumnFilterForColumn(columnId);
        const newFilter = {
            ...columnFilter,
            ColumnId: columnId,
            Predicates: adaptablePredicate,
            PredicatesOperator: logic
        };
        if (handleOnChangeOverride) handleOnChangeOverride(newFilter);
        else dispatch(columnFilter?.Uuid ? $2c155f3e4804e29e$export$bbe8b429f447e815(newFilter) : $2c155f3e4804e29e$export$89469bfff4112a24(newFilter));
    };
    const handleClear = $acw62.useCallback(()=>dispatch($2c155f3e4804e29e$export$171768c99fee2ba3(columnId)), [
        columnId
    ]);
    /**
     * Converts a QlPredicate to an AdaptablePredicate and dispatches the change.
     */ const handlePredicateChange = $acw62.useCallback((newPredicate)=>{
        if (!newPredicate) {
            handleClear();
            return;
        }
        const newAdaptablePredicates = newPredicate.args.map((0, $5b60d09ab87a9230$export$acf229288e9f8eb6));
        handleOnChange(newAdaptablePredicates, newPredicate.operator);
    }, [
        columnId
    ]);
    return {
        qlPredicate: qlPredicate,
        qlPredicateDefs: qlPredicateDefs,
        columnFilter: columnFilter,
        handleClear: handleClear,
        handlePredicateChange: handlePredicateChange,
        handleOnChange: handleOnChange,
        column: column
    };
};


const $c18eb22e16831d67$export$5d26e9d0e9751cd1 = (props)=>{
    const { qlPredicate: qlPredicate, qlPredicateDefs: qlPredicateDefs, columnFilter: columnFilter, handlePredicateChange: handlePredicateChange } = (0, $ea27eebda6956d72$export$f434b594b08f4e1d)(props.columnId, 'FilterForm');
    return $acw62.createElement((0, $82b30489994e43b2$export$dd1ed8f779a4000b), {
        location: props.location,
        wrapperProps: props.wrapperProps,
        columnId: props.columnId,
        predicate: qlPredicate,
        predicateDefs: qlPredicateDefs,
        disabled: columnFilter?.IsSuspended,
        onPredicateChange: $acw62.useCallback((predicate)=>{
            handlePredicateChange(predicate);
        }, [
            handlePredicateChange
        ])
    });
};





const $35d1010224fd384e$export$342553a67ba85cf6 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { value: initialColumnId } = props?.popupProps;
    const [columnId, setColumnId] = $acw62.useState(initialColumnId);
    $acw62.useEffect(()=>{
        setColumnId(initialColumnId);
    }, [
        props.popupProps.value
    ]);
    // const onChange = props.popupProps.onChange;
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "ab-ColumnFilterWindow twa:flex-1 twa:min-h-0 twa:p-2 twa:h-full"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-2"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Column"
    }, $acw62.createElement((0, $568d00bde2c337b2$export$e5d989eba9e871bb), {
        renderOption: (column)=>{
            const columnFilter = api.filterApi.columnFilterApi.getColumnFilterForColumn(column.columnId);
            const label = column.friendlyName ?? column.columnId;
            if (columnFilter && api.filterApi.columnFilterApi.isColumnFilterActive(columnFilter)) return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, label, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:flex-1"
            }), $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
                icon: {
                    name: 'filter'
                }
            }));
            return label;
        },
        onChange: (column)=>setColumnId(column),
        filterColumn: (column)=>column.queryable,
        isMulti: false,
        value: columnId
    })))), $acw62.createElement((0, $c18eb22e16831d67$export$5d26e9d0e9751cd1), {
        columnId: columnId,
        location: 'filterForm'
    }));
};


const $226a20b901481288$export$24d2a830caa0078a = 'WINDOW_GRID_FILTER_EDITOR';
const $226a20b901481288$export$b3bc1824253fee5c = 'SHOW_PIVOT_COLUMN_DETAILS';
const $226a20b901481288$export$d87df153f562e7a3 = 'SHOW_THEME_EDITOR';
const $226a20b901481288$export$4976abeffb8e0d2d = 'WINDOW_SHOW_TRANSPOSED_VIEW';
const $226a20b901481288$export$d423fc3beda7048e = 'COLUMN_FILTER_WINDOW';
const $226a20b901481288$export$58ba7329cbdbab90 = {
    [$226a20b901481288$export$24d2a830caa0078a]: (0, $32d6c730b6e720aa$export$17331cac31519f5e),
    [$226a20b901481288$export$b3bc1824253fee5c]: (0, $5ac8517c58a55b4c$export$b9c100ec6c2a13e6),
    [$226a20b901481288$export$d87df153f562e7a3]: (0, $8a4272ec2887a9e4$export$6f8170d9c34fb5ac),
    [$226a20b901481288$export$4976abeffb8e0d2d]: (0, $fa18b922d2770fa3$export$26cfde6f6e10b593),
    [$226a20b901481288$export$d423fc3beda7048e]: (0, $35d1010224fd384e$export$342553a67ba85cf6)
};


const $a22f97369f02628d$export$6220e2e98f7e58ca = '__ROW_SUMMARY_ROW_ID';
const $a22f97369f02628d$export$3a87fe7386ef35df = 'WEIGHTED_AVERAGE';
const $a22f97369f02628d$export$d7397d3f42b8dd61 = [
    'MIN',
    'MAX',
    'SUM',
    'AVG',
    'COUNT',
    'MEDIAN',
    'MODE',
    'DISTINCT',
    'ONLY',
    'STD_DEVIATION',
    $a22f97369f02628d$export$3a87fe7386ef35df
];



class $c5535a4c21cd8803$export$6da74e60dcaba63 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $0bcc5a009234cdaf$export$436409cfee65d88b)(_adaptable);
    }
    getAgGridColumnDefs() {
        return this._adaptable.agGridAdapter.getAgGridApi().getColumnDefs();
    }
    getVariant() {
        return this.getAdaptableVariant();
    }
    getInternalState() {
        return this.getAdaptableState().Internal;
    }
    loadGridData(dataSource) {
        // we intentionally set an initial empty array,
        // to prevent `cellchanged` events from being triggered for rows that have
        // the same primary key with existing rows
        // see #testprevent_cellchanged_event_on_load_grid_data
        this._adaptable.agGridAdapter.setGridOption('rowData', []);
        this._adaptable.setGridData(dataSource);
        const allRowNodes = this.getAllRowNodes();
        const rowDataChangedInfo = this.getAdaptableInternalApi().buildRowDataChangedInfo(dataSource, allRowNodes, 'Load');
        this.getAdaptableInternalApi().getDataService().CreateRowDataChangedEvent(rowDataChangedInfo);
    }
    getGridData() {
        return this._adaptable.getGridData();
    }
    getFilteredData() {
        return this._adaptable.getFilteredData();
    }
    getVisibleData() {
        const data = [];
        this.getAdaptableInternalApi().forAllVisibleRowNodesDo((rowNode)=>{
            if (!this.isGroupRowNode(rowNode)) data.push(rowNode.data);
        });
        return data;
    }
    async updateGridData(dataRows, dataUpdateConfig) {
        const rowNodes = await this._adaptable.updateRows(dataRows, dataUpdateConfig);
        const rowDataChangedInfo = this.getAdaptableInternalApi().buildRowDataChangedInfo(dataRows, rowNodes, 'Update');
        this.getAdaptableInternalApi().getDataService().CreateRowDataChangedEvent(rowDataChangedInfo);
        return rowNodes;
    }
    async addOrUpdateGridData(dataRows, dataUpdateConfig) {
        const { added: added, updated: updated } = await this._adaptable.addOrUpdateRows(dataRows, dataUpdateConfig);
        if ((0, $9g4SS.default).IsNotNullOrEmpty(updated)) {
            const rowDataChangedInfo = this.getAdaptableInternalApi().buildRowDataChangedInfo(dataRows, updated, 'Update');
            this.getAdaptableInternalApi().getDataService().CreateRowDataChangedEvent(rowDataChangedInfo);
        }
        if ((0, $9g4SS.default).IsNotNullOrEmpty(added)) {
            const rowDataChangedInfo = this.getAdaptableInternalApi().buildRowDataChangedInfo(dataRows, added, 'Add');
            this.getAdaptableInternalApi().getDataService().CreateRowDataChangedEvent(rowDataChangedInfo);
        }
        return {
            addedRows: added,
            updatedRows: updated
        };
    }
    async addGridData(dataRows, dataUpdateConfig) {
        const rowNodes = await this._adaptable.addRows(dataRows, dataUpdateConfig);
        const rowDataChangedInfo = this.getAdaptableInternalApi().buildRowDataChangedInfo(dataRows, rowNodes, 'Add');
        this.getAdaptableInternalApi().getDataService().CreateRowDataChangedEvent(rowDataChangedInfo);
        return rowNodes;
    }
    undoCellEdit(cellDataChangedInfo) {
        // for the reason of this hacky solution see the comments in DataService
        this.getAdaptableInternalApi().getDataService().logUndoChange(cellDataChangedInfo);
        const cellUpdateRequest = {
            columnId: cellDataChangedInfo.column.columnId,
            newValue: cellDataChangedInfo.oldValue,
            primaryKeyValue: cellDataChangedInfo.primaryKeyValue,
            rowNode: cellDataChangedInfo.rowNode
        };
        this.setCellValue(cellUpdateRequest);
        return true;
    }
    async deleteGridData(dataRows, dataUpdateConfig) {
        if (this.checkArrayExists(dataRows)) {
            const rowNodes = await this._adaptable.deleteRows(dataRows, dataUpdateConfig);
            const rowDataChangedInfo = this.getAdaptableInternalApi().buildRowDataChangedInfo(dataRows, rowNodes, 'Delete');
            this.getAdaptableInternalApi().getDataService().CreateRowDataChangedEvent(rowDataChangedInfo);
            return rowNodes;
        }
        return [];
    }
    async manageGridData(dataRowConfig, dataUpdateConfig) {
        const transactionResult = await this._adaptable.manageGridRows(dataRowConfig, dataUpdateConfig);
        if (Array.isArray(transactionResult.removedRows) && transactionResult.removedRows.length) {
            const rowDataChangedInfo = this.getAdaptableInternalApi().buildRowDataChangedInfo(dataRowConfig.deleteRows, transactionResult.removedRows, 'Delete');
            this.getAdaptableInternalApi().getDataService().CreateRowDataChangedEvent(rowDataChangedInfo);
        }
        if (Array.isArray(transactionResult.updatedRows) && transactionResult.updatedRows.length) {
            const rowDataChangedInfo = this.getAdaptableInternalApi().buildRowDataChangedInfo(dataRowConfig.updateRows, transactionResult.updatedRows, 'Update');
            this.getAdaptableInternalApi().getDataService().CreateRowDataChangedEvent(rowDataChangedInfo);
        }
        if (Array.isArray(transactionResult.addedRows) && transactionResult.addedRows.length) {
            const rowDataChangedInfo = this.getAdaptableInternalApi().buildRowDataChangedInfo(dataRowConfig.addRows, transactionResult.addedRows, 'Add');
            this.getAdaptableInternalApi().getDataService().CreateRowDataChangedEvent(rowDataChangedInfo);
        }
        return transactionResult;
    }
    setCellValue(cellUpdateRequest) {
        const abColumn = this.getColumnApi().getColumnWithColumnId(cellUpdateRequest.columnId);
        if (!abColumn) {
            this.logWarn(`setCellValue() - column not found for columnId: ${cellUpdateRequest.columnId}`);
            return;
        }
        const rowNode = cellUpdateRequest.rowNode ?? this.getRowNodeForPrimaryKey(cellUpdateRequest.primaryKeyValue);
        if (!rowNode) {
            this.logWarn(`setCellValue() - rowNode not found for primaryKeyValue: ${cellUpdateRequest.primaryKeyValue}`);
            return;
        }
        this._adaptable.setDataValue(cellUpdateRequest.newValue, abColumn, cellUpdateRequest.primaryKeyValue, rowNode);
        this.refreshCell(rowNode, abColumn.columnId);
    }
    setCellValues(cellUpdateRequests) {
        cellUpdateRequests?.forEach((cellUpdateRequest)=>this.setCellValue(cellUpdateRequest));
    }
    getCellSummaryInfo() {
        return this.getAdaptableState().Internal.CellSummary.CellSummaryInfo;
    }
    getSelectedCellInfo() {
        return this.getInternalState().SelectedCellInfo;
    }
    getSelectedRowInfo() {
        return this.getInternalState().SelectedRowInfo ?? {
            gridRows: []
        };
    }
    getCellDisplayValue(primaryKeyValue, columnId) {
        const rowNode = this.getRowNodeForPrimaryKey(primaryKeyValue);
        return rowNode ? this.getDisplayValueFromRowNode(rowNode, columnId) : undefined;
    }
    getCellRawValue(primaryKeyValue, columnId) {
        const rowNode = this.getRowNodeForPrimaryKey(primaryKeyValue);
        return rowNode ? this.getRawValueFromRowNode(rowNode, columnId) : undefined;
    }
    getCellNormalisedValue(primaryKeyValue, columnId) {
        const rowNode = this.getRowNodeForPrimaryKey(primaryKeyValue);
        return rowNode ? this.getNormalisedValueFromRowNode(rowNode, columnId) : undefined;
    }
    applyFiltering() {
        this._adaptable.applyFiltering();
    }
    clearFiltering() {
        // slightly round the houses but we have to call ColumnFilterAPI as it does it properly
        this.getColumnFilterApi().clearColumnFilters();
    }
    getColumnSorts() {
        return this.getLayoutApi().getCurrentLayout().ColumnSorts;
    }
    getColumnSortForColumn(columnId) {
        let columnSorts = this.getColumnSorts();
        return columnSorts?.find((cs)=>cs.ColumnId == columnId);
    }
    setAdaptableSorting(columnSorts) {
        this._adaptable.setColumnSort(columnSorts);
    }
    clearAdaptableSorting() {
        this._adaptable.clearColumnSort();
    }
    selectRow(primaryKeyValue, clearSelection) {
        this.selectNode(this.getRowNodeForPrimaryKey(primaryKeyValue), clearSelection);
    }
    selectRows(primaryKeyValues, clearSelection) {
        let nodes = [];
        primaryKeyValues.forEach((pkValue)=>{
            nodes.push(this.getRowNodeForPrimaryKey(pkValue));
        });
        this.selectNodes(nodes, clearSelection);
    }
    selectNode(rowNode, clearSelection) {
        this._adaptable.selectNode(rowNode, clearSelection);
    }
    selectNodes(rowNodes, clearSelection) {
        this._adaptable.selectNodes(rowNodes, clearSelection);
    }
    deSelectRow(primaryKeyValue, clearSelection) {
        this._adaptable.deSelectNode(this.getRowNodeForPrimaryKey(primaryKeyValue), clearSelection);
    }
    deSelectRows(primaryKeyValues, clearSelection) {
        let nodes = [];
        primaryKeyValues.forEach((pkValue)=>{
            nodes.push(this.getRowNodeForPrimaryKey(pkValue));
        });
        this.deSelectNodes(nodes, clearSelection);
    }
    deSelectNode(rowNode, clearSelection) {
        this._adaptable.deSelectNode(rowNode, clearSelection);
    }
    deSelectNodes(rowNodes, clearSelection) {
        this._adaptable.deSelectNodes(rowNodes, clearSelection);
    }
    getSelectionStartEndNodes(gridCellRange) {
        let startNode;
        let endNode;
        startNode = gridCellRange.primaryKeyValueEnd ? this._adaptable.getRowNodeForPrimaryKey(gridCellRange.primaryKeyValueStart) : this._adaptable.getRowNodeByIndex(gridCellRange.rowIndexStart);
        if (gridCellRange.primaryKeyValueEnd) endNode = this._adaptable.getRowNodeForPrimaryKey(gridCellRange.primaryKeyValueEnd);
        else if (gridCellRange.rowIndexEnd) endNode = this._adaptable.getRowNodeByIndex(gridCellRange.rowIndexEnd);
        else endNode = startNode;
        return [
            startNode,
            endNode
        ];
    }
    selectCellRange(gridCellRange, clearSelection) {
        if (gridCellRange == undefined) return;
        if (gridCellRange.primaryKeyValueStart == undefined && gridCellRange.rowIndexStart == undefined) return;
        const [startNode, endNode] = this.getSelectionStartEndNodes(gridCellRange);
        if (startNode && endNode) this._adaptable.selectCells(gridCellRange.columnIds, startNode, endNode, clearSelection);
    }
    selectCellRangeByQuery(query, gridCellRange, clearSelection) {
        const filteredRowNodes = [];
        const isRowNodeInQuery = (rowNode)=>{
            try {
                return this.getAdaptableApi().internalApi.getQueryLanguageService().evaluateBooleanExpression(query, 'GridInfo', rowNode);
            } catch (error) {
                (0, $10f858c943b30cc8$export$45c997b35cb132f6)(error.message);
                return false;
            }
        };
        if (gridCellRange) {
            const [startNode, endNode] = this.getSelectionStartEndNodes(gridCellRange);
            for(let rowIndex = startNode.rowIndex; rowIndex <= endNode.rowIndex; rowIndex++){
                const rowNode = this._adaptable.getRowNodeByIndex(rowIndex);
                isRowNodeInQuery(rowNode) && filteredRowNodes.push(rowNode);
            }
        } else // include all row
        this._adaptable.forAllRowNodesDo((rowNode)=>{
            isRowNodeInQuery(rowNode) && filteredRowNodes.push(rowNode);
        });
        if (!filteredRowNodes.length) return;
        let preapredGridCellRange = gridCellRange;
        if (!preapredGridCellRange) {
            /**
             * Select all rows and all columns
             */ const currentLayout = this.getLayoutApi().getCurrentLayout();
            preapredGridCellRange = {
                columnIds: currentLayout.TableColumns
            };
        }
        // ranges of row with consecutive indexes
        const rowRanges = filteredRowNodes.reduce((acc, rowNode, index, collection)=>{
            // add start if there is none
            const prevRange = acc[acc.length - 1];
            if (prevRange.startNode === undefined) prevRange.startNode = rowNode;
            // add end if next is not consecutive
            const nextNode = collection[index + 1];
            if (nextNode && nextNode.rowIndex - 1 !== rowNode.rowIndex) {
                prevRange.endNode = rowNode;
                // start a new one
                acc.push({});
            }
            // if at the end close last range
            if (index === collection.length - 1) prevRange.endNode = rowNode;
            return acc;
        }, [
            {}
        ]);
        let preparedClearSelection = clearSelection;
        rowRanges.forEach((range)=>{
            // clear only on first range selection
            this._adaptable.selectCells(preapredGridCellRange.columnIds, range.startNode, range.endNode, preparedClearSelection);
            preparedClearSelection = false;
        });
    }
    selectColumn(columnId) {
        this.selectColumns([
            columnId
        ]);
    }
    selectColumns(columnIds) {
        this.getColumnApi().selectColumns(columnIds);
    }
    getFirstRowNode() {
        return this._adaptable.getFirstRowNode();
    }
    getFirstDisplayedRowNode() {
        return this._adaptable.getFirstDisplayedRowNode();
    }
    getVisibleRowNodes(config) {
        const rowNodes = [];
        this.getAdaptableInternalApi().forAllVisibleRowNodesDo((rowNode)=>rowNodes.push(rowNode), config);
        return rowNodes;
    }
    getAllRowNodes(config) {
        return this._adaptable.getAllRowNodes(config);
    }
    getGroupRowNodes(config) {
        return this._adaptable.getGroupRowNodes(config);
    }
    getGridCellFromRowNode(rowNode, columnId) {
        return this._adaptable.getGridCellFromRowNode(rowNode, columnId);
    }
    getRawValueFromRowNode(rowNode, columnId) {
        return this._adaptable.getRawValueFromRowNode(rowNode, columnId);
    }
    getDisplayValueFromRowNode(rowNode, columnId) {
        return this._adaptable.getDisplayValueFromRowNode(rowNode, columnId);
    }
    getDisplayValueFromRawValue(rowNode, columnId, rawValue) {
        return this._adaptable.getDisplayValueFromRawValue(rowNode, columnId, rawValue);
    }
    getNormalisedValueFromRowNode(rowNode, columnId) {
        const rawValue = this._adaptable.getRawValueFromRowNode(rowNode, columnId);
        const abColumn = this.getColumnApi().getColumnWithColumnId(columnId);
        return this._adaptable.getNormalisedValueFromRawValue(rawValue, abColumn);
    }
    getRowNodesForPrimaryKeys(primaryKeyValues) {
        return this._adaptable.getRowNodesForPrimaryKeys(primaryKeyValues);
    }
    getRowNodeForPrimaryKey(primaryKeyValue) {
        return this._adaptable.getRowNodeForPrimaryKey(primaryKeyValue);
    }
    getPrimaryKeyValueForRowNode(rowNode) {
        return this._adaptable.getPrimaryKeyValueFromRowNode(rowNode);
    }
    getRowNodeForIndex(index) {
        return this._adaptable.getRowNodeByIndex(index);
    }
    getPrimaryKeyValuesForRowNodes(rowNodes) {
        return rowNodes.map((rowNode)=>this.getPrimaryKeyValueForRowNode(rowNode));
    }
    setRowGroupColumns(columnIds) {
        this._adaptable.setRowGroupColumns(columnIds);
    }
    clearRowGroupColumns() {
        this._adaptable.clearRowGroupColumns();
    }
    expandAllRowGroups() {
        this._adaptable.expandAllRowGroups();
    }
    collapseAllRowGroups() {
        this._adaptable.collapseAllRowGroups();
    }
    expandRowGroupsForValues(columnValues) {
        this._adaptable.expandRowGroupsForValues(columnValues);
    }
    isGridPivotable() {
        return !this.isTreeDataGrid();
    }
    isGridGroupable() {
        return !this.isTreeDataGrid();
    }
    isGridRowSelectable() {
        return this._adaptable.isGridRowSelectable();
    }
    isGridRowSelected(primaryKeyValue) {
        const rowInfo = this.getSelectedRowInfo();
        const row = rowInfo.gridRows.find((gr)=>gr.primaryKeyValue == primaryKeyValue);
        return row != undefined;
    }
    isGridRangeSelectable() {
        return this._adaptable.isGridRangeSelectable();
    }
    isGridRowGrouped() {
        return this._adaptable.isGridGroupingActive();
    }
    isGridInPivotMode() {
        return this.getLayoutApi().isCurrentLayoutPivot();
    }
    isMasterDetailGrid() {
        return this.getAgGridApi().getGridOption('masterDetail');
    }
    isTreeDataGrid() {
        return this.getAgGridApi().getGridOption('treeData');
    }
    isGroupRowNode(rowNode) {
        return this._adaptable.isGroupRowNode(rowNode);
    }
    isGrandTotalRowNode(rowNode) {
        return this._adaptable.isGrandTotalRowNode(rowNode);
    }
    isVisibleRowNode(rowNode) {
        return this._adaptable.isRowNodeVisible(rowNode);
    }
    isSummaryNode(rowNode) {
        return !!rowNode?.data?.[0, $a22f97369f02628d$export$6220e2e98f7e58ca];
    }
    isQuickFilterAvailable() {
        return this._adaptable.isQuickFilterAvailable();
    }
    redrawGrid() {
        this._adaptable.redrawBody();
        this._adaptable.refreshHeader();
    }
    getGridCellsForRawValue(columnId, rawValue) {
        const gridCells = this._adaptable.getGridCellsForColumn(columnId);
        if (!gridCells) return undefined;
        const returnValues = [];
        gridCells.forEach((gc)=>{
            if (gc.rawValue === rawValue) returnValues.push(gc);
        });
        return returnValues;
    }
    getCellRawValueCount(columnId, rawValue) {
        const gridCells = this.getGridCellsForRawValue(columnId, rawValue);
        return gridCells?.length;
    }
    getGridCellsForDisplayValue(columnId, displayValue) {
        const gridCells = this._adaptable.getGridCellsForColumn(columnId);
        if (!gridCells) return undefined;
        const returnGridCells = [];
        gridCells.forEach((gc)=>{
            if (gc.displayValue === displayValue) returnGridCells.push(gc);
        });
        return returnGridCells;
    }
    jumpToRow(primaryKeyValue) {
        const node = this._adaptable.getRowNodeForPrimaryKey(primaryKeyValue);
        this._adaptable.jumpToRow(node);
    }
    jumpToColumn(columnId) {
        this._adaptable.jumpToColumn(columnId);
    }
    jumpToCell(primaryKeyValue, columnId, rowNode) {
        const node = rowNode ?? this._adaptable.getRowNodeForPrimaryKey(primaryKeyValue);
        this._adaptable.jumpToCell(columnId, node);
    }
    highlightCell(cellHighlightInfo) {
        this.dispatchAction((0, $5b564bb703f29152$export$2011321d56e9cb61)(cellHighlightInfo));
        if (cellHighlightInfo.timeout) setTimeout(()=>{
            this.unHighlightCell(cellHighlightInfo.primaryKeyValue, cellHighlightInfo.columnId);
        }, cellHighlightInfo.timeout);
    }
    unHighlightCell(primaryKeyValue, columnId) {
        this.dispatchAction((0, $5b564bb703f29152$export$23ee2d95cb6fc250)(primaryKeyValue, columnId));
    }
    unHighlightAllCells() {
        this.dispatchAction((0, $5b564bb703f29152$export$e29b768e4ab19b3e)());
    }
    highlightColumn(columnHighlightInfo) {
        this.dispatchAction((0, $5b564bb703f29152$export$7a1b6ea0040d1206)(columnHighlightInfo));
        if (columnHighlightInfo.timeout) setTimeout(()=>{
            this.unHighlightColumn(columnHighlightInfo.columnId);
        }, columnHighlightInfo.timeout);
    }
    unHighlightColumn(columnId) {
        this.dispatchAction((0, $5b564bb703f29152$export$37e7ff783b2c940e)(columnId));
    }
    unHighlightAllColumns() {
        this.dispatchAction((0, $5b564bb703f29152$export$e010de3d94020f71)());
    }
    highlightRow(rowHighlightInfo) {
        this.dispatchAction((0, $5b564bb703f29152$export$3be12149c68c5f17)(rowHighlightInfo));
        if (rowHighlightInfo.timeout) setTimeout(()=>{
            this.unHighlightRow(rowHighlightInfo.primaryKeyValue);
        }, rowHighlightInfo.timeout);
    }
    highlightRows(rowHighlightInfos) {
        this.dispatchAction((0, $5b564bb703f29152$export$b2ff6d69f0e262a6)(rowHighlightInfos));
        if (rowHighlightInfos.timeout) setTimeout(()=>{
            this.unHighlightRows(rowHighlightInfos.primaryKeyValues);
        }, rowHighlightInfos.timeout);
    }
    unHighlightRow(primaryKeyValue) {
        this.dispatchAction((0, $5b564bb703f29152$export$c1756d4c088e843f)(primaryKeyValue));
    }
    unHighlightRows(primaryKeyValues) {
        this.dispatchAction((0, $5b564bb703f29152$export$f9e1a3d5dfadbc4a)(primaryKeyValues));
    }
    unHighlightAllRows() {
        this.dispatchAction((0, $5b564bb703f29152$export$490d2d7d7f44c6be)());
    }
    refreshCell(rowNode, columnId, suppressFlash = true) {
        this._adaptable.refreshCell(rowNode, columnId, suppressFlash);
    }
    refreshCells(rowNode, columnIds, suppressFlash = true) {
        this._adaptable.refreshCells(rowNode, columnIds, suppressFlash);
    }
    refreshAllCells(forceUpdate = false) {
        this._adaptable.refreshAllCells(forceUpdate);
    }
    refreshGridCell(gridCell) {
        this.refreshCell(gridCell.rowNode, gridCell.column.columnId);
    }
    refreshGridCells(gridCells) {
        gridCells.forEach((gc)=>{
            this.refreshGridCell(gc);
        });
    }
    refreshColumn(columnId) {
        this._adaptable.refreshColumns([
            columnId
        ], true);
    }
    refreshColumns(columnIds) {
        this._adaptable.refreshColumns(columnIds, true);
    }
    refreshRowByPrimaryKey(primaryKey) {
        const rowNode = this.getRowNodeForPrimaryKey(primaryKey);
        this.refreshRowNode(rowNode);
    }
    refreshRowNode(rowNode) {
        this._adaptable.redrawRow(rowNode);
    }
    refreshRowNodes(rowNodes) {
        this._adaptable.redrawRows(rowNodes);
    }
    refreshGroupRowNodes() {
        // see https://www.ag-grid.com/javascript-data-grid/client-side-row-stages/#refreshing-the-client-side-model
        this.getAgGridApi().refreshClientSideRowModel('group');
        this._adaptable.updateRowGroupsAndColumnGroupsExpandedState();
    }
    refreshGridHeader() {
        this._adaptable.refreshGridHeader();
    }
    isCellEditable(gridCell) {
        // If not Grid Cell or Column then return false - GridCell.column may be undefined for cells from synthetic columns created by AG Grid (ex. autoGroup columns)
        if (!gridCell || !gridCell.column || !gridCell.rowNode) return false;
        if (gridCell.rowNode && this.isSummaryNode(gridCell.rowNode)) return false;
        const agGridColumn = this.getColumnApi().internalApi.getAgGridColumnForAdaptableColumn(gridCell.column.columnId);
        // this will invoke the colDef.editable callback where we check both AdapTable and AG Grid editability
        return agGridColumn?.isCellEditable(gridCell.rowNode);
    }
    isCellEdited(gridCell) {
        if (!gridCell) return false;
        const cellDataChangedInfo = this.getDataChangeHistoryApi().getDataChangeForGridCell(gridCell);
        return cellDataChangedInfo != null;
    }
    isEveryCellEditable(gridCells) {
        for (let gridCell of gridCells){
            if (!this.isCellEditable(gridCell)) return false;
        }
        return true;
    }
    getRowCount() {
        return this._adaptable.getRowCount();
    }
    getVisibleRowCount() {
        return this._adaptable.getVisibleRowCount();
    }
    getRowsInViewport() {
        return this._adaptable.getRowsInViewport();
    }
    getColumnCount() {
        return this._adaptable.getColumnCount();
    }
    getVisibleColumnCount() {
        return this._adaptable.getVisibleColumnCount();
    }
    selectAll() {
        this._adaptable.selectAll();
    }
    deselectAll() {
        this._adaptable.deselectAll();
    }
    getGridContainerElement() {
        return this._adaptable.getAgGridContainerElement();
    }
    openGridInfoSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$1ec41f9c955a8b42);
    }
    getAgGridRowModelType() {
        return this._adaptable.getAgGridRowModelType();
    }
    showTransposedView(transposeConfig = {}) {
        const transposedColumnId = transposeConfig.transposedColumnId ?? this.getOptionsApi().getPrimaryKey();
        const hideTransposedColumn = transposeConfig.hideTransposedColumn ?? true;
        const columnsToTranspose = transposeConfig.columnsToTranspose;
        const rowsToTranspose = transposeConfig.rowsToTranspose;
        this.getAdaptableInternalApi().showPopupWindow({
            id: (0, $226a20b901481288$export$4976abeffb8e0d2d),
            factoryId: (0, $226a20b901481288$export$4976abeffb8e0d2d),
            title: 'Transposed View',
            icon: 'grid',
            popupProps: {
                transposedColumnId: transposedColumnId,
                hideTransposedColumn: hideTransposedColumn,
                columnsToTranspose: columnsToTranspose,
                rowsToTranspose: rowsToTranspose
            }
        });
    }
    closeTransposedView() {
        this.getUserInterfaceApi().closeCustomWindowPopup('WINDOW_SHOW_TRANSPOSED_VIEW');
    }
    getAllAgGridColumns() {
        return this._adaptable.getAllGridColumns();
    }
    updateAgGridColumnState(columnState) {
        const columnExists = this.getColumnApi().doesColumnExist(columnState.colId);
        if (!columnExists) {
            this.logWarn(`Column with id ${columnState.colId} does not exist, could NOT update configuration`);
            return;
        }
        const agGridApi = this._adaptable.agGridAdapter.getAgGridApi();
        agGridApi.applyColumnState({
            state: [
                columnState
            ]
        });
    }
    updateAgGridColumnStates(columnStates) {
        const existingColumnStates = columnStates.filter((cc)=>this.getColumnApi().doesColumnExist(cc.colId));
        const notExistingColumnIds = columnStates.filter((cc)=>!this.getColumnApi().doesColumnExist(cc.colId)).map((cc)=>cc.colId);
        notExistingColumnIds.forEach((colId)=>{
            this.logWarn(`Column with id ${colId} does not exist, could NOT update configuration`);
        });
        const agGridApi = this._adaptable.agGridAdapter.getAgGridApi();
        agGridApi.applyColumnState({
            state: existingColumnStates
        });
    }
    setAgGridColumnDefinitions(columnDefinitions) {
        const agGridApi = this._adaptable.agGridAdapter.getAgGridApi();
        agGridApi.setGridOption('columnDefs', columnDefinitions);
    }
    updateAgGridColumnDefinition(columnDefinitionToBeUpdated) {
        const currentColDefs = [
            ...this._adaptable.agGridAdapter.getAgGridApi().getColumnDefs()
        ];
        const columnId = columnDefinitionToBeUpdated.colId;
        const doesColumnExist = this.getColumnApi().doesColumnExist(columnId);
        if (!doesColumnExist) {
            this.logWarn(`Column with id ${columnId} does not exist, will add it instead!`);
            const newColDefs = [
                ...currentColDefs,
                columnDefinitionToBeUpdated
            ];
            this.setAgGridColumnDefinitions(newColDefs);
            return;
        }
        const updatedColDefs = this._adaptable.agGridAdapter.traverseColDefs(currentColDefs, (colDef)=>{
            return colDef.colId === columnId ? {
                ...colDef,
                ...columnDefinitionToBeUpdated
            } : colDef;
        });
        this.setAgGridColumnDefinitions(updatedColDefs);
    }
    updateAgGridColumnDefinitions(columnDefinitionsToBeUpdated) {
        const currentColDefs = [
            ...this._adaptable.agGridAdapter.getAgGridApi().getColumnDefs()
        ];
        const updatedColDefs = this._adaptable.agGridAdapter.traverseColDefs(currentColDefs, (colDef)=>{
            const newColDef = newColumnDefinitions.find((c)=>c.colId === colDef.colId);
            return newColDef ? {
                ...colDef,
                ...newColDef
            } : colDef;
        });
        // find out new columns which are not in the current column definitions
        const currentColIds = [];
        this._adaptable.agGridAdapter.traverseColDefs(currentColDefs, (colDef)=>{
            currentColIds.push(colDef.colId);
            return colDef;
        });
        const newColumnDefinitions = columnDefinitionsToBeUpdated.filter((c)=>!currentColIds.includes(c.colId));
        if (newColumnDefinitions.length) this.logWarn(`Columns with ids ${newColumnDefinitions.map((c)=>c.colId).join(', ')} do not exist, will add them instead!`);
        this.setAgGridColumnDefinitions([
            ...updatedColDefs,
            ...newColumnDefinitions
        ]);
    }
    removeAgGridColumnDefinition(columnId) {
        const doesColumnExist = this.getColumnApi().doesColumnExist(columnId);
        if (!doesColumnExist) {
            this.logWarn(`Column with id ${columnId} does not exist!`);
            return;
        }
        const currentColDefs = this._adaptable.agGridAdapter.getAgGridApi().getColumnDefs();
        const updatedColDefs = this._adaptable.agGridAdapter.traverseColDefs(currentColDefs, (colDef)=>{
            return colDef.colId === columnId ? null : colDef;
        }).filter(Boolean);
        this.setAgGridColumnDefinitions(updatedColDefs);
    }
    addAgGridColumnDefinition(newColumnDefinition) {
        const currentColDefs = this.getAgGridColumnDefs();
        // just in case check of there is not already an existing column with the same id and eliminate it
        const sanitizedColDefs = this._adaptable.agGridAdapter.traverseColDefs(currentColDefs, (colDef)=>{
            return colDef.colId === newColumnDefinition.colId ? null : colDef;
        }).filter(Boolean);
        this.setAgGridColumnDefinitions([
            ...sanitizedColDefs,
            newColumnDefinition
        ]);
    }
}






var $9OAZF = parcelRequire("9OAZF");




var $9g4SS = parcelRequire("9g4SS");





class $2a64a24cbc6c35de$export$35875618dd55e6c3 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Compares 2 Layouts for equality
     * @param layout1 First Layout
     * @param layout2 Second Layout
     */ areLayoutsEqual(layout1, layout2) {
        return (0, $702a77ed6db22640$export$896875e1f4ecfbd7)(layout1, layout2);
    }
    /**
     * Returns what the layout supports.
     * This takes into account the data-source.
     */ getLayoutSupportedFeatures() {
        const layoutSupportedFeatures = {
            RowGroupedColumns: true,
            TableAggregationColumns: true,
            PivotAggregationColumns: true,
            PivotColumns: true,
            ColumnFilters: true,
            ColumnSorts: true,
            GridFilter: true,
            RowSummaries: true
        };
        if (this.getGridApi().isTreeDataGrid()) //  layoutSupportedFeatures.RowGroupedColumns = false;
        layoutSupportedFeatures.PivotColumns = false;
        if (this.getGridApi().getAgGridRowModelType() === 'viewport') {
            layoutSupportedFeatures.RowGroupedColumns = false;
            layoutSupportedFeatures.TableAggregationColumns = false;
            layoutSupportedFeatures.PivotAggregationColumns = false;
            layoutSupportedFeatures.PivotColumns = false;
        }
        if (!this.getFilterOptions().useAdaptableFiltering) {
            layoutSupportedFeatures.ColumnFilters = false;
            layoutSupportedFeatures.GridFilter = false;
        }
        if (this.getEntitlementApi().getEntitlementAccessLevelForModule((0, $42e863194fcb493f$export$edfe19743c8e0917)) == 'Hidden') layoutSupportedFeatures.GridFilter = false;
        if (this.getEntitlementApi().getEntitlementAccessLevelForModule((0, $42e863194fcb493f$export$4908330cb20abb96)) == 'Hidden') layoutSupportedFeatures.GridFilter = false;
        if (this._adaptable?.getAgGridRowModelType?.() !== 'clientSide') layoutSupportedFeatures.RowSummaries = false;
        return layoutSupportedFeatures;
    }
    hasLayoutSpecificObjects() {
        const layoutTagOptions = this.getLayoutOptions().layoutTagOptions;
        if (!layoutTagOptions) return false;
        if (layoutTagOptions.autoCheckTagsForLayouts == true || typeof layoutTagOptions?.isObjectExtendedInLayout === 'function') return true;
        return false;
    }
    isObjectExtendedInLayout(object, module, layout) {
        if (!this.hasLayoutSpecificObjects()) return true;
        const layoutTagOptions = this.getLayoutOptions().layoutTagOptions;
        if (layoutTagOptions?.autoCheckTagsForLayouts == true) return (0, $9g4SS.default).IsNullOrEmpty(object.Tags) ? true : object.Tags?.includes(layout.Name);
        const context = {
            adaptableObject: object,
            module: module,
            layout: layout,
            ...this.getAdaptableInternalApi().buildBaseContext()
        };
        return layoutTagOptions?.isObjectExtendedInLayout(context);
    }
    showLayoutNonExtendedObjects() {
        return this.getAdaptableState().Internal.Layout.showLayoutNonExtendedObjects;
    }
    isLayoutGrouped(layout) {
        if (!layout) layout = this.getLayoutApi().getCurrentLayout();
        return (layout?.RowGroupedColumns?.length || layout?.PivotGroupedColumns?.length) > 0;
    }
    setupRowSummaries() {
        if (!this._adaptable.agGridModulesAdapter.isAgGridModuleRegistered('PinnedRowModule')) {
            this.getAdaptableApi().consoleError('Layout Row Summaries require the AG Grid "PinnedRowModule". Please register this module.');
            return;
        }
        const rowSummaries = this.getAdaptableState().Internal?.RowSummary?.rowSummaries ?? [];
        const { top: top, bottom: bottom } = rowSummaries.reduce((acc, summaryRow)=>{
            const row = summaryRow.RowData;
            if (summaryRow.Position === 'Bottom' || !summaryRow.Position) acc.bottom.push(row);
            else acc.top.push(row);
            return acc;
        }, {
            top: [],
            bottom: []
        });
        const agGridAdapter = this.getAdaptableInternalApi().getAgGridAdapter();
        agGridAdapter.setGridOption('pinnedTopRowData', top);
        agGridAdapter.setGridOption('pinnedBottomRowData', bottom);
    }
    refreshLayout() {
        this._adaptable.refreshLayout();
    }
    getChangedColumnSorts(oldSorts, newSorts) {
        if ((0, $9g4SS.default).IsNullOrEmpty(oldSorts) && (0, $9g4SS.default).IsNullOrEmpty(newSorts)) return [];
        // If either one is empty but not both, all columns in the non-empty array have changed
        if ((0, $9g4SS.default).IsNullOrEmpty(oldSorts)) return newSorts.map((sort)=>sort.ColumnId);
        if ((0, $9g4SS.default).IsNullOrEmpty(newSorts)) return oldSorts.map((sort)=>sort.ColumnId);
        const changedColumnIds = [];
        // Create maps for quick lookup
        const oldSortsMap = new Map();
        oldSorts.forEach((sort)=>{
            oldSortsMap.set(sort.ColumnId, sort.SortOrder);
        });
        // Check columns in new sorts that changed from old sorts
        newSorts.forEach((newSort)=>{
            const oldSortOrder = oldSortsMap.get(newSort.ColumnId);
            // If column wasn't sorted before or sort order changed
            if (oldSortOrder === undefined || oldSortOrder !== newSort.SortOrder) changedColumnIds.push(newSort.ColumnId);
            // Remove processed columns from the map
            oldSortsMap.delete(newSort.ColumnId);
        });
        // Add remaining columns from old sorts (these were removed in new sorts)
        oldSortsMap.forEach((_, columnId)=>{
            changedColumnIds.push(columnId);
        });
        return changedColumnIds;
    }
    buildInitialLayout(providedLayout, type) {
        const layoutType = type || ((0, $702a77ed6db22640$export$db5fe50348e92ffe)(providedLayout) ? 'pivot' : 'table');
        const providedTableLayout = providedLayout;
        const providedPivotLayout = providedLayout;
        const initialEmptyLayout = layoutType === 'pivot' ? (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyPivotLayout({
            ...providedPivotLayout
        }) : (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyTableLayout({
            ...providedTableLayout
        });
        const defaultLayoutProperties = this.getLayoutCreationDefaultProperties(layoutType);
        const initialLayout = {
            ...initialEmptyLayout,
            ...defaultLayoutProperties
        };
        return initialLayout;
    }
    getLayoutCreationDefaultProperties(layoutType) {
        const layoutCreationDefPropsOption = this.getLayoutOptions().layoutCreationDefaultProperties;
        if (typeof layoutCreationDefPropsOption === 'object') {
            const initialProps = layoutType === 'table' ? layoutCreationDefPropsOption.tableLayout : layoutCreationDefPropsOption.pivotLayout;
            return initialProps;
        }
        if (typeof layoutCreationDefPropsOption === 'function') {
            const context = {
                layoutType: layoutType,
                ...this.getAdaptableInternalApi().buildBaseContext()
            };
            return layoutCreationDefPropsOption(context);
        }
        return {};
    }
    cloneLayout(layoutToClone) {
        let clonedLayout = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).cloneObject(layoutToClone);
        let result = {
            ...this.buildInitialLayout(clonedLayout)
        };
        result = (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).removeAdaptableObjectPrimitivesInlineDeep(result);
        delete result.Name;
        return result;
    }
    getCurrentLayout_perfOptimized() {
        // perf-optimized version of getCurrentLayout()
        const layoutState = this.getAdaptableState().Layout;
        const currentLayoutName = layoutState.CurrentLayout;
        if (!currentLayoutName) return null;
        return layoutState.Layouts.find((layout)=>layout.Name === currentLayoutName);
    }
    getCurrentLayoutRowGroupDisplayType() {
        return this.getLayoutApi().getCurrentLayout()?.RowGroupDisplayType ?? 'single';
    }
    areAllGroupedColumnsFilterable() {
        const groupedAgColumns = this.getAgGridApi().getRowGroupColumns();
        let allHaveFilter = true;
        let allHaveFloatingFilter = true;
        for (const column of groupedAgColumns){
            // Early exit: no need to continue if both are already false
            if (!allHaveFilter && !allHaveFloatingFilter) break;
            const colDef = column.getColDef();
            if (allHaveFilter && !colDef.filter) allHaveFilter = false;
            if (allHaveFloatingFilter && !colDef.floatingFilter) allHaveFloatingFilter = false;
        }
        return {
            filter: allHaveFilter,
            floatingFilter: allHaveFloatingFilter
        };
    }
}




class $2812955cc66c9b1e$export$20c7b432cfa5d246 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $2a64a24cbc6c35de$export$35875618dd55e6c3)(_adaptable);
    }
    updateCurrentLayout(updateFn) {
        const currentLayout = this.getCurrentLayout();
        const updatedLayout = (0, $702a77ed6db22640$export$d859d72b10c9a984)(updateFn(structuredClone(currentLayout)));
        this.createOrUpdateLayout(updatedLayout);
    }
    isCurrentLayoutPivot() {
        return (0, $702a77ed6db22640$export$db5fe50348e92ffe)(this.getCurrentLayout());
    }
    getLayoutState() {
        return this.getAdaptableState().Layout;
    }
    getCurrentVisibleColumnIdsMapForTableLayout() {
        const layout = this.getCurrentLayout();
        if ((0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)) return {};
        return layout.TableColumns.reduce((acc, colId)=>{
            acc[colId] = true;
            return acc;
        }, {});
    }
    getCurrentVisibleColumnIdsForTableLayout() {
        const layout = this.getCurrentLayout();
        if ((0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)) return [];
        return this.getAgGridApi().getAllDisplayedColumns().map((col)=>col.getColId());
    }
    getCurrentVisibleColumnIdsForPivotLayout() {
        const layout = this.getCurrentLayout();
        if (!(0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)) return [];
        return this.getAgGridApi().getAllDisplayedColumns().map((col)=>col.getColId());
    }
    getCurrentRowGroupsColumnIds() {
        const layout = this.getCurrentLayout();
        if ((0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)) return layout.PivotGroupedColumns;
        return layout.RowGroupedColumns;
    }
    setLayout(layoutName) {
        if ((0, $9OAZF.default).IsNullOrEmpty(layoutName)) return;
        if (layoutName === this.getCurrentLayoutName()) return;
        let layout = this.getLayoutByName(layoutName);
        if (this.checkItemExists(layout, layoutName, 'Layout')) this.dispatchAction($2c155f3e4804e29e$export$256743b3edbbec77(layoutName));
    }
    getCurrentLayout() {
        let layoutName = this.getLayoutState().CurrentLayout;
        return this.getLayoutByName(layoutName) ?? (0, $58846ea7f4156db7$export$2657cb1ad92c69eb);
    }
    getCurrentLayoutColumnSort(columnId) {
        const currentLayout = this.getCurrentLayout();
        return currentLayout?.ColumnSorts?.find?.((sort)=>sort.ColumnId === columnId)?.SortOrder ?? null;
    }
    getCurrentLayoutName() {
        return this.getAdaptableState().Layout.CurrentLayout;
    }
    getLayoutByName(layoutName) {
        if ((0, $9OAZF.default).IsNotNullOrEmpty(layoutName)) {
            let layout = this.getLayouts().find((l)=>l.Name == layoutName);
            if (this.checkItemExists(layout, layoutName, 'Layout')) return layout;
        }
    }
    setExtendedLayout(extendedLayout) {
        this.setLayout(extendedLayout.Layout.Name);
    }
    createOrUpdateExtendedLayout(extendedLayoutInfo) {
        const config = {
            includeLayoutNotExtendedObjects: true
        };
        // Alerts
        const alertExtensions = extendedLayoutInfo.Extensions.filter((e)=>{
            return e.Module == 'Alert';
        });
        alertExtensions.forEach((le)=>{
            const alertDefinition = le.Object;
            const existingAlertDefinition = this.getAlertApi().getAlertDefinitionById(alertDefinition.Uuid, config);
            if (!existingAlertDefinition) this.getAlertApi().addAlertDefinition(alertDefinition);
        });
        // Custom Sorts
        const customSortExtensions = extendedLayoutInfo.Extensions.filter((e)=>{
            return e.Module == 'CustomSort';
        });
        customSortExtensions.forEach((le)=>{
            const customSort = le.Object;
            const existingCustomSort = this.getCustomSortApi().getCustomSortById(customSort.Uuid, config);
            if (!existingCustomSort) this.getCustomSortApi().addCustomSort(customSort);
        });
        // Flashing Cells
        const flashingCellExtensions = extendedLayoutInfo.Extensions.filter((e)=>{
            return e.Module == 'FlashingCell';
        });
        flashingCellExtensions.forEach((le)=>{
            const flashingCellDefinition = le.Object;
            const existingflashingCellDefinition = this.getFlashingCellApi().getFlashingCellDefinitionById(flashingCellDefinition.Uuid, config);
            if (!existingflashingCellDefinition) this.getFlashingCellApi().addFlashingCellDefinition(flashingCellDefinition);
        });
        // FormatColumns
        const formatColumnExtensions = extendedLayoutInfo.Extensions.filter((e)=>{
            return e.Module == 'FormatColumn';
        });
        formatColumnExtensions.forEach((le)=>{
            const formatColumn = le.Object;
            const existingFormatColumn = this.getFormatColumnApi().getFormatColumnByUuId(formatColumn.Uuid, config);
            if (!existingFormatColumn) this.getFormatColumnApi().addFormatColumn(formatColumn);
        });
        // Plus Minus
        const plusMinusExtensions = extendedLayoutInfo.Extensions.filter((e)=>{
            return e.Module == 'PlusMinus';
        });
        plusMinusExtensions.forEach((le)=>{
            const plusMinusNudge = le.Object;
            const existingPlusMinusNudge = this.getPlusMinusApi().getPlusMinusById(plusMinusNudge.Uuid, config);
            if (!existingPlusMinusNudge) this.getPlusMinusApi().addPlusMinusNudge(plusMinusNudge);
        });
        // Schedule
        const scheduleExtensions = extendedLayoutInfo.Extensions.filter((e)=>{
            return e.Module == 'Schedule';
        });
        scheduleExtensions.forEach((le)=>{
            const schedule = le.Object;
            const existingSchedule = this.getScheduleApi().getScheduleById(schedule.Uuid, config);
            if (!existingSchedule) {
                if (existingSchedule.ScheduleType == 'Reminder') this.getScheduleApi().addReminderSchedule(schedule);
                if (existingSchedule.ScheduleType == 'Report') this.getScheduleApi().addReportSchedule(schedule);
            }
        });
        // Shortcut
        const shortCutExtensions = extendedLayoutInfo.Extensions.filter((e)=>{
            return e.Module == 'Shortcut';
        });
        shortCutExtensions.forEach((le)=>{
            const shortcut = le.Object;
            const existingShortcut = this.getShortcutApi().getShortcutById(shortcut.Uuid, config);
            if (!existingShortcut) this.getShortcutApi().addShortcut(shortcut);
        });
        // StyledColumn
        const styledColumnExtensions = extendedLayoutInfo.Extensions.filter((e)=>{
            return e.Module == 'StyledColumn';
        });
        styledColumnExtensions.forEach((le)=>{
            const styledColumn = le.Object;
            const existingStyledColumn = this.getStyledColumnApi().getStyledColumnById(styledColumn.Uuid, config);
            if (!existingStyledColumn) this.getStyledColumnApi().addStyledColumn(styledColumn);
        });
        this.createOrUpdateLayout(extendedLayoutInfo.Layout);
    }
    getExtendedLayoutByName(layoutName) {
        const layout = this.getLayoutByName(layoutName);
        if (!layout) return undefined;
        const config = {
            includeLayoutNotExtendedObjects: false,
            extendedLayoutName: layoutName
        };
        // cannot see a better way than to go through this module by module...
        let extensions = [];
        this.getAlertApi().getAlertDefinitions(config).forEach((obj)=>{
            extensions.push({
                Module: 'Alert',
                Object: obj
            });
        });
        this.getCustomSortApi().getCustomSorts(config).forEach((obj)=>{
            extensions.push({
                Module: 'CustomSort',
                Object: obj
            });
        });
        this.getFlashingCellApi().getFlashingCellDefinitions(config).forEach((obj)=>{
            extensions.push({
                Module: 'FlashingCell',
                Object: obj
            });
        });
        this.getFormatColumnApi().getFormatColumns(config).forEach((obj)=>{
            extensions.push({
                Module: 'FormatColumn',
                Object: obj
            });
        });
        this.getPlusMinusApi().getAllPlusMinus(config).forEach((obj)=>{
            extensions.push({
                Module: 'PlusMinus',
                Object: obj
            });
        });
        this.getScheduleApi().getReminderSchedules(config).forEach((obj)=>{
            extensions.push({
                Module: 'Schedule',
                Object: obj
            });
        });
        this.getShortcutApi().getShortcuts(config).forEach((obj)=>{
            extensions.push({
                Module: 'Shortcut',
                Object: obj
            });
        });
        this.getStyledColumnApi().getStyledColumns(config).forEach((obj)=>{
            extensions.push({
                Module: 'StyledColumn',
                Object: obj
            });
        });
        return {
            Layout: layout,
            Extensions: extensions
        };
    }
    cloneExtendedLayout(extendedLayoutToClone, layoutName) {
        // first clone the underlying Layout
        const clonedLayout = this.cloneLayout(extendedLayoutToClone.Layout, layoutName);
        if (clonedLayout == false) return false;
        // Alerts
        const alertExtensions = extendedLayoutToClone.Extensions.filter((e)=>e.Module == 'Alert');
        alertExtensions.forEach((le)=>{
            const alertDef = le.Object;
            alertDef.Tags?.push(layoutName);
            this.getAlertApi().editAlertDefinition(alertDef);
        });
        // Custom Sorts
        const customSortExtensions = extendedLayoutToClone.Extensions.filter((e)=>{
            return e.Module == 'CustomSort';
        });
        customSortExtensions.forEach((le)=>{
            const customSort = le.Object;
            customSort.Tags?.push(layoutName);
            this.getCustomSortApi().editCustomSort(customSort);
        });
        // Flashing Cells
        const flashingCellExtensions = extendedLayoutToClone.Extensions.filter((e)=>{
            return e.Module == 'FlashingCell';
        });
        flashingCellExtensions.forEach((le)=>{
            const flashingCellDef = le.Object;
            flashingCellDef.Tags?.push(layoutName);
            this.getFlashingCellApi().editFlashingCellDefinition(flashingCellDef);
        });
        // FormatColumns
        const formatColumnExtensions = extendedLayoutToClone.Extensions.filter((e)=>e.Module == 'FormatColumn');
        formatColumnExtensions.forEach((le)=>{
            const formatCol = le.Object;
            formatCol.Tags?.push(layoutName);
            this.getFormatColumnApi().editFormatColumn(formatCol);
        });
        // Plus Minus
        const plusMinusExtensions = extendedLayoutToClone.Extensions.filter((e)=>{
            return e.Module == 'PlusMinus';
        });
        plusMinusExtensions.forEach((le)=>{
            const plusMinusNudge = le.Object;
            plusMinusNudge.Tags?.push(layoutName);
            this.getPlusMinusApi().editPlusMinusNudge(plusMinusNudge);
        });
        // Schedule
        const scheduleExtensions = extendedLayoutToClone.Extensions.filter((e)=>{
            return e.Module == 'Schedule';
        });
        scheduleExtensions.forEach((le)=>{
            const schedule = le.Object;
            schedule.Tags?.push(layoutName);
            this.getScheduleApi().editSchedule(schedule);
        });
        // Shortcut
        const shortCutExtensions = extendedLayoutToClone.Extensions.filter((e)=>{
            return e.Module == 'Shortcut';
        });
        shortCutExtensions.forEach((le)=>{
            const shortcut = le.Object;
            shortcut.Tags?.push(layoutName);
            this.getShortcutApi().editShortcut(shortcut);
        });
        // StyledColumn
        const styledColumnExtensions = extendedLayoutToClone.Extensions.filter((e)=>{
            return e.Module == 'StyledColumn';
        });
        styledColumnExtensions.forEach((le)=>{
            const styledColumn = le.Object;
            styledColumn.Tags?.push(layoutName);
            this.getStyledColumnApi().editStyledColumn(styledColumn);
        });
        // now create the new Extended Layout with the same extensions
        const extendedLayout = {
            Layout: clonedLayout,
            Extensions: extendedLayoutToClone.Extensions
        };
        return extendedLayout;
    }
    getLayouts() {
        return this.getAdaptableState().Layout.Layouts ?? [];
    }
    getLayoutById(id) {
        return this.getLayouts()?.find((layout)=>layout?.Uuid === id);
    }
    saveCurrentLayout() {
        let currentLayout = this.getCurrentLayout();
        if (currentLayout) this.createOrUpdateLayout(currentLayout);
    }
    doesLayoutExist(layout) {
        if (layout == null) return false;
        let existingLayout = this.getLayouts().find((l)=>l.Uuid == layout.Uuid || l.Name === layout.Name);
        return existingLayout != null;
    }
    createAndSetLayout(layoutToCreate) {
        const layout = this.createLayout(layoutToCreate);
        if (layout) this.setLayout(layoutToCreate.Name);
        return layout;
    }
    createLayout(layoutToCreate) {
        if (this.doesLayoutExist(layoutToCreate)) {
            this.logError("Cannot create layout with the Name: '" + layoutToCreate.Name + "' as it already exists");
            return false;
        }
        const newLayout = this.internalApi.buildInitialLayout(layoutToCreate);
        this.addUidToAdaptableObject(newLayout);
        this.dispatchAction($2c155f3e4804e29e$export$b6d8346e3e2d65d1(newLayout));
        return newLayout;
    }
    cloneAndSetLayout(layoutToClone, layoutName) {
        const newLayout = this.cloneLayout(layoutToClone, layoutName);
        if (newLayout) this.setLayout(layoutName);
        return newLayout;
    }
    cloneLayout(layoutToClone, layoutName) {
        if (!this.doesLayoutExist(layoutToClone)) {
            this.logError("Cannot clone Layout with Name: '" + layoutName + "' as other Layout does not exist");
            return false;
        }
        const newLayout = {
            ...this.internalApi.cloneLayout(layoutToClone),
            Name: layoutName,
            Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)()
        };
        this.dispatchAction($2c155f3e4804e29e$export$b6d8346e3e2d65d1(newLayout));
        return this.getLayoutById(newLayout.Uuid);
    }
    setColumnCaption(columnId, caption) {
        if ((0, $9OAZF.default).IsNotNullOrEmpty(columnId) && (0, $9OAZF.default).IsNotNullOrEmpty(caption)) this.updateCurrentLayout((layout)=>{
            layout.ColumnHeaders = {
                ...layout.ColumnHeaders
            };
            layout.ColumnHeaders[columnId] = caption;
            return layout;
        });
    }
    createOrUpdateLayout(layout) {
        if (!this.doesLayoutExist(layout)) this.createLayout(layout);
        else this.dispatchAction($2c155f3e4804e29e$export$ca72012c06bdea95(layout));
    }
    showChangeColumnCaption(column) {
        const currentLayout = this.getCurrentLayout();
        const customHeader = currentLayout.ColumnHeaders?.[column.columnId] ?? column.friendlyName;
        this.dispatchAction((0, $dc56b6267ce4d0bb$export$7e320e36addbb3a3)({
            Header: `Change Caption for "${column.friendlyName}"`,
            Msg: '',
            DefaultValue: customHeader,
            ConfirmActionCreator: (inputText)=>{
                if (inputText !== customHeader) this.setColumnCaption(column.columnId, inputText);
                return {
                    type: 'NOOP'
                };
            }
        }));
    }
    openLayoutSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$802bb096eb63f491);
    }
    showLayoutEditor(layoutName, layoutType, action = 'Edit') {
        let preparedAction = action;
        if (![
            'Edit',
            'New',
            'Clone'
        ].includes(action)) {
            preparedAction = 'Edit';
            this.logError(`When opening the layout editor the action must be one of: New, Clone, Edit; given: ${action}`);
        }
        let layout = layoutName ? this.getLayoutByName(layoutName) : this.getCurrentLayout();
        if (preparedAction === 'New') layout = null;
        this.showModulePopup($42e863194fcb493f$export$802bb096eb63f491, {
            source: 'Toolbar',
            action: preparedAction,
            value: layout,
            config: {
                layoutType: layoutType
            }
        });
    }
    deleteLayout(layout) {
        const layoutCount = this.getLayouts().length;
        if (layoutCount === 1) {
            this.logWarn('You cannot delete the only Layout.  AdapTable always requires one layout');
            return;
        }
        this.dispatchAction($2c155f3e4804e29e$export$16171190943cf4cb(layout));
    }
    deleteLayoutByName(layoutName) {
        const layout = this.getLayoutByName(layoutName);
        if (!layout) {
            this.logWarn('No Layout exists with that name');
            return;
        }
        return this.deleteLayout(layout);
    }
    removeColumnFromCurrentLayout(columnId) {
        const column = this.getColumnApi().getColumnWithColumnId(columnId);
        if (column) {
            const layout = this.getCurrentLayout();
            if (!(0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)) this.updateCurrentLayout((layout)=>{
                layout.TableColumns = layout.TableColumns.filter((c)=>c !== columnId);
                return layout;
            });
            else this.updateCurrentLayout((layout)=>{
                layout.PivotColumns = layout.PivotColumns.filter((c)=>c !== columnId);
                return layout;
            });
        }
    }
    addColumnToCurrentLayout(columnId) {
        const column = this.getColumnApi().getColumnWithColumnId(columnId);
        if (column) {
            const layout = this.getCurrentLayout();
            if (!(0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)) this.updateCurrentLayout((layout)=>{
                layout.TableColumns.push(columnId);
                return layout;
            });
            else this.updateCurrentLayout((layout)=>{
                layout.PivotColumns.push(columnId);
                return layout;
            });
        }
    }
}





class $af8902136581dfaa$export$c778fae82800158b extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getPlusMinusState() {
        return this.getAdaptableState().PlusMinus;
    }
    getAllPlusMinus(config) {
        const layoutSpecificPlusMinusNudges = this.handleLayoutExtensionObjects(this.getPlusMinusState().PlusMinusNudges, 'PlusMinus', config) ?? [];
        return layoutSpecificPlusMinusNudges.filter((plusMinusNudge)=>plusMinusNudge.Rule == undefined || plusMinusNudge.Rule.BooleanExpression != undefined);
    }
    getPlusMinusById(id, config) {
        return this.getAllPlusMinus(config).find((plusMinus)=>plusMinus?.Uuid === id);
    }
    getPlusMinusNudgeByName(name) {
        return this.getAllPlusMinus().find((plusMinus)=>plusMinus.Name === name);
    }
    getAllActivePlusMinus(config) {
        return this.getAllPlusMinus(config).filter((plusMinusNudge)=>!plusMinusNudge.IsSuspended);
    }
    getAllSuspendedPlusMinus(config) {
        return this.getAllPlusMinus(config).filter((plusMinusNudge)=>plusMinusNudge.IsSuspended);
    }
    runPlusMinusNudge(plusMinusNudge, cellsToUpdate, direction) {
        let plusMinusModule = this.getAdaptableInternalApi().getModules().get($42e863194fcb493f$export$1d33a3a77a9299ff);
        plusMinusModule.applyPlusMinus([
            plusMinusNudge
        ], cellsToUpdate, direction);
    }
    applyPlusMinus(cellUpdateRequests) {
        this.dispatchAction($36058826e464bb44$export$cd91cbe99074b1f9(cellUpdateRequests));
    }
    openPlusMinusSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$1d33a3a77a9299ff);
    }
    editPlusMinusNudge(plusMinusNudge) {
        this.dispatchAction($36058826e464bb44$export$15d09d450ef43f85(plusMinusNudge));
        return this.getPlusMinusById(plusMinusNudge.Uuid);
    }
    deletePlusMinusNudge(plusMinusNudge) {
        this.dispatchAction($36058826e464bb44$export$94d9a67dbae3ab19(plusMinusNudge));
    }
    suspendPlusMinusNudge(plusMinusNudge) {
        this.dispatchAction($36058826e464bb44$export$4147f49703def3fa(plusMinusNudge));
        return this.getPlusMinusById(plusMinusNudge.Uuid);
    }
    unSuspendPlusMinusNudge(plusMinusNudge) {
        this.dispatchAction($36058826e464bb44$export$e1c560b2519d0821(plusMinusNudge));
        return this.getPlusMinusById(plusMinusNudge.Uuid);
    }
    addPlusMinusNudge(plusMinusNudge) {
        this.addUidToAdaptableObject(plusMinusNudge);
        this.dispatchAction($36058826e464bb44$export$b57847b7da91dcb4(plusMinusNudge));
        return this.getPlusMinusById(plusMinusNudge.Uuid);
    }
}






class $7e5f6852810dc25d$export$6dc886cb7f15fda5 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getQuickSearchState() {
        return this.getAdaptableState().QuickSearch;
    }
    runQuickSearch(quickSearchText) {
        this.dispatchAction($a9684a89f07662ba$export$e6464f631b683a94(quickSearchText));
    }
    clearQuickSearch() {
        this.dispatchAction($a9684a89f07662ba$export$e6464f631b683a94(''));
    }
    gotoNextMatch() {
        this.getAdaptableApi().agGridApi.findNext();
    }
    gotoPreviousMatch() {
        this.getAdaptableApi().agGridApi.findPrevious();
    }
    getQuickSearchValue() {
        return this.getQuickSearchState().QuickSearchText;
    }
    getQuickSearchCellMatchStyle() {
        return this.getQuickSearchState().CellMatchStyle;
    }
    getQuickSearchTextMatchStyle() {
        return this.getQuickSearchState().TextMatchStyle;
    }
    getQuickSearchCurrentTextMatchStyle() {
        return this.getQuickSearchState().CurrentTextMatchStyle;
    }
    setQuickSearchCellMatchStyle(style) {
        this.dispatchAction($a9684a89f07662ba$export$fe53e034aaf6474a(style));
    }
    openQuickSearchSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$cf7621e489e71e3c);
    }
    showFloatingQuickSearch() {
        this.dispatchAction($5b564bb703f29152$export$3b7d4806745ba450(true));
    }
    hideFloatingQuickSearch() {
        this.dispatchAction($5b564bb703f29152$export$3b7d4806745ba450(false));
    }
}





class $c0ff6ba949be26a9$export$57d47f570df63072 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getShortcutState() {
        return this.getAdaptableState().Shortcut;
    }
    getShortcuts(config) {
        return this.handleLayoutExtensionObjects(this.getShortcutState().Shortcuts, 'Shortcut', config) ?? [];
    }
    getShortcutById(id, config) {
        return this.getShortcuts(config).find((shortcut)=>shortcut?.Uuid === id);
    }
    getShortcutByName(name) {
        return this.getShortcuts().find((shortcut)=>shortcut.Name === name);
    }
    getActiveShortcuts(config) {
        return this.getShortcuts(config).filter((shortcut)=>!shortcut.IsSuspended);
    }
    getSuspendedShortcuts(config) {
        return this.getShortcuts(config).filter((shortcut)=>shortcut.IsSuspended);
    }
    addShortcut(shortcut) {
        this.addUidToAdaptableObject(shortcut);
        this.dispatchAction($2172826b4c3056a0$export$cf28c5d1cdf589fe(shortcut));
        return this.getShortcutById(shortcut.Uuid);
    }
    editShortcut(shortcut) {
        this.dispatchAction($2172826b4c3056a0$export$1382c83aa7e9dbac(shortcut));
        return this.getShortcutById(shortcut.Uuid);
    }
    deleteShortcut(shortcut) {
        this.dispatchAction($2172826b4c3056a0$export$a5fd989017fb8235(shortcut));
    }
    deleteAllShortcuts() {
        this.getShortcuts().forEach((s)=>{
            this.deleteShortcut(s);
        });
    }
    suspendShortcut(shortcut) {
        this.dispatchAction($2172826b4c3056a0$export$22e447d5e4c01620(shortcut));
        return this.getShortcutById(shortcut.Uuid);
    }
    unSuspendShortcut(shortcut) {
        this.dispatchAction($2172826b4c3056a0$export$3b0cf718b694f89b(shortcut));
        return this.getShortcutById(shortcut.Uuid);
    }
    suspendAllShortcut() {
        this.dispatchAction($2172826b4c3056a0$export$79ba5c952010fc13());
    }
    unSuspendAllShortcut() {
        this.dispatchAction($2172826b4c3056a0$export$dc49008b1a140c86());
    }
    openShortcutSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$ef61c24f038f357f);
    }
}





class $14f28fb4d8e440fa$export$bebbed181493d9cf extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    setSmartEditOperation(mathOperation) {
        this.dispatchAction($5b564bb703f29152$export$bfdacd6a132082c7(mathOperation));
    }
    getSmartEditOperation() {
        return this.getAdaptableState().Internal.SmartEdit.SmartEditOperation;
    }
    setSmartEditValue(smartEditValue) {
        this.dispatchAction($5b564bb703f29152$export$c279917007950b1(smartEditValue));
    }
    getSmartEditValue() {
        return this.getAdaptableState().Internal.SmartEdit.SmartEditValue;
    }
    openSmartEditSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$3fb170c57e2678e6);
    }
    getSmartEditCustomOperations() {
        return this.getEditOptions().smartEditCustomOperations ?? [];
    }
    setCustomSmartEditOperation(customOperationName) {
        const customOperation = this.getSmartEditCustomOperations().find((so)=>so.name == customOperationName);
        if (customOperation) this.dispatchAction($5b564bb703f29152$export$bfdacd6a132082c7(customOperation));
    }
}








var $acw62 = parcelRequire("acw62");

var $5aWMQ = parcelRequire("5aWMQ");

var $9OAZF = parcelRequire("9OAZF");


class $d4aa94fd17d0c655$export$2e6e5a6892200523 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    addSystemStatusMessageInfo(systemStatusMessageInfo) {
        const maxMessagesInStore = this.getNotificationsOptions().maxSystemMessagesInStore;
        this.dispatchAction($5b564bb703f29152$export$852ef8a161eaa232(systemStatusMessageInfo, maxMessagesInStore));
    }
    getSystemStatusMessageInfos() {
        return this.getAdaptableState().Internal.SystemStatusMessages;
    }
}



var $9AsCL = parcelRequire("9AsCL");
class $b7be6d55f427f5bc$export$c875cb61a2bb358d extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    systemStatusDiv;
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $d4aa94fd17d0c655$export$2e6e5a6892200523)(_adaptable);
    }
    setSystemStatus(statusMessage, messageType, statusFurtherInformation) {
        let systemStatusMessageInfo = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateSystemStatusMessageInfo(statusMessage, messageType, statusFurtherInformation ? statusFurtherInformation : '');
        this.internalApi.addSystemStatusMessageInfo(systemStatusMessageInfo);
        // publish the event
        this.getEventApi().internalApi.fireSystemStatusMessageDisplayedEvent(systemStatusMessageInfo);
        if (this.getNotificationsOptions().showSystemStatusMessageNotifications) {
            const alertApi = this.getAlertApi();
            let fullMessage = statusMessage;
            if ((0, $9OAZF.default).IsNotNullOrEmpty(statusFurtherInformation)) fullMessage += '\n' + statusFurtherInformation;
            switch(messageType){
                case 'Success':
                    alertApi.showAlertSuccess('System Status', fullMessage);
                    return;
                case 'Info':
                    alertApi.showAlertInfo('System Status', fullMessage);
                    return;
                case 'Warning':
                    alertApi.showAlertWarning('System Status', fullMessage);
                    return;
                case 'Error':
                    alertApi.showAlertError('System Status', fullMessage);
                    return;
            }
        }
        if (this.getContainerOptions().systemStatusContainer != null) this.displayMessageInDiv(statusMessage, statusFurtherInformation, messageType);
        // doesnt do anything but useful for Audit
        this.dispatchAction($0c72086b8e93ba39$export$a449de6be534d0c2(systemStatusMessageInfo));
    }
    displayMessageInDiv(statusMessage, statusFurtherInformation, messageType) {
        if (!this.systemStatusDiv) this.systemStatusDiv = (0, $9AsCL.resolveContainerElement)(this.getContainerOptions().systemStatusContainer, this.getAdaptableInternalApi().buildBaseContext());
        if (this.systemStatusDiv) {
            if ((0, $9OAZF.default).IsNotNullOrEmpty(statusFurtherInformation)) statusMessage += statusFurtherInformation;
            const foreColor = messageType ? (0, $5aWMQ.default).getColorByMessageType(messageType) : 'black';
            this._adaptable.renderReactRoot((0, $acw62.createElement)('span', {
                style: {
                    color: foreColor
                }
            }, statusMessage), this.systemStatusDiv);
        }
    }
    setErrorSystemStatus(statusMessage, statusFurtherInformation) {
        this.setSystemStatus(statusMessage, 'Error', statusFurtherInformation);
    }
    setWarningSystemStatus(statusMessage, statusFurtherInformation) {
        this.setSystemStatus(statusMessage, 'Warning', statusFurtherInformation);
    }
    setSuccessSystemStatus(statusMessage, statusFurtherInformation) {
        this.setSystemStatus(statusMessage, 'Success', statusFurtherInformation);
    }
    setInfoSystemStatus(statusMessage, statusFurtherInformation) {
        this.setSystemStatus(statusMessage, 'Info', statusFurtherInformation);
    }
    openSystemStatusSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$49045387ac7420d5);
    }
    getCurrentSystemStatusMessageInfo() {
        const messageInfos = this.internalApi.getSystemStatusMessageInfos() || [];
        const orderedArray = messageInfos.sort((a, b)=>b.timestamp.getTime() - a.timestamp.getTime());
        return orderedArray[0];
    }
    deleteAllSystemStatusMessages() {
        this.dispatchAction($5b564bb703f29152$export$939ffb83766a0a85());
    }
    destroy() {
        this.systemStatusDiv = null;
        super.destroy();
    }
}






const $bf6534dfcdb5e921$export$cc02ea91de25c890 = [
    {
        Name: (0, $58846ea7f4156db7$export$ee8dd85a2e01b86f),
        Description: 'Light Theme'
    },
    {
        Name: (0, $58846ea7f4156db7$export$84426164da6cf571),
        Description: 'Dark Theme'
    },
    {
        Name: (0, $58846ea7f4156db7$export$9fa5d5f0144954cb),
        Description: 'OS Theme'
    }
];




class $acf27930f8fb04bf$export$f9ebeed2f855dbef extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    isSystemTheme(themeName) {
        return this.getThemeApi().getSystemThemes().some((theme)=>theme.Name === themeName);
    }
    getThemeClassName(theme) {
        return `ab--theme-${theme}`;
    }
    getDOMPreferredColorScheme() {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    openInWindow() {
        this.getAdaptableInternalApi().showPopupWindow({
            id: (0, $226a20b901481288$export$d87df153f562e7a3),
            title: 'Theme',
            icon: 'theme',
            factoryId: (0, $226a20b901481288$export$d87df153f562e7a3),
            popupProps: {}
        });
    }
}




class $c79b7a5583d9bf24$export$4a63af7049108867 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $acf27930f8fb04bf$export$f9ebeed2f855dbef)(_adaptable);
    }
    getThemeState() {
        return this.getAdaptableState().Theme;
    }
    loadTheme(theme) {
        this.dispatchAction($436d9a36bf9edcd8$export$1b9e02e625a724dc(theme));
    }
    loadLightTheme() {
        this.loadTheme('light');
    }
    loadDarkTheme() {
        this.loadTheme('dark');
    }
    getCurrentTheme() {
        return this.getAdaptableState().Theme.CurrentTheme;
    }
    getCurrentThemeObject() {
        const currentTheme = this.getCurrentTheme();
        return this.getThemes().find((themeObj)=>themeObj.Name === currentTheme);
    }
    setSystemThemes(systemThemes) {
        this.dispatchAction($436d9a36bf9edcd8$export$feda9bd84e4f320c(systemThemes));
    }
    setUserThemes(userThemes) {
        this.dispatchAction($436d9a36bf9edcd8$export$26e2802959258c51(userThemes));
    }
    getSystemThemes() {
        const themes = this.getAdaptableState().Theme.SystemThemes ?? [];
        return themes.map((theme)=>{
            if (typeof theme === 'string') {
                const description = (0, $bf6534dfcdb5e921$export$cc02ea91de25c890).find((staticTheme)=>staticTheme.Name === theme)?.Description ?? theme;
                return {
                    Name: theme,
                    Description: description
                };
            }
            return theme;
        });
    }
    applyCurrentTheme() {
        const currentTheme = this.getThemes().filter((theme)=>typeof theme === 'string' ? theme === this.getCurrentTheme() : theme.Name === this.getCurrentTheme())[0];
        if (!currentTheme) return;
        this._adaptable.applyAdaptableTheme(currentTheme);
        this.getEventApi().internalApi.fireThemeChangedEvent(currentTheme, 'ThemeSelected');
    }
    getUserThemes() {
        return this.getAdaptableState().Theme.UserThemes ?? [];
    }
    getThemes() {
        return [
            ...this.getSystemThemes(),
            ...this.getUserThemes()
        ];
    }
    getThemeByName(themeName) {
        return this.getThemes().find((theme)=>theme.Name === themeName);
    }
    openThemeSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$ebf1703e41256059);
    }
    getAgGridCurrentThemeName() {
        (0, $58cdac7f2ad9e749$export$24dadfefe309dcd6)(this._adaptable.logger, 'ThemeApi', 'getAgGridCurrentThemeName', null, `This is required only for AG Grid's legacy themes. See https://www.ag-grid.com/javascript-data-grid/theming-v32/`);
        return this._adaptable.agGridThemeAdapter.getAgGridCurrentThemeClassNames();
    }
    editTheme(theme) {
        this.dispatchAction($436d9a36bf9edcd8$export$6974728752898f91(theme));
        this.getEventApi().internalApi.fireThemeChangedEvent(theme, 'ThemeEdited');
        const currentTheme = this.getCurrentTheme();
        if (currentTheme === theme.Name) this._adaptable.applyAdaptableTheme(theme);
    }
    addUserTheme(theme) {
        (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(theme);
        this.dispatchAction($436d9a36bf9edcd8$export$cedf576ec9cfa2ac(theme));
    }
    deleteUserTheme(theme) {
        this.dispatchAction($436d9a36bf9edcd8$export$2e6aad93bd77037(theme));
    }
}




var $9g4SS = parcelRequire("9g4SS");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");




var $9AsCL = parcelRequire("9AsCL");


var $acw62 = parcelRequire("acw62");

const $1acaa6ff89593611$export$edafaa7cfa4a5013 = ({ render: render, frameworkComponent: frameworkComponent, componentName: componentName = 'N/A', onDestroy: onDestroy, ...rest })=>{
    const ref = $acw62.useRef(null);
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [contentsHTML, setContentsHTML] = $acw62.useState('');
    $acw62.useLayoutEffect(()=>{
        const element = ref.current;
        const adaptableApi = adaptable.api;
        if (render) {
            const html = render({
                phase: 'onMount',
                element: element,
                ...adaptableApi.internalApi.buildBaseContext()
            });
            setContentsHTML(html);
        } else if (frameworkComponent) adaptableApi.internalApi.createFrameworkComponent(element, frameworkComponent, 'toolbar');
        return ()=>{
            if (render) render({
                phase: 'onDestroy',
                element: element,
                ...adaptableApi.internalApi.buildBaseContext()
            });
            else if (frameworkComponent) {
                onDestroy?.();
                adaptableApi.internalApi.destroyFrameworkComponent(element, frameworkComponent, // @ts-ignore
                componentName);
            }
        };
    }, []);
    const RFC = adaptable.variant === 'react' ? frameworkComponent : null;
    return RFC ? $acw62.createElement("div", {
        ...rest,
        ref: ref
    }, $acw62.createElement(RFC, {
        adaptableApi: adaptable.api
    })) : $acw62.createElement("div", {
        ...rest,
        dangerouslySetInnerHTML: {
            __html: contentsHTML
        },
        ref: ref
    });
};




const $e3355316da89bc6f$export$b030b23cc5ca76ae = (size)=>{
    const height = window.innerHeight;
    const width = window.innerWidth;
    return {
        x: width / 2 - size.width / 2,
        y: height / 2 - size.height / 2
    };
};
const $e3355316da89bc6f$export$705e23ee65642488 = ()=>{
    const height = window.innerHeight;
    const width = window.innerWidth;
    return {
        height: (0, $f5fc3c9fe698fd70$export$7d15b64cf5a3a4c4)(600, 0, height * 0.9),
        width: (0, $f5fc3c9fe698fd70$export$7d15b64cf5a3a4c4)(800, 0, width * 0.9)
    };
};
const $e3355316da89bc6f$export$2a587b923ae1c91c = ()=>{
    const height = window.innerHeight;
    const width = window.innerWidth;
    return {
        height: (0, $f5fc3c9fe698fd70$export$7d15b64cf5a3a4c4)(height * 0.9, 0, 800),
        width: (0, $f5fc3c9fe698fd70$export$7d15b64cf5a3a4c4)(width * 0.9, 0, 800)
    };
};
const $e3355316da89bc6f$export$6b06d570feeee16 = ()=>{
    return $e3355316da89bc6f$export$2a587b923ae1c91c();
};



const $90a81868d5ed90ff$var$NoopComponent = ()=>{
    return $acw62.createElement($acw62.Fragment, null);
};
const $90a81868d5ed90ff$export$d9c18d5a501b5527 = 'CUSTOM_WINDOW_FACTORY_ID';
/**
 * Portals children into a target container element.
 * Monitors the container with a MutationObserver — if the container is removed
 * from the DOM, `onContainerRemoved` is called so callers can clean up React/Redux state.
 */ const $90a81868d5ed90ff$var$ContainerPortal = ({ container: container, onContainerRemoved: onContainerRemoved, children: children })=>{
    $acw62.useEffect(()=>{
        // If the container is already detached, clean up immediately
        if (!document.contains(container)) {
            onContainerRemoved();
            return;
        }
        const observer = new MutationObserver(()=>{
            if (!document.contains(container)) {
                onContainerRemoved();
                observer.disconnect();
            }
        });
        // Observe the entire document body for subtree removals
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        container,
        onContainerRemoved
    ]);
    return (0, $1u0KT.createPortal)(children, container);
};
const $90a81868d5ed90ff$export$7c6996a1f80fc67c = ()=>{
    const [windowModalSettings, setWindowModalSettings] = $acw62.useState({});
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const windowItems = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Popup.WindowPopup.PopupList);
    return $acw62.createElement($acw62.Fragment, null, windowItems?.map((windowItem)=>{
        let Component = (0, $226a20b901481288$export$58ba7329cbdbab90)[windowItem.FactoryId] ?? null;
        const { windowModalProps: windowModalProps, ...restPopupProps } = windowItem?.PopupProps ?? {};
        const handleDismiss = ()=>{
            dispatch((0, $dc56b6267ce4d0bb$export$b142f1ca754367a7)(windowItem.Id));
        };
        const size = windowModalSettings?.[windowItem.Id]?.size ?? windowItem?.PopupProps?.size ?? (0, $e3355316da89bc6f$export$6b06d570feeee16)();
        const position = windowModalSettings?.[windowItem.Id]?.position ?? windowItem?.PopupProps?.position ?? (0, $e3355316da89bc6f$export$b030b23cc5ca76ae)(size);
        let componentNode = null;
        if (!Component && (windowItem.PopupProps.render || windowItem.PopupProps.frameworkComponent)) componentNode = $acw62.createElement((0, $1acaa6ff89593611$export$edafaa7cfa4a5013), {
            style: {
                height: '100%'
            },
            render: windowItem.PopupProps.render,
            frameworkComponent: windowItem.PopupProps.frameworkComponent,
            onDestroy: windowItem.PopupProps.onFrameworkComponentDestroyed
        });
        else {
            Component = Component ?? $90a81868d5ed90ff$var$NoopComponent;
            componentNode = $acw62.createElement(Component, {
                api: adaptable.api,
                onDismiss: handleDismiss,
                popupProps: restPopupProps
            });
        }
        // Transposed View: portal into custom container if configured
        if (windowItem.FactoryId === (0, $226a20b901481288$export$4976abeffb8e0d2d)) {
            const transposedContainer = (0, $9AsCL.resolveContainerElement)(adaptable.adaptableOptions?.containerOptions?.transposedViewContainer, adaptable.api.internalApi.buildBaseContext());
            if (transposedContainer) return $acw62.createElement($90a81868d5ed90ff$var$ContainerPortal, {
                key: windowItem.Id,
                container: transposedContainer,
                onContainerRemoved: handleDismiss
            }, componentNode);
        }
        return $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
            "data-name": windowItem.Id,
            className: "ab-Window-Modal twa:h-full twa:p-0",
            key: windowItem.Id,
            windowModal: true,
            windowModalProps: {
                ...windowModalProps,
                onChange: (settings)=>{
                    setWindowModalSettings((settingsMap)=>({
                            ...settingsMap,
                            [windowItem.Id]: settings
                        }));
                },
                handleSelector: '.ab-Window-Modal .ab-Panel__header',
                size: size,
                position: position
            },
            fixed: false,
            onDismiss: handleDismiss,
            isOpen: true,
            showCloseButton: true
        }, $acw62.createElement((0, $283cf61293364231$export$226a98817755c0cc), {
            className: "twa:h-full",
            bodyProps: {
                className: 'twa:h-full twa:p-0'
            },
            header: windowItem.Title,
            glyphicon: windowItem.Icon,
            variant: "primary"
        }, componentNode));
    }));
};



class $246350bed03092d5$export$822c36c75325173c extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    prepareAdaptableIconDef(icon) {
        if (icon && 'name' in icon) {
            let customIcon = icon && 'name' in icon ? this.getCustomIconDefinition(icon.name) : null;
            if (customIcon) icon = customIcon;
        }
        return icon;
    }
    getCustomIconDefinition(iconName) {
        let customIcon = undefined;
        const customIcons = this.getUserInterfaceApi().getCustomIcons();
        customIcon = customIcons.find((icon)=>icon.name === iconName);
        if (customIcon) return customIcon.icon;
        return customIcon;
    }
    shouldShowSelectCellEditor(column) {
        const showSelectCellEditor = this.getEditOptions().showSelectCellEditor;
        if (showSelectCellEditor) {
            const columnColumnContext = {
                column: column,
                ...this.getAdaptableInternalApi().buildBaseContext()
            };
            return showSelectCellEditor(columnColumnContext);
        }
        return false;
    }
}




class $91a342c36d00e454$export$72bda8dd8aa6377 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    showProgressIndicatorTimeout = null;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $246350bed03092d5$export$822c36c75325173c)(_adaptable);
    }
    getColorPalette() {
        let colorPalette = this.getUserInterfaceOptions().colorPalette;
        // first do the function then get hardcoded items
        if (colorPalette != null && typeof colorPalette === 'function') {
            const currentTheme = this.getThemeApi().getCurrentTheme();
            const colours = colorPalette(currentTheme);
            return colours;
        } else {
            let arr = colorPalette;
            if (arr && (0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(arr)) return arr;
        }
        return [];
    }
    getCustomIcons() {
        let customIconsProp = this.getUserInterfaceOptions().customIcons;
        if (customIconsProp != null) // first do the function then get hardcoded items
        return typeof customIconsProp === 'function' ? customIconsProp() : customIconsProp;
        return [];
    }
    getStyleClassNames() {
        return this.getUserInterfaceOptions().styleClassNames;
    }
    getEditableCellStyle() {
        return this.getUserInterfaceOptions().editableCellStyle;
    }
    getEditedCellStyle() {
        return this.getUserInterfaceOptions().editedCellStyle;
    }
    getReadOnlyCellStyle() {
        return this.getUserInterfaceOptions().readOnlyCellStyle;
    }
    getAdaptableObjectTags() {
        const objectTags = this.getUserInterfaceOptions().objectTags;
        if (objectTags != null && typeof objectTags === 'function') return objectTags(this.getAdaptableInternalApi().buildBaseContext());
        else {
            let arr = objectTags;
            if (arr && (0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(arr)) return arr;
        }
    }
    getAdaptableObjectsWithTag(tag, adaptableModule) {
        if (adaptableModule) {
            const module = this.getAdaptableInternalApi().getModuleService().getModuleById(adaptableModule);
            if (!module) return undefined;
            return module.getModuleAdaptableObjects()?.filter((ao)=>ao.Tags?.includes(tag));
        } else {
            const modules = this.getAdaptableInternalApi().getModules();
            let returnObjects = [];
            modules.forEach((module)=>{
                returnObjects.push(...module.getModuleAdaptableObjects()?.filter((ao)=>ao.Tags?.includes(tag)));
            });
            return returnObjects;
        }
    }
    showProgressIndicator(config) {
        const close = ()=>{
            this.hideProgressIndicator();
        };
        if (config.delay) this.showProgressIndicatorTimeout = setTimeout(()=>{
            this.dispatchAction((0, $dc56b6267ce4d0bb$export$39707e86e75b7399)(config));
        }, config.delay);
        else this.dispatchAction((0, $dc56b6267ce4d0bb$export$39707e86e75b7399)(config));
        return {
            close: close
        };
    }
    hideProgressIndicator() {
        if (this.showProgressIndicatorTimeout) {
            clearTimeout(this.showProgressIndicatorTimeout);
            this.showProgressIndicatorTimeout = null;
        }
        this.dispatchAction((0, $dc56b6267ce4d0bb$export$64e48e6d146f50a4)());
    }
    openCustomWindowPopup(config) {
        const close = ()=>{
            this.dispatchAction($dc56b6267ce4d0bb$export$b142f1ca754367a7(config.id));
        };
        const action = $dc56b6267ce4d0bb$export$b67e0d4344a1d3c5({
            Id: config.id,
            Title: config.title,
            FactoryId: (0, $90a81868d5ed90ff$export$d9c18d5a501b5527),
            PopupProps: {
                render: config.render,
                frameworkComponent: config.frameworkComponent,
                onFrameworkComponentDestroyed: config.onFrameworkComponentDestroyed,
                size: config.size,
                position: config.position
            },
            Icon: config.icon
        });
        this.dispatchAction(action);
        return {
            close: close
        };
    }
    closeCustomWindowPopup(windowId) {
        this.dispatchAction($dc56b6267ce4d0bb$export$b142f1ca754367a7(windowId));
    }
    getUserInterfaceState() {
        return this.getAdaptableState().UserInterface;
    }
    isAdaptableUIVisible() {
        return !(this.getUserInterfaceState().HideAdaptableUI ?? false);
    }
    hideAdaptableUI() {
        this.dispatchAction($d1ff82162d29425a$export$be5939318a9ee8f5(true));
    }
    showAdaptableUI() {
        this.dispatchAction($d1ff82162d29425a$export$be5939318a9ee8f5(false));
    }
}






var $9OAZF = parcelRequire("9OAZF");

const $bb4e8902919c0845$export$7b1e824d1c92a241 = (isReady, timeout = 5000)=>{
    const startTime = Date.now();
    const ready = isReady();
    if (ready) return Promise.resolve();
    return new Promise((resolve, reject)=>{
        const wait = (callback)=>{
            const ready = isReady();
            if (Date.now() - startTime > timeout) {
                reject('Wait time expired');
                return;
            }
            if (!ready) setTimeout(()=>{
                wait(callback);
            }, 16);
            else callback();
        };
        wait(resolve);
    });
};




class $2e20dd0f0d571640$export$372d1f4026fcfc66 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getInternalState() {
        return this.getAdaptableState().Internal;
    }
    getAdaptableJSXElement() {
        return this._adaptable._PRIVATE_adaptableJSXElement ?? null;
    }
    // Popup Redux Actions
    showPopupConfirmation(confirmation) {
        this.dispatchAction($dc56b6267ce4d0bb$export$93a4701be822446e(confirmation));
    }
    showPopupScreen(module, componentName, popupParams, popupProps) {
        this.dispatchAction($dc56b6267ce4d0bb$export$e2d5bba0b444685d(module, componentName, popupParams, popupProps));
    }
    showPopupForm(config) {
        this.dispatchAction($dc56b6267ce4d0bb$export$16bbb31452c12825(config));
    }
    showPopupWindow({ id: id, title: title, icon: icon, popupProps: popupProps, factoryId: factoryId }) {
        this.dispatchAction($dc56b6267ce4d0bb$export$b67e0d4344a1d3c5({
            Id: id,
            Title: title,
            Icon: icon,
            PopupProps: popupProps,
            FactoryId: factoryId
        }));
    }
    hidePopupScreen() {
        this.dispatchAction($dc56b6267ce4d0bb$export$b591761538bae019());
    }
    setSettingsPanelItems(menuItems) {
        this.dispatchAction($5b564bb703f29152$export$f9bfd99851e0c3b7(menuItems));
    }
    setDashboardModuleButtons(menuItems) {
        this.dispatchAction($5b564bb703f29152$export$c86ddef8bc8627b4(menuItems));
    }
    getToolbarTitle() {
        let toolbarTitle = this.getDashboardApi().getDashboardState().DashboardTitle;
        if ((0, $9OAZF.default).IsNullOrEmpty(toolbarTitle)) {
            toolbarTitle = this.getOptions().adaptableId;
            if (toolbarTitle == (0, $58846ea7f4156db7$export$4241be43e8a445e5)) toolbarTitle = 'Adaptable ';
        }
        return toolbarTitle;
    }
    buildCellDataChangedInfo(config) {
        return {
            ...config,
            rowData: config.rowNode?.data,
            changedAt: Date.now()
        };
    }
    buildRowDataChangedInfo(dataRows, rowNodes, rowTrigger) {
        const rowDataChangedInfo = {
            changedAt: Date.now(),
            rowTrigger: rowTrigger,
            dataRows: dataRows,
            rowNodes: rowNodes
        };
        return rowDataChangedInfo;
    }
    getAdaptableInstance() {
        return this._adaptable;
    }
    getAgGridAdapter() {
        return this._adaptable.agGridAdapter;
    }
    getAgGridModulesAdapter() {
        return this._adaptable.agGridModulesAdapter;
    }
    getInitialState() {
        return this.getOptions().initialState;
    }
    getState() {
        return this.getAdaptableState();
    }
    getValidationService() {
        return this._adaptable.ValidationService;
    }
    getModuleService() {
        return this._adaptable.ModuleService;
    }
    getDataService() {
        return this._adaptable.DataService;
    }
    getAnnotationsService() {
        return this._adaptable.AnnotationsService;
    }
    getCalculatedColumnExpressionService() {
        return this._adaptable.CalculatedColumnExpressionService;
    }
    getQueryLanguageService() {
        return this._adaptable.QueryLanguageService;
    }
    getAlertService() {
        return this._adaptable.AlertService;
    }
    getTeamSharingService() {
        return this._adaptable.TeamSharingService;
    }
    getMetamodelService() {
        return this._adaptable.MetamodelService;
    }
    getRowFormService() {
        return this._adaptable.RowFormService;
    }
    getFdc3Service() {
        return this._adaptable.Fdc3Service;
    }
    getFlashingCellService() {
        return this._adaptable.FlashingCellService;
    }
    getModules() {
        return this._adaptable.adaptableModules;
    }
    forAllRowNodesDo(func, config) {
        this._adaptable.forAllRowNodesDo(func, config);
    }
    forAllVisibleRowNodesDo(func, config) {
        this._adaptable.forAllVisibleRowNodesDo(func, config);
    }
    getLabelForButton(button, context) {
        if (!button.label) return '';
        if (button.label != null && typeof button.label === 'function') return button.label(button, context);
        else return button.label;
    }
    getTooltipForButton(button, context) {
        if (!button.tooltip) return '';
        if (button.tooltip != null && typeof button.tooltip === 'function') return button.tooltip(button, context);
        else return button.tooltip;
    }
    getStyleForButton(button, context) {
        if (!button.buttonStyle) return undefined;
        if (button.buttonStyle != null && typeof button.buttonStyle === 'function') return button.buttonStyle(button, context);
        else return button.buttonStyle;
    }
    getIconForButton(button, context, defaultWidthHeight) {
        if (!button.icon) return;
        let buttonIcon;
        if (button.icon != null && typeof button.icon === 'function') buttonIcon = button.icon(button, context);
        else buttonIcon = button.icon;
        if (!buttonIcon) return;
        if ((0, $9200d8ae4e589d35$export$dff472f8017c5d8b)(buttonIcon) || (0, $9200d8ae4e589d35$export$276cfd3daee350b9)(buttonIcon)) {
            const defaultIconWidth = defaultWidthHeight?.width;
            const defaultIconHeight = defaultWidthHeight?.height;
            const buttonIconStyle = Object.assign({}, {
                width: defaultIconWidth ?? 20,
                height: defaultIconHeight ?? 20
            }, buttonIcon.style);
            buttonIcon.style = buttonIconStyle;
        }
        return buttonIcon;
    }
    isDocumentationLinksDisplayed() {
        return this.getUserInterfaceOptions().showDocumentationLinks;
    }
    // the row data which is used to preview the expression evaluation (usually the first row data)
    getQueryPreviewData() {
        const firstRowNode = this.getGridApi().getFirstRowNode();
        if (firstRowNode == undefined) return {};
        const firstRowData = firstRowNode?.data ? {
            ...firstRowNode?.data
        } : {};
        // handle CalcCols which are not persisted in the rowModel
        this.getCalculatedColumnApi().getCalculatedColumns().forEach((calculatedColumn)=>{
            const columnRawValue = this._adaptable.api.gridApi.getRawValueFromRowNode(firstRowNode, calculatedColumn.ColumnId);
            firstRowData[calculatedColumn.ColumnId] = columnRawValue;
        });
        // handle FreeTextCols which are not persisted in the rowModel
        this.getFreeTextColumnApi().getFreeTextColumns().forEach((freeTextColumn)=>{
            const columnRawValue = this.getGridApi().getRawValueFromRowNode(firstRowNode, freeTextColumn.ColumnId);
            firstRowData[freeTextColumn.ColumnId] = columnRawValue;
        });
        return firstRowData;
    }
    createFrameworkComponent(containerDomNode, frameworkComponent, componentType) {
        const createComponentFn = ()=>// delegate the logic to framework wrapper
            this._adaptable._emitSync('FrameworkComponentChange', {
                command: 'create',
                containerDomNode: containerDomNode,
                frameworkComponent: frameworkComponent,
                componentType: componentType
            });
        if (this.isAdapTableReady()) createComponentFn();
        else // adaptable may not be initialized yet if the framework component is part of the initial render
        // AFL 2021.10.14 - not really sure if this is necessary anymore?! (see the other changes in this commit)
        (0, $bb4e8902919c0845$export$7b1e824d1c92a241)(()=>this.isAdapTableReady()).then(()=>{
            createComponentFn();
        });
    }
    destroyFrameworkComponent(containerDomNode, frameworkComponent, componentType) {
        this._adaptable._emitSync('FrameworkComponentChange', {
            command: 'destroy',
            containerDomNode: containerDomNode,
            frameworkComponent: frameworkComponent,
            componentType: componentType
        });
    }
    initializeDataChangeHistory() {
        if (this.getDataChangeHistoryOptions().activeByDefault) this.dispatchAction($5b564bb703f29152$export$d4cbdbb82d50fbc3());
        else this.dispatchAction($5b564bb703f29152$export$4344ed6f5015b32c());
    }
    executeWithProgressIndicator(label, executeFn, errorHandlingFn) {
        this.getUserInterfaceApi().showProgressIndicator({
            text: label,
            delay: 300
        });
        // setTimeout required to give the ProgressIndicator rendering a head-start (see RAF in ProgressIndicator implementation)
        setTimeout(()=>{
            try {
                executeFn();
            } catch (error) {
                errorHandlingFn?.();
                this.getUserInterfaceApi().hideProgressIndicator();
                this.logError('Unexpected error while executing a function with a progress indicator', error);
            }
        }, 16);
    }
    getCorrectEnglishVariant(wordToSpell) {
        if (wordToSpell.includes('our')) return this.getUserInterfaceOptions().englishVariant == 'GB' ? wordToSpell : wordToSpell.replace('our', 'or');
        return wordToSpell;
    }
    shouldDisplayTagSections() {
        return this.getAvailableTags() != undefined;
    }
    getAvailableTags() {
        const layoutTags = this.getLayoutTags();
        const objectTags = this.getObjectTags();
        if (!layoutTags && !objectTags) return;
        return [
            ...layoutTags || [],
            ...objectTags || []
        ];
    }
    getObjectTags() {
        const userInterfaceOptions = this.getUserInterfaceOptions();
        if (!this.getUserInterfaceOptions().objectTags) return;
        if (Array.isArray(userInterfaceOptions.objectTags)) return userInterfaceOptions.objectTags;
        if (typeof userInterfaceOptions.objectTags === 'function') // sanitize the provided tags, just to be sure that the user does NOT break the UI
        return userInterfaceOptions.objectTags(this.buildBaseContext()).filter((tag)=>typeof tag === 'string');
    }
    getLayoutTags() {
        const layoutOptions = this.getLayoutOptions();
        if (!layoutOptions.layoutTagOptions?.autoGenerateTagsForLayouts) return;
        if (layoutOptions.layoutTagOptions.autoGenerateTagsForLayouts === true) return this.getLayoutApi().getLayouts().map((layout)=>{
            return layout.Name;
        });
        if (typeof layoutOptions.layoutTagOptions.autoGenerateTagsForLayouts === 'function') {
            const autoGenerateTagsForLayoutsContext = {
                layouts: this.getLayoutApi().getLayouts(),
                objectTags: this.getUserInterfaceApi().getAdaptableObjectTags(),
                ...this.buildBaseContext()
            };
            const customGeneratedTags = layoutOptions.layoutTagOptions.autoGenerateTagsForLayouts(autoGenerateTagsForLayoutsContext);
            // sanitize the provided tags, just to be sure that the user does NOT break the UI
            return customGeneratedTags.filter((tag)=>typeof tag === 'string');
        }
    }
    // General way to get to store from inside Adaptable...
    dispatchReduxAction(action) {
        this.dispatchAction(action);
    }
    // doing it this way to avoid having to expose Module Params which is internal
    showSettingsPanel(module, moduleParams) {
        this.showModulePopup(module, moduleParams);
    }
    getLabelForTag(adaptableObjectTag) {
        // not very interesting right now, but useful later when tag is not only a plain string
        return adaptableObjectTag;
    }
    getValueForTag(adaptableObjectTag) {
        // not very interesting right now, but useful later when tag is not only a plain string
        return adaptableObjectTag;
    }
    getAdaptableQueryExpressionText(query) {
        if (!query) return '';
        const displayColumnFriendlyNames = this.getExpressionOptions()?.displayColumnFriendlyNamesForExpressions;
        return displayColumnFriendlyNames ? this.getExpressionApi().getAdaptableQueryExpressionWithColumnFriendlyNames(query) : this.getExpressionApi().getAdaptableQueryExpression(query);
    }
    /**
     * Gets a value from a rowData object using a field name.
     * Supports deep values (e.g. fieldName = 'address.street')
     */ // "borrowed" from https://github.com/ag-grid/ag-grid/blob/v28.2.1/community-modules/core/src/ts/utils/object.ts#L205
    getValueUsingField(rowData, fieldName) {
        if (!rowData || !fieldName?.length) return;
        const isColumnValueKeyNested = fieldName?.includes('.');
        // if no '.', then it's not a deep value
        if (!isColumnValueKeyNested) return rowData[fieldName];
        // otherwise it is a deep value, so need to dig for it
        const fields = fieldName.split('.');
        let currentObject = rowData;
        for(let i = 0; i < fields.length; i++){
            if (currentObject == null) return undefined;
            currentObject = currentObject[fields[i]];
        }
        return currentObject;
    }
    /**
     * Sets a value in a rowData object using a field name.
     * Supports deep values (e.g. fieldName = 'address.street')
     */ // "borrowed" from https://github.com/ag-grid/ag-grid/blob/v28.2.1/community-modules/core/src/ts/valueService/valueService.ts#L236
    setValueUsingField(rowData, fieldName, newValue) {
        if (!rowData || !fieldName?.length) return;
        const isColumnValueKeyContainsDots = fieldName?.includes('.');
        let valuesAreSame = false;
        if (!isColumnValueKeyContainsDots) {
            // soft comparison to match strings and numbers
            valuesAreSame = rowData[fieldName] == newValue;
            if (!valuesAreSame) rowData[fieldName] = newValue;
        } else {
            // otherwise it is a deep value, so need to dig for it
            const fieldPieces = fieldName.split('.');
            let currentObject = rowData;
            while(fieldPieces.length > 0 && currentObject){
                const fieldPiece = fieldPieces.shift();
                if (fieldPieces.length === 0) {
                    // soft comparison to match strings and numbers
                    valuesAreSame = currentObject[fieldPiece] == newValue;
                    if (!valuesAreSame) currentObject[fieldPiece] = newValue;
                } else {
                    // NOTE AFL: this was NOT in the original AG Grid code, but we need it to handle inserting deep values (the original implementation only handled updating)
                    if (currentObject[fieldPiece] == null) currentObject[fieldPiece] = {};
                    currentObject = currentObject[fieldPiece];
                }
            }
        }
        return rowData;
    }
    findAdaptableObjectsByLookupCriteria({ scope: scope, tag: tag, ids: ids }, specificAdaptableObjects) {
        if (!ids?.length && !tag && !scope) return [];
        let locatedAdaptableObjects = [
            ...specificAdaptableObjects
        ];
        // IDs are the most specific locators
        if (ids?.length) locatedAdaptableObjects = locatedAdaptableObjects.filter((adaptableObject)=>ids.includes(adaptableObject.Uuid));
        // secondly filter by Tags
        if (tag) locatedAdaptableObjects = locatedAdaptableObjects.filter((adaptableObject)=>adaptableObject.Tags?.includes(tag));
        // lastly filter by scope
        if (scope) locatedAdaptableObjects = locatedAdaptableObjects.filter((adaptableObject)=>this.getColumnScopeApi().isScopeInScope(adaptableObject.Scope, scope));
        return locatedAdaptableObjects;
    }
    buildBaseContext() {
        const optionsApi = this.getOptionsApi();
        return {
            adaptableApi: this.getAdaptableApi(),
            adaptableId: optionsApi.getAdaptableId(),
            adaptableStateKey: optionsApi.getAdaptableStateKey(),
            userName: optionsApi.getUserName(),
            adaptableContext: optionsApi.getAdaptableContext(),
            clientTimestamp: new Date()
        };
    }
    buildAdaptableColumnContext(column) {
        return {
            ...this.buildBaseContext(),
            column: typeof column === 'string' ? this.getColumnApi().getColumnWithColumnId(column) : column
        };
    }
    setCellSummaryInfo(cellSummaryInfo) {
        this.dispatchAction($5b564bb703f29152$export$9bddc310e8204949(cellSummaryInfo));
    }
    parseDateValue(dateValue) {
        const dateFormat = this.getUserInterfaceOptions().dateInputOptions.dateFormat;
        if (dateFormat === 'yyyy-MM-dd') // if the format is ISO, we don't pass it so that we use the date-fns `parseISO` which is more robust
        return (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(dateValue);
        return (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(dateValue, dateFormat);
    }
}





class $ef13b79f080a66e1$export$6e9529d65cb529f4 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    constructor(_adaptable){
        super(_adaptable);
    }
    getScheduleState() {
        return this.getAdaptableState().Schedule;
    }
    getSchedules(config) {
        let allSchedules = [];
        allSchedules.push(...this.getReminderSchedules(config));
        allSchedules.push(...this.getReportSchedules(config));
        allSchedules.push(...this.getIPushPullSchedules(config));
        allSchedules.push(...this.getOpenFinSchedules(config));
        return allSchedules;
    }
    getScheduleByName(name) {
        return this.getSchedules().find((schedule)=>schedule.Name === name);
    }
    getReminderSchedules(config) {
        return this.handleLayoutExtensionObjects(this.getScheduleState().Reminders, 'Schedule', config) ?? [];
    }
    getScheduleById(id, config) {
        return this.getSchedules(config).find((schedule)=>schedule?.Uuid === id);
    }
    getActiveReminderSchedules(config) {
        return this.getReminderSchedules(config).filter((schedule)=>!schedule.IsSuspended);
    }
    getSuspendedReminderSchedules(config) {
        return this.getReminderSchedules(config).filter((schedule)=>schedule.IsSuspended);
    }
    addReminderSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$70bc39e24de4957e(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    deleteReminderSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$6039870450c4d55f(schedule));
    }
    editReminderSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$a013643dfd3ba9a6(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    suspendReminderSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$8f8b9ba2ded34223(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    unSuspendReminderSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$86f0f6bc1579d292(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    getReportSchedules(config) {
        return this.handleLayoutExtensionObjects(this.getAdaptableState().Schedule.ReportSchedules, 'Schedule', config) ?? [];
    }
    getActiveReportSchedules() {
        return this.getReportSchedules().filter((schedule)=>!schedule.IsSuspended);
    }
    getSuspendedReportSchedules() {
        return this.getReportSchedules().filter((schedule)=>schedule.IsSuspended);
    }
    editSchedule(schedule) {
        switch(schedule.ScheduleType){
            case 'ipushpull':
                return this.editIPushPullSchedule(schedule);
            case 'Reminder':
                return this.editReminderSchedule(schedule);
            case 'OpenFin':
                return this.editOpenFinSchedule(schedule);
            case 'Report':
                return this.editReportSchedule(schedule);
        }
    }
    addReportSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$4a744ac1b34f8f67(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    editReportSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$c7092aaffe90ec2f(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    deleteReportSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$a295a95489a73dd(schedule));
    }
    suspendReportSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$d7ee5ae4dc83275e(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    unSuspendReportSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$62ab8e50b7e8ae89(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    getIPushPullSchedules(config) {
        const ippApi = this.getAdaptableApi().pluginsApi.getipushpullPluginApi();
        return this.handleLayoutExtensionObjects(ippApi?.getIPushPullSchedules(), 'Schedule', config) ?? [];
    }
    getActiveIPushPullSchedules() {
        return this.getIPushPullSchedules().filter((schedule)=>!schedule.IsSuspended);
    }
    getSuspendedIPushPullSchedules() {
        return this.getIPushPullSchedules().filter((schedule)=>schedule.IsSuspended);
    }
    addIPushPullSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$e222f78188cd2696(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    editIPushPullSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$24a7aedf87930eef(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    deleteIPushPullSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$3b36c3ae2efe31cb(schedule));
    }
    suspendIPushPullSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$ea59ca87e7d93968(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    unSuspendIPushPullSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$e680ef46686b2048(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    getOpenFinSchedules(config) {
        const openFinApi = this.getAdaptableApi().pluginsApi.getOpenFinPluginApi();
        return this.handleLayoutExtensionObjects(openFinApi?.getOpenFinSchedules(), 'Schedule', config) ?? [];
    }
    getActiveOpenFinSchedules() {
        return this.getOpenFinSchedules().filter((schedule)=>!schedule.IsSuspended);
    }
    getSuspendedOpenFinSchedules() {
        return this.getOpenFinSchedules().filter((schedule)=>schedule.IsSuspended);
    }
    addOpenFinSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$b9fca2b9f0a6f24c(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    editOpenFinSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$9c48a79fad9fd033(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    deleteOpenFinSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$7b14e381193389a3(schedule));
    }
    suspendOpenFinSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$d605754f43ab43ce(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    unSuspendOpenFinSchedule(schedule) {
        this.dispatchAction($bb63955874685545$export$751f7472244e1a50(schedule));
        return this.getScheduleById(schedule.Uuid);
    }
    applySchedule(schedule, scheduleType) {
        if (scheduleType == 'Reminder') {
            const reminderSchedule = schedule;
            //   const reminder: Reminder = reminderSchedule.Reminder;
            const alert = {
                alertType: 'generic',
                header: reminderSchedule.Header,
                message: reminderSchedule.Message,
                alertDefinition: {
                    Name: reminderSchedule.Header,
                    MessageType: reminderSchedule.MessageType,
                    AlertProperties: {
                        DisplayNotification: reminderSchedule.DisplayNotification
                    },
                    Rule: undefined,
                    Scope: undefined
                }
            };
            this.getAlertApi().displayAdaptableAlert(alert);
            if (reminderSchedule.DisplaySystemStatusMessage) this.getSystemStatusApi().setSystemStatus(reminderSchedule.Header, reminderSchedule.MessageType, reminderSchedule.Message);
        } else if (scheduleType == 'Report') {
            const reportSchedule = schedule;
            this.getExportApi().exportReport(reportSchedule.ReportName, reportSchedule.ReportFormat, reportSchedule.ExportDestination ?? 'Download');
        } else if (scheduleType == 'ipushpull') {
            const ippApi = this.getAdaptableApi().pluginsApi.getipushpullPluginApi();
            const iPushPullSchedule = schedule;
            if (iPushPullSchedule.Transmission == 'Snapshot') ippApi.sendSnapshot(iPushPullSchedule.IPushPullReport);
            else if (iPushPullSchedule.Transmission == 'Live Data') ippApi.startLiveData(iPushPullSchedule.IPushPullReport);
        } else if (scheduleType == 'OpenFin') {
            const openFinApi = this.getAdaptableApi().pluginsApi.getOpenFinPluginApi();
            const openFinSchedule = schedule;
            openFinApi.startLiveData(openFinSchedule.OpenFinReport);
        }
        // now also send the action to Store so it can be audited if required
        this.dispatchAction($bb63955874685545$export$6e995036a96cd71c(schedule, scheduleType));
    }
    openScheduleSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$5dd6e67bf681ede8);
    }
}






class $385bb4e7977abce4$export$8ee343ac58dc6ea extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Retrieves shared entry dependencies.
     */ getSharedEntryDependencies(sharedEntity) {
        const allEntities = this.getTeamSharingApi().getLoadedAdaptableSharedEntities();
        return (sharedEntity?.EntityDependencyIds ?? []).map((id)=>allEntities.find((entity)=>entity.Uuid === id));
    }
    waitForTeamSharingImportEnd() {
        // we have no deterministic means to ensure the teamsharing import is finished (because the import actions are opaque and may have side-effects)
        // therefore we will listen for state changes and
        // if the state was unchanged in the last `waitForStableState` ms, we assume/hope the import is finished
        const waitForStableState = 1000;
        const waitThreshold = 5000;
        return new Promise((resolve, reject)=>{
            let pollTimer;
            // stop the poll after `waitThreshold` ms, if the state hasn't stabilised until now, it probably never will...
            let breakTimer = setTimeout(()=>{
                unsubscribe?.();
                clearTimeout(pollTimer);
                reject(false);
            }, waitThreshold);
            // poll state for changes:
            const unsubscribe = this.getEventApi().on('AdaptableStateChanged', ()=>{
                clearTimeout(pollTimer);
                pollTimer = setTimeout(()=>{
                    // state is stable, cleanup all subscriptions before returning
                    unsubscribe();
                    clearTimeout(breakTimer);
                    resolve(true);
                }, waitForStableState);
            });
        });
    }
}



class $78c3545eba2a27ab$export$a30f18fd28be459b extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $385bb4e7977abce4$export$8ee343ac58dc6ea)(_adaptable);
    }
    async loadSharedEntities() {
        if (!this.isTeamSharingAvailable()) {
            this.logWarn('Team Sharing is not Activated so Entities cannot be loaded');
            return [];
        }
        const teamSharingOptions = this.getTeamSharingOptions();
        const sharedEntitiesContext = this.getAdaptableInternalApi().buildBaseContext();
        let loadedSharedEntities = await teamSharingOptions.loadSharedEntities(sharedEntitiesContext);
        // with v15 we introduced 2 types of SharedEntity: AdaptableSharedEntity (basically the old one) and the new CustomSharedEntity
        // for backwards compatibility, we add default the 'EntityType' property to 'adaptableEntity'
        loadedSharedEntities = loadedSharedEntities.map((sharedEntity)=>{
            if (sharedEntity.EntityType !== 'adaptableEntity' && sharedEntity.EntityType !== 'customEntity') // @ts-ignore
            sharedEntity.EntityType = 'adaptableEntity';
            return sharedEntity;
        });
        const sharedEntities = teamSharingOptions.applySharedEntities(loadedSharedEntities, sharedEntitiesContext);
        return sharedEntities;
    }
    async persistSharedEntities(sharedEntities) {
        if (!this.isTeamSharingAvailable()) {
            this.logWarn('Team Sharing is not Activated so Entities cannot be shared');
            return false;
        }
        const teamSharingOptions = this.getTeamSharingOptions();
        const sharedEntitiesContext = this.getAdaptableInternalApi().buildBaseContext();
        const sharedEntitiesAfterCustomisation = teamSharingOptions.saveSharedEntities(sharedEntities, sharedEntitiesContext);
        await teamSharingOptions.persistSharedEntities(sharedEntitiesAfterCustomisation, sharedEntitiesContext);
        return true;
    }
    isTeamSharingAvailable() {
        return this._adaptable.ModuleService.isAdapTableModulePresent('TeamSharing');
    }
    hasTeamSharingFullRights() {
        return this.getEntitlementApi().isModuleFullEntitlement($42e863194fcb493f$export$ecef34e06f3704d9);
    }
    checkForUpdates() {
        this.dispatchAction((0, $a6df66119ff073ff$export$ee8a578a7894d481)());
    }
    openTeamSharingSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$ecef34e06f3704d9);
    }
    shareAdaptableEntity(adaptableObject, module, sharedEntityConfig) {
        if (!this.isTeamSharingAvailable()) {
            this.logWarn('Team Sharing is not Activated so Entities cannot be shared');
            return;
        }
        this.dispatchAction($a6df66119ff073ff$export$bfa3d118cda0ea7e(adaptableObject, module, sharedEntityConfig));
    }
    shareCustomEntity(customObject, sharedEntityConfig) {
        if (!this.isTeamSharingAvailable()) {
            this.logWarn('Team Sharing is not Activated so Entities cannot be shared');
            return;
        }
        this.dispatchAction($a6df66119ff073ff$export$66e6848ec7588b12(customObject, sharedEntityConfig));
    }
    unshareEntity(entityId) {
        if (!this.isTeamSharingAvailable()) {
            this.logWarn('Team Sharing is not Activated so Entities cannot be unshared');
            return;
        }
        this.dispatchAction($a6df66119ff073ff$export$d156e46d29aee999(entityId));
    }
    importSharedEntry(sharedEntity) {
        if ((0, $652f53856d8ee82a$export$e7cf26b8bffccd2a)(sharedEntity)) this.dispatchAction($a6df66119ff073ff$export$bed91c72cfaa4424(sharedEntity));
        else {
            const customSharedEntityImportHandler = this.getTeamSharingOptions().handleCustomSharedEntityImport;
            if (!customSharedEntityImportHandler) {
                this.logError(`Could NOT import custom shared entity because 'TeamSharingOptions.handleCustomSharedEntityImport(...)' is NOT defined!`, sharedEntity);
                return;
            }
            customSharedEntityImportHandler(sharedEntity, this.getAdaptableInternalApi().buildBaseContext());
        }
    }
    getTeamSharingState() {
        return this.getAdaptableState().TeamSharing;
    }
    getLoadedSharedEntities() {
        return this.getTeamSharingState().SharedEntities;
    }
    getLoadedAdaptableSharedEntities() {
        return this.getLoadedSharedEntities().filter((0, $652f53856d8ee82a$export$e7cf26b8bffccd2a));
    }
    getLoadedCustomSharedEntities() {
        return this.getLoadedSharedEntities().filter((0, $652f53856d8ee82a$export$378092868a0e61cd));
    }
    refreshTeamSharing() {
        this.dispatchAction($a6df66119ff073ff$export$418c60d5bcf62235());
    }
}





class $99e6394056d7eae3$export$b157d1e4821272f7 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getApplicationState() {
        return this.getAdaptableState().Application;
    }
    getApplicationDataEntries() {
        return this.getApplicationState().ApplicationDataEntries;
    }
    addApplicationDataEntry(keyValuePair) {
        this.dispatchAction($74b889ddf281400d$export$43a60c1dcd7079c4(keyValuePair));
    }
    createApplicationDataEntry(key, value) {
        let applicationDataEntry = {
            Key: key,
            Value: value
        };
        this.addApplicationDataEntry(applicationDataEntry);
    }
    editApplicationDataEntry(applicationDataEntry) {
        this.dispatchAction($74b889ddf281400d$export$b25db56e14802501(applicationDataEntry));
    }
    deleteApplicationDataEntry(applicationDataEntry) {
        this.dispatchAction($74b889ddf281400d$export$c46b519ec5aa9846(applicationDataEntry));
    }
    getApplicationDataEntryByKey(key) {
        let entries = this.getApplicationState().ApplicationDataEntries;
        return entries.find((e)=>e.Key === key);
    }
    getApplicationDataEntriesByValue(value) {
        let entries = this.getApplicationState().ApplicationDataEntries;
        return entries.filter((e)=>e.Value === value);
    }
}




var $9g4SS = parcelRequire("9g4SS");

var $5aWMQ = parcelRequire("5aWMQ");
class $e93500a4446aed1f$export$7eaf8713ae9c5108 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    isColumnInScope(column, scope) {
        if (!column) return false;
        if ('All' in scope) // do we need a true check here?
        return true;
        if ('DataTypes' in scope) {
            if (scope.DataTypes.includes(column.dataType)) return true;
            if (scope.DataTypes.includes('date')) {
                const agDateTypes = this.getColumnApi().internalApi.getColumnDateTypes();
                if (agDateTypes.includes(column.dataType)) return true;
            }
        }
        if ('ColumnTypes' in scope && scope.ColumnTypes.some((columnType)=>column.columnTypes?.includes(columnType))) return true;
        if ('ColumnIds' in scope && scope.ColumnIds.includes(column.columnId)) return true;
        return false;
    }
    getColumnsInScope(scope) {
        if (scope == undefined) return [];
        const columns = this.getColumnApi().getUIAvailableColumns();
        if ('All' in scope) return columns;
        return columns.filter((c)=>{
            return this.isColumnInScope(c, scope);
        });
    }
    getScopeDescription(scope) {
        if (scope === undefined) return 'Nothing';
        if ('All' in scope) // do we need a true check here?
        return 'Columns: All';
        if ('ColumnTypes' in scope) return (scope.ColumnTypes.length > 0 ? 'ColumnTypes' : 'ColumnType') + ': ' + scope.ColumnTypes.join(', ');
        if ('DataTypes' in scope) return (scope.DataTypes.length > 0 ? 'DataTypes' : 'DataType') + ': ' + scope.DataTypes.join(', ');
        if ('ColumnIds' in scope) return (scope.ColumnIds.length > 1 ? 'Columns' : 'Column') + ': ' + this.getColumnApi().getFriendlyNamesForColumnIds(scope.ColumnIds).map((c)=>{
            return '"' + c + '"';
        }).join(', ');
    }
    scopeIsEmpty(scope) {
        return scope === undefined;
    }
    scopeIsAll(scope) {
        return scope !== undefined && 'All' in scope;
    }
    scopeHasDataType(scope) {
        return scope !== undefined && 'DataTypes' in scope;
    }
    scopeHasColumnType(scope) {
        return scope !== undefined && 'ColumnTypes' in scope;
    }
    scopeHasOnlyBooleanDataType(scope) {
        return 'DataTypes' in scope && scope.DataTypes?.length == 1 && scope.DataTypes[0] == 'boolean';
    }
    scopeHasColumns(scope) {
        return scope !== undefined && 'ColumnIds' in scope;
    }
    isSingleColumnScope(scope) {
        return this.scopeHasColumns(scope) && !this.scopeHasDataType(scope) && !this.scopeIsAll(scope) && 'ColumnIds' in scope && scope.ColumnIds.length == 1;
    }
    getSingleColumnInScope(scope) {
        return this.isSingleColumnScope(scope) && 'ColumnIds' in scope ? scope.ColumnIds[0] : undefined;
    }
    isSingleNumericColumnScope(scope) {
        return this.scopeHasColumns(scope) && !this.scopeHasDataType(scope) && !this.scopeIsAll(scope) && 'ColumnIds' in scope && scope.ColumnIds.length == 1 && this.getColumnApi().hasNumberDataType(scope.ColumnIds[0]);
    }
    isSingleBooleanColumnScope(scope) {
        return this.scopeHasColumns(scope) && !this.scopeHasDataType(scope) && !this.scopeIsAll(scope) && 'ColumnIds' in scope && scope.ColumnIds.length == 1 && this.getColumnApi().hasBooleanDataType(scope.ColumnIds[0]);
    }
    areAllBooleanColumnsInScope(scope) {
        return this.scopeHasColumns(scope) && !this.scopeHasDataType(scope) && !this.scopeIsAll(scope) && 'ColumnIds' in scope && scope.ColumnIds.length && scope.ColumnIds.every((columnId)=>this.getColumnApi().hasBooleanDataType(columnId));
    }
    isColumnInScopeColumns(column, scope) {
        return this.scopeHasColumns(scope) && this.isColumnInScope(column, scope);
    }
    isPrimaryKeyColumnInScopeColumns(scope) {
        return 'ColumnIds' in scope && scope.ColumnIds.length == 1 && scope.ColumnIds.find((c)=>c == this.getOptions().primaryKey) != null;
    }
    getScopeToString(scope) {
        if ('All' in scope) return 'Columns: All';
        if ('ColumnTypes' in scope) return 'ColumnTypes: ' + scope.ColumnTypes.join(',');
        if ('DataTypes' in scope) return 'DataTypes: ' + scope.DataTypes.join(',');
        if ('ColumnIds' in scope) {
            let text = scope.ColumnIds.length == 1 ? 'Column: ' : 'Columns: ';
            return text + this.getAdaptableApi().columnApi.getFriendlyNamesForColumnIds(scope.ColumnIds).map((c)=>{
                return '"' + c + '"';
            }).join(', ');
        }
    }
    getColumnIdsInScope(scope) {
        if (scope !== undefined && 'ColumnIds' in scope) return scope.ColumnIds;
        return undefined;
    }
    getColumnTypesInScope(scope) {
        if (scope !== undefined && 'ColumnTypes' in scope) return scope.ColumnTypes;
        return undefined;
    }
    getDataTypesInScope(scope) {
        if (scope !== undefined && 'DataTypes' in scope) return scope.DataTypes;
        return undefined;
    }
    isColumnInNumericScope(column, scope) {
        // if column is not even numeric then return false
        if (column == null || column == undefined || column.dataType !== 'number') return false;
        // if no scope then return false
        if (scope == undefined) return false;
        // check if the scope has ColumnIds and whether this column is contained
        if ('ColumnIds' in scope && scope.ColumnIds.includes(column.columnId)) return true;
        // check if the scope has ColumnIds and whether this column is contained
        if ('DataTypes' in scope && scope.DataTypes.includes('number')) return true;
        if ('ColumnTypes' in scope && scope.ColumnTypes?.some?.((scopeColumnType)=>column.columnTypes?.includes?.(scopeColumnType))) return true;
        return false;
    }
    isColumnInTextScope(column, scope) {
        // if column is not even string then return false
        if (column == null || column == undefined || column.dataType !== 'text') return false;
        // if no scope then return false
        if (scope == undefined) return false;
        // check if the scope has ColumnIds and whether this column is contained
        if ('ColumnIds' in scope && scope.ColumnIds.includes(column.columnId)) return true;
        // check if the scope has ColumnIds and whether this column is contained
        if ('DataTypes' in scope && scope.DataTypes.includes('text')) return true;
        if ('ColumnTypes' in scope && scope.ColumnTypes?.some?.((scopeColumnType)=>column.columnTypes?.includes?.(scopeColumnType))) return true;
        return false;
    }
    isColumnInDateScope(column, scope) {
        // if column is not even numeric then return false
        if (column == null || column == undefined || column.dataType !== 'date') return false;
        // if no scope then return false
        if (scope == undefined) return false;
        // check if the scope has ColumnIds and whether this column is contained
        if ('ColumnIds' in scope && scope.ColumnIds.includes(column.columnId)) return true;
        // check if the scope has ColumnIds and whether this column is contained
        if ('DataTypes' in scope && scope.DataTypes.includes('date')) return true;
        if ('ColumnTypes' in scope && scope.ColumnTypes?.some?.((scopeColumnType)=>column.columnTypes?.includes?.(scopeColumnType))) return true;
        return false;
    }
    isScopeInScope(a, b) {
        // AFL: Scope:'All' for object 'a' is NOT handled
        // this is probably wrong, but we will touch it when a bug is filed
        if ('All' in b) return true;
        if ('DataTypes' in a && 'DataTypes' in b && a.DataTypes.every((type)=>b.DataTypes.includes(type))) return true;
        if ('ColumnIds' in a && 'ColumnIds' in b && a.ColumnIds.every((columnId)=>b.ColumnIds.includes(columnId))) return true;
        if ('ColumnIds' in a && 'DataTypes' in b && a.ColumnIds.every((columnId)=>{
            return b.DataTypes.includes(this.getColumnApi().getColumnWithColumnId(columnId)?.dataType);
        })) return true;
        if ('ColumnTypes' in a && 'ColumnTypes' in b && a.ColumnTypes.every((columnType)=>b.ColumnTypes.includes(columnType))) return true;
        // check if each colum in a has column types in b
        if ('ColumnIds' in a && 'ColumnTypes' in b) {
            const inScope = a.ColumnIds.every((columnId)=>{
                const column = this.getColumnApi().getColumnWithColumnId(columnId);
                // check if at least one column-type is in scope
                return column.columnTypes.some((columnColumnType)=>b.ColumnTypes.includes(columnColumnType));
            });
            if (inScope) return true;
        }
        return false;
    }
    createCellColorRangesForScope(scope) {
        let distinctColumnsValues = this.getGridApi().internalApi.getDistinctRawValuesForColumn(this.getSingleColumnInScope(scope));
        let minValue = Math.min(...distinctColumnsValues);
        let maxValue = Math.max(...distinctColumnsValues);
        const ranges = [];
        if (this.distinctColumnValuesAreEmpty(distinctColumnsValues)) ranges.push({
            Min: 0,
            Max: 0,
            Color: (0, $5aWMQ.getHexForName)((0, $5aWMQ.GRAY))
        });
        if (minValue < 0) ranges.push({
            Min: minValue,
            Max: 0,
            Color: (0, $5aWMQ.getHexForName)((0, $5aWMQ.RED))
        });
        if (maxValue > 0) ranges.push({
            Min: 0,
            Max: maxValue,
            Color: (0, $5aWMQ.getHexForName)((0, $5aWMQ.DARK_GREEN))
        });
        return ranges;
    }
    distinctColumnValuesAreEmpty(distinctColumnsValues) {
        if ((0, $9g4SS.default).IsNullOrEmpty(distinctColumnsValues)) return true;
        if (distinctColumnsValues.length === 1 && String(distinctColumnsValues[0]) == '') return true;
        return false;
    }
}





class $57f6bf4ff57dbb4b$export$14e4317417d66053 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getDataChangeHistoryMode() {
        return this.getAdaptableState().Internal.DataChangeHistory.currentMode;
    }
    activateDataChangeHistory(forceReset) {
        const currentMode = this.getDataChangeHistoryMode();
        if (currentMode === 'ACTIVE' && !forceReset) return;
        if (forceReset || currentMode === 'INACTIVE') this.dispatchAction((0, $5b564bb703f29152$export$d4cbdbb82d50fbc3)());
        else if (currentMode === 'SUSPENDED') this.dispatchAction((0, $5b564bb703f29152$export$d6776ceaeb5c77dd)());
    }
    deactivateDataChangeHistory() {
        if (this.getDataChangeHistoryMode() === 'ACTIVE' || this.getDataChangeHistoryMode() === 'SUSPENDED') this.dispatchAction((0, $5b564bb703f29152$export$4344ed6f5015b32c)());
    }
    suspendDataChangeHistory() {
        if (this.getDataChangeHistoryMode() === 'ACTIVE') this.dispatchAction((0, $5b564bb703f29152$export$89243c08c46c6822)());
    }
    getDataChangeHistoryLog() {
        const changeLog = this.getAdaptableState().Internal.DataChangeHistory.logs ?? {};
        return Object.values(changeLog);
    }
    getDataChangeForGridCell(gridCell) {
        const allChanges = this.getDataChangeHistoryLog();
        return allChanges.find((c)=>c.primaryKeyValue == gridCell.primaryKeyValue && c.column.columnId == gridCell.column.columnId);
    }
    addDataChangeHistoryEntry(dataChangeInfo) {
        const uniqueKey = this.getDataChangeHistoryKey(dataChangeInfo);
        this.dispatchAction((0, $5b564bb703f29152$export$8580dc17bbdd2573)(dataChangeInfo, uniqueKey));
    }
    undoDataChangeHistoryEntry(dataChangeInfo) {
        const uniqueKey = this.getDataChangeHistoryKey(dataChangeInfo);
        this.dispatchAction((0, $5b564bb703f29152$export$e26ce75f14d36591)(dataChangeInfo, uniqueKey));
    }
    clearDataChangeHistoryEntry(dataChangeInfo) {
        const uniqueKey = this.getDataChangeHistoryKey(dataChangeInfo);
        this.dispatchAction((0, $5b564bb703f29152$export$6794413ec992f145)(dataChangeInfo, uniqueKey));
    }
    openDataChangeHistorySettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$376343cd8119f6bf);
    }
    getDataChangeHistoryKey = (dataChangeInfo)=>{
        const columnId = dataChangeInfo.column.columnId;
        const primaryKeyValue = dataChangeInfo.primaryKeyValue;
        const changedAt = dataChangeInfo.changedAt;
        const showLastDataChangeOnly = this.getDataChangeHistoryOptions().showLastDataChangeOnly;
        if (showLastDataChangeOnly) return JSON.stringify({
            columnId: columnId,
            primaryKeyValue: primaryKeyValue
        });
        else return JSON.stringify({
            columnId: columnId,
            primaryKeyValue: primaryKeyValue,
            changedAt: changedAt
        });
    };
}






var $9g4SS = parcelRequire("9g4SS");
class $c5c02965849e9b40$export$45f49fc4ecaa58cb extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Checks if a column is referenced in a given Expression
     * @param columnId Column to Check
     * @param expression Expression to Lookup
     */ isColumnReferencedInExpression(columnId, expression) {
        const colIds = this.getExpressionApi().getColumnsFromExpression(expression);
        return colIds.some((c)=>c === columnId);
    }
    evaluateExpressionInAdaptableQL(module, object, expression) {
        const evaluateExpressionExternallyFn = this.getExpressionOptions()?.evaluateAdaptableQLExternally;
        if (typeof evaluateExpressionExternallyFn !== 'function') return true;
        const context = {
            ...this.getAdaptableInternalApi().buildBaseContext(),
            module: module
        };
        if (object) context.object = object;
        if (expression) {
            context.expression = expression;
            context.referencedColumns = this.getExpressionApi().getColumnsFromExpression(expression).map((columnId)=>this.getColumnApi().getColumnWithColumnId(columnId));
        }
        return !evaluateExpressionExternallyFn(context);
    }
    shouldEvaluatePredicatesInAdaptableQL(module, object, predicates) {
        const evaluateExpressionExternallyFn = this.getExpressionOptions()?.evaluateAdaptableQLExternally;
        if (typeof evaluateExpressionExternallyFn !== 'function') return true;
        const context = {
            ...this.getAdaptableInternalApi().buildBaseContext(),
            module: module
        };
        if (object) context.object = object;
        if (predicates) context.predicates = predicates;
        return !evaluateExpressionExternallyFn(context);
    }
    getFieldsFromOptions() {
        const fields = this.getExpressionOptions().fields;
        if (fields != null && typeof fields === 'function') return fields(this.getAdaptableInternalApi().buildBaseContext());
        else {
            let arr = fields;
            if (arr && (0, $9g4SS.default).IsNotNullOrEmpty(arr)) return arr;
        }
    }
    getAvailableFields(data) {
        const optionFields = (this.getFieldsFromOptions() ?? [])?.map((field)=>({
                ...field,
                label: field.label || field.name
            }));
        // const existingFields = new Set<string>();
        // Exclude fields already in options
        // optionFields.forEach((field) => existingFields.add(field.value));
        // const queriableColumns = this.getColumnApi().getQueryableColumns();
        // Exclude queriable columns
        // queriableColumns.forEach((column) => existingFields.add(column.field));
        // const dataFields = this.getFieldsFromData(data).reduce<AdaptableField[]>((acc, field) => {
        //   if (!existingFields.has(field)) {
        //     acc.push({
        //       label: field,
        //       value: field,
        //     });
        //   }
        //   return acc;
        // }, []);
        return optionFields;
    }
    getFieldType(field) {
        const fieldDef = this.getFieldsFromOptions()?.find((f)=>f.name === field);
        if (fieldDef) return fieldDef.dataType;
        return 'text';
    }
    getFieldsOfType(type) {
        if (!type) return this.getAvailableFields() ?? [];
        return this.getAvailableFields()?.filter((f)=>f.dataType === type) ?? [];
    }
}


class $f49d62d4234d0e38$export$a2f359658d079d3d extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $c5c02965849e9b40$export$45f49fc4ecaa58cb)(_adaptable);
    }
    isValidBooleanExpression(query, module, validationErrorMessage) {
        const { isValid: isValid, errorMessage: errorMessage } = this.getAdaptableApi().internalApi.getQueryLanguageService().validateBoolean(query, module, {
            force: true
        });
        if (!isValid && validationErrorMessage) this.logWarn(`${validationErrorMessage} :: ${errorMessage}`);
        return isValid;
    }
    isValidObservableExpression(expression, module, validationErrorMessage) {
        const { isValid: isValid, errorMessage: errorMessage } = this.getAdaptableApi().internalApi.getQueryLanguageService().validateObservable(expression, module);
        if (!isValid && validationErrorMessage) this.logWarn(`${validationErrorMessage} :: ${errorMessage}`);
        return isValid;
    }
    isValidAggregatedBooleanExpression(expression, module, validationErrorMessage) {
        const { isValid: isValid, errorMessage: errorMessage } = this.getAdaptableApi().internalApi.getQueryLanguageService().validateAggregatedBoolean(expression, module);
        if (!isValid && validationErrorMessage) this.logWarn(`${validationErrorMessage} :: ${errorMessage}`);
        return isValid;
    }
    isValidAggregatedScalarExpression(expression, module, validationErrorMessage) {
        const { isValid: isValid, errorMessage: errorMessage } = this.getAdaptableApi().internalApi.getQueryLanguageService().validateAggregatedScalar(expression, module);
        if (!isValid && validationErrorMessage) this.logWarn(`${validationErrorMessage} :: ${errorMessage}`);
        return isValid;
    }
    getASTForExpression(query) {
        return $3f77892da2e22ac4$export$3846c6cc0ea43ce0(query);
    }
    getColumnsFromExpression(expression) {
        try {
            const columnIds = this.getAdaptableApi().internalApi.getQueryLanguageService().getColumnsFromExpression(expression);
            columnIds.forEach((columnId)=>{
                const calculatedColumn = this.getCalculatedColumnApi().getCalculatedColumnForColumnId(columnId);
                if (calculatedColumn) {
                    const transitiveColumnIds = this.getColumnsFromExpression(this.getAdaptableQueryExpression(calculatedColumn.Query));
                    columnIds.push(...transitiveColumnIds);
                }
            });
            return Array.from(new Set(columnIds));
        } catch (error) {
            // defensive programing, this should happen only if someone botched Initial Adaptable State
            this.logWarn(`QueryApi.getColumnsFromExpressionInvalid received an invalid expression: ${expression}
                  Error: ${error}`);
            return [];
        }
    }
    isColumnQueryable(abColumn) {
        let queryableColumnFn = this.getExpressionOptions().isColumnQueryable;
        if (queryableColumnFn) {
            const queryableColumnContext = {
                column: abColumn,
                ...this.getAdaptableInternalApi().buildBaseContext()
            };
            return queryableColumnFn(queryableColumnContext);
        }
        return true;
    }
    getAdaptableQueryExpression(query) {
        return query.BooleanExpression ?? query.ScalarExpression ?? query.ObservableExpression ?? query.AggregatedBooleanExpression ?? query.AggregatedScalarExpression;
    }
    getAdaptableQueryExpressionWithColumnFriendlyNames(query) {
        return this.getAdaptableApi().internalApi.getQueryLanguageService().getExpressionWithColumnFriendlyNames(this.getAdaptableQueryExpression(query));
    }
    useCaseSensitivity() {
        return this.getExpressionOptions().caseSensitiveExpressions;
    }
}







const $988d8536461217b3$export$e2d0633420933550 = '__ROW';
class $988d8536461217b3$export$370bae6f7382e373 {
    api;
    // map of rowPrimaryKey -> ColIdOrRowId -> FlashingCellUuid
    gridCellsCurrentlyFlashing;
    // map of FlashingCellUuid -> FlashingCell
    flashingCellsMapping;
    constructor(api){
        this.api = api;
        this.gridCellsCurrentlyFlashing = {};
        this.flashingCellsMapping = {};
    }
    destroy() {
        this.gridCellsCurrentlyFlashing = {};
        this.flashingCellsMapping = {};
    }
    addGridCellFlash(flashingCell) {
        const { rowPrimaryKey: rowPrimaryKey } = flashingCell;
        this.gridCellsCurrentlyFlashing[rowPrimaryKey] = this.gridCellsCurrentlyFlashing[rowPrimaryKey] || {};
        const columnIds = Object.keys(flashingCell.flashColumnIds);
        if (flashingCell.flashTarget === 'row' || flashingCell.flashTarget.includes('row')) columnIds.push($988d8536461217b3$export$e2d0633420933550);
        columnIds.forEach((colId)=>{
            this.gridCellsCurrentlyFlashing[rowPrimaryKey][colId] = flashingCell.Uuid;
        });
        this.flashingCellsMapping[flashingCell.Uuid] = flashingCell;
        this.refreshGridCells(flashingCell);
    }
    clearGridCellFlash(flashingCell) {
        const { rowPrimaryKey: rowPrimaryKey } = flashingCell;
        const columnIds = Object.keys(flashingCell.flashColumnIds);
        if (flashingCell.flashTarget === 'row' || flashingCell.flashTarget.includes('row')) columnIds.push($988d8536461217b3$export$e2d0633420933550);
        // for high frequency rates, we might have multiple flashes for the same cell
        if (this.gridCellsCurrentlyFlashing[rowPrimaryKey]) {
            columnIds.forEach((colId)=>{
                if (this.gridCellsCurrentlyFlashing[rowPrimaryKey][colId] === flashingCell.Uuid) delete this.gridCellsCurrentlyFlashing[rowPrimaryKey][colId];
            });
            if (!Object.keys(this.gridCellsCurrentlyFlashing[rowPrimaryKey]).length) delete this.gridCellsCurrentlyFlashing[rowPrimaryKey];
        }
        delete this.flashingCellsMapping[flashingCell.Uuid];
        this.refreshGridCells(flashingCell);
    }
    clearAllGridCellFlashes() {
        this.gridCellsCurrentlyFlashing = {};
        this.flashingCellsMapping = {};
        this.api.gridApi.refreshAllCells(true);
    }
    isAnyFlashingCellActive() {
        return Object.keys(this.gridCellsCurrentlyFlashing).length > 0;
    }
    refreshGridCells(flashingCell) {
        const { cellDataChangedInfo: cellDataChangedInfo } = flashingCell;
        if (!cellDataChangedInfo) return;
        this.api.gridApi.refreshCells(cellDataChangedInfo.rowNode, Object.keys(flashingCell.flashColumnIds), true);
    }
}


class $795e4571149fd9c6$export$3da00b6e6ea0f796 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Merges a Flashing Cell Definition with default values
     * @param flashingCellDefinition Flashing Cell Definition to Merge
     */ mergeFlashingCellDefinitionWithDefaults(flashingCellDefinition) {
        let flashingDefaults = this.getFlashingCellOptions();
        if (!flashingDefaults) return flashingCellDefinition;
        // deep clone it, otherwise we will mutate&share(!!) the global flashingCellOptions object
        flashingDefaults = (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(flashingDefaults);
        if (!flashingCellDefinition.DownChangeStyle && flashingDefaults.defaultDownChangeStyle) flashingCellDefinition.DownChangeStyle = flashingDefaults.defaultDownChangeStyle;
        if (!flashingCellDefinition.UpChangeStyle && flashingDefaults.defaultUpChangeStyle) flashingCellDefinition.UpChangeStyle = flashingDefaults.defaultUpChangeStyle;
        if (!flashingCellDefinition.NeutralChangeStyle && flashingDefaults.defaultNeutralChangeStyle) flashingCellDefinition.NeutralChangeStyle = flashingDefaults.defaultNeutralChangeStyle;
        if (!flashingCellDefinition.FlashDuration && flashingDefaults.defaultFlashDuration) flashingCellDefinition.FlashDuration = flashingDefaults.defaultFlashDuration;
        if (!flashingCellDefinition.FlashTarget && flashingDefaults.defaultFlashTarget) flashingCellDefinition.FlashTarget = flashingDefaults.defaultFlashTarget;
        return flashingCellDefinition;
    }
    getAdaptableFlashingCellFor(primaryKey, columnId) {
        const flashingCellService = this.getAdaptableInternalApi().getFlashingCellService();
        const AdaptableFlashingAlerts = flashingCellService.gridCellsCurrentlyFlashing;
        const AdaptableFlashingAlertsMap = flashingCellService.flashingCellsMapping;
        const forPrimaryKey = AdaptableFlashingAlerts[primaryKey] ?? {};
        const toFlashingAlert = (uuid)=>uuid ? AdaptableFlashingAlertsMap[uuid] ?? null : null;
        const adaptableFlashingCell = columnId ? toFlashingAlert(forPrimaryKey[columnId]) : toFlashingAlert(forPrimaryKey[0, $988d8536461217b3$export$e2d0633420933550]);
        if (adaptableFlashingCell?.flashingCellDefinition && !this.getLayoutApi().internalApi.isObjectExtendedInLayout(adaptableFlashingCell.flashingCellDefinition, 'FlashingCell', this.getLayoutApi().getCurrentLayout())) return;
        return adaptableFlashingCell;
    }
    clearFlashingCellState() {
        this.dispatchAction($0040cfd693076bab$export$ea937b45452d1f66());
    }
}


class $8f4ab2136441a99d$export$813f6ac80564bd19 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $795e4571149fd9c6$export$3da00b6e6ea0f796)(_adaptable);
    }
    getFlashingCellState() {
        return this.getAdaptableState().FlashingCell;
    }
    getFlashingCellDefinitions(config) {
        const flashingCellDefinitions = this.handleLayoutExtensionObjects(this.getFlashingCellState().FlashingCellDefinitions, 'FlashingCell', config) ?? [];
        return flashingCellDefinitions.map((flashingCellDefinition)=>{
            return this.internalApi.mergeFlashingCellDefinitionWithDefaults(flashingCellDefinition);
        });
    }
    getFlashingCellDefinitionById(id, config) {
        return this.getFlashingCellDefinitions(config)?.find((fc)=>fc?.Uuid === id);
    }
    getFlashingCellDefinitionByName(name) {
        return this.getFlashingCellDefinitions().find((fc)=>fc.Name === name);
    }
    getActiveFlashingCellDefinitions(config) {
        return this.getFlashingCellDefinitions(config).filter((fc)=>!fc.IsSuspended);
    }
    getSuspendedFlashingCellDefinitions(config) {
        return this.getFlashingCellDefinitions(config).filter((fc)=>fc.IsSuspended);
    }
    getFlashingCellFlashTarget(flashingCellDefinition) {
        return flashingCellDefinition.FlashTarget ?? 'cell';
    }
    showFlashingCell(flashingCellToShow) {
        this.addUidToAdaptableObject(flashingCellToShow);
        this.getAdaptableApi().internalApi.getFlashingCellService().addGridCellFlash(flashingCellToShow);
        const { FlashDuration: FlashDuration } = flashingCellToShow.flashingCellDefinition;
        if (FlashDuration && FlashDuration !== 'always') setTimeout(()=>{
            this.getAdaptableApi().internalApi.getFlashingCellService().clearGridCellFlash(flashingCellToShow);
        }, FlashDuration);
        this.getEventApi().internalApi.fireFlashingCellDisplayedEvent(flashingCellToShow);
    }
    addFlashingCellDefinition(flashingCellDefinition) {
        this.dispatchAction($26ec30a4ba180d8a$export$a8d1d19a17affa5e(flashingCellDefinition));
        return this.getFlashingCellDefinitionById(flashingCellDefinition.Uuid);
    }
    setFlashingCellDefinitions(flashingCellDefinitions) {
        this.dispatchAction($26ec30a4ba180d8a$export$33d59aff38cdf86(flashingCellDefinitions));
    }
    editFlashingCellDefinition(flashingCellDefinition) {
        this.dispatchAction($26ec30a4ba180d8a$export$5927e3ffef099800(flashingCellDefinition));
        return this.getFlashingCellDefinitionById(flashingCellDefinition.Uuid);
    }
    suspendFlashingCellDefinition(flashingCellDefinition) {
        this.dispatchAction($26ec30a4ba180d8a$export$d7b5cc0486d3a052(flashingCellDefinition));
        return this.getFlashingCellDefinitionById(flashingCellDefinition.Uuid);
    }
    unSuspendFlashingCellDefinition(flashingCellDefinition) {
        this.dispatchAction($26ec30a4ba180d8a$export$18482237a63d9b71(flashingCellDefinition));
        return this.getFlashingCellDefinitionById(flashingCellDefinition.Uuid);
    }
    suspendAllFlashingCellDefinition() {
        this.dispatchAction($26ec30a4ba180d8a$export$c6ef66fac999d641());
    }
    unSuspendAllFlashingCellDefinition() {
        this.dispatchAction($26ec30a4ba180d8a$export$ecc232ed8e2f9f96());
    }
    addFlashingCellDefinitions(flashingCellDefinitions) {
        flashingCellDefinitions.forEach((fad)=>{
            this.addFlashingCellDefinition(fad);
        });
        return flashingCellDefinitions?.map((flashingCell)=>this.getFlashingCellDefinitionById(flashingCell?.Uuid));
    }
    editFlashingCellDefinitions(flashingCellDefinitions) {
        flashingCellDefinitions.forEach((fad)=>{
            this.editFlashingCellDefinition(fad);
        });
        return flashingCellDefinitions?.map((flashingCell)=>this.getFlashingCellDefinitionById(flashingCell?.Uuid));
    }
    deleteFlashingCellDefinition(flashingCellDefinition) {
        this.dispatchAction($26ec30a4ba180d8a$export$2a634d0eb40c9e99(flashingCellDefinition));
    }
    getFlashingCellPredicateDefsForScope(scope) {
        return this.getAdaptableApi().predicateApi.internalApi.getFlashingCellPredicateDefs(scope).filter((predicateDef)=>this.getColumnScopeApi().isScopeInScope(scope, predicateDef.columnScope));
    }
    clearAllFlashingCells() {
        this.getAdaptableInternalApi().getFlashingCellService().clearAllGridCellFlashes();
    }
    isAnyFlashingCellActive() {
        return this.getAdaptableInternalApi().getFlashingCellService().isAnyFlashingCellActive();
    }
    findFlashingCellDefinitions(criteria) {
        return this.getAdaptableInternalApi().findAdaptableObjectsByLookupCriteria(criteria, this.getFlashingCellDefinitions({
            includeLayoutNotExtendedObjects: true
        }));
    }
}





var $9OAZF = parcelRequire("9OAZF");

class $eb79f1ad87e349a4$export$49f5de29f97fddf7 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getContainerElement(chartContainer) {
        const element = typeof chartContainer?.element === 'string' ? document.querySelector(chartContainer.element) : chartContainer?.element;
        if (!element && typeof chartContainer?.element === 'string') {
            this.getAdatableLogger().consoleLogByMessageType(`Chart container element not found: ${chartContainer.element}`, 'Error');
            return null;
        }
        return element;
    }
    getContainerElemetnByName(containerName) {
        const chartContainers = this.getChartingOptions().chartContainers ?? [];
        const chartContainer = chartContainers.find((container)=>container.name === containerName);
        return this.getContainerElement(chartContainer);
    }
    getUniqueChartName() {
        const charts = this.getChartingApi().getChartDefinitions();
        const externalCharts = this.getChartingApi().getExternalChartDefinitions();
        return `Chart ${charts.length + externalCharts.length + 1}`;
    }
    // External lib charting service
    isExternalChartOpened(chartDefinition) {
        const externalChartingOptions = this.getChartingOptions().externalChartingOptions;
        if (!externalChartingOptions?.isChartOpened) return false;
        if (!chartDefinition) return false;
        return externalChartingOptions.isChartOpened({
            chartDefinition: chartDefinition,
            ...this.getAdaptableInternalApi().buildBaseContext()
        });
    }
    onHideExternalChart(chartDefinition) {
        const externalChartingOptions = this.getChartingOptions().externalChartingOptions;
        if (!externalChartingOptions?.onHideChart) return;
        externalChartingOptions.onHideChart({
            chartDefinition: chartDefinition,
            ...this.getAdaptableInternalApi().buildBaseContext()
        });
    }
    onShowExternalChart(chartDefinition, container) {
        const externalChartingOptions = this.getChartingOptions().externalChartingOptions;
        if (!externalChartingOptions?.onShowChart) return;
        externalChartingOptions.onShowChart({
            chartDefinition: chartDefinition,
            container: container,
            ...this.getAdaptableInternalApi().buildBaseContext()
        });
    }
    onPreviewExternalChart(chartDefinition, container) {
        const externalChartingOptions = this.getChartingOptions().externalChartingOptions;
        if (!externalChartingOptions?.onPreviewChart) return;
        return externalChartingOptions.onPreviewChart({
            chartDefinition: chartDefinition,
            container: container,
            ...this.getAdaptableInternalApi().buildBaseContext()
        });
    }
    onDeleteExternalChart(chartDefinition) {
        const externalChartingOptions = this.getChartingOptions().externalChartingOptions;
        if (!externalChartingOptions?.onDeleteChart) return;
        externalChartingOptions.onDeleteChart({
            chartDefinition: chartDefinition,
            ...this.getAdaptableInternalApi().buildBaseContext()
        });
    }
}



class $c0b6748b980d4838$export$aa8f36dabaa4041c extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * @internal
     */ internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $eb79f1ad87e349a4$export$49f5de29f97fddf7)(_adaptable);
    }
    isChartingEnabled() {
        return this._adaptable.canGenerateCharts();
    }
    getCurrentChartModels() {
        return this._adaptable.getChartModels();
    }
    getChartRef(chartId) {
        return this._adaptable.getChartRef(chartId);
    }
    saveCurrentCharts() {
        const currentCharts = this.getCurrentChartModels();
        const chartDefinitions = currentCharts.map((chart)=>(0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyChartDefinition({
                Name: chart.chartId,
                Model: chart
            }));
        this.dispatchAction($5571bec319fd98b0$export$811673b95e451b75(chartDefinitions));
    }
    getPersistedCharts() {
        return this.getChartDefinitions().map((chart)=>chart.Model);
    }
    getChartDefinitions() {
        return (0, $5571bec319fd98b0$export$6fe5e0acd43ef01a)(this.getAdaptableState()) ?? [];
    }
    getChartDefinitionByUuid(uuid) {
        return this.getChartDefinitions().find((c)=>c.Uuid == uuid);
    }
    getChartDefinitionByName(name) {
        if ((0, $9OAZF.default).IsNotNullOrEmpty(name)) {
            let chartDefinition = this.getChartDefinitions().find((c)=>c.Name == name);
            if (this.checkItemExists(chartDefinition, name, 'Chart')) return chartDefinition;
        }
    }
    showPersistedCharts() {
        return this._adaptable.showCharts(this.getChartDefinitions());
    }
    showChartDefinition(chartDefiniton, container) {
        let containerElement = container;
        if (typeof containerElement === 'string') containerElement = this.internalApi.getContainerElemetnByName(containerElement);
        return this._adaptable.showChart(chartDefiniton, containerElement);
    }
    showChartDefinitionOnce(chartDefinition, container) {
        const chartRef = this.getChartRef(chartDefinition?.Model?.chartId);
        if (chartRef) return;
        return this.showChartDefinition(chartDefinition, container);
    }
    closeChartDefinition(chartDefinition) {
        const chartRef = this.getChartRef(chartDefinition.Model.chartId);
        if (chartRef) chartRef.destroyChart();
    }
    editChartDefinition(editedChartDefinition) {
        this.dispatchAction($5571bec319fd98b0$export$be4f1183e24b6d84(editedChartDefinition));
        this.updateAgChart(editedChartDefinition);
    }
    updateAgChart(chartDefinition) {
        this._adaptable.updateChart(chartDefinition);
    }
    addChartDefinition(chart) {
        this.dispatchAction($5571bec319fd98b0$export$f6871d811919866e(chart));
    }
    getChartingOpenState() {
        return {
            charts: this.getChartDefinitions().map((chartDefinition)=>{
                return {
                    chartDefinition: chartDefinition,
                    isOpen: this.getChartRef(chartDefinition?.Model?.chartId) != null,
                    containerName: this.getOpenChartContainer(chartDefinition)?.name
                };
            })
        };
    }
    getOpenChartContainer(chartDefinition) {
        const containerOptions = this.getChartingOptions().chartContainers;
        if (!containerOptions || !containerOptions.length) return null;
        return containerOptions.find((container)=>{
            const chartRef = this.getChartRef(chartDefinition.Model.chartId);
            const containerElement = this.internalApi.getContainerElement(container);
            if (!chartRef?.chartElement || !containerElement) return false;
            return containerElement.contains(chartRef.chartElement);
        }) ?? null;
    }
    setChartReadOnly(chartDefinition) {
        this.dispatchAction($5571bec319fd98b0$export$be4f1183e24b6d84({
            ...chartDefinition,
            IsReadOnly: true
        }));
    }
    setChartEditable(chartDefinition) {
        this.dispatchAction($5571bec319fd98b0$export$be4f1183e24b6d84({
            ...chartDefinition,
            IsReadOnly: false
        }));
    }
    addExternalChartDefinition(chartDefinition, options) {
        const saveChartBehaviour = options?.saveChartBehaviour ?? 'manual';
        if (saveChartBehaviour === 'auto') this.dispatchAction($5571bec319fd98b0$export$ff1ccc893f523729({
            ...chartDefinition,
            Name: chartDefinition.Name ?? this.internalApi.getUniqueChartName()
        }));
        else {
            const alert = {
                alertType: 'generic',
                header: 'Save Chart',
                message: 'Would you like to save this chart?',
                alertDefinition: {
                    ...(0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyAlertDefinition(),
                    MessageType: 'Info',
                    AlertProperties: {
                        DisplayNotification: true,
                        NotificationDuration: 'always'
                    },
                    AlertForm: {
                        Buttons: [
                            {
                                Label: 'Save',
                                Command: (context)=>{
                                    this.dispatchAction($5571bec319fd98b0$export$ff1ccc893f523729({
                                        ...chartDefinition,
                                        Name: context.formData.name || this.internalApi.getUniqueChartName()
                                    }));
                                },
                                ButtonStyle: {
                                    tone: 'info',
                                    variant: 'raised'
                                }
                            },
                            {
                                Label: 'Dismiss',
                                ButtonStyle: {
                                    tone: 'neutral',
                                    variant: 'raised'
                                }
                            }
                        ],
                        fields: [
                            {
                                name: 'name',
                                label: 'Name',
                                fieldType: 'text',
                                defaultValue: chartDefinition.Name ?? ''
                            }
                        ]
                    }
                }
            };
            this.getAlertApi().displayAdaptableAlert(alert);
        }
    }
    editExternalChartDefinition(chartDefinition) {
        this.dispatchAction($5571bec319fd98b0$export$ea52e494833ea893(chartDefinition));
    }
    deleteExternalChartDefinition(chartDefinition) {
        this.dispatchAction($5571bec319fd98b0$export$32550d3e9883bb0d(chartDefinition));
    }
    getExternalChartDefinitions() {
        return this.getAdaptableState().Charting.ExternalChartDefinitions;
    }
    getExternalChartDefinitionByName(name) {
        if ((0, $9OAZF.default).IsNotNullOrEmpty(name)) {
            let chartDefinition = this.getExternalChartDefinitions().find((c)=>c.Name == name);
            if (this.checkItemExists(chartDefinition, name, 'Chart')) return chartDefinition;
        }
    }
}




class $6effc0d621f895cf$export$438eb92e8494362f extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    openSettingsPanel(moduleName) {
        if (!moduleName) this.dispatchAction($dc56b6267ce4d0bb$export$e2d5bba0b444685d());
        const moduleInfo = this.getAdaptableInternalApi().getModuleService().getModuleInfoByModule(moduleName);
        if (!moduleInfo) this.logWarn(`${moduleName} module does not exist`);
        this.dispatchAction($dc56b6267ce4d0bb$export$e2d5bba0b444685d(moduleName, moduleInfo?.Popup));
    }
    openCustomSettingsPanel(name) {
        this.dispatchAction($dc56b6267ce4d0bb$export$e2d5bba0b444685d(null, name));
    }
    closeSettingsPanel() {
        this.dispatchAction($dc56b6267ce4d0bb$export$b591761538bae019());
    }
}







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $5445b32c0b713891$export$14b855fd280765df = ()=>{
    const [_count, setCount] = (0, $acw62.useState)(0);
    return (0, $acw62.useCallback)(()=>{
        setCount((count)=>count + 1);
    }, []);
};




const $79b01c1d220556e7$var$ActionButtons = (props)=>{
    const { buttons: buttons, adaptableApi: adaptableApi, context: context, rerender: rerender } = props;
    return $acw62.createElement($acw62.Fragment, null, buttons.map((button, index)=>{
        if (button.hidden && button.hidden(button, context)) return;
        const buttonIcon = adaptableApi.internalApi.getIconForButton(button, context, {
            height: 15,
            width: 15
        });
        const buttonStyle = adaptableApi.internalApi.getStyleForButton(button, context);
        const buttonLabel = adaptableApi.internalApi.getLabelForButton(button, context);
        const buttonTooltip = adaptableApi.internalApi.getTooltipForButton(button, context);
        const handleClick = ()=>{
            button.onClick?.(button, context);
            // Timeout to let any updates to be done before re-rendering the component
            setTimeout(()=>{
                // when called again it triggers a re-render
                // https:reactjs.org/docs/react-dom.html#render
                rerender();
            }, 16);
        };
        const disabled = button.disabled && button.disabled(button, context);
        const identifier = button.label ?? button.icon?.name ?? button.tooltip ?? `${index + 1}`;
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            key: button.Uuid,
            "data-name": `action-button-${identifier}`,
            variant: buttonStyle?.variant ?? 'text',
            disabled: disabled,
            tooltip: buttonTooltip,
            icon: buttonIcon,
            tone: buttonStyle?.tone ?? 'none',
            onClick: handleClick,
            className: buttonStyle?.className,
            accessLevel: 'Full'
        }, buttonLabel);
    }));
};
const $79b01c1d220556e7$export$688e89b740279725 = (props)=>{
    const rerender = (0, $5445b32c0b713891$export$14b855fd280765df)();
    const adaptable = props.context.__adaptable;
    if (!adaptable) {
        console.warn('Adaptable not found in context of ActionColumnRenderer');
        return null;
    }
    const { actionButtons: actionButtons, actionColumn: actionColumn } = adaptable.api.actionColumnApi.internalApi.getActionColumnsAndButtons(props.colDef);
    if (!actionColumn || !actionButtons.length) return null;
    const isGroupedRow = adaptable.api.gridApi.isGroupRowNode(props.node);
    const isSummaryRow = adaptable.api.gridApi.isSummaryNode(props.node);
    const isGrandTotalRowNode = adaptable.api.gridApi.isGrandTotalRowNode(props.node);
    let shouldRender = true;
    if (isGrandTotalRowNode) {
        if (actionColumn.rowScope?.ExcludeTotalRows) shouldRender = false;
    } else if (isGroupedRow) {
        if (actionColumn.rowScope?.ExcludeGroupRows) shouldRender = false;
    } else if (isSummaryRow) {
        if (actionColumn.rowScope?.ExcludeSummaryRows) shouldRender = false;
    } else if (actionColumn.rowScope?.ExcludeDataRows) shouldRender = false;
    if (!shouldRender) return null;
    // subscribe to the LayoutChange event and rerender on change
    const unsubscribe = adaptable.api.eventApi.on('AdaptableStateChanged', (eventInfo)=>{
        if (eventInfo.actionName === (0, $2c155f3e4804e29e$export$b79ae389bfecc801)) {
            if (eventInfo.oldState.Layout.CurrentLayout !== eventInfo.newState.Layout.CurrentLayout) rerender();
        }
    });
    // unsubscribe on unmount
    $acw62.useEffect(()=>{
        return ()=>{
            unsubscribe();
        };
    }, []);
    const pkValue = adaptable.getPrimaryKeyValueFromRowNode(props.node, props.api);
    const buttonContext = {
        actionColumn: actionColumn,
        primaryKeyValue: pkValue,
        rowNode: props.node,
        ...adaptable.api.internalApi.buildBaseContext(),
        data: props.data
    };
    return $acw62.createElement("div", {
        className: "ab-ActionColumn"
    }, $acw62.createElement($79b01c1d220556e7$var$ActionButtons, {
        buttons: actionButtons,
        adaptableApi: adaptable.api,
        context: buttonContext,
        rerender: rerender
    }));
};
class $79b01c1d220556e7$export$e07699803620456f {
    eGui;
    eventListener;
    unmountReactRoot;
    layoutSwitchUnsubscribe;
    actionButtons;
    // gets called once before the renderer is used
    init(params) {
        const adaptable = params.context.__adaptable;
        if (!adaptable) {
            console.warn('Adaptable not found in context of ActionColumnRenderer');
            return null;
        }
        const { actionButtons: actionButtons, actionColumn: actionColumn } = adaptable.api.actionColumnApi.internalApi.getActionColumnsAndButtons(params.colDef);
        if (!actionColumn || !actionButtons.length) return;
        this.actionButtons = actionButtons;
        // create the cell
        this.eGui = document.createElement('div');
        this.eGui.className = 'ab-ActionColumn';
        const isGroupedRow = adaptable.api.gridApi.isGroupRowNode(params.node);
        const isSummaryRow = adaptable.api.gridApi.isSummaryNode(params.node);
        const isGrandTotalRowNode = adaptable.api.gridApi.isGrandTotalRowNode(params.node);
        let shouldRender = true;
        if (isGrandTotalRowNode) {
            if (actionColumn.rowScope?.ExcludeTotalRows) shouldRender = false;
        } else if (isGroupedRow) {
            if (actionColumn.rowScope?.ExcludeGroupRows) shouldRender = false;
        } else if (isSummaryRow) {
            if (actionColumn.rowScope?.ExcludeSummaryRows) shouldRender = false;
        } else if (actionColumn.rowScope?.ExcludeDataRows) shouldRender = false;
        if (!shouldRender) {
            this.eGui.innerHTML = '';
            return;
        }
        const pkValue = adaptable.getPrimaryKeyValueFromRowNode(params.node, params.api);
        const buttonContext = {
            actionColumn: actionColumn,
            primaryKeyValue: pkValue,
            rowNode: params.node,
            ...adaptable.api.internalApi.buildBaseContext(),
            data: params.data
        };
        const eGui = this.eGui;
        const doRender = ()=>{
            this.unmountReactRoot = adaptable.renderReactRoot((0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)($79b01c1d220556e7$var$ActionButtons({
                buttons: this.actionButtons,
                context: buttonContext,
                rerender: doRender,
                adaptableApi: adaptable.api
            }), adaptable), eGui);
        };
        this.render = doRender;
        this.layoutSwitchUnsubscribe = adaptable.api.eventApi.on('AdaptableStateChanged', (eventInfo)=>{
            if (eventInfo.actionName === (0, $2c155f3e4804e29e$export$b79ae389bfecc801)) {
                if (eventInfo.oldState.Layout.CurrentLayout !== eventInfo.newState.Layout.CurrentLayout) {
                    const { actionButtons: freshActionButtons } = adaptable.api.actionColumnApi.internalApi.getActionColumnsAndButtons(params.colDef);
                    this.actionButtons = freshActionButtons;
                    doRender();
                }
            }
        });
        doRender();
    }
    // defined on init
    // used to re-render in refresh
    render() {}
    // gets called once when grid ready to insert the element
    getGui() {
        return this.eGui;
    }
    // gets called whenever the user gets the cell to refresh
    refresh(params) {
        // return true to tell the grid we refreshed successfully
        this.render();
        return true;
    }
    // gets called when the cell is removed from the grid
    destroy() {
        this.layoutSwitchUnsubscribe?.();
        this.unmountReactRoot?.();
        // do cleanup, remove event listener from button
        if (this.eGui) this.eGui.removeEventListener('click', this.eventListener);
    }
}



class $bcc48ef0855f215e$export$873a9f8d8f4a7a6c extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getColDefsForActionColumns() {
        const defaultSpecialColumnSettings = this.getGridApi().internalApi.deriveSpecialColumnSettingsFromAgGridDefaultColDef();
        const defaultActionColumnSettings = {
            ...defaultSpecialColumnSettings,
            resizable: true,
            suppressMenu: false,
            suppressMovable: false
        };
        return this.getActionColumnApi().getActionColumns().map((actionColumn)=>{
            const actionColumnSettings = {
                ...defaultActionColumnSettings,
                ...actionColumn.actionColumnSettings
            };
            const newColDef = {
                headerName: actionColumn.friendlyName ? actionColumn.friendlyName : actionColumn.columnId,
                colId: actionColumn.columnId,
                hide: false,
                editable: false,
                width: actionColumnSettings.width,
                resizable: actionColumnSettings.resizable,
                suppressHeaderMenuButton: actionColumnSettings.suppressMenu,
                suppressMovable: actionColumnSettings.suppressMovable,
                filter: false,
                sortable: false,
                enableRowGroup: false,
                cellRenderer: this.getGridApi().getVariant() === 'react' ? (0, $79b01c1d220556e7$export$688e89b740279725) : (0, $79b01c1d220556e7$export$e07699803620456f),
                type: [
                    (0, $b0d14b794bdca4f2$export$bc60d51b21bb9885)
                ]
            };
            this.logInfo('Setting up Action Column: ' + actionColumn.columnId);
            return newColDef;
        });
    }
    getActionColumnsAndButtons(colDef) {
        let actionColumn;
        // this should probably be in FDC3 api...
        if (!actionColumn && this.getFdc3Api().internalApi.isFdc3MainActionColumn(colDef.colId)) {
            const actionButtons = this.getFdc3Api().internalApi.getButtonsForFdc3MainActionColumn();
            const actionColumnDefaultConfiguration = this.getFdc3Options().actionColumnDefaultConfiguration;
            actionColumn = {
                columnId: actionColumnDefaultConfiguration.columnId,
                actionColumnButton: actionButtons,
                rowScope: actionColumnDefaultConfiguration.rowScope
            };
        }
        if (!actionColumn && this.getFdc3Api().internalApi.isFdc3StandaloneActionColumn(colDef.colId)) {
            const actionButtons = this.getFdc3Api().internalApi.getButtonsForFdc3StandaloneActionColumn(colDef.colId);
            const actionColumnDefaultConfiguration = this.getFdc3Options().actionColumnDefaultConfiguration;
            actionColumn = {
                columnId: colDef.colId,
                actionColumnButton: actionButtons,
                rowScope: actionColumnDefaultConfiguration.rowScope
            };
        }
        if (!actionColumn) actionColumn = this.getActionColumnApi().getActionColumns()?.find((ac)=>ac.columnId == colDef.colId);
        if (!actionColumn?.actionColumnButton) return {
            actionButtons: [],
            actionColumn: actionColumn
        };
        let actionButtons = Array.isArray(actionColumn.actionColumnButton) ? actionColumn.actionColumnButton : [
            actionColumn.actionColumnButton
        ];
        actionButtons = this.updateAllActionColumnButtons(actionButtons);
        return {
            actionButtons: actionButtons,
            actionColumn: actionColumn
        };
    }
    updateAllActionColumnButtons(actionButtons) {
        return actionButtons.map((actionButton)=>{
            actionButton = {
                ...actionButton
            };
            actionButton.Uuid = (0, $d7790b1d1a829cfc$export$10a020066a0f444a)();
            if (actionButton.command) this.updateActionButtonCommand(actionButton);
            return actionButton;
        });
    }
    updateActionButtonCommand(button) {
        switch(button.command){
            case 'create':
                button.onClick = ()=>{
                    this.getRowFormApi().displayCreateRowForm();
                };
                button.tooltip = button.tooltip ? button.tooltip : 'Create Row';
                button.icon = button.icon ?? {
                    name: 'add'
                };
                break;
            case 'clone':
                button.onClick = (button, context)=>{
                    this.getRowFormApi().displayCloneRowForm(context.primaryKeyValue);
                };
                button.tooltip = button.tooltip ? button.tooltip : 'Clone Row';
                button.icon = button.icon ?? {
                    name: 'clone'
                };
                break;
            case 'delete':
                button.onClick = (button, context)=>{
                    this.getRowFormApi().displayDeleteRowForm(context.primaryKeyValue);
                };
                button.tooltip = button.tooltip ? button.tooltip : 'Delete Row';
                button.icon = button.icon ?? {
                    name: 'delete'
                };
                break;
            case 'edit':
                button.onClick = (button, context)=>{
                    this.getRowFormApi().displayEditRowForm(context.primaryKeyValue);
                };
                button.tooltip = button.tooltip ? button.tooltip : 'Edit Row';
                button.icon = button.icon ?? {
                    name: 'edit'
                };
                break;
        }
    }
}


class $7cdbced582e081be$export$ae5ba1f8f2042657 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $bcc48ef0855f215e$export$873a9f8d8f4a7a6c)(_adaptable);
    }
    getActionColumns() {
        return this.getActionColumnOptions().actionColumns ?? [];
    }
    getActionColumnForColumnId(columnId) {
        return this.getActionColumns().find((ac)=>ac.columnId === columnId);
    }
}






var $9g4SS = parcelRequire("9g4SS");
class $b7cf04b7bbd54890$export$9de768c0b8470618 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getMinValueForNumericColumn(column) {
        if (column.dataType !== 'number') return undefined;
        return this._adaptable.getMinMaxCachedValueForColumn(column, 'min');
    }
    getMaxValueForNumericColumn(column) {
        if (column.dataType !== 'number') return undefined;
        return this._adaptable.getMinMaxCachedValueForColumn(column, 'max');
    }
    /**
     * Gets the Minimum Value to display for a Styled Column
     * @param styledColumn Styled Column to check
     * @param rowNode current Row Node
     * @param cellValue current Cell Value
     */ getNumericStyleMinValue(styledColumn, column, rowNode, cellValue) {
        const columnComparison = styledColumn.GradientStyle ? styledColumn.GradientStyle.ColumnComparison : styledColumn.PercentBarStyle?.ColumnComparison;
        if (columnComparison) {
            if (!isNaN(Number(columnComparison.MinValue))) return Number(columnComparison.MinValue);
            else {
                let columnId = columnComparison.MinValue;
                if (!this.getColumnApi().isColumnInGrid(columnId)) return 0;
                else return this.getGridApi().getRawValueFromRowNode(rowNode, columnId);
            }
        }
        // for Gradient Column we want just the range that contains cell value
        if (styledColumn.GradientStyle) {
            const range = this.findRangeForColumn(styledColumn.GradientStyle.CellRanges, column, styledColumn.GradientStyle.RangeValueType, cellValue);
            return this.getCellColorRangeMinValue(range, column, styledColumn.GradientStyle.RangeValueType);
        }
        // for percentbar we want to get the whole Ranges
        if (styledColumn.PercentBarStyle) {
            const ranges = styledColumn.PercentBarStyle?.CellRanges;
            if (ranges) return this.getCellColorRangeMinValue(ranges[0], column, styledColumn.PercentBarStyle.RangeValueType);
        }
    }
    /**
     * Returns last range that matches the cell value.
     *
     * @param cellRanges
     * @param column
     * @param rangeValueType
     * @param cellValue
     */ findRangeForColumn(cellRanges, column, rangeValueType, cellValue) {
        if (!cellRanges || cellRanges.length === 0) return null;
        let lastMatchingRange = null;
        // findLast is not available on [], target is not es6
        for(let i = cellRanges.length; i >= 0; i--){
            const cellRange = cellRanges[i];
            const minRange = this.getCellColorRangeMinValue(cellRange, column, rangeValueType);
            const maxRange = this.getCellColorRangeMaxValue(cellRange, column, rangeValueType);
            if (cellValue >= minRange && cellValue <= maxRange) {
                lastMatchingRange = cellRange;
                break;
            }
        }
        return lastMatchingRange;
    }
    /**
     * Gets the Maximum Value to display for a Styled Column
     * @param styledColumn Styled Column to check
     * @param rowNode current Row Node
     * @param cellValue current Cell Value
     */ getNumericStyleMaxValue(styledColumn, column, rowNode, cellValue) {
        const columnComparison = styledColumn.GradientStyle ? styledColumn.GradientStyle.ColumnComparison : styledColumn.PercentBarStyle?.ColumnComparison;
        if (columnComparison) {
            if (!isNaN(Number(columnComparison.MaxValue))) return Number(columnComparison.MaxValue);
            else {
                let columnId = columnComparison.MaxValue;
                if (!this.getColumnApi().isColumnInGrid(columnId)) return 0;
                else return this.getGridApi().getRawValueFromRowNode(rowNode, columnId);
            }
        }
        if (styledColumn.GradientStyle) {
            let range = this.findRangeForColumn(styledColumn.GradientStyle.CellRanges, column, styledColumn.GradientStyle.RangeValueType, cellValue);
            return this.getCellColorRangeMaxValue(range, column, styledColumn.GradientStyle.RangeValueType);
        }
        if (styledColumn.PercentBarStyle) {
            const ranges = styledColumn.PercentBarStyle?.CellRanges;
            if (ranges) return this.getCellColorRangeMaxValue(ranges[ranges.length - 1], column, styledColumn.PercentBarStyle.RangeValueType);
        }
    }
    /**
     * Returns the smallest number in a Range
     * @param range Range to check
     * @param column current Column
     */ getCellColorRangeMinValue(range, column, rangeValueType) {
        if (!range) return undefined;
        if (range.Min == undefined) return undefined;
        let minValue;
        if (typeof range.Min === 'number' && rangeValueType === 'Percentage') {
            const minColumnValue = this.getMinValueForNumericColumn(column);
            const maxColumnValue = this.getMaxValueForNumericColumn(column);
            minValue = minColumnValue + range.Min / 100 * (maxColumnValue - minColumnValue);
        } else if (range.Min === 'Col-Min') {
            const minColumnValue = this.getMinValueForNumericColumn(column);
            minValue = minColumnValue;
        } else minValue = range.Min;
        return minValue;
    }
    /**
     * Returns the largest number in a Range
     * @param range Range to check
     * @param column current Column
     */ getCellColorRangeMaxValue(range, column, rangeValueType) {
        if (!range) return undefined;
        if (range.Max == undefined) return undefined;
        let maxValue;
        if (typeof range.Max === 'number' && rangeValueType === 'Percentage') {
            const minColumnValue = this.getMinValueForNumericColumn(column);
            const maxColumnValue = this.getMaxValueForNumericColumn(column);
            maxValue = minColumnValue + range.Max / 100 * (maxColumnValue - minColumnValue);
        } else if (range.Max === 'Col-Max') {
            const maxColumnValue = this.getMaxValueForNumericColumn(column);
            maxValue = maxColumnValue;
        } else maxValue = range.Max;
        return maxValue;
    }
    /**
     * Retrieves the ColumnComparison property, if there, from a Styled Column
     * @param styledColumn Styled Column to Add
     */ getColumnComparisonForStyledColumn(styledColumn) {
        if (styledColumn.GradientStyle) {
            if (styledColumn.GradientStyle?.ColumnComparison) return styledColumn.GradientStyle.ColumnComparison;
        }
        if (styledColumn.PercentBarStyle) {
            if (styledColumn.PercentBarStyle?.ColumnComparison) return styledColumn.PercentBarStyle.ColumnComparison;
        }
        return undefined;
    }
    /**
     * Returns any ColumnIds referenced in a Column Comparison
     * @param columnComparision Column Comparison to check
     */ getColumnIdsFromColumnComparison(columnComparison) {
        let returnValues = [];
        if (typeof columnComparison.MinValue === 'string') {
            let minIds = this.getDependentColumnIds(columnComparison.MinValue);
            if ((0, $9g4SS.default).IsNotNullOrEmpty(minIds)) returnValues.push(...minIds);
        }
        if (typeof columnComparison.MaxValue === 'string') {
            let maxIds = this.getDependentColumnIds(columnComparison.MaxValue);
            if ((0, $9g4SS.default).IsNotNullOrEmpty(maxIds)) returnValues.push(...maxIds);
        }
        return returnValues;
    }
    getDependentColumnIds(columnId) {
        if (this.getColumnApi().isCalculatedColumn(columnId)) return this.getCalculatedColumnApi().internalApi.getReferencedColumnIdsForCalculatedColumnId(columnId);
        else return [
            columnId
        ];
    }
    /**
     * Checks if the styled column has a range with a relative value
     * @param styledColumn Styled Column to Add
     */ hasStyledColumnRelativeCellRange(styledColumn) {
        let cellColorRange = null;
        let rangeValueType = 'Number';
        if (styledColumn.GradientStyle) {
            if (styledColumn.GradientStyle?.CellRanges) cellColorRange = styledColumn.GradientStyle.CellRanges;
            if (styledColumn.GradientStyle?.RangeValueType) rangeValueType = styledColumn.GradientStyle.RangeValueType;
        }
        if (styledColumn.PercentBarStyle) {
            if (styledColumn.PercentBarStyle?.CellRanges) cellColorRange = styledColumn.PercentBarStyle.CellRanges;
            if (styledColumn.PercentBarStyle?.RangeValueType) rangeValueType = styledColumn.PercentBarStyle.RangeValueType;
        }
        return (rangeValueType === 'Percentage' || cellColorRange?.some((cellColorRange)=>{
            return cellColorRange.Min == 'Col-Min' || cellColorRange.Max == 'Col-Max';
        })) ?? false;
    }
    getApplicableBadge(badgeStyle, context) {
        if (!badgeStyle.Badges.length) return null;
        // first that matches, sort last ones without predicate
        const badgesWithoutAll = [];
        const badgesWithAll = [];
        for (let badge of badgeStyle.Badges)if (!badge.Predicate) badgesWithAll.push(badge);
        else badgesWithoutAll.push(badge);
        for (let badge of badgesWithoutAll){
            if (this.getPredicateApi().handlePredicate(badge.Predicate, context, false)) return badge;
        }
        const [firstBadgeWithAll] = badgesWithAll;
        return firstBadgeWithAll ?? null;
    }
    getBadgePredicateDefsForColumn(columnId) {
        const column = this.getColumnApi().getColumnWithColumnId(columnId);
        if (!column) return undefined;
        const scope = {
            ColumnIds: [
                column.columnId
            ]
        };
        return this.getPredicateApi().internalApi.getBadgeStylePredicateDefs(scope).filter((predicate)=>this.getColumnScopeApi().isColumnInScope(column, predicate.columnScope));
    }
}



class $665789c2c1f7eabf$export$6dd6f6d80a5a8c88 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $b7cf04b7bbd54890$export$9de768c0b8470618)(_adaptable);
    }
    getStyledColumnState() {
        return this.getAdaptableState().StyledColumn;
    }
    getStyledColumns(config) {
        return this.handleLayoutExtensionObjects(this.getStyledColumnState().StyledColumns, 'StyledColumn', config) ?? [];
    }
    getStyledColumnById(id, config) {
        return this.getStyledColumns(config).find((styledcolumn)=>styledcolumn.Uuid === id);
    }
    getStyledColumnForColumnId(columnId, config) {
        return this.getStyledColumns(config).find((styledcolumn)=>styledcolumn.ColumnId === columnId);
    }
    getActiveStyledColumns(config) {
        return this.getStyledColumns(config).filter((styledcolumn)=>!styledcolumn.IsSuspended);
    }
    getSuspendedStyledColumns(config) {
        return this.getStyledColumns(config).filter((styledcolumn)=>styledcolumn.IsSuspended);
    }
    deleteStyledColumn(styledColumn) {
        this.dispatchAction($e8ca06942ba9c0b6$export$3dfcc5faf1946cbb(styledColumn));
    }
    deleteAllStyledColumns() {
        this.dispatchAction($e8ca06942ba9c0b6$export$8e07fce2d39db7d7());
    }
    addStyledColumn(styledColumn) {
        this.dispatchAction($e8ca06942ba9c0b6$export$292f31ea3d79c677(styledColumn));
    }
    editStyledColumn(styledColumn) {
        this.dispatchAction($e8ca06942ba9c0b6$export$bb2fbe12e4c588d7(styledColumn));
        return this.getStyledColumnById(styledColumn.Uuid);
    }
    isSparklineStyleStyledColumn(column) {
        if (!column) return false;
        return !!this.getStyledColumns().find((styledColumn)=>!!styledColumn.SparklineStyle && styledColumn.ColumnId === column.columnId);
    }
    getActiveStyledColumnForColumn(column) {
        const styledColumns = this.getActiveStyledColumns();
        return styledColumns.find((sc)=>sc.ColumnId == column.columnId);
    }
    hasPercentBarStyle(columnId) {
        if (!columnId) return false;
        return !!this.getStyledColumns().find((styledColumn)=>!!styledColumn.PercentBarStyle && styledColumn.ColumnId === columnId);
    }
    hasGradientStyle(columnId) {
        if (!columnId) return false;
        return !!this.getStyledColumns().find((styledColumn)=>!!styledColumn.GradientStyle && styledColumn.ColumnId === columnId);
    }
    canDisplaySparklines() {
        return this._adaptable.canDisplaySparklines();
    }
    suspendStyledColumn(styledColumn) {
        this.dispatchAction($e8ca06942ba9c0b6$export$2c1b6bb508b3a62c(styledColumn));
    }
    unSuspendStyledColumn(styledColumn) {
        this.dispatchAction($e8ca06942ba9c0b6$export$a2ae8bf0128483d5(styledColumn));
    }
    suspendAllStyledColumn() {
        this.dispatchAction($e8ca06942ba9c0b6$export$7b6ed1b680677da9());
    }
    unSuspendAllStyledColumn() {
        this.dispatchAction($e8ca06942ba9c0b6$export$b6435374e77e122f());
    }
    openStyledColumnSettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$7d380408a8ffe7db);
    }
}



class $b8a643437f1a9f0c$export$5032a4bae1ffb805 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getNextWorkingDay() {
        let counterDate = new Date();
        let isWorkingDay = false;
        while(!isWorkingDay){
            counterDate.setDate(counterDate.getDate() + 1);
            isWorkingDay = this.isWorkingDay(counterDate);
        }
        return counterDate;
    }
    getPreviousWorkingDay() {
        let counterDate = new Date();
        let isWorkingDay = false;
        while(!isWorkingDay){
            counterDate.setDate(counterDate.getDate() - 1);
            isWorkingDay = this.isWorkingDay(counterDate);
        }
        return counterDate;
    }
    isWorkingDay(dateToCheck) {
        const holidays = this.getHolidays();
        if (!holidays) return dateToCheck.getDay() != 0 && dateToCheck.getDay() != 6;
        for (let holiday of holidays){
            if (holiday.setHours(0, 0, 0, 0) == dateToCheck.setHours(0, 0, 0, 0)) return false;
        }
        return dateToCheck.getDay() != 0 && dateToCheck.getDay() != 6;
    }
    isHoliday(dateToCheck) {
        return !this.isWorkingDay(dateToCheck);
    }
    isSameDay(firstDateToCheck, secondDateToCheck) {
        return firstDateToCheck.getFullYear() === secondDateToCheck.getFullYear() && firstDateToCheck.getMonth() === secondDateToCheck.getMonth() && firstDateToCheck.getDate() === secondDateToCheck.getDate();
    }
    getHolidays() {
        const holidays = this.getCalendarOptions().holidays;
        if (holidays) {
            if (typeof holidays === 'function') return holidays(this.getAdaptableInternalApi().buildBaseContext());
            else return holidays;
        }
    }
}




class $067b8b3551768d32$export$6523f3060c2a5b80 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    setModulesEntitlements() {
        this.getAdaptableInternalApi().getModuleService().getModuleCollection().forEach((module)=>{
            module.setModuleEntitlement();
        });
    }
    setModulesAgGridDepsInfos() {
        this.getAdaptableInternalApi().getModuleService().getModuleCollection().forEach((module)=>{
            module.setAgGridDepsInfo();
        });
    }
}


class $664525c1a78dd067$export$7cec8b79960070af extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $067b8b3551768d32$export$6523f3060c2a5b80)(_adaptable);
    }
    getEntitlementAccessLevelForModule(adaptableModule) {
        let entitlementOptions = this.getEntitlementOptions();
        if (entitlementOptions) {
            const defaultAccessLevelContext = this.getAdaptableInternalApi().buildBaseContext();
            const defaultAccessLevel = typeof entitlementOptions.defaultAccessLevel === 'function' ? entitlementOptions.defaultAccessLevel(defaultAccessLevelContext) : entitlementOptions.defaultAccessLevel;
            const moduleEntitlements = entitlementOptions.moduleEntitlements;
            if (moduleEntitlements) {
                if (typeof moduleEntitlements === 'function') {
                    const entitlementContext = {
                        adaptableModule: adaptableModule,
                        ...this.getAdaptableInternalApi().buildBaseContext(),
                        defaultAccessLevel: defaultAccessLevel
                    };
                    const dynamicModuleEntitlement = moduleEntitlements(entitlementContext);
                    return dynamicModuleEntitlement ?? defaultAccessLevel;
                } else {
                    const entitlement = moduleEntitlements.find((f)=>f.adaptableModule === adaptableModule);
                    if (entitlement) return entitlement.accessLevel;
                }
            }
            // if still here then return their default Access Level
            return defaultAccessLevel;
        }
        return 'Full';
    }
    isObjectReadonly(object) {
        return object.IsReadOnly;
    }
    isModuleHiddenEntitlement(adaptableModule) {
        return this.getEntitlementAccessLevelForModule(adaptableModule) == 'Hidden';
    }
    isModuleFullEntitlement(adaptableModule) {
        return this.getEntitlementAccessLevelForModule(adaptableModule) == 'Full';
    }
    isModuleReadOnlyEntitlement(adaptableModule) {
        return this.getEntitlementAccessLevelForModule(adaptableModule) == 'ReadOnly';
    }
}



class $3866793aa54782fb$export$a59b55d19d8398c6 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    getAdaptableId() {
        return this.getAdaptableOptions().adaptableId;
    }
    getAdaptableStateKey() {
        return this.getAdaptableOptions().adaptableStateKey;
    }
    isAutogeneratePrimaryKey() {
        return this.getAdaptableOptions().autogeneratePrimaryKey;
    }
    getLicenseKey() {
        return this.getAdaptableOptions().licenseKey;
    }
    getPrimaryKey() {
        return this.getAdaptableOptions().primaryKey;
    }
    getUserName() {
        return this.getAdaptableOptions().userName;
    }
    getAdaptableContext() {
        if (this.getAdaptableOptions().adaptableContext == undefined) this.getAdaptableOptions().adaptableContext = {};
        return this.getAdaptableOptions().adaptableContext;
    }
    getAdaptableOptions() {
        return this.getOptions();
    }
    getActionColumnOptions() {
        return this.getOptions().actionColumnOptions;
    }
    getRowFormOptions() {
        return this.getOptions().rowFormOptions;
    }
    getCellSummaryOptions() {
        return this.getOptions().cellSummaryOptions;
    }
    getCalendarOptions() {
        return this.getOptions().calendarOptions;
    }
    getColumnOptions() {
        return this.getOptions().columnOptions;
    }
    getNoteOptions() {
        return this.getOptions().noteOptions;
    }
    getPredicateOptions() {
        return this.getOptions().predicateOptions;
    }
    getCommentOptions() {
        return this.getOptions().commentOptions;
    }
    getCustomSortOptions() {
        return this.getOptions().customSortOptions;
    }
    getContainerOptions() {
        return this.getOptions().containerOptions;
    }
    getDataSetOptions() {
        return this.getOptions().dataSetOptions;
    }
    getNotificationsOptions() {
        return this.getOptions().notificationsOptions;
    }
    getAlertOptions() {
        return this.getOptions().alertOptions;
    }
    getDashboardOptions() {
        return this.getOptions().dashboardOptions;
    }
    getEditOptions() {
        return this.getOptions().editOptions;
    }
    getExportOptions() {
        return this.getOptions().exportOptions;
    }
    getLayoutOptions() {
        return this.getOptions().layoutOptions;
    }
    getColumnMenuOptions() {
        return this.getOptions().columnMenuOptions;
    }
    getContextMenuOptions() {
        return this.getOptions().contextMenuOptions;
    }
    getFilterOptions() {
        return this.getOptions().filterOptions;
    }
    getExpressionOptions() {
        return this.getOptions().expressionOptions;
    }
    getQuickSearchOptions() {
        return this.getOptions().quickSearchOptions;
    }
    getFormatColumnOptions() {
        return this.getOptions().formatColumnOptions;
    }
    getStateOptions() {
        return this.getOptions().stateOptions;
    }
    getTeamSharingOptions() {
        return this.getOptions().teamSharingOptions;
    }
    getUserInterfaceOptions() {
        return this.getOptions().userInterfaceOptions;
    }
    getToolPanelOptions() {
        return this.getOptions().toolPanelOptions;
    }
    getChartingOptions() {
        return this.getOptions().chartingOptions;
    }
    getDataChangeHistoryOptions() {
        return this.getOptions().dataChangeHistoryOptions;
    }
    getEntitlementOptions() {
        return this.getOptions().entitlementOptions;
    }
    getFlashingCellOptions() {
        return this.getOptions().flashingCellOptions;
    }
    getSettingsPanelOptions() {
        return this.getOptions().settingsPanelOptions;
    }
    getFdc3Options() {
        return this.getOptions().fdc3Options;
    }
    getDataImportOptions() {
        return this.getOptions().dataImportOptions;
    }
    addToAdaptableContext(key, value) {
        const adaptableContext = this.getAdaptableContext();
        adaptableContext[key] = value;
    }
    removeFromAdaptableContext(key) {
        const adaptableContext = this.getAdaptableContext();
        delete adaptableContext[key];
    }
    clearAdaptableContext() {
        this.getAdaptableOptions().adaptableContext = {};
    }
}





class $64cffdacb2382e4c$export$9ba4c26836cf34f2 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    areNotesSupported() {
        if (this.getLayoutApi().isCurrentLayoutPivot()) return false;
        return true;
    }
    getNotesDateFormat() {
        const dateFormat = this.getNoteOptions().dateFormat;
        return typeof dateFormat === 'function' ? dateFormat() : dateFormat;
    }
}


class $da508fccc09992a1$export$44763b2263c3d96f extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $64cffdacb2382e4c$export$9ba4c26836cf34f2)(_adaptable);
    }
    addNote(noteStr, primaryKeyValue, columnId) {
        const note = {
            Text: noteStr,
            PrimaryKeyValue: primaryKeyValue,
            ColumnId: columnId,
            Timestamp: Date.now()
        };
        this.dispatchAction($b5b505fd5df04a9f$export$612fca4781b41952(note));
    }
    editNote(note) {
        note.Timestamp = Date.now();
        this.dispatchAction($b5b505fd5df04a9f$export$4ea42cdbfb14947f(note));
    }
    updateNoteText(noteStr, note) {
        this.editNote({
            ...note,
            Text: noteStr
        });
    }
    deleteNote(note) {
        this.dispatchAction($b5b505fd5df04a9f$export$178f4e1b750a5517(note));
    }
    getNoteState() {
        return this.getAdaptableState().Note;
    }
    getAllNotes() {
        return this.getNoteState().Notes;
    }
    getNoteForCell(cellAddress) {
        return $b5b505fd5df04a9f$export$382cdf5ac6d0bf8b(this.getAdaptableState().Note, cellAddress);
    }
    getNoteByUuid(uuid) {
        return this.getAllNotes().find((note)=>note.Uuid === uuid);
    }
}




// To parse this data:
//
//   import { Convert, AgentErrorResponseMessage, AgentRequestMessage, AgentResponseMessage, BridgeErrorResponseMessage, BridgeRequestMessage, BridgeResponseMessage, BroadcastAgentRequest, BroadcastBridgeRequest, ConnectionStepMessage, ConnectionStep2Hello, ConnectionStep3Handshake, ConnectionStep4AuthenticationFailed, ConnectionStep6ConnectedAgentsUpdate, FindInstancesAgentErrorResponse, FindInstancesAgentRequest, FindInstancesAgentResponse, FindInstancesBridgeErrorResponse, FindInstancesBridgeRequest, FindInstancesBridgeResponse, FindIntentAgentErrorResponse, FindIntentAgentRequest, FindIntentAgentResponse, FindIntentBridgeErrorResponse, FindIntentBridgeRequest, FindIntentBridgeResponse, FindIntentsByContextAgentErrorResponse, FindIntentsByContextAgentRequest, FindIntentsByContextAgentResponse, FindIntentsByContextBridgeErrorResponse, FindIntentsByContextBridgeRequest, FindIntentsByContextBridgeResponse, GetAppMetadataAgentErrorResponse, GetAppMetadataAgentRequest, GetAppMetadataAgentResponse, GetAppMetadataBridgeErrorResponse, GetAppMetadataBridgeRequest, GetAppMetadataBridgeResponse, OpenAgentErrorResponse, OpenAgentRequest, OpenAgentResponse, OpenBridgeErrorResponse, OpenBridgeRequest, OpenBridgeResponse, PrivateChannelBroadcastAgentRequest, PrivateChannelBroadcastBridgeRequest, PrivateChannelEventListenerAddedAgentRequest, PrivateChannelEventListenerAddedBridgeRequest, PrivateChannelEventListenerRemovedAgentRequest, PrivateChannelEventListenerRemovedBridgeRequest, PrivateChannelOnAddContextListenerAgentRequest, PrivateChannelOnAddContextListenerBridgeRequest, PrivateChannelOnDisconnectAgentRequest, PrivateChannelOnDisconnectBridgeRequest, PrivateChannelOnUnsubscribeAgentRequest, PrivateChannelOnUnsubscribeBridgeRequest, RaiseIntentAgentErrorResponse, RaiseIntentAgentRequest, RaiseIntentAgentResponse, RaiseIntentBridgeErrorResponse, RaiseIntentBridgeRequest, RaiseIntentBridgeResponse, RaiseIntentResultAgentErrorResponse, RaiseIntentResultAgentResponse, RaiseIntentResultBridgeErrorResponse, RaiseIntentResultBridgeResponse, Context } from "./file";
//
//   const fDC3DesktopAgentAPISchema = Convert.toFDC3DesktopAgentAPISchema(json);
//   const agentErrorResponseMessage = Convert.toAgentErrorResponseMessage(json);
//   const agentRequestMessage = Convert.toAgentRequestMessage(json);
//   const agentResponseMessage = Convert.toAgentResponseMessage(json);
//   const bridgeErrorResponseMessage = Convert.toBridgeErrorResponseMessage(json);
//   const bridgeRequestMessage = Convert.toBridgeRequestMessage(json);
//   const bridgeResponseMessage = Convert.toBridgeResponseMessage(json);
//   const broadcastAgentRequest = Convert.toBroadcastAgentRequest(json);
//   const broadcastBridgeRequest = Convert.toBroadcastBridgeRequest(json);
//   const bridgingCommons = Convert.toBridgingCommons(json);
//   const connectionStepMessage = Convert.toConnectionStepMessage(json);
//   const connectionStep2Hello = Convert.toConnectionStep2Hello(json);
//   const connectionStep3Handshake = Convert.toConnectionStep3Handshake(json);
//   const connectionStep4AuthenticationFailed = Convert.toConnectionStep4AuthenticationFailed(json);
//   const connectionStep6ConnectedAgentsUpdate = Convert.toConnectionStep6ConnectedAgentsUpdate(json);
//   const findInstancesAgentErrorResponse = Convert.toFindInstancesAgentErrorResponse(json);
//   const findInstancesAgentRequest = Convert.toFindInstancesAgentRequest(json);
//   const findInstancesAgentResponse = Convert.toFindInstancesAgentResponse(json);
//   const findInstancesBridgeErrorResponse = Convert.toFindInstancesBridgeErrorResponse(json);
//   const findInstancesBridgeRequest = Convert.toFindInstancesBridgeRequest(json);
//   const findInstancesBridgeResponse = Convert.toFindInstancesBridgeResponse(json);
//   const findIntentAgentErrorResponse = Convert.toFindIntentAgentErrorResponse(json);
//   const findIntentAgentRequest = Convert.toFindIntentAgentRequest(json);
//   const findIntentAgentResponse = Convert.toFindIntentAgentResponse(json);
//   const findIntentBridgeErrorResponse = Convert.toFindIntentBridgeErrorResponse(json);
//   const findIntentBridgeRequest = Convert.toFindIntentBridgeRequest(json);
//   const findIntentBridgeResponse = Convert.toFindIntentBridgeResponse(json);
//   const findIntentsByContextAgentErrorResponse = Convert.toFindIntentsByContextAgentErrorResponse(json);
//   const findIntentsByContextAgentRequest = Convert.toFindIntentsByContextAgentRequest(json);
//   const findIntentsByContextAgentResponse = Convert.toFindIntentsByContextAgentResponse(json);
//   const findIntentsByContextBridgeErrorResponse = Convert.toFindIntentsByContextBridgeErrorResponse(json);
//   const findIntentsByContextBridgeRequest = Convert.toFindIntentsByContextBridgeRequest(json);
//   const findIntentsByContextBridgeResponse = Convert.toFindIntentsByContextBridgeResponse(json);
//   const getAppMetadataAgentErrorResponse = Convert.toGetAppMetadataAgentErrorResponse(json);
//   const getAppMetadataAgentRequest = Convert.toGetAppMetadataAgentRequest(json);
//   const getAppMetadataAgentResponse = Convert.toGetAppMetadataAgentResponse(json);
//   const getAppMetadataBridgeErrorResponse = Convert.toGetAppMetadataBridgeErrorResponse(json);
//   const getAppMetadataBridgeRequest = Convert.toGetAppMetadataBridgeRequest(json);
//   const getAppMetadataBridgeResponse = Convert.toGetAppMetadataBridgeResponse(json);
//   const openAgentErrorResponse = Convert.toOpenAgentErrorResponse(json);
//   const openAgentRequest = Convert.toOpenAgentRequest(json);
//   const openAgentResponse = Convert.toOpenAgentResponse(json);
//   const openBridgeErrorResponse = Convert.toOpenBridgeErrorResponse(json);
//   const openBridgeRequest = Convert.toOpenBridgeRequest(json);
//   const openBridgeResponse = Convert.toOpenBridgeResponse(json);
//   const privateChannelBroadcastAgentRequest = Convert.toPrivateChannelBroadcastAgentRequest(json);
//   const privateChannelBroadcastBridgeRequest = Convert.toPrivateChannelBroadcastBridgeRequest(json);
//   const privateChannelEventListenerAddedAgentRequest = Convert.toPrivateChannelEventListenerAddedAgentRequest(json);
//   const privateChannelEventListenerAddedBridgeRequest = Convert.toPrivateChannelEventListenerAddedBridgeRequest(json);
//   const privateChannelEventListenerRemovedAgentRequest = Convert.toPrivateChannelEventListenerRemovedAgentRequest(json);
//   const privateChannelEventListenerRemovedBridgeRequest = Convert.toPrivateChannelEventListenerRemovedBridgeRequest(json);
//   const privateChannelOnAddContextListenerAgentRequest = Convert.toPrivateChannelOnAddContextListenerAgentRequest(json);
//   const privateChannelOnAddContextListenerBridgeRequest = Convert.toPrivateChannelOnAddContextListenerBridgeRequest(json);
//   const privateChannelOnDisconnectAgentRequest = Convert.toPrivateChannelOnDisconnectAgentRequest(json);
//   const privateChannelOnDisconnectBridgeRequest = Convert.toPrivateChannelOnDisconnectBridgeRequest(json);
//   const privateChannelOnUnsubscribeAgentRequest = Convert.toPrivateChannelOnUnsubscribeAgentRequest(json);
//   const privateChannelOnUnsubscribeBridgeRequest = Convert.toPrivateChannelOnUnsubscribeBridgeRequest(json);
//   const raiseIntentAgentErrorResponse = Convert.toRaiseIntentAgentErrorResponse(json);
//   const raiseIntentAgentRequest = Convert.toRaiseIntentAgentRequest(json);
//   const raiseIntentAgentResponse = Convert.toRaiseIntentAgentResponse(json);
//   const raiseIntentBridgeErrorResponse = Convert.toRaiseIntentBridgeErrorResponse(json);
//   const raiseIntentBridgeRequest = Convert.toRaiseIntentBridgeRequest(json);
//   const raiseIntentBridgeResponse = Convert.toRaiseIntentBridgeResponse(json);
//   const raiseIntentResultAgentErrorResponse = Convert.toRaiseIntentResultAgentErrorResponse(json);
//   const raiseIntentResultAgentResponse = Convert.toRaiseIntentResultAgentResponse(json);
//   const raiseIntentResultBridgeErrorResponse = Convert.toRaiseIntentResultBridgeErrorResponse(json);
//   const raiseIntentResultBridgeResponse = Convert.toRaiseIntentResultBridgeResponse(json);
//   const context = Convert.toContext(json);
//
// These functions will throw an error if the JSON doesn't
// match the expected interface, even if the JSON is valid.
// Converts JSON strings to/from your types
// and asserts the results of JSON.parse at runtime
var $8a9068d6d6521bd9$var$Convert$1 = /** @class */ function() {
    function Convert() {}
    Convert.toFDC3DesktopAgentAPISchema = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), "any");
    };
    Convert.fDC3DesktopAgentAPISchemaToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, "any"), null, 2);
    };
    Convert.toAgentErrorResponseMessage = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("AgentErrorResponseMessage"));
    };
    Convert.agentErrorResponseMessageToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("AgentErrorResponseMessage")), null, 2);
    };
    Convert.toAgentRequestMessage = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("AgentRequestMessage"));
    };
    Convert.agentRequestMessageToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("AgentRequestMessage")), null, 2);
    };
    Convert.toAgentResponseMessage = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("AgentResponseMessage"));
    };
    Convert.agentResponseMessageToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("AgentResponseMessage")), null, 2);
    };
    Convert.toBridgeErrorResponseMessage = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("BridgeErrorResponseMessage"));
    };
    Convert.bridgeErrorResponseMessageToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("BridgeErrorResponseMessage")), null, 2);
    };
    Convert.toBridgeRequestMessage = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("BridgeRequestMessage"));
    };
    Convert.bridgeRequestMessageToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("BridgeRequestMessage")), null, 2);
    };
    Convert.toBridgeResponseMessage = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("BridgeResponseMessage"));
    };
    Convert.bridgeResponseMessageToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("BridgeResponseMessage")), null, 2);
    };
    Convert.toBroadcastAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("BroadcastAgentRequest"));
    };
    Convert.broadcastAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("BroadcastAgentRequest")), null, 2);
    };
    Convert.toBroadcastBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("BroadcastBridgeRequest"));
    };
    Convert.broadcastBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("BroadcastBridgeRequest")), null, 2);
    };
    Convert.toBridgingCommons = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$m$1("any"));
    };
    Convert.bridgingCommonsToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$m$1("any")), null, 2);
    };
    Convert.toConnectionStepMessage = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("ConnectionStepMessage"));
    };
    Convert.connectionStepMessageToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("ConnectionStepMessage")), null, 2);
    };
    Convert.toConnectionStep2Hello = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("ConnectionStep2Hello"));
    };
    Convert.connectionStep2HelloToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("ConnectionStep2Hello")), null, 2);
    };
    Convert.toConnectionStep3Handshake = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("ConnectionStep3Handshake"));
    };
    Convert.connectionStep3HandshakeToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("ConnectionStep3Handshake")), null, 2);
    };
    Convert.toConnectionStep4AuthenticationFailed = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("ConnectionStep4AuthenticationFailed"));
    };
    Convert.connectionStep4AuthenticationFailedToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("ConnectionStep4AuthenticationFailed")), null, 2);
    };
    Convert.toConnectionStep6ConnectedAgentsUpdate = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("ConnectionStep6ConnectedAgentsUpdate"));
    };
    Convert.connectionStep6ConnectedAgentsUpdateToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("ConnectionStep6ConnectedAgentsUpdate")), null, 2);
    };
    Convert.toFindInstancesAgentErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindInstancesAgentErrorResponse"));
    };
    Convert.findInstancesAgentErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindInstancesAgentErrorResponse")), null, 2);
    };
    Convert.toFindInstancesAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindInstancesAgentRequest"));
    };
    Convert.findInstancesAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindInstancesAgentRequest")), null, 2);
    };
    Convert.toFindInstancesAgentResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindInstancesAgentResponse"));
    };
    Convert.findInstancesAgentResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindInstancesAgentResponse")), null, 2);
    };
    Convert.toFindInstancesBridgeErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeErrorResponse"));
    };
    Convert.findInstancesBridgeErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeErrorResponse")), null, 2);
    };
    Convert.toFindInstancesBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeRequest"));
    };
    Convert.findInstancesBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeRequest")), null, 2);
    };
    Convert.toFindInstancesBridgeResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeResponse"));
    };
    Convert.findInstancesBridgeResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeResponse")), null, 2);
    };
    Convert.toFindIntentAgentErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentAgentErrorResponse"));
    };
    Convert.findIntentAgentErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentAgentErrorResponse")), null, 2);
    };
    Convert.toFindIntentAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentAgentRequest"));
    };
    Convert.findIntentAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentAgentRequest")), null, 2);
    };
    Convert.toFindIntentAgentResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentAgentResponse"));
    };
    Convert.findIntentAgentResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentAgentResponse")), null, 2);
    };
    Convert.toFindIntentBridgeErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentBridgeErrorResponse"));
    };
    Convert.findIntentBridgeErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentBridgeErrorResponse")), null, 2);
    };
    Convert.toFindIntentBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentBridgeRequest"));
    };
    Convert.findIntentBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentBridgeRequest")), null, 2);
    };
    Convert.toFindIntentBridgeResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentBridgeResponse"));
    };
    Convert.findIntentBridgeResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentBridgeResponse")), null, 2);
    };
    Convert.toFindIntentsByContextAgentErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentErrorResponse"));
    };
    Convert.findIntentsByContextAgentErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentErrorResponse")), null, 2);
    };
    Convert.toFindIntentsByContextAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentRequest"));
    };
    Convert.findIntentsByContextAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentRequest")), null, 2);
    };
    Convert.toFindIntentsByContextAgentResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentResponse"));
    };
    Convert.findIntentsByContextAgentResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentResponse")), null, 2);
    };
    Convert.toFindIntentsByContextBridgeErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeErrorResponse"));
    };
    Convert.findIntentsByContextBridgeErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeErrorResponse")), null, 2);
    };
    Convert.toFindIntentsByContextBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeRequest"));
    };
    Convert.findIntentsByContextBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeRequest")), null, 2);
    };
    Convert.toFindIntentsByContextBridgeResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeResponse"));
    };
    Convert.findIntentsByContextBridgeResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeResponse")), null, 2);
    };
    Convert.toGetAppMetadataAgentErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentErrorResponse"));
    };
    Convert.getAppMetadataAgentErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentErrorResponse")), null, 2);
    };
    Convert.toGetAppMetadataAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentRequest"));
    };
    Convert.getAppMetadataAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentRequest")), null, 2);
    };
    Convert.toGetAppMetadataAgentResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentResponse"));
    };
    Convert.getAppMetadataAgentResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentResponse")), null, 2);
    };
    Convert.toGetAppMetadataBridgeErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeErrorResponse"));
    };
    Convert.getAppMetadataBridgeErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeErrorResponse")), null, 2);
    };
    Convert.toGetAppMetadataBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeRequest"));
    };
    Convert.getAppMetadataBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeRequest")), null, 2);
    };
    Convert.toGetAppMetadataBridgeResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeResponse"));
    };
    Convert.getAppMetadataBridgeResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeResponse")), null, 2);
    };
    Convert.toOpenAgentErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("OpenAgentErrorResponse"));
    };
    Convert.openAgentErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("OpenAgentErrorResponse")), null, 2);
    };
    Convert.toOpenAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("OpenAgentRequest"));
    };
    Convert.openAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("OpenAgentRequest")), null, 2);
    };
    Convert.toOpenAgentResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("OpenAgentResponse"));
    };
    Convert.openAgentResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("OpenAgentResponse")), null, 2);
    };
    Convert.toOpenBridgeErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("OpenBridgeErrorResponse"));
    };
    Convert.openBridgeErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("OpenBridgeErrorResponse")), null, 2);
    };
    Convert.toOpenBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("OpenBridgeRequest"));
    };
    Convert.openBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("OpenBridgeRequest")), null, 2);
    };
    Convert.toOpenBridgeResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("OpenBridgeResponse"));
    };
    Convert.openBridgeResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("OpenBridgeResponse")), null, 2);
    };
    Convert.toPrivateChannelBroadcastAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelBroadcastAgentRequest"));
    };
    Convert.privateChannelBroadcastAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelBroadcastAgentRequest")), null, 2);
    };
    Convert.toPrivateChannelBroadcastBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelBroadcastBridgeRequest"));
    };
    Convert.privateChannelBroadcastBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelBroadcastBridgeRequest")), null, 2);
    };
    Convert.toPrivateChannelEventListenerAddedAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerAddedAgentRequest"));
    };
    Convert.privateChannelEventListenerAddedAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerAddedAgentRequest")), null, 2);
    };
    Convert.toPrivateChannelEventListenerAddedBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerAddedBridgeRequest"));
    };
    Convert.privateChannelEventListenerAddedBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerAddedBridgeRequest")), null, 2);
    };
    Convert.toPrivateChannelEventListenerRemovedAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerRemovedAgentRequest"));
    };
    Convert.privateChannelEventListenerRemovedAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerRemovedAgentRequest")), null, 2);
    };
    Convert.toPrivateChannelEventListenerRemovedBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerRemovedBridgeRequest"));
    };
    Convert.privateChannelEventListenerRemovedBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerRemovedBridgeRequest")), null, 2);
    };
    Convert.toPrivateChannelOnAddContextListenerAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelOnAddContextListenerAgentRequest"));
    };
    Convert.privateChannelOnAddContextListenerAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelOnAddContextListenerAgentRequest")), null, 2);
    };
    Convert.toPrivateChannelOnAddContextListenerBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelOnAddContextListenerBridgeRequest"));
    };
    Convert.privateChannelOnAddContextListenerBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelOnAddContextListenerBridgeRequest")), null, 2);
    };
    Convert.toPrivateChannelOnDisconnectAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelOnDisconnectAgentRequest"));
    };
    Convert.privateChannelOnDisconnectAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelOnDisconnectAgentRequest")), null, 2);
    };
    Convert.toPrivateChannelOnDisconnectBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelOnDisconnectBridgeRequest"));
    };
    Convert.privateChannelOnDisconnectBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelOnDisconnectBridgeRequest")), null, 2);
    };
    Convert.toPrivateChannelOnUnsubscribeAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelOnUnsubscribeAgentRequest"));
    };
    Convert.privateChannelOnUnsubscribeAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelOnUnsubscribeAgentRequest")), null, 2);
    };
    Convert.toPrivateChannelOnUnsubscribeBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("PrivateChannelOnUnsubscribeBridgeRequest"));
    };
    Convert.privateChannelOnUnsubscribeBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("PrivateChannelOnUnsubscribeBridgeRequest")), null, 2);
    };
    Convert.toRaiseIntentAgentErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentErrorResponse"));
    };
    Convert.raiseIntentAgentErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentErrorResponse")), null, 2);
    };
    Convert.toRaiseIntentAgentRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentRequest"));
    };
    Convert.raiseIntentAgentRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentRequest")), null, 2);
    };
    Convert.toRaiseIntentAgentResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentResponse"));
    };
    Convert.raiseIntentAgentResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentResponse")), null, 2);
    };
    Convert.toRaiseIntentBridgeErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeErrorResponse"));
    };
    Convert.raiseIntentBridgeErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeErrorResponse")), null, 2);
    };
    Convert.toRaiseIntentBridgeRequest = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeRequest"));
    };
    Convert.raiseIntentBridgeRequestToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeRequest")), null, 2);
    };
    Convert.toRaiseIntentBridgeResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeResponse"));
    };
    Convert.raiseIntentBridgeResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeResponse")), null, 2);
    };
    Convert.toRaiseIntentResultAgentErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentErrorResponse"));
    };
    Convert.raiseIntentResultAgentErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentErrorResponse")), null, 2);
    };
    Convert.toRaiseIntentResultAgentResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentResponse"));
    };
    Convert.raiseIntentResultAgentResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentResponse")), null, 2);
    };
    Convert.toRaiseIntentResultBridgeErrorResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("RaiseIntentResultBridgeErrorResponse"));
    };
    Convert.raiseIntentResultBridgeErrorResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("RaiseIntentResultBridgeErrorResponse")), null, 2);
    };
    Convert.toRaiseIntentResultBridgeResponse = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("RaiseIntentResultBridgeResponse"));
    };
    Convert.raiseIntentResultBridgeResponseToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("RaiseIntentResultBridgeResponse")), null, 2);
    };
    Convert.toContext = function(json) {
        return $8a9068d6d6521bd9$var$cast$1(JSON.parse(json), $8a9068d6d6521bd9$var$r$1("Context"));
    };
    Convert.contextToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast$1(value, $8a9068d6d6521bd9$var$r$1("Context")), null, 2);
    };
    return Convert;
}();
function $8a9068d6d6521bd9$var$invalidValue$1(typ, val, key, parent) {
    if (parent === void 0) parent = '';
    var prettyTyp = $8a9068d6d6521bd9$var$prettyTypeName$1(typ);
    var parentText = parent ? " on ".concat(parent) : '';
    var keyText = key ? " for key \"".concat(key, "\"") : '';
    throw Error("Invalid value".concat(keyText).concat(parentText, ". Expected ").concat(prettyTyp, " but got ").concat(JSON.stringify(val)));
}
function $8a9068d6d6521bd9$var$prettyTypeName$1(typ) {
    if (Array.isArray(typ)) {
        if (typ.length === 2 && typ[0] === undefined) return "an optional ".concat($8a9068d6d6521bd9$var$prettyTypeName$1(typ[1]));
        else return "one of [".concat(typ.map(function(a) {
            return $8a9068d6d6521bd9$var$prettyTypeName$1(a);
        }).join(", "), "]");
    } else if (typeof typ === "object" && typ.literal !== undefined) return typ.literal;
    else return typeof typ;
}
function $8a9068d6d6521bd9$var$jsonToJSProps$1(typ) {
    if (typ.jsonToJS === undefined) {
        var map_1 = {};
        typ.props.forEach(function(p) {
            return map_1[p.json] = {
                key: p.js,
                typ: p.typ
            };
        });
        typ.jsonToJS = map_1;
    }
    return typ.jsonToJS;
}
function $8a9068d6d6521bd9$var$jsToJSONProps$1(typ) {
    if (typ.jsToJSON === undefined) {
        var map_2 = {};
        typ.props.forEach(function(p) {
            return map_2[p.js] = {
                key: p.json,
                typ: p.typ
            };
        });
        typ.jsToJSON = map_2;
    }
    return typ.jsToJSON;
}
function $8a9068d6d6521bd9$var$transform$1(val, typ, getProps, key, parent) {
    if (key === void 0) key = '';
    if (parent === void 0) parent = '';
    function transformPrimitive(typ, val) {
        if (typeof typ === typeof val) return val;
        return $8a9068d6d6521bd9$var$invalidValue$1(typ, val, key, parent);
    }
    function transformUnion(typs, val) {
        // val must validate against one typ in typs
        var l = typs.length;
        for(var i = 0; i < l; i++){
            var typ_1 = typs[i];
            try {
                return $8a9068d6d6521bd9$var$transform$1(val, typ_1, getProps);
            } catch (_) {}
        }
        return $8a9068d6d6521bd9$var$invalidValue$1(typs, val, key, parent);
    }
    function transformEnum(cases, val) {
        if (cases.indexOf(val) !== -1) return val;
        return $8a9068d6d6521bd9$var$invalidValue$1(cases.map(function(a) {
            return $8a9068d6d6521bd9$var$l$1(a);
        }), val, key, parent);
    }
    function transformArray(typ, val) {
        // val must be an array with no invalid elements
        if (!Array.isArray(val)) return $8a9068d6d6521bd9$var$invalidValue$1($8a9068d6d6521bd9$var$l$1("array"), val, key, parent);
        return val.map(function(el) {
            return $8a9068d6d6521bd9$var$transform$1(el, typ, getProps);
        });
    }
    function transformDate(val) {
        if (val === null) return null;
        var d = new Date(val);
        if (isNaN(d.valueOf())) return $8a9068d6d6521bd9$var$invalidValue$1($8a9068d6d6521bd9$var$l$1("Date"), val, key, parent);
        return d;
    }
    function transformObject(props, additional, val) {
        if (val === null || typeof val !== "object" || Array.isArray(val)) return $8a9068d6d6521bd9$var$invalidValue$1($8a9068d6d6521bd9$var$l$1(ref || "object"), val, key, parent);
        var result = {};
        Object.getOwnPropertyNames(props).forEach(function(key) {
            var prop = props[key];
            var v = Object.prototype.hasOwnProperty.call(val, key) ? val[key] : undefined;
            result[prop.key] = $8a9068d6d6521bd9$var$transform$1(v, prop.typ, getProps, key, ref);
        });
        Object.getOwnPropertyNames(val).forEach(function(key) {
            if (!Object.prototype.hasOwnProperty.call(props, key)) result[key] = $8a9068d6d6521bd9$var$transform$1(val[key], additional, getProps, key, ref);
        });
        return result;
    }
    if (typ === "any") return val;
    if (typ === null) {
        if (val === null) return val;
        return $8a9068d6d6521bd9$var$invalidValue$1(typ, val, key, parent);
    }
    if (typ === false) return $8a9068d6d6521bd9$var$invalidValue$1(typ, val, key, parent);
    var ref = undefined;
    while(typeof typ === "object" && typ.ref !== undefined){
        ref = typ.ref;
        typ = $8a9068d6d6521bd9$var$typeMap$1[typ.ref];
    }
    if (Array.isArray(typ)) return transformEnum(typ, val);
    if (typeof typ === "object") return typ.hasOwnProperty("unionMembers") ? transformUnion(typ.unionMembers, val) : typ.hasOwnProperty("arrayItems") ? transformArray(typ.arrayItems, val) : typ.hasOwnProperty("props") ? transformObject(getProps(typ), typ.additional, val) : $8a9068d6d6521bd9$var$invalidValue$1(typ, val, key, parent);
    // Numbers can be parsed by Date but shouldn't be.
    if (typ === Date && typeof val !== "number") return transformDate(val);
    return transformPrimitive(typ, val);
}
function $8a9068d6d6521bd9$var$cast$1(val, typ) {
    return $8a9068d6d6521bd9$var$transform$1(val, typ, $8a9068d6d6521bd9$var$jsonToJSProps$1);
}
function $8a9068d6d6521bd9$var$uncast$1(val, typ) {
    return $8a9068d6d6521bd9$var$transform$1(val, typ, $8a9068d6d6521bd9$var$jsToJSONProps$1);
}
function $8a9068d6d6521bd9$var$l$1(typ) {
    return {
        literal: typ
    };
}
function $8a9068d6d6521bd9$var$a$1(typ) {
    return {
        arrayItems: typ
    };
}
function $8a9068d6d6521bd9$var$u$1() {
    var typs = [];
    for(var _i = 0; _i < arguments.length; _i++)typs[_i] = arguments[_i];
    return {
        unionMembers: typs
    };
}
function $8a9068d6d6521bd9$var$o$1(props, additional) {
    return {
        props: props,
        additional: additional
    };
}
function $8a9068d6d6521bd9$var$m$1(additional) {
    return {
        props: [],
        additional: additional
    };
}
function $8a9068d6d6521bd9$var$r$1(name) {
    return {
        ref: name
    };
}
var $8a9068d6d6521bd9$var$typeMap$1 = {
    "AgentErrorResponseMessage": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("AgentResponseMetadata")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("ErrorResponseMessagePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("ResponseMessageType")
        }
    ], false),
    "AgentResponseMetadata": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "ErrorResponseMessagePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("ResponseErrorDetail")
        }
    ], "any"),
    "AgentRequestMessage": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("AgentRequestMetadata")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$m$1("any")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("RequestMessageType")
        }
    ], false),
    "AgentRequestMetadata": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("BridgeParticipantIdentifier"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("SourceIdentifier"))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "BridgeParticipantIdentifier": $8a9068d6d6521bd9$var$o$1([
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: ""
        },
        {
            json: "appId",
            js: "appId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], "any"),
    "SourceIdentifier": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appId",
            js: "appId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], "any"),
    "AgentResponseMessage": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("AgentResponseMetadata")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$m$1("any")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("ResponseMessageType")
        }
    ], false),
    "BridgeErrorResponseMessage": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("BridgeErrorResponseMessageMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("ResponseErrorMessagePayload")
        },
        {
            json: "type",
            js: "type",
            typ: ""
        }
    ], false),
    "BridgeErrorResponseMessageMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail"))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "DesktopAgentIdentifier": $8a9068d6d6521bd9$var$o$1([
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: ""
        }
    ], "any"),
    "ResponseErrorMessagePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("ResponseErrorDetail"))
        }
    ], "any"),
    "BridgeRequestMessage": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("BridgeRequestMetadata")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$m$1("any")
        },
        {
            json: "type",
            js: "type",
            typ: ""
        }
    ], false),
    "BridgeRequestMetadata": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("BridgeParticipantIdentifier"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("BridgeParticipantIdentifier")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "BridgeResponseMessage": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("BridgeResponseMessageMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$m$1("any")
        },
        {
            json: "type",
            js: "type",
            typ: ""
        }
    ], false),
    "BridgeResponseMessageMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail")))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "sources",
            js: "sources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "BroadcastAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("BroadcastAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("BroadcastAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("BroadcastAgentRequestType")
        }
    ], false),
    "BroadcastAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("SourceObject")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "SourceObject": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appId",
            js: "appId",
            typ: ""
        },
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], "any"),
    "BroadcastAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$r$1("ContextElement")
        }
    ], false),
    "ContextElement": $8a9068d6d6521bd9$var$o$1([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$m$1("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: ""
        }
    ], "any"),
    "BroadcastBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("BroadcastBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("BroadcastBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("BroadcastAgentRequestType")
        }
    ], false),
    "BroadcastBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSource")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "MetaSource": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appId",
            js: "appId",
            typ: ""
        },
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: ""
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], "any"),
    "BroadcastBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$r$1("ContextElement")
        }
    ], false),
    "ConnectionStepMessage": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStepMetadata")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$m$1("any")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStepMessageType")
        }
    ], false),
    "ConnectionStepMetadata": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "ConnectionStep2Hello": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep2HelloMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep2HelloPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep2HelloType")
        }
    ], false),
    "ConnectionStep2HelloMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "ConnectionStep2HelloPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "authRequired",
            js: "authRequired",
            typ: true
        },
        {
            json: "authToken",
            js: "authToken",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "desktopAgentBridgeVersion",
            js: "desktopAgentBridgeVersion",
            typ: ""
        },
        {
            json: "supportedFDC3Versions",
            js: "supportedFDC3Versions",
            typ: $8a9068d6d6521bd9$var$a$1("")
        }
    ], false),
    "ConnectionStep3Handshake": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep3HandshakeMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep3HandshakePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep3HandshakeType")
        }
    ], false),
    "ConnectionStep3HandshakeMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "ConnectionStep3HandshakePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "authToken",
            js: "authToken",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "channelsState",
            js: "channelsState",
            typ: $8a9068d6d6521bd9$var$m$1($8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ContextElement")))
        },
        {
            json: "implementationMetadata",
            js: "implementationMetadata",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectingAgentImplementationMetadata")
        },
        {
            json: "requestedName",
            js: "requestedName",
            typ: ""
        }
    ], false),
    "ConnectingAgentImplementationMetadata": $8a9068d6d6521bd9$var$o$1([
        {
            json: "fdc3Version",
            js: "fdc3Version",
            typ: ""
        },
        {
            json: "optionalFeatures",
            js: "optionalFeatures",
            typ: $8a9068d6d6521bd9$var$r$1("OptionalFeatures")
        },
        {
            json: "provider",
            js: "provider",
            typ: ""
        },
        {
            json: "providerVersion",
            js: "providerVersion",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], false),
    "OptionalFeatures": $8a9068d6d6521bd9$var$o$1([
        {
            json: "DesktopAgentBridging",
            js: "DesktopAgentBridging",
            typ: true
        },
        {
            json: "OriginatingAppMetadata",
            js: "OriginatingAppMetadata",
            typ: true
        },
        {
            json: "UserChannelMembershipAPIs",
            js: "UserChannelMembershipAPIs",
            typ: true
        }
    ], false),
    "ConnectionStep4AuthenticationFailed": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep4AuthenticationFailedMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep4AuthenticationFailedPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep4AuthenticationFailedType")
        }
    ], false),
    "ConnectionStep4AuthenticationFailedMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "ConnectionStep4AuthenticationFailedPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "message",
            js: "message",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], false),
    "ConnectionStep6ConnectedAgentsUpdate": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep6ConnectedAgentsUpdateMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep6ConnectedAgentsUpdatePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("ConnectionStep6ConnectedAgentsUpdateType")
        }
    ], false),
    "ConnectionStep6ConnectedAgentsUpdateMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "ConnectionStep6ConnectedAgentsUpdatePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "addAgent",
            js: "addAgent",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "allAgents",
            js: "allAgents",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentImplementationMetadata"))
        },
        {
            json: "channelsState",
            js: "channelsState",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$m$1($8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ContextElement"))))
        },
        {
            json: "removeAgent",
            js: "removeAgent",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], false),
    "DesktopAgentImplementationMetadata": $8a9068d6d6521bd9$var$o$1([
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: ""
        },
        {
            json: "fdc3Version",
            js: "fdc3Version",
            typ: ""
        },
        {
            json: "optionalFeatures",
            js: "optionalFeatures",
            typ: $8a9068d6d6521bd9$var$r$1("OptionalFeatures")
        },
        {
            json: "provider",
            js: "provider",
            typ: ""
        },
        {
            json: "providerVersion",
            js: "providerVersion",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], false),
    "FindInstancesAgentErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentErrorResponseType")
        }
    ], false),
    "FindInstancesAgentErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindInstancesAgentErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("ErrorMessage")
        }
    ], false),
    "FindInstancesAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentRequestType")
        }
    ], false),
    "FindInstancesAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("DestinationObject"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("SourceIdentifier"))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "DestinationObject": $8a9068d6d6521bd9$var$o$1([
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: ""
        },
        {
            json: "appId",
            js: "appId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], "any"),
    "FindInstancesAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "app",
            js: "app",
            typ: $8a9068d6d6521bd9$var$r$1("AppIdentifier")
        }
    ], false),
    "AppIdentifier": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appId",
            js: "appId",
            typ: ""
        },
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], "any"),
    "FindInstancesAgentResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentErrorResponseType")
        }
    ], false),
    "FindInstancesAgentResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindInstancesAgentResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appIdentifiers",
            js: "appIdentifiers",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("AppMetadata"))
        }
    ], false),
    "AppMetadata": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appId",
            js: "appId",
            typ: ""
        },
        {
            json: "description",
            js: "description",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "icons",
            js: "icons",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("Icon")))
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "instanceMetadata",
            js: "instanceMetadata",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$m$1("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "resultType",
            js: "resultType",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$u$1(null, ""))
        },
        {
            json: "screenshots",
            js: "screenshots",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("Image")))
        },
        {
            json: "title",
            js: "title",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "tooltip",
            js: "tooltip",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "version",
            js: "version",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], false),
    "Icon": $8a9068d6d6521bd9$var$o$1([
        {
            json: "size",
            js: "size",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "src",
            js: "src",
            typ: ""
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], false),
    "Image": $8a9068d6d6521bd9$var$o$1([
        {
            json: "label",
            js: "label",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "size",
            js: "size",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "src",
            js: "src",
            typ: ""
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], false),
    "FindInstancesBridgeErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentErrorResponseType")
        }
    ], false),
    "FindInstancesBridgeErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail"))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindInstancesBridgeErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("ErrorMessage")
        }
    ], false),
    "FindInstancesBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentRequestType")
        }
    ], false),
    "FindInstancesBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("DestinationObject"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSourceObject")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "MetaSourceObject": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appId",
            js: "appId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: ""
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], "any"),
    "FindInstancesBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "app",
            js: "app",
            typ: $8a9068d6d6521bd9$var$r$1("AppIdentifier")
        }
    ], false),
    "FindInstancesBridgeResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesBridgeResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindInstancesAgentErrorResponseType")
        }
    ], false),
    "FindInstancesBridgeResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail")))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "sources",
            js: "sources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindInstancesBridgeResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appIdentifiers",
            js: "appIdentifiers",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("AppMetadata"))
        }
    ], false),
    "FindIntentAgentErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentErrorResponseType")
        }
    ], false),
    "FindIntentAgentErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindIntentAgentErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("ErrorMessage")
        }
    ], false),
    "FindIntentAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentRequestType")
        }
    ], false),
    "FindIntentAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("SourceIdentifier"))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        },
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("BridgeParticipantIdentifier"))
        }
    ], false),
    "FindIntentAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("ContextElement"))
        },
        {
            json: "intent",
            js: "intent",
            typ: ""
        },
        {
            json: "resultType",
            js: "resultType",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], false),
    "FindIntentAgentResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentErrorResponseType")
        }
    ], false),
    "FindIntentAgentResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindIntentAgentResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appIntent",
            js: "appIntent",
            typ: $8a9068d6d6521bd9$var$r$1("AppIntent")
        }
    ], false),
    "AppIntent": $8a9068d6d6521bd9$var$o$1([
        {
            json: "apps",
            js: "apps",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("AppMetadata"))
        },
        {
            json: "intent",
            js: "intent",
            typ: $8a9068d6d6521bd9$var$r$1("IntentMetadata")
        }
    ], false),
    "IntentMetadata": $8a9068d6d6521bd9$var$o$1([
        {
            json: "displayName",
            js: "displayName",
            typ: ""
        },
        {
            json: "name",
            js: "name",
            typ: ""
        }
    ], false),
    "FindIntentBridgeErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentBridgeErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentBridgeErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentErrorResponseType")
        }
    ], false),
    "FindIntentBridgeErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail"))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindIntentBridgeErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("ErrorMessage")
        }
    ], false),
    "FindIntentBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentRequestType")
        }
    ], false),
    "FindIntentBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("BridgeParticipantIdentifier")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        },
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("BridgeParticipantIdentifier"))
        }
    ], false),
    "FindIntentBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("ContextElement"))
        },
        {
            json: "intent",
            js: "intent",
            typ: ""
        },
        {
            json: "resultType",
            js: "resultType",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], false),
    "FindIntentBridgeResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentBridgeResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentBridgeResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentAgentErrorResponseType")
        }
    ], false),
    "FindIntentBridgeResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail")))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "sources",
            js: "sources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindIntentBridgeResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appIntent",
            js: "appIntent",
            typ: $8a9068d6d6521bd9$var$r$1("AppIntent")
        }
    ], false),
    "FindIntentsByContextAgentErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentErrorResponseType")
        }
    ], false),
    "FindIntentsByContextAgentErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindIntentsByContextAgentErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("ErrorMessage")
        }
    ], false),
    "FindIntentsByContextAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentRequestType")
        }
    ], false),
    "FindIntentsByContextAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("SourceObject"))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        },
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("BridgeParticipantIdentifier"))
        }
    ], false),
    "FindIntentsByContextAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$r$1("ContextElement")
        }
    ], false),
    "FindIntentsByContextAgentResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentErrorResponseType")
        }
    ], false),
    "FindIntentsByContextAgentResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindIntentsByContextAgentResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appIntents",
            js: "appIntents",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("AppIntent"))
        }
    ], false),
    "FindIntentsByContextBridgeErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentErrorResponseType")
        }
    ], false),
    "FindIntentsByContextBridgeErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail"))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindIntentsByContextBridgeErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("ErrorMessage")
        }
    ], false),
    "FindIntentsByContextBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentRequestType")
        }
    ], false),
    "FindIntentsByContextBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSource")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        },
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("BridgeParticipantIdentifier"))
        }
    ], false),
    "FindIntentsByContextBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$r$1("ContextElement")
        }
    ], false),
    "FindIntentsByContextBridgeResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextBridgeResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("FindIntentsByContextAgentErrorResponseType")
        }
    ], false),
    "FindIntentsByContextBridgeResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail")))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "sources",
            js: "sources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "FindIntentsByContextBridgeResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appIntents",
            js: "appIntents",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("AppIntent"))
        }
    ], false),
    "GetAppMetadataAgentErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentErrorResponseType")
        }
    ], false),
    "GetAppMetadataAgentErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "GetAppMetadataAgentErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("ErrorMessage")
        }
    ], false),
    "GetAppMetadataAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentRequestType")
        }
    ], false),
    "GetAppMetadataAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("DestinationObject"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("SourceIdentifier"))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "GetAppMetadataAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "app",
            js: "app",
            typ: $8a9068d6d6521bd9$var$r$1("AppDestinationIdentifier")
        }
    ], false),
    "AppDestinationIdentifier": $8a9068d6d6521bd9$var$o$1([
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: ""
        },
        {
            json: "appId",
            js: "appId",
            typ: ""
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], "any"),
    "GetAppMetadataAgentResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentErrorResponseType")
        }
    ], false),
    "GetAppMetadataAgentResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "GetAppMetadataAgentResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appMetadata",
            js: "appMetadata",
            typ: $8a9068d6d6521bd9$var$r$1("AppMetadata")
        }
    ], false),
    "GetAppMetadataBridgeErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentErrorResponseType")
        }
    ], false),
    "GetAppMetadataBridgeErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail"))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "GetAppMetadataBridgeErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("ErrorMessage")
        }
    ], false),
    "GetAppMetadataBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentRequestType")
        }
    ], false),
    "GetAppMetadataBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("DestinationObject"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSourceObject")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "GetAppMetadataBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "app",
            js: "app",
            typ: $8a9068d6d6521bd9$var$r$1("AppDestinationIdentifier")
        }
    ], false),
    "GetAppMetadataBridgeResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataBridgeResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("GetAppMetadataAgentErrorResponseType")
        }
    ], false),
    "GetAppMetadataBridgeResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail")))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "sources",
            js: "sources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "GetAppMetadataBridgeResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appMetadata",
            js: "appMetadata",
            typ: $8a9068d6d6521bd9$var$r$1("AppMetadata")
        }
    ], false),
    "OpenAgentErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentErrorResponseType")
        }
    ], false),
    "OpenAgentErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "OpenAgentErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("OpenErrorMessage")
        }
    ], false),
    "OpenAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentRequestType")
        }
    ], false),
    "OpenAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("DestinationObject"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("SourceObject")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "OpenAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "app",
            js: "app",
            typ: $8a9068d6d6521bd9$var$r$1("AppToOpen")
        },
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("ContextElement"))
        }
    ], false),
    "AppToOpen": $8a9068d6d6521bd9$var$o$1([
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: ""
        },
        {
            json: "appId",
            js: "appId",
            typ: ""
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], "any"),
    "OpenAgentResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentErrorResponseType")
        }
    ], false),
    "OpenAgentResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "OpenAgentResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appIdentifier",
            js: "appIdentifier",
            typ: $8a9068d6d6521bd9$var$r$1("AppIdentifier")
        }
    ], false),
    "OpenBridgeErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("OpenBridgeErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("OpenBridgeErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentErrorResponseType")
        }
    ], false),
    "OpenBridgeErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail"))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "OpenBridgeErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("OpenErrorMessage")
        }
    ], false),
    "OpenBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("OpenBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("OpenBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentRequestType")
        }
    ], false),
    "OpenBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("DestinationObject"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSource")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "OpenBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "app",
            js: "app",
            typ: $8a9068d6d6521bd9$var$r$1("AppToOpen")
        },
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("ContextElement"))
        }
    ], false),
    "OpenBridgeResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("OpenBridgeResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("OpenBridgeResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("OpenAgentErrorResponseType")
        }
    ], false),
    "OpenBridgeResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail")))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "sources",
            js: "sources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "OpenBridgeResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "appIdentifier",
            js: "appIdentifier",
            typ: $8a9068d6d6521bd9$var$r$1("AppIdentifier")
        }
    ], false),
    "PrivateChannelBroadcastAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelBroadcastAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelBroadcastAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelBroadcastAgentRequestType")
        }
    ], false),
    "PrivateChannelBroadcastAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("SourceObject"))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "MetaDestination": $8a9068d6d6521bd9$var$o$1([
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: ""
        },
        {
            json: "appId",
            js: "appId",
            typ: ""
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], "any"),
    "PrivateChannelBroadcastAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$r$1("ContextElement")
        }
    ], false),
    "PrivateChannelBroadcastBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelBroadcastBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelBroadcastBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelBroadcastAgentRequestType")
        }
    ], false),
    "PrivateChannelBroadcastBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSource")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "PrivateChannelBroadcastBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$r$1("ContextElement")
        }
    ], false),
    "PrivateChannelEventListenerAddedAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerAddedAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerAddedAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerAddedAgentRequestType")
        }
    ], false),
    "PrivateChannelEventListenerAddedAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("SourceObject"))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "PrivateChannelEventListenerAddedAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "listenerType",
            js: "listenerType",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerTypes")
        }
    ], false),
    "PrivateChannelEventListenerAddedBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerAddedBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerAddedBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerAddedAgentRequestType")
        }
    ], false),
    "PrivateChannelEventListenerAddedBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSource")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "PrivateChannelEventListenerAddedBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "listenerType",
            js: "listenerType",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerTypes")
        }
    ], false),
    "PrivateChannelEventListenerRemovedAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerRemovedAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerRemovedAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerRemovedAgentRequestType")
        }
    ], false),
    "PrivateChannelEventListenerRemovedAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("SourceObject"))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "PrivateChannelEventListenerRemovedAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "listenerType",
            js: "listenerType",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerTypes")
        }
    ], false),
    "PrivateChannelEventListenerRemovedBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerRemovedBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerRemovedBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerRemovedAgentRequestType")
        }
    ], false),
    "PrivateChannelEventListenerRemovedBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSource")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "PrivateChannelEventListenerRemovedBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "listenerType",
            js: "listenerType",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelEventListenerTypes")
        }
    ], false),
    "PrivateChannelOnAddContextListenerAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnAddContextListenerAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnAddContextListenerAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnAddContextListenerAgentRequestType")
        }
    ], false),
    "PrivateChannelOnAddContextListenerAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("SourceObject"))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "PrivateChannelOnAddContextListenerAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "contextType",
            js: "contextType",
            typ: $8a9068d6d6521bd9$var$u$1(null, "")
        }
    ], false),
    "PrivateChannelOnAddContextListenerBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnAddContextListenerBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnAddContextListenerBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnAddContextListenerAgentRequestType")
        }
    ], false),
    "PrivateChannelOnAddContextListenerBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSource")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "PrivateChannelOnAddContextListenerBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "contextType",
            js: "contextType",
            typ: $8a9068d6d6521bd9$var$u$1(null, "")
        }
    ], false),
    "PrivateChannelOnDisconnectAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnDisconnectAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnDisconnectAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnDisconnectAgentRequestType")
        }
    ], false),
    "PrivateChannelOnDisconnectAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("SourceObject"))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "PrivateChannelOnDisconnectAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        }
    ], false),
    "PrivateChannelOnDisconnectBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnDisconnectBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnDisconnectBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnDisconnectAgentRequestType")
        }
    ], false),
    "PrivateChannelOnDisconnectBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSource")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "PrivateChannelOnDisconnectBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        }
    ], false),
    "PrivateChannelOnUnsubscribeAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnUnsubscribeAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnUnsubscribeAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnUnsubscribeAgentRequestType")
        }
    ], false),
    "PrivateChannelOnUnsubscribeAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("SourceObject"))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "PrivateChannelOnUnsubscribeAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "contextType",
            js: "contextType",
            typ: $8a9068d6d6521bd9$var$u$1(null, "")
        }
    ], false),
    "PrivateChannelOnUnsubscribeBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("ERequestMetadata")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnUnsubscribeBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("PrivateChannelOnUnsubscribeAgentRequestType")
        }
    ], false),
    "ERequestMetadata": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("MetaDestination"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSource")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "PrivateChannelOnUnsubscribeBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "channelId",
            js: "channelId",
            typ: ""
        },
        {
            json: "contextType",
            js: "contextType",
            typ: $8a9068d6d6521bd9$var$u$1(null, "")
        }
    ], false),
    "RaiseIntentAgentErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentErrorResponseType")
        }
    ], false),
    "RaiseIntentAgentErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "RaiseIntentAgentErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("ErrorMessage")
        }
    ], false),
    "RaiseIntentAgentRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentRequestType")
        }
    ], false),
    "RaiseIntentAgentRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$r$1("MetaDestination")
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("SourceObject")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "RaiseIntentAgentRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "app",
            js: "app",
            typ: $8a9068d6d6521bd9$var$r$1("AppDestinationIdentifier")
        },
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$r$1("ContextElement")
        },
        {
            json: "intent",
            js: "intent",
            typ: ""
        }
    ], false),
    "RaiseIntentAgentResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentErrorResponseType")
        }
    ], false),
    "RaiseIntentAgentResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "RaiseIntentAgentResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "intentResolution",
            js: "intentResolution",
            typ: $8a9068d6d6521bd9$var$r$1("IntentResolution")
        }
    ], false),
    "IntentResolution": $8a9068d6d6521bd9$var$o$1([
        {
            json: "intent",
            js: "intent",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("AppIdentifier")
        },
        {
            json: "version",
            js: "version",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], false),
    "RaiseIntentBridgeErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentErrorResponseType")
        }
    ], false),
    "RaiseIntentBridgeErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail"))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "RaiseIntentBridgeErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("ErrorMessage")
        }
    ], false),
    "RaiseIntentBridgeRequest": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeRequestMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeRequestPayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentRequestType")
        }
    ], false),
    "RaiseIntentBridgeRequestMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "destination",
            js: "destination",
            typ: $8a9068d6d6521bd9$var$r$1("MetaDestination")
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "source",
            js: "source",
            typ: $8a9068d6d6521bd9$var$r$1("MetaSource")
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "RaiseIntentBridgeRequestPayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "app",
            js: "app",
            typ: $8a9068d6d6521bd9$var$r$1("AppDestinationIdentifier")
        },
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$r$1("ContextElement")
        },
        {
            json: "intent",
            js: "intent",
            typ: ""
        }
    ], false),
    "RaiseIntentBridgeResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentBridgeResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentAgentErrorResponseType")
        }
    ], false),
    "RaiseIntentBridgeResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail")))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "sources",
            js: "sources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "RaiseIntentBridgeResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "intentResolution",
            js: "intentResolution",
            typ: $8a9068d6d6521bd9$var$r$1("IntentResolution")
        }
    ], false),
    "RaiseIntentResultAgentErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentErrorResponseType")
        }
    ], false),
    "RaiseIntentResultAgentErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "RaiseIntentResultAgentErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultErrorMessage")
        }
    ], false),
    "RaiseIntentResultAgentResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentErrorResponseType")
        }
    ], false),
    "RaiseIntentResultAgentResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "RaiseIntentResultAgentResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "intentResult",
            js: "intentResult",
            typ: $8a9068d6d6521bd9$var$r$1("IntentResult")
        }
    ], false),
    "IntentResult": $8a9068d6d6521bd9$var$o$1([
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("ContextElement"))
        },
        {
            json: "channel",
            js: "channel",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("Channel"))
        }
    ], false),
    "Channel": $8a9068d6d6521bd9$var$o$1([
        {
            json: "displayMetadata",
            js: "displayMetadata",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$r$1("DisplayMetadata"))
        },
        {
            json: "id",
            js: "id",
            typ: ""
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("Type")
        }
    ], false),
    "DisplayMetadata": $8a9068d6d6521bd9$var$o$1([
        {
            json: "color",
            js: "color",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "glyph",
            js: "glyph",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        }
    ], false),
    "RaiseIntentResultBridgeErrorResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultBridgeErrorResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultBridgeErrorResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentErrorResponseType")
        }
    ], false),
    "RaiseIntentResultBridgeErrorResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail"))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier"))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "RaiseIntentResultBridgeErrorResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "error",
            js: "error",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultErrorMessage")
        }
    ], false),
    "RaiseIntentResultBridgeResponse": $8a9068d6d6521bd9$var$o$1([
        {
            json: "meta",
            js: "meta",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultBridgeResponseMeta")
        },
        {
            json: "payload",
            js: "payload",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultBridgeResponsePayload")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r$1("RaiseIntentResultAgentErrorResponseType")
        }
    ], false),
    "RaiseIntentResultBridgeResponseMeta": $8a9068d6d6521bd9$var$o$1([
        {
            json: "errorDetails",
            js: "errorDetails",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("ResponseErrorDetail")))
        },
        {
            json: "errorSources",
            js: "errorSources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "requestUuid",
            js: "requestUuid",
            typ: ""
        },
        {
            json: "responseUuid",
            js: "responseUuid",
            typ: ""
        },
        {
            json: "sources",
            js: "sources",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$a$1($8a9068d6d6521bd9$var$r$1("DesktopAgentIdentifier")))
        },
        {
            json: "timestamp",
            js: "timestamp",
            typ: Date
        }
    ], false),
    "RaiseIntentResultBridgeResponsePayload": $8a9068d6d6521bd9$var$o$1([
        {
            json: "intentResult",
            js: "intentResult",
            typ: $8a9068d6d6521bd9$var$r$1("IntentResult")
        }
    ], false),
    "Context": $8a9068d6d6521bd9$var$o$1([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, $8a9068d6d6521bd9$var$m$1("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u$1(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: ""
        }
    ], "any"),
    "ResponseErrorDetail": [
        "AccessDenied",
        "AgentDisconnected",
        "AppNotFound",
        "AppTimeout",
        "CreationFailed",
        "DesktopAgentNotFound",
        "ErrorOnLaunch",
        "IntentDeliveryFailed",
        "IntentHandlerRejected",
        "MalformedContext",
        "MalformedMessage",
        "NoAppsFound",
        "NoChannelFound",
        "NoResultReturned",
        "NotConnectedToBridge",
        "ResolverTimeout",
        "ResolverUnavailable",
        "ResponseToBridgeTimedOut",
        "TargetAppUnavailable",
        "TargetInstanceUnavailable",
        "UserCancelledResolution"
    ],
    "ResponseMessageType": [
        "findInstancesResponse",
        "findIntentResponse",
        "findIntentsByContextResponse",
        "getAppMetadataResponse",
        "openResponse",
        "raiseIntentResponse",
        "raiseIntentResultResponse"
    ],
    "RequestMessageType": [
        "broadcastRequest",
        "findInstancesRequest",
        "findIntentRequest",
        "findIntentsByContextRequest",
        "getAppMetadataRequest",
        "openRequest",
        "PrivateChannel.broadcast",
        "PrivateChannel.eventListenerAdded",
        "PrivateChannel.eventListenerRemoved",
        "PrivateChannel.onAddContextListener",
        "PrivateChannel.onDisconnect",
        "PrivateChannel.onUnsubscribe",
        "raiseIntentRequest"
    ],
    "BroadcastAgentRequestType": [
        "broadcastRequest"
    ],
    "ConnectionStepMessageType": [
        "authenticationFailed",
        "connectedAgentsUpdate",
        "handshake",
        "hello"
    ],
    "ConnectionStep2HelloType": [
        "hello"
    ],
    "ConnectionStep3HandshakeType": [
        "handshake"
    ],
    "ConnectionStep4AuthenticationFailedType": [
        "authenticationFailed"
    ],
    "ConnectionStep6ConnectedAgentsUpdateType": [
        "connectedAgentsUpdate"
    ],
    "ErrorMessage": [
        "AgentDisconnected",
        "DesktopAgentNotFound",
        "IntentDeliveryFailed",
        "MalformedContext",
        "MalformedMessage",
        "NoAppsFound",
        "NotConnectedToBridge",
        "ResolverTimeout",
        "ResolverUnavailable",
        "ResponseToBridgeTimedOut",
        "TargetAppUnavailable",
        "TargetInstanceUnavailable",
        "UserCancelledResolution"
    ],
    "FindInstancesAgentErrorResponseType": [
        "findInstancesResponse"
    ],
    "FindInstancesAgentRequestType": [
        "findInstancesRequest"
    ],
    "FindIntentAgentErrorResponseType": [
        "findIntentResponse"
    ],
    "FindIntentAgentRequestType": [
        "findIntentRequest"
    ],
    "FindIntentsByContextAgentErrorResponseType": [
        "findIntentsByContextResponse"
    ],
    "FindIntentsByContextAgentRequestType": [
        "findIntentsByContextRequest"
    ],
    "GetAppMetadataAgentErrorResponseType": [
        "getAppMetadataResponse"
    ],
    "GetAppMetadataAgentRequestType": [
        "getAppMetadataRequest"
    ],
    "OpenErrorMessage": [
        "AgentDisconnected",
        "AppNotFound",
        "AppTimeout",
        "DesktopAgentNotFound",
        "ErrorOnLaunch",
        "MalformedContext",
        "MalformedMessage",
        "NotConnectedToBridge",
        "ResolverUnavailable",
        "ResponseToBridgeTimedOut"
    ],
    "OpenAgentErrorResponseType": [
        "openResponse"
    ],
    "OpenAgentRequestType": [
        "openRequest"
    ],
    "PrivateChannelBroadcastAgentRequestType": [
        "PrivateChannel.broadcast"
    ],
    "PrivateChannelEventListenerTypes": [
        "onAddContextListener",
        "onDisconnect",
        "onUnsubscribe"
    ],
    "PrivateChannelEventListenerAddedAgentRequestType": [
        "PrivateChannel.eventListenerAdded"
    ],
    "PrivateChannelEventListenerRemovedAgentRequestType": [
        "PrivateChannel.eventListenerRemoved"
    ],
    "PrivateChannelOnAddContextListenerAgentRequestType": [
        "PrivateChannel.onAddContextListener"
    ],
    "PrivateChannelOnDisconnectAgentRequestType": [
        "PrivateChannel.onDisconnect"
    ],
    "PrivateChannelOnUnsubscribeAgentRequestType": [
        "PrivateChannel.onUnsubscribe"
    ],
    "RaiseIntentAgentErrorResponseType": [
        "raiseIntentResponse"
    ],
    "RaiseIntentAgentRequestType": [
        "raiseIntentRequest"
    ],
    "RaiseIntentResultErrorMessage": [
        "AgentDisconnected",
        "IntentHandlerRejected",
        "MalformedMessage",
        "NoResultReturned",
        "NotConnectedToBridge",
        "ResponseToBridgeTimedOut"
    ],
    "RaiseIntentResultAgentErrorResponseType": [
        "raiseIntentResultResponse"
    ],
    "Type": [
        "app",
        "private",
        "user"
    ]
};
var $8a9068d6d6521bd9$export$1a2ec45350a660e9 = {
    __proto__: null,
    Convert: $8a9068d6d6521bd9$var$Convert$1
};
/**
 * SPDX-License-Identifier: Apache-2.0
 * Copyright FINOS FDC3 contributors - see NOTICE file
 */ /** Constants representing the errors that can be encountered when calling the `open` method on the DesktopAgent object (`fdc3`). */ var $8a9068d6d6521bd9$export$90e29c5366bc0e1f;
(function(OpenError) {
    /** Returned if the specified application is not found.*/ OpenError["AppNotFound"] = "AppNotFound";
    /** Returned if the specified application fails to launch correctly.*/ OpenError["ErrorOnLaunch"] = "ErrorOnLaunch";
    /** Returned if the specified application launches but fails to add a context listener in order to receive the context passed to the `fdc3.open` call.*/ OpenError["AppTimeout"] = "AppTimeout";
    /** Returned if the FDC3 desktop agent implementation is not currently able to handle the request.*/ OpenError["ResolverUnavailable"] = "ResolverUnavailable";
    /** Returned if a call to the `open` function is made with an invalid context argument. Contexts should be Objects with at least a `type` field that has a `string` value.*/ OpenError["MalformedContext"] = "MalformedContext";
    /** @experimental Returned if the specified Desktop Agent is not found, via a connected Desktop Agent Bridge.*/ OpenError["DesktopAgentNotFound"] = "DesktopAgentNotFound";
})($8a9068d6d6521bd9$export$90e29c5366bc0e1f || ($8a9068d6d6521bd9$export$90e29c5366bc0e1f = {}));
/** Constants representing the errors that can be encountered when calling the `findIntent`, `findIntentsByContext`, `raiseIntent` or `raiseIntentForContext` methods on the DesktopAgent (`fdc3`). */ var $8a9068d6d6521bd9$export$41d38ae9aac97c85;
(function(ResolveError) {
    /** SHOULD be returned if no apps are available that can resolve the intent and context combination.*/ ResolveError["NoAppsFound"] = "NoAppsFound";
    /** Returned if the FDC3 desktop agent implementation is not currently able to handle the request.*/ ResolveError["ResolverUnavailable"] = "ResolverUnavailable";
    /** Returned if the user cancelled the resolution request, for example by closing or cancelling a resolver UI.*/ ResolveError["UserCancelled"] = "UserCancelledResolution";
    /** SHOULD be returned if a timeout cancels an intent resolution that required user interaction. Please use `ResolverUnavailable` instead for situations where a resolver UI or similar fails.*/ ResolveError["ResolverTimeout"] = "ResolverTimeout";
    /** Returned if a specified target application is not available or a new instance of it cannot be opened. */ ResolveError["TargetAppUnavailable"] = "TargetAppUnavailable";
    /** Returned if a specified target application instance is not available, for example because it has been closed. */ ResolveError["TargetInstanceUnavailable"] = "TargetInstanceUnavailable";
    /** Returned if the intent and context could not be delivered to the selected application or instance, for example because it has not added an intent handler within a timeout.*/ ResolveError["IntentDeliveryFailed"] = "IntentDeliveryFailed";
    /** Returned if a call to one of the `raiseIntent` functions is made with an invalid context argument. Contexts should be Objects with at least a `type` field that has a `string` value.*/ ResolveError["MalformedContext"] = "MalformedContext";
    /** @experimental Returned if the specified Desktop Agent is not found, via a connected Desktop Agent Bridge.*/ ResolveError["DesktopAgentNotFound"] = "DesktopAgentNotFound";
})($8a9068d6d6521bd9$export$41d38ae9aac97c85 || ($8a9068d6d6521bd9$export$41d38ae9aac97c85 = {}));
var $8a9068d6d6521bd9$export$65ccc995d0e03818;
(function(ResultError) {
    /** Returned if the intent handler exited without returning a valid result (a promise resolving to a Context, Channel object or void). */ ResultError["NoResultReturned"] = "NoResultReturned";
    /** Returned if the Intent handler function processing the raised intent throws an error or rejects the Promise it returned. */ ResultError["IntentHandlerRejected"] = "IntentHandlerRejected";
})($8a9068d6d6521bd9$export$65ccc995d0e03818 || ($8a9068d6d6521bd9$export$65ccc995d0e03818 = {}));
var $8a9068d6d6521bd9$export$f60dd771a5682be5;
(function(ChannelError) {
    /** Returned if the specified channel is not found when attempting to join a channel via the `joinUserChannel` function  of the DesktopAgent (`fdc3`).*/ ChannelError["NoChannelFound"] = "NoChannelFound";
    /** SHOULD be returned when a request to join a user channel or to a retrieve a Channel object via the `joinUserChannel` or `getOrCreateChannel` methods of the DesktopAgent (`fdc3`) object is denied. */ ChannelError["AccessDenied"] = "AccessDenied";
    /** SHOULD be returned when a channel cannot be created or retrieved via the `getOrCreateChannel` method of the DesktopAgent (`fdc3`).*/ ChannelError["CreationFailed"] = "CreationFailed";
    /** Returned if a call to the `broadcast` functions is made with an invalid context argument. Contexts should be Objects with at least a `type` field that has a `string` value.*/ ChannelError["MalformedContext"] = "MalformedContext";
})($8a9068d6d6521bd9$export$f60dd771a5682be5 || ($8a9068d6d6521bd9$export$f60dd771a5682be5 = {}));
var $8a9068d6d6521bd9$export$4777f06001524cbe;
(function(BridgingError) {
    /** @experimental Returned if a Desktop Agent did not return a response, via Desktop Agent Bridging, within the alloted timeout. */ BridgingError["ResponseTimedOut"] = "ResponseToBridgeTimedOut";
    /** @experimental Returned if a Desktop Agent that has been targeted by a particular request has been disconnected from the Bridge before a response has been received from it. */ BridgingError["AgentDisconnected"] = "AgentDisconnected";
    /** @experimental Returned for FDC3 API calls that are specified with arguments indicating that a remote Desktop agent should be targeted (e.g. raiseIntent with an app on a remote DesktopAgent targeted), when the local Desktop Agent is not connected to a bridge. */ BridgingError["NotConnectedToBridge"] = "NotConnectedToBridge";
    /** @experimental Returned if a message to a Bridge deviates from the schema for that message sufficiently that it could not be processed. */ BridgingError["MalformedMessage"] = "MalformedMessage";
})($8a9068d6d6521bd9$export$4777f06001524cbe || ($8a9068d6d6521bd9$export$4777f06001524cbe = {}));
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $8a9068d6d6521bd9$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8a9068d6d6521bd9$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
typeof SuppressedError === "function" && SuppressedError;
/**
 * Ensures at compile time that the given string tuple is exhaustive on a given union type, i.e. contains ALL possible values of the given UNION_TYPE.
 */ var $8a9068d6d6521bd9$var$exhaustiveStringTuple = function() {
    return function() {
        var tuple = [];
        for(var _i = 0; _i < arguments.length; _i++)tuple[_i] = arguments[_i];
        return tuple;
    };
};
var $8a9068d6d6521bd9$var$STANDARD_CONTEXT_TYPES = $8a9068d6d6521bd9$var$exhaustiveStringTuple()('fdc3.action', 'fdc3.chart', 'fdc3.chat.initSettings', 'fdc3.chat.message', 'fdc3.chat.room', 'fdc3.chat.searchCriteria', 'fdc3.contact', 'fdc3.contactList', 'fdc3.country', 'fdc3.currency', 'fdc3.email', 'fdc3.instrument', 'fdc3.instrumentList', 'fdc3.interaction', 'fdc3.message', 'fdc3.organization', 'fdc3.portfolio', 'fdc3.position', 'fdc3.nothing', 'fdc3.timerange', 'fdc3.transactionResult', 'fdc3.valuation');
// used internally to check if a given intent/context is a standard one
var $8a9068d6d6521bd9$var$StandardContextsSet = new Set($8a9068d6d6521bd9$var$STANDARD_CONTEXT_TYPES);
var $8a9068d6d6521bd9$var$STANDARD_INTENTS = $8a9068d6d6521bd9$var$exhaustiveStringTuple()('CreateInteraction', 'SendChatMessage', 'StartCall', 'StartChat', 'StartEmail', 'ViewAnalysis', 'ViewChat', 'ViewChart', 'ViewContact', 'ViewHoldings', 'ViewInstrument', 'ViewInteractions', 'ViewMessages', 'ViewNews', 'ViewOrders', 'ViewProfile', 'ViewQuote', 'ViewResearch');
// used internally to check if a given intent/context is a standard one
var $8a9068d6d6521bd9$var$StandardIntentsSet = new Set($8a9068d6d6521bd9$var$STANDARD_INTENTS);
var $8a9068d6d6521bd9$var$DEFAULT_TIMEOUT = 5000;
var $8a9068d6d6521bd9$var$UnavailableError = new Error('FDC3 DesktopAgent not available at `window.fdc3`.');
var $8a9068d6d6521bd9$var$TimeoutError = new Error('Timed out waiting for `fdc3Ready` event.');
var $8a9068d6d6521bd9$var$UnexpectedError = new Error('`fdc3Ready` event fired, but `window.fdc3` not set to DesktopAgent.');
function $8a9068d6d6521bd9$var$rejectIfNoGlobal(f) {
    return window.fdc3 ? f() : Promise.reject($8a9068d6d6521bd9$var$UnavailableError);
}
/**
 * Utility function that returns a promise that will resolve immeadiately
 * if the desktop agent API is found at `window.fdc3`. If the API is found,
 * the promise will resolve when the `fdc3Ready` event is received or if it
 * is found at the end of the specified timeout. If the API is not found, it
 * will reject with an error.
 *
 * ```javascript
 * await fdc3Ready();
 * const intentListener = await addIntentListener("ViewChart", intentHandlerFn);
 * ```
 *
 * @param waitForMs The number of milliseconds to wait for the FDC3 API to be
 * ready. Defaults to 5 seconds.
 */ var $8a9068d6d6521bd9$export$6556d597568c1194 = function(waitForMs) {
    if (waitForMs === void 0) waitForMs = $8a9068d6d6521bd9$var$DEFAULT_TIMEOUT;
    return $8a9068d6d6521bd9$var$__awaiter(void 0, void 0, void 0, function() {
        return $8a9068d6d6521bd9$var$__generator(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    // if the global is already available resolve immediately
                    if (window.fdc3) resolve();
                    else {
                        // if its not available setup a timeout to return a rejected promise
                        var timeout_1 = setTimeout(function() {
                            return window.fdc3 ? resolve() : reject($8a9068d6d6521bd9$var$TimeoutError);
                        }, waitForMs);
                        // listen for the fdc3Ready event
                        window.addEventListener('fdc3Ready', function() {
                            clearTimeout(timeout_1);
                            window.fdc3 ? resolve() : reject($8a9068d6d6521bd9$var$UnexpectedError);
                        }, {
                            once: true
                        });
                    }
                })
            ];
        });
    });
};
function $8a9068d6d6521bd9$var$isString(app) {
    return !!app && typeof app === 'string';
}
function $8a9068d6d6521bd9$export$3ce6949f20cea765(app, context) {
    if ($8a9068d6d6521bd9$var$isString(app)) return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.open(app, context);
    });
    else return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.open(app, context);
    });
}
function $8a9068d6d6521bd9$export$75e7cb6e66a75b65(intent, context, resultType) {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.findIntent(intent, context, resultType);
    });
}
function $8a9068d6d6521bd9$export$a9b3034bb5e0b8e1(context, resultType) {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.findIntentsByContext(context, resultType);
    });
}
function $8a9068d6d6521bd9$export$24d33a6f4bffea69(context) {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.broadcast(context);
    });
}
function $8a9068d6d6521bd9$export$cab2ce8912787d2c(intent, context, app) {
    if ($8a9068d6d6521bd9$var$isString(app)) return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.raiseIntent(intent, context, app);
    });
    else return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.raiseIntent(intent, context, app);
    });
}
function $8a9068d6d6521bd9$export$33105bd799045c40(context, app) {
    if ($8a9068d6d6521bd9$var$isString(app)) return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.raiseIntentForContext(context, app);
    });
    else return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.raiseIntentForContext(context, app);
    });
}
function $8a9068d6d6521bd9$export$8a4933375eab36fe(intent, handler) {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.addIntentListener(intent, handler);
    });
}
function $8a9068d6d6521bd9$export$51acaa8d29b87eb6(contextTypeOrHandler, handler) {
    //Handle (deprecated) function signature that allowed contextType argument to be omitted
    if (typeof contextTypeOrHandler !== 'function') return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.addContextListener(contextTypeOrHandler, handler);
    });
    else return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.addContextListener(null, contextTypeOrHandler);
    });
}
function $8a9068d6d6521bd9$export$bfba34216691a56() {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        //fallback to getSystemChannels for FDC3 <2.0 implementations
        if (window.fdc3.getUserChannels) return window.fdc3.getUserChannels();
        else return window.fdc3.getSystemChannels();
    });
}
function $8a9068d6d6521bd9$export$e000f569e8a93c6d() {
    //fallforward to getUserChannels for FDC3 2.0+ implementations
    return $8a9068d6d6521bd9$export$bfba34216691a56();
}
function $8a9068d6d6521bd9$export$b6c7a6a24a377d8e(channelId) {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        //fallback to joinChannel for FDC3 <2.0 implementations
        if (window.fdc3.joinUserChannel) return window.fdc3.joinUserChannel(channelId);
        else return window.fdc3.joinChannel(channelId);
    });
}
function $8a9068d6d6521bd9$export$c127c26e30518ed5(channelId) {
    //fallforward to joinUserChannel for FDC3 2.0+ implementations
    return $8a9068d6d6521bd9$export$b6c7a6a24a377d8e(channelId);
}
function $8a9068d6d6521bd9$export$a17df2d376958662(channelId) {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.getOrCreateChannel(channelId);
    });
}
function $8a9068d6d6521bd9$export$b6634f2b0ace3bf6() {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.getCurrentChannel();
    });
}
function $8a9068d6d6521bd9$export$640df797d2783ec0() {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.leaveCurrentChannel();
    });
}
function $8a9068d6d6521bd9$export$4ffab89367979d6e() {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.createPrivateChannel();
    });
}
function $8a9068d6d6521bd9$export$c73dcf559dad2f44() {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.getInfo();
    });
}
function $8a9068d6d6521bd9$export$ba31e015127122bb(app) {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.getAppMetadata(app);
    });
}
function $8a9068d6d6521bd9$export$d72f9cf0f8177b35(app) {
    return $8a9068d6d6521bd9$var$rejectIfNoGlobal(function() {
        return window.fdc3.findInstances(app);
    });
}
/**
 * Check if the given context is a standard context type.
 * @param contextType
 */ function $8a9068d6d6521bd9$export$c995e46853dd6a78(contextType) {
    return $8a9068d6d6521bd9$var$StandardContextsSet.has(contextType);
}
/**
 * Check if the given intent is a standard intent.
 * @param intent
 */ function $8a9068d6d6521bd9$export$36ac6d3287e274c0(intent) {
    return $8a9068d6d6521bd9$var$StandardIntentsSet.has(intent);
}
/**
 * Compare numeric semver version number strings (in the form `1.2.3`).
 *
 * Returns `-1` if the first argument is a lower version number than the second,
 * `1` if the first argument is greater than the second, 0 if the arguments are
 * equal and `null` if an error occurred during the comparison.
 *
 * @param a
 * @param b
 */ var $8a9068d6d6521bd9$export$a8aa8ea9b4c17f56 = function(a, b) {
    try {
        var aVerArr = a.split('.').map(Number);
        var bVerArr = b.split('.').map(Number);
        for(var index = 0; index < Math.max(aVerArr.length, bVerArr.length); index++){
            /* If one version number has more digits and the other does not, and they are otherwise equal,
               assume the longer is greater. E.g. 1.1.1 > 1.1 */ if (index === aVerArr.length || aVerArr[index] < bVerArr[index]) return -1;
            else if (index === bVerArr.length || aVerArr[index] > bVerArr[index]) return 1;
        }
        return 0;
    } catch (e) {
        console.error('Failed to compare version strings', e);
        return null;
    }
};
/**
 * Check if the FDC3 version in an ImplementationMetadata object is greater than
 * or equal to the supplied numeric semver version number string (in the form `1.2.3`).
 *
 * Returns a boolean or null if an error occurred while comparing the version numbers.
 *
 * @param metadata
 * @param version
 */ var $8a9068d6d6521bd9$export$cb14fbeab966bfde = function(metadata, version) {
    var comparison = $8a9068d6d6521bd9$export$a8aa8ea9b4c17f56(metadata.fdc3Version, version);
    return comparison === null ? null : comparison >= 0 ? true : false;
};
/**
 * SPDX-License-Identifier: Apache-2.0
 * Copyright FINOS FDC3 contributors - see NOTICE file
 */ /**
 * @deprecated Use {@link StandardContextType} instead
 */ var $8a9068d6d6521bd9$export$bd0f7835a18a8866;
(function(ContextTypes) {
    ContextTypes["Chart"] = "fdc3.chart";
    ContextTypes["ChatInitSettings"] = "fdc3.chat.initSettings";
    ContextTypes["ChatRoom"] = "fdc3.chat.room";
    ContextTypes["Contact"] = "fdc3.contact";
    ContextTypes["ContactList"] = "fdc3.contactList";
    ContextTypes["Country"] = "fdc3.country";
    ContextTypes["Currency"] = "fdc3.currency";
    ContextTypes["Email"] = "fdc3.email";
    ContextTypes["Instrument"] = "fdc3.instrument";
    ContextTypes["InstrumentList"] = "fdc3.instrumentList";
    ContextTypes["Interaction"] = "fdc3.interaction";
    ContextTypes["Nothing"] = "fdc3.nothing";
    ContextTypes["Organization"] = "fdc3.organization";
    ContextTypes["Portfolio"] = "fdc3.portfolio";
    ContextTypes["Position"] = "fdc3.position";
    ContextTypes["ChatSearchCriteria"] = "fdc3.chat.searchCriteria";
    ContextTypes["TimeRange"] = "fdc3.timerange";
    ContextTypes["TransactionResult"] = "fdc3.transactionResult";
    ContextTypes["Valuation"] = "fdc3.valuation";
})($8a9068d6d6521bd9$export$bd0f7835a18a8866 || ($8a9068d6d6521bd9$export$bd0f7835a18a8866 = {}));
// To parse this data:
//
//   import { Convert, Action, Chart, ChatInitSettings, ChatMessage, ChatRoom, ChatSearchCriteria, Contact, ContactList, Context, Country, Currency, Email, Instrument, InstrumentList, Interaction, Message, Nothing, Order, OrderList, Organization, Portfolio, Position, Product, TimeRange, Trade, TradeList, TransactionResult, Valuation } from "./file";
//
//   const action = Convert.toAction(json);
//   const chart = Convert.toChart(json);
//   const chatInitSettings = Convert.toChatInitSettings(json);
//   const chatMessage = Convert.toChatMessage(json);
//   const chatRoom = Convert.toChatRoom(json);
//   const chatSearchCriteria = Convert.toChatSearchCriteria(json);
//   const contact = Convert.toContact(json);
//   const contactList = Convert.toContactList(json);
//   const context = Convert.toContext(json);
//   const country = Convert.toCountry(json);
//   const currency = Convert.toCurrency(json);
//   const email = Convert.toEmail(json);
//   const instrument = Convert.toInstrument(json);
//   const instrumentList = Convert.toInstrumentList(json);
//   const interaction = Convert.toInteraction(json);
//   const message = Convert.toMessage(json);
//   const nothing = Convert.toNothing(json);
//   const order = Convert.toOrder(json);
//   const orderList = Convert.toOrderList(json);
//   const organization = Convert.toOrganization(json);
//   const portfolio = Convert.toPortfolio(json);
//   const position = Convert.toPosition(json);
//   const product = Convert.toProduct(json);
//   const timeRange = Convert.toTimeRange(json);
//   const trade = Convert.toTrade(json);
//   const tradeList = Convert.toTradeList(json);
//   const transactionResult = Convert.toTransactionResult(json);
//   const valuation = Convert.toValuation(json);
//
// These functions will throw an error if the JSON doesn't
// match the expected interface, even if the JSON is valid.
/**
 * Free text to be used for a keyword search
 *
 * `interactionType` SHOULD be one of `'Instant Message'`, `'Email'`, `'Call'`, or
 * `'Meeting'` although other string values are permitted.
 */ // Converts JSON strings to/from your types
// and asserts the results of JSON.parse at runtime
var $8a9068d6d6521bd9$export$f4e2e0de8bec13cf = /** @class */ function() {
    function Convert() {}
    Convert.toAction = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Action"));
    };
    Convert.actionToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Action")), null, 2);
    };
    Convert.toChart = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Chart"));
    };
    Convert.chartToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Chart")), null, 2);
    };
    Convert.toChatInitSettings = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("ChatInitSettings"));
    };
    Convert.chatInitSettingsToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("ChatInitSettings")), null, 2);
    };
    Convert.toChatMessage = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("ChatMessage"));
    };
    Convert.chatMessageToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("ChatMessage")), null, 2);
    };
    Convert.toChatRoom = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("ChatRoom"));
    };
    Convert.chatRoomToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("ChatRoom")), null, 2);
    };
    Convert.toChatSearchCriteria = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("ChatSearchCriteria"));
    };
    Convert.chatSearchCriteriaToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("ChatSearchCriteria")), null, 2);
    };
    Convert.toContact = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Contact"));
    };
    Convert.contactToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Contact")), null, 2);
    };
    Convert.toContactList = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("ContactList"));
    };
    Convert.contactListToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("ContactList")), null, 2);
    };
    Convert.toContext = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Context"));
    };
    Convert.contextToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Context")), null, 2);
    };
    Convert.toCountry = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Country"));
    };
    Convert.countryToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Country")), null, 2);
    };
    Convert.toCurrency = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Currency"));
    };
    Convert.currencyToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Currency")), null, 2);
    };
    Convert.toEmail = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Email"));
    };
    Convert.emailToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Email")), null, 2);
    };
    Convert.toInstrument = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Instrument"));
    };
    Convert.instrumentToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Instrument")), null, 2);
    };
    Convert.toInstrumentList = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("InstrumentList"));
    };
    Convert.instrumentListToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("InstrumentList")), null, 2);
    };
    Convert.toInteraction = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Interaction"));
    };
    Convert.interactionToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Interaction")), null, 2);
    };
    Convert.toMessage = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Message"));
    };
    Convert.messageToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Message")), null, 2);
    };
    Convert.toNothing = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Nothing"));
    };
    Convert.nothingToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Nothing")), null, 2);
    };
    Convert.toOrder = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Order"));
    };
    Convert.orderToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Order")), null, 2);
    };
    Convert.toOrderList = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("OrderList"));
    };
    Convert.orderListToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("OrderList")), null, 2);
    };
    Convert.toOrganization = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Organization"));
    };
    Convert.organizationToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Organization")), null, 2);
    };
    Convert.toPortfolio = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Portfolio"));
    };
    Convert.portfolioToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Portfolio")), null, 2);
    };
    Convert.toPosition = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Position"));
    };
    Convert.positionToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Position")), null, 2);
    };
    Convert.toProduct = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Product"));
    };
    Convert.productToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Product")), null, 2);
    };
    Convert.toTimeRange = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("TimeRange"));
    };
    Convert.timeRangeToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("TimeRange")), null, 2);
    };
    Convert.toTrade = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Trade"));
    };
    Convert.tradeToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Trade")), null, 2);
    };
    Convert.toTradeList = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("TradeList"));
    };
    Convert.tradeListToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("TradeList")), null, 2);
    };
    Convert.toTransactionResult = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("TransactionResult"));
    };
    Convert.transactionResultToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("TransactionResult")), null, 2);
    };
    Convert.toValuation = function(json) {
        return $8a9068d6d6521bd9$var$cast(JSON.parse(json), $8a9068d6d6521bd9$var$r("Valuation"));
    };
    Convert.valuationToJson = function(value) {
        return JSON.stringify($8a9068d6d6521bd9$var$uncast(value, $8a9068d6d6521bd9$var$r("Valuation")), null, 2);
    };
    return Convert;
}();
function $8a9068d6d6521bd9$var$invalidValue(typ, val, key, parent) {
    if (parent === void 0) parent = '';
    var prettyTyp = $8a9068d6d6521bd9$var$prettyTypeName(typ);
    var parentText = parent ? " on ".concat(parent) : '';
    var keyText = key ? " for key \"".concat(key, "\"") : '';
    throw Error("Invalid value".concat(keyText).concat(parentText, ". Expected ").concat(prettyTyp, " but got ").concat(JSON.stringify(val)));
}
function $8a9068d6d6521bd9$var$prettyTypeName(typ) {
    if (Array.isArray(typ)) {
        if (typ.length === 2 && typ[0] === undefined) return "an optional ".concat($8a9068d6d6521bd9$var$prettyTypeName(typ[1]));
        else return "one of [".concat(typ.map(function(a) {
            return $8a9068d6d6521bd9$var$prettyTypeName(a);
        }).join(", "), "]");
    } else if (typeof typ === "object" && typ.literal !== undefined) return typ.literal;
    else return typeof typ;
}
function $8a9068d6d6521bd9$var$jsonToJSProps(typ) {
    if (typ.jsonToJS === undefined) {
        var map_1 = {};
        typ.props.forEach(function(p) {
            return map_1[p.json] = {
                key: p.js,
                typ: p.typ
            };
        });
        typ.jsonToJS = map_1;
    }
    return typ.jsonToJS;
}
function $8a9068d6d6521bd9$var$jsToJSONProps(typ) {
    if (typ.jsToJSON === undefined) {
        var map_2 = {};
        typ.props.forEach(function(p) {
            return map_2[p.js] = {
                key: p.json,
                typ: p.typ
            };
        });
        typ.jsToJSON = map_2;
    }
    return typ.jsToJSON;
}
function $8a9068d6d6521bd9$var$transform(val, typ, getProps, key, parent) {
    if (key === void 0) key = '';
    if (parent === void 0) parent = '';
    function transformPrimitive(typ, val) {
        if (typeof typ === typeof val) return val;
        return $8a9068d6d6521bd9$var$invalidValue(typ, val, key, parent);
    }
    function transformUnion(typs, val) {
        // val must validate against one typ in typs
        var l = typs.length;
        for(var i = 0; i < l; i++){
            var typ_1 = typs[i];
            try {
                return $8a9068d6d6521bd9$var$transform(val, typ_1, getProps);
            } catch (_) {}
        }
        return $8a9068d6d6521bd9$var$invalidValue(typs, val, key, parent);
    }
    function transformEnum(cases, val) {
        if (cases.indexOf(val) !== -1) return val;
        return $8a9068d6d6521bd9$var$invalidValue(cases.map(function(a) {
            return $8a9068d6d6521bd9$var$l(a);
        }), val, key, parent);
    }
    function transformArray(typ, val) {
        // val must be an array with no invalid elements
        if (!Array.isArray(val)) return $8a9068d6d6521bd9$var$invalidValue($8a9068d6d6521bd9$var$l("array"), val, key, parent);
        return val.map(function(el) {
            return $8a9068d6d6521bd9$var$transform(el, typ, getProps);
        });
    }
    function transformDate(val) {
        if (val === null) return null;
        var d = new Date(val);
        if (isNaN(d.valueOf())) return $8a9068d6d6521bd9$var$invalidValue($8a9068d6d6521bd9$var$l("Date"), val, key, parent);
        return d;
    }
    function transformObject(props, additional, val) {
        if (val === null || typeof val !== "object" || Array.isArray(val)) return $8a9068d6d6521bd9$var$invalidValue($8a9068d6d6521bd9$var$l(ref || "object"), val, key, parent);
        var result = {};
        Object.getOwnPropertyNames(props).forEach(function(key) {
            var prop = props[key];
            var v = Object.prototype.hasOwnProperty.call(val, key) ? val[key] : undefined;
            result[prop.key] = $8a9068d6d6521bd9$var$transform(v, prop.typ, getProps, key, ref);
        });
        Object.getOwnPropertyNames(val).forEach(function(key) {
            if (!Object.prototype.hasOwnProperty.call(props, key)) result[key] = $8a9068d6d6521bd9$var$transform(val[key], additional, getProps, key, ref);
        });
        return result;
    }
    if (typ === "any") return val;
    if (typ === null) {
        if (val === null) return val;
        return $8a9068d6d6521bd9$var$invalidValue(typ, val, key, parent);
    }
    if (typ === false) return $8a9068d6d6521bd9$var$invalidValue(typ, val, key, parent);
    var ref = undefined;
    while(typeof typ === "object" && typ.ref !== undefined){
        ref = typ.ref;
        typ = $8a9068d6d6521bd9$var$typeMap[typ.ref];
    }
    if (Array.isArray(typ)) return transformEnum(typ, val);
    if (typeof typ === "object") return typ.hasOwnProperty("unionMembers") ? transformUnion(typ.unionMembers, val) : typ.hasOwnProperty("arrayItems") ? transformArray(typ.arrayItems, val) : typ.hasOwnProperty("props") ? transformObject(getProps(typ), typ.additional, val) : $8a9068d6d6521bd9$var$invalidValue(typ, val, key, parent);
    // Numbers can be parsed by Date but shouldn't be.
    if (typ === Date && typeof val !== "number") return transformDate(val);
    return transformPrimitive(typ, val);
}
function $8a9068d6d6521bd9$var$cast(val, typ) {
    return $8a9068d6d6521bd9$var$transform(val, typ, $8a9068d6d6521bd9$var$jsonToJSProps);
}
function $8a9068d6d6521bd9$var$uncast(val, typ) {
    return $8a9068d6d6521bd9$var$transform(val, typ, $8a9068d6d6521bd9$var$jsToJSONProps);
}
function $8a9068d6d6521bd9$var$l(typ) {
    return {
        literal: typ
    };
}
function $8a9068d6d6521bd9$var$a(typ) {
    return {
        arrayItems: typ
    };
}
function $8a9068d6d6521bd9$var$u() {
    var typs = [];
    for(var _i = 0; _i < arguments.length; _i++)typs[_i] = arguments[_i];
    return {
        unionMembers: typs
    };
}
function $8a9068d6d6521bd9$var$o(props, additional) {
    return {
        props: props,
        additional: additional
    };
}
function $8a9068d6d6521bd9$var$m(additional) {
    return {
        props: [],
        additional: additional
    };
}
function $8a9068d6d6521bd9$var$r(name) {
    return {
        ref: name
    };
}
var $8a9068d6d6521bd9$var$typeMap = {
    "Action": $8a9068d6d6521bd9$var$o([
        {
            json: "app",
            js: "app",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ActionTargetApp"))
        },
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$r("ContextElement")
        },
        {
            json: "intent",
            js: "intent",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "title",
            js: "title",
            typ: ""
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ActionType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "ActionTargetApp": $8a9068d6d6521bd9$var$o([
        {
            json: "appId",
            js: "appId",
            typ: ""
        },
        {
            json: "desktopAgent",
            js: "desktopAgent",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "instanceId",
            js: "instanceId",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "ContextElement": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: ""
        }
    ], "any"),
    "Chart": $8a9068d6d6521bd9$var$o([
        {
            json: "instruments",
            js: "instruments",
            typ: $8a9068d6d6521bd9$var$a($8a9068d6d6521bd9$var$r("InstrumentElement"))
        },
        {
            json: "otherConfig",
            js: "otherConfig",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$a($8a9068d6d6521bd9$var$r("ContextElement")))
        },
        {
            json: "range",
            js: "range",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("TimeRangeObject"))
        },
        {
            json: "style",
            js: "style",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ChartStyle"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ChartType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "InstrumentElement": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$r("PurpleInstrumentIdentifiers")
        },
        {
            json: "market",
            js: "market",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("OrganizationMarket"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("PurpleInteractionType")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "PurpleInstrumentIdentifiers": $8a9068d6d6521bd9$var$o([
        {
            json: "BBG",
            js: "BBG",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "CUSIP",
            js: "CUSIP",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "FDS_ID",
            js: "FDS_ID",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "FIGI",
            js: "FIGI",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "ISIN",
            js: "ISIN",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "PERMID",
            js: "PERMID",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "RIC",
            js: "RIC",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "SEDOL",
            js: "SEDOL",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "ticker",
            js: "ticker",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "OrganizationMarket": $8a9068d6d6521bd9$var$o([
        {
            json: "BBG",
            js: "BBG",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "COUNTRY_ISOALPHA2",
            js: "COUNTRY_ISOALPHA2",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "MIC",
            js: "MIC",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "TimeRangeObject": $8a9068d6d6521bd9$var$o([
        {
            json: "endTime",
            js: "endTime",
            typ: $8a9068d6d6521bd9$var$u(undefined, Date)
        },
        {
            json: "startTime",
            js: "startTime",
            typ: $8a9068d6d6521bd9$var$u(undefined, Date)
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("TimeRangeType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "ChatInitSettings": $8a9068d6d6521bd9$var$o([
        {
            json: "chatName",
            js: "chatName",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "members",
            js: "members",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ContactListObject"))
        },
        {
            json: "message",
            js: "message",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$u($8a9068d6d6521bd9$var$r("MessageObject"), ""))
        },
        {
            json: "options",
            js: "options",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ChatOptions"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ChatInitSettingsType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "ContactListObject": $8a9068d6d6521bd9$var$o([
        {
            json: "contacts",
            js: "contacts",
            typ: $8a9068d6d6521bd9$var$a($8a9068d6d6521bd9$var$r("ContactElement"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ContactListType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "ContactElement": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$r("PurpleContactIdentifiers")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("FluffyInteractionType")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "PurpleContactIdentifiers": $8a9068d6d6521bd9$var$o([
        {
            json: "email",
            js: "email",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "FDS_ID",
            js: "FDS_ID",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "MessageObject": $8a9068d6d6521bd9$var$o([
        {
            json: "entities",
            js: "entities",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m($8a9068d6d6521bd9$var$r("PurpleAction")))
        },
        {
            json: "text",
            js: "text",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("PurpleMessageText"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("MessageType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "PurpleAction": $8a9068d6d6521bd9$var$o([
        {
            json: "app",
            js: "app",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ActionTargetApp"))
        },
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ContextElement"))
        },
        {
            json: "intent",
            js: "intent",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "title",
            js: "title",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("EntityType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "data",
            js: "data",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("PurpleData"))
        }
    ], "any"),
    "PurpleData": $8a9068d6d6521bd9$var$o([
        {
            json: "dataUri",
            js: "dataUri",
            typ: ""
        },
        {
            json: "name",
            js: "name",
            typ: ""
        }
    ], "any"),
    "PurpleMessageText": $8a9068d6d6521bd9$var$o([
        {
            json: "text/markdown",
            js: "text/markdown",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "text/plain",
            js: "text/plain",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "ChatOptions": $8a9068d6d6521bd9$var$o([
        {
            json: "allowAddUser",
            js: "allowAddUser",
            typ: $8a9068d6d6521bd9$var$u(undefined, true)
        },
        {
            json: "allowHistoryBrowsing",
            js: "allowHistoryBrowsing",
            typ: $8a9068d6d6521bd9$var$u(undefined, true)
        },
        {
            json: "allowMessageCopy",
            js: "allowMessageCopy",
            typ: $8a9068d6d6521bd9$var$u(undefined, true)
        },
        {
            json: "groupRecipients",
            js: "groupRecipients",
            typ: $8a9068d6d6521bd9$var$u(undefined, true)
        },
        {
            json: "isPublic",
            js: "isPublic",
            typ: $8a9068d6d6521bd9$var$u(undefined, true)
        }
    ], "any"),
    "ChatMessage": $8a9068d6d6521bd9$var$o([
        {
            json: "chatRoom",
            js: "chatRoom",
            typ: $8a9068d6d6521bd9$var$r("ChatRoomObject")
        },
        {
            json: "message",
            js: "message",
            typ: $8a9068d6d6521bd9$var$r("MessageObject")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ChatMessageType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "ChatRoomObject": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$m("any")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "providerName",
            js: "providerName",
            typ: ""
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ChatRoomType")
        },
        {
            json: "url",
            js: "url",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "ChatRoom": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$m("any")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "providerName",
            js: "providerName",
            typ: ""
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ChatRoomType")
        },
        {
            json: "url",
            js: "url",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "ChatSearchCriteria": $8a9068d6d6521bd9$var$o([
        {
            json: "criteria",
            js: "criteria",
            typ: $8a9068d6d6521bd9$var$a($8a9068d6d6521bd9$var$u($8a9068d6d6521bd9$var$r("OrganizationObject"), ""))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ChatSearchCriteriaType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "OrganizationObject": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$r("Identifiers")
        },
        {
            json: "market",
            js: "market",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("OrganizationMarket"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("TentacledInteractionType")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Identifiers": $8a9068d6d6521bd9$var$o([
        {
            json: "BBG",
            js: "BBG",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "CUSIP",
            js: "CUSIP",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "FDS_ID",
            js: "FDS_ID",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "FIGI",
            js: "FIGI",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "ISIN",
            js: "ISIN",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "PERMID",
            js: "PERMID",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "RIC",
            js: "RIC",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "SEDOL",
            js: "SEDOL",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "ticker",
            js: "ticker",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "LEI",
            js: "LEI",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "email",
            js: "email",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Contact": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$r("FluffyContactIdentifiers")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("FluffyInteractionType")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "FluffyContactIdentifiers": $8a9068d6d6521bd9$var$o([
        {
            json: "email",
            js: "email",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "FDS_ID",
            js: "FDS_ID",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "ContactList": $8a9068d6d6521bd9$var$o([
        {
            json: "contacts",
            js: "contacts",
            typ: $8a9068d6d6521bd9$var$a($8a9068d6d6521bd9$var$r("ContactElement"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ContactListType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Context": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: ""
        }
    ], "any"),
    "Country": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$r("CountryID")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("CountryType")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "CountryID": $8a9068d6d6521bd9$var$o([
        {
            json: "COUNTRY_ISOALPHA2",
            js: "COUNTRY_ISOALPHA2",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "COUNTRY_ISOALPHA3",
            js: "COUNTRY_ISOALPHA3",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "ISOALPHA2",
            js: "ISOALPHA2",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "ISOALPHA3",
            js: "ISOALPHA3",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Currency": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$r("CurrencyID")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("CurrencyType")
        }
    ], "any"),
    "CurrencyID": $8a9068d6d6521bd9$var$o([
        {
            json: "CURRENCY_ISOCODE",
            js: "CURRENCY_ISOCODE",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Email": $8a9068d6d6521bd9$var$o([
        {
            json: "recipients",
            js: "recipients",
            typ: $8a9068d6d6521bd9$var$r("EmailRecipients")
        },
        {
            json: "subject",
            js: "subject",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "textBody",
            js: "textBody",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("EmailType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "EmailRecipients": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("EmailRecipientsID"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("EmailRecipientsType")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "contacts",
            js: "contacts",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$a($8a9068d6d6521bd9$var$r("ContactElement")))
        }
    ], "any"),
    "EmailRecipientsID": $8a9068d6d6521bd9$var$o([
        {
            json: "email",
            js: "email",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "FDS_ID",
            js: "FDS_ID",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Instrument": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$r("FluffyInstrumentIdentifiers")
        },
        {
            json: "market",
            js: "market",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("PurpleMarket"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("PurpleInteractionType")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "FluffyInstrumentIdentifiers": $8a9068d6d6521bd9$var$o([
        {
            json: "BBG",
            js: "BBG",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "CUSIP",
            js: "CUSIP",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "FDS_ID",
            js: "FDS_ID",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "FIGI",
            js: "FIGI",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "ISIN",
            js: "ISIN",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "PERMID",
            js: "PERMID",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "RIC",
            js: "RIC",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "SEDOL",
            js: "SEDOL",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "ticker",
            js: "ticker",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "PurpleMarket": $8a9068d6d6521bd9$var$o([
        {
            json: "BBG",
            js: "BBG",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "COUNTRY_ISOALPHA2",
            js: "COUNTRY_ISOALPHA2",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "MIC",
            js: "MIC",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "InstrumentList": $8a9068d6d6521bd9$var$o([
        {
            json: "instruments",
            js: "instruments",
            typ: $8a9068d6d6521bd9$var$a($8a9068d6d6521bd9$var$r("InstrumentElement"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("InstrumentListType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Interaction": $8a9068d6d6521bd9$var$o([
        {
            json: "description",
            js: "description",
            typ: ""
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("InteractionID"))
        },
        {
            json: "initiator",
            js: "initiator",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ContactElement"))
        },
        {
            json: "interactionType",
            js: "interactionType",
            typ: ""
        },
        {
            json: "origin",
            js: "origin",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "participants",
            js: "participants",
            typ: $8a9068d6d6521bd9$var$r("ContactListObject")
        },
        {
            json: "timeRange",
            js: "timeRange",
            typ: $8a9068d6d6521bd9$var$r("TimeRangeObject")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("InteractionType")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "InteractionID": $8a9068d6d6521bd9$var$o([
        {
            json: "SALESFORCE",
            js: "SALESFORCE",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "SINGLETRACK",
            js: "SINGLETRACK",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "URI",
            js: "URI",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Message": $8a9068d6d6521bd9$var$o([
        {
            json: "entities",
            js: "entities",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m($8a9068d6d6521bd9$var$r("FluffyAction")))
        },
        {
            json: "text",
            js: "text",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("FluffyMessageText"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("MessageType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "FluffyAction": $8a9068d6d6521bd9$var$o([
        {
            json: "app",
            js: "app",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ActionTargetApp"))
        },
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ContextElement"))
        },
        {
            json: "intent",
            js: "intent",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "title",
            js: "title",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("EntityType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "data",
            js: "data",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("FluffyData"))
        }
    ], "any"),
    "FluffyData": $8a9068d6d6521bd9$var$o([
        {
            json: "dataUri",
            js: "dataUri",
            typ: ""
        },
        {
            json: "name",
            js: "name",
            typ: ""
        }
    ], "any"),
    "FluffyMessageText": $8a9068d6d6521bd9$var$o([
        {
            json: "text/markdown",
            js: "text/markdown",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "text/plain",
            js: "text/plain",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Nothing": $8a9068d6d6521bd9$var$o([
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("NothingType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Order": $8a9068d6d6521bd9$var$o([
        {
            json: "details",
            js: "details",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("PurpleOrderDetails"))
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$m("")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("OrderType")
        }
    ], "any"),
    "PurpleOrderDetails": $8a9068d6d6521bd9$var$o([
        {
            json: "product",
            js: "product",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ProductObject"))
        }
    ], "any"),
    "ProductObject": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$m("")
        },
        {
            json: "instrument",
            js: "instrument",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("InstrumentElement"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ProductType")
        }
    ], "any"),
    "OrderList": $8a9068d6d6521bd9$var$o([
        {
            json: "orders",
            js: "orders",
            typ: $8a9068d6d6521bd9$var$a($8a9068d6d6521bd9$var$r("OrderElement"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("OrderListType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "OrderElement": $8a9068d6d6521bd9$var$o([
        {
            json: "details",
            js: "details",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("FluffyOrderDetails"))
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$m("")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("OrderType")
        }
    ], "any"),
    "FluffyOrderDetails": $8a9068d6d6521bd9$var$o([
        {
            json: "product",
            js: "product",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ProductObject"))
        }
    ], "any"),
    "Organization": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$r("OrganizationIdentifiers")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("StickyInteractionType")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "OrganizationIdentifiers": $8a9068d6d6521bd9$var$o([
        {
            json: "FDS_ID",
            js: "FDS_ID",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "LEI",
            js: "LEI",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "PERMID",
            js: "PERMID",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Portfolio": $8a9068d6d6521bd9$var$o([
        {
            json: "positions",
            js: "positions",
            typ: $8a9068d6d6521bd9$var$a($8a9068d6d6521bd9$var$r("PositionElement"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("PortfolioType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "PositionElement": $8a9068d6d6521bd9$var$o([
        {
            json: "holding",
            js: "holding",
            typ: 3.14
        },
        {
            json: "instrument",
            js: "instrument",
            typ: $8a9068d6d6521bd9$var$r("InstrumentElement")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("PositionType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Position": $8a9068d6d6521bd9$var$o([
        {
            json: "holding",
            js: "holding",
            typ: 3.14
        },
        {
            json: "instrument",
            js: "instrument",
            typ: $8a9068d6d6521bd9$var$r("InstrumentElement")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("PositionType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Product": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$m("")
        },
        {
            json: "instrument",
            js: "instrument",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("InstrumentElement"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ProductType")
        }
    ], "any"),
    "TimeRange": $8a9068d6d6521bd9$var$o([
        {
            json: "endTime",
            js: "endTime",
            typ: $8a9068d6d6521bd9$var$u(undefined, Date)
        },
        {
            json: "startTime",
            js: "startTime",
            typ: $8a9068d6d6521bd9$var$u(undefined, Date)
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("TimeRangeType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Trade": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$m("")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "product",
            js: "product",
            typ: $8a9068d6d6521bd9$var$r("ProductObject")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("TradeType")
        }
    ], "any"),
    "TradeList": $8a9068d6d6521bd9$var$o([
        {
            json: "trades",
            js: "trades",
            typ: $8a9068d6d6521bd9$var$a($8a9068d6d6521bd9$var$r("TradeElement"))
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("TradeListType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "TradeElement": $8a9068d6d6521bd9$var$o([
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$m("")
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        },
        {
            json: "product",
            js: "product",
            typ: $8a9068d6d6521bd9$var$r("ProductObject")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("TradeType")
        }
    ], "any"),
    "TransactionResult": $8a9068d6d6521bd9$var$o([
        {
            json: "context",
            js: "context",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$r("ContextElement"))
        },
        {
            json: "status",
            js: "status",
            typ: $8a9068d6d6521bd9$var$r("TransactionStatus")
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("TransactionResultType")
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "Valuation": $8a9068d6d6521bd9$var$o([
        {
            json: "CURRENCY_ISOCODE",
            js: "CURRENCY_ISOCODE",
            typ: ""
        },
        {
            json: "expiryTime",
            js: "expiryTime",
            typ: $8a9068d6d6521bd9$var$u(undefined, Date)
        },
        {
            json: "price",
            js: "price",
            typ: $8a9068d6d6521bd9$var$u(undefined, 3.14)
        },
        {
            json: "type",
            js: "type",
            typ: $8a9068d6d6521bd9$var$r("ValuationType")
        },
        {
            json: "valuationTime",
            js: "valuationTime",
            typ: $8a9068d6d6521bd9$var$u(undefined, Date)
        },
        {
            json: "value",
            js: "value",
            typ: 3.14
        },
        {
            json: "id",
            js: "id",
            typ: $8a9068d6d6521bd9$var$u(undefined, $8a9068d6d6521bd9$var$m("any"))
        },
        {
            json: "name",
            js: "name",
            typ: $8a9068d6d6521bd9$var$u(undefined, "")
        }
    ], "any"),
    "ActionType": [
        "fdc3.action"
    ],
    "PurpleInteractionType": [
        "fdc3.instrument"
    ],
    "TimeRangeType": [
        "fdc3.timerange"
    ],
    "ChartStyle": [
        "bar",
        "candle",
        "custom",
        "heatmap",
        "histogram",
        "line",
        "mountain",
        "pie",
        "scatter",
        "stacked-bar"
    ],
    "ChartType": [
        "fdc3.chart"
    ],
    "FluffyInteractionType": [
        "fdc3.contact"
    ],
    "ContactListType": [
        "fdc3.contactList"
    ],
    "EntityType": [
        "fdc3.action",
        "fdc3.entity.fileAttachment"
    ],
    "MessageType": [
        "fdc3.message"
    ],
    "ChatInitSettingsType": [
        "fdc3.chat.initSettings"
    ],
    "ChatRoomType": [
        "fdc3.chat.room"
    ],
    "ChatMessageType": [
        "fdc3.chat.message"
    ],
    "TentacledInteractionType": [
        "fdc3.contact",
        "fdc3.instrument",
        "fdc3.organization"
    ],
    "ChatSearchCriteriaType": [
        "fdc3.chat.searchCriteria"
    ],
    "CountryType": [
        "fdc3.country"
    ],
    "CurrencyType": [
        "fdc3.currency"
    ],
    "EmailRecipientsType": [
        "fdc3.contact",
        "fdc3.contactList"
    ],
    "EmailType": [
        "fdc3.email"
    ],
    "InstrumentListType": [
        "fdc3.instrumentList"
    ],
    "InteractionType": [
        "fdc3.interaction"
    ],
    "NothingType": [
        "fdc3.nothing"
    ],
    "ProductType": [
        "fdc3.product"
    ],
    "OrderType": [
        "fdc3.order"
    ],
    "OrderListType": [
        "fdc3.orderList"
    ],
    "StickyInteractionType": [
        "fdc3.organization"
    ],
    "PositionType": [
        "fdc3.position"
    ],
    "PortfolioType": [
        "fdc3.portfolio"
    ],
    "TradeType": [
        "fdc3.trade"
    ],
    "TradeListType": [
        "fdc3.tradeList"
    ],
    "TransactionStatus": [
        "Created",
        "Deleted",
        "Failed",
        "Updated"
    ],
    "TransactionResultType": [
        "fdc3.transactionResult"
    ],
    "ValuationType": [
        "fdc3.valuation"
    ]
};
/**
 * SPDX-License-Identifier: Apache-2.0
 * Copyright FINOS FDC3 contributors - see NOTICE file
 */ /**
 * @deprecated Use {@link StandardIntent} instead
 */ var $8a9068d6d6521bd9$export$1e37dc3b6d3e73c3;
(function(Intents) {
    Intents["CreateInteraction"] = "CreateInteraction";
    Intents["SendChatMessage"] = "SendChatMessage";
    Intents["StartCall"] = "StartCall";
    Intents["StartChat"] = "StartChat";
    Intents["StartEmail"] = "StartEmail";
    Intents["ViewAnalysis"] = "ViewAnalysis";
    Intents["ViewChat"] = "ViewChat";
    Intents["ViewChart"] = "ViewChart";
    Intents["ViewContact"] = "ViewContact";
    Intents["ViewHoldings"] = "ViewHoldings";
    Intents["ViewInstrument"] = "ViewInstrument";
    Intents["ViewInteractions"] = "ViewInteractions";
    Intents["ViewMessages"] = "ViewMessages";
    Intents["ViewNews"] = "ViewNews";
    Intents["ViewOrders"] = "ViewOrders";
    Intents["ViewProfile"] = "ViewProfile";
    Intents["ViewQuote"] = "ViewQuote";
    Intents["ViewResearch"] = "ViewResearch";
})($8a9068d6d6521bd9$export$1e37dc3b6d3e73c3 || ($8a9068d6d6521bd9$export$1e37dc3b6d3e73c3 = {}));


const $492908848b137c96$export$3e6a4a7964fb1e36 = '_colId.';
const $492908848b137c96$export$c3fe228feb19c707 = '_field.';




class $9046cc0afe7415e1$export$2fd88947846a8235 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    mapRowToContextData(contextType, rowNode) {
        if (contextType === 'fdc3.nothing') return {
            type: contextType
        };
        const mappedContextData = this.mapRowValueToContextData(rowNode, this.isStandardContextType(contextType) && contextType !== 'fdc3.nothing' ? this.getFdc3Options().gridDataContextMapping?.[contextType] : this.getFdc3Options().gridDataContextMapping?.custom?.[contextType]);
        const contextMappedFromGridData = {
            type: contextType,
            ...mappedContextData
        };
        const resolveContextDataFn = this.getFdc3Options().resolveContextData;
        if (typeof resolveContextDataFn === 'function') return resolveContextDataFn({
            ...this.getAdaptableInternalApi().buildBaseContext(),
            contextType: contextType,
            contextMappedFromGridData: contextMappedFromGridData,
            rowNode: rowNode,
            rowData: rowNode.data,
            primaryKeyValue: this.getGridApi().getPrimaryKeyValueForRowNode(rowNode)
        });
        else return contextMappedFromGridData;
    }
    getFdc3ColumnIds() {
        const fdc3ColumnIds = [];
        if (this.isAtLeastOneActionButtonConfigured()) fdc3ColumnIds.push(this.getFdc3Options().actionColumnDefaultConfiguration.columnId);
        [
            ...this.getAllRaiseIntentConfigs(),
            ...this.getAllBroadcastContextConfigs()
        ].forEach((config)=>{
            if (config.actionColumn) fdc3ColumnIds.push(config.actionColumn.columnId);
        });
        return fdc3ColumnIds;
    }
    getFdc3ActionColDefs() {
        const actionColDefs = [];
        if (this.isAtLeastOneActionButtonConfigured()) {
            const actionColumnConfig = this.getFdc3Options().actionColumnDefaultConfiguration;
            actionColDefs.push({
                colId: actionColumnConfig.columnId,
                headerName: actionColumnConfig.headerName,
                hide: false,
                lockVisible: true,
                suppressColumnsToolPanel: true,
                suppressFiltersToolPanel: true,
                editable: false,
                width: actionColumnConfig.width,
                resizable: actionColumnConfig.resizable,
                suppressHeaderMenuButton: true,
                suppressMovable: !actionColumnConfig.movable,
                filter: false,
                sortable: false,
                enableRowGroup: false,
                cellRenderer: this.getAdaptableVariant() === 'react' ? (0, $79b01c1d220556e7$export$688e89b740279725) : (0, $79b01c1d220556e7$export$e07699803620456f),
                type: [
                    (0, $b0d14b794bdca4f2$export$aee5eaf013923665)
                ]
            });
        }
        const buildColDef = (actionColumnConfig)=>{
            return {
                colId: actionColumnConfig.columnId,
                headerName: actionColumnConfig.friendlyName,
                hide: false,
                lockVisible: true,
                suppressColumnsToolPanel: true,
                suppressFiltersToolPanel: true,
                editable: false,
                width: actionColumnConfig.defaultWidth,
                resizable: true,
                suppressHeaderMenuButton: true,
                suppressMovable: false,
                filter: false,
                sortable: false,
                enableRowGroup: false,
                cellRenderer: this.getAdaptableVariant() === 'react' ? (0, $79b01c1d220556e7$export$688e89b740279725) : (0, $79b01c1d220556e7$export$e07699803620456f),
                type: [
                    (0, $b0d14b794bdca4f2$export$aee5eaf013923665)
                ]
            };
        };
        this.getAllRaiseIntentConfigs().forEach((intentConfig)=>{
            if (!intentConfig.actionColumn) return;
            const intendActionColumnConfig = intentConfig.actionColumn;
            actionColDefs.push(buildColDef(intendActionColumnConfig));
        });
        this.getAllBroadcastContextConfigs().forEach((contextConfig)=>{
            if (!contextConfig.actionColumn) return;
            const contextActionColumnConfig = contextConfig.actionColumn;
            actionColDefs.push(buildColDef(contextActionColumnConfig));
        });
        return actionColDefs;
    }
    getButtonsForFdc3MainActionColumn() {
        const buttons = [];
        const intentButtonConfigs = this.getIntentConfigsWithActionButtons();
        intentButtonConfigs.forEach((intentConfig)=>{
            if (!intentConfig.actionButton) return;
            const intendActionButtonConfig = intentConfig.actionButton;
            buttons.push(this.mapFdc3ButtonConfigToAdaptableButton(intendActionButtonConfig, {
                action: 'raiseIntent',
                intent: intentConfig.intentType,
                contextType: intentConfig.contextType
            }));
        });
        const broadcastButtonConfigs = this.getContextConfigsWithActionButtons();
        broadcastButtonConfigs.forEach((contextConfig)=>{
            if (!contextConfig.actionButton) return;
            const contextActionButtonConfig = contextConfig.actionButton;
            buttons.push(this.mapFdc3ButtonConfigToAdaptableButton(contextActionButtonConfig, {
                action: 'broadcastContext',
                contextType: contextConfig.contextType
            }));
        });
        return buttons;
    }
    getButtonsForFdc3StandaloneActionColumn(columnId) {
        const buttons = [];
        this.getAllRaiseIntentConfigs().forEach((intentConfig)=>{
            if (intentConfig.actionColumn?.columnId === columnId) buttons.push(this.mapFdc3ButtonConfigToAdaptableButton(intentConfig.actionColumn.button, {
                action: 'raiseIntent',
                intent: intentConfig.intentType,
                contextType: intentConfig.contextType
            }));
        });
        this.getAllBroadcastContextConfigs().forEach((contextConfig)=>{
            if (contextConfig.actionColumn?.columnId === columnId) buttons.push(this.mapFdc3ButtonConfigToAdaptableButton(contextConfig.actionColumn.button, {
                action: 'broadcastContext',
                contextType: contextConfig.contextType
            }));
        });
        return buttons;
    }
    isFdc3MainActionColumn(columnId) {
        return columnId === this.getFdc3Options().actionColumnDefaultConfiguration.columnId;
    }
    isFdc3StandaloneActionColumn(columnId) {
        const allFdc3ColumnIds = this.getFdc3ColumnIds();
        return allFdc3ColumnIds.includes(columnId) && !this.isFdc3MainActionColumn(columnId);
    }
    handleIntentResolution(intentResolution, context, raisedIntent, app) {
        const relevantRaiseIntentConfig = this.getAllRaiseIntentConfigs().find((config)=>config.intentType === raisedIntent && config.contextType === context.type);
        if (typeof relevantRaiseIntentConfig?.handleIntentResolution === 'function') // call intent specific resolution handler
        relevantRaiseIntentConfig.handleIntentResolution({
            ...this.getAdaptableInternalApi().buildBaseContext(),
            intentResolution: intentResolution
        });
        else // call global resolution handler (if any)
        this.getFdc3Options().intents?.handleIntentResolution?.({
            ...this.getAdaptableInternalApi().buildBaseContext(),
            intentResolution: intentResolution
        });
    }
    isStandardContextType(contextType) {
        return (0, $8a9068d6d6521bd9$export$c995e46853dd6a78)(contextType);
    }
    isStandardIntentType(intentType) {
        return (0, $8a9068d6d6521bd9$export$36ac6d3287e274c0)(intentType);
    }
    getAllRaiseIntentConfigs() {
        const result = [];
        const mapConfig = (intentType, intentConfigs)=>intentConfigs.map((intentConfig)=>({
                    ...intentConfig,
                    intentType: intentType
                }));
        const raiseIntentConfiguration = this.getFdc3Options().intents?.raises || {};
        Object.keys(raiseIntentConfiguration).forEach((intentType)=>{
            if (intentType === 'custom') {
                const customIntentConfigs = raiseIntentConfiguration[intentType];
                Object.keys(customIntentConfigs).forEach((customIntentType)=>{
                    result.push(...mapConfig(customIntentType, customIntentConfigs[customIntentType]));
                });
            } else {
                const intentConfigs = raiseIntentConfiguration[intentType];
                result.push(...mapConfig(intentType, intentConfigs));
            }
        });
        return result;
    }
    getAllBroadcastContextConfigs() {
        const result = [];
        const mapConfig = (contextType, contextConfig)=>({
                ...contextConfig,
                contextType: contextType
            });
        const broadcastContextConfiguration = this.getFdc3Options().contexts?.broadcasts || {};
        Object.keys(broadcastContextConfiguration).forEach((contextType)=>{
            if (contextType === 'custom') {
                const customContextConfigs = broadcastContextConfiguration[contextType];
                Object.keys(customContextConfigs).forEach((customContextType)=>{
                    result.push(mapConfig(customContextType, customContextConfigs[customContextType]));
                });
            } else {
                const contextConfigs = broadcastContextConfiguration[contextType];
                result.push(mapConfig(contextType, contextConfigs));
            }
        });
        return result;
    }
    getDefaultIconForIntent(intentType) {
        const defaultConfig = this.getAdaptableInternalApi().getFdc3Service().getUiControlsDefaultConfiguration();
        // @ts-ignore
        const intentIcon = defaultConfig?.intents[intentType]?.icon ?? {
            name: 'fdc3'
        };
        return intentIcon;
    }
    getDefaultIconForContext(contextType) {
        const defaultConfig = this.getAdaptableInternalApi().getFdc3Service().getUiControlsDefaultConfiguration();
        // @ts-ignore
        const contextIcon = defaultConfig?.contexts[contextType]?.icon ?? {
            name: 'fdc3'
        };
        return contextIcon;
    }
    mapRowValueToContextData(rowNode, contextMapping = {}) {
        // recursively map the row node values to the context data
        const mapContext = (obj)=>{
            return Object.keys(obj).reduce((mappedData, contextKey)=>{
                const valueReference = obj[contextKey];
                if (Array.isArray(valueReference)) mappedData[contextKey] = valueReference.map((item)=>mapContext(item));
                else if (typeof valueReference === 'object') mappedData[contextKey] = mapContext(valueReference);
                else {
                    // map value from row node
                    // first validate refs
                    if (typeof valueReference !== 'string' || !valueReference.startsWith((0, $492908848b137c96$export$3e6a4a7964fb1e36)) && !valueReference.startsWith((0, $492908848b137c96$export$c3fe228feb19c707))) {
                        this.logError(`Invalid FDC3 value reference for '${contextKey}': ${valueReference}`);
                        return mappedData;
                    }
                    // '_coldId.columnId'
                    if (valueReference.startsWith((0, $492908848b137c96$export$3e6a4a7964fb1e36))) {
                        const columnId = valueReference.replace((0, $492908848b137c96$export$3e6a4a7964fb1e36), '');
                        mappedData[contextKey] = this.getGridApi().getRawValueFromRowNode(rowNode, columnId);
                    }
                    // '_field.fieldName'
                    if (valueReference.startsWith((0, $492908848b137c96$export$c3fe228feb19c707))) {
                        const fieldId = valueReference.replace((0, $492908848b137c96$export$c3fe228feb19c707), '');
                        mappedData[contextKey] = this.getAdaptableInternalApi().getValueUsingField(rowNode.data, fieldId);
                    }
                }
                return mappedData;
            }, {});
        };
        return mapContext(contextMapping);
    }
    isAtLeastOneActionButtonConfigured() {
        return this.getIntentConfigsWithActionButtons().length || this.getContextConfigsWithActionButtons().length;
    }
    getIntentConfigsWithActionButtons() {
        return this.getAllRaiseIntentConfigs().filter((intentConfig)=>!!intentConfig.actionButton);
    }
    getContextConfigsWithActionButtons() {
        return this.getAllBroadcastContextConfigs().filter((contextConfig)=>!!contextConfig.actionButton);
    }
    mapFdc3ButtonConfigToAdaptableButton(fdc3AdaptableButton, fdcInfo) {
        const buildFdc3Context = (context)=>{
            return {
                context: this.mapRowToContextData(fdcInfo.contextType, context.rowNode),
                intent: fdcInfo.action === 'raiseIntent' ? fdcInfo.intent : null,
                rowNode: context.rowNode,
                rowData: context.data,
                primaryKeyValue: context.primaryKeyValue,
                ...this.getAdaptableInternalApi().buildBaseContext()
            };
        };
        return {
            onClick: (_button, context)=>{
                if (fdcInfo.action === 'raiseIntent') this.getFdc3Api().raiseIntentFromRow(context.rowNode, fdcInfo.intent, fdcInfo.contextType);
                if (fdcInfo.action === 'broadcastContext') this.getFdc3Api().broadcastFromRow(context.rowNode, fdcInfo.contextType);
            },
            label: (_button, context)=>{
                const fdc3Label = fdc3AdaptableButton.label;
                if (typeof fdc3Label === 'function') return fdc3Label(fdc3AdaptableButton, buildFdc3Context(context));
                if (fdc3Label === '_defaultFdc3') return this.getDefaultFdc3ButtonLabel(fdcInfo);
                return fdc3Label;
            },
            icon: (_button, context)=>{
                const fdc3Icon = fdc3AdaptableButton.icon;
                if (typeof fdc3Icon === 'function') return fdc3Icon(fdc3AdaptableButton, buildFdc3Context(context));
                if (fdc3Icon === '_defaultFdc3') return this.getDefaultFdc3ButtonIcon(fdcInfo);
                return fdc3Icon;
            },
            buttonStyle: (_button, context)=>{
                const fdc3ButtonStyle = fdc3AdaptableButton.buttonStyle;
                if (fdc3ButtonStyle == undefined) return this.getDefaultFdc3ButtonStyle(fdcInfo);
                if (typeof fdc3ButtonStyle === 'function') return fdc3ButtonStyle(fdc3AdaptableButton, buildFdc3Context(context));
                return fdc3ButtonStyle;
            },
            tooltip: (_button, context)=>{
                const fdc3Tooltip = fdc3AdaptableButton.tooltip;
                if (typeof fdc3Tooltip === 'function') return fdc3Tooltip(fdc3AdaptableButton, buildFdc3Context(context));
                if (fdc3Tooltip === '_defaultFdc3') return this.getDefaultFdc3ButtonLabel(fdcInfo);
                return fdc3Tooltip;
            },
            disabled: (_button, context)=>{
                const fdc3Disabled = fdc3AdaptableButton.disabled;
                if (typeof fdc3Disabled === 'function') return fdc3Disabled(fdc3AdaptableButton, buildFdc3Context(context));
                return fdc3Disabled;
            },
            hidden: (_button, context)=>{
                const fdc3Hidden = fdc3AdaptableButton.hidden;
                if (typeof fdc3Hidden === 'function') return fdc3Hidden(fdc3AdaptableButton, buildFdc3Context(context));
                return fdc3Hidden;
            }
        };
    }
    getDefaultFdc3ButtonLabel(fdc3Info) {
        if (fdc3Info.action === 'raiseIntent') return `Raise ${fdc3Info.intent}`;
        if (fdc3Info.action === 'broadcastContext') return `Broadcast ${this.getFdc3Api().getContextLabel(fdc3Info.contextType)}`;
        return '';
    }
    getDefaultFdc3ButtonIcon(fdc3Info) {
        if (fdc3Info.action === 'raiseIntent') return this.getDefaultIconForIntent(fdc3Info.intent);
        else return this.getDefaultIconForContext(fdc3Info.contextType);
    }
    getDefaultFdc3ButtonStyle(fdcInfo) {
        return {
            variant: 'outlined',
            tone: 'neutral'
        };
    }
}


const $6c0fdce80feddf80$export$9f57e1cc37377461 = {
    'fdc3.action': {
        label: 'Action',
        icon: 'fdc3'
    },
    'fdc3.chart': {
        label: 'Chart',
        icon: 'pie-chart'
    },
    'fdc3.chat.initSettings': {
        label: 'ChatInitSettings',
        icon: 'chat'
    },
    'fdc3.chat.message': {
        label: 'ChatMessage',
        icon: 'chat'
    },
    'fdc3.chat.room': {
        label: 'ChatRoom',
        icon: 'chat'
    },
    'fdc3.chat.searchCriteria': {
        label: 'ChatSearchCriteria',
        icon: 'chat'
    },
    'fdc3.contact': {
        label: 'Contact',
        icon: 'badge'
    },
    'fdc3.contactList': {
        label: 'ContactList',
        icon: 'badge'
    },
    'fdc3.country': {
        label: 'Country',
        icon: 'flag'
    },
    'fdc3.currency': {
        label: 'Currency',
        icon: 'dollar'
    },
    'fdc3.email': {
        label: 'Email',
        icon: 'mail'
    },
    'fdc3.instrument': {
        label: 'Instrument',
        icon: 'money'
    },
    'fdc3.instrumentList': {
        label: 'InstrumentList',
        icon: 'money'
    },
    'fdc3.interaction': {
        label: 'Interaction',
        icon: 'sync'
    },
    'fdc3.message': {
        label: 'Message',
        icon: 'mail'
    },
    'fdc3.organization': {
        label: 'Organization',
        icon: 'organisation'
    },
    'fdc3.portfolio': {
        label: 'Portfolio',
        icon: 'building'
    },
    'fdc3.position': {
        label: 'Position',
        icon: 'building'
    },
    'fdc3.timerange': {
        label: 'TimeRange',
        icon: 'date-range'
    },
    'fdc3.transactionResult': {
        label: 'TransactionResult',
        icon: 'fdc3'
    },
    'fdc3.valuation': {
        label: 'Valuation',
        icon: 'equation'
    },
    'fdc3.nothing': {
        label: 'Nothing',
        icon: 'fdc3'
    }
};


class $6d093119220e2a11$export$e3683139a98dce74 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $9046cc0afe7415e1$export$2fd88947846a8235)(_adaptable);
    }
    getDesktopAgent() {
        return this.getFdc3Service().getDesktopAgent();
    }
    buildContextDataFromRow(contextType, rowNode) {
        return this.internalApi.mapRowToContextData(contextType, rowNode);
    }
    buildContextDataForPrimaryKey(contextType, primaryKeyValue) {
        const rowNode = this.getGridApi().getRowNodeForPrimaryKey(primaryKeyValue);
        if (!rowNode) {
            this.logWarn(`No row found for primary key value '${primaryKeyValue}'`);
            return undefined;
        }
        return this.buildContextDataFromRow(contextType, rowNode);
    }
    raiseIntentFromPrimaryKey(primaryKeyValue, intent, contextType, appIdentifier) {
        const rowNode = this.getGridApi().getRowNodeForPrimaryKey(primaryKeyValue);
        if (!rowNode) {
            this.logWarn(`No row found for primary key value '${primaryKeyValue}'`);
            return undefined;
        }
        return this.raiseIntentFromRow(rowNode, intent, contextType, appIdentifier);
    }
    raiseIntentFromRow(rowNode, intent, contextType, appIdentifier) {
        const contextData = this.buildContextDataFromRow(contextType, rowNode);
        return this.getFdc3Service().raiseIntent(intent, contextData, appIdentifier);
    }
    raiseIntentForContextFromRow(rowNode, contextType, appIdentifier) {
        const contextData = this.buildContextDataFromRow(contextType, rowNode);
        return this.getFdc3Service().raiseIntentForContext(contextData, appIdentifier);
    }
    raiseIntentForContextFromPrimaryKey(primaryKeyValue, contextType, appIdentifier) {
        const rowNode = this.getGridApi().getRowNodeForPrimaryKey(primaryKeyValue);
        if (!rowNode) {
            this.logWarn(`No row found for primary key value '${primaryKeyValue}'`);
            return undefined;
        }
        return this.raiseIntentForContextFromRow(rowNode, contextType, appIdentifier);
    }
    broadcastFromRow(rowNode, contextType, channel) {
        const contextData = this.buildContextDataFromRow(contextType, rowNode);
        return this.getFdc3Service().broadcast(contextData, channel);
    }
    broadcastFromPrimaryKey(primaryKeyValue, contextType, channel) {
        const rowNode = this.getGridApi().getRowNodeForPrimaryKey(primaryKeyValue);
        if (!rowNode) {
            this.logWarn(`No row found for primary key value '${primaryKeyValue}'`);
            return undefined;
        }
        return this.broadcastFromRow(rowNode, contextType, channel);
    }
    getContextLabel(contextType) {
        return this.isStandardContextType(contextType) ? (0, $6c0fdce80feddf80$export$9f57e1cc37377461)[contextType]?.label : contextType;
    }
    isStandardContextType(contextType) {
        return this.internalApi.isStandardContextType(contextType);
    }
    isStandardIntentType(intentType) {
        return this.internalApi.isStandardIntentType(intentType);
    }
    getFdc3Service() {
        return this.getAdaptableInternalApi().getFdc3Service();
    }
}





class $c0d24b54d3e29f60$export$c6c82d8ecad77f01 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    async importData(partialRows) {
        const dataImportOptions = this.getOptions().dataImportOptions;
        let importData = partialRows;
        if (typeof dataImportOptions.handleImportedData === 'function') {
            const resolution = await dataImportOptions.handleImportedData({
                data: importData,
                ...this.getAdaptableInternalApi().buildBaseContext()
            });
            if (resolution && resolution?.emitDataImportedEvent) this.getEventApi().internalApi.fireDataImportedEvent(importData, resolution.addedRows, resolution.updatedRows);
            return;
        }
        const gridApi = this.getGridApi();
        const primaryKey = this.getOptions().primaryKey;
        let newRowCount = 0;
        let updatedRowCount = 0;
        const preparedDataRows = importData.map((dataRow)=>{
            const node = gridApi.getRowNodeForPrimaryKey(dataRow[primaryKey]);
            if (!node) {
                newRowCount += 1;
                return dataRow;
            }
            updatedRowCount += 1;
            return {
                ...node?.data,
                ...dataRow
            };
        });
        const { addedRows: addedRows, updatedRows: updatedRows } = await gridApi.addOrUpdateGridData(preparedDataRows);
        let message = '';
        if (newRowCount && updatedRowCount) message = `Added: ${newRowCount} new Row${newRowCount > 1 ? 's' : ''}; Updated: ${updatedRowCount} existing Row${updatedRowCount > 1 ? 's' : ''}`;
        else if (newRowCount && !updatedRowCount) message = `Added: ${newRowCount} new Row${newRowCount > 1 ? 's' : ''}`;
        else if (!newRowCount && updatedRowCount) message = `Updated: ${updatedRowCount} existing Row${updatedRowCount > 1 ? 's' : ''}`;
        const alert = {
            alertType: 'generic',
            header: 'Data Imported',
            message: message,
            alertDefinition: {
                ...(0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyAlertDefinition(),
                MessageType: 'Info',
                AlertProperties: {
                    DisplayNotification: true
                }
            }
        };
        this.getAlertApi().displayAdaptableAlert(alert);
        const dataImportedInfo = this.getEventApi().internalApi.fireDataImportedEvent(importData, addedRows, updatedRows);
        // Dispatch action (purely so it will be in Audit Log)
        this.getAdaptableInternalApi().dispatchReduxAction($5b564bb703f29152$export$88b2e732fada6209(dataImportedInfo));
    }
}



class $6962baf54aa53242$export$38cf1851293b0f57 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $c0d24b54d3e29f60$export$c6c82d8ecad77f01)(_adaptable);
    }
    openImportWizard() {
        this.getSettingsPanelApi().openSettingsPanel('DataImport');
    }
    importData(partialRows) {}
}




var $9OAZF = parcelRequire("9OAZF");


class $2446f68b802ebb6c$export$5a6433e06e71b963 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Returns the name of all the referenced Named Queries as an array of strings
     * @param expression query string
     */ getReferencedNamedQueryNames(expression = '') {
        try {
            return this.getAdaptableInternalApi().getQueryLanguageService().getNamedQueryNamesFromExpression(expression);
        } catch (error) {
            // defensive programing, this should happen only if someone botched Initial Adaptable State
            this.logWarn(`QueryApi.getReferencedNamedQueryNames received an invalid expression: ${expression}
                  Error: ${error}`);
            return [];
        }
    }
    /**
     * Returns all the references in the AdaptableState of the NamedQuery with the given name
     * @param namedQueryName namedQuery name
     */ getNamedQueryModuleReferences(namedQueryName) {
        const references = [];
        this.getAdaptableInternalApi().getModules().forEach((module)=>{
            if (module.getModuleNamedQueryReferences().some((moduleReference)=>moduleReference === namedQueryName)) references.push(module.moduleInfo.FriendlyName);
        });
        return references;
    }
    validateDeletedNamedQuery(namedQuery) {
        const namedQueryReferences = this.getNamedQueryModuleReferences(namedQuery);
        if (namedQueryReferences.length) {
            const alert = {
                alertType: 'generic',
                header: 'Named Query',
                message: `This Named Query cannot be deleted. It is still referenced by: ${namedQueryReferences.join(', ')}.`,
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
            };
            this.getAlertApi().displayAdaptableAlertNotification(alert);
            return false;
        } else return true;
    }
    validateRenamedNamedQuery(namedQuery) {
        const namedQueryReferences = this.getNamedQueryModuleReferences(namedQuery);
        if (namedQueryReferences.length) {
            const alert = {
                alertType: 'generic',
                header: 'Named Query',
                message: `This Named Query cannot be renamed. It is currently referenced by: ${namedQueryReferences.join(', ')}.`,
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
            };
            this.getAlertApi().displayAdaptableAlertNotification(alert);
            return false;
        } else return true;
    }
}




class $6957be111b05b666$export$4c5eb70a6fb4cfb8 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $2446f68b802ebb6c$export$5a6433e06e71b963)(_adaptable);
    }
    addNamedQuery(namedQuery) {
        this.dispatchAction($f53463061a55e5a9$export$35d9816f002a20ec(namedQuery));
    }
    addNamedQueries(namedQueries) {
        this.dispatchAction($f53463061a55e5a9$export$346cb5b1d18b1d0b(namedQueries));
    }
    getNamedQueryState() {
        return this.getAdaptableState().NamedQuery;
    }
    getNamedQueries() {
        return this.getNamedQueryState().NamedQueries || [];
    }
    getNamedQueryByName(namedQueryName) {
        return this.getNamedQueries().find((se)=>se.Name == namedQueryName);
    }
    isValidNamedQuery(namedQuery) {
        if ((0, $9OAZF.IsNullOrEmptyOrWhiteSpace)(namedQuery?.Name)) return {
            valid: false,
            message: 'A name is required for the Named Query.'
        };
        // check that there is no other existing named query with the same name
        const duplicate = this.getNamedQueries().find((q)=>q.Name === namedQuery.Name && q.Uuid !== namedQuery.Uuid);
        if (duplicate) return {
            valid: false,
            message: 'A Named Query with this name already exists.'
        };
        return {
            valid: true,
            message: ''
        };
    }
    openNamedQuerySettingsPanel() {
        this.showModulePopup($42e863194fcb493f$export$97c45942f844607e);
    }
    runNamedQuery(namedQuery) {
        this.getGridFilterApi().setGridFilterExpression(namedQuery.Name);
    }
    runQueryByName(queryName) {
        const namedQuery = this.getNamedQueryByName(queryName);
        if (namedQuery) this.runNamedQuery(namedQuery);
    }
}







class $da841706b2b4ab02$export$6fdc0d39d61072dd extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    areCommentsSupportedInLayout() {
        if (this.getLayoutApi().isCurrentLayoutPivot()) return false;
        return true;
    }
    getCommentsDateFormat() {
        const dateFormat = this.getCommentOptions().dateFormat;
        return typeof dateFormat === 'function' ? dateFormat() : dateFormat;
    }
}


class $ced015b08bd92823$export$1d127f5a7b018129 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $da841706b2b4ab02$export$6fdc0d39d61072dd)(_adaptable);
    }
    getCommentThreadForCell(address) {
        return $4e814d4456d3e111$export$c662b749c0ef4d93(this.getAdaptableState().Comment, address);
    }
    getAllComments() {
        return this.getAdaptableState().Comment.CommentThreads ?? [];
    }
    editComment(comment, address) {
        this.dispatchAction($4e814d4456d3e111$export$aba82d4e5a4c129e({
            comment: comment,
            cellAddress: address
        }));
    }
    deleteComment(comment, address) {
        this.dispatchAction($4e814d4456d3e111$export$fbe86001491d9da3({
            commentUuid: comment.Uuid,
            cellAddress: address
        }));
    }
    addComment(commentText, address) {
        this.dispatchAction($4e814d4456d3e111$export$efe3cd4a09e7630d({
            comment: commentText ? (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateAdaptableComment(commentText, this.getAdaptableApi()) : null,
            cellAddress: address
        }));
    }
    addCommentThread(commentThread) {
        if (!commentThread.Uuid) (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).addAdaptableObjectPrimitives(commentThread);
        this.dispatchAction($4e814d4456d3e111$export$7377931e5393aad4({
            commentThread: commentThread
        }));
    }
    deleteCommentThread(cellAddress) {
        this.dispatchAction($4e814d4456d3e111$export$2f0a4ff7e52f33a({
            cellAddress: cellAddress
        }));
    }
    setComments(commentThreads) {
        this.dispatchAction($4e814d4456d3e111$export$deb82563293619ac({
            commentThreads: commentThreads
        }));
    }
    clearComments() {
        this.setComments([]);
    }
    hideCommentsPopup() {
        this.getAdaptableInternalApi().getAnnotationsService().hidePopup();
    }
}




class $4aee8b0b36aae84c$export$4f114e54dff3c9c7 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    constructor(adaptable){
        super(adaptable);
    }
    showColumnMenu(columnKey) {
        this.getAgGridApi().showColumnMenu(columnKey);
    }
    hideColumnMenu() {
        this.getAgGridApi().hidePopupMenu();
    }
    getColumnMenuItemsByCategory(category, context) {
        return context.defaultAdaptableMenuItems.filter((item)=>item.category === category);
    }
    getColumnMenuItemsByCategories(categories, context) {
        return context.defaultAdaptableMenuItems.filter((item)=>categories.includes(item.category));
    }
    createDefaultMenuStructure(context) {
        const test = [
            ...context.defaultAgGridMenuStructure,
            (0, $58846ea7f4156db7$export$86c4217d77f432b7),
            ...context.defaultAdaptableMenuStructure
        ];
        return test;
    }
    getColumnMenuItemByName(menuItemName, context) {
        const openSettingsPanelMenuItem = context.defaultAdaptableMenuItems.find((item)=>item.name === menuItemName);
        return openSettingsPanelMenuItem;
    }
    getColumnMenuItemsByNames(menuItemNames, context) {
        const menuItems = context.defaultAdaptableMenuItems.filter((item)=>menuItemNames.includes(item.name));
        return menuItems;
    }
    getColumnMenuItemByLabel(label, context) {
        const menuItem = context.defaultAdaptableMenuItems.find((item)=>item.label === label);
        return menuItem;
    }
    getColumnMenuItemsByLabels(labels, context) {
        const menuItems = context.defaultAdaptableMenuItems.filter((item)=>labels.includes(item.label));
        return menuItems;
    }
    removeAdaptableColumnMenuItemByName(menuItemName, context) {
        const filteredMenuItems = context.defaultAdaptableMenuStructure.filter((item)=>item !== '-' && item.name !== menuItemName);
        return filteredMenuItems;
    }
    removeAdaptableColumnMenuItemsByNames(menuItemNames, context) {
        const filteredMenuItems = context.defaultAdaptableMenuStructure.filter((item)=>item !== '-' && !menuItemNames.includes(item.name));
        return filteredMenuItems;
    }
    createGroupMenu(label, subMenuItems, disabled, icon) {
        return {
            menuType: 'Group',
            label: label,
            subMenuItems: subMenuItems,
            disabled: disabled,
            icon: icon
        };
    }
}




class $6ba1dca98b59bc78$export$b80b3864e6b6ee42 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    constructor(adaptable){
        super(adaptable);
    }
    hideContextMenu() {
        this.getAgGridApi().hidePopupMenu();
    }
    getContextMenuItemsByCategory(category, context) {
        return context.defaultAdaptableMenuItems.filter((item)=>item.category === category);
    }
    getContextMenuItemsByCategories(categories, context) {
        return context.defaultAdaptableMenuItems.filter((item)=>categories.includes(item.category));
    }
    createDefaultMenuStructure(context) {
        const test = [
            ...context.defaultAgGridMenuStructure,
            (0, $58846ea7f4156db7$export$86c4217d77f432b7),
            ...context.defaultAdaptableMenuStructure
        ];
        return test;
    }
    getContextMenuItemByName(menuItemName, context) {
        const openSettingsPanelMenuItem = context.defaultAdaptableMenuItems.find((item)=>item.name === menuItemName);
        return openSettingsPanelMenuItem;
    }
    getContextMenuItemsByNames(menuItemNames, context) {
        const menuItems = context.defaultAdaptableMenuItems.filter((item)=>menuItemNames.includes(item.name));
        return menuItems;
    }
    getContextMenuItemByLabel(label, context) {
        const menuItem = context.defaultAdaptableMenuItems.find((item)=>item.label === label);
        return menuItem;
    }
    getContextMenuItemsByLabels(labels, context) {
        const menuItems = context.defaultAdaptableMenuItems.filter((item)=>labels.includes(item.label));
        return menuItems;
    }
    removeAdaptableContextMenuItemByName(menuItemName, context) {
        const filteredMenuItems = context.defaultAdaptableMenuStructure.filter((item)=>item !== '-' && item.name !== menuItemName);
        return filteredMenuItems;
    }
    removeAdaptableContextMenuItemsByNames(menuItemNames, context) {
        const filteredMenuItems = context.defaultAdaptableMenuStructure.filter((item)=>item !== '-' && !menuItemNames.includes(item.name));
        return filteredMenuItems;
    }
    createGroupMenu(label, subMenuItems, disabled, icon) {
        return {
            menuType: 'Group',
            label: label,
            subMenuItems: subMenuItems,
            disabled: disabled,
            icon: icon
        };
    }
}




class $9a265e898c06bcdb$export$83c13bce9c99e009 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
}






var $9g4SS = parcelRequire("9g4SS");



var $9g4SS = parcelRequire("9g4SS");

var $9OAZF = parcelRequire("9OAZF");


class $a23991341724d458$export$e706c937f1e8c12d {
    adaptableApi;
    colId;
    filterDisplayValuesResult;
    previousFilterDisplayValuesResult;
    constructor(adaptableApi){
        this.adaptableApi = adaptableApi;
    }
    init(params) {
        this.colId = params.column.getColId();
    }
    doesFilterPass(params) {
        try {
            const rowNode = params.node;
            // first assess if the Row is filterable - if not, then return true so it always appears in Grid
            const isRowFilterable = this.adaptableApi.gridApi.internalApi.isRowFilterable(rowNode);
            if (!isRowFilterable) return true;
            const columnFilterModel = params.model;
            if (!columnFilterModel) {
                this.adaptableApi.logWarn(`AdaptableFilterHandler.doesFilterPass: No filter model found for column ${this.colId}`);
                return true;
            }
            if (columnFilterModel.IsSuspended) return true;
            return this.adaptableApi.filterApi.columnFilterApi.internalApi.evaluateColumnFilter(columnFilterModel, rowNode);
        } catch (ex) {
            this.adaptableApi.consoleError(ex);
            return false;
        }
    }
    getCachedFilterDisplayValues() {
        return this.filterDisplayValuesResult;
    }
    getLastCachedFilterDisplayValues() {
        return this.filterDisplayValuesResult ?? this.previousFilterDisplayValuesResult;
    }
    getFromCacheOrFetchFilterDisplayValues(options) {
        if (this.filterDisplayValuesResult) return Promise.resolve(this.filterDisplayValuesResult);
        return this.fetchFilterDisplayValues(options);
    }
    async fetchFilterDisplayValues(options) {
        return this.adaptableApi.gridApi.internalApi.getDistinctFilterDisplayValuesForColumn({
            columnId: this.colId,
            get currentSearchValue () {
                return options.currentSearchValue;
            },
            previousResult: this.filterDisplayValuesResult
        }).then((result)=>{
            this.filterDisplayValuesResult = result;
            return result;
        });
    }
    onNewRowsLoaded() {
        this.resetFilterDisplayValues();
    }
    onAnyFilterChanged() {
        const filterOptions = this.adaptableApi.optionsApi.getFilterOptions();
        if (!filterOptions.customInFilterValues) // no-one is using value.count or value.visible
        // or context.sortedValues
        // so no need to reset the filter display values
        return;
        this.resetFilterDisplayValues();
    }
    resetFilterDisplayValues() {
        if (this.filterDisplayValuesResult) this.previousFilterDisplayValuesResult = this.filterDisplayValuesResult;
        // Reset the filter display values manually
        this.filterDisplayValuesResult = undefined;
    }
    async refreshFilterDisplayValues() {
        this.resetFilterDisplayValues();
        return this.getFromCacheOrFetchFilterDisplayValues({
            currentSearchValue: ''
        });
    }
    refresh(_params) {}
    destroy() {
        this.filterDisplayValuesResult = undefined;
        this.previousFilterDisplayValuesResult = undefined;
    }
}


class $b505c69e4fc10a23$export$2b26b5b6782c3ac5 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Returns Predicate Definition for given Column and Quick Filter shortcut
     * @param shortcut Quick Filter shortcut to lookup
     * @param column AdapTable Column being Filtered
     */ findPredicateDefByShortcut(shortcut, column) {
        return this.getColumnFilterApi().getFilterPredicateDefsForColumn(column).find((predicateDef)=>this.getPredicateDefShortcuts(predicateDef)?.includes(shortcut));
    }
    /**
     * Creates an Equality Filter based on given Grid Cells
     * @param gridCells cells to create Filter for
     */ createValuesColumnFilterForCells(gridCells) {
        if (!gridCells) return null;
        const filter = {
            ColumnId: gridCells[0].column.columnId,
            Predicates: [
                {
                    PredicateId: 'In',
                    Inputs: [
                        ...new Set(gridCells.map((gc)=>gc.displayValue))
                    ]
                }
            ]
        };
        const [savedFilter] = this.getColumnFilterApi().setColumnFilters([
            filter
        ]) || [
            null
        ];
        return savedFilter;
    }
    /**
     *  Creates an Equality Filter based on given Grid Cell
     * @param gridCell cell to create Filter for
     */ createEqualityColumnFilterForCell(gridCell) {
        if (!gridCell) return null;
        const column = gridCell.column;
        const filter = {
            ColumnId: column.columnId,
            Predicates: [
                {
                    PredicateId: this.getPredicateApi().internalApi.getEqualityPredicateForDataType(column.dataType),
                    Inputs: [
                        ...new Set([
                            gridCell.normalisedValue
                        ])
                    ]
                }
            ]
        };
        const [savedFilter] = this.getColumnFilterApi().setColumnFilters([
            filter
        ]) || [
            null
        ];
        return savedFilter;
    }
    /**
     * Calls AdapTableQL to evaluate Filter for given Row
     * @param columnFilter Column Filter to use
     * @param node Row Node to evaluate
     */ evaluateColumnFilter(columnFilter, node) {
        if (!columnFilter.Predicates.length) return true;
        const someInputsAreEmpty = columnFilter.Predicates.some((predicate)=>predicate.Inputs?.some((input)=>{
                if (typeof input === 'string') return (0, $9OAZF.default).IsNullOrEmpty(input);
                if (typeof input === 'number') return isNaN(input);
                return !input;
            }));
        if (someInputsAreEmpty) return true;
        const column = this.getColumnApi().getColumnWithColumnId(columnFilter.ColumnId);
        if (!column) return true;
        const gridCell = this.getGridApi().getGridCellFromRowNode(node, columnFilter.ColumnId);
        if (!gridCell) return true;
        const normalisedValue = gridCell.normalisedValue;
        const predicateDefHandlerContext = {
            value: normalisedValue,
            rawValue: gridCell.rawValue,
            oldValue: null,
            displayValue: gridCell.displayValue,
            node: node,
            column: column,
            predicatesOperator: columnFilter.PredicatesOperator,
            ...this.getAdaptableInternalApi().buildBaseContext()
        };
        //  #column_filter_predicates_evaluation
        return this.getPredicateApi().handlePredicates(columnFilter.Predicates, predicateDefHandlerContext, true);
    }
    /**
     * Checks if the filter action should trigger Column Filtering
     *
     * @param action Filtering Action
     */ shouldNewColumnFilterTriggerColumnFiltering(action) {
        // trigger filter change only:
        // - new -> new filter is active
        // - clear -> previous filters was active
        // - clearAll -> a filter was active
        // - edit -> same => input change
        // - edit -> different & new is active
        // - edit -> different & old was active
        // - set -> new filter is active
        // filter -> suspend changes
        const isNewAndActive = action.type === $2c155f3e4804e29e$export$dfb8d886fc62ddf9 && this.getColumnFilterApi().isColumnFilterActive(action.columnFilter);
        const isClearAndPreviousWasActive = action.type === $2c155f3e4804e29e$export$c16e7bdd1b4bf32c && this.getColumnFilterApi().isColumnFilterActiveForColumn(action.columnId);
        const isClearAllAtLeastOneActiveFilter = action.type === $2c155f3e4804e29e$export$15be0f58f317384 && this.getColumnFilterApi().getColumnFilters().some((columnFilter)=>this.getColumnFilterApi().isColumnFilterActive(columnFilter));
        let isEditTrigger = false;
        if (action.type === $2c155f3e4804e29e$export$e108c947785ca6ca) {
            const newFilter = action.columnFilter;
            const previous = this.getColumnFilterApi().getColumnFilterForColumn(newFilter.ColumnId);
            // same filter edit, so always trigger
            if (previous && newFilter && // same predicates
            (0, $9g4SS.areArraysEqual)(previous.Predicates.map((p)=>p.PredicateId), newFilter.Predicates.map((p)=>p.PredicateId))) isEditTrigger = true;
            else if (this.getColumnFilterApi().isColumnFilterActive(newFilter)) isEditTrigger = true;
            else if (this.getColumnFilterApi().isColumnFilterActive(previous)) // previous filter was active
            isEditTrigger = true;
        }
        const isSetAndActive = action.type === $2c155f3e4804e29e$export$d13e0ad82ad445b3 && this.getColumnFilterApi().isColumnFilterActive(action.columnFilter);
        const isSuspendChanged = [
            $2c155f3e4804e29e$export$56404215ee113fd,
            $2c155f3e4804e29e$export$e9f77efbaf88a239,
            $2c155f3e4804e29e$export$22f48e79a2003d4f,
            $2c155f3e4804e29e$export$82cd5ee5d79079a4
        ].includes(action.type);
        return isNewAndActive || isClearAndPreviousWasActive || isClearAllAtLeastOneActiveFilter || isEditTrigger || isSetAndActive || isSuspendChanged;
    }
    /**
     * Compares to sets of Column Filters to see if they are identical
     * @param filters1
     * @param filters2
     */ areColumnFiltersDifferent(oldFilters, newFilters) {
        if ((0, $9g4SS.default).IsNullOrEmpty(oldFilters) && (0, $9g4SS.default).IsNullOrEmpty(newFilters)) return false;
        return !(0, $9g4SS.default).areArraysEqualWithCustomComparator(oldFilters, newFilters, (filter1, filter2)=>{
            // Compare basic properties
            if (filter1.ColumnId !== filter2.ColumnId) return false;
            if ((filter1.PredicatesOperator || 'AND') !== (filter2.PredicatesOperator || 'AND')) return false;
            if ((filter1.IsSuspended || false) !== (filter2.IsSuspended || false)) return false;
            // Compare predicates (regardless of order)
            return (0, $9g4SS.default).areArraysEqualWithCustomComparator(filter1.Predicates, filter2.Predicates, (pred1, pred2)=>{
                if (pred1.PredicateId !== pred2.PredicateId) return false;
                // Compare inputs array (might be primitives or objects)
                return (0, $9g4SS.default).areArraysEqualWithCustomComparator(pred1.Inputs, pred2.Inputs, (input1, input2)=>{
                    if (input1 === input2) return true;
                    if (typeof input1 !== typeof input2) return false;
                    // For object inputs, use JSON comparison
                    if (typeof input1 === 'object' && input1 !== null && input2 !== null) return JSON.stringify(input1) === JSON.stringify(input2);
                    return input1 === input2;
                });
            });
        });
    }
    getPredicateDefShortcuts(predicateDef) {
        const shortcuts = this.getFilterOptions().columnFilterOptions.quickFilterWildcards;
        let predicateShortcuts = predicateDef.shortcuts;
        const predicateId = predicateDef.id;
        if (shortcuts?.[predicateId] && Array.isArray(shortcuts[predicateId])) predicateShortcuts = shortcuts[predicateId];
        return predicateShortcuts;
    }
    showQuickFilterDropdown(columnId) {
        const hideQuickFilterDropdownFunction = this.getFilterOptions().columnFilterOptions.hideQuickFilterDropdown;
        if (hideQuickFilterDropdownFunction) {
            const column = this.getColumnApi().getColumnWithColumnId(columnId);
            const columnColumnContext = {
                column: column,
                ...this.getAdaptableInternalApi().buildBaseContext()
            };
            return !hideQuickFilterDropdownFunction(columnColumnContext);
        }
        return true;
    }
    openColumnFilterPopup(columnId, popupProps) {
        this.getAdaptableInternalApi().showPopupWindow({
            id: (0, $226a20b901481288$export$d423fc3beda7048e),
            title: $42e863194fcb493f$export$482638e9e23a2018,
            icon: 'filter',
            factoryId: (0, $226a20b901481288$export$d423fc3beda7048e),
            popupProps: {
                value: columnId,
                size: {
                    width: 380,
                    height: 450
                },
                ...popupProps
            }
        });
    }
    /**
     * First we try to get the cached values from the FilterHandler
     * Only if the FilterHandler is not available we fallback to the GridApi method
     */ async getColumnFilterValues(options) {
        const filterOptions = this.getOptionsApi().getFilterOptions();
        const newOptions = {
            columnId: options.columnId,
            get currentSearchValue () {
                // we need this in order to keep it lazy
                return options.currentSearchValue;
            },
            previousResult: undefined
        };
        const columnFilterHandler = this.getAgGridApi().getColumnFilterHandler(options.columnId);
        if (!columnFilterHandler) {
            this.logWarn(`No ColumnFilterHandler found for columnId: ${options.columnId}!`);
            return this.getGridApi().internalApi.getDistinctFilterDisplayValuesForColumn(newOptions);
        }
        if (typeof columnFilterHandler.getFromCacheOrFetchFilterDisplayValues !== 'function') {
            this.logWarn(`ColumnFilterHandler for columnId: ${options.columnId} does not have getFromCacheOrFetchFilterDisplayValues method!`);
            return this.getGridApi().internalApi.getDistinctFilterDisplayValuesForColumn(newOptions);
        }
        if (filterOptions.customInFilterValues) return columnFilterHandler.fetchFilterDisplayValues(newOptions);
        return columnFilterHandler.getFromCacheOrFetchFilterDisplayValues(newOptions);
    }
    shouldManuallyApplyColumnFilter(columnId) {
        const manuallyApplyColumnFilterOpt = this.getOptionsApi().getFilterOptions().columnFilterOptions?.manuallyApplyColumnFilter;
        if (typeof manuallyApplyColumnFilterOpt === 'boolean') return manuallyApplyColumnFilterOpt;
        if (typeof manuallyApplyColumnFilterOpt === 'function') {
            const column = this.getColumnApi().getColumnWithColumnId(columnId);
            const context = {
                column: column,
                ...this.getAdaptableApi().internalApi.buildBaseContext()
            };
            return manuallyApplyColumnFilterOpt(context);
        }
        // fallback, should never happen
        return false;
    }
    getAdaptableFilterHandler(columnId) {
        return this.getAgGridApi().getColumnFilterHandler(columnId);
    }
    getAllAdaptableFilterHandlers() {
        const allFilterableColumns = this.getColumnApi().getFilterableColumns();
        const filterHandlers = allFilterableColumns.map((column)=>this.getAgGridApi().getColumnFilterHandler(column.columnId)).filter(Boolean).filter((handler)=>handler instanceof (0, $a23991341724d458$export$e706c937f1e8c12d));
        return filterHandlers;
    }
}



var $9OAZF = parcelRequire("9OAZF");
class $9e1a1407751456fe$export$d7bbe9a9c750bc8e extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $b505c69e4fc10a23$export$2b26b5b6782c3ac5)(_adaptable);
    }
    getFilterPredicateDefsForColumn(column) {
        if (!column) return [];
        const scope = {
            ColumnIds: [
                column.columnId
            ]
        };
        return this.getAdaptableApi().predicateApi.internalApi.getFilterPredicateDefs(scope).filter((predicate)=>this.getColumnScopeApi().isColumnInScope(column, predicate.columnScope));
    }
    getFilterPredicateDefsForColumnId(columnId) {
        const column = this.getColumnApi().getColumnWithColumnId(columnId);
        return column ? this.getFilterPredicateDefsForColumn(column) : undefined;
    }
    showQuickFilterBar() {
        this.dispatchAction($5b564bb703f29152$export$c8d88f519547e598());
    }
    hideQuickFilterBar() {
        this.dispatchAction($5b564bb703f29152$export$bffa6555fdf75754());
    }
    isQuickFilterAvailable() {
        return this._adaptable.isQuickFilterAvailable();
    }
    isQuickFilterVisible() {
        return this.isQuickFilterAvailable() && this.getAdaptableInternalApi().getInternalState().IsQuickFilterVisible;
    }
    getColumnFilters() {
        const currentLayout = this.getLayoutApi().getCurrentLayout();
        return currentLayout.ColumnFilters ?? [];
    }
    getActiveColumnFilters() {
        return this.getColumnFilters().filter((columnFilter)=>!columnFilter.IsSuspended);
    }
    getColumnFilterDefs() {
        const filters = this.getColumnFilters();
        return filters.map((columnFilter)=>{
            const column = this.getColumnApi().getColumnWithColumnId(columnFilter.ColumnId);
            const predicates = columnFilter.Predicates.map((predicate)=>this.getPredicateApi().getPredicateDefById(predicate.PredicateId));
            return {
                predicates: predicates,
                dataType: column?.dataType,
                columnFilter: columnFilter
            };
        });
    }
    getColumnFiltersForLayout(layoutName) {
        const layout = this.getLayoutApi().getLayoutByName(layoutName);
        return layout.ColumnFilters ?? [];
    }
    setColumnFilters(columnFilters) {
        columnFilters.forEach((columnFilter)=>{
            if (!columnFilter.Predicates || columnFilter.Predicates.length == 0) this.logWarn('Column Filter has no Predicate', columnFilter);
            else {
                const isValidPredicate = this.getPredicateApi().isEveryPredicateValid(columnFilter.Predicates);
                if (!isValidPredicate) this.logWarn('Column Filter Predicate is not valid', columnFilter);
                else {
                    this.addUidToAdaptableObject(columnFilter);
                    if (this.getColumnFilters().find((cf)=>cf.ColumnId == columnFilter.ColumnId)) this.dispatchAction($2c155f3e4804e29e$export$da8b6ee930ff5718(columnFilter));
                    else this.dispatchAction($2c155f3e4804e29e$export$89469bfff4112a24(columnFilter));
                }
            }
        });
        return columnFilters?.map((columnFilter)=>this.getColumnFilterById(columnFilter.Uuid)).filter(Boolean);
    }
    clearColumnFilter(columnFilter) {
        this.dispatchAction($2c155f3e4804e29e$export$171768c99fee2ba3(columnFilter.ColumnId));
    }
    clearColumnFiltersForColumns(columns) {
        columns.forEach((c)=>{
            this.clearColumnFilterForColumn(c);
        });
    }
    getColumnFilterForColumn(columnId) {
        return this.getColumnFilters().find((columnFilter)=>columnFilter.ColumnId === columnId);
    }
    clearColumnFilterForColumn(columnId) {
        let columnFilterForColumn = this.getColumnFilterForColumn(columnId);
        if (columnFilterForColumn) {
            this.dispatchAction($2c155f3e4804e29e$export$171768c99fee2ba3(columnFilterForColumn.ColumnId));
            this._adaptable.clearColumnFilteringForColumns([
                columnId
            ]);
        }
    }
    clearColumnFilters() {
        this.dispatchAction($2c155f3e4804e29e$export$d5958280d3901be2());
        this._adaptable.clearColumnFiltering();
    }
    clearAndSetColumnFilters(columnFilters) {
        this.clearColumnFilters();
        this.setColumnFilters(columnFilters);
    }
    columnFilterToString(columnFilter) {
        if (columnFilter == null) return 'No Column Filter';
        const friendlyName = this.getColumnApi().getFriendlyNameForColumnId(columnFilter.ColumnId);
        return '[' + friendlyName + '] ' + this.getPredicateApi().predicatesToString(columnFilter.Predicates, columnFilter.PredicatesOperator);
    }
    columnFiltersToString(columnFilters) {
        return columnFilters.map((cf)=>this.columnFilterToString(cf)).join(', ');
    }
    getColumnFilterById(id) {
        return this.getColumnFilters()?.find((columnFilter)=>columnFilter.Uuid === id);
    }
    isColumnFilterActiveForColumn(columnId) {
        const columnFilter = this.getColumnFilterForColumn(columnId);
        return columnFilter ? this.isColumnFilterActive(columnFilter) : false;
    }
    /**
     * Checks if a filter is applied. It is applied when:
     * - has no inputs
     * - has inputs and inputs have values
     *
     * @param filter
     */ isColumnFilterActive(filter) {
        if (!filter || !filter.Predicates?.length) return false;
        if (filter.IsSuspended) return false;
        return filter.Predicates.some((predicate)=>{
            const predicateDef = this.getPredicateApi().getPredicateDefById(predicate.PredicateId);
            if ((0, $9g4SS.default).IsNull(predicateDef.inputs) && // In and NotIn predicates ave no inputs in the definition
            !this.getPredicateApi().internalApi.IsInOrNotInPredicate(predicate)) return true;
            const inputs = predicate.Inputs || [];
            if ((0, $9g4SS.default).IsEmpty(inputs)) return false;
            // all values in the array need to be non-empty (e.g. between has two values, [min, max])
            const allInputsHaveValues = inputs.every((value)=>{
                return value !== undefined && value !== null && value !== '';
            });
            return allInputsHaveValues;
        });
    }
    setColumnFilterForColumn(columnId, columnFilterPredicate) {
        const columnFilter = {
            ColumnId: columnId,
            Predicates: [
                columnFilterPredicate
            ]
        };
        this.setColumnFilters([
            columnFilter
        ]);
    }
    clearAndSetColumnFilterForColumn(columnId, columnFilterPredicate) {
        const columnFilter = {
            ColumnId: columnId,
            Predicates: [
                columnFilterPredicate
            ]
        };
        this.setColumnFilters([
            columnFilter
        ]);
    }
    suspendColumnFilter(columnFilter) {
        this.dispatchAction($2c155f3e4804e29e$export$6e8f0e06fbedf782(columnFilter));
    }
    unSuspendColumnFilter(columnFilter) {
        this.dispatchAction($2c155f3e4804e29e$export$312f8e656419ed01(columnFilter));
    }
    suspendAllColumnFilters() {
        this.dispatchAction($2c155f3e4804e29e$export$23028bf9d635e89c());
    }
    unSuspendAllColumnFilters() {
        this.dispatchAction($2c155f3e4804e29e$export$3f36c0aabf72f1d2());
    }
    addBlanksToInFilterValues(columnDistinctValues) {
        if (columnDistinctValues.some((item)=>(0, $9OAZF.default).IsNullOrEmpty(item.value))) return [
            {
                label: 'Blanks',
                value: 'Blanks'
            },
            ...columnDistinctValues
        ];
        return columnDistinctValues;
    }
    async refreshFilterValues(columnId) {
        const columnFilterHandler = this.getAgGridApi().getColumnFilterHandler(columnId);
        if (!columnFilterHandler || typeof columnFilterHandler.resetFilterDisplayValues !== 'function') {
            this.logWarn(`No filter handler found for column: ${columnId}`);
            return;
        }
        this.logInfo(`Refreshing filter values for column: ${columnId}`);
        return columnFilterHandler.refreshFilterDisplayValues();
    }
    async refreshAllFilterValues() {
        const allFilterHandlers = this.internalApi.getAllAdaptableFilterHandlers();
        const handlerPromises = allFilterHandlers.map(async (handler)=>{
            let result = {
                values: []
            };
            if (typeof handler.refreshFilterDisplayValues === 'function') result = await handler.refreshFilterDisplayValues();
            else {
                this.logWarn(`No refresh function for filter handler: ${handler.colId}`);
                result = {
                    values: []
                };
            }
            return {
                columnId: handler.colId,
                result: result
            };
        });
        return Promise.all(handlerPromises).then((results)=>{
            return results.reduce((acc, { columnId: columnId, result: result })=>{
                acc[columnId] = result;
                return acc;
            }, {});
        });
    }
    resetFilterValues(columnId) {
        const columnFilterHandler = this.getAgGridApi().getColumnFilterHandler(columnId);
        if (!columnFilterHandler || typeof columnFilterHandler.resetFilterDisplayValues !== 'function') {
            this.logWarn(`No filter handler found for column: ${columnId}`);
            return;
        }
        columnFilterHandler.resetFilterDisplayValues();
    }
    resetAllFilterValues() {
        const allFilterHandlers = this.internalApi.getAllAdaptableFilterHandlers();
        allFilterHandlers.forEach((handler)=>{
            if (typeof handler.resetFilterDisplayValues === 'function') handler.resetFilterDisplayValues();
            else this.logWarn(`No reset function for filter handler: ${handler.colId}`);
        });
    }
}





class $38cfcf33661899d5$export$aa40022bdacb32dc extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    /**
     * Compares to Grid Filter to see if they are identical
     */ isGridFilterDifferent(oldFilter, newFilter) {
        if (oldFilter == undefined && newFilter == undefined) return false;
        return oldFilter?.Expression !== newFilter?.Expression;
    }
}




class $6c53a11fa6b1593c$export$e51cb24518b59e0c extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $38cfcf33661899d5$export$aa40022bdacb32dc)(_adaptable);
    }
    reApplyGridFilter() {
        const currentGridFilter = this.getCurrentGridFilter();
        if (currentGridFilter?.Expression) this.setGridFilterExpression(currentGridFilter.Expression);
    }
    getCurrentGridFilter() {
        return this.getLayoutApi().getCurrentLayout()?.GridFilter;
    }
    getCurrentGridFilterExpression() {
        const gridFilter = this.getCurrentGridFilter();
        if (!gridFilter || gridFilter.IsSuspended) return '';
        return gridFilter.Expression;
    }
    setGridFilterExpression(filter) {
        this.dispatchAction($2c155f3e4804e29e$export$f079a5ac2c234fd(filter));
    }
    setGridFilterExpressionUsingNamedQuery(namedQuery) {
        const expressionString = 'QUERY("' + namedQuery.Name + '")';
        this.setGridFilterExpression(expressionString);
    }
    clearGridFilter() {
        this.dispatchAction($2c155f3e4804e29e$export$4ef493dc34f0b0bd());
    }
    openUIEditorForGridFilter(expression) {
        const preparedQuery = expression ?? this.getCurrentGridFilterExpression();
        this.getAdaptableInternalApi().showPopupWindow({
            id: (0, $226a20b901481288$export$24d2a830caa0078a),
            title: $42e863194fcb493f$export$e3b58083525a6d40,
            icon: 'filter-list',
            factoryId: (0, $226a20b901481288$export$24d2a830caa0078a),
            popupProps: {
                value: preparedQuery
            }
        });
    }
    suspendGridFilter() {
        const gridFilter = this.getCurrentGridFilter();
        if (gridFilter && !gridFilter.IsSuspended) this.dispatchAction($2c155f3e4804e29e$export$4398634f52771b1c());
    }
    unSuspendGridFilter() {
        const gridFilter = this.getCurrentGridFilter();
        if (gridFilter && gridFilter.IsSuspended) this.dispatchAction($2c155f3e4804e29e$export$3024cdbf089cb117());
    }
}


class $6833626b5fe7962d$export$e2d07065b511613 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    columnFilterApi;
    gridFilterApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $9a265e898c06bcdb$export$83c13bce9c99e009)(_adaptable);
        this.columnFilterApi = new (0, $9e1a1407751456fe$export$d7bbe9a9c750bc8e)(_adaptable);
        this.gridFilterApi = new (0, $6c53a11fa6b1593c$export$e51cb24518b59e0c)(_adaptable);
    }
    clearAllFilters() {
        this.columnFilterApi.clearColumnFilters();
        this.gridFilterApi.clearGridFilter();
    }
}




class $2fdda7d9ed571721$export$ce18c9acbe9273e0 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    // Row Form Methods
    buildRowEditForm(rowNode) {
        return this.buildRowForm('rowEdited', rowNode);
    }
    buildRowCreateForm(clonedRowNode) {
        return this.buildRowForm('rowCreated', clonedRowNode);
    }
    buildRowForm(type, rowNode) {
        const formFields = this.buildRowFormFields(type, rowNode);
        const formButtons = this.buidRowFormButtons(type, rowNode, formFields);
        const formTitle = this.getFormTitle(type, rowNode);
        const formDescription = this.getFormDescription(type, rowNode);
        const rowForm = {
            title: formTitle,
            description: formDescription,
            fields: formFields,
            buttons: formButtons
        };
        return rowForm;
    }
    getFormTitle(type, rowNode) {
        const rowFormOptions = this.getRowFormOptions();
        if (rowFormOptions.rowFormTitle == undefined) return type === 'rowCreated' ? 'Create New Row' : 'Edit Row';
        return typeof rowFormOptions.rowFormTitle === 'function' ? rowFormOptions.rowFormTitle(this.buildFormParamContext(type, rowNode)) : rowFormOptions.rowFormTitle;
    }
    buildFormParamContext(type, rowNode) {
        return {
            rowNode: rowNode,
            ...this.getAdaptableInternalApi().buildBaseContext(),
            type: type
        };
    }
    getFormDescription(type, rowNode) {
        const rowFormOptions = this.getRowFormOptions();
        return typeof rowFormOptions.rowFormDescription === 'function' ? rowFormOptions.rowFormDescription(this.buildFormParamContext(type, rowNode)) : rowFormOptions.rowFormDescription;
    }
    buidRowFormButtons(type, rowNode, formFields) {
        // 1. check if there are custom user provided buttons
        if (Array.isArray(this.getRowFormOptions().rowFormButtons)) return this.getRowFormOptions().rowFormButtons;
        // 2. else return the standard ones
        const cancelButton = {
            label: 'Cancel',
            buttonStyle: {
                variant: 'raised',
                tone: 'neutral'
            }
        };
        const saveButton = {
            label: 'Save',
            buttonStyle: {
                variant: 'raised',
                tone: 'success'
            },
            onClick: (button, context)=>{
                // textOutput should not be saved, their values are set to display values
                // we need to filter out the textOutput fields and add the primaryKey
                const eventInfo = type === 'rowCreated' ? {
                    type: 'rowCreated',
                    formData: this.prepareCreateData(formFields, context),
                    ...this.getAdaptableInternalApi().buildBaseContext(),
                    clonedRowNode: rowNode
                } : {
                    type: 'rowEdited',
                    formData: this.prepareEditData(formFields, context),
                    rowNode: rowNode,
                    ...this.getAdaptableInternalApi().buildBaseContext()
                };
                this.getEventApi().internalApi.fireRowFormSubmittedEvent(eventInfo);
                this.getRowFormOptions()?.onRowFormSubmit?.(eventInfo);
            }
        };
        return [
            cancelButton,
            saveButton
        ];
    }
    prepareCreateData(formFields, context) {
        // when creating we just omit values that are not set
        const dataToSave = {
            ...context.formData
        };
        for (const formField of formFields)if (dataToSave[formField.name] === '') delete dataToSave[formField.name];
        return dataToSave;
    }
    prepareEditData(formFields, context) {
        const dataToSave = {
            ...context.formData
        };
        for (const formField of formFields)if (formField.fieldType === 'textOutput') delete dataToSave[formField.name];
        const pkValue = this.getGridApi().getPrimaryKeyValueForRowNode(context.rowNode);
        dataToSave[this.getOptions().primaryKey] = pkValue;
        return dataToSave;
    }
    buildRowFormFields(rowFormType, rowNode) {
        const relevantColumns = this.getColumnApi().getUIAvailableColumns().filter((column)=>{
            // if there is NO rowNode, do NOT display the non-editable fields as they will be empty
            return !!rowNode || this.isCellEditable(column, rowNode);
        }).filter((column)=>this.showColumnInRowForm(column, rowFormType));
        return relevantColumns.map((column)=>this.buildRowFormField(rowFormType, column, rowNode));
    }
    showColumnInRowForm(adaptableColumn, rowFormType) {
        if (adaptableColumn.isActionColumn) return false;
        const showColumnFn = this.getRowFormOptions()?.includeColumnInRowForm;
        if (typeof showColumnFn === 'function') return showColumnFn({
            ...this.getAdaptableInternalApi().buildBaseContext(),
            adaptableColumn: adaptableColumn,
            rowFormType: rowFormType
        });
        return true;
    }
    isCellEditable(column, rowNode) {
        if (!rowNode) return !column.readOnly;
        const gridCell = this.getGridApi().getGridCellFromRowNode(rowNode, column.columnId);
        return this.getGridApi().isCellEditable(gridCell);
    }
    buildRowFormField(type, column, rowNode) {
        const isCellEditable = this.isCellEditable(column, rowNode);
        const fieldValueOptions = this.getFieldValueOptions(column, rowNode);
        const fieldType = isCellEditable ? !!fieldValueOptions?.length ? 'select' : this.getFieldTypeFromColumnType(column) : 'textOutput';
        const defaultValue = rowNode ? isCellEditable ? this.getGridApi().getRawValueFromRowNode(rowNode, column.columnId) : this.getGridApi().getDisplayValueFromRowNode(rowNode, column.columnId) : null;
        return {
            label: this.getRowFormFieldLabel(type, column, rowNode),
            name: column.columnId,
            defaultValue: defaultValue,
            fieldType: fieldType,
            options: fieldValueOptions
        };
    }
    getRowFormFieldLabel(type, column, rowNode) {
        const customFieldLabel = typeof this.getRowFormOptions().rowFormFieldLabel === 'function' ? this.getRowFormOptions().rowFormFieldLabel(this.buildFormFieldLabelContext(type, column, rowNode)) : undefined;
        return customFieldLabel ?? column.friendlyName;
    }
    buildFormFieldLabelContext(type, column, rowNode) {
        return {
            rowNode: rowNode,
            column: column,
            ...this.getAdaptableInternalApi().buildBaseContext(),
            type: type
        };
    }
    getFieldTypeFromColumnType(column) {
        switch(column.dataType){
            case 'boolean':
                return 'checkbox';
            case 'date':
                return 'date';
            case 'number':
                return 'number';
            default:
                // everything else is a plain text input
                return 'text';
        }
    }
    getFieldValueOptions(column, rowNode) {
        const shouldShowSelectCellEditor = this.getUserInterfaceApi().internalApi.shouldShowSelectCellEditor(column);
        if (!shouldShowSelectCellEditor) return;
        const returnValues = this.getGridApi().internalApi.getDistinctDisplayValuesForColumnOld(column.columnId);
        // FIXME add support for asynchronous custom select cell editor values
        // it involves refactoring the AdaptableForm & adaptableFormComponent
        // await this.getSelectCellEditorValuesForColumn(
        //   column,
        //   gridCell
        // );
        return returnValues?.map((value)=>({
                value: value,
                label: value
            }));
    }
}



class $6416783fe0659762$export$3f1a0738417b3534 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    internalApi;
    constructor(_adaptable){
        super(_adaptable);
        this.internalApi = new (0, $2fdda7d9ed571721$export$ce18c9acbe9273e0)(_adaptable);
    }
    displayEditRowForm(primaryKey) {
        const rowNode = this.getGridApi().getRowNodeForPrimaryKey(primaryKey);
        if (!rowNode) this.logWarn(`Cannot edit row: rowNode not found for primaryKey ${primaryKey}`);
        const editForm = this.internalApi.buildRowEditForm(rowNode);
        this.dispatchAction((0, $dc56b6267ce4d0bb$export$16bbb31452c12825)({
            Id: 'edit_row_form',
            Form: editForm,
            // formProps are added to the formContext
            FormProps: {
                rowNode: rowNode
            }
        }));
    }
    displayCreateRowForm() {
        const createForm = this.internalApi.buildRowCreateForm();
        this.dispatchAction((0, $dc56b6267ce4d0bb$export$16bbb31452c12825)({
            Id: 'create_row_form',
            Form: createForm
        }));
    }
    displayCloneRowForm(primaryKey) {
        const rowNode = this.getGridApi().getRowNodeForPrimaryKey(primaryKey);
        if (!rowNode) this.logWarn(`Can NOT clone row: rowNode not found for primaryKey ${primaryKey}`);
        const createForm = this.internalApi.buildRowCreateForm(rowNode);
        this.dispatchAction((0, $dc56b6267ce4d0bb$export$16bbb31452c12825)({
            Id: 'create_row_form',
            Form: createForm,
            // formProps are added to the formContext
            FormProps: {
                clonedRowNode: rowNode
            }
        }));
    }
    displayDeleteRowForm(primaryKey) {
        const rowNode = this.getGridApi().getRowNodeForPrimaryKey(primaryKey);
        if (!rowNode) this.logWarn(`Can NOT delete row: rowNode not found for primaryKey ${primaryKey}`);
        const eventInfo = {
            type: 'rowDeleted',
            rowNode: rowNode,
            ...this.getAdaptableInternalApi().buildBaseContext()
        };
        this.getEventApi().internalApi.fireRowFormSubmittedEvent(eventInfo);
        this.getRowFormOptions().onRowFormSubmit?.(eventInfo);
    }
}


class $817f0462ed83c088$export$7b1465d94b24e17c {
    adaptable;
    internalApi;
    optionsApi;
    actionColumnApi;
    applicationApi;
    alertApi;
    flashingCellApi;
    predicateApi;
    bulkUpdateApi;
    calendarApi;
    calculatedColumnApi;
    cellSummaryApi;
    columnApi;
    stateApi;
    customSortApi;
    dashboardApi;
    dataSetApi;
    entitlementApi;
    eventApi;
    exportApi;
    formatColumnApi;
    freeTextColumnApi;
    gridApi;
    layoutApi;
    plusMinusApi;
    quickSearchApi;
    rowFormApi;
    scheduleApi;
    shortcutApi;
    smartEditApi;
    filterApi;
    systemStatusApi;
    pluginsApi;
    themeApi;
    userInterfaceApi;
    expressionApi;
    settingsPanelApi;
    styledColumnApi;
    toolPanelApi;
    teamSharingApi;
    columnScopeApi;
    dataChangeHistoryApi;
    chartingApi;
    statusBarApi;
    noteApi;
    columnMenuApi;
    contextMenuApi;
    fdc3Api;
    dataImportApi;
    namedQueryApi;
    commentApi;
    destroyed;
    constructor(adaptable){
        this.adaptable = adaptable;
        this.destroyed = false;
        this.adaptable = adaptable;
        this.optionsApi = new (0, $3866793aa54782fb$export$a59b55d19d8398c6)(adaptable);
        this.actionColumnApi = new (0, $7cdbced582e081be$export$ae5ba1f8f2042657)(adaptable);
        this.applicationApi = new (0, $99e6394056d7eae3$export$b157d1e4821272f7)(adaptable);
        this.alertApi = new (0, $cca338f4714182be$export$1b944a52396315fe)(adaptable);
        this.flashingCellApi = new (0, $8f4ab2136441a99d$export$813f6ac80564bd19)(adaptable);
        this.predicateApi = new (0, $4d3ef767231dfbdc$export$25ea6ba48f88e141)(adaptable);
        this.pluginsApi = new (0, $7b6203c7655ccb91$export$957405a3b3e4bdc6)(adaptable);
        this.bulkUpdateApi = new (0, $e29a926c2762f446$export$67aca8533a32e090)(adaptable);
        this.calendarApi = new (0, $b8a643437f1a9f0c$export$5032a4bae1ffb805)(adaptable);
        this.calculatedColumnApi = new (0, $e385f9c6f09822fb$export$5f337f2322cda760)(adaptable);
        this.cellSummaryApi = new (0, $4b169038104877df$export$a0ef4a07d4fe454)(adaptable);
        this.columnApi = new (0, $49746e7bf2cf87d5$export$3c91042823dcf745)(adaptable);
        this.columnMenuApi = new (0, $4aee8b0b36aae84c$export$4f114e54dff3c9c7)(adaptable);
        this.contextMenuApi = new (0, $6ba1dca98b59bc78$export$b80b3864e6b6ee42)(adaptable);
        this.stateApi = new (0, $6362559a9efecb99$export$2de0c89ef75866dc)(adaptable);
        this.customSortApi = new (0, $786030feb0fac184$export$daae63932bb51652)(adaptable);
        this.dashboardApi = new (0, $d17adba74fbea2cb$export$c6bc7927c6b7b46d)(adaptable);
        this.dataSetApi = new (0, $036d2bff52772e1d$export$6352b8c501c22109)(adaptable);
        this.entitlementApi = new (0, $664525c1a78dd067$export$7cec8b79960070af)(adaptable);
        this.eventApi = new (0, $ab48c9edef6872b7$export$b8189126653a4626)(adaptable);
        this.exportApi = new (0, $f4688e90f61e3b27$export$3c545db55c640dbd)(adaptable);
        this.formatColumnApi = new (0, $147b3ae9f718efe8$export$5b73a81d83fa68db)(adaptable);
        this.freeTextColumnApi = new (0, $cd0efe97966e4d02$export$8b647f20721765b8)(adaptable);
        this.gridApi = new (0, $c5535a4c21cd8803$export$6da74e60dcaba63)(adaptable);
        this.layoutApi = new (0, $2812955cc66c9b1e$export$20c7b432cfa5d246)(adaptable);
        this.plusMinusApi = new (0, $af8902136581dfaa$export$c778fae82800158b)(adaptable);
        this.quickSearchApi = new (0, $7e5f6852810dc25d$export$6dc886cb7f15fda5)(adaptable);
        this.rowFormApi = new (0, $6416783fe0659762$export$3f1a0738417b3534)(adaptable);
        this.scheduleApi = new (0, $ef13b79f080a66e1$export$6e9529d65cb529f4)(adaptable);
        this.shortcutApi = new (0, $c0ff6ba949be26a9$export$57d47f570df63072)(adaptable);
        this.smartEditApi = new (0, $14f28fb4d8e440fa$export$bebbed181493d9cf)(adaptable);
        this.systemStatusApi = new (0, $b7be6d55f427f5bc$export$c875cb61a2bb358d)(adaptable);
        this.settingsPanelApi = new (0, $6effc0d621f895cf$export$438eb92e8494362f)(adaptable);
        this.themeApi = new (0, $c79b7a5583d9bf24$export$4a63af7049108867)(adaptable);
        this.userInterfaceApi = new (0, $91a342c36d00e454$export$72bda8dd8aa6377)(adaptable);
        this.namedQueryApi = new (0, $6957be111b05b666$export$4c5eb70a6fb4cfb8)(adaptable);
        this.expressionApi = new (0, $f49d62d4234d0e38$export$a2f359658d079d3d)(adaptable);
        this.styledColumnApi = new (0, $665789c2c1f7eabf$export$6dd6f6d80a5a8c88)(adaptable);
        this.toolPanelApi = new (0, $4068677b5806fc16$export$c58ff0365b9e9dde)(adaptable);
        this.teamSharingApi = new (0, $78c3545eba2a27ab$export$a30f18fd28be459b)(adaptable);
        this.columnScopeApi = new (0, $e93500a4446aed1f$export$7eaf8713ae9c5108)(adaptable);
        this.dataChangeHistoryApi = new (0, $57f6bf4ff57dbb4b$export$14e4317417d66053)(adaptable);
        this.chartingApi = new (0, $c0b6748b980d4838$export$aa8f36dabaa4041c)(adaptable);
        this.statusBarApi = new (0, $468a3cf3cee6b319$export$c47e5ee10600a731)(adaptable);
        this.noteApi = new (0, $da508fccc09992a1$export$44763b2263c3d96f)(adaptable);
        this.fdc3Api = new (0, $6d093119220e2a11$export$e3683139a98dce74)(adaptable);
        this.dataImportApi = new (0, $6962baf54aa53242$export$38cf1851293b0f57)(adaptable);
        this.filterApi = new (0, $6833626b5fe7962d$export$e2d07065b511613)(adaptable);
        this.commentApi = new (0, $ced015b08bd92823$export$1d127f5a7b018129)(adaptable);
        // adaptable internal api
        this.internalApi = new (0, $2e20dd0f0d571640$export$372d1f4026fcfc66)(adaptable);
    }
    get agGridApi() {
        return this.adaptable?.agGridAdapter?.getAgGridApi();
    }
    /**
     * This is only meant to be called by the Adaptable instance.
     */ _internalDestroySelf() {
        if (this.destroyed) return;
        this.destroyed = true;
        this.eventApi.destroy();
        this.exportApi.internalApi.destroy();
        this.internalApi = null;
        this.adaptable = null;
        this.optionsApi = null;
        this.alertApi = null;
        this.applicationApi = null;
        this.bulkUpdateApi = null;
        this.calculatedColumnApi = null;
        this.cellSummaryApi = null;
        this.chartingApi = null;
        this.columnApi = null;
        this.stateApi = null;
        this.customSortApi = null;
        this.dashboardApi = null;
        this.dataChangeHistoryApi = null;
        this.dataSetApi = null;
        this.eventApi = null;
        this.exportApi = null;
        this.columnApi = null;
        this.namedQueryApi = null;
        this.flashingCellApi = null;
        this.formatColumnApi = null;
        this.freeTextColumnApi = null;
        this.gridApi = null;
        this.rowFormApi = null;
        this.internalApi = null;
        this.layoutApi = null;
        this.pluginsApi = null;
        this.plusMinusApi = null;
        this.predicateApi = null;
        this.expressionApi = null;
        this.quickSearchApi = null;
        this.scheduleApi = null;
        this.columnScopeApi = null;
        this.settingsPanelApi = null;
        this.shortcutApi = null;
        this.smartEditApi = null;
        this.statusBarApi = null;
        this.systemStatusApi = null;
        this.teamSharingApi = null;
        this.themeApi = null;
        this.toolPanelApi = null;
        this.userInterfaceApi = null;
        this.fdc3Api = null;
        this.actionColumnApi = null;
        this.calendarApi = null;
        this.filterApi = null;
        this.columnMenuApi = null;
        this.commentApi = null;
        this.contextMenuApi = null;
        this.dataImportApi = null;
        this.entitlementApi = null;
        this.noteApi = null;
        this.styledColumnApi = null;
    }
    destroy(config) {
        this.adaptable.destroy(config);
    }
    isDestroyed() {
        return this.destroyed;
    }
    logConsoleMessage(message, ...optionalParams) {
        this.adaptable.logger.consoleLog(message, optionalParams);
    }
    logInfo(message, ...optionalParams) {
        this.adaptable.logger.info(message, optionalParams);
    }
    logSuccess(message, ...optionalParams) {
        this.adaptable.logger.success(message, optionalParams);
    }
    logWarn(message, ...optionalParams) {
        this.adaptable.logger.warn(message, optionalParams);
    }
    logError(message, ...optionalParams) {
        this.adaptable.logger.error(message, optionalParams);
    }
    consoleLog(message, ...optionalParams) {
        this.adaptable.logger.consoleLog(message, optionalParams);
    }
    consoleError(message, ...optionalParams) {
        this.adaptable.logger.consoleError(message, optionalParams);
    }
    consoleWarn(message, ...optionalParams) {
        this.adaptable.logger.consoleWarn(message, optionalParams);
    }
}



const $67c38c07b3125913$export$aa788b607096dc19 = {
    CreateInteraction: {
        icon: 'sync'
    },
    SendChatMessage: {
        icon: 'chat'
    },
    StartCall: {
        icon: 'call'
    },
    StartChat: {
        icon: 'chat'
    },
    StartEmail: {
        icon: 'mail'
    },
    ViewAnalysis: {
        icon: 'spark-line'
    },
    ViewChat: {
        icon: 'chat'
    },
    ViewChart: {
        icon: 'pie-chart'
    },
    ViewContact: {
        icon: 'person'
    },
    ViewHoldings: {
        icon: 'building'
    },
    ViewInstrument: {
        icon: 'money'
    },
    ViewInteractions: {
        icon: 'interactions'
    },
    ViewMessages: {
        icon: 'mail'
    },
    ViewNews: {
        icon: 'news'
    },
    ViewOrders: {
        icon: 'order'
    },
    ViewProfile: {
        icon: 'badge'
    },
    ViewQuote: {
        icon: 'quote'
    },
    ViewResearch: {
        icon: 'science'
    }
};


class $434e1eb25d78d3e3$export$ef0666579ee49e99 {
    adaptableApi;
    contextHandlerSubscriptions = [];
    intentHandlerSubscriptions = [];
    loggedAgentError = false;
    uiControlsDefaultConfiguration;
    constructor(adaptableApi){
        this.adaptableApi = adaptableApi;
        // 1. Subscribe to FDC3 events
        const adaptableHandleIntentFn = this.getFdc3Options().intents?.handleIntent;
        const listenForIntents = this.getFdc3Options().intents?.listensFor ?? [];
        if (listenForIntents.length) {
            if (!adaptableHandleIntentFn) this.adaptableApi.logError(`Following FDC3 Intent Listener(s) have been provided but no 'handleIntent' function has been supplied in the FDC3 Options`, listenForIntents);
            listenForIntents.forEach((intent)=>{
                this.adaptableApi.logInfo(`Listening for FDC3 Intent: ${intent}`);
                this.getDesktopAgent()?.addIntentListener(intent, (context, metadata)=>{
                    this.logFdc3Event('IN', `Intent`, JSON.stringify(context));
                    const fnContext = {
                        ...this.adaptableApi.internalApi.buildBaseContext(),
                        context: context,
                        intent: intent,
                        metadata: metadata
                    };
                    adaptableHandleIntentFn?.(fnContext);
                    const payload = {
                        ...this.adaptableApi.internalApi.buildBaseContext(),
                        direction: 'received',
                        eventType: 'IntentRaised',
                        intent: intent,
                        context: context,
                        metadata: metadata
                    };
                    this.adaptableApi.eventApi.emit('Fdc3Message', payload);
                }).then((listener)=>this.intentHandlerSubscriptions.push(listener));
            });
        }
        const adaptableHandleContextFn = this.getFdc3Options().contexts?.handleContext;
        const listenForContexts = this.getFdc3Options().contexts?.listensFor ?? [];
        if (listenForContexts.length) {
            if (!adaptableHandleContextFn) this.adaptableApi.logError(`Following FDC3 Context Listener(s) have been provided but no 'handleContext' function has been supplied in the FDC3 Options`, listenForContexts);
            listenForContexts.forEach((contextType)=>{
                this.adaptableApi.logInfo(`Listening for FDC3 Context: ${contextType}`);
                this.getDesktopAgent()?.addContextListener(contextType, (context, metadata)=>{
                    this.logFdc3Event('IN', `Context`, JSON.stringify(context));
                    const fnContext = {
                        ...this.adaptableApi.internalApi.buildBaseContext(),
                        context: context,
                        metadata: metadata
                    };
                    adaptableHandleContextFn?.(fnContext);
                    const payload = {
                        ...this.adaptableApi.internalApi.buildBaseContext(),
                        direction: 'received',
                        eventType: 'ContextBroadcast',
                        context: context,
                        metadata: metadata
                    };
                    this.adaptableApi.eventApi.emit('Fdc3Message', payload);
                }).then((listener)=>this.contextHandlerSubscriptions.push(listener));
            });
        }
        // 2. Init UI Controls default configuration
        this.uiControlsDefaultConfiguration = this.buildUiControlsDefaultConfiguration();
    }
    getUiControlsDefaultConfiguration() {
        return this.uiControlsDefaultConfiguration;
    }
    getDesktopAgent() {
        if (globalThis.fdc3 == null && !this.loggedAgentError) {
            this.loggedAgentError = true;
            this.adaptableApi.consoleError('FDC3 Desktop Agent not found. The host application must provide the FDC3 agent on globalThis.fdc3.');
        }
        return globalThis.fdc3;
    }
    destroy() {
        this.contextHandlerSubscriptions.forEach((subscription)=>subscription.unsubscribe());
        this.intentHandlerSubscriptions.forEach((subscription)=>subscription.unsubscribe());
    }
    async raiseIntent(intent, context, app) {
        if (!this.getDesktopAgent()) return;
        try {
            this.logFdc3Event('OUT', `raise ${intent}`, JSON.stringify(context));
            const payload = {
                ...this.adaptableApi.internalApi.buildBaseContext(),
                direction: 'sent',
                eventType: 'RaiseIntent',
                intent: intent,
                context: context,
                app: app
            };
            this.adaptableApi.eventApi.emit('Fdc3Message', payload);
            const intentResolution = await this.getDesktopAgent().raiseIntent(intent, context, app);
            this.logFdc3Event('IN', `IntentResolution`, intentResolution.intent);
            this.getFdc3Api().internalApi.handleIntentResolution(intentResolution, context, intent, app);
            return intentResolution;
        } catch (error) {
            this.logFdc3Error(error);
        }
    }
    async raiseIntentForContext(context, app) {
        if (!this.getDesktopAgent()) return;
        try {
            this.logFdc3Event('OUT', `raise for context`, JSON.stringify(context));
            const payload = {
                ...this.adaptableApi.internalApi.buildBaseContext(),
                direction: 'sent',
                eventType: 'RaiseIntentForContext',
                context: context,
                app: app
            };
            this.adaptableApi.eventApi.emit('Fdc3Message', payload);
            const intentResolution = await this.getDesktopAgent().raiseIntentForContext(context, app);
            this.logFdc3Event('IN', `IntentResolution`, intentResolution.intent);
            this.getFdc3Api().internalApi.handleIntentResolution(intentResolution, context, null, app);
            return intentResolution;
        } catch (error) {
            this.logFdc3Error(error);
        }
    }
    broadcast(context, channel) {
        if (!this.getDesktopAgent()) return;
        try {
            this.logFdc3Event('OUT', `broadcast`, JSON.stringify(context));
            const payload = {
                ...this.adaptableApi.internalApi.buildBaseContext(),
                direction: 'sent',
                eventType: 'BroadcastMessage',
                context: context
            };
            this.adaptableApi.eventApi.emit('Fdc3Message', payload);
            if (channel) return channel.broadcast(context);
            else return this.getDesktopAgent().broadcast(context);
        } catch (error) {
            this.logFdc3Error(error);
        }
    }
    logFdc3Event(type, ...params) {
        if (!this.getFdc3Options().enableLogging) return;
        this.adaptableApi.consoleLog(`FDC3 ${type}: ${params.join(' : ')}`);
    }
    logFdc3Error(error) {
        this.adaptableApi.consoleError('FDC3 operation failed.', error);
        this.adaptableApi.alertApi.showAlertError('FDC3', 'An error occurred. See the browser console for details.');
    }
    getFdc3Api() {
        return this.adaptableApi.fdc3Api;
    }
    getFdc3Options() {
        return this.adaptableApi.optionsApi.getFdc3Options();
    }
    buildUiControlsDefaultConfiguration() {
        const adaptableDefaultContextIcons = Object.keys((0, $6c0fdce80feddf80$export$9f57e1cc37377461)).reduce((contextsMapping, contextType)=>{
            contextsMapping[contextType] = {
                icon: {
                    name: (0, $6c0fdce80feddf80$export$9f57e1cc37377461)[contextType].icon
                }
            };
            return contextsMapping;
        }, {});
        const adaptableDefaultIntentIcons = Object.keys((0, $67c38c07b3125913$export$aa788b607096dc19)).reduce((intentsMapping, intentType)=>{
            intentsMapping[intentType] = {
                icon: {
                    name: (0, $67c38c07b3125913$export$aa788b607096dc19)[intentType].icon
                }
            };
            return intentsMapping;
        }, {});
        // merge adaptable defaults with (optional) user provided configuration
        return {
            contexts: {
                ...adaptableDefaultContextIcons,
                ...this.getFdc3Options().uiControlsDefaultConfiguration?.contexts
            },
            intents: {
                ...adaptableDefaultIntentIcons,
                ...this.getFdc3Options().uiControlsDefaultConfiguration?.intents
            }
        };
    }
}





class $e673deae37b98ce7$export$2e228d739b828e61 {
    api;
    constructor(api){
        this.api = api;
    }
    onChartModelChange(models, eventType, params) {
        const allChartDefinitions = this.api.chartingApi.getChartDefinitions();
        const currentChartModel = models.find((model)=>model?.chartId === params.chartId);
        const currentChartDefinition = allChartDefinitions.find((chartDefinition)=>chartDefinition.Model?.chartId === params.chartId);
        switch(eventType){
            case 'chartCreated':
                const createParams = params;
                if (allChartDefinitions.some((chartDefinition)=>chartDefinition.Model?.chartId === createParams.chartId)) ;
                else {
                    const chartModel = models.find((model)=>model?.chartId === createParams.chartId);
                    this.saveNewChart(chartModel);
                }
                break;
            case 'chartOptionsChanged':
            case 'chartRangeSelectionChanged':
                if (!currentChartDefinition) break;
                const updatedChartDefinition = {
                    ...currentChartDefinition,
                    Model: currentChartModel
                };
                this.api.chartingApi.editChartDefinition(updatedChartDefinition);
                break;
        }
        this.api.internalApi.dispatchReduxAction($5b564bb703f29152$export$b0b7b697aae7da85(models));
        this.emitAdaptableChartDefinitonChange();
    }
    /**
     * Emit events only for adaptable charting definition changes
     * - an adaptable chart opens
     * - an adaptable chart closes
     * - an adaptable chart is created
     * - an adaptable chart is deleted
     */ emitAdaptableChartDefinitonChange() {
        const chartingOpenState = this.api.chartingApi.getChartingOpenState();
        const chartChangedInfo = {
            chartingOpenState: chartingOpenState,
            ...this.api.internalApi.buildBaseContext()
        };
        this.api.eventApi.emit('ChartChanged', chartChangedInfo);
    }
    saveNewChart(chartModel) {
        const chartingOptions = this.api.optionsApi.getChartingOptions() ?? {};
        const saveStragegy = chartingOptions.saveChartBehaviour ?? 'manual';
        if (saveStragegy === 'none') return;
        if (saveStragegy === 'manual') {
            const alert = {
                alertType: 'generic',
                header: 'Save chart',
                message: 'Do you want to save this Chart?',
                alertDefinition: {
                    ...(0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyAlertDefinition(),
                    MessageType: 'Info',
                    AlertProperties: {
                        DisplayNotification: true,
                        NotificationDuration: 'always'
                    },
                    AlertForm: {
                        Buttons: [
                            {
                                Label: 'Save',
                                Command: (context)=>{
                                    const chartName = context.formData.name || chartModel.chartId;
                                    this.api.chartingApi.addChartDefinition((0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyChartDefinition({
                                        Name: chartName,
                                        Model: chartModel
                                    }));
                                },
                                ButtonStyle: {
                                    tone: 'info',
                                    variant: 'raised'
                                }
                            },
                            {
                                Label: 'Dismiss',
                                ButtonStyle: {
                                    tone: 'neutral',
                                    variant: 'raised'
                                }
                            }
                        ],
                        fields: [
                            {
                                name: 'name',
                                label: 'Name',
                                fieldType: 'text'
                            }
                        ]
                    }
                }
            };
            this.api.alertApi.displayAdaptableAlert(alert);
        } else if (saveStragegy === 'auto') this.api.chartingApi.addChartDefinition((0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyChartDefinition({
            Name: chartModel.chartId,
            Model: chartModel
        }));
    }
    destroy() {
        this.api = null;
    }
}


class $1b6bd0cf526f1c1c$export$c7501d0b7167aa9c {
    api;
    unsubscribe = ()=>{};
    styleSheetObject;
    constructor(api){
        this.api = api;
        this.subscribe();
        if (!this.styleSheetObject) {
            this.styleSheetObject = new CSSStyleSheet();
            // ts does not know about adoptedStyleSheets
            document.adoptedStyleSheets = [
                ...document.adoptedStyleSheets ?? [],
                this.styleSheetObject
            ];
        }
    }
    destroy() {
        this.api = null;
        this.unsubscribe();
        document.adoptedStyleSheets = [
            ...document.adoptedStyleSheets
        ].filter((sheet)=>sheet !== this.styleSheetObject);
    }
    subscribe() {
        const themeChangedUnsubscribe = this.api.eventApi.on('ThemeChanged', this.onThemeChanged);
        const prefferedColorSchemeUnsubscribe = this.attachPrefferedColorSchemeListener();
        this.unsubscribe = ()=>{
            themeChangedUnsubscribe();
            prefferedColorSchemeUnsubscribe();
        };
    }
    onThemeChanged = ()=>{
        let currentTheme = this.api.themeApi.getCurrentThemeObject();
        currentTheme = this.mapOsTheme(currentTheme);
        this.applyNewThemeVariables(currentTheme);
        // this needs to be called after variables are set
        // as it may show the warning for a custom/runtime theme
        this.showMissingThemeFiles(currentTheme);
    };
    applyNewThemeVariables(theme) {
        const variables = theme.CSSVariables;
        if (!variables || Object.keys(variables).length === 0) return;
        let str = `html.${this.api.themeApi.internalApi.getThemeClassName(theme.Name)} {
      --ab-theme-loaded: ab--theme-${theme.Name};
    `;
        for (const [key, value] of Object.entries(variables))if (key.includes('--')) str += `${key}: ${value};`;
        str += '}';
        this.styleSheetObject.replaceSync(str);
    }
    showMissingThemeFiles(theme) {
        // run time defined theme
        // because it may be an empty theme
        if (theme.Source === 'User') return;
        const themeName = theme.Name;
        const adaptable = this.api.internalApi.getAdaptableInstance();
        const logger = adaptable.logger;
        const documentElement = document.documentElement;
        const computedDocumentStyle = getComputedStyle(documentElement);
        const [abLoaded, abThemeLoaded] = [
            '--ab-loaded',
            '--ab-theme-loaded'
        ].map((variable)=>{
            let val = computedDocumentStyle.getPropertyValue(variable);
            if (typeof val === 'string' && val.trim) val = val.trim();
            return val;
        });
        if (abLoaded !== '777') logger.consoleError('Adaptable styles not detected. Please import "@adaptabletools/adaptable/index.css".');
        const isCustomUserTheme = !this.api.themeApi.internalApi.isSystemTheme(themeName);
        if (!isCustomUserTheme && abThemeLoaded !== themeName) logger.consoleWarn(`Theme "${themeName}" does not appear to be loaded. Ensure the CSS file is imported, e.g.: import "@adaptabletools/adaptable/themes/${themeName}.css".`);
    }
    // prefers-color-scheme
    getDOMPrefferedColorScheme() {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    mapOsTheme(theme) {
        theme = typeof theme === 'string' ? this.api.themeApi.getThemeByName(theme) : theme;
        if (typeof theme === 'string' && theme === 'os' || typeof theme === 'object' && theme.Name === 'os') return this.api.themeApi.getThemeByName(this.getDOMPrefferedColorScheme());
        return theme;
    }
    attachPrefferedColorSchemeListener() {
        const handlePrefferedColorSchemeChange = ()=>{
            // we need to reapply the theme
            const currentTheme = this.api.themeApi.getCurrentThemeObject();
            if (currentTheme.Name === 'os') this.api.themeApi.applyCurrentTheme();
        };
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', handlePrefferedColorSchemeChange);
        return ()=>{
            window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', handlePrefferedColorSchemeChange);
        };
    }
}



var $9g4SS = parcelRequire("9g4SS");

var $9OAZF = parcelRequire("9OAZF");



class $168c119cef991c21$export$7b25d229d5ec5033 {
    adaptableApi;
    constructor(adaptableApi){
        this.adaptableApi = adaptableApi;
        this.adaptableApi = adaptableApi;
    }
    // Not sure where to put this: was in the Module but might be better here until I can work out a way of having an event with a callback...
    getValidationRulesForDataChange(cellDataChangedInfo) {
        // if the new value is the same as the old value then we can get out as we dont see it as an edit?
        if (cellDataChangedInfo.oldValue == cellDataChangedInfo.newValue) return [];
        let editingRules = this.adaptableApi.alertApi.internalApi.getAlertDefinitionsWithPreventEdit().filter((v)=>this.adaptableApi.columnScopeApi.isColumnInScope(cellDataChangedInfo.column, v.Scope));
        let failedValidations = [];
        if ((0, $9g4SS.ArrayExtensions).IsNotEmpty(editingRules)) editingRules.forEach((alertDefinition)=>{
            if (alertDefinition.Rule.BooleanExpression) {
                let isSatisfiedExpression = false;
                try {
                    isSatisfiedExpression = cellDataChangedInfo.rowNode != null && this.adaptableApi.internalApi.getQueryLanguageService().evaluateBooleanExpression(alertDefinition.Rule.BooleanExpression, (0, $42e863194fcb493f$export$40024cb74c2bb550), cellDataChangedInfo.rowNode);
                } catch (error) {
                    isSatisfiedExpression = false;
                    (0, $10f858c943b30cc8$export$45c997b35cb132f6)(error.message);
                }
                if (isSatisfiedExpression) failedValidations.push(alertDefinition);
            } else if (this.IsAlertDefinitionTriggered(alertDefinition, cellDataChangedInfo)) failedValidations.push(alertDefinition);
        });
        return failedValidations;
    }
    performValidation(cellDataChangedInfo) {
        const failedRules = this.getValidationRulesForDataChange(cellDataChangedInfo);
        if (failedRules.length > 0) {
            let alert = {
                alertType: 'cellChanged',
                header: 'Alert',
                message: 'A validation rule was triggered for this edit.',
                alertDefinition: failedRules[0],
                cellDataChangedInfo: cellDataChangedInfo
            };
            this.adaptableApi.eventApi.internalApi.fireAlertFiredEvent(alert);
            // This is not needed because the change event is triggered regardless
            // if the edit is succesful. This is because (I think) Adaptable uses a non-standard way ot detecting data changes.
            // https://github.com/AdaptableTools/adaptable/issues/2197
            // failedRules.forEach((alertDefinition) => {
            //   const alert: AdaptableAlert = ObjectFactory.CreateCellChangedAlert(
            //     cellDataChangedInfo.column.friendlyName,
            //     this.adaptableApi.alertApi.internalApi.getAlertDescription(
            //       alertDefinition,
            //       cellDataChangedInfo
            //     ),
            //     alertDefinition,
            //     cellDataChangedInfo
            //   );
            //   this.adaptableApi.alertApi.showAdaptableAlert(alert);
            // });
            return false;
        }
        return true;
    }
    IsAlertDefinitionTriggered(alertDefinition, dataChangedEvent) {
        const displayValue = this.adaptableApi.gridApi.getDisplayValueFromRowNode(dataChangedEvent.rowNode, dataChangedEvent.column.columnId);
        const predicateDefHandlerContext = {
            value: dataChangedEvent.newValue,
            oldValue: dataChangedEvent.oldValue,
            rawValue: dataChangedEvent.newValue,
            displayValue: displayValue,
            node: dataChangedEvent.rowNode,
            column: dataChangedEvent.column,
            ...this.adaptableApi.internalApi.buildBaseContext()
        };
        return this.adaptableApi.predicateApi.handlePredicates(alertDefinition.Rule?.Predicates, predicateDefHandlerContext, false);
    }
    performServerValidation(cellDataChangedInfo, config) {
        const serverValidationContext = {
            cellDataChangedInfo: cellDataChangedInfo,
            ...this.adaptableApi.internalApi.buildBaseContext()
        };
        return ()=>{
            this.adaptableApi.optionsApi.getEditOptions().validateOnServer(serverValidationContext).then((validationResult)=>{
                if (validationResult.newCellValue === undefined) validationResult.newCellValue = cellDataChangedInfo.newValue;
                // If they have changed the return value then we should update the grid, log the function change
                // otherwise the value will persist
                if (validationResult.newCellValue !== cellDataChangedInfo.newValue) {
                    cellDataChangedInfo.newValue = validationResult.newCellValue;
                    // this.adaptable.setValue(cellDataChangedInfo, false);
                    const row = cellDataChangedInfo.rowNode?.data;
                    if (!row) return;
                    row[this.adaptableApi.columnApi.internalApi.getAgGridColumnFieldForAdaptableColumn(cellDataChangedInfo.column.columnId) ?? cellDataChangedInfo.column.columnId] = validationResult.newCellValue;
                    this.adaptableApi.gridApi.updateGridData([
                        row
                    ]);
                    if ((0, $9OAZF.default).IsNotNullOrEmpty(validationResult.validationMessage) && this.adaptableApi.optionsApi.getEditOptions().displayServerValidationMessages) {
                        const validationHeader = validationResult.validationHeader ? validationResult.validationHeader : (0, $58846ea7f4156db7$export$b58ad781082208e8);
                        const messageType = validationResult.messageType ? validationResult.messageType : (0, $58846ea7f4156db7$export$6c22698d5e37fb5a);
                        this.adaptableApi.alertApi.showAlert(validationHeader, validationResult.validationMessage, messageType);
                    }
                }
                config.onServerValidationCompleted();
            });
            return false;
        };
    }
    createValidationDescription(alertDefinition) {
        return this.adaptableApi.columnScopeApi.getScopeDescription(alertDefinition.Scope) + ' ' + alertDefinition.Rule?.Predicates?.map((predicate)=>this.adaptableApi.predicateApi.predicateToString(predicate)).join(' AND ');
    }
    createValidationMessage(alertDefinition) {
        let returnMessage = this.createValidationDescription(alertDefinition);
        if (alertDefinition.Rule.BooleanExpression) returnMessage += ' when ' + alertDefinition.Rule.BooleanExpression;
        return returnMessage;
    }
    destroy() {
    // TO DO
    }
}




class $39930c593ebd1c90$export$c98e455cccfe5cdb {
    adaptableApi;
    constructor(adaptableApi){
        this.adaptableApi = adaptableApi;
        this.adaptableApi = adaptableApi;
    }
    isAdapTableModulePresent(adaptableModule) {
        let module = this.getModuleCollection().get(adaptableModule);
        if (!module) return false;
        return module.isModuleVisible();
    }
    isModuleEditable(adaptableModule) {
        let module = this.getModuleCollection().get(adaptableModule);
        if (!module) return false;
        return module.isModuleEditable();
    }
    logMissingAgGridDepsInfos() {
        // log missing core (required) AG Grid dependencies
        const agGridModulesAdapter = this.adaptableApi.internalApi.getAgGridModulesAdapter();
        if (agGridModulesAdapter.isAgGridModuleRegistered('AllEnterpriseModule')) // no need to check further if AllEnterprise is registered
        // it may even trigger false positives (e.g. when using SSRM)
        return;
        const mandatoryAgGridModuleNames = agGridModulesAdapter.getMandatoryAgGridModuleNames();
        const registeredAgGridModuleNames = agGridModulesAdapter.getAgGridRegisteredModuleNames();
        const missingAgGridModuleNames = mandatoryAgGridModuleNames.filter((moduleName)=>!registeredAgGridModuleNames.includes(moduleName));
        if (missingAgGridModuleNames.length) this.adaptableApi.consoleError(`Adaptable requires these AG Grid modules: ${missingAgGridModuleNames.join(', ')}. Please register them. See: ${(0, $53c62e7ff907ad8d$export$1768e4e871cc8a23)}`);
        // log optional missing AG Grid dependencies for all modules
        this.getModuleCollection().forEach((adaptableModule)=>{
            adaptableModule.logMissingAgGridDepsInfos();
        });
    }
    getModuleFriendlyName(adaptableModule) {
        return this.getModuleInfoByModule(adaptableModule)?.FriendlyName ?? adaptableModule;
    }
    createModuleUIItems() {
        this.createSettingsPanelItems();
        this.createModuleButtonsForDashboardAndToolPanel();
    }
    createSettingsPanelItems() {
        const settingsPanelItems = [];
        this.getModuleCollection().forEach((module)=>{
            const settingsPanelMenuItem = module.createModuleMenuItem('ModuleMenu');
            if ((0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).objectExists(settingsPanelMenuItem)) {
                if (settingsPanelItems.findIndex((m)=>m.category == settingsPanelMenuItem.category) == -1) settingsPanelItems.push(settingsPanelMenuItem);
            }
        });
        // store Settings Panel items in Internal State as they never change and we often re-use
        this.adaptableApi.internalApi.setSettingsPanelItems(settingsPanelItems);
    }
    createModuleButtonsForDashboardAndToolPanel() {
        const moduleButtons = [];
        this.getModuleCollection().forEach((module)=>{
            const moduleButton = module.createModuleMenuItem('ModuleButton');
            if ((0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).objectExists(moduleButton)) {
                if (moduleButtons.findIndex((m)=>m.category == moduleButton.category) == -1) moduleButtons.push(moduleButton);
            }
        });
        // store Dashboard Buttons in Internal State as they never change l
        this.adaptableApi.internalApi.setDashboardModuleButtons(moduleButtons);
    }
    getTeamSharingAction(adaptableModule) {
        let module = this.getModuleCollection().get(adaptableModule);
        if (!module) return undefined;
        return module.getTeamSharingAction();
    }
    getModuleById(adaptableModule) {
        // @ts-ignore TODO: make modules generic
        return this.getModuleCollection().get(adaptableModule);
    }
    getModuleInfoByModule(adaptableModule) {
        const module = this.getModuleById(adaptableModule);
        return module ? module.moduleInfo : undefined;
    }
    getModuleInfoByFriendlyName(friendlyName) {
        for (let module of this.getModuleCollection().values()){
            let moduleInfo = module.moduleInfo;
            if (moduleInfo && moduleInfo.FriendlyName == friendlyName) return moduleInfo;
        }
        return undefined;
    }
    getPopupMaxWidth(adaptableModule) {
        return this.getModuleById(adaptableModule)?.getPopupMaxWidth();
    }
    getModuleCollection() {
        return this.adaptableApi.internalApi.getModules();
    }
    getModuleDocumentationPageByModule(adaptableModule) {
        let url = `${(0, $53c62e7ff907ad8d$export$6fb62bf2d8008f92)}/`;
        switch(adaptableModule){
            case 'Alert':
                return url + 'handbook-alerting';
            case 'BulkUpdate':
                return url + 'handbook-editing-bulk-update';
            case 'CalculatedColumn':
                return url + 'handbook-calculated-column';
            case 'CellSummary':
                return url + 'handbook-summarising-cells';
            case 'Charting':
                return url + 'handbook-charts';
            case 'ColumnFilter':
                return url + 'handbook-column-filter';
            case 'ColumnInfo':
                return url + 'dev-guide-columns-column-info';
            case 'Comment':
                return url + 'handbook-comments';
            case 'CustomSort':
                return url + 'handbook-custom-sorting';
            case 'Dashboard':
                return url + 'ui-dashboard';
            case 'DataChangeHistory':
                return url + 'handbook-monitoring-data-change-history';
            case 'DataImport':
                return url + 'handbook-importing';
            case 'DataSet':
                return url + 'handbook-data-sets';
            case 'Export':
                return url + 'handbook-exporting';
            case 'Fdc3':
                return url + 'handbook-fdc3';
            case 'FlashingCell':
                return url + 'handbook-flashing-cell';
            case 'FormatColumn':
                return url + 'handbook-column-formatting';
            case 'FreeTextColumn':
                return url + 'handbook-freetext-column';
            case 'GridFilter':
                return url + 'handbook-grid-filter';
            case 'GridInfo':
                return url + 'dev-guide-support-monitoring';
            case 'Layout':
                return url + 'handbook-layouts';
            case 'NamedQuery':
                return url + 'handbook-named-queries';
            case 'Note':
                return url + 'handbook-notes';
            case 'PlusMinus':
                return url + 'handbook-editing-plus-minus';
            case 'QuickSearch':
                return url + 'handbook-quick-search';
            case 'Schedule':
                return url + 'handbook-scheduling';
            case 'SettingsPanel':
                return url + 'ui-settings-panel';
            case 'Shortcut':
                return url + 'handbook-editing-shortcut';
            case 'SmartEdit':
                return url + 'handbook-editing-smart-edit';
            case 'StateManagement':
                return url + 'dev-guide-adaptable-state-management';
            case 'StatusBar':
                return url + 'ui-status-bar';
            case 'StyledColumn':
                return url + 'handbook-styled-column-overview';
            case 'SystemStatus':
                return url + 'handbook-system-status-message';
            case 'TeamSharing':
                return url + 'handbook-team-sharing';
            case 'Theme':
                return url + 'handbook-theming';
            case 'ToolPanel':
                return url + 'ui-tool-panel';
            case 'IPushPull':
                return url + 'integrations-ipushpull';
            case 'OpenFin':
                return url + 'integrations-openfin';
            default:
                return 'good';
        }
    }
    destroy() {
    // TO DO
    }
}



const $c81709b40fed9d6a$var$SORT_ASC_REVISION = (p1, p2)=>$c81709b40fed9d6a$var$sortAscending(p1.revision, p2.revision);
class $c81709b40fed9d6a$export$1c737028a0cb2e00 {
    map = new Map();
    length = 0;
    revision = 0;
    static clone(map) {
        const clone = new $c81709b40fed9d6a$export$1c737028a0cb2e00();
        map.visit((pair, keys)=>{
            clone.set(keys, pair.value);
        });
        return clone;
    }
    constructor(initial){
        if (initial) initial.forEach((entry)=>{
            const [keys, value] = entry;
            this.set(keys, value);
        });
    }
    set(keys, value) {
        let currentMap = this.map;
        if (!keys.length) throw `Cannot set given keys - please provide a non-empty keys array.`;
        for(let i = 0, len = keys.length; i < len; i++){
            const key = keys[i];
            const last = i === len - 1;
            if (last) {
                const pair = currentMap.has(key) ? currentMap.get(key) : {};
                pair.revision = this.revision++;
                pair.value = value;
                currentMap.set(key, pair);
                this.length++;
            } else {
                const pair = currentMap.has(key) ? currentMap.get(key) : {};
                if (!pair.map) {
                    pair.map = new Map();
                    currentMap.set(key, pair);
                }
                currentMap = pair.map;
            }
        }
        return this;
    }
    get(keys) {
        let currentMap = this.map;
        if (!keys.length) throw `Cannot get given keys - please provide a non-empty keys array.`;
        for(let i = 0, len = keys.length; i < len; i++){
            const key = keys[i];
            const last = i === len - 1;
            if (last) return currentMap.get(key)?.value;
            else {
                const pair = currentMap.get(key);
                if (!pair || !pair.map) return;
                currentMap = pair.map;
            }
        }
        return;
    }
    get size() {
        return this.length;
    }
    clear() {
        const clearMap = (map)=>{
            map.forEach((value, _key)=>{
                const { map: map } = value;
                if (map) clearMap(map);
            });
            map.clear();
        };
        clearMap(this.map);
        this.length = 0;
        this.revision = 0;
    }
    delete(keys) {
        keys = [
            ...keys
        ];
        let currentMap = this.map;
        if (!keys.length) throw `Cannot delete given keys - please provide a non-empty keys array.`;
        let maps = [
            currentMap
        ];
        let result = false;
        for(let i = 0, len = keys.length; i < len; i++){
            const key = keys[i];
            const last = i === len - 1;
            if (last) {
                const pair = currentMap.get(key);
                if (pair) {
                    if (pair.hasOwnProperty('value')) {
                        delete pair.value;
                        delete pair.revision;
                        result = true;
                        this.length--;
                    }
                    if (pair.map && pair.map.size === 0) delete pair.map;
                    if (!pair.map) // pair is empty, so we can remove it altogether
                    currentMap.delete(key);
                }
                break;
            } else {
                const pair = currentMap.get(key);
                if (!pair || !pair.map) {
                    result = false;
                    break;
                }
                currentMap = pair.map;
                maps.push(currentMap);
            }
        }
        while(maps.length){
            let map = maps.pop();
            let key = keys.pop();
            if (key && map?.size === 0) {
                let parentMap = maps[maps.length - 1];
                let pair = parentMap?.get(key);
                if (pair) {
                    // pair.map === map ; which can be deleted
                    delete pair.map;
                    if (!pair.hasOwnProperty('value')) // whole pair can be successfully deleted from parentMap
                    parentMap.delete(key);
                }
            }
        }
        return result;
    }
    has(keys) {
        let currentMap = this.map;
        if (!keys.length) throw `Cannot find existing given keys - please provide a non-empty keys array.`;
        for(let i = 0, len = keys.length; i < len; i++){
            const key = keys[i];
            const last = i === len - 1;
            if (last) {
                const pair = currentMap.get(key);
                return !!pair && pair.hasOwnProperty('value');
            } else {
                const pair = currentMap.get(key);
                if (!pair || !pair.map) return false;
                currentMap = pair.map;
            }
        }
        return false;
    }
    visitKey(key, currentMap, parentKeys, fn) {
        const pair = currentMap.get(key);
        if (!pair) return;
        const { map: map } = pair;
        const keys = [
            ...parentKeys,
            key
        ];
        const next = $c81709b40fed9d6a$export$d2de3aaeafa91619(()=>{
            if (map) map.forEach((_, k)=>{
                this.visitKey(k, map, keys, fn);
            });
        });
        if (pair.hasOwnProperty('value')) fn(pair, keys, next);
        // if it was called by fn, it won't be called again, as it's once-d
        next();
    }
    visit = (fn)=>{
        this.map.forEach((_, k)=>this.visitKey(k, this.map, [], fn));
    };
    visitDepthFirst = (fn)=>{
        this.visitWithNext([], fn);
    };
    visitWithNext = (parentKeys, fn, currentMap = this.map)=>{
        if (!currentMap) return;
        let i = 0;
        currentMap.forEach((_, key)=>{
            const pair = currentMap.get(key);
            if (!pair) return;
            const { map: map } = pair;
            const keys = [
                ...parentKeys,
                key
            ];
            const next = map ? ()=>this.visitWithNext(keys, fn, map) : undefined;
            if (pair.hasOwnProperty('value')) {
                fn(pair.value, keys, i, next);
                i++;
            } else next?.();
        });
    };
    getArray(fn) {
        const result = [];
        this.visit((pair, keys)=>{
            result.push(fn({
                ...pair,
                keys: keys
            }));
        });
        return result;
    }
    values() {
        return this.sortedIterator((pair)=>pair.value);
    }
    keys() {
        const keys = this.sortedIterator((pair)=>pair.keys);
        return keys;
    }
    entries() {
        return this.sortedIterator((pair)=>[
                pair.keys,
                pair.value
            ]);
    }
    topDownEntries() {
        return this.getArray((pair)=>[
                pair.keys,
                pair.value
            ]);
    }
    topDownKeys() {
        return this.getArray((pair)=>pair.keys);
    }
    topDownValues() {
        return this.getArray((pair)=>pair.value);
    }
    sortedIterator(fn) {
        const result = [];
        this.visit((pair, keys)=>{
            result.push({
                ...pair,
                keys: keys
            });
        });
        result.sort($c81709b40fed9d6a$var$SORT_ASC_REVISION);
        function* makeIterator() {
            for(let i = 0, len = result.length; i < len; i++)yield fn(result[i]);
        }
        return makeIterator();
    }
}
function $c81709b40fed9d6a$export$d2de3aaeafa91619(fn) {
    let called = false;
    let result = null;
    const onceFn = ()=>{
        if (called) return result;
        called = true;
        result = fn();
        return result;
    };
    return onceFn;
}
const $c81709b40fed9d6a$var$sortAscending = (a, b)=>a - b;


function $c706bea336af9fa2$var$DEFAULT_TO_KEY(value) {
    return value;
}
function $c706bea336af9fa2$export$258f7bf0e3a9da18(aggregateParams, data) {
    const { groupBy: groupBy = [], defaultToKey: defaultToKey = $c706bea336af9fa2$var$DEFAULT_TO_KEY, reducers: reducers } = aggregateParams;
    const groupByLength = groupBy.length;
    const deepMap = new (0, $c81709b40fed9d6a$export$1c737028a0cb2e00)();
    let currentGroupKeys = [];
    const getInitialReducerValue = ()=>{
        return structuredClone($c706bea336af9fa2$var$initReducers(reducers));
    };
    const globalReducerResults = getInitialReducerValue();
    for(let i = 0, len = data.length; i < len; i++){
        let item = data[i];
        for(let groupByIndex = 0; groupByIndex < groupByLength; groupByIndex++){
            const { field: groupByProperty, toKey: groupToKey } = groupBy[groupByIndex];
            const key = (groupToKey || defaultToKey)(item[groupByProperty], item);
            currentGroupKeys.push(key);
            if (!deepMap.has(currentGroupKeys)) {
                const deepMapGroupValue = {
                    items: [],
                    reducerResults: getInitialReducerValue()
                };
                deepMap.set(currentGroupKeys, deepMapGroupValue);
            }
            const { items: currentGroupItems, reducerResults: reducerResults } = deepMap.get(currentGroupKeys);
            currentGroupItems.push(item);
            if (reducers) $c706bea336af9fa2$var$computeReducersFor(item, reducers, reducerResults, i);
        }
        if (reducers) $c706bea336af9fa2$var$computeReducersFor(item, reducers, globalReducerResults, i);
        currentGroupKeys.length = 0;
    }
    if (reducers) deepMap.visitDepthFirst((deepMapValue, _keys, _indexInGroup, next)=>{
        $c706bea336af9fa2$var$completeReducers(reducers, deepMapValue.reducerResults, deepMapValue.items);
        next?.();
    });
    if (reducers) $c706bea336af9fa2$var$completeReducers(reducers, globalReducerResults, data);
    const result = {
        deepMap: deepMap,
        aggregateParams: aggregateParams,
        initialData: data,
        reducerResults: globalReducerResults
    };
    return result;
}
function $c706bea336af9fa2$var$initReducers(reducers) {
    if (!reducers || !Object.keys(reducers).length) return {};
    const result = {};
    for(let key in reducers)if (reducers.hasOwnProperty(key)) result[key] = reducers[key].initialValue;
    return result;
}
/**
 *
 * This fn mutates the reducerResults array!!!
 *
 * @param data data item
 * @param reducers an array of reducers
 * @param reducerResults the results on which to operate
 *
 */ function $c706bea336af9fa2$var$computeReducersFor(data, reducers, reducerResults, dataIndex) {
    if (!reducers || !Object.keys(reducers).length) return;
    for(let key in reducers)if (reducers.hasOwnProperty(key)) {
        const reducer = reducers[key];
        if (typeof reducer.reducer !== 'function') continue;
        const currentValue = reducerResults[key];
        const value = reducer.field ? data[reducer.field] : reducer.getter?.(data) ?? null;
        reducerResults[key] = reducer.reducer(currentValue, value, data, dataIndex);
    }
}
function $c706bea336af9fa2$var$completeReducers(reducers, reducerResults, items) {
    if (reducers) {
        for(let key in reducers)if (reducers.hasOwnProperty(key)) {
            const reducer = reducers[key];
            if (reducer.done) reducerResults[key] = reducer.done(reducerResults[key], items);
        }
    }
    return reducerResults;
}


const $204192e364083da9$var$doOnceFlags = {};
const $204192e364083da9$var$logOnce = (message, loggingFn)=>{
    if ($204192e364083da9$var$doOnceFlags[message]) return;
    loggingFn(message);
    $204192e364083da9$var$doOnceFlags[message] = true;
};
class $204192e364083da9$export$2543999d196edf32 {
    source;
    requestingModule;
    adaptableApi;
    getRowNodes;
    aggregationReducerName;
    aggregatedScalarExpression;
    expressionEvaluation;
    aggregationResult;
    constructor(source, requestingModule, adaptableApi, getRowNodes){
        this.source = source;
        this.requestingModule = requestingModule;
        this.adaptableApi = adaptableApi;
        this.getRowNodes = getRowNodes;
        if (source.aggregatedScalarExpression) this.aggregatedScalarExpression = source.aggregatedScalarExpression;
        this.expressionEvaluation = source.aggregatedScalarExpression ? this.adaptableApi.internalApi.getQueryLanguageService().evaluateAggregatedScalarExpression(source.aggregatedScalarExpression, requestingModule, getRowNodes).value : source.aggregatedScalarExpressionEvaluation;
        // currently we support only one reducer
        this.aggregationReducerName = Object.keys(this.expressionEvaluation.aggregationParams.reducers)[0];
        this.aggregationResult = this.computeAggregatedValue(this.expressionEvaluation);
    }
    refresh() {
        if (this.aggregatedScalarExpression) this.expressionEvaluation = this.adaptableApi.internalApi.getQueryLanguageService().evaluateAggregatedScalarExpression(this.aggregatedScalarExpression, this.requestingModule, this.getRowNodes).value;
        // currently we support only one reducer
        this.aggregationReducerName = Object.keys(this.expressionEvaluation.aggregationParams.reducers)[0];
        this.aggregationResult = this.computeAggregatedValue(this.expressionEvaluation);
    }
    getAggregatedValueForRow(rowNode) {
        const aggregationValue = this.getAggregationValue(rowNode);
        if (aggregationValue == undefined) {
            $204192e364083da9$var$logOnce(`${this.aggregatedScalarExpression} :: aggregation value is NOT available!`, (message)=>{
                this.adaptableApi.logWarn(message);
            });
            return;
        }
        if (this.expressionEvaluation.rowValueGetter) return this.expressionEvaluation.rowValueGetter(rowNode, aggregationValue);
        return aggregationValue;
    }
    getAllAggregationValues() {
        if (this.expressionEvaluation.aggregationParams.groupBy?.length) {
            const aggregations = this.aggregationResult.deepMap.topDownValues();
            return aggregations.map((aggregation)=>aggregation.reducerResults[this.aggregationReducerName]);
        }
        return [
            this.getGlobalAggregatedValue()
        ];
    }
    getAggregationValue(rowNode) {
        if (this.expressionEvaluation.aggregationParams.groupBy?.length) {
            const groupColumns = this.expressionEvaluation.aggregationParams.groupBy.map((groupByParam)=>groupByParam.field);
            const groupKeys = groupColumns.map((groupColumnName)=>this.getRowNodeValueForColumnId(rowNode, groupColumnName));
            return this.aggregationResult.deepMap.get(groupKeys)?.reducerResults[this.aggregationReducerName];
        }
        return this.getGlobalAggregatedValue();
    }
    getGlobalAggregatedValue() {
        return this.aggregationResult.reducerResults[this.aggregationReducerName];
    }
    getRowNodeValueForColumnId(rowNode, columnId) {
        const rawValue = this.adaptableApi.gridApi.getRawValueFromRowNode(rowNode, columnId);
        // we need to convert the Date object to a number, otherwise the grouping will not work (each Date instance is unique)
        return rawValue instanceof Date ? rawValue.getTime() : rawValue;
    }
    computeAggregatedValue(expressionEvaluation) {
        const gridRowNodes = expressionEvaluation.getRowNodes ? expressionEvaluation.getRowNodes() : this.adaptableApi.gridApi.getAllRowNodes({
            filterFn: expressionEvaluation.rowFilterFn
        });
        // we iterate over the RowNode list (we need this to handle complex column values (nested values, valueGetters etc)
        // so we will map the fieldNames to RowNode.data
        const mapReducerValueGetter = (columnId)=>{
            return (rowNode)=>this.getRowNodeValueForColumnId(rowNode, columnId);
        };
        Object.values(expressionEvaluation.aggregationParams.reducers).forEach((aggregationReducer)=>{
            aggregationReducer.getter = mapReducerValueGetter(aggregationReducer.field);
            // nullify the field to force the fallback on the getter fn
            aggregationReducer.field = null;
        });
        const mapGroupByToKey = (columnId)=>{
            return (_unusableProperty, rowNode)=>this.getRowNodeValueForColumnId(rowNode, columnId);
        };
        expressionEvaluation.aggregationParams.groupBy?.forEach((groupByDef)=>{
            groupByDef.toKey = mapGroupByToKey(groupByDef.field);
        });
        let aggregatedRowNodes = gridRowNodes;
        if (expressionEvaluation.sortByColumn) {
            const sortByColumn = expressionEvaluation.sortByColumn;
            // currently, we support only ascending sorting
            aggregatedRowNodes.sort((first, second)=>{
                const firstValue = this.getRowNodeValueForColumnId(first, sortByColumn);
                const secondValue = this.getRowNodeValueForColumnId(second, sortByColumn);
                if (firstValue < secondValue) return -1;
                if (firstValue > secondValue) return 1;
                return 0;
            });
        }
        const result = (0, $c706bea336af9fa2$export$258f7bf0e3a9da18)(expressionEvaluation.aggregationParams, aggregatedRowNodes);
        return result;
    }
}


class $c2ad72040957a875$export$121b2b63ac6c1a0c {
    adaptableApi;
    aggregatedScalarLiveValuesMap = new Map();
    constructor(adaptableApi){
        this.adaptableApi = adaptableApi;
        this.adaptableApi = adaptableApi;
    }
    listentoCellDataChange(cellDataChangedInfo) {
        const refreshedCalculatedColumns = [];
        this.aggregatedScalarLiveValuesMap.forEach((aggregatedScalarLiveValue, calculatedColumnId)=>{
            const calculatedColumn = this.adaptableApi.calculatedColumnApi.getCalculatedColumnById(calculatedColumnId);
            const columnDependencies = this.adaptableApi.calculatedColumnApi.internalApi.getReferencedColumnIdsForCalculatedColumn(calculatedColumn);
            if (columnDependencies.includes(cellDataChangedInfo.column.columnId)) {
                aggregatedScalarLiveValue.refresh();
                refreshedCalculatedColumns.push(calculatedColumn.ColumnId);
            }
        });
        if (refreshedCalculatedColumns.length) this.adaptableApi.gridApi.refreshColumns(refreshedCalculatedColumns);
    }
    listentoRowDataChange(rowDataChangedInfo) {
        const refreshedCalculatedColumns = [];
        this.aggregatedScalarLiveValuesMap.forEach((aggregatedScalarLiveValue, calculatedColumnId)=>{
            const calculatedColumn = this.adaptableApi.calculatedColumnApi.getCalculatedColumnById(calculatedColumnId);
            aggregatedScalarLiveValue.refresh();
            refreshedCalculatedColumns.push(calculatedColumn.ColumnId);
        });
        if (refreshedCalculatedColumns.length) this.adaptableApi.gridApi.refreshColumns(refreshedCalculatedColumns);
    }
    destroy() {
        this.aggregatedScalarLiveValuesMap.clear();
        this.aggregatedScalarLiveValuesMap = null;
    }
    getCalculatedColumnDataType(calculatedColumnQuery) {
        try {
            if (calculatedColumnQuery.AggregatedScalarExpression) // currently AggregatedScalarExpression support only numerical values
            // TODO AFL try to derive the type from the aggregatedColumn?
            // we definitely don't want to aggregate everything only to get the data type
            return 'number';
            let firstRowNode = this.adaptableApi.gridApi.getFirstRowNode();
            let firstRowValue = this.adaptableApi.internalApi.getQueryLanguageService().evaluateScalarExpression(calculatedColumnQuery.ScalarExpression, (0, $42e863194fcb493f$export$6619e71706e8514a), firstRowNode);
            if (firstRowValue instanceof Date) return 'date';
            if (typeof firstRowValue === 'boolean') return 'boolean';
            if (typeof firstRowValue === 'string') return 'text';
            if (typeof firstRowValue === 'number') return 'number';
            if (Array.isArray(firstRowValue)) return 'numberArray';
        } catch (e) {
            this.adaptableApi.logError(`Invalid CalculatedColumn expression ${this.adaptableApi.expressionApi.getAdaptableQueryExpression(calculatedColumnQuery)} :: ${e}`);
            return 'number';
        }
    }
    isCalculatedColumnQueryValid(calculatedColumnQuery) {
        if (calculatedColumnQuery.ScalarExpression) try {
            // TODO AFL add a cached validation for ScalarExpression, just like for all the other types
            let firstRowNode = this.adaptableApi.gridApi.getFirstRowNode();
            this.adaptableApi.internalApi.getQueryLanguageService().evaluateScalarExpression(calculatedColumnQuery.ScalarExpression, (0, $42e863194fcb493f$export$6619e71706e8514a), firstRowNode);
            return true;
        } catch (e) {
            // no logging as this method is used only in the UI
            return false;
        }
        if (calculatedColumnQuery.AggregatedScalarExpression) {
            const validationResult = this.adaptableApi.expressionApi.isValidAggregatedScalarExpression(calculatedColumnQuery.AggregatedScalarExpression, (0, $42e863194fcb493f$export$6619e71706e8514a));
            return validationResult;
        }
        // if query has neither a ScalarExpression nor an AggregatedScalarExpression => it can only be false
        return false;
    }
    evaluateCalculatedColumnQuery(calculatedColumn, rowNode) {
        try {
            if (this.adaptableApi.gridApi.isGroupRowNode(rowNode)) return undefined;
            // no validation here, this function has to be as performant as possible
            if (calculatedColumn?.Query?.ScalarExpression) return this.adaptableApi.internalApi.getQueryLanguageService().evaluateScalarExpression(calculatedColumn.Query.ScalarExpression, (0, $42e863194fcb493f$export$6619e71706e8514a), rowNode);
            if (calculatedColumn?.Query?.AggregatedScalarExpression) {
                const aggregatedScalarLiveValue = this.aggregatedScalarLiveValuesMap.get(calculatedColumn.Uuid);
                return aggregatedScalarLiveValue?.getAggregatedValueForRow(rowNode);
            }
        } catch (error) {
            this.adaptableApi.logError(`Invalid CalculatedColumn expression ${calculatedColumn?.Query?.ScalarExpression ?? calculatedColumn?.Query?.AggregatedScalarExpression} :: ${error}`);
            return null;
        }
    }
    createAggregatedScalarLiveValue(calculatedColumn) {
        // if there is already an aggregated scalar, delete it (possible when editing)
        this.destroyAggregatedScalarLiveValue(calculatedColumn);
        if (calculatedColumn.Query?.AggregatedScalarExpression) try {
            const aggregatedScalarLiveValue = new (0, $204192e364083da9$export$2543999d196edf32)({
                aggregatedScalarExpression: calculatedColumn.Query?.AggregatedScalarExpression
            }, (0, $42e863194fcb493f$export$6619e71706e8514a), this.adaptableApi);
            this.aggregatedScalarLiveValuesMap.set(calculatedColumn.Uuid, aggregatedScalarLiveValue);
        } catch (e) {
            this.adaptableApi.logError(`Creating CalculatedColumn ('${calculatedColumn.Query?.AggregatedScalarExpression}') failed!`, e.message);
        }
    }
    destroyAggregatedScalarLiveValue(calculatedColumn) {
        this.aggregatedScalarLiveValuesMap.delete(calculatedColumn.Uuid);
    }
}




function $f5782452f240f727$export$5cd057a6046189f9(obj) {
    return !!obj && (obj instanceof (0, $4f562137a990678a$export$77cea355fa80b5f4) || (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj.lift) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj.subscribe));
}



/**
 * Converts string to an integer of the specified radix.
 * If radix is undefined or 0, a radix of 10 is used (unlike native parseInt which auto-detects).
 * Drop-in replacement for lodash/parseInt.
 */ function $2515df1f447604e1$export$2e2bcd8739ae039(string, radix) {
    const str = typeof string === 'string' ? string.trim() : String(string);
    return globalThis.parseInt(str, radix || 10);
}






const $d33604e1c9cd4b4a$var$SUPPORTED_AGGREGATION_FNS = [
    'SUM',
    'MIN',
    'MAX',
    'AVG',
    'COUNT'
];
const $d33604e1c9cd4b4a$var$aggregationScalarOperandMap = {
    SUM: [
        'string',
        'number'
    ],
    MIN: [
        'string',
        'number'
    ],
    MAX: [
        'string',
        'number'
    ],
    AVG: [
        'string',
        'number'
    ],
    COUNT: [
        'string',
        'number'
    ]
};
// 0. optional non-capturing block of empty spaces
// 1. block containing a numeric value (any digits) (required)
// 2. block containing a single 'K', 'M' or 'B' letter (optional) (case insensitive)
const $d33604e1c9cd4b4a$var$CRITERIA_REGEX = /^(?:\s*)(\d+)(K|M|B)?$/i;
const $d33604e1c9cd4b4a$export$c9a1d525657ef6a3 = {
    WHERE: {
        handler (args, context) {
            return (0, $fb3b7f5e99ab7e90$export$a22b177b601d93d2)(args, context);
        },
        isHiddenFromMenu: true,
        description: 'Splits 2 composed queries, allowing for a main query(lhs) to have a where clause query(rhs) defined',
        signatures: [
            '<main_query> WHERE <boolean_query>'
        ],
        examples: [
            '<main_query> WHERE <boolean_query>',
            '<main_query> WHERE QUERY("abc")'
        ],
        hasEagerEvaluation: true,
        category: 'conditional'
    },
    SUM: (0, $3c4f25bf4245f8cf$export$5b94276e8442c87f)['SUM'],
    MIN: (0, $3c4f25bf4245f8cf$export$5b94276e8442c87f)['MIN'],
    MAX: (0, $3c4f25bf4245f8cf$export$5b94276e8442c87f)['MAX'],
    AVG: (0, $3c4f25bf4245f8cf$export$5b94276e8442c87f)['AVG'],
    WEIGHT: (0, $3c4f25bf4245f8cf$export$5b94276e8442c87f)['WEIGHT'],
    COUNT: (0, $3c4f25bf4245f8cf$export$5b94276e8442c87f)['COUNT'],
    GROUP_BY: (0, $3c4f25bf4245f8cf$export$5b94276e8442c87f)['GROUP_BY'],
    EQ: {
        handler (args, context) {
            return $d33604e1c9cd4b4a$var$buildBooleanAggregationParameter(args, context, '=', (aggregatedValue, conditionValue)=>aggregatedValue === conditionValue);
        },
        isHiddenFromMenu: true,
        description: 'Evaluates if the aggregation result equals a numerical value defined either as a number or a string abbreviation for thousands(K), millions(M) or billions(B)',
        signatures: [
            'SUM() = number',
            `SUM() = '%number%(K|M|B)'`,
            'EQ(a: SUM(), b: number)',
            `EQ(a: SUM(), b: '%number%(K|M|B)')`
        ],
        examples: [
            `SUM([col1]) = '5M'`,
            'EQ( SUM([col1]), 250000)'
        ],
        category: 'comparison'
    },
    NEQ: {
        handler (args, context) {
            return $d33604e1c9cd4b4a$var$buildBooleanAggregationParameter(args, context, '!=', (aggregatedValue, conditionValue)=>aggregatedValue !== conditionValue);
        },
        isHiddenFromMenu: true,
        description: 'Evaluates if the aggregation result is NOT equal with a numerical value defined either as a number or a string abbreviation for thousands(K), millions(M) or billions(B)',
        signatures: [
            'SUM() != number',
            `SUM() != '%number%(K|M|B)'`,
            'NEQ(a: SUM(), b: number)',
            `NEQ(a: SUM(), b: '%number%(K|M|B)')`
        ],
        examples: [
            `SUM([col1]) != '5M'`,
            'NEQ( SUM([col1]), 250000)'
        ],
        category: 'comparison'
    },
    LT: {
        handler (args, context) {
            return $d33604e1c9cd4b4a$var$buildBooleanAggregationParameter(args, context, '<', (aggregatedValue, conditionValue)=>aggregatedValue < conditionValue);
        },
        isHiddenFromMenu: true,
        description: 'Evaluates if the aggregation result is less than a numerical value defined either as a number or a string abbreviation for thousands(K), millions(M) or billions(B)',
        signatures: [
            'SUM() < number',
            `SUM() < '%number%(K|M|B)'`,
            'LT(a: SUM(), b: number)',
            `LT(a: SUM(), b: '%number%(K|M|B)')`
        ],
        examples: [
            `SUM([col1]) < '5M'`,
            'LT( SUM([col1]), 250000)'
        ],
        category: 'comparison'
    },
    LTE: {
        handler (args, context) {
            return $d33604e1c9cd4b4a$var$buildBooleanAggregationParameter(args, context, '<=', (aggregatedValue, conditionValue)=>aggregatedValue <= conditionValue);
        },
        isHiddenFromMenu: true,
        description: 'Evaluates if the aggregation result is less than or equals a numerical value defined either as a number or a string abbreviation for thousands(K), millions(M) or billions(B)',
        signatures: [
            'SUM() <= number',
            `SUM() <= '%number%(K|M|B)'`,
            'LTE(a: SUM(), b: number)',
            `LTE(a: SUM(), b: '%number%(K|M|B)')`
        ],
        examples: [
            `SUM([col1]) <= '5M'`,
            'LTE( SUM([col1]), 250000)'
        ],
        category: 'comparison'
    },
    GT: {
        handler (args, context) {
            return $d33604e1c9cd4b4a$var$buildBooleanAggregationParameter(args, context, '>', (aggregatedValue, conditionValue)=>aggregatedValue > conditionValue);
        },
        isHiddenFromMenu: true,
        description: 'Evaluates if the aggregation result is greater than a numerical value defined either as a number or a string abbreviation for thousands(K), millions(M) or billions(B)',
        signatures: [
            'SUM() > number',
            `SUM() > '%number%(K|M|B)'`,
            'GT(a: SUM(), b: number)',
            `GT(a: SUM(), b: '%number%(K|M|B)')`
        ],
        examples: [
            `SUM([col1]) > '5M'`,
            'GT( SUM([col1]), 250000)'
        ],
        category: 'comparison'
    },
    GTE: {
        handler (args, context) {
            return $d33604e1c9cd4b4a$var$buildBooleanAggregationParameter(args, context, '>=', (aggregatedValue, conditionValue)=>aggregatedValue >= conditionValue);
        },
        isHiddenFromMenu: true,
        description: 'Evaluates if the aggregation result is greater than or equals a numerical value defined either as a number or a string abbreviation for thousands(K), millions(M) or billions(B)',
        signatures: [
            'SUM() >= number',
            `SUM() >= '%number%(K|M|B)'`,
            'GTE(a: SUM(), b: number)',
            `GTE(a: SUM(), b: '%number%(K|M|B)')`
        ],
        examples: [
            `SUM([col1]) >= '5M'`,
            'GTE( SUM([col1]), 250000)'
        ],
        category: 'comparison'
    },
    COL: {
        handler (args, context) {
            return (0, $fb3b7f5e99ab7e90$export$fca3bbbb640635fc)(args, context);
        },
        description: 'References a column by its unique identifier',
        signatures: [
            '[colName]',
            'COL(name: string)'
        ],
        examples: [
            '[col1]',
            "COL('col1')"
        ],
        category: 'special'
    }
};
const $d33604e1c9cd4b4a$var$buildBooleanAggregationParameter = (args, context, comparisonOperator, conditionFn)=>{
    // LHS
    const aggregationOperand = $d33604e1c9cd4b4a$var$extractScalarAggregationOperand(comparisonOperator, args[0]);
    // RHS
    const scalarOperand = $d33604e1c9cd4b4a$var$extractScalarOperand(comparisonOperator, args[1], $d33604e1c9cd4b4a$var$aggregationScalarOperandMap[aggregationOperand.name]);
    return {
        type: 'aggregationBoolean',
        name: aggregationOperand.name,
        scalarAggregation: aggregationOperand,
        conditionValue: scalarOperand,
        conditionFn: conditionFn
    };
};
const $d33604e1c9cd4b4a$var$extractScalarAggregationOperand = (consumingFunctionName, argument)=>{
    const result = argument;
    if (result == undefined || result.type !== 'aggregationScalar' || !$d33604e1c9cd4b4a$var$SUPPORTED_AGGREGATION_FNS.includes(result.name)) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)(consumingFunctionName, `comparison operator expects as a left-hand operand an aggregation function of type '${$d33604e1c9cd4b4a$var$SUPPORTED_AGGREGATION_FNS.join(' | ')}'`);
    return result;
};
const $d33604e1c9cd4b4a$var$extractScalarOperand = (consumingFunctionName, value, allowedTypes)=>{
    if (value == undefined || !allowedTypes.find((allowedType)=>typeof value === allowedType)) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)(consumingFunctionName, `comparison operator expects as a right-hand operand a scalar value of type '${allowedTypes.join(' | ')}'`);
    if (typeof value === 'number') return value;
    // assertion is safe, we checked in the IF above
    const stringValue = value;
    const matchingResult = stringValue.match($d33604e1c9cd4b4a$var$CRITERIA_REGEX);
    const numericString = matchingResult?.[1];
    const largeNumberUnit = matchingResult?.[2] ?? 'number';
    if (!numericString) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('Numeric abbreviation', `"${stringValue}" is invalid, expecting a number with a suffix for thousands(K), millions(M) or billions(B)"`);
    // unit -> number
    const numberUnitRatios = {
        number: 1,
        k: 1000,
        m: 1000000,
        b: 1000000000
    };
    // numeric value
    return (0, $2515df1f447604e1$export$2e2bcd8739ae039)(numericString) * numberUnitRatios[largeNumberUnit.toLowerCase()];
};
const $d33604e1c9cd4b4a$export$e3988a154eaa30a1 = (0, $19aa91e82c6d8270$export$5206d47972fefe20)($d33604e1c9cd4b4a$export$c9a1d525657ef6a3);







var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};



function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]);
}



function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();



function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]);
}




function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $5c96a02c592fcff1$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $4f562137a990678a$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]();
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $18eb28ff53cc4943$export$ebf645db02d3e99f));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $54b99b9095e84ce4$export$cf4785e597badab3)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $5c96a02c592fcff1$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}


function $8312939aeeb1a4f7$export$260e5c0943f31606(observableFactory) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(observableFactory()).subscribe(subscriber);
    });
}



function $cd8e5ea142a386bd$export$187e35932e88c15c(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.schedule);
}


function $3b29c258456d9a89$var$last(arr) {
    return arr[arr.length - 1];
}
function $3b29c258456d9a89$export$9ae19b645239a61b(args) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$29534b2f653ae592(args) {
    return (0, $cd8e5ea142a386bd$export$187e35932e88c15c)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $3b29c258456d9a89$var$last(args) === 'number' ? args.pop() : defaultValue;
}



function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}




function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}





function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}



function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)((0, $54b99b9095e84ce4$export$cf4785e597badab3)(input), scheduler);
}


function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return (0, $e3a1d71c442b5de9$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return (0, $0ce5b91768be0a6d$export$b34673931371729a)(input, scheduler);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return (0, $7ea29ae5d684fb04$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return (0, $3a22bf76b9b6de63$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return (0, $7999ea1c5b71ad25$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}



function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $8f2bbfa9b5105688$export$49c44dfc2bb21d70)(input, scheduler) : (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input);
}


function $195e3b3043565ec4$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(args, scheduler);
}



function $35711d117487b96b$export$30fc204bc7867c02(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}



function $cb82533bf03eb8da$export$533b26079ad0b4b(accumulator, seed) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)((0, $35711d117487b96b$export$30fc204bc7867c02)(accumulator, seed, arguments.length >= 2, false, true));
}


function $8b9cd13543d50758$export$85b9a36db797e02b(predicate) {
    return (0, $cb82533bf03eb8da$export$533b26079ad0b4b)(function(total, value, i) {
        return !predicate || predicate(value, i) ? total + 1 : total;
    }, 0);
}




var $25237a26c7d2a6e0$export$e19cd5f9376f8cee = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $8343668acd7c4a9b$export$f55210826850c514));



var $7031d5c115ea3033$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $7031d5c115ea3033$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
        return setInterval.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $7031d5c115ea3033$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};



var $d97bc7fc19653fdc$export$b5369ffd7cb2211b = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $7031d5c115ea3033$export$f0ca5e16f6f68711).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $7031d5c115ea3033$export$f0ca5e16f6f68711).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $25237a26c7d2a6e0$export$e19cd5f9376f8cee));



var $94bcb2181a19339b$export$c1895ea2d519a677 = {
    now: function() {
        return ($94bcb2181a19339b$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $35afd13d3a3f6ae1$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $94bcb2181a19339b$export$c1895ea2d519a677).now;
    return Scheduler;
}();


var $5aa4ef89729a15e9$export$4114a3ec92faa3c6 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $35afd13d3a3f6ae1$export$d3e54bb8584cda7c).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $35afd13d3a3f6ae1$export$d3e54bb8584cda7c));


var $2b2c2daf44a1044e$export$8d6b71a2b178fc32 = new (0, $5aa4ef89729a15e9$export$4114a3ec92faa3c6)((0, $d97bc7fc19653fdc$export$b5369ffd7cb2211b));
var $2b2c2daf44a1044e$export$12af436354f1a4f7 = $2b2c2daf44a1044e$export$8d6b71a2b178fc32;




function $64b486e22e2192ab$export$7843a4469d64c07e(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, $2b2c2daf44a1044e$export$8d6b71a2b178fc32);
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}




function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}







function $9cbbbba4f565a378$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $46964ba1b403cbfc$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(resultSelector)) return $46964ba1b403cbfc$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        return (0, $9cbbbba4f565a378$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}



function $4707859e785b3da6$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)((0, $7569c528cdd9d182$export$f0954fd7d5368655), concurrent);
}


function $3a4e37c3b56570cb$export$b314777ae20abca9() {
    return (0, $4707859e785b3da6$export$18aef43295bbe906)(1);
}




function $82eda875fdd470db$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $3a4e37c3b56570cb$export$b314777ae20abca9)()((0, $2fe2b696577919a5$export$6788812c4e6611e6)(args, (0, $3b29c258456d9a89$export$29534b2f653ae592)(args)));
}



var $8faf6f2806f38bc2$export$ccb33e29d92c9a58 = new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $8faf6f2806f38bc2$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $8faf6f2806f38bc2$var$emptyScheduled(scheduler) : $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
}
function $8faf6f2806f38bc2$var$emptyScheduled(scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}




function $e53e80f9042754be$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
    } : (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}





function $55286ae00f8aa486$export$6953b97c7d866605() {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, (0, $528e75db69787807$export$8793edee2d425525)));
    });
}



function $687e56a36053246d$export$e0eaf3a86c03b2ad(value) {
    return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function() {
        return value;
    });
}




function $46d9baf1d6b028a7$export$286ca829307725c9(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(subscriptionDelay.pipe((0, $e53e80f9042754be$export$b7df5d561049483a)(1), (0, $55286ae00f8aa486$export$6953b97c7d866605)()), source.pipe($46d9baf1d6b028a7$export$286ca829307725c9(delayDurationSelector)));
    };
    return (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)(function(value, index) {
        return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(delayDurationSelector(value, index)).pipe((0, $e53e80f9042754be$export$b7df5d561049483a)(1), (0, $687e56a36053246d$export$e0eaf3a86c03b2ad)(value));
    });
}





function $3f3032e6ea410a39$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}


function $bce9e90ba9895d75$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $2b2c2daf44a1044e$export$12af436354f1a4f7);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $cd8e5ea142a386bd$export$187e35932e88c15c)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var due = (0, $3f3032e6ea410a39$export$c03bb0116ee09d4b)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}


function $29c2b0166fc07efc$export$1391212d75b2ee65(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, $2b2c2daf44a1044e$export$8d6b71a2b178fc32);
    var duration = (0, $bce9e90ba9895d75$export$9dc4ecf953986f04)(due, scheduler);
    return (0, $46d9baf1d6b028a7$export$286ca829307725c9)(function() {
        return duration;
    });
}




function $b52129d9072c7912$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(values);
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        (scheduler ? (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(values, source, scheduler) : (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(values, source)).subscribe(subscriber);
    });
}





function $e890d5c5b4491f33$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(notifier).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function() {
            return subscriber.complete();
        }, (0, $528e75db69787807$export$8793edee2d425525)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}





function $3e7edc5b22925f26$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $7569c528cdd9d182$export$f0954fd7d5368655);
}








function $ada720f14bd5f844$export$d449030e5c10edf7() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, $3b29c258456d9a89$export$9ae19b645239a61b)(inputs);
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(inputs[i]).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, $7569c528cdd9d182$export$f0954fd7d5368655))) && (hasValue = null);
                }
            }, (0, $528e75db69787807$export$8793edee2d425525)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            if (ready) {
                var values = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                    value
                ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(values))) : values);
            }
        }));
    });
}






// numeric value(digits) followed by a single 's', 'm' or 'h' letter (case insensitive)
const $7391114ea121c72d$var$TIMEFRAME_REGEX = /^(\d+)(s|m|h)$/i;
const $7391114ea121c72d$var$SYSTEM_MAX_TIMEFRAME_SIZE = 86400000; // 24h
const $7391114ea121c72d$export$94d9fa5facb1c88b = {
    WHERE: {
        handler (args, context) {
            return (0, $fb3b7f5e99ab7e90$export$a22b177b601d93d2)(args, context);
        },
        isHiddenFromMenu: true,
        description: 'Limits the rows against which the Observable expression will be evaluated',
        signatures: [
            '<main_query> WHERE <boolean_query>'
        ],
        examples: [
            '<main_query> WHERE <boolean_query>',
            '<main_query> WHERE QUERY("abc")'
        ],
        hasEagerEvaluation: true,
        category: 'conditional'
    },
    ROW_CHANGE: {
        handler (args, context) {
            const operandParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('ROW_CHANGE', 'operand', [
                'COUNT',
                'MAX',
                'MIN',
                'NONE'
            ], args);
            const timeframeParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('ROW_CHANGE', 'config', [
                'TIMEFRAME'
            ], args);
            let dataChangeLog$ = (0, $fb3b7f5e99ab7e90$export$2b10a53085118826)(context, operandParameter.column);
            switch(operandParameter.name){
                case 'COUNT':
                    {
                        const timeframeChange$ = $7391114ea121c72d$var$getTrailingRowCountChange$(dataChangeLog$, timeframeParameter.value, operandParameter.value);
                        return $7391114ea121c72d$var$getDataChangeCount$(dataChangeLog$, timeframeChange$, operandParameter.value);
                    }
                case 'MIN':
                    {
                        (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(operandParameter.column, [
                            'number'
                        ], 'MIN', context.adaptableApi);
                        const timeframeChange$ = $7391114ea121c72d$var$getTrailingRowValueChange$(dataChangeLog$, timeframeParameter.value);
                        return $7391114ea121c72d$var$getDataChangeMin$(dataChangeLog$, timeframeChange$);
                    }
                case 'MAX':
                    {
                        (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(operandParameter.column, [
                            'number'
                        ], 'MAX', context.adaptableApi);
                        const timeframeChange$ = $7391114ea121c72d$var$getTrailingRowValueChange$(dataChangeLog$, timeframeParameter.value);
                        return $7391114ea121c72d$var$getDataChangeMax$(dataChangeLog$, timeframeChange$);
                    }
                case 'NONE':
                    return dataChangeLog$.pipe(// wait for the given time
                    (0, $64b486e22e2192ab$export$7843a4469d64c07e)(timeframeParameter.value), // completing the observable (ex. alert deletion) will also fire the NONE event
                    // takeUntil takes care of this, ignoring any emissions as soon as the source completes
                    // (count() result is irrelevant here, the main thing is that it emits an source completion)
                    (0, $e890d5c5b4491f33$export$ac8dfd3a7ad06e80)(dataChangeLog$.pipe((0, $8b9cd13543d50758$export$85b9a36db797e02b)())));
            }
        },
        returnType: 'boolean',
        description: 'Observes changes with each row in a distinct scope',
        signatures: [
            'ROW_CHANGE(changeFunction: COUNT|MIN|MAX|NONE, timeframe:TIMEFRAME)'
        ],
        examples: [
            "ROW_CHANGE( COUNT([columnName],2),TIMEFRAME('20s'))",
            "ROW_CHANGE( MAX(COL('columnName')), TIMEFRAME('20s'))"
        ],
        category: 'observable'
    },
    GRID_CHANGE: {
        handler (args, context) {
            const operandParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('GRID_CHANGE', 'operand', [
                'COUNT',
                'MAX',
                'MIN',
                'NONE'
            ], args);
            const timeframeParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)('GRID_CHANGE', 'config', [
                'TIMEFRAME'
            ], args);
            let dataChangeLog$ = (0, $fb3b7f5e99ab7e90$export$2b10a53085118826)(context, operandParameter.column);
            switch(operandParameter.name){
                case 'COUNT':
                    {
                        const timeframeChange$ = $7391114ea121c72d$var$getTrailingGridCountChange$(dataChangeLog$, timeframeParameter.value, operandParameter.value);
                        return $7391114ea121c72d$var$getDataChangeCount$(dataChangeLog$, timeframeChange$, operandParameter.value);
                    }
                case 'MIN':
                    {
                        (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(operandParameter.column, [
                            'number'
                        ], 'MIN', context.adaptableApi);
                        const timeframeChange$ = $7391114ea121c72d$var$getTrailingGridValueChange$(dataChangeLog$, timeframeParameter.value);
                        return $7391114ea121c72d$var$getDataChangeMin$(dataChangeLog$, timeframeChange$);
                    }
                case 'MAX':
                    {
                        (0, $fb3b7f5e99ab7e90$export$a81e9103c93c1fd5)(operandParameter.column, [
                            'number'
                        ], 'MAX', context.adaptableApi);
                        const timeframeChange$ = $7391114ea121c72d$var$getTrailingGridValueChange$(dataChangeLog$, timeframeParameter.value);
                        return $7391114ea121c72d$var$getDataChangeMax$(dataChangeLog$, timeframeChange$);
                    }
                case 'NONE':
                    return dataChangeLog$.pipe(// add a synthetic first value to ensure the grid is observed even when there are no changes
                    (0, $b52129d9072c7912$export$a4fe86229b0e9bdd)($7391114ea121c72d$var$getDataChangedInfoStub(context)), // wait for the given time
                    (0, $64b486e22e2192ab$export$7843a4469d64c07e)(timeframeParameter.value), // completing the observable (ex. alert deletion) will also fire the NONE event
                    // takeUntil takes care of this, ignoring any emissions as soon as the source completes
                    // (count() result is irrelevant here, the main thing is that it emits a source completion)
                    (0, $e890d5c5b4491f33$export$ac8dfd3a7ad06e80)(dataChangeLog$.pipe((0, $8b9cd13543d50758$export$85b9a36db797e02b)())));
            }
        },
        returnType: 'boolean',
        description: 'Observes changes with the entire grid in a single scope',
        signatures: [
            'GRID_CHANGE(changeFunction: COUNT|MIN|MAX|NONE, timeframe:TIMEFRAME)'
        ],
        examples: [
            "GRID_CHANGE( COUNT([columnName],2),TIMEFRAME('20s'))",
            "GRID_CHANGE( MAX(COL('columnName')), TIMEFRAME('20s'))"
        ],
        category: 'observable'
    },
    ROW_ADDED: {
        handler (args, context) {
            const gridChangeLog$ = (0, $fb3b7f5e99ab7e90$export$2479247589b10d17)(context, 'Add');
            return $7391114ea121c72d$var$handleGridRowAddedOrRemoved(args, gridChangeLog$, 'ROW_ADDED', context);
        },
        returnType: 'boolean',
        description: 'Observes added rows in the grid',
        signatures: [
            'ROW_ADDED()',
            'ROW_ADDED(rowCount: number)',
            'ROW_ADDED(timeframe:TIMEFRAME)',
            'ROW_ADDED(rowCount: number, timeframe:TIMEFRAME)'
        ],
        examples: [
            'ROW_ADDED()',
            'ROW_ADDED(2)',
            "ROW_ADDED(TIMEFRAME('20s'))",
            "ROW_ADDED(2, TIMEFRAME('20s'))"
        ],
        category: 'observable'
    },
    ROW_REMOVED: {
        handler (args, context) {
            const gridChangeLog$ = (0, $fb3b7f5e99ab7e90$export$2479247589b10d17)(context, 'Delete');
            return $7391114ea121c72d$var$handleGridRowAddedOrRemoved(args, gridChangeLog$, 'ROW_REMOVED', context);
        },
        returnType: 'boolean',
        description: 'Observes removed rows in the grid',
        signatures: [
            'ROW_REMOVED()',
            'ROW_REMOVED(rowCount: number)',
            'ROW_REMOVED(timeframe:TIMEFRAME)',
            'ROW_REMOVED(rowCount: number, timeframe:TIMEFRAME)'
        ],
        examples: [
            'ROW_REMOVED()',
            'ROW_REMOVED(2)',
            "ROW_REMOVED(TIMEFRAME('20s'))",
            "ROW_REMOVED(2, TIMEFRAME('20s'))"
        ],
        category: 'observable'
    },
    COL: {
        handler (args, context) {
            return (0, $fb3b7f5e99ab7e90$export$fca3bbbb640635fc)(args, context);
        },
        description: 'References a column by its unique identifier',
        signatures: [
            '[colName]',
            'COL(name: string)'
        ],
        examples: [
            '[col1]',
            "COL('col1')"
        ],
        category: 'special'
    },
    COUNT: {
        handler (args) {
            const columnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('COUNT', args);
            const countValue = args.find((arg)=>typeof arg === 'number');
            if (countValue == null || countValue <= 0) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('COUNT', 'expects a positive number as argument');
            const result = {
                type: 'operand',
                name: 'COUNT',
                value: countValue,
                column: columnParameter.value
            };
            return result;
        },
        description: 'Observes if a column value has changed a given number of times.\nValid only as an operand for an observable function.',
        signatures: [
            'COUNT([colName],changeCount: number)',
            'COUNT(COL(name: string),changeCount: number)'
        ],
        examples: [
            'COUNT([colName],2)',
            `COUNT(COL('col1'),10)`
        ],
        category: 'operand'
    },
    NONE: {
        handler (args) {
            const columnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('NONE', args);
            const result = {
                type: 'operand',
                name: 'NONE',
                column: columnParameter.value
            };
            return result;
        },
        description: 'Observes if a column value has NOT changed.\nValid only as an operand for an observable function.',
        signatures: [
            'NONE([colName])',
            'NONE(COL(name: string))'
        ],
        examples: [
            'NONE([colA])',
            `NONE(COL('col1'))`
        ],
        category: 'operand'
    },
    MIN: {
        handler (args) {
            const columnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('MIN', args);
            const result = {
                type: 'operand',
                name: 'MIN',
                column: columnParameter.value
            };
            return result;
        },
        description: 'Observes if the changed column value is the lowest.\nValid only as an operand for an observable function.',
        signatures: [
            'MIN([colName])',
            'MIN(COL(name: string))'
        ],
        examples: [
            'MIN([colA])',
            `MIN(COL('col1'))`
        ],
        category: 'operand'
    },
    MAX: {
        handler (args) {
            const columnParameter = (0, $fb3b7f5e99ab7e90$export$32951e4da4746c73)('MAX', args);
            const result = {
                type: 'operand',
                name: 'MAX',
                column: columnParameter.value
            };
            return result;
        },
        description: 'Observes if the changed column value is the highest.\nValid only as an operand for an observable function.',
        signatures: [
            'MAX([colName])',
            'MAX(COL(name: string))'
        ],
        examples: [
            'MAX([colA])',
            `MAX(COL('col1'))`
        ],
        category: 'operand'
    },
    TIMEFRAME: {
        handler (args, context) {
            // unit -> milliseconds
            const durationUnitRatios = {
                s: 1000,
                m: 60000,
                h: 3600000
            };
            const input = args[0] + '';
            //we allow only seconds, minutes & hours durations
            const matchingResult = input.match($7391114ea121c72d$var$TIMEFRAME_REGEX);
            const value = matchingResult?.[1];
            const unit = matchingResult?.[2]?.toLowerCase();
            let duration;
            if (value && unit && durationUnitRatios[unit]) duration = (0, $2515df1f447604e1$export$2e2bcd8739ae039)(value) * durationUnitRatios[unit];
            if (!duration) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('TIMEFRAME', `timeframe expression is invalid`);
            // check if the given duration is greater than the generally defined maxTimeframe size
            duration = $7391114ea121c72d$var$getMaxTimeframeSize(duration, context);
            const result = {
                type: 'config',
                name: 'TIMEFRAME',
                value: duration
            };
            return result;
        },
        description: 'Limits the monitoring operators to a trailing timeframe defined in seconds, minutes or hours.\nValid only as an operand for an observable function.',
        signatures: [
            "TIMEFRAME('%numeric_value%s')",
            "TIMEFRAME('%numeric_value%m')",
            "TIMEFRAME('%numeric_value%h')"
        ],
        examples: [
            "TIMEFRAME('20s')",
            "TIMEFRAME('5m')",
            "TIMEFRAME('1h')"
        ],
        category: 'operand'
    }
};
const $7391114ea121c72d$export$e493db97372bc557 = (0, $19aa91e82c6d8270$export$5206d47972fefe20)($7391114ea121c72d$export$94d9fa5facb1c88b);
// return TRUE if the last(tail) element has the greatest value
const $7391114ea121c72d$var$isLastElementMaxValue = (values)=>{
    const [tailValue] = values.slice(-1);
    const restValues = values.slice(0, -1);
    return restValues.every((value)=>value < tailValue);
};
// return TRUE if the last(tail) element has the greatest value
const $7391114ea121c72d$var$isLastElementMinValue = (values)=>{
    const [tailValue] = values.slice(-1);
    const restValues = values.slice(0, -1);
    return restValues.every((value)=>value > tailValue);
};
// useful for functions which do NOT have an initial change (ex. GRID_CHANGE NONE)
const $7391114ea121c72d$var$getDataChangedInfoStub = (context)=>{
    let rowNodeStub;
    if (!context.filterFn) rowNodeStub = context.node ?? context.adaptableApi.gridApi.getFirstRowNode();
    else // if there is a WHERE clause defined, find the first rowNode which satisfies the condition
    context.adaptableApi.internalApi.forAllRowNodesDo((rowNode)=>{
        if (!rowNodeStub) {
            if (context.filterFn(rowNode)) rowNodeStub = rowNode;
        }
    });
    const rowNode = rowNodeStub;
    if (rowNode) {
        const primaryKeyValue = context.adaptableApi.gridApi.getPrimaryKeyValueForRowNode(rowNode);
        const columnId = context.adaptableApi.columnApi.internalApi.getQueryableColumnsForUIEditor()[0]?.columnId;
        const oldValue = context.adaptableApi.gridApi.getCellRawValue(primaryKeyValue, columnId);
        const column = context.adaptableApi.columnApi.getColumnWithColumnId(columnId);
        const newValue = oldValue;
        return {
            changedAt: Date.now(),
            rowNode: rowNode,
            primaryKeyValue: primaryKeyValue,
            column: column,
            oldValue: oldValue,
            newValue: newValue
        };
    } else return {
        changedAt: Date.now()
    };
};
// returns an observable which fires if the source$ emitted `targetCount` times in the given `timeframeChange$` period
const $7391114ea121c72d$var$getDataChangeCount$ = (dataChangeLog$, timeframeChange$, targetCount)=>{
    return dataChangeLog$.pipe((0, $ada720f14bd5f844$export$d449030e5c10edf7)(timeframeChange$), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([_, changeCountWithinTimeframe])=>{
        return targetCount === changeCountWithinTimeframe;
    }), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([source])=>source));
};
// returns an observable which fires if the last source$ emission had the lowest(min) value in the given `timeframeChange$` period
const $7391114ea121c72d$var$getDataChangeMin$ = (dataChangeLog$, timeframeChange$)=>{
    return dataChangeLog$.pipe((0, $ada720f14bd5f844$export$d449030e5c10edf7)(timeframeChange$), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([changeLog, values])=>{
        return values.length > 1 ? $7391114ea121c72d$var$isLastElementMinValue(values) : (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(changeLog.oldValue) > (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(changeLog.newValue);
    }), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([changeLog])=>{
        return changeLog;
    }));
};
// returns an observable which fires if the last source$ emission had the highest(max) value in the given `timeframeChange$` period
const $7391114ea121c72d$var$getDataChangeMax$ = (dataChangeLog$, timeframeChange$)=>{
    return dataChangeLog$.pipe((0, $ada720f14bd5f844$export$d449030e5c10edf7)(timeframeChange$), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([changeLog, values])=>{
        return values.length > 1 ? $7391114ea121c72d$var$isLastElementMaxValue(values) : (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(changeLog.oldValue) < (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(changeLog.newValue);
    }), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([changeLog])=>{
        return changeLog;
    }));
};
// returns an observable which maps a dataChangeLogEntry to the number(count) of changed values in the entire grid
// the counter is continuously up-to-date in the given timeframe
// if the given counterLimit is reached, the counter is reset
const $7391114ea121c72d$var$getTrailingGridCountChange$ = (source$, trailingPeriod, counterLimit)=>{
    return (0, $8312939aeeb1a4f7$export$260e5c0943f31606)(()=>{
        // keep the counter value in an internal intermediary state
        let counter = 0;
        const movingTimeWindow$ = $7391114ea121c72d$var$getSlidingTimeframe$(source$, trailingPeriod, (dataChangeLog)=>{
            counter++;
        }, (dataChangeLog)=>{
            // counter may have been reset during the timeframe, in which case we skip the decrement
            if (counter > 0) counter--;
        });
        return movingTimeWindow$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)(()=>{
            const gridCounter = counter;
            if (gridCounter === counterLimit) // reset counter
            counter = 0;
            return gridCounter;
        }));
    });
};
// returns an observable which maps a dataChangeLogEntry to the number(count) of changed values in the row of the given dataChangeLogEntry
// the counter is continuously up-to-date in the given timeframe
// if the given counterLimit is reached, the counter is reset
const $7391114ea121c72d$var$getTrailingRowCountChange$ = (source$, trailingPeriod, counterLimit)=>{
    return (0, $8312939aeeb1a4f7$export$260e5c0943f31606)(()=>{
        // keep the counter value in an internal intermediary state (distinct per row PK)
        const counterMap = new Map();
        const getCellCounter = (dataChangeLog)=>counterMap.get(dataChangeLog.primaryKeyValue) ?? 0;
        const slidingTimeframe$ = $7391114ea121c72d$var$getSlidingTimeframe$(source$, trailingPeriod, (dataChangeLog)=>{
            let currentCounter = getCellCounter(dataChangeLog);
            counterMap.set(dataChangeLog.primaryKeyValue, ++currentCounter);
        }, (dataChangeLog)=>{
            let currentCounter = getCellCounter(dataChangeLog);
            // counter may have been reset during the timeframe, in which case we skip the decrement
            if (currentCounter > 0) counterMap.set(dataChangeLog.primaryKeyValue, --currentCounter);
        });
        return slidingTimeframe$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((dataChangeLog)=>{
            const cellCounter = getCellCounter(dataChangeLog);
            if (cellCounter === counterLimit) // reset counter
            counterMap.set(dataChangeLog.primaryKeyValue, 0);
            return cellCounter;
        }));
    });
};
// returns an observable which maps a dataChangeLogEntry to the array of changed values in the entire grid
// the changed values array is continuously up-to-date in the given timeframe
const $7391114ea121c72d$var$getTrailingGridValueChange$ = (source$, trailingPeriod)=>{
    return (0, $8312939aeeb1a4f7$export$260e5c0943f31606)(()=>{
        // keep the changed values in an internal intermediary state
        let values = [];
        const doubleInsertionsMap = new WeakMap();
        const slidingTimeframe$ = $7391114ea121c72d$var$getSlidingTimeframe$(source$, trailingPeriod, (dataChangeLog)=>{
            if (!values.length) {
                // values is empty, so we evaluate both old & new node values
                values.push((0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(dataChangeLog.oldValue));
                // mark the double insertion, we will have to pop 2 elements
                doubleInsertionsMap.set(dataChangeLog, true);
            }
            values.push((0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(dataChangeLog.newValue));
        }, (dataChangeLog)=>{
            values.shift();
            if (doubleInsertionsMap.get(dataChangeLog)) {
                // the current change inserted both old and new values, so we have to extract 2 elements
                values.shift();
                doubleInsertionsMap.delete(dataChangeLog);
            }
        });
        return slidingTimeframe$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)(()=>values));
    });
};
// returns an observable which maps a dataChangeLogEntry to the array of changed values in the row of the given dataChangeLogEntry
// the changed values array is continuously up-to-date in the given timeframe
const $7391114ea121c72d$var$getTrailingRowValueChange$ = (source$, trailingPeriod)=>{
    return (0, $8312939aeeb1a4f7$export$260e5c0943f31606)(()=>{
        // keep the changed values in an internal intermediary state (distinct per row PK)
        const rowValuesMap = new Map();
        const doubleInsertionsMap = new WeakMap();
        const getRowValues = (dataChangeLog)=>rowValuesMap.get(dataChangeLog.primaryKeyValue) ?? [];
        const slidingTimeframe$ = $7391114ea121c72d$var$getSlidingTimeframe$(source$, trailingPeriod, (dataChangeLog)=>{
            let rowValues = getRowValues(dataChangeLog);
            if (!rowValues.length) {
                // values is empty, so we evaluate both old & new node values
                rowValues.push((0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(dataChangeLog.oldValue));
                // mark the double insertion, we will have to pop 2 elements
                doubleInsertionsMap.set(dataChangeLog, true);
            }
            rowValues.push((0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(dataChangeLog.newValue));
            rowValuesMap.set(dataChangeLog.primaryKeyValue, rowValues);
        }, (dataChangeLog)=>{
            let rowValues = getRowValues(dataChangeLog);
            rowValues.shift();
            if (doubleInsertionsMap.get(dataChangeLog)) {
                // the current change inserted both old and new values, so we have to extract 2 elements
                rowValues.shift();
                doubleInsertionsMap.delete(dataChangeLog);
            }
            rowValuesMap.set(dataChangeLog.primaryKeyValue, rowValues);
        });
        return slidingTimeframe$.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((dataChangeLog)=>getRowValues(dataChangeLog)));
    });
};
// return an observable which will emit when the source$ event enters, respectively exits the timeframe
// it also executes the provided onEnter/onExit handlers
const $7391114ea121c72d$var$getSlidingTimeframe$ = (source$, timeframeDuration, onTimeframeEnter, onTimeframeExit)=>{
    return source$.pipe(// create intermediary observable which, for each emission from source$:
    (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)((dataChangeLog)=>{
        // 1. it will emit the payload immediately...
        const enter$ = (0, $195e3b3043565ec4$export$ba255e9e49e00608)(dataChangeLog).pipe(// ...and execute the provided onPushHandler() callback
        (0, $3e7edc5b22925f26$export$3f23594af5f37336)((dataChangeLog)=>onTimeframeEnter(dataChangeLog)));
        // 2. and after a given 'timeWindowSize' delay it will re-emit the payload...
        const exit$ = (0, $195e3b3043565ec4$export$ba255e9e49e00608)(dataChangeLog).pipe((0, $29c2b0166fc07efc$export$1391212d75b2ee65)(timeframeDuration), // ...and execute the provided onPopHandler() callback
        (0, $3e7edc5b22925f26$export$3f23594af5f37336)((dataChangeLog)=>onTimeframeExit(dataChangeLog)));
        return (0, $195e3b3043565ec4$export$ba255e9e49e00608)(enter$, exit$).pipe((0, $4707859e785b3da6$export$18aef43295bbe906)());
    }));
};
const $7391114ea121c72d$var$getMaxTimeframeSize = (expressionValue, context)=>{
    let maxTimeframeSize = context.adaptableApi.optionsApi.getExpressionOptions().maxTimeframeSize;
    if (maxTimeframeSize > $7391114ea121c72d$var$SYSTEM_MAX_TIMEFRAME_SIZE) maxTimeframeSize = $7391114ea121c72d$var$SYSTEM_MAX_TIMEFRAME_SIZE;
    return expressionValue > maxTimeframeSize ? maxTimeframeSize : expressionValue;
};
const $7391114ea121c72d$var$handleGridRowAddedOrRemoved = (args, gridChangeLog$, consumingFunction, context)=>{
    let countValue = args.find((arg)=>typeof arg === 'number');
    if (countValue < 0) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)(consumingFunction, 'supports only zero or a positive number as argument');
    let timeframeParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)(consumingFunction, 'config', [
        'TIMEFRAME'
    ], args, {
        isOptional: true
    });
    if (countValue === 0 && timeframeParameter == null) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)(consumingFunction, 'requires a TIMEFRAME parameter when observing for no changes');
    if (countValue == null && timeframeParameter == null) // default - return all new rows
    return gridChangeLog$;
    if (countValue == null) // default count value of 1
    countValue = 1;
    if (timeframeParameter == null) // default time parameter of max
    timeframeParameter = {
        name: 'TIMEFRAME',
        type: 'config',
        value: $7391114ea121c72d$var$SYSTEM_MAX_TIMEFRAME_SIZE
    };
    if (countValue === 0) {
        // handle special case when observing NO changes
        const rowDataChangeInfoStub = {
            rowTrigger: consumingFunction === 'ROW_ADDED' ? 'Add' : 'Delete',
            rowNodes: [],
            dataRows: [],
            changedAt: Date.now(),
            ...context.adaptableApi.internalApi.buildBaseContext()
        };
        return gridChangeLog$.pipe(// add a synthetic first value to ensure the grid is observed even when there are no changes
        (0, $b52129d9072c7912$export$a4fe86229b0e9bdd)(rowDataChangeInfoStub), // wait for the given time
        (0, $64b486e22e2192ab$export$7843a4469d64c07e)(timeframeParameter.value), // completing the observable (ex. alert deletion) will also fire the NONE event
        // takeUntil takes care of this, ignoring any emissions as soon as the source completes
        // (count() result is irrelevant here, the main thing is that it emits a source completion)
        (0, $e890d5c5b4491f33$export$ac8dfd3a7ad06e80)(gridChangeLog$.pipe((0, $8b9cd13543d50758$export$85b9a36db797e02b)())));
    }
    const timeframeChange$ = $7391114ea121c72d$var$getTrailingGridCountChange$(gridChangeLog$, timeframeParameter.value, countValue);
    return $7391114ea121c72d$var$getDataChangeCount$(gridChangeLog$, timeframeChange$, countValue);
};





function $21c2b10d84e6b5ad$export$86415ebf4eb36b8c(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const sign = $21c2b10d84e6b5ad$var$compareLocalAsc(laterDate_, earlierDate_);
    const difference = Math.abs((0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(laterDate_, earlierDate_));
    laterDate_.setDate(laterDate_.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($21c2b10d84e6b5ad$var$compareLocalAsc(laterDate_, earlierDate_) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $21c2b10d84e6b5ad$var$compareLocalAsc(laterDate, earlierDate) {
    const diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$21c2b10d84e6b5ad$export$2e2bcd8739ae039 = $21c2b10d84e6b5ad$export$86415ebf4eb36b8c;



function $e9cff913190bd013$export$fe114145ae75d197(dateLeft, dateRight) {
    const diff = +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft) - +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$e9cff913190bd013$export$2e2bcd8739ae039 = $e9cff913190bd013$export$fe114145ae75d197;




function $b6a2419fd0059687$export$eb9a03f0e9aa6cea(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$b6a2419fd0059687$export$2e2bcd8739ae039 = $b6a2419fd0059687$export$eb9a03f0e9aa6cea;




function $d2050f4e5c1a3003$export$c817d0312007ea5e(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    return +(0, $b6a2419fd0059687$export$eb9a03f0e9aa6cea)(_date, options) === +(0, $e58340063d97ab50$export$a2258d9c4118825c)(_date, options);
}
var // Fallback for modularized imports:
$d2050f4e5c1a3003$export$2e2bcd8739ae039 = $d2050f4e5c1a3003$export$c817d0312007ea5e;


function $4bb5df50b9b59298$export$fc1ed482c2861792(laterDate, earlierDate, options) {
    const [laterDate_, workingLaterDate, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, laterDate, earlierDate);
    const sign = (0, $e9cff913190bd013$export$fe114145ae75d197)(workingLaterDate, earlierDate_);
    const difference = Math.abs((0, $8aa264ebd3f03841$export$489984ac7c996389)(workingLaterDate, earlierDate_));
    if (difference < 1) return 0;
    if (workingLaterDate.getMonth() === 1 && workingLaterDate.getDate() > 27) workingLaterDate.setDate(30);
    workingLaterDate.setMonth(workingLaterDate.getMonth() - sign * difference);
    let isLastMonthNotFull = (0, $e9cff913190bd013$export$fe114145ae75d197)(workingLaterDate, earlierDate_) === -sign;
    if ((0, $d2050f4e5c1a3003$export$c817d0312007ea5e)(laterDate_) && difference === 1 && (0, $e9cff913190bd013$export$fe114145ae75d197)(laterDate_, earlierDate_) === 1) isLastMonthNotFull = false;
    const result = sign * (difference - +isLastMonthNotFull);
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$4bb5df50b9b59298$export$2e2bcd8739ae039 = $4bb5df50b9b59298$export$fc1ed482c2861792;

function $495af4000bb18bf7$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}



function $84f21af906303191$export$b5147a91dc40ddb7(laterDate, earlierDate, options) {
    const diff = (0, $21c2b10d84e6b5ad$export$86415ebf4eb36b8c)(laterDate, earlierDate, options) / 7;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$84f21af906303191$export$2e2bcd8739ae039 = $84f21af906303191$export$b5147a91dc40ddb7;




function $539ce3f7450453a1$export$c06dce8b38891685(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() - earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$539ce3f7450453a1$export$2e2bcd8739ae039 = $539ce3f7450453a1$export$c06dce8b38891685;


function $bf315c5624a2ab0b$export$ed6bf486f68899ca(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    // -1 if the left date is earlier than the right date
    // 2023-12-31 - 2024-01-01 = -1
    const sign = (0, $e9cff913190bd013$export$fe114145ae75d197)(laterDate_, earlierDate_);
    // First calculate the difference in calendar years
    // 2024-01-01 - 2023-12-31 = 1 year
    const diff = Math.abs((0, $539ce3f7450453a1$export$c06dce8b38891685)(laterDate_, earlierDate_));
    // Now we need to calculate if the difference is full. To do that we set
    // both dates to the same year and check if the both date's month and day
    // form a full year.
    laterDate_.setFullYear(1584);
    earlierDate_.setFullYear(1584);
    // For it to be true, when the later date is indeed later than the earlier date
    // (2026-02-01 - 2023-12-10 = 3 years), the difference is full if
    // the normalized later date is also later than the normalized earlier date.
    // In our example, 1584-02-01 is earlier than 1584-12-10, so the difference
    // is partial, hence we need to subtract 1 from the difference 3 - 1 = 2.
    const partial = (0, $e9cff913190bd013$export$fe114145ae75d197)(laterDate_, earlierDate_) === -sign;
    const result = sign * (diff - +partial);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$bf315c5624a2ab0b$export$2e2bcd8739ae039 = $bf315c5624a2ab0b$export$ed6bf486f68899ca;





var $9OAZF = parcelRequire("9OAZF");



// useful for unary operators which expect a list of arguments
// we extract the provided array elements into a list
const $ef36e87b7f218a7a$var$flattenArguments = (values)=>{
    if (!Array.isArray(values)) return values;
    return values.flat(Infinity);
};
const $ef36e87b7f218a7a$var$sanitizeArguments = (values, allowNaN)=>{
    return values.filter((value)=>value != undefined && value != null && value !== '' && (allowNaN || !isNaN(value)));
};
const $ef36e87b7f218a7a$var$sanitizeNumericResult = (value)=>{
    if (isNaN(value)) return '';
    return value;
};
const $ef36e87b7f218a7a$export$cd51289811461f9 = {
    VAR: {
        handler (args, context) {
            const [functionName, ...optionalArgs] = args;
            if ((0, $9OAZF.default).IsNullOrEmpty(functionName)) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('VAR', 'should have a name');
            return context.evaluateCustomQueryVariable(functionName, optionalArgs);
        },
        description: 'Returns the variable evaluation',
        signatures: [
            'VAR(varName)',
            'VAR(varName, arg1, arg2)'
        ],
        examples: [
            'VAR(CURRENT_USER)',
            'VAR(IS_VALID_VALUE, IS_BLANK([col1]), [col2] < [col3])'
        ],
        category: 'special',
        returnType: 'any'
    },
    COL: {
        handler (args, context) {
            const columnId = args[0];
            const column = context.adaptableApi?.columnApi.getColumnWithColumnId(columnId);
            if (!column) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('COL', `Column name "${columnId}" is not found`);
            if (!column.queryable) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('COL', `Column name "${columnId}" is not queryable`);
            // see #derived_pivot_cell_style
            if (context.pivotResultColumn) {
                const baseColumnId = context.pivotResultColumn.getColDef()?.pivotValueColumn?.getColId();
                if (baseColumnId === columnId) // we evaluate the pivot result column instead of the base column
                return context.adaptableApi?.gridApi.getNormalisedValueFromRowNode(context.node, context.pivotResultColumn.getColId());
            }
            return context.adaptableApi?.gridApi.getNormalisedValueFromRowNode(context.node, columnId);
        },
        description: 'Returns the value of a Column',
        signatures: [
            '[colName]',
            'COL(name: string)'
        ],
        examples: [
            '[col1]',
            'COL("col1")'
        ],
        category: 'special',
        returnType: 'any'
    },
    FIELD: {
        handler (args, context) {
            const fieldName = args[0];
            if ((0, $9OAZF.default).IsNullOrEmpty(fieldName)) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('FIELD', 'requires a field name');
            return context.adaptableApi?.internalApi.getValueUsingField(context.node?.data, fieldName);
        },
        description: 'Returns the value of a row field (not necessarily mapped to a column). If the field is nested, use dot notation (e.g. "nested.fieldName")',
        signatures: [
            'FIELD(fieldName:string)'
        ],
        examples: [
            'FIELD("fieldName")',
            'FIELD("nested.fieldName")'
        ],
        category: 'special',
        returnType: 'any'
    },
    QUERY: {
        handler (args, context) {
            const namedQueryName = args[0];
            if ((0, $9OAZF.default).IsNullOrEmpty(namedQueryName)) return false;
            const namedQuery = context.adaptableApi?.namedQueryApi.getNamedQueryByName(namedQueryName);
            if (!namedQuery) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('QUERY', `Named Query with name ${namedQueryName} not found!`);
            // add query to call stack
            if (!context.namedQueryCallStack) context.namedQueryCallStack = [];
            context.namedQueryCallStack.push(namedQueryName);
            //check if this Named Query is not already evaluated, in which case this would lead to an infinite evaluation cycle
            const firstIndex = context.namedQueryCallStack.indexOf(namedQueryName);
            const lastIndex = context.namedQueryCallStack.lastIndexOf(namedQueryName);
            if (firstIndex !== lastIndex) {
                const cycle = context.namedQueryCallStack.slice(firstIndex, lastIndex + 1);
                throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)(`${namedQueryName}`, ` contains a circular reference: ${cycle.join('  ->  ')}`);
            }
            const queryEvaluationResult = (0, $3f77892da2e22ac4$export$fef61f332f2c0afc)(namedQuery.BooleanExpression, context);
            // remove query name from callstack
            context.namedQueryCallStack?.pop();
            return queryEvaluationResult;
        },
        category: 'special',
        description: 'Returns the evaluation result of the Named Query with the given name',
        signatures: [
            'QUERY("anyNamedQuery")'
        ],
        examples: [
            'QUERY("anyNamedQuery")'
        ],
        returnType: 'boolean'
    },
    TO_ARRAY: {
        handler (args) {
            if (!args?.length) return [];
            return [
                ...args
            ];
        },
        description: 'Creates an array containing all given parameters (which can be scalar values or expressions)',
        signatures: [
            'TO_ARRAY(value1, expression1, value2)'
        ],
        examples: [
            `TO_ARRAY([col1], AVG([col2],[col3]), QUERY("maxValue"))`
        ],
        category: 'special',
        returnType: 'any'
    },
    COALESCE: {
        handler (args) {
            return $ef36e87b7f218a7a$var$flattenArguments(args).find((arg)=>!(arg === null || arg === undefined));
        },
        description: 'Returns the first argument which is not null',
        signatures: [
            'COALESCE(value, value, ...value)'
        ],
        examples: [
            'COALESCE([col1], [col2], [col3], 0)'
        ],
        category: 'special',
        returnType: 'string'
    },
    NULL: {
        handler: ()=>{
            return null;
        },
        description: 'Returns the NULL literal which represents the intentional absence of any object value',
        category: 'special',
        returnType: 'null',
        signatures: [
            'NULL'
        ],
        examples: [
            '[status] = "accepted" ? 100 : NULL'
        ]
    },
    IS_BLANK: {
        handler (args) {
            return args[0] === undefined || args[0] === null || args[0] === '';
        },
        category: 'special',
        description: 'Returns true if input value is undefined, null, or an empty string',
        signatures: [
            'IS_BLANK(input: any)'
        ],
        examples: [
            'IS_BLANK([col1])'
        ],
        returnType: 'boolean'
    },
    IS_NOT_BLANK: {
        handler (args) {
            return args[0] !== undefined && args[0] !== null && String(args[0]).trim() !== '';
        },
        category: 'special',
        description: 'Returns true if input value is not empty',
        signatures: [
            'IS_NOT_BLANK(input: any)'
        ],
        examples: [
            'IS_NOT_BLANK([col1])'
        ],
        returnType: 'boolean'
    },
    ABS: {
        handler (args) {
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(Math.abs(args[0]));
        },
        isHiddenFromMenu: true,
        description: 'Returns the absolute value of the given number',
        signatures: [
            'ABS(a: number)'
        ],
        examples: [
            'ABS([columnName])'
        ],
        category: 'maths',
        returnType: 'number'
    },
    CEILING: {
        handler (args) {
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(Math.ceil(args[0]));
        },
        isHiddenFromMenu: true,
        description: 'Returns smallest integer greater than or equal to the given number',
        signatures: [
            'CEILING(a: number)'
        ],
        examples: [
            'CEILING([columnName])'
        ],
        category: 'maths',
        returnType: 'number'
    },
    FLOOR: {
        handler (args) {
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(Math.floor(args[0]));
        },
        isHiddenFromMenu: true,
        description: 'Returns largest integer less than or equal to the given number',
        signatures: [
            'FLOOR(a: number)'
        ],
        examples: [
            'FLOOR([columnName])'
        ],
        category: 'maths',
        returnType: 'number'
    },
    ROUND: {
        handler (args) {
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(Math.round(args[0]));
        },
        isHiddenFromMenu: true,
        description: 'Returns value of the given number rounded to the nearest integer',
        signatures: [
            'ROUND(a: number)'
        ],
        examples: [
            'ROUND([columnName])'
        ],
        category: 'maths',
        returnType: 'number'
    },
    MIN: {
        handler (args) {
            return Math.min(...$ef36e87b7f218a7a$var$sanitizeArguments($ef36e87b7f218a7a$var$flattenArguments(args)));
        },
        description: 'Returns the smallest of given numbers',
        signatures: [
            'MIN(number, number, ...number)'
        ],
        examples: [
            'MIN([col1], 5)'
        ],
        category: 'maths',
        returnType: 'number'
    },
    MAX: {
        handler (args) {
            return Math.max(...$ef36e87b7f218a7a$var$sanitizeArguments($ef36e87b7f218a7a$var$flattenArguments(args)));
        },
        description: 'Returns the highest of given numbers',
        signatures: [
            'MAX(number, number, ...number)'
        ],
        examples: [
            'MAX([col1], 5)'
        ],
        category: 'maths',
        returnType: 'number'
    },
    AVG: {
        handler (args) {
            const sanitizedArguments = $ef36e87b7f218a7a$var$sanitizeArguments($ef36e87b7f218a7a$var$flattenArguments(args));
            if (args.length && !sanitizedArguments.length) // expression is syntactically valid, but operates with incompatible values
            return;
            return sanitizedArguments.reduce((a, b)=>a + b) / sanitizedArguments.length;
        },
        description: 'Returns the average of inputted numbers',
        signatures: [
            'AVG(number, number, ...number)'
        ],
        examples: [
            'AVG([col1], 5)'
        ],
        category: 'maths',
        returnType: 'number'
    },
    ADD: {
        handler (args) {
            const sanitizedArguments = $ef36e87b7f218a7a$var$sanitizeArguments(args, true);
            if (args.length && !sanitizedArguments.length) // expression is syntactically valid, but operates with incompatible values
            return;
            return sanitizedArguments.reduce((a, b)=>a + b);
        },
        isHiddenFromMenu: true,
        description: 'Returns the sum of 2 numbers',
        signatures: [
            'number + number',
            'ADD(a: number, b: number)'
        ],
        examples: [
            '[col1] + 5',
            'ADD([col1], 5)'
        ],
        category: 'maths',
        returnType: 'number'
    },
    SUB: {
        handler (args) {
            const sanitizedArguments = $ef36e87b7f218a7a$var$sanitizeArguments(args);
            if (args.length && !sanitizedArguments.length) // expression is syntactically valid, but operates with incompatible values
            return;
            return sanitizedArguments.reduce((a, b)=>a - b);
        },
        isHiddenFromMenu: true,
        description: 'Returns the difference of 2 numbers',
        signatures: [
            'number - number',
            'SUB(a: number, b: number)'
        ],
        examples: [
            '[col1] - 5',
            'SUB([col1], 5)'
        ],
        category: 'maths',
        returnType: 'number'
    },
    MUL: {
        handler (args) {
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(args.reduce((a, b)=>a * b));
        },
        isHiddenFromMenu: true,
        description: 'Returns the product of 2 numbers',
        signatures: [
            'number * number',
            'mul(a: number, b: number)'
        ],
        examples: [
            '[col1] * 5',
            'mul([col1], 5)'
        ],
        category: 'maths',
        returnType: 'number'
    },
    DIV: {
        handler (args) {
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(args.reduce((a, b)=>a / b));
        },
        isHiddenFromMenu: true,
        description: 'Returns the division of 2 numbers',
        signatures: [
            'number / number',
            'DIV(a: number, b: number)'
        ],
        examples: [
            '[col1] / 5',
            'DIV([col1], 5)'
        ],
        category: 'maths',
        returnType: 'number'
    },
    MOD: {
        handler (args) {
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(args[0] % args[1]);
        },
        isHiddenFromMenu: true,
        description: 'Returns the modulo of 2 numbers',
        signatures: [
            'number % number',
            'MOD(a: number, b: number)'
        ],
        examples: [
            '[col1] % 5',
            'MOD([col1], 5)'
        ],
        category: 'maths',
        returnType: 'number'
    },
    IF: {
        handler (args) {
            return args[0] ? args[1] : args[2];
        },
        isHiddenFromMenu: true,
        description: 'Evaluates a condition expression and returns the result of one of the two expressions, depending on whether the condition expression evaluates to true or false',
        signatures: [
            'condition_expr ? true_statement : false_statement'
        ],
        examples: [
            '[col1] > [col2] ? "BIG" : "SMALL"'
        ],
        category: 'conditional',
        returnType: 'any'
    },
    CASE: {
        handler ([expressionValueNode, whenThenListNodes, defaultValueNode], context) {
            const caseExpressionValue = expressionValueNode != undefined ? (0, $fb3b7f5e99ab7e90$export$9c7ccef250f68ece)(expressionValueNode, context) : true;
            const matchingWhen = whenThenListNodes.find((whenThenStatement)=>{
                const whenValue = (0, $fb3b7f5e99ab7e90$export$9c7ccef250f68ece)(whenThenStatement.WHEN, context);
                return whenValue === caseExpressionValue;
            });
            if (!matchingWhen) {
                if (defaultValueNode) return (0, $fb3b7f5e99ab7e90$export$9c7ccef250f68ece)(defaultValueNode, context);
                return;
            }
            const matchingThen = (0, $fb3b7f5e99ab7e90$export$9c7ccef250f68ece)(matchingWhen.THEN, context);
            return matchingThen;
        },
        isHiddenFromMenu: true,
        hasEagerEvaluation: true,
        description: `The syntax of CASE supports 2 variants:
     1. CASE takes an expression and compares its value with each WHEN clause until one of them is equal, whereupon the corresponding THEN clause is executed.
     2. Each expression in the WHEN clause is evaluated until one of them is true, whereupon the corresponding THEN clause is executed.
    If no WHEN clause is satisfied, the ELSE clause is executed if one exists, otherwise NULL is returned`,
        signatures: [
            `CASE <expression> [WHEN <expression> THEN <expression>] [ELSE <expression>] END`,
            `CASE [WHEN <expression> THEN <expression>] [ELSE <expression>] END`
        ],
        examples: [
            `CASE [day] WHEN 'Saturday' THEN 'weekend' WHEN 'Sunday' THEN 'weekend' ELSE 'workday' END`,
            `CASE WHEN [price] < 10 THEN 'low price' WHEN [price] < 50 THEN 'medium price' ELSE 'high price' END`
        ],
        category: 'conditional',
        returnType: 'any'
    },
    POW: {
        handler (args) {
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(Math.pow(args[0], args[1]));
        },
        isHiddenFromMenu: true,
        description: 'Returns the pow of 2 numbers',
        signatures: [
            'number ^ number',
            'POW(a: number, b: number)'
        ],
        examples: [
            '[col1] ^ 5',
            'POW([col1], 5)'
        ],
        category: 'maths',
        returnType: 'number'
    },
    DATE: {
        handler (args) {
            return (0, $a92bacc669eda25d$export$4393d2ccbbedb219)(args[0]);
        },
        description: 'Returns a new date by parsing the given string in ISO 8601 format',
        signatures: [
            'DATE(input: string)',
            'DATE("YYYYMMDD")',
            'DATE("YYYY-MM-DD")',
            'DATE("YYYY-MM-DD HH:SS")'
        ],
        examples: [
            'DATE("20210101")',
            'DATE("2021-01-01")',
            'DATE("2021-01-01 10:10")'
        ],
        category: 'dates',
        returnType: 'date'
    },
    NOW: {
        handler () {
            return new Date();
        },
        description: 'Returns the current date',
        signatures: [
            'NOW()'
        ],
        examples: [
            '[col1] > NOW()'
        ],
        category: 'dates',
        returnType: 'date'
    },
    CURRENT_DAY: {
        handler () {
            return (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(new Date());
        },
        description: 'Returns the current day',
        signatures: [
            'CURRENT_DAY()'
        ],
        examples: [
            '[col1] > CURRENT_DAY()'
        ],
        category: 'dates',
        returnType: 'date'
    },
    DAY: {
        handler (args) {
            return (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(args[0]);
        },
        description: 'Returns the day from a date',
        signatures: [
            'DAY(input: date)'
        ],
        examples: [
            'DAY([col1]) = DAY(NOW())'
        ],
        category: 'dates',
        returnType: 'date'
    },
    WEEK: {
        handler (args) {
            return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(args[0]);
        },
        description: 'Returns the week from a date',
        signatures: [
            'WEEK(input: date)'
        ],
        examples: [
            'WEEK([col1]) = WEEK(NOW())'
        ],
        category: 'dates',
        returnType: 'number'
    },
    MONTH: {
        handler (args) {
            return (0, $c0b4ec5551eca4c9$export$a5a3b454ada2268e)(args[0]);
        },
        description: 'Returns the month from a date',
        signatures: [
            'MONTH(input: date)'
        ],
        examples: [
            'MONTH([col1]) = MONTH(NOW())'
        ],
        category: 'dates',
        returnType: 'number'
    },
    YEAR: {
        handler (args) {
            return (0, $29cc086f79701cd9$export$f91e89d3d0406102)(args[0]);
        },
        description: 'Returns the year from a date',
        signatures: [
            'YEAR(input: date)'
        ],
        examples: [
            'YEAR([col1]) = YEAR(NOW())'
        ],
        category: 'dates',
        returnType: 'date'
    },
    ADD_DAYS: {
        handler (args) {
            return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(args[0], args[1]);
        },
        description: 'Returns a date based on input data and days to add',
        signatures: [
            'ADD_DAYS(input: date, days: number)'
        ],
        examples: [
            'ADD_DAYS(CURRENT_DAY(), 5)',
            'ADD_DAYS([col1], 5)'
        ],
        category: 'dates',
        returnType: 'date'
    },
    ADD_WEEKS: {
        handler (args) {
            return (0, $bce641bd93181421$export$ef501a2bb4f3ee6b)(args[0], args[1]);
        },
        description: 'Returns a date based on input data and weeks to add',
        signatures: [
            'ADD_WEEKS(input: date, weeks: number)'
        ],
        examples: [
            'ADD_WEEKS(CURRENT_DAY(), 5)',
            'ADD_WEEKS([col1], 5)'
        ],
        category: 'dates',
        returnType: 'date'
    },
    ADD_MONTHS: {
        handler (args) {
            return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(args[0], args[1]);
        },
        description: 'Returns a date based on input data and months to add',
        signatures: [
            'ADD_MONTHS(input: date, months: number)'
        ],
        examples: [
            'ADD_MONTHS(CURRENT_DAY(), 5)',
            'ADD_MONTHS([col1], 5)'
        ],
        category: 'dates',
        returnType: 'date'
    },
    ADD_YEARS: {
        handler (args) {
            return (0, $25460c542fb3bf74$export$3d83eec43f4ea476)(args[0], args[1]);
        },
        description: 'Returns a date based on input data and years to add',
        signatures: [
            'ADD_YEARS(input: date, years: number)'
        ],
        examples: [
            'ADD_YEARS(CURRENT_DAY(), 5)',
            'ADD_YEARS([col1], 5)'
        ],
        category: 'dates',
        returnType: 'date'
    },
    DIFF_DAYS: {
        handler (args) {
            const [first, second] = (0, $5a5def29d0cbcbac$export$949ab7c957e48dcc)(args);
            const result = (0, $21c2b10d84e6b5ad$export$86415ebf4eb36b8c)(first, second);
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(result);
        },
        description: 'Returns the difference in days between 2 dates',
        signatures: [
            'DIFF_DAYS(a: date, b: date)'
        ],
        examples: [
            'DIFF_DAYS([col1], CURRENT_DAY())'
        ],
        category: 'dates',
        returnType: 'number'
    },
    DIFF_WEEKS: {
        handler (args) {
            const [first, second] = (0, $5a5def29d0cbcbac$export$949ab7c957e48dcc)(args);
            const result = (0, $84f21af906303191$export$b5147a91dc40ddb7)(first, second);
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(result);
        },
        description: 'Returns the difference in weeks between 2 dates',
        signatures: [
            'DIFF_WEEKS(a: date, b: date)'
        ],
        examples: [
            'DIFF_WEEKS([col1], CURRENT_DAY())'
        ],
        category: 'dates',
        returnType: 'number'
    },
    DIFF_MONTHS: {
        handler (args) {
            const [first, second] = (0, $5a5def29d0cbcbac$export$949ab7c957e48dcc)(args);
            const result = (0, $4bb5df50b9b59298$export$fc1ed482c2861792)(first, second);
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(result);
        },
        description: 'Returns the difference in months between 2 dates',
        signatures: [
            'DIFF_MONTHS(a: date, b: date)'
        ],
        examples: [
            'DIFF_MONTHS([col1], CURRENT_DAY())'
        ],
        category: 'dates',
        returnType: 'number'
    },
    DIFF_YEARS: {
        handler (args) {
            const [first, second] = (0, $5a5def29d0cbcbac$export$949ab7c957e48dcc)(args);
            const result = (0, $bf315c5624a2ab0b$export$ed6bf486f68899ca)(first, second);
            return $ef36e87b7f218a7a$var$sanitizeNumericResult(result);
        },
        description: 'Returns the difference in years between 2 dates',
        signatures: [
            'DIFF_YEARS(a: date, b: date)'
        ],
        examples: [
            'DIFF_YEARS([col1], CURRENT_DAY())'
        ],
        category: 'dates',
        returnType: 'number'
    },
    LEN: {
        handler (args) {
            return args[0] == null || args[0] == undefined ? 0 : String(args[0]).length;
        },
        description: 'Returns the length of a string',
        signatures: [
            'LEN(a: string)'
        ],
        examples: [
            'LEN([col1])'
        ],
        category: 'strings',
        returnType: 'number'
    },
    SUB_STRING: {
        handler (args) {
            return String(args[0]).substring(args[1], args[2]);
        },
        description: 'Extracts characters from string, between 2 indices, returning new sub string',
        signatures: [
            'SUB_STRING(a: string, b: number, c:number)'
        ],
        examples: [
            'SUB_STRING([col1], 1, 5)'
        ],
        category: 'strings',
        returnType: 'string'
    },
    UPPER: {
        handler (args) {
            return String(args[0]).toUpperCase();
        },
        description: 'Converts a string to Upper Case',
        signatures: [
            'UPPER(a: string)'
        ],
        examples: [
            'UPPER([col1])'
        ],
        category: 'strings',
        returnType: 'string'
    },
    LOWER: {
        handler (args) {
            return String(args[0]).toLowerCase();
        },
        description: 'Converts a string to Lower Case',
        signatures: [
            'LOWER(a: string)'
        ],
        examples: [
            'LOWER([col1])'
        ],
        category: 'strings',
        returnType: 'string'
    },
    REPLACE: {
        handler (args, context) {
            if ((0, $fb3b7f5e99ab7e90$export$ebbf16104ac722e7)(context)) return String(args[0]).replace(new RegExp(args[1], 'ig'), args[2]);
            else return String(args[0]).replace(args[1], args[2]);
        },
        description: 'Searches string for specified value returning new string with replaced values',
        signatures: [
            'REPLACE(a: string, b: string, c:string)'
        ],
        examples: [
            'REPLACE([col1], "GBP", "EUR")'
        ],
        category: 'strings',
        returnType: 'string'
    },
    CONCAT: {
        handler (args) {
            return args.join(' ');
        },
        description: 'Concatenates multiple strings',
        signatures: [
            'CONCAT(value1, value2, value3)'
        ],
        examples: [
            'CONCAT([col1], [col2], [col3]'
        ],
        category: 'strings',
        returnType: 'string'
    },
    PERCENT_CHANGE: {
        handler (args, context) {
            if (!context.dataChangedEvent) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('PERCENT_CHANGE', 'is only valid in changed cell contexts');
            const currentValue = (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(args[0], true);
            if (Number.isNaN(currentValue)) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('PERCENT_CHANGE', 'First argument should be numeric');
            const previousValue = context.dataChangedEvent.oldValue;
            const increaseDecrease = args[1];
            let result;
            if (!increaseDecrease) result = $ef36e87b7f218a7a$var$sanitizeNumericResult(Math.abs((currentValue - previousValue) / previousValue * 100));
            else if (increaseDecrease === 'INCREASE') result = currentValue - previousValue > 0 ? $ef36e87b7f218a7a$var$sanitizeNumericResult((currentValue - previousValue) / previousValue * 100) : undefined;
            else if (increaseDecrease === 'DECREASE') result = currentValue - previousValue < 0 ? $ef36e87b7f218a7a$var$sanitizeNumericResult((previousValue - currentValue) / previousValue * 100) : undefined;
            else throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('PERCENT_CHANGE', 'Optional second argument must be "INCREASE" or "DECREASE"');
            return result;
        },
        description: "Returns percentage difference between a cell's current value and previous value",
        signatures: [
            'PERCENT_CHANGE( [colName], <INCREASE|DECREASE> )',
            'PERCENT_CHANGE( COL(name: string), <INCREASE|DECREASE> )'
        ],
        examples: [
            'PERCENT_CHANGE([col1])',
            'PERCENT_CHANGE([col1], "INCREASE")',
            'PERCENT_CHANGE([col1], "DECREASE")'
        ],
        category: 'changes',
        returnType: 'number'
    },
    ABSOLUTE_CHANGE: {
        handler (args, context) {
            if (!context.dataChangedEvent) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('ABSOLUTE_CHANGE', 'is only valid in changed cell contexts');
            const currentValue = (0, $fb3b7f5e99ab7e90$export$7d1258ebb7625a0d)(args[0], true);
            if (Number.isNaN(currentValue)) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('ABSOLUTE_CHANGE', 'First argument should be numeric');
            const previousValue = context.dataChangedEvent.oldValue;
            const increaseDecrease = args[1];
            let result;
            if (!increaseDecrease) result = $ef36e87b7f218a7a$var$sanitizeNumericResult(Math.abs(previousValue - currentValue));
            else if (increaseDecrease === 'INCREASE') result = currentValue - previousValue > 0 ? $ef36e87b7f218a7a$var$sanitizeNumericResult(currentValue - previousValue) : undefined;
            else if (increaseDecrease === 'DECREASE') result = currentValue - previousValue < 0 ? $ef36e87b7f218a7a$var$sanitizeNumericResult(previousValue - currentValue) : undefined;
            else throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('ABSOLUTE_CHANGE', 'Optional second argument must be "INCREASE" or "DECREASE"');
            return result;
        },
        description: "Returns absolute difference between a cell's current value and previous value",
        signatures: [
            'ABSOLUTE_CHANGE( [colName] )',
            'ABSOLUTE_CHANGE( COL(name: string) )',
            'ABSOLUTE_CHANGE( COL(name: string), <INCREASE|DECREASE> )'
        ],
        examples: [
            'ABSOLUTE_CHANGE([col1])',
            'ABSOLUTE_CHANGE([col1], "INCREASE")',
            'ABSOLUTE_CHANGE([col1], "DECREASE")'
        ],
        category: 'changes',
        returnType: 'number'
    },
    ANY_CHANGE: {
        handler (args, context) {
            if (!context.dataChangedEvent) throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('ANY_CHANGE', 'is only valid in changed cell contexts');
            const columnArg = args[0];
            if (!columnArg) // if no column is provided, we check if any value has changed
            return context.dataChangedEvent.oldValue !== context.dataChangedEvent.newValue;
            // only COL argument is supported
            if (columnArg.type !== 'COL') throw new (0, $b346458668d4b64c$export$6f9d4bc737e2a74f)('ANY_CHANGE', 'accepts only a column reference as an argument');
            const currentColumnValue = (0, $558ccc63d44f8999$export$31d960970cb8c965)(columnArg, context);
            const previousValue = context.dataChangedEvent.oldValue;
            return currentColumnValue !== previousValue;
        },
        description: "Returns true if cell's current value is different from previous value, otherwise false; if no column is provided, it checks if any value has changed",
        signatures: [
            'ANY_CHANGE( [colName] )',
            'ANY_CHANGE()'
        ],
        examples: [
            'ANY_CHANGE([col1])',
            'ANY_CHANGE()'
        ],
        category: 'changes',
        returnType: 'boolean',
        hasEagerEvaluation: true
    }
};
const $ef36e87b7f218a7a$export$4ed26c334ed58531 = (0, $19aa91e82c6d8270$export$5206d47972fefe20)($ef36e87b7f218a7a$export$cd51289811461f9);




class $caf984f725867dd9$export$fac7c1d0dc89d92 {
    adaptableApi;
    cacheBooleanValidation = new Map();
    cacheObservableValidation = new Map();
    cacheAggregatedBooleanValidation = new Map();
    cacheAggregatedScalarValidation = new Map();
    cacheModuleSpecificExpressionFunctions = new Map();
    constructor(adaptableApi){
        this.adaptableApi = adaptableApi;
    }
    evaluateBooleanExpression(expression, module, rowNode, evalContext) {
        if (expression == undefined) {
            // should never happen, but just in case
            this.adaptableApi.logError('QueryLanguageService.evaluateBooleanExpression was called with an undefined expression');
            return false;
        }
        const moduleExpressionFunctions = this.getModuleExpressionFunctionsMap(module);
        const booleanAndScalarFunctions = this.getBooleanAndScalarFunctions(moduleExpressionFunctions);
        return $3f77892da2e22ac4$export$fef61f332f2c0afc(expression, {
            node: rowNode,
            functions: booleanAndScalarFunctions,
            evaluateCustomQueryVariable: this.evaluateCustomQueryVariable,
            dataChangedEvent: evalContext?.dataChangedEvent,
            pivotResultColumn: evalContext?.pivotResultColumn,
            ...this.adaptableApi.internalApi.buildBaseContext()
        });
    }
    evaluateScalarExpression(expression, module, rowNode) {
        // currently scalar and boolean expressions are evaluated the same
        return this.evaluateBooleanExpression(expression, module, rowNode);
    }
    evaluateAggregatedScalarExpression(expression, module, getRowNodes) {
        const aggregatedScalarFunctions = this.getModuleExpressionFunctionsMap(module).aggregatedScalarFunctions;
        return $3f77892da2e22ac4$export$fef61f332f2c0afc(expression, {
            node: null,
            functions: aggregatedScalarFunctions,
            evaluateCustomQueryVariable: this.evaluateCustomQueryVariable,
            getRowNodes: getRowNodes,
            ...this.adaptableApi.internalApi.buildBaseContext()
        });
    }
    evaluateObservableExpression(reactiveExpression, module) {
        const moduleExpressionFunctions = this.getModuleExpressionFunctionsMap(module);
        const booleanAndScalarFunctions = this.getBooleanAndScalarFunctions(moduleExpressionFunctions);
        const reactiveExpression$ = $3f77892da2e22ac4$export$fef61f332f2c0afc(reactiveExpression, {
            node: this.adaptableApi.gridApi.getFirstRowNode(),
            functions: moduleExpressionFunctions.observableFunctions,
            whereClauseFunctions: booleanAndScalarFunctions,
            evaluateCustomQueryVariable: this.evaluateCustomQueryVariable,
            ...this.adaptableApi.internalApi.buildBaseContext()
        });
        return reactiveExpression$;
    }
    evaluateAggregatedBooleanExpression(aggregationExpression, module) {
        const moduleExpressionFunctionsMap = this.getModuleExpressionFunctionsMap(module);
        const booleanAndScalarFunctions = this.getBooleanAndScalarFunctions(moduleExpressionFunctionsMap);
        const aggregationEvaluation = $3f77892da2e22ac4$export$fef61f332f2c0afc(aggregationExpression, {
            node: this.adaptableApi.gridApi.getFirstRowNode(),
            functions: moduleExpressionFunctionsMap.aggregatedBooleanFunctions,
            whereClauseFunctions: booleanAndScalarFunctions,
            evaluateCustomQueryVariable: this.evaluateCustomQueryVariable,
            ...this.adaptableApi.internalApi.buildBaseContext()
        });
        return aggregationEvaluation;
    }
    validateBoolean(expressionInput = '', module, config = {
        force: false
    }) {
        const cacheKey = this.getExpressionCacheKey(expressionInput, module);
        try {
            if (this.cacheBooleanValidation.has(cacheKey)) return this.cacheBooleanValidation.get(cacheKey);
            const expression = expressionInput.trim();
            if (expression === '') {
                const result = {
                    isValid: false,
                    errorMessage: 'empty boolean expression'
                };
                this.cacheBooleanValidation.set(cacheKey, result);
                return result;
            }
            const force = config?.force ?? false;
            // see if validation should be performed
            if (!this.adaptableApi.optionsApi.getExpressionOptions().performExpressionValidation && !force) {
                const result = {
                    isValid: true,
                    errorMessage: ''
                };
                this.cacheBooleanValidation.set(cacheKey, result);
                return result;
            }
            const { ast: ast } = $3f77892da2e22ac4$export$98e6a39c04603d36(expression.trim());
            const rootFn = ast[ast.length - 1];
            const moduleExpressionFunctions = this.getModuleExpressionFunctionsMap(module);
            const booleanAndScalarFunctions = this.getBooleanAndScalarFunctions(moduleExpressionFunctions);
            if (rootFn.type === undefined || booleanAndScalarFunctions[rootFn.type] === undefined) {
                const result = {
                    isValid: false,
                    errorMessage: `provided function ${rootFn?.type} cannot be handled`
                };
                this.cacheBooleanValidation.set(cacheKey, result);
                return result;
            }
            if (booleanAndScalarFunctions[rootFn.type].returnType !== 'boolean') {
                const result = {
                    isValid: false,
                    errorMessage: `provided function ${rootFn?.type} is not a predicate`
                };
                this.cacheBooleanValidation.set(cacheKey, result);
                return result;
            }
            // evaluating the expression is the only way to catch circular named query references
            const firstRowNode = this.adaptableApi.gridApi.getFirstRowNode();
            // Mock datachangedevent for change-based functions e.g. PERCENT_CHANGE
            const dataChangedEvent = {
                newValue: 100,
                oldValue: 150
            };
            this.evaluateBooleanExpression(expression, module, firstRowNode, {
                dataChangedEvent: dataChangedEvent
            });
            const result = {
                isValid: true,
                errorMessage: ''
            };
            this.cacheBooleanValidation.set(cacheKey, result);
            return result;
        } catch (error) {
            const result = {
                isValid: false,
                errorMessage: error
            };
            this.cacheBooleanValidation.set(cacheKey, result);
            return result;
        }
    }
    validateObservable(expressionInput = '', module) {
        const cacheKey = this.getExpressionCacheKey(expressionInput, module);
        if (this.cacheObservableValidation.has(cacheKey)) return this.cacheObservableValidation.get(cacheKey);
        const expression = expressionInput.trim();
        if (expression === '') {
            const result = {
                isValid: false,
                errorMessage: 'empty observable expression'
            };
            this.cacheObservableValidation.set(cacheKey, result);
            return result;
        }
        try {
            const observableExpression = this.evaluateObservableExpression(expression, module);
            if (!(0, $f5782452f240f727$export$5cd057a6046189f9)(observableExpression)) {
                const result = {
                    isValid: false,
                    errorMessage: `provided observable expression does not evaluate to an Observable`
                };
                this.cacheObservableValidation.set(cacheKey, result);
                return result;
            }
            const result = {
                isValid: true,
                errorMessage: ''
            };
            this.cacheObservableValidation.set(cacheKey, result);
            return result;
        } catch (error) {
            const result = {
                isValid: false,
                errorMessage: error
            };
            this.cacheObservableValidation.set(cacheKey, result);
            return result;
        }
    }
    validateAggregatedBoolean(expressionInput = '', module) {
        const cacheKey = this.getExpressionCacheKey(expressionInput, module);
        if (this.cacheAggregatedBooleanValidation.has(cacheKey)) return this.cacheAggregatedBooleanValidation.get(cacheKey);
        const expression = expressionInput.trim();
        if (expression === '') {
            const result = {
                isValid: false,
                errorMessage: 'empty AggregatedBoolean expression'
            };
            this.cacheAggregatedBooleanValidation.set(cacheKey, result);
            return result;
        }
        try {
            const evaluationResult = this.evaluateAggregatedBooleanExpression(expression, module);
            if (evaluationResult.type !== 'aggregationBoolean') {
                const result = {
                    isValid: false,
                    errorMessage: 'provided AggregatedBoolean expression does not evaluate to a supported aggregation'
                };
                this.cacheAggregatedBooleanValidation.set(cacheKey, result);
                return result;
            }
            // no exception,so everything seems to be fine
            const result = {
                isValid: true,
                errorMessage: ''
            };
            this.cacheAggregatedBooleanValidation.set(cacheKey, result);
            return result;
        } catch (error) {
            const result = {
                isValid: false,
                errorMessage: error
            };
            this.cacheAggregatedBooleanValidation.set(cacheKey, result);
            return result;
        }
    }
    validateAggregatedScalar(expressionInput = '', module) {
        const cacheKey = this.getExpressionCacheKey(expressionInput, module);
        if (this.cacheAggregatedScalarValidation.has(cacheKey)) return this.cacheAggregatedScalarValidation.get(cacheKey);
        const expression = expressionInput.trim();
        if (expression === '') {
            const result = {
                isValid: false,
                errorMessage: 'empty AggregatedScalar expression'
            };
            this.cacheAggregatedScalarValidation.set(cacheKey, result);
            return result;
        }
        try {
            const evaluationResult = this.evaluateAggregatedScalarExpression(expression, module);
            if (evaluationResult.type !== 'aggregationScalar') {
                const result = {
                    isValid: false,
                    errorMessage: 'provided AggregatedScalar expression does not evaluate to a supported aggregation'
                };
                this.cacheAggregatedScalarValidation.set(cacheKey, result);
                return result;
            }
            // no exception,so everything seems to be fine
            const result = {
                isValid: true,
                errorMessage: ''
            };
            this.cacheAggregatedScalarValidation.set(cacheKey, result);
            return result;
        } catch (error) {
            const result = {
                isValid: false,
                errorMessage: error
            };
            this.cacheAggregatedScalarValidation.set(cacheKey, result);
            return result;
        }
    }
    computeAggregatedBooleanValue(expression, module) {
        const booleanAggregationParameter = this.evaluateAggregatedBooleanExpression(expression, module);
        const aggregatedScalarExpressionEvaluation = booleanAggregationParameter.scalarAggregation.value;
        const aggregatedScalarLiveValue = new (0, $204192e364083da9$export$2543999d196edf32)({
            aggregatedScalarExpressionEvaluation: aggregatedScalarExpressionEvaluation
        }, module, this.adaptableApi);
        const allAggregationValues = aggregatedScalarLiveValue.getAllAggregationValues();
        const numericOperand = booleanAggregationParameter.conditionValue;
        const booleanConditionFn = booleanAggregationParameter.conditionFn;
        return allAggregationValues.some((aggregationValue)=>{
            return booleanConditionFn(aggregationValue, numericOperand);
        });
    }
    getColumnsFromExpression(input = '') {
        return this.getNodesFromExpression(input, 'COL');
    }
    getNamedQueryNamesFromExpression(input = '') {
        return this.getNodesFromExpression(input, 'QUERY');
    }
    getExpressionWithColumnFriendlyNames(expression = '') {
        let result = expression;
        const columnIds = this.getColumnsFromExpression(expression);
        columnIds.forEach((columnId)=>{
            const columnFriendlyName = this.adaptableApi.columnApi.getFriendlyNameForColumnId(columnId);
            result = result.split(columnId).join(columnFriendlyName);
        });
        return result;
    }
    // Returns the ExpressionFunctions available for the given Module as specified in the `QueryLanguageOptions.moduleExpressionFunctions`
    // if there are no specific functions defined, it falls back to the default values
    getModuleExpressionFunctionsMap(module) {
        const expressionOptions = this.adaptableApi.optionsApi.getExpressionOptions();
        if (module) {
            let cachedResult = this.cacheModuleSpecificExpressionFunctions.get(module);
            if (cachedResult) return cachedResult;
        }
        const generalBooleanExpressionFunctions = this.extractMappedExpressionFunctions((0, $759293e9f6921c8e$export$147a1738bbbef892), expressionOptions.systemBooleanFunctions, expressionOptions.customBooleanFunctions);
        const generalScalarExpressionFunctions = this.extractMappedExpressionFunctions((0, $ef36e87b7f218a7a$export$cd51289811461f9), expressionOptions.systemScalarFunctions, expressionOptions.customScalarFunctions);
        const generalObservableExpressionFunctions = this.extractMappedExpressionFunctions((0, $7391114ea121c72d$export$94d9fa5facb1c88b), expressionOptions.systemObservableFunctions);
        const generalAggregatedBooleanExpressionFunctions = this.extractMappedExpressionFunctions((0, $d33604e1c9cd4b4a$export$c9a1d525657ef6a3), expressionOptions.systemAggregatedBooleanFunctions, // right now the custom aggregated scalar functions are used in the aggregated boolean functions as well
        // hopefully we'll simplify this in the future
        this.getCustomAggregatedScalarFunctions());
        const generalAggregatedScalarExpressionFunctions = this.extractMappedExpressionFunctions((0, $3c4f25bf4245f8cf$export$5b94276e8442c87f), expressionOptions.systemAggregatedScalarFunctions, this.getCustomAggregatedScalarFunctions());
        if (!module) {
            this.adaptableApi.logWarn(`QueryLanguageService.getModuleExpressionFunctions() was called with an undefined 'module' param, this should never happen`);
            return {
                booleanFunctions: generalBooleanExpressionFunctions,
                scalarFunctions: generalScalarExpressionFunctions,
                observableFunctions: generalObservableExpressionFunctions,
                aggregatedBooleanFunctions: generalAggregatedBooleanExpressionFunctions,
                aggregatedScalarFunctions: generalAggregatedScalarExpressionFunctions
            };
        }
        let moduleExpressionFunctions;
        if (typeof expressionOptions.moduleExpressionFunctions === 'function') {
            const context = {
                module: module,
                availableBooleanFunctionNames: (0, $19aa91e82c6d8270$export$5206d47972fefe20)(generalBooleanExpressionFunctions),
                availableScalarFunctionNames: (0, $19aa91e82c6d8270$export$5206d47972fefe20)(generalScalarExpressionFunctions),
                availableObservableFunctionNames: (0, $19aa91e82c6d8270$export$5206d47972fefe20)(generalObservableExpressionFunctions),
                availableAggregatedBooleanFunctionNames: (0, $19aa91e82c6d8270$export$5206d47972fefe20)(generalAggregatedBooleanExpressionFunctions),
                availableAggregatedScalarFunctionNames: (0, $19aa91e82c6d8270$export$5206d47972fefe20)(generalAggregatedScalarExpressionFunctions),
                ...this.adaptableApi.internalApi.buildBaseContext()
            };
            moduleExpressionFunctions = expressionOptions.moduleExpressionFunctions(context) ?? {};
        } else moduleExpressionFunctions = expressionOptions.moduleExpressionFunctions?.[module] ?? {};
        const moduleExpressionFunctionsMap = {
            booleanFunctions: this.extractMappedExpressionFunctions(generalBooleanExpressionFunctions, moduleExpressionFunctions.systemBooleanFunctions, moduleExpressionFunctions.customBooleanFunctions),
            scalarFunctions: this.extractMappedExpressionFunctions(generalScalarExpressionFunctions, moduleExpressionFunctions.systemScalarFunctions, moduleExpressionFunctions.customScalarFunctions),
            observableFunctions: this.extractMappedExpressionFunctions(generalObservableExpressionFunctions, moduleExpressionFunctions.systemObservableFunctions),
            aggregatedBooleanFunctions: this.extractMappedExpressionFunctions(generalAggregatedBooleanExpressionFunctions, moduleExpressionFunctions.systemAggregatedBooleanFunctions),
            aggregatedScalarFunctions: this.extractMappedExpressionFunctions(generalAggregatedScalarExpressionFunctions, moduleExpressionFunctions.systemAggregatedScalarFunctions)
        };
        this.cacheModuleSpecificExpressionFunctions.set(module, moduleExpressionFunctionsMap);
        return moduleExpressionFunctionsMap;
    }
    getCustomAggregatedScalarFunctions() {
        const customAggregatedScalarFunctions = this.adaptableApi.optionsApi.getExpressionOptions()?.customAggregatedFunctions;
        if (!customAggregatedScalarFunctions) return {};
        if (typeof customAggregatedScalarFunctions === 'function') return (context)=>{
            const customDefinitions = customAggregatedScalarFunctions(context);
            return this.mapCustomAggregatedScalarFunctionsToInternal(customDefinitions);
        };
        return this.mapCustomAggregatedScalarFunctionsToInternal(customAggregatedScalarFunctions);
    }
    mapCustomAggregatedScalarFunctionsToInternal(aggregatedScalarFunctions) {
        const getValueForColId = (colId, rowNode)=>{
            return this.adaptableApi.gridApi.getRawValueFromRowNode(rowNode, colId);
        };
        return Object.entries(aggregatedScalarFunctions).reduce((acc, [expressionName, customExpressionDefinition])=>{
            const expression = {
                handler: (args, context)=>{
                    const [aggColParam, ...restOfColParams] = (0, $fb3b7f5e99ab7e90$export$417db24e4b34530)(expressionName, args);
                    const aggColumnId = aggColParam?.value;
                    const groupByParameter = (0, $fb3b7f5e99ab7e90$export$d6cd7b824e62471)(expressionName, 'operand', [
                        'GROUP_BY'
                    ], args, {
                        isOptional: true
                    });
                    const groupByColumnIds = groupByParameter?.value;
                    const contextArgs = args.filter((arg)=>{
                        if (typeof arg === 'object' && arg.name === 'COL') // filter out aggregation column
                        return arg.value !== aggColumnId;
                        if (typeof arg === 'object' && arg.name === 'GROUP_BY') // filter out groupBy column
                        return false;
                        return true;
                    });
                    const aggregationExpressionEvaluation = {
                        aggregationParams: {
                            reducers: {
                                [expressionName]: {
                                    name: expressionName,
                                    field: aggColumnId,
                                    initialValue: customExpressionDefinition.initialValue,
                                    reducer: (acc, value, rowNode, dataIndex)=>{
                                        const context = {
                                            accumulator: acc,
                                            currentValue: value,
                                            index: dataIndex,
                                            rowNode: rowNode,
                                            args: contextArgs.map((arg)=>{
                                                // if col, replace with value
                                                if (typeof arg === 'object' && arg.name === 'COL') return getValueForColId(arg.value, rowNode);
                                                return arg;
                                            }),
                                            aggColumnId: aggColumnId,
                                            groupByColumnIds: groupByColumnIds,
                                            getValueForColId: (colId)=>getValueForColId(colId, rowNode),
                                            ...this.adaptableApi.internalApi.buildBaseContext()
                                        };
                                        return customExpressionDefinition.reducer(context);
                                    },
                                    done: (accValue, dataArray)=>{
                                        if (customExpressionDefinition.processAggregatedValue) {
                                            const context = {
                                                ...this.adaptableApi.internalApi.buildBaseContext(),
                                                aggregatedValue: accValue,
                                                rowNodes: dataArray,
                                                args: contextArgs,
                                                aggColumnId: aggColumnId,
                                                groupByColumnIds: groupByColumnIds
                                            };
                                            return customExpressionDefinition.processAggregatedValue(context);
                                        }
                                        return accValue;
                                    }
                                }
                            }
                        },
                        rowValueGetter: (rowNode, aggregationValue)=>{
                            if (customExpressionDefinition.prepareRowValue) {
                                const context = {
                                    rowNode: rowNode,
                                    aggregatedValue: aggregationValue,
                                    ...this.adaptableApi.internalApi.buildBaseContext(),
                                    args: contextArgs.map((arg)=>{
                                        // if col, replace with value
                                        if (typeof arg === 'object' && arg.name === 'COL') return getValueForColId(arg.value, rowNode);
                                        return arg;
                                    }),
                                    aggColumnId: aggColumnId,
                                    groupByColumnIds: groupByColumnIds,
                                    getValueForColId: (colId)=>getValueForColId(colId, rowNode)
                                };
                                return customExpressionDefinition.prepareRowValue(context);
                            }
                            return aggregationValue;
                        },
                        rowFilterFn: (rowNode)=>{
                            if (customExpressionDefinition.filterRow) return customExpressionDefinition.filterRow({
                                rowNode: rowNode,
                                ...this.adaptableApi.internalApi.buildBaseContext(),
                                args: contextArgs.map((arg)=>{
                                    // if col, replace with value
                                    if (typeof arg === 'object' && arg.name === 'COL') return getValueForColId(arg.value, rowNode);
                                    return arg;
                                }),
                                aggColumnId: aggColumnId,
                                groupByColumnIds: groupByColumnIds,
                                getValueForColId: (colId)=>getValueForColId(colId, rowNode)
                            });
                            return context?.filterFn?.(rowNode) ?? true;
                        },
                        getRowNodes: context.getRowNodes
                    };
                    (0, $3c4f25bf4245f8cf$export$d6904cfd9385acda)(groupByParameter?.value, aggregationExpressionEvaluation);
                    const result = {
                        name: expressionName,
                        type: 'aggregationScalar',
                        value: aggregationExpressionEvaluation
                    };
                    return result;
                },
                description: customExpressionDefinition.description,
                signatures: customExpressionDefinition.signatures,
                inputs: customExpressionDefinition.inputTypes
            };
            acc[expressionName] = expression;
            return acc;
        }, {});
    }
    extractMappedExpressionFunctions(availableExpressionFunctions, systemFunctions, customFunctions) {
        const systemFunctionNames = typeof systemFunctions === 'function' ? systemFunctions({
            availableExpressionFunctionNames: (0, $19aa91e82c6d8270$export$5206d47972fefe20)(availableExpressionFunctions),
            ...this.adaptableApi.internalApi.buildBaseContext()
        }) : systemFunctions;
        let generalExpressionFunctions = {};
        // add system functions
        if (Array.isArray(systemFunctionNames)) // add only system functions specified by user
        systemFunctionNames.forEach((systemFunctionName)=>{
            generalExpressionFunctions[systemFunctionName] = availableExpressionFunctions[systemFunctionName];
        });
        else // add ALL system functions
        generalExpressionFunctions = {
            ...availableExpressionFunctions
        };
        const customFunctionDefinitions = typeof customFunctions === 'function' ? customFunctions({
            availableExpressionFunctionNames: (0, $19aa91e82c6d8270$export$5206d47972fefe20)(generalExpressionFunctions),
            ...this.adaptableApi.internalApi.buildBaseContext()
        }) : customFunctions;
        if (customFunctionDefinitions) generalExpressionFunctions = {
            ...generalExpressionFunctions,
            ...customFunctionDefinitions
        };
        return generalExpressionFunctions;
    }
    evaluateCustomQueryVariable(functionName, args) {
        const context = {
            args: args,
            ...this.adaptableApi.internalApi.buildBaseContext()
        };
        const customQueryVariableDefinition = this.adaptableApi.optionsApi.getExpressionOptions()?.customQueryVariables?.[functionName];
        return typeof customQueryVariableDefinition === 'function' ? customQueryVariableDefinition(context) : customQueryVariableDefinition;
    }
    getBooleanAndScalarFunctions(moduleExpressionFunctionsMap) {
        return {
            ...moduleExpressionFunctionsMap.booleanFunctions,
            ...moduleExpressionFunctionsMap.scalarFunctions
        };
    }
    getExpressionCacheKey(expression, module) {
        return `${module}::${expression}`;
    }
    getNodesFromExpression(input, nodeType) {
        try {
            const resultSet = new Set();
            // @ts-ignore
            const walk = (node)=>{
                if (typeof node !== 'object') return false;
                if (Array.isArray(node)) return node.map(walk);
                node.args.map(walk);
                if (node.type === nodeType) resultSet.add(String(node.args[0]));
            };
            const { ast: ast } = $3f77892da2e22ac4$export$98e6a39c04603d36(input.trim());
            walk(ast);
            return Array.from(resultSet.values());
        } catch (e) {
            return [];
        }
    }
}





var $93f4d2c1cc93ee63$var$isArray = Array.isArray;
var $93f4d2c1cc93ee63$var$getPrototypeOf = Object.getPrototypeOf, $93f4d2c1cc93ee63$var$objectProto = Object.prototype, $93f4d2c1cc93ee63$var$getKeys = Object.keys;
function $93f4d2c1cc93ee63$export$8871b3799a14360f(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if ($93f4d2c1cc93ee63$var$isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if ($93f4d2c1cc93ee63$var$isPOJO(first_1)) {
            var keys = $93f4d2c1cc93ee63$var$getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function $93f4d2c1cc93ee63$var$isPOJO(obj) {
    return obj && typeof obj === 'object' && $93f4d2c1cc93ee63$var$getPrototypeOf(obj) === $93f4d2c1cc93ee63$var$objectProto;
}






var $e6cd63efe08c02de$var$isArray = Array.isArray;
function $e6cd63efe08c02de$var$callOrApply(fn, args) {
    return $e6cd63efe08c02de$var$isArray(args) ? fn.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args))) : fn(args);
}
function $e6cd63efe08c02de$export$559affaa48f4288d(fn) {
    return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(args) {
        return $e6cd63efe08c02de$var$callOrApply(fn, args);
    });
}



function $00d6f9870244ce2a$export$79c7e160a7743efd(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}




function $0e8b72f41887b114$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    var resultSelector = (0, $3b29c258456d9a89$export$9ae19b645239a61b)(args);
    var _a = (0, $93f4d2c1cc93ee63$export$8871b3799a14360f)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, $2fe2b696577919a5$export$6788812c4e6611e6)([], scheduler);
    var result = new (0, $4f562137a990678a$export$77cea355fa80b5f4)($0e8b72f41887b114$export$f04dcfb475ed2128(observables, scheduler, keys ? function(values) {
        return (0, $00d6f9870244ce2a$export$79c7e160a7743efd)(keys, values);
    } : (0, $7569c528cdd9d182$export$f0954fd7d5368655)));
    return resultSelector ? result.pipe((0, $e6cd63efe08c02de$export$559affaa48f4288d)(resultSelector)) : result;
}
function $0e8b72f41887b114$export$f04dcfb475ed2128(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, $7569c528cdd9d182$export$f0954fd7d5368655);
    return function(subscriber) {
        $0e8b72f41887b114$var$maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                $0e8b72f41887b114$var$maybeSchedule(scheduler, function() {
                    var source = (0, $2fe2b696577919a5$export$6788812c4e6611e6)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function $0e8b72f41887b114$var$maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscription, scheduler, execute);
    else execute();
}



class $0ddb4c2559a88c07$export$6efe27c077f7cc6e {
    adaptableApi;
    emitter;
    reactiveAlertsMap = new Map();
    constructor(adaptableApi){
        this.adaptableApi = adaptableApi;
        this.emitter = new (0, $7ddf72f79776fa87$export$2e2bcd8739ae039)();
    }
    destroy() {
        this.emitter.destroy();
        this.emitter = null;
        this.reactiveAlertsMap.forEach((alertsSubscriptionInfo)=>alertsSubscriptionInfo.subscription.unsubscribe());
        this.reactiveAlertsMap.clear();
        this.reactiveAlertsMap = null;
    }
    onReactiveAlertTriggered = (callback)=>{
        return this.emitter.on('ReactiveAlertTriggered', callback);
    };
    createReactiveAlert(alertDefinition) {
        // if there is already a reactive alert for this definition, delete it (possible in case of editing definitions),
        this.deleteReactiveAlert(alertDefinition);
        if (!alertDefinition.Rule.ObservableExpression) return;
        const isValidExpression = this.adaptableApi.expressionApi.isValidObservableExpression(alertDefinition.Rule.ObservableExpression, (0, $42e863194fcb493f$export$40024cb74c2bb550), `Invalid Alert rule with observable expression `);
        if (!isValidExpression) {
            this.adaptableApi.logWarn(`Could NOT create reactive alert due to invalid Rule definition!`, alertDefinition.Rule);
            return;
        }
        const reactiveExpressionObservable = this.evaluateReactiveExpression(alertDefinition.Rule);
        const reactiveAlertSubscription = (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
            (0, $195e3b3043565ec4$export$ba255e9e49e00608)(alertDefinition),
            reactiveExpressionObservable
        ]).subscribe(([alertDefinition, changeLogEntry])=>{
            const reactiveAlertInfo = (0, $d883e0ce3aff9068$export$c9a86c97b528ef9b)(changeLogEntry) ? {
                alertDefinition: alertDefinition,
                type: 'rowDataChangedAlert',
                gridChangeLogEntry: changeLogEntry
            } : {
                alertDefinition: alertDefinition,
                type: 'cellDataChangedAlert',
                cellChangeLogEntry: changeLogEntry
            };
            this.emitter.emitSync('ReactiveAlertTriggered', reactiveAlertInfo);
        });
        this.reactiveAlertsMap.set(alertDefinition.Uuid, {
            definition: alertDefinition,
            subscription: reactiveAlertSubscription
        });
    }
    deleteReactiveAlert(alertDefinition) {
        if (this.reactiveAlertsMap.has(alertDefinition.Uuid)) {
            const obsoleteReactiveAlert = this.reactiveAlertsMap.get(alertDefinition.Uuid);
            obsoleteReactiveAlert?.subscription.unsubscribe();
            this.reactiveAlertsMap.delete(alertDefinition.Uuid);
        }
    }
    getReactiveActiveAlerts() {
        return [
            ...this.reactiveAlertsMap.values()
        ].map((item)=>item.definition);
    }
    isReactiveAlertActive(alertDefinition) {
        return this.reactiveAlertsMap.has(alertDefinition.Uuid);
    }
    evaluateReactiveExpression(rule) {
        return this.adaptableApi.internalApi.getQueryLanguageService().evaluateObservableExpression(rule.ObservableExpression, (0, $42e863194fcb493f$export$40024cb74c2bb550));
    }
}




class $834607a0c4cd07c3$export$403179f218b160b0 {
    adaptableApi;
    dismissedNotifications = [];
    updateCheckTimerId;
    constructor(adaptableApi){
        this.adaptableApi = adaptableApi;
        const teamSharingOptions = adaptableApi.optionsApi.getTeamSharingOptions();
        if (teamSharingOptions.updateInterval > 0) {
            // convert minutes to millis
            const updateInterval = teamSharingOptions.updateInterval * 60000;
            this.updateCheckTimerId = setInterval(()=>{
                this.adaptableApi.teamSharingApi.checkForUpdates();
            }, updateInterval);
        }
    }
    buildCustomSharedEntity(Entity, Configuration) {
        const currentTime = Date.now();
        const currentUser = this.adaptableApi.optionsApi.getUserName();
        return {
            EntityType: 'customEntity',
            Entity: Entity,
            Uuid: Configuration.Uuid ?? (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
            Name: Configuration.Name,
            Description: Configuration.Description,
            Tags: Configuration.Tags,
            UserName: currentUser,
            Timestamp: currentTime,
            ChangedBy: currentUser,
            ChangedAt: currentTime
        };
    }
    buildSharedEntityWithDependencies(adaptableObject, module, configuration) {
        const sharingUserName = this.adaptableApi.optionsApi.getUserName();
        const sharingTimestamp = new Date().getTime();
        const createdSharedEntities = [];
        this.createSharedEntity(adaptableObject, module, configuration, sharingUserName, sharingTimestamp, createdSharedEntities);
        return createdSharedEntities;
    }
    getSharedEntityDependants(sharedEntityId, sharedEntities) {
        return sharedEntities.filter((sharedEntity)=>sharedEntity.EntityDependencyIds.includes(sharedEntityId));
    }
    updateActiveSharedEntity(changedAdaptableObject, userName, sharedEntities) {
        let activeSharedEntity = sharedEntities.find((sharedEntity)=>sharedEntity.Type === 'Active' && sharedEntity.Entity.Uuid === changedAdaptableObject.Uuid);
        if (!activeSharedEntity) // shared entity may have been removed in the meantime
        return [
            sharedEntities,
            []
        ];
        activeSharedEntity = {
            ...activeSharedEntity,
            Entity: changedAdaptableObject,
            ChangedAt: Date.now(),
            ChangedBy: userName,
            Revision: activeSharedEntity.Revision + 1
        };
        // update EntityDependencyIds (references may have been removed or new ones added)
        const updatedEntityDependencyIds = [];
        const currentEntityDependencies = this.getSharedEntityDependencies(activeSharedEntity, sharedEntities);
        const newTeamSharingReferences = this.getTeamSharingReferences(changedAdaptableObject, activeSharedEntity.Module);
        const newReferenceAdaptableObjectIds = newTeamSharingReferences.map((reference)=>reference.Reference.Uuid);
        // 1. add all the existing dependencies which are still referenced
        updatedEntityDependencyIds.push(...currentEntityDependencies.filter((entityDependency)=>newReferenceAdaptableObjectIds.includes(entityDependency.Entity.Uuid)).map((entity)=>entity.Uuid));
        // 2. check if there are new references which are not yet shared
        const freshReferences = newTeamSharingReferences.filter((reference)=>!currentEntityDependencies.map((entityDependency)=>entityDependency.Entity.Uuid).includes(reference.Reference.Uuid));
        const newSharedEntityDependencies = [];
        freshReferences.forEach((reference)=>{
            this.createSharedEntity(reference.Reference, reference.Module, {
                description: activeSharedEntity.Description,
                type: activeSharedEntity.Type
            }, activeSharedEntity.UserName, Date.now(), newSharedEntityDependencies);
        });
        updatedEntityDependencyIds.push(...newSharedEntityDependencies.map((sharedEntity)=>sharedEntity.Uuid));
        activeSharedEntity.EntityDependencyIds = updatedEntityDependencyIds;
        const updatedSharedEntities = sharedEntities.map((sharedEntity)=>sharedEntity.Uuid === activeSharedEntity.Uuid ? activeSharedEntity : sharedEntity);
        updatedSharedEntities.push(...newSharedEntityDependencies);
        const updatedActiveEntities = [
            activeSharedEntity,
            ...newSharedEntityDependencies
        ];
        return [
            updatedSharedEntities,
            updatedActiveEntities
        ];
    }
    buildSharedEntityImportActions(importedSharedEntity) {
        let configOverwriteNeedsConfirmation = false;
        // either ADD or EDIT(in which case the user will need to confirm the overwrite)
        const getSharedEntityImportAction = (sharedEntity)=>{
            const { Module: Module, Entity: Entity } = sharedEntity;
            const importInfo = this.adaptableApi.internalApi.getModuleService().getTeamSharingAction(Module);
            if (importInfo?.ModuleEntities.some((moduleEntity)=>moduleEntity.Uuid === Entity.Uuid)) {
                configOverwriteNeedsConfirmation = true;
                return importInfo?.EditAction(Entity);
            } else return importInfo?.AddAction(Entity);
        };
        const existingSharedEntities = this.adaptableApi.teamSharingApi.getLoadedAdaptableSharedEntities();
        const sharedEntityDependencyTree = this.getSharedEntityDependencyTree(importedSharedEntity, existingSharedEntities);
        const importSteps = sharedEntityDependencyTree.map((sharedEntity)=>({
                sharedEntity: sharedEntity,
                importAction: getSharedEntityImportAction(sharedEntity)
            }));
        return [
            importSteps,
            configOverwriteNeedsConfirmation
        ];
    }
    getSharedEntityLocalAndRemoteRevisions(changedAdaptableObjectId, remoteSharedEntities) {
        const localRevision = this.adaptableApi.internalApi.getState().TeamSharing.ActiveSharedEntityMap[changedAdaptableObjectId]?.Revision ?? -1;
        const remoteRevision = remoteSharedEntities.find((sharedEntity)=>sharedEntity.Entity.Uuid === changedAdaptableObjectId)?.Revision ?? -1;
        return [
            localRevision,
            remoteRevision
        ];
    }
    getStaleActiveSharedEntities() {
        const sharedEntities = this.adaptableApi.teamSharingApi.getLoadedAdaptableSharedEntities();
        const activeEntities = this.adaptableApi.internalApi.getState().TeamSharing.ActiveSharedEntityMap;
        const result = {};
        sharedEntities.filter((sharedEntity)=>sharedEntity.Type === 'Active').forEach((sharedEntity)=>{
            const importedRevision = activeEntities[sharedEntity.Entity.Uuid]?.Revision ?? Number.MAX_VALUE;
            if (sharedEntity.Revision > importedRevision) result[sharedEntity.Uuid] = {
                sharedEntity: sharedEntity,
                sharedRevision: sharedEntity.Revision,
                importedRevision: activeEntities[sharedEntity.Entity.Uuid].Revision
            };
        });
        return result;
    }
    showUpdateNotifications() {
        const { updateNotification: updateNotification } = this.adaptableApi.optionsApi.getTeamSharingOptions();
        if (!updateNotification) return;
        Object.values(this.getStaleActiveSharedEntities()).forEach((sharedEntityActiveInfo)=>{
            const notificationMessage = `Active share ${sharedEntityActiveInfo.sharedEntity.Module} has a new Revision: ${sharedEntityActiveInfo.sharedEntity.Revision}`;
            if (updateNotification === 'Alert' || updateNotification === 'AlertWithNotification') this.showUpdateNotificationAlert(sharedEntityActiveInfo, notificationMessage);
            if (updateNotification === 'SystemStatus') this.adaptableApi.systemStatusApi.setInfoSystemStatus(`TeamSharing: ${notificationMessage}`);
            this.adaptableApi.eventApi.internalApi.fireTeamSharingEntityChangedEvent(sharedEntityActiveInfo.sharedEntity);
        });
    }
    showUpdateNotificationAlert(sharedEntityActiveInfo, message) {
        const { updateNotification: updateNotification, showUpdateNotificationOncePerUpdate: showUpdateNotificationOncePerUpdate } = this.adaptableApi.optionsApi.getTeamSharingOptions();
        if (this.dismissedNotifications.some((notification)=>notification.entityUuid === sharedEntityActiveInfo.sharedEntity.Uuid)) return;
        const buttons = [
            {
                Label: 'Ok',
                ButtonStyle: {
                    tone: 'neutral',
                    variant: 'raised'
                }
            },
            {
                Label: 'Import',
                Command: (context)=>{
                    this.adaptableApi.teamSharingApi.importSharedEntry(sharedEntityActiveInfo.sharedEntity);
                },
                ButtonStyle: {
                    tone: 'info',
                    variant: 'raised'
                }
            }
        ];
        if (!showUpdateNotificationOncePerUpdate) buttons.push({
            Label: 'Dismiss',
            ButtonStyle: {
                tone: 'error',
                variant: 'raised'
            },
            Command: ()=>{
                this.dismissedNotifications.push({
                    entityUuid: sharedEntityActiveInfo.sharedEntity.Uuid
                });
            }
        });
        const alert = {
            alertType: 'generic',
            header: 'Team Sharing Update',
            message: message,
            alertDefinition: {
                ...(0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyAlertDefinition(),
                MessageType: 'Info',
                AlertProperties: {
                    DisplayNotification: updateNotification === 'AlertWithNotification',
                    NotificationDuration: 'always'
                },
                AlertForm: {
                    Buttons: buttons
                }
            }
        };
        this.adaptableApi.alertApi.displayAdaptableAlert(alert);
        if (showUpdateNotificationOncePerUpdate) this.dismissedNotifications.push({
            entityUuid: sharedEntityActiveInfo.sharedEntity.Uuid
        });
    }
    destroy() {
        clearTimeout(this.updateCheckTimerId);
    }
    createSharedEntity(adaptableObject, module, configuration, sharingUserName, sharingTimestamp, createdSharedEntities) {
        // create main shared entity
        const mainSharedEntity = {
            EntityType: 'adaptableEntity',
            Uuid: (0, $d7790b1d1a829cfc$export$10a020066a0f444a)(),
            Entity: adaptableObject,
            EntityDependencyIds: [],
            Module: module,
            Description: configuration.description,
            UserName: sharingUserName,
            Timestamp: sharingTimestamp,
            ChangedBy: sharingUserName,
            ChangedAt: sharingTimestamp,
            Revision: 1,
            Type: configuration.type
        };
        // load all dependencies (special cols, shared queries etc)
        const teamSharingDependencies = this.getTeamSharingReferences(adaptableObject, module);
        // for every dependency, create recursively the corresponding shared entities
        teamSharingDependencies.forEach((teamSharingDependency)=>{
            const sharedEntityDependency = this.createSharedEntity(teamSharingDependency.Reference, teamSharingDependency.Module, configuration, sharingUserName, sharingTimestamp, createdSharedEntities);
            // update dependency IDs for the main shared entity
            mainSharedEntity.EntityDependencyIds.push(sharedEntityDependency.Uuid);
        });
        // add main shared entity to the accumulator
        createdSharedEntities.push(mainSharedEntity);
        return mainSharedEntity;
    }
    // returns the given rootSharedEntity with all its unique dependencies in their dependency order
    getSharedEntityDependencyTree(rootSharedEntity, allSharedEntities) {
        // using a map to handle the case where a SharedEntity occurs multiple times in the dependency tree
        const result = new Map();
        result.set(rootSharedEntity.Uuid, rootSharedEntity);
        rootSharedEntity.EntityDependencyIds.forEach((dependencyId)=>{
            const dependencySharedEntity = allSharedEntities.find((sharedEntity)=>sharedEntity.Uuid === dependencyId);
            // check for zombie dependencies (possible if state is inconsistent due to dirty reads)
            if (dependencySharedEntity) this.getSharedEntityDependencyTree(dependencySharedEntity, allSharedEntities).forEach((childDependency)=>{
                // check if this dependency is not already present in the dependency tree
                if (!result.has(childDependency.Uuid)) result.set(childDependency.Uuid, childDependency);
            });
        });
        return Array.from(result.values());
    }
    getTeamSharingReferences(adaptableObject, module) {
        return this.adaptableApi.internalApi.getModuleService().getModuleById(module)?.getTeamSharingReferences(adaptableObject) ?? [];
    }
    getSharedEntityDependencies(input, allSharedEntities) {
        return input.EntityDependencyIds.map((dependencyId)=>allSharedEntities.find((sharedEntity)=>sharedEntity.Uuid === dependencyId)).filter((dependencyEntity)=>!!dependencyEntity);
    }
}


const $4c1becfc35b7f033$export$f346223056c60dbf = {
    AccessLevel: {
        name: "AccessLevel",
        kind: "A",
        desc: "Whether an Entitlement is `ReadOnly`, `Hidden` or `Full`"
    },
    ActionButtonCommand: {
        name: "ActionButtonCommand",
        kind: "A",
        desc: "Commands to assign to Action Buttons that open Row Forms: &#39;create&#39;, &#39;clone&#39;, &#39;edit&#39; or &#39;delete&#39;"
    },
    ActionColumn: {
        name: "ActionColumn",
        kind: "I",
        desc: "A Special Column that wraps an AdapTable Button",
        props: [
            {
                name: "actionColumnButton",
                kind: "u",
                desc: "Button (or list of buttons) to display in the Column"
            },
            {
                name: "actionColumnSettings",
                kind: "R",
                desc: "Optional properties to configure the Column (e.g. filterable, resizable)",
                isOpt: !0,
                ref: "ActionColumnSettings"
            },
            {
                name: "columnId",
                kind: "s",
                desc: "Mandatory &#39;Id&#39;; if no value set for `FriendlyName`, this will also be Column name"
            },
            {
                name: "friendlyName",
                kind: "s",
                desc: "How Column appears in Column Header, Menus; if no value set, `ColumnId` is used",
                isOpt: !0
            },
            {
                name: "rowScope",
                kind: "R",
                desc: "Which types of Rows should contain buttons (i.e. data, grouped, summary)",
                isOpt: !0,
                ref: "RowScope"
            }
        ]
    },
    ActionColumnButton: {
        name: "ActionColumnButton",
        kind: "I",
        desc: "Button that is displayed inside an Action Column",
        props: [
            {
                name: "command",
                kind: "R",
                desc: "Command to assign to Action Column Button that displays a Row Form",
                isOpt: !0,
                ref: "ActionButtonCommand"
            }
        ]
    },
    ActionColumnContext: {
        name: "ActionColumnContext",
        kind: "I",
        desc: "Context required by functions when using an Action Column Button",
        props: [
            {
                name: "actionColumn",
                kind: "u",
                desc: "Action Column in question"
            },
            {
                name: "data",
                kind: "u",
                desc: "The current row&#39;s data"
            },
            {
                name: "primaryKeyValue",
                kind: "u",
                desc: "Primary Key Value in current row"
            },
            {
                name: "rowNode",
                kind: "u",
                desc: "Current AG Grid Row Node"
            }
        ]
    },
    ActionColumnDefaultConfiguration: {
        name: "ActionColumnDefaultConfiguration",
        kind: "I",
        desc: "Default configuration to use for an FDC3 Action Column",
        props: [
            {
                name: "columnId",
                kind: "s",
                desc: "Column Id",
                isOpt: !0,
                defVal: "&#39;fdc3ActionColumn&#39;"
            },
            {
                name: "headerName",
                kind: "s",
                desc: "Column Header",
                isOpt: !0,
                defVal: "&#39;FDC3 Actions&#39;"
            },
            {
                name: "movable",
                kind: "b",
                desc: "If Column is movable",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "resizable",
                kind: "b",
                desc: "If Column is resizable",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "rowScope",
                kind: "R",
                desc: "Which rows button appears in",
                isOpt: !0,
                defVal: "data rows only",
                ref: "RowScope"
            },
            {
                name: "width",
                kind: "n",
                desc: "Column Width in pixels",
                isOpt: !0,
                defVal: "200"
            }
        ]
    },
    ActionColumnOptions: {
        name: "ActionColumnOptions",
        kind: "I",
        desc: "Options related to Action Columns in AdapTable",
        props: [
            {
                name: "actionColumns",
                kind: "u",
                desc: "Columns which contain an AdapTable Button - used for performing Actions",
                isOpt: !0,
                defVal: "undefined"
            }
        ]
    },
    ActionColumnSettings: {
        name: "ActionColumnSettings",
        kind: "I",
        desc: "Set of optional properties that define an Action Columns behaviour",
        props: [
            {
                name: "resizable",
                kind: "b",
                desc: "Whether Column can be resized (by dragging column header edges)",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "suppressMenu",
                kind: "b",
                desc: "Whether no menu should be shown for this Column header.",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "suppressMovable",
                kind: "b",
                desc: "Whether if this Column should be movable via dragging",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "width",
                kind: "n",
                desc: "Preferred width (in pixels) for Column; if unset, calculated dynamically by AG Grid",
                isOpt: !0
            }
        ]
    },
    AdaptableAggregatedBooleanQuery: {
        name: "AdaptableAggregatedBooleanQuery",
        kind: "I",
        desc: "Wraps an AdapTableQL Aggregated Boolean Expression",
        props: [
            {
                name: "AggregatedBooleanExpression",
                kind: "s",
                desc: "AdapTableQL Expression that returns true / false based on multiple rows"
            }
        ]
    },
    AdaptableAggregatedScalarQuery: {
        name: "AdaptableAggregatedScalarQuery",
        kind: "I",
        desc: "Wraps an AdapTableQL Aggregated Scalar Expression",
        props: [
            {
                name: "AggregatedScalarExpression",
                kind: "s",
                desc: "AdapTableQL Expression that returns any value based on multiple rows"
            }
        ]
    },
    AdaptableAlert: {
        name: "AdaptableAlert",
        kind: "A",
        desc: "Defines an Alert fired by AdapTable"
    },
    AdaptableAlertBase: {
        name: "AdaptableAlertBase",
        kind: "I",
        desc: "Defines the base(common) properties of an Alert fired by AdapTable, regardless of the type of change",
        props: [
            {
                name: "alertDefinition",
                kind: "R",
                desc: "Rule that caused Alert to fire",
                ref: "AlertDefinition"
            },
            {
                name: "alertType",
                kind: "u",
                desc: "The type of Alert"
            },
            {
                name: "header",
                kind: "s",
                desc: "Alert Header text"
            },
            {
                name: "message",
                kind: "s",
                desc: "Alert Body text"
            }
        ]
    },
    AdaptableAlertCommand: {
        name: "AdaptableAlertCommand",
        kind: "A",
        desc: "Commands available in an Alert"
    },
    AdaptableAlertQuery: {
        name: "AdaptableAlertQuery",
        kind: "A",
        desc: "Alert Query which may be either a Boolean, Observable or AggregatedBoolean Expression"
    },
    AdaptableAlertType: {
        name: "AdaptableAlertType",
        kind: "A",
        desc: "Type of AdapTable Alert: generic, cellChange or rowChange"
    },
    AdaptableBaseIcon: {
        name: "AdaptableBaseIcon",
        kind: "I",
        desc: "Base interface for AdaptableIcon",
        props: [
            {
                name: "className",
                kind: "s",
                desc: "The class name of the icon",
                isOpt: !0
            },
            {
                name: "style",
                kind: "R",
                desc: "CSS Properties",
                isOpt: !0,
                ref: "unknown"
            }
        ]
    },
    AdaptableBooleanQuery: {
        name: "AdaptableBooleanQuery",
        kind: "I",
        desc: "Wraps an AdapTableQL Boolean Expression",
        props: [
            {
                name: "BooleanExpression",
                kind: "s",
                desc: "AdapTableQL Expression that returns true / false"
            }
        ]
    },
    AdaptableButton: {
        name: "AdaptableButton",
        kind: "I",
        desc: "Defines a Button that appears in numerous places including Adaptable Form",
        props: [
            {
                name: "buttonStyle",
                kind: "u",
                desc: "Style for Button - can be object or function that provides a `ButtonStyle` object",
                isOpt: !0
            },
            {
                name: "disabled",
                kind: "u",
                desc: "Function that disables / enables the button based on its evaluation result",
                isOpt: !0
            },
            {
                name: "hidden",
                kind: "u",
                desc: "Function which sets whether Button is hidden",
                isOpt: !0
            },
            {
                name: "icon",
                kind: "u",
                desc: "Icon for Button - can be object or function that provides a `AdaptableIcon` object",
                isOpt: !0
            },
            {
                name: "label",
                kind: "u",
                desc: "Label for Button - can be string or function that provides string",
                isOpt: !0
            },
            {
                name: "onClick",
                kind: "u",
                desc: "Function to invoke when button is clicked",
                isOpt: !0
            },
            {
                name: "tooltip",
                kind: "u",
                desc: "Tooltip for Button - can be string or function that provides string",
                isOpt: !0
            }
        ]
    },
    AdaptableCalculatedColumnQuery: {
        name: "AdaptableCalculatedColumnQuery",
        kind: "A",
        desc: "Calculated Column Query which may be a Scalar or an AggregatedScalar Expression"
    },
    AdaptableCellChangedAlert: {
        name: "AdaptableCellChangedAlert",
        kind: "I",
        desc: "Defines an Alert fired by AdapTable when a cell is changed",
        props: [
            {
                name: "cellDataChangedInfo",
                kind: "u",
                desc: "Cell DataChange which triggered Alert"
            }
        ]
    },
    AdaptableClearStateFunction: {
        name: "AdaptableClearStateFunction",
        kind: "I",
        desc: "Function that clears persisted state from the storage system. Only invoked during `StateApi.reloadInitialState()` operations."
    },
    AdaptableColumn: {
        name: "AdaptableColumn",
        kind: "I",
        desc: "Defines an AdapTable Column - created at run-time based on AG Grid ColDef",
        props: [
            {
                name: "aggregatable",
                kind: "b",
                desc: "Is Column able to display aggregations (e.g. &#39;sum&#39;) when grouped"
            },
            {
                name: "aggregationFunction",
                kind: "s",
                desc: "Custom Aggregation function for the Column",
                isOpt: !0
            },
            {
                name: "availableAggregationFunctions",
                kind: "a",
                desc: "Available Aggregations for the Column",
                isOpt: !0
            },
            {
                name: "columnGroup",
                kind: "R",
                desc: "The parent Column group (if Column belongs to one)",
                isOpt: !0,
                ref: "AdaptableColumnGroup"
            },
            {
                name: "exportable",
                kind: "b",
                desc: "Whether the Column can be included in Reports"
            },
            {
                name: "field",
                kind: "u",
                desc: "Field in the row to get cell data from",
                isOpt: !0
            },
            {
                name: "fieldOnly",
                kind: "b",
                desc: "Is the Column ONLY available as a field and never visible"
            },
            {
                name: "filterable",
                kind: "b",
                desc: "Is Column able to be filtered"
            },
            {
                name: "flex",
                kind: "n",
                desc: "Flex details of the Column",
                isOpt: !0
            },
            {
                name: "groupable",
                kind: "b",
                desc: "Can Column form a Row Group"
            },
            {
                name: "hideable",
                kind: "b",
                desc: "Can Column be removed from the grid"
            },
            {
                name: "isActionColumn",
                kind: "b",
                desc: "Is Column an Action Column"
            },
            {
                name: "isCalculatedColumn",
                kind: "b",
                desc: "Is Column a Calculated Column"
            },
            {
                name: "isFixed",
                kind: "b",
                desc: "Is Column pinned or locked into position"
            },
            {
                name: "isFreeTextColumn",
                kind: "b",
                desc: "Is Column a Free Text Column"
            },
            {
                name: "isGeneratedPivotResultColumn",
                kind: "b",
                desc: "Is Column a generated Pivot Result Column"
            },
            {
                name: "isGeneratedRowGroupColumn",
                kind: "b",
                desc: "Is Column a generated Row Group Column"
            },
            {
                name: "isGeneratedSelectionColumn",
                kind: "b",
                desc: "Is Column a generated Selection Column"
            },
            {
                name: "isGrouped",
                kind: "b",
                desc: "Is Column currently Row-Grouped"
            },
            {
                name: "isPivotTotalColumn",
                kind: "b",
                desc: "Is Column a Pivot Total Column (GrandTotal, GroupTotal, AggregationTotal)"
            },
            {
                name: "isPrimaryKey",
                kind: "b",
                desc: "Is this the Primary Key Column"
            },
            {
                name: "isSparkline",
                kind: "b",
                desc: "Is it a Sparkline Column"
            },
            {
                name: "isTreeColumn",
                kind: "b",
                desc: "Whether Column is the Tree Column (in Tree View)"
            },
            {
                name: "isUIHiddenColumn",
                kind: "b",
                desc: "Whether Column is always hidden in UI but still available programmatically"
            },
            {
                name: "moveable",
                kind: "b",
                desc: "Can Column be moved at run-time to a new position"
            },
            {
                name: "pinned",
                kind: "'left' | 'right' | false",
                desc: "The pinned position of the Column"
            },
            {
                name: "pivotable",
                kind: "b",
                desc: "Can Column be used in a Pivot Layout"
            },
            {
                name: "queryable",
                kind: "b",
                desc: "Can the Column be in included in Queries / Expressions"
            },
            {
                name: "readOnly",
                kind: "b",
                desc: "Is Column editable; returns FALSE if Column has conditional/dynamic editability, assuming some rows are editable"
            },
            {
                name: "resizable",
                kind: "b",
                desc: "Is Column resizable"
            },
            {
                name: "sortable",
                kind: "b",
                desc: "Is Column sortable"
            },
            {
                name: "visible",
                kind: "b",
                desc: "Is Column currently visible"
            },
            {
                name: "width",
                kind: "n",
                desc: "Column width",
                isOpt: !0
            }
        ]
    },
    AdaptableColumnBase: {
        name: "AdaptableColumnBase",
        kind: "I",
        desc: "Base class for AdapTable Column containing most important properties",
        props: [
            {
                name: "columnId",
                kind: "s",
                desc: "Name of Column in AG Grid (e.g. field or colId)"
            },
            {
                name: "columnTypes",
                kind: "a",
                desc: "Column Types of the Column",
                isOpt: !0
            },
            {
                name: "dataType",
                kind: "R",
                desc: "DataType of the Column",
                ref: "AdaptableColumnDataType"
            },
            {
                name: "friendlyName",
                kind: "s",
                desc: "How Column is referred to in Adaptable UI; `Caption` property in AG Grid"
            }
        ]
    },
    AdaptableColumnContext: {
        name: "AdaptableColumnContext",
        kind: "I",
        desc: "Context provided for per Column callbacks",
        props: [
            {
                name: "column",
                kind: "u",
                desc: "The current Column"
            }
        ]
    },
    AdaptableColumnDataType: {
        name: "AdaptableColumnDataType",
        kind: "A",
        desc: "Defines data type of a Column; can be an AG Grid BaseCellDataType or an AdapTable array-related one"
    },
    AdaptableColumnGroup: {
        name: "AdaptableColumnGroup",
        kind: "I",
        desc: "Defines a Column Group",
        props: [
            {
                name: "allowGroupSplit",
                kind: "b",
                desc: "Whether the Group can be split"
            },
            {
                name: "columnGroupId",
                kind: "s",
                desc: "Id for the Column Group"
            },
            {
                name: "friendlyName",
                kind: "s",
                desc: "Friendly name for the Group"
            },
            {
                name: "groupCount",
                kind: "n",
                desc: "Number of Columns in the the Group"
            }
        ]
    },
    AdaptableColumnMenuItem: {
        name: "AdaptableColumnMenuItem",
        kind: "A",
        desc: "Menu item used by Adaptable in Column Menus"
    },
    AdaptableColumnMenuItemName: {
        name: "AdaptableColumnMenuItemName",
        kind: "A",
        desc: "Name of Column Menu Item provided by AdapTable"
    },
    AdaptableColumnPredicate: {
        name: "AdaptableColumnPredicate",
        kind: "I",
        desc: "Restricts a Predicate to a given Column",
        props: [
            {
                name: "ColumnId",
                kind: "s",
                desc: "Id of Column which will be evaluated by the Predicate",
                isOpt: !0
            }
        ]
    },
    AdaptableColumnsContext: {
        name: "AdaptableColumnsContext",
        kind: "I",
        desc: "Context provided for callbacks involving multiple Columns",
        props: [
            {
                name: "columns",
                kind: "u",
                desc: "All Columns"
            }
        ]
    },
    AdaptableColumnSummary: {
        name: "AdaptableColumnSummary",
        kind: "I",
        desc: "Summary of a Column including filters and all unique values"
    },
    AdaptableColumnTypeName: {
        name: "AdaptableColumnTypeName",
        kind: "A",
        desc: "Column Types recognised by AdapTable; to be set in GridOptions"
    },
    AdaptableComment: {
        name: "AdaptableComment",
        kind: "I",
        desc: "Comment that can be applied to a Cell in AdapTable",
        props: [
            {
                name: "AdaptableId",
                kind: "s",
                desc: "Id of this AdapTable instance",
                isOpt: !0
            },
            {
                name: "Author",
                kind: "u",
                desc: "Author of the Comment",
                isOpt: !0
            },
            {
                name: "Timestamp",
                kind: "n",
                desc: "When Comment was made"
            },
            {
                name: "Uuid",
                kind: "R",
                desc: "Unique identifier for the Comment",
                isOpt: !0,
                ref: "unknown"
            },
            {
                name: "Value",
                kind: "s",
                desc: "Content of the Comment"
            }
        ]
    },
    AdaptableComparerFunction: {
        name: "AdaptableComparerFunction",
        kind: "A",
        desc: "Standard comparer function used to evaluate custom sorts, returns -1, 0, 1 as required"
    },
    AdaptableConfig: {
        name: "AdaptableConfig",
        kind: "I",
        desc: "Config used by No Code Plugin to set up AdapTable",
        props: [
            {
                name: "adaptableOptions",
                kind: "R",
                desc: "Adaptable Options object",
                ref: "AdaptableOptions"
            },
            {
                name: "gridOptions",
                kind: "R",
                desc: "AG Grid Grid Options object",
                ref: "unknown"
            }
        ]
    },
    AdaptableContainerValue: {
        name: "AdaptableContainerValue",
        kind: "A",
        desc: "A resolved (non-function) container reference"
    },
    AdaptableContextMenuItem: {
        name: "AdaptableContextMenuItem",
        kind: "A",
        desc: "Menu item used by Adaptable in Context Menus"
    },
    AdaptableContextMenuItemName: {
        name: "AdaptableContextMenuItemName",
        kind: "A",
        desc: "Name of Context Menu Item provided by AdapTable"
    },
    AdaptableCoordinate: {
        name: "AdaptableCoordinate",
        kind: "I",
        desc: "Used by AdapTable to remember position of Floating Dashboard",
        props: [
            {
                name: "x",
                kind: "n",
                desc: "x axis number"
            },
            {
                name: "y",
                kind: "n",
                desc: "y axis number"
            }
        ]
    },
    AdaptableCSSSelector: {
        name: "AdaptableCSSSelector",
        kind: "I",
        desc: "CSS Selector used to target elements by CSS selectors (e.g. class, attribute, etc.) rather than elementID",
        props: [
            {
                name: "selector",
                kind: "s",
                desc: "CSS Selector that locates DOM element"
            }
        ]
    },
    AdaptableCustomIcon: {
        name: "AdaptableCustomIcon",
        kind: "I",
        desc: "Defines an icon from an external source",
        props: [
            {
                name: "src",
                kind: "s",
                desc: "The URL of the icon to use"
            }
        ]
    },
    AdaptableDashboardToolbar: {
        name: "AdaptableDashboardToolbar",
        kind: "A",
        desc: "List of all the Toolbars that Adaptable provides"
    },
    AdaptableDataChangeHistoryAction: {
        name: "AdaptableDataChangeHistoryAction",
        kind: "A",
        desc: "Built in `undo` or `clear` data change action"
    },
    AdaptableDateEditorParams: {
        name: "AdaptableDateEditorParams",
        kind: "I",
        desc: "Params used by the AdapTable Date Editor"
    },
    AdaptableElementIcon: {
        name: "AdaptableElementIcon",
        kind: "I",
        desc: "Defines an icon as a provided DOM element or HTML string",
        props: [
            {
                name: "element",
                kind: "u",
                desc: "The icon to display, either a DOM element or HTML string"
            }
        ]
    },
    AdaptableField: {
        name: "AdaptableField",
        kind: "I",
        desc: "Used in Expressions to reference row values which are not a column definition",
        props: [
            {
                name: "dataType",
                kind: "R",
                desc: "Data Type of field, used to validate and show correctly in UI",
                ref: "AdaptableColumnDataType"
            },
            {
                name: "label",
                kind: "s",
                desc: "Label for field (optional - defaults to name)",
                isOpt: !0
            },
            {
                name: "name",
                kind: "s",
                desc: "Name of field in data source, e.g. &#39;rowId&#39;, &#39;parentObject.childObject.value&#39;"
            }
        ]
    },
    AdaptableFieldContext: {
        name: "AdaptableFieldContext",
        kind: "I",
        desc: "Context used when providing Fields programatically"
    },
    AdaptableFilterComponentLocation: {
        name: "AdaptableFilterComponentLocation",
        kind: "A",
        desc: "AdapTable&#39;s Filter components: FilterBar or FilterForm"
    },
    AdaptableFilterState: {
        name: "AdaptableFilterState",
        kind: "I",
        desc: "Current Filters in AdapTable",
        props: [
            {
                name: "columnFilterDefs",
                kind: "u",
                desc: "Column Filter definitions for currently applied Column Filters"
            },
            {
                name: "columnFilters",
                kind: "u",
                desc: "Currently applied Column Filters"
            },
            {
                name: "gridFilter",
                kind: "string | undefined",
                desc: "Current Grid Filter"
            },
            {
                name: "gridFilterAST",
                kind: "u",
                desc: "AST for Current Grid Filter"
            }
        ]
    },
    AdaptableFlashingCell: {
        name: "AdaptableFlashingCell",
        kind: "I",
        desc: "Defines an Alert fired by AdapTable",
        props: [
            {
                name: "cellDataChangedInfo",
                kind: "R",
                desc: "Data change which triggered the FlashingCell",
                isOpt: !0,
                ref: "CellDataChangedInfo"
            },
            {
                name: "direction",
                kind: "'up' | 'down' | 'neutral'",
                desc: "Direction of the change: &#39;up&#39;, &#39;down&#39; or &#39;neutral&#39;"
            },
            {
                name: "flashColumnIds",
                kind: "u",
                desc: "Column Ids that are flashing"
            },
            {
                name: "flashingCellDefinition",
                kind: "R",
                desc: "Rule that caused the FlashingCell to fire",
                ref: "FlashingCellDefinition"
            },
            {
                name: "flashTarget",
                kind: "u",
                desc: "What will flash (e.g. Cell, Row)"
            },
            {
                name: "rowPrimaryKey",
                kind: "s",
                desc: "Primary Key Value of Row which is flashing"
            }
        ]
    },
    AdaptableForm: {
        name: "AdaptableForm",
        kind: "I",
        desc: "Defines a form which appears dynamically; used by Alerts &amp; Export Custom Destinations",
        props: [
            {
                name: "buttons",
                kind: "a",
                desc: "Buttons to include in the Form",
                isOpt: !0
            },
            {
                name: "description",
                kind: "s",
                desc: "Additional information to appear in the Form",
                isOpt: !0
            },
            {
                name: "fields",
                kind: "u",
                desc: "Collection of Dynamic Fields to display",
                isOpt: !0
            },
            {
                name: "title",
                kind: "s",
                desc: "Title to appear in the Form",
                isOpt: !0
            }
        ]
    },
    AdaptableFormat: {
        name: "AdaptableFormat",
        kind: "A",
        desc: "Object containing formatting information for Numeric and Date Columns"
    },
    AdaptableFormData: {
        name: "AdaptableFormData",
        kind: "A",
        desc: "Data which appears in an AdapTable Form"
    },
    AdaptableFormField: {
        name: "AdaptableFormField",
        kind: "I",
        desc: "Defines a Field that appears in an Adaptable Form",
        props: [
            {
                name: "defaultValue",
                kind: "string | boolean | number",
                desc: "Field Default Value - can be of type string, boolean, number",
                isOpt: !0
            },
            {
                name: "fieldType",
                kind: "R",
                desc: "Field Type: text, date, number, checkbox, select, textOutput",
                ref: "AdaptableFormFieldType"
            },
            {
                name: "label",
                kind: "s",
                desc: "Label to display in the Field"
            },
            {
                name: "name",
                kind: "s",
                desc: "Name of the Field"
            },
            {
                name: "options",
                kind: "u",
                desc: "Items to populate the &#39;select&#39; fieldType",
                isOpt: !0
            }
        ]
    },
    AdaptableFormFieldType: {
        name: "AdaptableFormFieldType",
        kind: "A",
        desc: "Types of Controls used in an AdapTable Form"
    },
    AdaptableFrameworkComponent: {
        name: "AdaptableFrameworkComponent",
        kind: "A",
        desc: "Base Component for Bespoke Components: can be Angular, React or Vue"
    },
    AdaptableGenericAlert: {
        name: "AdaptableGenericAlert",
        kind: "I",
        desc: "Defines a generic AdapTable Alert"
    },
    AdaptableIcon: {
        name: "AdaptableIcon",
        kind: "A",
        desc: "Defines an icon to be used in AdapTable (e.g. in Dashboard Header, Buttons, Menu, etc.)"
    },
    AdaptableLoadStateFunction: {
        name: "AdaptableLoadStateFunction",
        kind: "I",
        desc: "Function that retrieves Adaptable state from storage or external source. Called during initialization to hydrate the application state."
    },
    AdaptableLogger: {
        name: "AdaptableLogger",
        kind: "C",
        desc: "AdapTable&#39;s Logger"
    },
    AdaptableMenuItem: {
        name: "AdaptableMenuItem",
        kind: "I",
        desc: "Generic Menu item used by Adaptable in Column or Context Menus",
        props: [
            {
                name: "category",
                kind: "R",
                desc: "Category of Adaptable Menu Item: Module, General, Group or CustomSettingsPanel",
                ref: "MenuCategory"
            },
            {
                name: "icon",
                kind: "R",
                desc: "Icon to display in Menu Item",
                isOpt: !0,
                ref: "AdaptableIcon"
            },
            {
                name: "isVisible",
                kind: "b",
                desc: "Whether menu item is visible"
            },
            {
                name: "label",
                kind: "s",
                desc: "Text that appears in the menu"
            },
            {
                name: "name",
                kind: "u",
                desc: "Unique name for the Menu Item"
            },
            {
                name: "onClick",
                kind: "u",
                desc: "Function to invoke when (custom) menu item is clicked",
                isOpt: !0
            },
            {
                name: "subItems",
                kind: "a",
                desc: "Sub Menu Items to display",
                isOpt: !0
            }
        ]
    },
    AdaptableMessageType: {
        name: "AdaptableMessageType",
        kind: "A",
        desc: "Defines a Message Types: &#39;Success&#39;, &#39;Info&#39;, &#39;Warning&#39; or &#39;Error&#39;"
    },
    AdaptableModule: {
        name: "AdaptableModule",
        kind: "A",
        desc: "Modules provided by AdapTable, subject to Entitlements and usually have Initial Adaptable State"
    },
    AdaptableModuleButton: {
        name: "AdaptableModuleButton",
        kind: "A",
        desc: "List of all the Module buttons Adaptable provides - each Module has a popup for which this is a shortcut button"
    },
    AdaptableNoCodeWizardOptions: {
        name: "AdaptableNoCodeWizardOptions",
        kind: "I",
        desc: "Adaptable Options used by the No Code Wizard"
    },
    AdaptableNote: {
        name: "AdaptableNote",
        kind: "I",
        desc: "Note that can be applied to a Cell in AdapTable",
        props: [
            {
                name: "ColumnId",
                kind: "s",
                desc: "Id of Column containing the Note"
            },
            {
                name: "PrimaryKeyValue",
                kind: "u",
                desc: "Value in Grid&#39;s Primary Key Column"
            },
            {
                name: "Text",
                kind: "s",
                desc: "Content of the Note"
            },
            {
                name: "Timestamp",
                kind: "n",
                desc: "When Note was made",
                isOpt: !0
            }
        ]
    },
    AdaptableNotes: {
        name: "AdaptableNotes",
        kind: "A",
        desc: "Collection of Cell Notes"
    },
    AdaptableNumberCellEditorParams: {
        name: "AdaptableNumberCellEditorParams",
        kind: "I",
        desc: "Adaptable number editor parameters extending the AG Grid .",
        props: [
            {
                name: "emptyValue",
                kind: "s",
                desc: "Value to set for the cell, when the clear button is pressed",
                defVal: "&#39;&#39; (empty string)"
            },
            {
                name: "showClearButton",
                kind: "b",
                desc: "Whether to show the clear button. If `true`, it works together with `cellEditorParams.emptyValue`",
                defVal: "true"
            }
        ]
    },
    AdaptableObject: {
        name: "AdaptableObject",
        kind: "I",
        desc: "Base interface which all other Adaptable State-related objects extend",
        props: [
            {
                name: "AdaptableVersion",
                kind: "R",
                desc: "Current AdapTable version",
                isOpt: !0,
                ref: "AdaptableVersion"
            },
            {
                name: "IsReadOnly",
                kind: "b",
                desc: "Sets Entity to ReadOnly (overwriting a Strategy Entitlement of &#39;Full&#39;)",
                isOpt: !0
            },
            {
                name: "Metadata",
                kind: "u",
                desc: "Optional metadata associated with the object; can be used to store additional information or configuration",
                isOpt: !0
            },
            {
                name: "Source",
                kind: "'InitialState' | 'User'",
                desc: "Source of state object: &#39;InitialState&#39; if provided via `AdaptableOptions.initialState`, &#39;User&#39; or undefined for runtime state",
                isOpt: !0
            },
            {
                name: "Tags",
                kind: "a",
                desc: "List of Tags associated with the Object; often used for extending Layouts",
                isOpt: !0
            }
        ]
    },
    AdaptableObjectLookupCriteria: {
        name: "AdaptableObjectLookupCriteria",
        kind: "I",
        desc: "Lookup criteria for finding specific Adaptable Objects; all given criteria will be composed with an AND operator",
        props: [
            {
                name: "ids",
                kind: "u",
                desc: "Technical IDs of Adaptable Objects",
                isOpt: !0
            },
            {
                name: "scope",
                kind: "R",
                desc: "ColumnScope",
                isOpt: !0,
                ref: "ColumnScope"
            },
            {
                name: "tag",
                kind: "R",
                desc: "AdaptableObjectTag",
                isOpt: !0,
                ref: "AdaptableObjectTag"
            }
        ]
    },
    AdaptableObjectTag: {
        name: "AdaptableObjectTag",
        kind: "A",
        desc: "AdaptableObjectTag Object Tag - currently supporting only plain string values, but open for future extensions, if needed"
    },
    AdaptableObservableQuery: {
        name: "AdaptableObservableQuery",
        kind: "I",
        desc: "Wraps an AdapTableQL Observable Expression",
        props: [
            {
                name: "ObservableExpression",
                kind: "s",
                desc: "AdapTableQL Expression that observes the Grid or given rows"
            }
        ]
    },
    AdaptableOptions: {
        name: "AdaptableOptions",
        kind: "I",
        desc: "Large group of options enabling developers to set up AdapTable at design time to fit precise requirements",
        props: [
            {
                name: "actionColumnOptions",
                kind: "u",
                desc: "Options for managing Action Columns",
                isOpt: !0
            },
            {
                name: "adaptableContext",
                kind: "u",
                desc: "Application-specific context object - is included by AdapTable in all callbacks and Events",
                isOpt: !0
            },
            {
                name: "adaptableId",
                kind: "s",
                desc: "Identifier for this instance of AdapTable",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "&#39;adaptable_id_$random_number&#39;"
            },
            {
                name: "adaptableStateKey",
                kind: "s",
                desc: "Identifier used as localStorage persistence key for AdaptableState",
                isOpt: !0,
                gridInfo: "item",
                defVal: "`adaptableId` value"
            },
            {
                name: "alertOptions",
                kind: "u",
                desc: "Options for managing Alerts in AdapTable",
                isOpt: !0,
                gridInfo: "container",
                noCode: "container"
            },
            {
                name: "autogeneratePrimaryKey",
                kind: "b",
                desc: "Will autogenerate a Primary Key; only use as a last resort if no unique column is available, as limits some Adaptable functionalities",
                isOpt: !0,
                gridInfo: "item",
                defVal: "false"
            },
            {
                name: "calendarOptions",
                kind: "R",
                desc: "Options for managing Holidays and Working Days",
                isOpt: !0,
                ref: "CalendarOptions"
            },
            {
                name: "cellSummaryOptions",
                kind: "u",
                desc: "Options for adding custom Cell Summaries",
                isOpt: !0
            },
            {
                name: "chartingOptions",
                kind: "R",
                desc: "Options for managing AG Grid&#39;s Charting",
                isOpt: !0,
                noCode: "container",
                ref: "ChartingOptions"
            },
            {
                name: "columnMenuOptions",
                kind: "u",
                desc: "Options for managing AdapTable Column Menu",
                isOpt: !0,
                gridInfo: "container"
            },
            {
                name: "columnOptions",
                kind: "R",
                desc: "Options related to Columns",
                isOpt: !0,
                noCode: "container",
                ref: "ColumnOptions"
            },
            {
                name: "commentOptions",
                kind: "u",
                desc: "Options for managing collaborative Comments",
                isOpt: !0
            },
            {
                name: "containerOptions",
                kind: "R",
                desc: "Options for setting the &#39;Div&#39; elements in which AdapTable, AG Grid, popups are placed",
                isOpt: !0,
                ref: "ContainerOptions"
            },
            {
                name: "contextMenuOptions",
                kind: "u",
                desc: "Options for managing AdapTable Context Menu",
                isOpt: !0,
                gridInfo: "container"
            },
            {
                name: "customSortOptions",
                kind: "R",
                desc: "Options for using Custom Sort",
                isOpt: !0,
                ref: "CustomSortOptions"
            },
            {
                name: "dashboardOptions",
                kind: "R",
                desc: "Options for managing the Dashboard in AdapTable",
                isOpt: !0,
                gridInfo: "container",
                noCode: "container",
                ref: "DashboardOptions"
            },
            {
                name: "dataChangeHistoryOptions",
                kind: "u",
                desc: "Options to manage Data Change History Module which provides an overview of all data changes",
                isOpt: !0,
                gridInfo: "container",
                noCode: "container"
            },
            {
                name: "dataImportOptions",
                kind: "R",
                desc: "Options for managing the Data Import function",
                isOpt: !0,
                ref: "DataImportOptions"
            },
            {
                name: "dataSetOptions",
                kind: "u",
                desc: "Options to manage Data Sets",
                isOpt: !0
            },
            {
                name: "editOptions",
                kind: "u",
                desc: "Options related to Editing in AdapTable including Server Validation",
                isOpt: !0,
                gridInfo: "container"
            },
            {
                name: "entitlementOptions",
                kind: "R",
                desc: "Options for managing Entitlements",
                isOpt: !0,
                gridInfo: "container",
                ref: "EntitlementOptions"
            },
            {
                name: "exportOptions",
                kind: "u",
                desc: "Options for managing Exporting and Reports in AdapTable",
                isOpt: !0,
                gridInfo: "container"
            },
            {
                name: "expressionOptions",
                kind: "u",
                desc: "Options for managing AdapTableQL Expressions",
                isOpt: !0,
                noCode: "container"
            },
            {
                name: "fdc3Options",
                kind: "R",
                desc: "Options for managing FDC3 in AdapTable",
                isOpt: !0,
                ref: "Fdc3Options"
            },
            {
                name: "filterOptions",
                kind: "u",
                desc: "Filtering Options - both Column Filters and the Grid Filter",
                isOpt: !0
            },
            {
                name: "flashingCellOptions",
                kind: "R",
                desc: "Options for managing Flashing Cells - primarily default values",
                isOpt: !0,
                gridInfo: "container",
                ref: "FlashingCellOptions"
            },
            {
                name: "formatColumnOptions",
                kind: "R",
                desc: "Options for providing Custom Display Formats",
                isOpt: !0,
                ref: "FormatColumnOptions"
            },
            {
                name: "initialState",
                kind: "R",
                desc: "Initial State set at design-time and shipped with AdapTable for first use; must include at least one Layout",
                defVal: "undefined",
                ref: "InitialState"
            },
            {
                name: "layoutOptions",
                kind: "R",
                desc: "Options related to Layouts",
                isOpt: !0,
                gridInfo: "container",
                noCode: "container",
                ref: "LayoutOptions"
            },
            {
                name: "licenseKey",
                kind: "s",
                desc: "Commercial license key. If the license is not provided or is expired, various visual information notes will be displayed and some functionality may be limited.",
                isOpt: !0
            },
            {
                name: "noteOptions",
                kind: "R",
                desc: "Options for managing personal Notes",
                isOpt: !0,
                ref: "NoteOptions"
            },
            {
                name: "notificationsOptions",
                kind: "R",
                desc: "Options for managing Notifications in AdapTable",
                isOpt: !0,
                gridInfo: "container",
                noCode: "container",
                ref: "NotificationsOptions"
            },
            {
                name: "plugins",
                kind: "a",
                desc: "Used for managing the AdapTable Plugins",
                isOpt: !0
            },
            {
                name: "predicateOptions",
                kind: "R",
                desc: "Options for managing Predicates in AdapTableQL",
                isOpt: !0,
                ref: "PredicateOptions"
            },
            {
                name: "primaryKey",
                kind: "s",
                desc: "Name of Column in AdapTable guaranteed to contain unique values",
                gridInfo: "item",
                defVal: "n/a (Mandatory)"
            },
            {
                name: "quickSearchOptions",
                kind: "u",
                desc: "Options for managing Search related functions in AdapTable",
                isOpt: !0,
                gridInfo: "container",
                noCode: "container"
            },
            {
                name: "rowFormOptions",
                kind: "u",
                desc: "Options for managing Row Forms",
                isOpt: !0
            },
            {
                name: "settingsPanelOptions",
                kind: "R",
                desc: "Setting panel options",
                isOpt: !0,
                gridInfo: "container",
                noCode: "container",
                ref: "SettingsPanelOptions"
            },
            {
                name: "stateOptions",
                kind: "R",
                desc: "Options related to state hydration / dehydration - allows users to intercept state persistence and state loading and change default behaviour of saving to local storage",
                isOpt: !0,
                ref: "StateOptions"
            },
            {
                name: "teamSharingOptions",
                kind: "R",
                desc: "Options for managing &#39;Team Sharing&#39; which allows users to create Adaptable Objects and share with colleagues",
                isOpt: !0,
                gridInfo: "container",
                ref: "TeamSharingOptions"
            },
            {
                name: "toolPanelOptions",
                kind: "R",
                desc: "Options related to managing the Tool Panel elements in AdapTable",
                isOpt: !0,
                gridInfo: "container",
                noCode: "container",
                ref: "ToolPanelOptions"
            },
            {
                name: "userInterfaceOptions",
                kind: "u",
                desc: "Options for managing the User Interface elements of AdapTable, i.e. Action Columns, Color Palette etc.",
                isOpt: !0,
                gridInfo: "container"
            },
            {
                name: "userName",
                kind: "s",
                desc: "Name of current AdapTable user",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;anonymous&#39;"
            }
        ]
    },
    AdaptablePercentageCellEditorParams: {
        name: "AdaptablePercentageCellEditorParams",
        kind: "I",
        desc: "AdapTablePercentageCellEditor parameters - extends AdaptableNumberCellEditorParams"
    },
    AdaptablePersistentState: {
        name: "AdaptablePersistentState",
        kind: "I",
        desc: "The state object of Adaptable which is persisted"
    },
    AdaptablePersistStateFunction: {
        name: "AdaptablePersistStateFunction",
        kind: "I",
        desc: "Function that handles persisting state to storage systems (localStorage, server, etc.). Called after `saveState()` to store the prepared state."
    },
    AdaptablePlugin: {
        name: "AdaptablePlugin",
        kind: "C",
        desc: "Base class for all AdapTable Plugins"
    },
    AdaptablePredicate: {
        name: "AdaptablePredicate",
        kind: "I",
        desc: "Predicate object used by AdapTableQL - essentially a boolean function",
        props: [
            {
                name: "Inputs",
                kind: "a",
                desc: "Optional Inputs that might be needed for evaluation",
                isOpt: !0
            },
            {
                name: "PredicateId",
                kind: "u",
                desc: "Id of Predicate (e.g. `Equals`, `GreaterThan`)"
            }
        ]
    },
    AdaptablePredicateDef: {
        name: "AdaptablePredicateDef",
        kind: "I",
        desc: "Defines a Predicate - include where it can run and what it does",
        props: [
            {
                name: "columnScope",
                kind: "R",
                desc: "Columns (or DataTypes) where Predicate is active",
                ref: "ColumnScope"
            },
            {
                name: "handler",
                kind: "f",
                desc: "Actual boolean function invoked when evaluating the Predicate"
            },
            {
                name: "icon",
                kind: "u",
                desc: "Icon to show (primarily used in Filter dropdown)",
                isOpt: !0
            },
            {
                name: "id",
                kind: "u",
                desc: "Predicate Id"
            },
            {
                name: "inputs",
                kind: "a",
                desc: "Inputs the Predicate can take",
                isOpt: !0
            },
            {
                name: "label",
                kind: "s",
                desc: "Name of the Predicate"
            },
            {
                name: "moduleScope",
                kind: "a",
                desc: "Modules where Predicate can run"
            },
            {
                name: "shortcuts",
                kind: "a",
                desc: "Keyboard shortcuts to initiate predicate - used in Quick Filter bar",
                isOpt: !0
            },
            {
                name: "toString",
                kind: "f",
                desc: "String representation of the Predicate",
                isOpt: !0
            }
        ]
    },
    AdaptableQLModule: {
        name: "AdaptableQLModule",
        kind: "A",
        desc: "Modules which leverage AdapTableQL; can be used to set remote evaluation"
    },
    AdaptableQuery: {
        name: "AdaptableQuery",
        kind: "A",
        desc: "An AdaptableQuery can be either a Boolean, Scalar, Observable, AggregatedBoolean, or AggregatedScalar expression"
    },
    AdaptableRowChangedAlert: {
        name: "AdaptableRowChangedAlert",
        kind: "I",
        desc: "Defines an Alert fired by AdapTable when a row is changed",
        props: [
            {
                name: "rowDataChangedInfo",
                kind: "u",
                desc: "Row DataChange which triggered Alert"
            }
        ]
    },
    AdaptableRowContext: {
        name: "AdaptableRowContext",
        kind: "I",
        desc: "Context provided for per Row callbacks",
        props: [
            {
                name: "rowNode",
                kind: "u",
                desc: "The current Row"
            }
        ]
    },
    AdaptableSaveStateFunction: {
        name: "AdaptableSaveStateFunction",
        kind: "I",
        desc: "Function that transforms state before persistence. Called first in the persistence flow, before `persistState()`."
    },
    AdaptableScalarQuery: {
        name: "AdaptableScalarQuery",
        kind: "I",
        desc: "Wraps an AdapTableQL Scalar Expression",
        props: [
            {
                name: "ScalarExpression",
                kind: "s",
                desc: "AdapTableQL Expression that returns any value"
            }
        ]
    },
    AdaptableSettingsPanel: {
        name: "AdaptableSettingsPanel",
        kind: "A",
        desc: "Modules which can appear in the Settings Panel"
    },
    AdaptableSharedEntity: {
        name: "AdaptableSharedEntity",
        kind: "I",
        desc: "Defines an AdaptableObject shared with Team Sharing",
        props: [
            {
                name: "ChangedAt",
                kind: "n",
                desc: "Last time when the object was changed"
            },
            {
                name: "ChangedBy",
                kind: "s",
                desc: "Last User who changed the object"
            },
            {
                name: "Description",
                kind: "s",
                desc: "Description of object being shared"
            },
            {
                name: "Entity",
                kind: "R",
                desc: "Actual Adaptable Object being shared",
                ref: "AdaptableObject"
            },
            {
                name: "EntityDependencyIds",
                kind: "a",
                desc: "Ids of direct entity dependencies"
            },
            {
                name: "EntityType",
                kind: "u",
                desc: "Type of shared entity (either Adaptable specific or custom object)"
            },
            {
                name: "Module",
                kind: "R",
                desc: "Adaptable Module to which object belongs",
                ref: "AdaptableModule"
            },
            {
                name: "Revision",
                kind: "n",
                desc: "Revision - incremental for &#39;Active&#39;, always 1 for &#39;Snapshot&#39;"
            },
            {
                name: "Timestamp",
                kind: "n",
                desc: "When the object was shared"
            },
            {
                name: "Type",
                kind: "R",
                desc: "&#39;Snapshot&#39; (for 1-time sharing) or &#39;Active&#39; (for continuous sharing)",
                ref: "SharedEntityType"
            },
            {
                name: "UserName",
                kind: "s",
                desc: "User who shared the object"
            }
        ]
    },
    AdaptableSharedEntityConfig: {
        name: "AdaptableSharedEntityConfig",
        kind: "I",
        desc: "Describes an AdaptableObject which is being Team Shared"
    },
    AdaptableSortState: {
        name: "AdaptableSortState",
        kind: "I",
        desc: "Overview of current, live, sorting state in grid",
        props: [
            {
                name: "columnSorts",
                kind: "a",
                desc: "Columns currently being sorted (with direction)"
            },
            {
                name: "customSortComparers",
                kind: "a",
                desc: "Custom Sort Comparers which are currently applied"
            },
            {
                name: "customSorts",
                kind: "a",
                desc: "Custom Sorts which are currently applied"
            }
        ]
    },
    AdaptableState: {
        name: "AdaptableState",
        kind: "I",
        desc: "The main state object of Adaptable"
    },
    AdaptableStateFunctionConfig: {
        name: "AdaptableStateFunctionConfig",
        kind: "I",
        desc: "State Function Config object passed into all State Options functions",
        props: [
            {
                name: "actionName",
                kind: "s",
                desc: "Name of the action that triggered the state change.",
                isOpt: !0
            },
            {
                name: "adaptableApi",
                kind: "R",
                desc: "Adaptable API",
                ref: "unknown"
            },
            {
                name: "adaptableContext",
                kind: "u",
                desc: "Custom application Context provided in `AdaptableOptions.adaptableContext`"
            },
            {
                name: "adaptableId",
                kind: "s",
                desc: "Id of current Adaptable instance"
            },
            {
                name: "adaptableStateKey",
                kind: "s",
                desc: "State Key being used"
            },
            {
                name: "previousState",
                kind: "R",
                desc: "Previous state before the action was applied. This is useful for comparing changes or reverting if necessary.",
                isOpt: !0,
                ref: "AdaptableState"
            },
            {
                name: "userName",
                kind: "s",
                desc: "current Adaptable user"
            }
        ]
    },
    AdaptableStatusBar: {
        name: "AdaptableStatusBar",
        kind: "I",
        desc: "Defines an Adaptable Status Bar",
        props: [
            {
                name: "Key",
                kind: "s",
                desc: "Key of Status Bar Panel as defined in AG Grid GridOptions - ensure keys are the same (note: AG Grid statusPanel is lowercase &#39;key&#39;)"
            },
            {
                name: "StatusBarPanels",
                kind: "a",
                desc: "Module Status Panels to render inside Adaptable Status Bar",
                isOpt: !0
            }
        ]
    },
    AdaptableStatusBarPanel: {
        name: "AdaptableStatusBarPanel",
        kind: "A",
        desc: "Modules which can appear in the AdapTable Status Bar"
    },
    AdaptableStyle: {
        name: "AdaptableStyle",
        kind: "I",
        desc: "Style object used in numerous AdapTable Modules",
        props: [
            {
                name: "Alignment",
                kind: "R",
                desc: "Align to `Left`, `Right` or `Center`",
                isOpt: !0,
                ref: "unknown"
            },
            {
                name: "BackColor",
                kind: "s",
                desc: "Colour background of cell: hex, rgb(a) or name",
                isOpt: !0
            },
            {
                name: "BorderColor",
                kind: "s",
                desc: "Colour of cell border: hex, rgb(a) or name",
                isOpt: !0
            },
            {
                name: "BorderRadius",
                kind: "n",
                desc: "Rounds corners of an element&#39;s outer border edge; equivalent of CSS border-radius",
                isOpt: !0
            },
            {
                name: "ClassName",
                kind: "s",
                desc: "Existing CSS Class; use instead of setting other object properties",
                isOpt: !0
            },
            {
                name: "FontSize",
                kind: "'XSmall' | 'Small' | 'Medium' | 'Large' | 'XLarge'",
                desc: "Size of font: `XSmall`, `Small`, `Medium`, `Large` or `XLarge`",
                isOpt: !0
            },
            {
                name: "FontStyle",
                kind: "'Normal' | 'Italic'",
                desc: "Style of font: `Normal` or `Italic`",
                isOpt: !0
            },
            {
                name: "FontWeight",
                kind: "'Normal' | 'Bold'",
                desc: "Weight of font: `Normal` or `Bold`",
                isOpt: !0
            },
            {
                name: "ForeColor",
                kind: "s",
                desc: "Font colour in cell: hex, rgb(a) or name",
                isOpt: !0
            },
            {
                name: "TextDecoration",
                kind: "'None' | 'Underline' | 'Overline' | 'LineThrough'",
                desc: "Decoration of font: `None`, `Underline`, `Overline` or `LineThrough`",
                isOpt: !0
            }
        ]
    },
    AdaptableSystemColumnMenuItem: {
        name: "AdaptableSystemColumnMenuItem",
        kind: "I",
        desc: "System Menu Item that is provided by AdapTable",
        props: [
            {
                name: "menuType",
                kind: "u",
                desc: "Type of Menu - always &#39;Adaptable&#39;"
            }
        ]
    },
    AdaptableSystemContextMenuItem: {
        name: "AdaptableSystemContextMenuItem",
        kind: "I",
        desc: "System Menu Item that is provided by AdapTable",
        props: [
            {
                name: "menuType",
                kind: "u",
                desc: "Type of Menu - always &#39;Adaptable&#39;"
            }
        ]
    },
    AdaptableSystemIcon: {
        name: "AdaptableSystemIcon",
        kind: "I",
        desc: "Defines an icon from the System AdapTable icon set",
        props: [
            {
                name: "name",
                kind: "u",
                desc: "The name of the icon to use (referencing the AdapTable Icon Library)"
            },
            {
                name: "size",
                kind: "n",
                desc: "The size (in pixels) of the SVG icon (defaults to `17px`)",
                isOpt: !0
            }
        ]
    },
    AdaptableSystemIconName: {
        name: "AdaptableSystemIconName",
        kind: "A",
        desc: "All AdapTable System Icon names"
    },
    AdaptableTheme: {
        name: "AdaptableTheme",
        kind: "I",
        desc: "Used for creating User (i.e. Custom) Themes",
        props: [
            {
                name: "AgGridClassName",
                kind: "s",
                desc: "Ag Grid theme to apply when loading theme; relevant only when using the legacy AG Grid themes",
                isOpt: !0
            },
            {
                name: "AgThemeMode",
                kind: "u",
                desc: "AG Grid theme mode to apply when this theme is selected. Valid values are `light`, `dark`, `dark-blue` or any custom theme mode defined in AG Grid. When set, adds a data-ag-theme-mode attribute to the document body.",
                isOpt: !0
            },
            {
                name: "CSSVariables",
                kind: "u",
                desc: "Variables to be applied at runtime",
                isOpt: !0
            },
            {
                name: "Description",
                kind: "s",
                desc: "Description of Theme - will appear in Theme Toolbar and Toolpanel"
            },
            {
                name: "Name",
                kind: "s",
                desc: "Name of the Theme as it appears in the Theme toolbar and tool panel"
            },
            {
                name: "Variant",
                kind: "'light' | 'dark'",
                desc: "Base theme variant to derive custom theme from. Use `light` to inherit from Adaptable Light Theme or `dark` for Adaptable Dark Theme. When creating custom themes, specifying a variant ensures proper inheritance of base theme styles.",
                isOpt: !0
            }
        ]
    },
    AdaptableToolPanel: {
        name: "AdaptableToolPanel",
        kind: "A",
        desc: "Modules which can appear as AdapTable Tool Panels"
    },
    AdaptableToolPanelDefinition: {
        name: "AdaptableToolPanelDefinition",
        kind: "I",
        desc: "Defines a ToolPanel - Name and VisibilityMode (Expanded / Collapsed)",
        props: [
            {
                name: "Name",
                kind: "u",
                desc: "ToolPanel name - either an Adaptable Module or a Custom ToolPanel (defined in ToolPanel Options)"
            },
            {
                name: "VisibilityMode",
                kind: "'expanded' | 'collapsed'",
                desc: "Whether the ToolPanel is &#39;expanded&#39; or &#39;collapsed&#39;",
                isOpt: !0,
                defVal: "&#39;collapsed&#39;"
            }
        ]
    },
    AdaptableTransientState: {
        name: "AdaptableTransientState",
        kind: "I",
        desc: "The state which is available in the internal Redux store but never persisted"
    },
    AdaptableVersion: {
        name: "AdaptableVersion",
        kind: "A",
        desc: "The current version of AdapTable being used"
    },
    AggregatedExpressionFilterRowContext: {
        name: "AggregatedExpressionFilterRowContext",
        kind: "I",
        desc: "Context used when applying a filter to Rows before Reducer is called",
        props: [
            {
                name: "aggColumnId",
                kind: "s",
                desc: "Column Id of the column being aggregated Usually the first Col argument, e.g. [colId]"
            },
            {
                name: "args",
                kind: "a",
                desc: "Arguments passed to the function"
            },
            {
                name: "getValueForColId",
                kind: "u",
                desc: "Utility function to get the value of a column"
            },
            {
                name: "groupByColumnIds",
                kind: "a",
                desc: "Column Id(s) of the column(s) being grouped by",
                isOpt: !0
            },
            {
                name: "rowNode",
                kind: "R",
                desc: "Current row node",
                ref: "unknown"
            }
        ]
    },
    AggregatedExpressionFunction: {
        name: "AggregatedExpressionFunction",
        kind: "I",
        desc: "Defines an AdapTableQL function that aggregates data",
        props: [
            {
                name: "description",
                kind: "s",
                desc: "Description of the Aggregated Expression Function",
                isOpt: !0
            },
            {
                name: "examples",
                kind: "a",
                desc: "Examples to use the Aggregated Expression Function",
                isOpt: !0
            },
            {
                name: "filterRow",
                kind: "f",
                desc: "Optional filter which is applied to each row before the reducer is called. If the filter returns false, the row is NOT included in the aggregation.",
                isOpt: !0
            },
            {
                name: "initialValue",
                kind: "u",
                desc: "Mandatory Initial Value for the aggregation"
            },
            {
                name: "inputTypes",
                kind: "a",
                desc: "Optional argument types.",
                isOpt: !0
            },
            {
                name: "prepareRowValue",
                kind: "u",
                desc: "Called for each row AFTER the reducer() and processAggregatedValue() functions Can be used when each row has a different aggregated value (e.g. percentage = row value / aggregated value). Returns return value for each individual row",
                isOpt: !0
            },
            {
                name: "processAggregatedValue",
                kind: "f",
                desc: "Called AFTER the reducer() has processed all values / rows Can be used to change result of reducer based on the values array (e.g. average = aggregated value / count)",
                isOpt: !0
            },
            {
                name: "reducer",
                kind: "f",
                desc: "Mandatory Reducer function which is called for each value(row) in the Column Data"
            },
            {
                name: "signatures",
                kind: "a",
                desc: "Example Signatures for the Aggregated Expression Function",
                isOpt: !0
            }
        ]
    },
    AggregatedExpressionPrepareRowValueContext: {
        name: "AggregatedExpressionPrepareRowValueContext",
        kind: "I",
        desc: "Context used by prepareRowValue property in Aggregated Expressions",
        props: [
            {
                name: "aggColumnId",
                kind: "s",
                desc: "Column Id of the column being aggregated"
            },
            {
                name: "aggregatedValue",
                kind: "u",
                desc: "Result of the reducer"
            },
            {
                name: "args",
                kind: "a",
                desc: "Arguments passed to the function"
            },
            {
                name: "getValueForColId",
                kind: "u",
                desc: "Helper function to get the value of a column"
            },
            {
                name: "groupByColumnIds",
                kind: "a",
                desc: "Column Id(s) of the column(s) being grouped by",
                isOpt: !0
            },
            {
                name: "rowNode",
                kind: "R",
                desc: "Current Row Node",
                ref: "unknown"
            }
        ]
    },
    AggregatedExpressionProcessAggValueContext: {
        name: "AggregatedExpressionProcessAggValueContext",
        kind: "I",
        desc: "Context used by processAggregatedValue property in Aggregated Expressions",
        props: [
            {
                name: "aggColumnId",
                kind: "s",
                desc: "Column Id of the column being aggregated"
            },
            {
                name: "aggregatedValue",
                kind: "u",
                desc: "Result of the reducer"
            },
            {
                name: "args",
                kind: "a",
                desc: "Arguments passed to the function"
            },
            {
                name: "groupByColumnIds",
                kind: "a",
                desc: "Column Id(s) of the column(s) being grouped by",
                isOpt: !0
            },
            {
                name: "rowNodes",
                kind: "a",
                desc: "Array of row nodes; if aggregation is grouped, this will be the array of row nodes for the group"
            }
        ]
    },
    AggregatedExpressionReducerContext: {
        name: "AggregatedExpressionReducerContext",
        kind: "I",
        desc: "Context used by the reducer property in Aggregated Expressions",
        props: [
            {
                name: "accumulator",
                kind: "u",
                desc: "Value returned by the previous call to the reducer function, or the initialValue if this is the first call. You return the new accumulator value from this function."
            },
            {
                name: "aggColumnId",
                kind: "s",
                desc: "Column Id of the column being aggregated"
            },
            {
                name: "args",
                kind: "a",
                desc: "Arguments passed to the function"
            },
            {
                name: "currentValue",
                kind: "u",
                desc: "Current value being processed in the Column Data"
            },
            {
                name: "getValueForColId",
                kind: "u",
                desc: "Helper function to get the value of a column"
            },
            {
                name: "groupByColumnIds",
                kind: "a",
                desc: "Column Id(s) of the column(s) being grouped by",
                isOpt: !0
            },
            {
                name: "index",
                kind: "n",
                desc: "Index of the current value in the Column Data"
            },
            {
                name: "rowNode",
                kind: "R",
                desc: "Current row node",
                ref: "unknown"
            }
        ]
    },
    AgGridColumnMenuItemType: {
        name: "AgGridColumnMenuItemType",
        kind: "A",
        desc: "Defines AG Grid Column Menu Items"
    },
    AgGridConfig: {
        name: "AgGridConfig",
        kind: "I",
        desc: "Contains AG Grid Options and Modules - used when instantiating AdapTable vanilla",
        props: [
            {
                name: "gridOptions",
                kind: "R",
                desc: "AG Grid GridOptions object",
                ref: "unknown"
            },
            {
                name: "modules",
                kind: "a",
                desc: "AG Grid Modules to use; provide empty array if using CJS"
            }
        ]
    },
    AgGridContextMenuItemType: {
        name: "AgGridContextMenuItemType",
        kind: "A",
        desc: "Defines AG Grid Context Menu Items"
    },
    AgGridMenuItem: {
        name: "AgGridMenuItem",
        kind: "I",
        desc: "Menu Item that is provided by AG Grid",
        props: [
            {
                name: "menuType",
                kind: "u",
                desc: "Type of Menu - always &#39;AgGrid&#39;"
            },
            {
                name: "name",
                kind: "u",
                desc: "Name of the Menu Type"
            }
        ]
    },
    AlertButton: {
        name: "AlertButton",
        kind: "I",
        desc: "Defines a button that appears in an Alert Form",
        props: [
            {
                name: "ButtonStyle",
                kind: "R",
                desc: "Style for the Button",
                isOpt: !0,
                ref: "ButtonStyle"
            },
            {
                name: "Command",
                kind: "u",
                desc: "Predefined Command(s) to trigger when button is clicked; implemented in `commandHandlers` property of Alert Options",
                isOpt: !0
            },
            {
                name: "Label",
                kind: "s",
                desc: "Label to show in the Button"
            },
            {
                name: "Tooltip",
                kind: "s",
                desc: "ToolTip to display",
                isOpt: !0
            }
        ]
    },
    AlertButtonForm: {
        name: "AlertButtonForm",
        kind: "A",
        desc: "Form triggered by an Alert which contains only Buttons"
    },
    AlertDefinition: {
        name: "AlertDefinition",
        kind: "I",
        desc: "The Alert Definition object used in the Alert function",
        props: [
            {
                name: "AlertForm",
                kind: "u",
                desc: "Form to display in Alert with buttons and inputs",
                isOpt: !0
            },
            {
                name: "AlertProperties",
                kind: "R",
                desc: "Series of properties which set what happens when Alert is triggered",
                isOpt: !0,
                ref: "AlertProperties"
            },
            {
                name: "MessageHeader",
                kind: "s",
                desc: "Title of displayed Alert Message",
                isOpt: !0
            },
            {
                name: "MessageText",
                kind: "s",
                desc: "Title of displayed Alert Message; if null, AdapTable creates dynamically using Rule &amp; Scope",
                isOpt: !0
            },
            {
                name: "MessageType",
                kind: "R",
                desc: "Type of Alert: &#39;Info&#39;, &#39;Success&#39;, &#39;Warning&#39;, &#39;Error&#39;; influences Alert colour, icon and logging",
                ref: "AdaptableMessageType"
            },
            {
                name: "Name",
                kind: "s",
                desc: "Name of the Alert Definition"
            },
            {
                name: "Rule",
                kind: "R",
                desc: "When Alert should be triggered",
                ref: "AlertRule"
            },
            {
                name: "Scope",
                kind: "R",
                desc: "Where Alert can be triggered: one, some or all columns or DataTypes",
                ref: "ColumnScope"
            }
        ]
    },
    AlertDefinitionPredicate: {
        name: "AlertDefinitionPredicate",
        kind: "I",
        desc: "Predicate used when creating a Predicate-based Rule for an Alert"
    },
    AlertForm: {
        name: "AlertForm",
        kind: "A",
        desc: "Form to show in an Alert"
    },
    AlertFormContext: {
        name: "AlertFormContext",
        kind: "I",
        desc: "Context required by functions when using an Alert Button",
        props: [
            {
                name: "alert",
                kind: "u",
                desc: "Alert that has been triggered"
            }
        ]
    },
    AlertMessageContext: {
        name: "AlertMessageContext",
        kind: "I",
        desc: "Context used for creating bespoke Alert messages",
        props: [
            {
                name: "alertDefinition",
                kind: "R",
                desc: "Current Alert Definition",
                ref: "AlertDefinition"
            },
            {
                name: "cellDataChangedInfo",
                kind: "u",
                desc: "Cell Data change that might have triggered the Alert",
                isOpt: !0
            },
            {
                name: "rowDataChangedInfo",
                kind: "u",
                desc: "Row Data change that might have triggered the Alert (e.g. Row Added or Removed)",
                isOpt: !0
            }
        ]
    },
    AlertOptions: {
        name: "AlertOptions",
        kind: "I",
        desc: "Options related to Alerts in Adaptable.",
        props: [
            {
                name: "alertForms",
                kind: "u",
                desc: "Full definitions of Alert Forms - the names of which are provided in Alert State",
                isOpt: !0
            },
            {
                name: "alertMessageHeader",
                kind: "u",
                desc: "Function providing Header to display in Alert; if empty, AdapTable provides dynamically",
                isOpt: !0
            },
            {
                name: "alertMessageText",
                kind: "u",
                desc: "Function providing Message to display in Alert; if empty, AdapTable provides dynamically",
                isOpt: !0
            },
            {
                name: "cellHighlightDuration",
                kind: "n",
                desc: "How long (in ms) a Cell will be highlighted when an Alert fires",
                isOpt: !0,
                gridInfo: "item",
                defVal: "2000"
            },
            {
                name: "commandHandlers",
                kind: "u",
                desc: "Custom onClick Handlers for Buttons (displayed in Alert Forms)",
                isOpt: !0
            },
            {
                name: "dataChangeDetectionPolicy",
                kind: "R",
                desc: "Whether Alert rule is evaluated against the `rawValue` or `formattedValue` of the changed cell data",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;rawValue&#39;",
                ref: "DataChangeDetectionPolicy"
            },
            {
                name: "maxAlertsInStore",
                kind: "n",
                desc: "How many alerts held in State at any one time; when limit is breached, oldest alert will be removed",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "20"
            },
            {
                name: "rowHighlightDuration",
                kind: "n",
                desc: "How long (in ms) a Row will be highlighted when an Alert Fires",
                isOpt: !0,
                gridInfo: "item",
                defVal: "4000"
            },
            {
                name: "showMissingPrimaryKeyAlert",
                kind: "b",
                desc: "Shows Alert if Primary Key column in Adaptable Options is not present or incorrect",
                uiLabel: "Show Missing Primary Key Warning",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "false"
            },
            {
                name: "statusbarHighlightDuration",
                kind: "n",
                desc: "How long (in ms) Alert panel in Status Bar highlights when an Alert Fires",
                isOpt: !0,
                defVal: "2000"
            }
        ]
    },
    AlertProperties: {
        name: "AlertProperties",
        kind: "I",
        desc: "Additional properties that specify how a particular Alert will ALWAYS behave",
        props: [
            {
                name: "DisplayNotification",
                kind: "b",
                desc: "Displays a notification when Alert is triggered",
                isOpt: !0
            },
            {
                name: "HighlightCell",
                kind: "u",
                desc: "Colours updated Row using `MessageType` of triggering Alert Definition",
                isOpt: !0
            },
            {
                name: "HighlightRow",
                kind: "u",
                desc: "Colours updated Row using `MessageType` of triggering Alert Definition",
                isOpt: !0
            },
            {
                name: "JumpToCell",
                kind: "b",
                desc: "Grid will &#39;jump&#39; to the changed cell which triggered the Alert",
                isOpt: !0
            },
            {
                name: "JumpToRow",
                kind: "b",
                desc: "Grid will &#39;jump&#39; to the newly added row which triggered the Alert",
                isOpt: !0
            },
            {
                name: "LogToConsole",
                kind: "b",
                desc: "Logs the Alert message to the console",
                isOpt: !0
            },
            {
                name: "NotificationDuration",
                kind: "u",
                desc: "Notifiction duration(defaults to `NotificationOptions.duration`)",
                isOpt: !0
            },
            {
                name: "PreventEdit",
                kind: "b",
                desc: "Automatically prevent any cell edit which triggered the Alert (i.e. validation)",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "ShowInDiv",
                kind: "b",
                desc: "Shows Alert text in the div specificed in `alertContainer` property of Container Options",
                isOpt: !0
            }
        ]
    },
    AlertRule: {
        name: "AlertRule",
        kind: "A",
        desc: "The Alert Rule defined by either an AdaptablePredicate or an AdaptableQuery"
    },
    AlertState: {
        name: "AlertState",
        kind: "I",
        desc: "Adaptable State section for Alert Module",
        props: [
            {
                name: "AlertDefinitions",
                kind: "a",
                desc: "Alert Definitions - will trigger Alerts when rule is met",
                isOpt: !0
            }
        ]
    },
    AlternativeModuleName: {
        name: "AlternativeModuleName",
        kind: "I",
        desc: "Defines a new name for an Adaptable Module (e.g. change Dashboard to Grid Manager)",
        props: [
            {
                name: "adaptableModule",
                kind: "R",
                desc: "Adaptable Module to rename",
                ref: "AdaptableModule"
            },
            {
                name: "newName",
                kind: "s",
                desc: "New name to use"
            }
        ]
    },
    AngularFrameworkComponent: {
        name: "AngularFrameworkComponent",
        kind: "A",
        desc: "Angular component defined by its type and (optional) initialisation callback"
    },
    ApplicationDataEntry: {
        name: "ApplicationDataEntry",
        kind: "I",
        desc: "Simple Key / Value pair object used to store custom - stringifiable - data in Adaptable State.",
        props: [
            {
                name: "Key",
                kind: "s",
                desc: "Key of Key / Value pair - always stored as a string"
            },
            {
                name: "Value",
                kind: "u",
                desc: "Value of Key / Value pair (actual data being stored) - needs to stringifiable"
            }
        ]
    },
    ApplicationState: {
        name: "ApplicationState",
        kind: "I",
        desc: "Adaptable State Section for the Application Module",
        props: [
            {
                name: "ApplicationDataEntries",
                kind: "a",
                desc: "Array of Key / Value pairs enabling custom data to be stored in Adaptable State.",
                isOpt: !0
            }
        ]
    },
    ApplyFilterAction: {
        name: "ApplyFilterAction",
        kind: "A",
        desc: "When to apply a Filter: &#39;Always&#39;, &#39;Never&#39; or &#39;Throttle&#39;"
    },
    AST_Expression: {
        name: "AST_Expression",
        kind: "A",
        desc: "Defines AST of an Expressoin"
    },
    AST_Function: {
        name: "AST_Function",
        kind: "A",
        desc: "Defines AST of an Expression Function"
    },
    AST: {
        name: "AST",
        kind: "A",
        desc: "An AST Expression"
    },
    AutoGenerateTagsForLayoutsContext: {
        name: "AutoGenerateTagsForLayoutsContext",
        kind: "I",
        desc: "Context for `LayoutOptions.autoGenerateTagsForLayouts` method",
        props: [
            {
                name: "layouts",
                kind: "a",
                desc: "Layouts currently in Adaptable State"
            },
            {
                name: "objectTags",
                kind: "a",
                desc: "Object Tags provided in User Interface Options"
            }
        ]
    },
    AutoGroupColumnHeaderContext: {
        name: "AutoGroupColumnHeaderContext",
        kind: "I",
        desc: "Context for Columns created automatically by AG Grid when Row Grouping",
        props: [
            {
                name: "columnId",
                kind: "s",
                desc: "Id of the Column"
            },
            {
                name: "columnType",
                kind: "u",
                desc: "Auto-generated Row Group Column (when RowGroupDisplayType is `single`)"
            },
            {
                name: "groupedColumnIds",
                kind: "a",
                desc: "Ids of all Row Grouped Columns"
            }
        ]
    },
    BadgeStyle: {
        name: "BadgeStyle",
        kind: "I",
        desc: "Collection of Badge Style Definitions to display in a Badge Styled Column",
        props: [
            {
                name: "Badges",
                kind: "a",
                desc: "Collection of Badge Style Definitions",
                isOpt: !0
            },
            {
                name: "RowScope",
                kind: "R",
                desc: "Which types of Rows should contain a Badge (data, grouped, summary)",
                isOpt: !0,
                ref: "RowScope"
            }
        ]
    },
    BadgeStyleDefinition: {
        name: "BadgeStyleDefinition",
        kind: "I",
        desc: "Defines a Badge Style",
        props: [
            {
                name: "Icon",
                kind: "R",
                desc: "Icon to display in Badge",
                isOpt: !0,
                ref: "AdaptableIcon"
            },
            {
                name: "IconOnly",
                kind: "b",
                desc: "Only show an Icon and no Cell text",
                isOpt: !0
            },
            {
                name: "IconPosition",
                kind: "'Start' | 'End'",
                desc: "Position of Icon in the Badge - &#39;Start&#39; or &#39;End&#39;",
                isOpt: !0
            },
            {
                name: "Predicate",
                kind: "R",
                desc: "Optional Rule for deciding whether Badge is displayed",
                isOpt: !0,
                ref: "BadgeStylePredicate"
            },
            {
                name: "Style",
                kind: "R",
                desc: "Style for the Badge",
                isOpt: !0,
                ref: "AdaptableStyle"
            }
        ]
    },
    BadgeStylePredicate: {
        name: "BadgeStylePredicate",
        kind: "I",
        desc: "System Predicate definition for Badge Style"
    },
    BaseColumnHeaderContext: {
        name: "BaseColumnHeaderContext",
        kind: "I",
        desc: "Common properties for Column Header Context",
        props: [
            {
                name: "currentLayout",
                kind: "R",
                desc: "Current Layout",
                ref: "Layout"
            },
            {
                name: "currentLayoutName",
                kind: "s",
                desc: "Name of Current Layout"
            },
            {
                name: "currentLayoutType",
                kind: "'table' | 'pivot'",
                desc: "Type (table/pivot) of Current Layout"
            },
            {
                name: "defaultHeaderName",
                kind: "s",
                desc: "Default header name for Column"
            }
        ]
    },
    BaseContext: {
        name: "BaseContext",
        kind: "I",
        desc: "Base class for all AdapTable callbacks and Events",
        props: [
            {
                name: "adaptableApi",
                kind: "R",
                desc: "Adaptable Api object",
                ref: "unknown"
            },
            {
                name: "adaptableContext",
                kind: "u",
                desc: "Custom application Context provided in `AdaptableOptions.adaptableContext`"
            },
            {
                name: "adaptableId",
                kind: "s",
                desc: "Id of current AdapTable instance"
            },
            {
                name: "adaptableStateKey",
                kind: "s",
                desc: "Current Adaptable State Key"
            },
            {
                name: "clientTimestamp",
                kind: "d",
                desc: "Time on user&#39;s computer"
            },
            {
                name: "userName",
                kind: "s",
                desc: "Name of Current User"
            }
        ]
    },
    BaseExportContext: {
        name: "BaseExportContext",
        kind: "I",
        desc: "Context information available in all Export-related functions",
        props: [
            {
                name: "exportDestination",
                kind: "R",
                desc: "Export Destination for the Report",
                isOpt: !0,
                ref: "ExportDestinationType"
            },
            {
                name: "report",
                kind: "R",
                desc: "The Report Configuration being run",
                ref: "Report"
            },
            {
                name: "reportFormat",
                kind: "R",
                desc: "Format of the Report being run",
                ref: "ReportFormatType"
            },
            {
                name: "reportName",
                kind: "R",
                desc: "Name of the Report being run",
                ref: "ReportNameType"
            }
        ]
    },
    BaseState: {
        name: "BaseState",
        kind: "I",
        desc: "Base Interface for all Adaptable State objects; contains`Revision` property, used for versioning",
        props: [
            {
                name: "Revision",
                kind: "number | {\n        Key: number;\n        UpdateStrategy: 'Override' | 'KeepUserDefined';\n    }",
                desc: "Version number of the Item - allows developers to update one section in Initial Adaptable State while keeping others unchanged",
                isOpt: !0
            }
        ]
    },
    BroadcastConfig: {
        name: "BroadcastConfig",
        kind: "I",
        desc: "Config used when broadcasting FDC3 Context",
        props: [
            {
                name: "actionButton",
                kind: "R",
                desc: "Definition of Action Button (to be put in default FDC3 Action Column)",
                isOpt: !0,
                ref: "Fdc3AdaptableButton"
            },
            {
                name: "actionColumn",
                kind: "R",
                desc: "Custom FDC3 Action Column definition to broadcast the Context",
                isOpt: !0,
                ref: "FDC3ActionColumn"
            },
            {
                name: "contextMenu",
                kind: "u",
                desc: "Columns to display a &#39;Broadcast&#39; Context Menu item",
                isOpt: !0
            }
        ]
    },
    BroadcastConfiguration: {
        name: "BroadcastConfiguration",
        kind: "I",
        desc: "Defines config options for Broadcasting FDC3 Context"
    },
    ButtonStyle: {
        name: "ButtonStyle",
        kind: "I",
        desc: "Defines the look and feel of an Adaptable Button",
        props: [
            {
                name: "className",
                kind: "s",
                desc: "CSS Classname to use for the Button",
                isOpt: !0
            },
            {
                name: "tone",
                kind: "'success' | 'error' | 'neutral' | 'none' | 'warning' | 'info' | 'accent'",
                desc: "Button&#39;s Tone - values: &#39;success&#39;, &#39;error&#39;, &#39;neutral&#39;, &#39;none&#39;, &#39;warning&#39;, &#39;info&#39;, &#39;accent&#39;",
                isOpt: !0,
                defVal: "&#39;neutral&#39;"
            },
            {
                name: "variant",
                kind: "'text' | 'outlined' | 'raised'",
                desc: "How Button appears - values: &#39;text&#39;, &#39;outlined&#39;, &#39;raised&#39;",
                isOpt: !0,
                defVal: "&#39;outlined&#39;"
            }
        ]
    },
    CalculatedColumn: {
        name: "CalculatedColumn",
        kind: "I",
        desc: "Defines a Column where the display value is derived from other values in row, and the definition is stored in State.",
        props: [
            {
                name: "CalculatedColumnSettings",
                kind: "R",
                desc: "Additional optional properties for Column (e.g. filterable, resizable)",
                ref: "CalculatedColumnSettings"
            },
            {
                name: "ColumnId",
                kind: "s",
                desc: "Name of Calculated Column"
            },
            {
                name: "FriendlyName",
                kind: "s",
                desc: "Name to be used in Column Header; if blank `ColumnId` is used",
                isOpt: !0
            },
            {
                name: "Query",
                kind: "R",
                desc: "Scalar/AggregatedScalar Query used by AdapTableQL to evaluate Column&#39;s value",
                ref: "AdaptableCalculatedColumnQuery"
            }
        ]
    },
    CalculatedColumnSettings: {
        name: "CalculatedColumnSettings",
        kind: "I",
        desc: "Set properties that define Calculated Column&#39;s behaviour (all optional except DataType)",
        props: [
            {
                name: "ShowToolTip",
                kind: "b",
                desc: "Show underlying Expression as ToolTip when hovering over a cell",
                isOpt: !0,
                defVal: "false"
            }
        ]
    },
    CalculatedColumnState: {
        name: "CalculatedColumnState",
        kind: "I",
        desc: "Adaptable State Section for Calculated Column Module",
        props: [
            {
                name: "CalculatedColumns",
                kind: "a",
                desc: "Collection of Calculated Columns",
                isOpt: !0
            }
        ]
    },
    CalendarOptions: {
        name: "CalendarOptions",
        kind: "I",
        desc: "Options for managing Holidays and Working Days in AdapTable",
        props: [
            {
                name: "holidays",
                kind: "u",
                desc: "Holidays for current User",
                isOpt: !0,
                defVal: "null"
            }
        ]
    },
    CellAddress: {
        name: "CellAddress",
        kind: "A",
        desc: "Very lightweight object to define an AdapTable Cell"
    },
    CellColorRange: {
        name: "CellColorRange",
        kind: "I",
        desc: "Defines which Colours to show in Gradient and Percent Bar Styles",
        props: [
            {
                name: "Color",
                kind: "s",
                desc: "Cell colour to use for values that fall inside Range"
            },
            {
                name: "Max",
                kind: "number | 'Col-Max'",
                desc: "End number of Range"
            },
            {
                name: "Min",
                kind: "number | 'Col-Min'",
                desc: "Start number of Range"
            },
            {
                name: "ReverseGradient",
                kind: "b",
                desc: "Reverses the Gradient so the lower the cell value the darker the colour",
                isOpt: !0
            }
        ]
    },
    CellDataChangedInfo: {
        name: "CellDataChangedInfo",
        kind: "I",
        desc: "Defines a Cell Edit - includes full details of old and new values, the column and the enclosing Row",
        props: [
            {
                name: "changedAt",
                kind: "n",
                desc: "Timestamp of change occurrence (in milliseconds)"
            },
            {
                name: "column",
                kind: "u",
                desc: "Column in which cell is situated"
            },
            {
                name: "newValue",
                kind: "u",
                desc: "New value for the cell"
            },
            {
                name: "oldValue",
                kind: "u",
                desc: "Value in the Cell before the edit"
            },
            {
                name: "primaryKeyValue",
                kind: "u",
                desc: "Primary Key Column&#39;s value for the row where edited cell is situated"
            },
            {
                name: "rowData",
                kind: "u",
                desc: "Data in the Row",
                isOpt: !0
            },
            {
                name: "rowNode",
                kind: "u",
                desc: "AG Grid RowNode that contains the cell",
                isOpt: !0
            },
            {
                name: "trigger",
                kind: "'edit' | 'tick' | 'undo' | 'aggChange'",
                desc: "What triggered the change - user, background change or a reverted change?",
                isOpt: !0
            }
        ]
    },
    CellEditableContext: {
        name: "CellEditableContext",
        kind: "I",
        desc: "Context used when checking Cell editability",
        props: [
            {
                name: "defaultColDefEditableValue",
                kind: "b",
                desc: "Default editability according to the AG Grid Column Definition (`ColDef.editable`)"
            },
            {
                name: "gridCell",
                kind: "u",
                desc: "Cell being edited"
            }
        ]
    },
    CellHighlightInfo: {
        name: "CellHighlightInfo",
        kind: "I",
        desc: "Defines how a given Cell in AdapTable should be highlighted",
        props: [
            {
                name: "columnId",
                kind: "s",
                desc: "Id of Column containing Cell"
            },
            {
                name: "highlightStyle",
                kind: "R",
                desc: "Adaptable Style to use in the Cell Highlight",
                ref: "AdaptableStyle"
            },
            {
                name: "primaryKeyValue",
                kind: "u",
                desc: "Primary Key Value of row containing Cell",
                isOpt: !0
            },
            {
                name: "timeout",
                kind: "n",
                desc: "Time after which Cell should be unhighlighted",
                isOpt: !0
            }
        ]
    },
    CellSummaryOptions: {
        name: "CellSummaryOptions",
        kind: "I",
        desc: "Options to provide custom Cell Summary Operations &amp; Display Formats",
        props: [
            {
                name: "customCellSummaryOperations",
                kind: "u",
                desc: "Custom Numeric Cell Summary Operations to add to set shipped by AdapTable",
                isOpt: !0
            },
            {
                name: "numericDisplayFormat",
                kind: "u",
                desc: "Numeric format to use for summary value; a Format Column DisplayFormat will take precedence",
                isOpt: !0
            }
        ]
    },
    CellSummmaryInfo: {
        name: "CellSummmaryInfo",
        kind: "I",
        desc: "Defines the Summary operations which AdapTable provides for Selected Numeric Cells"
    },
    CellTextOption: {
        name: "CellTextOption",
        kind: "A",
        desc: "Text optionally to show in a Special Column Style special style: &#39;CellValue&#39; or &#39;PercentageValue&#39;"
    },
    CellTextOptions: {
        name: "CellTextOptions",
        kind: "A",
        desc: "Array of CellTextOption available in Special Column Styles"
    },
    CellUpdateRequest: {
        name: "CellUpdateRequest",
        kind: "I",
        desc: "Lightweight object used for identifying a Cell to be updated",
        props: [
            {
                name: "columnId",
                kind: "s",
                desc: "Id of Column in which edited cell is situated"
            },
            {
                name: "newValue",
                kind: "u",
                desc: "New Value for the cell"
            },
            {
                name: "primaryKeyValue",
                kind: "u",
                desc: "Primary Key column&#39;s value in row - how Adaptable locates the cell",
                isOpt: !0
            },
            {
                name: "rowNode",
                kind: "u",
                desc: "AG Grid Row Node that contains the cell (optional)",
                isOpt: !0
            }
        ]
    },
    ChartContainer: {
        name: "ChartContainer",
        kind: "I",
        desc: "Describes Location to display an AG Grid Chart",
        props: [
            {
                name: "chartsDisplay",
                kind: "'single' | 'multiple'",
                desc: "Whether 1 or more Charts can be displayed in same location",
                isOpt: !0,
                defVal: "&#39;single&#39;"
            },
            {
                name: "element",
                kind: "u",
                desc: "Location - can be HTMLElement or CSS Selector"
            },
            {
                name: "name",
                kind: "s",
                desc: "Name of Container&#39;s Location - used in Dropdowns"
            }
        ]
    },
    ChartDefinition: {
        name: "ChartDefinition",
        kind: "I",
        desc: "Wraps an AG Grid Chart Model",
        props: [
            {
                name: "Model",
                kind: "R",
                desc: "AG Grid Chart Model",
                ref: "unknown"
            },
            {
                name: "Name",
                kind: "s",
                desc: "Name of the chart definition"
            }
        ]
    },
    ChartingAggFunc: {
        name: "ChartingAggFunc",
        kind: "A",
        desc: "Aggregation function used in the Chart"
    },
    ChartingOptions: {
        name: "ChartingOptions",
        kind: "I",
        desc: "Options for managing AG Grid&#39;s Charts",
        props: [
            {
                name: "agGridContainerName",
                kind: "s",
                desc: "Name of AG Grid Chart Container",
                isOpt: !0,
                defVal: "&#39;AG Grid Window&#39;"
            },
            {
                name: "chartContainers",
                kind: "a",
                desc: "Locations to display saved Charts",
                isOpt: !0
            },
            {
                name: "externalChartingOptions",
                kind: "R",
                desc: "Set of properties for managing behaviour of external (i.e non AG Grid) charts",
                isOpt: !0,
                ref: "ExternalChartingOptions"
            },
            {
                name: "saveChartBehaviour",
                kind: "R",
                desc: "Behaviour for saving Charts: auto, manual (via popup) or none",
                isOpt: !0,
                noCode: "item",
                defVal: "&#39;none&#39;",
                ref: "SaveChartBehaviour"
            }
        ]
    },
    ChartingState: {
        name: "ChartingState",
        kind: "I",
        desc: "Persists AG Grid Charts in Adaptable State",
        props: [
            {
                name: "ChartDefinitions",
                kind: "a",
                desc: "Wrappers around AG Grid Chart Models",
                isOpt: !0
            },
            {
                name: "ExternalChartDefinitions",
                kind: "u",
                desc: "Definitions of External Charts",
                isOpt: !0
            }
        ]
    },
    ColumnBooleanFalseMap: {
        name: "ColumnBooleanFalseMap",
        kind: "A",
        desc: "Defines a map of Columns with a Boolean value"
    },
    ColumnComparison: {
        name: "ColumnComparison",
        kind: "I",
        desc: "Enables a Percent Bar or Gradient Style to use another column in its calculations",
        props: [
            {
                name: "Color",
                kind: "s",
                desc: "Colour to use for the Comparison"
            },
            {
                name: "MaxValue",
                kind: "number | string",
                desc: "End value - either numeric value or Column name"
            },
            {
                name: "MinValue",
                kind: "number | string",
                desc: "Start value - either numeric value or Column name"
            }
        ]
    },
    ColumnDirectionMap: {
        name: "ColumnDirectionMap",
        kind: "A",
        desc: "Defines a map of Columns with a Left / Right direction value"
    },
    ColumnFilter: {
        name: "ColumnFilter",
        kind: "I",
        desc: "Defines a Filter applied on a Column using a Predicate",
        props: [
            {
                name: "ColumnId",
                kind: "s",
                desc: "Column where Filter should be applied"
            },
            {
                name: "Predicates",
                kind: "a",
                desc: "`AdaptablePredicate` which AdaptableQL will evaluate when the Filter is run"
            },
            {
                name: "PredicatesOperator",
                kind: "R",
                desc: "Logic used when combining multiple Predicates (&#39;AND&#39;|&#39;OR&#39;)",
                isOpt: !0,
                defVal: "&#39;AND&#39;",
                ref: "PredicatesOperator"
            }
        ]
    },
    ColumnFilterDef: {
        name: "ColumnFilterDef",
        kind: "I",
        desc: "Column Filter Definition for a specific Column"
    },
    ColumnFilterOptions: {
        name: "ColumnFilterOptions",
        kind: "I",
        desc: "Options for managing Column Filtering in AdapTable",
        props: [
            {
                name: "defaultArrayColumnFilter",
                kind: "u",
                desc: "Default filter type for array Columns (&#39;textArray&#39;, &#39;numberArray&#39;, etc.)",
                isOpt: !0,
                gridInfo: "item",
                defVal: "In"
            },
            {
                name: "defaultDateColumnFilter",
                kind: "u",
                desc: "Default filter type for date Columns",
                isOpt: !0,
                gridInfo: "item",
                defVal: "On"
            },
            {
                name: "defaultNumericColumnFilter",
                kind: "u",
                desc: "Default filter type for numeric Columns",
                isOpt: !0,
                gridInfo: "item",
                defVal: "Equals"
            },
            {
                name: "defaultTextColumnFilter",
                kind: "u",
                desc: "Default filter type for text Columns",
                isOpt: !0,
                gridInfo: "item",
                defVal: "Contains"
            },
            {
                name: "hideQuickFilterDropdown",
                kind: "u",
                desc: "Hides Dropdown in Quick Filter Bar for a given Column",
                isOpt: !0,
                defVal: "undefined"
            },
            {
                name: "hideQuickFilterInput",
                kind: "u",
                desc: "Hides Input in Quick Filter Bar for a given Column",
                isOpt: !0,
                defVal: "undefined"
            },
            {
                name: "indicateFilteredColumns",
                kind: "b",
                desc: "Make Column Header distinctive for filtered columns, helps users see currently filtered columns",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "true"
            },
            {
                name: "manuallyApplyColumnFilter",
                kind: "u",
                desc: "Manually apply Column Filters; an Apply Filter button is displayed and Quick Filter is disabled",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "false"
            },
            {
                name: "quickFilterDebounce",
                kind: "n",
                desc: "Time to wait (in ms) before Filter Bar reacts to new value",
                isOpt: !0,
                gridInfo: "item",
                defVal: "250"
            },
            {
                name: "quickFilterHeight",
                kind: "n",
                desc: "Height of Quick Filter Bar (if not provided, AG Grid default is used)",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null"
            },
            {
                name: "quickFilterWildcards",
                kind: "u",
                desc: "Shortcut Keys to activate a Quick Filter Predicate",
                isOpt: !0
            },
            {
                name: "showQuickFilter",
                kind: "b",
                desc: "Display Quick Filter Bar between Column Header and Grid (provided its been setup)",
                isOpt: !0,
                noCode: "item",
                defVal: "true"
            }
        ]
    },
    ColumnFilterPredicate: {
        name: "ColumnFilterPredicate",
        kind: "I",
        desc: "A Predicate used in Column Filtering"
    },
    ColumnFriendlyNameContext: {
        name: "ColumnFriendlyNameContext",
        kind: "I",
        desc: "Context used when setting a Column Friendly Name",
        props: [
            {
                name: "agColumn",
                kind: "R",
                desc: "AG Grid ColDef for the Column",
                ref: "unknown"
            },
            {
                name: "colId",
                kind: "s",
                desc: "Id of the Column"
            },
            {
                name: "columnGroup",
                kind: "R",
                desc: "Column Group Information",
                ref: "AdaptableColumnGroup"
            },
            {
                name: "displayName",
                kind: "s",
                desc: "AG Grid Display Name"
            }
        ]
    },
    ColumnGroupScope: {
        name: "ColumnGroupScope",
        kind: "A",
        desc: "Defines Column Group Scope"
    },
    ColumnGroupValues: {
        name: "ColumnGroupValues",
        kind: "A",
        desc: "Manages Column Group expand / collapse behaviour, including exceptions"
    },
    ColumnGroupValuesWithExceptionKeys: {
        name: "ColumnGroupValuesWithExceptionKeys",
        kind: "A",
        desc: "Defines which Column Groups are expanded or collapsed"
    },
    ColumnHeaderContext: {
        name: "ColumnHeaderContext",
        kind: "A",
        desc: "Context provided to columnHeader function custom Headers to be provided for any type of AG Grid Column"
    },
    ColumnMenuContext: {
        name: "ColumnMenuContext",
        kind: "I",
        desc: "Provides full details about the Column in which the Column Menu will appear",
        props: [
            {
                name: "adaptableColumn",
                kind: "u",
                desc: "Current AdapTable Column"
            },
            {
                name: "agGridColumn",
                kind: "R",
                desc: "Current AG Grid Column",
                ref: "unknown"
            },
            {
                name: "isRowGroupColumn",
                kind: "b",
                desc: "Whether current Column is Row Group"
            }
        ]
    },
    ColumnMenuOptions: {
        name: "ColumnMenuOptions",
        kind: "I",
        desc: "Options for managing menus in AdapTable \u2013 provided using 2 collections",
        props: [
            {
                name: "customColumnMenu",
                kind: "u",
                desc: "Customises Column Menu (default column menu items are available in the provided context)",
                isOpt: !0
            }
        ]
    },
    ColumnNumberMap: {
        name: "ColumnNumberMap",
        kind: "A",
        desc: "Defines a map of Columns with a Number value"
    },
    ColumnOptions: {
        name: "ColumnOptions",
        kind: "I",
        desc: "Options related to managing Columns in Adaptable.",
        props: [
            {
                name: "addColumnGroupToColumnFriendlyName",
                kind: "b",
                desc: "Appends the name of the Column Group to a Column&#39;s Friendly Name",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "false"
            },
            {
                name: "columnFriendlyName",
                kind: "f",
                desc: "Provide an alternative Friendly Name for a Column",
                isOpt: !0,
                defVal: "undefined"
            },
            {
                name: "columnHeader",
                kind: "f",
                desc: "Provide a custom Header Name for a Table or Pivot Column",
                isOpt: !0
            },
            {
                name: "columnTypes",
                kind: "u",
                desc: "Optional list of Column Types - used for Scope and creating Special Columns",
                isOpt: !0,
                defVal: "Empty Array"
            },
            {
                name: "showMissingColumnsWarning",
                kind: "b",
                desc: "Log warning to console if AdapTable cannot find a column",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "true"
            }
        ]
    },
    ColumnScope: {
        name: "ColumnScope",
        kind: "A",
        desc: "Defines where a given Object / Module is active"
    },
    ColumnSizingDefinition: {
        name: "ColumnSizingDefinition",
        kind: "A",
        desc: "State &amp; behaviour for column sizing (must set `width` or `flex` but not both); all other props optional"
    },
    ColumnSizingMap: {
        name: "ColumnSizingMap",
        kind: "A",
        desc: "Defines a map of Columns with Sizing information"
    },
    ColumnSort: {
        name: "ColumnSort",
        kind: "I",
        desc: "Defines how a Column is sorted",
        props: [
            {
                name: "ColumnId",
                kind: "s",
                desc: "Id of Column being sorted"
            },
            {
                name: "SortOrder",
                kind: "'Asc' | 'Desc'",
                desc: "How Column is sorted - either &#39;Asc&#39; or &#39;Desc&#39;"
            }
        ]
    },
    ColumnStringMap: {
        name: "ColumnStringMap",
        kind: "A",
        desc: "Defines a map of Columns with a String value"
    },
    ColumnTypesContext: {
        name: "ColumnTypesContext",
        kind: "I",
        desc: "Context used when retrieving Column Types",
        props: [
            {
                name: "types",
                kind: "a",
                desc: "Current Column Types"
            }
        ]
    },
    ColumnValuesComparer: {
        name: "ColumnValuesComparer",
        kind: "I",
        desc: "Comparer object for Column Values - used for custom sorting",
        props: [
            {
                name: "comparer",
                kind: "u",
                desc: "Comparer function to use"
            },
            {
                name: "name",
                kind: "s",
                desc: "Name of the CustomSort Comparer"
            },
            {
                name: "scope",
                kind: "R",
                desc: "Column for which to compare values",
                ref: "ColumnScope"
            }
        ]
    },
    CommandHandler: {
        name: "CommandHandler",
        kind: "A",
        desc: "Handles an Alert Form Command"
    },
    CommentableCellContext: {
        name: "CommentableCellContext",
        kind: "I",
        desc: "Context used when determining if a cell can show Comments",
        props: [
            {
                name: "gridCell",
                kind: "R",
                desc: "Grid Cell in AdapTable which has been clicked",
                ref: "GridCell"
            }
        ]
    },
    CommentLoadContext: {
        name: "CommentLoadContext",
        kind: "I",
        desc: "Context used when loading Comments"
    },
    CommentOptions: {
        name: "CommentOptions",
        kind: "I",
        desc: "Options for managing Comments and Comment Threads in AdapTable",
        props: [
            {
                name: "dateFormat",
                kind: "u",
                desc: "Date Format string for Comments timestamp",
                isOpt: !0,
                defVal: "&#39;dd-MM-yyyy HH:mm:ss&#39;"
            },
            {
                name: "isCellCommentable",
                kind: "f",
                desc: "Function to configure if a cell can contain Comments",
                isOpt: !0
            },
            {
                name: "loadCommentThreads",
                kind: "f",
                desc: "Loads the Comment Threads",
                isOpt: !0
            },
            {
                name: "persistCommentThreads",
                kind: "f",
                desc: "Persists the current Comment Threads",
                isOpt: !0
            },
            {
                name: "showPopupCloseButton",
                kind: "b",
                desc: "Show the Close Button in the Comments Popup",
                isOpt: !0,
                defVal: "true"
            }
        ]
    },
    CommentState: {
        name: "CommentState",
        kind: "I",
        desc: "Internal State used for Comments Module",
        props: [
            {
                name: "CommentThreads",
                kind: "a",
                desc: "Collection of AdapTable Comments",
                isOpt: !0
            }
        ]
    },
    CommentThread: {
        name: "CommentThread",
        kind: "I",
        desc: "Thread of Comments for an Adaptable Cell",
        props: [
            {
                name: "Comments",
                kind: "a",
                desc: "Collection of Comments for this Cell"
            },
            {
                name: "Uuid",
                kind: "R",
                desc: "Unique identifier for Comment",
                isOpt: !0,
                ref: "unknown"
            }
        ]
    },
    ContainerContext: {
        name: "ContainerContext",
        kind: "A",
        desc: "Context available to `modalContainer`, `systemStatusContainer`, `alertContainer` and `transposedViewContainer` function callbacks"
    },
    ContainerOptions: {
        name: "ContainerOptions",
        kind: "I",
        desc: "Options for managing the different div elements required by AdapTable",
        props: [
            {
                name: "adaptableContainer",
                kind: "u",
                desc: "Div containing AdapTable; element Id, CSS Selector, HTMLElement, or function returning one of these",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&quot;adaptable&quot;"
            },
            {
                name: "agGridContainer",
                kind: "u",
                desc: "Div containing AG Grid instance; element Id, CSS Selector, HTMLElement, or function returning one of these.",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&quot;grid&quot;"
            },
            {
                name: "alertContainer",
                kind: "u",
                desc: "Div to display Alerts; elementId, CSS Selector, HTMLElement, or function returning one of these",
                isOpt: !0,
                gridInfo: "item",
                defVal: "undefined"
            },
            {
                name: "modalContainer",
                kind: "u",
                desc: "Name of div where popups appear;element Id, CSS Selector, HTMLElement, or function returning one of these",
                isOpt: !0,
                gridInfo: "item",
                defVal: "undefined (centre of screen)"
            },
            {
                name: "systemStatusContainer",
                kind: "u",
                desc: "Div to show System Status Messages; elementId, CSS Selector, HTMLElement, or function returning one of these",
                isOpt: !0,
                gridInfo: "item",
                defVal: "undefined"
            },
            {
                name: "transposedViewContainer",
                kind: "u",
                desc: "Div to render a Transposed View; elementId, CSS Selector, HTMLElement, or function returning one of these",
                isOpt: !0,
                gridInfo: "item",
                defVal: "undefined (rendered in a draggable popup window)"
            }
        ]
    },
    ContextMenuContext: {
        name: "ContextMenuContext",
        kind: "I",
        desc: "Provides full details about current cell (and selected cells) where the Context Menu will appear",
        props: [
            {
                name: "adaptableColumn",
                kind: "u",
                desc: "Current AdapTable Column"
            },
            {
                name: "agGridColumn",
                kind: "R",
                desc: "Current AG Grid Column",
                ref: "unknown"
            },
            {
                name: "gridCell",
                kind: "u",
                desc: "Cell that has been clicked; contains cell value"
            },
            {
                name: "isGroupedNode",
                kind: "b",
                desc: "Whether current AG Grid row node is grouped"
            },
            {
                name: "isRowGroupColumn",
                kind: "b",
                desc: "Whether current Column is Row Grouped"
            },
            {
                name: "isSelectedCell",
                kind: "b",
                desc: "Whether cell that was clicked is also currently selected"
            },
            {
                name: "isSelectedRow",
                kind: "b",
                desc: "Whether cell that was clicked is in a Row that is currently selected"
            },
            {
                name: "isSingleSelectedCell",
                kind: "b",
                desc: "Whether the clicked cell is the only selected cell"
            },
            {
                name: "isSingleSelectedColumn",
                kind: "b",
                desc: "Whether Column that was clicked is only column with selected cells"
            },
            {
                name: "primaryKeyValue",
                kind: "u",
                desc: "Value of Primary Key column in current row"
            },
            {
                name: "rowNode",
                kind: "u",
                desc: "Current AG Grid row node"
            },
            {
                name: "selectedCellInfo",
                kind: "u",
                desc: "Currently selected cells in the grid"
            },
            {
                name: "selectedRowInfo",
                kind: "u",
                desc: "Currently selected rows in the grid"
            }
        ]
    },
    ContextMenuOptions: {
        name: "ContextMenuOptions",
        kind: "I",
        desc: "Options for managing menus in AdapTable \u2013 provided using 2 collections",
        props: [
            {
                name: "customContextMenu",
                kind: "u",
                desc: "Customises Context Menu (default context menu items are available in provided context)",
                isOpt: !0
            }
        ]
    },
    CreateRowFormContext: {
        name: "CreateRowFormContext",
        kind: "I",
        desc: "Context used in a Create Row Form",
        props: [
            {
                name: "clonedRowNode",
                kind: "u",
                desc: "The RowNode being cloned",
                isOpt: !0
            },
            {
                name: "type",
                kind: "u",
                desc: "Type of the Context"
            }
        ]
    },
    CustomCellSummaryOperation: {
        name: "CustomCellSummaryOperation",
        kind: "I",
        desc: "Defines a Custom Cell Summary operation provided by a user",
        props: [
            {
                name: "operationFunction",
                kind: "u",
                desc: "Function to run when a summary result is required"
            },
            {
                name: "operationName",
                kind: "s",
                desc: "Name of the Operation - will be displayed in the Cell Summary components"
            }
        ]
    },
    CustomCellSummaryOperationContext: {
        name: "CustomCellSummaryOperationContext",
        kind: "I",
        desc: "Context provided to a custom Cell Summary Operation function",
        props: [
            {
                name: "selectedCellInfo",
                kind: "u",
                desc: "Currently selected cells"
            },
            {
                name: "selectedColumn",
                kind: "R",
                desc: "Currently selected Column",
                ref: "AdaptableColumn"
            }
        ]
    },
    CustomColumnMenuContext: {
        name: "CustomColumnMenuContext",
        kind: "I",
        desc: "Context info provided when building Custom Column Menus",
        props: [
            {
                name: "defaultAdaptableMenuItems",
                kind: "a",
                desc: "Flat list of all available AdapTable Menu Items"
            },
            {
                name: "defaultAdaptableMenuStructure",
                kind: "u",
                desc: "Default structure of Adaptable Menu Items"
            },
            {
                name: "defaultAgGridMenuItems",
                kind: "a",
                desc: "Flat list of all available AG Grid Menu Items"
            },
            {
                name: "defaultAgGridMenuStructure",
                kind: "u",
                desc: "Default structure of AG Grid Menu Items"
            }
        ]
    },
    CustomColumnMenuItem: {
        name: "CustomColumnMenuItem",
        kind: "A",
        desc: "Custom Column Menu Item"
    },
    CustomContextMenuContext: {
        name: "CustomContextMenuContext",
        kind: "I",
        desc: "Context info provided when building Custom Context Menus",
        props: [
            {
                name: "defaultAdaptableMenuItems",
                kind: "a",
                desc: "Flat list of all available AdapTable Menu Items"
            },
            {
                name: "defaultAdaptableMenuStructure",
                kind: "R",
                desc: "Default structure of Adaptable Menu Items",
                ref: "DefaultAdaptableMenuStructure"
            },
            {
                name: "defaultAgGridMenuItems",
                kind: "a",
                desc: "Flat list of all available AG Grid Menu Items"
            },
            {
                name: "defaultAgGridMenuStructure",
                kind: "R",
                desc: "Default structure of AG Grid Menu Items",
                ref: "DefaultAgGridMenuStructure"
            }
        ]
    },
    CustomContextMenuItem: {
        name: "CustomContextMenuItem",
        kind: "A",
        desc: "Custom Context Menu Item"
    },
    CustomDestination: {
        name: "CustomDestination",
        kind: "I",
        desc: "Defines a custom Export destination",
        props: [
            {
                name: "form",
                kind: "u",
                desc: "Optional Adaptable Form; if provided, it must include Buttons that will execute the Export",
                isOpt: !0
            },
            {
                name: "name",
                kind: "s",
                desc: "Name of Custom Destination (mandatory)"
            },
            {
                name: "onExport",
                kind: "f",
                desc: "Optional Function invoked when Export is applied (used if no form is supplied)",
                isOpt: !0
            }
        ]
    },
    CustomDestinationsContext: {
        name: "CustomDestinationsContext",
        kind: "I",
        desc: "Context provided to `ExportOptions.customDestinations` callback",
        props: [
            {
                name: "currentLayoutName",
                kind: "s",
                desc: "Name of current Layout"
            },
            {
                name: "currentReportFormat",
                kind: "R",
                desc: "Format of current Report",
                isOpt: !0,
                ref: "ReportFormatType"
            },
            {
                name: "currentReportName",
                kind: "R",
                desc: "Name of current Report",
                isOpt: !0,
                ref: "ReportNameType"
            }
        ]
    },
    CustomDisplayFormatter: {
        name: "CustomDisplayFormatter",
        kind: "I",
        desc: "Defines a Custom Display Format",
        props: [
            {
                name: "handler",
                kind: "f",
                desc: "Function used to render the Custom Display Format"
            },
            {
                name: "id",
                kind: "s",
                desc: "Custom Format Id"
            },
            {
                name: "label",
                kind: "s",
                desc: "Custom Format Description",
                isOpt: !0
            },
            {
                name: "scope",
                kind: "R",
                desc: "Used by Format Columns wizard to show where Custom Display Format can be applied",
                ref: "ColumnScope"
            }
        ]
    },
    CustomDisplayFormatterContext: {
        name: "CustomDisplayFormatterContext",
        kind: "I",
        desc: "Context used in handler of CustomDisplayFormatter",
        props: [
            {
                name: "adaptableColumn",
                kind: "R",
                desc: "Column where Custom Display Format will apply",
                ref: "AdaptableColumn"
            },
            {
                name: "cellValue",
                kind: "u",
                desc: "Non-formatted Cell Value"
            },
            {
                name: "rowNode",
                kind: "R",
                desc: "Node where Custom Display Format will apply",
                ref: "unknown"
            }
        ]
    },
    CustomEditColumnValueInfo: {
        name: "CustomEditColumnValueInfo",
        kind: "I",
        desc: "Information about items in the custom Edit Controls"
    },
    CustomEditColumnValuesContext: {
        name: "CustomEditColumnValuesContext",
        kind: "I",
        desc: "Context used when getting Distinct Column Values for Editing",
        props: [
            {
                name: "currentSearchValue",
                kind: "s",
                desc: "Search text in Edit - used when fetching values from server"
            },
            {
                name: "defaultValues",
                kind: "a",
                desc: "Current distinct values in Column"
            },
            {
                name: "gridCell",
                kind: "R",
                desc: "Currently edited Grid Cell",
                ref: "GridCell"
            }
        ]
    },
    CustomExportParams: {
        name: "CustomExportParams",
        kind: "A",
        desc: "Custom Export Params extending AG Grid&#39;s base export params; allows overriding AdapTable default export"
    },
    CustomGroupColumnMenuItem: {
        name: "CustomGroupColumnMenuItem",
        kind: "A",
        desc: "Defines a Grouped Menu Item in the Column Menu"
    },
    CustomGroupContextMenuItem: {
        name: "CustomGroupContextMenuItem",
        kind: "A",
        desc: "Defines a Grouped Menu Item in the Context Menu"
    },
    CustomIcon: {
        name: "CustomIcon",
        kind: "I",
        desc: "Defines a bespoke Icon provided by a developer",
        props: [
            {
                name: "icon",
                kind: "R",
                desc: "AdapTable Icon definition",
                ref: "AdaptableIcon"
            },
            {
                name: "name",
                kind: "s",
                desc: "Name of Icon"
            }
        ]
    },
    CustomInFilterValuesContext: {
        name: "CustomInFilterValuesContext",
        kind: "I",
        desc: "Context used when providing values for the IN Column Filter",
        props: [
            {
                name: "currentSearchValue",
                kind: "s",
                desc: "Search text in the IN Filter component - used when filtering on server"
            },
            {
                name: "defaultValues",
                kind: "a",
                desc: "Default list of values that will be displayed"
            },
            {
                name: "orderedValues",
                kind: "a",
                desc: "Default values in order which currently listed in the grid"
            },
            {
                name: "previousFilterResult",
                kind: "R",
                desc: "Last filter result; avoids expensive recomputations (eg if async or server-side filtering)",
                isOpt: !0,
                ref: "InFilterValueResult"
            },
            {
                name: "sortedValues",
                kind: "a",
                desc: "Default values but sorted (if Column is sorted)"
            }
        ]
    },
    CustomQueryVariableContext: {
        name: "CustomQueryVariableContext",
        kind: "I",
        desc: "Context passed when evaluating customQueryVariables",
        props: [
            {
                name: "args",
                kind: "a",
                desc: "Optional variable arguments",
                isOpt: !0
            }
        ]
    },
    CustomRenderContext: {
        name: "CustomRenderContext",
        kind: "I",
        desc: "Context provided for any custom rendering",
        props: [
            {
                name: "element",
                kind: "R",
                desc: "Container Div Element",
                ref: "unknown"
            },
            {
                name: "phase",
                kind: "'onMount' | 'onDestroy'",
                desc: "Phase of DOM Element lifecycle"
            }
        ]
    },
    CustomRenderFunction: {
        name: "CustomRenderFunction",
        kind: "I",
        desc: "Function which is called when rendering/destroying a custom framework-agnostic component",
        props: [
            {
                name: "(call)",
                kind: "f",
                desc: "Function to provide bespoke content when NOT using a Framework wrapper"
            }
        ]
    },
    CustomSettingsPanel: {
        name: "CustomSettingsPanel",
        kind: "I",
        desc: "Definition of a Custom Panel to add to the Adaptable Settings Panel",
        props: [
            {
                name: "frameworkComponent",
                kind: "R",
                desc: "Framework-specific (Angular, React or Vue) component to be rendered",
                isOpt: !0,
                ref: "AdaptableFrameworkComponent"
            },
            {
                name: "icon",
                kind: "R",
                desc: "Icon rendered inside settings-panel name, inside the navigation",
                isOpt: !0,
                ref: "AdaptableIcon"
            },
            {
                name: "name",
                kind: "s",
                desc: "Appears in Settings Panel Navigation and must be included in settingsPanelOptions.navigation for it to be displayed (by default added to the end)"
            },
            {
                name: "render",
                kind: "f",
                desc: "Function to provide bespoke content when NOT using a Framework wrapper",
                isOpt: !0
            }
        ]
    },
    CustomSharedEntity: {
        name: "CustomSharedEntity",
        kind: "I",
        desc: "Defines a Custom object that will be shared using Team Sharing",
        props: [
            {
                name: "ChangedAt",
                kind: "n",
                desc: "Last time when the object was changed"
            },
            {
                name: "ChangedBy",
                kind: "s",
                desc: "Last User who changed the object"
            },
            {
                name: "Description",
                kind: "s",
                desc: "Description of object being shared"
            },
            {
                name: "Entity",
                kind: "u",
                desc: "Custom Object being shared"
            },
            {
                name: "EntityType",
                kind: "u",
                desc: "Type of shared entity (either Adaptable specific or custom object)"
            },
            {
                name: "IsReadOnly",
                kind: "b",
                desc: "Sets Entity to ReadOnly (overwriting a Strategy Entitlement of &#39;Full&#39;)",
                isOpt: !0
            },
            {
                name: "Name",
                kind: "s",
                desc: "Name of object being shared"
            },
            {
                name: "Tags",
                kind: "a",
                desc: "List of Tags associated with the Object",
                isOpt: !0
            },
            {
                name: "Timestamp",
                kind: "n",
                desc: "When the object was shared"
            },
            {
                name: "UserName",
                kind: "s",
                desc: "User who shared the object"
            },
            {
                name: "Uuid",
                kind: "R",
                desc: "Unique identifier for the Custom Shared Entity",
                ref: "unknown"
            }
        ]
    },
    CustomSharedEntityConfig: {
        name: "CustomSharedEntityConfig",
        kind: "I",
        desc: "Describes a custom Object which is being Team Shared",
        props: [
            {
                name: "Description",
                kind: "s",
                desc: "Description of object being shared"
            },
            {
                name: "Name",
                kind: "s",
                desc: "Name of object being shared"
            },
            {
                name: "Tags",
                kind: "a",
                desc: "List of Tags associated with the Object",
                isOpt: !0
            },
            {
                name: "Uuid",
                kind: "s",
                desc: "Optional technical ID; if not provided, it will be auto-generated by Adaptable",
                isOpt: !0
            }
        ]
    },
    CustomSort: {
        name: "CustomSort",
        kind: "I",
        desc: "Custom Sort object used in Custom Sort function.",
        props: [
            {
                name: "ColumnId",
                kind: "s",
                desc: "Id of Column on which Custom Sort will be applied"
            },
            {
                name: "Name",
                kind: "s",
                desc: "Name of the Custom Sort definition"
            },
            {
                name: "SortedValues",
                kind: "u",
                desc: "Order of values by which Column will be sorted; Date values are persisted as ISO strings (&#39;yyyy-MM-dd&#39;)",
                isOpt: !0
            }
        ]
    },
    CustomSortOptions: {
        name: "CustomSortOptions",
        kind: "I",
        desc: "Used to provide Custom Sorts comparers",
        props: [
            {
                name: "customSortComparers",
                kind: "u",
                desc: "CustomSort column comparer functions",
                isOpt: !0
            }
        ]
    },
    CustomSortState: {
        name: "CustomSortState",
        kind: "I",
        desc: "Adaptable State Section for Custom Sort Module",
        props: [
            {
                name: "CustomSorts",
                kind: "a",
                desc: "Collection of Custom Sort objects.",
                isOpt: !0
            }
        ]
    },
    CustomToolbar: {
        name: "CustomToolbar",
        kind: "I",
        desc: "Custom Toolbar (which AdapTable will manage) enabling devs to populate Dashboard with bepoke content",
        props: [
            {
                name: "frameworkComponent",
                kind: "R",
                desc: "The Framework-specific (Angular, React or Vue) component to be rendered",
                isOpt: !0,
                ref: "AdaptableFrameworkComponent"
            },
            {
                name: "name",
                kind: "s",
                desc: "How Toolbar is referenced (e.g. in Dashboard Popup when managing toolbars)"
            },
            {
                name: "render",
                kind: "f",
                desc: "Function to provide custom content when NOT using a Framework wrapper",
                isOpt: !0
            },
            {
                name: "title",
                kind: "s",
                desc: "Title to display in Toolbar; if unset or empty string, nothing will show",
                isOpt: !0
            },
            {
                name: "toolbarActions",
                kind: "R",
                desc: "Actions available in a Custom Dashboard Toolbar",
                isOpt: !0,
                ref: "ToolbarActions"
            },
            {
                name: "toolbarButtons",
                kind: "a",
                desc: "Optional set of buttons to show in the Toolbar",
                isOpt: !0
            }
        ]
    },
    CustomToolbarButtonContext: {
        name: "CustomToolbarButtonContext",
        kind: "I",
        desc: "Context required by functions when using a Custom Toolbar Button",
        props: [
            {
                name: "customToolbar",
                kind: "R",
                desc: "Custom Toolbar which hosts the Button",
                ref: "CustomToolbar"
            }
        ]
    },
    CustomToolPanel: {
        name: "CustomToolPanel",
        kind: "I",
        desc: "Defines a Custom ToolPanel - provided by Users and contains custom content",
        props: [
            {
                name: "buttons",
                kind: "a",
                desc: "Optional set of buttons to show in the ToolPanel",
                isOpt: !0
            },
            {
                name: "frameworkComponent",
                kind: "R",
                desc: "Framework-specific (Angular, React or Vue) component to be rendered",
                isOpt: !0,
                ref: "AdaptableFrameworkComponent"
            },
            {
                name: "name",
                kind: "s",
                desc: "Name of Custom ToolPanel - should be unique"
            },
            {
                name: "render",
                kind: "f",
                desc: "Function to provide bespoke content when using AdapTable Vanilla",
                isOpt: !0
            },
            {
                name: "title",
                kind: "s",
                desc: "Title to display in Custom ToolPanel; if undefined, will default to `name` property",
                isOpt: !0
            }
        ]
    },
    CustomToolPanelButtonContext: {
        name: "CustomToolPanelButtonContext",
        kind: "I",
        desc: "Context used for Custom Tool Panels containing Buttons",
        props: [
            {
                name: "customToolPanel",
                kind: "R",
                desc: "The Custom ToolPanel which contains the button",
                ref: "CustomToolPanel"
            }
        ]
    },
    CustomWindowConfig: {
        name: "CustomWindowConfig",
        kind: "I",
        desc: "Config used to open a Custom Window",
        props: [
            {
                name: "frameworkComponent",
                kind: "R",
                desc: "React, Angular or Vue Framework component to use for Custom Window content",
                isOpt: !0,
                ref: "AdaptableFrameworkComponent"
            },
            {
                name: "icon",
                kind: "R",
                desc: "Icon to display in Custom Window header",
                isOpt: !0,
                ref: "AdaptableSystemIconName"
            },
            {
                name: "id",
                kind: "s",
                desc: "Unique identifier for Custom Window"
            },
            {
                name: "onFrameworkComponentDestroyed",
                kind: "u",
                desc: "Callback function invoked when framework component is destroyed",
                isOpt: !0
            },
            {
                name: "position",
                kind: "R",
                desc: "Position of window in pixels (provided as x, y)",
                isOpt: !0,
                ref: "WindowPosition"
            },
            {
                name: "render",
                kind: "f",
                desc: "Render function to display content in Custom Window (if not using a framework component)",
                isOpt: !0
            },
            {
                name: "size",
                kind: "R",
                desc: "Size of window in pixels (provided as width, height)",
                isOpt: !0,
                ref: "WindowSize"
            },
            {
                name: "title",
                kind: "s",
                desc: "Title of Custom Window",
                isOpt: !0
            }
        ]
    },
    DashboardButtonContext: {
        name: "DashboardButtonContext",
        kind: "I",
        desc: "Context required by functions when using a Dashboard Button",
        props: [
            {
                name: "dashboardState",
                kind: "R",
                desc: "Current Dashboard State",
                ref: "DashboardState"
            }
        ]
    },
    DashboardButtonsLocation: {
        name: "DashboardButtonsLocation",
        kind: "A",
        desc: "Where Dashboard Buttons are displayed"
    },
    DashboardOptions: {
        name: "DashboardOptions",
        kind: "I",
        desc: "Options related to the Dashboard in Adaptable.",
        props: [
            {
                name: "buttonsLocation",
                kind: "R",
                desc: "Where in Dashboard to display Module and Custom Buttons",
                isOpt: !0,
                noCode: "item",
                defVal: "&#39;right&#39;",
                ref: "DashboardButtonsLocation"
            },
            {
                name: "canFloat",
                kind: "b",
                desc: "Whether the Dashboard can be floated; if true (the default), double-clicking Dashboard puts it in float mode",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "true"
            },
            {
                name: "customDashboardButtons",
                kind: "a",
                desc: "Custom Adaptable Buttons to appear in Dashboard (alongside Module Buttons)",
                isOpt: !0
            },
            {
                name: "customToolbars",
                kind: "a",
                desc: "Toolbars provided by Users which contain custom content",
                isOpt: !0
            },
            {
                name: "showQuickSearchInHeader",
                kind: "b",
                desc: "Shows Quick Search textbox in the Dashboard Header",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "true"
            }
        ]
    },
    DashboardState: {
        name: "DashboardState",
        kind: "I",
        desc: "Adaptable State Section for the AdapTable Dashboard",
        props: [
            {
                name: "ActiveTabIndex",
                kind: "n",
                desc: "Index of Active Tab (in Tabs collection)",
                isOpt: !0
            },
            {
                name: "DashboardTitle",
                kind: "s",
                desc: "Title displayed in Dashboard Header",
                isOpt: !0,
                defVal: "`adaptableId` in Adaptable Options"
            },
            {
                name: "FloatingPosition",
                kind: "R",
                desc: "Position of Dashboard when in Floating mode",
                isOpt: !0,
                ref: "AdaptableCoordinate"
            },
            {
                name: "IsCollapsed",
                kind: "b",
                desc: "Is Dashboard collapsed; if true, header is visible (but not Tabs&#39; contents)",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "IsFloating",
                kind: "b",
                desc: "Is Dashboard floating; if true, appears in draggable, minmised form (double-click to revert to default position)",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "IsHidden",
                kind: "b",
                desc: "Whether Dashboard is completely hidden - can be made visible again in Column Menu and Tool Panel",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "IsInline",
                kind: "b",
                desc: "Alternative way of rendering Dashboard, with headers section to left of Toolbars",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "ModuleButtons",
                kind: "R",
                desc: "Buttons which open the Settings Panel screen for associated AdapTable Module",
                isOpt: !0,
                defVal: "[&#39;SettingsPanel&#39;]",
                ref: "unknown"
            },
            {
                name: "PinnedToolbars",
                kind: "u",
                desc: "Toolbars displayed above Grid (and not in Tab)",
                isOpt: !0
            },
            {
                name: "Tabs",
                kind: "a",
                desc: "Named group of Toolbars",
                isOpt: !0,
                defVal: "Empty Array"
            }
        ]
    },
    DashboardTab: {
        name: "DashboardTab",
        kind: "I",
        desc: "Defines a named set of Toolbars in the AdapTable Dashboard",
        props: [
            {
                name: "Name",
                kind: "s",
                desc: "Name of the Dashboard Tab as it appears in the Dashboard header"
            },
            {
                name: "Toolbars",
                kind: "u",
                desc: "List of Toolbars to show in the Tab"
            }
        ]
    },
    DataChangeDetectionPolicy: {
        name: "DataChangeDetectionPolicy",
        kind: "A",
        desc: "Cell Change that will trigger an Alert: can be &#39;rawValue&#39; or &#39;formattedValue&#39;"
    },
    DataChangedScope: {
        name: "DataChangedScope",
        kind: "I",
        desc: "Defines where a Data Change should be monitored",
        props: [
            {
                name: "columnIds",
                kind: "u",
                desc: "Scopes a group of Column Ids"
            },
            {
                name: "wholeRow",
                kind: "b",
                desc: "Scopes every Column in the Row"
            }
        ]
    },
    DataChangeHistoryButton: {
        name: "DataChangeHistoryButton",
        kind: "I",
        desc: "A custom AdaptableButton which provides a build in `undo` action"
    },
    DataChangeHistoryContext: {
        name: "DataChangeHistoryContext",
        kind: "I",
        desc: "The context for the DataChangeHistoryButton",
        props: [
            {
                name: "clearRow",
                kind: "u",
                desc: "Helper function to row from Grid"
            },
            {
                name: "dataChangedInfo",
                kind: "u",
                desc: "The initial data change"
            },
            {
                name: "isGroupNode",
                kind: "b",
                desc: "If the change references a group node."
            },
            {
                name: "parentAdapTableApi",
                kind: "R",
                desc: "AdapTable API of underlying Grid (not from Data History Monitor)",
                ref: "unknown"
            },
            {
                name: "undoDataChange",
                kind: "u",
                desc: "Helper function to undo the change."
            }
        ]
    },
    DataChangeHistoryOptions: {
        name: "DataChangeHistoryOptions",
        kind: "I",
        desc: "Options to manage the &#39;Data Change History Module&#39;, which provides an overview of all previous changes, giving the possibility to undo specific changes",
        props: [
            {
                name: "activeByDefault",
                kind: "b",
                desc: "Make Data Change History active by default",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "false"
            },
            {
                name: "changeHistoryButton",
                kind: "u",
                desc: "Action button definition; can be used to implement undo functionality",
                isOpt: !0,
                defVal: "undefined"
            },
            {
                name: "showDataChange",
                kind: "u",
                desc: "Function specifying which data changes to include in Data Change History",
                isOpt: !0,
                gridInfo: "item",
                defVal: "undefined (all data changes are logged)"
            },
            {
                name: "showLastDataChangeOnly",
                kind: "b",
                desc: "Show all changes for a Cell or just the last one",
                isOpt: !0,
                defVal: "true"
            }
        ]
    },
    DataFormatDataType: {
        name: "DataFormatDataType",
        kind: "I",
        desc: "Defines the Format Data Types for all Data Types",
        props: [
            {
                name: "date",
                kind: "R",
                desc: "Data Format type for Date columns",
                isOpt: !0,
                ref: "DataFormatType"
            },
            {
                name: "number",
                kind: "R",
                desc: "Data Format type for Number columns",
                isOpt: !0,
                ref: "DataFormatType"
            },
            {
                name: "text",
                kind: "R",
                desc: "Data Format type for String / Text columns",
                isOpt: !0,
                ref: "DataFormatType"
            }
        ]
    },
    DataFormatType: {
        name: "DataFormatType",
        kind: "A",
        desc: "Format of exported Data - &#39;rawValue&#39; or &#39;formattedValue&#39;"
    },
    DataImportFileHandler: {
        name: "DataImportFileHandler",
        kind: "I",
        desc: "Files that can be handled by Data Import",
        props: [
            {
                name: "fileExtension",
                kind: "s",
                desc: "Name of File Extension",
                isOpt: !0
            },
            {
                name: "handleFile",
                kind: "u",
                desc: "Async function which handles the import returning a Data Record"
            }
        ]
    },
    DataImportOptions: {
        name: "DataImportOptions",
        kind: "I",
        desc: "Options for managing the Data Import function",
        props: [
            {
                name: "_getPrimaryKeyValue",
                kind: "u",
                desc: "Function to get the Primary Key value for a data row (defaults to value of the primaryKey column)",
                isOpt: !0
            },
            {
                name: "_preprocessRowData",
                kind: "u",
                desc: "Function to pre-process the data before it is imported",
                isOpt: !0
            },
            {
                name: "fileHandlers",
                kind: "a",
                desc: "Custom File Handlers to use for Data Import",
                isOpt: !0
            },
            {
                name: "handleImportedData",
                kind: "u",
                desc: "Function to handle the Imported Data and apply it to the Grid. If not provided then the Data will be applied to the Grid automatically.",
                isOpt: !0
            },
            {
                name: "textHandler",
                kind: "u",
                desc: "Handles Importing Data using text",
                isOpt: !0
            },
            {
                name: "validate",
                kind: "u",
                desc: "Function to validate the Imported Data",
                isOpt: !0
            }
        ]
    },
    DataImportValidateContext: {
        name: "DataImportValidateContext",
        kind: "I",
        desc: "Context passed to the `validate` function",
        props: [
            {
                name: "rowData",
                kind: "u",
                desc: "Imported Row Data"
            }
        ]
    },
    DataImportValidationError: {
        name: "DataImportValidationError",
        kind: "I",
        desc: "Defines a Validation Error",
        props: [
            {
                name: "columnId",
                kind: "s",
                desc: "Column which contains the Error"
            },
            {
                name: "error",
                kind: "s",
                desc: "The validatoin error text"
            }
        ]
    },
    DataRowConfig: {
        name: "DataRowConfig",
        kind: "I",
        desc: "Config object using for passing in rows to manageGridData function",
        props: [
            {
                name: "addRows",
                kind: "a",
                desc: "Rows to add",
                isOpt: !0
            },
            {
                name: "deleteRows",
                kind: "a",
                desc: "Rows to delete",
                isOpt: !0
            },
            {
                name: "updateRows",
                kind: "a",
                desc: "Rows to update",
                isOpt: !0
            }
        ]
    },
    DataSet: {
        name: "DataSet",
        kind: "I",
        desc: "Defines a Data Set object that can provide data to AdapTable",
        props: [
            {
                name: "description",
                kind: "s",
                desc: "Describes the Data Set"
            },
            {
                name: "form",
                kind: "u",
                desc: "Params for Data Set popup form",
                isOpt: !0
            },
            {
                name: "info",
                kind: "u",
                desc: "Additional info for Data Set",
                isOpt: !0
            },
            {
                name: "name",
                kind: "s",
                desc: "Name of Data Set"
            }
        ]
    },
    DataSetFormContext: {
        name: "DataSetFormContext",
        kind: "I",
        desc: "Used when a DataSet displays a Form",
        props: [
            {
                name: "dataSet",
                kind: "R",
                desc: "The DataSet which triggered the Form",
                ref: "DataSet"
            }
        ]
    },
    DataSetOptions: {
        name: "DataSetOptions",
        kind: "I",
        desc: "Options to provide Data Sets",
        props: [
            {
                name: "dataSets",
                kind: "a",
                desc: "Collection of Data Sets to provide data to AdapTable",
                isOpt: !0
            }
        ]
    },
    DataUpdateConfig: {
        name: "DataUpdateConfig",
        kind: "I",
        desc: "Object used to configure GridApi row management methods",
        props: [
            {
                name: "addIndex",
                kind: "n",
                desc: "Index where to add new rows",
                isOpt: !0
            },
            {
                name: "callback",
                kind: "u",
                desc: "Callback function invoked when a batch successfully concludes",
                isOpt: !0
            },
            {
                name: "flushAsync",
                kind: "b",
                desc: "Whether to flush async operations",
                isOpt: !0
            },
            {
                name: "runAsync",
                kind: "b",
                desc: "Whether row operation should happen asynchronously",
                isOpt: !0
            }
        ]
    },
    DateFormatterOptions: {
        name: "DateFormatterOptions",
        kind: "I",
        desc: "Formatter Options for Date Columns - contains a single `Pattern` property",
        props: [
            {
                name: "Pattern",
                kind: "s",
                desc: "Pattern to use for Date Format",
                isOpt: !0
            }
        ]
    },
    DateInputOptions: {
        name: "DateInputOptions",
        kind: "I",
        desc: "Options for managing and customizing the date inputs.",
        props: [
            {
                name: "dateFormat",
                kind: "s",
                desc: "Format string for formatting date input field",
                isOpt: !0,
                defVal: "&#39;yyyy-MM-dd&#39; (ISO 8601 format)"
            },
            {
                name: "datepickerButtons",
                kind: "a",
                desc: "List of buttons which are displayed in the datepicker overlay in the given order (provide empty array to display no buttons); custom button layout and positioning is achievable with the special elements `-` and `|`",
                isOpt: !0,
                defVal: "[&#39;close&#39;,&#39;today&#39;]"
            },
            {
                name: "locale",
                kind: "u",
                desc: "Locale object (to localize Date Picker)",
                isOpt: !0,
                defVal: "`en-US`"
            },
            {
                name: "showOutsideDays",
                kind: "b",
                desc: "Display outside days (i.e. those falling in next or previous month)",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "showWeekNumber",
                kind: "b",
                desc: "Display the week numbers column",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "useNativeInput",
                kind: "b",
                desc: "Use browser specific date input instead of AdapTable&#39;s Date Picker",
                isOpt: !0,
                defVal: "false"
            }
        ]
    },
    DefaultAccessLevelContext: {
        name: "DefaultAccessLevelContext",
        kind: "I",
        desc: "Provided to defaultAccessLevel function when setting Default Entitlement value programatically"
    },
    DefaultAdaptableMenuStructure: {
        name: "DefaultAdaptableMenuStructure",
        kind: "A",
        desc: "The Context Menu provided by AadapTable by default"
    },
    DefaultAgGridMenuStructure: {
        name: "DefaultAgGridMenuStructure",
        kind: "A",
        desc: "AG Grid section of Context Menu provided by AadapTable by default"
    },
    DefaultPredicateFilterContext: {
        name: "DefaultPredicateFilterContext",
        kind: "I",
        desc: "Context used for setting default Predicates for Column Filters",
        props: [
            {
                name: "column",
                kind: "u",
                desc: "Current Column"
            },
            {
                name: "filterComponent",
                kind: "R",
                desc: "Filter Component being displayed: FilterBar or FilterForm",
                ref: "AdaptableFilterComponentLocation"
            }
        ]
    },
    DetailInitContext: {
        name: "DetailInitContext",
        kind: "I",
        desc: "Context passed to Detail Grids when using Master Detail Plugin",
        props: [
            {
                name: "data",
                kind: "u",
                desc: "The data in the Master Grid Row that was opened"
            },
            {
                name: "primaryKeyValue",
                kind: "u",
                desc: "Primary Key Value of Master Grid Row that was opened"
            },
            {
                name: "rowNode",
                kind: "R",
                desc: "Row Node in the Master Grid that was opened",
                ref: "unknown"
            }
        ]
    },
    EditColumnValueInfo: {
        name: "EditColumnValueInfo",
        kind: "I",
        desc: "Information about items in the Edit Controls"
    },
    EditOptions: {
        name: "EditOptions",
        kind: "I",
        desc: "Options related to Editing in AdapTable - includes Server Validation, Smart Edit Operations and Cell Editabiility",
        props: [
            {
                name: "customEditColumnValues",
                kind: "u",
                desc: "List of Column values to display when Editing (i.e. in Edit Lookups, Bulk Update)",
                isOpt: !0
            },
            {
                name: "displayServerValidationMessages",
                kind: "b",
                desc: "Whether to display message after Server Validation runs",
                isOpt: !0,
                gridInfo: "item",
                defVal: "true"
            },
            {
                name: "isCellEditable",
                kind: "u",
                desc: "Function which checks if a given Grid Cell is editable",
                isOpt: !0
            },
            {
                name: "showSelectCellEditor",
                kind: "u",
                desc: "Columns that will display a Select dropdown when editing",
                isOpt: !0
            },
            {
                name: "smartEditCustomOperations",
                kind: "u",
                desc: "Custom Operations to use in Smart Edit",
                isOpt: !0
            },
            {
                name: "validateOnServer",
                kind: "u",
                desc: "Function to validate AdapTable data edits remotely",
                isOpt: !0
            }
        ]
    },
    EditRowFormContext: {
        name: "EditRowFormContext",
        kind: "I",
        desc: "Context used in an Edit Row Form",
        props: [
            {
                name: "rowNode",
                kind: "u",
                desc: "The RowNode being edited"
            },
            {
                name: "type",
                kind: "u",
                desc: "Type of the Context"
            }
        ]
    },
    Entitlement: {
        name: "Entitlement",
        kind: "I",
        desc: "Defines a Permission in AdapTable - Module and Access Level",
        props: [
            {
                name: "accessLevel",
                kind: "R",
                desc: "Access Level for an Entitlement; options are: `Full` `ReadOnly` `Hidden`",
                ref: "AccessLevel"
            },
            {
                name: "adaptableModule",
                kind: "R",
                desc: "Name of Adaptable Module that has the Entitlement applied",
                ref: "AdaptableModule"
            }
        ]
    },
    EntitlementContext: {
        name: "EntitlementContext",
        kind: "I",
        desc: "Provided to moduleEntitlements function when setting Entitlements programatically",
        props: [
            {
                name: "adaptableModule",
                kind: "R",
                desc: "Module being entitled",
                ref: "AdaptableModule"
            },
            {
                name: "defaultAccessLevel",
                kind: "R",
                desc: "The default Access Level for the current instance",
                ref: "AccessLevel"
            }
        ]
    },
    EntitlementOptions: {
        name: "EntitlementOptions",
        kind: "I",
        desc: "Options for managing Entitlements in AdapTable, ie. which Modules are available to the User and whether as *Full*, *ReadOnly* or *Hidden*.",
        props: [
            {
                name: "defaultAccessLevel",
                kind: "u",
                desc: "AccessLevel to use when an Entitlement is not explicitly set; can be hardcoded value or a function to invoke",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;Full&#39;"
            },
            {
                name: "moduleEntitlements",
                kind: "u",
                desc: "Returns either collection of `Entitlements`, or a function to invoke when an Entitlement is required",
                isOpt: !0,
                gridInfo: "item"
            }
        ]
    },
    EvaluateExpressionExternallyContext: {
        name: "EvaluateExpressionExternallyContext",
        kind: "I",
        desc: "Context passed when evaluating `expressionOptions.evaluateExpressionExternally()`",
        props: [
            {
                name: "expression",
                kind: "s",
                desc: "Expression to evaluate",
                isOpt: !0
            },
            {
                name: "module",
                kind: "R",
                desc: "Module being evaluated: Alert, CalculatedColumn, ColumnFilter, GridFilter",
                ref: "AdaptableQLModule"
            },
            {
                name: "object",
                kind: "R",
                desc: "AdapTable Object which contains the Expression or Predicates",
                isOpt: !0,
                ref: "AdaptableObject"
            },
            {
                name: "predicates",
                kind: "a",
                desc: "Any Predicates to evaluate",
                isOpt: !0
            },
            {
                name: "referencedColumns",
                kind: "u",
                desc: "Columns contained in Expression",
                isOpt: !0
            }
        ]
    },
    ExportConfig: {
        name: "ExportConfig",
        kind: "I",
        desc: "Config used when Exporting via API, allows fine grained exporting",
        props: [
            {
                name: "exportParams",
                kind: "u",
                desc: "Function to modify export params; receives default params &amp; returns modified params",
                isOpt: !0
            },
            {
                name: "showProgressIndicator",
                kind: "b",
                desc: "Whether to show progress indicator",
                isOpt: !0
            }
        ]
    },
    ExportDataFormatContext: {
        name: "ExportDataFormatContext",
        kind: "I",
        desc: "Context provided to `ExportOptions.exportDataFormat` callback",
        props: [
            {
                name: "column",
                kind: "u",
                desc: "The column being exported"
            }
        ]
    },
    ExportDateFormatContext: {
        name: "ExportDateFormatContext",
        kind: "I",
        desc: "Context provided to `ExportOptions.exportDateFormat` callback",
        props: [
            {
                name: "column",
                kind: "u",
                desc: "The column being exported"
            }
        ]
    },
    ExportDestinationType: {
        name: "ExportDestinationType",
        kind: "A",
        desc: "Configures which destination Reports get exported to"
    },
    ExportFormContext: {
        name: "ExportFormContext",
        kind: "I",
        desc: "Context required by functions when using an Export Button",
        props: [
            {
                name: "customDestination",
                kind: "R",
                desc: "Custom Export destination",
                ref: "CustomDestination"
            },
            {
                name: "report",
                kind: "R",
                desc: "The exported report",
                ref: "Report"
            },
            {
                name: "reportData",
                kind: "R",
                desc: "The data in the report",
                ref: "ExportResultData"
            }
        ]
    },
    ExportOptions: {
        name: "ExportOptions",
        kind: "I",
        desc: "Options regarding Exporting data from AdapTable",
        props: [
            {
                name: "appendFileTimestamp",
                kind: "b",
                desc: "Whether to add a timestamp as a suffix to exported file name",
                isOpt: !0,
                gridInfo: "item",
                defVal: "false"
            },
            {
                name: "csvSeparator",
                kind: "u",
                desc: "Separator for CSV exports",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;,&#39;"
            },
            {
                name: "customDestinations",
                kind: "u",
                desc: "User-provided Report Destinations (in addition to those shipped in AdapTable)",
                isOpt: !0
            },
            {
                name: "excelSheetName",
                kind: "u",
                desc: "Provides a custom name for the Excel sheet when exporting to Excel",
                isOpt: !0,
                defVal: "&#39;Sheet1&#39;"
            },
            {
                name: "exportDataFormat",
                kind: "u",
                desc: "Sets &#39;rawValue&#39; or &#39;formattedValue&#39; as Data format in Reports; can be set for whole grid, per Data Type, or per Column (via a function)",
                isOpt: !0,
                defVal: "rawValue"
            },
            {
                name: "exportDateFormat",
                kind: "u",
                desc: "Optional custom format for Date columns when exporting",
                isOpt: !0,
                gridInfo: "item",
                defVal: "undefined"
            },
            {
                name: "getDetailRows",
                kind: "u",
                desc: "Function to provide the Detail Rows when exporting in Master-Detail grids. This function will be invoked for each master row node.",
                isOpt: !0
            },
            {
                name: "isColumnExportable",
                kind: "f",
                desc: "Whether a Column is included in System Reports and available in UI for selection",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "processExport",
                kind: "u",
                desc: "Provides custom handling of the Export process before the default export is executed.",
                isOpt: !0
            },
            {
                name: "reportFilename",
                kind: "f",
                desc: "Provide a bespoke file name for the Report",
                isOpt: !0
            },
            {
                name: "skipColumnHeaders",
                kind: "u",
                desc: "Whether to exclude Column Headers from the exported data",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "systemExportDestinations",
                kind: "u",
                desc: "Export destinations to use; leave unset for all, empty array for none",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;Download&#39;, &#39;Clipboard&#39;"
            },
            {
                name: "systemReportFormats",
                kind: "u",
                desc: "System Report Formats to use; leave unset for all, empty array for none",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;Excel&#39;, &#39;VisualExcel&#39;, &#39;CSV&#39;, &#39;JSON&#39;"
            },
            {
                name: "systemReportNames",
                kind: "u",
                desc: "System Reports to use; leave unset for all, empty array for none",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;All Data&#39;, &#39;Current Layout&#39;, &#39;Selected Data&#39;,"
            }
        ]
    },
    ExportResultData: {
        name: "ExportResultData",
        kind: "A",
        desc: "Type of Export result data: string (CSV), ReportData (JSON), or Blob (Excel)"
    },
    ExportState: {
        name: "ExportState",
        kind: "I",
        desc: "Adaptable State Section for Export Module",
        props: [
            {
                name: "CurrentFormat",
                kind: "R",
                desc: "Selected Report Format - in Export Toolbar &amp; Tool Panel",
                isOpt: !0,
                ref: "ReportFormatType"
            },
            {
                name: "CurrentReport",
                kind: "R",
                desc: "Selected Report Type - in Export Toolbar &amp; Tool Panel",
                isOpt: !0,
                ref: "ReportNameType"
            },
            {
                name: "Reports",
                kind: "a",
                desc: "User-created Reports; each has Name and Row and Column Scope",
                isOpt: !0
            }
        ]
    },
    ExpressionCategory: {
        name: "ExpressionCategory",
        kind: "A",
        desc: "Categories for Expression Functions"
    },
    ExpressionContext: {
        name: "ExpressionContext",
        kind: "I",
        desc: "Provides context to an Expression Function, including current row node and AdaptableApi",
        props: [
            {
                name: "dataChangedEvent",
                kind: "R",
                desc: "Changed cell data",
                isOpt: !0,
                ref: "CellDataChangedInfo"
            },
            {
                name: "evaluateCustomQueryVariable",
                kind: "u",
                desc: "Evaluate custom variables",
                isOpt: !0
            },
            {
                name: "filterFn",
                kind: "u",
                desc: "Optional filter function to be applied before evaluating the expression",
                isOpt: !0
            },
            {
                name: "functions",
                kind: "u",
                desc: "All Expression Functions available to AdaptableQL"
            },
            {
                name: "getRowNodes",
                kind: "u",
                desc: "Get custom list rows",
                isOpt: !0
            },
            {
                name: "namedQueryCallStack",
                kind: "a",
                desc: "All Named Query evaluations: tracked in order to detect circular dependencies",
                isOpt: !0
            },
            {
                name: "node",
                kind: "R",
                desc: "Current AG Grid Row Node being evaluated",
                ref: "unknown"
            },
            {
                name: "pivotResultColumn",
                kind: "R",
                desc: "Pivot Result Column when evaluating a Pivoted Column",
                isOpt: !0,
                ref: "unknown"
            },
            {
                name: "whereClauseFunctions",
                kind: "u",
                desc: "Expression Functions available to AdaptableQL in (optional) WHERE clause",
                isOpt: !0
            }
        ]
    },
    ExpressionFunction: {
        name: "ExpressionFunction",
        kind: "I",
        desc: "Defines an AdaptableQL Function used in an Adaptable Expression",
        props: [
            {
                name: "category",
                kind: "R",
                desc: "Used to group Functions Expression Editor dropdown",
                isOpt: !0,
                ref: "ExpressionCategory"
            },
            {
                name: "description",
                kind: "s",
                desc: "What the AdaptableQL Function does",
                isOpt: !0
            },
            {
                name: "examples",
                kind: "a",
                desc: "Examples that demonstrate the AdaptableQL Function",
                isOpt: !0
            },
            {
                name: "handler",
                kind: "R",
                desc: "Actual AdaptableQL Function called by the Expression (mandatory prop)",
                ref: "ExpressionFunctionHandler"
            },
            {
                name: "hasEagerEvaluation",
                kind: "b",
                desc: "Whether Expression is evaluated without handling inner AST nodes",
                isOpt: !0
            },
            {
                name: "inputs",
                kind: "u",
                desc: "Data Types of Inputs required by Expression",
                isOpt: !0
            },
            {
                name: "isHiddenFromMenu",
                kind: "b",
                desc: "Removes entry from Expression Editor&#39;s Functions dropdown",
                isOpt: !0
            },
            {
                name: "returnType",
                kind: "'boolean' | 'number' | 'string' | 'date' | 'null' | 'any'",
                desc: "Type returned by Function: boolean, number, string, date, any",
                isOpt: !0
            },
            {
                name: "signatures",
                kind: "a",
                desc: "How the AdaptableQL Function should be called",
                isOpt: !0
            }
        ]
    },
    ExpressionFunctionDocBlock: {
        name: "ExpressionFunctionDocBlock",
        kind: "A",
        desc: "Defines how an AdaptableQL Function is described in Expression Editor"
    },
    ExpressionFunctionHandler: {
        name: "ExpressionFunctionHandler",
        kind: "A",
        desc: "The javascript function which is invoked by an AdaptableQL Function"
    },
    ExpressionFunctionInputType: {
        name: "ExpressionFunctionInputType",
        kind: "A",
        desc: "Data Types of Inputs used by Expression (test, number, date, boolean)"
    },
    ExpressionFunctionMap: {
        name: "ExpressionFunctionMap",
        kind: "A",
        desc: "Key-Value map of Expression Names and their implementation"
    },
    ExpressionOptions: {
        name: "ExpressionOptions",
        kind: "I",
        desc: "Options for managing Expressions in AdapTable&#39;s Query Language",
        props: [
            {
                name: "caseSensitiveExpressions",
                kind: "b",
                desc: "Perform case-sensitive text comparisons when evaluating Expressions",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "false"
            },
            {
                name: "customAggregatedFunctions",
                kind: "u",
                desc: "Bespoke Aggregated functions - to complement those provided by AdapTable",
                isOpt: !0
            },
            {
                name: "customBooleanFunctions",
                kind: "u",
                desc: "Custom Boolean Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (none)"
            },
            {
                name: "customQueryVariables",
                kind: "u",
                desc: "Values to be attached to variables so that a single value can easily be expressed multiple times within a query, or quickly changed to affect the results of a query; evaluated synchronously with each expression evaluation",
                isOpt: !0
            },
            {
                name: "customScalarFunctions",
                kind: "u",
                desc: "Custom Scalar Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (none)"
            },
            {
                name: "displayColumnFriendlyNamesForExpressions",
                kind: "b",
                desc: "Reference a Column&#39;s Header (i.e. FriendlyName) in all Expression overviews (instead of ColumnId)",
                isOpt: !0,
                noCode: "item",
                defVal: "true"
            },
            {
                name: "evaluateAdaptableQLExternally",
                kind: "u",
                desc: "Whether a Module (or specific expression) should be evaluated by AdapTableQL",
                isOpt: !0,
                defVal: "All Modules are evaluated by AdapTable"
            },
            {
                name: "fields",
                kind: "u",
                desc: "Fields are items in Data Source that are NOT columns but can be used in Expressions (via FIELD keyword)",
                isOpt: !0
            },
            {
                name: "isColumnQueryable",
                kind: "f",
                desc: "Can a given column be included in Expressions",
                isOpt: !0
            },
            {
                name: "maxTimeframeSize",
                kind: "n",
                desc: "Maximum time (in milliseconds) to hold a Data Change event in a trailing timeframe",
                isOpt: !0,
                gridInfo: "item",
                defVal: "28800000 (~8 hours)"
            },
            {
                name: "moduleExpressionFunctions",
                kind: "u",
                desc: "Module-specific Expression Functions available",
                isOpt: !0,
                gridInfo: "item",
                defVal: "undefined (defaults to available System &amp; Custom values)"
            },
            {
                name: "performExpressionValidation",
                kind: "b",
                desc: "Validate Expressions before they can be run or saved",
                isOpt: !0,
                gridInfo: "item",
                defVal: "true"
            },
            {
                name: "systemAggregatedBooleanFunctions",
                kind: "u",
                desc: "System AggregatedBoolean Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (sets all)"
            },
            {
                name: "systemAggregatedScalarFunctions",
                kind: "u",
                desc: "System AggregatedScalar Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "undefined (sets all)"
            },
            {
                name: "systemBooleanFunctions",
                kind: "u",
                desc: "System Boolean Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (sets all)"
            },
            {
                name: "systemObservableFunctions",
                kind: "u",
                desc: "System Observable Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (sets all)"
            },
            {
                name: "systemScalarFunctions",
                kind: "u",
                desc: "System Scalar Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (sets all)"
            }
        ]
    },
    ExtendedLayout: {
        name: "ExtendedLayout",
        kind: "I",
        desc: "Defines an Extended Layout - provides a Layout and all objects that refer to it",
        props: [
            {
                name: "Extensions",
                kind: "a",
                desc: "Object to be included in the Layout"
            },
            {
                name: "Layout",
                kind: "R",
                desc: "Layout being extended",
                ref: "Layout"
            }
        ]
    },
    ExternalChartingContext: {
        name: "ExternalChartingContext",
        kind: "I",
        desc: "Context passed to External Charting Options functions",
        props: [
            {
                name: "chartDefinition",
                kind: "u",
                desc: "Definition of External Chart"
            },
            {
                name: "container",
                kind: "R",
                desc: "Chart&#39;s Container",
                isOpt: !0,
                ref: "ChartContainer"
            }
        ]
    },
    ExternalChartingOptions: {
        name: "ExternalChartingOptions",
        kind: "I",
        desc: "Options for managing External (i.e. non AG Grid) Charts",
        props: [
            {
                name: "isChartOpened",
                kind: "f",
                desc: "Needs to be implemented to specify if Chart is opened; used to set Show Button&#39;s highlighting",
                isOpt: !0
            },
            {
                name: "onDeleteChart",
                kind: "f",
                desc: "Called when User deletes a persisted Chart",
                isOpt: !0
            },
            {
                name: "onHideChart",
                kind: "f",
                desc: "Called when User clicks on Hide button next to Chart",
                isOpt: !0
            },
            {
                name: "onPreviewChart",
                kind: "u",
                desc: "Shows Chart in Settings Panel preview (not saved into State); returned definition will be passed to &#39;onHideChart&#39; when Preview closes",
                isOpt: !0
            },
            {
                name: "onShowChart",
                kind: "f",
                desc: "Called when User clicks on Show button next to Chart",
                isOpt: !0
            }
        ]
    },
    FDC3ActionColumn: {
        name: "FDC3ActionColumn",
        kind: "I",
        desc: "Action Column used for FDC3 workflows",
        props: [
            {
                name: "button",
                kind: "R",
                desc: "FDC3 Button to display",
                ref: "Fdc3AdaptableButton"
            },
            {
                name: "columnId",
                kind: "s",
                desc: "Id of the Column"
            },
            {
                name: "defaultWidth",
                kind: "n",
                desc: "Default Width of column",
                isOpt: !0
            },
            {
                name: "friendlyName",
                kind: "s",
                desc: "Column&#39;s friendly name",
                isOpt: !0
            }
        ]
    },
    Fdc3AdaptableButton: {
        name: "Fdc3AdaptableButton",
        kind: "I",
        desc: "Button used in FDC3 Action Columns",
        props: [
            {
                name: "buttonStyle",
                kind: "u",
                desc: "Button&#39;s Style; can be object or function that provides `ButtonStyle` object",
                isOpt: !0
            },
            {
                name: "disabled",
                kind: "u",
                desc: "Function to disable / enable button based on evaluation result",
                isOpt: !0
            },
            {
                name: "hidden",
                kind: "u",
                desc: "Function to hide the Button",
                isOpt: !0
            },
            {
                name: "icon",
                kind: "u",
                desc: "Button&#39;s Icon; can be object or function that provides `AdaptableIcon` object",
                isOpt: !0
            },
            {
                name: "id",
                kind: "s",
                desc: "Unique id for the button"
            },
            {
                name: "label",
                kind: "u",
                desc: "Button&#39;s Label; can be string or function that provides string",
                isOpt: !0
            },
            {
                name: "tooltip",
                kind: "u",
                desc: "Button&#39;s Tooltip; can be string or function that provides string",
                isOpt: !0
            }
        ]
    },
    Fdc3ButtonContext: {
        name: "Fdc3ButtonContext",
        kind: "I",
        desc: "Context provided in dynamic FDC3 Buttons",
        props: [
            {
                name: "context",
                kind: "R",
                desc: "The FDC3 Context",
                ref: "unknown"
            },
            {
                name: "intent",
                kind: "R",
                desc: "The FDC3 Intent",
                isOpt: !0,
                ref: "unknown"
            },
            {
                name: "primaryKeyValue",
                kind: "u",
                desc: "Primary key value of row"
            },
            {
                name: "rowData",
                kind: "u",
                desc: "The row data which is the source of the context data"
            },
            {
                name: "rowNode",
                kind: "R",
                desc: "The row node which is the source of the context data",
                ref: "unknown"
            }
        ]
    },
    Fdc3ContextOptions: {
        name: "Fdc3ContextOptions",
        kind: "I",
        desc: "Options for configuring FDC3 Context Behaviour in AdapTable",
        props: [
            {
                name: "broadcasts",
                kind: "R",
                desc: "Broadcasts given standard Context(s) on various Grid Actions",
                isOpt: !0,
                ref: "BroadcastConfiguration"
            },
            {
                name: "handleContext",
                kind: "f",
                desc: "Handles incoming Contexts (standard and custom)",
                isOpt: !0
            },
            {
                name: "listensFor",
                kind: "a",
                desc: "Subscribe to given standard Context(s)",
                isOpt: !0
            }
        ]
    },
    Fdc3IntentOptions: {
        name: "Fdc3IntentOptions",
        kind: "I",
        desc: "Options for configuring FDC3 Intent Behaviour in AdapTable",
        props: [
            {
                name: "handleIntent",
                kind: "u",
                desc: "Handles incoming Intents (standard and custom)",
                isOpt: !0
            },
            {
                name: "handleIntentResolution",
                kind: "u",
                desc: "Handles the IntentResolution that a raised Intent might return",
                isOpt: !0
            },
            {
                name: "listensFor",
                kind: "a",
                desc: "Subscribe to given standard Intent(s)",
                isOpt: !0
            },
            {
                name: "raises",
                kind: "R",
                desc: "Raises given standard Intent(s) on various Grid Actions",
                isOpt: !0,
                ref: "RaiseIntentConfiguration"
            }
        ]
    },
    Fdc3Options: {
        name: "Fdc3Options",
        kind: "I",
        desc: "Options for configuring FDC3 in AdapTable",
        props: [
            {
                name: "actionColumnDefaultConfiguration",
                kind: "R",
                desc: "Configures the default FDC3 Actions column",
                isOpt: !0,
                ref: "ActionColumnDefaultConfiguration"
            },
            {
                name: "contexts",
                kind: "R",
                desc: "Configures FDC3 standard Contexts that AdapTable will listen for and broadcast",
                isOpt: !0,
                ref: "Fdc3ContextOptions"
            },
            {
                name: "enableLogging",
                kind: "b",
                desc: "Enable logging message exchanges to Console",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "gridDataContextMapping",
                kind: "R",
                desc: "Maps Context Type to AdapTable Grid Data",
                isOpt: !0,
                ref: "GridDataContextMapping"
            },
            {
                name: "intents",
                kind: "R",
                desc: "Configures FDC3 standard Intents that AdapTable will listen for and raise",
                isOpt: !0,
                ref: "Fdc3IntentOptions"
            },
            {
                name: "resolveContextData",
                kind: "u",
                desc: "Builds Context Data (useful for postprocessing Context Data mapped from Grid data)",
                isOpt: !0
            },
            {
                name: "uiControlsDefaultConfiguration",
                kind: "u",
                desc: "Customises FDC3 UI Controls",
                isOpt: !0
            }
        ]
    },
    FilterActionOnDataChange: {
        name: "FilterActionOnDataChange",
        kind: "I",
        desc: "Whether Adaptable re-applies filtering after data edits; if `applyFilter` value is &#39;Throttle&#39;, `throttleDelay` should be set",
        props: [
            {
                name: "applyFilter",
                kind: "R",
                desc: "When to re-apply Filters: &#39;Always&#39;, &#39;Never&#39; or &#39;Throttle&#39;",
                ref: "ApplyFilterAction"
            },
            {
                name: "throttleDelay",
                kind: "n",
                desc: "Delay in ms (when `applyFilter` is set to &#39;Throttle&#39;)",
                isOpt: !0
            }
        ]
    },
    FilterOptions: {
        name: "FilterOptions",
        kind: "I",
        desc: "Options for managing Column &amp; Grid Filters in AdapTable",
        props: [
            {
                name: "clearFiltersOnStartUp",
                kind: "b",
                desc: "Clear Grid and Column Filters when AdapTable loads",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "true"
            },
            {
                name: "columnFilterOptions",
                kind: "R",
                desc: "Options for managing Column Filters",
                isOpt: !0,
                ref: "ColumnFilterOptions"
            },
            {
                name: "customInFilterValues",
                kind: "u",
                desc: "Provide custom values (or sorting / count info) when using `In` Predicate in Column or Grid Filter",
                isOpt: !0
            },
            {
                name: "enableFilterOnSpecialColumns",
                kind: "b",
                desc: "Allow filtering on Calculated &amp; FreeText columns",
                isOpt: !0,
                gridInfo: "item",
                defVal: "true"
            },
            {
                name: "filterActionOnDataChange",
                kind: "R",
                desc: "When to re-filter grid after data changes: &#39;Always&#39;, &#39;Never&#39; or &#39;Throttle&#39; (with a delay value)",
                isOpt: !0,
                defVal: "&#39;Always&#39;",
                ref: "FilterActionOnDataChange"
            },
            {
                name: "gridFilterOptions",
                kind: "R",
                desc: "Options for managing the Grid Filter",
                isOpt: !0,
                ref: "GridFilterOptions"
            },
            {
                name: "isRowFilterable",
                kind: "f",
                desc: "Configures whether Rows will be evaluated when filtering",
                isOpt: !0
            },
            {
                name: "showDatePicker",
                kind: "b",
                desc: "Show Date Picker (or Date Input) in Filter controls",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "true"
            },
            {
                name: "useAdaptableFiltering",
                kind: "b",
                desc: "Use Adaptable&#39;s Column &amp; Grid Filters in preference to AG Grid&#39;s filtering",
                isOpt: !0,
                noCode: "item",
                defVal: "true"
            }
        ]
    },
    FlashingCellDefinition: {
        name: "FlashingCellDefinition",
        kind: "I",
        desc: "The Flashing Cell Definition",
        props: [
            {
                name: "DownChangeStyle",
                kind: "R",
                desc: "Style for &#39;Down&#39; value changes",
                isOpt: !0,
                defVal: "Red BackColour",
                ref: "AdaptableStyle"
            },
            {
                name: "FlashDuration",
                kind: "number | 'always'",
                desc: "Duration of Flash - can be number (in ms) or &#39;always&#39;",
                isOpt: !0,
                defVal: "500ms"
            },
            {
                name: "FlashTarget",
                kind: "u",
                desc: "Should a cell or whole row flash",
                isOpt: !0,
                defVal: "&#39;cell&#39;"
            },
            {
                name: "Name",
                kind: "s",
                desc: "Name of the Flashing Cell Definition"
            },
            {
                name: "NeutralChangeStyle",
                kind: "R",
                desc: "Style for &#39;Neutral&#39; value changes",
                isOpt: !0,
                defVal: "Gray BackColour",
                ref: "AdaptableStyle"
            },
            {
                name: "Rule",
                kind: "R",
                desc: "When Flashing Cell should be triggered",
                ref: "unknown"
            },
            {
                name: "Scope",
                kind: "R",
                desc: "Which Columns, DataTypes or Column Types can Flash",
                ref: "ColumnScope"
            },
            {
                name: "UpChangeStyle",
                kind: "R",
                desc: "Style for &#39;Up&#39; value changes",
                isOpt: !0,
                defVal: "Green BackColour",
                ref: "AdaptableStyle"
            }
        ]
    },
    FlashingCellOptions: {
        name: "FlashingCellOptions",
        kind: "I",
        desc: "Properties for Flashing Cell",
        props: [
            {
                name: "defaultDownChangeStyle",
                kind: "R",
                desc: "Style for &#39;Down&#39; value changes",
                isOpt: !0,
                defVal: "Red BackColour",
                ref: "AdaptableStyle"
            },
            {
                name: "defaultFlashDuration",
                kind: "number | 'always'",
                desc: "Duration of Flash - can be number (in ms) or &#39;always&#39;",
                isOpt: !0,
                defVal: "500ms"
            },
            {
                name: "defaultFlashTarget",
                kind: "R",
                desc: "Should a cell or whole row flash",
                isOpt: !0,
                defVal: "&#39;cell&#39;",
                ref: "FlashTarget"
            },
            {
                name: "defaultNeutralChangeStyle",
                kind: "R",
                desc: "Style for &#39;Neutral&#39; value changes",
                isOpt: !0,
                defVal: "Gray BackColour",
                ref: "AdaptableStyle"
            },
            {
                name: "defaultUpChangeStyle",
                kind: "R",
                desc: "Style for &#39;Up&#39; value changes",
                isOpt: !0,
                defVal: "Green BackColour",
                ref: "AdaptableStyle"
            }
        ]
    },
    FlashingCellState: {
        name: "FlashingCellState",
        kind: "I",
        desc: "Adaptable State Section for Flashing Cell module",
        props: [
            {
                name: "FlashingCellDefinitions",
                kind: "a",
                desc: "Flashing Cell Definitions - will flash cells/rows when rule is met",
                isOpt: !0
            }
        ]
    },
    FlashTarget: {
        name: "FlashTarget",
        kind: "A",
        desc: "Where a Flash can happen"
    },
    FormatColumn: {
        name: "FormatColumn",
        kind: "I",
        desc: "Object used in Format Column function",
        props: [
            {
                name: "ColumnGroupScope",
                kind: "R",
                desc: "When to format Columns in Column Groups (&#39;Expanded&#39;, &#39;Collapsed&#39;, &#39;Both&#39;)",
                isOpt: !0,
                ref: "ColumnGroupScope"
            },
            {
                name: "DisplayFormat",
                kind: "R",
                desc: "Display Format to apply to Column can be Numeric, String or Date",
                isOpt: !0,
                ref: "AdaptableFormat"
            },
            {
                name: "Name",
                kind: "s",
                desc: "Name of the Format Column definition"
            },
            {
                name: "RowScope",
                kind: "R",
                desc: "Which types of Rows to apply format (data, grouped, summary, total)",
                isOpt: !0,
                ref: "RowScope"
            },
            {
                name: "Rule",
                kind: "R",
                desc: "Rule to decide whether to apply Format; if undefined Format is always applied",
                isOpt: !0,
                ref: "FormatColumnRule"
            },
            {
                name: "Scope",
                kind: "R",
                desc: "Where Format will be applied: whole Row, some Columns, or Columns of DataType",
                ref: "ColumnScope"
            },
            {
                name: "Style",
                kind: "R",
                desc: "AdapTable Style to apply",
                isOpt: !0,
                ref: "AdaptableStyle"
            },
            {
                name: "Target",
                kind: "R",
                desc: "Where in Column to apply Format (`cell` or `columnHeader`)",
                isOpt: !0,
                defVal: "&#39;cell&#39;",
                ref: "FormatColumnTarget"
            }
        ]
    },
    FormatColumnConfig: {
        name: "FormatColumnConfig",
        kind: "I",
        desc: "Config for api methods that get Format Columns"
    },
    FormatColumnOptions: {
        name: "FormatColumnOptions",
        kind: "I",
        desc: "Provides Custom Formats used in Format Column Module",
        props: [
            {
                name: "customDisplayFormatters",
                kind: "a",
                desc: "Custom Formatters to use in Format Column Module",
                isOpt: !0
            }
        ]
    },
    FormatColumnPredicate: {
        name: "FormatColumnPredicate",
        kind: "I",
        desc: "Predicate used when creating a Format Column"
    },
    FormatColumnRule: {
        name: "FormatColumnRule",
        kind: "A",
        desc: "The Format Column Rule - can be either a Predicate or a BooleanExpression"
    },
    FormatColumnState: {
        name: "FormatColumnState",
        kind: "I",
        desc: "Adaptable State Section for Format Column Module",
        props: [
            {
                name: "FormatColumns",
                kind: "a",
                desc: "Collection of Format Columns",
                isOpt: !0
            }
        ]
    },
    FormatColumnTarget: {
        name: "FormatColumnTarget",
        kind: "A",
        desc: "Specifies whether Column&#39;s cells or header is formatted"
    },
    FormContext: {
        name: "FormContext",
        kind: "I",
        desc: "Context supplied to Buttons that appear in an Adaptable Form",
        props: [
            {
                name: "formData",
                kind: "R",
                desc: "Adaptable Form Data",
                ref: "AdaptableFormData"
            }
        ]
    },
    FreeTextColumn: {
        name: "FreeTextColumn",
        kind: "I",
        desc: "The FreeTextColumn object used in the Free Text Column function",
        props: [
            {
                name: "ColumnId",
                kind: "s",
                desc: "Id of Column"
            },
            {
                name: "DefaultValue",
                kind: "u",
                desc: "Initial value to use for each cell in the Column",
                isOpt: !0
            },
            {
                name: "FreeTextColumnSettings",
                kind: "R",
                desc: "Additional optional properties for Column (e.g. filterable, resizable)",
                ref: "FreeTextColumnSettings"
            },
            {
                name: "FreeTextStoredValues",
                kind: "a",
                desc: "Collection of Stored Values to aplly in the Column",
                isOpt: !0
            },
            {
                name: "FriendlyName",
                kind: "s",
                desc: "Friendly Name to use to refer to Column; if unset `ColumnId` is used",
                isOpt: !0
            },
            {
                name: "TextEditor",
                kind: "'Inline' | 'Large'",
                desc: "Cell editor to use when editing a string Free Text Column",
                isOpt: !0,
                defVal: "&#39;Inline&#39;"
            }
        ]
    },
    FreeTextColumnSettings: {
        name: "FreeTextColumnSettings",
        kind: "I",
        desc: "Set of optional properties that define a FreeText Columns behaviour"
    },
    FreeTextColumnState: {
        name: "FreeTextColumnState",
        kind: "I",
        desc: "Adaptable State Section for the Free Text Column Module",
        props: [
            {
                name: "FreeTextColumns",
                kind: "a",
                desc: "Collection of Free Text Columns",
                isOpt: !0
            }
        ]
    },
    FreeTextStoredValue: {
        name: "FreeTextStoredValue",
        kind: "I",
        desc: "Defines a cell value stored in a Free Text Column",
        props: [
            {
                name: "FreeText",
                kind: "u",
                desc: "Value to store in the cell"
            },
            {
                name: "PrimaryKey",
                kind: "u",
                desc: "Primary Key Column value for the row"
            }
        ]
    },
    GetDetailRowsContext: {
        name: "GetDetailRowsContext",
        kind: "I",
        desc: "Context provided to `ExportOptions.getDetailRows()` callback used when exporting Detail Rows",
        props: [
            {
                name: "adaptableColumn",
                kind: "u",
                desc: "Column of Master Row Node"
            },
            {
                name: "createCellCsv",
                kind: "u",
                desc: "Factory function to create a CSV Cell"
            },
            {
                name: "createCellExcel",
                kind: "u",
                desc: "Factory function to create an Excel Cell"
            },
            {
                name: "createCellHeader",
                kind: "u",
                desc: "Factory function to create an Header Cell (either CSV or Excel)"
            },
            {
                name: "isExpanded",
                kind: "b",
                desc: "Whether the Master Row Node is expanded"
            },
            {
                name: "masterRowData",
                kind: "u",
                desc: "Data of Master Row Node"
            },
            {
                name: "masterRowNode",
                kind: "u",
                desc: "Master Row Node"
            }
        ]
    },
    GetPrimaryKeyValueContext: {
        name: "GetPrimaryKeyValueContext",
        kind: "I",
        desc: "Context passed to the `getPrimaryKeyValue` function",
        props: [
            {
                name: "rowData",
                kind: "u",
                desc: "Data being imported"
            }
        ]
    },
    GlobalExpressionFunctionsContext: {
        name: "GlobalExpressionFunctionsContext",
        kind: "I",
        desc: "Context provided to global expression functions properties property callback",
        props: [
            {
                name: "availableExpressionFunctionNames",
                kind: "u",
                desc: "The names of all expression functions available in this context"
            }
        ]
    },
    GradientStyle: {
        name: "GradientStyle",
        kind: "I",
        desc: "Used to display Gradient Styles in Special Column Style"
    },
    GridCell: {
        name: "GridCell",
        kind: "I",
        desc: "Defines a Cell in Adaptable - every cell is an intersection of a Column Id and a Primary Key Value",
        props: [
            {
                name: "column",
                kind: "u",
                desc: "Column in which Cell is situated"
            },
            {
                name: "displayValue",
                kind: "u",
                desc: "Display value of Cell (e.g. if formatted)"
            },
            {
                name: "isPivotCell",
                kind: "b",
                desc: "Is Cell in a Pivot Column"
            },
            {
                name: "isRowGroupCell",
                kind: "b",
                desc: "Is Cell in a Row Group Column"
            },
            {
                name: "normalisedValue",
                kind: "u",
                desc: "Normalised value of Cell"
            },
            {
                name: "primaryKeyValue",
                kind: "u",
                desc: "Primary Key column&#39;s value in row - how Adaptable locates the Cell",
                isOpt: !0
            },
            {
                name: "rawValue",
                kind: "u",
                desc: "Raw value of Cell"
            },
            {
                name: "rowNode",
                kind: "u",
                desc: "AG Grid Row Node that holds the Cell"
            },
            {
                name: "visible",
                kind: "b",
                desc: "Is Cell in a currently filtered Row",
                isOpt: !0
            }
        ]
    },
    GridCellRange: {
        name: "GridCellRange",
        kind: "I",
        desc: "Defines a range of Cell - used in Grid Api Selection methods Typically use either PrimaryKey Values or Row Indexes",
        props: [
            {
                name: "columnIds",
                kind: "a",
                desc: "Columns to select"
            },
            {
                name: "primaryKeyValueEnd",
                kind: "u",
                desc: "Primary Key value of row at end of range",
                isOpt: !0
            },
            {
                name: "primaryKeyValueStart",
                kind: "u",
                desc: "Primary Key value of row at start of range",
                isOpt: !0
            },
            {
                name: "rowIndexEnd",
                kind: "u",
                desc: "Index of row at end of range",
                isOpt: !0
            },
            {
                name: "rowIndexStart",
                kind: "u",
                desc: "Index of row at start of range",
                isOpt: !0
            }
        ]
    },
    GridCellWithCount: {
        name: "GridCellWithCount",
        kind: "I",
        desc: "Extended GridCell, props to show how often appears in data source and how often visible",
        props: [
            {
                name: "count",
                kind: "n",
                desc: "How many times Cell appears in Data Source"
            },
            {
                name: "visibleCount",
                kind: "n",
                desc: "How many times Cell appears in Visible Rows",
                isOpt: !0
            }
        ]
    },
    GridDataContextMapping: {
        name: "GridDataContextMapping",
        kind: "I",
        desc: "Mapping of FDC3 Context Types to Grid Data/Columns"
    },
    GridFilter: {
        name: "GridFilter",
        kind: "I",
        desc: "Defines a Grid Filter (essentially a Boolean Expression)",
        props: [
            {
                name: "Expression",
                kind: "s",
                desc: "The (boolean) Expression to run",
                isOpt: !0
            }
        ]
    },
    GridFilterEditors: {
        name: "GridFilterEditors",
        kind: "A",
        desc: "List of Editors that can be used when creating the Grid Filter"
    },
    GridFilterOptions: {
        name: "GridFilterOptions",
        kind: "I",
        desc: "Options for managing the Grid Filter in AdapTable",
        props: [
            {
                name: "availableFilterEditors",
                kind: "R",
                desc: "Which UI Components can be used to edit a Grid Filter: Expression Editor, Query Builder (or both)",
                isOpt: !0,
                defVal: "[&#39;ExpressionEditor&#39;, &#39;QueryBuilder&#39;]",
                ref: "GridFilterEditors"
            }
        ]
    },
    GridRow: {
        name: "GridRow",
        kind: "I",
        desc: "Detailed information about a Row in AdapTable",
        props: [
            {
                name: "primaryKeyValue",
                kind: "u",
                desc: "Primary Key column&#39;s value for Row - how Adaptable locates a cell"
            },
            {
                name: "rowData",
                kind: "u",
                desc: "Actual data in the Row",
                isOpt: !0
            },
            {
                name: "rowInfo",
                kind: "R",
                desc: "Object which provides &#39;meta data&#39; about the Row",
                isOpt: !0,
                ref: "RowInfo"
            },
            {
                name: "rowNode",
                kind: "u",
                desc: "AG Grid Row Node object for the Row",
                isOpt: !0
            }
        ]
    },
    GroupKeys: {
        name: "GroupKeys",
        kind: "I",
        desc: "Enables setting Row Group behaviour with exceptions",
        props: [
            {
                name: "ExceptionGroupKeys",
                kind: "u",
                desc: "Exceptions to default behaviour, provided as array or arrays",
                isOpt: !0
            },
            {
                name: "RowGroupedColumns",
                kind: "a",
                desc: "Columns that are Row Grouped"
            }
        ]
    },
    HandleFdc3Context: {
        name: "HandleFdc3Context",
        kind: "I",
        desc: "Context used when handling incoming FDC3 messages",
        props: [
            {
                name: "context",
                kind: "R",
                desc: "The FDC3 Context",
                ref: "unknown"
            },
            {
                name: "metadata",
                kind: "R",
                desc: "The FDC3 Context Metadata related to the context",
                isOpt: !0,
                ref: "unknown"
            }
        ]
    },
    HandleFdc3IntentContext: {
        name: "HandleFdc3IntentContext",
        kind: "I",
        desc: "Context used when handling incoming FDC3 Intents",
        props: [
            {
                name: "intent",
                kind: "R",
                desc: "The FDC3 Intent",
                ref: "unknown"
            }
        ]
    },
    HandleFdc3IntentResolutionContext: {
        name: "HandleFdc3IntentResolutionContext",
        kind: "I",
        desc: "Context provided in `handleIntentResolution` callback",
        props: [
            {
                name: "intentResolution",
                kind: "R",
                desc: "The FDC3 Intent Resolution",
                ref: "unknown"
            }
        ]
    },
    HandleImportedDataContext: {
        name: "HandleImportedDataContext",
        kind: "I",
        desc: "Context used when importing Data",
        props: [
            {
                name: "data",
                kind: "u",
                desc: "Data which has been imported"
            }
        ]
    },
    HandleImportedDataResolution: {
        name: "HandleImportedDataResolution",
        kind: "I",
        desc: "Resolution returned by the `handleImportedData` function",
        props: [
            {
                name: "addedRows",
                kind: "a",
                desc: "Rows that were added"
            },
            {
                name: "emitDataImportedEvent",
                kind: "b",
                desc: "Whether to emit the `DataImported` event"
            },
            {
                name: "updatedRows",
                kind: "a",
                desc: "Rows that were updated"
            }
        ]
    },
    IAdaptableNoCodeWizard: {
        name: "IAdaptableNoCodeWizard",
        kind: "I",
        desc: "When you want to configure an Adaptable via json file D&amp;D, use this instead of the normal Adaptable constructor"
    },
    Identifiable: {
        name: "Identifiable",
        kind: "I",
        desc: "Interface for objects that can be uniquely identified by a UUID",
        props: [
            {
                name: "Uuid",
                kind: "R",
                desc: "Unique identifier for the Object, generated and used internally by AdapTable",
                isOpt: !0,
                ref: "unknown"
            }
        ]
    },
    InFilterValue: {
        name: "InFilterValue",
        kind: "I",
        desc: "Item in the IN Column Filter",
        props: [
            {
                name: "label",
                kind: "s",
                desc: "Item&#39;s label"
            },
            {
                name: "tooltip",
                kind: "boolean | string",
                desc: "Tooltip for Item (if true, the label is used as tooltip)",
                isOpt: !0
            },
            {
                name: "value",
                kind: "u",
                desc: "The value of Item being shown"
            }
        ]
    },
    InFilterValueInfo: {
        name: "InFilterValueInfo",
        kind: "I",
        desc: "Information about items in the IN Column Filter",
        props: [
            {
                name: "count",
                kind: "n",
                desc: "How many times Item appears in the column",
                isOpt: !0
            },
            {
                name: "isSelected",
                kind: "b",
                desc: "Whether Item is currently selected",
                isOpt: !0
            },
            {
                name: "leafChildrenCount",
                kind: "n",
                desc: "For the grouping scenario, how many leafs are there under this item",
                isOpt: !0
            },
            {
                name: "visible",
                kind: "b",
                desc: "Whether Item is currently visible in Grid (i.e. in filtered rows)",
                isOpt: !0
            },
            {
                name: "visibleCount",
                kind: "n",
                desc: "How many times Item appears in the column in filtered rows",
                isOpt: !0
            }
        ]
    },
    InFilterValueResult: {
        name: "InFilterValueResult",
        kind: "I",
        desc: "Result when providing custom values for the IN Column Filter",
        props: [
            {
                name: "skipDefaultSearch",
                kind: "b",
                desc: "If true, AdapTable will not filter the list using the current search value",
                isOpt: !0
            },
            {
                name: "values",
                kind: "a",
                desc: "List of Items to display in the IN Column Filter"
            }
        ]
    },
    InitContainerContext: {
        name: "InitContainerContext",
        kind: "I",
        desc: "Context available to `adaptableContainer` and `agGridContainer` function callbacks (resolve **before** AdapTable initialises, so `adaptableApi` not available)",
        props: [
            {
                name: "adaptableContext",
                kind: "u",
                desc: "Custom application Context provided in `AdaptableOptions.adaptableContext`"
            },
            {
                name: "adaptableId",
                kind: "s",
                desc: "Id of current AdapTable instance"
            },
            {
                name: "adaptableStateKey",
                kind: "s",
                desc: "Current Adaptable State Key"
            }
        ]
    },
    InitialState: {
        name: "InitialState",
        kind: "I",
        desc: "The initial state of Adaptable which is populated at design-time and used to create the Adaptable State - must include at least one Layout.",
        props: [
            {
                name: "Alert",
                kind: "R",
                desc: "Collection of `AlertDefinitions` which will fire Alerts when the rule is met",
                isOpt: !0,
                ref: "AlertState"
            },
            {
                name: "Application",
                kind: "R",
                desc: "Empty state section (only populated at Design Time) available for User to store their own data with the rest of AdapTable state.",
                isOpt: !0,
                ref: "ApplicationState"
            },
            {
                name: "CalculatedColumn",
                kind: "R",
                desc: "Collection of *CalculatedColumn* objects that will display a value based on other cells in the row (using a Calculated Column Expression)",
                isOpt: !0,
                ref: "CalculatedColumnState"
            },
            {
                name: "Charting",
                kind: "R",
                desc: "Named Charts (wrapping Chart models)",
                isOpt: !0,
                ref: "ChartingState"
            },
            {
                name: "CustomSort",
                kind: "R",
                desc: "Collection of *Custom Sort* objects to allow some columns to be sorted in non-standard (e.g. non alphabetical) ways",
                isOpt: !0,
                ref: "CustomSortState"
            },
            {
                name: "Dashboard",
                kind: "R",
                desc: "Large series of properties to give users full control over the look and feel of the *Dashboard* - the section above the grid with toolbars and buttons",
                isOpt: !0,
                ref: "DashboardState"
            },
            {
                name: "Export",
                kind: "R",
                desc: "Collection of *Report* objects, together with name of the Current Report, as part of AdapTable export Module",
                isOpt: !0,
                ref: "ExportState"
            },
            {
                name: "FlashingCell",
                kind: "R",
                desc: "Definitions of which cells flash in response to data changes",
                isOpt: !0,
                ref: "FlashingCellState"
            },
            {
                name: "FormatColumn",
                kind: "R",
                desc: "Collection of *FormatColumn* objects that will style an entire column either fully or using a Condition",
                isOpt: !0,
                ref: "FormatColumnState"
            },
            {
                name: "FreeTextColumn",
                kind: "R",
                desc: "Collection of *FreeText* objects so users can make their own notes in bespoke columns that will get stored with their state (and not with the DataSource). Useful if needing a &#39;Comments&#39; column.",
                isOpt: !0,
                ref: "FreeTextColumnState"
            },
            {
                name: "Layout",
                kind: "R",
                desc: "Collection of *Layouts* to name (and manage) sets of column visibility, order, grouping, sorts, aggregations, filters etc.",
                ref: "LayoutState"
            },
            {
                name: "NamedQuery",
                kind: "R",
                desc: "Named Queries available for use across multiple AdapTable Modules; and `CurrentQuery` - an Expression to run at start-up",
                isOpt: !0,
                ref: "NamedQueryState"
            },
            {
                name: "Note",
                kind: "R",
                desc: "Collection of personal Notes that are edited at Cell level",
                isOpt: !0,
                ref: "NoteState"
            },
            {
                name: "PlusMinus",
                kind: "R",
                desc: "Collection of *PlusMinus* rule objects to stipulate what happens when the user clicks &#39;+&#39; or &#39;-&#39; in a numeric cell",
                isOpt: !0,
                ref: "PlusMinusState"
            },
            {
                name: "QuickSearch",
                kind: "R",
                desc: "Configues how Quick Search will run i.e. how and whether to highlight matching cells and to filter out non-matching rows",
                isOpt: !0,
                ref: "QuickSearchState"
            },
            {
                name: "Schedule",
                kind: "R",
                desc: "Collection of *Schedule* objects",
                isOpt: !0,
                ref: "ScheduleState"
            },
            {
                name: "Shortcut",
                kind: "R",
                desc: "Collection of *Shortcut* objects to aid data entry and prevent &#39;fat finger&#39; issues",
                isOpt: !0,
                ref: "ShortcutState"
            },
            {
                name: "StatusBar",
                kind: "R",
                desc: "Configures the Adaptable Status Bar",
                isOpt: !0,
                ref: "StatusBarState"
            },
            {
                name: "StyledColumn",
                kind: "R",
                desc: "Collection of Special Column Styles",
                isOpt: !0,
                ref: "StyledColumnState"
            },
            {
                name: "Theme",
                kind: "R",
                desc: "Specifies current Theme and lists User and System themes available for selection",
                isOpt: !0,
                ref: "ThemeState"
            },
            {
                name: "ToolPanel",
                kind: "R",
                desc: "Sets order &amp; visibility of Tool Panel controls in AdapTable ToolPanel (on right of grid)",
                isOpt: !0,
                ref: "ToolPanelState"
            },
            {
                name: "UserInterface",
                kind: "R",
                desc: "Controls the visibility of AdapTable UI elements (Dashboard, Tool Panel, Status Bar, Menus etc.)",
                isOpt: !0,
                ref: "UserInterfaceState"
            }
        ]
    },
    InteropioPluginOptions: {
        name: "InteropioPluginOptions",
        kind: "I",
        desc: "Options for using the Interop plugin",
        props: [
            {
                name: "showAdaptableAlertsAsNotifications",
                kind: "b",
                desc: "Converts AdapTable Alerts configured to display in popup as Interop Notifications",
                isOpt: !0,
                defVal: "true"
            }
        ]
    },
    IPushPullDomain: {
        name: "IPushPullDomain",
        kind: "I",
        desc: "Internal object that maps an IPushPull Domain object",
        props: [
            {
                name: "FolderId",
                kind: "n",
                desc: "the Id of the Folder"
            },
            {
                name: "Name",
                kind: "s",
                desc: "the Name of the Domain / Folder"
            },
            {
                name: "Pages",
                kind: "a",
                desc: "The names of the pages within the (Folder)"
            }
        ]
    },
    IPushPullPluginOptions: {
        name: "IPushPullPluginOptions",
        kind: "I",
        desc: "Options available in ipushpull plugin; allows users to collborate and share data in powerful ways",
        props: [
            {
                name: "autoLogin",
                kind: "b",
                desc: "Whether AdapTable should try log in to ipushpull automatically at start-up",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "includeSystemReports",
                kind: "b",
                desc: "Whether AdapTable will include System Reports (e.g. &#39;All Data&#39;, &#39;Selected Cells&#39; etc) in the ipushpull toolbar dropdown",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "ippConfig",
                kind: "u",
                desc: "The config required to run ipushpull; use your ipushpull credentials",
                isOpt: !0
            },
            {
                name: "password",
                kind: "s",
                desc: "The user&#39;s ipushpull password; if supplied, pre-populates the login screen&#39;s password textbox",
                isOpt: !0
            },
            {
                name: "throttleTime",
                kind: "n",
                desc: "How many miliseconds AdapTable should throttle when sending data updates to ipushpull",
                isOpt: !0,
                defVal: "2000"
            },
            {
                name: "username",
                kind: "s",
                desc: "User&#39;s ipushpull user name (usually email address); if supplied, pre-populates the login screen&#39;s username textbox",
                isOpt: !0
            }
        ]
    },
    IPushPullReport: {
        name: "IPushPullReport",
        kind: "I",
        desc: "An ipushpull report",
        props: [
            {
                name: "Folder",
                kind: "s",
                desc: "ipushpull Folder which contains the Page"
            },
            {
                name: "Page",
                kind: "s",
                desc: "ipushpull Page which will contain the data"
            },
            {
                name: "ReportName",
                kind: "s",
                desc: "Name of the Report"
            }
        ]
    },
    IPushPullSchedule: {
        name: "IPushPullSchedule",
        kind: "I",
        desc: "Defines an ipushpull Schedule",
        props: [
            {
                name: "IPushPullReport",
                kind: "R",
                desc: "The report being exported to Excel (via ipushpull)",
                ref: "IPushPullReport"
            },
            {
                name: "Transmission",
                kind: "'Snapshot' | 'Live Data'",
                desc: "How data is sent: &#39;Snapshot&#39; or &#39;Live Data&#39;"
            }
        ]
    },
    IPushPullState: {
        name: "IPushPullState",
        kind: "I",
        desc: "Internal State used by AdapTable for managing the ipushpull plugin"
    },
    IsRowFilterableContext: {
        name: "IsRowFilterableContext",
        kind: "I",
        desc: "Context used for setting whether a Row can be Column Filtered",
        props: [
            {
                name: "data",
                kind: "u",
                desc: "The data in the Row Node"
            },
            {
                name: "rowNode",
                kind: "R",
                desc: "The Row Node about to be evaluated",
                ref: "unknown"
            }
        ]
    },
    Layout: {
        name: "Layout",
        kind: "A",
        desc: "Base Layout Type - Pivot or Table"
    },
    LayoutArray: {
        name: "LayoutArray",
        kind: "A",
        desc: "Array of Layouts - must contain at least one item"
    },
    LayoutBase: {
        name: "LayoutBase",
        kind: "I",
        desc: "Base object for both Table and Pivot Layouts",
        props: [
            {
                name: "AutoSizeColumns",
                kind: "b",
                desc: "Whether Columns should autosize when Layout first loads",
                isOpt: !0
            },
            {
                name: "ColumnFilters",
                kind: "a",
                desc: "Collection of Column Filters to apply in Layout",
                isOpt: !0
            },
            {
                name: "ColumnGroupValues",
                kind: "R",
                desc: "Defines which Column Groups are expanded / collapsed",
                isOpt: !0,
                ref: "ColumnGroupValues"
            },
            {
                name: "ColumnHeaders",
                kind: "R",
                desc: "Set of custom header names for some (or all) Columns",
                isOpt: !0,
                ref: "ColumnStringMap"
            },
            {
                name: "ColumnPinning",
                kind: "R",
                desc: "Details of which Columns are pinned",
                isOpt: !0,
                ref: "ColumnDirectionMap"
            },
            {
                name: "ColumnSizing",
                kind: "R",
                desc: "Controls size (width or flex &amp; min/max) for Columns",
                isOpt: !0,
                ref: "ColumnSizingMap"
            },
            {
                name: "ColumnSorts",
                kind: "a",
                desc: "Sorting to apply in the Layout",
                isOpt: !0
            },
            {
                name: "GrandTotalRow",
                kind: "'top' | 'bottom' | 'pinnedTop' | 'pinnedBottom' | boolean",
                desc: "Position of the Grand Total Row in the Layout",
                isOpt: !0
            },
            {
                name: "GridFilter",
                kind: "R",
                desc: "Grid Filter to apply in Layout",
                isOpt: !0,
                ref: "GridFilter"
            },
            {
                name: "Name",
                kind: "s",
                desc: "Name of the Layout as it appears in the Layout toolbar and tool panel"
            },
            {
                name: "RowGroupDisplayType",
                kind: "'single' | 'multi'",
                desc: "Display Row Grouped Columns as &#39;single&#39; or &#39;multi&#39; column",
                isOpt: !0
            },
            {
                name: "RowGroupValues",
                kind: "R",
                desc: "Defines which Row Groups are expanded / collapsed",
                isOpt: !0,
                ref: "RowGroupValues"
            },
            {
                name: "SuppressAggFuncInHeader",
                kind: "b",
                desc: "Hides the aggFunc in Column header: e.g. &#39;sum(Price)&#39; becomes &#39;Price&#39;",
                isOpt: !0
            }
        ]
    },
    LayoutCreationDefaultProperties: {
        name: "LayoutCreationDefaultProperties",
        kind: "I",
        desc: "Default properties to apply when creating a new Layout (Table or Pivot)",
        props: [
            {
                name: "pivotLayout",
                kind: "R",
                desc: "Default properties to apply when creating a new Pivot Layout",
                isOpt: !0,
                ref: "PivotLayoutCreationDefaultProperties"
            },
            {
                name: "tableLayout",
                kind: "R",
                desc: "Default properties to apply when creating a new Table Layout",
                isOpt: !0,
                ref: "TableLayoutCreationDefaultProperties"
            }
        ]
    },
    LayoutCreationDefaultPropertiesContext: {
        name: "LayoutCreationDefaultPropertiesContext",
        kind: "I",
        desc: "Context for `LayoutOptions.layoutCreationDefaultProperties` function",
        props: [
            {
                name: "layoutType",
                kind: "'table' | 'pivot'",
                desc: "Type of Layout (&#39;table&#39; | &#39;pivot&#39;)"
            }
        ]
    },
    LayoutExtendedConfig: {
        name: "LayoutExtendedConfig",
        kind: "I",
        desc: "Configuration for API methods which load objects that can be Layout extensions"
    },
    LayoutExtendedContext: {
        name: "LayoutExtendedContext",
        kind: "I",
        desc: "Context for `LayoutOptions.isObjectExtendedInLayout` function",
        props: [
            {
                name: "adaptableObject",
                kind: "R",
                desc: "Object being checked",
                ref: "LayoutExtensionObject"
            },
            {
                name: "layout",
                kind: "R",
                desc: "Current Layout",
                ref: "Layout"
            },
            {
                name: "module",
                kind: "R",
                desc: "Current Adaptable Module",
                ref: "LayoutExtensionModule"
            }
        ]
    },
    LayoutExtension: {
        name: "LayoutExtension",
        kind: "I",
        desc: "Defines an object being extended in a Layout",
        props: [
            {
                name: "Module",
                kind: "R",
                desc: "Module to which Extended Object belongs",
                ref: "LayoutExtensionModule"
            },
            {
                name: "Object",
                kind: "R",
                desc: "Object being Extended",
                ref: "LayoutExtensionObject"
            }
        ]
    },
    LayoutExtensionModule: {
        name: "LayoutExtensionModule",
        kind: "A",
        desc: "Modules which can provide objects in Extended Layouts"
    },
    LayoutExtensionObject: {
        name: "LayoutExtensionObject",
        kind: "A",
        desc: "Types of Adaptable Objects that can added to Extended Layouts"
    },
    LayoutOptions: {
        name: "LayoutOptions",
        kind: "I",
        desc: "Options for configuring Layouts; manage Column visibility, order, sorting, grouping, width etc.",
        props: [
            {
                name: "layoutCreationDefaultProperties",
                kind: "u",
                desc: "Default properties to apply when creating a new Layout (Table or Pivot)",
                isOpt: !0
            },
            {
                name: "layoutTagOptions",
                kind: "R",
                desc: "Set of options for leveraging Object Tags to extend Layouts",
                isOpt: !0,
                ref: "LayoutTagOptions"
            },
            {
                name: "layoutViewOptions",
                kind: "R",
                desc: "Set of options for how Layouts are displayed in Settings Panel",
                isOpt: !0,
                ref: "LayoutViewOptions"
            },
            {
                name: "pivotPreviewColumns",
                kind: "u",
                desc: "Columns to display in Table that opens when viewing Pivot Cell contents",
                isOpt: !0
            }
        ]
    },
    LayoutState: {
        name: "LayoutState",
        kind: "I",
        desc: "Adaptable State Section for Layout Module, containing collection of Layouts and name of Current Layout",
        props: [
            {
                name: "CurrentLayout",
                kind: "s",
                desc: "Layout to be loaded when AdapTable starts (using `Name` property in Layout); if not provided the first Layout is used",
                isOpt: !0
            },
            {
                name: "Layouts",
                kind: "R",
                desc: "Collection of Layouts - can be Table or Pivot",
                ref: "LayoutArray"
            }
        ]
    },
    LayoutTagOptions: {
        name: "LayoutTagOptions",
        kind: "I",
        desc: "Options for managing Tags in Layouts (used to enhance Layouts)",
        props: [
            {
                name: "autoCheckTagsForLayouts",
                kind: "b",
                desc: "Automatically assumes that any `LayoutExtensionObject` is available in the current Layout if it has a tag with the Layouts name (or no tags at all)",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "autoGenerateTagsForLayouts",
                kind: "u",
                desc: "Automatically generate an AdaptableObjectTag for each Layout",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "isObjectExtendedInLayout",
                kind: "f",
                desc: "Checks if provided Adaptable Object is extended in given Layout",
                isOpt: !0
            }
        ]
    },
    LayoutViewOptions: {
        name: "LayoutViewOptions",
        kind: "I",
        desc: "Customize how Layouts are displayed in Settings Panel",
        props: [
            {
                name: "maxColumnsToDisplay",
                kind: "n",
                desc: "How many Column Names to display in inline Layout preview",
                isOpt: !0,
                defVal: "10"
            }
        ]
    },
    LoadingScreenOptions: {
        name: "LoadingScreenOptions",
        kind: "I",
        desc: "Options for the Loading Screen shown when AdapTable is initialising",
        props: [
            {
                name: "loadingScreenDelay",
                kind: "n",
                desc: "Delay in ms before Loading Screen appears",
                isOpt: !0,
                defVal: "200"
            },
            {
                name: "loadingScreenText",
                kind: "s",
                desc: "Text to display in Loading Screen.",
                isOpt: !0,
                defVal: "&#39;Retrieving your settings and setting up Grid...&#39;"
            },
            {
                name: "loadingScreenTitle",
                kind: "s",
                desc: "Title to display in Loading Screen.",
                isOpt: !0,
                defVal: "&#39;Initialising Grid&#39;"
            },
            {
                name: "showLoadingScreen",
                kind: "b",
                desc: "Display Loading Screen when AdapTable initialises",
                isOpt: !0,
                noCode: "item",
                defVal: "true"
            }
        ]
    },
    MasterDetailPluginOptions: {
        name: "MasterDetailPluginOptions",
        kind: "I",
        desc: "Plugin Options used when creating a Master / Detail grid - passed into the plugin as the only argument.",
        props: [
            {
                name: "detailAdaptableOptions",
                kind: "R",
                desc: "`AdaptableOptions` used in Detail Grids; all share same behaviour &amp; State",
                ref: "AdaptableOptions"
            },
            {
                name: "onDetailInit",
                kind: "f",
                desc: "Function called when a Detail Grid is initialised, receives context including Adaptable Api",
                isOpt: !0
            }
        ]
    },
    MenuCategory: {
        name: "MenuCategory",
        kind: "A",
        desc: "Defines the Category of for a Menu Item"
    },
    MenuSeparator: {
        name: "MenuSeparator",
        kind: "A",
        desc: "A separator to add to Column or Context Menu"
    },
    ModuleExpressionFunctions: {
        name: "ModuleExpressionFunctions",
        kind: "I",
        desc: "Type specific Expression Functions",
        props: [
            {
                name: "customBooleanFunctions",
                kind: "u",
                desc: "Custom Boolean Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (none)"
            },
            {
                name: "customScalarFunctions",
                kind: "u",
                desc: "Custom Scalar Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (none)"
            },
            {
                name: "systemAggregatedBooleanFunctions",
                kind: "u",
                desc: "System AggregatedBoolean Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (sets all)"
            },
            {
                name: "systemAggregatedScalarFunctions",
                kind: "u",
                desc: "System AggregatedScalar Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (sets all)"
            },
            {
                name: "systemBooleanFunctions",
                kind: "u",
                desc: "System Boolean Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (sets all)"
            },
            {
                name: "systemObservableFunctions",
                kind: "u",
                desc: "System Observable Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (sets all)"
            },
            {
                name: "systemScalarFunctions",
                kind: "u",
                desc: "System Scalar Expression Functions available in AdapTableQL",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (sets all)"
            }
        ]
    },
    ModuleExpressionFunctionsContext: {
        name: "ModuleExpressionFunctionsContext",
        kind: "I",
        desc: "Context provided to moduleExpressionFunctions property callback",
        props: [
            {
                name: "availableAggregatedBooleanFunctionNames",
                kind: "a",
                desc: "The global aggregated boolean expression functions"
            },
            {
                name: "availableAggregatedScalarFunctionNames",
                kind: "a",
                desc: "The global aggregated scalar expression functions"
            },
            {
                name: "availableBooleanFunctionNames",
                kind: "a",
                desc: "The global boolean expression functions"
            },
            {
                name: "availableObservableFunctionNames",
                kind: "a",
                desc: "The global observable expression functions"
            },
            {
                name: "availableScalarFunctionNames",
                kind: "a",
                desc: "The global scalar expression functions"
            },
            {
                name: "module",
                kind: "R",
                desc: "The Adaptable Module requesting the expression functions",
                ref: "AdaptableModule"
            }
        ]
    },
    ModuleExpressionFunctionsMap: {
        name: "ModuleExpressionFunctionsMap",
        kind: "A",
        desc: "Module specific Expression Functions"
    },
    NamedQuery: {
        name: "NamedQuery",
        kind: "I",
        desc: "Defines a Query which can be referenced in AdaptableQL Expressions",
        props: [
            {
                name: "Name",
                kind: "s",
                desc: "Name of the Query, used to reference it in AdaptableQL Expressions"
            }
        ]
    },
    NamedQueryState: {
        name: "NamedQueryState",
        kind: "I",
        desc: "Adaptable State Section for Named Query Module",
        props: [
            {
                name: "NamedQueries",
                kind: "a",
                desc: "Named Queries which can be referenced in other Expressions",
                isOpt: !0
            }
        ]
    },
    NotableCellContext: {
        name: "NotableCellContext",
        kind: "I",
        desc: "Context used when determining if a Note can be added to a Cell",
        props: [
            {
                name: "gridCell",
                kind: "R",
                desc: "Grid Cell in AdapTable which has been clicked",
                ref: "GridCell"
            }
        ]
    },
    NoteOptions: {
        name: "NoteOptions",
        kind: "I",
        desc: "Options for managing AdapTable Notes",
        props: [
            {
                name: "dateFormat",
                kind: "u",
                desc: "Date Format string for Notes timestamp",
                isOpt: !0,
                defVal: "&#39;dd-MM-yyyy HH:mm:ss&#39;"
            },
            {
                name: "isCellNotable",
                kind: "f",
                desc: "Whether a cell can contain Notes",
                isOpt: !0
            },
            {
                name: "showPopupCloseButton",
                kind: "b",
                desc: "Show the Close Button in the Notes Popup",
                isOpt: !0,
                defVal: "true"
            }
        ]
    },
    NoteState: {
        name: "NoteState",
        kind: "I",
        desc: "Adaptable State Section for Note Module",
        props: [
            {
                name: "Notes",
                kind: "R",
                desc: "Collection of AdapTable Notes",
                isOpt: !0,
                ref: "AdaptableNotes"
            }
        ]
    },
    NotificationsOptions: {
        name: "NotificationsOptions",
        kind: "I",
        desc: "Options related to System Status Messages and Notifications in Adaptable.",
        props: [
            {
                name: "closeWhenClicked",
                kind: "b",
                desc: "Closes Notification automatically when its clicked",
                isOpt: !0,
                gridInfo: "item",
                defVal: "false"
            },
            {
                name: "duration",
                kind: "number | 'always'",
                desc: "How long (in ms) Notifications display for",
                isOpt: !0,
                gridInfo: "item",
                defVal: "3000"
            },
            {
                name: "isDraggable",
                kind: "b",
                desc: "Can Notification be dragged",
                isOpt: !0,
                gridInfo: "item",
                defVal: "false"
            },
            {
                name: "maxNotifications",
                kind: "n",
                desc: "How many Notifications can be displayed at one time",
                isOpt: !0,
                gridInfo: "item",
                defVal: "3"
            },
            {
                name: "maxSystemMessagesInStore",
                kind: "n",
                desc: "How many System Status Messages to hold in State; when limit is reached, oldest Message is removed",
                isOpt: !0,
                gridInfo: "item",
                defVal: "100"
            },
            {
                name: "pauseWhenHovering",
                kind: "b",
                desc: "Pauses the Notification when mouse hovers over it",
                isOpt: !0,
                gridInfo: "item",
                defVal: "false"
            },
            {
                name: "position",
                kind: "R",
                desc: "Where Notification will appear (if anywhere)",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;BottomRight&#39;",
                ref: "ToastPositions"
            },
            {
                name: "showApplicationIcon",
                kind: "b",
                desc: "Displays the application icon in Notifications",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "showProgressBar",
                kind: "b",
                desc: "Shows a Progress Bar in the Notification",
                isOpt: !0,
                gridInfo: "item",
                defVal: "false"
            },
            {
                name: "showSystemStatusMessageNotifications",
                kind: "b",
                desc: "Display System Status Messages as Notifications",
                isOpt: !0,
                gridInfo: "item",
                defVal: "false"
            },
            {
                name: "transition",
                kind: "'Bounce' | 'Slide' | 'Zoom' | 'Flip'",
                desc: "How Notification will appear: Bounce, Slide, Zoom or Flip",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;Slide&#39;"
            }
        ]
    },
    NumberFormatterOptions: {
        name: "NumberFormatterOptions",
        kind: "I",
        desc: "Formatter Options for Numeric Columns",
        props: [
            {
                name: "Abs",
                kind: "b",
                desc: "Returns absolute value of cell value",
                isOpt: !0
            },
            {
                name: "Ceiling",
                kind: "b",
                desc: "Returns smallest integer greater than cell value",
                isOpt: !0
            },
            {
                name: "Content",
                kind: "string | number",
                desc: "Replaces cell value with supplied value (that can contain Template Literals)",
                isOpt: !0
            },
            {
                name: "Empty",
                kind: "b",
                desc: "Show nothing in cell (but underlying value remains)",
                isOpt: !0
            },
            {
                name: "Floor",
                kind: "b",
                desc: "Returns largest integer cell value",
                isOpt: !0
            },
            {
                name: "FractionDigits",
                kind: "n",
                desc: "Number of digits to show in Fractions (up to 20)",
                isOpt: !0
            },
            {
                name: "FractionSeparator",
                kind: "s",
                desc: "Separator to use in fractions",
                isOpt: !0
            },
            {
                name: "IntegerDigits",
                kind: "n",
                desc: "Number of digits to show for Integers (up to 20)",
                isOpt: !0
            },
            {
                name: "IntegerSeparator",
                kind: "s",
                desc: "Separator to use in Integers",
                isOpt: !0
            },
            {
                name: "Multiplier",
                kind: "n",
                desc: "Multiplier to use on cell value",
                isOpt: !0
            },
            {
                name: "Parentheses",
                kind: "b",
                desc: "Shows negative numbers in parentheses",
                isOpt: !0
            },
            {
                name: "Prefix",
                kind: "s",
                desc: "Prefix to use before cell value",
                isOpt: !0
            },
            {
                name: "Round",
                kind: "b",
                desc: "Rounds cell value",
                isOpt: !0
            },
            {
                name: "Suffix",
                kind: "s",
                desc: "Suffix to use after cell value",
                isOpt: !0
            },
            {
                name: "Truncate",
                kind: "b",
                desc: "Truncates cell value",
                isOpt: !0
            }
        ]
    },
    NumericStyledColumn: {
        name: "NumericStyledColumn",
        kind: "I",
        desc: "Base type for Numeric Styled Columns (i.e. Gradient and Percent Bar)",
        props: [
            {
                name: "CellRanges",
                kind: "a",
                desc: "Ranges (e.g. to create traffic light effect)",
                isOpt: !0
            },
            {
                name: "ColumnComparison",
                kind: "R",
                desc: "Compares Cell values to another Column",
                isOpt: !0,
                ref: "ColumnComparison"
            },
            {
                name: "RangeValueType",
                kind: "R",
                desc: "Used with Ranges; can be Number (any number or Col-Min/Col-Max) or &#39;Percentage&#39; (values 0-100)",
                isOpt: !0,
                defVal: "Number",
                ref: "RangeValueType"
            }
        ]
    },
    ObjectTagsContext: {
        name: "ObjectTagsContext",
        kind: "I",
        desc: "Context used when evaluating Object Tags"
    },
    OpenFinPluginOptions: {
        name: "OpenFinPluginOptions",
        kind: "I",
        desc: "Options required for when using the OpenFin plugin",
        props: [
            {
                name: "notificationTimeout",
                kind: "number | false",
                desc: "Timeout (in ms) for OpenFin Notifications to expire; set false for notifications not to auto-dismiss",
                isOpt: !0,
                defVal: "5000"
            },
            {
                name: "onNotificationAction",
                kind: "u",
                desc: "Function which is invoked when a button in OpenFin notification is clicked",
                isOpt: !0
            },
            {
                name: "onShowNotification",
                kind: "f",
                desc: "Updates OpenFin Notification object before it&#39;s displayed (just add/remove properties); return false to stop Notification showing",
                isOpt: !0
            },
            {
                name: "onValidationFailureInExcel",
                kind: "'override' | 'show-notification' | 'show-undo-notification'",
                desc: "Action to perform when a data change in Live Excel report triggers Prevent Edit Alert failure",
                isOpt: !0
            },
            {
                name: "showAdaptableAlertsAsNotifications",
                kind: "b",
                desc: "Converts AdapTable Alerts configured to display in popup as OpenFin Notifications",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "showAppIconInNotifications",
                kind: "u",
                desc: "Icon to show in Notification - uses the value supplied in UserInterfaceOptions",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "throttleTime",
                kind: "n",
                desc: "How long (in ms) AdapTable throttles when sending data update to OpenFin",
                isOpt: !0,
                defVal: "2000"
            }
        ]
    },
    OpenFinReport: {
        name: "OpenFinReport",
        kind: "I",
        desc: "An OpenFin report",
        props: [
            {
                name: "ReportName",
                kind: "s",
                desc: "Name of Report (which will exist in the Export State)"
            }
        ]
    },
    OpenFinSchedule: {
        name: "OpenFinSchedule",
        kind: "I",
        desc: "Defines a OpenFin Schedule - used in Schedule Module",
        props: [
            {
                name: "OpenFinReport",
                kind: "R",
                desc: "Report being exported to Excel (via OpenFin)",
                ref: "OpenFinReport"
            },
            {
                name: "Transmission",
                kind: "u",
                desc: "Whether Snapshot or Live Data (currently only the latter is supported)"
            }
        ]
    },
    OpenFinState: {
        name: "OpenFinState",
        kind: "I",
        desc: "Internal State used by AdapTable for managing the OpenFin plugin"
    },
    PercentBarStyle: {
        name: "PercentBarStyle",
        kind: "I",
        desc: "Style used to display Percent Bars in Special Column Style",
        props: [
            {
                name: "BackColor",
                kind: "s",
                desc: "Background colour for &#39;Percent Bar&#39;; leave unset if none required",
                isOpt: !0,
                defVal: "undefined"
            },
            {
                name: "CellText",
                kind: "R",
                desc: "Whether Cell shows Cell Value, Percent Value, both or none",
                isOpt: !0,
                ref: "CellTextOptions"
            },
            {
                name: "CellTextPosition",
                kind: "'Above' | 'Below' | 'Merged'",
                desc: "Position of text in Cell relative to Percent Bar, &quot;Above&quot;, &quot;Below&quot; or &quot;Merged&quot;",
                isOpt: !0,
                defVal: "Below"
            },
            {
                name: "ToolTipText",
                kind: "R",
                desc: "Whether Tooltip shows Cell Value, Percent Value, both or none",
                isOpt: !0,
                ref: "CellTextOptions"
            }
        ]
    },
    PivotAggregationColumns: {
        name: "PivotAggregationColumns",
        kind: "A",
        desc: "Defines an Aggregated Column in a Pivot Layout"
    },
    PivotAggregationTotalHeaderContext: {
        name: "PivotAggregationTotalHeaderContext",
        kind: "I",
        desc: "Context for Pivot Aggregation Totals",
        props: [
            {
                name: "aggregatedColumnId",
                kind: "s",
                desc: "Id of Aggregated Column"
            },
            {
                name: "aggregation",
                kind: "s",
                desc: "Aggregation function of Column"
            },
            {
                name: "columnType",
                kind: "u",
                desc: "Pivot Aggregation Total Column"
            },
            {
                name: "pivotColumnId",
                kind: "s",
                desc: "Id of Pivot Column"
            },
            {
                name: "pivotKey",
                kind: "s",
                desc: "Key (i.e. column value) of Pivot Column"
            }
        ]
    },
    PivotColumnGroupHeaderContext: {
        name: "PivotColumnGroupHeaderContext",
        kind: "I",
        desc: "Context for Pivot Column Groups",
        props: [
            {
                name: "columnType",
                kind: "u",
                desc: "Pivot Column Group (created for each distinct value in a PivotColumn)"
            },
            {
                name: "groupId",
                kind: "s",
                desc: "Id of generated Column Group"
            },
            {
                name: "pivotKeys",
                kind: "a",
                desc: "Pivot Keys for Column Group"
            },
            {
                name: "state",
                kind: "'expanded' | 'collapsed'",
                desc: "Expanded / Collapsed state of Column Group"
            }
        ]
    },
    PivotColumnTotalHeaderContext: {
        name: "PivotColumnTotalHeaderContext",
        kind: "I",
        desc: "Context for Pivot Total Columns",
        props: [
            {
                name: "aggregation",
                kind: "s",
                desc: "Aggregation function of Column"
            },
            {
                name: "columnType",
                kind: "u",
                desc: "Pivot Column Total"
            },
            {
                name: "pivotColumnId",
                kind: "s",
                desc: "Id of Pivot Column"
            },
            {
                name: "pivotKey",
                kind: "s",
                desc: "Key (i.e. column value) of Pivot Column"
            }
        ]
    },
    PivotGrandTotalHeaderContext: {
        name: "PivotGrandTotalHeaderContext",
        kind: "I",
        desc: "Context for Pivot Grand Total Columns",
        props: [
            {
                name: "aggregatedColumnId",
                kind: "s",
                desc: "Id of Pivot Aggregated Column"
            },
            {
                name: "aggregation",
                kind: "s",
                desc: "Aggregation function of Column"
            },
            {
                name: "columnType",
                kind: "u",
                desc: "Pivot Grand Total Column"
            }
        ]
    },
    PivotLayout: {
        name: "PivotLayout",
        kind: "I",
        desc: "Defines a Pivot-based Layout",
        props: [
            {
                name: "PivotAggregationColumns",
                kind: "R",
                desc: "Columns showing aggregated values in Group Rows; 1st value in record is Column name, 2nd is either aggfunc (e.g. sum, avg etc.) or &#39;true&#39; (to use default aggfunc)",
                isOpt: !0,
                ref: "PivotAggregationColumns"
            },
            {
                name: "PivotColumns",
                kind: "a",
                desc: "Mandatory list of Columns to pivot (provide empty array if just displaying Aggregations)"
            },
            {
                name: "PivotColumnTotal",
                kind: "R",
                desc: "Display automatically calculated Totals within EACH Pivot Column Group, in the position specified",
                isOpt: !0,
                ref: "PivotTotalPosition"
            },
            {
                name: "PivotExpandLevel",
                kind: "n",
                desc: "How deep to expand Pivot Columns (0 for none, 1 for 1st level only etc, -1 to expand all)",
                isOpt: !0
            },
            {
                name: "PivotGrandTotal",
                kind: "R",
                desc: "Display automatically calculated Totals of all Pivot Columns, in the position specified",
                isOpt: !0,
                ref: "PivotTotalPosition"
            },
            {
                name: "PivotGroupedColumns",
                kind: "a",
                desc: "Columns which are row-grouped when the Layout is applied",
                isOpt: !0
            },
            {
                name: "PivotResultColumnsOrder",
                kind: "string[] | boolean",
                desc: "Ordered list of Pivot Result Columns; set to `true` to track current display order, or provide custom list",
                isOpt: !0
            },
            {
                name: "RowGroupedColumns",
                kind: "u",
                desc: "Row Grouped Columns Columns - must NOT be provided",
                isOpt: !0
            },
            {
                name: "TableAggregationColumns",
                kind: "u",
                desc: "Table Aggregation Columns - must NOT be provided",
                isOpt: !0
            },
            {
                name: "TableColumns",
                kind: "u",
                desc: "Table Columns - must NOT be provided",
                isOpt: !0
            }
        ]
    },
    PivotLayoutCreationDefaultProperties: {
        name: "PivotLayoutCreationDefaultProperties",
        kind: "A",
        desc: "Default properties to apply when creating a new Pivot Layout"
    },
    PivotPreviewColumnsContext: {
        name: "PivotPreviewColumnsContext",
        kind: "I",
        desc: "Context uses for pivotPreviewColumns function in Layout Options",
        props: [
            {
                name: "columnId",
                kind: "s",
                desc: "Column being opened"
            },
            {
                name: "layout",
                kind: "R",
                desc: "Current Layout",
                ref: "Layout"
            }
        ]
    },
    PivotResultColumnHeaderContext: {
        name: "PivotResultColumnHeaderContext",
        kind: "I",
        desc: "Context for Pivot Result Columns",
        props: [
            {
                name: "aggregatedColumnId",
                kind: "s",
                desc: "Id of Pivot Aggregated Column"
            },
            {
                name: "aggregation",
                kind: "s",
                desc: "Aggregation function of Column"
            },
            {
                name: "columnId",
                kind: "s",
                desc: "Id of generated Column"
            },
            {
                name: "columnType",
                kind: "u",
                desc: "Pivot Result Column (unique intersection of PivotAggregationColumn and PivotColumn)"
            },
            {
                name: "pivotKeys",
                kind: "a",
                desc: "Current Pivot Keys"
            }
        ]
    },
    PivotTotalPosition: {
        name: "PivotTotalPosition",
        kind: "A",
        desc: "Defines the position of Pivot Total position - &#39;before&#39; or &#39;after&#39; the Value Column(s)"
    },
    PlusMinusNudge: {
        name: "PlusMinusNudge",
        kind: "I",
        desc: "Defines a Plus Minus Rule - used in the Plus Minus Module",
        props: [
            {
                name: "Name",
                kind: "s",
                desc: "Name of the Plus Minus Nudge rule"
            },
            {
                name: "NudgeValue",
                kind: "n",
                desc: "Amount by which to update cell when Rule is applied"
            },
            {
                name: "Rule",
                kind: "R",
                desc: "(Optional) Boolean Expression to determine whether to apply the Nudge",
                isOpt: !0,
                ref: "AdaptableBooleanQuery"
            },
            {
                name: "Scope",
                kind: "R",
                desc: "Where Rule is applied",
                ref: "ColumnScope"
            }
        ]
    },
    PlusMinusState: {
        name: "PlusMinusState",
        kind: "I",
        desc: "Adaptable State Section for Plus Minus Module",
        props: [
            {
                name: "PlusMinusNudges",
                kind: "a",
                desc: "Array of Plus Minus Nudges",
                isOpt: !0
            }
        ]
    },
    PopupType: {
        name: "PopupType",
        kind: "A",
        desc: "Type of Popup"
    },
    PredefinedConfig: {
        name: "PredefinedConfig",
        kind: "I",
        desc: "Deprecated initial state object (now replaced by InitialState)",
        props: [
            {
                name: "Alert",
                kind: "R",
                desc: "Collection of `AlertDefinitions` which will fire Alerts when the rule is met",
                isOpt: !0,
                ref: "AlertState"
            },
            {
                name: "Application",
                kind: "R",
                desc: "Empty state section (only populated at Design Time) available for User to store their own data with the rest of AdapTable state.",
                isOpt: !0,
                ref: "ApplicationState"
            },
            {
                name: "CalculatedColumn",
                kind: "R",
                desc: "Collection of *CalculatedColumn* objects that will display a value based on other cells in the row (using a Calculated Column Expression)",
                isOpt: !0,
                ref: "CalculatedColumnState"
            },
            {
                name: "Charting",
                kind: "R",
                desc: "Named Charts (wrapping Chart models)",
                isOpt: !0,
                ref: "ChartingState"
            },
            {
                name: "CustomSort",
                kind: "R",
                desc: "Collection of *Custom Sort* objects to allow some columns to be sorted in non-standard (e.g. non alphabetical) ways",
                isOpt: !0,
                ref: "CustomSortState"
            },
            {
                name: "Dashboard",
                kind: "R",
                desc: "Large series of properties to give users full control over the look and feel of the *Dashboard* - the section (typically above the grid) with toolbars and buttons",
                isOpt: !0,
                ref: "DashboardState"
            },
            {
                name: "Export",
                kind: "R",
                desc: "Collection of *Report* objects, together with name of the Current Report, as part of AdapTable export Module",
                isOpt: !0,
                ref: "ExportState"
            },
            {
                name: "FlashingCell",
                kind: "R",
                desc: "* Objects which define which cells flash in response to data changes",
                isOpt: !0,
                ref: "FlashingCellState"
            },
            {
                name: "FormatColumn",
                kind: "R",
                desc: "Collection of *FormatColumn* objects that will style an entire column either fully or using a Condition",
                isOpt: !0,
                ref: "FormatColumnState"
            },
            {
                name: "FreeTextColumn",
                kind: "R",
                desc: "Collection of *FreeText* objects so users can make their own notes in bespoke columns that will get stored with their state (and not with the DataSource). Useful if needing a &#39;Comments&#39; column.",
                isOpt: !0,
                ref: "FreeTextColumnState"
            },
            {
                name: "Layout",
                kind: "R",
                desc: "Collection of *Layouts* to name (and manage) sets of column visibility, order, grouping, sorts, aggregations, filters etc.",
                ref: "LayoutState"
            },
            {
                name: "NamedQuery",
                kind: "R",
                desc: "Named Queries available for use across multiple AdapTable Modules",
                isOpt: !0,
                ref: "NamedQueryState"
            },
            {
                name: "Note",
                kind: "R",
                desc: "Collection of personal Notes that are edited at Cell level",
                isOpt: !0,
                ref: "NoteState"
            },
            {
                name: "PlusMinus",
                kind: "R",
                desc: "Collection of *PlusMinus* rule objects to stipulate what happens when the user clicks &#39;+&#39; or &#39;-&#39; in a numeric cell",
                isOpt: !0,
                ref: "PlusMinusState"
            },
            {
                name: "QuickSearch",
                kind: "R",
                desc: "Configues how Quick Search will run i.e. how and whether to highlight matching cells and to filter out non-matching rows",
                isOpt: !0,
                ref: "QuickSearchState"
            },
            {
                name: "Schedule",
                kind: "R",
                desc: "Collection of *Schedule* objects",
                isOpt: !0,
                ref: "ScheduleState"
            },
            {
                name: "Shortcut",
                kind: "R",
                desc: "Collection of *Shortcut* objects to aid data entry and prevent &#39;fat finger&#39; issues",
                isOpt: !0,
                ref: "ShortcutState"
            },
            {
                name: "StatusBar",
                kind: "R",
                desc: "Configures the Adaptable Status Bar",
                isOpt: !0,
                ref: "StatusBarState"
            },
            {
                name: "StyledColumn",
                kind: "R",
                desc: "Collection of Special Column Styles",
                isOpt: !0,
                ref: "StyledColumnState"
            },
            {
                name: "Theme",
                kind: "R",
                desc: "Specifies the current Theme and lists the User and System themes available for selection.",
                isOpt: !0,
                ref: "ThemeState"
            },
            {
                name: "ToolPanel",
                kind: "R",
                desc: "Sets the order and visibility of the Tool Panel controls in the AdapTable ToolPanel (on right of grid)",
                isOpt: !0,
                ref: "ToolPanelState"
            },
            {
                name: "UserInterface",
                kind: "R",
                desc: "Controls AdapTable UI including visibility of AdapTable components",
                isOpt: !0,
                ref: "UserInterfaceState"
            }
        ]
    },
    PredicateDefHandlerContext: {
        name: "PredicateDefHandlerContext",
        kind: "I",
        desc: "Object passed into an Adaptable Predicate Definition",
        props: [
            {
                name: "column",
                kind: "R",
                desc: "AdapTable Column which contains the cell",
                ref: "AdaptableColumn"
            },
            {
                name: "displayValue",
                kind: "u",
                desc: "Display value in cell being evaluated"
            },
            {
                name: "groupValues",
                kind: "a",
                desc: "For grouped columns, the array with all the values starting from the root group to the current node",
                isOpt: !0
            },
            {
                name: "inputs",
                kind: "a",
                desc: "Any (optional) inputs required to perform evaluation",
                isOpt: !0
            },
            {
                name: "node",
                kind: "R",
                desc: "AG Grid Row node which contains the cell",
                ref: "unknown"
            },
            {
                name: "oldValue",
                kind: "u",
                desc: "Previous value in cell (e.g. if evaluating an edit)"
            },
            {
                name: "predicatesOperator",
                kind: "u",
                desc: "Logic used when combining multiple Predicates (&#39;AND&#39;|&#39;OR&#39;)",
                isOpt: !0
            },
            {
                name: "rawValue",
                kind: "u",
                desc: "Raw value in cell being evaluated (as per underlying data source)"
            },
            {
                name: "treeSelectionState",
                kind: "R",
                desc: "Optional TreeSelectionState - used for `In` predicate, when evaluating the grouped column. If this is not provided, another valid implementation is used.",
                isOpt: !0,
                ref: "unknown"
            },
            {
                name: "value",
                kind: "u",
                desc: "Value in cell being evaluated (normalized as per Column DataType)"
            }
        ]
    },
    PredicateDefInput: {
        name: "PredicateDefInput",
        kind: "I",
        desc: "Defines an Input to a Predicate"
    },
    PredicateDefToStringParams: {
        name: "PredicateDefToStringParams",
        kind: "I",
        desc: "Inputs required for a Predicate"
    },
    PredicateModuleScope: {
        name: "PredicateModuleScope",
        kind: "A",
        desc: "Defines which Modules use the Predicate"
    },
    PredicateOptions: {
        name: "PredicateOptions",
        kind: "I",
        desc: "Options for managing Adaptable Predicates using AdaptableQL",
        props: [
            {
                name: "caseSensitivePredicates",
                kind: "u",
                desc: "Perform case-sensitive text comparisons when evaluating Predicates",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "false"
            },
            {
                name: "customPredicateDefs",
                kind: "u",
                desc: "Definitions for Custom provided Predicates",
                isOpt: !0
            },
            {
                name: "evaluateInPredicateUsingTime",
                kind: "u",
                desc: "Should In Predicate evaluate using datetime, rather than date (the default)",
                isOpt: !0,
                noCode: "item",
                defVal: "false"
            },
            {
                name: "systemAlertPredicates",
                kind: "u",
                desc: "Which System Predicates are available in Alert Module",
                isOpt: !0
            },
            {
                name: "systemBadgeStylePredicates",
                kind: "u",
                desc: "Which System Predicates are available for Badge Styles",
                isOpt: !0
            },
            {
                name: "systemFilterPredicates",
                kind: "u",
                desc: "Which System Predicates are available when Filtering",
                isOpt: !0
            },
            {
                name: "systemFlashingCellPredicates",
                kind: "u",
                desc: "Which System Predicates are available in Flashing Cell Module",
                isOpt: !0
            },
            {
                name: "systemFormatColumnPredicates",
                kind: "u",
                desc: "Which System Predicates are available in Format Column Module",
                isOpt: !0
            }
        ]
    },
    PredicatesOperator: {
        name: "PredicatesOperator",
        kind: "A",
        desc: "Logic used to join multiple Predicates"
    },
    PreprocessRowDataContext: {
        name: "PreprocessRowDataContext",
        kind: "I",
        desc: "Context used when pre-processing Import Data",
        props: [
            {
                name: "rowData",
                kind: "u",
                desc: "Data which has been imported"
            }
        ]
    },
    ProcessExportContext: {
        name: "ProcessExportContext",
        kind: "I",
        desc: "Context used by the processExport function",
        props: [
            {
                name: "convertToCsv",
                kind: "f",
                desc: "Converts the Report Data to CSV format"
            },
            {
                name: "convertToExcel",
                kind: "u",
                desc: "Converts the Report Data to Excel format"
            },
            {
                name: "getReportColumns",
                kind: "u",
                desc: "Returns Columns to export based on Report&#39;s `ReportColumnScope`"
            }
        ]
    },
    ProgressIndicatorConfig: {
        name: "ProgressIndicatorConfig",
        kind: "I",
        desc: "Config when displaying a Progress Indicator",
        props: [
            {
                name: "delay",
                kind: "n",
                desc: "Length of Delay",
                isOpt: !0
            },
            {
                name: "frameworkComponent",
                kind: "R",
                desc: "A React, Angular or Vue Framework component to use",
                isOpt: !0,
                ref: "AdaptableFrameworkComponent"
            },
            {
                name: "render",
                kind: "R",
                desc: "Render function",
                isOpt: !0,
                ref: "CustomRenderFunction"
            },
            {
                name: "renderMode",
                kind: "'content' | 'dialog'",
                desc: "Determines whether custom component is rendered as &quot;content&quot; (inside window) or &quot;dialog&quot; (replacing window)",
                isOpt: !0
            },
            {
                name: "text",
                kind: "s",
                desc: "Text to display",
                isOpt: !0
            }
        ]
    },
    QueryableColumnContext: {
        name: "QueryableColumnContext",
        kind: "I",
        desc: "Context passed when evaluating Queryable Columns"
    },
    QuickSearchContext: {
        name: "QuickSearchContext",
        kind: "I",
        desc: "Context used when applying Quick Search in bespoke fashion",
        props: [
            {
                name: "gridCell",
                kind: "R",
                desc: "Cell being checked",
                ref: "GridCell"
            },
            {
                name: "quickSearchValue",
                kind: "s",
                desc: "Current Quick Search Text"
            }
        ]
    },
    QuickSearchOptions: {
        name: "QuickSearchOptions",
        kind: "I",
        desc: "Options for configuring Quick Search",
        props: [
            {
                name: "clearQuickSearchOnStartUp",
                kind: "b",
                desc: "Clears saved searches when AdapTable loads",
                isOpt: !0,
                gridInfo: "item",
                defVal: "false"
            },
            {
                name: "filterGridAfterQuickSearch",
                kind: "b",
                desc: "Filters Grid after quick search so only matching rows are displayed",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "false"
            },
            {
                name: "getCellSearchText",
                kind: "f",
                desc: "Allows a different value to be used for a cell when searching (instead of its raw value)",
                isOpt: !0
            },
            {
                name: "isCellSearchable",
                kind: "f",
                desc: "Determines whether Quick Search should be applied to a given cell",
                isOpt: !0
            },
            {
                name: "isQuickSearchCaseSensitive",
                kind: "b",
                desc: "Run Quick Search using Case Sensitivity",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "false"
            },
            {
                name: "quickSearchPlaceholder",
                kind: "s",
                desc: "Value to use as placeholder in QuickSearch controls (e.g. in Dashboard)",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;Search&#39;"
            }
        ]
    },
    QuickSearchState: {
        name: "QuickSearchState",
        kind: "I",
        desc: "Adaptable State Section for Quick Search Module",
        props: [
            {
                name: "CellMatchStyle",
                kind: "u",
                desc: "Style used to highlight matching cells",
                isOpt: !0
            },
            {
                name: "CurrentTextMatchStyle",
                kind: "u",
                desc: "Style used to highlight matching text within current match (not availale in SSRM)",
                isOpt: !0
            },
            {
                name: "QuickSearchText",
                kind: "s",
                desc: "Last Quick Search that was run (and will be applied at start-up)",
                isOpt: !0
            },
            {
                name: "TextMatchStyle",
                kind: "u",
                desc: "Style used to highlight matching text within a cell (not availale in SSRM)",
                isOpt: !0
            }
        ]
    },
    RaiseIntentConfig: {
        name: "RaiseIntentConfig",
        kind: "I",
        desc: "Config used when raising an FDC3 Intent",
        props: [
            {
                name: "actionButton",
                kind: "R",
                desc: "Definition of Action Button (to be put in default FDC3 Action Column)",
                isOpt: !0,
                ref: "Fdc3AdaptableButton"
            },
            {
                name: "actionColumn",
                kind: "u",
                desc: "Custom FDC3 Action Column definition for the Intent",
                isOpt: !0
            },
            {
                name: "contextMenu",
                kind: "u",
                desc: "Columns to display a &#39;Raise Intent&#39; Context Menu item",
                isOpt: !0
            },
            {
                name: "contextType",
                kind: "R",
                desc: "Key of Context being Raised",
                ref: "unknown"
            },
            {
                name: "handleIntentResolution",
                kind: "u",
                desc: "Handles the IntentResolution for this specific raise intent configuration",
                isOpt: !0
            }
        ]
    },
    RaiseIntentConfiguration: {
        name: "RaiseIntentConfiguration",
        kind: "I",
        desc: "Defines config options for Raising FDC3 Intents"
    },
    RangeValueType: {
        name: "RangeValueType",
        kind: "A",
        desc: "Whether the Range is Number or Percent based"
    },
    ReactFrameworkComponent: {
        name: "ReactFrameworkComponent",
        kind: "A",
        desc: "A function that returns a ReactNode"
    },
    ReminderSchedule: {
        name: "ReminderSchedule",
        kind: "I",
        desc: "Schedules a Reminder to appear at a given point in time",
        props: [
            {
                name: "DisplayNotification",
                kind: "b",
                desc: "Displays Reminder as a Toast Notification"
            },
            {
                name: "DisplaySystemStatusMessage",
                kind: "b",
                desc: "Shows Reminder as System Status Message",
                isOpt: !0
            },
            {
                name: "Header",
                kind: "s",
                desc: "Reminder header text"
            },
            {
                name: "Message",
                kind: "s",
                desc: "Reminder body text"
            },
            {
                name: "MessageType",
                kind: "R",
                desc: "Type of Message - &#39;Success&#39;, &#39;Info&#39;, &#39;Warning&#39; or &#39;Error&#39;",
                ref: "AdaptableMessageType"
            }
        ]
    },
    Report: {
        name: "Report",
        kind: "I",
        desc: "A Report which can export data from AdapTable",
        props: [
            {
                name: "Name",
                kind: "R",
                desc: "Name of the Report as displayed in the Export toolbar and tool panel",
                ref: "ReportNameType"
            },
            {
                name: "Query",
                kind: "R",
                desc: "Query to use; only required if `ReportRowScope` is &#39;ExpressionRows&#39;",
                isOpt: !0,
                ref: "AdaptableBooleanQuery"
            },
            {
                name: "ReportColumnScope",
                kind: "R",
                desc: "Columns to display: `AllColumns`, `VisibleColumns`, `SelectedColumns`, `ScopeColumns`",
                ref: "ReportColumnScope"
            },
            {
                name: "ReportRowScope",
                kind: "R",
                desc: "Rows to export: `AllRows`, `VisibleRows`, `SelectedRows`, `ExpressionRows`",
                ref: "ReportRowScope"
            },
            {
                name: "Scope",
                kind: "R",
                desc: "Columns Scope; only required if `ReportColumnScope` is &#39;ScopeColumns&#39;",
                isOpt: !0,
                ref: "ColumnScope"
            }
        ]
    },
    ReportColumn: {
        name: "ReportColumn",
        kind: "I",
        desc: "A Column exported in a Report",
        props: [
            {
                name: "field",
                kind: "s",
                desc: "Field in the row to get cell data from; defaults to `columnId`",
                isOpt: !0
            }
        ]
    },
    ReportColumnScope: {
        name: "ReportColumnScope",
        kind: "A",
        desc: "Columns to be included in a Report"
    },
    ReportContext: {
        name: "ReportContext",
        kind: "I",
        desc: "Report Context sent when using Custom Export Destinations",
        props: [
            {
                name: "reportData",
                kind: "R",
                desc: "Export Data for the Report",
                ref: "ExportResultData"
            }
        ]
    },
    ReportData: {
        name: "ReportData",
        kind: "I",
        desc: "Defines the data in a Report run by AdapTable",
        props: [
            {
                name: "columns",
                kind: "a",
                desc: "Columns in the Report"
            },
            {
                name: "groupColumnIds",
                kind: "a",
                desc: "Group columns IDs in the Report",
                isOpt: !0
            },
            {
                name: "pivotColumnIds",
                kind: "a",
                desc: "Pivot columns IDs in the Report",
                isOpt: !0
            },
            {
                name: "rows",
                kind: "u",
                desc: "Row Data in the Report"
            }
        ]
    },
    ReportFileNameContext: {
        name: "ReportFileNameContext",
        kind: "I",
        desc: "Context used for providing a custom filename for a Report",
        props: [
            {
                name: "fileName",
                kind: "s",
                desc: "Default File Name to use"
            }
        ]
    },
    ReportFormatType: {
        name: "ReportFormatType",
        kind: "A",
        desc: "Type of Report Format"
    },
    ReportNameType: {
        name: "ReportNameType",
        kind: "A",
        desc: "Type of Report Name"
    },
    ReportRowScope: {
        name: "ReportRowScope",
        kind: "A",
        desc: "AG Grid Row Data to be included in a Report"
    },
    ReportSchedule: {
        name: "ReportSchedule",
        kind: "I",
        desc: "Defines a Scheduled Report - used in Schedule Module (where State is stored)",
        props: [
            {
                name: "ExportDestination",
                kind: "R",
                desc: "Destination of Report to run on Schedule",
                isOpt: !0,
                ref: "ExportDestinationType"
            },
            {
                name: "ReportFormat",
                kind: "R",
                desc: "Format of Report to run on Schedule",
                ref: "ReportFormatType"
            },
            {
                name: "ReportName",
                kind: "s",
                desc: "Name of Report to run on Schedule"
            }
        ]
    },
    ResolveContextDataContext: {
        name: "ResolveContextDataContext",
        kind: "I",
        desc: "Used to build Context Data",
        props: [
            {
                name: "contextMappedFromGridData",
                kind: "R",
                desc: "FDC3 Context Data which has been mapped from the grid data based on the given configuration in `gridDataContextMapping`",
                isOpt: !0,
                ref: "unknown"
            },
            {
                name: "contextType",
                kind: "R",
                desc: "FDC3 Context Type",
                ref: "unknown"
            },
            {
                name: "primaryKeyValue",
                kind: "u",
                desc: "Primary Key value of row"
            },
            {
                name: "rowData",
                kind: "u",
                desc: "Row data which is the source of the context data"
            },
            {
                name: "rowNode",
                kind: "R",
                desc: "Row Node which is source of the context data",
                ref: "unknown"
            }
        ]
    },
    RowDataChangedInfo: {
        name: "RowDataChangedInfo",
        kind: "I",
        desc: "Info for RowDataChangedEvent, which rows changed and why",
        props: [
            {
                name: "changedAt",
                kind: "n",
                desc: "Timestamp of change occurrence (in milliseconds)"
            },
            {
                name: "dataRows",
                kind: "u",
                desc: "Data rows that have been added, updated, or deleted"
            },
            {
                name: "rowNodes",
                kind: "u",
                desc: "Row Nodes that were affected by this change"
            },
            {
                name: "rowTrigger",
                kind: "R",
                desc: "Trigger for row change: Load, Add, Update, or Delete",
                ref: "RowDataChangeTrigger"
            }
        ]
    },
    RowDataChangeTrigger: {
        name: "RowDataChangeTrigger",
        kind: "A",
        desc: "What row action triggered the Row Change: &#39;Add&#39;, &#39;Update&#39;, &#39;Delete&#39; or &#39;Load&#39;"
    },
    RowFormColumnContext: {
        name: "RowFormColumnContext",
        kind: "I",
        desc: "Context used when decided if column should be included in a Row Form",
        props: [
            {
                name: "adaptableColumn",
                kind: "R",
                desc: "Column to be displayed",
                ref: "AdaptableColumn"
            },
            {
                name: "rowFormType",
                kind: "R",
                desc: "Type of Row Form",
                ref: "RowFormType"
            }
        ]
    },
    RowFormContext: {
        name: "RowFormContext",
        kind: "A",
        desc: "Context passed into a Row Form - can be `CreateRowFormContext` or `EditRowFormContext`"
    },
    RowFormFieldContext: {
        name: "RowFormFieldContext",
        kind: "I",
        desc: "Context used for overriding Field elements in Row Form"
    },
    RowFormOptions: {
        name: "RowFormOptions",
        kind: "I",
        desc: "Options related to Dynamic Row Forms in AdapTable",
        props: [
            {
                name: "autoHandle",
                kind: "b",
                desc: "Whether AdapTable automatically updates AG Grid data model with created/edited/deleted rows",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "disableInlineEditing",
                kind: "b",
                desc: "Prevents direct editing in Grid cells even for editable columns",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "includeColumnInRowForm",
                kind: "f",
                desc: "Is given Column displayed in Row Form",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "onRowFormSubmit",
                kind: "u",
                desc: "Event fired when a Row Form is submitted via a standard button provided by AdapTable; this is not invoked when custom form buttons are provided",
                isOpt: !0,
                defVal: "undefined"
            },
            {
                name: "rowFormButtons",
                kind: "u",
                desc: "Custom form buttons; if provided, need to handle form submission explicitly",
                isOpt: !0
            },
            {
                name: "rowFormDescription",
                kind: "u",
                desc: "Custom form description provider",
                isOpt: !0,
                defVal: "undefined"
            },
            {
                name: "rowFormFieldLabel",
                kind: "u",
                desc: "Custom form field label provider",
                isOpt: !0,
                defVal: "undefined"
            },
            {
                name: "rowFormTitle",
                kind: "u",
                desc: "Custom form title provider",
                isOpt: !0,
                defVal: "&#39;Create New Row&#39;/&#39;Edit Row&#39;"
            },
            {
                name: "setPrimaryKeyValue",
                kind: "u",
                desc: "Function called when auto-handling &#39;create&#39; or &#39;clone&#39; Command Button; returned value should be valid for Primary Key column",
                isOpt: !0,
                defVal: "undefined"
            }
        ]
    },
    RowFormTitleContext: {
        name: "RowFormTitleContext",
        kind: "I",
        desc: "Context used for overriding Title and Description of Row Form"
    },
    RowFormType: {
        name: "RowFormType",
        kind: "A",
        desc: "Type of RowForm: &#39;rowCreated&#39; | &#39;rowEdited&#39; | &#39;rowDeleted&#39;"
    },
    RowGroupColumnHeaderContext: {
        name: "RowGroupColumnHeaderContext",
        kind: "I",
        desc: "Context for Columns created when Row Grouping",
        props: [
            {
                name: "columnId",
                kind: "s",
                desc: "Id of the Column"
            },
            {
                name: "columnType",
                kind: "u",
                desc: "A Row Grouped Column (created in both Table and Pivot Layout)"
            },
            {
                name: "groupColumnId",
                kind: "s",
                desc: "Id of Row Grouped Column"
            }
        ]
    },
    RowGroupValues: {
        name: "RowGroupValues",
        kind: "A",
        desc: "Manages Row Group expand / collapse behaviour, including exceptions"
    },
    RowGroupValuesWithExceptionKeys: {
        name: "RowGroupValuesWithExceptionKeys",
        kind: "A",
        desc: "Defines which Row Groups are expanded or collapsed"
    },
    RowHighlightInfo: {
        name: "RowHighlightInfo",
        kind: "I",
        desc: "Define how to highlight a Row",
        props: [
            {
                name: "highlightStyle",
                kind: "R",
                desc: "Highlight style",
                ref: "AdaptableStyle"
            },
            {
                name: "primaryKeyValue",
                kind: "u",
                desc: "Primary key value for the row to be highlighted"
            },
            {
                name: "timeout",
                kind: "n",
                desc: "Timeout after which Row should be unhighlighted",
                isOpt: !0
            }
        ]
    },
    RowInfo: {
        name: "RowInfo",
        kind: "I",
        desc: "Provides meta data about a Row in Adaptable",
        props: [
            {
                name: "isDisplayed",
                kind: "b",
                desc: "Is Row displayed (ie. filtered, not necessarily in viewport)",
                isOpt: !0
            },
            {
                name: "isExpanded",
                kind: "b",
                desc: "Is Row expanded (if a group row)",
                isOpt: !0
            },
            {
                name: "isGroup",
                kind: "b",
                desc: "Is Row grouped",
                isOpt: !0
            },
            {
                name: "isMaster",
                kind: "b",
                desc: "Is Row a Master Row (in a Master-Detail grid)",
                isOpt: !0
            },
            {
                name: "isSelected",
                kind: "b",
                desc: "Is Row selected",
                isOpt: !0
            },
            {
                name: "rowGroupLevel",
                kind: "n",
                desc: "What level the Row is (if Row Grouping is active)",
                isOpt: !0
            }
        ]
    },
    RowScope: {
        name: "RowScope",
        kind: "I",
        desc: "Defines which types of Rows to exclude when rendering Format Columns, Action Columns and Badges",
        props: [
            {
                name: "ExcludeDataRows",
                kind: "b",
                desc: "Exclude regular data rows",
                isOpt: !0
            },
            {
                name: "ExcludeGroupRows",
                kind: "b",
                desc: "Exclude Group Rows",
                isOpt: !0
            },
            {
                name: "ExcludeSummaryRows",
                kind: "b",
                desc: "Exclude Summary Rows (used in Row Summaries)",
                isOpt: !0
            },
            {
                name: "ExcludeTotalRows",
                kind: "b",
                desc: "Exclude Grand Total Rows (used in Aggregations)",
                isOpt: !0
            }
        ]
    },
    RowsHighlightInfo: {
        name: "RowsHighlightInfo",
        kind: "I",
        desc: "Defines how to highlight a set of Rows",
        props: [
            {
                name: "highlightStyle",
                kind: "R",
                desc: "Highlight style",
                ref: "AdaptableStyle"
            },
            {
                name: "primaryKeyValues",
                kind: "a",
                desc: "Primary key valuse for the rows to be highlighted"
            },
            {
                name: "timeout",
                kind: "n",
                desc: "Timeout after which the highlight is removed",
                isOpt: !0
            }
        ]
    },
    RowSummary: {
        name: "RowSummary",
        kind: "I",
        desc: "Defines a Row Summary used in a Layout",
        props: [
            {
                name: "ColumnsMap",
                kind: "u",
                desc: "Map of Columns with Summary Expressions"
            },
            {
                name: "IncludeOnlyFilteredRows",
                kind: "b",
                desc: "Evaluates only currently filtered rows in the summary",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "Position",
                kind: "R",
                desc: "Where Row Summary appears - &#39;Top&#39; or &#39;Bottom&#39;",
                isOpt: !0,
                ref: "RowSummaryPosition"
            }
        ]
    },
    RowSummaryPosition: {
        name: "RowSummaryPosition",
        kind: "A",
        desc: "Position of Row Summary - &#39;Top&#39; or &#39;Bottom&#39;"
    },
    SaveChartBehaviour: {
        name: "SaveChartBehaviour",
        kind: "A",
        desc: "How Charts are saved"
    },
    Schedule: {
        name: "Schedule",
        kind: "I",
        desc: "Defines when an action will be run - either one-off or recurring",
        props: [
            {
                name: "DaysOfWeek",
                kind: "R",
                desc: "Days on which Schedule will run",
                isOpt: !0,
                ref: "unknown"
            },
            {
                name: "Hour",
                kind: "n",
                desc: "Hour the Schedule will run"
            },
            {
                name: "Minute",
                kind: "n",
                desc: "Minute the Schedule will run"
            },
            {
                name: "OneOffDate",
                kind: "s",
                desc: "A one off date on which the Schedule will run",
                isOpt: !0
            }
        ]
    },
    ScheduleState: {
        name: "ScheduleState",
        kind: "I",
        desc: "Adaptable State Section for the Schedule Module",
        props: [
            {
                name: "IPushPullSchedules",
                kind: "a",
                desc: "Schedules connected to ipushpull Reports - available if ipushpull plugin is running",
                isOpt: !0
            },
            {
                name: "OpenFinSchedules",
                kind: "a",
                desc: "Schedules connected to OpenFin exports - available if OpenFin plugin is running",
                isOpt: !0
            },
            {
                name: "Reminders",
                kind: "a",
                desc: "Schedules connected to Reminders - Alerts that fire at set times",
                isOpt: !0
            },
            {
                name: "ReportSchedules",
                kind: "a",
                desc: "Schedules connected to Reports (created in the Export function)",
                isOpt: !0
            }
        ]
    },
    SelectedCellInfo: {
        name: "SelectedCellInfo",
        kind: "I",
        desc: "Describes which Cells are currently selected in AdapTable",
        props: [
            {
                name: "columns",
                kind: "u",
                desc: "Array of Columns which have selected cells"
            },
            {
                name: "gridCells",
                kind: "u",
                desc: "Array of GridCells (which provide cell value, primary kev value and other info)"
            }
        ]
    },
    SelectedRowInfo: {
        name: "SelectedRowInfo",
        kind: "I",
        desc: "Description of currently selected Rows in AdapTable",
        props: [
            {
                name: "gridRows",
                kind: "u",
                desc: "Array of Grid Rows containing full information about a row in AdapTable"
            }
        ]
    },
    ServerValidationContext: {
        name: "ServerValidationContext",
        kind: "I",
        desc: "Context used when validating data edits on Server",
        props: [
            {
                name: "cellDataChangedInfo",
                kind: "u",
                desc: "Details of Cell Edit"
            }
        ]
    },
    ServerValidationResult: {
        name: "ServerValidationResult",
        kind: "I",
        desc: "Used for Server Validation ie. after an edit in AG Grid which must be checked on Server",
        props: [
            {
                name: "messageType",
                kind: "R",
                desc: "Type of Message to Display",
                isOpt: !0,
                defVal: "Info",
                ref: "AdaptableMessageType"
            },
            {
                name: "newCellValue",
                kind: "u",
                desc: "Cell Value to use for after Server Validation",
                isOpt: !0
            },
            {
                name: "validationHeader",
                kind: "s",
                desc: "Header to diplay with validation",
                isOpt: !0,
                defVal: "&#39;Server Validation Message&#39;,"
            },
            {
                name: "validationMessage",
                kind: "s",
                desc: "Message to diplay with validation",
                isOpt: !0
            }
        ]
    },
    SetPrimaryKeyValueContext: {
        name: "SetPrimaryKeyValueContext",
        kind: "I",
        desc: "Context for the setPrimaryKeyValue function",
        props: [
            {
                name: "rowData",
                kind: "u",
                desc: "Data in the row being created or cloned"
            }
        ]
    },
    SettingsPanelOptions: {
        name: "SettingsPanelOptions",
        kind: "I",
        desc: "Options for managing the AdapTable Settings Panel",
        props: [
            {
                name: "alwaysShowInDashboard",
                kind: "b",
                desc: "Whether a Settings Panel button should always be displayed in `ModuleButtons` area of Dashboard",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "false"
            },
            {
                name: "alwaysShowInToolPanel",
                kind: "b",
                desc: "Whether a Settings Panel button should always be displayed in `ModuleButtons` area of ToolPanel",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "false"
            },
            {
                name: "customSettingsPanels",
                kind: "a",
                desc: "Custom Settings Panels provided by developers at design-time",
                isOpt: !0
            },
            {
                name: "icon",
                kind: "u",
                desc: "Icon shown in top left of Settings Panel: Can be `ConfigurationIcon`, `ApplicationIcon` or custom Icon",
                isOpt: !0,
                defVal: "`ConfigurationIcon`"
            },
            {
                name: "navigation",
                kind: "u",
                desc: "Ordered items to display at side of Settings Panel",
                isOpt: !0,
                defVal: "all available AdapTable modules"
            },
            {
                name: "popupType",
                kind: "R",
                desc: "Whether Settings Panel is &#39;window&#39; (i.e. movable, resizable, no backdrop) or &#39;modal&#39; (centre of screen with backdrop)",
                isOpt: !0,
                defVal: "&#39;window&#39;",
                ref: "PopupType"
            },
            {
                name: "position",
                kind: "u",
                desc: "Initial position of Settings Panel window",
                isOpt: !0,
                defVal: "Middle of Screen"
            },
            {
                name: "showModuleIcons",
                kind: "b",
                desc: "Whether to show Icons for each Module in the Setting Panel",
                isOpt: !0,
                gridInfo: "item",
                defVal: "true"
            },
            {
                name: "size",
                kind: "u",
                desc: "Initial size of Settings Panel",
                isOpt: !0,
                defVal: "Computed based on size of screen"
            },
            {
                name: "title",
                kind: "s",
                desc: "Title for the Settings Panel",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;Settings Panel&#39;"
            }
        ]
    },
    SharedEntitiesContext: {
        name: "SharedEntitiesContext",
        kind: "I",
        desc: "Context provided to `TeamSharingOptions.loadSharedEntities()` callback"
    },
    SharedEntity: {
        name: "SharedEntity",
        kind: "A",
        desc: "Defines an object used in Team Sharing. The union type is discriminated by the `EntityType` property (`adaptableEntity` / `customEntity`)."
    },
    SharedEntityType: {
        name: "SharedEntityType",
        kind: "A",
        desc: "Type of Shared Entity - Snapshot or Active"
    },
    Shortcut: {
        name: "Shortcut",
        kind: "I",
        desc: "Used to define a Shortcut as used in Shortcut State",
        props: [
            {
                name: "Name",
                kind: "s",
                desc: "Name of the Shortcut"
            },
            {
                name: "Scope",
                kind: "u",
                desc: "Numeric Columns where Shortcut is applied"
            },
            {
                name: "ShortcutKey",
                kind: "s",
                desc: "Key which triggers the Shortcut when pressed"
            },
            {
                name: "ShortcutOperation",
                kind: "'Add' | 'Subtract' | 'Multiply' | 'Divide'",
                desc: "The Operation: &#39;Add&#39;, &#39;Subtract&#39;, &#39;Multiply&#39;, &#39;Divide&#39;"
            },
            {
                name: "ShortcutValue",
                kind: "n",
                desc: "Value acting as 2nd operand for ShortcutOperation (1st operand is the cell value)"
            }
        ]
    },
    ShortcutScopeDataType: {
        name: "ShortcutScopeDataType",
        kind: "A",
        desc: "Shortcut scope data type."
    },
    ShortcutState: {
        name: "ShortcutState",
        kind: "I",
        desc: "Adaptable State Section for Shortcut Module",
        props: [
            {
                name: "Shortcuts",
                kind: "a",
                desc: "Collection of Shortcuts - designed to speed up data entry",
                isOpt: !0
            }
        ]
    },
    SmartEditCustomOperation: {
        name: "SmartEditCustomOperation",
        kind: "A",
        desc: "Custom Operation used in Smart Edit Module"
    },
    SmartEditOperation: {
        name: "SmartEditOperation",
        kind: "A",
        desc: "Operation used by Smart Edit - either System or Custom"
    },
    SmartEditOperationContext: {
        name: "SmartEditOperationContext",
        kind: "I",
        desc: "Context used in Custom Smart Edit Operations",
        props: [
            {
                name: "currentCell",
                kind: "u",
                desc: "Current selected grid cell - contains column, row and cell value information"
            },
            {
                name: "smartEditValue",
                kind: "n",
                desc: "Smart Edit value"
            }
        ]
    },
    SparklineStyle: {
        name: "SparklineStyle",
        kind: "A",
        desc: "Style to show for a Sparkline Column"
    },
    SpecialColumnSettings: {
        name: "SpecialColumnSettings",
        kind: "I",
        desc: "Base Settings for both Calculated and FreeText Columns",
        props: [
            {
                name: "Aggregatable",
                kind: "b",
                desc: "Whether Column can be used in an aggregation when grouping",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "ColumnTypes",
                kind: "a",
                desc: "Custom column types added to AG Grid Column Types when object is created",
                isOpt: !0
            },
            {
                name: "DataType",
                kind: "R",
                desc: "Expression&#39;s return value DataType, only mandatory property",
                ref: "AdaptableColumnDataType"
            },
            {
                name: "Filterable",
                kind: "b",
                desc: "Whether Column is filterable",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "Groupable",
                kind: "b",
                desc: "Whether Column can be grouped",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "HeaderToolTip",
                kind: "s",
                desc: "Tooltip to show in the Column Header (not cells)",
                isOpt: !0
            },
            {
                name: "Pivotable",
                kind: "b",
                desc: "Whether Column can be used when grid is in pivot mode",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "Resizable",
                kind: "b",
                desc: "Whether Column can be resized (by dragging column header edges)",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "Sortable",
                kind: "b",
                desc: "Whether Column is sortable",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "SuppressMenu",
                kind: "b",
                desc: "Whether if no menu should be shown for this Column header.",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "SuppressMovable",
                kind: "b",
                desc: "Whether if this Column should be movable via dragging",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "Width",
                kind: "n",
                desc: "Preferred (pixel) Column Width; if unset, calculated dynamically by AG Grid",
                isOpt: !0
            }
        ]
    },
    StateOptions: {
        name: "StateOptions",
        kind: "I",
        desc: "Options related to Adaptable State hydration / dehydration; allows users to intercept state persistence and loading with custom functionality",
        props: [
            {
                name: "applyState",
                kind: "R",
                desc: "Transforms state before applying it to the application. Called after `loadState()` but before the state is used.",
                isOpt: !0,
                ref: "unknown"
            },
            {
                name: "autoMigrateState",
                kind: "b",
                desc: "Automatically migrate State from previous AdapTable version to current one",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "clearState",
                kind: "R",
                desc: "Allows clearing of remote Adaptable State. Only invoked during `StateApi.reloadInitialState()` operations.",
                isOpt: !0,
                defVal: "undefined",
                ref: "AdaptableClearStateFunction"
            },
            {
                name: "debounceStateDelay",
                kind: "n",
                desc: "Delay (in ms) to debounce `saveState` / `persistState` calls enabling grouping multiple sequential calls in single one (e.g. elevator doors)",
                isOpt: !0,
                defVal: "400"
            },
            {
                name: "loadState",
                kind: "R",
                desc: "Retrieves saved Adaptable State from storage or external source",
                isOpt: !0,
                ref: "AdaptableLoadStateFunction"
            },
            {
                name: "persistState",
                kind: "R",
                desc: "Handles the actual storage of state to localStorage, server, etc. Called after `saveState()` to store the prepared state.",
                isOpt: !0,
                ref: "AdaptablePersistStateFunction"
            },
            {
                name: "saveState",
                kind: "R",
                desc: "Transforms state before saving to storage. Called before `persistState()`.",
                isOpt: !0,
                ref: "AdaptableSaveStateFunction"
            }
        ]
    },
    StatusBarState: {
        name: "StatusBarState",
        kind: "I",
        desc: "Adaptable State Section for the Adaptable Status Bar",
        props: [
            {
                name: "StatusBars",
                kind: "a",
                desc: "Adaptable Status Bars to display - can be unlimited and displayed in 3 locations",
                isOpt: !0,
                defVal: "null"
            }
        ]
    },
    StringFormatterOptions: {
        name: "StringFormatterOptions",
        kind: "I",
        desc: "Formatter Options for String Columns",
        props: [
            {
                name: "Case",
                kind: "'Upper' | 'Lower' | 'Sentence'",
                desc: "Sets text to Upper or Lower case",
                isOpt: !0
            },
            {
                name: "Content",
                kind: "s",
                desc: "Replaces cell value; useful when using Condition (e.g. replace null with &#39;N/A&#39;)",
                isOpt: !0
            },
            {
                name: "Empty",
                kind: "b",
                desc: "Show nothing in cell (but underlying value remains)",
                isOpt: !0
            },
            {
                name: "Prefix",
                kind: "s",
                desc: "Prefix to use before the cell text",
                isOpt: !0
            },
            {
                name: "Suffix",
                kind: "s",
                desc: "Suffix to use after the cell text",
                isOpt: !0
            },
            {
                name: "Trim",
                kind: "b",
                desc: "Trims text (both start and end)",
                isOpt: !0
            }
        ]
    },
    StyledColumn: {
        name: "StyledColumn",
        kind: "I",
        desc: "Object used in Special Column Style function",
        props: [
            {
                name: "BadgeStyle",
                kind: "R",
                desc: "Displays cell values in Column as a Badge",
                isOpt: !0,
                ref: "BadgeStyle"
            },
            {
                name: "ColumnId",
                kind: "s",
                desc: "Column being styled"
            },
            {
                name: "GradientStyle",
                kind: "R",
                desc: "Styles a numeric column with a Gradient",
                isOpt: !0,
                ref: "GradientStyle"
            },
            {
                name: "PercentBarStyle",
                kind: "R",
                desc: "Styles a numeric column so each cell displays a &#39;Bar&#39;",
                isOpt: !0,
                ref: "PercentBarStyle"
            },
            {
                name: "SparklineStyle",
                kind: "R",
                desc: "Displays a Sparkline Chart in an array column",
                isOpt: !0,
                ref: "SparklineStyle"
            }
        ]
    },
    StyledColumnState: {
        name: "StyledColumnState",
        kind: "I",
        desc: "Adaptable State Section for Styled Column Module",
        props: [
            {
                name: "StyledColumns",
                kind: "a",
                desc: "Collection of Special Column Styles",
                isOpt: !0
            }
        ]
    },
    SuspendableObject: {
        name: "SuspendableObject",
        kind: "I",
        desc: "Interface that extends Adaptable Object for those config items that can be suspended at run-time",
        props: [
            {
                name: "IsSuspended",
                kind: "b",
                desc: "Suspends (i.e. turns off) an Adaptable Object",
                isOpt: !0
            }
        ]
    },
    SystemAlertPredicateId: {
        name: "SystemAlertPredicateId",
        kind: "A",
        desc: "List of System Predicates available for Alerts"
    },
    SystemAlertPredicateIds: {
        name: "SystemAlertPredicateIds",
        kind: "A",
        desc: "Array containing all System Alert Predicates"
    },
    SystemBadgeStylePredicateId: {
        name: "SystemBadgeStylePredicateId",
        kind: "A",
        desc: "Predicates available when creating a Badge Style Rule"
    },
    SystemBadgeStylePredicateIds: {
        name: "SystemBadgeStylePredicateIds",
        kind: "A",
        desc: "System Predicate Ids available for Badge Style"
    },
    SystemExportDestination: {
        name: "SystemExportDestination",
        kind: "A",
        desc: "Export Destinations provided by AdapTable"
    },
    SystemExportDestinationsContext: {
        name: "SystemExportDestinationsContext",
        kind: "I",
        desc: "Context provided to `ExportOptions.systemExportDestinations` callback",
        props: [
            {
                name: "currentLayoutName",
                kind: "s",
                desc: "Name of current Layout"
            },
            {
                name: "currentReportFormat",
                kind: "R",
                desc: "Format of current Report",
                isOpt: !0,
                ref: "ReportFormatType"
            },
            {
                name: "currentReportName",
                kind: "R",
                desc: "Name of current Report",
                isOpt: !0,
                ref: "ReportNameType"
            },
            {
                name: "defaultSystemExportDestinations",
                kind: "a",
                desc: "Default System Export Destinations"
            }
        ]
    },
    SystemFilterPredicateId: {
        name: "SystemFilterPredicateId",
        kind: "A",
        desc: "List of System Predicates available for Filters"
    },
    SystemFilterPredicateIds: {
        name: "SystemFilterPredicateIds",
        kind: "A",
        desc: "Array containing all System Filter Predicates"
    },
    SystemFlashingCellPredicateId: {
        name: "SystemFlashingCellPredicateId",
        kind: "A",
        desc: "List of System Predicates available for Flashing Cells"
    },
    SystemFlashingCellPredicateIds: {
        name: "SystemFlashingCellPredicateIds",
        kind: "A",
        desc: "Array containing all System Flashing Cell Predicates"
    },
    SystemFormatColumnPredicateId: {
        name: "SystemFormatColumnPredicateId",
        kind: "A",
        desc: "List of System Predicates available for Format Columns"
    },
    SystemFormatColumnPredicateIds: {
        name: "SystemFormatColumnPredicateIds",
        kind: "A",
        desc: "Array containing all System Format Column Predicates"
    },
    SystemPredicatesContext: {
        name: "SystemPredicatesContext",
        kind: "I",
        desc: "Context used for setting which System Predicates are available",
        props: [
            {
                name: "columnScope",
                kind: "R",
                desc: "Current Scope where Predicates are being used",
                ref: "ColumnScope"
            },
            {
                name: "moduleScope",
                kind: "R",
                desc: "Module for which Predicates are being retrieved",
                ref: "PredicateModuleScope"
            },
            {
                name: "systemPredicateDefs",
                kind: "u",
                desc: "AdapTable-provided System Predicate Definitions"
            }
        ]
    },
    SystemReportFormat: {
        name: "SystemReportFormat",
        kind: "A",
        desc: "System report formats provided by AdapTable"
    },
    SystemReportFormatsContext: {
        name: "SystemReportFormatsContext",
        kind: "I",
        desc: "Context provided to `ExportOptions.systemReportFormats` callback",
        props: [
            {
                name: "currentLayoutName",
                kind: "s",
                desc: "Name of current Layout"
            },
            {
                name: "currentReportName",
                kind: "R",
                desc: "Name of current Report",
                isOpt: !0,
                ref: "ReportNameType"
            },
            {
                name: "defaultSystemReportFormats",
                kind: "a",
                desc: "Default System Report Formats"
            }
        ]
    },
    SystemReportName: {
        name: "SystemReportName",
        kind: "A",
        desc: "System report names provided by AdapTable"
    },
    SystemReportNames: {
        name: "SystemReportNames",
        kind: "A",
        desc: "Array containing all System Report names"
    },
    SystemReportNamesContext: {
        name: "SystemReportNamesContext",
        kind: "I",
        desc: "Context provided to `ExportOptions.systemReportNames` callback",
        props: [
            {
                name: "currentLayoutName",
                kind: "s",
                desc: "Name of current Layout"
            },
            {
                name: "defaultSystemReportNames",
                kind: "a",
                desc: "Default System Report Names"
            }
        ]
    },
    SystemStatusMessageInfo: {
        name: "SystemStatusMessageInfo",
        kind: "I",
        desc: "Wraps a System Status Message",
        props: [
            {
                name: "statusFurtherInformation",
                kind: "s",
                desc: "Additional information to display (optional)",
                isOpt: !0
            },
            {
                name: "statusMessage",
                kind: "s",
                desc: "The Message to be displayed"
            },
            {
                name: "statusType",
                kind: "R",
                desc: "Type of Message i.e. Succcess, Warning, Error, Info",
                ref: "AdaptableMessageType"
            },
            {
                name: "timestamp",
                kind: "d",
                desc: "When Message was sent",
                isOpt: !0
            }
        ]
    },
    TableAggregationColumns: {
        name: "TableAggregationColumns",
        kind: "A",
        desc: "Defines an Aggregated Column in a Table Layout"
    },
    TableColumnGroupHeaderContext: {
        name: "TableColumnGroupHeaderContext",
        kind: "I",
        desc: "Context for Column Group headers",
        props: [
            {
                name: "childrenColumnIds",
                kind: "a",
                desc: "Ids of Column Group&#39;s children"
            },
            {
                name: "columnType",
                kind: "u",
                desc: "Table Column Group (used when Column Grouping in Table Layouts)"
            },
            {
                name: "groupId",
                kind: "s",
                desc: "Id of Column Group"
            },
            {
                name: "state",
                kind: "'expanded' | 'collapsed'",
                desc: "Expanded / Collapsed state of Column Group"
            }
        ]
    },
    TableColumnHeaderContext: {
        name: "TableColumnHeaderContext",
        kind: "I",
        desc: "Context for standard Table Layout Columns",
        props: [
            {
                name: "aggregation",
                kind: "s",
                desc: "Aggregation function of Column (optional)",
                isOpt: !0
            },
            {
                name: "columnId",
                kind: "s",
                desc: "Id of the Column"
            },
            {
                name: "columnType",
                kind: "u",
                desc: "Table Column (created in Table Layouts)"
            }
        ]
    },
    TableLayout: {
        name: "TableLayout",
        kind: "I",
        desc: "Defines a Table-based Layout",
        props: [
            {
                name: "ColumnVisibility",
                kind: "R",
                desc: "Map of Table Column Visibility",
                isOpt: !0,
                ref: "ColumnBooleanFalseMap"
            },
            {
                name: "PivotAggregationColumns",
                kind: "u",
                desc: "Pivot Aggregation Columns - must NOT be provided",
                isOpt: !0
            },
            {
                name: "PivotColumns",
                kind: "u",
                desc: "Pivot Columns - must NOT be provided",
                isOpt: !0
            },
            {
                name: "PivotExpandLevel",
                kind: "u",
                desc: "Pivot Expansions - must NOT be provided",
                isOpt: !0
            },
            {
                name: "PivotGroupedColumns",
                kind: "u",
                desc: "Pivot Group Columns - must NOT be provided",
                isOpt: !0
            },
            {
                name: "RowGroupedColumns",
                kind: "a",
                desc: "Columns which are row-grouped when the Layout is applied",
                isOpt: !0
            },
            {
                name: "RowSummaries",
                kind: "a",
                desc: "Pinned Rows that display Aggregation Info for a whole Column",
                isOpt: !0
            },
            {
                name: "TableAggregationColumns",
                kind: "R",
                desc: "Columns showing aggregated values in Grouped Rows; a record of ColumnId and aggfunc (e.g. sum) or &#39;true&#39; (to use default aggfunc)",
                isOpt: !0,
                ref: "TableAggregationColumns"
            },
            {
                name: "TableColumns",
                kind: "a",
                desc: "List of Column Ids to include in Table Layout"
            }
        ]
    },
    TableLayoutCreationDefaultProperties: {
        name: "TableLayoutCreationDefaultProperties",
        kind: "A",
        desc: "Default properties to apply when creating a new Table Layout"
    },
    TeamSharingOptions: {
        name: "TeamSharingOptions",
        kind: "I",
        desc: "Options for managing Team Sharing - which enables Adaptable Objects to be shared between colleagues",
        props: [
            {
                name: "applySharedEntities",
                kind: "u",
                desc: "Allows hooking into Shared Entities loading process",
                isOpt: !0
            },
            {
                name: "enableTeamSharing",
                kind: "b",
                desc: "Whether Team Sharing is enabled",
                gridInfo: "item",
                defVal: "false"
            },
            {
                name: "handleCustomSharedEntityImport",
                kind: "u",
                desc: "Handles import of Custom Shared Entities",
                isOpt: !0
            },
            {
                name: "loadSharedEntities",
                kind: "u",
                desc: "(Async) Loads available Shared Entities - user can download and auto-merge with Adaptable State",
                defVal: "null"
            },
            {
                name: "persistSharedEntities",
                kind: "u",
                desc: "(Async) Persists Shared Entities so that they can be downloaded by other team members",
                defVal: "null"
            },
            {
                name: "saveSharedEntities",
                kind: "u",
                desc: "Allows hooking into Shared Entities persistence process",
                isOpt: !0
            },
            {
                name: "showUpdateNotificationOncePerUpdate",
                kind: "b",
                desc: "Whether to show update notification once per update",
                isOpt: !0,
                defVal: "false"
            },
            {
                name: "suppressOverrideConfigWarning",
                kind: "b",
                desc: "Suppress warning when an Import overrides existing Adaptable State item",
                isOpt: !0,
                gridInfo: "item",
                defVal: "false"
            },
            {
                name: "updateInterval",
                kind: "n",
                desc: "Frequency (in minutes) to check if Active Shared Entities have a newer revision",
                isOpt: !0,
                gridInfo: "item",
                defVal: "0 (never)"
            },
            {
                name: "updateNotification",
                kind: "'Alert' | 'AlertWithNotification' | 'SystemStatus'",
                desc: "How user is informed when Active Shared Entities have newer revisions",
                isOpt: !0,
                gridInfo: "item",
                defVal: "null (none)"
            }
        ]
    },
    TeamSharingState: {
        name: "TeamSharingState",
        kind: "I",
        desc: "State for Team Sharing; internal so not designed to be provided as part of Initial Adaptable State",
        props: [
            {
                name: "ActiveSharedEntityMap",
                kind: "u",
                desc: "Mapping of active AdaptableObjects which are shared with the local state. Maps UUIDs of local AdaptableObjects to a snapshot of the latest synchronized SharedEntity"
            },
            {
                name: "importProcessInProgress",
                kind: "b",
                desc: "TRUE if an import is in progress, FALSE otherwise. This is required to skip the TEAMSHARING_UPDATE_ITEM action as a result of the import"
            },
            {
                name: "SharedEntities",
                kind: "a",
                desc: "List of objects currently being Team Shared"
            }
        ]
    },
    ThemeState: {
        name: "ThemeState",
        kind: "I",
        desc: "Theme section of Adaptable State",
        props: [
            {
                name: "CurrentTheme",
                kind: "u",
                desc: "Name of current theme (or theme to set at startup); leave blank if using &#39;Light Theme&#39;, set to &#39;dark&#39; for &#39;Dark Theme&#39; or provide name of Custom Theme",
                isOpt: !0
            },
            {
                name: "SystemThemes",
                kind: "u",
                desc: "Which, if any, of the 2 themes shipped by Adaptable should be available; leave unset to provide both, or an empty array to provide neither.",
                isOpt: !0
            },
            {
                name: "UserThemes",
                kind: "a",
                desc: "Custom themes (of type AdaptableTheme) provided by developers",
                isOpt: !0
            }
        ]
    },
    ToastPositions: {
        name: "ToastPositions",
        kind: "A",
        desc: "Different positions offered by Notifications"
    },
    ToastTransitions: {
        name: "ToastTransitions",
        kind: "A",
        desc: "Different transitions offered by Notifications"
    },
    Token: {
        name: "Token",
        kind: "A",
        desc: "Token used by the AdapTableQL parser"
    },
    ToolbarAction: {
        name: "ToolbarAction",
        kind: "A",
        desc: "Action available in Custom Toolbar - Close or Configure"
    },
    ToolbarActions: {
        name: "ToolbarActions",
        kind: "A",
        desc: "List of Actions available in Custom Toolbar"
    },
    ToolPanelButtonContext: {
        name: "ToolPanelButtonContext",
        kind: "I",
        desc: "Context required by functions when using a ToolPanel Button",
        props: [
            {
                name: "toolPanelState",
                kind: "R",
                desc: "Current ToolPanel State",
                ref: "ToolPanelState"
            }
        ]
    },
    ToolPanelOptions: {
        name: "ToolPanelOptions",
        kind: "I",
        desc: "Options related to managing the AdapTable ToolPanel Component",
        props: [
            {
                name: "customButtons",
                kind: "a",
                desc: "ToolPanel Buttons provided by Users which perform custom behaviour",
                isOpt: !0
            },
            {
                name: "customToolPanels",
                kind: "a",
                desc: "ToolPanels provided by Users which contain custom content",
                isOpt: !0
            },
            {
                name: "showToolPanelsDropdown",
                kind: "b",
                desc: "Display the Tool Panels dropdown",
                isOpt: !0,
                gridInfo: "item",
                noCode: "item",
                defVal: "true"
            }
        ]
    },
    ToolPanelState: {
        name: "ToolPanelState",
        kind: "I",
        desc: "Adaptable State Section for the AdapTable ToolPanel",
        props: [
            {
                name: "ModuleButtons",
                kind: "R",
                desc: "AdapTable Module Buttons visible in ToolPanel",
                isOpt: !0,
                defVal: "Empty Array",
                ref: "unknown"
            },
            {
                name: "ToolPanels",
                kind: "a",
                desc: "Adaptable Tool Panels which are viaible",
                isOpt: !0,
                defVal: "ToolPanels for all available Modules (subject to Entitlement rules)"
            }
        ]
    },
    ToolPanelVisibilityMode: {
        name: "ToolPanelVisibilityMode",
        kind: "A",
        desc: "Whether a ToolPanel displays as expanded or collapsed"
    },
    TransposeConfig: {
        name: "TransposeConfig",
        kind: "I",
        desc: "Config used when transposing a Grid",
        props: [
            {
                name: "columnsToTranspose",
                kind: "u",
                desc: "Ids of Columns to Transpose",
                isOpt: !0,
                defVal: "all Grid Columns"
            },
            {
                name: "hideTransposedColumn",
                kind: "b",
                desc: "Hide the Transposed Column",
                isOpt: !0,
                defVal: "true"
            },
            {
                name: "rowsToTranspose",
                kind: "u",
                desc: "Rows to Transpose: All, Visible or via Expression",
                isOpt: !0,
                defVal: "All"
            },
            {
                name: "transposedColumnId",
                kind: "s",
                desc: "Column to use to do Transposition",
                isOpt: !0,
                defVal: "Primary Key Column"
            }
        ]
    },
    UIControlConfig: {
        name: "UIControlConfig",
        kind: "I",
        desc: "Used to customise FDC3 controls (e.g. Action Columns)",
        props: [
            {
                name: "icon",
                kind: "R",
                desc: "Icon to display",
                isOpt: !0,
                ref: "AdaptableIcon"
            }
        ]
    },
    UniqueGridCell: {
        name: "UniqueGridCell",
        kind: "I",
        desc: "Defines a Unique Cell Value (incl. how many times it appears in Grid)",
        props: [
            {
                name: "count",
                kind: "n",
                desc: "How many times Cell appears in Data Source"
            },
            {
                name: "displayValue",
                kind: "u",
                desc: "Display value of Cell (e.g. if formatted)"
            },
            {
                name: "normalisedValue",
                kind: "u",
                desc: "Normalised value of Cell"
            },
            {
                name: "rawValue",
                kind: "u",
                desc: "Raw value of Cell"
            },
            {
                name: "visible",
                kind: "b",
                desc: "Is Cell in a currently filtered Row"
            },
            {
                name: "visibleCount",
                kind: "n",
                desc: "How many times Cell appears in filtered Rows"
            }
        ]
    },
    UpgradeConfig: {
        name: "UpgradeConfig",
        kind: "I",
        desc: "Config object used by State Auto-migration Wizard",
        props: [
            {
                name: "fromVersion",
                kind: "n",
                desc: "AdapTable version to upgrade from"
            },
            {
                name: "logger",
                kind: "R",
                desc: "The logger object",
                isOpt: !0,
                defVal: "The console object",
                ref: "unknown"
            },
            {
                name: "toVersion",
                kind: "n",
                desc: "AdapTable version to upgrade to",
                isOpt: !0,
                defVal: "The current version"
            }
        ]
    },
    UserColumnMenuItem: {
        name: "UserColumnMenuItem",
        kind: "I",
        desc: "Column Menu Item that is provided by User",
        props: [
            {
                name: "disabled",
                kind: "b",
                desc: "Whether menu item is disabled",
                isOpt: !0
            },
            {
                name: "hidden",
                kind: "b",
                desc: "Whether menu item is hidden",
                isOpt: !0
            },
            {
                name: "icon",
                kind: "R",
                desc: "Optional icon to display",
                isOpt: !0,
                ref: "AdaptableIcon"
            },
            {
                name: "label",
                kind: "s",
                desc: "Text to appear in the Menu Item"
            },
            {
                name: "menuType",
                kind: "u",
                desc: "Type of Menu - always &#39;User&#39;"
            },
            {
                name: "onClick",
                kind: "f",
                desc: "Function invoked when the Menu Item is clicked",
                isOpt: !0
            },
            {
                name: "subMenuItems",
                kind: "a",
                desc: "Array of Menu Items, enabling limitless levels of menus",
                isOpt: !0
            }
        ]
    },
    UserContextMenuItem: {
        name: "UserContextMenuItem",
        kind: "I",
        desc: "Context Menu Item that is provided by User",
        props: [
            {
                name: "disabled",
                kind: "b",
                desc: "Whether menu item is disabled",
                isOpt: !0
            },
            {
                name: "hidden",
                kind: "b",
                desc: "Whether menu item is hidden",
                isOpt: !0
            },
            {
                name: "icon",
                kind: "R",
                desc: "Optional icon to display",
                isOpt: !0,
                ref: "AdaptableIcon"
            },
            {
                name: "label",
                kind: "s",
                desc: "Text to appear in the Menu Item"
            },
            {
                name: "menuType",
                kind: "u",
                desc: "Type of Menu - always &#39;User&#39;"
            },
            {
                name: "onClick",
                kind: "f",
                desc: "Function invoked when the Menu Item is clicked",
                isOpt: !0
            },
            {
                name: "subMenuItems",
                kind: "a",
                desc: "Array of Menu Items, enabling limitless levels of menus",
                isOpt: !0
            }
        ]
    },
    UserInterfaceOptions: {
        name: "UserInterfaceOptions",
        kind: "I",
        desc: "Options for managing the User Interface of AdapTable",
        props: [
            {
                name: "alternativeModuleNames",
                kind: "a",
                desc: "Alternative names to use for Adaptable Modules in the UI",
                isOpt: !0,
                defVal: "null"
            },
            {
                name: "applicationIcon",
                kind: "R",
                desc: "The application icon to appear in Dashboard and elsewhere (e.g. in Notifications)",
                isOpt: !0,
                defVal: "null",
                ref: "AdaptableIcon"
            },
            {
                name: "colorPalette",
                kind: "u",
                desc: "Colours to display in Colour Picker (in place of AdapTable&#39;s default set); can be hardcoded list or function",
                isOpt: !0
            },
            {
                name: "customIcons",
                kind: "u",
                desc: "Bespoke icons that can be used in AdapTable (e.g. Badge Styles and Buttons)",
                isOpt: !0
            },
            {
                name: "dateInputOptions",
                kind: "R",
                desc: "Options for managing and customizing date inputs in AdapTable",
                isOpt: !0,
                ref: "DateInputOptions"
            },
            {
                name: "disableDeleteConfirmation",
                kind: "b",
                desc: "Hides confirmation dialog which displays whenever an AdaptableObject is deleted",
                isOpt: !0,
                noCode: "item",
                defVal: "false"
            },
            {
                name: "editableCellStyle",
                kind: "R",
                desc: "Style to set for editable Cells",
                isOpt: !0,
                ref: "AdaptableStyle"
            },
            {
                name: "editedCellStyle",
                kind: "R",
                desc: "Style to set for Cells which have been edited",
                isOpt: !0,
                ref: "AdaptableStyle"
            },
            {
                name: "englishVariant",
                kind: "'GB' | 'US'",
                desc: "English variant to use in AdapTable UI",
                isOpt: !0,
                gridInfo: "item",
                defVal: "&#39;GB&#39;"
            },
            {
                name: "loadingScreenOptions",
                kind: "R",
                desc: "Options for showing Loading Screen (during initialisation)",
                isOpt: !0,
                ref: "LoadingScreenOptions"
            },
            {
                name: "objectTags",
                kind: "u",
                desc: "Optional list of AdaptableObjectTags that can be associated with AdaptableObjects",
                isOpt: !0
            },
            {
                name: "readOnlyCellStyle",
                kind: "R",
                desc: "Style to set for non-editable Cells",
                isOpt: !0,
                ref: "AdaptableStyle"
            },
            {
                name: "showAdapTableVersion",
                kind: "b",
                desc: "Displays the AdapTable version in Grid Info section of Settings Panel",
                isOpt: !0,
                gridInfo: "item",
                defVal: "true"
            },
            {
                name: "showAgGridVersion",
                kind: "b",
                desc: "Displays the AG Grid version in Grid Info section of Settings Panel",
                isOpt: !0,
                gridInfo: "item",
                defVal: "true"
            },
            {
                name: "showDocumentationLinks",
                kind: "b",
                desc: "Provide links to AdapTable documentation (in Module popups and Expression Editor)",
                isOpt: !0,
                gridInfo: "item",
                defVal: "true"
            },
            {
                name: "styleClassNames",
                kind: "a",
                desc: "Optional list of CSS styles that can be used when creating Adaptable Styles in Adaptable (e.g. in Format Column and other Modules)",
                isOpt: !0,
                gridInfo: "item"
            },
            {
                name: "useCustomMacLikeScrollbars",
                kind: "b",
                desc: "Show Mac-like scrollbars; size is configurable via CSS variable `--ab-custom-scrollbar-size` (default: `10px`)",
                isOpt: !0,
                gridInfo: "item",
                defVal: "false"
            }
        ]
    },
    UserInterfaceState: {
        name: "UserInterfaceState",
        kind: "I",
        desc: "Adaptable State Section for the User Interface",
        props: [
            {
                name: "HideAdaptableUI",
                kind: "b",
                desc: "Hides all AdapTable UI elements (i.e. Dashboard, Tool Panel, Status Bar, Column &amp; Context Menus etc.)",
                isOpt: !0,
                defVal: "false"
            }
        ]
    },
    UserMenuItem: {
        name: "UserMenuItem",
        kind: "I",
        desc: "Menu Item which is added to Column or Context Menu - can contain sub items",
        props: [
            {
                name: "disabled",
                kind: "u",
                desc: "Function evaluating whether Menu Item is enabled",
                isOpt: !0
            },
            {
                name: "hidden",
                kind: "u",
                desc: "Function evaluating whether Menu Item is visible",
                isOpt: !0
            },
            {
                name: "icon",
                kind: "u",
                desc: "Optional icon to display",
                isOpt: !0
            },
            {
                name: "label",
                kind: "u",
                desc: "Text to appear in the Menu Item"
            },
            {
                name: "onClick",
                kind: "u",
                desc: "Function invoked when the Menu Item is clicked",
                isOpt: !0
            },
            {
                name: "subMenuItems",
                kind: "u",
                desc: "Array of Menu Items, enabling limitless levels of menus",
                isOpt: !0
            }
        ]
    },
    VueFrameworkComponent: {
        name: "VueFrameworkComponent",
        kind: "A",
        desc: "Creates a Vue Component to be used in AdapTable UI controls"
    },
    WeightedAverageAggregation: {
        name: "WeightedAverageAggregation",
        kind: "I",
        desc: "Defines a Weighted Average Agg",
        props: [
            {
                name: "type",
                kind: "u",
                desc: "Type is always &#39;weightedAverage&#39;"
            },
            {
                name: "weightedColumnId",
                kind: "s",
                desc: "Column which is weighted"
            }
        ]
    },
    WindowPosition: {
        name: "WindowPosition",
        kind: "I",
        desc: "Defines position of a Custom Window"
    },
    WindowSize: {
        name: "WindowSize",
        kind: "I",
        desc: "Defines size of a Custom Window"
    }
};




var $9OAZF = parcelRequire("9OAZF");


const $ec66a350fedeed6e$var$supportedMetamodelTypes = [
    's',
    'n',
    'b',
    'a',
    'f',
    'R'
];
class $ec66a350fedeed6e$export$15a16ddbf1f39b24 {
    gridInfoOptions = new Map();
    getAdaptableOptions = ()=>null;
    constructor(getAdaptableOptions, validateOptions){
        this.getAdaptableOptions = getAdaptableOptions;
        this.gridInfoOptions = this.buildGridInfoOptions();
        if (validateOptions) this.validateAdaptableOptionsValues();
    }
    getGridInfoOptions() {
        return this.gridInfoOptions;
    }
    getGridInfoNoCodeOptions() {
        return this.buildGridInfoOptions({
            filterItemProperty: (itemProperty)=>{
                return itemProperty.noCode === 'item';
            },
            filterEmptyAdaptableOptions: false
        });
    }
    validateAdaptableOptionsValues() {
        const adaptableOptionsValues = this.getAdaptableOptions();
        const adaptableOptionsMetamodel = this.getAdaptableOptionsMetamodel();
        const adaptableOptionsDefaultValues = this.getAdaptableOptionsDefaultValues();
        if (adaptableOptionsValues.adaptableId?.includes('.')) (0, $10f858c943b30cc8$export$a58502b374804b0f).consoleWarnBase("The 'AdaptableOptions.adaptableId' property should NOT include a '.' character.  We strongly recommend to remove it to avoid unexpected AdapTable behavior.");
        const validationErrors = [];
        this.validateOptionsObject(validationErrors, 'AdaptableOptions', adaptableOptionsValues, adaptableOptionsMetamodel, adaptableOptionsDefaultValues);
        if (validationErrors.length) (0, $10f858c943b30cc8$export$a58502b374804b0f).consoleWarnBase([
            'AdaptableOptions validation errors:',
            '\n',
            ...validationErrors,
            '\n',
            `See AdaptableOptions documentation at ${(0, $53c62e7ff907ad8d$export$583e39ddfce4335e)} for details`
        ].join('\n'));
    }
    validateOptionsObject(validationErrors, optionsObjectName, optionsObject, optionsObjectMetamodel, optionsObjectDefaultValues) {
        Object.entries(optionsObject).forEach(([optionKey, optionValue])=>{
            // ignore fdc3options
            if (optionKey === 'fdc3Options') return;
            const optionMetamodel = optionsObjectMetamodel?.props?.find((metamodelProperty)=>metamodelProperty.name === optionKey);
            // Return if property not found - log if not 'Revision' or 'Uuid' or 'AdaptableVersion'
            if (!optionMetamodel) {
                if (optionKey === 'Revision' || optionKey === 'Uuid' || optionKey === 'AdaptableVersion') return;
                else {
                    validationErrors.push(`${optionsObjectName}.${optionKey} (value=${optionValue}) :: unknown/unsupported property, will be ignored`);
                    return;
                }
            }
            // let's try to validate the type of the provided value
            const expectedOptionsValueType = this.getExpectedOptionsValueType(optionMetamodel);
            const providedOptionsValueType = Array.isArray(optionValue) ? 'a' : typeof optionValue;
            if (!expectedOptionsValueType) return;
            // if it's a REFERENCE, we try to go (recursively) deeper
            if (expectedOptionsValueType === 'R') {
                const referenceObjectName = optionMetamodel.ref;
                const referenceObject = optionsObject[optionKey];
                const referenceObjectMetamodel = this.getAdaptableMetamodel()[referenceObjectName];
                if (referenceObject && referenceObjectMetamodel?.kind === 'I') this.validateOptionsObject(validationErrors, referenceObjectName, referenceObject, referenceObjectMetamodel, optionsObjectDefaultValues?.[optionKey]);
            } else if ($ec66a350fedeed6e$var$supportedMetamodelTypes.includes(providedOptionsValueType) && providedOptionsValueType !== expectedOptionsValueType) validationErrors.push(`${optionsObjectName}.${optionKey} (value=${optionValue}) :: wrong type (${providedOptionsValueType}), expected ${expectedOptionsValueType}`);
        });
    }
    getExpectedOptionsValueType(metamodelProperty) {
        const metamodelPropertyKind = metamodelProperty.kind;
        if ($ec66a350fedeed6e$var$supportedMetamodelTypes.includes(metamodelPropertyKind)) return metamodelPropertyKind;
    }
    buildGridInfoOptions(options) {
        const { filterItemProperty: filterItemProperty, filterEmptyAdaptableOptions: filterEmptyAdaptableOptions = true } = options || {};
        const gridInfoOptions = new Map();
        const adaptableMetamodel = this.getAdaptableMetamodel();
        const adaptableOptionsMetamodel = this.getAdaptableOptionsMetamodel();
        const adaptableOptionsValues = this.getAdaptableOptions();
        const adaptableOptionsDefaultValues = this.getAdaptableOptionsDefaultValues();
        if (!adaptableOptionsMetamodel) // should never happen
        return gridInfoOptions;
        // root-level properties are grouped in a synthetic 'Base Options' container
        const baseOptionsItems = this.mapGridInfoContainerItems(adaptableOptionsMetamodel, adaptableOptionsValues, adaptableOptionsDefaultValues, filterItemProperty);
        gridInfoOptions.set('baseOptions', {
            containerLabel: 'Base Options',
            items: baseOptionsItems
        });
        // map containers
        adaptableOptionsMetamodel.props.filter((optionItem)=>optionItem.gridInfo === 'container').forEach((containerOptionItem)=>{
            const containerMetamodelName = containerOptionItem.ref;
            const adaptableOptionsName = containerOptionItem.name;
            const containerOptionsMetamodel = adaptableMetamodel[containerMetamodelName];
            // @ts-ignore
            const containerOptionsValues = adaptableOptionsValues[adaptableOptionsName];
            // @ts-ignore
            const containerOptionsDefaultValues = adaptableOptionsDefaultValues[adaptableOptionsName];
            if (!containerOptionsMetamodel || !containerOptionsValues && filterEmptyAdaptableOptions || !containerOptionsDefaultValues) // should never happen
            return;
            const optionItems = this.mapGridInfoContainerItems(containerOptionsMetamodel, containerOptionsValues, containerOptionsDefaultValues, filterItemProperty);
            gridInfoOptions.set(containerOptionItem.name, {
                containerLabel: this.extractUiLabel(containerOptionItem),
                items: optionItems
            });
        });
        return gridInfoOptions;
    }
    mapGridInfoContainerItems(optionItemContainer, adaptableOptionsValues, defaultAdaptableOptionsValues, filter = (itemProperty)=>itemProperty.gridInfo === 'item') {
        return optionItemContainer.props.filter(filter).map((itemProperty)=>{
            return {
                name: itemProperty.name,
                value: adaptableOptionsValues?.[itemProperty.name],
                defaultValue: defaultAdaptableOptionsValues[itemProperty.name],
                kind: itemProperty.kind,
                description: (0, $9OAZF.default).UnescapeHtmlEntities(itemProperty.desc),
                uiLabel: this.extractUiLabel(itemProperty)
            };
        });
    }
    getAdaptableOptionsDefaultValues() {
        return (0, $b7240075c75a7844$export$ae6abdb725d7cdd7)();
    }
    getAdaptableMetamodel() {
        return 0, $4c1becfc35b7f033$export$f346223056c60dbf;
    }
    getAdaptableOptionsMetamodel() {
        return this.getAdaptableMetamodel()['AdaptableOptions'];
    }
    extractUiLabel(item) {
        return item.uiLabel || this.formatCamelCaseToHumanText(item.name);
    }
    formatCamelCaseToHumanText(camelCase) {
        if (!camelCase || camelCase == null) return null;
        const rex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
        const words = camelCase.replace(rex, '$1$4 $2$3$5').replace('.', ' ').split(' ');
        return words.map((word)=>word.substring(0, 1).toUpperCase() + (word.length > 1 ? word.substring(1, word.length) : '')).join(' ');
    }
}





/**
 * Clamps number within the inclusive lower and upper bounds.
 * Drop-in replacement for lodash/clamp.
 */ function $43438b6501a58e4a$export$2e2bcd8739ae039(number, lower, upper) {
    return Math.min(Math.max(number, lower), upper);
}



const $b6f5a56a30d894cd$var$r = 3988292384;
function $b6f5a56a30d894cd$var$n(r = 3988292384) {
    var n1, t, o, u = new Array;
    for(n1 = 0; n1 < 256; n1++){
        for(o = n1, t = 8; t > 0; t--)1 & ~o ? o >>>= 1 : o = o >>> 1 ^ r;
        u[n1] = o;
    }
    return u;
}
function $b6f5a56a30d894cd$var$t() {
    return 4294967295;
}
function $b6f5a56a30d894cd$var$o(r, n, t) {
    return n = n >>> 8 ^ r[t ^ 255 & n];
}
function $b6f5a56a30d894cd$var$u(r) {
    return r = (r = ~r) < 0 ? 4294967295 + r + 1 : r;
}
function $b6f5a56a30d894cd$export$a938e7854debca8e(r, e = 3988292384) {
    var c, f = $b6f5a56a30d894cd$var$n(e), i = 0;
    for(i = $b6f5a56a30d894cd$var$t(), c = 0; c < r.length; c++)i = $b6f5a56a30d894cd$var$o(f, i, r.charCodeAt(c));
    return `${i = $b6f5a56a30d894cd$var$u(i)}`;
}


const $eac30c6d002d20cf$var$t = ()=>new Error("Invalid License");
const $eac30c6d002d20cf$export$3590324c00ad2abe = "GenericAdaptableApp";
const $eac30c6d002d20cf$export$19d4b9ea4eff7962 = (e)=>{
    const r = e.reduce((e, t)=>(e.set(t.name, t.value), e), new Map), a = {
        start: new Date(r.get("StartDate")),
        end: new Date(r.get("EndDate")),
        owner: r.get("Owner"),
        appName: r.get("AppName") || $eac30c6d002d20cf$export$3590324c00ad2abe,
        timestamp: r.get("TS") ? Number(r.get("TS")) : 0,
        trial: "true" === r.get("Trial"),
        ref: r.get("Ref") ?? ""
    };
    if (!(a.start && a.end && a.owner && "boolean" == typeof a.trial && a.ref)) throw $eac30c6d002d20cf$var$t();
    return a;
};
const $eac30c6d002d20cf$export$2f872c0f2117be69 = (r)=>{
    let a = "", n = r.split("|").map((e)=>{
        let [t, r] = e.split("=");
        return "C" === t && (a = r), {
            name: t,
            value: r
        };
    });
    if (!a) throw $eac30c6d002d20cf$var$t();
    const o = a.split(",").reverse(), s = o.pop();
    o.forEach((r, a)=>{
        const o = n[a];
        if ((0, $b6f5a56a30d894cd$export$a938e7854debca8e)(o.value) !== r) throw $eac30c6d002d20cf$var$t();
    });
    const p = [
        ...n
    ];
    p.pop();
    const i = p.map((e)=>`${e.name}=${e.value}`).join("|");
    if ((0, $b6f5a56a30d894cd$export$a938e7854debca8e)(i) !== s) throw $eac30c6d002d20cf$var$t();
    return n = n.map((e)=>({
            ...e,
            value: decodeURI(e.value)
        })), $eac30c6d002d20cf$export$19d4b9ea4eff7962(n);
};


function $6cdaea5f9f1a0a4d$export$931a5de8dff4ad3e() {
    try {
        return false;
    } catch (ex) {
        return false;
    }
}


const $10cef49c9bd5fdd1$var$c = "sales@adaptabletools.com", $10cef49c9bd5fdd1$var$p = 10, $10cef49c9bd5fdd1$var$d = 864e5;
var $10cef49c9bd5fdd1$export$1abdff75babd619a;
!function(e) {
    e.INVALID_LICENSE = "INVALID_LICENSE", e.NO_LICENSE = "NO_LICENSE", e.NON_PRODUCTION_VALID = "NON_PRODUCTION_VALID", e.NON_PRODUCTION_EXPIRED_IN_SCOPE = "NON_PRODUCTION_EXPIRED_IN_SCOPE", e.NON_PRODUCTION_EXPIRED_OUT_OF_SCOPE = "NON_PRODUCTION_EXPIRED_OUT_OF_SCOPE", e.COMMERCIAL_VALID = "COMMERCIAL_VALID", e.COMMERCIAL_EXPIRED_IN_SCOPE = "COMMERCIAL_EXPIRED_IN_SCOPE", e.COMMERCIAL_EXPIRED_OUT_OF_SCOPE = "COMMERCIAL_EXPIRED_OUT_OF_SCOPE";
}($10cef49c9bd5fdd1$export$1abdff75babd619a || ($10cef49c9bd5fdd1$export$1abdff75babd619a = {}));
const $10cef49c9bd5fdd1$var$h = ()=>"undefined" != typeof window ? window.location.origin : "", $10cef49c9bd5fdd1$var$E = ()=>{
    const e = $10cef49c9bd5fdd1$var$h(), [a, t, i] = Array.from(/(https):\/\/\d+\-\d+\-\d+\-(sandpack\.codesandbox\.io)/g.exec(e) || []);
    return "https" === t && "sandpack.codesandbox.io" === i;
}, $10cef49c9bd5fdd1$var$I = ()=>{
    const e = $10cef49c9bd5fdd1$var$h(), [a, t, i] = Array.from(/(https):\/\/\S+(\.csb\.app)/g.exec(e) || []);
    return "https" === t && ".csb.app" === i;
}, $10cef49c9bd5fdd1$var$_ = ()=>{
    const e = $10cef49c9bd5fdd1$var$h(), [a, t, i] = Array.from(/(https):\/\/\S+(\.adaptabletools\.com)/g.exec(e) || []);
    return "https" === t && ".adaptabletools.com" === i;
};
class $10cef49c9bd5fdd1$export$4bd85f9bf0db45 {
    adaptable;
    licenseKey;
    packageDetails;
    constructor(e, a, t){
        this.adaptable = e, this.licenseKey = a, this.packageDetails = t, this.adaptable = e, this.adaptable.api.eventApi.on("AdaptableReady", ()=>{
            requestAnimationFrame(()=>{
                this.adaptable.isDestroyed || this.init();
            });
        });
    }
    init() {
        let e = null;
        if (this.licenseKey) try {
            e = (0, $eac30c6d002d20cf$export$2f872c0f2117be69)(this.licenseKey);
        } catch (a) {
            e = a;
        }
        $10cef49c9bd5fdd1$var$E() || $10cef49c9bd5fdd1$var$I() || $10cef49c9bd5fdd1$var$_() || this.handleLicenseValidation(e, this.getValidityType(e, this.packageDetails));
    }
    getValidityType(e, a) {
        if (!e) return $10cef49c9bd5fdd1$export$1abdff75babd619a.NO_LICENSE;
        if (e instanceof Error) return $10cef49c9bd5fdd1$export$1abdff75babd619a.INVALID_LICENSE;
        const t = new Date(a.publishedAt), i = new Date(e.end), s = i < new Date, o = e.trial;
        let n = null;
        return n = s ? i > t ? o ? $10cef49c9bd5fdd1$export$1abdff75babd619a.NON_PRODUCTION_EXPIRED_IN_SCOPE : $10cef49c9bd5fdd1$export$1abdff75babd619a.COMMERCIAL_EXPIRED_IN_SCOPE : o ? $10cef49c9bd5fdd1$export$1abdff75babd619a.NON_PRODUCTION_EXPIRED_OUT_OF_SCOPE : $10cef49c9bd5fdd1$export$1abdff75babd619a.COMMERCIAL_EXPIRED_OUT_OF_SCOPE : o ? $10cef49c9bd5fdd1$export$1abdff75babd619a.NON_PRODUCTION_VALID : $10cef49c9bd5fdd1$export$1abdff75babd619a.COMMERCIAL_VALID, n;
    }
    handleLicenseValidation(e, a) {
        const t = new Date;
        t.setHours(0, 0, 0, 0);
        let i = 0;
        e instanceof Error || !e?.end || (i = Math.floor((e?.end?.getTime() - t.getTime()) / $10cef49c9bd5fdd1$var$d), i = (0, $43438b6501a58e4a$export$2e2bcd8739ae039)(i, 0, 1 / 0));
        let n = "", h = "";
        !e || e instanceof Error || !e.appName || e.appName == (0, $eac30c6d002d20cf$export$3590324c00ad2abe) || (n = e.appName, h = " for application [APP_NAME]");
        const E = (e, a = (0, $53c62e7ff907ad8d$export$aaffa8febb381f15), t = $10cef49c9bd5fdd1$var$c, s = i, r = n)=>e.replace("[LINK]", a).replace("[EMAIL]", t).replace("[APP_NAME]", r).replace("[DAYS]", `${s}`);
        switch(a){
            case "NO_LICENSE":
            case "NON_PRODUCTION_EXPIRED_OUT_OF_SCOPE":
                this.adaptable.logger.consoleLogByMessageType(E("This instance of AdapTable does not have a license, and some functionality has therefore been removed. In order to use a fully-featured version of AdapTable, please contact [EMAIL]. You can learn more about the different AdapTable license options at [LINK]."), "Error"), this.showNotification("No AdapTable License found."), this.showWatermark("This instance of AdapTable does not have a license, and some functionality has therefore been removed."), this.disableStatePersistence();
                break;
            case "INVALID_LICENSE":
                this.adaptable.logger.consoleLogByMessageType(E("This instance of AdapTable seems to use a corrupted License, and some functionality has therefore been removed. In order to use a fully-featured version of AdapTable, please contact [EMAIL]. You can learn more about the different AdapTable license options at [LINK]."), "Error"), this.showNotification("Corrupted AdapTable License found."), this.showWatermark("This instance of AdapTable has a corrupted License, and some functionality has therefore been removed."), this.disableStatePersistence();
                break;
            case "NON_PRODUCTION_VALID":
                this.adaptable.logger.consoleLogByMessageType(E("This AdapTable trial license expires in [DAYS] days. Please contact [EMAIL] to upgrade to a commercial version of AdapTable. You can learn more about the different AdapTable license options at [LINK]."), "Info");
                break;
            case "NON_PRODUCTION_EXPIRED_IN_SCOPE":
                this.adaptable.logger.consoleLogByMessageType(E("This AdapTable trial license has now expired. Please contact [EMAIL] to upgrade to a commercial version of AdapTable. You can learn more about the different AdapTable license options at [LINK]."), "Warning"), this.showWatermark("AdapTable License has expired");
                break;
            case "COMMERCIAL_VALID":
                if (i <= $10cef49c9bd5fdd1$var$p) this.adaptable.logger.consoleLogByMessageType(E(`This AdapTable license${h} expires in [DAYS] days.  Please contact [EMAIL] to renew (giving you access to Support and Updates)`), "Info");
                else try {
                    (0, $6cdaea5f9f1a0a4d$export$931a5de8dff4ad3e)() && this.adaptable.logger.consoleLogByMessageType(E(`Thank you for using a valid AdapTable license${h}. Your license will expire in [DAYS] days.`), "Info");
                } catch (e) {}
                break;
            case "COMMERCIAL_EXPIRED_IN_SCOPE":
                this.adaptable.logger.consoleLogByMessageType(E(`This AdapTable license${h} has expired.  Please contact [EMAIL] if you wish to renew (giving you access to Support and Updates)`), "Warning");
                break;
            case "COMMERCIAL_EXPIRED_OUT_OF_SCOPE":
                this.adaptable.logger.consoleLogByMessageType(E(`This AdapTable license${h} has expired. Adaptable version was published after the license expired. Please contact [EMAIL] if you wish to renew your license.`), "Error"), this.showNotification("Adaptable License has expired"), this.showWatermark("Adaptable License has expired");
        }
    }
    showNotification(e) {
        this.adaptable.api.internalApi.dispatchReduxAction((0, $dc56b6267ce4d0bb$export$1f102b51d7fb4f69)({
            alertType: "generic",
            header: "License Error",
            message: e,
            alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages("Error")
        }));
    }
    showWatermark(e) {
        this.adaptable.api.internalApi.dispatchReduxAction((0, $5b564bb703f29152$export$c12e15ae7dd00725)(e));
    }
    disableStatePersistence() {
        this.adaptable.api.internalApi.dispatchReduxAction((0, $5b564bb703f29152$export$452013501eb4f3bf)());
    }
    destroy() {}
}





class $6c7b22c169570458$export$e55739d890db0f9e {
    constructor(name, label, module, reduxAction, icon, isVisible){
        this.name = name;
        this.label = label;
        this.category = module;
        this.isVisible = isVisible;
        this.icon = {
            name: icon
        };
        this.reduxAction = reduxAction;
    }
    name;
    reduxAction;
    label;
    category;
    isVisible;
    icon;
}
class $6c7b22c169570458$export$65827d446e9b9df5 {
    constructor(name, label, module, clickFunction, icon, isVisible){
        this.name = name;
        this.label = label;
        this.category = module;
        this.isVisible = isVisible;
        this.icon = {
            name: icon
        };
        this.onClick = clickFunction;
    }
    name;
    onClick;
    label;
    category;
    isVisible;
    icon;
}
class $6c7b22c169570458$export$b0eb5e44ce4aa0a8 {
    constructor(name, label, module, componentName, icon, isVisible, popupParams){
        this.name = name;
        this.label = label;
        this.category = module;
        this.isVisible = isVisible;
        this.icon = {
            name: icon
        };
        this.reduxAction = $dc56b6267ce4d0bb$export$e2d5bba0b444685d(module, componentName, popupParams);
    }
    name;
    reduxAction;
    label;
    category;
    isVisible;
    icon;
}



var $9g4SS = parcelRequire("9g4SS");
class $882fe271edda834e$export$4233ed07d8ff5f4c {
    api;
    moduleInfo;
    AccessLevel;
    agGridModuleDepsInfo;
    constructor(module, friendlyName, glyph, popup, description, api){
        this.api = api;
        this.moduleInfo = {
            ModuleName: module,
            FriendlyName: this.getFriendlyName(module, friendlyName),
            Description: description,
            HelpPage: this.api.internalApi.getModuleService().getModuleDocumentationPageByModule(module),
            Glyph: glyph,
            Popup: popup
        };
        this.api = api;
        this.api.eventApi.on('AdaptableReady', ()=>{
            this.onAdaptableReady();
            this.api.stateApi.dispatchStateReadyAction(this.moduleInfo.ModuleName);
        });
        this.api.eventApi.on('AdaptableStateReloaded', (adaptableStateReloadedInfo)=>{
            this.onAdaptableStateReloaded(adaptableStateReloadedInfo);
        });
    }
    getViewAccessLevel() {
        // override where necessary (ex. only 'Full' accessLevel should be displayed)
        return 'ReadOnly';
    }
    getEditAccessLevel() {
        // override where necessary
        return 'Full';
    }
    getAgGridModuleDependencies() {
        // override where necessary
        return [];
    }
    isModuleEnabled() {
        // by default all modules are enabled; some modules may override this to check specific flags, configs, etc.
        return true;
    }
    isModuleAvailable() {
        return this.agGridModuleDepsInfo?.hasRequiredAgGridModuleDependencies;
    }
    isModuleVisible() {
        return this.isModuleEnabled() && this.isModuleAvailable() && this.hasRequiredAccessLevel(this.getViewAccessLevel());
    }
    isModuleEditable() {
        return this.isModuleEnabled() && this.isModuleAvailable() && this.hasRequiredAccessLevel(this.getEditAccessLevel());
    }
    setAgGridDepsInfo() {
        const agGridModulesAdapter = this.api.internalApi.getAgGridModulesAdapter();
        const missingAgGridModuleDependencies = this.getAgGridModuleDependencies().filter((agGridModule)=>!agGridModulesAdapter.isAgGridModuleRegistered(agGridModule));
        if (missingAgGridModuleDependencies.length) this.agGridModuleDepsInfo = {
            hasRequiredAgGridModuleDependencies: false,
            missingAgGridModuleDependencies: missingAgGridModuleDependencies
        };
        else this.agGridModuleDepsInfo = {
            hasRequiredAgGridModuleDependencies: true
        };
    }
    logMissingAgGridDepsInfos() {
        if (this.isModuleEnabled() && this.hasRequiredAccessLevel(this.getViewAccessLevel()) && !this.isModuleAvailable()) this.api.logWarn(`Module '${this.moduleInfo.ModuleName}' is not available -  missing required AG Grid modules: ${this.agGridModuleDepsInfo.missingAgGridModuleDependencies.join(', ')}`);
    }
    /**
     * Used inside the unified UI to show the share button
     */ isModuleObjectsShareable() {
        return true;
    }
    getModuleAdaptableObjects() {
        // override where necessary in base classes
        return [];
    }
    getExplicitlyReferencedColumnIds(adaptableObject) {
        // override where necessary in base classes
        return [];
    }
    getReferencedNamedQueryNames(adaptableObject) {
        // override where necessary in base classes
        return [];
    }
    hasNamedQueryReferences() {
        // override where necessary in base classes
        // this will skip the unnecessary evaluation of modules which do not have Named Query references
        return true;
    }
    onAdaptableReady() {
    // override where necessary in base classes
    }
    onAdaptableStateReloaded(adaptableStateReloadedInfo) {
    // override where necessary in base classes
    }
    setModuleEntitlement() {
        this.AccessLevel = this.api.entitlementApi.getEntitlementAccessLevelForModule(this.moduleInfo.ModuleName);
    }
    createModuleMenuItem(source) {
        if (this.isModuleVisible() && this.moduleInfo.Popup) {
            const moduleParams = {
                source: source,
                maxWidth: this.getPopupMaxWidth()
            };
            return this.createMainMenuItemShowPopup({
                Name: '_navbar',
                Label: this.moduleInfo.FriendlyName,
                ComponentName: this.moduleInfo.Popup,
                Icon: this.moduleInfo.Glyph,
                PopupParams: moduleParams
            });
        }
    }
    createColumnMenuItems(column) {
        // base class implementation which is empty
        return undefined;
    }
    createContextMenuItems(menuContext) {
        // base class implementation which is empty
        return undefined;
    }
    // creates the module menu items in the navbar
    createMainMenuItemShowPopup({ Name: Name, Label: Label, ComponentName: ComponentName, Icon: Icon, PopupParams: PopupParams }) {
        return new (0, $6c7b22c169570458$export$b0eb5e44ce4aa0a8)(Name, Label, this.moduleInfo.ModuleName, ComponentName, Icon, true, PopupParams);
    }
    // creates a menu item for the column menu to perform a function
    createMenuItemClickFunction(Name, Label, Icon, ClickFunction) {
        return new (0, $6c7b22c169570458$export$65827d446e9b9df5)(Name, Label, this.moduleInfo.ModuleName, ClickFunction, Icon, true);
    }
    // creates a menu item for the column menu to enact a Redux action
    createMenuItemReduxAction(Name, Label, Icon, Action) {
        return new (0, $6c7b22c169570458$export$e55739d890db0f9e)(Name, Label, this.moduleInfo.ModuleName, Action, Icon, true);
    }
    // popups called by the column menu - invisible if module is hidden or readonly
    createMenuItemShowPopup(Name, Label, ComponentName, Icon, PopupParams) {
        return new (0, $6c7b22c169570458$export$b0eb5e44ce4aa0a8)(Name, Label, this.moduleInfo.ModuleName, ComponentName, Icon, true, PopupParams);
    }
    getTeamSharingAction() {
        return undefined;
    }
    getModuleNamedQueryReferences() {
        if (!this.hasNamedQueryReferences()) return [];
        const references = [];
        this.getModuleAdaptableObjects().forEach((adaptableObject)=>references.push(...this.getReferencedNamedQueryNames(adaptableObject)));
        return references;
    }
    getModuleCalculatedColumnReferences() {
        const references = [];
        const allCalculatedColumns = this.api.calculatedColumnApi.getCalculatedColumns();
        this.getModuleAdaptableObjects().forEach((adaptableObject)=>{
            const referencedColumnIds = this.getExplicitlyReferencedColumnIds(adaptableObject);
            referencedColumnIds.forEach((referencedColumnId)=>{
                // check for calculated column
                const referencedCalculatedColumn = allCalculatedColumns.find((calculatedColumn)=>calculatedColumn.ColumnId === referencedColumnId);
                if (referencedCalculatedColumn) references.push(referencedCalculatedColumn);
            });
        });
        return references;
    }
    getModuleFreeTextColumnReferences() {
        const references = [];
        const allFreeTextColumns = this.api.freeTextColumnApi.getFreeTextColumns();
        this.getModuleAdaptableObjects().forEach((adaptableObject)=>{
            const referencedColumnIds = this.getExplicitlyReferencedColumnIds(adaptableObject);
            referencedColumnIds.forEach((referencedColumnId)=>{
                // check for calculated column
                const referencedFreeTextColumn = allFreeTextColumns.find((freeTextColumn)=>freeTextColumn.ColumnId === referencedColumnId);
                if (referencedFreeTextColumn) references.push(referencedFreeTextColumn);
            });
        });
        return references;
    }
    getTeamSharingReferences(adaptableObject) {
        const result = [];
        // extract special column references
        const referencedColumnIds = this.getExplicitlyReferencedColumnIds(adaptableObject);
        if (referencedColumnIds.length) {
            const allCalculatedColumns = this.api.calculatedColumnApi.getCalculatedColumns();
            const allFreeTextColumns = this.api.freeTextColumnApi.getFreeTextColumns();
            referencedColumnIds.forEach((referencedColumnId)=>{
                // check for calculated column
                const referencedCalculatedColumn = allCalculatedColumns.find((calculatedColumn)=>calculatedColumn.ColumnId === referencedColumnId);
                if (referencedCalculatedColumn) result.push({
                    Module: 'CalculatedColumn',
                    Reference: referencedCalculatedColumn
                });
                // check for freeText column
                const referencedFreeTextColumn = !referencedCalculatedColumn && allFreeTextColumns.find((freeTextColumn)=>freeTextColumn.ColumnId === referencedColumnId);
                if (referencedFreeTextColumn) result.push({
                    Module: 'FreeTextColumn',
                    Reference: referencedFreeTextColumn
                });
            });
        }
        // extract Named Query references
        const referencedNamedQueries = this.getReferencedNamedQueryNames(adaptableObject).map((namedQueryName)=>this.api.namedQueryApi.getNamedQueryByName(namedQueryName));
        referencedNamedQueries.forEach((referencedNamedQuery)=>{
            result.push({
                Module: 'NamedQuery',
                Reference: referencedNamedQuery
            });
        });
        return result;
    }
    getPopupMaxWidth() {
        // override where necessary in base classes
        // it allows every module to define a specific popup width
        return undefined;
    }
    /**
     * TRUE for objects of type {@link LayoutExtensionObject}
     */ containsLayoutExtensions() {
        return false;
    }
    showLayoutNonExtendedObjects() {
        return this.api.layoutApi.internalApi.showLayoutNonExtendedObjects();
    }
    getFriendlyName(module, friendlyName) {
        let returnValue = friendlyName;
        let userInterfaceOptions = this.api.optionsApi.getUserInterfaceOptions();
        if (userInterfaceOptions && (0, $9g4SS.default).IsNotNullOrEmpty(userInterfaceOptions.alternativeModuleNames)) userInterfaceOptions.alternativeModuleNames.forEach((af)=>{
            if (module == af.adaptableModule) returnValue = af.newName;
        });
        return returnValue;
    }
    hasRequiredAccessLevel(requiredAccessLevel) {
        if (this.AccessLevel === 'Hidden') return false;
        if (requiredAccessLevel === 'ReadOnly') return this.AccessLevel === 'ReadOnly' || this.AccessLevel === 'Full';
        if (requiredAccessLevel === 'Full') return this.AccessLevel === 'Full';
        // else requiredAccessLevel === 'Hidden' -- does NOT make sense unless a Module is programmatically disabled
        return false;
    }
}





var $9g4SS = parcelRequire("9g4SS");
class $636f4a55659b8ab7$export$50e1859f8e9b5fbb extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$b74b667f10548947, $42e863194fcb493f$export$9db043cbf8b89a1, 'dashboard', 'DashboardPopup', 'The Dashboard - usually placed above the Grid - is designed to provide quick access to commonly required AdapTable functionalty', api);
    }
    onAdaptableReady() {
        // we used to create a default tab here but we no longer do // this.api.internalApi.setDefaultDashboardTab();
        // this handler reacts to the 'AdaptableReady' event,
        // but so do all the other possible handlers of the 'DashboardChanged' event
        // therefore, we give them a head start to subscribe to 'DashboardChanged' before emitting it
        setTimeout(()=>{
            if (this.api.isDestroyed()) return;
            this.api.eventApi.internalApi.fireDashboardChangedEvent('ADAPTABLE_READY', null, this.api.dashboardApi.getDashboardState());
        }, 20);
    }
    createColumnMenuItems() {
        return this.buildMenuItems();
    }
    createContextMenuItems(menuContext) {
        return this.buildMenuItems();
    }
    buildMenuItems() {
        if (this.isModuleVisible()) {
            let menuItems = [];
            const dashboardState = this.api.dashboardApi.getDashboardState();
            if (this.isModuleEditable()) menuItems.push(this.createMenuItemClickFunction('dashboard-configure', 'Configure', 'settings', ()=>this.api.dashboardApi.openDashboardSettingsPanel()));
            if ((0, $9g4SS.default).IsNotNullOrEmpty(dashboardState.Tabs)) {
                if (dashboardState.IsCollapsed) menuItems.push(this.createMenuItemReduxAction('dashboard-expand', 'Expand', 'expand', $dc6bc6f406d56c84$export$4a9fdbf5568e83b6(false)));
                else menuItems.push(this.createMenuItemReduxAction('dashboard-collapse', 'Collapse', 'collapse', $dc6bc6f406d56c84$export$4a9fdbf5568e83b6(true)));
            }
            if (dashboardState.IsFloating) menuItems.push(this.createMenuItemReduxAction('dashboard-dock', 'Dock', 'dock', $dc6bc6f406d56c84$export$d83abcde9deec805(false)));
            else if (this.api.optionsApi.getDashboardOptions().canFloat) menuItems.push(this.createMenuItemReduxAction('dashboard-float', 'Float', 'dock', $dc6bc6f406d56c84$export$d83abcde9deec805(true)));
            if (dashboardState.IsHidden) menuItems.push(this.createMenuItemReduxAction('dashboard-show', 'Show', 'visibility-on-bold', $dc6bc6f406d56c84$export$b2de5be7510594c1(false)));
            else menuItems.push(this.createMenuItemReduxAction('dashboard-hide', 'Hide', 'visibility-off-bold', $dc6bc6f406d56c84$export$b2de5be7510594c1(true)));
            return menuItems;
        }
    }
}







var $9g4SS = parcelRequire("9g4SS");

var $acw62 = parcelRequire("acw62");


const $52125728d99aa873$export$287b3702a135396b = (object, api)=>{
    if (!api.internalApi.shouldDisplayTagSections() || !object?.Tags?.length) return;
    const currentLayoutName = api.layoutApi.getCurrentLayoutName();
    const hasCurrentLayoutAsTag = (object?.Tags ?? [])?.includes(currentLayoutName);
    return {
        name: 'Tags',
        values: object?.Tags?.map((tag)=>api.internalApi.getLabelForTag(tag)),
        viewAfter: (props)=>{
            const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
            const viewOptions = props.module.getViewProperties();
            const handleToggleTag = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
                let tags = props.data.Tags ?? [];
                if (hasCurrentLayoutAsTag) // remove layout
                tags = tags.filter((tag)=>tag !== currentLayoutName);
                else tags.push(currentLayoutName);
                const newObject = {
                    ...props.data,
                    Tags: tags
                };
                const editAction = viewOptions.getEditAction(newObject);
                dispatch(editAction);
            }, [
                hasCurrentLayoutAsTag,
                props.data
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
                onClick: handleToggleTag,
                className: "twa:mt-1",
                icon: hasCurrentLayoutAsTag ? 'minus' : 'plus'
            }, hasCurrentLayoutAsTag ? 'Remove from Layout' : 'Add to Layout');
        }
    };
};


const $60b27da1c4a88498$export$43359c935e54e9f1 = (rule, api)=>{
    return {
        name: 'Condition',
        values: [
            rule?.Predicates?.length ? rule?.Predicates?.map((predicate)=>api.predicateApi.predicateToString(predicate)).join(' AND ') : api.internalApi.getAdaptableQueryExpressionText(rule) ?? 'No condition'
        ]
    };
};



var $9OAZF = parcelRequire("9OAZF");
const $01403ab2be951cf5$export$4abcb9ed8272134c = (scope, api)=>{
    let values = [];
    if ('ColumnIds' in scope && Array.isArray(scope.ColumnIds)) {
        values = scope.ColumnIds;
        values = scope.ColumnIds.map((columnId)=>api.columnApi.getFriendlyNameForColumnId(columnId)).filter(Boolean);
    }
    if ('DataTypes' in scope) values = scope.DataTypes.map((d)=>{
        return 'Data Type: ' + (0, $9OAZF.default).CapitaliseFirstLetter(d);
    });
    if ('All' in scope) values = [
        'All Columns'
    ];
    if ('ColumnTypes' in scope) values = scope.ColumnTypes;
    return {
        label: 'Columns',
        name: 'Target',
        values: values
    };
};



var $acw62 = parcelRequire("acw62");


var $5aWMQ = parcelRequire("5aWMQ");

const $eccf16a0d7054b23$export$99b96388c12e4448 = (props)=>{
    const iconColor = (0, $5aWMQ.default).getColorByMessageType(props.data.alertDefinition.MessageType);
    const iconStyle = {
        color: iconColor,
        fill: iconColor
    };
    const iconName = (0, $5aWMQ.default).getGlyphByMessageType(props.data.alertDefinition.MessageType);
    const IconCmp = (0, $124c9aa27215a392$export$6aa6ecf6e8a98784)[iconName];
    const icon = IconCmp ? $acw62.createElement(IconCmp, null) : null;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:float-left",
        style: iconStyle
    }, icon), props.data.header);
};



var $acw62 = parcelRequire("acw62");

const $6696f2ec252fc59b$export$c6d3446570aef7d1 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const accessLevel = adaptable.api.entitlementApi.getEntitlementAccessLevelForModule(props.module.moduleInfo.ModuleName);
    const text = accessLevel == 'ReadOnly' ? 'You have no Alert Definitions.' : "Click 'New' to create a new Alert Definition - this will include the Rule which triggers the Alert, and the behaviour of the Alert.";
    return $acw62.createElement($acw62.Fragment, null, text);
};



var $acw62 = parcelRequire("acw62");



var $5aWMQ = parcelRequire("5aWMQ");
const $f0dfcbaaec308d70$export$7ee14007d4852d6 = (alerts)=>{
    const messageType = (0, $5aWMQ.default).getMessageTypeFromAdaptableAlerts(alerts);
    const messageTypeColor = (0, $5aWMQ.default).getColorByMessageType(messageType);
    const buttonBackground = (0, $5aWMQ.default).getButtonColourForAdaptableAlerts(alerts, messageTypeColor);
    const buttonTextColor = (0, $5aWMQ.default).getButtonTextColourForArrayandMessageType(alerts, messageType);
    let cssClasses = '';
    if (alerts?.length) {
        const cssMessageType = (0, $5aWMQ.default).getCSSColorByMessageType(messageType);
        cssClasses = cssMessageType ? `twa:bg-${cssMessageType} twa:text-text-on-${cssMessageType}` : '';
    }
    return {
        color: buttonTextColor,
        background: buttonBackground,
        cssClasses: cssClasses
    };
};



var $acw62 = parcelRequire("acw62");


var $9g4SS = parcelRequire("9g4SS");

var $acw62 = parcelRequire("acw62");

var $9OAZF = parcelRequire("9OAZF");

var $5aWMQ = parcelRequire("5aWMQ");




class $e0f4084337386050$export$9d50a40845f09423 extends $acw62.Component {
    render() {
        let messageType = this.props.MessageType != null ? this.props.MessageType : 'Info';
        const showIcon = this.props.showIcon ?? true;
        let useButton = this.props.useButton != null ? this.props.useButton : false;
        let popoverMinWidth = this.props.popoverMinWidth != null ? this.props.popoverMinWidth.toString() + 'px' : 'auto';
        const title = (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(this.props.headerText) ? this.props.headerText : '';
        const popoverClickRootClose = $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "ab-Popover",
            style: {
                margin: '0px',
                padding: '0px',
                minWidth: popoverMinWidth,
                maxWidth: this.props.popoverMaxWidth ?? 300
            }
        }, title ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:text-4 twa:p-2"
        }, title) : null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: `ab-Popover__body ${(this.props.popupPadding ?? 2) === 0 ? 'twa:p-0' : 'twa:p-2'}`
        }, this.props.bodyText.map((textOrHTML, index)=>$acw62.createElement("span", {
                key: index
            }, textOrHTML))));
        const icon = 'info'; // - think this is wrong - UIHelper.getGlyphByMessageType(messageType);
        const color = (0, $5aWMQ.UIHelper).getColorByMessageType(messageType);
        const iconStyle = {
            color: color,
            fill: 'currentColor'
        };
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center",
            className: this.props.className
        }, $acw62.createElement((0, $c9ce1fb924ab724e$export$2e2bcd8739ae039), {
            // showTriangle
            visible: this.props.visible,
            render: ()=>popoverClickRootClose,
            showEvent: this.props.showEvent || 'mouseenter',
            hideEvent: this.props.hideEvent || 'mouseleave',
            style: {
                overflow: 'visible'
            },
            alignPosition: this.props.alignPosition
        }, useButton ? $acw62.createElement((0, $00c4532606fa3d4c$export$5a2ee34a0d054ab8), {
            style: iconStyle,
            variant: "text",
            onClick: ()=>null,
            icon: showIcon && icon,
            tooltip: this.props.tooltipText,
            disabled: this.props.disabled
        }, this.props.children) : $acw62.createElement("div", {
            title: this.props.tooltipText,
            tabIndex: 0,
            style: {
                cursor: 'pointer',
                display: 'inline-block'
            }
        }, this.props.children, showIcon && $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
            name: icon,
            style: iconStyle
        }))));
    }
}




const $c3c8f1b03eab6873$export$6e0a8a81c9521e24 = (props)=>{
    const { icon: icon, content: content, popover: popover, popoverMinWidth: popoverMinWidth, view: view, onAction: onAction, extraActions: extraActions, triggerActionOnWrapperClick: triggerActionOnWrapperClick = true, tooltip: tooltip, ...flexProps } = props;
    const handleAction = ()=>onAction();
    if (view) {
        const View = view;
        return $acw62.createElement(View, null);
    }
    const baseClassName = 'ab-StatusBar__SubPanel';
    const handleIconClick = $acw62.useCallback(()=>{
        handleAction();
    }, []);
    const shouldTriggerActionOnWrapperClick = triggerActionOnWrapperClick && !popover;
    const handleWrapperClick = $acw62.useCallback(()=>{
        // handle action only if there is no popover
        if (shouldTriggerActionOnWrapperClick) handleAction();
    }, [
        popover,
        triggerActionOnWrapperClick
    ]);
    // popover
    const popoverContent = typeof popover === 'function' ? $acw62.createElement(popover) : popover;
    const preparedContent = typeof content === 'function' ? $acw62.createElement(content) : content;
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        ...flexProps,
        alignItems: "center",
        justifyContent: "center",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(baseClassName, flexProps.className, shouldTriggerActionOnWrapperClick ? 'twa:cursor-pointer' : 'twa:cursor-default'),
        onClick: handleWrapperClick
    }, props.icon && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        tooltip: tooltip,
        color: props.color,
        icon: props.icon,
        iconSize: 15,
        variant: "text",
        onClick: handleIconClick,
        className: preparedContent ? 'twa:mr-1' : 'twa:mr-0'
    }), popover ? $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
        alignPosition: [
            [
                'BottomCenter',
                'TopCenter'
            ]
        ],
        tooltipText: tooltip,
        showIcon: false,
        bodyText: [
            popoverContent
        ],
        MessageType: 'Info',
        showEvent: 'focus',
        hideEvent: "blur",
        popoverMinWidth: popoverMinWidth
    }, preparedContent) : preparedContent, (0, $9g4SS.default).IsNotNullOrEmpty(extraActions) && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-1"
    }, extraActions?.map?.((action, index)=>$acw62.createElement(action, {
            key: index
        }))));
};




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





const $6ebf50161baa0070$var$baseClassName = 'ab-Adaptable-Object-Compact-List';
const $6ebf50161baa0070$var$ICON_SIZE = 20;
const $6ebf50161baa0070$export$bc5a47aef6fc743 = (props)=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const objectView = props.module.toViewCompact(props.abObject);
    const viewOptions = props.module?.getViewProperties?.();
    const deleteAction = viewOptions?.getCompactDeleteAction?.(props.abObject);
    const moduleAccessLevel = adaptable.api.entitlementApi.getEntitlementAccessLevelForModule(props.module.moduleInfo.ModuleName);
    const suspendAction = viewOptions?.getCompactSuspendAction?.(props.abObject);
    const unSuspendAction = viewOptions?.getCompactUnSuspendAction?.(props.abObject);
    const isSuspended = props.abObject.IsSuspended;
    const handleDelete = $acw62.useCallback((event)=>{
        event.stopPropagation();
        event.preventDefault();
        dispatch(deleteAction);
    }, []);
    const handleSuspendUnSuspend = $acw62.useCallback((event)=>{
        event.stopPropagation();
        event.preventDefault();
        if (isSuspended) dispatch(unSuspendAction);
        else dispatch(suspendAction);
    }, [
        props.abObject
    ]);
    let labelEl = objectView.item.label;
    if (typeof labelEl === 'function') labelEl = $acw62.createElement(labelEl, {
        data: props.abObject
    });
    labelEl = labelEl ?? objectView.item.name;
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: `${$6ebf50161baa0070$var$baseClassName}__Item`,
        alignItems: "center"
    }, labelEl && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: `${$6ebf50161baa0070$var$baseClassName}__Item__Name twa:flex-[1_1_auto]`
    }, labelEl), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-[2_1_auto]"
    }, typeof objectView.item.view === 'function' ? $acw62.createElement(objectView.item.view, {
        data: props.abObject
    }) : objectView.item.view, Boolean(objectView.item?.values && objectView.item?.values?.length) && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: `${$6ebf50161baa0070$var$baseClassName}__Item__Values`
    }, $acw62.createElement((0, $3283d8fe16778b21$export$f9fef0f55402315b), {
        tags: objectView.item.values.map(String)
    }))), suspendAction && unSuspendAction && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onMouseDown: handleSuspendUnSuspend,
        tone: isSuspended ? 'neutral' : 'success',
        variant: "text",
        icon: isSuspended ? 'resume' : 'pause'
    }), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:ml-1 twa:flex-[0_0_auto]"
    }, deleteAction && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        iconSize: $6ebf50161baa0070$var$ICON_SIZE,
        icon: "delete",
        variant: "text",
        onMouseDown: handleDelete,
        accessLevel: moduleAccessLevel
    })));
};
const $6ebf50161baa0070$export$ac46f509dad8a7e8 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const viewProperties = props.module.getViewProperties?.();
    const deleteAllAction = viewProperties?.getDeleteAllAction?.();
    const suspendAllAction = viewProperties?.getSuspendAllAction?.();
    const unSuspendAllAction = viewProperties?.getUnSuspendAllAction?.();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const accessLevel = adaptable.api.entitlementApi.getEntitlementAccessLevelForModule(props.module.moduleInfo.ModuleName);
    const isAtLeastOneAbObjectActive = props.abObjects.some((abObject)=>{
        return !abObject.IsSuspended;
    });
    const handleSuspendUnsuspendAll = $acw62.useCallback((event)=>{
        event.stopPropagation();
        event.preventDefault();
        if (isAtLeastOneAbObjectActive) dispatch(suspendAllAction);
        else dispatch(unSuspendAllAction);
    }, [
        isAtLeastOneAbObjectActive
    ]);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: $6ebf50161baa0070$var$baseClassName
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: `${$6ebf50161baa0070$var$baseClassName}__Header twa:text-3`
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: `${$6ebf50161baa0070$var$baseClassName}__Title`,
        alignItems: 'center'
    }, props.module.moduleInfo.FriendlyName), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }), suspendAllAction && unSuspendAllAction && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        className: "twa:mr-2",
        onMouseDown: handleSuspendUnsuspendAll,
        tone: isAtLeastOneAbObjectActive ? 'neutral' : 'success',
        variant: "raised",
        icon: isAtLeastOneAbObjectActive ? 'pause' : 'resume',
        accessLevel: accessLevel
    }, isAtLeastOneAbObjectActive ? 'Suspend All' : 'Unsuspend All'), deleteAllAction && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onMouseDown: ()=>dispatch(deleteAllAction),
        variant: "raised",
        tone: "neutral",
        accessLevel: accessLevel
    }, "Clear All")), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: `${$6ebf50161baa0070$var$baseClassName}__Body`
    }, props.abObjects.map((abObject)=>{
        return $acw62.createElement($6ebf50161baa0070$export$bc5a47aef6fc743, {
            key: abObject.Uuid,
            abObject: abObject,
            module: props.module
        });
    })));
};



const $d307fa676f2a25b1$export$71257f160d78693e = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const filterModule = adaptable.ModuleService.getModuleById($42e863194fcb493f$export$40024cb74c2bb550);
    const alerts = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Internal.AdaptableAlerts);
    // map the suspended property from the underlying AlertDefinitions
    alerts.forEach((alert)=>{
        const liveAlertDef = adaptable.api.alertApi.getAlertDefinitionById(alert.alertDefinition.Uuid);
        if (liveAlertDef) // @ts-ignore theoretically AdaptableAlert is not Suspendable; practically <AdaptableObjectCompactList> expects it
        alert.IsSuspended = liveAlertDef.IsSuspended;
    });
    return $acw62.createElement((0, $6ebf50161baa0070$export$ac46f509dad8a7e8), {
        abObjects: alerts,
        module: filterModule
    });
};


const $3b7de478f21fae28$var$initialStyle = {
    color: '',
    background: ''
};
const $3b7de478f21fae28$export$bbbe66505753251b = ()=>{
    const adaptableApi = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)().api;
    const [style, setStyle] = $acw62.useState($3b7de478f21fae28$var$initialStyle);
    const module = adaptableApi.internalApi.getModuleService().getModuleById($42e863194fcb493f$export$40024cb74c2bb550);
    const statusbarHighlightDuration = adaptableApi.optionsApi.getAlertOptions().statusbarHighlightDuration;
    /**
     * Using a selector to so the component updates each time an alert is triggered.
     */ const alerts = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Internal.AdaptableAlerts);
    const text = alerts.length == 0 ? '0 Alerts' : alerts.length == 1 ? '1 Alert' : alerts.length + ' Alerts';
    const handleAction = $acw62.useCallback(()=>adaptableApi.alertApi.openAlertSettingsPanel(), []);
    // blinking logic
    const previousAlerts = $acw62.useRef(alerts);
    const timeoutId = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        const noNewAlerts = previousAlerts.current.length === alerts.length;
        previousAlerts.current = alerts;
        if (!alerts.length) return;
        if (noNewAlerts) return;
        const { color: color, background: background } = (0, $f0dfcbaaec308d70$export$7ee14007d4852d6)(alerts);
        setStyle({
            color: color,
            background: background
        });
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
            timeoutId.current = null;
        }
        /**
         * Cannot clear timeout in the useEffect cleanup function, because this logic is not
         * called for each case. e.g. it is skipped for when alerts are not added.
         */ timeoutId.current = setTimeout(()=>{
            setStyle($3b7de478f21fae28$var$initialStyle);
        }, statusbarHighlightDuration);
    }, [
        alerts
    ]);
    let alertsPanel = $acw62.createElement((0, $d307fa676f2a25b1$export$71257f160d78693e), null);
    return $acw62.createElement((0, $c3c8f1b03eab6873$export$6e0a8a81c9521e24), {
        tooltip: module.moduleInfo.ModuleName,
        "data-name": module.moduleInfo.ModuleName,
        style: {
            backgroundColor: style.background,
            color: style.color
        },
        onAction: handleAction,
        icon: module.moduleInfo.Glyph,
        popover: alerts.length ? alertsPanel : null,
        content: text
    });
};



var $2ce1445b81dc66ec$export$5b4a8869eb24d061;
(function(AlertType) {
    AlertType["DataChange"] = "DataChange";
    AlertType["Validation"] = "Validation";
    AlertType["RowChange"] = "RowChange";
    AlertType["Aggregation"] = "Aggregation";
    AlertType["Observable"] = "Observable";
})($2ce1445b81dc66ec$export$5b4a8869eb24d061 || ($2ce1445b81dc66ec$export$5b4a8869eb24d061 = {}));
const $2ce1445b81dc66ec$export$9d1c84ef9916433c = (alert)=>{
    if (alert.Rule.ObservableExpression) {
        if (alert.Rule.ObservableExpression.includes((0, $58846ea7f4156db7$export$91649df232e67626)) || alert.Rule.ObservableExpression.includes((0, $58846ea7f4156db7$export$b6627549cf8ad25d))) return $2ce1445b81dc66ec$export$5b4a8869eb24d061.RowChange;
        return $2ce1445b81dc66ec$export$5b4a8869eb24d061.Observable;
    }
    if (alert.Rule.AggregatedBooleanExpression) return $2ce1445b81dc66ec$export$5b4a8869eb24d061.Aggregation;
    if (alert.Rule.BooleanExpression) {
        if (alert.AlertProperties?.PreventEdit) return $2ce1445b81dc66ec$export$5b4a8869eb24d061.Validation;
        return $2ce1445b81dc66ec$export$5b4a8869eb24d061.DataChange;
    }
    const predicates = alert.Rule.Predicates;
    if (predicates) return alert.AlertProperties?.PreventEdit ? $2ce1445b81dc66ec$export$5b4a8869eb24d061.Validation : $2ce1445b81dc66ec$export$5b4a8869eb24d061.DataChange;
    // the object is not a valid alert
    return null;
};
const $2ce1445b81dc66ec$export$54be866b9f5db346 = (alertType)=>{
    let text = '';
    switch(alertType){
        case $2ce1445b81dc66ec$export$5b4a8869eb24d061.DataChange:
            text = 'Data Change';
            break;
        case $2ce1445b81dc66ec$export$5b4a8869eb24d061.Validation:
            text = 'Data Validation';
            break;
        case $2ce1445b81dc66ec$export$5b4a8869eb24d061.RowChange:
            text = 'Row Change';
            break;
        case $2ce1445b81dc66ec$export$5b4a8869eb24d061.Aggregation:
            text = 'Aggregation';
            break;
        case $2ce1445b81dc66ec$export$5b4a8869eb24d061.Observable:
            text = 'Observable';
            break;
    }
    return text;
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");




const $3c733dd7e3e38510$export$97c02de5f74f3224 = ()=>{
    const globalObject = typeof globalThis !== 'undefined' ? globalThis : window;
    return /(Mac|iPhone|iPod|iPad)/i.test(globalObject.navigator.platform);
};



var $acw62 = parcelRequire("acw62");


const $914e6624a1f38835$export$65fb1b893b7011dc = (props)=>{
    const cls = (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:text-1 twa:text-inputcolor', props.className);
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: cls
    });
};






var $acw62 = parcelRequire("acw62");
const $dd2e96645beb7721$export$4da28cf324280418 = (setCurrentSection, sections)=>{
    const handleKeyPress = $acw62.useCallback((event)=>{
        if (// (event.ctrlKey || event.metaKey) &&
        event.code === 'ArrowUp' || event.code === 'ArrowDown') {
            event.preventDefault();
            event.stopPropagation();
            const isKeyUp = event.code === 'ArrowUp';
            const validIndexes = sections.reduce((acc, item, index)=>{
                if (item !== '-') acc.push(index);
                return acc;
            }, []);
            setCurrentSection((currentActiveSection)=>{
                let nextActiveSection = null;
                const currentActiveInList = validIndexes.indexOf(currentActiveSection);
                if (isKeyUp) {
                    const candidate = validIndexes[currentActiveInList - 1];
                    nextActiveSection = typeof candidate === 'number' ? candidate : validIndexes[validIndexes.length - 1];
                } else {
                    const candidate = validIndexes[currentActiveInList + 1];
                    nextActiveSection = typeof candidate === 'number' ? candidate : validIndexes[0];
                }
                return nextActiveSection;
            });
        }
    }, [
        sections,
        setCurrentSection
    ]);
    return handleKeyPress;
};





const $16482cb6c18088bf$export$b13861a6b1e8b638 = (props)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props
    });
const $16482cb6c18088bf$export$4cb8a4f7658891b3 = (props)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:text-2 twa:mb-3', props.className)
    });
const $16482cb6c18088bf$export$dd180a7fd9107bd4 = (props)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:text-2 twa:mt-1', props.className)
    });
const $16482cb6c18088bf$export$b25b81c847b0e769 = $acw62.createContext({
    data: null,
    sections: [],
    setCurrentSection: (index)=>{}
});
function $16482cb6c18088bf$export$fd9424726448f440() {
    return $acw62.useContext($16482cb6c18088bf$export$b25b81c847b0e769);
}
const $16482cb6c18088bf$export$6d2e999e122179b5 = (props)=>{
    let defaultCurrentIndex = 0;
    const [currentSection, setCurrentSection] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'currentIndex', defaultCurrentIndex, {
        onChange: (index)=>{
            props.onSectionChange?.(index);
        }
    });
    const contextValue = {
        data: props.data,
        sections: props.sections,
        setCurrentSection: setCurrentSection
    };
    const visibleSections = $acw62.useMemo(()=>{
        return props.sections.filter(Boolean).filter((section)=>section === '-' || section.isVisible == undefined || section.isVisible(props.data, contextValue));
    }, [
        props.sections
    ]);
    contextValue.sections = visibleSections;
    $acw62.useEffect(()=>{
        if (props.defaultCurrentSectionName) {
            const candidate = visibleSections.findIndex((section)=>section !== '-' && section?.title === props.defaultCurrentSectionName);
            if (candidate >= 0) setCurrentSection(candidate);
        }
    }, [
        props.defaultCurrentSectionName,
        visibleSections
    ]);
    const [namedQuery, setNamedQuery] = (0, $acw62.useState)(false);
    const [navIndexMap] = (0, $acw62.useState)(()=>new Map());
    const handleClickFinish = ()=>{
        props.onFinish?.(props.data);
    };
    const renderSection = (index)=>{
        const section = visibleSections[index];
        if (section === '-') return $acw62.createElement($acw62.Fragment, {
            key: index
        });
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "column",
            key: index,
            "data-name": `section-${index}`,
            className: "twa:min-h-full twa:mr-2"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "ab-OnePageWizard__details twa:text-4 twa:py-3 twa:pl-2"
        }, section.details), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "ab-OnePageWizard__section twa:flex-1 twa:rounded-standard twa:overflow-auto twa:bg-defaultbackground"
        }, section.render(props.data, index)));
    };
    const handleNavigation = (0, $dd2e96645beb7721$export$4da28cf324280418)(setCurrentSection, visibleSections);
    const selectedNodeRef = (0, $acw62.useRef)(null);
    const selectedFeedback = $acw62.createElement("div", {
        ref: selectedNodeRef,
        onKeyDown: (event)=>handleNavigation(event),
        tabIndex: 0,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-OnePageWizard__selected-title-overlay', 'twa:absolute twa:rounded-standard twa:select-none twa:bg-accent twa:transition-top twa:duration-200', (0, $c1f662de8a4d1882$export$39b0426676282ece).focusOutline)
    });
    const sizeOwnerRef = (0, $acw62.useRef)(null);
    const [width, setWidth] = (0, $acw62.useState)(0);
    (0, $bdba03b512251bc7$export$683480f191c0e3ea)(sizeOwnerRef, ({ width: width })=>{
        setWidth(width);
    });
    $acw62.useEffect(()=>{
        const node = selectedNodeRef.current;
        const parent = node.parentNode;
        const activeElement = parent.children[currentSection];
        node.style.top = `${activeElement.offsetTop}px`;
        node.style.left = `${activeElement.offsetLeft}px`;
        node.style.height = `${activeElement.offsetHeight}px`;
        node.style.width = `${activeElement.offsetWidth}px`;
        node.focus();
    }, [
        currentSection,
        width
    ]);
    let navIndex = 0;
    const dialogRef = (0, $acw62.useRef)(null);
    let invalidCount = 0;
    let firstErrorMessage = null;
    const validSectionsMap = visibleSections.reduce((acc, section, index)=>{
        if (section === '-') {
            acc.set(index, true);
            return acc;
        }
        const valid = section.isValid ? section.isValid(props.data, contextValue) : true; //!active && canFinish !== true;
        if (valid !== true) {
            invalidCount++;
            if (firstErrorMessage == null) firstErrorMessage = valid;
        }
        acc.set(index, valid);
        return acc;
    }, new Map());
    const canFinish = !invalidCount;
    return $acw62.createElement((0, $52aad13a119b1140$export$8e4378d5a5cc668b).Provider, {
        value: {
            namedQuery: namedQuery,
            setNamedQuery: setNamedQuery
        }
    }, $acw62.createElement($16482cb6c18088bf$export$b25b81c847b0e769.Provider, {
        value: contextValue
    }, $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
        modal: props.modal ?? true,
        isOpen: true,
        showCloseButton: false,
        focusOnBrowserVisible: true,
        className: "twa:rounded-standard twa:overflow-hidden twa:h-[90vh]",
        ref: dialogRef,
        onDismiss: ()=>props.onHide?.(),
        onKeyDown: (event)=>{
            if (event.metaKey || event.ctrlKey) {
                const { key: key } = event;
                if (!isNaN(Number(key))) {
                    const num = Number(key);
                    if (navIndexMap.has(num)) {
                        const index = navIndexMap.get(num);
                        setCurrentSection(index);
                        event.preventDefault();
                        event.stopPropagation();
                        requestAnimationFrame(()=>{
                            dialogRef?.current?.bringToFront();
                        });
                    }
                }
            }
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-OnePageWizard twa:flex twa:flex-col twa:h-full twa:w-[90vw] twa:max-w-[1200px]', 'twa:bg-primarylight twa:text-primary-foreground'),
        "data-name": props.name,
        style: props.style
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        alignItems: "stretch",
        className: "twa:flex-1 twa:overflow-auto"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "ab-OnePageWizard__section-title-container twa:p-3 twa:flex-none twa:overflow-auto twa:relative",
        ref: sizeOwnerRef,
        style: props.titleContainerStyle
    }, visibleSections.map((section, index)=>{
        if (section === '-') return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            as: "hr",
            className: "ab-OnePageWizard__section-separator twa:mt-2 twa:w-full twa:border-t twa:border-t-inputborder",
            key: `${index}-`
        });
        navIndex++;
        navIndexMap.set(navIndex, index);
        const active = index === currentSection;
        const disabled = false; //!active && !currentSectionValid;
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-OnePageWizard__section-title twa:p-2', {
                'twa:cursor-auto': disabled,
                'twa:cursor-pointer': !disabled,
                'twa:z-10': true,
                'twa:opacity-50': disabled,
                'twa:opacity-100': !disabled,
                'twa:mt-2': index > 0,
                'twa:mt-0': index === 0,
                'twa:text-accent-foreground twa:pointer-events-none': active
            }),
            "data-name": section.title,
            flexDirection: "row",
            style: {
                transition: 'color 0.2s'
            },
            key: section.title,
            onClick: ()=>{
                if (disabled) return;
                if (active) return;
                setCurrentSection(index);
            }
        }, $acw62.createElement((0, $914e6624a1f38835$export$65fb1b893b7011dc), {
            className: "twa:mr-2 twa:inline-block twa:text-color-accent-foreground"
        }, navIndex), $acw62.createElement("div", {
            className: "twa:flex-1"
        }, section.title), $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
            name: "error",
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:ml-2', validSectionsMap.get(index) !== true ? 'twa:visible' : 'twa:invisible')
        }));
    }), selectedFeedback, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }), $acw62.createElement((0, $914e6624a1f38835$export$65fb1b893b7011dc), {
        className: "ab-OnePageWizard__key-hint twa:leading-normal"
    }, (0, $3c733dd7e3e38510$export$97c02de5f74f3224)() ? 'Cmd' : 'Ctrl', " + #", $acw62.createElement("br", null), "or arrow keys", $acw62.createElement("br", null), "to navigate")), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "ab-OnePageWizard__section-container twa:flex-1"
    }, renderSection(currentSection))), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        alignItems: "center",
        className: "ab-WizardDialog__footer ab-OnePageWizard__footer twa:p-2"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        tone: "neutral",
        variant: "text",
        "data-name": "close",
        onClick: ()=>props.onHide?.(),
        tooltip: props.closeTooltip ?? 'Close wizard',
        accessLevel: 'Full'
    }, props.closeText ?? 'CLOSE'), $acw62.createElement((0, $914e6624a1f38835$export$65fb1b893b7011dc), {
        className: "twa:ml-2"
    }, "Esc"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-OnePageWizard__error twa:text-2 twa:mr-3 twa:flex-1 twa:text-error twa:text-end"
    }, firstErrorMessage), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        tone: "accent",
        "data-name": "finish",
        variant: "raised",
        disabled: canFinish !== true,
        onClick: ()=>handleClickFinish(),
        icon: 'check',
        accessLevel: 'Full'
    }, props.finishText ?? 'Finish'))))));
};


/**
 * Converts string to kebab-case.
 * Drop-in replacement for lodash/kebabCase.
 */ 
var $9CW7w = parcelRequire("9CW7w");
function $9ce0650a2a8dba81$export$2e2bcd8739ae039(string) {
    return (0, $9CW7w.default)(string).map((w)=>w.toLowerCase()).join('-');
}




const $e70b2e3a7d03e2cc$export$b13861a6b1e8b638 = (props)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props
    });
const $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3 = (props)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:text-2 twa:mb-3', props.className)
    });
const $e70b2e3a7d03e2cc$export$dd180a7fd9107bd4 = (props)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:text-2 twa:mt-1', props.className)
    });
const $e70b2e3a7d03e2cc$export$b31b425178346100 = $acw62.createContext({
    data: null,
    sections: [],
    moduleInfo: null,
    api: null,
    namedQuery: false
});
function $e70b2e3a7d03e2cc$export$9db311725c0ce90e() {
    return $acw62.useContext($e70b2e3a7d03e2cc$export$b31b425178346100);
}
const $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const saveNamedQuery = $acw62.useCallback((namedQuery)=>dispatch($f53463061a55e5a9$export$35d9816f002a20ec(namedQuery)), []);
    const [namedQuery, setNamedQuery] = (0, $acw62.useState)(false);
    const name = props.moduleInfo.FriendlyName ? `${(0, $9ce0650a2a8dba81$export$2e2bcd8739ae039)(props.moduleInfo.FriendlyName)}-wizard` : '';
    const extraContext = {
        data: props.data,
        api: api,
        namedQuery: namedQuery,
        moduleInfo: props.moduleInfo,
        sections: props.sections
    };
    const sections = props.sections.map((section)=>{
        if (section === '-') return '-';
        const isValid = typeof section.isValid === 'function' ? (data, innerContext)=>{
            return section.isValid(data, api, {
                ...innerContext,
                ...extraContext
            });
        } : void 0;
        const isVisible = typeof section.isVisible === 'function' ? (data, innerContext)=>{
            return section.isVisible(data, api, {
                ...innerContext,
                ...extraContext
            });
        } : void 0;
        return {
            ...section,
            isValid: isValid,
            isVisible: isVisible
        };
    });
    const handleClickFinish = ()=>{
        if (namedQuery && namedQuery.Name) saveNamedQuery(namedQuery);
        props.onFinish?.(props.data);
    };
    return $acw62.createElement($e70b2e3a7d03e2cc$export$b31b425178346100.Provider, {
        value: extraContext
    }, $acw62.createElement((0, $52aad13a119b1140$export$8e4378d5a5cc668b).Provider, {
        value: {
            namedQuery: namedQuery,
            setNamedQuery: setNamedQuery
        }
    }, $acw62.createElement((0, $16482cb6c18088bf$export$6d2e999e122179b5), {
        ...props,
        name: name,
        sections: sections,
        onFinish: handleClickFinish
    })));
};
const $e70b2e3a7d03e2cc$export$50a34d6e6d05db65 = ()=>{
    const { sections: sections, data: data, api: api, moduleInfo: moduleInfo } = $e70b2e3a7d03e2cc$export$9db311725c0ce90e();
    const { setCurrentSection: setCurrentSection } = (0, $16482cb6c18088bf$export$fd9424726448f440)();
    const [namedQuery] = (0, $acw62.useState)(false);
    const renderEdit = (index)=>$acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            className: "twa:px-1 twa:inline-block twa:text-2 twa:underline",
            variant: "text",
            onClick: ()=>{
                setCurrentSection(index);
            }
        }, "edit");
    const extraContext = {
        data: data,
        api: api,
        namedQuery: namedQuery,
        moduleInfo: moduleInfo,
        sections: sections
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-OnePageWizardSummary twa:flex twa:flex-col twa:gap-2"
    }, sections.map((section, index)=>{
        if (section === '-') return null;
        if (!section.renderSummary) return null;
        if (section.isVisible && !section.isVisible(data, api, extraContext)) return null;
        return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
            keyboardNavigation: false,
            key: index
        }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, section.title, " ", renderEdit(index)), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, section.renderSummary(data, api))));
    }).filter(Boolean));
};




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");






var $9g4SS = parcelRequire("9g4SS");


function $d2ae5bba8d7d6225$var$useValuesMap({ options: options, value: value, toIdentifier: toIdentifier, selectedMap: selectedMap }) {
    const optionsMap = (0, $acw62.useMemo)(()=>{
        if (selectedMap) return;
        const map = new Map([]);
        options.forEach((option)=>{
            map.set(toIdentifier(option), option);
        });
        return map;
    }, [
        options,
        selectedMap
    ]);
    const result = (0, $acw62.useMemo)(()=>{
        if (selectedMap) return selectedMap;
        const map = new Map([]);
        value.forEach((id)=>{
            map.set(id, optionsMap.get(id) ?? null);
        });
        return map;
    }, [
        optionsMap,
        selectedMap,
        value
    ]);
    return {
        selectedMap: result,
        optionsMap: optionsMap
    };
}
const $d2ae5bba8d7d6225$var$baseClassName = 'ab-ValueSelector';
function $d2ae5bba8d7d6225$export$98c0468e3210506e(props) {
    const { options: options, value: value, filter: filter, onChange: onChange, allowReorder: allowReorder = true, singleSelect: singleSelect, toLabel: toLabel, toListLabel: toListLabel, toIdentifier: toIdentifier, showSelectedOnlyLabel: showSelectedOnlyLabel, showFilterInput: showFilterInput, onShowSelectedOnlyChange: onShowSelectedOnlyChange, isOptionDisabled: isOptionDisabled, disabled: disabled } = props;
    const [searchInputValue, setSearchInputValue] = $acw62.useState('');
    const preparedToLabel = toListLabel ?? toLabel;
    const [selectedOnly, doSetSelectedOnly] = (0, $acw62.useState)(false);
    const setSelectedOnly = (0, $acw62.useCallback)((selectedOnly)=>{
        doSetSelectedOnly(selectedOnly);
        onShowSelectedOnlyChange?.(selectedOnly);
    }, [
        onShowSelectedOnlyChange
    ]);
    const { selectedMap: selectedMap } = $d2ae5bba8d7d6225$var$useValuesMap({
        options: options,
        toIdentifier: toIdentifier,
        value: value
    });
    const notifyChange = (0, $acw62.useCallback)(()=>{
        const newSelection = [
            ...selectedMap.keys()
        ];
        if (!newSelection.length && selectedOnly) setSelectedOnly(false);
        onChange(newSelection, new Map(selectedMap));
    }, [
        onChange,
        selectedOnly,
        selectedMap
    ]);
    const renderOption = (option, index)=>{
        const identifier = toIdentifier(option);
        const label = !allowReorder ? preparedToLabel(option) : null;
        const reorderable = typeof allowReorder === 'function' ? allowReorder(option) : allowReorder;
        const renderNode = (props, dragHandleProps)=>{
            return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                alignItems: "center",
                key: identifier ?? index,
                "data-index": index,
                "data-id": identifier,
                "data-name": "option",
                ...props,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`twa:bg-primary twa:text-text-on-primary twa:rounded-standard twa:p-2`, {
                    'twa:mt-1': index,
                    'twa:mt-0': !index
                }, props.className, `${$d2ae5bba8d7d6225$var$baseClassName}__option`)
            }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                flexDirection: "row",
                alignItems: "center",
                className: "twa:flex-1"
            }, reorderable ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                ...dragHandleProps,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:mr-3', dragHandleProps?.className)
            }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "drag",
                style: {
                    cursor: 'grab'
                }
            })) : null, singleSelect ? $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
                checked: selectedMap.has(identifier),
                "data-name": identifier,
                onChange: (checked)=>{
                    if (checked) {
                        selectedMap.clear();
                        selectedMap.set(identifier, option);
                    } else selectedMap.delete(identifier);
                    notifyChange();
                }
            }, label) : $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                "data-name": identifier,
                disabled: disabled || (isOptionDisabled ? isOptionDisabled(option) : false),
                onChange: (checked)=>{
                    if (checked) selectedMap.set(identifier, option);
                    else selectedMap.delete(identifier);
                    notifyChange();
                },
                checked: selectedMap.has(identifier)
            }, label), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:ml-2 twa:flex-1"
            }, allowReorder ? preparedToLabel(option) : null)));
        };
        return $acw62.createElement((0, $1710e65dc30c5dd1$export$f2a139e5d18b9882), {
            key: identifier,
            index: index,
            draggableId: `${identifier}`,
            isDragDisabled: !reorderable
        }, (draggableProvided)=>{
            return renderNode({
                ref: draggableProvided.innerRef,
                ...draggableProvided.draggableProps,
                style: draggableProvided.draggableProps.style
            }, draggableProvided.dragHandleProps);
        });
    };
    const showOnlySelectedCheckbox = $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        disabled: !value.length,
        checked: selectedOnly,
        onChange: setSelectedOnly
    }, showSelectedOnlyLabel ?? 'Show Selected Only');
    const selectionSectionProps = {
        ...props,
        showOnlySelectedCheckbox: showOnlySelectedCheckbox,
        onSelectAll: ()=>{
            options.forEach((option)=>{
                selectedMap.set(toIdentifier(option), option);
            });
            notifyChange();
        },
        onClearOption: (id)=>{
            selectedMap.delete(id);
            notifyChange();
        },
        onClear: ()=>{
            selectedMap.clear();
            notifyChange();
        }
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        style: props.style,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:flex-1', $d2ae5bba8d7d6225$var$baseClassName),
        flexDirection: "column"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:mb-1"
    }, showFilterInput && filter ? $acw62.createElement((0, $0f5e3272866deca2$export$6e10b3df66bf9f52), {
        value: searchInputValue,
        OnTextChange: setSearchInputValue,
        placeholder: "Type to search",
        className: "twa:flex-1 twa:border-0 twa:m-[3px]"
    }) : $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    })), $d2ae5bba8d7d6225$export$6a1b3eef942b21a4(selectionSectionProps), $acw62.createElement((0, $e52d5c02f19d68ad$export$237bd83162c14364), {
        onDragEnd: (result)=>{
            const { source: source, destination: destination } = result;
            const selection = [];
            const extraKeys = [];
            for (let [key, value] of selectedMap)if (value != null) selection.push(key);
            else // null/non-existent keys have to be stored separately
            extraKeys.push(key);
            const clone = new Map(selectedMap);
            const newSelection = (0, $9g4SS.default).reorderArray(selection, source.index, destination.index);
            // and then pushed back in the new order, at the end
            newSelection.push(...extraKeys);
            selectedMap.clear();
            newSelection.forEach((key)=>{
                selectedMap.set(key, clone.get(key));
            });
            notifyChange();
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: `${$d2ae5bba8d7d6225$var$baseClassName}__body twa:flex-1 twa:overflow-auto`,
        flexDirection: "column"
    }, $acw62.createElement((0, $e52d5c02f19d68ad$export$423ec2075359570a), {
        droppableId: "droppable"
    }, (droppableProvided)=>{
        return $acw62.createElement("div", {
            ref: droppableProvided.innerRef,
            ...droppableProvided.droppableProps
        }, options.filter((option)=>{
            let result = true;
            if (filter) result = filter(option, searchInputValue);
            result = result && (selectedOnly ? selectedMap.has(toIdentifier(option)) : true);
            return result;
        }).map(renderOption), droppableProvided.placeholder);
    }))));
}
const $d2ae5bba8d7d6225$export$6a1b3eef942b21a4 = (props)=>{
    const { value: value, options: options, disabled: disabled, singleSelect: singleSelect, toLabel: toLabel, toIdentifier: toIdentifier } = props;
    const selectionBox = $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex twa:flex-col twa:gap-2 twa:py-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:flex twa:flex-row', 'twa:border-b twa:border-primarydark/30 twa:rounded-standard')
    }, singleSelect ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex twa:flex-row twa:text-3 twa:font-normal"
    }, "(", value.length, " of ", options.length, " selected)") : $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        className: "twa:ml-0.5 twa:font-bold",
        checked: !value.length ? false : value.length === options.length ? true : null,
        onChange: (checked)=>{
            if (checked) props.onSelectAll();
            else props.onClear();
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex twa:flex-row twa:items-center twa:gap-3"
    }, "Select All", $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:font-normal"
    }, "(", value.length, " of ", options.length, " selected)"))), $acw62.createElement("div", {
        className: "twa:flex-1"
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mr-2 twa:text-2 twa:font-normal"
    }, props.showOnlySelectedCheckbox)));
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`${$d2ae5bba8d7d6225$var$baseClassName}__header `)
    }, selectionBox);
};


const $a5fb2ed975764e91$export$ac01ee0b3a94fb49 = ({ allowReorder: allowReorder = true, ...props })=>{
    const { columnFilterText: columnFilterText, availableColumns: availableColumns, selected: selected, onChange: onChange, singleSelect: singleSelect } = props;
    const filterFn = (0, $acw62.useMemo)(()=>{
        return columnFilterText ? (c)=>c.friendlyName.toLowerCase().indexOf(columnFilterText.toLowerCase()) != -1 : null;
    }, [
        columnFilterText
    ]);
    return $acw62.createElement((0, $d2ae5bba8d7d6225$export$98c0468e3210506e), {
        value: selected,
        options: availableColumns,
        filter: filterFn,
        singleSelect: singleSelect,
        allowReorder: false,
        onChange: (colIds)=>{
            if (singleSelect) onChange(colIds.length ? [
                colIds.pop()
            ] : []);
            else onChange(colIds);
        },
        toIdentifier: (c)=>c.columnId,
        toLabel: (c)=>c.friendlyName
    });
};






var $9OAZF = parcelRequire("9OAZF");


const $65308a7002d19b3b$export$37abad8a5da7760 = ({ Scope: Scope })=>{
    const result = [];
    if (!Scope) return 'A scope is required.';
    if (Scope && 'ColumnIds' in Scope && Scope.ColumnIds.length === 0) result.push('Please select at least one column for the scope.');
    if (Scope && 'DataTypes' in Scope && Scope.DataTypes.length === 0) result.push('Please select at least one data type for the scope.');
    return result.length ? result.join(', ') : true;
};
const $65308a7002d19b3b$var$DATA_TYPES_MAP = {
    date: {
        label: 'Date',
        value: 'date'
    },
    number: {
        label: 'Number',
        value: 'number'
    },
    text: {
        label: 'Text',
        value: 'text'
    },
    boolean: {
        label: 'Boolean',
        value: 'boolean'
    }
};
const $65308a7002d19b3b$var$renderDataTypeLabel = (c)=>{
    return 'DataType: ' + (0, $9OAZF.default).CapitaliseFirstLetter(c);
};
const $65308a7002d19b3b$export$3f60d09dd2143243 = (scope, labels)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const scopeApi = adaptable.api.columnScopeApi;
    const columnsInScope = scopeApi.getColumnsInScope(scope);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), {
        className: "twa:mb-0"
    }, scopeApi.scopeIsAll(scope) ? labels.scopeWholeRow : null)), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:overflow-hidden"
    }, 'ColumnIds' in scope ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), {
        className: columnsInScope.length ? 'twa:mb-2' : ''
    }, labels.scopeColumns), columnsInScope.length ? $acw62.createElement((0, $3283d8fe16778b21$export$f9fef0f55402315b), {
        tags: columnsInScope.map((c)=>c.friendlyName)
    }) : null) : null), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, 'DataTypes' in scope ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:mb-2"
    }, labels.scopeDataTypes), $acw62.createElement((0, $3283d8fe16778b21$export$f9fef0f55402315b), {
        tags: scope.DataTypes.map((dataType)=>$65308a7002d19b3b$var$renderDataTypeLabel(dataType))
    })) : null));
};
const $65308a7002d19b3b$var$DATA_TYPES_OPTIONS = Object.values($65308a7002d19b3b$var$DATA_TYPES_MAP);
const $65308a7002d19b3b$export$b5842aa553688927 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { columnScopeApi: scopeApi, columnApi: columnApi } = api;
    const [columnsSearchText, setColumnsSearchText] = (0, $acw62.useState)('');
    const scopeColumns = $acw62.useMemo(()=>{
        const allColumns = props.scopeColumns || columnApi.getUIAvailableColumns();
        if (typeof props.isColumnAvailable === 'function') return allColumns.filter((c)=>props.isColumnAvailable(c));
        return allColumns;
    }, []);
    const getScopeChoice = (scope)=>{
        if (!scope) return undefined;
        if (scopeApi.scopeIsAll(scope)) return 'All';
        if (scopeApi.scopeHasColumns(props.scope)) return 'Column';
        if (scopeApi.scopeHasDataType(props.scope)) return 'DataType';
        if (scopeApi.scopeHasColumnType(props.scope)) return 'ColumnType';
        return undefined;
    };
    const onScopeSelectChanged = (value)=>{
        let newScope;
        if (value == 'Column') newScope = {
            ColumnIds: []
        };
        else if (value == 'DataType') newScope = {
            DataTypes: []
        };
        else if (value == 'ColumnType') newScope = {
            ColumnTypes: []
        };
        else newScope = {
            All: true
        };
        props.updateScope(newScope);
    };
    const onColumnsSelectedChanged = (cols)=>{
        const newScope = {
            ColumnIds: cols
        };
        props.updateScope(newScope);
    };
    const onCheckBoxDataTypeChecked = (checked, item)=>{
        let dataTypes = [].concat(scopeApi.getDataTypesInScope(props.scope));
        if (checked) dataTypes.push(item);
        else {
            const index = dataTypes.indexOf(item, 0);
            if (index > -1) dataTypes.splice(index, 1);
        }
        let newScope = {
            DataTypes: dataTypes
        };
        props.updateScope(newScope);
    };
    const scopeChoice = getScopeChoice(props.scope);
    const dataTypesInScope = props.scope && 'DataTypes' in props.scope ? scopeApi.getDataTypesInScope(props.scope) : null;
    let dataTypeOptions = $65308a7002d19b3b$var$DATA_TYPES_OPTIONS;
    if (Array.isArray(props.availableDataTypes)) dataTypeOptions = props.availableDataTypes.map((dataType)=>$65308a7002d19b3b$var$DATA_TYPES_MAP[dataType]);
    const hasColumnTypes = $acw62.useMemo(()=>{
        return api.columnApi.getColumnTypes()?.length > 0;
    }, []);
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        "data-name": 'scope-component',
        className: "ab-ScopeComponent",
        value: scopeChoice,
        style: {
            height: '100%',
            ...props.style
        },
        onValueChange: onScopeSelectChanged
    }, props.hideWholeRow ? null : $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "Row"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:m-0",
        checked: scopeChoice == 'All',
        tabIndex: -1
    }, "All Columns")), !props.disableColumns && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "Column"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:m-0",
        value: "Column",
        checked: scopeChoice == 'Column',
        tabIndex: -1
    }, "Selected Columns")), !props.disableDataTypes && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "DataType"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:m-0",
        value: "DataType",
        checked: scopeChoice == 'DataType',
        tabIndex: -1
    }, "Data Types")), hasColumnTypes && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "ColumnType"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:m-0",
        value: "ColumnType",
        checked: scopeChoice == 'ColumnType',
        tabIndex: -1
    }, "Column Types")), props.hideWholeRow ? null : $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "Row",
        style: {
            flex: 'none'
        },
        "data-name": "row-scope"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:pl-0 twa:text-2"
    }, props.descriptions.rowScope)), !props.disableColumns && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "Column",
        "data-name": "column-scope",
        className: "twa:p-0 twa:flex-1 twa:overflow-auto"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        alignItems: "center",
        className: "twa:p-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, props.descriptions.columnScope), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-3"
    }), $acw62.createElement((0, $0f5e3272866deca2$export$6e10b3df66bf9f52), {
        value: columnsSearchText,
        OnTextChange: setColumnsSearchText,
        placeholder: "Type to search columns",
        style: {
            flex: 1
        }
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:overflow-hidden twa:pl-2 twa:flex-1"
    }, $acw62.createElement((0, $a5fb2ed975764e91$export$ac01ee0b3a94fb49), {
        columnFilterText: columnsSearchText,
        allowReorder: false,
        availableColumns: scopeColumns,
        selected: scopeApi.getColumnIdsInScope(props.scope),
        onChange: onColumnsSelectedChanged
    }))), !props.disableDataTypes && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "DataType",
        style: {
            flex: 'none'
        },
        "data-name": "datatype-scope"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, props.descriptions.dataTypeScope && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:pl-0 twa:mb-2 twa:text-2"
    }, props.descriptions.dataTypeScope), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, dataTypeOptions.map((dataTypeOption)=>$acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            "data-name": "scope",
            "data-value": dataTypeOption.value,
            key: dataTypeOption.value,
            checked: dataTypesInScope && dataTypesInScope.includes(dataTypeOption.value),
            onChange: (checked)=>onCheckBoxDataTypeChecked(checked, dataTypeOption.value)
        }, dataTypeOption.label))))), hasColumnTypes && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "ColumnType",
        className: "twa:flex-none",
        "data-name": "column-type-scope"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, api.columnApi.getColumnTypes()?.map?.((columnType)=>$acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            "data-name": "scope",
            "data-value": columnType,
            key: columnType,
            checked: 'ColumnTypes' in props.scope && props.scope.ColumnTypes?.includes(columnType),
            onChange: (checked)=>{
                let columnTypes = [].concat(props.scope.ColumnTypes);
                if (checked) columnTypes.push(columnType);
                else columnTypes = columnTypes.filter((ct)=>ct !== columnType);
                let newScope = {
                    ColumnTypes: columnTypes
                };
                props.updateScope(newScope);
            }
        }, (0, $b0d14b794bdca4f2$export$8c479b03614a2754)(columnType)))))));
};




const $a9e941bf6e825744$export$21a542085efa7195 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    let disableDataTypes = true;
    let disableColumns = true;
    if (props.alertType === 'DataChange' || props.alertType == 'Validation') {
        disableDataTypes = false;
        disableColumns = false;
    }
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:p-2 twa:h-full"
    }, $acw62.createElement((0, $65308a7002d19b3b$export$b5842aa553688927), {
        disableColumns: disableColumns,
        disableDataTypes: disableDataTypes,
        descriptions: {
            rowScope: 'Changes in any Column in the row will trigger an Alert',
            columnScope: 'Changes in selected Columns will trigger an Alert',
            dataTypeScope: 'Changes in any Column which is of the selected Data Type(s) will trigger an Alert'
        },
        scope: data.Scope,
        updateScope: (Scope)=>{
            const newData = {
                ...data,
                Scope: Scope
            };
            if (newData.Rule.Predicates) // when scope is changed, reset the rule to predicate of any
            // if it was set to a predicate before
            newData.Rule = {
                Predicates: [
                    {
                        PredicateId: 'AnyChange'
                    }
                ]
            };
            if (newData.Rule.ObservableExpression !== undefined && !api.columnScopeApi.scopeIsAll(Scope)) {
                // if it had observable expression and the scope is changed to partial
                // we need to reset to not be an observable expression, as observable is not supported
                // for partial scope
                delete newData.Rule.ObservableExpression;
                newData.Rule.BooleanExpression = '';
            }
            if (newData.Rule.AggregatedBooleanExpression !== undefined && !api.columnScopeApi.scopeIsAll(Scope)) {
                // if it had aggregation expression and the scope is changed to partial
                // we need to reset to not be an aggregation expression, as aggregation is not supported
                // for partial scope
                delete newData.Rule.AggregatedBooleanExpression;
                newData.Rule.BooleanExpression = '';
            }
            props.onChange(newData);
        }
    }));
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");










const $7037612f472b3962$export$ae5262bb43652 = (props)=>{
    const baseClassName = 'ab-PredicateEditor';
    const predicateDefsOptions = $acw62.useMemo(()=>props?.predicateDefs?.map((item)=>({
                value: item.id,
                label: item.label,
                inputs: item.inputs
            })), [
        props.predicateDefs,
        props.onChange
    ]);
    const handlePredicateInputChange = (e, index)=>{
        const { value: value } = e.target;
        const newInputs = [
            ...props.predicate.Inputs ?? []
        ];
        newInputs[index] = value;
        props.onChange({
            ...props.predicate,
            Inputs: newInputs
        });
    };
    const handlePredicateValuesChange = (inputs)=>{
        props.onChange({
            ...props.predicate,
            Inputs: inputs
        });
    };
    const currentPredicateDef = props?.predicateDefs?.find((item)=>item.id === props.predicate?.PredicateId);
    let icon = null;
    if (currentPredicateDef) {
        if ((0, $9200d8ae4e589d35$export$dff472f8017c5d8b)(currentPredicateDef?.icon)) icon = $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
            icon: currentPredicateDef.icon
        });
        else if (currentPredicateDef?.icon && 'text' in currentPredicateDef?.icon) icon = $acw62.createElement("span", null, currentPredicateDef.icon.text);
    }
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const columnId = props.columnId;
    const column = adaptable.api.columnApi.getColumnWithColumnId(columnId);
    const searchValueRef = $acw62.useRef('');
    const { quickFilterValues: quickFilterValues, isDistinctColumnValuesLoading: isDistinctColumnValuesLoading, triggerValuesLoad: triggerValuesLoad } = (0, $318e9b87498d2460$export$e833de850ac6ad56)({
        columnId: columnId,
        searchValueRef: searchValueRef
    });
    const quickFilterValuesRef = $acw62.useRef(quickFilterValues);
    quickFilterValuesRef.current = quickFilterValues;
    (0, $acw62.useEffect)(triggerValuesLoad, []);
    const onMenuOpen = ()=>{
        triggerValuesLoad();
    };
    const onInputChange = $acw62.useCallback((value)=>{
        searchValueRef.current = value;
        const quickFilterValues = quickFilterValuesRef.current;
        if (quickFilterValues.searchValueUsedInFilterValue || quickFilterValues.skipDefaultSearch) triggerValuesLoad();
    }, []);
    const { skipDefaultSearch: skipDefaultSearch } = quickFilterValues;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: baseClassName
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:justify-stretch"
    }, icon && $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
        className: "twa:mr-2"
    }, icon), $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        isClearable: true,
        options: predicateDefsOptions,
        "data-name": "select-predicate",
        placeholder: "Select Rule",
        value: currentPredicateDef?.id,
        onChange: (value)=>{
            const option = predicateDefsOptions.find((x)=>x.value === value);
            props.onChange({
                ...props.predicate,
                PredicateId: option?.value,
                Inputs: (option?.inputs ?? []).map((input)=>input.defaultValue ?? '')
            });
        }
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, currentPredicateDef?.inputs?.map((predicateDefInput, index)=>$acw62.createElement($acw62.Fragment, null, index > 0 && $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
            className: "twa:m-2"
        }, "AND"), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            key: index,
            className: "twa:flex-1",
            flexDirection: "column"
        }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
            "data-name": `predicate-input-${index}`,
            className: "twa:mt-2",
            type: predicateDefInput.type,
            autoFocus: index === 0,
            value: props.predicate.Inputs?.[index] ?? '',
            onChange: (e)=>handlePredicateInputChange(e, index)
        }))))), adaptable.api.predicateApi.internalApi.IsInOrNotInPredicateDef(currentPredicateDef) && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-2"
    }, $acw62.createElement((0, $fe8e9fe7bf831ca5$export$5558c43cb64dbe0a), {
        isLoading: isDistinctColumnValuesLoading,
        column: column,
        options: quickFilterValues.values,
        selectProps: {
            onMenuOpen: onMenuOpen,
            onInputChange: onInputChange,
            skipDefaultFiltering: skipDefaultSearch
        },
        dataType: column.dataType,
        value: props.predicate.Inputs,
        onChange: handlePredicateValuesChange
    })));
};




const $b00f4585df0319fb$export$cb24a028ec73ebb5 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { predicate: predicate } = props;
    const allColumns = $acw62.useMemo(()=>{
        return api.columnApi.getColumns().map((column)=>({
                label: column.friendlyName,
                value: column.columnId
            }));
    }, []);
    const handleClear = ()=>{
        const newPredicates = props.data.Rule?.Predicates?.filter((prevPredicate)=>prevPredicate !== predicate);
        props.onChange({
            ...props.data,
            Rule: {
                Predicates: newPredicates
            }
        });
    };
    const handlePredicateChange = (newPredicateDef)=>{
        let newPredicates = [];
        if (predicate) newPredicates = props.data.Rule?.Predicates?.map((prevPredicate)=>{
            if (prevPredicate === predicate) return newPredicateDef;
            return prevPredicate;
        });
        else // no previous predicate, e.g. it was cleared
        newPredicates = [
            newPredicateDef
        ];
        props.onChange({
            ...props.data,
            Rule: {
                Predicates: newPredicates
            }
        });
    };
    const predicateDefs = $acw62.useMemo(()=>{
        let preparedPredicates = [];
        if (props.getPredicateDefsForColId && props?.predicate?.ColumnId) preparedPredicates = props.getPredicateDefsForColId(props.predicate.ColumnId);
        else preparedPredicates = props.predicateDefs;
        return preparedPredicates;
    }, [
        props.predicate
    ]);
    const columnIdPredicateScopeEnabled = Boolean(props.columnPredicateEnabled);
    const selectedColumn = allColumns.find((col)=>col.value === predicate?.ColumnId);
    const columnOptions = allColumns.map((col)=>({
            label: col.label,
            value: col.value
        }));
    // use global scope or custom scope
    let predicateColumnId = null;
    if (predicate?.ColumnId && predicate.ColumnId !== '') predicateColumnId = predicate.ColumnId;
    else if ('ColumnIds' in props.data.Scope && props.data.Scope?.ColumnIds?.[0]) predicateColumnId = props.data.Scope?.ColumnIds?.[0];
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-EntityRulePredicateEditor twa:p-3 twa:mb-3"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, columnIdPredicateScopeEnabled && $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Column"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        placeholder: "Select Column",
        options: columnOptions,
        value: selectedColumn?.value,
        onChange: (value)=>{
            handlePredicateChange({
                PredicateId: null,
                ColumnId: value,
                Inputs: []
            });
        }
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Predicate"
    }, $acw62.createElement((0, $7037612f472b3962$export$ae5262bb43652), {
        columnId: predicateColumnId,
        predicateDefs: predicateDefs,
        predicate: predicate,
        onChange: handlePredicateChange,
        onClear: handleClear
    })))), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        disabled: !predicate,
        className: "twa:ml-2 twa:h-input",
        onClick: handleClear,
        icon: "delete"
    })));
};





const $998a30775a771eab$export$17396808b117a78c = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const showDocumentationLinks = api.internalApi.isDocumentationLinksDisplayed();
    const columnPredicateEnabled = props.data.Rule.Predicates.some((predicate)=>predicate.ColumnId !== undefined);
    // filter out predicates that are already in use
    const defaultPredicateDefs = props.predicateDefs.filter((predicateDef)=>{
        return props.data.Rule?.Predicates?.every((rulePrediate)=>rulePrediate.PredicateId !== predicateDef.id);
    });
    const handlePredicateScopeTypeChange = (columnPredicateEnabled)=>{
        if (columnPredicateEnabled) props.onChange({
            ...props.data,
            Rule: {
                Predicates: [
                    {
                        PredicateId: null,
                        ColumnId: ''
                    }
                ]
            }
        });
        else props.onChange({
            ...props.data,
            Rule: {
                Predicates: []
            }
        });
    };
    const handleAddNewPredicate = ()=>{
        props.onChange({
            ...props.data,
            Rule: {
                Predicates: [
                    ...props.data.Rule?.Predicates || [],
                    {
                        PredicateId: defaultPredicateDefs[0].id,
                        Inputs: []
                    }
                ]
            }
        });
    };
    const scopeString = (0, $01403ab2be951cf5$export$4abcb9ed8272134c)(props.data.Scope, api).values.join(', ');
    const enablePredicateColumnId = props.enablePredicateColumnId ?? true;
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        justifyContent: "space-between",
        className: "twa:mb-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:mb-2"
    }, props.descriptions.selectPredicate), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        disabled: !props.data.Rule?.Predicates?.length,
        onClick: handleAddNewPredicate,
        icon: "plus",
        variant: "raised"
    }, "Add Predicate")), enablePredicateColumnId && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-EntityRulePredicateEditor-ScopeTypeSelector twa:p-2 twa:mb-2",
        flexDirection: "column"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-2"
    }, "Create Predicate Rule(s) using"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "entity-scope",
        onClick: ()=>handlePredicateScopeTypeChange(false),
        className: "twa:mr-3",
        checked: !columnPredicateEnabled
    }, "Active Column: ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
        className: "twa:mx-1"
    }, scopeString || 'Not Defined'), ' '), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "column-scope",
        onClick: ()=>handlePredicateScopeTypeChange(true),
        checked: columnPredicateEnabled
    }, "Selected Columns (overriding Active Column)")), (props.data.Rule?.Predicates?.length ? props.data.Rule.Predicates : [
        null
    ]).map((predicate, index)=>{
        const currentPredicatDef = props.predicateDefs.find((pd)=>pd.id === predicate?.PredicateId);
        let editorPredicateDefs = defaultPredicateDefs;
        if (currentPredicatDef) editorPredicateDefs = [
            currentPredicatDef,
            ...defaultPredicateDefs
        ];
        return $acw62.createElement($acw62.Fragment, {
            key: `${index}-${predicate?.PredicateId}`
        }, index > 0 && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
            className: "twa:mb-3"
        }, "AND")), $acw62.createElement((0, $b00f4585df0319fb$export$cb24a028ec73ebb5), {
            data: props.data,
            predicate: predicate,
            onChange: props.onChange,
            predicateDefs: editorPredicateDefs,
            getPredicateDefsForColId: props.getPredicateDefsForColId,
            columnPredicateEnabled: columnPredicateEnabled
        }));
    }), showDocumentationLinks && $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        "data-name": "query-documentation",
        className: "twa:mt-3 twa:mb-2 twa:p-0 twa:text-3"
    }, $acw62.createElement((0, $00c4532606fa3d4c$export$5a2ee34a0d054ab8), {
        className: "twa:mr-2",
        onClick: ()=>window.open((0, $53c62e7ff907ad8d$export$84bd4f31fbbffa34), '_blank')
    }), "See Predicate documentation for more details and examples"));
};







const $07845dcbd4d38c15$var$QueryTab = (props)=>{
    const { type: type, label: label, disabled: disabled = false, ...tabProps } = props;
    const text = $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, label, " ", $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, "query"));
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        style: {
            flex: 1
        },
        ...tabProps
    }, !disabled && props.showRadio ? $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        tabIndex: -1,
        className: "twa:m-0 twa:align-baseline",
        checked: type === props.value
    }, text) : text);
};
// needed here to be considered a child Tab component, inside the Tabs component
(0, $33d60c54c2c535f0$export$d09123193fa03dc0).add($07845dcbd4d38c15$var$QueryTab);
const $07845dcbd4d38c15$export$f59a408a7cde7e1f = (props)=>{
    const { data: data } = props;
    const { api: { predicateApi: predicateApi, internalApi: internalApi } } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    if (!data?.Rule?.Predicates?.length && !data?.Rule?.BooleanExpression && !data?.Rule?.ObservableExpression && !data?.Rule?.AggregatedBooleanExpression) return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, "No Rule defined");
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, data.Rule.Predicates ? $acw62.createElement($acw62.Fragment, null, data.Rule?.Predicates?.map?.((predicate, index)=>// predicate id is not unique
        $acw62.createElement($acw62.Fragment, {
            key: index
        }, props.renderPredicate(predicateApi.predicateToString(predicate))))) : $acw62.createElement($acw62.Fragment, null, props.renderQueryExpression(internalApi.getAdaptableQueryExpressionText(data.Rule))));
};
const $07845dcbd4d38c15$var$RuleTabTitle = (props)=>{
    return props.showRadio ? $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:m-0",
        tabIndex: -1,
        checked: props.checked
    }, props.children) : $acw62.createElement($acw62.Fragment, null, "props.children");
};
const $07845dcbd4d38c15$export$958c7d77bf3113b = (props)=>{
    const { data: data, children: children, descriptions: descriptions, predicateDefs: predicateDefs, showNoRule: showNoRule = false, showPredicate: showPredicate = true, showObservable: showObservable = true, showBoolean: showBoolean = true, showAggregation: showAggregation = true, flexProps: flexProps, module: module } = props;
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const numberOfTabs = [
        showNoRule,
        showPredicate,
        showObservable,
        showBoolean,
        showAggregation
    ].filter(Boolean).length;
    const showRadioButtons = numberOfTabs > 1;
    const type = data.Rule == undefined ? 'NoRule' : data.Rule.BooleanExpression != undefined ? 'BooleanExpression' : data.Rule.ObservableExpression != undefined && showObservable ? 'ObservableExpression' : data.Rule.AggregatedBooleanExpression != undefined && showAggregation ? 'AggregatedBooleanExpression' : 'Predicate';
    const [selectedTab, setSelectedTab] = $acw62.useState(type);
    const setType = (type)=>{
        setSelectedTab(type);
        if (type === 'NoRule' && showNoRule) {
            delete data.Rule;
            props.onChange({
                ...data
            });
        } else if (type === 'BooleanExpression' && showBoolean) props.onChange({
            ...data,
            Rule: {
                BooleanExpression: ''
            }
        });
        else if (type === 'ObservableExpression' && showObservable) props.onChange({
            ...data,
            Rule: {
                ObservableExpression: ''
            }
        });
        else if (type === 'AggregatedBooleanExpression' && showAggregation) props.onChange({
            ...data,
            Rule: {
                AggregatedBooleanExpression: ''
            }
        });
        else props.onChange({
            ...data,
            Rule: {
                Predicates: [
                    {
                        PredicateId: props.defaultPredicateId
                    }
                ]
            }
        });
    };
    const filteredPredicateDefs = predicateDefs.filter((def)=>{
        if (api.predicateApi.internalApi.IsInOrNotInPredicateDef(def)) return 'ColumnIds' in data.Scope && data.Scope.ColumnIds.length === 1;
        return true;
    });
    const setBooleanExpression = (expression)=>{
        props.onChange({
            ...data,
            Rule: {
                BooleanExpression: expression
            }
        });
    };
    const setReactiveExpression = (expression)=>{
        props.onChange({
            ...data,
            Rule: {
                ObservableExpression: expression
            }
        });
    };
    const setAggregationExpression = (expression)=>{
        props.onChange({
            ...data,
            Rule: {
                AggregatedBooleanExpression: expression
            }
        });
    };
    const initialData = (0, $acw62.useMemo)(()=>api.internalApi.getQueryPreviewData(), []);
    const baseClassName = 'ab-EntityRulesEditor';
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        ...flexProps,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(baseClassName, 'twa:p-2 twa:pt-0 twa:pl-0 twa:h-full', flexProps?.className),
        flexDirection: "column",
        style: flexProps?.style
    }, children, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        onValueChange: setType,
        value: selectedTab,
        className: "twa:pt-2 twa:pl-2 twa:flex-1 twa:overflow-auto"
    }, showNoRule ? $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: 'NoRule',
        style: {
            flex: 1
        }
    }, $acw62.createElement($07845dcbd4d38c15$var$RuleTabTitle, {
        showRadio: showRadioButtons,
        checked: type === 'NoRule'
    }, "No Condition")) : null, showNoRule ? $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: 'NoRule'
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:mb-2"
    }, 'Format Column is always applied')) : null, showPredicate ? $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: 'Predicate',
        style: {
            flex: 1
        }
    }, $acw62.createElement($07845dcbd4d38c15$var$RuleTabTitle, {
        showRadio: showRadioButtons,
        checked: type === 'Predicate'
    }, "Predicate")) : null, showPredicate ? $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        "data-name": "Predicate",
        value: "Predicate"
    }, $acw62.createElement((0, $998a30775a771eab$export$17396808b117a78c), {
        enablePredicateColumnId: props.enablePredicateColumnId,
        data: data,
        descriptions: descriptions,
        predicateDefs: filteredPredicateDefs,
        getPredicateDefsForColId: props.getPredicateDefsForColId,
        onChange: props.onChange
    })) : null, showBoolean ? $acw62.createElement($07845dcbd4d38c15$var$QueryTab, {
        showRadio: showRadioButtons,
        value: "BooleanExpression",
        type: type,
        label: "Boolean"
    }) : null, showBoolean ? $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        "data-name": "BooleanExpression",
        value: 'BooleanExpression'
    }, (()=>{
        const editor = $acw62.createElement((0, $5e4c4ab15f4fe7da$export$6f88ab97c822f23a), {
            type: 'boolean',
            module: module,
            value: data.Rule?.BooleanExpression,
            onChange: setBooleanExpression,
            initialData: initialData,
            columns: api.columnApi.internalApi.getQueryableColumnsForUIEditor(),
            fields: api.expressionApi.internalApi.getAvailableFields(),
            namedQueries: api.namedQueryApi.getNamedQueries(),
            api: api,
            showQueryBuilder: props.showQueryBuilder
        });
        return props.showQueryBuilder ? $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), null, editor) : editor;
    })()) : null, showObservable ? $acw62.createElement($07845dcbd4d38c15$var$QueryTab, {
        showRadio: showRadioButtons,
        value: "ObservableExpression",
        type: type,
        label: "Observable"
    }) : null, showObservable ? $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        "data-name": "ObservableExpression",
        value: 'ObservableExpression'
    }, $acw62.createElement((0, $5e4c4ab15f4fe7da$export$6f88ab97c822f23a), {
        type: 'observable',
        module: module,
        value: data.Rule?.ObservableExpression,
        onChange: setReactiveExpression,
        initialData: initialData,
        columns: api.columnApi.internalApi.getQueryableColumnsForUIEditor(),
        fields: api.expressionApi.internalApi.getAvailableFields(),
        namedQueries: api.namedQueryApi.getNamedQueries(),
        api: api
    })) : null, showAggregation ? $acw62.createElement($07845dcbd4d38c15$var$QueryTab, {
        showRadio: showRadioButtons,
        value: "AggregatedBooleanExpression",
        type: type,
        label: "Aggregated Boolean"
    }) : null, showAggregation ? $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        "data-name": "AggregatedBooleanExpression",
        value: 'AggregatedBooleanExpression'
    }, $acw62.createElement((0, $5e4c4ab15f4fe7da$export$6f88ab97c822f23a), {
        type: 'aggregatedBoolean',
        module: module,
        value: data.Rule?.AggregatedBooleanExpression,
        onChange: setAggregationExpression,
        initialData: initialData,
        columns: api.columnApi.internalApi.getQueryableColumnsForUIEditor(),
        fields: api.expressionApi.internalApi.getAvailableFields(),
        namedQueries: api.namedQueryApi.getNamedQueries(),
        api: api
    })) : null));
};




const $853205a7475f2bc9$export$5987c1f4d169c1ba = (api, scope, alertType)=>{
    let predicateDefs = [];
    if (alertType === 'DataChange' || alertType === 'Validation') {
        predicateDefs = api.alertApi.internalApi.getAlertPredicateDefsForScope(scope);
        predicateDefs = [
            ...predicateDefs
        ].sort((a, b)=>a.id === 'AnyChange' ? -1 : b.id === 'AnyChange' ? 1 : 0);
    }
    return predicateDefs;
};






const $f6efa6f233fb1737$export$10b881e8655be108 = (alertType)=>{
    switch(alertType){
        case 'DataChange':
            return $acw62.createElement($acw62.Fragment, null, "Build the Rule ", $acw62.createElement("b", null, "when"), " the Alert should trigger (using a Predicate or a Query)");
        case 'RowChange':
            return $acw62.createElement($acw62.Fragment, null, "Specify which type of Row Change will trigger the Alert");
        case 'Validation':
            return $acw62.createElement($acw62.Fragment, null, "Create the Validation Rule which will trigger the Alert (using a Predicate or a Query)");
        case 'Aggregation':
            return $acw62.createElement($acw62.Fragment, null, "Build an Aggregation Boolean Rule to specify when the Alert should trigger");
        case 'Observable':
            return $acw62.createElement($acw62.Fragment, null, "Build an Observable Rule to specify when the Alert should trigger");
    }
    return '';
};
const $f6efa6f233fb1737$export$8bac0f640071124e = (alertDefinition)=>{
    return $acw62.createElement((0, $07845dcbd4d38c15$export$f59a408a7cde7e1f), {
        data: alertDefinition,
        renderPredicate: (contents)=>{
            return $acw62.createElement($acw62.Fragment, null, "Alert Rule ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, contents));
        },
        renderQueryExpression: (contents)=>{
            return $acw62.createElement($acw62.Fragment, null, "Alert when ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, contents));
        }
    });
};
const $f6efa6f233fb1737$var$RowChangeEditor = (props)=>{
    const expression = props.alert.Rule?.ObservableExpression;
    const handleRowAddedChange = ()=>{
        props.onChange({
            ...props.alert,
            Rule: {
                ObservableExpression: 'ROW_ADDED()'
            }
        });
    };
    const handleRowRemovedChange = ()=>{
        props.onChange({
            ...props.alert,
            Rule: {
                ObservableExpression: 'ROW_REMOVED()'
            }
        });
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Row Change"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        onClick: ()=>handleRowAddedChange(),
        checked: expression?.includes((0, $58846ea7f4156db7$export$91649df232e67626))
    }, "Row Added"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        onClick: ()=>handleRowRemovedChange(),
        checked: expression?.includes((0, $58846ea7f4156db7$export$b6627549cf8ad25d))
    }, "Row Removed"))));
};
const $f6efa6f233fb1737$export$d86981d25fb8c4bd = (props)=>{
    const { data: data, api: api, moduleInfo: moduleInfo } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const predicateDefs = (0, $853205a7475f2bc9$export$5987c1f4d169c1ba)(api, data.Scope, props.alertType);
    const showObservable = props.alertType === 'Observable';
    const showAggregation = props.alertType === 'Aggregation';
    const showBoolean = props.alertType === 'DataChange' || props.alertType == 'Validation';
    const showPredicate = props.alertType === 'DataChange' || props.alertType == 'Validation';
    const enablePredicateColumnId = props.alertType === 'DataChange' || props.alertType == 'Validation';
    if (props.alertType === 'RowChange') return $acw62.createElement($f6efa6f233fb1737$var$RowChangeEditor, {
        alert: data,
        onChange: props.onChange
    });
    return $acw62.createElement((0, $07845dcbd4d38c15$export$958c7d77bf3113b), {
        module: moduleInfo.ModuleName,
        defaultPredicateId: "AnyChange",
        data: data,
        predicateDefs: predicateDefs,
        enablePredicateColumnId: enablePredicateColumnId,
        getPredicateDefsForColId: (colId)=>(0, $853205a7475f2bc9$export$5987c1f4d169c1ba)(api, {
                ColumnIds: [
                    colId
                ]
            }, props.alertType),
        onChange: props.onChange,
        showAggregation: showAggregation,
        showObservable: showObservable,
        showBoolean: showBoolean,
        showPredicate: showPredicate,
        descriptions: {
            selectPredicate: 'Build the Predicate',
            useBooleanQuery: $acw62.createElement($acw62.Fragment, null, "Use an BooleanQuery if ", $acw62.createElement("i", null, "Scope"), " is 'All Columns' - so any data change may be evaluated in a complex BooleanExpression"),
            useObservableQuery: $acw62.createElement($acw62.Fragment, null, "Use an ObservableQuery if ", $acw62.createElement("i", null, "Scope"), " is 'All Columns' - so any data change may be evaluated in a complex ObservableExpression"),
            useAggregationQuery: $acw62.createElement($acw62.Fragment, null, "Use an AggregatedBooleanQuery if ", $acw62.createElement("i", null, "Scope"), " is 'All Columns' - so any data change may be evaluated in a complex AggregatedBooleanExpression")
        }
    });
};


const $77459fc7566b1dde$export$509100fde248eb2b = (abObject, api, context)=>{
    if (abObject?.Rule?.Predicates?.length) {
        if (!api.predicateApi.isEveryPredicateValid(abObject?.Rule?.Predicates)) return `The predicate${abObject?.Rule?.Predicates?.length === 1 ? ' is' : 's are'} not valid.`;
    }
    if (abObject?.Rule?.BooleanExpression) {
        if (!api.expressionApi.isValidBooleanExpression(abObject?.Rule?.BooleanExpression, context.moduleInfo.ModuleName)) return 'The Boolean expression is not valid.';
    }
    if (abObject?.Rule?.ObservableExpression) {
        if (!api.expressionApi.isValidObservableExpression(abObject?.Rule?.ObservableExpression, context.moduleInfo.ModuleName)) return 'The Observable expression is not valid.';
    }
    if (abObject?.Rule?.AggregatedBooleanExpression) {
        if (!api.expressionApi.isValidAggregatedBooleanExpression(abObject?.Rule?.AggregatedBooleanExpression, context.moduleInfo.ModuleName)) return 'The Aggregated Boolean expression is not valid.';
    }
    if (abObject?.Rule?.Predicates?.length) {
        const isAPredicateWithInvalidColumnId = abObject?.Rule?.Predicates?.some((predicate)=>predicate.ColumnId !== undefined && predicate.ColumnId === '');
        if (isAPredicateWithInvalidColumnId) return 'Predicates with a custom scope require a valid column.';
    }
    return true;
};


const $cd1acc4a921695e0$export$84a7b3f2c4e99bad = (alert, api, context)=>{
    if (!alert.Rule.Predicates?.length && !alert.Rule.BooleanExpression && !alert.Rule.ObservableExpression && !alert.Rule.AggregatedBooleanExpression) return 'A rule is required for the Alert.';
    const isRuleValid = (0, $77459fc7566b1dde$export$509100fde248eb2b)(alert, api, context);
    if (typeof isRuleValid === 'string') return isRuleValid;
    // boolean expressions may also be saved as named queries
    if (context.namedQuery != false) {
        const isValidName = api.namedQueryApi.isValidNamedQuery(context.namedQuery);
        if (!isValidName.valid) return isValidName.message;
    }
    return true;
};



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




const $422a40ec82a0dd62$export$edde27ba6b07e9c8 = (props)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('ab-StylePreview twa:p-2 twa:mt-2', props.className), props.styleObject.ClassName),
        style: {
            ...(0, $0f8018328b88def3$export$b7b312ddf6b38c9f)(props.styleObject),
            ...props.style
        }
    }, props.children ?? 'Preview result');



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



const $4df338db1380ba8a$export$f3e27d70b3107db1 = $acw62.createContext({
    toggleButtons: [],
    activeIndex: -1
});
const $4df338db1380ba8a$export$af3ec21f6cfb5e30 = (props)=>{
    const ref = (0, $acw62.useRef)(null);
    const [context, setContext] = $acw62.useState({
        toggleButtons: [],
        activeIndex: 0
    });
    const setActiveIndex = $acw62.useCallback((index)=>{
        setContext((prev)=>({
                ...prev,
                activeIndex: index
            }));
    }, []);
    return $acw62.createElement($4df338db1380ba8a$export$f3e27d70b3107db1.Provider, {
        value: context
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        ref: ref,
        tabIndex: 0,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-Toggle-Group twa:shadow-sm', 'twa:bg-primary twa:text-text-on-primary', 'twa:rounded-standard twa:overflow-hidden', 'twa:inline-flex twa:w-fit', 'twa:focus:outline-0', // make the shadow of child Toggle buttons invisible when the group is not focused
        'twa:not-focus-within:[--ab-focus-light__box-shadow:none]', 'twa:not-focus-within:[--ab-focus__box-shadow:none]'),
        onMouseDown: (event)=>{
            const index = context.toggleButtons.findIndex((btn)=>(0, $a651380741b279ec$export$2e2bcd8739ae039)(btn.node, event.target));
            if (index !== -1) setActiveIndex(index);
        },
        onKeyDown: (event)=>{
            const { toggleButtons: toggleButtons, activeIndex: activeIndex } = context;
            if (event.key === ' ') {
                event.preventDefault();
                event.stopPropagation();
                const activeButton = toggleButtons[activeIndex];
                if (!activeButton) return;
                activeButton.toggle();
                return;
            }
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                event.preventDefault();
                event.stopPropagation();
                const node = ref.current;
                if (!node) return;
                const dir = event.key === 'ArrowLeft' ? -1 : 1;
                let nextIndex = activeIndex + dir;
                if (nextIndex < 0) nextIndex = toggleButtons.length - 1;
                else if (nextIndex > toggleButtons.length - 1) nextIndex = 0;
                setActiveIndex(nextIndex);
            }
        }
    }, props.children));
};


const $6d11e0f94e4885f4$var$baseClassName = 'ab-Toggle';
const $6d11e0f94e4885f4$export$bea8ebba691c5813 = ({ onPressedChange: onPressedChange, pressed: pressed, icon: icon, children: children, ...rest })=>{
    const onPressedChangeRef = $acw62.useRef(onPressedChange);
    $acw62.useLayoutEffect(()=>{
        onPressedChangeRef.current = onPressedChange;
    }, [
        onPressedChange
    ]);
    const pressedRef = $acw62.useRef(pressed);
    $acw62.useLayoutEffect(()=>{
        pressedRef.current = pressed;
    }, [
        pressed
    ]);
    const toggle = $acw62.useCallback(()=>onPressedChangeRef.current(!pressedRef.current), []);
    const toggleContext = $acw62.useContext((0, $4df338db1380ba8a$export$f3e27d70b3107db1));
    const [currentIndex, setCurrentIndex] = $acw62.useState(-1);
    const isActive = toggleContext.activeIndex === currentIndex;
    const ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!toggleContext || !toggleContext.toggleButtons) return;
        const thisButton = {
            node: ref.current,
            toggle: toggle
        };
        toggleContext.toggleButtons.push(thisButton);
        setCurrentIndex(toggleContext.toggleButtons.length - 1);
        return ()=>{
            const index = toggleContext.toggleButtons.indexOf(thisButton);
            if (index !== -1) toggleContext.toggleButtons.splice(index, 1);
        };
    }, [
        toggleContext
    ]);
    return $acw62.createElement("button", {
        ...rest,
        ref: ref,
        tabIndex: -1,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)((0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:border-0', 'twa:cursor-pointer twa:fill-current', 'twa:outline-0', 'twa:min-h-input twa:relative twa:py-1 twa:px-2', 'twa:not-first:after:content-[""] twa:not-first:after:border-l-2 twa:not-first:after:border-accent-foreground twa:not-first:after:h-[10px] twa:not-first:after:absolute twa:not-first:after:-left-px twa:not-first:after:top-1/2 twa:not-first:after:-translate-y-1/2', // backgrounds
        {
            'twa:text-inherit twa:bg-transparent': !pressed,
            'twa:hover:bg-primarylight twa:hover:text-text-on-primary': !pressed,
            [`${$6d11e0f94e4885f4$var$baseClassName}--pressed`]: pressed,
            'twa:bg-accent twa:hover:bg-accent/90 twa:text-accent-foreground': pressed
        }, {
            'twa:before:rounded-standard twa:before:content-[""] twa:before:absolute twa:before:inset-1 twa:before:z-20 twa:before:pointer-events-none': true,
            // let's display a shadow on the before pseudo element
            // when the toggle is active
            'twa:before:shadow-(--ab-focus-light__box-shadow)': isActive && pressed,
            'twa:before:shadow-(--ab-focus__box-shadow)': isActive && !pressed
        }, $6d11e0f94e4885f4$var$baseClassName)),
        onClick: toggle
    }, icon && $acw62.createElement((0, $9200d8ae4e589d35$export$f508444e7933c2b1), {
        icon: {
            name: icon
        }
    }), children);
};






var $hrtGQ = parcelRequire("hrtGQ");

var $9g4SS = parcelRequire("9g4SS");


var $9OAZF = parcelRequire("9OAZF");




var $acw62 = parcelRequire("acw62");



function $2f89a0dc2f97e4f0$export$60332b2344f7fe41(props) {
    const { shadow: shadow = true, children: children, className: className, style: style, gap: gap = 2 } = props;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:bg-defaultbackground twa:text-text-on-defaultbackground', 'ab-Card', 'twa:text-3', 'twa:rounded-standard twa:p-2', 'twa:flex twa:flex-col', {
            'twa:shadow-sm': shadow,
            'twa:gap-0': gap === 0,
            'twa:gap-1': gap === 1,
            'twa:gap-2': gap === 2,
            'twa:gap-3': gap === 3,
            'twa:gap-4': gap === 4,
            'twa:gap-8': gap === 8
        }, className),
        style: style
    }, children);
}
const $2f89a0dc2f97e4f0$var$CardTitle = (props)=>{
    const { children: children, className: className, gap: gap = 2, border: border = true } = props;
    return $acw62.createElement("div", {
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)((0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-Card__title', {
            'twa:flex twa:flex-row': true,
            'twa:items-center': true,
            'twa:text-4 twa:px-2': true,
            'twa:pb-2 twa:border-b': border,
            'twa:border-b-text-on-defaultbackground/20': true,
            'twa:gap-0': gap === 0,
            'twa:gap-1': gap === 1,
            'twa:gap-2': gap === 2,
            'twa:gap-3': gap === 3,
            'twa:gap-4': gap === 4,
            'twa:gap-8': gap === 8
        }, className))
    }, children);
};
const $2f89a0dc2f97e4f0$var$CardBody = (props)=>{
    const { children: children, gap: gap, className: className } = props;
    return $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-Card__body', 'twa:overflow-auto twa:min-h-0', 'twa:flex-1 twa:flex twa:flex-col', {
            'twa:gap-0': gap === 0,
            'twa:gap-1': gap === 1,
            'twa:gap-2': gap === 2,
            'twa:gap-3': gap === 3,
            'twa:gap-4': gap === 4,
            'twa:gap-8': gap === 8
        }, className)
    }, children);
};
$2f89a0dc2f97e4f0$export$60332b2344f7fe41.Title = $2f89a0dc2f97e4f0$var$CardTitle;
$2f89a0dc2f97e4f0$export$60332b2344f7fe41.Body = $2f89a0dc2f97e4f0$var$CardBody;


const $e629d4699b6af5c8$export$a7668fc2e148d940 = (props)=>{
    const [showClassName, setShowClassName] = (0, $acw62.useState)((0, $9OAZF.StringExtensions).IsNotNullOrEmpty(props.Style.ClassName));
    const componentStyle = props.Style;
    const setComponentStyle = (style)=>{
        props.UpdateStyle(style);
    };
    const onShowClassNameChanged = (checked)=>{
        const newStyle = {
            ...componentStyle
        };
        delete newStyle.BackColor;
        delete newStyle.ForeColor;
        delete newStyle.BorderColor;
        delete newStyle.FontSize;
        delete newStyle.FontStyle;
        delete newStyle.FontWeight;
        newStyle.ClassName = '';
        setComponentStyle(newStyle);
        setShowClassName(checked);
    };
    const onStyleClassNameChanged = (value)=>{
        const newStyle = {
            ...componentStyle
        };
        newStyle.ClassName = value == 'select' ? '' : value;
        setComponentStyle(newStyle);
    };
    const onUseBackColorCheckChange = (checked)=>{
        const newStyle = {
            ...componentStyle
        };
        if (checked) newStyle.BackColor = '#ffffff';
        else delete newStyle.BackColor;
        setComponentStyle(newStyle);
    };
    const onUseForeColorCheckChange = (checked)=>{
        const newStyle = {
            ...componentStyle
        };
        if (checked) newStyle.ForeColor = '#000000';
        else delete newStyle.ForeColor;
        setComponentStyle(newStyle);
    };
    const onUseBorderColorCheckChange = (checked)=>{
        const newStyle = {
            ...componentStyle
        };
        if (checked) newStyle.BorderColor = '#000000';
        else delete newStyle.BorderColor;
        setComponentStyle(newStyle);
    };
    const onBackColorSelectChange = (color)=>{
        const newStyle = {
            ...componentStyle
        };
        newStyle.BackColor = color;
        setComponentStyle(newStyle);
    };
    const onForeColorSelectChange = (color)=>{
        const newStyle = {
            ...componentStyle
        };
        newStyle.ForeColor = color;
        setComponentStyle(newStyle);
    };
    const onBorderColorSelectChange = (color)=>{
        const newStyle = {
            ...componentStyle
        };
        newStyle.BorderColor = color;
        setComponentStyle(newStyle);
    };
    const onFontWeightChange = (checked)=>{
        const newStyle = {
            ...componentStyle
        };
        if (checked) newStyle.FontWeight = (0, $hrtGQ.FontWeight).Bold;
        else delete newStyle.FontWeight;
        setComponentStyle(newStyle);
    };
    const onFontStyleChange = (checked)=>{
        const newStyle = {
            ...componentStyle
        };
        if (checked) newStyle.FontStyle = (0, $hrtGQ.FontStyle).Italic;
        else delete newStyle.FontStyle;
        setComponentStyle(newStyle);
    };
    const onTextDecorationChange = (textDecoration)=>{
        const newStyle = {
            ...componentStyle
        };
        newStyle.TextDecoration = textDecoration;
        if (textDecoration === 'None' || !textDecoration) delete newStyle.TextDecoration;
        setComponentStyle(newStyle);
    };
    const onBorderRadiusChange = (value)=>{
        const newStyle = {
            ...componentStyle
        };
        newStyle.BorderRadius = value;
        if (value === 0) delete newStyle.BorderRadius;
        setComponentStyle(newStyle);
    };
    const onFontSizeChange = (value)=>{
        const newStyle = {
            ...componentStyle
        };
        newStyle.FontSize = value;
        if (value === '' || value == 'Default') delete newStyle.FontSize;
        setComponentStyle(newStyle);
    };
    const onAlignmentChange = (alignment)=>{
        const newStyle = {
            ...componentStyle
        };
        newStyle.Alignment = alignment;
        if (alignment == 'Default') delete newStyle.Alignment;
        setComponentStyle(newStyle);
    };
    const Cmp = props.headless ? (0, $82c87f52da9ba110$export$e71c4d32a2263218) : (0, $6fe0561618a75b4b$export$2e2bcd8739ae039);
    const headerText = props.headerText ?? 'Style';
    const cmpProps = props.headless ? {} : {
        header: headerText,
        'data-name': 'style-component'
    };
    const styleClassNames = props.api.userInterfaceApi.getStyleClassNames();
    const colourSpellingVariant = props.api.internalApi.getCorrectEnglishVariant('Colour');
    const coloursSpellingVariant = props.api.internalApi.getCorrectEnglishVariant('colours');
    return $acw62.createElement(Cmp, {
        ...cmpProps,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)((0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-StyleComponent twa:text-3', props.className))
    }, (0, $9g4SS.default).IsNotNullOrEmpty(styleClassNames) ? $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        value: showClassName ? 'classname' : 'createstyle',
        onValueChange: (value)=>onShowClassNameChanged(value === 'classname')
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        "data-name": "show-class-name",
        value: "classname"
    }, "Use Style Class Name"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        "data-name": "create-style",
        value: "createstyle"
    }, "Create Style"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "classname"
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), {
        shadow: false
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, null, "CSS Class Name"), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, {
        gap: 2,
        className: "twa:p-1"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), null, "Select a CSS Class Name"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[15rem]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        options: (0, $9g4SS.default).IsNullOrEmpty(styleClassNames) ? [] : styleClassNames.map((item)=>({
                label: item,
                value: item
            })),
        value: componentStyle.ClassName,
        onChange: (value)=>onStyleClassNameChanged(value)
    })), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:m-2 twa:flex-2 twa:text-warn"
    }, 'Please ensure that the styles listed are in the current stylesheet')))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "createstyle"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:flex-1 twa:flex twa:flex-col twa:gap-2 twa:lg:flex-row"
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), {
        shadow: false,
        className: "twa:flex-1"
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, {
        gap: 2,
        className: "twa:grid twa:grid-cols-[auto_1fr_auto_1fr] twa:items-center twa:p-1"
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, {
        className: "twa:col-span-2"
    }, colourSpellingVariant, " & Border Properties"), $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:col-span-2"
    }, "Set ", coloursSpellingVariant, " by ticking a checkbox and selecting from the dropdown; leave unchecked to use cell's existing ", coloursSpellingVariant), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "set-background-color",
        value: "existing",
        checked: !!componentStyle.BackColor,
        onChange: (checked)=>onUseBackColorCheckChange(checked)
    }, "Back ", colourSpellingVariant), $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        disabled: componentStyle.BackColor == null,
        api: props.api,
        value: componentStyle.BackColor || '#ffffff',
        onChange: (x)=>onBackColorSelectChange(x)
    }), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "set-foreground-color",
        value: "existing",
        className: "twa:row-start-4",
        checked: componentStyle.ForeColor ? true : false,
        onChange: (checked)=>onUseForeColorCheckChange(checked)
    }, "Fore ", colourSpellingVariant), $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        className: "twa:row-start-4 twa:col-start-2",
        disabled: componentStyle.ForeColor == null,
        api: props.api,
        value: componentStyle.ForeColor || '#ffffff',
        onChange: (x)=>onForeColorSelectChange(x)
    }), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "set-border-color",
        value: "existing",
        className: "twa:row-start-5 twa:col-start-1",
        checked: componentStyle.BorderColor ? true : false,
        onChange: (checked)=>onUseBorderColorCheckChange(checked)
    }, "Border ", colourSpellingVariant), $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        disabled: componentStyle.BorderColor == null,
        api: props.api,
        className: "twa:row-start-5 twa:col-start-2",
        value: componentStyle.BorderColor || '#ffffff',
        onChange: (x)=>onBorderColorSelectChange(x)
    }), $acw62.createElement("span", {
        className: "twa:row-start-6"
    }, "Border Radius"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        className: "twa:w-[100px] twa:row-start-6",
        type: "number",
        min: "0",
        value: componentStyle.BorderRadius,
        onChange: (event)=>{
            const number = Number(event.target.value);
            if (isNaN(number)) onBorderRadiusChange(0);
            else onBorderRadiusChange(number);
        }
    }), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, {
        className: "twa:col-span-2 twa:col-start-3 twa:row-start-1"
    }, "Font Properties"), $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:self-stretch twa:col-span-2 twa:col-start-3 twa:row-start-2"
    }, "Set the font properties of the Style"), $acw62.createElement("span", null, "Font Style"), $acw62.createElement((0, $4df338db1380ba8a$export$af3ec21f6cfb5e30), null, $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        pressed: componentStyle.FontStyle == (0, $hrtGQ.FontStyle).Italic,
        onPressedChange: (checked)=>onFontStyleChange(checked),
        icon: "italic"
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        pressed: componentStyle.FontWeight == (0, $hrtGQ.FontWeight).Bold,
        onPressedChange: (checked)=>onFontWeightChange(checked),
        icon: "bold"
    })), $acw62.createElement("span", null, "Text Decoration"), $acw62.createElement((0, $4df338db1380ba8a$export$af3ec21f6cfb5e30), null, $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "underline",
        pressed: componentStyle.TextDecoration === 'Underline',
        onPressedChange: (checked)=>onTextDecorationChange(checked ? 'Underline' : 'None')
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "strikethrough",
        pressed: componentStyle.TextDecoration === 'LineThrough',
        onPressedChange: (checked)=>onTextDecorationChange(checked ? 'LineThrough' : 'None')
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "overline",
        pressed: componentStyle.TextDecoration === 'Overline',
        onPressedChange: (checked)=>onTextDecorationChange(checked ? 'Overline' : 'None')
    })), $acw62.createElement("span", null, "Font Size"), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        alignItems: "center"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        placeholder: "Default",
        options: [
            {
                label: 'Default',
                value: ''
            },
            ...(0, $3ca1f4c2b77d4ce9$export$51594d8e7854ff7d).getNames((0, $hrtGQ.FontSize)).map((enumName)=>({
                    label: enumName,
                    value: enumName
                }))
        ],
        value: componentStyle.FontSize?.toString() ?? '',
        onChange: (value)=>onFontSizeChange(value)
    })), $acw62.createElement("span", null, "Alignment"), $acw62.createElement((0, $4df338db1380ba8a$export$af3ec21f6cfb5e30), null, $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "align-left",
        pressed: componentStyle.Alignment === 'Left',
        onPressedChange: (pressed)=>pressed ? onAlignmentChange('Left') : onAlignmentChange('Default')
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "align-center",
        pressed: componentStyle.Alignment === 'Center',
        onPressedChange: (pressed)=>pressed ? onAlignmentChange('Center') : onAlignmentChange('Default')
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "align-right",
        pressed: componentStyle.Alignment === 'Right',
        onPressedChange: (pressed)=>pressed ? onAlignmentChange('Right') : onAlignmentChange('Default')
    }))))))) : $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:flex-1 twa:flex twa:flex-col twa:gap-2 twa:lg:flex-row"
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), {
        shadow: false,
        className: "twa:flex-1"
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, {
        gap: 2,
        className: "twa:grid twa:grid-cols-[auto_1fr_auto_1fr] twa:items-center twa:p-1"
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, {
        className: "twa:col-span-2"
    }, colourSpellingVariant, " & Border Properties"), $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:col-span-2"
    }, "Set ", coloursSpellingVariant, " by ticking a checkbox and selecting from the dropdown; leave unchecked to use cell's existing ", coloursSpellingVariant), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "set-background-color",
        value: "existing",
        checked: !!componentStyle.BackColor,
        onChange: (checked)=>onUseBackColorCheckChange(checked)
    }, "Back ", colourSpellingVariant), $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        disabled: componentStyle.BackColor == null,
        api: props.api,
        value: componentStyle.BackColor || '#ffffff',
        onChange: (x)=>onBackColorSelectChange(x)
    }), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "set-foreground-color",
        value: "existing",
        className: "twa:row-start-4",
        checked: componentStyle.ForeColor ? true : false,
        onChange: (checked)=>onUseForeColorCheckChange(checked)
    }, "Fore ", colourSpellingVariant), $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        className: "twa:row-start-4 twa:col-start-2",
        disabled: componentStyle.ForeColor == null,
        api: props.api,
        value: componentStyle.ForeColor || '#ffffff',
        onChange: (x)=>onForeColorSelectChange(x)
    }), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "set-border-color",
        value: "existing",
        className: "twa:row-start-5 twa:col-start-1",
        checked: componentStyle.BorderColor ? true : false,
        onChange: (checked)=>onUseBorderColorCheckChange(checked)
    }, "Border ", colourSpellingVariant), $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        disabled: componentStyle.BorderColor == null,
        api: props.api,
        className: "twa:row-start-5 twa:col-start-2",
        value: componentStyle.BorderColor || '#ffffff',
        onChange: (x)=>onBorderColorSelectChange(x)
    }), $acw62.createElement("span", {
        className: "twa:row-start-6"
    }, "Border Radius"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        className: "twa:w-[100px] twa:row-start-6",
        type: "number",
        min: "0",
        value: componentStyle.BorderRadius,
        onChange: (event)=>{
            const number = Number(event.target.value);
            if (isNaN(number)) onBorderRadiusChange(0);
            else onBorderRadiusChange(number);
        }
    }), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, {
        className: "twa:col-span-2 twa:col-start-3 twa:row-start-1"
    }, "Font Properties"), $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:self-stretch twa:col-span-2 twa:col-start-3 twa:row-start-2"
    }, "Set the font properties of the Style"), $acw62.createElement("span", null, "Font Style"), $acw62.createElement((0, $4df338db1380ba8a$export$af3ec21f6cfb5e30), null, $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        pressed: componentStyle.FontStyle == (0, $hrtGQ.FontStyle).Italic,
        onPressedChange: (checked)=>onFontStyleChange(checked),
        icon: "italic"
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        pressed: componentStyle.FontWeight == (0, $hrtGQ.FontWeight).Bold,
        onPressedChange: (checked)=>onFontWeightChange(checked),
        icon: "bold"
    })), $acw62.createElement("span", null, "Text Decoration"), $acw62.createElement((0, $4df338db1380ba8a$export$af3ec21f6cfb5e30), null, $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "underline",
        pressed: componentStyle.TextDecoration === 'Underline',
        onPressedChange: (checked)=>onTextDecorationChange(checked ? 'Underline' : 'None')
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "strikethrough",
        pressed: componentStyle.TextDecoration === 'LineThrough',
        onPressedChange: (checked)=>onTextDecorationChange(checked ? 'LineThrough' : 'None')
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "overline",
        pressed: componentStyle.TextDecoration === 'Overline',
        onPressedChange: (checked)=>onTextDecorationChange(checked ? 'Overline' : 'None')
    })), $acw62.createElement("span", null, "Font Size"), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        alignItems: "center"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        placeholder: "Default",
        options: [
            {
                label: 'Default',
                value: ''
            },
            ...(0, $3ca1f4c2b77d4ce9$export$51594d8e7854ff7d).getNames((0, $hrtGQ.FontSize)).map((enumName)=>({
                    label: enumName,
                    value: enumName
                }))
        ],
        value: componentStyle.FontSize?.toString() ?? '',
        onChange: (value)=>onFontSizeChange(value)
    })), $acw62.createElement("span", null, "Alignment"), $acw62.createElement((0, $4df338db1380ba8a$export$af3ec21f6cfb5e30), null, $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "align-left",
        pressed: componentStyle.Alignment === 'Left',
        onPressedChange: (pressed)=>pressed ? onAlignmentChange('Left') : onAlignmentChange('Default')
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "align-center",
        pressed: componentStyle.Alignment === 'Center',
        onPressedChange: (pressed)=>pressed ? onAlignmentChange('Center') : onAlignmentChange('Default')
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        icon: "align-right",
        pressed: componentStyle.Alignment === 'Right',
        onPressedChange: (pressed)=>pressed ? onAlignmentChange('Right') : onAlignmentChange('Default')
    }))))), !props.hidePreview && $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), {
        shadow: false
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, null, "Preview"), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, {
        className: "twa:grid twa:place-items-center"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:inline-block"
    }, $acw62.createElement((0, $422a40ec82a0dd62$export$edde27ba6b07e9c8), {
        className: "twa:mt-0",
        styleObject: componentStyle
    })))));
};









const $443db1da2653bcdc$var$HighlightStyle = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const options = [
        {
            label: 'Use Message Type',
            onClick: ()=>{
                props.onChange(true);
            }
        },
        {
            label: 'Custom Style',
            onClick: ()=>{
                const initialStyle = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyStyle();
                props.onChange(initialStyle);
            }
        }
    ];
    const options2 = [
        {
            label: 'Use Message Type',
            value: 'system'
        },
        {
            label: 'Custom Style',
            value: 'custom'
        }
    ];
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": props.dataName
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        className: "twa:mr-2 twa:items-start",
        checked: Boolean(props.highlight),
        onChange: (checked)=>{
            props.onChange(checked);
        }
    }, props.label), Boolean(props.highlight) && $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        options: options2,
        value: typeof props.highlight === 'boolean' ? 'system' : 'custom',
        onChange: (value)=>{
            if (value === 'system') props.onChange(true);
            else {
                const initialStyle = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyStyle();
                props.onChange(initialStyle);
            }
        }
    })), typeof props.highlight === 'object' && $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: "twa:m-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:pl-3"
    }, $acw62.createElement((0, $e629d4699b6af5c8$export$a7668fc2e148d940), {
        headless: true,
        api: adaptable.api,
        Style: props.highlight,
        UpdateStyle: (style)=>{
            props.onChange(style);
        }
    }))));
};
const $443db1da2653bcdc$export$a71c169934d04c24 = (alertDefinition)=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $443db1da2653bcdc$export$3d814a932c7c1dbc(alertDefinition, api);
};
const $443db1da2653bcdc$export$3d814a932c7c1dbc = (alert, api, allowWrap = false)=>{
    const { AlertProperties: AlertProperties = {} } = alert;
    const values = [
        AlertProperties.PreventEdit ? {
            label: 'Prevent Cell Edit',
            id: 'preventCellEdit'
        } : null,
        AlertProperties.HighlightCell ? {
            label: 'Highlight Cell',
            id: 'highlightCell'
        } : null,
        AlertProperties.HighlightRow ? {
            label: 'Highlight Row',
            id: 'highlightRow'
        } : null,
        AlertProperties.JumpToCell ? {
            label: 'Jump To Cell',
            id: 'jumptocell'
        } : null,
        AlertProperties.JumpToRow ? {
            label: 'Jump To Row',
            id: 'jumptorow'
        } : null,
        AlertProperties.ShowInDiv ? {
            label: $acw62.createElement($acw62.Fragment, null, "Show in ", $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), {
                className: "twa:p-0 twa:ml-1"
            }, `<div />`)),
            id: 'showInDiv'
        } : null,
        AlertProperties.LogToConsole ? {
            label: 'Log To Console',
            id: 'logtoconsole'
        } : null
    ].filter(Boolean);
    if (!values.length) values.push({
        label: 'No ' + api.internalApi.getCorrectEnglishVariant('Behaviour') + ' Selected',
        id: 'none'
    });
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $3283d8fe16778b21$export$cb17e1b962f1810f), null, values.map((x)=>{
        let label = $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:flex twa:items-center"
        }, x.label);
        if (x.id === 'highlightCell' && typeof AlertProperties.HighlightCell === 'object') label = $acw62.createElement((0, $422a40ec82a0dd62$export$edde27ba6b07e9c8), {
            styleObject: AlertProperties.HighlightCell,
            className: "twa:mt-0 twa:p-0"
        }, "Highlight Cell");
        if (x.id === 'highlightRow' && typeof AlertProperties.HighlightRow === 'object') label = $acw62.createElement((0, $422a40ec82a0dd62$export$edde27ba6b07e9c8), {
            styleObject: AlertProperties.HighlightRow,
            className: "twa:mt-0 twa:p-0"
        }, "Highlight Row");
        return $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
            key: x.id
        }, label);
    })));
};
const $443db1da2653bcdc$export$dd4a7d7f18c55ac6 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const { AlertProperties: AlertProperties = {} } = data;
    const rowRemovedAlert = api.alertApi.internalApi.isAlertDefinitionForRemovedRowChangeEvent(data);
    // data change only
    const hasPreventCellEdit = props.alertType === 'Validation';
    // except row change
    const hasHighlightCell = props.alertType !== 'RowChange';
    // except row removed
    const hasHighlightRow = !rowRemovedAlert;
    // except row changed
    const hasJumpToCell = props.alertType !== 'RowChange';
    // for all
    const showInSeparateDiv = true;
    // for all
    const logToConsole = true;
    // except row removed
    const hasJumpToRow = !rowRemovedAlert;
    const onChange = (AlertProperties)=>{
        props.onChange({
            ...data,
            AlertProperties: {
                ...data.AlertProperties,
                ...AlertProperties
            }
        });
    };
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, api.internalApi.getCorrectEnglishVariant('Behaviour')), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        className: "twa:flex twa:flex-col twa:gap-1"
    }, hasPreventCellEdit && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "prevent-cell-edit",
        style: {
            alignItems: 'flex-start'
        },
        checked: AlertProperties.PreventEdit,
        disabled: true
    }, "Prevent Cell Edit", $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:mt-1"
    }, "(automatically undo data change which triggered Alert)")), hasHighlightCell && $acw62.createElement($443db1da2653bcdc$var$HighlightStyle, {
        dataName: "highlight-cell",
        highlight: AlertProperties.HighlightCell,
        label: "Highlight Cell",
        onChange: (HighlightCell)=>{
            onChange({
                HighlightCell: HighlightCell
            });
        }
    }), hasHighlightRow && $acw62.createElement($443db1da2653bcdc$var$HighlightStyle, {
        dataName: "highlight-row",
        highlight: AlertProperties.HighlightRow,
        label: "Highlight Row",
        onChange: (HighlightRow)=>{
            onChange({
                HighlightRow: HighlightRow
            });
        }
    }), hasJumpToCell && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "jump-to-cell",
        checked: AlertProperties.JumpToCell,
        onChange: (JumpToCell)=>{
            onChange({
                JumpToCell: JumpToCell
            });
        }
    }, "Jump To Cell"), hasJumpToRow && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "jump-to-row",
        checked: AlertProperties.JumpToRow,
        onChange: (JumpToRow)=>{
            onChange({
                JumpToRow: JumpToRow
            });
        }
    }, "Jump To Row"), showInSeparateDiv && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "show-in-div",
        checked: AlertProperties.ShowInDiv,
        onChange: (ShowInDiv)=>{
            onChange({
                ShowInDiv: ShowInDiv
            });
        }
    }, "Show in separate ", $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), null, `<div />`), " element"), logToConsole && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "log-to-console",
        checked: AlertProperties.LogToConsole,
        onChange: (LogToConsole)=>{
            onChange({
                LogToConsole: LogToConsole
            });
        }
    }, "Log To Console")));
};




var $acw62 = parcelRequire("acw62");










const $62d4f6dea0aadb0e$export$4cdc4511bcb76c7f = ()=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, "Message Type ", $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), null, data.MessageType));
};
const $62d4f6dea0aadb0e$export$cf27617ff8d02ca8 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const messageType = data.MessageType;
    const messageText = api.alertApi.internalApi.getAlertDescriptionForDataChange(data);
    const messageHeader = data.MessageHeader;
    const showDocumentationLinks = api.internalApi.isDocumentationLinksDisplayed();
    const onMessageTextChange = (e)=>{
        const { value: value } = e.target;
        props.onChange({
            ...data,
            MessageText: value
        });
    };
    const onMessageHeaderChange = (e)=>{
        const { value: value } = e.target;
        props.onChange({
            ...data,
            MessageHeader: value
        });
    };
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        "data-name": "message-type"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Message Type"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $d6ef3253c01d4163$export$a98f0dcb43a68a25), {
        value: messageType,
        name: "messageType",
        orientation: "horizontal",
        onRadioChange: (MessageType)=>{
            props.onChange({
                ...data,
                MessageType: MessageType
            });
        }
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:ml-1",
        value: "Info"
    }, "Info"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:ml-4",
        value: "Success"
    }, "Success"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:ml-4",
        value: "Warning"
    }, "Warning"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:ml-4",
        value: "Error"
    }, "Error")))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        "data-name": "message-text",
        className: "twa:mt-2 twa:mb-3",
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Message Text"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:mt-3 twa:mb-2"
    }, "Text to display as the Alert Message (leave blank to show automated Message based on Alert Type)"), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Header"
    }, $acw62.createElement((0, $d541796d86c181e1$export$2e2bcd8739ae039), {
        className: "twa:min-w-[300px] twa:mt-2",
        rows: 3,
        placeholder: "(Use Default Header Message)",
        type: 'text',
        autoFocus: false,
        value: messageHeader ?? '',
        // placeholder="defaults to column name"
        onChange: (e)=>onMessageHeaderChange(e)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Message"
    }, $acw62.createElement((0, $d541796d86c181e1$export$2e2bcd8739ae039), {
        className: "twa:min-w-[300px] twa:mt-2",
        rows: 3,
        type: 'text',
        autoFocus: false,
        value: messageText ?? '',
        onChange: (e)=>onMessageTextChange(e)
    }))), showDocumentationLinks && $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        "data-name": "alert-message-documentation",
        className: "twa:mt-3 twa:mb-2 twa:p-0 twa:text-3"
    }, $acw62.createElement((0, $00c4532606fa3d4c$export$5a2ee34a0d054ab8), {
        className: "twa:mr-2",
        onClick: ()=>window.open((0, $53c62e7ff907ad8d$export$5a4f95df1865185a), '_blank')
    }), "See how to create dynamic Alert Messages using placeholders"))));
};



var $acw62 = parcelRequire("acw62");




const $71699b5aee4bce11$export$3f60d09dd2143243 = (data)=>{
    const { api: { columnScopeApi: scopeApi } } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const columnsInScope = scopeApi.getColumnsInScope(data.Scope);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, scopeApi.scopeIsAll(data.Scope) ? 'Changes to any Column in the row will trigger an Alert' : null)), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:overflow-hidden"
    }, 'ColumnIds' in data.Scope ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:text-2', columnsInScope.length ? 'twa:mb-2' : 'twa:mb-0')
    }, "Changes in selected columns will trigger an alert"), columnsInScope.length ? $acw62.createElement((0, $3283d8fe16778b21$export$f9fef0f55402315b), {
        tags: columnsInScope.map((c)=>c.friendlyName)
    }) : null) : null), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, 'DataTypes' in data.Scope ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:mb-2"
    }, "Changes in Columns with these Data Types trigger an Alert"), $acw62.createElement((0, $3283d8fe16778b21$export$f9fef0f55402315b), {
        tags: data.Scope.DataTypes.map((dataType)=>{
            return `DataType: ${dataType}`;
        })
    })) : null));
};








var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



const $dcb2921cee011924$export$f05b1ca029f2a070 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const getDefaultTags = ()=>{
        return api.internalApi.getAvailableTags() ?? [];
    };
    const { availableTags: availableTags = getDefaultTags(), selectedTags: selectedTags = [], onChange: onChange, singleSelect: singleSelect } = props;
    return $acw62.createElement((0, $d2ae5bba8d7d6225$export$98c0468e3210506e), {
        options: availableTags,
        value: selectedTags.map((tag)=>api.internalApi.getLabelForTag(tag)),
        singleSelect: singleSelect,
        allowReorder: false,
        onChange: (selectedTagsIds, selectedTagsMap)=>{
            onChange(selectedTagsIds.map((id)=>selectedTagsMap.get(id)));
        },
        toIdentifier: (tag)=>api.internalApi.getLabelForTag(tag),
        toLabel: (tag)=>api.internalApi.getLabelForTag(tag)
    });
};
const $dcb2921cee011924$export$aa81867a0520c2c5 = (props)=>{
    const { tags: tags = [] } = props;
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    return $acw62.createElement((0, $3283d8fe16778b21$export$f9fef0f55402315b), {
        tags: tags.map((tag)=>api.internalApi.getLabelForTag(tag))
    });
};



const $5e20d7539683bc9c$export$6c0fa642a4126977 = (props)=>{
    const { onChange: onChange } = props;
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Tags"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $dcb2921cee011924$export$f05b1ca029f2a070), {
        selectedTags: data.Tags,
        onChange: (selectedTags)=>onChange({
                ...data,
                Tags: selectedTags
            })
    })));
};
const $5e20d7539683bc9c$export$d2800d0dd3b55574 = (data)=>{
    return data.Tags?.length ? $acw62.createElement((0, $dcb2921cee011924$export$aa81867a0520c2c5), {
        tags: data.Tags
    }) : null;
};



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $a6b10ec9898965bc$export$31ff1d5d6736d74 = (props)=>$acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        onClick: ()=>props.onClick?.(),
        checked: props.checked,
        value: props.value
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, props.text), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:mt-1"
    }, props.description)));







const $4ab558a379fa0190$export$bd1cc8e0fb715366 = (data, api)=>{
    if (!data.Name?.trim()) return 'Name is required';
    const allAlerts = api.alertApi.getAlertDefinitions();
    const isDuplicateName = allAlerts.some((a)=>a.Name === data.Name && a.Uuid !== data.Uuid);
    if (isDuplicateName) return 'An Alert already exists with that name';
    return true;
};
const $4ab558a379fa0190$export$e9e32ee4c706499f = (alertType)=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const text = (0, $2ce1445b81dc66ec$export$54be866b9f5db346)(alertType);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), null, "Name ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.Name || 'Not specified')), $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), null, "Type ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, text)));
};
const $4ab558a379fa0190$export$6cde3a41ea7a6d15 = (props)=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const handleNameChange = (event)=>{
        props.onChange({
            ...data,
            Name: event.target.value
        });
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "alert-name",
        className: "twa:flex-1 twa:max-w-[200px] twa:mr-3",
        onChange: handleNameChange,
        placeholder: "Enter Name",
        value: data.Name ?? ''
    }))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mt-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Alert Type"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: (0, $2ce1445b81dc66ec$export$54be866b9f5db346)((0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).DataChange),
        description: "A change has been made to the Grid's underlying data",
        checked: props.alertType === (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).DataChange,
        onClick: ()=>props.onAlertTypeChange((0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).DataChange)
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: (0, $2ce1445b81dc66ec$export$54be866b9f5db346)((0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).RowChange),
        description: "A Row was added or removed from the data source",
        checked: props.alertType === (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).RowChange,
        onClick: ()=>props.onAlertTypeChange((0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).RowChange)
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: (0, $2ce1445b81dc66ec$export$54be866b9f5db346)((0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Aggregation),
        description: "A change has been made to aggregated data (i.e. from multiple Rows)",
        onClick: ()=>props.onAlertTypeChange((0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Aggregation),
        checked: props.alertType === (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Aggregation
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: (0, $2ce1445b81dc66ec$export$54be866b9f5db346)((0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Observable),
        description: "A specified change (or lack of change) over time has been observed in the Grid",
        onClick: ()=>props.onAlertTypeChange((0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Observable),
        checked: props.alertType === (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Observable
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: (0, $2ce1445b81dc66ec$export$54be866b9f5db346)((0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Validation),
        description: "A change has broken a data validation rule",
        checked: props.alertType === (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Validation,
        onClick: ()=>props.onAlertTypeChange((0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Validation)
    })))));
};



const $41aa61f42a6f304a$export$76c142a37bbdb59e = (api, alertDefinition)=>{
    const isRemovedRowChangeAlert = api.alertApi.internalApi.isAlertDefinitionForRemovedRowChangeEvent(alertDefinition);
    const mapValidButtonActions = (alertCommand)=>{
        if (isRemovedRowChangeAlert) {
            if (alertCommand === 'highlight-row' || alertCommand === 'jump-to-row') return null;
            return alertCommand;
        }
    };
    // the only case needed is when changing from AddedRow to RemovedRow
    // map FormButton Actions
    if (alertDefinition.AlertForm && typeof alertDefinition.AlertForm !== 'string') {
        const alertButtons = alertDefinition.AlertForm?.Buttons;
        alertButtons?.forEach((alertButton)=>{
            const alertCommand = alertButton.Command;
            if (Array.isArray(alertCommand)) alertButton.Command = alertCommand.map(mapValidButtonActions).filter(Boolean);
            else alertButton.Command = mapValidButtonActions(alertCommand);
        });
    }
    // behaviours
    if (isRemovedRowChangeAlert) {
        delete alertDefinition.AlertProperties.HighlightRow;
        delete alertDefinition.AlertProperties.JumpToRow;
    }
    return alertDefinition;
};




const $7345ff8b94b4a664$export$6ff65adf5c64964d = (alertDefinition, type)=>{
    const newAlert = {
        ...(0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyAlertDefinition(),
        Uuid: alertDefinition.Uuid
    };
    // can only be all
    if (type === (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Observable || type === (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Aggregation || type === (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).RowChange) newAlert.Scope = {
        All: true
    };
    if (type === (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).RowChange) newAlert.Rule = {
        ObservableExpression: 'ROW_ADDED()'
    };
    if (type === (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Validation) newAlert.AlertProperties = {
        PreventEdit: true
    };
    return newAlert;
};



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");






var $9OAZF = parcelRequire("9OAZF");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");






const $c0e313d6891b458a$var$IconButton = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onClick: ()=>props.onClick(),
        className: "twa:p-2",
        variant: props.active ? 'raised' : 'text',
        tone: props.active ? 'accent' : 'none',
        icon: props.icon
    }, props.children);
};
const $c0e313d6891b458a$export$bb3d1c4441733eac = (props)=>{
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const allIconsNames = Object.keys((0, $124c9aa27215a392$export$6aa6ecf6e8a98784));
    const filteredIcons = query ? allIconsNames.filter((iconName)=>{
        return iconName.toLowerCase().includes(query.toLowerCase());
    }) : allIconsNames;
    const iconsElements = filteredIcons.map((iconName)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            key: iconName
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c0e313d6891b458a$var$IconButton, {
            onClick: ()=>props.onChange(iconName),
            active: iconName === props.value,
            icon: iconName
        }));
    });
    const customIconsElements = props.customIcons?.map((def)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c0e313d6891b458a$var$IconButton, {
            key: def.name,
            active: false,
            onClick: ()=>props.onChange(def.name)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9200d8ae4e589d35$export$f508444e7933c2b1), {
            key: def.name,
            icon: def.icon
        }));
    });
    const popup = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-IconSelector__Popup"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-2 twa:text-4"
    }, "Select an Icon"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        value: query,
        onChange: (event)=>setQuery(event.target.value ?? ''),
        className: "twa:w-full"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:p-2 twa:w-[300px] twa:max-h-[300px] twa:overflow-auto twa:flex-wrap"
    }, iconsElements, " ", customIconsElements));
    let value = 'No Icon Selected';
    if (props.value in (0, $124c9aa27215a392$export$6aa6ecf6e8a98784)) value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        style: {
            display: 'inline-block'
        },
        name: props.value
    });
    else {
        const icon = props.customIcons?.find((def)=>def.name === props.value);
        if (icon) value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9200d8ae4e589d35$export$f508444e7933c2b1), {
            icon: icon.icon
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-IconSelector"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c9ce1fb924ab724e$export$2e2bcd8739ae039), {
        preventPortalEventPropagation: false,
        render: ()=>popup,
        showEvent: "mouseenter",
        hideEvent: "mouseleave",
        hideDelay: 300
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        className: "ab-IconSelector__trigger twa:text-center twa:w-[150px] twa:justify-center",
        onClick: ()=>null,
        variant: "raised"
    }, value)), (props.clearable ?? true) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        disabled: !props.value,
        className: "ab-IconSelector__clear-button twa:ml-2",
        onClick: (event)=>{
            event.stopPropagation();
            event.preventDefault();
            props.onChange('');
        },
        variant: "text",
        icon: "close"
    }));
};





const $141cb6e18289a62f$export$1d1f94b6ce72c6ac = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const customIcons = adaptable.api.userInterfaceApi.getCustomIcons();
    return $acw62.createElement((0, $c0e313d6891b458a$export$bb3d1c4441733eac), {
        customIcons: customIcons,
        ...props
    });
};





function $888c33dfb66d41e0$var$renderCommand(command) {
    switch(command){
        case 'highlight-cell':
            return 'Highlight Cell';
        case 'highlight-row':
            return 'Highlight Row';
        case 'jump-to-cell':
            return 'Jump to Cell';
        case 'jump-to-column':
            return 'Jump to Column';
        case 'jump-to-row':
            return 'Jump to Row';
        case 'suspend':
            return 'Suspend';
        case 'undo':
            return 'Undo';
        default:
            return command;
    }
}
const $888c33dfb66d41e0$var$TONE_OPTIONS = [
    {
        label: 'Tone: Use Alert Tone',
        value: 'text'
    },
    ...[
        'success',
        'info',
        'error',
        'warning',
        'accent',
        'neutral'
    ].map((tone)=>{
        return {
            label: $888c33dfb66d41e0$var$renderTone({
                label: (0, $9OAZF.default).CapitaliseFirstLetter(tone),
                value: tone
            }),
            value: tone
        };
    })
];
function $888c33dfb66d41e0$var$renderTone(option) {
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        alignItems: "center"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        className: "twa:mr-2 twa:w-[10px] twa:h-[10px] twa:line-height-0 twa:rounded-[100%] twa:bg-current",
        tone: option.value,
        variant: "text"
    }), option.label);
}
const $888c33dfb66d41e0$export$4a937ae8c57828bf = (props)=>{
    const { api: api, adaptableAlert: adaptableAlert } = props;
    const onChange = (newButtons)=>{
        props.onChange(newButtons);
    };
    const alertDefinition = adaptableAlert.alertDefinition;
    // const rowAddedAlert =
    //  api.alertApi.internalApi.isAlertDefinitionForAddedRowChangeEvent(alertDefinition);
    const isRowRemovedAlert = api.alertApi.internalApi.isAlertDefinitionForRemovedRowChangeEvent(alertDefinition);
    // except row change
    const hasHighlightCell = props.alertType !== 'RowChange';
    // all, except row removed
    const hasHighlightRow = !isRowRemovedAlert;
    // except row removed
    const hasJumpToCell = props.alertType !== 'RowChange';
    // all
    const hasJumpToRow = !isRowRemovedAlert;
    // all
    const hasSuspend = true;
    // only data change
    const hasUndo = props.alertType === 'DataChange';
    const AlertButtons = (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(props.AlertButtons || []) || [];
    const buttonCommands = [];
    if (hasHighlightRow) buttonCommands.push('highlight-row');
    if (hasJumpToRow) buttonCommands.push('jump-to-row');
    if (hasHighlightCell) buttonCommands.push('highlight-cell');
    if (hasJumpToCell) buttonCommands.push('jump-to-cell');
    if (hasUndo) buttonCommands.push('undo');
    if (hasSuspend) buttonCommands.push('suspend');
    const commandHandlers = api.optionsApi.getAlertOptions().commandHandlers;
    if (commandHandlers) commandHandlers.forEach((ch)=>{
        buttonCommands.push(ch.name);
    });
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:mt-3 twa:mb-2"
    }, "Add Buttons to the Alert Notification, and set Actions to perform when the Button is clicked"), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        icon: "plus",
        onClick: ()=>{
            onChange([
                ...AlertButtons || [],
                {
                    Label: 'OK',
                    ButtonStyle: {
                        variant: 'raised'
                    }
                }
            ]);
        }
    }, "Add")), AlertButtons.map((button, index)=>{
        let buttonStyle = button.ButtonStyle;
        let buttonLabel = button.Label;
        let btnCommands = [];
        if (button.Command && typeof button.Command === 'string') btnCommands = [
            button.Command
        ];
        else if (button.Command && Array.isArray(button.Command)) btnCommands = button.Command;
        // filter out the adaptable standard commands
        const btnUserFunctions = btnCommands.filter((command)=>!buttonCommands.includes(command));
        const setVariant = (variant)=>{
            onChange(AlertButtons.map((btn, i)=>{
                if (i === index) {
                    const buttonStyle = {
                        ...btn.ButtonStyle
                    };
                    buttonStyle.variant = variant;
                    return {
                        ...btn,
                        ButtonStyle: buttonStyle
                    };
                }
                return btn;
            }));
        };
        const setTone = (tone)=>{
            onChange(AlertButtons.map((btn, i)=>{
                if (i === index) {
                    const buttonStyle = {
                        ...btn.ButtonStyle
                    };
                    if (tone == null) delete buttonStyle.tone;
                    else buttonStyle.tone = tone;
                    return {
                        ...btn,
                        ButtonStyle: buttonStyle
                    };
                }
                return btn;
            }));
        };
        const handleCommandChange = (checked, commandName)=>{
            let commands = btnCommands;
            if (!checked) // remove current Command
            commands = commands.filter((a)=>a !== commandName);
            else commands = [
                ...commands,
                commandName
            ];
            onChange(AlertButtons.map((btn, i)=>{
                if (i === index) return {
                    ...btn,
                    Command: commands.length ? commands : undefined
                };
                return btn;
            }));
        };
        let iconSelector = null;
        if (!button.icon || button.icon && 'name' in button.icon) iconSelector = $acw62.createElement((0, $141cb6e18289a62f$export$1d1f94b6ce72c6ac), {
            value: button.icon && 'name' in button.icon ? button?.icon?.name : '',
            onChange: (iconName)=>{
                onChange(AlertButtons.map((btn)=>{
                    if (btn === button) return {
                        ...btn,
                        icon: {
                            name: iconName
                        }
                    };
                    return btn;
                }));
            }
        });
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            key: index,
            className: "twa:ml-3",
            style: {
                borderTop: index ? '1px dashed var(--ab-color-inputborder)' : ''
            }
        }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
            className: "twa:mb-2 twa:pt-2"
        }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            label: $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:text-2 twa:whitespace-nowrap"
            }, "Button Text")
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "row"
        }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
            value: buttonLabel,
            className: "twa:mr-2 twa:w-[80px]",
            onChange: (e)=>{
                onChange(AlertButtons.map((btn, i)=>{
                    if (i === index) return {
                        ...btn,
                        Label: e.target.value
                    };
                    return btn;
                }));
            }
        }), $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
            options: [
                'text',
                'outlined',
                'raised'
            ].map((variant)=>{
                return {
                    label: (0, $9OAZF.default).CapitaliseFirstLetter(variant),
                    value: variant
                };
            }),
            renderSingleValue: (option)=>`Variant: ${option.label}`,
            value: buttonStyle?.variant,
            onChange: (value)=>{
                setVariant(value);
            }
        }), $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
            className: "twa:ml-2",
            options: $888c33dfb66d41e0$var$TONE_OPTIONS,
            onChange: (value)=>{
                if (value === 'text') {
                    setTone(null);
                    return;
                }
                setTone(value);
            },
            value: buttonStyle?.tone ?? 'text'
        }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            icon: "close",
            tone: "error",
            disabled: AlertButtons.length <= 1,
            className: "twa:ml-1",
            variant: "text",
            tooltip: AlertButtons.length <= 1 ? 'Cannot remove last button' : 'Remove button',
            onClick: ()=>{
                onChange(AlertButtons.filter((btn)=>btn !== button));
            }
        }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            label: $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:text-2"
            }, "Actions")
        }, buttonCommands.map((commandName)=>{
            return $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                key: commandName,
                className: "twa:mr-3",
                onChange: (checked)=>handleCommandChange(checked, commandName),
                checked: button.Command === commandName || Array.isArray(button.Command) && button.Command.includes(commandName)
            }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:text-2"
            }, (0, $eba08d324485aa80$export$2e2bcd8739ae039)(commandName)));
        }), btnUserFunctions.length ? $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            checked: true,
            disabled: true
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:text-2"
        }, "User function", btnUserFunctions.length > 1 ? 's' : '', ":", ' ', btnUserFunctions.join(', '))) : null), iconSelector && $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            label: $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:text-2"
            }, "Icon")
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, iconSelector))));
    }));
};




const $4746f319f74b26c9$export$d6c01f2528677bfa = ()=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    if (!data.AlertProperties?.DisplayNotification) return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, "No Alert Notification will be displayed");
    return $acw62.createElement($4746f319f74b26c9$export$f084502b66b64510, {
        api: api,
        alertDefinition: data
    });
};
const $4746f319f74b26c9$export$f084502b66b64510 = ({ alertDefinition: alertDefinition, api: api, focusFirstButton: focusFirstButton, ...boxProps })=>{
    const mapButtons = $acw62.useCallback((button)=>{
        let buttonStyle = button.ButtonStyle;
        if (buttonStyle && buttonStyle.tone == null && alertDefinition?.MessageType) return {
            ...button,
            ButtonStyle: {
                tone: alertDefinition.MessageType.toLowerCase(),
                ...buttonStyle
            }
        };
        return button;
    }, [
        alertDefinition?.MessageType
    ]);
    const alertToPreview = $acw62.useMemo(()=>{
        const alertForm = alertDefinition.AlertForm || api.alertApi.internalApi.getDefaultAlertNotificationForm();
        if (typeof alertForm !== 'string') alertForm.Buttons = (alertForm.Buttons ?? []).map(mapButtons);
        const result = {
            alertType: 'generic',
            header: api.alertApi.internalApi.getAlertMessageHeaderForDataChange(alertDefinition),
            message: api.alertApi.internalApi.getAlertDescriptionForDataChange(alertDefinition),
            alertDefinition: {
                ...alertDefinition,
                AlertForm: alertForm
            }
        };
        return result;
    }, [
        alertDefinition
    ]);
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...boxProps,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-AlertPreview', boxProps.className),
        style: {
            border: '1px solid var(--ab-color-inputborder)',
            ...boxProps.style
        }
    }, $acw62.createElement((0, $cf3a9ab64121b7b4$export$32f30a30fea9be7d), {
        headless: true,
        focusFirstButton: focusFirstButton,
        adaptableAlert: alertToPreview,
        onClose: ()=>{}
    }));
};
const $4746f319f74b26c9$export$171c58391c2d67c1 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const adaptableAlert = {
        alertType: 'generic',
        header: data.MessageType,
        message: '',
        alertDefinition: data
    };
    if (data.AlertProperties.DisplayNotification && data.AlertForm == undefined) data.AlertForm = api.alertApi.internalApi.getDefaultAlertNotificationForm();
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        "data-name": "display-options",
        className: "twa:mt-2 twa:mb-3",
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Notification Options"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement("div", null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: data.AlertProperties?.DisplayNotification,
        onChange: (DisplayNotification)=>{
            const newAlertDefinition = {
                ...data,
                AlertProperties: {
                    ...data.AlertProperties,
                    DisplayNotification: DisplayNotification
                }
            };
            if (!DisplayNotification && typeof newAlertDefinition.AlertForm === 'object') delete newAlertDefinition.AlertForm.Buttons;
            if (DisplayNotification && newAlertDefinition.AlertForm == undefined) newAlertDefinition.AlertForm = api.alertApi.internalApi.getDefaultAlertNotificationForm();
            // make sure we have at least one button
            if (typeof newAlertDefinition.AlertForm === 'object' && (!newAlertDefinition.AlertForm?.Buttons || newAlertDefinition.AlertForm?.Buttons?.length === 0)) newAlertDefinition.AlertForm.Buttons = [
                api.alertApi.internalApi.getDefaultButton()
            ];
            props.onChange(newAlertDefinition);
        }
    }, "Display a Notification when Alert is triggered (with action buttons)")), data.AlertProperties?.DisplayNotification ? typeof data.AlertForm === 'string' ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, "Alert buttons cannot be customized because form is dynamically driven") : $acw62.createElement((0, $888c33dfb66d41e0$export$4a937ae8c57828bf), {
        alertType: props.alertType,
        AlertButtons: data.AlertForm?.Buttons,
        api: api,
        adaptableAlert: adaptableAlert,
        onChange: (buttons)=>{
            props.onChange({
                ...data,
                AlertForm: {
                    ...data.AlertForm,
                    Buttons: buttons
                }
            });
        }
    }) : null)), data.AlertProperties?.DisplayNotification ? $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        "data-name": "alert-preview",
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Alert Preview"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, typeof data.AlertForm === 'string' ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, "Preview not available because form is dynamically driven") : $acw62.createElement($4746f319f74b26c9$export$f084502b66b64510, {
        alertDefinition: data,
        api: api
    }))) : null);
};



const $e6af449f45fc03f9$export$260f3559d9f55805 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const behaviourSpelling = api.internalApi.getCorrectEnglishVariant('Behaviour');
    const [alertDefinition, doSetAlertDefinition] = (0, $acw62.useState)(()=>{
        const alertDefinition = props.data ? (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(props.data) : (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyAlertDefinition();
        if (!alertDefinition.Rule?.BooleanExpression && !alertDefinition.Rule?.ObservableExpression && !alertDefinition.Rule?.AggregatedBooleanExpression && !alertDefinition.Rule?.Predicates) alertDefinition.Rule = {
            BooleanExpression: ''
        };
        if (props.popupParams?.column && props.popupParams?.action === 'New') alertDefinition.Scope = {
            ColumnIds: [
                props.popupParams.column.columnId
            ]
        };
        alertDefinition.MessageType = alertDefinition.MessageType ?? (0, $c6e8cf0de7823bb0$export$6a864bfd495b17de);
        return alertDefinition;
    });
    const setAlertDefinition = (0, $acw62.useCallback)((data)=>{
        doSetAlertDefinition(data);
    }, []);
    // Alert type is based initialy on data, but can be changed by the user
    // the default objects do not neccesary have enough information to determine the type
    const [alertType, setAlertType] = (0, $acw62.useState)(()=>{
        return (0, $2ce1445b81dc66ec$export$9d1c84ef9916433c)(alertDefinition) ?? (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).DataChange;
    });
    const handleFinish = ()=>{
        if (props.data) dispatch($0040cfd693076bab$export$5616824fed3efc2a(alertDefinition));
        else dispatch($0040cfd693076bab$export$48fb1d70acb0b9bf(alertDefinition));
        props.onCloseWizard();
    };
    const updateAlertDefinition = (0, $acw62.useCallback)((newAlertDefinition)=>{
        doSetAlertDefinition((0, $41aa61f42a6f304a$export$76c142a37bbdb59e)(api, newAlertDefinition));
    }, [
        api
    ]);
    const handleAlertTypeChange = (newAlertType)=>{
        setAlertType(newAlertType);
        doSetAlertDefinition((0, $7345ff8b94b4a664$export$6ff65adf5c64964d)(alertDefinition, newAlertType));
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        modal: props.modal,
        data: alertDefinition,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Name & Type',
                isValid: (0, $4ab558a379fa0190$export$bd1cc8e0fb715366),
                details: $acw62.createElement($acw62.Fragment, null, "Enter Name and select ", $acw62.createElement("b", null, "what"), " type of change in AdapTable will cause the Alert to fire"),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $4ab558a379fa0190$export$6cde3a41ea7a6d15), {
                        alertType: alertType,
                        onAlertTypeChange: handleAlertTypeChange,
                        onChange: setAlertDefinition
                    })),
                renderSummary: ()=>(0, $4ab558a379fa0190$export$e9e32ee4c706499f)(alertType)
            },
            {
                title: 'Trigger',
                isVisible: ()=>alertType === (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).DataChange || alertType == (0, $2ce1445b81dc66ec$export$5b4a8869eb24d061).Validation,
                details: $acw62.createElement($acw62.Fragment, null, "Specify ", $acw62.createElement("b", null, "where"), " data changes should trigger the Alert"),
                isValid: (0, $65308a7002d19b3b$export$37abad8a5da7760),
                render: ()=>$acw62.createElement((0, $a9e941bf6e825744$export$21a542085efa7195), {
                        alertType: alertType,
                        onChange: setAlertDefinition
                    }),
                renderSummary: (0, $71699b5aee4bce11$export$3f60d09dd2143243)
            },
            {
                title: 'Rule',
                details: (0, $f6efa6f233fb1737$export$10b881e8655be108)(alertType),
                isValid: (0, $cd1acc4a921695e0$export$84a7b3f2c4e99bad),
                render: ()=>$acw62.createElement((0, $f6efa6f233fb1737$export$d86981d25fb8c4bd), {
                        alertType: alertType,
                        onChange: updateAlertDefinition,
                        module: "alert"
                    }),
                renderSummary: (0, $f6efa6f233fb1737$export$8bac0f640071124e)
            },
            {
                title: 'Message',
                details: "Select the Alert's Message Type and Text",
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $62d4f6dea0aadb0e$export$cf27617ff8d02ca8), {
                        alertType: alertType,
                        onChange: setAlertDefinition
                    })),
                renderSummary: (0, $62d4f6dea0aadb0e$export$4cdc4511bcb76c7f)
            },
            {
                title: 'Notification',
                details: 'Create a Notification for the Alert',
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $4746f319f74b26c9$export$171c58391c2d67c1), {
                        alertType: alertType,
                        onChange: setAlertDefinition
                    })),
                renderSummary: (0, $4746f319f74b26c9$export$d6c01f2528677bfa)
            },
            {
                title: behaviourSpelling,
                details: 'Configure ' + behaviourSpelling + 's for the Alert',
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $443db1da2653bcdc$export$dd4a7d7f18c55ac6), {
                        alertType: alertType,
                        onChange: setAlertDefinition
                    })),
                renderSummary: (0, $443db1da2653bcdc$export$a71c169934d04c24)
            },
            {
                details: 'Select Alert Tags',
                title: 'Tags',
                isVisible: ()=>api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setAlertDefinition
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                details: 'Review your Alert',
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null)),
                title: 'Summary'
            }
        ]
    });
};





const $c7c3edfc9c6a6a6c$var$BehaviourView = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    return (0, $443db1da2653bcdc$export$3d814a932c7c1dbc)(props.data, adaptable.api, true);
};
const $c7c3edfc9c6a6a6c$export$f101f297e6a3688c = (api)=>{
    return {
        name: api.internalApi.getCorrectEnglishVariant('Behaviour'),
        view: $c7c3edfc9c6a6a6c$var$BehaviourView
    };
};



var $acw62 = parcelRequire("acw62");


const $e81284d1c834c71d$export$39e60b309c2e7b57 = (alert, api)=>{
    return {
        name: 'Type and Display',
        view: ()=>{
            if (!alert?.AlertProperties?.DisplayNotification) return $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, alert.MessageType);
            return $acw62.createElement((0, $4746f319f74b26c9$export$f084502b66b64510), {
                focusFirstButton: false,
                className: "twa:max-w-[400px] twa:mt-2",
                api: api,
                alertDefinition: alert
            });
        }
    };
};



const $dd4c85632ca371c1$export$806862642c3fa057 = (alert)=>{
    const alertType = (0, $2ce1445b81dc66ec$export$9d1c84ef9916433c)(alert);
    const text = (0, $2ce1445b81dc66ec$export$54be866b9f5db346)(alertType);
    return {
        name: 'Type',
        values: [
            text
        ]
    };
};


class $c2cfd3844e646d31$export$d4fd38c7e1150c4c extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    isListeningToCellDataChanges;
    constructor(api){
        super($42e863194fcb493f$export$40024cb74c2bb550, $42e863194fcb493f$export$f97c8e368b37bea9, 'alert', 'AlertPopup', 'Get notified when things happen in Adaptable that you need to know about', api);
        this.isListeningToCellDataChanges = false;
    }
    onAdaptableReady() {
        this.checkListenToCellDataChanged();
    }
    shouldListenToDataChanges() {
        return (0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(this.api.alertApi.getActiveAlertDefinitions());
    }
    checkListenToCellDataChanged() {
        if (!this.isListeningToCellDataChanges) {
            if (this.shouldListenToDataChanges()) {
                this.setupCellDataChangeListener();
                this.isListeningToCellDataChanges = true;
            }
        }
    }
    setupCellDataChangeListener() {
        this.api.internalApi.getDataService().on('CellDataChanged', (cellDataChangedInfo)=>{
            let shouldIgnoreChange = false;
            if (cellDataChangedInfo.trigger === 'undo') shouldIgnoreChange = true;
            if (cellDataChangedInfo.trigger === 'aggChange') shouldIgnoreChange = !cellDataChangedInfo.column.isGeneratedPivotResultColumn;
            if (shouldIgnoreChange) // do NOT handle reverted or aggregated changes
            return;
            if (this.api.optionsApi.getAlertOptions().dataChangeDetectionPolicy === 'formattedValue') {
                const { oldValue: oldValue, newValue: newValue, rowNode: rowNode } = cellDataChangedInfo;
                const columnId = cellDataChangedInfo.column.columnId;
                const oldFormattedValue = this.api.gridApi.getDisplayValueFromRawValue(rowNode, columnId, oldValue);
                const newFormattedValue = this.api.gridApi.getDisplayValueFromRawValue(rowNode, columnId, newValue);
                if (oldFormattedValue === newFormattedValue) // if the formattedValues are identical, then no alert is fired
                return;
            }
            this.handleCellDataChanged(cellDataChangedInfo);
        });
        this.api.internalApi.getDataService().on('RowDataChanged', (rowDataChangedInfo)=>{
            if (rowDataChangedInfo.rowTrigger === 'Update') // changed row alerts should be handled by standard 'AnyChange' Predicate
            return;
            this.handleRowDataChanged(rowDataChangedInfo);
        });
        this.api.internalApi.getAlertService().onReactiveAlertTriggered((reactiveAlertInfo)=>this.handleReactiveAlertTriggered(reactiveAlertInfo));
        this.api.alertApi.internalApi.setUpReactiveAlerts();
    }
    getModuleAdaptableObjects(config) {
        return this.api.alertApi.getAlertDefinitions(config);
    }
    getExplicitlyReferencedColumnIds(alertDefinition) {
        const queryExpression = this.api.expressionApi.getAdaptableQueryExpression(alertDefinition.Rule);
        if (queryExpression) return this.api.expressionApi.getColumnsFromExpression(queryExpression);
        else if (this.api.columnScopeApi.scopeHasColumns(alertDefinition.Scope)) return this.api.columnScopeApi.getColumnsInScope(alertDefinition.Scope).map((adaptableColumn)=>adaptableColumn.columnId);
        return [];
    }
    getReferencedNamedQueryNames(alertDefinition) {
        const queryExpression = this.api.expressionApi.getAdaptableQueryExpression(alertDefinition.Rule);
        if (!queryExpression) return [];
        return this.api.namedQueryApi.internalApi.getReferencedNamedQueryNames(queryExpression);
    }
    createContextMenuItems(menuContext) {
        const items = [];
        if (!menuContext.isRowGroupColumn && this.isModuleVisible()) {
            if (menuContext.adaptableColumn && menuContext.rowNode) {
                let relevantAlert;
                // find alerts which highlight the current cell
                relevantAlert = this.api.alertApi.internalApi.getAdaptableAlertWithHighlightCell(menuContext.adaptableColumn.columnId, menuContext.rowNode);
                if (!relevantAlert) // find alerts which highlight the current row
                relevantAlert = this.api.alertApi.internalApi.getAdaptableAlertWithHighlightRow(menuContext.rowNode);
                if (relevantAlert) items.push(this.createMenuItemReduxAction('alert-clear', 'Clear Alert', this.moduleInfo.Glyph, $5b564bb703f29152$export$733f39b35c905b3d(relevantAlert)));
            }
        }
        return items;
    }
    handleCellDataChanged(cellDataChangedInfo) {
        const alertDefinitions = this.api.alertApi.internalApi.getAlertDefinitionsForCellDataChange(cellDataChangedInfo);
        if ((0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(alertDefinitions)) this.api.alertApi.internalApi.showAlertForDefinitions(cellDataChangedInfo, alertDefinitions);
    }
    handleRowDataChanged(rowDataChangedInfo) {
        const alertDefinitions = this.getAlertDefinitionsForRowDataChange(rowDataChangedInfo);
        this.api.alertApi.internalApi.showAlertsForRowDataChanges(rowDataChangedInfo, alertDefinitions);
    }
    handleReactiveAlertTriggered(reactiveAlertInfo) {
        // TODO  - suppress Notification if alert is not relevant for layout
        if (reactiveAlertInfo.type === 'cellDataChangedAlert') {
            // the row node data is most probably stale because the reactive queries buffer the changed data
            // so we have to refresh it
            reactiveAlertInfo.cellChangeLogEntry.rowNode = this.api.gridApi.getRowNodeForPrimaryKey(reactiveAlertInfo.cellChangeLogEntry.primaryKeyValue);
            reactiveAlertInfo.cellChangeLogEntry.rowData = reactiveAlertInfo.cellChangeLogEntry.rowNode?.data;
            this.api.alertApi.internalApi.showAlertForDefinitions(reactiveAlertInfo.cellChangeLogEntry, [
                reactiveAlertInfo.alertDefinition
            ]);
        } else // reactiveAlertInfo.type === rowDataChangedAlert'
        this.api.alertApi.internalApi.showAlertForDefinitions(reactiveAlertInfo.gridChangeLogEntry, [
            reactiveAlertInfo.alertDefinition
        ]);
    }
    getAlertDefinitionsForRowDataChange(rowDataChangedInfo) {
        return this.api.alertApi.internalApi.getActiveNonReactiveAlertDefinitions().filter((alertDefinition)=>this.api.alertApi.internalApi.isAlertDefinitionForRowChangeEvent(alertDefinition)).filter((alertDefinition)=>{
            if (rowDataChangedInfo.rowTrigger === 'Add') return alertDefinition.Rule?.ObservableExpression.includes((0, $58846ea7f4156db7$export$91649df232e67626));
            if (rowDataChangedInfo.rowTrigger === 'Delete') return alertDefinition.Rule?.ObservableExpression.includes((0, $58846ea7f4156db7$export$b6627549cf8ad25d));
            return false;
        });
    }
    getTeamSharingAction() {
        const config = {
            includeLayoutNotExtendedObjects: false
        };
        return {
            ModuleEntities: this.api.alertApi.getAlertDefinitions(config),
            AddAction: $0040cfd693076bab$export$48fb1d70acb0b9bf,
            EditAction: $0040cfd693076bab$export$5616824fed3efc2a
        };
    }
    toViewCompact(alert) {
        return {
            item: {
                name: alert.header,
                label: (0, $eccf16a0d7054b23$export$99b96388c12e4448),
                values: [
                    alert.message
                ]
            },
            abObject: alert
        };
    }
    toView(alert) {
        const alertType = (0, $2ce1445b81dc66ec$export$9d1c84ef9916433c)(alert);
        return {
            items: [
                {
                    name: 'Name',
                    values: [
                        alert.Name
                    ]
                },
                (0, $dd4c85632ca371c1$export$806862642c3fa057)(alert),
                alertType === 'DataChange' && {
                    ...(0, $01403ab2be951cf5$export$4abcb9ed8272134c)(alert.Scope, this.api),
                    label: 'Trigger',
                    name: 'Trigger'
                },
                {
                    ...(0, $60b27da1c4a88498$export$43359c935e54e9f1)(alert.Rule, this.api),
                    label: 'Rule',
                    name: 'Rule'
                },
                (0, $c7c3edfc9c6a6a6c$export$f101f297e6a3688c)(this.api),
                (0, $e81284d1c834c71d$export$39e60b309c2e7b57)(alert, this.api),
                (0, $52125728d99aa873$export$287b3702a135396b)(alert, this.api)
            ].filter(Boolean),
            abObject: alert
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects({
            includeLayoutNotExtendedObjects: this.showLayoutNonExtendedObjects()
        }).map((alert)=>this.toView(alert));
    }
    getViewProperties() {
        return {
            getDeleteAction: $0040cfd693076bab$export$fd2daac714b8b6d3,
            getEditAction: $0040cfd693076bab$export$5616824fed3efc2a,
            getSuspendAction: $0040cfd693076bab$export$75e27fe48d2e10dd,
            getUnSuspendAction: $0040cfd693076bab$export$c6368f11ad411cd3,
            getSuspendAllAction: $0040cfd693076bab$export$1346cde2393e56e2,
            getUnSuspendAllAction: $0040cfd693076bab$export$b84c6136fd7a4982,
            getCompactDeleteAction: $5b564bb703f29152$export$733f39b35c905b3d,
            getDeleteAllAction: ()=>{
                const alerts = this.api.internalApi.getState().Internal.AdaptableAlerts;
                return $5b564bb703f29152$export$1fa9ee6ea5769397(alerts);
            },
            emptyView: (0, $6696f2ec252fc59b$export$c6d3446570aef7d1),
            getEditWizard: ()=>(0, $e6af449f45fc03f9$export$260f3559d9f55805),
            getStatusBarPanelProps: ()=>{
                return {
                    popoverMinWidth: 360,
                    view: (0, $3b7de478f21fae28$export$bbbe66505753251b)
                };
            }
        };
    }
    containsLayoutExtensions() {
        return true;
    }
}





var $9g4SS = parcelRequire("9g4SS");


const $5c3cb5890df53c13$export$a19f810ad264cab = (flashingCell)=>{
    return {
        name: 'Target',
        values: Array.isArray(flashingCell.FlashTarget) ? flashingCell.FlashTarget : [
            flashingCell.FlashTarget
        ]
    };
};



var $acw62 = parcelRequire("acw62");


const $d3e6eaf72b6770bf$export$d52dda3d4cdca9b = (props)=>{
    const { data: data, ...boxProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        ...boxProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $422a40ec82a0dd62$export$edde27ba6b07e9c8), {
        "data-value": "up-style",
        styleObject: props.data.UpChangeStyle,
        className: "twa:mr-1 twa:flex-1"
    }, "Up ", !props.data.UpChangeStyle ? ' - no style' : ''), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $422a40ec82a0dd62$export$edde27ba6b07e9c8), {
        "data-value": "down-style",
        className: "twa:mr-1 twa:flex-1",
        styleObject: props.data.DownChangeStyle
    }, "Down", !props.data.DownChangeStyle ? ' - no style' : ''), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $422a40ec82a0dd62$export$edde27ba6b07e9c8), {
        "data-value": "neutral-style",
        className: "twa:flex-1",
        styleObject: props.data.NeutralChangeStyle
    }, "Neutral ", !props.data.NeutralChangeStyle ? ' - no style' : ''));
};


const $4d481af89cd30e9d$export$9ad1e1fda316a5df = ()=>{
    return {
        name: 'Flash Styles',
        label: 'Change Style',
        view: (0, $d3e6eaf72b6770bf$export$d52dda3d4cdca9b)
    };
};






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");









const $9baf58eb5105f36e$export$bd1cc8e0fb715366 = (data, api)=>{
    if (!data.Name?.trim()) return 'Name is required';
    const allFlashingCells = api.flashingCellApi.getFlashingCellDefinitions();
    const isDuplicateName = allFlashingCells.some((fc)=>fc.Name === data.Name && fc.Uuid !== data.Uuid);
    if (isDuplicateName) return 'A Flashing Cell already exists with that name';
    return true;
};
const $9baf58eb5105f36e$export$6719692148dc10af = (flashingAlert)=>{
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), null, "Name ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, flashingAlert.Name || 'Not specified')), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, flashingAlert.FlashDuration === 'always' ? $acw62.createElement($acw62.Fragment, null, "Flashing is never removed") : $acw62.createElement($acw62.Fragment, null, "Flashing is removed after ", $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), null, flashingAlert.FlashDuration), ' ', "milliseconds")));
};
const $9baf58eb5105f36e$export$e91efd85b672d915 = (props)=>{
    let { data: flashingCell } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    flashingCell = flashingCell ?? props.flashingCell;
    const handleNameChange = (event)=>{
        props.onChange({
            ...flashingCell,
            Name: event.target.value
        });
    };
    const setDuration = (FlashDuration)=>{
        props.onChange({
            ...flashingCell,
            FlashDuration: FlashDuration
        });
    };
    const duration = flashingCell.FlashDuration ?? 500;
    const numberDuration = $acw62.useRef(typeof duration === 'number' ? duration : 500);
    const inputRef = (0, $acw62.useRef)(null);
    const oldDuration = (0, $013bfe010f8c54af$export$2e2bcd8739ae039)(duration, duration);
    $acw62.useEffect(()=>{
        if (oldDuration === 'always' && duration != oldDuration) inputRef.current?.focus();
    }, [
        duration,
        oldDuration
    ]);
    const handleTypeChange = (type)=>{
        setDuration(type === 'number' ? numberDuration.current : 'always');
    };
    const handleTargetChange = (type, checked)=>{
        let FlashTarget = flashingCell.FlashTarget ?? [];
        if (typeof FlashTarget === 'string') FlashTarget = [
            FlashTarget
        ];
        if (Array.isArray(FlashTarget)) {
            if (checked) FlashTarget = [
                ...FlashTarget,
                type
            ];
            else FlashTarget = FlashTarget.filter((target)=>type != target);
        }
        props.onChange({
            ...flashingCell,
            FlashTarget: FlashTarget
        });
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        "data-name": "plus-minus-column-settings",
        className: "twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false,
        className: "twa:p-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Flashing Cell Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "flashing-cell-name",
        className: "twa:flex-1 twa:mr-3",
        onChange: handleNameChange,
        placeholder: "Enter Name",
        value: flashingCell.Name ?? ''
    }))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false,
        className: "twa:p-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Flash Duration"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "duration-always",
        checked: duration === 'always',
        onChange: (checked)=>handleTypeChange(checked ? 'always' : 'number'),
        className: "twa:mr-4",
        tabIndex: -1
    }, "Always"), duration !== 'always' && $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "duration-input",
        readOnly: props.readOnly,
        type: "number",
        name: "value",
        ref: inputRef,
        className: "twa:w-20 twa:mr-2",
        value: duration,
        onChange: (event)=>{
            const value = event.target.value;
            setDuration(isNaN(Number(value)) ? 500 : Number(value));
        }
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, "ms"))))))), ' ', $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false,
        className: "twa:p-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Flash Target"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "flashing-target",
        onChange: (checked)=>handleTargetChange('cell', checked),
        className: "twa:mr-3",
        checked: flashingCell?.FlashTarget === 'cell' || flashingCell?.FlashTarget?.includes?.('cell'),
        tabIndex: -1
    }, "Cell"), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "flashing-target-row",
        className: "twa:mr-3",
        onChange: (checked)=>handleTargetChange('row', checked),
        checked: flashingCell?.FlashTarget === 'row' || flashingCell?.FlashTarget?.includes?.('row'),
        tabIndex: -1
    }, "Row"), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "flashing-target-aggFuncCell",
        onChange: (checked)=>handleTargetChange('aggFuncCell', checked),
        checked: flashingCell?.FlashTarget === 'aggFuncCell' || flashingCell?.FlashTarget?.includes?.('aggFuncCell'),
        tabIndex: -1
    }, "Aggregated Function Cell"))))));
};




var $acw62 = parcelRequire("acw62");



const $6d8c3ab459e3492b$export$c6dde5fd6781376f = (flashingAlert)=>{
    const { api: { flashingCellApi: flashingCellApi } } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const FlashTarget = flashingAlert.FlashTarget ?? flashingCellApi.getFlashingCellFlashTarget(flashingAlert);
    return $acw62.createElement((0, $07845dcbd4d38c15$export$f59a408a7cde7e1f), {
        data: flashingAlert,
        renderPredicate: (content)=>{
            return $acw62.createElement($acw62.Fragment, null, "Flash ", $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), null, FlashTarget), " - value condition", ' ', $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), null, content));
        },
        renderQueryExpression: (content)=>{
            return $acw62.createElement($acw62.Fragment, null, "Flash ", $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), null, FlashTarget), " when", ' ', $acw62.createElement("b", null, $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), null, content)));
        }
    });
};
const $6d8c3ab459e3492b$export$19899fd8220ec28f = (props)=>{
    const { data: data, api: api, moduleInfo: moduleInfo } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const predicateDefs = api.flashingCellApi.getFlashingCellPredicateDefsForScope(data.Scope);
    return $acw62.createElement((0, $07845dcbd4d38c15$export$958c7d77bf3113b), {
        module: moduleInfo.ModuleName,
        defaultPredicateId: "AnyChange",
        data: data,
        predicateDefs: predicateDefs,
        getPredicateDefsForColId: (colId)=>api.flashingCellApi.getFlashingCellPredicateDefsForScope({
                ColumnIds: [
                    colId
                ]
            }),
        onChange: props.onChange,
        showAggregation: false,
        showObservable: false,
        showBoolean: true,
        showPredicate: true,
        descriptions: {
            selectPredicate: 'Select an Flashing Cell Rule - to be applied when data changes',
            useBooleanQuery: $acw62.createElement($acw62.Fragment, null, "Use an BooleanQuery if ", $acw62.createElement("i", null, "Scope"), " is 'All Columns' - so any data change may be evaluated in a complex BooleanExpression"),
            useObservableQuery: $acw62.createElement($acw62.Fragment, null, "Use an ObservableQuery if ", $acw62.createElement("i", null, "Scope"), " is 'All Columns' - so any data change may be evaluated in a complex ObservableExpression"),
            useAggregationQuery: $acw62.createElement($acw62.Fragment, null, "Use an AggregatedBooleanQuery if ", $acw62.createElement("i", null, "Scope"), " is 'All Columns' - so any data change may be evaluated in a complex AggregatedBooleanExpression")
        }
    });
};



var $acw62 = parcelRequire("acw62");





const $48d61b35b24925da$var$changeStyle = $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
    className: "twa:text-2 twa:inline-block"
}, "Change style");
const $48d61b35b24925da$export$5f55b7a9e82d84a9 = (props)=>{
    let { data: flashingAlert, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    flashingAlert = flashingAlert ?? props.flashingAlert;
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        defaultValue: "up"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "up"
    }, "Up ", $48d61b35b24925da$var$changeStyle), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "up"
    }, $acw62.createElement((0, $e629d4699b6af5c8$export$a7668fc2e148d940), {
        headless: true,
        api: api,
        Style: flashingAlert.UpChangeStyle ?? {},
        UpdateStyle: (style)=>props.onStyleChange('UpChangeStyle', style)
    })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "down"
    }, "Down ", $48d61b35b24925da$var$changeStyle), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "down"
    }, $acw62.createElement((0, $e629d4699b6af5c8$export$a7668fc2e148d940), {
        headless: true,
        api: api,
        Style: flashingAlert.DownChangeStyle ?? {},
        UpdateStyle: (style)=>props.onStyleChange('DownChangeStyle', style)
    })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "neutral"
    }, "Neutral ", $48d61b35b24925da$var$changeStyle), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "neutral"
    }, $acw62.createElement((0, $e629d4699b6af5c8$export$a7668fc2e148d940), {
        headless: true,
        api: api,
        Style: flashingAlert.NeutralChangeStyle ?? {},
        UpdateStyle: (style)=>props.onStyleChange('NeutralChangeStyle', style)
    }))));
};
const $48d61b35b24925da$export$d52dda3d4cdca9b = (props)=>{
    const { data: data, ...boxProps } = props;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...boxProps
    }, $acw62.createElement((0, $422a40ec82a0dd62$export$edde27ba6b07e9c8), {
        styleObject: props.data.UpChangeStyle
    }, "Up change style ", !props.data.UpChangeStyle ? ' - no style' : ''), $acw62.createElement((0, $422a40ec82a0dd62$export$edde27ba6b07e9c8), {
        styleObject: props.data.DownChangeStyle,
        className: "twa:mt-2"
    }, "Down change style ", !props.data.DownChangeStyle ? ' - no style' : ''), $acw62.createElement((0, $422a40ec82a0dd62$export$edde27ba6b07e9c8), {
        styleObject: props.data.NeutralChangeStyle,
        className: "twa:mt-2"
    }, "Neutral change style ", !props.data.NeutralChangeStyle ? ' - no style' : ''));
};
const $48d61b35b24925da$export$f732d0a9324cdfa2 = (flashingAlert)=>{
    return $acw62.createElement($48d61b35b24925da$export$d52dda3d4cdca9b, {
        data: flashingAlert
    });
};



var $acw62 = parcelRequire("acw62");



const $6b73526eecb01905$export$6ca99c3139789b61 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const availableColumns = $acw62.useMemo(()=>api.columnApi.getNonSpecialColumns(), []);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:p-2 twa:h-full"
    }, $acw62.createElement((0, $65308a7002d19b3b$export$b5842aa553688927), {
        descriptions: {
            rowScope: 'Changes anywhere in the row will trigger an Flashing Cell',
            columnScope: 'Changes in selected columns will trigger an Flashing Cell'
        },
        scopeColumns: availableColumns,
        scope: data.Scope,
        updateScope: (Scope)=>{
            const newData = {
                ...data,
                Scope: Scope
            };
            if (newData.Rule.Predicates) // when scope is changed, reset the rule to predicate of AnyChange
            // if it was set to a predicate before
            newData.Rule = {
                Predicates: [
                    {
                        PredicateId: 'AnyChange'
                    }
                ]
            };
            props.onChange(newData);
        }
    }));
};








const $81ccd95e6349a7cb$export$90060d33c3cb1244 = (flashingCell, api, context)=>{
    if (!flashingCell.Rule?.Predicates?.length && !flashingCell.Rule.BooleanExpression) return 'A rule is required for the Flashing Cell.';
    const isRuleValid = (0, $77459fc7566b1dde$export$509100fde248eb2b)(flashingCell, api, context);
    if (typeof isRuleValid === 'string') return isRuleValid;
    // boolean expressions may also be saved as named queries
    if (context.namedQuery != false) {
        const isValidName = api.namedQueryApi.isValidNamedQuery(context.namedQuery);
        if (!isValidName.valid) return isValidName.message;
    }
    return true;
};





const $3ab9166128e12756$export$24cf52c5172558c2 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [flashingCell, doSetFlashingCell] = (0, $acw62.useState)(()=>{
        let flashingCell = props.data ? (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(props.data) : (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyFlashingCellDefinition();
        flashingCell = api.flashingCellApi.internalApi.mergeFlashingCellDefinitionWithDefaults(flashingCell);
        if (!flashingCell.Rule.BooleanExpression && !flashingCell.Rule?.Predicates?.length) flashingCell.Rule.BooleanExpression = '';
        if (props.popupParams?.column && props.popupParams?.action === 'New') flashingCell.Scope = {
            ColumnIds: [
                props.popupParams.column.columnId
            ]
        };
        return flashingCell;
    });
    const setFlashingCell = (0, $acw62.useCallback)((data)=>{
        doSetFlashingCell(data);
    }, []);
    const updateProperty = (propName)=>{
        return (value)=>{
            doSetFlashingCell((flashingCell)=>{
                flashingCell = {
                    ...flashingCell,
                    [propName]: value
                };
                return flashingCell;
            });
        };
    };
    const updateStyles = {
        DownChangeStyle: (0, $acw62.useCallback)(updateProperty('DownChangeStyle'), []),
        UpChangeStyle: (0, $acw62.useCallback)(updateProperty('UpChangeStyle'), []),
        NeutralChangeStyle: (0, $acw62.useCallback)(updateProperty('NeutralChangeStyle'), [])
    };
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleFinish = ()=>{
        if (props.data) dispatch($26ec30a4ba180d8a$export$5927e3ffef099800(flashingCell));
        else dispatch($26ec30a4ba180d8a$export$a8d1d19a17affa5e(flashingCell));
        props.onFinishWizard(flashingCell);
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: flashingCell,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                details: 'Set Name, Duration and Target Properties',
                isValid: (0, $9baf58eb5105f36e$export$bd1cc8e0fb715366),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $9baf58eb5105f36e$export$e91efd85b672d915), {
                        onChange: setFlashingCell
                    })),
                renderSummary: (0, $9baf58eb5105f36e$export$6719692148dc10af),
                title: 'Settings'
            },
            {
                details: 'Specify which data changes should trigger Cell Flashing',
                isValid: (0, $65308a7002d19b3b$export$37abad8a5da7760),
                render: ()=>$acw62.createElement((0, $6b73526eecb01905$export$6ca99c3139789b61), {
                        onChange: setFlashingCell
                    }),
                renderSummary: (0, $71699b5aee4bce11$export$3f60d09dd2143243),
                title: 'Columns'
            },
            {
                details: 'Build the Rules for when Cells should Flash',
                isValid: (0, $81ccd95e6349a7cb$export$90060d33c3cb1244),
                render: ()=>$acw62.createElement((0, $6d8c3ab459e3492b$export$19899fd8220ec28f), {
                        onChange: setFlashingCell
                    }),
                renderSummary: (0, $6d8c3ab459e3492b$export$c6dde5fd6781376f),
                title: 'Rule'
            },
            {
                details: 'Choose Flash Styles for Up, Down and Neutral Changes',
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $48d61b35b24925da$export$5f55b7a9e82d84a9), {
                        onStyleChange: (styleName, style)=>{
                            updateStyles[styleName](style);
                        }
                    })),
                renderSummary: (0, $48d61b35b24925da$export$f732d0a9324cdfa2),
                title: 'Flash Styles'
            },
            {
                details: 'Select Flashing Cell Tags',
                title: 'Tags',
                isVisible: (_, api)=>api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setFlashingCell
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                details: 'Review the Flashing Cell Rule',
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null));
                },
                title: 'Summary'
            }
        ]
    });
};


const $1203554f5c349da5$export$b49b334f84543b8d = (flashingCell)=>{
    return {
        name: 'Duration',
        values: [
            flashingCell.FlashDuration
        ]
    };
};



class $75216ec6a421da93$export$b382ba0f444e793a extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    isListeningToCellDataChanges;
    constructor(api){
        super($42e863194fcb493f$export$fc2170ec34a40864, $42e863194fcb493f$export$1a465913ec780572, 'lightning', 'FlashingAlert', 'Flash cells when they change', api);
        this.isListeningToCellDataChanges = false;
    }
    onAdaptableReady() {
        this.checkListenToCellDataChanged();
    }
    shouldListenToDataChanges() {
        return (0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(this.api.flashingCellApi.getActiveFlashingCellDefinitions());
    }
    checkListenToCellDataChanged() {
        if (!this.isListeningToCellDataChanges) {
            if (this.shouldListenToDataChanges()) {
                this.setupCellDataChangeListener();
                this.isListeningToCellDataChanges = true;
            }
        }
    }
    setupCellDataChangeListener() {
        this.api.internalApi.getDataService().on('CellDataChanged', (cellDataChangedInfo)=>{
            if (cellDataChangedInfo.trigger === 'undo') // do NOT handle reverted changes
            return;
            const activeFlashingCellDefinitions = this.api.flashingCellApi.getActiveFlashingCellDefinitions();
            if ((0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(activeFlashingCellDefinitions)) {
                // TODO: think about flashing row value only
                // - flash for the underlying small data changes, but the visual does not
                if (this.api.optionsApi.getAlertOptions().dataChangeDetectionPolicy === 'formattedValue') {
                    const { oldValue: oldValue, newValue: newValue, rowNode: rowNode } = cellDataChangedInfo;
                    const columnId = cellDataChangedInfo.column.columnId;
                    const oldFormattedValue = this.api.gridApi.getDisplayValueFromRawValue(rowNode, columnId, oldValue);
                    const newFormattedValue = this.api.gridApi.getDisplayValueFromRawValue(rowNode, columnId, newValue);
                    if (oldFormattedValue === newFormattedValue) // if the formattedValues are identical, then no alert is fired
                    return;
                }
                const relevantFlashingCellDefinitions = this.getFlashingCellDefinitionsForDataChange(activeFlashingCellDefinitions, cellDataChangedInfo);
                if ((0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(relevantFlashingCellDefinitions)) this.showFlashingCellsForDefinitions(cellDataChangedInfo, relevantFlashingCellDefinitions);
            }
        });
    }
    getFlashingCellDefinitionsForDataChange(activeFlashingCellDefinitions, cellDataChangedInfo) {
        const defaultNoPredicateReturn = false;
        let relatedFlashingCellsDefinitions = activeFlashingCellDefinitions.filter((v)=>this.api.columnScopeApi.isColumnInScope(cellDataChangedInfo.column, v.Scope)).filter((flashingCellDefinition)=>!(0, $83a964ed2bfe6165$export$f332236d816621e1)(flashingCellDefinition.Rule));
        let triggeredFlashingCells = [];
        if ((0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(relatedFlashingCellsDefinitions)) relatedFlashingCellsDefinitions.forEach((flashingCellDefinition)=>{
            // for aggregation the data-change needs to be aggChange
            if (cellDataChangedInfo.trigger !== 'aggChange' && this.isFlashingTargetOnlyAggChange(flashingCellDefinition)) return;
            if (flashingCellDefinition.Rule.BooleanExpression) {
                let expression = flashingCellDefinition.Rule.BooleanExpression;
                let rowNode = cellDataChangedInfo.rowNode;
                if (!rowNode) rowNode = this.api.gridApi.getRowNodeForPrimaryKey(cellDataChangedInfo.primaryKeyValue);
                const isValidExpression = this.api.expressionApi.isValidBooleanExpression(expression, this.moduleInfo.ModuleName, `Invalid Alert boolean expression '${expression}'`);
                let isSatisfiedExpression = false;
                try {
                    isSatisfiedExpression = isValidExpression && this.api.internalApi.getQueryLanguageService().evaluateBooleanExpression(expression, this.moduleInfo.ModuleName, rowNode, {
                        dataChangedEvent: cellDataChangedInfo
                    });
                } catch (error) {
                    isSatisfiedExpression = false;
                    (0, $10f858c943b30cc8$export$45c997b35cb132f6)(error.message);
                }
                if (isSatisfiedExpression) triggeredFlashingCells.push(flashingCellDefinition);
            } else if (this.isAlertPredicateTriggered(flashingCellDefinition, cellDataChangedInfo, defaultNoPredicateReturn)) triggeredFlashingCells.push(flashingCellDefinition);
        });
        return triggeredFlashingCells;
    }
    showFlashingCellsForDefinitions(cellDataChangedInfo, flashingCellDefinitions = []) {
        const allColumnIds = this.api.columnApi.getUIAvailableColumns().map((c)=>c.columnId);
        const columnDataType = cellDataChangedInfo.column.dataType;
        const numeric = columnDataType === 'number';
        const isComparableType = numeric || columnDataType === 'date';
        let up = false;
        let down = false;
        let direction = 'neutral';
        if (isComparableType) {
            const newValue = numeric ? Number(cellDataChangedInfo.newValue) : cellDataChangedInfo.newValue;
            const oldValue = numeric ? Number(cellDataChangedInfo.oldValue) : cellDataChangedInfo.oldValue;
            up = newValue > oldValue;
            down = newValue < oldValue;
            direction = up ? 'up' : down ? 'down' : 'neutral';
        }
        flashingCellDefinitions.forEach((flashingCellDefinition)=>{
            let flashTarget = this.api.flashingCellApi.getFlashingCellFlashTarget(flashingCellDefinition);
            const flashColumnIds = {
                [cellDataChangedInfo.column.columnId]: true
            };
            /**
             * When flashing a row, all columns in that row are marked to flash.
             */ if (flashTarget === 'row' || flashTarget?.includes?.('row')) allColumnIds.forEach((colId)=>{
                flashColumnIds[colId] = true;
            });
            const rowPrimaryKey = cellDataChangedInfo.primaryKeyValue;
            this.api.flashingCellApi.showFlashingCell({
                rowPrimaryKey: rowPrimaryKey,
                flashingCellDefinition: flashingCellDefinition,
                cellDataChangedInfo: cellDataChangedInfo,
                direction: direction,
                flashTarget: flashTarget,
                flashColumnIds: flashColumnIds
            });
        });
    }
    getModuleAdaptableObjects(config) {
        return this.api.flashingCellApi.getFlashingCellDefinitions(config);
    }
    getExplicitlyReferencedColumnIds(alertDefinition) {
        const queryExpression = this.api.expressionApi.getAdaptableQueryExpression(alertDefinition.Rule);
        if (queryExpression) return this.api.expressionApi.getColumnsFromExpression(queryExpression);
        else if (this.api.columnScopeApi.scopeHasColumns(alertDefinition.Scope)) return this.api.columnScopeApi.getColumnsInScope(alertDefinition.Scope).map((adaptableColumn)=>adaptableColumn.columnId);
        return [];
    }
    getReferencedNamedQueryNames(alertDefinition) {
        const queryExpression = this.api.expressionApi.getAdaptableQueryExpression(alertDefinition.Rule);
        if (!queryExpression) return [];
        return this.api.namedQueryApi.internalApi.getReferencedNamedQueryNames(queryExpression);
    }
    createColumnMenuItems(column) {
        if (column && this.isModuleEditable()) {
            if (!column.isCalculatedColumn && !column.isTreeColumn) {
                const flashingCellDefinitions = this.api.flashingCellApi.getFlashingCellDefinitions();
                const flashingCellForCurrentColumn = flashingCellDefinitions.find((flashingCellDefinition)=>{
                    return this.api.columnScopeApi.isColumnInScope(column, flashingCellDefinition.Scope);
                });
                if (flashingCellForCurrentColumn) return [
                    this.createMenuItemReduxAction('flashing-cell-delete', 'Delete Flashing Cell', this.moduleInfo.Glyph, $26ec30a4ba180d8a$export$2a634d0eb40c9e99(flashingCellForCurrentColumn))
                ];
                return [
                    this.createMenuItemReduxAction('flashing-cell-add', 'Add Flashing Cell', this.moduleInfo.Glyph, $26ec30a4ba180d8a$export$a8d1d19a17affa5e({
                        Name: `Any Change [${column.columnId}]`,
                        Scope: {
                            ColumnIds: [
                                column.columnId
                            ]
                        },
                        Rule: {
                            BooleanExpression: 'ANY_CHANGE([' + column.columnId + '])'
                        }
                    }))
                ];
            }
        }
    }
    createContextMenuItems(menuContext) {
        const items = [];
        if (!menuContext.isRowGroupColumn && this.isModuleVisible()) {
            if (menuContext.adaptableColumn && menuContext.rowNode) {
                const flashingCellForRow = this.api.flashingCellApi.internalApi.getAdaptableFlashingCellFor(menuContext.primaryKeyValue);
                const flashingCellForCell = this.api.flashingCellApi.internalApi.getAdaptableFlashingCellFor(menuContext.primaryKeyValue, menuContext.adaptableColumn.columnId);
                if (flashingCellForRow) {
                    if (flashingCellForRow.flashTarget === 'row' || Array.isArray(flashingCellForRow?.flashTarget) && flashingCellForRow.flashTarget.includes('row')) items.push(this.createMenuItemClickFunction('flashing-row-clear', 'Clear Flashing Row', this.moduleInfo.Glyph, ()=>this.api.internalApi.getFlashingCellService().clearGridCellFlash(flashingCellForRow)));
                } else if (flashingCellForCell && flashingCellForCell.flashTarget === 'cell') items.push(this.createMenuItemClickFunction('flashing-cell-clear', 'Clear Flashing Cell', this.moduleInfo.Glyph, ()=>this.api.internalApi.getFlashingCellService().clearGridCellFlash(flashingCellForCell)));
            }
        }
        return items;
    }
    isFlashingTargetOnlyAggChange(flashingCellDefinition) {
        if (flashingCellDefinition.FlashTarget === 'aggFuncCell') return true;
        return Array.isArray(flashingCellDefinition.FlashTarget) && flashingCellDefinition.FlashTarget.length === 1 && flashingCellDefinition.FlashTarget.includes('aggFuncCell');
    }
    isAlertPredicateTriggered(alert, dataChangedEvent, defaultNoPredicateReturn = false) {
        const predicateDefHandlerContext = {
            value: dataChangedEvent.newValue,
            oldValue: dataChangedEvent.oldValue,
            rawValue: dataChangedEvent.newValue,
            displayValue: dataChangedEvent.newValue,
            node: dataChangedEvent.rowNode,
            column: dataChangedEvent.column,
            ...this.api.internalApi.buildBaseContext()
        };
        return this.api.predicateApi.handleColumnPredicates(alert.Rule?.Predicates, predicateDefHandlerContext, defaultNoPredicateReturn);
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.flashingCellApi.getFlashingCellDefinitions(),
            AddAction: $26ec30a4ba180d8a$export$a8d1d19a17affa5e,
            EditAction: $26ec30a4ba180d8a$export$5927e3ffef099800
        };
    }
    toView(flashingCell) {
        return {
            items: [
                {
                    name: 'Name',
                    values: [
                        flashingCell.Name
                    ]
                },
                {
                    ...(0, $01403ab2be951cf5$export$4abcb9ed8272134c)(flashingCell.Scope, this.api),
                    label: 'Trigger'
                },
                {
                    ...(0, $60b27da1c4a88498$export$43359c935e54e9f1)(flashingCell.Rule, this.api),
                    label: 'Rule',
                    name: 'Rule'
                },
                (0, $1203554f5c349da5$export$b49b334f84543b8d)(flashingCell),
                (0, $5c3cb5890df53c13$export$a19f810ad264cab)(flashingCell),
                (0, $4d481af89cd30e9d$export$9ad1e1fda316a5df)(),
                (0, $52125728d99aa873$export$287b3702a135396b)(flashingCell, this.api)
            ],
            abObject: flashingCell
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects({
            includeLayoutNotExtendedObjects: this.showLayoutNonExtendedObjects()
        }).map((flashingCell)=>this.toView(flashingCell));
    }
    getViewProperties() {
        return {
            getEditAction: $26ec30a4ba180d8a$export$5927e3ffef099800,
            getSuspendAction: $26ec30a4ba180d8a$export$d7b5cc0486d3a052,
            getUnSuspendAction: $26ec30a4ba180d8a$export$18482237a63d9b71,
            getSuspendAllAction: $26ec30a4ba180d8a$export$c6ef66fac999d641,
            getUnSuspendAllAction: $26ec30a4ba180d8a$export$ecc232ed8e2f9f96,
            getDeleteAction: $26ec30a4ba180d8a$export$2a634d0eb40c9e99,
            getEditWizard: ()=>(0, $3ab9166128e12756$export$24cf52c5172558c2)
        };
    }
    containsLayoutExtensions() {
        return true;
    }
}






var $9OAZF = parcelRequire("9OAZF");

var $9g4SS = parcelRequire("9g4SS");

class $fca4286b812b2474$export$60e0e2d379eaac21 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$bc824d5002237871, $42e863194fcb493f$export$ecc9b5cef2a93a9e, 'edit-table', 'BulkUpdatePopup', 'Update multiple cell simultaneously with a new or existing value', api);
    }
    getViewAccessLevel() {
        return 'Full';
    }
    createContextMenuItems(menuContext) {
        let menuItemShowPopup = undefined;
        if (!menuContext.isRowGroupColumn && this.isModuleEditable()) {
            if (menuContext.adaptableColumn && menuContext.isSelectedCell && menuContext.isSingleSelectedColumn && this.api.gridApi.isEveryCellEditable(menuContext.selectedCellInfo.gridCells)) {
                let popUpParams = {
                    source: 'ContextMenu'
                };
                menuItemShowPopup = this.createMainMenuItemShowPopup({
                    Name: 'bulk-update-apply',
                    Label: 'Apply Bulk Update',
                    ComponentName: this.moduleInfo.Popup,
                    Icon: this.moduleInfo.Glyph,
                    PopupParams: popUpParams
                });
            }
        }
        return [
            menuItemShowPopup
        ];
    }
    checkCorrectCellSelection() {
        let selectedCellInfo = this.api.gridApi.getSelectedCellInfo();
        if (this.api.layoutApi.isCurrentLayoutPivot()) return {
            IsValid: false,
            Alert: {
                alertType: 'generic',
                header: 'Bulk Update',
                message: 'Editing is not available in Pivot Mode.',
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
            }
        };
        if (selectedCellInfo == null || (0, $9g4SS.default).IsNullOrEmpty(selectedCellInfo.columns)) return {
            IsValid: false,
            Alert: {
                alertType: 'generic',
                header: 'Bulk Update',
                message: 'No cells selected. Please select one or more cells to continue.',
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
            }
        };
        if ((0, $9g4SS.default).NotCorrectLength(selectedCellInfo.columns, 1)) return {
            IsValid: false,
            Alert: {
                alertType: 'generic',
                header: 'Bulk Update',
                message: 'Bulk Update supports editing a single column at a time. Please adjust your selection.',
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
            }
        };
        let selectedColumn = selectedCellInfo.columns[0];
        if ((0, $9g4SS.default).IsNotNullOrEmpty(selectedCellInfo.gridCells) && !this.api.gridApi.isEveryCellEditable(selectedCellInfo.gridCells)) return {
            IsValid: false,
            Alert: {
                alertType: 'generic',
                header: 'Bulk Update',
                message: 'Bulk Update is not available for read-only cells. Please adjust your selection.',
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
            }
        };
        return {
            IsValid: true,
            Column: selectedColumn
        };
    }
    buildPreviewValues(bulkUpdateValue) {
        let previewResults = [];
        if ((0, $9OAZF.default).IsNullOrEmpty(String(bulkUpdateValue))) return null;
        let selectedCellInfo = this.api.gridApi.getSelectedCellInfo();
        let column;
        if (!this.api.layoutApi.isCurrentLayoutPivot()) {
            if (selectedCellInfo != null && selectedCellInfo.columns.length > 0) {
                column = this.api.columnApi.getColumnWithColumnId(selectedCellInfo.columns[0].columnId);
                let typedBulkUpdateValue;
                switch(column.dataType){
                    case 'number':
                        typedBulkUpdateValue = Number(bulkUpdateValue);
                        break;
                    case 'text':
                        typedBulkUpdateValue = bulkUpdateValue;
                        break;
                    case 'date':
                        typedBulkUpdateValue = new Date(bulkUpdateValue);
                        break;
                }
                selectedCellInfo.gridCells.forEach((selectedCell)=>{
                    const cellDataChangedInfo = this.api.internalApi.buildCellDataChangedInfo({
                        oldValue: selectedCell.rawValue,
                        newValue: typedBulkUpdateValue,
                        column: selectedCell.column,
                        primaryKeyValue: selectedCell.primaryKeyValue,
                        rowNode: selectedCell.rowNode,
                        trigger: 'edit'
                    });
                    const validationRules = this.api.internalApi.getValidationService().getValidationRulesForDataChange(cellDataChangedInfo);
                    const previewResult = {
                        id: selectedCell.primaryKeyValue,
                        initialValue: selectedCell.rawValue,
                        computedValue: typedBulkUpdateValue,
                        validationRules: validationRules,
                        rowNode: selectedCell.rowNode
                    };
                    previewResults.push(previewResult);
                });
            }
        }
        return {
            column: column,
            previewResults: previewResults,
            previewValidationSummary: (0, $ffbf29d095efdf81$export$69a3593e4bb2f3c1).GetPreviewValidationSummary(previewResults)
        };
    }
}






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $9OAZF = parcelRequire("9OAZF");

const $f54cd89c99afc181$export$2ef5400e749ac931 = (data)=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, "Column scalar expression:", ' ', $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), null, api.internalApi.getAdaptableQueryExpressionText(data.Query)));
};
const $f54cd89c99afc181$export$2199b61647b108a1 = (data, api)=>{
    const calculatedColumnExpressionService = api.internalApi.getCalculatedColumnExpressionService();
    const expression = api.expressionApi.getAdaptableQueryExpression(data.Query)?.trim();
    if (!expression) return 'An expression is required for the Calculated Column.';
    const isValid = calculatedColumnExpressionService.isCalculatedColumnQueryValid(data.Query);
    if (!isValid) return 'The Calculated Column expression is not valid.';
    return true;
};
const $f54cd89c99afc181$export$15debe17510e6bb9 = (props)=>{
    const { api: api, data: data, moduleInfo: moduleInfo } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const initialData = (0, $acw62.useMemo)(()=>api.internalApi.getQueryPreviewData(), []);
    const setCalculatedColumnExpression = (calculatedColumnQuery)=>{
        const calculatedColumnExpressionService = api.internalApi.getCalculatedColumnExpressionService();
        const dataType = calculatedColumnExpressionService.getCalculatedColumnDataType(calculatedColumnQuery);
        props.onChange({
            ...data,
            Query: calculatedColumnQuery,
            CalculatedColumnSettings: {
                ...data.CalculatedColumnSettings,
                DataType: dataType
            }
        });
    };
    const getEditorType = (expressionType)=>{
        switch(expressionType){
            case 'AggregatedScalarExpression':
                return 'aggregatedScalar';
            case 'CumulativeAggregatedExpression':
                return 'cumulativeAggregatedScalar';
            case 'QuantileAggregatedExpression':
                return 'quantileAggregatedScalar';
        }
    };
    const columns = api.columnApi.internalApi.getQueryableColumnsForUIEditor();
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false,
        height: "100%"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, (0, $9OAZF.Humanize)(props.expressionType)), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, (()=>{
        switch(props.expressionType){
            case 'ScalarExpression':
                return $acw62.createElement((0, $5e4c4ab15f4fe7da$export$6f88ab97c822f23a), {
                    type: 'scalar',
                    module: moduleInfo.ModuleName,
                    className: "twa:pl-0",
                    value: data.Query.ScalarExpression,
                    onChange: (ScalarExpression)=>setCalculatedColumnExpression({
                            ScalarExpression: ScalarExpression
                        }),
                    initialData: initialData,
                    columns: columns,
                    fields: api.expressionApi.internalApi.getAvailableFields(),
                    namedQueries: api.namedQueryApi.getNamedQueries(),
                    isFullExpression: true,
                    api: api
                });
            case 'AggregatedScalarExpression':
            case 'CumulativeAggregatedExpression':
            case 'QuantileAggregatedExpression':
                return $acw62.createElement((0, $5e4c4ab15f4fe7da$export$6f88ab97c822f23a), {
                    type: getEditorType(props.expressionType),
                    module: moduleInfo.ModuleName,
                    className: "twa:pl-0",
                    value: data.Query.AggregatedScalarExpression,
                    onChange: (AggregatedScalarExpression)=>setCalculatedColumnExpression({
                            AggregatedScalarExpression: AggregatedScalarExpression
                        }),
                    initialData: initialData,
                    columns: columns,
                    namedQueries: api.namedQueryApi.getNamedQueries(),
                    isFullExpression: true,
                    api: api
                });
            default:
                return $acw62.createElement($acw62.Fragment, null);
        }
    })()));
};



var $acw62 = parcelRequire("acw62");








const $75acf40f3955e132$export$eddb38e9e819f132 = (data)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:grid twa:items-center twa:grid-cols-[auto_1fr] twa:gap-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, "Column Identifier:"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.ColumnId)), data.FriendlyName ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, "Column Name:"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.FriendlyName ?? data.ColumnId))) : null);
};
const $75acf40f3955e132$export$8a5cb25e1ce7d1a7 = (data, api)=>{
    const columns = api.columnApi.getColumns();
    if (!data.ColumnId) return 'A Column ID is required.';
    const columnsWithSameIdCount = columns.filter((c)=>c.columnId === data.ColumnId).length;
    const hasAlreadyExistingId = data.Uuid ? columnsWithSameIdCount > 1 : columnsWithSameIdCount > 0;
    return hasAlreadyExistingId ? 'A column with this ID already exists.' : true;
};
const $75acf40f3955e132$export$ca516a41b1f1e232 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const handleColumnIdChange = (event)=>{
        let e = event.target;
        props.onChange({
            ...data,
            ColumnId: e.value
        });
    };
    const handleColumnNameChange = (event)=>{
        let e = event.target;
        props.onChange({
            ...data,
            FriendlyName: e.value
        });
    };
    const inEdit = props.isEdit;
    const validCheck = $75acf40f3955e132$export$8a5cb25e1ce7d1a7(data, api);
    const ErrorMessage = validCheck === true ? null : validCheck;
    const [ColumnNameFocused, setColumnNameFocused] = (0, $acw62.useState)(false);
    const ColumnName = data.FriendlyName;
    const ColumnId = data.ColumnId;
    const { ShowToolTip: ShowToolTip, HeaderToolTip: HeaderToolTip } = data.CalculatedColumnSettings ?? {};
    const handleSpecialColumnSettingsChange = (settings)=>{
        props.onChange({
            ...data,
            CalculatedColumnSettings: {
                ...data.CalculatedColumnSettings,
                ...settings
            }
        });
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": 'calculated-column-definition'
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column Details"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Column Id"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "column-id",
        value: data.ColumnId || '',
        width: 300,
        autoFocus: !inEdit,
        disabled: inEdit,
        type: "text",
        placeholder: "Enter an Id for the column",
        onChange: handleColumnIdChange
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "column-name",
        autoFocus: inEdit,
        onFocus: ()=>{
            setColumnNameFocused(true);
        },
        onBlur: ()=>{
            setColumnNameFocused(false);
        },
        value: ColumnNameFocused ? ColumnName || '' : ColumnName || ColumnId || '',
        width: 300,
        type: "text",
        placeholder: "Enter column name",
        onChange: handleColumnNameChange
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Header Tooltip"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "header-tooltip",
        type: "text",
        width: 300,
        value: HeaderToolTip,
        onChange: (e)=>handleSpecialColumnSettingsChange({
                HeaderToolTip: e.target.value
            })
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "column-show-tooltip",
        onChange: (checked)=>handleSpecialColumnSettingsChange({
                ShowToolTip: checked
            }),
        checked: ShowToolTip
    }, "Show Expression as Cell Tooltip")))))), ErrorMessage ? $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), {
        className: "twa:mt-2"
    }, ErrorMessage) : null);
};








var $acw62 = parcelRequire("acw62");





/**
 * Creates an array of elements split into groups the length of size.
 * If array can't be split evenly, the final chunk will be the remaining elements.
 * Drop-in replacement for lodash/chunk.
 */ function $c8360e98af364241$export$2e2bcd8739ae039(array, size = 1) {
    const length = array.length;
    if (!length || !(size >= 1)) return [];
    const chunkSize = Math.floor(size);
    const result = [];
    for(let i = 0; i < length; i += chunkSize)result.push(array.slice(i, i + chunkSize));
    return result;
}



var $acw62 = parcelRequire("acw62");





const $597cd2acd2d20001$export$56579ebfaa709732 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const possibleColumnTypes = adaptable.api.columnApi.getColumnTypes() ?? [];
    const { Filterable: Filterable, Resizable: Resizable, Groupable: Groupable, Sortable: Sortable, Pivotable: Pivotable, Aggregatable: Aggregatable, SuppressMenu: SuppressMenu, SuppressMovable: SuppressMovable } = props.settings ?? {};
    const handleColumnTypeChange = (columnType, checked)=>{
        const columnTypes = props.settings?.ColumnTypes ?? [];
        if (checked) props.onChange({
            ...props.settings,
            ColumnTypes: [
                ...columnTypes,
                columnType
            ]
        });
        else props.onChange({
            ...props.settings,
            ColumnTypes: columnTypes?.filter?.((item)=>item !== columnType)
        });
    };
    const onSettingsChange = (values)=>{
        props.onChange({
            ...props.settings,
            ...values
        });
    };
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mt-2",
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column Properties"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:w-full",
        columns: [
            {
                name: 'first',
                size: '30%'
            },
            {
                size: '30%',
                name: 'second'
            },
            {
                size: '30%',
                name: 'third'
            }
        ]
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "filterable",
        checked: Filterable,
        onChange: (Filterable)=>onSettingsChange({
                Filterable: Filterable
            }),
        disabled: !adaptable.api.optionsApi.getFilterOptions().enableFilterOnSpecialColumns
    }, "Filterable"), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "resizable",
        checked: Resizable,
        onChange: (Resizable)=>onSettingsChange({
                Resizable: Resizable
            })
    }, "Resizable"), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "groupable",
        checked: Groupable,
        onChange: (Groupable)=>onSettingsChange({
                Groupable: Groupable
            })
    }, "Groupable")), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "sortable",
        checked: Sortable,
        onChange: (Sortable)=>onSettingsChange({
                Sortable: Sortable
            })
    }, "Sortable"), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "pivotable",
        checked: Pivotable,
        onChange: (Pivotable)=>onSettingsChange({
                Pivotable: Pivotable
            })
    }, "Pivotable"), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "aggregatable",
        checked: Aggregatable,
        onChange: (Aggregatable)=>onSettingsChange({
                Aggregatable: Aggregatable
            })
    }, "Aggregatable")), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "suppres-smenu",
        checked: SuppressMenu,
        onChange: (SuppressMenu)=>onSettingsChange({
                SuppressMenu: SuppressMenu
            })
    }, "Suppress Menu"), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "suppres-movable",
        checked: SuppressMovable,
        onChange: (SuppressMovable)=>onSettingsChange({
                SuppressMovable: SuppressMovable
            })
    }, "Suppress Movable"), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        disabled: true,
        checked: props.isEditable
    }, "Editable")))))), Boolean(possibleColumnTypes?.length) && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mt-2",
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column Types"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        columns: [
            {
                name: 'first',
                size: '30%'
            },
            {
                name: 'second'
            }
        ]
    }, (0, $c8360e98af364241$export$2e2bcd8739ae039)(possibleColumnTypes ?? [], 2)?.map(([first, second])=>$acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            key: first
        }, first && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            "data-name": first,
            onChange: (checked)=>handleColumnTypeChange(first, checked),
            checked: props.settings?.ColumnTypes?.includes?.(first)
        }, first), second && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            "data-name": second,
            onChange: (checked)=>handleColumnTypeChange(second, checked),
            checked: props.settings?.ColumnTypes?.includes?.(second)
        }, second)))))));
};


const $d9298ad1a739849f$export$e7ffe35903ce510a = (settings)=>{
    const { DataType: DataType, Width: Width, Filterable: Filterable, Resizable: Resizable, Groupable: Groupable, Sortable: Sortable, Pivotable: Pivotable, Aggregatable: Aggregatable } = settings ?? {};
    const colTypes = settings?.ColumnTypes ? settings.ColumnTypes.join(', ') : '';
    return [
        DataType ? `DataType: ${DataType}` : null,
        Width ? `Width: ${Width}px` : null,
        Pivotable ? 'Pivotable' : null,
        Filterable ? 'Filterable' : null,
        Resizable ? 'Resizable' : null,
        Groupable ? 'Groupable' : null,
        Sortable ? 'Sortable' : null,
        Aggregatable ? 'Aggregatable' : null,
        colTypes ? `Column Types: ${colTypes}` : null
    ].filter(Boolean);
};





const $528c76f8fb20e504$export$7f28db7cffaac768 = (data)=>{
    const options = (0, $d9298ad1a739849f$export$e7ffe35903ce510a)(data.CalculatedColumnSettings);
    return $acw62.createElement((0, $3283d8fe16778b21$export$f9fef0f55402315b), {
        tags: options
    });
};
const $528c76f8fb20e504$export$947d02f8e12809ca = (data)=>{
    if (!data.CalculatedColumnSettings?.DataType) return 'A data type is required. It could not be inferred from the expression.';
    return true;
};
const $528c76f8fb20e504$export$9ed3c8837ecb35b9 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const calculatedColumnExpressionService = (0, $acw62.useMemo)(()=>api.internalApi.getCalculatedColumnExpressionService(), []);
    const handleDataTypeChange = (dataType)=>{
        const aggregatable = dataType == 'number' ? data.CalculatedColumnSettings?.Aggregatable : false;
        props.onChange({
            ...data,
            CalculatedColumnSettings: {
                ...data.CalculatedColumnSettings,
                DataType: dataType,
                Aggregatable: aggregatable
            }
        });
    };
    const validCheck = $528c76f8fb20e504$export$947d02f8e12809ca(data);
    const ErrorMessage = validCheck === true ? null : validCheck;
    const { DataType: dataType } = data.CalculatedColumnSettings ?? {};
    const { Width: Width } = data.CalculatedColumnSettings ?? {};
    const handleSpecialColumnSettingsChange = (settings)=>{
        props.onChange({
            ...data,
            CalculatedColumnSettings: {
                ...data.CalculatedColumnSettings,
                ...settings
            }
        });
    };
    $acw62.useEffect(()=>{
        if (!dataType) {
            const computedDataType = calculatedColumnExpressionService.getCalculatedColumnDataType(data.Query);
            handleSpecialColumnSettingsChange({
                ...data?.CalculatedColumnSettings,
                DataType: computedDataType
            });
        }
    }, []);
    const options = [
        {
            value: 'number',
            label: 'Number'
        },
        {
            value: 'text',
            label: 'Text'
        },
        {
            value: 'date',
            label: 'Date'
        },
        {
            value: 'boolean',
            label: 'Boolean'
        },
        {
            value: 'numberArray',
            label: 'NumberArray'
        }
    ];
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": 'calculated-column-settings'
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Data Type"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "data-name": "column-type",
        placeholder: "Select Data Type",
        options: options,
        value: dataType,
        onChange: (value)=>handleDataTypeChange(value)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Width"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "column-width",
        type: "number",
        width: 300,
        value: Width || '',
        onChange: (e)=>handleSpecialColumnSettingsChange({
                Width: Number(e.target.value)
            })
    })))))), ErrorMessage ? $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), {
        className: "twa:mt-2"
    }, ErrorMessage) : null, $acw62.createElement((0, $597cd2acd2d20001$export$56579ebfaa709732), {
        isEditable: false,
        // @ts-ignore CalculatedColumn has a broader DataType
        settings: data.CalculatedColumnSettings,
        onChange: handleSpecialColumnSettingsChange
    }));
};


const $1285c06be42d8867$export$ee29c1c4371b7e19 = (calculatedColumn, api)=>{
    return calculatedColumn?.Query?.AggregatedScalarExpression == undefined ? 'ScalarExpression' : api.calculatedColumnApi.internalApi.isCumulativeAggregatedExpression(calculatedColumn.Query.AggregatedScalarExpression) ? 'CumulativeAggregatedExpression' : api.calculatedColumnApi.internalApi.isQuantileAggregatedExpression(calculatedColumn.Query.AggregatedScalarExpression) ? 'QuantileAggregatedExpression' : 'AggregatedScalarExpression';
};



var $9OAZF = parcelRequire("9OAZF");


var $acw62 = parcelRequire("acw62");



const $84cea79100a22ae3$export$260bb1a7a9c33574 = (props)=>{
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Calculated Column Expression Type"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: 'Standard',
        description: "The calculated value is derived from other cells in the row",
        checked: props.type === 'ScalarExpression',
        onClick: ()=>props.onTypeChange('ScalarExpression')
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: 'Aggregated',
        description: "The calculated value is derived from other rows",
        checked: props.type === 'AggregatedScalarExpression',
        onClick: ()=>props.onTypeChange('AggregatedScalarExpression')
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: 'Cumulative',
        description: "The calculated value is derived cumulatively from other rows",
        checked: props.type === 'CumulativeAggregatedExpression',
        onClick: ()=>props.onTypeChange('CumulativeAggregatedExpression')
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: 'Quantile',
        description: "The calculated value is derived from other rows using quantile aggregations",
        checked: props.type === 'QuantileAggregatedExpression',
        onClick: ()=>props.onTypeChange('QuantileAggregatedExpression')
    }))));
};



const $d132bb6b66aceaeb$export$a8161260eb20efb3 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const allCalculatedColumns = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.CalculatedColumn.CalculatedColumns);
    const [calculatedColumn, setCalculatedColumn] = (0, $acw62.useState)(()=>{
        if (props.data) return (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(props.data);
        if (props.popupParams?.column) {
            const calculatedColumn = allCalculatedColumns.find((calculatedColumn)=>calculatedColumn.ColumnId === props.popupParams.column.columnId);
            if (calculatedColumn) return (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(calculatedColumn);
        }
        return (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyCalculatedColumn(adaptable.api.gridApi.internalApi.deriveSpecialColumnSettingsFromAgGridDefaultColDef());
    });
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const isEdit = Boolean(props.data) || props.popupParams?.action === 'Edit';
    const handleFinish = ()=>{
        if (isEdit) dispatch($754f469a84cf6e6e$export$f21cff55af8ea46e(calculatedColumn));
        else dispatch($754f469a84cf6e6e$export$b40c2dc2e1bce126(calculatedColumn));
        props.onCloseWizard();
    };
    const [expressionType, setExpressionType] = (0, $acw62.useState)(()=>{
        return (0, $1285c06be42d8867$export$ee29c1c4371b7e19)(calculatedColumn, adaptable.api) ?? 'ScalarExpression';
    });
    const handleExpressionTypeChange = (type)=>{
        setExpressionType(type);
        if (expressionType === 'ScalarExpression') setCalculatedColumn({
            ...calculatedColumn,
            Query: {
                ScalarExpression: ''
            }
        });
        else // Aggregated, Cumulative & Quantile are all AggregatedScalarExpression
        setCalculatedColumn({
            ...calculatedColumn,
            Query: {
                AggregatedScalarExpression: ''
            }
        });
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: calculatedColumn,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Type',
                renderSummary: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:text-2"
                    }, "Expression Type: ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, (0, $9OAZF.Humanize)(expressionType)));
                },
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $84cea79100a22ae3$export$260bb1a7a9c33574), {
                        type: expressionType,
                        onTypeChange: handleExpressionTypeChange
                    }));
                }
            },
            {
                title: 'Details',
                details: 'Specify Calculated Column details',
                isValid: (0, $75acf40f3955e132$export$8a5cb25e1ce7d1a7),
                renderSummary: (0, $75acf40f3955e132$export$eddb38e9e819f132),
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $75acf40f3955e132$export$ca516a41b1f1e232), {
                        isEdit: isEdit,
                        onChange: setCalculatedColumn
                    }));
                }
            },
            {
                title: 'Expression',
                details: 'Specify the Calculated Column Expression',
                isValid: (0, $f54cd89c99afc181$export$2199b61647b108a1),
                renderSummary: (0, $f54cd89c99afc181$export$2ef5400e749ac931),
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $f54cd89c99afc181$export$15debe17510e6bb9), {
                        expressionType: expressionType,
                        onChange: setCalculatedColumn
                    }));
                }
            },
            {
                title: 'Settings',
                details: 'Specify Column properties',
                isValid: (0, $528c76f8fb20e504$export$947d02f8e12809ca),
                renderSummary: (0, $528c76f8fb20e504$export$7f28db7cffaac768),
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $528c76f8fb20e504$export$9ed3c8837ecb35b9), {
                        isEdit: isEdit,
                        onChange: setCalculatedColumn
                    }));
                }
            },
            {
                details: 'Select Calculated Column Tags',
                title: 'Tags',
                isVisible: ()=>adaptable.api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setCalculatedColumn
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null));
                },
                title: 'Summary'
            }
        ]
    });
};



var $9g4SS = parcelRequire("9g4SS");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $484ff53c453ae1e6$export$ca85a0e2ff97f05a = (props)=>{
    const adaptableApi = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)().api;
    const displayColumnFriendlyNames = adaptableApi.optionsApi.getExpressionOptions()?.displayColumnFriendlyNamesForExpressions;
    if (!displayColumnFriendlyNames) return $acw62.createElement($acw62.Fragment, null, adaptableApi.expressionApi.getAdaptableQueryExpression(props.query));
    const expressionWithFriendlyNames = adaptableApi.expressionApi.getAdaptableQueryExpressionWithColumnFriendlyNames(props.query);
    // '[Column Name] > 2' => ['[Column Name]', '>', '2']
    // not the prettiest
    const strWithMarkedGroupes = expressionWithFriendlyNames.replace(/\]/gi, '],').split(',');
    return(/**
         * The etra wrapper is neede because the tag has display inline-flex and makes the content inside <i> to be displayed on
         * multiple lines when the expression is too long.
         *
         * The div allows the text to flow normally.
         */ $acw62.createElement("div", null, strWithMarkedGroupes.map((part, index)=>{
        const partEl = part.includes('[') ? $acw62.createElement("i", null, part.replace(/[\[\]]/g, '')) : part;
        return $acw62.createElement($acw62.Fragment, {
            key: index
        }, partEl);
    })));
};



const $fd2573a8dd303dd4$export$2651322f5f12da6f = (query, api)=>{
    // const expressionText = api.internalApi.getAdaptableQueryExpressionText(query);
    return {
        name: 'Expression',
        // values: [],
        view: $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, $acw62.createElement((0, $484ff53c453ae1e6$export$ca85a0e2ff97f05a), {
            query: query
        }))
    };
};



class $04067d70db82621f$export$bad396be621b2e0a extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    isListeningToCellDataChanges;
    constructor(api){
        super($42e863194fcb493f$export$6619e71706e8514a, $42e863194fcb493f$export$b25bd921e0e8a1d8, 'calculated-column', 'CalculatedColumnPopup', 'Create bespoke columns whose cell value is derived dynamically from an Expression', api);
        this.isListeningToCellDataChanges = false;
    }
    onAdaptableReady() {
        this.checkListenToCellDataChanged();
    }
    shouldListenToDataChanges() {
        return (0, $9g4SS.default).IsNotNullOrEmpty(this.api.calculatedColumnApi.getCalculatedColumns());
    }
    checkListenToCellDataChanged() {
        if (!this.isListeningToCellDataChanges) {
            if (this.shouldListenToDataChanges()) {
                this.setupCellDataChangeListener();
                this.setupRowDataChangeListener();
                this.api.calculatedColumnApi.refreshAggregatedCalculatedColumns();
                this.isListeningToCellDataChanges = true;
            }
        }
    }
    setupCellDataChangeListener() {
        this.api.internalApi.getDataService().on('CellDataChanged', (cellDataChangedInfo)=>{
            if (cellDataChangedInfo.trigger !== 'aggChange') this.api.internalApi.getCalculatedColumnExpressionService().listentoCellDataChange(cellDataChangedInfo);
        });
    }
    setupRowDataChangeListener() {
        this.api.internalApi.getDataService().on('RowDataChanged', (rowDataChangedInfo)=>{
            this.api.internalApi.getCalculatedColumnExpressionService().listentoRowDataChange(rowDataChangedInfo);
        });
    }
    onAdaptableStateReloaded() {
        this.api.calculatedColumnApi.refreshAggregatedCalculatedColumns();
    }
    getModuleAdaptableObjects() {
        return this.api.calculatedColumnApi.getCalculatedColumns();
    }
    getExplicitlyReferencedColumnIds(calculatedColumn) {
        return this.api.expressionApi.getColumnsFromExpression(this.api.expressionApi.getAdaptableQueryExpression(calculatedColumn.Query)) ?? [];
    }
    getReferencedNamedQueryNames(calculatedColumn) {
        return this.api.namedQueryApi.internalApi.getReferencedNamedQueryNames(this.api.expressionApi.getAdaptableQueryExpression(calculatedColumn.Query)) ?? [];
    }
    createColumnMenuItems(column) {
        if (!column) return;
        if (!this.isModuleVisible()) return;
        if (this.isModuleEditable() && column.isCalculatedColumn) {
            const popupParam = {
                column: column,
                action: 'Edit',
                source: 'ColumnMenu'
            };
            return [
                this.createMenuItemShowPopup('calculated-column-edit', 'Edit Calculated Column', this.moduleInfo.Popup, this.moduleInfo.Glyph, popupParam)
            ];
        }
    }
    createContextMenuItems(menuContext) {
        if (!menuContext.adaptableColumn) return;
        if (!this.isModuleVisible()) return;
        if (this.isModuleEditable() && menuContext.adaptableColumn.isCalculatedColumn && !menuContext.isRowGroupColumn && menuContext.isSingleSelectedCell) {
            const popupParam = {
                column: menuContext.adaptableColumn,
                action: 'Edit',
                source: 'ContextMenu'
            };
            return [
                this.createMenuItemShowPopup('calculated-column-edit', 'Edit Calculated Column', this.moduleInfo.Popup, this.moduleInfo.Glyph, popupParam)
            ];
        }
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.calculatedColumnApi.getCalculatedColumns(),
            AddAction: $754f469a84cf6e6e$export$b40c2dc2e1bce126,
            EditAction: $754f469a84cf6e6e$export$f21cff55af8ea46e
        };
    }
    toView(calculateColumn) {
        const settingsTags = (0, $d9298ad1a739849f$export$e7ffe35903ce510a)(calculateColumn.CalculatedColumnSettings);
        let items = [
            {
                name: 'Settings',
                label: 'Column Id',
                values: [
                    calculateColumn.ColumnId
                ]
            },
            calculateColumn.FriendlyName && {
                name: 'Settings',
                label: 'Column Name',
                values: [
                    calculateColumn.FriendlyName
                ]
            },
            (0, $fd2573a8dd303dd4$export$2651322f5f12da6f)(calculateColumn.Query, this.api)
        ].filter(Boolean);
        if ((0, $9g4SS.default).IsNotNullOrEmpty(settingsTags)) items.push({
            name: 'Settings',
            values: settingsTags
        });
        items.push((0, $52125728d99aa873$export$287b3702a135396b)(calculateColumn, this.api));
        return {
            items: items,
            abObject: calculateColumn
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects().map((calculatedColumn)=>this.toView(calculatedColumn));
    }
    getViewProperties() {
        return {
            getDeleteAction: $754f469a84cf6e6e$export$8a2941134f9c2f4,
            getEditWizard: ()=>(0, $d132bb6b66aceaeb$export$a8161260eb20efb3)
        };
    }
}




var $9g4SS = parcelRequire("9g4SS");



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $692d03a290feaea9$var$baseClassName = 'ab-EmptyContent';
const $692d03a290feaea9$var$EmptyContent = ({ children: children, className: className, style: style, ...flexProps })=>{
    if (typeof children === 'string') children = $acw62.createElement("p", null, children);
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: `${$692d03a290feaea9$var$baseClassName}__wrapper twa:flex-1 twa:relative twa:size-full`
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        ...flexProps,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:absolute twa:inset-0 twa:text-3 twa:text-center twa:p-4', 'twa:[&_p]:text-primary-foreground', $692d03a290feaea9$var$baseClassName, className),
        style: style
    }, children));
};
var $692d03a290feaea9$export$2e2bcd8739ae039 = $692d03a290feaea9$var$EmptyContent;



const $2b7a09b743acf941$var$columnsMap = {
    Operation: {
        field: 'Operation',
        defaultFlex: 1
    },
    Value: {
        field: 'Value',
        defaultFlex: 1
    }
};
const $2b7a09b743acf941$var$tableDOMProps = {
    style: {
        height: '100%',
        minWidth: '20rem',
        minHeight: 380
    }
};
class $2b7a09b743acf941$export$ee8c64b8520d04c6 extends $acw62.Component {
    render() {
        let data = [];
        if (this.props.CellSummary != null) data = Object.keys(this.props.CellSummary).map((operationName)=>{
            const operationLabel = operationName === 'Std_Deviation' ? 'Std. Deviation' : operationName;
            return {
                Operation: operationLabel,
                Value: this.props.CellSummary[operationName]
            };
        });
        return $acw62.createElement($acw62.Fragment, null, this.props.CellSummary != null ? $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
            data: data,
            primaryKey: "Operation"
        }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
            domProps: $2b7a09b743acf941$var$tableDOMProps,
            columns: $2b7a09b743acf941$var$columnsMap
        })) : $acw62.createElement((0, $692d03a290feaea9$export$2e2bcd8739ae039), null, $acw62.createElement("p", null, "No cells are selected - please select some cells.")));
    }
}



const $1a56de5e8f596768$export$65b584f001ff426c = ()=>{
    const cellSummary = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Internal.CellSummary.CellSummaryInfo);
    const summary = $acw62.createElement((0, $2b7a09b743acf941$export$ee8c64b8520d04c6), {
        CellSummary: cellSummary
    });
    return cellSummary && cellSummary.Count ? summary : // the extra wrapper is added because the empty text is rendered
    // inside a  EmptyContent, hat has position absolute
    $acw62.createElement("div", {
        style: {
            position: 'relative',
            width: '100%',
            height: 80
        }
    }, summary);
};


const $b214c2f7556e170c$export$c7f83c05d42fddf8 = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const cellSummaryApi = adaptable.api.cellSummaryApi;
    const module = adaptable.ModuleService.getModuleById($42e863194fcb493f$export$bbf6ee8f129590d);
    const text = `${cellSummaryApi.getCurrentCellSummaryOperation()}: ${cellSummaryApi.getCurrentCellSummaryOperationValue() ?? 'N/A'}`;
    const onAction = ()=>{
        adaptable.api.cellSummaryApi.openCellSummaryPopupSettingsPanel();
    };
    $acw62.useEffect(()=>{
        let cleanupEvent = ()=>null;
        const checkSelectedCells = ()=>{
            dispatch($5b564bb703f29152$export$1e02d3cd4f056ef1());
        };
        if (adaptable) cleanupEvent = adaptable._on('CellsSelected', ()=>{
            checkSelectedCells();
        });
        checkSelectedCells();
        return ()=>cleanupEvent?.();
    }, []);
    return $acw62.createElement((0, $c3c8f1b03eab6873$export$6e0a8a81c9521e24), {
        tooltip: module.moduleInfo.ModuleName,
        "data-name": module.moduleInfo.ModuleName,
        icon: module.moduleInfo.Glyph,
        onAction: onAction,
        content: text,
        popover: (0, $1a56de5e8f596768$export$65b584f001ff426c),
        popoverMinWidth: 360
    });
};



class $880b22dbd1564ec7$export$b1ea15659c0d3dd7 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    cachedCellSummary = new WeakMap();
    constructor(api){
        super($42e863194fcb493f$export$bbf6ee8f129590d, $42e863194fcb493f$export$a00f65970079ad19, 'cells', 'CellSummaryPopup', 'See summary information on a group of numeric cells using multiple summary operations', api);
    }
    isModuleAvailable() {
        return super.isModuleAvailable() && this.api.gridApi.isGridRangeSelectable();
    }
    getViewAccessLevel() {
        return 'Full';
    }
    createColumnMenuItems(column) {
        if (!this.isModuleVisible()) return;
        if (column.dataType !== 'number') return;
        return [
            this.createMainMenuItemShowPopup({
                Name: 'cell-summary-show',
                Label: 'See Cell Summary',
                ComponentName: this.moduleInfo.Popup,
                Icon: this.moduleInfo.Glyph,
                PopupParams: {
                    source: 'ColumnMenu',
                    column: column
                }
            })
        ];
    }
    createContextMenuItems(menuContext) {
        if (!this.isModuleVisible()) return;
        if (menuContext.adaptableColumn && menuContext.isSelectedCell && menuContext.adaptableColumn.dataType === 'number') return [
            this.createMainMenuItemShowPopup({
                Name: 'cell-summary-show',
                Label: 'See Cell Summary',
                ComponentName: this.moduleInfo.Popup,
                Icon: this.moduleInfo.Glyph,
                PopupParams: {
                    source: 'ContextMenu'
                }
            })
        ];
    }
    createCellSummaryInfo(selectedCellInfo) {
        if (this.cachedCellSummary.has(selectedCellInfo)) return this.cachedCellSummary.get(selectedCellInfo);
        let selectedCellSummary = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyCellSummmary();
        if (selectedCellInfo && (0, $9g4SS.ArrayExtensions).hasOneItem(selectedCellInfo.columns)) {
            let selectedColumn = selectedCellInfo.columns[0];
            if (selectedColumn && selectedColumn.dataType === 'number') {
                const numberFormatOptions = this.getNumberFormatOptions(selectedColumn);
                const rowNodes = selectedCellInfo.gridCells.map((gc)=>gc.rowNode);
                const handleExpression = (functionName)=>{
                    const aggScalarValue = new (0, $204192e364083da9$export$2543999d196edf32)({
                        aggregatedScalarExpression: `${functionName}([${selectedColumn.columnId}])`
                    }, $42e863194fcb493f$export$bbf6ee8f129590d, this.api, ()=>rowNodes);
                    return this.formatValue(numberFormatOptions, selectedColumn, aggScalarValue.getGlobalAggregatedValue(), rowNodes[0]);
                };
                const sumValue = handleExpression('SUM');
                const avgValue = handleExpression('AVG');
                const modeValue = handleExpression('MODE');
                const medianValue = handleExpression('MEDIAN');
                const distinctValue = handleExpression('DISTINCT');
                const maxValue = handleExpression('MAX');
                const minValue = handleExpression('MIN');
                const countValue = selectedCellInfo.gridCells.length;
                const stdDeviation = handleExpression('STD_DEVIATION');
                selectedCellSummary = {
                    Sum: sumValue,
                    Average: avgValue,
                    Median: medianValue,
                    Mode: modeValue,
                    Distinct: distinctValue,
                    Max: maxValue,
                    Min: minValue,
                    Count: countValue,
                    Std_Deviation: stdDeviation,
                    Only: distinctValue == 1 ? JSON.stringify(selectedCellInfo.gridCells[0].rawValue) : undefined
                };
                const weightedAverageConfig = this.getWeightedAverageConfig(selectedColumn.columnId);
                if (weightedAverageConfig) {
                    const weightedAverage = this.getWeightedAverageCellSummary(weightedAverageConfig, selectedColumn.columnId, rowNodes);
                    if (weightedAverage !== null) selectedCellSummary.Weighted_Average = this.formatValue(numberFormatOptions, selectedColumn, weightedAverage, rowNodes[0]);
                }
                const customCellSummaryOperations = this.api.cellSummaryApi.getCustomCellSummaryOperations();
                customCellSummaryOperations?.forEach((operation)=>{
                    if (operation.operationFunction) {
                        const cellSummaryOperationContext = {
                            selectedCellInfo: selectedCellInfo,
                            selectedColumn: selectedColumn,
                            ...this.api.internalApi.buildBaseContext()
                        };
                        selectedCellSummary[operation.operationName] = operation.operationFunction(cellSummaryOperationContext);
                    }
                });
                this.cachedCellSummary.set(selectedCellInfo, selectedCellSummary);
            }
        }
        return selectedCellSummary;
    }
    getNumberFormatOptions(column) {
        let columnToFormat = column;
        let adaptableFormat;
        // first get any Display Formats applied for the column and if provided, then return those
        // note: this will automatically include any custom formats
        adaptableFormat = this.api.formatColumnApi.getDisplayFormatForColumn(columnToFormat);
        if (adaptableFormat) return adaptableFormat.Options;
        // temporary hack until we get the parent for pivot columns - just in case we dont have time...
        if (columnToFormat.isGeneratedPivotResultColumn) {
            const parts = columnToFormat.columnId.split('_');
            const colid = parts[parts.length - 1];
            columnToFormat = this.api.columnApi.getColumnWithColumnId(colid);
            // check if this pivot result column has been give its own Format and if so return it
            adaptableFormat = this.api.formatColumnApi.getDisplayFormatForColumn(columnToFormat);
            if (adaptableFormat) return adaptableFormat.Options;
        }
        // otherwise get the numeric format in Cell Summary Options (either function or value)
        const numericDisplayFormat = this.api.optionsApi.getCellSummaryOptions().numericDisplayFormat;
        if (typeof numericDisplayFormat === 'function') {
            const context = {
                column: columnToFormat,
                ...this.api.internalApi.buildBaseContext()
            };
            return numericDisplayFormat(context);
        } else return numericDisplayFormat;
    }
    formatValue(formatterOptions, column, valueToFormat, node) {
        return isNaN(valueToFormat) ? valueToFormat : this.api.formatColumnApi.internalApi.getNumberFormattedValue(valueToFormat, node, column, formatterOptions);
    }
    getWeightedAverageConfig(columnId) {
        const weightedAverageConfig = (this.api.layoutApi.getCurrentLayout().TableAggregationColumns || []).find(({ ColumnId: ColumnId, AggFunc: AggFunc })=>typeof AggFunc === 'object' && AggFunc.type === 'weightedAverage' && ColumnId === columnId);
        return weightedAverageConfig;
    }
    getWeightedAverageCellSummary(weightedAverageConfig, columnId, rowNodes) {
        const weightedColumnId = weightedAverageConfig.AggFunc.weightedColumnId;
        const expression = `AVG([${columnId}], WEIGHT([${weightedColumnId}]))`;
        const aggScalarValue = new (0, $204192e364083da9$export$2543999d196edf32)({
            aggregatedScalarExpression: expression
        }, $42e863194fcb493f$export$bbf6ee8f129590d, this.api, ()=>rowNodes);
        return aggScalarValue.getGlobalAggregatedValue();
    }
    getViewProperties() {
        return {
            getStatusBarPanelProps () {
                /**
                 * This uses a custom view because it has special logic to
                 * trigger summary operations when the component is rendered.
                 */ return {
                    view: (0, $b214c2f7556e170c$export$c7f83c05d42fddf8)
                };
            }
        };
    }
}






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");







const $a20261d83897223c$export$c0a0d734cc34f659 = (data)=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2 twa:py-2 twa:pr-2"
    }, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
        className: "twa:mr-2"
    }, "Name: ", data.Name), $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "Column: ", api.columnApi.getFriendlyNameForColumnId(data.ColumnId)));
};
const $a20261d83897223c$export$5bc05846fec274c3 = (data, allCustomSorts)=>{
    if (!data.Name) return 'A name is required.';
    if (allCustomSorts.some((customSort)=>customSort.Name === data.Name && customSort.Uuid !== data.Uuid)) return 'A Custom Sort with this name already exists.';
    if (!data.ColumnId) return 'Please select a column for the Custom Sort.';
    return true;
};
const $a20261d83897223c$export$5633dfbf041ff3f5 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const sortableCols = $acw62.useMemo(()=>{
        const sortableColumns = api.columnApi.getSortableColumns();
        const nonComparerSortableColumns = sortableColumns.filter((c)=>{
            return api.customSortApi.internalApi.columnHasCustomSortComparer(c.columnId);
        });
        const customSorts = api.customSortApi.getCustomSorts();
        const columnSortComparers = api.optionsApi.getCustomSortOptions().customSortComparers || [];
        const usedColumnIds = [
            ...customSorts.map((customSort)=>customSort.ColumnId),
            ...columnSortComparers.map((comparer)=>api.columnScopeApi.getColumnIdsInScope(comparer.scope))
        ];
        // filter out used colum ids, but include the current one
        return sortableColumns.filter((column)=>{
            if (api.customSortApi.internalApi.columnHasCustomSortComparer(column.columnId)) return false;
            if (!props.isNew && column.columnId === data?.ColumnId) return true;
            return usedColumnIds.every((usedColumnId)=>{
                return column.columnId !== usedColumnId;
            });
        });
    }, []);
    const onNameChange = (event)=>{
        props.onChange({
            ...data,
            Name: event.target.value
        });
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        style: {
            height: '100%'
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mb-3"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:max-w-[300px] twa:w-full"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        className: "twa:w-full",
        "data-name": "custom-sort-name",
        onChange: onNameChange,
        value: data?.Name ?? ''
    })))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        style: {
            flex: 1,
            minHeight: 0
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $a5fb2ed975764e91$export$ac01ee0b3a94fb49), {
        availableColumns: sortableCols,
        selected: data.ColumnId ? [
            data.ColumnId
        ] : [],
        singleSelect: true,
        onChange: (ids)=>{
            props.onChange({
                ...data,
                SortedValues: [],
                ColumnId: ids[0]
            });
        },
        allowReorder: false
    }))));
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $ce6c64224079063e$export$57a80cbf859d803c = (props)=>{
    return $acw62.createElement("div", {
        style: props.style,
        className: "ab-Loader__Spinner"
    });
};
const $ce6c64224079063e$export$3b0d6d7590275603 = (props)=>{
    return $acw62.createElement("div", {
        style: props.style,
        className: "ab-Loader"
    }, $acw62.createElement($ce6c64224079063e$export$57a80cbf859d803c, null), $acw62.createElement("span", {
        className: "ab-Loader__text"
    }, props.children));
};










var $9g4SS = parcelRequire("9g4SS");


const $628efb6ba313d60e$export$8790f0a03b984fbc = (data)=>{
    if (!data.SortedValues || !data.SortedValues.length) return 'At least one value is required for the Custom Sort order.';
    return true;
};
const $628efb6ba313d60e$export$6373262af0e0914 = (data)=>{
    return $acw62.createElement((0, $3283d8fe16778b21$export$f9fef0f55402315b), {
        tags: data.SortedValues.map(String)
    });
};
const $628efb6ba313d60e$export$d618cb8edb90850d = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const [distinctValues, setDistinctValues] = (0, $acw62.useState)([]);
    const [isDistinctValuesLoading, setIsDistinctValuesLoading] = (0, $acw62.useState)(false);
    const columnDataType = api.columnApi.getColumnDataTypeForColumnId(data.ColumnId);
    (0, $acw62.useEffect)(()=>{
        let isMounted = true;
        (async ()=>{
            // for sync and very fast resolving promises does not make sense to show a loader
            setDistinctValues([]);
            const newValues = await (0, $7df315338233fd60$export$c73a921563bfad03)(api.gridApi.internalApi.getDistinctValuesForColumn(data.ColumnId), ()=>isMounted && setIsDistinctValuesLoading(true)) ?? [];
            if (!isMounted) return;
            setIsDistinctValuesLoading(false);
            setDistinctValues(newValues);
        })();
        return ()=>{
            isMounted = false;
        };
    }, [
        data.ColumnId
    ]);
    const toIdentifier = (optionItem)=>{
        return api.customSortApi.internalApi.getCustomSortValue(optionItem, columnDataType);
    };
    const toLabel = (optionItem)=>{
        return `${optionItem}`;
    };
    const sortedValuesMap = (0, $acw62.useMemo)(()=>{
        if (!data.SortedValues || !data.SortedValues.length) return new Map();
        return data.SortedValues.reduce((acc, val)=>{
            acc.set(val, true);
            return acc;
        }, new Map());
    }, [
        data.SortedValues
    ]);
    const allowReorder = $acw62.useCallback((option)=>{
        return sortedValuesMap.has(toIdentifier(option));
    }, [
        sortedValuesMap
    ]);
    const getOptionValues = (gridCells)=>{
        return gridCells.map((gridCell)=>{
            return columnDataType === 'date' ? (0, $eccba2ee7b674d85$export$53b52b78a0e685f9)(gridCell.rawValue) : gridCell.normalisedValue;
        });
    };
    const options = (0, $acw62.useMemo)(()=>{
        return (0, $9g4SS.default).sortArrayWithOrder(getOptionValues(distinctValues), data.SortedValues, {
            sortUnorderedItems: false
        });
    }, [
        allowReorder,
        distinctValues,
        data.SortedValues
    ]);
    const baseClassName = 'ab-CustomSortWizard__SortOrder';
    const className = (0, $c72009da7485afc2$export$2e2bcd8739ae039)(baseClassName, isDistinctValuesLoading && `${baseClassName}--loading`);
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        style: {
            height: '100%'
        },
        className: className
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Sort Order"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, isDistinctValuesLoading && $acw62.createElement((0, $ce6c64224079063e$export$3b0d6d7590275603), null, "Loading"), $acw62.createElement((0, $d2ae5bba8d7d6225$export$98c0468e3210506e), {
        toIdentifier: toIdentifier,
        toLabel: toLabel,
        options: options,
        value: data.SortedValues,
        allowReorder: allowReorder,
        onChange: (SortedValues)=>{
            props.onChange({
                ...data,
                SortedValues: SortedValues
            });
        }
    })));
};







const $624cad701eeb2161$export$3a6dad8349cae305 = (props)=>{
    let data = props.data;
    const allCustomSorts = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.CustomSort?.CustomSorts);
    if (props.popupParams?.action === 'Edit' && props.popupParams?.column) data = allCustomSorts.find((x)=>x.ColumnId == props.popupParams?.column.columnId);
    const [customSort, setCustomSort] = (0, $acw62.useState)(()=>{
        if (data) return (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(data);
        const newData = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyCustomSort();
        if (props.popupParams?.column) newData.ColumnId = props.popupParams?.column.columnId;
        return newData;
    });
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleFinish = ()=>{
        if (data) dispatch($75a64529baee8b47$export$4b53156c61c1ad3d(customSort));
        else dispatch($75a64529baee8b47$export$9cd83b3dd04bb797(customSort));
        props.onFinishWizard(customSort);
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: customSort,
        onFinish: handleFinish,
        onHide: props.onCloseWizard,
        sections: [
            {
                isValid: (data)=>(0, $a20261d83897223c$export$5bc05846fec274c3)(data, allCustomSorts),
                renderSummary: (0, $a20261d83897223c$export$c0a0d734cc34f659),
                details: 'Enter Name and select a Column for Custom Sort',
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $a20261d83897223c$export$5633dfbf041ff3f5), {
                        isNew: props.isNew,
                        onChange: setCustomSort,
                        allCustomSorts: allCustomSorts
                    }));
                },
                title: 'Name & Column'
            },
            {
                title: 'Sort Order',
                details: 'Specify Custom Sort order - drag selected items to modify order',
                isValid: (0, $628efb6ba313d60e$export$8790f0a03b984fbc),
                renderSummary: (0, $628efb6ba313d60e$export$6373262af0e0914),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $628efb6ba313d60e$export$d618cb8edb90850d), {
                        onChange: setCustomSort
                    }))
            },
            {
                details: 'Select Custom Sort Tags',
                title: 'Tags',
                isVisible: (_, api)=>api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setCustomSort
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                title: 'Summary',
                details: 'Review your Custom Sort',
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null));
                }
            }
        ]
    });
};


const $5cd1575693c044ab$export$d3c5bb2ed04187c8 = (customSort, api)=>{
    return {
        name: 'Column',
        values: [
            api.columnApi.getFriendlyNameForColumnId(customSort.ColumnId)
        ]
    };
};


const $2a3ffe2220f56bb5$export$aec3ec244924a5db = (customSort)=>{
    return {
        name: 'Sort Order',
        values: customSort.SortedValues
    };
};



class $577549681a4e9b4b$export$f8cd338d60465d1b extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$efdce168daed1549, $42e863194fcb493f$export$100c6fbbb6898dd8, 'import-export', 'CustomSortPopup', 'Provide bespoke sorting information for Columns (in place of alphabetical sorting)', api);
    }
    getModuleAdaptableObjects(config) {
        return this.api.customSortApi.getCustomSorts(config);
    }
    getExplicitlyReferencedColumnIds(customSort) {
        return [
            customSort.ColumnId
        ];
    }
    hasNamedQueryReferences() {
        return false;
    }
    createColumnMenuItems(column) {
        if (column && this.isModuleEditable() && column.sortable) {
            if (!this.api.customSortApi.internalApi.columnHasCustomSortComparer(column.columnId)) {
                let customSort = this.api.customSortApi.getCustomSorts().find((x)=>x.ColumnId == column.columnId);
                let label = customSort ? 'Edit ' : 'Create ';
                let popupParam = {
                    column: column,
                    action: customSort ? 'Edit' : 'New',
                    source: 'ColumnMenu'
                };
                let name = customSort ? 'custom-sort-edit' : 'custom-sort-add';
                return [
                    this.createMenuItemShowPopup(name, label + 'Custom Sort', this.moduleInfo.Popup, this.moduleInfo.Glyph, popupParam)
                ];
            }
        }
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.customSortApi.getCustomSorts(),
            AddAction: $75a64529baee8b47$export$9cd83b3dd04bb797,
            EditAction: $75a64529baee8b47$export$4b53156c61c1ad3d
        };
    }
    toView(customSort) {
        return {
            items: [
                {
                    name: 'Name',
                    values: [
                        customSort.Name
                    ]
                },
                (0, $5cd1575693c044ab$export$d3c5bb2ed04187c8)(customSort, this.api),
                (0, $2a3ffe2220f56bb5$export$aec3ec244924a5db)(customSort),
                (0, $52125728d99aa873$export$287b3702a135396b)(customSort, this.api)
            ],
            abObject: customSort
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects({
            includeLayoutNotExtendedObjects: this.showLayoutNonExtendedObjects()
        }).map((customSort)=>this.toView(customSort));
    }
    getViewProperties() {
        return {
            getEditAction: $75a64529baee8b47$export$4b53156c61c1ad3d,
            getDeleteAction: $75a64529baee8b47$export$6fc68e516c87f722,
            getSuspendAction: $75a64529baee8b47$export$259d7a681e73c8b6,
            getUnSuspendAction: $75a64529baee8b47$export$d37aedd8579b604,
            getSuspendAllAction: $75a64529baee8b47$export$20981ed2c354783f,
            getUnSuspendAllAction: $75a64529baee8b47$export$ed3948c082d4a953,
            emptyView: "Click 'New' to create a custom Sort Order for a selected Column",
            getEditWizard () {
                return 0, $624cad701eeb2161$export$3a6dad8349cae305;
            }
        };
    }
    containsLayoutExtensions() {
        return true;
    }
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $9OAZF = parcelRequire("9OAZF");
const $25a466b3a8eee6fb$export$23b1e8580c697083 = (props)=>{
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "play",
        tooltip: (0, $9OAZF.default).IsNullOrEmpty(props.tooltip) ? 'Play' : props.tooltip,
        iconSize: 20,
        icon: "play",
        variant: "text",
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

const $39b7a9837b4e4ef1$export$9a3ab81a844a27ca = (props)=>{
    const buttonIcon = props.fillColor === 'red' ? {
        name: 'pause',
        style: {
            fill: 'red'
        }
    } : {
        name: 'pause'
    };
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "pause",
        tooltip: "Pause",
        iconSize: 20,
        icon: buttonIcon,
        variant: "text",
        ...props
    });
};



var $acw62 = parcelRequire("acw62");

class $53ea84fdc7f88e84$export$1c8def558a81e30e extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "stop",
            tooltip: "Stop",
            iconSize: 20,
            icon: "stop",
            variant: "text",
            ...this.props
        });
    }
}








const $9496a3e89e38ca39$export$7b7ccfbe7e516813 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const onChangeHistoryEnable = $acw62.useCallback(()=>dispatch((0, $5b564bb703f29152$export$d4cbdbb82d50fbc3)()), []);
    const onChangeHistoryDisable = $acw62.useCallback(()=>dispatch((0, $5b564bb703f29152$export$4344ed6f5015b32c)()), []);
    const onChangeHistorySuspend = $acw62.useCallback(()=>dispatch((0, $5b564bb703f29152$export$89243c08c46c6822)()), []);
    const onChangeHistoryResume = $acw62.useCallback(()=>dispatch((0, $5b564bb703f29152$export$d6776ceaeb5c77dd)()), []);
    const handleOpenPopup = $acw62.useCallback(()=>{
        adaptable.api.settingsPanelApi.openSettingsPanel('DataChangeHistory');
    }, []);
    const dataChangeHistoryState = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Internal.DataChangeHistory);
    const changeHistoryMode = dataChangeHistoryState.currentMode;
    const activationTime = dataChangeHistoryState.enableTime;
    const suspensionTime = dataChangeHistoryState.suspendTime;
    const enabled = changeHistoryMode === 'ACTIVE';
    const disabled = changeHistoryMode === 'INACTIVE';
    const suspended = changeHistoryMode === 'SUSPENDED';
    const gap = props.gap ?? 'var(--ab-base-space)';
    const buttonsPaddingY = props.buttonsPaddingY ?? 2;
    const buttonPanel = $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-DataChangeHistoryPanel--button-panel",
        style: {
            gap: gap,
            paddingBlock: buttonsPaddingY
        }
    }, disabled && $acw62.createElement((0, $25a466b3a8eee6fb$export$23b1e8580c697083), {
        "aria-label": "Enable Data Change History",
        className: "ab-DataChangeHistoryPanel--button-activate",
        "data-name": 'data-change-history--button-activate',
        tooltip: '',
        onClick: ()=>onChangeHistoryEnable()
    }), suspended && $acw62.createElement((0, $25a466b3a8eee6fb$export$23b1e8580c697083), {
        "aria-label": "Resume Data Change History",
        className: "ab-DataChangeHistoryPanel--button-resume",
        "data-name": 'data-change-history--button-resume',
        tooltip: 'Resume tracking data changes',
        onClick: ()=>onChangeHistoryResume()
    }), enabled && $acw62.createElement((0, $39b7a9837b4e4ef1$export$9a3ab81a844a27ca), {
        "aria-label": "Suspend Data Change History",
        className: "ab-DataChangeHistoryPanel--button-suspend",
        "data-name": 'data-change-history--button-suspend',
        tooltip: 'Suspend tracking data changes',
        onClick: ()=>onChangeHistorySuspend()
    }), (enabled || suspended) && $acw62.createElement((0, $53ea84fdc7f88e84$export$1c8def558a81e30e), {
        "aria-label": "Deactivate Data Change History",
        className: "ab-DataChangeHistoryPanel--button-deactivate",
        "data-name": 'data-change-history--button-deactivate',
        tooltip: 'Deactivate data change tracking',
        onClick: ()=>onChangeHistoryDisable()
    }));
    const dateFormat = `${adaptable.api.optionsApi.getUserInterfaceOptions().dateInputOptions.dateFormat} HH:mm:ss`;
    const statusPanel = $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-DataChangeHistoryPanel--status-panel",
        alignItems: 'center',
        style: {
            gap: gap
        }
    }, enabled && $acw62.createElement((0, $0735c2b2ea9ec97d$export$2e2bcd8739ae039), {
        label: !!activationTime && `since ${(0, $1fe81e1078ace264$export$ad991b66133851cf)(activationTime, {
            Pattern: dateFormat
        })}`
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-DataChangeHistoryPanel--status-active twa:text-2 twa:text-success"
    }, "Active")), suspended && $acw62.createElement((0, $0735c2b2ea9ec97d$export$2e2bcd8739ae039), {
        label: !!suspensionTime && `since ${(0, $1fe81e1078ace264$export$ad991b66133851cf)(suspensionTime, {
            Pattern: dateFormat
        })}`
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-DataChangeHistoryPanel--status-suspended twa:text-2 twa:text-warn"
    }, "Suspended")), disabled && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-DataChangeHistoryPanel--status-disabled twa:text-2"
    }, "Activate Data Tracking"));
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: 'row'
    }, buttonPanel, statusPanel, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:ml-2"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onClick: handleOpenPopup,
        variant: "text"
    }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "open-in-new"
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-1"
    }, "Show"))));
};


const $85d03eb77e2a9775$export$69022e130d62283 = ()=>{
    return $acw62.createElement((0, $9496a3e89e38ca39$export$7b7ccfbe7e516813), {
        gap: 0,
        buttonsPaddingY: 0
    });
};


class $093cc3ebd7f6bade$export$d2d584b75ea1eea3 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    isListeningToCellDataChanges;
    constructor(api){
        super($42e863194fcb493f$export$376343cd8119f6bf, $42e863194fcb493f$export$d473711913a228c6, 'target', 'DataChangeHistoryPopup', 'Provides an overview of all previous changes, giving the possibility to undo specific changes', api);
        this.isListeningToCellDataChanges = false;
    }
    onAdaptableReady() {
        this.api.internalApi.initializeDataChangeHistory();
        this.checkListenToCellDataChanged();
    }
    getAgGridModuleDependencies() {
        return [
            'ClientSideRowModelModule'
        ];
    }
    shouldListenToDataChanges() {
        return this.api.dataChangeHistoryApi.getDataChangeHistoryMode() === 'ACTIVE';
    }
    checkListenToCellDataChanged() {
        if (!this.isListeningToCellDataChanges) {
            if (this.shouldListenToDataChanges()) {
                this.setupCellDataChangeListener();
                this.isListeningToCellDataChanges = true;
            }
        }
    }
    setupCellDataChangeListener() {
        this.api.internalApi.getDataService().on('CellDataChanged', (cellDataChangedInfo)=>{
            if (this.isListeningToCellDataChanges && this.isDataChangeLoggable(cellDataChangedInfo)) this.api.dataChangeHistoryApi.addDataChangeHistoryEntry(cellDataChangedInfo);
        });
    }
    getPopupMaxWidth() {
        return 1000;
    }
    hasNamedQueryReferences() {
        return false;
    }
    isDataChangeLoggable(cellDataChangedInfo) {
        if (cellDataChangedInfo.trigger === 'undo' || cellDataChangedInfo.trigger === 'aggChange') return false;
        if (this.api.optionsApi.getDataChangeHistoryOptions().showDataChange) return this.api.optionsApi.getDataChangeHistoryOptions().showDataChange(cellDataChangedInfo);
        return true;
    }
    getViewProperties() {
        return {
            getStatusBarPanelProps: ()=>{
                return {
                    triggerActionOnWrapperClick: false,
                    content: (0, $85d03eb77e2a9775$export$69022e130d62283)
                };
            }
        };
    }
}




class $70b8aa59f5184f63$export$f073b1cfee4f38c4 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$65414e618c4e5904, $42e863194fcb493f$export$80fb306a63e8f7ae, 'import', 'DataImportPopup', 'Import Data', api);
    }
    createModuleMenuItem(source) {
        if (this.isModuleVisible()) return this.createDataImportMenuItem(source);
    }
    createContextMenuItems() {
        if (this.isModuleVisible()) return [
            this.createDataImportMenuItem('ContextMenu')
        ];
        return undefined;
    }
    createColumnMenuItems() {
        if (this.isModuleVisible()) return [
            this.createDataImportMenuItem('ColumnMenu')
        ];
    }
    createDataImportMenuItem(source) {
        const moduleParams = {
            action: 'New',
            source: source,
            maxWidth: this.getPopupMaxWidth()
        };
        return this.createMenuItemShowPopup('data-import', 'Import Data', this.moduleInfo.Popup, this.moduleInfo.Glyph, moduleParams);
    }
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $0fa9f337c52cd4f4$export$ed433d8050015de5 = (props)=>{
    return $acw62.createElement($acw62.Fragment, null, props.options.map((option)=>$acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            className: "twa:p-2 twa:w-full",
            variant: "text",
            onClick: ()=>props.onChange(option),
            key: option.label
        }, option.label)));
};



const $478c6bc8816e6bee$export$764914e642e79419 = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dataSets = adaptable.api.dataSetApi.getDataSets();
    const handleDataSetChange = $acw62.useCallback((option)=>{
        adaptable.api.dataSetApi.setDataSet(option.label);
    }, []);
    const options = dataSets.map((dataSet)=>({
            label: dataSet.name,
            value: dataSet.name
        }));
    return $acw62.createElement((0, $0fa9f337c52cd4f4$export$ed433d8050015de5), {
        options: options,
        onChange: handleDataSetChange
    });
};




var $acw62 = parcelRequire("acw62");


const $afbdc0fed7190dd9$export$4268a4851d0a9df2 = ({ data: data })=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dataSets = adaptable.api.dataSetApi.getDataSets();
    const selectedDataSet = adaptable.api.dataSetApi.getCurrentDataSet();
    const isDisabled = dataSets?.length === 1;
    const isSelected = selectedDataSet?.name === data?.name;
    const handleToggle = $acw62.useCallback(()=>{
        adaptable.api.dataSetApi.setDataSet(data.name);
    }, [
        isSelected
    ]);
    return $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "select-dataset-button",
        "data-value": data.name,
        disabled: isDisabled,
        checked: isSelected,
        onClick: handleToggle
    });
};



class $d28ea97b07ebee59$export$99f71b933943be1 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$b0d2488aa9d7ee1f, $42e863194fcb493f$export$c95954131c91bff1, 'data-set', 'DataSetPopup', 'Update the entire data source in AdapTable using pre-populated data sets', api);
    }
    onAdaptableReady() {
        this.api.dataSetApi.getDataSets().forEach((ds)=>{
            if (!ds.Uuid) ds.Uuid = (0, $d7790b1d1a829cfc$export$10a020066a0f444a)();
        });
    }
    getModuleAdaptableObjects() {
        return this.api.optionsApi.getDataSetOptions()?.dataSets ?? [];
    }
    hasNamedQueryReferences() {
        return false;
    }
    toView(dataSet) {
        return {
            items: [
                {
                    name: 'Settings',
                    label: 'Name',
                    values: [
                        dataSet.name
                    ]
                },
                {
                    name: 'Settings',
                    label: 'Description',
                    values: [
                        dataSet.description ?? 'Not Specified'
                    ]
                },
                (0, $52125728d99aa873$export$287b3702a135396b)(dataSet, this.api)
            ],
            abObject: dataSet
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects().map((dataSet)=>this.toView(dataSet));
    }
    getViewProperties() {
        return {
            actions: [
                (0, $afbdc0fed7190dd9$export$4268a4851d0a9df2)
            ],
            emptyView: 'No DataSets are provided',
            getStatusBarPanelProps: ()=>{
                const content = this.api.dataSetApi.getCurrentDataSet()?.name ?? this.moduleInfo.FriendlyName;
                return {
                    content: content,
                    popover: (0, $478c6bc8816e6bee$export$764914e642e79419)
                };
            }
        };
    }
}






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





const $e901bced59f3026c$export$c54d0e8b7da1cfe = (report)=>{
    if (report.ReportColumnScope === 'ScopeColumns') return report.Scope != null ? true : 'Column scope is not defined';
    return true;
};
const $e901bced59f3026c$export$881e20ba9805b339 = (report)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, report.ReportColumnScope === 'AllColumns' ? $acw62.createElement($acw62.Fragment, null, "Include ", $acw62.createElement("b", null, "all Columns"), " in the Report") : null, report.ReportColumnScope === 'VisibleColumns' ? $acw62.createElement($acw62.Fragment, null, "Include ", $acw62.createElement("b", null, "only visible Columns"), " in the Report") : null, report.ReportColumnScope === 'ScopeColumns' ? $acw62.createElement($acw62.Fragment, null, (0, $65308a7002d19b3b$export$3f60d09dd2143243)(report.Scope, {
        scopeColumns: 'Report Columns',
        scopeWholeRow: 'not available',
        scopeDataTypes: 'Report will include columns with the following types'
    })) : null);
};
const $e901bced59f3026c$export$896d20d01ef28a66 = (props)=>{
    const { api: api, data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:m-2",
        value: data.ReportColumnScope,
        onValueChange: (ReportColumnScope)=>{
            const report = {
                ...data,
                ReportColumnScope: ReportColumnScope
            };
            if (report.ReportColumnScope !== 'ScopeColumns') delete report.Scope;
            else if (!report.Scope) report.Scope = {
                ColumnIds: []
            };
            props.onChange(report);
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "AllColumns"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:m-0",
        checked: data.ReportColumnScope == 'AllColumns',
        tabIndex: -1
    }, "All Columns")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "VisibleColumns"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:m-0",
        checked: data.ReportColumnScope == 'VisibleColumns',
        tabIndex: -1
    }, "Visible Columns")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "ScopeColumns"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:m-0",
        checked: data.ReportColumnScope == 'ScopeColumns',
        tabIndex: -1
    }, "Bespoke Columns")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "AllColumns"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:text-2"
    }, "All Columns in the datasource will be included in the Report, whether visible or not at time of export")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "VisibleColumns"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:text-2"
    }, "Only Columns that are visible at the time the Report is exported will be included")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "BespokeColumns"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:text-2"
    }, "Only selected Columns (which you will choose in the next step) will be exported - whether visible or not"))), data.ReportColumnScope === 'ScopeColumns' ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:flex-1 twa:overflow-auto"
    }, $acw62.createElement((0, $65308a7002d19b3b$export$b5842aa553688927), {
        hideWholeRow: true,
        isColumnAvailable: (column)=>Boolean(column.exportable),
        descriptions: {
            rowScope: 'Apply Scope for: Row, or one or more Columns, or one or more Data Types',
            columnScope: 'Selected columns will be included in the report'
        },
        scope: data.Scope,
        updateScope: (Scope)=>{
            const report = {
                ...data,
                Scope: Scope
            };
            props.onChange(report);
        }
    })) : null);
};



var $acw62 = parcelRequire("acw62");







const $c4d725dcbc12ab68$export$c1e366fe68f88c25 = (report)=>{
    if (report.ReportRowScope === 'ExpressionRows' && !report.Query?.BooleanExpression) return 'Rows query cannot be empty';
    return true;
};
const $c4d725dcbc12ab68$export$c9c3231951713d06 = (report)=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, report.ReportRowScope === 'AllRows' ? $acw62.createElement($acw62.Fragment, null, "Include ", $acw62.createElement("b", null, "all Rows"), " in the Report") : null, report.ReportRowScope === 'VisibleRows' ? $acw62.createElement($acw62.Fragment, null, "Include ", $acw62.createElement("b", null, "only visible Rows"), " in the Report") : null, report.ReportRowScope === 'ExpressionRows' ? $acw62.createElement($acw62.Fragment, null, "Include Rows matching the query:", ' ', $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, $acw62.createElement((0, $484ff53c453ae1e6$export$ca85a0e2ff97f05a), {
        query: report.Query
    }))) : null);
};
const $c4d725dcbc12ab68$export$1b8aa3bdb7a789be = (props)=>{
    const { api: api, data: data, moduleInfo: moduleInfo } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const initialData = (0, $acw62.useMemo)(()=>api.internalApi.getQueryPreviewData(), []);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:m-2",
        value: data.ReportRowScope,
        onValueChange: (ReportRowScope)=>{
            const report = {
                ...data,
                ReportRowScope: ReportRowScope
            };
            if (report.ReportRowScope !== 'ExpressionRows') delete report.Query;
            else if (!report.Query) report.Query = {
                BooleanExpression: ''
            };
            props.onChange(report);
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "AllRows"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:m-0",
        checked: data.ReportRowScope == 'AllRows',
        tabIndex: -1
    }, "All Rows")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "VisibleRows"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:m-0",
        checked: data.ReportRowScope == 'VisibleRows',
        tabIndex: -1
    }, "Visible Rows")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        value: "ExpressionRows"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:m-0",
        checked: data.ReportRowScope == 'ExpressionRows',
        tabIndex: -1
    }, "By Query")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "AllRows"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:text-2"
    }, "All Rows in the datasource will be included in the report, whether visible or not at time of export.")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "VisibleRows"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:text-2"
    }, "Only Rows that are visible at the time the Report is exported will be included in the Export")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        value: "ExpressionRows"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:pl-0 twa:text-2"
    }, "Only the Rows which match the Query will be exported - whether visible or not."), $acw62.createElement((0, $5e4c4ab15f4fe7da$export$6f88ab97c822f23a), {
        allowSaveNamedQuery: true,
        type: 'boolean',
        module: moduleInfo.ModuleName,
        style: {
            paddingLeft: 0
        },
        value: data.Query?.BooleanExpression ?? '',
        onChange: (BooleanExpression)=>{
            props.onChange({
                ...data,
                Query: {
                    BooleanExpression: BooleanExpression
                }
            });
        },
        initialData: initialData,
        columns: api.columnApi.internalApi.getQueryableColumnsForUIEditor(),
        fields: api.expressionApi.internalApi.getAvailableFields(),
        namedQueries: api.namedQueryApi.getNamedQueries(),
        api: api
    }))));
};



var $acw62 = parcelRequire("acw62");






const $eb59b4d3d59019ac$export$a93fb22e7f61b5d3 = (report)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, ' ', "Report Name: ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, report.Name));
};
const $eb59b4d3d59019ac$export$8e98c53ece55fcb4 = (report, api)=>{
    if (!report.Name) return 'Report name cannot be empty';
    const reportsWithSameNameCount = api.exportApi.getAllReports().filter((r)=>report.Name === r.Name).length;
    const hasAlreadyExistingName = report.Uuid ? reportsWithSameNameCount > 1 : reportsWithSameNameCount > 0;
    return hasAlreadyExistingName ? 'A Report already exists with that name' : true;
};
const $eb59b4d3d59019ac$export$3fbd264281a01e05 = (props)=>{
    const { api: api, data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const validCheck = $eb59b4d3d59019ac$export$8e98c53ece55fcb4(data, api);
    const ErrorMessage = validCheck === true ? null : validCheck;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        columns: [
            1,
            2
        ]
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mr-2"
    }, "Name:"), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "export-name",
        className: "twa:w-full",
        type: "text",
        autoFocus: true,
        placeholder: "Name",
        value: data.Name,
        onChange: (e)=>{
            props.onChange({
                ...data,
                Name: e.target.value
            });
        }
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), null, $acw62.createElement($acw62.Fragment, null), ErrorMessage ? $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), null, ErrorMessage) : null)));
};







const $e61d6a5f81c9f826$export$2108768aa8edab21 = (props)=>{
    const isEdit = props.popupParams?.action ? props.popupParams.action === 'Edit' : Boolean(props.data);
    const currentReport = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>{
        if (!isEdit) return;
        return state.Export.Reports.find((report)=>report.Name === state.Export.CurrentReport);
    });
    const data = props.data ?? currentReport;
    const [report, setReport] = (0, $acw62.useState)(()=>{
        return data ? (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(data) : (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyReport();
    });
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleFinish = ()=>{
        if (isEdit) dispatch($a3814690501f278b$export$93cc87a6c44ca1b(report));
        else dispatch($a3814690501f278b$export$912b4282768b66e2(report));
        props.onFinishWizard(report);
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: report,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Name',
                details: 'Enter the name of the Report',
                isValid: (0, $eb59b4d3d59019ac$export$8e98c53ece55fcb4),
                renderSummary: (0, $eb59b4d3d59019ac$export$a93fb22e7f61b5d3),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $eb59b4d3d59019ac$export$3fbd264281a01e05), {
                        onChange: setReport
                    }))
            },
            {
                title: 'Columns',
                details: 'Choose the Columns you want to include in the Report',
                renderSummary: (0, $e901bced59f3026c$export$881e20ba9805b339),
                render: ()=>$acw62.createElement((0, $e901bced59f3026c$export$896d20d01ef28a66), {
                        onChange: setReport
                    })
            },
            {
                title: 'Rows',
                details: 'Choose the Rows you want to include in the Report',
                isValid: (0, $c4d725dcbc12ab68$export$c1e366fe68f88c25),
                renderSummary: (0, $c4d725dcbc12ab68$export$c9c3231951713d06),
                render: ()=>$acw62.createElement((0, $c4d725dcbc12ab68$export$1b8aa3bdb7a789be), {
                        onChange: setReport
                    })
            },
            {
                details: 'Select Report Tags',
                title: 'Tags',
                isVisible: (_, api)=>api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setReport
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                title: 'Summary',
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null));
                }
            }
        ]
    });
};


const $3f1c61d30b5cf5e6$export$804f04fd36f82b25 = (report, api)=>{
    return {
        name: 'Columns',
        values: [
            ...api.exportApi.internalApi.getReportColumnScopeShortDescription(report)
        ]
    };
};



var $acw62 = parcelRequire("acw62");


const $ee7ef469314f0e0e$export$6461afa752e570d8 = (report, api)=>{
    let element = null;
    if (report.ReportRowScope === 'ExpressionRows') element = $acw62.createElement((0, $484ff53c453ae1e6$export$ca85a0e2ff97f05a), {
        query: report.Query
    });
    else element = api.exportApi.internalApi.getReportExpressionDescription(report, api.columnApi.getColumns());
    return {
        name: 'Rows',
        view: $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, element)
    };
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




const $70bf682cdf60405e$export$6fd82bc2349fee66 = (props)=>{
    const { reportName: reportName, onReportNameSelected: onReportNameSelected, size: size = 'normal' } = props;
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const exportApi = adaptable.api.exportApi;
    const allReportNames = exportApi.internalApi.getAllAvailableReportNames();
    const reportItems = allReportNames.map((report)=>{
        return {
            label: report,
            value: report
        };
    });
    const elementType = props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        "data-name": "report-name-selector",
        className: "twa:min-w-[160px] twa:flex-1"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "aria-label": (0, $58846ea7f4156db7$export$84d2b57a65e345bb),
        size: size,
        "data-name": "report-name-selector",
        placeholder: (0, $58846ea7f4156db7$export$84d2b57a65e345bb),
        disabled: !allReportNames.length,
        className: `ab-${elementType}__Export__report-select twa:w-full`,
        options: reportItems,
        onChange: (report)=>onReportNameSelected(report),
        value: reportName,
        isClearable: true
    }));
};



var $acw62 = parcelRequire("acw62");




const $cf8aebbb61cbdf00$export$673b1a0e3cf8a45 = (props)=>{
    const { reportName: reportName, reportFormat: reportFormat, onReportFormatSelected: onReportFormatSelected, size: size = 'normal' } = props;
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const exportApi = adaptable.api.exportApi;
    const allFormats = exportApi.getAvailableSystemFormats();
    const formatItems = allFormats.map((format)=>{
        return {
            label: format,
            value: format
        };
    });
    const elementType = props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        "data-name": "report-format-selector",
        className: "twa:min-w-[140px] twa:flex-1"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "aria-label": (0, $58846ea7f4156db7$export$6e64515c51de32a1),
        size: size,
        placeholder: (0, $58846ea7f4156db7$export$6e64515c51de32a1),
        disabled: !allFormats.length || reportName == undefined,
        className: `ab-${elementType}__Export__format-select twa:w-full`,
        options: formatItems,
        onChange: (format)=>onReportFormatSelected(format),
        value: reportFormat,
        isClearable: true
    }));
};



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

class $ce2fc2cff0df2441$export$8eb2896c2698648c extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "export",
            tooltip: "Export",
            iconSize: 20,
            icon: "export",
            variant: "text",
            ...this.props
        });
    }
}



const $8f7346cae58bd86f$export$469a85d60b6734a5 = ({ reportName: reportName, reportFormat: reportFormat, viewType: viewType })=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const exportApi = adaptable.api.exportApi;
    const handleExport = (destination)=>{
        exportApi.exportReport(reportName, reportFormat, destination);
    };
    const supportedDestinations = exportApi.getSupportedExportDestinations(reportFormat);
    if (supportedDestinations.length === 0 || supportedDestinations.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ce2fc2cff0df2441$export$8eb2896c2698648c), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(viewType !== 'StatusBar' ? '' : undefined, ''),
        onClick: ()=>handleExport(supportedDestinations[0]),
        tooltip: "Export Report",
        disabled: reportName == undefined || reportFormat == undefined
    });
    const destinationItems = supportedDestinations.map((destination)=>({
            label: destination,
            onClick: ()=>handleExport(destination)
        }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        "data-name": "report-export-selector",
        disabled: reportName == undefined || reportFormat == undefined,
        columns: [
            'label'
        ],
        tooltip: "Export Report",
        variant: "text",
        items: destinationItems
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "export"
    }));
};




const $d4e9e3d02c93454a$export$40e5ca5a3d513475 = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const exportApi = adaptable.api.exportApi;
    const currentReportName = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Export.CurrentReport);
    const currentFormat = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Export.CurrentFormat);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:gap-1"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70bf682cdf60405e$export$6fd82bc2349fee66), {
        viewType: "StatusBar",
        reportName: currentReportName,
        onReportNameSelected: (reportName)=>exportApi.selectReport(reportName)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cf8aebbb61cbdf00$export$673b1a0e3cf8a45), {
        viewType: "StatusBar",
        reportName: currentReportName,
        reportFormat: currentFormat,
        onReportFormatSelected: (reportFormat)=>exportApi.selectFormat(reportFormat)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f7346cae58bd86f$export$469a85d60b6734a5), {
        viewType: "StatusBar",
        reportName: currentReportName,
        reportFormat: currentFormat
    }));
};



var $acw62 = parcelRequire("acw62");



const $c489dc2df740b816$export$1ebcad26dae2e931 = (props)=>{
    const report = props.data;
    const [reportFormat, setReportFormat] = (0, $acw62.useState)(null);
    const viewType = 'SettingsPanel';
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        className: `ab-${viewType}__Export__panel`
    }, $acw62.createElement((0, $cf8aebbb61cbdf00$export$673b1a0e3cf8a45), {
        viewType: viewType,
        reportName: report.Name,
        reportFormat: reportFormat,
        onReportFormatSelected: (reportFormat)=>setReportFormat(reportFormat)
    }), $acw62.createElement((0, $8f7346cae58bd86f$export$469a85d60b6734a5), {
        viewType: "SettingsPanel",
        reportName: report.Name,
        reportFormat: reportFormat
    }));
};


class $9dc91de22c22579f$export$4e0f34fd9829977c extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$2bc329d2b6ae03ac, $42e863194fcb493f$export$c4352660356f52c7, 'export-data', 'ExportPopup', 'Export data from the Grid to numerous locations in numerous formatso', api);
    }
    getModuleAdaptableObjects() {
        return this.api.exportApi.getAllReports();
    }
    getExplicitlyReferencedColumnIds(report) {
        if (report.ReportColumnScope === 'ScopeColumns' && this.api.columnScopeApi.scopeHasColumns(report.Scope)) return this.api.columnScopeApi.getColumnsInScope(report.Scope).map((adaptableColumn)=>adaptableColumn.columnId);
        return [];
    }
    getReferencedNamedQueryNames(report) {
        if (!report.Query) return [];
        return this.api.namedQueryApi.internalApi.getReferencedNamedQueryNames(report.Query.BooleanExpression);
    }
    createContextMenuItems(menuContext) {
        const canExport = !menuContext.isRowGroupColumn && this.isModuleVisible();
        if (!canExport) return;
        let returnMenuItems = [];
        const allReportNames = this.api.exportApi.internalApi.getAllAvailableReportNames();
        const allReportFormats = this.api.exportApi.getAvailableSystemFormats();
        allReportNames.forEach((reportName)=>{
            const formatItems = allReportFormats.map((reportFormat)=>{
                const supportedDestinations = this.api.exportApi.getSupportedExportDestinations(reportFormat);
                const exportDestinationItems = supportedDestinations.map((exportDestination)=>this.createMenuItemClickFunction(this.getMenuItemName(reportName, reportFormat, exportDestination), exportDestination, this.getDestinationMenuItemIcon(exportDestination), ()=>this.api.exportApi.exportReport(reportName, reportFormat, exportDestination)));
                const formatMenuItemGroup = {
                    name: this.getMenuItemName(reportName, reportFormat),
                    label: reportFormat,
                    isVisible: true,
                    category: 'Export',
                    icon: {
                        name: this.getFormatMenuItemIcon(reportFormat)
                    },
                    subItems: exportDestinationItems
                };
                return formatMenuItemGroup;
            });
            const reportMenuItemGroup = {
                name: this.getMenuItemName(reportName),
                label: reportName,
                isVisible: true,
                category: 'Export',
                icon: {
                    name: 'export-data'
                },
                subItems: formatItems
            };
            returnMenuItems.push(reportMenuItemGroup);
        });
        return returnMenuItems;
    }
    getMenuItemName(reportName, reportFormat, exportDestination) {
        // convert to lowercase and replace empty spaces with hyphens
        const adjustName = (name = '')=>{
            const result = name.replace(/ /g, '-');
            return result.toLowerCase();
        };
        let name = `export-${adjustName(reportName)}`;
        if (reportFormat) name += `-${adjustName(reportFormat)}`;
        if (exportDestination) name += `-${adjustName(exportDestination)}`;
        return name;
    }
    getDestinationMenuItemIcon(exportDestination) {
        switch(exportDestination){
            case 'Download':
                return 'downloaded';
            case 'Clipboard':
                return 'clipboard';
            default:
                return 'export-data';
        }
    }
    getFormatMenuItemIcon(reportFormat) {
        switch(reportFormat){
            case 'Excel':
                return 'excel';
            case 'VisualExcel':
                return 'color-palette';
            case 'CSV':
                return 'csv';
            case 'JSON':
                return 'json';
            default:
                return 'export';
        }
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.exportApi.getAllReports(),
            AddAction: $a3814690501f278b$export$912b4282768b66e2,
            EditAction: $a3814690501f278b$export$93cc87a6c44ca1b
        };
    }
    toView(report) {
        const isSystemReport = this.api.exportApi.internalApi.isSystemReport(report.Name);
        if (isSystemReport) return {
            items: [
                {
                    name: 'Report',
                    values: [
                        report.Name
                    ]
                },
                (0, $52125728d99aa873$export$287b3702a135396b)(report, this.api)
            ],
            abObject: report
        };
        return {
            items: [
                {
                    name: 'Report',
                    values: [
                        report.Name
                    ]
                },
                (0, $3f1c61d30b5cf5e6$export$804f04fd36f82b25)(report, this.api),
                (0, $ee7ef469314f0e0e$export$6461afa752e570d8)(report, this.api),
                (0, $52125728d99aa873$export$287b3702a135396b)(report, this.api)
            ],
            abObject: report
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects().map((report)=>this.toView(report));
    }
    getViewProperties() {
        return {
            newTooltipText: 'Create New Report',
            actions: [
                (0, $c489dc2df740b816$export$1ebcad26dae2e931)
            ],
            getDeleteAction: $a3814690501f278b$export$4373a255555364a8,
            getEditWizard () {
                return 0, $e61d6a5f81c9f826$export$2108768aa8edab21;
            },
            getStatusBarPanelProps: ()=>{
                return {
                    content: (0, $d4e9e3d02c93454a$export$40e5ca5a3d513475),
                    triggerActionOnWrapperClick: false
                };
            }
        };
    }
}







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



const $e706c69e752e91b5$export$db90d729d8e01fb3 = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const filterModule = adaptable.ModuleService.getModuleById($42e863194fcb493f$export$edfe19743c8e0917);
    const columnFilters = adaptable.api.filterApi.columnFilterApi.getColumnFilters();
    return $acw62.createElement((0, $6ebf50161baa0070$export$ac46f509dad8a7e8), {
        abObjects: columnFilters,
        module: filterModule
    });
};


const $5c827d82db4d0598$export$a2707726b9bafe30 = ()=>{
    return $acw62.createElement((0, $e706c69e752e91b5$export$db90d729d8e01fb3), null);
};




const $6a7ec5df7bac55db$export$3bd855715549fe49 = (columnFilter, api)=>{
    const columnId = columnFilter.ColumnId;
    const column = api.columnApi.getColumnWithColumnId(columnId);
    const columnFilterOptions = api.optionsApi.getFilterOptions().columnFilterOptions;
    const predicateDefs = api.filterApi.columnFilterApi.getFilterPredicateDefsForColumn(column);
    const columnType = api.columnApi.getColumnDataTypeForColumnId(columnId);
    const qlDataType = (0, $47be09cb14df4bdb$export$d252517300e3b104)(columnType);
    const qlPredicateDefs = predicateDefs.map((pd)=>(0, $5b60d09ab87a9230$export$2a3e9a3fb4fb4111)(pd, qlDataType));
    const qlPredicate = (0, $5b60d09ab87a9230$export$685906aad993c4d6)(columnFilter, column, qlPredicateDefs, columnFilterOptions, 'FilterForm', api);
    return `${column.friendlyName} ${(0, $5b60d09ab87a9230$export$d9937b4f0cd29482)(qlPredicate, qlPredicateDefs)}`;
};
const $6a7ec5df7bac55db$export$4b152704e0654386 = (layout, api)=>{
    return {
        name: 'Column Filters',
        values: (layout.ColumnFilters ?? []).map((columnFilter)=>$6a7ec5df7bac55db$export$3bd855715549fe49(columnFilter, api))
    };
};


class $9e901c51b5ca5798$export$960e24ee5487e289 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$edfe19743c8e0917, $42e863194fcb493f$export$482638e9e23a2018, 'filter', 'FilterPopup', 'Advanced filtering capability allows users to see precisely the data they want', api);
    }
    onAdaptableReady() {
        if (this.api.optionsApi.getFilterOptions().columnFilterOptions.showQuickFilter == false) this.api.filterApi.columnFilterApi.hideQuickFilterBar();
        else this.api.filterApi.columnFilterApi.showQuickFilterBar();
        const columnFilters = this.api.filterApi.columnFilterApi.getColumnFilters();
        columnFilters.forEach((cf)=>{
            if (!this.api.columnApi.isColumnInGrid(cf.ColumnId)) this.api.logError('Column Filter contains missing column: ' + cf.ColumnId);
        });
        this.api.internalApi.getDataService().on('CellDataChanged', (cellDataChangedInfo)=>{
            const changedColumnId = cellDataChangedInfo.column.columnId;
            this.api.filterApi.columnFilterApi.resetFilterValues(changedColumnId);
        });
        // we reset the filter cache on sort change, because we might have columns
        // with "In" filters, with custom values, which use `context.orderedValues`
        // customInFilterValues: (context: CustomInFilterValuesContext<Car>) => {
        //   return {values: context.orderedValues};
        // }
        // and that order will most likely change when sorting happens
        // so we need to reset the cached filter values when sorting changes
        this.api.eventApi.on('GridSorted', ()=>{
            const filterOptions = this.api.optionsApi.getFilterOptions();
            if (!filterOptions.customInFilterValues) // no-one is using context.sortedValues/context.orderedValues
            // or a custom property from a value, like value.count or value.visible
            // so no need to reset the filter display values
            return;
            this.api.filterApi.columnFilterApi.resetAllFilterValues();
        });
    }
    setModuleEntitlement() {
        if (!this.api.optionsApi.getFilterOptions().useAdaptableFiltering) this.AccessLevel = 'Hidden';
        else this.AccessLevel = this.api.entitlementApi.getEntitlementAccessLevelForModule(this.moduleInfo.ModuleName);
    }
    getModuleAdaptableObjects() {
        return this.api.filterApi.columnFilterApi.getColumnFilters();
    }
    getExplicitlyReferencedColumnIds(columnFilter) {
        return [
            columnFilter.ColumnId
        ];
    }
    hasNamedQueryReferences() {
        return false;
    }
    createColumnMenuItems(column) {
        let columnFilterMenuItems = [];
        if (column && column.filterable && this.api.optionsApi.getFilterOptions().useAdaptableFiltering) {
            if (this.api.gridApi.isQuickFilterAvailable()) {
                const isFilterVisible = this.api.filterApi.columnFilterApi.isQuickFilterVisible();
                if (this.isModuleEditable() && this.api.optionsApi.getFilterOptions().useAdaptableFiltering) columnFilterMenuItems.push(this.createMenuItemReduxAction(isFilterVisible ? 'column-filter-bar-hide' : 'column-filter-bar-show', isFilterVisible ? 'Hide Filter Bar' : 'Show Filter Bar', isFilterVisible ? 'filter-off' : 'filter', isFilterVisible ? $5b564bb703f29152$export$bffa6555fdf75754() : $5b564bb703f29152$export$c8d88f519547e598()));
            }
            const existingColumnFilter = this.api.filterApi.columnFilterApi.getColumnFilterForColumn(column.columnId);
            if (existingColumnFilter) {
                columnFilterMenuItems.push(this.createMenuItemReduxAction('column-filter-clear', 'Clear Filter', 'close', $2c155f3e4804e29e$export$171768c99fee2ba3(existingColumnFilter.ColumnId)));
                columnFilterMenuItems.push(this.createMenuItemReduxAction(existingColumnFilter.IsSuspended ? 'column-filter-unsuspend' : 'column-filter-suspend', existingColumnFilter.IsSuspended ? 'Unsuspend Filter' : 'Suspend Filter', existingColumnFilter.IsSuspended ? 'resume' : 'pause', existingColumnFilter.IsSuspended ? $2c155f3e4804e29e$export$312f8e656419ed01(existingColumnFilter) : $2c155f3e4804e29e$export$6e8f0e06fbedf782(existingColumnFilter)));
            }
            return columnFilterMenuItems;
        }
    }
    createContextMenuItems(menuContext) {
        if (!menuContext.isRowGroupColumn && this.isModuleVisible()) {
            if (menuContext.adaptableColumn && menuContext.adaptableColumn.filterable && menuContext.isSingleSelectedColumn && menuContext.gridCell != null && this.api.optionsApi.getFilterOptions().useAdaptableFiltering) {
                const existingColumnFilter = this.api.filterApi.columnFilterApi.getColumnFilterForColumn(menuContext.adaptableColumn.columnId);
                if (!existingColumnFilter) {
                    if (!menuContext.isRowGroupColumn && !menuContext.isGroupedNode) {
                        let isMultiple = menuContext.selectedCellInfo.gridCells.length > 1;
                        let clickFunction = isMultiple ? ()=>{
                            this.api.filterApi.columnFilterApi.internalApi.createValuesColumnFilterForCells(menuContext.selectedCellInfo.gridCells);
                        } : ()=>{
                            this.api.filterApi.columnFilterApi.internalApi.createEqualityColumnFilterForCell(menuContext.selectedCellInfo.gridCells[0]);
                        };
                        return [
                            this.createMenuItemClickFunction('column-filter-on-cell-value', isMultiple ? 'Filter on Cell Values' : 'Filter on Cell Value', this.moduleInfo.Glyph, clickFunction)
                        ];
                    }
                } else return [
                    this.createMenuItemReduxAction('column-filter-clear', 'Clear Filter', 'close', $2c155f3e4804e29e$export$171768c99fee2ba3(existingColumnFilter.ColumnId)),
                    this.createMenuItemClickFunction(existingColumnFilter.IsSuspended ? 'column-filter-unsuspend' : 'column-filter-suspend', existingColumnFilter.IsSuspended ? 'Unsuspend Filter' : 'Suspend Filter', existingColumnFilter.IsSuspended ? 'resume' : 'pause', existingColumnFilter.IsSuspended ? ()=>{
                        this.api.filterApi.columnFilterApi.unSuspendColumnFilter(existingColumnFilter);
                    } : ()=>{
                        this.api.filterApi.columnFilterApi.suspendColumnFilter(existingColumnFilter);
                    })
                ];
            }
        }
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.filterApi.columnFilterApi.getColumnFilters(),
            AddAction: $2c155f3e4804e29e$export$89469bfff4112a24,
            EditAction: $2c155f3e4804e29e$export$bbe8b429f447e815
        };
    }
    toViewCompact(filter) {
        return {
            item: {
                values: [
                    this.api.filterApi.columnFilterApi.columnFilterToString(filter)
                ]
            },
            abObject: filter
        };
    }
    toView(filter) {
        return {
            items: [
                {
                    name: 'Column',
                    values: [
                        this.api.columnApi.getFriendlyNameForColumnId(filter.ColumnId)
                    ]
                },
                {
                    name: 'Filter',
                    values: [
                        (0, $6a7ec5df7bac55db$export$3bd855715549fe49)(filter, this.api)
                    ]
                }
            ],
            abObject: filter
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects().map((filter)=>this.toView(filter));
    }
    getViewProperties() {
        const api = this.api;
        return {
            getSuspendAction: (columnFilter)=>$2c155f3e4804e29e$export$6e8f0e06fbedf782(columnFilter),
            getUnSuspendAction: (columnFilter)=>$2c155f3e4804e29e$export$312f8e656419ed01(columnFilter),
            getCompactSuspendAction: (columnFilter)=>$2c155f3e4804e29e$export$6e8f0e06fbedf782(columnFilter),
            getCompactUnSuspendAction: (columnFilter)=>$2c155f3e4804e29e$export$312f8e656419ed01(columnFilter),
            getSuspendAllAction: ()=>$2c155f3e4804e29e$export$23028bf9d635e89c(),
            getUnSuspendAllAction: ()=>$2c155f3e4804e29e$export$3f36c0aabf72f1d2(),
            getDeleteAction: (columnFilter)=>$2c155f3e4804e29e$export$171768c99fee2ba3(columnFilter.ColumnId),
            getCompactDeleteAction: (columnFilter)=>$2c155f3e4804e29e$export$171768c99fee2ba3(columnFilter.ColumnId),
            getDeleteAllAction: $2c155f3e4804e29e$export$d5958280d3901be2,
            emptyView: `
        There are no Column Filters applied. \n
        Create Column Filters by using the Filter Components or by editing a Layout.
      `,
            getStatusBarPanelProps () {
                let text;
                const filters = api.filterApi.columnFilterApi.getColumnFilters();
                if (filters.length === 0) text = '0 Filters';
                else if (filters.length === 1) text = '1 Filter';
                else text = filters.length + ' Filters';
                const popover = filters.length ? (0, $5c827d82db4d0598$export$a2707726b9bafe30) : null;
                return {
                    content: text,
                    popover: popover,
                    popoverMinWidth: 320
                };
            }
        };
    }
}







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $f7fc77d2e5e70845$export$92afc871cd9d295b = 'NonBlanks';


const $4e04309159d6c8ef$export$869c0582a8c04efd = (data)=>{
    return (0, $65308a7002d19b3b$export$3f60d09dd2143243)(data.Scope, {
        scopeWholeRow: 'Matching rows will be formatted',
        scopeColumns: 'Cells in selected columns will be formatted',
        scopeDataTypes: 'Cells in columns with these Data Types will be formatted'
    });
};
const $4e04309159d6c8ef$export$40e2dd627643b7c9 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $65308a7002d19b3b$export$b5842aa553688927), {
        descriptions: {
            rowScope: 'Format all columns in the row',
            columnScope: 'Select columns to format'
        },
        scope: data.Scope,
        updateScope: (Scope)=>{
            const newData = {
                ...data,
                Scope: Scope
            };
            const wholeRow = api.columnScopeApi.scopeIsAll(Scope);
            if (newData.Rule?.Predicates?.length) {
                if (wholeRow) {
                    // if scope is whole row, a predicate cannot be present, so we set the rule
                    // to be a boolean expression
                    delete newData.Rule.Predicates;
                    newData.Rule.BooleanExpression = '';
                } else // if scope is not whole row, if you have a predicate, reset it
                newData.Rule.Predicates = [
                    {
                        PredicateId: (0, $f7fc77d2e5e70845$export$92afc871cd9d295b)
                    }
                ];
            }
            props.onChange(newData);
        }
    }));
};



var $acw62 = parcelRequire("acw62");






const $bc2cc00bb99305c8$export$2fe710a13d977335 = (data)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Data Rows ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.RowScope?.ExcludeDataRows ? 'no' : 'yes')), ' ', $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Group Rows ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.RowScope?.ExcludeGroupRows ? 'no' : 'yes')), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Summary Rows ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.RowScope?.ExcludeSummaryRows ? 'no' : 'yes')), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Total Rows ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.RowScope?.ExcludeTotalRows ? 'no' : 'yes')));
};
const $bc2cc00bb99305c8$export$9eb7ac841c335443 = (props)=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const onExcludeDataRowsChanged = (includeDataRows)=>{
        props.onChange({
            ...data,
            RowScope: {
                ...data.RowScope,
                ExcludeDataRows: !includeDataRows
            }
        });
    };
    const onExcludeGroupedRowsChanged = (includeGroupedRows)=>{
        props.onChange({
            ...data,
            RowScope: {
                ...data.RowScope,
                ExcludeGroupRows: !includeGroupedRows
            }
        });
    };
    const onExcludeSummaryRowsChanged = (includeSummaryRows)=>{
        props.onChange({
            ...data,
            RowScope: {
                ...data.RowScope,
                ExcludeSummaryRows: !includeSummaryRows
            }
        });
    };
    const onExcludeTotalRowsChanged = (includeTotalRows)=>{
        props.onChange({
            ...data,
            RowScope: {
                ...data.RowScope,
                ExcludeTotalRows: !includeTotalRows
            }
        });
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        style: {
            height: '100%'
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mb-3"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Row Types"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, data.Target === 'cell' && $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Data (leaf) Rows:"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:ml-2"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "include-data-rows-checkbox",
        checked: !data.RowScope?.ExcludeDataRows,
        onChange: onExcludeDataRowsChanged,
        className: "twa:mr-2"
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Group Rows:"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:ml-2"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "include-grouped-rows-checkbox",
        checked: !data.RowScope?.ExcludeGroupRows,
        onChange: onExcludeGroupedRowsChanged,
        className: "twa:mr-2"
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Summary Rows:"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:ml-2"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "include-summary-rows-checkbox",
        checked: !data.RowScope?.ExcludeSummaryRows,
        onChange: onExcludeSummaryRowsChanged,
        className: "twa:mr-2"
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Total Rows:"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:ml-2"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "include-total-rows-checkbox",
        checked: !data.RowScope?.ExcludeTotalRows,
        onChange: onExcludeTotalRowsChanged,
        className: "twa:mr-2"
    })))))))));
};



var $acw62 = parcelRequire("acw62");




var $5aWMQ = parcelRequire("5aWMQ");

const $3dd4446f8dd977f0$export$140a81f31c92fced = (data, api)=>{
    if (data.Style && (0, $5aWMQ.default).IsEmptyStyle(data.Style) && data.DisplayFormat === undefined && !api.columnScopeApi.isSingleBooleanColumnScope(data.Scope)) return 'No format applied';
    return true;
};
const $3dd4446f8dd977f0$var$toStyle = (data)=>{
    return {
        ...(0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(data.Style ?? {}),
        borderWidth: data.Style?.BorderColor ? 2 : 0,
        borderStyle: 'solid',
        // ToDO abcdefg
        textAlign: data.Style?.Alignment ? data.Style.Alignment.toLowerCase() : undefined
    };
};
const $3dd4446f8dd977f0$export$f6628dedfc94115c = (data)=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $3dd4446f8dd977f0$export$85e588a2a4dc5e3c(data, api);
};
const $3dd4446f8dd977f0$export$85e588a2a4dc5e3c = (data, api)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-FormatPreview twa:p-2",
        style: $3dd4446f8dd977f0$var$toStyle(data)
    }, "Preview result");
};
function $3dd4446f8dd977f0$export$32eda2d954a6fc06(props) {
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $e629d4699b6af5c8$export$a7668fc2e148d940), {
        headless: true,
        api: api,
        Style: data.Style ?? {},
        UpdateStyle: (Style)=>{
            props.onChange({
                ...data,
                Style: Style
            });
        }
    });
}



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");


class $fc1f09638343e37f$export$1ed2661f78171539 extends $acw62.Component {
    render() {
        const colItems = this.props.colItems.map((colItem, index)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: `ab-AdaptableObjectRow__cell twa:px-1`,
                style: {
                    flex: colItem.Size
                },
                "data-name": "list-group-cell",
                key: index,
                title: typeof colItem.Content === 'string' ? colItem.Content : undefined
            }, colItem.Content));
        const className = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-AdaptableObjectRow', 'twa:p-3', 'twa:m-0', this.props.isSuspended && 'ab-AdaptableObjectRow--is-suspended', this.props.className);
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: className,
            onClick: this.props.onClick,
            style: this.props.style
        }, colItems);
    }
}






var $9OAZF = parcelRequire("9OAZF");











const $46da88304e9d7214$var$DOLLAR_OPTIONS = {
    FractionDigits: 2,
    FractionSeparator: '.',
    IntegerDigits: undefined,
    IntegerSeparator: ',',
    Prefix: '$',
    Suffix: '',
    Multiplier: 1,
    Parentheses: false
};
const $46da88304e9d7214$var$STERLING_OPTIONS = {
    FractionDigits: 2,
    FractionSeparator: '.',
    IntegerDigits: undefined,
    IntegerSeparator: ',',
    Prefix: "\xa3",
    Suffix: '',
    Multiplier: 1,
    Parentheses: false
};
const $46da88304e9d7214$var$MILLION_OPTIONS = {
    FractionDigits: undefined,
    FractionSeparator: '.',
    IntegerDigits: undefined,
    IntegerSeparator: ',',
    Prefix: '',
    Suffix: 'M',
    Multiplier: 0.000001,
    Parentheses: false
};
const $46da88304e9d7214$var$THOUSAND_OPTIONS = {
    FractionDigits: undefined,
    FractionSeparator: '.',
    IntegerDigits: undefined,
    IntegerSeparator: ',',
    Prefix: '',
    Suffix: 'K',
    Multiplier: 0.001,
    Parentheses: false
};
const $46da88304e9d7214$var$PERCENT_OPTIONS = {
    FractionDigits: 2,
    FractionSeparator: '.',
    IntegerDigits: undefined,
    IntegerSeparator: ',',
    Prefix: '',
    Suffix: '%',
    Multiplier: 100,
    Parentheses: false
};
const $46da88304e9d7214$var$DateFormatPresets = [
    'MM/dd/yyyy',
    'dd-MM-yyyy',
    'MMMM do yyyy, h:mm:ss a',
    'EEEE',
    'MMM do yyyy',
    'yyyyMMdd',
    'HH:mm:ss'
];
const $46da88304e9d7214$export$d7165c60d065b91c = (data)=>{
    let content = 'N/A';
    if (!data.DisplayFormat) content = 'N/A';
    else {
        if (data.DisplayFormat.Formatter === 'NumberFormatter') content = (0, $1fe81e1078ace264$export$2e2bcd8739ae039).NumberFormatter((0, $58846ea7f4156db7$export$548d79e01aaf6256), data.DisplayFormat.Options);
        if (data.DisplayFormat.Formatter === 'DateFormatter') content = (0, $1fe81e1078ace264$export$2e2bcd8739ae039).DateFormatter(new Date(), data.DisplayFormat.Options);
        if (data.DisplayFormat.Formatter === 'StringFormatter') content = (0, $1fe81e1078ace264$export$2e2bcd8739ae039).StringFormatter((0, $58846ea7f4156db7$export$74c5c370dcf447e), data.DisplayFormat.Options);
    }
    return content;
};
const $46da88304e9d7214$var$renderCustomFormatter = (data, customFormatter, setFormatOption)=>$acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        key: customFormatter.id,
        label: customFormatter.label ?? customFormatter.id
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": customFormatter.id,
        checked: data.DisplayFormat.Options.CustomDisplayFormats?.some?.((item)=>item === customFormatter.id),
        onChange: (checked)=>{
            let newCustomFormats = data?.DisplayFormat?.Options?.CustomDisplayFormats ?? [];
            if (checked) newCustomFormats = [
                ...newCustomFormats,
                customFormatter.id
            ];
            else newCustomFormats = newCustomFormats.filter((item)=>item !== customFormatter.id);
            setFormatOption('CustomDisplayFormats', newCustomFormats);
        }
    }));
const $46da88304e9d7214$export$1efbab0ed1b35d09 = (data)=>{
    return $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, $46da88304e9d7214$export$d7165c60d065b91c(data));
};
const $46da88304e9d7214$export$ba1215dbaf858fe0 = (scope, api)=>{
    if (scope == undefined) return undefined;
    if ('All' in scope) return undefined;
    // Date-related data types that should all be treated as 'date'
    const dateTypes = api.columnApi.internalApi.getColumnDateTypes();
    // Check for ColumnIds in scope
    if ('ColumnIds' in scope) {
        const columns = scope.ColumnIds.map((c)=>api.columnApi.getColumnWithColumnId(c)).filter(Boolean);
        const columnDataTypes = (0, $aac165a6c1a53427$export$2e2bcd8739ae039)(columns.map((c)=>c.dataType));
        // If there's only one data type
        if (columnDataTypes.length === 1) {
            const dataType = columnDataTypes[0];
            if (dataType === 'number') return 'number';
            if (dateTypes.includes(dataType)) return 'date';
            if (dataType === 'text') return 'text';
        } else if (columnDataTypes.length > 0 && columnDataTypes.every((type)=>dateTypes.includes(type))) return 'date';
        return undefined;
    }
    // Check for DataTypes in scope
    if ('DataTypes' in scope && scope.DataTypes.length === 1) {
        const dataType = scope.DataTypes[0];
        if (dataType === 'number') return 'number';
        if (dateTypes.includes(dataType)) return 'date';
        if (dataType === 'text') return 'text';
    } else if ('DataTypes' in scope && scope.DataTypes.length > 0 && scope.DataTypes.every((type)=>dateTypes.includes(type))) return 'date';
    // Check for ColumnTypes in scope
    if ('ColumnTypes' in scope && scope.ColumnTypes.length) {
        // If a Pivot Total Column Type is specified, we can safely assume that the data type is number
        const pivotTotalTypes = [
            (0, $b0d14b794bdca4f2$export$afddfaff376a8546),
            (0, $b0d14b794bdca4f2$export$f744fcf34ea00f2c),
            (0, $b0d14b794bdca4f2$export$9a588f369e2c5bd7),
            (0, $b0d14b794bdca4f2$export$77dcda55adab6007)
        ];
        // If all column types are pivot total types, we can safely assume that the data type is number
        if (scope.ColumnTypes.length > 0 && scope.ColumnTypes.every((type)=>pivotTotalTypes.includes(type))) return 'number';
        // Check if all columns with this column type have the same data type
        const columns = scope.ColumnTypes.flatMap((columnType)=>{
            return api.columnApi.getColumnsByColumnType(columnType);
        });
        if (columns.length) {
            // Check if all columns have the same type
            const allSameType = columns.every((column)=>column.dataType === columns[0].dataType);
            // Handle specific data types
            if (allSameType) {
                const dataType = columns[0].dataType;
                if (dataType === 'number') return 'number';
                if (dateTypes.includes(dataType)) return 'date';
                if (dataType === 'text') return 'text';
            }
            // Check if all columns are date types (even if they're different date types)
            const allDateTypes = columns.every((column)=>dateTypes.includes(column.dataType));
            if (allDateTypes) return 'date';
        }
    }
    return undefined;
};
const $46da88304e9d7214$var$renderDateFormat = (data, _onChange, setFormatOption, scopedCustomFormatters)=>{
    if (data.DisplayFormat.Formatter !== 'DateFormatter') return null;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Format"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:text-2"
    }, "Either create your own date pattern, or select one of the preset date formats (check out", ' ', $acw62.createElement("a", {
        href: "https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table",
        target: "_blank"
    }, "available symbols"), ")."), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Pattern"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "pattern",
        value: data.DisplayFormat.Options.Pattern ?? '',
        onChange: (e)=>setFormatOption('Pattern', e.currentTarget.value),
        className: "twa:mr-2"
    }), $acw62.createElement("span", null, data.DisplayFormat.Options.Pattern && (0, $1fe81e1078ace264$export$2e2bcd8739ae039).DateFormatter(new Date(), data.DisplayFormat.Options, true)))))), scopedCustomFormatters.length > 0 && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mt-2",
        keyboardNavigation: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Custom Formats"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, scopedCustomFormatters.map((formatter)=>$46da88304e9d7214$var$renderCustomFormatter(data, formatter, setFormatOption))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mt-2",
        keyboardNavigation: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Presets"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $fc1f09638343e37f$export$1ed2661f78171539), {
        style: {
            fontWeight: 'bold'
        },
        colItems: [
            {
                Content: 'Pattern',
                Size: 1
            },
            {
                Content: 'Formatted Date',
                Size: 1
            },
            {
                Content: '',
                Size: 1
            }
        ]
    }), $46da88304e9d7214$var$DateFormatPresets.map((Pattern, index)=>$acw62.createElement((0, $fc1f09638343e37f$export$1ed2661f78171539), {
            key: index,
            colItems: [
                {
                    Content: Pattern,
                    Size: 1
                },
                {
                    Content: (0, $1fe81e1078ace264$export$2e2bcd8739ae039).DateFormatter(new Date(), {
                        Pattern: Pattern
                    }),
                    Size: 1
                },
                {
                    Content: $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
                        "data-name": "apply-format-pattern",
                        "data-value": Pattern,
                        onClick: ()=>setFormatOption('Pattern', Pattern)
                    }, "Apply"),
                    Size: 1
                }
            ]
        })))));
};
const $46da88304e9d7214$var$renderNumberFormat = (data, onChange, setFormatOption, scopedCustomFormatters, api)=>{
    if (data.DisplayFormat.Formatter !== 'NumberFormatter') return null;
    const setPercentPreset = ()=>{
        onChange({
            DisplayFormat: {
                Formatter: 'NumberFormatter',
                Options: $46da88304e9d7214$var$PERCENT_OPTIONS
            }
        });
    };
    const setDivideThousandPreset = ()=>{
        onChange({
            DisplayFormat: {
                Formatter: 'NumberFormatter',
                Options: $46da88304e9d7214$var$THOUSAND_OPTIONS
            }
        });
    };
    const setDivideMillionPreset = ()=>{
        onChange({
            DisplayFormat: {
                Formatter: 'NumberFormatter',
                Options: $46da88304e9d7214$var$MILLION_OPTIONS
            }
        });
    };
    const setDollarPreset = ()=>{
        onChange({
            DisplayFormat: {
                Formatter: 'NumberFormatter',
                Options: $46da88304e9d7214$var$DOLLAR_OPTIONS
            }
        });
    };
    const setSterlingPreset = ()=>{
        onChange({
            DisplayFormat: {
                Formatter: 'NumberFormatter',
                Options: $46da88304e9d7214$var$STERLING_OPTIONS
            }
        });
    };
    const IS_PERCENT = data.DisplayFormat.Options.Suffix === '%' && data.DisplayFormat.Options.Multiplier === $46da88304e9d7214$var$PERCENT_OPTIONS.Multiplier; //isEqual(data.DisplayFormat.Options, PERCENT_OPTIONS);
    const IS_THOUSAND = data.DisplayFormat.Options.Suffix === 'K' && data.DisplayFormat.Options.Multiplier === $46da88304e9d7214$var$THOUSAND_OPTIONS.Multiplier; // isEqual(data.DisplayFormat.Options, THOUSAND_OPTIONS);
    const IS_MILLION = data.DisplayFormat.Options.Suffix === 'M' && data.DisplayFormat.Options.Multiplier === $46da88304e9d7214$var$MILLION_OPTIONS.Multiplier; //isEqual(data.DisplayFormat.Options, MILLION_OPTIONS);
    const IS_DOLLAR = data.DisplayFormat.Options.Prefix === '$'; //isEqual(data.DisplayFormat.Options, DOLLAR_OPTIONS);
    const IS_STERLING = data.DisplayFormat.Options.Prefix === "\xa3"; //isEqual(data.DisplayFormat, STERLING_OPTIONS);
    const showDocumentationLinks = api.internalApi.isDocumentationLinksDisplayed();
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": 'format-column-display-format',
        className: "twa:p-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Format"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:mr-3"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Fraction Separator"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "fraction-separator",
        value: data.DisplayFormat.Options.FractionSeparator ?? '',
        onChange: (e)=>setFormatOption('FractionSeparator', e.currentTarget.value)
    }), ' '), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Integer Separator"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "integer-separator",
        value: data.DisplayFormat.Options.IntegerSeparator ?? '',
        onChange: (e)=>setFormatOption('IntegerSeparator', e.currentTarget.value)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Prefix"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "prefix",
        value: data.DisplayFormat.Options.Prefix ?? '',
        onChange: (e)=>setFormatOption('Prefix', e.currentTarget.value)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Suffix"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "suffix",
        value: data.DisplayFormat.Options.Suffix ?? '',
        onChange: (e)=>setFormatOption('Suffix', e.currentTarget.value)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Truncate"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "truncate-checkbox",
        checked: data.DisplayFormat.Options.Truncate,
        onChange: (checked)=>setFormatOption('Truncate', checked)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Ceiling"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "ceiling-checkbox",
        checked: data.DisplayFormat.Options.Ceiling,
        onChange: (checked)=>setFormatOption('Ceiling', checked)
    })), ' ', $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Absolute"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "abs-checkbox",
        checked: data.DisplayFormat.Options.Abs,
        onChange: (checked)=>setFormatOption('Abs', checked)
    }))), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Fraction Digits"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "fraction-digits",
        type: "number",
        min: "0",
        // max="20"
        value: typeof data.DisplayFormat.Options.FractionDigits === 'number' ? data.DisplayFormat.Options.FractionDigits : '',
        onChange: (e)=>setFormatOption('FractionDigits', (0, $9OAZF.default).IsNumeric(e.currentTarget.value) ? (0, $43438b6501a58e4a$export$2e2bcd8739ae039)(Number(e.currentTarget.value), 0, 20) : undefined)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Integer Digits"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "integer-digits",
        type: "number",
        min: "0",
        value: data.DisplayFormat.Options.IntegerDigits,
        onChange: (e)=>setFormatOption('IntegerDigits', (0, $9OAZF.default).IsNumeric(e.currentTarget.value) ? (0, $43438b6501a58e4a$export$2e2bcd8739ae039)(Number(e.currentTarget.value), 0, 20) : undefined)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Multiplier"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "multiplier",
        type: "number",
        value: data.DisplayFormat.Options.Multiplier,
        onChange: (e)=>setFormatOption('Multiplier', Number(e.currentTarget.value))
    })), ' ', $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Parentheses"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "parentheses-checkbox",
        checked: data.DisplayFormat.Options.Parentheses,
        onChange: (checked)=>setFormatOption('Parentheses', checked)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Floor"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "floor-checkbox",
        checked: data.DisplayFormat.Options.Floor,
        onChange: (checked)=>setFormatOption('Floor', checked)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Round"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "round-checkbox",
        checked: data.DisplayFormat.Options.Round,
        onChange: (checked)=>setFormatOption('Round', checked)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Empty"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "empty-checkbox",
        checked: data.DisplayFormat.Options.Empty,
        onChange: (checked)=>setFormatOption('Empty', checked)
    })))))), scopedCustomFormatters.length > 0 && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mt-2",
        keyboardNavigation: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Custom Formats"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, scopedCustomFormatters.map((formatter)=>$46da88304e9d7214$var$renderCustomFormatter(data, formatter, setFormatOption)))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mt-2",
        autoFocus: false,
        keyboardNavigation: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Presets"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:text-2"
    }, "Select a preset for common use cases"), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:m-2"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Show As:"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "preset-percentage",
        className: "twa:ml-2",
        checked: IS_PERCENT,
        onChange: ()=>setPercentPreset()
    }, "Percentage"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "preset-thousand",
        className: "twa:ml-3",
        checked: IS_THOUSAND,
        onChange: ()=>setDivideThousandPreset()
    }, "K (Thousand)"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "preset-million",
        className: "twa:ml-3",
        checked: IS_MILLION,
        onChange: ()=>setDivideMillionPreset()
    }, "M (Million)"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "preset-dollar",
        className: "twa:ml-3",
        checked: IS_DOLLAR,
        onChange: ()=>setDollarPreset()
    }, "Dollar"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "preset-sterling",
        className: "twa:ml-3",
        checked: IS_STERLING,
        onChange: ()=>setSterlingPreset()
    }, "Sterling")))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mt-2",
        autoFocus: false,
        keyboardNavigation: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Dynamic Content"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:text-2"
    }, "Provide dynamic content through the use of Placeholders"), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:m-2"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $d541796d86c181e1$export$2e2bcd8739ae039), {
        className: "twa:min-w-[300px] twa:mt-2",
        rows: 3,
        placeholder: "",
        type: 'text',
        autoFocus: false,
        value: data.DisplayFormat.Options.Content?.toString() ?? '',
        onChange: (e)=>setFormatOption('Content', e.currentTarget.value)
    }), showDocumentationLinks && $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        "data-name": "query-documentation",
        className: "twa:mt-3 twa:mb-2 twa:p-0 twa:text-3"
    }, $acw62.createElement((0, $00c4532606fa3d4c$export$5a2ee34a0d054ab8), {
        className: "twa:mr-2",
        onClick: ()=>window.open((0, $53c62e7ff907ad8d$export$97c302ec6cca56ba), '_blank')
    }), "Learn more about using placeholders")), ' '))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mt-2",
        autoFocus: false,
        keyboardNavigation: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Examples"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $fc1f09638343e37f$export$1ed2661f78171539), {
        className: "twa:font-bold",
        colItems: [
            {
                Content: 'Raw Number',
                Size: 1
            },
            {
                Content: 'Formatted Number',
                Size: 1
            }
        ]
    }), $acw62.createElement((0, $fc1f09638343e37f$export$1ed2661f78171539), {
        colItems: [
            {
                Content: (0, $58846ea7f4156db7$export$548d79e01aaf6256),
                Size: 1
            },
            {
                Content: (0, $1fe81e1078ace264$export$2e2bcd8739ae039).NumberFormatter((0, $58846ea7f4156db7$export$548d79e01aaf6256), data.DisplayFormat.Options),
                Size: 1
            }
        ]
    }), $acw62.createElement((0, $fc1f09638343e37f$export$1ed2661f78171539), {
        colItems: [
            {
                Content: '-' + (0, $58846ea7f4156db7$export$548d79e01aaf6256),
                Size: 1
            },
            {
                Content: (0, $1fe81e1078ace264$export$2e2bcd8739ae039).NumberFormatter(-(0, $58846ea7f4156db7$export$548d79e01aaf6256), data.DisplayFormat.Options),
                Size: 1
            }
        ]
    }), $acw62.createElement((0, $fc1f09638343e37f$export$1ed2661f78171539), {
        colItems: [
            {
                Content: '0.123',
                Size: 1
            },
            {
                Content: (0, $1fe81e1078ace264$export$2e2bcd8739ae039).NumberFormatter(0.123, data.DisplayFormat.Options),
                Size: 1
            }
        ]
    }))));
};
const $46da88304e9d7214$var$renderStringFormat = (data, _onChange, setFormatOption, scopedCustomFormatters, api)=>{
    if (data.DisplayFormat.Formatter !== 'StringFormatter') return null;
    const showDocumentationLinks = api.internalApi.isDocumentationLinksDisplayed();
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        "data-name": 'format-column-display-format',
        className: "twa:gap-3 twa:p-3"
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), null, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, null, "Format"), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, {
        className: "twa:grid twa:p-2 twa:grid-cols-[1fr_1fr] twa:gap-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        className: "twa:gap-2 twa:col-span-2 twa:items-center"
    }, $acw62.createElement("label", null, "Case:"), $acw62.createElement((0, $4df338db1380ba8a$export$af3ec21f6cfb5e30), null, $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        pressed: data.DisplayFormat.Options.Case === 'Upper',
        onPressedChange: (pressed)=>setFormatOption('Case', pressed ? 'Upper' : undefined),
        icon: "case-upper"
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        pressed: data.DisplayFormat.Options.Case === 'Lower',
        onPressedChange: (pressed)=>setFormatOption('Case', pressed ? 'Lower' : undefined),
        icon: "case-lower"
    }), $acw62.createElement((0, $6d11e0f94e4885f4$export$bea8ebba691c5813), {
        pressed: data.DisplayFormat.Options.Case === 'Sentence',
        onPressedChange: (pressed)=>setFormatOption('Case', pressed ? 'Sentence' : undefined),
        icon: "case-sentence"
    })), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "trim-checkbox",
        className: "twa:ml-5",
        checked: data.DisplayFormat.Options.Trim,
        onChange: (checked)=>setFormatOption('Trim', checked)
    }, "Trim")), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:gap-2"
    }, $acw62.createElement("label", null, "Prefix"), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "prefix",
        value: data.DisplayFormat.Options.Prefix ?? '',
        onChange: (e)=>setFormatOption('Prefix', e.currentTarget.value)
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:gap-2"
    }, $acw62.createElement("label", null, "Suffix"), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "suffix",
        value: data.DisplayFormat.Options.Suffix ?? '',
        onChange: (e)=>setFormatOption('Suffix', e.currentTarget.value)
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:col-span-2 twa:gap-2"
    }, $acw62.createElement("label", null, "Content"), $acw62.createElement((0, $d541796d86c181e1$export$2e2bcd8739ae039), {
        className: "twa:min-w-[300px]",
        rows: 3,
        placeholder: "",
        type: 'text',
        autoFocus: false,
        value: data.DisplayFormat.Options.Content ?? '',
        onChange: (e)=>setFormatOption('Content', e.currentTarget.value)
    }), showDocumentationLinks && $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        "data-name": "query-documentation",
        className: "twa:mt-3 twa:mb-2 twa:p-0 twa:text-3"
    }, $acw62.createElement((0, $00c4532606fa3d4c$export$5a2ee34a0d054ab8), {
        className: "twa:mr-2",
        onClick: ()=>window.open((0, $53c62e7ff907ad8d$export$97c302ec6cca56ba), '_blank')
    }), "See how to create dynamic Display Format using placeholders")), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        className: "twa:col-span-2",
        "data-name": "empty-checkbox",
        checked: data.DisplayFormat.Options.Empty,
        onChange: (checked)=>setFormatOption('Empty', checked)
    }, "Empty"))), scopedCustomFormatters.length > 0 && $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), {
        shadow: false
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, null, "Custom Formats"), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:mr-3"
    }, scopedCustomFormatters.map((formatter)=>$46da88304e9d7214$var$renderCustomFormatter(data, formatter, setFormatOption)))))), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), null, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, null, "Example"), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, null, $acw62.createElement((0, $fc1f09638343e37f$export$1ed2661f78171539), {
        className: "twa:font-bold",
        colItems: [
            {
                Content: 'Raw String',
                Size: 1
            },
            {
                Content: 'Formatted String',
                Size: 1
            }
        ]
    }), $acw62.createElement((0, $fc1f09638343e37f$export$1ed2661f78171539), {
        colItems: [
            {
                Content: '"' + (0, $58846ea7f4156db7$export$74c5c370dcf447e) + '"',
                Size: 1
            },
            {
                Content: '"' + (0, $1fe81e1078ace264$export$2e2bcd8739ae039).StringFormatter((0, $58846ea7f4156db7$export$74c5c370dcf447e), data.DisplayFormat.Options) + '"',
                Size: 1
            }
        ]
    }))));
};
const $46da88304e9d7214$export$6ff5ef3fe0deb0a9 = (props)=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const formatColumnApi = adaptable.api.formatColumnApi;
    const customDisplayFormatters = adaptable.api.optionsApi.getFormatColumnOptions().customDisplayFormatters ?? [];
    const update = (updated)=>{
        props.onChange({
            ...data,
            ...updated
        });
    };
    const setFormatOption = (key, value)=>{
        const DisplayFormat = {
            ...data.DisplayFormat
        };
        // @ts-ignore
        DisplayFormat.Options = {
            ...DisplayFormat.Options,
            [key]: value
        };
        update({
            DisplayFormat: DisplayFormat
        });
    };
    const Type = data.DisplayFormat && data.DisplayFormat.Formatter;
    const customScopedFormatters = customDisplayFormatters.filter((displayFormatter)=>adaptable.api.columnScopeApi.isScopeInScope(data.Scope, displayFormatter.scope));
    if (Type === 'NumberFormatter') return $46da88304e9d7214$var$renderNumberFormat(data, update, setFormatOption, customScopedFormatters, adaptable.api);
    if (Type === 'DateFormatter') return $46da88304e9d7214$var$renderDateFormat(data, update, setFormatOption, customScopedFormatters);
    if (Type === 'StringFormatter') return $46da88304e9d7214$var$renderStringFormat(data, update, setFormatOption, customScopedFormatters, adaptable.api);
    return $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:m-2"
    }, "Setting a Display Format is only possible if ", $acw62.createElement("b", null, "all"), " the columns in Scope are Numeric, String or Date");
};




var $acw62 = parcelRequire("acw62");








const $35fbf7b5aeb08bd3$export$b13b4041c6db9a7b = (data)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Name ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.Name)), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Target", ' ', $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, !data.Target || data.Target === 'cell' ? 'Column Cells' : 'Column Header')), ' ', $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Apply on Column Groups:", ' ', $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, !data.ColumnGroupScope || data.ColumnGroupScope === 'Both' ? 'Always' : data.ColumnGroupScope)));
};
const $35fbf7b5aeb08bd3$export$cb65aed7b9499a56 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const currentTarget = data.Target ? data.Target : 'cell';
    const handleTargetChange = (target)=>{
        // Update the formatColumn object
        props.onChange({
            ...data,
            Target: target
        });
    };
    const onNameChange = (event)=>{
        props.onChange({
            ...data,
            Name: event.target.value
        });
    };
    const behaviourSpellingVariant = api.internalApi.getCorrectEnglishVariant('Behaviour');
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        style: {
            height: '100%'
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mb-3"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:max-w-[300px] twa:w-full"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        className: "twa:w-full",
        "data-name": "format-column-name",
        onChange: onNameChange,
        value: data?.Name ?? ''
    })))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mb-3"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Target"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        "data-name": "target-column-cell",
        text: 'Column Cells',
        description: "Column Cells are styled and formatted",
        checked: currentTarget === 'cell',
        onClick: ()=>handleTargetChange('cell')
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        "data-name": "target-column-header",
        text: 'Column Header',
        description: "The Column Header is styled (Note: Conditions are not available for Column Headers)",
        checked: currentTarget === 'columnHeader',
        onClick: ()=>handleTargetChange('columnHeader')
    })))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column Group ", behaviourSpellingVariant, " "), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Apply on Column Group:"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$a98f0dcb43a68a25), {
        value: data.ColumnGroupScope || 'Both',
        name: "columnGroupScope",
        orientation: "horizontal",
        onRadioChange: (columnGroupScope)=>{
            props.onChange({
                ...data,
                ColumnGroupScope: columnGroupScope
            });
        }
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:ml-1",
        value: "Both"
    }, "Always"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:ml-4",
        value: "Expanded"
    }, "When Expanded"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        className: "twa:ml-4",
        value: "Collapsed"
    }, "When Collapsed"))))))));
};









var $acw62 = parcelRequire("acw62");



function $d8f9194e190d5376$export$b27345eb754b21b4(props) {
    const { data: data, api: api, moduleInfo: moduleInfo } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    if (data.Target && data.Target === 'columnHeader') return $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mt-3"
    }, "Conditions cannot be applied if the Target of the Format Column is Column Header");
    return $acw62.createElement((0, $07845dcbd4d38c15$export$958c7d77bf3113b), {
        module: moduleInfo.ModuleName,
        defaultPredicateId: props.defaultPredicateId,
        // TODO see what is this
        predicateDefs: api.formatColumnApi.internalApi.getFormatColumnDefsForScope(data.Scope),
        getPredicateDefsForColId: (colId)=>api.formatColumnApi.internalApi.getFormatColumnDefsForScope({
                ColumnIds: [
                    colId
                ]
            }),
        showNoRule: true,
        showBoolean: true,
        showAggregation: false,
        showObservable: false,
        showQueryBuilder: true,
        showPredicate: !api.columnScopeApi.scopeIsAll(data.Scope),
        data: data,
        onChange: (formatColumn)=>props.onChange(formatColumn),
        descriptions: {
            selectPredicate: 'Create a Format Column Rule - to be applied when data changes',
            useBooleanQuery: $acw62.createElement($acw62.Fragment, null, "Use an BooleanQuery if ", $acw62.createElement("i", null, "Scope"), " is 'All Columns' - so any data change may be evaluated in a complex BooleanExpression"),
            useObservableQuery: $acw62.createElement($acw62.Fragment, null, "Use an ObservableQuery if ", $acw62.createElement("i", null, "Scope"), " is 'All Columns' - so any data change may be evaluated in a complex ObservableExpression"),
            useAggregationQuery: $acw62.createElement($acw62.Fragment, null, "Use an AggregatedBooleanQuery if ", $acw62.createElement("i", null, "Scope"), " is 'All Columns' - so any data change may be evaluated in a complex AggregatedBooleanExpression")
        }
    });
}





const $ce955b7c3d7df7b1$var$adjustDisplayFormat = (fc, api)=>{
    const formatColumn = {
        ...fc
    };
    let formatDataType = (0, $46da88304e9d7214$export$ba1215dbaf858fe0)(formatColumn.Scope, api);
    // Add RowScope and Target defaults for Format Columns that have been created in Initial State
    if (!formatColumn.RowScope) formatColumn.RowScope = {
        ExcludeDataRows: false,
        ExcludeGroupRows: false,
        ExcludeSummaryRows: false,
        ExcludeTotalRows: false
    };
    if (!formatColumn.Target) formatColumn.Target = 'cell';
    if (formatColumn.Target === 'columnHeader') // Column Headers are always text
    formatDataType = 'text';
    if (!formatDataType && formatColumn.DisplayFormat) formatColumn.DisplayFormat = undefined;
    if ((!formatColumn.DisplayFormat || formatColumn.DisplayFormat.Formatter !== 'NumberFormatter') && formatDataType === 'number') formatColumn.DisplayFormat = {
        Formatter: 'NumberFormatter',
        Options: {}
    };
    if ((!formatColumn.DisplayFormat || formatColumn.DisplayFormat.Formatter !== 'DateFormatter') && formatDataType === 'date') formatColumn.DisplayFormat = {
        Formatter: 'DateFormatter',
        Options: {}
    };
    if ((!formatColumn.DisplayFormat || formatColumn.DisplayFormat.Formatter !== 'StringFormatter') && formatDataType === 'text') formatColumn.DisplayFormat = {
        Formatter: 'StringFormatter',
        Options: {}
    };
    return formatColumn;
};
const $ce955b7c3d7df7b1$var$adjustFormatColumn = (formatColumn, api)=>{
    formatColumn = $ce955b7c3d7df7b1$var$adjustDisplayFormat(formatColumn, api);
    return formatColumn;
};
function $ce955b7c3d7df7b1$export$946b45a44797d84f(props) {
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const allFormatColumns = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.FormatColumn?.FormatColumns ?? []);
    const data = props.data ?? props.popupParams?.value;
    const [formatColumn, doSetFormatColumn] = (0, $acw62.useState)(()=>{
        let formatColumn = data ? (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(data) : (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyFormatColumn();
        formatColumn.Scope = formatColumn.Scope ?? {
            ColumnIds: []
        };
        if (props.popupParams?.action === 'New' && props.popupParams?.column) formatColumn.Scope = {
            ColumnIds: [
                props.popupParams?.column.columnId
            ]
        };
        formatColumn = $ce955b7c3d7df7b1$var$adjustFormatColumn(formatColumn, api);
        return formatColumn;
    });
    const setFormatColumn = $acw62.useCallback((formatColumn)=>{
        doSetFormatColumn($ce955b7c3d7df7b1$var$adjustFormatColumn(formatColumn, api));
    }, []);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleFinish = ()=>{
        if (formatColumn?.DisplayFormat?.Options && (0, $28578c992716f58c$export$23cfe696632d10f4)(formatColumn?.DisplayFormat?.Options)) delete formatColumn.DisplayFormat;
        if (formatColumn.Style && (0, $28578c992716f58c$export$23cfe696632d10f4)(formatColumn.Style)) delete formatColumn.Style;
        if (data) dispatch($4a80335d87022149$export$fab121d063a53ee9(formatColumn));
        else dispatch($4a80335d87022149$export$f6dd745b1428a28(formatColumn));
        props.onFinishWizard(formatColumn);
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        modal: props.modal,
        data: formatColumn,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Settings',
                details: 'Enter Name and other Properties',
                isValid: (formatColumnData)=>{
                    if (!formatColumnData.Name) return 'Format Column Name cannot be blank';
                    if (allFormatColumns.some((fc)=>fc.Name === formatColumnData.Name && fc.Uuid !== formatColumnData.Uuid)) return 'A Format Column already exists with that name';
                    return true;
                },
                renderSummary: (0, $35fbf7b5aeb08bd3$export$b13b4041c6db9a7b),
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $35fbf7b5aeb08bd3$export$cb65aed7b9499a56), {
                        onChange: setFormatColumn
                    }));
                }
            },
            {
                title: 'Columns',
                details: 'Select which Columns will be formatted',
                isValid: (0, $65308a7002d19b3b$export$37abad8a5da7760),
                renderSummary: (0, $4e04309159d6c8ef$export$869c0582a8c04efd),
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                        flexDirection: "column",
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $4e04309159d6c8ef$export$40e2dd627643b7c9), {
                        onChange: setFormatColumn
                    }));
                }
            },
            {
                title: 'Rows',
                details: 'Select which Rows will be formatted',
                renderSummary: (0, $bc2cc00bb99305c8$export$2fe710a13d977335),
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                        flexDirection: "column",
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $bc2cc00bb99305c8$export$9eb7ac841c335443), {
                        onChange: setFormatColumn
                    }));
                }
            },
            {
                isValid: (abObject, api, context)=>{
                    if (!abObject.Rule) return true;
                    return (0, $77459fc7566b1dde$export$509100fde248eb2b)(abObject, api, context);
                },
                title: 'Condition',
                details: 'Build a Rule when the Format Column should be applied',
                render: ()=>{
                    return $acw62.createElement((0, $d8f9194e190d5376$export$b27345eb754b21b4), {
                        onChange: setFormatColumn,
                        defaultPredicateId: (0, $f7fc77d2e5e70845$export$92afc871cd9d295b)
                    });
                }
            },
            {
                title: 'Style',
                details: 'Create a Style',
                isValid: (0, $3dd4446f8dd977f0$export$140a81f31c92fced),
                renderSummary: (0, $3dd4446f8dd977f0$export$f6628dedfc94115c),
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $3dd4446f8dd977f0$export$32eda2d954a6fc06), {
                        onChange: setFormatColumn
                    }));
                }
            },
            {
                title: 'Display Format',
                details: 'Provide a Display Format',
                renderSummary: (data)=>(0, $46da88304e9d7214$export$1efbab0ed1b35d09)(data),
                render: ()=>{
                    return $acw62.createElement((0, $46da88304e9d7214$export$6ff5ef3fe0deb0a9), {
                        onChange: setFormatColumn
                    });
                }
            },
            {
                details: 'Select Format Column Tags',
                title: 'Tags',
                isVisible: (_, api)=>api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setFormatColumn
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                details: 'Review the Format Column',
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null));
                },
                title: 'Summary'
            }
        ]
    });
}



const $19c55d42dfa6f667$export$f428260c7cb1f453 = (formatColumn)=>{
    let values = [];
    if (!formatColumn.Target || formatColumn.Target === 'cell') values.push('Target: Column Cells');
    else values.push('Target: Column Header');
    if (formatColumn.ColumnGroupScope) values.push(`Column Groups: ${formatColumn.ColumnGroupScope === 'Both' ? 'Always' : formatColumn.ColumnGroupScope}`);
    values = values.filter(Boolean);
    return {
        name: 'Settings',
        values: values.length > 0 ? values : [
            '-'
        ]
    };
};



var $acw62 = parcelRequire("acw62");




const $15d0ce2599c6aaf7$export$88807fde5b95b881 = (props)=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const formatColumn = adaptable.api.formatColumnApi.getFormatColumns();
    const handleMoveUp = $acw62.useCallback(()=>{
        dispatch($4a80335d87022149$export$87b5a2238e687c4b(props.data));
    }, []);
    const handleMoveDown = $acw62.useCallback(()=>{
        dispatch($4a80335d87022149$export$6b99718b79b178be(props.data));
    }, []);
    if (formatColumn?.length <= 1) return $acw62.createElement($acw62.Fragment, null);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-id": "move-up",
        title: "move up",
        onClick: handleMoveUp,
        variant: "text",
        icon: "arrow-up"
    }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "move-down",
        title: "move down",
        onClick: handleMoveDown,
        variant: "text",
        icon: "arrow-down"
    }));
};





const $7697440afa7910e6$export$5593b575eaca3eda = (formatColumn)=>{
    let values = [];
    if (formatColumn.RowScope) {
        if (!formatColumn.RowScope.ExcludeDataRows) values.push('Data');
        if (!formatColumn.RowScope.ExcludeGroupRows) values.push('Group');
        if (!formatColumn.RowScope.ExcludeSummaryRows) values.push('Summary');
        if (!formatColumn.RowScope.ExcludeTotalRows) values.push('Total');
    }
    values = values.filter(Boolean);
    return {
        name: 'Rows',
        values: values.length > 0 ? values : [
            '-'
        ]
    };
};



class $52a77959e4f37a8d$export$24547111cdcfae13 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$7b96a9104aea727f, $42e863194fcb493f$export$9b82031e9014074c, 'color-palette', 'FormatColumnPopup', 'Create a column style, display format or cell alignment', api);
    }
    getModuleAdaptableObjects(config) {
        return this.api.formatColumnApi.getFormatColumns(config);
    }
    getExplicitlyReferencedColumnIds(formatColumn) {
        const queryExpression = formatColumn.Rule && this.api.expressionApi.getAdaptableQueryExpression(formatColumn.Rule);
        if (queryExpression) return this.api.expressionApi.getColumnsFromExpression(queryExpression);
        else if (this.api.columnScopeApi.scopeHasColumns(formatColumn.Scope)) return this.api.columnScopeApi.getColumnsInScope(formatColumn.Scope).map((adaptableColumn)=>adaptableColumn.columnId);
        return [];
    }
    getReferencedNamedQueryNames(formatColumn) {
        const queryExpression = formatColumn.Rule && this.api.expressionApi.getAdaptableQueryExpression(formatColumn.Rule);
        if (!queryExpression) return [];
        return this.api.namedQueryApi.internalApi.getReferencedNamedQueryNames(queryExpression);
    }
    createColumnMenuItems(column) {
        if (!column || !this.isModuleEditable() || column.isSparkline) return;
        let returnColumnMenuItems = [];
        let createPopupParam = {
            column: column,
            action: 'New',
            source: 'ColumnMenu'
        };
        returnColumnMenuItems.push(this.createMenuItemShowPopup('format-column-add', 'Create Format Column', this.moduleInfo.Popup, this.moduleInfo.Glyph, createPopupParam));
        const formatColumnsForColumn = this.api.formatColumnApi.getFormatColumnsForColumnId(column.columnId);
        if (formatColumnsForColumn.length === 1) {
            let editPopupParam = {
                column: column,
                action: 'Edit',
                value: formatColumnsForColumn[0],
                source: 'ColumnMenu'
            };
            const editFormatColumnMenuItem = this.createMenuItemShowPopup('format-column-edit', 'Edit Format Column', this.moduleInfo.Popup, 'edit', editPopupParam);
            returnColumnMenuItems.push(editFormatColumnMenuItem);
        } else if (formatColumnsForColumn.length > 1) {
            // if more than one then display a Create and a Show
            // we should probably do the Show better - perhaps use Column Info in some way?
            // or to filter the format columns ?
            const moduleInfo = this.api.internalApi.getModuleService().getModuleInfoByModule('FormatColumn');
            const editFormatColumnMenuItem = this.createMenuItemReduxAction('format-column-edit', 'Show Current', this.moduleInfo.Glyph, $dc56b6267ce4d0bb$export$e2d5bba0b444685d('FormatColumn', moduleInfo.Popup));
            returnColumnMenuItems.push(editFormatColumnMenuItem);
        }
        return returnColumnMenuItems;
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.formatColumnApi.getFormatColumns(),
            AddAction: $4a80335d87022149$export$f6dd745b1428a28,
            EditAction: $4a80335d87022149$export$fab121d063a53ee9
        };
    }
    toView(formatColumn) {
        return {
            abObject: formatColumn,
            items: [
                {
                    name: 'Name',
                    values: [
                        formatColumn.Name
                    ]
                },
                (0, $01403ab2be951cf5$export$4abcb9ed8272134c)(formatColumn.Scope, this.api),
                (0, $7697440afa7910e6$export$5593b575eaca3eda)(formatColumn),
                formatColumn.Rule && (0, $60b27da1c4a88498$export$43359c935e54e9f1)(formatColumn.Rule, this.api),
                {
                    name: 'Style',
                    view: ()=>(0, $3dd4446f8dd977f0$export$85e588a2a4dc5e3c)(formatColumn, this.api)
                },
                {
                    name: 'Display Format',
                    values: [
                        (0, $46da88304e9d7214$export$d7165c60d065b91c)(formatColumn)
                    ]
                },
                (0, $19c55d42dfa6f667$export$f428260c7cb1f453)(formatColumn),
                (0, $52125728d99aa873$export$287b3702a135396b)(formatColumn, this.api)
            ].filter(Boolean)
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects({
            includeLayoutNotExtendedObjects: this.showLayoutNonExtendedObjects()
        }).map((formatColumn)=>this.toView(formatColumn));
    }
    getViewProperties() {
        return {
            actions: [
                (0, $15d0ce2599c6aaf7$export$88807fde5b95b881)
            ],
            getEditAction: $4a80335d87022149$export$fab121d063a53ee9,
            getDeleteAction: $4a80335d87022149$export$bf94c20884c4c766,
            getSuspendAction: $4a80335d87022149$export$52a202b8aebe3f3b,
            getUnSuspendAction: $4a80335d87022149$export$6597bf75fa891de6,
            getSuspendAllAction: $4a80335d87022149$export$3153664dd4714fde,
            getUnSuspendAllAction: $4a80335d87022149$export$3de802c1f9ca8de0,
            getEditWizard () {
                return 0, $ce955b7c3d7df7b1$export$946b45a44797d84f;
            }
        };
    }
    containsLayoutExtensions() {
        return true;
    }
}






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");













const $d19cd7ab3c7bca99$var$options = [
    {
        value: 'number',
        label: 'Number'
    },
    {
        value: 'text',
        label: 'Text'
    },
    {
        value: 'date',
        label: 'Date'
    },
    {
        value: 'boolean',
        label: 'Boolean'
    }
];
const $d19cd7ab3c7bca99$export$e612deaba7f0f398 = (data)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, "Column Identifier: ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.ColumnId)), data.FriendlyName ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Column Name: ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.FriendlyName ?? data.ColumnId)) : null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Data Type: ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.FreeTextColumnSettings.DataType)), data.DefaultValue !== undefined ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Default Value: ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.DefaultValue)) : null, data.TextEditor !== undefined ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Editor Type: ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.TextEditor)) : null);
};
const $d19cd7ab3c7bca99$export$ff523a670d13cc77 = (data, api)=>{
    const columns = api.columnApi.getUIAvailableColumns();
    if (!data.ColumnId) return 'A Column ID is required.';
    const columnsWithSameIdCount = columns.filter((c)=>c.columnId === data.ColumnId).length;
    const hasAlreadyExistingId = data.Uuid ? columnsWithSameIdCount > 1 : columnsWithSameIdCount > 0;
    if (hasAlreadyExistingId) return 'A column with this ID already exists.';
    if (!data.FreeTextColumnSettings.DataType) return 'A data type is required for the column.';
    return true;
};
const $d19cd7ab3c7bca99$export$27beed907ffc5dcd = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const Pattern = api.optionsApi.getUserInterfaceOptions().dateInputOptions.dateFormat;
    const [ColumnNameFocused, setColumnNameFocused] = (0, $acw62.useState)(false);
    const inEdit = props.isEdit;
    const validCheck = $d19cd7ab3c7bca99$export$ff523a670d13cc77(data, api);
    const ErrorMessage = validCheck === true ? null : validCheck;
    const handleColumnIdChange = (event)=>{
        let e = event.target;
        const ColumnId = e.value;
        props.onChange({
            ...data,
            ColumnId: ColumnId
        });
    };
    const handleColumnNameChange = (event)=>{
        let e = event.target;
        const ColumnName = e.value;
        props.onChange({
            ...data,
            FriendlyName: ColumnName
        });
    };
    const handleDataTypeChange = (DataType)=>{
        const newData = {
            ...data,
            FreeTextColumnSettings: {
                ...data.FreeTextColumnSettings,
                DataType: DataType
            }
        };
        delete newData.DefaultValue;
        if (!DataType) delete newData.FreeTextColumnSettings?.DataType;
        props.onChange(newData);
    };
    const onDynamicSelectChanged = (event)=>{
        let e = event.target;
        const TextEditor = e.value;
        props.onChange({
            ...data,
            TextEditor: TextEditor
        });
    };
    const handleDefaultValueChange = (event)=>{
        let e = event.target;
        let DefaultValue = e.value;
        if (data.FreeTextColumnSettings.DataType === 'date') DefaultValue = (0, $1fe81e1078ace264$export$ad991b66133851cf)(DefaultValue, {
            Pattern: Pattern
        });
        props.onChange({
            ...data,
            DefaultValue: DefaultValue
        });
    };
    const handleSpecialColumnSettingsChange = (//  settings: SpecialColumnSettings
    settings)=>{
        props.onChange({
            ...data,
            FreeTextColumnSettings: {
                ...data?.FreeTextColumnSettings,
                ...settings
            }
        });
    };
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Column Id"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "column-id",
        autoFocus: !inEdit,
        value: data.ColumnId || '',
        style: {
            width: '100%',
            maxWidth: 500
        },
        disabled: inEdit,
        type: "text",
        placeholder: "Enter an id",
        onChange: (e)=>handleColumnIdChange(e)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Column Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "column-name",
        autoFocus: inEdit,
        onFocus: ()=>{
            setColumnNameFocused(true);
        },
        onBlur: ()=>{
            setColumnNameFocused(false);
        },
        value: ColumnNameFocused ? data.FriendlyName || '' : data.FriendlyName || data.ColumnId || '',
        style: {
            width: '100%',
            maxWidth: 500
        },
        type: "text",
        placeholder: "Enter a name",
        onChange: (e)=>handleColumnNameChange(e)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Data Type"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[500px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "data-name": "column-type-dropdown",
        options: $d19cd7ab3c7bca99$var$options,
        placeholder: "Select Data Type",
        value: data.FreeTextColumnSettings.DataType,
        onChange: (value)=>handleDataTypeChange(value)
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Default Value"
    }, data.FreeTextColumnSettings.DataType === 'boolean' ? $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "column-default-value-checkbox",
        checked: !!data.DefaultValue,
        onChange: (DefaultValue)=>{
            props.onChange({
                ...data,
                DefaultValue: DefaultValue
            });
        }
    }) : $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        "data-name": "column-default-value",
        value: data.FreeTextColumnSettings.DataType === 'date' && data.DefaultValue ? (0, $eccba2ee7b674d85$export$53b52b78a0e685f9)(data.DefaultValue, Pattern) || '' : data.DefaultValue || '',
        className: "twa:w-full twa:max-w-[500px]",
        type: data.FreeTextColumnSettings.DataType === 'number' ? 'number' : data.FreeTextColumnSettings.DataType === 'date' ? 'date' : 'text',
        placeholder: "Default Column Value (optional)",
        onChange: (e)=>handleDefaultValueChange(e)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Header Tooltip"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "header-tooltip",
        type: "text",
        style: {
            width: '100%',
            maxWidth: 500
        },
        value: data.FreeTextColumnSettings?.HeaderToolTip || '',
        onChange: (e)=>handleSpecialColumnSettingsChange({
                HeaderToolTip: e.target.value
            })
    })), ' ', data.FreeTextColumnSettings.DataType == 'text' && $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Cell Editor"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "inline-editor",
        value: "Inline",
        checked: data.TextEditor == 'Inline',
        onChange: (_, e)=>onDynamicSelectChanged(e),
        className: "twa:mr-2"
    }, "Inline Editor"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "large-editor",
        value: "Large",
        checked: data.TextEditor == 'Large',
        onChange: (_, e)=>onDynamicSelectChanged(e)
    }, "Large Editor"))), ErrorMessage ? $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), {
        className: "twa:my-2"
    }, ErrorMessage) : null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-2"
    }, $acw62.createElement((0, $597cd2acd2d20001$export$56579ebfaa709732), {
        isEditable: true,
        settings: data.FreeTextColumnSettings,
        onChange: handleSpecialColumnSettingsChange
    })));
};








const $b0c10b48ceac2de1$export$dac23433ad1bdffc = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const allFreeTextColumns = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.FreeTextColumn.FreeTextColumns);
    const [freeTextColumn, setFreeTextColumn] = (0, $acw62.useState)(()=>{
        if (props.data) return (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(props.data);
        if (props.popupParams?.action === 'Edit' && props.popupParams?.column) return allFreeTextColumns.find((column)=>column.ColumnId === props.popupParams.column.columnId);
        return (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyFreeTextColumn(adaptable.api.gridApi.internalApi.deriveSpecialColumnSettingsFromAgGridDefaultColDef());
    });
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const isEdit = props.data || props.popupParams?.action === 'Edit';
    const handleFinish = ()=>{
        if (isEdit) dispatch($d8c519ae038bb984$export$a83bd142017e0411(freeTextColumn));
        else dispatch($d8c519ae038bb984$export$4ca8d1bea9462d79(freeTextColumn));
        props.onFinishWizard(freeTextColumn);
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: freeTextColumn,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Settings',
                details: 'Configure the Free Text Column',
                isValid: (0, $d19cd7ab3c7bca99$export$ff523a670d13cc77),
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $d19cd7ab3c7bca99$export$27beed907ffc5dcd), {
                        isEdit: Boolean(props.data),
                        onChange: setFreeTextColumn
                    }));
                }
            },
            {
                details: 'Select Free Text Column Tags',
                title: 'Tags',
                isVisible: (_, api)=>api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setFreeTextColumn
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                details: 'Review the Free Text Column',
                renderSummary: (0, $d19cd7ab3c7bca99$export$e612deaba7f0f398),
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null));
                },
                title: 'Summary'
            }
        ]
    });
};




var $9g4SS = parcelRequire("9g4SS");
class $a6cec02de2e9f7ff$export$6cbdea0b0178ad2d extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    isListeningToCellDataChanges;
    constructor(api){
        super($42e863194fcb493f$export$7a2c7140815c0686, $42e863194fcb493f$export$45a38c01050861ce, 'horizontal-lines', 'FreeTextColumnPopup', 'Dynamic column showing custom content (stored in state and not with grid data)', api);
        this.isListeningToCellDataChanges = false;
    }
    onAdaptableReady() {
        this.checkListenToCellDataChanged();
    }
    shouldListenToDataChanges() {
        return (0, $9g4SS.default).IsNotNullOrEmpty(this.api.freeTextColumnApi.getFreeTextColumns());
    }
    checkListenToCellDataChanged() {
        if (!this.isListeningToCellDataChanges) {
            if (this.shouldListenToDataChanges()) {
                this.setupCellDataChangeListener();
                this.isListeningToCellDataChanges = true;
            }
        }
    }
    setupCellDataChangeListener() {
        // Listen to Data Service to save any Free Text Column Edits
        // We dont refresh here as that is all done in AdaptableAgGrid
        this.api.internalApi.getDataService().on('CellDataChanged', (cellDataChangedInfo)=>{
            if (cellDataChangedInfo.trigger !== 'aggChange') this.api.freeTextColumnApi.internalApi.handleFreeTextColumnDataChange(cellDataChangedInfo);
        });
    }
    isModuleEnabled() {
        // FreeTextColumn module doesn't support autogenerated primary keys
        return !this.api.optionsApi.isAutogeneratePrimaryKey();
    }
    getModuleAdaptableObjects() {
        return this.api.freeTextColumnApi.getFreeTextColumns();
    }
    hasNamedQueryReferences() {
        return false;
    }
    createColumnMenuItems(column) {
        if (column && column.isFreeTextColumn && this.isModuleEditable()) {
            let popupParam = {
                column: column,
                action: 'Edit',
                source: 'ColumnMenu'
            };
            return [
                this.createMenuItemShowPopup('free-text-column-edit', 'Edit Free Text Column', this.moduleInfo.Popup, this.moduleInfo.Glyph, popupParam)
            ];
        }
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.freeTextColumnApi.getFreeTextColumns(),
            AddAction: $d8c519ae038bb984$export$4ca8d1bea9462d79,
            EditAction: $d8c519ae038bb984$export$a83bd142017e0411
        };
    }
    toView(freeTextColumn) {
        return {
            abObject: freeTextColumn,
            items: [
                {
                    name: 'Settings',
                    label: 'Column Id',
                    values: [
                        freeTextColumn.ColumnId
                    ]
                },
                freeTextColumn.FriendlyName && {
                    name: 'Settings',
                    label: 'Column Name',
                    values: [
                        freeTextColumn.FriendlyName
                    ]
                },
                {
                    name: 'Settings',
                    label: 'Data Type',
                    values: [
                        freeTextColumn.FreeTextColumnSettings.DataType ?? 'Not specified'
                    ]
                },
                Boolean(freeTextColumn.DefaultValue) && {
                    name: 'Settings',
                    label: 'Default Value',
                    values: [
                        freeTextColumn.DefaultValue
                    ]
                },
                freeTextColumn.TextEditor && {
                    name: 'Editor Type',
                    label: 'Editor',
                    values: [
                        freeTextColumn.TextEditor
                    ]
                },
                (0, $52125728d99aa873$export$287b3702a135396b)(freeTextColumn, this.api)
            ].filter(Boolean)
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects().map((freeTextColumn)=>this.toView(freeTextColumn));
    }
    getViewProperties() {
        return {
            getDeleteAction: $d8c519ae038bb984$export$9de6cb54225dd17a,
            getEditWizard () {
                return 0, $b0c10b48ceac2de1$export$dac23433ad1bdffc;
            }
        };
    }
}






var $9g4SS = parcelRequire("9g4SS");

var $acw62 = parcelRequire("acw62");


const $51d790ae8a0e45a1$export$a74f6ef65f3c26d7 = ({ data: data })=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const currentLayout = adaptable.api.layoutApi.getCurrentLayout();
    const layouts = adaptable.api.layoutApi.getLayouts();
    const isDisabled = layouts?.length === 1;
    const isSelected = currentLayout.Name === data.Name;
    const handleToggle = $acw62.useCallback(()=>{
        adaptable.api.layoutApi.setLayout(data.Name);
    }, [
        isSelected
    ]);
    return $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "layout-select-button",
        "data-value": data.Name,
        disabled: isDisabled,
        checked: isSelected,
        onClick: handleToggle
    });
};



var $acw62 = parcelRequire("acw62");




const $a852c3e1c6668b15$export$fe5648a1911fc07c = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const layouts = adaptable.api.layoutApi.getLayouts();
    const options = layouts.map((layout)=>({
            label: layout.Name,
            value: layout.Name
        }));
    const currentLayout = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Layout.CurrentLayout);
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        onClick: (event)=>{
            event.stopPropagation();
        }
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        size: "small",
        options: options,
        value: currentLayout,
        onChange: (value)=>{
            adaptable.api.layoutApi.setLayout(value);
        }
    }));
};



var $acw62 = parcelRequire("acw62");





const $0f85f402d42d10cd$export$7bcac5f4c3ee8df7 = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const handleClick = $acw62.useCallback(()=>{
        const currentLayout = adaptable.api.layoutApi.getCurrentLayout();
        const layoutName = currentLayout.Name;
        const type = (0, $702a77ed6db22640$export$db5fe50348e92ffe)(currentLayout) ? 'pivot' : 'table';
        adaptable.api.layoutApi.showLayoutEditor(layoutName, type, 'Edit');
    }, []);
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        className: "twa:ml-1",
        variant: "text",
        iconSize: 15,
        icon: "edit",
        onClick: handleClick
    });
};



var $acw62 = parcelRequire("acw62");



const $17cd98021108d154$export$c7a7af74bf07c087 = ({ data: data, accessLevel: accessLevel })=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const isDisabled = accessLevel === 'ReadOnly';
    const handleClick = $acw62.useCallback(()=>{
        adaptable.api.layoutApi.showLayoutEditor(data.Name, (0, $702a77ed6db22640$export$db5fe50348e92ffe)(data) ? 'pivot' : 'table', 'Clone');
    }, []);
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onClick: handleClick,
        disabled: isDisabled,
        variant: "text",
        icon: "clone",
        tooltip: "Clone"
    });
};



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");








const $b5374d66d6c97c96$export$a4ef0c2aac6e4f8c = ()=>{
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const isPivot = (0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout);
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
        className: "twa:mr-2"
    }, "Layout Name: ", layout.Name), $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
        className: "twa:mr-2"
    }, "Layout Grid Type: ", isPivot ? 'Pivot' : 'Table'), $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
        className: "twa:mr-2"
    }, "Suppress Aggregation Function in Column Header:", ' ', layout.SuppressAggFuncInHeader ? 'Yes' : 'No'));
};
const $b5374d66d6c97c96$export$d239b03507a9e5cc = (props)=>{
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const onNameChange = (event)=>{
        props.onChange({
            ...layout,
            Name: event.target.value
        });
    };
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mb-3"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:max-w-[300px] twa:w-full"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        className: "twa:w-full",
        "data-name": "layout-name",
        onChange: onNameChange,
        value: layout?.Name ?? ''
    })))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mb-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Grid Type"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "layout-type-table",
        disabled: true,
        checked: !(0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)
    }, "Table"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "layout-type-pivot",
        disabled: true,
        checked: (0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)
    }, "Pivot")))));
};






var $acw62 = parcelRequire("acw62");





const $87d846d33c010e0a$export$fc20acf56d163798 = (column, searchText)=>[
        column.friendlyName,
        column.columnId
    ].some((candidate)=>candidate?.toLowerCase().includes(searchText.toLowerCase()));






var $9g4SS = parcelRequire("9g4SS");


var $acw62 = parcelRequire("acw62");



var $9g4SS = parcelRequire("9g4SS");


function $5dccbf0b4e30d5a3$export$eeb95d02ceba24d7(props) {
    const { onChange: onChange, order: order, toIdentifier: toIdentifier, isOptionDraggable: isOptionDraggable, disabled: disabled } = props;
    const baseClassName = 'ab-ReorderDraggable';
    const renderOption = (option, index)=>{
        const identifier = toIdentifier(option);
        const renderNode = (flexProps, dragHandleProps)=>{
            const reorderable = isOptionDraggable ? isOptionDraggable(option) : true;
            return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                alignItems: "center",
                key: identifier ?? index,
                "data-index": index,
                "data-id": identifier,
                "data-name": "option",
                ...flexProps,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`${baseClassName}__option ${index ? 'twa:mt-1' : 'twa:mt-0'} twa:bg-primary twa:p-2 ${flexProps?.className || ''}`, props.optionClassName?.(option)),
                onClick: (e)=>props.onOptionClick?.(option, e)
            }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                className: "twa:flex-1",
                flexDirection: "row",
                alignItems: "center"
            }, reorderable ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                ...dragHandleProps,
                className: `twa:mr-3 ${dragHandleProps?.className || ''}`
            }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "drag",
                style: {
                    cursor: 'grab'
                }
            })) : $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:mr-3"
            }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: "drag",
                style: {
                    cursor: 'not-allowed',
                    opacity: 0.3
                }
            })), props.renderOption(option, index)));
        };
        const reorderable = isOptionDraggable ? isOptionDraggable(option) : true;
        return $acw62.createElement((0, $1710e65dc30c5dd1$export$f2a139e5d18b9882), {
            key: identifier,
            index: index,
            draggableId: `${identifier}`,
            isDragDisabled: !reorderable || disabled
        }, (draggableProvided)=>{
            return renderNode({
                ref: draggableProvided.innerRef,
                ...draggableProvided.draggableProps,
                style: draggableProvided.draggableProps.style
            }, draggableProvided.dragHandleProps);
        });
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        style: props.style,
        className: `${baseClassName} twa:flex-1`,
        flexDirection: "column"
    }, $acw62.createElement((0, $e52d5c02f19d68ad$export$237bd83162c14364), {
        onDragEnd: (result)=>{
            const { source: source, destination: destination } = result;
            const newOrder = (0, $9g4SS.default).reorderArray(props.order, source.index, destination.index);
            onChange(newOrder);
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: `${baseClassName}__body twa:flex-1 twa:overflow-auto`,
        flexDirection: "column"
    }, $acw62.createElement((0, $e52d5c02f19d68ad$export$423ec2075359570a), {
        droppableId: "droppable"
    }, (droppableProvided)=>{
        return $acw62.createElement("div", {
            ref: droppableProvided.innerRef,
            ...droppableProvided.droppableProps
        }, order.map(renderOption), droppableProvided.placeholder);
    }))));
}









const $19da8f33a73dc6de$var$PropertyOrderText = (props)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:font-bold twa:text-2"
    }, props.children);
// we want to make sure tailwind generates this class
// as for now it's not used anywhere yet
const $19da8f33a73dc6de$var$_cls = 'twa:text-text-on-defaultbackground';
const $19da8f33a73dc6de$var$columnTypes = {
    default: {
        defaultFlex: 1
    }
};
const $19da8f33a73dc6de$export$498f21fd97b7df5c = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const rowHeight = 40;
    const headerHeight = 40;
    const ColumnIds = layout.TableColumns || layout.PivotColumns || [];
    const tableHeight = headerHeight + (0, $f5fc3c9fe698fd70$export$7d15b64cf5a3a4c4)(rowHeight * ColumnIds.length, 100, 360);
    const data = $acw62.useMemo(()=>{
        return ColumnIds.map((columnId)=>{
            if (adaptable.api.columnApi.isPivotResultColumn(columnId) || adaptable.api.columnApi.isAutoRowGroupColumn(columnId) || adaptable.api.columnApi.isSelectionColumn(columnId)) return null;
            const friendlyName = adaptable.api.columnApi.getFriendlyNameForColumnId(columnId, layout);
            const header = layout.ColumnHeaders?.[columnId] ?? '';
            const columnWidth = layout.ColumnSizing?.[columnId]?.Width;
            const columnPinning = layout.ColumnPinning?.[columnId];
            let agg = (layout.TableAggregationColumns || []).find((agg)=>agg.ColumnId === columnId)?.AggFunc;
            agg = typeof agg === 'object' ? agg.type : agg;
            const sortIndex = (layout?.ColumnSorts ?? []).findIndex((sort)=>sort.ColumnId === columnId);
            const sortOrder = sortIndex != -1 ? {
                index: sortIndex + 1,
                sort: layout.ColumnSorts[sortIndex]?.SortOrder ?? null
            } : {};
            let grouping = layout.RowGroupedColumns?.indexOf?.(columnId);
            grouping = grouping != -1 ? grouping + 1 : null;
            const filter = layout.ColumnFilters?.find((colFilter)=>colFilter.ColumnId === columnId);
            return {
                columnId: columnId,
                agg: agg,
                friendlyName: friendlyName,
                header: header,
                columnWidth: columnWidth,
                columnPinning: columnPinning,
                sortOrder: sortOrder,
                grouping: grouping,
                filter: filter
            };
        }).filter(Boolean);
    }, [
        layout
    ]);
    const columns = $acw62.useMemo(()=>{
        return {
            name: {
                header: 'Name',
                field: 'friendlyName',
                minWidth: 100
            },
            header: {
                header: 'Header',
                field: 'header',
                minWidth: 120
            },
            colId: {
                header: 'ID',
                field: 'columnId'
            },
            agg: {
                header: 'Agg',
                field: 'agg',
                minWidth: 70
            },
            width: {
                header: 'Width',
                field: 'columnWidth',
                minWidth: 70
            },
            pin: {
                header: 'Pin',
                field: 'columnPinning',
                minWidth: 80
            },
            sort: {
                header: 'Sort',
                field: 'sortOrder',
                minWidth: 50,
                align: 'center',
                render: (params)=>{
                    if (!params.data?.sortOrder?.sort) return $acw62.createElement($acw62.Fragment, null);
                    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                        name: params.data?.sortOrder?.sort === 'Asc' ? 'arrow-up-long' : 'arrow-down-long'
                    }), ' ', $acw62.createElement($19da8f33a73dc6de$var$PropertyOrderText, null, params.data?.sortOrder?.index ?? ''));
                }
            },
            filter: {
                header: 'Filter',
                field: 'filter',
                align: 'center',
                minWidth: 50,
                render: (params)=>{
                    if (!params.data?.filter) return $acw62.createElement($acw62.Fragment, null);
                    return $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                        checked: true
                    });
                }
            },
            group: {
                header: 'Group',
                minWidth: 50,
                field: 'columnGroupping',
                align: 'center',
                render: (params)=>{
                    if (!params.data.grouping) return $acw62.createElement($acw62.Fragment, null);
                    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                        className: "twa:m-0 twa:mr-1",
                        checked: true
                    }), $acw62.createElement($19da8f33a73dc6de$var$PropertyOrderText, null, params.data?.grouping));
                }
            }
        };
    }, []);
    const tableDOMProps = {
        style: {
            height: '100%',
            minWidth: '10rem',
            minHeight: tableHeight
        }
    };
    return $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
        data: data,
        primaryKey: "columnId"
    }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
        columnTypes: $19da8f33a73dc6de$var$columnTypes,
        rowHeight: rowHeight,
        columnHeaderHeight: headerHeight,
        domProps: tableDOMProps,
        columns: columns
    }));
};
const $19da8f33a73dc6de$var$isColumnVisible = (options)=>{
    const { columnId: columnId, layout: layout } = options;
    const isRowGroupColumn = (0, $49746e7bf2cf87d5$export$862c4c411407056)(columnId);
    const visible = !(0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout) && layout.TableColumns.includes(columnId) && layout.ColumnVisibility?.[columnId] !== false || isRowGroupColumn;
    return visible;
};
const $19da8f33a73dc6de$var$ColumnRow = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const initialHeader = adaptable.api.columnApi.getFriendlyNameForColumnId(props.column.columnId, props.layout);
    const isRowGroupColumn = (0, $49746e7bf2cf87d5$export$862c4c411407056)(props.column.columnId);
    const { column: column } = props;
    const visible = $19da8f33a73dc6de$var$isColumnVisible({
        columnId: column.columnId,
        layout: props.layout
    });
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": props.column.columnId,
        className: "twa:flex-1"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-Layout-Wizard__ColumnRow__Header twa:my-1"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": column.columnId,
        onChange: (checked)=>{
            props.onColumnVisibilityChange(column.columnId, checked);
        },
        disabled: column.hideable === false || isRowGroupColumn,
        onClick: (event1)=>{
            event1.stopPropagation();
        },
        checked: visible
    }), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:mx-2",
        alignItems: "center",
        "data-name": "column-label"
    }, initialHeader), props.column.columnGroup && props.column.columnGroup.groupCount > 1 ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-Layout-Wizard__ColumnRow__Title twa:mx-2 twa:p-1"
    }, "Column Group: ", props.column.columnGroup.friendlyName) : null));
};
const $19da8f33a73dc6de$export$e7d304bbce738d09 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const [searchInputValue, setSearchInputValue] = $acw62.useState('');
    const [selectedColumnId, setSelectedColumnId] = $acw62.useState(null);
    let hasSelectionColumn = false;
    const allColumns = adaptable.api.columnApi.getUIAvailableColumns().filter((col)=>{
        // since the "Row Groups" section of the editor can determine a change
        // which is not reflected into AG Grid until we hit finish
        // so we only rely on non-generated columns, which are the same
        return !col.isGeneratedRowGroupColumn;
    })// if the current Layout is a PivotLayout, then we also filter out current Pivot Result Columns
    .filter((col)=>!col.isGeneratedPivotResultColumn)// also we need to filter out selection column
    .filter((col)=>{
        const result = !col.isGeneratedSelectionColumn;
        if (!result) hasSelectionColumn = true;
        return result;
    });
    const onChange = (data)=>{
        if (hasSelectionColumn && Array.isArray(data.TableColumns) && !data.TableColumns.includes((0, $58846ea7f4156db7$export$8866fbaadb96699c))) data.TableColumns.unshift((0, $58846ea7f4156db7$export$8866fbaadb96699c));
        props.onChange(data);
    };
    // however, changes in RowGroupedColumns done in the previous step
    // are reflected into the layout, so we use the latest layout.RowGroupedColumns
    // to create new columns
    if (layout.RowGroupedColumns && layout.RowGroupedColumns.length > 0) {
        if (layout.RowGroupDisplayType === 'single') allColumns.unshift((0, $49746e7bf2cf87d5$export$2a4c43a0a47efea8)());
        else [
            ...layout.RowGroupedColumns
        ].reverse().forEach((col)=>{
            const groupCol = (0, $49746e7bf2cf87d5$export$526dfbcccf2f7c0)(adaptable.api.columnApi.getColumnWithColumnId(col));
            allColumns.unshift(groupCol);
        });
    }
    if (adaptable.api.gridApi.isTreeDataGrid() && !allColumns.find((col)=>col.columnId === (0, $58846ea7f4156db7$export$1fadf36dae8ed962))) allColumns.unshift((0, $49746e7bf2cf87d5$export$b855ba22978bfa2d)());
    const colIdToCol = allColumns.reduce((acc, col)=>{
        if (col) acc[col.columnId] = col;
        return acc;
    }, {});
    const TableColumns = layout.TableColumns;
    const ColumnOrderAllColumns = (0, $9g4SS.default).sortArrayWithOrder(allColumns.map((col)=>col.columnId), TableColumns, {
        sortUnorderedItems: false
    }).map((colId)=>colIdToCol[colId]);
    const currentOrder = searchInputValue ? ColumnOrderAllColumns.filter((col)=>{
        return (0, $87d846d33c010e0a$export$fc20acf56d163798)(col, searchInputValue);
    }) : ColumnOrderAllColumns;
    const currentOrderIds = currentOrder.map((col)=>col.columnId);
    const handleColumnsChange = (newColumns)=>{
        if (searchInputValue) {
            // there's a search in-place
            // so the current `newColumns` does not actually contain all the columns
            // so we need to recompute it
            const newOrder = (0, $098fa86aabe6d330$export$c2cd5eccc0f0183b)(// given those are all the columns
            ColumnOrderAllColumns.map((col)=>col.columnId), // we want to sort them to have this new order
            // - this sorting will leave all ids not found in this new order untouched
            newColumns.map((col)=>col.columnId));
            // so basically we now have the correct order, with all columns
            newColumns = newOrder.map((colId)=>colIdToCol[colId]);
        }
        const oldColumns = ColumnOrderAllColumns;
        const columnIds = newColumns.map((col)=>col.columnId);
        if (!(0, $b0d14b794bdca4f2$export$29b8313004691c1e)({
            oldColumns: oldColumns,
            newColumns: newColumns
        })) return;
        const ColumnVisibility = {
            ...layout.ColumnVisibility
        };
        const columnOrderSet = new Set(TableColumns);
        columnIds.forEach((colId)=>{
            if (!columnOrderSet.has(colId)) ColumnVisibility[colId] = false;
        });
        onChange({
            ...layout,
            TableColumns: columnIds,
            ColumnVisibility: ColumnVisibility
        });
    };
    const handleColumnVisibilityChange = (columnId, visible)=>{
        const columnIdArray = Array.isArray(columnId) ? columnId : [
            columnId
        ];
        const columnIdSet = new Set(columnIdArray);
        const ColumnVisibility = {
            ...layout.ColumnVisibility
        };
        let TableColumns = [
            ...layout.TableColumns
        ];
        if (visible) columnIdArray.forEach((colId)=>{
            delete ColumnVisibility[colId];
        });
        else columnIdArray.forEach((colId)=>{
            ColumnVisibility[colId] = false;
        });
        const columnIds = ColumnOrderAllColumns.map((col)=>col.columnId);
        const idsToIndexes = new Map(columnIds.map((colId, index)=>[
                colId,
                index
            ]));
        const columnOrderSet = new Set(TableColumns);
        const currentColumnIdsAreIncluded = columnIdArray.every((colId)=>columnOrderSet.has(colId));
        if (!currentColumnIdsAreIncluded) {
            const biggestIndex = Math.max(...columnIdArray.map((colId)=>idsToIndexes.get(colId)));
            TableColumns = columnIds.filter((colId)=>{
                const isCurrent = columnOrderSet.has(colId);
                if (isCurrent) return true;
                // include all columns past the current column order
                // that reach until the index of the currently checked column
                const shouldInclude = idsToIndexes.get(colId) <= biggestIndex;
                if (shouldInclude) {
                    if (!columnIdSet.has(colId) && visible) // this is a column that's between the current column order limit
                    // and the currently checked column
                    // so we need to include it in order
                    // but make it invisible
                    ColumnVisibility[colId] = false;
                }
                return shouldInclude;
            });
        }
        onChange({
            ...layout,
            TableColumns: TableColumns,
            ColumnVisibility: ColumnVisibility
        });
    };
    const handlePinChange = (columnId, pinning)=>{
        onChange({
            ...layout,
            ColumnPinning: {
                ...layout.ColumnPinning,
                [columnId]: pinning
            }
        });
    };
    const handleColumnNameChange = (columnId, headerName)=>{
        onChange({
            ...layout,
            ColumnHeaders: {
                ...layout.ColumnHeaders,
                [columnId]: headerName
            }
        });
    };
    const handleColumnWidthChange = (columnId, width)=>{
        const ColumnSizing = {
            ...layout.ColumnSizing
        };
        const colSizingForCol = {
            ...ColumnSizing[columnId]
        };
        delete colSizingForCol.Flex;
        colSizingForCol.Width = width;
        ColumnSizing[columnId] = colSizingForCol;
        onChange({
            ...layout,
            ColumnSizing: ColumnSizing
        });
    };
    const handleColumnFlexChange = (columnId, flex)=>{
        const ColumnSizing = {
            ...layout.ColumnSizing
        };
        const colSizingForCol = {
            ...ColumnSizing[columnId]
        };
        delete colSizingForCol.Width;
        colSizingForCol.Flex = flex;
        ColumnSizing[columnId] = colSizingForCol;
        onChange({
            ...layout,
            ColumnSizing: ColumnSizing
        });
    };
    const handleColumnMinWidthChange = (columnId, minWidth)=>{
        const ColumnSizing = {
            ...layout.ColumnSizing
        };
        const colSizingForCol = {
            ...ColumnSizing[columnId]
        };
        colSizingForCol.MinWidth = minWidth;
        ColumnSizing[columnId] = colSizingForCol;
        onChange({
            ...layout,
            ColumnSizing: ColumnSizing
        });
    };
    const handleColumnMaxWidthChange = (columnId, maxWidth)=>{
        const ColumnSizing = {
            ...layout.ColumnSizing
        };
        const colSizingForCol = {
            ...ColumnSizing[columnId]
        };
        colSizingForCol.MaxWidth = maxWidth;
        ColumnSizing[columnId] = colSizingForCol;
        onChange({
            ...layout,
            ColumnSizing: ColumnSizing
        });
    };
    const visibleIds = layout.TableColumns.filter((colId)=>{
        return layout.ColumnVisibility?.[colId] !== false && adaptable.api.columnApi.isSelectionColumn(colId) === false && !adaptable.api.columnApi.internalApi.isColumnUIHidden(colId);
    });
    const currentlyDisplayedColumnIds = searchInputValue ? currentOrder.filter((col)=>currentOrderIds.includes(col.columnId)).map((col)=>col.columnId) : currentOrder.map((col)=>col.columnId);
    const visibleIdsCurrentlyDisplayed = visibleIds.filter((colId)=>currentlyDisplayedColumnIds.includes(colId));
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Columns"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        className: "twa:overflow-hidden"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:grid twa:grid-cols-2 twa:gap-2 twa:focus:outline-none",
        "data-name": "columns-container",
        tabIndex: -1,
        onKeyDown: (event1)=>{
            if (event1.key === 'ArrowDown') {
                event1.preventDefault();
                event1.stopPropagation();
                const index = currentlyDisplayedColumnIds.indexOf(selectedColumnId);
                if (index === -1) return;
                const nextColumnId = currentlyDisplayedColumnIds[index + 1];
                const nextColumn = colIdToCol[nextColumnId];
                if (nextColumn) setSelectedColumnId(nextColumn.columnId);
            }
            if (event1.key === 'ArrowUp') {
                event1.preventDefault();
                event1.stopPropagation();
                const index = currentlyDisplayedColumnIds.indexOf(selectedColumnId);
                if (index === -1) return;
                const previousColumnId = currentlyDisplayedColumnIds[index - 1];
                const previousColumn = colIdToCol[previousColumnId];
                if (previousColumn) setSelectedColumnId(previousColumn.columnId);
            }
            if (event1.key === ' ') {
                event1.preventDefault();
                event1.stopPropagation();
                const selectedColumn = colIdToCol[selectedColumnId];
                if (!selectedColumn) return;
                const visible = $19da8f33a73dc6de$var$isColumnVisible({
                    columnId: selectedColumnId,
                    layout: layout
                });
                handleColumnVisibilityChange(selectedColumnId, !visible);
            }
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex twa:flex-col twa:gap-2"
    }, $acw62.createElement((0, $0f5e3272866deca2$export$6e10b3df66bf9f52), {
        value: searchInputValue,
        OnTextChange: setSearchInputValue,
        placeholder: "Search Columns...",
        className: "twa:w-full twa:border-none twa:p-1"
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:font-bold', 'twa:border-b twa:border-primarydark/30 twa:rounded-standard')
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: currentlyDisplayedColumnIds.length ? currentlyDisplayedColumnIds.length === visibleIdsCurrentlyDisplayed.length ? true : visibleIdsCurrentlyDisplayed.length ? null : false : false,
        onChange: (checked)=>{
            handleColumnVisibilityChange(currentlyDisplayedColumnIds, checked);
        }
    }, "Select All")), $acw62.createElement((0, $5dccbf0b4e30d5a3$export$eeb95d02ceba24d7), {
        toIdentifier: (option)=>`${option.columnId}`,
        isOptionDraggable: (option)=>{
            return option.moveable;
        },
        optionClassName: (option)=>{
            const baseCls = 'ab-Layout-Wizard__ColumnRow twa:cursor-pointer twa:rounded-standard';
            if (selectedColumnId !== option.columnId) return baseCls;
            return (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(baseCls, 'twa:after:border-accent twa:relative twa:after:border-2 twa:after:rounded-standard twa:after:pointer-events-none twa:after:inset-0 twa:after:absolute twa:after:bg-accent/15');
        },
        order: currentOrder,
        onOptionClick: (option, event1)=>{
            if (event1.ctrlKey || option.columnId === selectedColumnId) setSelectedColumnId(null);
            else setSelectedColumnId(option.columnId);
        },
        renderOption: (option)=>{
            return $acw62.createElement($19da8f33a73dc6de$var$ColumnRow, {
                onColumnNameChange: handleColumnNameChange,
                onColumnWidthChange: handleColumnWidthChange,
                onColumnFlexChange: handleColumnFlexChange,
                onColumnMinWidthChange: handleColumnMinWidthChange,
                onColumnMaxWidthChange: handleColumnMaxWidthChange,
                onColumnVisibilityChange: handleColumnVisibilityChange,
                onPinChange: handlePinChange,
                layout: layout,
                column: option
            });
        },
        onChange: handleColumnsChange
    })), currentOrderIds.length ? $acw62.createElement($19da8f33a73dc6de$var$ColumnPropertiesEditor, {
        column: selectedColumnId && currentOrderIds.includes(selectedColumnId) ? colIdToCol[selectedColumnId] ?? null : null,
        layout: layout,
        onPinChange: handlePinChange,
        onColumnNameChange: handleColumnNameChange,
        onColumnWidthChange: handleColumnWidthChange,
        onColumnFlexChange: handleColumnFlexChange,
        onColumnMinWidthChange: handleColumnMinWidthChange,
        onColumnMaxWidthChange: handleColumnMaxWidthChange,
        onColumnVisibilityChange: handleColumnVisibilityChange
    }) : null)));
};
const $19da8f33a73dc6de$var$hr = $acw62.createElement("hr", {
    className: "twa:my-2 twa:h-[0.5px] twa:bg-inputborder/50 twa:border-none"
});
const $19da8f33a73dc6de$var$ColumnPropertiesEditor = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const baseCls = 'ab-Layout-Wizard__ColumnPropertiesEditor twa:border twa:rounded-standard';
    if (!props.column) return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(baseCls, 'twa:border-inputborder twa:grid twa:place-items-center twa:border-dashed twa:border-2')
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex twa:flex-col twa:gap-2 twa:items-center twa:justify-center"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-text-on-primarydark ab-Layout-Wizard__ColumnPropertiesEditor__Placeholder__Icon"
    }, $acw62.createElement((0, $124c9aa27215a392$export$9965b2ecc258c4a1), {
        name: "inspector",
        style: {
            stroke: 'currentColor',
            fill: 'none',
            strokeWidth: 2
        }
    })), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-4 twa:font-bold ab-Layout-Wizard__ColumnPropertiesEditor__Placeholder__Title"
    }, "No Column Selected"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-3 twa:opacity-80 ab-Layout-Wizard__ColumnPropertiesEditor__Placeholder__Description"
    }, "Select a Column to view and edit its properties")));
    const { column: column } = props;
    const columnWidth = props.layout.ColumnSizing?.[column.columnId]?.Width;
    const columnFlex = props.layout.ColumnSizing?.[column.columnId]?.Flex;
    const minWidth = props.layout.ColumnSizing?.[column.columnId]?.MinWidth;
    const maxWidth = props.layout.ColumnSizing?.[column.columnId]?.MaxWidth;
    const resizable = column.resizable !== false;
    // column pinning
    const columnPinning = props.layout.ColumnPinning?.[props.column.columnId] || 'None';
    const initialHeader = adaptable.api.columnApi.getFriendlyNameForColumnId(props.column.columnId, props.layout);
    const customHeader = props.layout.ColumnHeaders?.[props.column.columnId] ?? initialHeader;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(baseCls, 'ab-Layout-Wizard__ColumnPropertiesEditor__Container twa:border-none twa:bg-defaultbackground twa:shadow-md twa:p-4')
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-5 twa:font-bold twa:leading-relaxed ab-Layout-Wizard__ColumnPropertiesEditor__Title"
    }, "Column Settings: ", column.friendlyName), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-3 twa:opacity-80 twa:flex twa:flex-row twa:gap-1 twa:items-center"
    }, "Column ID:", ' ', $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:bg-primarydark/20 twa:text-text-on-primarydark twa:px-1 twa:py-0.5 twa:rounded-standard"
    }, column.columnId)), props.column.columnGroup && props.column.columnGroup.groupCount > 1 ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-Layout-Wizard__ColumnRow__Title twa:mx-2 twa:p-1"
    }, "Column Group: ", props.column.columnGroup.friendlyName) : null, $19da8f33a73dc6de$var$hr, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:gap-3"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:gap-1"
    }, "Header", $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "column-header",
        className: "ab-Layout-Wizard__ColumnPropertiesEditor__Input twa:w-full",
        placeholder: "Custom name (optional)",
        onChange: ()=>{
            props.onColumnNameChange(props.column.columnId, event.target.value);
        },
        value: customHeader
    })), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:grid twa:grid-cols-[1fr_1fr] twa:gap-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, "Width:"), " ", $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, "Flex:"), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "column-width",
        className: "ab-Layout-Wizard__ColumnPropertiesEditor__Input",
        type: "number",
        placeholder: "Column width",
        disabled: resizable === false,
        onChange: (event1)=>{
            let value = parseFloat(event1.target.value);
            value = typeof value === 'number' && !isNaN(value) ? value : void 0;
            props.onColumnWidthChange(props.column.columnId, value);
        },
        value: columnWidth ?? ''
    }), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "column-flex",
        className: "ab-Layout-Wizard__ColumnPropertiesEditor__Input",
        type: "number",
        placeholder: "Column flex",
        disabled: resizable === false,
        onChange: (event1)=>{
            let value = parseFloat(event1.target.value);
            value = typeof value === 'number' && !isNaN(value) ? value : void 0;
            props.onColumnFlexChange(props.column.columnId, value);
        },
        value: columnFlex ?? ''
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, "Min Width:"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, "Max Width:"), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "column-min-width",
        className: "ab-Layout-Wizard__ColumnPropertiesEditor__Input",
        type: "number",
        placeholder: "Column min width",
        disabled: resizable === false,
        onChange: (event1)=>{
            let value = parseFloat(event1.target.value);
            value = typeof value === 'number' && !isNaN(value) ? value : void 0;
            props.onColumnMinWidthChange(props.column.columnId, value);
        },
        value: minWidth ?? ''
    }), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "column-max-width",
        className: "ab-Layout-Wizard__ColumnPropertiesEditor__Input",
        type: "number",
        placeholder: "Column max width",
        disabled: resizable === false,
        onChange: (event1)=>{
            let value = parseFloat(event1.target.value);
            value = typeof value === 'number' && !isNaN(value) ? value : void 0;
            props.onColumnMaxWidthChange(props.column.columnId, value);
        },
        value: maxWidth ?? ''
    })), "Pinning:", $acw62.createElement((0, $d6ef3253c01d4163$export$a98f0dcb43a68a25), {
        value: columnPinning || 'None',
        name: "columnPinning",
        orientation: "horizontal",
        variant: "text-only",
        className: (0, $d6ef3253c01d4163$export$38b13bf43ec3e697).horizontalTextOnly,
        onRadioChange: (columnPinning)=>{
            props.onPinChange(column.columnId, columnPinning === 'None' ? null : columnPinning);
        }
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        value: "left"
    }, "Left"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        value: "None"
    }, "None"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        value: "right"
    }, "Right"))), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-5"
    }), $19da8f33a73dc6de$var$hr, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:my-3"
    }, "Column Attributes"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            'twa:bg-primarylight': 'the bg color',
            'twa:gap-2 twa:flex twa:flex-col': 'layout configuration for small screens',
            'twa:lg:gap-3 twa:lg:grid twa:md:grid-cols-[1fr_1fr]': 'layout configuration for normal screens',
            'twa:p-5 twa:rounded-standard': true
        })
    }, [
        {
            label: 'Aggregatable',
            checked: props.column.aggregatable
        },
        {
            label: 'Filterable',
            checked: props.column.filterable
        },
        {
            label: 'Groupable',
            checked: props.column.groupable
        },
        {
            label: 'Moveable',
            checked: props.column.moveable
        },
        {
            label: 'Pivotable',
            checked: props.column.pivotable
        },
        {
            label: 'Sortable',
            checked: props.column.sortable
        }
    ].map(({ label: label, checked: checked })=>$acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            key: label,
            alignItems: "center",
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                'twa:rounded-standard twa:gap-2': true
            })
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:size-5"
        }, checked ? $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
            name: "check",
            className: "twa:text-success"
        }) : $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
            name: "close",
            className: "twa:text-error"
        })), label)))));
};



var $acw62 = parcelRequire("acw62");







var $9g4SS = parcelRequire("9g4SS");


const $23fa8a372d14d5c3$export$f5839ebce370ec94 = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2 twa:rounded-standard twa:bg-defaultbackground"
    }, layout.PivotColumns?.length ? layout.PivotColumns.map((columnId)=>$acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
            className: "twa:mr-1",
            key: columnId
        }, adaptable.api.columnApi.getFriendlyNameForColumnId(columnId))) : $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "No Pivot Columns Defined"));
};
const $23fa8a372d14d5c3$export$ff42eb5099fd35ef = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const allPivotColumns = adaptable.api.columnApi.getPivotableColumns();
    const sortedPivotColumns = $acw62.useMemo(()=>{
        return (0, $9g4SS.default).sortArrayWithOrder(allPivotColumns.map((col)=>col.columnId), layout.PivotColumns ?? [], {
            sortUnorderedItems: false
        }).map((colId)=>adaptable.api.columnApi.getColumnWithColumnId(colId));
    }, [
        layout,
        allPivotColumns
    ]);
    const handleColumnsChange = (columnIds)=>{
        props.onChange({
            ...layout,
            PivotColumns: columnIds
        });
    };
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Pivot Columns"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-3 twa:px-2"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: !!layout.PivotResultColumnsOrder,
        onChange: (checked)=>{
            props.onChange({
                ...layout,
                PivotResultColumnsOrder: checked
            });
        }
    }, "Persist Order of Pivot Result Columns")), $acw62.createElement((0, $d2ae5bba8d7d6225$export$98c0468e3210506e), {
        showFilterInput: true,
        filter: (0, $87d846d33c010e0a$export$fc20acf56d163798),
        toIdentifier: (option)=>`${option.columnId}`,
        toLabel: (option)=>option.friendlyName ?? option.columnId,
        options: sortedPivotColumns,
        value: layout.PivotColumns ?? [],
        allowReorder: true,
        onChange: handleColumnsChange
    })));
};



var $acw62 = parcelRequire("acw62");









var $9g4SS = parcelRequire("9g4SS");



const $b0210f4bbba14d75$export$8996fe5e9c68fe0b = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    if (adaptable.api.gridApi.isTreeDataGrid()) return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "Row Grouping is not available in Tree Grids"));
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, layout.RowGroupedColumns?.length ? layout.RowGroupedColumns.map((columnId)=>{
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            key: columnId,
            className: "twa:mb-2 twa:mr-2"
        }, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, adaptable.api.columnApi.getFriendlyNameForColumnId(columnId)));
    }) : $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "No Row Grouping"));
};
const $b0210f4bbba14d75$export$38837982e84e2a1c = (props)=>{
    const { layout: layout, onChange: onChange } = props;
    return $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $d6ef3253c01d4163$export$a98f0dcb43a68a25), {
        orientation: "vertical",
        value: layout.RowGroupValues?.RowGroupDefaultBehavior ?? 'always-collapsed',
        onRadioChange: (RowGroupDefaultBehavior)=>{
            const newLayout = {
                ...layout,
                RowGroupValues: {
                    RowGroupDefaultBehavior: RowGroupDefaultBehavior
                }
            };
            if (newLayout.RowGroupValues.RowGroupDefaultBehavior === 'collapsed' || newLayout.RowGroupValues.RowGroupDefaultBehavior === 'expanded') newLayout.RowGroupValues.ExceptionGroupKeys = [];
            onChange(newLayout);
        }
    }, $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        value: "always-collapsed",
        text: "All Collapsed",
        description: "Layout opens with all Grouped Rows always collapsed"
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        value: "always-expanded",
        text: "All Expanded",
        description: "Layout opens with all Grouped Rows always expanded"
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        value: "expanded",
        text: "Mostly Expanded",
        description: "Layout opens with all Grouped rows expanded, other than those collapsed when Layout last displayed"
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        value: "collapsed",
        text: "Mostly Collapsed",
        description: "Layout opens with all Grouped rows collapsed, other than those expanded when Layout last displayed"
    })));
};
const $b0210f4bbba14d75$export$f428a2c32db91dc2 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    if (adaptable.api.gridApi.isTreeDataGrid()) return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "Row Grouping is not available in Tree Grids"));
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const rowGroupsText = 'Row Group ' + adaptable.api.internalApi.getCorrectEnglishVariant('Behaviour');
    const allGroupableColumns = adaptable.api.columnApi.getGroupableColumns();
    const sortedGroupableColumns = $acw62.useMemo(()=>{
        return (0, $9g4SS.default).sortArrayWithOrder(allGroupableColumns.map((col)=>col.columnId), layout.RowGroupedColumns ?? [], {
            sortUnorderedItems: false
        }).map((colId)=>adaptable.api.columnApi.getColumnWithColumnId(colId));
    }, [
        layout,
        allGroupableColumns
    ]);
    const onChange = (layout)=>{
        props.onChange((0, $702a77ed6db22640$export$d859d72b10c9a984)(layout));
    };
    const handleColumnsChange = (columnIds)=>{
        const newLayout = {
            ...layout,
            RowGroupedColumns: columnIds
        };
        if (!newLayout.RowGroupValues) newLayout.RowGroupValues = {
            RowGroupDefaultBehavior: 'always-collapsed'
        };
        onChange(newLayout);
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Group Display Type"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $d6ef3253c01d4163$export$a98f0dcb43a68a25), {
        orientation: "vertical",
        value: layout.RowGroupDisplayType ?? 'single',
        onRadioChange: (RowGroupDisplayType)=>{
            let newLayout = {
                ...layout,
                RowGroupDisplayType: RowGroupDisplayType
            };
            if (RowGroupDisplayType === 'single') newLayout.TableColumns = (newLayout.TableColumns || []).filter((colId)=>!adaptable.api.columnApi.isAutoRowGroupColumnForMulti(colId));
            else newLayout.TableColumns = (newLayout.TableColumns || []).filter((colId)=>!adaptable.api.columnApi.isAutoRowGroupColumnForSingle(colId));
            onChange(newLayout);
        }
    }, $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        value: "single",
        text: "Single Column",
        description: "All Row Grouped Columns display in one hierarchical Column"
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        value: "multi",
        text: "Multiple Columns",
        description: "Each Row Grouped Columns displays in its own, separate, Column"
    }))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mt-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Row Grouped Columns"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, rowGroupsText), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $d2ae5bba8d7d6225$export$98c0468e3210506e), {
        showFilterInput: true,
        filter: (0, $87d846d33c010e0a$export$fc20acf56d163798),
        toIdentifier: (option)=>`${option.columnId}`,
        toLabel: (option)=>option.friendlyName ?? option.columnId,
        options: sortedGroupableColumns,
        value: layout.RowGroupedColumns ?? [],
        allowReorder: true,
        onChange: handleColumnsChange
    })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement($b0210f4bbba14d75$export$38837982e84e2a1c, {
        layout: layout,
        onChange: onChange
    }))));
};



var $acw62 = parcelRequire("acw62");










var $9g4SS = parcelRequire("9g4SS");


var $9OAZF = parcelRequire("9OAZF");

const $16126ed5a1737acc$var$WEIGHTED_AVERAGE_AGG_FN_NAME = 'weightedAvg';
const $16126ed5a1737acc$export$8764eda8856788e9 = (data)=>{
    const weightedAvg = data.TableAggregationColumns ? (data.TableAggregationColumns || []).find(({ AggFunc: AggFunc })=>typeof AggFunc === 'object' && AggFunc.type === 'weightedAverage')?.AggFunc : null;
    if (weightedAvg && !weightedAvg.weightedColumnId) return 'Weighted Average requires a weight column to be selected.';
    return true;
};
const $16126ed5a1737acc$export$1f7464667b39fd3f = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const entries = layout.TableAggregationColumns || [];
    let content = null;
    if (entries.length) content = $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, entries.map(({ ColumnId: ColumnId, AggFunc: AggFunc })=>$acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            key: ColumnId,
            label: adaptable.api.columnApi.getFriendlyNameForColumnId(ColumnId)
        }, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, typeof AggFunc === 'object' ? AggFunc.type : AggFunc))));
    else content = $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "No Aggregations");
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, content);
};
const $16126ed5a1737acc$var$ColumnRow = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const aggValue = props.layout?.TableAggregationColumns?.find((agg)=>agg.ColumnId === props.column.columnId)?.AggFunc;
    const adaptableAggFunctions = [];
    if (props.column.dataType === 'number' && props.column.aggregatable) adaptableAggFunctions.push($16126ed5a1737acc$var$WEIGHTED_AVERAGE_AGG_FN_NAME);
    // props.column.availableAggregationFunctions is null for non-aggregatable columns
    // but we want to support non-aggregatable columns that are specified to be aggregated by default
    // so we need to allow this. as soon as they will be unchecked from aggregation, they will no longer be displayed in the aggregation wizard.
    // but until the user checks them off, we want to allow them.
    const availableAggregationFunctions = props.column.availableAggregationFunctions || [];
    const aggOptions = [
        ...new Set([
            ...availableAggregationFunctions,
            ...adaptableAggFunctions
        ])
    ].map((fnName)=>{
        return {
            label: fnName,
            onClick: ()=>{
                let aggCols = props.layout.TableAggregationColumns || [];
                if (!aggCols) return;
                const AggFuncValue = fnName === $16126ed5a1737acc$var$WEIGHTED_AVERAGE_AGG_FN_NAME ? {
                    type: 'weightedAverage',
                    weightedColumnId: null
                } : fnName;
                let found = false;
                aggCols = aggCols.map(({ ColumnId: ColumnId, AggFunc: AggFunc })=>{
                    if (ColumnId === props.column.columnId) {
                        found = true;
                        return {
                            ColumnId: ColumnId,
                            AggFunc: AggFuncValue
                        };
                    }
                    return {
                        ColumnId: ColumnId,
                        AggFunc: AggFunc
                    };
                });
                if (!found) aggCols.push({
                    ColumnId: props.column.columnId,
                    AggFunc: AggFuncValue
                });
                props.onChangeAggFunction(aggCols);
            }
        };
    });
    const numericColumnsOptions = props.numberColumns.filter((col)=>col.columnId !== props.column.columnId).map((col)=>{
        return {
            label: col.friendlyName,
            onClick: ()=>{
                let aggCols = [
                    ...props.layout.TableAggregationColumns || []
                ];
                if (!aggCols || !aggCols.length) return;
                const AggFuncValue = {
                    type: 'weightedAverage',
                    weightedColumnId: col.columnId
                };
                let found = false;
                aggCols = aggCols.map(({ ColumnId: ColumnId, AggFunc: AggFunc })=>{
                    if (ColumnId === props.column.columnId) {
                        found = true;
                        return {
                            ColumnId: ColumnId,
                            AggFunc: AggFuncValue
                        };
                    }
                    return {
                        ColumnId: ColumnId,
                        AggFunc: AggFunc
                    };
                });
                if (!found) aggCols.push({
                    ColumnId: props.column.columnId,
                    AggFunc: AggFuncValue
                });
                props.onChangeAggFunction(aggCols);
            }
        };
    });
    const currentAggFnName = props.aggregationColumnsMap[props.column.columnId];
    let weightName = null;
    if (typeof aggValue === 'object' && aggValue.type === 'weightedAverage') weightName = aggValue.weightedColumnId ? adaptable.api.columnApi.getFriendlyNameForColumnId(aggValue.weightedColumnId) : 'Select Weight';
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, props.column.friendlyName, aggValue && $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        columns: [
            'label'
        ],
        items: aggOptions,
        className: "twa:ml-2"
    }, currentAggFnName), currentAggFnName === $16126ed5a1737acc$var$WEIGHTED_AVERAGE_AGG_FN_NAME && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:bg-primary twa:ml-3",
        alignItems: "center"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, "Weight"), ' ', $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        columns: [
            'label'
        ],
        items: numericColumnsOptions,
        className: "twa:ml-2"
    }, weightName)));
};
const $16126ed5a1737acc$export$5bed4fd52151e39b = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const allAggregableColumns = adaptable.api.columnApi.getAggregatableColumns();
    const allColumns = adaptable.api.columnApi.getUIAvailableColumns();
    const numberColumns = adaptable.api.columnApi.getNumericColumns();
    const allAggregatableColumnIds = allAggregableColumns.map((col)=>col.columnId);
    (layout.TableAggregationColumns || []).forEach((agg)=>{
        // we need to also display the columns currently aggregated,
        // even if they are not aggregatable
        if (!allAggregatableColumnIds.includes(agg.ColumnId)) allAggregatableColumnIds.push(agg.ColumnId);
    });
    const sortedAggregableColumns = (0, $9g4SS.default).sortArrayWithOrder(allAggregatableColumnIds, (layout.TableAggregationColumns ?? []).map((agg)=>agg.ColumnId), {
        sortUnorderedItems: false
    }).map((colId)=>adaptable.api.columnApi.getColumnWithColumnId(colId)).filter(Boolean);
    const handleColumnsSelectionChange = $acw62.useCallback((columnIds)=>{
        const currentAggsMap = (layout.TableAggregationColumns || []).reduce((acc, { ColumnId: ColumnId, AggFunc: AggFunc })=>{
            acc[ColumnId] = AggFunc;
            return acc;
        }, {});
        props.onChange({
            ...layout,
            TableAggregationColumns: columnIds.map((colId)=>{
                const AggFunc = currentAggsMap[colId] ?? adaptable.api.columnApi.getDefaultAggFunc(colId);
                return {
                    ColumnId: colId,
                    AggFunc: AggFunc
                };
            })
        });
    }, [
        layout
    ]);
    const handleAggregationChange = $acw62.useCallback((aggFunctions)=>{
        props.onChange({
            ...layout,
            TableAggregationColumns: aggFunctions
        });
    }, [
        layout
    ]);
    const aggregationColumnsMap = $acw62.useMemo(()=>{
        const allColumnsMap = allColumns.reduce((acc, col)=>{
            acc[col.columnId] = col;
            return acc;
        }, {});
        return (layout.TableAggregationColumns || []).reduce((acc, { ColumnId: colId, AggFunc: AggFunc })=>{
            let fn = AggFunc;
            let fnName = '';
            if (typeof fn === 'boolean') fnName = allColumnsMap[colId].aggregationFunction;
            if (typeof fn === 'object' && fn.type === 'weightedAverage') fnName = $16126ed5a1737acc$var$WEIGHTED_AVERAGE_AGG_FN_NAME;
            else if (typeof fn === 'string') fnName = fn;
            acc[colId] = fnName;
            return acc;
        }, {});
    }, [
        layout
    ]);
    const handleSuppressAggFuncInHeader = (checked)=>{
        props.onChange({
            ...layout,
            SuppressAggFuncInHeader: checked
        });
    };
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        style: {
            height: '100%'
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column Aggregations"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: 'Omit Aggregation from Header'
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: layout.SuppressAggFuncInHeader,
        onChange: handleSuppressAggFuncInHeader
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: 'Grand Total Row'
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        style: {
            width: 160
        },
        options: [
            'top',
            'bottom',
            'pinnedTop',
            'pinnedBottom'
        ].map((position)=>{
            return {
                label: (0, $9OAZF.default).CamelCaseToHumanText(position),
                value: position
            };
        }),
        placeholder: "Off",
        value: layout.GrandTotalRow,
        onChange: (value)=>{
            props.onChange({
                ...layout,
                GrandTotalRow: value
            });
        },
        isClearable: true
    })))), $acw62.createElement((0, $d2ae5bba8d7d6225$export$98c0468e3210506e), {
        showFilterInput: true,
        filter: (0, $87d846d33c010e0a$export$fc20acf56d163798),
        toIdentifier: (option)=>`${option.columnId}`,
        toLabel: (option)=>option.friendlyName ?? option.columnId,
        toListLabel: (column)=>$acw62.createElement($16126ed5a1737acc$var$ColumnRow, {
                onChangeAggFunction: handleAggregationChange,
                layout: layout,
                column: column,
                aggregationColumnsMap: aggregationColumnsMap,
                numberColumns: numberColumns
            }),
        options: sortedAggregableColumns,
        value: (layout.TableAggregationColumns || []).map((agg)=>agg.ColumnId),
        allowReorder: ()=>true,
        onChange: handleColumnsSelectionChange
    })));
};



var $acw62 = parcelRequire("acw62");



const $eed764d6d91a84f2$export$a6f14328ab10ee65 = (layout, api)=>{
    const columnIdToFriendlyName = (columnId)=>{
        return api.columnApi.getFriendlyNameForColumnId(columnId);
    };
    return {
        name: 'Sort',
        values: (layout.ColumnSorts ?? []).map((customSort)=>`[${columnIdToFriendlyName(customSort.ColumnId)}: ${customSort.SortOrder}]`)
    };
};







var $9g4SS = parcelRequire("9g4SS");

const $1e5f9dd65a8ec154$export$ce4443f8aa54143 = ()=>{
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const sortViewItems = (0, $eed764d6d91a84f2$export$a6f14328ab10ee65)(layout, adaptable.api);
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, sortViewItems.values.length ? sortViewItems.values.map((value)=>$acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
            key: value,
            className: "twa:mb-1 twa:mr-1"
        }, value)) : $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "No Sorts"));
};
const $1e5f9dd65a8ec154$var$ColumnRow = (props)=>{
    const SortOrder = (props.layout?.ColumnSorts ?? []).find((sort)=>sort.ColumnId === props.column.columnId)?.SortOrder;
    const icon = SortOrder === 'Asc' ? 'sort-asc' : 'sort-desc';
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, props.column.friendlyName, SortOrder && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        className: "twa:ml-2",
        onClick: ()=>props.onSortChange(props.column.columnId, SortOrder === 'Asc' ? 'Desc' : 'Asc'),
        variant: "raised",
        icon: icon
    }));
};
const $1e5f9dd65a8ec154$export$e5447ffaa0544e07 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const allSortableColumns = adaptable.api.columnApi.getSortableColumns();
    const sortedSortColumns = $acw62.useMemo(()=>{
        return (0, $9g4SS.default).sortArrayWithOrder(allSortableColumns.map((col)=>col.columnId), (layout.ColumnSorts ?? []).map((sort)=>sort.ColumnId), {
            sortUnorderedItems: false
        }).map((colId)=>adaptable.api.columnApi.getColumnWithColumnId(colId));
    }, [
        layout,
        allSortableColumns
    ]);
    const handleColumnsSelectionChange = $acw62.useCallback((columnIds)=>{
        props.onChange({
            ...layout,
            ColumnSorts: (columnIds || []).map((columnId)=>{
                const SortOrder = layout.ColumnSorts?.find((sort)=>sort.ColumnId === columnId)?.SortOrder ?? 'Asc';
                return {
                    ColumnId: columnId,
                    SortOrder: SortOrder
                };
            })
        });
    }, [
        layout
    ]);
    const handleSortChange = $acw62.useCallback((columnId, SortOrder)=>{
        props.onChange({
            ...layout,
            ColumnSorts: layout.ColumnSorts?.map((sort)=>{
                if (sort.ColumnId === columnId) return {
                    ...sort,
                    SortOrder: SortOrder
                };
                return sort;
            })
        });
    }, [
        layout
    ]);
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column Sorts"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $d2ae5bba8d7d6225$export$98c0468e3210506e), {
        showFilterInput: true,
        filter: (0, $87d846d33c010e0a$export$fc20acf56d163798),
        toIdentifier: (option)=>`${option.columnId}`,
        toLabel: (option)=>option.friendlyName ?? option.columnId,
        toListLabel: (column)=>$acw62.createElement($1e5f9dd65a8ec154$var$ColumnRow, {
                onSortChange: handleSortChange,
                layout: layout,
                column: column
            }),
        options: sortedSortColumns,
        value: (layout.ColumnSorts ?? []).map((sort)=>sort.ColumnId),
        allowReorder: ()=>true,
        onChange: handleColumnsSelectionChange
    })));
};



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



const $52184ede7cf4a09d$export$6c2dcda0a6ef7fa6 = (props)=>{
    const { ConfirmAction: ConfirmAction, ConfirmationMsg: ConfirmationMsg, ConfirmationTitle: ConfirmationTitle, onClickAction: onClickAction, onConfirmWarning: onConfirmWarning, ...restProps } = props;
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const dispatchConfirmation = (confirmation)=>{
        dispatch($dc56b6267ce4d0bb$export$93a4701be822446e(confirmation));
        onConfirmWarning?.(confirmation);
    };
    const onClick = ()=>{
        if (ConfirmAction) {
            let confirmation = {
                CancelButtonText: 'Cancel',
                Header: ConfirmationTitle,
                Msg: ConfirmationMsg,
                ConfirmButtonText: 'Delete',
                CancelAction: null,
                ConfirmAction: ConfirmAction,
                ShowInputBox: false,
                MessageType: 'Warning'
            };
            dispatchConfirmation(confirmation);
        } else onClickAction?.();
    };
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "delete",
        tooltip: props.tooltip ?? 'Delete',
        variant: "text",
        icon: "delete",
        iconSize: props.iconSize ?? 24,
        ...restProps,
        onClick: ()=>onClick()
    });
};



var $acw62 = parcelRequire("acw62");

const $c98867b89f88548d$export$f8a35005a0ddce8d = (props)=>{
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "edit",
        tooltip: "Edit",
        variant: "text",
        icon: "edit",
        iconSize: props.iconSize ?? 24,
        ...props
    });
};



var $acw62 = parcelRequire("acw62");



var $9OAZF = parcelRequire("9OAZF");


var $acw62 = parcelRequire("acw62");





const $28e72ece2436ca25$export$9f0ea909a6963ebf = (props)=>{
    const { showPopup: showPopup, onClose: onClose, onConfirm: onConfirm, header: header } = props;
    const [config, setConfig] = (0, $acw62.useState)({
        description: '',
        type: 'Snapshot'
    });
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
        modal: true,
        "data-name": "teamsharing-popup",
        isOpen: showPopup,
        onDismiss: onClose,
        autoFocus: false,
        showCloseButton: false,
        className: "twa:min-h-auto twa:max-w-1/2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        "data-name": "teamsharing-popup-description",
        className: "twa:m-2 twa:mb-2 twa:p-2 twa:text-3"
    }, "Create a ", header, " which may be either:", $acw62.createElement("ul", null, $acw62.createElement("li", null, $acw62.createElement("strong", null, "Snapshot"), ": a one-off share of an exact copy of the current object"), $acw62.createElement("li", null, $acw62.createElement("strong", null, "Active"), ": a \"live\" share that is automatically updated with every local change"))), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name: "
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "teamsharing-entity-name",
        autoFocus: true,
        value: config.description,
        type: "string",
        className: "twa:w-[300px]",
        placeholder: "Enter text",
        onChange: (e)=>setConfig({
                ...config,
                description: e.target.value
            })
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Share: "
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "teamsharing-entity-type-snapshot",
        checked: config.type === 'Snapshot',
        onChange: ()=>setConfig({
                ...config,
                type: 'Snapshot'
            })
    }, "Snapshot"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "teamsharing-entity-type-active",
        className: "twa:ml-3",
        checked: config.type === 'Active',
        onChange: ()=>setConfig({
                ...config,
                type: 'Active'
            })
    }, "Active")))), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "cancel",
        tone: "neutral",
        variant: "raised",
        onClick: ()=>onClose()
    }, "Cancel"), $acw62.createElement("div", {
        className: "twa:flex-1"
    }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "ok",
        tone: "accent",
        variant: "raised",
        disabled: (0, $9OAZF.StringExtensions).IsNullOrEmpty(config.description),
        onClick: ()=>onConfirm(config)
    }, "OK"))))));
};


class $edec82ffbc782b9b$export$a23f4382c2d967e8 extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            open: false
        };
    }
    render() {
        const { onShare: onShare, Header: Header, ...buttonProps } = this.props;
        return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "share",
            tooltip: "Share",
            variant: "text",
            icon: "folder-shared",
            iconSize: buttonProps.iconSize ?? 24,
            onClick: ()=>this.setState({
                    open: true
                }),
            ...buttonProps
        }), this.state.open && $acw62.createElement((0, $28e72ece2436ca25$export$9f0ea909a6963ebf), {
            header: Header,
            showPopup: true,
            onClose: ()=>this.setState({
                    open: false
                }),
            onConfirm: (config)=>{
                this.setState({
                    open: false
                });
                onShare(config);
            }
        }));
    }
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



const $c367b4f7d2ae39ea$export$d2b052e7b4be1756 = ({ checked: checked, onChange: onChange, disabled: disabled, className: className, children: children, style: style = {}, 'data-name': dataName })=>{
    const isChecked = Boolean(checked);
    const handleChange = (event)=>{
        if (disabled) return;
        onChange(Boolean(event.target.checked));
    };
    const baseClassName = 'ab-ToggleButton';
    const preparedClassName = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(baseClassName, 'twa:group twa:outline-0', 'twa:select-none twa:relative twa:inline-block', 'twa:min-w-[40px]', 'twa:min-h-input', 'twa:w-[77px]', {
        [`${baseClassName}--checked`]: isChecked,
        [`${baseClassName}--disabled`]: disabled,
        'twa:hover:cursor-pointer twa:hover:opacity-85': !disabled
    }, className);
    return $acw62.createElement("label", {
        "data-checked": isChecked,
        "data-name": dataName,
        style: style,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(preparedClassName)
    }, $acw62.createElement("input", {
        type: "checkbox",
        disabled: disabled,
        checked: isChecked,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`${baseClassName}__input`, 'twa:opacity-0 twa:size-0'),
        onChange: handleChange
    }), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        "data-checked": isChecked,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`${baseClassName}__slider`, 'twa:group:focus-within:ring-1 twa:group-focus-within:shadow-(--ab-focus__box-shadow)', 'twa:absolute twa:inset-0 twa:rounded-standard', {
            'twa:bg-(--ab-cmp-toggle-button__background)': !isChecked,
            'twa:bg-accent': isChecked,
            'twa:justify-start': isChecked,
            'twa:justify-end': !isChecked,
            'twa:opacity-50': disabled
        }, // the :before pseudo element
        'twa:before:absolute twa:before:content-[""] twa:before:size-[24px]', 'twa:before:rounded-standard twa:before:bg-white')
    }, $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`${baseClassName}__text`, 'twa:font-semibold', 'twa:pr-2', 'twa:text-1', {
            'twa:text-(--ab-cmp-toggle-button__color)': !isChecked,
            'twa:text-(--ab-cmp-toggle-button--checked__color)': isChecked,
            'twa:pl-2': isChecked
        })
    }, children)));
};



const $98b612c6852b2eed$export$179ee6bab8da7a40 = $acw62.memo(({ suspendableObject: suspendableObject, onUnSuspend: onUnSuspend, onSuspend: onSuspend, style: style, disabled: disabled, accessLevel: accessLevel, className: className })=>{
    const handleOnChange = $acw62.useCallback((checked)=>{
        if (checked) onUnSuspend(suspendableObject);
        else onSuspend(suspendableObject);
    }, [
        onUnSuspend,
        onSuspend
    ]);
    const preparedDisabled = accessLevel && accessLevel === 'ReadOnly' || disabled;
    const isSuspended = suspendableObject.IsSuspended;
    return $acw62.createElement((0, $c367b4f7d2ae39ea$export$d2b052e7b4be1756), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`ab-SuspendButton`, className),
        "data-name": suspendableObject.IsSuspended ? 'un-suspend' : 'suspend',
        disabled: preparedDisabled,
        style: style,
        onChange: handleOnChange,
        checked: !isSuspended
    }, isSuspended ? 'inactive' : 'active');
});






const $e7b071cd434f710e$var$ICON_SIZE = 26;
const $e7b071cd434f710e$var$LIST_BASE_CLASS_NAME = 'ab-Adaptable-Object-List';
const $e7b071cd434f710e$var$ITEM_BASE_CLASS_NAME = `${$e7b071cd434f710e$var$LIST_BASE_CLASS_NAME}__Item`;
const $e7b071cd434f710e$export$d810b63df9dfddba = (props)=>{
    const baseClassName = $e7b071cd434f710e$var$ITEM_BASE_CLASS_NAME;
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const deleteActionProps = {
        disabled: props.deleteDisabled,
        tooltip: props.deleteTooltip,
        iconSize: $e7b071cd434f710e$var$ICON_SIZE,
        ConfirmationMsg: `Are you sure you want to delete this ${props.entityType}?`,
        ConfirmationTitle: `Delete ${props.entityType}`,
        ConfirmAction: props.deleteAction,
        accessLevel: props.accessLevel
    };
    if (props.disableDeleteConfirmation) {
        deleteActionProps.ConfirmAction = null;
        deleteActionProps.onClickAction = ()=>{
            dispatch(props.deleteAction);
        };
    }
    const deleteActionButton = $acw62.createElement((0, $52184ede7cf4a09d$export$6c2dcda0a6ef7fa6), {
        ...deleteActionProps
    });
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        "data-name": "adaptable-object-list-item",
        "data-value": props.abObject.Uuid,
        as: "li",
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(baseClassName, 'twa:rounded-standard', props.className),
        style: props.style
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: `twa:flex-1 ${baseClassName}__rows twa:gap-2 twa:flex twa:flex-col`
    }, props.items.filter?.(Boolean)?.map((tag, index)=>{
        const labelElement = typeof tag.label === 'function' ? $acw62.createElement(tag.label, {
            key: index,
            data: props.abObject
        }) : tag.label ?? tag.name;
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            "data-name": tag.name,
            key: `${index}-${tag.name}`,
            className: `${baseClassName}__row twa:gap-3`
        }, !tag.isLabelInline && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: `${baseClassName}__label twa:flex twa:items-center twa:flex-row twa:text-nowrap`
        }, labelElement, props.showEditButton && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": `${tag.name}-edit-button`,
            accessLevel: props.accessLevel,
            className: `${baseClassName}__edit-property twa:ml-1`,
            icon: "edit",
            tooltip: "edit",
            iconSize: 18,
            variant: "text",
            onClick: ()=>{
                props.handleOnEdit(tag.name);
            }
        })), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: `twa:flex-1 ${baseClassName}__values`
        }, typeof tag.view === 'function' ? $acw62.createElement(tag.view, {
            data: props.abObject,
            module: props.module
        }) : tag.view, Boolean(tag?.values && tag?.values?.length) ? $acw62.createElement((0, $3283d8fe16778b21$export$f9fef0f55402315b), {
            tags: tag.values.map(String)
        }) : null, typeof tag.viewAfter === 'function' ? $acw62.createElement(tag.viewAfter, {
            data: props.abObject,
            module: props.module
        }) : tag.viewAfter));
    })), props.showActions && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: `${baseClassName}__buttons twa:ml-3 twa:pl-3 twa:text-right twa:min-w-[80px]`
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:justify-end"
    }, props.actions, props.teamSharingActivated && $acw62.createElement((0, $edec82ffbc782b9b$export$a23f4382c2d967e8), {
        iconSize: $e7b071cd434f710e$var$ICON_SIZE,
        Header: `TeamSharing ${props.entityType}`,
        accessLevel: props.accessLevel,
        onShare: props.onShare
    }), props.onDelete && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "delete",
        disabled: props.deleteDisabled,
        iconSize: $e7b071cd434f710e$var$ICON_SIZE,
        tooltip: props.deleteTooltip,
        icon: "delete",
        onClick: props.onDelete,
        variant: "text"
    }), props.deleteAction ? deleteActionButton : null, props.showEditButton && $acw62.createElement((0, $c98867b89f88548d$export$f8a35005a0ddce8d), {
        iconSize: $e7b071cd434f710e$var$ICON_SIZE,
        disabled: props.editDisabled,
        accessLevel: props.accessLevel,
        onClick: ()=>props.handleOnEdit()
    })), props.suspendedEnabled && $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1 twa:min-h-[20px]"
    }), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:justify-end"
    }, $acw62.createElement((0, $98b612c6852b2eed$export$179ee6bab8da7a40), {
        onSuspend: props.onSuspend,
        onUnSuspend: props.onUnSuspend,
        suspendableObject: props.abObject,
        accessLevel: props.accessLevel
    })))));
};
const $e7b071cd434f710e$export$6fb29754fafb7fb1 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [isEditWizardVisible, setIsEditWizardVisible] = $acw62.useState(false);
    const [wizardStepName, setWizardStepName] = $acw62.useState(null);
    const viewOptions = props.module?.getViewProperties?.() ?? {};
    const EditWizard = viewOptions.getEditWizard?.(props.data.abObject);
    const deleteAction = viewOptions?.getDeleteAction?.(props.data.abObject);
    const isObjectShareable = props.module.isModuleObjectsShareable();
    const teamSharingActivated = isObjectShareable && adaptable.api.teamSharingApi.isTeamSharingAvailable() && adaptable.api.teamSharingApi.hasTeamSharingFullRights();
    const entityType = props.module.moduleInfo.FriendlyName;
    const moduleAccessLevel = adaptable.api.entitlementApi.getEntitlementAccessLevelForModule(props.module.moduleInfo.ModuleName);
    const accessLevel = (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).getAccessLevelForObject(props.data.abObject, moduleAccessLevel);
    const itemClassName = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(props.className, props.data.className, $e7b071cd434f710e$var$ITEM_BASE_CLASS_NAME, props.data.abObject.IsSuspended && `${$e7b071cd434f710e$var$ITEM_BASE_CLASS_NAME}--is-suspended`);
    const handleCloseWizard = $acw62.useCallback(()=>{
        setIsEditWizardVisible(false);
        setWizardStepName(null);
    }, []);
    const handleOnEdit = $acw62.useCallback((sectionName)=>{
        if (EditWizard) {
            setIsEditWizardVisible(true);
            if (sectionName) setWizardStepName(sectionName);
        }
        viewOptions?.onOpenEditPopup?.(props.data.abObject);
    }, []);
    const hasSuspend = Boolean(viewOptions.getSuspendAction);
    const actions = viewOptions?.actions?.map?.((component, index)=>{
        return $acw62.createElement(component, {
            data: props.data.abObject,
            key: index,
            accessLevel: accessLevel
        });
    });
    const isEditDisabled = !Boolean(EditWizard || viewOptions.onOpenEditPopup);
    const showActions = !props.hideControls;
    const showEditButton = Boolean(EditWizard);
    const adaptableOpttions = adaptable.api.optionsApi.getAdaptableOptions();
    const disableDeleteConfirmationState = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((adaptableState)=>$5b564bb703f29152$export$b8c502323af02429(adaptableState.Internal));
    const disableDeleteConfirmation = disableDeleteConfirmationState || adaptableOpttions?.userInterfaceOptions?.disableDeleteConfirmation;
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement($e7b071cd434f710e$export$d810b63df9dfddba, {
        module: props.module,
        disableDeleteConfirmation: disableDeleteConfirmation,
        abObject: props.data.abObject,
        accessLevel: accessLevel,
        actions: actions,
        className: itemClassName,
        handleOnEdit: handleOnEdit,
        items: props.data.items,
        showActions: showActions,
        showEditButton: showEditButton,
        style: props.data.style,
        teamSharingActivated: teamSharingActivated,
        onShare: (config)=>adaptable.api.teamSharingApi.shareAdaptableEntity(props.data.abObject, props.module.moduleInfo.ModuleName, config),
        entityType: entityType,
        deleteAction: deleteAction,
        deleteDisabled: props.deleteDisabled,
        deleteTooltip: props.deleteTooltip,
        editDisabled: isEditDisabled,
        suspendedEnabled: hasSuspend,
        onSuspend: ()=>dispatch(viewOptions.getSuspendAction(props.data.abObject)),
        onUnSuspend: ()=>dispatch(viewOptions.getUnSuspendAction(props.data.abObject))
    }), isEditWizardVisible && EditWizard && $acw62.createElement(EditWizard, {
        defaultCurrentSectionName: wizardStepName,
        moduleInfo: props.module.moduleInfo,
        data: props.data.abObject,
        configEntities: null,
        onCloseWizard: handleCloseWizard,
        onFinishWizard: handleCloseWizard
    }));
};
const $e7b071cd434f710e$export$52f2aa84838d2a04 = (props)=>{
    return $acw62.createElement("ul", {
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)((0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($e7b071cd434f710e$var$LIST_BASE_CLASS_NAME, 'twa:list-none twa:p-0 twa:gap-3 twa:flex twa:flex-col', props.className))
    }, props?.items?.map((item, index)=>$acw62.createElement($e7b071cd434f710e$export$6fb29754fafb7fb1, {
            key: item.abObject.Uuid ?? index,
            data: item,
            module: props.module,
            ...props.itemProps
        })));
};





var $acw62 = parcelRequire("acw62");




const $e9afb45e74c9ce75$export$932cc2dc7d945b27 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const column = api.columnApi.getColumnWithColumnId(props.columnFilter.ColumnId);
    const columnFilterOptions = api.optionsApi.getFilterOptions().columnFilterOptions;
    const predicateDefs = api.filterApi.columnFilterApi.getFilterPredicateDefsForColumn(column);
    const qlDataType = (0, $47be09cb14df4bdb$export$d252517300e3b104)(column.dataType);
    const qlPredicateDefs = predicateDefs.map((predDef)=>(0, $5b60d09ab87a9230$export$2a3e9a3fb4fb4111)(predDef, qlDataType));
    const qlPredicate = (0, $5b60d09ab87a9230$export$685906aad993c4d6)(props.columnFilter, column, qlPredicateDefs, columnFilterOptions, 'FilterForm', api);
    const handlePredicateChange = (newPredicate)=>{
        const newAdaptablePredicates = newPredicate.args.map((0, $5b60d09ab87a9230$export$acf229288e9f8eb6));
        const newFilter = {
            ...props.columnFilter,
            ColumnId: props.columnFilter.ColumnId,
            Predicates: newAdaptablePredicates,
            PredicatesOperator: newPredicate.operator
        };
        props.onColumnFilterChange(newFilter);
    };
    return $acw62.createElement((0, $82b30489994e43b2$export$dd1ed8f779a4000b), {
        location: 'filterForm',
        columnId: props.columnFilter.ColumnId,
        predicate: qlPredicate,
        predicateDefs: qlPredicateDefs,
        disabled: props.columnFilter?.IsSuspended,
        onPredicateChange: handlePredicateChange,
        hideActionButtons: true
    });
};



const $68233238767ebee7$export$42db22e5907a03d = (layout)=>{
    const invalidColumnFilters = (layout.ColumnFilters ?? [])?.filter((columnFilter)=>!columnFilter?.Predicates[0]?.PredicateId);
    if (invalidColumnFilters.length > 0) return 'Please select a predicate for each column filter.';
    return true;
};
const $68233238767ebee7$export$4bc516e1957a3b64 = ()=>{
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const fitlerViewItems = (0, $6a7ec5df7bac55db$export$4b152704e0654386)(layout, adaptable.api);
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, fitlerViewItems.values.length ? fitlerViewItems.values.map((value)=>$acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
            key: value,
            className: "twa:mb-1 twa:mr-1"
        }, value)) : $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "No Column Filters"));
};
const $68233238767ebee7$export$4c5b17bfcbab1742 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const filterModule = adaptable.ModuleService.getModuleById($42e863194fcb493f$export$edfe19743c8e0917);
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const layoutFilters = layout.ColumnFilters ?? [];
    const handleDelete = $acw62.useCallback((columnFilter)=>{
        props.onChange({
            ...layout,
            ColumnFilters: layoutFilters.filter((layoutFilter)=>layoutFilter.ColumnId !== columnFilter.ColumnId)
        });
    }, [
        layout
    ]);
    const handlePredicateEdit = $acw62.useCallback((columnFilter)=>{
        props.onChange({
            ...layout,
            ColumnFilters: layoutFilters.map((layoutFilter)=>layoutFilter.ColumnId === columnFilter.ColumnId ? {
                    ...columnFilter
                } : layoutFilter)
        });
    }, [
        layout.ColumnFilters
    ]);
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column Filters"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:mb-2"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Add Column Filter"
    }, $acw62.createElement((0, $568d00bde2c337b2$export$e5d989eba9e871bb), {
        filterColumn: (column)=>column.filterable && !layoutFilters.some((f)=>f.ColumnId === column.columnId),
        placeholder: "Select Column to create Filter",
        onChange: (option)=>{
            props.onChange({
                ...layout,
                ColumnFilters: [
                    ...layoutFilters,
                    {
                        ColumnId: option,
                        Predicates: []
                    }
                ]
            });
        }
    }))), layoutFilters?.length > 0 && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-0",
        as: "ul"
    }, layoutFilters.map((columnFilter)=>{
        const items = [
            ...filterModule.toView(columnFilter).items,
            {
                name: 'Column Filter',
                view: $acw62.createElement((0, $e9afb45e74c9ce75$export$932cc2dc7d945b27), {
                    columnFilter: columnFilter,
                    onColumnFilterChange: (columnFilter)=>{
                        handlePredicateEdit(columnFilter);
                    }
                })
            }
        ];
        return $acw62.createElement((0, $e7b071cd434f710e$export$d810b63df9dfddba), {
            module: filterModule,
            abObject: columnFilter,
            entityType: "Column Filter",
            showActions: true,
            showEditButton: false,
            items: items,
            onDelete: ()=>handleDelete(columnFilter),
            key: columnFilter.ColumnId
        });
    }))));
};



var $acw62 = parcelRequire("acw62");






var $9OAZF = parcelRequire("9OAZF");


const $7f8d795f7acb537a$export$6925559d9f6d88bf = (layout, api)=>{
    const expression = layout?.GridFilter?.Expression;
    if ((0, $9OAZF.default).IsNullOrEmpty(expression)) return true;
    return api.internalApi.getQueryLanguageService().validateBoolean(expression, (0, $42e863194fcb493f$export$4908330cb20abb96)).isValid || 'The expression is not valid.';
};
const $7f8d795f7acb537a$export$7179dd1dec452dc0 = ()=>{
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
        className: "twa:mb-1 twa:mr-1"
    }, layout?.GridFilter?.Expression ?? 'No Grid Filter'));
};
const $7f8d795f7acb537a$export$97a01d537be95af = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const initialData = $acw62.useMemo(()=>api.internalApi.getQueryPreviewData(), []);
    const expressionEditorProps = (0, $2f3f4595a0bb253f$export$4fbc2a914da22bb)();
    const expressionEditorContent = $acw62.createElement((0, $5e4c4ab15f4fe7da$export$6f88ab97c822f23a), {
        ...expressionEditorProps,
        allowSaveNamedQuery: false,
        type: 'boolean',
        module: (0, $42e863194fcb493f$export$4908330cb20abb96),
        value: layout?.GridFilter?.Expression ?? '',
        onChange: (expression)=>{
            props.onChange({
                ...layout,
                GridFilter: {
                    ...layout.GridFilter,
                    Expression: expression
                }
            });
        },
        initialData: initialData,
        columns: api.columnApi.internalApi.getQueryableColumnsForUIEditor(),
        fields: api.expressionApi.internalApi.getAvailableFields(),
        namedQueries: api.namedQueryApi.getNamedQueries(),
        api: api
    });
    return $acw62.createElement("div", null, expressionEditorContent);
};



var $acw62 = parcelRequire("acw62");



















var $9g4SS = parcelRequire("9g4SS");

const $a3369eecb7da45e3$export$1ce60cfc21866493 = (layout)=>{
    if (!layout.RowSummaries) return true;
    let valid = true;
    layout.RowSummaries?.find((rowSummary)=>{
        for (const [_, fn] of Object.entries(rowSummary.ColumnsMap ?? {}))if (!fn) {
            valid = 'Each row summary column requires an aggregation function.';
            return true;
        }
    });
    return valid;
};
const $a3369eecb7da45e3$var$availableExpressionsForColumnTypeCache = new Map();
const $a3369eecb7da45e3$var$getAvailableExpressionsForColumnType = (columnType, availableScalarExpressions)=>{
    const key = columnType;
    if ($a3369eecb7da45e3$var$availableExpressionsForColumnTypeCache.has(key)) return $a3369eecb7da45e3$var$availableExpressionsForColumnTypeCache.get(key);
    const columnInputType = (0, $47be09cb14df4bdb$export$d252517300e3b104)(columnType);
    const expressions = Object.keys(availableScalarExpressions).filter((availableExpression)=>{
        if (!(0, $3c4f25bf4245f8cf$export$73c5bd56d38465fb).includes(availableExpression)) // is custom
        return true;
        return Boolean((0, $a22f97369f02628d$export$d7397d3f42b8dd61).includes(availableExpression));
    }).map((expression)=>{
        const expressionDef = availableScalarExpressions[expression];
        let firstArg = null;
        // filter out expressions without inputs defined
        if (!expressionDef?.inputs) return null;
        if (Array.isArray(expressionDef?.inputs?.[0])) // @ts-ignore
        firstArg = expressionDef.inputs.find((input)=>input.includes(columnInputType))?.[0];
        else firstArg = expressionDef.inputs[0];
        if (columnInputType === firstArg) return expression;
        else return null;
    }).filter(Boolean);
    $a3369eecb7da45e3$var$availableExpressionsForColumnTypeCache.set(key, expressions);
    return expressions;
};
const $a3369eecb7da45e3$export$2913ae5e45ff0b08 = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex twa:flex-col"
    }, layout.RowSummaries?.length ? layout.RowSummaries.map((rowSummary, index)=>{
        return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mr-1 twa:mb-1",
            key: index
        }, rowSummary.Position, ":", ' ', Object.keys(rowSummary.ColumnsMap).map((colId)=>{
            if (colId === 'Source' || colId === 'Uuid') return null;
            return $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
                className: "twa:mr-1",
                key: colId
            }, rowSummary.ColumnsMap[colId], "(", adaptable.api.columnApi.getFriendlyNameForColumnId(colId), ")");
        })));
    }) : $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "No Row Summaries"));
};
const $a3369eecb7da45e3$var$RowSummaryEditor = $acw62.memo(({ rowSummary: rowSummary, onChange: onChange, availableScalarExpressions: availableScalarExpressions, onDelete: onDelete })=>{
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const columns = $acw62.useMemo(()=>{
        const colIds = adaptable.api.columnApi.getUIAvailableColumns().filter((column)=>{
            if (![
                'number',
                'text',
                'date'
            ].includes(column.dataType)) return false;
            return layout.TableColumns?.includes?.(column.columnId);
        }).map((c)=>c.columnId);
        return (0, $9g4SS.default).sortArrayWithOrder(colIds, Object.keys(rowSummary.ColumnsMap), {
            sortUnorderedItems: false
        }).map((colId)=>adaptable.api.columnApi.getColumnWithColumnId(colId));
    }, [
        rowSummary.ColumnsMap
    ]);
    return $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        header: $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:w-full"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:flex-1",
            alignItems: "center"
        }, "Row Summary"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mr-2"
        }, $acw62.createElement((0, $98b612c6852b2eed$export$179ee6bab8da7a40), {
            onSuspend: ()=>{
                onChange({
                    ...rowSummary,
                    IsSuspended: true
                });
            },
            onUnSuspend: ()=>{
                onChange({
                    ...rowSummary,
                    IsSuspended: false
                });
            },
            suspendableObject: rowSummary
        })), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            icon: "delete",
            onClick: ()=>{
                onDelete();
            }
        })),
        className: "twa:p-2"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Position"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        options: [
            {
                label: 'Top',
                value: 'Top'
            },
            {
                label: 'Bottom',
                value: 'Bottom'
            }
        ],
        value: rowSummary.Position,
        onChange: (position)=>{
            onChange({
                ...rowSummary,
                Position: position
            });
        }
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: rowSummary.IncludeOnlyFilteredRows ?? true,
        onChange: (IncludeOnlyFilteredRows)=>{
            onChange({
                ...rowSummary,
                IncludeOnlyFilteredRows: IncludeOnlyFilteredRows
            });
        }
    }, "Include Only Filtered Rows"))), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:mt-2 twa:mb-1"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:flex-1 twa:mb-2"
    }, "Column Aggregations"), $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        bodyProps: {
            className: 'twa:max-h-full '
        },
        className: "twa:h-[360px]"
    }, $acw62.createElement((0, $d2ae5bba8d7d6225$export$98c0468e3210506e), {
        style: {
            maxHeight: '100%'
        },
        showFilterInput: true,
        filter: (0, $87d846d33c010e0a$export$fc20acf56d163798),
        toIdentifier: (column)=>column.columnId,
        toLabel: (option)=>option.friendlyName ?? option.columnId,
        options: columns,
        toListLabel: (column)=>{
            const label = column.friendlyName ?? column.columnId;
            if (!(column.columnId in (rowSummary.ColumnsMap ?? {}))) return label;
            const expressionOptions = $a3369eecb7da45e3$var$getAvailableExpressionsForColumnType(column.dataType, availableScalarExpressions).map((expression)=>({
                    label: expression,
                    value: expression
                }));
            // check out if this layout has a aggregation with weighted column
            const aggregation = layout.TableAggregationColumns?.find((agg)=>agg.ColumnId === column.columnId)?.AggFunc;
            if (aggregation && typeof aggregation === 'object' && aggregation.weightedColumnId) expressionOptions.push({
                label: 'WEIGHTERD_AVG',
                value: (0, $a22f97369f02628d$export$3a87fe7386ef35df)
            });
            const expression = rowSummary.ColumnsMap[column.columnId];
            return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                className: "twa:mr-2",
                alignItems: 'center'
            }, label), $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
                value: expression,
                options: expressionOptions,
                onChange: (expression)=>{
                    onChange({
                        ...rowSummary,
                        ColumnsMap: {
                            ...rowSummary.ColumnsMap,
                            [column.columnId]: expression
                        }
                    });
                }
            }));
        },
        value: Object.keys(rowSummary.ColumnsMap),
        onChange: (colIds)=>{
            const newColumnsMap = {};
            colIds.forEach((colId)=>{
                newColumnsMap[colId] = rowSummary.ColumnsMap[colId] ?? null;
            });
            onChange({
                ...rowSummary,
                ColumnsMap: newColumnsMap
            });
        }
    }))));
});
const $a3369eecb7da45e3$export$8ac52afafdd36739 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const availableScalarExpressions = $acw62.useMemo(()=>{
        const sytemExpressions = adaptable.api.internalApi.getQueryLanguageService().getModuleExpressionFunctionsMap((0, $42e863194fcb493f$export$802bb096eb63f491)).aggregatedScalarFunctions;
        return sytemExpressions;
    }, []);
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        style: {
            height: '100%'
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Row Summaries"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement("div", null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:mb-1"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:flex-1"
    }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onClick: ()=>{
            props.onChange({
                ...layout,
                RowSummaries: [
                    ...layout.RowSummaries ?? [],
                    {
                        Position: 'Top',
                        ColumnsMap: {},
                        IncludeOnlyFilteredRows: true
                    }
                ]
            });
        },
        icon: "plus"
    }, "Add Row Summary")), (layout.RowSummaries ?? []).map((rowSummary, index)=>{
        return $acw62.createElement($a3369eecb7da45e3$var$RowSummaryEditor, {
            key: index,
            onDelete: ()=>{
                const newSummaries = [
                    ...layout.RowSummaries
                ];
                newSummaries.splice(index, 1);
                props.onChange({
                    ...layout,
                    RowSummaries: newSummaries
                });
            },
            availableScalarExpressions: availableScalarExpressions,
            rowSummary: rowSummary,
            onChange: (rowSummary)=>{
                const newSummaries = [
                    ...layout.RowSummaries
                ];
                newSummaries[index] = rowSummary;
                props.onChange({
                    ...layout,
                    RowSummaries: newSummaries
                });
            }
        });
    }))));
};





var $acw62 = parcelRequire("acw62");







var $9g4SS = parcelRequire("9g4SS");



const $19c4fde65a7d4267$export$23fedbd56a6f70fe = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, layout.PivotGroupedColumns?.length ? layout.PivotGroupedColumns.map((columnId)=>{
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mb-2"
        }, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
            key: columnId
        }, adaptable.api.columnApi.getFriendlyNameForColumnId(columnId)));
    }) : $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "No Pivot Row Grouping"));
};
const $19c4fde65a7d4267$export$a0b80b26fafa688e = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const allGroupableColumns = adaptable.api.columnApi.getGroupableColumns();
    const sortedGroupableColumns = $acw62.useMemo(()=>{
        return (0, $9g4SS.default).sortArrayWithOrder(allGroupableColumns.map((col)=>col.columnId), layout.PivotGroupedColumns ?? [], {
            sortUnorderedItems: false
        }).map((colId)=>adaptable.api.columnApi.getColumnWithColumnId(colId));
    }, [
        layout,
        allGroupableColumns
    ]);
    const onChange = (layout)=>{
        props.onChange((0, $702a77ed6db22640$export$d859d72b10c9a984)(layout));
    };
    const handleColumnsChange = (columnIds)=>{
        onChange({
            ...layout,
            PivotGroupedColumns: columnIds
        });
    };
    const rowGroupsText = 'Row Group ' + adaptable.api.internalApi.getCorrectEnglishVariant('Behaviour');
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        style: {
            height: '100%'
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Row Grouped Columns"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, rowGroupsText), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $d2ae5bba8d7d6225$export$98c0468e3210506e), {
        showFilterInput: true,
        filter: (0, $87d846d33c010e0a$export$fc20acf56d163798),
        toIdentifier: (option)=>`${option.columnId}`,
        toLabel: (option)=>option.friendlyName ?? option.columnId,
        options: sortedGroupableColumns,
        value: layout.PivotGroupedColumns ?? [],
        allowReorder: true,
        onChange: handleColumnsChange
    })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $b0210f4bbba14d75$export$38837982e84e2a1c), {
        layout: layout,
        onChange: onChange
    })));
};



var $acw62 = parcelRequire("acw62");











var $9g4SS = parcelRequire("9g4SS");

var $9OAZF = parcelRequire("9OAZF");


const $f8eb7d60c05d4406$var$PivotColumnRow = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const aggValue = (props.layout.PivotAggregationColumns || []).find((x)=>x.ColumnId === props.column.columnId)?.AggFunc;
    const adaptableAggFunctions = [];
    if (props.column.dataType === 'number') adaptableAggFunctions.push((0, $8b34480a73f8989d$export$cddc429232233701));
    const aggOptions = [
        ...props.column.availableAggregationFunctions,
        ...adaptableAggFunctions
    ].map((fnName)=>{
        return {
            label: fnName,
            onClick: ()=>{
                let aggCols = props.layout.PivotAggregationColumns || [];
                if (!aggCols) return;
                const AggFuncValue = fnName === (0, $8b34480a73f8989d$export$cddc429232233701) ? {
                    type: 'weightedAverage',
                    weightedColumnId: null
                } : fnName;
                let found = false;
                aggCols = aggCols.map(({ ColumnId: ColumnId, AggFunc: AggFunc })=>{
                    if (ColumnId === props.column.columnId) {
                        found = true;
                        return {
                            ColumnId: ColumnId,
                            AggFunc: AggFuncValue
                        };
                    }
                    return {
                        ColumnId: ColumnId,
                        AggFunc: AggFunc
                    };
                });
                if (!found) aggCols.push({
                    ColumnId: props.column.columnId,
                    AggFunc: AggFuncValue
                });
                props.onChangeAggFunction(aggCols);
            }
        };
    });
    const numericColumnsOptions = props.numberColumns.filter((col)=>col.columnId !== props.column.columnId).map((col)=>{
        return {
            label: col.friendlyName,
            onClick: ()=>{
                let aggCols = props.layout.PivotAggregationColumns;
                if (!aggCols) return;
                const AggFuncValue = {
                    type: 'weightedAverage',
                    weightedColumnId: col.columnId
                };
                let found = false;
                aggCols = aggCols.map(({ ColumnId: ColumnId, AggFunc: AggFunc })=>{
                    if (ColumnId === props.column.columnId) {
                        found = true;
                        return {
                            ColumnId: ColumnId,
                            AggFunc: AggFuncValue
                        };
                    }
                    return {
                        ColumnId: ColumnId,
                        AggFunc: AggFunc
                    };
                });
                if (!found) aggCols.push({
                    ColumnId: props.column.columnId,
                    AggFunc: AggFuncValue
                });
                props.onChangeAggFunction(aggCols);
            }
        };
    });
    const currentAggFnName = props.aggregationColumnsMap[props.column.columnId];
    let weightName = null;
    if (typeof aggValue === 'object' && aggValue.type === 'weightedAverage') weightName = aggValue.weightedColumnId ? adaptable.api.columnApi.getFriendlyNameForColumnId(aggValue.weightedColumnId) : 'Select Weight';
    const totalOptions = [
        'Off',
        'Before',
        'After',
        'Pivot Specific'
    ].map((totalVariant)=>{
        return {
            label: totalVariant,
            onClick: ()=>{
                let aggCols = props.layout.PivotAggregationColumns;
                if (!aggCols) return;
                aggCols = aggCols.map((aggCol)=>{
                    if (aggCol.ColumnId === props.column.columnId) {
                        let updatedTotalColumn = false;
                        if (totalVariant === 'Before') updatedTotalColumn = 'before';
                        if (totalVariant === 'After') updatedTotalColumn = 'after';
                        if (totalVariant === 'Pivot Specific') updatedTotalColumn = props.layout.PivotColumns.map((pivotColId)=>{
                            return {
                                PivotColumnId: pivotColId,
                                ShowTotal: true
                            };
                        });
                        return {
                            ...aggCol,
                            Total: updatedTotalColumn
                        };
                    }
                    return aggCol;
                });
                props.onChangeAggFunction(aggCols);
            }
        };
    });
    const currentAggCol = props.layout.PivotAggregationColumns?.find((aggCol)=>aggCol.ColumnId === props.column.columnId);
    const currentTotal = currentAggCol?.Total ? currentAggCol.Total === true || currentAggCol.Total === 'before' ? 'Before' : currentAggCol.Total === 'after' ? 'After' : Array.isArray(currentAggCol.Total) ? 'Pivot Specific' : 'Off' : 'Off';
    const hasPivotSpecificTotals = Array.isArray(currentAggCol?.Total);
    const pivotSpecificTotals = Array.isArray(currentAggCol?.Total) ? currentAggCol.Total : props.layout.PivotColumns?.map((pivotColId)=>({
            PivotColumnId: pivotColId,
            ShowTotal: false
        }));
    const handleTotalChange = (pivotColId, value)=>{
        const updatedAggCols = (props.layout.PivotAggregationColumns || []).map((aggCol)=>{
            if (aggCol.ColumnId === props.column.columnId) {
                const updatedTotals = pivotSpecificTotals.map((total)=>{
                    if (total.PivotColumnId === pivotColId) return {
                        ...total,
                        ShowTotal: value
                    };
                    return total;
                });
                return {
                    ...aggCol,
                    Total: updatedTotals
                };
            }
            return aggCol;
        });
        props.onChangeAggFunction(updatedAggCols);
    };
    const pivotTotalOptions = [
        'Off',
        'Before',
        'After'
    ].map((option)=>({
            label: option,
            value: option === 'Off' ? false : option.toLowerCase()
        }));
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": props.column.columnId,
        className: "ab-Layout-Wizard__ColumnRow"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "flex-start"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:flex-[0_0_auto]",
        alignItems: "center"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:min-w-[80px]"
    }, props.column.friendlyName), aggValue && $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        columns: [
            'label'
        ],
        items: aggOptions,
        className: "twa:ml-2"
    }, currentAggFnName), currentAggFnName === (0, $8b34480a73f8989d$export$cddc429232233701) && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:bg-primary twa:ml-3",
        alignItems: "center"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, "Weight"), ' ', $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        columns: [
            'label'
        ],
        items: numericColumnsOptions,
        className: "twa:ml-2"
    }, weightName)), aggValue && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:bg-primary twa:ml-3",
        alignItems: "center"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, "Total"), ' ', $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        columns: [
            'label'
        ],
        items: totalOptions,
        className: "twa:ml-2"
    }, currentTotal))), hasPivotSpecificTotals && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:ml-2 twa:pl-2 twa:flex-[1_1_auto] twa:min-w-[200px]",
        flexWrap: "wrap",
        alignItems: "center",
        style: {
            borderLeft: '1px solid var(--ab-color-text-on-primary)',
            rowGap: '8px',
            columnGap: '12px'
        }
    }, props.layout.PivotColumns.map((pivotColId)=>{
        const pivotTotalSetting = pivotSpecificTotals.find((t)=>t.PivotColumnId === pivotColId);
        const currentValue = pivotTotalSetting == undefined ? 'Off' : pivotTotalSetting.ShowTotal === false ? 'Off' : pivotTotalSetting.ShowTotal === 'before' || pivotTotalSetting.ShowTotal === true || pivotTotalSetting.ShowTotal == undefined ? 'Before' : pivotTotalSetting.ShowTotal === 'after' ? 'After' : 'Off';
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            key: pivotColId,
            alignItems: "center"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mr-1"
        }, adaptable.api.columnApi.getFriendlyNameForColumnId(pivotColId), ":"), $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
            columns: [
                'label'
            ],
            items: pivotTotalOptions.map((opt)=>({
                    label: opt.label,
                    onClick: ()=>handleTotalChange(pivotColId, opt.value)
                }))
        }, currentValue));
    }))));
};
const $f8eb7d60c05d4406$export$75ba8f07b20ec0c6 = (data)=>{
    const weightedAvg = data.PivotAggregationColumns ? (data.PivotAggregationColumns || []).map((agg)=>agg.AggFunc).find((agg)=>typeof agg === 'object' && agg.type === 'weightedAverage') : null;
    if (weightedAvg && !weightedAvg.weightedColumnId) return 'Weighted Average requires a weight column to be selected.';
    return true;
};
const $f8eb7d60c05d4406$export$be2a0cb72739688 = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const pivotAggregationColumns = layout.PivotAggregationColumns || [];
    let content = null;
    if (pivotAggregationColumns.length) content = $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, pivotAggregationColumns.map(({ ColumnId: colId, AggFunc: aggFunc })=>$acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            key: colId,
            label: adaptable.api.columnApi.getFriendlyNameForColumnId(colId)
        }, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, typeof aggFunc === 'object' ? aggFunc.type : aggFunc))));
    else content = $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "No Pivot Column Aggregations");
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, content);
};
const $f8eb7d60c05d4406$export$bdf05d8709a48bf9 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { data: layout } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const allAggregableColumns = adaptable.api.columnApi.getAggregatableColumns();
    const allColumns = adaptable.api.columnApi.getUIAvailableColumns();
    const numberColumns = adaptable.api.columnApi.getNumericColumns();
    const sortedAggregableColumns = $acw62.useMemo(()=>{
        return (0, $9g4SS.default).sortArrayWithOrder(allAggregableColumns.map((col)=>col.columnId), (layout.PivotAggregationColumns ?? []).map((col)=>col.ColumnId), {
            sortUnorderedItems: false
        }).map((colId)=>adaptable.api.columnApi.getColumnWithColumnId(colId));
    }, [
        layout,
        allAggregableColumns
    ]);
    const handleColumnsSelectionChange = $acw62.useCallback((columnIds)=>{
        const currentAggColumns = layout.PivotAggregationColumns ?? [];
        const PivotAggregationColumns = columnIds.map((colId)=>{
            return {
                ColumnId: colId,
                AggFunc: currentAggColumns.find((x)=>x.ColumnId === colId)?.AggFunc ?? adaptable.api.columnApi.getDefaultAggFunc(colId),
                TotalColumn: currentAggColumns.find((x)=>x.ColumnId === colId)?.Total
            };
        });
        props.onChange({
            ...layout,
            PivotAggregationColumns: PivotAggregationColumns
        });
    }, [
        layout
    ]);
    const handleAggregationChange = $acw62.useCallback((pivotAggregationColumns)=>{
        if (pivotAggregationColumns.some((aggCol)=>aggCol.Total !== false || aggCol.Total !== null)) // if any Aggregation Column has a Total Column, we need to disable the Pivot Group Total Column
        delete layout['PivotColumnTotal'];
        props.onChange({
            ...layout,
            PivotAggregationColumns: pivotAggregationColumns
        });
    }, [
        layout
    ]);
    const aggregationColumnsMap = $acw62.useMemo(()=>{
        const allColumnsMap = allColumns.reduce((acc, col)=>{
            acc[col.columnId] = col;
            return acc;
        }, {});
        return (layout.PivotAggregationColumns || []).reduce((acc, { ColumnId: colId, AggFunc: aggFunc })=>{
            let fn = aggFunc;
            let fnName = '';
            if (typeof fn === 'boolean') fnName = allColumnsMap[colId].aggregationFunction;
            if (typeof fn === 'object' && fn.type === 'weightedAverage') fnName = (0, $8b34480a73f8989d$export$cddc429232233701);
            else if (typeof fn === 'string') fnName = fn;
            acc[colId] = fnName;
            return acc;
        }, {});
    }, [
        layout
    ]);
    const handleSuppressAggFuncInHeader = (checked)=>{
        props.onChange({
            ...layout,
            SuppressAggFuncInHeader: checked
        });
    };
    const checkIfPivotColumnTotalEnabled = ()=>{
        // check that all AggregationColumns have identical AggFuncs
        const aggregationColumns = layout.PivotAggregationColumns;
        if (!aggregationColumns || aggregationColumns.length === 0) return true;
        const firstAggFuncName = (0, $8b34480a73f8989d$export$b0a792687abe260d)(aggregationColumns[0].AggFunc);
        if (layout.PivotAggregationColumns?.some((aggCol)=>(0, $8b34480a73f8989d$export$b0a792687abe260d)(aggCol.AggFunc) !== firstAggFuncName)) return 'All columns must use the same aggregation function.';
        // check that no Aggregation Total Column is enabled
        const hasAggregationTotalColumn = aggregationColumns.some((aggCol)=>aggCol.Total !== false && aggCol.Total != null);
        if (hasAggregationTotalColumn) return 'This option is not available when an Aggregation Total Column is present.';
        return true;
    };
    const isPivotColumnTotalEnabled = checkIfPivotColumnTotalEnabled();
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        style: {
            height: '100%'
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column Aggregations"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: 'Omit Aggregation from Header'
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: layout.SuppressAggFuncInHeader,
        onChange: handleSuppressAggFuncInHeader
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: 'Grand Total Row'
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        style: {
            width: 160
        },
        options: [
            'top',
            'bottom',
            'pinnedTop',
            'pinnedBottom'
        ].map((position)=>{
            return {
                label: (0, $9OAZF.default).CamelCaseToHumanText(position),
                value: position
            };
        }),
        placeholder: "[none]",
        value: layout.GrandTotalRow,
        onChange: (value)=>{
            props.onChange({
                ...layout,
                GrandTotalRow: value
            });
        },
        isClearable: true
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: 'Pivot Grand Total'
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        className: "twa:w-[160px]",
        options: [
            'before',
            'after'
        ].map((position)=>{
            return {
                label: (0, $9OAZF.default).CapitaliseFirstLetter(position),
                value: position
            };
        }),
        placeholder: "[none]",
        value: layout.PivotGrandTotal,
        onChange: (value)=>{
            props.onChange({
                ...layout,
                PivotGrandTotal: value
            });
        },
        isClearable: true
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: 'Pivot Column Total'
    }, isPivotColumnTotalEnabled === true ? $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        style: {
            width: 160
        },
        options: [
            'before',
            'after'
        ].map((position)=>{
            return {
                label: (0, $9OAZF.default).CapitaliseFirstLetter(position),
                value: position
            };
        }),
        placeholder: "[none]",
        value: layout.PivotColumnTotal,
        onChange: (value)=>{
            props.onChange({
                ...layout,
                PivotColumnTotal: value
            });
        },
        isClearable: true
    }) : $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-1 twa:italic"
    }, isPivotColumnTotalEnabled)))), $acw62.createElement((0, $d2ae5bba8d7d6225$export$98c0468e3210506e), {
        showFilterInput: true,
        filter: (0, $87d846d33c010e0a$export$fc20acf56d163798),
        toIdentifier: (option)=>`${option.columnId}`,
        toLabel: (option)=>option.friendlyName ?? option.columnId,
        toListLabel: (column)=>$acw62.createElement($f8eb7d60c05d4406$var$PivotColumnRow, {
                onChangeAggFunction: handleAggregationChange,
                layout: layout,
                column: column,
                aggregationColumnsMap: aggregationColumnsMap,
                numberColumns: numberColumns
            }),
        options: sortedAggregableColumns,
        value: (layout.PivotAggregationColumns || []).map((col)=>col.ColumnId),
        allowReorder: true,
        onChange: handleColumnsSelectionChange
    })));
};



const $64d118a5199fc39c$export$998a97ed82e1e7ed = (props)=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const allLayouts = adaptable.api.layoutApi.getLayouts();
    const initialLayout = props.data ?? props.popupParams?.value;
    const [layout, setLayout] = $acw62.useState(()=>{
        let preparedLayout = null;
        if (initialLayout) {
            preparedLayout = (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(initialLayout);
            if (props?.popupParams?.action === 'Clone') preparedLayout = {
                ...adaptable.api.layoutApi.internalApi.cloneLayout(preparedLayout),
                Name: ''
            };
        } else {
            const shouldCreatePivot = props.popupParams?.config?.layoutType === 'pivot' || props.abObjectType?.name?.toLowerCase().includes('pivot') || false;
            preparedLayout = adaptable.api.layoutApi.internalApi.buildInitialLayout({
                Name: ''
            }, shouldCreatePivot ? 'pivot' : 'table');
        }
        if (preparedLayout.SuppressAggFuncInHeader === undefined) preparedLayout.SuppressAggFuncInHeader = !!adaptable.api.agGridApi.getGridOption('suppressAggFuncInHeader');
        return preparedLayout;
    });
    const handleFinish = ()=>{
        let action = props?.popupParams?.action;
        if (!action) action = initialLayout ? 'Edit' : 'New';
        switch(action){
            case 'Edit':
                const currentLayout = adaptable.api.layoutApi.getCurrentLayout();
                dispatch($2c155f3e4804e29e$export$ca72012c06bdea95(layout));
                if (currentLayout.Uuid === layout.Uuid) dispatch($2c155f3e4804e29e$export$256743b3edbbec77(layout.Name));
                break;
            case 'Clone':
                const clonedLayout = {
                    ...layout
                };
                dispatch($2c155f3e4804e29e$export$b6d8346e3e2d65d1(clonedLayout));
                dispatch($2c155f3e4804e29e$export$256743b3edbbec77(clonedLayout.Name));
                break;
            case 'New':
                dispatch($2c155f3e4804e29e$export$b6d8346e3e2d65d1(layout));
                dispatch($2c155f3e4804e29e$export$256743b3edbbec77(layout.Name));
        }
        props.onFinishWizard(layout);
    };
    const layoutSupportedFeatures = adaptable.api.layoutApi.internalApi.getLayoutSupportedFeatures();
    return (0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout) ? $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        titleContainerStyle: {
            width: 180
        },
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: layout,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Settings',
                details: 'Configure Pivot Layout',
                isValid: ()=>{
                    if (!layout.Name) return 'Pivot Layout Name cannot be blank';
                    if (allLayouts.some((layoutItem)=>layoutItem.Name === layout.Name && layoutItem.Uuid !== layout.Uuid)) return 'A Pivot Layout already exists with that name';
                    return true;
                },
                renderSummary: ()=>$acw62.createElement((0, $b5374d66d6c97c96$export$a4ef0c2aac6e4f8c), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $b5374d66d6c97c96$export$d239b03507a9e5cc), {
                        onChange: (newLayout)=>setLayout(newLayout)
                    }))
            },
            {
                title: 'Pivot Row Groups',
                isVisible: ()=>layoutSupportedFeatures.PivotColumns && layoutSupportedFeatures.RowGroupedColumns,
                details: 'Configure Pivot Row Grouping',
                renderSummary: ()=>$acw62.createElement((0, $19c4fde65a7d4267$export$23fedbd56a6f70fe), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $19c4fde65a7d4267$export$a0b80b26fafa688e), {
                        onChange: (newLayout)=>{
                            setLayout(newLayout);
                        }
                    }))
            },
            {
                title: 'Pivot Columns',
                details: 'Select Pivot Columns',
                isVisible: ()=>layoutSupportedFeatures.PivotColumns,
                renderSummary: ()=>$acw62.createElement((0, $23fa8a372d14d5c3$export$f5839ebce370ec94), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $23fa8a372d14d5c3$export$ff42eb5099fd35ef), {
                        onChange: (newLayout)=>setLayout(newLayout)
                    }))
            },
            {
                title: 'Pivot Aggregations',
                isVisible: ()=>layoutSupportedFeatures.PivotAggregationColumns && layoutSupportedFeatures.PivotColumns,
                details: 'Select Pivot Column Aggregations',
                renderSummary: ()=>$acw62.createElement((0, $f8eb7d60c05d4406$export$be2a0cb72739688), null),
                isValid: (data)=>(0, $f8eb7d60c05d4406$export$75ba8f07b20ec0c6)(data),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $f8eb7d60c05d4406$export$bdf05d8709a48bf9), {
                        onChange: (layout)=>{
                            let newLayout = (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(layout);
                            setLayout(newLayout);
                        }
                    }))
            },
            {
                title: 'Sort',
                isVisible: ()=>layoutSupportedFeatures.ColumnSorts,
                renderSummary: ()=>$acw62.createElement((0, $1e5f9dd65a8ec154$export$ce4443f8aa54143), null),
                details: 'Configure Aggregated Column Sorts',
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $1e5f9dd65a8ec154$export$e5447ffaa0544e07), {
                        onChange: (newLayout)=>setLayout(newLayout)
                    }))
            },
            {
                title: 'Column Filters',
                isVisible: ()=>layoutSupportedFeatures.ColumnFilters,
                isValid: (layout)=>(0, $68233238767ebee7$export$42db22e5907a03d)(layout),
                details: 'Set Aggregated Column Filters',
                renderSummary: ()=>$acw62.createElement((0, $68233238767ebee7$export$4bc516e1957a3b64), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $68233238767ebee7$export$4c5b17bfcbab1742), {
                        onChange: (newLayout)=>setLayout(newLayout)
                    }))
            },
            {
                title: 'Grid Filter',
                isVisible: ()=>layoutSupportedFeatures.GridFilter,
                isValid: (layout)=>(0, $7f8d795f7acb537a$export$6925559d9f6d88bf)(layout, adaptable.api),
                details: 'Set Grid Filter',
                renderSummary: ()=>$acw62.createElement((0, $7f8d795f7acb537a$export$7179dd1dec452dc0), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $7f8d795f7acb537a$export$97a01d537be95af), {
                        onChange: (newLayout)=>setLayout(newLayout)
                    }))
            },
            '-',
            {
                details: 'Review your Pivot Layout',
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null)),
                title: 'Summary'
            }
        ]
    }) : $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        titleContainerStyle: {
            width: 180
        },
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: layout,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Settings',
                details: 'Configure Table Layout',
                isValid: ()=>{
                    if (!layout.Name) return 'Layout Name cannot be blank';
                    if (allLayouts.some((layoutItem)=>layoutItem.Name === layout.Name && layoutItem.Uuid !== layout.Uuid)) return 'A Layout already exists with that name';
                    return true;
                },
                renderSummary: ()=>$acw62.createElement((0, $b5374d66d6c97c96$export$a4ef0c2aac6e4f8c), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $b5374d66d6c97c96$export$d239b03507a9e5cc), {
                        onChange: (newLayout)=>setLayout(newLayout)
                    }))
            },
            {
                title: 'Row Groups',
                isVisible: ()=>layoutSupportedFeatures.RowGroupedColumns,
                isValid: (0, $a3369eecb7da45e3$export$1ce60cfc21866493),
                details: 'Configure Row Grouping',
                renderSummary: ()=>$acw62.createElement((0, $b0210f4bbba14d75$export$8996fe5e9c68fe0b), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $b0210f4bbba14d75$export$f428a2c32db91dc2), {
                        onChange: setLayout
                    }))
            },
            {
                title: 'Columns',
                details: 'Select Columns',
                isVisible: ()=>true,
                renderSummary: ()=>$acw62.createElement((0, $19da8f33a73dc6de$export$498f21fd97b7df5c), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $19da8f33a73dc6de$export$e7d304bbce738d09), {
                        onChange: setLayout
                    }))
            },
            {
                title: 'Aggregations',
                isVisible: ()=>layoutSupportedFeatures.TableAggregationColumns,
                details: 'Select Column Aggregations',
                renderSummary: ()=>$acw62.createElement((0, $16126ed5a1737acc$export$1f7464667b39fd3f), null),
                isValid: (data)=>(0, $16126ed5a1737acc$export$8764eda8856788e9)(data),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $16126ed5a1737acc$export$5bed4fd52151e39b), {
                        onChange: (layout)=>{
                            let newLayout = (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(layout);
                            // if we do not have an weighted avg col, we need to clear the row summary if one exists
                            if (newLayout.RowSummaries) {
                                const aggColsMap = (newLayout.TableAggregationColumns || []).reduce((acc, { ColumnId: ColumnId, AggFunc: AggFunc })=>{
                                    acc[ColumnId] = AggFunc;
                                    return acc;
                                }, {});
                                newLayout.RowSummaries = newLayout.RowSummaries.map((rowSummary)=>{
                                    return {
                                        ...rowSummary,
                                        ColumnsMap: Object.entries(rowSummary.ColumnsMap).reduce((acc, [columnId, aggFunc])=>{
                                            if (// see if it is weighted avg
                                            aggFunc === (0, $a22f97369f02628d$export$3a87fe7386ef35df) && // see if we have a weight in the agg columns
                                            aggColsMap[columnId] && (typeof aggColsMap[columnId] !== 'object' || aggColsMap[columnId].weightColumnId)) // need to remove the row summary
                                            return acc;
                                            acc[columnId] = aggFunc;
                                            return acc;
                                        }, {})
                                    };
                                });
                            }
                            setLayout(newLayout);
                        }
                    }))
            },
            {
                title: 'Row Summaries',
                details: 'Configure Row Summaries',
                renderSummary: ()=>$acw62.createElement((0, $a3369eecb7da45e3$export$2913ae5e45ff0b08), null),
                isVisible: ()=>layoutSupportedFeatures.RowSummaries,
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $a3369eecb7da45e3$export$8ac52afafdd36739), {
                        onChange: setLayout
                    }))
            },
            {
                title: 'Sort',
                isVisible: ()=>layoutSupportedFeatures.ColumnSorts,
                renderSummary: ()=>$acw62.createElement((0, $1e5f9dd65a8ec154$export$ce4443f8aa54143), null),
                details: 'Configure Column Sorts',
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $1e5f9dd65a8ec154$export$e5447ffaa0544e07), {
                        onChange: (newLayout)=>setLayout(newLayout)
                    }))
            },
            {
                title: 'Column Filters',
                isVisible: ()=>layoutSupportedFeatures.ColumnFilters,
                isValid: (layout)=>(0, $68233238767ebee7$export$42db22e5907a03d)(layout),
                details: 'Set Column Filters',
                renderSummary: ()=>$acw62.createElement((0, $68233238767ebee7$export$4bc516e1957a3b64), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $68233238767ebee7$export$4c5b17bfcbab1742), {
                        onChange: (newLayout)=>setLayout(newLayout)
                    }))
            },
            {
                title: 'Grid Filter',
                isVisible: ()=>layoutSupportedFeatures.GridFilter,
                isValid: (layout)=>(0, $7f8d795f7acb537a$export$6925559d9f6d88bf)(layout, adaptable.api),
                details: 'Set Grid Filter',
                renderSummary: ()=>$acw62.createElement((0, $7f8d795f7acb537a$export$7179dd1dec452dc0), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $7f8d795f7acb537a$export$97a01d537be95af), {
                        onChange: (newLayout)=>setLayout(newLayout)
                    }))
            },
            '-',
            {
                details: 'Review your Table Layout',
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null)),
                title: 'Summary'
            }
        ]
    });
};






/**
 * Recursively flattens array.
 * Drop-in replacement for lodash/flattenDeep.
 */ function $b905ba555332c575$export$2e2bcd8739ae039(array) {
    return array.flat(Infinity);
}



var $9OAZF = parcelRequire("9OAZF");

var $acw62 = parcelRequire("acw62");


const $2a77e74554200d49$export$7736f1e8b1c9acac = (layout)=>{
    return {
        name: 'Grid Filter',
        view: $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, $acw62.createElement((0, $484ff53c453ae1e6$export$ca85a0e2ff97f05a), {
            query: {
                BooleanExpression: layout.GridFilter?.Expression
            }
        }))
    };
};










class $261e09ee283c687e$export$735a2c1a5796b258 {
    api;
    cachedCellSummary = new Map();
    previousRowSummaries;
    previousLayout;
    constructor(api){
        this.api = api;
    }
    onAdaptableReady() {
        this.rowSummariesSubscriptions();
    }
    rowSummariesSubscriptions() {
        // return;
        if (this.api.isDestroyed()) return;
        // Currently not available for serverside model
        if (!this.api.layoutApi.internalApi.getLayoutSupportedFeatures().RowSummaries) return;
        this.throttledEvaluateRowSummary();
        this.api.eventApi.on('AdaptableStateReloaded', ()=>{
            this.throttledEvaluateRowSummary();
        });
        this.api.internalApi.getDataService().on('RowDataChanged', (rowDataChangedInfo)=>{
            this.throttledEvaluateRowSummary();
        });
        this.api.eventApi.on('CellChanged', (event)=>{
            const columnId = event.cellDataChange.column.columnId;
            this.throttledEvaluateRowSummary({
                columnIds: [
                    columnId
                ]
            });
        });
        this.api.eventApi.on('LayoutChanged', (event)=>{
            // exclude filter events, those are handled in another event
            if (event.actionName.includes('FILTER')) return;
            setTimeout(()=>{
                // the timeout is added so the grid has time to repond to the layout changed
                this.throttledEvaluateRowSummary();
            }, 16);
        });
        const adaptable = this.api.internalApi.getAdaptableInstance();
        adaptable._on('AdapTableFiltersApplied', ()=>{
            // we need to use this instead of layout changed so the rows have time to update
            this.throttledEvaluateRowSummary();
        });
        adaptable._on('FirstDataRendered', ()=>{
            this.throttledEvaluateRowSummary();
        });
    }
    _throttleAcumulatedColumnsThatChanged = new Set();
    throttledEvaluateRowSummary(reason) {
        if (reason) reason.columnIds.forEach((col)=>this._throttleAcumulatedColumnsThatChanged.add(col));
        this._throttledEvaluateRowSummary(reason);
    }
    /**
     *
     * @param colId optional to evaluate only one column
     */ _throttledEvaluateRowSummary = (0, $3a4c9a3b92c4503b$export$2e2bcd8739ae039)(this.evaluateRowSummary, 300);
    evaluateRowSummary(reason) {
        if (this._throttleAcumulatedColumnsThatChanged.size > 0) {
            const columnIds = Array.from(this._throttleAcumulatedColumnsThatChanged.values());
            reason = {
                columnIds: columnIds
            };
            this._throttleAcumulatedColumnsThatChanged.clear();
        }
        if (this.api.isDestroyed() || this.api.layoutApi.isCurrentLayoutPivot()) return;
        const currentLayout = this.api.layoutApi.getCurrentLayout();
        let previousLayout = this.previousLayout;
        // it is added here to be sure it is saved
        this.previousLayout = currentLayout;
        /**
         * If the previous & current layout does not have row summaries, it is safe to exit
         */ if ((0, $28578c992716f58c$export$23cfe696632d10f4)(currentLayout?.RowSummaries) && (0, $28578c992716f58c$export$23cfe696632d10f4)(previousLayout?.RowSummaries)) return;
        const rowSummaries = currentLayout.RowSummaries ?? [];
        const aggColsMap = (currentLayout.TableAggregationColumns || []).reduce((acc, { ColumnId: ColumnId, AggFunc: AggFunc })=>{
            acc[ColumnId] = AggFunc;
            return acc;
        }, {});
        const rowSummariesResults = rowSummaries.filter((rowSummary)=>!rowSummary.IsSuspended).map((rowSummary, index)=>{
            const { ColumnsMap: ColumnsMap, Position: Position, IncludeOnlyFilteredRows: // it defaults to true
            IncludeOnlyFilteredRows = true } = rowSummary;
            return {
                Position: Position,
                RowData: Object.entries(ColumnsMap ?? {}).reduce((acc, [columnId, expression])=>{
                    if (columnId === 'Uuid' || columnId === 'Source' || columnId === 'AdaptableVersion') return acc;
                    const key = `${columnId}-${expression}-IncludeOnlyFilteredRows=${IncludeOnlyFilteredRows ? 'filtered' : 'all'}`;
                    let expressionLiveValue = this.cachedCellSummary.get(key);
                    if (expressionLiveValue) {
                        if (!reason) // refresh all of them
                        expressionLiveValue.refresh();
                        else if ('columnIds' in reason && reason.columnIds.includes(columnId)) expressionLiveValue.refresh();
                    }
                    if (!expressionLiveValue) {
                        try {
                            let aggregatedScalarExpression = `${expression}([${columnId}])`;
                            if (aggregatedScalarExpression.includes((0, $a22f97369f02628d$export$3a87fe7386ef35df)) && aggColsMap[columnId] && typeof aggColsMap[columnId] === 'object') {
                                const weight = aggColsMap[columnId].weightedColumnId;
                                if (weight) aggregatedScalarExpression = `AVG([${columnId}], WEIGHT([${weight}]))`;
                            }
                            expressionLiveValue = new (0, $204192e364083da9$export$2543999d196edf32)({
                                aggregatedScalarExpression: aggregatedScalarExpression
                            }, $42e863194fcb493f$export$802bb096eb63f491, this.api, ()=>{
                                if (rowSummary.IncludeOnlyFilteredRows ?? true) return this.api.gridApi.getVisibleRowNodes();
                                else return this.api.gridApi.getAllRowNodes();
                            });
                        } catch (e) {
                            this.api.logError('Error evaluating row summary', e);
                        }
                        this.cachedCellSummary.set(key, expressionLiveValue);
                    }
                    let value = null;
                    if (expressionLiveValue) {
                        value = expressionLiveValue.getGlobalAggregatedValue();
                        if (typeof value === 'number' && !isNaN(value)) value = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).roundNumber(value, 2);
                    }
                    const column = this.api.columnApi.getColumnWithColumnId(columnId);
                    const fieldName = column?.field ?? column?.columnId ?? columnId;
                    acc = this.api.internalApi.setValueUsingField(acc, fieldName, value);
                    return acc;
                }, {
                    [(0, $a22f97369f02628d$export$6220e2e98f7e58ca)]: `row-summary-${index}`
                })
            };
        });
        if (this.previousRowSummaries && (0, $f94a32af7542d5ef$export$2e2bcd8739ae039)(rowSummariesResults, this.previousRowSummaries)) return;
        this.api.internalApi.dispatchReduxAction((0, $5b564bb703f29152$export$648d0c2f1b9a0347)(rowSummariesResults));
        this.previousRowSummaries = rowSummariesResults;
    }
}



class $f9bd6737c8d30fe2$export$8b06f1a6fe6dd818 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    LayoutState;
    rowSummaryService = new (0, $261e09ee283c687e$export$735a2c1a5796b258)(this.api);
    constructor(api){
        super($42e863194fcb493f$export$802bb096eb63f491, $42e863194fcb493f$export$ffe377bba9205e92, 'grid', 'LayoutPopup', 'Named sets of column visibility, order, groupings, aggregation, pivots etc.', api);
    }
    onAdaptableReady() {
        this.rowSummaryService.onAdaptableReady();
        this.api.eventApi.on('LayoutChanged', (layoutChangedInfo)=>{
            if (layoutChangedInfo.actionName === 'LAYOUT_SELECT' && layoutChangedInfo.newLayoutState.CurrentLayout !== layoutChangedInfo.oldLayoutState?.CurrentLayout) this.handleLayoutSelection();
        });
        requestAnimationFrame(()=>{
            if (this.api.isDestroyed()) return;
            this.api.eventApi.internalApi.fireLayoutChangedEvent('LAYOUT_READY', null, this.api.layoutApi.getLayoutState());
        });
    }
    getModuleAdaptableObjects() {
        return this.api.layoutApi.getLayouts();
    }
    getExplicitlyReferencedColumnIds(layout) {
        const columnIds = [];
        if (!(0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout) && layout.TableColumns) {
            const visibility = layout.ColumnVisibility || {};
            columnIds.push(...layout.TableColumns.filter((colId)=>{
                return visibility[colId] !== false;
            }));
        }
        if (layout.TableAggregationColumns) columnIds.push(...Object.keys(layout.TableAggregationColumns));
        if ((0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)) {
            if (layout.PivotColumns) columnIds.push(...layout.PivotColumns);
            if (layout.PivotAggregationColumns) columnIds.push(...layout.PivotAggregationColumns.map((x)=>x.ColumnId));
            if (layout.PivotGroupedColumns) columnIds.push(...layout.PivotGroupedColumns);
        }
        if (layout.RowGroupedColumns) columnIds.push(...layout.RowGroupedColumns);
        return Array.from(new Set(columnIds));
    }
    getTeamSharingReferences(adaptableObject) {
        const teamSharingReferences = super.getTeamSharingReferences(adaptableObject);
        const layoutName = adaptableObject.Name;
        if (this.api.layoutApi.internalApi.hasLayoutSpecificObjects() && !!layoutName) {
            const LayoutExtensionObjectReferences = [];
            const loadConfig = {
                extendedLayoutName: layoutName
            };
            // we ensured that there are layout specific objects, so all the "getAll*()" api methods will return only the objects available in the current layout
            this.api.alertApi.getAlertDefinitions(loadConfig).forEach((alertDefinition)=>LayoutExtensionObjectReferences.push({
                    Reference: alertDefinition,
                    Module: 'Alert'
                }));
            this.api.customSortApi.getCustomSorts(loadConfig).forEach((customSort)=>LayoutExtensionObjectReferences.push({
                    Reference: customSort,
                    Module: 'CustomSort'
                }));
            this.api.flashingCellApi.getFlashingCellDefinitions(loadConfig).forEach((flashingCell)=>LayoutExtensionObjectReferences.push({
                    Reference: flashingCell,
                    Module: 'FlashingCell'
                }));
            this.api.formatColumnApi.getFormatColumns(loadConfig).forEach((formatColumn)=>LayoutExtensionObjectReferences.push({
                    Reference: formatColumn,
                    Module: 'FormatColumn'
                }));
            this.api.styledColumnApi.getStyledColumns(loadConfig).forEach((styledcolumn)=>LayoutExtensionObjectReferences.push({
                    Reference: styledcolumn,
                    Module: 'StyledColumn'
                }));
            this.api.plusMinusApi.getAllPlusMinus(loadConfig).forEach((plusMinusNudge)=>LayoutExtensionObjectReferences.push({
                    Reference: plusMinusNudge,
                    Module: 'PlusMinus'
                }));
            this.api.shortcutApi.getShortcuts(loadConfig).forEach((shortcut)=>LayoutExtensionObjectReferences.push({
                    Reference: shortcut,
                    Module: 'Shortcut'
                }));
            [
                ...this.api.scheduleApi.getReportSchedules(loadConfig),
                ...this.api.scheduleApi.getReminderSchedules(loadConfig),
                ...this.api.scheduleApi.getIPushPullSchedules(loadConfig),
                ...this.api.scheduleApi.getOpenFinSchedules(loadConfig)
            ].forEach((schedule)=>LayoutExtensionObjectReferences.push({
                    Reference: schedule,
                    Module: 'Schedule'
                }));
            teamSharingReferences.push(...LayoutExtensionObjectReferences);
        }
        return teamSharingReferences;
    }
    hasNamedQueryReferences() {
        return true;
    }
    createColumnMenuItems(column) {
        if (!this.isModuleEditable()) return;
        let returnColumnMenuItems = [];
        const isReadOnlyLayout = this.isCurrentLayoutReadOnly();
        if (!isReadOnlyLayout) {
            returnColumnMenuItems.push(this.createMenuItemShowPopup('layout-edit', 'Edit Layout', this.moduleInfo.Popup, 'edit-table', {
                action: 'Edit',
                source: 'ColumnMenu',
                value: this.api.layoutApi.getCurrentLayout()
            }));
            if (column && !column.isTreeColumn) returnColumnMenuItems.push(this.createMenuItemClickFunction('layout-column-caption-change', 'Change Caption', 'edit', ()=>this.api.layoutApi.showChangeColumnCaption(column)));
        }
        if (column) {
            if (column.hideable) returnColumnMenuItems.push(this.createMenuItemClickFunction('layout-column-hide', 'Hide Column', 'visibility-off-bold', ()=>{
                this.api.columnApi.hideColumn(column.columnId);
            }));
            if (this.api.gridApi.isGridRangeSelectable()) {
                const hasExistingSelection = this.api.gridApi.getSelectedCellInfo()?.gridCells?.length;
                if (hasExistingSelection) {
                    returnColumnMenuItems.push(this.createMenuItemClickFunction('layout-column-select-preserve', 'Select Column (Preserve Selection)', 'select-fwd', ()=>{
                        this.api.columnApi.addColumnToSelection(column.columnId);
                    }));
                    returnColumnMenuItems.push(this.createMenuItemClickFunction('layout-column-select-reset', 'Select Column (Reset Selection)', 'tab-unselected', ()=>{
                        this.api.columnApi.selectColumn(column.columnId);
                    }));
                } else returnColumnMenuItems.push(this.createMenuItemClickFunction('layout-column-select', 'Select Column', 'tab-unselected', ()=>{
                    this.api.columnApi.selectColumn(column.columnId);
                }));
                returnColumnMenuItems.push(this.createMenuItemClickFunction('layout-grid-select', 'Select Grid', 'select-all', ()=>{
                    this.api.gridApi.selectAll();
                }));
            }
        }
        return returnColumnMenuItems;
    }
    createContextMenuItems(menuContext) {
        let returnColumnMenuItems = [];
        if (this.isModuleEditable() && !this.isCurrentLayoutReadOnly()) returnColumnMenuItems.push(this.createMenuItemShowPopup('layout-edit', 'Edit Layout', this.moduleInfo.Popup, 'edit-table', {
            action: 'Edit',
            source: 'ColumnMenu'
        }));
        if (menuContext.selectedCellInfo && (0, $9g4SS.default).IsNotNullOrEmpty(menuContext.selectedCellInfo.columns) || menuContext.selectedRowInfo && (0, $9g4SS.default).IsNotNullOrEmpty(menuContext.selectedRowInfo.gridRows)) returnColumnMenuItems.push(this.createMenuItemClickFunction('layout-clear-selection', 'Clear Selected Cells', 'select-off', ()=>{
            this.api.gridApi.deselectAll();
        }));
        if (this.api.gridApi.isGridRangeSelectable()) returnColumnMenuItems.push(this.createMenuItemClickFunction('layout-select-all', 'Select Grid', 'select-all', ()=>{
            this.api.gridApi.selectAll();
        }));
        returnColumnMenuItems.push(this.createMenuItemClickFunction('layout-auto-size', 'Auto Size', 'arrow-expand', ()=>{
            this.api.columnApi.autosizeAllColumns();
        }));
        const viewPivotItemsMenuItem = this.createViewPivotItemsMenuItem(menuContext);
        if (viewPivotItemsMenuItem) returnColumnMenuItems.push(viewPivotItemsMenuItem);
        return returnColumnMenuItems;
    }
    // TODO next time this method is touched, it should be extracted in an internal Api
    createViewPivotItemsMenuItem(menuContext) {
        // current group => menuContext.rowNode.field;
        const selectedCellInfo = menuContext.selectedCellInfo ?? this.api.gridApi.getSelectedCellInfo();
        if (selectedCellInfo?.gridCells?.length !== 1) return;
        const gridCell = menuContext.gridCell ?? selectedCellInfo.gridCells[0];
        const currentLayout = this.api.layoutApi.getCurrentLayout();
        if (!(0, $702a77ed6db22640$export$db5fe50348e92ffe)(currentLayout)) return;
        const { agGridColumn: agGridColumn } = menuContext;
        const columnId = agGridColumn.getColId();
        const isPivotColumn = this.api.columnApi.isPivotResultColumn(columnId);
        if (!isPivotColumn && this.api.columnApi.getColumnDataTypeForColumnId(columnId) !== 'number') return;
        /**
         * Cannot base the values on the pivot column id, because the value or the field may have underscrores
         *
         *
         * e.g. pivot_license_MIT License_stargazers_count
         */ // pivot_status_Booked_price
        // price
        const aggColumn = agGridColumn?.getColDef?.().pivotValueColumn?.getColDef?.()?.field;
        // Booked
        const pivotValue = agGridColumn?.getColDef?.()?.pivotKeys?.[0];
        // status - the preview works only with one column
        const pivotColumnId = currentLayout?.PivotColumns?.[0];
        function getData(rows) {
            return [
                ...rows.map((row)=>{
                    if (row.childrenAfterFilter) return getData(row.childrenAfterFilter);
                    return row.data;
                })
            ];
        }
        const data = (0, $b905ba555332c575$export$2e2bcd8739ae039)(getData(menuContext.rowNode.childrenAfterFilter));
        const rowGroups = currentLayout.RowGroupedColumns;
        const cellValue = isPivotColumn ? menuContext.rowNode?.aggData?.[columnId] : gridCell.displayValue;
        const popupProps = {
            hasPivotValue: isPivotColumn,
            columnId: columnId,
            rowGroups: rowGroups,
            rows: data,
            layout: currentLayout,
            aggColumn: aggColumn,
            pivotValue: pivotValue,
            pivotColumnId: pivotColumnId
        };
        return {
            name: 'layout-aggregated-view',
            category: this.moduleInfo.ModuleName,
            isVisible: true,
            label: 'Expand Aggregated Value',
            onClick: ()=>{
                this.api.internalApi.showPopupWindow({
                    // force only one window instance opened
                    id: (0, $226a20b901481288$export$b3bc1824253fee5c),
                    factoryId: (0, $226a20b901481288$export$b3bc1824253fee5c),
                    title: `Rows for Aggregated Value: ${cellValue}`,
                    icon: undefined,
                    popupProps: popupProps
                });
            },
            icon: {
                name: 'arrow-expand'
            }
        };
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.layoutApi.getLayouts(),
            AddAction: $2c155f3e4804e29e$export$b6d8346e3e2d65d1,
            EditAction: $2c155f3e4804e29e$export$ca72012c06bdea95
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects().map((layout)=>this.toView(layout));
    }
    toView(layout) {
        const maxColumnsToDisplay = this.api.optionsApi.getLayoutOptions().layoutViewOptions?.maxColumnsToDisplay ?? 10;
        const columnIdToFriendlyName = (columnId)=>{
            return this.api.columnApi.getFriendlyNameForColumnId(columnId);
        };
        let columns = (layout.TableColumns || []).filter((c)=>!this.api.columnApi.isAutoRowGroupColumn(c)).filter((c)=>!this.api.columnApi.isPivotResultColumn(c)).filter((c)=>!this.api.columnApi.isSelectionColumn(c));
        if (columns.length > maxColumnsToDisplay + 1 /* +1 is to show tag only beginning with 2, 'other 2' */ ) {
            const extraColumns = columns.length - maxColumnsToDisplay;
            const firstNColumns = columns.slice(0, maxColumnsToDisplay).map((column)=>columnIdToFriendlyName(column));
            columns = [
                ...firstNColumns,
                `and ${extraColumns} more`
            ];
        } else columns = columns.map((column)=>columnIdToFriendlyName(column));
        return {
            items: [
                {
                    name: 'Name',
                    values: [
                        layout.Name
                    ]
                },
                {
                    name: 'Grid Type',
                    values: [
                        (0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout) ? 'Pivot' : 'Table'
                    ]
                },
                /**
                 * Hide pivot columns.
                 *
                 * The generated pivot columns cannot be prevented from beeing on the layout object.
                 * When they are removed/not added, they no longer appear in the grid.
                 */ !(0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout) && {
                    name: 'Columns',
                    values: columns
                },
                layout.ColumnSorts?.length && (0, $eed764d6d91a84f2$export$a6f14328ab10ee65)(layout, this.api),
                layout?.ColumnFilters?.length && (0, $6a7ec5df7bac55db$export$4b152704e0654386)(layout, this.api),
                layout?.RowGroupedColumns?.length && {
                    name: 'Row Groups',
                    values: layout.RowGroupedColumns.map((colId)=>columnIdToFriendlyName(colId))
                },
                layout?.PivotColumns?.length && {
                    name: 'Pivot Columns',
                    values: layout.PivotColumns.map((colId)=>columnIdToFriendlyName(colId))
                },
                layout?.PivotGroupedColumns?.length && {
                    name: 'Pivot Row Groups',
                    values: layout.PivotGroupedColumns.map((colId)=>columnIdToFriendlyName(colId))
                },
                layout?.TableAggregationColumns && layout.TableAggregationColumns.length && {
                    name: 'Aggregations',
                    values: layout.TableAggregationColumns.map(({ ColumnId: ColumnId, AggFunc: aggFn })=>{
                        if (ColumnId === 'Source' || ColumnId === 'Uuid' || ColumnId === 'AdaptableVersion') return '';
                        let aggFnName = '';
                        if (typeof aggFn === 'string') aggFnName = aggFn;
                        else if (typeof aggFn === 'object' && aggFn.type === 'weightedAverage') aggFnName = (0, $8b34480a73f8989d$export$cddc429232233701);
                        return `${aggFnName}(${columnIdToFriendlyName(ColumnId)})`;
                    }).filter(Boolean)
                },
                (0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout) && layout?.PivotAggregationColumns && layout.PivotAggregationColumns.length && {
                    name: 'Pivot Aggregations',
                    values: layout.PivotAggregationColumns.map(({ ColumnId: ColumnId, AggFunc: aggFn })=>{
                        if (ColumnId === 'Source' || ColumnId === 'Uuid' || ColumnId === 'AdaptableVersion') return '';
                        let aggFnName = '';
                        if (typeof aggFn === 'string') aggFnName = aggFn;
                        else if (typeof aggFn === 'object' && aggFn.type === 'weightedAverage') aggFnName = (0, $8b34480a73f8989d$export$cddc429232233701);
                        return `${aggFnName}(${columnIdToFriendlyName(ColumnId)})`;
                    }).filter(Boolean)
                },
                layout?.GridFilter && (0, $9OAZF.default).IsNotNullOrEmpty(layout.GridFilter.Expression) && (0, $2a77e74554200d49$export$7736f1e8b1c9acac)(layout),
                layout && !(0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout) && layout.RowSummaries?.length && {
                    name: 'Row Summaries',
                    values: layout.RowSummaries.map((rowSummary)=>{
                        const columns = Object.entries(rowSummary.ColumnsMap ?? {}).map(([columnId, expression])=>{
                            if (columnId === 'Source' || columnId === 'Uuid' || columnId === 'AdaptableVersion') return '';
                            return `${expression}(${columnIdToFriendlyName(columnId)})`;
                        }).filter(Boolean).join(', ');
                        return `${rowSummary.Position}: ${columns}`;
                    })
                }
            ].filter(Boolean),
            abObject: layout
        };
    }
    getViewProperties() {
        return {
            abObjectTypes: [
                {
                    name: 'Table Layout',
                    accessLevel: this.AccessLevel
                },
                !this.api.gridApi.isTreeDataGrid() && {
                    name: 'Pivot Layout',
                    accessLevel: this.AccessLevel
                }
            ].filter(Boolean),
            actions: [
                (0, $51d790ae8a0e45a1$export$a74f6ef65f3c26d7),
                (0, $17cd98021108d154$export$c7a7af74bf07c087)
            ],
            getDeleteAction: (layout)=>{
                // make sure we do not delete the last layout
                if (this.getModuleAdaptableObjects().length === 1) return null;
                return $2c155f3e4804e29e$export$16171190943cf4cb(layout);
            },
            getEditWizard: ()=>(0, $64d118a5199fc39c$export$998a97ed82e1e7ed),
            getStatusBarPanelProps: ()=>{
                return {
                    triggerActionOnWrapperClick: false,
                    content: (0, $a852c3e1c6668b15$export$fe5648a1911fc07c),
                    extraActions: [
                        (0, $0f85f402d42d10cd$export$7bcac5f4c3ee8df7)
                    ]
                };
            }
        };
    }
    handleLayoutSelection() {
        if (!this.api.layoutApi.internalApi.hasLayoutSpecificObjects()) // no need if no callback implementation is provided or no auto checking
        return;
        // PlusMinus
        this.api.internalApi.getModuleService().getModuleById('PlusMinus').checkListenToKeyDown();
        // Shortcut
        this.api.internalApi.getModuleService().getModuleById('Shortcut').checkListenToKeyDown();
        // Schedule
        this.api.internalApi.getModuleService().getModuleById('Schedule').setUpScheduleJobs();
        // CustomSort, FlashingCell, FormatColumn, StyledColumn
        // we need to re-setup the column defs, as some colDefs properties may be changed
        this.api.internalApi.getAdaptableInstance().updateColumnModelAndRefreshGrid();
    }
    getReferencedNamedQueryNames(layout) {
        if (!layout.GridFilter?.Expression) return [];
        return this.api.namedQueryApi.internalApi.getReferencedNamedQueryNames(layout.GridFilter.Expression);
    }
    isCurrentLayoutReadOnly() {
        const currentLayout = this.api.layoutApi.getCurrentLayout();
        if (currentLayout) return currentLayout.IsReadOnly;
        return true;
    }
}





var $9g4SS = parcelRequire("9g4SS");






var $acw62 = parcelRequire("acw62");




const $f9fe28ddd157f96c$export$a5d9dbbf691550b7 = (props)=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const plusMinusNudges = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.PlusMinus.PlusMinusNudges);
    const handleMoveUp = $acw62.useCallback(()=>{
        dispatch($36058826e464bb44$export$bc10974e56e9f8bb(props.data));
    }, []);
    const handleMoveDown = $acw62.useCallback(()=>{
        dispatch($36058826e464bb44$export$a06e4608b4d07139(props.data));
    }, []);
    if (plusMinusNudges?.length <= 1) return $acw62.createElement($acw62.Fragment, null);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-id": "move-up",
        title: "move up",
        onClick: handleMoveUp,
        variant: "text",
        icon: "arrow-up"
    }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "move-down",
        title: "move down",
        onClick: handleMoveDown,
        variant: "text",
        icon: "arrow-down"
    }));
};



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $8aff66a268b16141$export$6c89d0e795e22770 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const availableColumns = $acw62.useMemo(()=>api.columnApi.getNumericColumns(), []);
    return $acw62.createElement((0, $65308a7002d19b3b$export$b5842aa553688927), {
        availableDataTypes: [
            'number'
        ],
        scopeColumns: availableColumns,
        scope: data.Scope,
        descriptions: {
            rowScope: 'Matching rows will have the plus/minus applied',
            columnScope: 'Matching Columns will have the plus/minus applied'
        },
        updateScope: (Scope)=>{
            let preparedScope = Scope;
            if (Scope && 'DataTypes' in Scope && Scope.DataTypes.length === 0) // default to checked
            preparedScope = {
                ...Scope,
                DataTypes: [
                    'number'
                ]
            };
            props.onChange({
                ...data,
                Scope: preparedScope
            });
        }
    });
};



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



function $1fe50b193b21235a$export$f89dedb0e911e0e5() {
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $07845dcbd4d38c15$export$f59a408a7cde7e1f), {
        data: data,
        renderPredicate: (contents)=>{
            return $acw62.createElement($acw62.Fragment, null, "Apply Plus Minus on ", $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), null, contents));
        },
        renderQueryExpression: (contents)=>{
            return $acw62.createElement($acw62.Fragment, null, "Apply Plus Minus when", ' ', $acw62.createElement("b", null, $acw62.createElement((0, $a20f9e611d5a05eb$export$6c415d1fdae3dfdb), null, contents)));
        }
    });
}
function $1fe50b193b21235a$export$3da4ff66e1c24b9f(props) {
    const { data: data, moduleInfo: moduleInfo } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const plusMinusNudge = {
        ...data,
        Rule: data?.Rule ?? {
            BooleanExpression: ''
        }
    };
    return $acw62.createElement((0, $07845dcbd4d38c15$export$958c7d77bf3113b), {
        module: moduleInfo.ModuleName,
        // min-height 0 so the container does not min-size from it's children
        // https://stackoverflow.com/questions/33605552/how-to-prevent-a-flex-item-height-to-overflow-due-to-its-content
        flexProps: {
            style: {
                minHeight: 0
            }
        },
        defaultPredicateId: props.defaultPredicateId,
        predicateDefs: [],
        showAggregation: false,
        showObservable: false,
        showPredicate: false,
        data: plusMinusNudge,
        // the cast is to convince TS that it still a PlusMinusNudge
        // even when Rule is not optional, the type is inferred from `plusMinusNudge`
        onChange: (plusMinus)=>props.onChange(plusMinus),
        descriptions: {
            selectPredicate: null,
            useBooleanQuery: $acw62.createElement($acw62.Fragment, null, "Use an BooleanQuery if ", $acw62.createElement("i", null, "Scope"), " is 'All Columns' - so any data change may be evaluated in a complex BooleanExpression"),
            useObservableQuery: null,
            useAggregationQuery: null
        }
    });
}






const $bed95d6621b8fdf5$export$8a34dda69412ac35 = (props)=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), null, "Name ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.Name || 'Not specified')), $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), null, "Nudge Value ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.NudgeValue ?? 'Not selected')), $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), null, "Nudge Type ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, props.hasCondition ? 'Conditional' : 'Always Apply')), props.hasCondition && $acw62.createElement((0, $1fe50b193b21235a$export$f89dedb0e911e0e5), null));
};
const $bed95d6621b8fdf5$export$bd1cc8e0fb715366 = (hasCondition)=>(data, api, context)=>{
        if (!data.Name?.trim()) return 'A name is required.';
        const allPlusMinusNudges = api.plusMinusApi.getAllPlusMinus();
        const isDuplicateName = allPlusMinusNudges.some((nudge)=>nudge.Name === data.Name && nudge.Uuid !== data.Uuid);
        if (isDuplicateName) return 'A Plus/Minus Nudge with this name already exists.';
        if (hasCondition) {
            if (!data?.Rule?.BooleanExpression) return 'A valid rule is required.';
            const ruleValidation = (0, $77459fc7566b1dde$export$509100fde248eb2b)(data, api, context);
            if (typeof ruleValidation === 'string') return ruleValidation;
        }
        if (typeof data.NudgeValue !== 'number') return 'A nudge value is required.';
        if (data.NudgeValue === 0) return 'Nudge value must not be zero.';
        return true;
    };
const $bed95d6621b8fdf5$export$7f00cf655b465389 = (props)=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const handleNameChange = (event)=>{
        props.onChange({
            ...data,
            Name: event.target.value
        });
    };
    const handleNudgeValueChange = (event)=>{
        const newValue = parseFloat(event.target.value);
        props.onChange({
            ...data,
            NudgeValue: isNaN(newValue) ? '' : newValue
        });
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        "data-name": "plus-minus-column-settings",
        className: "twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "plus-minus-name",
        className: "twa:flex-1 twa:mr-3",
        onChange: handleNameChange,
        placeholder: "Enter Name",
        value: data.Name ?? ''
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Nudge Value"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "nudge-value",
        className: "twa:flex-1 twa:mr-3",
        onChange: handleNudgeValueChange,
        placeholder: "Enter Number",
        type: "number",
        value: data.NudgeValue ?? ''
    }))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:p-2",
        selectedIndex: props.hasCondition ? 1 : 0,
        onSelectedIndexChange: (index)=>props.onConditionChange(index === 1)
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        "data-name": "nudge-type-always"
    }, "Always Apply"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        "data-name": "nudge-type-condition"
    }, "Conditional"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:text-2 twa:py-2"
    }, "The nudge value is always applied when using Plus/Minus")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
        className: "twa:p-0"
    }, $acw62.createElement((0, $1fe50b193b21235a$export$3da4ff66e1c24b9f), {
        defaultPredicateId: "NonBlanks",
        onChange: props.onChange
    }))));
};







const $b386ac23fcf87e33$export$fc1cd112329d55a3 = (props)=>{
    const [plusMinus, doSetPlusMinus] = $acw62.useState(()=>{
        const newPlusMinus = {
            ...props.data ? props.data : (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyPlusMinusNudge(),
            Scope: props?.data?.Scope ?? {
                All: true
            },
            NudgeValue: props?.data?.NudgeValue ?? 20
        };
        if (props?.popupParams?.column) newPlusMinus.Scope = {
            ColumnIds: [
                props.popupParams.column.columnId
            ]
        };
        return newPlusMinus;
    });
    const setPlusMinus = $acw62.useCallback((data)=>{
        doSetPlusMinus(data);
    }, []);
    const [hasCondition, setHasCondition] = $acw62.useState(()=>{
        // true if on edit and it has a condition
        return Boolean(props?.data?.Rule);
    });
    $acw62.useEffect(()=>{
        doSetPlusMinus((prev)=>{
            const preparedData = {
                ...prev
            };
            if (hasCondition) preparedData.Rule = preparedData.Rule ?? {
                BooleanExpression: ''
            };
            else delete preparedData.Rule;
            return preparedData;
        });
    }, [
        hasCondition
    ]);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleFinish = ()=>{
        if (props.data) dispatch($36058826e464bb44$export$15d09d450ef43f85(plusMinus));
        else dispatch($36058826e464bb44$export$b57847b7da91dcb4(plusMinus));
        props.onFinishWizard(plusMinus);
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: plusMinus,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Settings',
                isValid: (0, $bed95d6621b8fdf5$export$bd1cc8e0fb715366)(hasCondition),
                renderSummary: ()=>$acw62.createElement((0, $bed95d6621b8fdf5$export$8a34dda69412ac35), {
                        hasCondition: hasCondition
                    }),
                render: ()=>$acw62.createElement((0, $bed95d6621b8fdf5$export$7f00cf655b465389), {
                        hasCondition: hasCondition,
                        onConditionChange: setHasCondition,
                        onChange: setPlusMinus
                    })
            },
            {
                title: 'Target',
                isValid: (0, $65308a7002d19b3b$export$37abad8a5da7760),
                details: 'Specify where Plus/Minus should be applied',
                renderSummary: ()=>(0, $65308a7002d19b3b$export$3f60d09dd2143243)(plusMinus.Scope, {
                        scopeWholeRow: 'Plus/Minus is applied for matching rows',
                        scopeColumns: 'Plus/Minus is applied in cells in selected columns',
                        scopeDataTypes: 'Plus/Minus is applied for cells with selected data type'
                    }),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $8aff66a268b16141$export$6c89d0e795e22770), {
                        onChange: setPlusMinus
                    }))
            },
            {
                details: 'Select Plus/Minus Tags',
                title: 'Tags',
                isVisible: (_, api)=>api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setPlusMinus
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null));
                },
                title: 'Summary'
            }
        ]
    });
};



class $8f237c8d7ccf415d$export$1e2df413e6695b34 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    shouldHandleKeyDown;
    adaptable;
    constructor(api){
        super($42e863194fcb493f$export$1d33a3a77a9299ff, $42e863194fcb493f$export$f518c662fee2c31a, 'add-circle', 'PlusMinusPopup', 'Configure how a cell value will edit when the + or - keys are pressed', api);
        this.shouldHandleKeyDown = false;
        this.adaptable = api.internalApi.getAdaptableInstance();
    }
    isModuleAvailable() {
        return super.isModuleAvailable() && this.api.gridApi.isGridRangeSelectable();
    }
    getModuleAdaptableObjects(config) {
        return this.api.plusMinusApi.getAllPlusMinus(config);
    }
    getExplicitlyReferencedColumnIds(plusMinusNudge) {
        if (this.api.columnScopeApi.scopeHasColumns(plusMinusNudge.Scope)) return this.api.columnScopeApi.getColumnsInScope(plusMinusNudge.Scope).map((adaptableColumn)=>adaptableColumn.columnId);
        return [];
    }
    getReferencedNamedQueryNames(plusMinusNudge) {
        if (!plusMinusNudge.Rule?.BooleanExpression) return [];
        return this.api.namedQueryApi.internalApi.getReferencedNamedQueryNames(plusMinusNudge.Rule?.BooleanExpression);
    }
    onAdaptableReady() {
        const hasPlusMinusNudges = (0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(this.api.plusMinusApi.getAllPlusMinus());
        this.shouldHandleKeyDown = this.isModuleAvailable() && hasPlusMinusNudges;
        if (this.shouldHandleKeyDown) this.setupKeyDownListener();
        else if (hasPlusMinusNudges && !this.api.gridApi.isGridRangeSelectable()) this.api.consoleWarn('Plus/Minus module is not available because AG Grid is not selectable');
    }
    setupKeyDownListener() {
        this.adaptable._on('KeyDown', (keyDownEvent)=>{
            this.handleKeyDown(keyDownEvent);
        });
    }
    checkListenToKeyDown() {
        const oldShouldHandleKeyDown = this.shouldHandleKeyDown;
        const newShouldHandleKeyDown = (0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(this.api.plusMinusApi.getAllPlusMinus());
        if (!oldShouldHandleKeyDown && newShouldHandleKeyDown) this.setupKeyDownListener();
        this.shouldHandleKeyDown = newShouldHandleKeyDown;
    }
    createColumnMenuItems(column) {
        if (column && this.isModuleEditable() && column.dataType == 'number') {
            let popupParam = {
                column: column,
                action: 'New',
                source: 'ColumnMenu'
            };
            return [
                this.createMenuItemShowPopup('plus-minus-add', 'Create Plus/Minus Rule', this.moduleInfo.Popup, this.moduleInfo.Glyph, popupParam)
            ];
        }
    }
    handleKeyDown(keyEvent) {
        if (this.shouldHandleKeyDown) {
            //it's a special key so we handle the string representation of the key '
            let keyEventString = (0, $f5fc3c9fe698fd70$export$37ddbc38b6af2a38).getStringRepresentionFromKey(keyEvent);
            if (keyEventString == '-' || keyEventString == '+') {
                let plusMinusNudges = this.api.plusMinusApi.getAllActivePlusMinus();
                if ((0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(plusMinusNudges)) {
                    let side = keyEventString == '-' ? 'down' : 'up';
                    let selectedCellInfo = this.api.gridApi.getSelectedCellInfo();
                    let isPlusMinusApplicable = this.applyPlusMinus(plusMinusNudges, selectedCellInfo.gridCells, side);
                    if (isPlusMinusApplicable) keyEvent.preventDefault();
                }
            }
        }
    }
    applyPlusMinus(plusMinusNudges, cellsToUpdate, direction) {
        let shouldApplyPlusMinus = false;
        let successfulValues = [];
        let failedPreventEdits = [];
        let side = direction == 'up' ? 1 : -1;
        cellsToUpdate.forEach((gridCell)=>{
            if (gridCell.column && gridCell.column.dataType == 'number' && this.api.gridApi.isCellEditable(gridCell)) {
                let foundRule;
                let replacementGridCell;
                plusMinusNudges.forEach((pmr)=>{
                    if (!foundRule) {
                        if (this.api.columnScopeApi.isColumnInScope(gridCell.column, pmr.Scope)) {
                            //for aggrid as we are getting strings sometimes
                            if (typeof gridCell.rawValue != 'number') gridCell.rawValue = parseFloat(gridCell.rawValue);
                            const isSatisfiedExpression = this.isPlusMinusNudgeApplied(pmr, gridCell);
                            if (isSatisfiedExpression) {
                                foundRule = pmr;
                                shouldApplyPlusMinus = true;
                                let computedValue = gridCell.rawValue + pmr.NudgeValue * side;
                                //avoid the 0.0000000000x??
                                //   computedValue=   parseFloat(computedValue.toFixed(12));
                                replacementGridCell = {
                                    primaryKeyValue: gridCell.primaryKeyValue,
                                    column: gridCell.column,
                                    rawValue: computedValue,
                                    displayValue: computedValue,
                                    normalisedValue: computedValue,
                                    rowNode: gridCell.rowNode,
                                    isPivotCell: false,
                                    isRowGroupCell: false
                                };
                            }
                        }
                    }
                });
                if (foundRule && replacementGridCell) {
                    const dataChangedEvent = this.api.internalApi.buildCellDataChangedInfo({
                        oldValue: Number(gridCell.rawValue),
                        newValue: replacementGridCell.rawValue,
                        column: gridCell.column,
                        primaryKeyValue: gridCell.primaryKeyValue,
                        rowNode: gridCell.rowNode,
                        trigger: 'edit'
                    });
                    let validationRules = this.api.internalApi.getValidationService().getValidationRulesForDataChange(dataChangedEvent);
                    if (validationRules.length > 0) failedPreventEdits.push(validationRules[0]);
                    else successfulValues.push(replacementGridCell);
                }
            }
        });
        this.ShowErrorPreventMessage(failedPreventEdits);
        if ((0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(successfulValues)) {
            const cellUpdateRequests = [];
            successfulValues.forEach((gridCell)=>{
                cellUpdateRequests.push({
                    columnId: gridCell.column.columnId,
                    newValue: gridCell.normalisedValue,
                    primaryKeyValue: gridCell.primaryKeyValue,
                    rowNode: gridCell.rowNode
                });
            });
            this.api.plusMinusApi.applyPlusMinus(cellUpdateRequests);
        }
        return shouldApplyPlusMinus;
    }
    isPlusMinusNudgeApplied(plusMinusNudge, gridCell) {
        if (plusMinusNudge.Rule?.BooleanExpression) return this.evaluateExpression(plusMinusNudge, gridCell.rowNode);
        return true;
    }
    evaluateExpression(plusMinusNudge, node) {
        try {
            return this.api.internalApi.getQueryLanguageService().evaluateBooleanExpression(plusMinusNudge.Rule?.BooleanExpression, (0, $42e863194fcb493f$export$1d33a3a77a9299ff), node);
        } catch (error) {
            (0, $10f858c943b30cc8$export$45c997b35cb132f6)(error.message);
            return false;
        }
    }
    ShowErrorPreventMessage(failedRules) {
        if (failedRules.length > 0) {
            let failedMessages = [];
            failedRules.forEach((fr)=>{
                let failedMessage = this.api.internalApi.getValidationService().createValidationMessage(fr) + '\n';
                let existingMessage = failedMessages.find((f)=>f == failedMessage);
                if (existingMessage == null) failedMessages.push(failedMessage);
            });
            this.api.alertApi.showAlertError('Plus/Minus', 'One or more nudge values were rejected by validation rules: ' + failedMessages.toString());
        }
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.plusMinusApi.getAllPlusMinus(),
            AddAction: $36058826e464bb44$export$b57847b7da91dcb4,
            EditAction: $36058826e464bb44$export$15d09d450ef43f85
        };
    }
    toView(plusMinus) {
        return {
            abObject: plusMinus,
            items: [
                {
                    name: 'Name',
                    values: [
                        plusMinus.Name
                    ]
                },
                {
                    name: 'Target',
                    ...(0, $01403ab2be951cf5$export$4abcb9ed8272134c)(plusMinus.Scope, this.api)
                },
                plusMinus.Rule && {
                    name: 'Settings',
                    label: 'Rule',
                    values: (0, $60b27da1c4a88498$export$43359c935e54e9f1)(plusMinus.Rule, this.api).values
                },
                {
                    name: 'Settings',
                    label: 'Nudge Value',
                    values: [
                        plusMinus.NudgeValue
                    ]
                },
                (0, $52125728d99aa873$export$287b3702a135396b)(plusMinus, this.api)
            ].filter(Boolean)
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects({
            includeLayoutNotExtendedObjects: this.showLayoutNonExtendedObjects()
        }).map((plusMinus)=>this.toView(plusMinus));
    }
    getViewProperties() {
        return {
            actions: [
                (0, $f9fe28ddd157f96c$export$a5d9dbbf691550b7)
            ],
            getEditAction: $36058826e464bb44$export$15d09d450ef43f85,
            getDeleteAction: $36058826e464bb44$export$94d9a67dbae3ab19,
            getSuspendAction: $36058826e464bb44$export$4147f49703def3fa,
            getUnSuspendAction: $36058826e464bb44$export$e1c560b2519d0821,
            getSuspendAllAction: $36058826e464bb44$export$c11ea8af075e1ee0,
            getUnSuspendAllAction: $36058826e464bb44$export$d6bc9564f73af63e,
            getEditWizard () {
                return 0, $b386ac23fcf87e33$export$fc1cd112329d55a3;
            }
        };
    }
    containsLayoutExtensions() {
        return true;
    }
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


const $d915c8074de8927b$export$e55c23b452e4455d = (props)=>{
    const [searchText, setSearchText] = (0, $acw62.useState)(props.QuickSearchText ?? '');
    const debouncedRunQuickSearch = (0, $acw62.useMemo)(()=>(0, $c34d1d35432b7498$export$2e2bcd8739ae039)(props.onRunQuickSearch, (0, $58846ea7f4156db7$export$243785e1cb1b9e1a)), [
        props.onRunQuickSearch
    ]);
    (0, $acw62.useEffect)(()=>{
        setSearchText(props.QuickSearchText);
    }, [
        props.QuickSearchText
    ]);
    const executeSearch = (searchText)=>{
        setSearchText(searchText);
        debouncedRunQuickSearch(searchText);
    };
    return [
        searchText,
        executeSearch
    ];
};






const $24eb18c810e68a5c$export$29e8bfda34c26ba7 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const QuickSearchText = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.QuickSearch.QuickSearchText);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const onRunQuickSearch = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((newQuickSearchText)=>dispatch($a9684a89f07662ba$export$e6464f631b683a94(newQuickSearchText)), []);
    const isServerSideRowModel = adaptable.api.gridApi.getAgGridRowModelType() === 'serverSide';
    const [searchText, search] = (0, $d915c8074de8927b$export$e55c23b452e4455d)({
        QuickSearchText: QuickSearchText,
        onRunQuickSearch: onRunQuickSearch
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0f5e3272866deca2$export$6e10b3df66bf9f52), {
        onClick: props.onClick,
        "aria-label": 'Quick Search',
        type: "text",
        autoFocus: props.autoFocus,
        placeholder: adaptable.api.optionsApi.getQuickSearchOptions().quickSearchPlaceholder,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('ab-QuickSearch__control twa:h-full twa:min-h-input', props.className),
        value: searchText,
        OnTextChange: search,
        inputClassName: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:w-[10rem]', props.inputClassName),
        actionTools: isServerSideRowModel ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "row",
            alignItems: "center",
            className: "twa:flex-none"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "aria-label": 'Previous Match',
            icon: "arrow-up",
            className: "twa:px-0 twa:py-0 twa:mr-1",
            disabled: !searchText,
            variant: "text",
            onClick: ()=>adaptable.api.quickSearchApi.gotoPreviousMatch()
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "aria-label": 'Next Match',
            icon: "arrow-down",
            className: "twa:px-0 twa:py-0 twa:mr-1",
            disabled: !searchText,
            variant: "text",
            onClick: ()=>adaptable.api.quickSearchApi.gotoNextMatch()
        }))
    });
};


const $7e0fc84232de5fbd$export$9560e8134832e060 = ()=>{
    return $acw62.createElement((0, $24eb18c810e68a5c$export$29e8bfda34c26ba7), {
        onClick: (event)=>event.stopPropagation()
    });
};



class $1e1484d9cd25466c$export$e91e2ed8ea7ffd8e extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$cf7621e489e71e3c, $42e863194fcb493f$export$e226d3e36d512400, 'search-table', 'QuickSearchPopup', 'Quickly highlight all cells in the grid that contain matching query text', api);
    }
    getAgGridModuleDependencies() {
        return [
            'FindModule'
        ];
    }
    getViewProperties() {
        return {
            getStatusBarPanelProps () {
                return {
                    content: (0, $7e0fc84232de5fbd$export$9560e8134832e060)
                };
            }
        };
    }
    onAdaptableReady() {
        const { api: api } = this;
        const { internalApi: internalApi, agGridApi: agGridApi } = api;
        // Check for AG Grid QuickFilterModule if running Filter After Quick Search
        if (api.optionsApi.getQuickSearchOptions().filterGridAfterQuickSearch) {
            if (!api.internalApi.getAgGridModulesAdapter().isAgGridModuleRegistered('QuickFilterModule')) api.consoleError('Quick Search with filterGridAfterQuickSearch requires the AG Grid "QuickFilterModule". Quick Search will run but grid filters will not be applied.');
        }
        const isServerSideRowModel = agGridApi.getGridOption('rowModelType') === 'serverSide';
        if (isServerSideRowModel && internalApi.getAdaptableState().QuickSearch.CellMatchStyle === undefined) // for server side row model,
        // let's setup some defaults if there are no styles set
        // as there are no defaults in the AG Grid find functionality (as it only works for non ssrm)
        // so we need to set the defaults here
        this.api.internalApi.dispatchReduxAction((0, $a9684a89f07662ba$export$fe53e034aaf6474a)((0, $a9684a89f07662ba$export$b30fee7900c0f46f)));
    }
}





var $hrtGQ = parcelRequire("hrtGQ");

var $9g4SS = parcelRequire("9g4SS");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $hrtGQ = parcelRequire("hrtGQ");

var $acw62 = parcelRequire("acw62");






const $fe4a93482453cc43$var$MESSAGE_TYPES = [
    'Success',
    'Info',
    'Warning',
    'Error'
];
const $fe4a93482453cc43$export$6b50d6e3237ffa30 = (props)=>{
    const messageTypes = $fe4a93482453cc43$var$MESSAGE_TYPES.map((messageType)=>({
            label: messageType,
            value: messageType,
            onClick: ()=>{
                props.onChange({
                    ...props.reminderSchedule,
                    MessageType: messageType
                });
            }
        }));
    const handleNameChange = (event)=>{
        props.onChange({
            ...props.reminderSchedule,
            Name: event.target.value
        });
    };
    const handleHeaderChange = (event)=>{
        props.onChange({
            ...props.reminderSchedule,
            Header: event.target.value
        });
    };
    const handleMessageChange = (event)=>{
        props.onChange({
            ...props.reminderSchedule,
            Message: event.target.value
        });
    };
    const handleDisplayNotificationChange = (checked)=>{
        props.onChange({
            ...props.reminderSchedule,
            DisplayNotification: checked
        });
    };
    const handleDisplaySystemStatusChange = (checked)=>{
        props.onChange({
            ...props.reminderSchedule,
            DisplaySystemStatusMessage: checked
        });
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "schedule-settings-reminder"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "schedule-name",
        className: "twa:w-[300px]",
        onChange: handleNameChange,
        placeholder: "Enter Reminder Name",
        type: "string",
        value: props.reminderSchedule?.Name ?? ''
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:h-2"
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Header"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "header",
        className: "twa:w-[300px]",
        onChange: handleHeaderChange,
        placeholder: "Enter Reminder Header",
        type: "string",
        value: props.reminderSchedule?.Header
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Message"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "message",
        className: "twa:w-[300px]",
        onChange: handleMessageChange,
        placeholder: "Enter Reminder Message",
        type: "string",
        value: props.reminderSchedule?.Message
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Type"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[300px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "data-name": "message-type",
        placeholder: "Select Option",
        options: messageTypes,
        value: props.reminderSchedule?.MessageType,
        onChange: (value)=>{
            props.onChange({
                ...props.reminderSchedule,
                MessageType: value
            });
        }
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "display-notification",
        checked: props.reminderSchedule?.DisplayNotification,
        onChange: handleDisplayNotificationChange
    }, "Show the Reminder as a Notification")), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "display-system-status",
        checked: props.reminderSchedule?.DisplaySystemStatusMessage,
        onChange: handleDisplaySystemStatusChange
    }, "Display a System Status Message"))))));
};



var $acw62 = parcelRequire("acw62");





const $201780a1d5972be3$export$3804fb5d81884585 = (props)=>{
    const handleNameChange = (event)=>{
        props.onChange({
            ...props.report,
            Name: event.target.value
        });
    };
    const reportOptions = props.allReports.map((report)=>({
            label: report.Name,
            value: report.Name
        }));
    const formatOptions = props.allFormats.map((reportFormat)=>({
            label: reportFormat,
            value: reportFormat,
            onClick: ()=>{
                props.onChange({
                    ...props.report,
                    ReportFormat: reportFormat
                });
            }
        }));
    const destinationOptions = props.allDestinations.map((destination)=>({
            label: destination,
            value: destination,
            onClick: ()=>{
                props.onChange({
                    ...props.report,
                    ExportDestination: destination
                });
            }
        }));
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "schedule-settings-report"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false,
        className: "twa:mb-3"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "schedule-name",
        className: "twa:w-[300px]",
        onChange: handleNameChange,
        placeholder: "Enter Schedule Name",
        type: "string",
        value: props.report?.Name ?? ''
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:h-2"
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Export"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[300px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "data-name": "select-report",
        options: reportOptions,
        value: props?.report?.ReportName,
        placeholder: "Select Export",
        onChange: (value)=>props.onChange({
                ...props.report,
                ReportName: value
            })
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Format"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[300px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "data-name": "select-format",
        options: formatOptions,
        value: props?.report?.ReportFormat,
        placeholder: "Select Format",
        onChange: (value)=>props.onChange({
                ...props.report,
                ReportFormat: value
            })
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Destination"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[300px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "data-name": "select-destination",
        options: destinationOptions,
        value: props?.report?.ExportDestination,
        placeholder: "Select Format",
        onChange: (value)=>props.onChange({
                ...props.report,
                ExportDestination: value
            })
    })))))));
};



var $acw62 = parcelRequire("acw62");







const $1e7219c13e4e3878$export$719dc112fb1f1740 = (props)=>{
    const handleNameChange = (event)=>{
        props.onChange({
            ...props.iPushPull,
            Name: event.target.value
        });
    };
    const reportOptions = props.allReports.map((report)=>({
            label: report.Name,
            value: report.Name,
            onClick: ()=>props.onChange({
                    ...props.iPushPull,
                    IPushPullReport: {
                        ...props.iPushPull.IPushPullReport,
                        ReportName: report.Name
                    }
                })
        }));
    const folderOptions = props.allFolders.map((folder)=>({
            label: folder.Name,
            value: folder.Name,
            onClick: ()=>props.onChange({
                    ...props.iPushPull,
                    IPushPullReport: {
                        ...props.iPushPull.IPushPullReport,
                        Folder: folder.Name
                    }
                })
        }));
    const pagesOptions = props.availablePages.map((page)=>({
            label: page,
            value: page,
            onClick: ()=>props.onChange({
                    ...props.iPushPull,
                    IPushPullReport: {
                        ...props.iPushPull.IPushPullReport,
                        Page: page
                    }
                })
        }));
    const handleDataTypeChange = (Transmission)=>props.onChange({
            ...props.iPushPull,
            Transmission: Transmission
        });
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "schedule-settings-ipushpull"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "schedule-name",
        className: "twa:w-[300px]",
        onChange: handleNameChange,
        placeholder: "Enter Schedule Name",
        type: "string",
        value: props.iPushPull?.Name ?? ''
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:h-2"
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Select Report"
    }, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        "data-name": "report-name",
        disabled: props.allReports.length == 0,
        items: reportOptions,
        className: "twa:w-[300px]"
    }, props?.iPushPull?.IPushPullReport?.ReportName || 'Select Report')), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Select Folder"
    }, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        "data-name": "folder-name",
        disabled: props.allFolders.length == 0,
        items: folderOptions,
        className: "twa:w-[300px]"
    }, props?.iPushPull?.IPushPullReport?.Folder || 'Select Folder')), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Select Page"
    }, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        "data-name": "page-name",
        disabled: props.allFolders.length == 0,
        items: pagesOptions,
        className: "twa:w-[300px]"
    }, props?.iPushPull?.IPushPullReport?.Page || 'Select Page')), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Data Type"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "data-type",
        className: "twa:mr-3",
        value: "Snapshot",
        checked: props.iPushPull.Transmission === 'Snapshot',
        onChange: (checked)=>checked && handleDataTypeChange('Snapshot')
    }, "Snapshot (one off report)"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "data-live",
        value: "Live Data",
        checked: props.iPushPull.Transmission === 'Live Data',
        onChange: (checked)=>checked && handleDataTypeChange('Live Data')
    }, "Live Data (real-time updates)")), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$dd180a7fd9107bd4), null, "Choose whether to send ipushpull Data as 'Snapshot' (One-off report) or 'Live Data' (updating as Grid updates)"))))));
};



var $acw62 = parcelRequire("acw62");





const $b993930d660952cd$export$6b6e961ba8d9af5a = (props)=>{
    const handleNameChange = (event)=>{
        props.onChange({
            ...props.openFin,
            Name: event.target.value
        });
    };
    const reportOptions = props.allReports.map((report)=>({
            label: report.Name,
            value: report.Name,
            onClick: ()=>props.onChange({
                    ...props.openFin,
                    OpenFinReport: {
                        ...props.openFin.OpenFinReport,
                        ReportName: report.Name
                    }
                })
        }));
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "schedule-settings-openfin"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "schedule-name",
        className: "twa:w-[300px]",
        onChange: handleNameChange,
        placeholder: "Enter Schedule Name",
        type: "string",
        value: props.openFin?.Name ?? ''
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:h-2"
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Select Report"
    }, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        "data-name": "select-report",
        columns: [
            'label'
        ],
        className: "twa:w-[300px]",
        disabled: props.allReports.length == 0,
        items: reportOptions
    }, props?.openFin?.OpenFinReport?.ReportName || 'Select Report'))))));
};


const $445bd547e0dfbcd8$export$e5dbf01e21782f22 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const allReports = api.exportApi.getAllReports();
    if (data?.ScheduleType === (0, $hrtGQ.ScheduleType).Reminder) return $acw62.createElement((0, $fe4a93482453cc43$export$6b50d6e3237ffa30), {
        reminderSchedule: data,
        onChange: props.onChange
    });
    if (data?.ScheduleType === (0, $hrtGQ.ScheduleType).Report) {
        const allFormats = api.exportApi.getAvailableSystemFormats();
        const allDestinations = api.exportApi.getAllExportDestinations();
        return $acw62.createElement((0, $201780a1d5972be3$export$3804fb5d81884585), {
            allReports: allReports ?? [],
            allFormats: allFormats ?? [],
            allDestinations: allDestinations ?? [],
            report: data,
            onChange: props.onChange
        });
    }
    if (data?.ScheduleType === (0, $hrtGQ.ScheduleType).ipushpull) {
        const ippApi = api.pluginsApi.getipushpullPluginApi();
        const allFolders = ippApi && ippApi.getIPushPullDomains();
        const folderName = data.IPushPullReport.Folder;
        const availablePages = ippApi && folderName && ippApi.getPagesForIPushPullDomain(folderName);
        return $acw62.createElement((0, $1e7219c13e4e3878$export$719dc112fb1f1740), {
            allReports: allReports || [],
            allFolders: allFolders || [],
            availablePages: availablePages || [],
            iPushPull: data,
            onChange: props.onChange
        });
    }
    if (data?.ScheduleType === (0, $hrtGQ.ScheduleType).OpenFin) return $acw62.createElement((0, $b993930d660952cd$export$6b6e961ba8d9af5a), {
        allReports: allReports || [],
        openFin: data,
        onChange: props.onChange
    });
    return $acw62.createElement($acw62.Fragment, null);
};



var $acw62 = parcelRequire("acw62");


var $hrtGQ = parcelRequire("hrtGQ");

const $74557918a583b323$export$ac764fae1c25f051 = (data)=>{
    if (data.ScheduleType === (0, $hrtGQ.ScheduleType).Reminder) {
        const reminder = data;
        return [
            {
                label: 'Header',
                value: reminder?.Header || 'Not Specified'
            },
            {
                label: 'Message',
                value: reminder?.Message || 'Not Specified'
            },
            {
                label: 'Message Type',
                value: reminder?.MessageType || 'Not Specified'
            },
            {
                label: 'Display Toast Notification',
                value: reminder?.DisplayNotification ? 'True' : 'False'
            },
            {
                label: 'Show System Status Message',
                value: reminder?.DisplaySystemStatusMessage ? 'True' : 'False'
            }
        ];
    }
    if (data.ScheduleType === (0, $hrtGQ.ScheduleType).Report) {
        const report = data;
        return [
            {
                label: 'Report Name',
                value: report?.ReportName || 'Not Specified'
            },
            {
                label: 'Report Format',
                value: report?.ReportFormat || 'Not Specified'
            },
            {
                label: 'Export Destination',
                value: report?.ExportDestination || 'Download'
            }
        ];
    }
    if (data.ScheduleType === (0, $hrtGQ.ScheduleType).ipushpull) {
        const report = data;
        return [
            {
                label: 'Report',
                value: report?.IPushPullReport.ReportName || 'Not Specified'
            },
            {
                label: 'Folder',
                value: report?.IPushPullReport.Folder || 'Not Specified'
            },
            {
                label: 'Page',
                value: report?.IPushPullReport.Page || 'Not Specified'
            },
            {
                label: 'Export As',
                value: report?.Transmission || 'Not Specified'
            }
        ];
    }
    if (data.ScheduleType === (0, $hrtGQ.ScheduleType).OpenFin) {
        const report = data;
        return [
            {
                label: 'Report',
                value: report?.OpenFinReport.ReportName || 'Not Specified'
            }
        ];
    }
    return [];
};
const $74557918a583b323$export$59591062c972d2d5 = ()=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement($acw62.Fragment, null, $74557918a583b323$export$ac764fae1c25f051(data).map((description, index)=>$acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), {
            key: index
        }, description.label, ": ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, description.value))));
};



var $hrtGQ = parcelRequire("hrtGQ");

var $9OAZF = parcelRequire("9OAZF");
const $246e1c79b3fb53cc$export$bd1cc8e0fb715366 = (schedule, api)=>{
    // Validate Name - mandatory and unique
    if (!schedule.Name?.trim()) return 'A name is required.';
    const allSchedules = api.scheduleApi.getSchedules();
    const isDuplicateName = allSchedules.some((s)=>s.Name === schedule.Name && s.Uuid !== schedule.Uuid);
    if (isDuplicateName) return 'A Schedule with this name already exists.';
    if (schedule.ScheduleType === (0, $hrtGQ.ScheduleType).Reminder) {
        const reminder = schedule;
        if (!reminder.MessageType) return 'Please select a message type.';
        if ((0, $9OAZF.default).IsNullOrEmpty(reminder?.Header)) return 'A reminder header is required.';
        if ((0, $9OAZF.default).IsNullOrEmpty(reminder?.Message)) return 'A reminder message is required.';
    }
    if (schedule.ScheduleType === (0, $hrtGQ.ScheduleType).Report) {
        const report = schedule;
        if ((0, $9OAZF.default).IsNullOrEmpty(report?.ReportName)) return 'Please select a report.';
        if ((0, $9OAZF.default).IsNullOrEmpty(report?.ReportFormat)) return 'Please select a report format.';
    }
    if (schedule.ScheduleType === (0, $hrtGQ.ScheduleType).ipushpull) {
        const ipushpull = schedule;
        if ((0, $9OAZF.default).IsNullOrEmpty(ipushpull?.IPushPullReport?.ReportName)) return 'Please select a report.';
        if ((0, $9OAZF.default).IsNullOrEmpty(ipushpull?.IPushPullReport?.Folder)) return 'Please select a report folder.';
        if ((0, $9OAZF.default).IsNullOrEmpty(ipushpull?.IPushPullReport?.Page)) return 'Please select a report page.';
    }
    if (schedule.ScheduleType === (0, $hrtGQ.ScheduleType).OpenFin) {
        const openfin = schedule;
        if ((0, $9OAZF.default).IsNullOrEmpty(openfin?.OpenFinReport?.ReportName)) return 'Please select a report.';
    }
    return true;
};





var $acw62 = parcelRequire("acw62");





var $9g4SS = parcelRequire("9g4SS");



const $6345c7b4c6f8fc45$export$3b0f40acae3b139c = (schedule, isOneOff)=>{
    if (!schedule.Schedule) return 'Schedule is not specified';
    if (schedule.Schedule.Hour === null || schedule.Schedule.Minute === null) return 'Schedule Time is not specified';
    if (isOneOff && !schedule.Schedule.OneOffDate) return 'Schedule Date is not specified';
    if (!isOneOff && (0, $9g4SS.default).IsEmpty(schedule?.Schedule?.DaysOfWeek)) return 'Schedule Days are not specified';
    return true;
};
const $6345c7b4c6f8fc45$var$daysMap = [
    {
        label: 'Monday',
        value: 'Monday'
    },
    {
        label: 'Tuesday',
        value: 'Tuesday'
    },
    {
        label: 'Wednesday',
        value: 'Wednesday'
    },
    {
        label: 'Thursday',
        value: 'Thursday'
    },
    {
        label: 'Friday',
        value: 'Friday'
    },
    {
        label: 'Saturday',
        value: 'Saturday'
    },
    {
        label: 'Sunday',
        value: 'Sunday'
    }
];
const $6345c7b4c6f8fc45$export$62fbf4b6a093f1d2 = (props)=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const handleIsOneOfChange = (isOneOffNew)=>{
        props.onSetIsOneOff(isOneOffNew);
        const OneOffDate = !isOneOffNew ? null : data?.Schedule?.OneOffDate;
        const DaysOfWeek = isOneOffNew ? [] : data?.Schedule?.DaysOfWeek;
        props.onChange({
            ...data,
            Schedule: {
                ...data.Schedule,
                OneOffDate: OneOffDate,
                DaysOfWeek: DaysOfWeek
            }
        });
    };
    const handleTimeChange = (event)=>{
        const [hours, minutes] = (event.target.value || '00:00')?.split(':')?.map((item)=>parseInt(item, 10));
        props.onChange({
            ...data,
            Schedule: {
                ...data.Schedule,
                Hour: hours,
                Minute: minutes
            }
        });
    };
    const handleDayChange = (checked, day)=>{
        let newDays = data.Schedule.DaysOfWeek || [];
        if (checked) newDays = [
            ...newDays,
            day
        ];
        else newDays = newDays.filter((previousDay)=>previousDay !== day);
        props.onChange({
            ...data,
            Schedule: {
                ...data.Schedule,
                DaysOfWeek: newDays
            }
        });
    };
    const handleOneOfDateChange = (event)=>{
        props.onChange({
            ...data,
            Schedule: {
                ...data.Schedule,
                OneOffDate: event.target.value
            }
        });
    };
    let timeValue = '00:00';
    if (typeof data.Schedule?.Hour === 'number' || typeof data?.Schedule?.Minute === 'number') {
        const hours = `${data.Schedule?.Hour}` || '00';
        const minute = `${data.Schedule?.Minute}` || '00';
        timeValue = `${hours.padStart(2, '0')}:${minute.padStart(2, '0')}`;
    }
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "schedule-setup"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Schedule"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Frequency"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "frequency-recurring",
        className: "twa:mr-2",
        value: "recurring",
        checked: !props.isOneOff,
        onChange: (checked)=>checked && handleIsOneOfChange(false)
    }, "Recurring Days"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        "data-name": "frequency-one-off",
        checked: props.isOneOff,
        value: "oneoff",
        onChange: (checked)=>checked && handleIsOneOfChange(true)
    }, "One-Off Date")), props.isOneOff ? $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Date"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        "data-name": "one-off-date",
        className: "twa:w-[300px]",
        type: "date",
        placeholder: "Date",
        onChange: handleOneOfDateChange,
        value: data.Schedule?.OneOffDate || ''
    })) : $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Days"
    }, $6345c7b4c6f8fc45$var$daysMap.map((day)=>$acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            "data-name": `day-${day.value}`,
            className: "twa:ml-2 twa:w-1/3",
            value: day.value,
            checked: data.Schedule?.DaysOfWeek?.includes(day.value),
            key: day.value,
            onChange: (checked)=>handleDayChange(checked, day.value)
        }, day.label))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Time"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        "data-name": "time",
        className: "twa:w-[300px]",
        value: timeValue,
        type: "time",
        onChange: handleTimeChange
    }))))));
};



var $acw62 = parcelRequire("acw62");


var $5aWMQ = parcelRequire("5aWMQ");

const $41fbae4769c011bb$export$62afde5e1eb23bd = ()=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), null, "Schedule: ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, (0, $5aWMQ.UIHelper).getScheduleDescription(data.Schedule)));
};



var $hrtGQ = parcelRequire("hrtGQ");





const $85ef93814a72a068$export$317c23cf0d909902 = (props)=>{
    const data = props.data ?? props.popupParams?.value;
    const isNew = props.popupParams?.action ? props.popupParams.action === 'New' : !props.data;
    const scheduleType = data ? data.ScheduleType : props?.abObjectType?.name;
    const [schedule, setSchedule] = $acw62.useState(()=>{
        if (data) return data;
        let scheduleState = null;
        switch(scheduleType){
            case (0, $hrtGQ.ScheduleType).Reminder:
                scheduleState = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyReminderSchedule();
                break;
            case (0, $hrtGQ.ScheduleType).Report:
                scheduleState = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyReportSchedule();
                break;
            case (0, $hrtGQ.ScheduleType).ipushpull:
                scheduleState = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyIPushPullSchedule();
                break;
            case (0, $hrtGQ.ScheduleType).OpenFin:
                scheduleState = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyOpenFinSchedule();
                break;
        }
        return scheduleState;
    });
    const [isOneOff, setIsOneOff] = $acw62.useState(false);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleFinish = ()=>{
        let action = null;
        if (!isNew) switch(scheduleType){
            case (0, $hrtGQ.ScheduleType).Reminder:
                action = $bb63955874685545$export$a013643dfd3ba9a6(schedule);
                break;
            case (0, $hrtGQ.ScheduleType).Report:
                action = $bb63955874685545$export$c7092aaffe90ec2f(schedule);
                break;
            case (0, $hrtGQ.ScheduleType).ipushpull:
                action = $bb63955874685545$export$24a7aedf87930eef(schedule);
                break;
            case (0, $hrtGQ.ScheduleType).OpenFin:
                action = $bb63955874685545$export$9c48a79fad9fd033(schedule);
                break;
        }
        else switch(scheduleType){
            case (0, $hrtGQ.ScheduleType).Reminder:
                action = $bb63955874685545$export$70bc39e24de4957e(schedule);
                break;
            case (0, $hrtGQ.ScheduleType).Report:
                action = $bb63955874685545$export$4a744ac1b34f8f67(schedule);
                break;
            case (0, $hrtGQ.ScheduleType).ipushpull:
                action = $bb63955874685545$export$e222f78188cd2696(schedule);
                break;
            case (0, $hrtGQ.ScheduleType).OpenFin:
                action = $bb63955874685545$export$b9fca2b9f0a6f24c(schedule);
                break;
        }
        dispatch(action);
        props.onFinishWizard(schedule);
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: schedule,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Settings',
                isValid: (0, $246e1c79b3fb53cc$export$bd1cc8e0fb715366),
                renderSummary: ()=>$acw62.createElement((0, $74557918a583b323$export$59591062c972d2d5), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-3"
                    }, $acw62.createElement((0, $445bd547e0dfbcd8$export$e5dbf01e21782f22), {
                        onChange: setSchedule
                    }))
            },
            {
                title: 'Schedule',
                isValid: (data)=>(0, $6345c7b4c6f8fc45$export$3b0f40acae3b139c)(data, isOneOff),
                renderSummary: ()=>$acw62.createElement((0, $41fbae4769c011bb$export$62afde5e1eb23bd), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-3"
                    }, $acw62.createElement((0, $6345c7b4c6f8fc45$export$62fbf4b6a093f1d2), {
                        isOneOff: isOneOff,
                        onSetIsOneOff: setIsOneOff,
                        onChange: setSchedule
                    }))
            },
            {
                details: 'Select Schedule Tags',
                title: 'Tags',
                isVisible: (_, api)=>api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setSchedule
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null));
                },
                title: 'Summary'
            }
        ]
    });
};




var $5aWMQ = parcelRequire("5aWMQ");


const $31173d676d3230c8$var$dateTimeouts = {};
const $31173d676d3230c8$var$NodeSchedule = {
    scheduleJob: (date, schedule, api, fn)=>{
        const timestamp = +date;
        const now = Date.now();
        const timeUntilDate = timestamp - now;
        if (timeUntilDate > 0) {
            const timeoutId = +setTimeout(()=>{
                fn();
                api.eventApi.internalApi.fireScheduleTriggeredEvent(schedule);
            }, timeUntilDate);
            $31173d676d3230c8$var$dateTimeouts[timestamp] = timeoutId;
        }
        return {
            cancel: ()=>{
                const theTimeout = $31173d676d3230c8$var$dateTimeouts[timestamp];
                if (theTimeout != undefined) clearTimeout(theTimeout);
            }
        };
    }
};
class $31173d676d3230c8$export$601f3c059bcd564f extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    scheduleJobs;
    constructor(api){
        super($42e863194fcb493f$export$5dd6e67bf681ede8, $42e863194fcb493f$export$42a87414a14312dc, 'schedule', 'SchedulePopup', 'Schedule AdapTable functionality to run at times of your choosing (e.g. run reports)', api);
        this.scheduleJobs = [];
        this.addMidnightRefreshSchedule();
    }
    onAdaptableReady() {
        this.setUpScheduleJobs();
    }
    setUpScheduleJobs() {
        this.clearAllJobs();
        //add schedules
        this.api.scheduleApi.getActiveReminderSchedules().forEach((reminderSchedule)=>{
            this.addSchedule(reminderSchedule, (0, $hrtGQ.ScheduleType).Reminder);
        });
        // add Reports
        this.api.scheduleApi.getActiveReportSchedules().forEach((reportSchedule)=>{
            this.addSchedule(reportSchedule, (0, $hrtGQ.ScheduleType).Report);
        });
        this.api.scheduleApi.getActiveIPushPullSchedules().forEach((iPushPullSchedule)=>{
            this.addSchedule(iPushPullSchedule, (0, $hrtGQ.ScheduleType).ipushpull);
        });
        this.api.scheduleApi.getActiveOpenFinSchedules().forEach((OpenFinSchedule)=>{
            this.addSchedule(OpenFinSchedule, (0, $hrtGQ.ScheduleType).OpenFin);
        });
    // }
    }
    addSchedule(schedule, scheduleType) {
        const date = this.getDateFromSchedule(schedule.Schedule);
        if (date != null) {
            const alertJob = $31173d676d3230c8$var$NodeSchedule.scheduleJob(date, schedule, this.api, ()=>{
                this.api.scheduleApi.applySchedule(schedule, scheduleType);
            });
            this.scheduleJobs.push(alertJob);
        }
    }
    addMidnightRefreshSchedule() {
        const reloadSchedule = {
            Hour: 0,
            Minute: 1,
            DaysOfWeek: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ]
        };
        const date = this.getDateFromSchedule(reloadSchedule);
        date;
    }
    getDateFromSchedule(schedule) {
        let date = null;
        if (schedule.OneOffDate != null) {
            date = new Date(schedule.OneOffDate);
            date.setHours(schedule.Hour);
            date.setMinutes(schedule.Minute);
            date.setSeconds(0);
        } else {
            date = new Date();
            if ((0, $9g4SS.default).ContainsItem(schedule.DaysOfWeek, (0, $5aWMQ.default).getWeekDayByIndex(date.getDay()))) {
                date.setHours(schedule.Hour);
                date.setMinutes(schedule.Minute);
                date.setSeconds(0);
            } else return null; // because it will rerun at midnight so we can get rid
        }
        // add check for whether date in the past
        if (date != null && date > new Date()) return date;
        return null;
    }
    clearAllJobs() {
        this.scheduleJobs.forEach((j)=>{
            if (j != null) j.cancel();
        });
        this.scheduleJobs = [];
    }
    getModuleAdaptableObjects(config) {
        const accessLevel = this.api.entitlementApi.getEntitlementAccessLevelForModule(this.moduleInfo.ModuleName);
        const exportAcessLevel = this.api.entitlementApi.getEntitlementAccessLevelForModule($42e863194fcb493f$export$2bc329d2b6ae03ac);
        let allSchedules = [];
        if (accessLevel !== 'Hidden') allSchedules.push(...this.api.scheduleApi.getReminderSchedules(config));
        if (exportAcessLevel !== 'Hidden') allSchedules.push(...this.api.scheduleApi.getReportSchedules(config));
        allSchedules.push(...this.api.scheduleApi.getIPushPullSchedules(config));
        allSchedules.push(...this.api.scheduleApi.getOpenFinSchedules(config));
        return allSchedules;
    }
    toView(schedule) {
        return {
            abObject: schedule,
            items: [
                {
                    name: 'Name',
                    values: [
                        schedule.Name
                    ]
                },
                {
                    name: 'Settings',
                    values: (0, $74557918a583b323$export$ac764fae1c25f051)(schedule).map((description)=>`${description.label}: ${description.value}`)
                },
                {
                    name: 'Schedule',
                    values: [
                        (0, $5aWMQ.default).getScheduleDescription(schedule.Schedule)
                    ]
                },
                (0, $52125728d99aa873$export$287b3702a135396b)(schedule, this.api)
            ]
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects({
            includeLayoutNotExtendedObjects: this.showLayoutNonExtendedObjects()
        }).map((schedule)=>this.toView(schedule));
    }
    getViewProperties() {
        const accessLevel = this.api.entitlementApi.getEntitlementAccessLevelForModule(this.moduleInfo.ModuleName);
        const exportAcessLevel = this.api.entitlementApi.getEntitlementAccessLevelForModule($42e863194fcb493f$export$2bc329d2b6ae03ac);
        const abObjectTypes = [];
        const ippApi = this.api.pluginsApi.getipushpullPluginApi();
        const openFinApi = this.api.pluginsApi.getOpenFinPluginApi();
        if (accessLevel !== 'Hidden') abObjectTypes.push({
            name: 'Reminder',
            accessLevel: accessLevel
        });
        if (exportAcessLevel !== 'Hidden') abObjectTypes.push({
            name: 'Report',
            accessLevel: exportAcessLevel
        });
        if (ippApi && ippApi.isIPushPullRunning()) abObjectTypes.push({
            name: 'ipushpull',
            accessLevel: accessLevel
        });
        if (openFinApi && openFinApi.isOpenFinRunning()) abObjectTypes.push({
            name: 'OpenFin',
            accessLevel: accessLevel
        });
        return {
            abObjectTypes: abObjectTypes,
            getEditAction: (schedule)=>{
                let editAction = null;
                switch(schedule.ScheduleType){
                    case (0, $hrtGQ.ScheduleType).Reminder:
                        editAction = $bb63955874685545$export$a013643dfd3ba9a6(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).Report:
                        editAction = $bb63955874685545$export$c7092aaffe90ec2f(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).ipushpull:
                        editAction = $bb63955874685545$export$24a7aedf87930eef(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).OpenFin:
                        editAction = $bb63955874685545$export$9c48a79fad9fd033(schedule);
                        break;
                }
                return editAction;
            },
            getDeleteAction: (schedule)=>{
                let deleteAction = null;
                switch(schedule.ScheduleType){
                    case (0, $hrtGQ.ScheduleType).Reminder:
                        deleteAction = $bb63955874685545$export$6039870450c4d55f(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).Report:
                        deleteAction = $bb63955874685545$export$a295a95489a73dd(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).ipushpull:
                        deleteAction = $bb63955874685545$export$3b36c3ae2efe31cb(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).OpenFin:
                        deleteAction = $bb63955874685545$export$7b14e381193389a3(schedule);
                        break;
                }
                return deleteAction;
            },
            getSuspendAction: (schedule)=>{
                let suspendAction = null;
                switch(schedule.ScheduleType){
                    case (0, $hrtGQ.ScheduleType).Reminder:
                        suspendAction = $bb63955874685545$export$8f8b9ba2ded34223(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).Report:
                        suspendAction = $bb63955874685545$export$d7ee5ae4dc83275e(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).ipushpull:
                        suspendAction = $bb63955874685545$export$ea59ca87e7d93968(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).OpenFin:
                        suspendAction = $bb63955874685545$export$d605754f43ab43ce(schedule);
                        break;
                }
                return suspendAction;
            },
            getUnSuspendAction: (schedule)=>{
                let unSuspendAction = null;
                switch(schedule.ScheduleType){
                    case (0, $hrtGQ.ScheduleType).Reminder:
                        unSuspendAction = $bb63955874685545$export$86f0f6bc1579d292(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).Report:
                        unSuspendAction = $bb63955874685545$export$62ab8e50b7e8ae89(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).ipushpull:
                        unSuspendAction = $bb63955874685545$export$e680ef46686b2048(schedule);
                        break;
                    case (0, $hrtGQ.ScheduleType).OpenFin:
                        unSuspendAction = $bb63955874685545$export$751f7472244e1a50(schedule);
                        break;
                }
                return unSuspendAction;
            },
            getEditWizard () {
                return 0, $85ef93814a72a068$export$317c23cf0d909902;
            }
        };
    }
    containsLayoutExtensions() {
        return true;
    }
}





var $hrtGQ = parcelRequire("hrtGQ");


var $9g4SS = parcelRequire("9g4SS");

class $908b1e4108668a4d$export$14b2e5f093b518fb extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$3fb170c57e2678e6, $42e863194fcb493f$export$98c9ce2425ae8ca1, 'edit', 'SmartEditPopup', 'Edit groups of numeric cells using mathematical operations (e.g. Multiply by 10)', api);
    }
    getViewAccessLevel() {
        return 'Full';
    }
    createContextMenuItems(menuContext) {
        // not sure if this is right but logic is that
        // if the context cell is one of a selection taht can have smart edit applied
        // then open the smart edit screen
        // perhaps this is faulty logic though?
        let menuItemShowPopup = undefined;
        if (!menuContext.isRowGroupColumn && this.isModuleEditable()) {
            if (menuContext.adaptableColumn && menuContext.adaptableColumn.dataType == 'number' && menuContext.isSelectedCell && menuContext.isSingleSelectedColumn && this.api.gridApi.isEveryCellEditable(menuContext.selectedCellInfo.gridCells)) {
                let popUpParams = {
                    source: 'ContextMenu'
                };
                menuItemShowPopup = this.createMainMenuItemShowPopup({
                    Name: 'smart-edit-apply',
                    Label: 'Apply Smart Edit',
                    ComponentName: this.moduleInfo.Popup,
                    Icon: this.moduleInfo.Glyph,
                    PopupParams: popUpParams
                });
            }
        }
        return [
            menuItemShowPopup
        ];
    }
    CheckCorrectCellSelection() {
        let selectedCellInfo = this.api.gridApi.getSelectedCellInfo();
        if (this.api.layoutApi.isCurrentLayoutPivot()) return {
            Alert: {
                alertType: 'generic',
                header: 'Smart Edit',
                message: 'Editing is not available in Pivot Mode.',
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
            }
        };
        if (selectedCellInfo == null || (0, $9g4SS.default).IsNullOrEmpty(selectedCellInfo.columns)) return {
            Alert: {
                alertType: 'generic',
                header: 'Smart Edit',
                message: 'No cells selected. Please select one or more cells to continue.',
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
            }
        };
        if ((0, $9g4SS.default).NotCorrectLength(selectedCellInfo.columns, 1)) return {
            Alert: {
                alertType: 'generic',
                header: 'Smart Edit',
                message: 'Smart Edit supports editing a single column at a time. Please adjust your selection.',
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
            }
        };
        let column = selectedCellInfo.columns[0];
        if (column) {
            if (column.dataType != 'number') return {
                Alert: {
                    alertType: 'generic',
                    header: 'Smart Edit',
                    message: 'Smart Edit only applies to numeric columns. Please adjust your selection.',
                    alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
                }
            };
        }
        if ((0, $9g4SS.default).IsNotNullOrEmpty(selectedCellInfo.gridCells) && !this.api.gridApi.isEveryCellEditable(selectedCellInfo.gridCells)) return {
            Alert: {
                alertType: 'generic',
                header: 'Smart Edit',
                message: 'Smart Edit is not available for read-only cells. Please adjust your selection.',
                alertDefinition: (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateInternalAlertDefinitionForMessages('Error')
            }
        };
        return {
            ActionReturn: true
        };
    }
    BuildPreviewValues(smartEditValue, smartEditOperation) {
        let selectedCellInfo = this.api.gridApi.getSelectedCellInfo();
        let previewResults = [];
        let column;
        if (!this.api.layoutApi.isCurrentLayoutPivot()) {
            if ((0, $9g4SS.default).IsNotNullOrEmpty(selectedCellInfo.columns)) {
                column = this.api.columnApi.getColumnWithColumnId(selectedCellInfo.columns[0].columnId);
                if (column) selectedCellInfo.gridCells.forEach((selectedCell)=>{
                    let newValue;
                    if (typeof smartEditOperation === 'object') {
                        const context = {
                            smartEditValue: smartEditValue,
                            currentCell: selectedCell,
                            ...this.api.internalApi.buildBaseContext()
                        };
                        newValue = smartEditOperation.operation(context);
                    } else switch(smartEditOperation){
                        case (0, $hrtGQ.MathOperation).Add:
                            newValue = Number(selectedCell.rawValue) + smartEditValue;
                            break;
                        case (0, $hrtGQ.MathOperation).Subtract:
                            newValue = Number(selectedCell.rawValue) - smartEditValue;
                            break;
                        case (0, $hrtGQ.MathOperation).Multiply:
                            newValue = Number(selectedCell.rawValue) * smartEditValue;
                            break;
                        case (0, $hrtGQ.MathOperation).Divide:
                            newValue = Number(selectedCell.rawValue) / smartEditValue;
                            break;
                    }
                    //avoid the 0.0000000000x
                    if (newValue) newValue = parseFloat(newValue.toFixed(12));
                    let dataChangedEvent = this.api.internalApi.buildCellDataChangedInfo({
                        oldValue: Number(selectedCell.rawValue),
                        newValue: newValue,
                        column: selectedCell.column,
                        primaryKeyValue: selectedCell.primaryKeyValue,
                        rowNode: selectedCell.rowNode,
                        trigger: 'edit'
                    });
                    let validationRules = this.api.internalApi.getValidationService().getValidationRulesForDataChange(dataChangedEvent);
                    let previewResult = {
                        id: selectedCell.primaryKeyValue,
                        initialValue: Number(selectedCell.rawValue),
                        computedValue: newValue,
                        validationRules: validationRules,
                        rowNode: selectedCell.rowNode
                    };
                    previewResults.push(previewResult);
                });
            }
        }
        return {
            column: column,
            previewResults: previewResults,
            previewValidationSummary: (0, $ffbf29d095efdf81$export$69a3593e4bb2f3c1).GetPreviewValidationSummary(previewResults)
        };
    }
}






var $hrtGQ = parcelRequire("hrtGQ");

var $9g4SS = parcelRequire("9g4SS");

var $9OAZF = parcelRequire("9OAZF");

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


const $99755b6b88f56f03$export$4ad82551c600edaf = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const availableColumns = $acw62.useMemo(()=>api.columnApi.getNumericColumns(), []);
    return $acw62.createElement((0, $65308a7002d19b3b$export$b5842aa553688927), {
        availableDataTypes: [
            'number'
        ],
        scopeColumns: availableColumns,
        scope: data.Scope,
        descriptions: {
            rowScope: 'All Numeric Columns will have the Shortcut applied',
            columnScope: 'Selected Columns will have the Shortcut applied'
        },
        updateScope: (Scope)=>{
            let preparedScope = Scope;
            if (Scope && 'DataTypes' in Scope && Scope.DataTypes.length === 0) // default to checked
            preparedScope = {
                ...Scope,
                DataTypes: [
                    'number'
                ]
            };
            props.onChange({
                ...data,
                Scope: preparedScope
            });
        }
    });
};



var $acw62 = parcelRequire("acw62");


var $hrtGQ = parcelRequire("hrtGQ");
const $21cf74035a002277$export$d131828c1c107352 = [
    (0, $hrtGQ.MathOperation).Add,
    (0, $hrtGQ.MathOperation).Subtract,
    (0, $hrtGQ.MathOperation).Multiply,
    (0, $hrtGQ.MathOperation).Divide
];










const $945a75ff469e8d92$export$bd1cc8e0fb715366 = (data, api)=>{
    if (!data.Name?.trim()) return 'Name is required';
    const allShortcuts = api.shortcutApi.getShortcuts();
    const isDuplicateName = allShortcuts.some((s)=>s.Name === data.Name && s.Uuid !== data.Uuid);
    if (isDuplicateName) return 'A Shortcut already exists with that name';
    const shortcutKey = data.ShortcutKey && typeof data.ShortcutKey === 'string' ? '' : 'Shortcut key is not selected';
    const shortcutValue = typeof data.ShortcutValue === 'number' ? '' : 'Shortcut value is not specified';
    const shortcutOperation = data.ShortcutOperation && typeof data.ShortcutOperation === 'string' ? '' : 'Shortcut operation is not selected';
    const result = [
        shortcutKey,
        shortcutValue,
        shortcutOperation
    ].filter(Boolean);
    return result.length ? result.join(', ') : true;
};
const $945a75ff469e8d92$export$c5f3ce4b3289fd95 = ()=>{
    const { data: shortcut } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), null, "Name ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, shortcut.Name || 'Not specified')), $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), null, "Shortcut Key ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, shortcut.ShortcutKey || 'Not selected')), $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), null, "Value ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, shortcut.ShortcutValue ?? 'Not specified')), $acw62.createElement((0, $e70b2e3a7d03e2cc$export$4cb8a4f7658891b3), null, "Operation ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, shortcut.ShortcutOperation ?? 'Not Specified')));
};
const $945a75ff469e8d92$export$1a67097d60ae07fa = (props)=>{
    const { data: shortcut } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const handleNameChange = (event)=>{
        props.onChange({
            ...shortcut,
            Name: event.target.value
        });
    };
    const handleKeyChange = $acw62.useCallback((ShortcutKey)=>{
        props.onChange({
            ...shortcut,
            ShortcutKey: ShortcutKey
        });
    }, [
        shortcut
    ]);
    const handleOperationChange = $acw62.useCallback((ShortcutOperation)=>props.onChange({
            ...shortcut,
            ShortcutOperation: ShortcutOperation
        }), [
        shortcut
    ]);
    const handleOperationValueChange = $acw62.useCallback((event)=>{
        props.onChange({
            ...shortcut,
            ShortcutValue: event.target.value ? parseFloat(event.target.value) : event.target.value
        });
    }, [
        shortcut
    ]);
    const optionActions = (0, $21cf74035a002277$export$d131828c1c107352).map((operation)=>({
            value: operation,
            label: operation
        }));
    const optionKeys = props.availableKeys.map((key)=>({
            value: key,
            label: key
        }));
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "shortcut-column-settings"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Shortcut Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "shortcut-name",
        className: "twa:flex-1 twa:max-w-[200px] twa:mr-3",
        onChange: handleNameChange,
        placeholder: "Enter Name",
        value: shortcut.Name ?? ''
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:h-2"
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:text-2 twa:mb-0"
    }, "Keyboard key that, when pressed, triggers the Shortcut")), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Key"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "data-name": "shortcut-key",
        placeholder: "Select Key",
        options: optionKeys,
        onChange: (key)=>handleKeyChange(key),
        value: shortcut.ShortcutKey || 'Select Key'
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:text-2 twa:mb-0"
    }, "Mathematical operation performed on Cell's current value (using the Shortcut's 'value') - used to calculate the Cell's new total")), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Operation"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "data-name": "shortcut-operation",
        placeholder: "Select Operation",
        options: optionActions,
        onChange: (operation)=>handleOperationChange(operation),
        value: shortcut.ShortcutOperation
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:text-2 twa:mb-0"
    }, "Number that is used - together with the 'Operation' and the current cell value - to calculate the new total for the cell")), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Value"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        "data-name": "shortcut-value",
        className: "twa:flex-1 twa:max-w-[100px] twa:mr-3",
        onChange: handleOperationValueChange,
        placeholder: "Enter Number",
        type: "number",
        value: shortcut.ShortcutValue ?? ''
    })))))));
};





const $42faeaa9cb249f47$export$7a9436a8a97a2663 = [
    'A',
    'B',
    'C',
    'D',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
];






var $9OAZF = parcelRequire("9OAZF");
const $2a365ec95185389e$export$c0ef0758169f061e = (props)=>{
    const [shortcut, doSetShortcut] = $acw62.useState(()=>{
        const shortcut = props.data ? (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(props.data) : (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyShortcut();
        shortcut.Scope = shortcut.Scope ?? {
            All: true
        };
        if (props.popupParams?.column && props.popupParams?.action === 'New') shortcut.Scope = {
            ColumnIds: [
                props.popupParams.column.columnId
            ]
        };
        return shortcut;
    });
    const setShortcut = $acw62.useCallback((data)=>{
        doSetShortcut(data);
    }, []);
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const availableKeys = $acw62.useMemo(()=>{
        const availableKeys = (0, $42faeaa9cb249f47$export$7a9436a8a97a2663).filter((key)=>adaptable.api.shortcutApi.getShortcuts().every((shortcut)=>shortcut.ShortcutKey !== key));
        if (shortcut && (0, $9OAZF.default).IsNotNullOrEmptyOrWhiteSpace(shortcut.ShortcutKey)) availableKeys.push(shortcut.ShortcutKey);
        availableKeys.sort();
        return availableKeys;
    }, []);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleFinish = ()=>{
        if (props.data) dispatch($2172826b4c3056a0$export$1382c83aa7e9dbac(shortcut));
        else dispatch($2172826b4c3056a0$export$cf28c5d1cdf589fe(shortcut));
        props.onFinishWizard(shortcut);
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: shortcut,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Settings',
                isValid: (0, $945a75ff469e8d92$export$bd1cc8e0fb715366),
                details: $acw62.createElement($acw62.Fragment, null, "A Shortcut is a mathematical calculation (", $acw62.createElement("b", null, "Operation"), ") which is applied with the defined operand ", $acw62.createElement("b", null, "Value"), " on the edited cell content when the corresponding Shortcut ", $acw62.createElement("b", null, "Key"), " is pressed."),
                renderSummary: ()=>$acw62.createElement((0, $945a75ff469e8d92$export$c5f3ce4b3289fd95), null),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $945a75ff469e8d92$export$1a67097d60ae07fa), {
                        availableKeys: props.availableKeys ?? availableKeys,
                        onChange: setShortcut
                    }))
            },
            {
                title: 'Target',
                isValid: (0, $65308a7002d19b3b$export$37abad8a5da7760),
                details: 'Specify where Shortcut should be applied',
                renderSummary: ()=>(0, $65308a7002d19b3b$export$3f60d09dd2143243)(shortcut.Scope, {
                        scopeWholeRow: 'Shortcut is triggered for all numeric cells',
                        scopeColumns: 'Shortcut is triggered for cells in selected columns',
                        scopeDataTypes: 'Shortcut is triggered for all numeric cells'
                    }),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $99755b6b88f56f03$export$4ad82551c600edaf), {
                        onChange: setShortcut
                    }))
            },
            {
                details: 'Select Shortcut Tags',
                title: 'Tags',
                isVisible: (_, api)=>api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setShortcut
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                details: 'Review the Shortcut',
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null));
                },
                title: 'Summary'
            }
        ]
    });
};


const $4c72bfe0e35d77b1$export$30697b644c3cee98 = (shortcut)=>{
    const values = [
        `Shortcut Key: ${shortcut.ShortcutKey || 'Not selected'}`,
        `Value: ${shortcut.ShortcutValue ?? 'Not specified'}`,
        `Operation: ${shortcut.ShortcutOperation ?? 'Not Specified'}`
    ];
    return {
        name: 'Settings',
        values: values
    };
};




class $d300e4dbdd7eb83d$export$5494cf856edd6bfc extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    shouldHandleKeyDown;
    adaptable;
    constructor(api){
        super($42e863194fcb493f$export$ef61c24f038f357f, $42e863194fcb493f$export$60ad68ab2ff295ef, 'link', 'ShortcutPopup', 'Set up rules so cells update mathematically when keys are pressed in numeric cells', api);
        this.shouldHandleKeyDown = false;
        this.adaptable = api.internalApi.getAdaptableInstance();
    }
    getModuleAdaptableObjects(config) {
        return this.api.shortcutApi.getShortcuts(config);
    }
    hasNamedQueryReferences() {
        return false;
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.shortcutApi.getShortcuts(),
            AddAction: $2172826b4c3056a0$export$cf28c5d1cdf589fe,
            EditAction: $2172826b4c3056a0$export$1382c83aa7e9dbac
        };
    }
    onAdaptableReady() {
        this.checkListenToKeyDown();
        if (this.shouldHandleKeyDown) this.setupKeyDownListener();
    }
    setupKeyDownListener() {
        this.adaptable._on('CellEditorKeyDown', (cellEditorKeyDownEvent)=>{
            this.handleKeyDown(cellEditorKeyDownEvent);
        });
    }
    checkListenToKeyDown() {
        const shortcuts = this.api.shortcutApi.getShortcuts();
        this.shouldHandleKeyDown = (0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(shortcuts);
        if (this.shouldHandleKeyDown) this.setupKeyDownListener();
    }
    handleKeyDown(cellEditorKeyDownEvent) {
        if (!this.shouldHandleKeyDown || (0, $9OAZF.default).IsNullOrEmpty(cellEditorKeyDownEvent.cellValue)) return;
        const { keyDownEvent: keyDownEvent, cellValue: cellValue, columnId: columnId, updateValueCallback: updateValueCallback } = cellEditorKeyDownEvent;
        const matchingShortcut = this.api.shortcutApi.getActiveShortcuts().find((x)=>keyDownEvent.key.toLowerCase() === x.ShortcutKey.toLowerCase() && this.api.columnScopeApi.isColumnInScope(this.api.columnApi.getColumnWithColumnId(columnId), x.Scope));
        if (!matchingShortcut || !matchingShortcut.ShortcutValue) return;
        const newValue = this.calculateShortcut(cellValue, matchingShortcut.ShortcutValue, matchingShortcut.ShortcutOperation);
        // update the editor value
        updateValueCallback(newValue);
    }
    calculateShortcut(first, second, shortcutOperation) {
        let firstNumber = Number(first);
        let secondNumber = Number(second);
        switch(shortcutOperation){
            case (0, $hrtGQ.MathOperation).Add:
                return firstNumber + secondNumber;
            case (0, $hrtGQ.MathOperation).Subtract:
                return firstNumber - secondNumber;
            case (0, $hrtGQ.MathOperation).Multiply:
                return firstNumber * secondNumber;
            case (0, $hrtGQ.MathOperation).Divide:
                return firstNumber / secondNumber;
        }
    }
    toView(shortcut) {
        return {
            abObject: shortcut,
            items: [
                {
                    name: 'Name',
                    values: [
                        shortcut.Name
                    ]
                },
                (0, $01403ab2be951cf5$export$4abcb9ed8272134c)(shortcut.Scope, this.api),
                (0, $4c72bfe0e35d77b1$export$30697b644c3cee98)(shortcut),
                (0, $52125728d99aa873$export$287b3702a135396b)(shortcut, this.api)
            ]
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects({
            includeLayoutNotExtendedObjects: this.showLayoutNonExtendedObjects()
        }).map((shortcut)=>this.toView(shortcut));
    }
    getViewProperties() {
        return {
            getEditAction: $2172826b4c3056a0$export$1382c83aa7e9dbac,
            getDeleteAction: $2172826b4c3056a0$export$a5fd989017fb8235,
            getSuspendAction: $2172826b4c3056a0$export$22e447d5e4c01620,
            getUnSuspendAction: $2172826b4c3056a0$export$3b0cf718b694f89b,
            getSuspendAllAction: $2172826b4c3056a0$export$79ba5c952010fc13,
            getUnSuspendAllAction: $2172826b4c3056a0$export$dc49008b1a140c86,
            getEditWizard () {
                return 0, $2a365ec95185389e$export$c0ef0758169f061e;
            }
        };
    }
    containsLayoutExtensions() {
        return true;
    }
}




class $3fc4d5eef037acba$export$f1d99b83d64cea7 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$826ed58486b36acd, $42e863194fcb493f$export$d3066b78c0fe60e, 'assignment', 'StateManagementPopup', 'Manages Adaptable State, User State and Initial Adaptable State', api);
    }
}








var $acw62 = parcelRequire("acw62");





const $1866db82573d7d70$export$5fc168abf4509884 = (props)=>{
    const [isExpanded, setIsExpanded] = $acw62.useState(false);
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const moduleName = props.data.Module;
    const module = adaptable.ModuleService.getModuleById(moduleName);
    const sharedObject = props.data.Entity;
    const item = module?.toView(sharedObject);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:my-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:mr-2",
        alignItems: "center"
    }, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
        className: "twa:m-0"
    }, props.data.Module)), item ? isExpanded ? $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "shared-entity-collapse-button",
        onClick: ()=>setIsExpanded(false),
        icon: "arrow-up"
    }, "Collapse") : $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "shared-entity-expand-button",
        onClick: ()=>setIsExpanded(true),
        icon: "arrow-down"
    }, "Expand") : null), isExpanded && item && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        as: "ul",
        className: "ab-Shared-Entity-Shared-Object twa:p-0 twa:flex twa:flex-col twa:gap-3"
    }, $acw62.createElement((0, $e7b071cd434f710e$export$6fb29754fafb7fb1), {
        hideControls: true,
        data: item,
        module: module
    })));
};
const $1866db82573d7d70$export$41f9ae3c0adf0047 = (isDependency)=>(props)=>{
        const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
        const activeEntries = adaptable.api.internalApi.getState().TeamSharing.ActiveSharedEntityMap;
        const sharedEntity = props.data;
        const isAdaptableObjectPresentInLocalState = !!adaptable.api.internalApi.getModuleService().getModuleById('TeamSharing').isAdaptableObjectPresentInLocalState(sharedEntity);
        const isUpToDateAndActive = isAdaptableObjectPresentInLocalState && sharedEntity.Type === 'Active' && activeEntries[sharedEntity.Entity.Uuid]?.Revision === sharedEntity.Revision;
        const staleActiveEntities = adaptable.api.internalApi.getTeamSharingService().getStaleActiveSharedEntities();
        const isStaleAndActive = isAdaptableObjectPresentInLocalState && !!staleActiveEntities[sharedEntity.Uuid];
        let activeInfo = null;
        if (isAdaptableObjectPresentInLocalState) {
            const activeRevision = activeEntries?.[sharedEntity.Entity.Uuid]?.Revision;
            if (sharedEntity.Type === 'Active') {
                const newRevision = sharedEntity.Revision;
                let statusInfo = null;
                if (isUpToDateAndActive) statusInfo = $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                    className: "twa:ml-1 twa:text-success"
                }, $acw62.createElement("b", null, "up-to-date"));
                if (isStaleAndActive) statusInfo = $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                    className: "twa:ml-1 twa:text-warn"
                }, ` (Rev. ${newRevision} available)`);
                activeInfo = activeRevision && $acw62.createElement($acw62.Fragment, null, activeRevision && `Imported Rev. ${activeRevision} ${isStaleAndActive ? 'is stale' : ''} `, ' ', statusInfo);
            } else // snapshot
            activeInfo = activeRevision && $acw62.createElement($acw62.Fragment, null, `Imported Rev. ${activeRevision}`);
        }
        const sharedValue = `by ${sharedEntity.UserName} at ${new Date(sharedEntity.Timestamp).toLocaleString()}`;
        return $acw62.createElement($acw62.Fragment, null, !isDependency && $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, sharedValue), activeInfo && $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, activeInfo));
    };
const $1866db82573d7d70$export$2a3d8367aa4e15ab = (staleDependencies)=>()=>{
        let staleDepsString = 'Shared entity has';
        if (staleDependencies?.length === 1) staleDepsString += ` one (${staleDependencies[0].Module}) stale dependency`;
        else staleDepsString += ` ${staleDependencies.length} stale dependencies`;
        return $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:ml-1 twa:text-warn"
        }, staleDepsString));
    };



var $acw62 = parcelRequire("acw62");


const $328542350248b0e4$export$c624e5228eabe18e = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const handleImport = $acw62.useCallback(()=>{
        adaptable.api.teamSharingApi.importSharedEntry(props.data);
    }, []);
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "shared-entity-apply-button",
        onClick: handleImport,
        variant: "text",
        tooltip: "Import",
        icon: "import-export"
    });
};



var $acw62 = parcelRequire("acw62");




const $914dda8a1ae5387e$export$ae259cdcdd2b27b1 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dependencies = adaptable.api.teamSharingApi.internalApi.getSharedEntryDependencies(props.sharedEntity);
    return $acw62.createElement($acw62.Fragment, null, dependencies.map((sharedEntity)=>{
        const module = adaptable.ModuleService.getModuleById('TeamSharing');
        const itemView = module.toView(sharedEntity);
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            as: "ul",
            key: sharedEntity.Uuid,
            className: "ab-Shared-Entity-Shared-Object twa:mb-2 twa:p-0 twa:flex twa:flex-col twa:gap-3"
        }, $acw62.createElement((0, $e7b071cd434f710e$export$6fb29754fafb7fb1), {
            deleteTooltip: 'Cannot delete dependencies.',
            deleteDisabled: true,
            module: module,
            data: itemView
        }));
    }));
};
const $914dda8a1ae5387e$export$8c5cca511d848123 = (props)=>{
    const [isExpanded, setIsExpanded] = $acw62.useState(false);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: 'ab-Adaptable-Object-List__Item__label twa:mr-3'
    }, "Dependencies"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:my-2"
    }, isExpanded ? $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onClick: ()=>setIsExpanded(false),
        icon: "arrow-up"
    }, "Collapse") : $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onClick: ()=>setIsExpanded(true),
        icon: "arrow-down"
    }, "Expand"))), isExpanded && $acw62.createElement($914dda8a1ae5387e$export$ae259cdcdd2b27b1, {
        sharedEntity: props.data
    }));
};



var $9g4SS = parcelRequire("9g4SS");
/**
 * Flattens array a single level deep.
 * Drop-in replacement for lodash/flatten.
 */ function $826488674b2774ee$export$2e2bcd8739ae039(array) {
    return array.flat();
}



class $fa8ed542eb34daf4$export$2067c51f3488fae5 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    SKIP_TEAMSHARING_UPDATE_ACTIONS = [
        (0, $a6df66119ff073ff$export$70af566873cc6e56),
        (0, $a6df66119ff073ff$export$8eb888aade303dfa),
        (0, $a6df66119ff073ff$export$e65d69fb9378122f),
        (0, $a6df66119ff073ff$export$9ce2368b2015d7d6),
        (0, $a6df66119ff073ff$export$f13fba9da03b7b6a),
        (0, $a6df66119ff073ff$export$205e9d2e34ac8592),
        (0, $a6df66119ff073ff$export$3c05fc7ef53a6a50),
        (0, $a6df66119ff073ff$export$a59df55c0577dd8c)
    ];
    constructor(api){
        super($42e863194fcb493f$export$ecef34e06f3704d9, $42e863194fcb493f$export$9a5ef319e3555d1f, 'folder-shared', 'TeamSharingPopup', 'Team Sharing allows users to share - at run-time - Adaptable Objects between colleagues.', api);
    }
    onAdaptableReady() {
        if (this.api.teamSharingApi.isTeamSharingAvailable()) {
            // make sure there is no zombie import process remaining (in case a previous import crashed)
            this.api.internalApi.dispatchReduxAction($a6df66119ff073ff$export$3393dff032b18693());
            this.api.teamSharingApi.refreshTeamSharing();
        }
        this.api.eventApi.on('AdaptableStateChanged', (adaptableStateChangedInfo)=>this.handleStateChanged(adaptableStateChangedInfo));
    }
    isModuleEnabled() {
        const teamSharingOptions = this.api.optionsApi.getTeamSharingOptions();
        return teamSharingOptions?.enableTeamSharing && typeof teamSharingOptions?.loadSharedEntities === 'function' && typeof teamSharingOptions?.persistSharedEntities === 'function';
    }
    isModuleObjectsShareable() {
        return false;
    }
    getPopupMaxWidth() {
        return 1000;
    }
    handleStateChanged(adaptableStateChangedInfo) {
        // check if TeamSharing is activated
        if (!this.api.teamSharingApi.isTeamSharingAvailable()) return;
        // skip all teamsharing actions, otherwise we could get in an infinite loop
        if (this.SKIP_TEAMSHARING_UPDATE_ACTIONS.includes(adaptableStateChangedInfo.action.type)) return;
        // check if there is any changed adaptable object
        const changedAdaptableObject = this.extractAdaptableObjectFromAction(adaptableStateChangedInfo.action);
        if (!changedAdaptableObject) return;
        // check if the changed adaptable object is active in TeamSharing
        const activeSharedEntity = this.api.internalApi.getState().TeamSharing.ActiveSharedEntityMap[changedAdaptableObject.Uuid];
        if (!activeSharedEntity) return;
        // handle special case of LAYOUT_SAVE which might be called redundantly without actually changing the state
        const isLayoutStateUnchanged = adaptableStateChangedInfo.action.type === (0, $2c155f3e4804e29e$export$8b6b33d09d8d1be4) && (0, $f94a32af7542d5ef$export$2e2bcd8739ae039)(adaptableStateChangedInfo.oldState.Layout, adaptableStateChangedInfo.newState.Layout);
        if (isLayoutStateUnchanged) return;
        this.api.internalApi.dispatchReduxAction((0, $a6df66119ff073ff$export$ab923fc15395daa2)(changedAdaptableObject, adaptableStateChangedInfo.userName));
    }
    extractAdaptableObjectFromAction(action) {
        // this implementation is based on the assumption that any action which mutates an AdaptableObject has
        // at most one(1) property which has an 'Uuid:TypeUuid' defined (and that is the AdaptableObject, of course)
        if (!action) return;
        return Object.values(action).find((actionPropertyValue)=>(0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).isAdaptableObject(actionPropertyValue));
    }
    isAdaptableObjectPresentInLocalState(sharedEntity) {
        return !!this.api.internalApi.getModuleService().getModuleById(sharedEntity.Module)?.getModuleAdaptableObjects().find((adaptableObject)=>adaptableObject.Uuid === sharedEntity.Entity.Uuid);
    }
    isSharedEntityADependency(sharedEntity) {
        const allSharedEntries = this.api.teamSharingApi.getLoadedAdaptableSharedEntities();
        return allSharedEntries.some((sharedEntryCandidate)=>{
            return sharedEntryCandidate?.EntityDependencyIds?.includes(sharedEntity.Uuid);
        });
    }
    isStaleAndActive(sharedEntity) {
        const staleActiveEntities = this.api.internalApi.getTeamSharingService().getStaleActiveSharedEntities();
        return this.isAdaptableObjectPresentInLocalState(sharedEntity) && !!staleActiveEntities[sharedEntity.Uuid];
    }
    getDependencies(sharedEntity) {
        if (!Array.isArray(sharedEntity.EntityDependencyIds) || sharedEntity.EntityDependencyIds.length === 0) return [
            sharedEntity
        ];
        const allSharedEntities = this.api.teamSharingApi.getLoadedAdaptableSharedEntities();
        const dependencies = sharedEntity.EntityDependencyIds.map((dependencyUuid)=>allSharedEntities.find((entity)=>entity.Uuid === dependencyUuid));
        return (0, $826488674b2774ee$export$2e2bcd8739ae039)(dependencies.map((dependency)=>this.getDependencies(dependency)));
    }
    getStaleDependencies(sharedEntity) {
        return this.getDependencies(sharedEntity).filter((dependency)=>dependency.Uuid !== sharedEntity.Uuid && this.isStaleAndActive(dependency));
    }
    toView(sharedEntity) {
        const isDependency = this.isSharedEntityADependency(sharedEntity);
        const staleDependencies = this.getStaleDependencies(sharedEntity);
        const staleDependenciesViewItems = [];
        if (staleDependencies?.length) staleDependenciesViewItems.push({
            name: 'Stale Deps',
            view: (0, $1866db82573d7d70$export$2a3d8367aa4e15ab)(staleDependencies)
        });
        const sharedViewItems = [];
        const isStaleAndActive = this.isStaleAndActive(sharedEntity);
        if (!isDependency || isStaleAndActive) sharedViewItems.push({
            name: 'Shared',
            view: (0, $1866db82573d7d70$export$41f9ae3c0adf0047)(isDependency)
        });
        return {
            items: [
                !isDependency && sharedEntity.Description && {
                    name: 'Name',
                    values: [
                        sharedEntity.Description
                    ]
                },
                !isDependency && {
                    name: 'Share Mode',
                    values: [
                        sharedEntity.Type
                    ]
                },
                ...sharedViewItems,
                {
                    name: 'Type',
                    view: (0, $1866db82573d7d70$export$5fc168abf4509884)
                },
                ...staleDependenciesViewItems,
                (0, $9g4SS.default).IsNotNullOrEmpty(sharedEntity.EntityDependencyIds) && {
                    name: 'Dependencies',
                    isLabelInline: true,
                    view: (0, $914dda8a1ae5387e$export$8c5cca511d848123)
                }
            ].filter(Boolean),
            abObject: sharedEntity
        };
    }
    toViewAll() {
        return (this.api.teamSharingApi.getLoadedAdaptableSharedEntities() ?? [])// only top level
        .filter((sharedEntity)=>!this.isSharedEntityADependency(sharedEntity)).map((item)=>this.toView(item));
    }
    getViewProperties() {
        return {
            actions: [
                (0, $328542350248b0e4$export$c624e5228eabe18e)
            ],
            onMount: ()=>{
                this.api.teamSharingApi.refreshTeamSharing();
            },
            getDeleteAction: (sharedEntity)=>{
                return $a6df66119ff073ff$export$d156e46d29aee999(sharedEntity.Uuid);
            },
            emptyView: 'Shared Items will appear here when available.'
        };
    }
}




class $5ff5075a2e720521$export$aeeb812d88921b15 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$6444167a07daa102, $42e863194fcb493f$export$2caa0aaffe7bbab6, 'clipboard', 'ToolPanelPopup', 'An alternative to using the Dashboard is the AdapTable Tool Panel, the Tool Panel is the collapsible area to the right of the Grid.', api);
    }
    isModuleEnabled() {
        return this.api.internalApi.getAdaptableInstance().hasAdaptableToolPanel;
    }
}





var $acw62 = parcelRequire("acw62");


var $5aWMQ = parcelRequire("5aWMQ");
const $b711f4225fda2a03$export$81f2fe300d687bc7 = (systemStatusMessageInfo)=>{
    const background = (0, $5aWMQ.default).getColorByMessageType(systemStatusMessageInfo?.statusType ?? 'Success');
    const color = systemStatusMessageInfo ? (0, $5aWMQ.default).getButtonTextColourForMessageType(systemStatusMessageInfo.statusType) : 'var(--ab-color-text-on-primary)';
    return {
        background: background,
        color: color
    };
};



const $c29dacdbc95dd639$export$f9f2b0d06b667fb2 = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const currentSystemStatusMessageInfo = adaptable.api.systemStatusApi.getCurrentSystemStatusMessageInfo();
    const { color: color, background: background } = (0, $b711f4225fda2a03$export$81f2fe300d687bc7)(currentSystemStatusMessageInfo);
    const message = currentSystemStatusMessageInfo?.statusMessage;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        style: {
            color: message ? color : '',
            backgroundColor: message ? background : ''
        },
        className: "twa:p-1 twa:rounded-standard"
    }, message || '0 Messages');
};


class $cca283709585569d$export$c6d893bb4363e4f3 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$49045387ac7420d5, $42e863194fcb493f$export$7eabab1cd8af1687, 'traffic-lights', 'SystemStatusPopup', 'Provide messages about the Status of your application', api);
    }
    createColumnMenuItems(column) {
        if (this.isModuleVisible()) return [
            this.createMenuItemShowPopup('system-status-show', 'Show System Status', this.moduleInfo.Popup, this.moduleInfo.Glyph, {
                source: 'ColumnMenu'
            })
        ];
    }
    createContextMenuItems(menuContext) {
        if (this.isModuleVisible()) {
            let popUpParams = {
                source: 'ContextMenu'
            };
            return [
                this.createMainMenuItemShowPopup({
                    Name: 'system-status-show',
                    Label: 'Show System Status',
                    ComponentName: this.moduleInfo.Popup,
                    Icon: this.moduleInfo.Glyph,
                    PopupParams: popUpParams
                })
            ];
        }
    }
    getViewProperties() {
        return {
            getStatusBarPanelProps: ()=>{
                return {
                    content: (0, $c29dacdbc95dd639$export$f9f2b0d06b667fb2)
                };
            }
        };
    }
}





var $acw62 = parcelRequire("acw62");


const $4745254359e324ce$export$6d4d06bd18de0e87 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        onClick: (event)=>{
            event.stopPropagation();
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e4b19c37008c87ef$export$17c20d206da56716), {
        size: "small"
    }));
};


class $eb83a50ae1ab468b$export$4e24a31cd466cf4e extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$ebf1703e41256059, $42e863194fcb493f$export$7f02dc9df35b5d62, 'theme', 'ThemePopup', 'Theme AdapTable with a colour configuration set of your choosing', api);
    }
    getModuleAdaptableObjects() {
        return this.api.themeApi.getThemes();
    }
    hasNamedQueryReferences() {
        return false;
    }
    getViewProperties() {
        return {
            getStatusBarPanelProps: ()=>{
                return {
                    content: (0, $4745254359e324ce$export$6d4d06bd18de0e87)
                };
            }
        };
    }
}




class $8c138402ab60471f$export$aeaf6a0e556907f0 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$1ec41f9c955a8b42, $42e863194fcb493f$export$334ea6dd049bd035, 'grid-info', 'GridInfoPopup', 'Display information about the Grid, the Options selected and all columns', api);
    }
    getViewAccessLevel() {
        return 'Full';
    }
    createColumnMenuItems(column) {
        if (this.isModuleVisible()) return [
            this.createMainMenuItemShowPopup({
                Name: 'grid-info-show',
                Label: 'Grid Info',
                ComponentName: this.moduleInfo.Popup,
                Icon: this.moduleInfo.Glyph
            })
        ];
    }
    createContextMenuItems(menuContext) {
        if (this.isModuleVisible()) return [
            this.createMainMenuItemShowPopup({
                Name: 'grid-info-show',
                Label: 'Grid Info',
                ComponentName: this.moduleInfo.Popup,
                Icon: this.moduleInfo.Glyph
            })
        ];
    }
}




class $743a31e838ad08bd$export$4cca8c3df8ca97ce extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$59d09157d833a722, $42e863194fcb493f$export$9b1f81b08128de98, 'columns', 'ColumnInfoPopup', 'Display information about Columns', api);
    }
    getViewAccessLevel() {
        return 'Full';
    }
    createColumnMenuItems(column) {
        if (this.isModuleVisible() && !column.isTreeColumn) {
            const columnPopUpParams = {
                source: 'ColumnMenu',
                column: column
            };
            return [
                this.createMainMenuItemShowPopup({
                    Name: 'column-info-show',
                    Label: 'Column Info',
                    ComponentName: this.moduleInfo.Popup,
                    Icon: 'info',
                    PopupParams: columnPopUpParams
                })
            ];
        }
    }
    createContextMenuItems(menuContext) {
        if (this.isModuleVisible()) {
            const columnPopUpParams = {
                source: 'ColumnMenu',
                column: menuContext.adaptableColumn
            };
            return [
                this.createMainMenuItemShowPopup({
                    Name: 'column-info-show',
                    Label: 'Column Info',
                    ComponentName: this.moduleInfo.Popup,
                    Icon: 'info',
                    PopupParams: columnPopUpParams
                })
            ];
        }
    }
}





class $5f022ddeb63d19dd$export$c1cbc51db0d3b620 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        const friendlyName = api.optionsApi.getSettingsPanelOptions().title;
        super($42e863194fcb493f$export$79267ef32fe02008, friendlyName, 'settings', null, 'Manage all Adaptable Settings', api);
    }
    createColumnMenuItems(column) {
        if (this.isModuleVisible()) return [
            // To do : get the icon and name from settings in case they have changed?
            this.createMenuItemReduxAction('settings-panel-open', 'Open ' + this.moduleInfo.FriendlyName, this.moduleInfo.Glyph, $dc56b6267ce4d0bb$export$e2d5bba0b444685d())
        ];
    }
    createContextMenuItems(menuContext) {
        if (this.isModuleVisible()) return [
            this.createMenuItemReduxAction('settings-panel-open', 'Open ' + this.moduleInfo.FriendlyName, this.moduleInfo.Glyph, $dc56b6267ce4d0bb$export$e2d5bba0b444685d())
        ];
    }
    createModuleMenuItem(source) {
        if (this.isModuleVisible()) return this.createMenuItemReduxAction('settings-panel-open', 'Open ' + this.moduleInfo.FriendlyName, this.moduleInfo.Glyph, $dc56b6267ce4d0bb$export$e2d5bba0b444685d());
    }
}




class $ba77a83e85e38041$export$76a316c8c2f3bc28 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$273162015487179c, $42e863194fcb493f$export$68c6891398a23f02, 'statusbar', 'StatusBarPopup', 'Configure AdapTable Status Bar', api);
    }
    getAgGridModuleDependencies() {
        return [
            'StatusBarModule'
        ];
    }
    isModuleEnabled() {
        return this.api.statusBarApi.getAgGridStatusPanels().length > 0;
    }
    syncStateWithOptions(agGridAdaptablePanels) {
        const statusPanelsState = this.api.statusBarApi.getAdaptableStatusBars();
        /**
         * Grid config determines how many adaptable status panels are rendered.
         * This dictates the state.
         * - if a status panel is removed from ag-grid, it's sub-panels are made available;
         * - if a new status panel is added it is added to state with an empty list
         */ const newStatusPanelsState = agGridAdaptablePanels.map((agGridStatusPanel)=>{
            let statusPanelState = statusPanelsState.find((statusPanel)=>statusPanel.Key === agGridStatusPanel.key);
            // no state found
            if (!statusPanelState) statusPanelState = {
                Key: agGridStatusPanel.key,
                StatusBarPanels: []
            };
            return statusPanelState;
        });
        this.api.statusBarApi.setStatusBarPanels(newStatusPanelsState);
    }
}





var $acw62 = parcelRequire("acw62");




const $5fa24847ca880629$export$4d70211d7fdc0dbb = (chartDefinition)=>{
    return chartDefinition && 'Data' in chartDefinition;
};
const $5fa24847ca880629$export$2f543dc9b1f90ccc = (chartDefinition)=>{
    return chartDefinition && 'Model' in chartDefinition;
};



var $acw62 = parcelRequire("acw62");



const $30f7f422c2d806c8$export$51a071123eb4916 = (chartDefinition)=>{
    const [chartRef, setChartRef] = $acw62.useState(null);
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const currentChartModels = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>$5b564bb703f29152$export$f4d29e2e5bc6db04(state.Internal));
    $acw62.useEffect(()=>{
        if (!chartDefinition) {
            setChartRef(null);
            return;
        }
        const currentChartRef = adaptable.api.chartingApi.getChartRef(chartDefinition?.Model?.chartId) ?? null;
        setChartRef(currentChartRef);
    }, [
        currentChartModels,
        chartDefinition
    ]);
    const closeAlreadyOpenedChartsInContainer = (element)=>{
        const chartModelAlreadyInChartContainer = currentChartModels.find((chartModel)=>{
            const chartRef = adaptable.api.chartingApi.getChartRef(chartModel?.chartId);
            return chartRef && element.contains(chartRef.chartElement);
        });
        if (chartModelAlreadyInChartContainer) {
            const chartRef = adaptable.api.chartingApi.getChartRef(chartModelAlreadyInChartContainer.chartId);
            if (chartRef) chartRef.destroyChart();
        }
    };
    const showChart = $acw62.useCallback((chartContainer)=>{
        if (!adaptable || !chartDefinition) return;
        const element = typeof chartContainer?.element === 'string' ? document.querySelector(chartContainer.element) : chartContainer?.element;
        if (!element && typeof chartContainer?.element === 'string') {
            adaptable.logger.consoleLogByMessageType(`Chart container element not found: ${chartContainer.element}`, 'Error');
            return;
        }
        const chartRef = adaptable.api.chartingApi.getChartRef(chartDefinition.Model.chartId);
        if (chartRef) // chart alredy opened
        return;
        /**
         * When using a custom container, make sure multiple charts are not opened in the same container.
         * If multple charts are opened in the same contianer, it infinitly adds the charts to the container.
         */ if (chartContainer && element) {
            if (chartContainer.chartsDisplay !== 'multiple') closeAlreadyOpenedChartsInContainer(element);
            adaptable.api.chartingApi.showChartDefinitionOnce(chartDefinition, element);
        } else adaptable.api.chartingApi.showChartDefinitionOnce(chartDefinition);
    }, [
        chartDefinition,
        currentChartModels
    ]);
    const closeChart = $acw62.useCallback(()=>{
        if (chartRef) chartRef.destroyChart();
    }, [
        chartRef
    ]);
    return {
        isOpen: Boolean(chartRef),
        showChart: showChart,
        closeChart: closeChart
    };
};



var $acw62 = parcelRequire("acw62");

// need to trigger other show-chart buttons to close/hide
const $5a1795b2e68804fb$var$buttonChangeSubscribers = [];
const $5a1795b2e68804fb$export$da880325bb9f829e = (chartDefinition)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    // needs to update when ever a chart is:
    // - opened, hidden
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        return chartDefinition && adaptable.api.chartingApi.internalApi.isExternalChartOpened(chartDefinition);
    });
    const liveChartState = adaptable.api.chartingApi.internalApi.isExternalChartOpened(chartDefinition);
    if (liveChartState !== isOpen) setIsOpen(liveChartState);
    const updateIsOpen = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setIsOpen(chartDefinition && adaptable.api.chartingApi.internalApi.isExternalChartOpened(chartDefinition));
    }, [
        chartDefinition
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const subscriber = ()=>{
            updateIsOpen();
        };
        $5a1795b2e68804fb$var$buttonChangeSubscribers.push(subscriber);
        // clear own subscriptions
        return ()=>{
            const index = $5a1795b2e68804fb$var$buttonChangeSubscribers.indexOf(subscriber);
            if (index > -1) $5a1795b2e68804fb$var$buttonChangeSubscribers.splice(index, 1);
        };
    }, [
        updateIsOpen
    ]);
    return {
        showChart: (container)=>{
            adaptable.api.chartingApi.internalApi.onShowExternalChart(chartDefinition, container);
            // The small delay allows the library to render the chart before the button is updated
            requestAnimationFrame(()=>{
                $5a1795b2e68804fb$var$buttonChangeSubscribers.forEach((subscriber)=>subscriber());
            });
        },
        hideChart: ()=>{
            adaptable.api.chartingApi.internalApi.onHideExternalChart(chartDefinition);
            // The small delay allows the library to destroy the chart before the button is updated
            requestAnimationFrame(()=>{
                $5a1795b2e68804fb$var$buttonChangeSubscribers.forEach((subscriber)=>subscriber());
            });
        },
        isOpen: isOpen
    };
};


const $4bef5bc23f6bd149$var$BaseShowChartButton = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const chartingOptions = adaptable.adaptableOptions?.chartingOptions;
    const chartContainers = chartingOptions?.chartContainers;
    if (props.chartOpened) return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "close-chart-button",
        onClick: props.onCloseChart,
        variant: "text",
        tone: "error",
        icon: "visibility-off",
        tooltip: "Hide Chart"
    });
    if (!chartContainers?.length) return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "show-chart-button",
        onClick: ()=>props.onShowChart(),
        variant: "text",
        tone: "success",
        icon: "visibility-on",
        tooltip: "Show Chart"
    });
    return $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        "data-name": "show-chart-dropdown",
        variant: "text",
        columns: [
            'label'
        ],
        items: props.containerOptions
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        variant: "raised",
        tone: "success"
    }, "Open"));
};
const $4bef5bc23f6bd149$var$ShowAgChartButton = (props)=>{
    const adaptableApi = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)().api;
    const chartingOptions = adaptableApi.optionsApi.getChartingOptions();
    const chartContainers = chartingOptions?.chartContainers;
    const { isOpen: isOpen, showChart: showChart, closeChart: closeChart } = (0, $30f7f422c2d806c8$export$51a071123eb4916)(props.chartDefinition);
    const containerOptions = [
        {
            label: chartingOptions.agGridContainerName ?? (0, $58846ea7f4156db7$export$2c93b592c78f216f),
            onClick: ()=>{
                showChart(null);
            },
            ...chartContainers ? chartContainers?.map((contianerDef)=>({
                    label: contianerDef.name,
                    onClick: ()=>showChart(contianerDef)
                })) : []
        }
    ];
    return $acw62.createElement($4bef5bc23f6bd149$var$BaseShowChartButton, {
        chartOpened: isOpen,
        onShowChart: showChart,
        onCloseChart: closeChart,
        containerOptions: containerOptions
    });
};
const $4bef5bc23f6bd149$var$ShowExternalChartButton = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const chartingOptions = adaptable.adaptableOptions?.chartingOptions;
    const chartContainers = chartingOptions?.chartContainers;
    /**
     * Need to refresh after the chart is closed/opened
     */ const { isOpen: isOpen, showChart: onShow, hideChart: onHide } = (0, $5a1795b2e68804fb$export$da880325bb9f829e)(props.chartDefinition);
    const containerOptions = chartContainers ? chartContainers?.map((contianerDef)=>({
            label: contianerDef.name,
            onClick: ()=>onShow(contianerDef)
        })) : [];
    return $acw62.createElement($4bef5bc23f6bd149$var$BaseShowChartButton, {
        chartOpened: isOpen,
        onShowChart: onShow,
        onCloseChart: onHide,
        containerOptions: containerOptions
    });
};
const $4bef5bc23f6bd149$export$d77b59e1f0913837 = (props)=>{
    if ((0, $5fa24847ca880629$export$2f543dc9b1f90ccc)(props.data)) return $acw62.createElement($4bef5bc23f6bd149$var$ShowAgChartButton, {
        chartDefinition: props.data
    });
    if ((0, $5fa24847ca880629$export$4d70211d7fdc0dbb)(props.data)) return $acw62.createElement($4bef5bc23f6bd149$var$ShowExternalChartButton, {
        chartDefinition: props.data
    });
    return $acw62.createElement($acw62.Fragment, null);
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




const $a63a547b9ec73bcd$export$83e4a7ee98acc3e9 = (props)=>{
    const currentChartModels = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>$5b564bb703f29152$export$f4d29e2e5bc6db04(state.Internal));
    const [localChartId, setLocalChartId] = $acw62.useState(null);
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const divRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!divRef.current) return;
        const chartRef = adaptable.api.chartingApi.showChartDefinition(props.chartDefinition, divRef.current);
        setLocalChartId(chartRef.chartId);
        chartRef.chart;
        return ()=>{
            chartRef.destroyChart();
        };
    }, [
        divRef
    ]);
    $acw62.useEffect(()=>{
        const model = currentChartModels.find((model)=>model.chartId == localChartId);
        if (model && !(0, $f94a32af7542d5ef$export$2e2bcd8739ae039)(model, props.chartDefinition.Model)) props.onChange({
            ...props.chartDefinition,
            Model: model
        });
    }, [
        currentChartModels
    ]);
    return $acw62.createElement("div", {
        ref: divRef
    });
};



var $acw62 = parcelRequire("acw62");




const $0b7e1be6294697e2$export$bd1cc8e0fb715366 = (chartDefinition, api)=>{
    if (!chartDefinition.Name) return 'A name is required.';
    const allChartDefinitions = api.chartingApi.getChartDefinitions();
    if (allChartDefinitions.some((chartDefinitionLoopItem)=>chartDefinitionLoopItem.Uuid !== chartDefinition.Uuid && chartDefinitionLoopItem.Name === chartDefinition.Name)) return 'A Chart with this name already exists.';
    return true;
};
const $0b7e1be6294697e2$export$d239b03507a9e5cc = (props)=>{
    const handleNameChange = $acw62.useCallback((event)=>{
        props.onChange({
            ...props.chartDefinition,
            Name: event.target.value,
            Model: props.chartDefinition.Model
        });
    }, [
        props.chartDefinition
    ]);
    const handleUnLinkChange = $acw62.useCallback(()=>{
        props.onChange({
            ...props.chartDefinition,
            Model: {
                ...props.chartDefinition.Model,
                unlinkChart: !props.chartDefinition.Model.unlinkChart
            }
        });
    }, [
        props.chartDefinition
    ]);
    const handleSuppressChartRanges = $acw62.useCallback(()=>{
        props.onChange({
            ...props.chartDefinition,
            Model: {
                ...props.chartDefinition.Model,
                suppressChartRanges: !props.chartDefinition.Model.suppressChartRanges
            }
        });
    }, [
        props.chartDefinition
    ]);
    const aggFuncs = [
        'sum',
        'min',
        'max',
        'count',
        'avg',
        'first',
        'last'
    ];
    const aggFuncsOptions = aggFuncs.map((aggFunc)=>({
            label: aggFunc,
            onClick: ()=>{
                props.onChange({
                    ...props.chartDefinition,
                    Model: {
                        ...props.chartDefinition.Model,
                        aggFunc: aggFunc
                    }
                });
            }
        }));
    const aggFunc = props.chartDefinition.Model.aggFunc;
    const handleAggFuncClear = $acw62.useCallback(()=>{
        props.onChange({
            ...props.chartDefinition,
            Model: {
                ...props.chartDefinition.Model,
                aggFunc: ''
            }
        });
    }, [
        props.chartDefinition
    ]);
    return $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        onChange: handleNameChange,
        value: props.chartDefinition.Name
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Unlink Chart"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        onClick: handleUnLinkChange,
        checked: props.chartDefinition.Model.unlinkChart
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Suppress Chart Ranges"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        onClick: handleSuppressChartRanges,
        checked: props.chartDefinition.Model.suppressChartRanges
    })), props.chartDefinition.Model.modelType === 'range' && typeof aggFunc !== 'function' && $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Agg Func"
    }, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        columns: [
            'label'
        ],
        items: aggFuncsOptions,
        onClear: handleAggFuncClear
    }, aggFunc ? aggFunc : 'Select ')));
};




const $26f3af7f0c2415fb$export$6e487b8742dabc6e = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [chartDefinition, setChartDefinition] = $acw62.useState(()=>{
        return props.data ?? props.popupParams?.value;
    });
    const handleFinish = $acw62.useCallback(()=>{
        adaptable.api.chartingApi.editChartDefinition(chartDefinition);
        props.onFinishWizard(chartDefinition);
    }, [
        chartDefinition
    ]);
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: chartDefinition,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Settings',
                details: 'Chart Settings',
                isValid: (0, $0b7e1be6294697e2$export$bd1cc8e0fb715366),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $0b7e1be6294697e2$export$d239b03507a9e5cc), {
                        chartDefinition: chartDefinition,
                        onChange: setChartDefinition
                    }))
            },
            {
                details: 'Select Chart Tags',
                title: 'Tags',
                isVisible: ()=>adaptable.api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setChartDefinition
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                title: 'Preview Chart',
                details: 'Chart Preview',
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $a63a547b9ec73bcd$export$83e4a7ee98acc3e9), {
                        chartDefinition: chartDefinition,
                        onChange: setChartDefinition
                    }))
            }
        ]
    });
};





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $dc440433b5c6d969$export$bd1cc8e0fb715366 = (chartDefinition, api)=>{
    if (!chartDefinition.Name) return 'A name is required.';
    const allChartDefinitions = api.chartingApi.getExternalChartDefinitions();
    if (allChartDefinitions.some((chartDefinitionLoopItem)=>chartDefinitionLoopItem.Uuid !== chartDefinition.Uuid && chartDefinitionLoopItem.Name === chartDefinition.Name)) return 'A Chart with this name already exists.';
    return true;
};
const $dc440433b5c6d969$export$d239b03507a9e5cc = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        value: props.chartDefinition.Name,
        onChange: (e)=>props.onChange({
                ...props.chartDefinition,
                Name: e.target.value
            })
    })));
};



const $46f65545990dd314$var$PreviewChartSection = ({ chartDefinition: chartDefinition })=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const divRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!divRef.current) return;
        const container = {
            name: 'Preview Chart',
            element: divRef.current
        };
        const transientChartDefinition = adaptable.api.chartingApi.internalApi.onPreviewExternalChart(chartDefinition, container);
        return ()=>{
            adaptable.api.chartingApi.internalApi.onHideExternalChart(transientChartDefinition);
        };
    }, [
        divRef
    ]);
    return $acw62.createElement("div", {
        ref: divRef
    });
};
const $46f65545990dd314$export$a3ecf09614531066 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const onPreviewChart = adaptable.api.optionsApi.getChartingOptions().externalChartingOptions?.onPreviewChart;
    const [chartDefinition, setChartDefinition] = $acw62.useState(()=>{
        return props.data ?? props.popupParams?.value;
    });
    const handleFinish = ()=>{
        adaptable.api.chartingApi.editExternalChartDefinition(chartDefinition);
        props.onFinishWizard(props.data);
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: chartDefinition,
        onHide: props.onCloseWizard,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Settings',
                details: 'Chart Settings',
                isValid: (0, $dc440433b5c6d969$export$bd1cc8e0fb715366),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $dc440433b5c6d969$export$d239b03507a9e5cc), {
                        chartDefinition: chartDefinition,
                        onChange: setChartDefinition
                    }))
            },
            onPreviewChart ? {
                title: 'Preview Chart',
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement($46f65545990dd314$var$PreviewChartSection, {
                        chartDefinition: chartDefinition
                    }));
                }
            } : null
        ].filter(Boolean)
    });
};




const $3e21d50a108601dc$export$29155ae3e76cb049 = (props)=>{
    const { data: data, configEntities: configEntities, ...other } = props;
    if ((0, $5fa24847ca880629$export$2f543dc9b1f90ccc)(data)) {
        const chartDef = data;
        return $acw62.createElement((0, $26f3af7f0c2415fb$export$6e487b8742dabc6e), {
            ...other,
            data: chartDef
        });
    } else {
        const chartDef = data;
        return $acw62.createElement((0, $46f65545990dd314$export$a3ecf09614531066), {
            ...other,
            data: chartDef
        });
    }
};






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");



const $f882546dc952795a$export$c8d26662938af998 = (props)=>{
    return $acw62.createElement((0, $52184ede7cf4a09d$export$6c2dcda0a6ef7fa6), {
        iconSize: props.iconSize,
        disabled: !props.chart,
        ConfirmAction: (0, $5fa24847ca880629$export$2f543dc9b1f90ccc)(props.chart) ? $5571bec319fd98b0$export$c0a99267db1a5bfa(props.chart) : $5571bec319fd98b0$export$32550d3e9883bb0d(props.chart),
        ConfirmationMsg: `Are you sure you want to delete this Charts?`,
        ConfirmationTitle: 'Delete Charts',
        accessLevel: props.accessLevel,
        tooltip: "Delete Chart"
    });
};



var $acw62 = parcelRequire("acw62");




const $adfd770be1c4fa9d$export$fe851a6b25d2ab1b = (props)=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    return $acw62.createElement((0, $c98867b89f88548d$export$f8a35005a0ddce8d), {
        iconSize: props.iconSize,
        tooltip: "Edit Chart",
        // It gets complicated when a chart is both open and opened in edit wizard
        // There an be conflicts between the two open charts (preview and main) and the changes to the active chart may not be syncronized correctly.
        disabled: !props.chart || props.isOpen,
        accessLevel: props.accessLevel,
        onClick: ()=>dispatch($dc56b6267ce4d0bb$export$e2d5bba0b444685d($42e863194fcb493f$export$a3fc1172140ca1e4, 'Chart', {
                action: 'Edit',
                value: props.chart,
                source: 'Toolbar'
            }))
    });
};




const $413e3b2ece8fc74a$export$93ffd2cb272551dc = ({ elementType: elementType, accessLevel: accessLevel, size: size = 'normal' })=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const chartDefinitions = (0, $55388fc2f116d4d7$export$2105062e25df4afe)($5571bec319fd98b0$export$6fe5e0acd43ef01a);
    const extenralChartDefinitions = (0, $55388fc2f116d4d7$export$2105062e25df4afe)($5571bec319fd98b0$export$4d41f59981e35290);
    const allChartDefinitions = [
        ...chartDefinitions,
        ...extenralChartDefinitions
    ];
    const chartingOptions = adaptable.adaptableOptions?.chartingOptions;
    const chartContainers = chartingOptions?.chartContainers;
    const [selectedChartId, setSelectedChartId] = $acw62.useState(()=>{
        // ID is kept in state becaus that does not change, the definition might change
        return allChartDefinitions.length > 0 ? allChartDefinitions[0].Uuid : null;
    });
    const selectedChart = allChartDefinitions.find((chart)=>chart.Uuid === selectedChartId);
    const isAgChart = (0, $5fa24847ca880629$export$2f543dc9b1f90ccc)(selectedChart);
    const chartAccessLevel = (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).getAccessLevelForObject(selectedChart, accessLevel);
    const [selectedContainer, setSelectedContainer] = $acw62.useState(null);
    // Need to always call as they the rule for hooks
    const { isOpen: isAgChartOpen, showChart: showAgChart, closeChart: hideAgChart } = (0, $30f7f422c2d806c8$export$51a071123eb4916)(isAgChart ? selectedChart : undefined);
    // Need to always call as they the rule for hooks
    const { isOpen: isExternalChartOpened, showChart: showExternalChart, hideChart: hideExternalChart } = (0, $5a1795b2e68804fb$export$da880325bb9f829e)(!isAgChart ? selectedChart : undefined);
    const isOpen = isAgChart ? isAgChartOpen : isExternalChartOpened;
    const showChart = isAgChart ? showAgChart : showExternalChart;
    const hideChart = isAgChart ? hideAgChart : hideExternalChart;
    const options = allChartDefinitions.map((chartDefinition)=>({
            label: chartDefinition.Name,
            value: chartDefinition.Uuid,
            onClick: ()=>{
                setSelectedChartId(chartDefinition.Uuid);
            }
        }));
    const hasCharts = options.length > 0;
    const isSelectedChart = hasCharts && selectedChart != null;
    let selectedChartValue = '';
    if (hasCharts && selectedChart) selectedChartValue = selectedChart.Name;
    else if (hasCharts) selectedChartValue = 'Select Chart';
    else selectedChartValue = 'No Charts';
    $acw62.useEffect(()=>{
        // select first
        if (!selectedChart && chartDefinitions.length > 0) setSelectedChartId(chartDefinitions[0].Uuid);
    }, [
        chartDefinitions
    ]);
    let containerOptions = chartContainers ? chartContainers?.map((contianerDef)=>({
            label: contianerDef.name,
            value: contianerDef.name
        })) : [];
    if ((0, $5fa24847ca880629$export$2f543dc9b1f90ccc)(selectedChart)) containerOptions.unshift({
        label: chartingOptions.agGridContainerName,
        value: chartingOptions.agGridContainerName
    });
    const style = {};
    let iconSize;
    if (size === 'small') {
        style.padding = 2;
        style.fontSize = 'small';
        iconSize = 15;
    }
    const chartSelector = $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        className: `ab-${elementType}__Chart__select`,
        size: size,
        value: selectedChartId,
        options: options,
        placeholder: 'Select Chart',
        disabled: !hasCharts,
        onChange: (chartUuid)=>setSelectedChartId(chartUuid)
    });
    const containerSelector = Boolean(chartContainers?.length) && $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        value: selectedContainer === null ? chartingOptions.agGridContainerName : selectedContainer?.name,
        size: size,
        onChange: (containerName)=>{
            if (containerName === chartingOptions.agGridContainerName) setSelectedContainer(null);
            else setSelectedContainer(chartContainers.find((containerOption)=>containerOption.name === containerName));
        },
        options: containerOptions,
        placeholder: "Select Container"
    });
    const chartButton = $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        style: style,
        className: "twa:mr-1",
        onClick: ()=>isOpen ? hideChart() : showChart(selectedContainer),
        disabled: !Boolean(selectedChart),
        variant: 'text',
        tone: 'neutral',
        icon: isOpen ? 'visibility-off' : 'visibility-on',
        tooltip: isOpen ? 'Hide Chart' : 'Show Chart'
    });
    const deleteButton = $acw62.createElement((0, $f882546dc952795a$export$c8d26662938af998), {
        iconSize: iconSize,
        chart: selectedChart,
        accessLevel: chartAccessLevel
    });
    const editButton = $acw62.createElement((0, $adfd770be1c4fa9d$export$fe851a6b25d2ab1b), {
        iconSize: iconSize,
        chart: selectedChart,
        accessLevel: chartAccessLevel,
        isOpen: isOpen
    });
    return {
        chartSelector: chartSelector,
        containerSelector: containerSelector,
        chartButton: chartButton,
        deleteButton: deleteButton,
        editButton: editButton,
        selectedChart: selectedChart
    };
};



const $8dec942efe342216$export$780a3e47258e61d0 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const accessLevel = adaptable.api.entitlementApi.getEntitlementAccessLevelForModule($42e863194fcb493f$export$a3fc1172140ca1e4);
    const { chartSelector: chartSelector, containerSelector: containerSelector, chartButton: chartButton, deleteButton: deleteButton, editButton: editButton } = (0, $413e3b2ece8fc74a$export$93ffd2cb272551dc)({
        elementType: 'Statusbar',
        accessLevel: accessLevel,
        size: 'small'
    });
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:w-full",
        alignItems: "center"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, chartSelector), containerSelector && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-1"
    }, containerSelector), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-1"
    }, chartButton, deleteButton, editButton));
};






var $9g4SS = parcelRequire("9g4SS");
class $8e7998a46635d406$export$d320d532394aec28 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$a3fc1172140ca1e4, $42e863194fcb493f$export$5d318d257a911a98, 'chart', 'ChartPopup', 'Create AG Grid Charts in order to see Adaptable Data visually', api);
    }
    getAgGridModuleDependencies() {
        return [
            'IntegratedChartsModule'
        ];
    }
    isModuleEnabled() {
        const agGridChartsEnabled = this.api.agGridApi.getGridOption('enableCharts');
        if (agGridChartsEnabled) return true;
        const externalChartsAvailable = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).objectHasKeys(this.api.optionsApi.getChartingOptions().externalChartingOptions);
        return externalChartsAvailable;
    }
    createColumnMenuItems(column) {
        if (column && this.isModuleEditable() && (0, $9g4SS.default).IsNotNullOrEmpty(this.api.chartingApi.getChartDefinitions())) return [
            this.createMainMenuItemShowPopup({
                Name: 'chart-show',
                Label: 'Manage Charts',
                ComponentName: this.moduleInfo.Popup,
                Icon: this.moduleInfo.Glyph
            })
        ];
    }
    getModuleAdaptableObjects() {
        return [
            ...this.api.chartingApi.getChartDefinitions(),
            ...this.api.chartingApi.getExternalChartDefinitions()
        ];
    }
    toViewAll() {
        return this.getModuleAdaptableObjects().map((chartDef)=>this.toView(chartDef));
    }
    toView(chart) {
        if ((0, $5fa24847ca880629$export$4d70211d7fdc0dbb)(chart)) return this.toViewExternalChartDefinition(chart);
        else return this.toViewChartDefinition(chart);
    }
    toViewExternalChartDefinition(chart) {
        return {
            items: [
                {
                    name: 'Name',
                    values: [
                        chart.Name
                    ]
                }
            ],
            abObject: chart
        };
    }
    toViewChartDefinition(chart) {
        return {
            items: [
                {
                    name: 'Name',
                    values: [
                        chart.Name
                    ]
                },
                {
                    name: 'About',
                    values: [
                        `Chart Type: ${chart.Model.chartType}`,
                        chart.Model.aggFunc && `Aggregation Function: ${chart.Model.aggFunc}`
                    ].filter(Boolean)
                },
                {
                    name: 'Settings',
                    values: [
                        `Unlink from data: ${chart.Model.unlinkChart ? 'Yes' : 'No'}`,
                        `Suppress Chart Ranges: ${chart.Model.suppressChartRanges ? 'Yes' : 'No'}`
                    ]
                },
                {
                    name: 'Range',
                    values: [
                        `Row start index: ${chart.Model.cellRange.rowStartIndex}`,
                        `Row end index: ${chart.Model.cellRange.rowEndIndex}`,
                        chart.Model.cellRange.columnStart && `Column start: ${typeof chart.Model.cellRange.columnStart === 'string' ? this.api.columnApi.getFriendlyNameForColumnId(chart.Model.cellRange.columnStart) : this.api.columnApi.getFriendlyNameForColumnId(chart.Model.cellRange.columnStart.getColId())}`,
                        chart.Model.cellRange.columnEnd && `Column start: ${typeof chart.Model.cellRange.columnEnd === 'string' ? this.api.columnApi.getFriendlyNameForColumnId(chart.Model.cellRange.columnEnd) : this.api.columnApi.getFriendlyNameForColumnId(chart.Model.cellRange.columnEnd.getColId())}`,
                        chart.Model.cellRange.columns?.length && `Columns ${chart.Model.cellRange.columns.map((column)=>typeof column === 'string' ? this.api.columnApi.getFriendlyNameForColumnId(column) : this.api.columnApi.getFriendlyNameForColumnId(column.getColId())).join(', ')}`
                    ].filter(Boolean)
                },
                (0, $52125728d99aa873$export$287b3702a135396b)(chart, this.api)
            ].filter(Boolean),
            abObject: chart
        };
    }
    getViewProperties() {
        return {
            actions: [
                (0, $4bef5bc23f6bd149$export$d77b59e1f0913837)
            ],
            getEditWizard: ()=>(0, $3e21d50a108601dc$export$29155ae3e76cb049),
            // not sure if charts should be created via adaptable wizard
            hideNewButton: true,
            getDeleteAction: (chartDefinition)=>{
                return (0, $5fa24847ca880629$export$2f543dc9b1f90ccc)(chartDefinition) ? $5571bec319fd98b0$export$c0a99267db1a5bfa(chartDefinition) : $5571bec319fd98b0$export$32550d3e9883bb0d(chartDefinition);
            },
            emptyView: 'To create a chart select a few cells and right click. Then select "Chart Range" from the context menu.',
            getStatusBarPanelProps: ()=>{
                const content = (0, $8dec942efe342216$export$780a3e47258e61d0);
                return {
                    content: content,
                    triggerActionOnWrapperClick: false
                };
            }
        };
    }
}




class $db47de99b5aa2d0d$export$3ebd7045d5dcea8e extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$7e30a30684cd1b52, $42e863194fcb493f$export$43aefa97b142d9fb, 'note', 'NotePopup', 'Notes', api);
    }
    isModuleEnabled() {
        // Note module doesn't support autogenerated primary keys
        return !this.api.optionsApi.isAutogeneratePrimaryKey();
    }
    getModuleAdaptableObjects() {
        return this.api.noteApi.getAllNotes();
    }
    createContextMenuItems(menuContext) {
        if (!this.isModuleVisible()) return;
        if (!this.api.noteApi.internalApi.areNotesSupported()) return;
        if (menuContext.isRowGroupColumn || menuContext.isGroupedNode || !menuContext.isSingleSelectedCell) return;
        const isReadOnly = this.api.entitlementApi.getEntitlementAccessLevelForModule(this.moduleInfo.ModuleName) === 'ReadOnly';
        if (isReadOnly) return undefined;
        const isCellNotable = typeof this.api.optionsApi?.getNoteOptions()?.isCellNotable === 'function' ? this.api.optionsApi.getNoteOptions().isCellNotable({
            gridCell: menuContext.gridCell,
            ...this.api.internalApi.buildBaseContext()
        }) : true;
        if (!isCellNotable) return;
        const note = this.api.noteApi.getNoteForCell({
            PrimaryKeyValue: menuContext.primaryKeyValue,
            ColumnId: menuContext.adaptableColumn.columnId
        });
        if (note) return [
            this.createMenuItemClickFunction('note-remove', 'Remove Note', this.moduleInfo.Glyph, ()=>{
                this.api.noteApi.deleteNote(note);
            })
        ];
        else return [
            this.createMenuItemClickFunction('note-add', 'Add Note', this.moduleInfo.Glyph, ()=>{
                // add an empty one
                this.api.noteApi.addNote('', menuContext.primaryKeyValue, menuContext.adaptableColumn.columnId);
                this.api.internalApi.getAnnotationsService().showPopup({
                    PrimaryKeyValue: menuContext.primaryKeyValue,
                    ColumnId: menuContext.adaptableColumn.columnId
                }, true);
            })
        ];
    }
}






var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");







const $4eab9f09520a5ddf$export$a1795c53d90c3de3 = (data)=>{
    let type = null;
    if (data.GradientStyle) type = 'Gradient Column';
    else if (data.PercentBarStyle) type = 'Percent Bar';
    else if (data.SparklineStyle) type = 'Spark Line';
    else if (data.BadgeStyle) type = 'Badge';
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:pr-2 twa:py-2"
    }, "Type ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, type));
};
const $4eab9f09520a5ddf$export$619a627c3fdcfa73 = (props)=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const handleTypeChange = (type)=>{
        const newStyledColumn = {
            ...data
        };
        delete newStyledColumn.GradientStyle;
        delete newStyledColumn.PercentBarStyle;
        delete newStyledColumn.SparklineStyle;
        delete newStyledColumn.BadgeStyle;
        switch(type){
            case 'gradient':
                newStyledColumn.GradientStyle = {};
                break;
            case 'percent':
                newStyledColumn.PercentBarStyle = {};
                break;
            case 'sparkline':
                newStyledColumn.SparklineStyle = {
                    options: {
                        type: 'line'
                    }
                };
                break;
            case 'badge':
                newStyledColumn.BadgeStyle = {
                    Badges: [
                        (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateDefaultStyledColumnBadge()
                    ]
                };
                break;
        }
        newStyledColumn.ColumnId = null;
        props.onChange(newStyledColumn);
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        "data-name": "styled-column-type",
        className: "twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        autoFocus: false,
        className: "twa:p-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Type"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: "Gradient",
        description: "Colour each cell in the column using a Gradient value (Numeric Columns)",
        checked: Boolean(data.GradientStyle),
        onClick: ()=>handleTypeChange('gradient')
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: "Percent Bar",
        description: "Display a coloured Bar where the width is based on the cell (Numeric Columns)",
        checked: Boolean(data.PercentBarStyle),
        onClick: ()=>handleTypeChange('percent')
    }), adaptable.api.styledColumnApi.canDisplaySparklines() && $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: "Sparkline",
        description: "Render the column as a Sparkline (Numeric Array Columns)",
        checked: Boolean(data.SparklineStyle),
        onClick: ()=>handleTypeChange('sparkline')
    }), $acw62.createElement((0, $a6b10ec9898965bc$export$31ff1d5d6736d74), {
        text: "Badge",
        description: "Display the column's values as Badges (All Columns)",
        checked: Boolean(data.BadgeStyle),
        onClick: ()=>handleTypeChange('badge')
    }))));
};



var $acw62 = parcelRequire("acw62");





const $17ba016a4fd0f965$export$14ce0fd1837d790e = (data)=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:pr-2 twa:py-2"
    }, "Styled Column column:", ' ', $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.ColumnId ? api.columnApi.getFriendlyNameForColumnId(data.ColumnId) : 'No Column Selected'));
};
const $17ba016a4fd0f965$export$ad06fd9c49d39ed8 = (data)=>{
    if (!data.ColumnId) return 'Please select a column for the Styled Column.';
    return true;
};
const $17ba016a4fd0f965$export$9abc1bf7ad0d7f59 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const sortableCols = $acw62.useMemo(()=>{
        let sortableColumns = [];
        if (data.SparklineStyle) sortableColumns = api.columnApi.getNumericArrayColumns();
        else if (data.BadgeStyle) sortableColumns = [
            ...api.columnApi.getNumericColumns(),
            ...api.columnApi.getTextColumns(),
            ...api.columnApi.getTextArrayColumns(),
            ...api.columnApi.getNumberArrayColumns()
        ];
        else sortableColumns = api.columnApi.getNumericColumns();
        const styledColumns = api.styledColumnApi.getStyledColumns();
        const usedColumnIds = styledColumns.map((styledColumn)=>{
            // filter out current styled column columnID
            if (styledColumn.Uuid === data.Uuid) return null;
            return styledColumn.ColumnId;
        }).filter(Boolean);
        return sortableColumns.filter((column)=>{
            return usedColumnIds.every((usedColumnId)=>{
                return column.columnId !== usedColumnId;
            });
        });
    }, [
        data
    ]);
    const handleColumnsChange = (columnIds)=>{
        const columnId = columnIds[0];
        const emptyRanges = api.columnScopeApi.createCellColorRangesForScope({
            ColumnIds: [
                columnId
            ]
        });
        const newStyledColumn = {
            ...data,
            ColumnId: columnId
        };
        if (newStyledColumn.PercentBarStyle) newStyledColumn.PercentBarStyle = {
            ...newStyledColumn.PercentBarStyle,
            CellRanges: emptyRanges
        };
        if (newStyledColumn.GradientStyle) newStyledColumn.GradientStyle = {
            ...newStyledColumn.GradientStyle,
            CellRanges: emptyRanges
        };
        props.onChange(newStyledColumn);
    };
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        style: {
            height: '100%'
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $a5fb2ed975764e91$export$ac01ee0b3a94fb49), {
        availableColumns: sortableCols,
        selected: data.ColumnId ? [
            data.ColumnId
        ] : [],
        singleSelect: true,
        onChange: handleColumnsChange,
        allowReorder: false
    })));
};



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


const $8f18596f06454d86$export$6bf0cd3a219bbade = $acw62.forwardRef((props, ref)=>{
    const [value, setValue] = $acw62.useState(()=>{
        // awlays controlled
        return props.value ?? '';
    });
    const handleChange = $acw62.useCallback((event)=>{
        const { value: value } = event.target;
        let newVal = Number(value);
        if (value === '-' || value === '') {
            // we are saving invalid values so we allow values as empty string and '-'
            // there is a validation that prevents the
            newVal = value;
            // the value may be empty or negative
            setValue(value);
        } else if (!isNaN(newVal)) {
            setValue(value);
            // only set when a valid numer
            props.onChange(newVal);
        }
    }, []);
    $acw62.useEffect(()=>{
        setValue(props.value);
    }, [
        props.value
    ]);
    const handleBlur = $acw62.useCallback((event)=>{
        props?.onBlur?.(event);
        // show the prop value
        if (value !== props.value) setValue(props.value);
    }, [
        props.value,
        value
    ]);
    const { noArrows: noArrows, ...restOfProps } = props;
    return $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        ...restOfProps,
        ref: ref,
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(noArrows ? `${0, $9e4562887d5c909d$export$e0e193db4cb7689a}--no-arrows` : '', props.className),
        value: value,
        onBlur: handleBlur,
        onChange: handleChange
    });
});




var $5aWMQ = parcelRequire("5aWMQ");




class $4b445e6a23353401$export$effae0f4725478f2 extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            rangesType: this.props.columnComparison ? 'ColumnComparison' : 'Standard'
        };
    }
    render() {
        let comparisonMinValueNumber = this.props.columnComparison != null && this.props.columnComparison.MinValue != null && !isNaN(Number(this.props.columnComparison.MinValue)) ? Number(this.props.columnComparison.MinValue) : '';
        let comparisonMaxValueNumber = this.props.columnComparison != null && this.props.columnComparison.MaxValue != null && !isNaN(Number(this.props.columnComparison.MaxValue)) ? Number(this.props.columnComparison.MaxValue) : '';
        let comparisonMinValueColumnId = this.props.columnComparison != null && this.props.columnComparison.MinValue != null && isNaN(Number(this.props.columnComparison.MinValue)) ? String(this.props.columnComparison.MinValue) : undefined;
        let comparisonMaxValueColumnId = this.props.columnComparison != null && this.props.columnComparison.MaxValue != null && isNaN(Number(this.props.columnComparison.MaxValue)) ? String(this.props.columnComparison.MaxValue) : undefined;
        let comparisonColor = this.props.columnComparison != null && this.props.columnComparison.Color != null ? this.props.columnComparison.Color : undefined;
        const isRangeValueTypeNumber = (this.props.rangeValueType ?? 'Number') === 'Number';
        return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "row"
        }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            className: "twa:mt-3",
            checked: this.state.rangesType == 'ColumnComparison',
            onChange: (checked)=>this.onRangesTypeChanged(checked)
        }, "Use a Column Comparison")), this.state.rangesType == 'Standard' && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
            autoFocus: false,
            className: "twa:mt-2"
        }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Ranges"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center",
            className: "twa:mb-2"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mr-3"
        }, "Range Type"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
            onChange: ()=>this.handleRangeValueTypeChange('Number'),
            checked: isRangeValueTypeNumber,
            className: "twa:mr-2"
        }, "Number"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
            onChange: ()=>this.handleRangeValueTypeChange('Percentage'),
            checked: !isRangeValueTypeNumber
        }, "Percentage")), this.props.ranges?.map((range, index, list)=>$acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                key: index,
                alignItems: "end",
                className: "twa:mb-2",
                "data-name": "percent-bar-range"
            }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                flexDirection: "column"
            }, isRangeValueTypeNumber && index === 0 && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                onClick: ()=>this.setRangeColMin(range),
                checked: range.Min === 'Col-Min',
                className: "twa:mt-0 twa:mb-1 twa:text-3",
                disabled: this.props.disabled
            }, "Col Min"), $acw62.createElement((0, $8f18596f06454d86$export$6bf0cd3a219bbade), {
                disabled: this.props.disabled || range.Min === 'Col-Min' || index === 0 && !isRangeValueTypeNumber,
                value: range.Min,
                onChange: (value)=>{
                    this.changeRangeMin(index, value);
                },
                className: "twa:mr-2"
            })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                flexDirection: "column"
            }, isRangeValueTypeNumber && index === list.length - 1 && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                className: "twa:mt-0 twa:mb-1 twa:text-3",
                onClick: ()=>this.setRangeColMax(range),
                checked: range.Max === 'Col-Max',
                disabled: this.props.disabled
            }, "Col Max"), $acw62.createElement((0, $8f18596f06454d86$export$6bf0cd3a219bbade), {
                value: range.Max,
                disabled: this.props.disabled || range.Max === 'Col-Max' || index === list.length - 1 && !isRangeValueTypeNumber,
                onChange: (value)=>{
                    this.changeRangeMax(index, value);
                },
                className: "twa:mr-2"
            })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                alignItems: "center",
                className: "twa:h-full"
            }, $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
                api: this.props.api,
                value: range.Color,
                onChange: (color)=>{
                    this.changeRangeColor(index, color);
                },
                className: "twa:mr-2 twa:h-[33px]"
            })), this.props.showRangeDirection && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                disabled: this.props.disabled,
                checked: range.ReverseGradient && range.ReverseGradient == true,
                onChange: (checked)=>this.changeRangeDirectionUp(index, checked),
                className: "twa:ml-2"
            }, "Reverse Gradient"), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
                className: "twa:ml-2 twa:mb-1",
                icon: "delete",
                disabled: this.props.disabled || this.props.ranges && this.props.ranges.length == 1,
                onClick: ()=>this.removeRange(index)
            }))), $acw62.createElement("div", null, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            disabled: this.props.disabled,
            variant: "raised",
            "data-name": "add",
            onClick: ()=>this.addRange()
        }, "Add New Range")))), this.state.rangesType == 'ColumnComparison' && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
            autoFocus: false,
            className: "twa:mt-2"
        }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column Comparison"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "column",
            key: 'cc',
            "data-name": "percent-bar-column-comparison"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:p-2 twa:text-2"
        }, "Create Minimum and Maximum Values by providing a value or selecting another Column, and choose a", ' ', this.props.api.internalApi.getCorrectEnglishVariant('Colour'), " for the Bar."), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
            columns: [
                'label',
                'first',
                'or',
                'second'
            ],
            sizes: [
                'auto',
                'auto',
                'auto',
                '1fr'
            ]
        }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            label: "Min Value:",
            first: $acw62.createElement((0, $8f18596f06454d86$export$6bf0cd3a219bbade), {
                disabled: this.props.disabled,
                type: "number",
                value: comparisonMinValueNumber,
                onChange: (value)=>{
                    this.changeColumnComparisonMinValue(value);
                }
            }),
            or: "OR",
            second: $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:max-w-[15rem]"
            }, $acw62.createElement((0, $568d00bde2c337b2$export$e5d989eba9e871bb), {
                menuPosition: "fixed",
                disabled: this.props.disabled,
                value: comparisonMinValueColumnId,
                type: "number",
                onChange: (columnId)=>{
                    this.onMinColumnSelectedChanged(columnId);
                }
            }))
        }), ' ', $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            label: "Max Value:",
            first: $acw62.createElement((0, $8f18596f06454d86$export$6bf0cd3a219bbade), {
                disabled: this.props.disabled,
                type: "number",
                value: comparisonMaxValueNumber,
                onChange: (value)=>{
                    this.changeColumnComparisonMaxValue(value);
                }
            }),
            or: "OR",
            second: $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:max-w-[15rem]"
            }, $acw62.createElement((0, $568d00bde2c337b2$export$e5d989eba9e871bb), {
                menuPosition: "fixed",
                disabled: this.props.disabled,
                value: comparisonMaxValueColumnId,
                type: "number",
                onChange: (columnId)=>this.onMaxColumnSelectedChanged(columnId)
            }))
        }), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
            label: `Bar ${this.props.api.internalApi.getCorrectEnglishVariant('Colour')}`,
            first: $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
                disabled: this.props.disabled,
                api: this.props.api,
                value: comparisonColor,
                onChange: (color)=>{
                    this.changeColumnComparisonColor(color);
                }
            })
        }))))));
    }
    onRangesTypeChanged(checked) {
        if (checked) {
            let columnComparison = {
                Color: (0, $5aWMQ.getHexForName)((0, $5aWMQ.DARK_GREEN)),
                MinValue: undefined,
                MaxValue: undefined
            };
            this.setState({
                rangesType: 'ColumnComparison'
            });
            this.props.updateColumnComparison(columnComparison);
        } else {
            const ranges = this.props.api.columnScopeApi.createCellColorRangesForScope(this.props.scope);
            this.setState({
                rangesType: 'Standard'
            });
            this.props.updateRanges(ranges);
        }
    }
    handleRangeValueTypeChange(rangeValueType) {
        this.props.onRangeValueTypeChange(rangeValueType);
    }
    changeRangeMin(index, value) {
        const { ranges: ranges } = this.props;
        let newMin = Number(value);
        if (this.props.rangeValueType === 'Percentage') newMin = (0, $43438b6501a58e4a$export$2e2bcd8739ae039)(newMin, 0, 100);
        ranges[index].Min = newMin;
        if (ranges[index - 1]) ranges[index - 1].Max = newMin;
        this.props.updateRanges(ranges);
    }
    changeRangeMax(index, value) {
        const { ranges: ranges } = this.props;
        let newMax = Number(value);
        if (this.props.rangeValueType === 'Percentage') newMax = (0, $43438b6501a58e4a$export$2e2bcd8739ae039)(newMax, 0, 100);
        ranges[index].Max = newMax;
        if (ranges[index + 1]) ranges[index + 1].Min = newMax;
        this.props.updateRanges(ranges);
    }
    changeRangeColor(index, value) {
        const { ranges: ranges } = this.props;
        ranges[index].Color = value;
        this.props.updateRanges(ranges);
    }
    changeRangeDirectionUp(index, checked) {
        const { ranges: ranges } = this.props;
        ranges[index].ReverseGradient = checked;
        this.props.updateRanges(ranges);
    }
    removeRange(index) {
        let ranges = [
            ...this.props.ranges
        ];
        ranges.splice(index, 1);
        // Max 100 is always disabled, this prevents from having a Max range lower than 100
        if (this.props.rangeValueType === 'Percentage' && ranges.length === 1) ranges[0] = {
            ...ranges[0],
            Max: 100
        };
        this.props.updateRanges(ranges);
    }
    setRangeColMin(range) {
        const newRanges = this.props.ranges.map((rangeItem)=>{
            if (rangeItem === range) {
                let newMin = rangeItem.Min === 'Col-Min' ? this.props.minMaxRangeValues.min : 'Col-Min';
                return {
                    ...rangeItem,
                    Min: newMin
                };
            }
            return rangeItem;
        });
        this.props.updateRanges(newRanges);
    }
    setRangeColMax(range) {
        const newRanges = this.props.ranges.map((rangeItem)=>{
            if (rangeItem === range) {
                let newMax = rangeItem.Max === 'Col-Max' ? this.props.minMaxRangeValues.max : 'Col-Max';
                return {
                    ...rangeItem,
                    Max: newMax
                };
            }
            return rangeItem;
        });
        this.props.updateRanges(newRanges);
    }
    addRange() {
        const lastRange = this.props.ranges[this.props.ranges.length - 1];
        let previousRange = lastRange;
        let Min = null;
        if (lastRange.Max === 'Col-Max') {
            Min = this.props.minMaxRangeValues.max;
            previousRange = {
                ...previousRange,
                Max: this.props.minMaxRangeValues.max
            };
        } else Min = lastRange.Max;
        const newRange = {
            Min: Min,
            Max: lastRange.Max,
            Color: (0, $5aWMQ.getHexForName)((0, $5aWMQ.GRAY))
        };
        const newRanges = [
            ...this.props.ranges.slice(0, -1),
            previousRange,
            newRange
        ];
        this.props.updateRanges(newRanges);
    }
    changeColumnComparisonMinValue(value) {
        const { columnComparison: columnComparison } = this.props;
        columnComparison.MinValue = value;
        this.props.updateColumnComparison(columnComparison);
    }
    onMinColumnSelectedChanged(columnId) {
        const { columnComparison: columnComparison } = this.props;
        columnComparison.MinValue = columnId || undefined;
        this.props.updateColumnComparison(columnComparison);
    }
    changeColumnComparisonMaxValue(value) {
        const { columnComparison: columnComparison } = this.props;
        columnComparison.MaxValue = value;
        this.props.updateColumnComparison(columnComparison);
    }
    onMaxColumnSelectedChanged(columnId) {
        const { columnComparison: columnComparison } = this.props;
        columnComparison.MaxValue = columnId || undefined;
        this.props.updateColumnComparison(columnComparison);
    }
    changeColumnComparisonColor(value) {
        const { columnComparison: columnComparison } = this.props;
        columnComparison.Color = value;
        this.props.updateColumnComparison(columnComparison);
    }
}



var $acw62 = parcelRequire("acw62");


var $hrtGQ = parcelRequire("hrtGQ");

var $9OAZF = parcelRequire("9OAZF");
class $955ebb3cc1af2c0d$export$9e4f698119c49807 extends $acw62.Component {
    render() {
        if (!this.props.Style) return null;
        let styleText = (0, $9OAZF.default).IsNotNullOrEmpty(this.props.Text) ? this.props.Text : 'Style';
        let styleVisualisation;
        if (this.props.Style.ClassName) styleVisualisation = $acw62.createElement("div", null, 'CSS Class: ' + this.props.Style.ClassName);
        else {
            let backColorForStyle = this.props.Style.BackColor != undefined ? this.props.Style.BackColor : null;
            let foreColorForStyle = this.props.Style.ForeColor != undefined ? this.props.Style.ForeColor : 'black';
            let borderColorForStyle = this.props.Style.BorderColor != undefined ? this.props.Style.BorderColor : null;
            let fontWeightForStyle = this.props.Style.FontWeight == (0, $hrtGQ.FontWeight).Bold ? 'bold' : 'normal';
            let fontStyleForStyle = this.props.Style.FontStyle == (0, $hrtGQ.FontStyle).Italic ? 'italic' : 'normal';
            let fontSizeForStyle = (0, $3ca1f4c2b77d4ce9$export$51594d8e7854ff7d).getCssFontSizeFromFontSizeEnum(this.props.Style.FontSize);
            styleVisualisation = $acw62.createElement("div", {
                className: this.props.Style.BackColor != undefined ? '' : 'ab_white_grey_stripes',
                style: {
                    textAlign: 'center',
                    margin: '2px',
                    padding: '3px',
                    background: backColorForStyle,
                    color: foreColorForStyle,
                    borderColor: borderColorForStyle,
                    borderStyle: borderColorForStyle ? 'solid' : 'none',
                    fontWeight: fontWeightForStyle,
                    fontStyle: fontStyleForStyle,
                    fontSize: fontSizeForStyle
                }
            }, styleText);
        }
        return styleVisualisation;
    }
}



var $5aWMQ = parcelRequire("5aWMQ");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

const $190fc76a6baabeea$var$getText = (options)=>{
    let text = '';
    if (options && options.includes('CellValue')) text += '20';
    if (options && options.includes('PercentageValue')) text += ' (50%)';
    return text.trim();
};
const $190fc76a6baabeea$export$4c77fe7908d1c9e1 = (props)=>{
    const cellText = $190fc76a6baabeea$var$getText(props.cellText);
    const tooltip = $190fc76a6baabeea$var$getText(props.toolTipText);
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        title: tooltip,
        className: "twa:flex-1"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        style: {
            backgroundColor: props.backgroundColor
        },
        className: `twa:flex-1 ${cellText ? 'twa:h-[8px]' : 'twa:h-[18px]'}`
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:basis-[50%]",
        style: {
            background: props.barBackgroundColor
        }
    })), cellText && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-3"
    }, cellText));
};



const $91b6c03b795a5c4f$export$35385ae8e5afe50d = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const columnComparison = props.percentBarStyle.ColumnComparison;
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:mr-3"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:basis-[120px] twa:mr-3"
    }, isNaN(Number(columnComparison.MinValue)) ? '[' + api.columnApi.getFriendlyNameForColumnId(String(columnComparison.MinValue)) + ']' : columnComparison.MinValue, ' ', "to", ' ', isNaN(Number(columnComparison.MaxValue)) ? '[' + api.columnApi.getFriendlyNameForColumnId(String(columnComparison.MaxValue)) + ']' : columnComparison.MaxValue, ' '), $acw62.createElement((0, $190fc76a6baabeea$export$4c77fe7908d1c9e1), {
        backgroundColor: columnComparison.Color,
        barBackgroundColor: props.percentBarStyle.BackColor,
        cellText: props.percentBarStyle.CellText,
        toolTipText: props.percentBarStyle.ToolTipText
    }));
};



var $acw62 = parcelRequire("acw62");


const $c762702c0528d73e$export$fc5d2cd612c38839 = (props)=>{
    let postfix = '';
    if (props.percentBarStyle.RangeValueType === 'Percentage') postfix = '%';
    return $acw62.createElement($acw62.Fragment, null, props.percentBarStyle.CellRanges.map((range, i)=>$acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            key: i,
            alignItems: "stretch",
            className: "twa:mr-3 twa:mb-2"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:basis-[120px] twa:mr-3",
            alignItems: "center"
        }, range.Min, postfix, " to ", range.Max, postfix), $acw62.createElement((0, $190fc76a6baabeea$export$4c77fe7908d1c9e1), {
            backgroundColor: props.percentBarStyle.BackColor,
            barBackgroundColor: range.Color,
            cellText: props.percentBarStyle.CellText,
            toolTipText: props.percentBarStyle.ToolTipText
        }))));
};




var $9g4SS = parcelRequire("9g4SS");

const $5ed0b75d515b5af3$export$f6628dedfc94115c = (data)=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $5ed0b75d515b5af3$export$3fd9ce47a190872b(data, api);
};
const $5ed0b75d515b5af3$var$getRanges = (ranges, rangeValueType)=>{
    let postfix = '';
    if (rangeValueType === 'Percentage') postfix = '%';
    return ranges.map((r, i)=>$acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            key: i,
            alignItems: "center",
            className: "twa:mr-3"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mr-1"
        }, r.Min, postfix, " to ", r.Max, postfix), $acw62.createElement((0, $955ebb3cc1af2c0d$export$9e4f698119c49807), {
            Style: {
                BackColor: r.Color,
                ForeColor: r.Color
            }
        })));
};
const $5ed0b75d515b5af3$var$getColumnComparison = (columnComparison, api)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        key: 'cc',
        alignItems: "center",
        className: "twa:mr-3"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mr-1"
    }, "Min Value:", ' ', isNaN(Number(columnComparison.MinValue)) ? '[' + api.columnApi.getFriendlyNameForColumnId(String(columnComparison.MinValue)) + ']' : columnComparison.MinValue, ' ', ", Max Value:", ' ', isNaN(Number(columnComparison.MaxValue)) ? '[' + api.columnApi.getFriendlyNameForColumnId(String(columnComparison.MaxValue)) + ']' : columnComparison.MaxValue, ' '), $acw62.createElement((0, $955ebb3cc1af2c0d$export$9e4f698119c49807), {
        Style: {
            BackColor: columnComparison.Color,
            ForeColor: columnComparison.Color
        }
    }));
};
const $5ed0b75d515b5af3$export$3fd9ce47a190872b = (data, api)=>{
    if (!api) {
        const { api: adaptableApi } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
        api = adaptableApi;
    }
    if (data.GradientStyle) {
        if (data.GradientStyle.CellRanges) return $5ed0b75d515b5af3$var$getRanges(data.GradientStyle.CellRanges, data.GradientStyle.RangeValueType);
        if (data.GradientStyle.ColumnComparison) return $5ed0b75d515b5af3$var$getColumnComparison(data.GradientStyle.ColumnComparison, api);
    }
    if (data.PercentBarStyle) {
        if (data.PercentBarStyle.ColumnComparison) return $acw62.createElement((0, $91b6c03b795a5c4f$export$35385ae8e5afe50d), {
            percentBarStyle: data.PercentBarStyle
        });
        if (data.PercentBarStyle.CellRanges) return $acw62.createElement((0, $c762702c0528d73e$export$fc5d2cd612c38839), {
            percentBarStyle: data.PercentBarStyle
        });
    }
    return $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "No Styling Defined");
};
const $5ed0b75d515b5af3$export$a858f3158c597ed6 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const minMaxRangeValues = $acw62.useMemo(()=>{
        const columnId = data.ColumnId;
        if (!columnId) return null;
        const column = api.columnApi.getColumnWithColumnId(columnId);
        return {
            min: api.styledColumnApi.internalApi.getMinValueForNumericColumn(column),
            max: api.styledColumnApi.internalApi.getMaxValueForNumericColumn(column)
        };
    }, [
        data
    ]);
    const scope = {
        ColumnIds: [
            data.ColumnId
        ]
    }; // TODO: remove scope when format column columnStyle is removed
    // gradient
    const onUpdateGradientStyleRanges = (ranges)=>{
        const gradientStyle = {
            ...data.GradientStyle,
            CellRanges: ranges
        };
        // delete gradientStyle.ColumnComparison in case we are switching from ColumnComparison to CellRanges
        delete gradientStyle.ColumnComparison;
        props.onChange({
            ...data,
            GradientStyle: gradientStyle
        });
    };
    const onUpdateGradientStyleColumnComparison = (columnComparison)=>{
        const GradientStyle = {
            ColumnComparison: columnComparison
        };
        props.onChange({
            ...data,
            GradientStyle: GradientStyle
        });
    };
    // percentbar
    const onUpdatePercentBarStyleColumnComparison = (columnComparison)=>{
        const PercentBarStyle = {
            ...data.PercentBarStyle,
            ColumnComparison: columnComparison
        };
        props.onChange({
            ...data,
            PercentBarStyle: PercentBarStyle
        });
    };
    const onUpdatePercentBarStyleRanges = (ranges)=>{
        const PercentBarStyle = {
            ...data.PercentBarStyle,
            CellRanges: ranges
        };
        props.onChange({
            ...data,
            PercentBarStyle: PercentBarStyle
        });
    };
    const onPercentBarCellTextCellValueChanged = (checked)=>{
        let percentBarStyle = data?.PercentBarStyle;
        if (checked) {
            if (!percentBarStyle.CellText) percentBarStyle.CellText = [
                'CellValue'
            ];
            else percentBarStyle.CellText.push('CellValue');
        } else if (percentBarStyle.CellText && percentBarStyle.CellText.includes('PercentageValue')) percentBarStyle.CellText = [
            'PercentageValue'
        ];
        else percentBarStyle.CellText = [];
        props.onChange({
            ...data,
            PercentBarStyle: percentBarStyle
        });
    };
    const onPercentBarCellTextPercentValueChanged = (checked)=>{
        let percentBarStyle = data?.PercentBarStyle;
        if (checked) {
            if (!percentBarStyle.CellText) percentBarStyle.CellText = [
                'PercentageValue'
            ];
            else percentBarStyle.CellText.push('PercentageValue');
        } else if (percentBarStyle.CellText && percentBarStyle.CellText.includes('CellValue')) percentBarStyle.CellText = [
            'CellValue'
        ];
        else percentBarStyle.CellText = [];
        props.onChange({
            ...data,
            PercentBarStyle: percentBarStyle
        });
    };
    const handlePercentBarCellTextPositionChange = (percentBarPosition)=>{
        props.onChange({
            ...data,
            PercentBarStyle: {
                ...data.PercentBarStyle,
                CellTextPosition: percentBarPosition
            }
        });
    };
    const onPercentBarToolTipTextCellValueChanged = (checked)=>{
        let percentBarStyle = data?.PercentBarStyle;
        if (checked) {
            if (!percentBarStyle.ToolTipText) percentBarStyle.ToolTipText = [
                'CellValue'
            ];
            else percentBarStyle.ToolTipText.push('CellValue');
        } else if (percentBarStyle.ToolTipText && percentBarStyle.ToolTipText.includes('PercentageValue')) percentBarStyle.ToolTipText = [
            'PercentageValue'
        ];
        else percentBarStyle.ToolTipText = [];
        props.onChange({
            ...data,
            PercentBarStyle: percentBarStyle
        });
    };
    const onPercentBarToolTipTextPercentValueChanged = (checked)=>{
        let percentBarStyle = data.PercentBarStyle;
        if (checked) {
            if (!percentBarStyle.ToolTipText) percentBarStyle.ToolTipText = [
                'PercentageValue'
            ];
            else percentBarStyle.ToolTipText.push('PercentageValue');
        } else if (percentBarStyle.ToolTipText && percentBarStyle.ToolTipText.includes('CellValue')) percentBarStyle.ToolTipText = [
            'CellValue'
        ];
        else percentBarStyle.ToolTipText = [];
        props.onChange({
            ...data,
            PercentBarStyle: percentBarStyle
        });
    };
    const onUsePercentStyleColorCheckChanged = (checked)=>{
        let percentBarStyle = data?.PercentBarStyle;
        percentBarStyle.BackColor = checked ? (0, $5aWMQ.getHexForName)((0, $5aWMQ.GRAY)) : null;
        props.onChange({
            ...data,
            PercentBarStyle: percentBarStyle
        });
    };
    const onForeColorSelectChange = (color)=>{
        let percentBarStyle = data.PercentBarStyle;
        percentBarStyle.BackColor = color;
        props.onChange({
            ...data,
            PercentBarStyle: percentBarStyle
        });
    };
    const handleRangeValueTypeChange = $acw62.useCallback((rangeValueType)=>{
        const ranges = rangeValueType === 'Number' ? api.columnScopeApi.createCellColorRangesForScope(scope) : [
            {
                Min: 0,
                Max: 100,
                Color: (0, $5aWMQ.getHexForName)((0, $5aWMQ.GRAY))
            }
        ];
        let newStyledColumn = data;
        const commonStyle = {
            CellRanges: ranges,
            RangeValueType: rangeValueType
        };
        if ('GradientStyle' in newStyledColumn) newStyledColumn = {
            ...newStyledColumn,
            GradientStyle: {
                ...newStyledColumn.GradientStyle,
                ...commonStyle
            }
        };
        else newStyledColumn = {
            ...newStyledColumn,
            PercentBarStyle: {
                ...newStyledColumn.PercentBarStyle,
                ...commonStyle
            }
        };
        props.onChange(newStyledColumn);
    }, [
        data
    ]);
    const disabled = !data.ColumnId;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, data?.GradientStyle && $acw62.createElement((0, $4b445e6a23353401$export$effae0f4725478f2), {
        disabled: !data.ColumnId,
        minMaxRangeValues: minMaxRangeValues,
        api: api,
        scope: scope,
        showRangeDirection: true,
        ranges: data.GradientStyle?.CellRanges,
        rangeValueType: data.GradientStyle?.RangeValueType,
        onRangeValueTypeChange: handleRangeValueTypeChange,
        columnComparison: data?.GradientStyle?.ColumnComparison,
        updateRanges: (ranges)=>onUpdateGradientStyleRanges(ranges),
        updateColumnComparison: (columnComparison)=>onUpdateGradientStyleColumnComparison(columnComparison)
    }), data.PercentBarStyle && $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $4b445e6a23353401$export$effae0f4725478f2), {
        disabled: disabled,
        minMaxRangeValues: minMaxRangeValues,
        api: api,
        scope: scope,
        showRangeDirection: false,
        ranges: data.PercentBarStyle?.CellRanges,
        rangeValueType: data.PercentBarStyle?.RangeValueType,
        onRangeValueTypeChange: handleRangeValueTypeChange,
        columnComparison: data?.PercentBarStyle?.ColumnComparison,
        updateRanges: (ranges)=>onUpdatePercentBarStyleRanges(ranges),
        updateColumnComparison: (columnComparison)=>onUpdatePercentBarStyleColumnComparison(columnComparison)
    }), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:mt-2 twa:ml-2"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Cell Display:"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        disabled: disabled,
        className: "twa:ml-2",
        checked: data.PercentBarStyle?.CellText?.includes('CellValue'),
        onChange: (checked)=>onPercentBarCellTextCellValueChanged(checked)
    }, "Cell Value"), ' ', $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        disabled: disabled,
        className: "twa:ml-3",
        checked: data?.PercentBarStyle?.CellText?.includes('PercentageValue'),
        onChange: (checked)=>onPercentBarCellTextPercentValueChanged(checked)
    }, "Percent Value", ' '), ' '), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Cell Display Position:"
    }, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        disabled: (0, $9g4SS.default).IsNullOrEmpty(data.PercentBarStyle.CellText) || disabled,
        columns: [
            'label'
        ],
        items: [
            {
                label: 'Above Bar',
                onClick: ()=>handlePercentBarCellTextPositionChange('Above')
            },
            {
                label: 'Below Bar',
                onClick: ()=>handlePercentBarCellTextPositionChange('Below')
            },
            {
                label: 'Merged',
                onClick: ()=>handlePercentBarCellTextPositionChange('Merged')
            }
        ]
    }, data.PercentBarStyle?.CellTextPosition ?? 'Below')), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "ToolTip Display:"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        disabled: disabled,
        className: "twa:ml-2",
        checked: data?.PercentBarStyle?.ToolTipText?.includes('CellValue'),
        onChange: (checked)=>onPercentBarToolTipTextCellValueChanged(checked)
    }, "Cell Value"), ' ', $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        disabled: disabled,
        className: "twa:ml-3",
        checked: data?.PercentBarStyle?.ToolTipText?.includes('PercentageValue'),
        onChange: (checked)=>onPercentBarToolTipTextPercentValueChanged(checked)
    }, "Percent Value", ' '), ' '), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: `Back ${api.internalApi.getCorrectEnglishVariant('Colour')}`
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:ml-2"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        disabled: disabled,
        checked: !!data.PercentBarStyle?.BackColor,
        onChange: (checked)=>onUsePercentStyleColorCheckChanged(checked),
        className: "twa:mr-2"
    }), data.PercentBarStyle?.BackColor !== undefined && $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        disabled: disabled,
        api: api,
        value: data.PercentBarStyle?.BackColor,
        onChange: (x)=>onForeColorSelectChange(x)
    }))))), !data.ColumnId && $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), {
        className: "twa:mt-2"
    }, "You need to select a column before styling."));
};






var $acw62 = parcelRequire("acw62");






const $090421cc4ba8fac6$export$c2396a8463c95432 = (data)=>{
    const badgeStyle = data;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Data Rows ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, badgeStyle.RowScope?.ExcludeDataRows ? 'no' : 'yes')), ' ', $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Group Rows ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, badgeStyle.RowScope?.ExcludeGroupRows ? 'no' : 'yes')), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Summary Rows ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, badgeStyle.RowScope?.ExcludeSummaryRows ? 'no' : 'yes')), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, "Total Rows ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, badgeStyle.RowScope?.ExcludeTotalRows ? 'no' : 'yes')));
};
const $090421cc4ba8fac6$export$97cef0beab27cdc5 = (props)=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const onExcludeDataRowsChanged = (includeDataRows)=>{
        props.onChange({
            ...data,
            BadgeStyle: {
                ...data.BadgeStyle,
                RowScope: {
                    ...data.BadgeStyle.RowScope,
                    ExcludeDataRows: !includeDataRows
                }
            }
        });
    };
    const onExcludeGroupedRowsChanged = (includeGroupedRows)=>{
        props.onChange({
            ...data,
            BadgeStyle: {
                ...data.BadgeStyle,
                RowScope: {
                    ...data.BadgeStyle.RowScope,
                    ExcludeGroupRows: !includeGroupedRows
                }
            }
        });
    };
    const onExcludeSummaryRowsChanged = (includeSummaryRows)=>{
        props.onChange({
            ...data,
            BadgeStyle: {
                ...data.BadgeStyle,
                RowScope: {
                    ...data.BadgeStyle.RowScope,
                    ExcludeSummaryRows: !includeSummaryRows
                }
            }
        });
    };
    const onExcludeTotalRowsChanged = (includeTotalRows)=>{
        props.onChange({
            ...data,
            BadgeStyle: {
                ...data.BadgeStyle,
                RowScope: {
                    ...data.BadgeStyle.RowScope,
                    ExcludeTotalRows: !includeTotalRows
                }
            }
        });
    };
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Row Types"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Data (leaf) Rows:"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:ml-2"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "exclude-data-rows-checkbox",
        className: "twa:mr-2",
        checked: // @ts-ignore
        !data.BadgeStyle.RowScope?.ExcludeDataRows,
        onChange: onExcludeDataRowsChanged
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Group Rows:"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:ml-2"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        className: "twa:mr-2",
        "data-name": "exclude-grouped-rows-checkbox",
        checked: // @ts-ignore
        !data.BadgeStyle.RowScope?.ExcludeGroupRows,
        onChange: onExcludeGroupedRowsChanged
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Summary Rows:"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:ml-2"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "exclude-summary-rows-checkbox",
        className: "twa:mr-2",
        checked: // @ts-ignore
        !data.BadgeStyle.RowScope?.ExcludeSummaryRows,
        onChange: onExcludeSummaryRowsChanged
    }))), ' ', $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Total Rows:"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:ml-2"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "exclude-total-rows-checkbox",
        className: "twa:mr-2",
        checked: // @ts-ignore
        !data.BadgeStyle.RowScope?.ExcludeTotalRows,
        onChange: onExcludeTotalRowsChanged
    })))))));
};



var $acw62 = parcelRequire("acw62");









const $d7cc9ec551ea7dec$var$SparklineTypes = {
    LINE: 'line',
    AREA: 'area',
    BAR_VERTICAL: 'bar_vertical',
    BAR_HORIZONTAL: 'bar_horizontal'
};
const $d7cc9ec551ea7dec$var$sparklineTypeOptions = [
    {
        label: 'Line',
        value: $d7cc9ec551ea7dec$var$SparklineTypes.LINE
    },
    {
        label: 'Area',
        value: $d7cc9ec551ea7dec$var$SparklineTypes.AREA
    },
    {
        label: 'Column',
        value: $d7cc9ec551ea7dec$var$SparklineTypes.BAR_VERTICAL
    },
    {
        label: 'Bar',
        value: $d7cc9ec551ea7dec$var$SparklineTypes.BAR_HORIZONTAL
    }
];
const $d7cc9ec551ea7dec$export$9df9adc888ce29bd = ({ onChange: onChange })=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const sparklineOptions = data.SparklineStyle?.options ?? {
        type: $d7cc9ec551ea7dec$var$SparklineTypes.LINE
    };
    if (!sparklineOptions.type) sparklineOptions.type = $d7cc9ec551ea7dec$var$SparklineTypes.LINE;
    const handleOptionsChange = (newOptions)=>{
        const updatedStyledColumn = {
            ...data,
            SparklineStyle: {
                ...data.SparklineStyle,
                options: newOptions
            }
        };
        onChange(updatedStyledColumn);
    };
    const currentType = sparklineOptions.type ?? 'line';
    const currentDirection = sparklineOptions.direction;
    const sparklineType = currentType === 'bar' ? `bar_${currentDirection ?? 'vertical'}` : currentType;
    const handleTypeChange = (value)=>{
        const [type, direction] = value.split('_');
        const newOptions = {
            ...sparklineOptions,
            type: type
        };
        if (direction) newOptions.direction = direction;
        else delete newOptions.direction;
        handleOptionsChange(newOptions);
    };
    const isObjectNumberArray = api.columnApi.getColumnWithColumnId(data.ColumnId)?.dataType === 'objectArray';
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mb-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Settings"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Sparkline Type"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[160px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        options: $d7cc9ec551ea7dec$var$sparklineTypeOptions,
        value: sparklineType,
        onChange: handleTypeChange,
        placeholder: "Select Sparkline Type"
    }))), isObjectNumberArray && $acw62.createElement($d7cc9ec551ea7dec$var$SparklineObjectArrayProperties, {
        options: sparklineOptions,
        onChange: handleOptionsChange
    }), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Min Value"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        type: "number",
        value: sparklineOptions.min ?? '',
        onChange: (e)=>handleOptionsChange({
                ...sparklineOptions,
                min: e.target.value === '' ? undefined : Number(e.target.value)
            }),
        placeholder: 'Auto',
        title: "User override for the automatically determined min value (based on series data)"
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Max Value"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        type: "number",
        value: sparklineOptions.max ?? '',
        onChange: (e)=>handleOptionsChange({
                ...sparklineOptions,
                max: e.target.value === '' ? undefined : Number(e.target.value)
            }),
        placeholder: 'Auto',
        title: "User override for the automatically determined max value (based on series data)"
    }))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mb-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Theming"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Axis"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
        hidden: sparklineOptions.type === 'bar'
    }, "Marker"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Tooltip"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Highlight Style"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement($d7cc9ec551ea7dec$var$SparklineThemingOptions, {
        options: sparklineOptions,
        onChange: handleOptionsChange
    })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement($d7cc9ec551ea7dec$var$SparklineAxisOptions, {
        options: sparklineOptions,
        onChange: handleOptionsChange
    })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement($d7cc9ec551ea7dec$var$SparklineMarkerOptions, {
        options: sparklineOptions,
        onChange: handleOptionsChange
    })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement($d7cc9ec551ea7dec$var$SparklineTooltipOptions, {
        options: sparklineOptions,
        onChange: handleOptionsChange
    })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement($d7cc9ec551ea7dec$var$SparklineHighlightOptions, {
        options: sparklineOptions,
        onChange: handleOptionsChange
    }))));
};
const $d7cc9ec551ea7dec$var$SparklineObjectArrayProperties = ({ options: options, onChange: onChange })=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const [previewData, setPreviewData] = $acw62.useState('');
    $acw62.useEffect(()=>{
        const column = api.columnApi.getColumnWithColumnId(data.ColumnId);
        if (!column) return;
        try {
            for(let row = 0; row < 20; row++){
                const rowNode = api.gridApi.getRowNodeForIndex(row);
                const cellData = rowNode?.data?.[column.field]?.[0];
                if (cellData) {
                    const preview = JSON.stringify(cellData, null, 2).replace(/[{}",]/g, '');
                    setPreviewData(preview);
                    break;
                }
            }
        } catch (error) {
            api.logError('Error parsing sparkline data', error);
        }
    }, [
        api,
        data.ColumnId
    ]);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "X Key"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        value: options.xKey ?? 'x',
        onChange: (e)=>onChange({
                ...options,
                xKey: e.target.value
            })
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Y Key"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        value: options.yKey ?? 'y',
        onChange: (e)=>onChange({
                ...options,
                yKey: e.target.value
            })
    })), previewData && $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Preview"
    }, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, previewData)));
};
const $d7cc9ec551ea7dec$var$SparklineThemingOptions = ({ options: options, onChange: onChange })=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const sparklineOptions = options;
    const handleChange = (key, value)=>{
        onChange({
            ...options,
            [key]: value
        });
    };
    const handlePaddingChange = (key, value)=>{
        const currentPadding = sparklineOptions.padding || {};
        handleChange('padding', {
            ...currentPadding,
            [key]: value
        });
    };
    const themes = [
        {
            value: 'ag-default',
            label: 'Default'
        },
        {
            value: 'ag-default-dark',
            label: 'Default Dark'
        },
        {
            value: 'ag-sheets',
            label: 'Sheets'
        },
        {
            value: 'ag-sheets-dark',
            label: 'Sheets Dark'
        },
        {
            value: 'ag-polychroma',
            label: 'Polychroma'
        },
        {
            value: 'ag-polychroma-dark',
            label: 'Polychroma Dark'
        },
        {
            value: 'ag-vivid',
            label: 'Vivid'
        },
        {
            value: 'ag-vivid-dark',
            label: 'Vivid Dark'
        },
        {
            value: 'ag-material',
            label: 'Material'
        },
        {
            value: 'ag-material-dark',
            label: 'Material Dark'
        },
        {
            value: 'ag-financial',
            label: 'Financial'
        },
        {
            value: 'ag-financial-dark',
            label: 'Financial Dark'
        }
    ];
    return $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, sparklineOptions.type !== 'line' && $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Fill"
    }, $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        title: "The colour for filling shapes",
        api: api,
        value: sparklineOptions.fill,
        onChange: (color)=>handleChange('fill', color)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Stroke"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        title: "The colour for the stroke",
        api: api,
        value: sparklineOptions.stroke,
        onChange: (color)=>handleChange('stroke', color)
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-2 twa:mr-1"
    }, "Width"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        title: "The width of the stroke in pixels",
        type: "number",
        className: "twa:w-[70px]",
        min: 0,
        value: sparklineOptions.strokeWidth ?? '',
        onChange: (e)=>handleChange('strokeWidth', Number(e.target.value))
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Padding"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mr-1"
    }, "Top"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        type: "number",
        min: 0,
        value: sparklineOptions.padding?.top ?? '',
        onChange: (e)=>handlePaddingChange('top', Number(e.target.value)),
        className: "twa:w-[70px]",
        title: "The number of pixels of padding at the top of the chart area"
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-2 twa:mr-1"
    }, "Right"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        type: "number",
        min: 0,
        value: sparklineOptions.padding?.right ?? '',
        onChange: (e)=>handlePaddingChange('right', Number(e.target.value)),
        className: "twa:w-[70px]",
        title: "The number of pixels of padding at the right of the chart area"
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-2 twa:mr-1"
    }, "Bottom"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        type: "number",
        min: 0,
        value: sparklineOptions.padding?.bottom ?? '',
        onChange: (e)=>handlePaddingChange('bottom', Number(e.target.value)),
        className: "twa:w-[70px]",
        title: "The number of pixels of padding at the bottom of the chart area"
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-2 twa:mr-1"
    }, "Left"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        type: "number",
        min: 0,
        value: sparklineOptions.padding?.left ?? '',
        onChange: (e)=>handlePaddingChange('left', Number(e.target.value)),
        className: "twa:w-[70px]",
        title: "The number of pixels of padding at the left of the chart area"
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Line Dash"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        title: "Length of dashes and gaps in pixels (comma-separated values, e.g. '3,6,9')",
        value: sparklineOptions.lineDash?.join(',') ?? '',
        onChange: (e)=>{
            const value = e.target.value;
            const dashArray = value ? value.split(',').map(Number).filter((n)=>!isNaN(n)) : [];
            handleChange('lineDash', dashArray);
        }
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Line Dash Offset"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        title: "The offset of the line dash pattern in pixels",
        type: "number",
        min: 0,
        value: sparklineOptions.lineDashOffset ?? '',
        onChange: (e)=>handleChange('lineDashOffset', Number(e.target.value))
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Background"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: sparklineOptions.background?.visible ?? false,
        onChange: (visible)=>handleChange('background', {
                ...sparklineOptions.background,
                visible: visible
            })
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-2"
    }, $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        disabled: !sparklineOptions.background?.visible,
        title: "The colour of the chart background",
        api: api,
        value: sparklineOptions.background?.fill,
        onChange: (fill)=>handleChange('background', {
                ...sparklineOptions.background,
                fill: fill
            })
    })))), typeof sparklineOptions.theme !== 'object' && $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Theme"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[160px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        value: sparklineOptions.theme ?? 'ag-default',
        onChange: (themeName)=>handleChange('theme', themeName),
        options: themes
    }))));
};
const $d7cc9ec551ea7dec$var$SparklineAxisOptions = ({ options: options, onChange: onChange })=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const sparklineOptions = options ?? {};
    if (!sparklineOptions.axis?.type) {
        sparklineOptions.axis = sparklineOptions.axis ?? {
            type: 'category'
        };
        sparklineOptions.axis.type = 'category';
    }
    const handleChange = (value)=>{
        onChange({
            ...options,
            axis: {
                ...options.axis,
                ...value
            }
        });
    };
    const axisTypes = [
        {
            value: 'category',
            label: 'Category'
        },
        {
            value: 'number',
            label: 'Number'
        },
        {
            value: 'time',
            label: 'Time'
        }
    ];
    const isAxisEnabled = sparklineOptions.axis?.visible ?? false;
    return $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Show Axis"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: isAxisEnabled,
        onChange: (visible)=>handleChange({
                visible: visible
            })
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Axis Type"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[160px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        disabled: !isAxisEnabled,
        value: sparklineOptions.axis.type,
        onChange: (type)=>handleChange({
                type: type
            }),
        options: axisTypes
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Stroke"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        disabled: !isAxisEnabled,
        title: "The colour of the axis line",
        api: api,
        value: sparklineOptions.axis?.stroke,
        onChange: (stroke)=>handleChange({
                stroke: stroke
            })
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-2 twa:mr-1"
    }, "Width"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        disabled: !isAxisEnabled,
        className: "twa:w-[70px]",
        title: "The width in pixels of the axis line",
        type: "number",
        min: 0,
        value: sparklineOptions.axis?.strokeWidth ?? '',
        onChange: (e)=>handleChange({
                strokeWidth: Number(e.target.value)
            })
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Reverse Scale"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        disabled: !isAxisEnabled,
        checked: sparklineOptions.axis?.reverse,
        onChange: (reverse)=>handleChange({
                reverse: reverse
            })
    })), sparklineOptions.axis.type === 'category' && $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Padding"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mr-1"
    }, "Inner"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        disabled: !isAxisEnabled,
        title: "The size of the gap between categories (0-1)",
        type: "number",
        min: 0,
        max: 1,
        step: 0.1,
        value: sparklineOptions.axis?.paddingInner ?? '',
        onChange: (e)=>handleChange({
                paddingInner: Number(e.target.value)
            })
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-2 twa:mr-1"
    }, "Outer"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        disabled: !isAxisEnabled,
        title: "The padding on the outside of first and last categories (0-1)",
        type: "number",
        min: 0,
        max: 1,
        step: 0.1,
        value: sparklineOptions.axis?.paddingOuter ?? '',
        onChange: (e)=>handleChange({
                paddingOuter: Number(e.target.value)
            })
    })))));
};
const $d7cc9ec551ea7dec$var$SparklineTooltipOptions = ({ options: options, onChange: onChange })=>{
    const sparklineOptions = options;
    const isTooltipEnabled = sparklineOptions.tooltip?.enabled ?? false;
    const handleChange = (property, value)=>{
        onChange({
            ...options,
            tooltip: {
                ...options.tooltip,
                [property]: value
            }
        });
    };
    const anchorToOptions = [
        {
            value: 'pointer',
            label: 'Pointer'
        },
        {
            value: 'node',
            label: 'Node'
        },
        {
            value: 'chart',
            label: 'Chart'
        }
    ];
    const placementOptions = [
        {
            value: 'top',
            label: 'Top'
        },
        {
            value: 'right',
            label: 'Right'
        },
        {
            value: 'bottom',
            label: 'Bottom'
        },
        {
            value: 'left',
            label: 'Left'
        },
        {
            value: 'top-right',
            label: 'Top Right'
        },
        {
            value: 'bottom-right',
            label: 'Bottom Right'
        },
        {
            value: 'bottom-left',
            label: 'Bottom Left'
        },
        {
            value: 'top-left',
            label: 'Top Left'
        },
        {
            value: 'center',
            label: 'Center'
        }
    ];
    return $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Show Tooltip"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: isTooltipEnabled,
        onChange: (enabled)=>handleChange('enabled', enabled)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Anchor To"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[160px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        disabled: !isTooltipEnabled,
        value: sparklineOptions.tooltip?.position?.anchorTo,
        onChange: (value)=>handleChange('position', {
                ...sparklineOptions.tooltip?.position,
                anchorTo: value
            }),
        options: anchorToOptions
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Placement"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[160px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        disabled: !isTooltipEnabled,
        value: sparklineOptions.tooltip?.position?.placement,
        onChange: (value)=>handleChange('position', {
                ...sparklineOptions.tooltip?.position,
                placement: value
            }),
        options: placementOptions
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Position Offset X"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        disabled: !isTooltipEnabled,
        title: "The horizontal offset in pixels for the position of the tooltip.",
        type: "number",
        value: sparklineOptions.tooltip?.position?.xOffset ?? '',
        onChange: (e)=>handleChange('position', {
                ...sparklineOptions.tooltip?.position,
                xOffset: Number(e.target.value)
            })
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Position Offset Y"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        disabled: !isTooltipEnabled,
        title: "The vertical offset in pixels for the position of the tooltip.",
        type: "number",
        value: sparklineOptions.tooltip?.position?.yOffset ?? '',
        onChange: (e)=>handleChange('position', {
                ...sparklineOptions.tooltip?.position,
                yOffset: Number(e.target.value)
            })
    })));
};
const $d7cc9ec551ea7dec$var$SparklineMarkerOptions = ({ options: options, onChange: onChange })=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const sparklineOptions = options;
    const handleChange = (value)=>{
        onChange({
            ...options,
            marker: {
                ...options.marker,
                ...value
            }
        });
    };
    const markerShapes = [
        {
            value: 'circle',
            label: 'Circle'
        },
        {
            value: 'cross',
            label: 'Cross'
        },
        {
            value: 'diamond',
            label: 'Diamond'
        },
        {
            value: 'heart',
            label: 'Heart'
        },
        {
            value: 'plus',
            label: 'Plus'
        },
        {
            value: 'pin',
            label: 'Pin'
        },
        {
            value: 'square',
            label: 'Square'
        },
        {
            value: 'star',
            label: 'Star'
        },
        {
            value: 'triangle',
            label: 'Triangle'
        }
    ];
    const isMarkerEnabled = sparklineOptions.marker?.enabled ?? false;
    return $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Show Markers"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: isMarkerEnabled,
        onChange: (enabled)=>handleChange({
                enabled: enabled
            })
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Marker Size"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        disabled: !isMarkerEnabled,
        type: "number",
        min: 1,
        value: sparklineOptions.marker?.size ?? '',
        onChange: (e)=>handleChange({
                size: Number(e.target.value)
            }),
        title: "The size in pixels of the markers"
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Marker Shape"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:max-w-[160px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        disabled: !isMarkerEnabled,
        value: sparklineOptions.marker?.shape,
        onChange: (shape)=>handleChange({
                shape: shape
            }),
        options: markerShapes
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Fill"
    }, $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        disabled: !isMarkerEnabled,
        title: "The colour for filling markers",
        api: api,
        value: sparklineOptions.marker?.fill,
        onChange: (fill)=>handleChange({
                fill: fill
            })
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Stroke"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        disabled: !isMarkerEnabled,
        title: "The colour for the marker stroke",
        api: api,
        value: sparklineOptions.marker?.stroke,
        onChange: (stroke)=>handleChange({
                stroke: stroke
            })
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-2 twa:mr-1"
    }, "Width"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        disabled: !isMarkerEnabled,
        className: "twa:w-[70px]",
        type: "number",
        min: 0,
        value: sparklineOptions.marker?.strokeWidth ?? '',
        onChange: (e)=>handleChange({
                strokeWidth: Number(e.target.value)
            }),
        title: "The width of the marker stroke in pixels"
    }))));
};
const $d7cc9ec551ea7dec$var$SparklineHighlightOptions = ({ options: options, onChange: onChange })=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const highlightOptions = options.highlight;
    const handleBaseChange = (value)=>{
        onChange({
            ...options,
            highlight: {
                ...options.highlight,
                ...value
            }
        });
    };
    const handleItemChange = (value)=>{
        onChange({
            ...options,
            highlight: {
                ...options.highlight,
                highlightedItem: {
                    ...options.highlight?.highlightedItem,
                    ...value
                }
            }
        });
    };
    const handleSeriesChange = (value)=>{
        onChange({
            ...options,
            highlight: {
                ...options.highlight,
                highlightedSeries: {
                    ...options.highlight?.highlightedSeries,
                    ...value
                }
            }
        });
    };
    return $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Item Fill"
    }, $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        title: "The colour for filling highlighted items",
        api: api,
        value: highlightOptions?.highlightedItem?.fill,
        onChange: (fill)=>handleItemChange({
                fill: fill
            })
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Item Stroke"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, $acw62.createElement((0, $f85e0cbc2462343a$export$9feb1bc2e5f1ccb3), {
        title: "The colour for the highlighted item stroke",
        api: api,
        value: highlightOptions?.highlightedItem?.stroke,
        onChange: (stroke)=>handleItemChange({
                stroke: stroke
            })
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-2 twa:mr-1"
    }, "Width"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        className: "twa:w-[70px]",
        type: "number",
        min: 0,
        value: highlightOptions?.highlightedItem?.strokeWidth ?? '',
        onChange: (e)=>handleItemChange({
                strokeWidth: Number(e.target.value)
            }),
        title: "The width of the highlighted item stroke in pixels"
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Series"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: highlightOptions?.enabled ?? false,
        onChange: (enabled)=>handleBaseChange({
                enabled: enabled
            })
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-2 twa:mr-1"
    }, "Stroke Width"), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        disabled: !highlightOptions?.enabled,
        className: "twa:w-[70px]",
        type: "number",
        min: 0,
        value: highlightOptions?.highlightedSeries?.strokeWidth ?? '',
        onChange: (e)=>handleSeriesChange({
                strokeWidth: Number(e.target.value)
            }),
        title: "The stroke width when markers are hovered or tooltip is shown"
    }))));
};




var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $8cca042f7654f935$export$37acb3580601e69a = (props)=>{
    const { iconPosition: iconPosition = 'start', icon: iconProps } = props;
    const preparedBadgePosition = iconPosition.toLowerCase();
    const icon = iconProps && $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
        icon: iconProps
    });
    const style = (0, $0f8018328b88def3$export$b7b312ddf6b38c9f)(props.adaptableStyle);
    return $acw62.createElement("div", {
        className: "ab-Badge",
        style: {
            ...style,
            marginRight: props.gap
        }
    }, preparedBadgePosition === 'start' && icon, props.children, preparedBadgePosition === 'end' && icon);
};



const $a26c8e54d85dea3c$export$afb28e45b4de1784 = ({ data: data })=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const badgeStyle = data.BadgeStyle;
    if (!badgeStyle || badgeStyle.Badges.length === 0) return $acw62.createElement("div", null, "No Badges Defined");
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, badgeStyle.Badges.map((badge, index)=>{
        const badgeValue = badge.IconOnly ? '' : adaptable.api.columnApi.getColumnDataTypeForColumnId(data.ColumnId) === 'number' ? (0, $58846ea7f4156db7$export$43dc5821ce3a3e46) : (0, $58846ea7f4156db7$export$74c5c370dcf447e);
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mb-1",
            key: index
        }, $acw62.createElement((0, $8cca042f7654f935$export$37acb3580601e69a), {
            icon: badge.Icon,
            adaptableStyle: badge.Style,
            iconPosition: badge.IconPosition
        }, badgeValue));
    }));
};






var $acw62 = parcelRequire("acw62");


const $9f1baacc2a682002$export$a766cd26d0d69044 = ({ title: title, children: children })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [height, setHeight] = (0, $acw62.useState)('0px');
    const content = (0, $acw62.useRef)(null);
    const observer = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        setHeight(isOpen && content.current ? `${content.current.scrollHeight}px` : '0px');
    }, [
        isOpen,
        content
    ]);
    (0, $acw62.useEffect)(()=>{
        if (content.current) {
            observer.current = new MutationObserver(()=>{
                setHeight(`${content.current?.scrollHeight}px`);
            });
            observer.current.observe(content.current, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            observer.current?.disconnect();
        };
    }, []);
    const toggleAccordion = ()=>{
        setIsOpen(!isOpen);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: "ab-Accordion"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        iconPosition: "end",
        icon: isOpen ? 'expand-all' : 'collapse-all',
        variant: "text",
        onClick: toggleAccordion,
        style: {
            width: '100%',
            textAlign: 'left'
        }
    }, title), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: content,
        style: {
            maxHeight: `${height}`,
            overflow: 'hidden',
            transition: 'max-height 0.6s ease'
        }
    }, children));
};
var $9f1baacc2a682002$export$2e2bcd8739ae039 = $9f1baacc2a682002$export$a766cd26d0d69044;




const $fb8b7c3f32f9c27d$var$BadgeEditor = (props)=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const { badge: badge, columnId: columnId, onChange: onChange } = props;
    // badges evaluate predicate per value
    const predicateDefs = api.styledColumnApi.internalApi.getBadgePredicateDefsForColumn(columnId);
    const dataType = api.columnApi.getColumnDataTypeForColumnId(columnId);
    const previewValue = dataType === 'number' || dataType == 'numberArray' ? (0, $58846ea7f4156db7$export$43dc5821ce3a3e46) : (0, $58846ea7f4156db7$export$74c5c370dcf447e);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-Badge-Definition-Editor twa:mb-[15px] twa:p-3"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Preview"
    }, $acw62.createElement((0, $8cca042f7654f935$export$37acb3580601e69a), {
        adaptableStyle: badge.Style,
        icon: badge.Icon,
        iconPosition: badge.IconPosition
    }, previewValue)), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Style"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:text-2 twa:mb-1 twa:mt-2"
    }, "Select the Style for the Badge"), ' ', $acw62.createElement((0, $9f1baacc2a682002$export$a766cd26d0d69044), {
        title: "Edit Badge Style"
    }, $acw62.createElement((0, $e629d4699b6af5c8$export$a7668fc2e148d940), {
        showFontSizeAs: "radio",
        headless: true,
        hidePreview: true,
        api: api,
        Style: badge.Style ?? {},
        UpdateStyle: (Style)=>{
            onChange({
                ...badge,
                Style: Style
            });
        }
    }))), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: 'Predicate'
    }, columnId ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:text-2 twa:mb-1 twa:mt-2"
    }, "Create (optional) Rule for when the Badge is displayed; if no Rule provided Badge will always display (unless overriden by another Rule)"), $acw62.createElement((0, $7037612f472b3962$export$ae5262bb43652), {
        columnId: columnId,
        predicate: badge.Predicate,
        predicateDefs: predicateDefs,
        placeholder: "No Predicate Selected",
        onChange: (predicate)=>{
            onChange({
                ...badge,
                Predicate: predicate
            });
        },
        onClear: ()=>onChange({
                ...badge,
                Predicate: undefined
            })
    })) : $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), null, "Select a column first")), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Icon"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:text-2 twa:mb-1 twa:mt-2"
    }, "Select (optional) Icon (and Icon position) to display in the Badge"), ' ', // for now, only show for system icons the
    !badge.Icon || 'name' in badge.Icon ? $acw62.createElement((0, $141cb6e18289a62f$export$1d1f94b6ce72c6ac), {
        value: badge?.Icon && 'name' in badge?.Icon ? badge.Icon.name : undefined,
        onChange: (iconName)=>{
            if (iconName) onChange({
                ...badge,
                Icon: {
                    name: iconName
                }
            });
            else onChange({
                ...badge,
                Icon: undefined
            });
        }
    }) : $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
        icon: badge.Icon
    })), badge.Icon && $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Icon Position"
    }, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        columns: [
            'label'
        ],
        items: [
            {
                label: 'Start',
                onClick: ()=>onChange({
                        ...badge,
                        IconPosition: 'Start'
                    })
            },
            {
                label: 'End',
                onClick: ()=>onChange({
                        ...badge,
                        IconPosition: 'End'
                    })
            }
        ]
    }, badge.IconPosition ?? 'Start')), badge.Icon && $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Show Icon Only"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: badge.IconOnly,
        // onClick=()=> onChange({ ...badge, IconPosition: 'End' })
        onClick: ()=>onChange({
                ...badge,
                IconOnly: !badge.IconOnly
            })
    })))), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:justify-end"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        icon: "delete",
        onClick: props.onDelete
    })));
};
const $fb8b7c3f32f9c27d$export$5b772d18a0aede75 = (styledColumn)=>{
    return $acw62.createElement((0, $a26c8e54d85dea3c$export$afb28e45b4de1784), {
        data: styledColumn
    });
};
const $fb8b7c3f32f9c27d$export$27ed180393734b1 = (props)=>{
    const { data: data } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const badges = data?.BadgeStyle?.Badges ?? [];
    return $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        style: {
            height: '100%'
        }
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Badges"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:justify-end"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        icon: "plus",
        onClick: ()=>{
            props.onChange({
                ...data,
                BadgeStyle: {
                    Badges: [
                        ...badges,
                        (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateDefaultStyledColumnBadge()
                    ]
                }
            });
        }
    }, "Add Badge")), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:p-2"
    }, badges.map((badge, index)=>{
        const handleEditBadge = (badge)=>{
            const newBadges = [
                ...badges
            ];
            newBadges[index] = badge;
            props.onChange({
                ...data,
                BadgeStyle: {
                    ...data.BadgeStyle,
                    Badges: newBadges
                }
            });
        };
        return $acw62.createElement($fb8b7c3f32f9c27d$var$BadgeEditor, {
            key: index,
            badge: badge,
            columnId: data.ColumnId,
            onChange: handleEditBadge,
            onDelete: ()=>{
                const newBadges = [
                    ...badges
                ];
                newBadges.splice(index, 1);
                props.onChange({
                    ...data,
                    BadgeStyle: {
                        ...data.BadgeStyle,
                        Badges: newBadges
                    }
                });
            }
        });
    }))));
};



const $012b20aab42877ae$export$36e944ed021335dd = (props)=>{
    const data = props.data ?? props.popupParams?.value;
    const popupDefaultCurrentSectionName = props?.popupParams?.config?.defaultCurrentSectionName ?? undefined;
    const defaultCurrentSectionName = props.defaultCurrentSectionName ?? popupDefaultCurrentSectionName;
    const [styledColumn, setStyledColumn] = (0, $acw62.useState)(()=>{
        if (data) return (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(data);
        const newData = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyStyledColumn();
        newData.GradientStyle = {};
        if (props.popupParams?.column && props.popupParams?.action === 'New') {
            newData.ColumnId = props.popupParams.column.columnId;
            if (props.popupParams.column.dataType === 'text') {
                newData.BadgeStyle = {
                    Badges: [
                        (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateDefaultStyledColumnBadge()
                    ]
                };
                delete newData.GradientStyle;
            } else if (props.popupParams.column.dataType.includes('Array')) {
                newData.SparklineStyle = {};
                delete newData.GradientStyle;
            }
        }
        return newData;
    });
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleFinish = ()=>{
        if (props?.popupParams?.action === 'New' || !data) dispatch($e8ca06942ba9c0b6$export$292f31ea3d79c677(styledColumn));
        else dispatch($e8ca06942ba9c0b6$export$bb2fbe12e4c588d7(styledColumn));
        props.onFinishWizard(styledColumn);
    };
    const specificSteps = [];
    if (styledColumn.SparklineStyle) specificSteps.push({
        title: 'Settings',
        render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:p-2"
            }, $acw62.createElement((0, $d7cc9ec551ea7dec$export$9df9adc888ce29bd), {
                onChange: setStyledColumn
            }))
    });
    else if (styledColumn.GradientStyle || styledColumn.PercentBarStyle) specificSteps.push({
        details: 'Create the Style to apply',
        renderSummary: (0, $5ed0b75d515b5af3$export$3fd9ce47a190872b),
        render: ()=>{
            return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                className: "twa:p-2"
            }, $acw62.createElement((0, $5ed0b75d515b5af3$export$a858f3158c597ed6), {
                onChange: setStyledColumn
            }));
        },
        title: 'Style',
        isValid: ()=>{
            const columnComparison = styledColumn.GradientStyle?.ColumnComparison ?? styledColumn.PercentBarStyle?.ColumnComparison;
            return columnComparison ? columnComparison.MaxValue == undefined && columnComparison.MinValue == undefined ? 'Define Min and Max Values for the Column Comparison' : columnComparison.MaxValue == undefined ? 'Define a Max Value for the Column Comparison' : columnComparison.MinValue == undefined ? 'Define a Min Value for the Column Comparison' : true : true;
        }
    });
    else if (styledColumn.BadgeStyle) {
        specificSteps.push({
            details: 'Select the Rows where the Badge will be applied',
            renderSummary: (0, $090421cc4ba8fac6$export$c2396a8463c95432),
            render: ()=>{
                return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                    className: "twa:p-2"
                }, $acw62.createElement((0, $090421cc4ba8fac6$export$97cef0beab27cdc5), {
                    onChange: setStyledColumn
                }));
            },
            title: 'Rows'
        });
        specificSteps.push({
            title: 'Badges',
            details: 'Create Badge Styles',
            isValid: ()=>{
                if (styledColumn.BadgeStyle.Badges?.length === 0) return 'Define at least one Badge';
                const badgesWithNoRules = styledColumn.BadgeStyle.Badges.filter((b)=>b.Expression == undefined && b.Predicate == undefined);
                if (badgesWithNoRules.length > 1) return 'Only one Badge can have no Rule';
                return true;
            },
            renderSummary: ()=>(0, $fb8b7c3f32f9c27d$export$5b772d18a0aede75)(styledColumn),
            render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                    className: "twa:p-2"
                }, $acw62.createElement((0, $fb8b7c3f32f9c27d$export$27ed180393734b1), {
                    onChange: setStyledColumn
                }))
        });
    }
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: defaultCurrentSectionName,
        moduleInfo: props.moduleInfo,
        data: styledColumn,
        onFinish: handleFinish,
        onHide: props.onCloseWizard,
        sections: [
            {
                details: 'Select a Styled Column type',
                renderSummary: (0, $4eab9f09520a5ddf$export$a1795c53d90c3de3),
                render: ()=>{
                    return $acw62.createElement((0, $4eab9f09520a5ddf$export$619a627c3fdcfa73), {
                        onChange: setStyledColumn
                    });
                },
                title: 'Type'
            },
            {
                isValid: (0, $17ba016a4fd0f965$export$ad06fd9c49d39ed8),
                renderSummary: (0, $17ba016a4fd0f965$export$14ce0fd1837d790e),
                details: 'Select the Column where the Style will be applied',
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2 twa:h-full"
                    }, $acw62.createElement((0, $17ba016a4fd0f965$export$9abc1bf7ad0d7f59), {
                        isNew: props.isNew,
                        onChange: setStyledColumn
                    }));
                },
                title: 'Column'
            },
            ...specificSteps,
            {
                details: 'Select Format Column Tags',
                title: 'Tags',
                isVisible: (_, api)=>api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setStyledColumn
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                title: 'Summary',
                details: 'Review your Styled Column',
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null));
                }
            }
        ]
    });
};







var $acw62 = parcelRequire("acw62");



const $077e42e7d6b77609$export$814264a9fab5b038 = ({ data: data })=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const badgeStyle = data.BadgeStyle;
    if (!badgeStyle || badgeStyle.Badges.length === 0) return $acw62.createElement("div", null, "No Badges Defined");
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, badgeStyle.Badges.map((badge, index)=>{
        let ruleString = 'No Rule';
        if (badge.Predicate) ruleString = adaptable.api.predicateApi.predicateToString(badge.Predicate);
        if (badge.Expression) ruleString = badge.Expression.BooleanExpression;
        const iconOnly = badge.Icon && badge.IconOnly;
        const hasIconPosition = badge.Icon && badge.IconPosition;
        const iconPosition = hasIconPosition ? 'Icon Position: ' + badge.IconPosition : '';
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:my-2",
            key: index
        }, $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, ruleString), iconOnly && $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
            className: "twa:ml-2"
        }, 'Icon Only'), hasIconPosition && $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), {
            className: "twa:ml-2"
        }, iconPosition));
    }));
};


class $75d3e1639e04c6e4$export$a737e359cf86c265 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$7d380408a8ffe7db, $42e863194fcb493f$export$c8dc099205b274b7, 'brush', 'StyledColumnPopup', 'Create a Special Column Style e.g Gradient, Percent Bar or Badge', api);
    }
    getModuleAdaptableObjects(config) {
        return this.api.styledColumnApi.getStyledColumns(config);
    }
    getExplicitlyReferencedColumnIds(styledColumn) {
        return [
            styledColumn.ColumnId
        ];
    }
    hasNamedQueryReferences() {
        return false;
    }
    createColumnMenuItems(column) {
        let returnColumnMenuItems = [];
        // Need a Column and an editable Module
        if (column && this.isModuleEditable() && !column.isTreeColumn) {
            let styledColumn = this.api.styledColumnApi.getStyledColumnForColumnId(column.columnId);
            // First look at Sparkline Columns - needs to be editable array type
            if (this.api.columnApi.hasNumericArrayDataType(column.columnId) && column.IsReadOnly !== true && this.api.styledColumnApi.canDisplaySparklines()) {
                let sparklineColumnExists = column.isSparkline && Boolean(styledColumn);
                if (column.isSparkline && !sparklineColumnExists) ;
                else {
                    const hasSparklineStyle = styledColumn != null && styledColumn.SparklineStyle != null;
                    if (!hasSparklineStyle) styledColumn = {
                        ...(0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyStyledColumn(),
                        ColumnId: column.columnId,
                        SparklineStyle: {}
                    };
                    let label = hasSparklineStyle ? 'Edit ' : 'Create ';
                    let name = hasSparklineStyle ? 'styled-column-sparkline-edit' : 'styled-column-sparkline-add';
                    let popupParam = {
                        action: hasSparklineStyle ? 'Edit' : 'New',
                        source: 'ColumnMenu',
                        value: styledColumn,
                        config: {
                            defaultCurrentSectionName: 'Settings'
                        }
                    };
                    returnColumnMenuItems.push(this.createMenuItemShowPopup(name, label + 'Sparkline Column', this.moduleInfo.Popup, this.getGlyphForStyledColumn(styledColumn), popupParam));
                }
            } else if (!column.isSparkline) {
                // Edit is common
                if (styledColumn) {
                    if (!styledColumn.IsReadOnly) {
                        let defaultCurrentSectionName = undefined;
                        if (styledColumn.BadgeStyle) defaultCurrentSectionName = 'Badges';
                        else defaultCurrentSectionName = 'Style';
                        const popupParam = {
                            action: 'Edit',
                            source: 'ColumnMenu',
                            value: styledColumn,
                            config: {
                                defaultCurrentSectionName: defaultCurrentSectionName
                            }
                        };
                        const icon = this.getGlyphForStyledColumn(styledColumn);
                        const typeLabel = this.getTypeLabel(styledColumn);
                        const label = `Edit ${typeLabel}`;
                        const name = this.getTypeName(styledColumn);
                        returnColumnMenuItems.push(this.createMenuItemShowPopup(name, label, this.moduleInfo.Popup, icon, popupParam));
                    }
                } else {
                    const newStyledColumn = {
                        ...(0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyStyledColumn(),
                        ColumnId: column.columnId
                    };
                    const popupParam = {
                        action: 'New',
                        source: 'ColumnMenu',
                        value: newStyledColumn,
                        config: {}
                    };
                    const badgeLabel = 'Create Badge Style';
                    const newBadgeButton = this.createMenuItemShowPopup('styled-column-badge-add', badgeLabel, this.moduleInfo.Popup, 'badge', {
                        ...popupParam,
                        value: {
                            ...newStyledColumn,
                            BadgeStyle: {
                                Badges: [
                                    (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateDefaultStyledColumnBadge()
                                ]
                            }
                        },
                        config: {
                            defaultCurrentSectionName: 'Badges'
                        }
                    });
                    switch(column.dataType){
                        // Number
                        // Create Styled Column - Gradient | Percent Bar | Badge
                        case 'number':
                            const emptyRanges = this.api.columnScopeApi.createCellColorRangesForScope({
                                ColumnIds: [
                                    column.columnId
                                ]
                            });
                            const newGrandientButton = this.createMenuItemShowPopup('styled-column-gradient-add', 'Create Gradient Column', this.moduleInfo.Popup, 'gradient', {
                                ...popupParam,
                                value: {
                                    ...newStyledColumn,
                                    GradientStyle: {
                                        CellRanges: emptyRanges
                                    }
                                },
                                config: {
                                    defaultCurrentSectionName: 'Style'
                                }
                            });
                            const newPercentBarButton = this.createMenuItemShowPopup('styled-column-percent-bar-add', 'Create Percent Bar', this.moduleInfo.Popup, 'percent', {
                                ...popupParam,
                                value: {
                                    ...newStyledColumn,
                                    PercentBarStyle: {
                                        CellRanges: emptyRanges
                                    }
                                },
                                config: {
                                    defaultCurrentSectionName: 'Style'
                                }
                            });
                            returnColumnMenuItems.push(...[
                                newGrandientButton,
                                newPercentBarButton,
                                newBadgeButton
                            ]);
                            break;
                        case 'text':
                        case 'textArray':
                        case 'numberArray':
                            returnColumnMenuItems.push(newBadgeButton);
                            break;
                    }
                }
            }
        }
        return returnColumnMenuItems;
    }
    getGlyphForStyledColumn(styledColumn) {
        if (styledColumn.GradientStyle) return 'gradient';
        else if (styledColumn.PercentBarStyle) return 'percent';
        else if (styledColumn.SparklineStyle) return 'spark-line';
        else if (styledColumn.BadgeStyle) return 'badge';
        return this.moduleInfo.Glyph;
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.styledColumnApi.getStyledColumns(),
            AddAction: $e8ca06942ba9c0b6$export$292f31ea3d79c677,
            EditAction: $e8ca06942ba9c0b6$export$bb2fbe12e4c588d7
        };
    }
    toView(styledColumn) {
        const specificTypeItems = [];
        if (styledColumn.GradientStyle || styledColumn.PercentBarStyle) specificTypeItems.push({
            name: 'Style',
            view: ()=>{
                return (0, $5ed0b75d515b5af3$export$3fd9ce47a190872b)(styledColumn, this.api);
            }
        });
        if (styledColumn.BadgeStyle) {
            let rowTypes = [];
            if (!styledColumn.BadgeStyle?.RowScope?.ExcludeDataRows) rowTypes.push('Data');
            if (!styledColumn.BadgeStyle?.RowScope?.ExcludeGroupRows) rowTypes.push('Group');
            if (!styledColumn.BadgeStyle?.RowScope?.ExcludeSummaryRows) rowTypes.push('Summary');
            if (!styledColumn.BadgeStyle?.RowScope?.ExcludeTotalRows) rowTypes.push('Total');
            specificTypeItems.push({
                name: 'Rows',
                values: rowTypes
            });
        }
        if (styledColumn.BadgeStyle) {
            specificTypeItems.push({
                name: 'Settings',
                view: (0, $077e42e7d6b77609$export$814264a9fab5b038)
            });
            specificTypeItems.push({
                name: 'Preview',
                view: (0, $a26c8e54d85dea3c$export$afb28e45b4de1784)
            });
        }
        return {
            abObject: styledColumn,
            items: [
                {
                    name: 'Type',
                    values: [
                        this.getTypeLabel(styledColumn)
                    ]
                },
                {
                    name: 'Column',
                    values: [
                        this.api.columnApi.getFriendlyNameForColumnId(styledColumn.ColumnId)
                    ]
                },
                ...specificTypeItems,
                ,
                (0, $52125728d99aa873$export$287b3702a135396b)(styledColumn, this.api)
            ].filter(Boolean)
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects({
            includeLayoutNotExtendedObjects: this.showLayoutNonExtendedObjects()
        }).map((styledColumn)=>this.toView(styledColumn));
    }
    getViewProperties() {
        return {
            getEditAction: $e8ca06942ba9c0b6$export$bb2fbe12e4c588d7,
            getDeleteAction: $e8ca06942ba9c0b6$export$3dfcc5faf1946cbb,
            getSuspendAction: $e8ca06942ba9c0b6$export$2c1b6bb508b3a62c,
            getUnSuspendAction: $e8ca06942ba9c0b6$export$a2ae8bf0128483d5,
            getSuspendAllAction: $e8ca06942ba9c0b6$export$7b6ed1b680677da9,
            getUnSuspendAllAction: $e8ca06942ba9c0b6$export$b6435374e77e122f,
            getEditWizard () {
                return 0, $012b20aab42877ae$export$36e944ed021335dd;
            }
        };
    }
    containsLayoutExtensions() {
        return true;
    }
    getTypeLabel(styledColumn) {
        let type = null;
        if (styledColumn.GradientStyle) type = 'Gradient Column';
        else if (styledColumn.PercentBarStyle) type = 'Percent Bar';
        else if (styledColumn.SparklineStyle) type = 'Spark Line';
        else if (styledColumn.BadgeStyle) type = 'Badge Style';
        return type;
    }
    getTypeName(styledColumn) {
        let type = null;
        if (styledColumn.GradientStyle) type = 'styled-column-gradient-edit';
        else if (styledColumn.PercentBarStyle) type = 'styled-column-percent-bar-edit';
        else if (styledColumn.SparklineStyle) type = 'styled-column-sparkline-edit';
        else if (styledColumn.BadgeStyle) type = 'styled-column-badge-edit';
        return type;
    }
}




class $ba7513b9a5b9695a$export$588a7a1511cdbc26 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$2cb53cfc1e4dddff, $42e863194fcb493f$export$3a62051e066152dc, 'fdc3', null, 'The FDC3 Module - handles the FDC3 integration', api);
    }
    createContextMenuItems(menuContext) {
        if (!this.isModuleVisible()) return;
        if (menuContext.adaptableColumn && menuContext.rowNode) {
            const currentColumnId = menuContext.adaptableColumn.columnId;
            const currentRowNode = menuContext.rowNode;
            const contextMenuItems = [];
            this.getFdc3Api().internalApi.getAllRaiseIntentConfigs().filter((raiseIntentConfig)=>raiseIntentConfig.contextMenu?.columnIds.includes(currentColumnId)).forEach((raiseIntentConfig)=>{
                contextMenuItems.push(this.buildRaiseIntentMenuItem(raiseIntentConfig, currentRowNode));
            });
            this.getFdc3Api().internalApi.getAllBroadcastContextConfigs().filter((broadcastConfig)=>broadcastConfig.contextMenu?.columnIds.includes(currentColumnId)).forEach((broadcastConfig)=>{
                contextMenuItems.push(this.buildBroadcastMenuItem(broadcastConfig, currentRowNode));
            });
            contextMenuItems.sort((a, b)=>a.label.localeCompare(b.label));
            return contextMenuItems;
        }
    }
    buildRaiseIntentMenuItem(intentConfig, rowNode) {
        const { intentType: intentType, contextType: contextType } = intentConfig;
        const menuItem = {
            name: 'fdc3-raise-intent',
            label: `Raise ${intentType}`,
            onClick: ()=>{
                this.getFdc3Api().raiseIntentFromRow(rowNode, intentType, contextType);
            },
            isVisible: true,
            category: this.moduleInfo.ModuleName
        };
        if (intentConfig.contextMenu?.icon) {
            const menuItemIcon = intentConfig.contextMenu?.icon === '_defaultFdc3' ? this.getFdc3Api().internalApi.getDefaultIconForIntent(intentType) : intentConfig.contextMenu?.icon;
            menuItem.icon = menuItemIcon;
        }
        return menuItem;
    }
    buildBroadcastMenuItem(contextConfig, rowNode) {
        const { contextType: contextType } = contextConfig;
        const menuItem = {
            name: 'fdc3-broadcast',
            label: `Broadcast ${this.getFdc3Api().getContextLabel(contextType)}`,
            onClick: ()=>{
                this.getFdc3Api().broadcastFromRow(rowNode, contextType);
            },
            isVisible: true,
            category: this.moduleInfo.ModuleName
        };
        if (contextConfig.contextMenu?.icon) {
            const menuItemIcon = contextConfig.contextMenu?.icon === '_defaultFdc3' ? this.getFdc3Api().internalApi.getDefaultIconForContext(contextType) : contextConfig.contextMenu?.icon;
            menuItem.icon = menuItemIcon;
        }
        return menuItem;
    }
    getFdc3Api() {
        return this.api.fdc3Api;
    }
}





var $acw62 = parcelRequire("acw62");


const $1353e799e84934a4$export$a5cfdda37ab1369f = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const handleClick = $acw62.useCallback((event)=>{
        event.stopPropagation();
        adaptable.api.filterApi.gridFilterApi.openUIEditorForGridFilter();
    }, []);
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        variant: "text",
        iconSize: 15,
        onClick: handleClick,
        icon: "edit"
    });
};



var $acw62 = parcelRequire("acw62");

const $7b9e8acac57a3581$export$e8cda29451868ee8 = (props)=>{
    const queryMaxLength = 15;
    const currentLayoutName = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Layout.CurrentLayout);
    const currentLayout = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Layout.Layouts).find((layout)=>layout.Name === currentLayoutName);
    const query = currentLayout?.GridFilter?.Expression ?? '';
    let text = query;
    let popover = null;
    if (query.length > queryMaxLength) {
        text = query.substring(0, queryMaxLength - 3) + '...';
        popover = query;
    }
    return $acw62.createElement($acw62.Fragment, null, text ?? 'No Query');
};


class $b87b6abba9b4f74d$export$5aa43b9b4ba284c3 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$4908330cb20abb96, $42e863194fcb493f$export$e3b58083525a6d40, 'filter-list', 'GridFilterPopup', 'Controls the Grid Filter funtionality', api);
    }
    setModuleEntitlement() {
        if (!this.api.optionsApi.getFilterOptions().useAdaptableFiltering) this.AccessLevel = 'Hidden';
        else this.AccessLevel = this.api.entitlementApi.getEntitlementAccessLevelForModule(this.moduleInfo.ModuleName);
    }
    getModuleAdaptableObjects() {
        const currentGridFilter = this.api.filterApi.gridFilterApi.getCurrentGridFilter();
        return currentGridFilter ? [
            currentGridFilter
        ] : [];
    }
    getViewProperties() {
        return {
            getStatusBarPanelProps: ()=>{
                const popover = this.api.filterApi.gridFilterApi.getCurrentGridFilterExpression();
                return {
                    content: (0, $7b9e8acac57a3581$export$e8cda29451868ee8),
                    extraActions: [
                        (0, $1353e799e84934a4$export$a5cfdda37ab1369f)
                    ],
                    popover: popover
                };
            }
        };
    }
}







var $acw62 = parcelRequire("acw62");

// TODO: move to named query

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $7c2d515f10fcbc57$var$WizardPanel = (props)=>{
    return $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        bodyScroll: true,
        bodyProps: props.bodyProps,
        "data-name": props['data-name'],
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('ab-WizardPanel', 'twa:border-none twa:rounded-none twa:h-full', props.className)
    }, props.children);
};
var $7c2d515f10fcbc57$export$2e2bcd8739ae039 = $7c2d515f10fcbc57$var$WizardPanel;








const $ce2d95824efec7c9$export$55c836322c6eb4bd = (data, api)=>{
    const validationResult = api.namedQueryApi.isValidNamedQuery(data);
    const ErrorMessage = !validationResult.valid ? validationResult.message : null;
    if (!ErrorMessage) return true;
    return ErrorMessage;
};
const $ce2d95824efec7c9$export$5ebe8c453527c380 = (data)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, "Name: ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, data.Name));
};
const $ce2d95824efec7c9$export$583bd23023c057d0 = (props)=>{
    const { data: data, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const valid = $ce2d95824efec7c9$export$55c836322c6eb4bd(data, api);
    const errorMessage = valid === true ? null : valid;
    const handleColumnNameChange = (event)=>{
        let e = event.target;
        props.onChange({
            ...data,
            Name: e.value
        });
    };
    return $acw62.createElement((0, $7c2d515f10fcbc57$export$2e2bcd8739ae039), {
        "data-name": 'named-query-settings'
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Name"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        "data-name": "query-name",
        value: data.Name,
        autoFocus: true,
        className: "twa:w-[300px]",
        type: "text",
        placeholder: "Enter Named Query Name",
        onChange: (e)=>handleColumnNameChange(e)
    })), ' ', errorMessage ? $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), null, errorMessage)) : null));
};




var $acw62 = parcelRequire("acw62");





const $80d86517a07b1658$export$2adbc7b42c30066c = (data, api)=>{
    if (!data.BooleanExpression) return 'An expression is required.';
    const valid = api.expressionApi.isValidBooleanExpression(data.BooleanExpression, (0, $42e863194fcb493f$export$97c45942f844607e));
    if (!valid) return 'The query is not a valid Boolean expression.';
    return valid;
};
const $80d86517a07b1658$export$a81efc3594f9100c = (data)=>{
    const { api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, "Expression: ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, api.internalApi.getAdaptableQueryExpressionText(data)));
};
const $80d86517a07b1658$export$6bff251c53fa58a1 = (props)=>{
    const { data: data, moduleInfo: moduleInfo, api: api } = (0, $e70b2e3a7d03e2cc$export$9db311725c0ce90e)();
    const initialData = (0, $acw62.useMemo)(()=>api.internalApi.getQueryPreviewData(), []);
    return $acw62.createElement((0, $5e4c4ab15f4fe7da$export$6f88ab97c822f23a), {
        allowSaveNamedQuery: false,
        showQueryBuilder: true,
        type: 'boolean',
        module: moduleInfo.ModuleName,
        value: data.BooleanExpression,
        onChange: (BooleanExpression)=>{
            props.onChange({
                ...data,
                BooleanExpression: BooleanExpression
            });
        },
        initialData: initialData,
        columns: api.columnApi.internalApi.getQueryableColumnsForUIEditor(),
        fields: api.expressionApi.internalApi.getAvailableFields(),
        namedQueries: api.namedQueryApi.getNamedQueries(),
        api: api
    });
};







function $17249a98ea03e2bc$export$a9059b054daa324a(props) {
    const [namedQuery, setNamedQuery] = (0, $acw62.useState)(()=>{
        const value = props.popupParams?.value ?? '';
        return props.data ? (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(props.data) : (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyNamedQuery(value);
    });
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleFinish = ()=>{
        if (props.data) dispatch($f53463061a55e5a9$export$f5c14b4ee8c8e36c(namedQuery));
        else dispatch($f53463061a55e5a9$export$35d9816f002a20ec(namedQuery));
        props.onFinishWizard(namedQuery);
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        defaultCurrentSectionName: props.defaultCurrentSectionName,
        onFinish: handleFinish,
        sections: [
            {
                title: 'Expression',
                details: "Build the Named Query's Expression",
                renderSummary: (0, $80d86517a07b1658$export$a81efc3594f9100c),
                isValid: (0, $80d86517a07b1658$export$2adbc7b42c30066c),
                render: ()=>$acw62.createElement((0, $80d86517a07b1658$export$6bff251c53fa58a1), {
                        onChange: setNamedQuery
                    })
            },
            {
                title: 'Query Name',
                details: 'Specify a unique Name for the Named Query',
                renderSummary: (0, $ce2d95824efec7c9$export$5ebe8c453527c380),
                isValid: (0, $ce2d95824efec7c9$export$55c836322c6eb4bd),
                render: ()=>{
                    return $acw62.createElement((0, $ce2d95824efec7c9$export$583bd23023c057d0), {
                        onChange: setNamedQuery
                    });
                }
            },
            {
                details: 'Select Named Query Tags',
                title: 'Tags',
                isVisible: (_, api)=>api.internalApi.shouldDisplayTagSections(),
                render: ()=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $5e20d7539683bc9c$export$6c0fa642a4126977), {
                        onChange: setNamedQuery
                    })),
                renderSummary: (0, $5e20d7539683bc9c$export$d2800d0dd3b55574)
            },
            '-',
            {
                title: 'Summary',
                details: 'Review your Named Query',
                render: ()=>{
                    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                        className: "twa:p-2"
                    }, $acw62.createElement((0, $e70b2e3a7d03e2cc$export$50a34d6e6d05db65), null));
                }
            }
        ],
        onHide: props.onCloseWizard,
        moduleInfo: props.moduleInfo,
        data: namedQuery
    });
}



class $72b8202d702ec972$export$67db688dcb64f441 extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$97c45942f844607e, $42e863194fcb493f$export$4857fd59919baf59, 'grid-filter', 'NamedQueryPopup', 'Creates Named Queries', api);
    }
    getModuleAdaptableObjects() {
        return this.api.namedQueryApi.getNamedQueries();
    }
    getTeamSharingAction() {
        return {
            ModuleEntities: this.api.namedQueryApi.getNamedQueries(),
            AddAction: $f53463061a55e5a9$export$35d9816f002a20ec,
            EditAction: $f53463061a55e5a9$export$f5c14b4ee8c8e36c
        };
    }
    getExplicitlyReferencedColumnIds(namedQuery) {
        return this.api.expressionApi.getColumnsFromExpression(namedQuery.BooleanExpression);
    }
    getReferencedNamedQueryNames(namedQuery) {
        return this.api.namedQueryApi.internalApi.getReferencedNamedQueryNames(namedQuery.BooleanExpression);
    }
    toView(query) {
        return {
            abObject: query,
            items: [
                {
                    name: 'Query Name',
                    values: [
                        query.Name
                    ]
                },
                {
                    name: 'Expression',
                    values: [
                        this.api.internalApi.getAdaptableQueryExpressionText(query)
                    ]
                },
                (0, $52125728d99aa873$export$287b3702a135396b)(query, this.api)
            ]
        };
    }
    toViewAll() {
        return this.getModuleAdaptableObjects().map((query)=>this.toView(query));
    }
    getViewProperties() {
        return {
            getDeleteAction: $f53463061a55e5a9$export$7c08b0322e8d8cbb,
            newTooltipText: 'Create New Named Query',
            emptyView: "Click 'New' to create a Named Query that can be referenced in other Expressions",
            getEditWizard: ()=>(0, $17249a98ea03e2bc$export$a9059b054daa324a),
            getStatusBarPanelProps: ()=>{
                const queryMaxLength = 15;
                const query = this.api.filterApi.gridFilterApi.getCurrentGridFilterExpression();
                let text = query;
                let popover = null;
                if (query.length > queryMaxLength) {
                    text = query.substring(0, queryMaxLength - 3) + '...';
                    popover = query;
                }
                return {
                    content: text || 'No Query',
                    extraActions: [
                        (0, $1353e799e84934a4$export$a5cfdda37ab1369f)
                    ],
                    popover: popover
                };
            }
        };
    }
}




class $7ecee0e3afb2d5ab$export$35701fbb80ff093c extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    constructor(api){
        super($42e863194fcb493f$export$8d2ece562190bba1, $42e863194fcb493f$export$397530e166563a3b, 'comments', 'CommentsPopup', 'comments', api);
    }
    onAdaptableReady() {
        this.loadComments();
    }
    isModuleEnabled() {
        const options = this.api.optionsApi.getCommentOptions();
        if (!options || !options.persistCommentThreads || !options.loadCommentThreads) return false;
        if (this.api.optionsApi.isAutogeneratePrimaryKey()) return false;
        return super.isModuleEnabled();
    }
    async loadComments() {
        const commentThreads = await this.api.optionsApi.getCommentOptions()?.loadCommentThreads?.(this.api.internalApi.buildBaseContext());
        this.api.commentApi.setComments(commentThreads);
    }
    createContextMenuItems(menuContext) {
        if (!this.isModuleVisible()) return;
        if (!this.api.commentApi.internalApi.areCommentsSupportedInLayout()) return;
        if (menuContext.isRowGroupColumn || menuContext.isGroupedNode || !menuContext.isSingleSelectedCell) return;
        const items = [];
        const isCellCommentable = typeof this.api.optionsApi?.getCommentOptions()?.isCellCommentable === 'function' ? this.api.optionsApi?.getCommentOptions()?.isCellCommentable({
            gridCell: menuContext.gridCell,
            ...this.api.internalApi.buildBaseContext()
        }) : true;
        if (!isCellCommentable) return;
        const cellAddress = {
            PrimaryKeyValue: menuContext.primaryKeyValue,
            ColumnId: menuContext.adaptableColumn.columnId
        };
        const cellComments = this.api.commentApi.getCommentThreadForCell(cellAddress)?.Comments;
        if (cellComments) return [
            this.createMenuItemClickFunction('comment-remove', 'Remove Comment', this.moduleInfo.Glyph, ()=>{
                this.api.commentApi.deleteCommentThread(cellAddress);
            })
        ];
        else return [
            this.createMenuItemClickFunction('comment-add', 'Add Comment', this.moduleInfo.Glyph, ()=>{
                // add an empty one
                this.api.commentApi.addCommentThread({
                    ...cellAddress,
                    Comments: []
                });
                requestAnimationFrame(()=>{
                    this.api.internalApi.getAnnotationsService().showPopup({
                        PrimaryKeyValue: menuContext.primaryKeyValue,
                        ColumnId: menuContext.adaptableColumn.columnId
                    }, true);
                    this.api.internalApi.getAnnotationsService().editFocusedEntity('Comment');
                });
            })
        ];
    }
}





var $5aWMQ = parcelRequire("5aWMQ");

var $acw62 = parcelRequire("acw62");




var $9g4SS = parcelRequire("9g4SS");






var $acw62 = parcelRequire("acw62");

class $a351badd06d496fe$export$dc1762fe2fbc8a24 extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "configure",
            tooltip: "Configure",
            iconSize: 18,
            icon: "spanner",
            ...this.props,
            variant: "text"
        });
    }
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




var $hrtGQ = parcelRequire("hrtGQ");




var $acw62 = parcelRequire("acw62");




var $5aWMQ = parcelRequire("5aWMQ");

const $dab8d46725028be5$var$columnsMap = {
    InitialValue: {
        field: 'InitialValue',
        defaultFlex: 1,
        header: 'Current',
        align: 'center',
        renderMenuIcon: false
    },
    ComputedValue: {
        field: 'ComputedValue',
        defaultFlex: 1,
        header: 'New',
        align: 'center',
        renderMenuIcon: false
    },
    ValidInfo: {
        field: 'ValidInfo',
        defaultWidth: 80,
        header: 'Valid',
        align: 'center',
        renderMenuIcon: false
    }
};
const $dab8d46725028be5$var$ROW_HEIGHT = 35;
const $dab8d46725028be5$var$HEADER_HEIGHT = 30;
class $dab8d46725028be5$export$5a0a2ad814f1ffcd extends $acw62.Component {
    render() {
        let previewHeader = this.props.showHeader && this.props.previewInfo != null ? 'Preview Results: ' + (this.props.selectedColumn ? this.props.selectedColumn.friendlyName : '') : '';
        let successColor = (0, $5aWMQ.default).getColorByMessageType('Success');
        const dataSource = this.props.previewInfo.previewResults.map((previewResult, index)=>{
            return {
                Id: index,
                InitialValue: previewResult.initialValue,
                ComputedValue: previewResult.computedValue,
                ValidInfo: previewResult.validationRules.length > 0 ? $acw62.createElement($acw62.Fragment, null, this.props.previewInfo.previewValidationSummary.validationResult != 'None' && $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
                    showEvent: "mouseenter",
                    hideEvent: "mouseleave",
                    headerText: 'Validation Error',
                    bodyText: [
                        this.getValidationErrorMessage(previewResult.validationRules)
                    ],
                    MessageType: 'Error'
                })) : $acw62.createElement($acw62.Fragment, null, ' ', $acw62.createElement((0, $b609955ddc27feb5$export$2e2bcd8739ae039), {
                    style: {
                        color: successColor,
                        fill: 'currentColor'
                    }
                }))
            };
        });
        const tableHeight = $dab8d46725028be5$var$HEADER_HEIGHT + dataSource.length * $dab8d46725028be5$var$ROW_HEIGHT;
        const tableDOMProps = {
            style: {
                height: tableHeight,
                maxWidth: 500
            }
        };
        return this.props.showPanel ? $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), {
            className: "twa:overflow-hidden",
            style: {
                maxWidth: 500
            },
            shadow: false
        }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, null, previewHeader), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, null, $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
            data: dataSource,
            primaryKey: "Id"
        }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
            sortable: false,
            domProps: tableDOMProps,
            columns: $dab8d46725028be5$var$columnsMap
        })))) : null;
    }
    getValidationErrorMessage(alertDefinitions) {
        let validationService = this.props.api.internalApi.getValidationService();
        let returnString = [];
        for (let alertDefinition of alertDefinitions){
            let expressionDescription = alertDefinition.Rule.BooleanExpression ? ' when ' + alertDefinition.Rule.BooleanExpression : '';
            returnString.push(validationService.createValidationDescription(alertDefinition) + expressionDescription);
        }
        return returnString.join('\n');
    }
}




var $9OAZF = parcelRequire("9OAZF");




const $7f9b56417e888f6c$var$preventDefault = (e)=>e.preventDefault();
class $7f9b56417e888f6c$var$SmartEditPopupComponent extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            isShowingError: false,
            errorText: ''
        };
    }
    componentDidMount() {
        this.props.onSmartEditCheckSelectedCells();
    }
    render() {
        let col;
        if (this.props.PreviewInfo) col = this.props.PreviewInfo.column;
        let globalValidationMessage = (0, $ffbf29d095efdf81$export$69a3593e4bb2f3c1).GetValidationMessage(this.props.PreviewInfo, `${this.props.SmartEditValue}`);
        let showPanel = this.props.PreviewInfo && (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(`${this.props.SmartEditValue}`);
        let previewPanel = showPanel ? $acw62.createElement((0, $dab8d46725028be5$export$5a0a2ad814f1ffcd), {
            className: "twa:flex-[1_1_100%] twa:overflow-initial twa:h-full",
            previewInfo: this.props.PreviewInfo,
            api: this.props.api,
            selectedColumn: col,
            showPanel: showPanel,
            showHeader: true
        }) : null;
        const operationMenuItems = (0, $3ca1f4c2b77d4ce9$export$51594d8e7854ff7d).getNames((0, $hrtGQ.MathOperation)).map((mathOperation, index)=>{
            return {
                label: mathOperation,
                onClick: ()=>{
                    this.props.onSmartEditOperationChange(mathOperation);
                }
            };
        });
        const customOperations = this.props.api.smartEditApi.getSmartEditCustomOperations();
        if (customOperations?.length) operationMenuItems.push(...customOperations.map((operation)=>{
            return {
                onClick: ()=>this.props.onSmartEditOperationChange(operation),
                label: operation.name
            };
        }));
        return $acw62.createElement((0, $283cf61293364231$export$226a98817755c0cc), {
            className: "twa:h-full twa:flex-1 twa:p-0!",
            variant: "primary",
            bodyProps: {
                className: 'twa:flex twa:flex-col'
            },
            bodyScroll: true,
            glyphicon: this.props.moduleInfo.Glyph,
            header: this.props.moduleInfo.FriendlyName,
            infoLink: this.props.moduleInfo.HelpPage,
            infoLinkDisabled: !this.props.api.internalApi.isDocumentationLinksDisplayed(),
            onKeyDown: (e)=>{
                if (e.key === 'Enter') this.submit();
            }
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "row",
            "data-name": "smart-edit-operation",
            className: "twa:p-2"
        }, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
            "data-name": "smart-edit-operation-dropdown",
            items: operationMenuItems,
            columns: [
                'label'
            ],
            onMouseDown: $7f9b56417e888f6c$var$preventDefault
        }, typeof this.props.SmartEditOperation === 'object' ? this.props.SmartEditOperation.name : this.props.SmartEditOperation), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
            "data-name": "smart-edit-value",
            value: this.props.SmartEditValue.toString(),
            className: "twa:mx-2",
            type: "number",
            placeholder: "Enter a Number",
            onChange: (e)=>this.onSmartEditValueChange(e)
        }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "smart-edit-apply-button",
            className: "twa:mr-2",
            tone: this.getButtonStyle(),
            variant: "raised",
            disabled: (0, $9OAZF.StringExtensions).IsNullOrEmpty(`${this.props.SmartEditValue}`) || this.props.PreviewInfo && this.props.PreviewInfo.previewValidationSummary.validationResult == 'All',
            onClick: ()=>{
                this.submit();
            }
        }, "Apply Smart Edit"), ' ', this.props.PreviewInfo && this.props.PreviewInfo.previewValidationSummary.validationResult != 'None' && $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
            headerText: 'Validation Error',
            bodyText: [
                globalValidationMessage
            ],
            MessageType: 'Error'
        })), previewPanel);
    }
    submit() {
        this.props.onApplySmartEdit();
    }
    onSmartEditValueChange(event) {
        const e = event.target;
        this.props.onSmartEditValueChange(Number(e.value));
    }
    getButtonStyle() {
        if (this.props.PreviewInfo) {
            if (this.props.PreviewInfo.previewValidationSummary.validationResult == 'All') return 'neutral';
            if (this.props.PreviewInfo.previewValidationSummary.validationResult == 'Some') return 'error';
        }
        return 'success';
    }
}
function $7f9b56417e888f6c$var$mapStateToProps(state, ownProps) {
    return {
        SmartEditValue: state.Internal.SmartEdit.SmartEditValue,
        SmartEditOperation: state.Internal.SmartEdit.SmartEditOperation,
        PreviewInfo: state.Internal.SmartEdit.SmartEditPreviewInfo
    };
}
function $7f9b56417e888f6c$var$mapDispatchToProps(dispatch) {
    return {
        onSmartEditValueChange: (value)=>dispatch($5b564bb703f29152$export$c279917007950b1(value)),
        onSmartEditOperationChange: (SmartEditOperation)=>dispatch($5b564bb703f29152$export$bfdacd6a132082c7(SmartEditOperation)),
        onSmartEditCheckSelectedCells: ()=>dispatch($5b564bb703f29152$export$bd269cd9b387ea7f()),
        onApplySmartEdit: ()=>dispatch($eeed7eb8174868ba$export$686758e9d668ae5c(false))
    };
}
const $7f9b56417e888f6c$export$4bc2a72351437dba = (0, $55388fc2f116d4d7$export$64605811ab45167f)($7f9b56417e888f6c$var$mapStateToProps, $7f9b56417e888f6c$var$mapDispatchToProps)($7f9b56417e888f6c$var$SmartEditPopupComponent);



var $acw62 = parcelRequire("acw62");







var $9OAZF = parcelRequire("9OAZF");




const $3994c9f0d97346a3$var$QuickSearchPopupComponent = (props)=>{
    const [searchText, search] = (0, $d915c8074de8927b$export$e55c23b452e4455d)(props);
    const [state, setState] = (0, $acw62.useState)({
        RunQueryAfterQuickSearch: props.api.optionsApi.getQuickSearchOptions().filterGridAfterQuickSearch,
        EditedStyle: props.QuickSearchStyle
    });
    const onUpdateStyle = (style)=>{
        setState({
            ...state,
            EditedStyle: style
        });
        props.onSetMatchingCellStyle(style);
    };
    const onQuickSearchBehaviourChange = (checked)=>{
        setState({
            ...state,
            RunQueryAfterQuickSearch: checked
        });
        props.api.optionsApi.getAdaptableOptions().quickSearchOptions.filterGridAfterQuickSearch = checked;
    };
    return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
        headerText: props.moduleInfo.FriendlyName,
        glyphicon: props.moduleInfo.Glyph,
        infoLink: props.moduleInfo.HelpPage,
        infoLinkDisabled: !props.api.internalApi.isDocumentationLinksDisplayed(),
        bodyClassName: "twa:gap-3 twa:flex twa:flex-col"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:h-full twa:gap-4"
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), null, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, null, "Search Text"), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, {
        className: "twa:p-1 twa:w-fit"
    }, $acw62.createElement((0, $24eb18c810e68a5c$export$29e8bfda34c26ba7), null))), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), null, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, null, "Behaviour"), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, {
        className: "twa:p-1",
        gap: 2
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:text-2 twa:w-fit"
    }, "Filter Grid when searching to only show rows with matching cells; ", $acw62.createElement("b", null, "use with care"), " as can cause performance issues"), $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        "data-name": "filter-quick-search-results",
        value: "existing",
        checked: state.RunQueryAfterQuickSearch,
        disabled: (0, $9OAZF.default).IsNotNullOrEmpty(searchText),
        onChange: onQuickSearchBehaviourChange
    }, "Filter using Quick Search Results"))), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, {
        border: false,
        className: "twa:pt-3"
    }, "Cell Matching Style"), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), null, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, null, $acw62.createElement((0, $e629d4699b6af5c8$export$a7668fc2e148d940), {
        headless: true,
        className: "twa:h-full twa:flex-1 twa:rounded-none",
        headerText: 'Cell Matching Style',
        api: props.api,
        Style: props.QuickSearchStyle,
        UpdateStyle: onUpdateStyle
    })))));
};
function $3994c9f0d97346a3$var$mapStateToProps(state, ownProps) {
    return {
        QuickSearchText: state.QuickSearch.QuickSearchText,
        QuickSearchStyle: state.QuickSearch.CellMatchStyle ?? {}
    };
}
function $3994c9f0d97346a3$var$mapDispatchToProps(dispatch) {
    return {
        onRunQuickSearch: (quickSearchText)=>dispatch($a9684a89f07662ba$export$e6464f631b683a94(quickSearchText)),
        onSetMatchingCellStyle: (style)=>dispatch($a9684a89f07662ba$export$fe53e034aaf6474a(style))
    };
}
const $3994c9f0d97346a3$export$b772fc5147b4377e = (0, $55388fc2f116d4d7$export$64605811ab45167f)($3994c9f0d97346a3$var$mapStateToProps, $3994c9f0d97346a3$var$mapDispatchToProps)($3994c9f0d97346a3$var$QuickSearchPopupComponent);




var $acw62 = parcelRequire("acw62");






var $9g4SS = parcelRequire("9g4SS");

var $acw62 = parcelRequire("acw62");



var $9g4SS = parcelRequire("9g4SS");
const $5460d6ff5d2c60f3$export$d0245a44c9a88495 = (props)=>{
    const { options: options, value: value, onChange: onChange, ...valueSelectorProps } = props;
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const selectedModulesMap = (0, $acw62.useMemo)(()=>{
        if (!value || !value.length) return new Map();
        return value.reduce((acc, val)=>{
            acc.set(val, true);
            return acc;
        }, new Map());
    }, [
        value
    ]);
    const allowReorder = (0, $acw62.useCallback)((option)=>{
        return selectedModulesMap.has(option);
    }, [
        selectedModulesMap
    ]);
    const moduleLabelMap = (0, $acw62.useMemo)(()=>{
        const labelMap = new Map();
        options.forEach((module)=>labelMap.set(module, adaptable.ModuleService.getModuleFriendlyName(module) ?? module));
        return labelMap;
    }, [
        options
    ]);
    const sortedOptions = (0, $acw62.useMemo)(()=>{
        return (0, $9g4SS.default).sortArrayWithOrder(options, value, {
            sortUnorderedItems: true
        });
    }, [
        allowReorder,
        options,
        value
    ]);
    return $acw62.createElement((0, $d2ae5bba8d7d6225$export$98c0468e3210506e), {
        ...valueSelectorProps,
        options: sortedOptions,
        value: value,
        onChange: onChange,
        allowReorder: allowReorder,
        toIdentifier: (module)=>module,
        toLabel: (module)=>moduleLabelMap.get(module),
        isOptionDisabled: props.isOptionDisabled,
        disabled: props.disabled
    });
};




var $69de3722b23fa6b3$export$e3fe7c16944ed97;
(function(ToolPanelConfigView) {
    ToolPanelConfigView["Buttons"] = "Buttons";
    ToolPanelConfigView["ToolPanels"] = "ToolPanels";
})($69de3722b23fa6b3$export$e3fe7c16944ed97 || ($69de3722b23fa6b3$export$e3fe7c16944ed97 = {}));
class $69de3722b23fa6b3$var$ToolPanelPopupComponent extends $acw62.Component {
    constructor(props){
        super(props);
        const initialTab = props.popupParams?.config?.initialTab ?? $69de3722b23fa6b3$export$e3fe7c16944ed97.ToolPanels;
        this.state = {
            ToolPanelConfigView: initialTab
        };
    }
    render() {
        // 1. process module buttons
        const selectedModuleButtons = [];
        if ((0, $9g4SS.default).IsNotNullOrEmpty(this.props.ToolPanelState.ModuleButtons)) this.props.ToolPanelState.ModuleButtons.forEach((module)=>{
            let menuItem = this.props.InternalState.SettingsPanelModuleEntries.find((m)=>m.category == module);
            if (menuItem?.isVisible) selectedModuleButtons.push(module);
        });
        const allModuleButtons = this.props.InternalState.SettingsPanelModuleEntries.map((x)=>x.category);
        // 2. process tool panels
        const availableModules = this.props.InternalState.SettingsPanelModuleEntries.filter((menuItem)=>menuItem.isVisible).map((menuItem)=>menuItem.category);
        // 'Dashboard' is a special case because it's not available in the dashboard menu items, s we have to add it manually
        if (!this.props.api.entitlementApi.isModuleHiddenEntitlement('Dashboard')) availableModules.push('Dashboard');
        if (this.props.api.pluginsApi.getipushpullPluginApi() && !this.props.api.entitlementApi.isModuleHiddenEntitlement('IPushPull')) availableModules.push('IPushPull');
        if (this.props.api.pluginsApi.getOpenFinPluginApi() && !this.props.api.entitlementApi.isModuleHiddenEntitlement('OpenFin')) availableModules.push('OpenFin');
        const availableModuleToolPanels = (0, $c75adffdf90b3d81$export$d064dfbe60243148).filter((moduleToolPanel)=>(0, $9g4SS.default).ContainsItem(availableModules, moduleToolPanel));
        const availableCustomToolPanels = this.props.api.toolPanelApi.getCustomToolPanels().map((customToolPanel)=>customToolPanel.name);
        const availableToolPanels = [
            ...availableCustomToolPanels,
            ...availableModuleToolPanels
        ];
        const selectedToolPanels = this.props.ToolPanelState.ToolPanels.map((toolPanelDefinition)=>toolPanelDefinition.Name)// ensure that the visible state has only valid tool panels
        .filter((visibleToolPanel)=>availableToolPanels.includes(visibleToolPanel));
        const isToolPanelReadOnly = this.props.api.entitlementApi.isModuleReadOnlyEntitlement('ToolPanel');
        const isModuleCheckboxDisabled = (module)=>{
            if (module === 'SettingsPanel') return this.props.api.optionsApi.getSettingsPanelOptions().alwaysShowInDashboard;
            return false;
        };
        return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
            headerText: "Tool Panel",
            glyphicon: this.props.moduleInfo.Glyph,
            infoLink: this.props.moduleInfo.HelpPage,
            infoLinkDisabled: !this.props.api.internalApi.isDocumentationLinksDisplayed(),
            scrollable: false
        }, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
            className: "twa:flex-1 twa:border-none twa:shadow-md twa:overflow-hidden"
        }, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039).FlexBody, null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
            "data-name": 'toolPanelPopup-component',
            className: "ab-ToolPanelPopup twa:min-h-0 twa:flex-1",
            value: this.state.ToolPanelConfigView,
            onValueChange: (value)=>this.setState({
                    ToolPanelConfigView: value
                })
        }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
            value: $69de3722b23fa6b3$export$e3fe7c16944ed97.ToolPanels
        }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
            className: "twa:m-0",
            value: $69de3722b23fa6b3$export$e3fe7c16944ed97.ToolPanels,
            checked: this.state.ToolPanelConfigView == $69de3722b23fa6b3$export$e3fe7c16944ed97.ToolPanels,
            tabIndex: -1
        }, "Tool Panels")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
            value: $69de3722b23fa6b3$export$e3fe7c16944ed97.Buttons
        }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
            className: "twa:m-0",
            value: $69de3722b23fa6b3$export$e3fe7c16944ed97.Buttons,
            checked: this.state.ToolPanelConfigView == $69de3722b23fa6b3$export$e3fe7c16944ed97.Buttons,
            tabIndex: -1
        }, "Module Buttons")), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
            value: $69de3722b23fa6b3$export$e3fe7c16944ed97.ToolPanels,
            style: {
                flex: 1,
                overflow: 'auto'
            }
        }, $acw62.createElement((0, $5460d6ff5d2c60f3$export$d0245a44c9a88495), {
            options: availableToolPanels,
            value: selectedToolPanels,
            onChange: (selectedValues)=>this.onToolPanelToolPanelsChanged(selectedValues),
            disabled: isToolPanelReadOnly
        })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
            value: $69de3722b23fa6b3$export$e3fe7c16944ed97.Buttons,
            style: {
                flex: 1,
                overflow: 'auto'
            }
        }, $acw62.createElement((0, $5460d6ff5d2c60f3$export$d0245a44c9a88495), {
            options: allModuleButtons,
            value: selectedModuleButtons,
            isOptionDisabled: isModuleCheckboxDisabled,
            disabled: isToolPanelReadOnly,
            onChange: (selectedValues)=>this.props.onToolPanelSetModuleButtons(selectedValues)
        }))))));
    }
    onShowGridPropertiesChanged(event) {
        let e = event.target;
        let ToolPanelConfigView = e.value;
        this.setState({
            ToolPanelConfigView: ToolPanelConfigView
        });
    }
    onToolPanelToolPanelsChanged(selectedValues) {
        const currentSelectedToolPanelDefinitions = this.props.ToolPanelState.ToolPanels;
        // try to return the pre-existing definition (to maintain the previous collapsed state)
        // otherwise select the new toolPanel with the default 'collapsed' state
        let newSelectedToolPanelDefinitions = selectedValues.map((selectedToolPanel)=>{
            return currentSelectedToolPanelDefinitions.find((currentDefinition)=>currentDefinition.Name === selectedToolPanel) ?? {
                Name: selectedToolPanel,
                VisibilityMode: 'collapsed'
            };
        });
        this.props.onToolPanelSetToolPanels(newSelectedToolPanelDefinitions);
    }
}
function $69de3722b23fa6b3$var$mapStateToProps(state) {
    return {
        ToolPanelState: state.ToolPanel,
        InternalState: state.Internal
    };
}
function $69de3722b23fa6b3$var$mapDispatchToProps(dispatch) {
    return {
        onToolPanelSetModuleButtons: (moduleButtons)=>dispatch($297dbcf3bf27faf2$export$2603e58d630068f9(moduleButtons)),
        onToolPanelSetToolPanels: (toolPanels)=>dispatch($297dbcf3bf27faf2$export$c8a6b1c32a7e4f85(toolPanels))
    };
}
let $69de3722b23fa6b3$export$ee4d8524b10cd215 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($69de3722b23fa6b3$var$mapStateToProps, $69de3722b23fa6b3$var$mapDispatchToProps)($69de3722b23fa6b3$var$ToolPanelPopupComponent);



var $acw62 = parcelRequire("acw62");

var $9g4SS = parcelRequire("9g4SS");


// packages/ag-grid-enterprise/src/license/gridLicenseManager.ts

// packages/ag-grid-enterprise/src/license/shared/md5.ts
var $5b7ccabde48fae90$var$MD5 = class {
    constructor(){
        this.ieCompatibility = false;
    }
    init() {
        this.ieCompatibility = this.md5("hello") != "5d41402abc4b2a76b9719d911017c592";
    }
    md5cycle(x, k) {
        let a = x[0], b = x[1], c = x[2], d = x[3];
        a = this.ff(a, b, c, d, k[0], 7, -680876936);
        d = this.ff(d, a, b, c, k[1], 12, -389564586);
        c = this.ff(c, d, a, b, k[2], 17, 606105819);
        b = this.ff(b, c, d, a, k[3], 22, -1044525330);
        a = this.ff(a, b, c, d, k[4], 7, -176418897);
        d = this.ff(d, a, b, c, k[5], 12, 1200080426);
        c = this.ff(c, d, a, b, k[6], 17, -1473231341);
        b = this.ff(b, c, d, a, k[7], 22, -45705983);
        a = this.ff(a, b, c, d, k[8], 7, 1770035416);
        d = this.ff(d, a, b, c, k[9], 12, -1958414417);
        c = this.ff(c, d, a, b, k[10], 17, -42063);
        b = this.ff(b, c, d, a, k[11], 22, -1990404162);
        a = this.ff(a, b, c, d, k[12], 7, 1804603682);
        d = this.ff(d, a, b, c, k[13], 12, -40341101);
        c = this.ff(c, d, a, b, k[14], 17, -1502002290);
        b = this.ff(b, c, d, a, k[15], 22, 1236535329);
        a = this.gg(a, b, c, d, k[1], 5, -165796510);
        d = this.gg(d, a, b, c, k[6], 9, -1069501632);
        c = this.gg(c, d, a, b, k[11], 14, 643717713);
        b = this.gg(b, c, d, a, k[0], 20, -373897302);
        a = this.gg(a, b, c, d, k[5], 5, -701558691);
        d = this.gg(d, a, b, c, k[10], 9, 38016083);
        c = this.gg(c, d, a, b, k[15], 14, -660478335);
        b = this.gg(b, c, d, a, k[4], 20, -405537848);
        a = this.gg(a, b, c, d, k[9], 5, 568446438);
        d = this.gg(d, a, b, c, k[14], 9, -1019803690);
        c = this.gg(c, d, a, b, k[3], 14, -187363961);
        b = this.gg(b, c, d, a, k[8], 20, 1163531501);
        a = this.gg(a, b, c, d, k[13], 5, -1444681467);
        d = this.gg(d, a, b, c, k[2], 9, -51403784);
        c = this.gg(c, d, a, b, k[7], 14, 1735328473);
        b = this.gg(b, c, d, a, k[12], 20, -1926607734);
        a = this.hh(a, b, c, d, k[5], 4, -378558);
        d = this.hh(d, a, b, c, k[8], 11, -2022574463);
        c = this.hh(c, d, a, b, k[11], 16, 1839030562);
        b = this.hh(b, c, d, a, k[14], 23, -35309556);
        a = this.hh(a, b, c, d, k[1], 4, -1530992060);
        d = this.hh(d, a, b, c, k[4], 11, 1272893353);
        c = this.hh(c, d, a, b, k[7], 16, -155497632);
        b = this.hh(b, c, d, a, k[10], 23, -1094730640);
        a = this.hh(a, b, c, d, k[13], 4, 681279174);
        d = this.hh(d, a, b, c, k[0], 11, -358537222);
        c = this.hh(c, d, a, b, k[3], 16, -722521979);
        b = this.hh(b, c, d, a, k[6], 23, 76029189);
        a = this.hh(a, b, c, d, k[9], 4, -640364487);
        d = this.hh(d, a, b, c, k[12], 11, -421815835);
        c = this.hh(c, d, a, b, k[15], 16, 530742520);
        b = this.hh(b, c, d, a, k[2], 23, -995338651);
        a = this.ii(a, b, c, d, k[0], 6, -198630844);
        d = this.ii(d, a, b, c, k[7], 10, 1126891415);
        c = this.ii(c, d, a, b, k[14], 15, -1416354905);
        b = this.ii(b, c, d, a, k[5], 21, -57434055);
        a = this.ii(a, b, c, d, k[12], 6, 1700485571);
        d = this.ii(d, a, b, c, k[3], 10, -1894986606);
        c = this.ii(c, d, a, b, k[10], 15, -1051523);
        b = this.ii(b, c, d, a, k[1], 21, -2054922799);
        a = this.ii(a, b, c, d, k[8], 6, 1873313359);
        d = this.ii(d, a, b, c, k[15], 10, -30611744);
        c = this.ii(c, d, a, b, k[6], 15, -1560198380);
        b = this.ii(b, c, d, a, k[13], 21, 1309151649);
        a = this.ii(a, b, c, d, k[4], 6, -145523070);
        d = this.ii(d, a, b, c, k[11], 10, -1120210379);
        c = this.ii(c, d, a, b, k[2], 15, 718787259);
        b = this.ii(b, c, d, a, k[9], 21, -343485551);
        x[0] = this.add32(a, x[0]);
        x[1] = this.add32(b, x[1]);
        x[2] = this.add32(c, x[2]);
        x[3] = this.add32(d, x[3]);
    }
    cmn(q, a, b, x, s2, t) {
        a = this.add32(this.add32(a, q), this.add32(x, t));
        return this.add32(a << s2 | a >>> 32 - s2, b);
    }
    ff(a, b, c, d, x, s2, t) {
        return this.cmn(b & c | ~b & d, a, b, x, s2, t);
    }
    gg(a, b, c, d, x, s2, t) {
        return this.cmn(b & d | c & ~d, a, b, x, s2, t);
    }
    hh(a, b, c, d, x, s2, t) {
        return this.cmn(b ^ c ^ d, a, b, x, s2, t);
    }
    ii(a, b, c, d, x, s2, t) {
        return this.cmn(c ^ (b | ~d), a, b, x, s2, t);
    }
    md51(s2) {
        const n = s2.length;
        const state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        let i;
        for(i = 64; i <= s2.length; i += 64)this.md5cycle(state, this.md5blk(s2.substring(i - 64, i)));
        s2 = s2.substring(i - 64);
        const tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < s2.length; i++)tail[i >> 2] |= s2.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 128 << (i % 4 << 3);
        if (i > 55) {
            this.md5cycle(state, tail);
            for(i = 0; i < 16; i++)tail[i] = 0;
        }
        tail[14] = n * 8;
        this.md5cycle(state, tail);
        return state;
    }
    /* there needs to be support for Unicode here, * unless we pretend that we can redefine the MD-5
   * algorithm for multi-byte characters (perhaps by adding every four 16-bit characters and
   * shortening the sum to 32 bits). Otherwise I suthis.ggest performing MD-5 as if every character
   * was two bytes--e.g., 0040 0025 = @%--but then how will an ordinary MD-5 sum be matched?
   * There is no way to standardize text to something like UTF-8 before transformation; speed cost is
   * utterly prohibitive. The JavaScript standard itself needs to look at this: it should start
   * providing access to strings as preformed UTF-8 8-bit unsigned value arrays.
   */ md5blk(s2) {
        const md5blks = [];
        for(let i = 0; i < 64; i += 4)md5blks[i >> 2] = s2.charCodeAt(i) + (s2.charCodeAt(i + 1) << 8) + (s2.charCodeAt(i + 2) << 16) + (s2.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    rhex(n) {
        const hex_chr = "0123456789abcdef".split("");
        let s2 = "", j = 0;
        for(; j < 4; j++)s2 += hex_chr[n >> j * 8 + 4 & 15] + hex_chr[n >> j * 8 & 15];
        return s2;
    }
    hex(x) {
        for(let i = 0; i < x.length; i++)x[i] = this.rhex(x[i]);
        return x.join("");
    }
    md5(s2) {
        return this.hex(this.md51(s2));
    }
    add32(a, b) {
        return this.ieCompatibility ? this.add32Compat(a, b) : this.add32Std(a, b);
    }
    /* this function is much faster, so if possible we use it. Some IEs are the only ones I know of that
   need the idiotic second function, generated by an if clause.  */ add32Std(a, b) {
        return a + b & 4294967295;
    }
    add32Compat(x, y) {
        const lsw = (x & 65535) + (y & 65535), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 65535;
    }
};
// packages/ag-grid-enterprise/src/license/shared/licenseManager.ts
var $5b7ccabde48fae90$var$LICENSE_TYPES = {
    "01": "GRID",
    "02": "CHARTS",
    "0102": "BOTH"
};
var $5b7ccabde48fae90$var$LICENSING_HELP_URL = "https://www.ag-grid.com/licensing/";
var $5b7ccabde48fae90$var$_LicenseManager = class _LicenseManager {
    constructor(document2){
        this.watermarkMessage = void 0;
        this.totalMessageLength = 124;
        this.document = document2;
        this.md5 = new $5b7ccabde48fae90$var$MD5();
        this.md5.init();
    }
    validateLicense() {
        const licenseDetails = this.getLicenseDetails(_LicenseManager.licenseKey);
        const currentLicenseName = `AG Grid ${licenseDetails.currentLicenseType === "BOTH" ? "and AG Charts " : ""}Enterprise`;
        const suppliedLicenseName = licenseDetails.suppliedLicenseType === void 0 ? "" : `AG ${licenseDetails.suppliedLicenseType === "BOTH" ? "Grid and AG Charts" : licenseDetails.suppliedLicenseType === "GRID" ? "Grid" : "Charts"} Enterprise`;
        if (licenseDetails.missing) {
            if (!this.isWebsiteUrl() || this.isForceWatermark()) this.outputMissingLicenseKey(currentLicenseName);
        } else if (licenseDetails.expired) {
            const gridReleaseDate = _LicenseManager.getGridReleaseDate();
            const formattedReleaseDate = _LicenseManager.formatDate(gridReleaseDate);
            this.outputExpiredKey(licenseDetails.expiry, formattedReleaseDate, currentLicenseName, suppliedLicenseName);
        } else if (!licenseDetails.valid) this.outputInvalidLicenseKey(!!licenseDetails.incorrectLicenseType, currentLicenseName, suppliedLicenseName);
        else if (licenseDetails.isTrial && licenseDetails.trialExpired) this.outputExpiredTrialKey(licenseDetails.expiry, currentLicenseName, suppliedLicenseName);
    }
    static extractExpiry(license) {
        const restrictionHashed = license.substring(license.lastIndexOf("_") + 1, license.length);
        return new Date(parseInt(_LicenseManager.decode(restrictionHashed), 10));
    }
    static extractLicenseComponents(licenseKey) {
        let cleanedLicenseKey = licenseKey.replace(/[\u200B-\u200D\uFEFF]/g, "");
        cleanedLicenseKey = cleanedLicenseKey.replace(/\r?\n|\r/g, "");
        if (licenseKey.length <= 32) return {
            md5: null,
            license: licenseKey,
            version: null,
            isTrial: null
        };
        const hashStart = cleanedLicenseKey.length - 32;
        const md5 = cleanedLicenseKey.substring(hashStart);
        const license = cleanedLicenseKey.substring(0, hashStart);
        const [version, isTrial, type] = _LicenseManager.extractBracketedInformation(cleanedLicenseKey);
        return {
            md5: md5,
            license: license,
            version: version,
            isTrial: isTrial,
            type: type
        };
    }
    getLicenseDetails(licenseKey) {
        const currentLicenseType = _LicenseManager.chartsLicenseManager ? "BOTH" : "GRID";
        if (!licenseKey?.length) return {
            licenseKey: licenseKey,
            valid: false,
            missing: true,
            currentLicenseType: currentLicenseType
        };
        const gridReleaseDate = _LicenseManager.getGridReleaseDate();
        const { md5: md5, license: license, version: version, isTrial: isTrial, type: type } = _LicenseManager.extractLicenseComponents(licenseKey);
        let valid = md5 === this.md5.md5(license) && !licenseKey.includes("For_Trialing_ag-Grid_Only");
        let trialExpired = void 0;
        let expired = void 0;
        let expiry = null;
        let incorrectLicenseType = false;
        let suppliedLicenseType = void 0;
        function handleTrial() {
            const now = /* @__PURE__ */ new Date();
            trialExpired = expiry < now;
            expired = void 0;
        }
        if (valid) {
            expiry = _LicenseManager.extractExpiry(license);
            valid = !isNaN(expiry.getTime());
            if (valid) {
                expired = gridReleaseDate > expiry;
                switch(version){
                    case "legacy":
                    case "2":
                        if (isTrial) handleTrial();
                        break;
                    case "3":
                        if (!type?.length) valid = false;
                        else {
                            suppliedLicenseType = type;
                            if (type !== $5b7ccabde48fae90$var$LICENSE_TYPES["01"] && type !== $5b7ccabde48fae90$var$LICENSE_TYPES["0102"] || currentLicenseType === "BOTH" && suppliedLicenseType !== "BOTH") {
                                valid = false;
                                incorrectLicenseType = true;
                            } else if (isTrial) handleTrial();
                        }
                }
            }
        }
        if (!valid) return {
            licenseKey: licenseKey,
            valid: valid,
            incorrectLicenseType: incorrectLicenseType,
            currentLicenseType: currentLicenseType,
            suppliedLicenseType: suppliedLicenseType
        };
        return {
            licenseKey: licenseKey,
            valid: valid,
            expiry: _LicenseManager.formatDate(expiry),
            expired: expired,
            version: version,
            isTrial: isTrial,
            trialExpired: trialExpired,
            incorrectLicenseType: incorrectLicenseType,
            currentLicenseType: currentLicenseType,
            suppliedLicenseType: suppliedLicenseType
        };
    }
    isDisplayWatermark() {
        return this.isForceWatermark() || !this.isLocalhost() && !this.isWebsiteUrl() && !!this.watermarkMessage?.length;
    }
    getWatermarkMessage() {
        return this.watermarkMessage || "";
    }
    getHostname() {
        const win = this.document.defaultView || window;
        const loc = win.location;
        const { hostname: hostname = "" } = loc;
        return hostname;
    }
    isForceWatermark() {
        const win = this.document.defaultView || window;
        const loc = win.location;
        const { pathname: pathname } = loc;
        return pathname ? pathname.includes("forceWatermark") : false;
    }
    isWebsiteUrl() {
        const hostname = this.getHostname();
        return hostname.match(/^((?:[\w-]+\.)?ag-grid\.com)$/) !== null;
    }
    isLocalhost() {
        const hostname = this.getHostname();
        return hostname.match(/^(?:127\.0\.0\.1|localhost)$/) !== null;
    }
    static formatDate(date) {
        const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();
        return day + " " + monthNames[monthIndex] + " " + year;
    }
    static getGridReleaseDate() {
        return new Date(parseInt(_LicenseManager.decode(_LicenseManager.RELEASE_INFORMATION), 10));
    }
    static decode(input) {
        const keystr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        let t = "";
        let n, r, i;
        let s2, o, u, a;
        let f = 0;
        const e = input.replace(/[^A-Za-z0-9+/=]/g, "");
        while(f < e.length){
            s2 = keystr.indexOf(e.charAt(f++));
            o = keystr.indexOf(e.charAt(f++));
            u = keystr.indexOf(e.charAt(f++));
            a = keystr.indexOf(e.charAt(f++));
            n = s2 << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);
            if (u != 64) t = t + String.fromCharCode(r);
            if (a != 64) t = t + String.fromCharCode(i);
        }
        t = _LicenseManager.utf8_decode(t);
        return t;
    }
    static utf8_decode(input) {
        input = input.replace(/rn/g, "n");
        let t = "";
        for(let n = 0; n < input.length; n++){
            const r = input.charCodeAt(n);
            if (r < 128) t += String.fromCharCode(r);
            else if (r > 127 && r < 2048) {
                t += String.fromCharCode(r >> 6 | 192);
                t += String.fromCharCode(r & 63 | 128);
            } else {
                t += String.fromCharCode(r >> 12 | 224);
                t += String.fromCharCode(r >> 6 & 63 | 128);
                t += String.fromCharCode(r & 63 | 128);
            }
        }
        return t;
    }
    static setChartsLicenseManager(dependantLicenseManager) {
        this.chartsLicenseManager = dependantLicenseManager;
        this.chartsLicenseManager?.setLicenseKey(this.licenseKey, true);
    }
    static setLicenseKey(licenseKey) {
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(this.licenseKey) && this.licenseKey !== licenseKey) (0, $437b23f6a393c3bf$export$2ff8152c3f8aff5b)(291, void 0, "AG Grid: License Key being set multiple times with different values. This can result in an incorrect license key being used.");
        this.licenseKey = licenseKey;
        this.chartsLicenseManager?.setLicenseKey(licenseKey, true);
    }
    static extractBracketedInformation(licenseKey) {
        if (!licenseKey.includes("[")) return [
            "legacy",
            false,
            void 0
        ];
        const matches = licenseKey.match(/\[(.*?)\]/g).map((match)=>match.replace("[", "").replace("]", ""));
        if (!matches || matches.length === 0) return [
            "legacy",
            false,
            void 0
        ];
        const isTrial = matches.filter((match)=>match === "TRIAL").length === 1;
        const rawVersion = matches.filter((match)=>match.indexOf("v") === 0)[0];
        const version = rawVersion ? rawVersion.replace("v", "") : "legacy";
        const type = $5b7ccabde48fae90$var$LICENSE_TYPES[matches.filter((match)=>$5b7ccabde48fae90$var$LICENSE_TYPES[match])[0]];
        return [
            version,
            isTrial,
            type
        ];
    }
    centerPadAndOutput(input) {
        const paddingRequired = this.totalMessageLength - input.length;
        console.error(input.padStart(paddingRequired / 2 + input.length, "*").padEnd(this.totalMessageLength, "*"));
    }
    padAndOutput(input, padding = "*", terminateWithPadding = "") {
        console.error(input.padEnd(this.totalMessageLength - terminateWithPadding.length, padding) + terminateWithPadding);
    }
    outputInvalidLicenseKey(incorrectLicenseType, currentLicenseName, suppliedLicenseName) {
        if (incorrectLicenseType) {
            this.centerPadAndOutput("");
            this.centerPadAndOutput(` ${currentLicenseName} License `);
            this.centerPadAndOutput(" Incompatible License Key ");
            this.padAndOutput(`* Your license key is for ${suppliedLicenseName} only and does not cover you for ${currentLicenseName}.`, " ", "*");
            this.padAndOutput(`* To troubleshoot your license key visit ${$5b7ccabde48fae90$var$LICENSING_HELP_URL}.`, " ", "*");
            this.centerPadAndOutput("");
            this.centerPadAndOutput("");
        } else {
            this.centerPadAndOutput("");
            this.centerPadAndOutput(` ${currentLicenseName} License `);
            this.centerPadAndOutput(" Invalid License Key ");
            this.padAndOutput(`* Your license key is not valid.`, " ", "*");
            this.padAndOutput(`* To troubleshoot your license key visit ${$5b7ccabde48fae90$var$LICENSING_HELP_URL}.`, " ", "*");
            this.centerPadAndOutput("");
            this.centerPadAndOutput("");
        }
        this.watermarkMessage = "Invalid License";
    }
    outputExpiredTrialKey(formattedExpiryDate, currentLicenseName, suppliedLicenseName) {
        this.centerPadAndOutput("");
        this.centerPadAndOutput(` ${currentLicenseName} License `);
        this.centerPadAndOutput(" Trial Period Expired. ");
        this.padAndOutput(`* Your trial only license for ${suppliedLicenseName} expired on ${formattedExpiryDate}.`, " ", "*");
        this.padAndOutput("* Please email info@ag-grid.com to purchase a license.", " ", "*");
        this.centerPadAndOutput("");
        this.centerPadAndOutput("");
        this.watermarkMessage = "Trial Period Expired";
    }
    outputMissingLicenseKey(currentLicenseName) {
        this.centerPadAndOutput("");
        this.centerPadAndOutput(` ${currentLicenseName} License `);
        this.centerPadAndOutput(" License Key Not Found ");
        this.padAndOutput(`* All ${currentLicenseName} features are unlocked for trial.`, " ", "*");
        this.padAndOutput("* If you want to hide the watermark please email info@ag-grid.com for a trial license key.", " ", "*");
        this.centerPadAndOutput("");
        this.centerPadAndOutput("");
        this.watermarkMessage = "For Trial Use Only";
    }
    outputExpiredKey(formattedExpiryDate, formattedReleaseDate, currentLicenseName, suppliedLicenseName) {
        this.centerPadAndOutput("");
        this.centerPadAndOutput(` ${currentLicenseName} License `);
        this.centerPadAndOutput(" Incompatible Software Version ");
        this.padAndOutput(`* Your license key works with versions${suppliedLicenseName == "" ? "" : ` of ${suppliedLicenseName}`} released before ${formattedExpiryDate}.`, " ", "*");
        this.padAndOutput(`* The version you are trying to use was released on ${formattedReleaseDate}.`, " ", "*");
        this.padAndOutput("* Please contact info@ag-grid.com to renew your license key.", " ", "*");
        this.centerPadAndOutput("");
        this.centerPadAndOutput("");
        this.watermarkMessage = "License Expired";
    }
};
$5b7ccabde48fae90$var$_LicenseManager.RELEASE_INFORMATION = "MTc2OTEwMTg5NDA0NQ==";
var $5b7ccabde48fae90$var$LicenseManager = $5b7ccabde48fae90$var$_LicenseManager;
// packages/ag-grid-enterprise/src/license/watermark.css-GENERATED.ts
var $5b7ccabde48fae90$var$watermarkCSS = /*css*/ `.ag-watermark{bottom:20px;color:#9b9b9b;opacity:.7;position:absolute;transition:opacity 1s ease-out 3s;&:before{background-image:url("data:image/svg+xml;base64,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");background-repeat:no-repeat;background-size:170px 40px;content:"";display:block;height:40px;width:170px}}:where(.ag-ltr) .ag-watermark{right:25px}:where(.ag-rtl) .ag-watermark{left:25px}.ag-watermark-text{font-family:Impact,sans-serif;font-size:19px;font-weight:700;opacity:.5}:where(.ag-ltr) .ag-watermark-text{padding-left:.7rem}:where(.ag-rtl) .ag-watermark-text{padding-right:.7rem}`;
// packages/ag-grid-enterprise/src/license/watermark.ts
var $5b7ccabde48fae90$var$WatermarkElement = {
    tag: "div",
    cls: "ag-watermark",
    children: [
        {
            tag: "div",
            ref: "eLicenseTextRef",
            cls: "ag-watermark-text"
        }
    ]
};
var $5b7ccabde48fae90$var$AgWatermark = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$WatermarkElement);
        this.eLicenseTextRef = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.registerCSS($5b7ccabde48fae90$var$watermarkCSS);
    }
    wireBeans(beans) {
        this.licenseManager = beans.licenseManager;
    }
    postConstruct() {
        const show = this.shouldDisplayWatermark();
        this.setDisplayed(show);
        if (show) {
            this.eLicenseTextRef.textContent = this.licenseManager.getWatermarkMessage();
            window.setTimeout(()=>this.addCss("ag-opacity-zero"), 0);
            window.setTimeout(()=>this.setDisplayed(false), 5e3);
        }
    }
    shouldDisplayWatermark() {
        return this.licenseManager.isDisplayWatermark();
    }
};
var $5b7ccabde48fae90$var$AgWatermarkSelector = {
    selector: "AG-WATERMARK",
    component: $5b7ccabde48fae90$var$AgWatermark
};
// packages/ag-grid-enterprise/src/license/gridLicenseManager.ts
var $5b7ccabde48fae90$export$91e2bbffdbb3852c = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "licenseManager";
    }
    postConstruct() {
        this.validateLicense();
    }
    validateLicense() {
        this.licenseManager = new $5b7ccabde48fae90$var$LicenseManager((0, $437b23f6a393c3bf$export$f63d0991874c6f81)(this.beans));
        this.licenseManager.validateLicense();
    }
    static getLicenseDetails(licenseKey) {
        return new $5b7ccabde48fae90$var$LicenseManager(null).getLicenseDetails(licenseKey);
    }
    getWatermarkSelector() {
        return $5b7ccabde48fae90$var$AgWatermarkSelector;
    }
    isDisplayWatermark() {
        return this.licenseManager.isDisplayWatermark();
    }
    getWatermarkMessage() {
        return this.licenseManager.getWatermarkMessage();
    }
    static setLicenseKey(licenseKey) {
        $5b7ccabde48fae90$var$LicenseManager.setLicenseKey(licenseKey);
    }
    static setChartsLicenseManager(chartsLicenseManager) {
        $5b7ccabde48fae90$var$LicenseManager.setChartsLicenseManager(chartsLicenseManager);
    }
};
// packages/ag-grid-enterprise/src/excelExport/assets/excelConstants.ts
var $5b7ccabde48fae90$var$INCH_TO_EMU = 9525;
var $5b7ccabde48fae90$var$numberFormatMap = {
    "0": 1,
    "0.00": 2,
    "#,##0": 3,
    "#,##0.00": 4,
    "0%": 9,
    "0.00%": 10,
    "0.00E+00": 11,
    "# ?/?": 12,
    "# ??/??": 13,
    "mm-dd-yy": 14,
    "d-mmm-yy": 15,
    "d-mmm": 16,
    "mmm-yy": 17,
    "h:mm AM/PM": 18,
    "h:mm:ss AM/PM": 19,
    "h:mm": 20,
    "h:mm:ss": 21,
    "m/d/yy h:mm": 22,
    "#,##0 ;(#,##0)": 37,
    "#,##0 ;[Red](#,##0)": 38,
    "#,##0.00;(#,##0.00)": 39,
    "#,##0.00;[Red](#,##0.00)": 40,
    "mm:ss": 45,
    "[h]:mm:ss": 46,
    "mmss.0": 47,
    "##0.0E+0": 48,
    "@": 49
};
// packages/ag-grid-enterprise/src/excelExport/assets/xmlFactory.ts
var $5b7ccabde48fae90$var$LINE_SEPARATOR = "\r\n";
function $5b7ccabde48fae90$var$returnAttributeIfPopulated(key, value, booleanTransformer) {
    if (!value && value !== "" && value !== 0) return "";
    let xmlValue = value;
    if (typeof value === "boolean") {
        if (booleanTransformer) xmlValue = booleanTransformer(value);
    }
    return ` ${key}="${xmlValue}"`;
}
function $5b7ccabde48fae90$var$createXmlHeader(headerElement = {}) {
    const headerStart = "<?";
    const headerEnd = "?>";
    const keys = [
        "version"
    ];
    if (!headerElement.version) headerElement.version = "1.0";
    if (headerElement.encoding) keys.push("encoding");
    if (headerElement.standalone) keys.push("standalone");
    const att = keys.map((key)=>`${key}="${headerElement[key]}"`).join(" ");
    return `${headerStart}xml ${att} ${headerEnd}`;
}
function $5b7ccabde48fae90$var$createXml(xmlElement, booleanTransformer) {
    let props = "";
    if (xmlElement.properties) {
        if (xmlElement.properties.prefixedAttributes) xmlElement.properties.prefixedAttributes.forEach((prefixedSet)=>{
            for (const key of Object.keys(prefixedSet.map))props += $5b7ccabde48fae90$var$returnAttributeIfPopulated(prefixedSet.prefix + key, prefixedSet.map[key], booleanTransformer);
        });
        if (xmlElement.properties.rawMap) for (const key of Object.keys(xmlElement.properties.rawMap))props += $5b7ccabde48fae90$var$returnAttributeIfPopulated(key, xmlElement.properties.rawMap[key], booleanTransformer);
    }
    let result = "<" + xmlElement.name + props;
    if (!xmlElement.children && xmlElement.textNode == null) return result + "/>" + $5b7ccabde48fae90$var$LINE_SEPARATOR;
    if (xmlElement.textNode != null) return result + ">" + xmlElement.textNode + "</" + xmlElement.name + ">" + $5b7ccabde48fae90$var$LINE_SEPARATOR;
    result += ">" + $5b7ccabde48fae90$var$LINE_SEPARATOR;
    if (xmlElement.children) for (const it of xmlElement.children)result += $5b7ccabde48fae90$var$createXml(it, booleanTransformer);
    return result + "</" + xmlElement.name + ">" + $5b7ccabde48fae90$var$LINE_SEPARATOR;
}
// packages/ag-grid-enterprise/src/excelExport/assets/excelUtils.ts
var $5b7ccabde48fae90$var$pointsToPixel = (points)=>{
    return Math.round(points * 96 / 72);
};
var $5b7ccabde48fae90$var$pixelsToEMU = (value)=>{
    return Math.ceil(value * $5b7ccabde48fae90$var$INCH_TO_EMU);
};
var $5b7ccabde48fae90$var$getFontFamilyId = (name)=>{
    if (name === void 0) return;
    const families = [
        "Automatic",
        "Roman",
        "Swiss",
        "Modern",
        "Script",
        "Decorative"
    ];
    const pos = families.indexOf(name || "Automatic");
    return Math.max(pos, 0);
};
var $5b7ccabde48fae90$var$getHeightFromProperty = (rowIndex, height)=>{
    if (!height) return;
    let finalHeight;
    if (typeof height === "number") finalHeight = height;
    else {
        const heightFunc = height;
        finalHeight = heightFunc({
            rowIndex: rowIndex
        });
    }
    return finalHeight;
};
var $5b7ccabde48fae90$var$setExcelImageTotalWidth = (image, columnsToExport)=>{
    const { colSpan: colSpan, column: column } = image.position;
    if (!image.width) return;
    if (colSpan) {
        const columnsInSpan = columnsToExport.slice(column - 1, column + colSpan - 1);
        let totalWidth = 0;
        for(let i = 0; i < columnsInSpan.length; i++){
            const colWidth = columnsInSpan[i].getActualWidth();
            if (image.width < totalWidth + colWidth) {
                image.position.colSpan = i + 1;
                image.totalWidth = image.width;
                image.width = image.totalWidth - totalWidth;
                break;
            }
            totalWidth += colWidth;
        }
    } else image.totalWidth = image.width;
};
var $5b7ccabde48fae90$var$setExcelImageTotalHeight = (image, rowHeight)=>{
    const { rowSpan: rowSpan, row: row } = image.position;
    if (!image.height) return;
    if (rowSpan) {
        let totalHeight = 0;
        let counter = 0;
        for(let i = row; i < row + rowSpan; i++){
            const nextRowHeight = $5b7ccabde48fae90$var$pointsToPixel($5b7ccabde48fae90$var$getHeightFromProperty(i, rowHeight) || 20);
            if (image.height < totalHeight + nextRowHeight) {
                image.position.rowSpan = counter + 1;
                image.totalHeight = image.height;
                image.height = image.totalHeight - totalHeight;
                break;
            }
            totalHeight += nextRowHeight;
            counter++;
        }
    } else image.totalHeight = image.height;
};
var $5b7ccabde48fae90$var$createXmlPart = (body, skipHeader)=>{
    const header = $5b7ccabde48fae90$var$createXmlHeader({
        encoding: "UTF-8",
        standalone: "yes"
    });
    const xmlBody = $5b7ccabde48fae90$var$createXml(body);
    if (skipHeader) return xmlBody;
    return `${header}${xmlBody}`;
};
var $5b7ccabde48fae90$var$getExcelColumnName = (colIdx)=>{
    const startCode = 65;
    const tableWidth = 26;
    const fromCharCode = String.fromCharCode;
    const pos = Math.floor(colIdx / tableWidth);
    const tableIdx = colIdx % tableWidth;
    if (!pos || colIdx === tableWidth) return fromCharCode(startCode + colIdx - 1);
    if (!tableIdx) return $5b7ccabde48fae90$var$getExcelColumnName(pos - 1) + "Z";
    if (pos < tableWidth) return fromCharCode(startCode + pos - 1) + fromCharCode(startCode + tableIdx - 1);
    return $5b7ccabde48fae90$var$getExcelColumnName(pos) + fromCharCode(startCode + tableIdx - 1);
};
var $5b7ccabde48fae90$var$sanitizeTableName = (name)=>{
    return name.replaceAll("\n", "_x000a_");
};
var $5b7ccabde48fae90$var$replaceInvisibleCharacters = (str)=>{
    if (str == null) return null;
    let newString = "";
    for(let i = 0; i < str.length; i++){
        const point = str.charCodeAt(i);
        if (point >= 0 && point <= 31 && point !== 10) {
            const convertedCode = point.toString(16).toUpperCase();
            const paddedCode = convertedCode.padStart(4, "0");
            const newValue = `_x${paddedCode}_`;
            newString += newValue;
        } else newString += str[i];
    }
    return newString;
};
var $5b7ccabde48fae90$var$buildSharedString = (strMap)=>{
    const ret = [];
    for (const key of strMap.keys()){
        const textNode = key.toString();
        const child = {
            name: "t",
            textNode: (0, $437b23f6a393c3bf$export$3df06b741968da82)($5b7ccabde48fae90$var$replaceInvisibleCharacters(textNode))
        };
        const preserveSpaces = textNode.trim().length !== textNode.length;
        if (preserveSpaces) child.properties = {
            rawMap: {
                "xml:space": "preserve"
            }
        };
        ret.push({
            name: "si",
            children: [
                child
            ]
        });
    }
    return ret;
};
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/contentType.ts
var $5b7ccabde48fae90$var$contentTypeFactory = {
    getTemplate (config) {
        const { name: name, ContentType: ContentType, Extension: Extension, PartName: PartName } = config;
        return {
            name: name,
            properties: {
                rawMap: {
                    Extension: Extension,
                    PartName: PartName,
                    ContentType: ContentType
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$contentType_default = $5b7ccabde48fae90$var$contentTypeFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/contentTypes.ts
var $5b7ccabde48fae90$var$_normaliseImageExtension = (ext)=>ext === "jpg" ? "jpeg" : ext;
var $5b7ccabde48fae90$var$contentTypesFactory = {
    getTemplate (sheetLen) {
        const worksheets = new Array(sheetLen).fill(void 0).map((v, i)=>({
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
                PartName: `/xl/worksheets/sheet${i + 1}.xml`
            }));
        const sheetsWithImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.size;
        const headerFooterImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.size;
        const imageTypesObject = {};
        $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.forEach((v)=>{
            imageTypesObject[$5b7ccabde48fae90$var$_normaliseImageExtension(v.type)] = true;
        });
        const imageDocs = new Array(sheetsWithImages).fill(void 0).map((v, i)=>({
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.drawing+xml",
                PartName: `/xl/drawings/drawing${i + 1}.xml`
            }));
        const tableDocs = [];
        $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.forEach(({ name: name })=>{
            tableDocs.push({
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml",
                PartName: `/xl/tables/${name}.xml`
            });
        });
        const imageTypes = Object.keys(imageTypesObject).map((ext)=>({
                name: "Default",
                ContentType: `image/${ext}`,
                Extension: ext
            }));
        if (headerFooterImages) imageTypes.push({
            name: "Default",
            Extension: "vml",
            ContentType: "application/vnd.openxmlformats-officedocument.vmlDrawing"
        });
        const children = [
            ...imageTypes,
            {
                name: "Default",
                Extension: "rels",
                ContentType: "application/vnd.openxmlformats-package.relationships+xml"
            },
            {
                name: "Default",
                ContentType: "application/xml",
                Extension: "xml"
            },
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
                PartName: "/xl/workbook.xml"
            },
            ...worksheets,
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.theme+xml",
                PartName: "/xl/theme/theme1.xml"
            },
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
                PartName: "/xl/styles.xml"
            },
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
                PartName: "/xl/sharedStrings.xml"
            },
            ...imageDocs,
            ...tableDocs,
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-package.core-properties+xml",
                PartName: "/docProps/core.xml"
            }
        ].map((contentType)=>$5b7ccabde48fae90$var$contentType_default.getTemplate(contentType));
        return {
            name: "Types",
            properties: {
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$contentTypes_default = $5b7ccabde48fae90$var$contentTypesFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/core.ts
var $5b7ccabde48fae90$var$coreFactory = {
    getTemplate (author) {
        const dt = /* @__PURE__ */ new Date();
        const jsonDate = dt.toJSON();
        return {
            name: "cp:coreProperties",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            cp: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
                            dc: "http://purl.org/dc/elements/1.1/",
                            dcterms: "http://purl.org/dc/terms/",
                            dcmitype: "http://purl.org/dc/dcmitype/",
                            xsi: "http://www.w3.org/2001/XMLSchema-instance"
                        }
                    }
                ]
            },
            children: [
                {
                    name: "dc:creator",
                    textNode: author
                },
                {
                    name: "dc:title",
                    textNode: "Workbook"
                },
                {
                    name: "dcterms:created",
                    properties: {
                        rawMap: {
                            "xsi:type": "dcterms:W3CDTF"
                        }
                    },
                    textNode: jsonDate
                },
                {
                    name: "dcterms:modified",
                    properties: {
                        rawMap: {
                            "xsi:type": "dcterms:W3CDTF"
                        }
                    },
                    textNode: jsonDate
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$core_default = $5b7ccabde48fae90$var$coreFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/drawing.ts
var $5b7ccabde48fae90$var$getAnchor = (name, imageAnchor)=>({
        name: `xdr:${name}`,
        children: [
            {
                name: "xdr:col",
                textNode: imageAnchor.col.toString()
            },
            {
                name: "xdr:colOff",
                textNode: imageAnchor.offsetX.toString()
            },
            {
                name: "xdr:row",
                textNode: imageAnchor.row.toString()
            },
            {
                name: "xdr:rowOff",
                textNode: imageAnchor.offsetY.toString()
            }
        ]
    });
var $5b7ccabde48fae90$var$getExt = (image)=>{
    const children = [
        {
            name: "a:ext",
            properties: {
                rawMap: {
                    uri: "{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}"
                }
            },
            children: [
                {
                    name: "a16:creationId",
                    properties: {
                        rawMap: {
                            id: "{822E6D20-D7BC-2841-A643-D49A6EF008A2}",
                            "xmlns:a16": "http://schemas.microsoft.com/office/drawing/2014/main"
                        }
                    }
                }
            ]
        }
    ];
    const recolor = image.recolor?.toLowerCase();
    switch(recolor){
        case "grayscale":
        case "sepia":
        case "washout":
            children.push({
                name: "a:ext",
                properties: {
                    rawMap: {
                        uri: "{C183D7F6-B498-43B3-948B-1728B52AA6E4}"
                    }
                },
                children: [
                    {
                        name: "adec:decorative",
                        properties: {
                            rawMap: {
                                val: "0",
                                "xmlns:adec": "http://schemas.microsoft.com/office/drawing/2017/decorative"
                            }
                        }
                    }
                ]
            });
    }
    return {
        name: "a:extLst",
        children: children
    };
};
var $5b7ccabde48fae90$var$getNvPicPr = (image, index)=>({
        name: "xdr:nvPicPr",
        children: [
            {
                name: "xdr:cNvPr",
                properties: {
                    rawMap: {
                        id: index,
                        name: image.id,
                        descr: image.altText != null ? image.altText : void 0
                    }
                },
                children: [
                    $5b7ccabde48fae90$var$getExt(image)
                ]
            },
            {
                name: "xdr:cNvPicPr",
                properties: {
                    rawMap: {
                        preferRelativeResize: "0"
                    }
                },
                children: [
                    {
                        name: "a:picLocks"
                    }
                ]
            }
        ]
    });
var $5b7ccabde48fae90$var$getColorDetails = (color)=>{
    if (!color.saturation && !color.tint) return;
    const ret = [];
    if (color.saturation) ret.push({
        name: "a:satMod",
        properties: {
            rawMap: {
                val: color.saturation * 1e3
            }
        }
    });
    if (color.tint) ret.push({
        name: "a:tint",
        properties: {
            rawMap: {
                val: color.tint * 1e3
            }
        }
    });
    return ret;
};
var $5b7ccabde48fae90$var$getDuoTone = (primaryColor, secondaryColor)=>{
    return {
        name: "a:duotone",
        children: [
            {
                name: "a:prstClr",
                properties: {
                    rawMap: {
                        val: primaryColor.color
                    }
                },
                children: $5b7ccabde48fae90$var$getColorDetails(primaryColor)
            },
            {
                name: "a:srgbClr",
                properties: {
                    rawMap: {
                        val: secondaryColor.color
                    }
                },
                children: $5b7ccabde48fae90$var$getColorDetails(secondaryColor)
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getBlipFill = (image, index)=>{
    let blipChildren;
    if (image.transparency) {
        const transparency = Math.min(Math.max(image.transparency, 0), 100);
        blipChildren = [
            {
                name: "a:alphaModFix",
                properties: {
                    rawMap: {
                        amt: 1e5 - Math.round(transparency * 1e3)
                    }
                }
            }
        ];
    }
    if (image.recolor) {
        if (!blipChildren) blipChildren = [];
        switch(image.recolor.toLocaleLowerCase()){
            case "grayscale":
                blipChildren.push({
                    name: "a:grayscl"
                });
                break;
            case "sepia":
                blipChildren.push($5b7ccabde48fae90$var$getDuoTone({
                    color: "black"
                }, {
                    color: "D9C3A5",
                    tint: 50,
                    saturation: 180
                }));
                break;
            case "washout":
                blipChildren.push({
                    name: "a:lum",
                    properties: {
                        rawMap: {
                            bright: "70000",
                            contrast: "-70000"
                        }
                    }
                });
                break;
            default:
        }
    }
    return {
        name: "xdr:blipFill",
        children: [
            {
                name: "a:blip",
                properties: {
                    rawMap: {
                        cstate: "print",
                        "r:embed": `rId${index}`,
                        "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
                    }
                },
                children: blipChildren
            },
            {
                name: "a:stretch",
                children: [
                    {
                        name: "a:fillRect"
                    }
                ]
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getSpPr = (image, imageBoxSize)=>{
    const xfrm = {
        name: "a:xfrm",
        children: [
            {
                name: "a:off",
                properties: {
                    rawMap: {
                        x: 0,
                        y: 0
                    }
                }
            },
            {
                name: "a:ext",
                properties: {
                    rawMap: {
                        cx: imageBoxSize.width,
                        cy: imageBoxSize.height
                    }
                }
            }
        ]
    };
    if (image.rotation) {
        const rotation = image.rotation;
        xfrm.properties = {
            rawMap: {
                rot: Math.min(Math.max(rotation, 0), 360) * 6e4
            }
        };
    }
    const prstGeom = {
        name: "a:prstGeom",
        properties: {
            rawMap: {
                prst: "rect"
            }
        },
        children: [
            {
                name: "a:avLst"
            }
        ]
    };
    const ret = {
        name: "xdr:spPr",
        children: [
            xfrm,
            prstGeom
        ]
    };
    return ret;
};
var $5b7ccabde48fae90$var$getImageBoxSize = (image)=>{
    image.fitCell = !!image.fitCell || !image.width || !image.height;
    const { position: position = {}, fitCell: fitCell, width: width = 0, height: height = 0, totalHeight: totalHeight, totalWidth: totalWidth } = image;
    const { offsetX: offsetX = 0, offsetY: offsetY = 0, row: row = 1, rowSpan: rowSpan = 1, column: column = 1, colSpan: colSpan = 1 } = position;
    return {
        from: {
            row: row - 1,
            col: column - 1,
            offsetX: $5b7ccabde48fae90$var$pixelsToEMU(offsetX),
            offsetY: $5b7ccabde48fae90$var$pixelsToEMU(offsetY)
        },
        to: {
            row: row - 1 + (fitCell ? 1 : rowSpan - 1),
            col: column - 1 + (fitCell ? 1 : colSpan - 1),
            offsetX: $5b7ccabde48fae90$var$pixelsToEMU(width + offsetX),
            offsetY: $5b7ccabde48fae90$var$pixelsToEMU(height + offsetY)
        },
        height: $5b7ccabde48fae90$var$pixelsToEMU(totalHeight || height),
        width: $5b7ccabde48fae90$var$pixelsToEMU(totalWidth || width)
    };
};
var $5b7ccabde48fae90$var$getPicture = (image, currentIndex, worksheetImageIndex, imageBoxSize)=>{
    return {
        name: "xdr:pic",
        children: [
            $5b7ccabde48fae90$var$getNvPicPr(image, currentIndex + 1),
            $5b7ccabde48fae90$var$getBlipFill(image, worksheetImageIndex + 1),
            $5b7ccabde48fae90$var$getSpPr(image, imageBoxSize)
        ]
    };
};
var $5b7ccabde48fae90$var$drawingFactory = {
    getTemplate (config) {
        const { sheetIndex: sheetIndex } = config;
        const sheetImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.get(sheetIndex);
        const sheetImageIds = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS.get(sheetIndex);
        const children = sheetImages.map((image, idx)=>{
            const boxSize = $5b7ccabde48fae90$var$getImageBoxSize(image);
            return {
                name: "xdr:twoCellAnchor",
                properties: {
                    rawMap: {
                        editAs: "absolute"
                    }
                },
                children: [
                    $5b7ccabde48fae90$var$getAnchor("from", boxSize.from),
                    $5b7ccabde48fae90$var$getAnchor("to", boxSize.to),
                    $5b7ccabde48fae90$var$getPicture(image, idx, sheetImageIds.get(image.id).index, boxSize),
                    {
                        name: "xdr:clientData"
                    }
                ]
            };
        });
        return {
            name: "xdr:wsDr",
            properties: {
                rawMap: {
                    "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main",
                    "xmlns:xdr": "http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$drawing_default = $5b7ccabde48fae90$var$drawingFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/relationship.ts
var $5b7ccabde48fae90$var$relationshipFactory = {
    getTemplate (config) {
        const { Id: Id, Type: Type, Target: Target } = config;
        return {
            name: "Relationship",
            properties: {
                rawMap: {
                    Id: Id,
                    Type: Type,
                    Target: Target
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$relationship_default = $5b7ccabde48fae90$var$relationshipFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/relationships.ts
var $5b7ccabde48fae90$var$relationshipsFactory = {
    getTemplate (c) {
        const children = c.map((relationship)=>$5b7ccabde48fae90$var$relationship_default.getTemplate(relationship));
        return {
            name: "Relationships",
            properties: {
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$relationships_default = $5b7ccabde48fae90$var$relationshipsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/sharedStrings.ts
var $5b7ccabde48fae90$var$sharedStrings = {
    getTemplate (strings) {
        return {
            name: "sst",
            properties: {
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    count: strings.size,
                    uniqueCount: strings.size
                }
            },
            children: $5b7ccabde48fae90$var$buildSharedString(strings)
        };
    }
};
var $5b7ccabde48fae90$var$sharedStrings_default = $5b7ccabde48fae90$var$sharedStrings;
// packages/ag-grid-enterprise/src/excelExport/assets/excelLegacyConvert.ts
var $5b7ccabde48fae90$var$getWeightName = (value)=>{
    switch(value){
        case 1:
            return "thin";
        case 2:
            return "medium";
        case 3:
            return "thick";
        default:
            return "hair";
    }
};
var $5b7ccabde48fae90$var$mappedBorderNames = {
    None: "None",
    Dot: "Dotted",
    Dash: "Dashed",
    Double: "Double",
    DashDot: "DashDot",
    DashDotDot: "DashDotDot",
    SlantDashDot: "SlantDashDot",
    Continuous: "Continuous"
};
var $5b7ccabde48fae90$var$mediumBorders = [
    "Dashed",
    "DashDot",
    "DashDotDot"
];
var $5b7ccabde48fae90$var$colorMap = {
    None: "none",
    Solid: "solid",
    Gray50: "mediumGray",
    Gray75: "darkGray",
    Gray25: "lightGray",
    HorzStripe: "darkHorizontal",
    VertStripe: "darkVertical",
    ReverseDiagStripe: "darkDown",
    DiagStripe: "darkUp",
    DiagCross: "darkGrid",
    ThickDiagCross: "darkTrellis",
    ThinHorzStripe: "lightHorizontal",
    ThinVertStripe: "lightVertical",
    ThinReverseDiagStripe: "lightDown",
    ThinDiagStripe: "lightUp",
    ThinHorzCross: "lightGrid",
    ThinDiagCross: "lightTrellis",
    Gray125: "gray125",
    Gray0625: "gray0625"
};
var $5b7ccabde48fae90$var$horizontalAlignmentMap = {
    Automatic: "general",
    Left: "left",
    Center: "center",
    Right: "right",
    Fill: "fill",
    Justify: "justify",
    CenterAcrossSelection: "centerContinuous",
    Distributed: "distributed",
    JustifyDistributed: "justify"
};
var $5b7ccabde48fae90$var$verticalAlignmentMap = {
    Automatic: void 0,
    Top: "top",
    Bottom: "bottom",
    Center: "center",
    Justify: "justify",
    Distributed: "distributed",
    JustifyDistributed: "justify"
};
var $5b7ccabde48fae90$var$convertLegacyPattern = (name)=>{
    if (!name) return "none";
    return $5b7ccabde48fae90$var$colorMap[name] || name;
};
var $5b7ccabde48fae90$var$convertLegacyColor = (color)=>{
    if (color == void 0) return color;
    if (color.charAt(0) === "#") color = color.substring(1);
    return color.length === 6 ? "FF" + color : color;
};
var $5b7ccabde48fae90$var$convertLegacyBorder = (type, weight)=>{
    if (!type) return "thin";
    const namedWeight = $5b7ccabde48fae90$var$getWeightName(weight);
    if (type === "Continuous") return namedWeight;
    const mappedName = $5b7ccabde48fae90$var$mappedBorderNames[type];
    if (namedWeight === "medium" && $5b7ccabde48fae90$var$mediumBorders.some((type2)=>type2 === mappedName)) return `medium${mappedName}`;
    return `${mappedName.charAt(0).toLowerCase()}${mappedName.substring(1)}`;
};
var $5b7ccabde48fae90$var$convertLegacyHorizontalAlignment = (alignment)=>{
    return $5b7ccabde48fae90$var$horizontalAlignmentMap[alignment] || "general";
};
var $5b7ccabde48fae90$var$convertLegacyVerticalAlignment = (alignment)=>{
    return $5b7ccabde48fae90$var$verticalAlignmentMap[alignment] || void 0;
};
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/border.ts
var $5b7ccabde48fae90$var$getBorderColor = (color)=>{
    return {
        name: "color",
        properties: {
            rawMap: {
                rgb: $5b7ccabde48fae90$var$convertLegacyColor(color || "#000000")
            }
        }
    };
};
var $5b7ccabde48fae90$var$borderFactory = {
    getTemplate (border) {
        const { left: left, right: right, top: top, bottom: bottom, diagonal: diagonal } = border;
        const leftChildren = left ? [
            $5b7ccabde48fae90$var$getBorderColor(left.color)
        ] : void 0;
        const rightChildren = right ? [
            $5b7ccabde48fae90$var$getBorderColor(right.color)
        ] : void 0;
        const topChildren = top ? [
            $5b7ccabde48fae90$var$getBorderColor(top.color)
        ] : void 0;
        const bottomChildren = bottom ? [
            $5b7ccabde48fae90$var$getBorderColor(bottom.color)
        ] : void 0;
        const diagonalChildren = diagonal ? [
            $5b7ccabde48fae90$var$getBorderColor(diagonal.color)
        ] : void 0;
        return {
            name: "border",
            children: [
                {
                    name: "left",
                    properties: {
                        rawMap: {
                            style: left?.style
                        }
                    },
                    children: leftChildren
                },
                {
                    name: "right",
                    properties: {
                        rawMap: {
                            style: right?.style
                        }
                    },
                    children: rightChildren
                },
                {
                    name: "top",
                    properties: {
                        rawMap: {
                            style: top?.style
                        }
                    },
                    children: topChildren
                },
                {
                    name: "bottom",
                    properties: {
                        rawMap: {
                            style: bottom?.style
                        }
                    },
                    children: bottomChildren
                },
                {
                    name: "diagonal",
                    properties: {
                        rawMap: {
                            style: diagonal?.style
                        }
                    },
                    children: diagonalChildren
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$border_default = $5b7ccabde48fae90$var$borderFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/borders.ts
var $5b7ccabde48fae90$var$bordersFactory = {
    getTemplate (borders) {
        return {
            name: "borders",
            properties: {
                rawMap: {
                    count: borders.length
                }
            },
            children: borders.map((border)=>$5b7ccabde48fae90$var$border_default.getTemplate(border))
        };
    }
};
var $5b7ccabde48fae90$var$borders_default = $5b7ccabde48fae90$var$bordersFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/alignment.ts
var $5b7ccabde48fae90$var$getReadingOrderId = (readingOrder)=>{
    const order = [
        "Context",
        "LeftToRight",
        "RightToLeft"
    ];
    const pos = order.indexOf(readingOrder);
    return Math.max(pos, 0);
};
var $5b7ccabde48fae90$var$alignmentFactory = {
    getTemplate (alignment) {
        const { horizontal: horizontal, indent: indent, readingOrder: readingOrder, rotate: rotate, shrinkToFit: shrinkToFit, vertical: vertical, wrapText: wrapText } = alignment;
        return {
            name: "alignment",
            properties: {
                rawMap: {
                    horizontal: horizontal && $5b7ccabde48fae90$var$convertLegacyHorizontalAlignment(horizontal),
                    indent: indent,
                    readingOrder: readingOrder && $5b7ccabde48fae90$var$getReadingOrderId(readingOrder),
                    textRotation: rotate,
                    shrinkToFit: shrinkToFit,
                    vertical: vertical && $5b7ccabde48fae90$var$convertLegacyVerticalAlignment(vertical),
                    wrapText: wrapText
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$alignment_default = $5b7ccabde48fae90$var$alignmentFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/protection.ts
var $5b7ccabde48fae90$var$protectionFactory = {
    getTemplate (protection) {
        const locked = protection.protected === false ? 0 : 1;
        const hidden = protection.hideFormula === true ? 1 : 0;
        return {
            name: "protection",
            properties: {
                rawMap: {
                    hidden: hidden,
                    locked: locked
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$protection_default = $5b7ccabde48fae90$var$protectionFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/xf.ts
var $5b7ccabde48fae90$var$xfFactory = {
    getTemplate (xf) {
        const { alignment: alignment, borderId: borderId, fillId: fillId, fontId: fontId, numFmtId: numFmtId, protection: protection, quotePrefix: quotePrefix, xfId: xfId } = xf;
        const children = [];
        if (alignment) children.push($5b7ccabde48fae90$var$alignment_default.getTemplate(alignment));
        if (protection) children.push($5b7ccabde48fae90$var$protection_default.getTemplate(protection));
        return {
            name: "xf",
            properties: {
                rawMap: {
                    applyAlignment: alignment ? 1 : void 0,
                    applyProtection: protection ? 1 : void 0,
                    applyBorder: borderId ? 1 : void 0,
                    applyFill: fillId ? 1 : void 0,
                    borderId: borderId,
                    fillId: fillId,
                    applyFont: fontId ? 1 : void 0,
                    fontId: fontId,
                    applyNumberFormat: numFmtId ? 1 : void 0,
                    numFmtId: numFmtId,
                    quotePrefix: quotePrefix ? 1 : void 0,
                    xfId: xfId
                }
            },
            children: children.length ? children : void 0
        };
    }
};
var $5b7ccabde48fae90$var$xf_default = $5b7ccabde48fae90$var$xfFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/cellStyleXfs.ts
var $5b7ccabde48fae90$var$cellStylesXfsFactory = {
    getTemplate (xfs) {
        return {
            name: "cellStyleXfs",
            properties: {
                rawMap: {
                    count: xfs.length
                }
            },
            children: xfs.map((xf)=>$5b7ccabde48fae90$var$xf_default.getTemplate(xf))
        };
    }
};
var $5b7ccabde48fae90$var$cellStyleXfs_default = $5b7ccabde48fae90$var$cellStylesXfsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/cellStyle.ts
var $5b7ccabde48fae90$var$borderFactory2 = {
    getTemplate (cellStyle) {
        const { builtinId: builtinId, name: name, xfId: xfId } = cellStyle;
        return {
            name: "cellStyle",
            properties: {
                rawMap: {
                    builtinId: builtinId,
                    name: name,
                    xfId: xfId
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$cellStyle_default = $5b7ccabde48fae90$var$borderFactory2;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/cellStyles.ts
var $5b7ccabde48fae90$var$cellStylesFactory = {
    getTemplate (cellStyles) {
        return {
            name: "cellStyles",
            properties: {
                rawMap: {
                    count: cellStyles.length
                }
            },
            children: cellStyles.map((cellStyle)=>$5b7ccabde48fae90$var$cellStyle_default.getTemplate(cellStyle))
        };
    }
};
var $5b7ccabde48fae90$var$cellStyles_default = $5b7ccabde48fae90$var$cellStylesFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/cellXfs.ts
var $5b7ccabde48fae90$var$cellXfsFactory = {
    getTemplate (xfs) {
        return {
            name: "cellXfs",
            properties: {
                rawMap: {
                    count: xfs.length
                }
            },
            children: xfs.map((xf)=>$5b7ccabde48fae90$var$xf_default.getTemplate(xf))
        };
    }
};
var $5b7ccabde48fae90$var$cellXfs_default = $5b7ccabde48fae90$var$cellXfsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/fill.ts
var $5b7ccabde48fae90$var$fillFactory = {
    getTemplate (fill) {
        const { patternType: patternType, fgTheme: fgTheme, fgTint: fgTint, fgRgb: fgRgb, bgRgb: bgRgb, bgIndexed: bgIndexed } = fill;
        const pf = {
            name: "patternFill",
            properties: {
                rawMap: {
                    patternType: patternType
                }
            }
        };
        if (fgTheme || fgTint || fgRgb) pf.children = [
            {
                name: "fgColor",
                properties: {
                    rawMap: {
                        theme: fgTheme,
                        tint: fgTint,
                        rgb: fgRgb
                    }
                }
            }
        ];
        if (bgIndexed || bgRgb) {
            if (!pf.children) pf.children = [];
            pf.children.push({
                name: "bgColor",
                properties: {
                    rawMap: {
                        indexed: bgIndexed,
                        rgb: bgRgb
                    }
                }
            });
        }
        return {
            name: "fill",
            children: [
                pf
            ]
        };
    }
};
var $5b7ccabde48fae90$var$fill_default = $5b7ccabde48fae90$var$fillFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/fills.ts
var $5b7ccabde48fae90$var$fillsFactory = {
    getTemplate (fills) {
        return {
            name: "fills",
            properties: {
                rawMap: {
                    count: fills.length
                }
            },
            children: fills.map((fill)=>$5b7ccabde48fae90$var$fill_default.getTemplate(fill))
        };
    }
};
var $5b7ccabde48fae90$var$fills_default = $5b7ccabde48fae90$var$fillsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/font.ts
var $5b7ccabde48fae90$var$fontFactory = {
    getTemplate (font) {
        const { size: size, colorTheme: colorTheme, color: color = "FF000000", fontName: fontName = "Calibri", family: family, scheme: scheme, italic: italic, bold: bold, strikeThrough: strikeThrough, outline: outline, shadow: shadow2, underline: underline, verticalAlign: verticalAlign } = font;
        const children = [
            {
                name: "sz",
                properties: {
                    rawMap: {
                        val: size
                    }
                }
            },
            {
                name: "color",
                properties: {
                    rawMap: {
                        theme: colorTheme,
                        rgb: color
                    }
                }
            },
            {
                name: "name",
                properties: {
                    rawMap: {
                        val: fontName
                    }
                }
            }
        ];
        if (family) children.push({
            name: "family",
            properties: {
                rawMap: {
                    val: family
                }
            }
        });
        if (scheme) children.push({
            name: "scheme",
            properties: {
                rawMap: {
                    val: scheme
                }
            }
        });
        if (italic) children.push({
            name: "i"
        });
        if (bold) children.push({
            name: "b"
        });
        if (strikeThrough) children.push({
            name: "strike"
        });
        if (outline) children.push({
            name: "outline"
        });
        if (shadow2) children.push({
            name: "shadow"
        });
        if (underline) children.push({
            name: "u",
            properties: {
                rawMap: {
                    val: underline
                }
            }
        });
        if (verticalAlign) children.push({
            name: "vertAlign",
            properties: {
                rawMap: {
                    val: verticalAlign
                }
            }
        });
        return {
            name: "font",
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$font_default = $5b7ccabde48fae90$var$fontFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/fonts.ts
var $5b7ccabde48fae90$var$fontsFactory = {
    getTemplate (fonts) {
        return {
            name: "fonts",
            properties: {
                rawMap: {
                    count: fonts.length
                }
            },
            children: fonts.map((font)=>$5b7ccabde48fae90$var$font_default.getTemplate(font))
        };
    }
};
var $5b7ccabde48fae90$var$fonts_default = $5b7ccabde48fae90$var$fontsFactory;
function $5b7ccabde48fae90$var$prepareString(str) {
    const split = str.split(/(\[[^\]]*\])/);
    for(let i = 0; i < split.length; i++){
        let currentString = split[i];
        if (!currentString.length) continue;
        if (!currentString.startsWith("[")) currentString = currentString.replace(/\$/g, '"$"');
        split[i] = (0, $437b23f6a393c3bf$export$3df06b741968da82)(currentString);
    }
    return split.join("");
}
var $5b7ccabde48fae90$var$numberFormatFactory = {
    getTemplate (numberFormat) {
        let { formatCode: formatCode, numFmtId: numFmtId } = numberFormat;
        if (formatCode.length) formatCode = $5b7ccabde48fae90$var$prepareString(formatCode);
        return {
            name: "numFmt",
            properties: {
                rawMap: {
                    formatCode: formatCode,
                    numFmtId: numFmtId
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$numberFormat_default = $5b7ccabde48fae90$var$numberFormatFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/numberFormats.ts
var $5b7ccabde48fae90$var$numberFormatsFactory = {
    getTemplate (numberFormats) {
        return {
            name: "numFmts",
            properties: {
                rawMap: {
                    count: numberFormats.length
                }
            },
            children: numberFormats.map((numberFormat)=>$5b7ccabde48fae90$var$numberFormat_default.getTemplate(numberFormat))
        };
    }
};
var $5b7ccabde48fae90$var$numberFormats_default = $5b7ccabde48fae90$var$numberFormatsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/styles/stylesheet.ts
var $5b7ccabde48fae90$var$stylesMap;
var $5b7ccabde48fae90$var$registeredNumberFmts;
var $5b7ccabde48fae90$var$registeredFonts;
var $5b7ccabde48fae90$var$registeredFills;
var $5b7ccabde48fae90$var$registeredBorders;
var $5b7ccabde48fae90$var$registeredCellStyleXfs;
var $5b7ccabde48fae90$var$registeredCellXfs;
var $5b7ccabde48fae90$var$registeredCellStyles;
var $5b7ccabde48fae90$var$currentSheet;
var $5b7ccabde48fae90$var$getStyleName = (name, currentSheet2)=>{
    if (name.includes("mixedStyle") && currentSheet2 > 1) name += `_${currentSheet2}`;
    return name;
};
var $5b7ccabde48fae90$var$resetStylesheetValues = ()=>{
    $5b7ccabde48fae90$var$stylesMap = {
        base: 0
    };
    $5b7ccabde48fae90$var$registeredNumberFmts = [];
    $5b7ccabde48fae90$var$registeredFonts = [
        {
            fontName: "Calibri",
            colorTheme: "1",
            family: "2",
            scheme: "minor"
        }
    ];
    $5b7ccabde48fae90$var$registeredFills = [
        {
            patternType: "none"
        },
        {
            patternType: "gray125"
        }
    ];
    $5b7ccabde48fae90$var$registeredBorders = [
        {
            left: void 0,
            right: void 0,
            top: void 0,
            bottom: void 0,
            diagonal: void 0
        }
    ];
    $5b7ccabde48fae90$var$registeredCellStyleXfs = [
        {
            borderId: 0,
            fillId: 0,
            fontId: 0,
            numFmtId: 0
        }
    ];
    $5b7ccabde48fae90$var$registeredCellXfs = [
        {
            borderId: 0,
            fillId: 0,
            fontId: 0,
            numFmtId: 0,
            xfId: 0
        }
    ];
    $5b7ccabde48fae90$var$registeredCellStyles = [
        {
            builtinId: 0,
            name: "Normal",
            xfId: 0
        }
    ];
};
var $5b7ccabde48fae90$var$registerFill = (fill)=>{
    const convertedPattern = $5b7ccabde48fae90$var$convertLegacyPattern(fill.pattern);
    const convertedFillColor = $5b7ccabde48fae90$var$convertLegacyColor(fill.color);
    const convertedPatternColor = $5b7ccabde48fae90$var$convertLegacyColor(fill.patternColor);
    let pos = $5b7ccabde48fae90$var$registeredFills.findIndex((currentFill)=>{
        const { patternType: patternType, fgRgb: fgRgb, bgRgb: bgRgb } = currentFill;
        return !(patternType != convertedPattern || fgRgb != convertedFillColor || bgRgb != convertedPatternColor);
    });
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredFills.length;
        $5b7ccabde48fae90$var$registeredFills.push({
            patternType: convertedPattern,
            fgRgb: convertedFillColor,
            bgRgb: convertedPatternColor
        });
    }
    return pos;
};
var $5b7ccabde48fae90$var$registerNumberFmt = (format)=>{
    if ($5b7ccabde48fae90$var$numberFormatMap[format]) return $5b7ccabde48fae90$var$numberFormatMap[format];
    let pos = $5b7ccabde48fae90$var$registeredNumberFmts.findIndex((currentFormat)=>currentFormat.formatCode === format);
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredNumberFmts.length + 164;
        $5b7ccabde48fae90$var$registeredNumberFmts.push({
            formatCode: format,
            numFmtId: pos
        });
    } else pos = $5b7ccabde48fae90$var$registeredNumberFmts[pos].numFmtId;
    return pos;
};
var $5b7ccabde48fae90$var$registerBorders = (borders)=>{
    const { borderBottom: borderBottom, borderTop: borderTop, borderLeft: borderLeft, borderRight: borderRight } = borders;
    let bottomStyle;
    let topStyle;
    let leftStyle;
    let rightStyle;
    let bottomColor;
    let topColor;
    let leftColor;
    let rightColor;
    if (borderLeft) {
        leftStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderLeft.lineStyle, borderLeft.weight);
        leftColor = $5b7ccabde48fae90$var$convertLegacyColor(borderLeft.color);
    }
    if (borderRight) {
        rightStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderRight.lineStyle, borderRight.weight);
        rightColor = $5b7ccabde48fae90$var$convertLegacyColor(borderRight.color);
    }
    if (borderBottom) {
        bottomStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderBottom.lineStyle, borderBottom.weight);
        bottomColor = $5b7ccabde48fae90$var$convertLegacyColor(borderBottom.color);
    }
    if (borderTop) {
        topStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderTop.lineStyle, borderTop.weight);
        topColor = $5b7ccabde48fae90$var$convertLegacyColor(borderTop.color);
    }
    let pos = $5b7ccabde48fae90$var$registeredBorders.findIndex((currentBorder)=>{
        const { left: left, right: right, top: top, bottom: bottom } = currentBorder;
        if (!left && (leftStyle || leftColor)) return false;
        if (!right && (rightStyle || rightColor)) return false;
        if (!top && (topStyle || topColor)) return false;
        if (!bottom && (bottomStyle || bottomColor)) return false;
        const { style: clS, color: clC } = left || {};
        const { style: crS, color: crC } = right || {};
        const { style: ctS, color: ctC } = top || {};
        const { style: cbS, color: cbC } = bottom || {};
        if (clS != leftStyle || clC != leftColor) return false;
        if (crS != rightStyle || crC != rightColor) return false;
        if (ctS != topStyle || ctC != topColor) return false;
        if (cbS != bottomStyle || cbC != bottomColor) return false;
        return true;
    });
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredBorders.length;
        $5b7ccabde48fae90$var$registeredBorders.push({
            left: {
                style: leftStyle,
                color: leftColor
            },
            right: {
                style: rightStyle,
                color: rightColor
            },
            top: {
                style: topStyle,
                color: topColor
            },
            bottom: {
                style: bottomStyle,
                color: bottomColor
            },
            diagonal: {
                style: void 0,
                color: void 0
            }
        });
    }
    return pos;
};
var $5b7ccabde48fae90$var$registerFont = (font)=>{
    const { fontName: name = "Calibri", color: color, size: size, bold: bold, italic: italic, outline: outline, shadow: shadow2, strikeThrough: strikeThrough, underline: underline, family: family, verticalAlign: verticalAlign } = font;
    const convertedColor = $5b7ccabde48fae90$var$convertLegacyColor(color);
    const familyId = $5b7ccabde48fae90$var$getFontFamilyId(family);
    const convertedUnderline = underline ? underline.toLocaleLowerCase() : void 0;
    const convertedVerticalAlign = verticalAlign ? verticalAlign.toLocaleLowerCase() : void 0;
    let pos = $5b7ccabde48fae90$var$registeredFonts.findIndex((currentFont)=>{
        return !(currentFont.fontName != name || currentFont.color != convertedColor || currentFont.size != size || currentFont.bold != bold || currentFont.italic != italic || currentFont.outline != outline || currentFont.shadow != shadow2 || currentFont.strikeThrough != strikeThrough || currentFont.underline != convertedUnderline || currentFont.verticalAlign != convertedVerticalAlign || currentFont.family != familyId);
    });
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredFonts.length;
        $5b7ccabde48fae90$var$registeredFonts.push({
            fontName: name,
            color: convertedColor,
            size: size,
            bold: bold,
            italic: italic,
            outline: outline,
            shadow: shadow2,
            strikeThrough: strikeThrough,
            underline: convertedUnderline,
            verticalAlign: convertedVerticalAlign,
            family: familyId != null ? familyId.toString() : void 0
        });
    }
    return pos;
};
var $5b7ccabde48fae90$var$registerStyle = (config)=>{
    const { alignment: alignment, borders: borders, font: font, interior: interior, numberFormat: numberFormat, protection: protection, quotePrefix: quotePrefix } = config;
    let { id: id } = config;
    let currentFill = 0;
    let currentBorder = 0;
    let currentFont = 0;
    let currentNumberFmt = 0;
    if (!id) return;
    id = $5b7ccabde48fae90$var$getStyleName(id, $5b7ccabde48fae90$var$currentSheet);
    if ($5b7ccabde48fae90$var$stylesMap[id] != void 0) return;
    if (interior) currentFill = $5b7ccabde48fae90$var$registerFill(interior);
    if (borders) currentBorder = $5b7ccabde48fae90$var$registerBorders(borders);
    if (font) currentFont = $5b7ccabde48fae90$var$registerFont(font);
    if (numberFormat) currentNumberFmt = $5b7ccabde48fae90$var$registerNumberFmt(numberFormat.format);
    $5b7ccabde48fae90$var$stylesMap[id] = $5b7ccabde48fae90$var$registeredCellXfs.length;
    $5b7ccabde48fae90$var$registeredCellXfs.push({
        alignment: alignment,
        borderId: currentBorder || 0,
        fillId: currentFill || 0,
        fontId: currentFont || 0,
        numFmtId: currentNumberFmt || 0,
        protection: protection,
        quotePrefix: quotePrefix,
        xfId: 0
    });
};
var $5b7ccabde48fae90$var$stylesheetFactory = {
    getTemplate (defaultFontSize) {
        const numberFormats = $5b7ccabde48fae90$var$numberFormats_default.getTemplate($5b7ccabde48fae90$var$registeredNumberFmts);
        const fonts = $5b7ccabde48fae90$var$fonts_default.getTemplate($5b7ccabde48fae90$var$registeredFonts.map((font)=>({
                ...font,
                size: font.size != null ? font.size : defaultFontSize
            })));
        const fills = $5b7ccabde48fae90$var$fills_default.getTemplate($5b7ccabde48fae90$var$registeredFills);
        const borders = $5b7ccabde48fae90$var$borders_default.getTemplate($5b7ccabde48fae90$var$registeredBorders);
        const cellStylesXfs = $5b7ccabde48fae90$var$cellStyleXfs_default.getTemplate($5b7ccabde48fae90$var$registeredCellStyleXfs);
        const cellXfs = $5b7ccabde48fae90$var$cellXfs_default.getTemplate($5b7ccabde48fae90$var$registeredCellXfs);
        const cellStyles = $5b7ccabde48fae90$var$cellStyles_default.getTemplate($5b7ccabde48fae90$var$registeredCellStyles);
        $5b7ccabde48fae90$var$resetStylesheetValues();
        return {
            name: "styleSheet",
            properties: {
                rawMap: {
                    "mc:Ignorable": "x14ac x16r2 xr",
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac",
                    "xmlns:x16r2": "http://schemas.microsoft.com/office/spreadsheetml/2015/02/main",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision"
                }
            },
            children: [
                numberFormats,
                fonts,
                fills,
                borders,
                cellStylesXfs,
                cellXfs,
                cellStyles,
                {
                    name: "tableStyles",
                    properties: {
                        rawMap: {
                            count: 0,
                            defaultPivotStyle: "PivotStyleLight16",
                            defaultTableStyle: "TableStyleMedium2"
                        }
                    }
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$getStyleId = (name, currentSheet2)=>{
    return $5b7ccabde48fae90$var$stylesMap[$5b7ccabde48fae90$var$getStyleName(name, currentSheet2)] || 0;
};
var $5b7ccabde48fae90$var$registerStyles = (styles, _currentSheet)=>{
    $5b7ccabde48fae90$var$currentSheet = _currentSheet;
    if ($5b7ccabde48fae90$var$currentSheet === 1) $5b7ccabde48fae90$var$resetStylesheetValues();
    styles.forEach($5b7ccabde48fae90$var$registerStyle);
};
var $5b7ccabde48fae90$var$stylesheet_default = $5b7ccabde48fae90$var$stylesheetFactory;
var $5b7ccabde48fae90$var$tableFactory = {
    getTemplate (dataTable, idx) {
        const { name: name, columns: columns, rowRange: rowRange, displayName: displayName, showRowStripes: showRowStripes, showColumnStripes: showColumnStripes, showFilterButtons: showFilterButtons, highlightFirstColumn: highlightFirstColumn, highlightLastColumn: highlightLastColumn } = dataTable || {};
        const noRows = !rowRange || rowRange[0] - rowRange[1] === 0;
        if (!dataTable || !name || !Array.isArray(columns) || !columns.length || noRows) return {
            name: "table"
        };
        const filterColumns = columns.map((col, idx2)=>({
                name: "filterColumn",
                properties: {
                    rawMap: {
                        colId: idx2.toString(),
                        // For filters, this should start with 0
                        hiddenButton: showFilterButtons[idx2] ? 0 : 1
                    }
                }
            }));
        const firstCell = `A${rowRange[0]}`;
        const lastCell = `${$5b7ccabde48fae90$var$getExcelColumnName(columns.length)}${rowRange[1]}`;
        const ref = `${firstCell}:${lastCell}`;
        const id = `${idx + 1}`;
        const displayNameToUse = idx ? `${displayName}_${id}` : displayName;
        return {
            name: "table",
            properties: {
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "xr xr3",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision",
                    "xmlns:xr3": "http://schemas.microsoft.com/office/spreadsheetml/2016/revision3",
                    name: displayNameToUse,
                    displayName: displayNameToUse,
                    ref: ref,
                    totalsRowShown: 0,
                    id: id
                }
            },
            children: [
                {
                    name: "autoFilter",
                    properties: {
                        rawMap: {
                            ref: ref
                        }
                    },
                    children: filterColumns
                },
                {
                    name: "tableColumns",
                    properties: {
                        rawMap: {
                            count: columns.length
                        }
                    },
                    children: columns.map((col, idx2)=>({
                            name: "tableColumn",
                            properties: {
                                rawMap: {
                                    id: (idx2 + 1).toString(),
                                    name: (0, $437b23f6a393c3bf$export$3df06b741968da82)($5b7ccabde48fae90$var$sanitizeTableName(col)),
                                    dataCellStyle: "Normal"
                                }
                            }
                        }))
                },
                {
                    name: "tableStyleInfo",
                    properties: {
                        rawMap: {
                            name: "TableStyleLight1",
                            showFirstColumn: highlightFirstColumn ? 1 : 0,
                            showLastColumn: highlightLastColumn ? 1 : 0,
                            showRowStripes: showRowStripes ? 1 : 0,
                            showColumnStripes: showColumnStripes ? 1 : 0
                        }
                    }
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$table_default = $5b7ccabde48fae90$var$tableFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/themes/office/colorScheme.ts
var $5b7ccabde48fae90$var$getColorChildren = (props)=>{
    const [type, innerType, val, lastClr] = props;
    return {
        name: `a:${type}`,
        children: [
            {
                name: `a:${innerType}`,
                properties: {
                    rawMap: {
                        val: val,
                        lastClr: lastClr
                    }
                }
            }
        ]
    };
};
var $5b7ccabde48fae90$var$colorScheme = {
    getTemplate () {
        return {
            name: "a:clrScheme",
            properties: {
                rawMap: {
                    name: "Office"
                }
            },
            children: [
                $5b7ccabde48fae90$var$getColorChildren([
                    "dk1",
                    "sysClr",
                    "windowText",
                    "000000"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "lt1",
                    "sysClr",
                    "window",
                    "FFFFFF"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "dk2",
                    "srgbClr",
                    "44546A"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "lt2",
                    "srgbClr",
                    "E7E6E6"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent1",
                    "srgbClr",
                    "4472C4"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent2",
                    "srgbClr",
                    "ED7D31"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent3",
                    "srgbClr",
                    "A5A5A5"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent4",
                    "srgbClr",
                    "FFC000"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent5",
                    "srgbClr",
                    "5B9BD5"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent6",
                    "srgbClr",
                    "70AD47"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "hlink",
                    "srgbClr",
                    "0563C1"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "folHlink",
                    "srgbClr",
                    "954F72"
                ])
            ]
        };
    }
};
var $5b7ccabde48fae90$var$colorScheme_default = $5b7ccabde48fae90$var$colorScheme;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/themes/office/fontScheme.ts
var $5b7ccabde48fae90$var$getFont = (props)=>{
    const [type, typeface, script, panose] = props;
    return {
        name: `a:${type}`,
        properties: {
            rawMap: {
                script: script,
                typeface: typeface,
                panose: panose
            }
        }
    };
};
var $5b7ccabde48fae90$var$fontScheme = {
    getTemplate () {
        return {
            name: "a:fontScheme",
            properties: {
                rawMap: {
                    name: "Office"
                }
            },
            children: [
                {
                    name: "a:majorFont",
                    children: [
                        $5b7ccabde48fae90$var$getFont([
                            "latin",
                            "Calibri Light",
                            void 0,
                            "020F0302020204030204"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "ea",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "cs",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u6E38\u30B4\u30B7\u30C3\u30AF Light",
                            "Jpan"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\uB9D1\uC740 \uACE0\uB515",
                            "Hang"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u7B49\u7EBF Light",
                            "Hans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u65B0\u7D30\u660E\u9AD4",
                            "Hant"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Times New Roman",
                            "Arab"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Times New Roman",
                            "Hebr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tahoma",
                            "Thai"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nyala",
                            "Ethi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Vrinda",
                            "Beng"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Shruti",
                            "Gujr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "MoolBoran",
                            "Khmr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tunga",
                            "Knda"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Raavi",
                            "Guru"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Euphemia",
                            "Cans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Plantagenet Cherokee",
                            "Cher"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Yi Baiti",
                            "Yiii"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Himalaya",
                            "Tibt"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "MV Boli",
                            "Thaa"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mangal",
                            "Deva"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Gautami",
                            "Telu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Latha",
                            "Taml"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrc"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kalinga",
                            "Orya"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kartika",
                            "Mlym"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "DokChampa",
                            "Laoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Iskoola Pota",
                            "Sinh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mongolian Baiti",
                            "Mong"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Times New Roman",
                            "Viet"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Uighur",
                            "Uigh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Sylfaen",
                            "Geor"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Armn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Leelawadee UI",
                            "Bugi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft JhengHei",
                            "Bopo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Javanese Text",
                            "Java"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Segoe UI",
                            "Lisu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Myanmar Text",
                            "Mymr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Nkoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Olck"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Osma"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Phagspa",
                            "Phag"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrj"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syre"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Sora"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Tai Le",
                            "Tale"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft New Tai Lue",
                            "Talu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Tfng"
                        ])
                    ]
                },
                {
                    name: "a:minorFont",
                    children: [
                        $5b7ccabde48fae90$var$getFont([
                            "latin",
                            "Calibri",
                            void 0,
                            "020F0502020204030204"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "ea",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "cs",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u6E38\u30B4\u30B7\u30C3\u30AF",
                            "Jpan"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\uB9D1\uC740 \uACE0\uB515",
                            "Hang"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u7B49\u7EBF",
                            "Hans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u65B0\u7D30\u660E\u9AD4",
                            "Hant"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Arab"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Hebr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tahoma",
                            "Thai"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nyala",
                            "Ethi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Vrinda",
                            "Beng"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Shruti",
                            "Gujr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "DaunPenh",
                            "Khmr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tunga",
                            "Knda"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Raavi",
                            "Guru"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Euphemia",
                            "Cans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Plantagenet Cherokee",
                            "Cher"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Yi Baiti",
                            "Yiii"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Himalaya",
                            "Tibt"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "MV Boli",
                            "Thaa"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mangal",
                            "Deva"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Gautami",
                            "Telu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Latha",
                            "Taml"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrc"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kalinga",
                            "Orya"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kartika",
                            "Mlym"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "DokChampa",
                            "Laoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Iskoola Pota",
                            "Sinh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mongolian Baiti",
                            "Mong"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Viet"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Uighur",
                            "Uigh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Sylfaen",
                            "Geor"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Armn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Leelawadee UI",
                            "Bugi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft JhengHei",
                            "Bopo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Javanese Text",
                            "Java"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Segoe UI",
                            "Lisu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Myanmar Text",
                            "Mymr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Nkoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Olck"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Osma"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Phagspa",
                            "Phag"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrj"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syre"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Sora"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Tai Le",
                            "Tale"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft New Tai Lue",
                            "Talu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Tfng"
                        ])
                    ]
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$fontScheme_default = $5b7ccabde48fae90$var$fontScheme;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/themes/office/formatScheme.ts
var $5b7ccabde48fae90$var$getPropertyVal = (name, val, children)=>({
        name: `a:${name}`,
        properties: {
            rawMap: {
                val: val
            }
        },
        children: children
    });
var $5b7ccabde48fae90$var$getGs = (props)=>{
    const [pos, schemeColor, satMod, lumMod, tint, shade] = props;
    const children = [];
    children.push($5b7ccabde48fae90$var$getPropertyVal("satMod", satMod));
    if (lumMod) children.push($5b7ccabde48fae90$var$getPropertyVal("lumMod", lumMod));
    if (tint) children.push($5b7ccabde48fae90$var$getPropertyVal("tint", tint));
    if (shade) children.push($5b7ccabde48fae90$var$getPropertyVal("shade", shade));
    return {
        name: "a:gs",
        properties: {
            rawMap: {
                pos: pos
            }
        },
        children: [
            {
                name: "a:schemeClr",
                properties: {
                    rawMap: {
                        val: schemeColor
                    }
                },
                children: children
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getSolidFill = (val, children)=>({
        name: "a:solidFill",
        children: [
            $5b7ccabde48fae90$var$getPropertyVal("schemeClr", val, children)
        ]
    });
var $5b7ccabde48fae90$var$getGradFill = (props)=>{
    const [rotWithShape, gs1, gs2, gs3, lin] = props;
    const [ang, scaled] = lin;
    return {
        name: "a:gradFill",
        properties: {
            rawMap: {
                rotWithShape: rotWithShape
            }
        },
        children: [
            {
                name: "a:gsLst",
                children: [
                    $5b7ccabde48fae90$var$getGs(gs1),
                    $5b7ccabde48fae90$var$getGs(gs2),
                    $5b7ccabde48fae90$var$getGs(gs3)
                ]
            },
            {
                name: "a:lin",
                properties: {
                    rawMap: {
                        ang: ang,
                        scaled: scaled
                    }
                }
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getLine = (props)=>{
    const [w, cap, cmpd, algn] = props;
    return {
        name: "a:ln",
        properties: {
            rawMap: {
                w: w,
                cap: cap,
                cmpd: cmpd,
                algn: algn
            }
        },
        children: [
            $5b7ccabde48fae90$var$getSolidFill("phClr"),
            $5b7ccabde48fae90$var$getPropertyVal("prstDash", "solid"),
            {
                name: "a:miter",
                properties: {
                    rawMap: {
                        lim: "800000"
                    }
                }
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getEffectStyle = (shadow2)=>{
    const children = [];
    if (shadow2) {
        const [blurRad, dist, dir, algn, rotWithShape] = shadow2;
        children.push({
            name: "a:outerShdw",
            properties: {
                rawMap: {
                    blurRad: blurRad,
                    dist: dist,
                    dir: dir,
                    algn: algn,
                    rotWithShape: rotWithShape
                }
            },
            children: [
                $5b7ccabde48fae90$var$getPropertyVal("srgbClr", "000000", [
                    $5b7ccabde48fae90$var$getPropertyVal("alpha", "63000")
                ])
            ]
        });
    }
    return {
        name: "a:effectStyle",
        children: [
            Object.assign({}, {
                name: "a:effectLst"
            }, children.length ? {
                children: children
            } : {})
        ]
    };
};
var $5b7ccabde48fae90$var$getFillStyleList = ()=>({
        name: "a:fillStyleLst",
        children: [
            $5b7ccabde48fae90$var$getSolidFill("phClr"),
            $5b7ccabde48fae90$var$getGradFill([
                "1",
                [
                    "0",
                    "phClr",
                    "105000",
                    "110000",
                    "67000"
                ],
                [
                    "50000",
                    "phClr",
                    "103000",
                    "105000",
                    "73000"
                ],
                [
                    "100000",
                    "phClr",
                    "109000",
                    "105000",
                    "81000"
                ],
                [
                    "5400000",
                    "0"
                ]
            ]),
            $5b7ccabde48fae90$var$getGradFill([
                "1",
                [
                    "0",
                    "phClr",
                    "103000",
                    "102000",
                    "94000"
                ],
                [
                    "50000",
                    "phClr",
                    "110000",
                    "100000",
                    void 0,
                    "100000"
                ],
                [
                    "100000",
                    "phClr",
                    "120000",
                    "99000",
                    void 0,
                    "78000"
                ],
                [
                    "5400000",
                    "0"
                ]
            ])
        ]
    });
var $5b7ccabde48fae90$var$getLineStyleList = ()=>({
        name: "a:lnStyleLst",
        children: [
            $5b7ccabde48fae90$var$getLine([
                "6350",
                "flat",
                "sng",
                "ctr"
            ]),
            $5b7ccabde48fae90$var$getLine([
                "12700",
                "flat",
                "sng",
                "ctr"
            ]),
            $5b7ccabde48fae90$var$getLine([
                "19050",
                "flat",
                "sng",
                "ctr"
            ])
        ]
    });
var $5b7ccabde48fae90$var$getEffectStyleList = ()=>({
        name: "a:effectStyleLst",
        children: [
            $5b7ccabde48fae90$var$getEffectStyle(),
            $5b7ccabde48fae90$var$getEffectStyle(),
            $5b7ccabde48fae90$var$getEffectStyle([
                "57150",
                "19050",
                "5400000",
                "ctr",
                "0"
            ])
        ]
    });
var $5b7ccabde48fae90$var$getBgFillStyleList = ()=>({
        name: "a:bgFillStyleLst",
        children: [
            $5b7ccabde48fae90$var$getSolidFill("phClr"),
            $5b7ccabde48fae90$var$getSolidFill("phClr", [
                $5b7ccabde48fae90$var$getPropertyVal("tint", "95000"),
                $5b7ccabde48fae90$var$getPropertyVal("satMod", "170000")
            ]),
            $5b7ccabde48fae90$var$getGradFill([
                "1",
                [
                    "0",
                    "phClr",
                    "150000",
                    "102000",
                    "93000",
                    "98000"
                ],
                [
                    "50000",
                    "phClr",
                    "130000",
                    "103000",
                    "98000",
                    "90000"
                ],
                [
                    "100000",
                    "phClr",
                    "120000",
                    void 0,
                    void 0,
                    "63000"
                ],
                [
                    "5400000",
                    "0"
                ]
            ])
        ]
    });
var $5b7ccabde48fae90$var$formatScheme = {
    getTemplate () {
        return {
            name: "a:fmtScheme",
            properties: {
                rawMap: {
                    name: "Office"
                }
            },
            children: [
                $5b7ccabde48fae90$var$getFillStyleList(),
                $5b7ccabde48fae90$var$getLineStyleList(),
                $5b7ccabde48fae90$var$getEffectStyleList(),
                $5b7ccabde48fae90$var$getBgFillStyleList()
            ]
        };
    }
};
var $5b7ccabde48fae90$var$formatScheme_default = $5b7ccabde48fae90$var$formatScheme;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/themes/office/themeElements.ts
var $5b7ccabde48fae90$var$themeElements = {
    getTemplate () {
        return {
            name: "a:themeElements",
            children: [
                $5b7ccabde48fae90$var$colorScheme_default.getTemplate(),
                $5b7ccabde48fae90$var$fontScheme_default.getTemplate(),
                $5b7ccabde48fae90$var$formatScheme_default.getTemplate()
            ]
        };
    }
};
var $5b7ccabde48fae90$var$themeElements_default = $5b7ccabde48fae90$var$themeElements;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/themes/office.ts
var $5b7ccabde48fae90$var$officeTheme = {
    getTemplate () {
        return {
            name: "a:theme",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            a: "http://schemas.openxmlformats.org/drawingml/2006/main"
                        }
                    }
                ],
                rawMap: {
                    name: "Office Theme"
                }
            },
            children: [
                $5b7ccabde48fae90$var$themeElements_default.getTemplate(),
                {
                    name: "a:objectDefaults"
                },
                {
                    name: "a:extraClrSchemeLst"
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$office_default = $5b7ccabde48fae90$var$officeTheme;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/vmlDrawing.ts
var $5b7ccabde48fae90$var$getShapeLayout = ()=>({
        name: "o:shapelayout",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "v:",
                    map: {
                        ext: "edit"
                    }
                }
            ]
        },
        children: [
            {
                name: "o:idmap",
                properties: {
                    prefixedAttributes: [
                        {
                            prefix: "v:",
                            map: {
                                ext: "edit"
                            }
                        }
                    ],
                    rawMap: {
                        data: "1"
                    }
                }
            }
        ]
    });
var $5b7ccabde48fae90$var$getStroke = ()=>({
        name: "v:stroke",
        properties: {
            rawMap: {
                joinstyle: "miter"
            }
        }
    });
var $5b7ccabde48fae90$var$getFormulas = (formulas)=>({
        name: "v:formulas",
        children: formulas.map((formula)=>({
                name: "v:f",
                properties: {
                    rawMap: {
                        eqn: formula
                    }
                }
            }))
    });
var $5b7ccabde48fae90$var$getPath = ()=>({
        name: "v:path",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "o:",
                    map: {
                        connecttype: "rect",
                        extrusionok: "f"
                    }
                }
            ],
            rawMap: {
                gradientshapeok: "t"
            }
        }
    });
var $5b7ccabde48fae90$var$getLock = (params)=>{
    const { aspectratio: aspectratio, rotation: rotation } = params || {};
    const rawMap = {};
    if (aspectratio) rawMap.aspectratio = "t";
    if (rotation) rawMap.rotation = "t";
    return {
        name: "o:lock",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "v:",
                    map: {
                        ext: "edit"
                    }
                }
            ],
            rawMap: rawMap
        }
    };
};
function $5b7ccabde48fae90$var$mapNumber(value, startSource, endSource, startTarget, endTarget) {
    return (value - startSource) / (endSource - startSource) * (endTarget - startTarget) + startTarget;
}
var $5b7ccabde48fae90$var$getImageData = (image, idx)=>{
    let rawMap;
    const { recolor: recolor, brightness: brightness, contrast: contrast, id: id } = image;
    if (recolor) {
        rawMap = {};
        if (recolor === "Washout" || recolor === "Grayscale") {
            rawMap.gain = "19661f";
            rawMap.blacklevel = "22938f";
        }
        if (recolor === "Black & White" || recolor === "Grayscale") {
            rawMap.grayscale = "t";
            if (recolor === "Black & White") rawMap.bilevel = "t";
        }
    }
    if (!recolor || recolor === "Grayscale") {
        if (!rawMap) rawMap = {};
        if (contrast != null && contrast !== 50) {
            let gain = "1";
            if (contrast >= 0) {
                if (contrast < 50) gain = String(contrast / 50);
                else if (contrast < 100) gain = String(50 / (100 - contrast));
                else if (contrast === 100) gain = "2147483647f";
            }
            rawMap.gain = gain;
        }
        if (brightness != null && brightness !== 50) rawMap.blacklevel = $5b7ccabde48fae90$var$mapNumber(brightness, 0, 100, -0.5, 0.5).toString();
    }
    return {
        name: "v:imagedata",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "o:",
                    map: {
                        relid: `rId${idx}`,
                        title: id
                    }
                }
            ],
            rawMap: rawMap
        }
    };
};
var $5b7ccabde48fae90$var$getShapeType = ()=>{
    const formulas = [
        "if lineDrawn pixelLineWidth 0",
        "sum @0 1 0",
        "sum 0 0 @1",
        "prod @2 1 2",
        "prod @3 21600 pixelWidth",
        "prod @3 21600 pixelHeight",
        "sum @0 0 1",
        "prod @6 1 2",
        "prod @7 21600 pixelWidth",
        "sum @8 21600 0",
        "prod @7 21600 pixelHeight",
        "sum @10 21600 0"
    ];
    return {
        name: "v:shapetype",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "o:",
                    map: {
                        spt: "75",
                        preferrelative: "t"
                    }
                }
            ],
            rawMap: {
                coordsize: "21600,21600",
                filled: "f",
                id: "_x0000_t75",
                path: "m@4@5l@4@11@9@11@9@5xe",
                stroked: "f"
            }
        },
        children: [
            $5b7ccabde48fae90$var$getStroke(),
            $5b7ccabde48fae90$var$getFormulas(formulas),
            $5b7ccabde48fae90$var$getPath(),
            $5b7ccabde48fae90$var$getLock({
                aspectratio: true
            })
        ]
    };
};
var $5b7ccabde48fae90$var$pixelToPoint = (value)=>Math.floor((value ?? 0) * 0.74999943307122);
var $5b7ccabde48fae90$var$getShape = (image, idx)=>{
    const { width: width = 0, height: height = 0, altText: altText } = image;
    const imageWidth = $5b7ccabde48fae90$var$pixelToPoint(width);
    const imageHeight = $5b7ccabde48fae90$var$pixelToPoint(height);
    return {
        name: "v:shape",
        properties: {
            rawMap: {
                id: image.headerFooterPosition,
                "o:spid": "_x0000_s1025",
                style: `position: absolute; margin-left: 0; margin-top: 10in; margin-bottom: 0; margin-right: 0; width: ${imageWidth}pt; height: ${imageHeight}pt; z-index: ${idx + 1}`,
                type: "#_x0000_t75",
                alt: altText
            }
        },
        children: [
            $5b7ccabde48fae90$var$getImageData(image, idx + 1),
            $5b7ccabde48fae90$var$getLock({
                rotation: true
            })
        ]
    };
};
var $5b7ccabde48fae90$var$vmlDrawingFactory = {
    getTemplate (params) {
        const headerFooterImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.get(params.sheetIndex) || [];
        const children = [
            $5b7ccabde48fae90$var$getShapeLayout(),
            $5b7ccabde48fae90$var$getShapeType(),
            ...headerFooterImages.map((img, idx)=>$5b7ccabde48fae90$var$getShape(img, idx))
        ];
        return {
            name: "xml",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            v: "urn:schemas-microsoft-com:vml",
                            o: "urn:schemas-microsoft-com:office:office",
                            x: "urn:schemas-microsoft-com:office:excel"
                        }
                    }
                ]
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$vmlDrawing_default = $5b7ccabde48fae90$var$vmlDrawingFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/sheet.ts
var $5b7ccabde48fae90$var$sheetFactory = {
    getTemplate (name, idx) {
        const sheetId = (idx + 1).toString();
        return {
            name: "sheet",
            properties: {
                rawMap: {
                    name: name,
                    sheetId: sheetId,
                    "r:id": `rId${sheetId}`
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$sheet_default = $5b7ccabde48fae90$var$sheetFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/sheets.ts
var $5b7ccabde48fae90$var$sheetsFactory = {
    getTemplate (names) {
        return {
            name: "sheets",
            children: names.map((sheet, idx)=>$5b7ccabde48fae90$var$sheet_default.getTemplate(sheet, idx))
        };
    }
};
var $5b7ccabde48fae90$var$sheets_default = $5b7ccabde48fae90$var$sheetsFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/workbook.ts
var $5b7ccabde48fae90$var$workbookFactory = {
    getTemplate (names, activeTab) {
        return {
            name: "workbook",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
                        }
                    }
                ],
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                }
            },
            children: [
                {
                    name: "bookViews",
                    children: [
                        {
                            name: "workbookView",
                            properties: {
                                rawMap: {
                                    activeTab: activeTab
                                }
                            }
                        }
                    ]
                },
                $5b7ccabde48fae90$var$sheets_default.getTemplate(names)
            ]
        };
    }
};
var $5b7ccabde48fae90$var$workbook_default = $5b7ccabde48fae90$var$workbookFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/column.ts
var $5b7ccabde48fae90$var$getExcelCellWidth = (width)=>Math.ceil((width - 12) / 7 + 1);
var $5b7ccabde48fae90$var$colFactory = {
    getTemplate (config) {
        const { min: min, max: max, outlineLevel: outlineLevel, s: s2, width: width, hidden: hidden, bestFit: bestFit } = config;
        let excelWidth = 1;
        let customWidth = "0";
        if (width > 1) {
            excelWidth = $5b7ccabde48fae90$var$getExcelCellWidth(width);
            customWidth = "1";
        }
        return {
            name: "col",
            properties: {
                rawMap: {
                    min: min,
                    max: max,
                    outlineLevel: outlineLevel != null ? outlineLevel : void 0,
                    width: excelWidth,
                    style: s2,
                    hidden: hidden ? "1" : "0",
                    bestFit: bestFit ? "1" : "0",
                    customWidth: customWidth
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$column_default = $5b7ccabde48fae90$var$colFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/mergeCell.ts
var $5b7ccabde48fae90$var$mergeCellFactory = {
    getTemplate (ref) {
        return {
            name: "mergeCell",
            properties: {
                rawMap: {
                    ref: ref
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$mergeCell_default = $5b7ccabde48fae90$var$mergeCellFactory;
var $5b7ccabde48fae90$var$convertLegacyType = (type)=>{
    const t = type.charAt(0).toLowerCase();
    return t === "s" ? "inlineStr" : t;
};
var $5b7ccabde48fae90$var$cellFactory = {
    getTemplate (config, idx, currentSheet2) {
        const { ref: ref, data: data, styleId: styleId } = config;
        const { type: type, value: value } = data || {
            type: "empty",
            value: null
        };
        let convertedType = type;
        if (type === "f") convertedType = "str";
        else if (type.charAt(0) === type.charAt(0).toUpperCase()) convertedType = $5b7ccabde48fae90$var$convertLegacyType(type);
        const obj = {
            name: "c",
            properties: {
                rawMap: {
                    r: ref,
                    t: convertedType === "empty" ? void 0 : convertedType,
                    s: styleId ? $5b7ccabde48fae90$var$getStyleId(styleId, currentSheet2) : void 0
                }
            }
        };
        if (convertedType === "empty") return obj;
        let children;
        if (convertedType === "str" && type === "f") children = [
            {
                name: "f",
                textNode: (0, $437b23f6a393c3bf$export$3df06b741968da82)($5b7ccabde48fae90$var$replaceInvisibleCharacters(value))
            }
        ];
        else if (convertedType === "inlineStr") children = [
            {
                name: "is",
                children: [
                    {
                        name: "t",
                        textNode: (0, $437b23f6a393c3bf$export$3df06b741968da82)($5b7ccabde48fae90$var$replaceInvisibleCharacters(value))
                    }
                ]
            }
        ];
        else children = [
            {
                name: "v",
                textNode: value
            }
        ];
        return Object.assign({}, obj, {
            children: children
        });
    }
};
var $5b7ccabde48fae90$var$cell_default = $5b7ccabde48fae90$var$cellFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/row.ts
var $5b7ccabde48fae90$var$addEmptyCells = (cells, rowIdx)=>{
    const mergeMap = [];
    let posCounter = 0;
    for(let i = 0; i < cells.length; i++){
        const cell = cells[i];
        if (cell.mergeAcross) {
            mergeMap.push({
                pos: i,
                excelPos: posCounter
            });
            posCounter += cell.mergeAcross;
        }
        posCounter++;
    }
    if (mergeMap.length) for(let i = mergeMap.length - 1; i >= 0; i--){
        const mergedCells = [];
        const cell = cells[mergeMap[i].pos];
        for(let j = 1; j <= cell.mergeAcross; j++)mergedCells.push({
            ref: `${$5b7ccabde48fae90$var$getExcelColumnName(mergeMap[i].excelPos + 1 + j)}${rowIdx + 1}`,
            styleId: cell.styleId,
            data: {
                type: "empty",
                value: null
            }
        });
        if (mergedCells.length) cells.splice(mergeMap[i].pos + 1, 0, ...mergedCells);
    }
};
var $5b7ccabde48fae90$var$shouldDisplayCell = (cell)=>cell.data?.value !== "" || cell.styleId !== void 0;
var $5b7ccabde48fae90$var$rowFactory = {
    getTemplate (config, idx, currentSheet2) {
        const { collapsed: collapsed, hidden: hidden, height: height, outlineLevel: outlineLevel, cells: cells = [] } = config;
        $5b7ccabde48fae90$var$addEmptyCells(cells, idx);
        const children = cells.filter($5b7ccabde48fae90$var$shouldDisplayCell).map((cell, idx2)=>$5b7ccabde48fae90$var$cell_default.getTemplate(cell, idx2, currentSheet2));
        return {
            name: "row",
            properties: {
                rawMap: {
                    r: idx + 1,
                    collapsed: collapsed ? "1" : "0",
                    hidden: hidden ? "1" : "0",
                    ht: height,
                    customHeight: height != null ? "1" : "0",
                    spans: "1:1",
                    outlineLevel: outlineLevel || void 0
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$row_default = $5b7ccabde48fae90$var$rowFactory;
// packages/ag-grid-enterprise/src/excelExport/files/ooxml/worksheet.ts
var $5b7ccabde48fae90$var$getMergedCellsAndAddColumnGroups = (rows, cols, suppressColumnOutline)=>{
    const mergedCells = [];
    const cellsWithCollapsibleGroups = [];
    rows.forEach((currentRow, rowIdx)=>{
        const cells = currentRow.cells;
        let merges = 0;
        let lastCol;
        cells.forEach((currentCell, cellIdx)=>{
            const min = cellIdx + merges + 1;
            const start = $5b7ccabde48fae90$var$getExcelColumnName(min);
            const outputRow = rowIdx + 1;
            if (currentCell.mergeAcross) {
                merges += currentCell.mergeAcross;
                const end = $5b7ccabde48fae90$var$getExcelColumnName(cellIdx + merges + 1);
                mergedCells.push(`${start}${outputRow}:${end}${outputRow}`);
            }
            if (!cols[min - 1]) cols[min - 1] = {};
            const { collapsibleRanges: collapsibleRanges } = currentCell;
            if (collapsibleRanges) collapsibleRanges.forEach((range)=>{
                cellsWithCollapsibleGroups.push([
                    min + range[0],
                    min + range[1]
                ]);
            });
            lastCol = cols[min - 1];
            lastCol.min = min;
            lastCol.max = min;
            currentCell.ref = `${start}${outputRow}`;
        });
    });
    cellsWithCollapsibleGroups.sort((a, b)=>{
        if (a[0] !== b[0]) return a[0] - b[0];
        return b[1] - a[1];
    });
    const rangeMap = /* @__PURE__ */ new Map();
    const outlineLevel = /* @__PURE__ */ new Map();
    cellsWithCollapsibleGroups.filter((currentRange)=>{
        const rangeString = currentRange.toString();
        const inMap = rangeMap.get(rangeString);
        if (inMap) return false;
        rangeMap.set(rangeString, true);
        return true;
    }).forEach((range)=>{
        const refCol = cols.find((col)=>col.min == range[0] && col.max == range[1]);
        const currentOutlineLevel = outlineLevel.get(range[0]);
        cols.push({
            min: range[0],
            max: range[1],
            outlineLevel: suppressColumnOutline ? void 0 : currentOutlineLevel || 1,
            width: (refCol || {
                width: 100
            }).width
        });
        outlineLevel.set(range[0], (currentOutlineLevel || 0) + 1);
    });
    return mergedCells;
};
var $5b7ccabde48fae90$var$getPageOrientation = (orientation)=>{
    if (!orientation || orientation !== "Portrait" && orientation !== "Landscape") return "portrait";
    return orientation.toLocaleLowerCase();
};
var $5b7ccabde48fae90$var$getPageSize = (pageSize)=>{
    if (pageSize == null) return 1;
    const positions = [
        "Letter",
        "Letter Small",
        "Tabloid",
        "Ledger",
        "Legal",
        "Statement",
        "Executive",
        "A3",
        "A4",
        "A4 Small",
        "A5",
        "A6",
        "B4",
        "B5",
        "Folio",
        "Envelope",
        "Envelope DL",
        "Envelope C5",
        "Envelope B5",
        "Envelope C3",
        "Envelope C4",
        "Envelope C6",
        "Envelope Monarch",
        "Japanese Postcard",
        "Japanese Double Postcard"
    ];
    const pos = positions.indexOf(pageSize);
    return pos === -1 ? 1 : pos + 1;
};
var $5b7ccabde48fae90$var$replaceHeaderFooterTokens = (value)=>{
    const map = {
        "&[Page]": "&P",
        "&[Pages]": "&N",
        "&[Date]": "&D",
        "&[Time]": "&T",
        "&[Tab]": "&A",
        "&[Path]": "&Z",
        "&[File]": "&F",
        "&[Picture]": "&G"
    };
    for (const key of Object.keys(map))value = value.replace(key, map[key]);
    return value;
};
var $5b7ccabde48fae90$var$getHeaderPosition = (position)=>{
    if (position === "Center") return "C";
    if (position === "Right") return "R";
    return "L";
};
var $5b7ccabde48fae90$var$applyHeaderFontStyle = (headerString, font)=>{
    if (!font) return headerString;
    headerString += "&amp;&quot;";
    headerString += font.fontName || "Calibri";
    if (font.bold !== font.italic) headerString += font.bold ? ",Bold" : ",Italic";
    else if (font.bold) headerString += ",Bold Italic";
    else headerString += ",Regular";
    headerString += "&quot;";
    if (font.size) headerString += `&amp;${font.size}`;
    if (font.strikeThrough) headerString += "&amp;S";
    if (font.underline) headerString += `&amp;${font.underline === "Double" ? "E" : "U"}`;
    if (font.color) headerString += `&amp;K${font.color.replace("#", "").toUpperCase()}`;
    return headerString;
};
var $5b7ccabde48fae90$var$processHeaderFooterContent = (content, location, rule)=>content.reduce((prev, curr, idx)=>{
        const pos = $5b7ccabde48fae90$var$getHeaderPosition(curr.position);
        const output = $5b7ccabde48fae90$var$applyHeaderFontStyle(`${prev}&amp;${pos}`, curr.font);
        const PositionMap = [
            "Left",
            "Center",
            "Right"
        ];
        if (!curr.position) curr.position = PositionMap[idx];
        const { image: image } = curr;
        if (curr.value === "&[Picture]" && image) {
            const imagePosition = `${pos}${location}${rule}`;
            $5b7ccabde48fae90$var$addXlsxHeaderFooterImageToMap(image, imagePosition);
        }
        return `${output}${(0, $437b23f6a393c3bf$export$3df06b741968da82)($5b7ccabde48fae90$var$replaceHeaderFooterTokens(curr.value))}`;
    }, "");
var $5b7ccabde48fae90$var$buildHeaderFooter = (headerFooterConfig)=>{
    const rules = [
        "all",
        "first",
        "even"
    ];
    const headersAndFooters = [];
    rules.forEach((rule)=>{
        const headerFooter = headerFooterConfig[rule];
        const namePrefix = rule === "all" ? "odd" : rule;
        if (!headerFooter) return;
        for (const key of Object.keys(headerFooter)){
            const value = headerFooter[key];
            const nameSuffix = `${key.charAt(0).toUpperCase()}${key.slice(1)}`;
            const location = key[0].toUpperCase();
            if (value) {
                const normalizedRule = rule === "all" ? "" : rule.toUpperCase();
                headersAndFooters.push({
                    name: `${namePrefix}${nameSuffix}`,
                    properties: {
                        rawMap: {
                            "xml:space": "preserve"
                        }
                    },
                    textNode: $5b7ccabde48fae90$var$processHeaderFooterContent(value, location, normalizedRule)
                });
            }
        }
    });
    return headersAndFooters;
};
var $5b7ccabde48fae90$var$addColumns = (columns)=>{
    return (params)=>{
        if (columns.length) params.children.push({
            name: "cols",
            children: columns.map((column)=>$5b7ccabde48fae90$var$column_default.getTemplate(column))
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addSheetData = (rows, sheetNumber)=>{
    return (params)=>{
        if (rows.length) params.children.push({
            name: "sheetData",
            children: rows.map((row, idx)=>$5b7ccabde48fae90$var$row_default.getTemplate(row, idx, sheetNumber))
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addMergeCells = (mergeCells)=>{
    return (params)=>{
        if (mergeCells.length) params.children.push({
            name: "mergeCells",
            properties: {
                rawMap: {
                    count: mergeCells.length
                }
            },
            children: mergeCells.map((mergedCell)=>$5b7ccabde48fae90$var$mergeCell_default.getTemplate(mergedCell))
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addPageMargins = (margins)=>{
    return (params)=>{
        const { top: top = 0.75, right: right = 0.7, bottom: bottom = 0.75, left: left = 0.7, header: header = 0.3, footer: footer = 0.3 } = margins;
        params.children.push({
            name: "pageMargins",
            properties: {
                rawMap: {
                    bottom: bottom,
                    footer: footer,
                    header: header,
                    left: left,
                    right: right,
                    top: top
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addPageSetup = (pageSetup)=>{
    return (params)=>{
        if (pageSetup) params.children.push({
            name: "pageSetup",
            properties: {
                rawMap: {
                    horizontalDpi: 0,
                    verticalDpi: 0,
                    orientation: $5b7ccabde48fae90$var$getPageOrientation(pageSetup.orientation),
                    paperSize: $5b7ccabde48fae90$var$getPageSize(pageSetup.pageSize)
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addHeaderFooter = (headerFooterConfig)=>{
    return (params)=>{
        if (!headerFooterConfig) return params;
        const differentFirst = headerFooterConfig.first != null ? 1 : 0;
        const differentOddEven = headerFooterConfig.even != null ? 1 : 0;
        params.children.push({
            name: "headerFooter",
            properties: {
                rawMap: {
                    differentFirst: differentFirst,
                    differentOddEven: differentOddEven
                }
            },
            children: $5b7ccabde48fae90$var$buildHeaderFooter(headerFooterConfig)
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addExcelTableRel = (excelTable)=>{
    return (params)=>{
        if (excelTable) params.children.push({
            name: "tableParts",
            properties: {
                rawMap: {
                    count: "1"
                }
            },
            children: [
                {
                    name: "tablePart",
                    properties: {
                        rawMap: {
                            "r:id": `rId${++params.rIdCounter}`
                        }
                    }
                }
            ]
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addDrawingRel = (currentSheet2)=>{
    return (params)=>{
        const worksheetImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.get(currentSheet2);
        if (worksheetImages?.length) params.children.push({
            name: "drawing",
            properties: {
                rawMap: {
                    "r:id": `rId${++params.rIdCounter}`
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addVmlDrawingRel = (currentSheet2)=>{
    return (params)=>{
        if ($5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.get(currentSheet2)) params.children.push({
            name: "legacyDrawingHF",
            properties: {
                rawMap: {
                    "r:id": `rId${++params.rIdCounter}`
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$getPane = (xSplit = 0, ySplit = 0)=>{
    const shouldSplit = xSplit > 0 || ySplit > 0;
    return shouldSplit ? [
        {
            name: "pane",
            properties: {
                rawMap: {
                    state: shouldSplit ? "frozen" : void 0,
                    topLeftCell: shouldSplit ? `${$5b7ccabde48fae90$var$getExcelColumnName(xSplit + 1)}${ySplit + 1}` : void 0,
                    xSplit: xSplit === 0 ? void 0 : xSplit,
                    ySplit: ySplit === 0 ? void 0 : ySplit
                }
            }
        }
    ] : void 0;
};
var $5b7ccabde48fae90$var$addSheetViews = (rtl = false, xSplit, ySplit)=>{
    return (params)=>{
        params.children.push({
            name: "sheetViews",
            children: [
                {
                    name: "sheetView",
                    properties: {
                        rawMap: {
                            rightToLeft: rtl === true ? "1" : "0",
                            workbookViewId: "0"
                        }
                    },
                    children: $5b7ccabde48fae90$var$getPane(xSplit, ySplit)
                }
            ]
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addSheetPr = ()=>{
    return (params)=>{
        params.children.push({
            name: "sheetPr",
            children: [
                {
                    name: "outlinePr",
                    properties: {
                        rawMap: {
                            summaryBelow: 0
                        }
                    }
                }
            ]
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addSheetFormatPr = (rows)=>{
    return (params)=>{
        const maxOutline = rows.reduce((prev, row)=>{
            if (row.outlineLevel && row.outlineLevel > prev) return row.outlineLevel;
            return prev;
        }, 0);
        params.children.push({
            name: "sheetFormatPr",
            properties: {
                rawMap: {
                    baseColWidth: 10,
                    defaultRowHeight: 16,
                    outlineLevelRow: maxOutline ? maxOutline : void 0
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$worksheetFactory = {
    getTemplate (params) {
        const { worksheet: worksheet, currentSheet: currentSheet2, config: config } = params;
        const { margins: margins = {}, pageSetup: pageSetup, headerFooterConfig: headerFooterConfig, suppressColumnOutline: suppressColumnOutline, rightToLeft: rightToLeft, frozenRowCount: frozenRowCount, frozenColumnCount: frozenColumnCount } = config;
        const { table: table } = worksheet;
        const { rows: rows, columns: columns } = table;
        const mergedCells = columns?.length ? $5b7ccabde48fae90$var$getMergedCellsAndAddColumnGroups(rows, columns, !!suppressColumnOutline) : [];
        const worksheetExcelTables = $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.get(currentSheet2);
        const { children: children } = [
            $5b7ccabde48fae90$var$addSheetPr(),
            $5b7ccabde48fae90$var$addSheetViews(rightToLeft, frozenColumnCount, frozenRowCount),
            $5b7ccabde48fae90$var$addSheetFormatPr(rows),
            $5b7ccabde48fae90$var$addColumns(columns),
            $5b7ccabde48fae90$var$addSheetData(rows, currentSheet2 + 1),
            $5b7ccabde48fae90$var$addMergeCells(mergedCells),
            $5b7ccabde48fae90$var$addPageMargins(margins),
            $5b7ccabde48fae90$var$addPageSetup(pageSetup),
            $5b7ccabde48fae90$var$addHeaderFooter(headerFooterConfig),
            $5b7ccabde48fae90$var$addDrawingRel(currentSheet2),
            $5b7ccabde48fae90$var$addVmlDrawingRel(currentSheet2),
            $5b7ccabde48fae90$var$addExcelTableRel(worksheetExcelTables)
        ].reduce((composed, f)=>f(composed), {
            children: [],
            rIdCounter: 0
        });
        return {
            name: "worksheet",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
                        }
                    }
                ],
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$worksheet_default = $5b7ccabde48fae90$var$worksheetFactory;
// packages/ag-grid-enterprise/src/excelExport/excelXlsxFactory.ts
var $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_SHEET_NAMES = [];
var $5b7ccabde48fae90$var$XLSX_IMAGES = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES = /* @__PURE__ */ new Map();
var $5b7ccabde48fae90$var$DEFAULT_TABLE_DISPLAY_NAME = "AG-GRID-TABLE";
var $5b7ccabde48fae90$var$XLSX_FACTORY_MODE = "SINGLE_SHEET";
function $5b7ccabde48fae90$var$getXlsxFactoryMode() {
    return $5b7ccabde48fae90$var$XLSX_FACTORY_MODE;
}
function $5b7ccabde48fae90$var$setXlsxFactoryMode(factoryMode) {
    $5b7ccabde48fae90$var$XLSX_FACTORY_MODE = factoryMode;
}
function $5b7ccabde48fae90$var$createXlsxExcel(styles, worksheet, config) {
    $5b7ccabde48fae90$var$addSheetName(worksheet);
    $5b7ccabde48fae90$var$registerStyles(styles, $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.length);
    const newConfig = Object.assign({}, config);
    if (config.exportAsExcelTable) {
        if (config.colModel.isPivotActive()) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(163, {
                featureName: "pivot mode"
            });
            newConfig.exportAsExcelTable = false;
        }
    }
    $5b7ccabde48fae90$var$processTableConfig(worksheet, newConfig);
    return $5b7ccabde48fae90$var$createWorksheet(worksheet, newConfig);
}
function $5b7ccabde48fae90$var$getXlsxSanitizedTableName(name) {
    return name.replace(/^[^a-zA-Z_]+/, "_").replace(/\s/g, "_").replace(/[^a-zA-Z0-9_]/g, "_");
}
function $5b7ccabde48fae90$var$addXlsxTableToSheet(sheetIndex, table) {
    if ($5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.has(sheetIndex)) {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(164);
        return;
    }
    $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.set(sheetIndex, table);
}
function $5b7ccabde48fae90$var$processTableConfig(worksheet, config) {
    const { exportAsExcelTable: exportAsExcelTable, prependContent: prependContent, appendContent: appendContent, colModel: colModel } = config;
    if (!exportAsExcelTable) return;
    const tableConfig = typeof exportAsExcelTable === "boolean" ? {} : exportAsExcelTable;
    const { name: name, showColumnStripes: showColumnStripes, showRowStripes: showRowStripes, showFilterButton: showFilterButton, highlightFirstColumn: highlightFirstColumn, highlightLastColumn: highlightLastColumn } = tableConfig;
    const tableName = $5b7ccabde48fae90$var$getXlsxSanitizedTableName(name || $5b7ccabde48fae90$var$DEFAULT_TABLE_DISPLAY_NAME);
    const sheetIndex = $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.length - 1;
    const { table: table } = worksheet;
    const { rows: rows, columns: columns } = table;
    const headerRowCount = (0, $437b23f6a393c3bf$export$4861f2356b3fc2d7)(colModel);
    const skipTopRows = prependContent ? prependContent.length : 0;
    const removeFromBottom = appendContent ? appendContent.length : 0;
    const tableRowCount = rows.length;
    const tableColCount = columns.length;
    const tableColumns = [];
    const showFilterButtons = [];
    for(let i = 0; i < tableColCount; i++){
        const col = columns[i];
        tableColumns.push(col.displayName || "");
        showFilterButtons.push(showFilterButton === "match" || showFilterButton === void 0 ? col.filterAllowed ?? false : showFilterButton);
    }
    if (!tableColumns?.length || !tableRowCount || !tableName) {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(165);
        return;
    }
    $5b7ccabde48fae90$var$addXlsxTableToSheet(sheetIndex, {
        name: `table${$5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.size + 1}`,
        displayName: tableName,
        columns: tableColumns,
        showFilterButtons: showFilterButtons,
        rowRange: [
            headerRowCount + skipTopRows,
            headerRowCount + (tableRowCount - headerRowCount) - removeFromBottom
        ],
        showRowStripes: showRowStripes ?? true,
        showColumnStripes: showColumnStripes ?? false,
        highlightFirstColumn: highlightFirstColumn ?? false,
        highlightLastColumn: highlightLastColumn ?? false
    });
}
function $5b7ccabde48fae90$var$addXlsxHeaderFooterImageToMap(image, position) {
    const sheetIndex = $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.length - 1;
    const headerFooterImage = image;
    headerFooterImage.headerFooterPosition = position;
    $5b7ccabde48fae90$var$buildImageMap({
        imageToAdd: headerFooterImage,
        idx: sheetIndex
    });
    let headerFooterImagesForSheet = $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.get(sheetIndex);
    if (!headerFooterImagesForSheet) {
        headerFooterImagesForSheet = [];
        $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.set(sheetIndex, headerFooterImagesForSheet);
    }
    if (!headerFooterImagesForSheet.find((img)=>img.id === image.id)) headerFooterImagesForSheet.push(image);
}
function $5b7ccabde48fae90$var$addXlsxBodyImageToMap(image, rowIndex, col, columnsToExport, rowHeight) {
    const sheetIndex = $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.length;
    const { row: row, column: column } = image.position || {};
    const calculatedImage = image;
    if (columnsToExport) {
        if (rowIndex != null && col != null && (!row || !column)) {
            if (!image.position) image.position = {};
            image.position = Object.assign({}, image.position, {
                row: rowIndex,
                column: columnsToExport.indexOf(col) + 1
            });
        }
        $5b7ccabde48fae90$var$setExcelImageTotalWidth(calculatedImage, columnsToExport);
        $5b7ccabde48fae90$var$setExcelImageTotalHeight(calculatedImage, rowHeight);
    }
    $5b7ccabde48fae90$var$buildImageMap({
        imageToAdd: calculatedImage,
        idx: sheetIndex
    });
    let worksheetImageIdMap = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS.get(sheetIndex);
    if (!worksheetImageIdMap) {
        worksheetImageIdMap = /* @__PURE__ */ new Map();
        $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS.set(sheetIndex, worksheetImageIdMap);
    }
    const sheetImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.get(sheetIndex);
    if (!sheetImages) $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.set(sheetIndex, [
        calculatedImage
    ]);
    else sheetImages.push(calculatedImage);
    if (!worksheetImageIdMap.get(image.id)) worksheetImageIdMap.set(image.id, {
        index: worksheetImageIdMap.size,
        type: image.imageType
    });
}
function $5b7ccabde48fae90$var$buildImageMap(params) {
    const { imageToAdd: imageToAdd, idx: idx } = params;
    const mappedImagesToSheet = $5b7ccabde48fae90$var$XLSX_IMAGES.get(imageToAdd.id);
    if (mappedImagesToSheet) {
        const currentSheetImages = mappedImagesToSheet.find((currentImage)=>currentImage.sheetId === idx);
        if (currentSheetImages) currentSheetImages.image.push(imageToAdd);
        else mappedImagesToSheet.push({
            sheetId: idx,
            image: [
                imageToAdd
            ]
        });
    } else {
        $5b7ccabde48fae90$var$XLSX_IMAGES.set(imageToAdd.id, [
            {
                sheetId: idx,
                image: [
                    imageToAdd
                ]
            }
        ]);
        $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.set(imageToAdd.id, {
            type: imageToAdd.imageType,
            index: $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.size
        });
    }
}
function $5b7ccabde48fae90$var$addSheetName(worksheet) {
    const name = (0, $437b23f6a393c3bf$export$3df06b741968da82)(worksheet.name) || "";
    let append = "";
    while($5b7ccabde48fae90$var$XLSX_SHEET_NAMES.indexOf(`${name}${append}`) !== -1)if (append === "") append = "_1";
    else {
        const curr = parseInt(append.slice(1), 10);
        append = `_${curr + 1}`;
    }
    worksheet.name = `${name}${append}`;
    $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.push(worksheet.name);
}
function $5b7ccabde48fae90$var$getXlsxStringPosition(str) {
    if ($5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.has(str)) return $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.get(str);
    $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.set(str, $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.size);
    return $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.size - 1;
}
function $5b7ccabde48fae90$var$resetXlsxFactory() {
    $5b7ccabde48fae90$var$XLSX_SHARED_STRINGS.clear();
    $5b7ccabde48fae90$var$XLSX_IMAGES.clear();
    $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.clear();
    $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.clear();
    $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.clear();
    $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS.clear();
    $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.clear();
    $5b7ccabde48fae90$var$XLSX_SHEET_NAMES = [];
    $5b7ccabde48fae90$var$XLSX_FACTORY_MODE = "SINGLE_SHEET";
}
function $5b7ccabde48fae90$var$createXlsxWorkbook(currentSheet2) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$workbook_default.getTemplate($5b7ccabde48fae90$var$XLSX_SHEET_NAMES, currentSheet2));
}
function $5b7ccabde48fae90$var$createXlsxStylesheet(defaultFontSize) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$stylesheet_default.getTemplate(defaultFontSize));
}
function $5b7ccabde48fae90$var$createXlsxSharedStrings() {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$sharedStrings_default.getTemplate($5b7ccabde48fae90$var$XLSX_SHARED_STRINGS));
}
function $5b7ccabde48fae90$var$createXlsxCore(author) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$core_default.getTemplate(author));
}
function $5b7ccabde48fae90$var$createXlsxContentTypes(sheetLen) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$contentTypes_default.getTemplate(sheetLen));
}
function $5b7ccabde48fae90$var$createXlsxRels() {
    const rs = $5b7ccabde48fae90$var$relationships_default.getTemplate([
        {
            Id: "rId1",
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
            Target: "xl/workbook.xml"
        },
        {
            Id: "rId2",
            Type: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
            Target: "docProps/core.xml"
        }
    ]);
    return $5b7ccabde48fae90$var$createXmlPart(rs);
}
function $5b7ccabde48fae90$var$createXlsxTheme() {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$office_default.getTemplate());
}
function $5b7ccabde48fae90$var$createXlsxTable(dataTable, index) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$table_default.getTemplate(dataTable, index));
}
function $5b7ccabde48fae90$var$createXlsxWorkbookRels(sheetLen) {
    const worksheets = new Array(sheetLen).fill(void 0).map((v, i)=>({
            Id: `rId${i + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
            Target: `worksheets/sheet${i + 1}.xml`
        }));
    const rs = $5b7ccabde48fae90$var$relationships_default.getTemplate([
        ...worksheets,
        {
            Id: `rId${sheetLen + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
            Target: "theme/theme1.xml"
        },
        {
            Id: `rId${sheetLen + 2}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
            Target: "styles.xml"
        },
        {
            Id: `rId${sheetLen + 3}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
            Target: "sharedStrings.xml"
        }
    ]);
    return $5b7ccabde48fae90$var$createXmlPart(rs);
}
function $5b7ccabde48fae90$var$createXlsxDrawing(sheetIndex) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$drawing_default.getTemplate({
        sheetIndex: sheetIndex
    }));
}
function $5b7ccabde48fae90$var$createXlsxDrawingRel(sheetIndex) {
    const worksheetImageIds = $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGE_IDS.get(sheetIndex) || [];
    const XMLArr = [];
    for (const [key, value] of worksheetImageIds){
        const { index: index, type: type } = value;
        XMLArr.push({
            Id: `rId${index + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
            Target: `../media/image${$5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.get(key).index + 1}.${$5b7ccabde48fae90$var$_normaliseImageExtension(type)}`
        });
    }
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$relationships_default.getTemplate(XMLArr));
}
function $5b7ccabde48fae90$var$createXlsxVmlDrawing(sheetIndex) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$vmlDrawing_default.getTemplate({
        sheetIndex: sheetIndex
    }), true);
}
function $5b7ccabde48fae90$var$createXlsxVmlDrawingRel(sheetIndex) {
    const worksheetHeaderFooterImages = $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.get(sheetIndex) || [];
    const XMLArr = [];
    for(let i = 0; i < worksheetHeaderFooterImages.length; i++){
        const headerFooterImage = worksheetHeaderFooterImages[i];
        const workbookImage = $5b7ccabde48fae90$var$XLSX_WORKBOOK_IMAGE_IDS.get(headerFooterImage.id);
        if (!workbookImage) continue;
        const { index: index, type: type } = workbookImage;
        XMLArr.push({
            Id: `rId${i + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
            Target: `../media/image${index + 1}.${$5b7ccabde48fae90$var$_normaliseImageExtension(type)}`
        });
    }
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$relationships_default.getTemplate(XMLArr));
}
function $5b7ccabde48fae90$var$createXlsxRelationships({ drawingIndex: drawingIndex, vmlDrawingIndex: vmlDrawingIndex, tableName: tableName } = {}) {
    if (drawingIndex === void 0 && vmlDrawingIndex === void 0 && tableName === void 0) return "";
    const config = [];
    if (drawingIndex != null) config.push({
        Id: `rId${config.length + 1}`,
        Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
        Target: `../drawings/drawing${drawingIndex + 1}.xml`
    });
    if (vmlDrawingIndex != null) config.push({
        Id: `rId${config.length + 1}`,
        Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
        Target: `../drawings/vmlDrawing${vmlDrawingIndex + 1}.vml`
    });
    if (tableName != null) config.push({
        Id: `rId${config.length + 1}`,
        Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/table",
        Target: `../tables/${tableName}.xml`
    });
    const rs = $5b7ccabde48fae90$var$relationships_default.getTemplate(config);
    return $5b7ccabde48fae90$var$createXmlPart(rs);
}
function $5b7ccabde48fae90$var$createWorksheet(worksheet, config) {
    return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$worksheet_default.getTemplate({
        worksheet: worksheet,
        currentSheet: $5b7ccabde48fae90$var$XLSX_SHEET_NAMES.length - 1,
        config: config
    }));
}
// packages/ag-grid-enterprise/src/excelExport/excelSerializingSession.ts
var $5b7ccabde48fae90$var$ExcelSerializingSession = class extends (0, $437b23f6a393c3bf$export$5018ab277b833b61) {
    constructor(config){
        super(config);
        this.mixedStyles = {};
        this.mixedStyleCounter = 0;
        this.rows = [];
        this.frozenRowCount = 0;
        this.skipFrozenRows = false;
        this.frozenColumnCount = 0;
        this.skipFrozenColumns = false;
        this.formulaSvc = config.formulaSvc;
        this.config = Object.assign({}, config);
        this.stylesByIds = {};
        for (const style of this.config.baseExcelStyles)this.stylesByIds[style.id] = style;
        this.excelStyles = [
            ...this.config.baseExcelStyles,
            {
                id: "_quotePrefix",
                quotePrefix: 1
            }
        ];
    }
    addCustomContent(customContent) {
        for (const row of customContent){
            const rowLen = this.rows.length + 1;
            let outlineLevel;
            if (!this.config.suppressRowOutline && row.outlineLevel != null) outlineLevel = row.outlineLevel;
            const rowObj = {
                height: $5b7ccabde48fae90$var$getHeightFromProperty(rowLen, row.height || this.config.rowHeight),
                cells: (row.cells || []).map((cell, idx)=>{
                    const image = this.addImage(rowLen, this.columnsToExport[idx], cell.data?.value);
                    let excelStyles = null;
                    if (cell.styleId) excelStyles = typeof cell.styleId === "string" ? [
                        cell.styleId
                    ] : cell.styleId;
                    const excelStyleId = this.getStyleId(excelStyles);
                    if (image) return this.createCell(excelStyleId, this.getDataTypeForValue(image.value), image.value == null ? "" : image.value);
                    const value = cell.data?.value ?? "";
                    const type = this.getDataTypeForValue(value);
                    if (cell.mergeAcross) return this.createMergedCell(excelStyleId, type, value, cell.mergeAcross);
                    return this.createCell(excelStyleId, type, value);
                }),
                outlineLevel: outlineLevel
            };
            if (row.collapsed != null) rowObj.collapsed = row.collapsed;
            if (row.hidden != null) rowObj.hidden = row.hidden;
            this.rows.push(rowObj);
        }
    }
    onNewHeaderGroupingRow() {
        const currentCells = [];
        const { freezeRows: freezeRows, headerRowHeight: headerRowHeight } = this.config;
        this.rows.push({
            cells: currentCells,
            height: $5b7ccabde48fae90$var$getHeightFromProperty(this.rows.length + 1, headerRowHeight)
        });
        if (freezeRows) this.frozenRowCount++;
        return {
            onColumn: (columnGroup, header, index, span, collapsibleGroupRanges)=>{
                const styleIds = this.config.styleLinker({
                    rowType: "HEADER_GROUPING",
                    rowIndex: 1,
                    value: `grouping-${header}`,
                    columnGroup: columnGroup
                });
                currentCells.push({
                    ...this.createMergedCell(this.getStyleId(styleIds), this.getDataTypeForValue("string"), header, span),
                    collapsibleRanges: collapsibleGroupRanges
                });
            }
        };
    }
    onNewHeaderRow() {
        const { freezeRows: freezeRows, headerRowHeight: headerRowHeight } = this.config;
        if (freezeRows) this.frozenRowCount++;
        return this.onNewRow(this.onNewHeaderColumn, headerRowHeight);
    }
    onNewBodyRow(node) {
        const { freezeRows: freezeRows, rowHeight: rowHeight } = this.config;
        if (!this.skipFrozenRows) {
            if (freezeRows === "headersAndPinnedRows" && node?.rowPinned === "top") this.frozenRowCount++;
            else if (typeof freezeRows === "function") {
                if (freezeRows((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
                    node: node
                }))) this.frozenRowCount++;
                else this.skipFrozenRows = true;
            } else this.skipFrozenRows = true;
        }
        const rowAccumulator = this.onNewRow(this.onNewBodyColumn, rowHeight);
        if (node) this.addRowOutlineIfNecessary(node);
        return rowAccumulator;
    }
    prepare(columnsToExport) {
        super.prepare(columnsToExport);
        this.columnsToExport = [
            ...columnsToExport
        ];
        this.cols = columnsToExport.map((col, i)=>this.convertColumnToExcel(col, i));
    }
    parse() {
        const longestRow = this.rows.reduce((a, b)=>Math.max(a, b.cells.length), 0);
        while(this.cols.length < longestRow)this.cols.push(this.convertColumnToExcel(null, this.cols.length + 1));
        const { config: config } = this;
        let name;
        if (config.sheetName != null) {
            const { sheetName: sheetName } = config;
            const sheetNameValue = typeof sheetName === "function" ? sheetName((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {})) : sheetName;
            name = String(sheetNameValue).substring(0, 31);
        } else name = "ag-grid";
        const data = {
            name: name,
            table: {
                columns: this.cols,
                rows: this.rows
            }
        };
        return this.createExcel(data);
    }
    addRowOutlineIfNecessary(node) {
        const { gos: gos, suppressRowOutline: suppressRowOutline, rowGroupExpandState: rowGroupExpandState = "expanded" } = this.config;
        const isGroupHideOpenParents = gos.get("groupHideOpenParents");
        if (isGroupHideOpenParents || suppressRowOutline || node.level == null) return;
        const padding = node.footer ? 1 : 0;
        const currentRow = (0, $437b23f6a393c3bf$export$236389741107357f)(this.rows);
        if (node.uiLevel == null || node.level === node.uiLevel) {
            const outlineLevel = Math.min(node.level + padding, 7);
            currentRow.outlineLevel = outlineLevel;
        }
        if (rowGroupExpandState === "expanded") return;
        const collapseAll = rowGroupExpandState === "collapsed";
        if (node.isExpandable()) {
            const isExpanded = !collapseAll && node.expanded;
            currentRow.collapsed = !isExpanded;
        }
        currentRow.hidden = !!node.parent && // or if it is a child of the root node
        node.parent.level !== -1 && (collapseAll || this.isAnyParentCollapsed(node.parent));
    }
    isAnyParentCollapsed(node) {
        while(node && node.level !== -1){
            if (!node.expanded) return true;
            node = node.parent;
        }
        return false;
    }
    convertColumnToExcel(column, index) {
        const columnWidth = this.config.columnWidth;
        const headerValue = column ? this.extractHeaderValue(column) : void 0;
        const displayName = headerValue ?? "";
        const filterAllowed = column ? column.isFilterAllowed() : false;
        if (columnWidth) {
            if (typeof columnWidth === "number") return {
                width: columnWidth,
                displayName: displayName,
                filterAllowed: filterAllowed
            };
            return {
                width: columnWidth({
                    column: column,
                    index: index
                }),
                displayName: displayName,
                filterAllowed: filterAllowed
            };
        }
        if (column) {
            const smallestUsefulWidth = 75;
            return {
                width: Math.max(column.getActualWidth(), smallestUsefulWidth),
                displayName: displayName,
                filterAllowed: filterAllowed
            };
        }
        return {
            displayName: displayName,
            filterAllowed: filterAllowed
        };
    }
    onNewHeaderColumn(rowIndex, currentCells) {
        return (column)=>{
            const nameForCol = this.extractHeaderValue(column);
            const styleIds = this.config.styleLinker({
                rowType: "HEADER",
                rowIndex: rowIndex,
                value: nameForCol,
                column: column
            });
            currentCells.push(this.createCell(this.getStyleId(styleIds), this.getDataTypeForValue("string"), nameForCol));
        };
    }
    onNewBodyColumn(rowIndex, currentCells) {
        let skipCols = 0;
        const { freezeColumns: freezeColumns, rightToLeft: rightToLeft } = this.config;
        return (column, index, node)=>{
            if (skipCols > 0) {
                skipCols -= 1;
                return;
            }
            if (!this.skipFrozenColumns) {
                const pinned = column.getPinned();
                const isPinnedLeft = pinned === true || pinned === "left";
                if (freezeColumns === "pinned" && pinned && isPinnedLeft !== rightToLeft) this.frozenColumnCount++;
                else if (typeof freezeColumns === "function" && freezeColumns((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
                    column: column
                }))) this.frozenColumnCount++;
                else this.skipFrozenColumns = true;
            }
            const { value: valueForCell, valueFormatted: valueFormatted } = this.extractRowCellValue({
                column: column,
                node: node,
                currentColumnIndex: index,
                accumulatedRowIndex: rowIndex,
                type: "excel",
                useRawFormula: true
            });
            const styleIds = this.config.styleLinker({
                rowType: "BODY",
                rowIndex: rowIndex,
                value: valueForCell,
                column: column,
                node: node
            });
            const excelStyleId = this.getStyleId(styleIds);
            const colSpan = column.getColSpan(node);
            const addedImage = this.addImage(rowIndex, column, valueForCell);
            if (addedImage) currentCells.push(this.createCell(excelStyleId, this.getDataTypeForValue(addedImage.value), addedImage.value == null ? "" : addedImage.value));
            else if (colSpan > 1) {
                skipCols = colSpan - 1;
                currentCells.push(this.createMergedCell(excelStyleId, this.getDataTypeForValue(valueForCell), valueForCell, colSpan - 1));
            } else {
                const isFormula = column.isAllowFormula() && this.formulaSvc?.isFormula(valueForCell);
                const cell = this.createCell(excelStyleId, isFormula ? "f" : this.getDataTypeForValue(valueForCell), isFormula ? this.formulaSvc?.updateFormulaByOffset({
                    value: valueForCell,
                    rowDelta: rowIndex - (node.formulaRowIndex + 1),
                    useRefFormat: false
                }) : valueForCell, valueFormatted);
                currentCells.push(cell);
            }
        };
    }
    onNewRow(onNewColumnAccumulator, height) {
        const currentCells = [];
        this.rows.push({
            cells: currentCells,
            height: $5b7ccabde48fae90$var$getHeightFromProperty(this.rows.length + 1, height)
        });
        return {
            onColumn: onNewColumnAccumulator.bind(this, this.rows.length, currentCells)()
        };
    }
    createExcel(data) {
        const { excelStyles: excelStyles, config: config } = this;
        if (this.frozenColumnCount) config.frozenColumnCount = this.frozenColumnCount;
        if (this.frozenRowCount) config.frozenRowCount = this.frozenRowCount;
        return $5b7ccabde48fae90$var$createXlsxExcel(excelStyles, data, config);
    }
    getDataTypeForValue(valueForCell) {
        if (valueForCell === void 0) return "empty";
        let dataType = "s";
        try {
            if (this.isNumerical(valueForCell)) dataType = "n";
        } catch (e) {}
        return dataType;
    }
    getTypeFromStyle(style, value) {
        if (this.isFormula(value)) return "f";
        if (style?.dataType) switch(style.dataType.toLocaleLowerCase()){
            case "formula":
                return "f";
            case "string":
                return "s";
            case "number":
                return "n";
            case "datetime":
                return "d";
            case "error":
                return "e";
            case "boolean":
                return "b";
            default:
                (0, $437b23f6a393c3bf$export$545083624300f13d)(162, {
                    id: style.id,
                    dataType: style.dataType
                });
        }
        return null;
    }
    addImage(rowIndex, column, value) {
        if (!this.config.addImageToCell) return;
        const addedImage = this.config.addImageToCell(rowIndex, column, value);
        if (!addedImage) return;
        $5b7ccabde48fae90$var$addXlsxBodyImageToMap(addedImage.image, rowIndex, column, this.columnsToExport, this.config.rowHeight);
        return addedImage;
    }
    createCell(styleId, type, value, valueFormatted) {
        const actualStyle = this.getStyleById(styleId);
        if (!actualStyle?.dataType && type === "s" && valueFormatted != null) value = valueFormatted;
        const processedType = this.getTypeFromStyle(actualStyle, value) || type;
        const { value: processedValue, escaped: escaped } = this.getCellValue(processedType, value);
        const styles = [];
        if (actualStyle) styles.push(styleId);
        if (escaped) styles.push("_quotePrefix");
        styleId = this.getStyleId(styles) || void 0;
        return {
            styleId: styleId,
            data: {
                type: processedType,
                value: processedValue
            }
        };
    }
    createMergedCell(styleId, type, value, numOfCells) {
        const valueToUse = value == null ? "" : value;
        return {
            styleId: this.getStyleById(styleId) ? styleId : void 0,
            data: {
                type: type,
                value: type === "s" ? $5b7ccabde48fae90$var$getXlsxStringPosition(valueToUse).toString() : value
            },
            mergeAcross: numOfCells
        };
    }
    getCellValue(type, value) {
        let escaped = false;
        if (value == null || type === "s" && value === "") return {
            value: "",
            escaped: false
        };
        if (type === "s") {
            if (value && value[0] === "'") {
                escaped = true;
                value = value.slice(1);
            }
            value = $5b7ccabde48fae90$var$getXlsxStringPosition(value).toString();
        } else if (type === "f") value = this.addXlfnPrefix(value).slice(1);
        else if (type === "n") {
            const numberValue = Number(value);
            if (isNaN(numberValue)) value = "";
            else if (value !== "") value = numberValue.toString();
        }
        return {
            value: value,
            escaped: escaped
        };
    }
    addXlfnPrefix(value) {
        if (!value) return value;
        const concatRegex = /(^|[^A-Z0-9._])(CONCAT)(\s*\()/gi;
        return value.replace(concatRegex, (_match, prefix, fn, openParen)=>`${prefix}_xlfn.${fn}${openParen}`);
    }
    getStyleId(styleIds) {
        if (!styleIds?.length) return null;
        if (styleIds.length === 1) return styleIds[0];
        const key = styleIds.join("-");
        if (!this.mixedStyles[key]) this.addNewMixedStyle(styleIds);
        return this.mixedStyles[key].excelID;
    }
    deepCloneObject(object) {
        return JSON.parse(JSON.stringify(object));
    }
    addNewMixedStyle(styleIds) {
        this.mixedStyleCounter += 1;
        const excelId = `mixedStyle${this.mixedStyleCounter}`;
        const resultantStyle = {};
        for (const styleId of styleIds){
            for (const excelStyle of this.excelStyles)if (excelStyle.id === styleId) (0, $437b23f6a393c3bf$export$8ade6bd474fcde42)(resultantStyle, this.deepCloneObject(excelStyle));
        }
        resultantStyle.id = excelId;
        const key = styleIds.join("-");
        this.mixedStyles[key] = {
            excelID: excelId,
            key: key,
            result: resultantStyle
        };
        this.excelStyles.push(resultantStyle);
        this.stylesByIds[excelId] = resultantStyle;
    }
    isFormula(value) {
        if (value == null) return false;
        const strValue = String(value);
        return this.config.autoConvertFormulas && (0, $437b23f6a393c3bf$export$8e19bf64bae2d78a)(strValue);
    }
    isNumerical(value) {
        if (typeof value === "bigint") return true;
        return isFinite(value) && value !== "" && !isNaN(parseFloat(value));
    }
    getStyleById(styleId) {
        if (styleId == null) return null;
        return this.stylesByIds[styleId] || null;
    }
};
// packages/ag-grid-enterprise/src/excelExport/zipContainer/compress.ts
var $5b7ccabde48fae90$var$compressBlob = async (data)=>{
    let chunksSize = 0;
    const chunks = [];
    const writeCompressedData = new WritableStream({
        write: (chunk)=>{
            chunks.push(chunk);
            chunksSize += chunk.length;
        }
    });
    const readable = new ReadableStream({
        start: (controller)=>{
            const reader = new FileReader();
            reader.onload = (e)=>{
                if (e.target?.result) controller.enqueue(e.target.result);
                controller.close();
            };
            reader.readAsArrayBuffer(data);
        }
    });
    const compressStream = new window.CompressionStream("deflate-raw");
    await readable.pipeThrough(compressStream).pipeTo(writeCompressedData);
    return {
        size: chunksSize,
        content: new Blob(chunks)
    };
};
var $5b7ccabde48fae90$var$deflateLocalFile = async (rawContent)=>{
    const contentAsBlob = new Blob([
        rawContent
    ]);
    const { size: compressedSize, content: compressedContent } = await $5b7ccabde48fae90$var$compressBlob(contentAsBlob);
    const compressedContentAsUint8Array = new Uint8Array(await compressedContent.arrayBuffer());
    return {
        size: compressedSize,
        content: compressedContentAsUint8Array
    };
};
// packages/ag-grid-enterprise/src/excelExport/zipContainer/convert.ts
var $5b7ccabde48fae90$var$convertTime = (date)=>{
    let time = date.getHours();
    time <<= 6;
    time = time | date.getMinutes();
    time <<= 5;
    time = time | date.getSeconds() / 2;
    return time;
};
var $5b7ccabde48fae90$var$convertDate = (date)=>{
    let dt = date.getFullYear() - 1980;
    dt <<= 4;
    dt = dt | date.getMonth() + 1;
    dt <<= 5;
    dt = dt | date.getDate();
    return dt;
};
function $5b7ccabde48fae90$var$convertDecToHex(number, bytes) {
    let hex = "";
    for(let i = 0; i < bytes; i++){
        hex += String.fromCharCode(number & 255);
        number >>>= 8;
    }
    return hex;
}
// packages/ag-grid-enterprise/src/excelExport/zipContainer/crcTable.ts
var $5b7ccabde48fae90$var$getCrcFromCrc32TableAndByteArray = (content)=>{
    if (!content.length) return 0;
    let crc = -1;
    let j = 0;
    let k = 0;
    let l = 0;
    for(let i = 0; i < content.length; i++){
        j = content[i];
        k = (crc ^ j) & 255;
        l = $5b7ccabde48fae90$var$crcTable[k];
        crc = crc >>> 8 ^ l;
    }
    return crc ^ -1;
};
var $5b7ccabde48fae90$var$getCrcFromCrc32Table = (content)=>{
    if (!content.length) return 0;
    if (typeof content === "string") return $5b7ccabde48fae90$var$getCrcFromCrc32TableAndByteArray(new TextEncoder().encode(content));
    return $5b7ccabde48fae90$var$getCrcFromCrc32TableAndByteArray(content);
};
var $5b7ccabde48fae90$var$crcTable = /* @__PURE__ */ new Uint32Array([
    0,
    1996959894,
    3993919788,
    2567524794,
    124634137,
    1886057615,
    3915621685,
    2657392035,
    249268274,
    2044508324,
    3772115230,
    2547177864,
    162941995,
    2125561021,
    3887607047,
    2428444049,
    498536548,
    1789927666,
    4089016648,
    2227061214,
    450548861,
    1843258603,
    4107580753,
    2211677639,
    325883990,
    1684777152,
    4251122042,
    2321926636,
    335633487,
    1661365465,
    4195302755,
    2366115317,
    997073096,
    1281953886,
    3579855332,
    2724688242,
    1006888145,
    1258607687,
    3524101629,
    2768942443,
    901097722,
    1119000684,
    3686517206,
    2898065728,
    853044451,
    1172266101,
    3705015759,
    2882616665,
    651767980,
    1373503546,
    3369554304,
    3218104598,
    565507253,
    1454621731,
    3485111705,
    3099436303,
    671266974,
    1594198024,
    3322730930,
    2970347812,
    795835527,
    1483230225,
    3244367275,
    3060149565,
    1994146192,
    31158534,
    2563907772,
    4023717930,
    1907459465,
    112637215,
    2680153253,
    3904427059,
    2013776290,
    251722036,
    2517215374,
    3775830040,
    2137656763,
    141376813,
    2439277719,
    3865271297,
    1802195444,
    476864866,
    2238001368,
    4066508878,
    1812370925,
    453092731,
    2181625025,
    4111451223,
    1706088902,
    314042704,
    2344532202,
    4240017532,
    1658658271,
    366619977,
    2362670323,
    4224994405,
    1303535960,
    984961486,
    2747007092,
    3569037538,
    1256170817,
    1037604311,
    2765210733,
    3554079995,
    1131014506,
    879679996,
    2909243462,
    3663771856,
    1141124467,
    855842277,
    2852801631,
    3708648649,
    1342533948,
    654459306,
    3188396048,
    3373015174,
    1466479909,
    544179635,
    3110523913,
    3462522015,
    1591671054,
    702138776,
    2966460450,
    3352799412,
    1504918807,
    783551873,
    3082640443,
    3233442989,
    3988292384,
    2596254646,
    62317068,
    1957810842,
    3939845945,
    2647816111,
    81470997,
    1943803523,
    3814918930,
    2489596804,
    225274430,
    2053790376,
    3826175755,
    2466906013,
    167816743,
    2097651377,
    4027552580,
    2265490386,
    503444072,
    1762050814,
    4150417245,
    2154129355,
    426522225,
    1852507879,
    4275313526,
    2312317920,
    282753626,
    1742555852,
    4189708143,
    2394877945,
    397917763,
    1622183637,
    3604390888,
    2714866558,
    953729732,
    1340076626,
    3518719985,
    2797360999,
    1068828381,
    1219638859,
    3624741850,
    2936675148,
    906185462,
    1090812512,
    3747672003,
    2825379669,
    829329135,
    1181335161,
    3412177804,
    3160834842,
    628085408,
    1382605366,
    3423369109,
    3138078467,
    570562233,
    1426400815,
    3317316542,
    2998733608,
    733239954,
    1555261956,
    3268935591,
    3050360625,
    752459403,
    1541320221,
    2607071920,
    3965973030,
    1969922972,
    40735498,
    2617837225,
    3943577151,
    1913087877,
    83908371,
    2512341634,
    3803740692,
    2075208622,
    213261112,
    2463272603,
    3855990285,
    2094854071,
    198958881,
    2262029012,
    4057260610,
    1759359992,
    534414190,
    2176718541,
    4139329115,
    1873836001,
    414664567,
    2282248934,
    4279200368,
    1711684554,
    285281116,
    2405801727,
    4167216745,
    1634467795,
    376229701,
    2685067896,
    3608007406,
    1308918612,
    956543938,
    2808555105,
    3495958263,
    1231636301,
    1047427035,
    2932959818,
    3654703836,
    1088359270,
    936918e3,
    2847714899,
    3736837829,
    1202900863,
    817233897,
    3183342108,
    3401237130,
    1404277552,
    615818150,
    3134207493,
    3453421203,
    1423857449,
    601450431,
    3009837614,
    3294710456,
    1567103746,
    711928724,
    3020668471,
    3272380065,
    1510334235,
    755167117
]);
// packages/ag-grid-enterprise/src/excelExport/zipContainer/zipContainerHelper.ts
function $5b7ccabde48fae90$var$_utf8_encode(s2) {
    const stringFromCharCode = String.fromCharCode;
    function ucs2decode(string) {
        const output = [];
        if (!string) return [];
        const len = string.length;
        let counter = 0;
        let value;
        let extra;
        while(counter < len){
            value = string.charCodeAt(counter++);
            if (value >= 55296 && value <= 56319 && counter < len) {
                extra = string.charCodeAt(counter++);
                if ((extra & 64512) == 56320) output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
                else {
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    function checkScalarValue(point) {
        if (point >= 55296 && point <= 57343) throw Error((0, $437b23f6a393c3bf$export$680bb5102fca525e)(255, {
            point: point
        }));
    }
    function createByte(point, shift) {
        return stringFromCharCode(point >> shift & 63 | 128);
    }
    function encodeCodePoint(point) {
        if ((point & 4294967168) == 0) return stringFromCharCode(point);
        let symbol = "";
        if ((point & 4294965248) == 0) symbol = stringFromCharCode(point >> 6 & 31 | 192);
        else if ((point & 4294901760) == 0) {
            checkScalarValue(point);
            symbol = stringFromCharCode(point >> 12 & 15 | 224);
            symbol += createByte(point, 6);
        } else if ((point & 4292870144) == 0) {
            symbol = stringFromCharCode(point >> 18 & 7 | 240);
            symbol += createByte(point, 12);
            symbol += createByte(point, 6);
        }
        symbol += stringFromCharCode(point & 63 | 128);
        return symbol;
    }
    const codePoints = ucs2decode(s2);
    const length = codePoints.length;
    let index = -1;
    let codePoint;
    let byteString = "";
    while(++index < length){
        codePoint = codePoints[index];
        byteString += encodeCodePoint(codePoint);
    }
    return byteString;
}
var $5b7ccabde48fae90$var$getHeaders = (currentFile, isCompressed, offset, rawSize, rawContent, deflatedSize)=>{
    const { content: content, path: path, created: creationDate } = currentFile;
    const time = $5b7ccabde48fae90$var$convertTime(creationDate);
    const dt = $5b7ccabde48fae90$var$convertDate(creationDate);
    const crcFlag = $5b7ccabde48fae90$var$getCrcFromCrc32Table(rawContent);
    const zipSize = deflatedSize !== void 0 ? deflatedSize : rawSize;
    const utfPath = $5b7ccabde48fae90$var$_utf8_encode(path);
    const isUTF8 = utfPath !== path;
    let extraFields = "";
    if (isUTF8) {
        const uExtraFieldPath = $5b7ccabde48fae90$var$convertDecToHex(1, 1) + $5b7ccabde48fae90$var$convertDecToHex($5b7ccabde48fae90$var$getCrcFromCrc32Table(utfPath), 4) + utfPath;
        extraFields = "up" + $5b7ccabde48fae90$var$convertDecToHex(uExtraFieldPath.length, 2) + uExtraFieldPath;
    }
    const commonHeader = "\0" + // version needed to extract
    (isUTF8 ? "\0\b" : "\0\0") + // Language encoding flag (EFS) (12th bit turned on)
    $5b7ccabde48fae90$var$convertDecToHex(isCompressed ? 8 : 0, 2) + // As per ECMA-376 Part 2 specs
    $5b7ccabde48fae90$var$convertDecToHex(time, 2) + // last modified time
    $5b7ccabde48fae90$var$convertDecToHex(dt, 2) + // last modified date
    $5b7ccabde48fae90$var$convertDecToHex(zipSize ? crcFlag : 0, 4) + $5b7ccabde48fae90$var$convertDecToHex(deflatedSize ?? rawSize, 4) + // compressed size
    $5b7ccabde48fae90$var$convertDecToHex(rawSize, 4) + // uncompressed size
    $5b7ccabde48fae90$var$convertDecToHex(utfPath.length, 2) + // file name length
    $5b7ccabde48fae90$var$convertDecToHex(extraFields.length, 2);
    const localFileHeader = "PK" + commonHeader + utfPath + extraFields;
    const centralDirectoryHeader = "PK\0" + commonHeader + // file header
    "\0\0\0\0\0\0" + (content ? "\0\0\0\0" : "\0\0\0") + // external file attributes
    $5b7ccabde48fae90$var$convertDecToHex(offset, 4) + // relative offset of local header
    utfPath + // file name
    extraFields;
    return {
        localFileHeader: Uint8Array.from(localFileHeader, (c)=>c.charCodeAt(0)),
        centralDirectoryHeader: Uint8Array.from(centralDirectoryHeader, (c)=>c.charCodeAt(0))
    };
};
var $5b7ccabde48fae90$var$getDecodedContent = (content)=>{
    let contentToUse;
    if (typeof content === "string") {
        const base64String = atob(content.split(";base64,")[1]);
        contentToUse = Uint8Array.from(base64String, (c)=>c.charCodeAt(0));
    } else contentToUse = content;
    return {
        size: contentToUse.length,
        content: contentToUse
    };
};
var $5b7ccabde48fae90$var$getDeflatedHeaderAndContent = async (currentFile, offset)=>{
    const { content: content } = currentFile;
    const { size: size, content: rawContent } = !content ? {
        size: 0,
        content: Uint8Array.from([])
    } : $5b7ccabde48fae90$var$getDecodedContent(content);
    let deflatedContent = void 0;
    let deflatedSize = void 0;
    let deflationPerformed = false;
    const shouldDeflate = currentFile.type === "file" && rawContent && size > 0;
    if (shouldDeflate) {
        const result = await $5b7ccabde48fae90$var$deflateLocalFile(rawContent);
        deflatedContent = result.content;
        deflatedSize = result.size;
        deflationPerformed = true;
    }
    const headers = $5b7ccabde48fae90$var$getHeaders(currentFile, deflationPerformed, offset, size, rawContent, deflatedSize);
    return {
        ...headers,
        content: deflatedContent || rawContent,
        isCompressed: deflationPerformed
    };
};
var $5b7ccabde48fae90$var$getHeaderAndContent = (currentFile, offset)=>{
    const { content: content } = currentFile;
    const { content: rawContent } = !content ? {
        content: Uint8Array.from([])
    } : $5b7ccabde48fae90$var$getDecodedContent(content);
    const headers = $5b7ccabde48fae90$var$getHeaders(currentFile, false, offset, rawContent.length, rawContent, void 0);
    return {
        ...headers,
        content: rawContent,
        isCompressed: false
    };
};
var $5b7ccabde48fae90$var$buildCentralDirectoryEnd = (tLen, cLen, lLen)=>{
    const str = "PK\0\0\0\0" + $5b7ccabde48fae90$var$convertDecToHex(tLen, 2) + // total number of entries in the central folder
    $5b7ccabde48fae90$var$convertDecToHex(tLen, 2) + // total number of entries in the central folder
    $5b7ccabde48fae90$var$convertDecToHex(cLen, 4) + // size of the central folder
    $5b7ccabde48fae90$var$convertDecToHex(lLen, 4) + // central folder start offset
    "\0\0";
    return Uint8Array.from(str, (c)=>c.charCodeAt(0));
};
// packages/ag-grid-enterprise/src/excelExport/zipContainer/zipContainer.ts
var $5b7ccabde48fae90$var$ZipContainer = class {
    constructor(){
        this.folders = [];
        this.files = [];
    }
    addFolders(paths) {
        paths.forEach(this.addFolder.bind(this));
    }
    addFolder(path) {
        this.folders.push({
            path: path,
            created: /* @__PURE__ */ new Date(),
            isBase64: false,
            type: "folder"
        });
    }
    addFile(path, content, isBase64 = false) {
        this.files.push({
            path: path,
            created: /* @__PURE__ */ new Date(),
            content: isBase64 ? content : new TextEncoder().encode(content),
            isBase64: isBase64,
            type: "file"
        });
    }
    async getZipFile(mimeType = "application/zip") {
        const textOutput = await this.buildCompressedFileStream();
        this.clearStream();
        return new Blob([
            textOutput
        ], {
            type: mimeType
        });
    }
    getUncompressedZipFile(mimeType = "application/zip") {
        const textOutput = this.buildFileStream();
        this.clearStream();
        return new Blob([
            textOutput
        ], {
            type: mimeType
        });
    }
    clearStream() {
        this.folders = [];
        this.files = [];
    }
    packageFiles(files) {
        let fileLen = 0;
        let folderLen = 0;
        for (const currentFile of files){
            const { localFileHeader: localFileHeader, centralDirectoryHeader: centralDirectoryHeader, content: content } = currentFile;
            fileLen += localFileHeader.length + content.length;
            folderLen += centralDirectoryHeader.length;
        }
        const fileData = new Uint8Array(fileLen);
        const folderData = new Uint8Array(folderLen);
        let fileOffset = 0;
        let folderOffset = 0;
        for (const currentFile of files){
            const { localFileHeader: localFileHeader, centralDirectoryHeader: centralDirectoryHeader, content: content } = currentFile;
            fileData.set(localFileHeader, fileOffset);
            fileOffset += localFileHeader.length;
            fileData.set(content, fileOffset);
            fileOffset += content.length;
            folderData.set(centralDirectoryHeader, folderOffset);
            folderOffset += centralDirectoryHeader.length;
        }
        const folderEnd = $5b7ccabde48fae90$var$buildCentralDirectoryEnd(files.length, folderLen, fileLen);
        const result = new Uint8Array(fileData.length + folderData.length + folderEnd.length);
        result.set(fileData);
        result.set(folderData, fileData.length);
        result.set(folderEnd, fileData.length + folderData.length);
        return result;
    }
    async buildCompressedFileStream() {
        const totalFiles = [
            ...this.folders,
            ...this.files
        ];
        const readyFiles = [];
        let lL = 0;
        for (const currentFile of totalFiles){
            const output = await $5b7ccabde48fae90$var$getDeflatedHeaderAndContent(currentFile, lL);
            const { localFileHeader: localFileHeader, content: content } = output;
            readyFiles.push(output);
            lL += localFileHeader.length + content.length;
        }
        return this.packageFiles(readyFiles);
    }
    buildFileStream() {
        const totalFiles = [
            ...this.folders,
            ...this.files
        ];
        const readyFiles = [];
        let lL = 0;
        for (const currentFile of totalFiles){
            const readyFile = $5b7ccabde48fae90$var$getHeaderAndContent(currentFile, lL);
            const { localFileHeader: localFileHeader, content: content } = readyFile;
            readyFiles.push(readyFile);
            lL += localFileHeader.length + content.length;
        }
        return this.packageFiles(readyFiles);
    }
};
// packages/ag-grid-enterprise/src/excelExport/excelCreator.ts
var $5b7ccabde48fae90$var$createExcelXMLCoreFolderStructure = (zipContainer)=>{
    zipContainer.addFolders([
        "_rels/",
        "docProps/",
        "xl/",
        "xl/theme/",
        "xl/_rels/",
        "xl/worksheets/"
    ]);
    if (!$5b7ccabde48fae90$var$XLSX_IMAGES.size) return;
    zipContainer.addFolders([
        "xl/worksheets/_rels",
        "xl/drawings/",
        "xl/drawings/_rels",
        "xl/media/"
    ]);
    let imgCounter = 0;
    $5b7ccabde48fae90$var$XLSX_IMAGES.forEach((value)=>{
        const firstImage = value[0].image[0];
        const { base64: base64, imageType: imageType } = firstImage;
        zipContainer.addFile(`xl/media/image${++imgCounter}.${$5b7ccabde48fae90$var$_normaliseImageExtension(imageType)}`, base64, true);
    });
};
var $5b7ccabde48fae90$var$createExcelXmlWorksheets = (zipContainer, data)=>{
    let imageRelationCounter = 0;
    let headerFooterImageCounter = 0;
    for(let i = 0; i < data.length; i++){
        const value = data[i];
        zipContainer.addFile(`xl/worksheets/sheet${i + 1}.xml`, value, false);
        const hasImages = $5b7ccabde48fae90$var$XLSX_IMAGES.size > 0 && $5b7ccabde48fae90$var$XLSX_WORKSHEET_IMAGES.has(i);
        const tableData = $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.size > 0 && $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES.get(i);
        const hasHeaderFooterImages = $5b7ccabde48fae90$var$XLSX_IMAGES.size && $5b7ccabde48fae90$var$XLSX_WORKSHEET_HEADER_FOOTER_IMAGES.has(i);
        if (!hasImages && !tableData && !hasHeaderFooterImages) continue;
        let tableName;
        let drawingIndex;
        let vmlDrawingIndex;
        if (hasImages) {
            $5b7ccabde48fae90$var$createExcelXmlDrawings(zipContainer, i, imageRelationCounter);
            drawingIndex = imageRelationCounter;
            imageRelationCounter++;
        }
        if (hasHeaderFooterImages) {
            $5b7ccabde48fae90$var$createExcelVmlDrawings(zipContainer, i, headerFooterImageCounter);
            vmlDrawingIndex = headerFooterImageCounter;
            headerFooterImageCounter++;
        }
        if (tableData) tableName = tableData.name;
        const worksheetRelFile = `xl/worksheets/_rels/sheet${i + 1}.xml.rels`;
        zipContainer.addFile(worksheetRelFile, $5b7ccabde48fae90$var$createXlsxRelationships({
            tableName: tableName,
            drawingIndex: drawingIndex,
            vmlDrawingIndex: vmlDrawingIndex
        }));
    }
};
var $5b7ccabde48fae90$var$createExcelXmlDrawings = (zipContainer, sheetIndex, drawingIndex)=>{
    const drawingFolder = "xl/drawings";
    const drawingFileName = `${drawingFolder}/drawing${drawingIndex + 1}.xml`;
    const relFileName = `${drawingFolder}/_rels/drawing${drawingIndex + 1}.xml.rels`;
    zipContainer.addFile(relFileName, $5b7ccabde48fae90$var$createXlsxDrawingRel(sheetIndex));
    zipContainer.addFile(drawingFileName, $5b7ccabde48fae90$var$createXlsxDrawing(sheetIndex));
};
var $5b7ccabde48fae90$var$createExcelVmlDrawings = (zipContainer, sheetIndex, drawingIndex)=>{
    const drawingFolder = "xl/drawings";
    const drawingFileName = `${drawingFolder}/vmlDrawing${drawingIndex + 1}.vml`;
    const relFileName = `${drawingFolder}/_rels/vmlDrawing${drawingIndex + 1}.vml.rels`;
    zipContainer.addFile(drawingFileName, $5b7ccabde48fae90$var$createXlsxVmlDrawing(sheetIndex));
    zipContainer.addFile(relFileName, $5b7ccabde48fae90$var$createXlsxVmlDrawingRel(sheetIndex));
};
var $5b7ccabde48fae90$var$createExcelXmlTables = (zipContainer)=>{
    const tablesDataByWorksheet = $5b7ccabde48fae90$var$XLSX_WORKSHEET_DATA_TABLES;
    const worksheetKeys = Array.from(tablesDataByWorksheet.keys());
    for(let i = 0; i < worksheetKeys.length; i++){
        const sheetIndex = worksheetKeys[i];
        const table = tablesDataByWorksheet.get(sheetIndex);
        if (!table) continue;
        zipContainer.addFile(`xl/tables/${table.name}.xml`, $5b7ccabde48fae90$var$createXlsxTable(table, i));
    }
};
var $5b7ccabde48fae90$var$createExcelXmlCoreSheets = (zipContainer, fontSize, author, sheetLen, activeTab)=>{
    zipContainer.addFile("xl/workbook.xml", $5b7ccabde48fae90$var$createXlsxWorkbook(activeTab));
    zipContainer.addFile("xl/styles.xml", $5b7ccabde48fae90$var$createXlsxStylesheet(fontSize));
    zipContainer.addFile("xl/sharedStrings.xml", $5b7ccabde48fae90$var$createXlsxSharedStrings());
    zipContainer.addFile("xl/theme/theme1.xml", $5b7ccabde48fae90$var$createXlsxTheme());
    zipContainer.addFile("xl/_rels/workbook.xml.rels", $5b7ccabde48fae90$var$createXlsxWorkbookRels(sheetLen));
    zipContainer.addFile("docProps/core.xml", $5b7ccabde48fae90$var$createXlsxCore(author));
    zipContainer.addFile("[Content_Types].xml", $5b7ccabde48fae90$var$createXlsxContentTypes(sheetLen));
    zipContainer.addFile("_rels/.rels", $5b7ccabde48fae90$var$createXlsxRels());
};
var $5b7ccabde48fae90$var$createExcelFileForExcel = (zipContainer, data, options = {})=>{
    if (!data || data.length === 0) {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(159);
        $5b7ccabde48fae90$var$resetXlsxFactory();
        return false;
    }
    const { fontSize: fontSize = 11, author: author = "AG Grid", activeTab: activeTab = 0 } = options;
    const len = data.length;
    const activeTabWithinBounds = Math.max(Math.min(activeTab, len - 1), 0);
    $5b7ccabde48fae90$var$createExcelXMLCoreFolderStructure(zipContainer);
    $5b7ccabde48fae90$var$createExcelXmlTables(zipContainer);
    $5b7ccabde48fae90$var$createExcelXmlWorksheets(zipContainer, data);
    $5b7ccabde48fae90$var$createExcelXmlCoreSheets(zipContainer, fontSize, author, len, activeTabWithinBounds);
    $5b7ccabde48fae90$var$resetXlsxFactory();
    return true;
};
var $5b7ccabde48fae90$var$getMultipleSheetsAsExcelCompressed = (params)=>{
    const { data: data, fontSize: fontSize, author: author, activeSheetIndex: activeSheetIndex } = params;
    const mimeType = params.mimeType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const zipContainer = new $5b7ccabde48fae90$var$ZipContainer();
    if (!$5b7ccabde48fae90$var$createExcelFileForExcel(zipContainer, data, {
        author: author,
        fontSize: fontSize,
        activeTab: activeSheetIndex
    })) return Promise.resolve(void 0);
    return zipContainer.getZipFile(mimeType);
};
var $5b7ccabde48fae90$export$cdca9ad0c864c7f0 = (params)=>{
    const { data: data, fontSize: fontSize, author: author, activeSheetIndex: activeSheetIndex } = params;
    const mimeType = params.mimeType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const zipContainer = new $5b7ccabde48fae90$var$ZipContainer();
    if (!$5b7ccabde48fae90$var$createExcelFileForExcel(zipContainer, data, {
        author: author,
        fontSize: fontSize,
        activeTab: activeSheetIndex
    })) return;
    return zipContainer.getUncompressedZipFile(mimeType);
};
var $5b7ccabde48fae90$export$e871bbb2307806ee = (params)=>{
    const { fileName: fileName = "export.xlsx" } = params;
    $5b7ccabde48fae90$var$getMultipleSheetsAsExcelCompressed(params).then((contents)=>{
        if (contents) {
            const downloadFileName = typeof fileName === "function" ? fileName() : fileName;
            (0, $437b23f6a393c3bf$export$97aef6bcdc3f7ef5)(downloadFileName, contents);
        }
    });
};
var $5b7ccabde48fae90$var$ExcelCreator = class extends (0, $437b23f6a393c3bf$export$b335f23c5aead909) {
    constructor(){
        super(...arguments);
        this.beanName = "excelCreator";
    }
    getMergedParams(params) {
        const baseParams = this.gos.get("defaultExcelExportParams");
        return Object.assign({}, baseParams, params);
    }
    export(userParams) {
        if (this.isExportSuppressed()) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(160);
            return;
        }
        const exportFunc = ()=>{
            const mergedParams = this.getMergedParams(userParams);
            const data = this.getData(mergedParams);
            const exportParams = {
                data: [
                    data
                ],
                fontSize: mergedParams.fontSize,
                author: mergedParams.author,
                mimeType: mergedParams.mimeType
            };
            this.packageCompressedFile(exportParams).then((packageFile)=>{
                if (packageFile) {
                    const { fileName: fileName } = mergedParams;
                    const providedFileName = typeof fileName === "function" ? fileName((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {})) : fileName;
                    (0, $437b23f6a393c3bf$export$97aef6bcdc3f7ef5)(this.getFileName(providedFileName), packageFile);
                }
            });
        };
        const { overlays: overlays } = this.beans;
        if (overlays) overlays.showExportOverlay(exportFunc);
        else exportFunc();
    }
    exportDataAsExcel(params) {
        this.export(params);
    }
    getDataAsExcel(params) {
        const mergedParams = this.getMergedParams(params);
        const data = this.getData(mergedParams);
        const exportParams = {
            data: [
                data
            ],
            fontSize: mergedParams.fontSize,
            author: mergedParams.author,
            mimeType: mergedParams.mimeType
        };
        return this.packageFile(exportParams);
    }
    setFactoryMode(factoryMode) {
        $5b7ccabde48fae90$var$setXlsxFactoryMode(factoryMode);
    }
    getFactoryMode() {
        return $5b7ccabde48fae90$var$getXlsxFactoryMode();
    }
    getSheetDataForExcel(params) {
        const mergedParams = this.getMergedParams(params);
        return this.getData(mergedParams);
    }
    getMultipleSheetsAsExcel(params) {
        return $5b7ccabde48fae90$export$cdca9ad0c864c7f0(params);
    }
    exportMultipleSheetsAsExcel(params) {
        $5b7ccabde48fae90$export$e871bbb2307806ee(params);
    }
    getDefaultFileExtension() {
        return "xlsx";
    }
    createSerializingSession(params) {
        const { colModel: colModel, colNames: colNames, rowGroupColsSvc: rowGroupColsSvc, valueSvc: valueSvc, formula: formula, gos: gos } = this.beans;
        const config = {
            ...params,
            colModel: colModel,
            colNames: colNames,
            rowGroupColsSvc: rowGroupColsSvc,
            valueSvc: valueSvc,
            formulaSvc: formula,
            gos: gos,
            suppressRowOutline: params.suppressRowOutline || params.skipRowGroups,
            headerRowHeight: params.headerRowHeight || params.rowHeight,
            baseExcelStyles: gos.get("excelStyles") || [],
            rightToLeft: params.rightToLeft ?? gos.get("enableRtl"),
            styleLinker: this.styleLinker.bind(this)
        };
        return new $5b7ccabde48fae90$var$ExcelSerializingSession(config);
    }
    styleLinker(params) {
        const { rowType: rowType, rowIndex: rowIndex, value: value, column: column, columnGroup: columnGroup, node: node } = params;
        const isHeader = rowType === "HEADER";
        const isGroupHeader = rowType === "HEADER_GROUPING";
        const col = isHeader ? column : columnGroup;
        let headerClasses = [];
        const { gos: gos, cellStyles: cellStyles } = this.beans;
        if (isHeader || isGroupHeader) {
            headerClasses.push("header");
            if (isGroupHeader) headerClasses.push("headerGroup");
            if (col) headerClasses = headerClasses.concat((0, $437b23f6a393c3bf$export$9ba3bd48c77c5e8a)(col.getDefinition(), gos, column || null, columnGroup || null));
            return headerClasses;
        }
        const styles = gos.get("excelStyles");
        const applicableStyles = [
            "cell"
        ];
        if (!styles?.length) return applicableStyles;
        const styleIds = styles.map((it)=>{
            return it.id;
        });
        const colDef = column.getDefinition();
        cellStyles?.processAllCellClasses(colDef, (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(gos, {
            value: value,
            data: node.data,
            node: node,
            colDef: colDef,
            column: column,
            rowIndex: rowIndex
        }), (className)=>{
            if (styleIds.indexOf(className) > -1) applicableStyles.push(className);
        });
        return applicableStyles.sort((left, right)=>{
            return styleIds.indexOf(left) < styleIds.indexOf(right) ? -1 : 1;
        });
    }
    isExportSuppressed() {
        return this.gos.get("suppressExcelExport");
    }
    packageCompressedFile(params) {
        return $5b7ccabde48fae90$var$getMultipleSheetsAsExcelCompressed(params);
    }
    packageFile(params) {
        return $5b7ccabde48fae90$export$cdca9ad0c864c7f0(params);
    }
};
// packages/ag-grid-enterprise/src/agStack/agVirtualList.css-GENERATED.ts
var $5b7ccabde48fae90$var$agVirtualListCSS = /*css*/ `:where(.ag-virtual-list-viewport) .ag-tab-guard{position:sticky}.ag-virtual-list-viewport{flex:1 1 auto;height:100%;min-width:0;overflow:auto;position:relative;width:100%}.ag-virtual-list-container{overflow:hidden;position:relative}.ag-virtual-list-item{height:var(--ag-list-item-height);position:absolute;width:100%}`;
// packages/ag-grid-enterprise/src/agStack/agVirtualList.ts
function $5b7ccabde48fae90$var$getVirtualListTemplate(cssIdentifier) {
    return {
        tag: "div",
        cls: `ag-virtual-list-viewport ag-${cssIdentifier}-virtual-list-viewport`,
        role: "presentation",
        children: [
            {
                tag: "div",
                ref: "eContainer",
                cls: `ag-virtual-list-container ag-${cssIdentifier}-virtual-list-container`
            }
        ]
    };
}
var $5b7ccabde48fae90$export$8e1851f3e0fb2e09 = class extends (0, $437b23f6a393c3bf$export$d62d00723c2ea1b5) {
    constructor(stopPropagationCallbacks, params){
        super($5b7ccabde48fae90$var$getVirtualListTemplate(params?.cssIdentifier || "default"));
        this.stopPropagationCallbacks = stopPropagationCallbacks;
        this.renderedRows = /* @__PURE__ */ new Map();
        this.rowHeight = 20;
        this.pageSize = -1;
        this.isScrolling = false;
        this.isHeightFromTheme = true;
        this.eContainer = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.awaitStableCallbacks = [];
        this.registerCSS($5b7ccabde48fae90$var$agVirtualListCSS);
        const { cssIdentifier: cssIdentifier = "default", ariaRole: ariaRole = "listbox", listName: listName, moveItemCallback: moveItemCallback } = params || {};
        this.cssIdentifier = cssIdentifier;
        this.ariaRole = ariaRole;
        this.listName = listName;
        this.moveItemCallback = moveItemCallback;
    }
    postConstruct() {
        this.addScrollListener();
        this.rowHeight = this.getItemHeight();
        this.addResizeObserver();
        this.initialiseTabGuard({
            onFocusIn: (e)=>this.onFocusIn(e),
            onFocusOut: (e)=>this.onFocusOut(e),
            focusInnerElement: (fromBottom)=>this.focusInnerElement(fromBottom),
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e)
        }, this.stopPropagationCallbacks);
        this.refreshAriaProperties();
        this.addManagedEventListeners({
            stylesChanged: this.onStylesChanged.bind(this)
        });
    }
    onStylesChanged(e) {
        if (e.listItemHeightChanged) {
            this.rowHeight = this.getItemHeight();
            this.refresh();
        }
    }
    refreshAriaProperties() {
        const translate = this.getLocaleTextFunc();
        const listName = translate("ariaDefaultListName", this.listName || "List");
        const ariaEl = this.eContainer;
        (0, $437b23f6a393c3bf$export$f8d01fa01787902)(ariaEl, this.model?.getRowCount() > 0 ? this.ariaRole : "presentation");
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(ariaEl, listName);
    }
    addResizeObserver() {
        const listener = ()=>(0, $437b23f6a393c3bf$export$7b1f5bd01973c897)(this.beans, ()=>this.drawVirtualRows());
        const destroyObserver = (0, $437b23f6a393c3bf$export$9aef8476630687be)(this.beans, this.getGui(), listener);
        this.addDestroyFunc(destroyObserver);
    }
    focusInnerElement(fromBottom) {
        this.focusRow(fromBottom ? this.model.getRowCount() - 1 : 0);
        return true;
    }
    onFocusIn(e) {
        const target = e.target;
        if (target.classList.contains("ag-virtual-list-item")) this.lastFocusedRowIndex = (0, $437b23f6a393c3bf$export$70c3a20563598672)(target) - 1;
    }
    onFocusOut(e) {
        if (!this.getFocusableElement().contains(e.relatedTarget)) this.lastFocusedRowIndex = null;
    }
    handleKeyDown(e) {
        const { key: key, shiftKey: shiftKey } = e;
        switch(key){
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN:
                {
                    const isUp = key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP;
                    e.preventDefault();
                    if (shiftKey) this.moveItem(isUp);
                    else this.navigate(isUp);
                }
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_HOME:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_END:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_UP:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_DOWN:
                if (this.navigateToPage(key) !== null) e.preventDefault();
                break;
        }
    }
    onTabKeyDown(e) {
        this.stopPropagationCallbacks?.stopPropagation(e);
        this.forceFocusOutOfContainer(e.shiftKey);
    }
    getNextRow(up) {
        if (this.lastFocusedRowIndex == null) return void 0;
        const nextRow = this.lastFocusedRowIndex + (up ? -1 : 1);
        if (nextRow < 0 || nextRow >= this.model.getRowCount()) return void 0;
        return nextRow;
    }
    moveItem(up) {
        if (!this.moveItemCallback) return;
        const item = this.getComponentAt(this.lastFocusedRowIndex);
        if (!item) return;
        this.moveItemCallback(item, up);
    }
    navigate(up) {
        const nextRow = this.getNextRow(up);
        if (nextRow === void 0) return;
        this.focusRow(nextRow);
    }
    navigateToPage(key, fromItem = "focused") {
        let hasFocus = false;
        if (fromItem === "focused") {
            fromItem = this.getLastFocusedRow();
            hasFocus = true;
        }
        const rowCount = this.model.getRowCount() - 1;
        let newIndex = -1;
        if (key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_HOME) newIndex = 0;
        else if (key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_END) newIndex = rowCount;
        else if (key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_DOWN) newIndex = Math.min(fromItem + this.pageSize, rowCount);
        else if (key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_UP) newIndex = Math.max(fromItem - this.pageSize, 0);
        if (newIndex === -1) return null;
        if (hasFocus) this.focusRow(newIndex);
        else this.ensureIndexVisible(newIndex);
        return newIndex;
    }
    getLastFocusedRow() {
        return this.lastFocusedRowIndex;
    }
    focusRow(rowNumber) {
        if (this.isScrolling) return;
        this.isScrolling = true;
        this.ensureIndexVisible(rowNumber);
        (0, $437b23f6a393c3bf$export$7b1f5bd01973c897)(this.beans, ()=>{
            this.isScrolling = false;
            if (!this.isAlive()) return;
            const renderedRow = this.renderedRows.get(rowNumber);
            if (renderedRow) renderedRow.eDiv.focus();
        });
    }
    getComponentAt(rowIndex) {
        const comp = this.renderedRows.get(rowIndex);
        return comp && comp.rowComponent;
    }
    forEachRenderedRow(func) {
        this.renderedRows.forEach((value, key)=>func(value.rowComponent, key));
    }
    getItemHeight() {
        if (!this.isHeightFromTheme) return this.rowHeight;
        return this.beans.environment.getDefaultListItemHeight();
    }
    /**
   * Returns true if the view had to be scrolled, otherwise, false.
   */ ensureIndexVisible(index, scrollPartialIntoView = true) {
        const lastRow = this.model.getRowCount();
        if (typeof index !== "number" || index < 0 || index >= lastRow) return false;
        const rowTopPixel = index * this.rowHeight;
        const rowBottomPixel = rowTopPixel + this.rowHeight;
        const eGui = this.getGui();
        const viewportTopPixel = eGui.scrollTop;
        const viewportHeight = eGui.offsetHeight;
        const viewportBottomPixel = viewportTopPixel + viewportHeight;
        const diff = scrollPartialIntoView ? 0 : this.rowHeight;
        const viewportScrolledPastRow = viewportTopPixel > rowTopPixel + diff;
        const viewportScrolledBeforeRow = viewportBottomPixel < rowBottomPixel - diff;
        if (viewportScrolledPastRow) {
            eGui.scrollTop = rowTopPixel;
            return true;
        }
        if (viewportScrolledBeforeRow) {
            const newScrollPosition = rowBottomPixel - viewportHeight;
            eGui.scrollTop = newScrollPosition;
            return true;
        }
        return false;
    }
    setComponentCreator(componentCreator) {
        this.componentCreator = componentCreator;
    }
    setComponentUpdater(componentUpdater) {
        this.componentUpdater = componentUpdater;
    }
    getRowHeight() {
        return this.rowHeight;
    }
    getScrollTop() {
        return this.getGui().scrollTop;
    }
    setRowHeight(rowHeight) {
        this.isHeightFromTheme = false;
        this.rowHeight = rowHeight;
        this.refresh();
    }
    refresh(softRefresh) {
        if (this.model == null || !this.isAlive()) return;
        const rowCount = this.model.getRowCount();
        this.eContainer.style.height = `${rowCount * this.rowHeight}px`;
        this.refreshAriaProperties();
        this.awaitStable(()=>{
            if (!this.isAlive()) return;
            if (this.canSoftRefresh(softRefresh)) this.drawVirtualRows(true);
            else {
                this.clearVirtualRows();
                this.drawVirtualRows();
            }
        });
    }
    awaitStable(callback) {
        this.awaitStableCallbacks.push(callback);
        if (this.awaitStableCallbacks.length > 1) return;
        const rowCount = this.model.getRowCount();
        (0, $437b23f6a393c3bf$export$b863e7aac7884b8)(this, ()=>this.eContainer.clientHeight >= rowCount * this.rowHeight, ()=>{
            if (!this.isAlive()) return;
            const callbacks = this.awaitStableCallbacks;
            this.awaitStableCallbacks = [];
            for (const c of callbacks)c();
        });
    }
    canSoftRefresh(softRefresh) {
        return !!(softRefresh && this.renderedRows.size && typeof this.model.areRowsEqual === "function" && this.componentUpdater);
    }
    clearVirtualRows() {
        this.renderedRows.forEach((_, rowIndex)=>this.removeRow(rowIndex));
    }
    drawVirtualRows(softRefresh) {
        if (!this.isAlive() || !this.model) return;
        const gui = this.getGui();
        const topPixel = gui.scrollTop;
        const bottomPixel = topPixel + gui.offsetHeight;
        if (topPixel === bottomPixel) this.clearVirtualRows();
        else {
            const firstRow = Math.floor(topPixel / this.rowHeight);
            const lastRow = Math.floor(bottomPixel / this.rowHeight);
            this.pageSize = Math.floor((bottomPixel - topPixel) / this.rowHeight);
            this.ensureRowsRendered(firstRow, lastRow, softRefresh);
        }
    }
    ensureRowsRendered(start, finish, softRefresh) {
        this.renderedRows.forEach((_, rowIndex)=>{
            if ((rowIndex < start || rowIndex > finish) && rowIndex !== this.lastFocusedRowIndex) this.removeRow(rowIndex);
        });
        if (softRefresh) this.refreshRows();
        for(let rowIndex = start; rowIndex <= finish; rowIndex++){
            if (this.renderedRows.has(rowIndex)) continue;
            if (rowIndex < this.model.getRowCount()) this.insertRow(rowIndex);
        }
    }
    insertRow(rowIndex) {
        const value = this.model.getRow(rowIndex);
        const role = this.ariaRole === "tree" ? "treeitem" : "option";
        const eDiv = (0, $437b23f6a393c3bf$export$378bc9c64290bc8b)({
            tag: "div",
            cls: `ag-virtual-list-item ag-${this.cssIdentifier}-virtual-list-item`,
            role: role,
            attrs: {
                tabindex: "-1"
            }
        });
        (0, $437b23f6a393c3bf$export$3d494c2007bbcac1)(eDiv, this.model.getRowCount());
        (0, $437b23f6a393c3bf$export$c3d3aede41065a84)(eDiv, rowIndex + 1);
        eDiv.style.height = `${this.rowHeight}px`;
        eDiv.style.top = `${this.rowHeight * rowIndex}px`;
        const rowComponent = this.componentCreator(value, eDiv);
        rowComponent.addGuiEventListener("focusin", ()=>this.lastFocusedRowIndex = rowIndex);
        eDiv.appendChild(rowComponent.getGui());
        if (this.renderedRows.has(rowIndex - 1)) this.renderedRows.get(rowIndex - 1).eDiv.insertAdjacentElement("afterend", eDiv);
        else if (this.renderedRows.has(rowIndex + 1)) this.renderedRows.get(rowIndex + 1).eDiv.insertAdjacentElement("beforebegin", eDiv);
        else this.eContainer.appendChild(eDiv);
        this.renderedRows.set(rowIndex, {
            rowComponent: rowComponent,
            eDiv: eDiv,
            value: value
        });
    }
    removeRow(rowIndex) {
        const component = this.renderedRows.get(rowIndex);
        component.eDiv.remove();
        this.destroyBean(component.rowComponent);
        this.renderedRows.delete(rowIndex);
    }
    refreshRows() {
        const rowCount = this.model.getRowCount();
        this.renderedRows.forEach((row, rowIndex)=>{
            if (rowIndex >= rowCount) this.removeRow(rowIndex);
            else {
                const newValue = this.model.getRow(rowIndex);
                if (this.model.areRowsEqual?.(row.value, newValue)) this.componentUpdater(newValue, row.rowComponent);
                else this.removeRow(rowIndex);
            }
        });
    }
    addScrollListener() {
        this.addGuiEventListener("scroll", ()=>this.drawVirtualRows(), {
            passive: true
        });
    }
    setModel(model) {
        this.model = model;
    }
    getAriaElement() {
        return this.eContainer;
    }
    destroy() {
        if (!this.isAlive()) return;
        this.clearVirtualRows();
        this.awaitStableCallbacks.length = 0;
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/agStack/agVirtualListDragFeature.css-GENERATED.ts
var $5b7ccabde48fae90$var$agVirtualListDragFeatureCSS = /*css*/ `.ag-list-item-hovered:after{background-color:var(--ag-accent-color);content:"";height:1px;left:0;position:absolute;right:0}.ag-item-highlight-top:after{top:0}.ag-item-highlight-bottom:after{bottom:0}`;
// packages/ag-grid-enterprise/src/agStack/agVirtualListDragFeature.ts
var $5b7ccabde48fae90$var$LIST_ITEM_HOVERED = "ag-list-item-hovered";
var $5b7ccabde48fae90$export$f5b514ca2d1e7160 = class extends (0, $437b23f6a393c3bf$export$347db2b30d253083) {
    constructor(comp, virtualList, params){
        super();
        this.comp = comp;
        this.virtualList = virtualList;
        this.params = params;
        this.currentDragValue = null;
        this.lastHoveredListItem = null;
    }
    postConstruct() {
        this.beans.environment.addGlobalCSS($5b7ccabde48fae90$var$agVirtualListDragFeatureCSS, "component-AgVirtualListDragFeature");
        this.params.addListeners(this, this.listItemDragStart.bind(this), this.listItemDragEnd.bind(this));
        this.createDropTarget();
        this.createAutoScrollService();
    }
    listItemDragStart(event) {
        this.currentDragValue = this.params.getCurrentDragValue(event);
        this.moveBlocked = this.params.isMoveBlocked(this.currentDragValue);
    }
    listItemDragEnd() {
        window.setTimeout(()=>{
            this.currentDragValue = null;
            this.moveBlocked = false;
        }, 10);
    }
    createDropTarget() {
        const dropTarget = {
            isInterestedIn: (type)=>type === this.params.dragSourceType,
            getIconName: ()=>this.moveBlocked ? "pinned" : "move",
            getContainer: ()=>this.comp.getGui(),
            onDragging: (e)=>this.onDragging(e),
            onDragStop: ()=>this.onDragStop(),
            onDragLeave: ()=>this.onDragLeave(),
            onDragCancel: ()=>this.onDragCancel()
        };
        this.beans.dragAndDrop?.addDropTarget(dropTarget);
    }
    createAutoScrollService() {
        const virtualListGui = this.virtualList.getGui();
        this.autoScrollService = new (0, $437b23f6a393c3bf$export$c66bdc3d55a4f95)({
            scrollContainer: virtualListGui,
            scrollAxis: "y",
            getVerticalPosition: ()=>virtualListGui.scrollTop,
            setVerticalPosition: (position)=>virtualListGui.scrollTop = position
        });
    }
    onDragging(e) {
        if (!this.currentDragValue || this.moveBlocked) return;
        const hoveredListItem = this.getListDragItem(e);
        const comp = this.virtualList.getComponentAt(hoveredListItem.rowIndex);
        if (!comp) return;
        const el = comp.getGui().parentElement;
        if (this.lastHoveredListItem && this.lastHoveredListItem.rowIndex === hoveredListItem.rowIndex && this.lastHoveredListItem.position === hoveredListItem.position) return;
        this.autoScrollService.check(e.event);
        this.clearHoveredItems();
        this.lastHoveredListItem = hoveredListItem;
        (0, $437b23f6a393c3bf$export$605571c1b2992cfe)(el, $5b7ccabde48fae90$var$LIST_ITEM_HOVERED);
        (0, $437b23f6a393c3bf$export$605571c1b2992cfe)(el, `ag-item-highlight-${hoveredListItem.position}`);
    }
    getListDragItem(e) {
        const virtualListGui = this.virtualList.getGui();
        const paddingTop = Number.parseFloat(window.getComputedStyle(virtualListGui).paddingTop);
        const rowHeight = this.virtualList.getRowHeight();
        const scrollTop = this.virtualList.getScrollTop();
        const rowIndex = Math.max(0, (e.y - paddingTop + scrollTop) / rowHeight);
        const maxLen = this.params.getNumRows(this.comp) - 1;
        const normalizedRowIndex = Math.min(maxLen, rowIndex) | 0;
        return {
            rowIndex: normalizedRowIndex,
            position: Math.round(rowIndex) > rowIndex || rowIndex > maxLen ? "bottom" : "top",
            component: this.virtualList.getComponentAt(normalizedRowIndex)
        };
    }
    onDragStop() {
        if (this.moveBlocked) return;
        this.params.moveItem(this.currentDragValue, this.lastHoveredListItem);
        this.clearDragProperties();
    }
    onDragCancel() {
        this.clearDragProperties();
    }
    onDragLeave() {
        this.clearDragProperties();
    }
    clearDragProperties() {
        this.clearHoveredItems();
        this.autoScrollService.ensureCleared();
    }
    clearHoveredItems() {
        const virtualListGui = this.virtualList.getGui();
        for (const el of virtualListGui.querySelectorAll(`.${$5b7ccabde48fae90$var$LIST_ITEM_HOVERED}`))for (const cls of [
            $5b7ccabde48fae90$var$LIST_ITEM_HOVERED,
            "ag-item-highlight-top",
            "ag-item-highlight-bottom"
        ])el.classList.remove(cls);
        this.lastHoveredListItem = null;
    }
};
var $5b7ccabde48fae90$export$cc850436d767dd9c = class extends (0, $437b23f6a393c3bf$export$9671f513d4aa42e3) {
    constructor(config){
        super(config, "ag-range-field", "range");
    }
    postConstruct() {
        super.postConstruct();
        const { min: min, max: max, step: step } = this.config;
        if (min != null) this.setMinValue(min);
        if (max != null) this.setMaxValue(max);
        this.setStep(step || 1);
    }
    addInputListeners() {
        this.addManagedElementListeners(this.eInput, {
            input: (e)=>{
                const value = e.target.value;
                this.setValue(value);
            }
        });
    }
    setMinValue(value) {
        this.min = value;
        this.eInput.setAttribute("min", value.toString());
        return this;
    }
    setMaxValue(value) {
        this.max = value;
        this.eInput.setAttribute("max", value.toString());
        return this;
    }
    setStep(value) {
        this.eInput.setAttribute("step", value.toString());
        return this;
    }
    setValue(value, silent) {
        if (this.min != null) value = Math.max(parseFloat(value), this.min).toString();
        if (this.max != null) value = Math.min(parseFloat(value), this.max).toString();
        const ret = super.setValue(value, silent);
        this.eInput.value = value;
        return ret;
    }
};
var $5b7ccabde48fae90$export$3c602df24e2a14c7 = {
    selector: "AG-INPUT-RANGE",
    component: $5b7ccabde48fae90$export$cc850436d767dd9c
};
// packages/ag-grid-enterprise/src/agStack/agSlider.ts
var $5b7ccabde48fae90$export$f781195bf2b12bc5 = class extends (0, $437b23f6a393c3bf$export$d72ea6e1c340e03b) {
    constructor(config){
        super(config, /* html */ `<div class="ag-slider">
            <label data-ref="eLabel"></label>
            <div class="ag-wrapper ag-slider-wrapper">
                <ag-input-range data-ref="eSlider"></ag-input-range>
                <ag-input-number-field data-ref="eText"></ag-input-number-field>
            </div>
        </div>`, [
            $5b7ccabde48fae90$export$3c602df24e2a14c7,
            (0, $437b23f6a393c3bf$export$c18153c9c909b7d7)
        ]);
        this.eLabel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eSlider = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eText = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.labelAlignment = "top";
    }
    postConstruct() {
        super.postConstruct();
        this.eSlider.addCss("ag-slider-field");
        const { minValue: minValue, maxValue: maxValue, textFieldWidth: textFieldWidth, step: step, value: value, onValueChange: onValueChange } = this.config;
        if (minValue != null) this.setMinValue(minValue);
        if (maxValue != null) this.setMaxValue(maxValue);
        if (textFieldWidth != null) this.setTextFieldWidth(textFieldWidth);
        if (step != null) this.setStep(step);
        if (value != null) this.setValue(value);
        if (onValueChange != null) this.onValueChange(onValueChange);
    }
    onValueChange(callbackFn) {
        this.addManagedListeners(this.eText, {
            fieldValueChanged: ()=>{
                const textValue = parseFloat(this.eText.getValue());
                this.eSlider.setValue(textValue.toString(), true);
                callbackFn(textValue || 0);
            }
        });
        this.addManagedListeners(this.eSlider, {
            fieldValueChanged: ()=>{
                const sliderValue = this.eSlider.getValue();
                this.eText.setValue(sliderValue, true);
                callbackFn(parseFloat(sliderValue));
            }
        });
        return this;
    }
    setSliderWidth(width) {
        this.eSlider.setWidth(width);
        return this;
    }
    setTextFieldWidth(width) {
        this.eText.setWidth(width);
        return this;
    }
    setMinValue(minValue) {
        this.eSlider.setMinValue(minValue);
        this.eText.setMin(minValue);
        return this;
    }
    setMaxValue(maxValue) {
        this.eSlider.setMaxValue(maxValue);
        this.eText.setMax(maxValue);
        return this;
    }
    getValue() {
        return this.eText.getValue();
    }
    setValue(value, silent) {
        if (this.getValue() === value) return this;
        this.eText.setValue(value, true);
        this.eSlider.setValue(value, true);
        if (!silent) this.dispatchLocalEvent({
            type: "fieldValueChanged"
        });
        return this;
    }
    setStep(step) {
        this.eSlider.setStep(step);
        this.eText.setStep(step);
        return this;
    }
};
var $5b7ccabde48fae90$export$2be649a426f1e774 = {
    selector: "AG-SLIDER",
    component: $5b7ccabde48fae90$export$f781195bf2b12bc5
};
var $5b7ccabde48fae90$var$AgColorInput = class extends (0, $437b23f6a393c3bf$export$8c027679838afd47) {
    constructor(){
        super({
            template: {
                tag: "div",
                cls: "ag-color-input",
                role: "presentation",
                children: [
                    {
                        tag: "div",
                        ref: "eLabel",
                        cls: "ag-input-field-label"
                    },
                    {
                        tag: "div",
                        ref: "eWrapper",
                        cls: "ag-wrapper ag-input-wrapper",
                        role: "presentation",
                        children: [
                            {
                                tag: "input",
                                ref: "eInput",
                                cls: "ag-input-field-input"
                            },
                            {
                                tag: "div",
                                ref: "eColor",
                                cls: "ag-color-input-color"
                            }
                        ]
                    }
                ]
            }
        });
        this.eColor = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    wireBeans(beans) {
        this.color = beans.agChartsExports._Util.Color;
    }
    setColor(color) {
        const rgbaColor = color.toRgbaString();
        this.setValue(this.color.fromString(rgbaColor).toHexString().toUpperCase(), true);
        this.eColor.style.backgroundColor = rgbaColor;
    }
    setValue(value, silent) {
        const isValid = this.color.validColorString(value ?? "");
        this.eInput.setCustomValidity(isValid ? "" : this.getLocaleTextFunc()("invalidColor", "Color value is invalid"));
        super.setValue(value, silent);
        if (isValid && !silent) this.dispatchLocalEvent({
            type: "colorChanged"
        });
        return this;
    }
    onColorChanged(callback) {
        this.addManagedListeners(this, {
            colorChanged: ()=>callback(this.color.fromString(this.value))
        });
    }
};
var $5b7ccabde48fae90$var$AgColorInputSelector = {
    selector: "AG-COLOR-INPUT",
    component: $5b7ccabde48fae90$var$AgColorInput
};
// packages/ag-grid-enterprise/src/agStack/agColorPanel.ts
var $5b7ccabde48fae90$var$maxRecentColors = 8;
var $5b7ccabde48fae90$var$sharedRecentColors = [];
var $5b7ccabde48fae90$var$AgColorPanel = class extends (0, $437b23f6a393c3bf$export$e6818678a6454cbe) {
    constructor(config){
        super(/* html */ `<div class="ag-color-panel" tabindex="-1">
            <div data-ref="spectrumColor" class="ag-spectrum-color">
                <div class="ag-spectrum-sat ag-spectrum-fill">
                    <div data-ref="spectrumVal" class="ag-spectrum-val ag-spectrum-fill">
                        <div data-ref="spectrumDragger" class="ag-spectrum-dragger"></div>
                    </div>
                </div>
            </div>
            <div class="ag-spectrum-tools">
                <div data-ref="spectrumHue" class="ag-spectrum-hue ag-spectrum-tool">
                    <div class="ag-spectrum-hue-background"></div>
                    <div data-ref="spectrumHueSlider" class="ag-spectrum-slider"></div>
                </div>
                <div data-ref="spectrumAlpha" class="ag-spectrum-alpha ag-spectrum-tool">
                    <div class="ag-spectrum-alpha-background"></div>
                    <div data-ref="spectrumAlphaSlider" class="ag-spectrum-slider"></div>
                </div>
                <ag-color-input data-ref="colorInput"></ag-color-input>
                <div data-ref="recentColors" class="ag-recent-colors"></div>
            </div>
        </div>`, [
            $5b7ccabde48fae90$var$AgColorInputSelector
        ]);
        this.H = 1;
        // in the [0, 1] range
        this.S = 1;
        // in the [0, 1] range
        this.B = 1;
        // in the [0, 1] range
        this.A = 1;
        this.isSpectrumDragging = false;
        this.isSpectrumHueDragging = false;
        this.isSpectrumAlphaDragging = false;
        this.colorChanged = false;
        this.spectrumColor = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.spectrumVal = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.spectrumDragger = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.spectrumHue = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.spectrumHueSlider = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.spectrumAlpha = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.spectrumAlphaSlider = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.colorInput = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.recentColors = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.picker = config.picker;
    }
    wireBeans(beans) {
        this._Color = beans.agChartsExports._Util.Color;
    }
    postConstruct() {
        this.initTabIndex();
        this.initRecentColors();
        this.addGuiEventListener("focus", ()=>this.spectrumColor.focus());
        this.addGuiEventListener("keydown", (e)=>{
            if (e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER && !e.defaultPrevented) this.destroy();
        });
        this.addManagedListeners(this.spectrumColor, {
            keydown: (e)=>this.moveDragger(e)
        });
        this.addManagedListeners(this.spectrumAlphaSlider, {
            keydown: (e)=>this.moveAlphaSlider(e)
        });
        this.addManagedListeners(this.spectrumHueSlider, {
            keydown: (e)=>this.moveHueSlider(e)
        });
        this.addManagedListeners(this.spectrumVal, {
            mousedown: this.onSpectrumDraggerDown.bind(this)
        });
        this.addManagedListeners(this.spectrumHue, {
            mousedown: this.onSpectrumHueDown.bind(this)
        });
        this.addManagedListeners(this.spectrumAlpha, {
            mousedown: this.onSpectrumAlphaDown.bind(this)
        });
        this.addGuiEventListener("mousemove", (e)=>{
            this.onSpectrumDraggerMove(e);
            this.onSpectrumHueMove(e);
            this.onSpectrumAlphaMove(e);
        });
        this.addManagedListeners(document, {
            mouseup: this.onMouseUp.bind(this)
        });
        this.colorInput.onColorChanged(this.setColor.bind(this));
        this.addManagedListeners(this.recentColors, {
            click: this.onRecentColorClick.bind(this),
            keydown: (e)=>{
                if (e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER || e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE) {
                    e.preventDefault();
                    this.onRecentColorClick(e);
                }
            }
        });
    }
    initTabIndex() {
        const tabIndex = this.tabIndex = this.gos.get("tabIndex").toString();
        this.spectrumColor.setAttribute("tabindex", tabIndex);
        this.spectrumHueSlider.setAttribute("tabindex", tabIndex);
        this.spectrumAlphaSlider.setAttribute("tabindex", tabIndex);
    }
    refreshSpectrumRect() {
        return this.spectrumValRect = this.spectrumVal.getBoundingClientRect();
    }
    refreshHueRect() {
        return this.spectrumHueRect = this.spectrumHue.getBoundingClientRect();
    }
    refreshAlphaRect() {
        return this.spectrumAlphaRect = this.spectrumAlpha.getBoundingClientRect();
    }
    onSpectrumDraggerDown(e) {
        e.preventDefault();
        this.refreshSpectrumRect();
        this.isSpectrumDragging = true;
        this.moveDragger(e);
    }
    onSpectrumDraggerMove(e) {
        if (this.isSpectrumDragging) this.moveDragger(e);
    }
    onSpectrumHueDown(e) {
        this.refreshHueRect();
        this.isSpectrumHueDragging = true;
        this.moveHueSlider(e);
    }
    onSpectrumHueMove(e) {
        if (this.isSpectrumHueDragging) this.moveHueSlider(e);
    }
    onSpectrumAlphaDown(e) {
        this.refreshAlphaRect();
        this.isSpectrumAlphaDragging = true;
        this.moveAlphaSlider(e);
    }
    onSpectrumAlphaMove(e) {
        if (this.isSpectrumAlphaDragging) this.moveAlphaSlider(e);
    }
    onMouseUp() {
        this.isSpectrumDragging = false;
        this.isSpectrumHueDragging = false;
        this.isSpectrumAlphaDragging = false;
    }
    moveDragger(e) {
        const valRect = this.spectrumValRect;
        if (!valRect) return;
        let x;
        let y;
        if (e instanceof MouseEvent) {
            x = e.clientX - valRect.left;
            y = e.clientY - valRect.top;
        } else {
            const isLeft = e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT;
            const isRight = e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT;
            const isUp = e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP;
            const isDown = e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN;
            const isVertical = isUp || isDown;
            const isHorizontal = isLeft || isRight;
            if (!isVertical && !isHorizontal) return;
            e.preventDefault();
            const { x: currentX, y: currentY } = this.getSpectrumValue();
            x = currentX + (isHorizontal ? isLeft ? -5 : 5 : 0);
            y = currentY + (isVertical ? isUp ? -5 : 5 : 0);
        }
        x = Math.max(x, 0);
        x = Math.min(x, valRect.width);
        y = Math.max(y, 0);
        y = Math.min(y, valRect.height);
        this.setSpectrumValue(x / valRect.width, 1 - y / valRect.height);
    }
    moveHueSlider(e) {
        const rect = this.spectrumHueRect;
        if (!rect) return;
        const x = this.moveSlider(this.spectrumHueSlider, e);
        if (x == null) return;
        this.H = 1 - x / rect.width;
        this.update();
    }
    moveAlphaSlider(e) {
        const rect = this.spectrumAlphaRect;
        if (!rect) return;
        const x = this.moveSlider(this.spectrumAlphaSlider, e);
        if (x == null) return;
        this.A = x / rect.width;
        this.update();
    }
    moveSlider(slider, e) {
        const sliderRect = slider.getBoundingClientRect();
        const parentRect = slider.parentElement?.getBoundingClientRect();
        if (!slider || !parentRect) return null;
        const offset = sliderRect.width / 2;
        let x;
        if (e instanceof MouseEvent) x = Math.floor(e.clientX - parentRect.left);
        else {
            const isLeft = e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT;
            const isRight = e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT;
            if (!isLeft && !isRight) return null;
            e.preventDefault();
            const diff = isLeft ? -5 : 5;
            x = parseFloat(slider.style.left) + offset + diff;
        }
        x = Math.max(x, 0);
        x = Math.min(x, parentRect.width);
        slider.style.left = x - offset + "px";
        return x;
    }
    update(suppressColorInputUpdate) {
        const { A: A, S: S, B: B, H: H, _Color: _Color } = this;
        const hue = H * 360;
        const color = _Color.fromHSB(hue, S, B, A);
        const rgbaColor = color.toRgbaString();
        const colorWithoutAlpha = _Color.fromHSB(hue, S, B);
        const rgbaColorWithoutAlpha = colorWithoutAlpha.toRgbaString();
        const spectrumColor = _Color.fromHSB(hue, 1, 1);
        const spectrumRgbaColor = spectrumColor.toRgbaString();
        const colorPicker = this.picker;
        const existingColor = _Color.fromString(colorPicker.getValue());
        if (existingColor.toRgbaString() !== rgbaColor) this.colorChanged = true;
        colorPicker.setValue(rgbaColor);
        this.spectrumColor.style.backgroundColor = spectrumRgbaColor;
        this.spectrumDragger.style.backgroundColor = rgbaColorWithoutAlpha;
        this.spectrumHueSlider.style.backgroundColor = spectrumRgbaColor;
        this.spectrumAlpha.style.setProperty("--ag-internal-spectrum-alpha-color-from", _Color.fromHSB(hue, S, B, 0).toRgbaString());
        this.spectrumAlpha.style.setProperty("--ag-internal-spectrum-alpha-color-to", rgbaColorWithoutAlpha);
        this.spectrumAlpha.style.setProperty("--ag-internal-spectrum-alpha-color", rgbaColor);
        if (!suppressColorInputUpdate) this.colorInput.setColor(color);
    }
    /**
   * @param saturation In the [0, 1] interval.
   * @param brightness In the [0, 1] interval.
   */ setSpectrumValue(saturation, brightness, suppressColorInputUpdate) {
        const valRect = this.spectrumValRect || this.refreshSpectrumRect();
        if (valRect == null) return;
        const dragger = this.spectrumDragger;
        const draggerRect = dragger.getBoundingClientRect();
        saturation = Math.max(0, saturation);
        saturation = Math.min(1, saturation);
        brightness = Math.max(0, brightness);
        brightness = Math.min(1, brightness);
        this.S = saturation;
        this.B = brightness;
        dragger.style.left = saturation * valRect.width - draggerRect.width / 2 + "px";
        dragger.style.top = (1 - brightness) * valRect.height - draggerRect.height / 2 + "px";
        this.update(suppressColorInputUpdate);
    }
    getSpectrumValue() {
        const dragger = this.spectrumDragger;
        const draggerRect = dragger.getBoundingClientRect();
        const x = parseFloat(dragger.style.left) + draggerRect.width / 2;
        const y = parseFloat(dragger.style.top) + draggerRect.height / 2;
        return {
            x: x,
            y: y
        };
    }
    initRecentColors() {
        const recentColors = $5b7ccabde48fae90$var$sharedRecentColors;
        const colorsHtmlStr = recentColors.map((color, index)=>{
            return /* html */ `<div class="ag-recent-color" id=${index} style="background-color: ${color}; width: 15px; height: 15px;" recent-color="${color}" tabIndex="${this.tabIndex}"></div>`;
        });
        this.recentColors.innerHTML = colorsHtmlStr.join("");
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.recentColors, !!recentColors.length);
    }
    setValue(val) {
        const color = this._Color.fromString(val);
        this.setColor(color, true);
    }
    setColor(color, updateColorInput) {
        const [h, s2, b] = color.toHSB();
        this.H = (isNaN(h) ? 0 : h) / 360;
        this.A = color.a;
        const spectrumHueRect = this.spectrumHueRect || this.refreshHueRect();
        const spectrumAlphaRect = this.spectrumAlphaRect || this.refreshAlphaRect();
        this.spectrumHueSlider.style.left = `${(this.H - 1) * -spectrumHueRect.width - this.spectrumHueSlider.getBoundingClientRect().width / 2}px`;
        this.spectrumAlphaSlider.style.left = `${this.A * spectrumAlphaRect.width - this.spectrumAlphaSlider.getBoundingClientRect().width / 2}px`;
        this.setSpectrumValue(s2, b, !updateColorInput);
    }
    onRecentColorClick(e) {
        const target = e.target;
        if (!(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(target.id)) return;
        const id = parseInt(target.id, 10);
        this.setValue($5b7ccabde48fae90$var$sharedRecentColors[id]);
        this.destroy();
    }
    addRecentColor() {
        const color = this._Color.fromHSB(this.H * 360, this.S, this.B, this.A);
        const rgbaColor = color.toRgbaString();
        let recentColors = $5b7ccabde48fae90$var$sharedRecentColors;
        if (!this.colorChanged || recentColors[0] === rgbaColor) return;
        recentColors = recentColors.filter((currentColor)=>currentColor != rgbaColor);
        recentColors = [
            rgbaColor
        ].concat(recentColors);
        if (recentColors.length > $5b7ccabde48fae90$var$maxRecentColors) recentColors = recentColors.slice(0, $5b7ccabde48fae90$var$maxRecentColors);
        $5b7ccabde48fae90$var$sharedRecentColors = recentColors;
    }
    destroy() {
        this.addRecentColor();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/agStack/agPanel.css-GENERATED.ts
var $5b7ccabde48fae90$var$agPanelCSS = /*css*/ `.ag-panel{background-color:var(--ag-panel-background-color);display:flex;flex-direction:column;overflow:hidden;position:relative}.ag-dialog{border:var(--ag-dialog-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dialog-shadow);position:absolute}.ag-panel-title-bar{align-items:center;background-color:var(--ag-panel-title-bar-background-color);border-bottom:var(--ag-panel-title-bar-border);color:var(--ag-panel-title-bar-text-color);cursor:default;display:flex;flex:none;font-weight:var(--ag-panel-title-bar-font-weight);height:var(--ag-panel-title-bar-height);padding:var(--ag-spacing) var(--ag-cell-horizontal-padding)}.ag-panel-title-bar-button{cursor:pointer;:where(.ag-icon){color:var(--ag-panel-title-bar-icon-color)}}:where(.ag-ltr) .ag-panel-title-bar-button{margin-left:calc(var(--ag-spacing)*2);margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-panel-title-bar-button{margin-left:var(--ag-spacing);margin-right:calc(var(--ag-spacing)*2)}.ag-panel-title-bar-title{flex:1 1 auto}.ag-panel-title-bar-buttons{display:flex}.ag-panel-content-wrapper{display:flex;flex:1 1 auto;overflow:hidden;position:relative}:where(.ag-dragging-fill-handle) .ag-dialog,:where(.ag-dragging-range-handle) .ag-dialog{opacity:.7;pointer-events:none}`;
// packages/ag-grid-enterprise/src/agStack/agPanel.ts
function $5b7ccabde48fae90$var$getTemplate(cssIdentifier) {
    cssIdentifier ?? (cssIdentifier = cssIdentifier || "default");
    return {
        tag: "div",
        cls: `ag-panel ag-${cssIdentifier}-panel`,
        attrs: {
            tabindex: "-1"
        },
        children: [
            {
                tag: "div",
                ref: "eTitleBar",
                cls: `ag-panel-title-bar ag-${cssIdentifier}-panel-title-bar ag-unselectable`,
                children: [
                    {
                        tag: "span",
                        ref: "eTitle",
                        cls: `ag-panel-title-bar-title ag-${cssIdentifier}-panel-title-bar-title`
                    },
                    {
                        tag: "div",
                        ref: "eTitleBarButtons",
                        cls: `ag-panel-title-bar-buttons ag-${cssIdentifier}-panel-title-bar-buttons`
                    }
                ]
            },
            {
                tag: "div",
                ref: "eContentWrapper",
                cls: `ag-panel-content-wrapper ag-${cssIdentifier}-panel-content-wrapper`
            }
        ]
    };
}
var $5b7ccabde48fae90$export$3057d1f56ef1c73f = class extends (0, $437b23f6a393c3bf$export$e6818678a6454cbe) {
    constructor(config){
        super($5b7ccabde48fae90$var$getTemplate(config.cssIdentifier));
        this.config = config;
        this.closable = true;
        this.eContentWrapper = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eTitleBar = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eTitleBarButtons = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eTitle = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.registerCSS($5b7ccabde48fae90$var$agPanelCSS);
    }
    postConstruct() {
        const { component: component, closable: closable, hideTitleBar: hideTitleBar, title: title, minWidth: minWidth = 250, width: width, minHeight: minHeight = 250, height: height, centered: centered, popup: popup, x: x, y: y, postProcessPopupParams: postProcessPopupParams } = this.config;
        const beans = this.beans;
        const positionableFeature = this.createManagedBean(new (0, $437b23f6a393c3bf$export$2da1335e50678d79)(this.getGui(), {
            minWidth: minWidth,
            width: width,
            minHeight: minHeight,
            height: height,
            centered: centered,
            x: x,
            y: y,
            popup: popup,
            calculateTopBuffer: ()=>this.positionableFeature.getHeight() - this.getBodyHeight()
        }));
        this.positionableFeature = positionableFeature;
        const eGui = this.getGui();
        if (component) this.setBodyComponent(component);
        if (!hideTitleBar) {
            if (title) this.setTitle(title);
            this.setClosable(closable != null ? closable : this.closable);
        } else (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eTitleBar, false);
        this.addManagedElementListeners(this.eTitleBar, {
            mousedown: (e)=>{
                if (eGui.contains(e.relatedTarget) || eGui.contains((0, $437b23f6a393c3bf$export$16bc98d422315038)(beans)) || this.eTitleBarButtons.contains(e.target)) {
                    e.preventDefault();
                    return;
                }
                const focusEl = this.eContentWrapper.querySelector("button, [href], input, select, textarea, [tabindex]");
                if (focusEl) focusEl.focus();
            }
        });
        if (popup && positionableFeature.isPositioned()) return;
        if (this.renderComponent) this.renderComponent();
        let postProcessCallback;
        if (postProcessPopupParams) {
            const { type: type, eventSource: eventSource, mouseEvent: mouseEvent } = postProcessPopupParams;
            postProcessCallback = ()=>beans.popupSvc?.callPostProcessPopup(postProcessPopupParams, type, eGui, eventSource, mouseEvent);
        }
        positionableFeature.initialisePosition(postProcessCallback);
        this.eContentWrapper.style.height = "0";
    }
    renderComponent() {
        const eGui = this.getGui();
        eGui.focus();
        this.close = ()=>{
            eGui.remove();
            this.destroy();
        };
    }
    getHeight() {
        return this.positionableFeature.getHeight();
    }
    setHeight(height) {
        this.positionableFeature.setHeight(height);
    }
    getWidth() {
        return this.positionableFeature.getWidth();
    }
    setWidth(width) {
        this.positionableFeature.setWidth(width);
    }
    setClosable(closable) {
        if (closable !== this.closable) this.closable = closable;
        if (closable) {
            const closeButtonComp = this.closeButtonComp = new (0, $437b23f6a393c3bf$export$e6818678a6454cbe)({
                tag: "div",
                cls: "ag-button"
            });
            this.createBean(closeButtonComp);
            const eGui = closeButtonComp.getGui();
            const child = this.beans.iconSvc.createIconNoSpan("close", this.beans);
            child.classList.add("ag-panel-title-bar-button-icon");
            eGui.appendChild(child);
            this.addTitleBarButton(closeButtonComp);
            closeButtonComp.addManagedElementListeners(eGui, {
                click: this.onBtClose.bind(this)
            });
        } else if (this.closeButtonComp) {
            const eGui = this.closeButtonComp.getGui();
            eGui.remove();
            this.closeButtonComp = this.destroyBean(this.closeButtonComp);
        }
    }
    setBodyComponent(bodyComponent) {
        bodyComponent.setParentComponent(this);
        this.eContentWrapper.appendChild(bodyComponent.getGui());
    }
    addTitleBarButton(button, position) {
        const eTitleBarButtons = this.eTitleBarButtons;
        const buttons = eTitleBarButtons.children;
        const len = buttons.length;
        if (position == null) position = len;
        position = Math.max(0, Math.min(position, len));
        button.addCss("ag-panel-title-bar-button");
        const eGui = button.getGui();
        if (position === 0) eTitleBarButtons.insertAdjacentElement("afterbegin", eGui);
        else if (position === len) eTitleBarButtons.insertAdjacentElement("beforeend", eGui);
        else buttons[position - 1].insertAdjacentElement("afterend", eGui);
        button.setParentComponent(this);
    }
    getBodyHeight() {
        return (0, $437b23f6a393c3bf$export$c20e968103d9c16e)(this.eContentWrapper);
    }
    getBodyWidth() {
        return (0, $437b23f6a393c3bf$export$cc615e4191ec3e0c)(this.eContentWrapper);
    }
    setTitle(title) {
        this.eTitle.innerText = title;
    }
    // called when user hits the 'x' in the top right
    onBtClose() {
        this.close();
    }
    destroy() {
        if (this.closeButtonComp) this.closeButtonComp = this.destroyBean(this.closeButtonComp);
        const eGui = this.getGui();
        if (eGui && (0, $437b23f6a393c3bf$export$2badf4aa566524cb)(eGui)) this.close();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/agStack/agDialog.ts
var $5b7ccabde48fae90$export$1ad436e57f28685a = class extends $5b7ccabde48fae90$export$3057d1f56ef1c73f {
    constructor(config, callbacks){
        super({
            ...config,
            popup: true
        });
        this.callbacks = callbacks;
        this.isMaximizable = false;
        this.isMaximized = false;
        this.maximizeListeners = [];
        this.resizeListenerDestroy = null;
        this.lastPosition = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
    }
    postConstruct() {
        const eGui = this.getGui();
        const { movable: movable, resizable: resizable, maximizable: maximizable, modal: modal } = this.config;
        this.addCss("ag-dialog");
        super.postConstruct();
        this.tabGuardFeature = this.createManagedBean(new (0, $437b23f6a393c3bf$export$63dba2ace36fd065)(this, this.callbacks?.stopPropagationCallbacks));
        this.tabGuardFeature.initialiseTabGuard({
            isFocusableContainer: true,
            onFocusIn: ()=>{
                this.popupSvc?.bringPopupToFront(eGui);
            },
            onTabKeyDown: (e)=>{
                if (modal) return;
                const backwards = e.shiftKey;
                const nextFocusableElement = (0, $437b23f6a393c3bf$export$83fc12531358bd28)(this.beans, eGui, false, backwards);
                if (!nextFocusableElement || this.tabGuardFeature.getTabGuardCtrl().isTabGuard(nextFocusableElement)) {
                    if (this.callbacks?.focusNextContainer(this.beans, backwards)) e.preventDefault();
                }
            }
        });
        if (movable) this.setMovable(movable);
        if (maximizable) this.setMaximizable(maximizable);
        if (resizable) this.setResizable(resizable);
        if (!this.config.modal) this.callbacks?.configureFocusableContainer(this.beans, this);
    }
    setAllowFocus(allowFocus) {
        this.tabGuardFeature.getTabGuardCtrl().setAllowFocus(allowFocus);
    }
    renderComponent() {
        const eGui = this.getGui();
        const { alwaysOnTop: alwaysOnTop, modal: modal, title: title, afterGuiAttached: afterGuiAttached } = this.config;
        const translate = this.getLocaleTextFunc();
        const addPopupRes = this.popupSvc?.addPopup({
            modal: modal,
            eChild: eGui,
            closeOnEsc: true,
            closedCallback: this.onClosed.bind(this),
            alwaysOnTop: alwaysOnTop,
            ariaLabel: title || translate("ariaLabelDialog", "Dialog"),
            afterGuiAttached: afterGuiAttached
        });
        if (addPopupRes) this.close = addPopupRes.hideFunc;
    }
    onClosed(event) {
        this.destroy();
        this.config.closedCallback?.(event);
    }
    setMaximized(maximized) {
        if (this.isMaximizable && maximized !== this.isMaximized) this.toggleMaximize();
    }
    toggleMaximize() {
        const position = this.positionableFeature.getPosition();
        if (this.isMaximized) {
            const { x: x, y: y, width: width, height: height } = this.lastPosition;
            this.setWidth(width);
            this.setHeight(height);
            this.positionableFeature.offsetElement(x, y);
        } else {
            this.lastPosition.width = this.getWidth();
            this.lastPosition.height = this.getHeight();
            this.lastPosition.x = position.x;
            this.lastPosition.y = position.y;
            this.positionableFeature.offsetElement(0, 0);
            this.setHeight("100%");
            this.setWidth("100%");
        }
        this.isMaximized = !this.isMaximized;
        this.refreshMaximizeIcon();
    }
    refreshMaximizeIcon() {
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.maximizeIcon, !this.isMaximized);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.minimizeIcon, this.isMaximized);
    }
    clearMaximizebleListeners() {
        if (this.maximizeListeners.length) {
            for (const destroyListener of this.maximizeListeners)destroyListener();
            this.maximizeListeners.length = 0;
        }
        if (this.resizeListenerDestroy) {
            this.resizeListenerDestroy();
            this.resizeListenerDestroy = null;
        }
    }
    destroy() {
        this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp);
        this.clearMaximizebleListeners();
        super.destroy();
    }
    setResizable(resizable) {
        this.positionableFeature.setResizable(resizable);
    }
    setMovable(movable) {
        this.positionableFeature.setMovable(movable, this.eTitleBar);
    }
    setMaximizable(maximizable) {
        if (!maximizable) {
            this.clearMaximizebleListeners();
            if (this.maximizeButtonComp) {
                this.destroyBean(this.maximizeButtonComp);
                this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = void 0;
            }
            return;
        }
        const eTitleBar = this.eTitleBar;
        if (!eTitleBar || maximizable === this.isMaximizable) return;
        this.isMaximizable = maximizable;
        const maximizeButtonComp = this.buildMaximizeAndMinimizeElements();
        this.refreshMaximizeIcon();
        maximizeButtonComp.addManagedElementListeners(maximizeButtonComp.getGui(), {
            click: this.toggleMaximize.bind(this)
        });
        this.addTitleBarButton(maximizeButtonComp, 0);
        this.maximizeListeners.push(...this.addManagedElementListeners(eTitleBar, {
            dblclick: this.toggleMaximize.bind(this)
        }));
        [this.resizeListenerDestroy] = this.addManagedListeners(this.positionableFeature, {
            resize: ()=>{
                this.isMaximized = false;
                this.refreshMaximizeIcon();
            }
        });
    }
    buildMaximizeAndMinimizeElements() {
        const maximizeButtonComp = this.maximizeButtonComp = this.createBean(new (0, $437b23f6a393c3bf$export$e6818678a6454cbe)({
            tag: "div",
            cls: "ag-dialog-button"
        }));
        const eGui = maximizeButtonComp.getGui();
        const iconSvc = this.beans.iconSvc;
        this.maximizeIcon = iconSvc.createIconNoSpan("maximize");
        eGui.appendChild(this.maximizeIcon);
        this.maximizeIcon.classList.add("ag-panel-title-bar-button-icon");
        this.minimizeIcon = iconSvc.createIconNoSpan("minimize");
        eGui.appendChild(this.minimizeIcon);
        this.minimizeIcon.classList.add("ag-panel-title-bar-button-icon");
        return maximizeButtonComp;
    }
};
// packages/ag-grid-enterprise/src/agStack/agColorPicker.ts
var $5b7ccabde48fae90$export$c7bbe886fe0efbe1 = class extends (0, $437b23f6a393c3bf$export$1f14489b6fdeb99b) {
    constructor(config){
        super({
            pickerAriaLabelKey: "ariaLabelColorPicker",
            pickerAriaLabelValue: "Color Picker",
            pickerType: "ag-list",
            className: "ag-color-picker",
            pickerIcon: "chartsColorPicker",
            ...config
        });
    }
    postConstruct() {
        this.eDisplayFieldColor = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "span",
            cls: "ag-color-picker-color"
        });
        this.eDisplayFieldText = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "span",
            cls: "ag-color-picker-value"
        });
        this.eDisplayField.append(this.eDisplayFieldColor, this.eDisplayFieldText);
        super.postConstruct();
        if (this.value) this.setValue(this.value);
    }
    createPickerComponent() {
        const eGuiRect = this.eWrapper.getBoundingClientRect();
        const parentRect = this.beans.popupSvc.getParentRect();
        const colorDialog = this.createBean(new $5b7ccabde48fae90$export$1ad436e57f28685a({
            closable: false,
            modal: true,
            hideTitleBar: true,
            minWidth: 190,
            width: 190,
            height: 250,
            x: eGuiRect.right - parentRect.left - 190,
            y: eGuiRect.top - parentRect.top - 250 - (this.config.pickerGap ?? 0),
            postProcessPopupParams: {
                type: "colorPicker",
                eventSource: this.eWrapper
            }
        }, this.config.dialogCallbacks));
        return colorDialog;
    }
    renderAndPositionPicker() {
        const pickerComponent = this.pickerComponent;
        const colorPanel = this.createBean(new $5b7ccabde48fae90$var$AgColorPanel({
            picker: this
        }));
        pickerComponent.addCss("ag-color-dialog");
        colorPanel.addDestroyFunc(()=>{
            if (pickerComponent.isAlive()) this.destroyBean(pickerComponent);
        });
        pickerComponent.setParentComponent(this);
        pickerComponent.setBodyComponent(colorPanel);
        colorPanel.setValue(this.getValue());
        colorPanel.getGui().focus();
        pickerComponent.addDestroyFunc(()=>{
            if (!this.isDestroyingPicker) {
                this.beforeHidePicker();
                this.isDestroyingPicker = true;
                if (colorPanel.isAlive()) this.destroyBean(colorPanel);
                if (this.isAlive()) this.getFocusableElement().focus();
            } else this.isDestroyingPicker = false;
        });
        return ()=>this.pickerComponent?.close();
    }
    setValue(color) {
        if (this.value === color) return this;
        this.eDisplayFieldColor.style.backgroundColor = color;
        this.eDisplayFieldText.textContent = this.beans.agChartsExports._Util.Color.fromString(color).toHexString().toUpperCase();
        return super.setValue(color);
    }
    getValue() {
        return this.value;
    }
};
var $5b7ccabde48fae90$export$1e6898594dee986e = {
    selector: "AG-COLOR-PICKER",
    component: $5b7ccabde48fae90$export$c7bbe886fe0efbe1
};
var $5b7ccabde48fae90$var$AgMenuPanel = class extends (0, $437b23f6a393c3bf$export$d62d00723c2ea1b5) {
    constructor(wrappedComponent){
        super();
        this.setTemplateFromElement(wrappedComponent.getGui(), void 0, void 0, true);
    }
    postConstruct() {
        this.initialiseTabGuard({
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e)
        });
    }
    handleKeyDown(e) {
        if (e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ESCAPE) this.closePanel();
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        this.closePanel();
        e.preventDefault();
    }
    closePanel() {
        const menuItem = this.parentComponent;
        menuItem.closeSubMenu();
        setTimeout(()=>menuItem.getGui().focus(), 0);
    }
};
// packages/ag-grid-enterprise/src/agStack/agMenuItemComponent.ts
var $5b7ccabde48fae90$export$f6c02b828bd3ada0 = class extends (0, $437b23f6a393c3bf$export$347db2b30d253083) {
    constructor(callbacks){
        super();
        this.callbacks = callbacks;
        this.ACTIVATION_DELAY = 80;
        this.isActive = false;
        this.subMenuIsOpen = false;
        this.subMenuIsOpening = false;
        this.suppressRootStyles = true;
        this.suppressAria = true;
        this.suppressFocus = true;
    }
    init(params) {
        const { menuItemDef: menuItemDef, isAnotherSubMenuOpen: isAnotherSubMenuOpen, level: level, childComponent: childComponent, contextParams: contextParams } = params;
        this.params = params.menuItemDef;
        this.level = level;
        this.isAnotherSubMenuOpen = isAnotherSubMenuOpen;
        this.childComponent = childComponent;
        this.contextParams = contextParams;
        this.cssClassPrefix = this.params.menuItemParams?.cssClassPrefix ?? "ag-menu-option";
        return this.callbacks.getMenuItemComp(this.beans, this.params, {
            ...menuItemDef,
            level: level,
            isAnotherSubMenuOpen: isAnotherSubMenuOpen,
            openSubMenu: (activateFirstItem)=>this.openSubMenu(activateFirstItem),
            closeSubMenu: ()=>this.closeSubMenu(),
            closeMenu: (event)=>this.closeMenu(event),
            updateTooltip: (tooltip, shouldDisplayTooltip)=>this.refreshTooltip(tooltip, shouldDisplayTooltip),
            onItemActivated: ()=>this.onItemActivated()
        }).then((comp)=>{
            if (!comp) return;
            this.menuItemComp = comp;
            const configureDefaults = comp.configureDefaults?.();
            if (configureDefaults) this.configureDefaults(configureDefaults === true ? void 0 : configureDefaults);
        });
    }
    addListeners(eGui, params) {
        if (!params?.suppressClick) this.addManagedElementListeners(eGui, {
            click: (e)=>this.onItemSelected(e)
        });
        if (!params?.suppressKeyboardSelect) this.addManagedElementListeners(eGui, {
            keydown: (e)=>{
                if (e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER || e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE) {
                    e.preventDefault();
                    this.onItemSelected(e);
                }
            }
        });
        if (!params?.suppressMouseDown) this.addManagedElementListeners(eGui, {
            mousedown: (e)=>{
                e.stopPropagation();
                e.preventDefault();
            }
        });
        if (!params?.suppressMouseOver) this.addManagedElementListeners(eGui, {
            mouseenter: ()=>this.onMouseEnter(),
            mouseleave: ()=>this.onMouseLeave()
        });
    }
    isDisabled() {
        return !!this.params.disabled;
    }
    openSubMenu(activateFirstItem = false, event) {
        this.closeSubMenu();
        if (!this.params.subMenu) return;
        this.subMenuIsOpening = true;
        const ePopup = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div",
            cls: "ag-menu",
            role: "presentation"
        });
        this.eSubMenuGui = ePopup;
        let destroySubMenu;
        let afterGuiAttached = ()=>{
            this.subMenuIsOpening = false;
        };
        if (this.childComponent) {
            const menuPanel = this.createBean(new $5b7ccabde48fae90$var$AgMenuPanel(this.childComponent));
            menuPanel.setParentComponent(this);
            const subMenuGui = menuPanel.getGui();
            const mouseEvent = "mouseenter";
            const mouseEnterListener = ()=>this.cancelDeactivate();
            subMenuGui.addEventListener(mouseEvent, mouseEnterListener);
            destroySubMenu = ()=>{
                subMenuGui.removeEventListener(mouseEvent, mouseEnterListener);
                this.destroyBean(menuPanel);
            };
            ePopup.appendChild(subMenuGui);
            if (this.childComponent.afterGuiAttached) afterGuiAttached = ()=>{
                this.childComponent.afterGuiAttached();
                this.subMenuIsOpening = false;
            };
        } else if (this.params.subMenu) {
            const childMenu = this.createBean(new $5b7ccabde48fae90$export$8b45680cfb58eb35(this.level + 1, this.contextParams, this.callbacks));
            childMenu.setParentComponent(this);
            childMenu.addMenuItems(this.params.subMenu);
            ePopup.appendChild(childMenu.getGui());
            this.addManagedListeners(childMenu, {
                closeMenu: (e)=>this.dispatchLocalEvent(e)
            });
            childMenu.addGuiEventListener("mouseenter", ()=>this.cancelDeactivate());
            destroySubMenu = ()=>this.destroyBean(childMenu);
            if (activateFirstItem) afterGuiAttached = ()=>{
                childMenu.activateFirstItem();
                this.subMenuIsOpening = false;
            };
        }
        const popupSvc = this.beans.popupSvc;
        const positionCallback = ()=>{
            const eventSource = this.eGui;
            popupSvc?.positionPopupForMenu({
                eventSource: eventSource,
                ePopup: ePopup,
                event: event instanceof MouseEvent ? event : void 0,
                additionalParams: this.callbacks.getPostProcessPopupParams(this.contextParams)
            });
        };
        const translate = this.getLocaleTextFunc();
        const addPopupRes = popupSvc?.addPopup({
            modal: true,
            eChild: ePopup,
            positionCallback: positionCallback,
            anchorToElement: this.eGui,
            ariaLabel: translate("ariaLabelSubMenu", "SubMenu"),
            afterGuiAttached: afterGuiAttached
        });
        this.subMenuIsOpen = true;
        this.setAriaExpanded(true);
        this.hideSubMenu = ()=>{
            if (addPopupRes) addPopupRes.hideFunc();
            this.subMenuIsOpen = false;
            this.setAriaExpanded(false);
            destroySubMenu();
            this.menuItemComp.setExpanded?.(false);
            this.eSubMenuGui = void 0;
        };
        this.menuItemComp.setExpanded?.(true);
    }
    setAriaExpanded(expanded) {
        if (!this.suppressAria) (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(this.eGui, expanded);
    }
    closeSubMenu() {
        if (!this.hideSubMenu) return;
        this.hideSubMenu();
        this.hideSubMenu = null;
        this.setAriaExpanded(false);
    }
    isSubMenuOpen() {
        return this.subMenuIsOpen;
    }
    isSubMenuOpening() {
        return this.subMenuIsOpening;
    }
    activate(openSubMenu, fromKeyNav) {
        this.cancelActivate();
        if (this.params.disabled && !fromKeyNav) return;
        this.isActive = true;
        if (!this.suppressRootStyles) this.eGui.classList.add(`${this.cssClassPrefix}-active`);
        this.menuItemComp.setActive?.(true);
        if (!this.suppressFocus) this.callbacks.preserveRangesWhile(this.beans, ()=>this.eGui.focus({
                preventScroll: !fromKeyNav
            }));
        if (openSubMenu && this.params.subMenu) window.setTimeout(()=>{
            if (this.isAlive() && this.isActive) this.openSubMenu();
        }, 300);
        this.onItemActivated();
    }
    deactivate() {
        this.cancelDeactivate();
        if (!this.suppressRootStyles) this.eGui.classList.remove(`${this.cssClassPrefix}-active`);
        this.menuItemComp.setActive?.(false);
        this.isActive = false;
        if (this.subMenuIsOpen) this.closeSubMenu();
    }
    getGui() {
        return this.menuItemComp.getGui();
    }
    getParentComponent() {
        return this.parentComponent;
    }
    setParentComponent(component) {
        this.parentComponent = component;
    }
    getSubMenuGui() {
        return this.eSubMenuGui;
    }
    onItemSelected(event) {
        this.menuItemComp.select?.();
        if (this.params.action) this.beans.frameworkOverrides.wrapOutgoing(()=>this.params.action(this.gos.addCommon({
                ...this.contextParams
            })));
        else this.openSubMenu(event && event.type === "keydown", event);
        if (this.params.subMenu && !this.params.action || this.params.suppressCloseOnSelect) return;
        this.closeMenu(event);
    }
    closeMenu(event) {
        const e = {
            type: "closeMenu"
        };
        if (event) {
            if (event instanceof MouseEvent) e.mouseEvent = event;
            else e.keyboardEvent = event;
        }
        this.dispatchLocalEvent(e);
    }
    onItemActivated() {
        const event = {
            type: "menuItemActivated",
            menuItem: this
        };
        this.dispatchLocalEvent(event);
    }
    cancelActivate() {
        if (this.activateTimeoutId) {
            window.clearTimeout(this.activateTimeoutId);
            this.activateTimeoutId = 0;
        }
    }
    cancelDeactivate() {
        if (this.deactivateTimeoutId) {
            window.clearTimeout(this.deactivateTimeoutId);
            this.deactivateTimeoutId = 0;
        }
    }
    onMouseEnter() {
        this.cancelDeactivate();
        if (this.isAnotherSubMenuOpen()) this.activateTimeoutId = window.setTimeout(()=>this.activate(true), this.ACTIVATION_DELAY);
        else this.activate(true);
    }
    onMouseLeave() {
        this.cancelActivate();
        if (this.isSubMenuOpen()) this.deactivateTimeoutId = window.setTimeout(()=>this.deactivate(), this.ACTIVATION_DELAY);
        else this.deactivate();
    }
    refreshRootElementGui(suppressRootStyles) {
        let eGui = this.menuItemComp.getGui();
        const { cssClassPrefix: cssClassPrefix, params: { cssClasses: cssClasses, disabled: disabled } } = this;
        const rootElement = this.menuItemComp.getRootElement?.();
        if (rootElement) {
            if (!suppressRootStyles) eGui.classList.add("ag-menu-option-custom");
            eGui = rootElement;
        }
        this.suppressRootStyles = !!suppressRootStyles;
        if (!this.suppressRootStyles) {
            eGui.classList.add(cssClassPrefix);
            for (const it of cssClasses ?? [])eGui.classList.add(it);
            if (disabled) eGui.classList.add(`${cssClassPrefix}-disabled`);
        }
        return eGui;
    }
    applyAriaProperties(eGui) {
        const { params: { checked: checked, subMenu: subMenu, subMenuRole: subMenuRole, disabled: disabled } } = this;
        const hasCheck = checked != null;
        (0, $437b23f6a393c3bf$export$f8d01fa01787902)(eGui, hasCheck ? "menuitemcheckbox" : "menuitem");
        if (subMenu) (0, $437b23f6a393c3bf$export$668d180e9cbef6da)(eGui, subMenuRole ?? "menu");
        if (disabled) (0, $437b23f6a393c3bf$export$7ed376f43c6f2bbd)(eGui, true);
    }
    configureDefaults(configParams) {
        if (!this.menuItemComp) {
            setTimeout(()=>this.configureDefaults(configParams));
            return;
        }
        const { suppressRootStyles: suppressRootStyles, suppressTooltip: suppressTooltip, suppressAria: suppressAria, suppressTabIndex: suppressTabIndex, suppressFocus: suppressFocus } = configParams || {};
        const { params: { tooltip: tooltip, disabled: disabled } } = this;
        const eGui = this.eGui = this.refreshRootElementGui(!!suppressRootStyles);
        this.suppressAria = !!suppressAria;
        if (!suppressAria) this.applyAriaProperties(eGui);
        if (!suppressTabIndex) eGui.setAttribute("tabindex", "-1");
        if (!suppressTooltip) this.refreshTooltip(tooltip);
        if (!disabled) this.addListeners(eGui, configParams);
        this.suppressFocus = !!suppressFocus;
    }
    refreshTooltip(tooltip, shouldDisplayTooltip) {
        this.tooltip = tooltip;
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        if (!tooltip || !this.menuItemComp) return;
        const tooltipFeature = this.beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            getTooltipValue: ()=>this.tooltip,
            getLocation: ()=>"menu",
            shouldDisplayTooltip: shouldDisplayTooltip
        });
        if (tooltipFeature) this.tooltipFeature = this.createBean(tooltipFeature);
    }
    destroy() {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        this.menuItemComp?.destroy?.();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/agStack/agMenuList.ts
var $5b7ccabde48fae90$export$8b45680cfb58eb35 = class extends (0, $437b23f6a393c3bf$export$d62d00723c2ea1b5) {
    constructor(level = 0, menuActionParams, callbacks){
        super({
            tag: "div",
            cls: "ag-menu-list",
            role: "menu"
        });
        this.level = level;
        this.menuActionParams = menuActionParams;
        this.callbacks = callbacks;
        this.menuItems = [];
    }
    postConstruct() {
        this.initialiseTabGuard({
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.callbacks.preserveRangesWhile(this.beans, ()=>this.handleKeyDown(e)),
            onFocusIn: (e)=>this.handleFocusIn(e),
            onFocusOut: (e)=>this.handleFocusOut(e)
        });
    }
    onTabKeyDown(e) {
        const parent = this.getParentComponent();
        const isManaged = parent?.getGui()?.classList.contains("ag-focus-managed");
        if (!isManaged) e.preventDefault();
        if (e.shiftKey) this.closeIfIsChild(e);
    }
    handleKeyDown(e) {
        switch(e.key){
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT:
                e.preventDefault();
                this.handleNavKey(e.key);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ESCAPE:
                if (this.closeIfIsChild()) this.callbacks.stopPropagationCallbacks.stopPropagation(e);
                break;
        }
    }
    handleFocusIn(e) {
        const oldFocusedElement = e.relatedTarget;
        if (!this.tabGuardFeature.getTabGuardCtrl().isTabGuard(oldFocusedElement) && (this.getGui().contains(oldFocusedElement) || this.activeMenuItem?.getSubMenuGui()?.contains(oldFocusedElement))) return;
        if (this.activeMenuItem) this.activeMenuItem.activate();
        else this.activateFirstItem();
    }
    handleFocusOut(e) {
        const newFocusedElement = e.relatedTarget;
        if (!this.activeMenuItem || this.getGui().contains(newFocusedElement) || this.activeMenuItem.getSubMenuGui()?.contains(newFocusedElement)) return;
        if (!this.activeMenuItem.isSubMenuOpening()) this.activeMenuItem.deactivate();
    }
    clearActiveItem() {
        if (this.activeMenuItem) {
            this.activeMenuItem.deactivate();
            this.activeMenuItem = null;
        }
    }
    addMenuItems(menuItems) {
        if (menuItems == null) return;
        (0, $437b23f6a393c3bf$export$30ec7836a4847721).all(menuItems.map((menuItemOrString)=>{
            if (menuItemOrString === "separator") return (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve({
                eGui: this.createSeparator()
            });
            else if (typeof menuItemOrString === "string") {
                this.callbacks.warnNoItem?.(menuItemOrString);
                return (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve({
                    eGui: null
                });
            } else return this.addItem(menuItemOrString);
        })).then((elements)=>{
            for (const element of elements ?? [])if (element?.eGui) {
                this.appendChild(element.eGui);
                if (element.comp) this.menuItems.push(element.comp);
            }
        });
    }
    addItem(menuItemDef) {
        const menuItem = this.createManagedBean(new $5b7ccabde48fae90$export$f6c02b828bd3ada0(this.callbacks));
        return menuItem.init({
            menuItemDef: menuItemDef,
            isAnotherSubMenuOpen: ()=>this.menuItems.some((m)=>m.isSubMenuOpen()),
            level: this.level,
            contextParams: this.menuActionParams
        }).then(()=>{
            menuItem.setParentComponent(this);
            this.addManagedListeners(menuItem, {
                closeMenu: (event)=>{
                    this.dispatchLocalEvent(event);
                },
                menuItemActivated: (event)=>{
                    if (this.activeMenuItem && this.activeMenuItem !== event.menuItem) this.activeMenuItem.deactivate();
                    this.activeMenuItem = event.menuItem;
                }
            });
            return {
                comp: menuItem,
                eGui: menuItem.getGui()
            };
        });
    }
    activateFirstItem() {
        const item = this.menuItems.filter((currentItem)=>!currentItem.isDisabled())[0];
        if (!item) return;
        item.activate();
    }
    createSeparator() {
        const part = {
            tag: "div",
            cls: "ag-menu-separator-part"
        };
        return (0, $437b23f6a393c3bf$export$378bc9c64290bc8b)({
            tag: "div",
            cls: "ag-menu-separator",
            attrs: {
                "aria-hidden": "true"
            },
            children: [
                part,
                part,
                part,
                part
            ]
        });
    }
    handleNavKey(key) {
        switch(key){
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN:
                {
                    const nextItem = this.findNextItem(key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP);
                    if (nextItem && nextItem !== this.activeMenuItem) nextItem.activate(false, true);
                    return;
                }
        }
        const left = this.gos.get("enableRtl") ? (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT : (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT;
        if (key === left) this.closeIfIsChild();
        else this.openChild();
    }
    closeIfIsChild(e) {
        const parentItem = this.getParentComponent();
        if (parentItem && parentItem instanceof $5b7ccabde48fae90$export$f6c02b828bd3ada0) {
            if (e) e.preventDefault();
            parentItem.closeSubMenu();
            parentItem.getGui().focus();
            return true;
        }
        return false;
    }
    openChild() {
        if (this.activeMenuItem) this.activeMenuItem.openSubMenu(true);
    }
    findNextItem(up) {
        const items = [
            ...this.menuItems
        ];
        if (!items.length) return;
        if (!this.activeMenuItem) return up ? (0, $437b23f6a393c3bf$export$236389741107357f)(items) : items[0];
        if (up) items.reverse();
        let nextItem;
        let foundCurrent = false;
        for (const item of items){
            if (!foundCurrent) {
                if (item === this.activeMenuItem) foundCurrent = true;
                continue;
            }
            nextItem = item;
            break;
        }
        if (foundCurrent && !nextItem) return items[0];
        return nextItem || this.activeMenuItem;
    }
    destroy() {
        this.clearActiveItem();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$CSS_MENU = "ag-menu";
var $5b7ccabde48fae90$var$CSS_CONTEXT_MENU_LOADING_ICON = "ag-context-menu-loading-icon";
var $5b7ccabde48fae90$export$8e53e0f426065c52 = class extends (0, $437b23f6a393c3bf$export$347db2b30d253083) {
    constructor(params){
        super();
        this.params = params;
        this.destroyLoadingSpinner = null;
        this.lastPromise = 0;
    }
    hideActiveMenu() {
        this.destroyBean(this.activeMenu);
    }
    showMenu(menuActionParams, mouseEvent, anchorToElement) {
        const { getMenuItems: getMenuItems, shouldBlockMenuOpen: shouldBlockMenu } = this.params;
        const menuItems = getMenuItems(menuActionParams, mouseEvent);
        if ((0, $437b23f6a393c3bf$export$2395b9dc826192b2)(menuItems)) {
            const currentPromise = this.lastPromise + 1;
            this.lastPromise = currentPromise;
            if (!this.destroyLoadingSpinner) this.createLoadingIcon(mouseEvent);
            menuItems.then((menuItems2)=>{
                if (this.lastPromise !== currentPromise) return;
                const { target: target } = mouseEvent;
                const isFromFakeEvent = !target;
                const shouldShowMenu = // check if there are actual menu items to be displayed
                menuItems2?.length && // check if the element that triggered the context menu was removed from the DOM
                (isFromFakeEvent || (0, $437b23f6a393c3bf$export$2badf4aa566524cb)(target)) && !shouldBlockMenu?.();
                if (shouldShowMenu) this.createContextMenu({
                    menuItems: menuItems2,
                    menuActionParams: menuActionParams,
                    mouseEvent: mouseEvent,
                    anchorToElement: anchorToElement
                });
                this.destroyLoadingSpinner?.();
            });
            return true;
        }
        if (!menuItems?.length) return false;
        this.createContextMenu({
            menuItems: menuItems,
            menuActionParams: menuActionParams,
            mouseEvent: mouseEvent,
            anchorToElement: anchorToElement
        });
        return true;
    }
    createLoadingIcon(mouseEvent) {
        const { beans: beans } = this;
        const translate = this.getLocaleTextFunc();
        const loadingIcon = beans.iconSvc.createIconNoSpan("loadingMenuItems");
        const wrapperEl = (0, $437b23f6a393c3bf$export$378bc9c64290bc8b)({
            tag: "div",
            cls: $5b7ccabde48fae90$var$CSS_CONTEXT_MENU_LOADING_ICON
        });
        wrapperEl.appendChild(loadingIcon);
        const rootNode = (0, $437b23f6a393c3bf$export$1911dd00c79744c0)(beans);
        const targetEl = (0, $437b23f6a393c3bf$export$50c54e860701cf22)(beans);
        if (!targetEl) return;
        targetEl.appendChild(wrapperEl);
        beans.ariaAnnounce?.announceValue(translate("ariaLabelLoadingContextMenu", "Loading Context Menu"), "contextmenu");
        beans.environment.applyThemeClasses(wrapperEl);
        (0, $437b23f6a393c3bf$export$3ce6b987cf48b8c2)(wrapperEl, mouseEvent, beans);
        const mouseMoveCallback = (e)=>{
            (0, $437b23f6a393c3bf$export$3ce6b987cf48b8c2)(wrapperEl, e, beans);
        };
        rootNode.addEventListener("mousemove", mouseMoveCallback);
        this.destroyLoadingSpinner = ()=>{
            rootNode.removeEventListener("mousemove", mouseMoveCallback);
            wrapperEl.remove();
            this.destroyLoadingSpinner = null;
        };
    }
    createContextMenu(params) {
        const { mapMenuItems: mapMenuItems, menuItemCallbacks: menuItemCallbacks, beforeMenuOpen: beforeMenuOpen, onMenuClose: onMenuClose, afterMenuDestroyed: afterMenuDestroyed, onVisibleChanged: onVisibleChanged, onMenuOpen: onMenuOpen } = this.params;
        const { menuItems: menuItems, menuActionParams: menuActionParams, mouseEvent: mouseEvent, anchorToElement: anchorToElement } = params;
        const popupSvc = this.beans.popupSvc;
        const getMenuItems = mapMenuItems ? (getGui)=>mapMenuItems(menuItems, menuActionParams, getGui) : ()=>menuItems;
        const menu = new $5b7ccabde48fae90$var$ContextMenu(getMenuItems, menuActionParams, menuItemCallbacks);
        this.createBean(menu);
        const eMenuGui = menu.getGui();
        beforeMenuOpen?.(menuActionParams);
        const positionParams = {
            additionalParams: menuItemCallbacks.getPostProcessPopupParams(menuActionParams),
            type: "contextMenu",
            mouseEvent: mouseEvent,
            ePopup: eMenuGui,
            // move one pixel away so that accidentally double clicking
            // won't show the browser's contextmenu
            nudgeY: 1
        };
        const translate = this.getLocaleTextFunc();
        const addPopupRes = popupSvc?.addPopup({
            modal: true,
            eChild: eMenuGui,
            closeOnEsc: true,
            closedCallback: (e)=>{
                menuItemCallbacks.preserveRangesWhile(this.beans, ()=>{
                    onMenuClose?.();
                    this.destroyBean(menu);
                    afterMenuDestroyed?.();
                    onVisibleChanged?.(false, e === void 0 ? "api" : "ui");
                });
            },
            click: mouseEvent,
            positionCallback: ()=>{
                const isRtl = this.gos.get("enableRtl");
                popupSvc?.positionPopupUnderMouseEvent({
                    ...positionParams,
                    nudgeX: isRtl ? (eMenuGui.offsetWidth + 1) * -1 : 1
                });
            },
            anchorToElement: // so when browser is scrolled down, or grid is scrolled, context menu stays with cell
            anchorToElement,
            ariaLabel: translate("ariaLabelContextMenu", "Context Menu")
        });
        if (addPopupRes) {
            onMenuOpen?.();
            menu.afterGuiAttached({
                container: "contextMenu",
                hidePopup: addPopupRes.hideFunc
            });
        }
        if (this.activeMenu) this.hideActiveMenu();
        this.activeMenu = menu;
        menu.addEventListener("destroyed", ()=>{
            if (this.activeMenu === menu) this.activeMenu = null;
        });
        if (addPopupRes) menu.addEventListener("closeMenu", (e)=>addPopupRes.hideFunc({
                mouseEvent: e.mouseEvent ?? void 0,
                keyboardEvent: e.keyboardEvent ?? void 0,
                forceHide: true
            }));
        const isApi = mouseEvent && mouseEvent instanceof MouseEvent && mouseEvent.type === "mousedown";
        onVisibleChanged?.(true, isApi ? "api" : "ui");
    }
    destroy() {
        this.destroyLoadingSpinner?.();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ContextMenu = class extends (0, $437b23f6a393c3bf$export$e6818678a6454cbe) {
    constructor(getMenuItems, menuActionParams, callbacks){
        super({
            tag: "div",
            cls: $5b7ccabde48fae90$var$CSS_MENU,
            role: "presentation"
        });
        this.getMenuItems = getMenuItems;
        this.menuActionParams = menuActionParams;
        this.callbacks = callbacks;
        this.menuList = null;
    }
    postConstruct() {
        const menuList = this.createManagedBean(new $5b7ccabde48fae90$export$8b45680cfb58eb35(0, this.menuActionParams, this.callbacks));
        const menuItemsMapped = this.getMenuItems(()=>this.getGui());
        menuList.addMenuItems(menuItemsMapped);
        this.appendChild(menuList);
        this.menuList = menuList;
        menuList.addEventListener("closeMenu", (e)=>this.dispatchLocalEvent(e));
    }
    afterGuiAttached({ hidePopup: hidePopup }) {
        if (hidePopup) this.addDestroyFunc(hidePopup);
        const menuList = this.menuList;
        if (menuList) this.callbacks.preserveRangesWhile(this.beans, ()=>(0, $437b23f6a393c3bf$export$8598088d375f416f)(menuList.getGui()));
    }
};
var $5b7ccabde48fae90$export$3de9fa9f64b2f09d = class extends (0, $437b23f6a393c3bf$export$e6818678a6454cbe) {
    constructor(callbacks){
        super({
            tag: "div"
        });
        this.callbacks = callbacks;
    }
    init(params) {
        this.params = params;
        this.cssClassPrefix = this.params.cssClassPrefix ?? "ag-menu-option";
        this.addAriaAttributes();
        this.addIcon();
        this.addName();
        this.addShortcut();
        this.addSubMenu();
    }
    configureDefaults() {
        return true;
    }
    addAriaAttributes() {
        const { checked: checked, subMenu: subMenu } = this.params;
        const eGui = this.getGui();
        if (checked) (0, $437b23f6a393c3bf$export$43b4d6c0ec0fa4c7)(eGui, checked);
        if (subMenu) (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(eGui, false);
    }
    addIcon() {
        if (this.params.isCompact) return;
        const iconWrapper = (0, $437b23f6a393c3bf$export$378bc9c64290bc8b)({
            tag: "span",
            ref: "eIcon",
            cls: `${this.getClassName("part")} ${this.getClassName("icon")}`,
            role: "presentation"
        });
        const { checked: checked, icon: icon } = this.params;
        if (checked) iconWrapper.appendChild(this.beans.iconSvc.createIconNoSpan("check"));
        else if (icon) {
            if ((0, $437b23f6a393c3bf$export$6e6303ef478b0c94)(icon)) iconWrapper.appendChild(icon);
            else if (typeof icon === "string") iconWrapper.innerHTML = icon;
            else this.callbacks?.warnNoIcon?.();
        }
        this.getGui().appendChild(iconWrapper);
    }
    addName() {
        const name = (0, $437b23f6a393c3bf$export$378bc9c64290bc8b)({
            tag: "span",
            ref: "eName",
            cls: `${this.getClassName("part")} ${this.getClassName("text")}`,
            children: this.params.name || ""
        });
        this.getGui().appendChild(name);
    }
    addShortcut() {
        if (this.params.isCompact) return;
        const shortcut = (0, $437b23f6a393c3bf$export$378bc9c64290bc8b)({
            tag: "span",
            ref: "eShortcut",
            cls: `${this.getClassName("part")} ${this.getClassName("shortcut")}`,
            children: this.params.shortcut || ""
        });
        this.getGui().appendChild(shortcut);
    }
    addSubMenu() {
        const pointer = (0, $437b23f6a393c3bf$export$378bc9c64290bc8b)({
            tag: "span",
            ref: "ePopupPointer",
            cls: `${this.getClassName("part")} ${this.getClassName("popup-pointer")}`
        });
        const eGui = this.getGui();
        if (this.params.subMenu) {
            const iconName = this.gos.get("enableRtl") ? "subMenuOpenRtl" : "subMenuOpen";
            pointer.appendChild(this.beans.iconSvc.createIconNoSpan(iconName));
        }
        eGui.appendChild(pointer);
    }
    getClassName(suffix) {
        return `${this.cssClassPrefix}-${suffix}`;
    }
};
function $5b7ccabde48fae90$var$findFocusableElementBeforeTabGuard(rootNode, referenceElement) {
    if (!referenceElement) return null;
    const focusableElements = (0, $437b23f6a393c3bf$export$7acf44f59625b1f6)(rootNode);
    const referenceIndex = focusableElements.indexOf(referenceElement);
    if (referenceIndex === -1) return null;
    let lastTabGuardIndex = -1;
    for(let i = referenceIndex - 1; i >= 0; i--)if (focusableElements[i].classList.contains((0, $437b23f6a393c3bf$export$3be5727576441c72).TAB_GUARD_TOP)) {
        lastTabGuardIndex = i;
        break;
    }
    if (lastTabGuardIndex <= 0) return null;
    return focusableElements[lastTabGuardIndex - 1];
}
function $5b7ccabde48fae90$var$isTargetUnderManagedComponent(rootNode, target) {
    if (!target) return false;
    const managedContainers = rootNode.querySelectorAll(`.${(0, $437b23f6a393c3bf$export$e24a3eb8593af8d8)}`);
    if (!managedContainers.length) return false;
    for(let i = 0; i < managedContainers.length; i++){
        if (managedContainers[i].contains(target)) return true;
    }
    return false;
}
// packages/ag-grid-enterprise/src/agStack/agTabbedLayout.ts
function $5b7ccabde48fae90$var$getTabbedLayoutTemplate(cssClass) {
    return {
        tag: "div",
        cls: `ag-tabs ${cssClass}`,
        children: [
            {
                tag: "div",
                ref: "eHeader"
            },
            {
                tag: "div",
                ref: "eBody",
                role: "presentation",
                cls: (cssClass, ` ${cssClass}-body`)
            }
        ]
    };
}
var $5b7ccabde48fae90$export$1f389880cb99530f = class extends (0, $437b23f6a393c3bf$export$d62d00723c2ea1b5) {
    constructor(params){
        super($5b7ccabde48fae90$var$getTabbedLayoutTemplate(params.cssClass));
        this.eHeader = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eBody = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.items = [];
        this.tabbedItemScrollMap = /* @__PURE__ */ new Map();
        this.params = params;
    }
    postConstruct() {
        this.setupHeader();
        if (this.params.items) for (const item of this.params.items)this.addItem(item);
        this.initialiseTabGuard({
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            focusInnerElement: this.focusInnerElement.bind(this),
            focusTrapActive: true
        });
        this.addDestroyFunc(()=>this.activeItem?.tabbedItem?.afterDetachedCallback?.());
    }
    setupHeader() {
        const { enableCloseButton: enableCloseButton, cssClass: cssClass } = this.params;
        const addCssClasses = (el, suffix)=>{
            el.classList.add(`ag-tabs-${suffix}`);
            if (cssClass) el.classList.add(`${cssClass}-${suffix}`);
        };
        if (enableCloseButton) {
            this.setupCloseButton(addCssClasses);
            this.eTabHeader = (0, $437b23f6a393c3bf$export$378bc9c64290bc8b)({
                tag: "div",
                role: "presentation"
            });
            addCssClasses(this.eHeader, "header-wrapper");
            this.eHeader.appendChild(this.eTabHeader);
        } else this.eTabHeader = this.eHeader;
        (0, $437b23f6a393c3bf$export$f8d01fa01787902)(this.eTabHeader, "tablist");
        addCssClasses(this.eTabHeader, "header");
    }
    setupCloseButton(addCssClasses) {
        const eCloseButton = (0, $437b23f6a393c3bf$export$378bc9c64290bc8b)({
            tag: "button"
        });
        addCssClasses(eCloseButton, "close-button");
        const eIcon = this.beans.iconSvc.createIconNoSpan("close");
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(eCloseButton, this.params.closeButtonAriaLabel);
        eCloseButton.appendChild(eIcon);
        this.addManagedElementListeners(eCloseButton, {
            click: ()=>this.params.onCloseClicked?.()
        });
        const eCloseButtonWrapper = (0, $437b23f6a393c3bf$export$378bc9c64290bc8b)({
            tag: "div",
            role: "presentation"
        });
        addCssClasses(eCloseButtonWrapper, "close-button-wrapper");
        eCloseButtonWrapper.appendChild(eCloseButton);
        this.eHeader.appendChild(eCloseButtonWrapper);
        this.eCloseButton = eCloseButton;
    }
    handleKeyDown(e) {
        switch(e.key){
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT:
                {
                    if (!this.eTabHeader.contains((0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans))) return;
                    const isRightKey = e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT;
                    const isRtl = this.gos.get("enableRtl");
                    const currentPosition = this.items.indexOf(this.activeItem);
                    const nextPosition = isRightKey !== isRtl ? Math.min(currentPosition + 1, this.items.length - 1) : Math.max(currentPosition - 1, 0);
                    if (currentPosition === nextPosition) return;
                    e.preventDefault();
                    const nextItem = this.items[nextPosition];
                    this.showItemWrapper(nextItem);
                    nextItem.eHeaderButton.focus();
                    break;
                }
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN:
                e.stopPropagation();
                break;
        }
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        const { beans: beans, eHeader: eHeader, eBody: eBody, activeItem: activeItem, params: params } = this;
        const { suppressTrapFocus: suppressTrapFocus, enableCloseButton: enableCloseButton } = params;
        const activeElement = (0, $437b23f6a393c3bf$export$16bc98d422315038)(beans);
        const target = e.target;
        const backwards = e.shiftKey;
        if (eHeader.contains(activeElement)) {
            e.preventDefault();
            if (enableCloseButton && backwards && !this.eCloseButton?.contains(activeElement)) this.eCloseButton?.focus();
            else if (suppressTrapFocus && backwards) $5b7ccabde48fae90$var$findFocusableElementBeforeTabGuard((0, $437b23f6a393c3bf$export$f63d0991874c6f81)(beans).body, target)?.focus();
            else this.focusBody(e.shiftKey);
            return;
        }
        let nextEl = null;
        if ($5b7ccabde48fae90$var$isTargetUnderManagedComponent(eBody, target)) {
            if (backwards) nextEl = $5b7ccabde48fae90$var$findFocusableElementBeforeTabGuard(eBody, target);
            if (!nextEl && !suppressTrapFocus) nextEl = activeItem.eHeaderButton;
        }
        if (!nextEl && eBody.contains(activeElement)) {
            nextEl = (0, $437b23f6a393c3bf$export$83fc12531358bd28)(beans, eBody, false, backwards);
            if (!nextEl) {
                if (suppressTrapFocus && !backwards) this.forceFocusOutOfContainer(backwards);
                else if (enableCloseButton && !backwards) {
                    e.preventDefault();
                    this.eCloseButton?.focus();
                } else {
                    e.preventDefault();
                    this.focusHeader();
                }
                return;
            }
        }
        if (nextEl) {
            e.preventDefault();
            nextEl.focus();
        }
    }
    focusInnerElement(fromBottom) {
        if (fromBottom) return this.focusBody(true);
        else {
            this.focusHeader();
            return true;
        }
    }
    focusHeader(preventScroll) {
        this.activeItem.eHeaderButton.focus({
            preventScroll: preventScroll
        });
    }
    focusBody(fromBottom) {
        return (0, $437b23f6a393c3bf$export$8598088d375f416f)(this.eBody, fromBottom);
    }
    setAfterAttachedParams(params) {
        this.afterAttachedParams = params;
    }
    showFirstItem() {
        if (this.items.length > 0) this.showItemWrapper(this.items[0]);
    }
    addItem(item) {
        const eHeaderButton = (0, $437b23f6a393c3bf$export$378bc9c64290bc8b)({
            tag: "span",
            cls: "ag-tab",
            role: "tab",
            attrs: {
                tabindex: "-1"
            }
        });
        eHeaderButton.appendChild(item.title);
        this.eTabHeader.appendChild(eHeaderButton);
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(eHeaderButton, item.titleLabel);
        const wrapper = {
            tabbedItem: item,
            eHeaderButton: eHeaderButton
        };
        this.items.push(wrapper);
        eHeaderButton.addEventListener("click", this.showItemWrapper.bind(this, wrapper));
    }
    showItem(tabbedItem) {
        const itemWrapper = this.items.find((wrapper)=>wrapper.tabbedItem === tabbedItem);
        if (itemWrapper) this.showItemWrapper(itemWrapper);
    }
    showItemWrapper(wrapper) {
        const { tabbedItem: tabbedItem, eHeaderButton: eHeaderButton } = wrapper;
        this.params.onItemClicked?.({
            item: tabbedItem
        });
        if (this.activeItem === wrapper) {
            this.params.onActiveItemClicked?.();
            return;
        }
        if (this.lastScrollListener) this.lastScrollListener = this.lastScrollListener();
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.eBody);
        tabbedItem.bodyPromise.then((body)=>{
            this.eBody.appendChild(body);
            const onlyUnmanaged = !(0, $437b23f6a393c3bf$export$e4c8c227337b7f23)();
            if (!this.params.suppressFocusBodyOnOpen) (0, $437b23f6a393c3bf$export$8598088d375f416f)(this.eBody, false, onlyUnmanaged);
            if (tabbedItem.afterAttachedCallback) tabbedItem.afterAttachedCallback(this.afterAttachedParams);
            if (this.params.keepScrollPosition) {
                const scrollableContainer = tabbedItem.getScrollableContainer?.() || body;
                [this.lastScrollListener] = this.addManagedElementListeners(scrollableContainer, {
                    scroll: ()=>{
                        this.tabbedItemScrollMap.set(tabbedItem.name, scrollableContainer.scrollTop);
                    }
                });
                const scrollPosition = this.tabbedItemScrollMap.get(tabbedItem.name);
                if (scrollPosition !== void 0) setTimeout(()=>{
                    scrollableContainer.scrollTop = scrollPosition;
                }, 0);
            }
        });
        if (this.activeItem) {
            this.activeItem.eHeaderButton.classList.remove("ag-tab-selected");
            this.activeItem.tabbedItem.afterDetachedCallback?.();
        }
        eHeaderButton.classList.add("ag-tab-selected");
        this.activeItem = wrapper;
    }
};
// packages/ag-grid-enterprise/src/agStack/agGroupComponent.css-GENERATED.ts
var $5b7ccabde48fae90$var$agGroupComponentCSS = /*css*/ `.ag-group{position:relative;width:100%}.ag-group-title-bar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-title{display:inline;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-group-title-bar) .ag-group-title{cursor:default}.ag-group-toolbar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-container{display:flex}.ag-disabled .ag-group-container{pointer-events:none}.ag-disabled-group-container,.ag-disabled-group-title-bar{opacity:.5}.ag-group-container-horizontal{flex-flow:row wrap}.ag-group-container-vertical{flex-direction:column}.ag-group-title-bar-icon{cursor:pointer;flex:none}:where(.ag-ltr) .ag-group-title-bar-icon{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-group-title-bar-icon{margin-left:var(--ag-spacing)}:where(.ag-group-item-alignment-stretch) .ag-group-item{align-items:stretch}:where(.ag-group-item-alignment-start) .ag-group-item{align-items:flex-start}:where(.ag-group-item-alignment-end) .ag-group-item{align-items:flex-end}`;
// packages/ag-grid-enterprise/src/agStack/agGroupComponent.ts
function $5b7ccabde48fae90$var$getAgGroupComponentTemplate(params) {
    const cssIdentifier = params.cssIdentifier || "default";
    const direction = params.direction || "vertical";
    return {
        tag: "div",
        cls: `ag-group ag-${cssIdentifier}-group`,
        role: "presentation",
        children: [
            {
                tag: "div",
                ref: "eToolbar",
                cls: `ag-group-toolbar ag-${cssIdentifier}-group-toolbar`,
                children: [
                    {
                        tag: "ag-checkbox",
                        ref: "cbGroupEnabled"
                    }
                ]
            },
            {
                tag: "div",
                ref: "eContainer",
                cls: `ag-group-container ag-group-container-${direction} ag-${cssIdentifier}-group-container`
            }
        ]
    };
}
var $5b7ccabde48fae90$export$9c4ea4ce92935a7e = class extends (0, $437b23f6a393c3bf$export$e6818678a6454cbe) {
    constructor(params = {}){
        super($5b7ccabde48fae90$var$getAgGroupComponentTemplate(params), [
            (0, $437b23f6a393c3bf$export$2e2c317d2e31f2ca)
        ]);
        this.params = params;
        this.suppressEnabledCheckbox = true;
        this.suppressToggleExpandOnEnableChange = false;
        this.eToolbar = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.cbGroupEnabled = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eContainer = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.registerCSS($5b7ccabde48fae90$var$agGroupComponentCSS);
        const { enabled: enabled, items: items, suppressEnabledCheckbox: suppressEnabledCheckbox, expanded: expanded, suppressToggleExpandOnEnableChange: suppressToggleExpandOnEnableChange, useToggle: toggleMode } = params;
        this.cssIdentifier = params.cssIdentifier || "default";
        this.enabled = enabled != null ? enabled : true;
        this.items = items || [];
        this.useToggle = toggleMode ?? false;
        this.alignItems = params.alignItems || "center";
        this.expanded = expanded == null ? true : expanded;
        if (suppressEnabledCheckbox != null) this.suppressEnabledCheckbox = suppressEnabledCheckbox;
        if (suppressToggleExpandOnEnableChange != null) this.suppressToggleExpandOnEnableChange = suppressToggleExpandOnEnableChange;
    }
    postConstruct() {
        this.setupTitleBar();
        if (this.items.length) {
            const initialItems = this.items;
            this.items = [];
            this.addItems(initialItems);
        }
        const localeTextFunc = this.getLocaleTextFunc();
        this.cbGroupEnabled.setLabel(localeTextFunc("enabled", "Enabled"));
        if (this.enabled) this.setEnabled(this.enabled, void 0, true);
        this.setAlignItems(this.alignItems);
        const { onEnableChange: onEnableChange, onExpandedChange: onExpandedChange, suppressOpenCloseIcons: suppressOpenCloseIcons } = this.params;
        this.hideEnabledCheckbox(this.suppressEnabledCheckbox);
        this.hideOpenCloseIcons(suppressOpenCloseIcons ?? false);
        this.refreshChildDisplay();
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eContainer, this.expanded);
        this.cbGroupEnabled.onValueChange((newSelection)=>{
            this.setEnabled(newSelection, true, this.suppressToggleExpandOnEnableChange);
            this.dispatchEnableChangeEvent(newSelection);
        });
        if (onEnableChange != null) this.onEnableChange(onEnableChange);
        if (onExpandedChange != null) this.onExpandedChange(onExpandedChange);
    }
    refreshChildDisplay() {
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eToolbar, this.expanded && !this.suppressEnabledCheckbox);
        this.eTitleBar?.refreshOnExpand(this.expanded);
    }
    isExpanded() {
        return this.expanded;
    }
    setAlignItems(alignment) {
        if (this.alignItems !== alignment) this.removeCss(`ag-group-item-alignment-${this.alignItems}`);
        this.alignItems = alignment;
        const newCls = `ag-group-item-alignment-${this.alignItems}`;
        this.addCss(newCls);
        return this;
    }
    toggleGroupExpand(expanded, silent) {
        if (this.eTitleBar?.isSuppressCollapse() && !this.useToggle) {
            expanded = true;
            silent = true;
        } else {
            expanded = expanded != null ? expanded : !this.expanded;
            if (this.expanded === expanded) return this;
        }
        this.expanded = expanded;
        this.refreshChildDisplay();
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eContainer, expanded);
        if (!silent) this.dispatchLocalEvent({
            type: expanded ? "expanded" : "collapsed"
        });
        return this;
    }
    addItems(items) {
        for (const item of items)this.addItem(item);
    }
    prependItem(item) {
        this.insertItem(item, true);
    }
    addItem(item) {
        this.insertItem(item, false);
    }
    updateItems(newItems) {
        const oldItems = this.items;
        let newIndex = 0;
        for(let prevIndex = 0; prevIndex < oldItems.length; ++prevIndex){
            const ePrevItem = oldItems[prevIndex];
            if (ePrevItem === newItems[newIndex]) newIndex++;
            else {
                const el = (0, $437b23f6a393c3bf$export$e9be47ed2688240e)(ePrevItem) ? ePrevItem.getGui() : ePrevItem;
                (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(el);
            }
        }
        while(newIndex < newItems.length)this.insertItem(newItems[newIndex++]);
        this.items = newItems;
    }
    insertItem(item, prepend) {
        const container = this.eContainer;
        const el = (0, $437b23f6a393c3bf$export$e9be47ed2688240e)(item) ? item.getGui() : item;
        el.classList.add("ag-group-item", `ag-${this.cssIdentifier}-group-item`);
        if (prepend) {
            container.insertAdjacentElement("afterbegin", el);
            this.items.unshift(el);
        } else {
            container.appendChild(el);
            this.items.push(el);
        }
    }
    hideItem(hide, index) {
        const itemToHide = this.items[index];
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(itemToHide, !hide);
    }
    getItemIndex(item) {
        const el = (0, $437b23f6a393c3bf$export$e9be47ed2688240e)(item) ? item.getGui() : item;
        return this.items.indexOf(el);
    }
    setTitle(title) {
        this.eTitleBar?.setTitle(title);
        return this;
    }
    addTitleBarWidget(el) {
        this.eTitleBar?.addWidget(el);
        return this;
    }
    addCssClassToTitleBar(cssClass) {
        this.eTitleBar?.addCss(cssClass);
    }
    dispatchEnableChangeEvent(enabled) {
        const event = {
            type: "enableChange",
            enabled: enabled
        };
        this.dispatchLocalEvent(event);
    }
    setEnabled(enabled, skipToggle, skipExpand) {
        this.enabled = enabled;
        this.refreshDisabledStyles();
        if (!skipExpand) this.toggleGroupExpand(enabled);
        if (!skipToggle) {
            this.cbGroupEnabled.setValue(enabled);
            this.eToggle?.setValue(enabled);
        }
        return this;
    }
    isEnabled() {
        return this.enabled;
    }
    onEnableChange(callbackFn) {
        this.addManagedListeners(this, {
            enableChange: (event)=>callbackFn(event.enabled)
        });
        return this;
    }
    onExpandedChange(callbackFn) {
        this.addManagedListeners(this, {
            expanded: ()=>callbackFn(true),
            collapsed: ()=>callbackFn(false)
        });
        return this;
    }
    hideEnabledCheckbox(hide) {
        this.suppressEnabledCheckbox = hide;
        this.refreshChildDisplay();
        this.refreshDisabledStyles();
        return this;
    }
    hideOpenCloseIcons(hide) {
        this.eTitleBar?.hideOpenCloseIcons(hide);
        return this;
    }
    refreshDisabledStyles() {
        const disabled = !this.enabled;
        this.eContainer.classList.toggle("ag-disabled", disabled);
        this.eTitleBar?.refreshDisabledStyles(this.suppressEnabledCheckbox && disabled);
        this.eContainer.classList.toggle("ag-disabled-group-container", disabled);
    }
    setupTitleBar() {
        const titleBar = this.useToggle ? this.createToggleTitleBar() : this.createDefaultTitleBar();
        this.eToolbar.insertAdjacentElement("beforebegin", titleBar.getGui());
    }
    createDefaultTitleBar() {
        const titleBar = this.createManagedBean(new $5b7ccabde48fae90$var$DefaultTitleBar(this.params));
        this.eTitleBar = titleBar;
        titleBar.refreshOnExpand(this.expanded);
        this.addManagedListeners(titleBar, {
            expandedChanged: (event)=>this.toggleGroupExpand(event.expanded)
        });
        return titleBar;
    }
    createToggleTitleBar() {
        const eToggle = this.createManagedBean(new (0, $437b23f6a393c3bf$export$167b21bf245ce0bf)({
            value: this.enabled,
            label: this.params.title,
            labelAlignment: "left",
            labelWidth: "flex",
            onValueChange: (enabled)=>{
                this.setEnabled(enabled, true);
                this.dispatchEnableChangeEvent(enabled);
            }
        }));
        eToggle.addCss("ag-group-title-bar");
        eToggle.addCss(`ag-${this.params.cssIdentifier ?? "default"}-group-title-bar ag-unselectable`);
        this.eToggle = eToggle;
        this.toggleGroupExpand(this.enabled);
        return eToggle;
    }
};
var $5b7ccabde48fae90$var$TITLE_BAR_DISABLED_CLASS = "ag-disabled-group-title-bar";
function $5b7ccabde48fae90$var$getDefaultTitleBarTemplate(params) {
    const cssIdentifier = params.cssIdentifier ?? "default";
    return {
        tag: "div",
        cls: `ag-group-title-bar ag-${cssIdentifier}-group-title-bar ag-unselectable`,
        role: params.suppressKeyboardNavigation ? "presentation" : "group",
        children: [
            {
                tag: "span",
                ref: "eGroupOpenedIcon",
                cls: `ag-group-title-bar-icon ag-${cssIdentifier}-group-title-bar-icon`,
                role: "presentation"
            },
            {
                tag: "span",
                ref: "eGroupClosedIcon",
                cls: `ag-group-title-bar-icon ag-${cssIdentifier}-group-title-bar-icon`,
                role: "presentation"
            },
            {
                tag: "span",
                ref: "eTitle",
                cls: `ag-group-title ag-${cssIdentifier}-group-title`
            }
        ]
    };
}
var $5b7ccabde48fae90$var$DefaultTitleBar = class extends (0, $437b23f6a393c3bf$export$e6818678a6454cbe) {
    constructor(params = {}){
        super($5b7ccabde48fae90$var$getDefaultTitleBarTemplate(params));
        this.suppressOpenCloseIcons = false;
        this.suppressKeyboardNavigation = false;
        this.eGroupOpenedIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eGroupClosedIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eTitle = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        const { title: title, suppressOpenCloseIcons: suppressOpenCloseIcons, suppressKeyboardNavigation: suppressKeyboardNavigation } = params;
        if (!!title && title.length > 0) this.title = title;
        if (suppressOpenCloseIcons != null) this.suppressOpenCloseIcons = suppressOpenCloseIcons;
        this.suppressKeyboardNavigation = suppressKeyboardNavigation ?? false;
    }
    postConstruct() {
        this.setTitle(this.title);
        this.hideOpenCloseIcons(this.suppressOpenCloseIcons);
        this.setupExpandContract();
    }
    setupExpandContract() {
        const iconSvc = this.beans.iconSvc;
        this.eGroupClosedIcon.appendChild(iconSvc.createIconNoSpan("accordionClosed"));
        this.eGroupOpenedIcon.appendChild(iconSvc.createIconNoSpan("accordionOpen"));
        this.addManagedElementListeners(this.getGui(), {
            click: ()=>this.dispatchExpandChanged(),
            keydown: (e)=>{
                switch(e.key){
                    case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER:
                    case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE:
                        e.preventDefault();
                        this.dispatchExpandChanged();
                        break;
                    case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT:
                    case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT:
                        e.preventDefault();
                        this.dispatchExpandChanged(e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT);
                        break;
                }
            }
        });
    }
    refreshOnExpand(expanded) {
        this.refreshAriaStatus(expanded);
        this.refreshOpenCloseIcons(expanded);
    }
    refreshAriaStatus(expanded) {
        if (!this.suppressOpenCloseIcons) (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(this.getGui(), expanded);
    }
    refreshOpenCloseIcons(expanded) {
        const showIcon = !this.suppressOpenCloseIcons;
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eGroupOpenedIcon, showIcon && expanded);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eGroupClosedIcon, showIcon && !expanded);
    }
    isSuppressCollapse() {
        return this.suppressOpenCloseIcons;
    }
    dispatchExpandChanged(expanded) {
        const event = {
            type: "expandedChanged",
            expanded: expanded
        };
        this.dispatchLocalEvent(event);
    }
    setTitle(title) {
        const eGui = this.getGui();
        const hasTitle = !!title && title.length > 0;
        title = hasTitle ? title : void 0;
        this.eTitle.textContent = title ?? "";
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eGui, hasTitle);
        if (title !== this.title) this.title = title;
        const disabled = eGui.classList.contains($5b7ccabde48fae90$var$TITLE_BAR_DISABLED_CLASS);
        this.refreshDisabledStyles(disabled);
        return this;
    }
    addWidget(el) {
        this.getGui().appendChild(el);
        return this;
    }
    hideOpenCloseIcons(hide) {
        this.suppressOpenCloseIcons = hide;
        if (hide) this.dispatchExpandChanged(true);
        return this;
    }
    refreshDisabledStyles(disabled) {
        const eGui = this.getGui();
        if (disabled) {
            eGui.classList.add($5b7ccabde48fae90$var$TITLE_BAR_DISABLED_CLASS);
            eGui.removeAttribute("tabindex");
            (0, $437b23f6a393c3bf$export$f8d01fa01787902)(eGui, "presentation");
        } else {
            eGui.classList.remove($5b7ccabde48fae90$var$TITLE_BAR_DISABLED_CLASS);
            if (typeof this.title === "string" && !this.suppressKeyboardNavigation) {
                this.activateTabIndex([
                    eGui
                ]);
                (0, $437b23f6a393c3bf$export$f8d01fa01787902)(eGui, "group");
            } else {
                eGui.removeAttribute("tabindex");
                (0, $437b23f6a393c3bf$export$f8d01fa01787902)(eGui, "presentation");
            }
        }
    }
};
var $5b7ccabde48fae90$export$e8864b221efeb73a = {
    selector: "AG-GROUP-COMPONENT",
    component: $5b7ccabde48fae90$export$9c4ea4ce92935a7e
};
// packages/ag-grid-enterprise/src/version.ts
var $5b7ccabde48fae90$var$VERSION = "35.0.1";
// packages/ag-grid-enterprise/src/agGridEnterpriseModule.ts
var $5b7ccabde48fae90$var$EnterpriseCoreModule = {
    moduleName: "EnterpriseCore",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$export$91e2bbffdbb3852c
    ],
    icons: {
        // accordion open (filter tool panel group, charts group)
        accordionOpen: "tree-open",
        // accordion closed (filter tool panel group, charts group)
        accordionClosed: "tree-closed",
        // accordion indeterminate - shown when some children are expanded and
        //     others are collapsed (filter tool panel group, charts group)
        accordionIndeterminate: "tree-indeterminate",
        // dialog title bar
        close: "cross",
        // X (remove) on column 'pill' after adding it to a drop zone list
        cancel: "cancel",
        // button in chart regular size window title bar (click to maximise)
        maximize: "maximize",
        // button in chart maximised window title bar (click to make regular size)
        minimize: "minimize",
        // drag handle used to pick up draggable columns
        columnDrag: "grip"
    },
    dependsOn: []
};
// packages/ag-grid-enterprise/src/advancedFilter/advanced-filter.css-GENERATED.ts
var $5b7ccabde48fae90$var$advancedFilterCSS = /*css*/ `.ag-advanced-filter-header{align-items:center;background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);display:flex;position:relative}.ag-advanced-filter{align-items:center;display:flex;width:100%}.ag-advanced-filter-buttons{display:contents}.ag-advanced-filter-header-cell{height:100%;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding)}.ag-advanced-filter-apply-button,.ag-advanced-filter-builder-button{align-items:center;background-color:unset;border:0;display:flex;font-size:var(--ag-font-size);font-weight:600;line-height:normal;padding:var(--ag-spacing);white-space:nowrap;&:where(:not(:disabled)){cursor:pointer;&:hover{background-color:var(--ag-row-hover-color)}}}:where(.ag-ltr) .ag-advanced-filter-apply-button,:where(.ag-ltr) .ag-advanced-filter-builder-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-advanced-filter-apply-button,:where(.ag-rtl) .ag-advanced-filter-builder-button{margin-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-advanced-filter-builder-button-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-advanced-filter-builder-button-label{margin-right:var(--ag-spacing)}.ag-advanced-filter-builder{display:flex;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}.ag-advanced-filter-builder-list{flex:1;overflow:auto}.ag-advanced-filter-builder-button-panel{border-top:var(--ag-advanced-filter-builder-button-bar-border);display:flex;justify-content:flex-end;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-advanced-filter-builder-apply-button,:where(.ag-ltr) .ag-advanced-filter-builder-cancel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-advanced-filter-builder-apply-button,:where(.ag-rtl) .ag-advanced-filter-builder-cancel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-advanced-filter-builder-item-wrapper{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between;overflow:hidden}:where(.ag-ltr) .ag-advanced-filter-builder-item-wrapper{padding-left:calc(var(--ag-icon-size)/2);padding-right:var(--ag-icon-size)}:where(.ag-rtl) .ag-advanced-filter-builder-item-wrapper{padding-left:var(--ag-icon-size);padding-right:calc(var(--ag-icon-size)/2)}:where(.ag-virtual-list-viewport) .ag-advanced-filter-builder-item-wrapper .ag-tab-guard{position:absolute}.ag-advanced-filter-builder-item-tree-lines>*{width:var(--ag-advanced-filter-builder-indent-size)}.ag-advanced-filter-builder-item-tree-line-root{width:var(--ag-icon-size);&:before{height:50%;top:50%}}.ag-advanced-filter-builder-item-tree-line-horizontal,.ag-advanced-filter-builder-item-tree-line-vertical,.ag-advanced-filter-builder-item-tree-line-vertical-bottom,.ag-advanced-filter-builder-item-tree-line-vertical-top{align-items:center;display:flex;height:100%;position:relative;&:after,&:before{content:"";height:100%;position:absolute}}.ag-advanced-filter-builder-item-tree-line-horizontal:after{border-bottom:var(--ag-border-width) solid var(--ag-border-color);height:50%;top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size))}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-horizontal:after{left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-horizontal:after{right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical:before{top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical-top:before{height:50%;top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical-top:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical-top:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{height:calc(50% - var(--ag-icon-size)*1.5/2);top:calc(50% + var(--ag-icon-size)*1.5/2);width:calc(var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{border-left:var(--ag-border-width) solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{border-right:var(--ag-border-width) solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-condition{padding-bottom:var(--ag-spacing);padding-top:var(--ag-spacing)}.ag-advanced-filter-builder-item,.ag-advanced-filter-builder-item-buttons,.ag-advanced-filter-builder-item-condition,.ag-advanced-filter-builder-item-tree-lines,.ag-advanced-filter-builder-pill,.ag-advanced-filter-builder-pill-wrapper{align-items:center;display:flex;height:100%}.ag-advanced-filter-builder-pill-wrapper{margin:0 var(--ag-spacing)}.ag-advanced-filter-builder-pill{border-radius:var(--ag-border-radius);min-height:calc(100% - var(--ag-spacing)*3);min-width:calc(var(--ag-spacing)*2);padding:var(--ag-spacing) calc(var(--ag-spacing)*2);position:relative}:where(.ag-advanced-filter-builder-pill){.ag-advanced-filter-builder-value-number{font-family:monospace;font-weight:700}.ag-advanced-filter-builder-value-empty{color:var(--ag-subtle-text-color)}}:where(.ag-ltr) :where(.ag-advanced-filter-builder-pill){.ag-picker-field-display{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-advanced-filter-builder-pill){.ag-picker-field-display{margin-left:var(--ag-spacing)}}.ag-advanced-filter-builder-pill-display{font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-advanced-filter-builder-join-pill{background-color:var(--ag-advanced-filter-builder-join-pill-color);cursor:pointer}.ag-advanced-filter-builder-column-pill{background-color:var(--ag-advanced-filter-builder-column-pill-color);cursor:pointer}.ag-advanced-filter-builder-option-pill{background-color:var(--ag-advanced-filter-builder-option-pill-color);cursor:pointer}.ag-advanced-filter-builder-value-pill{background-color:var(--ag-advanced-filter-builder-value-pill-color);cursor:text;max-width:140px;:where(.ag-advanced-filter-builder-pill-display){display:block}}.ag-advanced-filter-builder-item-buttons>*{margin:0 calc(var(--ag-spacing)*.5)}.ag-advanced-filter-builder-item-button{color:var(--ag-subtle-text-color);cursor:pointer;position:relative}.ag-advanced-filter-builder-item-button,.ag-advanced-filter-builder-pill{&:focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-advanced-filter-builder-item-button-disabled{cursor:default;opacity:.5}.ag-advanced-filter-builder-virtual-list-container{top:var(--ag-spacing)}.ag-advanced-filter-builder-virtual-list-item{cursor:default;display:flex;height:var(--ag-list-item-height);&:hover{background-color:var(--ag-row-hover-color);:where(.ag-advanced-filter-builder-item-button){opacity:1}}}.ag-advanced-filter-builder-invalid{color:var(--ag-subtle-text-color);cursor:default;margin:0 var(--ag-spacing)}:where(.ag-advanced-filter-builder-validation) .ag-advanced-filter-builder-invalid{color:var(--ag-invalid-color)}:where(.ag-advanced-filter-builder-virtual-list-item-highlight) .ag-advanced-filter-builder-item-button:focus-visible{opacity:1}`;
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterApi.ts
function $5b7ccabde48fae90$var$getAdvancedFilterModel(beans) {
    return beans.filterManager?.getAdvFilterModel() ?? null;
}
function $5b7ccabde48fae90$var$setAdvancedFilterModel(beans, advancedFilterModel) {
    beans.filterManager?.setAdvFilterModel(advancedFilterModel);
}
function $5b7ccabde48fae90$var$showAdvancedFilterBuilder(beans) {
    beans.filterManager?.toggleAdvFilterBuilder(true, "api");
}
function $5b7ccabde48fae90$var$hideAdvancedFilterBuilder(beans) {
    beans.filterManager?.toggleAdvFilterBuilder(false, "api");
}
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterLocaleText.ts
var $5b7ccabde48fae90$var$ADVANCED_FILTER_LOCALE_TEXT = {
    ariaAdvancedFilterBuilderItem: (variableValues)=>`${variableValues[0]}. Level ${variableValues[1]}. Press ENTER to edit`,
    ariaAdvancedFilterBuilderItemValidation: (variableValues)=>`${variableValues[0]}. Level ${variableValues[1]}. ${variableValues[2]} Press ENTER to edit`,
    ariaAdvancedFilterBuilderList: "Advanced Filter Builder List",
    ariaAdvancedFilterBuilderFilterItem: "Filter Condition",
    ariaAdvancedFilterBuilderGroupItem: "Filter Group",
    ariaAdvancedFilterBuilderColumn: "Column",
    ariaAdvancedFilterBuilderOption: "Option",
    ariaAdvancedFilterBuilderValue: "Value",
    ariaAdvancedFilterBuilderJoinOperator: "Join Operator",
    ariaAdvancedFilterInput: "Advanced Filter Input",
    ariaLabelAdvancedFilterAutocomplete: "Advanced Filter Autocomplete",
    advancedFilterContains: "contains",
    advancedFilterNotContains: "does not contain",
    advancedFilterTextEquals: "equals",
    advancedFilterTextNotEqual: "does not equal",
    advancedFilterStartsWith: "begins with",
    advancedFilterEndsWith: "ends with",
    advancedFilterBlank: "is blank",
    advancedFilterNotBlank: "is not blank",
    advancedFilterEquals: "=",
    advancedFilterNotEqual: "!=",
    advancedFilterGreaterThan: ">",
    advancedFilterGreaterThanOrEqual: ">=",
    advancedFilterLessThan: "<",
    advancedFilterLessThanOrEqual: "<=",
    advancedFilterTrue: "is true",
    advancedFilterFalse: "is false",
    advancedFilterAnd: "AND",
    advancedFilterOr: "OR",
    advancedFilterApply: "Apply",
    advancedFilterReset: "Reset",
    advancedFilterCancel: "Cancel",
    advancedFilterClear: "Clear",
    advancedFilterBuilder: "Builder",
    advancedFilterValidationMissingColumn: "Column is missing",
    advancedFilterValidationMissingOption: "Option is missing",
    advancedFilterValidationMissingValue: "Value is missing",
    advancedFilterValidationInvalidColumn: "Column not found",
    advancedFilterValidationInvalidOption: "Option not found",
    advancedFilterValidationMissingQuote: "Value is missing an end quote",
    advancedFilterValidationNotANumber: "Value is not a number",
    advancedFilterValidationInvalidDate: "Value is not a valid date",
    advancedFilterValidationMissingCondition: "Condition is missing",
    advancedFilterValidationJoinOperatorMismatch: "Join operators within a condition must be the same",
    advancedFilterValidationInvalidJoinOperator: "Join operator not found",
    advancedFilterValidationMissingEndBracket: "Missing end bracket",
    advancedFilterValidationExtraEndBracket: "Too many end brackets",
    advancedFilterValidationMessage: (variableValues)=>`Expression has an error. ${variableValues[0]} - ${variableValues[1]}.`,
    advancedFilterValidationMessageAtEnd: (variableValues)=>`Expression has an error. ${variableValues[0]} at end of expression.`,
    advancedFilterBuilderTitle: "Advanced Filter",
    advancedFilterBuilderApply: "Apply",
    advancedFilterBuilderCancel: "Cancel",
    advancedFilterBuilderClear: "Clear",
    advancedFilterBuilderReset: "Reset",
    advancedFilterBuilderAddButtonTooltip: "Add Filter or Group",
    advancedFilterBuilderRemoveButtonTooltip: "Remove",
    advancedFilterBuilderMoveUpButtonTooltip: "Move Up",
    advancedFilterBuilderMoveDownButtonTooltip: "Move Down",
    advancedFilterBuilderAddJoin: "Add Group",
    advancedFilterBuilderAddCondition: "Add Filter",
    advancedFilterBuilderSelectColumn: "Select a column",
    advancedFilterBuilderSelectOption: "Select an option",
    advancedFilterBuilderEnterValue: "Enter a value...",
    advancedFilterBuilderValidationAlreadyApplied: "Current filter already applied.",
    advancedFilterBuilderValidationIncomplete: "Not all conditions are complete.",
    advancedFilterBuilderValidationSelectColumn: "Must select a column.",
    advancedFilterBuilderValidationSelectOption: "Must select an option.",
    advancedFilterBuilderValidationEnterValue: "Must enter a value."
};
// packages/ag-grid-enterprise/src/advancedFilter/filterExpressionUtils.ts
function $5b7ccabde48fae90$var$getSearchString(value, position, endPosition) {
    if (!value) return "";
    const numChars = endPosition - position;
    return numChars ? value.slice(0, value.length - numChars) : value;
}
function $5b7ccabde48fae90$var$updateExpression(expression, startPosition, endPosition, updatedValuePart, appendSpace, appendQuote, empty) {
    const secondPartStartPosition = endPosition + (!expression.length || empty ? 0 : 1);
    let positionOffset = 0;
    if (appendSpace) {
        if (expression[secondPartStartPosition] === " ") positionOffset = 1;
        else {
            updatedValuePart += " ";
            if (appendQuote) updatedValuePart += `"`;
        }
    }
    const updatedValue = expression.slice(0, startPosition) + updatedValuePart + expression.slice(secondPartStartPosition);
    return {
        updatedValue: updatedValue,
        updatedPosition: startPosition + updatedValuePart.length + positionOffset
    };
}
function $5b7ccabde48fae90$var$findStartPosition(expression, position, endPosition) {
    let startPosition = position;
    while(startPosition < endPosition){
        const char = expression[startPosition];
        if (char !== " ") break;
        startPosition++;
    }
    return startPosition;
}
function $5b7ccabde48fae90$var$findEndPosition(expression, position, includeCloseBracket, isStartPositionUnknown) {
    let endPosition = position;
    let isEmpty = false;
    while(endPosition < expression.length){
        const char = expression[endPosition];
        if (char === "(") {
            if (isStartPositionUnknown && expression[endPosition - 1] === " ") isEmpty = true;
            else endPosition = endPosition - 1;
            break;
        } else if (char === " " || includeCloseBracket && char === ")") {
            endPosition = endPosition - 1;
            break;
        }
        endPosition++;
    }
    return {
        endPosition: endPosition,
        isEmpty: isEmpty
    };
}
function $5b7ccabde48fae90$var$checkAndUpdateExpression(params, userValue, displayValue, endPosition) {
    if (displayValue !== userValue) params.expression = $5b7ccabde48fae90$var$updateExpression(params.expression, endPosition - userValue.length + 1, endPosition, displayValue).updatedValue;
}
// packages/ag-grid-enterprise/src/advancedFilter/colFilterExpressionParser.ts
var $5b7ccabde48fae90$var$ColumnParser = class {
    constructor(params, startPosition){
        this.params = params;
        this.startPosition = startPosition;
        this.type = "column";
        this.valid = true;
        this.hasStartChar = false;
        this.hasEndChar = false;
        this.colName = "";
    }
    parse(char, position) {
        if (char === $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_START_CHAR && !this.colName) this.hasStartChar = true;
        else if (char === $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_END_CHAR && this.hasStartChar) {
            const isMatch = this.parseColumn(false, position);
            if (isMatch) {
                this.hasEndChar = true;
                return false;
            } else this.colName += char;
        } else this.colName += char;
        return void 0;
    }
    getDisplayValue() {
        return (this.hasStartChar ? $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_START_CHAR : "") + this.colName + (this.hasEndChar ? $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_END_CHAR : "");
    }
    getColId() {
        return this.colId;
    }
    complete(position) {
        this.parseColumn(true, position);
    }
    getValidationError() {
        return this.valid ? null : {
            message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidColumn"),
            startPosition: this.startPosition,
            endPosition: this.endPosition ?? this.params.expression.length - 1
        };
    }
    parseColumn(fromComplete, endPosition) {
        this.endPosition = endPosition;
        const colValue = this.params.advFilterExpSvc.getColId(this.colName);
        if (colValue && this.hasStartChar) {
            this.colId = colValue.colId;
            $5b7ccabde48fae90$var$checkAndUpdateExpression(this.params, this.colName, colValue.columnName, endPosition - 1);
            this.colName = colValue.columnName;
            this.column = this.params.colModel.getColDefCol(this.colId);
            if (this.column) {
                this.baseCellDataType = this.params.dataTypeSvc?.getBaseDataType(this.column) ?? "text";
                return true;
            }
        }
        if (fromComplete) this.valid = false;
        this.baseCellDataType = "text";
        return false;
    }
};
var $5b7ccabde48fae90$var$OperatorParser = class {
    constructor(params, startPosition, baseCellDataType){
        this.params = params;
        this.startPosition = startPosition;
        this.baseCellDataType = baseCellDataType;
        this.type = "operator";
        this.valid = true;
        this.expectedNumOperands = 0;
        this.operator = "";
    }
    parse(char, position) {
        if (char === " " || char === ")") {
            const isMatch = this.parseOperator(false, position - 1);
            if (isMatch) return true;
            else this.operator += char;
        } else this.operator += char;
        return void 0;
    }
    complete(position) {
        this.parseOperator(true, position);
    }
    getValidationError() {
        return this.valid ? null : {
            message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidOption"),
            startPosition: this.startPosition,
            endPosition: this.endPosition ?? this.params.expression.length - 1
        };
    }
    getDisplayValue() {
        return this.operator;
    }
    getOperatorKey() {
        return this.parsedOperator;
    }
    parseOperator(fromComplete, endPosition) {
        const operatorForType = this.params.advFilterExpSvc.getDataTypeExpressionOperator(this.baseCellDataType);
        const parsedOperator = operatorForType.findOperator(this.operator);
        this.endPosition = endPosition;
        if (parsedOperator) {
            this.parsedOperator = parsedOperator;
            const operator = operatorForType.operators[parsedOperator];
            this.expectedNumOperands = operator.numOperands;
            const operatorDisplayValue = operator.displayValue;
            $5b7ccabde48fae90$var$checkAndUpdateExpression(this.params, this.operator, operatorDisplayValue, endPosition);
            this.operator = operatorDisplayValue;
            return true;
        }
        const isPartialMatch = parsedOperator === null;
        if (fromComplete || !isPartialMatch) this.valid = false;
        return false;
    }
};
var $5b7ccabde48fae90$var$OperandParser = class {
    constructor(params, startPosition, baseCellDataType, column){
        this.params = params;
        this.startPosition = startPosition;
        this.baseCellDataType = baseCellDataType;
        this.column = column;
        this.type = "operand";
        this.valid = true;
        this.operand = "";
        this.validationMessage = null;
        this.filterValidationSetters = {
            number: ()=>{
                if (this.quotes || isNaN(this.modelValue)) {
                    this.valid = false;
                    this.validationMessage = this.params.advFilterExpSvc.translate("advancedFilterValidationNotANumber");
                }
            },
            date: (modelValue)=>{
                if (modelValue == null) {
                    this.valid = false;
                    this.validationMessage = this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidDate");
                }
            },
            dateString: (...args)=>this.filterValidationSetters.date(...args),
            dateTime: (...args)=>this.filterValidationSetters.date(...args),
            dateTimeString: (...args)=>this.filterValidationSetters.date(...args),
            boolean () {},
            object () {},
            text () {}
        };
    }
    parse(char, position) {
        if (char === " ") {
            if (this.quotes) this.operand += char;
            else {
                this.parseOperand(false, position);
                return true;
            }
        } else if (char === ")") {
            if (this.baseCellDataType === "number" || !this.quotes) {
                this.parseOperand(false, position - 1);
                return true;
            } else this.operand += char;
        } else if (!this.operand && !this.quotes && (char === `'` || char === `"`)) this.quotes = char;
        else if (this.quotes && char === this.quotes) {
            this.parseOperand(false, position);
            return false;
        } else this.operand += char;
        return void 0;
    }
    complete(position) {
        this.parseOperand(true, position);
    }
    getValidationError() {
        return this.validationMessage ? {
            message: this.validationMessage,
            startPosition: this.startPosition,
            endPosition: this.endPosition ?? this.params.expression.length - 1
        } : null;
    }
    getRawValue() {
        return this.operand;
    }
    getModelValue() {
        return this.modelValue;
    }
    parseOperand(fromComplete, position) {
        const { advFilterExpSvc: advFilterExpSvc } = this.params;
        this.endPosition = position;
        this.modelValue = this.operand;
        if (fromComplete && this.quotes) {
            this.valid = false;
            this.validationMessage = advFilterExpSvc.translate("advancedFilterValidationMissingQuote");
        } else if (this.modelValue === "") {
            this.valid = false;
            this.validationMessage = advFilterExpSvc.translate("advancedFilterValidationMissingValue");
        } else {
            const modelValue = advFilterExpSvc.getOperandModelValue(this.operand, this.baseCellDataType, this.column);
            if (modelValue != null) this.modelValue = modelValue;
            this.filterValidationSetters[this.baseCellDataType](modelValue);
        }
    }
};
var $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_START_CHAR = "[";
var $5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_END_CHAR = "]";
var $5b7ccabde48fae90$var$ColFilterExpressionParser = class {
    constructor(params, startPosition){
        this.params = params;
        this.startPosition = startPosition;
        this.isAwaiting = true;
        this.operandValueGetters = {
            number: Number,
            date: (operand)=>this.params.valueSvc.parseValue(this.columnParser.column, null, operand, void 0),
            dateString: (...args)=>this.operandValueGetters.date(...args),
            dateTime: (...args)=>this.operandValueGetters.date(...args),
            dateTimeString: (...args)=>this.operandValueGetters.date(...args),
            boolean: (operand)=>operand,
            object: (operand)=>operand,
            text: (operand)=>operand
        };
    }
    parseExpression() {
        let i = this.startPosition;
        const { expression: expression } = this.params;
        while(i < expression.length){
            const char = expression[i];
            if (char === " " && this.isAwaiting) ;
            else {
                this.isAwaiting = false;
                if (!this.parser) {
                    let parser;
                    if (!this.columnParser) {
                        this.columnParser = new $5b7ccabde48fae90$var$ColumnParser(this.params, i);
                        parser = this.columnParser;
                    } else if (!this.operatorParser) {
                        this.operatorParser = new $5b7ccabde48fae90$var$OperatorParser(this.params, i, this.columnParser.baseCellDataType);
                        parser = this.operatorParser;
                    } else {
                        this.operandParser = new $5b7ccabde48fae90$var$OperandParser(this.params, i, this.columnParser.baseCellDataType, this.columnParser.column);
                        parser = this.operandParser;
                    }
                    this.parser = parser;
                }
                const hasCompletedOnPrevChar = this.parser.parse(char, i);
                if (hasCompletedOnPrevChar != null) {
                    if (this.isComplete()) return this.returnEndPosition(hasCompletedOnPrevChar ? i - 1 : i, true);
                    this.parser = void 0;
                    this.isAwaiting = true;
                }
            }
            i++;
        }
        this.parser?.complete?.(i - 1);
        return this.returnEndPosition(i);
    }
    isValid() {
        return this.isComplete() && this.columnParser.valid && this.operatorParser.valid && (!this.operandParser || this.operandParser.valid);
    }
    getValidationError() {
        const validationError = this.columnParser?.getValidationError() ?? this.operatorParser?.getValidationError() ?? this.operandParser?.getValidationError();
        if (validationError) return validationError;
        const endPosition = this.params.expression.length;
        let translateKey;
        if (!this.columnParser) translateKey = "advancedFilterValidationMissingColumn";
        else if (!this.operatorParser) translateKey = "advancedFilterValidationMissingOption";
        else if (this.operatorParser.expectedNumOperands && !this.operandParser) translateKey = "advancedFilterValidationMissingValue";
        if (translateKey) return {
            message: this.params.advFilterExpSvc.translate(translateKey),
            startPosition: endPosition,
            endPosition: endPosition
        };
        return null;
    }
    getFunction(params) {
        return this.getFunctionCommon(params, (operandIndex, operatorIndex, colId, evaluatorParamsIndex)=>{
            return (expressionProxy, node, p)=>p.operators[operatorIndex].evaluator(expressionProxy.getValue(colId, node), node, p.evaluatorParams[evaluatorParamsIndex], operandIndex == null ? void 0 : p.operands[operandIndex]);
        });
    }
    getAutocompleteListParams(position) {
        if (this.isColumnPosition(position)) return this.getColumnAutocompleteListParams(position);
        if (this.isOperatorPosition(position)) return this.getOperatorAutocompleteListParams(position);
        if (this.isBeyondEndPosition(position)) return void 0;
        return {
            enabled: false
        };
    }
    updateExpression(position, updateEntry, type) {
        const { expression: expression } = this.params;
        if (this.isColumnPosition(position)) return $5b7ccabde48fae90$var$updateExpression(this.params.expression, this.startPosition, this.columnParser?.getColId() ? this.columnParser.endPosition : $5b7ccabde48fae90$var$findEndPosition(expression, position).endPosition, this.params.advFilterExpSvc.getColumnValue(updateEntry), true);
        else if (this.isOperatorPosition(position)) {
            const baseCellDataType = this.getBaseCellDataTypeFromOperatorAutocompleteType(type);
            const hasOperand = this.hasOperand(baseCellDataType, updateEntry.key);
            const doesOperandNeedQuotes = hasOperand && this.doesOperandNeedQuotes(baseCellDataType);
            let update;
            if (this.operatorParser?.startPosition != null && position < this.operatorParser.startPosition) update = $5b7ccabde48fae90$var$updateExpression(expression, position, position, updateEntry.displayValue ?? updateEntry.key, hasOperand, doesOperandNeedQuotes);
            else {
                let endPosition;
                let empty = false;
                if (this.operatorParser?.getOperatorKey()) endPosition = this.operatorParser.endPosition;
                else {
                    const { endPosition: calculatedEndPosition, isEmpty: isEmpty } = $5b7ccabde48fae90$var$findEndPosition(expression, position, true, true);
                    endPosition = calculatedEndPosition;
                    empty = isEmpty;
                }
                update = $5b7ccabde48fae90$var$updateExpression(expression, $5b7ccabde48fae90$var$findStartPosition(expression, this.columnParser.endPosition + 1, endPosition), endPosition, updateEntry.displayValue ?? updateEntry.key, hasOperand, doesOperandNeedQuotes, empty);
            }
            return {
                ...update,
                hideAutocomplete: !hasOperand
            };
        }
        return null;
    }
    getModel() {
        const colId = this.columnParser.getColId();
        const model = {
            filterType: this.columnParser.baseCellDataType,
            colId: colId,
            type: this.operatorParser.getOperatorKey()
        };
        if (this.operatorParser.expectedNumOperands) model.filter = this.operandParser.getModelValue();
        return model;
    }
    getFunctionCommon(params, processFunc) {
        const colId = this.columnParser.getColId();
        const operator = this.operatorParser?.getOperatorKey();
        const { operators: operators, evaluatorParams: evaluatorParams, operands: operands } = params;
        const operatorForColumn = this.params.advFilterExpSvc.getExpressionOperator(this.columnParser.baseCellDataType, operator);
        const operatorIndex = this.addToListAndGetIndex(operators, operatorForColumn);
        const evaluatorParamsForColumn = this.params.advFilterExpSvc.getExpressionEvaluatorParams(colId);
        const evaluatorParamsIndex = this.addToListAndGetIndex(evaluatorParams, evaluatorParamsForColumn);
        const operandIndex = this.operatorParser?.expectedNumOperands === 0 ? void 0 : this.addToListAndGetIndex(operands, this.getOperandValue());
        return processFunc(operandIndex, operatorIndex, colId, evaluatorParamsIndex);
    }
    getOperandValue() {
        const { baseCellDataType: baseCellDataType, column: column } = this.columnParser;
        const operand = this.operandValueGetters[baseCellDataType](this.operandParser.getRawValue());
        if (baseCellDataType === "dateString" || baseCellDataType === "dateTimeString") return this.params.dataTypeSvc?.getDateParserFunction(column)(operand) ?? operand;
        return operand;
    }
    isComplete() {
        return !!(this.operatorParser && (!this.operatorParser.expectedNumOperands || this.operatorParser.expectedNumOperands && this.operandParser));
    }
    isColumnPosition(position) {
        return this.columnParser?.endPosition == null || position <= this.columnParser.endPosition + 1;
    }
    isOperatorPosition(position) {
        return this.operatorParser?.endPosition == null || position <= this.operatorParser.endPosition + 1;
    }
    isBeyondEndPosition(position) {
        return this.isComplete() && this.endPosition != null && position > this.endPosition + 1 && this.endPosition + 1 < this.params.expression.length;
    }
    returnEndPosition(returnPosition, treatAsEnd) {
        this.endPosition = treatAsEnd ? returnPosition : returnPosition - 1;
        return returnPosition;
    }
    getColumnAutocompleteListParams(position) {
        return this.params.advFilterExpSvc.generateAutocompleteListParams(this.params.advFilterExpSvc.getColumnAutocompleteEntries(), "column", this.getColumnSearchString(position));
    }
    getColumnSearchString(position) {
        const columnName = this.columnParser?.getDisplayValue() ?? "";
        const searchString = $5b7ccabde48fae90$var$getSearchString(columnName, position, this.columnParser?.endPosition == null ? this.params.expression.length : this.columnParser.endPosition + 1);
        const containsStartChar = this.columnParser?.hasStartChar && searchString.length > 0;
        const containsEndChar = this.columnParser?.hasEndChar && searchString.length === columnName.length + 2;
        if (containsStartChar) return searchString.slice(1, containsEndChar ? -1 : void 0);
        return searchString;
    }
    getOperatorAutocompleteListParams(position) {
        const column = this.columnParser?.column;
        if (!column) return {
            enabled: false
        };
        const baseCellDataType = this.columnParser.baseCellDataType;
        const searchString = this.operatorParser?.startPosition != null && position < this.operatorParser.startPosition ? "" : $5b7ccabde48fae90$var$getSearchString(this.operatorParser?.getDisplayValue() ?? "", position, this.operatorParser?.endPosition == null ? this.params.expression.length : this.operatorParser.endPosition + 1);
        return this.params.advFilterExpSvc.generateAutocompleteListParams(this.params.advFilterExpSvc.getOperatorAutocompleteEntries(column, baseCellDataType), `operator-${baseCellDataType}`, searchString);
    }
    getBaseCellDataTypeFromOperatorAutocompleteType(type) {
        return type?.replace("operator-", "");
    }
    hasOperand(baseCellDataType, operator) {
        return !baseCellDataType || !operator || (this.params.advFilterExpSvc.getExpressionOperator(baseCellDataType, operator)?.numOperands ?? 0) > 0;
    }
    doesOperandNeedQuotes(baseCellDataType) {
        return baseCellDataType !== "number";
    }
    addToListAndGetIndex(list, value) {
        const index = list.length;
        list.push(value);
        return index;
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/filterExpressionOperators.ts
function $5b7ccabde48fae90$var$findMatch(searchValue, values, getDisplayValue) {
    let partialMatch = false;
    const searchValueLowerCase = searchValue.toLocaleLowerCase();
    const partialSearchValue = searchValueLowerCase + " ";
    const parsedValue = Object.keys(values).find((key)=>{
        const value = values[key];
        const displayValueLowerCase = getDisplayValue(value).toLocaleLowerCase();
        if (displayValueLowerCase.startsWith(partialSearchValue)) partialMatch = true;
        return displayValueLowerCase === searchValueLowerCase;
    });
    if (parsedValue) return parsedValue;
    else if (partialMatch) return null;
    else return void 0;
}
function $5b7ccabde48fae90$var$getEntries(operators, activeOperatorKeys) {
    const keys = activeOperatorKeys ?? Object.keys(operators);
    return keys.map((key)=>({
            key: key,
            displayValue: operators[key].displayValue
        }));
}
var $5b7ccabde48fae90$var$TextFilterExpressionOperators = class {
    constructor(params){
        this.params = params;
        this.initOperators();
    }
    getEntries(activeOperators) {
        return $5b7ccabde48fae90$var$getEntries(this.operators, activeOperators);
    }
    findOperator(displayValue) {
        return $5b7ccabde48fae90$var$findMatch(displayValue, this.operators, ({ displayValue: displayValue2 })=>displayValue2);
    }
    initOperators() {
        const { translate: translate } = this.params;
        this.operators = {
            contains: {
                displayValue: translate("advancedFilterContains"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v.includes(o)),
                numOperands: 1
            },
            notContains: {
                displayValue: translate("advancedFilterNotContains"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, true, (v, o)=>!v.includes(o)),
                numOperands: 1
            },
            equals: {
                displayValue: translate("advancedFilterTextEquals"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v === o),
                numOperands: 1
            },
            notEqual: {
                displayValue: translate("advancedFilterTextNotEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, true, (v, o)=>v != o),
                numOperands: 1
            },
            startsWith: {
                displayValue: translate("advancedFilterStartsWith"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v.startsWith(o)),
                numOperands: 1
            },
            endsWith: {
                displayValue: translate("advancedFilterEndsWith"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v.endsWith(o)),
                numOperands: 1
            },
            blank: {
                displayValue: translate("advancedFilterBlank"),
                evaluator: (value)=>value == null || typeof value === "string" && value.trim().length === 0,
                numOperands: 0
            },
            notBlank: {
                displayValue: translate("advancedFilterNotBlank"),
                evaluator: (value)=>value != null && (typeof value !== "string" || value.trim().length > 0),
                numOperands: 0
            }
        };
    }
    evaluateExpression(value, node, params, operand, nullsMatch, expression) {
        if (value == null) return nullsMatch;
        return params.caseSensitive ? expression(params.valueConverter(value, node), operand) : expression(params.valueConverter(value, node).toLocaleLowerCase(), operand.toLocaleLowerCase());
    }
};
var $5b7ccabde48fae90$var$ScalarFilterExpressionOperators = class {
    constructor(params){
        this.params = params;
        this.initOperators();
    }
    getEntries(activeOperators) {
        return $5b7ccabde48fae90$var$getEntries(this.operators, activeOperators);
    }
    findOperator(displayValue) {
        return $5b7ccabde48fae90$var$findMatch(displayValue, this.operators, ({ displayValue: displayValue2 })=>displayValue2);
    }
    initOperators() {
        const { translate: translate, equals: equals } = this.params;
        this.operators = {
            equals: {
                displayValue: translate("advancedFilterEquals"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInEquals, equals),
                numOperands: 1
            },
            notEqual: {
                displayValue: translate("advancedFilterNotEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInEquals, (v, o)=>!equals(v, o)),
                numOperands: 1
            },
            greaterThan: {
                displayValue: translate("advancedFilterGreaterThan"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInGreaterThan, (v, o)=>v > o),
                numOperands: 1
            },
            greaterThanOrEqual: {
                displayValue: translate("advancedFilterGreaterThanOrEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInGreaterThan, (v, o)=>v >= o),
                numOperands: 1
            },
            lessThan: {
                displayValue: translate("advancedFilterLessThan"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInLessThan, (v, o)=>v < o),
                numOperands: 1
            },
            lessThanOrEqual: {
                displayValue: translate("advancedFilterLessThanOrEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInLessThan, (v, o)=>v <= o),
                numOperands: 1
            },
            blank: {
                displayValue: translate("advancedFilterBlank"),
                evaluator: (value)=>value == null,
                numOperands: 0
            },
            notBlank: {
                displayValue: translate("advancedFilterNotBlank"),
                evaluator: (value)=>value != null,
                numOperands: 0
            }
        };
    }
    evaluateSingleOperandExpression(value, node, params, operand, nullsMatch, expression) {
        if (value == null) return nullsMatch;
        return expression(params.valueConverter(value, node), operand);
    }
};
var $5b7ccabde48fae90$var$BooleanFilterExpressionOperators = class {
    constructor(params){
        this.params = params;
        this.initOperators();
    }
    getEntries(activeOperators) {
        return $5b7ccabde48fae90$var$getEntries(this.operators, activeOperators);
    }
    findOperator(displayValue) {
        return $5b7ccabde48fae90$var$findMatch(displayValue, this.operators, ({ displayValue: displayValue2 })=>displayValue2);
    }
    initOperators() {
        const { translate: translate } = this.params;
        this.operators = {
            true: {
                displayValue: translate("advancedFilterTrue"),
                evaluator: (value)=>!!value,
                numOperands: 0
            },
            false: {
                displayValue: translate("advancedFilterFalse"),
                evaluator: (value)=>value === false,
                numOperands: 0
            },
            blank: {
                displayValue: translate("advancedFilterBlank"),
                evaluator: (value)=>value == null,
                numOperands: 0
            },
            notBlank: {
                displayValue: translate("advancedFilterNotBlank"),
                evaluator: (value)=>value != null,
                numOperands: 0
            }
        };
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterExpressionService.ts
var $5b7ccabde48fae90$var$AdvancedFilterExpressionService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "advFilterExpSvc";
        this.filterOperandGetters = {
            number: (model)=>(0, $437b23f6a393c3bf$export$2a74c29220d5c88e)(model.filter) ?? "",
            date: (model)=>{
                const column = this.colModel.getColDefCol(model.colId);
                if (!column) return null;
                return this.valueSvc.formatValue(column, null, (0, $437b23f6a393c3bf$export$26ded2d88c01b527)(model.filter));
            },
            dateTime: (model)=>this.filterOperandGetters.date(model),
            dateString: (model)=>{
                const column = this.colModel.getColDefCol(model.colId);
                if (!column) return null;
                const { filter: filter } = model;
                const dateFormatFn = this.dataTypeSvc?.getDateFormatterFunction(column);
                const dateStringStringValue = dateFormatFn?.((0, $437b23f6a393c3bf$export$26ded2d88c01b527)(filter) ?? void 0) ?? filter;
                return this.valueSvc.formatValue(column, null, dateStringStringValue);
            },
            dateTimeString: (model)=>this.filterOperandGetters.dateString(model),
            boolean: ()=>null,
            object: ()=>null,
            text: ()=>null
        };
        this.operandModelValueGetters = {
            number: (operand)=>(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(operand) ? Number(operand) : null,
            date: (operand, column, baseCellDataType)=>(0, $437b23f6a393c3bf$export$3d7fedfb21962874)(this.valueSvc.parseValue(column, null, operand, void 0), !!this.dataTypeSvc?.getDateIncludesTimeFlag(baseCellDataType)),
            dateTime: (...args)=>this.operandModelValueGetters.date(...args),
            dateString: (operand, column, baseCellDataType)=>{
                const parsedDateString = this.valueSvc.parseValue(column, null, operand, void 0);
                if (this.dataTypeSvc) return (0, $437b23f6a393c3bf$export$3d7fedfb21962874)(this.dataTypeSvc.getDateParserFunction(column)(parsedDateString) ?? null, this.dataTypeSvc.getDateIncludesTimeFlag(baseCellDataType));
                return parsedDateString;
            },
            dateTimeString: (...args)=>this.operandModelValueGetters.dateString(...args),
            boolean: (operand)=>operand,
            object: (operand)=>operand,
            text: (operand)=>operand
        };
        this.columnNameToIdMap = {};
        this.columnAutocompleteEntries = null;
        this.expressionEvaluatorParams = {};
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
        this.colModel = beans.colModel;
        this.colNames = beans.colNames;
        this.dataTypeSvc = beans.dataTypeSvc;
    }
    postConstruct() {
        this.expressionJoinOperators = this.generateExpressionJoinOperators();
        this.expressionOperators = this.generateExpressionOperators();
    }
    parseJoinOperator(model) {
        const { type: type } = model;
        return this.expressionJoinOperators[type] ?? type;
    }
    getColumnDisplayValue(model) {
        const { colId: colId } = model;
        const columnEntries = this.getColumnAutocompleteEntries();
        const columnEntry = columnEntries.find(({ key: key })=>key === colId);
        let columnName;
        if (columnEntry) {
            columnName = columnEntry.displayValue;
            this.columnNameToIdMap[columnName.toLocaleUpperCase()] = {
                colId: colId,
                columnName: columnName
            };
        } else columnName = colId;
        return columnName;
    }
    getOperatorDisplayValue(model) {
        return this.getExpressionOperator(model.filterType, model.type)?.displayValue ?? model.type;
    }
    getOperandModelValue(operand, baseCellDataType, column) {
        return this.operandModelValueGetters[baseCellDataType](operand, column, baseCellDataType);
    }
    getOperandDisplayValue(model, skipFormatting) {
        const { filter: filter } = model;
        if (filter == null) return "";
        let operand1 = this.filterOperandGetters[model.filterType](model);
        if (model.filterType !== "number") {
            operand1 ?? (operand1 = (0, $437b23f6a393c3bf$export$2a74c29220d5c88e)(filter) ?? "");
            if (!skipFormatting) operand1 = `"${operand1}"`;
        }
        return skipFormatting ? operand1 : ` ${operand1}`;
    }
    parseColumnFilterModel(model) {
        const columnName = this.getColumnDisplayValue(model) ?? "";
        const operator = this.getOperatorDisplayValue(model) ?? "";
        const operands = this.getOperandDisplayValue(model);
        return `[${columnName}] ${operator}${operands}`;
    }
    updateAutocompleteCache(updateEntry, type) {
        if (type === "column") {
            const { key: colId, displayValue: displayValue } = updateEntry;
            this.columnNameToIdMap[updateEntry.displayValue.toLocaleUpperCase()] = {
                colId: colId,
                columnName: displayValue
            };
        }
    }
    translate(key, variableValues) {
        let defaultValue = $5b7ccabde48fae90$var$ADVANCED_FILTER_LOCALE_TEXT[key];
        if (typeof defaultValue === "function") defaultValue = defaultValue(variableValues);
        return this.getLocaleTextFunc()(key, defaultValue, variableValues);
    }
    generateAutocompleteListParams(entries, type, searchString) {
        return {
            enabled: true,
            type: type,
            searchString: searchString,
            entries: entries
        };
    }
    getColumnAutocompleteEntries() {
        if (this.columnAutocompleteEntries) return this.columnAutocompleteEntries;
        const columns = this.colModel.getColDefCols() ?? [];
        const entries = [];
        const includeHiddenColumns = this.gos.get("includeHiddenColumnsInAdvancedFilter");
        for (const column of columns)if (column.getColDef().filter && (includeHiddenColumns || column.isVisible() || column.isRowGroupActive())) entries.push({
            key: column.getColId(),
            displayValue: this.colNames.getDisplayNameForColumn(column, "advancedFilter")
        });
        entries.sort((a, b)=>{
            const aValue = a.displayValue ?? "";
            const bValue = b.displayValue ?? "";
            if (aValue < bValue) return -1;
            else if (bValue > aValue) return 1;
            return 0;
        });
        return entries;
    }
    getOperatorAutocompleteEntries(column, baseCellDataType) {
        const activeOperators = this.getActiveOperators(column);
        return this.getDataTypeExpressionOperator(baseCellDataType).getEntries(activeOperators);
    }
    getJoinOperatorAutocompleteEntries() {
        return Object.entries(this.expressionJoinOperators).map(([key, displayValue])=>({
                key: key,
                displayValue: displayValue
            }));
    }
    getDefaultAutocompleteListParams(searchString) {
        return this.generateAutocompleteListParams(this.getColumnAutocompleteEntries(), "column", searchString);
    }
    getDataTypeExpressionOperator(baseCellDataType) {
        return this.expressionOperators[baseCellDataType];
    }
    getExpressionOperator(baseCellDataType, operator) {
        return this.getDataTypeExpressionOperator(baseCellDataType)?.operators?.[operator];
    }
    getExpressionJoinOperators() {
        return this.expressionJoinOperators;
    }
    getColId(columnName) {
        const upperCaseColumnName = columnName.toLocaleUpperCase();
        const cachedColId = this.columnNameToIdMap[upperCaseColumnName];
        if (cachedColId) return cachedColId;
        const columnAutocompleteEntries = this.getColumnAutocompleteEntries();
        const colEntry = columnAutocompleteEntries.find(({ displayValue: displayValue })=>displayValue.toLocaleUpperCase() === upperCaseColumnName);
        if (colEntry) {
            const { key: colId, displayValue: displayValue } = colEntry;
            const colValue = {
                colId: colId,
                columnName: displayValue
            };
            this.columnNameToIdMap[upperCaseColumnName] = colValue;
            return colValue;
        }
        return null;
    }
    getExpressionEvaluatorParams(colId) {
        let params = this.expressionEvaluatorParams[colId];
        if (params) return params;
        const column = this.colModel.getColDefCol(colId);
        if (!column) return {
            valueConverter: (v)=>v
        };
        const baseCellDataType = this.dataTypeSvc?.getBaseDataType(column);
        switch(baseCellDataType){
            case "dateTimeString":
            case "dateString":
                params = {
                    valueConverter: this.dataTypeSvc?.getDateParserFunction(column) ?? ((v)=>v)
                };
                break;
            case "object":
                if (column.getColDef().filterValueGetter) params = {
                    valueConverter: (v)=>v
                };
                else params = {
                    valueConverter: (value, node)=>this.valueSvc.formatValue(column, node, value) ?? (typeof value.toString === "function" ? value.toString() : "")
                };
                break;
            case "text":
            case void 0:
                params = {
                    valueConverter: (v)=>(0, $437b23f6a393c3bf$export$2a74c29220d5c88e)(v)
                };
                break;
            default:
                params = {
                    valueConverter: (v)=>v
                };
                break;
        }
        const { filterParams: filterParams } = column.getColDef();
        if (filterParams) [
            "caseSensitive",
            "includeBlanksInEquals",
            "includeBlanksInLessThan",
            "includeBlanksInGreaterThan"
        ].forEach((param)=>{
            const paramValue = filterParams[param];
            if (paramValue) params[param] = paramValue;
        });
        this.expressionEvaluatorParams[colId] = params;
        return params;
    }
    getColumnDetails(colId) {
        const column = this.colModel.getColDefCol(colId) ?? void 0;
        const baseCellDataType = (column ? this.dataTypeSvc?.getBaseDataType(column) : void 0) ?? "text";
        return {
            column: column,
            baseCellDataType: baseCellDataType
        };
    }
    generateExpressionOperators() {
        const translate = (key, variableValues)=>this.translate(key, variableValues);
        const dateOperatorsParams = {
            translate: translate,
            equals: (v, o)=>v.getTime() === o.getTime()
        };
        return {
            text: new $5b7ccabde48fae90$var$TextFilterExpressionOperators({
                translate: translate
            }),
            boolean: new $5b7ccabde48fae90$var$BooleanFilterExpressionOperators({
                translate: translate
            }),
            object: new $5b7ccabde48fae90$var$TextFilterExpressionOperators({
                translate: translate
            }),
            number: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators({
                translate: translate,
                equals: (v, o)=>v === o
            }),
            date: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators(dateOperatorsParams),
            dateString: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators(dateOperatorsParams),
            dateTime: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators(dateOperatorsParams),
            dateTimeString: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators(dateOperatorsParams)
        };
    }
    getColumnValue({ displayValue: displayValue }) {
        return `${$5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_START_CHAR}${displayValue}${$5b7ccabde48fae90$var$COL_FILTER_EXPRESSION_END_CHAR}`;
    }
    generateExpressionJoinOperators() {
        return {
            AND: this.translate("advancedFilterAnd"),
            OR: this.translate("advancedFilterOr")
        };
    }
    getActiveOperators(column) {
        const filterOptions = column.getColDef().filterParams?.filterOptions;
        if (!filterOptions) return void 0;
        const isValid = filterOptions.every((filterOption)=>typeof filterOption === "string");
        return isValid ? filterOptions : void 0;
    }
    resetColumnCaches() {
        this.columnAutocompleteEntries = null;
        this.columnNameToIdMap = {};
        this.expressionEvaluatorParams = {};
    }
};
var $5b7ccabde48fae90$var$DIALOG_CALLBACKS = {
    stopPropagationCallbacks: (0, $437b23f6a393c3bf$export$24fcbcdf47263033),
    focusNextContainer: (beans, backwards)=>{
        return (0, $437b23f6a393c3bf$export$987f3c95dc941f0c)(beans, backwards);
    },
    configureFocusableContainer: (beans, dialog)=>{
        const gridCtrl = beans.ctrlsSvc.get("gridCtrl");
        gridCtrl.addFocusableContainer(dialog);
        dialog.addDestroyFunc(()=>gridCtrl.removeFocusableContainer(dialog));
    }
};
var $5b7ccabde48fae90$var$Dialog = class extends $5b7ccabde48fae90$export$1ad436e57f28685a {
    constructor(config){
        super(config, $5b7ccabde48fae90$var$DIALOG_CALLBACKS);
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/autocomplete/agAutocomplete.css-GENERATED.ts
var $5b7ccabde48fae90$var$agAutocompleteCSS = /*css*/ `.ag-autocomplete{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}}.ag-autocomplete-list-popup{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-autocomplete-list{height:calc(var(--ag-row-height)*6.5);min-width:200px;position:relative;width:100%}.ag-autocomplete-virtual-list-item{cursor:default;display:flex;height:var(--ag-list-item-height);&:focus-visible:after{content:none}&:hover{background-color:var(--ag-row-hover-color)}}.ag-autocomplete-row{align-items:center;display:flex;flex:1 1 auto;overflow:hidden}.ag-autocomplete-row-label{margin:0 var(--ag-widget-container-horizontal-padding);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-autocomplete-row-selected{background-color:var(--ag-selected-row-background-color)}`;
var $5b7ccabde48fae90$var$VirtualList = class extends $5b7ccabde48fae90$export$8e1851f3e0fb2e09 {
    constructor(params){
        super((0, $437b23f6a393c3bf$export$24fcbcdf47263033), params);
    }
};
var $5b7ccabde48fae90$var$AgAutocompleteRowElement = {
    tag: "div",
    cls: "ag-autocomplete-row",
    role: "presentation",
    children: [
        {
            tag: "div",
            cls: "ag-autocomplete-row-label"
        }
    ]
};
var $5b7ccabde48fae90$var$AgAutocompleteRow = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$AgAutocompleteRowElement);
        this.hasHighlighting = false;
    }
    setState(value, selected) {
        this.value = value;
        this.render();
        this.updateSelected(selected);
    }
    updateSelected(selected) {
        this.toggleCss("ag-autocomplete-row-selected", selected);
    }
    setSearchString(searchString) {
        let keepHighlighting = false;
        const { value: value } = this;
        if (value && (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(searchString)) {
            const index = value.toLocaleLowerCase().indexOf(searchString.toLocaleLowerCase());
            if (index >= 0) {
                keepHighlighting = true;
                this.hasHighlighting = true;
                const highlightEndIndex = index + searchString.length;
                const child = this.getGui().lastElementChild;
                (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(child);
                child.append(// Start part
                value.slice(0, index), // Highlighted part wrapped in bold tag
                (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
                    tag: "b",
                    children: value.slice(index, highlightEndIndex)
                }), // End part
                value.slice(highlightEndIndex));
            }
        }
        if (!keepHighlighting && this.hasHighlighting) {
            this.hasHighlighting = false;
            this.render();
        }
    }
    render() {
        this.getGui().lastElementChild.textContent = this.value ?? "\xA0";
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/autocomplete/agAutocompleteList.ts
var $5b7ccabde48fae90$var$AgAutocompleteListElement = {
    tag: "div",
    cls: "ag-autocomplete-list-popup",
    children: [
        {
            tag: "div",
            ref: "eList",
            cls: "ag-autocomplete-list"
        }
    ]
};
var $5b7ccabde48fae90$var$AgAutocompleteList = class extends (0, $437b23f6a393c3bf$export$acd471c9223f27ae) {
    constructor(params){
        super($5b7ccabde48fae90$var$AgAutocompleteListElement);
        this.params = params;
        this.eList = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.searchString = "";
    }
    postConstruct() {
        this.autocompleteEntries = this.params.autocompleteEntries;
        this.virtualList = this.createManagedBean(new $5b7ccabde48fae90$var$VirtualList({
            cssIdentifier: "autocomplete"
        }));
        this.virtualList.setComponentCreator(this.createRowComponent.bind(this));
        this.eList.appendChild(this.virtualList.getGui());
        this.virtualList.setModel({
            getRowCount: ()=>this.autocompleteEntries.length,
            getRow: (index)=>this.autocompleteEntries[index]
        });
        const virtualListGui = this.virtualList.getGui();
        this.addManagedListeners(virtualListGui, {
            click: ()=>this.params.onConfirmed(),
            mousemove: this.onMouseMove.bind(this),
            mousedown: (e)=>e.preventDefault()
        });
        this.setSelectedValue(0);
    }
    onNavigationKeyDown(event, key) {
        event.preventDefault();
        const oldIndex = this.autocompleteEntries.indexOf(this.selectedValue);
        const newIndex = key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP ? oldIndex - 1 : oldIndex + 1;
        this.checkSetSelectedValue(newIndex);
    }
    setSearch(searchString) {
        this.searchString = searchString;
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(searchString)) this.runSearch();
        else {
            this.autocompleteEntries = this.params.autocompleteEntries;
            this.virtualList.refresh();
            this.checkSetSelectedValue(0);
        }
        this.updateSearchInList();
    }
    runContainsSearch(searchString, searchStrings) {
        let topMatch;
        let topMatchStartsWithSearchString = false;
        const lowerCaseSearchString = searchString.toLocaleLowerCase();
        const allMatches = searchStrings.filter((string)=>{
            const lowerCaseString = string.toLocaleLowerCase();
            const index = lowerCaseString.indexOf(lowerCaseSearchString);
            const startsWithSearchString = index === 0;
            const isMatch = index >= 0;
            if (isMatch && (!topMatch || !topMatchStartsWithSearchString && startsWithSearchString || topMatchStartsWithSearchString === startsWithSearchString && string.length < topMatch.length)) {
                topMatch = string;
                topMatchStartsWithSearchString = startsWithSearchString;
            }
            return isMatch;
        });
        if (!topMatch && allMatches.length) topMatch = allMatches[0];
        return {
            topMatch: topMatch,
            allMatches: allMatches
        };
    }
    runSearch() {
        const { autocompleteEntries: autocompleteEntries, useFuzzySearch: useFuzzySearch, forceLastSelection: forceLastSelection } = this.params;
        const searchStrings = autocompleteEntries.map((v)=>v.displayValue ?? v.key);
        let matchingStrings;
        let topSuggestion;
        if (useFuzzySearch) {
            matchingStrings = (0, $437b23f6a393c3bf$export$85cab1b5a4aa292c)({
                inputValue: this.searchString,
                allSuggestions: searchStrings,
                hideIrrelevant: true
            }).values;
            topSuggestion = matchingStrings.length ? matchingStrings[0] : void 0;
        } else {
            const containsMatches = this.runContainsSearch(this.searchString, searchStrings);
            matchingStrings = containsMatches.allMatches;
            topSuggestion = containsMatches.topMatch;
        }
        let filteredEntries = autocompleteEntries.filter(({ key: key, displayValue: displayValue })=>matchingStrings.includes(displayValue ?? key));
        if (!filteredEntries.length && this.selectedValue && forceLastSelection?.(this.selectedValue, this.searchString)) filteredEntries = [
            this.selectedValue
        ];
        this.autocompleteEntries = filteredEntries;
        this.virtualList.refresh();
        if (!topSuggestion) return;
        const topSuggestionIndex = matchingStrings.indexOf(topSuggestion);
        this.checkSetSelectedValue(topSuggestionIndex);
    }
    updateSearchInList() {
        this.virtualList.forEachRenderedRow((row)=>row.setSearchString(this.searchString));
    }
    checkSetSelectedValue(index) {
        if (index >= 0 && index < this.autocompleteEntries.length) this.setSelectedValue(index);
    }
    setSelectedValue(index) {
        const value = this.autocompleteEntries[index];
        if (this.selectedValue === value) return;
        this.selectedValue = value;
        this.virtualList.ensureIndexVisible(index);
        this.virtualList.forEachRenderedRow((cmp, idx)=>{
            cmp.updateSelected(index === idx);
        });
    }
    createRowComponent(value) {
        const row = new $5b7ccabde48fae90$var$AgAutocompleteRow();
        this.createBean(row);
        row.setState(value.displayValue ?? value.key, value === this.selectedValue);
        return row;
    }
    onMouseMove(mouseEvent) {
        const virtualList = this.virtualList;
        const rect = virtualList.getGui().getBoundingClientRect();
        const scrollTop = virtualList.getScrollTop();
        const mouseY = mouseEvent.clientY - rect.top + scrollTop;
        const row = Math.floor(mouseY / virtualList.getRowHeight());
        this.checkSetSelectedValue(row);
    }
    afterGuiAttached() {
        this.virtualList.refresh();
    }
    getSelectedValue() {
        if (!this.autocompleteEntries.length) return null;
        return this.selectedValue ?? null;
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/autocomplete/agAutocomplete.ts
var $5b7ccabde48fae90$var$AgAutocompleteElement = {
    tag: "div",
    cls: "ag-autocomplete",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eAutocompleteInput"
        }
    ]
};
var $5b7ccabde48fae90$var$AgAutocomplete = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$AgAutocompleteElement, [
            (0, $437b23f6a393c3bf$export$31e2985be4ee06ab)
        ]);
        this.eAutocompleteInput = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.isListOpen = false;
        this.lastPosition = 0;
        this.valid = true;
        this.registerCSS($5b7ccabde48fae90$var$agAutocompleteCSS);
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
    }
    postConstruct() {
        this.eAutocompleteInput.onValueChange((value)=>this.onValueChanged(value));
        this.eAutocompleteInput.getInputElement().setAttribute("autocomplete", "off");
        this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
        this.addGuiEventListener("click", this.updatePositionAndList.bind(this));
        this.addDestroyFunc(()=>{
            this.destroyBean(this.autocompleteList);
        });
        this.addGuiEventListener("focusout", ()=>this.onFocusOut());
    }
    onValueChanged(value) {
        const parsedValue = (0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(value);
        this.updateValue(parsedValue);
        this.updateAutocompleteList(parsedValue);
    }
    updateValue(value) {
        this.updateLastPosition();
        this.dispatchLocalEvent({
            type: "eventValueChanged",
            value: value
        });
        this.validate(value);
    }
    updateAutocompleteList(value) {
        const autocompleteListParams = this.listGenerator?.(value, this.lastPosition) ?? {
            enabled: false
        };
        if (!autocompleteListParams.type || autocompleteListParams.type !== this.autocompleteListParams?.type) {
            if (this.isListOpen) this.closeList();
        }
        const isListOpen = this.isListOpen;
        this.autocompleteListParams = autocompleteListParams;
        if (autocompleteListParams?.enabled) {
            if (!isListOpen) this.openList();
            const { searchString: searchString } = autocompleteListParams;
            this.autocompleteList.setSearch(searchString ?? "");
        } else if (isListOpen) this.closeList();
    }
    onKeyDown(event) {
        const key = event.key;
        this.updateLastPosition();
        switch(key){
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER:
                this.onEnterKeyDown(event);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).TAB:
                this.onTabKeyDown(event);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP:
                this.onUpDownKeyDown(event, key);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_HOME:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_END:
                setTimeout(()=>{
                    this.updatePositionAndList();
                });
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ESCAPE:
                this.onEscapeKeyDown(event);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE:
                if (event.ctrlKey && !this.isListOpen) {
                    event.preventDefault();
                    this.forceOpenList();
                }
                break;
        }
    }
    confirmSelection() {
        const selectedValue = this.autocompleteList?.getSelectedValue();
        if (selectedValue) {
            this.closeList();
            this.dispatchLocalEvent({
                type: "eventOptionSelected",
                value: this.getValue(),
                position: this.lastPosition,
                updateEntry: selectedValue,
                autocompleteType: this.autocompleteListParams.type
            });
        }
    }
    onTabKeyDown(event) {
        if (this.isListOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.confirmSelection();
        }
    }
    onEnterKeyDown(event) {
        event.preventDefault();
        if (this.isListOpen) this.confirmSelection();
        else this.onCompleted();
    }
    onUpDownKeyDown(event, key) {
        event.preventDefault();
        if (!this.isListOpen) this.forceOpenList();
        else this.autocompleteList?.onNavigationKeyDown(event, key);
    }
    onEscapeKeyDown(event) {
        if (this.isListOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.closeList();
            this.setCaret(this.lastPosition, true);
        }
    }
    onFocusOut() {
        if (this.isListOpen) this.closeList();
    }
    updatePositionAndList() {
        this.updateLastPosition();
        this.updateAutocompleteList(this.eAutocompleteInput.getValue() ?? null);
    }
    setCaret(position, setFocus) {
        if (setFocus || (0, $437b23f6a393c3bf$export$8ff9eef09a45371f)(this.beans)) this.eAutocompleteInput.getFocusableElement().focus();
        const eInput = this.eAutocompleteInput.getInputElement();
        eInput.setSelectionRange(position, position);
        if (position === eInput.value.length) eInput.scrollLeft = eInput.scrollWidth;
    }
    forceOpenList() {
        this.onValueChanged(this.eAutocompleteInput.getValue());
    }
    updateLastPosition() {
        this.lastPosition = this.eAutocompleteInput.getInputElement().selectionStart ?? 0;
    }
    validate(value) {
        if (!this.validator) return;
        const validationMessage = this.validationMessage = this.validator(value);
        this.eAutocompleteInput.getInputElement().setCustomValidity(validationMessage ?? "");
        this.valid = !validationMessage;
        this.dispatchLocalEvent({
            type: "eventValidChanged",
            isValid: this.valid,
            validationMessage: validationMessage
        });
    }
    openList() {
        this.isListOpen = true;
        this.autocompleteList = this.createBean(new $5b7ccabde48fae90$var$AgAutocompleteList({
            autocompleteEntries: this.autocompleteListParams.entries,
            onConfirmed: ()=>this.confirmSelection(),
            forceLastSelection: this.forceLastSelection
        }));
        const ePopupGui = this.autocompleteList.getGui();
        const positionParams = {
            ePopup: ePopupGui,
            type: "autocomplete",
            eventSource: this.getGui(),
            position: "under",
            alignSide: this.gos.get("enableRtl") ? "right" : "left",
            keepWithinBounds: true
        };
        const addPopupRes = this.popupSvc.addPopup({
            eChild: ePopupGui,
            anchorToElement: this.getGui(),
            positionCallback: ()=>this.popupSvc.positionPopupByComponent(positionParams),
            ariaLabel: this.listAriaLabel
        });
        this.hidePopup = addPopupRes.hideFunc;
        this.autocompleteList.afterGuiAttached();
    }
    closeList() {
        this.isListOpen = false;
        this.hidePopup();
        this.destroyBean(this.autocompleteList);
        this.autocompleteList = null;
    }
    onCompleted() {
        if (this.isListOpen) this.closeList();
        this.dispatchLocalEvent({
            type: "eventValueConfirmed",
            value: this.getValue(),
            isValid: this.isValid()
        });
    }
    getValue() {
        return (0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(this.eAutocompleteInput.getValue());
    }
    setInputPlaceholder(placeholder) {
        this.eAutocompleteInput.setInputPlaceholder(placeholder);
        return this;
    }
    setInputAriaLabel(label) {
        this.eAutocompleteInput.setInputAriaLabel(label);
        return this;
    }
    setListAriaLabel(label) {
        this.listAriaLabel = label;
        return this;
    }
    setListGenerator(listGenerator) {
        this.listGenerator = listGenerator;
        return this;
    }
    setValidator(validator) {
        this.validator = validator;
        return this;
    }
    isValid() {
        return this.valid;
    }
    setValue(params) {
        const { value: value, position: position, silent: silent, updateListOnlyIfOpen: updateListOnlyIfOpen, restoreFocus: restoreFocus } = params;
        this.eAutocompleteInput.setValue(value, true);
        this.setCaret(position ?? this.lastPosition, restoreFocus);
        if (!silent) this.updateValue(value);
        if (!updateListOnlyIfOpen || this.isListOpen) this.updateAutocompleteList(value);
    }
    setForceLastSelection(forceLastSelection) {
        this.forceLastSelection = forceLastSelection;
        return this;
    }
    setInputDisabled(disabled) {
        this.eAutocompleteInput.setDisabled(disabled);
        return this;
    }
};
var $5b7ccabde48fae90$var$AgAutocompleteSelector = {
    selector: "AG-AUTOCOMPLETE",
    component: $5b7ccabde48fae90$var$AgAutocomplete
};
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterComp.ts
var $5b7ccabde48fae90$var$DEFAULT_ADVANCED_FILTER_PARAMS = {
    buttons: [
        "apply"
    ],
    suppressBuilderButton: false
};
var $5b7ccabde48fae90$var$ButtonLocaleMap = {
    apply: "advancedFilterApply",
    clear: "advancedFilterClear",
    cancel: "advancedFilterCancel",
    reset: "advancedFilterReset"
};
var $5b7ccabde48fae90$var$AdvancedFilterElement = {
    tag: "div",
    cls: "ag-advanced-filter",
    role: "presentation",
    attrs: {
        tabindex: "-1"
    },
    children: [
        {
            tag: "ag-autocomplete",
            ref: "eAutocomplete"
        },
        {
            tag: "ag-filter-button",
            ref: "eButtons",
            cls: "ag-advanced-filter-buttons"
        },
        {
            tag: "button",
            ref: "eBuilderFilterButton",
            cls: "ag-button ag-advanced-filter-builder-button",
            children: [
                {
                    tag: "span",
                    ref: "eBuilderFilterButtonIcon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                },
                {
                    tag: "span",
                    ref: "eBuilderFilterButtonLabel",
                    cls: "ag-advanced-filter-builder-button-label"
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$AdvancedFilterComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$AdvancedFilterElement, [
            $5b7ccabde48fae90$var$AgAutocompleteSelector,
            (0, $437b23f6a393c3bf$export$4a8eed8acd632fcc)
        ]);
        this.eAutocomplete = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eButtons = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eBuilderFilterButton = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eBuilderFilterButtonIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eBuilderFilterButtonLabel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.expressionParser = null;
        this.isApplyDisabled = true;
        this.builderOpen = false;
    }
    wireBeans(beans) {
        this.advFilterExpSvc = beans.advFilterExpSvc;
        this.advancedFilter = beans.advancedFilter;
        this.filterManager = beans.filterManager;
        this.registry = beans.registry;
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            getTooltipShowDelayOverride: ()=>1e3,
            getLocation: ()=>"advancedFilter"
        }));
        this.eAutocomplete.setListGenerator((_value, position)=>this.generateAutocompleteListParams(position)).setValidator(()=>this.validateValue()).setForceLastSelection((lastSelection, searchString)=>this.forceLastSelection(lastSelection, searchString)).setInputAriaLabel(this.advFilterExpSvc.translate("ariaAdvancedFilterInput")).setListAriaLabel(this.advFilterExpSvc.translate("ariaLabelAdvancedFilterAutocomplete"));
        this.refresh();
        this.addManagedListeners(this.eAutocomplete, {
            eventValueChanged: ({ value: value })=>this.onValueChanged(value),
            eventValueConfirmed: ({ isValid: isValid })=>this.onValueConfirmed(isValid),
            eventOptionSelected: ({ position: position, updateEntry: updateEntry, autocompleteType: autocompleteType })=>this.onOptionSelected(position, updateEntry, autocompleteType),
            eventValidChanged: ({ isValid: isValid, validationMessage: validationMessage })=>this.onValidChanged(isValid, validationMessage)
        });
        const { buttons: buttons, suppressBuilderButton: suppressBuilderButton } = {
            ...$5b7ccabde48fae90$var$DEFAULT_ADVANCED_FILTER_PARAMS,
            ...this.gos.get("advancedFilterParams")
        };
        this.setupButtons(buttons);
        this.setupBuilderButton(suppressBuilderButton);
        this.beans.gos.addManagedPropertyListener("advancedFilterParams", (event)=>{
            const currentValue = {
                ...$5b7ccabde48fae90$var$DEFAULT_ADVANCED_FILTER_PARAMS,
                ...event.currentValue
            };
            const previousValue = {
                ...$5b7ccabde48fae90$var$DEFAULT_ADVANCED_FILTER_PARAMS,
                ...event.previousValue
            };
            if (currentValue.buttons !== previousValue.buttons) {
                const buttons2 = currentValue.buttons.map((type)=>({
                        type: type,
                        label: this.advFilterExpSvc.translate($5b7ccabde48fae90$var$ButtonLocaleMap[type])
                    }));
                this.eButtons.updateButtons(buttons2);
            }
            if (currentValue.suppressBuilderButton !== previousValue.suppressBuilderButton) (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eBuilderFilterButton, !currentValue.suppressBuilderButton);
        });
    }
    refresh() {
        const expression = this.advancedFilter.getExpressionDisplayValue();
        this.eAutocomplete.setValue({
            value: expression ?? "",
            position: expression?.length,
            updateListOnlyIfOpen: true
        });
    }
    setInputDisabled(disabled) {
        this.eAutocomplete.setInputDisabled(disabled);
        this.eButtons.updateValidity(!disabled && !this.isApplyDisabled && !this.advancedFilter.isCurrentExpressionApplied());
    }
    setupButtons(actions) {
        const buttons = actions.map((type)=>({
                type: type,
                label: this.advFilterExpSvc.translate($5b7ccabde48fae90$var$ButtonLocaleMap[type])
            }));
        const getListener = (action)=>()=>{
                this.updateModel(action);
            };
        this.eButtons.addManagedListeners(this.eButtons, {
            apply: getListener("apply"),
            clear: getListener("clear"),
            reset: getListener("reset"),
            cancel: getListener("cancel")
        });
        this.eButtons.updateButtons(buttons);
    }
    updateModel(action) {
        switch(action){
            case "apply":
                this.onValueConfirmed(this.eAutocomplete.isValid());
                break;
            case "reset":
                this.advancedFilter.setModel(null);
                this.filterManager?.onFilterChanged({
                    source: "advancedFilter"
                });
                break;
            case "cancel":
                this.advancedFilter.setModel(this.advancedFilter.getModel());
                this.filterManager?.onFilterChanged({
                    source: "advancedFilter"
                });
                break;
            case "clear":
                this.eAutocomplete.setValue({
                    value: "",
                    restoreFocus: true
                });
                break;
        }
    }
    setupBuilderButton(suppressed) {
        this.eBuilderFilterButtonIcon.appendChild((0, $437b23f6a393c3bf$export$d8feba07bf373edb)("advancedFilterBuilder", this.beans));
        this.eBuilderFilterButtonLabel.textContent = this.advFilterExpSvc.translate("advancedFilterBuilder");
        this.activateTabIndex([
            this.eBuilderFilterButton
        ]);
        this.addManagedElementListeners(this.eBuilderFilterButton, {
            click: ()=>this.openBuilder()
        });
        this.addManagedListeners(this.advancedFilter.getCtrl(), {
            advancedFilterBuilderClosed: ()=>this.closeBuilder()
        });
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eBuilderFilterButton, !suppressed);
    }
    onValueChanged(value) {
        value = (0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(value);
        this.advancedFilter.setExpressionDisplayValue(value);
        this.expressionParser = this.advancedFilter.createExpressionParser(value);
        const updatedExpression = this.expressionParser?.parseExpression();
        if (updatedExpression && updatedExpression !== value) this.eAutocomplete.setValue({
            value: updatedExpression,
            silent: true,
            restoreFocus: true
        });
    }
    onValueConfirmed(isValid) {
        if (!isValid || this.isApplyDisabled) return;
        this.eButtons?.updateValidity(false);
        this.advancedFilter.applyExpression();
        this.filterManager?.onFilterChanged({
            source: "advancedFilter"
        });
    }
    onOptionSelected(position, updateEntry, type) {
        const { updatedValue: updatedValue, updatedPosition: updatedPosition, hideAutocomplete: hideAutocomplete } = this.updateExpression(position, updateEntry, type);
        this.eAutocomplete.setValue({
            value: updatedValue,
            position: updatedPosition,
            updateListOnlyIfOpen: hideAutocomplete,
            restoreFocus: true
        });
    }
    validateValue() {
        return this.expressionParser?.isValid() ? null : this.expressionParser?.getValidationMessage() ?? null;
    }
    onValidChanged(isValid, validationMessage) {
        this.isApplyDisabled = !isValid || this.advancedFilter.isCurrentExpressionApplied();
        this.eButtons.updateValidity(!this.isApplyDisabled);
        this.tooltipFeature?.setTooltipAndRefresh(validationMessage);
    }
    generateAutocompleteListParams(position) {
        return this.expressionParser ? this.expressionParser.getAutocompleteListParams(position) : this.advFilterExpSvc.getDefaultAutocompleteListParams("");
    }
    updateExpression(position, updateEntry, type) {
        this.advFilterExpSvc.updateAutocompleteCache(updateEntry, type);
        return this.expressionParser?.updateExpression(position, updateEntry, type) ?? this.advancedFilter.getDefaultExpression(updateEntry);
    }
    forceLastSelection({ key: key, displayValue: displayValue }, searchString) {
        return !!searchString.toLocaleLowerCase().match(`^${(displayValue ?? key).toLocaleLowerCase()}\\s*$`);
    }
    openBuilder() {
        if (this.builderOpen) return;
        this.builderOpen = true;
        (0, $437b23f6a393c3bf$export$b6b4f08392e9bfaf)(this.eBuilderFilterButton, true);
        this.advancedFilter.getCtrl().toggleFilterBuilder({
            source: "ui",
            eventSource: this.eBuilderFilterButton
        });
    }
    closeBuilder() {
        if (!this.builderOpen) return;
        this.builderOpen = false;
        (0, $437b23f6a393c3bf$export$b6b4f08392e9bfaf)(this.eBuilderFilterButton, false);
        this.eBuilderFilterButton.focus();
    }
};
var $5b7ccabde48fae90$var$AdvancedFilterHeaderElement = {
    tag: "div",
    cls: "ag-advanced-filter-header",
    role: "row"
};
var $5b7ccabde48fae90$var$AdvancedFilterHeaderComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(enabled){
        super($5b7ccabde48fae90$var$AdvancedFilterHeaderElement);
        this.enabled = enabled;
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.focusSvc = beans.focusSvc;
        this.ctrlsSvc = beans.ctrlsSvc;
    }
    postConstruct() {
        this.setupAdvancedFilter(this.enabled);
        this.addDestroyFunc(()=>this.destroyBean(this.eAdvancedFilter));
        const heightListener = ()=>{
            if (this.enabled) this.setEnabledHeight();
        };
        this.addManagedEventListeners({
            gridColumnsChanged: ()=>this.onGridColumnsChanged(),
            columnHeaderHeightChanged: heightListener,
            stylesChanged: heightListener
        });
        this.addManagedPropertyListener("headerHeight", heightListener);
        this.addManagedPropertyListener("floatingFiltersHeight", heightListener);
        this.addGuiEventListener("keydown", (event)=>this.onKeyDown(event));
        this.addGuiEventListener("focusout", (event)=>{
            if (!this.getFocusableElement().contains(event.relatedTarget)) this.focusSvc.clearAdvancedFilterColumn();
        });
    }
    getFocusableElement() {
        return this.eAdvancedFilter?.getGui() ?? this.getGui();
    }
    setEnabled(enabled) {
        if (enabled === this.enabled) return;
        this.setupAdvancedFilter(enabled);
    }
    refresh() {
        this.eAdvancedFilter?.refresh();
    }
    getHeight() {
        return this.height;
    }
    setInputDisabled(disabled) {
        this.eAdvancedFilter?.setInputDisabled(disabled);
    }
    setupAdvancedFilter(enabled) {
        const eGui = this.getGui();
        if (enabled) {
            this.eAdvancedFilter = this.createBean(new $5b7ccabde48fae90$var$AdvancedFilterComp());
            const eAdvancedFilterGui = this.eAdvancedFilter.getGui();
            this.eAdvancedFilter.addCss("ag-advanced-filter-header-cell");
            this.setEnabledHeight();
            this.setAriaRowIndex();
            (0, $437b23f6a393c3bf$export$f8d01fa01787902)(eAdvancedFilterGui, "gridcell");
            (0, $437b23f6a393c3bf$export$84b73ecd0b234e89)(eAdvancedFilterGui, 1);
            this.setAriaColumnCount(eAdvancedFilterGui);
            eGui.appendChild(eAdvancedFilterGui);
        } else {
            (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(eGui);
            this.destroyBean(this.eAdvancedFilter);
            this.height = 0;
        }
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eGui, enabled);
        this.enabled = enabled;
    }
    setEnabledHeight() {
        const eGui = this.getGui();
        this.height = (0, $437b23f6a393c3bf$export$b52d5533bf5be44)(this.beans);
        const height = `${this.height}px`;
        eGui.style.height = height;
        eGui.style.minHeight = height;
    }
    setAriaColumnCount(eAdvancedFilterGui) {
        (0, $437b23f6a393c3bf$export$371d80f0281454ce)(eAdvancedFilterGui, this.colModel.getCols().length);
    }
    setAriaRowIndex() {
        (0, $437b23f6a393c3bf$export$ba731dedf9d88615)(this.getGui(), this.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0);
    }
    onGridColumnsChanged() {
        if (!this.eAdvancedFilter) return;
        this.setAriaColumnCount(this.eAdvancedFilter.getGui());
        this.setAriaRowIndex();
    }
    onKeyDown(event) {
        switch(event.key){
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER:
                if (this.hasFocus()) {
                    if ((0, $437b23f6a393c3bf$export$8598088d375f416f)(this.getFocusableElement())) event.preventDefault();
                }
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ESCAPE:
                if (!this.hasFocus()) this.getFocusableElement().focus();
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP:
                this.navigateUpDown(true, event);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN:
                this.navigateUpDown(false, event);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).TAB:
                if (this.hasFocus()) this.navigateLeftRight(event);
                else {
                    const nextFocusableEl = (0, $437b23f6a393c3bf$export$83fc12531358bd28)(this.beans, this.getFocusableElement(), null, event.shiftKey);
                    if (nextFocusableEl) {
                        event.preventDefault();
                        nextFocusableEl.focus();
                    } else this.navigateLeftRight(event);
                }
                break;
        }
    }
    navigateUpDown(backwards, event) {
        if (this.hasFocus()) {
            if (this.focusSvc.focusNextFromAdvancedFilter(backwards)) event.preventDefault();
        }
    }
    navigateLeftRight(event) {
        if (event.shiftKey ? this.focusSvc.focusLastHeader() : this.focusSvc.focusNextFromAdvancedFilter(false, true)) event.preventDefault();
    }
    hasFocus() {
        return (0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans) === this.getFocusableElement();
    }
};
// packages/ag-grid-enterprise/src/features/virtualListDragFeature.ts
var $5b7ccabde48fae90$var$VirtualListDragFeature = class extends $5b7ccabde48fae90$export$f5b514ca2d1e7160 {
};
// packages/ag-grid-enterprise/src/advancedFilter/builder/advancedFilterBuilderDragFeature.ts
var $5b7ccabde48fae90$var$AdvancedFilterBuilderDragFeature = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(comp, virtualList){
        super();
        this.comp = comp;
        this.virtualList = virtualList;
    }
    postConstruct() {
        this.createManagedBean(new $5b7ccabde48fae90$var$VirtualListDragFeature(this.comp, this.virtualList, {
            dragSourceType: (0, $437b23f6a393c3bf$export$46ba5a92125911d9).AdvancedFilterBuilder,
            addListeners: (parent, listItemDragStart, listItemDragEnd)=>{
                parent.addManagedListeners(this, {
                    advancedFilterBuilderDragStarted: listItemDragStart,
                    advancedFilterBuilderDragEnded: listItemDragEnd
                });
            },
            getCurrentDragValue: (listItemDragStartEvent)=>this.getCurrentDragValue(listItemDragStartEvent),
            isMoveBlocked: ()=>false,
            getNumRows: (comp)=>comp.getNumItems(),
            moveItem: (currentDragValue, lastHoveredListItem)=>this.moveItem(currentDragValue, lastHoveredListItem)
        }));
    }
    getCurrentDragValue(listItemDragStartEvent) {
        return listItemDragStartEvent.item;
    }
    moveItem(currentDragValue, lastHoveredListItem) {
        this.comp.moveItem(currentDragValue, lastHoveredListItem);
    }
};
var $5b7ccabde48fae90$var$AgPillElement = {
    tag: "div",
    cls: "ag-pill",
    role: "option",
    children: [
        {
            tag: "span",
            ref: "eText",
            cls: "ag-pill-text"
        },
        {
            tag: "span",
            ref: "eButton",
            cls: "ag-button ag-pill-button",
            role: "presentation"
        }
    ]
};
var $5b7ccabde48fae90$var$AgPill = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(config){
        super($5b7ccabde48fae90$var$AgPillElement);
        this.config = config;
        this.eText = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eButton = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        const { config: config, eButton: eButton } = this;
        const { onKeyDown: onKeyDown, onButtonClick: onButtonClick } = config;
        this.getGui().setAttribute("tabindex", String(this.gos.get("tabIndex")));
        this.addGuiEventListener("focus", ()=>{
            this.eButton.focus();
        });
        if (onKeyDown) this.addGuiEventListener("keydown", onKeyDown);
        if (onButtonClick) this.addManagedElementListeners(eButton, {
            click: onButtonClick
        });
    }
    toggleCloseButtonClass(className, force) {
        this.eButton.classList.toggle(className, force);
    }
    setText(text) {
        this.eText.textContent = text;
    }
    getText() {
        return this.eText.textContent;
    }
};
// packages/ag-grid-enterprise/src/widgets/AgPillContainer.ts
var $5b7ccabde48fae90$var$AgPillContainerElement = {
    tag: "div",
    cls: "ag-pill-container"
};
var $5b7ccabde48fae90$var$AgPillContainer = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$AgPillContainerElement);
        this.pills = [];
    }
    init(params) {
        this.params = params;
        this.getKey = params.valueFormatter ?? ((v)=>String(v));
        this.refresh();
    }
    refresh() {
        this.clearPills();
        const { params: params, onPillKeyDown: onPillKeyDown, getKey: getKey } = this;
        let values = params.getValue();
        if (!Array.isArray(values)) {
            if (values == null) return;
            values = [
                values
            ];
        }
        const valueFormatter = params.valueFormatter ?? ((v)=>String(v));
        const len = values.length;
        (0, $437b23f6a393c3bf$export$f8d01fa01787902)(this.getGui(), len === 0 ? "presentation" : "listbox");
        for(let i = 0; i < len; i++){
            const value = values[i];
            const pill = this.createBean(new $5b7ccabde48fae90$var$AgPill({
                onButtonClick: ()=>this.onPillButtonClick(pill),
                onKeyDown: onPillKeyDown.bind(this)
            }));
            const pillGui = pill.getGui();
            (0, $437b23f6a393c3bf$export$c3d3aede41065a84)(pillGui, i + 1);
            (0, $437b23f6a393c3bf$export$3d494c2007bbcac1)(pillGui, len);
            if (params.onPillMouseDown) pill.addGuiEventListener("mousedown", params.onPillMouseDown);
            if (params.announceItemFocus) pill.addGuiEventListener("focus", params.announceItemFocus);
            pill.setText(valueFormatter(value) ?? "");
            pill.toggleCloseButtonClass("ag-icon-cancel", true);
            this.appendChild(pillGui);
            this.pills.push({
                key: getKey(value) ?? i.toString(),
                pill: pill
            });
        }
    }
    onNavigationKeyDown(e) {
        const { key: key } = e;
        if (!this.pills.length || key !== (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT && key !== (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT) return;
        e.preventDefault();
        const { params: params, beans: beans } = this;
        const activeEl = (0, $437b23f6a393c3bf$export$16bc98d422315038)(beans);
        const eGui = this.getGui();
        if (eGui.contains(activeEl)) {
            const nextFocusableEl = (0, $437b23f6a393c3bf$export$83fc12531358bd28)(beans, eGui, false, key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT);
            if (nextFocusableEl) nextFocusableEl.focus();
            else if (params.eWrapper) params.eWrapper.focus();
        } else {
            const focusableElements = (0, $437b23f6a393c3bf$export$7acf44f59625b1f6)(eGui);
            if (focusableElements.length > 0) focusableElements[key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT ? 0 : focusableElements.length - 1].focus();
        }
    }
    clearPills() {
        const eGui = this.getGui();
        if (eGui.contains((0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans)) && this.params.eWrapper) this.params.eWrapper.focus();
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(eGui);
        this.destroyBeans(this.pills.map(({ pill: pill })=>pill));
        this.pills = [];
    }
    onPillButtonClick(pill) {
        this.deletePill(pill);
    }
    onPillKeyDown(e) {
        const key = e.key;
        if (key !== (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DELETE && key !== (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).BACKSPACE) return;
        e.preventDefault();
        const eDoc = (0, $437b23f6a393c3bf$export$f63d0991874c6f81)(this.beans);
        const pillIndex = this.pills.findIndex(({ pill: pill })=>pill.getGui().contains(eDoc.activeElement));
        if (pillIndex === -1) return;
        const pillObj = this.pills[pillIndex];
        if (pillObj?.pill) this.deletePill(pillObj.pill, pillIndex);
    }
    deletePill(p, restoreFocusToIndex) {
        const { getKey: getKey, pills: pills, params: params } = this;
        const pillKey = (pills[restoreFocusToIndex ?? -1] ?? pills.find(({ pill: pill })=>pill === p))?.key;
        const values = (params.getValue() || []).filter((val)=>getKey(val) !== pillKey);
        params.setValue(values);
        if (!values.length && params.eWrapper) params.eWrapper.focus();
        else if (restoreFocusToIndex != null) {
            const { pill: pill } = pills[Math.min(restoreFocusToIndex, pills.length - 1)];
            if (pill) pill.getFocusableElement().focus();
        }
    }
    destroy() {
        this.clearPills();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/widgets/agRichSelect.css-GENERATED.ts
var $5b7ccabde48fae90$var$agRichSelectCSS = /*css*/ `.ag-rich-select{cursor:default;height:100%}.ag-rich-select-value{align-items:center;background-color:var(--ag-picker-button-background-color);display:flex;height:100%;padding:var(--ag-spacing);:where(.ag-picker-field-display){overflow:hidden;text-overflow:ellipsis;&:where(.ag-display-as-placeholder){opacity:.5}}}.ag-virtual-list-viewport.ag-rich-select-list{background-color:var(--ag-picker-list-background-color);border:var(--ag-picker-list-border);border-radius:var(--ag-input-border-radius);box-shadow:var(--ag-dropdown-shadow);height:auto;position:relative;width:100%;:where(.ag-rich-select-loading){display:flex;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}}.ag-rich-select-row{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;padding:0 var(--ag-spacing);white-space:nowrap}.ag-rich-select-row-selected{background-color:var(--ag-selected-row-background-color)}.ag-rich-select-row-highlighted,.ag-rich-select-row:hover{background-image:linear-gradient(var(--ag-row-hover-color),var(--ag-row-hover-color))}.ag-rich-select-row-text-highlight{font-weight:700}.ag-rich-select-field-input{flex:1 1 auto;:where(.ag-input-field-input){border:none!important;box-shadow:none!important;padding:0!important;text-overflow:ellipsis;&::-moz-placeholder{opacity:.8}&::placeholder{opacity:.8}}}:where(.ag-ltr) .ag-rich-select-field-input{left:var(--ag-spacing)}:where(.ag-rtl) .ag-rich-select-field-input{right:var(--ag-spacing)}:where(.ag-popup-editor) .ag-rich-select-value{height:var(--ag-row-height);min-width:200px}.ag-rich-select-virtual-list-item{cursor:default;height:var(--ag-list-item-height)}.ag-pill-container{display:flex;flex-wrap:nowrap;gap:.25rem}.ag-pill{align-items:center;background:var(--ag-select-cell-background-color);border:var(--ag-select-cell-border);border-radius:var(--ag-border-radius);display:flex;padding:0 .25rem;white-space:nowrap}.ag-pill-button{border:none;padding:0;&:hover{color:var(--ag-accent-color);cursor:pointer}}:where(.ag-ltr) .ag-pill-button{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-pill-button{margin-right:var(--ag-spacing)}`;
var $5b7ccabde48fae90$var$RichSelectRowElement = {
    tag: "div",
    cls: "ag-rich-select-row",
    role: "presentation"
};
var $5b7ccabde48fae90$var$RichSelectRow = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(params){
        super($5b7ccabde48fae90$var$RichSelectRowElement);
        this.params = params;
    }
    wireBeans(beans) {
        this.userCompFactory = beans.userCompFactory;
        this.registry = beans.registry;
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("highlightTooltipFeature", false, {
            getGui: ()=>this.getGui(),
            shouldDisplayTooltip: ()=>this.shouldDisplayTooltip?.() ?? true
        }, this));
    }
    setState(value) {
        const { params: params } = this;
        const formattedValue = params.valueFormatter?.(value) ?? "";
        const rendererSuccessful = this.populateWithRenderer(value, formattedValue);
        if (!rendererSuccessful) this.populateWithoutRenderer(value, formattedValue);
        this.value = value;
    }
    highlightString(matchString) {
        const { parsedValue: parsedValue, params: params } = this;
        if (params.cellRenderer || !(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(parsedValue)) return;
        let hasMatch = (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(matchString);
        if (hasMatch) {
            const index = parsedValue?.toLocaleLowerCase().indexOf(matchString.toLocaleLowerCase());
            if (index >= 0) {
                const highlightEndIndex = index + matchString.length;
                const child = this.getGui().querySelector("span");
                if (child) {
                    (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(child);
                    child.append(// Start part
                    parsedValue.slice(0, index), // Highlighted part wrapped in bold tag
                    (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
                        tag: "span",
                        cls: "ag-rich-select-row-text-highlight",
                        children: parsedValue.slice(index, highlightEndIndex)
                    }), // End part
                    parsedValue.slice(highlightEndIndex));
                }
            } else hasMatch = false;
        }
        if (!hasMatch) this.renderValueWithoutRenderer(parsedValue);
    }
    updateSelected(selected) {
        const eGui = this.getGui();
        (0, $437b23f6a393c3bf$export$c22e3722e8a33469)(eGui.parentElement, selected);
        this.toggleCss("ag-rich-select-row-selected", selected);
    }
    getValue() {
        return this.value;
    }
    toggleHighlighted(highlighted) {
        this.toggleCss("ag-rich-select-row-highlighted", highlighted);
        this.dispatchLocalEvent({
            type: "itemHighlighted",
            highlighted: highlighted
        });
    }
    populateWithoutRenderer(value, valueFormatted) {
        const eGui = this.getGui();
        const span = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "span"
        });
        span.style.overflow = "hidden";
        span.style.textOverflow = "ellipsis";
        const parsedValue = (0, $437b23f6a393c3bf$export$a16cfb6652fe466f)((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(valueFormatted) ? valueFormatted : value);
        this.parsedValue = (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(parsedValue) ? parsedValue : null;
        eGui.appendChild(span);
        this.renderValueWithoutRenderer(parsedValue);
        this.shouldDisplayTooltip = (0, $437b23f6a393c3bf$export$8980540b0a37a11d)(()=>span);
        this.tooltipFeature?.setTooltipAndRefresh(this.parsedValue);
    }
    renderValueWithoutRenderer(value) {
        const span = this.getGui().querySelector("span");
        if (!span) return;
        span.textContent = (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(value) ? value : "\xA0";
    }
    populateWithRenderer(value, valueFormatted) {
        let cellRendererPromise;
        let userCompDetails;
        const { cellRenderer: cellRenderer, cellRendererParams: cellRendererParams } = this.params;
        if (cellRenderer) {
            const richSelect = this.getParentComponent()?.getParentComponent();
            userCompDetails = (0, $437b23f6a393c3bf$export$85a10ea90cfc8a53)(this.userCompFactory, this.params, (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
                value: value,
                valueFormatted: valueFormatted,
                cellRendererParams: cellRendererParams,
                getValue: ()=>richSelect?.getValue(),
                setValue: (value2)=>{
                    richSelect?.setValue(value2, true);
                },
                setTooltip: (value2, shouldDisplayTooltip)=>{
                    this.gos.assertModuleRegistered("Tooltip", 3);
                    this.shouldDisplayTooltip = shouldDisplayTooltip;
                    this.tooltipFeature?.setTooltipAndRefresh(value2);
                }
            }));
        }
        if (userCompDetails) cellRendererPromise = userCompDetails.newAgStackInstance();
        if (cellRendererPromise) $5b7ccabde48fae90$var$_bindCellRendererToHtmlElement(cellRendererPromise, this.getGui());
        if (cellRendererPromise) {
            cellRendererPromise.then((childComponent)=>{
                this.addDestroyFunc(()=>{
                    this.destroyBean(childComponent);
                });
            });
            return true;
        }
        return false;
    }
};
// packages/ag-grid-enterprise/src/widgets/agRichSelectList.ts
var $5b7ccabde48fae90$var$LIST_COMPONENT_NAME = "ag-rich-select-list";
var $5b7ccabde48fae90$var$ROW_COMPONENT_NAME = "ag-rich-select-row";
var $5b7ccabde48fae90$var$STATE_LOADING = 0;
var $5b7ccabde48fae90$var$STATE_READY_WITH_RESULTS = 1;
var $5b7ccabde48fae90$var$STATE_NO_RESULTS = 2;
var $5b7ccabde48fae90$var$STATE_READY_FOR_INPUT = 3;
var $5b7ccabde48fae90$var$AgRichSelectList = class extends $5b7ccabde48fae90$var$VirtualList {
    constructor(params, richSelectWrapper, getSearchString2){
        super({
            cssIdentifier: "rich-select"
        });
        this.params = params;
        this.richSelectWrapper = richSelectWrapper;
        this.getSearchString = getSearchString2;
        this.lastRowHovered = -1;
        this.selectedItems = /* @__PURE__ */ new Set();
        this.loadingState = $5b7ccabde48fae90$var$STATE_READY_FOR_INPUT;
        this.params = params;
        this.setComponentCreator(this.createRowComponent.bind(this));
        this.setComponentUpdater(()=>{});
    }
    postConstruct() {
        super.postConstruct();
        const i18n = this.getLocaleTextFunc();
        this.loadingLabel = i18n("loadingOoo", "Loading...");
        this.noMatchesLabel = i18n("noMatches", "No matches to show");
        this.eLoadingIcon = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("richSelectLoading", this.beans, null);
        this.eStateCompLabel = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "span",
            cls: "ag-loading-text",
            children: this.loadingLabel
        });
        this.eStateComp = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div",
            cls: "ag-rich-select-loading",
            children: [
                {
                    tag: "span",
                    cls: "ag-loading-icon",
                    children: [
                        this.eLoadingIcon ? ()=>this.eLoadingIcon : void 0
                    ]
                },
                {
                    tag: "span",
                    cls: "ag-loading-text",
                    children: [
                        ()=>this.eStateCompLabel
                    ]
                }
            ]
        });
        this.appendChild(this.eStateComp);
        const { cellRowHeight: cellRowHeight, pickerAriaLabelKey: pickerAriaLabelKey, pickerAriaLabelValue: pickerAriaLabelValue } = this.params;
        if (cellRowHeight) this.setRowHeight(cellRowHeight);
        const eGui = this.getGui();
        const eListAriaEl = this.getAriaElement();
        this.addManagedListeners(eGui, {
            mousemove: this.onMouseMove.bind(this),
            mouseout: this.onMouseOut.bind(this),
            mousedown: this.onMouseDown.bind(this),
            click: this.onClick.bind(this)
        });
        eGui.classList.add($5b7ccabde48fae90$var$LIST_COMPONENT_NAME);
        const listId = `${$5b7ccabde48fae90$var$LIST_COMPONENT_NAME}-${this.getCompId()}`;
        eListAriaEl.setAttribute("id", listId);
        const translate = this.getLocaleTextFunc();
        const ariaLabel = translate(pickerAriaLabelKey, pickerAriaLabelValue);
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(eListAriaEl, ariaLabel);
        (0, $437b23f6a393c3bf$export$6ff31a4a210c60ad)(this.richSelectWrapper, eListAriaEl);
    }
    setIsLoading() {
        this.setLoadingState($5b7ccabde48fae90$var$STATE_LOADING);
    }
    setLoadingState(state) {
        this.loadingState = state;
        this.toggleStateComp();
        this.toggleVisibility();
    }
    toggleStateComp() {
        const { eStateComp: eStateComp, eStateCompLabel: eStateCompLabel, eLoadingIcon: eLoadingIcon, loadingState: loadingState, loadingLabel: loadingLabel, noMatchesLabel: noMatchesLabel, params: params } = this;
        if (!eStateComp) return;
        if (loadingState === $5b7ccabde48fae90$var$STATE_LOADING) {
            eStateCompLabel.textContent = loadingLabel;
            if (eLoadingIcon) (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eLoadingIcon, true);
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eStateComp, true);
            return;
        }
        if (loadingState === $5b7ccabde48fae90$var$STATE_NO_RESULTS && params.allowNoResultsCopy) {
            eStateCompLabel.textContent = noMatchesLabel;
            if (eLoadingIcon) (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eLoadingIcon, false);
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eStateComp, true);
            return;
        }
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eStateComp, false);
    }
    shouldBeVisible() {
        if (this.loadingState === $5b7ccabde48fae90$var$STATE_NO_RESULTS) return !!this.params.allowNoResultsCopy;
        return this.loadingState !== $5b7ccabde48fae90$var$STATE_READY_FOR_INPUT;
    }
    toggleVisibility(forceVisible) {
        const eListGui = this.getGui();
        if (forceVisible === void 0) (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eListGui, this.shouldBeVisible());
        else (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eListGui, forceVisible);
    }
    navigateToPage(key) {
        const newIndex = super.navigateToPage(key, this.lastRowHovered);
        if (newIndex != null) (0, $437b23f6a393c3bf$export$7b1f5bd01973c897)(this.beans, ()=>{
            if (!this.isAlive()) return null;
            this.highlightIndex(newIndex);
        });
        return newIndex;
    }
    drawVirtualRows(softRefresh) {
        super.drawVirtualRows(softRefresh);
        this.refreshSelectedItems();
    }
    highlightFilterMatch(searchString) {
        this.forEachRenderedRow((cmp)=>{
            cmp.highlightString(searchString);
        });
    }
    onNavigationKeyDown(key, announceItem) {
        (0, $437b23f6a393c3bf$export$7b1f5bd01973c897)(this.beans, ()=>{
            if (!this.currentList || !this.isAlive()) return;
            const len = this.currentList.length;
            const oldIndex = this.lastRowHovered;
            const diff = key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN ? 1 : -1;
            const newIndex = Math.min(Math.max(oldIndex === -1 ? 0 : oldIndex + diff, 0), len - 1);
            this.highlightIndex(newIndex);
            announceItem();
        });
    }
    selectValue(value) {
        if (!this.currentList || value == null) return false;
        const selectedPositions = this.getIndicesForValues(value);
        const refresh = selectedPositions.length > 0;
        if (refresh) {
            this.refresh();
            this.ensureIndexVisible(selectedPositions[0]);
            this.refresh(true);
        }
        this.selectListItems(Array.isArray(value) ? value : [
            value
        ]);
        return refresh;
    }
    selectListItems(values, append = false) {
        if (!append) this.selectedItems.clear();
        for(let i = 0; i < values.length; i++){
            const currentItem = values[i];
            if (this.findItemInSelected(currentItem) !== void 0) continue;
            this.selectedItems.add(currentItem);
        }
        this.refreshSelectedItems();
    }
    getCurrentList() {
        return this.currentList;
    }
    setCurrentList(list) {
        const newState = $5b7ccabde48fae90$var$getListStateBasedOnResults(list);
        this.setLoadingState(newState);
        list || (list = []);
        this.currentList = list;
        this.setModel({
            getRowCount: ()=>list.length,
            getRow: (index)=>list[index],
            areRowsEqual: (oldRow, newRow)=>oldRow === newRow
        });
    }
    getSelectedItems() {
        return this.selectedItems;
    }
    getLastItemHovered() {
        return this.currentList?.[this.lastRowHovered];
    }
    highlightIndex(index, preventUnnecessaryScroll) {
        if (!this.currentList) return;
        if (index < 0 || index >= this.currentList.length) this.lastRowHovered = -1;
        else {
            this.lastRowHovered = index;
            const wasScrolled = this.ensureIndexVisible(index, !preventUnnecessaryScroll);
            if (wasScrolled && !preventUnnecessaryScroll) this.refresh(true);
        }
        this.forEachRenderedRow((cmp, idx)=>{
            const highlighted = index === idx;
            cmp.toggleHighlighted(highlighted);
            if (highlighted) {
                const idForParent = `${$5b7ccabde48fae90$var$ROW_COMPONENT_NAME}-${cmp.getCompId()}`;
                (0, $437b23f6a393c3bf$export$5db804730c3c8346)(this.richSelectWrapper, idForParent);
                this.richSelectWrapper.setAttribute("data-active-option", idForParent);
            }
        });
    }
    getIndicesForValues(values) {
        const { currentList: currentList } = this;
        if (!currentList || currentList.length === 0 || values == null) return [];
        if (!Array.isArray(values)) values = [
            values
        ];
        if (values.length === 0) return [];
        const { valueFormatter: valueFormatter } = this.params;
        const positions = [];
        const isObject = typeof values[0] === "object";
        const formattedList = currentList.map(valueFormatter);
        for (const value of values){
            let idx = -1;
            if (isObject) idx = formattedList.indexOf(valueFormatter(value));
            else idx = currentList.indexOf(value);
            if (idx >= 0) positions.push(idx);
        }
        return positions;
    }
    toggleListItemSelection(value) {
        const item = this.findItemInSelected(value);
        if (item !== void 0) this.selectedItems.delete(item);
        else this.selectedItems.add(value);
        this.refreshSelectedItems();
        this.dispatchValueSelected();
    }
    refreshSelectedItems() {
        this.forEachRenderedRow((cmp)=>{
            const selected = this.findItemInSelected(cmp.getValue()) !== void 0;
            cmp.updateSelected(selected);
        });
    }
    findItemInSelected(value) {
        if (typeof value === "object") {
            const valueFormatter = this.params.valueFormatter;
            const valueFormatted = valueFormatter(value);
            for (const item of this.selectedItems){
                if (valueFormatter(item) === valueFormatted) return item;
            }
        } else return this.selectedItems.has(value) ? value : void 0;
    }
    createRowComponent(value, listItemElement) {
        const row = new $5b7ccabde48fae90$var$RichSelectRow(this.params);
        listItemElement.setAttribute("id", `${$5b7ccabde48fae90$var$ROW_COMPONENT_NAME}-${row.getCompId()}`);
        row.setParentComponent(this);
        this.createBean(row);
        row.setState(value);
        const { highlightMatch: highlightMatch, searchType: searchType = "fuzzy" } = this.params;
        if (highlightMatch && searchType !== "fuzzy") row.highlightString(this.getSearchString());
        return row;
    }
    getRowForMouseEvent(e) {
        if (!this.model) return -1;
        const eGui = this.getGui();
        const rect = eGui.getBoundingClientRect();
        const scrollTop = this.getScrollTop();
        const mouseY = e.clientY - rect.top + scrollTop;
        return Math.min(Math.floor(mouseY / this.getRowHeight()), this.model.getRowCount() - 1);
    }
    onMouseMove(e) {
        const row = this.getRowForMouseEvent(e);
        if (row !== -1 && row != this.lastRowHovered) {
            this.lastRowHovered = row;
            this.highlightIndex(row, true);
        }
    }
    onMouseDown(e) {
        e.preventDefault();
    }
    onMouseOut(e) {
        if (!this.getGui().contains(e.relatedTarget)) this.highlightIndex(-1);
    }
    onClick(e) {
        const { multiSelect: multiSelect } = this.params;
        if (!this.currentList?.length) return;
        const row = this.getRowForMouseEvent(e);
        const item = this.currentList[row];
        if (multiSelect) this.toggleListItemSelection(item);
        else {
            this.selectListItems([
                item
            ]);
            this.dispatchValueSelected();
        }
    }
    dispatchValueSelected() {
        this.dispatchLocalEvent({
            type: "richSelectListRowSelected",
            fromEnterKey: false,
            value: this.selectedItems
        });
    }
    destroy() {
        super.destroy();
        this.eStateComp = void 0;
    }
};
function $5b7ccabde48fae90$var$getListStateBasedOnResults(valueList) {
    if (!valueList) return $5b7ccabde48fae90$var$STATE_READY_FOR_INPUT;
    if (valueList.length) return $5b7ccabde48fae90$var$STATE_READY_WITH_RESULTS;
    return $5b7ccabde48fae90$var$STATE_NO_RESULTS;
}
// packages/ag-grid-enterprise/src/widgets/agRichSelect.ts
var $5b7ccabde48fae90$var$ON_SEARCH_CALLBACK_DEBOUNCE_DELAY = 300;
var $5b7ccabde48fae90$var$AgRichSelectElement = {
    tag: "div",
    cls: "ag-picker-field",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eLabel"
        },
        {
            tag: "div",
            ref: "eWrapper",
            cls: "ag-wrapper ag-picker-field-wrapper ag-rich-select-value ag-picker-collapsed",
            children: [
                {
                    tag: "span",
                    ref: "eDisplayField",
                    cls: "ag-picker-field-display"
                },
                {
                    tag: "ag-input-text-field",
                    ref: "eInput",
                    cls: "ag-rich-select-field-input"
                },
                {
                    tag: "span",
                    ref: "eDeselect",
                    cls: "ag-rich-select-deselect-button ag-picker-field-icon",
                    role: "presentation"
                },
                {
                    tag: "span",
                    ref: "eIcon",
                    cls: "ag-picker-field-icon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$AgRichSelect = class extends (0, $437b23f6a393c3bf$export$1f14489b6fdeb99b) {
    constructor(config){
        super({
            pickerAriaLabelKey: "ariaLabelRichSelectField",
            pickerAriaLabelValue: "Rich Select Field",
            pickerType: "ag-list",
            className: "ag-rich-select",
            pickerIcon: "richSelectOpen",
            ariaRole: "combobox",
            template: config?.template ?? $5b7ccabde48fae90$var$AgRichSelectElement,
            agComponents: [
                (0, $437b23f6a393c3bf$export$31e2985be4ee06ab)
            ],
            modalPicker: false,
            ...config,
            // maxPickerHeight needs to be set after expanding `config`
            maxPickerHeight: config?.maxPickerHeight ?? "calc(var(--ag-row-height) * 6.5)"
        });
        this.searchString = "";
        this.searchStringCreator = null;
        this.eInput = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eDeselect = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.skipWrapperAnnouncement = false;
        const { value: value, valueList: valueList, searchStringCreator: searchStringCreator, onSearch: onSearch } = config || {};
        if (value !== void 0) this.value = value;
        if (searchStringCreator) this.searchStringCreator = searchStringCreator;
        if (valueList != null) this.setValueList({
            valueList: valueList,
            isInitial: true
        });
        const { searchDebounceDelay: searchDebounceDelay = $5b7ccabde48fae90$var$ON_SEARCH_CALLBACK_DEBOUNCE_DELAY } = this.config;
        if (onSearch) this.onSearchCallbackDebounced = (0, $437b23f6a393c3bf$export$cf7e39bfb94de6e)(this, onSearch, searchDebounceDelay);
        this.registerCSS($5b7ccabde48fae90$var$agRichSelectCSS);
    }
    wireBeans(beans) {
        this.userCompFactory = beans.userCompFactory;
        this.ariaAnnounce = beans.ariaAnnounce;
        this.registry = beans.registry;
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            shouldDisplayTooltip: ()=>this.shouldDisplayTooltip?.() ?? true
        }));
        super.postConstruct();
        this.createListComponent();
        this.eDeselect.appendChild((0, $437b23f6a393c3bf$export$d8feba07bf373edb)("richSelectRemove", this.beans));
        const { allowTyping: allowTyping, placeholder: placeholder, suppressDeselectAll: suppressDeselectAll } = this.config;
        this.eDeselect.classList.add("ag-hidden");
        if (allowTyping) {
            this.eInput.setAutoComplete(false).setInputPlaceholder(placeholder);
            this.eDisplayField.classList.add("ag-hidden");
        } else this.eInput.setDisplayed(false);
        this.setupAriaProperties();
        const { searchDebounceDelay: searchDebounceDelay = 300 } = this.config;
        this.clearSearchString = (0, $437b23f6a393c3bf$export$cf7e39bfb94de6e)(this, this.clearSearchString.bind(this), searchDebounceDelay);
        this.renderSelectedValue();
        if (allowTyping) this.eInput.onValueChange((value)=>this.searchTextFromString(value));
        this.addManagedElementListeners(this.eWrapper, {
            focus: this.onWrapperFocus.bind(this)
        });
        this.addManagedElementListeners(this.eWrapper, {
            focusout: this.onWrapperFocusOut.bind(this)
        });
        if (!suppressDeselectAll) this.addManagedElementListeners(this.eDeselect, {
            mousedown: this.onDeselectAllMouseDown.bind(this),
            click: this.onDeselectAllClick.bind(this)
        });
    }
    setupAriaProperties() {
        const { eWrapper: eWrapper, gos: gos } = this;
        eWrapper.tabIndex = gos.get("tabIndex");
        const translate = this.getLocaleTextFunc();
        this.ariaDeleteSelection = translate("ariaLabelRichSelectDeleteSelection", "Press DELETE to deselect item");
        this.ariaDeselectAllItems = translate("ariaLabelRichSelectDeselectAllItems", "Press DELETE to deselect all items");
        this.ariaToggleSelection = translate("ariaLabelRichSelectToggleSelection", "Press SPACE to toggle selection");
    }
    createListComponent() {
        this.listComponent = this.createBean(new $5b7ccabde48fae90$var$AgRichSelectList(this.config, this.getFocusableElement(), ()=>this.searchString));
        this.listComponent.setParentComponent(this);
        this.addManagedListeners(this.listComponent, {
            richSelectListRowSelected: (e)=>{
                this.onListValueSelected(e.value, e.fromEnterKey);
            }
        });
    }
    renderSelectedValue(fromPicker) {
        const { value: value, eDisplayField: eDisplayField, config: config, gos: gos } = this;
        const { allowTyping: allowTyping, cellRenderer: cellRenderer, cellRendererParams: cellRendererParams, initialInputValue: initialInputValue, multiSelect: multiSelect, suppressDeselectAll: suppressDeselectAll, suppressMultiSelectPillRenderer: suppressMultiSelectPillRenderer, valueFormatter: valueFormatter, onSearch: onSearch } = config;
        const valueFormatted = $5b7ccabde48fae90$var$formatValueFn(value, valueFormatter);
        if (allowTyping) {
            this.eInput.setValue(initialInputValue ?? valueFormatted, !!fromPicker && !!onSearch);
            return;
        }
        if (multiSelect && !suppressDeselectAll) {
            const isEmpty = value == null || Array.isArray(value) && value.length === 0;
            this.eDeselect.classList.toggle("ag-hidden", isEmpty);
        }
        let userCompDetails;
        if (multiSelect && !suppressMultiSelectPillRenderer) {
            this.createOrUpdatePillContainer(eDisplayField);
            return;
        }
        if (cellRenderer) userCompDetails = (0, $437b23f6a393c3bf$export$85a10ea90cfc8a53)(this.userCompFactory, config, (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
            value: value,
            valueFormatted: valueFormatted,
            cellRendererParams: cellRendererParams,
            getValue: ()=>this.getValue(),
            setValue: (value2)=>{
                this.setValue(value2, true);
            },
            setTooltip: (value2, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.shouldDisplayTooltip = shouldDisplayTooltip;
                this.tooltipFeature?.setTooltipAndRefresh(value2);
            }
        }));
        let userCompDetailsPromise;
        if (userCompDetails) userCompDetailsPromise = userCompDetails.newAgStackInstance();
        if (userCompDetailsPromise) {
            (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(eDisplayField);
            $5b7ccabde48fae90$var$_bindCellRendererToHtmlElement(userCompDetailsPromise, eDisplayField);
            userCompDetailsPromise.then((renderer)=>{
                this.addDestroyFunc(()=>this.destroyBean(renderer));
            });
        } else {
            if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(this.value)) {
                eDisplayField.innerText = valueFormatted;
                eDisplayField.classList.remove("ag-display-as-placeholder");
            } else {
                const { placeholder: placeholder } = config;
                if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(placeholder)) {
                    eDisplayField.textContent = placeholder;
                    eDisplayField.classList.add("ag-display-as-placeholder");
                } else (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(eDisplayField);
            }
            this.shouldDisplayTooltip = (0, $437b23f6a393c3bf$export$8980540b0a37a11d)(()=>this.eDisplayField);
            this.tooltipFeature?.setTooltipAndRefresh(valueFormatted ?? null);
        }
    }
    createPickerComponent() {
        const { values: values } = this;
        if (values) this.setValueList({
            valueList: values
        });
        return this.listComponent;
    }
    setSearchStringCreator(searchStringFn) {
        this.searchStringCreator = searchStringFn;
    }
    setValueListInternal(params) {
        const { listComponent: listComponent, isPickerDisplayed: isPickerDisplayed, value: value } = this;
        const { valueList: valueList, refresh: refresh, isInitial: isInitial } = params;
        if (isInitial) this.setValues(valueList);
        if (!listComponent) return;
        this.listComponent?.setCurrentList(valueList);
        if (!refresh) return;
        if (this.values) listComponent.refresh(true);
        else if (isPickerDisplayed) {
            const hasRefreshed = listComponent.selectValue(value);
            if (!hasRefreshed) listComponent.refresh();
        }
        this.alignPickerToComponent();
    }
    setValueList(params) {
        const { valueList: valueList } = params;
        if (!valueList || Array.isArray(valueList)) {
            this.setValueListInternal(params);
            return;
        }
        this.listComponent?.setIsLoading();
        valueList.then((values)=>{
            if (values) this.setValueListInternal({
                ...params,
                valueList: values
            });
        });
    }
    /**
   * This method updates the list of select options
   */ setValues(values) {
        this.values = values;
        this.searchStrings = this.getSearchStringsFromValues(values || []);
    }
    showPicker() {
        const { listComponent: listComponent, value: value } = this;
        if (!listComponent) return;
        super.showPicker();
        let valueToUse = value;
        if (value === void 0) valueToUse = null;
        listComponent.selectValue(valueToUse);
        const idx = listComponent.getIndicesForValues(Array.isArray(valueToUse) ? valueToUse : [
            valueToUse
        ])[0];
        if (idx != null) {
            this.tooltipFeature?.attemptToHideTooltip();
            listComponent.highlightIndex(idx);
        } else listComponent.refresh();
    }
    createOrUpdatePillContainer(container) {
        if (!this.pillContainer) {
            const pillContainer = this.pillContainer = this.createBean(new $5b7ccabde48fae90$var$AgPillContainer());
            this.addDestroyFunc(()=>{
                this.destroyBean(this.pillContainer);
                this.pillContainer = null;
            });
            (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(container);
            container.appendChild(pillContainer.getGui());
            const { config: config, eWrapper: eWrapper, ariaDeleteSelection: ariaDeleteSelection } = this;
            const { valueFormatter: valueFormatter } = config;
            pillContainer.init({
                eWrapper: eWrapper,
                valueFormatter: valueFormatter,
                onPillMouseDown: (e)=>{
                    e.stopImmediatePropagation();
                },
                announceItemFocus: ()=>{
                    this.announceAriaValue(ariaDeleteSelection);
                },
                getValue: ()=>this.getValue(),
                setValue: (value)=>this.setValue(value, true)
            });
        }
        this.doWhileBlockingAnnouncement(()=>this.pillContainer?.refresh());
    }
    doWhileBlockingAnnouncement(func) {
        this.skipWrapperAnnouncement = true;
        func();
        this.skipWrapperAnnouncement = false;
    }
    onWrapperFocus() {
        const { eInput: eInput, config: config } = this;
        const { allowTyping: allowTyping, multiSelect: multiSelect, suppressDeselectAll: suppressDeselectAll } = config;
        if (allowTyping) {
            const focusableEl = eInput.getFocusableElement();
            focusableEl.focus();
            focusableEl.select();
        } else if (multiSelect && !suppressDeselectAll && !this.skipWrapperAnnouncement) this.announceAriaValue(this.ariaDeselectAllItems);
    }
    onWrapperFocusOut(e) {
        if (!this.eWrapper.contains(e.relatedTarget)) this.hidePicker();
    }
    onDeselectAllMouseDown(e) {
        e.stopImmediatePropagation();
    }
    onDeselectAllClick() {
        this.setValue([], true);
    }
    buildSearchStringFromKeyboardEvent(searchKey) {
        let { key: key } = searchKey;
        if (key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).BACKSPACE) {
            this.searchString = this.searchString.slice(0, -1);
            key = "";
        } else if (!(0, $437b23f6a393c3bf$export$33ecd6e270298858)(searchKey)) return;
        searchKey.preventDefault();
        this.searchTextFromCharacter(key);
    }
    searchTextFromCharacter(char) {
        this.searchString += char;
        this.runSearch();
        this.clearSearchString();
    }
    searchTextFromString(str) {
        if (str == null) str = "";
        this.searchString = str;
        this.runSearch();
    }
    getSearchStringsFromValues(values) {
        const { config: { valueFormatter: valueFormatter } } = this;
        if (typeof values[0] === "object" && this.searchStringCreator) return this.searchStringCreator(values);
        return values.map((value)=>$5b7ccabde48fae90$var$formatValueFn(value, valueFormatter));
    }
    filterListModel(filteredValues) {
        const { filterList: filterList } = this.config;
        if (!filterList) return;
        this.setValueList({
            valueList: filteredValues,
            refresh: true
        });
    }
    runSearch() {
        if (!this.listComponent) return;
        if (this.onSearchCallbackDebounced) {
            this.onSearchCallbackDebounced(this.searchString);
            return;
        }
        const searchStrings = this.searchStrings;
        if (!searchStrings) {
            this.listComponent.highlightIndex(-1);
            return;
        }
        const { suggestions: suggestions, filteredValues: filteredValues } = this.getSuggestionsAndFilteredValues(this.searchString, searchStrings);
        const { filterList: filterList, highlightMatch: highlightMatch, searchType: searchType = "fuzzy" } = this.config;
        const shouldFilter = !!(filterList && this.searchString !== "");
        this.filterListModel(shouldFilter ? filteredValues : this.values || []);
        if (!this.highlightEmptyValue()) this.highlightListValue(suggestions, filteredValues, shouldFilter);
        if (highlightMatch && searchType !== "fuzzy") this.listComponent?.highlightFilterMatch(this.searchString);
        this.listComponent?.toggleVisibility();
    }
    highlightEmptyValue() {
        if (this.searchString === "") {
            const emptyIdx = this.searchStrings?.indexOf("");
            if (emptyIdx !== void 0 && emptyIdx !== -1) {
                this.listComponent?.highlightIndex(emptyIdx);
                return true;
            }
        }
        return false;
    }
    highlightListValue(suggestions, filteredValues, shouldFilter) {
        if (suggestions.length) {
            const topSuggestionIndex = shouldFilter ? 0 : this.searchStrings?.indexOf(suggestions[0]);
            if (topSuggestionIndex !== void 0) this.listComponent?.highlightIndex(topSuggestionIndex);
        } else {
            this.listComponent?.highlightIndex(-1);
            if (!shouldFilter || filteredValues.length) this.listComponent?.ensureIndexVisible(0);
            else if (shouldFilter) {
                this.getAriaElement().removeAttribute("data-active-option");
                const eListAriaEl = this.listComponent?.getAriaElement();
                if (eListAriaEl) (0, $437b23f6a393c3bf$export$5db804730c3c8346)(eListAriaEl, null);
            }
        }
    }
    getSuggestionsAndFilteredValues(searchValue, valueList) {
        let suggestions = [];
        const filteredValues = [];
        if (!searchValue.length) return {
            suggestions: suggestions,
            filteredValues: filteredValues
        };
        const { searchType: searchType = "fuzzy", filterList: filterList } = this.config;
        const values = this.values || [];
        if (searchType === "fuzzy") {
            const fuzzySearchResult = (0, $437b23f6a393c3bf$export$85cab1b5a4aa292c)({
                inputValue: searchValue,
                allSuggestions: valueList,
                hideIrrelevant: true
            });
            suggestions = fuzzySearchResult.values;
            const indices = fuzzySearchResult.indices;
            if (filterList && indices.length) for(let i = 0; i < indices.length; i++)filteredValues.push(values[indices[i]]);
        } else suggestions = valueList.filter((val, idx)=>{
            const currentValue = val.toLocaleLowerCase();
            const valueToMatch = this.searchString.toLocaleLowerCase();
            const isMatch = searchType === "match" ? currentValue.startsWith(valueToMatch) : currentValue.includes(valueToMatch);
            if (filterList && isMatch) filteredValues.push(values[idx]);
            return isMatch;
        });
        return {
            suggestions: suggestions,
            filteredValues: filteredValues
        };
    }
    clearSearchString() {
        this.searchString = "";
    }
    setValue(value, silent, fromPicker, skipRendering) {
        if (this.value === value) return this;
        const isArray = Array.isArray(value);
        if (value != null) {
            if (!isArray) {
                const list = this.listComponent?.getCurrentList();
                const index = list ? list.indexOf(value) : -1;
                if (index === -1) return this;
            }
            if (!fromPicker) this.listComponent?.selectValue(value);
        }
        super.setValue(value, silent);
        if (!skipRendering) this.renderSelectedValue(fromPicker);
        return this;
    }
    onNavigationKeyDown(event, key, announceItem) {
        event.preventDefault();
        const isDown = key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN;
        if (!this.isPickerDisplayed && isDown) {
            this.showPicker();
            return;
        }
        this.listComponent?.onNavigationKeyDown(key, announceItem);
    }
    onEnterKeyDown(e) {
        if (!this.isPickerDisplayed) return;
        e.preventDefault();
        if (this.listComponent?.getCurrentList()) {
            const lastRowHovered = this.listComponent.getLastItemHovered();
            if (this.config.multiSelect || lastRowHovered === void 0) this.dispatchPickerEventAndHidePicker(this.value, true);
            else this.onListValueSelected(/* @__PURE__ */ new Set([
                lastRowHovered
            ]), true);
        }
    }
    onDeleteKeyDown(e) {
        const { eWrapper: eWrapper, beans: beans } = this;
        const activeEl = (0, $437b23f6a393c3bf$export$16bc98d422315038)(beans);
        if (activeEl === eWrapper) {
            e.preventDefault();
            this.setValue([], true);
        }
    }
    onTabKeyDown() {
        const { config: config, isPickerDisplayed: isPickerDisplayed, listComponent: listComponent } = this;
        const { multiSelect: multiSelect } = config;
        if (!isPickerDisplayed || !listComponent) return;
        if (multiSelect) {
            const values = this.getValueFromSet(listComponent.getSelectedItems());
            if (values) this.setValue(values, false, true, true);
        } else {
            const lastItemHovered = listComponent.getLastItemHovered();
            if (lastItemHovered !== void 0) this.setValue(lastItemHovered, false, true);
        }
        this.hidePicker();
    }
    getValueFromSet(valueSet) {
        const { multiSelect: multiSelect } = this.config;
        let newValue = null;
        for (const value of valueSet){
            if (valueSet.size === 1 && !multiSelect) {
                newValue = value;
                break;
            }
            if (!newValue) newValue = [];
            newValue.push(value);
        }
        if (Array.isArray(newValue)) newValue.sort();
        return newValue;
    }
    onListValueSelected(valueSet, fromEnterKey) {
        const newValue = this.getValueFromSet(valueSet);
        this.setValue(newValue, false, true);
        if (!this.config.multiSelect) this.dispatchPickerEventAndHidePicker(newValue, fromEnterKey);
    }
    dispatchPickerEventAndHidePicker(value, fromEnterKey) {
        const event = {
            type: "fieldPickerValueSelected",
            fromEnterKey: fromEnterKey,
            value: value
        };
        this.dispatchLocalEvent(event);
        this.hidePicker();
    }
    getFocusableElement() {
        const { allowTyping: allowTyping } = this.config;
        if (allowTyping) return this.eInput.getFocusableElement();
        return super.getFocusableElement();
    }
    onKeyDown(e) {
        const { key: key, isComposing: isComposing } = e;
        const { isPickerDisplayed: isPickerDisplayed, config: { allowTyping: allowTyping, multiSelect: multiSelect, suppressDeselectAll: suppressDeselectAll }, listComponent: listComponent, pickerComponent: pickerComponent } = this;
        switch(key){
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT:
                if (!allowTyping || this.pillContainer) {
                    e.preventDefault();
                    if (this.pillContainer) {
                        this.listComponent?.highlightIndex(-1);
                        this.pillContainer.onNavigationKeyDown(e);
                    }
                }
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_HOME:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_END:
                if (allowTyping) {
                    e.preventDefault();
                    const inputEl = this.eInput.getInputElement();
                    const target = key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_HOME ? 0 : inputEl.value.length;
                    inputEl.setSelectionRange(target, target);
                    break;
                }
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_UP:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).PAGE_DOWN:
                e.preventDefault();
                if (pickerComponent) listComponent?.navigateToPage(key);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP:
                if (!isComposing) this.onNavigationKeyDown(e, key, ()=>{
                    if (multiSelect) {
                        this.doWhileBlockingAnnouncement(()=>this.eWrapper.focus());
                        this.announceAriaValue(this.ariaToggleSelection);
                    }
                });
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ESCAPE:
                if (isPickerDisplayed) {
                    if ((0, $437b23f6a393c3bf$export$2badf4aa566524cb)(this.listComponent.getGui())) {
                        e.preventDefault();
                        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(e);
                    }
                    this.hidePicker();
                }
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER:
                if (isComposing) e.preventDefault();
                else this.onEnterKeyDown(e);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE:
                if (!allowTyping || isComposing) e.preventDefault();
                if (!isComposing && isPickerDisplayed && multiSelect && listComponent) {
                    const lastItemHovered = listComponent.getLastItemHovered();
                    if (lastItemHovered !== void 0) listComponent.toggleListItemSelection(lastItemHovered);
                }
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).TAB:
                this.onTabKeyDown();
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DELETE:
                if (multiSelect && !suppressDeselectAll) this.onDeleteKeyDown(e);
                break;
            default:
                if (!allowTyping) this.buildSearchStringFromKeyboardEvent(e);
        }
    }
    announceAriaValue(value) {
        this.ariaAnnounce?.announceValue(value, "richSelect");
    }
    destroy() {
        if (this.listComponent) this.listComponent = this.destroyBean(this.listComponent);
        this.searchStrings = void 0;
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$formatValueFn = (value, valueFormatter)=>valueFormatter?.(value) ?? String(value ?? "");
function $5b7ccabde48fae90$var$_bindCellRendererToHtmlElement(cellRendererPromise, eTarget) {
    cellRendererPromise.then((cellRenderer)=>{
        const gui = cellRenderer.getGui();
        if (gui != null) eTarget.appendChild(gui);
    });
}
// packages/ag-grid-enterprise/src/advancedFilter/builder/addDropdownComp.ts
var $5b7ccabde48fae90$var$AddDropdownCompElement = {
    tag: "div",
    cls: "ag-picker-field",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eLabel"
        },
        {
            tag: "div",
            ref: "eWrapper",
            cls: "ag-wrapper ag-picker-collapsed",
            children: [
                {
                    tag: "div",
                    ref: "eDisplayField",
                    cls: "ag-picker-field-display"
                },
                {
                    tag: "ag-input-text-field",
                    ref: "eInput",
                    cls: "ag-rich-select-field-input"
                },
                {
                    tag: "span",
                    ref: "eDeselect",
                    cls: "ag-rich-select-deselect-button ag-picker-field-icon",
                    role: "presentation"
                },
                {
                    tag: "div",
                    ref: "eIcon",
                    cls: "ag-picker-field-icon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$AddDropdownComp = class extends $5b7ccabde48fae90$var$AgRichSelect {
    constructor(params){
        super({
            ...params,
            template: $5b7ccabde48fae90$var$AddDropdownCompElement,
            agComponents: [
                (0, $437b23f6a393c3bf$export$31e2985be4ee06ab)
            ]
        });
        this.params = params;
    }
    showPicker() {
        setTimeout(()=>super.showPicker());
    }
    hidePicker() {
        setTimeout(()=>super.hidePicker());
    }
    postConstruct() {
        super.postConstruct();
        const { wrapperClassName: wrapperClassName, ariaLabel: ariaLabel } = this.params;
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eDisplayField, false);
        if (wrapperClassName) this.eWrapper.classList.add(wrapperClassName);
        (0, $437b23f6a393c3bf$export$84233c40c4c74001)(this.eWrapper, "");
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.eWrapper, ariaLabel);
    }
    onEnterKeyDown(event) {
        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
        if (this.isPickerDisplayed) super.onEnterKeyDown(event);
        else {
            event.preventDefault();
            this.showPicker();
        }
    }
};
var $5b7ccabde48fae90$var$AdvancedFilterBuilderItemNavigationFeature = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(eGui, focusWrapper, eFocusableComp){
        super();
        this.eGui = eGui;
        this.focusWrapper = focusWrapper;
        this.eFocusableComp = eFocusableComp;
    }
    postConstruct() {
        this.addManagedElementListeners(this.eGui, {
            keydown: (event)=>{
                switch(event.key){
                    case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).TAB:
                        if (!event.defaultPrevented) (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
                        break;
                    case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP:
                    case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN:
                        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
                        break;
                    case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ESCAPE:
                        if ((0, $437b23f6a393c3bf$export$9a48e23524c6d58)(event)) return;
                        if (this.eGui.contains((0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans))) {
                            event.preventDefault();
                            (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
                            this.focusWrapper.focus();
                        }
                        break;
                }
            }
        });
        const highlightClass = "ag-advanced-filter-builder-virtual-list-item-highlight";
        this.addManagedListeners(this.focusWrapper, {
            keydown: (event)=>{
                if (event.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER) {
                    if ((0, $437b23f6a393c3bf$export$9a48e23524c6d58)(event)) return;
                    if ((0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans) === this.focusWrapper) {
                        event.preventDefault();
                        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
                        this.eFocusableComp.getFocusableElement().focus();
                    }
                }
            },
            focusin: ()=>{
                this.focusWrapper.classList.add(highlightClass);
            },
            focusout: (event)=>{
                if (!this.focusWrapper.contains(event.relatedTarget)) this.focusWrapper.classList.remove(highlightClass);
            }
        });
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/builder/advancedFilterBuilderUtils.ts
function $5b7ccabde48fae90$var$getAdvancedFilterBuilderAddButtonParams(translate, maxPickerWidth) {
    return {
        pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderAddField",
        pickerAriaLabelValue: "Advanced Filter Builder Add Field",
        pickerType: "ag-list",
        valueList: [
            {
                key: "condition",
                displayValue: translate("advancedFilterBuilderAddCondition")
            },
            {
                key: "join",
                displayValue: translate("advancedFilterBuilderAddJoin")
            }
        ],
        valueFormatter: (value)=>value == null ? "" : value.displayValue ?? value.key,
        pickerIcon: "advancedFilterBuilderAdd",
        maxPickerWidth: `${maxPickerWidth ?? 120}px`,
        wrapperClassName: "ag-advanced-filter-builder-item-button",
        ariaLabel: translate("advancedFilterBuilderAddButtonTooltip")
    };
}
// packages/ag-grid-enterprise/src/advancedFilter/builder/advancedFilterBuilderItemAddComp.ts
var $5b7ccabde48fae90$var$ItemAddElement = {
    tag: "div",
    cls: "ag-advanced-filter-builder-item-wrapper",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eItem",
            cls: "ag-advanced-filter-builder-item",
            role: "presentation",
            children: [
                {
                    tag: "div",
                    cls: "ag-advanced-filter-builder-item-tree-lines",
                    attrs: {
                        "aria-hidden": "true"
                    },
                    children: [
                        {
                            tag: "div",
                            cls: "ag-advanced-filter-builder-item-tree-line-vertical-top ag-advanced-filter-builder-item-tree-line-horizontal"
                        }
                    ]
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$AdvancedFilterBuilderItemAddComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(item, focusWrapper){
        super($5b7ccabde48fae90$var$ItemAddElement);
        this.item = item;
        this.focusWrapper = focusWrapper;
        this.eItem = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    wireBeans(beans) {
        this.advFilterExpSvc = beans.advFilterExpSvc;
        this.registry = beans.registry;
    }
    postConstruct() {
        (0, $437b23f6a393c3bf$export$9eaf1f20171625e8)(this.focusWrapper, 2);
        const addButtonParams = $5b7ccabde48fae90$var$getAdvancedFilterBuilderAddButtonParams((key)=>this.advFilterExpSvc.translate(key), this.gos.get("advancedFilterBuilderParams")?.addSelectWidth);
        const eAddButton = this.createManagedBean(new $5b7ccabde48fae90$var$AddDropdownComp(addButtonParams));
        this.addManagedListeners(eAddButton, {
            fieldPickerValueSelected: ({ value: value })=>{
                this.dispatchLocalEvent({
                    type: "advancedFilterBuilderAdded",
                    item: this.item,
                    isJoin: value.key === "join"
                });
            }
        });
        this.eItem.appendChild(eAddButton.getGui());
        this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>eAddButton.getGui(),
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip")
        }));
        this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemNavigationFeature(this.getGui(), this.focusWrapper, eAddButton));
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.focusWrapper, this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItem", [
            this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip"),
            `${this.item.level + 1}`
        ]));
    }
    afterAdd() {}
};
var $5b7ccabde48fae90$var$ConditionPillWrapperComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-advanced-filter-builder-item-condition",
            role: "presentation"
        });
        this.validationMessage = null;
    }
    wireBeans(beans) {
        this.advFilterExpSvc = beans.advFilterExpSvc;
    }
    init(params) {
        const { item: item, createPill: createPill } = params;
        this.item = item;
        this.createPill = createPill;
        this.filterModel = item.filterModel;
        this.setupColumnCondition(this.filterModel);
        this.validate();
        this.addDestroyFunc(()=>this.destroyBeans([
                this.eColumnPill,
                this.eOperatorPill,
                this.eOperandPill
            ]));
    }
    getDragName() {
        return this.filterModel.colId ? this.advFilterExpSvc.parseColumnFilterModel(this.filterModel) : this.getDefaultColumnDisplayValue();
    }
    getAriaLabel() {
        return `${this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderFilterItem")} ${this.getDragName()}`;
    }
    getValidationMessage() {
        return this.validationMessage;
    }
    getFocusableElement() {
        return this.eColumnPill.getFocusableElement();
    }
    setupColumnCondition(filterModel) {
        const columnDetails = this.advFilterExpSvc.getColumnDetails(filterModel.colId);
        this.baseCellDataType = columnDetails.baseCellDataType;
        this.column = columnDetails.column;
        this.numOperands = this.getNumOperands(this.getOperatorKey());
        this.eColumnPill = this.createPill({
            key: this.getColumnKey(),
            displayValue: this.getColumnDisplayValue() ?? this.getDefaultColumnDisplayValue(),
            cssClass: "ag-advanced-filter-builder-column-pill",
            isSelect: true,
            getEditorParams: ()=>({
                    values: this.advFilterExpSvc.getColumnAutocompleteEntries()
                }),
            update: (key)=>this.setColumnKey(key),
            pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderColumnSelectField",
            pickerAriaLabelValue: "Advanced Filter Builder Column Select Field",
            ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderColumn")
        });
        this.getGui().appendChild(this.eColumnPill.getGui());
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(this.getColumnKey())) {
            this.createOperatorPill();
            if (this.hasOperand()) this.createOperandPill();
        }
    }
    createOperatorPill() {
        this.eOperatorPill = this.createPill({
            key: this.getOperatorKey(),
            displayValue: this.getOperatorDisplayValue() ?? this.getDefaultOptionSelectValue(),
            cssClass: "ag-advanced-filter-builder-option-pill",
            isSelect: true,
            getEditorParams: ()=>({
                    values: this.getOperatorAutocompleteEntries()
                }),
            update: (key)=>this.setOperatorKey(key),
            pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderOptionSelectField",
            pickerAriaLabelValue: "Advanced Filter Builder Option Select Field",
            ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderOption")
        });
        this.eColumnPill.getGui().insertAdjacentElement("afterend", this.eOperatorPill.getGui());
    }
    createOperandPill() {
        const { filter: filter } = this.filterModel;
        const key = (typeof filter === "number" ? (0, $437b23f6a393c3bf$export$2a74c29220d5c88e)(filter) : filter) ?? "";
        this.eOperandPill = this.createPill({
            key: key,
            // Convert from the input format to display format.
            // Input format matches model format except for numbers, but these get stringified anyway
            valueFormatter: (value)=>this.advFilterExpSvc.getOperandDisplayValue({
                    ...this.filterModel,
                    filter: value
                }, true),
            baseCellDataType: this.baseCellDataType,
            cssClass: "ag-advanced-filter-builder-value-pill",
            isSelect: false,
            update: (key2)=>this.setOperand(key2),
            ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderValue")
        });
        this.getGui().appendChild(this.eOperandPill.getGui());
    }
    getColumnKey() {
        return this.filterModel.colId;
    }
    getColumnDisplayValue() {
        return this.advFilterExpSvc.getColumnDisplayValue(this.filterModel);
    }
    getOperatorKey() {
        return this.filterModel.type;
    }
    getOperatorDisplayValue() {
        return this.advFilterExpSvc.getOperatorDisplayValue(this.filterModel);
    }
    getOperandDisplayValue() {
        return this.advFilterExpSvc.getOperandDisplayValue(this.filterModel, true);
    }
    hasOperand() {
        return this.numOperands > 0;
    }
    getOperatorAutocompleteEntries() {
        return this.column ? this.advFilterExpSvc.getOperatorAutocompleteEntries(this.column, this.baseCellDataType) : [];
    }
    setColumnKey(colId) {
        if (!this.eOperatorPill) this.createOperatorPill();
        const newColumnDetails = this.advFilterExpSvc.getColumnDetails(colId);
        this.column = newColumnDetails.column;
        const newBaseCellDataType = newColumnDetails.baseCellDataType;
        if (this.baseCellDataType !== newBaseCellDataType) {
            this.baseCellDataType = newBaseCellDataType;
            this.setOperatorKey(void 0);
            if (this.eOperatorPill) {
                (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(this.eOperatorPill.getGui());
                this.destroyBean(this.eOperatorPill);
                this.createOperatorPill();
            }
            this.validate();
        }
        this.filterModel.colId = colId;
        this.filterModel.filterType = this.baseCellDataType;
    }
    setOperatorKey(operator) {
        const newNumOperands = this.getNumOperands(operator);
        if (newNumOperands !== this.numOperands) {
            this.numOperands = newNumOperands;
            if (newNumOperands === 0) this.destroyOperandPill();
            else {
                this.createOperandPill();
                if (this.baseCellDataType !== "number") this.setOperand("");
            }
        }
        this.filterModel.type = operator;
        this.validate();
    }
    setOperand(operand) {
        let parsedOperand = operand;
        if (this.baseCellDataType === "number") parsedOperand = (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(operand) ? Number(operand) : "";
        this.filterModel.filter = parsedOperand;
        this.validate();
    }
    getNumOperands(operator) {
        return this.advFilterExpSvc.getExpressionOperator(this.baseCellDataType, operator)?.numOperands ?? 0;
    }
    destroyOperandPill() {
        delete this.filterModel.filter;
        this.eOperandPill?.getGui().remove();
        this.destroyBean(this.eOperandPill);
        this.eOperandPill = void 0;
    }
    validate() {
        let validationMessage = null;
        if (!(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(this.getColumnKey())) validationMessage = this.advFilterExpSvc.translate("advancedFilterBuilderValidationSelectColumn");
        else if (!(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(this.getOperatorKey())) validationMessage = this.advFilterExpSvc.translate("advancedFilterBuilderValidationSelectOption");
        else if (this.numOperands > 0 && !(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(this.getOperandDisplayValue())) validationMessage = this.advFilterExpSvc.translate("advancedFilterBuilderValidationEnterValue");
        this.item.valid = !validationMessage;
        if (validationMessage !== this.validationMessage) {
            this.validationMessage = validationMessage;
            this.dispatchLocalEvent({
                type: "advancedFilterBuilderValidChanged"
            });
        }
    }
    getDefaultColumnDisplayValue() {
        return this.advFilterExpSvc.translate("advancedFilterBuilderSelectColumn");
    }
    getDefaultOptionSelectValue() {
        return this.advFilterExpSvc.translate("advancedFilterBuilderSelectOption");
    }
};
var $5b7ccabde48fae90$var$inputComponentDescriptors = {
    number: [
        (0, $437b23f6a393c3bf$export$c8aa0be99738aee)
    ],
    boolean: [
        (0, $437b23f6a393c3bf$export$8c027679838afd47)
    ],
    object: [
        (0, $437b23f6a393c3bf$export$8c027679838afd47)
    ],
    text: [
        (0, $437b23f6a393c3bf$export$8c027679838afd47)
    ],
    date: [
        (0, $437b23f6a393c3bf$export$9e01ec8ba43de612)
    ],
    dateString: [
        (0, $437b23f6a393c3bf$export$9e01ec8ba43de612)
    ],
    dateTime: [
        (0, $437b23f6a393c3bf$export$9e01ec8ba43de612),
        (i)=>i.setIncludeTime(true)
    ],
    dateTimeString: [
        (0, $437b23f6a393c3bf$export$9e01ec8ba43de612),
        (i)=>i.setIncludeTime(true)
    ]
};
var $5b7ccabde48fae90$var$InputPillElement = {
    tag: "div",
    cls: "ag-advanced-filter-builder-pill-wrapper",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "ePill",
            cls: "ag-advanced-filter-builder-pill",
            role: "button",
            children: [
                {
                    tag: "span",
                    ref: "eLabel",
                    cls: "ag-advanced-filter-builder-pill-display"
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$InputPillComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(params){
        super($5b7ccabde48fae90$var$InputPillElement);
        this.params = params;
        this.ePill = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eLabel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        const { value: value, valueFormatter: valueFormatter } = params;
        this.value = value;
        this.displayValue = valueFormatter(value);
    }
    wireBeans(beans) {
        this.advFilterExpSvc = beans.advFilterExpSvc;
    }
    postConstruct() {
        const { cssClass: cssClass, ariaLabel: ariaLabel } = this.params;
        this.ePill.classList.add(cssClass);
        this.activateTabIndex([
            this.ePill
        ]);
        this.eLabel.id = `${this.getCompId()}`;
        (0, $437b23f6a393c3bf$export$3c2bc877474a7797)(this.ePill, this.eLabel.id);
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.ePill, ariaLabel);
        this.renderValue();
        this.addManagedListeners(this.ePill, {
            click: (event)=>{
                event.preventDefault();
                this.showEditor();
            },
            keydown: (event)=>{
                if (event.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER) {
                    event.preventDefault();
                    (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
                    this.showEditor();
                }
            }
        });
        this.addDestroyFunc(()=>this.destroyBean(this.eEditor));
    }
    getFocusableElement() {
        return this.ePill;
    }
    showEditor() {
        if (this.eEditor) return;
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.ePill, false);
        this.eEditor = this.createEditorComp(this.params.type);
        this.eEditor.setValue(this.value);
        const eEditorGui = this.eEditor.getGui();
        this.eEditor.addManagedElementListeners(eEditorGui, {
            keydown: (event)=>{
                switch(event.key){
                    case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER:
                        event.preventDefault();
                        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
                        this.updateValue(true);
                        break;
                    case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ESCAPE:
                        event.preventDefault();
                        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
                        this.hideEditor(true);
                        break;
                }
            },
            focusout: ()=>this.updateValue(false)
        });
        this.getGui().appendChild(eEditorGui);
        this.eEditor.getFocusableElement().focus();
    }
    /**
   * Responsible for instantiating an InputField and calling some of the setup methods
   */ createEditorComp(type) {
        const [Comp, postConstruct] = $5b7ccabde48fae90$var$inputComponentDescriptors[type];
        const instance = this.createBean(new Comp());
        postConstruct?.(instance);
        return instance;
    }
    hideEditor(keepFocus) {
        const { eEditor: eEditor } = this;
        if (!eEditor) return;
        this.eEditor = void 0;
        eEditor.getGui().remove();
        this.destroyBean(eEditor);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.ePill, true);
        if (keepFocus) this.ePill.focus();
    }
    renderValue() {
        let value;
        const { displayValue: displayValue, eLabel: eLabel } = this;
        const { classList: classList } = eLabel;
        classList.remove("ag-advanced-filter-builder-value-empty", "ag-advanced-filter-builder-value-number", "ag-advanced-filter-builder-value-text");
        if (!(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(displayValue)) {
            value = this.advFilterExpSvc.translate("advancedFilterBuilderEnterValue");
            classList.add("ag-advanced-filter-builder-value-empty");
        } else if (this.params.type === "number") {
            value = displayValue;
            classList.add("ag-advanced-filter-builder-value-number");
        } else {
            value = `"${displayValue}"`;
            classList.add("ag-advanced-filter-builder-value-text");
        }
        eLabel.textContent = value;
    }
    updateValue(keepFocus) {
        if (!this.eEditor) return;
        const value = this.eEditor.getValue() ?? "";
        this.dispatchLocalEvent({
            type: "fieldValueChanged",
            value: value
        });
        this.value = value;
        this.displayValue = this.params.valueFormatter(value);
        this.renderValue();
        this.hideEditor(keepFocus);
    }
};
var $5b7ccabde48fae90$var$JoinPillWrapperComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    wireBeans(beans) {
        this.advFilterExpSvc = beans.advFilterExpSvc;
    }
    constructor(){
        super({
            tag: "div",
            cls: "ag-advanced-filter-builder-item-condition",
            role: "presentation"
        });
    }
    init(params) {
        const { item: item, createPill: createPill } = params;
        const filterModel = item.filterModel;
        this.filterModel = filterModel;
        this.ePill = createPill({
            key: filterModel.type,
            displayValue: this.advFilterExpSvc.parseJoinOperator(filterModel),
            cssClass: "ag-advanced-filter-builder-join-pill",
            isSelect: true,
            getEditorParams: ()=>({
                    values: this.advFilterExpSvc.getJoinOperatorAutocompleteEntries()
                }),
            update: (key)=>filterModel.type = key,
            pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderJoinSelectField",
            pickerAriaLabelValue: "Advanced Filter Builder Join Operator Select Field",
            ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderJoinOperator")
        });
        this.getGui().appendChild(this.ePill.getGui());
        this.addDestroyFunc(()=>this.destroyBean(this.ePill));
    }
    getDragName() {
        return this.advFilterExpSvc.parseJoinOperator(this.filterModel);
    }
    getAriaLabel() {
        return `${this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderGroupItem")} ${this.getDragName()}`;
    }
    getValidationMessage() {
        return null;
    }
    getFocusableElement() {
        return this.ePill.getFocusableElement();
    }
};
var $5b7ccabde48fae90$var$SelectPillElement = {
    tag: "div",
    cls: "ag-picker-field ag-advanced-filter-builder-pill-wrapper",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eLabel"
        },
        {
            tag: "div",
            ref: "eWrapper",
            cls: "ag-wrapper ag-advanced-filter-builder-pill ag-picker-collapsed",
            children: [
                {
                    tag: "div",
                    ref: "eDisplayField",
                    cls: "ag-picker-field-display ag-advanced-filter-builder-pill-display"
                },
                {
                    tag: "ag-input-text-field",
                    ref: "eInput",
                    cls: "ag-rich-select-field-input"
                },
                {
                    tag: "span",
                    ref: "eDeselect",
                    cls: "ag-rich-select-deselect-button ag-picker-field-icon",
                    role: "presentation"
                },
                {
                    tag: "div",
                    ref: "eIcon",
                    cls: "ag-picker-field-icon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$SelectPillComp = class extends $5b7ccabde48fae90$var$AgRichSelect {
    constructor(params){
        super({
            ...params,
            template: $5b7ccabde48fae90$var$SelectPillElement,
            agComponents: [
                (0, $437b23f6a393c3bf$export$31e2985be4ee06ab)
            ]
        });
        this.params = params;
    }
    getFocusableElement() {
        return this.eWrapper;
    }
    showPicker() {
        setTimeout(()=>super.showPicker());
    }
    hidePicker() {
        setTimeout(()=>super.hidePicker());
    }
    postConstruct() {
        super.postConstruct();
        const { wrapperClassName: wrapperClassName, ariaLabel: ariaLabel } = this.params;
        this.eWrapper.classList.add(wrapperClassName);
        (0, $437b23f6a393c3bf$export$84233c40c4c74001)(this.eWrapper, "");
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.eWrapper, ariaLabel);
    }
    createPickerComponent() {
        if (!this.values) {
            const { values: values } = this.params.getEditorParams();
            this.values = values;
            const key = this.value.key;
            const value = values.find((value2)=>value2.key === key) ?? {
                key: key,
                displayValue: this.value.displayValue
            };
            this.value = value;
        }
        return super.createPickerComponent();
    }
    onEnterKeyDown(event) {
        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
        if (this.isPickerDisplayed) super.onEnterKeyDown(event);
        else {
            event.preventDefault();
            this.showPicker();
        }
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/builder/advancedFilterBuilderItemComp.ts
var $5b7ccabde48fae90$var$AdvancedFilterBuilderItemElement = {
    tag: "div",
    cls: "ag-advanced-filter-builder-item-wrapper",
    role: "presentation",
    children: [
        {
            tag: "div",
            cls: "ag-advanced-filter-builder-item",
            role: "presentation",
            children: [
                {
                    tag: "div",
                    ref: "eTreeLines",
                    cls: "ag-advanced-filter-builder-item-tree-lines",
                    attrs: {
                        "aria-hidden": "true"
                    }
                },
                {
                    tag: "span",
                    ref: "eDragHandle",
                    cls: "ag-drag-handle",
                    attrs: {
                        "aria-hidden": "true"
                    }
                },
                {
                    tag: "span",
                    ref: "eValidation",
                    cls: "ag-advanced-filter-builder-item-button ag-advanced-filter-builder-invalid",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        },
        {
            tag: "div",
            ref: "eButtons",
            cls: "ag-advanced-filter-builder-item-buttons",
            children: [
                {
                    tag: "span",
                    ref: "eMoveUpButton",
                    cls: "ag-advanced-filter-builder-item-button",
                    role: "button"
                },
                {
                    tag: "span",
                    ref: "eMoveDownButton",
                    cls: "ag-advanced-filter-builder-item-button",
                    role: "button"
                },
                {
                    tag: "div",
                    ref: "eAddButton",
                    role: "presentation"
                },
                {
                    tag: "span",
                    ref: "eRemoveButton",
                    cls: "ag-advanced-filter-builder-item-button",
                    role: "button"
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp = class extends (0, $437b23f6a393c3bf$export$5a26e3abd1c845b6) {
    constructor(item, dragFeature, focusWrapper){
        super($5b7ccabde48fae90$var$AdvancedFilterBuilderItemElement);
        this.item = item;
        this.dragFeature = dragFeature;
        this.focusWrapper = focusWrapper;
        this.eTreeLines = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eDragHandle = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eButtons = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eValidation = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eMoveUpButton = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eMoveDownButton = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eAddButton = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eRemoveButton = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.moveUpDisabled = false;
        this.moveDownDisabled = false;
    }
    wireBeans(beans) {
        this.dragAndDrop = beans.dragAndDrop;
        this.advFilterExpSvc = beans.advFilterExpSvc;
        this.registry = beans.registry;
    }
    postConstruct() {
        const { filterModel: filterModel, level: level, showMove: showMove } = this.item;
        const isJoin = filterModel.filterType === "join";
        this.ePillWrapper = this.createManagedBean(isJoin ? new $5b7ccabde48fae90$var$JoinPillWrapperComp() : new $5b7ccabde48fae90$var$ConditionPillWrapperComp());
        this.ePillWrapper.init({
            item: this.item,
            createPill: (params)=>this.createPill(params)
        });
        this.eDragHandle.insertAdjacentElement("afterend", this.ePillWrapper.getGui());
        if (level === 0) {
            const eTreeLine = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
                tag: "div",
                cls: "ag-advanced-filter-builder-item-tree-line-vertical-bottom ag-advanced-filter-builder-item-tree-line-root"
            });
            this.eTreeLines.appendChild(eTreeLine);
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eDragHandle, false);
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eButtons, false);
            (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(this.focusWrapper, true);
        } else {
            this.setupTreeLines(level);
            this.eDragHandle.appendChild((0, $437b23f6a393c3bf$export$d8feba07bf373edb)("advancedFilterBuilderDrag", this.beans));
            this.setupValidation();
            this.setupMoveButtons(showMove);
            this.setupAddButton();
            this.setupRemoveButton();
            this.setupDragging();
            this.updateAriaExpanded();
        }
        (0, $437b23f6a393c3bf$export$9eaf1f20171625e8)(this.focusWrapper, level + 1);
        this.initialiseTabGuard({});
        this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemNavigationFeature(this.getGui(), this.focusWrapper, this.ePillWrapper));
        this.updateAriaLabel();
        this.addManagedListeners(this.ePillWrapper, {
            advancedFilterBuilderValueChanged: ()=>this.dispatchLocalEvent({
                    type: "advancedFilterBuilderValueChanged"
                }),
            advancedFilterBuilderValidChanged: ()=>this.updateValidity()
        });
    }
    setState(params) {
        const { level: level } = this.item;
        if (level === 0) return;
        const { showMove: showMove } = this.item;
        const { disableMoveUp: disableMoveUp, disableMoveDown: disableMoveDown, treeLines: treeLines, showStartTreeLine: showStartTreeLine } = params;
        this.updateTreeLines(treeLines, showStartTreeLine);
        this.updateAriaExpanded();
        if (showMove) {
            this.moveUpDisabled = !!disableMoveUp;
            this.moveDownDisabled = !!disableMoveDown;
            this.eMoveUpButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", disableMoveUp);
            this.eMoveDownButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", disableMoveDown);
            (0, $437b23f6a393c3bf$export$7ed376f43c6f2bbd)(this.eMoveUpButton, !!disableMoveUp);
            (0, $437b23f6a393c3bf$export$7ed376f43c6f2bbd)(this.eMoveDownButton, !!disableMoveDown);
            this.moveUpTooltipFeature?.refreshTooltip();
            this.moveDownTooltipFeature?.refreshTooltip();
        }
    }
    focusMoveButton(backwards) {
        (backwards ? this.eMoveUpButton : this.eMoveDownButton).focus();
    }
    afterAdd() {
        this.ePillWrapper.getFocusableElement().focus();
    }
    setupTreeLines(level) {
        for(let i = 0; i < level; i++)this.eTreeLines.appendChild((0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div"
        }));
    }
    updateTreeLines(treeLines, showStartTreeLine) {
        const lastTreeLineIndex = treeLines.length - 1;
        const { children: children } = this.eTreeLines;
        for(let i = 0; i < lastTreeLineIndex; i++){
            const eTreeLine2 = children.item(i);
            if (eTreeLine2) eTreeLine2.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !treeLines[i]);
        }
        const eTreeLine = children.item(lastTreeLineIndex);
        if (eTreeLine) {
            eTreeLine.classList.add("ag-advanced-filter-builder-item-tree-line-horizontal");
            const isLastChild = treeLines[lastTreeLineIndex];
            eTreeLine.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical-top", isLastChild);
            eTreeLine.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !isLastChild);
        }
        this.eDragHandle.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical-bottom", showStartTreeLine);
    }
    setupValidation() {
        this.eValidation.appendChild((0, $437b23f6a393c3bf$export$d8feba07bf373edb)("advancedFilterBuilderInvalid", this.beans));
        this.validationTooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.eValidation,
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.ePillWrapper.getValidationMessage(),
            getTooltipShowDelayOverride: ()=>1e3
        }));
        this.updateValidity();
    }
    setupAddButton() {
        const addButtonParams = $5b7ccabde48fae90$var$getAdvancedFilterBuilderAddButtonParams((key)=>this.advFilterExpSvc.translate(key), this.gos.get("advancedFilterBuilderParams")?.addSelectWidth);
        const eAddButton = this.createManagedBean(new $5b7ccabde48fae90$var$AddDropdownComp(addButtonParams));
        this.addManagedListeners(eAddButton, {
            fieldPickerValueSelected: ({ value: value })=>this.dispatchLocalEvent({
                    type: "advancedFilterBuilderAdded",
                    item: this.item,
                    isJoin: value.key === "join"
                })
        });
        this.eAddButton.appendChild(eAddButton.getGui());
        this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.eAddButton,
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip")
        }));
    }
    setupRemoveButton() {
        this.eRemoveButton.appendChild((0, $437b23f6a393c3bf$export$d8feba07bf373edb)("advancedFilterBuilderRemove", this.beans));
        this.addManagedListeners(this.eRemoveButton, {
            click: ()=>this.removeItem(),
            keydown: (event)=>{
                if (event.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER) {
                    event.preventDefault();
                    (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
                    this.removeItem();
                }
            }
        });
        this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.eRemoveButton,
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.advFilterExpSvc.translate("advancedFilterBuilderRemoveButtonTooltip")
        }));
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.eRemoveButton, this.advFilterExpSvc.translate("advancedFilterBuilderRemoveButtonTooltip"));
        this.activateTabIndex([
            this.eRemoveButton
        ]);
    }
    setupMoveButtons(showMove) {
        if (showMove) {
            this.eMoveUpButton.appendChild((0, $437b23f6a393c3bf$export$d8feba07bf373edb)("advancedFilterBuilderMoveUp", this.beans));
            this.addManagedListeners(this.eMoveUpButton, {
                click: ()=>this.moveItem(true),
                keydown: (event)=>{
                    if (event.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER) {
                        event.preventDefault();
                        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
                        this.moveItem(true);
                    }
                }
            });
            this.moveUpTooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
                getGui: ()=>this.eMoveUpButton,
                getLocation: ()=>"advancedFilter",
                getTooltipValue: ()=>this.moveUpDisabled ? null : this.advFilterExpSvc.translate("advancedFilterBuilderMoveUpButtonTooltip")
            }));
            (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.eMoveUpButton, this.advFilterExpSvc.translate("advancedFilterBuilderMoveUpButtonTooltip"));
            this.eMoveDownButton.appendChild((0, $437b23f6a393c3bf$export$d8feba07bf373edb)("advancedFilterBuilderMoveDown", this.beans));
            this.addManagedListeners(this.eMoveDownButton, {
                click: ()=>this.moveItem(false),
                keydown: (event)=>{
                    if (event.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER) {
                        event.preventDefault();
                        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(event);
                        this.moveItem(false);
                    }
                }
            });
            this.moveDownTooltipFeature = this.createOptionalManagedBean(this.registry.createDynamicBean("tooltipFeature", false, {
                getGui: ()=>this.eMoveDownButton,
                getLocation: ()=>"advancedFilter",
                getTooltipValue: ()=>this.moveDownDisabled ? null : this.advFilterExpSvc.translate("advancedFilterBuilderMoveDownButtonTooltip")
            }));
            (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.eMoveDownButton, this.advFilterExpSvc.translate("advancedFilterBuilderMoveDownButtonTooltip"));
            this.activateTabIndex([
                this.eMoveUpButton,
                this.eMoveDownButton
            ]);
        } else {
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eMoveUpButton, false);
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eMoveDownButton, false);
        }
    }
    updateValidity() {
        (0, $437b23f6a393c3bf$export$a6c2c477cd60daa8)(this.eValidation, !this.item.valid);
        this.validationTooltipFeature?.refreshTooltip();
        this.updateAriaLabel();
    }
    createPill(params) {
        const { key: key, cssClass: cssClass, update: update, ariaLabel: ariaLabel } = params;
        const onUpdated = (key2)=>{
            if (key2 == null) return;
            update(key2);
            this.dispatchLocalEvent({
                type: "advancedFilterBuilderValueChanged"
            });
        };
        if (params.isSelect) {
            const { getEditorParams: getEditorParams, pickerAriaLabelKey: pickerAriaLabelKey, pickerAriaLabelValue: pickerAriaLabelValue, displayValue: displayValue } = params;
            const advancedFilterBuilderParams = this.gos.get("advancedFilterBuilderParams");
            const minPickerWidth = `${advancedFilterBuilderParams?.pillSelectMinWidth ?? 140}px`;
            const maxPickerWidth = `${advancedFilterBuilderParams?.pillSelectMaxWidth ?? 200}px`;
            const comp = this.createBean(new $5b7ccabde48fae90$var$SelectPillComp({
                pickerAriaLabelKey: pickerAriaLabelKey,
                pickerAriaLabelValue: pickerAriaLabelValue,
                pickerType: "ag-list",
                value: {
                    key: key,
                    displayValue: displayValue
                },
                valueFormatter: (value)=>value == null ? "" : value.displayValue ?? value.key,
                variableWidth: true,
                minPickerWidth: minPickerWidth,
                maxPickerWidth: maxPickerWidth,
                getEditorParams: getEditorParams,
                wrapperClassName: cssClass,
                ariaLabel: ariaLabel,
                pickerIcon: "advancedFilterBuilderSelectOpen"
            }));
            this.addManagedListeners(comp, {
                fieldPickerValueSelected: ({ value: value })=>onUpdated(value?.key)
            });
            return comp;
        } else {
            const { baseCellDataType: baseCellDataType, valueFormatter: valueFormatter } = params;
            const comp = this.createBean(new $5b7ccabde48fae90$var$InputPillComp({
                value: key,
                valueFormatter: valueFormatter,
                cssClass: cssClass,
                type: baseCellDataType,
                ariaLabel: ariaLabel
            }));
            this.addManagedListeners(comp, {
                fieldValueChanged: ({ value: value })=>onUpdated(value)
            });
            return comp;
        }
    }
    setupDragging() {
        const dragSource = {
            type: (0, $437b23f6a393c3bf$export$46ba5a92125911d9).AdvancedFilterBuilder,
            eElement: this.eDragHandle,
            dragItemName: ()=>this.ePillWrapper.getDragName(),
            getDefaultIconName: ()=>"notAllowed",
            getDragItem: ()=>({}),
            onDragStarted: ()=>this.dragFeature.dispatchLocalEvent({
                    type: "advancedFilterBuilderDragStarted",
                    item: this.item
                }),
            onDragStopped: ()=>this.dragFeature.dispatchLocalEvent({
                    type: "advancedFilterBuilderDragEnded"
                })
        };
        this.dragAndDrop.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>this.dragAndDrop.removeDragSource(dragSource));
    }
    updateAriaLabel() {
        const wrapperLabel = this.ePillWrapper.getAriaLabel();
        const level = `${this.item.level + 1}`;
        const validationMessage = this.ePillWrapper.getValidationMessage();
        let ariaLabel;
        if (validationMessage) ariaLabel = this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItemValidation", [
            wrapperLabel,
            level,
            validationMessage
        ]);
        else ariaLabel = this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItem", [
            wrapperLabel,
            level
        ]);
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.focusWrapper, ariaLabel);
    }
    updateAriaExpanded() {
        (0, $437b23f6a393c3bf$export$2254dfb132f01330)(this.focusWrapper);
        const { filterModel: filterModel } = this.item;
        if (filterModel?.filterType === "join" && filterModel.conditions.length) (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(this.focusWrapper, true);
    }
    removeItem() {
        this.dispatchLocalEvent({
            type: "advancedFilterBuilderRemoved",
            item: this.item
        });
    }
    moveItem(backwards) {
        this.dispatchLocalEvent({
            type: "advancedFilterBuilderMoved",
            item: this.item,
            backwards: backwards
        });
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/builder/advancedFilterBuilderComp.ts
var $5b7ccabde48fae90$var$ButtonLocaleMap2 = {
    apply: "advancedFilterBuilderApply",
    clear: "advancedFilterBuilderClear",
    cancel: "advancedFilterBuilderCancel",
    reset: "advancedFilterBuilderReset"
};
var $5b7ccabde48fae90$var$AdvancedFilterBuilderElement = {
    tag: "div",
    cls: "ag-advanced-filter-builder",
    role: "presentation",
    attrs: {
        tabindex: "-1"
    },
    children: [
        {
            tag: "div",
            ref: "eList",
            cls: "ag-advanced-filter-builder-list",
            role: "presentation"
        }
    ]
};
var $5b7ccabde48fae90$var$AdvancedFilterBuilderComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$AdvancedFilterBuilderElement);
        this.eList = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    wireBeans(beans) {
        this.filterManager = beans.filterManager;
        this.advancedFilter = beans.advancedFilter;
        this.advFilterExpSvc = beans.advFilterExpSvc;
    }
    postConstruct() {
        const params = this.gos.get("advancedFilterBuilderParams");
        this.params = {
            buttons: [
                "apply",
                "cancel"
            ],
            ...params
        };
        this.addManagedPropertyListener("advancedFilterBuilderParams", ({ currentValue: currentValue })=>{
            this.params.showMoveButtons = !!currentValue?.showMoveButtons;
            this.params.buttons = currentValue?.buttons ?? [
                "apply",
                "cancel"
            ];
            this.refreshList(false);
        });
        this.filterModel = this.setupFilterModel();
        this.setupVirtualList();
        this.dragFeature = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderDragFeature(this, this.virtualList));
        this.resetButtonsPanel(this.params.buttons);
    }
    refresh() {
        const virtualList = this.virtualList;
        let indexToFocus = virtualList.getLastFocusedRow();
        this.setupFilterModel();
        this.validateItems();
        this.refreshList(false);
        if (indexToFocus != null) {
            if (!virtualList.getComponentAt(indexToFocus)) indexToFocus = 0;
            virtualList.focusRow(indexToFocus);
        }
    }
    getNumItems() {
        return this.items.length;
    }
    moveItem(item, destination) {
        if (!destination || !item) return;
        this.moveItemToIndex(item, destination.rowIndex, destination.position);
    }
    afterGuiAttached() {
        this.virtualList.awaitStable(()=>this.virtualList.focusRow(0));
    }
    setupVirtualList() {
        const virtualList = this.virtualList = this.createManagedBean(new $5b7ccabde48fae90$var$VirtualList({
            cssIdentifier: "advanced-filter-builder",
            ariaRole: "tree",
            listName: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderList"),
            moveItemCallback: this.virtualListMoveItemCallback.bind(this)
        }));
        virtualList.setComponentCreator(this.createItemComponent.bind(this));
        virtualList.setComponentUpdater(this.updateItemComponent.bind(this));
        virtualList.setRowHeight(40);
        this.eList.appendChild(virtualList.getGui());
        virtualList.setModel({
            getRowCount: ()=>this.items?.length || 0,
            getRow: (index)=>this.items[index],
            areRowsEqual: (oldRow, newRow)=>oldRow === newRow
        });
        this.buildList();
        virtualList.refresh();
    }
    resetButtonsPanel(actions) {
        const hasButtons = actions && actions.length > 0;
        let eButtonsPanel = this.eButtons;
        if (hasButtons) {
            const buttons = actions.map((type)=>({
                    type: type,
                    label: this.advFilterExpSvc.translate($5b7ccabde48fae90$var$ButtonLocaleMap2[type])
                }));
            if (!eButtonsPanel) {
                eButtonsPanel = this.createBean(new (0, $437b23f6a393c3bf$export$226c2a54d31bd592)());
                this.appendChild(eButtonsPanel.getGui());
                const getListener = (action)=>({ event: event })=>{
                        this.updateModel(action);
                        this.afterAction(action, event);
                    };
                eButtonsPanel.addManagedListeners(eButtonsPanel, {
                    apply: getListener("apply"),
                    clear: getListener("clear"),
                    reset: getListener("reset"),
                    cancel: getListener("cancel")
                });
                this.eButtons = eButtonsPanel;
            }
            eButtonsPanel.updateButtons(buttons);
            const applyButton = eButtonsPanel.getApplyButton();
            if (applyButton) {
                const mouseListener = (isEnter)=>this.toggleCss("ag-advanced-filter-builder-validation", isEnter);
                this.addManagedElementListeners(applyButton, {
                    mouseenter: ()=>mouseListener(true),
                    mouseleave: ()=>mouseListener(false)
                });
            }
        } else if (eButtonsPanel) {
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(eButtonsPanel.getGui());
            this.eButtons = this.destroyBean(eButtonsPanel);
        }
    }
    updateModel(action) {
        switch(action){
            case "apply":
                this.advancedFilter.setModel(this.filterModel);
                this.filterManager?.onFilterChanged({
                    source: "advancedFilter"
                });
                break;
            case "reset":
                this.advancedFilter.setModel(null);
                this.filterManager?.onFilterChanged({
                    source: "advancedFilter"
                });
                break;
            case "cancel":
                break;
            case "clear":
                this.filterModel = this.formatFilterModel(null);
                this.refreshList(false);
                break;
        }
    }
    afterAction(action, event) {
        switch(action){
            case "apply":
                event?.preventDefault();
                this.close();
                break;
            case "reset":
                this.close();
                break;
            case "cancel":
                this.close();
                break;
        }
    }
    removeItemFromParent(item) {
        const sourceParentIndex = item.parent.conditions.indexOf(item.filterModel);
        item.parent.conditions.splice(sourceParentIndex, 1);
        return sourceParentIndex;
    }
    moveItemToIndex(item, destinationRowIndex, destinationPosition) {
        const destinationItem = this.items[destinationRowIndex];
        const destinationIsParent = destinationItem.filterModel?.filterType === "join" && destinationPosition === "bottom";
        const destinationParent = destinationIsParent ? destinationItem.filterModel : destinationItem.parent;
        if (!destinationParent) return;
        if (this.isChildOrSelf(destinationParent, item.filterModel) || destinationItem === item) return;
        this.removeItemFromParent(item);
        let destinationParentIndex;
        if (destinationIsParent) destinationParentIndex = 0;
        else {
            destinationParentIndex = destinationParent.conditions.indexOf(destinationItem.filterModel);
            if (destinationParentIndex === -1) destinationParentIndex = destinationParent.conditions.length;
            else if (destinationPosition === "bottom") destinationParentIndex += 1;
        }
        destinationParent.conditions.splice(destinationParentIndex, 0, item.filterModel);
        this.refreshList(false);
    }
    isChildOrSelf(modelToCheck, potentialParentModel) {
        return modelToCheck === potentialParentModel || potentialParentModel.filterType === "join" && potentialParentModel.conditions.some((condition)=>this.isChildOrSelf(modelToCheck, condition));
    }
    setupFilterModel() {
        const filterModel = this.formatFilterModel(this.advancedFilter.getModel());
        this.stringifiedModel = JSON.stringify(filterModel);
        return filterModel;
    }
    formatFilterModel(filterModel) {
        filterModel = filterModel ?? {
            filterType: "join",
            type: "AND",
            conditions: []
        };
        if (filterModel.filterType !== "join") filterModel = {
            filterType: "join",
            type: "AND",
            conditions: [
                filterModel
            ]
        };
        return filterModel;
    }
    buildList() {
        const parseFilterModel = (filterModel, items, level, parent)=>{
            items.push({
                filterModel: filterModel,
                level: level,
                parent: parent,
                valid: true,
                showMove: this.params.showMoveButtons
            });
            if (filterModel.filterType === "join") {
                for (const childFilterModel of filterModel.conditions)parseFilterModel(childFilterModel, items, level + 1, filterModel);
                if (level === 0) items.push({
                    filterModel: null,
                    level: level + 1,
                    parent: filterModel,
                    valid: true
                });
            }
        };
        this.items = [];
        parseFilterModel(this.filterModel, this.items, 0);
    }
    refreshList(softRefresh) {
        if (!softRefresh) {
            const invalidModels = [];
            for (const item of this.items)if (!item.valid) invalidModels.push(item.filterModel);
            this.buildList();
            if (invalidModels.length) {
                for (const item of this.items)if (item.filterModel && invalidModels.includes(item.filterModel)) item.valid = false;
            }
        }
        this.virtualList.refresh(softRefresh);
        this.validate();
    }
    updateItemComponent(item, comp) {
        const index = this.items.indexOf(item);
        const populateTreeLines = (filterModel2, treeLines2)=>{
            const parentItem = this.items.find((itemToCheck)=>itemToCheck.filterModel === filterModel2);
            const parentFilterModel = parentItem?.parent;
            if (parentFilterModel) {
                const { conditions: conditions } = parentFilterModel;
                populateTreeLines(parentFilterModel, treeLines2);
                treeLines2.push(conditions[conditions.length - 1] === filterModel2);
            }
        };
        const treeLines = [];
        const { filterModel: filterModel } = item;
        if (filterModel) {
            populateTreeLines(filterModel, treeLines);
            treeLines[0] = false;
        }
        const showStartTreeLine = filterModel?.filterType === "join" && !!filterModel.conditions.length;
        comp.setState({
            disableMoveUp: index === 1,
            disableMoveDown: !this.canMoveDown(item, index),
            treeLines: treeLines,
            showStartTreeLine: showStartTreeLine
        });
    }
    createItemComponent(item, focusWrapper) {
        const itemComp = this.createBean(item.filterModel ? new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp(item, this.dragFeature, focusWrapper) : new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemAddComp(item, focusWrapper));
        itemComp.addManagedListeners(itemComp, {
            advancedFilterBuilderRemoved: ({ item: item2 })=>this.removeItem(item2),
            advancedFilterBuilderValueChanged: ()=>this.validate(),
            advancedFilterBuilderAdded: ({ item: item2, isJoin: isJoin })=>this.addItem(item2, isJoin),
            advancedFilterBuilderMoved: ({ item: item2, backwards: backwards })=>this.moveItemUpDown(item2, backwards)
        });
        if (itemComp instanceof $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp) this.updateItemComponent(item, itemComp);
        return itemComp;
    }
    addItem(item, isJoin) {
        const { parent: itemParent, level: level, filterModel: itemFilterModel } = item;
        const itemIsJoin = itemFilterModel?.filterType === "join";
        const filterModel = isJoin ? {
            filterType: "join",
            type: "AND",
            conditions: []
        } : {};
        const parent = itemIsJoin ? itemFilterModel : itemParent;
        let insertIndex = itemIsJoin ? 0 : parent.conditions.indexOf(itemFilterModel);
        if (insertIndex >= 0) {
            if (!itemIsJoin) insertIndex += 1;
            parent.conditions.splice(insertIndex, 0, filterModel);
        } else parent.conditions.push(filterModel);
        let index = this.items.indexOf(item);
        const softRefresh = index >= 0;
        if (softRefresh) {
            if (item.filterModel) index++;
            const newItems = [
                {
                    filterModel: filterModel,
                    level: itemIsJoin ? level + 1 : level,
                    parent: parent,
                    valid: isJoin,
                    showMove: this.params.showMoveButtons
                }
            ];
            this.items.splice(index, 0, ...newItems);
        }
        this.refreshList(softRefresh);
        if (softRefresh) this.virtualList.getComponentAt(index)?.afterAdd();
    }
    removeItem(item) {
        const parent = item.parent;
        const { filterModel: filterModel } = item;
        const parentIndex = parent.conditions.indexOf(filterModel);
        parent.conditions.splice(parentIndex, 1);
        const isJoin = item.filterModel?.filterType === "join";
        const index = this.items.indexOf(item);
        const softRefresh = !isJoin && index >= 0;
        if (softRefresh) this.items.splice(index, 1);
        this.refreshList(softRefresh);
        if (index >= 0) this.virtualList.focusRow(index);
    }
    moveItemUpDown(item, backwards, fromVirtualList) {
        const itemIndex = this.items.indexOf(item);
        const destinationIndex = backwards ? itemIndex - 1 : itemIndex + 1;
        if (destinationIndex === 0 || !backwards && !this.canMoveDown(item, itemIndex)) return;
        const destinationItem = this.items[destinationIndex];
        const indexInParent = this.removeItemFromParent(item);
        const { level: level, filterModel: filterModel, parent: parent } = item;
        const { level: destinationLevel, filterModel: destinationFilterModel, parent: destinationParent } = destinationItem;
        if (backwards) {
            if (destinationLevel === level && destinationFilterModel.filterType === "join") destinationFilterModel.conditions.push(filterModel);
            else if (destinationLevel <= level) {
                const destinationIndex2 = destinationParent.conditions.indexOf(destinationFilterModel);
                destinationParent.conditions.splice(destinationIndex2, 0, filterModel);
            } else {
                const newParentItem = parent.conditions[indexInParent - 1];
                newParentItem.conditions.push(filterModel);
            }
        } else if (destinationLevel === level) {
            if (destinationFilterModel.filterType === "join") destinationFilterModel.conditions.splice(0, 0, filterModel);
            else {
                const destinationIndex2 = destinationParent.conditions.indexOf(destinationFilterModel);
                destinationParent.conditions.splice(destinationIndex2 + 1, 0, filterModel);
            }
        } else if (indexInParent < parent.conditions.length) parent.conditions.splice(indexInParent + 1, 0, filterModel);
        else {
            const parentItem = this.items.find((itemToCheck)=>itemToCheck.filterModel === parent);
            const destinationIndex2 = parentItem.parent.conditions.indexOf(parentItem.filterModel) + 1;
            parentItem.parent.conditions.splice(destinationIndex2, 0, filterModel);
        }
        this.refreshList(false);
        const newIndex = this.items.findIndex(({ filterModel: filterModelToCheck })=>filterModelToCheck === filterModel);
        if (newIndex < 0) return;
        const comp = this.virtualList.getComponentAt(newIndex);
        if (!(comp instanceof $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp)) return;
        if (!fromVirtualList) comp.focusMoveButton(backwards);
    }
    virtualListMoveItemCallback(itemComp, isUp) {
        const item = itemComp.item;
        const from = this.items.indexOf(item);
        if (from <= 0 || from === this.items.length - 1) return;
        if (isUp && from === 1 || !isUp && !this.canMoveDown(item, from)) return;
        this.moveItemUpDown(item, isUp, true);
        this.virtualList.focusRow(from + (isUp ? -1 : 1));
    }
    canMoveDown(item, index) {
        return !(item.level === 1 && index === this.items.length - 2 || item.level === 1 && item.parent.conditions[item.parent.conditions.length - 1] === item.filterModel);
    }
    close() {
        this.advancedFilter.getCtrl().toggleFilterBuilder({
            source: "ui"
        });
    }
    validate() {
        let isValid = this.items.every(({ valid: valid })=>valid);
        let validationMessage = null;
        if (isValid) {
            isValid = JSON.stringify(this.filterModel) !== this.stringifiedModel;
            if (!isValid) validationMessage = this.advFilterExpSvc.translate("advancedFilterBuilderValidationAlreadyApplied");
        } else validationMessage = this.advFilterExpSvc.translate("advancedFilterBuilderValidationIncomplete");
        this.eButtons?.updateValidity(isValid, validationMessage);
    }
    validateItems() {
        const clearOperator = (filterModel)=>{
            filterModel.type = void 0;
        };
        const clearOperand = (filterModel)=>{
            delete filterModel.filter;
        };
        for (const item of this.items){
            if (!item.valid || !item.filterModel || item.filterModel.filterType === "join") continue;
            const { filterModel: filterModel } = item;
            const { colId: colId } = filterModel;
            const hasColumn = this.advFilterExpSvc.getColumnAutocompleteEntries().find(({ key: key })=>key === colId);
            const columnDetails = this.advFilterExpSvc.getColumnDetails(filterModel.colId);
            if (!hasColumn || !columnDetails.column) {
                item.valid = false;
                filterModel.colId = void 0;
                clearOperator(filterModel);
                clearOperand(filterModel);
                continue;
            }
            const operatorForType = this.advFilterExpSvc.getDataTypeExpressionOperator(columnDetails.baseCellDataType);
            const operator = operatorForType.operators[filterModel.type];
            if (!operator) {
                item.valid = false;
                clearOperator(filterModel);
                clearOperand(filterModel);
                continue;
            }
            if (operator.numOperands > 0 && !(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(filterModel.filter)) item.valid = false;
        }
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterCtrl.ts
var $5b7ccabde48fae90$var$AdvancedFilterCtrl = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(enabled){
        super();
        this.enabled = enabled;
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.popupSvc = beans.popupSvc;
        this.advFilterExpSvc = beans.advFilterExpSvc;
        this.environment = beans.environment;
    }
    postConstruct() {
        this.hasAdvancedFilterParent = !!this.gos.get("advancedFilterParent");
        this.ctrlsSvc.whenReady(this, ()=>this.setAdvancedFilterComp());
        this.addManagedEventListeners({
            advancedFilterEnabledChanged: ({ enabled: enabled })=>this.onEnabledChanged(enabled)
        });
        this.addManagedPropertyListener("advancedFilterParent", ()=>this.updateComps());
        this.addManagedPropertyListener("advancedFilterBuilderParams", (event)=>{
            if (event.currentValue?.suppressFullScreenButton !== event.previousValue?.suppressFullScreenButton) this.eBuilderDialog?.setMaximizable(event.currentValue?.suppressFullScreenButton ?? true);
        });
        this.addDestroyFunc(()=>{
            this.destroyAdvancedFilterComp();
            this.destroyBean(this.eBuilderComp);
            if (this.eBuilderDialog?.isAlive()) this.destroyBean(this.eBuilderDialog);
        });
    }
    setupHeaderComp(eCompToInsertBefore) {
        if (this.eHeaderComp) {
            this.eHeaderComp?.getGui().remove();
            this.destroyBean(this.eHeaderComp);
        }
        this.eHeaderComp = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterHeaderComp(this.enabled && !this.hasAdvancedFilterParent));
        eCompToInsertBefore.insertAdjacentElement("beforebegin", this.eHeaderComp.getGui());
    }
    focusHeaderComp() {
        if (this.eHeaderComp) {
            this.eHeaderComp.getFocusableElement().focus();
            return true;
        }
        return false;
    }
    refreshComp() {
        this.eFilterComp?.refresh();
        this.eHeaderComp?.refresh();
    }
    refreshBuilderComp() {
        this.eBuilderComp?.refresh();
    }
    getHeaderHeight() {
        return this.eHeaderComp?.getHeight() ?? 0;
    }
    setInputDisabled(disabled) {
        this.eFilterComp?.setInputDisabled(disabled);
        this.eHeaderComp?.setInputDisabled(disabled);
    }
    toggleFilterBuilder(params) {
        const { source: source, force: force, eventSource: eventSource } = params;
        if (force && this.eBuilderDialog || force === false && !this.eBuilderDialog) return;
        if (this.eBuilderDialog) {
            this.builderDestroySource = source;
            this.destroyBean(this.eBuilderDialog);
            return;
        }
        this.setInputDisabled(true);
        const { width: width, height: height, minWidth: minWidth } = this.getBuilderDialogSize();
        const { suppressFullScreenButton: suppressFullScreenButton } = {
            suppressFullScreenButton: false,
            ...this.gos.get("advancedFilterBuilderParams")
        };
        this.eBuilderComp = this.createBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderComp());
        this.eBuilderDialog = this.createBean(new $5b7ccabde48fae90$var$Dialog({
            title: this.advFilterExpSvc.translate("advancedFilterBuilderTitle"),
            component: this.eBuilderComp,
            width: width,
            height: height,
            resizable: true,
            movable: true,
            maximizable: !suppressFullScreenButton,
            centered: true,
            closable: true,
            minWidth: minWidth,
            afterGuiAttached: ()=>this.eBuilderComp?.afterGuiAttached(),
            postProcessPopupParams: {
                type: "advancedFilterBuilder",
                eventSource: eventSource
            }
        }));
        this.dispatchFilterBuilderVisibleChangedEvent(source, true);
        this.eBuilderDialog.addEventListener("destroyed", ()=>{
            this.destroyBean(this.eBuilderComp);
            this.eBuilderComp = void 0;
            this.eBuilderDialog = void 0;
            this.setInputDisabled(false);
            this.dispatchLocalEvent({
                type: "advancedFilterBuilderClosed"
            });
            this.dispatchFilterBuilderVisibleChangedEvent(this.builderDestroySource ?? "ui", false);
            this.builderDestroySource = void 0;
        });
    }
    dispatchFilterBuilderVisibleChangedEvent(source, visible) {
        this.eventSvc.dispatchEvent({
            type: "advancedFilterBuilderVisibleChanged",
            source: source,
            visible: visible
        });
    }
    getBuilderDialogSize() {
        const minWidth = this.gos.get("advancedFilterBuilderParams")?.minWidth ?? 500;
        const popupParent = this.popupSvc.getPopupParent();
        const maxWidth = Math.round((0, $437b23f6a393c3bf$export$642efcb17474eb51)(popupParent)) - 2;
        const maxHeight = Math.round((0, $437b23f6a393c3bf$export$d23c22492e0f7c0c)(popupParent) * 0.75) - 2;
        const width = Math.min(Math.max(700, minWidth), maxWidth);
        const height = Math.min(600, maxHeight);
        return {
            width: width,
            height: height,
            minWidth: minWidth
        };
    }
    onEnabledChanged(enabled) {
        this.enabled = enabled;
        this.updateComps();
    }
    updateComps() {
        this.setAdvancedFilterComp();
        this.setHeaderCompEnabled();
        this.eventSvc.dispatchEvent({
            type: "headerHeightChanged"
        });
    }
    setAdvancedFilterComp() {
        this.destroyAdvancedFilterComp();
        if (!this.enabled) return;
        const advancedFilterParent = this.gos.get("advancedFilterParent");
        this.hasAdvancedFilterParent = !!advancedFilterParent;
        if (advancedFilterParent) {
            const eAdvancedFilterComp = this.createBean(new $5b7ccabde48fae90$var$AdvancedFilterComp());
            const eAdvancedFilterCompGui = eAdvancedFilterComp.getGui();
            this.environment.applyThemeClasses(eAdvancedFilterCompGui);
            eAdvancedFilterCompGui.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
            advancedFilterParent.appendChild(eAdvancedFilterCompGui);
            this.eFilterComp = eAdvancedFilterComp;
        }
    }
    setHeaderCompEnabled() {
        this.eHeaderComp?.setEnabled(this.enabled && !this.hasAdvancedFilterParent);
    }
    destroyAdvancedFilterComp() {
        if (this.eFilterComp) {
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(this.eFilterComp.getGui());
            this.destroyBean(this.eFilterComp);
        }
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/joinFilterExpressionParser.ts
var $5b7ccabde48fae90$var$OperatorParser2 = class {
    constructor(params){
        this.params = params;
        this.operators = [];
        this.operatorStartPositions = [];
        this.operatorEndPositions = [];
        this.activeOperator = 0;
        this.validationError = null;
    }
    parseExpression(i) {
        this.operators.push("");
        this.operatorStartPositions.push(i);
        this.operatorEndPositions.push(void 0);
        const { expression: expression } = this.params;
        while(i < expression.length){
            const char = expression[i];
            if (char === " ") {
                const isComplete = this.parseOperator(i - 1);
                if (isComplete) {
                    this.activeOperator++;
                    return i - 1;
                } else this.operators[this.activeOperator] += char;
            } else this.operators[this.activeOperator] += char;
            i++;
        }
        this.parseOperator(i - 1);
        return i;
    }
    isValid() {
        return !this.validationError && (!this.operators.length || !!this.parsedOperator);
    }
    getValidationError() {
        return this.validationError;
    }
    getFunction() {
        return this.parsedOperator === "OR" ? "||" : "&&";
    }
    getModel() {
        return this.parsedOperator === "OR" ? "OR" : "AND";
    }
    getAutocompleteListParams(position, operatorIndex) {
        let searchString;
        if (operatorIndex == null) searchString = "";
        else {
            const operator = this.operators[operatorIndex];
            const operatorEndPosition = this.operatorEndPositions[operatorIndex];
            searchString = $5b7ccabde48fae90$var$getSearchString(operator, position, operatorEndPosition == null ? this.params.expression.length : operatorEndPosition + 1);
        }
        let entries = this.params.advFilterExpSvc.getJoinOperatorAutocompleteEntries();
        if (operatorIndex || operatorIndex == null && this.activeOperator) entries = entries.filter(({ key: key })=>key === this.parsedOperator);
        return this.params.advFilterExpSvc.generateAutocompleteListParams(entries, "join", searchString);
    }
    updateExpression(position, updateEntry, operatorIndex) {
        let { expression: expression } = this.params;
        const updatedValuePart = updateEntry.displayValue ?? updateEntry.key;
        if (operatorIndex === 0) for(let i = this.operatorEndPositions.length - 1; i > 0; i--){
            const operatorEndPosition = this.operatorEndPositions[i];
            if (operatorEndPosition == null) continue;
            expression = $5b7ccabde48fae90$var$updateExpression(expression, this.operatorStartPositions[i], operatorEndPosition, updatedValuePart).updatedValue;
        }
        const startPosition = this.operatorStartPositions.length > operatorIndex ? this.operatorStartPositions[operatorIndex] : position;
        const endPosition = (this.operatorEndPositions.length > operatorIndex ? this.operatorEndPositions[operatorIndex] : void 0) ?? $5b7ccabde48fae90$var$findEndPosition(expression, position, true).endPosition;
        return $5b7ccabde48fae90$var$updateExpression(expression, startPosition, endPosition, updatedValuePart, true);
    }
    getNumOperators() {
        return this.operators.length;
    }
    getLastOperatorEndPosition() {
        return this.operatorEndPositions[this.operatorEndPositions.length - 1];
    }
    parseOperator(endPosition) {
        const operator = this.operators.length > this.activeOperator ? this.operators[this.activeOperator] : "";
        const joinOperators = this.params.advFilterExpSvc.getExpressionJoinOperators();
        const parsedValue = $5b7ccabde48fae90$var$findMatch(operator, joinOperators, (v)=>v);
        if (parsedValue) {
            this.operatorEndPositions[this.activeOperator] = endPosition;
            const displayValue = joinOperators[parsedValue];
            if (this.activeOperator) {
                if (parsedValue !== this.parsedOperator) {
                    if (!this.validationError) this.validationError = {
                        message: this.params.advFilterExpSvc.translate("advancedFilterValidationJoinOperatorMismatch"),
                        startPosition: endPosition - operator.length + 1,
                        endPosition: endPosition
                    };
                    return false;
                }
            } else this.parsedOperator = parsedValue;
            if (operator !== displayValue) {
                $5b7ccabde48fae90$var$checkAndUpdateExpression(this.params, operator, displayValue, endPosition);
                this.operators[this.activeOperator] = displayValue;
            }
            return true;
        } else if (parsedValue === null) return false;
        else {
            if (!this.validationError) this.validationError = {
                message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidJoinOperator"),
                startPosition: endPosition - operator.length + 1,
                endPosition: endPosition
            };
            return true;
        }
    }
};
var $5b7ccabde48fae90$var$JoinFilterExpressionParser = class _JoinFilterExpressionParser {
    constructor(params, startPosition){
        this.params = params;
        this.startPosition = startPosition;
        this.expectingExpression = true;
        this.expectingOperator = false;
        this.expressionParsers = [];
        this.operatorParser = new $5b7ccabde48fae90$var$OperatorParser2(this.params);
        this.missingEndBracket = false;
        this.extraEndBracket = false;
    }
    parseExpression() {
        let i = this.startPosition;
        const { expression: expression } = this.params;
        while(i < expression.length){
            const char = expression[i];
            if (char === "(" && !this.expectingOperator) {
                const nestedParser = new _JoinFilterExpressionParser(this.params, i + 1);
                i = nestedParser.parseExpression();
                this.expressionParsers.push(nestedParser);
                this.expectingExpression = false;
                this.expectingOperator = true;
            } else if (char === ")") {
                this.endPosition = i - 1;
                if (this.startPosition === 0) this.extraEndBracket = true;
                return i;
            } else if (char === " ") ;
            else if (this.expectingExpression) {
                const nestedParser = new $5b7ccabde48fae90$var$ColFilterExpressionParser(this.params, i);
                i = nestedParser.parseExpression();
                this.expressionParsers.push(nestedParser);
                this.expectingExpression = false;
                this.expectingOperator = true;
            } else if (this.expectingOperator) {
                i = this.operatorParser.parseExpression(i);
                this.expectingOperator = false;
                this.expectingExpression = true;
            }
            i++;
        }
        if (this.startPosition > 0) this.missingEndBracket = true;
        return i;
    }
    isValid() {
        return !this.missingEndBracket && !this.extraEndBracket && this.expressionParsers.length === this.operatorParser.getNumOperators() + 1 && this.operatorParser.isValid() && this.expressionParsers.every((expressionParser)=>expressionParser.isValid());
    }
    getValidationError() {
        const operatorError = this.operatorParser.getValidationError();
        for(let i = 0; i < this.expressionParsers.length; i++){
            const expressionError = this.expressionParsers[i].getValidationError();
            if (expressionError) return operatorError && operatorError.startPosition < expressionError.startPosition ? operatorError : expressionError;
        }
        if (operatorError) return operatorError;
        if (this.extraEndBracket) return {
            message: this.params.advFilterExpSvc.translate("advancedFilterValidationExtraEndBracket"),
            startPosition: this.endPosition + 1,
            endPosition: this.endPosition + 1
        };
        let translateKey;
        if (this.expressionParsers.length === this.operatorParser.getNumOperators()) translateKey = "advancedFilterValidationMissingCondition";
        else if (this.missingEndBracket) translateKey = "advancedFilterValidationMissingEndBracket";
        if (translateKey) return {
            message: this.params.advFilterExpSvc.translate(translateKey),
            startPosition: this.params.expression.length,
            endPosition: this.params.expression.length
        };
        return null;
    }
    getFunction(params) {
        const operator = this.operatorParser.getFunction();
        const funcs = this.expressionParsers.map((expressionParser)=>expressionParser.getFunction(params));
        const arrayFunc = operator === "&&" ? "every" : "some";
        return (expressionProxy, node, p)=>funcs[arrayFunc]((func)=>func(expressionProxy, node, p));
    }
    getAutocompleteListParams(position) {
        if (this.endPosition != null && position > this.endPosition + 1) return void 0;
        if (!this.expressionParsers.length) return this.getColumnAutocompleteListParams();
        const expressionParserIndex = this.getExpressionParserIndex(position);
        if (expressionParserIndex == null) {
            if (this.params.expression[position] === "(") return {
                enabled: false
            };
            return this.getColumnAutocompleteListParams();
        }
        const expressionParser = this.expressionParsers[expressionParserIndex];
        const autocompleteType = expressionParser.getAutocompleteListParams(position);
        if (!autocompleteType) {
            if (expressionParserIndex < this.expressionParsers.length - 1) return this.operatorParser.getAutocompleteListParams(position, expressionParserIndex);
            if (this.expressionParsers.length === this.operatorParser.getNumOperators()) {
                const operatorEndPosition = this.operatorParser.getLastOperatorEndPosition();
                return operatorEndPosition == null || position <= operatorEndPosition + 1 ? this.operatorParser.getAutocompleteListParams(position, this.operatorParser.getNumOperators() - 1) : this.getColumnAutocompleteListParams();
            }
            if (this.params.expression[position - 1] === ")") return {
                enabled: false
            };
            return this.operatorParser.getAutocompleteListParams(position);
        }
        return autocompleteType;
    }
    updateExpression(position, updateEntry, type) {
        const expression = this.params.expression;
        const expressionParserIndex = this.getExpressionParserIndex(position);
        if (expressionParserIndex == null) {
            const updatedValuePart = type === "column" ? this.params.advFilterExpSvc.getColumnValue(updateEntry) : updateEntry.displayValue ?? updateEntry.key;
            return $5b7ccabde48fae90$var$updateExpression(expression, this.startPosition, this.startPosition, updatedValuePart, true);
        }
        const expressionParser = this.expressionParsers[expressionParserIndex];
        const updatedExpression = expressionParser.updateExpression(position, updateEntry, type);
        if (updatedExpression == null) {
            if (type === "column") return $5b7ccabde48fae90$var$updateExpression(expression, position, expression.length - 1, this.params.advFilterExpSvc.getColumnValue(updateEntry), true);
            else if (this.endPosition != null && position > this.endPosition + 1) return null;
            else return this.operatorParser.updateExpression(position, updateEntry, expressionParserIndex);
        }
        return updatedExpression;
    }
    getModel() {
        if (this.expressionParsers.length > 1) return {
            filterType: "join",
            type: this.operatorParser.getModel(),
            conditions: this.expressionParsers.map((parser)=>parser.getModel())
        };
        else return this.expressionParsers[0].getModel();
    }
    getColumnAutocompleteListParams() {
        return this.params.advFilterExpSvc.generateAutocompleteListParams(this.params.advFilterExpSvc.getColumnAutocompleteEntries(), "column", "");
    }
    getExpressionParserIndex(position) {
        let expressionParserIndex;
        for(let i = 0; i < this.expressionParsers.length; i++){
            const expressionParserToCheck = this.expressionParsers[i];
            if (expressionParserToCheck.startPosition > position) break;
            expressionParserIndex = i;
        }
        return expressionParserIndex;
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/filterExpressionParser.ts
var $5b7ccabde48fae90$var$FilterExpressionParser = class {
    constructor(params){
        this.params = params;
        this.valid = false;
    }
    parseExpression() {
        this.joinExpressionParser = new $5b7ccabde48fae90$var$JoinFilterExpressionParser(this.params, 0);
        const i = this.joinExpressionParser.parseExpression();
        this.valid = i >= this.params.expression.length - 1 && this.joinExpressionParser.isValid();
        return this.params.expression;
    }
    isValid() {
        return this.valid;
    }
    getValidationMessage() {
        const error = this.joinExpressionParser.getValidationError();
        if (!error) return null;
        const { message: message, startPosition: startPosition, endPosition: endPosition } = error;
        return startPosition < this.params.expression.length ? this.params.advFilterExpSvc.translate("advancedFilterValidationMessage", [
            message,
            this.params.expression.slice(startPosition, endPosition + 1).trim()
        ]) : this.params.advFilterExpSvc.translate("advancedFilterValidationMessageAtEnd", [
            message
        ]);
    }
    getFunction() {
        const params = this.createFunctionParams();
        return {
            expressionFunction: this.joinExpressionParser.getFunction(params),
            params: params
        };
    }
    getAutocompleteListParams(position) {
        return this.joinExpressionParser.getAutocompleteListParams(position) ?? {
            enabled: false
        };
    }
    updateExpression(position, updateEntry, type) {
        return this.joinExpressionParser.updateExpression(position, updateEntry, type);
    }
    getModel() {
        return this.isValid() ? this.joinExpressionParser.getModel() : null;
    }
    createFunctionParams() {
        return {
            operands: [],
            operators: [],
            evaluatorParams: []
        };
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterService.ts
var $5b7ccabde48fae90$var$AdvancedFilterService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "advancedFilter";
        this.appliedExpression = null;
        /** The value displayed in the input, which may be invalid */ this.expression = null;
        this.isValid = true;
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
        this.colModel = beans.colModel;
        this.dataTypeSvc = beans.dataTypeSvc;
        this.advFilterExpSvc = beans.advFilterExpSvc;
        this.filterValueSvc = beans.filterValueSvc;
        this.filterManager = beans.filterManager;
    }
    postConstruct() {
        this.setEnabled(this.gos.get("enableAdvancedFilter"), true);
        this.ctrl = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterCtrl(this.enabled));
        this.expressionProxy = {
            getValue: (colId, node)=>{
                const column = this.colModel.getColDefCol(colId);
                return column ? this.filterValueSvc.getValue(column, node) : void 0;
            }
        };
        this.addManagedPropertyListener("enableAdvancedFilter", (event)=>this.setEnabled(!!event.currentValue));
        this.addManagedEventListeners({
            newColumnsLoaded: (event)=>this.onNewColumnsLoaded(event)
        });
        this.addManagedPropertyListener("includeHiddenColumnsInAdvancedFilter", ()=>{
            const updatedValidity = this.updateValidity();
            if (updatedValidity) this.filterManager?.onFilterChanged({
                source: "advancedFilter"
            });
        });
    }
    isEnabled() {
        return this.enabled;
    }
    isFilterPresent() {
        return !!this.expressionFunction;
    }
    doesFilterPass(node) {
        return this.expressionFunction(this.expressionProxy, node, this.expressionParams);
    }
    getModel() {
        const expressionParser = this.createExpressionParser(this.appliedExpression);
        expressionParser?.parseExpression();
        return expressionParser?.getModel() ?? null;
    }
    setModel(model) {
        const parseModel = (model2, isFirstParent)=>{
            if (model2.filterType === "join") {
                const operator = this.advFilterExpSvc.parseJoinOperator(model2);
                const expression2 = model2.conditions.map((condition)=>parseModel(condition)).filter((condition)=>(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(condition)).join(` ${operator} `);
                return isFirstParent || model2.conditions.length <= 1 ? expression2 : `(${expression2})`;
            } else return this.advFilterExpSvc.parseColumnFilterModel(model2);
        };
        const expression = model ? parseModel(model, true) : null;
        this.setExpressionDisplayValue(expression);
        this.applyExpression();
        this.ctrl.refreshComp();
        this.ctrl.refreshBuilderComp();
    }
    getExpressionDisplayValue() {
        return this.expression;
    }
    setExpressionDisplayValue(expression) {
        this.expression = expression;
    }
    isCurrentExpressionApplied() {
        return this.appliedExpression === this.expression;
    }
    createExpressionParser(expression) {
        if (!expression) return null;
        return new $5b7ccabde48fae90$var$FilterExpressionParser({
            expression: expression,
            colModel: this.colModel,
            dataTypeSvc: this.dataTypeSvc,
            valueSvc: this.valueSvc,
            advFilterExpSvc: this.advFilterExpSvc
        });
    }
    getDefaultExpression(updateEntry) {
        const updatedValue = this.advFilterExpSvc.getColumnValue(updateEntry) + " ";
        return {
            updatedValue: updatedValue,
            updatedPosition: updatedValue.length
        };
    }
    isHeaderActive() {
        return !this.gos.get("advancedFilterParent");
    }
    getCtrl() {
        return this.ctrl;
    }
    setEnabled(enabled, silent) {
        const previousValue = this.enabled;
        const isValidRowModel = (0, $437b23f6a393c3bf$export$9f182d9ca737e15)(this.gos) || (0, $437b23f6a393c3bf$export$cf1bac0013650216)(this.gos);
        if (enabled && !isValidRowModel) (0, $437b23f6a393c3bf$export$545083624300f13d)(123);
        this.enabled = enabled && isValidRowModel;
        if (!silent && this.enabled !== previousValue) this.eventSvc.dispatchEvent({
            type: "advancedFilterEnabledChanged",
            enabled: this.enabled
        });
    }
    applyExpression() {
        const expressionParser = this.createExpressionParser(this.expression);
        expressionParser?.parseExpression();
        this.applyExpressionFromParser(expressionParser);
    }
    getAppliedExpressionDisplayValue() {
        return this.appliedExpression;
    }
    applyExpressionFromParser(expressionParser) {
        this.isValid = !expressionParser || expressionParser.isValid();
        if (!expressionParser || !this.isValid) {
            this.expressionFunction = null;
            this.expressionParams = null;
            this.appliedExpression = null;
            return;
        }
        const { expressionFunction: expressionFunction, params: params } = expressionParser.getFunction();
        this.expressionFunction = expressionFunction;
        this.expressionParams = params;
        this.appliedExpression = this.expression;
    }
    updateValidity() {
        this.advFilterExpSvc.resetColumnCaches();
        const expressionParser = this.createExpressionParser(this.expression);
        expressionParser?.parseExpression();
        const isValid = !expressionParser || expressionParser.isValid();
        const updatedValidity = isValid !== this.isValid;
        this.applyExpressionFromParser(expressionParser);
        this.ctrl.refreshComp();
        this.ctrl.refreshBuilderComp();
        return updatedValidity;
    }
    onNewColumnsLoaded(event) {
        if (event.source !== "gridInitializing" || !this.dataTypeSvc?.isPendingInference) return;
        this.ctrl.setInputDisabled(true);
        const [destroyFunc] = this.addManagedEventListeners({
            dataTypesInferred: ()=>{
                destroyFunc?.();
                this.ctrl.setInputDisabled(false);
            }
        });
    }
};
// packages/ag-grid-enterprise/src/advancedFilter/advancedFilterModule.ts
var $5b7ccabde48fae90$export$5f40a5e44930bd02 = {
    moduleName: "AdvancedFilter",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$AdvancedFilterService,
        $5b7ccabde48fae90$var$AdvancedFilterExpressionService
    ],
    icons: {
        // Builder button in Advanced Filter
        advancedFilterBuilder: "group",
        // drag handle used to pick up Advanced Filter Builder rows
        advancedFilterBuilderDrag: "grip",
        // Advanced Filter Builder row validation error
        advancedFilterBuilderInvalid: "not-allowed",
        // shown on Advanced Filter Builder rows to move them up
        advancedFilterBuilderMoveUp: "up",
        // shown on Advanced Filter Builder rows to move them down
        advancedFilterBuilderMoveDown: "down",
        // shown on Advanced Filter Builder rows to add new rows
        advancedFilterBuilderAdd: "plus",
        // shown on Advanced Filter Builder rows to remove row
        advancedFilterBuilderRemove: "minus",
        // shown on Advanced Filter Builder selection pills
        advancedFilterBuilderSelectOpen: "small-down",
        // remove for rich select editor pills
        richSelectRemove: "cancel",
        // loading async values
        richSelectLoading: "loading"
    },
    apiFunctions: {
        getAdvancedFilterModel: $5b7ccabde48fae90$var$getAdvancedFilterModel,
        setAdvancedFilterModel: $5b7ccabde48fae90$var$setAdvancedFilterModel,
        showAdvancedFilterBuilder: $5b7ccabde48fae90$var$showAdvancedFilterBuilder,
        hideAdvancedFilterBuilder: $5b7ccabde48fae90$var$hideAdvancedFilterBuilder
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$b8779358eaaabc87),
        (0, $437b23f6a393c3bf$export$4ad116d131ade5b4),
        (0, $437b23f6a393c3bf$export$da5c9bb998e6c24d),
        (0, $437b23f6a393c3bf$export$55e846ac25ec4cc0),
        (0, $437b23f6a393c3bf$export$d0c662c133b8814e)
    ],
    css: [
        $5b7ccabde48fae90$var$advancedFilterCSS
    ]
};
// packages/ag-grid-enterprise/src/aiToolkit/schemaBuilder.ts
var $5b7ccabde48fae90$var$BaseSchemaBuilder = class {
    constructor(description){
        this._defs = {};
        this._nullable = false;
        this.description = description;
    }
    _collectNestedDefs(schemas) {
        const allDefs = {
            ...this._defs
        };
        for (const schema of schemas)if (schema && typeof schema === "object" && "$defs" in schema) {
            Object.assign(allDefs, schema.$defs);
            delete schema.$defs;
        }
        return allDefs;
    }
    _toJSON(additionalProperties = {}) {
        const result = {
            type: this._nullable ? [
                this.type,
                "null"
            ] : this.type,
            description: this.description,
            ...additionalProperties
        };
        if (Object.keys(this._defs).length > 0) result.$defs = this._defs;
        return result;
    }
    nullable() {
        this._nullable = true;
        return this;
    }
    define(id, schema) {
        this._defs[id] = schema;
        return this;
    }
};
var $5b7ccabde48fae90$var$StringSchemaBuilder = class extends $5b7ccabde48fae90$var$BaseSchemaBuilder {
    constructor(descriptionOrOptions){
        super(typeof descriptionOrOptions === "string" ? descriptionOrOptions : descriptionOrOptions?.description);
        this.type = "string";
        if (typeof descriptionOrOptions === "object" && descriptionOrOptions) {
            this._pattern = descriptionOrOptions.pattern;
            this._format = descriptionOrOptions.format;
        }
    }
    pattern(input) {
        this._pattern = input;
        return this;
    }
    format(input) {
        this._format = input;
        return this;
    }
    toJSON() {
        return this._toJSON({
            pattern: this._pattern,
            format: this._format
        });
    }
};
var $5b7ccabde48fae90$var$NumberSchemaBuilder = class extends $5b7ccabde48fae90$var$BaseSchemaBuilder {
    constructor(descriptionOrOptions){
        super(typeof descriptionOrOptions === "string" ? descriptionOrOptions : descriptionOrOptions?.description);
        this.type = "number";
        if (typeof descriptionOrOptions === "object" && descriptionOrOptions) {
            this._minimum = descriptionOrOptions.minimum;
            this._maximum = descriptionOrOptions.maximum;
            this._exclusiveMinimum = descriptionOrOptions.exclusiveMinimum;
            this._exclusiveMaximum = descriptionOrOptions.exclusiveMaximum;
            this._multipleOf = descriptionOrOptions.multipleOf;
        }
    }
    minimum(value) {
        this._minimum = value;
        return this;
    }
    exclusiveMinimum(value) {
        this._exclusiveMinimum = value;
        return this;
    }
    maximum(value) {
        this._maximum = value;
        return this;
    }
    exclusiveMaximum(value) {
        this._exclusiveMaximum = value;
        return this;
    }
    multipleOf(value) {
        this._multipleOf = value;
        return this;
    }
    toJSON() {
        return this._toJSON({
            minimum: this._minimum,
            exclusiveMinimum: this._exclusiveMinimum,
            maximum: this._maximum,
            exclusiveMaximum: this._exclusiveMaximum,
            multipleOf: this._multipleOf
        });
    }
};
var $5b7ccabde48fae90$var$EnumSchemaBuilder = class extends $5b7ccabde48fae90$var$BaseSchemaBuilder {
    constructor(_enum, description){
        super(description);
        this._enum = _enum;
        this.type = "string";
    }
    toJSON() {
        return this._toJSON({
            enum: this._enum
        });
    }
};
var $5b7ccabde48fae90$var$LiteralSchemaBuilder = class extends $5b7ccabde48fae90$var$EnumSchemaBuilder {
    constructor(value, description){
        super([
            value
        ], description);
    }
};
var $5b7ccabde48fae90$var$BooleanSchemaBuilder = class extends $5b7ccabde48fae90$var$BaseSchemaBuilder {
    constructor(description){
        super(description);
        this.type = "boolean";
    }
    toJSON() {
        return this._toJSON();
    }
};
var $5b7ccabde48fae90$var$ArraySchemaBuilder = class extends $5b7ccabde48fae90$var$BaseSchemaBuilder {
    constructor(items, descriptionOrOptions){
        super(typeof descriptionOrOptions === "string" ? descriptionOrOptions : descriptionOrOptions?.description);
        this.items = items;
        this.type = "array";
        if (typeof descriptionOrOptions === "object" && descriptionOrOptions) {
            this._minItems = descriptionOrOptions.minItems;
            this._maxItems = descriptionOrOptions.maxItems;
        }
    }
    minItems(value) {
        this._minItems = value;
        return this;
    }
    maxItems(value) {
        this._maxItems = value;
        return this;
    }
    toJSON() {
        const itemsSchema = this.items.toJSON();
        const allDefs = this._collectNestedDefs([
            itemsSchema
        ]);
        this._defs = allDefs;
        return this._toJSON({
            items: itemsSchema,
            minItems: this._minItems,
            maxItems: this._maxItems
        });
    }
};
var $5b7ccabde48fae90$var$ObjectSchemaBuilder = class extends $5b7ccabde48fae90$var$BaseSchemaBuilder {
    constructor(properties, description){
        super(description);
        this.properties = properties;
        this.type = "object";
    }
    toJSON() {
        const propertySchemas = Object.fromEntries(Object.keys(this.properties).map((key)=>[
                key,
                this.properties[key].toJSON()
            ]));
        const allDefs = this._collectNestedDefs(Object.values(propertySchemas));
        this._defs = allDefs;
        return this._toJSON({
            required: Object.keys(this.properties),
            additionalProperties: false,
            properties: propertySchemas
        });
    }
};
var $5b7ccabde48fae90$var$UnionSchemaBuilder = class {
    constructor(schemas, description){
        this.schemas = schemas;
        this._nullable = false;
        this._defs = {};
        this.description = description;
    }
    nullable() {
        this._nullable = true;
        return this;
    }
    define(id, schema) {
        this._defs[id] = schema;
        return this;
    }
    _collectNestedDefs(schemas) {
        const allDefs = this._defs;
        for (const schema of schemas)if (schema && typeof schema === "object" && "$defs" in schema) {
            Object.assign(allDefs, schema.$defs);
            delete schema.$defs;
        }
        return allDefs;
    }
    toJSON() {
        const schemaJsons = this.schemas.map((x)=>x.toJSON());
        const allDefs = this._collectNestedDefs(schemaJsons);
        const result = {
            anyOf: this._nullable ? [
                ...schemaJsons,
                {
                    type: "null"
                }
            ] : schemaJsons
        };
        if (this.description) result.description = this.description;
        if (Object.keys(allDefs).length > 0) result.$defs = allDefs;
        return result;
    }
};
var $5b7ccabde48fae90$var$ReferenceSchemaBuilder = class {
    constructor(id){
        this.id = id;
    }
    nullable() {
        return this;
    }
    toJSON() {
        return {
            $ref: `#/$defs/${this.id}`
        };
    }
};
var $5b7ccabde48fae90$var$s = {
    string: (descriptionOrOptions)=>new $5b7ccabde48fae90$var$StringSchemaBuilder(descriptionOrOptions),
    number: (descriptionOrOptions)=>new $5b7ccabde48fae90$var$NumberSchemaBuilder(descriptionOrOptions),
    enum: (values, description)=>new $5b7ccabde48fae90$var$EnumSchemaBuilder(values, description),
    boolean: (description)=>new $5b7ccabde48fae90$var$BooleanSchemaBuilder(description),
    array: (items, descriptionOrOptions)=>new $5b7ccabde48fae90$var$ArraySchemaBuilder(items, descriptionOrOptions),
    object: (properties, description)=>new $5b7ccabde48fae90$var$ObjectSchemaBuilder(properties, description),
    union: (schemas, description)=>new $5b7ccabde48fae90$var$UnionSchemaBuilder(schemas, description),
    literal: (value, description)=>new $5b7ccabde48fae90$var$LiteralSchemaBuilder(value, description),
    ref: (id)=>new $5b7ccabde48fae90$var$ReferenceSchemaBuilder(id)
};
// packages/ag-grid-enterprise/src/aiToolkit/features/aggregationFeatureSchema.ts
var $5b7ccabde48fae90$var$buildAggregationFeatureSchema = (beans)=>{
    const { aggFuncSvc: aggFuncSvc } = beans;
    if (!aggFuncSvc) return;
    const columns = beans.colModel.getCols();
    const aggregatableColumns = columns.filter((col)=>col.isAllowValue() && aggFuncSvc.getFuncNames(col).length > 0);
    if (aggregatableColumns.length === 0) return;
    return $5b7ccabde48fae90$var$s.object({
        aggregationModel: $5b7ccabde48fae90$var$s.array($5b7ccabde48fae90$var$s.union(aggregatableColumns.map((col)=>$5b7ccabde48fae90$var$s.object({
                colId: $5b7ccabde48fae90$var$s.literal(col.getColId(), "Column identifier"),
                aggFunc: $5b7ccabde48fae90$var$s.enum(beans.aggFuncSvc?.getFuncNames(col) || [], "Aggregation function")
            }))), "Array of column aggregations")
    }, "Aggregation configuration for the grid").nullable();
};
// packages/ag-grid-enterprise/src/aiToolkit/features/columnSizingFeatureSchema.ts
var $5b7ccabde48fae90$var$buildColumnSizingFeatureSchema = (beans)=>{
    const columns = beans.colModel.getCols();
    const resizableColumns = columns.filter((col)=>col.isResizable());
    if (resizableColumns.length === 0) return;
    const resizableColumnIds = resizableColumns.map((col)=>col.getColId());
    return $5b7ccabde48fae90$var$s.object({
        columnSizingModel: $5b7ccabde48fae90$var$s.array($5b7ccabde48fae90$var$s.union([
            $5b7ccabde48fae90$var$s.object({
                colId: $5b7ccabde48fae90$var$s.ref("resizableColumnId"),
                width: $5b7ccabde48fae90$var$s.number("Fixed width in pixels").minimum(20)
            }),
            $5b7ccabde48fae90$var$s.object({
                colId: $5b7ccabde48fae90$var$s.ref("resizableColumnId"),
                flex: $5b7ccabde48fae90$var$s.number("Flex sizing ratio").minimum(0)
            })
        ]), "Array of column sizing configurations")
    }, "Column sizing configuration for the grid").define("resizableColumnId", $5b7ccabde48fae90$var$s.enum(resizableColumnIds, "Column ID that supports resizing"));
};
// packages/ag-grid-enterprise/src/aiToolkit/features/columnVisibilityFeatureSchema.ts
var $5b7ccabde48fae90$var$buildColumnVisibilityFeatureSchema = ()=>{
    return $5b7ccabde48fae90$var$s.object({
        hiddenColIds: $5b7ccabde48fae90$var$s.array($5b7ccabde48fae90$var$s.ref("allColumnIds"), "Array of column IDs to hide")
    }, "Column visibility configuration for the grid").nullable();
};
// packages/ag-grid-enterprise/src/aiToolkit/features/advancedFilterFeatureSchema.ts
var $5b7ccabde48fae90$var$buildAdvancedFilterFeatureSchema = ({ colModel: colModel, dataTypeSvc: dataTypeSvc })=>{
    if (!dataTypeSvc) return;
    const columns = colModel.getCols();
    const dataTypes = {
        boolean: [],
        object: [],
        date: [],
        dateString: [],
        dateTime: [],
        dateTimeString: [],
        number: [],
        text: []
    };
    for (const col of columns){
        const dataType = dataTypeSvc.getBaseDataType(col);
        if (dataType) dataTypes[dataType].push(col.colId);
    }
    const columnFilterModels = [];
    const defs = {};
    for (const key of Object.keys(dataTypes))if (dataTypes[key].length > 0) {
        const ref = `${key}AdvancedFilterModel`;
        const builder = $5b7ccabde48fae90$var$DataTypeSchemaBuilders[key];
        defs[ref] = builder(dataTypes[key]);
        columnFilterModels.push({
            $ref: `#/$defs/${ref}`
        });
    }
    defs.joinAdvancedFilterModel = $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("join", "Filter type identifier for joining multiple advanced filter conditions"),
        type: $5b7ccabde48fae90$var$s.enum([
            "AND",
            "OR"
        ], "Logical operator to combine multiple advanced filter conditions"),
        conditions: $5b7ccabde48fae90$var$s.array($5b7ccabde48fae90$var$s.ref("advancedFilterModel"), "Array of advanced filter conditions to be combined")
    });
    defs.advancedFilterModel = {
        anyOf: [
            ...columnFilterModels,
            {
                $ref: "#/$defs/joinAdvancedFilterModel"
            }
        ]
    };
    return $5b7ccabde48fae90$var$s.object({
        advancedFilterModel: $5b7ccabde48fae90$var$s.ref("advancedFilterModel")
    }, "Advanced filter configuration for the grid").nullable();
};
var $5b7ccabde48fae90$var$buildBooleanFilterSchema = (colIds)=>{
    return $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("boolean", "Filter type identifier for boolean column filters"),
        colId: $5b7ccabde48fae90$var$s.enum(colIds, "Column identifier for the boolean column to filter"),
        type: $5b7ccabde48fae90$var$s.enum([
            "true",
            "false"
        ], "Boolean value to filter by")
    });
};
var $5b7ccabde48fae90$var$buildObjectFilterSchema = (colIds)=>{
    return $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("object", "Filter type identifier for object column filters"),
        colId: $5b7ccabde48fae90$var$s.enum(colIds, "Column identifier for the object column to filter"),
        filter: $5b7ccabde48fae90$var$s.string("Filter value to compare against object column values").nullable(),
        type: $5b7ccabde48fae90$var$s.enum([
            "equals",
            "notEqual",
            "contains",
            "notContains",
            "startsWith",
            "endsWith",
            "blank",
            "notBlank"
        ], "Object filter operation type")
    });
};
var $5b7ccabde48fae90$var$buildDateFilterSchema = (colIds)=>{
    return $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("date", "Filter type identifier for date column filters"),
        colId: $5b7ccabde48fae90$var$s.enum(colIds, "Column identifier for the date column to filter"),
        filter: $5b7ccabde48fae90$var$s.string({
            pattern: "^\\d{4}-\\d{2}-\\d{2}$",
            description: "Date value in YYYY-MM-DD format"
        }).nullable(),
        type: $5b7ccabde48fae90$var$s.enum([
            "equals",
            "notEqual",
            "lessThan",
            "lessThanOrEqual",
            "greaterThan",
            "greaterThanOrEqual",
            "blank",
            "notBlank"
        ], "Date filter operation type")
    });
};
var $5b7ccabde48fae90$var$buildDateStringFilterSchema = (colIds)=>{
    return $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("date", "Filter type identifier for date string column filters"),
        colId: $5b7ccabde48fae90$var$s.enum(colIds, "Column identifier for the date string column to filter"),
        filter: $5b7ccabde48fae90$var$s.string({
            pattern: "^\\d{4}-\\d{2}-\\d{2}$",
            description: "Date value in YYYY-MM-DD format"
        }).nullable(),
        type: $5b7ccabde48fae90$var$s.enum([
            "equals",
            "notEqual",
            "lessThan",
            "lessThanOrEqual",
            "greaterThan",
            "greaterThanOrEqual",
            "blank",
            "notBlank"
        ], "Date string filter operation type")
    });
};
var $5b7ccabde48fae90$var$buildDateTimeFilterSchema = (colIds)=>{
    return $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("dateTime", "Filter type identifier for datetime column filters"),
        colId: $5b7ccabde48fae90$var$s.enum(colIds, "Column identifier for the datetime column to filter"),
        filter: $5b7ccabde48fae90$var$s.string({
            pattern: "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}$",
            description: "DateTime value in YYYY-MM-DDTHH:mm:ss format"
        }).nullable(),
        type: $5b7ccabde48fae90$var$s.enum([
            "equals",
            "notEqual",
            "lessThan",
            "lessThanOrEqual",
            "greaterThan",
            "greaterThanOrEqual",
            "blank",
            "notBlank"
        ], "DateTime filter operation type")
    });
};
var $5b7ccabde48fae90$var$buildDateTimeStringFilterSchema = (colIds)=>{
    return $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("dateTimeString", "Filter type identifier for datetime string column filters"),
        colId: $5b7ccabde48fae90$var$s.enum(colIds, "Column identifier for the datetime string column to filter"),
        filter: $5b7ccabde48fae90$var$s.string({
            pattern: "^\\d{4}-\\d{2}-\\d{2} \\d{2}:\\d{2}:\\d{2}$",
            description: "DateTime value in YYYY-MM-DD HH:mm:ss format"
        }).nullable(),
        type: $5b7ccabde48fae90$var$s.enum([
            "equals",
            "notEqual",
            "lessThan",
            "lessThanOrEqual",
            "greaterThan",
            "greaterThanOrEqual",
            "blank",
            "notBlank"
        ], "DateTime string filter operation type")
    });
};
var $5b7ccabde48fae90$var$buildNumberFilterSchema = (colIds)=>{
    return $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("number", "Filter type identifier for number column filters"),
        colId: $5b7ccabde48fae90$var$s.enum(colIds, "Column identifier for the number column to filter"),
        filter: $5b7ccabde48fae90$var$s.number("Numeric value to filter by").nullable(),
        type: $5b7ccabde48fae90$var$s.enum([
            "equals",
            "notEqual",
            "lessThan",
            "lessThanOrEqual",
            "greaterThan",
            "greaterThanOrEqual",
            "blank",
            "notBlank"
        ], "Number filter operation type")
    });
};
var $5b7ccabde48fae90$var$buildTextFilterSchema = (colIds)=>{
    return $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("text", "Filter type identifier for text column filters"),
        colId: $5b7ccabde48fae90$var$s.enum(colIds, "Column identifier for the text column to filter"),
        filter: $5b7ccabde48fae90$var$s.string("Text value to filter by").nullable(),
        type: $5b7ccabde48fae90$var$s.enum([
            "equals",
            "notEqual",
            "contains",
            "notContains",
            "startsWith",
            "endsWith",
            "blank",
            "notBlank"
        ], "Text filter operation type")
    });
};
var $5b7ccabde48fae90$var$DataTypeSchemaBuilders = {
    boolean: $5b7ccabde48fae90$var$buildBooleanFilterSchema,
    object: $5b7ccabde48fae90$var$buildObjectFilterSchema,
    date: $5b7ccabde48fae90$var$buildDateFilterSchema,
    dateString: $5b7ccabde48fae90$var$buildDateStringFilterSchema,
    dateTime: $5b7ccabde48fae90$var$buildDateTimeFilterSchema,
    dateTimeString: $5b7ccabde48fae90$var$buildDateTimeStringFilterSchema,
    number: $5b7ccabde48fae90$var$buildNumberFilterSchema,
    text: $5b7ccabde48fae90$var$buildTextFilterSchema
};
// packages/ag-grid-enterprise/src/aiToolkit/features/filterFeatureSchema.ts
var $5b7ccabde48fae90$var$TextFilterKey = "agTextColumnFilter";
var $5b7ccabde48fae90$var$NumberFilterKey = "agNumberColumnFilter";
var $5b7ccabde48fae90$var$DateFilterKey = "agDateColumnFilter";
var $5b7ccabde48fae90$var$SetFilterKey = "agSetColumnFilter";
var $5b7ccabde48fae90$var$MultiFilterKey = "agMultiColumnFilter";
var $5b7ccabde48fae90$var$SimpleFilterKeys = [
    $5b7ccabde48fae90$var$TextFilterKey,
    $5b7ccabde48fae90$var$NumberFilterKey,
    $5b7ccabde48fae90$var$DateFilterKey
];
var $5b7ccabde48fae90$var$buildFilterFeatureSchema = (beans, params)=>{
    const { advancedFilter: advancedFilter } = beans;
    if (advancedFilter?.isEnabled()) return $5b7ccabde48fae90$var$buildAdvancedFilterFeatureSchema(beans);
    else return $5b7ccabde48fae90$var$buildColumnFilterFeatureSchema(beans, params);
};
var $5b7ccabde48fae90$var$buildColumnFilterFeatureSchema = (beans, params)=>{
    const { gos: gos, colFilter: colFilter, colModel: colModel } = beans;
    if (!colFilter) return;
    const columns = colModel.getCols();
    const filterableColumns = columns.filter((col)=>col.isFilterAllowed());
    if (filterableColumns.length === 0) return;
    const filterSchemas = {};
    const enableFilterHandlers = gos.get("enableFilterHandlers");
    for (const column of filterableColumns){
        const columnParams = params?.columns ? params.columns[column.getColId()] : void 0;
        const colDef = column.getColDef();
        const defaultFilter = colFilter.getDefaultFilter(column);
        const includeSetValues = columnParams?.includeSetValues ?? false;
        const filter = $5b7ccabde48fae90$var$buildColumnFilterSchema(colDef.filter, colDef.filterParams, defaultFilter, (isMulti = false, multiIndex = 0)=>{
            if (!includeSetValues) return [];
            let handler = void 0;
            if (!isMulti) handler = colFilter.getHandler(column, true);
            else if (enableFilterHandlers) {
                const multiHandler = colFilter.getHandler(column, true);
                handler = multiHandler.getHandler(multiIndex);
            }
            if (!handler) return [];
            return handler.getFilterKeys();
        });
        if (filter) filterSchemas[column.colId] = filter.nullable();
    }
    return $5b7ccabde48fae90$var$s.object({
        filterModel: $5b7ccabde48fae90$var$s.object(filterSchemas)
    }).nullable();
};
function $5b7ccabde48fae90$var$buildColumnFilterSchema(filter, filterParams, defaultFilter, getKeys) {
    let filterKey = void 0;
    if (typeof filter === "string") filterKey = filter;
    else if (typeof filter === "object" && typeof filter.component === "string") filterKey = filter.component;
    else if (filter === true || typeof filter === "object" && filter.component === true) filterKey = defaultFilter;
    if (!filterKey) return null;
    if ($5b7ccabde48fae90$var$SimpleFilterKeys.includes(filterKey)) {
        const maxConditions = filterParams?.maxNumConditions;
        const filterOptions = filterParams?.filterOptions ? filterParams.filterOptions.map((option)=>{
            if (typeof option === "string") return option;
            if (typeof option === "object" && option.displayKey) return option.displayKey;
            return null;
        }).filter(Boolean) : void 0;
        const useIsoSeparator = filterParams?.useIsoSeparator || false;
        return $5b7ccabde48fae90$var$buildSimpleFilterSchema(filterKey, {
            maxConditions: maxConditions,
            filterOptions: filterOptions,
            useIsoSeparator: useIsoSeparator
        });
    } else if (filterKey === $5b7ccabde48fae90$var$SetFilterKey) return $5b7ccabde48fae90$var$buildSetFilterSchema(getKeys);
    else if (filterKey === $5b7ccabde48fae90$var$MultiFilterKey) return $5b7ccabde48fae90$var$buildMultiFilterSchema(filterParams.filters, defaultFilter, getKeys);
    return null;
}
var $5b7ccabde48fae90$var$buildSimpleFilterSchema = (filterKey, params)=>{
    if (filterKey === $5b7ccabde48fae90$var$DateFilterKey) return $5b7ccabde48fae90$var$buildDateFilterSchema2(params);
    else if (filterKey === $5b7ccabde48fae90$var$NumberFilterKey) return $5b7ccabde48fae90$var$buildNumberFilterSchema2(params);
    else return $5b7ccabde48fae90$var$buildTextFilterSchema2(params);
};
var $5b7ccabde48fae90$var$buildJoinSchema = (schema, filterType, maxConditions = 2)=>{
    if (maxConditions === 1) return schema;
    return $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal(filterType, `Filter type identifier for ${filterType} filters with multiple conditions`),
        operator: $5b7ccabde48fae90$var$s.enum([
            "AND",
            "OR"
        ], "Logical operator to combine multiple filter conditions. Must be included even with a single filter to adhere to the API."),
        conditions: $5b7ccabde48fae90$var$s.array(schema, "Array of filter conditions to be combined").minItems(2).maxItems(maxConditions)
    });
};
var $5b7ccabde48fae90$var$buildTextFilterSchema2 = (params)=>{
    const options = params.filterOptions ?? [
        "contains",
        "notContains",
        "equals",
        "notEqual",
        "startsWith",
        "endsWith",
        "blank",
        "notBlank"
    ];
    const schema = $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("text", "Filter type identifier for text filters"),
        type: $5b7ccabde48fae90$var$s.enum(options, "Text filter operation type"),
        filter: $5b7ccabde48fae90$var$s.string("Primary filter value").nullable(),
        filterTo: $5b7ccabde48fae90$var$s.string("Secondary filter value for range operations").nullable()
    });
    return $5b7ccabde48fae90$var$buildJoinSchema(schema, "text", params.maxConditions);
};
var $5b7ccabde48fae90$var$buildNumberFilterSchema2 = (params)=>{
    const options = params.filterOptions ?? [
        "equals",
        "notEqual",
        "greaterThan",
        "greaterThanOrEqual",
        "lessThan",
        "lessThanOrEqual",
        "inRange",
        "blank",
        "notBlank"
    ];
    const schema = $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("number", "Filter type identifier for number filters"),
        type: $5b7ccabde48fae90$var$s.enum(options, "Number filter operation type"),
        filter: $5b7ccabde48fae90$var$s.number("Primary filter value").nullable(),
        filterTo: $5b7ccabde48fae90$var$s.number("Secondary filter value for range operations").nullable()
    });
    return $5b7ccabde48fae90$var$buildJoinSchema(schema, "number", params.maxConditions);
};
var $5b7ccabde48fae90$var$buildDateFilterSchema2 = (params)=>{
    const options = params.filterOptions ?? [
        "equals",
        "notEqual",
        "lessThan",
        "greaterThan",
        "inRange",
        "blank",
        "notBlank"
    ];
    const pattern = params.useIsoSeparator ? "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}$" : "^\\d{4}-\\d{2}-\\d{2} \\d{2}:\\d{2}:\\d{2}$";
    const schema = $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("date", "Filter type identifier for date filters"),
        type: $5b7ccabde48fae90$var$s.enum(options, "Date filter operation type"),
        dateFrom: $5b7ccabde48fae90$var$s.string({
            pattern: pattern,
            description: "Primary date filter value in YYYY-MM-DD HH:mm:ss format"
        }).nullable(),
        dateTo: $5b7ccabde48fae90$var$s.string({
            pattern: pattern,
            description: "Secondary date filter value for range operations in YYYY-MM-DD HH:mm:ss format"
        }).nullable()
    });
    return $5b7ccabde48fae90$var$buildJoinSchema(schema, "date", params.maxConditions);
};
var $5b7ccabde48fae90$var$buildSetFilterSchema = (getKeys)=>{
    const values = getKeys ? getKeys().filter(Boolean) : [];
    return $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("set", "Filter type identifier for set filters"),
        values: $5b7ccabde48fae90$var$s.array(values.length > 0 ? $5b7ccabde48fae90$var$s.enum(values, "Available values to filter by") : $5b7ccabde48fae90$var$s.string("Filter values"), "Array of values to include in the filter")
    });
};
var $5b7ccabde48fae90$var$buildMultiFilterSchema = (filters, defaultFilter, getKeys = ()=>[])=>{
    return $5b7ccabde48fae90$var$s.object({
        filterType: $5b7ccabde48fae90$var$s.literal("multi", "Filter type identifier for multi-condition filters"),
        filterModels: $5b7ccabde48fae90$var$s.array($5b7ccabde48fae90$var$s.union(filters.map((filter, index)=>$5b7ccabde48fae90$var$buildColumnFilterSchema(filter.filter, filter.filterParams, defaultFilter, ()=>getKeys(true, index))), "Union of different filter types that can be combined").nullable(), "Array of filter conditions to be combined with AND/OR logic")
    });
};
// packages/ag-grid-enterprise/src/aiToolkit/features/pivotFeatureSchema.ts
var $5b7ccabde48fae90$var$buildPivotFeatureSchema = (beans)=>{
    const columns = beans.colModel.getCols();
    const pivotableColumnIds = columns.filter((col)=>col.isAllowPivot()).map((col)=>col.getColId());
    if (pivotableColumnIds.length === 0) return;
    return $5b7ccabde48fae90$var$s.object({
        pivotMode: $5b7ccabde48fae90$var$s.boolean("Whether pivot mode is enabled"),
        pivotColIds: $5b7ccabde48fae90$var$s.array($5b7ccabde48fae90$var$s.enum(pivotableColumnIds, "Column ID that supports pivoting"), "Array of column IDs to use as pivot columns")
    }, "Pivot configuration for the grid").nullable();
};
// packages/ag-grid-enterprise/src/aiToolkit/features/rowGroupFeatureSchema.ts
var $5b7ccabde48fae90$var$buildRowGroupFeatureSchema = (beans)=>{
    const columns = beans.colModel.getCols();
    const groupableColumns = columns.filter((col)=>col.isAllowRowGroup());
    if (groupableColumns.length === 0) return;
    const groupableColumnIds = groupableColumns.map((col)=>col.getColId());
    return $5b7ccabde48fae90$var$s.object({
        groupColIds: $5b7ccabde48fae90$var$s.array($5b7ccabde48fae90$var$s.enum(groupableColumnIds, "Column ID that supports row grouping"), "Array of column IDs to group by")
    }, "Row grouping configuration for the grid");
};
// packages/ag-grid-enterprise/src/aiToolkit/features/sortFeatureSchema.ts
var $5b7ccabde48fae90$var$buildSortFeatureSchema = (beans)=>{
    const { sortSvc: sortSvc } = beans;
    if (!sortSvc) return;
    const columns = beans.colModel.getCols();
    const sortableColumns = columns.filter((col)=>col.isSortable());
    if (sortableColumns.length === 0) return;
    const sortableColumnIds = sortableColumns.map((col)=>col.getColId());
    return $5b7ccabde48fae90$var$s.object({
        sortModel: $5b7ccabde48fae90$var$s.array($5b7ccabde48fae90$var$s.object({
            colId: $5b7ccabde48fae90$var$s.enum(sortableColumnIds, "Column ID that supports sorting"),
            sort: $5b7ccabde48fae90$var$s.enum([
                "asc",
                "desc"
            ], "Sort direction: ascending or descending"),
            type: $5b7ccabde48fae90$var$s.enum([
                "default",
                "absolute"
            ], "Sort type: default or absolute values")
        }), "Array of sort configurations")
    }, "Sort configuration for the grid").nullable();
};
// packages/ag-grid-enterprise/src/aiToolkit/structuredSchema.ts
var $5b7ccabde48fae90$var$StructuredSchemaBuilderMap = {
    aggregation: $5b7ccabde48fae90$var$buildAggregationFeatureSchema,
    filter: $5b7ccabde48fae90$var$buildFilterFeatureSchema,
    sort: $5b7ccabde48fae90$var$buildSortFeatureSchema,
    pivot: $5b7ccabde48fae90$var$buildPivotFeatureSchema,
    columnVisibility: $5b7ccabde48fae90$var$buildColumnVisibilityFeatureSchema,
    columnSizing: $5b7ccabde48fae90$var$buildColumnSizingFeatureSchema,
    rowGroup: $5b7ccabde48fae90$var$buildRowGroupFeatureSchema
};
function $5b7ccabde48fae90$var$getStructuredSchema(beans, params) {
    const allColumnIds = beans.colModel.getCols().map((col)=>col.getColId());
    const features = {};
    for (const feature of (0, $437b23f6a393c3bf$export$e85ca1dd7f3d099e)){
        if (params?.exclude?.includes(feature)) continue;
        const builder = $5b7ccabde48fae90$var$StructuredSchemaBuilderMap[feature];
        const schema2 = builder(beans, params);
        if (schema2) features[feature] = schema2.nullable();
    }
    const columnParams = params?.columns ?? {};
    const descriptions = allColumnIds.map((colId)=>{
        if (columnParams[colId]?.description) return `${colId}: ${columnParams[colId].description}`;
        else return colId;
    }).filter(Boolean).join("\n");
    const schema = $5b7ccabde48fae90$var$s.object(features).define("allColumnIds", $5b7ccabde48fae90$var$s.enum(allColumnIds, descriptions));
    return schema.toJSON();
}
// packages/ag-grid-enterprise/src/aiToolkit/aiToolkitModule.ts
var $5b7ccabde48fae90$export$8e5f38fcc2e9340c = {
    moduleName: "AiToolkit",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [],
    dependsOn: [
        (0, $437b23f6a393c3bf$export$5c4abee658e86c68)
    ],
    apiFunctions: {
        getStructuredSchema: $5b7ccabde48fae90$var$getStructuredSchema
    }
};
function $5b7ccabde48fae90$var$isSideBarVisible(beans) {
    return beans.sideBar?.comp.isDisplayed() ?? false;
}
function $5b7ccabde48fae90$var$setSideBarVisible(beans, show) {
    beans.sideBar?.comp.setDisplayed(show);
}
function $5b7ccabde48fae90$var$setSideBarPosition(beans, position) {
    beans.sideBar?.comp.setSideBarPosition(position);
}
function $5b7ccabde48fae90$var$openToolPanel(beans, key, parent) {
    beans.sideBar?.comp.openToolPanel(key, "api", parent);
}
function $5b7ccabde48fae90$var$closeToolPanel(beans) {
    beans.sideBar?.comp.close("api");
}
function $5b7ccabde48fae90$var$getOpenedToolPanel(beans) {
    return beans.sideBar?.comp.openedItem() ?? null;
}
function $5b7ccabde48fae90$var$refreshToolPanel(beans) {
    beans.sideBar?.comp.refresh();
}
function $5b7ccabde48fae90$var$isToolPanelShowing(beans) {
    return beans.sideBar?.comp.isToolPanelShowing() ?? false;
}
function $5b7ccabde48fae90$var$getToolPanelInstance(beans, id) {
    const comp = beans.sideBar?.comp.getToolPanelInstance(id);
    return (0, $437b23f6a393c3bf$export$213d4c63c3df47e4)(comp);
}
function $5b7ccabde48fae90$var$getSideBar(beans) {
    return beans.sideBar?.comp.getDef();
}
// packages/ag-grid-enterprise/src/sideBar/agSideBar.css-GENERATED.ts
var $5b7ccabde48fae90$var$agSideBarCSS = /*css*/ `.ag-tool-panel-wrapper{display:flex;overflow:hidden auto;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-side-bar-panel-width)}.ag-tool-panel-external{display:flex;flex-direction:row}:where(.ag-tool-panel-external) .ag-tool-panel-wrapper{flex-grow:1}.ag-select-agg-func-item{align-items:center;display:flex;flex:1 1 auto;flex-flow:row nowrap;height:100%;overflow:hidden;position:relative;text-overflow:ellipsis;white-space:nowrap;>*{flex:none}}.ag-tool-panel-horizontal-resize{cursor:ew-resize;height:100%;position:absolute;top:0;width:5px;z-index:1}.ag-side-bar{background-color:var(--ag-side-bar-background-color);display:flex;flex-direction:row-reverse;position:relative}:where(.ag-ltr) :where(.ag-side-bar-left) .ag-tool-panel-horizontal-resize{right:-3px}:where(.ag-rtl) :where(.ag-side-bar-left) .ag-tool-panel-horizontal-resize{left:-3px}:where(.ag-ltr) :where(.ag-side-bar-right) .ag-tool-panel-horizontal-resize{left:-3px}:where(.ag-rtl) :where(.ag-side-bar-right) .ag-tool-panel-horizontal-resize{right:-3px}.ag-side-bar-left{flex-direction:row;order:-1}.ag-side-buttons{background-color:var(--ag-side-button-bar-background-color);padding-top:var(--ag-side-button-bar-top-padding);position:relative}.ag-side-button{background-color:var(--ag-side-button-background-color);border-bottom:var(--ag-side-button-border);border-top:var(--ag-side-button-border);color:var(--ag-side-button-text-color);margin-top:-1px;position:relative;&:before{background-color:transparent;bottom:0;content:"";display:block;position:absolute;top:0;transition:background-color var(--ag-side-button-selected-underline-transition-duration);width:var(--ag-side-button-selected-underline-width)}&:hover{background-color:var(--ag-side-button-hover-background-color);color:var(--ag-side-button-hover-text-color)}&.ag-selected{background-color:var(--ag-side-button-selected-background-color);border-bottom:var(--ag-side-button-selected-border);border-top:var(--ag-side-button-selected-border);color:var(--ag-side-button-selected-text-color);&:before{background-color:var(--ag-side-button-selected-underline-color)}}}:where(.ag-ltr) .ag-side-button{&:before{left:0}}:where(.ag-rtl) .ag-side-button{&:before{right:0}}.ag-side-button-button{align-items:center;display:flex;flex-direction:column;gap:var(--ag-spacing);position:relative;white-space:nowrap;width:100%;&:focus{box-shadow:none}}:where(.ag-ltr) .ag-side-button-button{padding:var(--ag-side-button-vertical-padding) var(--ag-side-button-right-padding) var(--ag-side-button-vertical-padding) var(--ag-side-button-left-padding)}:where(.ag-rtl) .ag-side-button-button{padding:var(--ag-side-button-vertical-padding) var(--ag-side-button-left-padding) var(--ag-side-button-vertical-padding) var(--ag-side-button-right-padding)}.ag-side-button-button:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-side-button-label{writing-mode:vertical-lr}@media (resolution <= 1.5x){.ag-side-button-label{font-family:"Segoe UI",var(--ag-font-family)}:where(.ag-ltr) .ag-side-button-label{transform:rotate(.05deg)}:where(.ag-rtl) .ag-side-button-label{transform:rotate(-.05deg)}}:where(.ag-ltr) .ag-side-bar-left,:where(.ag-rtl) .ag-side-bar-right{border-right:var(--ag-side-panel-border);:where(.ag-tool-panel-wrapper){border-left:var(--ag-side-panel-border)}}:where(.ag-ltr) .ag-side-bar-right,:where(.ag-rtl) .ag-side-bar-left{border-left:var(--ag-side-panel-border);:where(.ag-tool-panel-wrapper){border-right:var(--ag-side-panel-border)}}`;
var $5b7ccabde48fae90$var$SideBarButtonElement = {
    tag: "div",
    cls: "ag-side-button",
    role: "presentation",
    children: [
        {
            tag: "button",
            ref: "eToggleButton",
            cls: "ag-button ag-side-button-button",
            role: "tab",
            attrs: {
                type: "button",
                tabindex: "-1",
                "aria-expanded": "false"
            },
            children: [
                {
                    tag: "div",
                    ref: "eIconWrapper",
                    cls: "ag-side-button-icon-wrapper",
                    attrs: {
                        "aria-hidden": "true"
                    }
                },
                {
                    tag: "span",
                    ref: "eLabel",
                    cls: "ag-side-button-label"
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$SideBarButtonComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(toolPanelDef){
        super();
        this.toolPanelDef = toolPanelDef;
        this.eToggleButton = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eIconWrapper = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eLabel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    getToolPanelId() {
        return this.toolPanelDef.id;
    }
    postConstruct() {
        this.setTemplate($5b7ccabde48fae90$var$SideBarButtonElement, []);
        this.setLabel();
        this.setIcon();
        this.addManagedElementListeners(this.eToggleButton, {
            click: this.onButtonPressed.bind(this)
        });
        this.eToggleButton.setAttribute("id", `ag-${this.getCompId()}-button`);
    }
    setLabel() {
        const def = this.toolPanelDef;
        const label = this.getLocaleTextFunc()(def.labelKey, def.labelDefault);
        this.eLabel.textContent = label;
    }
    setIcon() {
        this.eIconWrapper.insertAdjacentElement("afterbegin", (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(this.toolPanelDef.iconKey, this.beans));
    }
    onButtonPressed() {
        this.dispatchLocalEvent({
            type: "toggleButtonClicked"
        });
    }
    setSelected(selected) {
        this.toggleCss("ag-selected", selected);
        (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(this.eToggleButton, selected);
    }
};
// packages/ag-grid-enterprise/src/sideBar/agSideBarButtons.ts
var $5b7ccabde48fae90$var$SideBarElement = {
    tag: "div",
    cls: "ag-side-buttons",
    role: "tablist"
};
var $5b7ccabde48fae90$var$AgSideBarButtons = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$SideBarElement);
        this.buttonComps = [];
    }
    postConstruct() {
        this.addManagedElementListeners(this.getFocusableElement(), {
            keydown: this.handleKeyDown.bind(this)
        });
    }
    handleKeyDown(e) {
        if (e.key !== (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).TAB || !e.shiftKey) return;
        if ((0, $437b23f6a393c3bf$export$987f3c95dc941f0c)(this.beans, true)) {
            e.preventDefault();
            return;
        }
        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(e);
    }
    setActiveButton(id) {
        for (const comp of this.buttonComps)comp.setSelected(id === comp.getToolPanelId());
    }
    addButtonComp(def) {
        const buttonComp = this.createBean(new $5b7ccabde48fae90$var$SideBarButtonComp(def));
        this.buttonComps.push(buttonComp);
        this.appendChild(buttonComp);
        buttonComp.addEventListener("toggleButtonClicked", ()=>{
            this.dispatchLocalEvent({
                type: "sideBarButtonClicked",
                toolPanelId: def.id
            });
        });
        return buttonComp;
    }
    clearButtons() {
        this.buttonComps = this.destroyBeans(this.buttonComps);
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.getGui());
    }
    destroy() {
        this.clearButtons();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$AgSideBarButtonsSelector = {
    selector: "AG-SIDE-BAR-BUTTONS",
    component: $5b7ccabde48fae90$var$AgSideBarButtons
};
var $5b7ccabde48fae90$var$DEFAULT_COLUMN_COMP = {
    id: "columns",
    labelDefault: "Columns",
    labelKey: "columns",
    iconKey: "columnsToolPanel",
    toolPanel: "agColumnsToolPanel"
};
var $5b7ccabde48fae90$var$DEFAULT_FILTER_COMP = {
    id: "filters",
    labelDefault: "Filters",
    labelKey: "filters",
    iconKey: "filtersToolPanel",
    toolPanel: "agFiltersToolPanel"
};
var $5b7ccabde48fae90$var$DEFAULT_NEW_FILTER_COMP = {
    id: "filters-new",
    labelDefault: "Filters",
    labelKey: "filters",
    iconKey: "filtersToolPanel",
    toolPanel: "agNewFiltersToolPanel"
};
var $5b7ccabde48fae90$var$DEFAULT_BY_KEY = {
    columns: $5b7ccabde48fae90$var$DEFAULT_COLUMN_COMP,
    filters: $5b7ccabde48fae90$var$DEFAULT_FILTER_COMP,
    "filters-new": $5b7ccabde48fae90$var$DEFAULT_NEW_FILTER_COMP
};
function $5b7ccabde48fae90$var$parseSideBarDef(toParse) {
    if (!toParse) return void 0;
    if (toParse === true) return {
        toolPanels: [
            $5b7ccabde48fae90$var$DEFAULT_COLUMN_COMP,
            $5b7ccabde48fae90$var$DEFAULT_FILTER_COMP
        ],
        defaultToolPanel: "columns"
    };
    if (typeof toParse === "string") return $5b7ccabde48fae90$var$parseSideBarDef([
        toParse
    ]);
    if (Array.isArray(toParse)) {
        const comps = [];
        for (const key of toParse){
            const lookupResult = $5b7ccabde48fae90$var$DEFAULT_BY_KEY[key];
            if (!lookupResult) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(215, {
                    key: key,
                    defaultByKey: $5b7ccabde48fae90$var$DEFAULT_BY_KEY
                });
                continue;
            }
            comps.push(lookupResult);
        }
        if (comps.length === 0) return void 0;
        return {
            toolPanels: comps,
            defaultToolPanel: comps[0].id
        };
    }
    return {
        toolPanels: $5b7ccabde48fae90$var$parseComponents(toParse.toolPanels),
        defaultToolPanel: toParse.defaultToolPanel,
        hiddenByDefault: toParse.hiddenByDefault,
        position: toParse.position,
        hideButtons: toParse.hideButtons
    };
}
function $5b7ccabde48fae90$var$parseComponents(from) {
    const result = [];
    if (!from) return result;
    from.forEach((it)=>{
        const parsed = $5b7ccabde48fae90$var$parseOneComponent(it);
        if (!parsed) return;
        result.push(parsed);
    });
    return result;
}
function $5b7ccabde48fae90$var$parseOneComponent(it) {
    if (typeof it !== "string") return it;
    if ($5b7ccabde48fae90$var$DEFAULT_BY_KEY[it]) return $5b7ccabde48fae90$var$DEFAULT_BY_KEY[it];
    (0, $437b23f6a393c3bf$export$545083624300f13d)(215, {
        key: it,
        defaultByKey: $5b7ccabde48fae90$var$DEFAULT_BY_KEY
    });
    return null;
}
var $5b7ccabde48fae90$var$AgHorizontalResize = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-tool-panel-horizontal-resize"
        });
        this.minWidth = 100;
        this.maxWidth = null;
    }
    postConstruct() {
        const finishedWithResizeFunc = this.beans.horizontalResizeSvc.addResizeBar({
            eResizeBar: this.getGui(),
            dragStartPixels: 1,
            onResizeStart: this.onResizeStart.bind(this),
            onResizing: this.onResizing.bind(this),
            onResizeEnd: this.onResizeEnd.bind(this)
        });
        this.addDestroyFunc(finishedWithResizeFunc);
        this.inverted = this.gos.get("enableRtl");
    }
    dispatchResizeEvent(start, end, width) {
        this.eventSvc.dispatchEvent({
            type: "toolPanelSizeChanged",
            width: width,
            started: start,
            ended: end
        });
    }
    onResizeStart() {
        this.startingWidth = this.elementToResize.offsetWidth;
        this.dispatchResizeEvent(true, false, this.startingWidth);
    }
    onResizeEnd(delta) {
        return this.onResizing(delta, true);
    }
    onResizing(delta, isEnd = false) {
        const direction = this.inverted ? -1 : 1;
        let newWidth = Math.max(this.minWidth, Math.floor(this.startingWidth - delta * direction));
        if (this.maxWidth != null) newWidth = Math.min(this.maxWidth, newWidth);
        this.elementToResize.style.width = `${newWidth}px`;
        this.dispatchResizeEvent(false, isEnd, newWidth);
    }
};
// packages/ag-grid-enterprise/src/sideBar/toolPanelWrapper.ts
function $5b7ccabde48fae90$var$getToolPanelCompDetails(userCompFactory, toolPanelDef, params) {
    return userCompFactory.getCompDetails(toolPanelDef, $5b7ccabde48fae90$var$ToolPanelComponent, void 0, params, true);
}
var $5b7ccabde48fae90$var$ToolPanelComponent = {
    name: "toolPanel",
    optionalMethods: [
        "refresh",
        "getState"
    ]
};
var $5b7ccabde48fae90$var$ToolPanelElement = {
    tag: "div",
    cls: "ag-tool-panel-wrapper",
    role: "tabpanel"
};
var $5b7ccabde48fae90$var$ToolPanelWrapper = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$ToolPanelElement);
    }
    postConstruct() {
        const eGui = this.getGui();
        const resizeBar = this.resizeBar = this.createManagedBean(new $5b7ccabde48fae90$var$AgHorizontalResize());
        eGui.setAttribute("id", `ag-${this.getCompId()}`);
        resizeBar.elementToResize = eGui;
        this.appendChild(resizeBar);
    }
    getToolPanelId() {
        return this.toolPanelId;
    }
    setToolPanelDef(toolPanelDef, params) {
        const { id: id, minWidth: minWidth, maxWidth: maxWidth, width: width } = toolPanelDef;
        this.toolPanelId = id;
        this.width = width;
        const compDetails = $5b7ccabde48fae90$var$getToolPanelCompDetails(this.beans.userCompFactory, toolPanelDef, params);
        if (compDetails == null) return false;
        const componentPromise = compDetails.newAgStackInstance();
        this.params = compDetails.params;
        componentPromise.then(this.setToolPanelComponent.bind(this));
        const resizeBar = this.resizeBar;
        if (minWidth != null) resizeBar.minWidth = minWidth;
        if (maxWidth != null) resizeBar.maxWidth = maxWidth;
        return true;
    }
    setToolPanelComponent(compInstance) {
        this.toolPanelCompInstance = compInstance;
        this.appendChild(compInstance.getGui());
        this.addDestroyFunc(()=>{
            this.destroyBean(compInstance);
        });
        const width = this.width;
        if (width) this.getGui().style.width = `${width}px`;
    }
    getToolPanelInstance() {
        return this.toolPanelCompInstance;
    }
    setResizerSizerSide(side) {
        const isRtl = this.gos.get("enableRtl");
        const isLeft = side === "left";
        const inverted = isRtl ? isLeft : !isLeft;
        this.resizeBar.inverted = inverted;
    }
    refresh() {
        this.toolPanelCompInstance?.refresh(this.params);
    }
};
// packages/ag-grid-enterprise/src/sideBar/agSideBar.ts
var $5b7ccabde48fae90$var$AgSideBarElement = {
    tag: "div",
    cls: "ag-side-bar ag-unselectable",
    children: [
        {
            tag: "ag-side-bar-buttons",
            ref: "sideBarButtons"
        }
    ]
};
var $5b7ccabde48fae90$var$AgSideBar = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$AgSideBarElement, [
            $5b7ccabde48fae90$var$AgSideBarButtonsSelector
        ]);
        this.sideBarButtons = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.toolPanelWrappers = [];
        this.registerCSS($5b7ccabde48fae90$var$agSideBarCSS);
    }
    postConstruct() {
        this.sideBarButtons.addEventListener("sideBarButtonClicked", this.onToolPanelButtonClicked.bind(this));
        const { beans: beans, gos: gos } = this;
        const { sideBar: sideBarState } = gos.get("initialState") ?? {};
        this.setSideBarDef({
            sideBarDef: $5b7ccabde48fae90$var$parseSideBarDef(gos.get("sideBar")),
            sideBarState: sideBarState
        });
        this.addManagedPropertyListener("sideBar", ()=>this.setState());
        beans.sideBar.comp = this;
        const eGui = this.getFocusableElement();
        this.createManagedBean(new (0, $437b23f6a393c3bf$export$5510e53ed3962582)(eGui, {
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this)
        }));
        (0, $437b23f6a393c3bf$export$8865b8c867776648)(beans, this, eGui);
        this.addManagedPropertyListener("enableAdvancedFilter", this.onAdvancedFilterChanged.bind(this));
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        const { beans: beans, sideBarButtons: sideBarButtons } = this;
        const eGui = this.getGui();
        const sideBarGui = sideBarButtons.getGui();
        const activeElement = (0, $437b23f6a393c3bf$export$16bc98d422315038)(beans);
        const openPanel = eGui.querySelector(".ag-tool-panel-wrapper:not(.ag-hidden)");
        const target = e.target;
        const backwards = e.shiftKey;
        if (!openPanel) {
            if ((0, $437b23f6a393c3bf$export$987f3c95dc941f0c)(beans, backwards)) {
                e.preventDefault();
                return true;
            }
            return (0, $437b23f6a393c3bf$export$987f3c95dc941f0c)(beans, backwards, true);
        }
        if (sideBarGui.contains(activeElement)) {
            if ((0, $437b23f6a393c3bf$export$8598088d375f416f)(openPanel, backwards)) e.preventDefault();
            return;
        }
        if (!backwards) return;
        let nextEl = null;
        if (openPanel.contains(activeElement)) nextEl = (0, $437b23f6a393c3bf$export$83fc12531358bd28)(beans, openPanel, void 0, true);
        else if ($5b7ccabde48fae90$var$isTargetUnderManagedComponent(openPanel, target)) nextEl = $5b7ccabde48fae90$var$findFocusableElementBeforeTabGuard(openPanel, target);
        if (!nextEl) {
            nextEl = sideBarGui.querySelector(".ag-selected button");
            nextEl = (0, $437b23f6a393c3bf$export$2badf4aa566524cb)(nextEl) ? nextEl : null;
        }
        if (nextEl && nextEl !== e.target) {
            e.preventDefault();
            nextEl.focus();
        }
    }
    handleKeyDown(e) {
        const currentButton = (0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans);
        const sideBarButtons = this.sideBarButtons;
        if (!sideBarButtons.getGui().contains(currentButton)) return;
        const sideBarGui = sideBarButtons.getGui();
        const buttons = Array.prototype.slice.call(sideBarGui.querySelectorAll(".ag-side-button"));
        const currentPos = buttons.findIndex((button)=>button.contains(currentButton));
        let nextPos = null;
        switch(e.key){
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP:
                nextPos = Math.max(0, currentPos - 1);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT:
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN:
                nextPos = Math.min(currentPos + 1, buttons.length - 1);
                break;
        }
        if (nextPos === null) return;
        const innerButton = buttons[nextPos].querySelector("button");
        if (innerButton) {
            innerButton.focus();
            e.preventDefault();
        }
    }
    onToolPanelButtonClicked(event) {
        const id = event.toolPanelId;
        const openedItem = this.openedItem();
        if (openedItem === id) this.openToolPanel(void 0, "sideBarButtonClicked");
        else this.openToolPanel(id, "sideBarButtonClicked");
    }
    clearDownUi() {
        this.sideBarButtons.clearButtons();
        this.destroyToolPanelWrappers();
    }
    setSideBarDef({ sideBarDef: sideBarDef, sideBarState: sideBarState, existingToolPanelWrappers: existingToolPanelWrappers }) {
        this.setDisplayed(false);
        this.sideBar = sideBarDef;
        if (sideBarDef) this.sideBarButtons.setDisplayed(!sideBarDef.hideButtons);
        if (sideBarDef?.toolPanels) {
            const toolPanelDefs = sideBarDef.toolPanels;
            this.createToolPanelsAndSideButtons(toolPanelDefs, sideBarState, existingToolPanelWrappers);
            if (!this.toolPanelWrappers.length) return;
            const shouldDisplaySideBar = sideBarState ? sideBarState.visible : !sideBarDef.hiddenByDefault;
            this.setDisplayed(shouldDisplaySideBar);
            this.setSideBarPosition(sideBarState ? sideBarState.position : sideBarDef.position);
            if (shouldDisplaySideBar) {
                if (sideBarState) {
                    const { openToolPanel: openToolPanel2 } = sideBarState;
                    if (openToolPanel2) this.openToolPanel(openToolPanel2, "sideBarInitializing");
                } else this.openToolPanel(sideBarDef.defaultToolPanel, "sideBarInitializing");
            }
        }
    }
    getDef() {
        return this.sideBar;
    }
    setSideBarPosition(position) {
        if (!position) position = "right";
        this.position = position;
        const isLeft = position === "left";
        const resizerSide = isLeft ? "right" : "left";
        this.toggleCss("ag-side-bar-left", isLeft);
        this.toggleCss("ag-side-bar-right", !isLeft);
        for (const wrapper of this.toolPanelWrappers)wrapper.setResizerSizerSide(resizerSide);
        this.dispatchSideBarUpdated();
        return this;
    }
    setDisplayed(displayed, options) {
        super.setDisplayed(displayed, options);
        this.dispatchSideBarUpdated();
    }
    getState() {
        const toolPanels = {};
        for (const wrapper of this.toolPanelWrappers)toolPanels[wrapper.getToolPanelId()] = wrapper.getToolPanelInstance()?.getState?.();
        return {
            visible: this.isDisplayed(),
            position: this.position,
            openToolPanel: this.openedItem(),
            toolPanels: toolPanels
        };
    }
    createToolPanelsAndSideButtons(defs, sideBarState, existingToolPanelWrappers) {
        for (const def of defs)this.createToolPanelAndSideButton(def, sideBarState?.toolPanels?.[def.id], existingToolPanelWrappers?.[def.id]);
    }
    validateDef(def) {
        const { id: id, toolPanel: toolPanel } = def;
        if (id == null) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(212);
            return false;
        }
        if ($5b7ccabde48fae90$var$isFilterPanel(toolPanel)) {
            if (this.beans.filterManager?.isAdvFilterEnabled()) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(213);
                return false;
            }
        }
        return true;
    }
    createToolPanelAndSideButton(def, initialState, existingToolPanelWrapper) {
        if (!this.validateDef(def)) {
            this.destroyBean(existingToolPanelWrapper);
            return;
        }
        let wrapper;
        if (existingToolPanelWrapper) wrapper = existingToolPanelWrapper;
        else {
            wrapper = this.createBean(new $5b7ccabde48fae90$var$ToolPanelWrapper());
            const created = wrapper.setToolPanelDef(def, (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
                initialState: initialState,
                onStateUpdated: ()=>this.dispatchSideBarUpdated()
            }));
            if (!created) return;
        }
        wrapper.setDisplayed(false);
        const wrapperGui = wrapper.getGui();
        const parent = def.parent instanceof HTMLElement ? def.parent : this;
        if (parent === def.parent) {
            this.beans.environment.applyThemeClasses(parent, [
                "ag-external",
                "ag-tool-panel-external"
            ]);
            wrapperGui.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
        }
        parent.appendChild(wrapperGui);
        this.toolPanelWrappers.push(wrapper);
        const button = this.sideBarButtons.addButtonComp(def);
        (0, $437b23f6a393c3bf$export$6ff31a4a210c60ad)(button.eToggleButton, wrapperGui);
    }
    refresh() {
        for (const wrapper of this.toolPanelWrappers)wrapper.refresh();
    }
    renderToolPanelUnderParent(key, parent) {
        const selfDefOrStr = this.sideBar?.toolPanels?.find((tp)=>(typeof tp === "string" ? tp : tp.id) === key);
        if (selfDefOrStr) {
            const panelDef = $5b7ccabde48fae90$var$parseOneComponent(selfDefOrStr);
            if (panelDef) {
                const state = this.gos.get("initialState")?.sideBar?.toolPanels?.[panelDef.id];
                panelDef.parent = parent;
                const wrapper = this.toolPanelWrappers.find((wrapper2)=>wrapper2.getToolPanelId() === key);
                this.createToolPanelAndSideButton(panelDef, state, wrapper);
            }
        }
    }
    openToolPanel(key, source = "api", parent) {
        if (parent && key) this.renderToolPanelUnderParent(key, parent);
        const currentlyOpenedKey = this.openedItem();
        if (currentlyOpenedKey === key) return;
        for (const wrapper of this.toolPanelWrappers){
            const show = key === wrapper.getToolPanelId();
            wrapper.setDisplayed(show);
        }
        const newlyOpenedKey = this.openedItem();
        const openToolPanelChanged = currentlyOpenedKey !== newlyOpenedKey;
        if (openToolPanelChanged) {
            this.sideBarButtons.setActiveButton(key);
            this.raiseToolPanelVisibleEvent(key, currentlyOpenedKey ?? void 0, source);
        }
    }
    getToolPanelInstance(key) {
        const toolPanelWrapper = this.toolPanelWrappers.filter((toolPanel)=>toolPanel.getToolPanelId() === key)[0];
        if (!toolPanelWrapper) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(214, {
                key: key
            });
            return;
        }
        return toolPanelWrapper.getToolPanelInstance();
    }
    raiseToolPanelVisibleEvent(key, previousKey, source) {
        const switchingToolPanel = !!key && !!previousKey;
        const eventSvc = this.eventSvc;
        if (previousKey) eventSvc.dispatchEvent({
            type: "toolPanelVisibleChanged",
            source: source,
            key: previousKey,
            visible: false,
            switchingToolPanel: switchingToolPanel
        });
        if (key) eventSvc.dispatchEvent({
            type: "toolPanelVisibleChanged",
            source: source,
            key: key,
            visible: true,
            switchingToolPanel: switchingToolPanel
        });
    }
    close(source = "api") {
        this.openToolPanel(void 0, source);
    }
    isToolPanelShowing() {
        return !!this.openedItem();
    }
    openedItem() {
        let activeToolPanel = null;
        for (const wrapper of this.toolPanelWrappers)if (wrapper.isDisplayed()) activeToolPanel = wrapper.getToolPanelId();
        return activeToolPanel;
    }
    setState(sideBarState) {
        const sideBarDef = $5b7ccabde48fae90$var$parseSideBarDef(this.gos.get("sideBar"));
        const existingToolPanelWrappers = {};
        if (sideBarDef && this.sideBar) sideBarDef.toolPanels?.forEach((toolPanelDef)=>{
            const { id: id } = toolPanelDef;
            if (!id) return;
            const existingToolPanelDef = this.sideBar.toolPanels?.find((toolPanelDefToCheck)=>toolPanelDefToCheck.id === id);
            if (!existingToolPanelDef || toolPanelDef.toolPanel !== existingToolPanelDef.toolPanel) return;
            const toolPanelWrapper = this.toolPanelWrappers.find((toolPanel)=>toolPanel.getToolPanelId() === id);
            if (!toolPanelWrapper) return;
            const params = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
                ...toolPanelDef.toolPanelParams ?? {},
                initialState: sideBarState?.toolPanels?.[id],
                onStateUpdated: ()=>this.dispatchSideBarUpdated()
            });
            const hasRefreshed = toolPanelWrapper.getToolPanelInstance()?.refresh(params);
            if (hasRefreshed !== true) return;
            this.toolPanelWrappers = this.toolPanelWrappers.filter((toolPanel)=>toolPanel !== toolPanelWrapper);
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(toolPanelWrapper.getGui());
            existingToolPanelWrappers[id] = toolPanelWrapper;
        });
        this.clearDownUi();
        this.setSideBarDef({
            sideBarDef: sideBarDef,
            sideBarState: sideBarState,
            existingToolPanelWrappers: existingToolPanelWrappers
        });
    }
    dispatchSideBarUpdated() {
        this.eventSvc.dispatchEvent({
            type: "sideBarUpdated"
        });
    }
    destroyToolPanelWrappers() {
        for (const wrapper of this.toolPanelWrappers){
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(wrapper.getGui());
            this.destroyBean(wrapper);
        }
        this.toolPanelWrappers.length = 0;
    }
    onAdvancedFilterChanged() {
        const needsRefresh = this.sideBar?.toolPanels?.some((toolPanel)=>$5b7ccabde48fae90$var$isFilterPanel(typeof toolPanel === "string" ? toolPanel : toolPanel.toolPanel));
        if (needsRefresh) this.setState();
    }
    destroy() {
        this.destroyToolPanelWrappers();
        super.destroy();
    }
};
function $5b7ccabde48fae90$var$isFilterPanel(toolPanel) {
    return toolPanel === "agFiltersToolPanel" || toolPanel === "agNewFiltersToolPanel";
}
var $5b7ccabde48fae90$var$AgSideBarSelector = {
    selector: "AG-SIDE-BAR",
    component: $5b7ccabde48fae90$var$AgSideBar
};
// packages/ag-grid-enterprise/src/sideBar/sideBarService.ts
var $5b7ccabde48fae90$var$SideBarService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "sideBar";
    }
    getSelector() {
        return $5b7ccabde48fae90$var$AgSideBarSelector;
    }
};
// packages/ag-grid-enterprise/src/sideBar/sideBarModule.ts
var $5b7ccabde48fae90$export$707a9bd30915b7fe = {
    moduleName: "SideBar",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$SideBarService
    ],
    apiFunctions: {
        isSideBarVisible: $5b7ccabde48fae90$var$isSideBarVisible,
        setSideBarVisible: $5b7ccabde48fae90$var$setSideBarVisible,
        setSideBarPosition: $5b7ccabde48fae90$var$setSideBarPosition,
        openToolPanel: $5b7ccabde48fae90$var$openToolPanel,
        closeToolPanel: $5b7ccabde48fae90$var$closeToolPanel,
        getOpenedToolPanel: $5b7ccabde48fae90$var$getOpenedToolPanel,
        refreshToolPanel: $5b7ccabde48fae90$var$refreshToolPanel,
        isToolPanelShowing: $5b7ccabde48fae90$var$isToolPanelShowing,
        getToolPanelInstance: $5b7ccabde48fae90$var$getToolPanelInstance,
        getSideBar: $5b7ccabde48fae90$var$getSideBar
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$57b5b4ab4a8a663e)
    ]
};
// packages/ag-grid-enterprise/src/widgets/menu.css-GENERATED.ts
var $5b7ccabde48fae90$var$menuCSS = /*css*/ `.ag-menu-list{cursor:default;display:table;padding:var(--ag-spacing) 0;width:100%}.ag-menu-option,.ag-menu-separator{display:table-row}.ag-menu-option-part,.ag-menu-separator-part{display:table-cell;vertical-align:middle}.ag-menu-option{cursor:pointer;font-weight:500}:where(.ag-ltr) :where(.ag-menu-option-popup-pointer) .ag-icon{text-align:right}:where(.ag-rtl) :where(.ag-menu-option-popup-pointer) .ag-icon{text-align:left}.ag-menu-option-text{white-space:nowrap}.ag-menu-option-custom{display:contents}.ag-compact-menu-option{display:flex;flex-wrap:nowrap;width:100%}.ag-compact-menu-option-text{flex:1 1 auto;white-space:nowrap}.ag-menu-separator{height:calc(var(--ag-spacing)*2 + 1px)}.ag-menu-separator-part:after{border-top:solid var(--ag-border-width) var(--ag-menu-separator-color);content:"";display:block}.ag-compact-menu-option-active,.ag-menu-option-active{background-color:var(--ag-row-hover-color)}.ag-compact-menu-option-part,.ag-menu-option-part{line-height:var(--ag-icon-size);padding:calc(var(--ag-spacing) + 2px) 0}.ag-compact-menu-option-disabled,.ag-menu-option-disabled{cursor:not-allowed;opacity:.5}.ag-compact-menu-option-icon,.ag-menu-option-icon{width:var(--ag-icon-size)}:where(.ag-ltr) .ag-compact-menu-option-icon,:where(.ag-ltr) .ag-menu-option-icon{padding-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-compact-menu-option-icon,:where(.ag-rtl) .ag-menu-option-icon{padding-right:calc(var(--ag-spacing)*2)}.ag-compact-menu-option-text,.ag-menu-option-text{padding-left:calc(var(--ag-spacing)*2);padding-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-compact-menu-option-shortcut,:where(.ag-ltr) .ag-menu-option-shortcut{padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-compact-menu-option-shortcut,:where(.ag-rtl) .ag-menu-option-shortcut{padding-left:var(--ag-spacing)}:where(.ag-ltr) .ag-compact-menu-option-popup-pointer,:where(.ag-ltr) .ag-menu-option-popup-pointer{padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-compact-menu-option-popup-pointer,:where(.ag-rtl) .ag-menu-option-popup-pointer{padding-left:var(--ag-spacing)}.ag-menu-column-select-wrapper{height:265px;overflow:auto;:where(.ag-column-select){height:100%}}.ag-menu:where(.ag-tabs){min-width:290px}.ag-context-menu-loading-icon{pointer-events:none;position:absolute}`;
var $5b7ccabde48fae90$var$MenuItemRenderer = class extends $5b7ccabde48fae90$export$3de9fa9f64b2f09d {
    constructor(){
        super({
            warnNoIcon: ()=>(0, $437b23f6a393c3bf$export$545083624300f13d)(227)
        });
    }
};
// packages/ag-grid-enterprise/src/widgets/menuItemModule.ts
var $5b7ccabde48fae90$var$MenuItemModule = {
    moduleName: "MenuItem",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agMenuItem: $5b7ccabde48fae90$var$MenuItemRenderer
    },
    icons: {
        // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
        check: "tick",
        // icon for sub menu item
        subMenuOpen: "small-right",
        // version of subMenuOpen used in RTL mode
        subMenuOpenRtl: "small-left"
    },
    css: [
        $5b7ccabde48fae90$var$menuCSS
    ]
};
// packages/ag-grid-enterprise/src/columnToolPanel/agPrimaryCols.css-GENERATED.ts
var $5b7ccabde48fae90$var$agPrimaryColsCSS = /*css*/ `.ag-column-select{display:flex;flex:3 1 0px;flex-direction:column;overflow:hidden;position:relative}.ag-column-select-header{align-items:center;display:flex;flex:none;gap:var(--ag-widget-horizontal-spacing);height:var(--ag-header-height);padding-left:var(--ag-widget-container-horizontal-padding);padding-right:var(--ag-widget-container-horizontal-padding);position:relative}.ag-column-select-column,.ag-column-select-column-group{align-items:center;display:flex;gap:var(--ag-widget-horizontal-spacing);height:100%;position:relative;&:where(:not(:last-child)){margin-bottom:var(--ag-widget-vertical-spacing)}}:where(.ag-ltr) .ag-column-select-column,:where(.ag-ltr) .ag-column-select-column-group{padding-left:calc(var(--ag-indentation-level)*var(--ag-column-select-indent-size))}:where(.ag-rtl) .ag-column-select-column,:where(.ag-rtl) .ag-column-select-column-group{padding-right:calc(var(--ag-indentation-level)*var(--ag-column-select-indent-size))}.ag-column-select-header-icon{border-radius:var(--ag-border-radius);cursor:pointer;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);&:focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-column-select-header-filter-wrapper{flex:1 1 auto}.ag-column-select-header-filter{width:100%}.ag-column-select-list{flex:1 1 0px;overflow:hidden}:where(.ag-ltr) .ag-column-select-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-spacing)*1.5)}:where(.ag-rtl) .ag-column-select-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-spacing)*1.5)}.ag-column-select-column-group-readonly,.ag-column-select-column-readonly{opacity:.5;pointer-events:none;.ag-icon{opacity:.5}&.ag-icon-grip{opacity:.35}}.ag-column-select-column-readonly{&.ag-icon-grip,.ag-icon-grip{opacity:.35}}.ag-column-select-virtual-list-viewport{padding:calc(var(--ag-widget-container-vertical-padding)*.5) 0}.ag-column-select-virtual-list-item{padding:0 var(--ag-widget-container-horizontal-padding)}.ag-column-select-column-label{flex:1 1 auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-select-checkbox{display:flex}`;
var $5b7ccabde48fae90$var$DEBOUNCE_DELAY = 300;
var $5b7ccabde48fae90$var$AgPrimaryColsHeaderElement = {
    tag: "div",
    cls: "ag-column-select-header",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eExpand",
            cls: "ag-column-select-header-icon"
        },
        {
            tag: "ag-checkbox",
            ref: "eSelect",
            cls: "ag-column-select-header-checkbox"
        },
        {
            tag: "ag-input-text-field",
            ref: "eFilterTextField",
            cls: "ag-column-select-header-filter-wrapper"
        }
    ]
};
var $5b7ccabde48fae90$var$AgPrimaryColsHeader = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$AgPrimaryColsHeaderElement, [
            (0, $437b23f6a393c3bf$export$2e2c317d2e31f2ca),
            (0, $437b23f6a393c3bf$export$31e2985be4ee06ab)
        ]);
        this.eExpand = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eSelect = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eFilterTextField = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        this.createExpandIcons();
        this.addManagedListeners(this.eExpand, {
            click: this.onExpandClicked.bind(this),
            keydown: (e)=>{
                if (e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE) {
                    e.preventDefault();
                    this.onExpandClicked();
                }
            }
        });
        this.addManagedElementListeners(this.eSelect.getInputElement(), {
            click: this.onSelectClicked.bind(this)
        });
        this.addManagedPropertyListener("functionsReadOnly", ()=>this.onFunctionsReadOnlyPropChanged());
        this.eFilterTextField.setAutoComplete(false).onValueChange(()=>this.onFilterTextChanged());
        this.addManagedEventListeners({
            newColumnsLoaded: this.showOrHideOptions.bind(this)
        });
        const translate = this.getLocaleTextFunc();
        this.eSelect.setInputAriaLabel(translate("ariaColumnSelectAll", "Toggle All Columns Visibility"));
        this.eFilterTextField.setInputAriaLabel(translate("ariaFilterColumnsInput", "Filter Columns Input"));
        this.activateTabIndex([
            this.eExpand
        ]);
    }
    onFunctionsReadOnlyPropChanged() {
        const readOnly = this.gos.get("functionsReadOnly");
        this.eSelect.setReadOnly(readOnly);
        this.eSelect.toggleCss("ag-column-select-column-readonly", readOnly);
    }
    init(params) {
        this.params = params;
        const readOnly = this.gos.get("functionsReadOnly");
        this.eSelect.setReadOnly(readOnly);
        this.eSelect.toggleCss("ag-column-select-column-readonly", readOnly);
        if (this.beans.colModel.ready) this.showOrHideOptions();
    }
    createExpandIcons() {
        const beans = this.beans;
        this.eExpand.appendChild(this.eExpandChecked = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("columnSelectOpen", beans));
        this.eExpand.appendChild(this.eExpandUnchecked = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("columnSelectClosed", beans));
        this.eExpand.appendChild(this.eExpandIndeterminate = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("columnSelectIndeterminate", beans));
        this.setExpandState(0 /* EXPANDED */ );
    }
    // we only show expand / collapse if we are showing columns
    showOrHideOptions() {
        const params = this.params;
        const showFilter = !params.suppressColumnFilter;
        const showSelect = !params.suppressColumnSelectAll;
        const showExpand = !params.suppressColumnExpandAll;
        const groupsPresent = !!this.beans.colModel.colDefCols?.treeDepth;
        const translate = this.getLocaleTextFunc();
        this.eFilterTextField.setInputPlaceholder(translate("searchOoo", "Search..."));
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eFilterTextField.getGui(), showFilter);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eSelect.getGui(), showSelect);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpand, showExpand && groupsPresent);
    }
    onFilterTextChanged() {
        if (!this.onFilterTextChangedDebounced) this.onFilterTextChangedDebounced = (0, $437b23f6a393c3bf$export$cf7e39bfb94de6e)(this, ()=>{
            const filterText = this.eFilterTextField.getValue();
            this.dispatchLocalEvent({
                type: "filterChanged",
                filterText: filterText
            });
        }, $5b7ccabde48fae90$var$DEBOUNCE_DELAY);
        this.onFilterTextChangedDebounced();
    }
    onSelectClicked() {
        this.dispatchLocalEvent({
            type: this.selectState ? "unselectAll" : "selectAll"
        });
    }
    onExpandClicked() {
        this.dispatchLocalEvent({
            type: this.expandState === 0 /* EXPANDED */  ? "collapseAll" : "expandAll"
        });
    }
    setExpandState(state) {
        this.expandState = state;
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpandChecked, state === 0 /* EXPANDED */ );
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpandUnchecked, state === 1 /* COLLAPSED */ );
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpandIndeterminate, state === 2 /* INDETERMINATE */ );
    }
    setSelectionState(state) {
        this.selectState = state;
        this.eSelect.setValue(this.selectState);
    }
};
var $5b7ccabde48fae90$var$AgPrimaryColsHeaderSelector = {
    selector: "AG-PRIMARY-COLS-HEADER",
    component: $5b7ccabde48fae90$var$AgPrimaryColsHeader
};
function $5b7ccabde48fae90$var$isColGroupDef(colDef) {
    return !!colDef && typeof colDef.children !== "undefined";
}
function $5b7ccabde48fae90$var$getId(colDef) {
    return $5b7ccabde48fae90$var$isColGroupDef(colDef) ? colDef.groupId : colDef.colId;
}
function $5b7ccabde48fae90$var$addChildrenToGroup(tree, groupId, colDef) {
    const subGroupIsSplit = (currentSubGroup, currentSubGroupToAdd)=>{
        const existingChildIds = currentSubGroup.children.map($5b7ccabde48fae90$var$getId);
        const childGroupAlreadyExists = existingChildIds.includes($5b7ccabde48fae90$var$getId(currentSubGroupToAdd));
        const lastChild = (0, $437b23f6a393c3bf$export$236389741107357f)(currentSubGroup.children);
        const lastChildIsDifferent = lastChild && $5b7ccabde48fae90$var$getId(lastChild) !== $5b7ccabde48fae90$var$getId(currentSubGroupToAdd);
        return childGroupAlreadyExists && lastChildIsDifferent;
    };
    if (!$5b7ccabde48fae90$var$isColGroupDef(tree)) return true;
    const currentGroup = tree;
    const groupToAdd = colDef;
    if (subGroupIsSplit(currentGroup, groupToAdd)) {
        currentGroup.children.push(groupToAdd);
        return true;
    }
    if (currentGroup.groupId === groupId) {
        const existingChildIds = currentGroup.children.map($5b7ccabde48fae90$var$getId);
        const colDefAlreadyPresent = existingChildIds.includes($5b7ccabde48fae90$var$getId(groupToAdd));
        if (!colDefAlreadyPresent) {
            currentGroup.children.push(groupToAdd);
            return true;
        }
    }
    for(let i = currentGroup.children.length - 1; i >= 0; i--){
        if ($5b7ccabde48fae90$var$addChildrenToGroup(currentGroup.children[i], groupId, colDef)) break;
    }
    return false;
}
function $5b7ccabde48fae90$var$mergeLeafPathTrees(leafPathTrees) {
    const matchingRootGroupIds = (pathA, pathB)=>{
        const bothPathsAreGroups = $5b7ccabde48fae90$var$isColGroupDef(pathA) && $5b7ccabde48fae90$var$isColGroupDef(pathB);
        return bothPathsAreGroups && $5b7ccabde48fae90$var$getId(pathA) === $5b7ccabde48fae90$var$getId(pathB);
    };
    const mergeTrees = (treeA, treeB)=>{
        if (!$5b7ccabde48fae90$var$isColGroupDef(treeB)) return treeA;
        const mergeResult = treeA;
        const groupToMerge = treeB;
        if (groupToMerge.children && groupToMerge.groupId) {
            const added = $5b7ccabde48fae90$var$addChildrenToGroup(mergeResult, groupToMerge.groupId, groupToMerge.children[0]);
            if (added) return mergeResult;
        }
        for (const child of groupToMerge.children)mergeTrees(mergeResult, child);
        return mergeResult;
    };
    const mergeColDefs = [];
    for(let i = 1; i <= leafPathTrees.length; i++){
        const first = leafPathTrees[i - 1];
        const second = leafPathTrees[i];
        if (matchingRootGroupIds(first, second)) leafPathTrees[i] = mergeTrees(first, second);
        else mergeColDefs.push(first);
    }
    return mergeColDefs;
}
// packages/ag-grid-enterprise/src/sideBar/common/toolPanelColDefService.ts
function $5b7ccabde48fae90$var$toolPanelCreateColumnTree(colModel, colDefs) {
    const invalidColIds = [];
    const createDummyColGroup = (abstractColDef, depth)=>{
        if ($5b7ccabde48fae90$var$isColGroupDef(abstractColDef)) {
            const groupDef = abstractColDef;
            const groupId = typeof groupDef.groupId !== "undefined" ? groupDef.groupId : groupDef.headerName;
            const group = new (0, $437b23f6a393c3bf$export$7ff27642a6ecc1cf)(groupDef, groupId, false, depth);
            const children = [];
            for (const def of groupDef.children){
                const child = createDummyColGroup(def, depth + 1);
                if (child) children.push(child);
            }
            group.setChildren(children);
            return group;
        } else {
            const colDef = abstractColDef;
            const key = colDef.colId ? colDef.colId : colDef.field;
            const column = colModel.getColDefCol(key);
            if (!column) invalidColIds.push(colDef);
            return column;
        }
    };
    const mappedResults = [];
    for (const colDef of colDefs){
        const result = createDummyColGroup(colDef, 0);
        if (result) mappedResults.push(result);
    }
    if (invalidColIds.length > 0) (0, $437b23f6a393c3bf$export$545083624300f13d)(217, {
        invalidColIds: invalidColIds
    });
    return mappedResults;
}
function $5b7ccabde48fae90$var$syncLayoutWithGrid(colModel, syncLayoutCallback) {
    const leafPathTrees = $5b7ccabde48fae90$var$getLeafPathTrees(colModel);
    const mergedColumnTrees = $5b7ccabde48fae90$var$mergeLeafPathTrees(leafPathTrees);
    syncLayoutCallback(mergedColumnTrees);
}
function $5b7ccabde48fae90$var$getLeafPathTrees(colModel) {
    const getLeafPathTree = (node, childDef)=>{
        let leafPathTree;
        if ((0, $437b23f6a393c3bf$export$bb4bfad2b594b78e)(node)) {
            if (node.isPadding()) leafPathTree = childDef;
            else {
                const groupDef = Object.assign({}, node.getColGroupDef());
                groupDef.groupId = node.getGroupId();
                groupDef.children = [
                    childDef
                ];
                leafPathTree = groupDef;
            }
        } else {
            const colDef = Object.assign({}, node.getColDef());
            colDef.colId = node.getColId();
            leafPathTree = colDef;
        }
        const parent = node.getOriginalParent();
        if (parent) return getLeafPathTree(parent, leafPathTree);
        else return leafPathTree;
    };
    const allGridColumns = colModel.getCols();
    const allPrimaryGridColumns = allGridColumns.filter((column)=>{
        const colDef = column.getColDef();
        return column.isPrimary() && !colDef.showRowGroup;
    });
    return allPrimaryGridColumns.map((col)=>getLeafPathTree(col, col.getColDef()));
}
var $5b7ccabde48fae90$var$ColumnModelItem = class {
    constructor(displayName, columnOrGroup, depth, group = false, expanded){
        this.displayName = displayName;
        this.depth = depth;
        this.group = group;
        this.localEventService = new (0, $437b23f6a393c3bf$export$820da7696a401cdc)();
        if (group) {
            this.columnGroup = columnOrGroup;
            this._expanded = expanded;
            this.children = [];
        } else this.column = columnOrGroup;
    }
    get expanded() {
        return !!this._expanded;
    }
    set expanded(expanded) {
        if (expanded === this._expanded) return;
        this._expanded = expanded;
        this.localEventService.dispatchEvent({
            type: "expandedChanged"
        });
    }
    addEventListener(eventType, listener) {
        this.localEventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.localEventService.removeEventListener(eventType, listener);
    }
};
function $5b7ccabde48fae90$var$selectAllChildren(beans, colTree, selectAllChecked, eventType) {
    const cols = $5b7ccabde48fae90$var$extractAllLeafColumns(colTree);
    $5b7ccabde48fae90$var$setAllColumns(beans, cols, selectAllChecked, eventType);
}
function $5b7ccabde48fae90$var$setAllColumns(beans, cols, selectAllChecked, eventType) {
    if (beans.colModel.isPivotMode()) $5b7ccabde48fae90$var$setAllPivot(beans, cols, selectAllChecked, eventType);
    else $5b7ccabde48fae90$var$setAllVisible(beans, cols, selectAllChecked, eventType);
}
function $5b7ccabde48fae90$var$extractAllLeafColumns(allItems) {
    const res = [];
    const recursiveFunc = (items)=>{
        for (const item of items){
            if (!item.passesFilter) continue;
            if (item.group) recursiveFunc(item.children);
            else res.push(item.column);
        }
    };
    recursiveFunc(allItems);
    return res;
}
function $5b7ccabde48fae90$var$setAllVisible(beans, columns, visible, eventType) {
    const colStateItems = [];
    for (const col of columns){
        if (col.getColDef().lockVisible) continue;
        if (col.isVisible() != visible) colStateItems.push({
            colId: col.getId(),
            hide: !visible
        });
    }
    if (colStateItems.length > 0) (0, $437b23f6a393c3bf$export$b2854c1cb8f10386)(beans, {
        state: colStateItems
    }, eventType);
}
function $5b7ccabde48fae90$var$setAllPivot(beans, columns, value, eventType) {
    $5b7ccabde48fae90$var$setAllPivotActive(beans, columns, value, eventType);
}
function $5b7ccabde48fae90$var$setAllPivotActive(beans, columns, value, eventType) {
    const colStateItems = [];
    const turnOnAction = (col)=>{
        if (col.isAnyFunctionActive()) return;
        if (col.isAllowValue()) {
            const aggFunc = typeof col.getAggFunc() === "string" ? col.getAggFunc() : beans.aggFuncSvc?.getDefaultAggFunc(col);
            colStateItems.push({
                colId: col.getId(),
                aggFunc: aggFunc
            });
        } else if (col.isAllowRowGroup()) colStateItems.push({
            colId: col.getId(),
            rowGroup: true
        });
        else if (col.isAllowPivot()) colStateItems.push({
            colId: col.getId(),
            pivot: true
        });
    };
    const turnOffAction = (col)=>{
        const isActive = col.isPivotActive() || col.isRowGroupActive() || col.isValueActive();
        if (isActive) colStateItems.push({
            colId: col.getId(),
            pivot: false,
            rowGroup: false,
            aggFunc: null
        });
    };
    const action = value ? turnOnAction : turnOffAction;
    columns.forEach(action);
    if (colStateItems.length > 0) (0, $437b23f6a393c3bf$export$b2854c1cb8f10386)(beans, {
        state: colStateItems
    }, eventType);
}
function $5b7ccabde48fae90$var$updateColumns(beans, params) {
    const { columns: columns, visibleState: visibleState, pivotState: pivotState, eventType: eventType } = params;
    const state = columns.map((column)=>{
        const colId = column.getColId();
        if (beans.colModel.isPivotMode()) {
            const pivotStateForColumn = pivotState?.[colId];
            return {
                colId: colId,
                pivot: pivotStateForColumn?.pivot,
                rowGroup: pivotStateForColumn?.rowGroup,
                aggFunc: pivotStateForColumn?.aggFunc
            };
        } else return {
            colId: colId,
            hide: !visibleState?.[colId]
        };
    });
    (0, $437b23f6a393c3bf$export$b2854c1cb8f10386)(beans, {
        state: state
    }, eventType);
}
function $5b7ccabde48fae90$var$createPivotState(column) {
    return {
        pivot: column.isPivotActive(),
        rowGroup: column.isRowGroupActive(),
        aggFunc: column.isValueActive() ? column.getAggFunc() : void 0
    };
}
// packages/ag-grid-enterprise/src/rowGrouping/rowGroupingUtils.ts
function $5b7ccabde48fae90$var$setRowNodeGroupValue(rowNode, colModel, colKey, newValue) {
    const column = colModel.getCol(colKey);
    let groupData = rowNode._groupData;
    if (!groupData) {
        groupData = {};
        rowNode._groupData = groupData;
    }
    const columnId = column.getColId();
    const oldValue = groupData[columnId];
    if (oldValue === newValue) return;
    groupData[columnId] = newValue;
    rowNode.dispatchCellChangedEvent(column, newValue, oldValue);
}
function $5b7ccabde48fae90$var$setRowNodeGroup(rowNode, beans, group) {
    if (rowNode.group === group) return;
    if (rowNode.group && !group) rowNode.expanded = false;
    rowNode.group = group;
    rowNode.updateHasChildren();
    beans.selectionSvc?.updateRowSelectable(rowNode);
    rowNode.dispatchRowEvent("groupChanged");
}
function $5b7ccabde48fae90$var$isRowGroupColLocked(column, beans) {
    const { gos: gos, rowGroupColsSvc: rowGroupColsSvc } = beans;
    if (!rowGroupColsSvc || !column) return false;
    const groupLockGroupColumns = gos.get("groupLockGroupColumns");
    if (!column.isRowGroupActive() || groupLockGroupColumns === 0) return false;
    if (groupLockGroupColumns === -1) return true;
    const colIndex = rowGroupColsSvc.columns.findIndex((groupCol)=>groupCol.getColId() === column.getColId());
    return groupLockGroupColumns > colIndex;
}
function $5b7ccabde48fae90$var$_getTextSelectionRanges(beans) {
    const rootNode = (0, $437b23f6a393c3bf$export$1911dd00c79744c0)(beans);
    const selection = "getSelection" in rootNode ? rootNode.getSelection() : null;
    const ranges = [];
    for(let i = 0; i < (selection?.rangeCount ?? 0); i++){
        const range = selection?.getRangeAt(i);
        if (range) ranges.push(range);
    }
    return {
        selection: selection,
        ranges: ranges
    };
}
function $5b7ccabde48fae90$var$_preserveRangesWhile(beans, fn) {
    const enableCellTextSelection = beans.gos.get("enableCellTextSelection");
    if (!enableCellTextSelection) return fn();
    if (!(0, $437b23f6a393c3bf$export$ca98fb7c82ac5538)() && !(0, $437b23f6a393c3bf$export$8caf403dacd36a68)()) return fn();
    const { selection: selection, ranges: ranges } = $5b7ccabde48fae90$var$_getTextSelectionRanges(beans);
    fn();
    selection?.removeAllRanges();
    for (const range of ranges)selection?.addRange(range);
}
// packages/ag-grid-enterprise/src/widgets/menuItemComponent.ts
var $5b7ccabde48fae90$var$MenuItemComponentType = {
    name: "menuItem",
    optionalMethods: [
        "setActive",
        "select",
        "setExpanded",
        "configureDefaults"
    ]
};
var $5b7ccabde48fae90$var$MENU_ITEM_CALLBACKS = {
    getMenuItemComp: (beans, def, params)=>{
        const compDetails = beans.userCompFactory.getCompDetails(def, $5b7ccabde48fae90$var$MenuItemComponentType, "agMenuItem", (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(beans.gos, params), true);
        return compDetails?.newAgStackInstance() ?? (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve();
    },
    getPostProcessPopupParams: ({ column: column, node: node })=>({
            column: column,
            rowNode: node
        }),
    preserveRangesWhile: $5b7ccabde48fae90$var$_preserveRangesWhile,
    stopPropagationCallbacks: (0, $437b23f6a393c3bf$export$24fcbcdf47263033),
    warnNoItem: (menuItemOrString)=>{
        (0, $437b23f6a393c3bf$export$545083624300f13d)(228, {
            menuItemOrString: menuItemOrString
        });
    }
};
var $5b7ccabde48fae90$var$MenuItemComponent = class extends $5b7ccabde48fae90$export$f6c02b828bd3ada0 {
    constructor(){
        super($5b7ccabde48fae90$var$MENU_ITEM_CALLBACKS);
    }
};
// packages/ag-grid-enterprise/src/widgets/menuList.ts
var $5b7ccabde48fae90$var$MenuList = class extends $5b7ccabde48fae90$export$8b45680cfb58eb35 {
    constructor(level, menuActionParams = {
        column: null,
        node: null,
        value: null
    }){
        super(level, menuActionParams, $5b7ccabde48fae90$var$MENU_ITEM_CALLBACKS);
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/toolPanelContextMenu.ts
var $5b7ccabde48fae90$var$ToolPanelContextMenu = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(column, mouseEventOrTouch, parentEl){
        super({
            tag: "div",
            cls: "ag-menu"
        });
        this.column = column;
        this.mouseEventOrTouch = mouseEventOrTouch;
        this.parentEl = parentEl;
        this.displayName = null;
    }
    postConstruct() {
        const { column: column, beans: { colNames: colNames } } = this;
        this.initializeProperties(column);
        let displayName;
        if ((0, $437b23f6a393c3bf$export$891484e65a02ec71)(column)) displayName = colNames.getDisplayNameForColumn(column, "columnToolPanel");
        else displayName = colNames.getDisplayNameForProvidedColumnGroup(null, column, "columnToolPanel");
        this.displayName = displayName;
        this.buildMenuItemMap();
        if (this.isActive()) {
            const mouseEventOrTouch = this.mouseEventOrTouch;
            if ("preventDefault" in mouseEventOrTouch) mouseEventOrTouch.preventDefault();
            const menuItemsMapped = this.getMappedMenuItems();
            if (menuItemsMapped.length === 0) return;
            this.displayContextMenu(menuItemsMapped);
        }
    }
    initializeProperties(column) {
        let columns;
        if ((0, $437b23f6a393c3bf$export$bb4bfad2b594b78e)(column)) columns = column.getLeafColumns();
        else columns = [
            column
        ];
        this.columns = columns;
        const isPivotMode2 = this.beans.colModel.isPivotMode();
        this.allowScrollIntoView = !isPivotMode2 && columns.some(this.isColumnValidForScrollIntoView);
        this.allowGrouping = columns.some((col)=>col.isPrimary() && col.isAllowRowGroup());
        this.allowValues = columns.some((col)=>col.isPrimary() && col.isAllowValue());
        this.allowPivoting = isPivotMode2 && columns.some((col)=>col.isPrimary() && col.isAllowPivot());
    }
    buildMenuItemMap() {
        const localeTextFunc = this.getLocaleTextFunc();
        const { beans: beans, displayName: displayName } = this;
        const { rowGroupColsSvc: rowGroupColsSvc, valueColsSvc: valueColsSvc, pivotColsSvc: pivotColsSvc, colModel: colModel } = beans;
        const menuItemMap = /* @__PURE__ */ new Map();
        this.menuItemMap = menuItemMap;
        const isPivotMode2 = colModel.isPivotMode();
        menuItemMap.set("scrollIntoView", {
            allowedFunction: (col)=>!col.isPinned() && !isPivotMode2 && this.isColumnValidForScrollIntoView(col),
            activeFunction: ()=>false,
            activateLabel: ()=>localeTextFunc("scrollColumnIntoView", `Scroll ${displayName} into View`, [
                    displayName
                ]),
            activateFunction: ()=>{
                const firstVisibleColumn = this.columns.find(this.isColumnValidForScrollIntoView);
                if (firstVisibleColumn) this.beans.ctrlsSvc.getScrollFeature().ensureColumnVisible(firstVisibleColumn);
            },
            deActivateFunction: ()=>{},
            addIcon: "ensureColumnVisible"
        });
        const rowGroupAllowed = (col)=>col.isPrimary() && col.isAllowRowGroup() && !$5b7ccabde48fae90$var$isRowGroupColLocked(col, beans);
        menuItemMap.set("rowGroup", {
            allowedFunction: rowGroupAllowed,
            activeFunction: (col)=>col.isRowGroupActive(),
            activateLabel: ()=>`${localeTextFunc("groupBy", "Group by")} ${displayName}`,
            deactivateLabel: ()=>`${localeTextFunc("ungroupBy", "Un-Group by")} ${displayName}`,
            activateFunction: ()=>rowGroupColsSvc?.setColumns(this.addColumnsToList(rowGroupColsSvc.columns, rowGroupAllowed), "toolPanelUi"),
            deActivateFunction: ()=>rowGroupColsSvc?.setColumns(this.removeColumnsFromList(rowGroupColsSvc.columns, rowGroupAllowed), "toolPanelUi"),
            addIcon: "menuAddRowGroup",
            removeIcon: "menuRemoveRowGroup"
        });
        const valueAllowed = (col)=>col.isPrimary() && col.isAllowValue();
        menuItemMap.set("value", {
            allowedFunction: valueAllowed,
            activeFunction: (col)=>col.isValueActive(),
            activateLabel: ()=>localeTextFunc("addToValues", `Add ${displayName} to values`, [
                    displayName
                ]),
            deactivateLabel: ()=>localeTextFunc("removeFromValues", `Remove ${displayName} from values`, [
                    displayName
                ]),
            activateFunction: ()=>valueColsSvc?.setColumns(this.addColumnsToList(valueColsSvc.columns, valueAllowed), "toolPanelUi"),
            deActivateFunction: ()=>valueColsSvc?.setColumns(this.removeColumnsFromList(valueColsSvc.columns, valueAllowed), "toolPanelUi"),
            addIcon: "valuePanel",
            removeIcon: "valuePanel"
        });
        const pivotAllowed = (col)=>isPivotMode2 && col.isPrimary() && col.isAllowPivot();
        menuItemMap.set("pivot", {
            allowedFunction: pivotAllowed,
            activeFunction: (col)=>col.isPivotActive(),
            activateLabel: ()=>localeTextFunc("addToLabels", `Add ${displayName} to labels`, [
                    displayName
                ]),
            deactivateLabel: ()=>localeTextFunc("removeFromLabels", `Remove ${displayName} from labels`, [
                    displayName
                ]),
            activateFunction: ()=>pivotColsSvc?.setColumns(this.addColumnsToList(pivotColsSvc.columns, pivotAllowed), "toolPanelUi"),
            deActivateFunction: ()=>pivotColsSvc?.setColumns(this.removeColumnsFromList(pivotColsSvc.columns, pivotAllowed), "toolPanelUi"),
            addIcon: "pivotPanel",
            removeIcon: "pivotPanel"
        });
    }
    isColumnValidForScrollIntoView(col) {
        const isVisible = col.isVisible();
        if (!isVisible) return false;
        const parent = col.getParent();
        if (!parent) return true;
        return parent.getDisplayedChildren()?.includes(col) ?? true;
    }
    addColumnsToList(columnList, predicate) {
        return [
            ...columnList
        ].concat(this.columns.filter((col)=>predicate(col) && !columnList.includes(col)));
    }
    removeColumnsFromList(columnList, predicate) {
        return columnList.filter((col)=>predicate(col) && this.columns.includes(col));
    }
    displayContextMenu(menuItemsMapped) {
        const eGui = this.getGui();
        const menuList = this.createBean(new $5b7ccabde48fae90$var$MenuList());
        const localeTextFunc = this.getLocaleTextFunc();
        let hideFunc = ()=>{};
        eGui.appendChild(menuList.getGui());
        menuList.addMenuItems(menuItemsMapped);
        menuList.addManagedListeners(menuList, {
            closeMenu: ()=>{
                this.parentEl.focus();
                hideFunc();
            }
        });
        const popupSvc = this.beans.popupSvc;
        const addPopupRes = popupSvc.addPopup({
            modal: true,
            eChild: eGui,
            closeOnEsc: true,
            afterGuiAttached: ()=>(0, $437b23f6a393c3bf$export$8598088d375f416f)(menuList.getGui()),
            ariaLabel: localeTextFunc("ariaLabelContextMenu", "Context Menu"),
            closedCallback: (e)=>{
                if (e instanceof KeyboardEvent) this.parentEl.focus();
                this.destroyBean(menuList);
            }
        });
        if (addPopupRes) hideFunc = addPopupRes.hideFunc;
        popupSvc.positionPopupUnderMouseEvent({
            type: "columnContextMenu",
            mouseEvent: this.mouseEventOrTouch,
            ePopup: eGui
        });
    }
    isActive() {
        return this.allowScrollIntoView || this.allowGrouping || this.allowValues || this.allowPivoting;
    }
    getMappedMenuItems() {
        const ret = [];
        const { menuItemMap: menuItemMap, columns: columns, displayName: displayName, beans: beans } = this;
        for (const val of menuItemMap.values()){
            const isInactive = columns.some((col)=>val.allowedFunction(col) && !val.activeFunction(col));
            const isActive = columns.some((col)=>val.allowedFunction(col) && val.activeFunction(col));
            if (isInactive) ret.push({
                name: val.activateLabel(displayName),
                icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(val.addIcon, beans, null),
                action: ()=>val.activateFunction()
            });
            if (isActive && val.removeIcon && val.deactivateLabel) ret.push({
                name: val.deactivateLabel(displayName),
                icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(val.removeIcon, beans, null),
                action: ()=>val.deActivateFunction?.()
            });
        }
        return ret;
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/toolPanelColumnGroupComp.ts
var $5b7ccabde48fae90$var$ToolPanelColumnGroupElement = {
    tag: "div",
    cls: "ag-column-select-column-group",
    children: [
        {
            tag: "span",
            ref: "eColumnGroupIcons",
            cls: "ag-column-group-icons",
            children: [
                {
                    tag: "span",
                    ref: "eGroupClosedIcon",
                    cls: "ag-column-group-closed-icon"
                },
                {
                    tag: "span",
                    ref: "eGroupOpenedIcon",
                    cls: "ag-column-group-opened-icon"
                }
            ]
        },
        {
            tag: "ag-checkbox",
            ref: "cbSelect",
            cls: "ag-column-select-checkbox"
        },
        {
            tag: "span",
            ref: "eLabel",
            cls: "ag-column-select-column-label"
        }
    ]
};
var $5b7ccabde48fae90$var$ToolPanelColumnGroupComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(modelItem, allowDragging, eventType, focusWrapper){
        super();
        this.modelItem = modelItem;
        this.allowDragging = allowDragging;
        this.eventType = eventType;
        this.focusWrapper = focusWrapper;
        this.cbSelect = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eLabel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eGroupOpenedIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eGroupClosedIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eColumnGroupIcons = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.processingColumnStateChange = false;
        const { columnGroup: columnGroup, depth: depth, displayName: displayName } = modelItem;
        this.columnGroup = columnGroup;
        this.columnDepth = depth;
        this.displayName = displayName;
    }
    postConstruct() {
        this.setTemplate($5b7ccabde48fae90$var$ToolPanelColumnGroupElement, [
            (0, $437b23f6a393c3bf$export$2e2c317d2e31f2ca)
        ]);
        const { beans: beans, cbSelect: cbSelect, eLabel: eLabel, displayName: displayName, columnDepth: columnDepth, modelItem: modelItem, focusWrapper: focusWrapper, columnGroup: columnGroup } = this;
        const { registry: registry, gos: gos } = beans;
        const eDragHandle = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("columnDrag", beans);
        this.eDragHandle = eDragHandle;
        eDragHandle.classList.add("ag-drag-handle", "ag-column-select-column-group-drag-handle");
        const checkboxGui = cbSelect.getGui();
        const checkboxInput = cbSelect.getInputElement();
        checkboxGui.after(eDragHandle);
        checkboxInput.setAttribute("tabindex", "-1");
        eLabel.textContent = displayName ?? "";
        this.setupExpandContract();
        this.addCss("ag-column-select-indent-" + columnDepth);
        this.getGui().style.setProperty("--ag-indentation-level", String(columnDepth));
        this.tooltipFeature = this.createOptionalManagedBean(registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.focusWrapper,
            getLocation: ()=>"columnToolPanelColumnGroup",
            shouldDisplayTooltip: (0, $437b23f6a393c3bf$export$75f51ed61a5271e6)(gos, ()=>eLabel)
        }));
        this.addManagedEventListeners({
            columnPivotModeChanged: this.onColumnStateChanged.bind(this)
        });
        this.addManagedElementListeners(eLabel, {
            click: this.onLabelClicked.bind(this)
        });
        this.addManagedListeners(cbSelect, {
            fieldValueChanged: this.onCheckboxChanged.bind(this)
        });
        this.addManagedListeners(modelItem, {
            expandedChanged: this.onExpandChanged.bind(this)
        });
        const touchListener = new (0, $437b23f6a393c3bf$export$7b2e93987414b382)(this.getGui(), false);
        this.addManagedListeners(touchListener, {
            longTap: (e)=>this.onContextMenu(e.touchStart)
        });
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
        this.addManagedListeners(focusWrapper, {
            keydown: this.handleKeyDown.bind(this),
            contextmenu: this.onContextMenu.bind(this)
        });
        this.setOpenClosedIcons();
        this.setupDragging();
        this.onColumnStateChanged();
        this.addVisibilityListenersToAllChildren();
        this.refreshAriaExpanded();
        this.refreshAriaLabel();
        this.setupTooltip();
        const classes = (0, $437b23f6a393c3bf$export$1784132bab54c462)(columnGroup.getColGroupDef(), gos, null, columnGroup);
        for (const c of classes)this.toggleCss(c, true);
    }
    getColumns() {
        return this.columnGroup.getLeafColumns();
    }
    setupTooltip() {
        const colGroupDef = this.columnGroup.getColGroupDef();
        if (!colGroupDef) return;
        const refresh = ()=>this.tooltipFeature?.setTooltipAndRefresh(colGroupDef.headerTooltip);
        refresh();
        this.addManagedEventListeners({
            newColumnsLoaded: refresh
        });
    }
    handleKeyDown(e) {
        switch(e.key){
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT:
                e.preventDefault();
                this.modelItem.expanded = false;
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT:
                e.preventDefault();
                this.modelItem.expanded = true;
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE:
                e.preventDefault();
                if (this.isSelectable()) this.onSelectAllChanged(!this.isSelected());
                break;
        }
    }
    onContextMenu(e) {
        const { columnGroup: columnGroup, gos: gos } = this;
        if (gos.get("functionsReadOnly")) return;
        const contextMenu = this.createBean(new $5b7ccabde48fae90$var$ToolPanelContextMenu(columnGroup, e, this.focusWrapper));
        this.addDestroyFunc(()=>{
            if (contextMenu.isAlive()) this.destroyBean(contextMenu);
        });
    }
    addVisibilityListenersToAllChildren() {
        const listener = this.onColumnStateChanged.bind(this);
        for (const column of this.columnGroup.getLeafColumns())this.addManagedListeners(column, {
            visibleChanged: listener,
            columnValueChanged: listener,
            columnPivotChanged: listener,
            columnRowGroupChanged: listener
        });
    }
    setupDragging() {
        if (!this.allowDragging) {
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eDragHandle, false);
            return;
        }
        const beans = this.beans;
        const { gos: gos, eventSvc: eventSvc, dragAndDrop: dragAndDrop } = beans;
        let hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
        const dragSource = {
            type: (0, $437b23f6a393c3bf$export$46ba5a92125911d9).ToolPanel,
            eElement: this.eDragHandle,
            dragItemName: this.displayName,
            getDefaultIconName: ()=>hideColumnOnExit ? "hide" : "notAllowed",
            getDragItem: ()=>this.createDragItem(),
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                eventSvc.dispatchEvent({
                    type: "columnPanelItemDragStart",
                    column: this.columnGroup
                });
            },
            onDragStopped: ()=>{
                eventSvc.dispatchEvent({
                    type: "columnPanelItemDragEnd"
                });
            },
            onGridEnter: (dragItem)=>{
                if (hideColumnOnExit) $5b7ccabde48fae90$var$updateColumns(beans, {
                    columns: this.columnGroup.getLeafColumns(),
                    visibleState: dragItem?.visibleState,
                    pivotState: dragItem?.pivotState,
                    eventType: this.eventType
                });
            },
            onGridExit: ()=>{
                if (hideColumnOnExit) this.onChangeCommon(false);
            }
        };
        dragAndDrop.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>dragAndDrop.removeDragSource(dragSource));
    }
    createDragItem() {
        const columns = this.columnGroup.getLeafColumns();
        const visibleState = {};
        const pivotState = {};
        for (const col of columns){
            const colId = col.getId();
            visibleState[colId] = col.isVisible();
            pivotState[colId] = $5b7ccabde48fae90$var$createPivotState(col);
        }
        return {
            columns: columns,
            visibleState: visibleState,
            pivotState: pivotState
        };
    }
    setupExpandContract() {
        const { beans: beans, eGroupClosedIcon: eGroupClosedIcon, eGroupOpenedIcon: eGroupOpenedIcon, eColumnGroupIcons: eColumnGroupIcons } = this;
        eGroupClosedIcon.appendChild((0, $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1)("columnSelectClosed", beans, null));
        eGroupOpenedIcon.appendChild((0, $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1)("columnSelectOpen", beans, null));
        const listener = this.onExpandOrContractClicked.bind(this);
        this.addManagedElementListeners(eGroupClosedIcon, {
            click: listener
        });
        this.addManagedElementListeners(eGroupOpenedIcon, {
            click: listener
        });
        const touchListener = new (0, $437b23f6a393c3bf$export$7b2e93987414b382)(eColumnGroupIcons, true);
        this.addManagedListeners(touchListener, {
            tap: listener
        });
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    }
    onLabelClicked() {
        const nextState = !this.cbSelect.getValue();
        this.onChangeCommon(nextState);
    }
    onCheckboxChanged(event) {
        this.onChangeCommon(event.selected);
    }
    getVisibleLeafColumns() {
        const childColumns = [];
        const extractCols = (children)=>{
            for (const child of children)if (child.passesFilter) {
                if (child.group) extractCols(child.children);
                else childColumns.push(child.column);
            }
        };
        extractCols(this.modelItem.children);
        return childColumns;
    }
    onChangeCommon(nextState) {
        this.refreshAriaLabel();
        if (this.processingColumnStateChange) return;
        $5b7ccabde48fae90$var$selectAllChildren(this.beans, this.modelItem.children, nextState, this.eventType);
    }
    refreshAriaLabel() {
        const { cbSelect: cbSelect, focusWrapper: focusWrapper, displayName: displayName } = this;
        const translate = this.getLocaleTextFunc();
        const columnLabel = translate("ariaColumnGroup", "Column Group");
        const checkboxValue = cbSelect.getValue();
        const state = checkboxValue === void 0 ? translate("ariaIndeterminate", "indeterminate") : checkboxValue ? translate("ariaVisible", "visible") : translate("ariaHidden", "hidden");
        const visibilityLabel = translate("ariaToggleVisibility", "Press SPACE to toggle visibility");
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(focusWrapper, `${displayName} ${columnLabel}`);
        cbSelect.setInputAriaLabel(`${visibilityLabel} (${state})`);
        (0, $437b23f6a393c3bf$export$3c2bc877474a7797)(focusWrapper, cbSelect.getInputElement().id);
    }
    onColumnStateChanged() {
        const selectedValue = this.workOutSelectedValue();
        const readOnlyValue = this.workOutReadOnlyValue();
        this.processingColumnStateChange = true;
        const cbSelect = this.cbSelect;
        cbSelect.setValue(selectedValue);
        cbSelect.setReadOnly(readOnlyValue);
        this.toggleCss("ag-column-select-column-group-readonly", readOnlyValue);
        this.processingColumnStateChange = false;
    }
    workOutSelectedValue() {
        const pivotMode = this.beans.colModel.isPivotMode();
        const visibleLeafColumns = this.getVisibleLeafColumns();
        let checkedCount = 0;
        let uncheckedCount = 0;
        for (const column of visibleLeafColumns)if (pivotMode || !column.getColDef().lockVisible) {
            if (this.isColumnChecked(column, pivotMode)) checkedCount++;
            else uncheckedCount++;
        }
        if (checkedCount > 0 && uncheckedCount > 0) return void 0;
        return checkedCount > 0;
    }
    workOutReadOnlyValue() {
        const pivotMode = this.beans.colModel.isPivotMode();
        let colsThatCanAction = 0;
        for (const col of this.columnGroup.getLeafColumns()){
            if (pivotMode) {
                if (col.isAnyFunctionAllowed()) colsThatCanAction++;
            } else if (!col.getColDef().lockVisible) colsThatCanAction++;
        }
        return colsThatCanAction === 0;
    }
    isColumnChecked(column, pivotMode) {
        if (pivotMode) {
            const pivoted = column.isPivotActive();
            const grouped = column.isRowGroupActive();
            const aggregated = column.isValueActive();
            return pivoted || grouped || aggregated;
        }
        return column.isVisible();
    }
    onExpandOrContractClicked() {
        const modelItem = this.modelItem;
        const oldState = modelItem.expanded;
        modelItem.expanded = !oldState;
    }
    onExpandChanged() {
        this.setOpenClosedIcons();
        this.refreshAriaExpanded();
    }
    setOpenClosedIcons() {
        const folderOpen = this.modelItem.expanded;
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eGroupClosedIcon, !folderOpen);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eGroupOpenedIcon, folderOpen);
    }
    refreshAriaExpanded() {
        (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(this.focusWrapper, this.modelItem.expanded);
    }
    getDisplayName() {
        return this.displayName;
    }
    onSelectAllChanged(value) {
        const cbSelect = this.cbSelect;
        const cbValue = cbSelect.getValue();
        const readOnly = cbSelect.isReadOnly();
        if (!readOnly && (value && !cbValue || !value && cbValue)) cbSelect.toggle();
    }
    isSelected() {
        return this.cbSelect.getValue();
    }
    isSelectable() {
        return !this.cbSelect.isReadOnly();
    }
    setSelected(selected) {
        this.cbSelect.setValue(selected, true);
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/columnMoveUtils.ts
var $5b7ccabde48fae90$var$getCurrentColumnsBeingMoved = (column)=>{
    if ((0, $437b23f6a393c3bf$export$bb4bfad2b594b78e)(column)) return column.getLeafColumns();
    return column ? [
        column
    ] : [];
};
var $5b7ccabde48fae90$var$getMoveTargetIndex = (beans, currentColumns, lastHoveredColumn, isBefore)=>{
    if (!lastHoveredColumn || !currentColumns) return null;
    const allColumns = beans.colModel.getCols();
    const targetColumnIndex = allColumns.indexOf(lastHoveredColumn);
    const adjustedTarget = isBefore ? targetColumnIndex : targetColumnIndex + 1;
    const diff = $5b7ccabde48fae90$var$getMoveDiff(allColumns, currentColumns, adjustedTarget);
    return adjustedTarget - diff;
};
var $5b7ccabde48fae90$var$getMoveDiff = (allColumns, currentColumns, end)=>{
    if (!currentColumns) return 0;
    const targetColumn = currentColumns[0];
    const span = currentColumns.length;
    const currentIndex = allColumns.indexOf(targetColumn);
    if (currentIndex < end) return span;
    return 0;
};
var $5b7ccabde48fae90$var$isMoveBlocked = (gos, beans, currentColumns)=>{
    const preventMoving = gos.get("suppressMovableColumns") || beans.colModel.isPivotMode();
    if (preventMoving) return true;
    const hasNotMovable = currentColumns.find(({ colDef: colDef })=>!!colDef.suppressMovable || !!colDef.lockPosition);
    return !!hasNotMovable;
};
var $5b7ccabde48fae90$var$moveItem = (beans, currentColumns, lastHoveredListItem)=>{
    if (!lastHoveredListItem) return;
    const { component: component } = lastHoveredListItem;
    let lastHoveredColumn = null;
    let isBefore = lastHoveredListItem.position === "top";
    if (component instanceof $5b7ccabde48fae90$var$ToolPanelColumnGroupComp) {
        const columns = component.getColumns();
        lastHoveredColumn = columns[0];
        isBefore = true;
    } else if (component) lastHoveredColumn = component.column;
    if (!lastHoveredColumn) return;
    const targetIndex = $5b7ccabde48fae90$var$getMoveTargetIndex(beans, currentColumns, lastHoveredColumn, isBefore);
    if (targetIndex != null) beans.colMoves?.moveColumns(currentColumns, targetIndex, "toolPanelUi");
};
var $5b7ccabde48fae90$var$getCurrentDragValue = (listItemDragStartEvent)=>{
    return listItemDragStartEvent.column;
};
var $5b7ccabde48fae90$var$ToolPanelColumnElement = {
    tag: "div",
    cls: "ag-column-select-column",
    children: [
        {
            tag: "ag-checkbox",
            ref: "cbSelect",
            cls: "ag-column-select-checkbox"
        },
        {
            tag: "span",
            ref: "eLabel",
            cls: "ag-column-select-column-label"
        }
    ]
};
var $5b7ccabde48fae90$var$ToolPanelColumnComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(modelItem, allowDragging, groupsExist, focusWrapper){
        super();
        this.modelItem = modelItem;
        this.allowDragging = allowDragging;
        this.groupsExist = groupsExist;
        this.focusWrapper = focusWrapper;
        this.eLabel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.cbSelect = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.processingColumnStateChange = false;
        const { column: column, depth: depth, displayName: displayName } = modelItem;
        this.column = column;
        this.columnDepth = depth;
        this.displayName = displayName;
    }
    postConstruct() {
        this.setTemplate($5b7ccabde48fae90$var$ToolPanelColumnElement, [
            (0, $437b23f6a393c3bf$export$2e2c317d2e31f2ca)
        ]);
        const { beans: beans, cbSelect: cbSelect, displayName: displayName, eLabel: eLabel, columnDepth: indent, groupsExist: groupsExist, column: column, gos: gos, focusWrapper: focusWrapper } = this;
        const eDragHandle = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("columnDrag", beans);
        this.eDragHandle = eDragHandle;
        eDragHandle.classList.add("ag-drag-handle", "ag-column-select-column-drag-handle");
        const checkboxGui = cbSelect.getGui();
        const checkboxInput = cbSelect.getInputElement();
        checkboxGui.after(eDragHandle);
        checkboxInput.setAttribute("tabindex", "-1");
        eLabel.textContent = displayName;
        if (groupsExist) this.addCss("ag-column-select-add-group-indent");
        this.addCss(`ag-column-select-indent-${indent}`);
        this.getGui().style.setProperty("--ag-indentation-level", String(indent));
        this.tooltipFeature = this.createOptionalManagedBean(beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.focusWrapper,
            getLocation: ()=>"columnToolPanelColumn",
            shouldDisplayTooltip: (0, $437b23f6a393c3bf$export$75f51ed61a5271e6)(gos, ()=>eLabel),
            getAdditionalParams: ()=>({
                    colDef: column.getColDef()
                })
        }));
        this.setupDragging();
        const onColStateChanged = this.onColumnStateChanged.bind(this);
        this.addManagedEventListeners({
            columnPivotModeChanged: onColStateChanged
        });
        this.addManagedListeners(column, {
            columnValueChanged: onColStateChanged,
            columnPivotChanged: onColStateChanged,
            columnRowGroupChanged: onColStateChanged,
            visibleChanged: onColStateChanged
        });
        this.addManagedListeners(focusWrapper, {
            keydown: this.handleKeyDown.bind(this),
            contextmenu: this.onContextMenu.bind(this)
        });
        const touchListener = new (0, $437b23f6a393c3bf$export$7b2e93987414b382)(focusWrapper);
        this.addManagedListeners(touchListener, {
            longTap: (e)=>this.onContextMenu(e.touchStart)
        });
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
        this.addManagedPropertyListener("functionsReadOnly", this.onColumnStateChanged.bind(this));
        this.addManagedListeners(cbSelect, {
            fieldValueChanged: this.onCheckboxChanged.bind(this)
        });
        this.addManagedElementListeners(eLabel, {
            click: this.onLabelClicked.bind(this)
        });
        this.onColumnStateChanged();
        this.refreshAriaLabel();
        this.setupTooltip();
        const classes = (0, $437b23f6a393c3bf$export$1784132bab54c462)(column.getColDef(), gos, column, null);
        for (const c of classes)this.toggleCss(c, true);
    }
    getColumn() {
        return this.column;
    }
    setupTooltip() {
        const refresh = ()=>this.tooltipFeature?.setTooltipAndRefresh(this.column.getColDef().headerTooltip);
        refresh();
        this.addManagedEventListeners({
            newColumnsLoaded: refresh
        });
    }
    onContextMenu(e) {
        const { column: column, gos: gos } = this;
        if (gos.get("functionsReadOnly")) return;
        const contextMenu = this.createBean(new $5b7ccabde48fae90$var$ToolPanelContextMenu(column, e, this.focusWrapper));
        this.addDestroyFunc(()=>{
            if (contextMenu.isAlive()) this.destroyBean(contextMenu);
        });
    }
    handleKeyDown(e) {
        if (e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE) {
            e.preventDefault();
            if (this.isSelectable()) this.onSelectAllChanged(!this.isSelected());
        }
    }
    onLabelClicked() {
        if (this.gos.get("functionsReadOnly")) return;
        const nextState = !this.cbSelect.getValue();
        this.onChangeCommon(nextState);
    }
    onCheckboxChanged(event) {
        this.onChangeCommon(event.selected);
    }
    onChangeCommon(nextState) {
        if (this.cbSelect.isReadOnly()) return;
        this.refreshAriaLabel();
        if (this.processingColumnStateChange) return;
        $5b7ccabde48fae90$var$setAllColumns(this.beans, [
            this.column
        ], nextState, "toolPanelUi");
    }
    refreshAriaLabel() {
        const { cbSelect: cbSelect, focusWrapper: focusWrapper, displayName: displayName } = this;
        const translate = this.getLocaleTextFunc();
        const columnLabel = translate("ariaColumn", "Column");
        const state = cbSelect.getValue() ? translate("ariaVisible", "visible") : translate("ariaHidden", "hidden");
        const visibilityLabel = translate("ariaToggleVisibility", "Press SPACE to toggle visibility");
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(focusWrapper, `${displayName} ${columnLabel}`);
        this.cbSelect.setInputAriaLabel(`${visibilityLabel} (${state})`);
        (0, $437b23f6a393c3bf$export$3c2bc877474a7797)(focusWrapper, cbSelect.getInputElement().id);
    }
    setupDragging() {
        const eDragHandle = this.eDragHandle;
        if (!this.allowDragging) {
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eDragHandle, false);
            return;
        }
        const beans = this.beans;
        const { gos: gos, eventSvc: eventSvc, dragAndDrop: dragAndDrop } = beans;
        let hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
        const dragSource = {
            type: (0, $437b23f6a393c3bf$export$46ba5a92125911d9).ToolPanel,
            eElement: eDragHandle,
            dragItemName: this.displayName,
            getDefaultIconName: ()=>hideColumnOnExit ? "hide" : "notAllowed",
            getDragItem: ()=>this.createDragItem(),
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                eventSvc.dispatchEvent({
                    type: "columnPanelItemDragStart",
                    column: this.column
                });
            },
            onDragStopped: ()=>{
                eventSvc.dispatchEvent({
                    type: "columnPanelItemDragEnd"
                });
            },
            onGridEnter: (dragItem)=>{
                if (hideColumnOnExit) $5b7ccabde48fae90$var$updateColumns(beans, {
                    columns: [
                        this.column
                    ],
                    visibleState: dragItem?.visibleState,
                    pivotState: dragItem?.pivotState,
                    eventType: "toolPanelUi"
                });
            },
            onGridExit: ()=>{
                if (hideColumnOnExit) this.onChangeCommon(false);
            }
        };
        dragAndDrop.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>dragAndDrop.removeDragSource(dragSource));
    }
    createDragItem() {
        const colId = this.column.getColId();
        const visibleState = {
            [colId]: this.column.isVisible()
        };
        const pivotState = {
            [colId]: $5b7ccabde48fae90$var$createPivotState(this.column)
        };
        return {
            columns: [
                this.column
            ],
            visibleState: visibleState,
            pivotState: pivotState
        };
    }
    onColumnStateChanged() {
        this.processingColumnStateChange = true;
        const isPivotMode2 = this.beans.colModel.isPivotMode();
        if (isPivotMode2) {
            const anyFunctionActive = this.column.isAnyFunctionActive();
            this.cbSelect.setValue(anyFunctionActive);
        } else this.cbSelect.setValue(this.column.isVisible());
        let canBeToggled = true;
        let canBeDragged = true;
        if (isPivotMode2) {
            const functionsReadOnly = this.gos.get("functionsReadOnly");
            const noFunctionsAllowed = !this.column.isAnyFunctionAllowed();
            canBeToggled = !functionsReadOnly && !noFunctionsAllowed;
            canBeDragged = canBeToggled;
        } else {
            const { enableRowGroup: enableRowGroup, enableValue: enableValue, lockPosition: lockPosition, suppressMovable: suppressMovable, lockVisible: lockVisible } = this.column.getColDef();
            const forceDraggable = !!enableRowGroup || !!enableValue;
            const disableDraggable = !!lockPosition || !!suppressMovable;
            canBeToggled = !lockVisible;
            canBeDragged = forceDraggable || !disableDraggable;
        }
        this.cbSelect.setReadOnly(!canBeToggled);
        this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !canBeDragged);
        this.toggleCss("ag-column-select-column-readonly", !canBeDragged && !canBeToggled);
        this.cbSelect.setPassive(false);
        this.processingColumnStateChange = false;
    }
    getDisplayName() {
        return this.displayName;
    }
    onSelectAllChanged(value) {
        const cbSelect = this.cbSelect;
        if (value !== cbSelect.getValue()) {
            if (!cbSelect.isReadOnly()) cbSelect.toggle();
        }
    }
    isSelected() {
        return this.cbSelect.getValue();
    }
    isSelectable() {
        return !this.cbSelect.isReadOnly();
    }
    isExpandable() {
        return false;
    }
    setExpanded(_value) {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(158);
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/agPrimaryColsList.ts
var $5b7ccabde48fae90$var$UIColumnModel = class {
    constructor(items){
        this.items = items;
    }
    getRowCount() {
        return this.items.length;
    }
    getRow(index) {
        return this.items[index];
    }
};
var $5b7ccabde48fae90$var$PRIMARY_COLS_LIST_PANEL_CLASS = "ag-column-select-list";
var $5b7ccabde48fae90$var$AgPrimaryColsList = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tag: "div",
            cls: $5b7ccabde48fae90$var$PRIMARY_COLS_LIST_PANEL_CLASS,
            role: "presentation"
        });
        this.destroyColumnItemFuncs = [];
        this.hasLoadedInitialState = false;
        this.isInitialState = false;
        this.skipRefocus = false;
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
    }
    destroy() {
        this.destroyColumnTree();
        super.destroy();
    }
    destroyColumnTree() {
        this.allColsTree = [];
        for (const f of this.destroyColumnItemFuncs)f();
        this.destroyColumnItemFuncs = [];
    }
    init(params, allowDragging, eventType) {
        this.params = params;
        const { suppressSyncLayoutWithGrid: suppressSyncLayoutWithGrid, contractColumnSelection: contractColumnSelection, suppressColumnMove: suppressColumnMove } = params;
        this.allowDragging = allowDragging;
        this.eventType = eventType;
        if (!suppressSyncLayoutWithGrid) this.addManagedEventListeners({
            columnMoved: this.onColumnsChanged.bind(this)
        });
        this.addManagedEventListeners({
            newColumnsLoaded: this.onColumnsChanged.bind(this)
        });
        const listener = this.fireSelectionChangedEvent.bind(this);
        this.addManagedEventListeners({
            columnPivotChanged: listener,
            columnPivotModeChanged: listener,
            columnRowGroupChanged: listener,
            columnValueChanged: listener,
            columnVisible: listener,
            newColumnsLoaded: listener
        });
        this.expandGroupsByDefault = !contractColumnSelection;
        const isPreventMove = suppressColumnMove || suppressSyncLayoutWithGrid;
        const virtualList = this.createManagedBean(new $5b7ccabde48fae90$var$VirtualList({
            cssIdentifier: "column-select",
            ariaRole: "tree",
            moveItemCallback: (item, isUp)=>{
                if (isPreventMove) return;
                this.moveItems(item, isUp);
            }
        }));
        this.virtualList = virtualList;
        this.appendChild(virtualList.getGui());
        virtualList.setComponentCreator((item, listItemElement)=>{
            (0, $437b23f6a393c3bf$export$9eaf1f20171625e8)(listItemElement, item.depth + 1);
            return this.createComponentFromItem(item, listItemElement);
        });
        if (this.colModel.ready) this.onColumnsChanged();
        if (isPreventMove) return;
        this.createItemDragFeature();
    }
    createItemDragFeature() {
        const { gos: gos, beans: beans, virtualList: virtualList } = this;
        this.createManagedBean(new $5b7ccabde48fae90$var$VirtualListDragFeature(this, virtualList, {
            dragSourceType: (0, $437b23f6a393c3bf$export$46ba5a92125911d9).ToolPanel,
            addListeners: (parent, listItemDragStart, listItemDragEnd)=>{
                parent.addManagedEventListeners({
                    columnPanelItemDragStart: listItemDragStart,
                    columnPanelItemDragEnd: listItemDragEnd
                });
            },
            getCurrentDragValue: (listItemDragStartEvent)=>$5b7ccabde48fae90$var$getCurrentDragValue(listItemDragStartEvent),
            isMoveBlocked: (currentDragValue)=>$5b7ccabde48fae90$var$isMoveBlocked(gos, beans, $5b7ccabde48fae90$var$getCurrentColumnsBeingMoved(currentDragValue)),
            getNumRows: (comp)=>comp.getDisplayedColsList().length,
            moveItem: (currentDragValue, lastHoveredListItem)=>$5b7ccabde48fae90$var$moveItem(beans, $5b7ccabde48fae90$var$getCurrentColumnsBeingMoved(currentDragValue), lastHoveredListItem)
        }));
    }
    moveItems(item, isUp) {
        const { gos: gos, beans: beans } = this;
        const { modelItem: modelItem } = item;
        const { group: group, columnGroup: columnGroup, column: column, expanded: expanded } = modelItem;
        const currentColumns = $5b7ccabde48fae90$var$getCurrentColumnsBeingMoved(group ? columnGroup : column);
        if ($5b7ccabde48fae90$var$isMoveBlocked(gos, beans, currentColumns)) return;
        const currentIndex = this.displayedColsList.indexOf(modelItem);
        const diff = isUp ? -1 : 1;
        let movePadding = 0;
        if (isUp) {
            const children = item.columnDepth > 0 ? column.getParent()?.getChildren() : null;
            if (children?.length && column === children[0]) movePadding = -1;
        } else if (group) movePadding = expanded ? modelItem.children.length : 0;
        const nextItem = Math.min(Math.max(currentIndex + movePadding + diff, 0), this.displayedColsList.length - 1);
        this.skipRefocus = true;
        $5b7ccabde48fae90$var$moveItem(beans, currentColumns, {
            rowIndex: nextItem,
            position: isUp ? "top" : "bottom",
            component: this.virtualList.getComponentAt(nextItem)
        });
        this.focusRowIfAlive(nextItem - movePadding).then(()=>{
            this.skipRefocus = false;
        });
    }
    createComponentFromItem(item, listItemElement) {
        const allowDragging = this.allowDragging;
        if (item.group) {
            const renderedGroup = new $5b7ccabde48fae90$var$ToolPanelColumnGroupComp(item, allowDragging, this.eventType, listItemElement);
            this.createBean(renderedGroup);
            return renderedGroup;
        }
        const columnComp = new $5b7ccabde48fae90$var$ToolPanelColumnComp(item, allowDragging, this.groupsExist, listItemElement);
        this.createBean(columnComp);
        return columnComp;
    }
    onColumnsChanged() {
        const params = this.params;
        if (!this.hasLoadedInitialState) {
            this.hasLoadedInitialState = true;
            this.isInitialState = !!params.initialState;
        }
        const expandedStates = this.getExpandedStates();
        const pivotModeActive = this.colModel.isPivotMode();
        const shouldSyncColumnLayoutWithGrid = !params.suppressSyncLayoutWithGrid && !pivotModeActive;
        if (shouldSyncColumnLayoutWithGrid) this.buildTreeFromWhatGridIsDisplaying();
        else this.buildTreeFromProvidedColumnDefs();
        this.setExpandedStates(expandedStates);
        this.markFilteredColumns();
        this.flattenAndFilterModel();
        this.isInitialState = false;
    }
    getDisplayedColsList() {
        return this.displayedColsList;
    }
    getExpandedStates() {
        const res = {};
        if (this.isInitialState) {
            const { expandedGroupIds: expandedGroupIds } = this.params.initialState;
            for (const id of expandedGroupIds)res[id] = true;
            return res;
        }
        if (!this.allColsTree) return {};
        this.forEachItem((item)=>{
            if (!item.group) return;
            const colGroup = item.columnGroup;
            if (colGroup) res[colGroup.getId()] = item.expanded;
        });
        return res;
    }
    setExpandedStates(states) {
        if (!this.allColsTree) return;
        const { isInitialState: isInitialState } = this;
        this.forEachItem((item)=>{
            if (!item.group) return;
            const colGroup = item.columnGroup;
            if (colGroup) {
                const expanded = states[colGroup.getId()];
                const groupExistedLastTime = expanded != null;
                if (groupExistedLastTime || isInitialState) item.expanded = !!expanded;
            }
        });
    }
    buildTreeFromWhatGridIsDisplaying() {
        $5b7ccabde48fae90$var$syncLayoutWithGrid(this.colModel, this.setColumnLayout.bind(this));
    }
    setColumnLayout(colDefs) {
        const columnTree = $5b7ccabde48fae90$var$toolPanelCreateColumnTree(this.colModel, colDefs);
        this.buildListModel(columnTree);
        this.groupsExist = colDefs.some((colDef)=>{
            return colDef && typeof colDef.children !== "undefined";
        });
        this.markFilteredColumns();
        this.flattenAndFilterModel();
    }
    buildTreeFromProvidedColumnDefs() {
        const colModel = this.colModel;
        this.buildListModel(colModel.getColDefColTree());
        this.groupsExist = !!colModel.colDefCols?.treeDepth;
    }
    buildListModel(columnTree) {
        const columnExpandedListener = this.onColumnExpanded.bind(this);
        const addListeners = (item)=>{
            item.addEventListener("expandedChanged", columnExpandedListener);
            const removeFunc = item.removeEventListener.bind(item, "expandedChanged", columnExpandedListener);
            this.destroyColumnItemFuncs.push(removeFunc);
        };
        const colNames = this.beans.colNames;
        const recursivelyBuild = (tree, depth, parentList)=>{
            for (const child of tree)if ((0, $437b23f6a393c3bf$export$bb4bfad2b594b78e)(child)) createGroupItem(child, depth, parentList);
            else createColumnItem(child, depth, parentList);
        };
        const createGroupItem = (columnGroup, depth, parentList)=>{
            const columnGroupDef = columnGroup.getColGroupDef();
            const skipThisGroup = columnGroupDef?.suppressColumnsToolPanel;
            if (skipThisGroup) return;
            if (columnGroup.isPadding()) {
                recursivelyBuild(columnGroup.getChildren(), depth, parentList);
                return;
            }
            const displayName = colNames.getDisplayNameForProvidedColumnGroup(null, columnGroup, "columnToolPanel");
            const item = new $5b7ccabde48fae90$var$ColumnModelItem(displayName, columnGroup, depth, true, this.expandGroupsByDefault);
            parentList.push(item);
            addListeners(item);
            recursivelyBuild(columnGroup.getChildren(), depth + 1, item.children);
        };
        const createColumnItem = (column, depth, parentList)=>{
            const skipThisColumn = column.getColDef()?.suppressColumnsToolPanel;
            if (skipThisColumn) return;
            const displayName = colNames.getDisplayNameForColumn(column, "columnToolPanel");
            parentList.push(new $5b7ccabde48fae90$var$ColumnModelItem(displayName, column, depth));
        };
        this.destroyColumnTree();
        recursivelyBuild(columnTree, 0, this.allColsTree);
    }
    onColumnExpanded() {
        this.flattenAndFilterModel();
    }
    flattenAndFilterModel() {
        this.displayedColsList = [];
        const recursiveFunc = (item)=>{
            if (!item.passesFilter) return;
            this.displayedColsList.push(item);
            if (item.group && item.expanded) item.children.forEach(recursiveFunc);
        };
        const virtualList = this.virtualList;
        this.allColsTree.forEach(recursiveFunc);
        virtualList.setModel(new $5b7ccabde48fae90$var$UIColumnModel(this.displayedColsList));
        let focusedRow = null;
        if (!this.skipRefocus) focusedRow = virtualList.getLastFocusedRow();
        virtualList.refresh();
        if (focusedRow != null) this.focusRowIfAlive(focusedRow);
        this.notifyListeners();
        this.refreshAriaLabel();
    }
    refreshAriaLabel() {
        const translate = this.getLocaleTextFunc();
        const columnListName = translate("ariaColumnPanelList", "Column List");
        const localeColumns = translate("columns", "Columns");
        const items = this.displayedColsList.length;
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.virtualList.getAriaElement(), `${columnListName} ${items} ${localeColumns}`);
    }
    focusRowIfAlive(rowIndex) {
        if (rowIndex === -1) return Promise.resolve();
        return new Promise((res)=>{
            window.setTimeout(()=>{
                if (this.isAlive()) this.virtualList.focusRow(rowIndex);
                res();
            }, 0);
        });
    }
    forEachItem(callback) {
        const recursiveFunc = (items)=>{
            for (const item of items){
                callback(item);
                if (item.group) recursiveFunc(item.children);
            }
        };
        const allColsTree = this.allColsTree;
        if (!allColsTree) return;
        recursiveFunc(allColsTree);
    }
    doSetExpandedAll(value) {
        this.forEachItem((item)=>{
            if (item.group) item.expanded = value;
        });
    }
    setGroupsExpanded(expand, groupIds) {
        if (!groupIds) {
            this.doSetExpandedAll(expand);
            return;
        }
        const expandedGroupIds = [];
        this.forEachItem((item)=>{
            if (!item.group) return;
            const groupId = item.columnGroup.getId();
            if (groupIds.indexOf(groupId) >= 0) {
                item.expanded = expand;
                expandedGroupIds.push(groupId);
            }
        });
        const unrecognisedGroupIds = groupIds.filter((groupId)=>!expandedGroupIds.includes(groupId));
        if (unrecognisedGroupIds.length > 0) (0, $437b23f6a393c3bf$export$545083624300f13d)(157, {
            unrecognisedGroupIds: unrecognisedGroupIds
        });
    }
    getExpandState() {
        let expandedCount = 0;
        let notExpandedCount = 0;
        this.forEachItem((item)=>{
            if (!item.group) return;
            if (item.expanded) expandedCount++;
            else notExpandedCount++;
        });
        if (expandedCount > 0 && notExpandedCount > 0) return 2 /* INDETERMINATE */ ;
        if (notExpandedCount > 0) return 1 /* COLLAPSED */ ;
        return 0 /* EXPANDED */ ;
    }
    doSetSelectedAll(selectAllChecked) {
        $5b7ccabde48fae90$var$selectAllChildren(this.beans, this.allColsTree, selectAllChecked, this.eventType);
    }
    getSelectionState() {
        let checkedCount = 0;
        let uncheckedCount = 0;
        const pivotMode = this.colModel.isPivotMode();
        this.forEachItem((item)=>{
            if (item.group) return;
            if (!item.passesFilter) return;
            const column = item.column;
            const colDef = column.getColDef();
            let checked;
            if (pivotMode) {
                const noPivotModeOptionsAllowed = !column.isAllowPivot() && !column.isAllowRowGroup() && !column.isAllowValue();
                if (noPivotModeOptionsAllowed) return;
                checked = column.isValueActive() || column.isPivotActive() || column.isRowGroupActive();
            } else {
                if (colDef.lockVisible) return;
                checked = column.isVisible();
            }
            checked ? checkedCount++ : uncheckedCount++;
        });
        if (checkedCount > 0 && uncheckedCount > 0) return void 0;
        return !(checkedCount === 0 || uncheckedCount > 0);
    }
    setFilterText(filterText) {
        this.filterText = (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(filterText) ? filterText.toLowerCase() : null;
        this.markFilteredColumns();
        this.flattenAndFilterModel();
    }
    markFilteredColumns() {
        const passesFilter = (item)=>{
            if (!(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(this.filterText)) return true;
            const displayName = item.displayName;
            return displayName == null || displayName.toLowerCase().indexOf(this.filterText) !== -1;
        };
        const recursivelyCheckFilter = (item, parentPasses)=>{
            let atLeastOneChildPassed = false;
            if (item.group) {
                const groupPasses = passesFilter(item);
                for (const child of item.children){
                    const childPasses = recursivelyCheckFilter(child, groupPasses || parentPasses);
                    if (childPasses) atLeastOneChildPassed = childPasses;
                }
            }
            const filterPasses = parentPasses || atLeastOneChildPassed ? true : passesFilter(item);
            item.passesFilter = filterPasses;
            return filterPasses;
        };
        for (const item of this.allColsTree)recursivelyCheckFilter(item, false);
    }
    notifyListeners() {
        this.fireGroupExpandedEvent();
        this.fireSelectionChangedEvent();
    }
    fireGroupExpandedEvent() {
        const expandState = this.getExpandState();
        this.dispatchLocalEvent({
            type: "groupExpanded",
            state: expandState
        });
    }
    fireSelectionChangedEvent() {
        if (!this.allColsTree) return;
        const selectionState = this.getSelectionState();
        this.dispatchLocalEvent({
            type: "selectionChanged",
            state: selectionState
        });
    }
    getExpandedGroups() {
        const expandedGroupIds = [];
        if (!this.allColsTree) return expandedGroupIds;
        this.forEachItem((item)=>{
            if (item.group && item.expanded) expandedGroupIds.push(item.columnGroup.getId());
        });
        return expandedGroupIds;
    }
};
var $5b7ccabde48fae90$var$AgPrimaryColsListSelector = {
    selector: "AG-PRIMARY-COLS-LIST",
    component: $5b7ccabde48fae90$var$AgPrimaryColsList
};
// packages/ag-grid-enterprise/src/columnToolPanel/agPrimaryCols.ts
var $5b7ccabde48fae90$var$AgPrimaryColsElement = {
    tag: "div",
    cls: "ag-column-select",
    children: [
        {
            tag: "ag-primary-cols-header",
            ref: "primaryColsHeaderPanel"
        },
        {
            tag: "ag-primary-cols-list",
            ref: "primaryColsListPanel"
        }
    ]
};
var $5b7ccabde48fae90$var$AgPrimaryCols = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$AgPrimaryColsElement, [
            $5b7ccabde48fae90$var$AgPrimaryColsHeaderSelector,
            $5b7ccabde48fae90$var$AgPrimaryColsListSelector
        ]);
        this.primaryColsHeaderPanel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.primaryColsListPanel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.registerCSS($5b7ccabde48fae90$var$agPrimaryColsCSS);
    }
    // we allow dragging in the toolPanel, but not when this component appears in the column menu
    init(allowDragging, params, eventType) {
        const { primaryColsHeaderPanel: primaryColsHeaderPanel, primaryColsListPanel: primaryColsListPanel } = this;
        primaryColsHeaderPanel.init(params);
        const hideFilter = params.suppressColumnFilter;
        const hideSelect = params.suppressColumnSelectAll;
        const hideExpand = params.suppressColumnExpandAll;
        if (hideExpand && hideFilter && hideSelect) primaryColsHeaderPanel.setDisplayed(false);
        this.addManagedListeners(primaryColsListPanel, {
            groupExpanded: (event)=>{
                primaryColsHeaderPanel.setExpandState(event.state);
                params.onStateUpdated();
            },
            selectionChanged: (event)=>primaryColsHeaderPanel.setSelectionState(event.state)
        });
        primaryColsListPanel.init(params, allowDragging, eventType);
        this.addManagedListeners(primaryColsHeaderPanel, {
            expandAll: primaryColsListPanel.doSetExpandedAll.bind(primaryColsListPanel, true),
            collapseAll: primaryColsListPanel.doSetExpandedAll.bind(primaryColsListPanel, false),
            selectAll: primaryColsListPanel.doSetSelectedAll.bind(primaryColsListPanel, true),
            unselectAll: primaryColsListPanel.doSetSelectedAll.bind(primaryColsListPanel, false),
            filterChanged: (event)=>primaryColsListPanel.setFilterText(event.filterText)
        });
        this.positionableFeature = this.createManagedBean(new (0, $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6)(this.getGui(), {
            minHeight: 100
        }));
    }
    toggleResizable(resizable) {
        this.positionableFeature.setResizable(resizable ? {
            bottom: true
        } : false);
    }
    expandGroups(groupIds) {
        this.primaryColsListPanel.setGroupsExpanded(true, groupIds);
    }
    collapseGroups(groupIds) {
        this.primaryColsListPanel.setGroupsExpanded(false, groupIds);
    }
    setColumnLayout(colDefs) {
        this.primaryColsListPanel.setColumnLayout(colDefs);
    }
    syncLayoutWithGrid() {
        this.primaryColsListPanel.onColumnsChanged();
    }
    getExpandedGroups() {
        return this.primaryColsListPanel.getExpandedGroups();
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/columnToolPanel.css-GENERATED.ts
var $5b7ccabde48fae90$var$columnToolPanelCSS = /*css*/ `.ag-column-panel{display:flex;flex:1 1 auto;flex-direction:column;overflow:hidden}.ag-pivot-mode-panel{display:flex;height:var(--ag-header-height)}.ag-pivot-mode-select{align-items:center;display:flex}:where(.ag-ltr) .ag-pivot-mode-select{margin-left:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-pivot-mode-select{margin-right:var(--ag-widget-container-horizontal-padding)}.ag-column-panel-column-select{border-bottom:var(--ag-tool-panel-separator-border)}.ag-column-panel-column-select:where(:nth-child(n+2 of :not(.ag-hidden))){border-top:var(--ag-tool-panel-separator-border)}:where(.ag-column-panel) .ag-column-drop-vertical{flex:1 1 0px;min-height:50px;&:where(:not(.ag-last-column-drop)){border-bottom:var(--ag-tool-panel-separator-border)}}`;
// packages/ag-grid-enterprise/src/columnToolPanel/columnToolPanel.ts
var $5b7ccabde48fae90$var$ColumnToolPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-column-panel"
        });
        this.initialised = false;
        this.childDestroyFuncs = [];
        this.registerCSS($5b7ccabde48fae90$var$columnToolPanelCSS);
    }
    wireBeans(beans) {
        this.colToolPanelFactory = beans.colToolPanelFactory;
    }
    // lazy initialise the panel
    setVisible(visible) {
        super.setDisplayed(visible);
        if (visible && !this.initialised) this.init(this.params);
    }
    init(params) {
        const defaultParams = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
            suppressColumnMove: false,
            suppressColumnSelectAll: false,
            suppressColumnFilter: false,
            suppressColumnExpandAll: false,
            contractColumnSelection: false,
            suppressPivotMode: false,
            suppressRowGroups: false,
            suppressValues: false,
            suppressPivots: false,
            suppressSyncLayoutWithGrid: false
        });
        const mergedParams = {
            ...defaultParams,
            ...params
        };
        this.params = mergedParams;
        const { childDestroyFuncs: childDestroyFuncs, colToolPanelFactory: colToolPanelFactory, gos: gos } = this;
        const hasPivotModule = gos.isModuleRegistered("SharedPivot");
        const hasRowGroupingModule = hasPivotModule || gos.isModuleRegistered("SharedRowGrouping");
        if (!mergedParams.suppressPivotMode && colToolPanelFactory && hasPivotModule) this.pivotModePanel = colToolPanelFactory.createPivotModePanel(this, childDestroyFuncs);
        const primaryColsPanel = this.createBean(new $5b7ccabde48fae90$var$AgPrimaryCols());
        this.primaryColsPanel = primaryColsPanel;
        childDestroyFuncs.push(()=>this.destroyBean(this.primaryColsPanel));
        primaryColsPanel.init(true, mergedParams, "toolPanelUi");
        primaryColsPanel.addCss("ag-column-panel-column-select");
        this.appendChild(primaryColsPanel);
        if (colToolPanelFactory) {
            if (!mergedParams.suppressRowGroups && hasRowGroupingModule) this.rowGroupDropZonePanel = colToolPanelFactory.createRowGroupPanel(this, childDestroyFuncs);
            if (!mergedParams.suppressValues && hasRowGroupingModule) this.valuesDropZonePanel = colToolPanelFactory.createValuesPanel(this, childDestroyFuncs);
            if (!mergedParams.suppressPivots && hasPivotModule) this.pivotDropZonePanel = colToolPanelFactory.createPivotPanel(this, childDestroyFuncs);
            this.setLastVisible();
            const [pivotModeListener] = this.addManagedEventListeners({
                columnPivotModeChanged: ()=>{
                    this.resetChildrenHeight();
                    this.setLastVisible();
                }
            });
            childDestroyFuncs.push(()=>pivotModeListener());
        }
        this.initialised = true;
    }
    setPivotModeSectionVisible(visible) {
        const colToolPanelFactory = this.colToolPanelFactory;
        if (!colToolPanelFactory) return;
        this.pivotModePanel = colToolPanelFactory.setPanelVisible(this.pivotModePanel, visible, colToolPanelFactory.createPivotModePanel.bind(colToolPanelFactory, this, this.childDestroyFuncs, true));
        this.setLastVisible();
    }
    setRowGroupsSectionVisible(visible) {
        const colToolPanelFactory = this.colToolPanelFactory;
        if (!colToolPanelFactory) return;
        this.rowGroupDropZonePanel = colToolPanelFactory.setPanelVisible(this.rowGroupDropZonePanel, visible, colToolPanelFactory.createRowGroupPanel.bind(colToolPanelFactory, this, this.childDestroyFuncs));
        this.setLastVisible();
    }
    setValuesSectionVisible(visible) {
        const colToolPanelFactory = this.colToolPanelFactory;
        if (!colToolPanelFactory) return;
        this.valuesDropZonePanel = colToolPanelFactory.setPanelVisible(this.valuesDropZonePanel, visible, colToolPanelFactory.createValuesPanel.bind(colToolPanelFactory, this, this.childDestroyFuncs));
        this.setLastVisible();
    }
    setPivotSectionVisible(visible) {
        const colToolPanelFactory = this.colToolPanelFactory;
        if (!colToolPanelFactory) return;
        this.pivotDropZonePanel = colToolPanelFactory.setPanelVisible(this.pivotDropZonePanel, visible, colToolPanelFactory.createPivotPanel.bind(colToolPanelFactory, this, this.childDestroyFuncs));
        this.pivotDropZonePanel?.setDisplayed(visible);
        this.setLastVisible();
    }
    setResizers() {
        for (const panel of [
            this.primaryColsPanel,
            this.rowGroupDropZonePanel,
            this.valuesDropZonePanel,
            this.pivotDropZonePanel
        ]){
            if (!panel) continue;
            const eGui = panel.getGui();
            panel.toggleResizable(!eGui.classList.contains("ag-last-column-drop") && !eGui.classList.contains("ag-hidden"));
        }
    }
    setLastVisible() {
        const eGui = this.getGui();
        const columnDrops = Array.prototype.slice.call(eGui.querySelectorAll(".ag-column-drop"));
        for (const columnDrop of columnDrops)columnDrop.classList.remove("ag-last-column-drop");
        const columnDropEls = eGui.querySelectorAll(".ag-column-drop:not(.ag-hidden)");
        const lastVisible = (0, $437b23f6a393c3bf$export$236389741107357f)(columnDropEls);
        if (lastVisible) lastVisible.classList.add("ag-last-column-drop");
        this.setResizers();
    }
    resetChildrenHeight() {
        const eGui = this.getGui();
        const children = eGui.children;
        for(let i = 0; i < children.length; i++){
            const { style: style } = children[i];
            style.removeProperty("height");
            style.removeProperty("flex");
        }
    }
    expandColumnGroups(groupIds) {
        this.primaryColsPanel.expandGroups(groupIds);
    }
    collapseColumnGroups(groupIds) {
        this.primaryColsPanel.collapseGroups(groupIds);
    }
    setColumnLayout(colDefs) {
        this.primaryColsPanel.setColumnLayout(colDefs);
    }
    syncLayoutWithGrid() {
        this.primaryColsPanel.syncLayoutWithGrid();
    }
    destroyChildren() {
        const childDestroyFuncs = this.childDestroyFuncs;
        for (const func of childDestroyFuncs)func();
        childDestroyFuncs.length = 0;
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.getGui());
    }
    refresh(params) {
        this.destroyChildren();
        this.init(params);
        return true;
    }
    getState() {
        return {
            expandedGroupIds: this.primaryColsPanel.getExpandedGroups()
        };
    }
    destroy() {
        this.destroyChildren();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/widgets/pillDropZonePanel.css-GENERATED.ts
var $5b7ccabde48fae90$var$pillDropZonePanelCSS = /*css*/ `.ag-column-drop{align-items:center;display:inline-flex;overflow:auto;position:relative;width:100%}.ag-column-drop-list{align-items:center;display:flex}.ag-column-drop-cell{align-items:center;background-color:var(--ag-column-drop-cell-background-color);border:var(--ag-column-drop-cell-border);border-radius:500px;color:var(--ag-column-drop-cell-text-color);display:flex;padding:calc(var(--ag-spacing)*.25);position:relative;&:focus-visible{box-shadow:var(--ag-focus-shadow)}:where(.ag-drag-handle){color:var(--ag-column-drop-cell-drag-handle-color)}}:where(.ag-ltr) .ag-column-drop-cell{padding-left:calc(var(--ag-spacing)*.75)}:where(.ag-rtl) .ag-column-drop-cell{padding-right:calc(var(--ag-spacing)*.75)}.ag-column-drop-cell-text{flex:1 1 auto;margin:0 var(--ag-spacing);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-drop-vertical{align-items:stretch;display:flex;flex-direction:column;min-height:75px;overflow:hidden}.ag-column-drop-vertical-title-bar{align-items:center;display:flex;flex:none;padding:var(--ag-widget-container-vertical-padding) calc(var(--ag-spacing)*2) 0}.ag-column-drop-vertical-list{align-items:stretch;flex-direction:column;flex-grow:1;overflow-x:auto;padding-bottom:var(--ag-spacing);padding-left:var(--ag-spacing);padding-right:var(--ag-spacing);position:relative;>*{flex:none}}:where(.ag-column-drop-empty) .ag-column-drop-vertical-list{overflow:hidden}.ag-column-drop-cell-button{cursor:pointer;min-width:0;opacity:.75;&:hover{opacity:1}}:where(.ag-ltr) .ag-column-drop-cell-button{margin-right:calc(var(--ag-spacing)/4)}:where(.ag-rtl) .ag-column-drop-cell-button{margin-left:calc(var(--ag-spacing)/4)}:where(.ag-ltr) .ag-column-drop-cell-drag-handle{margin-left:calc(var(--ag-spacing)/4)}:where(.ag-rtl) .ag-column-drop-cell-drag-handle{margin-right:calc(var(--ag-spacing)/4)}.ag-column-drop-wrapper{display:flex}.ag-column-drop-horizontal-half-width{width:50%!important}.ag-column-drop-cell-ghost{opacity:.5}.ag-column-drop-horizontal{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;white-space:nowrap}:where(.ag-ltr) .ag-column-drop-horizontal{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-column-drop-horizontal{padding-right:var(--ag-cell-horizontal-padding)}.ag-column-drop-horizontal-list{gap:var(--ag-cell-widget-spacing)}.ag-column-drop-vertical-cell{margin-top:var(--ag-spacing)}:where(.ag-ltr) .ag-column-drop-vertical-icon{margin-right:var(--ag-widget-horizontal-spacing)}:where(.ag-rtl) .ag-column-drop-vertical-icon{margin-left:var(--ag-widget-horizontal-spacing)}.ag-select-agg-func-popup{background:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);height:calc(var(--ag-spacing)*5*3.5);padding:0;position:absolute}.ag-select-agg-func-virtual-list-item{cursor:default;&:hover{background-color:var(--ag-selected-row-background-color)}}:where(.ag-ltr) .ag-select-agg-func-virtual-list-item{padding-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-select-agg-func-virtual-list-item{padding-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-column-drop-horizontal-half-width:where(:not(:last-child)){border-right:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-column-drop-horizontal-half-width:where(:not(:last-child)){border-left:solid var(--ag-border-width) var(--ag-border-color)}`;
// packages/ag-grid-enterprise/src/widgets/pillDropZonePanel.ts
function $5b7ccabde48fae90$var$_insertArrayIntoArray(dest, src, toIndex) {
    if (dest == null || src == null) return;
    dest.splice(toIndex, 0, ...src);
}
var $5b7ccabde48fae90$var$PillDropZonePanelElement = {
    tag: "div",
    cls: "ag-unselectable",
    role: "presentation"
};
var $5b7ccabde48fae90$var$PillDropZonePanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(horizontal){
        super($5b7ccabde48fae90$var$PillDropZonePanelElement);
        this.horizontal = horizontal;
        this.state = "notDragging";
        this.guiDestroyFunctions = [];
        this.childPillComponents = [];
        this.resizeEnabled = false;
        this.addElementClasses(this.getGui());
        this.ePillDropList = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div"
        });
        this.addElementClasses(this.ePillDropList, "list");
        this.registerCSS($5b7ccabde48fae90$var$pillDropZonePanelCSS);
    }
    toggleResizable(resizable) {
        this.positionableFeature.setResizable(resizable ? {
            bottom: true
        } : false);
        this.resizeEnabled = resizable;
    }
    isSourceEventFromTarget(draggingEvent) {
        const { dropZoneTarget: dropZoneTarget, dragSource: dragSource } = draggingEvent;
        return dropZoneTarget.contains(dragSource.eElement);
    }
    destroy() {
        this.destroyGui();
        super.destroy();
    }
    destroyGui() {
        for (const func of this.guiDestroyFunctions)func();
        this.guiDestroyFunctions.length = 0;
        this.childPillComponents.length = 0;
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.getGui());
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.ePillDropList);
    }
    init(params) {
        this.params = params ?? {};
        this.createManagedBean(new (0, $437b23f6a393c3bf$export$5510e53ed3962582)(this.getFocusableElement(), {
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.onKeyDown.bind(this)
        }));
        this.setupDropTarget();
        this.positionableFeature = new (0, $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6)(this.getGui());
        this.createManagedBean(this.positionableFeature);
        this.refreshGui();
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.ePillDropList, this.getAriaLabel());
    }
    onTabKeyDown(e) {
        const focusableElements = (0, $437b23f6a393c3bf$export$7acf44f59625b1f6)(this.getFocusableElement(), null, true);
        const len = focusableElements.length;
        if (len === 0) return;
        const { shiftKey: shiftKey } = e;
        const activeEl = (0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans);
        const isFirstFocused = activeEl === focusableElements[0];
        const isLastFocused = activeEl === (0, $437b23f6a393c3bf$export$236389741107357f)(focusableElements);
        const shouldAllowDefaultTab = len === 1 || isFirstFocused && shiftKey || isLastFocused && !shiftKey;
        if (!shouldAllowDefaultTab) focusableElements[shiftKey ? 0 : len - 1].focus();
    }
    onKeyDown(e) {
        const { key: key } = e;
        const isVertical = !this.horizontal;
        let isNext = key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN;
        let isPrevious = key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP;
        if (!isVertical) {
            const isRtl = this.gos.get("enableRtl");
            isNext = !isRtl && key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT || isRtl && key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT;
            isPrevious = !isRtl && key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT || isRtl && key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT;
        }
        if (!isNext && !isPrevious) return;
        e.preventDefault();
        if (e.shiftKey) this.moveFocusedItem(isPrevious);
        else {
            const el = (0, $437b23f6a393c3bf$export$83fc12531358bd28)(this.beans, this.getFocusableElement(), false, isPrevious);
            if (el) el.focus();
        }
    }
    moveFocusedItem(isPrevious) {
        const currentItemIndex = this.getFocusedItem();
        if (currentItemIndex === -1) return;
        const diff = isPrevious ? -1 : 1;
        const changed = this.normalizeAndUpdateInsertIndex(currentItemIndex, currentItemIndex + diff);
        if (!changed) return;
        const comp = this.childPillComponents[currentItemIndex];
        if (!comp.isMovable()) return;
        const currentItem = comp.getItem();
        this.focusItemAtIndex(this.insertIndex);
        this.rearrangeItems([
            currentItem
        ], true);
    }
    addElementClasses(el, suffix) {
        suffix = suffix ? `-${suffix}` : "";
        const direction = this.horizontal ? "horizontal" : "vertical";
        el.classList.add(`ag-column-drop${suffix}`, `ag-column-drop-${direction}${suffix}`);
    }
    setupDropTarget() {
        this.dropTarget = {
            getContainer: this.getGui.bind(this),
            getIconName: this.getIconName.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragEnter: this.onDragEnter.bind(this),
            onDragLeave: this.onDragLeave.bind(this),
            onDragStop: this.onDragStop.bind(this),
            onDragCancel: this.onDragCancel.bind(this),
            isInterestedIn: this.isInterestedIn.bind(this)
        };
        this.beans.dragAndDrop?.addDropTarget(this.dropTarget);
    }
    minimumAllowedNewInsertIndex() {
        return 0;
    }
    checkInsertIndex(draggingEvent) {
        const newIndex = this.getNewInsertIndex(draggingEvent);
        if (newIndex < 0) return false;
        return this.normalizeAndUpdateInsertIndex(this.insertIndex, newIndex);
    }
    normalizeAndUpdateInsertIndex(currentIndex, index) {
        const minimumAllowedIndex = this.minimumAllowedNewInsertIndex();
        const newAdjustedIndex = Math.max(minimumAllowedIndex, index);
        const changed = newAdjustedIndex !== currentIndex;
        if (changed) this.insertIndex = newAdjustedIndex;
        return changed;
    }
    getNewInsertIndex(draggingEvent) {
        const mouseEvent = draggingEvent.event;
        const mouseLocation = this.horizontal ? mouseEvent.clientX : mouseEvent.clientY;
        const boundsList = this.childPillComponents.map((comp)=>comp.getGui().getBoundingClientRect());
        const hoveredIndex = boundsList.findIndex((rect)=>this.horizontal ? rect.right > mouseLocation && rect.left < mouseLocation : rect.top < mouseLocation && rect.bottom > mouseLocation);
        if (hoveredIndex === -1) {
            const enableRtl = this.gos.get("enableRtl");
            const isLast = boundsList.every((rect)=>mouseLocation > (this.horizontal ? rect.right : rect.bottom));
            if (isLast) return enableRtl && this.horizontal ? 0 : this.childPillComponents.length;
            const isFirst = boundsList.every((rect)=>mouseLocation < (this.horizontal ? rect.left : rect.top));
            if (isFirst) return enableRtl && this.horizontal ? this.childPillComponents.length : 0;
            return this.insertIndex;
        }
        if (this.insertIndex <= hoveredIndex) return hoveredIndex + 1;
        return hoveredIndex;
    }
    checkDragStartedBySelf(draggingEvent) {
        if (this.state !== "notDragging") return;
        this.state = "rearrangeItems";
        this.potentialDndItems = this.getItems(draggingEvent.dragSource.getDragItem());
        this.refreshGui();
        this.checkInsertIndex(draggingEvent);
        this.refreshGui();
    }
    onDragging(draggingEvent) {
        this.checkDragStartedBySelf(draggingEvent);
        if (this.checkInsertIndex(draggingEvent)) this.refreshGui();
    }
    handleDragEnterEnd(_) {}
    onDragEnter(draggingEvent) {
        const dragItems = this.getItems(draggingEvent.dragSource.getDragItem());
        this.state = "newItemsIn";
        const goodDragItems = dragItems.filter((item)=>this.isItemDroppable(item, draggingEvent));
        const alreadyPresent = goodDragItems.every((item)=>this.childPillComponents.map((cmp)=>cmp.getItem()).indexOf(item) !== -1);
        if (goodDragItems.length === 0) return;
        this.potentialDndItems = goodDragItems;
        if (alreadyPresent) {
            this.state = "notDragging";
            return;
        }
        this.handleDragEnterEnd(draggingEvent);
        this.checkInsertIndex(draggingEvent);
        this.refreshGui();
    }
    isPotentialDndItems() {
        return !!this.potentialDndItems?.length;
    }
    handleDragLeaveEnd(_) {}
    onDragLeave(draggingEvent) {
        if (this.state === "rearrangeItems") {
            const items = this.getItems(draggingEvent.dragSource.getDragItem());
            this.removeItems(items);
        }
        if (this.isPotentialDndItems()) {
            this.handleDragLeaveEnd(draggingEvent);
            this.potentialDndItems = [];
            this.refreshGui();
        }
        this.state = "notDragging";
    }
    onDragCancel(draggingEvent) {
        if (this.isPotentialDndItems()) {
            if (this.state === "newItemsIn") this.handleDragLeaveEnd(draggingEvent);
            this.potentialDndItems = [];
            this.refreshGui();
        }
        this.state = "notDragging";
    }
    onDragStop() {
        if (this.isPotentialDndItems()) {
            if (this.state === "newItemsIn") this.addItems(this.potentialDndItems);
            else this.rearrangeItems(this.potentialDndItems);
            this.potentialDndItems = [];
            this.refreshGui();
        }
        this.state = "notDragging";
    }
    removeItems(itemsToRemove) {
        const newItemList = this.getExistingItems().filter((item)=>!itemsToRemove.includes(item));
        this.updateItems(newItemList);
    }
    addItems(itemsToAdd) {
        if (!itemsToAdd) return;
        const newItemList = this.getExistingItems().slice();
        const itemsToAddNoDuplicates = itemsToAdd.filter((item)=>newItemList.indexOf(item) < 0);
        $5b7ccabde48fae90$var$_insertArrayIntoArray(newItemList, itemsToAddNoDuplicates, this.insertIndex);
        this.updateItems(newItemList);
    }
    addItem(item) {
        this.insertIndex = this.getExistingItems().length;
        this.addItems([
            item
        ]);
        this.refreshGui();
    }
    rearrangeItems(itemsToAdd, fromKeyboard) {
        let newItemList;
        if (!fromKeyboard) newItemList = this.getNonGhostItems().slice();
        else newItemList = this.getExistingItems().filter((item)=>itemsToAdd.indexOf(item) === -1);
        $5b7ccabde48fae90$var$_insertArrayIntoArray(newItemList, itemsToAdd, this.insertIndex);
        if ((0, $437b23f6a393c3bf$export$893967cdb9833fdd)(newItemList, this.getExistingItems())) return false;
        this.updateItems(newItemList);
        return true;
    }
    refreshGui() {
        let scrollTop = 0;
        if (!this.horizontal) scrollTop = this.ePillDropList.scrollTop;
        const resizeEnabled = this.resizeEnabled;
        const focusedIndex = this.getFocusedItem();
        const { eGridDiv: eGridDiv } = this.beans;
        const isKeyboardMode = (0, $437b23f6a393c3bf$export$e4c8c227337b7f23)();
        let alternateElement = null;
        if (isKeyboardMode) alternateElement = (0, $437b23f6a393c3bf$export$83fc12531358bd28)(this.beans, eGridDiv) ?? (0, $437b23f6a393c3bf$export$83fc12531358bd28)(this.beans, eGridDiv, false, true);
        this.toggleResizable(false);
        this.destroyGui();
        this.addIconAndTitleToGui();
        this.addEmptyMessageToGui();
        this.addItemsToGui();
        if (scrollTop !== 0) this.ePillDropList.scrollTop = scrollTop;
        if (resizeEnabled) this.toggleResizable(resizeEnabled);
        if (isKeyboardMode) this.restoreFocus(focusedIndex, alternateElement);
    }
    getFocusedItem() {
        const eGui = this.getGui();
        const activeElement = (0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans);
        if (!eGui.contains(activeElement)) return -1;
        const items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));
        return items.indexOf(activeElement);
    }
    focusItemAtIndex(index) {
        const eGui = this.getGui();
        const items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));
        const item = items[index];
        if (!item) return;
        item.focus({
            preventScroll: true
        });
    }
    restoreFocus(index, alternateElement) {
        const eGui = this.getGui();
        const items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));
        if (index === -1) return;
        if (items.length === 0) alternateElement.focus();
        const indexToFocus = Math.min(items.length - 1, index);
        const el = items[indexToFocus];
        if (el) el.focus();
    }
    focusList(fromBottom) {
        const index = fromBottom ? this.childPillComponents.length - 1 : 0;
        this.restoreFocus(index, this.getFocusableElement());
    }
    getNonGhostItems() {
        const existingItems = this.getExistingItems();
        if (this.isPotentialDndItems()) return existingItems.filter((item)=>!this.potentialDndItems.includes(item));
        return existingItems;
    }
    addItemsToGui() {
        const nonGhostItems = this.getNonGhostItems();
        const itemsToAddToGui = nonGhostItems.map((item)=>this.createItemComponent(item, false));
        if (this.isPotentialDndItems()) {
            const dndItems = this.potentialDndItems.map((item)=>this.createItemComponent(item, true));
            if (this.insertIndex >= itemsToAddToGui.length) itemsToAddToGui.push(...dndItems);
            else itemsToAddToGui.splice(this.insertIndex, 0, ...dndItems);
        }
        this.appendChild(this.ePillDropList);
        itemsToAddToGui.forEach((itemComponent, index)=>{
            if (index > 0) this.addArrow(this.ePillDropList);
            this.ePillDropList.appendChild(itemComponent.getGui());
        });
        this.addAriaLabelsToComponents();
    }
    addAriaLabelsToComponents() {
        const { childPillComponents: childPillComponents, ePillDropList: ePillDropList } = this;
        const len = childPillComponents.length;
        (0, $437b23f6a393c3bf$export$f8d01fa01787902)(ePillDropList, len === 0 ? "presentation" : "listbox");
        for(let i = 0; i < len; i++){
            const comp = childPillComponents[i];
            const eGui = comp.getGui();
            (0, $437b23f6a393c3bf$export$c3d3aede41065a84)(eGui, i + 1);
            (0, $437b23f6a393c3bf$export$3d494c2007bbcac1)(eGui, len);
        }
    }
    createItemComponent(item, ghost) {
        const itemComponent = this.createPillComponent(item, this.dropTarget, ghost, this.horizontal);
        itemComponent.addEventListener("columnRemove", this.removeItems.bind(this, [
            item
        ]));
        this.createBean(itemComponent);
        this.guiDestroyFunctions.push(()=>this.destroyBean(itemComponent));
        if (!ghost) this.childPillComponents.push(itemComponent);
        return itemComponent;
    }
    addIconAndTitleToGui() {
        const { title: title, icon: eGroupIcon } = this.params;
        if (!title || !eGroupIcon) return;
        const eTitleBar = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div"
        });
        (0, $437b23f6a393c3bf$export$ee52c2b3744c455d)(eTitleBar, true);
        this.addElementClasses(eTitleBar, "title-bar");
        this.addElementClasses(eGroupIcon, "icon");
        this.toggleCss("ag-column-drop-empty", this.isExistingItemsEmpty());
        eTitleBar.appendChild(eGroupIcon);
        if (!this.horizontal) {
            const eTitle = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
                tag: "span"
            });
            this.addElementClasses(eTitle, "title");
            eTitle.textContent = title;
            eTitleBar.appendChild(eTitle);
        }
        this.appendChild(eTitleBar);
    }
    isExistingItemsEmpty() {
        return this.getExistingItems().length === 0;
    }
    addEmptyMessageToGui() {
        const { emptyMessage: emptyMessage } = this.params;
        if (!emptyMessage || !this.isExistingItemsEmpty() || this.isPotentialDndItems()) return;
        const eMessage = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "span"
        });
        eMessage.textContent = emptyMessage;
        this.addElementClasses(eMessage, "empty-message");
        this.ePillDropList.appendChild(eMessage);
    }
    addArrow(eParent) {
        if (this.horizontal) {
            const enableRtl = this.gos.get("enableRtl");
            const icon = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(enableRtl ? "panelDelimiterRtl" : "panelDelimiter", this.beans);
            this.addElementClasses(icon, "cell-separator");
            eParent.appendChild(icon);
        }
    }
};
var $5b7ccabde48fae90$var$PillDragCompElement = {
    tag: "span",
    role: "option",
    children: [
        {
            tag: "span",
            ref: "eDragHandle",
            cls: "ag-drag-handle ag-column-drop-cell-drag-handle",
            role: "presentation"
        },
        {
            tag: "span",
            ref: "eText",
            cls: "ag-column-drop-cell-text",
            attrs: {
                "aria-hidden": "true"
            }
        },
        {
            tag: "span",
            ref: "eButton",
            cls: "ag-column-drop-cell-button",
            role: "presentation"
        }
    ]
};
var $5b7ccabde48fae90$var$PillDragComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(dragSourceDropTarget, ghost, horizontal, template, agComponents){
        super();
        this.dragSourceDropTarget = dragSourceDropTarget;
        this.ghost = ghost;
        this.horizontal = horizontal;
        this.template = template;
        this.agComponents = agComponents;
        this.eText = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eDragHandle = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eButton = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        this.setTemplate(this.template ?? $5b7ccabde48fae90$var$PillDragCompElement, this.agComponents);
        const eGui = this.getGui();
        const { beans: beans, eDragHandle: eDragHandle, eText: eText, eButton: eButton } = this;
        this.addElementClasses(eGui);
        this.addElementClasses(eDragHandle, "drag-handle");
        this.addElementClasses(eText, "text");
        this.addElementClasses(eButton, "button");
        eDragHandle.appendChild((0, $437b23f6a393c3bf$export$d8feba07bf373edb)("columnDrag", beans));
        eButton.appendChild((0, $437b23f6a393c3bf$export$d8feba07bf373edb)("cancel", beans));
        this.tooltipFeature = this.createOptionalManagedBean(beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui()
        }));
        this.setupComponents();
        if (!this.ghost && this.isDraggable()) this.addDragSource();
        this.setupAria();
        this.setupTooltip();
        this.activateTabIndex();
        this.refreshDraggable();
    }
    isDraggable() {
        return true;
    }
    refreshDraggable() {
        this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !this.isDraggable());
    }
    setupAria() {
        const translate = this.getLocaleTextFunc();
        const ariaInstructions = [
            this.getAriaDisplayName()
        ];
        this.addAdditionalAriaInstructions(ariaInstructions, translate);
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.getGui(), ariaInstructions.join(". "));
    }
    addAdditionalAriaInstructions(ariaInstructions, translate) {
        if (this.isRemovable()) {
            const deleteAria = translate("ariaDropZoneColumnComponentDescription", "Press DELETE to remove");
            ariaInstructions.push(deleteAria);
        }
    }
    setupTooltip() {
        const refresh = ()=>this.tooltipFeature?.setTooltipAndRefresh(this.getTooltip());
        refresh();
        this.addManagedEventListeners({
            newColumnsLoaded: refresh
        });
    }
    getDragSourceId() {
        return void 0;
    }
    getDefaultIconName() {
        return "notAllowed";
    }
    addDragSource() {
        const { beans: { dragAndDrop: dragAndDrop }, eDragHandle: eDragHandle } = this;
        const getDragItem = this.createGetDragItem();
        const defaultIconName = this.getDefaultIconName();
        const dragSource = {
            type: this.getDragSourceType(),
            sourceId: this.getDragSourceId(),
            eElement: eDragHandle,
            getDefaultIconName: ()=>defaultIconName,
            getDragItem: getDragItem,
            dragItemName: this.getDisplayName()
        };
        dragAndDrop?.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>dragAndDrop?.removeDragSource(dragSource));
    }
    setupComponents() {
        this.eText.textContent = this.getDisplayValue();
        this.setupRemove();
        if (this.ghost) this.addCss("ag-column-drop-cell-ghost");
    }
    isRemovable() {
        return true;
    }
    refreshRemove() {
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eButton, this.isRemovable());
    }
    setupRemove() {
        this.refreshRemove();
        const agEvent = {
            type: "columnRemove"
        };
        this.addGuiEventListener("keydown", (e)=>this.onKeyDown(e));
        this.addManagedElementListeners(this.eButton, {
            click: (mouseEvent)=>{
                this.dispatchLocalEvent(agEvent);
                mouseEvent.stopPropagation();
            }
        });
        const touchListener = new (0, $437b23f6a393c3bf$export$7b2e93987414b382)(this.eButton);
        this.addManagedListeners(touchListener, {
            tap: ()=>this.dispatchLocalEvent(agEvent)
        });
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    }
    onKeyDown(e) {
        const isDelete = e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DELETE;
        if (isDelete) {
            if (this.isRemovable()) {
                e.preventDefault();
                this.dispatchLocalEvent({
                    type: "columnRemove"
                });
            }
        }
    }
    getDisplayValue() {
        return this.getDisplayName();
    }
    addElementClasses(el, suffix) {
        suffix = suffix ? `-${suffix}` : "";
        const direction = this.horizontal ? "horizontal" : "vertical";
        el.classList.add(`ag-column-drop-cell${suffix}`, `ag-column-drop-${direction}-cell${suffix}`);
    }
    destroy() {
        super.destroy();
        this.dragSourceDropTarget = null;
    }
};
// packages/ag-grid-enterprise/src/rowGrouping/columnDropZones/dropZoneColumnComp.ts
var $5b7ccabde48fae90$var$DropZoneColumnComp = class extends $5b7ccabde48fae90$var$PillDragComp {
    constructor(column, dragSourceDropTarget, ghost, dropZonePurpose, horizontal){
        super(dragSourceDropTarget, ghost, horizontal);
        this.column = column;
        this.dropZonePurpose = dropZonePurpose;
        this.eSortIndicator = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.popupShowing = false;
    }
    postConstruct() {
        const { sortSvc: sortSvc, colNames: colNames } = this.beans;
        this.template = {
            tag: "span",
            role: "option",
            children: [
                {
                    tag: "span",
                    ref: "eDragHandle",
                    cls: "ag-drag-handle ag-column-drop-cell-drag-handle",
                    role: "presentation"
                },
                {
                    tag: "span",
                    ref: "eText",
                    cls: "ag-column-drop-cell-text",
                    attrs: {
                        "aria-hidden": "true"
                    }
                },
                sortSvc ? {
                    tag: "ag-sort-indicator",
                    ref: "eSortIndicator"
                } : void 0,
                {
                    tag: "span",
                    ref: "eButton",
                    cls: "ag-column-drop-cell-button",
                    role: "presentation"
                }
            ]
        };
        if (sortSvc) this.agComponents = [
            sortSvc.getSortIndicatorSelector()
        ];
        this.displayName = colNames.getDisplayNameForColumn(this.column, "columnDrop");
        super.postConstruct();
        if (sortSvc) {
            this.setupSort();
            this.addManagedEventListeners({
                sortChanged: ()=>{
                    this.setupAria();
                }
            });
        }
        if (this.isGroupingZone()) this.addManagedPropertyListener("groupLockGroupColumns", ()=>{
            this.refreshRemove();
            this.refreshDraggable();
            this.setupAria();
        });
    }
    getItem() {
        return this.column;
    }
    getDisplayName() {
        return this.displayName;
    }
    getTooltip() {
        return this.column.getColDef().headerTooltip;
    }
    addAdditionalAriaInstructions(ariaInstructions, translate) {
        const isSortSuppressed = this.gos.get("rowGroupPanelSuppressSort");
        const isFunctionsReadOnly = this.gos.get("functionsReadOnly");
        if (this.isAggregationZone() && !isFunctionsReadOnly) {
            const aggregationMenuAria = translate("ariaDropZoneColumnValueItemDescription", "Press ENTER to change the aggregation type");
            ariaInstructions.push(aggregationMenuAria);
        }
        if (this.isGroupingZone() && this.column.isSortable() && !isSortSuppressed) {
            const sortProgressAria = translate("ariaDropZoneColumnGroupItemDescription", "Press ENTER to sort");
            ariaInstructions.push(sortProgressAria);
        }
        super.addAdditionalAriaInstructions(ariaInstructions, translate);
    }
    isMovable() {
        return this.isDraggable();
    }
    isDraggable() {
        return this.isReadOnly();
    }
    isRemovable() {
        return this.isReadOnly();
    }
    isReadOnly() {
        return !this.isGroupingAndLocked() && !this.gos.get("functionsReadOnly");
    }
    getAriaDisplayName() {
        const translate = this.getLocaleTextFunc();
        const { name: name, aggFuncName: aggFuncName } = this.getColumnAndAggFuncName();
        const aggSeparator = translate("ariaDropZoneColumnComponentAggFuncSeparator", " of ");
        const sortDirection = {
            asc: translate("ariaDropZoneColumnComponentSortAscending", "ascending"),
            desc: translate("ariaDropZoneColumnComponentSortDescending", "descending")
        };
        const columnSort = this.column.getSort();
        const isSortSuppressed = this.gos.get("rowGroupPanelSuppressSort");
        return [
            aggFuncName && `${aggFuncName}${aggSeparator}`,
            name,
            this.isGroupingZone() && !isSortSuppressed && columnSort && `, ${sortDirection[columnSort]}`
        ].filter((part)=>!!part).join("");
    }
    getColumnAndAggFuncName() {
        const name = this.displayName;
        let aggFuncName = "";
        if (this.isAggregationZone()) {
            const aggFunc = this.column.getAggFunc();
            const aggFuncString = typeof aggFunc === "string" ? aggFunc : "agg";
            const localeTextFunc = this.getLocaleTextFunc();
            aggFuncName = localeTextFunc(aggFuncString, aggFuncString);
        }
        return {
            name: name,
            aggFuncName: aggFuncName
        };
    }
    setupSort() {
        if (!this.column.isSortable() || !this.isGroupingZone()) return;
        if (!this.gos.get("rowGroupPanelSuppressSort")) {
            this.eSortIndicator.setupSort(this.column, true);
            const performSort = (event)=>{
                event.preventDefault();
                this.beans.sortSvc.progressSortFromEvent(this.column, event);
            };
            this.addGuiEventListener("click", performSort);
            this.addGuiEventListener("keydown", (e)=>{
                const isEnter = e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER;
                if (isEnter && this.isGroupingZone()) performSort(e);
            });
        }
    }
    getDefaultIconName() {
        return "hide";
    }
    createGetDragItem() {
        const { column: column } = this;
        return ()=>{
            const visibleState = {};
            visibleState[column.getId()] = column.isVisible();
            return {
                columns: [
                    column
                ],
                visibleState: visibleState
            };
        };
    }
    setupComponents() {
        super.setupComponents();
        if (this.isAggregationZone() && !this.gos.get("functionsReadOnly")) this.addGuiEventListener("click", this.onShowAggFuncSelection.bind(this));
    }
    onKeyDown(e) {
        super.onKeyDown(e);
        const isEnter = e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER;
        if (isEnter && this.isAggregationZone() && !this.gos.get("functionsReadOnly")) {
            e.preventDefault();
            this.onShowAggFuncSelection();
        }
    }
    getDisplayValue() {
        const { name: name, aggFuncName: aggFuncName } = this.getColumnAndAggFuncName();
        return this.isAggregationZone() ? `${aggFuncName}(${name})` : name;
    }
    onShowAggFuncSelection() {
        if (this.popupShowing) return;
        this.popupShowing = true;
        const { aggFuncSvc: aggFuncSvc, popupSvc: popupSvc } = this.beans;
        const virtualList = new $5b7ccabde48fae90$var$VirtualList({
            cssIdentifier: "select-agg-func"
        });
        const rows = aggFuncSvc.getFuncNames(this.column);
        const eGui = this.getGui();
        const virtualListGui = virtualList.getGui();
        virtualList.setModel({
            getRow: function(index) {
                return rows[index];
            },
            getRowCount: function() {
                return rows.length;
            }
        });
        this.createBean(virtualList);
        const ePopup = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div",
            cls: "ag-select-agg-func-popup"
        });
        ePopup.style.top = "0px";
        ePopup.style.left = "0px";
        ePopup.appendChild(virtualListGui);
        ePopup.style.width = `${eGui.clientWidth}px`;
        const [focusoutListener] = this.addManagedElementListeners(ePopup, {
            focusout: (e)=>{
                if (!ePopup.contains(e.relatedTarget) && addPopupRes) addPopupRes.hideFunc();
            }
        });
        const popupHiddenFunc = (callbackEvent)=>{
            this.destroyBean(virtualList);
            this.popupShowing = false;
            if (callbackEvent?.key === "Escape") eGui.focus();
            if (focusoutListener) focusoutListener();
        };
        const translate = this.getLocaleTextFunc();
        const addPopupRes = popupSvc.addPopup({
            modal: true,
            eChild: ePopup,
            closeOnEsc: true,
            closedCallback: popupHiddenFunc,
            ariaLabel: translate("ariaLabelAggregationFunction", "Aggregation Function")
        });
        if (addPopupRes) virtualList.setComponentCreator(this.createAggSelect.bind(this, addPopupRes.hideFunc));
        virtualList.addGuiEventListener("keydown", (e)=>{
            if (e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER || e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE) {
                const row = virtualList.getLastFocusedRow();
                if (row == null) return;
                const comp = virtualList.getComponentAt(row);
                if (comp) comp.selectItem();
            }
        });
        popupSvc.positionPopupByComponent({
            type: "aggFuncSelect",
            eventSource: eGui,
            ePopup: ePopup,
            keepWithinBounds: true,
            additionalParams: {
                column: this.column
            },
            position: "under"
        });
        virtualList.refresh();
        let rowToFocus = rows.findIndex((r)=>r === this.column.getAggFunc());
        if (rowToFocus === -1) rowToFocus = 0;
        virtualList.focusRow(rowToFocus);
    }
    createAggSelect(hidePopup, value) {
        const itemSelected = ()=>{
            hidePopup();
            this.getGui().focus();
            this.beans.valueColsSvc?.setColumnAggFunc?.(this.column, value, "toolPanelDragAndDrop");
        };
        const localeTextFunc = this.getLocaleTextFunc();
        const aggFuncString = value.toString();
        const aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
        const comp = new $5b7ccabde48fae90$var$AggItemComp(itemSelected, aggFuncStringTranslated);
        return comp;
    }
    isGroupingAndLocked() {
        return this.isGroupingZone() && $5b7ccabde48fae90$var$isRowGroupColLocked(this.column, this.beans);
    }
    isAggregationZone() {
        return this.dropZonePurpose === "aggregation";
    }
    isGroupingZone() {
        return this.dropZonePurpose === "rowGroup";
    }
    getDragSourceType() {
        return (0, $437b23f6a393c3bf$export$46ba5a92125911d9).ToolPanel;
    }
    destroy() {
        super.destroy();
        this.column = null;
    }
};
var $5b7ccabde48fae90$var$AggItemComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(itemSelected, value){
        super({
            tag: "div",
            cls: "ag-select-agg-func-item",
            children: value
        });
        this.selectItem = itemSelected;
        this.addGuiEventListener("click", this.selectItem);
    }
};
// packages/ag-grid-enterprise/src/rowGrouping/columnDropZones/baseDropZonePanel.ts
var $5b7ccabde48fae90$var$BaseDropZonePanel = class extends $5b7ccabde48fae90$var$PillDropZonePanel {
    constructor(horizontal, dropZonePurpose){
        super(horizontal);
        this.dropZonePurpose = dropZonePurpose;
        this.addElementClasses(this.getGui(), this.dropZonePurpose.toLowerCase());
    }
    init(params) {
        super.init(params);
        this.addManagedEventListeners({
            newColumnsLoaded: this.refreshGui.bind(this)
        });
        this.addManagedPropertyListeners([
            "functionsReadOnly",
            "rowGroupPanelSuppressSort",
            "groupLockGroupColumns"
        ], this.refreshGui.bind(this));
    }
    getItems(dragItem) {
        return dragItem.columns ?? [];
    }
    isInterestedIn(type) {
        return type === (0, $437b23f6a393c3bf$export$46ba5a92125911d9).HeaderCell || type === (0, $437b23f6a393c3bf$export$46ba5a92125911d9).ToolPanel;
    }
    minimumAllowedNewInsertIndex() {
        const { gos: gos, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        const numberOfLockedCols = gos.get("groupLockGroupColumns");
        const numberOfGroupCols = rowGroupColsSvc?.columns.length ?? 0;
        if (numberOfLockedCols === -1) return numberOfGroupCols;
        return Math.min(numberOfLockedCols, numberOfGroupCols);
    }
    showOrHideColumnOnExit(draggingEvent) {
        return this.isRowGroupPanel() && (0, $437b23f6a393c3bf$export$d80073cdfb810fa8)(this.gos, true) && !draggingEvent.fromNudge;
    }
    handleDragEnterEnd(draggingEvent) {
        const hideColumnOnExit = this.showOrHideColumnOnExit(draggingEvent);
        if (hideColumnOnExit) {
            const dragItem = draggingEvent.dragSource.getDragItem();
            const columns = dragItem.columns;
            this.setColumnsVisible(columns, false, "uiColumnDragged");
        }
    }
    handleDragLeaveEnd(draggingEvent) {
        const showColumnOnExit = this.showOrHideColumnOnExit(draggingEvent);
        if (showColumnOnExit) {
            const dragItem = draggingEvent.dragSource.getDragItem();
            this.setColumnsVisible(dragItem.columns, true, "uiColumnDragged");
        }
    }
    setColumnsVisible(columns, visible, source) {
        if (columns) {
            const allowedCols = columns.filter((c)=>!c.getColDef().lockVisible);
            this.beans.colModel.setColsVisible(allowedCols, visible, source);
        }
    }
    isRowGroupPanel() {
        return this.dropZonePurpose === "rowGroup";
    }
    createPillComponent(column, dropTarget, ghost, horizontal) {
        return new $5b7ccabde48fae90$var$DropZoneColumnComp(column, dropTarget, ghost, this.dropZonePurpose, horizontal);
    }
};
// packages/ag-grid-enterprise/src/rowGrouping/columnDropZones/pivotDropZonePanel.ts
var $5b7ccabde48fae90$var$PivotDropZonePanel = class extends $5b7ccabde48fae90$var$BaseDropZonePanel {
    constructor(horizontal){
        super(horizontal, "pivot");
    }
    postConstruct() {
        const localeTextFunc = this.getLocaleTextFunc();
        const emptyMessage = localeTextFunc("pivotColumnsEmptyMessage", "Drag here to set column labels");
        const title = localeTextFunc("pivots", "Column Labels");
        super.init({
            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("pivotPanel", this.beans, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addManagedEventListeners({
            newColumnsLoaded: this.refresh.bind(this),
            columnPivotChanged: this.refresh.bind(this),
            columnPivotModeChanged: this.checkVisibility.bind(this)
        });
        this.refresh();
    }
    getAriaLabel() {
        const translate = this.getLocaleTextFunc();
        const label = translate("ariaPivotDropZonePanelLabel", "Column Labels");
        return label;
    }
    refresh() {
        this.checkVisibility();
        this.refreshGui();
    }
    checkVisibility() {
        const colModel = this.beans.colModel;
        const pivotMode = colModel.isPivotMode();
        if (this.horizontal) switch(this.gos.get("pivotPanelShow")){
            case "always":
                this.setDisplayed(pivotMode);
                break;
            case "onlyWhenPivoting":
                {
                    const pivotActive = colModel.isPivotActive();
                    this.setDisplayed(pivotMode && pivotActive);
                    break;
                }
            default:
                this.setDisplayed(false);
                break;
        }
        else this.setDisplayed(pivotMode);
    }
    isItemDroppable(column, draggingEvent) {
        if (this.gos.get("functionsReadOnly") || !column.isPrimary()) return false;
        return column.isAllowPivot() && (!column.isPivotActive() || this.isSourceEventFromTarget(draggingEvent));
    }
    updateItems(columns) {
        this.beans.pivotColsSvc?.setColumns(columns, "toolPanelUi");
    }
    getIconName() {
        return this.isPotentialDndItems() ? "pivot" : "notAllowed";
    }
    getExistingItems() {
        return this.beans.pivotColsSvc?.columns ?? [];
    }
};
var $5b7ccabde48fae90$var$RowGroupDropZonePanel = class extends $5b7ccabde48fae90$var$BaseDropZonePanel {
    constructor(horizontal){
        super(horizontal, "rowGroup");
    }
    postConstruct() {
        const localeTextFunc = this.getLocaleTextFunc();
        const emptyMessage = localeTextFunc("rowGroupColumnsEmptyMessage", "Drag here to set row groups");
        const title = localeTextFunc("groups", "Row Groups");
        super.init({
            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("rowGroupPanel", this.beans, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addManagedEventListeners({
            columnRowGroupChanged: this.refreshGui.bind(this)
        });
    }
    getAriaLabel() {
        const translate = this.getLocaleTextFunc();
        const label = translate("ariaRowGroupDropZonePanelLabel", "Row Groups");
        return label;
    }
    isItemDroppable(column, draggingEvent) {
        if (this.gos.get("functionsReadOnly") || !column.isPrimary() || column.colDef.showRowGroup) return false;
        return column.isAllowRowGroup() && (!column.isRowGroupActive() || this.isSourceEventFromTarget(draggingEvent));
    }
    updateItems(columns) {
        this.beans.rowGroupColsSvc?.setColumns(columns, "toolPanelUi");
    }
    getIconName() {
        return this.isPotentialDndItems() ? "group" : "notAllowed";
    }
    getExistingItems() {
        return this.beans.rowGroupColsSvc?.columns ?? [];
    }
};
var $5b7ccabde48fae90$var$ValuesDropZonePanel = class extends $5b7ccabde48fae90$var$BaseDropZonePanel {
    constructor(horizontal){
        super(horizontal, "aggregation");
    }
    postConstruct() {
        const localeTextFunc = this.getLocaleTextFunc();
        const emptyMessage = localeTextFunc("valueColumnsEmptyMessage", "Drag here to aggregate");
        const title = localeTextFunc("values", "Values");
        super.init({
            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("valuePanel", this.beans, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addManagedEventListeners({
            columnValueChanged: this.refreshGui.bind(this)
        });
    }
    getAriaLabel() {
        const translate = this.getLocaleTextFunc();
        const label = translate("ariaValuesDropZonePanelLabel", "Values");
        return label;
    }
    getIconName() {
        return this.isPotentialDndItems() ? "aggregate" : "notAllowed";
    }
    isItemDroppable(column, draggingEvent) {
        if (this.gos.get("functionsReadOnly") || !column.isPrimary()) return false;
        return column.isAllowValue() && (!column.isValueActive() || this.isSourceEventFromTarget(draggingEvent));
    }
    updateItems(columns) {
        this.beans.valueColsSvc?.setColumns(columns, "toolPanelUi");
    }
    getExistingItems() {
        return this.beans.valueColsSvc?.columns ?? [];
    }
};
var $5b7ccabde48fae90$var$PivotModePanelElement = {
    tag: "div",
    cls: "ag-pivot-mode-panel",
    children: [
        {
            tag: "ag-toggle-button",
            ref: "cbPivotMode",
            cls: "ag-pivot-mode-select"
        }
    ]
};
var $5b7ccabde48fae90$var$PivotModePanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.cbPivotMode = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        this.setTemplate($5b7ccabde48fae90$var$PivotModePanelElement, [
            (0, $437b23f6a393c3bf$export$b825a5135f318030)
        ]);
        const cbPivotMode = this.cbPivotMode;
        const { colModel: colModel, ctrlsSvc: ctrlsSvc, gos: gos } = this.beans;
        cbPivotMode.setValue(colModel.isPivotMode());
        const localeTextFunc = this.getLocaleTextFunc();
        cbPivotMode.setLabel(localeTextFunc("pivotMode", "Pivot Mode"));
        const onBtPivotMode = ()=>{
            const newValue = !!cbPivotMode.getValue();
            if (newValue !== colModel.isPivotMode()) {
                gos.updateGridOptions({
                    options: {
                        pivotMode: newValue
                    },
                    source: "toolPanelUi"
                });
                for (const c of ctrlsSvc.getHeaderRowContainerCtrls())c.refresh();
            }
        };
        const onPivotModeChanged = ()=>{
            const pivotModeActive = colModel.isPivotMode();
            cbPivotMode.setValue(pivotModeActive);
        };
        this.addManagedListeners(cbPivotMode, {
            fieldValueChanged: onBtPivotMode
        });
        this.addManagedEventListeners({
            newColumnsLoaded: onPivotModeChanged,
            columnPivotModeChanged: onPivotModeChanged
        });
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/columnToolPanelFactory.ts
var $5b7ccabde48fae90$var$ColumnToolPanelFactory = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "colToolPanelFactory";
    }
    setPanelVisible(existingPanel, visible, createFunc) {
        if (existingPanel) existingPanel.setDisplayed(visible);
        else if (visible) existingPanel = createFunc();
        return existingPanel;
    }
    createRowGroupPanel(parent, destroyFuncs) {
        return this.createPanel(parent, destroyFuncs, new $5b7ccabde48fae90$var$RowGroupDropZonePanel(false));
    }
    createValuesPanel(parent, destroyFuncs) {
        return this.createPanel(parent, destroyFuncs, new $5b7ccabde48fae90$var$ValuesDropZonePanel(false));
    }
    createPivotPanel(parent, destroyFuncs) {
        return this.createPanel(parent, destroyFuncs, new $5b7ccabde48fae90$var$PivotDropZonePanel(false));
    }
    createPivotModePanel(parent, destroyFuncs, prepend) {
        return this.createPanel(parent, destroyFuncs, new $5b7ccabde48fae90$var$PivotModePanel(), prepend);
    }
    createPanel(parent, destroyFuncs, panel, prepend) {
        panel = parent.createBean(panel);
        destroyFuncs.push(()=>parent.destroyBean(panel));
        if (prepend) parent.prependChild(panel);
        else parent.appendChild(panel);
        return panel;
    }
};
// packages/ag-grid-enterprise/src/columnToolPanel/columnsToolPanelModule.ts
var $5b7ccabde48fae90$export$8ff0dc87b3f8200e = {
    moduleName: "ColumnsToolPanel",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$ColumnToolPanelFactory
    ],
    userComponents: {
        agColumnsToolPanel: $5b7ccabde48fae90$var$ColumnToolPanel
    },
    icons: {
        ensureColumnVisible: "column-arrow",
        // column tool panel tab
        columnsToolPanel: "columns",
        // "Group by {column-name}" item in column header menu
        menuAddRowGroup: "group",
        // "Un-Group by {column-name}" item in column header menu
        menuRemoveRowGroup: "group",
        // identifies the pivot drop zone
        pivotPanel: "pivot",
        // "Row groups" drop zone in column tool panel
        rowGroupPanel: "group",
        // columns tool panel Values drop zone
        valuePanel: "aggregation",
        // column tool panel column group contracted (click to expand)
        columnSelectClosed: "tree-closed",
        // column tool panel column group expanded (click to contract)
        columnSelectOpen: "tree-open",
        // column tool panel header expand/collapse all button, shown when some children are expanded and
        //     others are collapsed
        columnSelectIndeterminate: "tree-indeterminate"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        $5b7ccabde48fae90$export$707a9bd30915b7fe,
        (0, $437b23f6a393c3bf$export$1458fbffed29c925),
        (0, $437b23f6a393c3bf$export$4ad116d131ade5b4),
        (0, $437b23f6a393c3bf$export$da5c9bb998e6c24d),
        $5b7ccabde48fae90$var$MenuItemModule
    ]
};
var $5b7ccabde48fae90$var$ChartMenuItemMapper = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "chartMenuItemMapper";
    }
    getChartItems(key) {
        const beans = this.beans;
        const chartSvc = beans.chartSvc;
        const isPivot = key === "pivotChart";
        if (!chartSvc) return null;
        const getLocaleTextFunc = this.getLocaleTextFunc.bind(this);
        const builder = isPivot ? new $5b7ccabde48fae90$var$PivotMenuItemMapper(beans, chartSvc, getLocaleTextFunc) : new $5b7ccabde48fae90$var$RangeMenuItemMapper(beans, chartSvc, getLocaleTextFunc);
        const isEnterprise = chartSvc.isEnterprise();
        let topLevelMenuItem = builder.getMenuItem();
        if (topLevelMenuItem?.subMenu && !isEnterprise) {
            const filterEnterpriseItems = (m)=>({
                    ...m,
                    subMenu: m.subMenu?.filter((menu)=>!menu._enterprise).map((menu)=>filterEnterpriseItems(menu))
                });
            topLevelMenuItem = filterEnterpriseItems(topLevelMenuItem);
        }
        const chartGroupsDef = this.gos.get("chartToolPanelsDef")?.settingsPanel?.chartGroupsDef;
        if (chartGroupsDef) topLevelMenuItem = this.filterAndOrderChartMenu(topLevelMenuItem, chartGroupsDef, builder.getConfigLookup());
        return this.cleanInternals(topLevelMenuItem);
    }
    // Remove our internal _key and _enterprise properties so this does not leak out of the class on the menu items.
    cleanInternals(menuItem) {
        if (!menuItem) return menuItem;
        const removeKeys = (m)=>{
            delete m?._key;
            delete m?._enterprise;
            for (const s2 of m?.subMenu ?? [])removeKeys(s2);
            return m;
        };
        return removeKeys(menuItem);
    }
    buildLookup(menuItem) {
        const itemLookup = {};
        const addItem = (item)=>{
            itemLookup[item._key] = item;
            if (item.subMenu) for (const s2 of item.subMenu)addItem(s2);
        };
        addItem(menuItem);
        return itemLookup;
    }
    /**
   * Make the MenuItem match the charts provided and their ordering on the ChartGroupsDef config object as provided by the user.
   */ filterAndOrderChartMenu(topLevelMenuItem, chartGroupsDef, configLookup) {
        const menuItemLookup = this.buildLookup(topLevelMenuItem);
        const orderedAndFiltered = {
            ...topLevelMenuItem,
            subMenu: []
        };
        for (const group of Object.keys(chartGroupsDef)){
            const chartTypes = chartGroupsDef[group];
            const chartConfigGroup = configLookup[group];
            if (chartConfigGroup === null) continue;
            if (chartConfigGroup == void 0) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(173, {
                    group: group
                });
                continue;
            }
            const menuItem = menuItemLookup[chartConfigGroup._key];
            if (menuItem) {
                if (menuItem.subMenu) {
                    const subMenus = chartTypes.map((chartType)=>{
                        const itemKey = chartConfigGroup[chartType];
                        if (itemKey == void 0) {
                            (0, $437b23f6a393c3bf$export$545083624300f13d)(174, {
                                group: group,
                                chartType: chartType
                            });
                            return void 0;
                        }
                        return menuItemLookup[itemKey];
                    }).filter((s2)=>s2 !== void 0);
                    if (subMenus.length > 0) {
                        menuItem.subMenu = subMenus;
                        orderedAndFiltered.subMenu?.push(menuItem);
                    }
                } else orderedAndFiltered.subMenu?.push(menuItem);
            }
        }
        if (orderedAndFiltered.subMenu?.length == 0) return null;
        return orderedAndFiltered;
    }
};
var $5b7ccabde48fae90$var$PivotMenuItemMapper = class {
    constructor(beans, chartSvc, getLocaleTextFunc){
        this.beans = beans;
        this.chartSvc = chartSvc;
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getMenuItem() {
        const localeTextFunc = this.getLocaleTextFunc();
        const getMenuItem = (localeKey, defaultText, chartType, key, enterprise = false)=>{
            return {
                // will have a LRM character appended to ensure correct display in RTL languages
                name: localeTextFunc(localeKey, defaultText + "\u200E"),
                action: ()=>this.chartSvc.createPivotChart({
                        chartType: chartType
                    }),
                _key: key,
                _enterprise: enterprise
            };
        };
        return {
            name: localeTextFunc("pivotChart", "Pivot Chart"),
            _key: "pivotChart",
            subMenu: [
                {
                    _key: "pivotColumnChart",
                    name: localeTextFunc("columnChart", "Column"),
                    subMenu: [
                        getMenuItem("groupedColumn", "Grouped", "groupedColumn", "pivotGroupedColumn"),
                        getMenuItem("stackedColumn", "Stacked", "stackedColumn", "pivotStackedColumn"),
                        getMenuItem("normalizedColumn", "100% Stacked", "normalizedColumn", "pivotNormalizedColumn")
                    ]
                },
                {
                    _key: "pivotBarChart",
                    name: localeTextFunc("barChart", "Bar"),
                    subMenu: [
                        getMenuItem("groupedBar", "Grouped", "groupedBar", "pivotGroupedBar"),
                        getMenuItem("stackedBar", "Stacked", "stackedBar", "pivotStackedBar"),
                        getMenuItem("normalizedBar", "100% Stacked", "normalizedBar", "pivotNormalizedBar")
                    ]
                },
                {
                    _key: "pivotPieChart",
                    name: localeTextFunc("pieChart", "Pie"),
                    subMenu: [
                        getMenuItem("pie", "Pie", "pie", "pivotPie"),
                        getMenuItem("donut", "Donut", "donut", "pivotDonut")
                    ]
                },
                {
                    _key: "pivotLineChart",
                    name: localeTextFunc("lineChart", "Line"),
                    subMenu: [
                        getMenuItem("lineChart", "Line", "line", "pivotLineChart"),
                        getMenuItem("stackedLine", "Stacked", "stackedLine", "pivotStackedLine"),
                        getMenuItem("normalizedLine", "100% Stacked", "normalizedLine", "pivotNormalizedLine")
                    ]
                },
                {
                    _key: "pivotAreaChart",
                    name: localeTextFunc("areaChart", "Area"),
                    subMenu: [
                        getMenuItem("areaChart", "Area", "area", "pivotArea"),
                        getMenuItem("stackedArea", "Stacked", "stackedArea", "pivotStackedArea"),
                        getMenuItem("normalizedArea", "100% Stacked", "normalizedArea", "pivotNormalizedArea")
                    ]
                },
                {
                    _key: "pivotXYChart",
                    name: localeTextFunc("xyChart", "X Y (Scatter)"),
                    subMenu: [
                        getMenuItem("scatter", "Scatter", "scatter", "pivotScatter"),
                        getMenuItem("bubble", "Bubble", "bubble", "pivotBubble")
                    ]
                },
                {
                    _key: "pivotStatisticalChart",
                    _enterprise: false,
                    // histogram chart is available in both community and enterprise distributions
                    name: localeTextFunc("statisticalChart", "Statistical"),
                    subMenu: [
                        getMenuItem("histogramChart", "Histogram", "histogram", "pivotHistogram", false)
                    ]
                },
                {
                    _key: "pivotHierarchicalChart",
                    _enterprise: true,
                    name: localeTextFunc("hierarchicalChart", "Hierarchical"),
                    subMenu: [
                        getMenuItem("treemapChart", "Treemap", "treemap", "pivotTreemap", true),
                        getMenuItem("sunburstChart", "Sunburst", "sunburst", "pivotSunburst", true)
                    ]
                },
                {
                    _key: "pivotFunnel",
                    name: localeTextFunc("funnel", "Funnel"),
                    subMenu: [
                        getMenuItem("funnel", "Funnel", "funnel", "pivotFunnel"),
                        getMenuItem("coneFunnel", "Cone Funnel", "coneFunnel", "pivotConeFunnel"),
                        getMenuItem("pyramid", "Pyramid", "pyramid", "pivotPyramid")
                    ]
                },
                {
                    _key: "pivotCombinationChart",
                    name: localeTextFunc("combinationChart", "Combination"),
                    subMenu: [
                        getMenuItem("columnLineCombo", "Column & Line", "columnLineCombo", "pivotColumnLineCombo"),
                        getMenuItem("AreaColumnCombo", "Area & Column", "areaColumnCombo", "pivotAreaColumnCombo")
                    ]
                }
            ],
            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("chart", this.beans, void 0)
        };
    }
    getConfigLookup() {
        return {
            columnGroup: {
                _key: "pivotColumnChart",
                column: "pivotGroupedColumn",
                stackedColumn: "pivotStackedColumn",
                normalizedColumn: "pivotNormalizedColumn"
            },
            barGroup: {
                _key: "pivotBarChart",
                bar: "pivotGroupedBar",
                stackedBar: "pivotStackedBar",
                normalizedBar: "pivotNormalizedBar"
            },
            pieGroup: {
                _key: "pivotPieChart",
                pie: "pivotPie",
                donut: "pivotDonut",
                doughnut: "pivotDonut"
            },
            lineGroup: {
                _key: "pivotLineChart",
                line: "pivotLineChart",
                stackedLine: "pivotStackedLine",
                normalizedLine: "pivotNormalizedLine"
            },
            areaGroup: {
                _key: "pivotAreaChart",
                area: "pivotArea",
                stackedArea: "pivotStackedArea",
                normalizedArea: "pivotNormalizedArea"
            },
            scatterGroup: {
                _key: "pivotXYChart",
                bubble: "pivotBubble",
                scatter: "pivotScatter"
            },
            combinationGroup: {
                _key: "pivotCombinationChart",
                columnLineCombo: "pivotColumnLineCombo",
                areaColumnCombo: "pivotAreaColumnCombo",
                customCombo: null
            },
            hierarchicalGroup: {
                _key: "pivotHierarchicalChart",
                treemap: "pivotTreemap",
                sunburst: "pivotSunburst"
            },
            statisticalGroup: {
                _key: "pivotStatisticalChart",
                histogram: "pivotHistogram",
                // Some statistical charts do not currently support pivot mode
                rangeBar: null,
                rangeArea: null,
                boxPlot: null
            },
            funnelGroup: {
                _key: "pivotFunnel",
                funnel: "pivotFunnel",
                coneFunnel: "pivotConeFunnel",
                pyramid: "pivotPyramid"
            },
            // Polar charts do not support pivot mode
            polarGroup: null,
            // Specialized charts do not currently support pivot mode
            specializedGroup: null
        };
    }
};
var $5b7ccabde48fae90$var$RangeMenuItemMapper = class {
    constructor(beans, chartSvc, getLocaleTextFunc){
        this.beans = beans;
        this.chartSvc = chartSvc;
        this.getLocaleTextFunc = getLocaleTextFunc;
    }
    getMenuItem() {
        const localeTextFunc = this.getLocaleTextFunc();
        const getMenuItem = (localeKey, defaultText, chartType, key, enterprise = false)=>{
            return {
                name: localeTextFunc(localeKey, defaultText),
                action: ()=>this.chartSvc.createChartFromCurrentRange(chartType),
                _key: key,
                _enterprise: enterprise
            };
        };
        return {
            name: localeTextFunc("chartRange", "Chart Range"),
            _key: "chartRange",
            subMenu: [
                {
                    name: localeTextFunc("columnChart", "Column"),
                    subMenu: [
                        getMenuItem("groupedColumn", "Grouped", "groupedColumn", "rangeGroupedColumn"),
                        getMenuItem("stackedColumn", "Stacked", "stackedColumn", "rangeStackedColumn"),
                        getMenuItem("normalizedColumn", "100% Stacked", "normalizedColumn", "rangeNormalizedColumn")
                    ],
                    _key: "rangeColumnChart"
                },
                {
                    name: localeTextFunc("barChart", "Bar"),
                    subMenu: [
                        getMenuItem("groupedBar", "Grouped", "groupedBar", "rangeGroupedBar"),
                        getMenuItem("stackedBar", "Stacked", "stackedBar", "rangeStackedBar"),
                        getMenuItem("normalizedBar", "100% Stacked", "normalizedBar", "rangeNormalizedBar")
                    ],
                    _key: "rangeBarChart"
                },
                {
                    name: localeTextFunc("pieChart", "Pie"),
                    subMenu: [
                        getMenuItem("pie", "Pie", "pie", "rangePie"),
                        getMenuItem("donut", "Donut", "donut", "rangeDonut")
                    ],
                    _key: "rangePieChart"
                },
                {
                    name: localeTextFunc("lineChart", "Line"),
                    subMenu: [
                        getMenuItem("lineChart", "Line", "line", "rangeLineChart"),
                        getMenuItem("stackedLine", "Stacked", "stackedLine", "rangeStackedLine"),
                        getMenuItem("normalizedLine", "100% Stacked", "normalizedLine", "rangeNormalizedLine")
                    ],
                    _key: "rangeLineChart"
                },
                {
                    name: localeTextFunc("areaChart", "Area"),
                    subMenu: [
                        getMenuItem("areaChart", "Area", "area", "rangeArea"),
                        getMenuItem("stackedArea", "Stacked", "stackedArea", "rangeStackedArea"),
                        getMenuItem("normalizedArea", "100% Stacked", "normalizedArea", "rangeNormalizedArea")
                    ],
                    _key: "rangeAreaChart"
                },
                {
                    name: localeTextFunc("xyChart", "X Y (Scatter)"),
                    subMenu: [
                        getMenuItem("scatter", "Scatter", "scatter", "rangeScatter"),
                        getMenuItem("bubble", "Bubble", "bubble", "rangeBubble")
                    ],
                    _key: "rangeXYChart"
                },
                {
                    name: localeTextFunc("polarChart", "Polar"),
                    subMenu: [
                        getMenuItem("radarLine", "Radar Line", "radarLine", "rangeRadarLine"),
                        getMenuItem("radarArea", "Radar Area", "radarArea", "rangeRadarArea"),
                        getMenuItem("nightingale", "Nightingale", "nightingale", "rangeNightingale"),
                        getMenuItem("radialColumn", "Radial Column", "radialColumn", "rangeRadialColumn"),
                        getMenuItem("radialBar", "Radial Bar", "radialBar", "rangeRadialBar")
                    ],
                    _key: "rangePolarChart",
                    _enterprise: true
                },
                {
                    name: localeTextFunc("statisticalChart", "Statistical"),
                    subMenu: [
                        getMenuItem("boxPlot", "Box Plot", "boxPlot", "rangeBoxPlot", true),
                        getMenuItem("histogramChart", "Histogram", "histogram", "rangeHistogram", false),
                        getMenuItem("rangeBar", "Range Bar", "rangeBar", "rangeRangeBar", true),
                        getMenuItem("rangeArea", "Range Area", "rangeArea", "rangeRangeArea", true)
                    ],
                    _key: "rangeStatisticalChart",
                    _enterprise: false
                },
                {
                    name: localeTextFunc("hierarchicalChart", "Hierarchical"),
                    subMenu: [
                        getMenuItem("treemap", "Treemap", "treemap", "rangeTreemap"),
                        getMenuItem("sunburst", "Sunburst", "sunburst", "rangeSunburst")
                    ],
                    _key: "rangeHierarchicalChart",
                    _enterprise: true
                },
                {
                    name: localeTextFunc("specializedChart", "Specialized"),
                    subMenu: [
                        getMenuItem("heatmap", "Heatmap", "heatmap", "rangeHeatmap"),
                        getMenuItem("waterfall", "Waterfall", "waterfall", "rangeWaterfall")
                    ],
                    _key: "rangeSpecializedChart",
                    _enterprise: true
                },
                {
                    name: localeTextFunc("funnel", "Funnel"),
                    subMenu: [
                        getMenuItem("funnel", "Funnel", "funnel", "rangeFunnel"),
                        getMenuItem("coneFunnel", "Cone Funnel", "coneFunnel", "rangeConeFunnel"),
                        getMenuItem("pyramid", "Pyramid", "pyramid", "rangePyramid")
                    ],
                    _key: "rangeFunnel",
                    _enterprise: true
                },
                {
                    name: localeTextFunc("combinationChart", "Combination"),
                    subMenu: [
                        getMenuItem("columnLineCombo", "Column & Line", "columnLineCombo", "rangeColumnLineCombo"),
                        getMenuItem("AreaColumnCombo", "Area & Column", "areaColumnCombo", "rangeAreaColumnCombo")
                    ],
                    _key: "rangeCombinationChart"
                }
            ],
            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("chart", this.beans, void 0)
        };
    }
    getConfigLookup() {
        return {
            columnGroup: {
                _key: "rangeColumnChart",
                column: "rangeGroupedColumn",
                stackedColumn: "rangeStackedColumn",
                normalizedColumn: "rangeNormalizedColumn"
            },
            barGroup: {
                _key: "rangeBarChart",
                bar: "rangeGroupedBar",
                stackedBar: "rangeStackedBar",
                normalizedBar: "rangeNormalizedBar"
            },
            pieGroup: {
                _key: "rangePieChart",
                pie: "rangePie",
                donut: "rangeDonut",
                doughnut: "rangeDonut"
            },
            lineGroup: {
                _key: "rangeLineChart",
                line: "rangeLineChart",
                stackedLine: "rangeStackedLine",
                normalizedLine: "rangeNormalizedLine"
            },
            areaGroup: {
                _key: "rangeAreaChart",
                area: "rangeArea",
                stackedArea: "rangeStackedArea",
                normalizedArea: "rangeNormalizedArea"
            },
            scatterGroup: {
                _key: "rangeXYChart",
                bubble: "rangeBubble",
                scatter: "rangeScatter"
            },
            polarGroup: {
                _key: "rangePolarChart",
                radarLine: "rangeRadarLine",
                radarArea: "rangeRadarArea",
                nightingale: "rangeNightingale",
                radialColumn: "rangeRadialColumn",
                radialBar: "rangeRadialBar"
            },
            statisticalGroup: {
                _key: "rangeStatisticalChart",
                boxPlot: "rangeBoxPlot",
                histogram: "rangeHistogram",
                rangeBar: "rangeRangeBar",
                rangeArea: "rangeRangeArea"
            },
            hierarchicalGroup: {
                _key: "rangeHierarchicalChart",
                treemap: "rangeTreemap",
                sunburst: "rangeSunburst"
            },
            specializedGroup: {
                _key: "rangeSpecializedChart",
                heatmap: "rangeHeatmap",
                waterfall: "rangeWaterfall"
            },
            funnelGroup: {
                _key: "rangeFunnel",
                funnel: "rangeFunnel",
                coneFunnel: "rangeConeFunnel",
                pyramid: "rangePyramid"
            },
            combinationGroup: {
                _key: "rangeCombinationChart",
                columnLineCombo: "rangeColumnLineCombo",
                areaColumnCombo: "rangeAreaColumnCombo",
                customCombo: null
            }
        };
    }
};
var $5b7ccabde48fae90$var$ColumnChooserFactory = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "colChooserFactory";
    }
    createColumnSelectPanel(parent, column, draggable, params) {
        const columnSelectPanel = parent.createManagedBean(new $5b7ccabde48fae90$var$AgPrimaryCols());
        const columnChooserParams = params ?? column?.getColDef().columnChooserParams ?? {};
        const { contractColumnSelection: contractColumnSelection, suppressColumnExpandAll: suppressColumnExpandAll, suppressColumnFilter: suppressColumnFilter, suppressColumnSelectAll: suppressColumnSelectAll, suppressSyncLayoutWithGrid: suppressSyncLayoutWithGrid, columnLayout: columnLayout } = columnChooserParams;
        columnSelectPanel.init(!!draggable, (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
            suppressColumnMove: false,
            suppressValues: false,
            suppressPivots: false,
            suppressRowGroups: false,
            suppressPivotMode: false,
            contractColumnSelection: !!contractColumnSelection,
            suppressColumnExpandAll: !!suppressColumnExpandAll,
            suppressColumnFilter: !!suppressColumnFilter,
            suppressColumnSelectAll: !!suppressColumnSelectAll,
            suppressSyncLayoutWithGrid: !!columnLayout || !!suppressSyncLayoutWithGrid,
            onStateUpdated: ()=>{}
        }), "columnMenu");
        if (columnLayout) columnSelectPanel.setColumnLayout(columnLayout);
        return columnSelectPanel;
    }
    showColumnChooser({ column: column, chooserParams: chooserParams, eventSource: eventSource, headerPosition: providedHeaderPosition }) {
        this.hideActiveColumnChooser();
        const columnSelectPanel = this.createColumnSelectPanel(this, column, true, chooserParams);
        const translate = this.getLocaleTextFunc();
        const beans = this.beans;
        const { visibleCols: visibleCols, focusSvc: focusSvc, menuUtils: menuUtils } = beans;
        const columnIndex = visibleCols.allCols.indexOf(column);
        const headerPosition = column ? focusSvc.focusedHeader ?? providedHeaderPosition ?? null : null;
        this.activeColumnChooserDialog = this.createBean(new $5b7ccabde48fae90$var$Dialog({
            title: translate("chooseColumns", "Choose Columns"),
            component: columnSelectPanel,
            width: 300,
            height: 300,
            resizable: true,
            movable: true,
            centered: true,
            closable: true,
            afterGuiAttached: ()=>{
                (0, $437b23f6a393c3bf$export$83fc12531358bd28)(beans, columnSelectPanel.getGui())?.focus({
                    preventScroll: true
                });
                this.dispatchVisibleChangedEvent(true, column);
            },
            closedCallback: (event)=>{
                const eComp = this.activeColumnChooser.getGui();
                this.destroyBean(this.activeColumnChooser);
                this.activeColumnChooser = void 0;
                this.activeColumnChooserDialog = void 0;
                this.dispatchVisibleChangedEvent(false, column);
                if (column) menuUtils.restoreFocusOnClose({
                    column: column,
                    headerPosition: headerPosition,
                    columnIndex: columnIndex,
                    eventSource: eventSource
                }, eComp, event, true);
            },
            postProcessPopupParams: {
                type: "columnChooser",
                column: column,
                eventSource: eventSource
            }
        }));
        this.activeColumnChooser = columnSelectPanel;
    }
    hideActiveColumnChooser() {
        this.destroyBean(this.activeColumnChooserDialog);
    }
    dispatchVisibleChangedEvent(visible, column) {
        this.eventSvc.dispatchEvent({
            type: "columnMenuVisibleChanged",
            visible: visible,
            switchingTab: false,
            key: "columnChooser",
            column: column ?? null
        });
    }
};
// packages/ag-grid-enterprise/src/menu/menuItemValidations.ts
var $5b7ccabde48fae90$var$MENU_ITEM_MODULES = {
    pinSubMenu: "PinnedColumn",
    pinLeft: "PinnedColumn",
    pinRight: "PinnedColumn",
    clearPinned: "PinnedColumn",
    pinRowSubMenu: "PinnedRow",
    pinBottom: "PinnedRow",
    pinTop: "PinnedRow",
    unpinRow: "PinnedRow",
    valueAggSubMenu: "SharedAggregation",
    autoSizeThis: "ColumnAutoSize",
    autoSizeAll: "ColumnAutoSize",
    rowGroup: "SharedRowGrouping",
    rowUnGroup: "SharedRowGrouping",
    resetColumns: "CommunityCore",
    expandAll: [
        "ClientSideRowModelHierarchy",
        "ServerSideRowModel"
    ],
    contractAll: [
        "ClientSideRowModelHierarchy",
        "ServerSideRowModel"
    ],
    copy: "Clipboard",
    copyWithHeaders: "Clipboard",
    copyWithGroupHeaders: "Clipboard",
    cut: "Clipboard",
    paste: "Clipboard",
    export: [
        "CsvExport",
        "ExcelExport"
    ],
    csvExport: "CsvExport",
    excelExport: "ExcelExport",
    separator: "CommunityCore",
    pivotChart: "IntegratedCharts",
    chartRange: "IntegratedCharts",
    columnFilter: "ColumnFilter",
    columnChooser: "ColumnMenu",
    sortAscending: "Sort",
    sortDescending: "Sort",
    sortAbsoluteAscending: "Sort",
    sortAbsoluteDescending: "Sort",
    sortUnSort: "Sort"
};
function $5b7ccabde48fae90$var$validateMenuItem(gos, key) {
    const moduleName4 = $5b7ccabde48fae90$var$MENU_ITEM_MODULES[key];
    if (moduleName4) gos.assertModuleRegistered(moduleName4, `menu item '${key}'`);
}
// packages/ag-grid-enterprise/src/menu/menuItemMapper.ts
var $5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR = "separator";
function $5b7ccabde48fae90$var$_removeRepeatsFromArray(array, object) {
    if (!array) return;
    for(let index = array.length - 2; index >= 0; index--){
        const thisOneMatches = array[index] === object;
        const nextOneMatches = array[index + 1] === object;
        if (thisOneMatches && nextOneMatches) array.splice(index + 1, 1);
    }
}
var $5b7ccabde48fae90$var$SORT_MENU_ITEM_TO_MENU_ACTION_PARAMS = {
    sortAscending: {
        fallback: "Sort Ascending",
        getSortDef: ()=>({
                type: "default",
                direction: "asc"
            })
    },
    sortDescending: {
        fallback: "Sort Descending",
        getSortDef: ()=>({
                type: "default",
                direction: "desc"
            })
    },
    sortAbsoluteAscending: {
        fallback: "Sort Absolute Ascending",
        getSortDef: ()=>({
                type: "absolute",
                direction: "asc"
            })
    },
    sortAbsoluteDescending: {
        fallback: "Sort Absolute Descending",
        getSortDef: ()=>({
                type: "absolute",
                direction: "desc"
            })
    },
    sortUnSort: {
        fallback: "Clear Sort",
        getSortDef: (column)=>({
                type: (0, $437b23f6a393c3bf$export$fb66185d3079b298)(column.getSortDef()?.type),
                direction: null
            })
    }
};
var $5b7ccabde48fae90$var$MenuItemMapper = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "menuItemMapper";
    }
    mapWithStockItems(originalList, column, node, sourceElement, source) {
        if (!originalList) return [];
        const resultList = [];
        const localeTextFunc = this.getLocaleTextFunc();
        const { beans: beans, gos: gos } = this;
        const { pinnedCols: pinnedCols, colAutosize: colAutosize, aggFuncSvc: aggFuncSvc, rowGroupColsSvc: rowGroupColsSvc, colNames: colNames, colModel: colModel, clipboardSvc: clipboardSvc, expansionSvc: expansionSvc, focusSvc: focusSvc, csvCreator: csvCreator, excelCreator: excelCreator, menuSvc: menuSvc, colChooserFactory: colChooserFactory, sortSvc: sortSvc, chartMenuItemMapper: chartMenuItemMapper, valueColsSvc: valueColsSvc, pinnedRowModel: pinnedRowModel } = beans;
        const getStockMenuItem = (key, column2, sourceElement2, source2)=>{
            $5b7ccabde48fae90$var$validateMenuItem(gos, key);
            switch(key){
                case "pinSubMenu":
                    return pinnedCols && column2 ? {
                        name: localeTextFunc("pinColumn", "Pin Column"),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("menuPin", beans, null),
                        subMenu: [
                            "clearPinned",
                            "pinLeft",
                            "pinRight"
                        ]
                    } : null;
                case "pinLeft":
                    return pinnedCols && column2 ? {
                        name: localeTextFunc("pinLeft", "Pin Left"),
                        action: ()=>pinnedCols.setColsPinned([
                                column2
                            ], "left", source2),
                        checked: !!column2 && column2.isPinnedLeft()
                    } : null;
                case "pinRight":
                    return pinnedCols && column2 ? {
                        name: localeTextFunc("pinRight", "Pin Right"),
                        action: ()=>pinnedCols.setColsPinned([
                                column2
                            ], "right", source2),
                        checked: !!column2 && column2.isPinnedRight()
                    } : null;
                case "clearPinned":
                    return pinnedCols && column2 ? {
                        name: localeTextFunc("noPin", "No Pin"),
                        action: ()=>pinnedCols.setColsPinned([
                                column2
                            ], null, source2),
                        checked: !!column2 && !column2.isPinned()
                    } : null;
                case "pinRowSubMenu":
                    {
                        const enableRowPinning = gos.get("enableRowPinning");
                        const subMenu = [];
                        const pinned = node?.rowPinned ?? node?.pinnedSibling?.rowPinned;
                        if (pinned) subMenu.push("unpinRow");
                        if (enableRowPinning && enableRowPinning !== "bottom" && pinned != "top") subMenu.push("pinTop");
                        if (enableRowPinning && enableRowPinning !== "top" && pinned != "bottom") subMenu.push("pinBottom");
                        return pinnedRowModel?.isManual() ? {
                            name: localeTextFunc("pinRow", "Pin Row"),
                            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("rowPin", beans, column2),
                            subMenu: subMenu
                        } : null;
                    }
                case "pinTop":
                    return pinnedRowModel?.isManual() ? {
                        name: localeTextFunc("pinTop", "Pin to Top"),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("rowPinTop", beans, column2),
                        action: ({ node: node2, column: column3 })=>node2 && pinnedRowModel.pinRow(node2, "top", column3)
                    } : null;
                case "pinBottom":
                    return pinnedRowModel?.isManual() ? {
                        name: localeTextFunc("pinBottom", "Pin to Bottom"),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("rowPinBottom", beans, column2),
                        action: ({ node: node2, column: column3 })=>node2 && pinnedRowModel.pinRow(node2, "bottom", column3)
                    } : null;
                case "unpinRow":
                    return pinnedRowModel?.isManual() ? {
                        name: localeTextFunc("unpinRow", "Unpin Row"),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("rowUnpin", beans, column2),
                        action: ({ node: node2, column: column3 })=>node2 && pinnedRowModel.pinRow(node2, null, column3)
                    } : null;
                case "valueAggSubMenu":
                    if (aggFuncSvc && valueColsSvc && (column2?.isPrimary() || column2?.getColDef().pivotValueColumn)) return {
                        name: localeTextFunc("valueAggregation", "Value Aggregation"),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("menuValue", beans, null),
                        subMenu: $5b7ccabde48fae90$var$createAggregationSubMenu(column2, aggFuncSvc, valueColsSvc, localeTextFunc),
                        disabled: gos.get("functionsReadOnly")
                    };
                    else return null;
                case "autoSizeThis":
                    return colAutosize ? {
                        name: localeTextFunc("autosizeThisColumn", "Autosize This Column"),
                        action: ()=>column2 && colAutosize.autoSizeColumn(column2, source2, gos.get("skipHeaderOnAutoSize"))
                    } : null;
                case "autoSizeAll":
                    return colAutosize ? {
                        name: localeTextFunc("autosizeAllColumns", "Autosize All Columns"),
                        action: ()=>colAutosize.autoSizeAllColumns({
                                source: source2,
                                skipHeader: gos.get("skipHeaderOnAutoSize")
                            })
                    } : null;
                case "rowGroup":
                    return rowGroupColsSvc ? {
                        name: localeTextFunc("groupBy", "Group by") + " " + colNames.getDisplayNameForColumn(column2, "header"),
                        disabled: gos.get("functionsReadOnly") || column2?.isRowGroupActive() || !column2?.getColDef().enableRowGroup,
                        action: ()=>rowGroupColsSvc.addColumns([
                                column2
                            ], source2),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("menuAddRowGroup", beans, null)
                    } : null;
                case "rowUnGroup":
                    if (rowGroupColsSvc && gos.isModuleRegistered("SharedRowGrouping")) {
                        const showRowGroup = column2?.getColDef().showRowGroup;
                        const lockedGroups = gos.get("groupLockGroupColumns");
                        let name;
                        let disabled;
                        let action;
                        if (showRowGroup === true) {
                            name = localeTextFunc("ungroupAll", "Un-Group All");
                            disabled = gos.get("functionsReadOnly") || lockedGroups === -1 || lockedGroups >= (rowGroupColsSvc.columns.length ?? 0);
                            action = ()=>rowGroupColsSvc.setColumns(rowGroupColsSvc.columns.slice(0, lockedGroups), source2);
                        } else if (typeof showRowGroup === "string") {
                            const underlyingColumn = colModel.getColDefCol(showRowGroup);
                            const ungroupByName = underlyingColumn != null ? colNames.getDisplayNameForColumn(underlyingColumn, "header") : showRowGroup;
                            name = localeTextFunc("ungroupBy", "Un-Group by") + " " + ungroupByName;
                            disabled = gos.get("functionsReadOnly") || $5b7ccabde48fae90$var$isRowGroupColLocked(underlyingColumn, beans);
                            action = ()=>{
                                rowGroupColsSvc.removeColumns([
                                    showRowGroup
                                ], source2);
                            };
                        } else {
                            name = localeTextFunc("ungroupBy", "Un-Group by") + " " + colNames.getDisplayNameForColumn(column2, "header");
                            disabled = gos.get("functionsReadOnly") || !column2?.isRowGroupActive() || !column2?.getColDef().enableRowGroup || $5b7ccabde48fae90$var$isRowGroupColLocked(column2, beans);
                            action = ()=>rowGroupColsSvc.removeColumns([
                                    column2
                                ], source2);
                        }
                        return {
                            name: name,
                            disabled: disabled,
                            action: action,
                            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("menuRemoveRowGroup", beans, null)
                        };
                    } else return null;
                case "resetColumns":
                    return {
                        name: localeTextFunc("resetColumns", "Reset Columns"),
                        action: ()=>(0, $437b23f6a393c3bf$export$96a6cbc000255060)(beans, source2)
                    };
                case "expandAll":
                    return expansionSvc ? {
                        name: localeTextFunc("expandAll", "Expand All Row Groups"),
                        action: ()=>expansionSvc.expandAll(true)
                    } : null;
                case "contractAll":
                    return expansionSvc ? {
                        name: localeTextFunc("collapseAll", "Collapse All Row Groups"),
                        action: ()=>expansionSvc.expandAll(false)
                    } : null;
                case "copy":
                    return clipboardSvc ? {
                        name: localeTextFunc("copy", "Copy"),
                        shortcut: localeTextFunc("ctrlC", "Ctrl+C"),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("clipboardCopy", beans, null),
                        action: ()=>clipboardSvc.copyToClipboard()
                    } : null;
                case "copyWithHeaders":
                    return clipboardSvc ? {
                        name: localeTextFunc("copyWithHeaders", "Copy with Headers"),
                        // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("clipboardCopy", beans, null),
                        action: ()=>clipboardSvc.copyToClipboard({
                                includeHeaders: true
                            })
                    } : null;
                case "copyWithGroupHeaders":
                    return clipboardSvc ? {
                        name: localeTextFunc("copyWithGroupHeaders", "Copy with Group Headers"),
                        // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("clipboardCopy", beans, null),
                        action: ()=>clipboardSvc.copyToClipboard({
                                includeHeaders: true,
                                includeGroupHeaders: true
                            })
                    } : null;
                case "cut":
                    if (clipboardSvc) {
                        const focusedCell = focusSvc.getFocusedCell();
                        const rowNode = focusedCell ? (0, $437b23f6a393c3bf$export$d4675a60917db7b0)(beans, focusedCell) : null;
                        const isEditable = rowNode ? focusedCell?.column.isCellEditable(rowNode) : false;
                        return {
                            name: localeTextFunc("cut", "Cut"),
                            shortcut: localeTextFunc("ctrlX", "Ctrl+X"),
                            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("clipboardCut", beans, null),
                            disabled: !isEditable || gos.get("suppressCutToClipboard"),
                            action: ()=>clipboardSvc.cutToClipboard(void 0, "contextMenu")
                        };
                    } else return null;
                case "paste":
                    if (clipboardSvc) {
                        const isPasteBlocked = gos.get("suppressClipboardApi") || gos.get("suppressClipboardPaste") || !column2 || !node || !column2.isCellEditable(node) || column2.isSuppressPaste(node);
                        return {
                            name: localeTextFunc("paste", "Paste"),
                            shortcut: localeTextFunc("ctrlV", "Ctrl+V"),
                            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("clipboardPaste", beans, null),
                            disabled: isPasteBlocked,
                            action: ()=>clipboardSvc.pasteFromClipboard()
                        };
                    } else return null;
                case "export":
                    {
                        const exportSubMenuItems = [];
                        if (!gos.get("suppressCsvExport") && csvCreator) exportSubMenuItems.push("csvExport");
                        if (!gos.get("suppressExcelExport") && excelCreator) exportSubMenuItems.push("excelExport");
                        return exportSubMenuItems.length ? {
                            name: localeTextFunc("export", "Export"),
                            subMenu: exportSubMenuItems,
                            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("save", beans, null)
                        } : null;
                    }
                case "csvExport":
                    return csvCreator ? {
                        name: localeTextFunc("csvExport", "CSV Export"),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("csvExport", beans, null),
                        action: ()=>csvCreator.exportDataAsCsv()
                    } : null;
                case "excelExport":
                    return excelCreator ? {
                        name: localeTextFunc("excelExport", "Excel Export"),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("excelExport", beans, null),
                        action: ()=>excelCreator.exportDataAsExcel()
                    } : null;
                case "separator":
                    return key;
                case "pivotChart":
                case "chartRange":
                    return chartMenuItemMapper.getChartItems(key);
                case "columnFilter":
                    return menuSvc && column2 ? {
                        name: localeTextFunc("columnFilter", "Column Filter"),
                        icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("filter", beans, null),
                        action: ()=>menuSvc.showFilterMenu({
                                column: column2,
                                buttonElement: sourceElement2(),
                                containerType: "columnFilter",
                                positionBy: "button"
                            })
                    } : null;
                case "columnChooser":
                    {
                        const headerPosition = focusSvc.focusedHeader;
                        return colChooserFactory ? {
                            name: localeTextFunc("columnChooser", "Choose Columns"),
                            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("columns", beans, null),
                            action: ()=>colChooserFactory.showColumnChooser({
                                    column: column2,
                                    eventSource: sourceElement2(),
                                    headerPosition: headerPosition
                                })
                        } : null;
                    }
                case "sortUnSort":
                case "sortAscending":
                case "sortDescending":
                case "sortAbsoluteAscending":
                case "sortAbsoluteDescending":
                    {
                        if (!sortSvc || !column2) return null;
                        const { fallback: fallback, getSortDef: getSortDef } = $5b7ccabde48fae90$var$SORT_MENU_ITEM_TO_MENU_ACTION_PARAMS[key];
                        return {
                            name: localeTextFunc(key, fallback),
                            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(key, beans, null),
                            action: ()=>sortSvc.setSortForColumn(column2, getSortDef(column2), false, source2)
                        };
                    }
                default:
                    (0, $437b23f6a393c3bf$export$545083624300f13d)(176, {
                        key: key
                    });
                    return null;
            }
        };
        for (const menuItemOrString of originalList){
            let result;
            if (typeof menuItemOrString === "string") result = getStockMenuItem(menuItemOrString, column, sourceElement, source);
            else result = {
                ...menuItemOrString
            };
            if (!result) continue;
            const resultDef = result;
            const { subMenu: subMenu } = resultDef;
            if (subMenu && subMenu instanceof Array) resultDef.subMenu = this.mapWithStockItems(subMenu, column, node, sourceElement, source);
            if (result != null) resultList.push(result);
        }
        $5b7ccabde48fae90$var$_removeRepeatsFromArray(resultList, $5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        return resultList;
    }
};
function $5b7ccabde48fae90$var$createAggregationSubMenu(column, aggFuncSvc, valueColsSvc, localeTextFunc) {
    let columnToUse;
    if (column.isPrimary()) columnToUse = column;
    else {
        const pivotValueColumn = column.getColDef().pivotValueColumn;
        columnToUse = (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(pivotValueColumn) ? pivotValueColumn : void 0;
    }
    const result = [];
    if (columnToUse) {
        const columnIsAlreadyAggValue = columnToUse.isValueActive();
        const funcNames = aggFuncSvc.getFuncNames(columnToUse);
        result.push({
            name: localeTextFunc("noAggregation", "None"),
            action: ()=>{
                valueColsSvc.removeColumns([
                    columnToUse
                ], "contextMenu");
                valueColsSvc.setColumnAggFunc(columnToUse, void 0, "contextMenu");
            },
            checked: !columnIsAlreadyAggValue
        });
        for (const funcName of funcNames)result.push({
            name: localeTextFunc(funcName, aggFuncSvc.getDefaultFuncLabel(funcName)),
            action: ()=>{
                valueColsSvc.setColumnAggFunc(columnToUse, funcName, "contextMenu");
                valueColsSvc.addColumns([
                    columnToUse
                ], "contextMenu");
            },
            checked: columnIsAlreadyAggValue && columnToUse.getAggFunc() === funcName
        });
    }
    return result;
}
// packages/ag-grid-enterprise/src/menu/columnMenuFactory.ts
var $5b7ccabde48fae90$var$ColumnMenuFactory = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "colMenuFactory";
    }
    createMenu(parent, menuItems, column, sourceElement) {
        const menuList = parent.createManagedBean(new $5b7ccabde48fae90$var$MenuList(0, {
            column: column ?? null,
            node: null,
            value: null
        }));
        const menuItemsMapped = this.beans.menuItemMapper.mapWithStockItems(menuItems, column ?? null, null, sourceElement, "columnMenu");
        menuList.addMenuItems(menuItemsMapped);
        return menuList;
    }
    getMenuItems(column = null, columnGroup = null) {
        const defaultItems = this.getDefaultMenuOptions(column);
        let result;
        const columnMainMenuItems = (column?.getColDef() ?? columnGroup?.getColGroupDef())?.mainMenuItems;
        if (Array.isArray(columnMainMenuItems)) result = columnMainMenuItems;
        else if (typeof columnMainMenuItems === "function") result = columnMainMenuItems((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
            column: column,
            columnGroup: columnGroup,
            defaultItems: defaultItems
        }));
        else {
            const userFunc = this.gos.getCallback("getMainMenuItems");
            if (userFunc) result = userFunc({
                column: column,
                columnGroup: columnGroup,
                defaultItems: defaultItems
            });
            else result = defaultItems;
        }
        $5b7ccabde48fae90$var$_removeRepeatsFromArray(result, $5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        return result;
    }
    getDefaultMenuOptions(column) {
        const result = [];
        const { beans: beans, gos: gos } = this;
        const { colChooserFactory: colChooserFactory, rowGroupColsSvc: rowGroupColsSvc, colModel: colModel, expansionSvc: expansionSvc, sortSvc: sortSvc, menuSvc: menuSvc, pinnedCols: pinnedCols, aggFuncSvc: aggFuncSvc, colAutosize: colAutosize } = beans;
        const isLegacyMenuEnabled = (0, $437b23f6a393c3bf$export$2f1c8e943ce1a1be)(gos);
        const addColumnItems = ()=>{
            if (!isLegacyMenuEnabled && colChooserFactory) result.push("columnChooser");
            result.push("resetColumns");
        };
        if (!column) {
            addColumnItems();
            return result;
        }
        const { colDef: colDef } = column;
        const allowPinning = pinnedCols && !colDef.lockPinned;
        const rowGroupCount = rowGroupColsSvc?.columns.length ?? 0;
        const doingGrouping = rowGroupCount > 0;
        const grandTotalRow = (0, $437b23f6a393c3bf$export$c6fad27ed643a862)(gos);
        const treeData = gos.get("treeData");
        const isPrimary = column.isPrimary();
        const allowValueAgg = !isPrimary || aggFuncSvc && column.isAllowValue() && (doingGrouping || grandTotalRow || treeData);
        if (sortSvc && !isLegacyMenuEnabled && column.isSortable()) {
            const sortDef = column.getSortDef();
            const type = (0, $437b23f6a393c3bf$export$fb66185d3079b298)(sortDef?.type);
            const direction = (0, $437b23f6a393c3bf$export$b26b2467cef719c1)(sortDef?.direction);
            const allowedSortTypes = column.getAvailableSortTypes();
            const isDefaultSortAllowed = allowedSortTypes.has("default");
            const isAbsoluteSortAllowed = allowedSortTypes.has("absolute");
            const isAbsoluteSort = type === "absolute";
            const isDefaultSort = type === "default";
            const isAscending = direction === "asc";
            const isDescending = direction === "desc";
            if (isDefaultSortAllowed && !(isAscending && isDefaultSort)) result.push("sortAscending");
            if (isDefaultSortAllowed && !(isDescending && isDefaultSort)) result.push("sortDescending");
            if (isAbsoluteSortAllowed && !(isAscending && isAbsoluteSort)) result.push("sortAbsoluteAscending");
            if (isAbsoluteSortAllowed && !(isDescending && isAbsoluteSort)) result.push("sortAbsoluteDescending");
            if (direction) result.push("sortUnSort");
            result.push($5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        }
        if (menuSvc?.isFilterMenuItemEnabled(column)) {
            result.push("columnFilter");
            result.push($5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        }
        if (allowPinning) result.push("pinSubMenu");
        if (allowValueAgg) result.push("valueAggSubMenu");
        if (allowPinning || allowValueAgg) result.push($5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        if (colAutosize) {
            if (!colDef.suppressAutoSize) result.push("autoSizeThis");
            result.push("autoSizeAll");
            result.push($5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        }
        if (rowGroupColsSvc && gos.isModuleRegistered("SharedRowGrouping")) {
            const numItems = result.length;
            const showRowGroup = colDef.showRowGroup;
            if (showRowGroup) result.push("rowUnGroup");
            else if (column.isAllowRowGroup() && isPrimary) {
                if (column.isRowGroupActive()) {
                    const groupLocked = $5b7ccabde48fae90$var$isRowGroupColLocked(column, beans);
                    if (!groupLocked) result.push("rowUnGroup");
                } else result.push("rowGroup");
            }
            if (result.length > numItems) result.push($5b7ccabde48fae90$var$MENU_ITEM_SEPARATOR);
        }
        addColumnItems();
        if (expansionSvc && ((0, $437b23f6a393c3bf$export$9f182d9ca737e15)(gos) || gos.get("ssrmExpandAllAffectsAllRows")) && (treeData || rowGroupCount > (colModel.isPivotMode() ? 1 : 0))) {
            result.push("expandAll");
            result.push("contractAll");
        }
        return result;
    }
};
var $5b7ccabde48fae90$var$CSS_CONTEXT_MENU_OPEN = "ag-context-menu-open";
var $5b7ccabde48fae90$var$ContextMenuService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "contextMenuSvc";
        this.focusedCell = null;
    }
    postConstruct() {
        this.menu = this.createManagedBean(new $5b7ccabde48fae90$export$8e53e0f426065c52({
            menuItemCallbacks: $5b7ccabde48fae90$var$MENU_ITEM_CALLBACKS,
            getMenuItems: this.getMenuItems.bind(this),
            mapMenuItems: this.mapWithStockItems.bind(this),
            beforeMenuOpen: this.beforeMenuOpen.bind(this),
            onMenuOpen: this.onMenuOpen.bind(this),
            onMenuClose: this.onMenuClose.bind(this),
            afterMenuDestroyed: this.afterMenuDestroyed.bind(this),
            onVisibleChanged: this.dispatchVisibleChangedEvent.bind(this),
            // overlay was displayed
            shouldBlockMenuOpen: ()=>!!this.beans.overlays?.exclusive
        }));
    }
    hideActiveMenu() {
        this.menu.hideActiveMenu();
    }
    getMenuItems(menuActionParams, mouseEvent) {
        const { column: column, node: node, value: value } = menuActionParams;
        const defaultMenuOptions = [];
        const { clipboardSvc: clipboardSvc, chartSvc: chartSvc, csvCreator: csvCreator, excelCreator: excelCreator, colModel: colModel, rangeSvc: rangeSvc, gos: gos } = this.beans;
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(node) && clipboardSvc) {
            if (column) {
                if (!gos.get("suppressCutToClipboard")) defaultMenuOptions.push("cut");
                defaultMenuOptions.push("copy", "copyWithHeaders", "copyWithGroupHeaders", "paste", "separator");
            }
        }
        if (gos.get("enableCharts") && chartSvc) {
            if (colModel.isPivotMode()) defaultMenuOptions.push("pivotChart");
            if (rangeSvc && !rangeSvc.isEmpty()) defaultMenuOptions.push("chartRange");
        }
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(node)) {
            const enableRowPinning = gos.get("enableRowPinning");
            const isRowPinnable = gos.get("isRowPinnable");
            if (enableRowPinning) {
                const isGroupTotalRow = node.level > -1 && node.footer;
                const isGrandTotalRow = node.level === -1 && node.footer;
                const grandTotalRow = (0, $437b23f6a393c3bf$export$c6fad27ed643a862)(gos);
                const isGrandTotalRowFixed = grandTotalRow === "pinnedBottom" || grandTotalRow === "pinnedTop";
                if (isGrandTotalRow && !isGrandTotalRowFixed || !isGrandTotalRow && !isGroupTotalRow) {
                    const pinnable = isRowPinnable?.(node) ?? true;
                    if (pinnable) defaultMenuOptions.push("pinRowSubMenu");
                }
            }
            const suppressExcel = gos.get("suppressExcelExport") || !excelCreator;
            const suppressCsv = gos.get("suppressCsvExport") || !csvCreator;
            const onIPad = (0, $437b23f6a393c3bf$export$6b6034a68325bd8a)();
            const anyExport = !onIPad && (!suppressExcel || !suppressCsv);
            if (anyExport) defaultMenuOptions.push("export");
        }
        const defaultItems = defaultMenuOptions.length ? defaultMenuOptions : void 0;
        const columnContextMenuItems = column?.getColDef().contextMenuItems;
        if (Array.isArray(columnContextMenuItems)) return columnContextMenuItems;
        if (typeof columnContextMenuItems === "function") return columnContextMenuItems((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(gos, {
            column: column,
            node: node,
            value: value,
            defaultItems: defaultItems,
            event: mouseEvent
        }));
        const userFunc = gos.getCallback("getContextMenuItems");
        return userFunc?.({
            column: column,
            node: node,
            value: value,
            defaultItems: defaultItems,
            event: mouseEvent
        }) ?? defaultMenuOptions;
    }
    getContextMenuPosition(rowNode, column) {
        const rowCtrl = this.getRowCtrl(rowNode);
        const eGui = this.getCellGui(rowCtrl, column);
        if (!eGui) return {
            x: 0,
            y: rowCtrl?.getRowYPosition() ?? 0
        };
        const rect = eGui.getBoundingClientRect();
        return {
            x: rect.x + rect.width / 2,
            y: rect.y + rect.height / 2
        };
    }
    showContextMenu(params) {
        const rowNode = params.rowNode ?? null;
        const column = params.column ?? null;
        let { anchorToElement: anchorToElement, value: value, source: source } = params;
        if (rowNode && column && value == null) value = this.beans.valueSvc.getValueForDisplay({
            column: column,
            node: rowNode
        }).value;
        if (anchorToElement == null) anchorToElement = this.getContextMenuAnchorElement(rowNode, column);
        this.beans.menuUtils.onContextMenu({
            mouseEvent: params.mouseEvent ?? null,
            touchEvent: params.touchEvent ?? null,
            showMenuCallback: (eventOrTouch)=>this.menu.showMenu({
                    node: rowNode,
                    column: column,
                    value: value
                }, eventOrTouch, anchorToElement),
            source: source
        });
    }
    handleContextMenuMouseEvent(mouseEvent, touchEvent, rowCtrl, cellCtrl) {
        const rowNode = cellCtrl?.rowNode ?? rowCtrl?.rowNode ?? null;
        const column = cellCtrl?.column ?? rowCtrl?.findFullWidthInfoForEvent(mouseEvent || touchEvent)?.column ?? null;
        const { valueSvc: valueSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        const value = column ? valueSvc.getValue(column, rowNode) : null;
        const gridBodyCon = ctrlsSvc.getGridBodyCtrl();
        const anchorToElement = cellCtrl ? cellCtrl.eGui : gridBodyCon.eGridBody;
        this.showContextMenu({
            mouseEvent: mouseEvent,
            touchEvent: touchEvent,
            rowNode: rowNode,
            column: column,
            value: value,
            anchorToElement: anchorToElement,
            source: "ui"
        });
    }
    beforeMenuOpen(menuActionParams) {
        if (!menuActionParams.column) this.beans.focusSvc.clearFocusedCell();
    }
    onMenuOpen() {
        const { ctrlsSvc: ctrlsSvc, focusSvc: focusSvc } = this.beans;
        ctrlsSvc.getGridBodyCtrl().eGridBody.classList.add($5b7ccabde48fae90$var$CSS_CONTEXT_MENU_OPEN);
        this.focusedCell = focusSvc.getFocusedCell();
    }
    onMenuClose() {
        this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody.classList.remove($5b7ccabde48fae90$var$CSS_CONTEXT_MENU_OPEN);
    }
    afterMenuDestroyed() {
        const { beans: beans, focusedCell: focusedCell } = this;
        (0, $437b23f6a393c3bf$export$d43227ca3cbe63fa)(beans, focusedCell);
    }
    dispatchVisibleChangedEvent(visible, source) {
        this.eventSvc.dispatchEvent({
            type: "contextMenuVisibleChanged",
            visible: visible,
            source: source
        });
    }
    getRowCtrl(rowNode) {
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode || {};
        if (rowIndex == null) return;
        return this.beans.rowRenderer.getRowByPosition({
            rowIndex: rowIndex,
            rowPinned: rowPinned
        }) || void 0;
    }
    getCellGui(rowCtrl, column) {
        if (!rowCtrl || !column) return;
        const cellCtrl = rowCtrl.getCellCtrl(column);
        return cellCtrl?.eGui || void 0;
    }
    getContextMenuAnchorElement(rowNode, column) {
        const gridBodyEl = this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody;
        const rowCtrl = this.getRowCtrl(rowNode);
        if (!rowCtrl) return gridBodyEl;
        const cellGui = this.getCellGui(rowCtrl, column);
        if (cellGui) return cellGui;
        if (rowCtrl.isFullWidth()) return rowCtrl.getFullWidthElement();
        return gridBodyEl;
    }
    mapWithStockItems(menuItems, menuActionParams, getGui) {
        const { column: column, node: node } = menuActionParams;
        return this.beans.menuItemMapper.mapWithStockItems(menuItems, column, node, getGui, "contextMenu");
    }
};
var $5b7ccabde48fae90$var$TAB_FILTER = "filterMenuTab";
var $5b7ccabde48fae90$var$TAB_GENERAL = "generalMenuTab";
var $5b7ccabde48fae90$var$TAB_COLUMNS = "columnsMenuTab";
var $5b7ccabde48fae90$var$TABS_DEFAULT = [
    $5b7ccabde48fae90$var$TAB_GENERAL,
    $5b7ccabde48fae90$var$TAB_FILTER,
    $5b7ccabde48fae90$var$TAB_COLUMNS
];
var $5b7ccabde48fae90$var$EnterpriseMenuFactory = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "enterpriseMenuFactory";
    }
    hideActiveMenu() {
        this.destroyBean(this.activeMenu);
    }
    showMenuAfterMouseEvent(columnOrGroup, mouseEvent, containerType, onClosedCallback, filtersOnly) {
        const { column: column, columnGroup: columnGroup } = this.splitColumnOrGroup(columnOrGroup);
        const defaultTab = filtersOnly ? "filterMenuTab" : void 0;
        this.showMenu(column, columnGroup, (menu)=>{
            const ePopup = menu.getGui();
            this.beans.popupSvc.positionPopupUnderMouseEvent({
                type: containerType,
                additionalParams: {
                    column: column
                },
                mouseEvent: mouseEvent,
                ePopup: ePopup
            });
            if (defaultTab) menu.showTab?.(defaultTab);
            this.dispatchVisibleChangedEvent(true, false, column, columnGroup, defaultTab);
        }, containerType, defaultTab, void 0, mouseEvent.target, onClosedCallback);
    }
    splitColumnOrGroup(columnOrGroup) {
        const colIsColumn = columnOrGroup && (0, $437b23f6a393c3bf$export$891484e65a02ec71)(columnOrGroup);
        const column = colIsColumn ? columnOrGroup : void 0;
        const columnGroup = colIsColumn ? void 0 : columnOrGroup;
        return {
            column: column,
            columnGroup: columnGroup
        };
    }
    showMenuAfterButtonClick(columnOrGroup, eventSource, containerType, onClosedCallback, filtersOnly) {
        let multiplier = -1;
        let alignSide = "left";
        if (this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        const defaultTab = filtersOnly ? "filterMenuTab" : void 0;
        const restrictToTabs = defaultTab ? [
            defaultTab
        ] : void 0;
        const isLegacyMenuEnabled = (0, $437b23f6a393c3bf$export$2f1c8e943ce1a1be)(this.gos);
        const nudgeX = (isLegacyMenuEnabled ? 9 : 4) * multiplier;
        const nudgeY = isLegacyMenuEnabled ? -23 : 4;
        const { column: column, columnGroup: columnGroup } = this.splitColumnOrGroup(columnOrGroup);
        this.showMenu(column, columnGroup, (menu)=>{
            const ePopup = menu.getGui();
            this.beans.popupSvc.positionPopupByComponent({
                type: containerType,
                additionalParams: {
                    column: column
                },
                eventSource: eventSource,
                ePopup: ePopup,
                alignSide: alignSide,
                nudgeX: nudgeX,
                nudgeY: nudgeY,
                position: "under",
                keepWithinBounds: true
            });
            if (defaultTab) menu.showTab?.(defaultTab);
            this.dispatchVisibleChangedEvent(true, false, column, columnGroup, defaultTab);
        }, containerType, defaultTab, restrictToTabs, eventSource, onClosedCallback);
    }
    showMenu(column, columnGroup, positionCallback, containerType, defaultTab, restrictToTabs, eventSource, onClosedCallback) {
        const menuParams = this.getMenuParams(column, columnGroup, restrictToTabs, eventSource);
        if (!menuParams) return;
        const { menu: menu, eMenuGui: eMenuGui, anchorToElement: anchorToElement, restoreFocusParams: restoreFocusParams } = menuParams;
        const closedFuncs = [];
        const { menuUtils: menuUtils, popupSvc: popupSvc } = this.beans;
        closedFuncs.push((e)=>{
            const eComp = menu.getGui();
            this.destroyBean(menu);
            if (column) {
                (0, $437b23f6a393c3bf$export$2f1bf9feac2f7fbd)(column, false, "contextMenu");
                menuUtils.restoreFocusOnClose(restoreFocusParams, eComp, e);
            }
            onClosedCallback?.();
        });
        const translate = this.getLocaleTextFunc();
        popupSvc.addPopup({
            modal: true,
            eChild: eMenuGui,
            closeOnEsc: true,
            closedCallback: (e)=>{
                for (const f of closedFuncs)f(e);
                this.dispatchVisibleChangedEvent(false, false, column, columnGroup, defaultTab);
            },
            afterGuiAttached: (params)=>menu.afterGuiAttached(Object.assign({}, {
                    container: containerType
                }, params)),
            // if defaultTab is not present, positionCallback will be called
            // after `showTabBasedOnPreviousSelection` is called.
            positionCallback: defaultTab ? ()=>positionCallback(menu) : void 0,
            ariaLabel: translate("ariaLabelColumnMenu", "Column Menu")
        });
        if (!defaultTab) {
            menu.showTabBasedOnPreviousSelection?.();
            positionCallback(menu);
        }
        if ((0, $437b23f6a393c3bf$export$cfe4cf52f3717a7b)(this.gos)) {
            const stopAnchoringPromise = popupSvc.setPopupPositionRelatedToElement(eMenuGui, anchorToElement);
            if (stopAnchoringPromise && column) this.addStopAnchoring(stopAnchoringPromise, column, closedFuncs);
        }
        menu.addEventListener("tabSelected", (event)=>{
            this.dispatchVisibleChangedEvent(false, true, column);
            this.lastSelectedTab = event.key;
            this.dispatchVisibleChangedEvent(true, true, column);
        });
        if (column) (0, $437b23f6a393c3bf$export$2f1bf9feac2f7fbd)(column, true, "contextMenu");
        this.activeMenu = menu;
        menu.addEventListener("destroyed", ()=>{
            if (this.activeMenu === menu) this.activeMenu = null;
        });
    }
    addStopAnchoring(stopAnchoringPromise, column, closedFuncsArr) {
        stopAnchoringPromise.then((stopAnchoringFunc)=>{
            column.__addEventListener("leftChanged", stopAnchoringFunc);
            column.__addEventListener("visibleChanged", stopAnchoringFunc);
            closedFuncsArr.push(()=>{
                column.__removeEventListener("leftChanged", stopAnchoringFunc);
                column.__removeEventListener("visibleChanged", stopAnchoringFunc);
            });
        });
    }
    getMenuParams(column, columnGroup, restrictToTabs, eventSource) {
        const { focusSvc: focusSvc, visibleCols: visibleCols, ctrlsSvc: ctrlsSvc } = this.beans;
        const restoreFocusParams = {
            column: column,
            headerPosition: focusSvc.focusedHeader,
            columnIndex: visibleCols.allCols.indexOf(column),
            eventSource: eventSource
        };
        const menu = this.createMenu(column, columnGroup, restoreFocusParams, restrictToTabs, eventSource);
        return menu ? {
            menu: menu,
            eMenuGui: menu.getGui(),
            anchorToElement: eventSource || ctrlsSvc.getGridBodyCtrl().eGridBody,
            restoreFocusParams: restoreFocusParams
        } : void 0;
    }
    createMenu(column, columnGroup, restoreFocusParams, restrictToTabs, eventSource) {
        if ((0, $437b23f6a393c3bf$export$2f1c8e943ce1a1be)(this.gos)) return this.createBean(new $5b7ccabde48fae90$var$TabbedColumnMenu(column, restoreFocusParams, this.lastSelectedTab, restrictToTabs, eventSource));
        else {
            const menuItems = this.beans.colMenuFactory.getMenuItems(column, columnGroup);
            return menuItems.length ? this.createBean(new $5b7ccabde48fae90$var$ColumnContextMenu(menuItems, column, restoreFocusParams, eventSource)) : void 0;
        }
    }
    dispatchVisibleChangedEvent(visible, switchingTab, column, columnGroup, defaultTab) {
        this.eventSvc.dispatchEvent({
            type: "columnMenuVisibleChanged",
            visible: visible,
            switchingTab: switchingTab,
            key: this.lastSelectedTab ?? defaultTab ?? ((0, $437b23f6a393c3bf$export$2f1c8e943ce1a1be)(this.gos) ? $5b7ccabde48fae90$var$TAB_GENERAL : "columnMenu"),
            column: column ?? null,
            columnGroup: columnGroup ?? null
        });
    }
    isMenuEnabled(column) {
        if (!(0, $437b23f6a393c3bf$export$2f1c8e943ce1a1be)(this.gos)) return true;
        const isFilterDisabled = !this.beans.filterManager?.isFilterAllowed(column);
        const tabs = column.getColDef().menuTabs ?? $5b7ccabde48fae90$var$TABS_DEFAULT;
        const numActiveTabs = isFilterDisabled && tabs.includes($5b7ccabde48fae90$var$TAB_FILTER) ? tabs.length - 1 : tabs.length;
        return numActiveTabs > 0;
    }
    showMenuAfterContextMenuEvent(column, mouseEvent, touchEvent) {
        this.beans.menuUtils.onContextMenu({
            mouseEvent: mouseEvent,
            touchEvent: touchEvent,
            source: "ui",
            showMenuCallback: (eventOrTouch)=>{
                this.showMenuAfterMouseEvent(column, eventOrTouch, "columnMenu");
                return true;
            }
        });
    }
};
var $5b7ccabde48fae90$var$TabbedColumnMenu = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(column, restoreFocusParams, initialSelection, restrictTo, sourceElement){
        super();
        this.column = column;
        this.restoreFocusParams = restoreFocusParams;
        this.initialSelection = initialSelection;
        this.restrictTo = restrictTo;
        this.sourceElement = sourceElement;
        this.tabFactories = {};
        this.includeChecks = {};
        const { tabFactories: tabFactories, includeChecks: includeChecks } = this;
        tabFactories[$5b7ccabde48fae90$var$TAB_GENERAL] = this.createMainPanel.bind(this);
        tabFactories[$5b7ccabde48fae90$var$TAB_FILTER] = this.createFilterPanel.bind(this);
        tabFactories[$5b7ccabde48fae90$var$TAB_COLUMNS] = this.createColumnsPanel.bind(this);
        includeChecks[$5b7ccabde48fae90$var$TAB_GENERAL] = ()=>true;
        includeChecks[$5b7ccabde48fae90$var$TAB_FILTER] = ()=>column ? !!this.beans.filterManager?.isFilterAllowed(column) : false;
        includeChecks[$5b7ccabde48fae90$var$TAB_COLUMNS] = ()=>true;
    }
    postConstruct() {
        const tabs = this.getTabsToCreate().map((name)=>this.createTab(name));
        const tabbedLayout = new $5b7ccabde48fae90$export$1f389880cb99530f({
            items: tabs,
            cssClass: "ag-menu",
            onActiveItemClicked: this.onHidePopup.bind(this),
            onItemClicked: this.onTabItemClicked.bind(this)
        });
        this.tabbedLayout = this.createBean(tabbedLayout);
        this.mainMenuList?.setParentComponent(tabbedLayout);
        this.addDestroyFunc(()=>this.destroyBean(tabbedLayout));
    }
    getTabsToCreate() {
        if (this.restrictTo) return this.restrictTo;
        return (this.column?.getColDef().menuTabs ?? $5b7ccabde48fae90$var$TABS_DEFAULT).filter((tabName)=>this.isValidMenuTabItem(tabName) && this.isNotSuppressed(tabName));
    }
    isValidMenuTabItem(menuTabName) {
        let isValid = true;
        let itemsToConsider = $5b7ccabde48fae90$var$TABS_DEFAULT;
        if (this.restrictTo != null) {
            isValid = this.restrictTo.indexOf(menuTabName) > -1;
            itemsToConsider = this.restrictTo;
        }
        isValid = isValid && $5b7ccabde48fae90$var$TABS_DEFAULT.indexOf(menuTabName) > -1;
        if (!isValid) (0, $437b23f6a393c3bf$export$545083624300f13d)(175, {
            menuTabName: menuTabName,
            itemsToConsider: itemsToConsider
        });
        return isValid;
    }
    isNotSuppressed(menuTabName) {
        return this.includeChecks[menuTabName]();
    }
    createTab(name) {
        return this.tabFactories[name]();
    }
    showTabBasedOnPreviousSelection() {
        this.showTab(this.initialSelection);
    }
    showTab(toShow) {
        const { tabItemColumns: tabItemColumns, tabbedLayout: tabbedLayout, tabItemFilter: tabItemFilter, tabItemGeneral: tabItemGeneral } = this;
        if (tabItemColumns && toShow === $5b7ccabde48fae90$var$TAB_COLUMNS) tabbedLayout.showItem(tabItemColumns);
        else if (tabItemFilter && toShow === $5b7ccabde48fae90$var$TAB_FILTER) tabbedLayout.showItem(tabItemFilter);
        else if (tabItemGeneral && toShow === $5b7ccabde48fae90$var$TAB_GENERAL) tabbedLayout.showItem(tabItemGeneral);
        else tabbedLayout.showFirstItem();
    }
    onTabItemClicked(event) {
        let key = null;
        switch(event.item){
            case this.tabItemColumns:
                key = $5b7ccabde48fae90$var$TAB_COLUMNS;
                break;
            case this.tabItemFilter:
                key = $5b7ccabde48fae90$var$TAB_FILTER;
                break;
            case this.tabItemGeneral:
                key = $5b7ccabde48fae90$var$TAB_GENERAL;
                break;
        }
        if (key) this.activateTab(key);
    }
    activateTab(tab) {
        const ev = {
            type: "tabSelected",
            key: tab
        };
        this.dispatchLocalEvent(ev);
    }
    createMainPanel() {
        const { beans: beans, column: column } = this;
        const colMenuFactory = beans.colMenuFactory;
        const mainMenuList = colMenuFactory.createMenu(this, colMenuFactory.getMenuItems(column), this.column, ()=>this.sourceElement ?? this.getGui());
        this.mainMenuList = mainMenuList;
        mainMenuList.addEventListener("closeMenu", this.onHidePopup.bind(this));
        const tabItemGeneral = {
            title: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("legacyMenu", beans, column),
            titleLabel: $5b7ccabde48fae90$var$TAB_GENERAL.replace("MenuTab", ""),
            bodyPromise: (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(mainMenuList.getGui()),
            name: $5b7ccabde48fae90$var$TAB_GENERAL
        };
        this.tabItemGeneral = tabItemGeneral;
        return tabItemGeneral;
    }
    onHidePopup(event) {
        this.beans.menuUtils.closePopupAndRestoreFocusOnSelect(this.hidePopupFunc, this.restoreFocusParams, event);
    }
    createFilterPanel() {
        const comp = this.column ? this.createBean(new (0, $437b23f6a393c3bf$export$7db6d402989d8b90)(this.column, "COLUMN_MENU")) : null;
        this.filterComp = comp;
        if (!comp?.hasFilter()) (0, $437b23f6a393c3bf$export$a20c7248650823a9)(119);
        const afterAttachedCallback = (params)=>comp?.afterGuiAttached(params);
        const afterDetachedCallback = ()=>comp?.afterGuiDetached();
        this.tabItemFilter = {
            title: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("filterTab", this.beans, this.column),
            titleLabel: $5b7ccabde48fae90$var$TAB_FILTER.replace("MenuTab", ""),
            bodyPromise: (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(comp?.getGui()),
            afterAttachedCallback: afterAttachedCallback,
            afterDetachedCallback: afterDetachedCallback,
            name: $5b7ccabde48fae90$var$TAB_FILTER
        };
        return this.tabItemFilter;
    }
    createColumnsPanel() {
        const eWrapperDiv = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div",
            cls: "ag-menu-column-select-wrapper"
        });
        const { beans: beans, column: column } = this;
        const columnSelectPanel = beans.colChooserFactory.createColumnSelectPanel(this, column);
        const columnSelectPanelGui = columnSelectPanel.getGui();
        columnSelectPanelGui.classList.add("ag-menu-column-select");
        eWrapperDiv.appendChild(columnSelectPanelGui);
        const tabItemColumns = {
            title: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("columns", beans, column),
            //createColumnsIcon(),
            titleLabel: $5b7ccabde48fae90$var$TAB_COLUMNS.replace("MenuTab", ""),
            bodyPromise: (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(eWrapperDiv),
            name: $5b7ccabde48fae90$var$TAB_COLUMNS
        };
        this.tabItemColumns = tabItemColumns;
        return tabItemColumns;
    }
    afterGuiAttached(params) {
        const { container: container, hidePopup: hidePopup } = params;
        this.tabbedLayout.setAfterAttachedParams({
            container: container,
            hidePopup: hidePopup
        });
        if (hidePopup) {
            this.hidePopupFunc = hidePopup;
            this.addDestroyFunc(hidePopup);
        }
    }
    getGui() {
        return this.tabbedLayout.getGui();
    }
    destroy() {
        super.destroy();
        this.destroyBean(this.filterComp);
    }
};
var $5b7ccabde48fae90$var$ColumnContextMenu = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(menuItems, column, restoreFocusParams, sourceElement){
        super({
            tag: "div",
            ref: "eColumnMenu",
            cls: "ag-menu ag-column-menu",
            role: "presentation"
        });
        this.menuItems = menuItems;
        this.column = column;
        this.restoreFocusParams = restoreFocusParams;
        this.sourceElement = sourceElement;
        this.eColumnMenu = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        const mainMenuList = this.beans.colMenuFactory.createMenu(this, this.menuItems, this.column, ()=>this.sourceElement ?? this.getGui());
        this.mainMenuList = mainMenuList;
        mainMenuList.addEventListener("closeMenu", this.onHidePopup.bind(this));
        this.eColumnMenu.appendChild(mainMenuList.getGui());
    }
    // eslint-disable-next-line sonarjs/no-identical-functions
    onHidePopup(event) {
        this.beans.menuUtils.closePopupAndRestoreFocusOnSelect(this.hidePopupFunc, this.restoreFocusParams, event);
    }
    afterGuiAttached({ hidePopup: hidePopup }) {
        if (hidePopup) {
            this.hidePopupFunc = hidePopup;
            this.addDestroyFunc(hidePopup);
        }
        (0, $437b23f6a393c3bf$export$8598088d375f416f)(this.mainMenuList.getGui());
    }
};
// packages/ag-grid-enterprise/src/menu/menuApi.ts
function $5b7ccabde48fae90$var$showContextMenu(beans, params) {
    const { contextMenuSvc: contextMenuSvc } = beans;
    if (!contextMenuSvc) return;
    const { rowNode: rowNode, column: column, value: value, x: x, y: y } = params || {};
    let { x: clientX, y: clientY } = contextMenuSvc.getContextMenuPosition(rowNode, column);
    if (x != null) clientX = x;
    if (y != null) clientY = y;
    contextMenuSvc.showContextMenu({
        mouseEvent: new MouseEvent("mousedown", {
            clientX: clientX,
            clientY: clientY
        }),
        rowNode: rowNode,
        column: column,
        value: value,
        source: "api"
    });
}
function $5b7ccabde48fae90$var$showColumnChooser(beans, params) {
    beans.colChooserFactory?.showColumnChooser({
        chooserParams: params
    });
}
function $5b7ccabde48fae90$var$hideColumnChooser(beans) {
    beans.colChooserFactory?.hideActiveColumnChooser();
}
var $5b7ccabde48fae90$var$MenuUtils = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "menuUtils";
    }
    restoreFocusOnClose(restoreFocusParams, eComp, e, restoreIfMouseEvent) {
        const { eventSource: eventSource } = restoreFocusParams;
        const isKeyboardEvent = e instanceof KeyboardEvent;
        if (!restoreIfMouseEvent && !isKeyboardEvent || !eventSource) return;
        const activeEl = (0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans);
        if (// focus is outside of comp
        !eComp.contains(activeEl) && // something else has focus
        !(0, $437b23f6a393c3bf$export$8ff9eef09a45371f)(this.beans)) return;
        this.focusHeaderCell(restoreFocusParams);
    }
    closePopupAndRestoreFocusOnSelect(hidePopupFunc, restoreFocusParams, event) {
        let keyboardEvent;
        if (event?.keyboardEvent) keyboardEvent = event.keyboardEvent;
        hidePopupFunc(keyboardEvent && {
            keyboardEvent: keyboardEvent
        });
        const beans = this.beans;
        const focusSvc = beans.focusSvc;
        const focusedCell = focusSvc.getFocusedCell();
        if ((0, $437b23f6a393c3bf$export$8ff9eef09a45371f)(beans)) {
            if (focusedCell) {
                const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = focusedCell;
                focusSvc.setFocusedCell({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned,
                    forceBrowserFocus: true,
                    preventScrollOnBrowserFocus: true
                });
            } else this.focusHeaderCell(restoreFocusParams);
        }
    }
    onContextMenu(params) {
        const { mouseEvent: mouseEvent, touchEvent: touchEvent, showMenuCallback: showMenuCallback, source: source } = params;
        if (!this.gos.get("allowContextMenuWithControlKey")) {
            if (mouseEvent && (mouseEvent.ctrlKey || mouseEvent.metaKey)) return;
        }
        if (mouseEvent) this.blockMiddleClickScrollsIfNeeded(mouseEvent);
        if (source === "ui" && this.gos.get("suppressContextMenu")) return;
        const eventOrTouch = mouseEvent ?? touchEvent.touches[0];
        if (showMenuCallback(eventOrTouch)) {
            const event = mouseEvent ?? touchEvent;
            if (event?.cancelable) event.preventDefault();
        }
    }
    // make this async for react
    async focusHeaderCell(restoreFocusParams) {
        const { column: column, columnIndex: columnIndex, headerPosition: headerPosition, eventSource: eventSource } = restoreFocusParams;
        const { visibleCols: visibleCols, headerNavigation: headerNavigation, focusSvc: focusSvc } = this.beans;
        const isColumnStillVisible = await visibleCols.allCols.some((col)=>col === column);
        if (!this.isAlive()) return;
        if (column?.isAlive() && isColumnStillVisible && eventSource && (0, $437b23f6a393c3bf$export$2badf4aa566524cb)(eventSource)) {
            const focusableEl = (0, $437b23f6a393c3bf$export$c4c49c776025d475)(eventSource);
            if (focusableEl) {
                headerNavigation?.scrollToColumn(column);
                focusableEl.focus();
            }
        } else if (headerPosition && columnIndex !== -1) {
            const allColumns = visibleCols.allCols;
            const columnToFocus = allColumns[columnIndex] || (0, $437b23f6a393c3bf$export$236389741107357f)(allColumns);
            if (columnToFocus) focusSvc.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: headerPosition.headerRowIndex,
                    column: columnToFocus
                }
            });
        }
    }
    blockMiddleClickScrollsIfNeeded(mouseEvent) {
        if (this.gos.get("suppressMiddleClickScrolls") && mouseEvent.which === 2) mouseEvent.preventDefault();
    }
};
// packages/ag-grid-enterprise/src/menu/menuModule.ts
var $5b7ccabde48fae90$var$MenuCoreModule = {
    moduleName: "MenuCore",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$MenuItemMapper,
        $5b7ccabde48fae90$var$ChartMenuItemMapper,
        $5b7ccabde48fae90$var$MenuUtils
    ],
    icons: {
        // context menu chart item
        chart: "chart",
        // columns in menu (column chooser / columns tab)
        columns: "columns",
        // loading async menu items
        loadingMenuItems: "loading",
        // "Pin column" item in column header menu
        menuPin: "pin",
        // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
        menuValue: "aggregation",
        // "Group by {column-name}" item in column header menu
        menuAddRowGroup: "group",
        // "Un-Group by {column-name}" item in column header menu
        menuRemoveRowGroup: "group",
        // context menu copy item
        clipboardCopy: "copy",
        // context menu cut item
        clipboardCut: "cut",
        // context menu paste item
        clipboardPaste: "paste",
        // context menu export item
        save: "save",
        // csv export
        csvExport: "csv",
        // excel export,
        excelExport: "excel",
        // show on column header when column is sorted ascending
        sortAscending: "asc",
        // show on column header when column is sorted descending
        sortDescending: "desc",
        // show on column header when column is sorted absolute ascending
        sortAbsoluteAscending: "aasc",
        // show on column header when column is sorted absolute descending
        sortAbsoluteDescending: "adesc",
        // show on column header when column has no sort, only when enabled with colDef.unSortIcon=true
        sortUnSort: "none"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$da5c9bb998e6c24d),
        (0, $437b23f6a393c3bf$export$b0ea578339daf1f7),
        $5b7ccabde48fae90$var$MenuItemModule
    ]
};
var $5b7ccabde48fae90$export$af7cdc2b9a7c9c3 = {
    moduleName: "ColumnMenu",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$EnterpriseMenuFactory,
        $5b7ccabde48fae90$var$ColumnMenuFactory,
        $5b7ccabde48fae90$var$ColumnChooserFactory
    ],
    icons: {
        ensureColumnVisible: "column-arrow",
        // menu tab icon in legacy tabbed enterprise column menu
        legacyMenu: "menu",
        // filter tab icon in legacy tabbed enterprise column menu
        filterTab: "filter",
        // column tool panel column group contracted (click to expand)
        columnSelectClosed: "tree-closed",
        // column tool panel column group expanded (click to contract)
        columnSelectOpen: "tree-open",
        // column tool panel header expand/collapse all button, shown when some children are expanded and
        //     others are collapsed
        columnSelectIndeterminate: "tree-indeterminate"
    },
    apiFunctions: {
        showColumnChooser: $5b7ccabde48fae90$var$showColumnChooser,
        hideColumnChooser: $5b7ccabde48fae90$var$hideColumnChooser
    },
    dependsOn: [
        $5b7ccabde48fae90$var$MenuCoreModule,
        (0, $437b23f6a393c3bf$export$4ad116d131ade5b4),
        (0, $437b23f6a393c3bf$export$1458fbffed29c925)
    ]
};
var $5b7ccabde48fae90$export$30ae2785d49a9f03 = {
    moduleName: "ContextMenu",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$ContextMenuService
    ],
    apiFunctions: {
        showContextMenu: $5b7ccabde48fae90$var$showContextMenu
    },
    dependsOn: [
        $5b7ccabde48fae90$var$MenuCoreModule
    ]
};
var $5b7ccabde48fae90$export$f1ab43fc4c3c5ce0 = {
    moduleName: "Menu",
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: [
        $5b7ccabde48fae90$export$af7cdc2b9a7c9c3,
        $5b7ccabde48fae90$export$30ae2785d49a9f03
    ]
};
var $5b7ccabde48fae90$var$RichSelectCellEditor = class extends (0, $437b23f6a393c3bf$export$803b08aecd9af1a9) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-cell-edit-wrapper"
        });
        this.currentSearchRequest = 0;
        this.onSearchCallback = (searchString)=>{
            const currentRequest = ++this.currentSearchRequest;
            const richSelect = this.eEditor;
            richSelect.setValueList({
                refresh: true,
                valueList: void 0
            });
            const params = this.params;
            params.search = searchString;
            if (!params.search) return;
            if (typeof params.values !== "function") {
                if (this.isFullAsync()) (0, $437b23f6a393c3bf$export$545083624300f13d)(294);
                return;
            }
            const valuesPromise = params.values(params);
            if (Array.isArray(valuesPromise)) {
                if (this.isFullAsync()) (0, $437b23f6a393c3bf$export$545083624300f13d)(294);
                richSelect.setValueList({
                    refresh: true,
                    valueList: valuesPromise
                });
                return;
            }
            richSelect.setValueList({
                valueList: valuesPromise.then((results)=>{
                    if (currentRequest === this.currentSearchRequest) return results;
                }),
                refresh: true
            });
        };
    }
    initialiseEditor(_params) {
        const { cellStartedEdit: cellStartedEdit, values: values, eventKey: eventKey } = this.params;
        if ((0, $437b23f6a393c3bf$export$672d9e47bc342bac)(values)) (0, $437b23f6a393c3bf$export$545083624300f13d)(180);
        const { params: richSelectParams, valueList: valueList } = this.buildRichSelectParams();
        const richSelect = this.createManagedBean(new $5b7ccabde48fae90$var$AgRichSelect(richSelectParams));
        this.eEditor = richSelect;
        richSelect.addCss("ag-cell-editor");
        this.appendChild(richSelect);
        if (this.isFullAsync()) richSelect.showPicker();
        this.eEditor.setValueList({
            valueList: valueList,
            refresh: true,
            isInitial: true
        });
        const isOneTimeAsync = valueList && !Array.isArray(valueList);
        if (isOneTimeAsync) valueList.then((values2)=>{
            const searchStringCallback = this.getSearchStringCallback(values2);
            if (searchStringCallback) richSelect.setSearchStringCreator(searchStringCallback);
            this.processEventKey(eventKey);
        });
        this.addManagedListeners(richSelect, {
            fieldPickerValueSelected: this.onEditorPickerValueSelected.bind(this)
        });
        this.focusAfterAttached = cellStartedEdit;
    }
    onEditorPickerValueSelected(e) {
        if (this.gos.get("editType") !== "fullRow") setTimeout(()=>this.params.stopEditing(!e.fromEnterKey));
    }
    getPlaceholderText() {
        const { valuePlaceholder: valuePlaceholder } = this.params;
        if (valuePlaceholder !== void 0) return valuePlaceholder;
        const i18n = this.getLocaleTextFunc();
        return this.isFullAsync() ? i18n("typeToSearchOoo", "Type to search...") : i18n("advancedFilterBuilderSelectOption", "Select an option...");
    }
    isFullAsync() {
        const { allowTyping: allowTyping, filterListAsync: filterListAsync, values: values } = this.params;
        const isSyncOrAsyncOrFullAsync = typeof values === "function";
        if (!isSyncOrAsyncOrFullAsync && filterListAsync) (0, $437b23f6a393c3bf$export$545083624300f13d)(294);
        return !!(allowTyping && filterListAsync && typeof values === "function");
    }
    getInitialValueList() {
        const params = this.params;
        const { values: values } = params;
        const maybeItIsFullAsync = this.isFullAsync();
        const isSync = Array.isArray(values) || !values;
        const isSyncOrAsyncOrFullAsync = typeof values === "function";
        if (isSync) return values ?? [];
        if (!isSyncOrAsyncOrFullAsync) return [];
        if (maybeItIsFullAsync) return;
        return values({
            ...params
        });
    }
    buildRichSelectParams() {
        const params = this.params;
        const { cellRenderer: cellRenderer, cellRendererParams: cellRendererParams, cellHeight: cellHeight, value: value, values: values, formatValue: formatValue, searchDebounceDelay: searchDebounceDelay, valueListGap: valueListGap, valueListMaxHeight: valueListMaxHeight, valueListMaxWidth: valueListMaxWidth, allowTyping: allowTyping, filterList: filterList, searchType: searchType, highlightMatch: highlightMatch, eventKey: eventKey, multiSelect: multiSelect, suppressDeselectAll: suppressDeselectAll, suppressMultiSelectPillRenderer: suppressMultiSelectPillRenderer } = params;
        const ret = {
            value: value,
            cellRenderer: cellRenderer,
            cellRendererParams: cellRendererParams,
            cellRowHeight: cellHeight,
            searchDebounceDelay: searchDebounceDelay,
            valueFormatter: formatValue,
            pickerAriaLabelKey: "ariaLabelRichSelectField",
            pickerAriaLabelValue: "Rich Select Field",
            pickerType: "virtual-list",
            pickerGap: valueListGap,
            allowTyping: allowTyping,
            filterList: filterList,
            searchType: searchType,
            highlightMatch: highlightMatch,
            maxPickerHeight: valueListMaxHeight,
            maxPickerWidth: valueListMaxWidth,
            placeholder: this.getPlaceholderText(),
            initialInputValue: eventKey?.length === 1 ? eventKey : eventKey === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).BACKSPACE ? "" : void 0,
            multiSelect: multiSelect,
            suppressDeselectAll: suppressDeselectAll,
            suppressMultiSelectPillRenderer: suppressMultiSelectPillRenderer
        };
        const valueList = this.getInitialValueList();
        const maybeItIsFullAsync = this.isFullAsync();
        const isSync = Array.isArray(values);
        const isSyncOrAsyncOrFullAsync = typeof values === "function";
        if (isSync) {
            ret.valueList = valueList;
            ret.searchStringCreator = this.getSearchStringCallback(valueList);
        } else if (isSyncOrAsyncOrFullAsync && maybeItIsFullAsync) {
            ret.onSearch = this.onSearchCallback;
            ret.allowNoResultsCopy = true;
            ret.filterList = true;
        }
        if (multiSelect && allowTyping) {
            params.allowTyping = false;
            ret.allowTyping = false;
            (0, $437b23f6a393c3bf$export$545083624300f13d)(181);
        }
        return {
            params: ret,
            valueList: valueList
        };
    }
    getSearchStringCallback(values) {
        if (typeof values[0] !== "object") return;
        const params = this.params;
        const { colDef: colDef, formatValue: formatValue } = params;
        if (colDef.cellEditorParams?.formatValue) return (values2)=>values2.map(formatValue);
        const { keyCreator: keyCreator } = colDef;
        if (keyCreator) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(266);
            const { column: column, node: node, data: data } = params;
            return (values2)=>values2.map((value)=>{
                    const keyParams = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
                        value: value,
                        colDef: colDef,
                        column: column,
                        node: node,
                        data: data
                    });
                    return keyCreator(keyParams);
                });
        }
        return (values2)=>values2.map(formatValue);
    }
    // we need to have the gui attached before we can draw the virtual rows, as the
    // virtual row logic needs info about the gui state.
    afterGuiAttached() {
        const { focusAfterAttached: focusAfterAttached, params: params } = this;
        setTimeout(()=>{
            if (!this.isAlive()) return;
            const richSelect = this.eEditor;
            const { allowTyping: allowTyping, eventKey: eventKey, cellStartedEdit: cellStartedEdit } = params;
            if (focusAfterAttached) {
                const focusableEl = richSelect.getFocusableElement();
                focusableEl.focus();
                if (allowTyping && (!eventKey || eventKey.length !== 1)) focusableEl.select();
            }
            if (cellStartedEdit) richSelect.showPicker();
            this.processEventKey(eventKey);
        });
    }
    processEventKey(eventKey) {
        if (!eventKey) return;
        if (eventKey === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).BACKSPACE) this.eEditor.searchTextFromString(null);
        else if (eventKey?.length === 1) this.eEditor.searchTextFromString(eventKey);
    }
    focusIn() {
        this.eEditor.getFocusableElement().focus();
    }
    getValue() {
        const { params: params } = this;
        const value = this.eEditor.getValue();
        return params.parseValue?.(value) ?? value;
    }
    isPopup() {
        return false;
    }
    getValidationElement() {
        return this.eEditor.getAriaElement();
    }
    getValidationErrors() {
        const { params: params } = this;
        const { getValidationErrors: getValidationErrors } = params;
        if (!getValidationErrors) return null;
        return getValidationErrors({
            value: this.getValue(),
            internalErrors: null,
            cellEditorParams: params
        });
    }
};
// packages/ag-grid-enterprise/src/richSelect/richSelectModule.ts
var $5b7ccabde48fae90$export$9bd93207561bb9c = {
    moduleName: "RichSelect",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [],
    userComponents: {
        agRichSelect: $5b7ccabde48fae90$var$RichSelectCellEditor,
        agRichSelectCellEditor: $5b7ccabde48fae90$var$RichSelectCellEditor
    },
    icons: {
        // open icon for rich select editor
        richSelectOpen: "small-down",
        // remove for rich select editor pills
        richSelectRemove: "cancel",
        // loading async values
        richSelectLoading: "loading"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$12c61a50add34259)
    ]
};
// packages/ag-grid-enterprise/src/setFilter/iSetDisplayValueModel.ts
var $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL = "__AG_SELECT_ALL__";
var $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER = "__AG_ADD_SELECTION_TO_FILTER__";
// packages/ag-grid-enterprise/src/setFilter/flatSetDisplayValueModel.ts
var $5b7ccabde48fae90$var$FlatSetDisplayValueModel = class {
    constructor(valueSvc, getValueFormatter, formatter, column){
        this.valueSvc = valueSvc;
        this.getValueFormatter = getValueFormatter;
        this.formatter = formatter;
        this.column = column;
        /** All keys that are currently displayed, after the mini-filter has been applied. */ this.displayedKeys = [];
    }
    updateDisplayedValuesToAllAvailable(_getValue, _allKeys, availableKeys) {
        this.displayedKeys = Array.from(availableKeys);
    }
    updateDisplayedValuesToMatchMiniFilter(getValue, _allKeys, availableKeys, matchesFilter, nullMatchesFilter) {
        this.displayedKeys = [];
        const valueFormatter = this.getValueFormatter();
        for (const key of availableKeys){
            if (key == null) {
                if (nullMatchesFilter) this.displayedKeys.push(key);
            } else {
                const value = getValue(key);
                const valueFormatterValue = this.valueSvc.formatValue(this.column, null, value, valueFormatter, false);
                const textFormatterValue = this.formatter(valueFormatterValue);
                if (matchesFilter(textFormatterValue)) this.displayedKeys.push(key);
            }
        }
    }
    getDisplayedValueCount() {
        return this.displayedKeys.length;
    }
    getDisplayedItem(index) {
        return this.displayedKeys[index];
    }
    getSelectAllItem() {
        return $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL;
    }
    getAddSelectionToFilterItem() {
        return $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER;
    }
    getDisplayedKeys() {
        return this.displayedKeys;
    }
    forEachDisplayedKey(func) {
        this.displayedKeys.forEach(func);
    }
    someDisplayedKey(func) {
        return this.displayedKeys.some(func);
    }
    hasGroups() {
        return false;
    }
    refresh() {}
};
var $5b7ccabde48fae90$var$SetFilterGroupElement = {
    tag: "div",
    cls: "ag-set-filter-item",
    attrs: {
        "aria-hidden": "true"
    },
    children: [
        {
            tag: "span",
            cls: "ag-set-filter-group-icons",
            children: [
                {
                    tag: "span",
                    ref: "eGroupClosedIcon",
                    cls: "ag-set-filter-group-closed-icon"
                },
                {
                    tag: "span",
                    ref: "eGroupOpenedIcon",
                    cls: "ag-set-filter-group-opened-icon"
                },
                {
                    tag: "span",
                    ref: "eGroupIndeterminateIcon",
                    cls: "ag-set-filter-group-indeterminate-icon"
                }
            ]
        },
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            cls: "ag-set-filter-item-checkbox"
        }
    ]
};
var $5b7ccabde48fae90$var$SetFilterElement = {
    tag: "div",
    cls: "ag-set-filter-item",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            cls: "ag-set-filter-item-checkbox"
        }
    ]
};
var $5b7ccabde48fae90$var$SetFilterListItem = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(params){
        super(params.isGroup ? $5b7ccabde48fae90$var$SetFilterGroupElement : $5b7ccabde48fae90$var$SetFilterElement, [
            (0, $437b23f6a393c3bf$export$2e2c317d2e31f2ca)
        ]);
        this.eCheckbox = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eGroupOpenedIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eGroupClosedIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eGroupIndeterminateIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.formattedValue = null;
        this.focusWrapper = params.focusWrapper;
        this.value = params.value;
        this.params = params.params;
        this.translate = params.translate;
        this.valueFormatter = params.valueFormatter;
        this.item = params.item;
        this.isSelected = params.isSelected;
        this.isTree = params.isTree;
        this.depth = params.depth ?? 0;
        this.isGroup = params.isGroup;
        this.groupsExist = params.groupsExist;
        this.isExpanded = params.isExpanded;
        this.hasIndeterminateExpandState = params.hasIndeterminateExpandState;
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.focusWrapper,
            getLocation: ()=>"setFilterValue",
            shouldDisplayTooltip: ()=>this.shouldDisplayTooltip?.() ?? true,
            getAdditionalParams: ()=>{
                const { colDef: colDef, column: column } = this.params;
                const additionalParams = {
                    colDef: colDef,
                    column: column,
                    valueFormatted: this.formattedValue ?? void 0
                };
                if (this.isTree) additionalParams.level = this.depth;
                return additionalParams;
            }
        }));
        this.addDestroyFunc(()=>this.destroyCellRendererComponent?.());
        this.render();
        this.eCheckbox.setLabelEllipsis(true).setValue(this.isSelected, true).setDisabled(!!this.params.readOnly).getInputElement().setAttribute("tabindex", "-1");
        this.refreshVariableAriaLabels();
        if (this.isTree) {
            if (this.depth > 0) {
                this.addCss("ag-set-filter-indent-" + this.depth);
                this.getGui().style.setProperty("--ag-indentation-level", String(this.depth));
            }
            if (this.isGroup) this.setupExpansion();
            else if (this.groupsExist) this.addCss("ag-set-filter-add-group-indent");
            (0, $437b23f6a393c3bf$export$9eaf1f20171625e8)(this.getAriaElement(), this.depth + 1);
        }
        this.refreshAriaChecked();
        if (this.params.readOnly) return;
        this.eCheckbox.onValueChange((value)=>this.onCheckboxChanged(!!value));
    }
    getFocusableElement() {
        return this.focusWrapper;
    }
    setupExpansion() {
        const { eGroupClosedIcon: eGroupClosedIcon, eGroupOpenedIcon: eGroupOpenedIcon, eGroupIndeterminateIcon: eGroupIndeterminateIcon, hasIndeterminateExpandState: hasIndeterminateExpandState, beans: beans } = this;
        eGroupClosedIcon.appendChild((0, $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1)("setFilterGroupClosed", beans, null));
        eGroupOpenedIcon.appendChild((0, $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1)("setFilterGroupOpen", beans, null));
        const listener = this.onExpandOrContractClicked.bind(this);
        this.addManagedElementListeners(eGroupClosedIcon, {
            click: listener
        });
        this.addManagedElementListeners(eGroupOpenedIcon, {
            click: listener
        });
        if (hasIndeterminateExpandState) {
            eGroupIndeterminateIcon.appendChild((0, $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1)("setFilterGroupIndeterminate", beans, null));
            this.addManagedElementListeners(eGroupIndeterminateIcon, {
                click: listener
            });
        }
        this.setExpandedIcons();
        this.refreshAriaExpanded();
    }
    onExpandOrContractClicked() {
        this.setExpanded(!this.isExpanded);
    }
    setExpanded(isExpanded, silent) {
        if (this.isGroup && isExpanded !== this.isExpanded) {
            this.isExpanded = isExpanded;
            const event = {
                type: "expandedChanged",
                isExpanded: !!isExpanded,
                item: this.item
            };
            if (!silent) this.dispatchLocalEvent(event);
            this.setExpandedIcons();
            this.refreshAriaExpanded();
        }
    }
    setExpandedIcons() {
        const { isExpanded: isExpanded, hasIndeterminateExpandState: hasIndeterminateExpandState, eGroupClosedIcon: eGroupClosedIcon, eGroupOpenedIcon: eGroupOpenedIcon, eGroupIndeterminateIcon: eGroupIndeterminateIcon } = this;
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eGroupClosedIcon, hasIndeterminateExpandState ? isExpanded === false : !isExpanded);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eGroupOpenedIcon, isExpanded === true);
        if (hasIndeterminateExpandState) (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eGroupIndeterminateIcon, isExpanded === void 0);
    }
    onCheckboxChanged(isSelected) {
        this.isSelected = isSelected;
        const event = {
            type: "selectionChanged",
            isSelected: isSelected,
            item: this.item
        };
        this.dispatchLocalEvent(event);
        this.refreshVariableAriaLabels();
        this.refreshAriaChecked();
    }
    toggleSelected() {
        if (this.params.readOnly) return;
        this.setSelected(!this.isSelected);
    }
    setSelected(isSelected, silent) {
        this.isSelected = isSelected;
        this.eCheckbox.setValue(isSelected, silent);
        this.refreshAriaChecked();
    }
    refreshVariableAriaLabels() {
        if (!this.isTree) return;
        const translate = this.getLocaleTextFunc();
        const checkboxValue = this.eCheckbox.getValue();
        const state = checkboxValue === void 0 ? translate("ariaIndeterminate", "indeterminate") : checkboxValue ? translate("ariaVisible", "visible") : translate("ariaHidden", "hidden");
        const visibilityLabel = translate("ariaToggleVisibility", "Press SPACE to toggle visibility");
        (0, $437b23f6a393c3bf$export$84233c40c4c74001)(this.eCheckbox.getInputElement(), void 0);
        this.eCheckbox.setInputAriaLabel(`${visibilityLabel} (${state})`);
    }
    setupFixedAriaLabels(value) {
        if (!this.isTree) return;
        const translate = this.getLocaleTextFunc();
        const itemLabel = translate("ariaFilterValue", "Filter Value");
        const ariaEl = this.getAriaElement();
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(ariaEl, `${value} ${itemLabel}`);
        (0, $437b23f6a393c3bf$export$3c2bc877474a7797)(ariaEl, this.eCheckbox.getInputElement().id);
    }
    refreshAriaChecked() {
        const ariaEl = this.getAriaElement();
        (0, $437b23f6a393c3bf$export$43b4d6c0ec0fa4c7)(ariaEl, this.eCheckbox.getValue());
    }
    refreshAriaExpanded() {
        (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(this.getAriaElement(), !!this.isExpanded);
    }
    refresh(item, isSelected, isExpanded) {
        this.item = item;
        if (isSelected !== this.isSelected) this.setSelected(isSelected, true);
        this.setExpanded(isExpanded, true);
        const { cellRendererComponent: cellRendererComponent, cellRendererParams: cellRendererParams, beans: beans, params: params } = this;
        if (this.valueFunction) {
            const value = this.valueFunction();
            this.setTooltipAndCellRendererParams(value, value);
            if (!cellRendererComponent) this.renderCellWithoutCellRenderer();
        }
        if (cellRendererComponent) {
            const compDetails = (0, $437b23f6a393c3bf$export$1f172e021e4d8401)(beans.userCompFactory, params, cellRendererParams);
            const success = cellRendererComponent.refresh?.(compDetails?.params ?? cellRendererParams);
            if (!success) {
                const oldComponent = cellRendererComponent;
                this.renderCell();
                this.destroyBean(oldComponent);
            }
        }
    }
    render() {
        const { params: { column: column } } = this;
        let { value: value } = this;
        let formattedValue = null;
        if (typeof value === "function") {
            this.valueFunction = value;
            formattedValue = this.valueFunction();
            value = formattedValue;
        } else if (this.isTree) formattedValue = (0, $437b23f6a393c3bf$export$2a74c29220d5c88e)(value);
        else formattedValue = this.getFormattedValue(column, value);
        this.formattedValue = formattedValue;
        this.setTooltipAndCellRendererParams(value, formattedValue);
        this.renderCell();
    }
    setTooltipAndCellRendererParams(value, formattedValue) {
        const gos = this.gos;
        if (this.params.showTooltips && (!(0, $437b23f6a393c3bf$export$58660753196c7cdf)(gos) || !this.params.cellRenderer)) {
            const newTooltipText = formattedValue != null ? formattedValue : (0, $437b23f6a393c3bf$export$2a74c29220d5c88e)(value);
            this.shouldDisplayTooltip = (0, $437b23f6a393c3bf$export$75f51ed61a5271e6)(gos, ()=>this.eCheckbox.getGui().querySelector(".ag-label"));
            this.tooltipFeature?.setTooltipAndRefresh(newTooltipText);
        }
        this.cellRendererParams = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(gos, {
            value: value,
            valueFormatted: formattedValue,
            colDef: this.params.colDef,
            column: this.params.column,
            setTooltip: (value2, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.shouldDisplayTooltip = shouldDisplayTooltip;
                this.tooltipFeature?.setTooltipAndRefresh(value2);
            }
        });
    }
    getFormattedValue(column, value) {
        return this.beans.valueSvc.formatValue(column, null, value, this.valueFormatter, false);
    }
    renderCell() {
        const compDetails = (0, $437b23f6a393c3bf$export$1f172e021e4d8401)(this.beans.userCompFactory, this.params, this.cellRendererParams);
        const cellRendererPromise = compDetails?.newAgStackInstance();
        if (cellRendererPromise == null) {
            this.renderCellWithoutCellRenderer();
            return;
        }
        cellRendererPromise.then((component)=>{
            if (component) {
                this.cellRendererComponent = component;
                this.eCheckbox.setLabel(component.getGui());
                this.destroyCellRendererComponent = ()=>this.destroyBean(component);
            }
        });
    }
    renderCellWithoutCellRenderer() {
        const { valueFormatted: valueFormatted, value: value } = this.cellRendererParams;
        let valueToRender = (valueFormatted == null ? value : valueFormatted) ?? this.translate("blanks");
        if (typeof valueToRender !== "string") {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(208);
            valueToRender = "";
        }
        this.eCheckbox.setLabel(valueToRender);
        this.setupFixedAriaLabels(valueToRender);
    }
    getComponentHolder() {
        return this.params.column.getColDef();
    }
};
// packages/ag-grid-enterprise/src/setFilter/localeText.ts
var $5b7ccabde48fae90$var$DEFAULT_LOCALE_TEXT = {
    loadingOoo: "Loading...",
    blanks: "(Blanks)",
    searchOoo: "Search...",
    selectAll: "(Select All)",
    selectAllSearchResults: "(Select All Search Results)",
    addCurrentSelectionToFilter: "Add current selection to filter",
    noMatches: "No matches.",
    ariaSearchFilterValues: "Search filter values",
    ariaFilterList: "Filter List",
    filterSummaryListInactive: "is (All)",
    filterSummaryListSeparator: ", ",
    filterSummaryListShort: (variableValues)=>`is (${variableValues[0]})`,
    filterSummaryListLong: (variableValues)=>`is (${variableValues[0]}) and ${variableValues[1]} more`
};
// packages/ag-grid-enterprise/src/setFilter/setFilterUtils.ts
function $5b7ccabde48fae90$var$processDataPath(dataPath, treeData, groupAllowUnbalanced) {
    let processedDataPath = dataPath;
    if (!processedDataPath) return null;
    processedDataPath = processedDataPath.map((treeKey)=>(0, $437b23f6a393c3bf$export$2a74c29220d5c88e)((0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(treeKey)));
    if (!treeData && groupAllowUnbalanced && processedDataPath.some((treeKey)=>treeKey == null)) {
        if ((0, $437b23f6a393c3bf$export$236389741107357f)(processedDataPath) == null) return null;
        return processedDataPath.filter((treeKey)=>treeKey != null);
    }
    return processedDataPath;
}
function $5b7ccabde48fae90$var$translateForSetFilter(bean, key, variableValues) {
    return (0, $437b23f6a393c3bf$export$4ad3db330991f17d)(bean, $5b7ccabde48fae90$var$DEFAULT_LOCALE_TEXT, key, variableValues);
}
function $5b7ccabde48fae90$var$applyExcelModeOptions(params) {
    if (params.excelMode === "windows") {
        if (!params.buttons) params.buttons = [
            "apply",
            "cancel"
        ];
        if (params.closeOnApply == null) params.closeOnApply = true;
    } else if (params.excelMode === "mac") {
        if (!params.buttons) params.buttons = [
            "reset"
        ];
        if (params.applyMiniFilterWhileTyping == null) params.applyMiniFilterWhileTyping = true;
        if (params.debounceMs == null) params.debounceMs = 500;
    }
    if (params.excelMode && params.defaultToNothingSelected) {
        params.defaultToNothingSelected = false;
        (0, $437b23f6a393c3bf$export$545083624300f13d)(207);
    }
}
function $5b7ccabde48fae90$var$createTreeDataOrGroupingComparator() {
    return ([_aKey, aValue], [_bKey, bValue])=>{
        if (aValue == null) return bValue == null ? 0 : -1;
        else if (bValue == null) return 1;
        for(let i = 0; i < aValue.length; i++){
            if (i >= bValue.length) return 1;
            const diff = (0, $437b23f6a393c3bf$export$b0cca9f3c87c8df8)(aValue[i], bValue[i]);
            if (diff !== 0) return diff;
        }
        return 0;
    };
}
var $5b7ccabde48fae90$var$TreeSetDisplayValueModel = class {
    constructor(formatter, treeListPathGetter, treeListFormatter, treeDataOrGrouping){
        this.formatter = formatter;
        this.treeListPathGetter = treeListPathGetter;
        this.treeListFormatter = treeListFormatter;
        this.treeDataOrGrouping = treeDataOrGrouping;
        /** all displayed items in a tree structure */ this.allDisplayedItemsTree = /* @__PURE__ */ new Map();
        /** all displayed items flattened and filtered */ this.activeDisplayedItemsFlat = [];
        this.selectAllItem = {
            depth: 0,
            filterPasses: true,
            available: true,
            treeKey: $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL,
            children: this.allDisplayedItemsTree,
            expanded: true,
            key: $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL,
            parentTreeKeys: []
        };
        this.addSelectionToFilterItem = {
            depth: 0,
            filterPasses: true,
            available: true,
            treeKey: $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER,
            expanded: true,
            key: $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER,
            parentTreeKeys: []
        };
    }
    updateParams(treeListPathGetter, treeListFormatter) {
        this.treeListPathGetter = treeListPathGetter;
        this.treeListFormatter = treeListFormatter;
    }
    updateDisplayedValuesToAllAvailable(getValue, allKeys, availableKeys, source) {
        if (source === "reload") this.generateItemTree(getValue, allKeys, availableKeys);
        else if (source === "otherFilter") {
            this.updateAvailable(availableKeys);
            this.updateExpandAll();
        } else if (source === "miniFilter") {
            this.resetFilter();
            this.updateExpandAll();
        }
        this.flattenItems();
    }
    updateDisplayedValuesToMatchMiniFilter(getValue, allKeys, availableKeys, matchesFilter, nullMatchesFilter, source) {
        if (source === "reload") this.generateItemTree(getValue, allKeys, availableKeys);
        else if (source === "otherFilter") this.updateAvailable(availableKeys);
        this.updateFilter(matchesFilter, nullMatchesFilter);
        this.updateExpandAll();
        this.flattenItems();
    }
    generateItemTree(getValue, allKeys, availableKeys) {
        const allDisplayedItemsTree = /* @__PURE__ */ new Map();
        this.allDisplayedItemsTree = allDisplayedItemsTree;
        let groupsExist = false;
        const treeListPathGetter = this.getTreeListPathGetter(getValue, availableKeys);
        for (const key of allKeys){
            const value = getValue(key);
            const dataPath = treeListPathGetter(value) ?? [
                null
            ];
            const dataPathLength = dataPath.length;
            if (dataPathLength > 1) groupsExist = true;
            const available = availableKeys.has(key);
            let children = allDisplayedItemsTree;
            let item;
            let parentTreeKeys = [];
            for(let depth = 0; depth < dataPathLength; depth++){
                const treeKey = dataPath[depth];
                if (!children) {
                    children = /* @__PURE__ */ new Map();
                    item.children = children;
                }
                const treeKeyUpper = treeKey?.toUpperCase() ?? null;
                item = children.get(treeKeyUpper);
                if (!item) {
                    item = {
                        treeKey: treeKey,
                        depth: depth,
                        filterPasses: true,
                        expanded: false,
                        available: available,
                        parentTreeKeys: parentTreeKeys
                    };
                    if (depth === dataPath.length - 1) item.key = key;
                    children.set(treeKeyUpper, item);
                }
                children = item.children;
                parentTreeKeys = [
                    ...parentTreeKeys,
                    treeKey
                ];
            }
        }
        this.groupsExist = groupsExist;
        this.updateAvailable(availableKeys);
        this.selectAllItem.children = allDisplayedItemsTree;
        this.selectAllItem.expanded = false;
    }
    getTreeListPathGetter(getValue, availableKeys) {
        if (this.treeListPathGetter) return this.treeListPathGetter;
        if (this.treeDataOrGrouping) return (value)=>value;
        let isDate = false;
        for (const availableKey of availableKeys){
            const value = getValue(availableKey);
            if (value instanceof Date) {
                isDate = true;
                break;
            } else if (value != null) break;
        }
        if (isDate) return (value)=>(0, $437b23f6a393c3bf$export$bb4eb333cc2b3e25)(value, false);
        (0, $437b23f6a393c3bf$export$545083624300f13d)(211);
        return (value)=>[
                String(value)
            ];
    }
    flattenItems() {
        this.activeDisplayedItemsFlat = [];
        const recursivelyFlattenDisplayedItems = (items)=>{
            for (const item of items.values()){
                if (!item.filterPasses || !item.available) continue;
                this.activeDisplayedItemsFlat.push(item);
                if (item.children && item.expanded) recursivelyFlattenDisplayedItems(item.children);
            }
        };
        recursivelyFlattenDisplayedItems(this.allDisplayedItemsTree);
    }
    resetFilter() {
        const recursiveFilterReset = (item)=>{
            const children = item.children;
            if (children) for (const child of children.values())recursiveFilterReset(child);
            item.filterPasses = true;
        };
        for (const item of this.allDisplayedItemsTree.values())recursiveFilterReset(item);
    }
    updateFilter(matchesFilter, nullMatchesFilter) {
        const passesFilter = (item)=>{
            if (!item.available) return false;
            if (item.treeKey == null) return nullMatchesFilter;
            return matchesFilter(this.formatter(this.treeListFormatter ? this.treeListFormatter(item.treeKey, item.depth, item.parentTreeKeys) : item.treeKey));
        };
        for (const item of this.allDisplayedItemsTree.values())this.recursiveItemCheck(item, false, passesFilter, "filterPasses");
    }
    getDisplayedValueCount() {
        return this.activeDisplayedItemsFlat.length;
    }
    getDisplayedItem(index) {
        return this.activeDisplayedItemsFlat[index];
    }
    getSelectAllItem() {
        return this.selectAllItem;
    }
    getAddSelectionToFilterItem() {
        return this.addSelectionToFilterItem;
    }
    getDisplayedKeys() {
        const displayedKeys = [];
        this.forEachDisplayedKey((key)=>displayedKeys.push(key));
        return displayedKeys;
    }
    forEachDisplayedKey(func) {
        const recursiveForEachItem = (item, topParentExpanded)=>{
            const children = item.children;
            if (children) {
                if (!item.expanded || !topParentExpanded) {
                    for (const child of children.values())if (child.filterPasses) recursiveForEachItem(child, false);
                }
            } else func(item.key);
        };
        for (const item of this.activeDisplayedItemsFlat)recursiveForEachItem(item, true);
    }
    someDisplayedKey(func) {
        const recursiveSomeItem = (item, topParentExpanded)=>{
            const children = item.children;
            if (children) {
                if (!item.expanded || !topParentExpanded) {
                    for (const child of children.values()){
                        if (child.filterPasses && recursiveSomeItem(child, false)) return true;
                    }
                    return false;
                }
            } else return func(item.key);
            return false;
        };
        return this.activeDisplayedItemsFlat.some((item)=>recursiveSomeItem(item, true));
    }
    hasGroups() {
        return this.groupsExist;
    }
    refresh() {
        this.updateExpandAll();
        this.flattenItems();
    }
    updateExpandAll() {
        const recursiveExpansionCheck = (items, someTrue, someFalse)=>{
            for (const item2 of items.values()){
                if (!item2.filterPasses || !item2.available || !item2.children) continue;
                someTrue = someTrue || !!item2.expanded;
                someFalse = someFalse || !item2.expanded;
                if (someTrue && someFalse) return void 0;
                const childExpanded = recursiveExpansionCheck(item2.children, someTrue, someFalse);
                if (childExpanded === void 0) return void 0;
                else if (childExpanded) someTrue = true;
                else someFalse = true;
            }
            return someTrue && someFalse ? void 0 : someTrue;
        };
        const item = this.getSelectAllItem();
        item.expanded = recursiveExpansionCheck(item.children, false, false);
    }
    recursiveItemCheck(item, parentPasses, checkFunction, itemProp) {
        let atLeastOneChildPassed = false;
        const children = item.children;
        if (children) for (const child of children.values()){
            const childPasses = this.recursiveItemCheck(child, parentPasses || checkFunction(item), checkFunction, itemProp);
            atLeastOneChildPassed = atLeastOneChildPassed || childPasses;
        }
        const itemPasses = parentPasses || atLeastOneChildPassed || checkFunction(item);
        item[itemProp] = itemPasses;
        return itemPasses;
    }
    updateAvailable(availableKeys) {
        const isAvailable = (item)=>availableKeys.has(item.key);
        for (const item of this.allDisplayedItemsTree.values())this.recursiveItemCheck(item, false, isAvailable, "available");
    }
};
// packages/ag-grid-enterprise/src/setFilter/setFilter.ts
var $5b7ccabde48fae90$var$SetFilter = class extends (0, $437b23f6a393c3bf$export$a927a1327c2cc7f0) {
    constructor(){
        super("setFilter", "set-filter");
        this.filterType = "set";
        this.eMiniFilter = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eFilterLoading = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eFilterLoadingIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eSetFilterList = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eFilterNoMatches = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.hardRefreshVirtualList = false;
        this.miniFilterText = null;
        /** When true, in excelMode = 'windows', it adds previously selected filter items to newly checked filter selection */ this.addCurrentSelectionToFilter = false;
        /** Keys that have been selected for this filter. */ this.selectedKeys = /* @__PURE__ */ new Set();
    }
    setParams(params) {
        super.setParams(params);
        const handler = this.updateHandler(params.getHandler());
        const { column: column, textFormatter: textFormatter, treeList: treeList, treeListPathGetter: treeListPathGetter, treeListFormatter: treeListFormatter } = params;
        this.formatter = textFormatter ?? ((value)=>value ?? null);
        this.displayValueModel = treeList ? new $5b7ccabde48fae90$var$TreeSetDisplayValueModel(this.formatter, treeListPathGetter, treeListFormatter, handler.isTreeDataOrGrouping()) : new $5b7ccabde48fae90$var$FlatSetDisplayValueModel(this.beans.valueSvc, ()=>this.handler.valueFormatter, this.formatter, column);
        handler.valueModel.allKeys.then((values)=>{
            if (!this.isAlive()) return;
            this.updateDisplayedValues("reload", values ?? []);
            this.resetSelectionState(values ?? []);
        });
        if (handler.valueModel.isLoading()) this.setIsLoading(true);
        this.initialiseFilterBodyUi();
    }
    refresh(legacyNewParams) {
        if (this.params.treeList !== legacyNewParams.treeList) return false;
        this.updateHandler(legacyNewParams.getHandler());
        return super.refresh(legacyNewParams);
    }
    updateParams(newParams, oldParams) {
        super.updateParams(newParams, oldParams);
        this.updateMiniFilter();
        if (newParams.suppressSelectAll !== oldParams.suppressSelectAll) this.createVirtualListModel(newParams);
        const { textFormatter: textFormatter, treeListPathGetter: treeListPathGetter, treeListFormatter: treeListFormatter } = newParams;
        this.formatter = textFormatter ?? ((value)=>value ?? null);
        if (this.displayValueModel instanceof $5b7ccabde48fae90$var$TreeSetDisplayValueModel) this.displayValueModel.updateParams(treeListPathGetter, treeListFormatter);
        this.handler.refreshFilterValues(true);
    }
    updateHandler(handler) {
        const oldHandler = this.handler;
        if (oldHandler !== handler) {
            for (const func of this.handlerDestroyFuncs ?? [])func();
            this.handlerDestroyFuncs = [
                ...this.addManagedListeners(handler, {
                    anyFilterChanged: (event)=>{
                        handler.valueModel.allKeys.then((values)=>{
                            if (this.isAlive()) {
                                this.updateDisplayedValues("otherFilter", values ?? []);
                                if (event.updated) {
                                    this.checkAndRefreshVirtualList();
                                    this.showOrHideResults();
                                }
                            }
                        });
                    },
                    dataChanged: ({ hardRefresh: hardRefresh })=>{
                        handler.valueModel.allKeys.then((values)=>{
                            if (this.isAlive()) {
                                this.updateDisplayedValues("reload", values ?? []);
                                this.setSelectedModel(this.state.model?.values ?? null);
                                if (hardRefresh) this.hardRefreshVirtualList = true;
                                this.checkAndRefreshVirtualList();
                            }
                        });
                    }
                }),
                ...this.addManagedListeners(handler.valueModel, {
                    loadingStart: ()=>this.setIsLoading(true),
                    loadingEnd: ()=>this.setIsLoading(false)
                })
            ];
            this.handler = handler;
        }
        return handler;
    }
    // unlike the simple filters, nothing in the set filter UI shows/hides.
    // maybe this method belongs in abstractSimpleFilter???
    updateUiVisibility() {}
    createBodyTemplate() {
        return {
            tag: "div",
            cls: "ag-set-filter",
            children: [
                {
                    tag: "div",
                    ref: "eFilterLoading",
                    cls: "ag-filter-loading ag-loading ag-hidden",
                    children: [
                        {
                            tag: "span",
                            ref: "eFilterLoadingIcon",
                            cls: "ag-loading-icon"
                        },
                        {
                            tag: "span",
                            cls: "ag-loading-text",
                            children: $5b7ccabde48fae90$var$translateForSetFilter(this, "loadingOoo")
                        }
                    ]
                },
                {
                    tag: "ag-input-text-field",
                    ref: "eMiniFilter",
                    cls: "ag-mini-filter"
                },
                {
                    tag: "div",
                    ref: "eFilterNoMatches",
                    cls: "ag-filter-no-matches ag-hidden",
                    children: $5b7ccabde48fae90$var$translateForSetFilter(this, "noMatches")
                },
                {
                    tag: "div",
                    ref: "eSetFilterList",
                    cls: "ag-set-filter-list",
                    role: "presentation"
                }
            ]
        };
    }
    getAgComponents() {
        return [
            (0, $437b23f6a393c3bf$export$31e2985be4ee06ab)
        ];
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        if (e.defaultPrevented) return;
        const getComponentForKeyEvent = ()=>{
            if (!this.eSetFilterList.contains((0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans))) return;
            const currentItem = this.virtualList.getLastFocusedRow();
            if (currentItem == null) return;
            const component = this.virtualList.getComponentAt(currentItem);
            if (component == null) return;
            e.preventDefault();
            const { readOnly: readOnly } = this.params;
            if (readOnly) return;
            return component;
        };
        switch(e.key){
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE:
                getComponentForKeyEvent()?.toggleSelected();
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER:
                this.handleKeyEnter(e);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT:
                getComponentForKeyEvent()?.setExpanded(false);
                break;
            case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT:
                getComponentForKeyEvent()?.setExpanded(true);
                break;
        }
    }
    handleKeyEnter(e) {
        e.preventDefault();
        const { excelMode: excelMode, readOnly: readOnly } = this.params;
        if (!excelMode || !!readOnly) return;
        this.params.onAction("apply", void 0, e);
        if (this.params.excelMode === "mac") this.eMiniFilter.getInputElement().select();
    }
    setModelAndRefresh(values) {
        return this.setSelectedModel(values).then(()=>{
            if (this.isAlive()) this.checkAndRefreshVirtualList();
        });
    }
    setModelIntoUi(model) {
        this.setMiniFilter(this.params.state.state?.miniFilterValue ?? null, true);
        const values = model == null ? null : model.values;
        return this.setModelAndRefresh(values);
    }
    getModelFromUi() {
        const values = this.getSelectedModel();
        if (!values) return null;
        return {
            values: values,
            filterType: this.filterType
        };
    }
    areNonNullModelsEqual(a, b) {
        return (0, $437b23f6a393c3bf$export$893967cdb9833fdd)(a.values, b.values);
    }
    setIsLoading(isLoading) {
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eFilterLoading, isLoading);
        if (!isLoading) this.hardRefreshVirtualList = true;
    }
    initialiseFilterBodyUi() {
        this.initVirtualList();
        this.initMiniFilter();
        this.initLoading();
    }
    initLoading() {
        const loadingIcon = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("setFilterLoading", this.beans, this.params.column);
        if (loadingIcon) this.eFilterLoadingIcon.appendChild(loadingIcon);
    }
    initVirtualList() {
        const filterListName = $5b7ccabde48fae90$var$translateForSetFilter(this, "ariaFilterList");
        const isTree = !!this.params.treeList;
        const virtualList = this.virtualList = this.createBean(new $5b7ccabde48fae90$var$VirtualList({
            cssIdentifier: "filter",
            ariaRole: isTree ? "tree" : "listbox",
            listName: filterListName
        }));
        const eSetFilterList = this.eSetFilterList;
        if (isTree) eSetFilterList.classList.add("ag-set-filter-tree-list");
        eSetFilterList.appendChild(virtualList.getGui());
        const { cellHeight: cellHeight } = this.params;
        if (cellHeight != null) virtualList.setRowHeight(cellHeight);
        const componentCreator = (item, listItemElement)=>this.createSetListItem(item, isTree, listItemElement);
        virtualList.setComponentCreator(componentCreator);
        const componentUpdater = (item, component)=>this.updateSetListItem(item, component);
        virtualList.setComponentUpdater(componentUpdater);
        this.createVirtualListModel(this.params);
    }
    createVirtualListModel(params) {
        let model;
        if (params.suppressSelectAll) model = new $5b7ccabde48fae90$var$ModelWrapper(this.displayValueModel);
        else model = new $5b7ccabde48fae90$var$ModelWrapperWithSelectAll(this.displayValueModel, this.showAddCurrentSelectionToFilter.bind(this));
        if (params.treeList) model = new $5b7ccabde48fae90$var$TreeModelWrapper(model);
        this.virtualList.setModel(model);
    }
    getSelectAllLabel() {
        const key = this.miniFilterText == null || !this.params.excelMode ? "selectAll" : "selectAllSearchResults";
        return $5b7ccabde48fae90$var$translateForSetFilter(this, key);
    }
    getAddSelectionToFilterLabel() {
        return $5b7ccabde48fae90$var$translateForSetFilter(this, "addCurrentSelectionToFilter");
    }
    createSetListItem(item, isTree, focusWrapper) {
        const groupsExist = this.displayValueModel.hasGroups();
        const { isSelected: isSelected, isExpanded: isExpanded } = this.isSelectedExpanded(item);
        const { value: value, depth: depth, isGroup: isGroup, hasIndeterminateExpandState: hasIndeterminateExpandState, selectedListener: selectedListener, expandedListener: expandedListener } = this.newSetListItemAttributes(item);
        const itemParams = {
            focusWrapper: focusWrapper,
            value: value,
            params: this.params,
            translate: (translateKey)=>$5b7ccabde48fae90$var$translateForSetFilter(this, translateKey),
            valueFormatter: this.handler.valueFormatter,
            item: item,
            isSelected: isSelected,
            isTree: isTree,
            depth: depth,
            groupsExist: groupsExist,
            isGroup: isGroup,
            isExpanded: isExpanded,
            hasIndeterminateExpandState: hasIndeterminateExpandState
        };
        const listItem = this.createBean(new $5b7ccabde48fae90$var$SetFilterListItem(itemParams));
        listItem.addEventListener("selectionChanged", selectedListener);
        if (expandedListener) listItem.addEventListener("expandedChanged", expandedListener);
        return listItem;
    }
    newSetTreeItemAttributes(item) {
        const groupsExist = this.displayValueModel.hasGroups();
        if (item.key === $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL) return {
            value: ()=>this.getSelectAllLabel(),
            isGroup: groupsExist,
            depth: item.depth,
            hasIndeterminateExpandState: true,
            selectedListener: (e)=>this.onSelectAll(e.isSelected),
            expandedListener: (e)=>this.onExpandAll(e.item, e.isExpanded)
        };
        if (item.key === $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER) return {
            value: ()=>this.getAddSelectionToFilterLabel(),
            depth: item.depth,
            isGroup: false,
            hasIndeterminateExpandState: false,
            selectedListener: (e)=>{
                this.addCurrentSelectionToFilter = e.isSelected;
                this.refreshAfterSelection();
            }
        };
        if (item.children) return {
            value: this.params.treeListFormatter?.(item.treeKey, item.depth, item.parentTreeKeys) ?? item.treeKey,
            depth: item.depth,
            isGroup: true,
            selectedListener: (e)=>this.onGroupItemSelected(e.item, e.isSelected),
            expandedListener: (e)=>this.onExpandedChanged(e.item, e.isExpanded)
        };
        return {
            value: this.params.treeListFormatter?.(item.treeKey, item.depth, item.parentTreeKeys) ?? item.treeKey,
            depth: item.depth,
            selectedListener: (e)=>this.onItemSelected(e.item.key, e.isSelected)
        };
    }
    newSetListItemAttributes(item) {
        if (this.isSetFilterModelTreeItem(item)) return this.newSetTreeItemAttributes(item);
        if (item === $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL) return {
            value: ()=>this.getSelectAllLabel(),
            selectedListener: (e)=>this.onSelectAll(e.isSelected)
        };
        if (item === $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER) return {
            value: ()=>this.getAddSelectionToFilterLabel(),
            selectedListener: (e)=>{
                this.addCurrentSelectionToFilter = e.isSelected;
                this.refreshAfterSelection();
            }
        };
        return {
            value: this.handler.valueModel.allValues.get(item) ?? null,
            selectedListener: (e)=>this.onItemSelected(e.item, e.isSelected)
        };
    }
    updateSetListItem(item, component) {
        const { isSelected: isSelected, isExpanded: isExpanded } = this.isSelectedExpanded(item);
        component.refresh(item, isSelected, isExpanded);
    }
    isSelectedExpanded(item) {
        let isSelected;
        let isExpanded;
        if (this.isSetFilterModelTreeItem(item)) {
            isExpanded = item.expanded;
            if (item.key === $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL) isSelected = this.isSelectAllSelected();
            else if (item.key === $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER) isSelected = this.isAddCurrentSelectionToFilterChecked();
            else if (item.children) isSelected = this.areAllChildrenSelected(item);
            else isSelected = this.selectedKeys.has(item.key);
        } else if (item === $5b7ccabde48fae90$var$SET_FILTER_SELECT_ALL) isSelected = this.isSelectAllSelected();
        else if (item === $5b7ccabde48fae90$var$SET_FILTER_ADD_SELECTION_TO_FILTER) isSelected = this.isAddCurrentSelectionToFilterChecked();
        else isSelected = this.selectedKeys.has(item);
        return {
            isSelected: isSelected,
            isExpanded: isExpanded
        };
    }
    isSetFilterModelTreeItem(item) {
        return item?.treeKey !== void 0;
    }
    initMiniFilter() {
        const { eMiniFilter: eMiniFilter } = this;
        this.updateMiniFilter();
        eMiniFilter.onValueChange(()=>this.onMiniFilterInput());
        eMiniFilter.setInputAriaLabel($5b7ccabde48fae90$var$translateForSetFilter(this, "ariaSearchFilterValues"));
        this.addManagedElementListeners(eMiniFilter.getInputElement(), {
            keydown: (e)=>this.onMiniFilterKeyDown(e)
        });
    }
    updateMiniFilter() {
        const { eMiniFilter: eMiniFilter, miniFilterText: miniFilterText, params: params } = this;
        eMiniFilter.setDisplayed(!params.suppressMiniFilter);
        eMiniFilter.setValue(miniFilterText);
    }
    // we need to have the GUI attached before we can draw the virtual rows, as the
    // virtual row logic needs info about the GUI state
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.resetExpansion();
        this.refreshVirtualList();
        const { eMiniFilter: eMiniFilter } = this;
        eMiniFilter.setInputPlaceholder($5b7ccabde48fae90$var$translateForSetFilter(this, "searchOoo"));
        if (!params?.suppressFocus) {
            if (eMiniFilter.isDisplayed()) eMiniFilter.getFocusableElement().focus();
            else this.virtualList.awaitStable(()=>this.virtualList.focusRow(0));
        }
    }
    afterGuiDetached() {
        super.afterGuiDetached();
        const { column: column, excelMode: excelMode, model: model, onStateChange: onStateChange } = this.params;
        if (this.beans.colFilter?.shouldKeepStateOnDetach(column)) return;
        if (excelMode) this.resetMiniFilter();
        if (excelMode || model !== this.state.model) {
            onStateChange({
                model: model,
                state: this.getState()
            });
            this.showOrHideResults();
        }
    }
    canApply(model) {
        return this.params.excelMode ? model == null || model.values.length > 0 : true;
    }
    /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */ onNewRowsLoaded() {}
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ setFilterValues(values) {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(283);
        this.handler.setFilterValues(values);
    }
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ resetFilterValues() {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(283);
        this.handler.resetFilterValues();
    }
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ refreshFilterValues() {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(283);
        this.doRefreshFilterValues();
    }
    doRefreshFilterValues() {
        this.handler.refreshFilterValues();
    }
    /**
   * @deprecated v34 Internal method - should only be called by the grid.
   */ onAnyFilterChanged() {}
    onMiniFilterInput(silent) {
        if (!this.doSetMiniFilter(this.eMiniFilter.getValue())) return;
        if (silent) {
            this.showOrHideResults();
            return;
        }
        const { applyMiniFilterWhileTyping: applyMiniFilterWhileTyping, readOnly: readOnly, excelMode: excelMode } = this.params;
        const updateSelections = !readOnly && (applyMiniFilterWhileTyping || !!excelMode);
        const apply = applyMiniFilterWhileTyping && !readOnly ? "debounce" : void 0;
        this.updateUiAfterMiniFilterChange(updateSelections, apply);
    }
    updateUiAfterMiniFilterChange(updateSelections, apply) {
        if (updateSelections) {
            const { excelMode: excelMode, readOnly: readOnly, model: model } = this.params;
            if (excelMode && !readOnly && this.miniFilterText == null) this.setModelAndRefresh(model?.values ?? null);
            else this.selectAllMatchingMiniFilter(true);
        }
        this.checkAndRefreshVirtualList();
        this.onUiChanged(updateSelections ? apply : "prevent");
        this.showOrHideResults();
    }
    showOrHideResults() {
        const hideResults = this.miniFilterText != null && this.displayValueModel.getDisplayedValueCount() < 1;
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eFilterNoMatches, hideResults);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eSetFilterList, !hideResults);
    }
    resetMiniFilter() {
        this.eMiniFilter.setValue(null, true);
        this.doSetMiniFilter(null);
    }
    onMiniFilterKeyDown(e) {
        const { excelMode: excelMode, readOnly: readOnly } = this.params;
        if (e.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER && !excelMode && !readOnly) this.updateUiAfterMiniFilterChange(true, "immediately");
    }
    focusRowIfAlive(rowIndex) {
        if (rowIndex == null) return Promise.resolve();
        return new Promise((res)=>{
            window.setTimeout(()=>{
                if (this.isAlive()) this.virtualList.focusRow(rowIndex);
                res();
            }, 0);
        });
    }
    onSelectAll(isSelected) {
        if (isSelected) this.selectAllMatchingMiniFilter();
        else this.deselectAllMatchingMiniFilter();
        this.refreshAfterSelection();
    }
    onGroupItemSelected(item, isSelected) {
        const recursiveGroupSelection = (i)=>{
            if (!i.filterPasses) return;
            const children = i.children;
            if (children) for (const childItem of children.values())recursiveGroupSelection(childItem);
            else this.setKeySelected(i.key, isSelected);
        };
        recursiveGroupSelection(item);
        this.refreshAfterSelection();
    }
    onItemSelected(key, isSelected) {
        this.setKeySelected(key, isSelected);
        this.refreshAfterSelection();
    }
    onExpandAll(item, isExpanded) {
        const recursiveExpansion = (i)=>{
            if (i.filterPasses && i.available && i.children) {
                for (const childItem of i.children.values())recursiveExpansion(childItem);
                i.expanded = isExpanded;
            }
        };
        recursiveExpansion(item);
        this.refreshAfterExpansion();
    }
    onExpandedChanged(item, isExpanded) {
        item.expanded = isExpanded;
        this.refreshAfterExpansion();
    }
    refreshAfterExpansion() {
        const focusedRow = this.virtualList.getLastFocusedRow();
        this.updateDisplayedValues("expansion");
        this.checkAndRefreshVirtualList();
        this.focusRowIfAlive(focusedRow);
    }
    refreshAfterSelection() {
        const focusedRow = this.virtualList.getLastFocusedRow();
        this.checkAndRefreshVirtualList();
        this.onUiChanged();
        this.focusRowIfAlive(focusedRow);
    }
    setMiniFilter(newMiniFilter, silent) {
        this.eMiniFilter.setValue(newMiniFilter, silent);
        this.onMiniFilterInput(silent);
    }
    /** Sets mini filter value. Returns true if it changed from last value, otherwise false. */ doSetMiniFilter(value) {
        value = (0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(value);
        if (this.miniFilterText === value) return false;
        if (value === null) this.addCurrentSelectionToFilter = false;
        this.miniFilterText = value;
        this.updateDisplayedValues("miniFilter");
        return true;
    }
    getMiniFilter() {
        return this.miniFilterText;
    }
    getUiChangeEventParams() {
        return {
            miniFilterValue: this.miniFilterText
        };
    }
    getState() {
        const miniFilterValue = this.miniFilterText;
        return miniFilterValue ? {
            miniFilterValue: miniFilterValue
        } : void 0;
    }
    checkAndRefreshVirtualList() {
        this.virtualList.refresh(!this.hardRefreshVirtualList);
        if (this.hardRefreshVirtualList) this.hardRefreshVirtualList = false;
    }
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ getFilterKeys() {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(283);
        return this.handler.getFilterKeys();
    }
    /**
   * @deprecated v34 Use the same method on the filter handler (`api.getColumnFilterHandler()`) instead.
   */ getFilterValues() {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(283);
        return this.handler.getFilterValues();
    }
    refreshVirtualList() {
        if (this.params.refreshValuesOnOpen) this.doRefreshFilterValues();
        else this.checkAndRefreshVirtualList();
    }
    isSelectAllSelected() {
        if (!this.params.defaultToNothingSelected) {
            if (this.hasSelections() && this.isNothingVisibleSelected()) return false;
            if (this.isEverythingVisibleSelected()) return true;
        } else {
            if (this.hasSelections() && this.isEverythingVisibleSelected()) return true;
            if (this.isNothingVisibleSelected()) return false;
        }
        return void 0;
    }
    areAllChildrenSelected(item) {
        const recursiveChildSelectionCheck = (i)=>{
            if (i.children) {
                let someTrue = false;
                let someFalse = false;
                for (const child of i.children.values()){
                    if (!child.filterPasses || !child.available) continue;
                    const childSelected = recursiveChildSelectionCheck(child);
                    if (childSelected === void 0) return void 0;
                    if (childSelected) someTrue = true;
                    else someFalse = true;
                    if (someTrue && someFalse) return void 0;
                }
                return someTrue;
            } else return this.selectedKeys.has(i.key);
        };
        if (!this.params.defaultToNothingSelected) return recursiveChildSelectionCheck(item);
        else return this.hasSelections() && recursiveChildSelectionCheck(item);
    }
    resetExpansion() {
        if (!this.params.treeList) return;
        const selectAllItem = this.displayValueModel.getSelectAllItem();
        if (this.isSetFilterModelTreeItem(selectAllItem)) {
            const recursiveCollapse = (i)=>{
                const children = i.children;
                if (children) {
                    for (const childItem of children.values())recursiveCollapse(childItem);
                    i.expanded = false;
                }
            };
            recursiveCollapse(selectAllItem);
            this.updateDisplayedValues("expansion");
        }
    }
    getModelAsString(model) {
        return this.handler.getModelAsString(model);
    }
    getPositionableElement() {
        return this.eSetFilterList;
    }
    updateDisplayedValues(source, allKeys) {
        if (source === "expansion") {
            this.displayValueModel.refresh();
            return;
        }
        const handler = this.handler;
        const valueModel = handler.valueModel;
        if (this.miniFilterText == null) {
            this.displayValueModel.updateDisplayedValuesToAllAvailable((key)=>valueModel.allValues.get(key) ?? null, allKeys, valueModel.availableKeys, source);
            return;
        }
        const formattedFilterText = handler.caseFormat(this.formatter(this.miniFilterText) || "");
        const matchesFilter = (valueToCheck)=>valueToCheck != null && handler.caseFormat(valueToCheck).includes(formattedFilterText);
        const nullMatchesFilter = !!this.params.excelMode && matchesFilter($5b7ccabde48fae90$var$translateForSetFilter(this, "blanks"));
        this.displayValueModel.updateDisplayedValuesToMatchMiniFilter((key)=>valueModel.allValues.get(key) ?? null, allKeys, valueModel.availableKeys, matchesFilter, nullMatchesFilter, source);
    }
    hasSelections() {
        return this.params.defaultToNothingSelected ? this.selectedKeys.size > 0 : this.handler.valueModel.allValues.size !== this.selectedKeys.size;
    }
    isInWindowsExcelMode() {
        return this.params.excelMode === "windows";
    }
    isAddCurrentSelectionToFilterChecked() {
        return this.isInWindowsExcelMode() && this.addCurrentSelectionToFilter;
    }
    showAddCurrentSelectionToFilter() {
        return this.isInWindowsExcelMode() && (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(this.miniFilterText) && this.miniFilterText.length > 0;
    }
    selectAllMatchingMiniFilter(clearExistingSelection = false) {
        if (this.miniFilterText == null) this.selectedKeys = new Set(this.handler.valueModel.allValues.keys());
        else {
            if (clearExistingSelection) this.selectedKeys.clear();
            this.displayValueModel.forEachDisplayedKey((key)=>this.selectedKeys.add(key));
        }
    }
    deselectAllMatchingMiniFilter() {
        if (this.miniFilterText == null) this.selectedKeys.clear();
        else this.displayValueModel.forEachDisplayedKey((key)=>this.selectedKeys.delete(key));
    }
    setKeySelected(key, selected) {
        if (selected) this.selectedKeys.add(key);
        else {
            if (this.params.excelMode && this.isEverythingVisibleSelected()) this.resetSelectionState(this.displayValueModel.getDisplayedKeys());
            this.selectedKeys.delete(key);
        }
    }
    isEverythingVisibleSelected() {
        return !this.displayValueModel.someDisplayedKey((it)=>!this.selectedKeys.has(it));
    }
    isNothingVisibleSelected() {
        return !this.displayValueModel.someDisplayedKey((it)=>this.selectedKeys.has(it));
    }
    getSelectedModel() {
        if (!this.hasSelections()) return null;
        const filteringKeys = this.isAddCurrentSelectionToFilterChecked() ? this.params.model?.values : void 0;
        if (filteringKeys?.length) {
            if (this.selectedKeys) {
                const modelKeys = /* @__PURE__ */ new Set([
                    ...filteringKeys,
                    ...this.selectedKeys
                ]);
                return Array.from(modelKeys);
            }
            return Array.from(filteringKeys);
        }
        return Array.from(this.selectedKeys);
    }
    setSelectedModel(model) {
        const handler = this.handler;
        const valueModel = handler.valueModel;
        return valueModel.allKeys.then((keys)=>{
            if (model == null) this.resetSelectionState(keys ?? []);
            else {
                this.selectedKeys.clear();
                const existingFormattedKeys = /* @__PURE__ */ new Map();
                valueModel.allValues.forEach((_value, key)=>{
                    existingFormattedKeys.set(handler.caseFormat(key), key);
                });
                model.forEach((unformattedKey)=>{
                    const formattedKey = handler.caseFormat((0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(unformattedKey));
                    const existingUnformattedKey = existingFormattedKeys.get(formattedKey);
                    if (existingUnformattedKey !== void 0) this.selectedKeys.add(existingUnformattedKey);
                });
            }
        });
    }
    resetSelectionState(keys) {
        if (this.params.defaultToNothingSelected) this.selectedKeys.clear();
        else this.selectedKeys = new Set(keys);
    }
    getFilterHandler() {
        return this.handler;
    }
    destroy() {
        this.virtualList = this.destroyBean(this.virtualList);
        for (const func of this.handlerDestroyFuncs ?? [])func();
        this.handler = void 0;
        this.displayValueModel = void 0;
        this.selectedKeys.clear();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ModelWrapper = class {
    constructor(model){
        this.model = model;
    }
    getRowCount() {
        return this.model.getDisplayedValueCount();
    }
    getRow(index) {
        return this.model.getDisplayedItem(index);
    }
    areRowsEqual(oldRow, newRow) {
        return oldRow === newRow;
    }
};
var $5b7ccabde48fae90$var$ModelWrapperWithSelectAll = class {
    constructor(model, showAddCurrentSelectionToFilter){
        this.model = model;
        this.showAddCurrentSelectionToFilter = showAddCurrentSelectionToFilter;
    }
    getRowCount() {
        const showAddCurrentSelectionToFilter = this.showAddCurrentSelectionToFilter();
        const outboundItems = showAddCurrentSelectionToFilter ? 2 : 1;
        return this.model.getDisplayedValueCount() + outboundItems;
    }
    getRow(index) {
        if (index === 0) return this.model.getSelectAllItem();
        const showAddCurrentSelectionToFilter = this.showAddCurrentSelectionToFilter();
        const outboundItems = showAddCurrentSelectionToFilter ? 2 : 1;
        if (index === 1 && showAddCurrentSelectionToFilter) return this.model.getAddSelectionToFilterItem();
        return this.model.getDisplayedItem(index - outboundItems);
    }
    areRowsEqual(oldRow, newRow) {
        return oldRow === newRow;
    }
};
var $5b7ccabde48fae90$var$TreeModelWrapper = class {
    constructor(model){
        this.model = model;
    }
    getRowCount() {
        return this.model.getRowCount();
    }
    getRow(index) {
        return this.model.getRow(index);
    }
    areRowsEqual(oldRow, newRow) {
        if (oldRow == null && newRow == null) return true;
        return oldRow != null && newRow != null && oldRow.treeKey === newRow.treeKey && oldRow.depth === newRow.depth;
    }
};
var $5b7ccabde48fae90$var$ClientSideValuesExtractor = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(createKey, caseFormat, getValue, isTreeDataOrGrouping, isTreeData){
        super();
        this.createKey = createKey;
        this.caseFormat = caseFormat;
        this.getValue = getValue;
        this.isTreeDataOrGrouping = isTreeDataOrGrouping;
        this.isTreeData = isTreeData;
    }
    extractUniqueValuesAsync(predicate, existingValues) {
        return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            if (this.beans.rowModel.rowCountReady) resolve(this.extractUniqueValues(predicate, existingValues));
            else {
                const [destroyFunc] = this.addManagedEventListeners({
                    rowCountReady: ()=>{
                        destroyFunc?.();
                        resolve(this.extractUniqueValues(predicate, existingValues));
                    }
                });
            }
        });
    }
    extractUniqueValues(predicate, existingValues) {
        const values = /* @__PURE__ */ new Map();
        const existingFormattedKeys = this.extractExistingFormattedKeys(existingValues);
        const formattedKeys = /* @__PURE__ */ new Set();
        const treeData = this.isTreeData();
        const treeDataOrGrouping = this.isTreeDataOrGrouping();
        const groupedCols = this.beans.rowGroupColsSvc?.columns;
        const groupAllowUnbalanced = this.gos.get("groupAllowUnbalanced");
        const addValue = (unformattedKey, value)=>{
            const formattedKey = this.caseFormat(unformattedKey);
            if (!formattedKeys.has(formattedKey)) {
                formattedKeys.add(formattedKey);
                let keyToAdd = unformattedKey;
                let valueToAdd = (0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(value);
                const existingUnformattedKey = existingFormattedKeys?.get(formattedKey);
                if (existingUnformattedKey != null) {
                    keyToAdd = existingUnformattedKey;
                    valueToAdd = existingValues.get(existingUnformattedKey);
                }
                values.set(keyToAdd, valueToAdd);
            }
        };
        this.beans.rowModel.forEachLeafNode((node)=>{
            if (!node.data || !predicate(node)) return;
            if (treeDataOrGrouping) {
                this.addValueForTreeDataOrGrouping(node, treeData, groupedCols, addValue, groupAllowUnbalanced);
                return;
            }
            const value = this.getValue(node);
            if (value != null && Array.isArray(value)) {
                for (const x of value)addValue(this.createKey(x, node), x);
                if (value.length === 0) addValue(null, null);
            } else addValue(this.createKey(value, node), value);
        });
        return values;
    }
    addValueForTreeDataOrGrouping(node, treeData, groupedCols = [], addValue, groupAllowUnbalanced) {
        let dataPath;
        if (treeData) {
            if (node.childrenAfterGroup?.length) return;
            dataPath = node.getRoute() ?? [
                node.key ?? node.id
            ];
        } else {
            dataPath = groupedCols.map((groupCol)=>this.beans.valueSvc.getKeyForNode(groupCol, node));
            dataPath.push(this.getValue(node));
        }
        const processedDataPath = $5b7ccabde48fae90$var$processDataPath(dataPath, treeData, groupAllowUnbalanced);
        addValue(this.createKey(processedDataPath), processedDataPath);
    }
    extractExistingFormattedKeys(existingValues) {
        if (!existingValues) return null;
        const existingFormattedKeys = /* @__PURE__ */ new Map();
        existingValues.forEach((_value, key)=>{
            existingFormattedKeys.set(this.caseFormat(key), key);
        });
        return existingFormattedKeys;
    }
};
// packages/ag-grid-enterprise/src/setFilter/setFilterAppliedModel.ts
var $5b7ccabde48fae90$var$SetFilterAppliedModel = class {
    constructor(caseFormat){
        this.caseFormat = caseFormat;
        // This attribute contains keys that are actually used for filtering.
        // These keys take into account case sensitivity:
        // - When filtering is case-insensitive, all filtering keys are converted to upper case and stored here.
        this.keys = null;
    }
    /** No model applied */ isNull() {
        return this.keys == null;
    }
    /** Nothing selected */ isEmpty() {
        return !this.keys?.size;
    }
    update(appliedModel) {
        const keys = /* @__PURE__ */ new Set();
        this.keys = keys;
        const values = appliedModel?.values;
        if (values) {
            const caseFormat = this.caseFormat;
            for(let i = 0, len = values.length; i < len; i++)keys.add(caseFormat(values[i]));
        }
    }
    has(key) {
        return !!this.keys?.has(this.caseFormat(key));
    }
    destroy() {
        this.keys = null;
    }
};
var $5b7ccabde48fae90$var$SetFilterModelValuesType = /* @__PURE__ */ ((SetFilterModelValuesType2)=>{
    SetFilterModelValuesType2[SetFilterModelValuesType2["PROVIDED_LIST"] = 0] = "PROVIDED_LIST";
    SetFilterModelValuesType2[SetFilterModelValuesType2["PROVIDED_CALLBACK"] = 1] = "PROVIDED_CALLBACK";
    SetFilterModelValuesType2[SetFilterModelValuesType2["TAKEN_FROM_GRID_VALUES"] = 2] = "TAKEN_FROM_GRID_VALUES";
    return SetFilterModelValuesType2;
})($5b7ccabde48fae90$var$SetFilterModelValuesType || {});
var $5b7ccabde48fae90$var$setValueModel_default = $5b7ccabde48fae90$var$SetFilterModelValuesType;
var $5b7ccabde48fae90$var$SetValueModel = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(clientSideValuesExtractor, caseFormat, createKey, isTreeDataOrGrouping, params){
        super();
        this.clientSideValuesExtractor = clientSideValuesExtractor;
        this.caseFormat = caseFormat;
        this.createKey = createKey;
        this.isTreeDataOrGrouping = isTreeDataOrGrouping;
        this.params = params;
        /** All possible values for the filter, sorted if required. */ this.allValues = /* @__PURE__ */ new Map();
        /** Remaining keys when filters from other columns have been applied. */ this.availableKeys = /* @__PURE__ */ new Set();
        this.providedValues = null;
        this.initialised = false;
    }
    postConstruct() {
        const params = this.params;
        const values = params.handlerParams.filterParams.values;
        this.updateParams(params);
        if (values == null) this.valuesType = 2 /* TAKEN_FROM_GRID_VALUES */ ;
        else {
            this.valuesType = Array.isArray(values) ? 0 /* PROVIDED_LIST */  : 1 /* PROVIDED_CALLBACK */ ;
            this.providedValues = values;
        }
        this.updateAllValues();
    }
    refresh(params) {
        const handlerParams = params.handlerParams;
        if (handlerParams.source !== "colDef") return;
        const { values: values, suppressSorting: suppressSorting } = handlerParams.filterParams;
        const currentProvidedValues = this.providedValues;
        const currentSuppressSorting = this.params.handlerParams.filterParams.suppressSorting;
        this.params = params;
        this.updateParams(params);
        this.providedValues = values ?? null;
        if (this.providedValues !== currentProvidedValues || suppressSorting !== currentSuppressSorting) {
            if (!values || values.length === 0) {
                this.valuesType = 2 /* TAKEN_FROM_GRID_VALUES */ ;
                this.providedValues = null;
            } else this.valuesType = Array.isArray(values) ? 0 /* PROVIDED_LIST */  : 1 /* PROVIDED_CALLBACK */ ;
            this.updateAllValues();
        }
    }
    updateParams(params) {
        const { handlerParams: { colDef: colDef, filterParams: { comparator: comparator, treeList: treeList, treeListPathGetter: treeListPathGetter } }, usingComplexObjects: usingComplexObjects } = params;
        const keyComparator = comparator ?? colDef.comparator;
        const treeDataOrGrouping = this.isTreeDataOrGrouping();
        let entryComparator;
        if (treeDataOrGrouping && !keyComparator) entryComparator = $5b7ccabde48fae90$var$createTreeDataOrGroupingComparator();
        else if (treeList && !treeListPathGetter && !keyComparator) entryComparator = ([_aKey, aValue], [_bKey, bValue])=>(0, $437b23f6a393c3bf$export$b0cca9f3c87c8df8)(aValue, bValue);
        else entryComparator = ([_aKey, aValue], [_bKey, bValue])=>keyComparator(aValue, bValue);
        this.entryComparator = entryComparator;
        this.keyComparator = keyComparator ?? (0, $437b23f6a393c3bf$export$b0cca9f3c87c8df8);
        this.compareByValue = !!(usingComplexObjects && keyComparator || treeDataOrGrouping || treeList && !treeListPathGetter);
    }
    updateAllValues() {
        this.allKeys = new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            switch(this.valuesType){
                case 2 /* TAKEN_FROM_GRID_VALUES */ :
                    this.getValuesFromRowsAsync().then((values)=>resolve(this.processAllValues(values)));
                    break;
                case 0 /* PROVIDED_LIST */ :
                    resolve(this.processAllValues(this.uniqueValues(this.validateProvidedValues(this.providedValues))));
                    break;
                case 1 /* PROVIDED_CALLBACK */ :
                    {
                        this.dispatchLocalEvent({
                            type: "loadingStart"
                        });
                        const callback = this.providedValues;
                        const { column: column, colDef: colDef } = this.params.handlerParams;
                        const params = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
                            success: (values)=>{
                                this.dispatchLocalEvent({
                                    type: "loadingEnd"
                                });
                                resolve(this.processAllValues(this.uniqueValues(this.validateProvidedValues(values))));
                            },
                            colDef: colDef,
                            column: column
                        });
                        window.setTimeout(()=>callback(params), 0);
                        break;
                    }
            }
        });
        this.allKeys.then((values)=>{
            this.updateAvailableKeys(values ?? []);
            this.initialised = true;
        });
        return this.allKeys;
    }
    getAvailableValues(predicate) {
        return this.sortKeys(this.getValuesFromRows(predicate));
    }
    overrideValues(valuesToUse) {
        return this.allKeys.then(()=>{
            this.valuesType = 0 /* PROVIDED_LIST */ ;
            this.providedValues = valuesToUse;
        });
    }
    refreshAvailable() {
        return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            if (this.showAvailableOnly()) {
                this.allKeys.then((keys)=>{
                    const updatedKeys = keys ?? [];
                    this.updateAvailableKeys(updatedKeys);
                    resolve(true);
                });
                return;
            }
            resolve(false);
        });
    }
    refreshAll() {
        return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            this.allKeys.then(()=>{
                this.updateAllValues().then(()=>{
                    resolve();
                });
            });
        });
    }
    isLoading() {
        return !this.initialised && this.valuesType === 1 /* PROVIDED_CALLBACK */ ;
    }
    isInitialised() {
        return this.initialised;
    }
    getValueForFormatter(key) {
        return this.initialised ? this.allValues.get(key) : key;
    }
    getAvailableKeys(values) {
        return this.initialised ? values.filter((v)=>this.availableKeys.has(v)) : values;
    }
    getParamsForValuesFromRows(removeUnavailableValues) {
        if (!this.clientSideValuesExtractor) {
            (0, $437b23f6a393c3bf$export$a20c7248650823a9)(113);
            return void 0;
        }
        const existingValues = removeUnavailableValues && !this.params.handlerParams.filterParams.caseSensitive ? this.allValues : void 0;
        return existingValues;
    }
    getValuesFromRows(predicate) {
        const existingValues = this.getParamsForValuesFromRows(true);
        return this.clientSideValuesExtractor?.extractUniqueValues(predicate, existingValues) ?? null;
    }
    getValuesFromRowsAsync() {
        const existingValues = this.getParamsForValuesFromRows(false);
        return this.clientSideValuesExtractor?.extractUniqueValuesAsync(()=>true, existingValues) ?? (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(null);
    }
    processAllValues(values) {
        const sortedKeys = this.sortKeys(values);
        this.allValues = values ?? /* @__PURE__ */ new Map();
        return sortedKeys;
    }
    uniqueValues(values) {
        const uniqueValues = /* @__PURE__ */ new Map();
        const formattedKeys = /* @__PURE__ */ new Set();
        const { caseFormat: caseFormat, createKey: createKey } = this;
        for (const value of values ?? []){
            const valueToUse = (0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(value);
            const unformattedKey = createKey(valueToUse);
            const formattedKey = caseFormat(unformattedKey);
            if (!formattedKeys.has(formattedKey)) {
                formattedKeys.add(formattedKey);
                uniqueValues.set(unformattedKey, valueToUse);
            }
        }
        return uniqueValues;
    }
    validateProvidedValues(values) {
        if (this.params.usingComplexObjects && values?.length) {
            const firstValue = values[0];
            if (firstValue && typeof firstValue !== "object" && typeof firstValue !== "function") {
                const firstKey = this.createKey(firstValue);
                if (firstKey == null) (0, $437b23f6a393c3bf$export$545083624300f13d)(209);
                else (0, $437b23f6a393c3bf$export$545083624300f13d)(210);
            }
        }
        return values;
    }
    sortKeys(nullableValues) {
        const values = nullableValues ?? /* @__PURE__ */ new Map();
        const filterParams = this.params.handlerParams.filterParams;
        if (filterParams.suppressSorting) return Array.from(values.keys());
        let sortedKeys;
        if (this.compareByValue) sortedKeys = Array.from(values.entries()).sort(this.entryComparator).map(([key])=>key);
        else sortedKeys = Array.from(values.keys()).sort(this.keyComparator);
        if (filterParams.excelMode && values.has(null)) {
            sortedKeys = sortedKeys.filter((v)=>v != null);
            sortedKeys.push(null);
        }
        return sortedKeys;
    }
    showAvailableOnly() {
        return this.valuesType === 2 /* TAKEN_FROM_GRID_VALUES */ ;
    }
    updateAvailableKeys(allKeys) {
        const availableKeys = this.showAvailableOnly() ? this.getAvailableValues((node)=>this.params.handlerParams.doesRowPassOtherFilter(node)) : allKeys;
        this.availableKeys = new Set(availableKeys);
        this.dispatchLocalEvent({
            type: "availableValuesChanged"
        });
    }
};
// packages/ag-grid-enterprise/src/setFilter/setFilterHandler.ts
var $5b7ccabde48fae90$var$SetFilterHandler = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        /** Used to get the filter type for filter models. */ this.filterType = "set";
        this.treeDataTreeList = false;
        this.groupingTreeList = false;
        this.caseSensitive = false;
        this.noValueFormatterSupplied = false;
    }
    init(params) {
        this.updateParams(params);
        const isTreeDataOrGrouping = this.isTreeDataOrGrouping.bind(this);
        const isTreeData = ()=>this.treeDataTreeList;
        const createKey = this.createKey;
        const caseFormat = this.caseFormat.bind(this);
        const { gos: gos, beans: beans } = this;
        const clientSideValuesExtractor = (0, $437b23f6a393c3bf$export$9f182d9ca737e15)(gos, beans.rowModel) ? this.createManagedBean(new $5b7ccabde48fae90$var$ClientSideValuesExtractor(createKey, caseFormat, params.getValue, isTreeDataOrGrouping, isTreeData)) : void 0;
        this.valueModel = this.createManagedBean(new $5b7ccabde48fae90$var$SetValueModel(clientSideValuesExtractor, caseFormat, createKey, isTreeDataOrGrouping, {
            handlerParams: params,
            usingComplexObjects: !!(params.filterParams.keyCreator ?? params.colDef.keyCreator)
        }));
        this.appliedModel = new $5b7ccabde48fae90$var$SetFilterAppliedModel(this.caseFormat.bind(this));
        this.appliedModel.update(params.model);
        this.validateModel(params);
        this.addEventListenersForDataChanges();
    }
    refresh(params) {
        this.updateParams(params);
        this.valueModel.refresh({
            handlerParams: params,
            usingComplexObjects: !!(params.filterParams.keyCreator ?? params.colDef.keyCreator)
        });
        this.appliedModel.update(params.model);
        this.validateModel(params);
    }
    updateParams(params) {
        this.params = params;
        const { colDef: colDef, filterParams: { caseSensitive: caseSensitive, treeList: treeList, keyCreator: keyCreator, valueFormatter: valueFormatter } } = params;
        this.caseSensitive = !!caseSensitive;
        const isGroupCol = !!colDef.showRowGroup;
        this.treeDataTreeList = this.gos.get("treeData") && !!treeList && isGroupCol;
        this.groupingTreeList = !!this.beans.rowGroupColsSvc?.columns.length && !!treeList && isGroupCol;
        const resolvedKeyCreator = keyCreator ?? colDef.keyCreator;
        this.createKey = this.generateCreateKey(resolvedKeyCreator, this.isTreeDataOrGrouping());
        this.setValueFormatter(valueFormatter, resolvedKeyCreator, !!treeList, !!colDef.refData);
    }
    doesFilterPass(params) {
        const { appliedModel: appliedModel, treeDataTreeList: treeDataTreeList, groupingTreeList: groupingTreeList } = this;
        if (appliedModel.isNull()) return true;
        if (appliedModel.isEmpty()) return false;
        const { node: node } = params;
        if (treeDataTreeList) return this.doesFilterPassForTreeData(node);
        if (groupingTreeList) return this.doesFilterPassForGrouping(node);
        const value = this.params.getValue(node);
        if (value != null && Array.isArray(value)) {
            if (value.length === 0) return appliedModel.has(null);
            return value.some((v)=>appliedModel.has(this.createKey(v, node)));
        }
        return appliedModel.has(this.createKey(value, node));
    }
    getFormattedValue(key) {
        let value = this.valueModel.getValueForFormatter(key);
        if (this.noValueFormatterSupplied && this.isTreeDataOrGrouping() && Array.isArray(value)) value = (0, $437b23f6a393c3bf$export$236389741107357f)(value);
        const formattedValue = this.beans.valueSvc.formatValue(this.params.column, null, value, this.valueFormatter, false);
        return (formattedValue == null ? (0, $437b23f6a393c3bf$export$2a74c29220d5c88e)(value) : formattedValue) ?? $5b7ccabde48fae90$var$translateForSetFilter(this, "blanks");
    }
    getModelAsString(model, source) {
        const { values: values } = model ?? {};
        const forToolPanel = source === "filterToolPanel";
        if (values == null) return forToolPanel ? $5b7ccabde48fae90$var$translateForSetFilter(this, "filterSummaryListInactive") : "";
        const availableKeys = this.valueModel.getAvailableKeys(values);
        const numValues = availableKeys.length;
        const numToDisplay = forToolPanel ? 3 : 10;
        const formattedValues = availableKeys.slice(0, numToDisplay).map((key)=>this.getFormattedValue(key));
        if (forToolPanel) {
            const valueList = formattedValues.join($5b7ccabde48fae90$var$translateForSetFilter(this, "filterSummaryListSeparator"));
            if (numValues > 3) return $5b7ccabde48fae90$var$translateForSetFilter(this, "filterSummaryListLong", [
                valueList,
                String(numValues - 3)
            ]);
            else return $5b7ccabde48fae90$var$translateForSetFilter(this, "filterSummaryListShort", [
                valueList
            ]);
        }
        return `(${numValues}) ${formattedValues.join(",")}${numValues > 10 ? ",..." : ""}`;
    }
    onAnyFilterChanged() {
        window.setTimeout(()=>{
            if (!this.isAlive()) return;
            this.valueModel.refreshAvailable().then((updated)=>{
                this.dispatchLocalEvent({
                    type: "anyFilterChanged",
                    updated: !!updated
                });
            });
        });
    }
    onNewRowsLoaded() {
        this.syncAfterDataChange();
    }
    setFilterValues(values) {
        this.valueModel.overrideValues(values).then(()=>{
            this.refreshFilterValues();
        });
    }
    resetFilterValues() {
        this.valueModel.valuesType = $5b7ccabde48fae90$var$setValueModel_default.TAKEN_FROM_GRID_VALUES;
        this.syncAfterDataChange();
    }
    /**
   * @param suppressAvailableValuesCheck when refreshing values via the API, the model will be reset if all available values are selected.
   * When refreshing due to internal changes, set this to `true` to do the reset check based on all values instead.
   */ refreshFilterValues(suppressAvailableValuesCheck) {
        if (!this.valueModel.isInitialised()) return;
        this.valueModel.refreshAll().then(()=>{
            this.dispatchLocalEvent({
                type: "dataChanged",
                hardRefresh: true
            });
            this.validateModel(this.params, void 0, !suppressAvailableValuesCheck);
        });
    }
    getFilterKeys() {
        return Array.from(this.valueModel.allValues.keys());
    }
    getFilterValues() {
        return Array.from(this.valueModel.allValues.values());
    }
    isTreeDataOrGrouping() {
        return this.treeDataTreeList || this.groupingTreeList;
    }
    caseFormat(valueToFormat) {
        if (valueToFormat == null || typeof valueToFormat !== "string") return valueToFormat;
        return this.caseSensitive ? valueToFormat : valueToFormat.toUpperCase();
    }
    addEventListenersForDataChanges() {
        this.addManagedPropertyListeners([
            "groupAllowUnbalanced"
        ], ()=>this.syncAfterDataChange());
        const syncAfterDataChangeDebounced = (0, $437b23f6a393c3bf$export$cf7e39bfb94de6e)(this, this.syncAfterDataChange.bind(this), 0);
        this.addManagedEventListeners({
            cellValueChanged: (event)=>{
                if (event.column === this.params.column) syncAfterDataChangeDebounced();
            }
        });
    }
    syncAfterDataChange() {
        if (!this.isValuesTakenFromGrid()) return;
        this.valueModel.refreshAll().then(()=>{
            this.dispatchLocalEvent({
                type: "dataChanged"
            });
            this.validateModel(this.params, {
                afterDataChange: true
            });
        });
    }
    validateModel(params, additionalEventAttributes, restrictToAvailableValues) {
        const valueModel = this.valueModel;
        valueModel.allKeys.then(()=>{
            const model = params.model;
            if (model == null) return;
            const existingFormattedKeys = /* @__PURE__ */ new Map();
            const addKey = (key)=>existingFormattedKeys.set(this.caseFormat(key), key);
            if (restrictToAvailableValues) for (const key of valueModel.availableKeys)addKey(key);
            else valueModel.allValues.forEach((_value, key)=>addKey(key));
            const newValues = [];
            let updated = false;
            for (const unformattedKey of model.values){
                const formattedKey = this.caseFormat((0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(unformattedKey));
                const existingUnformattedKey = existingFormattedKeys.get(formattedKey);
                if (existingUnformattedKey !== void 0) {
                    newValues.push(existingUnformattedKey);
                    if (existingUnformattedKey !== unformattedKey) updated = true;
                } else updated = true;
            }
            const numNewValues = newValues.length;
            const filterParams = params.filterParams;
            if (numNewValues === 0 && filterParams.excelMode) {
                params.onModelChange(null, additionalEventAttributes);
                return;
            }
            const clearOnAllSelected = !filterParams.defaultToNothingSelected && (this.valueModel.valuesType === $5b7ccabde48fae90$var$setValueModel_default.TAKEN_FROM_GRID_VALUES || !filterParams.suppressClearModelOnRefreshValues);
            const allSelected = clearOnAllSelected && numNewValues === existingFormattedKeys.size;
            if (updated || !model.filterType || allSelected) {
                const newModel = allSelected ? null : {
                    filterType: this.filterType,
                    values: newValues
                };
                params.onModelChange(newModel, additionalEventAttributes);
            }
        });
    }
    isValuesTakenFromGrid() {
        return this.valueModel.valuesType === $5b7ccabde48fae90$var$setValueModel_default.TAKEN_FROM_GRID_VALUES;
    }
    doesFilterPassForTreeData(node) {
        if (node.childrenAfterGroup?.length) return false;
        const { gos: gos, appliedModel: appliedModel } = this;
        return appliedModel.has(this.createKey($5b7ccabde48fae90$var$processDataPath(node.getRoute() ?? [
            node.key ?? node.id
        ], true, gos.get("groupAllowUnbalanced"))));
    }
    doesFilterPassForGrouping(node) {
        const { appliedModel: appliedModel, params: params, gos: gos, beans: { rowGroupColsSvc: rowGroupColsSvc, valueSvc: valueSvc } } = this;
        const dataPath = (rowGroupColsSvc?.columns ?? []).map((groupCol)=>valueSvc.getKeyForNode(groupCol, node));
        dataPath.push(params.getValue(node));
        return appliedModel.has(this.createKey($5b7ccabde48fae90$var$processDataPath(dataPath, false, gos.get("groupAllowUnbalanced"))));
    }
    generateCreateKey(keyCreator, treeDataOrGrouping) {
        if (treeDataOrGrouping && !keyCreator) {
            (0, $437b23f6a393c3bf$export$a20c7248650823a9)(250);
            return ()=>null;
        }
        if (keyCreator) return (value, node = null)=>{
            const params = this.getKeyCreatorParams(value, node);
            return (0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(keyCreator(params));
        };
        return (value)=>(0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)((0, $437b23f6a393c3bf$export$2a74c29220d5c88e)(value));
    }
    getKeyCreatorParams(value, node = null) {
        const { colDef: colDef, column: column } = this.params;
        return (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
            value: value,
            colDef: colDef,
            column: column,
            node: node,
            data: node?.data
        });
    }
    setValueFormatter(providedValueFormatter, keyCreator, treeList, isRefData) {
        let valueFormatter = providedValueFormatter;
        if (!valueFormatter) {
            if (keyCreator && !treeList) {
                (0, $437b23f6a393c3bf$export$a20c7248650823a9)(249);
                return;
            }
            this.noValueFormatterSupplied = true;
            if (!isRefData) valueFormatter = (params)=>(0, $437b23f6a393c3bf$export$2a74c29220d5c88e)(params.value);
        }
        this.valueFormatter = valueFormatter;
    }
    getCrossFilterModel(callback) {
        const { createKey: createKey, valueModel: valueModel, params: params } = this;
        return callback(createKey, valueModel.availableKeys, params.model?.values);
    }
    destroy() {
        this.appliedModel.destroy();
        super.destroy();
        this.valueModel = void 0;
    }
};
var $5b7ccabde48fae90$var$SetFloatingFilterElement = {
    tag: "div",
    cls: "ag-floating-filter-input ag-set-floating-filter-input",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eFloatingFilterText"
        }
    ]
};
var $5b7ccabde48fae90$var$SetFloatingFilterComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$SetFloatingFilterElement, [
            (0, $437b23f6a393c3bf$export$31e2985be4ee06ab)
        ]);
        this.eFloatingFilterText = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.listenerAdded = false;
    }
    init(params) {
        this.params = params;
        this.eFloatingFilterText.setDisabled(true).addGuiEventListener("click", ()=>this.params.showParentFilter());
        this.setParams(params);
    }
    setParams(params) {
        const displayName = this.beans.colNames.getDisplayNameForColumn(params.column, "header", true);
        const translate = this.getLocaleTextFunc();
        this.eFloatingFilterText.setInputAriaLabel(`${displayName} ${translate("ariaFilterInput", "Filter Input")}`);
        if (this.gos.get("enableFilterHandlers")) {
            const reactiveParams = params;
            this.updateFloatingFilterText(reactiveParams.model);
        }
    }
    refresh(params) {
        this.params = params;
        this.setParams(params);
    }
    onParentModelChanged(parentModel) {
        this.updateFloatingFilterText(parentModel);
    }
    parentSetFilterInstance(cb) {
        this.params.parentFilterInstance((filter)=>{
            if (!(filter instanceof $5b7ccabde48fae90$var$SetFilter)) {
                (0, $437b23f6a393c3bf$export$a20c7248650823a9)(248);
                return;
            }
            cb(filter);
        });
    }
    addAvailableValuesListener() {
        const addListener = (handler)=>{
            if (!handler?.isAlive()) return;
            const valueModel = handler.valueModel;
            this.destroyListeners = valueModel.addManagedListeners(valueModel, {
                availableValuesChanged: ()=>this.updateFloatingFilterText(handler.params.model),
                destroyed: ()=>{
                    this.listenerAdded = false;
                    this.destroyListeners = void 0;
                }
            });
        };
        if (this.gos.get("enableFilterHandlers")) addListener(this.params.getHandler());
        else this.parentSetFilterInstance((setFilter)=>{
            addListener(setFilter.handler);
        });
        this.listenerAdded = true;
    }
    updateFloatingFilterText(parentModel) {
        if (parentModel == null) this.eFloatingFilterText.setValue("");
        else {
            if (!this.listenerAdded) this.addAvailableValuesListener();
            if (this.gos.get("enableFilterHandlers")) this.eFloatingFilterText.setValue(this.params.getHandler().getModelAsString?.(parentModel) ?? "");
            else this.parentSetFilterInstance((setFilter)=>{
                this.eFloatingFilterText.setValue(setFilter.getModelAsString(parentModel));
            });
        }
    }
    destroy() {
        const destroyListeners = this.destroyListeners;
        if (destroyListeners) {
            for (const destroyFunc of destroyListeners)destroyFunc();
            destroyListeners.length = 0;
        }
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/setFilter/setFilterModule.ts
var $5b7ccabde48fae90$export$4ab172eba3fdda9e = {
    moduleName: "SetFilter",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agSetColumnFilter: {
            classImp: $5b7ccabde48fae90$var$SetFilter,
            params: {
                useForm: true
            },
            processParams: (params)=>{
                $5b7ccabde48fae90$var$applyExcelModeOptions(params);
                return params;
            }
        },
        agSetColumnFloatingFilter: $5b7ccabde48fae90$var$SetFloatingFilterComp
    },
    dynamicBeans: {
        agSetColumnFilterHandler: $5b7ccabde48fae90$var$SetFilterHandler
    },
    icons: {
        // set filter tree list group contracted (click to expand)
        setFilterGroupClosed: "tree-closed",
        // set filter tree list group expanded (click to contract)
        setFilterGroupOpen: "tree-open",
        // set filter tree list expand/collapse all button, shown when some children are expanded and
        //     others are collapsed
        setFilterGroupIndeterminate: "tree-indeterminate",
        // set filter async values loading
        setFilterLoading: "loading"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$bee7a6b8183a1c61)
    ]
};
// packages/ag-grid-enterprise/src/statusBar/agStatusBar.css-GENERATED.ts
var $5b7ccabde48fae90$var$agStatusBarCSS = /*css*/ `.ag-status-bar{border-top:var(--ag-footer-row-border);display:flex;justify-content:space-between;line-height:1.5;overflow:hidden;padding-left:calc(var(--ag-spacing)*4);padding-right:calc(var(--ag-spacing)*4)}.ag-status-panel,:where(.ag-status-panel.ag-status-panel-aggregations .ag-status-name-value){display:inline-flex}.ag-status-name-value{color:var(--ag-status-bar-label-color);font-weight:var(--ag-status-bar-label-font-weight);margin-left:var(--ag-spacing);margin-right:var(--ag-spacing);padding-bottom:var(--ag-widget-container-vertical-padding);padding-top:var(--ag-widget-container-vertical-padding);white-space:nowrap}.ag-status-name-value-value{color:var(--ag-status-bar-value-color);font-weight:var(--ag-status-bar-value-font-weight)}.ag-status-bar-left{display:inline-flex}.ag-status-bar-center{display:inline-flex;text-align:center}.ag-status-bar-right{display:inline-flex}`;
// packages/ag-grid-enterprise/src/statusBar/agStatusBar.ts
function $5b7ccabde48fae90$var$getStatusPanelCompDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $5b7ccabde48fae90$var$StatusPanelComponent, void 0, params, true);
}
var $5b7ccabde48fae90$var$StatusPanelComponent = {
    name: "statusPanel",
    optionalMethods: [
        "refresh"
    ]
};
var $5b7ccabde48fae90$var$AgStatusBarValidationMap = {
    agAggregationComponent: {
        rowModels: [
            "clientSide",
            "serverSide"
        ],
        warnArgs: [
            221
        ]
    },
    agFilteredRowCountComponent: {
        rowModels: [
            "clientSide"
        ],
        warnArgs: [
            222
        ]
    },
    agSelectedRowCountComponent: {
        rowModels: [
            "clientSide",
            "serverSide"
        ],
        warnArgs: [
            223
        ]
    },
    agTotalAndFilteredRowCountComponent: {
        rowModels: [
            "clientSide"
        ],
        warnArgs: [
            224
        ]
    },
    agTotalRowCountComponent: {
        rowModels: [
            "clientSide"
        ],
        warnArgs: [
            225
        ]
    }
};
var $5b7ccabde48fae90$var$AgStatusBarElement = {
    tag: "div",
    cls: "ag-status-bar",
    children: [
        {
            tag: "div",
            ref: "eStatusBarLeft",
            cls: "ag-status-bar-left",
            role: "status"
        },
        {
            tag: "div",
            ref: "eStatusBarCenter",
            cls: "ag-status-bar-center",
            role: "status"
        },
        {
            tag: "div",
            ref: "eStatusBarRight",
            cls: "ag-status-bar-right",
            role: "status"
        }
    ]
};
var $5b7ccabde48fae90$var$AgStatusBar = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$AgStatusBarElement);
        this.updateQueued = false;
        this.panelsPromise = (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve();
        this.eStatusBarLeft = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eStatusBarCenter = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eStatusBarRight = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.compDestroyFunctions = {};
        this.registerCSS($5b7ccabde48fae90$var$agStatusBarCSS);
    }
    wireBeans(beans) {
        this.userCompFactory = beans.userCompFactory;
        this.statusBarSvc = beans.statusBarSvc;
    }
    postConstruct() {
        this.processStatusPanels(/* @__PURE__ */ new Map());
        this.addManagedPropertyListeners([
            "statusBar"
        ], this.handleStatusBarChanged.bind(this));
    }
    getValidPanels() {
        const gos = this.gos;
        const statusPanels = gos.get("statusBar")?.statusPanels;
        if (!statusPanels) return statusPanels;
        return statusPanels.filter((panel)=>{
            const { rowModels: rowModels, warnArgs: warnArgs } = $5b7ccabde48fae90$var$AgStatusBarValidationMap[panel.statusPanel] ?? {};
            if (!rowModels) return true;
            if (rowModels.includes(gos.get("rowModelType"))) return true;
            (0, $437b23f6a393c3bf$export$545083624300f13d)(...warnArgs);
            return false;
        });
    }
    processStatusPanels(existingStatusPanelsToReuse) {
        const statusPanels = this.getValidPanels();
        if (statusPanels) {
            const leftStatusPanelComponents = statusPanels.filter((componentConfig)=>componentConfig.align === "left");
            const centerStatusPanelComponents = statusPanels.filter((componentConfig)=>componentConfig.align === "center");
            const rightStatusPanelComponents = statusPanels.filter((componentConfig)=>!componentConfig.align || componentConfig.align === "right");
            this.panelsPromise = (0, $437b23f6a393c3bf$export$30ec7836a4847721).all([
                this.createAndRenderComponents(leftStatusPanelComponents, this.eStatusBarLeft, existingStatusPanelsToReuse),
                this.createAndRenderComponents(centerStatusPanelComponents, this.eStatusBarCenter, existingStatusPanelsToReuse),
                this.createAndRenderComponents(rightStatusPanelComponents, this.eStatusBarRight, existingStatusPanelsToReuse)
            ]);
        } else this.setDisplayed(false);
    }
    handleStatusBarChanged() {
        if (this.updateQueued) return;
        this.updateQueued = true;
        this.panelsPromise.then(()=>{
            this.updateStatusBar();
            this.updateQueued = false;
        });
    }
    updateStatusBar() {
        const statusPanels = this.getValidPanels();
        const validStatusBarPanelsProvided = Array.isArray(statusPanels) && statusPanels.length > 0;
        this.setDisplayed(validStatusBarPanelsProvided);
        const existingStatusPanelsToReuse = /* @__PURE__ */ new Map();
        if (validStatusBarPanelsProvided) for (const statusPanelConfig of statusPanels){
            const key = statusPanelConfig.key ?? statusPanelConfig.statusPanel;
            const existingStatusPanel = this.statusBarSvc.getStatusPanel(key);
            if (existingStatusPanel?.refresh) {
                const newParams = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
                    ...statusPanelConfig.statusPanelParams ?? {},
                    key: key
                });
                const hasRefreshed = existingStatusPanel.refresh(newParams);
                if (hasRefreshed) {
                    existingStatusPanelsToReuse.set(key, existingStatusPanel);
                    delete this.compDestroyFunctions[key];
                    (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(existingStatusPanel.getGui());
                }
            }
        }
        this.resetStatusBar();
        if (validStatusBarPanelsProvided) this.processStatusPanels(existingStatusPanelsToReuse);
    }
    resetStatusBar() {
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.eStatusBarLeft);
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.eStatusBarCenter);
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.eStatusBarRight);
        this.destroyComponents();
        this.statusBarSvc.unregisterAllComponents();
    }
    destroy() {
        this.destroyComponents();
        super.destroy();
    }
    destroyComponents() {
        for (const func of Object.values(this.compDestroyFunctions))func();
        this.compDestroyFunctions = {};
    }
    createAndRenderComponents(statusBarComponents, ePanelComponent, existingStatusPanelsToReuse) {
        const componentDetails = [];
        for (const componentConfig of statusBarComponents){
            const key = componentConfig.key || componentConfig.statusPanel;
            const existingStatusPanel = existingStatusPanelsToReuse.get(key);
            let promise;
            if (existingStatusPanel) promise = (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(existingStatusPanel);
            else {
                const compDetails = $5b7ccabde48fae90$var$getStatusPanelCompDetails(this.userCompFactory, componentConfig, (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
                    key: key
                }));
                if (compDetails == null) continue;
                promise = compDetails.newAgStackInstance();
            }
            componentDetails.push({
                key: key,
                promise: promise
            });
        }
        return (0, $437b23f6a393c3bf$export$30ec7836a4847721).all(componentDetails.map((details)=>details.promise)).then(()=>{
            for (const componentDetail of componentDetails)componentDetail.promise.then((component)=>{
                const destroyFunc = ()=>{
                    this.destroyBean(component);
                };
                if (this.isAlive()) {
                    this.statusBarSvc.registerStatusPanel(componentDetail.key, component);
                    ePanelComponent.appendChild(component.getGui());
                    this.compDestroyFunctions[componentDetail.key] = destroyFunc;
                } else destroyFunc();
            });
        });
    }
};
var $5b7ccabde48fae90$var$AgStatusBarSelector = {
    selector: "AG-STATUS-BAR",
    component: $5b7ccabde48fae90$var$AgStatusBar
};
var $5b7ccabde48fae90$var$AgNameValueElement = {
    tag: "div",
    cls: "ag-status-name-value",
    children: [
        {
            tag: "span",
            ref: "eLabel"
        },
        ":\xA0",
        {
            tag: "span",
            ref: "eValue",
            cls: "ag-status-name-value-value"
        }
    ]
};
var $5b7ccabde48fae90$var$AgNameValue = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$AgNameValueElement);
        this.eLabel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eValue = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    setLabel(key, defaultValue) {
        this.setDisplayed(false);
        this.eLabel.textContent = this.getLocaleTextFunc()(key, defaultValue);
    }
    setValue(value, totalRows) {
        this.eValue.textContent = this.valueFormatter((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
            value: value,
            totalRows: totalRows,
            key: this.key
        }));
    }
};
var $5b7ccabde48fae90$var$AgNameValueSelector = {
    selector: "AG-NAME-VALUE",
    component: $5b7ccabde48fae90$var$AgNameValue
};
// packages/ag-grid-enterprise/src/statusBar/providedPanels/utils.ts
var $5b7ccabde48fae90$var$_getFilteredRowCount = (rowModel)=>{
    let filteredRowCount = 0;
    rowModel.forEachNodeAfterFilter((node)=>{
        if (node.data) filteredRowCount++;
    });
    return filteredRowCount;
};
var $5b7ccabde48fae90$var$_getTotalRowCount = (rowModel)=>{
    let totalRowCount = 0;
    rowModel.forEachNode((node)=>{
        if (node.data) totalRowCount++;
    });
    return totalRowCount;
};
// packages/ag-grid-enterprise/src/statusBar/providedPanels/aggregationComp.ts
function $5b7ccabde48fae90$var$_formatNumberTwoDecimalPlacesAndCommas(value, getLocaleTextFunc) {
    if (typeof value !== "number") return "";
    return (0, $437b23f6a393c3bf$export$c8980add4a69422e)(Math.round(value * 100) / 100, getLocaleTextFunc);
}
var $5b7ccabde48fae90$var$AggregationCompElement = {
    tag: "div",
    cls: "ag-status-panel ag-status-panel-aggregations",
    children: [
        {
            tag: "ag-name-value",
            ref: "avgAggregationComp"
        },
        {
            tag: "ag-name-value",
            ref: "countAggregationComp"
        },
        {
            tag: "ag-name-value",
            ref: "minAggregationComp"
        },
        {
            tag: "ag-name-value",
            ref: "maxAggregationComp"
        },
        {
            tag: "ag-name-value",
            ref: "sumAggregationComp"
        }
    ]
};
var $5b7ccabde48fae90$var$AggregationComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$AggregationCompElement, [
            $5b7ccabde48fae90$var$AgNameValueSelector
        ]);
        this.sumAggregationComp = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.countAggregationComp = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.minAggregationComp = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.maxAggregationComp = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.avgAggregationComp = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        this.avgAggregationComp.setLabel("avg", "Average");
        this.countAggregationComp.setLabel("count", "Count");
        this.minAggregationComp.setLabel("min", "Min");
        this.maxAggregationComp.setLabel("max", "Max");
        this.sumAggregationComp.setLabel("sum", "Sum");
        this.addManagedEventListeners({
            cellSelectionChanged: this.onCellSelectionChanged.bind(this),
            modelUpdated: this.onCellSelectionChanged.bind(this)
        });
    }
    init(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.params = params;
        const valueFormatter = params.valueFormatter ?? (({ value: value })=>$5b7ccabde48fae90$var$_formatNumberTwoDecimalPlacesAndCommas(value, this.getLocaleTextFunc.bind(this)));
        const aggFuncNames = [
            "avg",
            "count",
            "min",
            "max",
            "sum"
        ];
        for (const key of aggFuncNames){
            const comp = this.getAllowedAggregationValueComponent(key);
            if (comp) {
                comp.key = key;
                comp.valueFormatter = valueFormatter.bind(this);
            }
        }
        this.onCellSelectionChanged();
        return true;
    }
    setAggregationComponentValue(aggFuncName, value, visible) {
        const statusBarValueComponent = this.getAllowedAggregationValueComponent(aggFuncName);
        const totalRow = $5b7ccabde48fae90$var$_getTotalRowCount(this.beans.rowModel);
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(statusBarValueComponent) && statusBarValueComponent) {
            statusBarValueComponent.setValue(value, totalRow);
            statusBarValueComponent.setDisplayed(visible);
        } else this.getAggregationValueComponent(aggFuncName)?.setDisplayed(false);
    }
    getAllowedAggregationValueComponent(aggFuncName) {
        const { aggFuncs: aggFuncs } = this.params;
        if (!aggFuncs || aggFuncs.includes(aggFuncName)) return this.getAggregationValueComponent(aggFuncName);
        return null;
    }
    getAggregationValueComponent(aggFuncName) {
        const refComponentName = `${aggFuncName}AggregationComp`;
        return this[refComponentName];
    }
    onCellSelectionChanged() {
        const beans = this.beans;
        const { rangeSvc: rangeSvc, valueSvc: valueSvc } = beans;
        const cellRanges = rangeSvc?.getCellRanges();
        let sum = 0;
        let count = 0;
        let numberCount = 0;
        let min = null;
        let max = null;
        const cellsSoFar = {};
        if (cellRanges?.length && rangeSvc) for(let i = 0; i < cellRanges.length; i++){
            const cellRange = cellRanges[i];
            let currentRow = rangeSvc.getRangeStartRow(cellRange);
            const lastRow = rangeSvc.getRangeEndRow(cellRange);
            while(true){
                const finishedAllRows = (0, $437b23f6a393c3bf$export$672d9e47bc342bac)(currentRow) || !currentRow || (0, $437b23f6a393c3bf$export$6cce97428a227a31)(lastRow, currentRow);
                if (finishedAllRows || !currentRow || !cellRange.columns) break;
                cellRange.columns.forEach((col)=>{
                    if (currentRow === null) return;
                    const cellId = (0, $437b23f6a393c3bf$export$c0c5a5ba9327269f)({
                        rowPinned: currentRow.rowPinned,
                        column: col,
                        rowIndex: currentRow.rowIndex
                    });
                    if (cellsSoFar[cellId]) return;
                    cellsSoFar[cellId] = true;
                    const rowNode = (0, $437b23f6a393c3bf$export$d4675a60917db7b0)(beans, currentRow);
                    if ((0, $437b23f6a393c3bf$export$672d9e47bc342bac)(rowNode)) return;
                    let value = valueSvc.getValue(col, rowNode);
                    if ((0, $437b23f6a393c3bf$export$672d9e47bc342bac)(value) || value === "") return;
                    count++;
                    if (typeof value === "object" && "value" in value) {
                        value = value.value;
                        if (value === "") return;
                    }
                    if (typeof value === "string") value = Number(value);
                    if (typeof value === "number" && !isNaN(value)) {
                        sum += value;
                        if (max === null || value > max) max = value;
                        if (min === null || value < min) min = value;
                        numberCount++;
                    }
                });
                currentRow = (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(beans, currentRow);
            }
        }
        const gotResult = count > 1;
        const gotNumberResult = numberCount > 1;
        this.setAggregationComponentValue("count", count, gotResult);
        this.setAggregationComponentValue("sum", sum, gotNumberResult);
        this.setAggregationComponentValue("min", min, gotNumberResult);
        this.setAggregationComponentValue("max", max, gotNumberResult);
        this.setAggregationComponentValue("avg", sum / numberCount, gotNumberResult);
    }
};
var $5b7ccabde48fae90$var$FilteredRowsComp = class extends $5b7ccabde48fae90$var$AgNameValue {
    postConstruct() {
        this.setLabel("filteredRows", "Filtered");
        this.addCss("ag-status-panel");
        this.addCss("ag-status-panel-filtered-row-count");
        this.setDisplayed(true);
        const listener = this.onDataChanged.bind(this);
        this.addManagedEventListeners({
            modelUpdated: listener
        });
    }
    onDataChanged() {
        const { rowModel: rowModel } = this.beans;
        const totalRowCountValue = $5b7ccabde48fae90$var$_getTotalRowCount(rowModel);
        const filteredRowCountValue = $5b7ccabde48fae90$var$_getFilteredRowCount(rowModel);
        this.setValue(filteredRowCountValue, totalRowCountValue);
        this.setDisplayed(totalRowCountValue !== filteredRowCountValue);
    }
    init(params) {
        this.refresh(params);
        this.onDataChanged();
    }
    updateValueFormatter(valueFormatter) {
        this.valueFormatter = valueFormatter ?? (({ value: value })=>(0, $437b23f6a393c3bf$export$c8980add4a69422e)(value, this.getLocaleTextFunc.bind(this)));
    }
    refresh(params) {
        const { key: key, valueFormatter: valueFormatter } = params;
        this.key = key;
        this.updateValueFormatter(valueFormatter);
        return true;
    }
};
var $5b7ccabde48fae90$var$SelectedRowsComp = class extends $5b7ccabde48fae90$var$AgNameValue {
    postConstruct() {
        this.setLabel("selectedRows", "Selected");
        this.addCss("ag-status-panel");
        this.addCss("ag-status-panel-selected-row-count");
        const eventListener = this.onRowSelectionChanged.bind(this);
        this.addManagedEventListeners({
            modelUpdated: eventListener,
            selectionChanged: eventListener
        });
    }
    onRowSelectionChanged() {
        const { selectionSvc: selectionSvc, rowModel: rowModel } = this.beans;
        const selectedRowCount = selectionSvc?.getSelectionCount() ?? 0;
        const totalRowCount = $5b7ccabde48fae90$var$_getTotalRowCount(rowModel);
        this.setValue(selectedRowCount, totalRowCount);
        if (selectedRowCount < 0) {
            this.setDisplayed(true);
            return;
        }
        this.setDisplayed(selectedRowCount > 0);
    }
    init(params) {
        this.refresh(params);
        this.onRowSelectionChanged();
    }
    updateValueFormatter(valueFormatter) {
        this.valueFormatter = valueFormatter ?? (({ value: value })=>{
            if (value == null || value >= 0) return (0, $437b23f6a393c3bf$export$c8980add4a69422e)(value, this.getLocaleTextFunc.bind(this));
            return this.getLocaleTextFunc()("statusBarLastRowUnknown", "?");
        });
    }
    refresh(params) {
        const { key: key, valueFormatter: valueFormatter } = params;
        this.key = key;
        this.updateValueFormatter(valueFormatter);
        return true;
    }
};
var $5b7ccabde48fae90$var$TotalAndFilteredRowsComp = class extends $5b7ccabde48fae90$var$AgNameValue {
    postConstruct() {
        this.setLabel("totalAndFilteredRows", "Rows");
        this.addCss("ag-status-panel");
        this.addCss("ag-status-panel-total-and-filtered-row-count");
        this.setDisplayed(true);
        this.addManagedEventListeners({
            modelUpdated: this.onDataChanged.bind(this)
        });
    }
    onDataChanged() {
        const { rowModel: rowModel } = this.beans;
        const rowCount = $5b7ccabde48fae90$var$_getFilteredRowCount(rowModel);
        const totalRowCount = $5b7ccabde48fae90$var$_getTotalRowCount(rowModel);
        this.setValue(rowCount, totalRowCount);
    }
    init(params) {
        this.refresh(params);
        this.onDataChanged();
    }
    updateValueFormatter(valueFormatter) {
        this.valueFormatter = valueFormatter ?? (({ value: value, totalRows: totalRows })=>{
            const getLocaleTextFunc = this.getLocaleTextFunc.bind(this);
            const rowCount = (0, $437b23f6a393c3bf$export$c8980add4a69422e)(value, getLocaleTextFunc);
            const totalRowCount = (0, $437b23f6a393c3bf$export$c8980add4a69422e)(totalRows ?? value, getLocaleTextFunc);
            if (value === totalRows) return rowCount;
            const localeTextFunc = getLocaleTextFunc();
            return `${rowCount} ${localeTextFunc("of", "of")} ${totalRowCount}`;
        });
    }
    refresh(params) {
        const { key: key, valueFormatter: valueFormatter } = params;
        this.key = key;
        this.updateValueFormatter(valueFormatter);
        return true;
    }
};
var $5b7ccabde48fae90$var$TotalRowsComp = class extends $5b7ccabde48fae90$var$AgNameValue {
    postConstruct() {
        this.setLabel("totalRows", "Total Rows");
        this.addCss("ag-status-panel");
        this.addCss("ag-status-panel-total-row-count");
        this.setDisplayed(true);
        this.addManagedEventListeners({
            modelUpdated: this.onDataChanged.bind(this)
        });
    }
    onDataChanged() {
        const totalRow = $5b7ccabde48fae90$var$_getTotalRowCount(this.beans.rowModel);
        this.setValue(totalRow, totalRow);
    }
    init(params) {
        this.refresh(params);
        this.onDataChanged();
    }
    updateValueFormatter(valueFormatter) {
        this.valueFormatter = valueFormatter ?? (({ value: value })=>(0, $437b23f6a393c3bf$export$c8980add4a69422e)(value, this.getLocaleTextFunc.bind(this)));
    }
    refresh(params) {
        const { key: key, valueFormatter: valueFormatter } = params;
        this.key = key;
        this.updateValueFormatter(valueFormatter);
        return true;
    }
};
function $5b7ccabde48fae90$var$getStatusPanel(beans, key) {
    const comp = beans.statusBarSvc?.getStatusPanel(key);
    return (0, $437b23f6a393c3bf$export$213d4c63c3df47e4)(comp);
}
var $5b7ccabde48fae90$var$StatusBarService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    // tslint:disable-next-line
    constructor(){
        super();
        this.beanName = "statusBarSvc";
        this.comps = /* @__PURE__ */ new Map();
    }
    registerStatusPanel(key, component) {
        this.comps.set(key, component);
    }
    unregisterStatusPanel(key) {
        this.comps.delete(key);
    }
    unregisterAllComponents() {
        this.comps.clear();
    }
    getStatusPanel(key) {
        return this.comps.get(key);
    }
    destroy() {
        this.unregisterAllComponents();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/statusBar/statusBarModule.ts
var $5b7ccabde48fae90$export$76a316c8c2f3bc28 = {
    moduleName: "StatusBar",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$StatusBarService
    ],
    userComponents: {
        agAggregationComponent: $5b7ccabde48fae90$var$AggregationComp,
        agTotalRowCountComponent: $5b7ccabde48fae90$var$TotalRowsComp,
        agFilteredRowCountComponent: $5b7ccabde48fae90$var$FilteredRowsComp,
        agTotalAndFilteredRowCountComponent: $5b7ccabde48fae90$var$TotalAndFilteredRowsComp,
        agSelectedRowCountComponent: $5b7ccabde48fae90$var$SelectedRowsComp
    },
    selectors: [
        $5b7ccabde48fae90$var$AgStatusBarSelector
    ],
    apiFunctions: {
        getStatusPanel: $5b7ccabde48fae90$var$getStatusPanel
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$44f04c51d8088336)
    ]
};
function $5b7ccabde48fae90$var$assertNotExcelMultiSheet(beans) {
    if (beans.excelCreator?.getFactoryMode() === "MULTI_SHEET") {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(161);
        return false;
    }
    return true;
}
function $5b7ccabde48fae90$var$getDataAsExcel(beans, params) {
    if ($5b7ccabde48fae90$var$assertNotExcelMultiSheet(beans)) return beans.excelCreator?.getDataAsExcel(params);
    return void 0;
}
function $5b7ccabde48fae90$var$exportDataAsExcel(beans, params) {
    if ($5b7ccabde48fae90$var$assertNotExcelMultiSheet(beans)) beans.excelCreator?.exportDataAsExcel(params);
}
function $5b7ccabde48fae90$var$getSheetDataForExcel(beans, params) {
    beans.excelCreator?.setFactoryMode("MULTI_SHEET");
    return beans.excelCreator?.getSheetDataForExcel(params);
}
function $5b7ccabde48fae90$var$getMultipleSheetsAsExcel2(beans, params) {
    return beans.excelCreator?.getMultipleSheetsAsExcel(params);
}
function $5b7ccabde48fae90$var$exportMultipleSheetsAsExcel2(beans, params) {
    beans.excelCreator?.exportMultipleSheetsAsExcel(params);
}
// packages/ag-grid-enterprise/src/excelExport/excelExportModule.ts
var $5b7ccabde48fae90$export$98f0c53ca0379def = {
    moduleName: "ExcelExport",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$ExcelCreator
    ],
    apiFunctions: {
        getDataAsExcel: $5b7ccabde48fae90$var$getDataAsExcel,
        exportDataAsExcel: $5b7ccabde48fae90$var$exportDataAsExcel,
        getSheetDataForExcel: $5b7ccabde48fae90$var$getSheetDataForExcel,
        getMultipleSheetsAsExcel: $5b7ccabde48fae90$var$getMultipleSheetsAsExcel2,
        exportMultipleSheetsAsExcel: $5b7ccabde48fae90$var$exportMultipleSheetsAsExcel2
    },
    dependsOn: [
        (0, $437b23f6a393c3bf$export$e6030935e93fda2b),
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
function $5b7ccabde48fae90$var$getMultiFilterDefs(params) {
    const { filters: filters } = params;
    return filters && filters.length > 0 ? filters : [
        {
            filter: "agTextColumnFilter"
        },
        {
            filter: "agSetColumnFilter"
        }
    ];
}
function $5b7ccabde48fae90$var$forEachReverse(list, action) {
    if (list == null) return;
    for(let i = list.length - 1; i >= 0; i--)action(list[i], i);
}
function $5b7ccabde48fae90$var$getFilterTitle(filter, filterDef) {
    if (filterDef.title != null) return filterDef.title;
    return filter instanceof (0, $437b23f6a393c3bf$export$a927a1327c2cc7f0) ? filter.getFilterTitle() : "Filter";
}
function $5b7ccabde48fae90$var$getUpdatedMultiFilterModel(existingModel, numFilters, newModel, index) {
    const filterModels = [];
    const existingFilterModels = existingModel?.filterModels;
    for(let i = 0; i < numFilters; i++)filterModels[i] = (i === index ? newModel : existingFilterModels?.[i]) ?? null;
    return filterModels.every((childModel)=>childModel == null) ? null : {
        filterType: "multi",
        filterModels: filterModels
    };
}
function $5b7ccabde48fae90$var$getFilterModelForIndex(model, index) {
    return model?.filterModels?.[index] ?? null;
}
function $5b7ccabde48fae90$var$updateGetValue(beans, column, filterDef, existingGetValue) {
    const filterValueGetter = filterDef.filterValueGetter;
    return filterValueGetter ? beans.colFilter.createGetValue(column, filterValueGetter) : existingGetValue;
}
// packages/ag-grid-enterprise/src/multiFilter/baseMultiFilter.ts
var $5b7ccabde48fae90$var$BaseMultiFilter = class extends (0, $437b23f6a393c3bf$export$5a26e3abd1c845b6) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-multi-filter ag-menu-list-compact"
        });
        this.filterDefs = [];
        this.guiDestroyFuncs = [];
        // this could be the accordion/sub menu element depending on the display type
        this.filterGuis = [];
        this.lastActivatedMenuItem = null;
    }
    postConstruct() {
        this.initialiseTabGuard({
            onFocusIn: (e)=>this.onFocusIn(e)
        });
    }
    refreshGui(container) {
        if (container === this.lastOpenedInContainer) return (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve();
        this.tabGuardFeature.removeAllChildrenExceptTabGuards();
        this.destroyChildren();
        return (0, $437b23f6a393c3bf$export$30ec7836a4847721).all(this.getFilterWrappers().map((wrapper, index)=>{
            if (!wrapper) return (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(null);
            const filter = this.getFilterFromWrapper(wrapper);
            const comp = this.getCompFromWrapper(wrapper);
            const filterDef = this.filterDefs[index];
            const filterTitle = $5b7ccabde48fae90$var$getFilterTitle(filter, filterDef);
            let filterGuiPromise;
            if (filterDef.display === "subMenu" && container !== "toolPanel") filterGuiPromise = this.insertFilterMenu(comp, filter, filterTitle).then((menuItem)=>menuItem.getGui());
            else if (filterDef.display === "subMenu" || filterDef.display === "accordion") {
                const group = this.insertFilterGroup(filter, comp, filterTitle);
                filterGuiPromise = (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(group.getGui());
            } else filterGuiPromise = (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(comp.getGui());
            return filterGuiPromise;
        })).then((filterGuis)=>{
            filterGuis.forEach((filterGui, index)=>{
                if (!filterGui) return;
                if (index > 0) this.appendChild((0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
                    tag: "div",
                    cls: "ag-filter-separator"
                }));
                this.appendChild(filterGui);
            });
            this.filterGuis = filterGuis;
            this.lastOpenedInContainer = container;
        });
    }
    destroyChildren() {
        for (const func of this.guiDestroyFuncs)func();
        this.guiDestroyFuncs.length = 0;
        this.filterGuis.length = 0;
    }
    insertFilterMenu(comp, filter, name) {
        const eGui = comp.getGui();
        (0, $437b23f6a393c3bf$export$f8d01fa01787902)(eGui, "dialog");
        const menuItem = this.createBean(new $5b7ccabde48fae90$var$MenuItemComponent());
        const childComponent = {
            getGui: ()=>comp.getGui(),
            afterGuiAttached: (params)=>{
                comp.afterGuiAttached?.(params);
                if (comp !== filter) filter.afterGuiAttached?.(params);
            }
        };
        return menuItem.init({
            menuItemDef: {
                name: name,
                subMenu: [],
                subMenuRole: "dialog",
                cssClasses: [
                    "ag-multi-filter-menu-item"
                ],
                menuItem: $5b7ccabde48fae90$var$MenuItemRenderer,
                menuItemParams: {
                    cssClassPrefix: "ag-compact-menu-option",
                    isCompact: true
                }
            },
            level: 0,
            isAnotherSubMenuOpen: ()=>false,
            childComponent: childComponent,
            contextParams: {
                column: null,
                node: null,
                value: null
            }
        }).then(()=>{
            menuItem.setParentComponent(this);
            this.guiDestroyFuncs.push(()=>this.destroyBean(menuItem));
            this.addManagedListeners(menuItem, {
                menuItemActivated: (event)=>{
                    if (this.lastActivatedMenuItem && this.lastActivatedMenuItem !== event.menuItem) this.lastActivatedMenuItem.deactivate();
                    this.lastActivatedMenuItem = event.menuItem;
                }
            });
            const menuItemGui = menuItem.getGui();
            menuItem.addManagedElementListeners(menuItemGui, {
                // `AgMenuList` normally handles keyboard navigation, so need to do here
                keydown: (e)=>{
                    const { key: key } = e;
                    switch(key){
                        case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).UP:
                        case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT:
                        case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).DOWN:
                        case (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT:
                            e.preventDefault();
                            if (key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).RIGHT) menuItem.openSubMenu(true);
                            break;
                    }
                },
                focusin: ()=>menuItem.activate(),
                focusout: ()=>{
                    if (!menuItem.isSubMenuOpen() && !menuItem.isSubMenuOpening()) menuItem.deactivate();
                }
            });
            return menuItem;
        });
    }
    insertFilterGroup(filter, comp, title) {
        const group = this.createBean(new $5b7ccabde48fae90$export$9c4ea4ce92935a7e({
            title: title,
            cssIdentifier: "multi-filter"
        }));
        this.guiDestroyFuncs.push(()=>this.destroyBean(group));
        group.addItem(comp.getGui());
        group.toggleGroupExpand(false);
        if (filter.afterGuiAttached) group.addManagedListeners(group, {
            expanded: ()=>filter.afterGuiAttached({
                    container: this.lastOpenedInContainer,
                    suppressFocus: true,
                    hidePopup: this.hidePopup
                })
        });
        return group;
    }
    afterGuiAttached(params) {
        let refreshPromise;
        if (params) {
            this.hidePopup = params.hidePopup;
            refreshPromise = this.refreshGui(params.container);
        } else {
            this.hidePopup = void 0;
            refreshPromise = (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve();
        }
        const suppressFocus = params?.suppressFocus;
        refreshPromise.then(()=>{
            const { filterDefs: filterDefs, filterGuis: filterGuis, beans: beans } = this;
            const wrappers = this.getFilterWrappers();
            let hasFocused = !!suppressFocus;
            if (filterDefs) $5b7ccabde48fae90$var$forEachReverse(filterDefs, (filterDef, index)=>{
                const isFirst = index === 0;
                const notInlineDisplayType = filterDef.display && filterDef.display !== "inline";
                const suppressFocusForFilter = suppressFocus || !isFirst || notInlineDisplayType;
                const afterGuiAttachedParams = {
                    ...params ?? {},
                    suppressFocus: suppressFocusForFilter
                };
                const wrapper = wrappers[index];
                const filter = wrapper ? this.getFilterFromWrapper(wrapper) : void 0;
                if (wrapper) {
                    const comp = this.getCompFromWrapper(wrapper);
                    if (comp !== filter) comp.afterGuiAttached(afterGuiAttachedParams);
                }
                if (filter) {
                    this.executeFunctionIfExistsOnFilter(filter, "afterGuiAttached", afterGuiAttachedParams);
                    if (isFirst && !suppressFocusForFilter) hasFocused = true;
                }
                if (!suppressFocus && isFirst && notInlineDisplayType) {
                    const filterGui = filterGuis[index];
                    if (filterGui) {
                        if (!(0, $437b23f6a393c3bf$export$8598088d375f416f)(filterGui)) filterGui.focus({
                            preventScroll: true
                        });
                        hasFocused = true;
                    }
                }
            });
            const activeEl = (0, $437b23f6a393c3bf$export$16bc98d422315038)(beans);
            if (!hasFocused && ((0, $437b23f6a393c3bf$export$8ff9eef09a45371f)(beans) || this.getGui().contains(activeEl))) this.forceFocusOutOfContainer(true);
        });
    }
    afterGuiDetached() {
        this.executeFunctionIfExists("afterGuiDetached");
    }
    onAnyFilterChanged() {
        this.executeFunctionIfExists("onAnyFilterChanged", (wrapper)=>this.executeOnWrapper(wrapper, "onAnyFilterChanged"));
    }
    onNewRowsLoaded() {
        this.executeFunctionIfExists("onNewRowsLoaded", (wrapper)=>this.executeOnWrapper(wrapper, "onNewRowsLoaded"));
    }
    destroy() {
        this.destroyChildren();
        this.hidePopup = void 0;
        super.destroy();
    }
    executeOnWrapper(_wrapper, _name) {}
    executeFunctionIfExists(name, executeOnHandler) {
        $5b7ccabde48fae90$var$forEachReverse(this.getFilterWrappers(), (wrapper)=>{
            if (wrapper) {
                executeOnHandler?.(wrapper);
                this.executeFunctionIfExistsOnFilter(this.getFilterFromWrapper(wrapper), name);
            }
        });
    }
    executeFunctionIfExistsOnFilter(filter, name, ...params) {
        const func = filter[name];
        if (typeof func === "function") func.apply(filter, params);
    }
    onFocusIn(e) {
        const lastActivatedMenuItem = this.lastActivatedMenuItem;
        if (lastActivatedMenuItem != null && !lastActivatedMenuItem.getGui().contains(e.target)) {
            lastActivatedMenuItem.deactivate();
            this.lastActivatedMenuItem = null;
        }
    }
};
// packages/ag-grid-enterprise/src/multiFilter/multiFilter.ts
var $5b7ccabde48fae90$var$MultiFilter = class extends $5b7ccabde48fae90$var$BaseMultiFilter {
    constructor(){
        super(...arguments);
        this.filterType = "multi";
        this.wrappers = [];
        this.activeFilterIndices = [];
        this.afterFiltersReadyFuncs = [];
    }
    init(params) {
        this.params = params;
        this.filterDefs = $5b7ccabde48fae90$var$getMultiFilterDefs(params);
        const initialModel = (0, $437b23f6a393c3bf$export$8981db65da4532f2)(this.beans.colFilter.model, params.column.getColId());
        const { filterChangedCallback: filterChangedCallback } = params;
        this.filterChangedCallback = filterChangedCallback;
        const filterPromises = this.filterDefs.map((filterDef, index)=>this.createFilter(filterDef, index, initialModel));
        return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            (0, $437b23f6a393c3bf$export$30ec7836a4847721).all(filterPromises).then((wrappers)=>{
                this.wrappers = wrappers;
                this.refreshGui("columnMenu").then(()=>{
                    resolve();
                });
            });
        }).then(()=>{
            for (const f of this.afterFiltersReadyFuncs)f();
            this.afterFiltersReadyFuncs.length = 0;
        });
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    isFilterActive() {
        return this.wrappers.some((wrapper)=>{
            if (!wrapper) return false;
            const { filter: filter, handler: handler, model: model } = wrapper;
            if (handler) return model != null;
            return filter.isFilterActive();
        });
    }
    getLastActiveFilterIndex() {
        const activeFilterIndices = this.activeFilterIndices;
        return activeFilterIndices.length > 0 ? activeFilterIndices[activeFilterIndices.length - 1] : null;
    }
    doesFilterPass(params, indexToSkip) {
        return this.wrappers.every((wrapper, index)=>{
            if (!wrapper || indexToSkip != null && index === indexToSkip) return true;
            const { handler: handler, filter: filter, model: model } = wrapper;
            if (handler) return model == null || handler.doesFilterPass({
                ...params,
                model: model,
                handlerParams: wrapper.handlerParams
            });
            return !filter.isFilterActive() || filter.doesFilterPass(params);
        });
    }
    getModelFromUi() {
        const model = {
            filterType: this.filterType,
            filterModels: this.wrappers.map((wrapper)=>{
                if (!wrapper) return null;
                const providedFilter = wrapper.filter;
                if (typeof providedFilter.getModelFromUi === "function") return providedFilter.getModelFromUi();
                return null;
            })
        };
        return model;
    }
    getModel() {
        if (!this.isFilterActive()) return null;
        const model = {
            filterType: this.filterType,
            filterModels: this.wrappers.map((wrapper)=>{
                if (!wrapper) return null;
                const { filter: filter, handler: handler, model: model2 } = wrapper;
                if (handler) return model2;
                return filter.isFilterActive() ? filter.getModel() : null;
            })
        };
        return model;
    }
    setModel(model) {
        const setFilterModel = (filter, filterModel)=>{
            return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
                const promise = filter.setModel(filterModel);
                promise ? promise.then(()=>resolve()) : resolve();
            });
        };
        const promises = [];
        this.wrappers.forEach((wrapper, index)=>{
            if (!wrapper) return;
            const modelForFilter = $5b7ccabde48fae90$var$getFilterModelForIndex(model, index);
            const { filter: filter, filterParams: filterParams, handler: handler, handlerParams: handlerParams, state: state } = wrapper;
            if (handler) {
                const newState = {
                    model: modelForFilter,
                    state: state?.state
                };
                wrapper.state = newState;
                wrapper.model = modelForFilter;
                promises.push((0, $437b23f6a393c3bf$export$1fc9ad198b29415d)(()=>(0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve({
                        filter: filter,
                        filterParams: filterParams
                    }), handler, handlerParams, modelForFilter, newState, "api").then(()=>{
                    this.updateActiveListForHandler(index, wrapper.model);
                }));
            } else promises.push(setFilterModel(filter, modelForFilter).then(()=>{
                this.updateActiveListForFilter(index, filter);
            }));
        });
        return (0, $437b23f6a393c3bf$export$30ec7836a4847721).all(promises).then(()=>{});
    }
    applyModel(source = "api") {
        let result = false;
        for (const wrapper of this.wrappers)if (wrapper) {
            const filter = wrapper.filter;
            if (filter instanceof (0, $437b23f6a393c3bf$export$a927a1327c2cc7f0)) result = filter.applyModel(source) || result;
        }
        return result;
    }
    getChildFilterInstance(index) {
        return this.wrappers[index]?.filter;
    }
    getNumChildFilters() {
        return this.wrappers.length;
    }
    destroy() {
        for (const wrapper of this.wrappers){
            this.destroyBean(wrapper?.filter);
            this.destroyBean(wrapper?.handler);
        }
        this.wrappers.length = 0;
        super.destroy();
    }
    getFilterWrappers() {
        return this.wrappers;
    }
    getFilterFromWrapper(wrapper) {
        return wrapper.filter;
    }
    getCompFromWrapper(wrapper) {
        return wrapper.comp;
    }
    executeOnWrapper(wrapper, name) {
        wrapper.handler?.[name]?.();
    }
    createFilter(filterDef, index, initialModel) {
        const column = this.params.column;
        let initialModelForFilter = null;
        let createWrapperComp;
        const beans = this.beans;
        const onModelChange = (model, additionalEventAttributes)=>{
            const wrapper = this.wrappers[index];
            if (!wrapper) return;
            const newState = {
                model: model,
                state: wrapper.state?.state
            };
            wrapper.state = newState;
            wrapper.model = model;
            (0, $437b23f6a393c3bf$export$1fc9ad198b29415d)(()=>(0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve({
                    filter: wrapper.filter,
                    filterParams: wrapper.filterParams
                }), wrapper.handler, wrapper.handlerParams, model, newState, "ui").then(()=>{
                this.onHandlerModelChanged(index, wrapper.model, additionalEventAttributes);
            });
        };
        const { compDetails: compDetails, handler: handler, handlerParams: originalHandlerParams, createFilterUi: createFilterUi } = beans.colFilter.createFilterInstance(column, filterDef, "agTextColumnFilter", (defaultParams, isHandler)=>{
            const updatedParams = {
                ...defaultParams,
                filterChangedCallback: isHandler ? ()=>{} : (additionalEventAttributes)=>{
                    this.executeWhenAllFiltersReady(()=>this.onFilterModelChanged(index, additionalEventAttributes));
                },
                doesRowPassOtherFilter: (node)=>defaultParams.doesRowPassOtherFilter(node) && this.doesFilterPass({
                        node: node,
                        data: node.data
                    }, index),
                getValue: $5b7ccabde48fae90$var$updateGetValue(beans, column, filterDef, defaultParams.getValue)
            };
            if (isHandler) {
                initialModelForFilter = $5b7ccabde48fae90$var$getFilterModelForIndex(initialModel, index);
                createWrapperComp = this.updateDisplayParams(updatedParams, index, initialModelForFilter, ()=>compDetails, ()=>handler, onModelChange);
            }
            return updatedParams;
        });
        if (!createFilterUi) return (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(null);
        let handlerParams;
        if (handler) {
            const { doesRowPassOtherFilter: doesRowPassOtherFilter, getValue: getValue } = originalHandlerParams;
            handlerParams = {
                ...originalHandlerParams,
                onModelChange: onModelChange,
                doesRowPassOtherFilter: (node)=>doesRowPassOtherFilter(node) && this.doesFilterPass({
                        node: node,
                        data: node.data
                    }, index),
                getValue: $5b7ccabde48fae90$var$updateGetValue(beans, column, filterDef, getValue)
            };
            handler.init?.({
                ...handlerParams,
                model: initialModelForFilter,
                source: "init"
            });
        }
        return createFilterUi().then((filter)=>{
            if (!handler) return {
                filter: filter,
                comp: filter
            };
            const filterParams = compDetails?.params;
            const comp = createWrapperComp(filter);
            return {
                filter: filter,
                comp: comp,
                filterParams: filterParams,
                handler: handler,
                handlerParams: handlerParams,
                model: initialModelForFilter
            };
        });
    }
    updateDisplayParams(displayParams, index, initialModelForFilter, getCompDetails, getHandler, onModelChange) {
        const column = this.params.column;
        const eventSvc = new (0, $437b23f6a393c3bf$export$820da7696a401cdc)();
        displayParams.model = initialModelForFilter;
        displayParams.state = {
            model: initialModelForFilter
        };
        displayParams.onModelChange = onModelChange;
        displayParams.getHandler = getHandler;
        const updateState = (wrapper, state)=>{
            wrapper.state = state;
            eventSvc.dispatchEvent({
                type: "filterStateChanged",
                column: column,
                state: state
            });
        };
        displayParams.onStateChange = (state)=>{
            const wrapper = this.wrappers[index];
            if (!wrapper) return;
            updateState(wrapper, state);
            (0, $437b23f6a393c3bf$export$8e370ccb0273c891)(wrapper.filter, wrapper.filterParams, wrapper.model ?? null, state, "ui");
        };
        const updateModel = (_column, action, additionalEventAttributes)=>{
            const wrapper = this.wrappers[index];
            if (!wrapper) return;
            const getModel = ()=>wrapper?.model ?? null;
            (0, $437b23f6a393c3bf$export$3305e8c6f4c8572a)({
                action: action,
                filterParams: wrapper.filterParams,
                getFilterUi: ()=>{
                    const promise = (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(wrapper.filter);
                    return {
                        created: true,
                        filterParams: wrapper.filterParams,
                        compDetails: getCompDetails(),
                        create: ()=>promise,
                        promise: promise
                    };
                },
                getModel: getModel,
                getState: ()=>wrapper?.state ?? {
                        model: getModel()
                    },
                updateState: (state)=>updateState(wrapper, state),
                updateModel: (newModel)=>wrapper.filterParams?.onModelChange(newModel, additionalEventAttributes),
                processModelToApply: wrapper.handler?.processModelToApply?.bind(wrapper.handler)
            });
        };
        displayParams.onAction = (action, additionalEventAttributes, event)=>{
            updateModel(column, action, additionalEventAttributes);
            eventSvc.dispatchEvent({
                type: "filterAction",
                column: column,
                action: action,
                event: event
            });
        };
        return (filter)=>{
            const filterParams = getCompDetails()?.params;
            return this.createManagedBean(new (0, $437b23f6a393c3bf$export$70acaf0e0e30e7d)(column, {
                comp: filter,
                params: filterParams,
                isHandler: true
            }, eventSvc, updateModel, false));
        };
    }
    executeWhenAllFiltersReady(action) {
        if ((this.wrappers?.length ?? 0) > 0) action();
        else this.afterFiltersReadyFuncs.push(action);
    }
    updateActiveListForFilter(index, filter) {
        this.updateActiveList(index, ()=>filter?.isFilterActive());
    }
    updateActiveListForHandler(index, model) {
        this.updateActiveList(index, ()=>model != null);
    }
    updateActiveList(index, isActive) {
        const activeFilterIndices = this.activeFilterIndices;
        (0, $437b23f6a393c3bf$export$83a881c8b5120679)(this.activeFilterIndices, index);
        if (isActive()) activeFilterIndices.push(index);
    }
    /** Only called for non-handlers */ onFilterModelChanged(index, additionalEventAttributes) {
        this.updateActiveListForFilter(index, this.wrappers[index]?.filter);
        this.filterChanged(index, additionalEventAttributes);
    }
    onHandlerModelChanged(index, model, additionalEventAttributes) {
        this.updateActiveListForHandler(index, model);
        this.filterChanged(index, additionalEventAttributes);
    }
    filterChanged(index, additionalEventAttributes) {
        this.filterChangedCallback(additionalEventAttributes);
        this.wrappers.forEach((wrapper, childIndex)=>{
            if (index === childIndex || !wrapper) return;
            const { filter: filter, handler: handler } = wrapper;
            handler?.onAnyFilterChanged?.();
            if (typeof filter.onAnyFilterChanged === "function") filter.onAnyFilterChanged();
        });
    }
    getModelAsString(model) {
        if (!model?.filterModels?.length) return "";
        const lastActiveIndex = this.getLastActiveFilterIndex() ?? 0;
        const activeFilter = this.wrappers[lastActiveIndex]?.filter;
        return activeFilter?.getModelAsString?.(model.filterModels[lastActiveIndex]) ?? "";
    }
};
var $5b7ccabde48fae90$var$MultiFilterHandler = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        /** Used to get the filter type for filter models. */ this.filterType = "multi";
        this.handlerWrappers = [];
        /** ui active. could still have null model */ this.activeFilterIndices = [];
        this.filterDefs = [];
    }
    init(params) {
        this.params = params;
        const filterDefs = $5b7ccabde48fae90$var$getMultiFilterDefs(params.filterParams);
        this.filterDefs = filterDefs;
        filterDefs.forEach((def, index)=>{
            const wrapper = this.beans.colFilter.createHandler(params.column, def, "agTextColumnFilter");
            this.handlerWrappers.push(wrapper);
            if (!wrapper) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(278, {
                    colId: params.column.getColId()
                });
                return;
            }
            const { handler: handler, handlerParams: handlerParams } = wrapper;
            handler.init?.({
                ...this.updateHandlerParams(handlerParams, index, true),
                model: $5b7ccabde48fae90$var$getFilterModelForIndex(params.model, index),
                source: "init"
            });
        });
        this.resetActiveList(params.model);
    }
    refresh(params) {
        this.params = params;
        const { model: model, source: source, filterParams: filterParams } = params;
        const filters = filterParams?.filters;
        this.handlerWrappers.forEach((wrapper, index)=>{
            if (wrapper) {
                const handlerParams = this.updateHandlerParams(params, index, false);
                const originalFilterParams = handlerParams.filterParams;
                const providedFilterParams = filters?.[index].filterParams;
                const filterParamsForFilter = providedFilterParams ? {
                    ...originalFilterParams,
                    ...providedFilterParams
                } : originalFilterParams;
                const updatedParams = {
                    ...handlerParams,
                    filterParams: filterParamsForFilter
                };
                wrapper.handlerParams = updatedParams;
                wrapper.handler.refresh?.({
                    ...updatedParams,
                    model: $5b7ccabde48fae90$var$getFilterModelForIndex(model, index),
                    source: source
                });
            }
        });
        if (params.source !== "floating" && params.source !== "ui") this.resetActiveList(params.model);
        if (params.additionalEventAttributes?.fromButtons) this.onAnyFilterChanged();
    }
    updateHandlerParams(params, index, isInit) {
        const { onModelChange: onModelChange, doesRowPassOtherFilter: doesRowPassOtherFilter, getValue: getValue } = params;
        const handlerParams = {
            ...params,
            onModelChange: (newModel, additionalEventAttributes)=>onModelChange($5b7ccabde48fae90$var$getUpdatedMultiFilterModel(this.params.model, this.handlerWrappers.length, newModel, index), additionalEventAttributes),
            doesRowPassOtherFilter: (node)=>doesRowPassOtherFilter(node) && this.doesFilterPass({
                    node: node,
                    data: node.data,
                    model: this.params.model,
                    handlerParams: handlerParams
                }, index),
            getValue: $5b7ccabde48fae90$var$updateGetValue(this.beans, params.column, this.filterDefs[index], getValue)
        };
        if (handlerParams.filterParams.buttons) {
            if (isInit) (0, $437b23f6a393c3bf$export$545083624300f13d)(292, {
                colId: params.column.getColId()
            });
            delete handlerParams.filterParams.buttons;
        }
        return handlerParams;
    }
    doesFilterPass(params, indexToSkip) {
        const filterModels = params.model?.filterModels;
        if (filterModels == null) return true;
        return this.handlerWrappers.every((wrapper, index)=>{
            const model = filterModels[index];
            if (model == null || indexToSkip != null && index === indexToSkip) return true;
            const handler = wrapper?.handler;
            return !handler || handler.doesFilterPass({
                ...params,
                model: model,
                handlerParams: wrapper.handlerParams
            });
        });
    }
    resetActiveList(model) {
        this.activeFilterIndices = [];
        const filterModels = model?.filterModels;
        if (filterModels == null) return;
        for(let i = 0; i < this.handlerWrappers.length; i++){
            const isActive = filterModels[i] != null;
            if (isActive) this.activeFilterIndices.push(i);
        }
    }
    updateActiveList(index, childModel) {
        const activeFilterIndices = this.activeFilterIndices;
        (0, $437b23f6a393c3bf$export$83a881c8b5120679)(activeFilterIndices, index);
        if (childModel != null) activeFilterIndices.push(index);
    }
    getLastActiveFilterIndex() {
        const activeFilterIndices = this.activeFilterIndices;
        return activeFilterIndices.length > 0 ? activeFilterIndices[activeFilterIndices.length - 1] : null;
    }
    getModelAsString(model, source) {
        const isForToolPanel = source === "filterToolPanel";
        const defaultOption = ()=>isForToolPanel ? this.getLocaleTextFunc()("filterSummaryInactive", "is (All)") : "";
        if (!model?.filterModels?.length) return defaultOption();
        const lastActiveIndex = this.getLastActiveFilterIndex() ?? 0;
        const activeWrapper = this.handlerWrappers[lastActiveIndex];
        return activeWrapper?.handler.getModelAsString?.(model.filterModels[lastActiveIndex], source) ?? defaultOption();
    }
    getHandler(index) {
        return this.handlerWrappers[index]?.handler;
    }
    onAnyFilterChanged() {
        $5b7ccabde48fae90$var$forEachReverse(this.handlerWrappers, (wrapper)=>wrapper?.handler?.onAnyFilterChanged?.());
    }
    onNewRowsLoaded() {
        $5b7ccabde48fae90$var$forEachReverse(this.handlerWrappers, (wrapper)=>wrapper?.handler?.onNewRowsLoaded?.());
    }
    destroy() {
        for (const wrapper of this.handlerWrappers)this.destroyBean(wrapper?.handler);
        this.handlerWrappers.length = 0;
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$MultiFilterService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "multiFilter";
    }
    getParamsForDataType(existingFilterParams, existingFilterValueGetter, dataTypeDefinition, formatValue) {
        let filters = existingFilterParams?.filters;
        const beans = this.beans;
        if (!filters) {
            const simpleFilter = (0, $437b23f6a393c3bf$export$4a4e3cf6acc7e93)(dataTypeDefinition.baseDataType);
            filters = [
                {
                    filter: simpleFilter
                },
                {
                    filter: "agSetColumnFilter"
                }
            ];
        }
        const translate = this.getLocaleTextFunc();
        filters = filters.map((filterDef)=>{
            const { filter: filter, filterParams: existingChildFilterParams, filterValueGetter: existingChildFilterValueGetter } = filterDef;
            if (typeof filter !== "string") return filterDef;
            const { filterParams: filterParams, filterValueGetter: filterValueGetter } = (0, $437b23f6a393c3bf$export$4a99b58ce484acc)(filter, existingChildFilterParams, existingChildFilterValueGetter ?? existingFilterValueGetter, dataTypeDefinition, formatValue, beans, translate);
            return {
                ...filterDef,
                filterParams: filterParams,
                filterValueGetter: filterValueGetter
            };
        });
        return {
            filterParams: {
                ...existingFilterParams,
                filters: filters
            }
        };
    }
};
var $5b7ccabde48fae90$var$MultiFilterUi = class extends $5b7ccabde48fae90$var$BaseMultiFilter {
    constructor(){
        super(...arguments);
        this.filterType = "multi";
        this.filters = [];
        this.filterParams = [];
        this.validity = [];
    }
    init(params) {
        this.params = params;
        const filterDefs = $5b7ccabde48fae90$var$getMultiFilterDefs(params).map((filterDef)=>{
            if (filterDef.filterParams?.buttons) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(292, {
                    colId: params.column.getColId()
                });
                const newParams = {
                    ...filterDef.filterParams
                };
                delete newParams.buttons;
                return {
                    ...filterDef,
                    filterParams: newParams
                };
            }
            return filterDef;
        });
        this.filterDefs = filterDefs;
        this.allState = params.state;
        const filterPromises = this.filterDefs.map((filterDef, index)=>this.createFilter(filterDef, index));
        return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            (0, $437b23f6a393c3bf$export$30ec7836a4847721).all(filterPromises).then((filters)=>{
                this.filters = filters;
                this.refreshGui("columnMenu").then(()=>{
                    resolve();
                });
            });
        });
    }
    refresh(params) {
        const { model: model, state: state, source: source } = params;
        if (source === "colDef") return false;
        this.params = params;
        const filterParams = this.filterParams;
        if (state === this.allState) return true;
        this.allState = state;
        const newAllStateState = state.state;
        this.filters.forEach((filter, index)=>{
            const modelForFilter = $5b7ccabde48fae90$var$getFilterModelForIndex(model, index);
            const stateForFilter = {
                state: newAllStateState?.[index],
                model: $5b7ccabde48fae90$var$getFilterModelForIndex(state.model, index)
            };
            (0, $437b23f6a393c3bf$export$8e370ccb0273c891)(filter, filterParams[index], modelForFilter, stateForFilter, source);
        });
        return true;
    }
    getLastActiveFilterIndex() {
        return this.getHandler().getLastActiveFilterIndex?.() ?? null;
    }
    getChildFilterInstance(index) {
        return this.filters[index] ?? void 0;
    }
    getNumChildFilters() {
        return this.filters.length;
    }
    destroy() {
        for (const filter of this.filters)this.destroyBean(filter);
        this.filters.length = 0;
        super.destroy();
    }
    getFilterWrappers() {
        return this.filters;
    }
    getFilterFromWrapper(wrapper) {
        return wrapper;
    }
    getCompFromWrapper(wrapper) {
        return wrapper;
    }
    createFilter(filterDef, index) {
        const userCompFactory = this.beans.userCompFactory;
        const filterParams = this.updateParams(filterDef, this.params, index);
        const compDetails = (0, $437b23f6a393c3bf$export$e6db9a2d59456da0)(userCompFactory, filterDef, filterParams, "agTextColumnFilter");
        if (!compDetails) return (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(null);
        this.filterParams[index] = compDetails.params;
        return compDetails.newAgStackInstance();
    }
    updateParams(filterDef, params, index) {
        const { doesRowPassOtherFilter: doesRowPassOtherFilter, model: model, onModelChange: onModelChange, state: state, onStateChange: onStateChange, column: column, source: source, onAction: onAction, onUiChange: onUiChange, getValue: getValue } = params;
        const filterModel = $5b7ccabde48fae90$var$getFilterModelForIndex(model, index);
        const filterState = state ? {
            model: $5b7ccabde48fae90$var$getFilterModelForIndex(state.model, index),
            state: state.state?.[index]
        } : {
            model: filterModel
        };
        const onAnyFilterChanged = ()=>{
            const handler = this.getHandler();
            this.filters.forEach((filter, otherIndex)=>{
                if (index !== otherIndex) {
                    handler.getHandler(otherIndex)?.onAnyFilterChanged?.();
                    filter?.onAnyFilterChanged?.();
                }
            });
        };
        const colFilter = this.beans.colFilter;
        return {
            ...colFilter.createBaseFilterParams(column),
            ...filterDef,
            doesRowPassOtherFilter: (node)=>doesRowPassOtherFilter(node) && this.getHandler().doesFilterPass({
                    node: node,
                    data: node.data,
                    model: this.params.model,
                    handlerParams: colFilter.getHandlerParams(column)
                }, index),
            model: filterModel,
            state: filterState,
            onModelChange: (childModel, additionalEventAttributes)=>{
                const { filters: filters, params: params2 } = this;
                const newModel = $5b7ccabde48fae90$var$getUpdatedMultiFilterModel(params2.model, filters.length, childModel, index);
                this.updateActiveList(index, childModel);
                onModelChange(newModel, additionalEventAttributes);
                onAnyFilterChanged();
            },
            onStateChange: (newState)=>this.onStateChange(onStateChange, index, newState),
            getHandler: ()=>this.getHandler().getHandler(index),
            onAction: (action, additionalEventAttributes, event)=>{
                if ((0, $437b23f6a393c3bf$export$527c1b777ebd9069)(params)) return;
                const isChange = action === "apply" || action === "reset";
                if (isChange) this.updateActiveList(index, $5b7ccabde48fae90$var$getFilterModelForIndex(this.params.state.model, index));
                onAction(action, additionalEventAttributes, event);
                if (isChange) onAnyFilterChanged();
            },
            onUiChange: onUiChange,
            source: source,
            getValue: $5b7ccabde48fae90$var$updateGetValue(this.beans, column, filterDef, getValue)
        };
    }
    updateActiveList(index, childModel) {
        this.getHandler().updateActiveList?.(index, childModel);
    }
    getHandler() {
        return this.params.getHandler();
    }
    onStateChange(onStateChange, index, newState) {
        const { model: model, state: state, valid: valid } = newState;
        const validity = this.validity;
        validity[index] = valid;
        const allState = this.allState;
        const newModel = $5b7ccabde48fae90$var$getUpdatedMultiFilterModel(allState.model, this.filters.length, model, index);
        const allValid = validity.every((filterValid)=>filterValid !== false);
        const allStateState = [
            ...allState.state ?? []
        ];
        allStateState[index] = state;
        const newAllState = {
            state: allStateState,
            model: newModel,
            valid: allValid
        };
        this.allState = newAllState;
        onStateChange(newAllState);
    }
    getModelAsString(model) {
        return this.getHandler().getModelAsString?.(model) ?? "";
    }
};
var $5b7ccabde48fae90$var$MultiFloatingFilterElement = {
    tag: "div",
    cls: "ag-multi-floating-filter ag-floating-filter-input"
};
var $5b7ccabde48fae90$var$MultiFloatingFilterComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$MultiFloatingFilterElement);
        this.floatingFilters = [];
        this.compDetailsList = [];
    }
    init(params) {
        this.params = params;
        const { compDetailsList: compDetailsList } = this.getCompDetailsList(params);
        return this.setParams(compDetailsList);
    }
    setParams(compDetailsList) {
        const floatingFilterPromises = [];
        compDetailsList.forEach((compDetails)=>{
            const floatingFilterPromise = compDetails?.newAgStackInstance();
            if (floatingFilterPromise != null) {
                this.compDetailsList.push(compDetails);
                floatingFilterPromises.push(floatingFilterPromise);
            }
        });
        return (0, $437b23f6a393c3bf$export$30ec7836a4847721).all(floatingFilterPromises).then((floatingFilters)=>{
            floatingFilters.forEach((floatingFilter, index)=>{
                this.floatingFilters.push(floatingFilter);
                const gui = floatingFilter.getGui();
                this.appendChild(gui);
                if (index > 0) (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(gui, false);
            });
        });
    }
    refresh(params) {
        this.params = params;
        const { compDetailsList: newCompDetailsList, floatingFilterParamsList: floatingFilterParamsList } = this.getCompDetailsList(params);
        const allFloatingFilterCompsUnchanged = newCompDetailsList.length === this.compDetailsList.length && newCompDetailsList.every((newCompDetails, index)=>!this.beans.colFilter?.areFilterCompsDifferent(this.compDetailsList[index], newCompDetails));
        if (allFloatingFilterCompsUnchanged) {
            floatingFilterParamsList.forEach((floatingFilterParams, index)=>{
                const floatingFilter = this.floatingFilters[index];
                floatingFilter.refresh?.(floatingFilterParams);
            });
            if (this.gos.get("enableFilterHandlers")) {
                const reactiveParams = params;
                if (reactiveParams.model == null) this.floatingFilters.forEach((filter, i)=>{
                    (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(filter.getGui(), i === 0);
                });
                else {
                    const lastActiveFloatingFilterIndex = reactiveParams.getHandler()?.getLastActiveFilterIndex?.();
                    this.floatingFilters.forEach((filter, i)=>{
                        const shouldShow = lastActiveFloatingFilterIndex == null ? i === 0 : i === lastActiveFloatingFilterIndex;
                        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(filter.getGui(), shouldShow);
                    });
                }
            }
        } else {
            (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.getGui());
            this.destroyBeans(this.floatingFilters);
            this.floatingFilters = [];
            this.compDetailsList = [];
            this.setParams(newCompDetailsList);
        }
    }
    getCompDetailsList(params) {
        const compDetailsList = [];
        const floatingFilterParamsList = [];
        const filterParams = params.filterParams;
        const currentParentModel = params.currentParentModel;
        const filterDefs = $5b7ccabde48fae90$var$getMultiFilterDefs(filterParams);
        filterDefs.forEach((filterDef, index)=>{
            const floatingFilterParams = {
                ...params,
                // set the parent filter instance for each floating filter to the relevant child filter instance
                parentFilterInstance: (callback)=>{
                    this.parentMultiFilterInstance((parent)=>{
                        const child = parent.getChildFilterInstance(index);
                        if (child == null) return;
                        callback(child);
                    });
                },
                // return the parent model for the specific filter
                currentParentModel: ()=>currentParentModel()?.filterModels?.[index] ?? null
            };
            if (this.gos.get("enableFilterHandlers")) {
                const reactiveParams = floatingFilterParams;
                reactiveParams.model = reactiveParams.model?.filterModels?.[index] ?? null;
                const { onModelChange: onModelChange, getHandler: getHandler } = reactiveParams;
                reactiveParams.onModelChange = (newModel, additionalEventAttributes)=>onModelChange($5b7ccabde48fae90$var$getUpdatedMultiFilterModel(this.params.model, filterDefs.length, newModel, index), additionalEventAttributes);
                reactiveParams.getHandler = ()=>{
                    const multiFilterHandler = getHandler();
                    return multiFilterHandler.getHandler(index);
                };
            }
            (0, $437b23f6a393c3bf$export$8ade6bd474fcde42)(floatingFilterParams.filterParams, filterDef.filterParams);
            const compDetails = this.getCompDetails(filterDef, floatingFilterParams);
            if (compDetails) {
                compDetailsList.push(compDetails);
                floatingFilterParamsList.push(floatingFilterParams);
            }
        });
        return {
            compDetailsList: compDetailsList,
            floatingFilterParamsList: floatingFilterParamsList
        };
    }
    onParentModelChanged(model, event) {
        if (event?.afterFloatingFilter) return;
        this.parentMultiFilterInstance((parent)=>{
            if (model == null) this.floatingFilters.forEach((filter, i)=>{
                filter.onParentModelChanged(null, event);
                (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(filter.getGui(), i === 0);
            });
            else {
                const lastActiveFloatingFilterIndex = parent.getLastActiveFilterIndex();
                this.floatingFilters.forEach((filter, i)=>{
                    const filterModel = model.filterModels.length > i ? model.filterModels[i] : null;
                    filter.onParentModelChanged(filterModel, event);
                    const shouldShow = lastActiveFloatingFilterIndex == null ? i === 0 : i === lastActiveFloatingFilterIndex;
                    (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(filter.getGui(), shouldShow);
                });
            }
        });
    }
    destroy() {
        this.destroyBeans(this.floatingFilters);
        this.floatingFilters.length = 0;
        super.destroy();
    }
    getCompDetails(filterDef, params) {
        const { colFilter: colFilter, frameworkOverrides: frameworkOverrides, userCompFactory: userCompFactory } = this.beans;
        const defaultComponentName = (0, $437b23f6a393c3bf$export$47072b32bdaf5d61)(frameworkOverrides, filterDef, ()=>colFilter.getDefaultFloatingFilter(this.params.column)) ?? "agReadOnlyFloatingFilter";
        return (0, $437b23f6a393c3bf$export$14d0998f093f007e)(userCompFactory, filterDef, params, defaultComponentName);
    }
    parentMultiFilterInstance(cb) {
        this.params.parentFilterInstance((parent)=>{
            if (!(parent instanceof $5b7ccabde48fae90$var$MultiFilter || parent instanceof $5b7ccabde48fae90$var$MultiFilterUi)) (0, $437b23f6a393c3bf$export$a20c7248650823a9)(120);
            cb(parent);
        });
    }
};
// packages/ag-grid-enterprise/src/multiFilter/multiFilterModule.ts
var $5b7ccabde48fae90$export$8897e17f4dd9d13a = {
    moduleName: "MultiFilter",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agMultiColumnFilter: {
            getComp: (beans)=>beans.gos.get("enableFilterHandlers") ? {
                    classImp: $5b7ccabde48fae90$var$MultiFilterUi,
                    params: {
                        useForm: true
                    }
                } : $5b7ccabde48fae90$var$MultiFilter
        },
        agMultiColumnFloatingFilter: $5b7ccabde48fae90$var$MultiFloatingFilterComp
    },
    beans: [
        $5b7ccabde48fae90$var$MultiFilterService
    ],
    dynamicBeans: {
        agMultiColumnFilterHandler: $5b7ccabde48fae90$var$MultiFilterHandler
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$bee7a6b8183a1c61),
        $5b7ccabde48fae90$var$MenuItemModule
    ]
};
var $5b7ccabde48fae90$var$AggColumnNameService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "aggColNameSvc";
    }
    getHeaderName(column, headerName) {
        if (this.gos.get("suppressAggFuncInHeader")) return headerName;
        const { valueColsSvc: valueColsSvc, colModel: colModel, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        const pivotValueColumn = column.getColDef().pivotValueColumn;
        const pivotActiveOnThisColumn = (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(pivotValueColumn);
        let aggFunc = null;
        let aggFuncFound;
        if (pivotActiveOnThisColumn) {
            const valueColumns = valueColsSvc?.columns ?? [];
            const isCollapsedHeaderEnabled = this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && valueColumns.length === 1;
            const isTotalColumn = column.getColDef().pivotTotalColumnIds !== void 0;
            if (isCollapsedHeaderEnabled && !isTotalColumn) return headerName;
            aggFunc = pivotValueColumn ? pivotValueColumn.getAggFunc() : null;
            aggFuncFound = true;
        } else {
            const measureActive = column.isValueActive();
            const isGrouping = rowGroupColsSvc?.columns.length !== 0;
            const aggregationPresent = colModel.isPivotMode() || isGrouping || this.gos.get("treeData");
            if (measureActive && aggregationPresent) {
                aggFunc = column.getAggFunc();
                aggFuncFound = true;
            } else aggFuncFound = false;
        }
        if (aggFuncFound) {
            const aggFuncString = typeof aggFunc === "string" ? aggFunc : "func";
            const localeTextFunc = this.getLocaleTextFunc();
            const aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
            return `${aggFuncStringTranslated}(${headerName})`;
        }
        return headerName;
    }
};
var $5b7ccabde48fae90$var$defaultAggFuncNames = {
    sum: "Sum",
    first: "First",
    last: "Last",
    min: "Min",
    max: "Max",
    count: "Count",
    avg: "Average"
};
var $5b7ccabde48fae90$var$AggFuncService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "aggFuncSvc";
        this.aggFuncsMap = {};
        this.initialised = false;
    }
    postConstruct() {
        this.init();
    }
    init() {
        if (this.initialised) return;
        this.initialiseWithDefaultAggregations();
        this.addAggFuncs(this.gos.get("aggFuncs"));
    }
    initialiseWithDefaultAggregations() {
        const aggMap = this.aggFuncsMap;
        aggMap["sum"] = $5b7ccabde48fae90$var$aggSum;
        aggMap["first"] = $5b7ccabde48fae90$var$aggFirst;
        aggMap["last"] = $5b7ccabde48fae90$var$aggLast;
        aggMap["min"] = $5b7ccabde48fae90$var$aggMin;
        aggMap["max"] = $5b7ccabde48fae90$var$aggMax;
        aggMap["count"] = $5b7ccabde48fae90$var$aggCount;
        aggMap["avg"] = $5b7ccabde48fae90$var$aggAvg;
        this.initialised = true;
    }
    isAggFuncPossible(column, func) {
        const allKeys = this.getFuncNames(column);
        const allowed = allKeys.includes(func);
        const funcExists = (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(this.aggFuncsMap[func]);
        return allowed && funcExists;
    }
    getDefaultFuncLabel(fctName) {
        return $5b7ccabde48fae90$var$defaultAggFuncNames[fctName] ?? fctName;
    }
    getDefaultAggFunc(column) {
        const defaultAgg = column.getColDef().defaultAggFunc;
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(defaultAgg) && this.isAggFuncPossible(column, defaultAgg)) return defaultAgg;
        if (this.isAggFuncPossible(column, "sum")) return "sum";
        const allKeys = this.getFuncNames(column);
        return allKeys?.length ? allKeys[0] : null;
    }
    addAggFuncs(aggFuncs) {
        this.init();
        if (!aggFuncs) return;
        for (const key of Object.keys(aggFuncs))if (aggFuncs[key]) this.aggFuncsMap[key] = aggFuncs[key];
    }
    getAggFunc(name) {
        this.init();
        return this.aggFuncsMap[name];
    }
    getFuncNames(column) {
        const userAllowedFuncs = column.getColDef().allowedAggFuncs;
        return userAllowedFuncs == null ? Object.keys(this.aggFuncsMap).sort() : userAllowedFuncs;
    }
    clear() {
        this.aggFuncsMap = {};
    }
};
function $5b7ccabde48fae90$var$aggSum(params) {
    const { values: values } = params;
    let result = null;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (typeof value === "number") {
            if (result === null) result = value;
            else result += typeof result === "number" ? value : BigInt(value);
        } else if (typeof value === "bigint") {
            if (result === null) result = value;
            else result = (typeof result === "bigint" ? result : BigInt(result)) + value;
        }
    }
    return result;
}
function $5b7ccabde48fae90$var$aggFirst(params) {
    return params.values.length > 0 ? params.values[0] : null;
}
function $5b7ccabde48fae90$var$aggLast(params) {
    return params.values.length > 0 ? (0, $437b23f6a393c3bf$export$236389741107357f)(params.values) : null;
}
function $5b7ccabde48fae90$var$aggMin(params) {
    const { values: values } = params;
    let result = null;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if ((typeof value === "number" || typeof value === "bigint") && (result === null || result > value)) result = value;
    }
    return result;
}
function $5b7ccabde48fae90$var$aggMax(params) {
    const { values: values } = params;
    let result = null;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if ((typeof value === "number" || typeof value === "bigint") && (result === null || result < value)) result = value;
    }
    return result;
}
var $5b7ccabde48fae90$var$COUNT_PROTO = Object.freeze({
    // the grid by default uses toString to render values for an object, so this
    // is a trick to get the default cellRenderer to display the avg value
    toString: function() {
        return this.value.toString();
    },
    // used for sorting
    toNumber: function() {
        return this.value;
    }
});
function $5b7ccabde48fae90$var$aggCount(params) {
    const { values: values } = params;
    let count = 0;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        count += value != null && typeof value.value === "number" ? value.value : 1;
    }
    const existingAggData = params.rowNode?.aggData?.[params.column.getColId()];
    if (existingAggData && existingAggData.value === count) return existingAggData;
    const result = Object.create($5b7ccabde48fae90$var$COUNT_PROTO);
    result.value = count;
    return result;
}
var $5b7ccabde48fae90$var$AVERAGE_PROTO = Object.freeze({
    // the grid by default uses toString to render values for an object, so this
    // is a trick to get the default cellRenderer to display the avg value
    toString: function() {
        return typeof this.value === "number" || typeof this.value === "bigint" ? this.value.toString() : "";
    },
    // used for sorting
    toNumber: function() {
        return this.value;
    }
});
function $5b7ccabde48fae90$var$aggAvg(params) {
    const { values: values } = params;
    let sum = 0;
    let count = 0;
    for(let i = 0; i < values.length; i++){
        const currentValue = values[i];
        let valueToAdd = null;
        if (typeof currentValue === "number" || typeof currentValue === "bigint") {
            valueToAdd = currentValue;
            count++;
        } else if (currentValue != null && (typeof currentValue.value === "number" || typeof currentValue.value === "bigint") && typeof currentValue.count === "number") {
            valueToAdd = currentValue.value * (typeof currentValue.value === "number" ? currentValue.count : BigInt(currentValue.count));
            count += currentValue.count;
        }
        if (typeof valueToAdd === "number") sum += typeof sum === "number" ? valueToAdd : BigInt(valueToAdd);
        else if (typeof valueToAdd === "bigint") sum = (typeof sum === "bigint" ? sum : BigInt(sum)) + valueToAdd;
    }
    let value = null;
    if (count > 0) value = sum / (typeof sum === "number" ? count : BigInt(count));
    const existingAggData = params.rowNode?.aggData?.[params.column?.getColId()];
    if (existingAggData && existingAggData.count === count && existingAggData.value === value) return existingAggData;
    const result = Object.create($5b7ccabde48fae90$var$AVERAGE_PROTO);
    result.count = count;
    result.value = value;
    return result;
}
// packages/ag-grid-enterprise/src/aggregation/aggregationApi.ts
function $5b7ccabde48fae90$var$addAggFuncs(beans, aggFuncs) {
    if (beans.aggFuncSvc) beans.aggFuncSvc.addAggFuncs(aggFuncs);
}
function $5b7ccabde48fae90$var$clearAggFuncs(beans) {
    if (beans.aggFuncSvc) beans.aggFuncSvc.clear();
}
function $5b7ccabde48fae90$var$setColumnAggFunc(beans, key, aggFunc) {
    beans.valueColsSvc?.setColumnAggFunc?.(key, aggFunc, "api");
}
function $5b7ccabde48fae90$var$_aggregateValues(beans, values, aggFuncOrString, column, rowNode, pivotResultColumn) {
    const aggFunc = typeof aggFuncOrString === "string" ? beans.aggFuncSvc.getAggFunc(aggFuncOrString) : aggFuncOrString;
    if (typeof aggFunc !== "function") {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(109, {
            inputValue: aggFuncOrString.toString(),
            allSuggestions: beans.aggFuncSvc.getFuncNames(column)
        });
        return null;
    }
    const params = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(beans.gos, {
        values: values,
        column: column,
        colDef: column.colDef,
        pivotResultColumn: pivotResultColumn,
        rowNode: rowNode,
        // this is typed incorrectly. Within CSRM, this will always be defined. When called from integrated charts, this will never be defined.
        data: rowNode?.data
    });
    return aggFunc(params);
}
// packages/ag-grid-enterprise/src/aggregation/aggregationStage.ts
var $5b7ccabde48fae90$var$AggregationStage = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "aggStage";
        this.step = "aggregate";
        this.refreshProps = [
            "getGroupRowAgg",
            "alwaysAggregateAtRootLevel",
            "suppressAggFilteredOnly",
            "grandTotalRow"
        ];
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.pivotColsSvc = beans.pivotColsSvc;
        this.valueColsSvc = beans.valueColsSvc;
        this.pivotResultCols = beans.pivotResultCols;
        this.valueSvc = beans.valueSvc;
    }
    // it's possible to recompute the aggregate without doing the other parts
    // + api.refreshClientSideRowModel('aggregate')
    execute(changedPath) {
        const noValueColumns = !this.valueColsSvc?.columns?.length;
        const noUserAgg = !this.gos.getCallback("getGroupRowAgg");
        if (noValueColumns && noUserAgg && changedPath?.active) return;
        const aggDetails = this.createAggDetails(changedPath);
        this.recursivelyCreateAggData(aggDetails);
    }
    createAggDetails(changedPath) {
        const pivotActive = this.colModel.isPivotActive();
        const measureColumns = this.valueColsSvc?.columns;
        const pivotColumns = pivotActive && this.pivotColsSvc ? this.pivotColsSvc.columns : [];
        const aggDetails = {
            alwaysAggregateAtRootLevel: this.gos.get("alwaysAggregateAtRootLevel"),
            groupIncludeTotalFooter: !!(0, $437b23f6a393c3bf$export$c6fad27ed643a862)(this.gos),
            changedPath: changedPath,
            valueColumns: measureColumns ?? [],
            pivotColumns: pivotColumns,
            filteredOnly: !this.isSuppressAggFilteredOnly(),
            userAggFunc: this.gos.getCallback("getGroupRowAgg")
        };
        return aggDetails;
    }
    isSuppressAggFilteredOnly() {
        const isGroupAggFiltering = (0, $437b23f6a393c3bf$export$3708afee0330994)(this.gos) !== void 0;
        return isGroupAggFiltering || this.gos.get("suppressAggFilteredOnly");
    }
    recursivelyCreateAggData(aggDetails) {
        const callback = (rowNode)=>{
            const hasNoChildren = !rowNode.hasChildren();
            if (hasNoChildren) {
                if (rowNode.aggData) this.setAggData(rowNode, null);
                return;
            }
            const isRootNode = rowNode.level === -1;
            if (isRootNode && !aggDetails.groupIncludeTotalFooter) {
                const notPivoting = !this.colModel.isPivotMode();
                if (!aggDetails.alwaysAggregateAtRootLevel && notPivoting) {
                    this.setAggData(rowNode, null);
                    return;
                }
            }
            this.aggregateRowNode(rowNode, aggDetails);
        };
        aggDetails.changedPath.forEachChangedNodeDepthFirst(callback, true);
    }
    aggregateRowNode(rowNode, aggDetails) {
        const measureColumnsMissing = aggDetails.valueColumns.length === 0;
        const pivotColumnsMissing = aggDetails.pivotColumns.length === 0;
        let aggResult;
        if (aggDetails.userAggFunc) aggResult = aggDetails.userAggFunc({
            nodes: rowNode.childrenAfterFilter
        });
        else if (measureColumnsMissing) aggResult = null;
        else if (pivotColumnsMissing) aggResult = this.aggregateRowNodeUsingValuesOnly(rowNode, aggDetails);
        else aggResult = this.aggregateRowNodeUsingValuesAndPivot(rowNode);
        this.setAggData(rowNode, aggResult);
        if (rowNode.sibling) {
            this.setAggData(rowNode.sibling, aggResult);
            if (rowNode.sibling.pinnedSibling) this.setAggData(rowNode.sibling.pinnedSibling, aggResult);
        }
    }
    aggregateRowNodeUsingValuesAndPivot(rowNode) {
        const result = {};
        const secondaryColumns = this.pivotResultCols?.getPivotResultCols()?.list ?? [];
        let canSkipTotalColumns = true;
        const beans = this.beans;
        for(let i = 0; i < secondaryColumns.length; i++){
            const secondaryCol = secondaryColumns[i];
            const colDef = secondaryCol.getColDef();
            if (colDef.pivotTotalColumnIds != null) {
                canSkipTotalColumns = false;
                continue;
            }
            const keys = colDef.pivotKeys ?? [];
            let values;
            if (rowNode.leafGroup) values = this.getValuesFromMappedSet(rowNode.childrenMapped, keys, colDef.pivotValueColumn);
            else values = this.getValuesPivotNonLeaf(rowNode, colDef.colId);
            result[colDef.colId] = $5b7ccabde48fae90$var$_aggregateValues(beans, values, colDef.pivotValueColumn.getAggFunc(), colDef.pivotValueColumn, rowNode, secondaryCol);
        }
        if (!canSkipTotalColumns) for(let i = 0; i < secondaryColumns.length; i++){
            const secondaryCol = secondaryColumns[i];
            const colDef = secondaryCol.getColDef();
            if (!colDef.pivotTotalColumnIds?.length) continue;
            const aggResults = colDef.pivotTotalColumnIds.map((currentColId)=>result[currentColId]);
            result[colDef.colId] = $5b7ccabde48fae90$var$_aggregateValues(beans, aggResults, colDef.pivotValueColumn.getAggFunc(), colDef.pivotValueColumn, rowNode, secondaryCol);
        }
        return result;
    }
    aggregateRowNodeUsingValuesOnly(rowNode, aggDetails) {
        const result = {};
        const { changedPath: changedPath, valueColumns: valueColumns, filteredOnly: filteredOnly } = aggDetails;
        const changedValueColumns = changedPath.active ? changedPath.getValueColumnsForNode(rowNode, valueColumns) : valueColumns;
        const notChangedValueColumns = changedPath.active ? changedPath.getNotValueColumnsForNode(rowNode, valueColumns) : null;
        const values2d = this.getValuesNormal(rowNode, changedValueColumns, filteredOnly);
        const oldValues = rowNode.aggData;
        const beans = this.beans;
        changedValueColumns.forEach((valueColumn, index)=>{
            result[valueColumn.getId()] = $5b7ccabde48fae90$var$_aggregateValues(beans, values2d[index], valueColumn.getAggFunc(), valueColumn, rowNode);
        });
        if (notChangedValueColumns && oldValues) for (const valueColumn of notChangedValueColumns)result[valueColumn.getId()] = oldValues[valueColumn.getId()];
        return result;
    }
    getValuesPivotNonLeaf(rowNode, colId) {
        return rowNode.childrenAfterFilter.map((childNode)=>childNode.aggData[colId]);
    }
    getValuesFromMappedSet(mappedSet, keys, valueColumn) {
        let mapPointer = mappedSet;
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            mapPointer = mapPointer ? mapPointer[key] : null;
        }
        if (!mapPointer) return [];
        return mapPointer.map((rowNode)=>this.valueSvc.getValue(valueColumn, rowNode));
    }
    getValuesNormal(rowNode, valueColumns, filteredOnly) {
        const values = [];
        valueColumns.forEach(()=>values.push([]));
        const valueColumnCount = valueColumns.length;
        const nodeList = filteredOnly ? rowNode.childrenAfterFilter : rowNode.childrenAfterGroup;
        const rowCount = nodeList.length;
        for(let i = 0; i < rowCount; i++){
            const childNode = nodeList[i];
            for(let j = 0; j < valueColumnCount; j++){
                const valueColumn = valueColumns[j];
                const value = this.valueSvc.getValue(valueColumn, childNode);
                values[j].push(value);
            }
        }
        return values;
    }
    setAggData(rowNode, newAggData) {
        const oldAggData = rowNode.aggData;
        rowNode.aggData = newAggData;
        if (rowNode.__localEventService) {
            const eventFunc = (colId)=>{
                const value = rowNode.aggData ? rowNode.aggData[colId] : void 0;
                const oldValue = oldAggData ? oldAggData[colId] : void 0;
                if (value === oldValue) return;
                const column = this.colModel.getColById(colId);
                if (!column) return;
                rowNode.dispatchCellChangedEvent(column, value, oldValue);
            };
            if (oldAggData) for (const key of Object.keys(oldAggData))eventFunc(key);
            if (newAggData) {
                for (const key of Object.keys(newAggData))if (!oldAggData || !(key in oldAggData)) eventFunc(key);
            }
        }
    }
};
var $5b7ccabde48fae90$var$FilterAggregatesStage = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "filterAggStage";
        this.step = "filter_aggregates";
        this.refreshProps = [];
    }
    wireBeans(beans) {
        this.filterManager = beans.filterManager;
    }
    execute(changedPath) {
        const isPivotMode2 = this.beans.colModel.isPivotMode();
        const isAggFilterActive = this.filterManager?.isAggregateFilterPresent() || this.filterManager?.isAggregateQuickFilterPresent();
        const defaultPrimaryColumnPredicate = (params)=>!params.node.group;
        const defaultSecondaryColumnPredicate = (params)=>params.node.leafGroup;
        const applyFilterToNode = (0, $437b23f6a393c3bf$export$3708afee0330994)(this.gos) || (isPivotMode2 ? defaultSecondaryColumnPredicate : defaultPrimaryColumnPredicate);
        const preserveChildren = (node, recursive = false)=>{
            if (node.childrenAfterFilter) {
                node.childrenAfterAggFilter = node.childrenAfterFilter;
                if (recursive) for (const child of node.childrenAfterAggFilter)preserveChildren(child, recursive);
                this.setAllChildrenCount(node);
            }
            if (node.sibling) node.sibling.childrenAfterAggFilter = node.childrenAfterAggFilter;
        };
        const filterChildren = (node)=>{
            node.childrenAfterAggFilter = node.childrenAfterFilter?.filter((child)=>{
                const shouldFilterRow = applyFilterToNode({
                    node: child
                });
                if (shouldFilterRow) {
                    const doesNodePassFilter = this.filterManager.doesRowPassAggregateFilters({
                        rowNode: child
                    });
                    if (doesNodePassFilter) {
                        preserveChildren(child, true);
                        return true;
                    }
                }
                const hasChildPassed = child.childrenAfterAggFilter?.length;
                return hasChildPassed;
            }) || null;
            this.setAllChildrenCount(node);
            if (node.sibling) node.sibling.childrenAfterAggFilter = node.childrenAfterAggFilter;
        };
        changedPath.forEachChangedNodeDepthFirst(isAggFilterActive ? filterChildren : preserveChildren, true);
    }
    /** for tree data, we include all children, groups and leafs */ setAllChildrenCountTreeData(rowNode) {
        const childrenAfterAggFilter = rowNode.childrenAfterAggFilter;
        let allChildrenCount = 0;
        if (childrenAfterAggFilter) {
            const length = childrenAfterAggFilter.length;
            allChildrenCount = length;
            for(let i = 0; i < length; ++i)allChildrenCount += childrenAfterAggFilter[i].allChildrenCount ?? 0;
        }
        rowNode.setAllChildrenCount(// Maintain the historical behaviour:
        // - allChildrenCount is 0 in the root if there are no children
        // - allChildrenCount is null in any non-root row if there are no children
        allChildrenCount === 0 && rowNode.level >= 0 ? null : allChildrenCount);
    }
    /* for grid data, we only count the leafs */ setAllChildrenCountGridGrouping(rowNode) {
        let allChildrenCount = 0;
        rowNode.childrenAfterAggFilter.forEach((child)=>{
            if (child.group) allChildrenCount += child.allChildrenCount;
            else allChildrenCount++;
        });
        rowNode.setAllChildrenCount(allChildrenCount);
    }
    setAllChildrenCount(rowNode) {
        if (!rowNode.hasChildren()) {
            rowNode.setAllChildrenCount(null);
            return;
        }
        if (this.gos.get("treeData")) this.setAllChildrenCountTreeData(rowNode);
        else this.setAllChildrenCountGridGrouping(rowNode);
    }
};
function $5b7ccabde48fae90$var$_createRowNodeFooter(rowNode, beans) {
    if (rowNode.sibling) return;
    const footerNode = (0, $437b23f6a393c3bf$export$48fabbbfcde9fe36)(rowNode, beans);
    footerNode.footer = true;
    footerNode.setRowTop(null);
    footerNode.setRowIndex(null);
    footerNode.oldRowTop = null;
    footerNode.id = "rowGroupFooter_" + rowNode.id;
    footerNode.sibling = rowNode;
    rowNode.sibling = footerNode;
}
function $5b7ccabde48fae90$var$_destroyRowNodeFooter(rowNode) {
    const sibling = rowNode.sibling;
    if (!sibling) return;
    sibling._destroy(false);
    rowNode.sibling = void 0;
    sibling.sibling = void 0;
}
// packages/ag-grid-enterprise/src/aggregation/footerService.ts
var $5b7ccabde48fae90$var$FooterService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "footerSvc";
    }
    addTotalRows(startIndex, node, callback, includeFooterNodes, isRootNode, position) {
        let index = startIndex;
        if (isRootNode) {
            const grandTotal = includeFooterNodes && (0, $437b23f6a393c3bf$export$c6fad27ed643a862)(this.gos);
            if ($5b7ccabde48fae90$var$_positionMatchesGrandTotalRow(position, grandTotal)) {
                $5b7ccabde48fae90$var$_createRowNodeFooter(node, this.beans);
                callback(node.sibling, index++);
            }
            return index;
        }
        const isGroupIncludeFooter = (0, $437b23f6a393c3bf$export$713d6cabeaa7f2a5)(this.gos);
        const groupTotal = includeFooterNodes && isGroupIncludeFooter({
            node: node
        });
        if (groupTotal === position) {
            $5b7ccabde48fae90$var$_createRowNodeFooter(node, this.beans);
            callback(node.sibling, index++);
        }
        return index;
    }
    getTopDisplayIndex(rowsToDisplay, topLevelIndex, childrenAfterSort, getDefaultIndex) {
        let adjustedIndex = topLevelIndex;
        if (rowsToDisplay[0].footer) {
            if (topLevelIndex === 0) return 0;
            adjustedIndex -= 1;
        }
        const lastRow = rowsToDisplay[rowsToDisplay.length - 1];
        const indexOutsideGroupBounds = adjustedIndex >= childrenAfterSort.length;
        if (lastRow.footer && indexOutsideGroupBounds) return lastRow.rowIndex;
        return getDefaultIndex(adjustedIndex);
    }
    doesCellShowTotalPrefix(node, col) {
        if (!node.footer || !col?.getColDef().showRowGroup) return false;
        if (this.gos.get("treeData")) return true;
        if (node.level === -1) return this.beans.showRowGroupCols?.columns[0] === col;
        return !!node.rowGroupColumn && col?.isRowGroupDisplayed(node.rowGroupColumn.getId());
    }
    applyTotalPrefix(value, formattedValue, node, column) {
        const totalValueGetter = column.getColDef().cellRendererParams?.totalValueGetter;
        if (totalValueGetter) {
            const valueGetterParams = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
                column: column,
                node: node,
                value: value,
                formattedValue: formattedValue
            });
            const getterType = typeof totalValueGetter;
            if (getterType === "function") return totalValueGetter(valueGetterParams);
            if (typeof totalValueGetter === "string") return this.beans.expressionSvc?.evaluate(totalValueGetter, valueGetterParams);
            (0, $437b23f6a393c3bf$export$545083624300f13d)(179);
        }
        if (node.level === -1) return this.getLocaleTextFunc()("footerTotal", "Total") + " ";
        return this.getTotalValue(formattedValue ?? value) ?? "";
    }
    getTotalValue(value) {
        return this.getLocaleTextFunc()("footerTotal", "Total") + " " + (value ?? "");
    }
};
function $5b7ccabde48fae90$var$_positionMatchesGrandTotalRow(position, grandTotaRow) {
    switch(grandTotaRow){
        case "top":
        case "pinnedTop":
            return position === "top";
        case "bottom":
        case "pinnedBottom":
            return position === "bottom";
        default:
            return false;
    }
}
var $5b7ccabde48fae90$var$ValueColsSvc = class extends (0, $437b23f6a393c3bf$export$3687f0f5678a5df3) {
    constructor(){
        super(...arguments);
        this.beanName = "valueColsSvc";
        this.eventName = "columnValueChanged";
        this.columnProcessors = {
            set: (column, added, source)=>this.setValueActive(added, column, source),
            add: (column, added, source)=>this.setValueActive(true, column, source),
            remove: (column, added, source)=>this.setValueActive(false, column, source)
        };
        this.columnExtractors = {
            setFlagFunc: (col, flag, source)=>this.setColValueActive(col, flag, source),
            getIndexFunc: ()=>void 0,
            getInitialIndexFunc: ()=>void 0,
            getValueFunc: (colDef)=>{
                const aggFunc = colDef.aggFunc;
                if (aggFunc === null || aggFunc === "") return null;
                if (aggFunc === void 0) return;
                return !!aggFunc;
            },
            getInitialValueFunc: (colDef)=>{
                return colDef.initialAggFunc != null && colDef.initialAggFunc != "";
            }
        };
        this.modifyColumnsNoEventsCallbacks = {
            addCol: (column)=>this.columns.push(column),
            removeCol: (column)=>(0, $437b23f6a393c3bf$export$83a881c8b5120679)(this.columns, column)
        };
    }
    extractCols(source, oldProvidedCols) {
        this.columns = super.extractCols(source, oldProvidedCols);
        for (const col of this.columns){
            const colDef = col.getColDef();
            if (colDef.aggFunc != null && colDef.aggFunc != "") this.setColAggFunc(col, colDef.aggFunc);
            else if (!col.getAggFunc()) this.setColAggFunc(col, colDef.initialAggFunc);
        }
        return this.columns;
    }
    setColumnAggFunc(key, aggFunc, source) {
        if (!key) return;
        const column = this.colModel.getColDefCol(key);
        if (!column) return;
        this.setColAggFunc(column, aggFunc);
        this.dispatchColumnChangedEvent(this.eventSvc, this.eventName, [
            column
        ], source);
    }
    syncColumnWithState(column, source, getValue) {
        const aggFunc = getValue("aggFunc").value1;
        if (aggFunc !== void 0) {
            if (typeof aggFunc === "string") {
                this.setColAggFunc(column, aggFunc);
                if (!column.isValueActive()) {
                    this.setColValueActive(column, true, source);
                    this.modifyColumnsNoEventsCallbacks.addCol(column);
                }
            } else {
                if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(aggFunc)) (0, $437b23f6a393c3bf$export$545083624300f13d)(33);
                if (column.isValueActive()) {
                    this.setColValueActive(column, false, source);
                    this.modifyColumnsNoEventsCallbacks.removeCol(column);
                }
            }
        }
    }
    setValueActive(active, column, source) {
        if (active === column.isValueActive()) return;
        this.setColValueActive(column, active, source);
        if (active && !column.getAggFunc() && this.aggFuncSvc) {
            const initialAggFunc = this.aggFuncSvc.getDefaultAggFunc(column);
            this.setColAggFunc(column, initialAggFunc);
        }
    }
    setColAggFunc(column, aggFunc) {
        column.aggFunc = aggFunc;
        column.dispatchStateUpdatedEvent("aggFunc");
    }
    setColValueActive(column, value, source) {
        if (column.aggregationActive !== value) {
            column.aggregationActive = value;
            column.dispatchColEvent("columnValueChanged", source);
        }
    }
};
// packages/ag-grid-enterprise/src/aggregation/aggregationModule.ts
var $5b7ccabde48fae90$var$SharedAggregationModule = {
    moduleName: "SharedAggregation",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$AggFuncService,
        $5b7ccabde48fae90$var$AggColumnNameService,
        $5b7ccabde48fae90$var$FooterService,
        $5b7ccabde48fae90$var$ValueColsSvc
    ],
    apiFunctions: {
        addAggFuncs: $5b7ccabde48fae90$var$addAggFuncs,
        clearAggFuncs: $5b7ccabde48fae90$var$clearAggFuncs,
        setColumnAggFunc: $5b7ccabde48fae90$var$setColumnAggFunc
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
var $5b7ccabde48fae90$export$b53def5458540436 = {
    moduleName: "Aggregation",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$AggregationStage,
        $5b7ccabde48fae90$var$FilterAggregatesStage
    ],
    rowModels: [
        "clientSide"
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$SharedAggregationModule
    ]
};
var $5b7ccabde48fae90$var$getDate = ({ valueSvc: valueSvc, dataTypeSvc: dataTypeSvc }, sourceCol, node)=>{
    const innerValue = valueSvc.getValue(sourceCol, node);
    let date = null;
    if (innerValue instanceof Date) date = innerValue;
    else if (typeof innerValue === "string") {
        const parseDate = dataTypeSvc?.getDateParserFunction(sourceCol) ?? (0, $437b23f6a393c3bf$export$26ded2d88c01b527);
        date = parseDate(innerValue) ?? null;
    }
    return date;
};
var $5b7ccabde48fae90$var$getDatePartValueGetter = (beans, col, index, map)=>(params)=>{
        const date = $5b7ccabde48fae90$var$getDate(beans, col, params.node);
        const parts = (0, $437b23f6a393c3bf$export$bb4eb333cc2b3e25)(date);
        if (!parts) return null;
        return map?.(parts[index]) ?? parts[index];
    };
var $5b7ccabde48fae90$var$getHeaderValueGetter = ({ colNames: colNames }, col, part)=>(params)=>{
        const sourceName = colNames.getDisplayNameForColumn(col, params.location);
        if (sourceName) return `${sourceName} (${part})`;
        return "";
    };
var $5b7ccabde48fae90$var$MONTH_TO_LOCALE_KEY = Object.fromEntries((0, $437b23f6a393c3bf$export$ae5a33daf12ff29).map((m)=>[
        m,
        m.toLowerCase()
    ]));
var $5b7ccabde48fae90$var$numericalMonthToNamedMonth = (monthStr)=>{
    const month = (0, $437b23f6a393c3bf$export$ae5a33daf12ff29)[Number.parseInt(monthStr, 10) - 1] ?? monthStr;
    const localeKey = $5b7ccabde48fae90$var$MONTH_TO_LOCALE_KEY[month] ?? monthStr;
    return {
        month: month,
        localeKey: localeKey
    };
};
function $5b7ccabde48fae90$var$_getGroupHierarchy(colDef) {
    return colDef.groupHierarchy ?? colDef.rowGroupingHierarchy;
}
// packages/ag-grid-enterprise/src/groupHierarchy/groupHierarchyColService.ts
var $5b7ccabde48fae90$var$GroupHierarchyColService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "groupHierarchyColSvc";
        this.columns = null;
        /** Map from primary column to virtual (i.e. generated) columns */ this.sourceColumnMap = /* @__PURE__ */ new WeakMap();
        /** Map from virtual column to associated primary column. Inverse of `sourceColumnMap` */ this.inverseColumnMap = /* @__PURE__ */ new WeakMap();
    }
    addColumns(cols) {
        const groupHierarchyCols = this.columns;
        if (groupHierarchyCols == null) return;
        cols.list = groupHierarchyCols.list.filter((col)=>!cols.list.some((c)=>c.getColId() === col.getColId())).concat(cols.list);
        cols.tree = groupHierarchyCols.tree.filter((col)=>!cols.tree.some((c)=>c.getId() === col.getId())).concat(cols.tree);
        (0, $437b23f6a393c3bf$export$c82fd63ff1738bed)(cols);
    }
    createColumns(cols) {
        const newSourceColumnMap = /* @__PURE__ */ new WeakMap();
        const newInverseColumnMap = /* @__PURE__ */ new WeakMap();
        const list = this.createGroupHierarchyColumns(cols, newSourceColumnMap, newInverseColumnMap);
        const areSame = (0, $437b23f6a393c3bf$export$f56e341a1fe35ed4)(list, this.columns?.list ?? []);
        if (areSame) return;
        (0, $437b23f6a393c3bf$export$dbaaa57234b60d8f)(this.beans, this.columns?.tree);
        this.columns = null;
        const { colGroupSvc: colGroupSvc } = this.beans;
        const treeDepth = colGroupSvc?.findDepth(cols.tree) ?? 0;
        const tree = colGroupSvc?.balanceTreeForAutoCols(list, treeDepth) ?? [];
        this.columns = {
            list: list,
            tree: tree,
            treeDepth: treeDepth,
            map: {}
        };
        this.sourceColumnMap = newSourceColumnMap;
        this.inverseColumnMap = newInverseColumnMap;
    }
    updateColumns(_event) {}
    getColumn(key) {
        return this.columns?.list.find((col)=>(0, $437b23f6a393c3bf$export$f5687d41c39fa1b3)(col, key)) ?? null;
    }
    getColumns() {
        return this.columns?.list ?? null;
    }
    expandColumnInto(target, col) {
        const expanded = this.getVirtualColumnsForColumn(col).concat(col);
        for (const expandedCol of expanded)if (!target.some((_c)=>(0, $437b23f6a393c3bf$export$f5687d41c39fa1b3)(_c, expandedCol) || _c.getColId() === expandedCol.getColId())) target.push(expandedCol);
    }
    compareVirtualColumns(colA, colB) {
        const sourceA = this.inverseColumnMap.get(colA);
        const sourceB = this.inverseColumnMap.get(colB);
        if (sourceA && sourceA === sourceB) {
            const hierarchyCols = this.sourceColumnMap.get(sourceA) ?? [];
            return hierarchyCols?.indexOf(colA) - hierarchyCols?.indexOf(colB);
        }
        if (this.sourceColumnMap.get(colA)?.includes(colB)) return 1;
        if (this.sourceColumnMap.get(colB)?.includes(colA)) return -1;
        return null;
    }
    insertVirtualColumnsForCol(columns, col) {
        const hierarchyCols = this.getVirtualColumnsForColumn(col);
        if (!hierarchyCols) return [];
        let idxCol = columns.indexOf(col);
        if (idxCol < 0) idxCol = columns.length - 1;
        (0, $437b23f6a393c3bf$export$d938638f12233be7)(columns, hierarchyCols);
        columns.splice(idxCol, 0, ...hierarchyCols);
        return hierarchyCols;
    }
    getVirtualColumnsForColumn(col) {
        if (this.isGroupHierarchyColsEnabledForCol(col)) return this.sourceColumnMap.get(col) ?? [];
        return [];
    }
    isGroupHierarchyColsEnabled(cols) {
        return cols.list.some((col)=>this.isGroupHierarchyColsEnabledForCol(col));
    }
    isGroupHierarchyColsEnabledForCol(col) {
        const def = col.getColDef();
        const groupHierarchy = $5b7ccabde48fae90$var$_getGroupHierarchy(def);
        return !!(groupHierarchy && (def.rowGroup || def.enableRowGroup || def.rowGroupIndex != null || def.pivot || def.enablePivot || def.pivotIndex != null));
    }
    createGroupHierarchyColDefs(sourceCol) {
        const colDefs = [];
        const sourceColDef = sourceCol.getColDef();
        const groupHierarchy = $5b7ccabde48fae90$var$_getGroupHierarchy(sourceColDef);
        if (!groupHierarchy) return colDefs;
        if (!this.isGroupHierarchyColsEnabledForCol(sourceCol)) return colDefs;
        for (const part of groupHierarchy){
            let colDef = null;
            if (typeof part === "string") colDef = this.createColDefForPart(part, sourceCol, sourceColDef);
            else colDef = part;
            if (colDef) colDefs.push(colDef);
        }
        return colDefs;
    }
    createGroupHierarchyColumns(cols, sourceColMap, inverseColMap) {
        if (!this.isGroupHierarchyColsEnabled(cols)) return [];
        const newCols = [];
        for (const col of cols.list)for (const colDef of this.createGroupHierarchyColDefs(col)){
            const colId = colDef.colId;
            this.gos.validateColDef(colDef, colId, true);
            const newCol = new (0, $437b23f6a393c3bf$export$a8da3e2b83e5ddf2)(colDef, null, colId, true);
            this.createBean(newCol);
            newCols.push(newCol);
            $5b7ccabde48fae90$var$updateMap(sourceColMap, col, newCol);
            inverseColMap.set(newCol, col);
        }
        return newCols;
    }
    createColDefForPart(part, sourceCol, sourceColDef) {
        const { beans: beans, gos: gos } = this;
        const colId = `${(0, $437b23f6a393c3bf$export$2c8ac3f8e81f483f)}-${sourceCol.getColId()}-${part}`;
        const defaults = {
            enableRowGroup: sourceColDef.enableRowGroup,
            rowGroup: sourceColDef.rowGroup,
            enablePivot: sourceColDef.enablePivot,
            hide: true,
            editable: false
        };
        const groupHierarchyConfig = gos.get("groupHierarchyConfig") ?? {};
        if (part in groupHierarchyConfig) {
            const colDef = {
                ...defaults,
                ...groupHierarchyConfig[part]
            };
            colDef.colId ?? (colDef.colId = colId);
            return (0, $437b23f6a393c3bf$export$310bdd432cb2279e)(beans, colDef, colDef.colId, true);
        }
        const base = (0, $437b23f6a393c3bf$export$310bdd432cb2279e)(beans, {
            colId: colId,
            ...defaults
        }, colId, true);
        const translate = this.getLocaleTextFunc();
        const translatePart = (part2, fallback)=>translate?.(part2, fallback) ?? fallback;
        switch(part){
            case "year":
                return {
                    ...base,
                    headerValueGetter: $5b7ccabde48fae90$var$getHeaderValueGetter(beans, sourceCol, translatePart(part, "Year")),
                    valueGetter: $5b7ccabde48fae90$var$getDatePartValueGetter(beans, sourceCol, 0)
                };
            case "quarter":
                return {
                    ...base,
                    headerValueGetter: $5b7ccabde48fae90$var$getHeaderValueGetter(beans, sourceCol, translatePart(part, "Quarter")),
                    valueGetter: $5b7ccabde48fae90$var$getDatePartValueGetter(beans, sourceCol, 1, (month)=>(Math.floor(Number(month) / 4) + 1).toString())
                };
            case "month":
                return {
                    ...base,
                    headerValueGetter: $5b7ccabde48fae90$var$getHeaderValueGetter(beans, sourceCol, translatePart(part, "Month")),
                    valueGetter: $5b7ccabde48fae90$var$getDatePartValueGetter(beans, sourceCol, 1)
                };
            case "formattedMonth":
                return {
                    ...base,
                    headerValueGetter: $5b7ccabde48fae90$var$getHeaderValueGetter(beans, sourceCol, translatePart("month", "Month")),
                    valueGetter: $5b7ccabde48fae90$var$getDatePartValueGetter(beans, sourceCol, 1, (month)=>{
                        const nm = $5b7ccabde48fae90$var$numericalMonthToNamedMonth(month);
                        return translatePart(nm.localeKey, nm.month);
                    })
                };
            case "day":
                return {
                    ...base,
                    headerValueGetter: $5b7ccabde48fae90$var$getHeaderValueGetter(beans, sourceCol, translatePart(part, "Day")),
                    valueGetter: $5b7ccabde48fae90$var$getDatePartValueGetter(beans, sourceCol, 2)
                };
            case "hour":
                return {
                    ...base,
                    headerValueGetter: $5b7ccabde48fae90$var$getHeaderValueGetter(beans, sourceCol, translatePart(part, "Hour")),
                    valueGetter: $5b7ccabde48fae90$var$getDatePartValueGetter(beans, sourceCol, 3)
                };
            case "minute":
                return {
                    ...base,
                    headerValueGetter: $5b7ccabde48fae90$var$getHeaderValueGetter(beans, sourceCol, translatePart(part, "Minute")),
                    valueGetter: $5b7ccabde48fae90$var$getDatePartValueGetter(beans, sourceCol, 4)
                };
            case "second":
                return {
                    ...base,
                    headerValueGetter: $5b7ccabde48fae90$var$getHeaderValueGetter(beans, sourceCol, translatePart(part, "Second")),
                    valueGetter: $5b7ccabde48fae90$var$getDatePartValueGetter(beans, sourceCol, 5)
                };
            default:
                return null;
        }
    }
};
function $5b7ccabde48fae90$var$updateMap(wm, key, value) {
    const existing = wm.get(key);
    wm.set(key, (existing ?? []).concat(value));
}
// packages/ag-grid-enterprise/src/groupHierarchy/groupHierarchyModule.ts
var $5b7ccabde48fae90$var$GroupHierarchyModule = {
    moduleName: "GroupHierarchy",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$GroupHierarchyColService
    ]
};
var $5b7ccabde48fae90$var$PivotColsSvc = class extends (0, $437b23f6a393c3bf$export$3687f0f5678a5df3) {
    constructor(){
        super(...arguments);
        this.beanName = "pivotColsSvc";
        this.eventName = "columnPivotChanged";
        this.columnProcessors = {
            set: (column, added, source)=>this.setColPivotActive(column, added, source),
            add: (column, added, source)=>this.setColPivotActive(column, true, source),
            remove: (column, added, source)=>this.setColPivotActive(column, false, source)
        };
        this.columnOrdering = {
            enableProp: "pivot",
            initialEnableProp: "initialPivot",
            indexProp: "pivotIndex",
            initialIndexProp: "initialPivotIndex"
        };
        this.columnExtractors = {
            setFlagFunc: (col, flag, source)=>this.setColPivotActive(col, flag, source),
            getIndexFunc: (colDef)=>colDef.pivotIndex,
            getInitialIndexFunc: (colDef)=>colDef.initialPivotIndex,
            getValueFunc: (colDef)=>colDef.pivot,
            getInitialValueFunc: (colDef)=>colDef.initialPivot
        };
        this.modifyColumnsNoEventsCallbacks = {
            addCol: (column)=>{
                if (!this.columns.includes(column)) this.columns.push(column);
            },
            removeCol: (column)=>(0, $437b23f6a393c3bf$export$83a881c8b5120679)(this.columns, column)
        };
    }
    syncColumnWithState(column, source, getValue, rowIndex) {
        const { value1: pivot, value2: pivotIndex } = getValue("pivot", "pivotIndex");
        if (pivot !== void 0 || pivotIndex !== void 0) {
            if (typeof pivotIndex === "number" || pivot) {
                if (!column.isPivotActive()) {
                    this.setColPivotActive(column, true, source);
                    this.modifyColumnsNoEventsCallbacks.addCol(column);
                }
                if (rowIndex && typeof pivotIndex === "number") rowIndex[column.getId()] = pivotIndex;
            } else if (column.isPivotActive()) {
                this.setColPivotActive(column, false, source);
                this.modifyColumnsNoEventsCallbacks.removeCol(column);
            }
        }
    }
    setColPivotActive(column, pivot, source) {
        if (column.pivotActive !== pivot) {
            column.pivotActive = pivot;
            if (pivot) {
                const addedCols = this.beans.groupHierarchyColSvc?.insertVirtualColumnsForCol(this.columns, column);
                addedCols?.forEach((c)=>this.setColPivotActive(c, pivot, source));
            }
            column.dispatchColEvent("columnPivotChanged", source);
        }
        column.dispatchStateUpdatedEvent("pivot");
    }
};
var $5b7ccabde48fae90$var$RowGroupColsSvc = class extends (0, $437b23f6a393c3bf$export$3687f0f5678a5df3) {
    constructor(){
        super(...arguments);
        this.beanName = "rowGroupColsSvc";
        this.eventName = "columnRowGroupChanged";
        this.columnProcessors = {
            set: (column, added, source)=>this.setActive(added, column, source),
            add: (column, added, source)=>this.setActive(true, column, source),
            remove: (column, added, source)=>this.setActive(false, column, source)
        };
        this.columnOrdering = {
            enableProp: "rowGroup",
            initialEnableProp: "initialRowGroup",
            indexProp: "rowGroupIndex",
            initialIndexProp: "initialRowGroupIndex"
        };
        this.columnExtractors = {
            setFlagFunc: (col, flag, source)=>this.setColRowGroupActive(col, flag, source),
            getIndexFunc: (colDef)=>colDef.rowGroupIndex,
            getInitialIndexFunc: (colDef)=>colDef.initialRowGroupIndex,
            getValueFunc: (colDef)=>colDef.rowGroup,
            getInitialValueFunc: (colDef)=>colDef.initialRowGroup
        };
        this.modifyColumnsNoEventsCallbacks = {
            addCol: (column)=>{
                if (!this.columns.includes(column)) this.columns.push(column);
            },
            removeCol: (column)=>(0, $437b23f6a393c3bf$export$83a881c8b5120679)(this.columns, column)
        };
    }
    moveColumn(fromIndex, toIndex, source) {
        if (this.columns.length === 0) return;
        const column = this.columns[fromIndex];
        const impactedColumns = this.columns.slice(fromIndex, toIndex);
        this.columns.splice(fromIndex, 1);
        this.columns.splice(toIndex, 0, column);
        this.updateIndexMap();
        this.eventSvc.dispatchEvent({
            type: this.eventName,
            columns: impactedColumns,
            column: impactedColumns.length === 1 ? impactedColumns[0] : null,
            source: source
        });
    }
    syncColumnWithState(column, source, getValue, rowIndex) {
        const { value1: rowGroup, value2: rowGroupIndex } = getValue("rowGroup", "rowGroupIndex");
        if (rowGroup !== void 0 || rowGroupIndex !== void 0) {
            if (typeof rowGroupIndex === "number" || rowGroup) {
                if (!column.isRowGroupActive()) {
                    this.setColRowGroupActive(column, true, source);
                    this.modifyColumnsNoEventsCallbacks.addCol(column);
                }
                if (rowIndex && typeof rowGroupIndex === "number") rowIndex[column.getId()] = rowGroupIndex;
            } else if (column.isRowGroupActive()) {
                this.setColRowGroupActive(column, false, source);
                this.modifyColumnsNoEventsCallbacks.removeCol(column);
            }
        }
    }
    setActive(active, column, source) {
        if (active === column.isRowGroupActive()) return;
        this.setColRowGroupActive(column, active, source);
        const isGroupHierarchyCol = this.beans.groupHierarchyColSvc?.getColumn(column);
        if ((0, $437b23f6a393c3bf$export$d80073cdfb810fa8)(this.gos, active) && !isGroupHierarchyCol) this.colModel.setColsVisible([
            column
        ], !active, source);
    }
    setColRowGroupActive(column, rowGroup, source) {
        if (column.rowGroupActive !== rowGroup) {
            column.rowGroupActive = rowGroup;
            if (rowGroup) {
                const addedCols = this.beans.groupHierarchyColSvc?.insertVirtualColumnsForCol(this.columns, column);
                addedCols?.forEach((c)=>this.setColRowGroupActive(c, rowGroup, source));
            }
            column.dispatchColEvent("columnRowGroupChanged", source);
        }
        column.dispatchStateUpdatedEvent("rowGroup");
    }
};
var $5b7ccabde48fae90$var$AutoColService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "autoColSvc";
    }
    postConstruct() {
        this.addManagedPropertyListener("autoGroupColumnDef", this.updateColumns.bind(this));
    }
    addColumns(cols) {
        if (this.columns == null) return;
        cols.list = this.columns.list.concat(cols.list);
        cols.tree = this.columns.tree.concat(cols.tree);
        (0, $437b23f6a393c3bf$export$c82fd63ff1738bed)(cols);
    }
    createColumns(cols, updateOrders, source) {
        const beans = this.beans;
        const { colModel: colModel, gos: gos, rowGroupColsSvc: rowGroupColsSvc, colGroupSvc: colGroupSvc } = beans;
        const isPivotMode2 = colModel.isPivotMode();
        const groupFullWidthRow = (0, $437b23f6a393c3bf$export$b911c5b172d227b4)(gos, isPivotMode2);
        const suppressAutoColumn = isPivotMode2 ? gos.get("pivotSuppressAutoColumn") : this.isSuppressAutoCol();
        const rowGroupCols = rowGroupColsSvc?.columns;
        const groupingActive = rowGroupCols && rowGroupCols.length > 0 || gos.get("treeData");
        const noAutoCols = !groupingActive || suppressAutoColumn || groupFullWidthRow;
        const destroyPrevious = ()=>{
            if (this.columns) {
                (0, $437b23f6a393c3bf$export$dbaaa57234b60d8f)(beans, this.columns.tree);
                this.columns = null;
            }
        };
        if (noAutoCols) {
            destroyPrevious();
            return;
        }
        const list = this.generateAutoCols(rowGroupCols);
        const autoColsSame = (0, $437b23f6a393c3bf$export$f56e341a1fe35ed4)(list, this.columns?.list || null);
        const newTreeDepth = cols.treeDepth;
        const oldTreeDepth = this.columns ? this.columns.treeDepth : -1;
        const treeDepthSame = oldTreeDepth == newTreeDepth;
        if (autoColsSame && treeDepthSame) {
            const colsMap = new Map(list.map((col)=>[
                    col.getId(),
                    col
                ]));
            for (const col of this.columns?.list ?? []){
                const newDef = colsMap.get(col.getId());
                if (newDef) col.setColDef(newDef.getColDef(), null, source);
            }
            return;
        }
        destroyPrevious();
        const treeDepth = colGroupSvc?.findDepth(cols.tree) ?? 0;
        const tree = colGroupSvc?.balanceTreeForAutoCols(list, treeDepth) ?? [];
        this.columns = {
            list: list,
            tree: tree,
            treeDepth: treeDepth,
            map: {}
        };
        const putAutoColsFirstInList = (cols2)=>{
            if (!cols2) return null;
            const colsFiltered = cols2.filter((col)=>!(0, $437b23f6a393c3bf$export$61b34611dc010a97)(col));
            return [
                ...list,
                ...colsFiltered
            ];
        };
        updateOrders(putAutoColsFirstInList);
    }
    updateColumns(event) {
        const source = (0, $437b23f6a393c3bf$export$eb2a92b6162267d1)(event.source);
        this.columns?.list.forEach((col, index)=>this.updateOneAutoCol(col, index, source));
    }
    getColumn(key) {
        return this.columns?.list.find((groupCol)=>(0, $437b23f6a393c3bf$export$f5687d41c39fa1b3)(groupCol, key)) ?? null;
    }
    getColumns() {
        return this.columns?.list ?? null;
    }
    generateAutoCols(rowGroupCols = []) {
        const autoCols = [];
        const { gos: gos } = this;
        const doingTreeData = gos.get("treeData");
        let doingMultiAutoColumn = (0, $437b23f6a393c3bf$export$7122eb216a66bef2)(gos);
        if (doingTreeData && doingMultiAutoColumn) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(182);
            doingMultiAutoColumn = false;
        }
        if (doingMultiAutoColumn) rowGroupCols.forEach((rowGroupCol, index)=>{
            autoCols.push(this.createOneAutoCol(rowGroupCol, index));
        });
        else autoCols.push(this.createOneAutoCol());
        return autoCols;
    }
    isSuppressAutoCol() {
        const gos = this.gos;
        const groupDisplayType = gos.get("groupDisplayType");
        const isCustomRowGroups = groupDisplayType === "custom";
        if (isCustomRowGroups) return true;
        const treeDataDisplayType = gos.get("treeDataDisplayType");
        return treeDataDisplayType === "custom";
    }
    // rowGroupCol and index are missing if groupDisplayType != "multipleColumns"
    createOneAutoCol(rowGroupCol, index) {
        let colId;
        if (rowGroupCol) colId = `${0, $437b23f6a393c3bf$export$a7016588c430dba6}-${rowGroupCol.getId()}`;
        else colId = (0, $437b23f6a393c3bf$export$a7016588c430dba6);
        const colDef = this.createAutoColDef(colId, rowGroupCol, index);
        colDef.colId = colId;
        const newCol = new (0, $437b23f6a393c3bf$export$a8da3e2b83e5ddf2)(colDef, null, colId, true);
        this.createBean(newCol);
        return newCol;
    }
    /**
   * Refreshes an auto group col to load changes from defaultColDef or autoGroupColDef
   */ updateOneAutoCol(colToUpdate, index, source) {
        const oldColDef = colToUpdate.getColDef();
        const underlyingColId = typeof oldColDef.showRowGroup == "string" ? oldColDef.showRowGroup : void 0;
        const beans = this.beans;
        const underlyingColumn = underlyingColId != null ? beans.colModel.getColDefCol(underlyingColId) : void 0;
        const colId = colToUpdate.getId();
        const colDef = this.createAutoColDef(colId, underlyingColumn ?? void 0, index);
        colToUpdate.setColDef(colDef, null, source);
        (0, $437b23f6a393c3bf$export$b2854c1cb8f10386)(beans, {
            state: [
                (0, $437b23f6a393c3bf$export$2fd1bdef8244d93c)(colDef, colId)
            ]
        }, source);
    }
    createAutoColDef(colId, underlyingColumn, index) {
        let res = this.createBaseColDef(underlyingColumn);
        const autoGroupColumnDef = this.gos.get("autoGroupColumnDef");
        (0, $437b23f6a393c3bf$export$8ade6bd474fcde42)(res, autoGroupColumnDef);
        res = (0, $437b23f6a393c3bf$export$310bdd432cb2279e)(this.beans, res, colId, true);
        if (!this.gos.get("treeData")) {
            const noFieldOrValueGetter = (0, $437b23f6a393c3bf$export$672d9e47bc342bac)(res.field) && (0, $437b23f6a393c3bf$export$672d9e47bc342bac)(res.valueGetter) && (0, $437b23f6a393c3bf$export$672d9e47bc342bac)(res.filterValueGetter) && res.filter !== "agGroupColumnFilter";
            if (noFieldOrValueGetter) res.filter = false;
        }
        if (index && index > 0) res.headerCheckboxSelection = false;
        const isSortingCoupled = (0, $437b23f6a393c3bf$export$96c51c2547b81aed)(this.gos);
        const hasOwnData = res.valueGetter || res.field != null;
        if (isSortingCoupled && !hasOwnData) {
            res.sortIndex = void 0;
            res.initialSort = void 0;
        }
        return res;
    }
    createBaseColDef(rowGroupCol) {
        const userDef = this.gos.get("autoGroupColumnDef");
        const localeTextFunc = this.getLocaleTextFunc();
        const res = {
            headerName: localeTextFunc("group", "Group"),
            showRowGroup: rowGroupCol?.getColId() ?? true
        };
        const userHasProvidedGroupCellRenderer = userDef && (userDef.cellRenderer || userDef.cellRendererSelector);
        if (!userHasProvidedGroupCellRenderer) res.cellRenderer = "agGroupCellRenderer";
        if (rowGroupCol) {
            res.headerName = this.beans.colNames.getDisplayNameForColumn(rowGroupCol, "header") ?? void 0;
            res.headerValueGetter = rowGroupCol.colDef.headerValueGetter;
        }
        return res;
    }
    destroy() {
        (0, $437b23f6a393c3bf$export$dbaaa57234b60d8f)(this.beans, this.columns?.tree);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$BaseExpansionService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    addExpandedCss(classes, rowNode) {
        if (rowNode.isExpandable()) {
            classes.push("ag-row-group");
            classes.push(rowNode.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted");
        }
    }
    getRowExpandedListeners(rowCtrl) {
        const { rowNode: rowNode } = rowCtrl;
        const updateExpandedCss = this.updateExpandedCss.bind(this, rowCtrl, rowNode);
        return {
            expandedChanged: updateExpandedCss,
            hasChildrenChanged: updateExpandedCss
        };
    }
    setExpanded(rowNode, expanded, e, forceSync) {
        if (rowNode.expanded === expanded) return;
        rowNode.expanded = expanded;
        rowNode.dispatchRowEvent("expandedChanged");
        const event = {
            ...(0, $437b23f6a393c3bf$export$5c5bd6257397e1bc)(rowNode, this.gos, "rowGroupOpened"),
            expanded: expanded,
            event: e || null
        };
        this.dispatchExpandedEvent(event, forceSync);
    }
    isExpandable(rowNode) {
        if (rowNode.footer) return false;
        if (this.beans.colModel.isPivotMode()) return rowNode.hasChildren() && !rowNode.leafGroup;
        return rowNode.hasChildren() || rowNode.master;
    }
    updateExpandedCss(rowCtrl, rowNode) {
        const expandable = rowNode.isExpandable();
        const expanded = rowNode.expanded == true;
        rowCtrl.forEachGui(void 0, (gui)=>{
            const rowComp = gui.rowComp;
            rowComp.toggleCss("ag-row-group", expandable);
            rowComp.toggleCss("ag-row-group-expanded", expandable && expanded);
            rowComp.toggleCss("ag-row-group-contracted", expandable && !expanded);
            (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(gui.element, expandable && expanded);
        });
    }
    dispatchStateUpdatedEvent() {
        this.eventSvc.dispatchEvent({
            type: "rowExpansionStateChanged"
        });
    }
};
// packages/ag-grid-enterprise/src/rowHierarchy/clientSideExpansionService.ts
var $5b7ccabde48fae90$var$ClientSideExpansionService = class extends $5b7ccabde48fae90$var$BaseExpansionService {
    constructor(){
        super(...arguments);
        this.beanName = "expansionSvc";
        this.events = null;
        this.dispatchExpandedDebounced = null;
    }
    destroy() {
        super.destroy();
        this.events = null;
        this.dispatchExpandedDebounced = null;
    }
    setExpansionState(state) {
        const rowIdsToExpandSet = new Set(state.expandedRowGroupIds);
        this.beans.rowModel.forEachNode((node)=>{
            const id = node.id;
            if (!id) return;
            node.expanded = rowIdsToExpandSet.has(id);
        });
        this.onGroupExpandedOrCollapsed();
    }
    getExpansionState() {
        const expandedRowGroupIds = [];
        const collapsedRowGroupIds = [];
        this.beans.rowModel.forEachNode((node)=>{
            const id = node.id;
            if (!id) return;
            if (node.expanded) expandedRowGroupIds.push(id);
            else collapsedRowGroupIds.push(id);
        });
        return {
            expandedRowGroupIds: expandedRowGroupIds,
            collapsedRowGroupIds: collapsedRowGroupIds
        };
    }
    expandAll(expand) {
        const { gos: gos, rowModel: rowModel, colModel: colModel, eventSvc: eventSvc } = this.beans;
        const usingTreeData = gos.get("treeData");
        const usingPivotMode = colModel.isPivotActive();
        const recursiveExpandOrCollapse = (rowNodes)=>{
            if (!rowNodes) return;
            for (const rowNode of rowNodes){
                const actionRow = ()=>{
                    rowNode.expanded = expand;
                    recursiveExpandOrCollapse(rowNode.childrenAfterGroup);
                };
                if (rowNode.master) {
                    actionRow();
                    continue;
                }
                if (usingTreeData) {
                    const hasChildren = (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(rowNode.childrenAfterGroup);
                    if (hasChildren) actionRow();
                    continue;
                }
                if (usingPivotMode) {
                    const notLeafGroup = !rowNode.leafGroup;
                    if (notLeafGroup) actionRow();
                    continue;
                }
                const isRowGroup = rowNode.group;
                if (isRowGroup) actionRow();
            }
        };
        const rootNode = rowModel.rootNode;
        if (rootNode) recursiveExpandOrCollapse(rootNode.childrenAfterGroup);
        this.onGroupExpandedOrCollapsed();
        eventSvc.dispatchEvent({
            type: "expandOrCollapseAll",
            source: expand ? "expandAll" : "collapseAll"
        });
    }
    onGroupExpandedOrCollapsed() {
        this.dispatchStateUpdatedEvent();
        this.beans.rowModel.refreshModel({
            step: "map"
        });
    }
    setDetailsExpansionState(detailGridApi) {
        const expansionState = this.getExpansionState();
        const allExpanded = expansionState.collapsedRowGroupIds.length === 0;
        const allCollapsed = expansionState.expandedRowGroupIds.length === 0;
        if (allCollapsed === allExpanded) return;
        return allExpanded ? detailGridApi.expandAll() : detailGridApi.collapseAll();
    }
    /**
   * because the user can call rowNode.setExpanded() many times in one VM turn,
   * we throttle the calls to ClientSideRowModel using animationFrameSvc. this means for 100
   * row nodes getting expanded, we only update the CSRM once, and then we fire all events after
   * CSRM has updated.
   *
   * if we did not do this, then the user could call setExpanded on 100+ rows, causing the grid
   * to re-render 100+ times, which would be a performance lag.
   *
   * we use animationFrameService
   * rather than debounce() so this will get done if anyone flushes the animationFrameService
   * (eg user calls api.ensureRowVisible(), which in turn flushes ).
   */ dispatchExpandedEvent(event, forceSync) {
        (this.events ?? (this.events = [])).push(event);
        if (forceSync) {
            this.dispatchExpandedEvents();
            return;
        }
        let dispatch = this.dispatchExpandedDebounced;
        if (!dispatch) {
            if (!this.isAlive()) return;
            dispatch = this.debounce(()=>this.dispatchExpandedEvents());
            this.dispatchExpandedDebounced = dispatch;
        }
        dispatch();
    }
    dispatchExpandedEvents() {
        const { eventSvc: eventSvc, rowRenderer: rowRenderer } = this.beans;
        const eventsToDispatch = this.events;
        const eventsLen = eventsToDispatch?.length;
        if (!eventsLen) return;
        this.events = null;
        const rowNodes = new Array(eventsLen);
        for(let i = 0; i < eventsLen; ++i){
            rowNodes[i] = eventsToDispatch[i].node;
            eventSvc.dispatchEvent(eventsToDispatch[i]);
        }
        this.dispatchStateUpdatedEvent();
        rowRenderer.refreshCells({
            rowNodes: rowNodes
        });
    }
    // the advantage over normal debounce is the client can call flushAllFrames()
    // to make sure all rendering is complete. we don't wait any milliseconds,
    // as this is intended to batch calls in one VM turn.
    debounce(func) {
        const animationFrameSvc = this.beans.animationFrameSvc;
        if (!animationFrameSvc) return ()=>window.setTimeout(func, 0);
        let pending = false;
        return ()=>{
            if (!animationFrameSvc.active) {
                window.setTimeout(func, 0);
                return;
            }
            if (pending) return;
            pending = true;
            animationFrameSvc.addDestroyTask(()=>{
                pending = false;
                func();
            });
        };
    }
};
function $5b7ccabde48fae90$var$_getFlattenDetails(gos) {
    let groupHideParentOfSingleChild = gos.get("groupHideParentOfSingleChild");
    if (!groupHideParentOfSingleChild) {
        groupHideParentOfSingleChild = gos.get("groupRemoveSingleChildren");
        if (!groupHideParentOfSingleChild && gos.get("groupRemoveLowestSingleChildren")) groupHideParentOfSingleChild = "leafGroupsOnly";
    }
    return {
        groupHideParentOfSingleChild: groupHideParentOfSingleChild,
        isGroupMultiAutoColumn: (0, $437b23f6a393c3bf$export$7122eb216a66bef2)(gos),
        hideOpenParents: gos.get("groupHideOpenParents"),
        grandTotalRow: (0, $437b23f6a393c3bf$export$c6fad27ed643a862)(gos),
        groupTotalRow: (0, $437b23f6a393c3bf$export$713d6cabeaa7f2a5)(gos)
    };
}
function $5b7ccabde48fae90$var$_isRemovedSingleChildrenGroup(details, rowNode, isParent) {
    return details.groupHideParentOfSingleChild === true && isParent && rowNode.childrenAfterGroup.length === 1;
}
function $5b7ccabde48fae90$var$_isRemovedLowestSingleChildrenGroup(details, rowNode, isParent) {
    return details.groupHideParentOfSingleChild === "leafGroupsOnly" && isParent && rowNode.leafGroup && rowNode.childrenAfterGroup.length === 1;
}
function $5b7ccabde48fae90$var$_shouldRowBeRendered(details, rowNode, isParent, skipLeafNodes, isRemovedSingleChildrenGroup, isRemovedLowestSingleChildrenGroup) {
    const isSkippedLeafNode = skipLeafNodes && !isParent;
    const neverAllowToExpand = skipLeafNodes && rowNode.leafGroup;
    const isHiddenOpenParent = details.hideOpenParents && rowNode.expanded && !rowNode.master && !neverAllowToExpand;
    return !isSkippedLeafNode && !isHiddenOpenParent && !isRemovedSingleChildrenGroup && !isRemovedLowestSingleChildrenGroup;
}
// packages/ag-grid-enterprise/src/rowHierarchy/flattenStage.ts
var $5b7ccabde48fae90$var$FlattenStage = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "flattenStage";
        this.step = "map";
        this.refreshProps = [
            "groupHideParentOfSingleChild",
            "groupRemoveSingleChildren",
            "groupRemoveLowestSingleChildren",
            "groupTotalRow",
            "masterDetail"
        ];
    }
    execute() {
        const { beans: beans, gos: gos } = this;
        const result = [];
        const rootNode = beans.rowModel.rootNode;
        if (!rootNode) return result;
        const skipLeafNodes = beans.colModel.isPivotMode();
        const showRootNode = skipLeafNodes && rootNode.leafGroup && rootNode.aggData;
        const topList = showRootNode ? [
            rootNode
        ] : rootNode.childrenAfterSort;
        const details = $5b7ccabde48fae90$var$_getFlattenDetails(gos);
        this.recursivelyAddToRowsToDisplay(details, topList, result, skipLeafNodes, 0);
        const atLeastOneRowPresent = result.length > 0;
        const grandTotalRow = details.grandTotalRow;
        const includeGrandTotalRow = !showRootNode && // don't show total footer when showRootNode is true (i.e. in pivot mode and no groups)
        atLeastOneRowPresent && grandTotalRow;
        if (includeGrandTotalRow) {
            $5b7ccabde48fae90$var$_createRowNodeFooter(rootNode, beans);
            if (grandTotalRow === "pinnedBottom" || grandTotalRow === "pinnedTop") this.beans.pinnedRowModel?.setGrandTotalPinned(grandTotalRow === "pinnedBottom" ? "bottom" : "top");
            else {
                const addToTop = grandTotalRow === "top";
                this.addRowNodeToRowsToDisplay(details, rootNode.sibling, result, 0, addToTop);
            }
        }
        return result;
    }
    recursivelyAddToRowsToDisplay(details, rowsToFlatten, result, skipLeafNodes, uiLevel) {
        if (!rowsToFlatten?.length) return;
        const masterDetailSvc = this.beans.masterDetailSvc;
        for(let i = 0; i < rowsToFlatten.length; i++){
            const rowNode = rowsToFlatten[i];
            const isParent = rowNode.hasChildren();
            const isRemovedSingleChildrenGroup = $5b7ccabde48fae90$var$_isRemovedSingleChildrenGroup(details, rowNode, isParent);
            const isRemovedLowestSingleChildrenGroup = $5b7ccabde48fae90$var$_isRemovedLowestSingleChildrenGroup(details, rowNode, isParent);
            const thisRowShouldBeRendered = $5b7ccabde48fae90$var$_shouldRowBeRendered(details, rowNode, isParent, skipLeafNodes, isRemovedSingleChildrenGroup, isRemovedLowestSingleChildrenGroup);
            if (thisRowShouldBeRendered) this.addRowNodeToRowsToDisplay(details, rowNode, result, uiLevel);
            if (skipLeafNodes && rowNode.leafGroup) continue;
            if (isParent) {
                const excludedParent = isRemovedSingleChildrenGroup || isRemovedLowestSingleChildrenGroup;
                if (rowNode.expanded || excludedParent) {
                    const doesRowShowFooter = details.groupTotalRow({
                        node: rowNode
                    });
                    if (!doesRowShowFooter) $5b7ccabde48fae90$var$_destroyRowNodeFooter(rowNode);
                    const uiLevelForChildren = excludedParent ? uiLevel : uiLevel + 1;
                    if (doesRowShowFooter === "top") {
                        $5b7ccabde48fae90$var$_createRowNodeFooter(rowNode, this.beans);
                        this.addRowNodeToRowsToDisplay(details, rowNode.sibling, result, uiLevelForChildren);
                    }
                    const detailNode = masterDetailSvc?.getDetail(rowNode);
                    if (detailNode) this.addRowNodeToRowsToDisplay(details, detailNode, result, uiLevel);
                    this.recursivelyAddToRowsToDisplay(details, rowNode.childrenAfterSort, result, skipLeafNodes, uiLevelForChildren);
                    if (doesRowShowFooter === "bottom") {
                        $5b7ccabde48fae90$var$_createRowNodeFooter(rowNode, this.beans);
                        this.addRowNodeToRowsToDisplay(details, rowNode.sibling, result, uiLevelForChildren);
                    }
                }
            } else {
                const detailNode = masterDetailSvc?.getDetail(rowNode);
                if (detailNode) this.addRowNodeToRowsToDisplay(details, detailNode, result, uiLevel);
            }
        }
    }
    // duplicated method, it's also in floatingRowModel
    addRowNodeToRowsToDisplay(details, rowNode, result, uiLevel, addToTop) {
        if (addToTop) result.unshift(rowNode);
        else result.push(rowNode);
        rowNode.setUiLevel(details.isGroupMultiAutoColumn ? 0 : uiLevel);
    }
};
var $5b7ccabde48fae90$var$GroupEditService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "groupEditSvc";
        this.pendingEditRefresh = null;
        this.dropGroupTarget = null;
        this.dropGroupTimer = null;
        this.dropGroupThrottled = false;
        this.draggingGroups = null;
    }
    postConstruct() {
        if ((0, $437b23f6a393c3bf$export$9f182d9ca737e15)(this.gos)) this.addManagedListeners(this.eventSvc, {
            cellValueChanged: (event)=>this.onCsrmCellChange(event),
            batchEditingStopped: ()=>this.flushGroupEdits()
        });
    }
    destroy() {
        this.stopDragging(true);
        super.destroy();
    }
    /** Checks if the drop operation described by `rowsDrop` is a grouping edit */ isGroupingDrop(rowsDrop) {
        if (!rowsDrop.rowDragManaged || !rowsDrop.sameGrid) return false;
        if (!this.gos.get("refreshAfterGroupEdit")) return false;
        return !!this.beans.rowGroupColsSvc?.columns?.length && !this.beans.colModel.isPivotMode();
    }
    initDraggingGroups(rowsDrop) {
        const structure = /* @__PURE__ */ new Map();
        const recurse = (row)=>{
            const childrenAfterGroup = row.childrenAfterGroup;
            if (childrenAfterGroup) {
                if (structure.has(row)) return;
                const children = childrenAfterGroup.slice();
                structure.set(row, children);
                for (const child of children)recurse(child);
            }
        };
        for (const row of rowsDrop.rows)if (row.group) recurse(row);
        this.draggingGroups = structure;
    }
    /** Checks if the drop operation described by `rowsDrop` can set a new parent */ canSetParent(rowsDrop) {
        if (!rowsDrop.sameGrid) return false;
        if (this.beans.groupStage?.treeData) return true;
        if (rowsDrop.rowDragManaged && !this.gos.get("refreshAfterGroupEdit")) return false;
        return !!this.beans.rowGroupColsSvc?.columns?.length;
    }
    canDropRow(rowNode, rowsDrop) {
        if (this.beans.groupStage?.treeData) return !$5b7ccabde48fae90$var$wouldCycle(rowNode, rowsDrop.newParent);
        const { position: position, target: target, newParent: newParent, rootNode: rootNode } = rowsDrop;
        const currentParent = rowNode.parent;
        if (rowNode.group && ($5b7ccabde48fae90$var$isAncestorOrSelf(rowNode, target) || $5b7ccabde48fae90$var$isAncestorOrSelf(rowNode, newParent))) return false;
        if (position === "inside") return true;
        if (newParent && newParent !== currentParent) return newParent !== rootNode || currentParent === rootNode;
        const comparisonParent = newParent ?? target?.parent ?? rootNode;
        if (comparisonParent !== currentParent) return false;
        const sourceLevel = rowNode.group ? rowNode.level : currentParent.level ?? -1;
        let targetLevel = -1;
        if (target) targetLevel = target.group ? target.level : target.parent?.level ?? -1;
        else if (comparisonParent) targetLevel = comparisonParent.level;
        if (sourceLevel >= 0 && targetLevel >= 0 && targetLevel !== sourceLevel) return false;
        return true;
    }
    fixRowsDrop(rowsDrop, canSetParent, fromNudge, yDelta) {
        const treeData = !!this.beans.groupStage?.treeData;
        rowsDrop.treeData = treeData;
        const isRowGrouping = !!this.beans.rowGroupColsSvc?.columns?.length || this.gos.get("pivotMode");
        if (!isRowGrouping && !treeData) return;
        if (!this.draggingGroups && this.isGroupingDrop(rowsDrop) && !rowsDrop.suppressMoveWhenRowDragging) this.initDraggingGroups(rowsDrop);
        let target = rowsDrop.target;
        let newParent = null;
        let inside = false;
        const rootNode = rowsDrop.rootNode;
        const rowModel = this.beans.rowModel;
        const canStartGroup = this.canStartGroup(target, treeData);
        this.updateDropTarget(rowsDrop, fromNudge, canStartGroup);
        const lastRowIndex = this.beans.pageBounds?.getLastRow?.() ?? rowModel.getRowCount() - 1;
        if (canSetParent) {
            if (!target || yDelta >= 0.5 && target.rowIndex === lastRowIndex) newParent = rootNode;
            else if (rowsDrop.moved && target && this.dropGroupThrottled && this.shouldDropTargetBeParent(rowsDrop)) newParent = target;
            if (!newParent) newParent = target?.parent ?? rootNode;
        }
        if (!fromNudge && target && canStartGroup && !(target.group && target.expanded)) this.startDropGroupDelay(target);
        if (newParent) {
            if (target && newParent === target && newParent !== rootNode) {
                const firstRow = newParent.expanded ? (0, $437b23f6a393c3bf$export$c2c097fde6ba0eab)(rowModel, 1, target) : null;
                if (firstRow?.parent === newParent) {
                    target = firstRow;
                    yDelta = -0.5;
                } else inside = true;
            }
            if (target && !inside) {
                let current = target;
                while(current && current !== rootNode && current !== newParent){
                    target = current;
                    current = current.parent;
                }
            }
        }
        rowsDrop.target = target;
        rowsDrop.newParent = newParent;
        rowsDrop.yDelta = yDelta;
        rowsDrop.inside = inside;
    }
    clearNewSameParent(rowsDrop, canSetParent) {
        const newParent = rowsDrop.newParent;
        if (newParent && (!canSetParent || $5b7ccabde48fae90$var$rowsHaveSameParent(rowsDrop.rows, newParent))) rowsDrop.newParent = null;
    }
    updateDropTarget(rowsDrop, fromNudge, canStartGroup) {
        const target = canStartGroup ? rowsDrop.target : null;
        if (this.dropGroupTarget && this.dropGroupTarget !== target) this.resetDragGroup();
        if (!target?.childrenAfterSort?.length) return;
        if (fromNudge && this.dropGroupThrottled && !target.expanded && target.isExpandable?.()) target.setExpanded(true, void 0, true);
        if (this.canDropInTarget(target, rowsDrop)) {
            this.dropGroupThrottled = true;
            this.dropGroupTarget = target;
        }
    }
    canDropInTarget(target, rowsDrop) {
        if (target.expanded) return true;
        if (!target.group) return false;
        if (rowsDrop.pointerPos === "inside") return true;
        if (rowsDrop.treeData) return false;
        const rows = rowsDrop.rows;
        const targetLevel = target.level;
        for(let i = 0, len = rows.length; i < len; ++i){
            const row = rows[i];
            if (row !== target && row.group && row.level !== targetLevel) return false;
        }
        return true;
    }
    startDropGroupDelay(target) {
        if (this.dropGroupTarget && this.dropGroupTarget !== target) this.resetDragGroup();
        this.dropGroupTarget = target;
        if (this.dropGroupTimer !== null) return;
        const delay = this.gos.get("rowDragInsertDelay");
        this.dropGroupTimer = window.setTimeout(()=>{
            this.dropGroupTimer = null;
            this.dropGroupThrottled = true;
            this.beans.dragAndDrop?.nudge();
        }, delay);
    }
    resetDragGroup() {
        if (this.dropGroupTimer !== null) {
            window.clearTimeout(this.dropGroupTimer);
            this.dropGroupTimer = null;
        }
        this.dropGroupTarget = null;
        this.dropGroupThrottled = false;
    }
    stopDragging(final) {
        if (final) this.draggingGroups = null;
        this.resetDragGroup();
    }
    shouldDropTargetBeParent({ target: target, rows: rows, pointerPos: pointerPos, treeData: treeData }) {
        if (!target || pointerPos === "none") return false;
        if (pointerPos === "inside") return true;
        if (!treeData && target.group && !target.expanded) return true;
        if (pointerPos === "above") return false;
        const rowModel = this.beans.rowModel;
        const targetRowIndex = target.rowIndex;
        let nextRowIndex = targetRowIndex + 1;
        let nextRow;
        do nextRow = rowModel.getRow(nextRowIndex++);
        while (nextRow?.footer);
        const childrenAfterGroup = this.draggingGroups?.get(target) ?? target.childrenAfterGroup;
        if (nextRow && nextRow.parent === target && childrenAfterGroup?.length) {
            const rowsSet = new Set(rows);
            for(let i = 0, len = childrenAfterGroup.length; i < len; ++i){
                const child = childrenAfterGroup[i];
                if (child.rowIndex !== null && !rowsSet.has(child)) return true;
            }
        }
        return false;
    }
    /** Performs the grouping edit described by `rowsDrop` */ dropGroupEdit(rowsDrop) {
        const { beans: beans } = this;
        const position = rowsDrop.position;
        const target = rowsDrop.target ?? null;
        const rootNode = rowsDrop.rootNode;
        const parentForValues = rowsDrop.newParent ?? target?.parent ?? rootNode;
        const focusSvc = beans.focusSvc;
        const cellPosition = focusSvc.getFocusedCell();
        const cellCtrl = cellPosition && (0, $437b23f6a393c3bf$export$1bd7ce47360c3c0)(beans, cellPosition);
        const leafs = /* @__PURE__ */ new Set();
        const changedRowNodes = new (0, $437b23f6a393c3bf$export$31d871bfcf904e4b)();
        const updates = changedRowNodes.updates;
        let newGroupValues;
        const processLeaf = (leafRow)=>{
            if (leafs.has(leafRow)) return;
            leafs.add(leafRow);
            newGroupValues ?? (newGroupValues = this.newGroupValues(parentForValues));
            if (this.setRowGroup(leafRow, newGroupValues)) updates.add(leafRow);
        };
        const visitGroupedChildren = (groupNode)=>{
            const children = this.draggingGroups?.get(groupNode) ?? groupNode.childrenAfterGroup;
            const childrenLen = children?.length;
            if (childrenLen) for(let i = 0; i < childrenLen; ++i){
                const child = children[i];
                if (child.sourceRowIndex >= 0) processLeaf(child);
                else visitGroupedChildren(child);
            }
        };
        for (const row of rowsDrop.rows)if (row.group) visitGroupedChildren(row);
        else {
            const firstLeaf = row.sourceRowIndex >= 0 && !row.destroyed ? row : this.csrmFirstLeaf(row);
            if (firstLeaf) processLeaf(firstLeaf);
        }
        const reorderPosition = position === "inside" ? "above" : position;
        const reorderTarget = position === "inside" ? this.findFirstLeafForParent(parentForValues, leafs) ?? target : target;
        let orderChanged = false;
        if (leafs.size && reorderPosition !== "none") orderChanged = (0, $437b23f6a393c3bf$export$bdac36eff8582fbb)(rootNode._leafs, leafs, reorderTarget, reorderPosition === "above");
        if (!updates.size && !orderChanged) return false;
        changedRowNodes.reordered = orderChanged;
        for (const leaf of leafs)changedRowNodes.updates.add(leaf);
        this.csrmRefresh(changedRowNodes);
        if (cellCtrl) cellCtrl.focusCell();
        else focusSvc.clearFocusedCell();
        return true;
    }
    canStartGroup(target, treeData) {
        if (!target || target.level < 0 || target.footer || target.detail) return false;
        if (target.group) return true;
        return treeData;
    }
    /** Flushes any pending group edits for batch processing */ flushGroupEdits() {
        const pending = this.pendingEditRefresh;
        if (pending) {
            this.pendingEditRefresh = null;
            this.csrmRefresh(pending);
        }
    }
    /** Refreshes the grouping for the provided rows */ csrmRefresh(changedRowNodes) {
        const clientSideRowModel = this.beans.rowModel;
        const rootNode = clientSideRowModel.rootNode;
        if (!rootNode) return;
        clientSideRowModel.refreshModel({
            step: "group",
            keepRenderedRows: true,
            animate: !this.gos.get("suppressAnimationFrame"),
            changedPath: new (0, $437b23f6a393c3bf$export$cb4d9114a9732e85)(false, rootNode),
            changedRowNodes: changedRowNodes
        });
    }
    newGroupValues(parent) {
        const columns = this.beans.rowGroupColsSvc?.columns ?? [];
        const values = new Array(columns.length);
        let maxLevel = -1;
        let current = parent;
        while(current && current.level >= 0){
            const column = columns[current.level];
            if (column) {
                const colId = column.getColId();
                const level = current.level;
                values[level] = current.groupData?.[colId] ?? current.key ?? void 0;
                if (level > maxLevel) maxLevel = level;
            }
            current = current.parent;
        }
        return {
            values: values,
            columns: columns,
            maxLevel: maxLevel
        };
    }
    setRowGroup(row, { values: values, columns: columns, maxLevel: maxLevel }) {
        if (maxLevel < 0) return false;
        const { valueSvc: valueSvc, editSvc: editSvc } = this.beans;
        let changed = false;
        for(let level = 0; level < columns.length; ++level){
            const column = columns[level];
            if (!column || level > maxLevel) continue;
            const newValue = values[level];
            const currentValue = valueSvc.getValue(column, row, false, "api");
            if (currentValue === newValue || currentValue == null && newValue == null) continue;
            let valueToSet = newValue;
            const parsedValue = valueSvc.parseValue(column, row, newValue, currentValue);
            if (parsedValue !== void 0) valueToSet = parsedValue;
            const result = editSvc?.setDataValue({
                rowNode: row,
                column: column
            }, valueToSet, "rowDrag");
            const updated = result != null ? !!result : row.setDataValue(column, valueToSet, "rowDrag");
            if (updated) changed = true;
        }
        return changed;
    }
    onCsrmCellChange(event) {
        const { column: column, node: node, source: source } = event;
        if (!this.gos.get("refreshAfterGroupEdit")) return;
        if (source === "rowDrag") return;
        if (!column?.isRowGroupActive()) return;
        if (node.group || !node.data) return;
        const editSvc = this.beans.editSvc;
        if (editSvc?.isBatchEditing()) {
            let pending = this.pendingEditRefresh;
            if (!pending) {
                pending = $5b7ccabde48fae90$var$newEditChangedRowNodes();
                this.pendingEditRefresh = pending;
            }
            pending.updates.add(node);
        } else {
            const changedRowNodes = $5b7ccabde48fae90$var$newEditChangedRowNodes();
            changedRowNodes.updates.add(node);
            this.csrmRefresh(changedRowNodes);
        }
    }
    csrmFirstLeaf(parent) {
        if (!parent) return null;
        const draggingGroups = this.draggingGroups;
        let children = draggingGroups?.get(parent) ?? parent.childrenAfterGroup;
        while(children?.length){
            const child = children[0];
            if (child.sourceRowIndex >= 0) {
                if (!child.destroyed) return child;
                return this.firstAliveChildLeaf(child);
            }
            children = draggingGroups?.get(child) ?? child.childrenAfterGroup;
        }
        return (0, $437b23f6a393c3bf$export$600fb6a3864e66ca)(parent);
    }
    firstAliveChildLeaf(parent) {
        const children = this.draggingGroups?.get(parent) ?? parent.childrenAfterGroup;
        if (children) for (const grandChild of children){
            if (grandChild.sourceRowIndex >= 0 && !grandChild.destroyed) return grandChild;
        }
        return null;
    }
    findFirstLeafForParent(parent, exclude) {
        if (!parent) return null;
        const children = this.draggingGroups?.get(parent) ?? parent?.childrenAfterGroup;
        if (!children) return null;
        for(let i = 0, len = children.length; i < len; ++i){
            const child = children[i];
            if (child.sourceRowIndex >= 0 && !exclude.has(child)) return child;
            const found = this.findFirstLeafForParent(child, exclude);
            if (found !== null) return found;
        }
        return null;
    }
};
var $5b7ccabde48fae90$var$newEditChangedRowNodes = ()=>{
    const result = new (0, $437b23f6a393c3bf$export$31d871bfcf904e4b)();
    result.reordered = true;
    return result;
};
var $5b7ccabde48fae90$var$isAncestorOrSelf = (candidate, node)=>{
    if (!candidate || !node) return false;
    let current = node;
    while(current){
        if (current === candidate) return true;
        current = current.parent;
    }
    return false;
};
var $5b7ccabde48fae90$var$wouldCycle = (row, newParent)=>{
    if (!newParent || row.parent === newParent) return false;
    let current = newParent;
    const rowId = row.id;
    while(current){
        if (current === row) return true;
        if (rowId != null && current.id === rowId) return true;
        current = current.parent;
    }
    return false;
};
var $5b7ccabde48fae90$var$rowsHaveSameParent = (rows, newParent)=>{
    for(let i = 0, len = rows.length; i < len; ++i){
        if (rows[i].parent !== newParent) return false;
    }
    return true;
};
var $5b7ccabde48fae90$var$GroupStage = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "groupStage";
        this.step = "group";
        this.refreshProps = [
            "groupAllowUnbalanced",
            "groupDefaultExpanded",
            "groupDisplayType",
            "groupHideOpenParents",
            "initialGroupOrderComparator",
            "treeData",
            "treeDataChildrenField",
            "treeDataParentIdField"
        ];
        this.treeData = false;
        this.hasTreeData = false;
        this.needReset = false;
        this.nested = false;
        this.strategy = void 0;
    }
    postConstruct() {
        const gos = this.gos;
        if (gos.isModuleRegistered("TreeData")) {
            this.hasTreeData = true;
            this.treeData = gos.get("treeData");
        }
        this.addManagedEventListeners({
            showRowGroupColsSetChanged: ()=>this.strategy?.onShowRowGroupColsSetChanged()
        });
    }
    invalidateGroupCols() {
        this.strategy?.invalidateGroupCols?.();
    }
    destroy() {
        this.strategy = this.destroyBean(this.strategy);
        super.destroy();
    }
    getNonLeaf(id) {
        return this.strategy?.nonLeafsById?.get(id);
    }
    getNestedDataGetter() {
        return this.getStrategy()?.nestedDataGetter;
    }
    onPropChange(changedProps) {
        const gos = this.gos;
        const oldNestedDataGetter = this.strategy?.nestedDataGetter;
        if (changedProps.has("treeData")) {
            const value = gos.get("treeData") && this.hasTreeData;
            if (this.treeData !== value) {
                this.beans.rowDragSvc?.cancelRowDrag();
                this.treeData = value;
                this.needReset = true;
                this.strategy = this.destroyBean(this.strategy);
            }
        }
        this.strategy?.onPropChange?.(changedProps);
        return this.getNestedDataGetter() !== oldNestedDataGetter;
    }
    extractData() {
        const rootNode = this.beans.rowModel.rootNode;
        const nodes = this.nested ? rootNode?.childrenAfterGroup : rootNode?._leafs;
        if (!nodes) return this.gos.get("rowData") ?? [];
        const len = nodes.length;
        const result = new Array(len);
        let writeIdx = 0;
        for(let i = 0; i < len; ++i){
            const data = nodes[i].data;
            if (data != null) result[writeIdx++] = data;
        }
        result.length = writeIdx;
        return result;
    }
    execute(params) {
        const beans = this.beans;
        const rootNode = beans.rowModel.rootNode;
        if (!rootNode) return false;
        const strategy = this.getStrategy();
        const nested = !!strategy?.nestedDataGetter;
        const needReset = this.needReset;
        this.nested = nested;
        if (needReset) {
            this.needReset = false;
            beans.rowDragSvc?.cancelRowDrag();
            params.animate = false;
            $5b7ccabde48fae90$var$resetGrouping(rootNode, !nested);
        }
        return strategy ? strategy.execute(rootNode, params) || needReset : void 0;
    }
    loadLeafs(node) {
        return node.footer ? $5b7ccabde48fae90$var$loadFooterLeafs(node) : $5b7ccabde48fae90$var$loadRealLeafs(node);
    }
    loadGroupData(node) {
        const strategy = this.getStrategy();
        if (strategy) return strategy.loadGroupData(node);
        node._groupData = null;
        return null;
    }
    clearNonLeafs() {
        this.strategy?.clearNonLeafs();
    }
    getStrategy() {
        let strategy = this.strategy;
        if (strategy !== void 0 && this.isAlive()) return strategy;
        strategy = this.beans.registry.createDynamicBean(this.treeData ? "treeGroupStrategy" : "groupStrategy", false) ?? null;
        this.strategy = strategy && this.createBean(strategy);
        return strategy;
    }
};
var $5b7ccabde48fae90$var$loadFooterLeafs = (node)=>{
    const sibling = node.sibling;
    if (!sibling) return null;
    const siblingLeafs = sibling._leafs;
    if (siblingLeafs !== void 0) return siblingLeafs;
    return $5b7ccabde48fae90$var$loadRealLeafs(sibling);
};
var $5b7ccabde48fae90$var$loadRealLeafs = (node)=>{
    const childrenAfterGroup = node.childrenAfterGroup;
    const childrenAfterGroupLen = childrenAfterGroup?.length;
    node._leafs = null;
    if (!childrenAfterGroupLen) return null;
    let leafs;
    const onlyChild = childrenAfterGroupLen === 1 ? childrenAfterGroup[0] : null;
    if (onlyChild?.group && onlyChild.sourceRowIndex < 0) {
        leafs = onlyChild._leafs;
        if (leafs === void 0) leafs = $5b7ccabde48fae90$var$loadRealLeafs(onlyChild);
    } else if (node.leafGroup) leafs = childrenAfterGroup;
    else {
        leafs = [];
        for(let i = 0; i < childrenAfterGroupLen; ++i){
            const child = childrenAfterGroup[i];
            if (child.sourceRowIndex >= 0) leafs.push(child);
            if (!child.group) continue;
            let childLeafs = child._leafs;
            if (childLeafs === void 0) childLeafs = $5b7ccabde48fae90$var$loadRealLeafs(child);
            if (childLeafs) for(let j = 0, len = childLeafs.length; j < len; ++j)leafs.push(childLeafs[j]);
        }
    }
    node._leafs = leafs;
    return leafs;
};
var $5b7ccabde48fae90$var$resetGrouping = (rootNode, canResetTreeNode)=>{
    const allLeafs = rootNode._leafs;
    const rootSibling = rootNode.sibling;
    rootNode.treeNodeFlags = 0;
    rootNode.childrenAfterGroup = allLeafs;
    rootNode.childrenMapped = null;
    rootNode._groupData = void 0;
    if (rootSibling) {
        rootSibling.childrenAfterGroup = rootNode.childrenAfterGroup;
        rootSibling.childrenAfterAggFilter = rootNode.childrenAfterAggFilter;
        rootSibling.childrenAfterFilter = rootNode.childrenAfterFilter;
        rootSibling.childrenAfterSort = rootNode.childrenAfterSort;
        rootSibling.childrenMapped = null;
        rootSibling._groupData = void 0;
    }
    for(let i = 0, allLeafsLen = allLeafs.length ?? 0; i < allLeafsLen; ++i){
        const row = allLeafs[i];
        const sibling = row.sibling;
        row._leafs = void 0;
        $5b7ccabde48fae90$var$resetChildRowGrouping(row);
        if (sibling) $5b7ccabde48fae90$var$resetChildRowGrouping(sibling);
        row.parent = rootNode;
        if (canResetTreeNode) row.treeParent = null;
        row.group = false;
        row.updateHasChildren();
    }
    rootNode.updateHasChildren();
};
var $5b7ccabde48fae90$var$resetChildRowGrouping = (row)=>{
    row.key = null;
    row.treeNodeFlags = 0;
    row.allChildrenCount = null;
    row.childrenAfterGroup = null;
    row.childrenAfterAggFilter = null;
    row.childrenAfterFilter = null;
    row.childrenAfterSort = null;
    row.childrenMapped = null;
    row.level = 0;
    row._groupData = void 0;
};
// packages/ag-grid-enterprise/src/rowHierarchy/rowHierarchyUtils.ts
function $5b7ccabde48fae90$var$_isHiddenParent(node, ancestor, gos) {
    let currentNode = node;
    const levelDiff = currentNode.level - ancestor.level;
    if (levelDiff <= 0) return false;
    const isHideOpenParents = gos.get("groupHideOpenParents");
    if (!isHideOpenParents) return false;
    for(let i = 0; i < levelDiff; i++){
        const isFirstChild = currentNode.parent?.getFirstChild() === currentNode;
        if (!isFirstChild) return false;
        currentNode = currentNode.parent;
    }
    return currentNode === ancestor;
}
var $5b7ccabde48fae90$var$_getRowDefaultExpanded = (beans, rowNode, level, group = rowNode.group)=>{
    const gos = beans.gos;
    const isGroupOpenByDefault = group && gos.get("isGroupOpenByDefault");
    if (!isGroupOpenByDefault) {
        const groupDefaultExpanded = gos.get("groupDefaultExpanded");
        return groupDefaultExpanded === -1 || level < groupDefaultExpanded;
    }
    const params = {
        api: beans.gridApi,
        context: beans.gridOptions.context,
        rowNode: rowNode,
        field: rowNode.field,
        key: rowNode.key,
        level: level,
        rowGroupColumn: rowNode.rowGroupColumn
    };
    return isGroupOpenByDefault(params) == true;
};
// packages/ag-grid-enterprise/src/rowHierarchy/rendering/groupCellRendererCtrl.ts
var $5b7ccabde48fae90$var$GroupCellRendererCtrl = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        // keep reference to this, so we can remove again when indent changes
        this.indentClass = null;
    }
    init(comp, eGui, eCheckbox, eExpanded, eContracted, compClass, params) {
        this.params = params;
        this.eGui = eGui;
        this.eCheckbox = eCheckbox;
        this.eExpanded = eExpanded;
        this.eContracted = eContracted;
        this.comp = comp;
        this.compClass = compClass;
        const { node: node, column: column } = params;
        this.node = node;
        this.displayedNode = node;
        const embeddedRowMismatch = this.isEmbeddedRowMismatch();
        if (embeddedRowMismatch) return;
        if (node.footer) {
            this.initFooterCell();
            return;
        }
        if (!column) {
            this.initFullWidthCell();
            return;
        }
        this.displayedNode = this.beans.showRowGroupColValueSvc?.getDisplayedNode(node, column) ?? this.node;
        this.setupExpand();
        this.setupCheckbox();
        this.addGroupValue();
        this.setupIndent();
    }
    initFooterCell() {
        const { node: node } = this.params;
        this.addGroupValue();
        this.setupIndent();
        const isGrandTotal = node.level === -1;
        if (!isGrandTotal) this.comp.toggleCss("ag-row-group-leaf-indent", true);
    }
    initFullWidthCell() {
        const setupDragger = ()=>{
            const { rowDragSvc: rowDragSvc } = this.beans;
            if (!this.params.rowDrag || !rowDragSvc) return;
            const rowDragComp = rowDragSvc.createRowDragComp(()=>this.params.value, this.params.node);
            this.createManagedBean(rowDragComp);
            this.eGui.insertAdjacentElement("afterbegin", rowDragComp.getGui());
        };
        this.setupExpand();
        setupDragger();
        this.setupCheckbox();
        this.addGroupValue();
        this.setupIndent();
    }
    /**
   * Returns an aria "role" to place on full width group cells, or the parent wrapper.
   * @returns the aria role to place on the parent wrapper
   */ getCellAriaRole() {
        const colDefAriaRole = this.params.colDef?.cellAriaRole;
        const columnColDefAriaRole = this.params.column?.getColDef().cellAriaRole;
        return colDefAriaRole || columnColDefAriaRole || "gridcell";
    }
    /**
   * Determines if this cell should be rendered, as when using embeddedFullWidthRows
   * only one group cell should be rendered.
   *
   * if [enableRTL] all but pinned right cells should be skipped if available
   * otherwise prioritise pinned left cell if available
   * otherwise center viewport.
   *
   * @returns whether the cell should be skipped due to embedded full width rows
   */ isEmbeddedRowMismatch() {
        if (!this.params.fullWidth || !this.gos.get("embedFullWidthRows")) return false;
        const { visibleCols: visibleCols } = this.beans;
        const pinnedLeftCell = this.params.pinned === "left";
        const pinnedRightCell = this.params.pinned === "right";
        const bodyCell = !pinnedLeftCell && !pinnedRightCell;
        if (this.gos.get("enableRtl")) {
            if (visibleCols.isPinningLeft()) return !pinnedRightCell;
            return !bodyCell;
        }
        if (visibleCols.isPinningLeft()) return !pinnedLeftCell;
        return !bodyCell;
    }
    /**
   * Displays the group value for the displayed node
   */ addGroupValue() {
        const { params: { value: value, valueFormatted: valueFormatted } } = this;
        const innerCompDetails = this.getInnerCompDetails();
        this.comp.setInnerRenderer(innerCompDetails, valueFormatted ?? value ?? null);
    }
    /**
   * Sets up expand/collapse:
   * Chevron
   * Aria-expanded
   * Child count
   */ setupExpand() {
        const { colModel: colModel } = this.beans;
        const { eGridCell: eGridCell, column: column, suppressDoubleClickExpand: suppressDoubleClickExpand } = this.params;
        const addIconToDom = (iconName, element)=>{
            const icon = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(iconName, this.beans, null);
            if (icon) {
                element.appendChild(icon);
                this.addDestroyFunc(()=>icon.remove());
            }
        };
        addIconToDom("groupExpanded", this.eExpanded);
        addIconToDom("groupContracted", this.eContracted);
        const comp = this.comp;
        const onExpandedChanged = ()=>{
            const expandable = this.isExpandable();
            if (!expandable) return;
            const expanded = this.displayedNode.expanded;
            comp.setExpandedDisplayed(expanded);
            comp.setContractedDisplayed(!expanded);
            (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(eGridCell, !!this.displayedNode.expanded);
        };
        const onExpandableChanged = ()=>{
            const expandable = this.isExpandable();
            comp.toggleCss("ag-cell-expandable", expandable);
            comp.toggleCss("ag-row-group", expandable);
            const pivotModeAndLeaf = !expandable && colModel.isPivotMode();
            comp.toggleCss("ag-pivot-leaf-group", pivotModeAndLeaf);
            const normalModeNotTotalFooter = !colModel.isPivotMode() && (!this.displayedNode.footer || this.displayedNode.level !== -1);
            comp.toggleCss("ag-row-group-leaf-indent", !expandable && normalModeNotTotalFooter);
            const count = this.getChildCount();
            const countString = count > 0 ? `(${count})` : ``;
            comp.setChildCount(countString);
            if (!expandable) {
                comp.setExpandedDisplayed(false);
                comp.setContractedDisplayed(false);
                (0, $437b23f6a393c3bf$export$2254dfb132f01330)(eGridCell);
            } else onExpandedChanged();
        };
        const setupListeners = ()=>{
            const isDoubleClickEdit = column?.isCellEditable(this.displayedNode) && this.gos.get("enableGroupEdit");
            if (!isDoubleClickEdit && !suppressDoubleClickExpand) this.addManagedListeners(eGridCell, {
                dblclick: this.onCellDblClicked.bind(this)
            });
            this.addManagedListeners(this.eExpanded, {
                click: this.onExpandClicked.bind(this)
            });
            this.addManagedListeners(this.eContracted, {
                click: this.onExpandClicked.bind(this)
            });
            this.addManagedListeners(eGridCell, {
                keydown: this.onKeyDown.bind(this)
            });
            this.addManagedListeners(this.displayedNode, {
                // Expandable state has changed
                allChildrenCountChanged: onExpandableChanged,
                masterChanged: onExpandableChanged,
                groupChanged: onExpandableChanged,
                hasChildrenChanged: onExpandableChanged,
                // Node expanded changed
                expandedChanged: onExpandedChanged
            });
        };
        setupListeners();
        onExpandableChanged();
    }
    /**
   * Return the inner renderer details for the cell
   *
   * Prioritises:
   * 1. Group row renderer for group rows
   * 2. agFindCellRenderer for find results in group rows
   * 3. Provided innerRenderer (i.e, cellRendererParams.innerRenderer)
   * 4. Cell renderer of the grouped column
   * 5. Inner renderer of the grouped column
   * 6. agFindCellRenderer for find results
   */ getInnerCompDetails() {
        const { userCompFactory: userCompFactory, findSvc: findSvc } = this.beans;
        const params = this.params;
        if (params.fullWidth) {
            const groupRowRendererParams = this.gos.get("groupRowRendererParams");
            const groupRowInnerCompDetails = (0, $437b23f6a393c3bf$export$c3f4e745c2fdf1c0)(userCompFactory, groupRowRendererParams, params);
            if (groupRowInnerCompDetails) return groupRowInnerCompDetails;
            if (findSvc?.isMatch(params.node, null)) return (0, $437b23f6a393c3bf$export$c3f4e745c2fdf1c0)(userCompFactory, {
                ...groupRowRendererParams,
                innerRenderer: "agFindCellRenderer"
            }, params);
            return void 0;
        }
        const isGroupRowRenderer = (details)=>details && details.componentClass == this.compClass;
        const innerCompDetails = (0, $437b23f6a393c3bf$export$c3f4e745c2fdf1c0)(userCompFactory, params, params);
        if (innerCompDetails && !isGroupRowRenderer(innerCompDetails)) return innerCompDetails;
        const { displayedNode: { rowGroupColumn: rowGroupColumn } } = this;
        const relatedColDef = rowGroupColumn?.colDef;
        const isShowingThisCol = rowGroupColumn && params.column?.isRowGroupDisplayed(rowGroupColumn.getId());
        if (relatedColDef && isShowingThisCol) {
            const relatedCompDetails = (0, $437b23f6a393c3bf$export$1f172e021e4d8401)(userCompFactory, relatedColDef, params);
            if (relatedCompDetails) {
                if (isGroupRowRenderer(relatedCompDetails)) {
                    if (relatedColDef?.cellRendererParams?.innerRenderer) return (0, $437b23f6a393c3bf$export$c3f4e745c2fdf1c0)(userCompFactory, relatedColDef.cellRendererParams, params);
                } else return relatedCompDetails;
            }
        }
        if (findSvc?.isMatch(params.node, params.column)) return (0, $437b23f6a393c3bf$export$1f172e021e4d8401)(userCompFactory, {
            ...relatedColDef ?? params.colDef,
            cellRenderer: "agFindCellRenderer"
        }, params);
    }
    /**
   * Get the allChildCount of a given node
   * @param node the node to return the count for
   * @returns 0 if the count should not be displayed, otherwise the count
   */ getChildCount() {
        const { column: column, suppressCount: suppressCount } = this.params;
        if (suppressCount) return 0;
        const { allChildrenCount: allChildrenCount, rowGroupColumn: rowGroupColumn } = this.displayedNode;
        const isDisplayingRowGroupCell = (allChildrenCount ?? 0) > 0 && (!rowGroupColumn || !column || column?.isRowGroupDisplayed(rowGroupColumn.getId()));
        if (!isDisplayingRowGroupCell) return 0;
        const isRepresentingOtherNode = this.gos.get("showOpenedGroup") && this.displayedNode !== this.node;
        if (isRepresentingOtherNode && !$5b7ccabde48fae90$var$_isHiddenParent(this.node, this.displayedNode, this.gos)) return 0;
        return allChildrenCount ?? 0;
    }
    /**
   * Checks whether the current cell is expandable, either due to [groupHideOpenParent] control or otherwise.
   * @returns whether this cell is expandable
   */ isExpandable() {
        const { node: node, column: column, colDef: colDef } = this.params;
        if (!this.displayedNode.isExpandable()) return false;
        if (node.rowPinned) return false;
        const isFullWidth = !column;
        if (isFullWidth) return true;
        const hasChildren = node.hasChildren();
        if (hasChildren && colDef) {
            const { showRowGroup: showRowGroup } = colDef;
            if (!showRowGroup) return false;
            if (showRowGroup === true) return true;
        }
        if (node === this.displayedNode) {
            if (node.rowGroupColumn) {
                const showingThisRowGroup = column?.isRowGroupDisplayed(node.rowGroupColumn.getId());
                if (showingThisRowGroup) return true;
            }
            if (node.master) return colDef?.showRowGroup === true || colDef?.showRowGroup == null;
            return false;
        }
        return $5b7ccabde48fae90$var$_isHiddenParent(this.node, this.displayedNode, this.gos);
    }
    /**
   * For full width group cells & single group column, indents child groups based on uiLevel
   */ setupIndent() {
        const { suppressPadding: suppressPadding, node: node, colDef: colDef } = this.params;
        if (suppressPadding) return;
        const setIndent = ()=>{
            let level = node.uiLevel;
            if (colDef && colDef.showRowGroup !== true) level = 0;
            const newIndentClass = "ag-row-group-indent-" + level;
            if (newIndentClass === this.indentClass) return;
            if (this.indentClass) this.comp.toggleCss(this.indentClass, false);
            this.indentClass = newIndentClass;
            this.comp.toggleCss(newIndentClass, true);
            this.eGui.style.setProperty("--ag-indentation-level", String(level));
        };
        this.addManagedListeners(node, {
            uiLevelChanged: setIndent.bind(this)
        });
        setIndent();
    }
    /**
   * Selection checkboxes
   */ setupCheckbox() {
        const { node: node } = this.params;
        const isRowSelectable = !node.footer && !node.rowPinned && !node.detail;
        if (!isRowSelectable) return;
        this.addManagedPropertyListener("rowSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            const curr = typeof currentValue === "object" ? currentValue : void 0;
            const prev = typeof previousValue === "object" ? previousValue : void 0;
            if (curr?.checkboxLocation !== prev?.checkboxLocation) {
                this.destroyCheckbox();
                this.addCheckbox();
            }
        });
        this.addCheckbox();
    }
    addCheckbox() {
        const { selectionSvc: selectionSvc } = this.beans;
        if (!selectionSvc || !(0, $437b23f6a393c3bf$export$5d5fd838f5df1dd2)(this.gos)) return;
        const { node: node, column: column } = this.params;
        const rowSelection = this.gos.get("rowSelection");
        const checkboxLocation = (0, $437b23f6a393c3bf$export$8fb5d781b5c28347)(rowSelection);
        if (checkboxLocation === "selectionColumn") return;
        if (checkboxLocation === "autoGroupColumn") {
            const isGroupColumn = column?.getColDef().showRowGroup != null;
            const isFullWidthGroupRow = !column && node.group;
            const isApplicableCell = isGroupColumn || isFullWidthGroupRow;
            if (!isApplicableCell) return;
        }
        const checkboxes = typeof rowSelection === "object" ? (0, $437b23f6a393c3bf$export$6df3a55606bca6ae)(rowSelection) : this.params.checkbox;
        const userWantsCheckboxes = typeof checkboxes === "function" || checkboxes === true;
        if (!userWantsCheckboxes) return;
        const isMultiAutoCol = typeof column?.getColDef().showRowGroup === "string";
        if (isMultiAutoCol && !this.isExpandable()) {
            this.comp.setCheckboxSpacing(true);
            return;
        }
        const cbSelectionComponent = selectionSvc.createCheckboxSelectionComponent();
        this.cbComp = cbSelectionComponent;
        this.createBean(cbSelectionComponent);
        cbSelectionComponent.init({
            rowNode: node,
            column: // when groupHideOpenParents = true and group expanded, we want the checkbox to refer to leaf node state (not group node state)
            column,
            overrides: {
                isVisible: checkboxes,
                callbackParams: this.params,
                removeHidden: true
            }
        });
        this.eCheckbox.appendChild(cbSelectionComponent.getGui());
        this.comp.setCheckboxVisible(true);
    }
    destroyCheckbox() {
        this.comp.setCheckboxSpacing(false);
        this.comp.setCheckboxVisible(false);
        this.cbComp?.getGui().remove();
        this.cbComp = this.destroyBean(this.cbComp);
    }
    /**
   * Called when the expand / contract icon is clicked.
   */ onExpandClicked(mouseEvent) {
        if ((0, $437b23f6a393c3bf$export$9a48e23524c6d58)(mouseEvent)) return;
        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(mouseEvent);
        this.onExpandOrContract(mouseEvent);
    }
    /**
   * Called on cell key press - only handles 'Enter' key for expand/collapse
   */ onKeyDown(event) {
        const isEnterKey = event.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER;
        if (!isEnterKey || this.params.suppressEnterExpand) return;
        const cellEditable = this.params.column?.isCellEditable(this.params.node);
        if (cellEditable) return;
        this.onExpandOrContract(event);
    }
    /**
   * Called on cell double click - only expands/collapses if the event is not on the expand / contract icon
   */ onCellDblClicked(mouseEvent) {
        if ((0, $437b23f6a393c3bf$export$9a48e23524c6d58)(mouseEvent)) return;
        const targetIsExpandIcon = (0, $437b23f6a393c3bf$export$b5446458166e97b4)(this.eExpanded, mouseEvent) || (0, $437b23f6a393c3bf$export$b5446458166e97b4)(this.eContracted, mouseEvent);
        if (!targetIsExpandIcon) this.onExpandOrContract(mouseEvent);
    }
    /**
   * Called when expand or contract is attempted, to scroll the row and update the node state
   * @param e originating event
   */ onExpandOrContract(e) {
        if (!this.isExpandable()) return;
        const rowNode = this.displayedNode;
        const nextExpandState = !rowNode.expanded;
        if (!nextExpandState && rowNode.sticky) this.beans.ctrlsSvc.getScrollFeature().setVerticalScrollPosition(rowNode.rowTop - rowNode.stickyRowTop);
        rowNode.setExpanded(nextExpandState, e);
    }
    destroy() {
        super.destroy();
        this.destroyCheckbox();
    }
};
// packages/ag-grid-enterprise/src/rowHierarchy/rendering/groupCellRenderer.ts
var $5b7ccabde48fae90$var$GroupCellRendererElement = {
    tag: "span",
    cls: "ag-cell-wrapper",
    children: [
        {
            tag: "span",
            ref: "eExpanded",
            cls: "ag-group-expanded ag-hidden"
        },
        {
            tag: "span",
            ref: "eContracted",
            cls: "ag-group-contracted ag-hidden"
        },
        {
            tag: "span",
            ref: "eCheckbox",
            cls: "ag-group-checkbox ag-invisible"
        },
        {
            tag: "span",
            ref: "eValue",
            cls: "ag-group-value"
        },
        {
            tag: "span",
            ref: "eChildCount",
            cls: "ag-group-child-count"
        }
    ]
};
var $5b7ccabde48fae90$var$GroupCellRenderer = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$GroupCellRendererElement);
        this.eExpanded = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eContracted = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eCheckbox = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eValue = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eChildCount = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    init(params) {
        const compProxy = {
            setInnerRenderer: (compDetails, valueToDisplay)=>this.setRenderDetails(compDetails, valueToDisplay),
            setChildCount: (count)=>this.eChildCount.textContent = count,
            toggleCss: (cssClass, value)=>this.toggleCss(cssClass, value),
            setContractedDisplayed: (expanded)=>(0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eContracted, expanded),
            setExpandedDisplayed: (expanded)=>(0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpanded, expanded),
            setCheckboxVisible: (visible)=>this.eCheckbox.classList.toggle("ag-invisible", !visible),
            setCheckboxSpacing: (add)=>this.eCheckbox.classList.toggle("ag-group-checkbox-spacing", add)
        };
        const ctrl = this.createManagedBean(new $5b7ccabde48fae90$var$GroupCellRendererCtrl());
        const fullWidth = !params.colDef;
        const eGui = this.getGui();
        ctrl.init(compProxy, eGui, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, params);
        if (fullWidth) (0, $437b23f6a393c3bf$export$f8d01fa01787902)(eGui, ctrl.getCellAriaRole());
    }
    setRenderDetails(compDetails, valueToDisplay) {
        if (compDetails) compDetails.newAgStackInstance().then((comp)=>{
            if (!comp) return;
            const destroyComp = ()=>this.destroyBean(comp);
            if (this.isAlive()) {
                this.eValue.appendChild(comp.getGui());
                this.addDestroyFunc(destroyComp);
            } else destroyComp();
        });
        else this.eValue.innerText = valueToDisplay;
    }
    destroy() {
        this.destroyBean(this.innerCellRenderer);
        super.destroy();
    }
    refresh() {
        return false;
    }
};
// packages/ag-grid-enterprise/src/rowHierarchy/rendering/groupCellStyles.css-GENERATED.ts
var $5b7ccabde48fae90$var$groupCellStylesCSS = /*css*/ `.ag-group-checkbox-spacing{width:var(--ag-icon-size)}:where(.ag-ltr) .ag-group-checkbox-spacing{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-checkbox-spacing{margin-left:var(--ag-cell-widget-spacing)}`;
var $5b7ccabde48fae90$var$ShowRowGroupColValueService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "showRowGroupColValueSvc";
    }
    /**
   * Get the value for format in the group column, also returns the displayedNode from which the value was
   * taken in cases of groupHideOpenParents and showOpenedGroup.
   */ getGroupValue(node, column) {
        if (!column) {
            if (!node.group) return null;
            return {
                displayedNode: node,
                value: node.groupValue
            };
        }
        const valueSvc = this.beans.valueSvc;
        const rowGroupColId = column.colDef.showRowGroup;
        if (!rowGroupColId) return null;
        if (node.level === -1 && node.footer) return {
            displayedNode: node,
            value: null
        };
        if (typeof rowGroupColId === "string") {
            const colRowGroupIndex = this.beans.rowGroupColsSvc?.getColumnIndex(rowGroupColId) ?? -1;
            if (colRowGroupIndex > node.level) return null;
            const hideOpenParentsNode = this.getDisplayedNode(node, column, true);
            if (hideOpenParentsNode) return {
                displayedNode: hideOpenParentsNode,
                value: valueSvc.getValue(column, hideOpenParentsNode)
            };
        }
        const value = valueSvc.getValue(column, node);
        if (value == null) {
            const displayedNode = this.getDisplayedNode(node, column);
            if (displayedNode) return {
                displayedNode: displayedNode,
                value: valueSvc.getValue(column, displayedNode)
            };
        }
        return {
            displayedNode: node,
            value: value
        };
    }
    /**
   * Formats a group col value, and prefixes it with the "Total" prefix if applicable
   */ formatAndPrefixGroupColValue(groupValue, column, exporting = false) {
        const formattedValue = this.formatGroupColValue(groupValue, column, exporting);
        const { value: value, displayedNode: displayedNode } = groupValue;
        const footerSvc = this.beans.footerSvc;
        if (footerSvc?.doesCellShowTotalPrefix(displayedNode, column)) {
            const footerValue = footerSvc.applyTotalPrefix(value, formattedValue, displayedNode, column);
            return footerValue;
        }
        if (displayedNode.footer && displayedNode.level === -1) return null;
        return formattedValue;
    }
    /**
   * Formats the group col value using the underlying column's value formatter
   */ formatGroupColValue(groupValue, column, exporting = false) {
        const valueSvc = this.beans.valueSvc;
        const { displayedNode: displayedNode, value: value } = groupValue;
        const groupedCol = displayedNode.rowGroupColumn;
        const isFullWidthGroup = displayedNode.group && !column;
        const isShowingGroupCell = groupedCol && (isFullWidthGroup || column?.isRowGroupDisplayed(groupedCol.colId));
        if (isShowingGroupCell) {
            if (exporting && groupedCol.colDef.useValueFormatterForExport === false) return null;
            const formattedValue = valueSvc.formatValue(groupedCol, displayedNode, value);
            if (formattedValue == null && displayedNode.key === "") {
                const localeTextFunc = this.getLocaleTextFunc();
                return localeTextFunc("blanks", "(Blanks)");
            }
            return formattedValue;
        }
        if (!column || displayedNode.group) return null;
        if (exporting && column.colDef.useValueFormatterForExport === false) return null;
        return valueSvc.formatValue(column, displayedNode, value);
    }
    /**
   * Checks if the node has a value to inherit from the parent node for display in the given column
   *
   * This is used when [groupHideOpenParents] or [showOpenedGroup] are enabled
   *
   * @param node node to check for preferential nodes to display
   * @param column column to get the displayed node for
   * @returns a parent node of node to display the value from, or undefined if no value will be inherited
   */ getDisplayedNode(node, column, onlyHideOpenParents = false) {
        const gos = this.gos;
        const isGroupHideOpenParents = gos.get("groupHideOpenParents");
        const isShowOpenedGroupValue = gos.get("showOpenedGroup") && !onlyHideOpenParents;
        if (!isGroupHideOpenParents && !isShowOpenedGroupValue) return void 0;
        const showRowGroup = column.colDef.showRowGroup;
        if (showRowGroup === true) {
            if (node.group) return void 0;
            return node.parent ?? void 0;
        }
        let pointer = node;
        while(pointer && pointer.rowGroupColumn?.getId() != showRowGroup){
            const isFirstChild = pointer === pointer.parent?.getFirstChild();
            if (!isShowOpenedGroupValue && !isFirstChild) return void 0;
            pointer = pointer.parent;
        }
        if (pointer === node) return void 0;
        return pointer ?? void 0;
    }
};
var $5b7ccabde48fae90$var$ShowRowGroupColsService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "showRowGroupCols";
        this.columns = [];
        this.colsSet = /* @__PURE__ */ new Set();
        this.colsMap = /* @__PURE__ */ new Map();
    }
    destroy() {
        super.destroy();
        this.columns.length = 0;
        this.colsSet.clear();
        this.colsMap.clear();
    }
    refresh() {
        const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        const showRowGroupCols = this.columns;
        const showRowGroupColsSet = this.colsSet;
        const showRowGroupColsMap = this.colsMap;
        showRowGroupColsMap.clear();
        const oldShowRowGroupColsLLen = showRowGroupCols.length;
        let showRowGroupColsCount = 0;
        let showRowGroupColsSetChanged = false;
        const cols = colModel.getCols();
        for(let colIdx = 0, colsLen = cols.length; colIdx < colsLen; ++colIdx){
            const col = cols[colIdx];
            const colDef = col.getColDef();
            const showRowGroup = colDef.showRowGroup;
            if (typeof showRowGroup === "string") showRowGroupColsMap.set(showRowGroup, col);
            else if (showRowGroup === true) {
                const groupColumns = rowGroupColsSvc?.columns;
                if (groupColumns) for(let grpColIdx = 0, grpColsLen = groupColumns.length; grpColIdx < grpColsLen; ++grpColIdx)showRowGroupColsMap.set(groupColumns[grpColIdx].getId(), col);
            } else continue;
            showRowGroupColsSetChanged || (showRowGroupColsSetChanged = showRowGroupColsCount >= oldShowRowGroupColsLLen || !showRowGroupColsSet.has(col));
            showRowGroupCols[showRowGroupColsCount++] = col;
        }
        showRowGroupColsSetChanged || (showRowGroupColsSetChanged = showRowGroupColsCount !== oldShowRowGroupColsLLen);
        if (showRowGroupColsSetChanged) {
            showRowGroupCols.length = showRowGroupColsCount;
            showRowGroupColsSet.clear();
            for(let j = 0; j < showRowGroupColsCount; ++j)showRowGroupColsSet.add(showRowGroupCols[j]);
            this.eventSvc.dispatchEvent({
                type: "showRowGroupColsSetChanged"
            });
        }
    }
    getShowRowGroupCol(id) {
        return this.colsMap.get(id);
    }
    getSourceColumnsForGroupColumn(groupCol) {
        const sourceColumnId = groupCol.getColDef().showRowGroup;
        if (!sourceColumnId) return null;
        const { rowGroupColsSvc: rowGroupColsSvc, colModel: colModel } = this.beans;
        if (sourceColumnId === true && rowGroupColsSvc) return rowGroupColsSvc.columns;
        const column = colModel.getColDefCol(sourceColumnId);
        return column ? [
            column
        ] : null;
    }
    isRowGroupDisplayed(column, colId) {
        const showRowGroup = column.getColDef()?.showRowGroup;
        return showRowGroup === true || showRowGroup != null && showRowGroup === colId;
    }
};
var $5b7ccabde48fae90$var$StickyRowFeature = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(createRowCon, destroyRowCtrls){
        super();
        this.createRowCon = createRowCon;
        this.destroyRowCtrls = destroyRowCtrls;
        this.stickyTopRowCtrls = [];
        this.stickyBottomRowCtrls = [];
        // sticky rows pulls in extra rows from other pages which impacts row position
        this.extraTopHeight = 0;
        this.extraBottomHeight = 0;
    }
    postConstruct() {
        this.isClientSide = (0, $437b23f6a393c3bf$export$9f182d9ca737e15)(this.gos);
        this.beans.ctrlsSvc.whenReady(this, (params)=>{
            this.gridBodyCtrl = params.gridBodyCtrl;
        });
        this.resetStickyContainers();
    }
    setOffsetTop(offset) {
        if (this.extraTopHeight === offset) return;
        this.extraTopHeight = offset;
        this.eventSvc.dispatchEvent({
            type: "stickyTopOffsetChanged",
            offset: offset
        });
    }
    setOffsetBottom(offset) {
        if (this.extraBottomHeight === offset) return;
        this.extraBottomHeight = offset;
    }
    resetOffsets() {
        this.setOffsetBottom(0);
        this.setOffsetTop(0);
    }
    /**
   * Get the last pixel of the group, this pixel is used to push the sticky node up out of the viewport.
   */ getLastPixelOfGroup(row) {
        return this.isClientSide ? $5b7ccabde48fae90$var$getClientSideLastPixelOfGroup(row) : $5b7ccabde48fae90$var$getServerSideLastPixelOfGroup(row);
    }
    /**
   * Get the first pixel of the group, this pixel is used to push the sticky node down out of the viewport
   */ getFirstPixelOfGroup(row) {
        if (row.footer) return row.sibling.rowTop + row.sibling.rowHeight - 1;
        if (row.hasChildren()) return row.rowTop - 1;
        return 0;
    }
    updateStickyRows(container) {
        const isTop = container === "top";
        let newStickyContainerHeight = 0;
        if (!this.canRowsBeSticky()) return this.refreshNodesAndContainerHeight(container, /* @__PURE__ */ new Set(), newStickyContainerHeight);
        const { rowModel: rowModel, rowRenderer: rowRenderer, pinnedRowModel: pinnedRowModel } = this.beans;
        const pixelAtContainerBoundary = isTop ? rowRenderer.firstVisibleVPixel - this.extraTopHeight : rowRenderer.lastVisibleVPixel - this.extraTopHeight;
        const newStickyRows = /* @__PURE__ */ new Set();
        const addStickyRow = (stickyRow)=>{
            newStickyRows.add(stickyRow);
            if (isTop) {
                const lastChildBottom = this.getLastPixelOfGroup(stickyRow);
                const stickRowBottom = pixelAtContainerBoundary + newStickyContainerHeight + stickyRow.rowHeight;
                if (lastChildBottom < stickRowBottom) stickyRow.stickyRowTop = newStickyContainerHeight + (lastChildBottom - stickRowBottom);
                else stickyRow.stickyRowTop = newStickyContainerHeight;
            } else {
                const lastChildBottom = this.getFirstPixelOfGroup(stickyRow);
                const stickRowTop = pixelAtContainerBoundary - (newStickyContainerHeight + stickyRow.rowHeight);
                if (lastChildBottom > stickRowTop) stickyRow.stickyRowTop = newStickyContainerHeight - (lastChildBottom - stickRowTop);
                else stickyRow.stickyRowTop = newStickyContainerHeight;
            }
            newStickyContainerHeight = 0;
            newStickyRows.forEach((rowNode)=>{
                const thisRowLastPx = rowNode.stickyRowTop + rowNode.rowHeight;
                if (newStickyContainerHeight < thisRowLastPx) newStickyContainerHeight = thisRowLastPx;
            });
        };
        const suppressFootersSticky = this.areFooterRowsStickySuppressed();
        const suppressGroupsSticky = this.gos.get("suppressGroupRowsSticky");
        const isRowSticky = (row)=>{
            if (!row.displayed) return false;
            if (row.footer) {
                if (suppressFootersSticky === true) return false;
                if (suppressFootersSticky === "grand" && row.level === -1) return false;
                if (suppressFootersSticky === "group" && row.level > -1) return false;
                const isFooterFirstRowInGroup = row.sibling.rowIndex ? row.sibling.rowIndex + 1 === row.rowIndex : false;
                if (container === "bottom" && isFooterFirstRowInGroup) return false;
                if (row.level === -1 && pinnedRowModel?.getGrandTotalPinned()) return false;
                const alreadySticking = newStickyRows.has(row);
                return !alreadySticking;
            }
            if (row.isExpandable()) {
                if (suppressGroupsSticky === true) return false;
                if (container === "bottom") return false;
                const alreadySticking = newStickyRows.has(row);
                return !alreadySticking && row.expanded;
            }
            return false;
        };
        for(let i = 0; i < 100; i++){
            let firstPixelAfterStickyRows = pixelAtContainerBoundary + newStickyContainerHeight;
            if (!isTop) firstPixelAfterStickyRows = pixelAtContainerBoundary - newStickyContainerHeight;
            const firstIndex = rowModel.getRowIndexAtPixel(firstPixelAfterStickyRows);
            const firstRow = rowModel.getRow(firstIndex);
            if (firstRow == null) break;
            const ancestors = this.getStickyAncestors(firstRow);
            const firstMissingParent = ancestors.find((parent)=>(isTop ? parent.rowIndex < firstIndex : parent.rowIndex > firstIndex) && isRowSticky(parent));
            if (firstMissingParent) {
                addStickyRow(firstMissingParent);
                continue;
            }
            const isFirstRowOutsideViewport = isTop ? firstRow.rowTop < firstPixelAfterStickyRows : firstRow.rowTop + firstRow.rowHeight > firstPixelAfterStickyRows;
            if (isFirstRowOutsideViewport && isRowSticky(firstRow)) {
                addStickyRow(firstRow);
                continue;
            }
            break;
        }
        if (!isTop) newStickyRows.forEach((rowNode)=>{
            rowNode.stickyRowTop = newStickyContainerHeight - (rowNode.stickyRowTop + rowNode.rowHeight);
        });
        return this.refreshNodesAndContainerHeight(container, newStickyRows, newStickyContainerHeight);
    }
    areFooterRowsStickySuppressed() {
        const suppressFootersSticky = this.gos.get("suppressStickyTotalRow");
        if (suppressFootersSticky === true) return true;
        const suppressGroupRows = suppressFootersSticky === "group";
        const suppressGrandRows = suppressFootersSticky === "grand";
        if (suppressGroupRows && suppressGrandRows) return true;
        if (suppressGrandRows) return "grand";
        if (suppressGroupRows) return "group";
        return false;
    }
    canRowsBeSticky() {
        const isStickyEnabled = (0, $437b23f6a393c3bf$export$d5f33aacea6a0849)(this.gos);
        const suppressFootersSticky = this.areFooterRowsStickySuppressed();
        const suppressGroupsSticky = this.gos.get("suppressGroupRowsSticky");
        return isStickyEnabled && (!suppressFootersSticky || !suppressGroupsSticky);
    }
    getStickyAncestors(rowNode) {
        const ancestors = [];
        let p = rowNode.footer ? rowNode.sibling : rowNode.parent;
        while(p){
            if (p.sibling) ancestors.push(p.sibling);
            ancestors.push(p);
            p = p.parent;
        }
        return ancestors.reverse();
    }
    checkStickyRows() {
        const hasTopUpdated = this.updateStickyRows("top");
        const hasBottomUpdated = this.updateStickyRows("bottom");
        return hasTopUpdated || hasBottomUpdated;
    }
    destroyStickyCtrls() {
        this.resetStickyContainers();
    }
    resetStickyContainers() {
        this.refreshNodesAndContainerHeight("top", /* @__PURE__ */ new Set(), 0);
        this.refreshNodesAndContainerHeight("bottom", /* @__PURE__ */ new Set(), 0);
    }
    refreshStickyNode(stickRowNode) {
        const allStickyNodes = /* @__PURE__ */ new Set();
        if (this.stickyTopRowCtrls.some((ctrl)=>ctrl.rowNode === stickRowNode)) {
            for(let i = 0; i < this.stickyTopRowCtrls.length; i++){
                const currentNode = this.stickyTopRowCtrls[i].rowNode;
                if (currentNode !== stickRowNode) allStickyNodes.add(currentNode);
            }
            if (this.refreshNodesAndContainerHeight("top", allStickyNodes, this.topContainerHeight)) this.checkStickyRows();
            return;
        }
        for(let i = 0; i < this.stickyBottomRowCtrls.length; i++){
            const currentNode = this.stickyBottomRowCtrls[i].rowNode;
            if (currentNode !== stickRowNode) allStickyNodes.add(currentNode);
        }
        if (this.refreshNodesAndContainerHeight("bottom", allStickyNodes, this.bottomContainerHeight)) this.checkStickyRows();
    }
    /**
   * Destroy old ctrls and create new ctrls where necessary.
   */ refreshNodesAndContainerHeight(container, newStickyNodes, height) {
        const isTop = container === "top";
        const previousCtrls = isTop ? this.stickyTopRowCtrls : this.stickyBottomRowCtrls;
        const removedCtrlsMap = {};
        const remainingCtrls = [];
        for(let i = 0; i < previousCtrls.length; i++){
            const node = previousCtrls[i].rowNode;
            const hasBeenRemoved = !newStickyNodes.has(node);
            if (hasBeenRemoved) {
                removedCtrlsMap[node.id] = previousCtrls[i];
                node.sticky = false;
                continue;
            }
            remainingCtrls.push(previousCtrls[i]);
        }
        const existingNodes = /* @__PURE__ */ new Set();
        for(let i = 0; i < remainingCtrls.length; i++)existingNodes.add(remainingCtrls[i].rowNode);
        const newCtrls = [];
        newStickyNodes.forEach((node)=>{
            if (existingNodes.has(node)) return;
            node.sticky = true;
            newCtrls.push(this.createRowCon(node, false, false));
        });
        let hasSomethingChanged = !!newCtrls.length || remainingCtrls.length !== previousCtrls.length;
        if (isTop) {
            if (this.topContainerHeight !== height) {
                this.topContainerHeight = height;
                this.gridBodyCtrl.setStickyTopHeight(height);
                hasSomethingChanged = true;
            }
        } else if (this.bottomContainerHeight !== height) {
            this.bottomContainerHeight = height;
            this.gridBodyCtrl.setStickyBottomHeight(height);
            hasSomethingChanged = true;
        }
        this.destroyRowCtrls(removedCtrlsMap, false);
        const newCtrlsList = [
            ...remainingCtrls,
            ...newCtrls
        ];
        newCtrlsList.sort((a, b)=>b.rowNode.rowIndex - a.rowNode.rowIndex);
        if (!isTop) newCtrlsList.reverse();
        for (const ctrl of newCtrlsList)ctrl.setRowTop(ctrl.rowNode.stickyRowTop);
        const pageBounds = this.beans.pageBounds;
        let extraHeight = 0;
        if (isTop) {
            for (const node of newStickyNodes)if (node.rowIndex < pageBounds.getFirstRow()) extraHeight += node.rowHeight;
            if (extraHeight > this.topContainerHeight) extraHeight = this.topContainerHeight;
            this.setOffsetTop(extraHeight);
        } else {
            for (const node of newStickyNodes)if (node.rowIndex > pageBounds.getLastRow()) extraHeight += node.rowHeight;
            if (extraHeight > this.bottomContainerHeight) extraHeight = this.bottomContainerHeight;
            this.setOffsetBottom(extraHeight);
        }
        if (!hasSomethingChanged) return false;
        if (isTop) this.stickyTopRowCtrls = newCtrlsList;
        else this.stickyBottomRowCtrls = newCtrlsList;
        return true;
    }
    ensureRowHeightsValid() {
        let anyChange = false;
        const updateRowHeight = (ctrl)=>{
            const rowNode = ctrl.rowNode;
            if (rowNode.rowHeightEstimated) {
                const rowHeight = (0, $437b23f6a393c3bf$export$b6de5fa3decc8f7b)(this.beans, rowNode);
                rowNode.setRowHeight(rowHeight.height);
                anyChange = true;
            }
        };
        this.stickyTopRowCtrls.forEach(updateRowHeight);
        this.stickyBottomRowCtrls.forEach(updateRowHeight);
        return anyChange;
    }
};
function $5b7ccabde48fae90$var$getServerSideLastPixelOfGroup(row) {
    if (row.isExpandable() || row.footer) {
        if (row.master && row.detailNode) return row.detailNode.rowTop + row.detailNode.rowHeight;
        const noOrContiguousSiblings = !row.sibling || Math.abs(row.sibling.rowIndex - row.rowIndex) === 1;
        if (noOrContiguousSiblings) {
            let storeBounds = row.childStore?.getStoreBounds();
            if (row.footer) storeBounds = row.sibling.childStore?.getStoreBounds();
            return (storeBounds?.heightPx ?? 0) + (storeBounds?.topPx ?? 0);
        }
        if (row.footer) return row.rowTop + row.rowHeight;
        return row.sibling.rowTop + row.sibling.rowHeight;
    }
    return Number.MAX_SAFE_INTEGER;
}
function $5b7ccabde48fae90$var$getClientSideLastPixelOfGroup(row) {
    if (row.isExpandable() || row.footer) {
        const grandTotalAtTop = row.footer && row.rowIndex === 0;
        if (grandTotalAtTop) return Number.MAX_SAFE_INTEGER;
        const noOrContiguousSiblings = !row.sibling || Math.abs(row.sibling.rowIndex - row.rowIndex) === 1;
        if (noOrContiguousSiblings) {
            let lastAncestor = row.footer ? row.sibling : row;
            while(lastAncestor.isExpandable() && lastAncestor.expanded){
                if (lastAncestor.master && lastAncestor.detailNode) lastAncestor = lastAncestor.detailNode;
                else if (lastAncestor.childrenAfterSort) {
                    if (lastAncestor.childrenAfterSort.length === 0) break;
                    lastAncestor = (0, $437b23f6a393c3bf$export$236389741107357f)(lastAncestor.childrenAfterSort);
                }
            }
            return lastAncestor.rowTop + lastAncestor.rowHeight;
        }
        if (row.footer) return row.rowTop + row.rowHeight;
        return row.sibling.rowTop + row.sibling.rowHeight;
    }
    return Number.MAX_SAFE_INTEGER;
}
// packages/ag-grid-enterprise/src/rowHierarchy/stickyRowService.ts
var $5b7ccabde48fae90$var$StickyRowService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "stickyRowSvc";
    }
    createStickyRowFeature(ctrl, createRowCon, destroyRowCtrls) {
        const gos = this.gos;
        if ((0, $437b23f6a393c3bf$export$d5f33aacea6a0849)(gos) && (0, $437b23f6a393c3bf$export$9f182d9ca737e15)(gos) || (0, $437b23f6a393c3bf$export$cf1bac0013650216)(gos)) return ctrl.createManagedBean(new $5b7ccabde48fae90$var$StickyRowFeature(createRowCon, destroyRowCtrls));
        return void 0;
    }
};
// packages/ag-grid-enterprise/src/rowHierarchy/rowHierarchyModule.ts
var $5b7ccabde48fae90$var$GroupCellRendererModule = {
    moduleName: "GroupCellRenderer",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agGroupRowRenderer: $5b7ccabde48fae90$var$GroupCellRenderer,
        agGroupCellRenderer: $5b7ccabde48fae90$var$GroupCellRenderer
    },
    dynamicBeans: {
        groupCellRendererCtrl: $5b7ccabde48fae90$var$GroupCellRendererCtrl
    },
    icons: {
        // shown on row group when contracted (click to expand)
        groupContracted: "tree-closed",
        // shown on row group when expanded (click to contract)
        groupExpanded: "tree-open"
    },
    css: [
        $5b7ccabde48fae90$var$groupCellStylesCSS
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
var $5b7ccabde48fae90$var$GroupColumnModule = {
    moduleName: "GroupColumn",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$AutoColService,
        $5b7ccabde48fae90$var$ShowRowGroupColsService,
        $5b7ccabde48fae90$var$ShowRowGroupColValueService,
        $5b7ccabde48fae90$var$RowGroupColsSvc,
        $5b7ccabde48fae90$var$PivotColsSvc,
        $5b7ccabde48fae90$var$ValueColsSvc
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        $5b7ccabde48fae90$var$GroupCellRendererModule
    ]
};
var $5b7ccabde48fae90$var$ClientSideRowModelHierarchyModule = {
    moduleName: "ClientSideRowModelHierarchy",
    version: $5b7ccabde48fae90$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $5b7ccabde48fae90$var$GroupStage,
        $5b7ccabde48fae90$var$FlattenStage,
        $5b7ccabde48fae90$var$ClientSideExpansionService
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
var $5b7ccabde48fae90$var$StickyRowModule = {
    moduleName: "StickyRow",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$StickyRowService
    ]
};
var $5b7ccabde48fae90$var$GroupEditModule = {
    moduleName: "GroupEdit",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$GroupEditService
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        $5b7ccabde48fae90$var$ClientSideRowModelHierarchyModule
    ]
};
var $5b7ccabde48fae90$var$AgGridHeaderDropZones = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super();
    }
    postConstruct() {
        this.setGui(this.createNorthPanel());
        const onRowGroupChanged = this.onRowGroupChanged.bind(this);
        this.addManagedEventListeners({
            columnRowGroupChanged: onRowGroupChanged,
            newColumnsLoaded: onRowGroupChanged
        });
        this.addManagedPropertyListener("rowGroupPanelShow", onRowGroupChanged);
        this.addManagedPropertyListener("pivotPanelShow", ()=>this.onPivotPanelShow());
        this.onRowGroupChanged();
    }
    createNorthPanel() {
        const topPanelGui = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div",
            cls: "ag-column-drop-wrapper",
            role: "presentation"
        });
        const rowGroupComp = new $5b7ccabde48fae90$var$RowGroupDropZonePanel(true);
        this.rowGroupComp = this.createManagedBean(rowGroupComp);
        const pivotComp = new $5b7ccabde48fae90$var$PivotDropZonePanel(true);
        this.pivotComp = this.createManagedBean(pivotComp);
        topPanelGui.appendChild(rowGroupComp.getGui());
        topPanelGui.appendChild(pivotComp.getGui());
        const listener = this.onDropPanelVisible.bind(this);
        this.addManagedListeners(rowGroupComp, {
            displayChanged: listener
        });
        this.addManagedListeners(pivotComp, {
            displayChanged: listener
        });
        this.onDropPanelVisible();
        return topPanelGui;
    }
    onDropPanelVisible() {
        const { rowGroupComp: rowGroupComp, pivotComp: pivotComp } = this;
        const bothDisplayed = rowGroupComp.isDisplayed() && pivotComp.isDisplayed();
        const classStr = "ag-column-drop-horizontal-half-width";
        rowGroupComp.toggleCss(classStr, bothDisplayed);
        pivotComp.toggleCss(classStr, bothDisplayed);
    }
    onRowGroupChanged() {
        const rowGroupComp = this.rowGroupComp;
        if (!rowGroupComp) return;
        const rowGroupPanelShow = this.gos.get("rowGroupPanelShow");
        if (rowGroupPanelShow === "always") rowGroupComp.setDisplayed(true);
        else if (rowGroupPanelShow === "onlyWhenGrouping") {
            const grouping = this.beans.rowGroupColsSvc?.columns?.length !== 0;
            rowGroupComp.setDisplayed(grouping);
        } else rowGroupComp.setDisplayed(false);
    }
    onPivotPanelShow() {
        const pivotComp = this.pivotComp;
        if (!pivotComp) return;
        const pivotPanelShow = this.gos.get("pivotPanelShow");
        if (pivotPanelShow === "always") pivotComp.setDisplayed(true);
        else if (pivotPanelShow === "onlyWhenPivoting") {
            const pivoting = this.beans.colModel.isPivotActive();
            pivotComp.setDisplayed(pivoting);
        } else pivotComp.setDisplayed(false);
    }
};
var $5b7ccabde48fae90$var$AgGridHeaderDropZonesSelector = {
    selector: "AG-GRID-HEADER-DROP-ZONES",
    component: $5b7ccabde48fae90$var$AgGridHeaderDropZones
};
function $5b7ccabde48fae90$var$processGroupFilterParams(params) {
    if (params.buttons) params.buttons = [];
    return params;
}
var $5b7ccabde48fae90$var$GroupFilterElement = {
    tag: "div",
    cls: "ag-group-filter",
    children: [
        {
            tag: "div",
            ref: "eGroupField"
        },
        {
            tag: "div",
            ref: "eUnderlyingFilter"
        }
    ]
};
var $5b7ccabde48fae90$var$GroupFilter = class extends (0, $437b23f6a393c3bf$export$5a26e3abd1c845b6) {
    constructor(){
        super($5b7ccabde48fae90$var$GroupFilterElement);
        this.filterType = "group";
        this.eGroupField = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eUnderlyingFilter = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    wireBeans(beans) {
        this.groupFilterSvc = beans.groupFilter;
    }
    postConstruct() {
        this.initialiseTabGuard({});
    }
    init(legacyParams) {
        this.params = legacyParams;
        return this.updateParams().then(()=>{
            this.addHandlerListeners(this.updateGroups.bind(this));
        });
    }
    refresh(legacyParams) {
        const params = legacyParams;
        this.params = params;
        if (params.source === "colDef") this.updateParams();
        return true;
    }
    updateParams() {
        this.validateParams();
        return this.updateGroups();
    }
    validateParams() {
        const { colDef: colDef } = this.params;
        if (colDef.field) (0, $437b23f6a393c3bf$export$545083624300f13d)(234);
        if (colDef.filterValueGetter) (0, $437b23f6a393c3bf$export$545083624300f13d)(235);
        if (colDef.filterParams) (0, $437b23f6a393c3bf$export$545083624300f13d)(236);
    }
    addHandlerListeners(listener) {
        const destroyFunctions = this.addManagedListeners(this.getHandler(), {
            sourceColumnsChanged: ()=>{
                this.updateGroups();
            },
            destroyed: ()=>{
                for (const func of destroyFunctions)func();
                this.addHandlerListeners(listener);
            }
        });
    }
    updateGroups() {
        const { sourceColumns: sourceColumns, selectedColumn: selectedColumn } = this.updateGroupField();
        this.dispatchLocalEvent({
            type: "columnsChanged"
        });
        return this.getUnderlyingFilters(sourceColumns, selectedColumn);
    }
    updateGroupField() {
        this.groupColumn = this.params.column;
        const handler = this.getHandler();
        if (!handler) return {
            sourceColumns: null
        };
        const { sourceColumns: sourceColumns, hasMultipleColumns: hasMultipleColumns, selectedColumn: selectedColumn } = handler;
        const eGroupField = this.eGroupField;
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(eGroupField);
        if (this.eGroupFieldSelect) this.destroyBean(this.eGroupFieldSelect);
        if (hasMultipleColumns && sourceColumns) {
            this.createGroupFieldSelectElement(sourceColumns, selectedColumn);
            eGroupField.appendChild(this.eGroupFieldSelect.getGui());
            eGroupField.appendChild((0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
                tag: "div",
                cls: "ag-filter-separator"
            }));
        }
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eGroupField, hasMultipleColumns);
        return {
            sourceColumns: sourceColumns,
            selectedColumn: selectedColumn
        };
    }
    createGroupFieldSelectElement(sourceColumns, selectedColumn) {
        const eGroupFieldSelect = this.createManagedBean(new (0, $437b23f6a393c3bf$export$6f9c460854d56032)());
        this.eGroupFieldSelect = eGroupFieldSelect;
        const localeTextFunc = this.getLocaleTextFunc();
        eGroupFieldSelect.setLabel(localeTextFunc("groupFilterSelect", "Select field:"));
        eGroupFieldSelect.setLabelAlignment("top");
        eGroupFieldSelect.addOptions(sourceColumns.map((sourceColumn)=>({
                value: sourceColumn.getColId(),
                text: this.beans.colNames.getDisplayNameForColumn(sourceColumn, "groupFilter", false) ?? void 0
            })));
        eGroupFieldSelect.setValue(selectedColumn.getColId());
        eGroupFieldSelect.onValueChange((newValue)=>this.updateSelectedColumn(newValue));
        eGroupFieldSelect.addCss("ag-group-filter-field-select-wrapper");
        if (sourceColumns.length === 1) eGroupFieldSelect.setDisabled(true);
    }
    getUnderlyingFilters(sourceColumns, selectedColumn) {
        if (!sourceColumns) {
            this.filterColumnPairs = void 0;
            this.selectedFilter = void 0;
            return (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve();
        }
        const filterPromises = [];
        const filterColumnPairs = [];
        const colFilter = this.beans.colFilter;
        for (const column of sourceColumns){
            const filterPromise = colFilter.getOrCreateFilterUi(column);
            if (filterPromise) filterPromises.push(filterPromise.then((filter)=>{
                if (filter) filterColumnPairs.push({
                    filter: filter,
                    column: column
                });
                if (column.getColId() === selectedColumn.getColId()) this.selectedFilter = filter ?? void 0;
            }));
        }
        return (0, $437b23f6a393c3bf$export$30ec7836a4847721).all(filterPromises).then(()=>{
            this.filterColumnPairs = filterColumnPairs;
        });
    }
    addUnderlyingFilterElement(selectedColumn) {
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.eUnderlyingFilter);
        if (!selectedColumn) return (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve();
        const comp = this.createManagedBean(new (0, $437b23f6a393c3bf$export$7db6d402989d8b90)(selectedColumn, "COLUMN_MENU"));
        this.filterComp = comp;
        if (!comp.hasFilter()) return (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve();
        this.eUnderlyingFilter.appendChild(comp.getGui());
        return comp.getFilter()?.then(()=>{
            comp.afterGuiAttached?.(this.afterGuiAttachedParams);
            if (!this.afterGuiAttachedParams?.suppressFocus && this.eGroupFieldSelect && !this.eGroupFieldSelect.isDisabled()) this.eGroupFieldSelect.getFocusableElement().focus();
        }) ?? (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve();
    }
    updateSelectedColumn(columnId) {
        if (!columnId) return;
        this.filterComp?.afterGuiDetached();
        this.destroyBean(this.filterComp);
        const selectedFilterColumnPair = this.getFilterColumnPair(columnId);
        const selectedColumn = selectedFilterColumnPair?.column;
        this.selectedFilter = selectedFilterColumnPair?.filter;
        this.getHandler().setSelectedColumn(selectedColumn);
        this.dispatchLocalEvent({
            type: "columnsChanged"
        });
        this.addUnderlyingFilterElement(selectedColumn);
    }
    isFilterActive() {
        return this.groupFilterSvc.isFilterActive(this.groupColumn);
    }
    doesFilterPass() {
        return true;
    }
    getModel() {
        return null;
    }
    setModel() {}
    afterGuiAttached(params) {
        this.afterGuiAttachedParams = params;
        this.addUnderlyingFilterElement(this.getHandler().selectedColumn);
    }
    afterGuiDetached() {
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.eUnderlyingFilter);
        this.selectedFilter?.afterGuiDetached?.();
    }
    getSelectedColumn() {
        return this.getHandler().selectedColumn;
    }
    getHandler() {
        return this.params.getHandler();
    }
    getFilterColumnPair(columnId) {
        if (!columnId) return void 0;
        return this.filterColumnPairs?.find(({ column: column })=>column.getColId() === columnId);
    }
};
var $5b7ccabde48fae90$var$GroupFilterHandler = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    init(params) {
        this.params = params;
        this.validateModel(params);
        this.updateColumns();
        this.addManagedEventListeners({
            columnRowGroupChanged: this.updateColumns.bind(this),
            filterDestroyed: (event)=>this.onFilterDestroyed(event)
        });
    }
    refresh(params) {
        this.params = params;
        this.validateModel(params);
        if (params.source === "colDef") this.updateColumns();
    }
    doesFilterPass() {
        return true;
    }
    setSelectedColumn(selectedColumn) {
        this.selectedColumn = selectedColumn;
        this.dispatchLocalEvent({
            type: "selectedColumnChanged"
        });
    }
    validateModel(params) {
        if (params.model != null) params.onModelChange(null);
    }
    getSourceColumns() {
        const groupColumn = this.params.column;
        if (this.gos.get("treeData")) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(237);
            return [];
        }
        const sourceColumns = this.beans.groupFilter.getSourceColumns(groupColumn);
        if (!sourceColumns) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(183);
            return [];
        }
        return sourceColumns;
    }
    updateColumns() {
        const allSourceColumns = this.getSourceColumns();
        const sourceColumns = allSourceColumns.filter((sourceColumn)=>sourceColumn.isFilterAllowed());
        this.sourceColumns = sourceColumns;
        let selectedColumn;
        let hasMultipleColumns;
        if (!sourceColumns.length) {
            selectedColumn = void 0;
            hasMultipleColumns = false;
        } else if (allSourceColumns.length === 1) {
            selectedColumn = sourceColumns[0];
            hasMultipleColumns = false;
        } else {
            selectedColumn = this.selectedColumn;
            if (!selectedColumn || !sourceColumns.some((column)=>column.getId() === selectedColumn.getId())) selectedColumn = sourceColumns[0];
            hasMultipleColumns = true;
        }
        this.selectedColumn = selectedColumn;
        this.hasMultipleColumns = hasMultipleColumns;
        this.dispatchLocalEvent({
            type: "sourceColumnsChanged"
        });
    }
    onFilterDestroyed({ column: eventColumn, source: source }) {
        if (source === "gridDestroyed") return;
        const colId = eventColumn.getColId();
        if (this.sourceColumns?.some((column)=>column.getColId() === colId)) setTimeout(()=>{
            if (this.isAlive()) this.updateColumns();
        });
    }
};
var $5b7ccabde48fae90$var$GroupFilterService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "groupFilter";
    }
    postConstruct() {
        this.addManagedEventListeners({
            columnRowGroupChanged: ()=>this.updateFilterFlags("columnRowGroupChanged")
        });
    }
    isGroupFilter(column) {
        return column.getColDef().filter === "agGroupColumnFilter";
    }
    isFilterAllowed(column) {
        const colFilter = this.beans.colFilter;
        return !!this.getSourceColumns(column)?.some((column2)=>colFilter?.isFilterAllowed(column2));
    }
    isFilterActive(column) {
        const colFilter = this.beans.colFilter;
        return !!this.getSourceColumns(column)?.some((column2)=>colFilter?.isFilterActive(column2));
    }
    getSourceColumns(column) {
        return this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(column);
    }
    updateFilterFlags(source, additionalEventAttributes) {
        const { autoColSvc: autoColSvc, colFilter: colFilter } = this.beans;
        autoColSvc?.getColumns()?.forEach((groupColumn)=>{
            if (this.isGroupFilter(groupColumn)) colFilter?.setColFilterActive(groupColumn, this.isFilterActive(groupColumn), source, additionalEventAttributes);
        });
    }
};
var $5b7ccabde48fae90$var$GroupFloatingFilterElement = {
    tag: "div",
    ref: "eFloatingFilter",
    cls: "ag-group-floating-filter ag-floating-filter-input",
    role: "presentation"
};
var $5b7ccabde48fae90$var$GroupFloatingFilterComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$GroupFloatingFilterElement);
        this.eFloatingFilter = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.haveAddedColumnListeners = false;
    }
    init(params) {
        this.params = params;
        const canShowUnderlyingFloatingFilter = (0, $437b23f6a393c3bf$export$7122eb216a66bef2)(this.gos);
        const onColChange = this.onColChange.bind(this);
        const setupFilterElement = (resolve)=>{
            if (canShowUnderlyingFloatingFilter) this.setupUnderlyingFloatingFilterElement().then(()=>resolve());
            else {
                this.setupReadOnlyFloatingFilterElement();
                resolve();
            }
        };
        if (this.gos.get("enableFilterHandlers")) return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>setupFilterElement(resolve)).then(()=>{
            this.addHandlerListeners(params, onColChange);
        });
        else return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((resolve)=>{
            this.params.parentFilterInstance((parentFilterInstance)=>{
                this.parentFilterInstance = parentFilterInstance;
                setupFilterElement(resolve);
            });
        }).then(()=>{
            this.addManagedListeners(this.parentFilterInstance, {
                columnsChanged: onColChange
            });
        });
    }
    refresh(params) {
        this.params = params;
        this.setParams();
        if (this.gos.get("enableFilterHandlers")) {
            if (this.showingUnderlyingFloatingFilter) {
                const column = this.getSelectedColumn();
                const compDetails = this.beans.colFilter.getFloatingFilterCompDetails(column, this.params.showParentFilter);
                this.underlyingFloatingFilter?.refresh?.(compDetails?.params);
            } else this.updateDisplayedValue();
        }
    }
    setParams() {
        const displayName = this.beans.colNames.getDisplayNameForColumn(this.params.column, "header", true);
        const translate = this.getLocaleTextFunc();
        this.eFloatingFilterText?.setInputAriaLabel(`${displayName} ${translate("ariaFilterInput", "Filter Input")}`);
    }
    addHandlerListeners(params, listener) {
        const destroyFunctions = this.addManagedListeners(params.getHandler(), {
            selectedColumnChanged: listener,
            sourceColumnsChanged: listener,
            destroyed: ()=>{
                for (const func of destroyFunctions)func();
                this.addHandlerListeners(this.params, listener);
            }
        });
    }
    setupReadOnlyFloatingFilterElement() {
        if (!this.eFloatingFilterText) {
            this.eFloatingFilterText = this.createManagedBean(new (0, $437b23f6a393c3bf$export$8c027679838afd47)());
            this.eFloatingFilterText.setDisabled(true).addGuiEventListener("click", ()=>this.params.showParentFilter());
            this.setParams();
        }
        this.updateDisplayedValue();
        this.eFloatingFilter.appendChild(this.eFloatingFilterText.getGui());
    }
    setupUnderlyingFloatingFilterElement() {
        this.showingUnderlyingFloatingFilter = false;
        this.underlyingFloatingFilter = void 0;
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.eFloatingFilter);
        const column = this.getSelectedColumn();
        if (column && !column.isVisible()) {
            const colFilter = this.beans.colFilter;
            const compDetails = colFilter.getFloatingFilterCompDetails(column, this.params.showParentFilter);
            if (compDetails) {
                if (!this.haveAddedColumnListeners) {
                    this.haveAddedColumnListeners = true;
                    this.addManagedListeners(column, {
                        visibleChanged: this.onColumnVisibleChanged.bind(this),
                        colDefChanged: this.onColDefChanged.bind(this)
                    });
                }
                return compDetails.newAgStackInstance().then((floatingFilter)=>{
                    this.underlyingFloatingFilter = floatingFilter;
                    this.underlyingFloatingFilter?.onParentModelChanged(colFilter.getModelForColumn(column));
                    this.appendChild(floatingFilter.getGui());
                    this.showingUnderlyingFloatingFilter = true;
                });
            }
        }
        this.setupReadOnlyFloatingFilterElement();
        return (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve();
    }
    getSelectedColumn() {
        if (this.gos.get("enableFilterHandlers")) {
            const reactiveParams = this.params;
            return reactiveParams.getHandler().selectedColumn;
        } else return this.parentFilterInstance.getSelectedColumn();
    }
    onColumnVisibleChanged() {
        this.setupUnderlyingFloatingFilterElement();
    }
    onColDefChanged(event) {
        if (!event.column) return;
        const compDetails = this.beans.colFilter.getFloatingFilterCompDetails(event.column, this.params.showParentFilter);
        if (compDetails) this.underlyingFloatingFilter?.refresh?.(compDetails.params);
    }
    onParentModelChanged(_model, event) {
        if (this.showingUnderlyingFloatingFilter) this.underlyingFloatingFilter?.onParentModelChanged(this.beans.colFilter.getModelForColumn(this.getSelectedColumn()), event);
        else this.updateDisplayedValue();
    }
    updateDisplayedValue() {
        const eFloatingFilterText = this.eFloatingFilterText;
        if (!eFloatingFilterText) return;
        const colFilter = this.beans.colFilter;
        const column = this.getSelectedColumn();
        const updateText = (filterOrHandler)=>{
            if (!filterOrHandler) {
                eFloatingFilterText.setValue("");
                eFloatingFilterText.setDisplayed(false);
            } else {
                const model = column ? colFilter.getModelForColumn(column) : null;
                eFloatingFilterText.setValue(model == null ? "" : filterOrHandler.getModelAsString?.(model) ?? "");
                eFloatingFilterText.setDisplayed(true);
            }
        };
        if (this.gos.get("enableFilterHandlers")) updateText(colFilter.getHandler(column));
        else colFilter.getOrCreateFilterUi(column)?.then((filter)=>{
            updateText(filter);
        });
    }
    onColChange() {
        if (!this.showingUnderlyingFloatingFilter) this.updateDisplayedValue();
    }
};
// packages/ag-grid-enterprise/src/rowGrouping/groupStrategy/groupColumns.ts
var $5b7ccabde48fae90$var$makeGroupColumns = (columns, result)=>{
    if (!columns) {
        result.length = 0;
        return;
    }
    const len = columns.length;
    result.length = len;
    for(let i = 0; i < len; i++){
        const col = columns[i];
        const colDef = col.getColDef();
        result[i] = {
            col: col,
            field: colDef.field,
            type: colDef.type,
            keyCreator: colDef.keyCreator,
            valueGetter: colDef.valueGetter
        };
    }
};
var $5b7ccabde48fae90$var$groupColumnsChanged = (groupColumns, columns)=>{
    const len = groupColumns.length;
    if (len !== columns?.length) return true;
    for(let i = 0; i < len; i++){
        const a = groupColumns[i];
        const b = columns[i];
        if (a.col !== b) return true;
        const bColDef = b.getColDef();
        if (a.field !== bColDef.field || a.type !== bColDef.type || a.valueGetter !== bColDef.valueGetter || a.keyCreator !== bColDef.keyCreator) return true;
    }
    return false;
};
// packages/ag-grid-enterprise/src/rowGrouping/groupStrategy/sortGroupChildren.ts
function $5b7ccabde48fae90$var$sortGroupChildren(rowNodes) {
    if (!rowNodes) return false;
    const length = rowNodes.length;
    if (length < 2) return false;
    let atLeastOneOutOfOrder = false;
    for(let i = 1; i < length; i++)if ($5b7ccabde48fae90$var$compareGroupChildren(rowNodes[i - 1], rowNodes[i]) > 0) {
        atLeastOneOutOfOrder = true;
        break;
    }
    if (!atLeastOneOutOfOrder) return false;
    rowNodes.sort($5b7ccabde48fae90$var$compareGroupChildren);
    return true;
}
function $5b7ccabde48fae90$var$compareGroupChildren(nodeA, nodeB) {
    const positionA = nodeA.sourceRowIndex;
    const positionB = nodeB.sourceRowIndex;
    const aHasIndex = positionA >= 0;
    const bHasIndex = positionB >= 0;
    const bothNodesAreUserNodes = aHasIndex && bHasIndex;
    const bothNodesAreFillerNodes = !aHasIndex && !bHasIndex;
    if (bothNodesAreUserNodes) return positionA - positionB;
    if (bothNodesAreFillerNodes) return nodeA.__objectId - nodeB.__objectId;
    if (aHasIndex) return 1;
    return -1;
}
// packages/ag-grid-enterprise/src/rowGrouping/groupStrategy/groupStrategy.ts
var $5b7ccabde48fae90$var$GroupStrategy = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        // when grouping, these items are of note:
        // rowNode.parent: RowNode: set to the parent
        // rowNode.childrenAfterGroup: RowNode[] = the direct children of this group
        // rowNode.childrenMapped: string=>RowNode = children mapped by group key (when groups) or an empty map if leaf group (this is then used by pivot)
        // for leaf groups, rowNode.childrenAfterGroup = rowNode.allLeafChildren;
        this.groupCols = [];
        this.nonLeafsById = /* @__PURE__ */ new Map();
        this.checkGroupCols = true;
        this.pivotMode = false;
        this.groupEmpty = false;
    }
    invalidateGroupCols() {
        this.checkGroupCols = true;
    }
    destroy() {
        super.destroy();
        this.groupCols.length = 0;
        this.nonLeafsById.clear();
    }
    clearNonLeafs() {
        const nonLeafsById = this.nonLeafsById;
        for (const node of nonLeafsById.values())node._destroy(false);
        nonLeafsById.clear();
    }
    loadGroupData(node) {
        if (!node.group) {
            node._groupData = null;
            return null;
        }
        const rowGroupCol = node.rowGroupColumn;
        const { valueSvc: valueSvc, showRowGroupCols: showRowGroupCols } = this.beans;
        const groupData = {};
        node._groupData = groupData;
        if (!rowGroupCol) return groupData;
        const leafNode = (0, $437b23f6a393c3bf$export$600fb6a3864e66ca)(node);
        const rowGroupColId = rowGroupCol.getId();
        if (!showRowGroupCols) return groupData;
        const groupDisplayCols = showRowGroupCols.columns;
        for(let i = 0, len = groupDisplayCols.length; i < len; ++i){
            const col = groupDisplayCols[i];
            if (col.isRowGroupDisplayed(rowGroupColId)) groupData[col.getColId()] = valueSvc.getValue(rowGroupCol, leafNode);
        }
        return groupData;
    }
    execute(rootNode, params) {
        const changedPath = params.changedPath;
        if (this.initRefresh(params)) {
            const changedRowNodes = params.changedRowNodes;
            if (changedRowNodes) this.handleDeltaUpdate(rootNode, changedPath, changedRowNodes, !!params.animate);
            else this.shotgunResetEverything(rootNode);
        }
        this.positionLeafsAndGroups(changedPath);
        this.orderGroups(rootNode);
        this.beans.selectionSvc?.updateSelectableAfterGrouping(changedPath);
    }
    positionLeafsAndGroups(changedPath) {
        changedPath.forEachChangedNodeDepthFirst((group)=>{
            const children = group.childrenAfterGroup;
            const childrenLen = children?.length;
            if (!childrenLen) return;
            const newChildren = new Array(childrenLen);
            let writeIdx = 0;
            let changed = false;
            let unbalancedNode;
            for(let readIdx = 0; readIdx < childrenLen; ++readIdx){
                const node = children[readIdx];
                if (!node.childrenAfterGroup?.length) {
                    changed || (changed = writeIdx !== readIdx);
                    newChildren[writeIdx++] = node;
                } else if (!unbalancedNode && node.key === "") {
                    unbalancedNode = node;
                    const last = childrenLen - 1;
                    changed || (changed = readIdx !== last);
                    newChildren[last] = node;
                }
            }
            if (changed) {
                for(let readIdx = 0; readIdx < childrenLen; ++readIdx){
                    const node = children[readIdx];
                    if (node.childrenAfterGroup?.length && node !== unbalancedNode) newChildren[writeIdx++] = node;
                }
                group.childrenAfterGroup = newChildren;
                const sibling = group.sibling;
                if (sibling) sibling.childrenAfterGroup = newChildren;
            }
        }, false);
    }
    initRefresh(params) {
        const { rowGroupColsSvc: rowGroupColsSvc, colModel: colModel, gos: gos } = this.beans;
        const pivotMode = colModel.isPivotMode();
        this.pivotMode = pivotMode;
        this.groupEmpty = pivotMode || !gos.get("groupAllowUnbalanced");
        const cols = rowGroupColsSvc?.columns;
        const groupCols = this.groupCols;
        const afterColumnsChanged = params.afterColumnsChanged;
        if (afterColumnsChanged || !groupCols || this.checkGroupCols) {
            this.checkGroupCols = false;
            if (groupCols && !$5b7ccabde48fae90$var$groupColumnsChanged(groupCols, cols)) {
                if (afterColumnsChanged) return false;
            } else {
                params.animate = false;
                $5b7ccabde48fae90$var$makeGroupColumns(cols, this.groupCols);
            }
        }
        return true;
    }
    handleDeltaUpdate(rootNode, changedPath, { removals: removals, updates: updates, adds: adds, reordered: reordered }, animate) {
        const parentsWithRemovals = /* @__PURE__ */ new Set();
        let activeChangedPath = changedPath;
        if (!activeChangedPath.active) activeChangedPath = null;
        for(let i = 0, len = removals.length; i < len; ++i){
            const rowNode = removals[i];
            const oldParent = this.removeFromParent(rowNode);
            if (!parentsWithRemovals.has(oldParent)) {
                parentsWithRemovals.add(oldParent);
                activeChangedPath?.addParentNode(oldParent);
            }
        }
        for (const rowNode of updates){
            const oldParent = rowNode.parent;
            activeChangedPath?.addParentNode(oldParent);
            if (this.moveNodeInWrongPath(rootNode, rowNode)) {
                parentsWithRemovals.add(oldParent);
                const newParent = rowNode.parent;
                activeChangedPath?.addParentNode(newParent);
                reordered || (reordered = (newParent?.childrenAfterGroup?.length ?? 0) > 1);
            }
        }
        if (adds.size) for (const rowNode of adds){
            this.insertOneNode(rootNode, rowNode);
            const newParent = rowNode.parent;
            activeChangedPath?.addParentNode(newParent);
            reordered || (reordered = (newParent?.childrenAfterGroup?.length ?? 0) > 1);
        }
        if (parentsWithRemovals.size) {
            $5b7ccabde48fae90$var$batchedRemove(parentsWithRemovals);
            this.removeEmptyGroups(parentsWithRemovals, animate);
        }
        if (reordered) this.sortChildren(changedPath);
    }
    // this is used when doing delta updates, eg Redux, keeps nodes in right order
    sortChildren(changedPath) {
        changedPath.forEachChangedNodeDepthFirst((node)=>{
            const didSort = $5b7ccabde48fae90$var$sortGroupChildren(node.childrenAfterGroup);
            if (didSort && changedPath.active) changedPath.addParentNode(node);
        }, false, true);
    }
    orderGroups(rootNode) {
        const initialGroupOrderComparator = this.gos.getCallback("initialGroupOrderComparator");
        if (!initialGroupOrderComparator) return;
        const beans = this.beans;
        const api = beans.gridApi;
        const context = beans.gridOptions.context;
        const comparer = (nodeA, nodeB)=>initialGroupOrderComparator({
                api: api,
                context: context,
                nodeA: nodeA,
                nodeB: nodeB
            });
        const recursiveSort = (rowNode)=>{
            const childrenAfterGroup = rowNode.childrenAfterGroup;
            const childrenAfterGroupLen = childrenAfterGroup?.length;
            if (!childrenAfterGroupLen || rowNode.leafGroup) return;
            if (childrenAfterGroupLen > 1) childrenAfterGroup.sort(comparer);
            for(let i = 0, len = childrenAfterGroupLen; i < len; ++i)recursiveSort(childrenAfterGroup[i]);
        };
        recursiveSort(rootNode);
    }
    moveNodeInWrongPath(rootNode, childNode) {
        const { valueSvc: valueSvc } = this.beans;
        const createGroupForEmpty = this.groupEmpty;
        let ancestor = childNode.parent;
        let changed = false;
        const groupCols = this.groupCols;
        if (!groupCols) return false;
        for(let idx = groupCols.length - 1; idx >= 0; --idx){
            const { col: col } = groupCols[idx];
            let key = valueSvc.getKeyForNode(col, childNode);
            if (key == null || key === "") {
                if (!createGroupForEmpty) continue;
                key = "";
            }
            if (!ancestor?.parent || ancestor.key !== key) {
                changed = true;
                break;
            }
            ancestor = ancestor.parent;
        }
        changed || (changed = !!ancestor?.parent);
        if (!changed) return false;
        this.removeFromParent(childNode);
        this.insertOneNode(rootNode, childNode);
        childNode.setData(childNode.data);
        return true;
    }
    groupShouldBeRemoved(rowNode) {
        const mapKey = this.getChildrenMappedKey(rowNode.key, rowNode.rowGroupColumn);
        const parentChildrenMapped = rowNode.parent?.childrenMapped;
        const groupAlreadyRemoved = parentChildrenMapped ? !parentChildrenMapped[mapKey] : true;
        if (groupAlreadyRemoved) return false;
        return !!rowNode.group && (rowNode.childrenAfterGroup?.length ?? 0) === 0;
    }
    removeEmptyGroups(parents, animate) {
        const selectionSvc = this.beans.selectionSvc;
        let nodesToUnselect;
        const possibleEmptyGroups = Array.from(parents);
        const groupsById = this.nonLeafsById;
        do {
            parents.clear();
            for(let idx = 0; idx < possibleEmptyGroups.length; ++idx){
                let pointer = possibleEmptyGroups[idx];
                while(pointer){
                    const parent = pointer.parent;
                    if (pointer.destroyed) {
                        possibleEmptyGroups[idx] = parent;
                        pointer = parent;
                        continue;
                    }
                    if (!parent) break;
                    if (!this.groupShouldBeRemoved(pointer)) {
                        pointer = parent;
                        continue;
                    }
                    parents.add(parent);
                    this.removeFromParent(pointer);
                    if (selectionSvc && pointer.isSelected()) {
                        nodesToUnselect ?? (nodesToUnselect = []);
                        nodesToUnselect.push(pointer);
                    }
                    possibleEmptyGroups[idx] = parent;
                    groupsById.delete(pointer.id);
                    pointer._destroy(animate);
                    pointer = parent;
                }
            }
            $5b7ccabde48fae90$var$batchedRemove(parents);
        }while (parents.size);
        if (nodesToUnselect) selectionSvc.setNodesSelected({
            nodes: nodesToUnselect,
            newValue: false,
            source: "rowGroupChanged"
        });
    }
    // removes the node from the parent by:
    // a) removing from childrenAfterGroup (using batchRemover if present, otherwise immediately)
    // b) removing from childrenMapped (immediately)
    // c) setRowTop(null) - as the rowRenderer uses this to know the RowNode is no longer needed
    // d) setRowIndex(null) - as the rowNode will no longer be displayed.
    removeFromParent(child) {
        const oldParent = child.parent;
        if (oldParent) {
            const mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
            const childParentChildrenMapped = oldParent.childrenMapped;
            if (childParentChildrenMapped) delete childParentChildrenMapped[mapKey];
        }
        child.setRowTop(null);
        child.setRowIndex(null);
        return oldParent;
    }
    /**
   * This is idempotent, but relies on the `key` field being the same throughout a RowNode's lifetime
   */ addToParent(child, parent) {
        const childrenMapped = parent.childrenMapped ?? (parent.childrenMapped = {});
        const mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
        if (childrenMapped[mapKey] !== child) {
            childrenMapped[mapKey] = child;
            let childrenAfterGroup = parent.childrenAfterGroup;
            if (!childrenAfterGroup) {
                parent.childrenAfterGroup = childrenAfterGroup = [];
                const sibling = parent.sibling;
                if (sibling) sibling.childrenAfterGroup = parent.childrenAfterGroup;
            }
            childrenAfterGroup.push(child);
            $5b7ccabde48fae90$var$setRowNodeGroup(parent, this.beans, true);
            $5b7ccabde48fae90$var$invalidateAllLeafChildren(parent);
        }
    }
    shotgunResetEverything(rootNode) {
        this.beans.selectionSvc?.filterFromSelection?.((node)=>!node.group);
        this.nonLeafsById.clear();
        rootNode.leafGroup = !this.groupCols?.length;
        rootNode.childrenAfterGroup = [];
        rootNode.childrenMapped = {};
        rootNode.updateHasChildren();
        const sibling = rootNode.sibling;
        if (sibling) {
            sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
            sibling.childrenMapped = rootNode.childrenMapped;
        }
        const allLeafs = rootNode._leafs;
        for(let i = 0, len = allLeafs.length; i < len; ++i)this.insertOneNode(rootNode, allLeafs[i]);
    }
    insertOneNode(rootNode, childNode) {
        let parentGroup = rootNode;
        const { beans: beans, pivotMode: pivotMode, groupCols: groupCols, groupEmpty: groupEmpty } = this;
        const valueSvc = beans.valueSvc;
        if (!groupCols) return;
        const len = groupCols.length;
        for(let i = 0; i < len; ++i){
            const groupCol = groupCols[i];
            const col = groupCol.col;
            let key = valueSvc.getKeyForNode(col, childNode);
            if (key == null || key === "") {
                if (!groupEmpty) continue;
                key = "";
            }
            const existingGroup = parentGroup.childrenMapped?.[this.getChildrenMappedKey(key, col)];
            if (existingGroup) {
                parentGroup = existingGroup;
                continue;
            }
            const nextLevel = parentGroup.level + 1;
            const isLeafLevel = nextLevel >= len - 1;
            const newGroup = this.createGroup(parentGroup, groupCol, key, nextLevel, isLeafLevel, childNode);
            this.addToParent(newGroup, parentGroup);
            this.setExpandedInitialValue(pivotMode, newGroup);
            parentGroup = newGroup;
        }
        if (!parentGroup.group) (0, $437b23f6a393c3bf$export$545083624300f13d)(184, {
            parentGroupData: parentGroup.data,
            childNodeData: childNode.data
        });
        childNode.parent = parentGroup;
        childNode.level = parentGroup.level + 1;
        parentGroup.childrenAfterGroup.push(childNode);
        parentGroup.updateHasChildren();
        $5b7ccabde48fae90$var$invalidateAllLeafChildren(parentGroup);
    }
    createGroup(parent, groupCol, key, level, isLeafLevel, leafNode) {
        const col = groupCol.col;
        const id = (parent.level >= 0 ? parent.id + "-" : "row-group-") + (col.getColId() + "-" + key);
        const groupsById = this.nonLeafsById;
        let groupNode = groupsById.get(id);
        if (groupNode !== void 0) return groupNode;
        groupNode = new (0, $437b23f6a393c3bf$export$6af91cd58ec2edf9)(this.beans);
        groupNode.group = true;
        groupNode.parent = parent;
        groupNode.field = groupCol.field ?? null;
        groupNode.rowGroupColumn = col;
        groupNode.key = key;
        groupNode.id = id;
        groupNode.level = level;
        groupNode.leafGroup = isLeafLevel;
        groupNode.rowGroupIndex = level;
        groupNode.childrenAfterGroup = [];
        groupNode.childrenMapped = {};
        groupsById.set(id, groupNode);
        groupNode.groupValue = leafNode && this.beans.valueSvc.getValue(col, leafNode);
        groupNode.setAllChildrenCount(0);
        groupNode.updateHasChildren();
        return groupNode;
    }
    getChildrenMappedKey(key, rowGroupColumn) {
        return rowGroupColumn ? rowGroupColumn.getId() + "-" + key : key;
    }
    setExpandedInitialValue(pivotMode, groupNode) {
        if (pivotMode && groupNode.leafGroup) {
            groupNode.expanded = false;
            return;
        }
        groupNode.expanded = $5b7ccabde48fae90$var$_getRowDefaultExpanded(this.beans, groupNode, groupNode.level);
    }
    onShowRowGroupColsSetChanged() {
        const { rowModel: rowModel, valueSvc: valueSvc } = this.beans;
        for (const groupNode of this.nonLeafsById.values()){
            groupNode._groupData = void 0;
            const rowGroupColumn = groupNode.rowGroupColumn;
            const leafNode = rowGroupColumn && (0, $437b23f6a393c3bf$export$600fb6a3864e66ca)(groupNode);
            groupNode.groupValue = leafNode && valueSvc.getValue(rowGroupColumn, leafNode);
        }
        const allLeafs = rowModel.rootNode?._leafs;
        if (allLeafs) for(let i = 0, len = allLeafs.length; i < len; ++i){
            const leafNode = allLeafs[i];
            leafNode.parent._groupData = void 0;
        }
    }
};
var $5b7ccabde48fae90$var$batchedRemove = (parents)=>{
    for (const parent of parents){
        const childrenAfterGroup = parent?.childrenAfterGroup;
        if (!childrenAfterGroup) continue;
        const childrenAfterGroupLen = childrenAfterGroup.length;
        let writeIdx = 0;
        for(let readIdx = 0; readIdx < childrenAfterGroupLen; ++readIdx){
            const item = childrenAfterGroup[readIdx];
            if (item.parent === parent && !item.destroyed) {
                if (writeIdx !== readIdx) childrenAfterGroup[writeIdx] = item;
                ++writeIdx;
            }
        }
        if (childrenAfterGroupLen !== writeIdx) {
            childrenAfterGroup.length = writeIdx;
            parent.updateHasChildren();
            $5b7ccabde48fae90$var$invalidateAllLeafChildren(parent);
        }
    }
};
var $5b7ccabde48fae90$var$invalidateAllLeafChildren = (node)=>{
    while(node._leafs !== void 0){
        const parent = node.parent;
        if (!parent) break;
        node._leafs = void 0;
        node = parent;
    }
};
// packages/ag-grid-enterprise/src/rowGrouping/rowGroupingApi.ts
function $5b7ccabde48fae90$var$setRowGroupColumns(beans, colKeys) {
    beans.rowGroupColsSvc?.setColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$removeRowGroupColumns(beans, colKeys) {
    beans.rowGroupColsSvc?.removeColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$addRowGroupColumns(beans, colKeys) {
    beans.rowGroupColsSvc?.addColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$moveRowGroupColumn(beans, fromIndex, toIndex) {
    beans.rowGroupColsSvc?.moveColumn?.(fromIndex, toIndex, "api");
}
function $5b7ccabde48fae90$var$getRowGroupColumns(beans) {
    return beans.rowGroupColsSvc?.columns ?? [];
}
// packages/ag-grid-enterprise/src/rowGrouping/rowGroupingModule.ts
var $5b7ccabde48fae90$var$SharedRowGroupingModule = {
    moduleName: "SharedRowGrouping",
    version: $5b7ccabde48fae90$var$VERSION,
    apiFunctions: {
        setRowGroupColumns: $5b7ccabde48fae90$var$setRowGroupColumns,
        removeRowGroupColumns: $5b7ccabde48fae90$var$removeRowGroupColumns,
        addRowGroupColumns: $5b7ccabde48fae90$var$addRowGroupColumns,
        getRowGroupColumns: $5b7ccabde48fae90$var$getRowGroupColumns,
        moveRowGroupColumn: $5b7ccabde48fae90$var$moveRowGroupColumn
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        $5b7ccabde48fae90$var$SharedAggregationModule,
        $5b7ccabde48fae90$var$GroupColumnModule,
        $5b7ccabde48fae90$var$StickyRowModule,
        $5b7ccabde48fae90$var$GroupHierarchyModule
    ]
};
var $5b7ccabde48fae90$export$e67935bd41653107 = {
    moduleName: "RowGrouping",
    version: $5b7ccabde48fae90$var$VERSION,
    dynamicBeans: {
        groupStrategy: $5b7ccabde48fae90$var$GroupStrategy
    },
    rowModels: [
        "clientSide"
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$SharedRowGroupingModule,
        $5b7ccabde48fae90$export$b53def5458540436,
        $5b7ccabde48fae90$var$ClientSideRowModelHierarchyModule,
        $5b7ccabde48fae90$var$GroupEditModule
    ]
};
var $5b7ccabde48fae90$export$60c70655af65b0f1 = {
    moduleName: "RowGroupingPanel",
    version: $5b7ccabde48fae90$var$VERSION,
    selectors: [
        $5b7ccabde48fae90$var$AgGridHeaderDropZonesSelector
    ],
    icons: {
        // identifies the pivot drop zone
        pivotPanel: "pivot",
        // "Row groups" drop zone in column tool panel
        rowGroupPanel: "group",
        // separator between column 'pills' when you add multiple columns to the header drop zone
        panelDelimiter: "small-right",
        // version of panelDelimiter used in RTL mode
        panelDelimiterRtl: "small-left"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$da5c9bb998e6c24d)
    ]
};
var $5b7ccabde48fae90$export$aca1637eb4e24373 = {
    moduleName: "GroupFilter",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agGroupColumnFilter: {
            classImp: $5b7ccabde48fae90$var$GroupFilter,
            processParams: $5b7ccabde48fae90$var$processGroupFilterParams
        },
        agGroupColumnFloatingFilter: $5b7ccabde48fae90$var$GroupFloatingFilterComp
    },
    beans: [
        $5b7ccabde48fae90$var$GroupFilterService
    ],
    dynamicBeans: {
        agGroupColumnFilterHandler: $5b7ccabde48fae90$var$GroupFilterHandler
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$bee7a6b8183a1c61)
    ]
};
var $5b7ccabde48fae90$var$ViewportRowModel = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
        // rowRenderer tells us these
        this.firstRow = -1;
        this.lastRow = -1;
        // datasource tells us this
        this.rowCount = -1;
        this.rowNodesByIndex = {};
        /** Dummy root node */ this.rootNode = null;
        /**
     * Used to see if setRowData has been called inside of the viewportChanged event context,
     * if so the new rows are already being calculated, and the model does not need updated
     * otherwise, a new model event needs to fire as rows have changed externally.
     */ this.viewportChangedContext = false;
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid(_startPixel, _endPixel, _startLimitIndex, _endLimitIndex) {
        return false;
    }
    postConstruct() {
        const beans = this.beans;
        const rootNode = new (0, $437b23f6a393c3bf$export$6af91cd58ec2edf9)(beans);
        this.rootNode = rootNode;
        rootNode.level = -1;
        this.rowHeight = (0, $437b23f6a393c3bf$export$8966875adec41e5b)(beans);
        this.addManagedEventListeners({
            viewportChanged: this.onViewportChanged.bind(this)
        });
        this.addManagedPropertyListener("viewportDatasource", ()=>this.updateDatasource());
        this.addManagedPropertyListener("rowHeight", ()=>{
            this.rowHeight = (0, $437b23f6a393c3bf$export$8966875adec41e5b)(beans);
            this.updateRowHeights();
        });
    }
    start() {
        this.updateDatasource();
    }
    isLastRowIndexKnown() {
        return true;
    }
    destroy() {
        this.destroyDatasource();
        super.destroy();
        this.rootNode = null;
    }
    destroyDatasource() {
        const datasource = this.datasource;
        if (!datasource) return;
        datasource.destroy?.();
        this.beans.rowRenderer.datasourceChanged();
        this.firstRow = -1;
        this.lastRow = -1;
    }
    updateDatasource() {
        const datasource = this.gos.get("viewportDatasource");
        if (datasource) this.setViewportDatasource(datasource);
    }
    getPageSize() {
        return this.gos.get("viewportRowModelPageSize");
    }
    getBufferSize() {
        return this.gos.get("viewportRowModelBufferSize");
    }
    calculateFirstRow(firstRenderedRow) {
        const bufferSize = this.getBufferSize();
        const pageSize = this.getPageSize();
        const afterBuffer = firstRenderedRow - bufferSize;
        if (afterBuffer < 0) return 0;
        return Math.floor(afterBuffer / pageSize) * pageSize;
    }
    calculateLastRow(lastRenderedRow) {
        if (lastRenderedRow === -1) return lastRenderedRow;
        const bufferSize = this.getBufferSize();
        const pageSize = this.getPageSize();
        const afterBuffer = lastRenderedRow + bufferSize;
        const result = Math.ceil(afterBuffer / pageSize) * pageSize;
        const lastRowIndex = this.rowCount - 1;
        return Math.min(result, lastRowIndex);
    }
    onViewportChanged(event) {
        const newFirst = this.calculateFirstRow(event.firstRow);
        const newLast = this.calculateLastRow(event.lastRow);
        if (this.firstRow !== newFirst || this.lastRow !== newLast) {
            this.firstRow = newFirst;
            this.lastRow = newLast;
            this.purgeRowsNotInViewport();
            this.viewportChangedContext = true;
            this.datasource?.setViewportRange(this.firstRow, this.lastRow);
            this.viewportChangedContext = false;
        }
    }
    purgeRowsNotInViewport() {
        const rowNodesByIndex = this.rowNodesByIndex;
        for (const indexStr of Object.keys(rowNodesByIndex)){
            const index = parseInt(indexStr, 10);
            if (index < this.firstRow || index > this.lastRow) {
                if (this.isRowFocused(index) || this.beans.editSvc?.isRowEditing(rowNodesByIndex[index])) continue;
                delete rowNodesByIndex[index];
            }
        }
    }
    isRowFocused(rowIndex) {
        const focusedCell = this.beans.focusSvc.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const hasFocus = focusedCell.rowIndex === rowIndex;
        return hasFocus;
    }
    setViewportDatasource(viewportDatasource) {
        this.destroyDatasource();
        this.datasource = viewportDatasource;
        this.rowCount = -1;
        if (!viewportDatasource.init) (0, $437b23f6a393c3bf$export$545083624300f13d)(226);
        else viewportDatasource.init((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
            setRowCount: this.setRowCount.bind(this),
            setRowData: this.setRowData.bind(this),
            getRow: this.getRow.bind(this)
        }));
    }
    getType() {
        return "viewport";
    }
    getRow(rowIndex) {
        if (!this.rowNodesByIndex[rowIndex]) this.rowNodesByIndex[rowIndex] = this.createBlankRowNode(rowIndex);
        return this.rowNodesByIndex[rowIndex];
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
        });
        return result;
    }
    getRowCount() {
        return this.rowCount === -1 ? 0 : this.rowCount;
    }
    getRowIndexAtPixel(pixel) {
        if (this.rowHeight !== 0) return Math.floor(pixel / this.rowHeight);
        return 0;
    }
    /** Viewport row model does not support dynamic row heights by design and while it is possible to implement this feature, it leads to view-model desync due to data being not isotropic in time */ resetRowHeights() {}
    onRowHeightChanged() {}
    getRowBounds(index) {
        const rowHeight = this.rowHeight;
        return {
            rowHeight: rowHeight,
            rowTop: rowHeight * index
        };
    }
    updateRowHeights() {
        const rowHeight = this.rowHeight;
        this.forEachNode((node)=>{
            node.setRowHeight(rowHeight);
            node.setRowTop(rowHeight * node.rowIndex);
        });
        this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            newData: false,
            newPage: false,
            keepRenderedRows: true,
            animate: false
        });
    }
    getTopLevelRowCount() {
        return this.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        return topLevelIndex;
    }
    isEmpty() {
        return this.rowCount > 0;
    }
    getOverlayType() {
        return null;
    }
    isRowsToRender() {
        return this.rowCount > 0;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        const firstIndex = firstInRange.rowIndex;
        const lastIndex = lastInRange.rowIndex;
        const firstNodeOutOfRange = firstIndex < this.firstRow || firstIndex > this.lastRow;
        const lastNodeOutOfRange = lastIndex < this.firstRow || lastIndex > this.lastRow;
        if (firstNodeOutOfRange || lastNodeOutOfRange) return [];
        const result = [];
        const startIndex = firstIndex <= lastIndex ? firstIndex : lastIndex;
        const endIndex = firstIndex <= lastIndex ? lastIndex : firstIndex;
        for(let i = startIndex; i <= endIndex; i++)result.push(this.rowNodesByIndex[i]);
        return result;
    }
    forEachNode(callback) {
        let callbackCount = 0;
        for (const indexStr of Object.keys(this.rowNodesByIndex)){
            const index = parseInt(indexStr, 10);
            const rowNode = this.rowNodesByIndex[index];
            callback(rowNode, callbackCount);
            callbackCount++;
        }
    }
    setRowData(rowData) {
        const getRowIdFunc = (0, $437b23f6a393c3bf$export$57c3bb2f89b59a89)(this.beans.gos);
        const existingNodesById = /* @__PURE__ */ new Map();
        if (getRowIdFunc) for (const row of Object.values(this.rowNodesByIndex))existingNodesById.set(row.id, row);
        for(let i = this.firstRow; i <= this.lastRow; i++){
            const data = rowData[i];
            if (!data) continue;
            let rowId;
            let row;
            if (getRowIdFunc) {
                rowId = getRowIdFunc({
                    data: data,
                    rowPinned: void 0,
                    level: 0,
                    parentKeys: void 0
                });
                row = existingNodesById.get(rowId);
            } else row = this.rowNodesByIndex[i];
            if (row) {
                row.updateData(data);
                row.setRowIndex(i);
                row.setRowTop(this.rowHeight * i);
            } else {
                row = this.createBlankRowNode(i);
                row.setDataAndId(data, rowId ?? i.toString());
            }
            this.rowNodesByIndex[i] = row;
        }
        if (!this.viewportChangedContext) this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            newData: false,
            newPage: false,
            keepRenderedRows: true,
            animate: false
        });
    }
    createBlankRowNode(rowIndex) {
        const rowNode = new (0, $437b23f6a393c3bf$export$6af91cd58ec2edf9)(this.beans);
        const rowHeight = this.rowHeight;
        rowNode.setRowHeight(rowHeight);
        rowNode.setRowTop(rowHeight * rowIndex);
        rowNode.setRowIndex(rowIndex);
        return rowNode;
    }
    setRowCount(rowCount, keepRenderedRows = false) {
        if (rowCount === this.rowCount) return;
        this.rowCount = rowCount;
        const eventSvc = this.eventSvc;
        eventSvc.dispatchEventOnce({
            type: "rowCountReady"
        });
        eventSvc.dispatchEvent({
            type: "modelUpdated",
            newData: false,
            newPage: false,
            keepRenderedRows: keepRenderedRows,
            animate: false
        });
    }
    isRowPresent(rowNode) {
        const foundRowNode = this.getRowNode(rowNode.id);
        return !!foundRowNode;
    }
};
// packages/ag-grid-enterprise/src/viewportRowModel/viewportRowModelModule.ts
var $5b7ccabde48fae90$export$5afa3276c0fcf76 = {
    moduleName: "ViewportRowModel",
    version: $5b7ccabde48fae90$var$VERSION,
    rowModels: [
        "viewport"
    ],
    beans: [
        $5b7ccabde48fae90$var$ViewportRowModel
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
// packages/ag-grid-enterprise/src/clipboard/clipboardApi.ts
function $5b7ccabde48fae90$var$copyToClipboard(beans, params) {
    beans.clipboardSvc?.copyToClipboard(params);
}
function $5b7ccabde48fae90$var$cutToClipboard(beans, params) {
    beans.clipboardSvc?.cutToClipboard(params);
}
function $5b7ccabde48fae90$var$copySelectedRowsToClipboard(beans, params) {
    beans.clipboardSvc?.copySelectedRowsToClipboard(params);
}
function $5b7ccabde48fae90$var$copySelectedRangeToClipboard(beans, params) {
    beans.clipboardSvc?.copySelectedRangeToClipboard(params);
}
function $5b7ccabde48fae90$var$copySelectedRangeDown(beans) {
    beans.clipboardSvc?.copyRangeDown();
}
function $5b7ccabde48fae90$var$pasteFromClipboard(beans) {
    beans.clipboardSvc?.pasteFromClipboard();
}
var $5b7ccabde48fae90$var$SOURCE_PASTE = "paste";
var $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY = "dragCopy";
var $5b7ccabde48fae90$var$EXPORT_TYPE_CLIPBOARD = "clipboard";
function $5b7ccabde48fae90$var$stringToArray(strData, delimiter = ",") {
    const data = [];
    const isNewline = (char)=>char === "\r" || char === "\n";
    let insideQuotedField = false;
    if (strData === "") return [
        [
            ""
        ]
    ];
    for(let row = 0, column = 0, position = 0; position < strData.length; position++){
        const previousChar = strData[position - 1];
        const currentChar = strData[position];
        const nextChar = strData[position + 1];
        const ensureDataExists = ()=>{
            if (!data[row]) data[row] = [];
            if (!data[row][column]) data[row][column] = "";
        };
        ensureDataExists();
        if (currentChar === '"') {
            if (insideQuotedField) {
                if (nextChar === '"') {
                    data[row][column] += '"';
                    position++;
                } else insideQuotedField = false;
            } else if (previousChar === void 0 || previousChar === delimiter || isNewline(previousChar)) insideQuotedField = true;
        }
        if (!insideQuotedField && currentChar !== '"') {
            if (currentChar === delimiter) {
                column++;
                ensureDataExists();
                continue;
            } else if (isNewline(currentChar)) {
                column = 0;
                row++;
                ensureDataExists();
                if (currentChar === "\r" && nextChar === "\n") position++;
                continue;
            }
        }
        data[row][column] += currentChar;
    }
    return data;
}
var $5b7ccabde48fae90$var$ClipboardService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "clipboardSvc";
        this.clientSideRowModel = null;
        this.gridCtrl = null;
        this.lastPasteOperationTime = 0;
        this.navigatorApiFailed = false;
    }
    postConstruct() {
        const { gos: gos, rowModel: rowModel, ctrlsSvc: ctrlsSvc } = this.beans;
        if ((0, $437b23f6a393c3bf$export$9f182d9ca737e15)(gos, rowModel)) this.clientSideRowModel = rowModel;
        ctrlsSvc.whenReady(this, (p)=>{
            this.gridCtrl = p.gridCtrl;
        });
    }
    destroy() {
        super.destroy();
        this.clientSideRowModel = null;
        this.gridCtrl = null;
    }
    pasteFromClipboard() {
        const allowNavigator = !this.gos.get("suppressClipboardApi");
        if (allowNavigator && !this.navigatorApiFailed && navigator.clipboard?.readText) navigator.clipboard.readText().then(this.processClipboardData.bind(this)).catch((e)=>{
            (0, $437b23f6a393c3bf$export$545083624300f13d)(40, {
                e: e,
                method: "readText"
            });
            this.navigatorApiFailed = true;
            this.pasteFromClipboardLegacy();
        });
        else this.pasteFromClipboardLegacy();
    }
    pasteFromClipboardLegacy() {
        let defaultPrevented = false;
        const handlePasteEvent = (e)=>{
            const currentPastOperationTime = Date.now();
            if (currentPastOperationTime - this.lastPasteOperationTime < 50) {
                defaultPrevented = true;
                e.preventDefault();
            }
            this.lastPasteOperationTime = currentPastOperationTime;
        };
        this.executeOnTempElement((textArea)=>{
            textArea.addEventListener("paste", handlePasteEvent);
            textArea.focus({
                preventScroll: true
            });
        }, (element)=>{
            const data = element.value;
            if (!defaultPrevented) this.processClipboardData(data);
            else this.refocusLastFocusedCell();
            element.removeEventListener("paste", handlePasteEvent);
        });
    }
    refocusLastFocusedCell() {
        const { focusSvc: focusSvc } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (focusedCell) focusSvc.setFocusedCell({
            rowIndex: focusedCell.rowIndex,
            column: focusedCell.column,
            rowPinned: focusedCell.rowPinned,
            forceBrowserFocus: true
        });
    }
    getClipboardDelimiter() {
        const delimiter = this.gos.get("clipboardDelimiter");
        return (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(delimiter) ? delimiter : "	";
    }
    processClipboardData(data) {
        if (data == null) return;
        let parsedData = $5b7ccabde48fae90$var$stringToArray(data, this.getClipboardDelimiter());
        const userFunc = this.gos.getCallback("processDataFromClipboard");
        if (userFunc) parsedData = userFunc({
            data: parsedData
        });
        if (parsedData == null) return;
        if (this.gos.get("suppressLastEmptyLineOnPaste")) this.removeLastLineIfBlank(parsedData);
        const { rangeSvc: rangeSvc, editSvc: editSvc } = this.beans;
        const pasteOperation = (cellsToFlash, updatedRowNodes, focusedCell, changedPath)=>{
            const rangeActive = rangeSvc?.isMoreThanOneCell();
            const pasteIntoRange = rangeActive && !this.hasOnlyOneValueToPaste(parsedData);
            if (pasteIntoRange) this.pasteIntoActiveRange(parsedData, cellsToFlash, updatedRowNodes, changedPath);
            else this.pasteStartingFromFocusedCell(parsedData, cellsToFlash, updatedRowNodes, focusedCell, changedPath);
            editSvc?.stopEditing(void 0, {
                source: $5b7ccabde48fae90$var$SOURCE_PASTE
            });
        };
        this.doPasteOperation(pasteOperation);
    }
    // common code to paste operations, e.g. paste to cell, paste to range, and copy range down
    doPasteOperation(pasteOperationFunc) {
        const source = "clipboard";
        const { eventSvc: eventSvc, focusSvc: focusSvc, rowRenderer: rowRenderer, gos: gos } = this.beans;
        eventSvc.dispatchEvent({
            type: "pasteStart",
            source: source
        });
        const { clientSideRowModel: clientSideRowModel } = this;
        const rootNode = clientSideRowModel?.rootNode;
        const changedPath = rootNode && new (0, $437b23f6a393c3bf$export$cb4d9114a9732e85)(gos.get("aggregateOnlyChangedColumns"), rootNode);
        const cellsToFlash = {};
        const updatedRowNodes = [];
        const focusedCell = focusSvc.getFocusedCell();
        pasteOperationFunc(cellsToFlash, updatedRowNodes, focusedCell, changedPath);
        const nodesToRefresh = [
            ...updatedRowNodes
        ];
        if (changedPath) {
            clientSideRowModel.doAggregate(changedPath);
            changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
                nodesToRefresh.push(rowNode);
            });
        }
        rowRenderer.refreshCells({
            rowNodes: nodesToRefresh
        });
        this.dispatchFlashCells(cellsToFlash);
        this.fireRowChanged(updatedRowNodes);
        this.refocusLastFocusedCell();
        eventSvc.dispatchEvent({
            type: "pasteEnd",
            source: source
        });
    }
    getPreProcessRangeCallback(clipboardData) {
        return (cellRange)=>{
            const { rangeSvc: rangeSvc } = this.beans;
            if (!rangeSvc) return;
            const { rowDiff: rowDiff, colDiff: colDiff } = this.getAdjustedRangeDimensionForPaste(cellRange, clipboardData);
            if (rowDiff !== 0) rangeSvc.extendRangeRowCountBy(cellRange, rowDiff);
            if (colDiff !== 0) rangeSvc.extendRangeColumnCountBy(cellRange, colDiff);
        };
    }
    getAdjustedRangeDimensionForPaste(cellRange, clipboardData) {
        const rangeSvc = this.beans.rangeSvc;
        const clipboardRowCount = clipboardData.length;
        const rangeRowCount = rangeSvc.getRangeRowCount(cellRange);
        const isRowMultiple = rangeRowCount >= clipboardRowCount && rangeRowCount % clipboardRowCount === 0;
        const clipboardColCount = clipboardData[0].length;
        const rangeColCount = cellRange.columns.length;
        const isColMultiple = rangeColCount >= clipboardColCount && rangeColCount % clipboardColCount === 0;
        return {
            rowDiff: isRowMultiple ? 0 : clipboardRowCount - rangeRowCount,
            colDiff: isColMultiple ? 0 : clipboardColCount - rangeColCount
        };
    }
    pasteIntoActiveRange(clipboardData, cellsToFlash, updatedRowNodes, changedPath) {
        let indexOffset = 0;
        let dataRowIndex = 0;
        const rowCallback = (currentRow, rowNode, range, rangeIndex)=>{
            const atEndOfClipboardData = rangeIndex - indexOffset >= clipboardData.length;
            if (atEndOfClipboardData) {
                if (rangeIndex % clipboardData.length !== 0) return;
                indexOffset += dataRowIndex;
                dataRowIndex = 0;
            }
            const currentRowData = clipboardData[rangeIndex - indexOffset];
            updatedRowNodes.push(rowNode);
            const processCellFromClipboardFunc = this.gos.getCallback("processCellFromClipboard");
            const columns = range.columns;
            const selectionColIdx = columns.findIndex((0, $437b23f6a393c3bf$export$f6074a9792015c5d));
            if (selectionColIdx !== -1) columns.splice(selectionColIdx, 1);
            for(let idx = 0; idx < columns.length; idx++){
                const column = columns[idx];
                if (!column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) continue;
                let calculatedIdx = idx;
                if (idx >= currentRowData.length) calculatedIdx = idx % currentRowData.length;
                const newValue = this.processCell(rowNode, column, currentRowData[calculatedIdx], $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY, processCellFromClipboardFunc, true);
                rowNode.setDataValue(column, newValue, $5b7ccabde48fae90$var$SOURCE_PASTE);
                changedPath?.addParentNode(rowNode.parent, [
                    column
                ]);
                const { rowIndex: rowIndex, rowPinned: rowPinned } = currentRow;
                const cellId = (0, $437b23f6a393c3bf$export$c0c5a5ba9327269f)({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned
                });
                cellsToFlash[cellId] = true;
            }
            dataRowIndex++;
        };
        this.iterateActiveRanges(rowCallback, false, this.getPreProcessRangeCallback(clipboardData));
    }
    getDisplayedColumnsStartingAt(column) {
        let currentColumn = column;
        const columns = [];
        const { visibleCols: visibleCols } = this.beans;
        while(currentColumn && (0, $437b23f6a393c3bf$export$ee97d5717f8d44ec)(currentColumn))currentColumn = visibleCols.getColAfter(currentColumn);
        while(currentColumn != null){
            columns.push(currentColumn);
            currentColumn = visibleCols.getColAfter(currentColumn);
        }
        return columns;
    }
    pasteStartingFromFocusedCell(parsedData, cellsToFlash, updatedRowNodes, focusedCell, changedPath) {
        if (!focusedCell) return;
        const currentRow = {
            rowIndex: focusedCell.rowIndex,
            rowPinned: focusedCell.rowPinned
        };
        const columnsToPasteInto = this.getDisplayedColumnsStartingAt(focusedCell.column);
        if (this.isPasteSingleValueIntoRange(parsedData)) this.pasteSingleValueIntoRange(parsedData, updatedRowNodes, cellsToFlash, changedPath);
        else this.pasteMultipleValues(parsedData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, $5b7ccabde48fae90$var$EXPORT_TYPE_CLIPBOARD, changedPath);
    }
    // if range is active, and only one cell, then we paste this cell into all cells in the active range.
    isPasteSingleValueIntoRange(parsedData) {
        const rangeSvc = this.beans.rangeSvc;
        return this.hasOnlyOneValueToPaste(parsedData) && !!rangeSvc && !rangeSvc.isEmpty();
    }
    pasteSingleValueIntoRange(parsedData, updatedRowNodes, cellsToFlash, changedPath) {
        const value = parsedData[0][0];
        const rowCallback = (currentRow, rowNode, range)=>{
            updatedRowNodes.push(rowNode);
            range.columns.forEach((column)=>this.updateCellValue(rowNode, column, value, cellsToFlash, $5b7ccabde48fae90$var$EXPORT_TYPE_CLIPBOARD, changedPath));
        };
        this.iterateActiveRanges(rowCallback);
    }
    hasOnlyOneValueToPaste(parsedData) {
        return parsedData.length === 1 && parsedData[0].length === 1;
    }
    copyRangeDown() {
        const { rangeSvc: rangeSvc, gos: gos, formula: formula, valueSvc: valueSvc } = this.beans;
        if (!rangeSvc || rangeSvc.isEmpty()) return;
        const firstRowValues = [];
        const pasteOperation = (cellsToFlash, updatedRowNodes, focusedCell, changedPath)=>{
            const processCellForClipboardFunc = gos.getCallback("processCellForClipboard");
            const processCellFromClipboardFunc = gos.getCallback("processCellFromClipboard");
            const rowCallback = (currentRow, rowNode, range)=>{
                const { columns: columns } = range;
                if (!firstRowValues.length) columns.forEach((column)=>{
                    const value = this.processCell(rowNode, column, valueSvc.getValue(column, rowNode), $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY, processCellForClipboardFunc, false, true);
                    firstRowValues.push(value);
                });
                else {
                    updatedRowNodes.push(rowNode);
                    columns.forEach((column, index)=>{
                        if (!column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) return;
                        const isFormula = column.isAllowFormula() && formula?.isFormula(firstRowValues[index]);
                        if (isFormula) firstRowValues[index] = formula?.updateFormulaByOffset({
                            value: firstRowValues[index],
                            rowDelta: 1
                        });
                        const firstRowValue = this.processCell(rowNode, column, firstRowValues[index], $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY, processCellFromClipboardFunc, true);
                        rowNode.setDataValue(column, firstRowValue, $5b7ccabde48fae90$var$SOURCE_PASTE);
                        if (changedPath) changedPath.addParentNode(rowNode.parent, [
                            column
                        ]);
                        const { rowIndex: rowIndex, rowPinned: rowPinned } = currentRow;
                        const cellId = (0, $437b23f6a393c3bf$export$c0c5a5ba9327269f)({
                            rowIndex: rowIndex,
                            column: column,
                            rowPinned: rowPinned
                        });
                        cellsToFlash[cellId] = true;
                    });
                }
            };
            this.iterateActiveRanges(rowCallback, true);
        };
        this.doPasteOperation(pasteOperation);
    }
    removeLastLineIfBlank(parsedData) {
        const lastLine = (0, $437b23f6a393c3bf$export$236389741107357f)(parsedData);
        const lastLineIsBlank = lastLine && lastLine.length === 1 && lastLine[0] === "";
        if (lastLineIsBlank) {
            if (parsedData.length === 1) return;
            (0, $437b23f6a393c3bf$export$83a881c8b5120679)(parsedData, lastLine);
        }
    }
    fireRowChanged(rowNodes) {
        if (this.gos.get("editType") !== "fullRow") return;
        for (const rowNode of rowNodes)this.eventSvc.dispatchEvent({
            type: "rowValueChanged",
            node: rowNode,
            data: rowNode.data,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned
        });
    }
    pasteMultipleValues(clipboardGridData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, type, changedPath) {
        let rowPointer = currentRow;
        const beans = this.beans;
        const { gos: gos } = beans;
        const skipGroupRows = this.clientSideRowModel != null && !gos.get("enableGroupEdit") && !gos.get("treeData");
        const getNextGoodRowNode = ()=>{
            while(true){
                if (!rowPointer) return null;
                const res = (0, $437b23f6a393c3bf$export$d4675a60917db7b0)(beans, rowPointer);
                rowPointer = (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(beans, {
                    rowPinned: rowPointer.rowPinned,
                    rowIndex: rowPointer.rowIndex
                });
                if (res == null) return null;
                const skipRow = res.detail || res.footer || skipGroupRows && res.group;
                if (!skipRow) return res;
            }
        };
        for (const clipboardRowData of clipboardGridData){
            const rowNode = getNextGoodRowNode();
            if (!rowNode) continue;
            clipboardRowData.forEach((value, index)=>this.updateCellValue(rowNode, columnsToPasteInto[index], value, cellsToFlash, type, changedPath));
            updatedRowNodes.push(rowNode);
        }
    }
    updateCellValue(rowNode, column, value, cellsToFlash, type, changedPath) {
        if (!rowNode || !column?.isCellEditable(rowNode) || column?.isSuppressPaste(rowNode)) return;
        const processedValue = this.processCell(rowNode, column, value, type, this.gos.getCallback("processCellFromClipboard"), true);
        rowNode.setDataValue(column, processedValue, $5b7ccabde48fae90$var$SOURCE_PASTE);
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode;
        const cellId = (0, $437b23f6a393c3bf$export$c0c5a5ba9327269f)({
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned
        });
        cellsToFlash[cellId] = true;
        if (changedPath) changedPath.addParentNode(rowNode.parent, [
            column
        ]);
    }
    copyToClipboard(params = {}) {
        this.copyOrCutToClipboard(params);
    }
    cutToClipboard(params = {}, source = "api") {
        if (this.gos.get("suppressCutToClipboard")) return;
        this.eventSvc.dispatchEvent({
            type: "cutStart",
            source: source
        });
        this.copyOrCutToClipboard(params, true);
        this.eventSvc.dispatchEvent({
            type: "cutEnd",
            source: source
        });
    }
    copyOrCutToClipboard(params, cut) {
        let { includeHeaders: includeHeaders, includeGroupHeaders: includeGroupHeaders } = params;
        const { gos: gos, focusSvc: focusSvc } = this.beans;
        if (includeHeaders == null) includeHeaders = gos.get("copyHeadersToClipboard");
        if (includeGroupHeaders == null) includeGroupHeaders = gos.get("copyGroupHeadersToClipboard");
        const copyParams = {
            includeHeaders: includeHeaders,
            includeGroupHeaders: includeGroupHeaders
        };
        const rowSelection = gos.get("rowSelection");
        const cellSelection = gos.get("cellSelection");
        let cellClearType = null;
        if (this.shouldCopyCells(cellSelection, rowSelection)) {
            this.copySelectedRangeToClipboard(copyParams);
            cellClearType = 0 /* CellRange */ ;
        } else if (this.shouldCopyRows(rowSelection)) {
            this.copySelectedRowsToClipboard(copyParams);
            cellClearType = 1 /* SelectedRows */ ;
        } else if (focusSvc.isAnyCellFocused()) {
            this.copyFocusedCellToClipboard(copyParams);
            cellClearType = 2 /* FocusedCell */ ;
        }
        if (cut && cellClearType !== null) this.clearCellsAfterCopy(cellClearType);
    }
    shouldCopyCells(cellSelection, rowSelection) {
        const { rangeSvc: rangeSvc, selectionSvc: selectionSvc, gos: gos } = this.beans;
        if (!rangeSvc || rangeSvc.isEmpty()) return false;
        if (cellSelection) {
            const shouldCopyRowsInstead = typeof rowSelection === "object" && rowSelection.copySelectedRows && !selectionSvc?.isEmpty();
            return !shouldCopyRowsInstead;
        } else {
            const suppressCopySingleCellRanges = gos.get("suppressCopySingleCellRanges");
            const shouldSkip = !rangeSvc.isMoreThanOneCell() && suppressCopySingleCellRanges;
            return !shouldSkip;
        }
    }
    shouldCopyRows(rowSelection) {
        const { selectionSvc: selectionSvc, gos: gos } = this.beans;
        if (selectionSvc?.isEmpty() ?? true) return false;
        if (rowSelection && typeof rowSelection !== "string") return rowSelection.copySelectedRows ?? false;
        else return !gos.get("suppressCopyRowsToClipboard");
    }
    clearCellsAfterCopy(type) {
        const beans = this.beans;
        const { rangeSvc: rangeSvc, focusSvc: focusSvc, eventSvc: eventSvc } = beans;
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellStart"
        });
        if (type === 0 /* CellRange */ ) rangeSvc.clearCellRangeCellValues({
            cellEventSource: "clipboardSvc"
        });
        else if (type === 1 /* SelectedRows */ ) this.clearSelectedRows();
        else {
            const focusedCell = focusSvc.getFocusedCell();
            if (focusedCell == null) return;
            const rowNode = (0, $437b23f6a393c3bf$export$d4675a60917db7b0)(beans, focusedCell);
            if (rowNode) this.clearCellValue(rowNode, focusedCell.column);
        }
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellEnd"
        });
    }
    clearSelectedRows() {
        const { selectionSvc: selectionSvc, visibleCols: visibleCols } = this.beans;
        const selected = selectionSvc?.getSelectedNodes() ?? [];
        const columns = visibleCols.allCols;
        for (const row of selected)for (const col of columns)this.clearCellValue(row, col);
    }
    clearCellValue(rowNode, column) {
        if (!column.isCellEditable(rowNode)) return;
        const emptyValue = this.beans.valueSvc.getDeleteValue(column, rowNode);
        rowNode.setDataValue(column, emptyValue, "clipboardSvc");
    }
    iterateActiveRanges(rowCallback, onlyFirst, preProcessRange) {
        const rangeSvc = this.beans.rangeSvc;
        if (!rangeSvc || rangeSvc.isEmpty()) return;
        const currentCellRanges = rangeSvc.getCellRanges();
        const cellRanges = onlyFirst ? [
            currentCellRanges[0]
        ] : currentCellRanges;
        for (const cellRange of cellRanges)this.iterateActiveRange({
            cellRange: cellRange,
            rowCallback: rowCallback,
            preProcessRange: preProcessRange
        });
    }
    iterateActiveRange(params) {
        const { cellRange: cellRange, preProcessRange: preProcessRange, rowCallback: rowCallback } = params;
        const { beans: beans } = this;
        const { rangeSvc: rangeSvc } = beans;
        if (!rangeSvc) return;
        if (preProcessRange) preProcessRange(cellRange);
        let currentRow = rangeSvc.getRangeStartRow(cellRange);
        const lastRow = rangeSvc.getRangeEndRow(cellRange);
        let rangeIndex = 0;
        let isLastRow = false;
        while(!isLastRow && currentRow != null){
            const rowNode = (0, $437b23f6a393c3bf$export$d4675a60917db7b0)(beans, currentRow);
            isLastRow = (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(currentRow, lastRow);
            rowCallback(currentRow, rowNode, cellRange, rangeIndex++);
            currentRow = (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(beans, currentRow);
        }
    }
    copySelectedRangeToClipboard(params = {}) {
        const rangeSvc = this.beans.rangeSvc;
        if (!rangeSvc || rangeSvc.isEmpty()) return;
        const allRangesMerge = rangeSvc.areAllRangesAbleToMerge();
        const { data: data, cellsToFlash: cellsToFlash } = allRangesMerge ? this.buildDataFromMergedRanges(rangeSvc, params) : this.buildDataFromRanges(rangeSvc, params);
        this.copyDataToClipboard(data);
        this.dispatchFlashCells(cellsToFlash);
    }
    buildDataFromMergedRanges(rangeSvc, params) {
        const columnsSet = /* @__PURE__ */ new Set();
        const ranges = rangeSvc.getCellRanges();
        const rowPositionsMap = /* @__PURE__ */ new Map();
        const allRowPositions = [];
        const allCellsToFlash = {};
        const isClientSideRowModel = (0, $437b23f6a393c3bf$export$9f182d9ca737e15)(this.gos, this.beans.rowModel);
        const flatCache = /* @__PURE__ */ new Set();
        if (!isClientSideRowModel) this.beans.rowModel.forEachNode((node)=>{
            flatCache.add(node.rowIndex);
        });
        for (const range of ranges){
            range.columns.forEach((col)=>columnsSet.add(col));
            const { rowPositions: rowPositions, cellsToFlash: cellsToFlash } = this.getRangeRowPositionsAndCellsToFlash(rangeSvc, range);
            for (const rowPosition of rowPositions){
                const isInCache = flatCache.has(rowPosition.rowIndex);
                if (!isClientSideRowModel && !isInCache) continue;
                const rowPositionAsString = `${rowPosition.rowIndex}-${rowPosition.rowPinned || "null"}`;
                if (!rowPositionsMap.get(rowPositionAsString)) {
                    rowPositionsMap.set(rowPositionAsString, true);
                    allRowPositions.push(rowPosition);
                }
            }
            Object.assign(allCellsToFlash, cellsToFlash);
        }
        const allColumns = this.beans.visibleCols.allCols;
        const exportedColumns = Array.from(columnsSet);
        exportedColumns.sort((a, b)=>{
            const posA = allColumns.indexOf(a);
            const posB = allColumns.indexOf(b);
            return posA - posB;
        });
        const data = this.buildExportParams({
            columns: exportedColumns,
            rowPositions: allRowPositions,
            includeHeaders: params.includeHeaders,
            includeGroupHeaders: params.includeGroupHeaders
        });
        return {
            data: data,
            cellsToFlash: allCellsToFlash
        };
    }
    buildDataFromRanges(rangeSvc, params) {
        const ranges = rangeSvc.getCellRanges();
        const data = [];
        const allCellsToFlash = {};
        for (const range of ranges){
            const { rowPositions: rowPositions, cellsToFlash: cellsToFlash } = this.getRangeRowPositionsAndCellsToFlash(rangeSvc, range);
            Object.assign(allCellsToFlash, cellsToFlash);
            data.push(this.buildExportParams({
                columns: range.columns,
                rowPositions: rowPositions,
                includeHeaders: params.includeHeaders,
                includeGroupHeaders: params.includeGroupHeaders
            }));
        }
        return {
            data: data.join("\n"),
            cellsToFlash: allCellsToFlash
        };
    }
    getRangeRowPositionsAndCellsToFlash(rangeSvc, range) {
        const rowPositions = [];
        const cellsToFlash = {};
        const startRow = rangeSvc.getRangeStartRow(range);
        const lastRow = rangeSvc.getRangeEndRow(range);
        let node = startRow;
        while(node){
            rowPositions.push(node);
            for (const column of range.columns){
                const { rowIndex: rowIndex, rowPinned: rowPinned } = node;
                const cellId = (0, $437b23f6a393c3bf$export$c0c5a5ba9327269f)({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned
                });
                cellsToFlash[cellId] = true;
            }
            if ((0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(node, lastRow)) break;
            node = (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(this.beans, node);
        }
        return {
            rowPositions: rowPositions,
            cellsToFlash: cellsToFlash
        };
    }
    getCellsToFlashFromRowNodes(rowNodes) {
        const allDisplayedColumns = this.beans.visibleCols.allCols;
        const cellsToFlash = {};
        for(let i = 0; i < rowNodes.length; i++){
            const { level: level, rowIndex: index, rowPinned: rowPinned, sibling: sibling } = rowNodes[i];
            const rowIndex = level === -1 ? sibling.rowIndex : index;
            if (rowIndex == null) continue;
            for(let j = 0; j < allDisplayedColumns.length; j++){
                const column = allDisplayedColumns[j];
                const cellId = (0, $437b23f6a393c3bf$export$c0c5a5ba9327269f)({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned
                });
                cellsToFlash[cellId] = true;
            }
        }
        return cellsToFlash;
    }
    copyFocusedCellToClipboard(params = {}) {
        let focusedCell = this.beans.focusSvc.getFocusedCell();
        if (focusedCell == null) return;
        focusedCell = this.beans.rowSpanSvc?.getCellStart(focusedCell) ?? focusedCell;
        const cellId = (0, $437b23f6a393c3bf$export$c0c5a5ba9327269f)(focusedCell);
        const currentRow = {
            rowPinned: focusedCell.rowPinned,
            rowIndex: focusedCell.rowIndex
        };
        const column = focusedCell.column;
        const data = this.buildExportParams({
            columns: [
                column
            ],
            rowPositions: [
                currentRow
            ],
            includeHeaders: params.includeHeaders,
            includeGroupHeaders: params.includeGroupHeaders
        });
        this.copyDataToClipboard(data);
        this.dispatchFlashCells({
            [cellId]: true
        });
    }
    copySelectedRowsToClipboard(params = {}) {
        const { columnKeys: columnKeys, includeHeaders: includeHeaders, includeGroupHeaders: includeGroupHeaders } = params;
        const data = this.buildExportParams({
            columns: columnKeys,
            includeHeaders: includeHeaders,
            includeGroupHeaders: includeGroupHeaders
        });
        this.copyDataToClipboard(data);
        const rowNodes = this.beans.selectionSvc?.getSelectedNodes() || [];
        this.dispatchFlashCells(this.getCellsToFlashFromRowNodes(rowNodes));
    }
    buildExportParams(params) {
        const { columns: columns, rowPositions: rowPositions, includeHeaders: includeHeaders = false, includeGroupHeaders: includeGroupHeaders = false } = params;
        const { gos: gos, csvCreator: csvCreator } = this.beans;
        const processRowGroupCallback = ({ node: node, column: column })=>{
            const { value: value, valueFormatted: valueFormatted } = this.beans.valueSvc.getValueForDisplay({
                column: column,
                node: node,
                includeValueFormatted: true
            });
            const val = valueFormatted ?? value ?? "";
            const cb = gos.getCallback("processCellForClipboard");
            if (!cb) return val;
            return cb({
                column: column,
                node: node,
                value: val,
                type: $5b7ccabde48fae90$var$EXPORT_TYPE_CLIPBOARD,
                formatValue: (valueToFormat)=>this.beans.valueSvc.formatValue(column, node, valueToFormat) ?? valueToFormat,
                parseValue: (valueToParse)=>this.beans.valueSvc.parseValue(column, node, valueToParse, value) ?? valueToParse
            });
        };
        const exportParams = {
            columnKeys: columns,
            rowPositions: rowPositions,
            skipColumnHeaders: !includeHeaders,
            skipColumnGroupHeaders: !includeGroupHeaders,
            suppressQuotes: true,
            columnSeparator: this.getClipboardDelimiter(),
            onlySelected: !rowPositions,
            processCellCallback: gos.getCallback("processCellForClipboard"),
            processRowGroupCallback: processRowGroupCallback,
            processHeaderCallback: gos.getCallback("processHeaderForClipboard"),
            processGroupHeaderCallback: gos.getCallback("processGroupHeaderForClipboard")
        };
        return csvCreator.getDataAsCsv(exportParams, true);
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    dispatchFlashCells(cellsToFlash) {
        window.setTimeout(()=>{
            this.eventSvc.dispatchEvent({
                type: "flashCells",
                cells: cellsToFlash
            });
        }, 0);
    }
    processCell(rowNode, column, value, type, func, canParse, canFormat) {
        const { valueSvc: valueSvc, formula: formula } = this.beans;
        if (func) {
            const params = {
                column: column,
                node: rowNode,
                value: value,
                type: type,
                formatValue: (valueToFormat)=>valueSvc.formatValue(column, rowNode ?? null, valueToFormat) ?? valueToFormat,
                parseValue: (valueToParse)=>valueSvc.parseValue(column, rowNode ?? null, valueToParse, valueSvc.getValue(column, rowNode))
            };
            return func(params);
        }
        if (canParse && column.getColDef().useValueParserForImport !== false) return valueSvc.parseValue(column, rowNode ?? null, value, valueSvc.getValue(column, rowNode));
        if (canFormat && column.getColDef().useValueFormatterForExport !== false) {
            if (formula?.isFormula(value)) return value;
            return valueSvc.formatValue(column, rowNode ?? null, value) ?? value;
        }
        return value;
    }
    copyDataToClipboard(data) {
        const userProvidedFunc = this.gos.getCallback("sendToClipboard");
        if (userProvidedFunc) {
            userProvidedFunc({
                data: data
            });
            return;
        }
        const allowNavigator = !this.gos.get("suppressClipboardApi");
        if (allowNavigator && navigator.clipboard) {
            navigator.clipboard.writeText(data).catch((e)=>{
                (0, $437b23f6a393c3bf$export$545083624300f13d)(40, {
                    e: e,
                    method: "writeText"
                });
                this.copyDataToClipboardLegacy(data);
            });
            return;
        }
        this.copyDataToClipboardLegacy(data);
    }
    copyDataToClipboardLegacy(data) {
        this.executeOnTempElement((element)=>{
            const eDocument = (0, $437b23f6a393c3bf$export$f63d0991874c6f81)(this.beans);
            const focusedElementBefore = (0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans);
            element.value = data || " ";
            element.select();
            element.focus({
                preventScroll: true
            });
            const result = eDocument.execCommand("copy");
            if (!result) (0, $437b23f6a393c3bf$export$545083624300f13d)(41);
            if (focusedElementBefore?.focus != null) focusedElementBefore.focus({
                preventScroll: true
            });
        });
    }
    executeOnTempElement(callbackNow, callbackAfter) {
        if (!this.gridCtrl) return;
        const eDoc = (0, $437b23f6a393c3bf$export$f63d0991874c6f81)(this.beans);
        const eTempInput = eDoc.createElement("textarea");
        const style = eTempInput.style;
        style.width = "1px";
        style.height = "1px";
        const documentElement = eDoc.documentElement;
        style.top = documentElement.scrollTop + "px";
        style.left = documentElement.scrollLeft + "px";
        style.position = "absolute";
        style.opacity = "0";
        const guiRoot = this.gridCtrl.getGui();
        guiRoot.appendChild(eTempInput);
        try {
            callbackNow(eTempInput);
        } catch (err) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(42);
        }
        if (callbackAfter) window.setTimeout(()=>{
            callbackAfter(eTempInput);
            eTempInput.remove();
        }, 100);
        else eTempInput.remove();
    }
};
// packages/ag-grid-enterprise/src/clipboard/clipboardModule.ts
var $5b7ccabde48fae90$export$3a36bd45ca02edda = {
    moduleName: "Clipboard",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$ClipboardService
    ],
    apiFunctions: {
        copyToClipboard: $5b7ccabde48fae90$var$copyToClipboard,
        cutToClipboard: $5b7ccabde48fae90$var$cutToClipboard,
        copySelectedRowsToClipboard: $5b7ccabde48fae90$var$copySelectedRowsToClipboard,
        copySelectedRangeToClipboard: $5b7ccabde48fae90$var$copySelectedRangeToClipboard,
        copySelectedRangeDown: $5b7ccabde48fae90$var$copySelectedRangeDown,
        pasteFromClipboard: $5b7ccabde48fae90$var$pasteFromClipboard
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$f744275d8b795fc2),
        (0, $437b23f6a393c3bf$export$44f04c51d8088336),
        (0, $437b23f6a393c3bf$export$98e8472b11750a07)
    ]
};
// packages/ag-grid-enterprise/src/rowNumbers/rowNumbers.css-GENERATED.ts
var $5b7ccabde48fae90$var$rowNumbersCSS = /*css*/ `.ag-row-number-cell{background-color:var(--ag-header-background-color);border:none;color:var(--ag-header-text-color);font-family:var(--ag-header-font-family);font-size:var(--ag-header-font-size);font-weight:var(--ag-header-font-weight);overflow:hidden;-webkit-user-select:none;-moz-user-select:none;user-select:none;white-space:nowrap;width:100%}:where(.ag-ltr) .ag-row-number-cell{text-align:right}:where(.ag-rtl) .ag-row-number-cell{text-align:left}.ag-row-numbers-resizer{bottom:-2px;cursor:ns-resize;height:4px;position:absolute;width:100%}:where(.ag-ltr) .ag-row-numbers-resizer{left:0}:where(.ag-rtl) .ag-row-numbers-resizer{right:0}.ag-floating-bottom .ag-row-numbers-resizer{bottom:unset;top:-2px}:where(.ag-row-number-header.ag-row-number-selection-enabled){cursor:cell}.ag-row-number-range-highlight{background-color:var(--ag-range-header-highlight-color)}.ag-row-number-range-selected{background-color:var(--ag-row-numbers-selected-color)}:where(.ag-ltr){.ag-row-number-header,:where(.ag-cell.ag-row-number-cell):not(.ag-cell-last-left-pinned){border-right:var(--ag-pinned-column-border)}:where(.ag-cell.ag-row-number-cell.ag-row-number-selection-enabled){cursor:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxLjUiPjxwYXRoIGQ9Ik0zLjQ0NSA4LjkxMVY3LjQwOUg5Ljc1VjYuMDE0bDIuNTM1IDIuMTQ2LTIuNTM1IDIuMTQ2VjguOTExeiIgc3R5bGU9InN0cm9rZTojZmZmO3N0cm9rZS13aWR0aDouNDFweCIgdHJhbnNmb3JtPSJtYXRyaXgoMS41Nzg0IDAgMCAxLjg2NDI5IC00LjQxMyAtNy4yMTIpIi8+PC9zdmc+"),auto}}:where(.ag-rtl){.ag-row-number-header,:where(.ag-cell.ag-row-number-cell):not(.ag-cell-first-right-pinned){border-left:var(--ag-pinned-column-border)}:where(.ag-cell.ag-row-number-cell.ag-row-number-selection-enabled){cursor:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxLjUiPjxwYXRoIGQ9Ik01Ljk3OSA4LjkxMXYxLjM5NUwzLjQ0NSA4LjE2bDIuNTM0LTIuMTQ2djEuMzk1aDYuMzA2djEuNTAyeiIgc3R5bGU9InN0cm9rZTojZmZmO3N0cm9rZS13aWR0aDouNDFweCIgdHJhbnNmb3JtPSJtYXRyaXgoMS41Nzg0IDAgMCAxLjg2NDI5IC00LjQxMyAtNy4yMTIpIi8+PC9zdmc+"),auto}}`;
var $5b7ccabde48fae90$var$RowNumbersRowResizerElement = {
    tag: "div",
    cls: "ag-row-numbers-resizer"
};
var $5b7ccabde48fae90$var$AgRowNumbersRowResizer = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(cellCtrl){
        super($5b7ccabde48fae90$var$RowNumbersRowResizerElement);
        this.cellCtrl = cellCtrl;
        this.initialYPosition = -1;
        this.dragging = false;
    }
    postConstruct() {
        const { beans: beans, cellCtrl: cellCtrl } = this;
        const { dragSvc: dragSvc, environment: environment } = beans;
        this.defaultRowHeight = environment.getDefaultRowHeight();
        dragSvc.addDragSource({
            dragStartPixels: 0,
            eElement: this.getGui(),
            onDragStart: this.onDragStart.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragStop: this.onDragStop.bind(this),
            onDragCancel: this.onDragCancel.bind(this),
            includeTouch: true,
            stopPropagationForTouch: true
        });
        const rowPosition = cellCtrl.getRowPosition();
        this.node = (0, $437b23f6a393c3bf$export$d4675a60917db7b0)(this.beans, rowPosition);
    }
    onDragStart(mouseEvent) {
        if (!this.node) return;
        const { beans: { ctrlsSvc: ctrlsSvc, eventSvc: eventSvc } } = this;
        const ctrl = ctrlsSvc.get("gridCtrl");
        ctrl.setResizeCursor((0, $437b23f6a393c3bf$export$cacd6541cfeeb6c1).Vertical);
        this.dragging = true;
        this.initialHeight = this.node.rowHeight;
        eventSvc.dispatchEvent({
            type: "rowResizeStarted",
            node: this.node,
            event: mouseEvent,
            rowHeight: this.initialHeight
        });
    }
    onDragging(mouseEvent) {
        let { clientY: clientY } = mouseEvent;
        if (this.cellCtrl.rowNode.rowPinned === "bottom") clientY *= -1;
        if (this.initialYPosition === -1 || !this.dragging) {
            this.initialYPosition = clientY;
            return;
        }
        const { beans: beans, initialHeight: initialHeight, initialYPosition: initialYPosition, defaultRowHeight: defaultRowHeight, node: node } = this;
        if (initialHeight == null) return;
        const currentSize = node?.rowHeight;
        const newSize = Math.max(initialHeight - (initialYPosition - clientY), defaultRowHeight);
        if (currentSize === newSize) return;
        node?.setRowHeight(newSize);
        const { rowRenderer: rowRenderer, rowModel: rowModel, pinnedRowModel: pinnedRowModel } = beans;
        const pinned = !!node?.rowPinned;
        if (pinned) rowRenderer.redraw({
            afterScroll: true
        });
        if (!pinned || pinnedRowModel?.isManual()) rowModel.onRowHeightChanged({
            animate: false
        });
    }
    onDragStop(mouseEvent) {
        this.beans.eventSvc.dispatchEvent({
            type: "rowResizeEnded",
            node: this.node,
            event: mouseEvent,
            rowHeight: this.node?.rowHeight
        });
        this.clearDragDetails(true);
    }
    onDragCancel() {
        this.clearDragDetails(true);
    }
    clearDragDetails(fromDragEvent) {
        this.initialYPosition = -1;
        this.initialHeight = null;
        this.dragging = false;
        if (fromDragEvent) {
            const ctrl = this.beans.ctrlsSvc.get("gridCtrl");
            ctrl.setResizeCursor(false);
        }
    }
    destroy() {
        this.clearDragDetails(false);
        this.node = void 0;
        super.destroy();
    }
};
function $5b7ccabde48fae90$var$_isRowNumbersResizerEnabled(beans) {
    const rowNumbers = (0, $437b23f6a393c3bf$export$58f4eed4127eb370)(beans);
    return !(!rowNumbers || typeof rowNumbers !== "object" || !rowNumbers.enableRowResizer);
}
var $5b7ccabde48fae90$var$RowNumbersRowResizeFeature = class {
    constructor(beans, cellCtrl){
        this.beans = beans;
        this.cellCtrl = cellCtrl;
    }
    refreshRowResizer() {
        if (!$5b7ccabde48fae90$var$_isRowNumbersResizerEnabled(this.beans) || !this.isRowResizeSupported(this.cellCtrl.rowNode)) this.removeRowResizerFromCellComp();
        else this.addResizerToCellComp();
    }
    isRowResizeSupported(node) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel, visibleCols: visibleCols } = this.beans;
        const rowModelModelHasOnRowHeightChanged = !!rowModel.onRowHeightChanged;
        if (visibleCols.autoHeightCols.length) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(276);
            return false;
        }
        if (node.rowPinned != null) return pinnedRowModel?.isManual() ? rowModelModelHasOnRowHeightChanged : true;
        return rowModelModelHasOnRowHeightChanged;
    }
    addResizerToCellComp() {
        const { beans: beans, cellCtrl: cellCtrl } = this;
        const { eGui: eGui } = cellCtrl;
        let { rowResizer: rowResizer } = this;
        if (rowResizer) {
            eGui.appendChild(rowResizer.getGui());
            return;
        }
        rowResizer = beans.registry.createDynamicBean("rowNumberRowResizer", false, cellCtrl);
        if (!rowResizer) return;
        this.rowResizer = beans.context.createBean(rowResizer);
        eGui.appendChild(rowResizer.getGui());
    }
    removeRowResizerFromCellComp() {
        const { rowResizer: rowResizer, beans: { context: context } } = this;
        if (!rowResizer) return;
        (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(rowResizer.getGui());
        this.rowResizer = context.destroyBean(rowResizer);
    }
    destroy() {
        this.removeRowResizerFromCellComp();
    }
};
// packages/ag-grid-enterprise/src/rowNumbers/rowNumbersService.ts
var $5b7ccabde48fae90$var$RowNumbersService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "rowNumbersSvc";
        this.isIntegratedWithSelection = false;
        this.lastColumnResized = 0;
    }
    postConstruct() {
        const refreshCells_debounced = (0, $437b23f6a393c3bf$export$cf7e39bfb94de6e)(this, this.refreshCells.bind(this), 10);
        this.addManagedEventListeners({
            columnResized: ()=>{
                this.lastColumnResized = Date.now();
            },
            modelUpdated: (params)=>{
                refreshCells_debounced(false, !params.keepRenderedRows);
            },
            rangeSelectionChanged: ()=>this.refreshCells(true),
            pinnedRowsChanged: ()=>refreshCells_debounced(false, true)
        });
        this.addManagedPropertyListeners([
            "rowNumbers",
            "cellSelection"
        ], (e)=>{
            this.updateColumns(e);
        });
        this.refreshSelectionIntegration();
    }
    addColumns(cols) {
        if (this.columns == null) return;
        cols.list = this.columns.list.concat(cols.list);
        cols.tree = this.columns.tree.concat(cols.tree);
        (0, $437b23f6a393c3bf$export$c82fd63ff1738bed)(cols);
    }
    createColumns(cols, updateOrders) {
        const destroyCollection = ()=>{
            (0, $437b23f6a393c3bf$export$dbaaa57234b60d8f)(this.beans, this.columns?.tree);
            this.columns = null;
        };
        const { beans: beans } = this;
        if (!(0, $437b23f6a393c3bf$export$58f4eed4127eb370)(beans)) {
            destroyCollection();
            return;
        }
        const newTreeDepth = cols.treeDepth;
        const oldTreeDepth = this.columns?.treeDepth ?? -1;
        const treeDepthSame = oldTreeDepth == newTreeDepth;
        const list = this.generateRowNumberCols();
        const areSame = (0, $437b23f6a393c3bf$export$f56e341a1fe35ed4)(list, this.columns?.list ?? []);
        if (areSame && treeDepthSame) return;
        destroyCollection();
        const { colGroupSvc: colGroupSvc } = this.beans;
        const treeDepth = colGroupSvc?.findDepth(cols.tree) ?? 0;
        const tree = colGroupSvc?.balanceTreeForAutoCols(list, treeDepth) ?? [];
        this.columns = {
            list: list,
            tree: tree,
            treeDepth: treeDepth,
            map: {}
        };
        const putRowNumbersColsFirstInList = (cols2)=>{
            if (!cols2) return null;
            const colsFiltered = cols2.filter((col)=>!(0, $437b23f6a393c3bf$export$3d3e7d751f0445eb)(col));
            return [
                ...list,
                ...colsFiltered
            ];
        };
        updateOrders(putRowNumbersColsFirstInList);
    }
    handleMouseDownOnCell(cellPosition, mouseEvent) {
        if (!this.isIntegratedWithSelection || mouseEvent.target.classList.contains("ag-row-numbers-resizer")) {
            if (this.beans.rangeSvc) mouseEvent.preventDefault();
            mouseEvent.stopImmediatePropagation();
            return false;
        }
        if (!mouseEvent.shiftKey && !(0, $437b23f6a393c3bf$export$f8093014f10b296a)(this.beans, mouseEvent)) this.focusFirstRenderedCellAtRowPosition(cellPosition);
        return true;
    }
    updateColumns(event) {
        const source = (0, $437b23f6a393c3bf$export$eb2a92b6162267d1)(event.source);
        this.refreshSelectionIntegration();
        for (const col of this.columns?.list ?? []){
            const colDef = this.createRowNumbersColDef();
            col.setColDef(colDef, null, source);
            (0, $437b23f6a393c3bf$export$b2854c1cb8f10386)(this.beans, {
                state: [
                    (0, $437b23f6a393c3bf$export$2fd1bdef8244d93c)(colDef, col.getColId())
                ]
            }, source);
        }
    }
    getColumn() {
        return this.columns?.list.find((0, $437b23f6a393c3bf$export$3d3e7d751f0445eb)) ?? null;
    }
    getColumns() {
        return this.columns?.list ?? null;
    }
    setupForHeader(comp) {
        const { column: column, eGridHeader: eGridHeader } = comp.params;
        if (!(0, $437b23f6a393c3bf$export$3d3e7d751f0445eb)(column)) return;
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(eGridHeader, "Row Number");
        this.addManagedElementListeners(eGridHeader, {
            click: this.onHeaderClick.bind(this),
            keydown: this.onHeaderKeyDown.bind(this),
            focus: this.onHeaderFocus.bind(this)
        });
    }
    createRowNumbersRowResizerFeature(ctrl) {
        if (!$5b7ccabde48fae90$var$_isRowNumbersResizerEnabled(this.beans)) return void 0;
        return new $5b7ccabde48fae90$var$RowNumbersRowResizeFeature(this.beans, ctrl);
    }
    refreshSelectionIntegration() {
        const { beans: beans } = this;
        const { gos: gos, rangeSvc: rangeSvc } = beans;
        const cellSelection = gos.get("cellSelection");
        this.refreshRowNumberOverrides();
        this.isIntegratedWithSelection = !!rangeSvc && !!cellSelection && !this.isSuppressCellSelectionIntegration;
    }
    refreshRowNumberOverrides() {
        const rowNumbers = (0, $437b23f6a393c3bf$export$58f4eed4127eb370)(this.beans);
        this.rowNumberOverrides = {};
        if (!rowNumbers || typeof rowNumbers !== "object") return;
        if (rowNumbers.suppressCellSelectionIntegration) this.isSuppressCellSelectionIntegration = true;
        const colDefValidProps = [
            "contextMenuItems",
            "context",
            "onCellClicked",
            "onCellContextMenu",
            "onCellDoubleClicked",
            "headerTooltip",
            "headerStyle",
            "headerComponent",
            "headerComponentParams",
            "suppressHeaderKeyboardEvent",
            "tooltipField",
            "tooltipValueGetter",
            "tooltipComponent",
            "tooltipComponentParams",
            "tooltipComponentSelector",
            "valueGetter",
            "valueFormatter",
            "width",
            "maxWidth",
            "minWidth",
            "resizable"
        ];
        for (const prop of colDefValidProps)if (rowNumbers[prop] != null) this.rowNumberOverrides[prop] = rowNumbers[prop];
    }
    onHeaderFocus() {
        this.beans.ariaAnnounce?.announceValue("Press Space to select all cells", "ariaSelectAllCells");
    }
    onHeaderKeyDown(e) {
        if (!this.isIntegratedWithSelection || e.key !== (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE) return;
        this.handleFocusAllCellsFromHeader();
    }
    onHeaderClick(_e) {
        if (Date.now() - this.lastColumnResized < 100 || !this.isIntegratedWithSelection || this.getColumn()?.resizing) return;
        this.handleFocusAllCellsFromHeader();
    }
    handleFocusAllCellsFromHeader() {
        (0, $437b23f6a393c3bf$export$57896ee3d2f5a3d)(this.beans);
        this.focusFirstRenderedCellAtRowPosition();
    }
    refreshCells(force, runAutoSize) {
        const column = this.getColumn();
        if (!column) return;
        if (runAutoSize) {
            const width = this.beans.autoWidthCalc?.getPreferredWidthForElements([
                this.createDummyElement(column)
            ], 2);
            if (width != null) this.beans.colResize?.setColumnWidths([
                {
                    key: column,
                    newWidth: width
                }
            ], false, true, "rowNumbersService");
        }
        this.beans.rowRenderer.refreshCells({
            columns: [
                column
            ],
            force: force
        });
    }
    createDummyElement(column) {
        const div = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div",
            cls: "ag-cell-value ag-cell"
        });
        let value = String(this.beans.rowModel.getRowCount() + 1);
        if (typeof this.rowNumberOverrides.valueFormatter === "function") {
            const valueFormatterParams = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.beans.gos, {
                data: void 0,
                value: value,
                node: null,
                column: column,
                colDef: column.colDef
            });
            value = this.rowNumberOverrides.valueFormatter(valueFormatterParams);
        }
        div.textContent = value;
        return div;
    }
    createRowNumbersColDef() {
        const { gos: gos, contextMenuSvc: contextMenuSvc } = this.beans;
        const enableRTL = gos.get("enableRtl");
        return {
            // overridable properties
            minWidth: 60,
            width: 60,
            resizable: false,
            valueGetter: this.valueGetter.bind(this),
            contextMenuItems: this.isIntegratedWithSelection || !contextMenuSvc ? void 0 : ()=>[],
            // overrides
            ...this.rowNumberOverrides,
            // non-overridable properties
            colId: (0, $437b23f6a393c3bf$export$f55c01dfb205b029),
            chartDataType: "excluded",
            suppressHeaderMenuButton: true,
            sortable: false,
            suppressMovable: true,
            lockPinned: true,
            pinned: enableRTL ? "right" : "left",
            lockPosition: enableRTL ? "right" : "left",
            editable: false,
            suppressFillHandle: true,
            suppressAutoSize: true,
            suppressSizeToFit: true,
            suppressHeaderContextMenu: true,
            suppressNavigable: true,
            headerClass: this.getHeaderClass(),
            cellClass: this.getCellClass.bind(this),
            cellAriaRole: "rowheader"
        };
    }
    valueGetter(params) {
        const node = params.node;
        const isFormulasActive = this.beans.formula?.active;
        const pinnedSibling = node?.pinnedSibling;
        if (node?.rowPinned && pinnedSibling) {
            const rowIndex = isFormulasActive ? pinnedSibling.formulaRowIndex : pinnedSibling.rowIndex;
            return `${rowIndex == null ? "-" : rowIndex + 1}`;
        }
        return String(((isFormulasActive ? node?.formulaRowIndex : node?.rowIndex) || 0) + 1);
    }
    getHeaderClass() {
        const cssClass = [
            "ag-row-number-header"
        ];
        if (this.isIntegratedWithSelection) cssClass.push("ag-row-number-selection-enabled");
        return cssClass;
    }
    getCellClass(params) {
        const { beans: beans } = this;
        const { rangeSvc: rangeSvc, gos: gos } = beans;
        const { node: node } = params;
        const cssClasses = [
            "ag-row-number-cell"
        ];
        const cellSelection = gos.get("cellSelection");
        if (!rangeSvc || !cellSelection) return cssClasses;
        if (this.isIntegratedWithSelection) cssClasses.push("ag-row-number-selection-enabled");
        const ranges = rangeSvc.getCellRanges();
        if (!ranges.length) return cssClasses;
        const allColsLen = this.beans.visibleCols.allCols.length - 1;
        const shouldHighlight = typeof cellSelection === "object" && cellSelection.enableHeaderHighlight;
        for (const range of ranges)if (rangeSvc.isRowInRange({
            rowIndex: node.rowIndex,
            rowPinned: node.rowPinned
        }, range)) {
            if (shouldHighlight) cssClasses.push("ag-row-number-range-highlight");
            if (range.columns.length === allColsLen) cssClasses.push("ag-row-number-range-selected");
        }
        return cssClasses;
    }
    generateRowNumberCols() {
        const { gos: gos, beans: beans } = this;
        if (!(0, $437b23f6a393c3bf$export$58f4eed4127eb370)(beans)) return [];
        const colDef = this.createRowNumbersColDef();
        const colId = colDef.colId;
        gos.validateColDef(colDef, colId, true);
        const col = new (0, $437b23f6a393c3bf$export$a8da3e2b83e5ddf2)(colDef, null, colId, false);
        this.createBean(col);
        return [
            col
        ];
    }
    // focus is disabled on the Row Numbers cells, when a click happens on it,
    // it should focus the first cell of that row or first cell of the grid (from header).
    focusFirstRenderedCellAtRowPosition(rowPosition) {
        if (!rowPosition) {
            rowPosition = (0, $437b23f6a393c3bf$export$124b4386b662b699)(this.beans);
            if (!rowPosition) return;
        }
        const { beans: beans, gos: gos } = this;
        const { visibleCols: visibleCols, colViewport: colViewport } = beans;
        const pinnedCols = gos.get("enableRtl") ? visibleCols.rightCols : visibleCols.leftCols;
        let columns;
        if (pinnedCols.length == 1) {
            const rowNode = (0, $437b23f6a393c3bf$export$d4675a60917db7b0)(beans, rowPosition);
            if (!rowNode) return;
            columns = colViewport.getColsWithinViewport(rowNode);
        } else columns = pinnedCols;
        const column = columns.find((col)=>!(0, $437b23f6a393c3bf$export$3d3e7d751f0445eb)(col));
        if (!column) return;
        const { rowPinned: rowPinned, rowIndex: rowIndex } = rowPosition;
        setTimeout(()=>{
            beans.focusSvc.setFocusedCell({
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                column: column,
                forceBrowserFocus: true,
                preventScrollOnBrowserFocus: true
            });
        });
    }
    destroy() {
        (0, $437b23f6a393c3bf$export$dbaaa57234b60d8f)(this.beans, this.columns?.tree);
        this.rowNumberOverrides = null;
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/rowNumbers/rowNumbersModule.ts
var $5b7ccabde48fae90$export$f0e5f58d7c17c748 = {
    moduleName: "RowNumbers",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$RowNumbersService
    ],
    dynamicBeans: {
        rowNumberRowResizer: $5b7ccabde48fae90$var$AgRowNumbersRowResizer
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$be75c2ed74fb2144),
        (0, $437b23f6a393c3bf$export$4ad116d131ade5b4)
    ],
    css: [
        $5b7ccabde48fae90$var$rowNumbersCSS
    ]
};
var $5b7ccabde48fae90$var$AgFiltersToolPanelHeaderElement = {
    tag: "div",
    cls: "ag-filter-toolpanel-search",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eExpand",
            cls: "ag-filter-toolpanel-expand"
        },
        {
            tag: "ag-input-text-field",
            ref: "eFilterTextField",
            cls: "ag-filter-toolpanel-search-input"
        }
    ]
};
var $5b7ccabde48fae90$var$AgFiltersToolPanelHeader = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.eExpand = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eFilterTextField = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        this.setTemplate($5b7ccabde48fae90$var$AgFiltersToolPanelHeaderElement, [
            (0, $437b23f6a393c3bf$export$31e2985be4ee06ab)
        ]);
        const translate = this.getLocaleTextFunc();
        this.eFilterTextField.setAutoComplete(false).setInputAriaLabel(translate("ariaFilterColumnsInput", "Filter Columns Input")).onValueChange(this.onSearchTextChanged.bind(this));
        this.createExpandIcons();
        this.setExpandState(0 /* EXPANDED */ );
        this.addManagedElementListeners(this.eExpand, {
            click: this.onExpandClicked.bind(this)
        });
        this.addManagedEventListeners({
            newColumnsLoaded: this.showOrHideOptions.bind(this)
        });
    }
    init(params) {
        this.params = params;
        if (this.beans.colModel.ready) this.showOrHideOptions();
    }
    createExpandIcons() {
        const { eExpand: eExpand, beans: beans } = this;
        eExpand.appendChild(this.eExpandChecked = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("accordionOpen", beans));
        eExpand.appendChild(this.eExpandUnchecked = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("accordionClosed", beans));
        eExpand.appendChild(this.eExpandIndeterminate = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("accordionIndeterminate", beans));
    }
    // we only show expand / collapse if we are showing filters
    showOrHideOptions() {
        const { params: params, eFilterTextField: eFilterTextField } = this;
        const showFilterSearch = !params.suppressFilterSearch;
        const showExpand = !params.suppressExpandAll;
        const translate = this.getLocaleTextFunc();
        eFilterTextField.setInputPlaceholder(translate("searchOoo", "Search..."));
        const isFilterGroupPresent = (col)=>col.getOriginalParent() && col.isFilterAllowed();
        const filterGroupsPresent = this.beans.colModel.getCols().some(isFilterGroupPresent);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eFilterTextField.getGui(), showFilterSearch);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpand, showExpand && filterGroupsPresent);
    }
    onSearchTextChanged() {
        if (!this.onSearchTextChangedDebounced) this.onSearchTextChangedDebounced = (0, $437b23f6a393c3bf$export$cf7e39bfb94de6e)(this, ()=>this.dispatchLocalEvent({
                type: "searchChanged",
                searchText: this.eFilterTextField.getValue()
            }), 300);
        this.onSearchTextChangedDebounced();
    }
    onExpandClicked() {
        const event = this.currentExpandState === 0 /* EXPANDED */  ? {
            type: "collapseAll"
        } : {
            type: "expandAll"
        };
        this.dispatchLocalEvent(event);
    }
    setExpandState(state) {
        this.currentExpandState = state;
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpandChecked, state === 0 /* EXPANDED */ );
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpandUnchecked, state === 1 /* COLLAPSED */ );
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpandIndeterminate, state === 2 /* INDETERMINATE */ );
    }
};
var $5b7ccabde48fae90$var$AgFiltersToolPanelHeaderSelector = {
    selector: "AG-FILTERS-TOOL-PANEL-HEADER",
    component: $5b7ccabde48fae90$var$AgFiltersToolPanelHeader
};
var $5b7ccabde48fae90$var$ToolPanelFilterElement = {
    tag: "div",
    cls: "ag-filter-toolpanel-instance",
    children: [
        {
            tag: "div",
            ref: "eFilterToolPanelHeader",
            cls: "ag-filter-toolpanel-header ag-filter-toolpanel-instance-header",
            role: "button",
            attrs: {
                "aria-expanded": "false"
            },
            children: [
                {
                    tag: "div",
                    ref: "eExpand",
                    cls: "ag-filter-toolpanel-expand"
                },
                {
                    tag: "span",
                    ref: "eFilterName",
                    cls: "ag-header-cell-text"
                },
                {
                    tag: "span",
                    ref: "eFilterIcon",
                    cls: "ag-header-icon ag-filter-icon ag-filter-toolpanel-instance-header-icon"
                }
            ]
        },
        {
            tag: "div",
            ref: "agFilterToolPanelBody",
            cls: "ag-filter-toolpanel-instance-body ag-filter"
        }
    ]
};
var $5b7ccabde48fae90$var$ToolPanelFilterComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(hideHeader, expandedCallback){
        super($5b7ccabde48fae90$var$ToolPanelFilterElement);
        this.hideHeader = hideHeader;
        this.expandedCallback = expandedCallback;
        this.eFilterToolPanelHeader = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eFilterName = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.agFilterToolPanelBody = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eFilterIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eExpand = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.expanded = false;
    }
    postConstruct() {
        const { beans: beans, eExpand: eExpand, eFilterIcon: eFilterIcon } = this;
        const eExpandChecked = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("accordionOpen", beans);
        this.eExpandChecked = eExpandChecked;
        const eExpandUnchecked = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("accordionClosed", beans);
        this.eExpandUnchecked = eExpandUnchecked;
        eExpand.appendChild(eExpandChecked);
        eExpand.appendChild(eExpandUnchecked);
        const translate = this.getLocaleTextFunc();
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(eFilterIcon, translate("ariaFilterActive", "Filter Active"));
        (0, $437b23f6a393c3bf$export$f8d01fa01787902)(eFilterIcon, "img");
    }
    setColumn(column) {
        this.column = column;
        const { beans: beans, eFilterToolPanelHeader: eFilterToolPanelHeader, eFilterIcon: eFilterIcon, eExpandChecked: eExpandChecked, hideHeader: hideHeader } = this;
        this.eFilterName.innerText = beans.colNames.getDisplayNameForColumn(column, "filterToolPanel", false) || "";
        this.addManagedListeners(eFilterToolPanelHeader, {
            click: this.toggleExpanded.bind(this),
            keydown: this.onKeyDown.bind(this)
        });
        this.addManagedEventListeners({
            filterOpened: this.onFilterOpened.bind(this)
        });
        this.addInIcon("filterActive", eFilterIcon, column);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eFilterIcon, this.isFilterActive());
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eExpandChecked, false);
        if (hideHeader) {
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eFilterToolPanelHeader, false);
            eFilterToolPanelHeader.removeAttribute("tabindex");
        } else eFilterToolPanelHeader.setAttribute("tabindex", "0");
        this.addManagedListeners(column, {
            filterChanged: this.onFilterChanged.bind(this)
        });
    }
    onKeyDown(e) {
        const { key: key } = e;
        const { ENTER: ENTER, SPACE: SPACE, LEFT: LEFT, RIGHT: RIGHT } = (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33);
        if (key !== ENTER && key !== SPACE && key !== LEFT && key !== RIGHT) return;
        e.preventDefault();
        if (key === ENTER || key === SPACE) this.toggleExpanded();
        else if (key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).LEFT) this.collapse();
        else this.expand();
    }
    getColumn() {
        return this.column;
    }
    getColumnFilterName() {
        return this.beans.colNames.getDisplayNameForColumn(this.column, "filterToolPanel", false);
    }
    addCssClassToTitleBar(cssClass) {
        this.eFilterToolPanelHeader.classList.add(cssClass);
    }
    addInIcon(iconName, eParent, column) {
        if (eParent == null) return;
        const eIcon = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(iconName, this.beans, column);
        eParent.appendChild(eIcon);
    }
    isFilterActive() {
        return !!this.beans.colFilter?.isFilterActive(this.column);
    }
    onFilterChanged() {
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eFilterIcon, this.isFilterActive());
        this.dispatchLocalEvent({
            type: "filterChanged"
        });
    }
    toggleExpanded() {
        this.expanded ? this.collapse() : this.expand();
    }
    expand() {
        if (this.expanded) return;
        this.expanded = true;
        (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(this.eFilterToolPanelHeader, true);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpandChecked, true);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpandUnchecked, false);
        this.addFilterElement();
        this.expandedCallback();
    }
    addFilterElement(suppressFocus) {
        const filterPanelWrapper = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div",
            cls: "ag-filter-toolpanel-instance-filter"
        });
        const comp = this.createManagedBean(new (0, $437b23f6a393c3bf$export$7db6d402989d8b90)(this.column, "TOOLBAR"));
        this.filterComp = comp;
        if (!comp.hasFilter()) return;
        comp.getFilter()?.then((filter)=>{
            this.underlyingFilter = filter;
            if (!filter) return;
            filterPanelWrapper.appendChild(comp.getGui());
            this.agFilterToolPanelBody.appendChild(filterPanelWrapper);
            comp.afterGuiAttached({
                container: "toolPanel",
                suppressFocus: suppressFocus
            });
        });
    }
    collapse() {
        if (!this.expanded) return;
        this.expanded = false;
        (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(this.eFilterToolPanelHeader, false);
        this.removeFilterElement();
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpandChecked, false);
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eExpandUnchecked, true);
        const filterComp = this.filterComp;
        filterComp?.afterGuiDetached();
        this.destroyBean(filterComp);
        this.expandedCallback();
    }
    removeFilterElement() {
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.agFilterToolPanelBody);
    }
    isExpanded() {
        return this.expanded;
    }
    onPanelHidden() {
        if (!this.expanded) return;
        const filter = this.underlyingFilter;
        if (!filter) return;
        filter.afterGuiDetached?.();
    }
    onFilterOpened(event) {
        if (event.source !== "COLUMN_MENU") return;
        if (event.column !== this.column) return;
        if (!this.expanded) return;
        this.collapse();
    }
};
var $5b7ccabde48fae90$var$ToolPanelFilterGroupComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(columnGroup, childFilterComps, expandedCallback, depth, showingColumn){
        super();
        this.columnGroup = columnGroup;
        this.childFilterComps = childFilterComps;
        this.expandedCallback = expandedCallback;
        this.depth = depth;
        this.showingColumn = showingColumn;
        this.filterGroupComp = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        const groupParams = {
            cssIdentifier: "filter-toolpanel",
            direction: "vertical"
        };
        this.setTemplate({
            tag: "div",
            cls: "ag-filter-toolpanel-group-wrapper",
            children: [
                {
                    tag: "ag-group-component",
                    ref: "filterGroupComp"
                }
            ]
        }, [
            $5b7ccabde48fae90$export$e8864b221efeb73a
        ], {
            filterGroupComp: groupParams
        });
        this.setGroupTitle();
        const { filterGroupComp: filterGroupComp, depth: depth, childFilterComps: childFilterComps, gos: gos } = this;
        filterGroupComp.setAlignItems("stretch");
        filterGroupComp.addCss(`ag-filter-toolpanel-group-level-${depth}`);
        filterGroupComp.getGui().style.setProperty("--ag-indentation-level", String(depth));
        filterGroupComp.addCssClassToTitleBar(`ag-filter-toolpanel-group-level-${depth}-header`);
        for (const filterComp of childFilterComps){
            filterGroupComp.addItem(filterComp);
            filterComp.addCssClassToTitleBar(`ag-filter-toolpanel-group-level-${depth + 1}-header`);
            filterComp.getGui().style.setProperty("--ag-indentation-level", String(depth + 1));
        }
        const column = this.showingColumn ? this.columnGroup : void 0;
        this.tooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            getGui: ()=>this.getGui(),
            getLocation: ()=>"filterToolPanelColumnGroup",
            shouldDisplayTooltip: (0, $437b23f6a393c3bf$export$75f51ed61a5271e6)(gos, ()=>filterGroupComp.getGui().querySelector(".ag-group-title")),
            getAdditionalParams: ()=>({
                    colDef: column?.getColDef(),
                    column: column
                })
        }));
        this.refreshFilterClass();
        this.addExpandCollapseListeners();
        this.addFilterChangedListeners();
        this.setupTooltip();
        this.addInIcon("filterActive");
    }
    setupTooltip() {
        if (!this.showingColumn) return;
        const refresh = ()=>{
            this.tooltipFeature?.setTooltipAndRefresh(this.columnGroup.getColDef().headerTooltip);
        };
        refresh();
        this.addManagedEventListeners({
            newColumnsLoaded: refresh
        });
    }
    addCssClassToTitleBar(cssClass) {
        this.filterGroupComp.addCssClassToTitleBar(cssClass);
    }
    onPanelHidden() {
        for (const filterComp of this.childFilterComps)filterComp.onPanelHidden();
    }
    isColumnGroup() {
        return (0, $437b23f6a393c3bf$export$bb4bfad2b594b78e)(this.columnGroup);
    }
    isExpanded() {
        return this.filterGroupComp.isExpanded();
    }
    getChildren() {
        return this.childFilterComps;
    }
    getFilterGroupName() {
        return this.filterGroupName ?? "";
    }
    getFilterGroupId() {
        return this.columnGroup.getId();
    }
    hideGroupItem(hide, index) {
        this.filterGroupComp.hideItem(hide, index);
    }
    hideGroup(hide) {
        this.setDisplayed(!hide);
    }
    addInIcon(iconName) {
        const eIcon = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(iconName, this.beans);
        if (eIcon) {
            eIcon.classList.add("ag-filter-toolpanel-group-instance-header-icon");
            const translate = this.getLocaleTextFunc();
            (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(eIcon, translate("ariaFilterActive", "Filter Active"));
            (0, $437b23f6a393c3bf$export$f8d01fa01787902)(eIcon, "img");
        }
        this.filterGroupComp.addTitleBarWidget(eIcon);
    }
    forEachToolPanelFilterChild(action) {
        for (const filterComp of this.childFilterComps)if (filterComp instanceof $5b7ccabde48fae90$var$ToolPanelFilterComp) action(filterComp);
    }
    addExpandCollapseListeners() {
        const expandListener = this.isColumnGroup() ? ()=>this.expandedCallback() : ()=>this.forEachToolPanelFilterChild((filterComp)=>filterComp.expand());
        const collapseListener = this.isColumnGroup() ? ()=>this.expandedCallback() : ()=>this.forEachToolPanelFilterChild((filterComp)=>filterComp.collapse());
        this.addManagedListeners(this.filterGroupComp, {
            expanded: expandListener,
            collapsed: collapseListener
        });
    }
    getColumns() {
        if ((0, $437b23f6a393c3bf$export$bb4bfad2b594b78e)(this.columnGroup)) return this.columnGroup.getLeafColumns();
        return [
            this.columnGroup
        ];
    }
    addFilterChangedListeners() {
        for (const column of this.getColumns())this.addManagedListeners(column, {
            filterChanged: ()=>this.refreshFilterClass()
        });
        if (!(0, $437b23f6a393c3bf$export$bb4bfad2b594b78e)(this.columnGroup)) this.addManagedEventListeners({
            filterOpened: this.onFilterOpened.bind(this)
        });
    }
    refreshFilterClass() {
        const columns = this.getColumns();
        const anyChildFiltersActive = ()=>columns.some((col)=>col.isFilterActive());
        this.filterGroupComp.toggleCss("ag-has-filter", anyChildFiltersActive());
    }
    onFilterOpened(event) {
        if (event.source !== "COLUMN_MENU") return;
        if (event.column !== this.columnGroup) return;
        if (!this.isExpanded()) return;
        this.collapse();
    }
    expand() {
        this.filterGroupComp.toggleGroupExpand(true);
    }
    collapse() {
        this.filterGroupComp.toggleGroupExpand(false);
    }
    setGroupTitle() {
        const columnGroup = this.columnGroup;
        const filterGroupName = (0, $437b23f6a393c3bf$export$bb4bfad2b594b78e)(columnGroup) ? this.getColumnGroupName(columnGroup) : this.getColumnName(columnGroup);
        this.filterGroupName = filterGroupName;
        this.filterGroupComp.setTitle(filterGroupName || "");
    }
    getColumnGroupName(columnGroup) {
        return this.beans.colNames.getDisplayNameForProvidedColumnGroup(null, columnGroup, "filterToolPanel");
    }
    getColumnName(column) {
        return this.beans.colNames.getDisplayNameForColumn(column, "filterToolPanel", false);
    }
    destroyFilters() {
        this.childFilterComps = this.destroyBeans(this.childFilterComps);
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.getGui());
    }
    destroy() {
        this.destroyFilters();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/filterToolPanel/agFiltersToolPanelList.ts
var $5b7ccabde48fae90$var$AgFiltersToolPanelList = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-filter-list-panel"
        });
        this.initialised = false;
        this.hasLoadedInitialState = false;
        this.isInitialState = false;
        this.filterGroupComps = [];
        // If a column drag is happening, we suppress handling the event until it has completed
        this.suppressOnColumnsChanged = false;
        this.onColumnsChangedPending = false;
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
    }
    init(params) {
        this.initialised = true;
        const defaultParams = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
            suppressExpandAll: false,
            suppressFilterSearch: false,
            suppressSyncLayoutWithGrid: false
        });
        (0, $437b23f6a393c3bf$export$8ade6bd474fcde42)(defaultParams, params);
        this.params = defaultParams;
        if (!defaultParams.suppressSyncLayoutWithGrid) this.addManagedEventListeners({
            columnMoved: ()=>this.onColumnsChanged()
        });
        this.addManagedEventListeners({
            newColumnsLoaded: ()=>this.onColumnsChanged(),
            toolPanelVisibleChanged: (event)=>{
                if (event.key === "filters" && !event.visible) this.onPanelHidden();
            },
            dragStarted: ()=>{
                this.suppressOnColumnsChanged = true;
            },
            dragStopped: ()=>{
                this.suppressOnColumnsChanged = false;
                if (this.onColumnsChangedPending) {
                    this.onColumnsChangedPending = false;
                    this.onColumnsChanged();
                }
            }
        });
        if (this.colModel.ready) this.onColumnsChanged();
    }
    onColumnsChanged() {
        if (this.suppressOnColumnsChanged) {
            this.onColumnsChangedPending = true;
            return;
        }
        const pivotModeActive = this.colModel.isPivotMode();
        const shouldSyncColumnLayoutWithGrid = !this.params.suppressSyncLayoutWithGrid && !pivotModeActive;
        shouldSyncColumnLayoutWithGrid ? this.syncFilterLayout() : this.buildTreeFromProvidedColumnDefs();
        this.refreshAriaLabel();
    }
    syncFilterLayout() {
        $5b7ccabde48fae90$var$syncLayoutWithGrid(this.colModel, this.setFiltersLayout.bind(this));
        this.refreshAriaLabel();
    }
    buildTreeFromProvidedColumnDefs() {
        const columnTree = this.colModel.getColDefColTree();
        this.recreateFilters(columnTree);
    }
    setFiltersLayout(colDefs) {
        const columnTree = $5b7ccabde48fae90$var$toolPanelCreateColumnTree(this.colModel, colDefs);
        this.recreateFilters(columnTree);
    }
    recreateFilters(columnTree) {
        const activeElement = (0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans);
        if (!this.hasLoadedInitialState) {
            this.hasLoadedInitialState = true;
            this.isInitialState = !!this.params.initialState;
        }
        const expansionState = this.getExpansionState();
        this.destroyFilters();
        const filterGroupComps = this.recursivelyAddComps(columnTree, 0, expansionState);
        this.filterGroupComps = filterGroupComps;
        const len = filterGroupComps.length;
        if (len) {
            for (const comp of filterGroupComps)this.appendChild(comp);
            this.setFirstAndLastVisible(0, len - 1);
        }
        const searchFilterText = this.searchFilterText;
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(searchFilterText)) this.searchFilters(searchFilterText);
        this.fireExpandedEvent();
        if (this.getGui().contains(activeElement)) activeElement.focus();
        this.isInitialState = false;
        this.refreshAriaLabel();
    }
    recursivelyAddComps(tree, depth, expansionState) {
        return tree.map((child)=>{
            if ((0, $437b23f6a393c3bf$export$bb4bfad2b594b78e)(child)) return this.recursivelyAddFilterGroupComps(child, depth, expansionState)?.flatMap((a)=>a) ?? [];
            const column = child;
            if (!this.shouldDisplayFilter(column)) return [];
            const hideFilterCompHeader = depth === 0;
            const filterComp = new $5b7ccabde48fae90$var$ToolPanelFilterComp(hideFilterCompHeader, ()=>this.onFilterExpanded());
            this.createBean(filterComp);
            filterComp.setColumn(column);
            if (expansionState.get(column.getId())) filterComp.expand();
            if (depth > 0) return filterComp;
            const filterGroupComp = this.createBean(new $5b7ccabde48fae90$var$ToolPanelFilterGroupComp(column, [
                filterComp
            ], this.onGroupExpanded.bind(this), depth, true));
            filterGroupComp.addCssClassToTitleBar("ag-filter-toolpanel-header");
            if (!expansionState.get(filterGroupComp.getFilterGroupId())) filterGroupComp.collapse();
            return filterGroupComp;
        }).flatMap((a)=>a);
    }
    refreshAriaLabel() {
        const translate = this.getLocaleTextFunc();
        const filterListName = translate("ariaFilterPanelList", "Filter List");
        const localeFilters = translate("filters", "Filters");
        const eGui = this.getGui();
        const groupSelector = ".ag-filter-toolpanel-group-wrapper";
        const itemSelector = ".ag-filter-toolpanel-group-item";
        const hiddenSelector = ".ag-hidden";
        const visibleItems = eGui.querySelectorAll(`${itemSelector}:not(${groupSelector}, ${hiddenSelector})`);
        const totalVisibleItems = visibleItems.length;
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(this.getAriaElement(), `${filterListName} ${totalVisibleItems} ${localeFilters}`);
    }
    recursivelyAddFilterGroupComps(columnGroup, depth, expansionState) {
        if (!this.filtersExistInChildren(columnGroup.getChildren())) return;
        const colGroupDef = columnGroup.getColGroupDef();
        if (colGroupDef?.suppressFiltersToolPanel) return [];
        const newDepth = columnGroup.isPadding() ? depth : depth + 1;
        const childFilterComps = this.recursivelyAddComps(columnGroup.getChildren(), newDepth, expansionState).flatMap((a)=>a);
        if (columnGroup.isPadding()) return childFilterComps;
        const filterGroupComp = new $5b7ccabde48fae90$var$ToolPanelFilterGroupComp(columnGroup, childFilterComps, this.onGroupExpanded.bind(this), depth, false);
        this.createBean(filterGroupComp);
        filterGroupComp.addCssClassToTitleBar("ag-filter-toolpanel-header");
        const expansionStateValue = expansionState.get(filterGroupComp.getFilterGroupId());
        if (this.isInitialState && !expansionStateValue || expansionStateValue === false) filterGroupComp.collapse();
        return [
            filterGroupComp
        ];
    }
    filtersExistInChildren(tree) {
        return tree.some((child)=>{
            if ((0, $437b23f6a393c3bf$export$bb4bfad2b594b78e)(child)) return this.filtersExistInChildren(child.getChildren());
            return this.shouldDisplayFilter(child);
        });
    }
    shouldDisplayFilter(column) {
        const suppressFiltersToolPanel = column.getColDef()?.suppressFiltersToolPanel;
        return column.isFilterAllowed() && !suppressFiltersToolPanel;
    }
    getExpansionState() {
        const expansionState = /* @__PURE__ */ new Map();
        if (this.isInitialState) {
            const { expandedColIds: expandedColIds, expandedGroupIds: expandedGroupIds } = this.params.initialState;
            for (const id of expandedColIds)expansionState.set(id, true);
            for (const id of expandedGroupIds)expansionState.set(id, true);
            return expansionState;
        }
        const recursiveGetExpansionState = (filterGroupComp)=>{
            expansionState.set(filterGroupComp.getFilterGroupId(), filterGroupComp.isExpanded());
            for (const child of filterGroupComp.getChildren())if (child instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) recursiveGetExpansionState(child);
            else expansionState.set(child.getColumn().getId(), child.isExpanded());
        };
        this.filterGroupComps.forEach(recursiveGetExpansionState);
        return expansionState;
    }
    // we don't support refreshing, but must implement because it's on the tool panel interface
    refresh() {}
    // lazy initialise the panel
    setVisible(visible) {
        super.setDisplayed(visible);
        if (visible && !this.initialised) this.init(this.params);
    }
    expandFilterGroups(expand, groupIds) {
        const updatedGroupIds = [];
        const updateGroupExpandState = (filterGroup)=>{
            const groupId = filterGroup.getFilterGroupId();
            const shouldExpandOrCollapse = !groupIds || groupIds.includes(groupId);
            if (shouldExpandOrCollapse) {
                if (expand && filterGroup.isColumnGroup()) filterGroup.expand();
                else filterGroup.collapse();
                updatedGroupIds.push(groupId);
            }
            for (const child of filterGroup.getChildren())if (child instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) updateGroupExpandState(child);
        };
        this.filterGroupComps.forEach(updateGroupExpandState);
        this.onGroupExpanded();
        if (groupIds) {
            const unrecognisedGroupIds = groupIds.filter((groupId)=>updatedGroupIds.indexOf(groupId) < 0);
            if (unrecognisedGroupIds.length > 0) (0, $437b23f6a393c3bf$export$545083624300f13d)(166, {
                unrecognisedGroupIds: unrecognisedGroupIds
            });
        }
    }
    expandFilters(expand, colIds) {
        const updatedColIds = [];
        const updateGroupExpandState = (filterComp)=>{
            if (filterComp instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) {
                let anyChildrenChanged = false;
                for (const child of filterComp.getChildren()){
                    const childUpdated = updateGroupExpandState(child);
                    if (childUpdated) {
                        if (expand) {
                            filterComp.expand();
                            anyChildrenChanged = true;
                        } else if (!filterComp.isColumnGroup()) filterComp.collapse();
                    }
                }
                return anyChildrenChanged;
            }
            const colId = filterComp.getColumn().getColId();
            const updateFilterExpandState = !colIds || colIds.includes(colId);
            if (updateFilterExpandState) {
                expand ? filterComp.expand() : filterComp.collapse();
                updatedColIds.push(colId);
            }
            return updateFilterExpandState;
        };
        this.filterGroupComps.forEach(updateGroupExpandState);
        this.onGroupExpanded();
        if (colIds) {
            const unrecognisedColIds = colIds.filter((colId)=>updatedColIds.indexOf(colId) < 0);
            if (unrecognisedColIds.length > 0) (0, $437b23f6a393c3bf$export$545083624300f13d)(167, {
                unrecognisedColIds: unrecognisedColIds
            });
        }
    }
    onGroupExpanded() {
        this.fireExpandedEvent();
    }
    onFilterExpanded() {
        this.dispatchLocalEvent({
            type: "filterExpanded"
        });
    }
    fireExpandedEvent() {
        let expandedCount = 0;
        let notExpandedCount = 0;
        const updateExpandCounts = (filterGroup)=>{
            if (!filterGroup.isColumnGroup()) return;
            filterGroup.isExpanded() ? expandedCount++ : notExpandedCount++;
            for (const child of filterGroup.getChildren())if (child instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) updateExpandCounts(child);
        };
        this.filterGroupComps.forEach(updateExpandCounts);
        let state;
        if (expandedCount > 0 && notExpandedCount > 0) state = 2 /* INDETERMINATE */ ;
        else if (notExpandedCount > 0) state = 1 /* COLLAPSED */ ;
        else state = 0 /* EXPANDED */ ;
        this.dispatchLocalEvent({
            type: "groupExpanded",
            state: state
        });
    }
    performFilterSearch(searchText) {
        this.searchFilterText = (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(searchText) ? searchText.toLowerCase() : null;
        this.searchFilters(this.searchFilterText);
    }
    searchFilters(searchFilter) {
        const passesFilter = (groupName)=>{
            return !(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(searchFilter) || groupName.toLowerCase().indexOf(searchFilter) !== -1;
        };
        const recursivelySearch = (filterItem, parentPasses)=>{
            if (!(filterItem instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp)) return passesFilter(filterItem.getColumnFilterName() || "");
            const children = filterItem.getChildren();
            const groupNamePasses = passesFilter(filterItem.getFilterGroupName());
            const alreadyPassed = parentPasses || groupNamePasses;
            if (alreadyPassed) {
                filterItem.hideGroup(false);
                for(let i = 0; i < children.length; i++){
                    recursivelySearch(children[i], alreadyPassed);
                    filterItem.hideGroupItem(false, i);
                }
                return true;
            }
            let anyChildPasses = false;
            children.forEach((child, index)=>{
                const childPasses = recursivelySearch(child, parentPasses);
                filterItem.hideGroupItem(!childPasses, index);
                if (childPasses) anyChildPasses = true;
            });
            filterItem.hideGroup(!anyChildPasses);
            return anyChildPasses;
        };
        let firstVisible;
        let lastVisible;
        this.filterGroupComps.forEach((filterGroup, idx)=>{
            recursivelySearch(filterGroup, false);
            const isHidden = filterGroup.getGui()?.classList.contains("ag-hidden");
            if (firstVisible === void 0) {
                if (!isHidden) {
                    firstVisible = idx;
                    lastVisible = idx;
                }
            } else if (!isHidden && lastVisible !== idx) lastVisible = idx;
        });
        this.setFirstAndLastVisible(firstVisible, lastVisible);
        this.refreshAriaLabel();
    }
    setFirstAndLastVisible(firstIdx, lastIdx) {
        this.filterGroupComps.forEach((filterGroup, idx)=>{
            filterGroup.removeCss("ag-first-group-visible");
            filterGroup.removeCss("ag-last-group-visible");
            if (idx === firstIdx) filterGroup.addCss("ag-first-group-visible");
            if (idx === lastIdx) filterGroup.addCss("ag-last-group-visible");
        });
    }
    onPanelHidden() {
        for (const filterGroupComp of this.filterGroupComps)filterGroupComp.onPanelHidden();
    }
    getExpandedFiltersAndGroups() {
        const expandedGroupIds = [];
        const expandedColIds = /* @__PURE__ */ new Set();
        const getExpandedFiltersAndGroups = (filterComp)=>{
            if (filterComp instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) {
                for (const child of filterComp.getChildren())getExpandedFiltersAndGroups(child);
                const groupId = filterComp.getFilterGroupId();
                if (filterComp.isExpanded() && !expandedColIds.has(groupId)) expandedGroupIds.push(groupId);
            } else if (filterComp.isExpanded()) expandedColIds.add(filterComp.getColumn().getColId());
        };
        this.filterGroupComps.forEach(getExpandedFiltersAndGroups);
        return {
            expandedGroupIds: expandedGroupIds,
            expandedColIds: Array.from(expandedColIds)
        };
    }
    destroyFilters() {
        this.filterGroupComps = this.destroyBeans(this.filterGroupComps);
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.getGui());
    }
    destroy() {
        this.destroyFilters();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$AgFiltersToolPanelListSelector = {
    selector: "AG-FILTERS-TOOL-PANEL-LIST",
    component: $5b7ccabde48fae90$var$AgFiltersToolPanelList
};
// packages/ag-grid-enterprise/src/filterToolPanel/filtersToolPanel.css-GENERATED.ts
var $5b7ccabde48fae90$var$filtersToolPanelCSS = /*css*/ `.ag-filter-toolpanel{flex:1 1 0px;min-width:0}.ag-filter-toolpanel-header,.ag-filter-toolpanel-search{align-items:center;color:var(--ag-header-text-color);display:flex;font-weight:var(--ag-header-font-weight);padding:0 var(--ag-spacing);>*{align-items:center;display:flex}}.ag-filter-toolpanel-header{padding-bottom:var(--ag-spacing);padding-top:var(--ag-spacing);position:relative;&:focus-visible{border-radius:var(--ag-border-radius);box-shadow:inset var(--ag-focus-shadow)}}:where(.ag-ltr) .ag-filter-toolpanel-group-instance-header-icon,:where(.ag-ltr) .ag-filter-toolpanel-instance-header-icon{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-filter-toolpanel-group-instance-header-icon,:where(.ag-rtl) .ag-filter-toolpanel-instance-header-icon{margin-right:var(--ag-spacing)}.ag-filter-toolpanel-search{min-height:var(--ag-header-height);padding-bottom:var(--ag-spacing);padding-top:var(--ag-widget-container-vertical-padding)}:where(.ag-filter-toolpanel-group:not(.ag-has-filter)>.ag-group-title-bar) .ag-filter-toolpanel-group-instance-header-icon{display:none}.ag-filter-toolpanel-search-input{flex-grow:1;height:calc(var(--ag-spacing)*4)}:where(.ag-ltr) .ag-filter-toolpanel-group-title-bar-icon{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-filter-toolpanel-group-title-bar-icon{margin-left:var(--ag-spacing)}.ag-filter-toolpanel-expand{cursor:pointer}:where(.ag-ltr) .ag-filter-toolpanel-expand{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-filter-toolpanel-expand{margin-left:var(--ag-spacing)}:where(.ag-ltr) .ag-filter-toolpanel-group-title-bar,:where(.ag-ltr) .ag-filter-toolpanel-instance-header{padding-left:calc(var(--ag-spacing) + var(--ag-filter-tool-panel-group-indent)*var(--ag-indentation-level))}:where(.ag-rtl) .ag-filter-toolpanel-group-title-bar,:where(.ag-rtl) .ag-filter-toolpanel-instance-header{padding-right:calc(var(--ag-spacing) + var(--ag-filter-tool-panel-group-indent)*var(--ag-indentation-level))}:where(.ag-ltr) .ag-filter-toolpanel-instance-body{margin-left:var(--ag-filter-tool-panel-group-indent)}:where(.ag-rtl) .ag-filter-toolpanel-instance-body{margin-right:var(--ag-filter-tool-panel-group-indent)}.ag-filter-toolpanel-instance-filter{background-color:var(--ag-chrome-background-color)}.ag-filter-toolpanel-group-level-0{border-top:none}`;
// packages/ag-grid-enterprise/src/filterToolPanel/filtersToolPanel.ts
var $5b7ccabde48fae90$var$FiltersToolPanelElement = {
    tag: "div",
    cls: "ag-filter-toolpanel",
    children: [
        {
            tag: "ag-filters-tool-panel-header",
            ref: "filtersToolPanelHeaderPanel"
        },
        {
            tag: "ag-filters-tool-panel-list",
            ref: "filtersToolPanelListPanel"
        }
    ]
};
var $5b7ccabde48fae90$var$FiltersToolPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$FiltersToolPanelElement, [
            $5b7ccabde48fae90$var$AgFiltersToolPanelHeaderSelector,
            $5b7ccabde48fae90$var$AgFiltersToolPanelListSelector
        ]);
        this.filtersToolPanelHeaderPanel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.filtersToolPanelListPanel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.initialised = false;
        this.listenerDestroyFuncs = [];
        this.registerCSS($5b7ccabde48fae90$var$filtersToolPanelCSS);
    }
    init(params) {
        if (this.initialised) {
            for (const func of this.listenerDestroyFuncs)func();
            this.listenerDestroyFuncs = [];
        }
        this.initialised = true;
        const defaultParams = {
            suppressExpandAll: false,
            suppressFilterSearch: false,
            suppressSyncLayoutWithGrid: false
        };
        const newParams = {
            ...defaultParams,
            ...params
        };
        this.params = newParams;
        const { filtersToolPanelHeaderPanel: filtersToolPanelHeaderPanel, filtersToolPanelListPanel: filtersToolPanelListPanel } = this;
        filtersToolPanelHeaderPanel.init(newParams);
        filtersToolPanelListPanel.init(newParams);
        const { suppressExpandAll: hideExpand, suppressFilterSearch: hideSearch } = newParams;
        if (hideExpand && hideSearch) filtersToolPanelHeaderPanel.setDisplayed(false);
        this.listenerDestroyFuncs.push(...this.addManagedListeners(filtersToolPanelHeaderPanel, {
            expandAll: ()=>filtersToolPanelListPanel.expandFilterGroups(true),
            collapseAll: ()=>filtersToolPanelListPanel.expandFilterGroups(false),
            searchChanged: (event)=>filtersToolPanelListPanel.performFilterSearch(event.searchText)
        }), ...this.addManagedListeners(filtersToolPanelListPanel, {
            filterExpanded: newParams.onStateUpdated,
            groupExpanded: (event)=>{
                filtersToolPanelHeaderPanel.setExpandState(event.state);
                newParams.onStateUpdated();
            }
        }));
    }
    // lazy initialise the panel
    setVisible(visible) {
        super.setDisplayed(visible);
        if (visible && !this.initialised) this.init(this.params);
    }
    setFilterLayout(colDefs) {
        this.filtersToolPanelListPanel.setFiltersLayout(colDefs);
    }
    expandFilterGroups(groupIds) {
        this.filtersToolPanelListPanel.expandFilterGroups(true, groupIds);
    }
    collapseFilterGroups(groupIds) {
        this.filtersToolPanelListPanel.expandFilterGroups(false, groupIds);
    }
    expandFilters(colIds) {
        this.filtersToolPanelListPanel.expandFilters(true, colIds);
    }
    collapseFilters(colIds) {
        this.filtersToolPanelListPanel.expandFilters(false, colIds);
    }
    syncLayoutWithGrid() {
        this.filtersToolPanelListPanel.syncFilterLayout();
    }
    refresh(params) {
        this.init(params);
        return true;
    }
    getState() {
        return this.filtersToolPanelListPanel.getExpandedFiltersAndGroups();
    }
};
var $5b7ccabde48fae90$var$FilterPanelService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "filterPanelSvc";
        this.states = /* @__PURE__ */ new Map();
        this.orderedStates = [];
        this.initialStateApplied = false;
        this.columnsLoaded = false;
        this.isActive = false;
    }
    postConstruct() {
        if (!this.gos.get("enableFilterHandlers")) return;
        const updateFilterStates = this.updateFilterStates.bind(this);
        const updateApplyButton = ()=>this.dispatchStatesUpdates(void 0, true);
        const onFilterDestroyed = this.onFilterDestroyed.bind(this);
        this.addManagedEventListeners({
            newColumnsLoaded: ()=>{
                this.columnsLoaded = true;
                if (!this.initialStateApplied) this.applyState();
                updateFilterStates();
            },
            dataTypesInferred: updateFilterStates,
            filterChanged: updateFilterStates,
            filterDestroyed: onFilterDestroyed,
            filterHandlerDestroyed: onFilterDestroyed,
            filterOpened: updateApplyButton,
            filterClosed: updateApplyButton
        });
        this.addManagedListeners(this.beans.colFilter, {
            filterStateChanged: ({ column: column })=>{
                this.states.get(column.getColId())?.refresh?.();
                updateApplyButton();
            }
        });
    }
    updateParams(params, state) {
        this.params = params;
        let dispatchedStateUpdates = false;
        if (state) {
            this.currState = state;
            if (this.columnsLoaded) {
                const newIds = new Set(state.filters?.map((f)=>f.colId));
                for (const id of this.getIds())if (!newIds.has(id)) this.remove(id);
                this.clear();
                this.applyState();
                this.updateFilterStates();
                dispatchedStateUpdates = true;
            }
        }
        if (!dispatchedStateUpdates) this.dispatchStatesUpdates();
        this.beans.colFilter?.setGlobalButtons(!!params.buttons?.length);
    }
    getIds() {
        return Array.from(this.states.keys());
    }
    getAvailable() {
        const beans = this.beans;
        const availableFilters = [];
        for (const column of beans.colModel.getColDefCols() ?? []){
            const id = column.getColId();
            if (column.isFilterAllowed() && !column.colDef.suppressFiltersToolPanel && !this.states.get(id)) availableFilters.push({
                id: id,
                name: $5b7ccabde48fae90$var$getDisplayName(beans, column)
            });
        }
        return availableFilters;
    }
    add(id) {
        this.createFilter(id, true);
        this.dispatchStatesUpdates(id);
    }
    remove(id) {
        const { states: states, orderedStates: orderedStates, beans: { colFilter: colFilter, selectableFilter: selectableFilter } } = this;
        const state = states.get(id);
        if (!state) return;
        state.destroy?.();
        const column = state.state.column;
        states.delete(id);
        selectableFilter?.clearActive(id);
        colFilter?.destroyFilter(column);
        this.eventSvc.dispatchEvent({
            type: "filterSwitched",
            column: column
        });
        const index = orderedStates.indexOf(id);
        orderedStates.splice(index, 1);
        const newActiveId = orderedStates[index];
        this.dispatchStatesUpdates(newActiveId);
    }
    getState(id) {
        return this.states.get(id)?.state;
    }
    updateFilterState(id, key, value, suppressEvents) {
        const filterState = this.getState(id);
        if (!filterState) return;
        filterState[key] = value;
        if (!suppressEvents) this.dispatchLocalEvent({
            type: "filterPanelStateChanged",
            id: id,
            state: filterState
        });
    }
    expand(id, expanded) {
        const existingFilterState = this.states.get(id);
        if (!existingFilterState) return;
        existingFilterState.destroy?.();
        const { handler: handler, state: { column: column } } = existingFilterState;
        const newFilterState = this.createFilterState(column, handler, expanded);
        this.states.set(id, newFilterState);
        this.dispatchLocalEvent({
            type: "filterPanelStateChanged",
            id: id,
            state: newFilterState.state
        });
    }
    updateType(id, filterDef) {
        const stateWrapper = this.states.get(id);
        if (!stateWrapper) return;
        const state = stateWrapper.state;
        if (state.expanded === false) return;
        const filterDefs = state.filterDefs;
        if (!filterDefs) return;
        const { colFilter: colFilter, selectableFilter: selectableFilter } = this.beans;
        selectableFilter?.setActive(id, filterDefs, filterDef);
        colFilter.filterParamsChanged(id, "columnFilter");
        const column = state.column;
        this.eventSvc.dispatchEvent({
            type: "filterSwitched",
            column: column
        });
        const newStateWrapper = this.states.get(id);
        if (!newStateWrapper) return;
        const newState = newStateWrapper.state;
        this.dispatchLocalEvent({
            type: "filterPanelStateChanged",
            id: id,
            state: newState
        });
    }
    getActions() {
        const actions = this.params?.buttons;
        if (!actions?.length) return void 0;
        const canApply = !!this.beans.colFilter?.canApplyAll();
        return {
            actions: actions,
            canApply: canApply
        };
    }
    doAction(action) {
        this.beans.colFilter?.updateAllModels(action);
    }
    getGridState() {
        const filters = [];
        this.states.forEach((stateWrapper, colId)=>{
            filters.push({
                colId: colId,
                expanded: stateWrapper.state.expanded
            });
        });
        return {
            filters: filters
        };
    }
    createFilter(id, expanded) {
        const stateWrapper = this.createFilterStateWrapper(id, expanded);
        if (stateWrapper) {
            this.states.set(id, stateWrapper);
            this.orderedStates.push(id);
        }
    }
    createFilterStateWrapper(id, expanded) {
        const { colModel: colModel, colFilter: colFilter } = this.beans;
        const column = colModel.getColDefCol(id);
        if (column && !column.colDef.suppressFiltersToolPanel) {
            const handler = colFilter.getHandler(column, true);
            if (handler) return this.createFilterState(column, handler, expanded);
        }
        return void 0;
    }
    updateFilterStates() {
        if (!this.params) return;
        const filterModel = this.beans.colFilter.getModel();
        const processedIds = /* @__PURE__ */ new Set();
        for (const id of Object.keys(filterModel)){
            const existingState = this.states.get(id);
            if (!existingState) this.createFilter(id);
            else existingState.refresh?.();
            processedIds.add(id);
        }
        this.states.forEach((state, id)=>{
            if (!processedIds.has(id)) state.refresh?.();
        });
        this.dispatchStatesUpdates();
    }
    createFilterState(column, handler, expanded) {
        const beans = this.beans;
        const { colFilter: colFilter, selectableFilter: selectableFilter } = beans;
        const name = $5b7ccabde48fae90$var$getDisplayName(beans, column);
        const colId = column.getColId();
        const getIsEditing = ()=>!!this.params?.buttons && colFilter.hasUnappliedModel(colId);
        const isEditing = getIsEditing();
        if (expanded) {
            const colDef = column.colDef;
            const { filterDefs: filterDefs, activeFilterDef: activeFilterDef } = selectableFilter?.getDefs(column, colDef) ?? {};
            const filterComp = this.createBean(new (0, $437b23f6a393c3bf$export$7db6d402989d8b90)(column, "TOOLBAR", true));
            return {
                state: {
                    column: column,
                    name: name,
                    isEditing: isEditing,
                    expanded: expanded,
                    detail: filterComp.getGui(),
                    activeFilterDef: activeFilterDef,
                    filterDefs: filterDefs,
                    afterGuiAttached: filterComp.afterGuiAttached.bind(filterComp),
                    afterGuiDetached: filterComp.afterGuiDetached.bind(filterComp)
                },
                handler: handler,
                refresh: ()=>{
                    this.updateFilterState(colId, "isEditing", getIsEditing());
                },
                destroy: ()=>this.destroyBean(filterComp)
            };
        } else {
            const colId2 = column.getColId();
            const getSummary = ()=>handler.getModelAsString?.(colFilter.getStateForColumn(colId2).model, "filterToolPanel") ?? "";
            return {
                state: {
                    column: column,
                    name: name,
                    isEditing: isEditing,
                    expanded: false,
                    summary: getSummary()
                },
                handler: handler,
                refresh: ()=>{
                    this.updateFilterState(colId2, "isEditing", getIsEditing(), true);
                    this.updateFilterState(colId2, "summary", getSummary());
                }
            };
        }
    }
    onFilterDestroyed({ column: column, source: source }) {
        const { colFilter: colFilter, filterManager: filterManager } = this.beans;
        if (!colFilter?.isAlive() || !filterManager?.isFilterAllowed(column)) return;
        const states = this.states;
        const id = column.getColId();
        const existingState = states.get(id);
        if (existingState) {
            const stateWrapper = this.createFilterStateWrapper(id, existingState.state.expanded);
            if (stateWrapper) {
                existingState.destroy?.();
                states.set(id, stateWrapper);
            } else this.remove(id);
            if (source === "api") this.dispatchStatesUpdates();
        }
    }
    dispatchStatesUpdates(activeId, action) {
        this.dispatchLocalEvent({
            type: "filterPanelStatesChanged",
            activeId: activeId,
            action: action
        });
    }
    applyState() {
        if (this.params && this.columnsLoaded) {
            this.initialStateApplied = true;
            for (const { colId: colId, expanded: expanded } of this.currState?.filters ?? [])this.createFilter(colId, expanded);
        }
    }
    destroy() {
        this.clear();
        this.params = void 0;
        this.currState = void 0;
        super.destroy();
    }
    clear() {
        const { states: states, orderedStates: orderedStates } = this;
        states.forEach((state)=>state.destroy?.());
        states.clear();
        orderedStates.length = 0;
    }
};
function $5b7ccabde48fae90$var$getDisplayName(beans, column) {
    return beans.colNames.getDisplayNameForColumn(column, "filterToolPanel") ?? column.getColId();
}
var $5b7ccabde48fae90$var$DEFAULT_LOCALE_TEXT2 = {
    addFilterCard: "Add Filter",
    ariaLabelAddFilterField: "Add Filter Field",
    ariaLabelFilterCardDelete: "Delete Filter",
    ariaLabelFilterCardHasEdits: "Has Edits",
    agTextColumnFilterDisplayName: "Simple Filter",
    agNumberColumnFilterDisplayName: "Simple Filter",
    agDateColumnFilterDisplayName: "Simple Filter",
    agSetColumnFilterDisplayName: "Selection Filter",
    agMultiColumnFilterDisplayName: "Combo Filter",
    addFilterPlaceholder: "Search columns..."
};
function $5b7ccabde48fae90$var$translateForFilterPanel(bean, key) {
    return (0, $437b23f6a393c3bf$export$4ad3db330991f17d)(bean, $5b7ccabde48fae90$var$DEFAULT_LOCALE_TEXT2, key);
}
function $5b7ccabde48fae90$var$compareAndUpdateListsInDom(eContainer, eNewItems, ePrevItems) {
    let newIndex = 0;
    for(let prevIndex = 0; prevIndex < ePrevItems.length; prevIndex++){
        const ePrevItem = ePrevItems[prevIndex];
        if (ePrevItem === eNewItems[newIndex]) newIndex++;
        else (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(ePrevItem);
    }
    while(newIndex < eNewItems.length)eContainer.appendChild(eNewItems[newIndex++]);
}
// packages/ag-grid-enterprise/src/filterToolPanel/newFilterToolPanel/selectableFilterService.ts
var $5b7ccabde48fae90$var$SelectableFilterService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "selectableFilter";
        this.selectedFilters = /* @__PURE__ */ new Map();
        this.valueGetters = /* @__PURE__ */ new Map();
    }
    postConstruct() {
        const { gos: gos, selectedFilters: selectedFilters } = this;
        const initialState = gos.get("initialState")?.filter?.selectableFilters ?? {};
        for (const colId of Object.keys(initialState))selectedFilters.set(colId, initialState[colId]);
    }
    getFilterValueGetter(colId) {
        return this.valueGetters.get(colId);
    }
    isSelectable(filterDef) {
        return filterDef.filter === "agSelectableColumnFilter";
    }
    getFilterDef(column, filterDef) {
        return this.getDefs(column, filterDef).activeFilterDef;
    }
    getDefs(column, filterDef, overrideIndex) {
        if (!this.isSelectable(filterDef)) return void 0;
        const beans = this.beans;
        const { gos: gos, dataTypeSvc: dataTypeSvc, colFilter: colFilter } = beans;
        let filterParams = filterDef.filterParams;
        const colDef = column.colDef;
        if (typeof filterParams === "function") filterParams = filterParams((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(gos, {
            column: column,
            colDef: colDef
        }));
        const cellDataType = dataTypeSvc?.getBaseDataType(column);
        const dataTypeDefinition = dataTypeSvc?.getDataTypeDefinition(column);
        const formatValue = dataTypeSvc?.getFormatValue(cellDataType);
        const { filters: filters, defaultFilterParams: defaultFilterParams, defaultFilterIndex: defaultFilterIndex } = filterParams ?? {};
        const updateDef = (def)=>{
            const { filter: filter, filterParams: defFilterParams, name: name, filterValueGetter: filterValueGetter = colDef.filterValueGetter } = def;
            const userParams = defaultFilterParams ? {
                ...defaultFilterParams,
                ...defFilterParams
            } : defFilterParams;
            let updatedParams;
            if (dataTypeDefinition && formatValue) {
                if (filter === "agMultiColumnFilter") updatedParams = beans.multiFilter?.getParamsForDataType(userParams, filterValueGetter, dataTypeDefinition, formatValue);
                else updatedParams = (0, $437b23f6a393c3bf$export$4a99b58ce484acc)(filter, userParams, filterValueGetter, dataTypeDefinition, formatValue, beans, this.getLocaleTextFunc());
            }
            let updatedName;
            if (!name) {
                let filterString = filter;
                if (typeof filter === "boolean") filterString = colFilter?.getDefaultFilterFromDataType(()=>cellDataType);
                if (typeof filterString === "string") updatedName = $5b7ccabde48fae90$var$translateForFilterPanel(this, `${filterString}DisplayName`);
                else {
                    (0, $437b23f6a393c3bf$export$545083624300f13d)(280, {
                        colId: column.getColId()
                    });
                    updatedName = "";
                }
            }
            if (defaultFilterParams || updatedParams || updatedName) return {
                ...def,
                filterParams: userParams,
                name: updatedName ?? name,
                ...updatedParams
            };
            return def;
        };
        const filterDefs = (filters ?? this.getDefaultFilters(column)).map(updateDef);
        let index = overrideIndex ?? // provided override
        this.selectedFilters.get(column.getColId()) ?? // UI selected value
        defaultFilterIndex ?? // col def value
        (!filters && (0, $437b23f6a393c3bf$export$b68e6345dc6b83fa)(gos) ? 1 : 0);
        if (index >= filterDefs.length) index = 0;
        const activeFilterDef = filterDefs[index];
        return {
            filterDefs: filterDefs,
            activeFilterDef: activeFilterDef
        };
    }
    setActive(colId, filterDefs, activeFilterDef, silent) {
        const index = filterDefs.indexOf(activeFilterDef);
        if (index < 0) return;
        const { selectedFilters: selectedFilters, valueGetters: valueGetters } = this;
        selectedFilters.set(colId, index);
        const filterValueGetter = activeFilterDef.filterValueGetter;
        if (filterValueGetter) valueGetters.set(colId, filterValueGetter);
        else valueGetters.delete(colId);
        if (!silent) this.onChange();
    }
    clearActive(colId) {
        const { selectedFilters: selectedFilters, valueGetters: valueGetters } = this;
        selectedFilters.delete(colId);
        valueGetters.delete(colId);
        this.onChange();
    }
    getState() {
        return Object.fromEntries(this.selectedFilters);
    }
    setState(state) {
        this.clearAll();
        const colModel = this.beans.colModel;
        for (const colId of Object.keys(state)){
            const column = colModel.getColDefCol(colId);
            if (column) {
                const defs = this.getDefs(column, column.colDef, state[colId]);
                if (defs) this.setActive(colId, defs.filterDefs, defs.activeFilterDef, true);
            }
        }
    }
    destroy() {
        this.clearAll();
        super.destroy();
    }
    clearAll() {
        const { selectedFilters: selectedFilters, valueGetters: valueGetters } = this;
        selectedFilters.clear();
        valueGetters.clear();
    }
    onChange() {
        this.dispatchLocalEvent({
            type: "selectedFilterChanged"
        });
    }
    getDefaultFilters(column) {
        const beans = this.beans;
        const { gos: gos, dataTypeSvc: dataTypeSvc } = beans;
        const isMultiFilterEnabled = gos.isModuleRegistered("MultiFilter");
        const cellDataType = dataTypeSvc?.getBaseDataType(column);
        const simpleFilter = (0, $437b23f6a393c3bf$export$4a4e3cf6acc7e93)(cellDataType, false);
        return [
            {
                filter: simpleFilter
            },
            {
                filter: "agSetColumnFilter"
            },
            ...isMultiFilterEnabled ? [
                {
                    filter: "agMultiColumnFilter"
                }
            ] : []
        ];
    }
};
var $5b7ccabde48fae90$var$AddFilterElement = {
    tag: "div",
    cls: "ag-filter-card ag-filter-card-add"
};
var $5b7ccabde48fae90$var$AddFilterComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(options){
        super($5b7ccabde48fae90$var$AddFilterElement);
        this.options = /* @__PURE__ */ new Map();
        this.setOptions(options);
    }
    postConstruct() {
        this.showButton();
    }
    refresh(newOptions) {
        this.setOptions(newOptions);
        const { eSelect: eSelect, options: options } = this;
        if (eSelect) eSelect.setValueList({
            valueList: Array.from(options.keys()),
            refresh: true
        });
    }
    showButton() {
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.getGui());
        this.destroySelect();
        const eButton = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "button",
            cls: "ag-button ag-standard-button ag-filter-add-button",
            children: [
                {
                    tag: "span",
                    children: [
                        ()=>(0, $437b23f6a393c3bf$export$d8feba07bf373edb)("filterAdd", this.beans)
                    ]
                },
                {
                    tag: "span",
                    cls: "ag-filter-add-button-label",
                    children: $5b7ccabde48fae90$var$translateForFilterPanel(this, "addFilterCard")
                }
            ]
        });
        this.activateTabIndex([
            eButton
        ]);
        const clickListener = this.showSelect.bind(this);
        eButton.addEventListener("click", clickListener);
        this.removeButton = ()=>{
            eButton.removeEventListener("click", clickListener);
        };
        this.appendChild(eButton);
        eButton.focus();
    }
    showSelect() {
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.getGui());
        this.destroyButton();
        const pickerAriaLabelKey = "ariaLabelAddFilterField";
        const selectParams = {
            className: "ag-filter-add-select",
            pickerType: "virtual-list",
            pickerAriaLabelKey: pickerAriaLabelKey,
            pickerAriaLabelValue: $5b7ccabde48fae90$var$translateForFilterPanel(this, pickerAriaLabelKey),
            placeholder: $5b7ccabde48fae90$var$translateForFilterPanel(this, "addFilterPlaceholder"),
            value: "",
            valueList: Array.from(this.options.keys()),
            searchType: "matchAny",
            allowTyping: true,
            filterList: true,
            highlightMatch: true,
            valueFormatter: (value)=>this.options.get(value)
        };
        const eSelect = this.createManagedBean(new $5b7ccabde48fae90$var$AgRichSelect(selectParams));
        this.eSelect = eSelect;
        this.appendChild(eSelect.getGui());
        eSelect.showPicker();
        eSelect.getFocusableElement().focus();
        eSelect.addManagedListeners(eSelect, {
            fieldPickerValueSelected: ({ value: id })=>this.dispatchLocalEvent({
                    type: "filterSelected",
                    id: id
                }),
            pickerHidden: ()=>{
                this.showButton();
            }
        });
    }
    setOptions(newOptions) {
        const options = this.options;
        options.clear();
        for (const { id: id, name: name } of newOptions)options.set(id, name);
    }
    destroySelect() {
        this.eSelect = this.destroyBean(this.eSelect);
    }
    destroyButton() {
        this.removeButton = this.removeButton?.();
    }
    destroy() {
        this.destroySelect();
        this.destroyButton();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$FilterDetailElement = {
    tag: "div",
    cls: "ag-filter-card-body",
    children: [
        {
            tag: "ag-select",
            cls: "ag-filter-type-select",
            ref: "eFilterType"
        }
    ]
};
var $5b7ccabde48fae90$var$FilterDetailComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.eFilterType = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        const eFilterTypeParams = {
            onValueChange: (filterDef)=>this.dispatchLocalEvent({
                    type: "filterTypeChanged",
                    filterDef: filterDef
                })
        };
        this.setTemplate($5b7ccabde48fae90$var$FilterDetailElement, [
            (0, $437b23f6a393c3bf$export$e32612175ad118ef)
        ], {
            eFilterType: eFilterTypeParams
        });
        this.eFilterType.setDisplayed(false);
    }
    refresh(newState) {
        const oldState = this.state;
        this.state = newState;
        const { activeFilterDef: newActiveFilterDef, filterDefs: newFilterDefs, detail: newDetail, afterGuiAttached: afterGuiAttached, afterGuiDetached: afterGuiDetached } = newState;
        const { activeFilterDef: oldActiveFilterDef, filterDefs: oldFilterDefs, detail: oldDetail } = oldState ?? {};
        const eFilterType = this.eFilterType;
        if (newFilterDefs !== oldFilterDefs) {
            eFilterType.clearOptions();
            const options = newFilterDefs?.map((filterDef)=>({
                    value: filterDef,
                    text: filterDef.name
                }));
            if (options) eFilterType.clearOptions().addOptions(options).setValue(newActiveFilterDef, true);
            eFilterType.setDisplayed(!!options);
        } else if (newActiveFilterDef !== oldActiveFilterDef) eFilterType.setValue(newActiveFilterDef, true);
        if (newDetail !== oldDetail) {
            if (oldDetail) {
                (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(oldDetail);
                afterGuiDetached();
            }
            this.appendChild(newDetail);
            afterGuiAttached({
                container: "newFiltersToolPanel",
                suppressFocus: true
            });
        }
    }
};
var $5b7ccabde48fae90$var$FilterSummaryElement = {
    tag: "div",
    cls: "ag-filter-card-summary",
    attrs: {
        "aria-hidden": "true"
    }
};
var $5b7ccabde48fae90$var$FilterSummaryComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$FilterSummaryElement);
    }
    refresh(state) {
        this.getGui().textContent = state.summary;
    }
};
// packages/ag-grid-enterprise/src/filterToolPanel/newFilterToolPanel/filterCardComp.ts
var $5b7ccabde48fae90$var$FilterCardElement = {
    tag: "div",
    cls: "ag-filter-card",
    children: [
        {
            tag: "div",
            cls: "ag-filter-card-header",
            role: "presentation",
            children: [
                {
                    tag: "div",
                    cls: "ag-filter-card-heading",
                    role: "heading",
                    attrs: {
                        "aria-level": "2"
                    },
                    children: [
                        {
                            tag: "button",
                            ref: "eExpand",
                            cls: "ag-button ag-filter-card-expand",
                            children: [
                                {
                                    tag: "span",
                                    ref: "eTitle",
                                    cls: "ag-filter-card-title"
                                },
                                {
                                    tag: "span",
                                    ref: "eEditing",
                                    cls: "ag-filter-card-editing-icon"
                                },
                                {
                                    tag: "span",
                                    ref: "eExpandIcon",
                                    cls: "ag-filter-card-expand-icon"
                                }
                            ]
                        }
                    ]
                },
                {
                    tag: "button",
                    ref: "eDelete",
                    cls: "ag-button ag-filter-card-delete",
                    children: [
                        {
                            tag: "span",
                            ref: "eDeleteIcon",
                            cls: "ag-filter-card-delete-icon"
                        }
                    ]
                }
            ]
        }
    ]
};
var $5b7ccabde48fae90$var$FilterCardComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(id){
        super($5b7ccabde48fae90$var$FilterCardElement);
        this.id = id;
        this.eTitle = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eExpand = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eDelete = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eExpandIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eDeleteIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eEditing = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        const { beans: beans, eDelete: eDelete, eExpand: eExpand, eDeleteIcon: eDeleteIcon, eEditing: eEditing, id: id } = this;
        const filterPanelService = beans.filterPanelSvc;
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(eDelete, $5b7ccabde48fae90$var$translateForFilterPanel(this, "ariaLabelFilterCardDelete"));
        eDeleteIcon.appendChild((0, $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1)("close", beans, null));
        this.activateTabIndex([
            eExpand,
            eDelete
        ]);
        this.addManagedElementListeners(eExpand, {
            click: ()=>filterPanelService.expand(id, !this.state?.expanded)
        });
        this.addManagedElementListeners(eDelete, {
            click: ()=>filterPanelService.remove(id)
        });
        this.addManagedEventListeners({
            filterOpened: this.onFilterOpened.bind(this)
        });
        eEditing.appendChild((0, $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1)("filterCardEditing", beans, null));
    }
    refresh(newState) {
        const { eExpand: eExpand, eEditing: eEditing, state: oldState, beans: beans } = this;
        this.state = newState;
        const { name: name, expanded: expanded, isEditing: isEditing } = newState;
        this.eTitle.textContent = name;
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(eEditing, isEditing);
        if (!oldState || expanded !== oldState.expanded) this.toggleExpand(newState);
        let ariaLabel = expanded ? null : `${name} ${newState.summary}`;
        if (isEditing) ariaLabel = `${ariaLabel ?? name}. ${$5b7ccabde48fae90$var$translateForFilterPanel(this, "ariaLabelFilterCardHasEdits")}`;
        (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(eExpand, ariaLabel);
        const removeComp = (comp)=>{
            if (!comp) return;
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(comp.getGui());
            return this.destroyBean(comp);
        };
        const createOrRefreshComp = (comp, FilterComp5, postCreateFunc)=>{
            if (!comp) {
                comp = this.createBean(new FilterComp5());
                postCreateFunc?.(comp);
                this.appendChild(comp.getGui());
            }
            comp.refresh(newState);
            return comp;
        };
        if (newState.expanded) {
            this.summaryComp = removeComp(this.summaryComp);
            const detailComp = createOrRefreshComp(this.detailComp, $5b7ccabde48fae90$var$FilterDetailComp, (comp)=>comp.addManagedListeners(comp, {
                    filterTypeChanged: ({ filterDef: filterDef })=>beans.filterPanelSvc.updateType(this.id, filterDef)
                }));
            this.detailComp = detailComp;
            const detailId = `ag-${this.getCompId()}-filter`;
            detailComp.getGui().id = detailId;
            (0, $437b23f6a393c3bf$export$26fd6a3f123d4e67)(eExpand, detailId);
        } else {
            this.detailComp = removeComp(this.detailComp);
            this.summaryComp = createOrRefreshComp(this.summaryComp, $5b7ccabde48fae90$var$FilterSummaryComp);
            (0, $437b23f6a393c3bf$export$26fd6a3f123d4e67)(eExpand, null);
        }
    }
    toggleExpand(state) {
        const expanded = !!state.expanded;
        const { eExpandIcon: eExpandIcon, eExpand: eExpand, beans: beans } = this;
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(eExpandIcon);
        eExpandIcon.appendChild((0, $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1)(expanded ? "filterCardCollapse" : "filterCardExpand", beans, null));
        (0, $437b23f6a393c3bf$export$3ad3518dddf15485)(eExpand, expanded);
    }
    onFilterOpened(event) {
        const { state: state, beans: beans, id: id } = this;
        if (event.source === "COLUMN_MENU" && event.column === state?.column && state?.expanded) beans.filterPanelSvc.expand(id, false);
    }
    destroy() {
        this.detailComp = this.destroyBean(this.detailComp);
        this.summaryComp = this.destroyBean(this.summaryComp);
        this.state = void 0;
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/filterToolPanel/newFilterToolPanel/filterPanel.ts
function $5b7ccabde48fae90$var$isSingleRefresh(params) {
    return !!params?.id;
}
function $5b7ccabde48fae90$var$isActionRefresh(params) {
    return !!params?.action;
}
var $5b7ccabde48fae90$var$FilterPanelElement = {
    tag: "div",
    cls: "ag-filter-panel",
    children: [
        {
            tag: "div",
            cls: "ag-filter-panel-container",
            ref: "eContainer"
        }
    ]
};
var $5b7ccabde48fae90$var$FilterPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$FilterPanelElement);
        this.eContainer = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.filters = /* @__PURE__ */ new Map();
    }
    refresh(params) {
        if ($5b7ccabde48fae90$var$isActionRefresh(params)) {
            this.refreshActions();
            return;
        }
        if ($5b7ccabde48fae90$var$isSingleRefresh(params)) {
            this.filters.get(params.id)?.refresh(params.state);
            return;
        }
        const { eContainer: eContainer, filters: existingFilters, beans: beans } = this;
        const filterPanelSvc = beans.filterPanelSvc;
        const filterIds = filterPanelSvc.getIds();
        const newFilters = /* @__PURE__ */ new Map();
        const somethingIsFocused = !(0, $437b23f6a393c3bf$export$8ff9eef09a45371f)(beans);
        const activeElement = somethingIsFocused ? (0, $437b23f6a393c3bf$export$16bc98d422315038)(beans) : void 0;
        const containerHasFocus = somethingIsFocused && eContainer.contains(activeElement);
        const ePrevItems = [];
        const eNewItems = [];
        for (const id of filterIds){
            const newFilter = existingFilters.get(id) ?? this.createBean(new $5b7ccabde48fae90$var$FilterCardComp(id));
            newFilter.refresh(filterPanelSvc.getState(id));
            newFilters.set(id, newFilter);
            eNewItems.push(newFilter.getGui());
        }
        this.filters = newFilters;
        const compsToDestroy = [];
        existingFilters.forEach((existingFilter, id)=>{
            ePrevItems.push(existingFilter.getGui());
            if (!newFilters.has(id)) compsToDestroy.push(existingFilter);
        });
        let addFilterComp = this.addFilterComp;
        if (addFilterComp) ePrevItems.push(addFilterComp.getGui());
        const addFilterOptions = filterPanelSvc.getAvailable();
        if (addFilterOptions.length) {
            if (!addFilterComp) {
                addFilterComp = this.createBean(new $5b7ccabde48fae90$var$AddFilterComp(addFilterOptions));
                addFilterComp.addManagedListeners(addFilterComp, {
                    filterSelected: ({ id: id })=>filterPanelSvc.add(id)
                });
            }
            addFilterComp.refresh(addFilterOptions);
            eNewItems.push(addFilterComp.getGui());
        } else addFilterComp = this.destroyBean(addFilterComp);
        this.addFilterComp = addFilterComp;
        $5b7ccabde48fae90$var$compareAndUpdateListsInDom(eContainer, eNewItems, ePrevItems);
        for (const comp of compsToDestroy)this.destroyBean(comp);
        const activeId = params?.activeId;
        const activeItemToFocus = activeId && newFilters.get(activeId)?.getGui();
        if (activeItemToFocus) (0, $437b23f6a393c3bf$export$8598088d375f416f)(activeItemToFocus);
        else if (containerHasFocus && (0, $437b23f6a393c3bf$export$8ff9eef09a45371f)(beans)) (0, $437b23f6a393c3bf$export$8598088d375f416f)(eNewItems[eNewItems.length - 1] ?? eContainer);
        this.refreshActions();
    }
    refreshActions() {
        const filterPanelSvc = this.beans.filterPanelSvc;
        const { actions: actions, canApply: canApply } = filterPanelSvc.getActions() ?? {};
        let buttonComp = this.buttonComp;
        if (actions?.length) {
            const buttons = actions.map((type)=>({
                    type: type,
                    label: (0, $437b23f6a393c3bf$export$e2a0ae4af921fff8)(this, `${type}Filter`)
                }));
            if (!buttonComp) {
                buttonComp = this.createBean(new (0, $437b23f6a393c3bf$export$226c2a54d31bd592)({
                    className: "ag-filter-panel-buttons"
                }));
                this.getGui().appendChild(buttonComp.getGui());
                const listeners = {};
                for (const action of [
                    "apply",
                    "clear",
                    "reset",
                    "cancel"
                ])listeners[action] = ()=>filterPanelSvc.doAction(action);
                buttonComp.addManagedListeners(buttonComp, listeners);
            }
            buttonComp.updateButtons(buttons);
            buttonComp.updateValidity(canApply !== false);
        } else if (buttonComp) {
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(buttonComp.getGui());
            buttonComp = this.destroyBean(buttonComp);
        }
        this.buttonComp = buttonComp;
    }
    destroy() {
        this.beans.filterPanelSvc?.clear?.();
        this.addFilterComp = this.destroyBean(this.addFilterComp);
        this.buttonComp = this.destroyBean(this.buttonComp);
        const filters = this.filters;
        filters.forEach((filter)=>this.destroyBean(filter));
        filters.clear();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/filterToolPanel/newFilterToolPanel/newFiltersToolPanel.css-GENERATED.ts
var $5b7ccabde48fae90$var$newFiltersToolPanelCSS = /*css*/ `.ag-filter-panel{display:flex;flex-direction:column;width:100%;:where(.ag-standard-button){transition:background-color .25s ease-in-out,color .25s ease-in-out}}.ag-filter-panel .ag-simple-filter-body-wrapper{padding:var(--ag-widget-vertical-spacing) var(--ag-widget-container-horizontal-padding) 0}.ag-filter-panel .ag-mini-filter{margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding);margin-top:var(--ag-widget-vertical-spacing)}.ag-filter-panel-container{flex:1;overflow:auto;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding) 0}.ag-filter-panel-container>:where(:not(:last-child)){margin-bottom:var(--ag-widget-container-vertical-padding)}.ag-filter-card{background-color:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:var(--ag-border-radius)}.ag-filter-card-header{align-items:center;display:flex;flex-direction:row;padding-top:var(--ag-widget-vertical-spacing)}:where(.ag-ltr) .ag-filter-card-header{&>:where(:not(:last-child)){padding-right:var(--ag-spacing)}}:where(.ag-rtl) .ag-filter-card-header{&>:where(:not(:last-child)){padding-left:var(--ag-spacing)}}.ag-filter-card-heading{flex:1;overflow:hidden;padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));padding-top:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing))}:where(.ag-ltr) .ag-filter-card-heading{padding-left:var(--ag-widget-horizontal-spacing)}:where(.ag-rtl) .ag-filter-card-heading{padding-right:var(--ag-widget-horizontal-spacing)}.ag-filter-card-expand{align-items:center;display:flex;flex-direction:row;width:100%}.ag-filter-card-title{font-weight:var(--ag-header-font-weight);overflow:hidden;text-overflow:ellipsis}.ag-filter-card-expand-icon{display:flex;flex:1;justify-content:end}.ag-filter-card-editing-icon{margin:0 var(--ag-spacing)}.ag-filter-card-delete-icon,.ag-filter-card-editing-icon,.ag-filter-card-expand-icon,.ag-filter-card-summary{color:var(--ag-filter-panel-card-subtle-color)}.ag-filter-card-delete-icon,.ag-filter-card-expand-icon{transition:color .25s ease-in-out}.ag-filter-card-delete-icon:hover,.ag-filter-card-expand-icon:hover,.ag-filter-card-heading:hover .ag-filter-card-expand-icon{color:var(--ag-filter-panel-card-subtle-hover-color)}.ag-filter-add-button,.ag-filter-card-delete,.ag-filter-card-expand{border-radius:var(--ag-button-border-radius)}.ag-filter-card-summary,.ag-filter-type-select{margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-filter-card-delete{margin-right:var(--ag-widget-horizontal-spacing)}:where(.ag-rtl) .ag-filter-card-delete{margin-left:var(--ag-widget-horizontal-spacing)}.ag-filter-card-summary{margin-bottom:var(--ag-widget-container-vertical-padding)}.ag-filter-type-select{padding-top:var(--ag-widget-vertical-spacing)}.ag-filter-card-add{border:0;padding:0}.ag-filter-add-button{align-items:center;display:flex;flex-direction:row;line-height:1.5;width:100%}:where(.ag-ltr) .ag-filter-add-button-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-filter-add-button-label{margin-right:var(--ag-spacing)}.ag-filter-add-select{border:0;.ag-rich-select-value{border:0;padding:calc(((1.5*var(--ag-font-size) + 2*var(--ag-button-vertical-padding)) - var(--ag-input-height))/2) var(--ag-spacing)}}:where(.ag-ltr) .ag-filter-add-select{.ag-text-field-input{padding-left:calc(var(--ag-spacing)*1.5 + 12px)!important}}:where(.ag-rtl) .ag-filter-add-select{.ag-text-field-input{padding-right:calc(var(--ag-spacing)*1.5 + 12px)!important}}.ag-filter-panel-buttons{display:flex;flex-wrap:wrap;gap:var(--ag-widget-vertical-spacing) var(--ag-widget-horizontal-spacing);justify-content:flex-end;overflow:hidden;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding) 0}.ag-filter-panel-buttons-button{line-height:1.5}.ag-filter-panel .ag-filter-panel-buttons-apply-button{background-color:var(--ag-filter-panel-apply-button-background-color);color:var(--ag-filter-panel-apply-button-color)}.ag-filter-panel>:where(:last-child){padding-bottom:var(--ag-widget-container-vertical-padding)}.ag-filter-panel .ag-set-filter-body-wrapper,.ag-filter-panel .ag-simple-filter-body-wrapper>:last-child{margin-bottom:var(--ag-widget-container-vertical-padding)}`;
// packages/ag-grid-enterprise/src/filterToolPanel/newFilterToolPanel/wrapperToolPanel.ts
var $5b7ccabde48fae90$var$WrapperToolPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super();
        this.registerCSS($5b7ccabde48fae90$var$newFiltersToolPanelCSS);
    }
    init(params) {
        if (!this.gos.get("enableFilterHandlers")) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(282);
            return;
        }
        const filterPanelSvc = this.beans.filterPanelSvc;
        filterPanelSvc.isActive = true;
        this.addDestroyFunc(()=>{
            filterPanelSvc.isActive = false;
        });
        this.updateParams(params, params.initialState);
        const filterPanel = this.createManagedBean(new $5b7ccabde48fae90$var$FilterPanel());
        this.filterPanel = filterPanel;
        const refresh = (event)=>{
            filterPanel.refresh(event);
            params.onStateUpdated();
        };
        refresh();
        this.addManagedListeners(filterPanelSvc, {
            filterPanelStatesChanged: refresh,
            filterPanelStateChanged: refresh
        });
    }
    getGui() {
        return this.filterPanel?.getGui();
    }
    refresh(params) {
        this.updateParams(params, params.initialState);
        return true;
    }
    updateParams(params, initialState) {
        this.beans.filterPanelSvc?.updateParams(params, initialState);
    }
    getState() {
        return this.beans.filterPanelSvc?.getGridState() ?? {};
    }
};
// packages/ag-grid-enterprise/src/filterToolPanel/filtersToolPanelModule.ts
var $5b7ccabde48fae90$export$783953a68616c0a2 = {
    moduleName: "FiltersToolPanel",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agFiltersToolPanel: $5b7ccabde48fae90$var$FiltersToolPanel
    },
    icons: {
        // filter tool panel tab
        filtersToolPanel: "filter"
    },
    dependsOn: [
        $5b7ccabde48fae90$export$707a9bd30915b7fe,
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$bee7a6b8183a1c61)
    ]
};
var $5b7ccabde48fae90$export$5d9e175412b51985 = {
    moduleName: "NewFiltersToolPanel",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agNewFiltersToolPanel: $5b7ccabde48fae90$var$WrapperToolPanel
    },
    beans: [
        $5b7ccabde48fae90$var$FilterPanelService,
        $5b7ccabde48fae90$var$SelectableFilterService
    ],
    icons: {
        // filter add button in new filter tool panel
        filterAdd: "filter-add",
        // filter tool panel tab
        filtersToolPanel: "filter",
        // open icon for rich select
        richSelectOpen: "small-down",
        // remove for rich select editor pills
        richSelectRemove: "cancel",
        // loading async values
        richSelectLoading: "loading",
        // button to expand filter card in new filter tool panel
        filterCardExpand: "chevron-down",
        // button to collapse filter card in new filter tool panel
        filterCardCollapse: "chevron-up",
        // indicates filter card in new filter tool panel has edits
        filterCardEditing: "edit"
    },
    dependsOn: [
        $5b7ccabde48fae90$export$707a9bd30915b7fe,
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$bee7a6b8183a1c61)
    ]
};
var $5b7ccabde48fae90$var$DetailCellRendererCtrl = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.loadRowDataVersion = 0;
    }
    wireBeans(beans) {
        this.environment = beans.environment;
    }
    init(comp, params) {
        this.params = params;
        this.comp = comp;
        const doNothingBecauseInsidePinnedSection = params.pinned != null;
        if (doNothingBecauseInsidePinnedSection) return;
        this.setAutoHeightClasses();
        this.setupRefreshStrategy();
        this.createDetailGrid();
        this.loadRowData();
        this.addManagedEventListeners({
            fullWidthRowFocused: this.onFullWidthRowFocused.bind(this)
        });
    }
    onFullWidthRowFocused(e) {
        const params = this.params;
        const row = {
            rowIndex: params.node.rowIndex,
            rowPinned: params.node.rowPinned
        };
        const eventRow = {
            rowIndex: e.rowIndex,
            rowPinned: e.rowPinned
        };
        const isSameRow = (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(row, eventRow);
        if (!isSameRow) return;
        (0, $437b23f6a393c3bf$export$8598088d375f416f)(this.comp.getGui(), e.fromBelow);
    }
    setAutoHeightClasses() {
        const autoHeight = this.gos.get("detailRowAutoHeight");
        const parentClass = autoHeight ? "ag-details-row-auto-height" : "ag-details-row-fixed-height";
        const detailClass = autoHeight ? "ag-details-grid-auto-height" : "ag-details-grid-fixed-height";
        const comp = this.comp;
        comp.toggleCss(parentClass, true);
        comp.toggleDetailGridCss(detailClass, true);
    }
    setupRefreshStrategy() {
        const providedStrategy = this.params.refreshStrategy;
        const validSelection = providedStrategy == "everything" || providedStrategy == "nothing" || providedStrategy == "rows";
        if (validSelection) {
            this.refreshStrategy = providedStrategy;
            return;
        }
        if (providedStrategy != null) (0, $437b23f6a393c3bf$export$545083624300f13d)(170, {
            providedStrategy: providedStrategy
        });
        this.refreshStrategy = "rows";
    }
    createDetailGrid() {
        const { params: params, gos: gos } = this;
        if ((0, $437b23f6a393c3bf$export$672d9e47bc342bac)(params.detailGridOptions)) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(171);
            return;
        }
        const masterTheme = gos.get("theme");
        const detailTheme = params.detailGridOptions.theme;
        if (detailTheme && detailTheme !== masterTheme) (0, $437b23f6a393c3bf$export$545083624300f13d)(267);
        const gridOptions = {
            themeStyleContainer: this.environment.eStyleContainer,
            ...params.detailGridOptions,
            theme: masterTheme
        };
        const autoHeight = gos.get("detailRowAutoHeight");
        if (autoHeight) gridOptions.domLayout = "autoHeight";
        this.comp.setDetailGrid(gridOptions);
    }
    registerDetailWithMaster(api) {
        const { params: params, beans: { selectionSvc: selectionSvc, findSvc: findSvc, expansionSvc: expansionSvc } } = this;
        const rowId = params.node.id;
        const masterGridApi = params.api;
        const gridInfo = {
            id: rowId,
            api: api
        };
        const rowNode = params.node;
        if (masterGridApi.isDestroyed()) return;
        masterGridApi.addDetailGridInfo(rowId, gridInfo);
        rowNode.detailGridInfo = gridInfo;
        const masterNode = rowNode.parent;
        findSvc?.registerDetailGrid(rowNode, api);
        function onDetailSelectionChanged() {
            if (masterNode) selectionSvc?.refreshMasterNodeState(masterNode);
        }
        function adjustDetailsOnExpandOrCollapseAll({ source: source }) {
            if (source === "expandAll") return api.expandAll();
            if (source === "collapseAll") return api.collapseAll();
        }
        function onMasterRowSelected({ node: node, source: source }) {
            if (node !== masterNode || source === "masterDetail" || api.isDestroyed()) return;
            selectionSvc?.setDetailSelectionState(masterNode, params.detailGridOptions, api);
        }
        api.addEventListener("firstDataRendered", ()=>{
            if (api.isDestroyed() || masterGridApi.isDestroyed()) return;
            selectionSvc?.setDetailSelectionState(masterNode, params.detailGridOptions, api);
            api.addEventListener("selectionChanged", onDetailSelectionChanged);
            masterGridApi.addEventListener("rowSelected", onMasterRowSelected);
            const sharedApiModuleName = "CsrmSsrmSharedApi";
            const asAgModuleName = `${sharedApiModuleName}Module`;
            if (api.isModuleRegistered(asAgModuleName)) {
                masterGridApi.addEventListener("expandOrCollapseAll", adjustDetailsOnExpandOrCollapseAll);
                expansionSvc?.setDetailsExpansionState(api);
            }
        });
        this.addManagedListeners(masterNode, {
            masterChanged: (event)=>{
                if (!event.node.master) this.onDestroy(gridInfo);
            }
        });
        this.addDestroyFunc(()=>this.onDestroy(gridInfo));
    }
    onDestroy(gridInfo) {
        const { params: params } = this;
        const rowNode = params.node;
        const masterGridApi = params.api;
        if (rowNode.detailGridInfo !== gridInfo) return;
        if (!masterGridApi.isDestroyed()) masterGridApi.removeDetailGridInfo(rowNode.id);
        rowNode.detailGridInfo = null;
    }
    loadRowData() {
        this.loadRowDataVersion++;
        const versionThisCall = this.loadRowDataVersion;
        const params = this.params;
        if (params.detailGridOptions?.rowModelType === "serverSide") {
            const node = params.node;
            node.detailGridInfo?.api?.refreshServerSide({
                purge: true
            });
            return;
        }
        const userFunc = params.getDetailRowData;
        if (!userFunc) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(172);
            return;
        }
        const successCallback = (rowData)=>{
            const mostRecentCall = this.loadRowDataVersion === versionThisCall;
            if (mostRecentCall) this.comp.setRowData(rowData);
        };
        const funcParams = {
            node: params.node,
            // we take data from node, rather than params.data
            // as the data could have been updated with new instance
            data: params.node.data,
            successCallback: successCallback,
            context: (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {}).context
        };
        userFunc(funcParams);
    }
    refresh() {
        const GET_GRID_TO_REFRESH = false;
        const GET_GRID_TO_DO_NOTHING = true;
        switch(this.refreshStrategy){
            case "nothing":
                return GET_GRID_TO_DO_NOTHING;
            case "everything":
                return GET_GRID_TO_REFRESH;
        }
        this.loadRowData();
        return GET_GRID_TO_DO_NOTHING;
    }
};
// packages/ag-grid-enterprise/src/masterDetail/detailFrameworkComponentWrapper.ts
var $5b7ccabde48fae90$var$DetailFrameworkComponentWrapper = class {
    constructor(parentWrapper){
        this.parentWrapper = parentWrapper;
    }
    wrap(frameworkComponent, mandatoryMethods, optionalMethods, componentType) {
        return this.parentWrapper.wrap(frameworkComponent, mandatoryMethods, optionalMethods, componentType);
    }
};
// packages/ag-grid-enterprise/src/masterDetail/detailCellRenderer.ts
var $5b7ccabde48fae90$var$PinnedDetailCellRendererElement = {
    tag: "div",
    cls: "ag-details-row"
};
var $5b7ccabde48fae90$var$DetailCellRendererElement = {
    tag: "div",
    cls: "ag-details-row",
    role: "gridcell",
    children: [
        {
            tag: "div",
            ref: "eDetailGrid",
            cls: "ag-details-grid",
            role: "presentation"
        }
    ]
};
var $5b7ccabde48fae90$var$DetailCellRenderer = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.eDetailGrid = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    wireBeans(beans) {
        this.context = beans.context;
    }
    init(params) {
        this.params = params;
        this.selectAndSetTemplate();
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            toggleDetailGridCss: (cssClassName, on)=>this.eDetailGrid.classList.toggle(cssClassName, on),
            setDetailGrid: (gridOptions)=>this.setDetailGrid(gridOptions),
            setRowData: (rowData)=>this.setRowData(rowData),
            getGui: ()=>this.eDetailGrid
        };
        this.ctrl = this.createManagedBean(new $5b7ccabde48fae90$var$DetailCellRendererCtrl());
        this.ctrl.init(compProxy, params);
    }
    refresh() {
        return this.ctrl?.refresh() ?? false;
    }
    selectAndSetTemplate() {
        const params = this.params;
        if (params.pinned) {
            this.setTemplate($5b7ccabde48fae90$var$PinnedDetailCellRendererElement);
            return;
        }
        const setDefaultTemplate = ()=>{
            this.setTemplate($5b7ccabde48fae90$var$DetailCellRendererElement);
        };
        if ((0, $437b23f6a393c3bf$export$672d9e47bc342bac)(params.template)) setDefaultTemplate();
        else if (typeof params.template === "string") this.setTemplate(params.template, []);
        else if (typeof params.template === "function") {
            const templateFunc = params.template;
            const template = templateFunc(params);
            this.setTemplate(template, []);
        } else {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(168);
            setDefaultTemplate();
        }
        if (this.eDetailGrid == null) (0, $437b23f6a393c3bf$export$545083624300f13d)(169);
    }
    setDetailGrid(gridOptions) {
        if (!this.eDetailGrid) return;
        const parentFrameworkComponentWrapper = this.context.getBean("frameworkCompWrapper");
        const frameworkCompWrapper = new $5b7ccabde48fae90$var$DetailFrameworkComponentWrapper(parentFrameworkComponentWrapper);
        const { frameworkOverrides: frameworkOverrides } = this.beans;
        const api = (0, $437b23f6a393c3bf$export$fce123c48a7b4eae)(this.eDetailGrid, gridOptions, {
            frameworkOverrides: frameworkOverrides,
            providedBeanInstances: {
                frameworkCompWrapper: frameworkCompWrapper
            },
            modules: (0, $437b23f6a393c3bf$export$7c244c452cd4b417)(this.params.api.getGridId(), gridOptions.rowModelType ?? "clientSide")
        });
        this.detailApi = api;
        this.ctrl?.registerDetailWithMaster(api);
        this.addDestroyFunc(()=>{
            api.destroy();
        });
    }
    setRowData(rowData) {
        this.detailApi?.setGridOption("rowData", rowData);
    }
};
// packages/ag-grid-enterprise/src/masterDetail/masterDetailApi.ts
function $5b7ccabde48fae90$var$operateOnStore(beans, callback) {
    const store = beans.masterDetailSvc?.store;
    return store ? callback(store) : void 0;
}
function $5b7ccabde48fae90$var$addDetailGridInfo(beans, id, gridInfo) {
    $5b7ccabde48fae90$var$operateOnStore(beans, (store)=>{
        store[id] = gridInfo;
    });
}
function $5b7ccabde48fae90$var$removeDetailGridInfo(beans, id) {
    $5b7ccabde48fae90$var$operateOnStore(beans, (store)=>{
        delete store[id];
    });
}
function $5b7ccabde48fae90$var$getDetailGridInfo(beans, id) {
    return $5b7ccabde48fae90$var$operateOnStore(beans, (store)=>store[id]);
}
function $5b7ccabde48fae90$var$forEachDetailGridInfo(beans, callback) {
    $5b7ccabde48fae90$var$operateOnStore(beans, (store)=>{
        let index = 0;
        Object.values(store).forEach((gridInfo)=>{
            if (gridInfo) callback(gridInfo, index++);
        });
    });
}
// packages/ag-grid-enterprise/src/masterDetail/masterDetailModule.css-GENERATED.ts
var $5b7ccabde48fae90$var$masterDetailModuleCSS = /*css*/ `.ag-details-row{width:100%}.ag-details-row-fixed-height{height:100%}.ag-details-grid{width:100%}.ag-details-grid-fixed-height{height:100%}`;
var $5b7ccabde48fae90$var$MasterDetailService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "masterDetailSvc";
        this.store = {};
    }
    isEnabled() {
        return this.gos.get("masterDetail");
    }
    postConstruct() {
        const gos = this.gos;
        if ((0, $437b23f6a393c3bf$export$9f182d9ca737e15)(gos)) this.enabled = this.isEnabled();
        if ((0, $437b23f6a393c3bf$export$cf1bac0013650216)(gos)) this.addEventListeners();
    }
    addEventListeners() {
        const rowNodeDataChanged = (event)=>{
            this.setMaster(event.node, false, true);
        };
        let removeListeners;
        const addOrRemoveListeners = ()=>{
            if (removeListeners) {
                for (const removeListener of removeListeners)removeListener();
                removeListeners = void 0;
            }
            if (this.isEnabled()) removeListeners = this.addManagedListeners(this.beans.eventSvc, {
                rowNodeDataChanged: rowNodeDataChanged
            });
        };
        addOrRemoveListeners();
        this.gos.addPropertyEventListener("masterDetail", addOrRemoveListeners);
    }
    refreshModel(params) {
        if (params.changedProps) {
            const enabled = this.isEnabled();
            if (this.enabled !== enabled) {
                this.setMasters(null);
                return;
            }
        }
        if (params.rowDataUpdated) this.setMasters(params.changedRowNodes);
    }
    setMaster(row, created, updated) {
        const oldMaster = row.master;
        const enabled = this.isEnabled();
        let newMaster = enabled;
        const gos = this.gos;
        const isRowMaster = gos.get("isRowMaster");
        const treeData = gos.get("treeData");
        if (enabled) {
            if (created || updated) {
                if (isRowMaster) {
                    const data = row.data;
                    newMaster = !!data && !!isRowMaster(data);
                }
            } else newMaster = oldMaster;
        }
        const beans = this.beans;
        if (!treeData) {
            if (newMaster && created) {
                const level = beans.rowGroupColsSvc?.columns.length ?? 0;
                row.expanded = $5b7ccabde48fae90$var$_getRowDefaultExpanded(beans, row, level, false);
            } else if (!newMaster && oldMaster) row.expanded = false;
        }
        if (newMaster !== oldMaster) {
            row.master = newMaster;
            row.dispatchRowEvent("masterChanged");
        }
    }
    setMasters(changedRowNodes) {
        this.enabled = this.isEnabled();
        if (changedRowNodes) {
            for (const node of changedRowNodes.updates)this.setMaster(node, false, true);
            for (const node of changedRowNodes.adds)this.setMaster(node, true, false);
        } else {
            const allLeafChildren = (0, $437b23f6a393c3bf$export$f5285e6f27a03f95)(this.beans)?.rootNode?._leafs;
            if (allLeafChildren) for(let i = 0, len = allLeafChildren.length; i < len; ++i)this.setMaster(allLeafChildren[i], true, false);
        }
    }
    /** Used by flatten stage to get or create a detail node from a master node */ getDetail(masterNode) {
        if (!masterNode.master || !masterNode.expanded) return null;
        let detailNode = masterNode.detailNode;
        if (detailNode) return detailNode;
        detailNode = new (0, $437b23f6a393c3bf$export$6af91cd58ec2edf9)(this.beans);
        detailNode.detail = true;
        detailNode.selectable = false;
        detailNode.parent = masterNode;
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(masterNode.id)) detailNode.id = "detail_" + masterNode.id;
        detailNode.data = masterNode.data;
        detailNode.level = masterNode.level + 1;
        masterNode.detailNode = detailNode;
        return detailNode;
    }
    setupDetailRowAutoHeight(rowCtrl, eDetailGui) {
        const { gos: gos, beans: beans } = this;
        if (!gos.get("detailRowAutoHeight")) return;
        const checkRowSizeFunc = ()=>{
            const clientHeight = eDetailGui.clientHeight;
            if (clientHeight != null && clientHeight > 0) {
                const updateRowHeightFunc = ()=>{
                    const { rowModel: rowModel } = this.beans;
                    const { rowNode: rowNode } = rowCtrl;
                    rowNode.setRowHeight(clientHeight);
                    if ((0, $437b23f6a393c3bf$export$9f182d9ca737e15)(gos, rowModel) || (0, $437b23f6a393c3bf$export$cf1bac0013650216)(gos, rowModel)) rowModel.onRowHeightChanged();
                };
                window.setTimeout(updateRowHeightFunc, 0);
            }
        };
        const resizeObserverDestroyFunc = (0, $437b23f6a393c3bf$export$9aef8476630687be)(beans, eDetailGui, checkRowSizeFunc);
        rowCtrl.addDestroyFunc(resizeObserverDestroyFunc);
        checkRowSizeFunc();
    }
    destroy() {
        this.store = {};
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/masterDetail/masterDetailModule.ts
var $5b7ccabde48fae90$var$SharedMasterDetailModule = {
    moduleName: "SharedMasterDetail",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$MasterDetailService
    ],
    userComponents: {
        agDetailCellRenderer: $5b7ccabde48fae90$var$DetailCellRenderer
    },
    dynamicBeans: {
        detailCellRendererCtrl: $5b7ccabde48fae90$var$DetailCellRendererCtrl
    },
    apiFunctions: {
        addDetailGridInfo: $5b7ccabde48fae90$var$addDetailGridInfo,
        removeDetailGridInfo: $5b7ccabde48fae90$var$removeDetailGridInfo,
        getDetailGridInfo: $5b7ccabde48fae90$var$getDetailGridInfo,
        forEachDetailGridInfo: $5b7ccabde48fae90$var$forEachDetailGridInfo
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        $5b7ccabde48fae90$var$GroupCellRendererModule,
        $5b7ccabde48fae90$var$StickyRowModule
    ],
    css: [
        $5b7ccabde48fae90$var$masterDetailModuleCSS
    ]
};
var $5b7ccabde48fae90$export$656cedc46227f6d2 = {
    moduleName: "MasterDetail",
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: [
        $5b7ccabde48fae90$var$SharedMasterDetailModule,
        $5b7ccabde48fae90$var$ClientSideRowModelHierarchyModule,
        (0, $437b23f6a393c3bf$export$d20c5df25778eac8)
    ]
};
var $5b7ccabde48fae90$var$AbstractSelectionHandle = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.changedCalculatedValues = false;
        this.dragging = false;
        this.shouldDestroyOnEndDragging = false;
    }
    postConstruct() {
        this.beans.dragSvc.addDragSource({
            dragStartPixels: 0,
            eElement: this.getGui(),
            onDragging: (e)=>{
                if (!this.dragging) {
                    this.dragging = true;
                    const pageBody = (0, $437b23f6a393c3bf$export$50c54e860701cf22)(this.beans);
                    pageBody.classList?.add(this.getDraggingCssClass());
                }
                this.updateValuesOnMove(e);
                this.beans.rangeSvc.autoScrollService.check(e);
                if (this.changedCalculatedValues) {
                    this.onDrag(e);
                    this.changedCalculatedValues = false;
                }
            },
            onDragStop: (e)=>{
                this.dragging = false;
                this.onDragEnd(e);
                this.clearDragProperties();
            },
            onDragCancel: ()=>{
                this.dragging = false;
                this.onDragCancel();
                this.clearDragProperties();
            }
        });
        this.addManagedElementListeners(this.getGui(), {
            pointerdown: $5b7ccabde48fae90$var$stopEventPropagation,
            mousedown: $5b7ccabde48fae90$var$stopEventPropagation
        });
    }
    getLastCellHovered() {
        return this.lastCellHovered;
    }
    getDraggingCssClass() {
        return `ag-dragging-${this.type === 0 /* FILL */  ? "fill" : "range"}-handle`;
    }
    updateValuesOnMove(e) {
        const cell = (0, $437b23f6a393c3bf$export$d85fcb0e6e51242)(this.gos, e);
        if (!cell || this.shouldSkipCell(cell) || this.lastCellHovered && (0, $437b23f6a393c3bf$export$be3973033c2c5267)(cell, this.lastCellHovered)) return;
        this.lastCellHovered = cell;
        this.changedCalculatedValues = true;
    }
    clearDragProperties() {
        this.clearValues();
        this.beans.rangeSvc.autoScrollService.ensureCleared();
        const pageBody = (0, $437b23f6a393c3bf$export$50c54e860701cf22)(this.beans);
        pageBody.classList?.remove(this.getDraggingCssClass());
        if (this.shouldDestroyOnEndDragging) this.destroy();
    }
    getType() {
        return this.type;
    }
    refresh(cellCtrl) {
        const oldCellComp = this.cellCtrl;
        const eGui = this.getGui();
        const cellRange = (0, $437b23f6a393c3bf$export$236389741107357f)(this.beans.rangeSvc.getCellRanges());
        const start = cellRange.startRow;
        const end = cellRange.endRow;
        if (start && end) {
            const isBefore = (0, $437b23f6a393c3bf$export$6cce97428a227a31)(end, start);
            if (isBefore) {
                this.rangeStartRow = end;
                this.rangeEndRow = start;
            } else {
                this.rangeStartRow = start;
                this.rangeEndRow = end;
            }
        }
        if (oldCellComp !== cellCtrl || !(0, $437b23f6a393c3bf$export$2badf4aa566524cb)(eGui)) {
            this.cellCtrl = cellCtrl;
            const eParentOfValue = cellCtrl.comp.getParentOfValue();
            if (eParentOfValue) eParentOfValue.appendChild(eGui);
        }
        this.cellRange = cellRange;
    }
    clearValues() {
        this.lastCellHovered = void 0;
    }
    destroy() {
        if (!this.shouldDestroyOnEndDragging && this.dragging) {
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.getGui(), false);
            this.shouldDestroyOnEndDragging = true;
            return;
        }
        this.shouldDestroyOnEndDragging = false;
        super.destroy();
        this.getGui()?.remove();
    }
};
var $5b7ccabde48fae90$var$stopEventPropagation = (e)=>{
    e.stopPropagation();
};
// packages/ag-grid-enterprise/src/rangeSelection/utils.ts
function $5b7ccabde48fae90$var$findLineByLeastSquares(values) {
    const len = values.length;
    let maxDecimals = 0;
    if (len <= 1) return values;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        const splitExponent = value.toString().split("e-");
        if (splitExponent.length > 1) {
            maxDecimals = Math.max(maxDecimals, parseInt(splitExponent[1], 10));
            continue;
        }
        if (Math.floor(value) === value) continue;
        maxDecimals = Math.max(maxDecimals, value.toString().split(".")[1].length);
    }
    let sum_x = 0;
    let sum_y = 0;
    let sum_xy = 0;
    let sum_xx = 0;
    let y = 0;
    for(let x = 0; x < len; x++){
        y = values[x];
        sum_x += x;
        sum_y += y;
        sum_xx += x * x;
        sum_xy += x * y;
    }
    const m = (len * sum_xy - sum_x * sum_y) / (len * sum_xx - sum_x * sum_x);
    const b = sum_y / len - m * sum_x / len;
    const result = [];
    for(let x = 0; x <= len; x++)result.push(parseFloat((x * m + b).toFixed(maxDecimals)));
    return result;
}
// packages/ag-grid-enterprise/src/rangeSelection/agFillHandle.ts
var $5b7ccabde48fae90$var$FillHandleElement = {
    tag: "div",
    cls: "ag-fill-handle"
};
var $5b7ccabde48fae90$var$AgFillHandle = class extends $5b7ccabde48fae90$var$AbstractSelectionHandle {
    constructor(){
        super($5b7ccabde48fae90$var$FillHandleElement);
        this.markedCells = [];
        this.cellValues = [];
        this.isUp = false;
        this.isLeft = false;
        this.isReduce = false;
        this.type = 0 /* FILL */ ;
    }
    postConstruct() {
        super.postConstruct();
        this.addManagedElementListeners(this.getGui(), {
            dblclick: this.onDblClick.bind(this)
        });
    }
    onDblClick(e) {
        (0, $437b23f6a393c3bf$export$456c40e80134d72a)(e);
        const { cellRange: initialRange, rangeStartRow: rangeStartRow, beans: beans } = this;
        const { rangeSvc: rangeSvc, visibleCols: visibleCols } = beans;
        const lastRow = (0, $437b23f6a393c3bf$export$a1449222017e428)(beans);
        if (!lastRow) return;
        const fillHandleDirection = this.getFillHandleDirection();
        this.dragAxis = fillHandleDirection === "xy" ? "y" : fillHandleDirection;
        const finalRange = rangeSvc?.createCellRangeFromCellRangeParams({
            rowStartIndex: rangeStartRow.rowIndex,
            rowStartPinned: rangeStartRow.rowPinned,
            columnStart: initialRange.columns[0],
            rowEndIndex: this.dragAxis === "x" ? initialRange.endRow?.rowIndex ?? null : lastRow.rowIndex,
            rowEndPinned: this.dragAxis === "x" ? initialRange.endRow?.rowPinned : lastRow.rowPinned,
            columnEnd: this.dragAxis === "x" ? (0, $437b23f6a393c3bf$export$236389741107357f)(visibleCols.allCols) : (0, $437b23f6a393c3bf$export$236389741107357f)(initialRange.columns)
        });
        this.isUp = false;
        this.isLeft = false;
        if (finalRange) this.performFill({
            event: e,
            initialRange: initialRange,
            finalRange: finalRange
        });
        this.dragAxis = void 0;
    }
    updateValuesOnMove(e) {
        super.updateValuesOnMove(e);
        if (!this.initialXY) this.initialXY = (0, $437b23f6a393c3bf$export$530c24bdfacb8cd1)(this.beans, e);
        const { x: x, y: y } = this.initialXY;
        const { x: newX, y: newY } = (0, $437b23f6a393c3bf$export$530c24bdfacb8cd1)(this.beans, e);
        const diffX = Math.abs(x - newX);
        const diffY = Math.abs(y - newY);
        const allowedDirection = this.getFillHandleDirection();
        let direction;
        if (allowedDirection === "xy") direction = diffX > diffY ? "x" : "y";
        else direction = allowedDirection;
        if (direction !== this.dragAxis) {
            this.dragAxis = direction;
            this.changedCalculatedValues = true;
        }
    }
    shouldSkipCell(cell) {
        return (0, $437b23f6a393c3bf$export$3d3e7d751f0445eb)(cell.column);
    }
    onDrag(_) {
        if (!this.initialPosition) {
            const cellCtrl = this.cellCtrl;
            if (!cellCtrl) return;
            this.initialPosition = cellCtrl.cellPosition;
        }
        const lastCellHovered = this.getLastCellHovered();
        if (lastCellHovered) this.markPathFrom(this.initialPosition, lastCellHovered);
    }
    onDragEnd(e) {
        this.initialXY = null;
        if (!this.markedCells.length) return;
        const isX = this.dragAxis === "x";
        const { cellRange: initialRange, rangeStartRow: rangeStartRow, rangeEndRow: rangeEndRow, beans: { rangeSvc: rangeSvc } } = this;
        const colLen = initialRange.columns.length;
        let finalRange;
        if (!this.isUp && !this.isLeft) finalRange = rangeSvc.createCellRangeFromCellRangeParams({
            rowStartIndex: rangeStartRow.rowIndex,
            rowStartPinned: rangeStartRow.rowPinned,
            columnStart: initialRange.columns[0],
            rowEndIndex: isX ? rangeEndRow.rowIndex : this.lastCellMarked.rowIndex,
            rowEndPinned: isX ? rangeEndRow.rowPinned : this.lastCellMarked.rowPinned,
            columnEnd: isX ? this.lastCellMarked.column : initialRange.columns[colLen - 1]
        });
        else {
            const startRow = isX ? rangeStartRow : this.lastCellMarked;
            finalRange = rangeSvc.createCellRangeFromCellRangeParams({
                rowStartIndex: startRow.rowIndex,
                rowStartPinned: startRow.rowPinned,
                columnStart: isX ? this.lastCellMarked.column : initialRange.columns[0],
                rowEndIndex: rangeEndRow.rowIndex,
                rowEndPinned: rangeEndRow.rowPinned,
                columnEnd: initialRange.columns[colLen - 1]
            });
        }
        if (finalRange) this.performFill({
            event: e,
            initialRange: initialRange,
            finalRange: finalRange,
            shouldUpdateRange: true
        });
    }
    onDragCancel() {
        this.initialXY = null;
        if (!this.markedCells.length) return;
        this.clearMarkedPath();
    }
    performFill({ event: event, initialRange: initialRange, finalRange: finalRange, shouldUpdateRange: shouldUpdateRange }) {
        const { eventSvc: eventSvc, rangeSvc: rangeSvc } = this.beans;
        eventSvc.dispatchEvent({
            type: "fillStart"
        });
        this.handleValueChanged(initialRange, finalRange, event);
        if (shouldUpdateRange) rangeSvc.setCellRanges([
            finalRange
        ]);
        eventSvc.dispatchEvent({
            type: "fillEnd",
            initialRange: initialRange,
            finalRange: finalRange
        });
    }
    getFillHandleDirection() {
        const direction = (0, $437b23f6a393c3bf$export$c96ba82819c56957)(this.gos)?.direction;
        if (!direction) return "xy";
        if (direction !== "x" && direction !== "y" && direction !== "xy") {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(177);
            return "xy";
        }
        return direction;
    }
    handleValueChanged(initialRange, finalRange, e) {
        const { beans: beans } = this;
        const { rangeSvc: rangeSvc, gos: gos, valueSvc: valueSvc } = beans;
        const initialRangeEndRow = rangeSvc.getRangeEndRow(initialRange);
        const initialRangeStartRow = rangeSvc.getRangeStartRow(initialRange);
        const finalRangeEndRow = rangeSvc.getRangeEndRow(finalRange);
        const finalRangeStartRow = rangeSvc.getRangeStartRow(finalRange);
        const isVertical = this.dragAxis === "y";
        if (this.isReduce && !(0, $437b23f6a393c3bf$export$c96ba82819c56957)(gos)?.suppressClearOnFillReduction) {
            const columns = isVertical ? initialRange.columns : initialRange.columns.filter((col)=>finalRange.columns.indexOf(col) < 0);
            const startRow = isVertical ? (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(beans, finalRangeEndRow) : finalRangeStartRow;
            if (startRow) this.clearCellsInRange(startRow, initialRangeEndRow, columns);
            return;
        }
        const values = [];
        const initialValues = [];
        const initialNonAggregatedValues = [];
        const initialFormattedValues = [];
        let withinInitialRange = true;
        let idx = 0;
        const resetValues = ()=>{
            values.length = 0;
            initialValues.length = 0;
            initialNonAggregatedValues.length = 0;
            initialFormattedValues.length = 0;
            idx = 0;
        };
        const iterateAcrossCells = (column, columns)=>{
            let currentRow = this.isUp ? initialRangeEndRow : initialRangeStartRow;
            let finished = false;
            if (isVertical) {
                withinInitialRange = true;
                resetValues();
            }
            while(!finished && currentRow){
                const rowNode = (0, $437b23f6a393c3bf$export$d4675a60917db7b0)(beans, currentRow);
                if (!rowNode) break;
                if (isVertical && column) fillValues(values, column, rowNode, ()=>!(0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(currentRow, this.isUp ? initialRangeStartRow : initialRangeEndRow));
                else if (columns) {
                    withinInitialRange = true;
                    resetValues();
                    for (const col of columns)fillValues(values, col, rowNode, ()=>col !== (this.isLeft ? initialRange.columns[0] : (0, $437b23f6a393c3bf$export$236389741107357f)(initialRange.columns)));
                }
                finished = (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(currentRow, this.isUp ? finalRangeStartRow : finalRangeEndRow);
                currentRow = this.isUp ? (0, $437b23f6a393c3bf$export$b36b14fdaf41f4d8)(this.beans, currentRow) : (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(beans, currentRow);
            }
        };
        const fillValues = (currentValues, col, rowNode, updateInitialSet)=>{
            let currentValue;
            let skipValue = false;
            if (withinInitialRange) {
                currentValue = valueSvc.getValue(col, rowNode);
                initialValues.push(currentValue);
                initialNonAggregatedValues.push(valueSvc.getValue(col, rowNode, true));
                initialFormattedValues.push(valueSvc.getValueForDisplay({
                    column: col,
                    node: rowNode
                }).valueFormatted);
                withinInitialRange = updateInitialSet();
            } else {
                const { value: value, fromUserFunction: fromUserFunction, sourceCol: sourceCol, sourceRowNode: sourceRowNode } = this.processValues({
                    event: e,
                    values: currentValues,
                    initialValues: initialValues,
                    initialNonAggregatedValues: initialNonAggregatedValues,
                    initialFormattedValues: initialFormattedValues,
                    col: col,
                    rowNode: rowNode,
                    idx: idx++
                });
                currentValue = value;
                if (col.isCellEditable(rowNode)) {
                    const cellValue = valueSvc.getValue(col, rowNode);
                    if (!fromUserFunction) {
                        if (sourceCol) {
                            const sourceColDef = sourceCol.getColDef();
                            if (sourceColDef.useValueFormatterForExport !== false && sourceColDef.valueFormatter) {
                                const formattedValue = valueSvc.getValueForDisplay({
                                    column: sourceCol,
                                    node: sourceRowNode,
                                    includeValueFormatted: true
                                }).valueFormatted;
                                if (formattedValue != null) currentValue = formattedValue;
                            }
                        }
                        if (col.getColDef().useValueParserForImport !== false) currentValue = valueSvc.parseValue(col, rowNode, // if no sourceCol, then currentValue is a number
                        sourceCol ? currentValue : (0, $437b23f6a393c3bf$export$2a74c29220d5c88e)(currentValue), cellValue);
                    }
                    if (!fromUserFunction || cellValue !== currentValue) rowNode.setDataValue(col, currentValue, "rangeSvc");
                    else skipValue = true;
                }
            }
            if (!skipValue) currentValues.push({
                value: currentValue,
                column: col,
                rowNode: rowNode
            });
        };
        if (isVertical) initialRange.columns.forEach((col)=>{
            iterateAcrossCells(col);
        });
        else {
            const columns = this.isLeft ? [
                ...finalRange.columns
            ].reverse() : finalRange.columns;
            iterateAcrossCells(void 0, columns);
        }
        this.beans.editSvc?.stopEditing(void 0, {
            source: "fillHandle"
        });
    }
    clearCellsInRange(startRow, endRow, columns) {
        const cellRange = {
            startRow: startRow,
            endRow: endRow,
            columns: columns,
            startColumn: columns[0]
        };
        this.beans.rangeSvc.clearCellRangeCellValues({
            cellRanges: [
                cellRange
            ]
        });
    }
    processValues(params) {
        const { formula: formula, valueSvc: valueSvc } = this.beans;
        const { event: event, values: values, initialValues: initialValues, initialNonAggregatedValues: initialNonAggregatedValues, initialFormattedValues: initialFormattedValues, col: col, rowNode: rowNode, idx: idx } = params;
        const userFillOperation = (0, $437b23f6a393c3bf$export$c96ba82819c56957)(this.gos)?.setFillValue;
        const isVertical = this.dragAxis === "y";
        let direction;
        if (isVertical) direction = this.isUp ? "up" : "down";
        else direction = this.isLeft ? "left" : "right";
        if (userFillOperation) {
            const params2 = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
                event: event,
                values: values.map(({ value: value })=>value),
                initialValues: initialValues,
                initialNonAggregatedValues: initialNonAggregatedValues,
                initialFormattedValues: initialFormattedValues,
                currentIndex: idx,
                currentCellValue: valueSvc.getValue(col, rowNode),
                direction: direction,
                column: col,
                rowNode: rowNode
            });
            const userResult = userFillOperation(params2);
            if (userResult !== false) return {
                value: userResult,
                fromUserFunction: true
            };
        }
        const isNumeric = (v)=>typeof v === "number" && Number.isFinite(v) || typeof v === "string" && /^[+-]?\d+(?:\.\d+)?$/.test(v.trim());
        const allNumbers = values.every(({ value: value })=>isNumeric(value));
        if (event.altKey || !allNumbers) {
            const valueForFunctions = String((0, $437b23f6a393c3bf$export$236389741107357f)(values)?.value ?? "");
            if (allNumbers && initialValues.length === 1) {
                const multiplier = this.isUp || this.isLeft ? -1 : 1;
                return {
                    value: parseFloat(valueForFunctions) + 1 * multiplier,
                    fromUserFunction: false
                };
            }
            const { value: cyclicValue, column: sourceCol, rowNode: sourceRowNode } = values[idx % values.length];
            let processedValue;
            if (sourceCol.isAllowFormula() && formula?.isFormula(valueForFunctions)) {
                const rowDelta = direction === "up" ? -1 : direction === "down" ? 1 : 0;
                const columnDelta = direction === "left" ? -1 : direction === "right" ? 1 : 0;
                processedValue = formula.updateFormulaByOffset({
                    value: valueForFunctions,
                    rowDelta: rowDelta,
                    columnDelta: columnDelta
                });
            } else processedValue = cyclicValue;
            return {
                value: processedValue,
                fromUserFunction: false,
                sourceCol: sourceCol,
                sourceRowNode: sourceRowNode
            };
        }
        return {
            value: (0, $437b23f6a393c3bf$export$236389741107357f)($5b7ccabde48fae90$var$findLineByLeastSquares(values.map(({ value: value })=>Number(value)))),
            fromUserFunction: false
        };
    }
    clearValues() {
        this.clearMarkedPath();
        this.clearCellValues();
        this.lastCellMarked = void 0;
        super.clearValues();
    }
    clearMarkedPath() {
        for (const cell of this.markedCells){
            if (!cell.isAlive()) continue;
            const { comp: comp } = cell;
            comp.toggleCss("ag-selection-fill-top", false);
            comp.toggleCss("ag-selection-fill-right", false);
            comp.toggleCss("ag-selection-fill-bottom", false);
            comp.toggleCss("ag-selection-fill-left", false);
        }
        this.markedCells.length = 0;
        this.isUp = false;
        this.isLeft = false;
        this.isReduce = false;
    }
    clearCellValues() {
        this.cellValues.length = 0;
    }
    markPathFrom(initialPosition, currentPosition) {
        this.clearMarkedPath();
        this.clearCellValues();
        if (this.dragAxis === "y") {
            if ((0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(currentPosition, initialPosition)) return;
            const isBefore = (0, $437b23f6a393c3bf$export$6cce97428a227a31)(currentPosition, initialPosition);
            const { rangeStartRow: rangeStartRow, rangeEndRow: rangeEndRow } = this;
            if (isBefore && (currentPosition.rowPinned == rangeStartRow.rowPinned && currentPosition.rowIndex >= rangeStartRow.rowIndex || rangeStartRow.rowPinned != rangeEndRow.rowPinned && currentPosition.rowPinned == rangeEndRow.rowPinned && currentPosition.rowIndex <= rangeEndRow.rowIndex)) {
                this.reduceVertical(initialPosition, currentPosition);
                this.isReduce = true;
            } else {
                this.extendVertical(initialPosition, currentPosition, isBefore);
                this.isReduce = false;
            }
        } else {
            const initialColumn = initialPosition.column;
            const currentColumn = currentPosition.column;
            if (initialColumn === currentColumn) return;
            const displayedColumns = this.beans.visibleCols.allCols;
            const initialIndex = displayedColumns.indexOf(initialColumn);
            const currentIndex = displayedColumns.indexOf(currentColumn);
            if (currentIndex <= initialIndex && currentIndex >= displayedColumns.indexOf(this.cellRange.columns[0])) {
                this.reduceHorizontal(initialPosition, currentPosition);
                this.isReduce = true;
            } else {
                this.extendHorizontal(initialPosition, currentPosition, currentIndex < initialIndex);
                this.isReduce = false;
            }
        }
        this.lastCellMarked = currentPosition;
    }
    extendVertical(initialPosition, endPosition, isMovingUp) {
        const beans = this.beans;
        const { rangeSvc: rangeSvc } = beans;
        let row = initialPosition;
        do {
            const cellRange = this.cellRange;
            const colLen = cellRange.columns.length;
            for(let i = 0; i < colLen; i++){
                const column = cellRange.columns[i];
                const rowPos = {
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned
                };
                const cellPos = {
                    ...rowPos,
                    column: column
                };
                const cellInRange = rangeSvc.isCellInSpecificRange(cellPos, cellRange);
                const isInitialRow = (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(row, initialPosition);
                if (isMovingUp) this.isUp = true;
                if (!isInitialRow) {
                    const cell = (0, $437b23f6a393c3bf$export$1bd7ce47360c3c0)(beans, cellPos);
                    if (cell) {
                        this.markedCells.push(cell);
                        const cellComp = cell.comp;
                        if (!cellInRange) {
                            cellComp.toggleCss("ag-selection-fill-left", i === 0);
                            cellComp.toggleCss("ag-selection-fill-right", i === colLen - 1);
                        }
                        cellComp.toggleCss(isMovingUp ? "ag-selection-fill-top" : "ag-selection-fill-bottom", (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(row, endPosition));
                    }
                }
            }
            if ((0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(row, endPosition)) break;
        }while (// tslint:disable-next-line
        row = isMovingUp ? (0, $437b23f6a393c3bf$export$b36b14fdaf41f4d8)(this.beans, row) : (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(beans, row));
    }
    reduceVertical(initialPosition, endPosition) {
        let row = initialPosition;
        const beans = this.beans;
        do {
            const cellRange = this.cellRange;
            const colLen = cellRange.columns.length;
            const isLastRow = (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(row, endPosition);
            for(let i = 0; i < colLen; i++){
                const rowPos = {
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned
                };
                const celPos = {
                    ...rowPos,
                    column: cellRange.columns[i]
                };
                const cell = (0, $437b23f6a393c3bf$export$1bd7ce47360c3c0)(beans, celPos);
                if (cell) {
                    this.markedCells.push(cell);
                    cell.comp.toggleCss("ag-selection-fill-bottom", (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(row, endPosition));
                }
            }
            if (isLastRow) break;
        }while (row = (0, $437b23f6a393c3bf$export$b36b14fdaf41f4d8)(beans, row));
    }
    extendHorizontal(initialPosition, endPosition, isMovingLeft) {
        const beans = this.beans;
        const { visibleCols: visibleCols } = beans;
        const allCols = visibleCols.allCols;
        const startCol = allCols.indexOf(isMovingLeft ? endPosition.column : initialPosition.column);
        const endCol = allCols.indexOf(isMovingLeft ? this.cellRange.columns[0] : endPosition.column);
        const offset = isMovingLeft ? 0 : 1;
        const colsToMark = allCols.slice(startCol + offset, endCol + offset);
        const { rangeStartRow: rangeStartRow, rangeEndRow: rangeEndRow } = this;
        for (const column of colsToMark){
            let row = rangeStartRow;
            let isLastRow = false;
            do {
                isLastRow = (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(row, rangeEndRow);
                const cell = (0, $437b23f6a393c3bf$export$1bd7ce47360c3c0)(beans, {
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned,
                    column: column
                });
                if (cell) {
                    this.markedCells.push(cell);
                    const cellComp = cell.comp;
                    cellComp.toggleCss("ag-selection-fill-top", (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(row, rangeStartRow));
                    cellComp.toggleCss("ag-selection-fill-bottom", (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(row, rangeEndRow));
                    if (isMovingLeft) {
                        this.isLeft = true;
                        cellComp.toggleCss("ag-selection-fill-left", column === colsToMark[0]);
                    } else cellComp.toggleCss("ag-selection-fill-right", column === (0, $437b23f6a393c3bf$export$236389741107357f)(colsToMark));
                }
                row = (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(beans, row);
            }while (!isLastRow);
        }
    }
    reduceHorizontal(initialPosition, endPosition) {
        const beans = this.beans;
        const { visibleCols: visibleCols } = beans;
        const allCols = visibleCols.allCols;
        const startCol = allCols.indexOf(endPosition.column);
        const endCol = allCols.indexOf(initialPosition.column);
        const colsToMark = allCols.slice(startCol, endCol);
        const { rangeStartRow: rangeStartRow, rangeEndRow: rangeEndRow } = this;
        for (const column of colsToMark){
            let row = rangeStartRow;
            let isLastRow = false;
            do {
                isLastRow = (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(row, rangeEndRow);
                const cell = (0, $437b23f6a393c3bf$export$1bd7ce47360c3c0)(this.beans, {
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned,
                    column: column
                });
                if (cell) {
                    this.markedCells.push(cell);
                    cell.comp.toggleCss("ag-selection-fill-right", column === colsToMark[0]);
                }
                row = (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(beans, row);
            }while (!isLastRow);
        }
    }
    refresh(cellCtrl) {
        const cellRange = this.beans.rangeSvc.getCellRanges()[0];
        const isColumnRange = !cellRange.startRow || !cellRange.endRow;
        if (isColumnRange) {
            this.destroy();
            return;
        }
        super.refresh(cellCtrl);
    }
};
var $5b7ccabde48fae90$var$AgRangeHandle = class extends $5b7ccabde48fae90$var$AbstractSelectionHandle {
    constructor(){
        super({
            tag: "div",
            cls: "ag-range-handle"
        });
        this.type = 1 /* RANGE */ ;
        this.rangeFixed = false;
    }
    onDrag(_) {
        const lastCellHovered = this.getLastCellHovered();
        if (!lastCellHovered) return;
        const rangeSvc = this.beans.rangeSvc;
        const cellRanges = rangeSvc.getCellRanges();
        const lastRange = (0, $437b23f6a393c3bf$export$236389741107357f)(cellRanges);
        if (!this.rangeFixed) {
            this.fixRangeStartEnd(lastRange);
            this.rangeFixed = true;
        }
        this.endPosition = {
            rowIndex: lastCellHovered.rowIndex,
            rowPinned: lastCellHovered.rowPinned,
            column: lastCellHovered.column
        };
        if (cellRanges.length === 2 && cellRanges[0].type === (0, $437b23f6a393c3bf$export$162bc75b85f28397).DIMENSION && lastRange.type === (0, $437b23f6a393c3bf$export$162bc75b85f28397).VALUE) {
            const rowChanged = !(0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(this.endPosition, rangeSvc.getRangeEndRow(lastRange));
            if (rowChanged) rangeSvc.updateRangeRowBoundary({
                cellRange: cellRanges[0],
                boundary: "end",
                cellPosition: {
                    ...this.endPosition,
                    column: cellRanges[0].columns[0]
                },
                silent: true
            });
        }
        rangeSvc.extendLatestRangeToCell(this.endPosition);
    }
    shouldSkipCell(_) {
        return false;
    }
    onDragEnd(_) {
        const cellRange = (0, $437b23f6a393c3bf$export$236389741107357f)(this.beans.rangeSvc.getCellRanges());
        this.fixRangeStartEnd(cellRange);
        this.rangeFixed = false;
    }
    onDragCancel() {
        this.rangeFixed = false;
    }
    fixRangeStartEnd(cellRange) {
        const rangeSvc = this.beans.rangeSvc;
        const startRow = rangeSvc.getRangeStartRow(cellRange);
        const endRow = rangeSvc.getRangeEndRow(cellRange);
        const column = cellRange.columns[0];
        cellRange.startRow = startRow;
        cellRange.endRow = endRow;
        cellRange.startColumn = column;
    }
};
// packages/ag-grid-enterprise/src/rangeSelection/rangeSelection.css-GENERATED.ts
var $5b7ccabde48fae90$var$rangeSelectionCSS = /*css*/ `.ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing),.ag-cell-range-selected.ag-cell-range-chart,.ag-cell-range-selected:not(.ag-cell-focus){background-color:var(--ag-range-selection-background-color);&.ag-cell-range-chart{background-color:var(--ag-range-selection-chart-background-color)!important;&.ag-cell-range-chart-category{background-color:var(--ag-range-selection-chart-category-background-color)!important}}}.ag-cell-range-selected-1.ag-cell-range-chart,.ag-cell-range-selected-1:not(.ag-cell-focus),.ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing){background-color:var(--ag-range-selection-background-color)}.ag-cell-range-selected-2.ag-cell-range-chart,.ag-cell-range-selected-2:not(.ag-cell-focus){background-image:linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color))}.ag-cell-range-selected-3.ag-cell-range-chart,.ag-cell-range-selected-3:not(.ag-cell-focus){background-image:linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color)),linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color))}.ag-cell-range-selected-4.ag-cell-range-chart,.ag-cell-range-selected-4:not(.ag-cell-focus){background-image:linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color)),linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color)),linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color))}.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell){&.ag-cell-range-top{border-top-color:var(--ag-range-selection-border-color);border-top-style:var(--ag-range-selection-border-style)}&.ag-cell-range-right{border-right-color:var(--ag-range-selection-border-color);border-right-style:var(--ag-range-selection-border-style)}&.ag-cell-range-bottom{border-bottom-color:var(--ag-range-selection-border-color);border-bottom-style:var(--ag-range-selection-border-style)}&.ag-cell-range-left{border-left-color:var(--ag-range-selection-border-color);border-left-style:var(--ag-range-selection-border-style)}}.ag-cell.ag-selection-fill-top,.ag-cell.ag-selection-fill-top.ag-cell-range-selected{border-top:1px dashed;border-top-color:var(--ag-range-selection-border-color)}:where(.ag-ltr) .ag-cell.ag-selection-fill-right,:where(.ag-ltr) .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-right:1px dashed var(--ag-range-selection-border-color)!important}:where(.ag-rtl) .ag-cell.ag-selection-fill-right,:where(.ag-rtl) .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-left:1px dashed var(--ag-range-selection-border-color)!important}.ag-cell.ag-selection-fill-bottom,.ag-cell.ag-selection-fill-bottom.ag-cell-range-selected{border-bottom:1px dashed;border-bottom-color:var(--ag-range-selection-border-color)}:where(.ag-ltr) .ag-cell.ag-selection-fill-left,:where(.ag-ltr) .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-left:1px dashed var(--ag-range-selection-border-color)!important}:where(.ag-rtl) .ag-cell.ag-selection-fill-left,:where(.ag-rtl) .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-right:1px dashed var(--ag-range-selection-border-color)!important}.ag-fill-handle,.ag-range-handle{background-color:var(--ag-range-selection-border-color);bottom:-1px;height:6px;position:absolute;width:6px}:where(.ag-ltr) .ag-fill-handle,:where(.ag-ltr) .ag-range-handle{right:-1px}:where(.ag-rtl) .ag-fill-handle,:where(.ag-rtl) .ag-range-handle{left:-1px}.ag-fill-handle{cursor:crosshair}:where(.ag-ltr) .ag-range-handle{cursor:nwse-resize}:where(.ag-rtl) .ag-range-handle{cursor:nesw-resize}`;
// packages/ag-grid-enterprise/src/rangeSelection/rangeSelectionApi.ts
function $5b7ccabde48fae90$var$getCellRanges(beans) {
    return beans.rangeSvc?.getCellRanges() ?? null;
}
function $5b7ccabde48fae90$var$addCellRange(beans, params) {
    beans.rangeSvc?.addCellRange(params);
}
function $5b7ccabde48fae90$var$clearRangeSelection(beans) {
    beans.rangeSvc?.removeAllCellRanges();
}
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED = "ag-cell-range-selected";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_CHART = "ag-cell-range-chart";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_SINGLE_CELL = "ag-cell-range-single-cell";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_CHART_CATEGORY = "ag-cell-range-chart-category";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_HANDLE = "ag-cell-range-handle";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_TOP = "ag-cell-range-top";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_RIGHT = "ag-cell-range-right";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_BOTTOM = "ag-cell-range-bottom";
var $5b7ccabde48fae90$var$CSS_CELL_RANGE_LEFT = "ag-cell-range-left";
function $5b7ccabde48fae90$var$_isRangeHandleEnabled(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return gos.get("enableRangeHandle");
    return typeof selection !== "boolean" ? selection.handle?.mode === "range" : false;
}
function $5b7ccabde48fae90$var$_isFillHandleEnabled(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return gos.get("enableFillHandle");
    return typeof selection !== "boolean" ? selection.handle?.mode === "fill" : false;
}
var $5b7ccabde48fae90$var$CellRangeFeature = class {
    constructor(beans, cellCtrl){
        this.beans = beans;
        this.cellCtrl = cellCtrl;
        this.rangeSvc = beans.rangeSvc;
    }
    setComp(cellComp) {
        this.cellComp = cellComp;
        this.eGui = this.cellCtrl.eGui;
        this.onCellSelectionChanged();
    }
    unsetComp() {
        this.beans.context.destroyBean(this.selectionHandle);
    }
    onCellSelectionChanged() {
        const cellComp = this.cellComp;
        if (!cellComp) return;
        const { rangeSvc: rangeSvc, cellCtrl: cellCtrl, eGui: eGui } = this;
        const rangeCount = rangeSvc.getCellRangeCount(cellCtrl.cellPosition);
        this.rangeCount = rangeCount;
        const hasChartRange = this.getHasChartRange();
        this.hasChartRange = hasChartRange;
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED, rangeCount !== 0);
        cellComp.toggleCss(`${$5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED}-1`, rangeCount === 1);
        cellComp.toggleCss(`${$5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED}-2`, rangeCount === 2);
        cellComp.toggleCss(`${$5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED}-3`, rangeCount === 3);
        cellComp.toggleCss(`${$5b7ccabde48fae90$var$CSS_CELL_RANGE_SELECTED}-4`, rangeCount >= 4);
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_CHART, hasChartRange);
        (0, $437b23f6a393c3bf$export$c22e3722e8a33469)(eGui, rangeCount > 0 ? true : void 0);
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_SINGLE_CELL, this.isSingleCell());
        this.updateRangeBorders();
        this.refreshHandle();
    }
    updateRangeBorders() {
        const rangeBorders = this.getRangeBorders();
        const isSingleCell = this.isSingleCell();
        const isTop = !isSingleCell && rangeBorders.top;
        const isRight = !isSingleCell && rangeBorders.right;
        const isBottom = !isSingleCell && rangeBorders.bottom;
        const isLeft = !isSingleCell && rangeBorders.left;
        const cellComp = this.cellComp;
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_TOP, isTop);
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_RIGHT, isRight);
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_BOTTOM, isBottom);
        cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_LEFT, isLeft);
    }
    isSingleCell() {
        const { rangeSvc: rangeSvc } = this;
        return this.rangeCount === 1 && !!rangeSvc && !rangeSvc.isMoreThanOneCell();
    }
    getHasChartRange() {
        const { rangeSvc: rangeSvc } = this;
        if (!this.rangeCount || !rangeSvc) return false;
        const cellRanges = rangeSvc.getCellRanges();
        return cellRanges.length > 0 && cellRanges.every((range)=>[
                (0, $437b23f6a393c3bf$export$162bc75b85f28397).DIMENSION,
                (0, $437b23f6a393c3bf$export$162bc75b85f28397).VALUE
            ].includes(range.type));
    }
    updateRangeBordersIfRangeCount() {
        if (this.rangeCount > 0) {
            this.updateRangeBorders();
            this.refreshHandle();
        }
    }
    getRangeBorders() {
        const isRtl = this.beans.gos.get("enableRtl");
        let top = false;
        let right = false;
        let bottom = false;
        let left = false;
        const { rangeSvc: rangeSvc, beans: { visibleCols: visibleCols }, cellCtrl: { cellPosition: cellPosition } } = this;
        const thisCol = cellPosition.column;
        const ranges = rangeSvc.getCellRanges().filter((range)=>rangeSvc.isCellInSpecificRange(cellPosition, range));
        if (!ranges.length) return {
            top: top,
            right: right,
            bottom: bottom,
            left: left
        };
        let leftCol;
        let rightCol;
        if (isRtl) {
            leftCol = visibleCols.getColAfter(thisCol);
            rightCol = visibleCols.getColBefore(thisCol);
        } else {
            leftCol = visibleCols.getColBefore(thisCol);
            rightCol = visibleCols.getColAfter(thisCol);
        }
        if (!leftCol) left = true;
        if (!rightCol) right = true;
        for(let i = 0; i < ranges.length; i++){
            if (top && right && bottom && left) break;
            const range = ranges[i];
            const startRow = rangeSvc.getRangeStartRow(range);
            const endRow = rangeSvc.getRangeEndRow(range);
            if (!top && (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(startRow, cellPosition)) top = true;
            if (!bottom && (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(endRow, cellPosition)) bottom = true;
            if (!left && leftCol && range.columns.indexOf(leftCol) < 0) left = true;
            if (!right && rightCol && range.columns.indexOf(rightCol) < 0) right = true;
        }
        return {
            top: top,
            right: right,
            bottom: bottom,
            left: left
        };
    }
    refreshHandle() {
        const { context: context } = this.beans;
        if (context.isDestroyed()) return;
        const shouldHaveSelectionHandle = this.shouldHaveSelectionHandle();
        if (this.selectionHandle && !shouldHaveSelectionHandle) this.selectionHandle = context.destroyBean(this.selectionHandle);
        if (shouldHaveSelectionHandle) this.addSelectionHandle();
        this.cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_HANDLE, !!this.selectionHandle);
    }
    shouldHaveSelectionHandle() {
        const { gos: gos, editSvc: editSvc } = this.beans;
        const rangeSvc = this.rangeSvc;
        const cellRanges = rangeSvc.getCellRanges();
        const rangesLen = cellRanges.length;
        if (this.rangeCount < 1 || rangesLen < 1) return false;
        const cellRange = (0, $437b23f6a393c3bf$export$236389741107357f)(cellRanges);
        const { cellPosition: cellPosition, column: column } = this.cellCtrl;
        const isFillHandleAvailable = $5b7ccabde48fae90$var$_isFillHandleEnabled(gos) && !column.isSuppressFillHandle();
        const isRangeHandleAvailable = $5b7ccabde48fae90$var$_isRangeHandleEnabled(gos);
        const isCellEditing = editSvc?.isEditing(this.cellCtrl, {
            withOpenEditor: true
        });
        let handleIsAvailable = rangesLen === 1 && !isCellEditing && (isFillHandleAvailable || isRangeHandleAvailable);
        if (this.hasChartRange) {
            const hasCategoryRange = cellRanges[0].type === (0, $437b23f6a393c3bf$export$162bc75b85f28397).DIMENSION;
            const isCategoryCell = hasCategoryRange && rangeSvc.isCellInSpecificRange(cellPosition, cellRanges[0]);
            this.cellComp.toggleCss($5b7ccabde48fae90$var$CSS_CELL_RANGE_CHART_CATEGORY, isCategoryCell);
            handleIsAvailable = cellRange.type === (0, $437b23f6a393c3bf$export$162bc75b85f28397).VALUE;
        }
        return handleIsAvailable && cellRange.endRow != null && rangeSvc.isContiguousRange(cellRange) && rangeSvc.isBottomRightCell(cellRange, cellPosition);
    }
    addSelectionHandle() {
        const { beans: beans, rangeSvc: rangeSvc } = this;
        const cellRangeType = (0, $437b23f6a393c3bf$export$236389741107357f)(rangeSvc.getCellRanges()).type;
        const selectionHandleFill = $5b7ccabde48fae90$var$_isFillHandleEnabled(beans.gos) && (0, $437b23f6a393c3bf$export$672d9e47bc342bac)(cellRangeType);
        const type = selectionHandleFill ? 0 /* FILL */  : 1 /* RANGE */ ;
        if (this.selectionHandle && this.selectionHandle.getType() !== type) this.selectionHandle = beans.context.destroyBean(this.selectionHandle);
        if (!this.selectionHandle) {
            const selectionHandle = beans.registry.createDynamicBean(type === 0 /* FILL */  ? "fillHandle" : "rangeHandle", false);
            if (selectionHandle) this.selectionHandle = beans.context.createBean(selectionHandle);
        }
        this.selectionHandle?.refresh(this.cellCtrl);
    }
    destroy() {
        this.unsetComp();
    }
};
var $5b7ccabde48fae90$var$DragListenerFeature = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(eContainer){
        super();
        this.eContainer = eContainer;
    }
    postConstruct() {
        const { beans: beans, gos: gos, eContainer: eContainer } = this;
        const rangeSvc = beans.rangeSvc;
        const params = {
            eElement: eContainer,
            onDragStart: rangeSvc.onDragStart.bind(rangeSvc),
            onDragStop: rangeSvc.onDragStop.bind(rangeSvc),
            onDragging: rangeSvc.onDragging.bind(rangeSvc)
        };
        const dragSvc = beans.dragSvc;
        const enableFeature = dragSvc.addDragSource.bind(dragSvc, params);
        const disableFeature = dragSvc.removeDragSource.bind(dragSvc, params);
        this.addManagedPropertyListeners([
            "enableRangeSelection",
            "cellSelection"
        ], ()=>{
            if ((0, $437b23f6a393c3bf$export$1f7ca6920544d9e4)(gos)) enableFeature();
            else disableFeature();
        });
        this.addDestroyFunc(disableFeature);
        if ((0, $437b23f6a393c3bf$export$1f7ca6920544d9e4)(gos)) enableFeature();
    }
};
var $5b7ccabde48fae90$var$HeaderGroupCellMouseListenerFeature = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(column, eGui){
        super();
        this.column = column;
        this.eGui = eGui;
    }
    postConstruct() {
        this.addManagedElementListeners(this.eGui, {
            click: (e)=>e && this.onClick(e)
        });
    }
    onClick(event) {
        this.beans.rangeSvc?.handleColumnSelection(this.column, event);
    }
};
var $5b7ccabde48fae90$var$RangeHeaderHighlightFeature = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(column, comp){
        super();
        this.column = column;
        this.comp = comp;
        this.columnMap = /* @__PURE__ */ new Map();
        this.isActive = false;
        this.resetColumnMap();
    }
    postConstruct() {
        this.addManagedPropertyListener("cellSelection", ()=>{
            this.refreshActive();
        });
        this.refreshActive();
        this.setupRangeHeaderHighlight();
    }
    resetColumnMap() {
        this.columnMap.clear();
        let columns;
        if (this.column.isColumn) columns = [
            this.column
        ];
        else columns = this.column.getDisplayedLeafColumns();
        for (const column of columns)this.columnMap.set(column, false);
    }
    refreshActive() {
        const { gos: gos, rangeSvc: rangeSvc } = this.beans;
        const selection = gos.get("cellSelection");
        this.isActive = !!(selection && rangeSvc && typeof selection === "object" && selection.enableHeaderHighlight);
    }
    setupRangeHeaderHighlight() {
        const listener = this.onRangeSelectionChanged.bind(this);
        this.addManagedEventListeners({
            rangeSelectionChanged: listener,
            columnPinned: listener,
            columnMoved: listener,
            columnGroupOpened: listener
        });
        listener();
    }
    onRangeSelectionChanged() {
        if (!this.isActive) return;
        this.resetColumnMap();
        const ranges = this.beans.rangeSvc.getCellRanges();
        let hasRange = false;
        let isAllColumnRange = true;
        for (const range of ranges){
            if (hasRange) break;
            for (const column of range.columns)if (this.columnMap.has(column)) {
                this.columnMap.set(column, true);
                hasRange || (hasRange = true);
            }
        }
        for (const value of Array.from(this.columnMap.values()))if (value === false) {
            isAllColumnRange = false;
            break;
        }
        this.comp.toggleCss("ag-header-range-highlight", hasRange && isAllColumnRange);
    }
    destroy() {
        super.destroy();
        this.comp = null;
        this.column = null;
    }
};
// packages/ag-grid-enterprise/src/rangeSelection/rangeService.ts
var $5b7ccabde48fae90$var$RangeService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "rangeSvc";
        this.cellRanges = [];
        this.bodyScrollListener = this.onBodyScroll.bind(this);
        this.dragging = false;
        /** When dragging ends, the current range will be used to intersect all other ranges */ this.intersectionRange = false;
        this.columnRangeSelectionCtx = {};
    }
    wireBeans(beans) {
        this.rowModel = beans.rowModel;
        this.dragSvc = beans.dragSvc;
        this.colModel = beans.colModel;
        this.visibleCols = beans.visibleCols;
        this.cellNavigation = beans.cellNavigation;
        this.ctrlsSvc = beans.ctrlsSvc;
        this.valueSvc = beans.valueSvc;
    }
    postConstruct() {
        const onColumnsChanged = this.onColumnsChanged.bind(this);
        const removeAllCellRanges = ()=>this.removeAllCellRanges();
        const refreshLastRangeStart = this.refreshLastRangeStart.bind(this);
        this.addManagedEventListeners({
            newColumnsLoaded: onColumnsChanged,
            columnVisible: onColumnsChanged,
            columnValueChanged: onColumnsChanged,
            columnPivotModeChanged: removeAllCellRanges,
            columnRowGroupChanged: removeAllCellRanges,
            columnPivotChanged: removeAllCellRanges,
            columnGroupOpened: refreshLastRangeStart,
            columnMoved: refreshLastRangeStart,
            columnPinned: refreshLastRangeStart
        });
        this.ctrlsSvc.whenReady(this, (p)=>{
            const gridBodyCtrl = p.gridBodyCtrl;
            this.autoScrollService = new (0, $437b23f6a393c3bf$export$c66bdc3d55a4f95)({
                scrollContainer: gridBodyCtrl.eBodyViewport,
                scrollAxis: "xy",
                getVerticalPosition: ()=>gridBodyCtrl.scrollFeature.getVScrollPosition().top,
                setVerticalPosition: (position)=>gridBodyCtrl.scrollFeature.setVerticalScrollPosition(position),
                getHorizontalPosition: ()=>gridBodyCtrl.scrollFeature.getHScrollPosition().left,
                setHorizontalPosition: (position)=>gridBodyCtrl.scrollFeature.setHorizontalScrollPosition(position),
                shouldSkipVerticalScroll: ()=>!(0, $437b23f6a393c3bf$export$aa3ea9d0da61306f)(this.gos, "normal"),
                shouldSkipHorizontalScroll: ()=>!gridBodyCtrl.scrollFeature.isHorizontalScrollShowing()
            });
        });
    }
    // Drag And Drop Target Methods
    onDragStart(mouseEvent) {
        const gos = this.gos;
        if (!(0, $437b23f6a393c3bf$export$1f7ca6920544d9e4)(gos) || (0, $437b23f6a393c3bf$export$d06ffa2f01e3cdc7)(gos, mouseEvent.target)?.isSuppressMouseEvent(mouseEvent)) return;
        const { ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = mouseEvent;
        const isMultiKey = ctrlKey || metaKey;
        const allowMulti = !(0, $437b23f6a393c3bf$export$93073c0b97dd7eba)(gos);
        const isMultiSelect = allowMulti ? isMultiKey : false;
        const extendRange = shiftKey && !!this.cellRanges?.length;
        if (!isMultiSelect && (!extendRange || (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)((0, $437b23f6a393c3bf$export$236389741107357f)(this.cellRanges).type))) this.removeAllCellRanges(true);
        const startTarget = this.dragSvc.startTarget;
        if (startTarget) this.updateValuesOnMove(startTarget);
        if (!this.lastCellHovered) return;
        this.dragging = true;
        this.lastMouseEvent = mouseEvent;
        this.intersectionRange = isMultiSelect && this.getCellRangeCount(this.lastCellHovered) > 1;
        if (!extendRange) this.setNewestRangeStartCell(this.lastCellHovered);
        if (this.cellRanges.length > 0) this.draggingRange = (0, $437b23f6a393c3bf$export$236389741107357f)(this.cellRanges);
        else {
            const mouseRowPosition = {
                rowIndex: this.lastCellHovered.rowIndex,
                rowPinned: this.lastCellHovered.rowPinned
            };
            const columns = this.getColumnsFromModel([
                this.lastCellHovered.column
            ]);
            if (!columns?.length) return;
            this.draggingRange = {
                startRow: mouseRowPosition,
                endRow: mouseRowPosition,
                columns: columns,
                startColumn: this.newestRangeStartCell.column
            };
            this.cellRanges.push(this.draggingRange);
        }
        this.ctrlsSvc.getGridBodyCtrl().eBodyViewport.addEventListener("scroll", this.bodyScrollListener, {
            passive: true
        });
        this.dispatchChangedEvent(true, false, this.draggingRange.id);
    }
    onDragging(mouseEvent) {
        const { dragging: dragging, lastCellHovered: lastCellHovered, newestRangeStartCell: newestRangeStartCell, autoScrollService: autoScrollService, cellHasChanged: cellHasChanged } = this;
        if (!dragging || !mouseEvent) return;
        this.updateValuesOnMove(mouseEvent.target);
        this.lastMouseEvent = mouseEvent;
        const isMouseAndStartInPinned = (position)=>lastCellHovered && lastCellHovered.rowPinned === position && newestRangeStartCell.rowPinned === position;
        const skipVerticalScroll = isMouseAndStartInPinned("top") || isMouseAndStartInPinned("bottom");
        autoScrollService.check(mouseEvent, skipVerticalScroll);
        if (!cellHasChanged || !lastCellHovered) return;
        const startColumn = newestRangeStartCell?.column;
        const currentColumn = lastCellHovered?.column;
        const columns = this.calculateColumnsBetween(startColumn, currentColumn);
        if (!columns) return;
        const { rowIndex: rowIndex, rowPinned: rowPinned } = lastCellHovered;
        this.draggingRange.endRow = {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
        this.draggingRange.columns = columns;
        this.dispatchChangedEvent(false, false, this.draggingRange.id);
    }
    onDragStop() {
        if (!this.dragging) return;
        const { id: id } = this.draggingRange;
        this.autoScrollService.ensureCleared();
        this.ctrlsSvc.getGridBodyCtrl().eBodyViewport.removeEventListener("scroll", this.bodyScrollListener);
        this.lastMouseEvent = null;
        this.dragging = false;
        this.draggingRange = void 0;
        this.lastCellHovered = void 0;
        if (this.intersectionRange) {
            this.intersectionRange = false;
            this.intersectLastRange();
        }
        this.dispatchChangedEvent(false, true, id);
    }
    // Called for both columns loaded & column visibility events
    onColumnsChanged() {
        this.refreshLastRangeStart();
        const allColumns = this.visibleCols.allCols;
        for (const cellRange of this.cellRanges){
            const beforeCols = cellRange.columns;
            cellRange.columns = cellRange.columns.filter((col)=>col.isVisible() && allColumns.indexOf(col) !== -1);
            const colsInRangeChanged = !(0, $437b23f6a393c3bf$export$893967cdb9833fdd)(beforeCols, cellRange.columns);
            if (colsInRangeChanged) this.dispatchChangedEvent(false, true, cellRange.id);
        }
        const countBefore = this.cellRanges.length;
        this.cellRanges = this.cellRanges.filter((range)=>range.columns.length > 0);
        if (countBefore > this.cellRanges.length) this.dispatchChangedEvent(false, true);
    }
    refreshLastRangeStart() {
        const lastRange = (0, $437b23f6a393c3bf$export$236389741107357f)(this.cellRanges);
        if (!lastRange) return;
        this.refreshRangeStart(lastRange);
    }
    isContiguousRange(cellRange) {
        const rangeColumns = cellRange.columns;
        if (!rangeColumns.length) return false;
        const allColumns = this.visibleCols.allCols;
        const allPositions = rangeColumns.map((c)=>allColumns.indexOf(c)).sort((a, b)=>a - b);
        return (0, $437b23f6a393c3bf$export$236389741107357f)(allPositions) - allPositions[0] + 1 === rangeColumns.length;
    }
    getRangeStartRow(cellRange) {
        if (cellRange.startRow && cellRange.endRow) return (0, $437b23f6a393c3bf$export$6cce97428a227a31)(cellRange.startRow, cellRange.endRow) ? cellRange.startRow : cellRange.endRow;
        const pinnedTopRowCount = this.beans.pinnedRowModel?.getPinnedTopRowCount() ?? 0;
        const rowPinned = pinnedTopRowCount > 0 ? "top" : null;
        return {
            rowIndex: 0,
            rowPinned: rowPinned
        };
    }
    getRangeEndRow(cellRange) {
        if (cellRange.startRow && cellRange.endRow) return (0, $437b23f6a393c3bf$export$6cce97428a227a31)(cellRange.startRow, cellRange.endRow) ? cellRange.endRow : cellRange.startRow;
        const pinnedBottomRowCount = this.beans.pinnedRowModel?.getPinnedBottomRowCount() ?? 0;
        const pinnedBottom = pinnedBottomRowCount > 0;
        if (pinnedBottom) return {
            rowIndex: pinnedBottomRowCount - 1,
            rowPinned: "bottom"
        };
        return {
            rowIndex: this.rowModel.getRowCount() - 1,
            rowPinned: null
        };
    }
    getRangeRowCount(cellRange) {
        const beans = this.beans;
        const start = this.getRangeStartRow(cellRange);
        const end = this.getRangeEndRow(cellRange);
        const startIndex = (0, $437b23f6a393c3bf$export$5d5d8b440c4b4c91)(beans, start);
        const endIndex = (0, $437b23f6a393c3bf$export$5d5d8b440c4b4c91)(beans, end);
        return endIndex - startIndex + 1;
    }
    handleCellMouseDown(event, cell) {
        const { beans: beans } = this;
        const isRowNumber = (0, $437b23f6a393c3bf$export$3d3e7d751f0445eb)(cell.column);
        if (isRowNumber) event.preventDefault();
        if (event.shiftKey) return this.extendLatestRangeToCell(cell);
        if (isRowNumber && (0, $437b23f6a393c3bf$export$f8093014f10b296a)(beans, event)) return;
        const isMultiKey = event.ctrlKey || event.metaKey;
        this.setSelectionMode(isRowNumber);
        const columns = this.calculateColumnsBetween(cell.column, cell.column);
        if (!columns) return;
        const containingRange = this.findContainingRange({
            columns: columns,
            startRow: cell,
            endRow: cell
        });
        if (isRowNumber && isMultiKey && containingRange) this.removeRowFromRowNumberRange(cell, containingRange);
        else this.setRangeToCell(cell, isMultiKey);
    }
    removeRowFromRowNumberRange(cell, containingRange) {
        const { beans: beans, cellRanges: cellRanges } = this;
        const firstRow = (0, $437b23f6a393c3bf$export$124b4386b662b699)(beans);
        const lastRow = (0, $437b23f6a393c3bf$export$a1449222017e428)(beans);
        const startRow = this.getRangeStartRow(containingRange);
        const endRow = this.getRangeEndRow(containingRange);
        if (!startRow && (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(firstRow, cell)) $5b7ccabde48fae90$var$replaceEdgeRow(containingRange, (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(beans, firstRow), "top");
        else if (!endRow && (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(lastRow, cell)) $5b7ccabde48fae90$var$replaceEdgeRow(containingRange, (0, $437b23f6a393c3bf$export$b36b14fdaf41f4d8)(beans, lastRow), "bottom");
        else if ((0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(startRow, endRow)) (0, $437b23f6a393c3bf$export$83a881c8b5120679)(cellRanges, containingRange);
        else if ((0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(startRow, cell)) $5b7ccabde48fae90$var$replaceEdgeRow(containingRange, (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(beans, cell), "top");
        else if ((0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(endRow, cell)) $5b7ccabde48fae90$var$replaceEdgeRow(containingRange, (0, $437b23f6a393c3bf$export$b36b14fdaf41f4d8)(beans, cell), "bottom");
        else {
            const rowAbove = (0, $437b23f6a393c3bf$export$b36b14fdaf41f4d8)(beans, cell);
            const rowBelow = (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(beans, cell);
            containingRange.startRow = startRow;
            containingRange.endRow = rowAbove ?? void 0;
            cellRanges.push({
                ...containingRange,
                startRow: rowBelow ?? void 0,
                endRow: endRow
            });
        }
        this.dispatchChangedEvent(true, true);
    }
    setRangeToCell(cell, appendRange = false) {
        const { gos: gos, beans: beans } = this;
        if (!(0, $437b23f6a393c3bf$export$1f7ca6920544d9e4)(gos)) return;
        const isRowNumbersEnabled = (0, $437b23f6a393c3bf$export$58f4eed4127eb370)(beans);
        if (isRowNumbersEnabled) {
            const allColumnsRange = (0, $437b23f6a393c3bf$export$3d3e7d751f0445eb)(cell.column);
            this.setSelectionMode(allColumnsRange);
        }
        const columns = this.calculateColumnsBetween(cell.column, cell.column);
        if (!columns) return;
        const suppressMultiRangeSelections = (0, $437b23f6a393c3bf$export$93073c0b97dd7eba)(gos);
        if (suppressMultiRangeSelections || !appendRange || (0, $437b23f6a393c3bf$export$672d9e47bc342bac)(this.cellRanges)) this.removeAllCellRanges(true);
        const rowForCell = {
            rowIndex: cell.rowIndex,
            rowPinned: cell.rowPinned
        };
        const cellRange = {
            startRow: rowForCell,
            endRow: rowForCell,
            columns: columns,
            startColumn: cell.column
        };
        this.cellRanges.push(cellRange);
        this.setNewestRangeStartCell(cell);
        this.onDragStop();
        this.dispatchChangedEvent(true, true);
    }
    getRangeLastColumn(cellRange) {
        const firstCol = cellRange.columns[0];
        const lastCol = (0, $437b23f6a393c3bf$export$236389741107357f)(cellRange.columns);
        return this.newestRangeStartCell?.column === firstCol ? lastCol : firstCol;
    }
    extendRangeRowCountBy(cellRange, targetCount) {
        const { beans: beans } = this;
        const { startRow: startRow, endRow: endRow } = cellRange;
        if (!startRow || !endRow) return;
        let stepsMoved = 0;
        let currentRow;
        const isBottomUp = (0, $437b23f6a393c3bf$export$6cce97428a227a31)(endRow, startRow);
        if (isBottomUp) currentRow = startRow;
        else currentRow = endRow;
        const stepFn = targetCount > 0 ? (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1) : (0, $437b23f6a393c3bf$export$b36b14fdaf41f4d8);
        const stepCount = Math.abs(targetCount);
        while(stepsMoved < stepCount){
            const nextRow = stepFn(beans, currentRow);
            if (!nextRow) break;
            currentRow = nextRow;
            stepsMoved++;
        }
        if (stepsMoved !== stepCount) return;
        const cellPosition = {
            ...currentRow,
            column: this.getRangeLastColumn(cellRange)
        };
        this.updateRangeRowBoundary({
            cellRange: cellRange,
            boundary: isBottomUp ? "start" : "end",
            cellPosition: cellPosition
        });
    }
    extendRangeColumnCountBy(cellRange, delta) {
        const { columns: columns, startColumn: startColumn } = cellRange;
        if (delta === 0) return;
        const allColumns = this.getColumnsFromModel();
        if (!allColumns) return;
        const lastColumn = (0, $437b23f6a393c3bf$export$236389741107357f)(columns);
        const endColumn = startColumn === columns[0] ? lastColumn : columns[0];
        if (!lastColumn || !endColumn) return;
        let startIdx = allColumns.indexOf(startColumn);
        const endIdx = allColumns.indexOf(endColumn);
        const isRtlRange = endIdx < startIdx;
        if (isRtlRange) startIdx = endIdx;
        const currentLength = columns.length;
        const targetLength = currentLength + delta;
        if (targetLength <= 0) return;
        const newColumns = [];
        for(let i = startIdx; i < startIdx + targetLength; i++){
            const col = allColumns[i];
            if (!col) break;
            newColumns.push(col);
        }
        if (newColumns.length === targetLength) {
            if (isRtlRange) {
                const newColumnToFocus = (0, $437b23f6a393c3bf$export$236389741107357f)(newColumns);
                cellRange.startColumn = newColumnToFocus;
                this.focusCellOnNewColumn(cellRange, newColumnToFocus);
            }
            cellRange.columns = newColumns;
            this.dispatchChangedEvent(true, true, cellRange.id);
        }
    }
    extendLatestRangeToCell(cellPosition) {
        if (this.isEmpty() || !this.newestRangeStartCell) return;
        const cellRange = (0, $437b23f6a393c3bf$export$236389741107357f)(this.cellRanges);
        this.setSelectionMode((0, $437b23f6a393c3bf$export$3d3e7d751f0445eb)(cellPosition.column));
        this.updateRangeRowBoundary({
            cellRange: cellRange,
            boundary: "end",
            cellPosition: cellPosition
        });
    }
    updateRangeRowBoundary(params) {
        const { cellRange: cellRange, boundary: boundary, cellPosition: cellPosition, silent: silent = false } = params;
        const endColumn = cellPosition.column;
        const colsToAdd = this.calculateColumnsBetween(cellRange.startColumn, endColumn);
        if (!colsToAdd || $5b7ccabde48fae90$var$isLastCellOfRange(cellRange, cellPosition)) return;
        if (boundary === "start") this.focusCellOnNewRow(cellRange, cellPosition);
        cellRange.columns = colsToAdd;
        cellRange[boundary === "start" ? "startRow" : "endRow"] = {
            rowIndex: cellPosition.rowIndex,
            rowPinned: cellPosition.rowPinned
        };
        if (!silent) this.dispatchChangedEvent(true, true, cellRange.id);
    }
    getRangeEdgeColumns(cellRange) {
        const allColumns = this.visibleCols.allCols;
        const allIndices = cellRange.columns.map((c)=>allColumns.indexOf(c)).filter((i)=>i > -1).sort((a, b)=>a - b);
        return {
            left: allColumns[allIndices[0]],
            right: allColumns[(0, $437b23f6a393c3bf$export$236389741107357f)(allIndices)]
        };
    }
    // returns true if successful, false if not successful
    extendLatestRangeInDirection(event) {
        if (this.isEmpty() || !this.newestRangeStartCell) return;
        const key = event.key;
        const ctrlKey = event.ctrlKey || event.metaKey;
        const lastRange = (0, $437b23f6a393c3bf$export$236389741107357f)(this.cellRanges);
        const startCell = this.newestRangeStartCell;
        const endCellIndex = lastRange.endRow.rowIndex;
        const endCellFloating = lastRange.endRow.rowPinned;
        const endCellColumn = this.getRangeLastColumn(lastRange);
        const endCell = {
            column: endCellColumn,
            rowIndex: endCellIndex,
            rowPinned: endCellFloating
        };
        const newEndCell = this.cellNavigation.getNextCellToFocus(key, endCell, ctrlKey);
        if (!newEndCell) return;
        this.setCellRange({
            rowStartIndex: startCell.rowIndex,
            rowStartPinned: startCell.rowPinned,
            rowEndIndex: newEndCell.rowIndex,
            rowEndPinned: newEndCell.rowPinned,
            columnStart: startCell.column,
            columnEnd: newEndCell.column
        });
        return newEndCell;
    }
    setCellRange(params) {
        if (!(0, $437b23f6a393c3bf$export$1f7ca6920544d9e4)(this.gos)) return;
        this.removeAllCellRanges(true);
        this.addCellRange(params);
    }
    setCellRanges(cellRanges) {
        if ((0, $437b23f6a393c3bf$export$893967cdb9833fdd)(this.cellRanges, cellRanges)) return;
        if (!this.verifyCellRanges(this.gos)) return;
        this.removeAllCellRanges(true);
        for (const cellRange of cellRanges){
            if (cellRange.columns && cellRange.startRow) {
                const columns = this.getColumnsFromModel(cellRange.columns);
                if (!columns || columns.length === 0) continue;
                cellRange.columns = columns;
                const { startRow: startRow } = cellRange;
                this.setNewestRangeStartCell({
                    rowIndex: startRow.rowIndex,
                    rowPinned: startRow.rowPinned,
                    column: cellRange.columns[0]
                });
            }
            this.cellRanges.push(cellRange);
        }
        this.dispatchChangedEvent(false, true);
    }
    clearCellRangeCellValues(params) {
        const { beans: beans, valueSvc: valueSvc, eventSvc: eventSvc } = this;
        const { cellEventSource: cellEventSource = "rangeSvc", dispatchWrapperEvents: dispatchWrapperEvents, wrapperEventSource: wrapperEventSource = "deleteKey" } = params;
        let { cellRanges: cellRanges } = params;
        if (dispatchWrapperEvents) {
            eventSvc.dispatchEvent({
                type: "cellSelectionDeleteStart",
                source: wrapperEventSource
            });
            eventSvc.dispatchEvent({
                type: "rangeDeleteStart",
                source: wrapperEventSource
            });
        }
        if (!cellRanges) cellRanges = this.cellRanges;
        for (const cellRange of cellRanges)this.forEachRowInRange(cellRange, (rowPosition)=>{
            const rowNode = (0, $437b23f6a393c3bf$export$d4675a60917db7b0)(beans, rowPosition);
            if (!rowNode) return;
            for(let i = 0; i < cellRange.columns.length; i++){
                const column = this.getColumnFromModel(cellRange.columns[i]);
                if (!column?.isCellEditable(rowNode)) continue;
                const emptyValue = valueSvc.getDeleteValue(column, rowNode);
                rowNode.setDataValue(column, emptyValue, cellEventSource);
            }
        });
        if (dispatchWrapperEvents) {
            eventSvc.dispatchEvent({
                type: "cellSelectionDeleteEnd",
                source: wrapperEventSource
            });
            eventSvc.dispatchEvent({
                type: "rangeDeleteEnd",
                source: wrapperEventSource
            });
        }
    }
    createCellRangeFromCellRangeParams(params) {
        return this.createPartialCellRangeFromRangeParams(params, false);
    }
    // Range service can't normally support a range without columns, but charts can
    createPartialCellRangeFromRangeParams(params, allowEmptyColumns) {
        const { columns: paramColumns, columnStart: columnStart, columnEnd: columnEnd, rowStartIndex: rowStartIndex, rowStartPinned: rowStartPinned, rowEndIndex: rowEndIndex, rowEndPinned: rowEndPinned } = params;
        const columnInfo = this.getColumnsFromParams(paramColumns, columnStart, columnEnd);
        if (!columnInfo || !allowEmptyColumns && columnInfo.columns.length === 0) return;
        const { columns: columns, startsOnTheRight: startsOnTheRight } = columnInfo;
        const startRow = $5b7ccabde48fae90$var$createRowPosition(rowStartIndex, rowStartPinned);
        const endRow = $5b7ccabde48fae90$var$createRowPosition(rowEndIndex, rowEndPinned);
        return {
            startRow: startRow,
            endRow: endRow,
            columns: columns,
            startColumn: this.getColumnFromModel(columnStart) ?? (startsOnTheRight ? (0, $437b23f6a393c3bf$export$236389741107357f)(columns) : columns[0])
        };
    }
    addCellRange(params) {
        const gos = this.gos;
        if (!(0, $437b23f6a393c3bf$export$1f7ca6920544d9e4)(gos) || !this.verifyCellRanges(gos)) return;
        this.setSelectionMode(false);
        const newRange = this.createCellRangeFromCellRangeParams(params);
        if (newRange) {
            if (newRange.startRow) this.setNewestRangeStartCell({
                rowIndex: newRange.startRow.rowIndex,
                rowPinned: newRange.startRow.rowPinned,
                column: newRange.startColumn
            });
            this.cellRanges.push(newRange);
            this.dispatchChangedEvent(false, true, newRange.id);
            return newRange;
        }
    }
    getCellRanges() {
        return this.cellRanges;
    }
    isEmpty() {
        return this.cellRanges.length === 0;
    }
    isMoreThanOneCell() {
        const len = this.cellRanges.length;
        if (len === 0) return false;
        if (len > 1) return true;
        const range = this.cellRanges[0];
        const startRow = this.getRangeStartRow(range);
        const endRow = this.getRangeEndRow(range);
        return startRow.rowPinned !== endRow.rowPinned || startRow.rowIndex !== endRow.rowIndex || range.columns.length !== 1;
    }
    areAllRangesAbleToMerge() {
        const rowToColumnMap = /* @__PURE__ */ new Map();
        const len = this.cellRanges.length;
        if (len <= 1) return true;
        for (const range of this.cellRanges)this.forEachRowInRange(range, (row)=>{
            const rowName = `${row.rowPinned || "normal"}_${row.rowIndex}`;
            const columns = rowToColumnMap.get(rowName);
            const currentRangeColIds = range.columns.map((col)=>col.getId());
            if (columns) {
                const filteredColumns = currentRangeColIds.filter((col)=>columns.indexOf(col) === -1);
                columns.push(...filteredColumns);
            } else rowToColumnMap.set(rowName, currentRangeColIds);
        });
        let columnsString;
        for (const val of rowToColumnMap.values()){
            const currentValString = val.sort().join();
            if (columnsString === void 0) {
                columnsString = currentValString;
                continue;
            }
            if (columnsString !== currentValString) return false;
        }
        return true;
    }
    removeAllCellRanges(silent) {
        if (this.isEmpty()) return;
        this.onDragStop();
        this.cellRanges.length = 0;
        if (!silent) this.dispatchChangedEvent(false, true);
    }
    isCellInAnyRange(cell) {
        return this.getCellRangeCount(cell) > 0;
    }
    isCellInSpecificRange(cell, range) {
        const columnInRange = range.columns?.includes(cell.column);
        const rowInRange = this.isRowInRange(cell, range);
        return columnInRange && rowInRange;
    }
    isColumnInAnyRange(column) {
        const { beans: beans } = this;
        const firstRow = (0, $437b23f6a393c3bf$export$124b4386b662b699)(beans);
        const lastRow = (0, $437b23f6a393c3bf$export$a1449222017e428)(beans);
        if (!firstRow || !lastRow) return false;
        const columns = column.isColumn ? [
            column
        ] : column.getDisplayedLeafColumns();
        return this.findContainingRange({
            columns: columns,
            startRow: firstRow,
            endRow: lastRow
        }, true) != null;
    }
    findContainingRange({ columns: columns, startRow: startRow, endRow: endRow }, matchOnly = false) {
        const ranges = this.cellRanges;
        for(let i = ranges.length - 1; i >= 0; i--){
            const range = ranges[i];
            const hasCols = columns.every((c)=>range.columns.includes(c));
            let condition = false;
            if (matchOnly) condition = (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(range.startRow, startRow) && (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(range.endRow, endRow);
            else {
                const isStartBeforeOrEqual = startRow && this.isRowInRange(startRow, range);
                const isEndAfterOrEqual = endRow && this.isRowInRange(endRow, range);
                condition = !!isStartBeforeOrEqual && !!isEndAfterOrEqual;
            }
            if (hasCols && condition) return range;
        }
    }
    isBottomRightCell(cellRange, cell) {
        const allColumns = this.visibleCols.allCols;
        const allPositions = cellRange.columns.map((c)=>allColumns.indexOf(c)).sort((a, b)=>a - b);
        const { startRow: startRow, endRow: endRow } = cellRange;
        const lastRow = (0, $437b23f6a393c3bf$export$6cce97428a227a31)(startRow, endRow) ? endRow : startRow;
        const isRightColumn = allColumns.indexOf(cell.column) === (0, $437b23f6a393c3bf$export$236389741107357f)(allPositions);
        const isLastRow = cell.rowIndex === lastRow.rowIndex && (0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(cell.rowPinned) === (0, $437b23f6a393c3bf$export$4978424c4f7b5fc0)(lastRow.rowPinned);
        return isRightColumn && isLastRow;
    }
    // returns the number of ranges this cell is in
    getCellRangeCount(cell) {
        return this.cellRanges.filter((cellRange)=>this.isCellInSpecificRange(cell, cellRange)).length;
    }
    isRowInRange(thisRow, cellRange) {
        const firstRow = this.getRangeStartRow(cellRange);
        const lastRow = this.getRangeEndRow(cellRange);
        const equalsFirstRow = (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(thisRow, firstRow);
        const equalsLastRow = (0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(thisRow, lastRow);
        if (equalsFirstRow || equalsLastRow) return true;
        const afterFirstRow = !(0, $437b23f6a393c3bf$export$6cce97428a227a31)(thisRow, firstRow);
        const beforeLastRow = (0, $437b23f6a393c3bf$export$6cce97428a227a31)(thisRow, lastRow);
        return afterFirstRow && beforeLastRow;
    }
    intersectLastRange(fromMouseClick) {
        if (fromMouseClick && this.dragging) return;
        if ((0, $437b23f6a393c3bf$export$93073c0b97dd7eba)(this.gos)) return;
        if (this.isEmpty()) return;
        const lastRange = (0, $437b23f6a393c3bf$export$236389741107357f)(this.cellRanges);
        const intersectionStartRow = this.getRangeStartRow(lastRange);
        const intersectionEndRow = this.getRangeEndRow(lastRange);
        const newRanges = [];
        for (const range of this.cellRanges.slice(0, -1)){
            const startRow = this.getRangeStartRow(range);
            const endRow = this.getRangeEndRow(range);
            const cols = range.columns;
            const intersectCols = cols.filter((col)=>lastRange.columns.indexOf(col) === -1);
            if (intersectCols.length === cols.length) {
                newRanges.push(range);
                continue;
            }
            if ((0, $437b23f6a393c3bf$export$6cce97428a227a31)(intersectionEndRow, startRow) || (0, $437b23f6a393c3bf$export$6cce97428a227a31)(endRow, intersectionStartRow)) {
                newRanges.push(range);
                continue;
            }
            const rangeCountBefore = newRanges.length;
            if ((0, $437b23f6a393c3bf$export$6cce97428a227a31)(startRow, intersectionStartRow)) {
                const top = {
                    columns: [
                        ...cols
                    ],
                    startColumn: lastRange.startColumn,
                    startRow: {
                        ...startRow
                    },
                    endRow: (0, $437b23f6a393c3bf$export$b36b14fdaf41f4d8)(this.beans, intersectionStartRow)
                };
                newRanges.push(top);
            }
            if (intersectCols.length > 0) {
                const middle = {
                    columns: intersectCols,
                    startColumn: intersectCols.includes(lastRange.startColumn) ? lastRange.startColumn : intersectCols[0],
                    startRow: $5b7ccabde48fae90$var$rowMax([
                        {
                            ...intersectionStartRow
                        },
                        {
                            ...startRow
                        }
                    ]),
                    endRow: $5b7ccabde48fae90$var$rowMin([
                        {
                            ...intersectionEndRow
                        },
                        {
                            ...endRow
                        }
                    ])
                };
                newRanges.push(middle);
            }
            if ((0, $437b23f6a393c3bf$export$6cce97428a227a31)(intersectionEndRow, endRow)) newRanges.push({
                columns: [
                    ...cols
                ],
                startColumn: lastRange.startColumn,
                startRow: (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(this.beans, intersectionEndRow),
                endRow: {
                    ...endRow
                }
            });
            if (newRanges.length - rangeCountBefore === 1) newRanges[newRanges.length - 1].id = range.id;
        }
        this.cellRanges = newRanges;
        if (fromMouseClick) this.dispatchChangedEvent(false, true);
    }
    createRangeHighlightFeature(compBean, column, headerComp) {
        compBean.createManagedBean(new $5b7ccabde48fae90$var$RangeHeaderHighlightFeature(column, headerComp));
    }
    setSelectionMode(allColumns) {
        this.selectionMode = allColumns ? 1 /* ALL_COLUMNS */  : 0 /* NORMAL */ ;
    }
    refreshRangeStart(cellRange) {
        const { startColumn: startColumn, columns: columns } = cellRange;
        const moveColInCellRange = (colToMove, moveToFront)=>{
            const otherCols = cellRange.columns.filter((col)=>col !== colToMove);
            if (colToMove) {
                cellRange.startColumn = colToMove;
                cellRange.columns = moveToFront ? [
                    colToMove,
                    ...otherCols
                ] : [
                    ...otherCols,
                    colToMove
                ];
            } else cellRange.columns = otherCols;
        };
        const { left: left, right: right } = this.getRangeEdgeColumns(cellRange);
        const shouldMoveLeftCol = startColumn === columns[0] && startColumn !== left;
        if (shouldMoveLeftCol) {
            moveColInCellRange(left, true);
            return;
        }
        const shouldMoveRightCol = startColumn === (0, $437b23f6a393c3bf$export$236389741107357f)(columns) && startColumn === right;
        if (shouldMoveRightCol) moveColInCellRange(right, false);
    }
    setNewestRangeStartCell(position) {
        this.newestRangeStartCell = position;
    }
    getColumnsFromParams(columns, columnA, columnB) {
        const noColsInfo = !columns && !columnA && !columnB;
        let processedColumns;
        let startsOnTheRight = false;
        if (noColsInfo || columns) processedColumns = this.getColumnsFromModel(noColsInfo ? void 0 : columns);
        else if (columnA && columnB) {
            processedColumns = this.calculateColumnsBetween(columnA, columnB);
            if (processedColumns?.length) startsOnTheRight = processedColumns[0] !== this.getColumnFromModel(columnA);
        }
        return processedColumns ? {
            columns: processedColumns,
            startsOnTheRight: startsOnTheRight
        } : void 0;
    }
    verifyCellRanges(gos) {
        const invalid = (0, $437b23f6a393c3bf$export$63600d24670d494d)(gos) && (0, $437b23f6a393c3bf$export$93073c0b97dd7eba)(gos) && this.cellRanges.length > 1;
        if (invalid) (0, $437b23f6a393c3bf$export$545083624300f13d)(93);
        return !invalid;
    }
    forEachRowInRange(cellRange, callback) {
        const topRow = this.getRangeStartRow(cellRange);
        const bottomRow = this.getRangeEndRow(cellRange);
        let currentRow = topRow;
        while(currentRow){
            callback(currentRow);
            if ((0, $437b23f6a393c3bf$export$de6f9fa10e9f4188)(currentRow, bottomRow)) break;
            currentRow = (0, $437b23f6a393c3bf$export$3077f3bcabdc5ad1)(this.beans, currentRow);
        }
    }
    // as the user is dragging outside of the panel, the div starts to scroll, which in turn
    // means we are selecting more (or less) cells, but the mouse isn't moving, so we recalculate
    // the selection my mimicking a new mouse event
    onBodyScroll() {
        if (this.dragging && this.lastMouseEvent) this.onDragging(this.lastMouseEvent);
    }
    updateValuesOnMove(eventTarget) {
        const cellCtrl = (0, $437b23f6a393c3bf$export$b5bf61dcea514250)(this.gos, eventTarget);
        const cell = cellCtrl?.cellPosition;
        this.cellHasChanged = false;
        if (!cell || this.lastCellHovered && (0, $437b23f6a393c3bf$export$be3973033c2c5267)(cell, this.lastCellHovered)) return;
        const editing = this.beans.editSvc?.isEditing(cellCtrl, {
            withOpenEditor: true
        });
        if (editing) {
            this.dragSvc.cancelDrag(eventTarget);
            return;
        }
        if (this.lastCellHovered) this.cellHasChanged = true;
        this.lastCellHovered = cell;
    }
    dispatchChangedEvent(started, finished, id) {
        this.eventSvc.dispatchEvent({
            type: "cellSelectionChanged",
            started: started,
            finished: finished,
            id: id
        });
        this.eventSvc.dispatchEvent({
            type: "rangeSelectionChanged",
            started: started,
            finished: finished,
            id: id
        });
    }
    getColumnFromModel(col) {
        return typeof col === "string" ? this.colModel.getCol(col) : col;
    }
    getColumnsFromModel(cols) {
        const { visibleCols: visibleCols, beans: beans, selectionMode: selectionMode } = this;
        const isRowHeaderActive = (0, $437b23f6a393c3bf$export$58f4eed4127eb370)(beans);
        if (!cols || selectionMode === 1 /* ALL_COLUMNS */ ) cols = visibleCols.allCols;
        const columns = [];
        for (const col of cols){
            const column = this.getColumnFromModel(col);
            if (!column || isRowHeaderActive && $5b7ccabde48fae90$var$shouldSkipCurrentColumn(column)) continue;
            columns.push(column);
        }
        return columns.length ? columns : void 0;
    }
    calculateColumnsBetween(columnA, columnB) {
        const allColumns = this.visibleCols.allCols;
        const fromColumn = this.getColumnFromModel(columnA);
        const toColumn = this.getColumnFromModel(columnB);
        const isSameColumn = fromColumn === toColumn;
        const fromIndex = allColumns.indexOf(fromColumn);
        if (fromIndex < 0) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(178, {
                colId: fromColumn.getId()
            });
            return;
        }
        const toIndex = isSameColumn ? fromIndex : allColumns.indexOf(toColumn);
        if (toIndex < 0) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(178, {
                colId: toColumn.getId()
            });
            return;
        }
        if (isSameColumn || this.selectionMode === 1 /* ALL_COLUMNS */ ) return this.getColumnsFromModel([
            fromColumn
        ]);
        const firstIndex = Math.min(fromIndex, toIndex);
        const lastIndex = firstIndex === fromIndex ? toIndex : fromIndex;
        return this.getColumnsFromModel(allColumns.slice(firstIndex, lastIndex + 1));
    }
    focusCellOnNewColumn(currentRange, column) {
        const { focusSvc: focusSvc } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (!focusedCell) return;
        if (this.isCellInSpecificRange(focusedCell, currentRange)) focusSvc.setFocusedCell({
            ...focusedCell,
            column: column,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true
        });
    }
    focusCellOnNewRow(currentRange, row) {
        const { focusSvc: focusSvc } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (!focusedCell) return;
        if (this.isCellInSpecificRange(focusedCell, currentRange)) focusSvc.setFocusedCell({
            ...row,
            column: focusedCell.column,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true
        });
    }
    createDragListenerFeature(eContainer) {
        return new $5b7ccabde48fae90$var$DragListenerFeature(eContainer);
    }
    createCellRangeFeature(ctrl) {
        return new $5b7ccabde48fae90$var$CellRangeFeature(this.beans, ctrl);
    }
    createHeaderGroupCellMouseListenerFeature(column, eGui) {
        return new $5b7ccabde48fae90$var$HeaderGroupCellMouseListenerFeature(column, eGui);
    }
    /**
   * Handle a user clicking column header to (de)select one or more column of cells
   * CTRL-clicking for toggling column selection + CTRL-SHIFT-clicking supported for selecting ranges of columns
   */ handleColumnSelection(clickedColumn, event) {
        const { gos: gos, beans: beans, columnRangeSelectionCtx: ctx, cellRanges: cellRanges } = this;
        const enableColumnSelection = (0, $437b23f6a393c3bf$export$8242077b143dbc86)(gos);
        if (!enableColumnSelection) return;
        const suppressMultiRanges = (0, $437b23f6a393c3bf$export$93073c0b97dd7eba)(gos);
        const hasRanges = cellRanges.length > 0;
        const isMeta = event.ctrlKey || event.metaKey;
        const firstRow = (0, $437b23f6a393c3bf$export$124b4386b662b699)(beans);
        const lastRow = (0, $437b23f6a393c3bf$export$a1449222017e428)(beans);
        if (!firstRow || !lastRow) return;
        if (event.shiftKey) {
            const root = ctx.root;
            if (!root) return;
            const column = clickedColumn.isColumn ? clickedColumn : (0, $437b23f6a393c3bf$export$236389741107357f)(clickedColumn.getLeafColumns());
            const range = this.findContainingRange({
                columns: [
                    root
                ],
                startRow: firstRow,
                endRow: lastRow
            }, true);
            if (!range) {
                (0, $437b23f6a393c3bf$export$83a881c8b5120679)(cellRanges, ctx.lastCellRange);
                this.selectColumns(this.calculateColumnsBetween(root, column), firstRow, lastRow);
                return;
            }
            this.updateRangeRowBoundary({
                cellRange: range,
                boundary: "end",
                cellPosition: {
                    column: column,
                    ...lastRow
                }
            });
        } else if (clickedColumn.isColumn) {
            if (hasRanges && (suppressMultiRanges || !isMeta)) this.removeAllCellRanges(true);
            const foundRange = this.findContainingRange({
                columns: [
                    clickedColumn
                ],
                startRow: firstRow,
                endRow: lastRow
            }, true);
            const lastCellRange = foundRange ? this.deselectColumnsFromRange(foundRange, [
                clickedColumn
            ]) : this.selectColumns([
                clickedColumn
            ], firstRow, lastRow);
            if (lastCellRange) ctx.lastCellRange = lastCellRange;
            ctx.root = clickedColumn;
        } else {
            if (hasRanges && (suppressMultiRanges || !isMeta)) this.removeAllCellRanges(true);
            const leafCols = clickedColumn.getDisplayedLeafColumns();
            const foundRange = this.findContainingRange({
                columns: leafCols,
                startRow: firstRow,
                endRow: lastRow
            }, true);
            if (foundRange) {
                this.deselectColumnsFromRange(foundRange, leafCols);
                ctx.root = leafCols[0];
            } else {
                const addedRange = this.selectColumns(leafCols, firstRow, lastRow);
                ctx.root = leafCols[0];
                if (addedRange) ctx.lastCellRange = addedRange;
            }
        }
    }
    deselectColumnsFromRange(range, columns) {
        (0, $437b23f6a393c3bf$export$d938638f12233be7)(range.columns, columns);
        if (columns.includes(range.startColumn)) range.startColumn = range.columns[0];
        if (range.columns.length === 0) (0, $437b23f6a393c3bf$export$83a881c8b5120679)(this.cellRanges, range);
        this.dispatchChangedEvent(true, true);
    }
    selectColumns(columns, startRow, endRow) {
        return this.addCellRange({
            columns: columns,
            columnStart: columns[0],
            columnEnd: (0, $437b23f6a393c3bf$export$236389741107357f)(columns),
            rowStartIndex: startRow.rowIndex,
            rowStartPinned: startRow.rowPinned,
            rowEndIndex: endRow.rowIndex,
            rowEndPinned: endRow.rowPinned
        });
    }
};
function $5b7ccabde48fae90$var$createRowPosition(rowIndex, rowPinned) {
    return rowIndex != null ? {
        rowIndex: rowIndex,
        rowPinned: rowPinned
    } : void 0;
}
function $5b7ccabde48fae90$var$rowMax(rows) {
    let max;
    for (const row of rows)if (max === void 0 || (0, $437b23f6a393c3bf$export$6cce97428a227a31)(max, row)) max = row;
    return max;
}
function $5b7ccabde48fae90$var$rowMin(rows) {
    let min;
    for (const row of rows)if (min === void 0 || (0, $437b23f6a393c3bf$export$6cce97428a227a31)(row, min)) min = row;
    return min;
}
function $5b7ccabde48fae90$var$shouldSkipCurrentColumn(currentColumn) {
    return (0, $437b23f6a393c3bf$export$3d3e7d751f0445eb)(currentColumn);
}
function $5b7ccabde48fae90$var$isLastCellOfRange(cellRange, cell) {
    const { startRow: startRow, endRow: endRow } = cellRange;
    const lastRow = (0, $437b23f6a393c3bf$export$6cce97428a227a31)(startRow, endRow) ? endRow : startRow;
    const isLastRow = cell.rowIndex === lastRow.rowIndex && cell.rowPinned === lastRow.rowPinned;
    const rangeFirstIndexColumn = cellRange.columns[0];
    const rangeLastIndexColumn = (0, $437b23f6a393c3bf$export$236389741107357f)(cellRange.columns);
    const lastRangeColumn = cellRange.startColumn === rangeFirstIndexColumn ? rangeLastIndexColumn : rangeFirstIndexColumn;
    const isLastColumn = cell.column === lastRangeColumn;
    return isLastColumn && isLastRow;
}
function $5b7ccabde48fae90$var$replaceEdgeRow(range, row, topOrBottom) {
    let key;
    if (topOrBottom === "top") key = !range.startRow || !range.endRow || (0, $437b23f6a393c3bf$export$6cce97428a227a31)(range.startRow, range.endRow) ? "startRow" : "endRow";
    else key = !range.startRow || !range.endRow || (0, $437b23f6a393c3bf$export$6cce97428a227a31)(range.startRow, range.endRow) ? "endRow" : "startRow";
    range[key] = row ?? void 0;
}
// packages/ag-grid-enterprise/src/rangeSelection/rangeSelectionModule.ts
var $5b7ccabde48fae90$export$6f4ee80b1242642d = {
    moduleName: "CellSelection",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$RangeService
    ],
    dynamicBeans: {
        fillHandle: $5b7ccabde48fae90$var$AgFillHandle,
        rangeHandle: $5b7ccabde48fae90$var$AgRangeHandle
    },
    apiFunctions: {
        getCellRanges: $5b7ccabde48fae90$var$getCellRanges,
        addCellRange: $5b7ccabde48fae90$var$addCellRange,
        clearRangeSelection: $5b7ccabde48fae90$var$clearRangeSelection,
        clearCellSelection: $5b7ccabde48fae90$var$clearRangeSelection
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$44f04c51d8088336),
        (0, $437b23f6a393c3bf$export$e88a21946d283d22)
    ],
    css: [
        $5b7ccabde48fae90$var$rangeSelectionCSS
    ]
};
var $5b7ccabde48fae90$export$5e5c8269d4d7ed2e = {
    moduleName: "RangeSelection",
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: [
        $5b7ccabde48fae90$export$6f4ee80b1242642d
    ]
};
var $5b7ccabde48fae90$var$LoadingCellRendererElement = {
    tag: "div",
    cls: "ag-loading",
    children: [
        {
            tag: "span",
            ref: "eLoadingIcon",
            cls: "ag-loading-icon"
        },
        {
            tag: "span",
            ref: "eLoadingText",
            cls: "ag-loading-text"
        }
    ]
};
var $5b7ccabde48fae90$var$LoadingCellRenderer = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$LoadingCellRendererElement);
        this.eLoadingIcon = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eLoadingText = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    init(params) {
        params.node.failedLoad ? this.setupFailed() : this.setupLoading();
    }
    setupFailed() {
        this.eLoadingText.textContent = this.getLocaleTextFunc()("loadingError", "ERR");
    }
    setupLoading() {
        const eLoadingIcon = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)("groupLoading", this.beans, null);
        if (eLoadingIcon) this.eLoadingIcon.appendChild(eLoadingIcon);
        this.eLoadingText.textContent = this.getLocaleTextFunc()("loadingOoo", "Loading...");
    }
    refresh(_params) {
        return false;
    }
};
// packages/ag-grid-enterprise/src/cellRenderers/enterpriseCellRendererModule.ts
var $5b7ccabde48fae90$var$LoadingCellRendererModule = {
    moduleName: "LoadingCellRenderer",
    version: $5b7ccabde48fae90$var$VERSION,
    userComponents: {
        agLoadingCellRenderer: $5b7ccabde48fae90$var$LoadingCellRenderer
    },
    icons: {
        // rotating spinner shown by the loading cell renderer
        groupLoading: "loading"
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ]
};
// packages/ag-grid-enterprise/src/pivot/pivotApi.ts
function $5b7ccabde48fae90$var$isPivotMode(beans) {
    return beans.colModel.isPivotMode();
}
function $5b7ccabde48fae90$var$getPivotResultColumn(beans, pivotKeys, valueColKey) {
    return beans.pivotResultCols?.lookupPivotResultCol(pivotKeys, valueColKey) ?? null;
}
function $5b7ccabde48fae90$var$setValueColumns(beans, colKeys) {
    beans.valueColsSvc?.setColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$getValueColumns(beans) {
    return beans.valueColsSvc?.columns ?? [];
}
function $5b7ccabde48fae90$var$removeValueColumns(beans, colKeys) {
    beans.valueColsSvc?.removeColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$addValueColumns(beans, colKeys) {
    beans.valueColsSvc?.addColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$setPivotColumns(beans, colKeys) {
    beans.pivotColsSvc?.setColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$removePivotColumns(beans, colKeys) {
    beans.pivotColsSvc?.removeColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$addPivotColumns(beans, colKeys) {
    beans.pivotColsSvc?.addColumns(colKeys, "api");
}
function $5b7ccabde48fae90$var$getPivotColumns(beans) {
    return beans.pivotColsSvc?.columns ?? [];
}
function $5b7ccabde48fae90$var$setPivotResultColumns(beans, colDefs) {
    beans.pivotResultCols?.setPivotResultCols(colDefs, "api");
}
function $5b7ccabde48fae90$var$getPivotResultColumns(beans) {
    const pivotResultCols = beans.pivotResultCols?.getPivotResultCols();
    return pivotResultCols ? pivotResultCols.list : null;
}
var $5b7ccabde48fae90$var$PIVOT_ROW_TOTAL_PREFIX = "PivotRowTotal_";
var $5b7ccabde48fae90$var$headerNameComparator = ({ headerName: a }, { headerName: b })=>{
    if (a && !b) return 1;
    else if (!a && b) return -1;
    else if (!a && !b) return 0;
    if (a < b) return -1;
    else if (a > b) return 1;
    else return 0;
};
var $5b7ccabde48fae90$var$convertToHeaderNameComparator = (comparator)=>(a, b)=>comparator(a.headerName, b.headerName);
var $5b7ccabde48fae90$var$PivotColDefService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "pivotColDefSvc";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.pivotColsSvc = beans.pivotColsSvc;
        this.valueColsSvc = beans.valueColsSvc;
        this.colNames = beans.colNames;
    }
    postConstruct() {
        const getFieldSeparator = ()=>this.gos.get("serverSidePivotResultFieldSeparator") ?? "_";
        this.fieldSeparator = getFieldSeparator();
        this.addManagedPropertyListener("serverSidePivotResultFieldSeparator", ()=>{
            this.fieldSeparator = getFieldSeparator();
        });
        const getPivotDefaultExpanded = ()=>this.gos.get("pivotDefaultExpanded");
        this.pivotDefaultExpanded = getPivotDefaultExpanded();
        this.addManagedPropertyListener("pivotDefaultExpanded", ()=>{
            this.pivotDefaultExpanded = getPivotDefaultExpanded();
        });
    }
    createPivotColumnDefs(uniqueValues) {
        const pivotColumnGroupDefs = this.createPivotColumnsFromUniqueValues(uniqueValues);
        function extractColDefs(input, arr = []) {
            input.forEach((def)=>{
                if (def.children !== void 0) extractColDefs(def.children, arr);
                else arr.push(def);
            });
            return arr;
        }
        const pivotColumnDefs = extractColDefs(pivotColumnGroupDefs);
        this.addRowGroupTotals(pivotColumnGroupDefs, pivotColumnDefs);
        this.addExpandablePivotGroups(pivotColumnGroupDefs, pivotColumnDefs);
        this.addPivotTotalsToGroups(pivotColumnGroupDefs, pivotColumnDefs);
        return pivotColumnGroupDefs;
    }
    createPivotColumnsFromUniqueValues(uniqueValues) {
        const pivotColumns = this.pivotColsSvc?.columns ?? [];
        const maxDepth = pivotColumns.length;
        const pivotColumnGroupDefs = this.recursivelyBuildGroup(0, uniqueValues, [], maxDepth, pivotColumns);
        return pivotColumnGroupDefs;
    }
    recursivelyBuildGroup(index, uniqueValue, pivotKeys, maxDepth, primaryPivotColumns) {
        if (index >= maxDepth) return this.buildMeasureCols(pivotKeys);
        const { pivotComparator: pivotComparator } = primaryPivotColumns[index].getColDef();
        const comparator = pivotComparator ? $5b7ccabde48fae90$var$convertToHeaderNameComparator(pivotComparator) : $5b7ccabde48fae90$var$headerNameComparator;
        const measureColumns = this.valueColsSvc?.columns;
        if (measureColumns?.length === 1 && this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && index === maxDepth - 1) {
            const leafCols = [];
            for (const key of uniqueValue.keys()){
                const newPivotKeys = [
                    ...pivotKeys,
                    key
                ];
                const colDef = this.createColDef(measureColumns[0], key, newPivotKeys);
                colDef.columnGroupShow = "open";
                leafCols.push(colDef);
            }
            leafCols.sort(comparator);
            return leafCols;
        }
        const groups = [];
        for (const key of uniqueValue.keys()){
            const openByDefault = this.pivotDefaultExpanded === -1 || index < this.pivotDefaultExpanded;
            const newPivotKeys = [
                ...pivotKeys,
                key
            ];
            groups.push({
                children: this.recursivelyBuildGroup(index + 1, uniqueValue.get(key), newPivotKeys, maxDepth, primaryPivotColumns),
                headerName: key,
                pivotKeys: newPivotKeys,
                columnGroupShow: "open",
                openByDefault: openByDefault,
                groupId: this.generateColumnGroupId(newPivotKeys)
            });
        }
        groups.sort(comparator);
        return groups;
    }
    buildMeasureCols(pivotKeys) {
        const measureColumns = this.valueColsSvc?.columns ?? [];
        if (measureColumns.length === 0) return [
            this.createColDef(null, "-", pivotKeys)
        ];
        return measureColumns.map((measureCol)=>{
            const columnName = this.colNames.getDisplayNameForColumn(measureCol, "header");
            const colDef = this.createColDef(measureCol, columnName, pivotKeys);
            colDef.columnGroupShow = "open";
            return colDef;
        });
    }
    addExpandablePivotGroups(pivotColumnGroupDefs, pivotColumnDefs) {
        const isSuppressExpand = this.gos.get("suppressExpandablePivotGroups");
        if (isSuppressExpand || this.gos.get("pivotColumnGroupTotals")) return;
        const recursivelyAddSubTotals = (def, currentPivotColumnDefs, acc)=>{
            if ("children" in def) {
                const { valueColsSvc: valueColsSvc } = this;
                const { columns: valueCols = [] } = valueColsSvc ?? {};
                const childAcc = /* @__PURE__ */ new Map();
                def.children.forEach((grp)=>{
                    recursivelyAddSubTotals(grp, currentPivotColumnDefs, childAcc);
                });
                const leafGroup = !def.children.some((child)=>child.children);
                const hasCollapsedLeafGroup = leafGroup && valueCols.length === 1 && this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
                for (const valueColumn of valueCols){
                    const columnName = this.colNames.getDisplayNameForColumn(valueColumn, "header");
                    const totalColDef = this.createColDef(valueColumn, columnName, def.pivotKeys);
                    totalColDef.pivotTotalColumnIds = childAcc.get(valueColumn.getColId());
                    totalColDef.columnGroupShow = !isSuppressExpand ? "closed" : "open";
                    totalColDef.aggFunc = valueColumn.getAggFunc();
                    if (!leafGroup || hasCollapsedLeafGroup) {
                        const children = def.children;
                        children.push(totalColDef);
                        currentPivotColumnDefs.push(totalColDef);
                    }
                }
                this.merge(acc, childAcc);
                return;
            }
            if (!def.pivotValueColumn) return;
            const pivotValueColId = def.pivotValueColumn.getColId();
            const exists = acc.has(pivotValueColId);
            if (exists) {
                const arr = acc.get(pivotValueColId);
                arr.push(def.colId);
            } else acc.set(pivotValueColId, [
                def.colId
            ]);
        };
        pivotColumnGroupDefs.forEach((groupDef)=>{
            recursivelyAddSubTotals(groupDef, pivotColumnDefs, /* @__PURE__ */ new Map());
        });
    }
    addPivotTotalsToGroups(pivotColumnGroupDefs, pivotColumnDefs) {
        if (!this.gos.get("pivotColumnGroupTotals")) return;
        const insertAfter = this.gos.get("pivotColumnGroupTotals") === "after";
        const valueCols = this.valueColsSvc?.columns;
        const aggFuncs = valueCols?.map((valueCol)=>valueCol.getAggFunc());
        if (!aggFuncs || aggFuncs.length < 1 || !this.sameAggFuncs(aggFuncs)) return;
        if (valueCols) {
            const valueColumn = valueCols[0];
            pivotColumnGroupDefs.forEach((groupDef)=>{
                this.recursivelyAddPivotTotal(groupDef, pivotColumnDefs, valueColumn, insertAfter);
            });
        }
    }
    recursivelyAddPivotTotal(groupDef, pivotColumnDefs, valueColumn, insertAfter) {
        const group = groupDef;
        if (!group.children) {
            const def = groupDef;
            return def.colId ? [
                def.colId
            ] : null;
        }
        let colIds = [];
        group.children.forEach((grp)=>{
            const childColIds = this.recursivelyAddPivotTotal(grp, pivotColumnDefs, valueColumn, insertAfter);
            if (childColIds) colIds = colIds.concat(childColIds);
        });
        if (group.children.length > 1) {
            const localeTextFunc = this.getLocaleTextFunc();
            const headerName = localeTextFunc("pivotColumnGroupTotals", "Total");
            const totalColDef = this.createColDef(valueColumn, headerName, groupDef.pivotKeys, true);
            totalColDef.pivotTotalColumnIds = colIds;
            totalColDef.aggFunc = valueColumn.getAggFunc();
            totalColDef.columnGroupShow = this.gos.get("suppressExpandablePivotGroups") ? "open" : void 0;
            const children = groupDef.children;
            insertAfter ? children.push(totalColDef) : children.unshift(totalColDef);
            pivotColumnDefs.push(totalColDef);
        }
        return colIds;
    }
    addRowGroupTotals(pivotColumnGroupDefs, pivotColumnDefs) {
        if (!this.gos.get("pivotRowTotals")) return;
        const insertAtEnd = this.gos.get("pivotRowTotals") === "after";
        const valueColumns = this.valueColsSvc?.columns ?? [];
        const valueCols = valueColumns.slice();
        if (!insertAtEnd) valueCols.reverse();
        const isCreateTotalGroups = valueCols.length > 1 || !this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
        for(let i = 0; i < valueCols.length; i++){
            const valueCol = valueCols[i];
            const columnName = this.colNames.getDisplayNameForColumn(valueCol, "header");
            const colDef = this.createColDef(valueCol, columnName, []);
            const colIds = [];
            for(let i2 = 0; i2 < pivotColumnDefs.length; i2++){
                const colDef2 = pivotColumnDefs[i2];
                if (colDef2.pivotValueColumn === valueCol) colIds.push(colDef2.colId);
            }
            colDef.pivotTotalColumnIds = colIds;
            colDef.colId = $5b7ccabde48fae90$var$PIVOT_ROW_TOTAL_PREFIX + colDef.colId;
            const valueGroup = isCreateTotalGroups ? {
                children: [
                    colDef
                ],
                pivotKeys: [],
                groupId: `${$5b7ccabde48fae90$var$PIVOT_ROW_TOTAL_PREFIX}_pivotGroup_${valueCol.getColId()}`
            } : colDef;
            pivotColumnDefs.push(colDef);
            insertAtEnd ? pivotColumnGroupDefs.push(valueGroup) : pivotColumnGroupDefs.unshift(valueGroup);
        }
    }
    /**
   * Recreate a pivot colDef to update from a changed valueColumn colDef
   */ recreateColDef(colDef) {
        const { pivotValueColumn: pivotValueColumn, headerName: headerName, pivotKeys: pivotKeys, pivotTotalColumnIds: pivotTotalColumnIds, columnGroupShow: columnGroupShow, colId: colId, valueGetter: valueGetter, aggFunc: aggFunc } = colDef;
        if (!pivotValueColumn) return colDef;
        const newColDef = this.createColDef(pivotValueColumn, headerName, pivotKeys, !!pivotTotalColumnIds);
        newColDef.columnGroupShow = columnGroupShow;
        newColDef.colId = colId;
        newColDef.valueGetter = valueGetter;
        newColDef.aggFunc = aggFunc;
        newColDef.pivotTotalColumnIds = pivotTotalColumnIds;
        this.gos.get("processPivotResultColDef")?.(newColDef);
        return newColDef;
    }
    createColDef(valueColumn, headerName, pivotKeys, totalColumn = false) {
        const colDef = {};
        if (valueColumn) {
            const colDefToCopy = valueColumn.getColDef();
            Object.assign(colDef, colDefToCopy);
            colDef.hide = false;
        }
        colDef.headerName = headerName;
        colDef.colId = this.generateColumnId(pivotKeys || [], valueColumn && !totalColumn ? valueColumn.getColId() : "");
        colDef.field = colDef.colId;
        colDef.valueGetter = (params)=>params.data?.[params.colDef.field];
        colDef.pivotKeys = pivotKeys;
        colDef.pivotValueColumn = valueColumn;
        if (colDef.filter === true) colDef.filter = "agNumberColumnFilter";
        return colDef;
    }
    sameAggFuncs(aggFuncs) {
        if (aggFuncs.length == 1) return true;
        for(let i = 1; i < aggFuncs.length; i++){
            if (aggFuncs[i] !== aggFuncs[0]) return false;
        }
        return true;
    }
    merge(m1, m2) {
        m2.forEach((value, key)=>{
            const existingList = m1.has(key) ? m1.get(key) : [];
            const updatedList = [
                ...existingList,
                ...value
            ];
            m1.set(key, updatedList);
        });
    }
    generateColumnGroupId(pivotKeys) {
        const pivotCols = (this.pivotColsSvc?.columns ?? []).map((col)=>col.getColId());
        return `pivotGroup_${pivotCols.join("-")}_${pivotKeys.join("-")}`;
    }
    generateColumnId(pivotKeys, measureColumnId) {
        const pivotCols = (this.pivotColsSvc?.columns ?? []).map((col)=>col.getColId());
        return `pivot_${pivotCols.join("-")}_${pivotKeys.join("-")}_${measureColumnId}`;
    }
    /**
   * Used by the SSRM to create secondary columns from provided fields
   * @param fields
   */ createColDefsFromFields(fields) {
        const uniqueValues = /* @__PURE__ */ new Map();
        for(let i = 0; i < fields.length; i++){
            const field = fields[i];
            const parts = field.split(this.fieldSeparator);
            let level = uniqueValues;
            for(let p = 0; p < parts.length; p++){
                const part = parts[p];
                let map = level.get(part);
                if (!map) {
                    map = /* @__PURE__ */ new Map();
                    level.set(part, map);
                }
                level = map;
            }
        }
        const uniqueValuesToGroups = (id, key, uniqueValues2, depth)=>{
            const children = [];
            for (const [key2, item] of uniqueValues2){
                const child = uniqueValuesToGroups(`${id}${this.fieldSeparator}${key2}`, key2, item, depth + 1);
                children.push(child);
            }
            if (children.length === 0) {
                const potentialAggCol = this.colModel.getColDefCol(key);
                if (potentialAggCol) {
                    const headerName = this.colNames.getDisplayNameForColumn(potentialAggCol, "header") ?? key;
                    const colDef = this.createColDef(potentialAggCol, headerName, void 0, false);
                    colDef.colId = id;
                    colDef.aggFunc = potentialAggCol.getAggFunc();
                    colDef.valueGetter = (params)=>params.data?.[id];
                    return colDef;
                }
                const col = {
                    colId: id,
                    headerName: key,
                    // this is to support using pinned rows, normally the data will be extracted from the aggData object using the colId
                    // however pinned rows still access the data object by field, this prevents values with dots from being treated as complex objects
                    valueGetter: (params)=>params.data?.[id]
                };
                return col;
            }
            const collapseSingleChildren = this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
            if (collapseSingleChildren && children.length === 1 && "colId" in children[0]) {
                children[0].headerName = key;
                return children[0];
            }
            const group = {
                openByDefault: this.pivotDefaultExpanded === -1 || depth < this.pivotDefaultExpanded,
                groupId: id,
                headerName: key,
                children: children
            };
            return group;
        };
        const res = [];
        for (const [key, item] of uniqueValues){
            const col = uniqueValuesToGroups(key, key, item, 0);
            res.push(col);
        }
        return res;
    }
};
var $5b7ccabde48fae90$var$PivotResultColsService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "pivotResultCols";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.visibleCols = beans.visibleCols;
    }
    destroy() {
        (0, $437b23f6a393c3bf$export$dbaaa57234b60d8f)(this.beans, this.pivotResultCols?.tree);
        super.destroy();
    }
    isPivotResultColsPresent() {
        return this.pivotResultCols != null;
    }
    lookupPivotResultCol(pivotKeys, valueColKey) {
        if (this.pivotResultCols == null) return null;
        const valueColumnToFind = this.colModel.getColDefCol(valueColKey);
        let foundColumn = null;
        for (const column of this.pivotResultCols.list){
            const thisPivotKeys = column.getColDef().pivotKeys;
            const pivotValueColumn = column.getColDef().pivotValueColumn;
            const pivotKeyMatches = (0, $437b23f6a393c3bf$export$893967cdb9833fdd)(thisPivotKeys, pivotKeys);
            const pivotValueMatches = pivotValueColumn === valueColumnToFind;
            if (pivotKeyMatches && pivotValueMatches) foundColumn = column;
        }
        return foundColumn;
    }
    getPivotResultCols() {
        return this.pivotResultCols;
    }
    getPivotResultCol(key) {
        if (!this.pivotResultCols) return null;
        return this.colModel.getColFromCollection(key, this.pivotResultCols);
    }
    setPivotResultCols(colDefs, source) {
        if (!this.colModel.ready) return;
        if (colDefs == null && this.pivotResultCols == null) return;
        if (colDefs) {
            this.processPivotResultColDef(colDefs);
            const createColTreeFunc = source === "api" ? (0, $437b23f6a393c3bf$export$e03b26088dedc2ab) : (0, $437b23f6a393c3bf$export$575b8d8234793d75);
            const balancedTreeResult = createColTreeFunc(this.beans, colDefs, false, this.pivotResultCols?.tree || this.previousPivotResultCols || void 0, source);
            (0, $437b23f6a393c3bf$export$dbaaa57234b60d8f)(this.beans, this.pivotResultCols?.tree, balancedTreeResult.columnTree);
            const tree = balancedTreeResult.columnTree;
            const treeDepth = balancedTreeResult.treeDepth;
            const list = (0, $437b23f6a393c3bf$export$42da2aea8fab5b)(tree);
            const map = {};
            this.pivotResultCols = {
                tree: tree,
                treeDepth: treeDepth,
                list: list,
                map: map
            };
            for (const col of this.pivotResultCols.list)this.pivotResultCols.map[col.getId()] = col;
            const hasPreviousCols = !!this.previousPivotResultCols;
            this.previousPivotResultCols = null;
            this.colModel.refreshCols(!hasPreviousCols, source);
        } else {
            this.previousPivotResultCols = this.pivotResultCols ? this.pivotResultCols.tree : null;
            this.pivotResultCols = null;
            this.colModel.refreshCols(false, source);
        }
        this.visibleCols.refresh(source);
    }
    processPivotResultColDef(colDefs) {
        const columnCallback = this.gos.get("processPivotResultColDef");
        const groupCallback = this.gos.get("processPivotResultColGroupDef");
        if (!columnCallback && !groupCallback) return void 0;
        const searchForColDefs = (colDefs2)=>{
            colDefs2.forEach((abstractColDef)=>{
                const isGroup = (0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(abstractColDef.children);
                if (isGroup) {
                    const colGroupDef = abstractColDef;
                    if (groupCallback) groupCallback(colGroupDef);
                    searchForColDefs(colGroupDef.children);
                } else {
                    const colDef = abstractColDef;
                    if (columnCallback) columnCallback(colDef);
                }
            });
        };
        if (colDefs) searchForColDefs(colDefs);
    }
};
var $5b7ccabde48fae90$var$EXCEEDED_MAX_UNIQUE_VALUES = "Exceeded maximum allowed pivot column count.";
var $5b7ccabde48fae90$var$mapToObject = (map)=>{
    const obj = {};
    map.forEach((value, key)=>obj[key] = value instanceof Map ? $5b7ccabde48fae90$var$mapToObject(value) : value);
    return obj;
};
var $5b7ccabde48fae90$var$PivotStage = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "pivotStage";
        this.step = "pivot";
        this.refreshProps = [
            "removePivotHeaderRowWhenSingleValueColumn",
            "pivotRowTotals",
            "pivotColumnGroupTotals",
            "suppressExpandablePivotGroups"
        ];
        this.uniqueValues = /* @__PURE__ */ new Map();
        this.lastTimeFailed = false;
        this.maxUniqueValues = -1;
        this.currentUniqueCount = 0;
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
        this.colModel = beans.colModel;
        this.pivotResultCols = beans.pivotResultCols;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.valueColsSvc = beans.valueColsSvc;
        this.pivotColsSvc = beans.pivotColsSvc;
        this.pivotColDefSvc = beans.pivotColDefSvc;
    }
    execute(changedPath) {
        if (this.colModel.isPivotActive()) this.executePivotOn(changedPath);
        else this.executePivotOff(changedPath);
    }
    executePivotOff(changedPath) {
        this.aggregationColumnsHashLastTime = null;
        this.uniqueValues = /* @__PURE__ */ new Map();
        if (this.pivotResultCols.isPivotResultColsPresent()) {
            this.pivotResultCols.setPivotResultCols(null, "rowModelUpdated");
            if (changedPath) changedPath.active = false;
        }
    }
    executePivotOn(changedPath) {
        const numberOfAggregationColumns = this.valueColsSvc?.columns.length ?? 1;
        const configuredMaxCols = this.gos.get("pivotMaxGeneratedColumns");
        this.maxUniqueValues = configuredMaxCols === -1 ? -1 : configuredMaxCols / numberOfAggregationColumns;
        let uniqueValues;
        try {
            uniqueValues = this.bucketUpRowNodes(changedPath);
        } catch (e) {
            if (e.message === $5b7ccabde48fae90$var$EXCEEDED_MAX_UNIQUE_VALUES) {
                this.pivotResultCols.setPivotResultCols([], "rowModelUpdated");
                this.eventSvc.dispatchEvent({
                    type: "pivotMaxColumnsExceeded",
                    message: e.message
                });
                this.lastTimeFailed = true;
                return;
            }
            throw e;
        }
        const uniqueValuesChanged = this.setUniqueValues(uniqueValues);
        const aggregationColumns = this.valueColsSvc?.columns ?? [];
        const aggregationColumnsHash = aggregationColumns.map((column)=>`${column.getId()}-${column.getColDef().headerName}`).join("#");
        const aggregationFuncsHash = aggregationColumns.map((column)=>column.getAggFunc().toString()).join("#");
        const aggregationColumnsChanged = this.aggregationColumnsHashLastTime !== aggregationColumnsHash;
        const aggregationFuncsChanged = this.aggregationFuncsHashLastTime !== aggregationFuncsHash;
        this.aggregationColumnsHashLastTime = aggregationColumnsHash;
        this.aggregationFuncsHashLastTime = aggregationFuncsHash;
        const groupColumnsHash = (this.rowGroupColsSvc?.columns ?? []).map((column)=>column.getId()).join("#");
        const groupColumnsChanged2 = groupColumnsHash !== this.groupColumnsHashLastTime;
        this.groupColumnsHashLastTime = groupColumnsHash;
        const pivotRowTotals = this.gos.get("pivotRowTotals");
        const pivotColumnGroupTotals = this.gos.get("pivotColumnGroupTotals");
        const suppressExpandablePivotGroups = this.gos.get("suppressExpandablePivotGroups");
        const removePivotHeaderRowWhenSingleValueColumn = this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
        const anyGridOptionsChanged = pivotRowTotals !== this.pivotRowTotalsLastTime || pivotColumnGroupTotals !== this.pivotColumnGroupTotalsLastTime || suppressExpandablePivotGroups !== this.suppressExpandablePivotGroupsLastTime || removePivotHeaderRowWhenSingleValueColumn !== this.removePivotHeaderRowWhenSingleValueColumnLastTime;
        this.pivotRowTotalsLastTime = pivotRowTotals;
        this.pivotColumnGroupTotalsLastTime = pivotColumnGroupTotals;
        this.suppressExpandablePivotGroupsLastTime = suppressExpandablePivotGroups;
        this.removePivotHeaderRowWhenSingleValueColumnLastTime = removePivotHeaderRowWhenSingleValueColumn;
        if (this.lastTimeFailed || uniqueValuesChanged || aggregationColumnsChanged || groupColumnsChanged2 || aggregationFuncsChanged || anyGridOptionsChanged) {
            const pivotColumnGroupDefs = this.pivotColDefSvc.createPivotColumnDefs(this.uniqueValues);
            this.pivotResultCols.setPivotResultCols(pivotColumnGroupDefs, "rowModelUpdated");
            if (changedPath) changedPath.active = false;
        }
        this.lastTimeFailed = false;
    }
    setUniqueValues(newValues) {
        const json1 = JSON.stringify($5b7ccabde48fae90$var$mapToObject(this.uniqueValues));
        const json2 = JSON.stringify($5b7ccabde48fae90$var$mapToObject(newValues));
        const uniqueValuesChanged = json1 !== json2;
        if (uniqueValuesChanged) {
            this.uniqueValues = newValues;
            return true;
        } else return false;
    }
    bucketUpRowNodes(changedPath) {
        this.currentUniqueCount = 0;
        const uniqueValues = /* @__PURE__ */ new Map();
        changedPath.forEachChangedNodeDepthFirst((node)=>{
            if (node.leafGroup) node.childrenMapped = null;
        });
        const recursivelyBucketFilteredChildren = (node)=>{
            if (node.leafGroup) this.bucketRowNode(node, uniqueValues);
            else node.childrenAfterFilter?.forEach(recursivelyBucketFilteredChildren);
        };
        changedPath.executeFromRootNode(recursivelyBucketFilteredChildren);
        return uniqueValues;
    }
    bucketRowNode(rowNode, uniqueValues) {
        const pivotColumns = this.pivotColsSvc?.columns;
        if (pivotColumns?.length === 0) rowNode.childrenMapped = null;
        else rowNode.childrenMapped = $5b7ccabde48fae90$var$mapToObject(this.bucketChildren(rowNode.childrenAfterFilter, pivotColumns, 0, uniqueValues));
        if (rowNode.sibling) rowNode.sibling.childrenMapped = rowNode.childrenMapped;
    }
    bucketChildren(children, pivotColumns = [], pivotIndex, uniqueValues) {
        const mappedChildren = /* @__PURE__ */ new Map();
        const pivotColumn = pivotColumns[pivotIndex];
        children.forEach((child)=>{
            let key = this.valueSvc.getKeyForNode(pivotColumn, child);
            if ((0, $437b23f6a393c3bf$export$672d9e47bc342bac)(key)) key = "";
            if (!uniqueValues.get(key)) {
                this.currentUniqueCount += 1;
                uniqueValues.set(key, /* @__PURE__ */ new Map());
                const doesGeneratedColMaxExist = this.maxUniqueValues !== -1;
                const hasExceededColMax = this.currentUniqueCount > this.maxUniqueValues;
                if (doesGeneratedColMaxExist && hasExceededColMax) throw Error($5b7ccabde48fae90$var$EXCEEDED_MAX_UNIQUE_VALUES);
            }
            if (!mappedChildren.has(key)) mappedChildren.set(key, []);
            mappedChildren.get(key).push(child);
        });
        if (pivotIndex === pivotColumns.length - 1) return mappedChildren;
        const result = /* @__PURE__ */ new Map();
        for (const key of mappedChildren.keys())result.set(key, this.bucketChildren(mappedChildren.get(key), pivotColumns, pivotIndex + 1, uniqueValues.get(key)));
        return result;
    }
};
// packages/ag-grid-enterprise/src/pivot/pivotModule.ts
var $5b7ccabde48fae90$var$SharedPivotModule = {
    moduleName: "SharedPivot",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$PivotResultColsService,
        $5b7ccabde48fae90$var$PivotColDefService,
        $5b7ccabde48fae90$var$PivotColsSvc
    ],
    apiFunctions: {
        isPivotMode: $5b7ccabde48fae90$var$isPivotMode,
        getPivotResultColumn: $5b7ccabde48fae90$var$getPivotResultColumn,
        setValueColumns: $5b7ccabde48fae90$var$setValueColumns,
        getValueColumns: $5b7ccabde48fae90$var$getValueColumns,
        removeValueColumns: $5b7ccabde48fae90$var$removeValueColumns,
        addValueColumns: $5b7ccabde48fae90$var$addValueColumns,
        setPivotColumns: $5b7ccabde48fae90$var$setPivotColumns,
        removePivotColumns: $5b7ccabde48fae90$var$removePivotColumns,
        addPivotColumns: $5b7ccabde48fae90$var$addPivotColumns,
        getPivotColumns: $5b7ccabde48fae90$var$getPivotColumns,
        setPivotResultColumns: $5b7ccabde48fae90$var$setPivotResultColumns,
        getPivotResultColumns: $5b7ccabde48fae90$var$getPivotResultColumns
    },
    dependsOn: [
        $5b7ccabde48fae90$var$SharedRowGroupingModule,
        (0, $437b23f6a393c3bf$export$922da35340a6d14e)
    ]
};
var $5b7ccabde48fae90$export$4fc40ce1b35c05e1 = {
    moduleName: "Pivot",
    version: $5b7ccabde48fae90$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $5b7ccabde48fae90$var$PivotStage
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$SharedPivotModule,
        $5b7ccabde48fae90$export$e67935bd41653107,
        $5b7ccabde48fae90$var$ClientSideRowModelHierarchyModule
    ]
};
// packages/ag-grid-enterprise/src/treeData/fieldAccess.ts
var $5b7ccabde48fae90$var$fieldGetter = (path)=>{
    const segments = path.split(".");
    if (segments.includes("__proto__")) return ()=>{};
    const len = segments.length;
    if (len < 2) return (data)=>data?.[path];
    return (data)=>{
        let i = 0;
        do {
            data = data?.[segments[i++]];
            if (i === len) return data;
        }while (typeof data === "object");
    };
};
// packages/ag-grid-enterprise/src/treeData/treeGroupStrategy.ts
var $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED = 2147483648;
var $5b7ccabde48fae90$var$FLAG_CHANGED = 1073741824;
var $5b7ccabde48fae90$var$FLAG_MARKED_FILLER = 536870912;
var $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED = 268435456;
var $5b7ccabde48fae90$var$MASK_CHILDREN_LEN = 268435455;
var $5b7ccabde48fae90$var$PATH_KEY_SEPARATOR = String.fromCodePoint(31, 41150, 8291);
var $5b7ccabde48fae90$var$PATH_KEY_SEPARATOR_LEN = 3;
var $5b7ccabde48fae90$var$TreeGroupStrategy = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.nestedDataGetter = null;
        this.parentIdGetter = null;
        this.nonLeafsById = null;
        this.nodesToUnselect = null;
        this.fullReload = false;
    }
    postConstruct() {
        this.onPropChange(null);
    }
    onPropChange(changedProps) {
        const gos = this.gos;
        if (!changedProps || changedProps.has("treeDataParentIdField")) {
            const parentIdField = gos.get("treeDataParentIdField");
            const getter = parentIdField ? $5b7ccabde48fae90$var$fieldGetter(parentIdField) : null;
            this.fullReload || (this.fullReload = this.parentIdGetter !== getter);
            this.parentIdGetter = getter;
            if (getter) this.nestedDataGetter = null;
        }
        if (!changedProps || changedProps.has("treeDataChildrenField")) {
            const childrenField = this.parentIdGetter ? "" : gos.get("treeDataChildrenField");
            const getter = childrenField ? $5b7ccabde48fae90$var$fieldGetter(childrenField) : null;
            this.fullReload || (this.fullReload = this.nestedDataGetter !== getter);
            this.nestedDataGetter = getter;
        }
    }
    destroy() {
        this.nodesToUnselect = null;
        this.reset();
        super.destroy();
    }
    reset() {
        this.clearNonLeafs();
        this.deselectHiddenNodes(false);
        this.fullReload = true;
    }
    clearNonLeafs() {
        const fillers = this.nonLeafsById;
        if (fillers) {
            for (const node of fillers.values())node._destroy(false);
            fillers.clear();
            this.nonLeafsById = null;
        }
    }
    getNonLeaf(id) {
        return this.nonLeafsById?.get(id);
    }
    loadGroupData(node) {
        const key = node.key;
        if (key == null) {
            node._groupData = null;
            return null;
        }
        const groupData = {};
        node._groupData = groupData;
        const groupDisplayCols = this.beans.showRowGroupCols?.columns;
        if (groupDisplayCols) for(let i = 0, len = groupDisplayCols.length; i < len; ++i)groupData[groupDisplayCols[i].getColId()] = key;
        return groupData;
    }
    execute(rootNode, params) {
        if (this.fullReload) this.reset();
        const { changedRowNodes: changedRowNodes, changedPath: changedPath } = params;
        const activeChangedPath = changedPath?.active ? changedPath : void 0;
        const fullReload = this.fullReload || !changedRowNodes && !activeChangedPath;
        const hasUpdates = !!changedRowNodes && this.flagUpdatedNodes(changedRowNodes);
        if (fullReload || hasUpdates) {
            this.fullReload = false;
            if (this.parentIdGetter) this.loadSelfRef(rootNode, fullReload);
            else if (this.nestedDataGetter) this.loadNested(rootNode, changedRowNodes, fullReload);
            else this.loadDataPath(rootNode, fullReload);
        }
        const parentsChanged = this.initRowsParents(rootNode);
        this.destroyFillerRows(!!params.animate);
        this.initRowsChildrenSize(rootNode);
        let preprocessedCount = this.preprocessRows(rootNode);
        const treeChanged = parentsChanged || (preprocessedCount & $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED) !== 0;
        preprocessedCount &= ~$5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED;
        const traverseCount = this.traverseRoot(rootNode, activeChangedPath);
        if (preprocessedCount > 0 && preprocessedCount !== traverseCount) {
            this.handleCycles(rootNode);
            this.traverseRoot(rootNode, activeChangedPath);
        }
        rootNode.treeNodeFlags = 0;
        this.deselectHiddenNodes(parentsChanged || fullReload);
        return treeChanged;
    }
    flagUpdatedNodes(changedRowNodes) {
        const { adds: adds, updates: updates, removals: removals } = changedRowNodes;
        let hasUpdates = removals.length > 0;
        if (adds.size > 0) {
            hasUpdates = true;
            for (const node of adds)node.treeNodeFlags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
        }
        if (updates.size > 0) {
            hasUpdates = true;
            for (const node of updates)node.treeNodeFlags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
        }
        return hasUpdates;
    }
    initRowsParents(rootNode) {
        const allLeafs = rootNode._leafs;
        const allLeafsLen = allLeafs.length;
        let parentsChanged = false;
        for(let i = 0; i < allLeafsLen; ++i)if (this.initRowParent(allLeafs[i])) parentsChanged = true;
        return parentsChanged;
    }
    initRowParent(current) {
        let parentsChanged = false;
        while(true){
            const oldParent = current.parent;
            const parent = current.treeParent;
            if (parent === null) {
                if (oldParent) {
                    parentsChanged = true;
                    this.hideRow(current);
                }
                break;
            }
            let parentFlags = parent.treeNodeFlags + 1;
            const parentChanged = oldParent !== parent;
            if (parentChanged) {
                parentsChanged = true;
                parentFlags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
                current.parent = parent;
            }
            if (parentChanged && oldParent) {
                if (oldParent.destroyed && $5b7ccabde48fae90$var$maybeExpandFromRemovedParent(parent, oldParent)) parentFlags |= $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED;
                oldParent.treeNodeFlags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
            }
            if (parent.sourceRowIndex >= 0 || parent.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_MARKED_FILLER || parent.treeParent === null) {
                parent.treeNodeFlags = parentFlags;
                break;
            }
            parent.treeNodeFlags = parentFlags | $5b7ccabde48fae90$var$FLAG_MARKED_FILLER | current.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_CHANGED;
            current = parent;
        }
        return parentsChanged;
    }
    destroyFillerRows(animate) {
        const nonLeafsById = this.nonLeafsById;
        if (nonLeafsById) {
            for (const node of nonLeafsById.values())if (node.treeParent === null || (node.treeNodeFlags & $5b7ccabde48fae90$var$MASK_CHILDREN_LEN) === 0) {
                nonLeafsById.delete(node.id);
                node._destroy(animate);
                this.hideRow(node);
            }
            if (nonLeafsById.size === 0) this.nonLeafsById = null;
        }
    }
    initRowsChildrenSize(rootNode) {
        this.initRowChildrenSize(rootNode);
        const allLeafs = rootNode._leafs;
        const allLeafsLen = allLeafs.length;
        for(let i = 0; i < allLeafsLen; ++i)this.initRowChildrenSize(allLeafs[i]);
        const nonLeafsById = this.nonLeafsById;
        if (nonLeafsById !== null) for (const filler of nonLeafsById.values())this.initRowChildrenSize(filler);
    }
    initRowChildrenSize(row) {
        let { childrenAfterGroup: childrenAfterGroup, _leafs: rowLeafs, treeNodeFlags: treeNodeFlags } = row;
        const oldLen = childrenAfterGroup?.length;
        const len = treeNodeFlags & $5b7ccabde48fae90$var$MASK_CHILDREN_LEN;
        row.treeNodeFlags = treeNodeFlags & ~$5b7ccabde48fae90$var$MASK_CHILDREN_LEN | ((oldLen || 0) === len ? 0 : $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED);
        if (len === 0 && row.level >= 0) {
            if (childrenAfterGroup !== (0, $437b23f6a393c3bf$export$c758d9371030a6ac)) {
                row.childrenAfterGroup = (0, $437b23f6a393c3bf$export$c758d9371030a6ac);
                const sibling = row.sibling;
                if (sibling) sibling.childrenAfterGroup = (0, $437b23f6a393c3bf$export$c758d9371030a6ac);
            }
        } else if (oldLen !== len || childrenAfterGroup === rowLeafs) {
            if (!childrenAfterGroup || childrenAfterGroup === (0, $437b23f6a393c3bf$export$c758d9371030a6ac) || childrenAfterGroup === rowLeafs) {
                row.childrenAfterGroup = childrenAfterGroup = new Array(len);
                const sibling = row.sibling;
                if (sibling) sibling.childrenAfterGroup = childrenAfterGroup;
            } else childrenAfterGroup.length = len;
        }
    }
    preprocessRows(rootNode) {
        const allLeafs = rootNode._leafs;
        const allLeafsLen = allLeafs.length;
        let preprocessedCount = 0;
        let treeChanged = false;
        for(let i = 0; i < allLeafsLen; ++i){
            let current = allLeafs[i];
            while(true){
                const parent = current.treeParent;
                if (parent === null) break;
                ++preprocessedCount;
                let parentFlags = parent.treeNodeFlags;
                const parentChildren = parent.childrenAfterGroup;
                const indexInParent = parentFlags & $5b7ccabde48fae90$var$MASK_CHILDREN_LEN;
                parentFlags = parentFlags & ~$5b7ccabde48fae90$var$MASK_CHILDREN_LEN | indexInParent + 1;
                if (parentFlags & $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED || parentChildren[indexInParent] !== current) {
                    parentFlags |= $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED;
                    parentChildren[indexInParent] = current;
                    treeChanged = true;
                }
                parent.treeNodeFlags = parentFlags;
                if (parent.data || (parent.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_MARKED_FILLER) === 0 || parent.treeParent === null) break;
                parent.treeNodeFlags = parentFlags & ~$5b7ccabde48fae90$var$FLAG_MARKED_FILLER | current.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_CHANGED;
                current = parent;
            }
        }
        return preprocessedCount | (treeChanged ? $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED : 0);
    }
    traverseRoot(rootNode, activeChangedPath) {
        let traverseCount = 0;
        const rootChildrenAfterGroup = rootNode.childrenAfterGroup;
        for(let i = 0, len = rootChildrenAfterGroup.length; i < len; ++i)traverseCount += this.traverse(rootChildrenAfterGroup[i], 0, false, activeChangedPath);
        return traverseCount & ~$5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED;
    }
    /**
   * After all the rows are initialized and treeParent is set and childrenAfterGroup is filled,
   * we traverse the tree to finalize it
   * @returns the number of leaf nodes processed, which is used to detect cycles in the tree, and a flag set if leaf children were changed.
   */ traverse(row, level, collapsed, activeChangedPath) {
        const children = row.childrenAfterGroup;
        const len = children.length;
        let flags = row.treeNodeFlags;
        row.treeNodeFlags = flags & $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED;
        row.level = level;
        if (row.group !== !!len) {
            $5b7ccabde48fae90$var$setRowNodeGroup(row, this.beans, !!len);
            flags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
        } else if (row.hasChildren() !== !!len) {
            row.updateHasChildren();
            flags |= $5b7ccabde48fae90$var$FLAG_CHANGED;
        }
        if ((flags & ($5b7ccabde48fae90$var$FLAG_CHANGED | $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED)) !== 0) activeChangedPath?.addParentNode(row);
        const canBeExpanded = len !== 0 || row.master;
        if (!canBeExpanded) {
            if (row.expanded) row.expanded = false;
            if ((flags & $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED) !== 0) row.treeNodeFlags &= ~$5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED;
        } else if ((flags & $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED) === 0) {
            row.treeNodeFlags |= $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED;
            row.expanded = $5b7ccabde48fae90$var$_getRowDefaultExpanded(this.beans, row, level);
        }
        if (collapsed && row.rowIndex !== null) row.clearRowTopAndRowIndex();
        collapsed || (collapsed = row.expanded === false);
        ++level;
        flags &= $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED;
        for(let i = 0; i < len; ++i){
            const child = children[i];
            const childFlags = this.traverse(child, level, collapsed, activeChangedPath);
            flags = flags + (childFlags & ~$5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED) | childFlags & $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED;
        }
        if (flags & $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED) row._leafs = void 0;
        return flags + 1;
    }
    /** Handle cycles in a tree. Is not optimal for performance but this is an edge case that shouldn't happen as is a warning. */ handleCycles(rootNode) {
        const marked = /* @__PURE__ */ new Set();
        const mark = (row)=>{
            if (marked.has(row)) return false;
            marked.add(row);
            for (const child of row.childrenAfterGroup)mark(child);
            return true;
        };
        mark(rootNode);
        const rootChildrenAfterGroup = rootNode.childrenAfterGroup;
        rootChildrenAfterGroup.length = 0;
        const allLeafs = rootNode._leafs;
        for(let i = 0, allLeafsLen = allLeafs.length; i < allLeafsLen; ++i){
            const row = allLeafs[i];
            const parent = row.treeParent;
            if (parent && mark(row)) {
                parent.treeNodeFlags |= $5b7ccabde48fae90$var$FLAG_CHILDREN_CHANGED | $5b7ccabde48fae90$var$FLAG_CHANGED;
                row.parent = rootNode;
                (0, $437b23f6a393c3bf$export$83a881c8b5120679)(parent.childrenAfterGroup, row);
                rootChildrenAfterGroup.push(row);
                (0, $437b23f6a393c3bf$export$545083624300f13d)(270, {
                    id: row.id,
                    parentId: parent?.id ?? ""
                });
            } else if (parent === rootNode) rootChildrenAfterGroup.push(row);
        }
    }
    /** Load the tree structure for nested groups, aka children property */ loadNested(rootNode, changedRowNodes, fullReload) {
        if (!fullReload && changedRowNodes) {
            for (const row of changedRowNodes.adds)row.key = row.id;
            return;
        }
        const allLeafs = rootNode._leafs;
        for(let i = 0, allLeafsLen = allLeafs.length; i < allLeafsLen; ++i){
            const row = allLeafs[i];
            const id = row.id;
            if (row.key !== id) $5b7ccabde48fae90$var$updateNodeKey(row, id);
        }
    }
    /** Load the tree structure for self-referencing data, aka parentId field */ loadSelfRef(rootNode, reload) {
        const allLeafs = rootNode._leafs;
        const allLeafsLen = allLeafs.length;
        const gos = this.gos;
        if (!gos.get("getRowId")) {
            for(let i = 0; i < allLeafsLen; i++)allLeafs[i].treeParent = null;
            return;
        }
        const rowModel = this.beans.rowModel;
        const parentIdGetter = this.parentIdGetter;
        for(let i = 0; i < allLeafsLen; i++){
            const row = allLeafs[i];
            if (reload || row.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_CHANGED || row.treeParent?.destroyed) {
                let newParent;
                const parentId = parentIdGetter?.(row.data);
                if (parentId !== null && parentId !== void 0) {
                    newParent = rowModel.getRowNode(parentId);
                    if (!newParent) (0, $437b23f6a393c3bf$export$545083624300f13d)(271, {
                        id: row.id,
                        parentId: parentId
                    });
                }
                row.treeParent = newParent ?? rootNode;
                const id = row.id;
                if (row.key !== id) $5b7ccabde48fae90$var$updateNodeKey(row, id);
            } else row.treeParent ?? (row.treeParent = rootNode);
        }
    }
    loadFlattened(rootNode) {
        const allLeafs = rootNode._leafs;
        for(let i = 0, allLeafsLen = allLeafs.length; i < allLeafsLen; ++i){
            const row = allLeafs[i];
            row.treeParent = rootNode;
            const id = row.id;
            if (row.key !== id) $5b7ccabde48fae90$var$updateNodeKey(row, id);
        }
    }
    /** Load the tree structure for data paths, aka getDataPath callback */ loadDataPath(rootNode, fullReload) {
        const getDataPath = this.gos.get("getDataPath");
        if (!getDataPath) {
            this.loadFlattened(rootNode);
            return;
        }
        const nodesByPath = /* @__PURE__ */ new Map();
        const paths = /* @__PURE__ */ new Map();
        let dupPaths;
        if (!fullReload) dupPaths = this.loadExistingDataPath(rootNode, nodesByPath, paths);
        const allLeafs = rootNode._leafs;
        for(let i = 0, allLeafsLen = allLeafs.length; i < allLeafsLen; ++i){
            const node = allLeafs[i];
            if (!fullReload && node.treeParent !== null && (node.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_CHANGED) === 0) continue;
            const path = getDataPath(node.data);
            const pathLen = path?.length;
            if (!pathLen) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(185, {
                    data: node.data
                });
                continue;
            }
            const key = path[pathLen - 1];
            if (node.key !== key) $5b7ccabde48fae90$var$updateNodeKey(node, key);
            const pathKey = path.join($5b7ccabde48fae90$var$PATH_KEY_SEPARATOR);
            paths.set(node, pathKey);
            const existing = nodesByPath.get(pathKey);
            if (existing === void 0) nodesByPath.set(pathKey, node);
            else if (existing !== node) dupPaths = this.duplicatedPath(nodesByPath, dupPaths, existing, node, pathKey);
        }
        if (dupPaths) this.processDuplicatePaths(dupPaths, paths);
        this.buildFromPaths(rootNode, nodesByPath, paths);
    }
    loadExistingDataPath(rootNode, nodesByPath, paths) {
        let dupPaths;
        const allLeafs = rootNode._leafs;
        for(let i = 0, allLeafsLen = allLeafs.length; i < allLeafsLen; ++i){
            const node = allLeafs[i];
            const treeParent = node.treeParent;
            if (treeParent === null || (node.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_CHANGED) !== 0) continue;
            let pathKey = node.key;
            let current = treeParent;
            while(current && current !== rootNode && current !== node){
                pathKey = $5b7ccabde48fae90$var$PATH_KEY_SEPARATOR + pathKey;
                const existingPathKey = paths.get(current);
                if (existingPathKey !== void 0) {
                    pathKey = existingPathKey + pathKey;
                    break;
                }
                pathKey = current.key + pathKey;
                current = current.treeParent;
            }
            if (current !== node) {
                paths.set(node, pathKey);
                const existing = nodesByPath.get(pathKey);
                if (existing === void 0) nodesByPath.set(pathKey, node);
                else if (existing !== node) dupPaths = this.duplicatedPath(nodesByPath, dupPaths, existing, node, pathKey);
            }
        }
        return dupPaths;
    }
    duplicatedPath(nodesByPath, dupPaths, existing, node, pathKey) {
        if (node.sourceRowIndex < existing.sourceRowIndex) nodesByPath.set(pathKey, node);
        const duplicates = (dupPaths ?? (dupPaths = /* @__PURE__ */ new Map())).get(pathKey);
        if (duplicates === void 0) dupPaths.set(pathKey, [
            existing,
            node
        ]);
        else duplicates.push(node);
        return dupPaths;
    }
    buildFromPaths(rootNode, nodesByPath, paths) {
        const segments = new Array(48);
        const allLeafs = rootNode._leafs;
        for(let i = 0, allLeafsLen = allLeafs.length; i < allLeafsLen; ++i){
            const node = allLeafs[i];
            const pathKey = paths.get(node);
            if (pathKey === void 0) continue;
            const segmentsLen = this.splitPathKey(segments, pathKey);
            let startLevel = 0;
            let treeParent = rootNode;
            for(let level = segmentsLen - 1; level >= 0; --level){
                const existing = nodesByPath.get(pathKey.slice(0, segments[level]));
                if (existing) {
                    treeParent = existing;
                    startLevel = level + 1;
                    break;
                }
            }
            if (startLevel < segmentsLen) treeParent = this.buildMissingFillers(nodesByPath, pathKey, segments, segmentsLen, startLevel, treeParent);
            node.treeParent = treeParent;
        }
    }
    /** Collect separators positions, fast string split without allocations */ splitPathKey(segments, pathKey) {
        let segmentsLen = 0;
        let scanPos = 0;
        const pathKeyLen = pathKey.length;
        while(scanPos < pathKeyLen){
            const sepPos = pathKey.indexOf($5b7ccabde48fae90$var$PATH_KEY_SEPARATOR, scanPos);
            if (sepPos === -1) break;
            segments[segmentsLen++] = sepPos;
            scanPos = sepPos + $5b7ccabde48fae90$var$PATH_KEY_SEPARATOR_LEN;
        }
        return segmentsLen;
    }
    /** Walk forward from startLevel to segmentsLen creating missing filler nodes and return the final parent. */ buildMissingFillers(nodesByPath, pathKey, segments, segmentsLen, level, treeParent) {
        let fillerLevel = 0;
        let fillerId = "row-group";
        if (treeParent.sourceRowIndex < 0 && treeParent.treeParent) {
            fillerLevel = level;
            fillerId = treeParent.id;
        }
        do {
            const start = level === 0 ? 0 : segments[level - 1] + $5b7ccabde48fae90$var$PATH_KEY_SEPARATOR_LEN;
            const end = segments[level];
            const subPath = pathKey.slice(0, end);
            let current = nodesByPath.get(subPath);
            if (current === void 0) {
                const fillerKey = start === 0 ? subPath : pathKey.slice(start, end);
                fillerId = this.makeFillerIdBase(pathKey, segments, level, fillerId, fillerLevel) + fillerKey;
                current = this.getOrCreateFiller(fillerKey, fillerId);
                nodesByPath.set(subPath, current);
                fillerLevel = level + 1;
            } else if (current.sourceRowIndex < 0) {
                fillerId = current.id;
                fillerLevel = level + 1;
            }
            current.treeParent = treeParent;
            treeParent = current;
            ++level;
        }while (level < segmentsLen);
        return treeParent;
    }
    processDuplicatePaths(duplicatePaths, paths) {
        for (const duplicates of duplicatePaths.values()){
            duplicates.sort($5b7ccabde48fae90$var$compareSourceRowIndex);
            const len = duplicates.length;
            const duplicateRowsData = new Array(len - 1);
            for(let i = 1; i < len; ++i){
                const node = duplicates[i];
                paths.delete(node);
                node.treeParent = null;
                duplicateRowsData[i - 1] = node.data;
            }
            const first = duplicates[0];
            (0, $437b23f6a393c3bf$export$545083624300f13d)(186, {
                rowId: first.id,
                rowData: first.data,
                duplicateRowsData: duplicateRowsData
            });
        }
    }
    getOrCreateFiller(key, id) {
        const nonLeafsById = this.nonLeafsById ?? (this.nonLeafsById = /* @__PURE__ */ new Map());
        let node = nonLeafsById.get(id);
        if (node === void 0) {
            node = new (0, $437b23f6a393c3bf$export$6af91cd58ec2edf9)(this.beans);
            node.id = id;
            node.key = key;
            node.group = true;
            node.leafGroup = false;
            node.rowGroupIndex = null;
            nonLeafsById.set(id, node);
        }
        return node;
    }
    /**
   * Build the base filler ID up to the given 'level' and include the final level separator prefix.
   * Caller should append only the 'fillerKey' after this base.
   * Result format:
   * - With no prefix and level === 0: _ROW_ID_PREFIX_ROW_GROUP + '0-'
   * - With no prefix and level > 0: _ROW_ID_PREFIX_ROW_GROUP + '0-key0-1-key1-...-(level-1)-key(level-1)-level-'
   * - With prefix present: prefixId + '-level-'
   */ makeFillerIdBase(pathKey, segments, level, prefix, prefixLevel) {
        while(prefixLevel < level){
            const start = prefixLevel > 0 ? segments[prefixLevel - 1] + $5b7ccabde48fae90$var$PATH_KEY_SEPARATOR_LEN : 0;
            const end = segments[prefixLevel];
            prefix += "-" + prefixLevel + "-" + pathKey.slice(start, end);
            ++prefixLevel;
        }
        return prefix + "-" + level + "-";
    }
    deselectHiddenNodes(updated) {
        const selectionSvc = this.beans.selectionSvc;
        const nodes = this.nodesToUnselect;
        const source = "rowDataChanged";
        if (nodes) {
            this.nodesToUnselect = null;
            selectionSvc?.setNodesSelected({
                newValue: false,
                nodes: nodes,
                suppressFinishActions: true,
                source: source
            });
        }
        if (nodes || updated) selectionSvc?.updateGroupsFromChildrenSelections?.(source);
        if (nodes) {
            const selectedNodes = selectionSvc?.getSelectedNodes() ?? null;
            this.eventSvc.dispatchEvent({
                type: "selectionChanged",
                source: source,
                selectedNodes: selectedNodes,
                serverSideState: null
            });
        }
    }
    hideRow(row) {
        if (row.isSelected()) (this.nodesToUnselect ?? (this.nodesToUnselect = [])).push(row);
        row.parent = null;
        row.group = false;
        row.treeParent = null;
        row.treeNodeFlags = 0;
        row.childrenAfterGroup = (0, $437b23f6a393c3bf$export$c758d9371030a6ac);
        row._leafs = void 0;
        row._groupData = null;
        const sibling = row.sibling;
        if (sibling) sibling.childrenAfterGroup = (0, $437b23f6a393c3bf$export$c758d9371030a6ac);
        row.updateHasChildren();
        if (row.rowIndex !== null) row.clearRowTopAndRowIndex();
    }
    onShowRowGroupColsSetChanged() {
        const allLeafs = this.beans.rowModel.rootNode._leafs;
        if (!allLeafs) return;
        for(let i = 0, len = allLeafs.length; i < len; ++i)allLeafs[i]._groupData = void 0;
        const fillers = this.nonLeafsById;
        if (fillers) for (const rowNode of fillers.values())rowNode._groupData = void 0;
    }
};
var $5b7ccabde48fae90$var$compareSourceRowIndex = (a, b)=>a.sourceRowIndex - b.sourceRowIndex;
var $5b7ccabde48fae90$var$maybeExpandFromRemovedParent = (parent, oldParent)=>{
    if ((oldParent.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED) !== 0 && (parent.treeNodeFlags & $5b7ccabde48fae90$var$FLAG_EXPANDED_INITIALIZED) === 0 && parent.treeParent !== null && parent.sourceRowIndex < 0) {
        parent.expanded = oldParent.expanded;
        return true;
    }
    return false;
};
var $5b7ccabde48fae90$var$updateNodeKey = (node, key)=>{
    const hadData = node._groupData !== void 0;
    node.key = key;
    node.groupValue = key;
    const sibling = node.sibling;
    if (sibling) sibling.key = key;
    if (hadData) {
        node._groupData = void 0;
        node.setData(node.data);
    }
};
// packages/ag-grid-enterprise/src/treeData/treeDataModule.ts
var $5b7ccabde48fae90$var$SharedTreeDataModule = {
    moduleName: "SharedTreeData",
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        $5b7ccabde48fae90$var$SharedAggregationModule,
        $5b7ccabde48fae90$var$GroupColumnModule,
        $5b7ccabde48fae90$var$StickyRowModule
    ]
};
var $5b7ccabde48fae90$export$3460d687131d67ba = {
    moduleName: "TreeData",
    version: $5b7ccabde48fae90$var$VERSION,
    dynamicBeans: {
        treeGroupStrategy: $5b7ccabde48fae90$var$TreeGroupStrategy
    },
    rowModels: [
        "clientSide"
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$SharedTreeDataModule,
        $5b7ccabde48fae90$export$b53def5458540436,
        $5b7ccabde48fae90$var$ClientSideRowModelHierarchyModule,
        $5b7ccabde48fae90$var$GroupEditModule
    ]
};
var $5b7ccabde48fae90$var$GROUP_MISSING_KEY_ID = "ag-Grid-MissingKey";
var $5b7ccabde48fae90$var$BlockUtils = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmBlockUtils";
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
        this.showRowGroupCols = beans.showRowGroupCols;
        this.nodeManager = beans.ssrmNodeManager;
        this.expansionSvc = beans.expansionSvc;
        this.serverSideRowModel = beans.rowModel;
        this.storeFactory = beans.ssrmStoreFactory;
    }
    createRowNode(params) {
        const rowNode = new (0, $437b23f6a393c3bf$export$6af91cd58ec2edf9)(this.beans);
        const rowHeight = params.rowHeight != null ? params.rowHeight : (0, $437b23f6a393c3bf$export$8966875adec41e5b)(this.beans);
        rowNode.setRowHeight(rowHeight);
        rowNode.group = params.group;
        rowNode.leafGroup = params.leafGroup;
        rowNode.level = params.level;
        rowNode.uiLevel = params.level;
        rowNode.parent = params.parent;
        rowNode.stub = true;
        rowNode.__needsRefreshWhenVisible = false;
        if (rowNode.group) {
            rowNode.expanded = false;
            rowNode.field = params.field;
            rowNode.rowGroupColumn = params.rowGroupColumn;
            rowNode.rowGroupIndex = params.level;
        }
        return rowNode;
    }
    destroyRowNode(rowNode, preserveStore = false) {
        if (rowNode.childStore && !preserveStore) {
            this.destroyBean(rowNode.childStore);
            rowNode.childStore = null;
        }
        const sibling = rowNode.sibling;
        if (sibling && !rowNode.footer) this.destroyRowNode(sibling, false);
        rowNode._destroy(true);
        if (rowNode.id != null) this.nodeManager.removeNode(rowNode);
    }
    setTreeGroupInfo(rowNode) {
        rowNode.updateHasChildren();
        const getKeyFunc = this.gos.get("getServerSideGroupKey");
        const hasChildren = rowNode.hasChildren();
        if (hasChildren && getKeyFunc != null) rowNode.key = getKeyFunc(rowNode.data);
        if (!hasChildren && rowNode.childStore != null) {
            this.destroyBean(rowNode.childStore);
            rowNode.childStore = null;
            if (!rowNode.master) rowNode.expanded = false;
        }
    }
    setRowGroupInfo(rowNode) {
        rowNode.key = this.valueSvc.getValue(rowNode.rowGroupColumn, rowNode);
        if (rowNode.key === null || rowNode.key === void 0) (0, $437b23f6a393c3bf$export$e150fb6ea3b45c0d)(()=>{
            (0, $437b23f6a393c3bf$export$545083624300f13d)(190, {
                rowGroupId: rowNode.rowGroupColumn?.getId(),
                data: rowNode.data
            });
        }, "SSBlock-BadKey");
        const isUnbalancedGroup = this.gos.get("groupAllowUnbalanced") && rowNode.key === "";
        if (isUnbalancedGroup) {
            const storeParams = this.serverSideRowModel.getParams();
            rowNode.childStore = this.createBean(this.storeFactory.createStore(storeParams, rowNode));
        }
        const getGroupIncludeFooter = (0, $437b23f6a393c3bf$export$713d6cabeaa7f2a5)(this.beans.gos);
        const doesRowShowFooter = getGroupIncludeFooter({
            node: rowNode
        });
        if (doesRowShowFooter) {
            $5b7ccabde48fae90$var$_createRowNodeFooter(rowNode, this.beans);
            if (rowNode.sibling) rowNode.sibling.uiLevel = rowNode.uiLevel + 1;
        }
    }
    setMasterDetailInfo(rowNode) {
        const isMasterFunc = this.gos.get("isRowMaster");
        if (isMasterFunc != null) rowNode.master = isMasterFunc(rowNode.data);
        else rowNode.master = true;
    }
    updateDataIntoRowNode(rowNode, data) {
        rowNode.updateData(data);
        if (this.gos.get("treeData")) {
            this.setTreeGroupInfo(rowNode);
            this.setChildCountIntoRowNode(rowNode);
            this.updateRowFooter(rowNode);
        } else if (rowNode.group) {
            this.setChildCountIntoRowNode(rowNode);
            this.updateRowFooter(rowNode);
        } else this.gos.get("masterDetail");
    }
    updateRowFooter(rowNode) {
        if (rowNode.footer) return;
        if (rowNode.group) {
            const getGroupIncludeFooter = (0, $437b23f6a393c3bf$export$713d6cabeaa7f2a5)(this.beans.gos);
            const shouldRowShowFooter = getGroupIncludeFooter({
                node: rowNode
            });
            if (shouldRowShowFooter && !rowNode.sibling) {
                $5b7ccabde48fae90$var$_createRowNodeFooter(rowNode, this.beans);
                return;
            }
        }
        if (rowNode.sibling) $5b7ccabde48fae90$var$_destroyRowNodeFooter(rowNode);
    }
    setDataIntoRowNode(rowNode, data, defaultId, cachedRowHeight) {
        rowNode.stub = false;
        const treeData = this.gos.get("treeData");
        rowNode.setDataAndId(data, defaultId);
        const group = rowNode.group;
        if ((treeData || !group) && this.gos.get("masterDetail")) this.setMasterDetailInfo(rowNode);
        if (treeData) this.setTreeGroupInfo(rowNode);
        else if (group) this.setRowGroupInfo(rowNode);
        if (treeData || group) {
            this.setGroupDataIntoRowNode(rowNode);
            this.setChildCountIntoRowNode(rowNode);
        }
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(data)) {
            rowNode.setRowHeight((0, $437b23f6a393c3bf$export$b6de5fa3decc8f7b)(this.beans, rowNode, false, cachedRowHeight).height);
            rowNode.sibling?.setRowHeight((0, $437b23f6a393c3bf$export$b6de5fa3decc8f7b)(this.beans, rowNode.sibling, false, cachedRowHeight).height);
        }
    }
    setChildCountIntoRowNode(rowNode) {
        const getChildCount = this.gos.get("getChildCount");
        if (getChildCount) rowNode.setAllChildrenCount(getChildCount(rowNode.data));
    }
    setGroupDataIntoRowNode(rowNode) {
        const key = rowNode.key;
        rowNode.groupValue = key;
        if (rowNode.sibling) rowNode.sibling.groupValue = key;
        const groupDisplayCols = this.showRowGroupCols?.columns;
        if (!groupDisplayCols) return;
        const usingTreeData = this.gos.get("treeData");
        for (const col of groupDisplayCols){
            let groupData = rowNode._groupData;
            if (!groupData) {
                groupData = {};
                rowNode._groupData = groupData;
            }
            if (usingTreeData) groupData[col.getColId()] = key;
            else if (col.isRowGroupDisplayed(rowNode.rowGroupColumn.getId())) {
                const groupValue = this.valueSvc.getValue(rowNode.rowGroupColumn, rowNode);
                groupData[col.getColId()] = groupValue;
            }
        }
    }
    clearDisplayIndex(rowNode) {
        rowNode.clearRowTopAndRowIndex();
        const hasChildStore = rowNode.hasChildren() && !!rowNode.childStore;
        if (hasChildStore) rowNode.childStore?.clearDisplayIndexes();
        const hasDetailNode = rowNode.master && rowNode.detailNode;
        if (hasDetailNode) rowNode.detailNode?.clearRowTopAndRowIndex();
    }
    setDisplayIndex(rowNode, displayIndexSeq, nextRowTop, uiLevel) {
        const isUnbalancedGroup = this.gos.get("groupAllowUnbalanced") && rowNode.group && rowNode.key === "";
        const isHiddenOpenGroup = this.gos.get("groupHideOpenParents") && rowNode.group && rowNode.expanded;
        if (isHiddenOpenGroup || isUnbalancedGroup) {
            rowNode.setRowIndex(null);
            rowNode.setRowTop(null);
        } else {
            rowNode.setRowIndex(displayIndexSeq.value++);
            rowNode.setRowTop(nextRowTop.value);
            nextRowTop.value += rowNode.rowHeight;
        }
        rowNode.setUiLevel(uiLevel);
        if (rowNode.footer) return;
        const hasDetailRow = rowNode.master;
        if (hasDetailRow) {
            if (rowNode.expanded && rowNode.detailNode) {
                rowNode.detailNode.setRowIndex(displayIndexSeq.value++);
                rowNode.detailNode.setRowTop(nextRowTop.value);
                nextRowTop.value += rowNode.detailNode.rowHeight;
            } else if (rowNode.detailNode) rowNode.detailNode.clearRowTopAndRowIndex();
        }
        const hasChildStore = rowNode.hasChildren() && !!rowNode.childStore;
        if (hasChildStore) {
            const childStore = rowNode.childStore;
            if (rowNode.expanded || isUnbalancedGroup) childStore.setDisplayIndexes(displayIndexSeq, nextRowTop, isUnbalancedGroup ? uiLevel : uiLevel + 1);
            else childStore.clearDisplayIndexes();
        }
    }
    extractRowBounds(rowNode, index) {
        const extractRowBounds = (currentRowNode)=>({
                rowHeight: currentRowNode.rowHeight,
                rowTop: currentRowNode.rowTop
            });
        if (rowNode.rowIndex === index) return extractRowBounds(rowNode);
        if (rowNode.hasChildren() && rowNode.expanded && !!rowNode.childStore) {
            const childStore = rowNode.childStore;
            if (childStore.isDisplayIndexInStore(index)) return childStore.getRowBounds(index);
        } else if (rowNode.master && rowNode.expanded && rowNode.detailNode) {
            if (rowNode.detailNode.rowIndex === index) return extractRowBounds(rowNode.detailNode);
        }
    }
    isPixelInNodeRange(node, pixel) {
        if (!(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(node.rowTop) || !(0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(node.rowHeight)) return false;
        return pixel >= node.rowTop && pixel < node.rowTop + node.rowHeight;
    }
    getIndexAtPixel(rowNode, pixel) {
        if (this.isPixelInNodeRange(rowNode, pixel)) return rowNode.rowIndex;
        const expandedMasterRow = rowNode.master && rowNode.expanded;
        const detailNode = rowNode.detailNode;
        if (expandedMasterRow && detailNode && this.isPixelInNodeRange(detailNode, pixel)) return detailNode.rowIndex;
        if (rowNode.hasChildren() && rowNode.expanded && !!rowNode.childStore) {
            const childStore = rowNode.childStore;
            if (childStore.isPixelInRange(pixel)) return childStore.getRowIndexAtPixel(pixel);
        }
        return null;
    }
    createNodeIdPrefix(parentRowNode) {
        const parts = [];
        let rowNode = parentRowNode;
        while(rowNode && rowNode.level >= 0){
            if (rowNode.key === "") parts.push($5b7ccabde48fae90$var$GROUP_MISSING_KEY_ID);
            else parts.push(rowNode.key);
            rowNode = rowNode.parent;
        }
        if (parts.length > 0) return parts.reverse().join("-");
        return void 0;
    }
    checkOpenByDefault(rowNode) {
        const expanded = !!this.expansionSvc?.isNodeExpanded(rowNode);
        const oldExpanded = rowNode.expanded;
        if (!!oldExpanded !== expanded) rowNode.setExpanded(expanded);
        else if (oldExpanded === void 0) rowNode.expanded = expanded;
    }
};
var $5b7ccabde48fae90$var$ExpandListener = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmExpandListener";
    }
    postConstruct() {
        if (!(0, $437b23f6a393c3bf$export$cf1bac0013650216)(this.gos)) return;
        this.addManagedEventListeners({
            rowExpansionStateChanged: this.onRowExpandStateChanged.bind(this)
        });
    }
    onRowExpandStateChanged() {
        const beans = this.beans;
        const expansionSvx = beans.expansionSvc;
        beans.rowModel.forEachNode((rowNode)=>{
            expansionSvx.updateExpandedState(rowNode);
        });
        this.eventSvc.dispatchEvent({
            type: "storeUpdated"
        });
    }
};
var $5b7ccabde48fae90$var$FilterListener = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmFilterListener";
    }
    wireBeans(beans) {
        this.serverSideRowModel = beans.rowModel;
        this.filterManager = beans.filterManager;
        this.listenerUtils = beans.ssrmListenerUtils;
    }
    postConstruct() {
        if (!(0, $437b23f6a393c3bf$export$cf1bac0013650216)(this.gos)) return;
        this.addManagedEventListeners({
            advancedFilterEnabledChanged: ()=>this.onFilterChanged(true),
            filterChanged: ()=>this.onFilterChanged()
        });
    }
    onFilterChanged(advancedFilterEnabledChanged) {
        const storeParams = this.serverSideRowModel.getParams();
        if (!storeParams) return;
        const oldModel = storeParams.filterModel;
        let newModel;
        let changedColumns;
        if (this.filterManager?.isAdvFilterEnabled()) {
            newModel = this.filterManager.getAdvFilterModel();
            const oldColumns = advancedFilterEnabledChanged ? Object.keys(oldModel ?? {}) : this.getAdvancedFilterColumns(oldModel);
            const newColumns = this.getAdvancedFilterColumns(newModel);
            for (const column of oldColumns)newColumns.add(column);
            changedColumns = Array.from(newColumns);
        } else {
            newModel = this.filterManager?.getFilterModel() ?? {};
            if (advancedFilterEnabledChanged) {
                const oldColumns = this.getAdvancedFilterColumns(oldModel);
                for (const column of Object.keys(newModel))oldColumns.add(column);
                changedColumns = Array.from(oldColumns);
            } else changedColumns = this.findChangedColumns(oldModel, newModel);
        }
        const valueColChanged = this.listenerUtils.isSortingWithValueColumn(changedColumns);
        const secondaryColChanged = this.listenerUtils.isSortingWithSecondaryColumn(changedColumns);
        const params = {
            valueColChanged: valueColChanged,
            secondaryColChanged: secondaryColChanged,
            changedColumns: changedColumns
        };
        this.serverSideRowModel.refreshAfterFilter(newModel, params);
    }
    findChangedColumns(oldModel, newModel) {
        const allColKeysMap = {};
        for (const key of Object.keys(oldModel))allColKeysMap[key] = true;
        for (const key of Object.keys(newModel))allColKeysMap[key] = true;
        const res = [];
        for (const key of Object.keys(allColKeysMap)){
            const oldJson = JSON.stringify(oldModel[key]);
            const newJson = JSON.stringify(newModel[key]);
            const filterChanged = oldJson != newJson;
            if (filterChanged) res.push(key);
        }
        return res;
    }
    getAdvancedFilterColumns(model) {
        const columns = /* @__PURE__ */ new Set();
        if (!model) return columns;
        const processAdvancedFilterModel = (filterModel)=>{
            if (filterModel.filterType === "join") for (const condition of filterModel.conditions)processAdvancedFilterModel(condition);
            else columns.add(filterModel.colId);
        };
        processAdvancedFilterModel(model);
        return columns;
    }
};
var $5b7ccabde48fae90$var$ListenerUtils = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmListenerUtils";
    }
    wireBeans(beans) {
        this.pivotResultCols = beans.pivotResultCols;
        this.valueColsSvc = beans.valueColsSvc;
    }
    isSortingWithValueColumn(changedColumnsInSort) {
        const valueColIds = (this.valueColsSvc?.columns ?? []).map((col)=>col.getColId());
        for(let i = 0; i < changedColumnsInSort.length; i++){
            if (valueColIds.indexOf(changedColumnsInSort[i]) > -1) return true;
        }
        return false;
    }
    isSortingWithSecondaryColumn(changedColumnsInSort) {
        const pivotResultCols = this.pivotResultCols?.getPivotResultCols();
        if (!pivotResultCols) return false;
        const secondaryColIds = pivotResultCols.list.map((col)=>col.getColId());
        for(let i = 0; i < changedColumnsInSort.length; i++){
            if (secondaryColIds.indexOf(changedColumnsInSort[i]) > -1) return true;
        }
        return false;
    }
};
var $5b7ccabde48fae90$var$SortListener = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmSortSvc";
    }
    wireBeans(beans) {
        this.sortSvc = beans.sortSvc;
        this.serverSideRowModel = beans.rowModel;
        this.listenerUtils = beans.ssrmListenerUtils;
    }
    postConstruct() {
        if (!(0, $437b23f6a393c3bf$export$cf1bac0013650216)(this.gos)) return;
        this.addManagedEventListeners({
            sortChanged: this.onSortChanged.bind(this)
        });
    }
    onSortChanged() {
        const storeParams = this.serverSideRowModel.getParams();
        if (!storeParams) return;
        const newSortModel = this.sortSvc.getSortModel();
        const oldSortModel = storeParams.sortModel;
        const changedColumns = this.findChangedColumnsInSort(newSortModel, oldSortModel);
        const valueColChanged = this.listenerUtils.isSortingWithValueColumn(changedColumns);
        const secondaryColChanged = this.listenerUtils.isSortingWithSecondaryColumn(changedColumns);
        const params = {
            valueColChanged: valueColChanged,
            secondaryColChanged: secondaryColChanged,
            changedColumns: changedColumns
        };
        this.serverSideRowModel.refreshAfterSort(newSortModel, params);
    }
    // returns back all the cols that were effected by the sorting. eg if we were sorting by col A,
    // and now we are sorting by col B, the list of impacted cols should be A and B. so if a cache
    // is impacted by sorting on A or B then it needs to be refreshed. this includes where the cache
    // was previously sorted by A and then the A sort now needs to be cleared.
    findChangedColumnsInSort(newSortModel, oldSortModel) {
        let allColsInBothSorts = [];
        for (const sortModel of [
            newSortModel,
            oldSortModel
        ])if (sortModel) {
            const ids = sortModel.map((sm)=>sm.colId);
            allColsInBothSorts = allColsInBothSorts.concat(ids);
        }
        const differentSorts = (oldSortItem, newSortItem)=>{
            const oldSort = oldSortItem ? oldSortItem.sort : null;
            const newSort = newSortItem ? newSortItem.sort : null;
            return oldSort !== newSort;
        };
        const differentIndexes = (oldSortItem, newSortItem)=>{
            const oldIndex = oldSortItem ? oldSortModel.indexOf(oldSortItem) : -1;
            const newIndex = newSortItem ? newSortModel.indexOf(newSortItem) : -1;
            return oldIndex !== newIndex;
        };
        return allColsInBothSorts.filter((colId)=>{
            const oldSortItem = oldSortModel.find((sm)=>sm.colId === colId);
            const newSortItem = newSortModel.find((sm)=>sm.colId === colId);
            return differentSorts(oldSortItem, newSortItem) || differentIndexes(oldSortItem, newSortItem);
        });
    }
};
var $5b7ccabde48fae90$var$NodeManager = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmNodeManager";
        this.rowNodes = /* @__PURE__ */ new Map();
    }
    addRowNode(rowNode) {
        const id = rowNode.id;
        if (this.rowNodes.has(id)) (0, $437b23f6a393c3bf$export$545083624300f13d)(187, {
            rowId: id,
            firstData: this.rowNodes.get(id).data,
            secondData: rowNode.data
        });
        this.rowNodes.set(id, rowNode);
    }
    removeNode(rowNode) {
        const id = rowNode.id;
        this.rowNodes.delete(id);
    }
    destroy() {
        this.clear();
        super.destroy();
    }
    clear() {
        this.rowNodes.clear();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ServerSideRowModel = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
        this.started = false;
        this.managingPivotResultColumns = false;
        this.onRowHeightChanged_debounced = (0, $437b23f6a393c3bf$export$cf7e39bfb94de6e)(this, this.onRowHeightChanged.bind(this), 100);
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.colNames = beans.colNames;
        this.pivotResultCols = beans.pivotResultCols;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.pivotColsSvc = beans.pivotColsSvc;
        this.valueColsSvc = beans.valueColsSvc;
        this.filterManager = beans.filterManager;
        this.sortSvc = beans.sortSvc;
        this.rowRenderer = beans.rowRenderer;
        this.nodeManager = beans.ssrmNodeManager;
        this.storeFactory = beans.ssrmStoreFactory;
        this.pivotColDefSvc = beans.pivotColDefSvc;
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid() {
        return false;
    }
    start() {
        this.started = true;
        this.updateDatasource();
    }
    destroyDatasource() {
        if (!this.datasource) return;
        if (this.datasource.destroy) this.datasource.destroy();
        this.rowRenderer.datasourceChanged();
        this.datasource = void 0;
    }
    postConstruct() {
        const resetListener = this.resetRootStore.bind(this);
        this.addManagedEventListeners({
            newColumnsLoaded: this.onColumnEverything.bind(this),
            storeUpdated: this.onStoreUpdated.bind(this),
            columnValueChanged: resetListener,
            columnPivotChanged: resetListener,
            columnRowGroupChanged: resetListener,
            columnPivotModeChanged: resetListener
        });
        this.addManagedPropertyListeners([
            /**
         * Following properties omitted as they are likely to come with undesired  side effects.
         * 'getRowId', 'isRowMaster', 'getRowHeight', 'isServerSideGroup', 'getServerSideGroupKey',
         * */ "masterDetail",
            "treeData",
            "removePivotHeaderRowWhenSingleValueColumn",
            "cacheBlockSize"
        ], resetListener);
        this.addManagedPropertyListeners([
            "groupAllowUnbalanced",
            "groupTotalRow"
        ], ()=>this.onStoreUpdated());
        this.addManagedPropertyListener("rowHeight", ()=>this.resetRowHeights());
        this.verifyProps();
        this.addManagedPropertyListener("serverSideDatasource", ()=>this.updateDatasource());
    }
    updateDatasource() {
        const datasource = this.gos.get("serverSideDatasource");
        if (datasource) this.setDatasource(datasource);
    }
    verifyProps() {
        if ((0, $437b23f6a393c3bf$export$5d5fd838f5df1dd2)(this.gos) && !this.gos.exists("getRowId")) (0, $437b23f6a393c3bf$export$545083624300f13d)(188, {
            feature: "selection"
        });
    }
    setDatasource(datasource) {
        if (!this.started) return;
        this.destroyDatasource();
        this.datasource = datasource;
        this.resetRootStore();
    }
    applyRowData(rowDataParams, startRow, route) {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        const storeToExecuteOn = rootStore.getChildStore(route);
        if (!storeToExecuteOn) return;
        storeToExecuteOn.applyRowData(rowDataParams, startRow, rowDataParams.rowData.length);
    }
    isLastRowIndexKnown() {
        const cache = this.getRootStore();
        if (!cache) return false;
        return cache.isLastRowIndexKnown();
    }
    onColumnEverything() {
        if (!this.storeParams) {
            this.resetRootStore();
            return;
        }
        const rowGroupColumnVos = this.columnsToValueObjects(this.rowGroupColsSvc?.columns);
        const valueColumnVos = this.columnsToValueObjects(this.valueColsSvc?.columns);
        const pivotColumnVos = this.columnsToValueObjects(this.pivotColsSvc?.columns);
        const areColsSame = (params)=>{
            const oldColsMap = {};
            for (const col of params.oldCols)oldColsMap[col.id] = col;
            const allColsUnchanged = params.newCols.every((col)=>{
                const equivalentCol = oldColsMap[col.id];
                if (equivalentCol) delete oldColsMap[col.id];
                return equivalentCol && equivalentCol.field === col.field && equivalentCol.aggFunc === col.aggFunc;
            });
            const missingCols = !params.allowRemovedColumns && !!Object.values(oldColsMap).length;
            return allColsUnchanged && !missingCols;
        };
        const sortModelDifferent = !(0, $437b23f6a393c3bf$export$dbc2068cc90f5875)(this.storeParams.sortModel, this.sortSvc?.getSortModel() ?? []);
        const rowGroupDifferent = !areColsSame({
            oldCols: this.storeParams.rowGroupCols,
            newCols: rowGroupColumnVos
        });
        const pivotDifferent = !areColsSame({
            oldCols: this.storeParams.pivotCols,
            newCols: pivotColumnVos
        });
        const valuesDifferent = !!rowGroupColumnVos?.length && !areColsSame({
            oldCols: this.storeParams.valueCols,
            newCols: valueColumnVos,
            allowRemovedColumns: true
        });
        const resetRequired = sortModelDifferent || rowGroupDifferent || pivotDifferent || valuesDifferent;
        if (resetRequired) this.resetRootStore();
        else {
            const newParams = this.createStoreParams();
            this.storeParams.rowGroupCols = newParams.rowGroupCols;
            this.storeParams.pivotCols = newParams.pivotCols;
            this.storeParams.valueCols = newParams.valueCols;
        }
    }
    destroyRootStore() {
        if (!this.rootNode?.childStore) return;
        this.rootNode.childStore = this.destroyBean(this.rootNode.childStore);
        this.nodeManager.clear();
    }
    refreshAfterSort(newSortModel, params) {
        if (this.storeParams) this.storeParams.sortModel = newSortModel;
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.refreshAfterSort(params);
        this.onStoreUpdated();
    }
    generateSecondaryColumns(pivotFields) {
        if (!this.pivotColDefSvc) {
            this.gos.assertModuleRegistered("SharedPivot", 2);
            return;
        }
        const pivotColumnGroupDefs = this.pivotColDefSvc.createColDefsFromFields(pivotFields);
        this.managingPivotResultColumns = true;
        this.pivotResultCols?.setPivotResultCols(pivotColumnGroupDefs, "rowModelUpdated");
    }
    resetRowHeights() {
        const atLeastOne = this.resetRowHeightsForAllRowNodes();
        const rootNodeHeight = (0, $437b23f6a393c3bf$export$b6de5fa3decc8f7b)(this.beans, this.rootNode);
        this.rootNode.setRowHeight(rootNodeHeight.height, rootNodeHeight.estimated);
        if (this.rootNode.sibling) {
            const rootNodeSibling = (0, $437b23f6a393c3bf$export$b6de5fa3decc8f7b)(this.beans, this.rootNode.sibling);
            this.rootNode.sibling.setRowHeight(rootNodeSibling.height, rootNodeSibling.estimated);
        }
        if (atLeastOne) this.onRowHeightChanged();
    }
    resetRowHeightsForAllRowNodes() {
        let atLeastOne = false;
        this.forEachNode((rowNode)=>{
            const rowHeightForNode = (0, $437b23f6a393c3bf$export$b6de5fa3decc8f7b)(this.beans, rowNode);
            rowNode.setRowHeight(rowHeightForNode.height, rowHeightForNode.estimated);
            const detailNode = rowNode.detailNode;
            if (detailNode) {
                const detailRowHeight = (0, $437b23f6a393c3bf$export$b6de5fa3decc8f7b)(this.beans, detailNode);
                detailNode.setRowHeight(detailRowHeight.height, detailRowHeight.estimated);
            }
            if (rowNode.sibling) {
                const siblingRowHeight = (0, $437b23f6a393c3bf$export$b6de5fa3decc8f7b)(this.beans, rowNode.sibling);
                detailNode?.setRowHeight(siblingRowHeight.height, siblingRowHeight.estimated);
            }
            atLeastOne = true;
        });
        return atLeastOne;
    }
    resetRootStore() {
        this.destroyRootStore();
        this.rootNode = new (0, $437b23f6a393c3bf$export$6af91cd58ec2edf9)(this.beans);
        this.rootNode.group = true;
        this.rootNode.level = -1;
        if (this.datasource) {
            this.storeParams = this.createStoreParams();
            this.rootNode.childStore = this.createBean(this.storeFactory.createStore(this.storeParams, this.rootNode));
            this.updateRowIndexesAndBounds();
        }
        if (this.managingPivotResultColumns) {
            this.pivotResultCols?.setPivotResultCols(null, "api");
            this.managingPivotResultColumns = false;
        }
        this.dispatchModelUpdated(true);
    }
    columnsToValueObjects(columns = []) {
        return columns.map((col)=>({
                id: col.getId(),
                aggFunc: col.getAggFunc(),
                displayName: this.colNames.getDisplayNameForColumn(col, "model"),
                field: col.getColDef().field
            }));
    }
    createStoreParams() {
        const rowGroupColumnVos = this.columnsToValueObjects(this.rowGroupColsSvc?.columns);
        const valueColumnVos = this.columnsToValueObjects(this.valueColsSvc?.columns);
        const pivotColumnVos = this.columnsToValueObjects(this.pivotColsSvc?.columns);
        const dynamicRowHeight = (0, $437b23f6a393c3bf$export$f0ddd2d4ccc7fed8)(this.gos);
        const params = {
            // the columns the user has grouped and aggregated by
            valueCols: valueColumnVos,
            rowGroupCols: rowGroupColumnVos,
            pivotCols: pivotColumnVos,
            pivotMode: this.colModel.isPivotMode(),
            // sort and filter model
            filterModel: this.filterManager?.isAdvFilterEnabled() ? this.filterManager?.getAdvFilterModel() : this.filterManager?.getFilterModel() ?? {},
            sortModel: this.sortSvc?.getSortModel() ?? [],
            datasource: this.datasource,
            lastAccessedSequence: {
                value: 0
            },
            dynamicRowHeight: // blockSize: blockSize == null ? 100 : blockSize,
            dynamicRowHeight
        };
        return params;
    }
    getParams() {
        return this.storeParams;
    }
    dispatchModelUpdated(reset = false) {
        this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            animate: !reset,
            keepRenderedRows: !reset,
            newPage: false,
            newData: false
        });
    }
    onStoreUpdated() {
        this.updateRowIndexesAndBounds();
        this.dispatchModelUpdated();
    }
    onRowHeightChanged() {
        this.updateRowIndexesAndBounds();
        this.dispatchModelUpdated();
    }
    updateRowIndexesAndBounds() {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.setDisplayIndexes({
            value: 0
        }, {
            value: 0
        }, 0);
    }
    retryLoads() {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.retryLoads();
        this.onStoreUpdated();
    }
    getRow(index) {
        const rootStore = this.getRootStore();
        if (!rootStore) return void 0;
        return rootStore.getRowUsingDisplayIndex(index);
    }
    refreshAfterFilter(newFilterModel, params) {
        if (this.storeParams) this.storeParams.filterModel = newFilterModel;
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.refreshAfterFilter(params);
        this.onStoreUpdated();
    }
    getRootStore() {
        return this.rootNode?.childStore;
    }
    getRowCount() {
        const rootStore = this.getRootStore();
        if (!rootStore) return 0;
        return rootStore.getDisplayIndexEnd();
    }
    getTopLevelRowCount() {
        const rootStore = this.getRootStore();
        if (!rootStore) return 1;
        return rootStore.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        const rootStore = this.getRootStore();
        if (!rootStore) return topLevelIndex;
        return rootStore.getTopLevelRowDisplayedIndex(topLevelIndex);
    }
    getRowBounds(index) {
        const rootStore = this.getRootStore();
        if (!rootStore) {
            const rowHeight = (0, $437b23f6a393c3bf$export$8966875adec41e5b)(this.beans);
            return {
                rowTop: 0,
                rowHeight: rowHeight
            };
        }
        return rootStore.getRowBounds(index);
    }
    getBlockStates() {
        const root = this.getRootStore();
        if (!root) return void 0;
        const states = {};
        root.forEachStoreDeep((store)=>{
            const blockStates = store.getBlockStates();
            for (const block of Object.keys(blockStates))states[block] = blockStates[block];
        });
        return states;
    }
    getRowIndexAtPixel(pixel) {
        const rootStore = this.getRootStore();
        if (pixel <= 0 || !rootStore) return 0;
        return rootStore.getRowIndexAtPixel(pixel);
    }
    isEmpty() {
        return false;
    }
    getOverlayType() {
        const rootStore = this.getRootStore();
        if (rootStore?.getDisplayIndexEnd() === 0) return this.filterManager?.isAnyFilterPresent() ? "noMatchingRows" : "noRows";
        return null;
    }
    isRowsToRender() {
        return this.getRootStore() != null && this.getRowCount() > 0;
    }
    getType() {
        return "serverSide";
    }
    forEachNode(callback) {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.forEachNodeDeep(callback);
    }
    forEachDisplayedNode(callback) {
        const wrappedCallback = (node, index)=>{
            if (node.stub || !node.displayed) return;
            callback(node, index);
        };
        this.forEachNode(wrappedCallback);
    }
    forEachNodeAfterFilterAndSort(callback, includeFooterNodes = false) {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.forEachNodeDeepAfterFilterAndSort(callback, void 0, includeFooterNodes);
    }
    /** @returns false if store hasn't started */ executeOnStore(route, callback) {
        if (!this.started) return false;
        const rootStore = this.getRootStore();
        if (!rootStore) return true;
        const storeToExecuteOn = rootStore.getChildStore(route);
        if (storeToExecuteOn) callback(storeToExecuteOn);
        return true;
    }
    refreshStore(params = {}) {
        const route = params.route ? params.route : [];
        this.executeOnStore(route, (store)=>store.refreshStore(params.purge == true));
    }
    getStoreState() {
        const res = [];
        const rootStore = this.getRootStore();
        if (rootStore) rootStore.addStoreStates(res);
        return res;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        const startIndex = firstInRange.rowIndex;
        const endIndex = lastInRange.rowIndex;
        if (startIndex === null && endIndex === null) return [];
        if (endIndex === null) return firstInRange ? [
            firstInRange
        ] : [];
        if (startIndex === null) return [
            lastInRange
        ];
        const nodeRange = [];
        const [firstIndex, lastIndex] = [
            startIndex,
            endIndex
        ].sort((a, b)=>a - b);
        this.forEachNode((node)=>{
            const thisRowIndex = node.rowIndex;
            if (thisRowIndex == null || node.stub) return;
            if (thisRowIndex >= firstIndex && thisRowIndex <= lastIndex) nodeRange.push(node);
        });
        if (nodeRange.length !== lastIndex - firstIndex + 1) return null;
        return nodeRange;
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
            if (rowNode.detailNode && rowNode.detailNode.id === id) result = rowNode.detailNode;
        });
        return result;
    }
    isRowPresent(rowNode) {
        const foundRowNode = this.getRowNode(rowNode.id);
        return !!foundRowNode;
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.setRowCount(rowCount, lastRowIndexKnown);
    }
    destroy() {
        this.destroyDatasource();
        this.destroyRootStore();
        super.destroy();
    }
    /**
   * @deprecated v33.1
   */ onRowHeightChangedDebounced() {
        this.onRowHeightChanged_debounced();
    }
};
function $5b7ccabde48fae90$var$getServerSideSelectionState(beans) {
    return beans.selectionSvc?.getSelectionState() ?? null;
}
function $5b7ccabde48fae90$var$setServerSideSelectionState(beans, state) {
    beans.selectionSvc?.setSelectionState(state, "api");
}
function $5b7ccabde48fae90$var$applyServerSideTransaction(beans, transaction) {
    return beans.ssrmTxnManager?.applyTransaction(transaction);
}
function $5b7ccabde48fae90$var$applyServerSideRowData(beans, params) {
    const startRow = params.startRow ?? 0;
    const route = params.route ?? [];
    if (startRow < 0) {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(189, {
            startRow: startRow
        });
        return;
    }
    (0, $437b23f6a393c3bf$export$aada92189a74e985)(beans)?.applyRowData(params.successParams, startRow, route);
}
function $5b7ccabde48fae90$var$applyServerSideTransactionAsync(beans, transaction, callback) {
    return beans.ssrmTxnManager?.applyTransactionAsync(transaction, callback);
}
function $5b7ccabde48fae90$var$retryServerSideLoads(beans) {
    (0, $437b23f6a393c3bf$export$aada92189a74e985)(beans)?.retryLoads();
}
function $5b7ccabde48fae90$var$flushServerSideAsyncTransactions(beans) {
    return beans.ssrmTxnManager?.flushAsyncTransactions();
}
function $5b7ccabde48fae90$var$refreshServerSide(beans, params) {
    (0, $437b23f6a393c3bf$export$aada92189a74e985)(beans)?.refreshStore(params);
}
function $5b7ccabde48fae90$var$getServerSideGroupLevelState(beans) {
    return (0, $437b23f6a393c3bf$export$aada92189a74e985)(beans)?.getStoreState() ?? [];
}
var $5b7ccabde48fae90$var$ExpandStrategy = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.name = "expand";
        this.expanded = /* @__PURE__ */ new Set();
        this.collapsed = /* @__PURE__ */ new Set();
        this.initialState = /* @__PURE__ */ new Map();
    }
    /**
   * Set the expanded and collapsed rows.
   * @param expandedRows the rows to expand
   * @param touchedRows the rows that have been touched
   */ setExpandedState({ expandedRowGroupIds: expandedRowGroupIds, collapsedRowGroupIds: collapsedRowGroupIds }) {
        this.expanded = new Set(expandedRowGroupIds);
        this.collapsed = new Set(collapsedRowGroupIds);
        for (const node of this.expanded)this.initialState.set(node, false);
        for (const node of this.collapsed)this.initialState.set(node, true);
    }
    /**
   * Get the serializable expanded state
   * @returns an object containing the expanded and collapsed rows
   */ getExpandedState() {
        return {
            expandedRowGroupIds: Array.from(this.expanded),
            collapsedRowGroupIds: Array.from(this.collapsed)
        };
    }
    /**
   * Set the expanded state for a row.
   * @param row the row to expand/collapse
   * @param expanded true to expand the row, false to collapse it
   */ setRowExpanded(row, expanded) {
        const id = row.id;
        const stateIsDefault = this.initialState.get(id) === expanded;
        if (expanded) {
            this.collapsed.delete(id);
            if (!stateIsDefault) this.expanded.add(id);
            return;
        }
        this.expanded.delete(id);
        if (!stateIsDefault) this.collapsed.add(id);
    }
    /**
   * Check if a row is expanded.
   * @param rowId the row id to check
   * @returns true if the row is expanded
   */ isRowExpanded(node) {
        const rowId = node.id;
        if (this.expanded.has(rowId)) return true;
        if (this.collapsed.has(rowId)) return false;
        const initialVal = this.initialState.get(rowId);
        if (initialVal != null) return initialVal;
        const initial = this.getInitialRowState(node);
        this.initialState.set(rowId, initial);
        return initial;
    }
    /**
   * This is different from just checking expandedState.isExpanded(rowNode.id),
   * as this correctly prioritizes user interaction over the user-defined initial state.
   * Plus sanity checks that the rowNode is actually expandable.
   */ getInitialRowState(rowNode) {
        if (!rowNode.isExpandable()) return false;
        const userFunc = this.gos.getCallback("isServerSideGroupOpenByDefault");
        if (!userFunc) return false;
        const params = {
            data: rowNode.data,
            rowNode: rowNode
        };
        return userFunc(params);
    }
    /**
   * if the row is expanded or has been collapsed intentionally, do not apply initial state.
   * @param rowId the row id to check
   * @returns true if the row has been toggled
   */ isRowInitialised(rowId) {
        return this.initialState.has(rowId);
    }
    /**
   * Expand or collapse all loaded rows.
   * @param expanded true to expand all rows, false to collapse all rows
   */ expandAll(expanded) {
        this.beans.rowModel.forEachNode((node)=>{
            this.setRowExpanded(node, expanded);
        });
    }
};
var $5b7ccabde48fae90$var$ExpandAllStrategy = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.name = "expandAll";
        this.allExpanded = void 0;
        this.flipped = /* @__PURE__ */ new Set();
    }
    setExpandedState(state) {
        this.allExpanded = state.expandAll;
        this.flipped = new Set(state.invertedRowGroupIds);
    }
    getExpandedState() {
        return {
            expandAll: this.allExpanded,
            invertedRowGroupIds: Array.from(this.flipped)
        };
    }
    setRowExpanded(row, expanded) {
        const id = row.id;
        if (expanded === this.allExpanded) {
            this.flipped.delete(id);
            return;
        }
        this.flipped.add(id);
    }
    isRowExpanded(node) {
        const rowId = node.id;
        return this.allExpanded !== this.flipped.has(rowId);
    }
    isRowInitialised() {
        return true;
    }
    expandAll(expanded) {
        this.allExpanded = expanded;
        this.flipped.clear();
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/services/serverSideExpansionService.ts
var $5b7ccabde48fae90$var$ServerSideExpansionService = class extends $5b7ccabde48fae90$var$BaseExpansionService {
    constructor(){
        super(...arguments);
        this.beanName = "expansionSvc";
    }
    wireBeans(beans) {
        this.serverSideRowModel = beans.rowModel;
        this.storeFactory = beans.ssrmStoreFactory;
    }
    postConstruct() {
        const setDefaultExpand = ()=>{
            this.strategy = this.createManagedBean(new $5b7ccabde48fae90$var$ExpandStrategy());
        };
        this.addManagedEventListeners({
            // when row grouping / pivot changes, the old expand all state is no longer valid as rows changed
            columnRowGroupChanged: setDefaultExpand,
            columnPivotChanged: setDefaultExpand,
            columnPivotModeChanged: setDefaultExpand
        });
        this.addManagedPropertyListener("ssrmExpandAllAffectsAllRows", (p)=>{
            if (!p.currentValue) {
                this.strategy = this.createManagedBean(new $5b7ccabde48fae90$var$ExpandStrategy());
                this.updateAllNodes();
                this.dispatchStateUpdatedEvent();
            }
        });
        setDefaultExpand();
    }
    setExpansionState(state) {
        const isExpandAllState = "expandAll" in state;
        const isExpandAllStrategy = this.isExpandAllStrategy(this.strategy);
        if (isExpandAllState !== isExpandAllStrategy) this.strategy = isExpandAllState ? this.createManagedBean(new $5b7ccabde48fae90$var$ExpandAllStrategy()) : this.createManagedBean(new $5b7ccabde48fae90$var$ExpandStrategy());
        this.strategy.setExpandedState(state);
        this.dispatchStateUpdatedEvent();
        this.updateAllNodes();
    }
    getExpansionState() {
        return this.strategy.getExpandedState();
    }
    /**
   * Updates all nodes to the correct expanded/collapsed state.
   */ updateAllNodes() {
        this.serverSideRowModel.forEachNode((node)=>{
            super.setExpanded(node, this.isNodeExpanded(node));
        });
    }
    isNodeExpanded(node) {
        return this.strategy.isRowExpanded(node);
    }
    setExpanded(node, expanded, e, _) {
        this.strategy.setRowExpanded(node, expanded);
        super.setExpanded(node, expanded, e);
        this.dispatchStateUpdatedEvent();
        this.updateExpandedState(node);
    }
    expandAll(expanded) {
        const ssrmExpandAllAffectsAllRows = this.beans.gos.get("ssrmExpandAllAffectsAllRows");
        const shouldUseExpandAllStrategy = !this.isExpandAllStrategy(this.strategy) && ssrmExpandAllAffectsAllRows;
        this.strategy = shouldUseExpandAllStrategy ? new $5b7ccabde48fae90$var$ExpandAllStrategy() : this.strategy;
        this.strategy.expandAll(expanded);
        this.updateAllNodes();
        this.dispatchStateUpdatedEvent();
        this.beans.eventSvc.dispatchEvent({
            type: "expandOrCollapseAll",
            source: expanded ? "expandAll" : "collapseAll"
        });
    }
    isExpandAllStrategy(strategy) {
        return strategy.name === "expandAll";
    }
    onGroupExpandedOrCollapsed() {}
    setDetailsExpansionState(detailGridApi) {
        const { gos: masterGos } = this.beans;
        if (!masterGos.get("ssrmExpandAllAffectsAllRows")) return;
        const masterExpansionState = this.getExpansionState();
        const isInitial = masterExpansionState.expandAll === void 0;
        if (isInitial) return;
        const allExpanded = masterExpansionState.expandAll && masterExpansionState.invertedRowGroupIds.length === 0;
        const allCollapsed = !masterExpansionState.expandAll && masterExpansionState.invertedRowGroupIds.length === 0;
        if (allCollapsed === allExpanded) return;
        return allExpanded ? detailGridApi.expandAll() : detailGridApi.collapseAll();
    }
    dispatchExpandedEvent(event) {
        this.eventSvc.dispatchEvent(event);
        this.beans.rowRenderer.refreshCells({
            rowNodes: [
                event.node
            ]
        });
    }
    updateExpandedState(rowNode) {
        const oldChildStore = rowNode.childStore;
        if (rowNode.expanded) {
            if (rowNode.master && !rowNode.detailNode) rowNode.detailNode = this.createDetailNode(rowNode);
            if (!oldChildStore && rowNode.hasChildren()) {
                const storeParams = this.serverSideRowModel.getParams();
                rowNode.childStore = this.createBean(this.storeFactory.createStore(storeParams, rowNode));
            }
        } else if (oldChildStore && this.gos.get("purgeClosedRowNodes")) rowNode.childStore = this.destroyBean(oldChildStore);
    }
    createDetailNode(masterNode) {
        const detailNode = new (0, $437b23f6a393c3bf$export$6af91cd58ec2edf9)(this.beans);
        detailNode.detail = true;
        detailNode.selectable = false;
        detailNode.parent = masterNode;
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(masterNode.id)) detailNode.id = "detail_" + masterNode.id;
        detailNode.data = masterNode.data;
        detailNode.level = masterNode.level + 1;
        const defaultDetailRowHeight = 200;
        const rowHeight = (0, $437b23f6a393c3bf$export$b6de5fa3decc8f7b)(this.beans, detailNode).height;
        detailNode.rowHeight = rowHeight ? rowHeight : defaultDetailRowHeight;
        return detailNode;
    }
};
var $5b7ccabde48fae90$var$DefaultStrategy = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(selectionCtx){
        super();
        this.selectionCtx = selectionCtx;
        this.selectedState = {
            selectAll: false,
            toggledNodes: /* @__PURE__ */ new Set()
        };
        /**
     * Whether select-all functionality has ever been used. Used only to print warnings in `getSelectedNodes` for users.
     * We print a warning even if not currently selecting all because we want users to be aware of the potential
     * for unexpected behaviour when these two features are used together.
     */ this.selectAllUsed = false;
        /** This is to prevent regressions, default selectionSvc retains reference of selected nodes. */ this.selectedNodes = {};
    }
    getSelectedState() {
        return {
            selectAll: this.selectedState.selectAll,
            toggledNodes: [
                ...this.selectedState.toggledNodes
            ]
        };
    }
    setSelectedState(state) {
        if (typeof state !== "object") {
            (0, $437b23f6a393c3bf$export$a20c7248650823a9)(116);
            return;
        }
        if (!("selectAll" in state)) {
            (0, $437b23f6a393c3bf$export$a20c7248650823a9)(116);
            return;
        }
        if (typeof state.selectAll !== "boolean") {
            (0, $437b23f6a393c3bf$export$a20c7248650823a9)(117);
            return;
        }
        if (!("toggledNodes" in state) || !Array.isArray(state.toggledNodes)) return (0, $437b23f6a393c3bf$export$545083624300f13d)(197);
        const newState = {
            selectAll: state.selectAll,
            toggledNodes: /* @__PURE__ */ new Set()
        };
        state.toggledNodes.forEach((key)=>{
            if (typeof key === "string") newState.toggledNodes.add(key);
            else (0, $437b23f6a393c3bf$export$545083624300f13d)(196, {
                key: key
            });
        });
        const isSelectingMultipleRows = newState.selectAll || newState.toggledNodes.size > 1;
        if ((0, $437b23f6a393c3bf$export$d3c80fcacb2e2d55)(this.gos) && !(0, $437b23f6a393c3bf$export$7bd8c52ebc4117d6)(this.gos) && isSelectingMultipleRows) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(130);
            return;
        }
        this.selectedState = newState;
    }
    deleteSelectionStateFromParent(parentPath, removedNodeIds) {
        if (this.selectedState.toggledNodes.size === 0) return false;
        let anyNodesToggled = false;
        for (const id of removedNodeIds)if (this.selectedState.toggledNodes.delete(id)) anyNodesToggled = true;
        return anyNodesToggled;
    }
    setNodesSelected(params) {
        const { nodes: nodes, clearSelection: clearSelection, newValue: newValue, source: source } = params;
        if (nodes.length === 0) return 0;
        const onlyThisNode = clearSelection && newValue;
        if (!(0, $437b23f6a393c3bf$export$7bd8c52ebc4117d6)(this.gos) || onlyThisNode) {
            if (nodes.length > 1) {
                (0, $437b23f6a393c3bf$export$a20c7248650823a9)(130);
                return 0;
            }
            const rowNode = nodes[0];
            const node = rowNode.footer ? rowNode.sibling : rowNode;
            if (newValue && node.selectable) {
                this.selectedNodes = {
                    [node.id]: node
                };
                this.selectedState = {
                    selectAll: false,
                    toggledNodes: /* @__PURE__ */ new Set([
                        node.id
                    ])
                };
            } else {
                this.selectedNodes = {};
                this.selectedState = {
                    selectAll: false,
                    toggledNodes: /* @__PURE__ */ new Set()
                };
            }
            return 1;
        }
        const updateNodeState = (rowNode, value = newValue)=>{
            const node = rowNode.footer ? rowNode.sibling : rowNode;
            if (value && node.selectable) this.selectedNodes[node.id] = node;
            else delete this.selectedNodes[node.id];
            const doesNodeConform = value === this.selectedState.selectAll;
            if (doesNodeConform || !node.selectable) this.selectedState.toggledNodes.delete(node.id);
            else this.selectedState.toggledNodes.add(node.id);
        };
        for (const node of nodes)updateNodeState(node);
        if (nodes.length === 1 && source === "api") this.selectionCtx.setRoot(nodes[0].footer ? nodes[0].sibling : nodes[0]);
        return 1;
    }
    processNewRow(node) {
        if (this.selectedNodes[node.id]) this.selectedNodes[node.id] = node;
    }
    isNodeSelected(node) {
        const isToggled = this.selectedState.toggledNodes.has(node.id);
        return this.selectedState.selectAll ? !isToggled : isToggled;
    }
    getSelectedNodes(nullWhenSelectAll = false, warnWhenSelectAll = true) {
        const { selectedState: { selectAll: selectAll }, selectedNodes: selectedNodes, selectAllUsed: selectAllUsed } = this;
        if (warnWhenSelectAll && selectAllUsed) (0, $437b23f6a393c3bf$export$545083624300f13d)(199);
        return nullWhenSelectAll && selectAll ? null : Object.values(selectedNodes);
    }
    getSelectedRows() {
        return (this.getSelectedNodes() ?? []).map((node)=>node.data);
    }
    getSelectionCount() {
        if (this.selectedState.selectAll) return -1;
        return this.selectedState.toggledNodes.size;
    }
    isEmpty() {
        return !this.selectedState.selectAll && !this.selectedState.toggledNodes?.size;
    }
    selectAllRowNodes() {
        this.reset(true);
    }
    deselectAllRowNodes() {
        this.reset(false);
    }
    reset(selectAll) {
        this.selectedState = {
            selectAll: selectAll,
            toggledNodes: /* @__PURE__ */ new Set()
        };
        this.selectedNodes = {};
        this.selectAllUsed || (this.selectAllUsed = selectAll);
    }
    getSelectAllState() {
        if (this.selectedState.selectAll) {
            if (this.selectedState.toggledNodes.size > 0) return null;
            return true;
        }
        if (this.selectedState.toggledNodes.size > 0) return null;
        return false;
    }
};
var $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(selectionCtx){
        super();
        this.selectionCtx = selectionCtx;
        this.selectedState = {
            selectAllChildren: false,
            toggledNodes: /* @__PURE__ */ new Map()
        };
    }
    wireBeans(beans) {
        this.rowModel = beans.rowModel;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.filterManager = beans.filterManager;
        this.selectionSvc = beans.selectionSvc;
    }
    postConstruct() {
        this.addManagedEventListeners({
            // if model has updated, a store may now be fully loaded to clean up indeterminate states
            modelUpdated: ()=>this.removeRedundantState(),
            // when the grouping changes, the state no longer makes sense, so reset the state.
            columnRowGroupChanged: ()=>this.selectionSvc.reset("rowGroupChanged")
        });
    }
    getSelectedState() {
        const { gos: gos, rowGroupColsSvc: rowGroupColsSvc, selectedState: selectedState } = this;
        const treeData = gos.get("treeData");
        const recursivelySerializeState = (state, level, nodeId)=>{
            const normalisedState = {
                nodeId: nodeId
            };
            if (treeData || rowGroupColsSvc && level <= rowGroupColsSvc.columns.length) normalisedState.selectAllChildren = state.selectAllChildren;
            if (state.toggledNodes.size) {
                const toggledNodes = [];
                state.toggledNodes.forEach((value, key)=>{
                    const newState = recursivelySerializeState(value, level + 1, key);
                    toggledNodes.push(newState);
                });
                normalisedState.toggledNodes = toggledNodes;
            }
            return normalisedState;
        };
        return recursivelySerializeState(selectedState, 0);
    }
    setSelectedState(state) {
        if ("selectAll" in state) {
            (0, $437b23f6a393c3bf$export$a20c7248650823a9)(111);
            return;
        }
        const recursivelyDeserializeState = (normalisedState, parentSelected)=>{
            if (typeof normalisedState !== "object") {
                (0, $437b23f6a393c3bf$export$a20c7248650823a9)(243);
                throw new Error();
            }
            if ("selectAllChildren" in normalisedState && typeof normalisedState.selectAllChildren !== "boolean") {
                (0, $437b23f6a393c3bf$export$a20c7248650823a9)(244);
                throw new Error();
            }
            if ("toggledNodes" in normalisedState) {
                if (!Array.isArray(normalisedState.toggledNodes)) {
                    (0, $437b23f6a393c3bf$export$a20c7248650823a9)(245);
                    throw new Error();
                }
                const allHaveIds = normalisedState.toggledNodes.every((innerState)=>typeof innerState === "object" && "nodeId" in innerState && typeof innerState.nodeId === "string");
                if (!allHaveIds) {
                    (0, $437b23f6a393c3bf$export$a20c7248650823a9)(246);
                    throw new Error();
                }
            }
            const isThisNodeSelected = normalisedState.selectAllChildren ?? !parentSelected;
            const convertedChildren = normalisedState.toggledNodes?.map((innerState)=>[
                    innerState.nodeId,
                    recursivelyDeserializeState(innerState, isThisNodeSelected)
                ]);
            const doesRedundantStateExist = convertedChildren?.some(([, innerState])=>isThisNodeSelected === innerState.selectAllChildren && innerState.toggledNodes.size === 0);
            if (doesRedundantStateExist) {
                (0, $437b23f6a393c3bf$export$a20c7248650823a9)(247);
                throw new Error();
            }
            return {
                selectAllChildren: isThisNodeSelected,
                toggledNodes: new Map(convertedChildren)
            };
        };
        try {
            this.selectedState = recursivelyDeserializeState(state, !!state.selectAllChildren);
        } catch (e) {}
    }
    deleteSelectionStateFromParent(parentRoute, removedNodeIds) {
        let parentState = this.selectedState;
        const remainingRoute = [
            ...parentRoute
        ];
        while(parentState && remainingRoute.length)parentState = parentState.toggledNodes.get(remainingRoute.pop());
        if (!parentState) return false;
        let anyStateChanged = false;
        for (const id of removedNodeIds)if (parentState?.toggledNodes.delete(id)) anyStateChanged = true;
        if (anyStateChanged) this.removeRedundantState();
        return anyStateChanged;
    }
    setNodesSelected({ nodes: nodes, newValue: newValue, clearSelection: clearSelection, source: source }) {
        if (nodes.length === 0) return 0;
        const onlyThisNode = clearSelection && newValue;
        if (!(0, $437b23f6a393c3bf$export$7bd8c52ebc4117d6)(this.gos) || onlyThisNode) {
            if (nodes.length > 1) {
                (0, $437b23f6a393c3bf$export$a20c7248650823a9)(130);
                return 0;
            }
            this.deselectAllRowNodes();
        }
        for (const rowNode of nodes){
            const node = rowNode.footer ? rowNode.sibling : rowNode;
            const idPathToNode = this.getRouteToNode(node);
            this.recursivelySelectNode(idPathToNode, this.selectedState, newValue);
        }
        this.removeRedundantState();
        if (nodes.length === 1 && source === "api") this.selectionCtx.setRoot(nodes[0].footer ? nodes[0].sibling : nodes[0]);
        return 1;
    }
    isNodeSelected(node) {
        const path = this.getRouteToNode(node);
        return this.isNodePathSelected(path, this.selectedState);
    }
    isNodePathSelected([nextNode, ...nodes], state) {
        if (nodes.length === 0) {
            const isToggled = state.toggledNodes.has(nextNode.id);
            if (nextNode.hasChildren()) {
                const groupState = state.toggledNodes.get(nextNode.id);
                if (groupState?.toggledNodes.size) return void 0;
            }
            return state.selectAllChildren ? !isToggled : isToggled;
        }
        if (state.toggledNodes.has(nextNode.id)) {
            const nextState = state.toggledNodes.get(nextNode.id);
            if (nextState) return this.isNodePathSelected(nodes, nextState);
        }
        return state.selectAllChildren;
    }
    getRouteToNode(node) {
        const pathToNode = [];
        let tempNode = node;
        while(tempNode.parent){
            pathToNode.push(tempNode);
            tempNode = tempNode.parent;
        }
        return pathToNode.reverse();
    }
    removeRedundantState() {
        if (this.filterManager?.isAnyFilterPresent()) return;
        const forEachNodeStateDepthFirst = (state = this.selectedState, thisKey, parentState)=>{
            state.toggledNodes.forEach((value, key)=>{
                forEachNodeStateDepthFirst(value, key, state);
            });
            if (thisKey) {
                const thisRow = this.rowModel.getRowNode(thisKey);
                const thisRowStore = thisRow?.childStore;
                const isStoreSizeKnown = thisRowStore?.isLastRowIndexKnown();
                if (isStoreSizeKnown) {
                    const possibleAllNodesToggled = state.toggledNodes.size >= thisRowStore.getRowCount();
                    if (possibleAllNodesToggled) {
                        for (const childState of state.toggledNodes.entries()){
                            const [key, value] = childState;
                            if (value.toggledNodes.size > 0) return;
                            const rowDoesNotExist = !this.rowModel.getRowNode(key);
                            if (rowDoesNotExist) return;
                        }
                        state.selectAllChildren = !state.selectAllChildren;
                        state.toggledNodes.clear();
                    }
                }
            }
            const hasNoToggledRows = state.toggledNodes.size === 0;
            const isIdenticalToParent = parentState?.selectAllChildren === state.selectAllChildren;
            if (hasNoToggledRows && isIdenticalToParent) parentState?.toggledNodes.delete(thisKey);
        };
        forEachNodeStateDepthFirst();
    }
    recursivelySelectNode([nextNode, ...nodes], selectedState, newValue) {
        if (!nextNode) return;
        const isLastNode = !nodes.length;
        if (isLastNode) {
            const isNodeSelectable = nextNode.selectable;
            const doesNodeConform = selectedState.selectAllChildren === newValue;
            if (doesNodeConform || !isNodeSelectable) {
                selectedState.toggledNodes.delete(nextNode.id);
                return;
            }
            const newState = {
                selectAllChildren: newValue,
                toggledNodes: /* @__PURE__ */ new Map()
            };
            selectedState.toggledNodes.set(nextNode.id, newState);
            return;
        }
        const doesStateAlreadyExist = selectedState.toggledNodes.has(nextNode.id);
        const childState = selectedState.toggledNodes.get(nextNode.id) ?? {
            selectAllChildren: selectedState.selectAllChildren,
            toggledNodes: /* @__PURE__ */ new Map()
        };
        if (!doesStateAlreadyExist) selectedState.toggledNodes.set(nextNode.id, childState);
        this.recursivelySelectNode(nodes, childState, newValue);
        if (selectedState.selectAllChildren === childState.selectAllChildren && childState.toggledNodes.size === 0) selectedState.toggledNodes.delete(nextNode.id);
    }
    getSelectedNodes(nullWhenSelectAll = false) {
        (0, $437b23f6a393c3bf$export$545083624300f13d)(202);
        if (this.selectedState.selectAllChildren && nullWhenSelectAll) return null;
        const selectedNodes = [];
        this.rowModel.forEachNode((node)=>{
            if (node.isSelected()) selectedNodes.push(node);
        });
        return selectedNodes;
    }
    processNewRow() {}
    getSelectedRows() {
        return this.getSelectedNodes()?.map((node)=>node.data) ?? [];
    }
    getSelectionCount() {
        return -1;
    }
    isEmpty() {
        return !this.selectedState.selectAllChildren && !this.selectedState.toggledNodes?.size;
    }
    selectAllRowNodes() {
        this.reset(true);
    }
    deselectAllRowNodes() {
        this.reset(false);
    }
    reset(selectAllChildren2) {
        this.selectedState = {
            selectAllChildren: selectAllChildren2,
            toggledNodes: /* @__PURE__ */ new Map()
        };
    }
    getSelectAllState() {
        if (this.selectedState.selectAllChildren) {
            if (this.selectedState.toggledNodes.size > 0) return null;
            return true;
        }
        if (this.selectedState.toggledNodes.size > 0) return null;
        return false;
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/services/serverSideSelectionService.ts
var $5b7ccabde48fae90$var$ServerSideSelectionService = class extends (0, $437b23f6a393c3bf$export$3d7b168c0c9c2a78) {
    constructor(){
        super(...arguments);
        this.beanName = "selectionSvc";
    }
    postConstruct() {
        super.postConstruct();
        this.addManagedPropertyListeners([
            "groupSelectsChildren",
            "rowSelection"
        ], ()=>{
            const groupSelectsChildren2 = (0, $437b23f6a393c3bf$export$460e5745f0e6a40d)(this.gos);
            const Strategy2 = groupSelectsChildren2 && this.selectionStrategy instanceof $5b7ccabde48fae90$var$DefaultStrategy ? $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy : !groupSelectsChildren2 && this.selectionStrategy instanceof $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy ? $5b7ccabde48fae90$var$DefaultStrategy : void 0;
            if (Strategy2) {
                this.destroyBean(this.selectionStrategy);
                this.selectionStrategy = this.createManagedBean(new Strategy2(this.selectionCtx));
                this.shotgunResetNodeSelectionState();
                this.dispatchSelectionChanged("api");
            }
        });
        this.addManagedPropertyListeners([
            "rowSelection"
        ], ()=>{
            const rowSelection = (0, $437b23f6a393c3bf$export$80b6607444b3274f)(this.gos);
            if (rowSelection !== this.selectionMode) {
                this.selectionMode = rowSelection;
                this.deselectAllRowNodes({
                    source: "api"
                });
            }
        });
        this.selectionMode = (0, $437b23f6a393c3bf$export$80b6607444b3274f)(this.gos);
        const groupSelectsChildren = (0, $437b23f6a393c3bf$export$460e5745f0e6a40d)(this.gos);
        const Strategy = !groupSelectsChildren ? $5b7ccabde48fae90$var$DefaultStrategy : $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy;
        this.selectionStrategy = this.createManagedBean(new Strategy(this.selectionCtx));
    }
    handleSelectionEvent(event, rowNode, source) {
        if (this.isRowSelectionBlocked(rowNode)) return 0;
        let updatedRows = 0;
        const selection = this.inferNodeSelections(rowNode, event.shiftKey, event.metaKey || event.ctrlKey, source);
        if (selection == null) return 0;
        this.selectionCtx.selectAll = false;
        if ("select" in selection) {
            if (selection.reset) this.selectionStrategy.deselectAllRowNodes({
                source: "api"
            });
            else this.selectionStrategy.setNodesSelected({
                nodes: selection.deselect,
                newValue: false,
                source: source
            });
            updatedRows = this.selectionStrategy.setNodesSelected({
                nodes: selection.select,
                newValue: true,
                source: source
            });
        } else updatedRows = this.selectionStrategy.setNodesSelected({
            nodes: [
                selection.node
            ],
            newValue: selection.newValue,
            clearSelection: selection.clearSelection,
            event: event,
            source: source
        });
        this.shotgunResetNodeSelectionState(source);
        this.dispatchSelectionChanged(source);
        return updatedRows;
    }
    getSelectionState() {
        return this.selectionStrategy.getSelectedState();
    }
    setSelectionState(state, source) {
        if (!(0, $437b23f6a393c3bf$export$5d5fd838f5df1dd2)(this.gos)) {
            if (state) (0, $437b23f6a393c3bf$export$545083624300f13d)(132);
            return;
        }
        if (Array.isArray(state)) return;
        if (state) {
            this.selectionStrategy.setSelectedState(state);
            this.shotgunResetNodeSelectionState();
            this.dispatchSelectionChanged(source);
        } else this.deselectAllRowNodes({
            source: source
        });
    }
    setNodesSelected(params) {
        if (!(0, $437b23f6a393c3bf$export$5d5fd838f5df1dd2)(this.gos) && params.newValue) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(132);
            return 0;
        }
        const { nodes: nodes, ...otherParams } = params;
        if (nodes.length > 1 && this.selectionMode !== "multiRow") {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(130);
            return 0;
        }
        const adjustedParams = {
            nodes: nodes.filter((node)=>node.selectable),
            ...otherParams
        };
        if (!adjustedParams.nodes.length) return 0;
        const changedNodes = this.selectionStrategy.setNodesSelected(adjustedParams);
        this.shotgunResetNodeSelectionState(adjustedParams.source);
        this.dispatchSelectionChanged(adjustedParams.source);
        return changedNodes;
    }
    /**
   * Deletes the selection state for a set of nodes, for use after deleting nodes via
   * transaction. As this is designed for transactions, all nodes should belong to the same group.
   */ deleteSelectionStateFromParent(storeRoute, removedNodeIds) {
        const stateChanged = this.selectionStrategy.deleteSelectionStateFromParent(storeRoute, removedNodeIds);
        if (!stateChanged) return;
        this.shotgunResetNodeSelectionState();
        this.dispatchSelectionChanged("api");
    }
    shotgunResetNodeSelectionState(source) {
        this.beans.rowModel.forEachNode((node)=>{
            if (node.stub) return;
            const isNodeSelected = this.selectionStrategy.isNodeSelected(node);
            if (isNodeSelected !== node.isSelected()) this.selectRowNode(node, isNodeSelected, void 0, source);
        });
    }
    getSelectedNodes() {
        return this.selectionStrategy.getSelectedNodes() ?? [];
    }
    getSelectedRows() {
        return this.selectionStrategy.getSelectedRows();
    }
    getSelectionCount() {
        return this.selectionStrategy.getSelectionCount();
    }
    syncInRowNode(rowNode) {
        this.selectionStrategy.processNewRow(rowNode);
        const isNodeSelected = this.selectionStrategy.isNodeSelected(rowNode);
        if (isNodeSelected != false && !rowNode.selectable) {
            this.selectionStrategy.setNodesSelected({
                nodes: [
                    rowNode
                ],
                newValue: false,
                source: "api"
            });
            this.shotgunResetNodeSelectionState();
            this.dispatchSelectionChanged("api");
            return;
        }
        rowNode.__selected = isNodeSelected;
    }
    reset() {
        this.selectionStrategy.deselectAllRowNodes({
            source: "api"
        });
        this.selectionCtx.reset();
    }
    isEmpty() {
        return this.selectionStrategy.isEmpty();
    }
    hasNodesToSelect() {
        return true;
    }
    selectAllRowNodes(params) {
        if (!(0, $437b23f6a393c3bf$export$5d5fd838f5df1dd2)(this.gos)) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(132);
            return;
        }
        $5b7ccabde48fae90$var$validateSelectionParameters(params);
        if ((0, $437b23f6a393c3bf$export$d3c80fcacb2e2d55)(this.gos) && !(0, $437b23f6a393c3bf$export$7bd8c52ebc4117d6)(this.gos)) return (0, $437b23f6a393c3bf$export$545083624300f13d)(130);
        this.selectionStrategy.selectAllRowNodes(params);
        this.selectionCtx.selectAll = true;
        this.beans.rowModel.forEachNode((node)=>{
            if (node.stub) return;
            this.selectRowNode(node, true, void 0, params.source);
        });
        this.dispatchSelectionChanged(params.source);
    }
    deselectAllRowNodes(params) {
        $5b7ccabde48fae90$var$validateSelectionParameters(params);
        this.selectionStrategy.deselectAllRowNodes(params);
        this.selectionCtx.selectAll = false;
        this.beans.rowModel.forEachNode((node)=>{
            if (node.stub) return;
            this.selectRowNode(node, false, void 0, params.source);
        });
        this.dispatchSelectionChanged(params.source);
    }
    getSelectAllState(selectAll) {
        return this.selectionStrategy.getSelectAllState(selectAll);
    }
    // used by CSRM
    getBestCostNodeSelection() {
        return (0, $437b23f6a393c3bf$export$545083624300f13d)(194, {
            method: "getBestCostNodeSelection"
        });
    }
    /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData
   */ updateSelectable() {
        if (!(0, $437b23f6a393c3bf$export$5d5fd838f5df1dd2)(this.gos)) return;
        const nodesToDeselect = [];
        this.beans.rowModel.forEachNode((node)=>{
            const rowSelectable = this.updateRowSelectable(node, true);
            if (!rowSelectable && node.isSelected()) nodesToDeselect.push(node);
        });
        if (nodesToDeselect.length) this.setNodesSelected({
            nodes: nodesToDeselect,
            newValue: false,
            source: "selectableChanged"
        });
    }
    dispatchSelectionChanged(source) {
        this.eventSvc.dispatchEvent({
            type: "selectionChanged",
            source: source,
            selectedNodes: this.selectionStrategy instanceof $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy ? null : this.selectionStrategy.getSelectedNodes(true, false),
            serverSideState: this.getSelectionState()
        });
    }
    updateSelectableAfterGrouping() {
        return (0, $437b23f6a393c3bf$export$a20c7248650823a9)(194, {
            method: "updateSelectableAfterGrouping"
        });
    }
    refreshMasterNodeState() {}
    setDetailSelectionState() {
        return;
    }
};
function $5b7ccabde48fae90$var$validateSelectionParameters({ selectAll: selectAll }) {
    if (selectAll === "filtered" || selectAll === "currentPage") (0, $437b23f6a393c3bf$export$545083624300f13d)(195, {
        justCurrentPage: selectAll === "currentPage"
    });
}
var $5b7ccabde48fae90$var$SsrmRowChildrenService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "rowChildrenSvc";
    }
    getHasChildrenValue(rowNode) {
        const isTreeData = this.gos.get("treeData");
        const isGroupFunc = this.gos.get("isServerSideGroup");
        return !rowNode.stub && !rowNode.footer && (isTreeData ? !!isGroupFunc && isGroupFunc(rowNode.data) : !!rowNode.group);
    }
};
var $5b7ccabde48fae90$var$LazyBlockLoadingService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "lazyBlockLoadingSvc";
        this.outboundRequests = 0;
        // a map of caches to loading nodes
        this.cacheLoadingNodesMap = /* @__PURE__ */ new Map();
        // if a check is queued to happen this cycle
        this.isCheckQueued = false;
        // this is cached for blockLoadDebounce
        this.nextBlockToLoad = void 0;
    }
    wireBeans(beans) {
        this.rowRenderer = beans.rowRenderer;
        this.rowModel = beans.rowModel;
    }
    postConstruct() {
        this.maxOutboundRequests = (0, $437b23f6a393c3bf$export$efae4c751fa7cc4d)(this.gos);
    }
    subscribe(cache) {
        this.cacheLoadingNodesMap.set(cache, /* @__PURE__ */ new Set());
    }
    unsubscribe(cache) {
        this.cacheLoadingNodesMap.delete(cache);
    }
    /**
   * Queues a microtask to check if any blocks need to be loaded.
   */ queueLoadCheck() {
        if (this.isCheckQueued) return;
        this.isCheckQueued = true;
        setTimeout(()=>{
            this.queueLoadAction();
            this.isCheckQueued = false;
        });
    }
    onLoadComplete() {
        this.outboundRequests -= 1;
        this.queueLoadCheck();
    }
    hasAvailableLoadBandwidth() {
        if (this.maxOutboundRequests === void 0) return true;
        return this.outboundRequests < this.maxOutboundRequests;
    }
    queueLoadAction() {
        const nextBlockToLoad = this.getBlockToLoad();
        if (!nextBlockToLoad) return;
        const isSameBlock = this.nextBlockToLoad && this.nextBlockToLoad.cache === nextBlockToLoad.cache && this.nextBlockToLoad.index === nextBlockToLoad.index;
        if (isSameBlock) return;
        if (!this.nextBlockToLoad || !isSameBlock) {
            this.nextBlockToLoad = nextBlockToLoad;
            window.clearTimeout(this.loaderTimeout);
            const startRow = Number(this.nextBlockToLoad.index);
            const cache = this.nextBlockToLoad.cache;
            const endRow = nextBlockToLoad.index + nextBlockToLoad.cache.getBlockSize();
            this.loaderTimeout = window.setTimeout(()=>{
                if (!cache.isAlive()) return;
                this.loaderTimeout = void 0;
                this.attemptLoad(cache, startRow, endRow);
                this.nextBlockToLoad = void 0;
            }, this.gos.get("blockLoadDebounceMillis"));
        }
    }
    attemptLoad(cache, start, end) {
        const hasBandwidth = this.hasAvailableLoadBandwidth();
        if (!hasBandwidth) return;
        this.executeLoad(cache, start, end);
        this.queueLoadCheck();
    }
    executeLoad(cache, startRow, endRow) {
        const ssrmParams = cache.getSsrmParams();
        const request = {
            startRow: startRow,
            endRow: endRow,
            rowGroupCols: ssrmParams.rowGroupCols,
            valueCols: ssrmParams.valueCols,
            pivotCols: ssrmParams.pivotCols,
            pivotMode: ssrmParams.pivotMode,
            groupKeys: cache.store.getParentNode().getRoute() ?? [],
            filterModel: ssrmParams.filterModel,
            sortModel: ssrmParams.sortModel
        };
        const loadingNodes = this.cacheLoadingNodesMap.get(cache);
        const removeNodesFromLoadingMap = ()=>{
            for(let i = 0; i < endRow - startRow; i++)loadingNodes.delete(startRow + i);
        };
        const addNodesToLoadingMap = ()=>{
            for(let i = 0; i < endRow - startRow; i++)loadingNodes.add(startRow + i);
        };
        const success = (params2)=>{
            this.onLoadComplete();
            cache.onLoadSuccess(startRow, endRow - startRow, params2);
            removeNodesFromLoadingMap();
        };
        const fail = ()=>{
            this.onLoadComplete();
            cache.onLoadFailed(startRow, endRow - startRow);
            removeNodesFromLoadingMap();
        };
        const params = (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
            request: request,
            success: success,
            fail: fail,
            parentNode: cache.store.getParentNode()
        });
        addNodesToLoadingMap();
        this.outboundRequests += 1;
        cache.getSsrmParams().datasource?.getRows(params);
    }
    getBlockToLoad() {
        const firstRowInViewport = this.rowRenderer.firstRenderedRow;
        const lastRowInViewport = this.rowRenderer.lastRenderedRow;
        for(let i = firstRowInViewport; i <= lastRowInViewport; i++){
            const row = this.rowModel.getRow(i);
            if (!row) continue;
            const store = row.parent?.childStore;
            if (!store) continue;
            const cache = store.getCache();
            const lazyNode = cache.getNodes().getBy("node", row);
            if (!lazyNode) continue;
            const loadingNodes = this.cacheLoadingNodesMap.get(cache);
            if (loadingNodes?.has(lazyNode.index)) continue;
            if (row.__needsRefreshWhenVisible || row.stub && !row.failedLoad) return {
                cache: cache,
                index: cache.getBlockStartIndex(lazyNode.index)
            };
        }
        let cacheToRefresh = null;
        let nodeToRefresh = null;
        let nodeToRefreshDist = Number.MAX_SAFE_INTEGER;
        for (const cache of this.cacheLoadingNodesMap.keys()){
            const nodesToRefresh = cache.getNodesToRefresh();
            nodesToRefresh.forEach((node)=>{
                if (node.rowIndex == null) {
                    nodeToRefresh = node;
                    cacheToRefresh = cache;
                    return;
                }
                const lazyNode = cache.getNodes().getBy("node", node);
                if (!lazyNode) return;
                const loadingNodes = this.cacheLoadingNodesMap.get(cache);
                if (loadingNodes?.has(lazyNode.index)) return;
                const distToViewportTop = Math.abs(firstRowInViewport - node.rowIndex);
                const distToViewportBottom = Math.abs(node.rowIndex - lastRowInViewport);
                if (distToViewportTop < nodeToRefreshDist) {
                    nodeToRefresh = node;
                    nodeToRefreshDist = distToViewportTop;
                    cacheToRefresh = cache;
                }
                if (distToViewportBottom < nodeToRefreshDist) {
                    nodeToRefresh = node;
                    nodeToRefreshDist = distToViewportBottom;
                    cacheToRefresh = cache;
                }
            });
        }
        if (!cacheToRefresh) return void 0;
        const lazyCache = cacheToRefresh;
        const lazyIndex = lazyCache.getNodes().getBy("node", nodeToRefresh)?.index;
        return lazyIndex == null ? void 0 : {
            cache: lazyCache,
            index: lazyCache.getBlockStartIndex(lazyIndex)
        };
    }
    isRowLoading(cache, index) {
        return this.cacheLoadingNodesMap.get(cache)?.has(index) ?? false;
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/stores/lazy/multiIndexMap.ts
var $5b7ccabde48fae90$var$MultiIndexMap = class {
    constructor(...indexes){
        this.indexes = indexes;
        this.maps = new Map(this.indexes.map((index)=>[
                index,
                /* @__PURE__ */ new Map()
            ]));
    }
    getSize() {
        return this.maps.get(this.indexes[0]).size;
    }
    getBy(index, key) {
        const map = this.maps.get(index);
        return map.get(key);
    }
    set(item) {
        for (const index of this.indexes){
            const map = this.maps.get(index);
            map.set(item[index], item);
        }
    }
    delete(item) {
        for (const index of this.indexes){
            const map = this.maps.get(index);
            map.delete(item[index]);
        }
    }
    clear() {
        this.maps.forEach((map)=>map.clear());
    }
    getIterator(index) {
        const map = this.maps.get(index);
        return map.values();
    }
    forEach(callback) {
        const iterator = this.getIterator(this.indexes[0]);
        let pointer;
        while(pointer = iterator.next()){
            if (pointer.done) break;
            callback(pointer.value);
        }
    }
    find(callback) {
        const iterator = this.getIterator(this.indexes[0]);
        let pointer;
        while(pointer = iterator.next()){
            if (pointer.done) break;
            if (callback(pointer.value)) return pointer.value;
        }
    }
    filter(predicate) {
        const iterator = this.getIterator(this.indexes[0]);
        let pointer;
        const result = [];
        while(pointer = iterator.next()){
            if (pointer.done) break;
            if (predicate(pointer.value)) result.push(pointer.value);
        }
        return result;
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/stores/lazy/lazyCache.ts
var $5b7ccabde48fae90$var$DEFAULT_BLOCK_SIZE = 100;
var $5b7ccabde48fae90$var$LazyCache = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(store, numberOfRows, isLastRowKnown, storeParams){
        super();
        /**
     * Indicates whether this is still the live dataset for this store (used for ignoring old requests after purge)
     */ this.live = true;
        /**
     * A cache of removed group nodes, this is retained for preserving group
     * state when the node moves in and out of the cache. Generally caused by
     * rows moving blocks.
     */ this.removedNodeCache = /* @__PURE__ */ new Map();
        this.store = store;
        this.numberOfRows = numberOfRows;
        this.isLastRowKnown = isLastRowKnown;
        this.storeParams = storeParams;
    }
    wireBeans(beans) {
        this.rowRenderer = beans.rowRenderer;
        this.blockUtils = beans.ssrmBlockUtils;
        this.focusSvc = beans.focusSvc;
        this.nodeManager = beans.ssrmNodeManager;
        this.serverSideRowModel = beans.rowModel;
        this.rowNodeSorter = beans.rowNodeSorter;
        this.sortSvc = beans.sortSvc;
        this.lazyBlockLoadingSvc = beans.lazyBlockLoadingSvc;
        this.colModel = beans.colModel;
    }
    postConstruct() {
        this.lazyBlockLoadingSvc.subscribe(this);
        this.nodeMap = new $5b7ccabde48fae90$var$MultiIndexMap("index", "id", "node");
        this.nodeDisplayIndexMap = /* @__PURE__ */ new Map();
        this.nodesToRefresh = /* @__PURE__ */ new Set();
        const { blockUtils: blockUtils, gos: gos, store: store } = this;
        this.defaultNodeIdPrefix = blockUtils.createNodeIdPrefix(store.getParentNode());
        this.getRowIdFunc = (0, $437b23f6a393c3bf$export$57c3bb2f89b59a89)(gos);
        this.isMasterDetail = gos.get("masterDetail");
    }
    destroy() {
        this.lazyBlockLoadingSvc.unsubscribe(this);
        this.numberOfRows = 0;
        this.nodeMap.forEach((node)=>this.blockUtils.destroyRowNode(node.node));
        this.nodeMap.clear();
        this.nodeDisplayIndexMap.clear();
        this.nodesToRefresh.clear();
        this.live = false;
        super.destroy();
    }
    /**
   * Get the row node for a specific display index from this store
   * @param displayIndex the display index of the node to find
   * @returns undefined if the node is not in the store bounds, otherwise will always return a node
   */ getRowByDisplayIndex(displayIndex) {
        if (!this.store.isDisplayIndexInStore(displayIndex)) return void 0;
        const node = this.nodeDisplayIndexMap.get(displayIndex);
        if (node) {
            if (node.stub || node.__needsRefreshWhenVisible) this.lazyBlockLoadingSvc.queueLoadCheck();
            return node;
        }
        const hideOpenGroups = this.gos.get("groupHideOpenParents") || this.gos.get("groupAllowUnbalanced");
        if (hideOpenGroups) {
            const nextParent = this.nodeMap.find((lazyNode)=>!!lazyNode.node.childStore?.isDisplayIndexInStore(displayIndex));
            if (nextParent) return nextParent.node.childStore?.getRowUsingDisplayIndex(displayIndex);
        }
        if (displayIndex === this.store.getDisplayIndexStart()) return this.createStubNode(0, displayIndex);
        const contiguouslyPreviousNode = this.nodeDisplayIndexMap.get(displayIndex - 1);
        if (contiguouslyPreviousNode) {
            if (this.isMasterDetail && contiguouslyPreviousNode.master && contiguouslyPreviousNode.expanded) return contiguouslyPreviousNode.detailNode;
            if (contiguouslyPreviousNode.expanded && contiguouslyPreviousNode.childStore?.isDisplayIndexInStore(displayIndex)) return contiguouslyPreviousNode.childStore?.getRowUsingDisplayIndex(displayIndex);
            const lazyCacheNode = this.nodeMap.getBy("node", contiguouslyPreviousNode);
            return this.createStubNode(lazyCacheNode.index + 1, displayIndex);
        }
        const adjacentNodes = this.getSurroundingNodesByDisplayIndex(displayIndex);
        if (adjacentNodes == null) {
            const storeIndexFromEndIndex2 = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - displayIndex);
            return this.createStubNode(storeIndexFromEndIndex2, displayIndex);
        }
        const { previousNode: previousNode, nextNode: nextNode } = adjacentNodes;
        if (previousNode?.node.expanded && previousNode.node.childStore?.isDisplayIndexInStore(displayIndex)) return previousNode.node.childStore?.getRowUsingDisplayIndex(displayIndex);
        if (nextNode) {
            const displayIndexDiff = nextNode.node.rowIndex - displayIndex;
            const newStoreIndex = nextNode.index - displayIndexDiff;
            return this.createStubNode(newStoreIndex, displayIndex);
        }
        const storeIndexFromEndIndex = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - displayIndex);
        return this.createStubNode(storeIndexFromEndIndex, displayIndex);
    }
    /**
   * Used for creating and positioning a stub node without firing a store updated event
   */ createStubNode(storeIndex, displayIndex) {
        const rowBounds = this.store.getRowBounds(displayIndex);
        const newNode = this.createRowAtIndex(storeIndex, null, (node)=>{
            node.setRowIndex(displayIndex);
            node.setRowTop(rowBounds.rowTop);
            this.nodeDisplayIndexMap.set(displayIndex, node);
        });
        if (storeIndex === 0 && this.gos.get("groupHideOpenParents")) {
            const parentGroupData = this.store.getParentNode().groupData;
            if (parentGroupData) for (const key of Object.keys(parentGroupData))$5b7ccabde48fae90$var$setRowNodeGroupValue(newNode, this.colModel, key, parentGroupData[key]);
        }
        this.lazyBlockLoadingSvc.queueLoadCheck();
        return newNode;
    }
    /**
   * @param index The row index relative to this store
   * @returns A rowNode at the given store index
   */ getRowByStoreIndex(index) {
        return this.nodeMap.getBy("index", index)?.node;
    }
    /**
   * Given a number of rows, skips through the given sequence & row top reference (using default row height)
   * @param numberOfRowsToSkip number of rows to skip over in the given sequence
   * @param displayIndexSeq the sequence in which to skip
   * @param nextRowTop the row top reference in which to skip
   */ skipDisplayIndexes(numberOfRowsToSkip, displayIndexSeq, nextRowTop) {
        if (numberOfRowsToSkip === 0) return;
        const defaultRowHeight = (0, $437b23f6a393c3bf$export$8966875adec41e5b)(this.beans);
        displayIndexSeq.value += numberOfRowsToSkip;
        nextRowTop.value += numberOfRowsToSkip * defaultRowHeight;
    }
    /**
   * @param displayIndexSeq the number sequence for generating the display index of each row
   * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
   */ setDisplayIndexes(displayIndexSeq, nextRowTop, uiLevel) {
        this.nodeDisplayIndexMap.clear();
        const orderedMap = {};
        this.nodeMap.forEach((lazyNode)=>{
            orderedMap[lazyNode.index] = lazyNode.node;
        });
        let lastIndex = -1;
        for (const stringIndex of Object.keys(orderedMap)){
            const node = orderedMap[stringIndex];
            const numericIndex = Number(stringIndex);
            const numberOfRowsToSkip2 = numericIndex - 1 - lastIndex;
            this.skipDisplayIndexes(numberOfRowsToSkip2, displayIndexSeq, nextRowTop);
            const isFirstChild = numericIndex === 0;
            if (node.firstChild !== isFirstChild) {
                node.firstChild = isFirstChild;
                node.dispatchRowEvent("firstChildChanged");
            }
            if (isFirstChild && this.gos.get("groupHideOpenParents")) {
                const parentGroupData = this.store.getParentNode().groupData;
                if (parentGroupData) for (const key of Object.keys(parentGroupData))$5b7ccabde48fae90$var$setRowNodeGroupValue(node, this.colModel, key, isFirstChild ? parentGroupData[key] : void 0);
            }
            this.blockUtils.setDisplayIndex(node, displayIndexSeq, nextRowTop, uiLevel);
            if (node.rowIndex != null) this.nodeDisplayIndexMap.set(node.rowIndex, node);
            lastIndex = numericIndex;
        }
        const numberOfRowsToSkip = this.numberOfRows - 1 - lastIndex;
        this.skipDisplayIndexes(numberOfRowsToSkip, displayIndexSeq, nextRowTop);
        this.purgeExcessRows();
    }
    getRowCount() {
        return this.numberOfRows;
    }
    setRowCount(rowCount, isLastRowIndexKnown) {
        this.numberOfRows = rowCount;
        if (isLastRowIndexKnown != null) {
            this.isLastRowKnown = isLastRowIndexKnown;
            if (isLastRowIndexKnown === false) this.numberOfRows += 1;
        }
        this.fireStoreUpdatedEvent();
    }
    getNodes() {
        return this.nodeMap;
    }
    getNodeCachedByDisplayIndex(displayIndex) {
        return this.nodeDisplayIndexMap.get(displayIndex) ?? null;
    }
    getNodesToRefresh() {
        return this.nodesToRefresh;
    }
    /**
   * @returns the previous and next loaded row nodes surrounding the given display index
   */ getSurroundingNodesByDisplayIndex(displayIndex) {
        let nextNode;
        let previousNode;
        this.nodeMap.forEach((lazyNode)=>{
            if (displayIndex > lazyNode.node.rowIndex) {
                if (previousNode == null || previousNode.node.rowIndex < lazyNode.node.rowIndex) previousNode = lazyNode;
                return;
            }
            if (nextNode == null || nextNode.node.rowIndex > lazyNode.node.rowIndex) nextNode = lazyNode;
        });
        if (!previousNode && !nextNode) return null;
        return {
            previousNode: previousNode,
            nextNode: nextNode
        };
    }
    /**
   * Get or calculate the display index for a given store index
   * @param storeIndex the rows index within this store
   * @returns the rows visible display index relative to the grid
   */ getDisplayIndexFromStoreIndex(storeIndex) {
        const nodeAtIndex = this.nodeMap.getBy("index", storeIndex);
        if (nodeAtIndex) return nodeAtIndex.node.rowIndex;
        let nextNode;
        let previousNode;
        this.nodeMap.forEach((lazyNode)=>{
            if (storeIndex > lazyNode.index) {
                if (previousNode == null || previousNode.index < lazyNode.index) previousNode = lazyNode;
                return;
            }
            if (nextNode == null || nextNode.index > lazyNode.index) nextNode = lazyNode;
        });
        if (!nextNode) return this.store.getDisplayIndexEnd() - (this.numberOfRows - storeIndex);
        if (!previousNode) return this.store.getDisplayIndexStart() + storeIndex;
        const storeIndexDiff = storeIndex - previousNode.index;
        const previousDisplayIndex = previousNode.node.childStore?.getDisplayIndexEnd() ?? previousNode.node.rowIndex;
        return previousDisplayIndex + storeIndexDiff;
    }
    /**
   * Creates a new row and inserts it at the given index
   * @param atStoreIndex the node index relative to this store
   * @param data the data object to populate the node with
   * @returns the new row node
   */ createRowAtIndex(atStoreIndex, data, createNodeCallback) {
        const lazyNode = this.nodeMap.getBy("index", atStoreIndex);
        if (lazyNode) {
            const { node: node } = lazyNode;
            node.__needsRefreshWhenVisible = false;
            if (this.doesNodeMatch(data, node)) {
                this.blockUtils.updateDataIntoRowNode(node, data);
                this.nodesToRefresh.delete(node);
                return node;
            }
            if (this.getRowIdFunc == null && node.hasChildren() && node.expanded) {
                this.nodesToRefresh.delete(node);
                return node;
            }
            this.destroyRowAtIndex(atStoreIndex);
        }
        if (data && this.getRowIdFunc != null) {
            const id = this.getRowId(data);
            const deletedNode = id && this.removedNodeCache?.get(id);
            if (deletedNode) {
                this.removedNodeCache?.delete(id);
                this.blockUtils.updateDataIntoRowNode(deletedNode, data);
                this.nodeMap.set({
                    id: deletedNode.id,
                    node: deletedNode,
                    index: atStoreIndex
                });
                this.nodesToRefresh.delete(deletedNode);
                deletedNode.__needsRefreshWhenVisible = false;
                return deletedNode;
            }
            const lazyNode2 = this.nodeMap.getBy("id", id);
            if (lazyNode2) {
                this.nodeMap.delete(lazyNode2);
                const { node: node, index: index } = lazyNode2;
                this.blockUtils.updateDataIntoRowNode(node, data);
                this.nodeMap.set({
                    id: node.id,
                    node: node,
                    index: atStoreIndex
                });
                this.nodesToRefresh.delete(node);
                node.__needsRefreshWhenVisible = false;
                if (this.getBlockStartIndex(index) === this.getBlockStartIndex(atStoreIndex)) return node;
                this.markBlockForVerify(index);
                return node;
            }
        }
        const newNode = this.blockUtils.createRowNode(this.store.getRowDetails());
        if (data != null) {
            const defaultId = this.getPrefixedId(this.store.getIdSequence().value++);
            this.blockUtils.setDataIntoRowNode(newNode, data, defaultId, void 0);
            this.blockUtils.checkOpenByDefault(newNode);
            this.nodeManager.addRowNode(newNode);
        }
        this.nodeMap.set({
            id: newNode.id,
            node: newNode,
            index: atStoreIndex
        });
        if (createNodeCallback) createNodeCallback(newNode);
        return newNode;
    }
    getBlockStates() {
        const blockCounts = {};
        const blockStates = {};
        this.nodeMap.forEach(({ node: node, index: index })=>{
            const blockStart = this.getBlockStartIndex(index);
            if (!node.stub && !node.failedLoad) blockCounts[blockStart] = (blockCounts[blockStart] ?? 0) + 1;
            let rowState = "loaded";
            if (node.failedLoad) rowState = "failed";
            else if (this.lazyBlockLoadingSvc.isRowLoading(this, blockStart)) rowState = "loading";
            else if (this.nodesToRefresh.has(node) || node.stub) rowState = "needsLoading";
            if (!blockStates[blockStart]) blockStates[blockStart] = /* @__PURE__ */ new Set();
            blockStates[blockStart].add(rowState);
        });
        const statePriorityMap = {
            loading: 4,
            failed: 3,
            needsLoading: 2,
            loaded: 1
        };
        const blockPrefix = this.blockUtils.createNodeIdPrefix(this.store.getParentNode());
        const results = {};
        for (const blockStart of Object.keys(blockStates)){
            const sortedStates = [
                ...blockStates[blockStart]
            ].sort((a, b)=>(statePriorityMap[a] ?? 0) - (statePriorityMap[b] ?? 0));
            const priorityState = sortedStates[0];
            const blockNumber = Number(blockStart) / this.getBlockSize();
            const blockId = blockPrefix ? `${blockPrefix}-${blockNumber}` : String(blockNumber);
            results[blockId] = {
                blockNumber: blockNumber,
                startRow: Number(blockStart),
                endRow: Number(blockStart) + this.getBlockSize(),
                pageStatus: priorityState,
                loadedRowCount: blockCounts[blockStart] ?? 0
            };
        }
        return results;
    }
    destroyRowAtIndex(atStoreIndex) {
        const lazyNode = this.nodeMap.getBy("index", atStoreIndex);
        if (!lazyNode) return;
        this.nodeMap.delete(lazyNode);
        this.nodeDisplayIndexMap.delete(lazyNode.node.rowIndex);
        if (this.nodesToRefresh.size > 0) this.removedNodeCache.set(lazyNode.node.id, lazyNode.node);
        else this.blockUtils.destroyRowNode(lazyNode.node);
        this.nodesToRefresh.delete(lazyNode.node);
    }
    getSsrmParams() {
        return this.store.getSsrmParams();
    }
    /**
   * @param id the base id to be prefixed
   * @returns a node id with prefix if required
   */ getPrefixedId(id) {
        if (this.defaultNodeIdPrefix) return this.defaultNodeIdPrefix + "-" + id;
        else return id.toString();
    }
    markBlockForVerify(rowIndex) {
        const [start, end] = this.getBlockBounds(rowIndex);
        const lazyNodesInRange = this.nodeMap.filter((lazyNode)=>lazyNode.index >= start && lazyNode.index < end);
        lazyNodesInRange.forEach(({ node: node })=>{
            node.__needsRefreshWhenVisible = true;
        });
    }
    doesNodeMatch(data, node) {
        if (node.stub) return false;
        const id = this.getRowId(data);
        return id === null ? node.data === data : node.id === id;
    }
    /**
   * Deletes any stub nodes not within the given range
   */ purgeStubsOutsideOfViewport() {
        const { firstRenderedRow: firstRenderedRow, lastRenderedRow: lastRenderedRow } = this.rowRenderer;
        const firstRowBlockStart = this.getBlockStartIndex(firstRenderedRow);
        const [, lastRowBlockEnd] = this.getBlockBounds(lastRenderedRow);
        this.nodeMap.forEach((lazyNode)=>{
            if (this.lazyBlockLoadingSvc.isRowLoading(this, lazyNode.index) || lazyNode.node.failedLoad) return;
            if (lazyNode.node.stub && (lazyNode.index < firstRowBlockStart || lazyNode.index > lastRowBlockEnd)) this.destroyRowAtIndex(lazyNode.index);
        });
    }
    getBlocksDistanceFromRow(nodes, otherDisplayIndex) {
        const blockDistanceToMiddle = {};
        nodes.forEach(({ node: node, index: index })=>{
            const [blockStart, blockEnd] = this.getBlockBounds(index);
            if (blockStart in blockDistanceToMiddle) return;
            const distStart = Math.abs(node.rowIndex - otherDisplayIndex);
            let distEnd;
            const lastLazyNode = this.nodeMap.getBy("index", [
                blockEnd - 1
            ]);
            if (lastLazyNode) distEnd = Math.abs(lastLazyNode.node.rowIndex - otherDisplayIndex);
            const farthest = distEnd == null || distStart < distEnd ? distStart : distEnd;
            blockDistanceToMiddle[blockStart] = farthest;
        });
        return Object.entries(blockDistanceToMiddle);
    }
    purgeExcessRows() {
        this.purgeStubsOutsideOfViewport();
        if (this.store.getDisplayIndexEnd() == null || this.storeParams.maxBlocksInCache == null) return;
        const { firstRenderedRow: firstRenderedRow, lastRenderedRow: lastRenderedRow } = this.rowRenderer;
        const allLoadedBlocks = /* @__PURE__ */ new Set();
        const blocksInViewport = /* @__PURE__ */ new Set();
        this.nodeMap.forEach(({ index: index, node: node })=>{
            const blockStart = this.getBlockStartIndex(index);
            allLoadedBlocks.add(blockStart);
            const isInViewport = node.rowIndex >= firstRenderedRow && node.rowIndex <= lastRenderedRow;
            if (isInViewport) blocksInViewport.add(blockStart);
        });
        const numberOfBlocksToRetain = Math.max(blocksInViewport.size, this.storeParams.maxBlocksInCache ?? 0);
        const loadedBlockCount = allLoadedBlocks.size;
        const blocksToRemove = loadedBlockCount - numberOfBlocksToRetain;
        if (blocksToRemove <= 0) return;
        let firstRowBlockStart = Number.MAX_SAFE_INTEGER;
        let lastRowBlockStart = Number.MIN_SAFE_INTEGER;
        blocksInViewport.forEach((blockStart)=>{
            if (firstRowBlockStart > blockStart) firstRowBlockStart = blockStart;
            if (lastRowBlockStart < blockStart) lastRowBlockStart = blockStart;
        });
        const disposableNodes = this.nodeMap.filter(({ node: node, index: index })=>{
            const rowBlockStart = this.getBlockStartIndex(index);
            const rowBlockInViewport = rowBlockStart >= firstRowBlockStart && rowBlockStart <= lastRowBlockStart;
            return !rowBlockInViewport && !this.isNodeCached(node);
        });
        if (disposableNodes.length === 0) return;
        const midViewportRow = firstRenderedRow + (lastRenderedRow - firstRenderedRow) / 2;
        const blockDistanceArray = this.getBlocksDistanceFromRow(disposableNodes, midViewportRow);
        const blockSize = this.getBlockSize();
        blockDistanceArray.sort((a, b)=>Math.sign(b[1] - a[1]));
        for(let i = 0; i < Math.min(blocksToRemove, blockDistanceArray.length); i++){
            const blockStart = Number(blockDistanceArray[i][0]);
            for(let x = blockStart; x < blockStart + blockSize; x++){
                const lazyNode = this.nodeMap.getBy("index", x);
                if (!lazyNode || this.isNodeCached(lazyNode.node)) continue;
                this.destroyRowAtIndex(x);
            }
        }
    }
    isNodeFocused(node) {
        const focusedCell = this.focusSvc.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const hasFocus = focusedCell.rowIndex === node.rowIndex;
        return hasFocus;
    }
    isNodeCached(node) {
        const isExpandedGroup = node.isExpandable() && node.expanded;
        const isUnbalancedNode = this.gos.get("groupAllowUnbalanced") && node.key === "";
        const isEditing = !!this.beans.editSvc?.isRowEditing(node);
        return isExpandedGroup || this.isNodeFocused(node) || isUnbalancedNode || isEditing;
    }
    extractDuplicateIds(rows) {
        if (this.getRowIdFunc == null) return [];
        const newIds = /* @__PURE__ */ new Set();
        const duplicates = /* @__PURE__ */ new Set();
        rows.forEach((data)=>{
            const id = this.getRowId(data);
            if (newIds.has(id)) {
                duplicates.add(id);
                return;
            }
            newIds.add(id);
        });
        return [
            ...duplicates
        ];
    }
    onLoadSuccess(firstRowIndex, numberOfRowsExpected, response) {
        if (!this.live) return;
        const info = response.groupLevelInfo;
        this.store.setStoreInfo(info);
        if (this.getRowIdFunc != null) {
            const duplicates = this.extractDuplicateIds(response.rowData);
            if (duplicates.length > 0) {
                const duplicateIdText = duplicates.join(", ");
                (0, $437b23f6a393c3bf$export$545083624300f13d)(205, {
                    duplicateIdText: duplicateIdText
                });
                this.onLoadFailed(firstRowIndex, numberOfRowsExpected);
                return;
            }
        }
        if (response.pivotResultFields) this.serverSideRowModel.generateSecondaryColumns(response.pivotResultFields);
        const wasRefreshing = this.nodesToRefresh.size > 0;
        response.rowData.forEach((data, responseRowIndex)=>{
            const rowIndex = firstRowIndex + responseRowIndex;
            const nodeFromCache = this.nodeMap.getBy("index", rowIndex);
            if (nodeFromCache?.node?.stub) {
                this.createRowAtIndex(rowIndex, data);
                return;
            }
            if (nodeFromCache && this.doesNodeMatch(data, nodeFromCache.node)) {
                this.blockUtils.updateDataIntoRowNode(nodeFromCache.node, data);
                this.nodesToRefresh.delete(nodeFromCache.node);
                nodeFromCache.node.__needsRefreshWhenVisible = false;
                return;
            }
            this.createRowAtIndex(rowIndex, data);
        });
        if (response.rowCount != void 0 && response.rowCount !== -1) {
            this.numberOfRows = response.rowCount;
            this.isLastRowKnown = true;
        } else if (numberOfRowsExpected > response.rowData.length) {
            this.numberOfRows = firstRowIndex + response.rowData.length;
            this.isLastRowKnown = true;
        } else if (!this.isLastRowKnown) {
            const lastInferredRow = firstRowIndex + response.rowData.length + 1;
            if (lastInferredRow > this.numberOfRows) this.numberOfRows = lastInferredRow;
        }
        if (this.isLastRowKnown) {
            const lazyNodesAfterStoreEnd = this.nodeMap.filter((lazyNode)=>lazyNode.index >= this.numberOfRows);
            lazyNodesAfterStoreEnd.forEach((lazyNode)=>this.destroyRowAtIndex(lazyNode.index));
        }
        this.fireStoreUpdatedEvent();
        const finishedRefreshing = this.nodesToRefresh.size === 0;
        if (wasRefreshing && finishedRefreshing) this.fireRefreshFinishedEvent();
    }
    fireRefreshFinishedEvent() {
        const finishedRefreshing = this.nodesToRefresh.size === 0;
        if (!finishedRefreshing) return;
        this.removedNodeCache.forEach((node)=>{
            this.blockUtils.destroyRowNode(node);
        });
        this.removedNodeCache = /* @__PURE__ */ new Map();
        this.store.fireRefreshFinishedEvent();
    }
    /**
   * @returns true if all rows are loaded
   */ isStoreFullyLoaded() {
        const knowsSize = this.isLastRowKnown;
        const hasCorrectRowCount = this.nodeMap.getSize() === this.numberOfRows;
        if (!knowsSize || !hasCorrectRowCount) return;
        if (this.nodesToRefresh.size > 0) return;
        let index = -1;
        const firstOutOfPlaceNode = this.nodeMap.find((lazyNode)=>{
            index += 1;
            if (lazyNode.index !== index) return true;
            if (lazyNode.node.__needsRefreshWhenVisible) return true;
            if (lazyNode.node.stub) return true;
            return false;
        });
        return firstOutOfPlaceNode == null;
    }
    isLastRowIndexKnown() {
        return this.isLastRowKnown;
    }
    onLoadFailed(firstRowIndex, numberOfRowsExpected) {
        if (!this.live) return;
        const wasRefreshing = this.nodesToRefresh.size > 0;
        for(let i = firstRowIndex; i < firstRowIndex + numberOfRowsExpected && i < this.getRowCount(); i++){
            let { node: node } = this.nodeMap.getBy("index", i) ?? {};
            if (node) this.nodesToRefresh.delete(node);
            if (!node?.stub) {
                if (node && !node.stub) this.destroyRowAtIndex(i);
                node = this.createRowAtIndex(i);
            }
            node.__needsRefreshWhenVisible = false;
            node.failedLoad = true;
        }
        const finishedRefreshing = this.nodesToRefresh.size === 0;
        if (wasRefreshing && finishedRefreshing) this.fireRefreshFinishedEvent();
        this.fireStoreUpdatedEvent();
    }
    markNodesForRefresh() {
        this.nodeMap.forEach((lazyNode)=>{
            if (lazyNode.node.stub && !lazyNode.node.failedLoad) return;
            this.nodesToRefresh.add(lazyNode.node);
        });
        this.lazyBlockLoadingSvc.queueLoadCheck();
        if (this.isLastRowKnown && this.numberOfRows === 0) {
            this.numberOfRows = 1;
            this.isLastRowKnown = false;
            this.fireStoreUpdatedEvent();
        }
    }
    isNodeInCache(id) {
        return !!this.nodeMap.getBy("id", id);
    }
    // gets called 1) row count changed 2) cache purged 3) items inserted
    fireStoreUpdatedEvent() {
        if (!this.live) return;
        this.store.fireStoreUpdatedEvent();
    }
    getRowId(data) {
        if (this.getRowIdFunc == null) return null;
        const { level: level } = this.store.getRowDetails();
        const parentKeys = this.store.getParentNode().getRoute() ?? [];
        return this.getRowIdFunc({
            data: data,
            parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
            level: level
        });
    }
    getOrderedNodeMap() {
        const obj = {};
        this.nodeMap.forEach((node)=>obj[node.index] = node);
        return obj;
    }
    clearDisplayIndexes() {
        this.nodeDisplayIndexMap.clear();
    }
    /**
   * Client side sorting
   */ clientSideSortRows() {
        const sortOptions = this.sortSvc?.getSortOptions() ?? [];
        const isAnySort = sortOptions.some((opt)=>opt.sort != null);
        const rowNodeSorter = this.rowNodeSorter;
        if (!isAnySort || !rowNodeSorter) return;
        const allNodes = new Array(this.nodeMap.getSize());
        const nodesMap = this.nodeMap;
        nodesMap.forEach((lazyNode)=>allNodes[lazyNode.index] = lazyNode.node);
        nodesMap.clear();
        const sortedNodes = rowNodeSorter.doFullSortInPlace(allNodes, sortOptions);
        for(let i = 0, len = sortedNodes.length; i < len; ++i){
            const node = sortedNodes[i];
            nodesMap.set({
                id: node.id,
                node: node,
                index: i
            });
        }
    }
    /**
   * Transaction Support here
   */ updateRowNodes(updates) {
        const updatedNodes = [];
        updates.forEach((data)=>{
            const id = this.getRowId(data);
            const lazyNode = this.nodeMap.getBy("id", id);
            if (lazyNode) {
                this.blockUtils.updateDataIntoRowNode(lazyNode.node, data);
                updatedNodes.push(lazyNode.node);
            }
        });
        return updatedNodes;
    }
    insertRowNodes(inserts, indexToAdd) {
        const realRowCount = this.store.getRowCount() - (this.store.getParentNode().sibling ? 1 : 0);
        const addIndex = indexToAdd == null && this.isLastRowKnown ? realRowCount : indexToAdd;
        if (addIndex == null || realRowCount < addIndex) return [];
        const uniqueInsertsMap = {};
        inserts.forEach((data)=>{
            const dataId = this.getRowId(data);
            if (dataId && this.isNodeInCache(dataId)) return;
            uniqueInsertsMap[dataId] = data;
        });
        const uniqueInserts = Object.values(uniqueInsertsMap);
        const numberOfInserts = uniqueInserts.length;
        if (numberOfInserts === 0) return [];
        const nodesToMove = this.nodeMap.filter((node)=>node.index >= addIndex);
        nodesToMove.forEach((lazyNode)=>this.nodeMap.delete(lazyNode));
        nodesToMove.forEach((lazyNode)=>{
            this.nodeMap.set({
                node: lazyNode.node,
                index: lazyNode.index + numberOfInserts,
                id: lazyNode.id
            });
        });
        this.numberOfRows += numberOfInserts;
        return uniqueInserts.map((data, uniqueInsertOffset)=>this.createRowAtIndex(addIndex + uniqueInsertOffset, data));
    }
    removeRowNodes(idsToRemove) {
        const removedNodes = [];
        const nodesToVerify = [];
        let deletedNodeCount = 0;
        const remainingIdsToRemove = [
            ...idsToRemove
        ];
        const allNodes = this.getOrderedNodeMap();
        let contiguousIndex = -1;
        for (const stringIndex of Object.keys(allNodes)){
            contiguousIndex += 1;
            const node = allNodes[stringIndex];
            const matchIndex = remainingIdsToRemove.findIndex((idToRemove)=>idToRemove === node.id);
            if (matchIndex !== -1) {
                remainingIdsToRemove.splice(matchIndex, 1);
                this.destroyRowAtIndex(Number(stringIndex));
                removedNodes.push(node.node);
                deletedNodeCount += 1;
                continue;
            }
            if (deletedNodeCount === 0) continue;
            const numericStoreIndex = Number(stringIndex);
            if (contiguousIndex !== numericStoreIndex) nodesToVerify.push(node.node);
            this.nodeMap.delete(node);
            this.nodeMap.set({
                id: node.id,
                node: node.node,
                index: numericStoreIndex - deletedNodeCount
            });
        }
        this.numberOfRows -= this.isLastRowIndexKnown() ? idsToRemove.length : deletedNodeCount;
        if (remainingIdsToRemove.length > 0 && nodesToVerify.length > 0) {
            nodesToVerify.forEach((node)=>node.__needsRefreshWhenVisible = true);
            this.lazyBlockLoadingSvc.queueLoadCheck();
        }
        return removedNodes;
    }
    /**
   * Return the block size configured for this cache
   */ getBlockSize() {
        return this.storeParams.cacheBlockSize || $5b7ccabde48fae90$var$DEFAULT_BLOCK_SIZE;
    }
    /**
   * Get the start index of the loading block for a given index
   */ getBlockStartIndex(storeIndex) {
        const blockSize = this.getBlockSize();
        return storeIndex - storeIndex % blockSize;
    }
    /**
   * Get the start and end index of a block, given a row store index
   */ getBlockBounds(storeIndex) {
        const startOfBlock = this.getBlockStartIndex(storeIndex);
        const blockSize = this.getBlockSize();
        return [
            startOfBlock,
            startOfBlock + blockSize
        ];
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/stores/lazy/lazyStore.ts
var $5b7ccabde48fae90$var$LazyStore = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(ssrmParams, storeParams, parentRowNode){
        super();
        this.idSequence = {
            value: 0
        };
        this.ssrmParams = ssrmParams;
        this.parentRowNode = parentRowNode;
        this.storeParams = storeParams;
        this.level = parentRowNode.level + 1;
        this.group = ssrmParams.rowGroupCols ? this.level < ssrmParams.rowGroupCols.length : false;
        this.leafGroup = ssrmParams.rowGroupCols ? this.level === ssrmParams.rowGroupCols.length - 1 : false;
        this.info = {};
    }
    wireBeans(beans) {
        this.blockUtils = beans.ssrmBlockUtils;
        this.storeUtils = beans.ssrmStoreUtils;
        this.selectionSvc = beans.selectionSvc;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
    }
    postConstruct() {
        let numberOfRows = 1;
        if (this.level === 0) {
            numberOfRows = this.storeUtils.getServerSideInitialRowCount() ?? 1;
            this.eventSvc.dispatchEventOnce({
                type: "rowCountReady"
            });
        }
        this.cache = this.createManagedBean(new $5b7ccabde48fae90$var$LazyCache(this, numberOfRows, false, this.storeParams));
        const usingTreeData = this.gos.get("treeData");
        if (!usingTreeData && this.group && this.rowGroupColsSvc) {
            const groupColVo = this.ssrmParams.rowGroupCols[this.level];
            this.groupField = groupColVo.field;
            this.rowGroupColumn = this.rowGroupColsSvc.columns[this.level];
        }
    }
    destroy() {
        this.displayIndexStart = void 0;
        this.displayIndexEnd = void 0;
        this.destroyBean(this.cache);
        super.destroy();
    }
    /**
   * Given a server response, ingest the rows outside of the data source lifecycle.
   *
   * @param rowDataParams the server response containing the rows to ingest
   * @param startRow the index to start ingesting rows
   * @param expectedRows the expected number of rows in the response (used to determine if the last row index is known)
   */ applyRowData(rowDataParams, startRow, expectedRows) {
        this.cache.onLoadSuccess(startRow, expectedRows, rowDataParams);
    }
    /**
   * Applies a given transaction to the data set within this store
   *
   * @param transaction an object containing delta instructions determining the changes to apply to this store
   * @returns an object determining the status of this transaction and effected nodes
   */ applyTransaction(transaction) {
        const idFunc = (0, $437b23f6a393c3bf$export$57c3bb2f89b59a89)(this.gos);
        if (!idFunc) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(206);
            return {
                status: (0, $437b23f6a393c3bf$export$58e95be8934cbc38).Cancelled
            };
        }
        const applyCallback = this.gos.getCallback("isApplyServerSideTransaction");
        if (applyCallback) {
            const params = {
                transaction: transaction,
                parentNode: this.parentRowNode,
                groupLevelInfo: this.info
            };
            const apply = applyCallback(params);
            if (!apply) return {
                status: (0, $437b23f6a393c3bf$export$58e95be8934cbc38).Cancelled
            };
        }
        const allRowsLoaded = this.cache.isStoreFullyLoaded();
        let updatedNodes = void 0;
        if (transaction.update?.length) updatedNodes = this.cache.updateRowNodes(transaction.update);
        let insertedNodes = void 0;
        if (transaction.add?.length) {
            let addIndex = transaction.addIndex;
            if (addIndex != null && addIndex < 0) addIndex = void 0;
            insertedNodes = this.cache.insertRowNodes(transaction.add, addIndex);
        }
        let removedNodes = void 0;
        if (transaction.remove?.length) {
            const allIdsToRemove = transaction.remove.map((data)=>idFunc({
                    level: this.level,
                    parentKeys: this.parentRowNode.getRoute() ?? [],
                    data: data
                }));
            const allUniqueIdsToRemove = [
                ...new Set(allIdsToRemove)
            ];
            removedNodes = this.cache.removeRowNodes(allUniqueIdsToRemove);
        }
        const isClientSideSortingEnabled = this.gos.get("serverSideEnableClientSideSort");
        const isUpdateOrAdd = updatedNodes?.length || insertedNodes?.length;
        const isClientSideSort = allRowsLoaded && isClientSideSortingEnabled;
        if (isClientSideSort && isUpdateOrAdd) this.cache.clientSideSortRows();
        this.updateSelectionAfterTransaction(updatedNodes, removedNodes);
        return {
            status: (0, $437b23f6a393c3bf$export$58e95be8934cbc38).Applied,
            update: updatedNodes,
            add: insertedNodes,
            remove: removedNodes
        };
    }
    updateSelectionAfterTransaction(updatedNodes, removedNodes) {
        if (!this.selectionSvc) return;
        const nodesToDeselect = [];
        for (const node of updatedNodes ?? [])if (node.isSelected() && !node.selectable) nodesToDeselect.push(node);
        for (const node of removedNodes ?? [])if (node.isSelected()) nodesToDeselect.push(node);
        if (nodesToDeselect.length) this.selectionSvc.setNodesSelected({
            newValue: false,
            clearSelection: false,
            nodes: nodesToDeselect,
            source: "rowDataChanged"
        });
    }
    /**
   * Clear the display indexes, used for fading rows out when stores are not being destroyed
   */ clearDisplayIndexes() {
        this.displayIndexStart = void 0;
        this.displayIndexEnd = void 0;
        this.cache.getNodes().forEach((lazyNode)=>this.blockUtils.clearDisplayIndex(lazyNode.node));
        if (this.parentRowNode.sibling) this.blockUtils.clearDisplayIndex(this.parentRowNode.sibling);
        this.cache.clearDisplayIndexes();
    }
    /**
   * @returns an index representing the last sequentially displayed row in the grid for this store
   */ getDisplayIndexStart() {
        return this.displayIndexStart;
    }
    /**
   * @returns the index representing one after the last sequentially displayed row in the grid for this store
   */ getDisplayIndexEnd() {
        return this.displayIndexEnd;
    }
    /**
   * @returns the virtual size of this store
   */ getRowCount() {
        if (this.parentRowNode.sibling) return this.cache.getRowCount() + 1;
        return this.cache.getRowCount();
    }
    /**
   * Sets the current row count of the store, and whether the last row index is known
   */ setRowCount(rowCount, isLastRowIndexKnown) {
        this.cache.setRowCount(rowCount, isLastRowIndexKnown);
    }
    /**
   * Given a display index, returns whether that row is within this store or a child store of this store
   *
   * @param displayIndex the visible index of a row
   * @returns whether or not the row exists within this store
   */ isDisplayIndexInStore(displayIndex) {
        if (this.cache.getRowCount() === 0) return false;
        return this.displayIndexStart <= displayIndex && displayIndex < this.getDisplayIndexEnd();
    }
    /**
   * Recursively sets up the display indexes and top position of every node belonging to this store.
   *
   * Called after a row height changes, or a store updated event.
   *
   * @param displayIndexSeq the number sequence for generating the display index of each row
   * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
   */ setDisplayIndexes(displayIndexSeq, nextRowTop, uiLevel) {
        this.displayIndexStart = displayIndexSeq.value;
        this.topPx = nextRowTop.value;
        const footerNode = this.parentRowNode.level > -1 && (0, $437b23f6a393c3bf$export$713d6cabeaa7f2a5)(this.gos)({
            node: this.parentRowNode
        });
        if (!footerNode) $5b7ccabde48fae90$var$_destroyRowNodeFooter(this.parentRowNode);
        if (footerNode === "top") {
            $5b7ccabde48fae90$var$_createRowNodeFooter(this.parentRowNode, this.beans);
            this.blockUtils.setDisplayIndex(this.parentRowNode.sibling, displayIndexSeq, nextRowTop, uiLevel);
        }
        this.cache.setDisplayIndexes(displayIndexSeq, nextRowTop, uiLevel);
        if (footerNode === "bottom") {
            $5b7ccabde48fae90$var$_createRowNodeFooter(this.parentRowNode, this.beans);
            this.blockUtils.setDisplayIndex(this.parentRowNode.sibling, displayIndexSeq, nextRowTop, uiLevel);
        }
        this.displayIndexEnd = displayIndexSeq.value;
        this.heightPx = nextRowTop.value - this.topPx;
    }
    /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
   */ forEachStoreDeep(callback, sequence = {
        value: 0
    }) {
        callback(this, sequence.value++);
        this.cache.getNodes().forEach((lazyNode)=>{
            const childCache = lazyNode.node.childStore;
            if (childCache) childCache.forEachStoreDeep(callback, sequence);
        });
    }
    /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
   */ forEachNodeDeep(callback, sequence = {
        value: 0
    }) {
        this.cache.getNodes().forEach((lazyNode)=>{
            callback(lazyNode.node, sequence.value++);
            const childCache = lazyNode.node.childStore;
            if (childCache) childCache.forEachNodeDeep(callback, sequence);
        });
    }
    /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeep
   */ forEachNodeDeepAfterFilterAndSort(callback, sequence = {
        value: 0
    }, includeFooterNodes = false) {
        const footerNode = this.parentRowNode.level > -1 && (0, $437b23f6a393c3bf$export$713d6cabeaa7f2a5)(this.gos)({
            node: this.parentRowNode
        });
        if (footerNode === "top") callback(this.parentRowNode.sibling, sequence.value++);
        const orderedNodes = this.cache.getOrderedNodeMap();
        for (const lazyNode of Object.values(orderedNodes)){
            callback(lazyNode.node, sequence.value++);
            const childCache = lazyNode.node.childStore;
            if (childCache) childCache.forEachNodeDeepAfterFilterAndSort(callback, sequence, includeFooterNodes);
        }
        if (footerNode === "bottom") callback(this.parentRowNode.sibling, sequence.value++);
    }
    /**
   * Removes the failed status from all nodes, and marks them as stub to encourage reloading
   */ retryLoads() {
        this.cache.getNodes().forEach(({ node: node })=>{
            if (node.failedLoad) {
                node.failedLoad = false;
                node.__needsRefreshWhenVisible = true;
                node.stub = true;
            }
        });
        this.forEachChildStoreShallow((store)=>store.retryLoads());
        this.fireStoreUpdatedEvent();
    }
    /**
   * Given a display index, returns the row at that location.
   *
   * @param displayRowIndex the displayed index within the grid to search for
   * @returns the row node if the display index falls within the store, if it didn't exist this will create a new stub to return
   */ getRowUsingDisplayIndex(displayRowIndex) {
        if (this.parentRowNode.sibling && displayRowIndex === this.parentRowNode.sibling.rowIndex) return this.parentRowNode.sibling;
        return this.cache.getRowByDisplayIndex(displayRowIndex);
    }
    /**
   * Given a display index, returns the row top and height for the row at that index.
   *
   * @param displayIndex the display index of the node
   * @returns an object containing the rowTop and rowHeight of the node at the given displayIndex
   */ getRowBounds(displayIndex) {
        if (!this.isDisplayIndexInStore(displayIndex)) return null;
        const thisNode = this.cache.getNodeCachedByDisplayIndex(displayIndex);
        if (thisNode) {
            const boundsFromRow = this.blockUtils.extractRowBounds(thisNode, displayIndex);
            if (boundsFromRow) return boundsFromRow;
        }
        const { previousNode: previousNode, nextNode: nextNode } = this.cache.getSurroundingNodesByDisplayIndex(displayIndex) ?? {};
        if (previousNode) {
            const boundsFromRow = this.blockUtils.extractRowBounds(previousNode.node, displayIndex);
            if (boundsFromRow != null) return boundsFromRow;
        }
        const defaultRowHeight = (0, $437b23f6a393c3bf$export$8966875adec41e5b)(this.beans);
        if (nextNode) {
            const numberOfRowDiff2 = (nextNode.node.rowIndex - displayIndex) * defaultRowHeight;
            return {
                rowTop: nextNode.node.rowTop - numberOfRowDiff2,
                rowHeight: defaultRowHeight
            };
        }
        const lastTop = this.topPx + this.heightPx;
        const numberOfRowDiff = (this.getDisplayIndexEnd() - displayIndex) * defaultRowHeight;
        return {
            rowTop: lastTop - numberOfRowDiff,
            rowHeight: defaultRowHeight
        };
    }
    /**
   * Given a vertical pixel, determines whether this store contains a row at that pixel
   *
   * @param pixel a vertical pixel position from the grid
   * @returns whether that pixel points to a virtual space belonging to this store
   */ isPixelInRange(pixel) {
        return pixel >= this.topPx && pixel < this.topPx + this.heightPx;
    }
    /**
   * Given a vertical pixel, returns the row existing at that pixel location
   *
   * @param pixel a vertical pixel position from the grid
   * @returns the display index at the given pixel location
   */ getRowIndexAtPixel(pixel) {
        if (pixel < this.topPx) return this.getDisplayIndexStart();
        if (pixel >= this.topPx + this.heightPx) return this.getDisplayIndexEnd() - 1;
        if (this.parentRowNode.sibling && pixel > this.parentRowNode.sibling.rowTop && pixel < this.parentRowNode.sibling.rowTop + this.parentRowNode.sibling.rowHeight) return this.parentRowNode.sibling.rowIndex;
        let distToPreviousNodeTop = Number.MAX_SAFE_INTEGER;
        let previousNode = null;
        let distToNextNodeTop = Number.MAX_SAFE_INTEGER;
        let nextNode = null;
        this.cache.getNodes().forEach(({ node: node })=>{
            const distBetween = Math.abs(pixel - node.rowTop);
            if (node.rowTop < pixel) {
                if (distBetween < distToPreviousNodeTop) {
                    distToPreviousNodeTop = distBetween;
                    previousNode = node;
                }
                return;
            }
            if (distBetween < distToNextNodeTop) {
                distToNextNodeTop = distBetween;
                nextNode = node;
            }
        });
        previousNode;
        nextNode;
        if (previousNode) {
            const indexOfRow = this.blockUtils.getIndexAtPixel(previousNode, pixel);
            if (indexOfRow != null) return indexOfRow;
        }
        const defaultRowHeight = (0, $437b23f6a393c3bf$export$8966875adec41e5b)(this.beans);
        if (nextNode) {
            const nextTop2 = nextNode.rowTop;
            const numberOfRowDiff2 = Math.ceil((nextTop2 - pixel) / defaultRowHeight);
            return nextNode.rowIndex - numberOfRowDiff2;
        }
        const nextTop = this.topPx + this.heightPx;
        const numberOfRowDiff = Math.floor((nextTop - pixel) / defaultRowHeight);
        return this.getDisplayIndexEnd() - numberOfRowDiff;
    }
    /**
   * Given a path of group keys, returns the child store for that group.
   *
   * @param keys the grouping path to the desired store
   * @returns the child store for the given keys, or null if not found
   */ getChildStore(keys) {
        return this.storeUtils.getChildStore(keys, this, (key)=>{
            const lazyNode = this.cache.getNodes().find((lazyNode2)=>lazyNode2.node.key == key);
            if (!lazyNode) return null;
            return lazyNode.node;
        });
    }
    /**
   * Executes a provided callback on each child store belonging to this store
   *
   * @param cb the callback to execute
   */ forEachChildStoreShallow(cb) {
        this.cache.getNodes().forEach(({ node: node })=>{
            if (node.childStore) cb(node.childStore);
        });
    }
    /**
   * Executes after a change to sorting, determines recursively whether this store or a child requires refreshed.
   *
   * If a purge refresh occurs, the row count is preserved.
   *
   * @param params a set of properties pertaining to the sort changes
   */ refreshAfterSort(params) {
        const serverSortsAllLevels = this.storeUtils.isServerSideSortAllLevels();
        if (serverSortsAllLevels || this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, params)) {
            const allRowsLoaded = this.cache.isStoreFullyLoaded();
            const isClientSideSortingEnabled = this.gos.get("serverSideEnableClientSideSort");
            const isClientSideSort = allRowsLoaded && isClientSideSortingEnabled;
            if (!isClientSideSort) {
                const oldCount = this.cache.getRowCount();
                const lastKnown = this.cache.isLastRowIndexKnown();
                this.destroyBean(this.cache);
                this.cache = this.createManagedBean(new $5b7ccabde48fae90$var$LazyCache(this, oldCount, lastKnown, this.storeParams));
                return;
            }
            this.cache.clientSideSortRows();
        }
        this.forEachChildStoreShallow((store)=>store.refreshAfterSort(params));
    }
    /**
   * Executes after a change to filtering, determines recursively whether this store or a child requires refreshed.
   *
   * If a refresh occurs, the row count is reset.
   *
   * @param params a set of properties pertaining to the filter changes
   */ refreshAfterFilter(params) {
        const serverFiltersAllLevels = !this.storeUtils.isServerSideOnlyRefreshFilteredGroups();
        if (serverFiltersAllLevels || this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, params)) {
            this.refreshStore(true);
            return;
        }
        this.forEachChildStoreShallow((store)=>store.refreshAfterFilter(params));
    }
    /**
   * Marks all existing nodes as requiring reloaded, and triggers a load check
   *
   * @param purge whether to remove all nodes and data in favour of stub nodes
   */ refreshStore(purge) {
        if (purge) {
            this.destroyBean(this.cache);
            this.cache = this.createManagedBean(new $5b7ccabde48fae90$var$LazyCache(this, 1, false, this.storeParams));
            this.fireStoreUpdatedEvent();
            return;
        }
        this.cache.markNodesForRefresh();
    }
    /**
   * Used for pagination, given a local/store index, returns the display index of that row
   *
   * @param topLevelIndex the store index of a row
   * @returns the display index for the given store index
   */ getTopLevelRowDisplayedIndex(topLevelIndex) {
        const displayIndex = this.cache.getDisplayIndexFromStoreIndex(topLevelIndex);
        return displayIndex ?? topLevelIndex;
    }
    /**
   * Used for pagination to determine if the last page is known, and for aria to determine if the last grid row is known
   *
   * @returns whether the last index of this store is known, or if lazy loading still required
   */ isLastRowIndexKnown() {
        return this.cache.isLastRowIndexKnown();
    }
    /**
   * Used by the selection service to select a range of nodes
   *
   * @param firstInRange the first node in the range to find
   * @param lastInRange the last node in the range to find
   * @returns a range of nodes between firstInRange and lastInRange inclusive
   */ getRowNodesInRange(firstInRange, lastInRange) {
        return this.cache.getNodes().filter(({ node: node })=>{
            return node.rowIndex >= firstInRange.rowIndex && node.rowIndex <= lastInRange.rowIndex;
        }).map(({ node: node })=>node);
    }
    /**
   * Mutates a given array to add this stores state, and recursively add all the children store states.
   *
   * @param result a mutable results array
   */ addStoreStates(result) {
        result.push({
            route: this.parentRowNode.getRoute() ?? [],
            rowCount: this.getRowCount(),
            lastRowIndexKnown: this.isLastRowIndexKnown(),
            info: this.info,
            maxBlocksInCache: this.storeParams.maxBlocksInCache,
            cacheBlockSize: this.storeParams.cacheBlockSize
        });
        this.forEachChildStoreShallow((childStore)=>childStore.addStoreStates(result));
    }
    getIdSequence() {
        return this.idSequence;
    }
    getParentNode() {
        return this.parentRowNode;
    }
    getRowDetails() {
        return {
            field: this.groupField,
            group: this.group,
            leafGroup: this.leafGroup,
            level: this.level,
            parent: this.parentRowNode,
            rowGroupColumn: this.rowGroupColumn
        };
    }
    getSsrmParams() {
        return this.ssrmParams;
    }
    setStoreInfo(info) {
        if (info) Object.assign(this.info, info);
    }
    // gets called 1) row count changed 2) cache purged
    fireStoreUpdatedEvent() {
        this.eventSvc.dispatchEvent({
            type: "storeUpdated"
        });
    }
    // gets called when row data updated, and no more refreshing needed
    fireRefreshFinishedEvent() {
        this.eventSvc.dispatchEvent({
            type: "storeRefreshed",
            route: this.parentRowNode.getRoute()
        });
    }
    getBlockStates() {
        return this.cache.getBlockStates();
    }
    getStoreBounds() {
        return {
            topPx: this.topPx,
            heightPx: this.heightPx
        };
    }
    getCache() {
        return this.cache;
    }
    getFirstNode() {
        const firstNode = this.cache.getNodes().getBy("index", 0);
        return firstNode?.node ?? null;
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/stores/storeFactory.ts
var $5b7ccabde48fae90$var$StoreFactory = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmStoreFactory";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.pivotColsSvc = beans.pivotColsSvc;
        this.rowAutoHeight = beans.rowAutoHeight;
    }
    createStore(ssrmParams, parentNode) {
        const storeParams = this.getStoreParams(ssrmParams, parentNode);
        return new $5b7ccabde48fae90$var$LazyStore(ssrmParams, storeParams, parentNode);
    }
    getStoreParams(ssrmParams, parentNode) {
        const userStoreParams = this.getLevelSpecificParams(parentNode);
        const cacheBlockSize = this.getBlockSize(userStoreParams);
        const maxBlocksInCache = this.getMaxBlocksInCache(ssrmParams, userStoreParams);
        const storeParams = {
            cacheBlockSize: cacheBlockSize,
            maxBlocksInCache: maxBlocksInCache
        };
        return storeParams;
    }
    getMaxBlocksInCache(ssrmParams, userStoreParams) {
        const maxBlocksInCache = userStoreParams?.maxBlocksInCache != null ? userStoreParams.maxBlocksInCache : this.gos.get("maxBlocksInCache");
        const maxBlocksActive = maxBlocksInCache != null && maxBlocksInCache >= 0;
        if (!maxBlocksActive) return;
        if (ssrmParams.dynamicRowHeight) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(203);
            return;
        }
        if (this.rowAutoHeight?.active) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(204);
            return void 0;
        }
        return maxBlocksInCache;
    }
    getBlockSize(userStoreParams) {
        const blockSize = userStoreParams?.cacheBlockSize != null ? userStoreParams.cacheBlockSize : this.gos.get("cacheBlockSize");
        if (blockSize != null && blockSize > 0) return blockSize;
        else return 100;
    }
    getLevelSpecificParams(parentNode) {
        const callback = this.gos.getCallback("getServerSideGroupLevelParams");
        if (!callback) return void 0;
        const params = {
            level: parentNode.level + 1,
            parentRowNode: parentNode.level >= 0 ? parentNode : void 0,
            rowGroupColumns: this.rowGroupColsSvc?.columns ?? [],
            pivotColumns: this.pivotColsSvc?.columns ?? [],
            pivotMode: this.colModel.isPivotMode()
        };
        const res = callback(params);
        return res;
    }
};
var $5b7ccabde48fae90$var$StoreUtils = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmStoreUtils";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.serverSideRowModel = beans.rowModel;
        this.storeFactory = beans.ssrmStoreFactory;
    }
    getChildStore(keys, currentCache, findNodeFunc) {
        if (!keys?.length) return currentCache;
        const nextKey = keys[0];
        const nextNode = findNodeFunc(nextKey);
        if (nextNode) {
            if (keys.length === 1 && !nextNode.childStore) {
                const storeParams = this.serverSideRowModel.getParams();
                nextNode.childStore = this.createBean(this.storeFactory.createStore(storeParams, nextNode));
            }
            const keyListForNextLevel = keys.slice(1, keys.length);
            const nextStore = nextNode.childStore;
            return nextStore ? nextStore.getChildStore(keyListForNextLevel) : null;
        }
        return null;
    }
    isServerRefreshNeeded(parentRowNode, rowGroupCols, params) {
        if (params.valueColChanged || params.secondaryColChanged) return true;
        const level = parentRowNode.level + 1;
        const grouping = level < rowGroupCols.length;
        const leafNodes = !grouping;
        if (leafNodes) return true;
        const colIdThisGroup = rowGroupCols[level].id;
        const actionOnThisGroup = params.changedColumns.indexOf(colIdThisGroup) > -1;
        if (actionOnThisGroup) return true;
        const allCols = this.colModel.getCols();
        const affectedGroupCols = allCols.filter((col)=>col.getColDef().showRowGroup && params.changedColumns.includes(col.getId())).map((col)=>col.getColDef().showRowGroup).some((group)=>group === true || group === colIdThisGroup);
        return affectedGroupCols;
    }
    getServerSideInitialRowCount() {
        return this.gos.get("serverSideInitialRowCount");
    }
    isServerSideSortAllLevels() {
        return this.gos.get("serverSideSortAllLevels") && (0, $437b23f6a393c3bf$export$cf1bac0013650216)(this.gos);
    }
    isServerSideOnlyRefreshFilteredGroups() {
        return this.gos.get("serverSideOnlyRefreshFilteredGroups") && (0, $437b23f6a393c3bf$export$cf1bac0013650216)(this.gos);
    }
};
var $5b7ccabde48fae90$var$TransactionManager = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "ssrmTxnManager";
        this.asyncTransactions = [];
    }
    wireBeans(beans) {
        this.valueCache = beans.valueCache;
        this.serverSideRowModel = beans.rowModel;
        this.selectionSvc = beans.selectionSvc;
    }
    postConstruct() {
        if (!(0, $437b23f6a393c3bf$export$cf1bac0013650216)(this.gos)) return;
    }
    applyTransactionAsync(transaction, callback) {
        if (this.asyncTransactionsTimeout == null) this.scheduleExecuteAsync();
        this.asyncTransactions.push({
            transaction: transaction,
            callback: callback
        });
    }
    scheduleExecuteAsync() {
        const waitMillis = this.gos.get("asyncTransactionWaitMillis");
        this.asyncTransactionsTimeout = window.setTimeout(()=>{
            this.executeAsyncTransactions();
        }, waitMillis);
    }
    executeAsyncTransactions() {
        if (!this.asyncTransactions) return;
        const resultFuncs = [];
        const resultsForEvent = [];
        const transactionsToRetry = [];
        let atLeastOneTransactionApplied = false;
        for (const txWrapper of this.asyncTransactions){
            let result;
            const hasStarted = this.serverSideRowModel.executeOnStore(txWrapper.transaction.route, (cache)=>{
                result = cache.applyTransaction(txWrapper.transaction);
            });
            if (!hasStarted) result = {
                status: (0, $437b23f6a393c3bf$export$58e95be8934cbc38).StoreNotStarted
            };
            else if (result == void 0) result = {
                status: (0, $437b23f6a393c3bf$export$58e95be8934cbc38).StoreNotFound
            };
            resultsForEvent.push(result);
            const retryTransaction = result.status == (0, $437b23f6a393c3bf$export$58e95be8934cbc38).StoreLoading;
            if (retryTransaction) {
                transactionsToRetry.push(txWrapper);
                continue;
            }
            if (txWrapper.callback) resultFuncs.push(()=>txWrapper.callback(result));
            if (result.status === (0, $437b23f6a393c3bf$export$58e95be8934cbc38).Applied) atLeastOneTransactionApplied = true;
        }
        if (resultFuncs.length > 0) window.setTimeout(()=>{
            for (const func of resultFuncs)func();
        }, 0);
        this.asyncTransactionsTimeout = void 0;
        this.asyncTransactions = transactionsToRetry;
        if (atLeastOneTransactionApplied) {
            this.valueCache?.onDataChanged();
            this.eventSvc.dispatchEvent({
                type: "storeUpdated"
            });
        }
        if (resultsForEvent.length > 0) this.eventSvc.dispatchEvent({
            type: "asyncTransactionsFlushed",
            results: resultsForEvent
        });
    }
    flushAsyncTransactions() {
        if (this.asyncTransactionsTimeout != null) clearTimeout(this.asyncTransactionsTimeout);
        this.executeAsyncTransactions();
    }
    applyTransaction(transaction) {
        let res;
        const hasStarted = this.serverSideRowModel.executeOnStore(transaction.route, (store)=>{
            res = store.applyTransaction(transaction);
        });
        if (!hasStarted) return {
            status: (0, $437b23f6a393c3bf$export$58e95be8934cbc38).StoreNotStarted
        };
        else if (res) {
            this.valueCache?.onDataChanged();
            if (res.remove && this.selectionSvc) {
                const removedRowIds = res.remove.map((row)=>row.id);
                this.selectionSvc.deleteSelectionStateFromParent(transaction.route || [], removedRowIds);
            }
            this.eventSvc.dispatchEvent({
                type: "storeUpdated"
            });
            return res;
        } else return {
            status: (0, $437b23f6a393c3bf$export$58e95be8934cbc38).StoreNotFound
        };
    }
};
// packages/ag-grid-enterprise/src/serverSideRowModel/serverSideRowModelModule.ts
var $5b7ccabde48fae90$export$5c0e9f044c5e2dce = {
    moduleName: "ServerSideRowModel",
    version: $5b7ccabde48fae90$var$VERSION,
    rowModels: [
        "serverSide"
    ],
    beans: [
        $5b7ccabde48fae90$var$ServerSideRowModel,
        $5b7ccabde48fae90$var$ExpandListener,
        $5b7ccabde48fae90$var$StoreUtils,
        $5b7ccabde48fae90$var$BlockUtils,
        $5b7ccabde48fae90$var$NodeManager,
        $5b7ccabde48fae90$var$TransactionManager,
        $5b7ccabde48fae90$var$FilterListener,
        $5b7ccabde48fae90$var$StoreFactory,
        $5b7ccabde48fae90$var$ListenerUtils,
        $5b7ccabde48fae90$var$ServerSideSelectionService,
        $5b7ccabde48fae90$var$LazyBlockLoadingService,
        $5b7ccabde48fae90$var$SsrmRowChildrenService,
        $5b7ccabde48fae90$var$ServerSideExpansionService,
        $5b7ccabde48fae90$var$SortListener
    ],
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$1a6625c5691649e8),
        (0, $437b23f6a393c3bf$export$16cbd1164b82410d),
        $5b7ccabde48fae90$var$SharedPivotModule,
        $5b7ccabde48fae90$var$SharedTreeDataModule,
        $5b7ccabde48fae90$var$LoadingCellRendererModule
    ]
};
var $5b7ccabde48fae90$export$208b04021c462957 = {
    moduleName: "ServerSideRowModelApi",
    version: $5b7ccabde48fae90$var$VERSION,
    apiFunctions: {
        getServerSideSelectionState: $5b7ccabde48fae90$var$getServerSideSelectionState,
        setServerSideSelectionState: $5b7ccabde48fae90$var$setServerSideSelectionState,
        applyServerSideTransaction: $5b7ccabde48fae90$var$applyServerSideTransaction,
        applyServerSideTransactionAsync: $5b7ccabde48fae90$var$applyServerSideTransactionAsync,
        applyServerSideRowData: $5b7ccabde48fae90$var$applyServerSideRowData,
        retryServerSideLoads: $5b7ccabde48fae90$var$retryServerSideLoads,
        flushServerSideAsyncTransactions: $5b7ccabde48fae90$var$flushServerSideAsyncTransactions,
        refreshServerSide: $5b7ccabde48fae90$var$refreshServerSide,
        getServerSideGroupLevelState: $5b7ccabde48fae90$var$getServerSideGroupLevelState,
        resetRowHeights: $437b23f6a393c3bf$export$80ac5296eda53df5,
        onRowHeightChanged: $437b23f6a393c3bf$export$39ff1118beb20c8b
    },
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule,
        (0, $437b23f6a393c3bf$export$b36e8e3b22fa08ce),
        (0, $437b23f6a393c3bf$export$76fb120d9e251426),
        (0, $437b23f6a393c3bf$export$2f6740e35dedc261)
    ]
};
// packages/ag-grid-enterprise/src/formula/formula-styles.css-GENERATED.ts
var $5b7ccabde48fae90$var$formulaStylesCSS = /*css*/ `.formula-error:after{background-color:var(--ag-invalid-color);content:"";height:12px;position:absolute;top:-6px;width:12px}:where(.ag-ltr) .formula-error:after{right:-6px;transform:rotate(45deg)}:where(.ag-rtl) .formula-error:after{left:-6px;transform:rotate(-45deg)}`;
var $5b7ccabde48fae90$var$FormulaDataService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "formulaDataSvc";
        this.hasSource = false;
    }
    postConstruct() {
        const dataSource = this.gos.get("formulaDataSource");
        if (dataSource) this.setDataSource(dataSource);
    }
    hasDataSource() {
        return this.hasSource;
    }
    getFormula(params) {
        const formula = this.dataSource?.getFormula(params);
        return (0, $437b23f6a393c3bf$export$8e19bf64bae2d78a)(formula) ? formula : void 0;
    }
    setFormula(params) {
        this.dataSource?.setFormula(params);
    }
    setDataSource(dataSource) {
        this.dataSource = dataSource;
        this.hasSource = true;
        dataSource.init?.(this.createInitParams());
    }
    createInitParams() {
        return (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {});
    }
    destroy() {
        this.dataSource?.destroy?.();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/formula/ast/operators.ts
var $5b7ccabde48fae90$var$OP_DEFS = [
    {
        symbol: "%",
        fixity: "postfix",
        precedence: 100
    },
    {
        symbol: "-",
        fixity: "prefix",
        precedence: 90
    },
    {
        symbol: "+",
        fixity: "prefix",
        precedence: 90
    },
    {
        symbol: "^",
        fixity: "infix",
        precedence: 80,
        associativity: "right"
    },
    {
        symbol: "*",
        fixity: "infix",
        precedence: 70,
        associativity: "left",
        isAssociative: true
    },
    {
        symbol: "/",
        fixity: "infix",
        precedence: 70,
        associativity: "left"
    },
    {
        symbol: "+",
        fixity: "infix",
        precedence: 60,
        associativity: "left",
        isAssociative: true
    },
    {
        symbol: "-",
        fixity: "infix",
        precedence: 60,
        associativity: "left"
    },
    {
        symbol: "&",
        fixity: "infix",
        precedence: 55,
        associativity: "left",
        isAssociative: true
    },
    {
        symbol: "=",
        fixity: "infix",
        precedence: 50,
        associativity: "left"
    },
    {
        symbol: "<>",
        fixity: "infix",
        precedence: 50,
        associativity: "left"
    },
    {
        symbol: ">=",
        fixity: "infix",
        precedence: 50,
        associativity: "left"
    },
    {
        symbol: "<=",
        fixity: "infix",
        precedence: 50,
        associativity: "left"
    },
    {
        symbol: ">",
        fixity: "infix",
        precedence: 50,
        associativity: "left"
    },
    {
        symbol: "<",
        fixity: "infix",
        precedence: 50,
        associativity: "left"
    }
];
var $5b7ccabde48fae90$var$symbolOperatorMap = /* @__PURE__ */ new Map();
for (const d of $5b7ccabde48fae90$var$OP_DEFS){
    const s2 = $5b7ccabde48fae90$var$symbolOperatorMap.get(d.symbol) ?? [];
    s2.push(d);
    $5b7ccabde48fae90$var$symbolOperatorMap.set(d.symbol, s2);
}
function $5b7ccabde48fae90$var$getDefBySymbol(symbol, fixity) {
    const arr = $5b7ccabde48fae90$var$symbolOperatorMap.get(symbol) ?? [];
    return fixity ? arr.find((d)=>d.fixity === fixity) : arr[0];
}
var $5b7ccabde48fae90$var$OP_SYMBOLS_DESC = [
    ...new Set($5b7ccabde48fae90$var$OP_DEFS.map((d)=>d.symbol))
].sort((a, b)=>b.length - a.length);
var $5b7ccabde48fae90$var$OP_BY_SYMBOL = $5b7ccabde48fae90$var$symbolOperatorMap;
// packages/ag-grid-enterprise/src/formula/ast/utils.ts
var $5b7ccabde48fae90$var$FormulaError = class extends Error {
    constructor(message, type = "#ERROR!"){
        super(message);
        this.type = type;
        this.name = "FormulaError";
    }
};
var $5b7ccabde48fae90$var$FormulaParseError = class extends $5b7ccabde48fae90$var$FormulaError {
    constructor(message, errorStart, errorEnd){
        super(message, "#PARSE!");
        this.errorStart = errorStart;
        this.errorEnd = errorEnd;
    }
};
// packages/ag-grid-enterprise/src/formula/ast/parsers.ts
var $5b7ccabde48fae90$var$parseOperand = (beans, operand, unsafe)=>{
    const trimmed = operand.trim();
    if (trimmed.startsWith('"') && trimmed.endsWith('"') && trimmed.length > 2) return trimmed.slice(1, -1);
    if (trimmed.toLowerCase() === "true") return true;
    if (trimmed.toLowerCase() === "false") return false;
    const num = Number(trimmed);
    if (!isNaN(num)) return num;
    const cellRegex = /^(\$?)([A-Z]+)(\$?)([0-9]+)(?::(\$?)([A-Z]+)(\$?)([0-9]+))?$/i;
    const match = trimmed.match(cellRegex);
    if (match) {
        const [, absCol1, col1, absRow1, row1, absCol2, col2, absRow2, row2] = match;
        const toCell = (colAbs, colStr, rowAbs, rowStr, unsafe2)=>{
            const col = colAbs || unsafe2 ? colStr.toUpperCase() : beans.formula?.getColByRef(colStr)?.colId;
            const row = rowAbs || unsafe2 ? rowStr : (0, $437b23f6a393c3bf$export$f5285e6f27a03f95)(beans)?.getFormulaRow(Number(rowStr) - 1)?.id;
            if (col == null || row == null) throw new $5b7ccabde48fae90$var$FormulaParseError(`Invalid cell reference: ${trimmed}`, 0, 0);
            return {
                column: {
                    id: col,
                    absolute: colAbs
                },
                row: {
                    id: row,
                    absolute: rowAbs
                }
            };
        };
        const start = toCell(absCol1 === "$", col1, absRow1 === "$", row1, unsafe);
        if (col2 && row2) {
            const end = toCell(absCol2 === "$", col2, absRow2 === "$", row2, unsafe);
            start.endColumn = end.column;
            start.endRow = end.row;
        }
        return start;
    }
    return null;
};
function $5b7ccabde48fae90$var$tokenize(expr) {
    const tokens = [];
    let i = 0;
    const lexCellRange = (s2, start)=>{
        let j = start;
        const dollar = ()=>s2[j] === "$" ? (j++, true) : false;
        const letters = ()=>{
            const k = j;
            while(j < s2.length && /[A-Za-z]/.test(s2[j]))j++;
            return j > k;
        };
        const digits = ()=>{
            const k = j;
            while(j < s2.length && /[0-9]/.test(s2[j]))j++;
            return j > k;
        };
        const parseCell = ()=>{
            const j0 = j;
            dollar();
            if (!letters()) {
                j = j0;
                return false;
            }
            dollar();
            if (!digits()) {
                j = j0;
                return false;
            }
            return true;
        };
        if (!parseCell()) return 0;
        if (s2[j] === ":") {
            const colonPos = j;
            j++;
            if (!parseCell()) throw new $5b7ccabde48fae90$var$FormulaParseError("Invalid range end reference", colonPos, j);
        }
        return j - start;
    };
    while(i < expr.length){
        const ch = expr[i];
        if (/\s/.test(ch)) {
            i++;
            continue;
        }
        if (ch === '"') {
            let j = i + 1;
            while(j < expr.length && expr[j] !== '"')j++;
            if (j >= expr.length) throw new $5b7ccabde48fae90$var$FormulaParseError("Unterminated string", i, expr.length);
            tokens.push(expr.slice(i, j + 1));
            i = j + 1;
            continue;
        }
        if (/[0-9]/.test(ch) || ch === "." && /[0-9]/.test(expr[i + 1])) {
            let j = i + 1;
            while(j < expr.length && /[0-9.]/.test(expr[j]))j++;
            tokens.push(expr.slice(i, j));
            i = j;
            continue;
        }
        if (ch === "$" || /[A-Za-z]/.test(ch)) {
            const len = lexCellRange(expr, i);
            if (len > 0) {
                tokens.push(expr.slice(i, i + len));
                i += len;
                continue;
            }
            let j = i + 1;
            while(j < expr.length && /[A-Za-z0-9]/.test(expr[j]))j++;
            tokens.push(expr.slice(i, j));
            i = j;
            continue;
        }
        if (ch === "(" || ch === ")" || ch === ",") {
            tokens.push(ch);
            i++;
            continue;
        }
        const firstMatch = $5b7ccabde48fae90$var$OP_SYMBOLS_DESC.find((sym)=>expr.startsWith(sym, i));
        if (!firstMatch) throw new $5b7ccabde48fae90$var$FormulaParseError("Unexpected character: " + ch, i, i + 1);
        tokens.push(firstMatch);
        i += firstMatch.length;
    }
    return tokens;
}
function $5b7ccabde48fae90$var$shouldReduce(top, incoming) {
    if (top.fixity !== "infix" || incoming.fixity !== "infix") return true;
    if (top.associativity === "right" && top.precedence === incoming.precedence) return false;
    return top.precedence >= incoming.precedence;
}
function $5b7ccabde48fae90$var$pickOpDefForContext(symbol, prevToken) {
    const defs = $5b7ccabde48fae90$var$OP_BY_SYMBOL.get(symbol);
    if (!defs) return null;
    const prevIsOperator = prevToken !== void 0 && $5b7ccabde48fae90$var$OP_BY_SYMBOL.has(prevToken);
    const prevIsOpenOrComma = prevToken === "(" || prevToken === ",";
    const prevIsValueLike = prevToken !== void 0 && !prevIsOperator && !prevIsOpenOrComma && prevToken !== "(";
    if (prevIsValueLike || prevToken === ")") return defs.find((d)=>d.fixity === "postfix") ?? defs.find((d)=>d.fixity === "infix") ?? null;
    return defs.find((d)=>d.fixity === "prefix") ?? defs.find((d)=>d.fixity === "infix") ?? null;
}
function $5b7ccabde48fae90$var$parseExpression(beans, expr, unsafe) {
    const tokens = $5b7ccabde48fae90$var$tokenize(expr);
    const output = [];
    const ops = [];
    const applyTop = ()=>{
        const frame = ops.pop();
        if (!frame) throw new $5b7ccabde48fae90$var$FormulaParseError("Operator stack underflow", 0, 0);
        if (frame.kind === "op") {
            const def = frame.def;
            if (def.fixity !== "infix") {
                const right2 = output.pop();
                if (!right2) throw new $5b7ccabde48fae90$var$FormulaParseError(`Missing operand for '${def.symbol}'`, 0, 0);
                if (def.symbol === "+" && def.fixity === "prefix") {
                    output.push(right2);
                    return;
                }
                if (def.fixity === "postfix" && def.symbol === "%") {
                    output.push({
                        type: "operation",
                        operation: def.symbol,
                        operands: [
                            right2
                        ]
                    });
                    return;
                }
                if (def.symbol === "-" && def.fixity === "prefix") output.push({
                    type: "operation",
                    operation: "-",
                    operands: [
                        {
                            type: "operand",
                            value: 0
                        },
                        right2
                    ]
                });
                else output.push({
                    type: "operation",
                    operation: def.symbol,
                    operands: [
                        right2
                    ]
                });
                return;
            }
            const right = output.pop();
            const left = output.pop();
            if (!left || !right) throw new $5b7ccabde48fae90$var$FormulaParseError(`Missing operand for '${def.symbol}'`, 0, 0);
            output.push({
                type: "operation",
                operation: def.symbol,
                operands: [
                    left,
                    right
                ]
            });
            return;
        }
        throw new $5b7ccabde48fae90$var$FormulaParseError("Internal error: unexpected frame during reduction", 0, 0);
    };
    let i = 0;
    while(i < tokens.length){
        const token = tokens[i];
        if (/[A-Za-z]/.test(token[0] || "") && tokens[i + 1] === "(") {
            const name = token;
            ops.push({
                kind: "function",
                name: name,
                args: []
            });
            ops.push({
                kind: "parenthesis",
                outLen: output.length
            });
            i += 2;
            continue;
        }
        if (token === "(") {
            ops.push({
                kind: "parenthesis",
                outLen: output.length
            });
            i++;
            continue;
        }
        if (token === ",") {
            while(true){
                const top = ops[ops.length - 1];
                if (!top || top.kind === "parenthesis") break;
                if (top.kind === "op") applyTop();
                else throw new $5b7ccabde48fae90$var$FormulaParseError("Internal error: unexpected frame before '('", i, i + 1);
            }
            const paren = ops[ops.length - 1];
            if (!paren || paren.kind !== "parenthesis") throw new $5b7ccabde48fae90$var$FormulaParseError("Misplaced comma", i, i + 1);
            const maybeFunction = ops[ops.length - 2];
            if (!maybeFunction || maybeFunction.kind !== "function") throw new $5b7ccabde48fae90$var$FormulaParseError("Comma outside of a function call", i, i + 1);
            if (output.length > paren.outLen) maybeFunction.args.push(output.pop());
            i++;
            continue;
        }
        if (token === ")") {
            while(true){
                const top = ops[ops.length - 1];
                if (!top || top.kind === "parenthesis") break;
                if (top.kind === "op") applyTop();
                else throw new $5b7ccabde48fae90$var$FormulaParseError("Internal error: unexpected frame before ')'", i, i + 1);
            }
            const paren = ops[ops.length - 1];
            if (!paren || paren.kind !== "parenthesis") throw new $5b7ccabde48fae90$var$FormulaParseError("Mismatched parentheses", i, i + 1);
            const parenOutLen = paren.outLen;
            ops.pop();
            if (ops[ops.length - 1]?.kind === "function") {
                const fn = ops.pop();
                if (output.length > parenOutLen) fn.args.push(output.pop());
                output.push({
                    type: "operation",
                    operation: fn.name,
                    operands: fn.args
                });
            }
            i++;
            continue;
        }
        const incoming = $5b7ccabde48fae90$var$OP_BY_SYMBOL.has(token) ? $5b7ccabde48fae90$var$pickOpDefForContext(token, tokens[i - 1]) : null;
        if (incoming) {
            while(true){
                const top = ops[ops.length - 1];
                if (!top || top.kind !== "op") break;
                if ($5b7ccabde48fae90$var$shouldReduce(top.def, incoming)) applyTop();
                else break;
            }
            ops.push({
                kind: "op",
                def: incoming
            });
            i++;
            continue;
        }
        const parsed = $5b7ccabde48fae90$var$parseOperand(beans, token, unsafe);
        if (parsed == null) throw new $5b7ccabde48fae90$var$FormulaParseError("Unsupported operand: " + token, 0, token.length);
        output.push({
            type: "operand",
            value: parsed
        });
        i++;
    }
    while(ops.length){
        const top = ops[ops.length - 1];
        if (top.kind === "op") applyTop();
        else throw new $5b7ccabde48fae90$var$FormulaParseError("Mismatched parentheses or unfinished function call", 0, 0);
    }
    if (output.length !== 1) throw new $5b7ccabde48fae90$var$FormulaParseError("Invalid expression", 0, 0);
    return output[0];
}
var $5b7ccabde48fae90$var$parseFormula = (beans, formula, unsafe = false)=>{
    if (!(0, $437b23f6a393c3bf$export$8e19bf64bae2d78a)(formula)) throw new $5b7ccabde48fae90$var$FormulaParseError("Formulas must begin with =", 0, 1);
    const body = formula.slice(1).trim();
    return $5b7ccabde48fae90$var$normalizeRefCells($5b7ccabde48fae90$var$parseExpression(beans, body, unsafe));
};
function $5b7ccabde48fae90$var$isOperation(node, name) {
    return node.type === "operation" && node.operation.toUpperCase() === name.toUpperCase();
}
function $5b7ccabde48fae90$var$asBool(node, def = false) {
    if (!node) return def;
    if (node.type !== "operand") return def;
    return !!node.value;
}
function $5b7ccabde48fae90$var$asStringish(node) {
    if (!node || node.type !== "operand") return null;
    const v = node.value;
    if (typeof v === "string") return v;
    if (typeof v === "number" || typeof v === "boolean") return String(v);
    return null;
}
function $5b7ccabde48fae90$var$extractColumnRef(node) {
    if (!$5b7ccabde48fae90$var$isOperation(node, "COLUMN")) return null;
    const id = $5b7ccabde48fae90$var$asStringish(node.operands[0]);
    if (id == null) return null;
    const absolute = $5b7ccabde48fae90$var$asBool(node.operands[1], false);
    return {
        id: id,
        absolute: absolute
    };
}
function $5b7ccabde48fae90$var$extractRowRef(node) {
    if (!$5b7ccabde48fae90$var$isOperation(node, "ROW")) return null;
    const id = $5b7ccabde48fae90$var$asStringish(node.operands[0]);
    if (id == null) return null;
    const absolute = $5b7ccabde48fae90$var$asBool(node.operands[1], false);
    return {
        id: id,
        absolute: absolute
    };
}
function $5b7ccabde48fae90$var$tryFoldRefToCell(node) {
    if (!$5b7ccabde48fae90$var$isOperation(node, "REF")) return null;
    const ops = node.operands;
    if (ops.length !== 2 && ops.length !== 4) return null;
    const col1 = $5b7ccabde48fae90$var$extractColumnRef(ops[0]);
    const row1 = $5b7ccabde48fae90$var$extractRowRef(ops[1]);
    if (!col1 || !row1) return null;
    const cell = {
        column: col1,
        row: row1
    };
    if (ops.length === 4) {
        const col2 = $5b7ccabde48fae90$var$extractColumnRef(ops[2]);
        const row2 = $5b7ccabde48fae90$var$extractRowRef(ops[3]);
        if (!col2 || !row2) return null;
        cell.endColumn = col2;
        cell.endRow = row2;
    }
    return {
        type: "operand",
        value: cell
    };
}
function $5b7ccabde48fae90$var$normalizeRefCells(node) {
    if (node.type === "operation") {
        const normalizedOperands = node.operands.map($5b7ccabde48fae90$var$normalizeRefCells);
        const rebuilt = {
            type: "operation",
            operation: node.operation,
            operands: normalizedOperands
        };
        const folded = $5b7ccabde48fae90$var$tryFoldRefToCell(rebuilt);
        return folded ?? rebuilt;
    }
    return node;
}
var $5b7ccabde48fae90$var$isOperationNode = (n)=>n.type === "operation";
function $5b7ccabde48fae90$var$colLabelFromId(beans, colId) {
    const col = beans.colModel.getColById(colId);
    if (col) return beans.formula?.getColRef(col) ?? null;
    return null;
}
function $5b7ccabde48fae90$var$colIdFromLabel(beans, label) {
    return beans.formula?.getColByRef?.(label)?.colId ?? null;
}
function $5b7ccabde48fae90$var$colIndexFromId(colModel, cols, colId) {
    const col = colModel.getColById(colId);
    if (!col) return null;
    const i = cols.indexOf(col);
    return i >= 0 ? i : null;
}
function $5b7ccabde48fae90$var$colIdFromIndex(cols, idx) {
    const col = cols[idx];
    return col ? col.getId() ?? null : null;
}
function $5b7ccabde48fae90$var$rowIndexFromId(beans, rowId) {
    const row = beans.rowModel?.getRowNode?.(rowId);
    if (row?.formulaRowIndex != null) return row.formulaRowIndex + 1;
    return null;
}
function $5b7ccabde48fae90$var$rowIdFromIndex(beans, idx) {
    return (0, $437b23f6a393c3bf$export$f5285e6f27a03f95)(beans)?.getFormulaRow?.(idx - 1)?.id ?? null;
}
function $5b7ccabde48fae90$var$quoteString(s2) {
    if (s2.includes('"')) throw 'String contains a quote (") which the tokenizer does not support.';
    return `"${s2}"`;
}
function $5b7ccabde48fae90$var$columnValueForREF(beans, ref) {
    const looksLetters = /^[A-Za-z]+$/.test(ref.id);
    if (ref.absolute) {
        if (looksLetters) return ref.id.toUpperCase();
        const label = $5b7ccabde48fae90$var$colLabelFromId(beans, ref.id);
        if (label) return label.toUpperCase();
        throw `Cannot produce absolute COLUMN label from id '${ref.id}'`;
    } else {
        if (looksLetters) {
            const id = $5b7ccabde48fae90$var$colIdFromLabel(beans, ref.id);
            if (id) return id;
        }
        return ref.id;
    }
}
function $5b7ccabde48fae90$var$rowValueForREF(beans, ref) {
    const { id: id, absolute: absolute } = ref;
    if (absolute) {
        const rowId = $5b7ccabde48fae90$var$rowIdFromIndex(beans, Number(id));
        if (rowId == null) throw `Cannot produce absolute ROW index from id '${id}'`;
    } else {
        const idx = $5b7ccabde48fae90$var$rowIndexFromId(beans, id);
        if (idx == null) throw `Cannot produce ROW index from id '${id}'`;
    }
    return id;
}
function $5b7ccabde48fae90$var$columnLabelForA1(beans, ref) {
    if (ref.absolute) return ref.id;
    const label = $5b7ccabde48fae90$var$colLabelFromId(beans, ref.id);
    if (label) return label.toUpperCase();
    throw `Cannot map column id '${ref.id}' to A1 label`;
}
function $5b7ccabde48fae90$var$rowIndexForA1(beans, ref) {
    if (ref.absolute) {
        const idx2 = Number(ref.id);
        if (Number.isFinite(idx2) && idx2 >= 1) return idx2;
        throw `Cannot parse absolute row index '${ref.id}'`;
    }
    const idx = $5b7ccabde48fae90$var$rowIndexFromId(beans, ref.id);
    if (idx != null) return idx;
    throw `Cannot map row id '${ref.id}' to A1 index`;
}
function $5b7ccabde48fae90$var$serializeCellA1(beans, cell, unsafe) {
    const a = (abs, x)=>(abs ? "$" : "") + String(x);
    const col1 = unsafe ? cell.column.id : $5b7ccabde48fae90$var$columnLabelForA1(beans, cell.column);
    const row1 = unsafe ? cell.row.id : $5b7ccabde48fae90$var$rowIndexForA1(beans, cell.row);
    const startRef = a(cell.column.absolute, col1) + a(cell.row.absolute, row1);
    if (cell.endColumn && cell.endRow) {
        const col2 = unsafe ? cell.endColumn.id : $5b7ccabde48fae90$var$columnLabelForA1(beans, cell.endColumn);
        const row2 = unsafe ? cell.endRow.id : $5b7ccabde48fae90$var$rowIndexForA1(beans, cell.endRow);
        return `${startRef}:${a(cell.endColumn.absolute, col2)}${a(cell.endRow.absolute, row2)}`;
    }
    return startRef;
}
function $5b7ccabde48fae90$var$serializeCellREF(beans, cell) {
    const colPart = (r)=>`COLUMN(${$5b7ccabde48fae90$var$quoteString($5b7ccabde48fae90$var$columnValueForREF(beans, r))}${r.absolute ? ",true" : ""})`;
    const rowPart = (r)=>`ROW(${$5b7ccabde48fae90$var$quoteString($5b7ccabde48fae90$var$rowValueForREF(beans, r))}${r.absolute ? ",true" : ""})`;
    const start = `REF(${colPart(cell.column)},${rowPart(cell.row)}`;
    if (cell.endColumn && cell.endRow) return `${start},${colPart(cell.endColumn)},${rowPart(cell.endRow)})`;
    return `${start})`;
}
function $5b7ccabde48fae90$var$isUnaryMinusNode(node) {
    if (!$5b7ccabde48fae90$var$isOperationNode(node) || node.operation !== "-" || node.operands.length !== 2) return null;
    const [left, right] = node.operands;
    if (left.type === "operand" && left.value === 0) return right;
    return null;
}
function $5b7ccabde48fae90$var$isInfixOpNode(node) {
    if (!$5b7ccabde48fae90$var$isOperationNode(node)) return false;
    return !!$5b7ccabde48fae90$var$getDefBySymbol(node.operation, "infix");
}
function $5b7ccabde48fae90$var$needsParensInBinary(parentDef, child, side) {
    if (!$5b7ccabde48fae90$var$isOperationNode(child)) return false;
    if ($5b7ccabde48fae90$var$isUnaryMinusNode(child)) return false;
    const childDef = $5b7ccabde48fae90$var$getDefBySymbol(child.operation, "infix");
    if (!childDef || childDef.fixity !== "infix") return false;
    const pParent = parentDef.precedence;
    const pChild = childDef.precedence;
    if (pChild < pParent) return true;
    if (pChild > pParent) return false;
    if (parentDef.associativity === "right") {
        const sameOp = childDef.symbol === parentDef.symbol;
        return side === "left" && sameOp;
    }
    const parentAssociative = parentDef.isAssociative === true;
    if (!parentAssociative) return side === "right";
    return false;
}
function $5b7ccabde48fae90$var$needsParensForUnaryMinus(rhs) {
    if (!$5b7ccabde48fae90$var$isOperationNode(rhs)) return false;
    const innerInfix = $5b7ccabde48fae90$var$getDefBySymbol(rhs.operation, "infix");
    if (!innerInfix) return false;
    const isPow = innerInfix.symbol === "^";
    return !isPow;
}
function $5b7ccabde48fae90$var$serializeFormula(beans, root, useRefFormat, unsafe) {
    const emitCell = (cell)=>useRefFormat ? $5b7ccabde48fae90$var$serializeCellREF(beans, cell) : $5b7ccabde48fae90$var$serializeCellA1(beans, cell, unsafe);
    function emit(node) {
        if (node.type === "operand") {
            const v = node.value;
            if (typeof v === "string") return $5b7ccabde48fae90$var$quoteString(v);
            if (typeof v === "number") return String(v);
            if (typeof v === "boolean") return v ? "TRUE" : "FALSE";
            return emitCell(v);
        }
        const unaryMinusInner = $5b7ccabde48fae90$var$isUnaryMinusNode(node);
        if (unaryMinusInner) {
            const s2 = emit(unaryMinusInner);
            return $5b7ccabde48fae90$var$needsParensForUnaryMinus(unaryMinusInner) ? `-(${s2})` : `-${s2}`;
        }
        const op = node.operation.toUpperCase();
        if (node.operands.length === 1) {
            const rhs = node.operands[0];
            const post = $5b7ccabde48fae90$var$getDefBySymbol(op, "postfix");
            if (post) return `${emit(rhs)}${post.symbol}`;
            const pre = $5b7ccabde48fae90$var$getDefBySymbol(op, "prefix");
            if (pre) {
                const inner = emit(rhs);
                const need = $5b7ccabde48fae90$var$isInfixOpNode(rhs);
                return need ? `${pre.symbol}(${inner})` : `${pre.symbol}${inner}`;
            }
            return `${op}(${emit(rhs)})`;
        }
        if (node.operands.length === 2) {
            const def = $5b7ccabde48fae90$var$getDefBySymbol(op, "infix");
            if (def) {
                const [l, r] = node.operands;
                const Ls = $5b7ccabde48fae90$var$needsParensInBinary(def, l, "left") ? `(${emit(l)})` : emit(l);
                const Rs = $5b7ccabde48fae90$var$needsParensInBinary(def, r, "right") ? `(${emit(r)})` : emit(r);
                return `${Ls}${def.symbol}${Rs}`;
            }
        }
        return `${op}(${node.operands.map(emit).join(",")})`;
    }
    return "=" + emit(root);
}
function $5b7ccabde48fae90$var$isRangeCell(cell) {
    return !!(cell.endColumn && cell.endRow);
}
function $5b7ccabde48fae90$var$resolveRefToAddress(beans, cell) {
    const { row: row, column: column } = cell;
    const rowNode = row.absolute ? (0, $437b23f6a393c3bf$export$f5285e6f27a03f95)(beans)?.getFormulaRow(Number(row.id) - 1) : beans.rowModel.getRowNode(row.id);
    const agCol = column.absolute ? beans.formula.getColByRef(column.id) : beans.colModel.getColById(column.id);
    if (!rowNode || !agCol) return null;
    return {
        row: rowNode,
        column: agCol
    };
}
function $5b7ccabde48fae90$var$evalAst(beans, node, getCellValue, caller) {
    if (node.type === "operand") {
        const v = node.value;
        if (typeof v !== "object") return v;
        if ($5b7ccabde48fae90$var$isRangeCell(v)) throw new $5b7ccabde48fae90$var$FormulaError("Range is not allowed in scalar context");
        const addr = $5b7ccabde48fae90$var$resolveRefToAddress(beans, v);
        if (!addr) throw new $5b7ccabde48fae90$var$FormulaError("Unknown reference to cell", "#REF!");
        return getCellValue(addr);
    }
    const fn = beans.formula?.getFunction(node.operation);
    if (!fn) throw new $5b7ccabde48fae90$var$FormulaError(`Unsupported operation ${node.operation}`, "#NAME?");
    const { args: args, values: values } = $5b7ccabde48fae90$var$makeArgIterables(beans, node.operands, getCellValue, caller);
    return fn({
        row: caller.row,
        column: caller.column,
        args: args,
        values: values
    });
}
function $5b7ccabde48fae90$var$operandToArg(beans, node, getCellValue, caller) {
    if (node.type === "operand") {
        const v = node.value;
        if (typeof v !== "object") return {
            kind: "value",
            value: v
        };
        if ($5b7ccabde48fae90$var$isRangeCell(v)) return $5b7ccabde48fae90$var$buildRangeArgLazy(beans, v, getCellValue);
        const addr = $5b7ccabde48fae90$var$resolveRefToAddress(beans, v);
        if (!addr) throw new $5b7ccabde48fae90$var$FormulaError("Unknown reference to cell", "#REF!");
        return {
            kind: "value",
            value: getCellValue(addr)
        };
    }
    const val = $5b7ccabde48fae90$var$evalAst(beans, node, getCellValue, caller);
    return {
        kind: "value",
        value: val
    };
}
var $5b7ccabde48fae90$var$ParamsIterator = class {
    constructor(beans, operandNodes, getCellValue, caller){
        this.beans = beans;
        this.operandNodes = operandNodes;
        this.getCellValue = getCellValue;
        this.caller = caller;
        this.i = 0;
        this.res = {
            done: false,
            value: void 0
        };
    }
    next() {
        if (this.i >= this.operandNodes.length) {
            this.res.done = true;
            this.res.value = void 0;
            return this.res;
        }
        this.res.done = false;
        this.res.value = $5b7ccabde48fae90$var$operandToArg(this.beans, this.operandNodes[this.i++], this.getCellValue, this.caller);
        return this.res;
    }
    [Symbol.iterator]() {
        return this;
    }
};
var $5b7ccabde48fae90$var$ValuesIterator = class {
    constructor(beans, operandNodes, getCellValue, caller){
        this.beans = beans;
        this.operandNodes = operandNodes;
        this.getCellValue = getCellValue;
        this.caller = caller;
        this.i = 0;
        this.inner = null;
        this.res = {
            done: false,
            value: void 0
        };
    }
    next() {
        while(true){
            if (this.inner) {
                const step = this.inner.next();
                if (!step.done) {
                    this.res.done = false;
                    this.res.value = step.value;
                    return this.res;
                }
                this.inner = null;
                continue;
            }
            if (this.i >= this.operandNodes.length) {
                this.res.done = true;
                this.res.value = void 0;
                return this.res;
            }
            const arg = $5b7ccabde48fae90$var$operandToArg(this.beans, this.operandNodes[this.i++], this.getCellValue, this.caller);
            if (arg.kind === "value") {
                this.res.done = false;
                this.res.value = arg.value;
                return this.res;
            }
            this.inner = arg[Symbol.iterator]();
        }
    }
    [Symbol.iterator]() {
        return this;
    }
};
function $5b7ccabde48fae90$var$makeArgIterables(beans, operandNodes, getCellValue, caller) {
    const args = {
        [Symbol.iterator] () {
            return new $5b7ccabde48fae90$var$ParamsIterator(beans, operandNodes, getCellValue, caller);
        }
    };
    const values = {
        [Symbol.iterator] () {
            return new $5b7ccabde48fae90$var$ValuesIterator(beans, operandNodes, getCellValue, caller);
        }
    };
    return {
        args: args,
        values: values
    };
}
function $5b7ccabde48fae90$var$resolveRowIndex(beans, ref) {
    if (ref.absolute) {
        const n = Number(ref.id) - 1;
        if (!Number.isFinite(n) || n < 0) throw new $5b7ccabde48fae90$var$FormulaError("Invalid absolute row", "#REF!");
        return n;
    }
    const node = beans.rowModel?.getRowNode?.(ref.id);
    if (node?.formulaRowIndex == null) throw new $5b7ccabde48fae90$var$FormulaError("Unrecognised row id", "#REF!");
    return node.formulaRowIndex;
}
function $5b7ccabde48fae90$var$resolveCol(beans, ref) {
    if (ref.absolute) {
        const col2 = beans.formula?.getColByRef(ref.id);
        if (!col2) throw new $5b7ccabde48fae90$var$FormulaError("Invalid absolute column", "#REF!");
        return col2;
    }
    const col = beans.colModel.getColById(ref.id);
    if (!col) throw new $5b7ccabde48fae90$var$FormulaError("Unrecognised column id", "#REF!");
    return col;
}
var $5b7ccabde48fae90$var$RangeValuesIterator = class {
    constructor(beans, rowStartIndex, rowEndIndex, colStart, colEnd, getCellValue){
        this.beans = beans;
        this.rowStartIndex = rowStartIndex;
        this.rowEndIndex = rowEndIndex;
        this.colStart = colStart;
        this.colEnd = colEnd;
        this.getCellValue = getCellValue;
        this.cols = null;
        this.currentRowIndex = this.rowStartIndex;
        this.currentColIdx = -1;
        this.colStartIdx = -1;
        this.colEndIdx = -1;
        this.res = {
            done: false,
            value: void 0
        };
    }
    initColsOnce() {
        if (this.cols) return;
        this.cols = this.beans.colModel.getCols() ?? [];
        const range = $5b7ccabde48fae90$var$getColRangeIndices(this.beans, this.colStart, this.colEnd);
        if (!range) {
            this.colStartIdx = -1;
            this.colEndIdx = -1;
            return;
        }
        [this.colStartIdx, this.colEndIdx] = range;
        this.currentColIdx = this.colStartIdx;
    }
    next() {
        if (!this.cols) {
            this.initColsOnce();
            if (this.colStartIdx < 0) {
                this.res.done = true;
                return this.res;
            }
        }
        if (this.currentRowIndex <= this.rowEndIndex) {
            const row = (0, $437b23f6a393c3bf$export$f5285e6f27a03f95)(this.beans)?.getFormulaRow(this.currentRowIndex);
            if (!row) throw new $5b7ccabde48fae90$var$FormulaError("Unrecognised row in range", "#REF!");
            const col = this.cols[this.currentColIdx];
            if (this.currentColIdx < this.colEndIdx) this.currentColIdx++;
            else {
                this.currentColIdx = this.colStartIdx;
                this.currentRowIndex++;
            }
            this.res.value = this.getCellValue({
                row: row,
                column: col
            });
            return this.res;
        }
        this.res.done = true;
        this.res.value = void 0;
        return this.res;
    }
};
function $5b7ccabde48fae90$var$buildRangeArgLazy(beans, cell, getCellValue) {
    const r1 = $5b7ccabde48fae90$var$resolveRowIndex(beans, cell.row);
    const r2 = cell.endRow ? $5b7ccabde48fae90$var$resolveRowIndex(beans, cell.endRow) : r1;
    const rowStart = Math.min(r1, r2);
    const rowEnd = Math.max(r1, r2);
    const c1 = $5b7ccabde48fae90$var$resolveCol(beans, cell.column);
    const c2 = cell.endColumn ? $5b7ccabde48fae90$var$resolveCol(beans, cell.endColumn) : c1;
    return {
        kind: "range",
        rowStart: rowStart,
        rowEnd: rowEnd,
        colStart: c1,
        colEnd: c2,
        [Symbol.iterator] () {
            return new $5b7ccabde48fae90$var$RangeValuesIterator(beans, rowStart, rowEnd, c1, c2, getCellValue);
        }
    };
}
function $5b7ccabde48fae90$var$getColRangeIndices(beans, c1, c2) {
    const allColumns = beans.colModel.getCols() ?? [];
    let startColIndex = null;
    let endColIndex = null;
    for(let i = 0; i < allColumns.length && (startColIndex === null || endColIndex === null); i++){
        const column = allColumns[i];
        if (column === c2) endColIndex = i;
        if (column === c1) startColIndex = i;
        if (endColIndex !== null && startColIndex !== null) break;
    }
    if (startColIndex === null || endColIndex === null) return null;
    const colIndexMin = Math.min(startColIndex, endColIndex);
    const colIndexMax = Math.max(startColIndex, endColIndex);
    return [
        colIndexMin,
        colIndexMax
    ];
}
function* $5b7ccabde48fae90$var$rangeAddrs(beans, rowStartIndex, rowEndIndex, startColumn, endColumn) {
    const allColumns = beans.colModel.getCols() ?? [];
    const colRange = $5b7ccabde48fae90$var$getColRangeIndices(beans, startColumn, endColumn);
    if (colRange == null) return;
    const [colIndexMin, colIndexMax] = colRange;
    for(let rowIndex = rowStartIndex; rowIndex <= rowEndIndex; rowIndex++){
        const rowNode = (0, $437b23f6a393c3bf$export$f5285e6f27a03f95)(beans)?.getFormulaRow(rowIndex);
        if (!rowNode) continue;
        for(let colIndex = colIndexMin; colIndex <= colIndexMax; colIndex++)yield {
            row: rowNode,
            column: allColumns[colIndex]
        };
    }
}
function* $5b7ccabde48fae90$var$unresolvedDeps(beans, root, ensureFormulaCache) {
    const astStack = [
        root
    ];
    while(astStack.length){
        const currentNode = astStack.pop();
        if (currentNode.type === "operand") {
            const operandValue = currentNode.value;
            if (typeof operandValue !== "object" || operandValue == null) continue;
            if (!operandValue.endColumn && !operandValue.endRow) {
                const cellAddress = $5b7ccabde48fae90$var$resolveRefToAddress(beans, operandValue);
                if (!cellAddress) throw new $5b7ccabde48fae90$var$FormulaError("Unrecognised reference to cell", "#REF!");
                const cachedCellFormula = ensureFormulaCache(cellAddress.row, cellAddress.column);
                if (!cachedCellFormula || cachedCellFormula.isValueReady()) continue;
                yield cellAddress;
                continue;
            }
            if (!operandValue.endColumn || !operandValue.endRow) throw new $5b7ccabde48fae90$var$FormulaError("Incomplete range reference", "#REF!");
            const firstRowIndex = $5b7ccabde48fae90$var$resolveRowIndex(beans, operandValue.row);
            const secondRowIndex = $5b7ccabde48fae90$var$resolveRowIndex(beans, operandValue.endRow);
            const rowStartIndex = Math.min(firstRowIndex, secondRowIndex);
            const rowEndIndex = Math.max(firstRowIndex, secondRowIndex);
            const startCol = $5b7ccabde48fae90$var$resolveCol(beans, operandValue.column);
            const endCol = $5b7ccabde48fae90$var$resolveCol(beans, operandValue.endColumn);
            for (const cellAddress of $5b7ccabde48fae90$var$rangeAddrs(beans, rowStartIndex, rowEndIndex, startCol, endCol)){
                const cachedCellFormula = ensureFormulaCache(cellAddress.row, cellAddress.column);
                if (!cachedCellFormula || cachedCellFormula.isValueReady()) continue;
                yield cellAddress;
            }
            continue;
        }
        for(let i = 0; i < currentNode.operands.length; i++)astStack.push(currentNode.operands[i]);
    }
}
// packages/ag-grid-enterprise/src/formula/functions/utils.ts
function $5b7ccabde48fae90$var$take(values, name, n) {
    const it = values[Symbol.iterator]();
    const out = new Array(n);
    for(let i = 0; i < n; i++){
        const step = it.next();
        if (step.done) throw new $5b7ccabde48fae90$var$FormulaError(`${name}: expected exactly ${n} arguments`);
        out[i] = step.value;
    }
    if (!it.next().done) throw new $5b7ccabde48fae90$var$FormulaError(`${name}: expected exactly ${n} arguments`);
    return out;
}
function $5b7ccabde48fae90$var$iterableWithoutBlanks(values) {
    return {
        *[Symbol.iterator] () {
            for (const v of values)if (v != null && v !== "") yield v;
        }
    };
}
function $5b7ccabde48fae90$var$takeBetween(values, name, min, max) {
    const out = [];
    for (const v of values){
        out.push(v);
        if (out.length > max) throw new $5b7ccabde48fae90$var$FormulaError(`${name}: expected at most ${max} arguments`);
    }
    if (out.length < min) throw new $5b7ccabde48fae90$var$FormulaError(`${name}: expected at least ${min} arguments`);
    return out;
}
var $5b7ccabde48fae90$var$isRangeParam = (p)=>{
    return p.kind === "range";
};
var $5b7ccabde48fae90$var$isValueParam = (p)=>{
    return p.kind === "value";
};
var $5b7ccabde48fae90$var$OPERATOR_TOKENS = [
    "<=",
    ">=",
    "<>",
    "<",
    ">",
    "="
];
function $5b7ccabde48fae90$var$findOperatorSymbol(s2) {
    for (const tok of $5b7ccabde48fae90$var$OPERATOR_TOKENS){
        if (s2.startsWith(tok)) return tok;
    }
    return null;
}
function $5b7ccabde48fae90$var$toNumberLike(x) {
    if (typeof x === "number" && Number.isFinite(x)) return x;
    if (x instanceof Date) return +x;
    if (typeof x === "string") {
        const num = Number(x);
        if (!Number.isNaN(num)) return num;
    }
    return null;
}
function $5b7ccabde48fae90$var$toText(x) {
    if (x == null) return "";
    switch(typeof x){
        case "string":
            return x;
        case "number":
            return String(x);
        case "boolean":
            return x ? "TRUE" : "FALSE";
    }
    if (x instanceof Date) return String(+x);
    return String(x);
}
function $5b7ccabde48fae90$var$wildcardToRegExp(pattern) {
    let out = "^";
    for(let i = 0; i < pattern.length; i++){
        const ch = pattern[i];
        if (ch === "~" && i + 1 < pattern.length && (pattern[i + 1] === "*" || pattern[i + 1] === "?")) {
            out += "\\" + pattern[++i];
            continue;
        }
        if (ch === "*") {
            out += ".*";
            continue;
        }
        if (ch === "?") {
            out += ".";
            continue;
        }
        if (/[-/\\^$*+?.()|[\]{}]/.test(ch)) out += "\\" + ch;
        else out += ch;
    }
    out += "$";
    return new RegExp(out, "i");
}
var $5b7ccabde48fae90$var$COMPARE_VALUES = (op, query, cell)=>{
    let queryVal = $5b7ccabde48fae90$var$toNumberLike(query);
    let cellVal = $5b7ccabde48fae90$var$toNumberLike(cell);
    if (queryVal == null || cellVal == null) {
        queryVal = query;
        cellVal = $5b7ccabde48fae90$var$toText(cell).toUpperCase();
    }
    switch(op){
        case "<":
            return cellVal < queryVal;
        case ">":
            return cellVal > queryVal;
        case "<=":
            return cellVal <= queryVal;
        case ">=":
            return cellVal >= queryVal;
        case "=":
            return cellVal === queryVal;
        case "<>":
            return cellVal !== queryVal;
    }
    return false;
};
var $5b7ccabde48fae90$var$REGEX_COMPARE_VALUES = (op, rx, cell)=>{
    const text = $5b7ccabde48fae90$var$toText(cell);
    const match = rx.test(text);
    return op === "=" ? match : !match;
};
var $5b7ccabde48fae90$var$EMPTY_PREDICATE = (cell)=>cell == null || cell === "";
function $5b7ccabde48fae90$var$criteriaToPredicate(criteria) {
    if (typeof criteria === "number") return (cell)=>$5b7ccabde48fae90$var$toNumberLike(cell) === criteria;
    if (typeof criteria !== "string") return (cell)=>criteria === cell;
    const trimmed = criteria.trim();
    if (trimmed === "") return $5b7ccabde48fae90$var$EMPTY_PREDICATE;
    const symbol = $5b7ccabde48fae90$var$findOperatorSymbol(trimmed);
    const query = symbol ? trimmed.substring(symbol.length) : trimmed;
    const wildcard = /[*?]/.test(query);
    if (!wildcard) return $5b7ccabde48fae90$var$COMPARE_VALUES.bind(null, symbol ?? "=", query.toUpperCase());
    if (symbol && symbol !== "=" && symbol !== "<>") throw new $5b7ccabde48fae90$var$FormulaError("Invalid criteria: wildcards with comparator", "#VALUE!");
    const regexp = $5b7ccabde48fae90$var$wildcardToRegExp(query);
    return $5b7ccabde48fae90$var$REGEX_COMPARE_VALUES.bind(null, symbol ?? "=", regexp);
}
var $5b7ccabde48fae90$var$shiftColRef = (beans, delta, ref)=>{
    if (!ref || delta === 0 || ref.absolute) return;
    const { visibleCols: visibleCols, colModel: colModel } = beans;
    const cols = visibleCols.allCols;
    const i0 = $5b7ccabde48fae90$var$colIndexFromId(colModel, cols, ref.id);
    if (i0 == null) return;
    const j0 = i0 + delta;
    if (j0 < 0) return;
    const nextId = $5b7ccabde48fae90$var$colIdFromIndex(cols, j0);
    if (nextId) ref.id = nextId;
};
var $5b7ccabde48fae90$var$shiftRowRef = (beans, rowDelta, ref, unsafe)=>{
    if (!ref || rowDelta === 0 || ref.absolute) return;
    if (unsafe) {
        const numericId = Number(ref.id);
        if (!Number.isFinite(numericId)) return;
        ref.id = String(numericId + rowDelta);
        return;
    }
    const idx1 = $5b7ccabde48fae90$var$rowIndexFromId(beans, ref.id);
    if (idx1 == null) return;
    const next1 = idx1 + rowDelta;
    if (next1 < 1) return;
    const nextId = $5b7ccabde48fae90$var$rowIdFromIndex(beans, next1);
    if (nextId) ref.id = nextId;
};
var $5b7ccabde48fae90$var$isCellOperand = (value)=>{
    return !!value && typeof value === "object" && value !== null && "row" in value && "column" in value;
};
var $5b7ccabde48fae90$var$shiftNode = (beans, node, rowDelta, columnDelta, unsafe)=>{
    if (node.type === "operand") {
        const { value: value } = node;
        if (!$5b7ccabde48fae90$var$isCellOperand(value)) return;
        const { row: row, column: column, endRow: endRow, endColumn: endColumn } = value;
        $5b7ccabde48fae90$var$shiftRowRef(beans, rowDelta, row, unsafe);
        $5b7ccabde48fae90$var$shiftColRef(beans, columnDelta, column);
        $5b7ccabde48fae90$var$shiftRowRef(beans, rowDelta, endRow, unsafe);
        $5b7ccabde48fae90$var$shiftColRef(beans, columnDelta, endColumn);
        return;
    }
    if (node.type === "operation") for (const child of node.operands)$5b7ccabde48fae90$var$shiftNode(beans, child, rowDelta, columnDelta, unsafe);
};
// packages/ag-grid-enterprise/src/formula/functions/counting/functions.ts
var $5b7ccabde48fae90$var$COUNT = ({ values: values })=>{
    let count = 0;
    for (const v of values)if (v != null && v !== "" && !isNaN(v)) count++;
    return count;
};
var $5b7ccabde48fae90$var$COUNTA = ({ values: values })=>{
    let count = 0;
    for (const v of values)if (v != null && v !== "") count++;
    return count;
};
var $5b7ccabde48fae90$var$COUNTBLANK = ({ values: values })=>{
    let count = 0;
    for (const v of values)if (v == null || v === "") count++;
    return count;
};
var $5b7ccabde48fae90$var$COUNTIF = ({ args: args })=>{
    const [range, criteria] = $5b7ccabde48fae90$var$take(args, "COUNTIF", 2);
    if (!$5b7ccabde48fae90$var$isRangeParam(range)) throw new $5b7ccabde48fae90$var$FormulaError("COUNTIF: first argument must be a range", "#VALUE!");
    if (!$5b7ccabde48fae90$var$isValueParam(criteria)) throw new $5b7ccabde48fae90$var$FormulaError("COUNTIF: second argument must be a value (criteria)", "#VALUE!");
    const pred = $5b7ccabde48fae90$var$criteriaToPredicate(criteria.value);
    let count = 0;
    for (const v of range)if (pred(v)) count++;
    return count;
};
// packages/ag-grid-enterprise/src/formula/functions/dates/functions.ts
var $5b7ccabde48fae90$var$NOW = ()=>/* @__PURE__ */ new Date();
var $5b7ccabde48fae90$var$TODAY = ()=>{
    const now = /* @__PURE__ */ new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};
// packages/ag-grid-enterprise/src/formula/functions/logic/functions.ts
var $5b7ccabde48fae90$var$EQUALS = ({ values: values })=>{
    const [a, b] = $5b7ccabde48fae90$var$take(values, "EQUALS", 2);
    return a === b;
};
var $5b7ccabde48fae90$var$NOT_EQUALS = ({ values: values })=>{
    const [a, b] = $5b7ccabde48fae90$var$take(values, "NOT_EQUALS", 2);
    return a !== b;
};
var $5b7ccabde48fae90$var$GT = ({ values: values })=>{
    const [a, b] = $5b7ccabde48fae90$var$take(values, "GT", 2);
    return a > b;
};
var $5b7ccabde48fae90$var$GTE = ({ values: values })=>{
    const [a, b] = $5b7ccabde48fae90$var$take(values, "GTE", 2);
    return a >= b;
};
var $5b7ccabde48fae90$var$LT = ({ values: values })=>{
    const [a, b] = $5b7ccabde48fae90$var$take(values, "LT", 2);
    return a < b;
};
var $5b7ccabde48fae90$var$LTE = ({ values: values })=>{
    const [a, b] = $5b7ccabde48fae90$var$take(values, "LTE", 2);
    return a <= b;
};
var $5b7ccabde48fae90$var$IF = ({ values: values })=>{
    const [cond, valTrue, valFalse] = $5b7ccabde48fae90$var$take(values, "IF", 3);
    return cond ? valTrue : valFalse;
};
var $5b7ccabde48fae90$var$MIN = ({ values: values })=>{
    let best = null;
    for (const v of values){
        if (v == null) continue;
        if (best === null || v < best) best = v;
    }
    if (best === null) throw new $5b7ccabde48fae90$var$FormulaError("MIN: requires at least one value");
    return best;
};
var $5b7ccabde48fae90$var$MAX = ({ values: values })=>{
    let best = null;
    for (const v of values){
        if (v == null) continue;
        if (best === null || v > best) best = v;
    }
    if (best === null) throw new $5b7ccabde48fae90$var$FormulaError("MAX: requires at least one value");
    return best;
};
// packages/ag-grid-enterprise/src/formula/functions/numbers/utils.ts
var $5b7ccabde48fae90$var$isFiniteNumber = (v)=>typeof v === "number" && Number.isFinite(v);
var $5b7ccabde48fae90$var$MS_PER_DAY = 86400000;
function $5b7ccabde48fae90$var$daysFromDate(d) {
    return d.getTime() / $5b7ccabde48fae90$var$MS_PER_DAY;
}
function $5b7ccabde48fae90$var$dateFromDays(n) {
    return new Date(n * $5b7ccabde48fae90$var$MS_PER_DAY);
}
function $5b7ccabde48fae90$var$isDateValue(v) {
    return v instanceof Date;
}
function $5b7ccabde48fae90$var$coerceFiniteNumber(fname, v) {
    if ($5b7ccabde48fae90$var$isFiniteNumber(v)) return v;
    if ($5b7ccabde48fae90$var$isDateValue(v)) return $5b7ccabde48fae90$var$daysFromDate(v);
    if (typeof v === "boolean") return v ? 1 : 0;
    if (typeof v === "string") {
        const n = Number(v.trim());
        if (Number.isFinite(n)) return n;
    }
    throw new $5b7ccabde48fae90$var$FormulaError(`${fname}: values must be numeric`, "#VALUE!");
}
// packages/ag-grid-enterprise/src/formula/functions/numbers/functions.ts
var $5b7ccabde48fae90$var$PRODUCT = ({ values: values })=>{
    let acc = 1;
    for (const v of $5b7ccabde48fae90$var$iterableWithoutBlanks(values)){
        const n = $5b7ccabde48fae90$var$coerceFiniteNumber("PRODUCT", v);
        if (n == null) continue;
        if (n === 0) return 0;
        acc *= n;
    }
    return acc;
};
var $5b7ccabde48fae90$var$DIVIDE = ({ values: values })=>{
    const [a, b] = $5b7ccabde48fae90$var$take($5b7ccabde48fae90$var$iterableWithoutBlanks(values), "DIVIDE", 2);
    const na = $5b7ccabde48fae90$var$coerceFiniteNumber("DIV", a);
    const nb = $5b7ccabde48fae90$var$coerceFiniteNumber("DIV", b);
    if (na == null || nb == null) throw new $5b7ccabde48fae90$var$FormulaError("DIV: non-numeric argument", "#VALUE!");
    if (nb === 0) throw new $5b7ccabde48fae90$var$FormulaError("DIV: division by zero", "#DIV/0!");
    return na / nb;
};
var $5b7ccabde48fae90$var$SUM = ({ values: values })=>{
    let hasDates = false;
    let acc = 0;
    let hasValue = false;
    for (const v of $5b7ccabde48fae90$var$iterableWithoutBlanks(values)){
        hasDates || (hasDates = $5b7ccabde48fae90$var$isDateValue(v));
        const n = $5b7ccabde48fae90$var$coerceFiniteNumber("SUM", v);
        if (n == null) continue;
        acc += n;
        hasValue = true;
    }
    if (!hasValue) throw new $5b7ccabde48fae90$var$FormulaError("SUM: requires at least one numeric value", "#PARSE!");
    return hasDates ? $5b7ccabde48fae90$var$dateFromDays(acc) : acc;
};
var $5b7ccabde48fae90$var$MINUS = ({ values: values })=>{
    const [a, b] = $5b7ccabde48fae90$var$take($5b7ccabde48fae90$var$iterableWithoutBlanks(values), "MINUS", 2);
    const na = $5b7ccabde48fae90$var$coerceFiniteNumber("MINUS", a);
    const nb = $5b7ccabde48fae90$var$coerceFiniteNumber("MINUS", b);
    if (na == null || nb == null) throw new $5b7ccabde48fae90$var$FormulaError("MINUS: non-numeric argument", "#VALUE!");
    const aDate = $5b7ccabde48fae90$var$isDateValue(a);
    const bDate = $5b7ccabde48fae90$var$isDateValue(b);
    if (aDate && !bDate) return $5b7ccabde48fae90$var$dateFromDays(na - nb);
    if (aDate && bDate) return na - nb;
    return na - nb;
};
var $5b7ccabde48fae90$var$PERCENT = ({ values: values })=>{
    const [a] = $5b7ccabde48fae90$var$take(values, "PERCENT", 1);
    const n = $5b7ccabde48fae90$var$coerceFiniteNumber("PERCENT", a);
    if (n == null) throw new $5b7ccabde48fae90$var$FormulaError("PERCENT: non-numeric argument", "#VALUE!");
    return n / 100;
};
var $5b7ccabde48fae90$var$POWER = ({ values: values })=>{
    const [a, b] = $5b7ccabde48fae90$var$take(values, "POWER", 2);
    const na = $5b7ccabde48fae90$var$coerceFiniteNumber("POWER", a);
    const nb = $5b7ccabde48fae90$var$coerceFiniteNumber("POWER", b);
    if (na == null || nb == null) throw new $5b7ccabde48fae90$var$FormulaError("POWER: non-numeric argument", "#VALUE!");
    return Math.pow(na, nb);
};
var $5b7ccabde48fae90$var$AVERAGE = ({ values: values })=>{
    let sum = 0;
    let count = 0;
    let allDate = true;
    for (const v of $5b7ccabde48fae90$var$iterableWithoutBlanks(values)){
        const n = $5b7ccabde48fae90$var$coerceFiniteNumber("AVG", v);
        if (n == null) continue;
        sum += n;
        count++;
        allDate && (allDate = $5b7ccabde48fae90$var$isDateValue(v));
    }
    if (count === 0) throw new $5b7ccabde48fae90$var$FormulaError("AVG: requires at least one value");
    const avg = sum / count;
    return allDate ? $5b7ccabde48fae90$var$dateFromDays(avg) : avg;
};
var $5b7ccabde48fae90$var$MEDIAN = ({ values: values })=>{
    let allDates = true;
    const arr = [];
    for (const v of $5b7ccabde48fae90$var$iterableWithoutBlanks(values)){
        const n = $5b7ccabde48fae90$var$coerceFiniteNumber("MEDIAN", v);
        if (n == null) throw new $5b7ccabde48fae90$var$FormulaError("MEDIAN: all values must be numbers", "#VALUE!");
        arr.push(n);
        allDates && (allDates = $5b7ccabde48fae90$var$isDateValue(v));
    }
    if (arr.length === 0) throw new $5b7ccabde48fae90$var$FormulaError("MEDIAN: requires at least one value");
    arr.sort((a, b)=>a - b);
    const mid = Math.floor(arr.length / 2);
    const med = arr.length % 2 === 1 ? arr[mid] : (arr[mid - 1] + arr[mid]) / 2;
    return allDates ? $5b7ccabde48fae90$var$dateFromDays(med) : med;
};
var $5b7ccabde48fae90$var$RAND = ()=>Math.random();
var $5b7ccabde48fae90$var$SUMIF = ({ args: args })=>{
    const [critRange, criteria, sumRange] = $5b7ccabde48fae90$var$takeBetween(args, "SUMIF", 2, 3);
    if (!$5b7ccabde48fae90$var$isRangeParam(critRange)) throw new $5b7ccabde48fae90$var$FormulaError("SUMIF: first argument must be a range", "#VALUE!");
    if (!$5b7ccabde48fae90$var$isValueParam(criteria)) throw new $5b7ccabde48fae90$var$FormulaError("SUMIF: second argument must be a value (criteria)", "#VALUE!");
    if (sumRange && !$5b7ccabde48fae90$var$isRangeParam(sumRange)) throw new $5b7ccabde48fae90$var$FormulaError("SUMIF: third argument must be a range (sum_range)", "#VALUE!");
    const pred = $5b7ccabde48fae90$var$criteriaToPredicate(criteria.value);
    if (!sumRange) {
        let acc = 0;
        for (const v of critRange)if (pred(v)) {
            const n = $5b7ccabde48fae90$var$coerceFiniteNumber("SUMIF", v);
            if (n != null) acc += n;
        }
        return acc;
    }
    const critRangeHeight = critRange.rowEnd - critRange.rowStart;
    const sumRangeHeight = sumRange.rowEnd - sumRange.rowStart;
    if (critRangeHeight !== sumRangeHeight) throw new $5b7ccabde48fae90$var$FormulaError("SUMIF: ranges have different sizes", "#VALUE!");
    const critRangeIterator = critRange[Symbol.iterator]();
    const sumRangeIterator = sumRange[Symbol.iterator]();
    let total = 0;
    while(true){
        const a = critRangeIterator.next();
        const b = sumRangeIterator.next();
        if (a.done || b.done) {
            if (a.done !== b.done) throw new $5b7ccabde48fae90$var$FormulaError("SUMIF: ranges have different sizes", "#VALUE!");
            break;
        }
        if (pred(a.value)) {
            const n = $5b7ccabde48fae90$var$coerceFiniteNumber("SUMIF", b.value);
            if (n != null) total += n;
        }
    }
    return total;
};
// packages/ag-grid-enterprise/src/formula/functions/strings/functions.ts
var $5b7ccabde48fae90$var$CONCAT = ({ values: values })=>{
    let out = "";
    for (const v of values){
        if (v == null) continue;
        switch(typeof v){
            case "string":
                out += v;
                break;
            case "number":
                out += String(v);
                break;
            case "boolean":
                out += v ? "TRUE" : "FALSE";
                break;
            case "object":
                out += v.toString();
                break;
            default:
                throw new $5b7ccabde48fae90$var$FormulaError("CONCAT: unsupported value type", "#VALUE!");
        }
    }
    return out;
};
// packages/ag-grid-enterprise/src/formula/functions/supportedFuncs.ts
var $5b7ccabde48fae90$var$supportedFuncs_default = {
    IF: // logic/date
    $5b7ccabde48fae90$var$IF,
    NOW: $5b7ccabde48fae90$var$NOW,
    TODAY: $5b7ccabde48fae90$var$TODAY,
    PRODUCT: // arithmetic
    $5b7ccabde48fae90$var$PRODUCT,
    SUM: // DIVIDE,
    // DIV: DIVIDE,
    $5b7ccabde48fae90$var$SUM,
    ADD: $5b7ccabde48fae90$var$SUM,
    SUMIF: $5b7ccabde48fae90$var$SUMIF,
    POWER: // MINUS,
    // PERCENT,
    $5b7ccabde48fae90$var$POWER,
    MIN: $5b7ccabde48fae90$var$MIN,
    MAX: $5b7ccabde48fae90$var$MAX,
    AVERAGE: $5b7ccabde48fae90$var$AVERAGE,
    MEDIAN: $5b7ccabde48fae90$var$MEDIAN,
    COUNT: // counting
    $5b7ccabde48fae90$var$COUNT,
    COUNTA: $5b7ccabde48fae90$var$COUNTA,
    COUNTBLANK: $5b7ccabde48fae90$var$COUNTBLANK,
    COUNTIF: $5b7ccabde48fae90$var$COUNTIF,
    RAND: // random
    $5b7ccabde48fae90$var$RAND,
    CONCAT: // text
    $5b7ccabde48fae90$var$CONCAT,
    CONCATENATE: $5b7ccabde48fae90$var$CONCAT,
    // comparisons
    // EQ: EQUALS,
    // NE: NOT_EQUALS,
    // GT,
    // GTE,
    // LT,
    // LTE,
    // operator aliases
    "+": $5b7ccabde48fae90$var$SUM,
    "-": $5b7ccabde48fae90$var$MINUS,
    "*": $5b7ccabde48fae90$var$PRODUCT,
    "/": $5b7ccabde48fae90$var$DIVIDE,
    "^": $5b7ccabde48fae90$var$POWER,
    "%": $5b7ccabde48fae90$var$PERCENT,
    "=": $5b7ccabde48fae90$var$EQUALS,
    "&": $5b7ccabde48fae90$var$CONCAT,
    "<>": $5b7ccabde48fae90$var$NOT_EQUALS,
    ">": $5b7ccabde48fae90$var$GT,
    ">=": $5b7ccabde48fae90$var$GTE,
    "<": $5b7ccabde48fae90$var$LT,
    "<=": $5b7ccabde48fae90$var$LTE
};
// packages/ag-grid-enterprise/src/formula/formulaService.ts
var $5b7ccabde48fae90$var$CellFormula = class {
    constructor(rowNode, column, formulaString, beans){
        this.rowNode = rowNode;
        this.column = column;
        this.formulaString = formulaString;
        this.beans = beans;
        this.error = null;
        this.ast = null;
        this.astStale = true;
        this._value = void 0;
        this._valueStale = true;
    }
    setFormulaString(next) {
        if (this.formulaString === next) return;
        this.formulaString = next;
        this.astStale = true;
        this._valueStale = true;
    }
    /** Cache write: store a fresh computed value (and clear previous error). */ setComputedValue(v) {
        this._value = v;
        this._valueStale = false;
        this.error = null;
    }
    /** Cache write: store an error (value considered stale). */ setError(e) {
        this.error = e;
        this._valueStale = false;
    }
    isValueReady() {
        return !this._valueStale;
    }
    /**
   * Return the error type or the value
   */ getValue() {
        return this.error?.type ?? this._value;
    }
    getError() {
        return this.error;
    }
    /** Returns the AST for the formula and recomputes if stale */ getAst() {
        if (!this.astStale) return this.ast;
        const ast = $5b7ccabde48fae90$var$parseFormula(this.beans, this.formulaString);
        this.ast = ast ?? null;
        this.astStale = false;
        return this.ast;
    }
};
var $5b7ccabde48fae90$var$FormulaService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "formula";
        /** Cache: row -> (column -> CellFormula) */ this.cachedResult = /* @__PURE__ */ new WeakMap();
        /** Map "A", "B", ..., "AA" -> actual AgColumn */ this.colRefMap = /* @__PURE__ */ new Map();
        this.active = false;
    }
    setFormulasActive(cols) {
        const formulaColumnsPresent = cols.list.some((col)=>col.isAllowFormula());
        const active = formulaColumnsPresent && this.checkForIncompatibleServices(cols);
        if (active !== this.active) {
            this.active = active;
            this.refreshFormulas(true);
        }
    }
    checkForIncompatibleServices(cols) {
        if (this.gos.get("masterDetail")) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(295, {
                blockedService: "Master Detail"
            });
            return false;
        }
        if (this.gos.get("treeData")) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(295, {
                blockedService: "Tree Data"
            });
            return false;
        }
        if (this.gos.get("enableCellExpressions")) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(295, {
                blockedService: "Cell Expressions"
            });
            return false;
        }
        return cols.list.every((col)=>{
            if (col.isAllowPivot() || col.isPivotActive()) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(295, {
                    blockedService: "Column Pivoting"
                });
                return false;
            }
            if (col.isAllowRowGroup() || col.isRowGroupActive()) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(295, {
                    blockedService: "Row Groups"
                });
                return false;
            }
            if (col.isAllowValue() || col.isValueActive() || col.getAggFunc()) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(295, {
                    blockedService: "Value Aggregation"
                });
                return false;
            }
            return true;
        });
    }
    postConstruct() {
        this.setupFunctions();
        const refreshFormulas = ()=>{
            if (this.active) this.refreshFormulas(true);
        };
        const resetColMap = ()=>{
            if (this.active) this.setupColRefMap();
        };
        this.addManagedPropertyListeners([
            "masterDetail",
            "enableCellExpressions"
        ], (e)=>{
            const { colModel: colModel } = this.beans;
            const formulaColumnsPresent = colModel.cols?.list.some((col)=>col.isAllowFormula());
            if (formulaColumnsPresent) this.beans.colModel.refreshAll((0, $437b23f6a393c3bf$export$eb2a92b6162267d1)(e.source));
        });
        this.addManagedListeners(this.beans.eventSvc, {
            modelUpdated: refreshFormulas,
            cellValueChanged: refreshFormulas,
            rowDataUpdated: refreshFormulas,
            newColumnsLoaded: resetColMap,
            columnMoved: resetColMap
        });
    }
    updateFormulaByOffset(params) {
        const { value: value, rowDelta: rowDelta = 0, columnDelta: columnDelta = 0, useRefFormat: useRefFormat = true } = params;
        try {
            const unsafe = !useRefFormat;
            const ast = $5b7ccabde48fae90$var$parseFormula(this.beans, value, unsafe);
            $5b7ccabde48fae90$var$shiftNode(this.beans, ast, rowDelta, columnDelta, unsafe);
            return $5b7ccabde48fae90$var$serializeFormula(this.beans, ast, /*useRefFormat*/ useRefFormat, unsafe);
        } catch  {
            return value;
        }
    }
    setupFunctions() {
        this.supportedOperations = new Map(Object.entries($5b7ccabde48fae90$var$supportedFuncs_default));
        const customFuncs = this.gos.get("formulaFuncs");
        if (customFuncs) Object.keys(customFuncs).forEach((name)=>{
            this.supportedOperations.set(name.toUpperCase(), customFuncs[name].func);
        });
    }
    setupColRefMap() {
        if (!this.active) {
            this.colRefMap = /* @__PURE__ */ new Map();
            return;
        }
        const alphabet = "abcdefghijklmnopqrstuvwxyz";
        const base = alphabet.length;
        const list = this.beans.colModel.getCols();
        const map = /* @__PURE__ */ new Map();
        let idx = 0;
        list?.forEach((col)=>{
            if (!col.isPrimary()) return;
            let label = "";
            let n = idx++;
            while(true){
                label = alphabet[n % base] + label;
                if (n < base) break;
                n = Math.floor(n / base) - 1;
            }
            if (col.formulaRef !== label.toUpperCase()) {
                col.formulaRef = label.toUpperCase();
                col.dispatchColEvent("formulaRefChanged", "api");
            }
            map.set(label.toUpperCase(), col);
        });
        this.colRefMap = map;
        this.refreshFormulas(true);
    }
    /** Lookup a column by A1-style reference label, e.g. "A", "AB". */ getColByRef(ref) {
        return this.colRefMap.get(ref.toUpperCase()) ?? null;
    }
    /** Find the A1-style label for a given column (reverse lookup). */ getColRef(col) {
        for (const [label, value] of this.colRefMap.entries()){
            if (value === col) return label;
        }
        return null;
    }
    /** Clear all cached results and re-render cells. */ refreshFormulas(refreshCells) {
        this.cachedResult = /* @__PURE__ */ new WeakMap();
        if (refreshCells) this.beans.rowRenderer.refreshCells({
            suppressFlash: true,
            force: true
        });
    }
    /**
   * Is a value a formula string (starts with '=')
   **/ isFormula(value) {
        return this.active && (0, $437b23f6a393c3bf$export$8e19bf64bae2d78a)(value);
    }
    /**
   * Normalise a formula by parsing and serializing it (REF(COLUMN(), ROW()) format).
   * @returns null if the formula is invalid.
   */ normaliseFormula(value, shorthand = false) {
        try {
            const parsedAST = $5b7ccabde48fae90$var$parseFormula(this.beans, value);
            const serialized = $5b7ccabde48fae90$var$serializeFormula(this.beans, parsedAST, !shorthand, false);
            return serialized;
        } catch  {
            return null;
        }
    }
    /** If the cell has been evaluated and errored, return its last error (else null). */ getFormulaError(column, node) {
        const rowMap = this.cachedResult.get(node);
        const cell = rowMap?.get(column);
        return cell?.error ?? null;
    }
    /** Get a registered function by name (used by the evaluator). */ getFunction(name) {
        return this.supportedOperations.get(name.toUpperCase());
    }
    /** Ensure a CellFormula exists for (row,col) if it's a formula cell; returns null for non-formula. */ ensureCellFormula(row, col) {
        let rowMap = this.cachedResult.get(row);
        let cf = rowMap?.get(col);
        if (cf) return cf;
        const str = this.getFormulaFromDataSource(row, col) ?? this.fetchRawValue(col, row);
        if (typeof str !== "string" || str[0] !== "=") return null;
        cf = new $5b7ccabde48fae90$var$CellFormula(row, col, str, this.beans);
        if (!rowMap) {
            rowMap = /* @__PURE__ */ new Map();
            this.cachedResult.set(row, rowMap);
        }
        rowMap.set(col, cf);
        return cf;
    }
    getFormulaFromDataSource(row, col) {
        const dataSource = this.beans.formulaDataSvc;
        if (!dataSource?.hasDataSource()) return void 0;
        return dataSource.getFormula({
            column: col,
            rowNode: row
        });
    }
    /** Fetch a non-formula value from the grid without triggering nested formula calc. */ fetchRawValue(col, row) {
        return this.beans.valueSvc.getValue(col, row, false, "ui");
    }
    getVisitorContext() {
        if (this.activeCtx) return this.activeCtx;
        const stateByCell = /* @__PURE__ */ new Map();
        const setVisiting = (r, c)=>{
            let colSet = stateByCell.get(r);
            const isVisiting = colSet?.has(c);
            if (isVisiting) throw new $5b7ccabde48fae90$var$FormulaError("Circular reference", "#CIRCREF!");
            if (!colSet) {
                colSet = /* @__PURE__ */ new Set();
                stateByCell.set(r, colSet);
            }
            colSet.add(c);
        };
        const setVisited = (r, c)=>{
            const colSet = stateByCell.get(r);
            if (colSet) {
                colSet.delete(c);
                if (colSet.size === 0) stateByCell.delete(r);
            }
        };
        const errorAllVisitors = (error)=>{
            for (const [row, cells] of stateByCell)for (const col of cells){
                const cache = this.ensureCellFormula(row, col);
                cache?.setError(error);
            }
        };
        return this.activeCtx = {
            setVisited: setVisited,
            setVisiting: setVisiting,
            errorAllVisitors: errorAllVisitors
        };
    }
    makeFormulaFrame(address) {
        const cachedItem = this.ensureCellFormula(address.row, address.column);
        const ast = cachedItem.getAst();
        if (!ast) throw new $5b7ccabde48fae90$var$FormulaError("Expected parsable formula", "#PARSE!");
        const unresolvedDepIterator = $5b7ccabde48fae90$var$unresolvedDeps(this.beans, ast, this.ensureCellFormula.bind(this));
        return {
            address: address,
            ast: ast,
            unresolvedDepIterator: unresolvedDepIterator
        };
    }
    /**
   * Evaluate a single cell's formula **iteratively** (no recursion to avoid large stack traces),
   * caching dependency results into their own CellFormula entries.
   *
   * Returns the computed value, or a '#...' string on error.
   */ resolveValue(column, node) {
        const rootCachedCellFormula = this.ensureCellFormula(node, column);
        if (!rootCachedCellFormula) return this.fetchRawValue(column, node);
        if (rootCachedCellFormula.isValueReady()) return rootCachedCellFormula.getValue();
        const hadCtx = !!this.activeCtx;
        const { setVisited: setVisited, setVisiting: setVisiting, errorAllVisitors: errorAllVisitors } = this.getVisitorContext();
        const evalStack = [];
        try {
            setVisiting(node, column);
            evalStack.push(this.makeFormulaFrame({
                row: node,
                column: column
            }));
            while(evalStack.length){
                const { address: address, ast: ast, unresolvedDepIterator: unresolvedDepIterator } = evalStack[evalStack.length - 1];
                const { row: row, column: col } = address;
                const cachedCellFormula = this.ensureCellFormula(row, col);
                if (cachedCellFormula.isValueReady()) {
                    evalStack.pop();
                    setVisited(row, col);
                    if (cachedCellFormula.error) throw cachedCellFormula.error;
                    continue;
                }
                const depStep = unresolvedDepIterator.next();
                if (!depStep.done) {
                    const depAddr = depStep.value;
                    const depCachedCellFormula = this.ensureCellFormula(depAddr.row, depAddr.column);
                    if (!depCachedCellFormula || depCachedCellFormula.isValueReady()) continue;
                    setVisiting(depAddr.row, depAddr.column);
                    evalStack.push(this.makeFormulaFrame(depAddr));
                    continue;
                }
                const computed = $5b7ccabde48fae90$var$evalAst(this.beans, ast, (addr)=>{
                    const cachedRefFormula = this.ensureCellFormula(addr.row, addr.column);
                    if (cachedRefFormula) {
                        if (!cachedRefFormula.isValueReady()) throw new $5b7ccabde48fae90$var$FormulaError("Internal scheduling error");
                        const error = cachedRefFormula.getError();
                        if (error) throw error;
                        return cachedRefFormula.getValue();
                    }
                    return this.fetchRawValue(addr.column, addr.row);
                }, {
                    row: row,
                    column: col
                });
                const existing = cachedCellFormula.getError();
                if (existing) {
                    setVisited(row, col);
                    throw existing;
                }
                cachedCellFormula.setComputedValue(computed);
                setVisited(row, col);
                evalStack.pop();
            }
            if (!rootCachedCellFormula.isValueReady()) throw new $5b7ccabde48fae90$var$FormulaError("Internal scheduling error");
            return rootCachedCellFormula.getValue();
        } catch (e) {
            const normalized = e instanceof $5b7ccabde48fae90$var$FormulaError ? e : new $5b7ccabde48fae90$var$FormulaError(String(e?.message ?? e));
            errorAllVisitors(normalized);
            return normalized.type;
        } finally{
            if (!hadCtx) this.activeCtx = null;
        }
    }
};
// packages/ag-grid-enterprise/src/formula/formulaModule.ts
var $5b7ccabde48fae90$export$73682ece87e2337a = {
    moduleName: "Formula",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [
        $5b7ccabde48fae90$var$FormulaService,
        $5b7ccabde48fae90$var$FormulaDataService
    ],
    dependsOn: [
        $5b7ccabde48fae90$export$f0e5f58d7c17c748
    ],
    css: [
        $5b7ccabde48fae90$var$formulaStylesCSS
    ]
};
// packages/ag-grid-enterprise/src/sparkline/sparkline.css-GENERATED.ts
var $5b7ccabde48fae90$var$sparklineCSS = /*css*/ `.ag-sparkline-wrapper{height:100%;line-height:normal;position:absolute;top:0;width:100%}`;
// packages/ag-grid-enterprise/src/sparkline/sparklinesUtils.ts
var $5b7ccabde48fae90$var$WrappedFunctionMarker = Symbol("WrappedFunctionMarker");
var $5b7ccabde48fae90$var$wrapFn = (fn, wrapperFn)=>{
    if (fn[$5b7ccabde48fae90$var$WrappedFunctionMarker]) return fn;
    const wrapped = (...args)=>wrapperFn(fn, ...args);
    wrapped[$5b7ccabde48fae90$var$WrappedFunctionMarker] = $5b7ccabde48fae90$var$WrappedFunctionMarker;
    return wrapped;
};
// packages/ag-grid-enterprise/src/sparkline/sparklineCellRenderer.ts
function $5b7ccabde48fae90$var$tooltipRendererWithXValue(params) {
    return {
        content: `${params.xValue} ${params.yValue}`
    };
}
function $5b7ccabde48fae90$var$tooltipRenderer(params) {
    return {
        content: `${params.yValue}`
    };
}
var $5b7ccabde48fae90$var$SparklineCellRenderer = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tag: "div",
            cls: "ag-sparkline-wrapper",
            children: [
                {
                    tag: "span",
                    ref: "eSparkline"
                }
            ]
        });
        this.eSparkline = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.cachedWidth = 0;
        this.cachedHeight = 0;
        this.dataRef = [];
        this.processedData = [];
    }
    postConstruct() {
        this.env = this.beans.environment;
        this.addManagedPropertyListeners([
            "chartThemeOverrides",
            "chartThemes",
            "styleNonce"
        ], ()=>this.refresh(this.params));
    }
    createListener(batch = true) {
        return ()=>this.updateSize(this.params?.column?.getActualWidth() ?? 0, (this.params?.node.rowHeight ?? 0) - 2, batch);
    }
    initGridObserver() {
        const batchListener = this.createListener();
        const listener = this.createListener(false);
        const column = this.params?.column;
        const rowNode = this.params?.node;
        column.__addEventListener("columnStateUpdated", batchListener);
        rowNode.__addEventListener("heightChanged", batchListener);
        this.addDestroyFunc(()=>{
            column.__removeEventListener("columnStateUpdated", batchListener);
            rowNode.__removeEventListener("heightChanged", batchListener);
        });
        listener();
    }
    updateSize(newWidth, newHeight, batch = true) {
        newWidth -= this.env.getCellPadding();
        if (newWidth !== this.cachedWidth || newHeight !== this.cachedHeight) {
            this.cachedWidth = newWidth;
            this.cachedHeight = newHeight;
            const refresh = this.refresh.bind(this);
            if (batch) (0, $437b23f6a393c3bf$export$8ea55376d0d59592)(()=>this.isAlive() && refresh());
            else refresh();
        }
    }
    init(params) {
        this.params = params;
        this.initGridObserver();
    }
    refresh(params = this.params) {
        var _a;
        this.params = params;
        const width = this.cachedWidth;
        const height = this.cachedHeight;
        const styleNonce = this.gos.get("styleNonce");
        if (!this.sparklineInstance && params && width > 0 && height > 0) {
            this.sparklineOptions = {
                container: this.eSparkline,
                width: width,
                height: height,
                ...params.sparklineOptions,
                ...styleNonce ? {
                    styleNonce: styleNonce
                } : {},
                data: this.processData(params.value)
            };
            (_a = this.sparklineOptions).type ?? (_a.type = "line");
            if (this.sparklineOptions.tooltip?.renderer) this.wrapTooltipRenderer();
            else {
                const renderer = this.getDefaultTooltipRenderer();
                this.sparklineOptions.tooltip = {
                    ...this.sparklineOptions.tooltip,
                    renderer: renderer
                };
            }
            const theme = this.sparklineOptions?.theme;
            if (this.sparklineOptions.type === "bar" && this.sparklineOptions.itemStyler) this.wrapItemStyler(this.sparklineOptions);
            else if (theme?.overrides?.bar?.series?.itemStyler) this.wrapItemStyler(theme.overrides.bar.series);
            this.sparklineInstance = params.createSparkline(this.sparklineOptions);
            return true;
        } else if (this.sparklineInstance) {
            this.sparklineInstance.update({
                ...this.sparklineOptions,
                data: this.processData(params?.value),
                width: width,
                height: height,
                ...styleNonce ? {
                    styleNonce: styleNonce
                } : {}
            });
            return true;
        }
        return false;
    }
    processData(data) {
        if (!data?.length) return data ?? [];
        if (this.dataRef !== data) {
            this.dataRef = data;
            this.processedData = Array.isArray(data[0]) ? data.filter((item)=>item != null) : data;
        }
        return this.processedData;
    }
    createContext() {
        return {
            data: this.params?.data,
            cellData: this.params?.value
        };
    }
    getDefaultTooltipRenderer(userRendererResult) {
        const userTitle = userRendererResult?.title;
        const xKeyProvided = this.sparklineOptions.xKey;
        const tupleData = Array.isArray(this.sparklineOptions.data?.[0]);
        const showXValue = !userTitle && (xKeyProvided || tupleData);
        return showXValue ? $5b7ccabde48fae90$var$tooltipRendererWithXValue : $5b7ccabde48fae90$var$tooltipRenderer;
    }
    wrapItemStyler(container) {
        container.itemStyler = $5b7ccabde48fae90$var$wrapFn(container.itemStyler, (fn, stylerParams)=>{
            return fn({
                ...stylerParams,
                context: this.createContext()
            });
        });
    }
    wrapTooltipRenderer() {
        this.sparklineOptions.tooltip = {
            ...this.sparklineOptions.tooltip,
            renderer: $5b7ccabde48fae90$var$wrapFn(this.sparklineOptions.tooltip.renderer, (fn, tooltipParams)=>{
                const userRendererResult = fn({
                    ...tooltipParams,
                    context: this.createContext()
                });
                if (typeof userRendererResult === "string") return userRendererResult;
                return {
                    ...this.getDefaultTooltipRenderer(userRendererResult)(tooltipParams),
                    ...userRendererResult
                };
            })
        };
    }
    destroy() {
        super.destroy();
        this.sparklineInstance?.destroy();
    }
};
// packages/ag-grid-enterprise/src/sparkline/sparklinesModule.ts
var $5b7ccabde48fae90$var$moduleName = "Sparklines";
var $5b7ccabde48fae90$export$4e5a2f3bfb2b8795 = {
    moduleName: $5b7ccabde48fae90$var$moduleName,
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: [
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ],
    validate: ()=>{
        return {
            isValid: false,
            message: (0, $437b23f6a393c3bf$export$d73cab7876c2c868)(258)
        };
    },
    with: (params)=>{
        params.setup();
        return {
            moduleName: $5b7ccabde48fae90$var$moduleName,
            version: $5b7ccabde48fae90$var$VERSION,
            dependsOn: [
                $5b7ccabde48fae90$var$EnterpriseCoreModule
            ],
            css: [
                $5b7ccabde48fae90$var$sparklineCSS
            ],
            userComponents: {
                agSparklineCellRenderer: {
                    classImp: $5b7ccabde48fae90$var$SparklineCellRenderer,
                    /** Default params for provided components */ params: {
                        createSparkline: params.createSparkline
                    }
                }
            },
            validate: ()=>{
                return {
                    isValid: true
                };
            }
        };
    }
};
// packages/ag-grid-enterprise/src/find/find.css-GENERATED.ts
var $5b7ccabde48fae90$var$findCSS = /*css*/ `.ag-find-cell{display:block;overflow:hidden;text-overflow:ellipsis}.ag-find-match{background-color:var(--ag-find-match-background-color);color:var(--ag-find-match-color)}.ag-find-active-match{background-color:var(--ag-find-active-match-background-color);color:var(--ag-find-active-match-color)}`;
// packages/ag-grid-enterprise/src/find/findApi.ts
function $5b7ccabde48fae90$var$findNext(beans) {
    beans.findSvc?.next();
}
function $5b7ccabde48fae90$var$findPrevious(beans) {
    beans.findSvc?.previous();
}
function $5b7ccabde48fae90$var$findGetTotalMatches(beans) {
    return beans.findSvc?.totalMatches ?? 0;
}
function $5b7ccabde48fae90$var$findGoTo(beans, match, force) {
    beans.findSvc?.goTo(match, force);
}
function $5b7ccabde48fae90$var$findClearActive(beans) {
    beans.findSvc?.clearActive();
}
function $5b7ccabde48fae90$var$findGetActiveMatch(beans) {
    return beans.findSvc?.activeMatch;
}
function $5b7ccabde48fae90$var$findGetNumMatches(beans, params) {
    const { node: node, column: column } = params;
    return beans.findSvc?.getNumMatches(node, column) ?? 0;
}
function $5b7ccabde48fae90$var$findGetParts(beans, params) {
    return beans.findSvc?.getParts(params) ?? [];
}
function $5b7ccabde48fae90$var$findRefresh(beans) {
    return beans.findSvc?.refresh(true);
}
var $5b7ccabde48fae90$var$FindCellRendererElement = {
    tag: "span",
    cls: "ag-find-cell"
};
var $5b7ccabde48fae90$var$FindCellRenderer = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super($5b7ccabde48fae90$var$FindCellRendererElement);
    }
    init(params) {
        this.refresh(params);
    }
    refresh(params) {
        const { node: node, column: column } = params;
        const { findSvc: findSvc, valueSvc: valueSvc } = this.beans;
        const { value: value, valueFormatted: valueFormatted } = valueSvc.getValueForDisplay({
            column: column,
            node: node,
            includeValueFormatted: true
        });
        const displayValue = valueFormatted ?? value ?? "";
        const eGui = this.getGui();
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(eGui);
        const parts = findSvc?.getParts({
            value: displayValue,
            node: node,
            column: column ?? null
        });
        if (!parts) {
            eGui.textContent = (0, $437b23f6a393c3bf$export$a16cfb6652fe466f)(displayValue) ?? "";
            eGui.classList.remove("ag-find-cell-active-match");
        } else {
            let hasActiveMatch = false;
            for (const { value: value2, match: match, activeMatch: activeMatch } of parts){
                const content = (0, $437b23f6a393c3bf$export$a16cfb6652fe466f)(value2) ?? "";
                if (match) {
                    const element = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
                        tag: "mark",
                        cls: "ag-find-match"
                    });
                    element.textContent = content;
                    if (activeMatch) {
                        element.classList.add("ag-find-active-match");
                        hasActiveMatch = true;
                    }
                    eGui.appendChild(element);
                } else eGui.appendChild(document.createTextNode(content));
            }
            eGui.classList.toggle("ag-find-cell-active-match", hasActiveMatch);
        }
        return true;
    }
};
function $5b7ccabde48fae90$var$defaultCaseFormat(value) {
    return value?.toLocaleLowerCase();
}
function $5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, caseFormat, valueToFind) {
    const finalValue = caseFormat((0, $437b23f6a393c3bf$export$a16cfb6652fe466f)(valueToFind));
    let numMatches = 0;
    if (finalValue?.length) {
        let index = -1;
        while(true){
            index = finalValue.indexOf(findSearchValue, index + 1);
            if (index != -1) numMatches++;
            else break;
        }
    }
    return numMatches;
}
var $5b7ccabde48fae90$var$FindService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "findSvc";
        /**
     * Is find currently active (e.g. non-empty search value).
     * Used for performance when checking matches (part of cell rendering)
     */ this.active = false;
        /** pinned top matches */ this.topMatches = /* @__PURE__ */ new Map();
        /** same nodes as keys in `topMatches`, but kept separate for performance when moving backwards and forwards through the matches */ this.topNodes = [];
        /** total number of matches in pinned top */ this.topNumMatches = 0;
        this.centerMatches = /* @__PURE__ */ new Map();
        this.centerNodes = [];
        this.centerNumMatches = 0;
        this.bottomMatches = /* @__PURE__ */ new Map();
        this.bottomNodes = [];
        /** switches based on grid options */ this.caseFormat = $5b7ccabde48fae90$var$defaultCaseFormat;
        /** whether to scroll to active match after a refresh */ this.scrollOnRefresh = false;
        this.totalMatches = 0;
    }
    postConstruct() {
        if (!(0, $437b23f6a393c3bf$export$9f182d9ca737e15)(this.gos)) return;
        const refreshAndWipeActive = this.refresh.bind(this, false);
        const refreshAndKeepActive = this.refresh.bind(this, true);
        const refreshAndKeepActiveDebounced = (0, $437b23f6a393c3bf$export$cf7e39bfb94de6e)(this, ()=>{
            if (this.isAlive()) refreshAndKeepActive();
        }, 0);
        this.refreshDebounced = refreshAndKeepActiveDebounced;
        this.addManagedPropertyListener("findSearchValue", refreshAndWipeActive);
        this.addManagedPropertyListener("findOptions", ({ currentValue: currentValue, previousValue: previousValue })=>{
            if (!(0, $437b23f6a393c3bf$export$dbc2068cc90f5875)(currentValue, previousValue)) refreshAndWipeActive();
        });
        this.addManagedPropertyListeners([
            "groupSuppressBlankHeader",
            "showOpenedGroup"
        ], refreshAndKeepActive);
        this.addManagedEventListeners({
            modelUpdated: refreshAndKeepActive,
            displayedColumnsChanged: refreshAndKeepActive,
            pinnedRowDataChanged: refreshAndKeepActive,
            cellValueChanged: refreshAndKeepActiveDebounced,
            rowNodeDataChanged: refreshAndKeepActiveDebounced
        });
        const rowSpanSvc = this.beans.rowSpanSvc;
        if (rowSpanSvc) this.addManagedListeners(rowSpanSvc, {
            spannedCellsUpdated: refreshAndKeepActiveDebounced
        });
        refreshAndWipeActive();
    }
    next() {
        this.findAcrossContainers(false, [
            "top",
            null,
            "bottom"
        ], 1, 1);
    }
    previous() {
        this.findAcrossContainers(true, [
            "bottom",
            null,
            "top"
        ], this.totalMatches, -1);
    }
    goTo(match, force) {
        if (!force && match === this.activeMatch?.numOverall) return;
        const { topMatches: topMatches, topNumMatches: topNumMatches, centerMatches: centerMatches, centerNumMatches: centerNumMatches, bottomMatches: bottomMatches } = this;
        if (match <= topNumMatches) {
            this.goToInContainer(topMatches, match, 0);
            return;
        }
        if (match <= centerNumMatches) {
            this.goToInContainer(centerMatches, match, topNumMatches);
            return;
        }
        this.goToInContainer(bottomMatches, match, topNumMatches + centerNumMatches);
    }
    clearActive() {
        if (this.activeMatch) this.setActive(void 0);
    }
    // called by cell ctrl, so needs to be performant
    isMatch(node, column) {
        return this.active && !!this.getMatches(node.rowPinned).get(node)?.some(([colToCheck])=>colToCheck === column);
    }
    getNumMatches(node, column) {
        return this.getMatches(node.rowPinned).get(node)?.find(([colToCheck])=>colToCheck === column)?.[1] ?? 0;
    }
    /**
   * Get detail for cell renderer. Splits up the cell value into strings depending on
   * whether they don't match, match, or are the active match
   */ getParts(params) {
        const { value: value, node: node, column: column, precedingNumMatches: precedingNumMatches } = params;
        const findSearchValue = this.findSearchValue;
        const stringValue = (0, $437b23f6a393c3bf$export$a16cfb6652fe466f)(value) ?? "";
        if ((0, $437b23f6a393c3bf$export$672d9e47bc342bac)(findSearchValue)) return [
            {
                value: stringValue
            }
        ];
        const valueToFind = this.caseFormat(stringValue) ?? "";
        const activeMatchNum = this.getActiveMatchNum(node, column) - (precedingNumMatches ?? 0);
        let lastIndex = 0;
        let currentMatchNum = 0;
        const findTextLength = findSearchValue.length;
        const parts = [];
        while(true){
            const index = valueToFind.indexOf(findSearchValue, lastIndex);
            if (index != -1) {
                currentMatchNum++;
                if (index > lastIndex) parts.push({
                    value: stringValue.slice(lastIndex, index)
                });
                const endIndex = index + findTextLength;
                parts.push({
                    value: stringValue.slice(index, endIndex),
                    match: true,
                    activeMatch: currentMatchNum === activeMatchNum
                });
                lastIndex = endIndex;
            } else {
                if (lastIndex < stringValue.length) parts.push({
                    value: stringValue.slice(lastIndex)
                });
                return parts;
            }
        }
    }
    // when a detail grid is created, we need to sync the matches
    registerDetailGrid(node, api) {
        const gos = this.gos;
        if (!(0, $437b23f6a393c3bf$export$9f182d9ca737e15)(gos)) return;
        const isSearchDetail = ()=>gos.get("findOptions")?.searchDetail;
        const compareMatchesAndRefresh = (newNumMatches)=>{
            const nodeMatch = this.centerMatches.get(node)?.[0];
            const oldNumMatches = nodeMatch?.[1] ?? 0;
            if (newNumMatches !== oldNumMatches) this.refreshDebounced();
        };
        api.addEventListener("findChanged", (event)=>{
            if (api.isDestroyed() || !this.isAlive() || !this.active || !isSearchDetail()) return;
            compareMatchesAndRefresh(event.totalMatches);
        });
        api.addEventListener("gridPreDestroyed", ()=>{
            if (!this.isAlive() || !this.active || !isSearchDetail()) return;
            const masterNode = node.parent;
            const findSearchValue = this.findSearchValue;
            if (!masterNode || !findSearchValue) return;
            const numMatches = gos.get("detailCellRendererParams")?.getFindMatches?.({
                node: masterNode,
                data: masterNode.data,
                findSearchValue: gos.get("findSearchValue"),
                updateMatches: this.refreshDebounced,
                getMatchesForValue: (value)=>$5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, this.caseFormat, value)
            }) ?? 0;
            compareMatchesAndRefresh(numMatches);
        });
        if (isSearchDetail()) api.setGridOption("findSearchValue", gos.get("findSearchValue"));
    }
    // updates all the matches
    refresh(maintainActive) {
        const rowNodesToRefresh = /* @__PURE__ */ new Set([
            ...this.topNodes,
            ...this.centerNodes,
            ...this.bottomNodes
        ]);
        this.topNodes = [];
        this.centerNodes = [];
        this.bottomNodes = [];
        const { topNodes: topNodes, topMatches: topMatches, centerMatches: centerMatches, centerNodes: centerNodes, bottomNodes: bottomNodes, bottomMatches: bottomMatches, beans: { gos: gos, visibleCols: visibleCols, rowModel: rowModel, valueSvc: valueSvc, pinnedRowModel: pinnedRowModel, pagination: pagination, rowSpanSvc: rowSpanSvc, masterDetailSvc: masterDetailSvc, colModel: colModel }, findSearchValue: oldFindSearchValue } = this;
        const findOptions = gos.get("findOptions");
        const caseFormat = findOptions?.caseSensitive ? (value)=>value ?? void 0 : $5b7ccabde48fae90$var$defaultCaseFormat;
        this.caseFormat = caseFormat;
        const providedFindSearchValue = gos.get("findSearchValue");
        const findSearchValue = caseFormat(providedFindSearchValue?.trim());
        this.findSearchValue = findSearchValue;
        topMatches.clear();
        centerMatches.clear();
        bottomMatches.clear();
        const oldActiveMatch = maintainActive ? this.activeMatch : void 0;
        this.activeMatch = void 0;
        const checkMasterDetail = gos.get("masterDetail") && findOptions?.searchDetail && masterDetailSvc;
        if ((0, $437b23f6a393c3bf$export$672d9e47bc342bac)(findSearchValue)) {
            this.active = false;
            this.topNumMatches = 0;
            this.centerNumMatches = 0;
            this.totalMatches = 0;
            this.refreshRows(rowNodesToRefresh);
            if (checkMasterDetail) {
                const store = masterDetailSvc.store;
                for (const detailId of Object.keys(store))store[detailId]?.api?.findClearActive();
            }
            if (!(0, $437b23f6a393c3bf$export$672d9e47bc342bac)(oldFindSearchValue)) this.dispatchFindChanged();
            return;
        }
        const allCols = visibleCols.allCols;
        const isFullWidthCellFunc = gos.getCallback("isFullWidthRow");
        const detailCellRendererParams = gos.get("detailCellRendererParams");
        const fullWidthCellRendererParams = gos.get("fullWidthCellRendererParams");
        const groupRowRendererParams = gos.get("groupRowRendererParams");
        const flattenDetails = $5b7ccabde48fae90$var$_getFlattenDetails(gos);
        const pivotMode = colModel.isPivotMode();
        let containerNumMatches = 0;
        let matches;
        let rowNodes;
        let checkCurrentPage = false;
        const addMatches = (node, column, numMatches, skipRefresh)=>{
            if (!numMatches) return;
            let rowMatches = matches.get(node);
            if (!rowMatches) {
                rowMatches = [];
                matches.set(node, rowMatches);
                rowNodes.push(node);
                if (!skipRefresh) rowNodesToRefresh.add(node);
            }
            rowMatches.push([
                column,
                numMatches
            ]);
            containerNumMatches += numMatches;
        };
        const findMatchesForRow = (node)=>{
            if (checkCurrentPage) {
                let rowIndex = node.rowIndex;
                let nodeToCheck = node.parent;
                while(rowIndex == null && nodeToCheck){
                    rowIndex = nodeToCheck.rowIndex;
                    nodeToCheck = nodeToCheck.parent;
                }
                if (rowIndex == null || !pagination.isRowInPage(rowIndex)) return;
            }
            const isParent = node.hasChildren();
            if (!$5b7ccabde48fae90$var$_shouldRowBeRendered(flattenDetails, node, isParent, pivotMode, $5b7ccabde48fae90$var$_isRemovedSingleChildrenGroup(flattenDetails, node, isParent), $5b7ccabde48fae90$var$_isRemovedLowestSingleChildrenGroup(flattenDetails, node, isParent))) return;
            const data = node.data;
            if (isFullWidthCellFunc?.({
                rowNode: node
            })) {
                if (fullWidthCellRendererParams) {
                    const numMatches = fullWidthCellRendererParams.getFindMatches?.({
                        node: node,
                        data: data,
                        findSearchValue: providedFindSearchValue,
                        updateMatches: this.refreshDebounced,
                        getMatchesForValue: (value)=>$5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, caseFormat, value)
                    }) ?? 0;
                    addMatches(node, null, numMatches);
                }
                return;
            }
            if ((0, $437b23f6a393c3bf$export$410912a9c501b8cc)(gos, node, pivotMode)) {
                let valueToFind;
                const getFindText = groupRowRendererParams?.getFindText;
                if (getFindText) {
                    const value = valueSvc.getValueForDisplay({
                        node: node
                    }).value;
                    valueToFind = getFindText((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(gos, {
                        value: value,
                        node: node,
                        data: data,
                        column: null,
                        colDef: null,
                        getValueFormatted: ()=>{
                            const { valueFormatted: valueFormatted } = valueSvc.getValueForDisplay({
                                node: node,
                                includeValueFormatted: true
                            });
                            return valueFormatted;
                        }
                    }));
                } else {
                    const { value: value, valueFormatted: valueFormatted } = valueSvc.getValueForDisplay({
                        node: node,
                        includeValueFormatted: true
                    });
                    valueToFind = valueFormatted ?? value;
                }
                const numMatches = $5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, caseFormat, valueToFind);
                addMatches(node, null, numMatches);
                return;
            }
            const nodeWillBeHiddenByOpenParent = node.level > 0 && gos.get("groupHideOpenParents") && node.parent?.getFirstChild() === node && !node.parent?.expanded;
            for (const column of allCols){
                if ((0, $437b23f6a393c3bf$export$ee97d5717f8d44ec)(column)) continue;
                const cellSpan = rowSpanSvc?.getCellSpan(column, node);
                if (cellSpan && cellSpan.firstNode !== node) continue;
                if (column.colDef.showRowGroup && nodeWillBeHiddenByOpenParent) continue;
                let valueToFind;
                const colDef = column.colDef;
                const getFindText = colDef.getFindText;
                if (getFindText) {
                    const value = valueSvc.getValueForDisplay({
                        column: column,
                        node: node
                    }).value;
                    valueToFind = getFindText((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(gos, {
                        value: value,
                        node: node,
                        data: data,
                        column: column,
                        colDef: colDef,
                        getValueFormatted: ()=>{
                            const { valueFormatted: valueFormatted } = valueSvc.getValueForDisplay({
                                column: column,
                                node: node,
                                includeValueFormatted: true
                            });
                            return valueFormatted;
                        }
                    }));
                } else {
                    const { value: value, valueFormatted: valueFormatted } = valueSvc.getValueForDisplay({
                        column: column,
                        node: node,
                        includeValueFormatted: true
                    });
                    valueToFind = valueFormatted ?? value;
                }
                const numMatches = $5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, caseFormat, valueToFind);
                addMatches(node, column, numMatches);
            }
            if (node.master && checkMasterDetail) {
                const detailNode = node.detailNode;
                if (detailNode) {
                    const detailApi = detailNode.detailGridInfo?.api;
                    if (detailApi) {
                        detailApi.setGridOption("findSearchValue", providedFindSearchValue);
                        const numMatches = detailApi.findGetTotalMatches();
                        addMatches(detailNode, null, numMatches);
                        return;
                    }
                }
                if (detailCellRendererParams) {
                    const numMatches = detailCellRendererParams.getFindMatches?.({
                        node: node,
                        data: data,
                        findSearchValue: providedFindSearchValue,
                        updateMatches: this.refreshDebounced,
                        getMatchesForValue: (value)=>$5b7ccabde48fae90$var$getMatchesForValue(findSearchValue, caseFormat, value)
                    }) ?? 0;
                    addMatches(detailNode ?? {
                        parent: node,
                        dummy: true
                    }, null, numMatches, !detailNode);
                }
            }
        };
        matches = topMatches;
        rowNodes = topNodes;
        pinnedRowModel?.forEachPinnedRow("top", findMatchesForRow);
        this.topNumMatches = containerNumMatches;
        let totalMatches = containerNumMatches;
        matches = centerMatches;
        rowNodes = centerNodes;
        containerNumMatches = 0;
        checkCurrentPage = !!pagination && !!findOptions?.currentPageOnly;
        rowModel.forEachNodeAfterFilterAndSort(findMatchesForRow, true);
        this.centerNumMatches = containerNumMatches;
        totalMatches += containerNumMatches;
        matches = bottomMatches;
        rowNodes = bottomNodes;
        containerNumMatches = 0;
        checkCurrentPage = false;
        pinnedRowModel?.forEachPinnedRow("bottom", findMatchesForRow);
        totalMatches += containerNumMatches;
        this.totalMatches = totalMatches;
        this.active = true;
        this.refreshRows(rowNodesToRefresh);
        if (oldActiveMatch) this.resetActiveMatch(oldActiveMatch);
        this.dispatchFindChanged();
    }
    // update the active match back to what it was previously if possible. e.g. row index might have changed
    resetActiveMatch(oldActiveMatch) {
        const { column: column, numInMatch: numInMatch } = oldActiveMatch;
        let node = oldActiveMatch.node;
        if (node.dummy) {
            const detailNode = node.parent?.detailNode;
            if (!detailNode) return;
            node = detailNode;
        }
        const rowPinned = node.rowPinned ?? null;
        const stillValid = this.getMatches(rowPinned)?.get(node)?.some(([columnToCheck, numMatches])=>columnToCheck === column && numMatches >= numInMatch);
        if (!stillValid) return;
        let numOverall = 0;
        if (rowPinned == null) numOverall = this.topNumMatches;
        else if (rowPinned === "bottom") numOverall = this.topNumMatches + this.centerNumMatches;
        const updateNumInMatches = ()=>{
            const matches = this.getMatches(rowPinned);
            for (const nodeToCheck of matches.keys()){
                const matchingNode = nodeToCheck === node;
                const cols = matches.get(nodeToCheck);
                for (const [columnToCheck, numMatches] of cols){
                    if (matchingNode && columnToCheck === column) {
                        numOverall += numInMatch;
                        return;
                    }
                    numOverall += numMatches;
                }
            }
        };
        updateNumInMatches();
        const activeMatch = {
            ...oldActiveMatch,
            node: node,
            numOverall: numOverall
        };
        this.activeMatch = activeMatch;
        this.refreshRows(/* @__PURE__ */ new Set([
            node
        ]), column == null ? void 0 : /* @__PURE__ */ new Set([
            column
        ]));
        if (this.scrollOnRefresh) {
            this.scrollOnRefresh = false;
            this.scrollToActive(activeMatch);
        }
        this.setDetailActive(activeMatch);
    }
    refreshRows(rowNodes, columns) {
        if (!rowNodes.size) return;
        this.beans.rowRenderer.refreshCells({
            rowNodes: [
                ...rowNodes
            ],
            columns: columns ? [
                ...columns
            ] : void 0,
            force: true,
            suppressFlash: true
        });
    }
    // go to the next/previous match across all containers
    findAcrossContainers(backwards, containers, startNum, increment) {
        if (!this.totalMatches) {
            this.setActive();
            return;
        }
        const activeMatch = this.activeMatch;
        let containersToFind = containers;
        if (activeMatch) {
            const { column: column, node: node, numInMatch: numInMatch, numOverall: numOverall } = activeMatch;
            const rowPinned = node.rowPinned ?? null;
            const nextOverallNum = numOverall + increment;
            const matchInContainer = this.findInContainer(rowPinned, backwards, nextOverallNum, node, column, numInMatch);
            if (matchInContainer) return;
            const activeContainerIndex = containers.indexOf(rowPinned);
            const containerLength = containers.length;
            const containersAfter = containers.slice(activeContainerIndex + 1, containerLength);
            if (containersAfter.some((containerRowPinned)=>this.findInContainer(containerRowPinned, backwards, nextOverallNum))) return;
            containersToFind = containers.slice(0, activeContainerIndex + 1);
        }
        containersToFind.some((containerRowPinned)=>this.findInContainer(containerRowPinned, backwards, startNum));
    }
    // go to the next/previous match within a container
    findInContainer(rowPinned, backwards, nextOverallNum, currentNode, currentColumn, currentNumInMatch) {
        const matches = this.getMatches(rowPinned);
        const rowNodes = this.getRowNodes(rowPinned);
        const direction = backwards ? -1 : 1;
        if (currentNode != null) {
            const currentIndexRowMatches = matches.get(currentNode);
            const colArrayIndex = currentIndexRowMatches?.findIndex(([column])=>column === currentColumn);
            if (colArrayIndex != null && colArrayIndex != -1) {
                const [column, numMatches] = currentIndexRowMatches[colArrayIndex];
                if (backwards ? currentNumInMatch > 1 : currentNumInMatch < numMatches) {
                    this.setActive({
                        column: column,
                        node: currentNode,
                        numInMatch: currentNumInMatch + direction,
                        numOverall: nextOverallNum
                    });
                    return true;
                }
            }
            const nextMatch2 = colArrayIndex != null && colArrayIndex != -1 ? currentIndexRowMatches?.[colArrayIndex + direction] : void 0;
            if (nextMatch2) {
                const [column, numMatches] = nextMatch2;
                this.setActive({
                    column: column,
                    node: currentNode,
                    numInMatch: backwards ? numMatches : 1,
                    numOverall: nextOverallNum
                });
                return true;
            }
        }
        let nextNode;
        if (currentNode == null) nextNode = rowNodes[backwards ? rowNodes.length - 1 : 0];
        else {
            const rowArrayIndex = rowNodes.findIndex((node)=>node === currentNode);
            nextNode = rowNodes[rowArrayIndex + direction];
        }
        if (nextNode == null) return false;
        const nextIndexRowMatches = matches.get(nextNode);
        const nextMatch = nextIndexRowMatches?.[backwards ? nextIndexRowMatches.length - 1 : 0];
        if (nextMatch) {
            const [column, numMatches] = nextMatch;
            this.setActive({
                column: column,
                node: nextNode,
                numInMatch: backwards ? numMatches : 1,
                numOverall: nextOverallNum
            });
            return true;
        }
        return false;
    }
    dispatchFindChanged() {
        const { eventSvc: eventSvc, activeMatch: activeMatch, totalMatches: totalMatches, findSearchValue: findSearchValue } = this;
        eventSvc.dispatchEvent({
            type: "findChanged",
            activeMatch: activeMatch,
            totalMatches: totalMatches,
            findSearchValue: findSearchValue
        });
    }
    setActive(activeMatch) {
        if (activeMatch && activeMatch.node.rowIndex == null) {
            const node = activeMatch.node;
            let parent = node.footer ? node.sibling : node.parent;
            while(parent && parent.level !== -1){
                parent.expanded = true;
                parent = parent.parent;
            }
            this.activeMatch = activeMatch;
            this.scrollOnRefresh = true;
            this.beans.expansionSvc?.onGroupExpandedOrCollapsed();
            return;
        }
        const oldActiveMatch = this.activeMatch;
        this.activeMatch = activeMatch;
        this.refreshAndScrollToActive(activeMatch, oldActiveMatch);
        if (activeMatch) this.setDetailActive(activeMatch);
        this.dispatchFindChanged();
    }
    setDetailActive({ node: node, numInMatch: numInMatch }) {
        if (node.detail) node.detailGridInfo?.api?.findGoTo(numInMatch);
    }
    refreshAndScrollToActive(activeMatch, oldActiveMatch) {
        if (activeMatch || oldActiveMatch) {
            const nodes = /* @__PURE__ */ new Set();
            const columns = /* @__PURE__ */ new Set();
            let skipColumns = false;
            const addMatch = (match)=>{
                if (!match) return;
                const { node: node, column: column } = match;
                nodes.add(node);
                if (column == null) skipColumns = true;
                else columns.add(column);
            };
            addMatch(activeMatch);
            addMatch(oldActiveMatch);
            this.refreshRows(nodes, skipColumns ? void 0 : columns);
        }
        if (activeMatch) this.scrollToActive(activeMatch);
    }
    scrollToActive({ node: { rowPinned: rowPinned, rowIndex: rowIndex }, column: column }) {
        const { ctrlsSvc: ctrlsSvc, pagination: pagination, gos: gos } = this.beans;
        const scrollFeature = ctrlsSvc.getScrollFeature();
        if (rowPinned == null && rowIndex != null) {
            if (pagination && !gos.get("findOptions")?.currentPageOnly && !pagination.isRowInPage(rowIndex)) pagination.goToPageWithIndex(rowIndex);
            scrollFeature.ensureIndexVisible(rowIndex);
        }
        scrollFeature.ensureColumnVisible(column);
    }
    // search for the specified overall `match` number with the provided container, and set it to be active
    goToInContainer(matches, match, startNum) {
        let currentMatch = startNum;
        for (const node of matches.keys()){
            const cols = matches.get(node);
            for (const [column, numMatches] of cols){
                if (match <= currentMatch + numMatches) {
                    this.setActive({
                        column: column,
                        node: node,
                        numInMatch: match - currentMatch,
                        numOverall: match
                    });
                    return;
                }
                currentMatch += numMatches;
            }
        }
    }
    getMatches(rowPinned) {
        if (rowPinned === "top") return this.topMatches;
        else if (rowPinned === "bottom") return this.bottomMatches;
        else return this.centerMatches;
    }
    getRowNodes(rowPinned) {
        if (rowPinned === "top") return this.topNodes;
        else if (rowPinned === "bottom") return this.bottomNodes;
        else return this.centerNodes;
    }
    getActiveMatchNum(node, column) {
        const activeMatch = this.activeMatch;
        return activeMatch != null && activeMatch.node === node && activeMatch.column === column ? activeMatch.numInMatch : 0;
    }
    destroy() {
        this.topMatches.clear();
        this.topNodes.length = 0;
        this.centerMatches.clear();
        this.centerNodes.length = 0;
        this.bottomMatches.clear();
        this.bottomNodes.length = 0;
        this.activeMatch = void 0;
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/find/findModule.ts
var $5b7ccabde48fae90$var$FindCoreModule = {
    moduleName: "FindCore",
    version: $5b7ccabde48fae90$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $5b7ccabde48fae90$var$FindService
    ],
    userComponents: {
        agFindCellRenderer: $5b7ccabde48fae90$var$FindCellRenderer
    },
    css: [
        $5b7ccabde48fae90$var$findCSS
    ]
};
var $5b7ccabde48fae90$export$3b7f0581dcb7e440 = {
    moduleName: "Find",
    version: $5b7ccabde48fae90$var$VERSION,
    apiFunctions: {
        findGetTotalMatches: $5b7ccabde48fae90$var$findGetTotalMatches,
        findGoTo: $5b7ccabde48fae90$var$findGoTo,
        findNext: $5b7ccabde48fae90$var$findNext,
        findPrevious: $5b7ccabde48fae90$var$findPrevious,
        findGetActiveMatch: $5b7ccabde48fae90$var$findGetActiveMatch,
        findGetNumMatches: $5b7ccabde48fae90$var$findGetNumMatches,
        findGetParts: $5b7ccabde48fae90$var$findGetParts,
        findClearActive: $5b7ccabde48fae90$var$findClearActive,
        findRefresh: $5b7ccabde48fae90$var$findRefresh
    },
    dependsOn: [
        $5b7ccabde48fae90$var$FindCoreModule
    ]
};
function $5b7ccabde48fae90$var$startBatchEdit({ editSvc: editSvc, gos: gos, rowModel: rowModel }) {
    if (!editSvc?.isBatchEditing()) {
        if (!(0, $437b23f6a393c3bf$export$9f182d9ca737e15)(gos, rowModel)) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(289, {
                rowModelType: gos.get("rowModelType")
            });
            return;
        }
        editSvc?.setBatchEditing(true);
    }
}
function $5b7ccabde48fae90$var$cancelBatchEdit({ editSvc: editSvc }) {
    if (!editSvc?.isBatchEditing()) return;
    editSvc?.stopEditing(void 0, {
        cancel: true,
        source: "api",
        forceCancel: true
    });
    editSvc?.setBatchEditing(false);
}
function $5b7ccabde48fae90$var$commitBatchEdit({ editSvc: editSvc }) {
    if (!editSvc?.isBatchEditing()) return;
    editSvc?.stopEditing(void 0, {
        source: "api",
        forceStop: true
    });
    editSvc?.setBatchEditing(false);
}
function $5b7ccabde48fae90$var$isBatchEditing(beans) {
    return beans.editSvc?.isBatchEditing() ?? false;
}
// packages/ag-grid-enterprise/src/batch-edit/batchEditModule.ts
var $5b7ccabde48fae90$export$3b8008724bbc4e9f = {
    moduleName: "BatchEdit",
    version: $5b7ccabde48fae90$var$VERSION,
    beans: [],
    apiFunctions: {
        isBatchEditing: $5b7ccabde48fae90$var$isBatchEditing,
        startBatchEdit: $5b7ccabde48fae90$var$startBatchEdit,
        cancelBatchEdit: $5b7ccabde48fae90$var$cancelBatchEdit,
        commitBatchEdit: $5b7ccabde48fae90$var$commitBatchEdit
    },
    dependsOn: [
        (0, $437b23f6a393c3bf$export$12c61a50add34259),
        $5b7ccabde48fae90$var$EnterpriseCoreModule
    ],
    css: []
};
var $5b7ccabde48fae90$var$AgChartsExports = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(params){
        super();
        this.beanName = "agChartsExports";
        this.isEnterprise = false;
        this.create = params.create;
        this._Theme = params._Theme;
        this._Scene = params._Scene;
        this.isEnterprise = params.isEnterprise;
        this._Util = params._Util;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/utils/integration.ts
function $5b7ccabde48fae90$var$deproxy(chartOrProxy) {
    if (chartOrProxy.chart != null) return chartOrProxy.chart;
    return chartOrProxy;
}
// packages/ag-grid-enterprise/src/charts/chartComp/utils/object.ts
var $5b7ccabde48fae90$var$SKIP_JS_BUILTINS = /* @__PURE__ */ new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
function $5b7ccabde48fae90$var$get(source, expression, defaultValue) {
    if (source == null) return defaultValue;
    const keys = expression.split(".");
    let objectToRead = source;
    while(keys.length > 1){
        objectToRead = objectToRead[keys.shift()];
        if (objectToRead == null) return defaultValue;
    }
    const value = objectToRead[keys[0]];
    return value != null ? value : defaultValue;
}
function $5b7ccabde48fae90$var$set(target, expression, value) {
    if (target == null) return;
    const keys = expression.split(".");
    let objectToUpdate = target;
    keys.filter((key)=>!$5b7ccabde48fae90$var$SKIP_JS_BUILTINS.has(key)).forEach((key, i)=>{
        if (!objectToUpdate[key]) objectToUpdate[key] = {};
        if (i < keys.length - 1) objectToUpdate = objectToUpdate[key];
    });
    objectToUpdate[keys[keys.length - 1]] = value;
}
// packages/ag-grid-enterprise/src/charts/chartComp/utils/seriesTypeMapper.ts
var $5b7ccabde48fae90$var$CHART_TYPE_TO_SERIES_TYPE = {
    column: "bar",
    groupedColumn: "bar",
    stackedColumn: "bar",
    normalizedColumn: "bar",
    bar: "bar",
    groupedBar: "bar",
    stackedBar: "bar",
    normalizedBar: "bar",
    line: "line",
    stackedLine: "line",
    normalizedLine: "line",
    scatter: "scatter",
    bubble: "bubble",
    pie: "pie",
    donut: "donut",
    doughnut: "donut",
    area: "area",
    stackedArea: "area",
    normalizedArea: "area",
    histogram: "histogram",
    radarLine: "radar-line",
    radarArea: "radar-area",
    nightingale: "nightingale",
    radialColumn: "radial-column",
    radialBar: "radial-bar",
    sunburst: "sunburst",
    rangeBar: "range-bar",
    rangeArea: "range-area",
    boxPlot: "box-plot",
    treemap: "treemap",
    heatmap: "heatmap",
    waterfall: "waterfall",
    funnel: "funnel",
    coneFunnel: "cone-funnel",
    pyramid: "pyramid"
};
var $5b7ccabde48fae90$var$COMBO_CHART_TYPES = /* @__PURE__ */ new Set([
    "columnLineCombo",
    "areaColumnCombo",
    "customCombo"
]);
var $5b7ccabde48fae90$var$SERIES_GROUP_TYPES = [
    "grouped",
    "stacked",
    "normalized"
];
var $5b7ccabde48fae90$var$SERIES_TYPES = {
    area: {
        isCartesian: true,
        canInvert: true
    },
    bar: {
        isCartesian: true,
        canInvert: true
    },
    histogram: {
        isCartesian: true
    },
    line: {
        isCartesian: true,
        canInvert: true
    },
    pie: {
        isPie: true
    },
    donut: {
        isPie: true,
        canInvert: true
    },
    scatter: {
        isCartesian: true
    },
    bubble: {
        isCartesian: true
    },
    "radial-column": {
        isPolar: true,
        isEnterprise: true,
        isRadial: true,
        canInvert: true
    },
    "radial-bar": {
        isPolar: true,
        isEnterprise: true,
        isRadial: true,
        canInvert: true
    },
    "radar-line": {
        isPolar: true,
        isEnterprise: true,
        canInvert: true
    },
    "radar-area": {
        isPolar: true,
        isEnterprise: true,
        canInvert: true
    },
    nightingale: {
        isPolar: true,
        isEnterprise: true,
        canInvert: true
    },
    "range-bar": {
        isCartesian: true,
        isStatistical: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    "range-area": {
        isCartesian: true,
        isStatistical: true,
        isEnterprise: true
    },
    "box-plot": {
        isCartesian: true,
        isStatistical: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    treemap: {
        isEnterprise: true,
        isHierarchical: true
    },
    sunburst: {
        isEnterprise: true,
        isHierarchical: true
    },
    heatmap: {
        isCartesian: true,
        isEnterprise: true
    },
    waterfall: {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    funnel: {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    "cone-funnel": {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    pyramid: {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    }
};
function $5b7ccabde48fae90$var$isSeriesType(seriesType) {
    return !!$5b7ccabde48fae90$var$SERIES_TYPES[seriesType];
}
function $5b7ccabde48fae90$var$isComboChart(chartType) {
    return $5b7ccabde48fae90$var$COMBO_CHART_TYPES.has(chartType);
}
function $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, prop) {
    return !!$5b7ccabde48fae90$var$SERIES_TYPES[seriesType]?.[prop];
}
function $5b7ccabde48fae90$var$isEnterpriseChartType(chartType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty($5b7ccabde48fae90$var$getSeriesType(chartType), "isEnterprise");
}
var $5b7ccabde48fae90$var$stackedChartTypes = /* @__PURE__ */ new Set([
    "stackedColumn",
    "normalizedColumn",
    "stackedBar",
    "normalizedBar"
]);
function $5b7ccabde48fae90$var$isStacked(chartType) {
    return $5b7ccabde48fae90$var$stackedChartTypes.has(chartType);
}
function $5b7ccabde48fae90$var$isCartesian(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isCartesian");
}
function $5b7ccabde48fae90$var$isFunnel(seriesType) {
    return seriesType === "funnel" || seriesType === "cone-funnel" || seriesType === "pyramid";
}
function $5b7ccabde48fae90$var$isPolar(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isPolar");
}
function $5b7ccabde48fae90$var$isRadial(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isRadial");
}
function $5b7ccabde48fae90$var$isHierarchical(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isHierarchical");
}
function $5b7ccabde48fae90$var$isStatistical(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isStatistical");
}
function $5b7ccabde48fae90$var$getCanonicalChartType(chartType) {
    return chartType === "doughnut" ? "donut" : chartType;
}
function $5b7ccabde48fae90$var$getSeriesTypeIfExists(chartType) {
    return $5b7ccabde48fae90$var$CHART_TYPE_TO_SERIES_TYPE[chartType];
}
function $5b7ccabde48fae90$var$getSeriesType(chartType) {
    return $5b7ccabde48fae90$var$getSeriesTypeIfExists(chartType) ?? "line";
}
function $5b7ccabde48fae90$var$isPieChartSeries(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isPie");
}
function $5b7ccabde48fae90$var$canOnlyHaveSingleSeries(chartType) {
    return chartType === "pie" || chartType === "waterfall" || chartType === "histogram" || chartType === "funnel" || chartType === "coneFunnel" || chartType === "pyramid";
}
function $5b7ccabde48fae90$var$getMaxNumCategories(chartType) {
    return $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(chartType)) ? void 0 : 1;
}
function $5b7ccabde48fae90$var$getMaxNumSeries(chartType) {
    if ($5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(chartType))) return 2;
    else if ($5b7ccabde48fae90$var$canOnlyHaveSingleSeries(chartType)) return 1;
    else return void 0;
}
function $5b7ccabde48fae90$var$supportsInvertedCategorySeries(chartType) {
    return !$5b7ccabde48fae90$var$isComboChart(chartType) && $5b7ccabde48fae90$var$doesSeriesHaveProperty($5b7ccabde48fae90$var$getSeriesType(chartType), "canInvert");
}
function $5b7ccabde48fae90$var$canSwitchDirection(chartType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty($5b7ccabde48fae90$var$getSeriesType(chartType), "canSwitchDirection");
}
function $5b7ccabde48fae90$var$getFullChartNameTranslationKey(chartType) {
    switch(chartType){
        case "groupedColumn":
        case "stackedColumn":
        case "normalizedColumn":
        case "groupedBar":
        case "stackedBar":
        case "normalizedBar":
        case "stackedLine":
        case "normalizedLine":
        case "stackedArea":
        case "normalizedArea":
            return `${chartType}Full`;
        case "doughnut":
            return "donut";
        case "areaColumnCombo":
            return "AreaColumnCombo";
        default:
            return chartType;
    }
}
// packages/ag-grid-enterprise/src/charts/chartComp/utils/axisTypeMapper.ts
var $5b7ccabde48fae90$var$ALL_AXIS_TYPES = [
    "number",
    "category",
    "grouped-category",
    "log",
    "time"
];
function $5b7ccabde48fae90$var$getLegacyAxisType(chartType) {
    switch(chartType){
        case "bar":
        case "stackedBar":
        case "normalizedBar":
            return [
                "number",
                "category"
            ];
        case "groupedBar":
            return [
                "number",
                "grouped-category"
            ];
        case "column":
        case "stackedColumn":
        case "normalizedColumn":
        case "line":
        case "stackedLine":
        case "normalizedLine":
        case "area":
        case "stackedArea":
        case "normalizedArea":
        case "histogram":
            return [
                "category",
                "number"
            ];
        case "groupedColumn":
            return [
                "grouped-category",
                "number"
            ];
        case "scatter":
        case "bubble":
            return [
                "number",
                "number"
            ];
        default:
            return void 0;
    }
}
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/chartTheme.ts
function $5b7ccabde48fae90$var$createAgChartTheme(chartProxyParams, proxy, isEnterprise, chartThemeDefaults, updatedOverrides) {
    const { chartOptionsToRestore: chartOptionsToRestore, chartPaletteToRestore: chartPaletteToRestore, chartThemeToRestore: chartThemeToRestore, agChartsExports: agChartsExports } = chartProxyParams;
    const themeName = $5b7ccabde48fae90$var$getSelectedTheme(chartProxyParams);
    const stockTheme = $5b7ccabde48fae90$var$isStockTheme(themeName, agChartsExports._Theme);
    const rootTheme = stockTheme ? {
        baseTheme: themeName
    } : $5b7ccabde48fae90$var$lookupCustomChartTheme(chartProxyParams, themeName) ?? {};
    const gridOptionsThemeOverrides = chartProxyParams.getGridOptionsChartThemeOverrides();
    const apiThemeOverrides = chartProxyParams.apiChartThemeOverrides;
    const standaloneChartType = $5b7ccabde48fae90$var$getSeriesType(chartProxyParams.chartType);
    const crossFilteringOverrides = chartProxyParams.crossFiltering ? $5b7ccabde48fae90$var$createCrossFilterThemeOverrides(proxy, chartProxyParams, standaloneChartType) : void 0;
    const isTitleEnabled = ()=>{
        const isTitleEnabled2 = (obj)=>{
            if (!obj) return false;
            return Object.keys(obj).some((key)=>$5b7ccabde48fae90$var$get(obj[key], "title.enabled", false));
        };
        return isTitleEnabled2(gridOptionsThemeOverrides) || isTitleEnabled2(apiThemeOverrides);
    };
    const overrides = [
        stockTheme ? $5b7ccabde48fae90$var$inbuiltStockThemeOverrides(chartProxyParams, isEnterprise, isTitleEnabled()) : void 0,
        $5b7ccabde48fae90$var$pieAndDonutOverrides(),
        chartThemeDefaults,
        crossFilteringOverrides,
        gridOptionsThemeOverrides,
        apiThemeOverrides,
        {
            ...chartOptionsToRestore ?? {}
        },
        updatedOverrides
    ];
    const theme = overrides.filter((v)=>!!v).reduce((r, n)=>({
            baseTheme: r,
            overrides: n
        }), rootTheme);
    if (chartPaletteToRestore && themeName === chartThemeToRestore) {
        const rootThemePalette = chartProxyParams.agChartsExports._Theme.getChartTheme(rootTheme).palette;
        if (!$5b7ccabde48fae90$var$isIdenticalPalette(chartPaletteToRestore, rootThemePalette)) theme.palette = chartPaletteToRestore;
    }
    return theme;
}
function $5b7ccabde48fae90$var$isIdenticalPalette(paletteA, paletteB) {
    const arrayCompare = (arrA, arrB)=>{
        if (arrA === arrB) return true;
        if (arrA?.length !== arrB?.length) return false;
        return arrA?.every((v, i)=>v === arrB?.[i]) ?? false;
    };
    return arrayCompare(paletteA.fills, paletteB.fills) && arrayCompare(paletteA.strokes, paletteB.strokes);
}
function $5b7ccabde48fae90$var$isStockTheme(themeName, theme) {
    return Object.keys(theme.themes).includes(themeName);
}
function $5b7ccabde48fae90$var$createCrossFilterThemeOverrides(proxy, chartProxyParams, seriesType) {
    const legend = {
        listeners: {
            legendItemClick: (e)=>{
                const chart = proxy.getChart();
                const eligibleSeriesIds = [
                    e.seriesId,
                    `${e.seriesId}-filtered-out`
                ];
                for (const s2 of chart.series.filter((s3)=>eligibleSeriesIds.includes(s3.id)))s2.toggleSeriesItem(void 0, "category", e.itemId, void 0);
            }
        }
    };
    const common = {
        tooltip: {
            delay: 500
        },
        legend: legend,
        listeners: {
            click: (e)=>chartProxyParams.crossFilterCallback(e, true)
        }
    };
    if (seriesType === "pie" || seriesType === "donut") return {
        [seriesType]: {
            series: {
                fills: {
                    $applyCycle: [
                        {
                            $cacheMax: {
                                $size: {
                                    $path: [
                                        "./data",
                                        {
                                            $path: "/data"
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            $palette: "fills"
                        },
                        {
                            $if: [
                                {
                                    $eq: [
                                        {
                                            $value: "$parentIndex"
                                        },
                                        0
                                    ]
                                },
                                {
                                    $mix: [
                                        {
                                            $value: "$1"
                                        },
                                        {
                                            $ref: "backgroundColor"
                                        },
                                        0.7
                                    ]
                                },
                                {
                                    $value: "$1"
                                }
                            ]
                        }
                    ]
                },
                strokes: {
                    $applyCycle: [
                        {
                            $cacheMax: {
                                $size: {
                                    $path: [
                                        "./data",
                                        {
                                            $path: "/data"
                                        }
                                    ]
                                }
                            }
                        },
                        {
                            $palette: "strokes"
                        },
                        {
                            $if: [
                                {
                                    $eq: [
                                        {
                                            $value: "$parentIndex"
                                        },
                                        0
                                    ]
                                },
                                {
                                    $mix: [
                                        {
                                            $value: "$1"
                                        },
                                        {
                                            $ref: "backgroundColor"
                                        },
                                        0.7
                                    ]
                                },
                                {
                                    $value: "$1"
                                }
                            ]
                        }
                    ]
                }
            },
            ...common
        }
    };
    const fill = {};
    if (seriesType !== "line") fill.fill = {
        $if: [
            {
                $isEven: [
                    {
                        $value: "$index"
                    }
                ]
            },
            {
                $palette: "fill"
            },
            {
                $mix: [
                    {
                        $path: [
                            "../$prevIndex/fill",
                            {
                                $palette: "fill"
                            }
                        ]
                    },
                    {
                        $ref: "backgroundColor"
                    },
                    0.7
                ]
            }
        ]
    };
    return {
        [seriesType]: {
            series: {
                stroke: {
                    $if: [
                        {
                            $isEven: [
                                {
                                    $value: "$index"
                                }
                            ]
                        },
                        {
                            $palette: "stroke"
                        },
                        {
                            $mix: [
                                {
                                    $path: [
                                        "../$prevIndex/fill",
                                        {
                                            $palette: "stroke"
                                        }
                                    ]
                                },
                                {
                                    $ref: "backgroundColor"
                                },
                                0.7
                            ]
                        }
                    ]
                },
                ...fill
            },
            ...common
        }
    };
}
var $5b7ccabde48fae90$var$STATIC_INBUILT_STOCK_THEME_AXES_OVERRIDES = $5b7ccabde48fae90$var$ALL_AXIS_TYPES.reduce((r, n)=>({
        ...r,
        [n]: {
            title: {
                _enabledFromTheme: true
            }
        }
    }), {});
function $5b7ccabde48fae90$var$inbuiltStockThemeOverrides(params, isEnterprise, titleEnabled) {
    const extraPadding = params.getExtraPaddingDirections();
    return {
        common: {
            ...isEnterprise ? {
                animation: {
                    duration: 500
                }
            } : void 0,
            axes: $5b7ccabde48fae90$var$STATIC_INBUILT_STOCK_THEME_AXES_OVERRIDES,
            padding: {
                // don't add extra padding when a title is present!
                top: !titleEnabled && extraPadding.includes("top") ? 40 : 20,
                right: extraPadding.includes("right") ? 30 : 20,
                bottom: extraPadding.includes("bottom") ? 40 : 20,
                left: extraPadding.includes("left") ? 30 : 20
            }
        }
    };
}
function $5b7ccabde48fae90$var$pieAndDonutOverrides() {
    return {
        pie: {
            series: {
                title: {
                    _enabledFromTheme: true
                },
                calloutLabel: {
                    _enabledFromTheme: true
                },
                sectorLabel: {
                    enabled: false,
                    _enabledFromTheme: true
                }
            }
        },
        donut: {
            series: {
                title: {
                    _enabledFromTheme: true
                },
                calloutLabel: {
                    _enabledFromTheme: true
                },
                sectorLabel: {
                    enabled: false,
                    _enabledFromTheme: true
                }
            }
        }
    };
}
function $5b7ccabde48fae90$var$getSelectedTheme(chartProxyParams) {
    let chartThemeName = chartProxyParams.getChartThemeName();
    const availableThemes = chartProxyParams.getChartThemes();
    if (!availableThemes.includes(chartThemeName)) chartThemeName = availableThemes[0];
    return chartThemeName;
}
function $5b7ccabde48fae90$var$lookupCustomChartTheme(chartProxyParams, name) {
    const { customChartThemes: customChartThemes } = chartProxyParams;
    const customChartTheme = customChartThemes?.[name];
    if (!customChartTheme) (0, $437b23f6a393c3bf$export$545083624300f13d)(140, {
        name: name
    });
    return customChartTheme;
}
function $5b7ccabde48fae90$var$getSeriesHighlight(crossFiltering) {
    const highlight = {
        unhighlightedSeries: {
            opacity: 1
        },
        highlightedItem: {
            strokeWidth: 2
        }
    };
    if (!crossFiltering) highlight.unhighlightedItem = {
        opacity: 1
    };
    return highlight;
}
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/chartProxy.ts
var $5b7ccabde48fae90$var$ChartProxy = class {
    constructor(chartProxyParams){
        this.chartProxyParams = chartProxyParams;
        this.clearThemeOverrides = false;
        this.agChartsExports = chartProxyParams.agChartsExports;
        this.chart = chartProxyParams.chartInstance;
        this.chartType = chartProxyParams.chartType;
        this.crossFiltering = chartProxyParams.crossFiltering;
        this.crossFilterCallback = chartProxyParams.crossFilterCallback;
        this.standaloneChartType = $5b7ccabde48fae90$var$getSeriesType(this.chartType);
        if (this.chart == null) this.chart = chartProxyParams.agChartsExports.create(this.getCommonChartOptions());
        else this.clearThemeOverrides = true;
    }
    crossFilteringReset() {}
    update(params) {
        this.getChartRef().update(this.getUpdateOptions(params, this.getCommonChartOptions(params.updatedOverrides)));
    }
    updateThemeOverrides(themeOverrides) {
        this.getChartRef().updateDelta({
            theme: {
                overrides: themeOverrides
            }
        });
    }
    getChart() {
        return $5b7ccabde48fae90$var$deproxy(this.chart);
    }
    getChartRef() {
        return this.chart;
    }
    downloadChart(dimensions, fileName, fileFormat) {
        const { chart: chart } = this;
        const rawChart = $5b7ccabde48fae90$var$deproxy(chart);
        const imageFileName = fileName || rawChart.title.node.getPlainText();
        const { width: width, height: height } = dimensions || {};
        chart.download({
            width: width,
            height: height,
            fileName: imageFileName,
            fileFormat: fileFormat
        });
    }
    getChartImageDataURL(type) {
        return this.getChart().getCanvasDataURL(type);
    }
    getChartOptions() {
        return this.chart.getOptions();
    }
    getChartThemeOverrides() {
        const chartOptionsTheme = this.getChartOptions().theme;
        return chartOptionsTheme.overrides ?? {};
    }
    getChartPalette() {
        return this.agChartsExports._Theme.getChartTheme(this.getChartOptions().theme).palette;
    }
    setPaired(paired) {
        const seriesType = $5b7ccabde48fae90$var$getSeriesType(this.chartProxyParams.chartType);
        this.chart.updateDelta({
            theme: {
                overrides: {
                    [seriesType]: {
                        paired: paired
                    }
                }
            }
        });
    }
    isPaired() {
        const seriesType = $5b7ccabde48fae90$var$getSeriesType(this.chartProxyParams.chartType);
        return $5b7ccabde48fae90$var$get(this.getChartThemeOverrides(), `${seriesType}.paired`, true);
    }
    lookupCustomChartTheme(themeName) {
        return $5b7ccabde48fae90$var$lookupCustomChartTheme(this.chartProxyParams, themeName);
    }
    getSeriesGroupType() {
        return void 0;
    }
    transformCategoryData(data, categoryKey) {
        return data.map((d, index)=>{
            const value = d[categoryKey];
            const valueString = value?.toString ? value.toString() : "";
            const datum = {
                ...d
            };
            datum[categoryKey] = {
                id: index,
                value: value,
                toString: ()=>valueString
            };
            return datum;
        });
    }
    getCommonChartOptions(updatedOverrides) {
        const existingOptions = this.clearThemeOverrides ? {} : this.chart?.getOptions() ?? {};
        const formattingPanelOverrides = this.chart != null ? this.getActiveFormattingPanelOverrides() : void 0;
        this.clearThemeOverrides = false;
        const styleNonce = this.chartProxyParams.styleNonce;
        const theme = $5b7ccabde48fae90$var$createAgChartTheme(this.chartProxyParams, this, this.agChartsExports.isEnterprise, this.getChartThemeDefaults(), updatedOverrides ?? formattingPanelOverrides);
        const newOptions = {
            ...existingOptions,
            mode: "integrated",
            ...styleNonce ? {
                styleNonce: styleNonce
            } : {},
            suppressFieldDotNotation: true,
            theme: theme,
            container: this.chartProxyParams.parentElement
        };
        return newOptions;
    }
    getChartThemeDefaults() {
        const crosshair = {
            enabled: true,
            snap: true,
            label: {
                enabled: false
            }
        };
        const common = this.agChartsExports.isEnterprise ? {
            zoom: {
                enabled: true
            },
            animation: {
                enabled: true,
                duration: 500
            },
            axes: {
                number: {
                    crosshair: crosshair
                },
                category: {
                    crosshair: crosshair
                },
                log: {
                    crosshair: crosshair
                },
                time: {
                    crosshair: crosshair
                }
            }
        } : {};
        common.minHeight = 0;
        common.minWidth = 0;
        common.navigator = {
            enabled: false,
            height: 18
        };
        common.context = this.chartProxyParams.context;
        const overrides = {
            common: common
        };
        this.setSeriesChartThemeDefaults(overrides);
        return overrides;
    }
    setSeriesChartThemeDefaults(overrides) {
        const seriesOverrides = this.getSeriesChartThemeDefaults();
        if (!seriesOverrides) return;
        overrides[this.standaloneChartType] = seriesOverrides;
    }
    getSeriesChartThemeDefaults() {
        return void 0;
    }
    getActiveFormattingPanelOverrides() {
        if (this.clearThemeOverrides) return {};
        const inUseTheme = this.chart?.getOptions().theme;
        return inUseTheme?.overrides ?? {};
    }
    destroy({ keepChartInstance: keepChartInstance = false } = {}) {
        if (keepChartInstance) {
            this.chart.resetAnimations();
            return this.chart;
        }
        this.destroyChart();
    }
    destroyChart() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = void 0;
        }
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/cartesianChartProxy.ts
var $5b7ccabde48fae90$var$CartesianChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    constructor(){
        super(...arguments);
        this.crossFilteringAllPoints = /* @__PURE__ */ new Set();
        this.crossFilteringSelectedPoints = [];
    }
    getUpdateOptions(params, commonChartOptions) {
        const axes = this.getAxes(params, commonChartOptions);
        return {
            ...commonChartOptions,
            data: this.getData(params, axes),
            axes: axes,
            series: this.getSeries(params)
        };
    }
    getData(params, axes) {
        const supportsCrossFiltering = [
            "area",
            "line"
        ].includes(this.standaloneChartType);
        return this.crossFiltering && supportsCrossFiltering ? this.getCrossFilterData(params) : this.getDataTransformedData(params, axes);
    }
    getDataTransformedData(params, axes) {
        const xAxisType = axes.x.type;
        const { categories: categories, data: data } = params;
        const [category] = categories;
        switch(xAxisType){
            case "category":
                return this.transformCategoryData(data, category.id);
            case "time":
                return this.transformTimeData(data, category.id, category.convertTime);
            default:
                return data;
        }
    }
    getXAxisType(params) {
        if (params.grouping) return "grouped-category";
        else if (this.isXAxisOfType(params, "time", (value)=>value instanceof Date)) return "time";
        else if (this.isXAxisOfType(params, "number")) return "number";
        return "category";
    }
    isXAxisOfType(params, type, isInstance) {
        const [category] = params.categories;
        if (category?.chartDataType) return category.chartDataType === type;
        if (!isInstance) return false;
        const testDatum = params.data[0];
        if (!testDatum) return false;
        return isInstance(testDatum[category.id]);
    }
    transformTimeData(data, categoryKey, convertTime2) {
        const firstValue = data[0]?.[categoryKey];
        if (firstValue instanceof Date) return data;
        return data.map((datum)=>{
            const value = datum[categoryKey];
            return typeof value === "string" ? {
                ...datum,
                [categoryKey]: convertTime2 ? convertTime2(value) : (0, $437b23f6a393c3bf$export$26ded2d88c01b527)(value)
            } : datum;
        });
    }
    crossFilteringReset() {
        this.crossFilteringSelectedPoints = [];
        this.crossFilteringAllPoints.clear();
    }
    crossFilteringPointSelected(point) {
        return this.crossFilteringSelectedPoints.length == 0 || this.crossFilteringSelectedPoints.includes(point);
    }
    crossFilteringDeselectedPoints() {
        return this.crossFilteringSelectedPoints.length > 0 && this.crossFilteringAllPoints.size !== this.crossFilteringSelectedPoints.length;
    }
    extractLineAreaCrossFilterSeries(series, params) {
        const [category] = params.categories;
        const getYKey = (yKey)=>{
            if (this.standaloneChartType === "area") {
                const lastSelectedChartId = params.getCrossFilteringContext().lastSelectedChartId;
                return lastSelectedChartId === params.chartId ? yKey + "-total" : yKey;
            }
            return yKey + "-total";
        };
        return series.map((s2)=>{
            s2.yKey = getYKey(s2.yKey);
            s2.listeners = {
                seriesNodeClick: (e)=>{
                    const value = e.datum[s2.xKey];
                    const multiSelection = e.event.metaKey || e.event.ctrlKey;
                    this.crossFilteringAddSelectedPoint(multiSelection, value);
                    this.crossFilterCallback(e);
                }
            };
            s2.marker = {
                itemStyler: (p)=>{
                    const value = p.datum[category.id];
                    const highlighted = p.highlightState === "highlighted-item";
                    return {
                        fill: highlighted ? "yellow" : p.fill,
                        size: highlighted ? 14 : this.crossFilteringPointSelected(value) ? 8 : 0
                    };
                }
            };
            if (this.standaloneChartType === "area") s2.fillOpacity = this.crossFilteringDeselectedPoints() ? 0.3 : 1;
            if (this.standaloneChartType === "line") s2.strokeOpacity = this.crossFilteringDeselectedPoints() ? 0.3 : 1;
            return s2;
        });
    }
    getCrossFilterData(params) {
        this.crossFilteringAllPoints.clear();
        const [category] = params.categories;
        const colId = params.fields[0].colId;
        const filteredOutColId = `${colId}-filtered-out`;
        const lastSelectedChartId = params.getCrossFilteringContext().lastSelectedChartId;
        return params.data.map((d)=>{
            const value = d[category.id];
            this.crossFilteringAllPoints.add(value);
            const pointSelected = this.crossFilteringPointSelected(value);
            if (this.standaloneChartType === "area" && lastSelectedChartId === params.chartId) d[`${colId}-total`] = pointSelected ? d[colId] : d[colId] + d[filteredOutColId];
            if (this.standaloneChartType === "line") d[`${colId}-total`] = pointSelected ? d[colId] : d[colId] + d[filteredOutColId];
            return d;
        });
    }
    crossFilteringAddSelectedPoint(multiSelection, value) {
        multiSelection ? this.crossFilteringSelectedPoints.push(value) : this.crossFilteringSelectedPoints = [
            value
        ];
    }
    isHorizontal(commonChartOptions) {
        const seriesType = this.standaloneChartType;
        if (seriesType !== "waterfall" && seriesType !== "box-plot" && seriesType !== "range-bar") return false;
        const theme = commonChartOptions.theme;
        const isHorizontal = (theme2)=>{
            const direction = theme2?.overrides?.[seriesType]?.series?.direction;
            if (direction != null) return direction === "horizontal";
            if (typeof theme2?.baseTheme === "object") return isHorizontal(theme2.baseTheme);
            return false;
        };
        return isHorizontal(theme);
    }
    getSeriesChartThemeDefaults() {
        return {
            series: {
                highlight: $5b7ccabde48fae90$var$getSeriesHighlight(this.crossFiltering)
            }
        };
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/histogramChartProxy.ts
var $5b7ccabde48fae90$var$HistogramChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getSeries(params) {
        const firstField = params.fields[0];
        return [
            {
                type: this.standaloneChartType,
                xKey: firstField.colId,
                xName: firstField.displayName,
                yName: this.chartProxyParams.translate("histogramFrequency"),
                areaPlot: false
            }
        ];
    }
    getAxes(_params) {
        return {
            x: {
                type: "number",
                position: "bottom"
            },
            y: {
                type: "number",
                position: "left"
            }
        };
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/waterfallChartProxy.ts
var $5b7ccabde48fae90$var$WaterfallChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params, commonChartOptions) {
        const isHorizontal = this.isHorizontal(commonChartOptions);
        const crossAxis = isHorizontal ? "y" : "x";
        const valueAxis = isHorizontal ? "x" : "y";
        return {
            [crossAxis]: {
                type: this.getXAxisType(params),
                position: isHorizontal ? "left" : "bottom"
            },
            [valueAxis]: {
                type: "number",
                position: isHorizontal ? "bottom" : "left"
            }
        };
    }
    getSeries(params) {
        const [category] = params.categories;
        const [firstField] = params.fields;
        const firstSeries = {
            type: this.standaloneChartType,
            xKey: category.id,
            xName: category.name,
            yKey: firstField.colId,
            yName: firstField.displayName ?? void 0
        };
        return [
            firstSeries
        ];
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/funnel/funnelChartProxy.ts
var $5b7ccabde48fae90$var$FunnelChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    getUpdateOptions(params, commonChartOptions) {
        return {
            ...commonChartOptions,
            data: this.transformFunnelCategories(params),
            series: this.getSeries(params)
        };
    }
    transformFunnelCategories(params) {
        const { data: data } = params;
        const [{ id: id }] = params.categories;
        return data.map((d, index)=>({
                ...d,
                [id]: {
                    name: d[id],
                    id: index,
                    toString: ()=>String(d[id])
                }
            }));
    }
    getSeriesChartThemeDefaults() {
        const config = {
            crosshair: {
                enabled: false
            }
        };
        return {
            zoom: {
                enabled: false
            },
            ...this.chartType !== "pyramid" && {
                axes: {
                    category: config,
                    number: config
                }
            }
        };
    }
    getSeries(params) {
        const [{ id: id }] = params.categories;
        const [{ colId: colId }] = params.fields;
        const series = {
            type: this.standaloneChartType,
            stageKey: id,
            valueKey: colId
        };
        return [
            series
        ];
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/hierarchical/hierarchicalChartUtils.ts
var $5b7ccabde48fae90$var$CATEGORY_LABEL_KEY = "AG-GRID-DEFAULT-LABEL-KEY";
function $5b7ccabde48fae90$var$createCategoryHierarchy(data, categoryKeys) {
    const hierarchy = $5b7ccabde48fae90$var$buildNestedHierarchy(data, getItemDepth, getItemCategoryLabel);
    return $5b7ccabde48fae90$var$formatCategoryHierarchy(hierarchy);
    function getItemDepth(_item) {
        return categoryKeys.length;
    }
    function getItemCategoryLabel(item, categoryIndex) {
        const categoryKey = categoryKeys[categoryIndex];
        const categoryValue = item[categoryKey];
        return getCategoryLabel(categoryValue);
    }
    function getCategoryLabel(value) {
        if (value == null) return null;
        return String(value);
    }
}
function $5b7ccabde48fae90$var$createAutoGroupHierarchy(data, getItemLabels) {
    const hierarchy = $5b7ccabde48fae90$var$buildNestedHierarchy(data, getItemDepth, getItemGroupLabel);
    return $5b7ccabde48fae90$var$formatCategoryHierarchy(hierarchy);
    function getItemDepth(item) {
        return getItemLabels(item)?.length ?? 0;
    }
    function getItemGroupLabel(item, groupIndex) {
        const labels2 = getItemLabels(item);
        return labels2 ? labels2[groupIndex] : labels2;
    }
}
function $5b7ccabde48fae90$var$formatCategoryHierarchy(hierarchy, key = null, isChild) {
    const { depth: depth, rootValues: rootValues, value: value, children: inputChildren } = hierarchy;
    if (rootValues) return rootValues.map((item)=>({
            [$5b7ccabde48fae90$var$CATEGORY_LABEL_KEY]: key,
            ...item
        }));
    else if (depth === 0) return [
        {
            [$5b7ccabde48fae90$var$CATEGORY_LABEL_KEY]: key,
            ...value
        }
    ];
    const children = [];
    for (const [childKey, childHierarchy] of inputChildren.entries())children.push(...$5b7ccabde48fae90$var$formatCategoryHierarchy(childHierarchy, childKey, true));
    return isChild ? [
        {
            [$5b7ccabde48fae90$var$CATEGORY_LABEL_KEY]: key,
            children: children,
            ...value ?? {}
        }
    ] : children;
}
function $5b7ccabde48fae90$var$buildNestedHierarchy(data, getItemDepth, getItemGroupKey) {
    const hierarchy = {
        depth: 0,
        children: /* @__PURE__ */ new Map()
    };
    for (const item of data){
        const itemDepth = getItemDepth(item);
        createNestedItemHierarchy(item, itemDepth, getItemGroupKey, 0, hierarchy);
    }
    return hierarchy;
    function createNestedItemHierarchy(item, itemDepth, getItemGroupKey2, currentDepth, hierarchy2) {
        if (currentDepth === itemDepth) {
            if (currentDepth === 0) {
                if (!hierarchy2.rootValues) hierarchy2.rootValues = [];
                hierarchy2.rootValues.push(item);
            } else hierarchy2.value = item;
            return hierarchy2;
        } else {
            const key = getItemGroupKey2(item, currentDepth);
            const existingChildHierarchy = hierarchy2.children.get(key);
            const childHierarchy = createNestedItemHierarchy(item, itemDepth, getItemGroupKey2, currentDepth + 1, existingChildHierarchy || {
                depth: 0,
                children: /* @__PURE__ */ new Map()
            });
            hierarchy2.children.set(key, childHierarchy);
            hierarchy2.depth = Math.max(1 + childHierarchy.depth, hierarchy2.depth);
            return hierarchy2;
        }
    }
}
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/hierarchical/hierarchicalChartProxy.ts
var $5b7ccabde48fae90$var$HierarchicalChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    getUpdateOptions(params, commonChartOptions) {
        const { fields: fields } = params;
        const [sizeField, colorField] = fields;
        return {
            ...commonChartOptions,
            series: this.getSeries(sizeField, colorField),
            data: this.getData(params, sizeField, colorField)
        };
    }
    getSeriesChartThemeDefaults() {
        return {
            gradientLegend: {
                gradient: {
                    preferredLength: 200
                },
                position: "right"
            }
        };
    }
    getSeries(sizeField, colorField) {
        return [
            {
                type: this.standaloneChartType,
                labelKey: $5b7ccabde48fae90$var$CATEGORY_LABEL_KEY,
                // Size and color fields are inferred from the range data
                sizeKey: sizeField?.colId,
                sizeName: sizeField?.displayName ?? void 0,
                colorKey: colorField?.colId,
                colorName: colorField?.displayName ?? void 0
            }
        ];
    }
    getData(params, sizeField, colorField) {
        const { categories: categories, data: data, groupData: groupData, grouping: isGrouped } = params;
        if (isGrouped) {
            const processedData = colorField ? data.concat(groupData?.map((groupDatum)=>{
                const newDatum = {
                    ...groupDatum
                };
                delete newDatum[sizeField.colId];
                return newDatum;
            }) ?? []) : data;
            return $5b7ccabde48fae90$var$createAutoGroupHierarchy(processedData, (item)=>item[0, $437b23f6a393c3bf$export$a7016588c430dba6]?.value ?? null);
        } else {
            const categoryKeys = categories.map(({ id: id })=>id);
            return $5b7ccabde48fae90$var$createCategoryHierarchy(data, categoryKeys);
        }
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/polar/polarChartProxy.ts
var $5b7ccabde48fae90$var$PolarChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    getAxes(_) {
        const radialBar = this.standaloneChartType === "radial-bar";
        return {
            angle: {
                type: radialBar ? "angle-number" : "angle-category"
            },
            radius: {
                type: radialBar ? "radius-category" : "radius-number"
            }
        };
    }
    getSeries(params) {
        const { fields: fields, categories: categories, seriesGroupType: seriesGroupType } = params;
        const [category] = categories;
        const radialBar = this.standaloneChartType === "radial-bar";
        const seriesGroupTypeOptions = this.getSeriesGroupTypeOptions(seriesGroupType);
        return fields.map((f)=>{
            return {
                type: this.standaloneChartType,
                angleKey: radialBar ? f.colId : category.id,
                angleName: radialBar ? f.displayName ?? void 0 : category.name,
                radiusKey: radialBar ? category.id : f.colId,
                radiusName: radialBar ? category.name : f.displayName ?? void 0,
                ...seriesGroupTypeOptions
            };
        });
    }
    getSeriesGroupType() {
        const standaloneChartType = this.standaloneChartType;
        if (![
            "nightingale",
            "radial-bar",
            "radial-column"
        ].includes(standaloneChartType)) return void 0;
        const firstSeriesProperties = this.getChart().series?.[0]?.properties.toJson();
        const getStackedValue = ()=>firstSeriesProperties.normalizedTo ? "normalized" : "stacked";
        if (standaloneChartType === "nightingale") return firstSeriesProperties.grouped ? "grouped" : getStackedValue();
        else return firstSeriesProperties.stacked ? getStackedValue() : "grouped";
    }
    getUpdateOptions(params, commonChartOptions) {
        const axes = this.getAxes(params);
        return {
            ...commonChartOptions,
            data: this.getData(params, axes),
            axes: axes,
            series: this.getSeries(params)
        };
    }
    getData(params, axes) {
        const isCategoryAxis = axes.angle.type === "angle-category" || axes.radius.type === "radius-category";
        if (isCategoryAxis) {
            const [category] = params.categories;
            return this.transformCategoryData(params.data, category.id);
        } else return params.data;
    }
    getSeriesGroupTypeOptions(seriesGroupType) {
        if (!seriesGroupType) return {};
        return {
            grouped: seriesGroupType === "grouped" || void 0,
            stacked: seriesGroupType !== "grouped" || void 0,
            normalizedTo: seriesGroupType === "normalized" ? 100 : void 0
        };
    }
    getSeriesChartThemeDefaults() {
        return {
            series: {
                highlight: $5b7ccabde48fae90$var$getSeriesHighlight(this.crossFiltering)
            }
        };
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/specialized/heatmapChartProxy.ts
var $5b7ccabde48fae90$var$HEATMAP_CATEGORY_KEY = "AG-GRID-DEFAULT-HEATMAP-CATEGORY-KEY";
var $5b7ccabde48fae90$var$HEATMAP_SERIES_KEY = "AG-GRID-DEFAULT-HEATMAP-SERIES-KEY";
var $5b7ccabde48fae90$var$HEATMAP_VALUE_KEY = "AG-GRID-DEFAULT-HEATMAP-VALUE-KEY";
function $5b7ccabde48fae90$var$flatMap(items, iteratee) {
    return items.reduce((acc, item, index, array)=>acc.concat(iteratee(item, index, array)), new Array());
}
var $5b7ccabde48fae90$var$HeatmapChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    getUpdateOptions(params, commonChartOptions) {
        const xSeriesKey = $5b7ccabde48fae90$var$HEATMAP_SERIES_KEY;
        const xValueKey = $5b7ccabde48fae90$var$HEATMAP_VALUE_KEY;
        const yKey = $5b7ccabde48fae90$var$HEATMAP_CATEGORY_KEY;
        return {
            ...commonChartOptions,
            series: this.getSeries(params, xSeriesKey, xValueKey, yKey),
            data: this.getData(params, xSeriesKey, xValueKey, yKey)
        };
    }
    getSeries(params, xSeriesKey, xValueKey, yKey) {
        const [category] = params.categories;
        return [
            {
                type: this.standaloneChartType,
                yKey: // The axis keys reference synthetic fields based on the category values and series column names
                yKey,
                xKey: xSeriesKey,
                // The color key references a synthetic field based on the series column value for a specific cell
                colorKey: xValueKey,
                yName: category.name,
                // We don't know how to label the 'x' series, as it is a synthetic series created from the set of all input columns
                // In future releases we may want to consider inferring the series label from column groupings etc
                xName: void 0,
                colorName: void 0
            }
        ];
    }
    getData(params, xSeriesKey, xValueKey, yKey) {
        const [category] = params.categories;
        return $5b7ccabde48fae90$var$flatMap(params.data, (datum, index)=>{
            const value = datum[category.id];
            const valueString = value == null ? "" : String(value);
            const yValue = {
                id: index,
                value: value,
                toString: ()=>valueString
            };
            return params.fields.map(({ colId: colId, displayName: displayName })=>({
                    ...datum,
                    [xSeriesKey]: displayName,
                    [xValueKey]: datum[colId],
                    [yKey]: yValue
                }));
        });
    }
    getSeriesChartThemeDefaults() {
        return {
            gradientLegend: {
                gradient: {
                    preferredLength: 200
                },
                position: "right"
            },
            series: {
                tooltip: {
                    renderer: $5b7ccabde48fae90$var$renderHeatmapTooltip
                }
            }
        };
    }
};
function $5b7ccabde48fae90$var$renderHeatmapTooltip(params) {
    const { xKey: xKey, yKey: yKey, colorKey: colorKey, yName: yName, datum: datum } = params;
    const table = [
        {
            label: yName,
            value: datum[yKey]
        },
        {
            label: datum[xKey],
            value: colorKey && datum[colorKey]
        }
    ];
    return {
        title: "",
        data: table.map(({ label: label, value: value })=>({
                label: String(label),
                value: String(value)
            }))
    };
}
var $5b7ccabde48fae90$var$ChartDatasource = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    wireBeans(beans) {
        this.sortSvc = beans.sortSvc;
        this.gridRowModel = beans.rowModel;
        this.colModel = beans.colModel;
        this.valueSvc = beans.valueSvc;
        this.pivotResultCols = beans.pivotResultCols;
        this.rowNodeSorter = beans.rowNodeSorter;
    }
    getData(params) {
        if (params.crossFiltering) {
            if (params.grouping) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(141);
                return {
                    chartData: [],
                    colNames: {}
                };
            }
            if (!(0, $437b23f6a393c3bf$export$9f182d9ca737e15)(this.gos)) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(142);
                return {
                    chartData: [],
                    colNames: {}
                };
            }
        }
        const isServerSide = (0, $437b23f6a393c3bf$export$cf1bac0013650216)(this.gos);
        if (isServerSide && params.pivoting) this.updatePivotKeysForSSRM();
        const result = this.extractRowsFromGridRowModel(params);
        result.chartData = this.aggregateRowsByDimension(params, result.chartData);
        return result;
    }
    extractRowsFromGridRowModel(params) {
        const { crossFiltering: crossFiltering, startRow: startRow, endRow: endRow, valueCols: valueCols, dimensionCols: dimensionCols, grouping: grouping, crossFilteringSort: crossFilteringSort, combineGroupValues: combineGroupValues } = params;
        let extractedRowData = [];
        const colNames = {};
        const groupNodeIndexes = {};
        const groupsToRemove = {};
        let filteredNodes = {};
        let allRowNodes = [];
        let numRows;
        if (crossFiltering) {
            filteredNodes = this.getFilteredRowNodes();
            allRowNodes = this.getAllRowNodes(crossFilteringSort);
            numRows = allRowNodes.length;
        } else {
            const modelLastRow = this.gridRowModel.getRowCount() - 1;
            const hasNoRange = startRow === endRow && startRow === 0 && dimensionCols.length === 0 && valueCols.length === 0;
            if (hasNoRange) numRows = 0;
            else {
                const rangeLastRow = endRow >= 0 ? Math.min(endRow, modelLastRow) : modelLastRow;
                numRows = rangeLastRow - startRow + 1;
            }
        }
        if (numRows > 0) for (const col of valueCols){
            let colNamesArr = [];
            const pivotKeys = col.getColDef().pivotKeys;
            if (pivotKeys) colNamesArr = pivotKeys.slice();
            const headerName = col.getColDef().headerName;
            if (headerName) colNamesArr.push(headerName);
            if (colNamesArr.length > 0) colNames[col.getId()] = colNamesArr;
        }
        let numRemovedNodes = 0;
        let id = 0;
        const groupingCache = {};
        for(let i = 0; i < numRows; i++){
            const rowNode = crossFiltering ? allRowNodes[i] : this.gridRowModel.getRow(i + startRow);
            if (rowNode.footer || rowNode.detail) {
                numRemovedNodes++;
                continue;
            }
            const data = {
                node: rowNode
            };
            for (const col of dimensionCols){
                const colId = col.colId;
                const column = this.colModel.getCol(colId);
                if (column) {
                    const valueObject = this.valueSvc.getValue(column, rowNode);
                    if (grouping) {
                        const valueString = valueObject?.toString ? String(valueObject.toString()) : " ";
                        const labels2 = this.getGroupLabels(rowNode, valueString);
                        const value = labels2.slice().reverse();
                        let groupingValue = {
                            value: value,
                            // this is needed so that standalone can handle animations properly when data updates
                            id: id++,
                            toString: ()=>value.filter(Boolean).join(" - ")
                        };
                        if (combineGroupValues) {
                            const groupingKey = groupingValue.toString();
                            const cachedGroupingValue = groupingCache[groupingKey];
                            if (cachedGroupingValue) groupingValue = cachedGroupingValue;
                            else groupingCache[groupingKey] = groupingValue;
                        }
                        data[colId] = groupingValue;
                        if (rowNode.group) groupNodeIndexes[labels2.toString()] = i - numRemovedNodes;
                        const groupKey = labels2.slice(1, labels2.length).toString();
                        if (groupKey) groupsToRemove[groupKey] = groupNodeIndexes[groupKey];
                    } else data[colId] = valueObject;
                } else data[$5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY] = i + 1;
            }
            for (const col of valueCols){
                const colId = col.getColId();
                if (crossFiltering) {
                    const filteredOutColId = colId + "-filtered-out";
                    const value = this.valueSvc.getValue(col, rowNode);
                    let actualValue = value;
                    if (value != null) {
                        if (typeof value.toNumber === "function") actualValue = value.toNumber();
                        else if (typeof value.value === "number") actualValue = value.value;
                    }
                    if (filteredNodes[rowNode.id]) {
                        data[colId] = actualValue;
                        data[filteredOutColId] = params.aggFunc || params.isScatter ? void 0 : 0;
                    } else {
                        data[colId] = params.aggFunc || params.isScatter ? void 0 : 0;
                        data[filteredOutColId] = actualValue;
                    }
                } else {
                    let value = this.valueSvc.getValue(col, rowNode);
                    if (value && typeof value.value === "number") value = value.value;
                    if (value && Object.prototype.hasOwnProperty.call(value, "toString")) value = parseFloat(value.toString());
                    data[colId] = value != null && typeof value.toNumber === "function" ? value.toNumber() : value;
                }
            }
            extractedRowData.push(data);
        }
        let groupChartData;
        if (grouping) {
            const groupIndexesToRemove = Object.values(groupsToRemove);
            const allData = extractedRowData;
            extractedRowData = [];
            groupChartData = [];
            for(let i = 0; i < allData.length; i++)(groupIndexesToRemove.includes(i) ? groupChartData : extractedRowData).push(allData[i]);
        }
        return {
            chartData: extractedRowData,
            colNames: colNames,
            groupChartData: groupChartData
        };
    }
    aggregateRowsByDimension(params, dataFromGrid) {
        const dimensionCols = params.dimensionCols;
        if (!params.aggFunc || dimensionCols.length === 0) return dataFromGrid;
        const lastCol = (0, $437b23f6a393c3bf$export$236389741107357f)(dimensionCols);
        const lastColId = lastCol?.colId;
        const map = {};
        const dataAggregated = [];
        for (const data of dataFromGrid){
            let currentMap = map;
            for (const col of dimensionCols){
                const colId = col.colId;
                const key = data[colId];
                if (colId === lastColId) {
                    let groupItem = currentMap[key];
                    if (!groupItem) {
                        groupItem = {
                            __children: []
                        };
                        for (const dimCol of dimensionCols){
                            const dimColId = dimCol.colId;
                            groupItem[dimColId] = data[dimColId];
                        }
                        currentMap[key] = groupItem;
                        dataAggregated.push(groupItem);
                    }
                    groupItem.__children.push(data);
                } else {
                    if (!currentMap[key]) currentMap[key] = {};
                    currentMap = currentMap[key];
                }
            }
        }
        if (this.gos.assertModuleRegistered("SharedAggregation", 1)) {
            for (const groupItem of dataAggregated)for (const col of params.valueCols){
                const colId = col.getColId();
                if (params.crossFiltering) {
                    const dataToAgg = groupItem.__children.filter((child)=>typeof child[colId] !== "undefined").map((child)=>child[colId]);
                    const aggResult = $5b7ccabde48fae90$var$_aggregateValues(this.beans, dataToAgg, params.aggFunc, col);
                    groupItem[colId] = aggResult && typeof aggResult.value !== "undefined" ? aggResult.value : aggResult;
                    const filteredOutColId = `${colId}-filtered-out`;
                    const dataToAggFiltered = groupItem.__children.filter((child)=>typeof child[filteredOutColId] !== "undefined").map((child)=>child[filteredOutColId]);
                    const aggResultFiltered = $5b7ccabde48fae90$var$_aggregateValues(this.beans, dataToAggFiltered, params.aggFunc, col);
                    groupItem[filteredOutColId] = aggResultFiltered && typeof aggResultFiltered.value !== "undefined" ? aggResultFiltered.value : aggResultFiltered;
                } else {
                    const dataToAgg = groupItem.__children.map((child)=>child[colId]);
                    const aggResult = $5b7ccabde48fae90$var$_aggregateValues(this.beans, dataToAgg, params.aggFunc, col);
                    groupItem[colId] = aggResult && typeof aggResult.value !== "undefined" ? aggResult.value : aggResult;
                }
            }
        }
        return dataAggregated;
    }
    updatePivotKeysForSSRM() {
        const secondaryColumns = this.pivotResultCols?.getPivotResultCols()?.list;
        if (!secondaryColumns) return;
        const pivotKeySeparator = this.extractPivotKeySeparator(secondaryColumns);
        for (const col of secondaryColumns)if (pivotKeySeparator === "") col.getColDef().pivotKeys = [];
        else {
            const keys = col.getColId().split(pivotKeySeparator);
            col.getColDef().pivotKeys = keys.slice(0, keys.length - 1);
        }
    }
    extractPivotKeySeparator(secondaryColumns) {
        if (secondaryColumns.length === 0) return "";
        const extractSeparator = (columnGroup, childId)=>{
            const groupId = columnGroup.getGroupId();
            if (!columnGroup.getParent()) return childId.split(groupId)[1][0];
            return extractSeparator(columnGroup.getParent(), groupId);
        };
        const firstSecondaryCol = secondaryColumns[0];
        if (firstSecondaryCol.getParent() == null) return "";
        return extractSeparator(firstSecondaryCol.getParent(), firstSecondaryCol.getColId());
    }
    getGroupLabels(rowNode, initialLabel) {
        const labels2 = [
            initialLabel
        ];
        while(rowNode && rowNode.level !== 0){
            rowNode = rowNode.parent;
            if (rowNode) {
                if (rowNode.group) {
                    const groupColumn = this.colModel.getCol((0, $437b23f6a393c3bf$export$a7016588c430dba6));
                    if (groupColumn) {
                        const valueObject = this.valueSvc.getValue(groupColumn, rowNode);
                        const valueString = valueObject?.toString ? String(valueObject.toString()) : " ";
                        labels2.push(valueString);
                    }
                } else labels2.push(rowNode.key);
            }
        }
        return labels2;
    }
    /** cross filtering only */ getFilteredRowNodes() {
        const filteredNodes = {};
        this.gridRowModel.forEachNodeAfterFilterAndSort((rowNode)=>{
            filteredNodes[rowNode.id] = rowNode;
        });
        return filteredNodes;
    }
    /** cross filtering only */ getAllRowNodes(sortModel) {
        const allRowNodes = [];
        this.gridRowModel.forEachNode((rowNode)=>{
            allRowNodes.push(rowNode);
        });
        const rowNodeSorter = this.rowNodeSorter;
        if (!rowNodeSorter) return allRowNodes;
        const sortOptions = sortModel === true ? this.sortSvc?.getSortOptions() : sortModel;
        if (!sortOptions || sortOptions.length == 0) return allRowNodes;
        return rowNodeSorter.doFullSortInPlace(allRowNodes, sortOptions);
    }
};
var $5b7ccabde48fae90$var$ChartColumnService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.valueColsWithoutSeriesType = /* @__PURE__ */ new Set();
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.colNames = beans.colNames;
        this.valueSvc = beans.valueSvc;
    }
    postConstruct() {
        const clearValueCols = ()=>this.valueColsWithoutSeriesType.clear();
        this.addManagedEventListeners({
            newColumnsLoaded: clearValueCols,
            rowDataUpdated: clearValueCols
        });
    }
    getColumn(colId) {
        return this.colModel.getColDefCol(colId);
    }
    getAllDisplayedColumns() {
        return this.beans.visibleCols.allCols;
    }
    getColDisplayName(col) {
        return this.colNames.getDisplayNameForColumn(col, "chart");
    }
    getColGroupDisplayName(colGroup) {
        return this.colNames.getDisplayNameForColumnGroup(colGroup, "chart");
    }
    getRowGroupColumns() {
        return this.beans.rowGroupColsSvc?.columns ?? [];
    }
    getGroupDisplayColumns() {
        return this.beans.showRowGroupCols?.columns ?? [];
    }
    isPivotMode() {
        return this.colModel.isPivotMode();
    }
    isPivotActive() {
        return this.colModel.isPivotActive();
    }
    getChartColumns() {
        const gridCols = this.colModel.getCols();
        const dimensionCols = /* @__PURE__ */ new Set();
        const valueCols = /* @__PURE__ */ new Set();
        for (const col of gridCols){
            const colDef = col.getColDef();
            const chartDataType = colDef.chartDataType;
            if (chartDataType) switch(chartDataType){
                case "category":
                case "time":
                    dimensionCols.add(col);
                    continue;
                case "series":
                    valueCols.add(col);
                    continue;
                case "excluded":
                    continue;
                default:
                    (0, $437b23f6a393c3bf$export$545083624300f13d)(153, {
                        chartDataType: chartDataType
                    });
                    break;
            }
            if (colDef.colId === "ag-Grid-AutoColumn") {
                dimensionCols.add(col);
                continue;
            }
            if (!col.isPrimary()) {
                valueCols.add(col);
                continue;
            }
            (this.isInferredValueCol(col) ? valueCols : dimensionCols).add(col);
        }
        return {
            dimensionCols: dimensionCols,
            valueCols: valueCols
        };
    }
    isInferredValueCol(col) {
        const colId = col.getColId();
        if (colId === "ag-Grid-AutoColumn") return false;
        const row = (0, $437b23f6a393c3bf$export$d4675a60917db7b0)(this.beans, {
            rowIndex: 0,
            rowPinned: null
        });
        if (!row) return this.valueColsWithoutSeriesType.has(colId);
        let cellValue = this.valueSvc.getValue(col, row);
        if (cellValue == null) cellValue = this.extractLeafData(row, col);
        if (cellValue != null) {
            if (typeof cellValue.toNumber === "function") cellValue = cellValue.toNumber();
            else if (typeof cellValue.value === "number") cellValue = cellValue.value;
        }
        const isNumber = typeof cellValue === "number" || col.colDef.cellDataType === "number" || [
            "series",
            "time"
        ].includes(col.colDef.chartDataType);
        if (isNumber) this.valueColsWithoutSeriesType.add(colId);
        else if (cellValue == null && col.colDef.cellDataType !== "number") (0, $437b23f6a393c3bf$export$545083624300f13d)(265, {
            colId: colId
        });
        return isNumber;
    }
    extractLeafData(row, col) {
        const value = row.data && this.valueSvc.getValue(col, row);
        if (value != null) return value;
        const childrenAfterGroup = row.childrenAfterGroup;
        if (childrenAfterGroup) for(let i = 0, len = childrenAfterGroup.length; i < len; ++i){
            const child = childrenAfterGroup[i];
            const result = this.extractLeafData(child, col);
            if (result != null) return result;
        }
        return null;
    }
    destroy() {
        this.valueColsWithoutSeriesType.clear();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$SUPPORTED_COMBO_CHART_TYPES = /* @__PURE__ */ new Set([
    "line",
    "groupedColumn",
    "stackedColumn",
    "area",
    "stackedArea"
]);
var $5b7ccabde48fae90$var$ComboChartModel = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(chartDataModel){
        super();
        // this control flag is used to only log warning for the initial user config
        this.suppressComboChartWarnings = false;
        this.chartDataModel = chartDataModel;
        this.seriesChartTypes = chartDataModel.params.seriesChartTypes ?? [];
    }
    postConstruct() {
        this.initComboCharts();
    }
    update(seriesChartTypes) {
        this.seriesChartTypes = seriesChartTypes ?? this.seriesChartTypes;
        this.initComboCharts();
        this.updateSeriesChartTypes();
    }
    initComboCharts() {
        const seriesChartTypesExist = this.seriesChartTypes && this.seriesChartTypes.length > 0;
        const customCombo = this.chartDataModel.chartType === "customCombo" || seriesChartTypesExist;
        if (customCombo) {
            this.chartDataModel.chartType = "customCombo";
            this.savedCustomSeriesChartTypes = this.seriesChartTypes || [];
        }
    }
    updateSeriesChartTypes() {
        if (!this.chartDataModel.isComboChart()) return;
        this.seriesChartTypes = this.seriesChartTypes.map((seriesChartType)=>{
            const primaryOnly = [
                "groupedColumn",
                "stackedColumn",
                "stackedArea"
            ].includes(seriesChartType.chartType);
            seriesChartType.secondaryAxis = primaryOnly ? false : seriesChartType.secondaryAxis;
            return seriesChartType;
        });
        if (this.chartDataModel.chartType === "customCombo") {
            this.updateSeriesChartTypesForCustomCombo();
            return;
        }
        this.updateChartSeriesTypesForBuiltInCombos();
    }
    updateSeriesChartTypesForCustomCombo() {
        const seriesChartTypesSupplied = this.seriesChartTypes && this.seriesChartTypes.length > 0;
        if (!seriesChartTypesSupplied && !this.suppressComboChartWarnings) (0, $437b23f6a393c3bf$export$545083624300f13d)(150);
        this.seriesChartTypes = this.seriesChartTypes.map((s2)=>{
            if (!$5b7ccabde48fae90$var$SUPPORTED_COMBO_CHART_TYPES.has(s2.chartType)) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(151, {
                    chartType: s2.chartType
                });
                s2.chartType = "line";
            }
            return s2;
        });
        const getSeriesChartType = (valueCol)=>{
            if (!this.savedCustomSeriesChartTypes || this.savedCustomSeriesChartTypes.length === 0) this.savedCustomSeriesChartTypes = this.seriesChartTypes;
            const providedSeriesChartType = this.savedCustomSeriesChartTypes.find((s2)=>s2.colId === valueCol.colId);
            if (!providedSeriesChartType) {
                if (valueCol.selected && !this.suppressComboChartWarnings) (0, $437b23f6a393c3bf$export$545083624300f13d)(152, {
                    colId: valueCol.colId
                });
                return {
                    colId: valueCol.colId,
                    chartType: "line",
                    secondaryAxis: false
                };
            }
            return providedSeriesChartType;
        };
        const updatedSeriesChartTypes = this.chartDataModel.valueColState.map(getSeriesChartType);
        this.seriesChartTypes = updatedSeriesChartTypes;
        this.savedCustomSeriesChartTypes = updatedSeriesChartTypes;
        this.suppressComboChartWarnings = true;
    }
    updateChartSeriesTypesForBuiltInCombos() {
        const { chartType: chartType, valueColState: valueColState } = this.chartDataModel;
        const primaryChartType = chartType === "columnLineCombo" ? "groupedColumn" : "stackedArea";
        const secondaryChartType = chartType === "columnLineCombo" ? "line" : "groupedColumn";
        const selectedCols = valueColState.filter((cs)=>cs.selected);
        const lineIndex = Math.ceil(selectedCols.length / 2);
        this.seriesChartTypes = selectedCols.map((valueCol, i)=>{
            const seriesType = i >= lineIndex ? secondaryChartType : primaryChartType;
            return {
                colId: valueCol.colId,
                chartType: seriesType,
                secondaryAxis: false
            };
        });
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/model/chartDataModel.ts
var $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY = "AG-GRID-DEFAULT-CATEGORY";
var $5b7ccabde48fae90$var$ChartDataModel = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(params){
        super();
        this.unlinked = false;
        this.chartData = [];
        this.valueColState = [];
        this.dimensionColState = [];
        this.colNames = {};
        this.crossFiltering = false;
        this.crossFilteringSort = true;
        this.grouping = false;
        this.useGroupColumnAsCategory = false;
        this.params = params;
        this.chartId = params.chartId;
        this.setParams(params);
    }
    wireBeans(beans) {
        this.rangeSvc = beans.rangeSvc;
        this.chartTranslation = beans.chartTranslation;
    }
    setParams(params) {
        const { chartType: chartType, pivotChart: pivotChart, chartThemeName: chartThemeName, switchCategorySeries: switchCategorySeries, aggFunc: aggFunc, cellRange: cellRange, suppressChartRanges: suppressChartRanges, unlinkChart: unlinkChart, crossFiltering: crossFiltering, crossFilteringSort: crossFilteringSort, seriesGroupType: seriesGroupType, useGroupColumnAsCategory: useGroupColumnAsCategory } = params;
        this.chartType = chartType;
        this.pivotChart = pivotChart ?? false;
        this.chartThemeName = chartThemeName;
        this.switchCategorySeries = !!switchCategorySeries;
        this.aggFunc = aggFunc;
        this.referenceCellRange = cellRange;
        this.suppliedCellRange = cellRange;
        this.suppressChartRanges = suppressChartRanges ?? false;
        this.unlinked = !!unlinkChart;
        this.crossFiltering = !!crossFiltering;
        this.crossFilteringSort = crossFilteringSort ?? true;
        this.seriesGroupType = seriesGroupType;
        this.useGroupColumnAsCategory = !!useGroupColumnAsCategory;
    }
    postConstruct() {
        this.datasource = this.createManagedBean(new $5b7ccabde48fae90$var$ChartDatasource());
        this.chartColSvc = this.createManagedBean(new $5b7ccabde48fae90$var$ChartColumnService());
        this.comboChartModel = this.createManagedBean(new $5b7ccabde48fae90$var$ComboChartModel(this));
        this.updateCellRanges({
            setColsFromRange: true
        });
        this.updateData();
    }
    updateModel(params) {
        const { cellRange: cellRange, seriesChartTypes: seriesChartTypes } = params;
        if (cellRange !== this.suppliedCellRange) {
            this.dimensionCellRange = void 0;
            this.valueCellRange = void 0;
        }
        this.setParams(params);
        this.updateSelectedDimensions(cellRange?.columns);
        this.updateCellRanges({
            setColsFromRange: true
        });
        const shouldUpdateComboModel = this.isComboChart() || seriesChartTypes;
        if (shouldUpdateComboModel) this.comboChartModel.update(seriesChartTypes);
        if (!this.unlinked) this.updateData();
    }
    updateCellRanges(params) {
        const { updatedColState: updatedColState, resetOrder: resetOrder, maintainColState: maintainColState, setColsFromRange: setColsFromRange } = params ?? {};
        if (this.valueCellRange) this.referenceCellRange = this.valueCellRange;
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartColSvc.getChartColumns();
        const allColsFromRanges = this.getAllColumnsFromRanges();
        if (updatedColState) this.updateColumnState(updatedColState, resetOrder);
        this.setDimensionCellRange(dimensionCols, allColsFromRanges, updatedColState);
        this.setValueCellRange(valueCols, allColsFromRanges, setColsFromRange);
        if (!updatedColState && !maintainColState) {
            this.resetColumnState();
            this.syncDimensionCellRange();
        }
        this.comboChartModel.updateSeriesChartTypes();
    }
    updateData() {
        const { startRow: startRow, endRow: endRow } = this.getRowIndexes();
        if (this.pivotChart) this.resetColumnState();
        this.grouping = this.isGrouping();
        const params = {
            aggFunc: this.aggFunc,
            dimensionCols: this.getSelectedDimensions(),
            grouping: this.grouping,
            pivoting: this.isPivotActive(),
            crossFiltering: this.crossFiltering,
            crossFilteringSort: this.getCrossFilteringSort(),
            valueCols: this.getSelectedValueCols(),
            startRow: startRow,
            endRow: endRow,
            isScatter: [
                "scatter",
                "bubble"
            ].includes(this.chartType),
            combineGroupValues: $5b7ccabde48fae90$var$isStatistical($5b7ccabde48fae90$var$getSeriesType(this.chartType))
        };
        const { chartData: chartData, colNames: colNames, groupChartData: groupChartData } = this.datasource.getData(params);
        this.chartData = chartData;
        this.groupChartData = groupChartData;
        this.colNames = colNames;
        this.categoryAxisType = void 0;
    }
    isGrouping() {
        const usingTreeData = this.gos.get("treeData");
        const groupedCols = usingTreeData ? null : this.chartColSvc.getRowGroupColumns();
        const isGroupActive = usingTreeData || groupedCols && groupedCols.length > 0;
        const colIds = this.getSelectedDimensions().map(({ colId: colId })=>colId);
        const displayedGroupCols = this.chartColSvc.getGroupDisplayColumns();
        const groupDimensionSelected = displayedGroupCols.map((col)=>col.getColId()).some((id)=>colIds.includes(id));
        return !!isGroupActive && groupDimensionSelected;
    }
    getSelectedValueCols() {
        return this.valueColState.filter((cs)=>cs.selected).map((cs)=>cs.column);
    }
    getSelectedDimensions() {
        return this.dimensionColState.filter((cs)=>cs.selected);
    }
    getValueColState() {
        return this.valueColState.map(this.displayNameMapper.bind(this));
    }
    displayNameMapper(col) {
        const { column: column } = col;
        if (column) {
            const columnDisplayName = this.getColDisplayName(column);
            col.displayName = this.isPivotMode() ? this.getPivotDisplayName(column, columnDisplayName) : columnDisplayName;
        } else {
            const colNames = this.colNames[col.colId];
            col.displayName = colNames ? colNames.join(" - ") : this.getColDisplayName(column);
        }
        return col;
    }
    getPivotDisplayName(column, columnDisplayName) {
        let attemptFallbackToColNames = false;
        let displayNames = [
            columnDisplayName
        ];
        const getDisplayName2 = (colGroup)=>{
            if (!colGroup) return;
            const colGroupName = this.chartColSvc.getColGroupDisplayName(colGroup);
            if (colGroupName?.length) {
                displayNames.unshift(colGroupName);
                getDisplayName2(colGroup.getParent());
            } else attemptFallbackToColNames = true;
        };
        getDisplayName2(column.getParent());
        if (attemptFallbackToColNames) {
            const colNames = this.colNames[column.getColId()];
            if (colNames) displayNames = colNames;
        }
        return displayNames.join(" - ");
    }
    getColDisplayName(col) {
        return this.chartColSvc.getColDisplayName(col);
    }
    isPivotMode() {
        return this.chartColSvc.isPivotMode();
    }
    getChartDataType(colId) {
        const column = this.chartColSvc.getColumn(colId);
        return column ? column.getColDef().chartDataType : void 0;
    }
    getConvertTime(colId) {
        const column = this.chartColSvc.getColumn(colId);
        if (column?.colDef.cellDataType === "dateString") return this.beans.dataTypeSvc?.getDateParserFunction(column);
        return void 0;
    }
    isPivotActive() {
        return this.chartColSvc.isPivotActive();
    }
    createCellRange(type, ...columns) {
        return {
            id: this.chartId,
            // set range ID to match chart ID so we can identify changes to the ranges for this chart
            startRow: this.referenceCellRange.startRow,
            endRow: this.referenceCellRange.endRow,
            columns: columns,
            startColumn: type === (0, $437b23f6a393c3bf$export$162bc75b85f28397).DIMENSION || this.referenceCellRange.startColumn == null ? columns[0] : this.referenceCellRange.startColumn,
            type: type
        };
    }
    getAllColumnsFromRanges() {
        if (this.pivotChart) return new Set(this.chartColSvc.getAllDisplayedColumns());
        const columns = this.dimensionCellRange || this.valueCellRange ? [] : this.referenceCellRange.columns;
        if (this.dimensionCellRange) columns.push(...this.dimensionCellRange.columns);
        if (this.valueCellRange) columns.push(...this.valueCellRange.columns);
        return new Set(columns);
    }
    getRowIndexes() {
        let startRow = 0, endRow = 0;
        const { rangeSvc: rangeSvc, valueCellRange: valueCellRange, dimensionCellRange: dimensionCellRange } = this;
        const cellRange = valueCellRange || dimensionCellRange;
        if (rangeSvc && cellRange) {
            startRow = rangeSvc.getRangeStartRow(cellRange).rowIndex;
            const endRowPosition = rangeSvc.getRangeEndRow(cellRange);
            endRow = endRowPosition.rowPinned === "bottom" ? -1 : endRowPosition.rowIndex;
        }
        return {
            startRow: startRow,
            endRow: endRow
        };
    }
    resetColumnState() {
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartColSvc.getChartColumns();
        const allCols = this.getAllColumnsFromRanges();
        const isInitialising = this.valueColState.length < 1;
        this.dimensionColState = [];
        this.valueColState = [];
        const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
        let hasSelectedDimension = false;
        let order = 1;
        const aggFuncDimension = this.suppliedCellRange.columns[0];
        const usingTreeData = this.gos.get("treeData");
        const rowGroupCols = usingTreeData ? null : this.chartColSvc.getRowGroupColumns();
        const groupingActive = usingTreeData || rowGroupCols && rowGroupCols.length > 0;
        dimensionCols.forEach((column)=>{
            const autoGroup = (0, $437b23f6a393c3bf$export$61b34611dc010a97)(column);
            const selected = this.crossFiltering && this.aggFunc ? aggFuncDimension.getColId() === column.getColId() : this.useGroupColumnAsCategory && groupingActive && autoGroup || (!hasSelectedDimension || supportsMultipleDimensions) && allCols.has(column);
            this.dimensionColState.push({
                column: column,
                colId: column.getColId(),
                displayName: this.getColDisplayName(column),
                selected: selected,
                order: order++
            });
            if (selected) hasSelectedDimension = true;
        });
        const defaultCategory = {
            colId: $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY,
            displayName: this.chartTranslation.translate("defaultCategory"),
            selected: !hasSelectedDimension,
            // if no dimensions in range select the default
            order: 0
        };
        this.dimensionColState.unshift(defaultCategory);
        const valueColumnsFromReferenceRange = this.referenceCellRange.columns.filter((c)=>valueCols.has(c));
        valueCols.forEach((column)=>{
            if (isInitialising && this.referenceCellRange.columns.includes(column)) column = valueColumnsFromReferenceRange.shift();
            this.valueColState.push({
                column: column,
                colId: column.getColId(),
                displayName: this.getColDisplayName(column),
                selected: allCols.has(column),
                order: order++
            });
        });
    }
    updateColumnState(updatedCol, resetOrder) {
        const idsMatch = (cs)=>cs.colId === updatedCol.colId;
        const { dimensionColState: dimensionColState, valueColState: valueColState } = this;
        const matchedDimensionColState = dimensionColState.find(idsMatch);
        const matchedValueColState = valueColState.find(idsMatch);
        if (matchedDimensionColState) {
            const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
            if (!supportsMultipleDimensions) {
                const selectedColumnState = updatedCol.selected ? matchedDimensionColState : dimensionColState.filter((cs)=>cs !== matchedDimensionColState).find(({ selected: selected })=>selected);
                dimensionColState.forEach((cs)=>cs.selected = cs === selectedColumnState);
            } else matchedDimensionColState.selected = updatedCol.selected;
        } else if (matchedValueColState) matchedValueColState.selected = updatedCol.selected;
        const allColumns = [
            ...dimensionColState,
            ...valueColState
        ];
        const orderedColIds = [];
        if (!resetOrder) {
            allColumns.forEach((col, i)=>{
                if (i === updatedCol.order) orderedColIds.push(updatedCol.colId);
                if (col.colId !== updatedCol.colId) orderedColIds.push(col.colId);
            });
            allColumns.forEach((col)=>{
                const order = orderedColIds.indexOf(col.colId);
                col.order = order >= 0 ? orderedColIds.indexOf(col.colId) : allColumns.length - 1;
            });
        }
        this.reorderColState();
    }
    reorderColState() {
        const ascColStateOrder = (a, b)=>a.order - b.order;
        this.dimensionColState.sort(ascColStateOrder);
        this.valueColState.sort(ascColStateOrder);
    }
    setDimensionCellRange(dimensionCols, colsInRange, updatedColState) {
        this.dimensionCellRange = void 0;
        const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
        if (!updatedColState && !this.dimensionColState.length) {
            const selectedCols = new Array();
            dimensionCols.forEach((col)=>{
                if (selectedCols.length > 0 && !supportsMultipleDimensions || !colsInRange.has(col)) return;
                selectedCols.push(col);
            });
            if (selectedCols.length > 0) this.dimensionCellRange = this.createCellRange((0, $437b23f6a393c3bf$export$162bc75b85f28397).DIMENSION, ...selectedCols);
            return;
        }
        let selectedDimensionColStates = updatedColState ? [
            updatedColState
        ] : [];
        if (this.crossFiltering && this.aggFunc) {
            const aggFuncDimension = this.suppliedCellRange.columns[0];
            selectedDimensionColStates = this.dimensionColState.filter((cs)=>cs.colId === aggFuncDimension.getColId());
        } else if (supportsMultipleDimensions || selectedDimensionColStates.length === 0 || selectedDimensionColStates.some(({ column: column })=>!column || !dimensionCols.has(column))) selectedDimensionColStates = this.dimensionColState.filter((cs)=>cs.selected);
        const isDefaultCategory = selectedDimensionColStates.length === 1 ? selectedDimensionColStates[0].colId === $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY : false;
        const selectedColumns = selectedDimensionColStates.map(({ column: column })=>column).filter((value)=>value != null);
        if (selectedColumns.length > 0 && !isDefaultCategory) this.dimensionCellRange = this.createCellRange((0, $437b23f6a393c3bf$export$162bc75b85f28397).DIMENSION, ...selectedColumns);
    }
    setValueCellRange(valueCols, colsInRange, setColsFromRange) {
        this.valueCellRange = void 0;
        const selectedValueCols = [];
        const maxSelection = $5b7ccabde48fae90$var$getMaxNumSeries(this.chartType);
        let numSelected = 0;
        valueCols.forEach((col)=>{
            if (setColsFromRange) {
                if ((maxSelection == null || numSelected < maxSelection) && colsInRange.has(col)) {
                    selectedValueCols.push(col);
                    numSelected++;
                }
            } else if (this.valueColState.some((colState)=>colState.selected && colState.colId === col.getColId())) selectedValueCols.push(col);
        });
        if (selectedValueCols.length > 0) {
            let orderedColIds = [];
            if (this.valueColState.length > 0) orderedColIds = this.valueColState.map((c)=>c.colId);
            else colsInRange.forEach((c)=>orderedColIds.push(c.getColId()));
            selectedValueCols.sort((a, b)=>orderedColIds.indexOf(a.getColId()) - orderedColIds.indexOf(b.getColId()));
            this.valueCellRange = this.createCellRange((0, $437b23f6a393c3bf$export$162bc75b85f28397).VALUE, ...selectedValueCols);
        }
    }
    resetCellRanges(dimension, value) {
        if (!dimension && !value) return;
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartColSvc.getChartColumns();
        const allColsFromRanges = this.getAllColumnsFromRanges();
        if (dimension) this.setDimensionCellRange(dimensionCols, allColsFromRanges);
        if (value) this.setValueCellRange(valueCols, allColsFromRanges);
    }
    updateSelectedDimensions(columns) {
        const colIdSet = new Set(columns.map((column)=>column.getColId()));
        const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
        if (!supportsMultipleDimensions) {
            const foundColState = this.dimensionColState.find((colState)=>colIdSet.has(colState.colId)) || this.dimensionColState[0];
            const selectedColumnId = foundColState.colId;
            this.dimensionColState = this.dimensionColState.map((colState)=>({
                    ...colState,
                    selected: colState.colId === selectedColumnId
                }));
        } else {
            const foundColStates = this.dimensionColState.filter((colState)=>colIdSet.has(colState.colId));
            const selectedColumnIds = new Set(foundColStates.map((colState)=>colState.colId));
            this.dimensionColState = this.dimensionColState.map((colState)=>({
                    ...colState,
                    selected: selectedColumnIds.has(colState.colId)
                }));
        }
    }
    syncDimensionCellRange() {
        const selectedDimensions = this.getSelectedDimensions();
        if (selectedDimensions.length === 0) return;
        const selectedCols = selectedDimensions.map(({ column: column })=>column).filter((value)=>value != null);
        if (selectedCols.length > 0) this.dimensionCellRange = this.createCellRange((0, $437b23f6a393c3bf$export$162bc75b85f28397).DIMENSION, ...selectedCols);
    }
    isComboChart(chartType) {
        return $5b7ccabde48fae90$var$isComboChart(chartType ?? this.chartType);
    }
    getCrossFilteringSort() {
        const sort = this.crossFilteringSort;
        if (typeof sort === "boolean") return sort;
        const sortOptions = [];
        sort.forEach(({ sort: sort2, colId: colId })=>{
            const column = this.chartColSvc.getColumn(colId);
            if (column) sortOptions.push({
                sort: sort2,
                column: column,
                type: (0, $437b23f6a393c3bf$export$fb66185d3079b298)(column.getSortDef()?.type)
            });
        });
        return sortOptions;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/statistical/statisticalChartProxy.ts
var $5b7ccabde48fae90$var$StatisticalChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params, commonChartOptions) {
        return {
            x: {
                type: this.getXAxisType(params),
                position: this.isHorizontal(commonChartOptions) ? "left" : "bottom"
            },
            y: {
                type: "number",
                position: this.isHorizontal(commonChartOptions) ? "bottom" : "left"
            }
        };
    }
    computeSeriesStatistics(params, computeStatsFn) {
        const { data: data, fields: fields } = params;
        const [category] = params.categories;
        const categoryKey = category.id || $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY;
        const groupedData = this.groupDataByCategory(categoryKey, data);
        return Array.from(groupedData).map(([categoryValue, categoryData])=>{
            const categoryResult = {
                [category.id]: categoryValue
            };
            fields.forEach((field, seriesIndex)=>{
                const seriesValues = categoryData.map((datum)=>datum[field.colId]).filter((value)=>typeof value === "number" && !isNaN(value));
                const computed = computeStatsFn(seriesValues);
                for (const statKey of Object.keys(computed)){
                    const propertyKey = `${statKey}:${seriesIndex}`;
                    categoryResult[propertyKey] = seriesValues.length > 0 ? computed[statKey] : null;
                }
            });
            return categoryResult;
        });
    }
    groupDataByCategory(categoryKey, data) {
        const getCategory = (datum)=>{
            if (categoryKey === $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY) return 1;
            const categoryValue = datum[categoryKey];
            if (categoryValue === null || categoryValue === void 0) return "";
            return categoryValue instanceof Date ? categoryValue.getTime() : categoryValue;
        };
        return data.reduce((acc, datum)=>{
            const category = getCategory(datum);
            const existingCategoryData = acc.get(category);
            if (existingCategoryData) existingCategoryData.push(datum);
            else acc.set(category, [
                datum
            ]);
            return acc;
        }, /* @__PURE__ */ new Map());
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/statistical/boxPlotChartProxy.ts
var $5b7ccabde48fae90$var$BoxPlotChartProxy = class extends $5b7ccabde48fae90$var$StatisticalChartProxy {
    getSeries(params) {
        const [category] = params.categories;
        return params.fields.map((field, seriesIndex)=>({
                type: this.standaloneChartType,
                // xKey/xName refer to category buckets
                xKey: category.id,
                xName: category.name,
                // yName is used to label the series
                yName: field.displayName ?? void 0,
                // custom field labels shown in the tooltip
                minName: "Min",
                q1Name: "Q1",
                medianName: "Median",
                q3Name: "Q3",
                maxName: "Max",
                // generated 'synthetic fields' from getData()
                minKey: `min:${seriesIndex}`,
                q1Key: `q1:${seriesIndex}`,
                medianKey: `median:${seriesIndex}`,
                q3Key: `q3:${seriesIndex}`,
                maxKey: `max:${seriesIndex}`
            }));
    }
    getData(params) {
        return this.computeSeriesStatistics(params, (seriesValues)=>{
            const sortedValues = seriesValues.sort((a, b)=>a - b);
            return {
                min: sortedValues[0],
                q1: this.quantile(sortedValues, 0.25),
                median: this.quantile(sortedValues, 0.5),
                q3: this.quantile(sortedValues, 0.75),
                max: sortedValues[sortedValues.length - 1]
            };
        });
    }
    quantile(sortedValues, q) {
        const position = (sortedValues.length - 1) * q;
        const indexBelow = Math.floor(position);
        const aboveValue = position - indexBelow;
        if (sortedValues[indexBelow + 1] !== void 0) return sortedValues[indexBelow] + aboveValue * (sortedValues[indexBelow + 1] - sortedValues[indexBelow]);
        return sortedValues[indexBelow];
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/statistical/rangeChartProxy.ts
var $5b7ccabde48fae90$var$RangeChartProxy = class extends $5b7ccabde48fae90$var$StatisticalChartProxy {
    getSeries(params) {
        const [category] = params.categories;
        return params.fields.map((field, seriesIndex)=>({
                type: this.standaloneChartType,
                // xKey/xName refer to category buckets
                xKey: category.id,
                xName: category.name,
                // yName is used to label the series
                yName: field.displayName ?? void 0,
                // custom field labels shown in the tooltip
                yLowName: "Min",
                yHighName: "Max",
                // generated 'synthetic fields' from getData()
                yLowKey: `min:${seriesIndex}`,
                yHighKey: `max:${seriesIndex}`
            }));
    }
    getData(params) {
        return this.computeSeriesStatistics(params, (seriesValues)=>{
            return {
                min: Math.min(...seriesValues),
                max: Math.max(...seriesValues)
            };
        });
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/enterpriseChartProxyFactory.ts
var $5b7ccabde48fae90$var$EnterpriseChartProxyFactory = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "enterpriseChartProxyFactory";
    }
    createChartProxy(chartProxyParams) {
        switch(chartProxyParams.chartType){
            case "histogram":
                return new $5b7ccabde48fae90$var$HistogramChartProxy(chartProxyParams);
            case "radarLine":
            case "radarArea":
            case "nightingale":
            case "radialColumn":
            case "radialBar":
                return new $5b7ccabde48fae90$var$PolarChartProxy(chartProxyParams);
            case "rangeBar":
            case "rangeArea":
                return new $5b7ccabde48fae90$var$RangeChartProxy(chartProxyParams);
            case "boxPlot":
                return new $5b7ccabde48fae90$var$BoxPlotChartProxy(chartProxyParams);
            case "treemap":
            case "sunburst":
                return new $5b7ccabde48fae90$var$HierarchicalChartProxy(chartProxyParams);
            case "heatmap":
                return new $5b7ccabde48fae90$var$HeatmapChartProxy(chartProxyParams);
            case "waterfall":
                return new $5b7ccabde48fae90$var$WaterfallChartProxy(chartProxyParams);
            case "funnel":
            case "coneFunnel":
            case "pyramid":
                return new $5b7ccabde48fae90$var$FunnelChartProxy(chartProxyParams);
        }
        return void 0;
    }
};
var $5b7ccabde48fae90$var$ChartPanelFeature = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(chartController, eGui, cssClass, createPanels){
        super();
        this.chartController = chartController;
        this.eGui = eGui;
        this.cssClass = cssClass;
        this.createPanels = createPanels;
        this.panels = [];
    }
    postConstruct() {
        this.addManagedListeners(this.chartController, {
            chartUpdated: ()=>this.refreshPanels(true),
            chartApiUpdate: ()=>this.refreshPanels(false)
        });
    }
    addComponent(component) {
        this.createBean(component);
        this.panels.push(component);
        component.addCss(this.cssClass);
        this.eGui.appendChild(component.getGui());
    }
    refreshPanels(reuse) {
        const chartType = this.chartController.getChartType();
        const isGrouping = this.chartController.isGrouping();
        const seriesType = $5b7ccabde48fae90$var$getSeriesType(chartType);
        if (reuse && chartType === this.chartType && isGrouping === this.isGrouping) return;
        this.destroyPanels();
        this.createPanels(chartType, seriesType);
        this.chartType = chartType;
        this.isGrouping = isGrouping;
    }
    destroyPanels() {
        for (const panel of this.panels){
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(panel.getGui());
            this.destroyBean(panel);
        }
        this.panels = [];
    }
    destroy() {
        this.destroyPanels();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$AnimationPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const animationGroupParams = this.chartMenuParamsFactory.addEnableParams("animation.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("animation"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const animationHeightInputParams = this.chartMenuParamsFactory.getDefaultNumberInputParams("animation.duration", "durationMillis", {
            min: 0
        });
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="animationGroup">
                <ag-input-number-field data-ref="animationHeightInput"></ag-input>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            (0, $437b23f6a393c3bf$export$c18153c9c909b7d7)
        ], {
            animationGroup: animationGroupParams,
            animationHeightInput: animationHeightInputParams
        });
    }
};
// packages/ag-grid-enterprise/src/charts/widgets/colorPicker.ts
var $5b7ccabde48fae90$var$ColorPicker = class extends $5b7ccabde48fae90$export$c7bbe886fe0efbe1 {
    constructor(config){
        super({
            ...config,
            dialogCallbacks: $5b7ccabde48fae90$var$DIALOG_CALLBACKS
        });
    }
};
var $5b7ccabde48fae90$var$ColorPickerSelector = {
    selector: "AG-COLOR-PICKER",
    component: $5b7ccabde48fae90$var$ColorPicker
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/advancedSettings/interactivity/crosshairPanel.ts
var $5b7ccabde48fae90$var$CrosshairPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const crosshairGroupParams = this.chartMenuParamsFactory.addEnableParams("crosshair.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("crosshair"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const crosshairLabelCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("crosshair.label.enabled", "crosshairLabel");
        const crosshairSnapCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("crosshair.snap", "crosshairSnap");
        const crosshairStrokeColorPickerParams = this.chartMenuParamsFactory.getDefaultColorPickerParams("crosshair.stroke", "color");
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="crosshairGroup">
                <ag-checkbox data-ref="crosshairLabelCheckbox"></ag-checkbox>
                <ag-checkbox data-ref="crosshairSnapCheckbox"></ag-checkbox>
                <ag-color-picker data-ref="crosshairStrokeColorPicker"></ag-color-picker>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            (0, $437b23f6a393c3bf$export$2e2c317d2e31f2ca),
            $5b7ccabde48fae90$var$ColorPickerSelector
        ], {
            crosshairGroup: crosshairGroupParams,
            crosshairLabelCheckbox: crosshairLabelCheckboxParams,
            crosshairSnapCheckbox: crosshairSnapCheckboxParams,
            crosshairStrokeColorPicker: crosshairStrokeColorPickerParams
        });
    }
};
var $5b7ccabde48fae90$var$NavigatorPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const navigatorGroupParams = this.chartMenuParamsFactory.addEnableParams("navigator.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("navigator"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const navigatorHeightSliderParams = this.chartMenuParamsFactory.getDefaultSliderParams("navigator.height", "height", 60);
        navigatorHeightSliderParams.minValue = 10;
        const navigatorMiniChartCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("navigator.miniChart.enabled", "miniChart");
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="navigatorGroup">
                <ag-slider data-ref="navigatorHeightSlider"></ag-slider>
                <ag-checkbox data-ref="navigatorMiniChartCheckbox"></ag-checkbox>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$export$2be649a426f1e774,
            (0, $437b23f6a393c3bf$export$2e2c317d2e31f2ca)
        ], {
            navigatorGroup: navigatorGroupParams,
            navigatorHeightSlider: navigatorHeightSliderParams,
            navigatorMiniChartCheckbox: navigatorMiniChartCheckboxParams
        });
    }
};
var $5b7ccabde48fae90$var$ZoomPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
        this.zoomScrollingStepInput = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const zoomGroupParams = this.chartMenuParamsFactory.addEnableParams("zoom.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("zoom"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const zoomScrollingCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("zoom.enableScrolling", "scrollingZoom");
        const zoomScrollingStepSliderParams = this.chartMenuParamsFactory.getDefaultSliderParams("zoom.scrollingStep", "scrollingStep", 1);
        zoomScrollingStepSliderParams.step = 0.01;
        zoomScrollingStepSliderParams.minValue = zoomScrollingStepSliderParams.step;
        const zoomSelectingCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("zoom.enableSelecting", "selectingZoom");
        zoomScrollingCheckboxParams.onValueChange = /* @__PURE__ */ ((onValueChange)=>(value)=>{
                if (!onValueChange) return;
                onValueChange(value);
                this.zoomScrollingStepInput.setDisabled(!value);
            })(zoomScrollingCheckboxParams.onValueChange);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="zoomGroup">
                <ag-checkbox data-ref="zoomSelectingCheckbox"></ag-checkbox>
                <ag-checkbox data-ref="zoomScrollingCheckbox"></ag-checkbox>
                <ag-slider data-ref="zoomScrollingStepInput"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            (0, $437b23f6a393c3bf$export$2e2c317d2e31f2ca),
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            zoomGroup: zoomGroupParams,
            zoomScrollingCheckbox: zoomScrollingCheckboxParams,
            zoomScrollingStepInput: zoomScrollingStepSliderParams,
            zoomSelectingCheckbox: zoomSelectingCheckboxParams
        });
        this.zoomScrollingStepInput.setDisabled(!zoomScrollingCheckboxParams.value);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/advancedSettings/advancedSettingsPanel.ts
var $5b7ccabde48fae90$var$INTERACTIVITY_GROUPS = [
    "navigator",
    "zoom",
    "animation",
    "crosshair"
];
var $5b7ccabde48fae90$var$AdvancedSettingsPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuContext){
        super(/* html */ `<div class="ag-chart-advanced-settings-wrapper"></div>`);
        this.chartMenuContext = chartMenuContext;
    }
    postConstruct() {
        this.chartPanelFeature = this.createManagedBean(new $5b7ccabde48fae90$var$ChartPanelFeature(this.chartMenuContext.chartController, this.getGui(), "ag-chart-advanced-settings-section", (chartType, seriesType)=>this.createPanels(chartType, seriesType)));
        this.chartPanelFeature.refreshPanels();
    }
    createPanels(chartType, seriesType) {
        for (const group of $5b7ccabde48fae90$var$INTERACTIVITY_GROUPS){
            if (!this.isGroupPanelShownForSeries(group, seriesType)) continue;
            const comp = this.createPanel(group);
            this.chartPanelFeature.addComponent(comp);
        }
    }
    isGroupPanelShownForSeries(group, seriesType) {
        return group === "animation" || $5b7ccabde48fae90$var$isCartesian(seriesType) && !$5b7ccabde48fae90$var$isFunnel(seriesType);
    }
    createPanel(group) {
        const { chartMenuParamsFactory: chartMenuParamsFactory, chartAxisMenuParamsFactory: chartAxisMenuParamsFactory } = this.chartMenuContext;
        switch(group){
            case "navigator":
                return new $5b7ccabde48fae90$var$NavigatorPanel(chartMenuParamsFactory);
            case "zoom":
                return new $5b7ccabde48fae90$var$ZoomPanel(chartMenuParamsFactory);
            case "animation":
                return new $5b7ccabde48fae90$var$AnimationPanel(chartMenuParamsFactory);
            case "crosshair":
                return new $5b7ccabde48fae90$var$CrosshairPanel(chartAxisMenuParamsFactory);
        }
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/advancedSettings/advancedSettingsMenuFactory.ts
var $5b7ccabde48fae90$var$AdvancedSettingsMenuFactory = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "advSettingsMenuFactory";
    }
    showMenu(chartMenuContext, eventSource) {
        this.hideMenu();
        const menu = this.createBean(new $5b7ccabde48fae90$var$AdvancedSettingsMenu(chartMenuContext));
        this.activeDialog = this.createBean(new $5b7ccabde48fae90$var$Dialog({
            title: this.beans.chartTranslation.translate("advancedSettings"),
            component: menu,
            width: 300,
            height: 400,
            resizable: true,
            movable: true,
            centered: true,
            closable: true,
            afterGuiAttached: ()=>{
                (0, $437b23f6a393c3bf$export$7acf44f59625b1f6)(menu.getGui())[0]?.focus();
            },
            closedCallback: ()=>{
                this.activeMenu = this.destroyBean(this.activeMenu);
                this.activeDialog = void 0;
                eventSource?.focus({
                    preventScroll: true
                });
            }
        }));
        this.activeMenu = menu;
    }
    hideMenu() {
        if (this.activeDialog) this.destroyBean(this.activeDialog);
    }
    destroy() {
        this.activeMenu = this.destroyBean(this.activeMenu);
        this.activeDialog = this.destroyBean(this.activeDialog);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$AdvancedSettingsMenu = class extends (0, $437b23f6a393c3bf$export$5a26e3abd1c845b6) {
    constructor(chartMenuContext){
        super(/* html */ `<div class="ag-chart-advanced-settings"></div>`);
        this.chartMenuContext = chartMenuContext;
    }
    postConstruct() {
        this.advancedSettingsPanel = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedSettingsPanel(this.chartMenuContext));
        this.getGui().appendChild(this.advancedSettingsPanel.getGui());
        this.initialiseTabGuard({
            onTabKeyDown: this.onTabKeyDown.bind(this),
            focusTrapActive: true
        });
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        e.preventDefault();
        const backwards = e.shiftKey;
        const panelGui = this.advancedSettingsPanel.getGui();
        const nextEl = (0, $437b23f6a393c3bf$export$83fc12531358bd28)(this.beans, panelGui, false, backwards);
        if (nextEl) nextEl.focus();
        else {
            const focusableElements = (0, $437b23f6a393c3bf$export$7acf44f59625b1f6)(panelGui);
            if (focusableElements.length) focusableElements[backwards ? focusableElements.length - 1 : 0].focus();
        }
    }
};
var $5b7ccabde48fae90$var$ChartMenuListFactory = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "chartMenuListFactory";
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
        this.chartMenuSvc = beans.chartMenuSvc;
        this.chartTranslation = beans.chartTranslation;
    }
    showMenuList(params) {
        const { eventSource: eventSource, showMenu: showMenu, chartMenuContext: chartMenuContext } = params;
        const areChartToolPanelsEnabled = this.chartMenuSvc.doChartToolPanelsExist(chartMenuContext.chartController);
        const menuItems = this.mapWithStockItems(this.getMenuItems(chartMenuContext.chartController, areChartToolPanelsEnabled), chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled);
        if (!menuItems.length) return;
        const chartMenuList = this.createBean(new $5b7ccabde48fae90$var$ChartMenuList(menuItems));
        this.activeChartMenuList = chartMenuList;
        let multiplier = -1;
        let alignSide = "left";
        if (this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        const eGui = chartMenuList.getGui();
        this.popupSvc.addPopup({
            modal: true,
            eChild: eGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                this.destroyBean(chartMenuList);
                this.activeChartMenuList = void 0;
                if ((0, $437b23f6a393c3bf$export$8ff9eef09a45371f)(this.beans)) eventSource.focus({
                    preventScroll: true
                });
            },
            afterGuiAttached: (params2)=>chartMenuList.afterGuiAttached(params2),
            positionCallback: ()=>{
                this.popupSvc.positionPopupByComponent({
                    type: "chartMenu",
                    eventSource: eventSource,
                    ePopup: eGui,
                    alignSide: alignSide,
                    nudgeX: 4 * multiplier,
                    nudgeY: 4,
                    position: "under",
                    keepWithinBounds: true
                });
            },
            ariaLabel: "Chart Menu"
        });
    }
    getMenuItems(chartController, areChartToolPanelsEnabled) {
        const defaultItems = [
            ...areChartToolPanelsEnabled ? [
                "chartEdit"
            ] : [],
            ...chartController.isEnterprise() ? [
                "chartAdvancedSettings"
            ] : [],
            chartController.isChartLinked() ? "chartUnlink" : "chartLink",
            "chartDownload"
        ];
        const chartMenuItems = this.gos.get("chartMenuItems");
        if (!chartMenuItems) return defaultItems;
        else if (Array.isArray(chartMenuItems)) return chartMenuItems;
        else return chartMenuItems((0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {
            defaultItems: defaultItems,
            chartId: chartController.getChartId()
        }));
    }
    mapWithStockItems(originalList, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled) {
        if (!originalList) return [];
        const resultList = [];
        for (const menuItemOrString of originalList){
            let result;
            if (typeof menuItemOrString === "string") result = this.getStockMenuItem(menuItemOrString, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled);
            else result = {
                ...menuItemOrString
            };
            if (!result) continue;
            const { subMenu: subMenu } = result;
            if (Array.isArray(subMenu)) result.subMenu = this.mapWithStockItems(subMenu, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled);
            resultList.push(result);
        }
        return resultList;
    }
    getStockMenuItem(key, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled) {
        switch(key){
            case "chartEdit":
                return areChartToolPanelsEnabled ? this.createMenuItem(this.chartTranslation.translate("chartEdit"), "chartsMenuEdit", showMenu) : null;
            case "chartAdvancedSettings":
                return this.createMenuItem(this.chartTranslation.translate("chartAdvancedSettings"), "chartsMenuAdvancedSettings", ()=>this.chartMenuSvc.openAdvancedSettings(chartMenuContext, eventSource));
            case "chartUnlink":
                return chartMenuContext.chartController.isChartLinked() ? this.createMenuItem(this.chartTranslation.translate("chartUnlink"), "unlinked", ()=>this.chartMenuSvc.toggleLinked(chartMenuContext)) : null;
            case "chartLink":
                return !chartMenuContext.chartController.isChartLinked() ? this.createMenuItem(this.chartTranslation.translate("chartLink"), "linked", ()=>this.chartMenuSvc.toggleLinked(chartMenuContext)) : null;
            case "chartDownload":
                return this.createMenuItem(this.chartTranslation.translate("chartDownload"), "chartsDownload", ()=>this.chartMenuSvc.downloadChart(chartMenuContext));
        }
        return null;
    }
    createMenuItem(name, iconName, action) {
        return {
            name: name,
            icon: (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(iconName, this.beans, null),
            action: action
        };
    }
    destroy() {
        this.destroyBean(this.activeChartMenuList);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ChartMenuList = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(menuItems){
        super(/* html */ `
            <div data-ref="eChartsMenu" role="presentation" class="ag-menu ag-chart-menu-popup"></div>
        `);
        this.menuItems = menuItems;
        this.eChartsMenu = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        this.mainMenuList = this.createManagedBean(new $5b7ccabde48fae90$var$MenuList(0));
        this.mainMenuList.addMenuItems(this.menuItems);
        this.mainMenuList.addEventListener("closeMenu", this.onHidePopup.bind(this));
        this.eChartsMenu.appendChild(this.mainMenuList.getGui());
    }
    onHidePopup() {
        this.hidePopupFunc?.();
    }
    afterGuiAttached({ hidePopup: hidePopup }) {
        if (hidePopup) {
            this.hidePopupFunc = hidePopup;
            this.addDestroyFunc(hidePopup);
        }
        (0, $437b23f6a393c3bf$export$8598088d375f416f)(this.mainMenuList.getGui());
    }
};
var $5b7ccabde48fae90$var$ChartCrossFilterService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "chartCrossFilterSvc";
    }
    filter(event, reset = false) {
        const filterManager = this.beans.filterManager;
        const filterModel = filterManager?.getFilterModel() ?? {};
        if (reset) {
            if (Object.keys(filterModel).length > 0) filterManager?.setFilterModel(null);
            return;
        }
        let colId = $5b7ccabde48fae90$var$extractFilterColId(event);
        if (colId.indexOf("-filtered-out")) colId = colId.replace("-filtered-out", "");
        this.updateFilters(filterModel, event, colId);
    }
    updateFilters(filterModel, event, colId) {
        const dataKey = $5b7ccabde48fae90$var$extractFilterColId(event);
        const rawValue = this.convertRawValue(colId, event.datum[dataKey]);
        if (rawValue === void 0) return;
        const filterManager = this.beans.filterManager;
        filterManager?.getColumnFilterInstance(colId).then((filter)=>{
            const filterType = filter?.filterType;
            let setFilter;
            let processModel = (model)=>model;
            if (filterType === "multi") {
                const result = $5b7ccabde48fae90$var$extractFromMultiFilter(filter);
                setFilter = result.setFilter;
                processModel = result.processModel ?? processModel;
            } else if (filterType === "set") setFilter = filter;
            if (!setFilter) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(154, {
                    colId: colId
                });
                return;
            }
            const update = event.event.metaKey || event.event.ctrlKey;
            const setFilterModel = setFilter.getFilterHandler().getCrossFilterModel((createKey, availableKeys, existingValues)=>$5b7ccabde48fae90$var$getSetFilterModel(update, createKey(rawValue), availableKeys, existingValues));
            const colFilterModel = processModel(setFilterModel);
            const newFilterModel = update ? {
                ...filterModel
            } : {};
            newFilterModel[colId] = colFilterModel;
            filterManager?.setFilterModel(newFilterModel);
        });
    }
    convertRawValue(colId, rawValue) {
        const { colModel: colModel, dataTypeSvc: dataTypeSvc } = this.beans;
        const column = colModel.getColById(colId);
        const colDef = column?.colDef;
        if (colDef && dataTypeSvc && colDef.chartDataType === "time" && colDef.cellDataType === "dateString") return dataTypeSvc.getDateFormatterFunction(column)(rawValue);
        return rawValue;
    }
};
function $5b7ccabde48fae90$var$processMultiFilterModel(setFilterModel, index, numFilters) {
    const filterModels = new Array(numFilters);
    for(let i = 0; i < numFilters; i++)filterModels[i] = i === index ? setFilterModel : null;
    return {
        filterType: "multi",
        filterModels: filterModels
    };
}
function $5b7ccabde48fae90$var$extractFromMultiFilter(multiFilter) {
    const numFilters = multiFilter.getNumChildFilters();
    for(let i = 0; i < numFilters; i++){
        const childFilter = multiFilter.getChildFilterInstance(i);
        if (childFilter?.filterType === "set") return {
            setFilter: childFilter,
            processModel: (model)=>$5b7ccabde48fae90$var$processMultiFilterModel(model, i, numFilters)
        };
    }
    return {};
}
function $5b7ccabde48fae90$var$extractFilterColId(event) {
    return event.xKey || event.calloutLabelKey;
}
function $5b7ccabde48fae90$var$getSetFilterModel(update, key, availableKeySet, existingValues) {
    let values;
    if (update) {
        if (availableKeySet.has(key) && (existingValues == null || existingValues.includes(key))) {
            values = [];
            if (existingValues == null) {
                for (const availableKey of availableKeySet)if (availableKey !== key) values.push(availableKey);
            } else {
                for (const existingValue of existingValues)if (existingValue !== key && availableKeySet.has(existingValue)) values.push(existingValue);
            }
        } else {
            if (existingValues == null) values = Array.from(availableKeySet);
            else {
                values = [];
                for (const existingValue of existingValues)if (availableKeySet.has(existingValue)) values.push(existingValue);
            }
            values.push(key);
        }
    } else values = [
        key
    ];
    return {
        filterType: "set",
        values: values
    };
}
var $5b7ccabde48fae90$var$CHART_TOOLBAR_ALLOW_LIST = [
    "chartUnlink",
    "chartLink",
    "chartDownload",
    "chartMenu"
];
var $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS = {
    settings: "chartSettings",
    data: "chartData",
    format: "chartFormat"
};
var $5b7ccabde48fae90$var$ChartMenuService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "chartMenuSvc";
    }
    wireBeans(beans) {
        this.advSettingsMenuFactory = beans.advSettingsMenuFactory;
    }
    downloadChart(chartMenuContext, dimensions, fileName, fileFormat) {
        chartMenuContext.chartController.getChartProxy().downloadChart(dimensions, fileName, fileFormat);
    }
    toggleLinked(chartMenuContext) {
        chartMenuContext.chartController.detachChartRange();
    }
    openAdvancedSettings(chartMenuContext, eventSource) {
        this.advSettingsMenuFactory?.showMenu(chartMenuContext, eventSource);
    }
    hideAdvancedSettings() {
        this.advSettingsMenuFactory?.hideMenu();
    }
    getChartToolbarOptions() {
        const defaultChartToolbarOptions = [
            "chartMenu"
        ];
        const toolbarItemsFunc = this.gos.getCallback("getChartToolbarItems");
        const params = {
            defaultItems: defaultChartToolbarOptions
        };
        return toolbarItemsFunc ? toolbarItemsFunc(params).filter((option)=>{
            if (!$5b7ccabde48fae90$var$CHART_TOOLBAR_ALLOW_LIST.includes(option)) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(155, {
                    option: option
                });
                return false;
            }
            return true;
        }) : defaultChartToolbarOptions;
    }
    getChartToolPanels(chartController) {
        const chartToolPanelsDef = this.gos.get("chartToolPanelsDef");
        const panelsOverride = chartToolPanelsDef?.panels?.map((panel)=>{
            const menuOption = $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS[panel];
            if (!menuOption) (0, $437b23f6a393c3bf$export$545083624300f13d)(156, {
                panel: panel
            });
            return menuOption;
        }).filter((panel)=>Boolean(panel));
        let panels = panelsOverride ?? Object.values($5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS);
        if (chartController.isPivotChart()) panels = panels.filter((panel)=>panel !== "chartData");
        const defaultToolPanel = chartToolPanelsDef?.defaultToolPanel;
        const defaultPanel = defaultToolPanel && $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS[defaultToolPanel] || panels[0];
        return {
            panels: panels,
            defaultPanel: defaultPanel
        };
    }
    doesChartToolbarExist() {
        const chartToolbarOptions = this.getChartToolbarOptions();
        return chartToolbarOptions.length > 0;
    }
    doChartToolPanelsExist(chartController) {
        const { panels: panels } = this.getChartToolPanels(chartController);
        return panels.length > 0;
    }
};
var $5b7ccabde48fae90$var$DEFAULT_CHART_TRANSLATIONS = {
    pivotChartTitle: "Pivot Chart",
    rangeChartTitle: "Range Chart",
    settings: "Chart",
    data: "Set Up",
    format: "Customize",
    categories: "Categories",
    defaultCategory: "(None)",
    series: "Series",
    switchCategorySeries: "Switch Category / Series",
    categoryValues: "Category Values",
    seriesLabels: "Series Labels",
    aggregate: "Aggregate",
    xyValues: "X Y Values",
    paired: "Paired Mode",
    axis: "Axis",
    xAxis: "Horizontal Axis",
    yAxis: "Vertical Axis",
    polarAxis: "Polar Axis",
    radiusAxis: "Radius Axis",
    navigator: "Navigator",
    zoom: "Zoom",
    animation: "Animation",
    crosshair: "Crosshair",
    color: "Color",
    thickness: "Thickness",
    preferredLength: "Preferred Length",
    xType: "X Type",
    axisType: "Axis Type",
    automatic: "Automatic",
    category: "Category",
    number: "Number",
    time: "Time",
    timeFormat: "Time Format",
    autoRotate: "Auto Rotate",
    labelRotation: "Rotation",
    circle: "Circle",
    polygon: "Polygon",
    square: "Square",
    cross: "Cross",
    diamond: "Diamond",
    plus: "Plus",
    triangle: "Triangle",
    heart: "Heart",
    orientation: "Orientation",
    fixed: "Fixed",
    parallel: "Parallel",
    perpendicular: "Perpendicular",
    radiusAxisPosition: "Position",
    ticks: "Ticks",
    gridLines: "Grid Lines",
    width: "Width",
    height: "Height",
    length: "Length",
    padding: "Padding",
    spacing: "Spacing",
    chartStyle: "Chart Style",
    title: "Title",
    chartTitles: "Titles",
    chartTitle: "Chart Title",
    chartSubtitle: "Subtitle",
    horizontalAxisTitle: "Horizontal Axis Title",
    verticalAxisTitle: "Vertical Axis Title",
    polarAxisTitle: "Polar Axis Title",
    titlePlaceholder: "Chart Title",
    background: "Background",
    font: "Font",
    weight: "Weight",
    top: "Top",
    right: "Right",
    bottom: "Bottom",
    left: "Left",
    labels: "Labels",
    calloutLabels: "Callout Labels",
    sectorLabels: "Sector Labels",
    positionRatio: "Position Ratio",
    size: "Size",
    shape: "Shape",
    minSize: "Minimum Size",
    maxSize: "Maximum Size",
    legend: "Legend",
    position: "Position",
    markerSize: "Marker Size",
    markerStroke: "Marker Stroke",
    markerPadding: "Marker Padding",
    itemSpacing: "Item Spacing",
    itemPaddingX: "Item Padding X",
    itemPaddingY: "Item Padding Y",
    layoutHorizontalSpacing: "Horizontal Spacing",
    layoutVerticalSpacing: "Vertical Spacing",
    strokeWidth: "Stroke Width",
    offset: "Offset",
    offsets: "Offsets",
    tooltips: "Tooltips",
    callout: "Callout",
    markers: "Markers",
    shadow: "Shadow",
    blur: "Blur",
    xOffset: "X Offset",
    yOffset: "Y Offset",
    lineWidth: "Line Width",
    lineDash: "Line Dash",
    lineDashOffset: "Dash Offset",
    scrollingZoom: "Scrolling",
    scrollingStep: "Scrolling Step",
    selectingZoom: "Selecting",
    durationMillis: "Duration (ms)",
    crosshairLabel: "Label",
    crosshairSnap: "Snap to Node",
    normal: "Normal",
    bold: "Bold",
    italic: "Italic",
    boldItalic: "Bold Italic",
    predefined: "Predefined",
    fillOpacity: "Fill Opacity",
    strokeColor: "Line Color",
    strokeOpacity: "Line Opacity",
    miniChart: "Mini-Chart",
    histogramBinCount: "Bin count",
    connectorLine: "Connector Line",
    seriesItems: "Series Items",
    seriesItemType: "Item Type",
    seriesItemPositive: "Positive",
    seriesItemNegative: "Negative",
    seriesItemLabels: "Item Labels",
    columnGroup: "Column",
    barGroup: "Bar",
    pieGroup: "Pie",
    lineGroup: "Line",
    scatterGroup: "X Y (Scatter)",
    areaGroup: "Area",
    polarGroup: "Polar",
    statisticalGroup: "Statistical",
    hierarchicalGroup: "Hierarchical",
    specializedGroup: "Specialized",
    combinationGroup: "Combination",
    groupedColumnTooltip: "Grouped",
    stackedColumnTooltip: "Stacked",
    normalizedColumnTooltip: "100% Stacked",
    groupedBarTooltip: "Grouped",
    stackedBarTooltip: "Stacked",
    normalizedBarTooltip: "100% Stacked",
    pieTooltip: "Pie",
    donutTooltip: "Donut",
    lineTooltip: "Line",
    stackedLineTooltip: "Stacked",
    normalizedLineTooltip: "100% Stacked",
    groupedAreaTooltip: "Area",
    stackedAreaTooltip: "Stacked",
    normalizedAreaTooltip: "100% Stacked",
    scatterTooltip: "Scatter",
    bubbleTooltip: "Bubble",
    histogramTooltip: "Histogram",
    radialColumnTooltip: "Radial Column",
    radialBarTooltip: "Radial Bar",
    radarLineTooltip: "Radar Line",
    radarAreaTooltip: "Radar Area",
    nightingaleTooltip: "Nightingale",
    rangeBarTooltip: "Range Bar",
    rangeAreaTooltip: "Range Area",
    boxPlotTooltip: "Box Plot",
    treemapTooltip: "Treemap",
    sunburstTooltip: "Sunburst",
    waterfallTooltip: "Waterfall",
    heatmapTooltip: "Heatmap",
    columnLineComboTooltip: "Column & Line",
    areaColumnComboTooltip: "Area & Column",
    customComboTooltip: "Custom Combination",
    innerRadius: "Inner Radius",
    startAngle: "Start Angle",
    endAngle: "End Angle",
    reverseDirection: "Reverse Direction",
    groupPadding: "Group Padding",
    seriesPadding: "Series Padding",
    tile: "Tile",
    whisker: "Whisker",
    cap: "Cap",
    capLengthRatio: "Length Ratio",
    labelPlacement: "Placement",
    inside: "Inside",
    outside: "Outside",
    noDataToChart: "No data available to be charted.",
    pivotChartRequiresPivotMode: "Pivot Chart requires Pivot Mode enabled.",
    chartSettingsToolbarTooltip: "Menu",
    chartLinkToolbarTooltip: "Linked to Grid",
    chartUnlinkToolbarTooltip: "Unlinked from Grid",
    chartDownloadToolbarTooltip: "Download Chart",
    chartMenuToolbarTooltip: "Menu",
    chartEdit: "Edit Chart",
    chartAdvancedSettings: "Advanced Settings",
    chartLink: "Link to Grid",
    chartUnlink: "Unlink from Grid",
    chartDownload: "Download Chart",
    histogramFrequency: "Frequency",
    seriesChartType: "Series Chart Type",
    seriesType: "Series Type",
    secondaryAxis: "Secondary Axis",
    seriesAdd: "Add a series",
    categoryAdd: "Add a category",
    bar: "Bar",
    column: "Column",
    histogram: "Histogram",
    advancedSettings: "Advanced Settings",
    direction: "Direction",
    horizontal: "Horizontal",
    vertical: "Vertical",
    seriesGroupType: "Group Type",
    groupedSeriesGroupType: "Grouped",
    stackedSeriesGroupType: "Stacked",
    normalizedSeriesGroupType: "100% Stacked",
    legendEnabled: "Enabled",
    groupedColumnFull: "Grouped Column",
    stackedColumnFull: "Stacked Column",
    normalizedColumnFull: "100% Stacked Column",
    groupedBarFull: "Grouped Bar",
    stackedBarFull: "Stacked Bar",
    normalizedBarFull: "100% Stacked Bar",
    stackedAreaFull: "Stacked Area",
    normalizedAreaFull: "100% Stacked Area",
    stackedLineFull: "Stacked Line",
    normalizedLineFull: "100% Stacked Line",
    customCombo: "Custom Combination",
    funnel: "Funnel",
    coneFunnel: "Cone Funnel",
    pyramid: "Pyramid",
    funnelGroup: "Funnel",
    funnelTooltip: "Funnel",
    coneFunnelTooltip: "Cone Funnel",
    pyramidTooltip: "Pyramid",
    dropOff: "Drop-Off",
    stageLabels: "Stage Labels",
    reverse: "Reverse",
    tooltipMode: "Tooltip Mode",
    tooltipModeSingle: "Single",
    tooltipModeShared: "Multiple",
    tooltipModeCompact: "Compact",
    // menu items
    groupedColumn: "Grouped",
    stackedColumn: "Stacked",
    pie: "Pie",
    donut: "Donut",
    line: "Line",
    scatter: "Scatter",
    bubble: "Bubble",
    area: "Area",
    stackedArea: "Stacked",
    radarLine: "Radar Line",
    radarArea: "Radar Area",
    nightingale: "Nightingale",
    radialColumn: "Radial Column",
    radialBar: "Radial Bar",
    boxPlot: "Box Plot",
    rangeBar: "Range Bar",
    rangeArea: "Range Area",
    treemap: "Treemap",
    sunburst: "Sunburst",
    waterfall: "Waterfall",
    heatmap: "Heatmap",
    columnLineCombo: "Column & Line",
    AreaColumnCombo: "Area & Column",
    // aria
    ariaChartMenuClose: "Close Chart Edit Menu",
    ariaChartSelected: "Selected",
    // group
    group: "Group",
    // time formats
    timeFormatSlashesDDMMYYYY: "DD/MM/YYYY",
    timeFormatSlashesMMDDYYYY: "MM/DD/YYYY",
    timeFormatSlashesDDMMYY: "DD/MM/YY",
    timeFormatSlashesMMDDYY: "MM/DD/YY",
    timeFormatDotsDDMYY: "DD.M.YY",
    timeFormatDotsMDDYY: "M.DD.YY",
    timeFormatDashesYYYYMMDD: "YYYY-MM-DD",
    timeFormatSpacesDDMMMMYYYY: "DD MMMM YYYY",
    timeFormatHHMMSS: "HH:MM:SS",
    timeFormatHHMMSSAmPm: "HH:MM:SS AM/PM",
    // agg funcs
    sum: "Sum",
    first: "First",
    last: "Last",
    min: "Min",
    max: "Max",
    count: "Count",
    avg: "Average"
};
var $5b7ccabde48fae90$var$ChartTranslationService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "chartTranslation";
    }
    translate(toTranslate) {
        const translate = this.getLocaleTextFunc();
        const defaultTranslation = $5b7ccabde48fae90$var$DEFAULT_CHART_TRANSLATIONS[toTranslate];
        return translate(toTranslate, defaultTranslation);
    }
};
var $5b7ccabde48fae90$var$validateIfDefined = (validationFn)=>{
    return (value)=>{
        if (value == void 0) return true;
        return validationFn(value);
    };
};
var $5b7ccabde48fae90$var$isString = (value)=>typeof value === "string";
var $5b7ccabde48fae90$var$isBoolean = (value)=>typeof value === "boolean";
var $5b7ccabde48fae90$var$isValidSeriesChartType = (value)=>typeof value === "object";
var $5b7ccabde48fae90$var$createWarnMessage = (property, expectedType)=>(value)=>`AG Grid - unable to update chart as invalid params supplied:  \`${property}: ${value}\`, expected ${expectedType}.`;
var $5b7ccabde48fae90$var$createEnterpriseMessage = (feature)=>{
    const url = "https://www.ag-grid.com/javascript-data-grid/integrated-charts-installation/";
    return `${feature} is not supported in AG Charts Community ('ag-charts-enterprise' hasn't been loaded). See ${url} for more details.`;
};
var $5b7ccabde48fae90$var$legacyChartTypes = [
    "doughnut"
];
var $5b7ccabde48fae90$var$baseUpdateChartParams = [
    "type",
    "chartId",
    "chartType",
    "chartThemeName",
    "chartThemeOverrides",
    "unlinkChart"
];
function $5b7ccabde48fae90$var$isValidChartType(value) {
    return !!$5b7ccabde48fae90$var$getSeriesTypeIfExists(value) || $5b7ccabde48fae90$var$isComboChart(value);
}
function $5b7ccabde48fae90$var$isLegacyChartType(value) {
    return $5b7ccabde48fae90$var$legacyChartTypes.includes(value);
}
var $5b7ccabde48fae90$var$validateChartType = $5b7ccabde48fae90$var$validateIfDefined((chartType)=>{
    if ($5b7ccabde48fae90$var$isValidChartType(chartType)) return true;
    if ($5b7ccabde48fae90$var$isLegacyChartType(chartType)) {
        const renamedChartType = $5b7ccabde48fae90$var$getCanonicalChartType(chartType);
        (0, $437b23f6a393c3bf$export$2cf41453020eef66)(`The chart type '${chartType}' has been deprecated. Please use '${renamedChartType}' instead.`);
        return renamedChartType;
    }
    return false;
});
var $5b7ccabde48fae90$var$validateAgChartThemeOverrides = $5b7ccabde48fae90$var$validateIfDefined((themeOverrides)=>{
    return typeof themeOverrides === "object";
});
var $5b7ccabde48fae90$var$validateChartParamsCellRange = $5b7ccabde48fae90$var$validateIfDefined((cellRange)=>{
    return typeof cellRange === "object";
});
var $5b7ccabde48fae90$var$validateAggFunc = $5b7ccabde48fae90$var$validateIfDefined((aggFunc)=>{
    return typeof aggFunc === "string" || typeof aggFunc === "function";
});
var $5b7ccabde48fae90$var$enterpriseChartTypeValidation = (isEnterprise)=>({
        property: "chartType",
        validationFn: $5b7ccabde48fae90$var$validateIfDefined((chartType)=>isEnterprise || !chartType || !$5b7ccabde48fae90$var$isEnterpriseChartType(chartType)),
        warnMessage: (chartType)=>$5b7ccabde48fae90$var$createEnterpriseMessage(`The '${chartType}' chart type`)
    });
var $5b7ccabde48fae90$var$switchCategorySeriesValidation = (isEnterprise)=>({
        property: "switchCategorySeries",
        validationFn: $5b7ccabde48fae90$var$validateIfDefined((switchCategorySeries)=>{
            if (!switchCategorySeries || isEnterprise) return true;
            return void 0;
        }),
        warnMessage: ()=>$5b7ccabde48fae90$var$createEnterpriseMessage(`'switchCategorySeries' has been ignored as it`),
        warnIfFixed: true
    });
var $5b7ccabde48fae90$var$commonUpdateValidations = ()=>[
        {
            property: "chartId",
            validationFn: $5b7ccabde48fae90$var$isString,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartId", "string")
        },
        {
            property: "chartType",
            validationFn: $5b7ccabde48fae90$var$validateChartType,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartType", "ChartType")
        },
        {
            property: "chartThemeName",
            validationFn: $5b7ccabde48fae90$var$isString,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartThemeName", "string")
        },
        {
            property: "chartThemeOverrides",
            validationFn: $5b7ccabde48fae90$var$validateAgChartThemeOverrides,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartThemeOverrides", "AgChartThemeOverrides")
        },
        {
            property: "unlinkChart",
            validationFn: $5b7ccabde48fae90$var$isBoolean,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("unlinkChart", "boolean")
        }
    ];
var $5b7ccabde48fae90$var$cellRangeValidations = (isEnterprise)=>[
        {
            property: "cellRange",
            validationFn: $5b7ccabde48fae90$var$validateChartParamsCellRange,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("cellRange", "ChartParamsCellRange")
        },
        {
            property: "suppressChartRanges",
            validationFn: $5b7ccabde48fae90$var$isBoolean,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("suppressChartRanges", "boolean")
        },
        {
            property: "aggFunc",
            validationFn: $5b7ccabde48fae90$var$validateAggFunc,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("aggFunc", "string or IAggFunc")
        },
        $5b7ccabde48fae90$var$switchCategorySeriesValidation(isEnterprise)
    ];
function $5b7ccabde48fae90$var$validateUpdateParams(params, isEnterprise) {
    const paramsToValidate = params;
    switch(paramsToValidate.type){
        case "rangeChartUpdate":
            return $5b7ccabde48fae90$var$validateUpdateRangeChartParams(params, isEnterprise);
        case "pivotChartUpdate":
            return $5b7ccabde48fae90$var$validateUpdatePivotChartParams(params);
        case "crossFilterChartUpdate":
            return $5b7ccabde48fae90$var$validateUpdateCrossFilterChartParams(params, isEnterprise);
        default:
            (0, $437b23f6a393c3bf$export$2cf41453020eef66)(`Invalid value supplied for 'type': ${params.type}. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.`);
            return false;
    }
}
function $5b7ccabde48fae90$var$validateCreateParams(params, isEnterprise) {
    return $5b7ccabde48fae90$var$validateProperties(params, [
        $5b7ccabde48fae90$var$enterpriseChartTypeValidation(isEnterprise),
        $5b7ccabde48fae90$var$switchCategorySeriesValidation(isEnterprise)
    ]);
}
function $5b7ccabde48fae90$var$validateUpdateRangeChartParams(params, isEnterprise) {
    const validations = [
        ...$5b7ccabde48fae90$var$commonUpdateValidations(),
        $5b7ccabde48fae90$var$enterpriseChartTypeValidation(isEnterprise),
        ...$5b7ccabde48fae90$var$cellRangeValidations(isEnterprise),
        {
            property: "seriesChartTypes",
            validationFn: (value)=>value === void 0 || Array.isArray(value) && value.every($5b7ccabde48fae90$var$isValidSeriesChartType),
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("seriesChartTypes", "Array of SeriesChartType")
        },
        {
            property: "useGroupColumnAsCategory",
            validationFn: $5b7ccabde48fae90$var$isBoolean,
            warnMessage: $5b7ccabde48fae90$var$createWarnMessage("useGroupColumnAsCategory", "boolean")
        }
    ];
    return $5b7ccabde48fae90$var$validateProperties(params, validations, [
        ...$5b7ccabde48fae90$var$baseUpdateChartParams,
        "cellRange",
        "suppressChartRanges",
        "switchCategorySeries",
        "aggFunc",
        "seriesChartTypes",
        "seriesGroupType",
        "useGroupColumnAsCategory"
    ], "UpdateRangeChartParams");
}
function $5b7ccabde48fae90$var$validateUpdatePivotChartParams(params) {
    const validations = [
        ...$5b7ccabde48fae90$var$commonUpdateValidations()
    ];
    return $5b7ccabde48fae90$var$validateProperties(params, validations, [
        ...$5b7ccabde48fae90$var$baseUpdateChartParams
    ], "UpdatePivotChartParams");
}
function $5b7ccabde48fae90$var$validateUpdateCrossFilterChartParams(params, isEnterprise) {
    const validations = [
        ...$5b7ccabde48fae90$var$commonUpdateValidations(),
        ...$5b7ccabde48fae90$var$cellRangeValidations(isEnterprise)
    ];
    return $5b7ccabde48fae90$var$validateProperties(params, validations, [
        ...$5b7ccabde48fae90$var$baseUpdateChartParams,
        "cellRange",
        "suppressChartRanges",
        "aggFunc"
    ], "UpdateCrossFilterChartParams");
}
function $5b7ccabde48fae90$var$validateProperties(params, validations, validPropertyNames, paramsType) {
    let validatedProperties = void 0;
    for (const validation of validations){
        const { property: property, validationFn: validationFn, warnMessage: warnMessage, warnIfFixed: warnIfFixed } = validation;
        if (property in params) {
            const value = params[property];
            const validationResult = validationFn(value);
            if (validationResult === true) continue;
            if (validationResult === false) {
                (0, $437b23f6a393c3bf$export$2cf41453020eef66)(warnMessage(value));
                return false;
            }
            validatedProperties = validatedProperties || {
                ...params
            };
            validatedProperties[property] = validationResult;
            if (warnIfFixed) (0, $437b23f6a393c3bf$export$2cf41453020eef66)(warnMessage(value));
        }
    }
    if (validPropertyNames) {
        for (const property of Object.keys(params))if (!validPropertyNames.includes(property)) {
            (0, $437b23f6a393c3bf$export$2cf41453020eef66)(`Unexpected property supplied. ${paramsType} does not contain: \`${property}\`.`);
            return false;
        }
    }
    if (validatedProperties) return validatedProperties;
    return true;
}
// packages/ag-grid-enterprise/src/charts/chartComp/chartController.ts
var $5b7ccabde48fae90$var$DEFAULT_THEMES = [
    "ag-default",
    "ag-material",
    "ag-sheets",
    "ag-polychroma",
    "ag-vivid"
];
var $5b7ccabde48fae90$var$ChartController = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(model){
        super();
        this.model = model;
        this.isEnterprise = ()=>this.agChartsExports.isEnterprise;
    }
    wireBeans(beans) {
        this.rangeSvc = beans.rangeSvc;
        this.agChartsExports = beans.agChartsExports;
    }
    postConstruct() {
        this.setChartRange();
        if (this.model.unlinked) {
            if (this.rangeSvc) this.rangeSvc.setCellRanges([]);
        }
        const listener = this.updateForGridChange.bind(this, {});
        this.addManagedEventListeners({
            cellSelectionChanged: (event)=>{
                if (event.id && event.id === this.model.chartId) this.updateForRangeChange();
            },
            columnMoved: listener,
            columnPinned: listener,
            columnVisible: listener,
            columnRowGroupChanged: listener,
            modelUpdated: listener,
            cellValueChanged: this.updateForDataChange.bind(this),
            cellEditValuesChanged: this.updateForDataChange.bind(this)
        });
    }
    update(params) {
        if (!this.validUpdateType(params)) return false;
        const validationResult = $5b7ccabde48fae90$var$validateUpdateParams(params, this.agChartsExports.isEnterprise);
        if (!validationResult) return false;
        const validParams = validationResult === true ? params : validationResult;
        this.applyValidatedChartParams(validParams);
        return true;
    }
    applyValidatedChartParams(params) {
        const { chartId: chartId, chartType: chartType, chartThemeName: chartThemeName, unlinkChart: unlinkChart } = params;
        const common = {
            chartId: chartId,
            pivotChart: this.model.pivotChart,
            chartType: chartType ?? this.model.chartType,
            chartThemeName: chartThemeName ?? this.model.chartThemeName,
            unlinkChart: unlinkChart ?? this.model.unlinked,
            cellRange: this.model.suppliedCellRange,
            switchCategorySeries: this.model.switchCategorySeries,
            aggFunc: this.model.aggFunc,
            seriesChartTypes: void 0,
            suppressChartRanges: false,
            crossFiltering: false
        };
        const chartModelParams = {
            ...common
        };
        switch(params.type){
            case "rangeChartUpdate":
                chartModelParams.cellRange = this.createCellRange(params) ?? this.model.suppliedCellRange;
                chartModelParams.switchCategorySeries = params.switchCategorySeries ?? this.model.switchCategorySeries;
                chartModelParams.aggFunc = params.aggFunc ?? this.model.aggFunc;
                chartModelParams.seriesChartTypes = params.seriesChartTypes;
                chartModelParams.suppressChartRanges = params.suppressChartRanges ?? this.model.suppressChartRanges;
                chartModelParams.seriesGroupType = params.seriesGroupType ?? this.model.seriesGroupType;
                chartModelParams.useGroupColumnAsCategory = params.useGroupColumnAsCategory ?? this.model.useGroupColumnAsCategory;
                break;
            case "crossFilterChartUpdate":
                chartModelParams.cellRange = this.createCellRange(params) ?? this.model.suppliedCellRange;
                chartModelParams.switchCategorySeries = false;
                chartModelParams.aggFunc = params.aggFunc ?? this.model.aggFunc;
                chartModelParams.crossFiltering = true;
                chartModelParams.crossFilteringSort = this.model.crossFilteringSort;
                chartModelParams.suppressChartRanges = params.suppressChartRanges ?? this.model.suppressChartRanges;
                break;
            case "pivotChartUpdate":
                chartModelParams.switchCategorySeries = false;
                break;
        }
        this.model.updateModel(chartModelParams);
        const removeChartCellRanges = chartModelParams.unlinkChart || chartModelParams.suppressChartRanges;
        removeChartCellRanges ? this.rangeSvc?.setCellRanges([]) : this.setChartRange();
    }
    updateForGridChange(params) {
        if (this.model.unlinked) return;
        const { maintainColState: maintainColState, setColsFromRange: setColsFromRange } = params ?? {};
        this.model.updateCellRanges({
            maintainColState: maintainColState,
            setColsFromRange: setColsFromRange
        });
        this.model.updateData();
        this.setChartRange();
    }
    updateForDataChange() {
        if (this.model.unlinked) return;
        this.model.updateData();
        this.raiseChartModelUpdateEvent();
    }
    updateForRangeChange() {
        this.updateForGridChange({
            setColsFromRange: true
        });
        this.raiseChartRangeSelectionChangedEvent();
    }
    updateForPanelChange(params) {
        this.model.updateCellRanges(params);
        this.model.updateData();
        if (params.skipAnimation) this.getChartProxy().getChartRef().skipAnimations();
        this.setChartRange();
        this.raiseChartRangeSelectionChangedEvent();
    }
    updateThemeOverrides(updatedOverrides) {
        this.chartProxy.updateThemeOverrides(updatedOverrides);
    }
    getChartUpdateParams(updatedOverrides) {
        const selectedCols = this.getSelectedValueColState();
        const fields = selectedCols.map((c)=>({
                colId: c.colId,
                displayName: c.displayName
            }));
        const data = this.getChartData();
        const selectedDimensions = this.getSelectedDimensions();
        const model = this.model;
        const params = {
            data: data,
            groupData: model.groupChartData,
            grouping: this.isGrouping(),
            categories: selectedDimensions.map(({ colId: colId, displayName: displayName })=>{
                const chartDataType = model.categoryAxisType ?? model.getChartDataType(colId);
                return {
                    id: colId,
                    name: displayName,
                    chartDataType: chartDataType,
                    convertTime: chartDataType === "time" ? model.getConvertTime(colId) : void 0
                };
            }),
            fields: fields,
            chartId: this.getChartId(),
            getCrossFilteringContext: ()=>({
                    lastSelectedChartId: "xxx"
                }),
            //this.params.crossFilteringContext, //TODO
            seriesChartTypes: this.getSeriesChartTypes(),
            updatedOverrides: updatedOverrides,
            seriesGroupType: model.seriesGroupType
        };
        return this.isCategorySeriesSwitched() ? this.invertCategorySeriesParams(params) : params;
    }
    invertCategorySeriesParams(params) {
        const [category] = params.categories;
        const categories = [
            {
                id: $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY,
                name: ""
            }
        ];
        const fields = params.data.map((value, index)=>{
            const categoryKey = `${category.id}:${index}`;
            const categoryValue = value[category.id];
            const seriesLabel = categoryValue == null ? "" : String(categoryValue);
            return {
                colId: categoryKey,
                displayName: seriesLabel
            };
        });
        const data = params.fields.map((field)=>{
            const row = {
                [$5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY]: field.displayName
            };
            for (const [index, value] of params.data.entries()){
                const categoryKey = `${category.id}:${index}`;
                const seriesLabelValue = value[field.colId];
                row[categoryKey] = seriesLabelValue;
            }
            return row;
        });
        return {
            ...params,
            categories: categories,
            fields: fields,
            data: data
        };
    }
    getChartModel() {
        const modelType = this.model.pivotChart ? "pivot" : "range";
        const seriesChartTypes = this.isComboChart() ? this.model.comboChartModel.seriesChartTypes : void 0;
        return {
            modelType: modelType,
            chartId: this.model.chartId,
            chartType: this.model.chartType,
            chartThemeName: this.getChartThemeName(),
            chartOptions: this.chartProxy?.getChartThemeOverrides(),
            chartPalette: this.chartProxy?.getChartPalette(),
            cellRange: this.getCellRangeParams(),
            switchCategorySeries: this.model.switchCategorySeries,
            suppressChartRanges: this.model.suppressChartRanges,
            aggFunc: this.model.aggFunc,
            unlinkChart: this.model.unlinked,
            seriesChartTypes: seriesChartTypes,
            seriesGroupType: this.model.seriesGroupType,
            useGroupColumnAsCategory: this.model.useGroupColumnAsCategory
        };
    }
    getChartId() {
        return this.model.chartId;
    }
    getChartData() {
        return this.model.chartData;
    }
    getChartType() {
        return this.model.chartType;
    }
    setChartType(chartType) {
        this.updateMultiSeriesAndCategory(this.model.chartType, chartType);
        this.model.chartType = chartType;
        this.model.comboChartModel.updateSeriesChartTypes();
        this.model.switchCategorySeries = false;
        this.model.categoryAxisType = void 0;
        this.model.seriesGroupType = void 0;
        this.raiseChartModelUpdateEvent();
    }
    isCategorySeriesSwitched() {
        return this.model.switchCategorySeries && !this.model.isGrouping();
    }
    switchCategorySeries(inverted) {
        if (!$5b7ccabde48fae90$var$supportsInvertedCategorySeries(this.getChartType())) return;
        this.model.switchCategorySeries = inverted;
        this.raiseChartModelUpdateEvent();
    }
    getAggFunc() {
        return this.model.aggFunc;
    }
    setAggFunc(value, silent) {
        if (this.model.aggFunc === value) return;
        this.model.aggFunc = value;
        if (silent) return;
        this.model.updateData();
        this.raiseChartModelUpdateEvent();
    }
    updateMultiSeriesAndCategory(previousChartType, chartType) {
        const updateForMax = (columns, maxNum)=>{
            let numSelected = 0;
            for (const colState of columns){
                if (!colState.selected) continue;
                if (numSelected >= maxNum) colState.selected = false;
                else numSelected++;
            }
            if (numSelected === 0) columns[0].selected = true;
        };
        const maxNumDimensions = $5b7ccabde48fae90$var$getMaxNumCategories(chartType);
        const maxNumSeries = $5b7ccabde48fae90$var$getMaxNumSeries(chartType);
        const updateDimensionColState = maxNumDimensions != null && ($5b7ccabde48fae90$var$getMaxNumCategories(previousChartType) ?? 100) > (maxNumDimensions ?? 100);
        const updateValueColState = maxNumSeries != null && ($5b7ccabde48fae90$var$getMaxNumSeries(previousChartType) ?? 100) > (maxNumSeries ?? 100);
        if (updateDimensionColState) updateForMax(this.model.dimensionColState, maxNumDimensions);
        if (updateValueColState) updateForMax(this.model.valueColState, maxNumSeries);
        if (updateDimensionColState || updateValueColState) {
            this.model.resetCellRanges(updateDimensionColState, updateValueColState);
            this.setChartRange(true);
        }
    }
    setChartThemeName(chartThemeName, silent) {
        this.model.chartThemeName = chartThemeName;
        if (!silent) this.raiseChartModelUpdateEvent();
    }
    getChartThemeName() {
        return this.model.chartThemeName;
    }
    isPivotChart() {
        return this.model.pivotChart;
    }
    isPivotMode() {
        return this.model.isPivotMode();
    }
    isGrouping() {
        return this.model.isGrouping();
    }
    isCrossFilterChart() {
        return this.model.crossFiltering;
    }
    getThemeNames() {
        return this.gos.get("chartThemes") || $5b7ccabde48fae90$var$DEFAULT_THEMES;
    }
    getThemes() {
        const themeNames = this.getThemeNames();
        return themeNames.map((themeName)=>{
            const stockTheme = $5b7ccabde48fae90$var$isStockTheme(themeName, this.agChartsExports._Theme);
            const theme = stockTheme ? themeName : this.chartProxy.lookupCustomChartTheme(themeName);
            return this.agChartsExports._Theme.getChartTheme(theme);
        });
    }
    getPalettes() {
        const themes = this.getThemes();
        return themes.map((theme)=>{
            return theme.palette;
        });
    }
    getSelectedValueColState() {
        return this.model.getValueColState().filter((cs)=>cs.selected);
    }
    getSelectedDimensions() {
        return this.model.getSelectedDimensions();
    }
    getColStateForMenu() {
        return {
            dimensionCols: this.model.dimensionColState,
            valueCols: this.model.getValueColState()
        };
    }
    setChartRange(silent = false) {
        if (this.rangeSvc && !this.model.suppressChartRanges && !this.model.unlinked) this.rangeSvc.setCellRanges(this.getCellRanges());
        if (!silent) this.raiseChartModelUpdateEvent();
    }
    detachChartRange() {
        this.model.unlinked = !this.model.unlinked;
        if (this.model.unlinked) {
            if (this.rangeSvc) this.rangeSvc.setCellRanges([]);
        } else this.updateForGridChange();
        this.dispatchLocalEvent({
            type: "chartLinkedChanged"
        });
    }
    setChartProxy(chartProxy) {
        this.chartProxy = chartProxy;
    }
    getChartProxy() {
        return this.chartProxy;
    }
    isActiveXYChart() {
        return [
            "scatter",
            "bubble"
        ].includes(this.getChartType());
    }
    isChartLinked() {
        return !this.model.unlinked;
    }
    customComboExists() {
        const savedCustomSeriesChartTypes = this.model.comboChartModel.savedCustomSeriesChartTypes;
        return savedCustomSeriesChartTypes && savedCustomSeriesChartTypes.length > 0;
    }
    getSeriesChartTypes() {
        return this.model.comboChartModel.seriesChartTypes;
    }
    isComboChart(chartType) {
        return this.model.isComboChart(chartType);
    }
    updateSeriesChartType(colId, chartType, secondaryAxis) {
        const seriesChartType = this.model.comboChartModel.seriesChartTypes.find((s2)=>s2.colId === colId);
        if (seriesChartType) {
            const updateChartType = this.model.chartType !== "customCombo";
            if (updateChartType) this.model.chartType = "customCombo";
            const prevSeriesChartType = seriesChartType.chartType;
            if (chartType != null) seriesChartType.chartType = chartType;
            if (secondaryAxis != null) seriesChartType.secondaryAxis = secondaryAxis;
            this.model.comboChartModel.savedCustomSeriesChartTypes = this.model.comboChartModel.seriesChartTypes;
            this.model.comboChartModel.updateSeriesChartTypes();
            this.updateForDataChange();
            if (updateChartType) this.dispatchLocalEvent({
                type: "chartTypeChanged"
            });
            if (prevSeriesChartType !== chartType) this.dispatchLocalEvent({
                type: "chartSeriesChartTypeChanged"
            });
            this.raiseChartOptionsChangedEvent();
        }
    }
    getActiveSeriesChartTypes() {
        const selectedColIds = this.getSelectedValueColState().map((c)=>c.colId);
        return this.getSeriesChartTypes().filter((s2)=>selectedColIds.includes(s2.colId));
    }
    getChartSeriesTypes(chartType) {
        const targetChartType = chartType ?? this.getChartType();
        return this.isComboChart(targetChartType) ? [
            "line",
            "bar",
            "area"
        ] : [
            $5b7ccabde48fae90$var$getSeriesType(targetChartType)
        ];
    }
    getChartSeriesType() {
        const seriesChartTypes = this.getSeriesChartTypes();
        if (seriesChartTypes.length === 0) return "bar";
        const ct = seriesChartTypes[0].chartType;
        if (ct === "columnLineCombo") return "bar";
        if (ct === "areaColumnCombo") return "area";
        return $5b7ccabde48fae90$var$getSeriesType(ct);
    }
    getCellRanges() {
        return [
            this.model.dimensionCellRange,
            this.model.valueCellRange
        ].filter((r)=>r);
    }
    createCellRange(params) {
        return params.cellRange && this.rangeSvc?.createPartialCellRangeFromRangeParams(params.cellRange, true);
    }
    validUpdateType(params) {
        if (!params.type) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(136);
            return false;
        }
        const chartTypeMap = {
            "Range Chart": ()=>!this.isPivotChart() && !this.isCrossFilterChart(),
            "Pivot Chart": ()=>this.isPivotChart(),
            "Cross Filter Chart": ()=>this.isCrossFilterChart()
        };
        const currentChartType = Object.keys(chartTypeMap).find((type)=>chartTypeMap[type]()) ?? "Range Chart";
        const valid = params.type === `${currentChartType[0].toLowerCase()}${currentChartType.slice(1).replace(/ /g, "")}Update`;
        if (!valid) (0, $437b23f6a393c3bf$export$545083624300f13d)(137, {
            currentChartType: currentChartType,
            type: params.type
        });
        return valid;
    }
    getCellRangeParams() {
        const cellRanges = this.getCellRanges();
        const firstCellRange = cellRanges[0];
        const startRow = firstCellRange?.startRow || null;
        const endRow = firstCellRange?.endRow || null;
        return {
            rowStartIndex: startRow?.rowIndex ?? null,
            rowStartPinned: startRow?.rowPinned,
            rowEndIndex: endRow?.rowIndex ?? null,
            rowEndPinned: endRow?.rowPinned,
            columns: cellRanges.reduce((columns, value)=>columns.concat(value.columns.map((c)=>c.getId())), [])
        };
    }
    setCategoryAxisType(categoryAxisType) {
        this.model.categoryAxisType = categoryAxisType;
        this.raiseChartModelUpdateEvent();
    }
    getSeriesGroupType() {
        return this.model.seriesGroupType ?? this.chartProxy.getSeriesGroupType();
    }
    setSeriesGroupType(seriesGroupType) {
        this.model.seriesGroupType = seriesGroupType;
        this.raiseChartModelUpdateEvent();
    }
    raiseChartModelUpdateEvent() {
        this.dispatchLocalEvent({
            type: "chartModelUpdate"
        });
        this.raiseChartOptionsChangedEvent();
    }
    raiseChartUpdatedEvent() {
        this.dispatchLocalEvent({
            type: "chartUpdated"
        });
    }
    raiseChartApiUpdateEvent() {
        this.dispatchLocalEvent({
            type: "chartApiUpdate"
        });
    }
    raiseChartOptionsChangedEvent() {
        const { chartId: chartId, chartType: chartType } = this.getChartModel();
        this.eventSvc.dispatchEvent({
            type: "chartOptionsChanged",
            chartId: chartId,
            chartType: chartType,
            chartThemeName: this.getChartThemeName(),
            chartOptions: this.chartProxy?.getChartThemeOverrides()
        });
    }
    raiseChartRangeSelectionChangedEvent() {
        this.eventSvc.dispatchEvent({
            type: "chartRangeSelectionChanged",
            id: this.model.chartId,
            chartId: this.model.chartId,
            cellRange: this.getCellRangeParams()
        });
    }
    destroy() {
        super.destroy();
        if (this.rangeSvc) this.rangeSvc.setCellRanges([]);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/areaChartProxy.ts
var $5b7ccabde48fae90$var$AreaChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params) {
        const axes = {
            x: {
                type: this.getXAxisType(params),
                position: "bottom"
            },
            y: {
                type: "number",
                position: "left"
            }
        };
        if (this.isNormalised()) axes.y.label = {
            ...axes.y.label,
            formatter: (params2)=>Math.round(params2.value) + "%"
        };
        return axes;
    }
    getSeries(params) {
        const [category] = params.categories;
        const series = params.fields.map((f)=>({
                type: this.standaloneChartType,
                xKey: category.id,
                xName: category.name,
                yKey: f.colId,
                yName: f.displayName,
                normalizedTo: this.chartType === "normalizedArea" ? 100 : void 0,
                stacked: [
                    "normalizedArea",
                    "stackedArea"
                ].includes(this.chartType)
            }));
        return this.crossFiltering ? this.extractLineAreaCrossFilterSeries(series, params) : series;
    }
    isNormalised() {
        return !this.crossFiltering && this.chartType === "normalizedArea";
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/barChartProxy.ts
var $5b7ccabde48fae90$var$HORIZONTAL_CHART_TYPES = /* @__PURE__ */ new Set([
    "bar",
    "groupedBar",
    "stackedBar",
    "normalizedBar"
]);
var $5b7ccabde48fae90$var$BarChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params) {
        const axes = {
            x: {
                type: this.getXAxisType(params),
                position: this.isHorizontal() ? "left" : "bottom"
            },
            y: {
                type: "number",
                position: this.isHorizontal() ? "bottom" : "left"
            }
        };
        if (this.isNormalised()) axes.y.label = {
            ...axes.y.label,
            formatter: (params2)=>Math.round(params2.value) + "%"
        };
        return axes;
    }
    getSeries(params) {
        const [category] = params.categories;
        const series = params.fields.map((f)=>({
                type: this.standaloneChartType,
                direction: this.isHorizontal() ? "horizontal" : "vertical",
                stacked: this.crossFiltering || $5b7ccabde48fae90$var$isStacked(this.chartType),
                normalizedTo: this.isNormalised() ? 100 : void 0,
                xKey: category.id,
                xName: category.name,
                yKey: f.colId,
                yName: f.displayName
            }));
        return this.crossFiltering ? this.extractCrossFilterSeries(series) : series;
    }
    extractCrossFilterSeries(series) {
        const allSeries = [];
        for(let i = 0; i < series.length; i++){
            const commonSeries = series[i];
            const primarySeries = {
                ...commonSeries,
                listeners: {
                    seriesNodeClick: this.crossFilterCallback
                }
            };
            const filteredOutSeries = {
                ...primarySeries,
                yKey: `${primarySeries.yKey}-filtered-out`,
                showInLegend: false
            };
            allSeries.push(primarySeries);
            allSeries.push(filteredOutSeries);
        }
        return allSeries;
    }
    isNormalised() {
        const normalisedCharts = [
            "normalizedColumn",
            "normalizedBar"
        ];
        return !this.crossFiltering && normalisedCharts.includes(this.chartType);
    }
    isHorizontal() {
        return $5b7ccabde48fae90$var$HORIZONTAL_CHART_TYPES.has(this.chartType);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/lineChartProxy.ts
var $5b7ccabde48fae90$var$LineChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params) {
        const axes = {
            x: {
                type: this.getXAxisType(params),
                position: "bottom"
            },
            y: {
                type: "number",
                position: "left"
            }
        };
        if (this.isNormalised()) axes.y.label = {
            ...axes.y.label,
            formatter: (params2)=>Math.round(params2.value) + "%"
        };
        return axes;
    }
    getSeries(params) {
        const [category] = params.categories;
        const stacked = [
            "normalizedLine",
            "stackedLine"
        ].includes(this.chartType);
        const series = params.fields.map((f)=>({
                type: this.standaloneChartType,
                xKey: category.id,
                xName: category.name,
                yKey: f.colId,
                yName: f.displayName,
                normalizedTo: stacked && this.isNormalised() ? 100 : void 0,
                stacked: stacked
            }));
        return this.crossFiltering ? this.extractLineAreaCrossFilterSeries(series, params) : series;
    }
    isNormalised() {
        const normalisedCharts = [
            "normalizedLine"
        ];
        return !this.crossFiltering && normalisedCharts.includes(this.chartType);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/cartesian/scatterChartProxy.ts
var $5b7ccabde48fae90$var$ScatterChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(_params) {
        return {
            x: {
                type: "number",
                position: "bottom"
            },
            y: {
                type: "number",
                position: "left"
            }
        };
    }
    getSeries(params) {
        const [category] = params.categories;
        const paired = this.isPaired();
        const seriesDefinitions = this.getSeriesDefinitions(params.fields, paired);
        const labelFieldDefinition = category.id === $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY ? void 0 : category;
        const series = seriesDefinitions.map((seriesDefinition)=>{
            if (seriesDefinition?.sizeField) {
                const opts2 = {
                    type: "bubble",
                    xKey: seriesDefinition.xField.colId,
                    xName: seriesDefinition.xField.displayName ?? void 0,
                    yKey: seriesDefinition.yField.colId,
                    yName: seriesDefinition.yField.displayName ?? void 0,
                    title: `${seriesDefinition.yField.displayName} vs ${seriesDefinition.xField.displayName}`,
                    sizeKey: seriesDefinition.sizeField.colId,
                    sizeName: seriesDefinition.sizeField.displayName ?? "",
                    labelKey: labelFieldDefinition ? labelFieldDefinition.id : seriesDefinition.yField.colId,
                    labelName: labelFieldDefinition ? labelFieldDefinition.name : void 0
                };
                return opts2;
            }
            const opts = {
                type: "scatter",
                xKey: seriesDefinition.xField.colId,
                xName: seriesDefinition.xField.displayName ?? void 0,
                yKey: seriesDefinition.yField.colId,
                yName: seriesDefinition.yField.displayName ?? void 0,
                title: `${seriesDefinition.yField.displayName} vs ${seriesDefinition.xField.displayName}`,
                labelKey: labelFieldDefinition ? labelFieldDefinition.id : seriesDefinition.yField.colId,
                labelName: labelFieldDefinition ? labelFieldDefinition.name : void 0
            };
            return opts;
        });
        return this.crossFiltering ? this.extractCrossFilterSeries(series, params) : series;
    }
    extractCrossFilterSeries(series, params) {
        const { data: data } = params;
        const filteredOutKey = (key)=>`${key}-filtered-out`;
        const calcMarkerDomain = (data2, sizeKey)=>{
            const markerDomain = [
                Infinity,
                -Infinity
            ];
            if (sizeKey != null) for (const datum of data2){
                const value = datum[sizeKey] ?? datum[filteredOutKey(sizeKey)];
                if (value < markerDomain[0]) markerDomain[0] = value;
                if (value > markerDomain[1]) markerDomain[1] = value;
            }
            if (markerDomain[0] <= markerDomain[1]) return markerDomain;
            return void 0;
        };
        const updatePrimarySeries = (series2)=>{
            let markerDomain = void 0;
            if (series2.type === "bubble") {
                const { sizeKey: sizeKey } = series2;
                markerDomain = calcMarkerDomain(data, sizeKey);
            }
            return {
                ...series2,
                domain: markerDomain,
                highlight: {
                    highlightedItem: {
                        fill: "yellow"
                    }
                },
                listeners: {
                    ...series2.listeners,
                    seriesNodeClick: this.crossFilterCallback
                }
            };
        };
        const updateFilteredOutSeries = (series2)=>{
            const { yKey: yKey, xKey: xKey } = series2;
            let alteredSizeKey = {};
            if (series2.type === "bubble") alteredSizeKey = {
                sizeKey: filteredOutKey(series2.sizeKey)
            };
            return {
                ...series2,
                ...alteredSizeKey,
                yKey: filteredOutKey(yKey),
                xKey: filteredOutKey(xKey),
                showInLegend: false,
                listeners: {
                    ...series2.listeners,
                    seriesNodeClick: (e)=>{
                        const value = e.datum[filteredOutKey(xKey)];
                        const filterableEvent = {
                            ...e,
                            xKey: xKey,
                            datum: {
                                ...e.datum,
                                [xKey]: value
                            }
                        };
                        this.crossFilterCallback(filterableEvent);
                    }
                }
            };
        };
        const updatedSeries = series.map(updatePrimarySeries);
        return [
            ...updatedSeries,
            ...updatedSeries.map(updateFilteredOutSeries)
        ];
    }
    getSeriesDefinitions(fields, paired) {
        if (fields.length < 2) return [];
        const isBubbleChart = this.chartType === "bubble";
        if (paired) {
            if (isBubbleChart) return fields.map((currentXField, i)=>i % 3 === 0 ? {
                    xField: currentXField,
                    yField: fields[i + 1],
                    sizeField: fields[i + 2]
                } : null).filter((x)=>x?.yField && x.sizeField);
            return fields.map((currentXField, i)=>i % 2 === 0 ? {
                    xField: currentXField,
                    yField: fields[i + 1]
                } : null).filter((x)=>x?.yField);
        }
        const xField = fields[0];
        if (isBubbleChart) return fields.map((yField, i)=>i % 2 === 1 ? {
                xField: xField,
                yField: yField,
                sizeField: fields[i + 1]
            } : null).filter((x)=>x?.sizeField);
        return fields.filter((value, i)=>i > 0).map((yField)=>({
                xField: xField,
                yField: yField
            }));
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/combo/comboChartProxy.ts
var $5b7ccabde48fae90$var$ComboChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    getAxes(params) {
        const fields = params ? params.fields : [];
        const fieldsMap = new Map(fields.map((f)=>[
                f.colId,
                f
            ]));
        const { primaryYKeys: primaryYKeys, secondaryYKeys: secondaryYKeys } = this.getYKeys(fields, params.seriesChartTypes);
        const axes = {
            x: {
                type: this.getXAxisType(params),
                position: "bottom"
            }
        };
        if (primaryYKeys.length > 0) axes.y = {
            type: "number",
            position: "left"
        };
        if (secondaryYKeys.length > 0) secondaryYKeys.forEach((secondaryYKey)=>{
            const field = fieldsMap.get(secondaryYKey);
            const secondaryAxisIsVisible = field && field.colId === secondaryYKey;
            if (!secondaryAxisIsVisible) return;
            const secondaryAxisOptions = {
                type: "number",
                position: "right"
            };
            axes[`y_${secondaryYKey}`] = secondaryAxisOptions;
        });
        return axes;
    }
    getSeries(params) {
        const { fields: fields, seriesChartTypes: seriesChartTypes } = params;
        const [category] = params.categories;
        return fields.map((field)=>{
            const seriesChartType = seriesChartTypes.find((s2)=>s2.colId === field.colId);
            if (seriesChartType) {
                const chartType = seriesChartType.chartType;
                const grouped = [
                    "groupedColumn",
                    "groupedBar"
                ].includes(chartType);
                const groupedOpts = grouped ? {
                    grouped: true
                } : {};
                const yKeyAxis = seriesChartType.secondaryAxis ? `y_${field.colId}` : "y";
                return {
                    type: $5b7ccabde48fae90$var$getSeriesType(chartType),
                    xKey: category.id,
                    yKey: field.colId,
                    yName: field.displayName,
                    yKeyAxis: yKeyAxis,
                    stacked: [
                        "stackedArea",
                        "stackedColumn"
                    ].includes(chartType),
                    ...groupedOpts
                };
            }
        });
    }
    getYKeys(fields, seriesChartTypes) {
        const primaryYKeys = [];
        const secondaryYKeys = [];
        for (const field of fields){
            const colId = field.colId;
            const seriesChartType = seriesChartTypes.find((s2)=>s2.colId === colId);
            if (seriesChartType) seriesChartType.secondaryAxis ? secondaryYKeys.push(colId) : primaryYKeys.push(colId);
        }
        return {
            primaryYKeys: primaryYKeys,
            secondaryYKeys: secondaryYKeys
        };
    }
    setSeriesChartThemeDefaults(overrides) {
        const seriesOverrides = this.getSeriesChartThemeDefaults();
        if (!seriesOverrides) return;
        const chartTypes = /* @__PURE__ */ new Set();
        for (const seriesChartType of this.chartProxyParams.seriesChartTypes)chartTypes.add(seriesChartType.chartType);
        for (const chartType of chartTypes)overrides[$5b7ccabde48fae90$var$getSeriesType(chartType)] = seriesOverrides;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/chartProxies/pie/pieChartProxy.ts
function $5b7ccabde48fae90$var$calculateOffsets(offset) {
    const outerRadiusOffset = offset.currentOffset;
    offset.currentOffset -= offset.offsetAmount;
    const innerRadiusOffset = offset.currentOffset;
    offset.currentOffset -= offset.offsetAmount;
    return {
        outerRadiusOffset: outerRadiusOffset,
        innerRadiusOffset: innerRadiusOffset
    };
}
var $5b7ccabde48fae90$var$PieChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    getUpdateOptions(params, commonChartOptions) {
        return {
            ...commonChartOptions,
            data: this.crossFiltering ? this.getCrossFilterData(params) : params.data,
            series: this.getSeries(params)
        };
    }
    getSeries(params) {
        const [category] = params.categories;
        const numFields = params.fields.length;
        const offset = {
            currentOffset: 0,
            offsetAmount: numFields > 1 ? 20 : 40
        };
        const series = this.getFields(params).map((f)=>{
            const options = {
                type: this.standaloneChartType,
                angleKey: f.colId,
                angleName: f.displayName,
                sectorLabelKey: f.colId,
                calloutLabelName: category.name,
                calloutLabelKey: category.id
            };
            if (this.chartType === "donut" || this.chartType === "doughnut") {
                const { outerRadiusOffset: outerRadiusOffset, innerRadiusOffset: innerRadiusOffset } = $5b7ccabde48fae90$var$calculateOffsets(offset);
                const title = f.displayName ? {
                    title: {
                        text: f.displayName,
                        showInLegend: numFields > 1
                    }
                } : void 0;
                return {
                    ...options,
                    type: "donut",
                    outerRadiusOffset: outerRadiusOffset,
                    innerRadiusOffset: innerRadiusOffset,
                    ...title
                };
            }
            return options;
        });
        return this.crossFiltering ? this.extractCrossFilterSeries(series) : series;
    }
    getCrossFilterData(params) {
        const colId = params.fields[0].colId;
        const filteredOutColId = `${colId}-filtered-out`;
        return params.data.map((d)=>{
            const total = d[colId] + d[filteredOutColId];
            d[`${colId}-total`] = total;
            d[filteredOutColId] = 1;
            d[colId] = d[colId] / total;
            return d;
        });
    }
    extractCrossFilterSeries(series) {
        const primarySeries = series[0];
        const angleKey = primarySeries.angleKey;
        const commonOptions = {
            ...primarySeries,
            radiusMin: 0,
            radiusMax: 1,
            listeners: {
                seriesNodeClick: this.crossFilterCallback
            },
            legendItemKey: primarySeries.calloutLabelKey,
            angleKey: `${angleKey}-total`
        };
        const primaryOptions = {
            ...commonOptions,
            radiusKey: angleKey,
            sectorLabelKey: `${angleKey}-total`
        };
        const filteredOutOptions = {
            ...commonOptions,
            radiusKey: `${angleKey}-filtered-out`,
            showInLegend: false
        };
        return [
            filteredOutOptions,
            primaryOptions
        ];
    }
    getFields(params) {
        return this.chartType === "pie" ? params.fields.slice(0, 1) : params.fields;
    }
    getSeriesChartThemeDefaults() {
        return {
            series: {
                highlight: $5b7ccabde48fae90$var$getSeriesHighlight(this.crossFiltering)
            }
        };
    }
};
var $5b7ccabde48fae90$var$ChartToolbar = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(){
        super(/* html */ `<div class="ag-chart-menu" data-ref="eMenu"></div>`);
        this.eMenu = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.buttonListenersDestroyFuncs = [];
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    updateParams(params) {
        const { buttons: buttons } = params;
        this.createButtons(buttons);
    }
    createButtons(buttons) {
        for (const func of this.buttonListenersDestroyFuncs)func?.();
        this.buttonListenersDestroyFuncs = [];
        const menuEl = this.eMenu;
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(menuEl);
        for (const buttonConfig of buttons){
            const { buttonName: buttonName, iconName: iconName, callback: callback } = buttonConfig;
            const buttonEl = this.createButton(iconName);
            const tooltipTitle = this.chartTranslation.translate(buttonName + "ToolbarTooltip");
            if (tooltipTitle && buttonEl instanceof HTMLElement) buttonEl.title = tooltipTitle;
            this.buttonListenersDestroyFuncs.push(...this.addManagedElementListeners(buttonEl, {
                click: (event)=>callback(event.currentTarget)
            }));
            menuEl.appendChild(buttonEl);
        }
    }
    createButton(iconName) {
        const buttonEl = (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(iconName, this.beans);
        buttonEl.classList.add("ag-chart-menu-icon");
        const wrapperEl = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "button",
            attrs: {
                type: "button"
            },
            cls: "ag-chart-menu-toolbar-button"
        });
        wrapperEl.appendChild(buttonEl);
        return wrapperEl;
    }
    destroy() {
        this.buttonListenersDestroyFuncs = [];
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/widgets/agPillSelect.css-GENERATED.ts
var $5b7ccabde48fae90$var$agPillSelectCSS = /*css*/ `.ag-pill-select{display:flex;flex-direction:column}.ag-pill-select .ag-column-drop-list{padding:0}:where(.ag-pill-select){.ag-select{padding-top:var(--ag-spacing)}.ag-picker-field-wrapper{background-color:transparent;border:0}.ag-picker-field-display{cursor:pointer;font-weight:500}.ag-picker-field-display,.ag-picker-field-icon{color:var(--ag-chart-menu-label-color)}}`;
// packages/ag-grid-enterprise/src/charts/widgets/agPillSelect.ts
var $5b7ccabde48fae90$var$AgPillSelect = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(config){
        super(/* html */ `<div class="ag-pill-select" role="presentation"></div>`);
        this.config = config ?? {};
        const { selectedValueList: selectedValueList, valueFormatter: valueFormatter, valueList: valueList } = this.config;
        this.selectedValues = selectedValueList ?? [];
        this.valueList = valueList ?? [];
        this.valueFormatter = valueFormatter ?? ((value)=>(0, $437b23f6a393c3bf$export$3df06b741968da82)(value));
        this.registerCSS($5b7ccabde48fae90$var$agPillSelectCSS);
    }
    postConstruct() {
        const { ariaLabel: ariaLabel, onValuesChange: onValuesChange, dragSourceId: dragSourceId } = this.config;
        this.dropZonePanel = this.createManagedBean(new $5b7ccabde48fae90$var$PillSelectDropZonePanel({
            getValues: ()=>this.selectedValues,
            setValues: (values)=>this.updateValues(values),
            isDraggable: ()=>this.selectedValues.length > 1
        }, (value)=>this.valueFormatter(value), ariaLabel, dragSourceId));
        const eGui = this.getGui();
        eGui.appendChild(this.dropZonePanel.getGui());
        this.initSelect();
        if (onValuesChange != null) this.onValuesChange = onValuesChange;
    }
    setValues(valueList, selectedValues) {
        const { added: added, removed: removed, updated: updated } = this.getChanges(this.valueList, valueList);
        let refreshSelect = false;
        if (added.length || removed.length || updated.length) refreshSelect = true;
        this.valueList = valueList;
        this.updateValues(selectedValues, refreshSelect, true);
        return this;
    }
    setValueFormatter(valueFormatter) {
        this.valueFormatter = valueFormatter;
        return this;
    }
    initSelect() {
        const options = this.createSelectOptions();
        if (!options.length) return false;
        const { selectPlaceholder: placeholder } = this.config;
        this.eSelect = this.createBean(new (0, $437b23f6a393c3bf$export$6f9c460854d56032)({
            options: options,
            placeholder: placeholder,
            onValueChange: (value)=>this.addValue(value),
            pickerIcon: "chartsMenuAdd"
        }));
        this.getGui().appendChild(this.eSelect.getGui());
        return true;
    }
    createSelectOptions() {
        const options = [];
        const { maxSelection: maxSelection } = this.config;
        if (maxSelection && this.selectedValues.length >= maxSelection) return options;
        for (const value of this.valueList)if (!this.selectedValues.includes(value)) options.push({
            value: value,
            text: this.valueFormatter(value)
        });
        return options;
    }
    addValue(value) {
        this.dropZonePanel.addItem(value);
    }
    updateValues(values, forceRefreshSelect, silent) {
        const previousSelectedValues = this.selectedValues;
        this.selectedValues = values;
        const changes = this.getChanges(previousSelectedValues, values);
        const refreshSelect = forceRefreshSelect || changes.added.length || changes.removed.length;
        const activeElement = (0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans);
        const selectHasFocus = this.eSelect?.getGui().contains(activeElement);
        const dropZoneHasFocus = this.dropZonePanel?.getGui().contains(activeElement);
        if (!silent) this.onValuesChange?.(changes);
        const emptyRefreshedSelect = refreshSelect ? !this.refreshSelect() : false;
        this.dropZonePanel.refreshGui();
        if (refreshSelect && selectHasFocus) {
            if (emptyRefreshedSelect) this.dropZonePanel.focusList(true);
            else this.eSelect?.getFocusableElement().focus();
        }
        if (dropZoneHasFocus && !values.length) this.eSelect?.getFocusableElement().focus();
    }
    getChanges(previousSelectedValues, newSelectedValues) {
        const added = newSelectedValues.filter((value)=>!previousSelectedValues.includes(value));
        const removed = previousSelectedValues.filter((value)=>!newSelectedValues.includes(value));
        const updated = newSelectedValues.filter((value, index)=>previousSelectedValues[index] !== value);
        return {
            added: added,
            removed: removed,
            updated: updated,
            selected: newSelectedValues
        };
    }
    refreshSelect() {
        if (!this.eSelect) return this.initSelect();
        const options = this.createSelectOptions();
        if (!options.length) {
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(this.eSelect.getGui());
            this.eSelect = this.destroyBean(this.eSelect);
            return false;
        }
        this.eSelect.clearOptions().addOptions(options).setValue(void 0, true);
        return true;
    }
    destroy() {
        this.destroyBean(this.eSelect);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$PillSelectDragComp = class extends $5b7ccabde48fae90$var$PillDragComp {
    constructor(value, dragSourceDropTarget, ghost, valueFormatter, draggable, sourceId){
        super(dragSourceDropTarget, ghost, false);
        this.value = value;
        this.valueFormatter = valueFormatter;
        this.draggable = draggable;
        this.sourceId = sourceId;
    }
    getItem() {
        return this.value;
    }
    getDisplayName() {
        return this.valueFormatter(this.value);
    }
    getAriaDisplayName() {
        return this.getDisplayName();
    }
    getTooltip() {
        return void 0;
    }
    createGetDragItem() {
        return ()=>({
                value: this.value
            });
    }
    getDragSourceType() {
        return (0, $437b23f6a393c3bf$export$46ba5a92125911d9).ChartPanel;
    }
    getDragSourceId() {
        return this.sourceId;
    }
    isMovable() {
        return this.isDraggable();
    }
    isDraggable() {
        return this.draggable;
    }
};
var $5b7ccabde48fae90$var$PillSelectDropZonePanel = class extends $5b7ccabde48fae90$var$PillDropZonePanel {
    constructor(model, valueFormatter, ariaLabel, sourceId){
        super(false);
        this.model = model;
        this.valueFormatter = valueFormatter;
        this.ariaLabel = ariaLabel;
        this.sourceId = sourceId;
    }
    postConstruct() {
        super.init();
    }
    isItemDroppable(item, draggingEvent) {
        return this.isSourceEventFromTarget(draggingEvent) || this.sourceId != null && this.sourceId === draggingEvent.dragSource.sourceId;
    }
    updateItems(items) {
        this.model.setValues(items);
    }
    getExistingItems() {
        return this.model.getValues();
    }
    getIconName() {
        return this.isPotentialDndItems() ? "move" : "notAllowed";
    }
    getAriaLabel() {
        return this.ariaLabel;
    }
    createPillComponent(item, dropTarget, ghost) {
        return new $5b7ccabde48fae90$var$PillSelectDragComp(item, dropTarget, ghost, this.valueFormatter, this.model.isDraggable(), this.sourceId);
    }
    getItems(dragItem) {
        return [
            dragItem.value
        ];
    }
    isInterestedIn(type) {
        return type === (0, $437b23f6a393c3bf$export$46ba5a92125911d9).ChartPanel;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/data/dragDataPanel.ts
var $5b7ccabde48fae90$var$DragDataPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartController, allowMultipleSelection, maxSelection, template){
        super(template);
        this.chartController = chartController;
        this.allowMultipleSelection = allowMultipleSelection;
        this.maxSelection = maxSelection;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    addItem(eItem) {
        this.groupComp.addItem(eItem);
    }
    createGroup(columns, valueFormatter, selectLabelKey, dragSourceId, skipAnimation) {
        if (this.allowMultipleSelection) {
            const selectedValueList = columns.filter((col)=>col.selected);
            this.valuePillSelect = this.groupComp.createManagedBean(new $5b7ccabde48fae90$var$AgPillSelect({
                valueList: columns,
                selectedValueList: selectedValueList,
                valueFormatter: valueFormatter,
                selectPlaceholder: this.chartTranslation.translate(selectLabelKey),
                dragSourceId: dragSourceId,
                onValuesChange: (params)=>this.onValueChange(params),
                maxSelection: this.maxSelection
            }));
            this.groupComp.addItem(this.valuePillSelect);
        } else {
            const params = this.createValueSelectParams(columns);
            params.onValueChange = (updatedColState)=>{
                for (const col of columns)col.selected = false;
                updatedColState.selected = true;
                if (updatedColState.colId === $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY) this.chartController.setAggFunc(void 0, true);
                this.chartController.updateForPanelChange({
                    updatedColState: updatedColState,
                    skipAnimation: skipAnimation?.()
                });
            };
            this.valueSelect = this.groupComp.createManagedBean(new (0, $437b23f6a393c3bf$export$6f9c460854d56032)(params));
            this.groupComp.addItem(this.valueSelect);
        }
    }
    refreshValueSelect(columns) {
        if (!this.valueSelect) return;
        const { options: options, value: value } = this.createValueSelectParams(columns);
        this.valueSelect.clearOptions().addOptions(options).setValue(value, true);
    }
    createValueSelectParams(columns) {
        let selectedValue;
        const options = columns.map((value)=>{
            const text = value.displayName ?? "";
            if (value.selected) selectedValue = value;
            return {
                value: value,
                text: text
            };
        });
        return {
            options: options,
            value: selectedValue
        };
    }
    onValueChange({ added: added, updated: updated, removed: removed, selected: selected }) {
        let updatedColState;
        let resetOrder;
        const updateOrder = ()=>{
            selected.forEach((col, index)=>{
                col.order = index;
            });
            resetOrder = true;
        };
        if (added.length) {
            updatedColState = added[0];
            updatedColState.selected = true;
            updateOrder();
        } else if (removed.length) {
            updatedColState = removed[0];
            updatedColState.selected = false;
        } else if (updated.length) {
            updateOrder();
            updatedColState = updated[0];
        }
        if (updatedColState) this.chartController.updateForPanelChange({
            updatedColState: updatedColState,
            resetOrder: resetOrder
        });
    }
    destroy() {
        this.valuePillSelect = void 0;
        this.valueSelect = void 0;
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/data/categoriesDataPanel.ts
var $5b7ccabde48fae90$var$DEFAULT_AGG_FUNC = "sum";
var $5b7ccabde48fae90$var$CategoriesDataPanel = class extends $5b7ccabde48fae90$var$DragDataPanel {
    constructor(chartController, title, allowMultipleSelection, dimensionCols, isOpen){
        const maxSelection = void 0;
        super(chartController, allowMultipleSelection, maxSelection, /* html */ `<div id="categoriesGroup"></div>`);
        this.title = title;
        this.dimensionCols = dimensionCols;
        this.isOpen = isOpen;
    }
    postConstruct() {
        this.groupComp = this.createBean(new $5b7ccabde48fae90$export$9c4ea4ce92935a7e({
            title: this.title,
            enabled: true,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: false,
            cssIdentifier: "charts-data",
            expanded: this.isOpen
        }));
        this.createGroup(this.dimensionCols, (col)=>col.displayName ?? "", "categoryAdd", "categorySelect", ()=>!this.chartController.getAggFunc());
        this.createAggFuncControls(this.dimensionCols);
        this.getGui().appendChild(this.groupComp.getGui());
    }
    refresh(dimensionCols) {
        this.valuePillSelect?.setValues(dimensionCols, dimensionCols.filter((col)=>col.selected));
        this.refreshValueSelect(dimensionCols);
        this.refreshAggFuncControls(dimensionCols, this.chartController.getAggFunc());
    }
    createAggFuncControls(dimensionCols) {
        const aggFunc = this.chartController.getAggFunc();
        this.groupComp.addItem(this.aggFuncToggle = this.createBean(new (0, $437b23f6a393c3bf$export$167b21bf245ce0bf)({
            label: this.chartTranslation.translate("aggregate"),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex",
            value: aggFunc != void 0,
            onValueChange: (value)=>{
                const aggFunc2 = value ? $5b7ccabde48fae90$var$DEFAULT_AGG_FUNC : void 0;
                this.chartController.setAggFunc(aggFunc2);
                this.aggFuncSelect?.setValue(aggFunc2, true);
                this.aggFuncSelect?.setDisplayed(aggFunc2 != void 0);
            }
        })));
        this.groupComp.addItem(this.aggFuncSelect = this.createBean(new (0, $437b23f6a393c3bf$export$6f9c460854d56032)({
            options: [
                {
                    value: "sum",
                    text: this.chartTranslation.translate("sum")
                },
                {
                    value: "first",
                    text: this.chartTranslation.translate("first")
                },
                {
                    value: "last",
                    text: this.chartTranslation.translate("last")
                },
                {
                    value: "min",
                    text: this.chartTranslation.translate("min")
                },
                {
                    value: "max",
                    text: this.chartTranslation.translate("max")
                },
                {
                    value: "count",
                    text: this.chartTranslation.translate("count")
                },
                {
                    value: "avg",
                    text: this.chartTranslation.translate("avg")
                }
            ],
            value: typeof aggFunc === "string" ? aggFunc : void 0,
            onValueChange: (value)=>{
                this.chartController.setAggFunc(value);
            }
        })));
        this.refreshAggFuncControls(dimensionCols, aggFunc);
    }
    refreshAggFuncControls(dimensionCols, aggFunc) {
        const selectedDimensions = dimensionCols.filter((col)=>col.selected);
        const supportsAggregation = selectedDimensions.some((col)=>col.colId !== $5b7ccabde48fae90$var$DEFAULT_CHART_CATEGORY);
        this.aggFuncToggle?.setValue(aggFunc != void 0);
        this.aggFuncSelect?.setValue(typeof aggFunc === "string" ? aggFunc : void 0, true);
        this.aggFuncToggle?.setDisplayed(supportsAggregation);
        this.aggFuncSelect?.setDisplayed(supportsAggregation && aggFunc != void 0);
    }
    clearAggFuncControls() {
        this.aggFuncToggle = this.destroyBean(this.aggFuncToggle);
        this.aggFuncSelect = this.destroyBean(this.aggFuncSelect);
    }
    destroy() {
        this.clearAggFuncControls();
        this.groupComp = this.destroyBean(this.groupComp);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ChartMenuParamsFactory = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(chartOptionsProxy){
        super();
        this.chartOptionsProxy = chartOptionsProxy;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    getDefaultColorPickerParams(expression, labelKey, options) {
        return this.addValueParams(expression, {
            label: this.chartTranslation.translate(labelKey ?? "color"),
            labelWidth: "flex",
            inputWidth: "flex",
            labelAlignment: "top",
            pickerGap: 6
        }, options);
    }
    getDefaultNumberInputParams(expression, labelKey, options) {
        return this.addValueParams(expression, {
            label: this.chartTranslation.translate(labelKey),
            labelAlignment: "top",
            labelWidth: "flex",
            inputWidth: "flex",
            precision: options?.precision,
            step: options?.step,
            min: options?.min,
            max: options?.max
        }, {
            parseInputValue: (value)=>{
                const numberValue = Number(value);
                return isNaN(numberValue) ? void 0 : numberValue;
            },
            formatInputValue: (value)=>{
                return value == null ? "" : `${value}`;
            }
        });
    }
    getDefaultSliderParams(expression, labelKey, defaultMaxValue, isArray) {
        let value = this.chartOptionsProxy.getValue(expression) ?? 0;
        if (isArray && Array.isArray(value)) value = value[0];
        const params = this.getDefaultSliderParamsWithoutValueParams(value, labelKey, defaultMaxValue);
        params.onValueChange = (value2)=>this.chartOptionsProxy.setValue(expression, isArray ? [
                value2
            ] : value2);
        return params;
    }
    getDefaultSliderParamsWithoutValueParams(value, labelKey, defaultMaxValue) {
        return {
            label: this.chartTranslation.translate(labelKey),
            minValue: 0,
            maxValue: Math.max(value, defaultMaxValue),
            textFieldWidth: 45,
            value: `${value}`
        };
    }
    getDefaultCheckboxParams(expression, labelKey, options) {
        const value = this.chartOptionsProxy.getValue(expression);
        const params = {
            label: this.chartTranslation.translate(labelKey),
            value: value,
            readOnly: options?.readOnly,
            passive: options?.passive
        };
        params.onValueChange = (value2)=>{
            this.chartOptionsProxy.setValue(expression, typeof value2 === "boolean" ? value2 : void 0);
        };
        return params;
    }
    getDefaultToggleParams(expression, labelKey, options) {
        const value = this.chartOptionsProxy.getValue(expression);
        const params = {
            label: this.chartTranslation.translate(labelKey),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex",
            value: value,
            readOnly: options?.readOnly,
            passive: options?.passive
        };
        params.onValueChange = (value2)=>{
            this.chartOptionsProxy.setValue(expression, typeof value2 === "boolean" ? value2 : void 0);
        };
        return params;
    }
    getDefaultSelectParams(expression, labelKey, dropdownOptions) {
        return this.getDefaultSelectParamsWithoutValueParams(labelKey, dropdownOptions, this.chartOptionsProxy.getValue(expression), (value)=>{
            this.chartOptionsProxy.setValue(expression, value);
        });
    }
    getDefaultSelectParamsWithoutValueParams(labelKey, options, value, onValueChange) {
        return {
            label: this.chartTranslation.translate(labelKey),
            labelAlignment: "top",
            options: options,
            pickerGap: 6,
            value: value,
            onValueChange: onValueChange
        };
    }
    getDefaultFontPanelParams(expression, labelKey) {
        const keyMapper = (key)=>`${expression}.${key}`;
        return this.addEnableParams(keyMapper("enabled"), {
            name: this.chartTranslation.translate(labelKey),
            suppressEnabledCheckbox: false,
            chartMenuParamsFactory: this,
            keyMapper: keyMapper
        });
    }
    addValueParams(expression, params, options) {
        const optionsValue = this.chartOptionsProxy.getValue(expression);
        params.value = options?.formatInputValue ? options.formatInputValue(optionsValue) : optionsValue;
        params.onValueChange = (value)=>{
            const optionsValue2 = options?.parseInputValue ? options.parseInputValue(value) : value;
            this.chartOptionsProxy.setValue(expression, optionsValue2);
        };
        return params;
    }
    addEnableParams(expression, params) {
        params.enabled = this.chartOptionsProxy.getValue(expression) ?? false;
        params.onEnableChange = (value)=>this.chartOptionsProxy.setValue(expression, value);
        return params;
    }
    getChartOptions() {
        return this.chartOptionsProxy;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/data/chartSpecificDataPanel.ts
var $5b7ccabde48fae90$var$ChartSpecificDataPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuContext, isOpen){
        super();
        this.chartMenuContext = chartMenuContext;
        this.isOpen = isOpen;
        this.chartSpecificGroup = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.hasContent = false;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
        this.chartSvc = beans.chartSvc;
    }
    postConstruct() {
        const title = this.getTitle();
        const chartSpecificGroupParams = {
            title: title,
            enabled: true,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: false,
            cssIdentifier: "charts-data",
            expanded: this.isOpen,
            items: [
                ...this.createDirectionSelect(),
                this.createReverseSelect(),
                this.createGroupTypeSelect()
            ]
        };
        this.setTemplate(/* html */ `
            <div id="chartSpecificGroup">
                <ag-group-component data-ref="chartSpecificGroup"></ag-group-component>
            </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a
        ], {
            chartSpecificGroup: chartSpecificGroupParams
        });
        this.setDisplayed(this.hasContent);
    }
    refresh() {
        this.hasContent = false;
        this.chartSpecificGroup.setTitle(this.getTitle());
        this.updateDirectionSelect();
        this.updateReverseSelect();
        this.updateGroupTypeSelect();
        this.setDisplayed(this.hasContent);
    }
    getTitle() {
        const chartType = this.chartMenuContext.chartController.getChartType();
        return this.chartTranslation.translate($5b7ccabde48fae90$var$getFullChartNameTranslationKey(chartType));
    }
    createDirectionSelect() {
        if (!this.chartSvc.isEnterprise()) return [];
        const { chartOptionsService: chartOptionsService, chartController: chartController } = this.chartMenuContext;
        const chartOptionsSeriesProxy = chartOptionsService.getSeriesOptionsProxy(()=>$5b7ccabde48fae90$var$getSeriesType(chartController.getChartType()));
        const chartSeriesMenuParamsFactory = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(chartOptionsSeriesProxy));
        const options = [
            "horizontal",
            "vertical"
        ].map((value)=>({
                value: value,
                text: this.chartTranslation.translate(value)
            }));
        const params = chartSeriesMenuParamsFactory.getDefaultSelectParams("direction", "direction", options);
        const onValueChange = params.onValueChange;
        params.onValueChange = (value)=>{
            onValueChange(value);
            chartController.raiseChartModelUpdateEvent();
        };
        this.directionSelect = this.createManagedBean(new (0, $437b23f6a393c3bf$export$6f9c460854d56032)(params));
        this.updateDirectionSelect();
        return [
            this.directionSelect
        ];
    }
    createReverseSelect() {
        const { chartMenuParamsFactory: chartMenuParamsFactory } = this.chartMenuContext;
        const params = chartMenuParamsFactory.getDefaultToggleParams("series.reverse", "reverse");
        this.reverseToggle = this.createManagedBean(new (0, $437b23f6a393c3bf$export$167b21bf245ce0bf)(params));
        this.updateReverseSelect();
        return this.reverseToggle;
    }
    updateReverseSelect() {
        const isDisplayed = this.chartMenuContext.chartController.getChartType() === "pyramid";
        this.updateDisplayed(this.reverseToggle, isDisplayed);
    }
    updateDirectionSelect() {
        const isDisplayed = $5b7ccabde48fae90$var$canSwitchDirection(this.chartMenuContext.chartController.getChartType());
        this.updateDisplayed(this.directionSelect, isDisplayed);
    }
    createGroupTypeSelect() {
        const { chartController: chartController, chartMenuParamsFactory: chartMenuParamsFactory } = this.chartMenuContext;
        this.groupTypeSelect = this.createManagedBean(new (0, $437b23f6a393c3bf$export$6f9c460854d56032)(chartMenuParamsFactory.getDefaultSelectParamsWithoutValueParams("seriesGroupType", $5b7ccabde48fae90$var$SERIES_GROUP_TYPES.map((value)=>({
                value: value,
                text: this.chartTranslation.translate(`${value}SeriesGroupType`)
            })), chartController.getSeriesGroupType(), (value)=>chartController.setSeriesGroupType(value))));
        this.updateGroupTypeSelect();
        return this.groupTypeSelect;
    }
    updateGroupTypeSelect() {
        const isDisplayed = [
            "radialColumn",
            "radialBar",
            "nightingale"
        ].includes(this.chartMenuContext.chartController.getChartType());
        this.updateDisplayed(this.groupTypeSelect, isDisplayed);
    }
    updateDisplayed(select, isDisplayed) {
        select?.setDisplayed(isDisplayed);
        if (select) this.hasContent = this.hasContent || isDisplayed;
    }
};
var $5b7ccabde48fae90$var$SeriesChartTypePanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartController, columns, isOpen){
        super(/* html */ `<div id="seriesChartTypeGroup"></div>`);
        this.chartController = chartController;
        this.columns = columns;
        this.isOpen = isOpen;
        this.selectedColIds = [];
        this.chartTypeComps = /* @__PURE__ */ new Map();
        this.secondaryAxisComps = /* @__PURE__ */ new Map();
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        this.createSeriesChartTypeGroup(this.columns);
    }
    refresh(columns) {
        if (!(0, $437b23f6a393c3bf$export$893967cdb9833fdd)(this.getValidColIds(columns), this.selectedColIds)) this.recreate(columns);
        else this.refreshComps();
    }
    recreate(columns) {
        this.isOpen = this.seriesChartTypeGroupComp.isExpanded();
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.getGui());
        this.destroyBean(this.seriesChartTypeGroupComp);
        this.columns = columns;
        this.selectedColIds = [];
        this.clearComps();
        this.postConstruct();
    }
    getValidColIds(columns) {
        const seriesChartTypes = this.chartController.getSeriesChartTypes();
        return columns.filter((col)=>col.selected && !!seriesChartTypes.filter((s2)=>s2.colId === col.colId)[0]).map(({ colId: colId })=>colId);
    }
    createSeriesChartTypeGroup(columns) {
        this.seriesChartTypeGroupComp = this.createBean(new $5b7ccabde48fae90$export$9c4ea4ce92935a7e({
            title: this.chartTranslation.translate("seriesChartType"),
            enabled: true,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: false,
            cssIdentifier: "charts-data",
            expanded: this.isOpen
        }));
        const seriesChartTypes = this.chartController.getSeriesChartTypes();
        for (const col of columns){
            if (!col.selected) continue;
            const seriesChartType = seriesChartTypes.filter((s2)=>s2.colId === col.colId)[0];
            if (!seriesChartType) continue;
            this.selectedColIds.push(col.colId);
            const seriesItemGroup = this.seriesChartTypeGroupComp.createManagedBean(new $5b7ccabde48fae90$export$9c4ea4ce92935a7e({
                title: col.displayName,
                enabled: true,
                suppressEnabledCheckbox: true,
                suppressOpenCloseIcons: true,
                cssIdentifier: "charts-format-sub-level"
            }));
            const isSecondaryAxisDisabled = (chartType)=>[
                    "groupedColumn",
                    "stackedColumn",
                    "stackedArea"
                ].includes(chartType);
            const secondaryAxisComp = this.seriesChartTypeGroupComp.createManagedBean(new (0, $437b23f6a393c3bf$export$b00c508c1ae18d07)({
                label: this.chartTranslation.translate("secondaryAxis"),
                labelWidth: "flex",
                disabled: isSecondaryAxisDisabled(seriesChartType.chartType),
                value: !!seriesChartType.secondaryAxis,
                onValueChange: (enabled)=>this.chartController.updateSeriesChartType(col.colId, void 0, enabled)
            }));
            seriesItemGroup.addItem(secondaryAxisComp);
            const options = [
                "line",
                "area",
                "stackedArea",
                "groupedColumn",
                "stackedColumn"
            ].map((value)=>({
                    value: value,
                    text: this.chartTranslation.translate($5b7ccabde48fae90$var$getFullChartNameTranslationKey(value))
                }));
            const chartTypeComp = seriesItemGroup.createManagedBean(new (0, $437b23f6a393c3bf$export$6f9c460854d56032)({
                options: options,
                value: seriesChartType.chartType,
                onValueChange: (chartType)=>this.chartController.updateSeriesChartType(col.colId, chartType)
            }));
            seriesItemGroup.addItem(chartTypeComp);
            this.seriesChartTypeGroupComp.addItem(seriesItemGroup);
            this.chartTypeComps.set(col.colId, chartTypeComp);
            this.secondaryAxisComps.set(col.colId, secondaryAxisComp);
        }
        this.getGui().appendChild(this.seriesChartTypeGroupComp.getGui());
    }
    refreshComps() {
        const seriesChartTypes = this.chartController.getSeriesChartTypes();
        for (const colId of this.selectedColIds){
            const seriesChartType = seriesChartTypes.find((chartType)=>chartType.colId === colId);
            if (!seriesChartType) continue;
            const chartTypeComp = this.chartTypeComps.get(colId);
            const secondaryAxisComp = this.secondaryAxisComps.get(colId);
            chartTypeComp?.setValue(seriesChartType.chartType);
            secondaryAxisComp?.setValue(!!seriesChartType.secondaryAxis);
            secondaryAxisComp?.setDisabled(this.isSecondaryAxisDisabled(seriesChartType.chartType));
        }
    }
    clearComps() {
        this.chartTypeComps.clear();
        this.secondaryAxisComps.clear();
    }
    isSecondaryAxisDisabled(chartType) {
        return [
            "groupedColumn",
            "stackedColumn",
            "stackedArea"
        ].includes(chartType);
    }
    destroy() {
        this.clearComps();
        this.seriesChartTypeGroupComp = this.destroyBean(this.seriesChartTypeGroupComp);
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$SeriesDataPanel = class extends $5b7ccabde48fae90$var$DragDataPanel {
    constructor(chartController, chartOptionsService, title, allowMultipleSelect, maxSelection, valueCols, isOpen){
        super(chartController, allowMultipleSelect, maxSelection, /* html */ `<div id="seriesGroup"></div>`);
        this.chartOptionsService = chartOptionsService;
        this.title = title;
        this.valueCols = valueCols;
        this.isOpen = isOpen;
    }
    postConstruct() {
        this.groupComp = this.createBean(new $5b7ccabde48fae90$export$9c4ea4ce92935a7e({
            title: this.title,
            enabled: true,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: false,
            cssIdentifier: "charts-data",
            expanded: this.isOpen
        }));
        if (this.chartController.isActiveXYChart()) {
            const pairedModeToggle = this.groupComp.createManagedBean(new (0, $437b23f6a393c3bf$export$167b21bf245ce0bf)({
                label: this.chartTranslation.translate("paired"),
                labelAlignment: "left",
                labelWidth: "flex",
                inputWidth: "flex",
                value: this.chartOptionsService.getPairedMode(),
                onValueChange: (newValue)=>{
                    this.chartOptionsService.setPairedMode(!!newValue);
                    this.chartController.updateForGridChange({
                        maintainColState: true
                    });
                }
            }));
            this.groupComp.addItem(pairedModeToggle);
        }
        this.createGroup(this.valueCols, this.generateGetSeriesLabel(this.valueCols), "seriesAdd", "seriesSelect");
        this.getGui().appendChild(this.groupComp.getGui());
    }
    refresh(valueCols) {
        this.valuePillSelect?.setValueFormatter(this.generateGetSeriesLabel(valueCols));
        this.valuePillSelect?.setValues(valueCols, valueCols.filter((col)=>col.selected));
        this.refreshValueSelect(valueCols);
    }
    generateGetSeriesLabel(valueCols) {
        if (!this.chartController.isActiveXYChart()) return (col)=>col.displayName ?? "";
        const selectedCols = valueCols.filter((col)=>col.selected);
        const isBubble = this.chartController.getChartType() === "bubble";
        const isInPairedMode = this.chartOptionsService.getPairedMode();
        const indexToAxisLabel = /* @__PURE__ */ new Map();
        indexToAxisLabel.set(0, "X");
        indexToAxisLabel.set(1, "Y");
        indexToAxisLabel.set(2, "size");
        return (col)=>{
            const escapedLabel = col.displayName ?? "";
            if (!col.selected) return escapedLabel;
            const index = selectedCols.indexOf(col);
            if (index === -1) return escapedLabel;
            let axisLabel;
            if (isInPairedMode) axisLabel = indexToAxisLabel.get(index % (isBubble ? 3 : 2));
            else if (index === 0) axisLabel = "X";
            else axisLabel = isBubble && index % 2 === 0 ? "size" : "Y";
            return `${escapedLabel} (${axisLabel})`;
        };
    }
    destroy() {
        this.groupComp = this.destroyBean(this.groupComp);
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/data/chartDataPanel.ts
var $5b7ccabde48fae90$var$DefaultDataPanelDef = {
    groups: [
        {
            type: "categories",
            isOpen: true
        },
        {
            type: "series",
            isOpen: true
        },
        {
            type: "seriesChartType",
            isOpen: true
        },
        {
            type: "chartSpecific",
            isOpen: true
        }
    ]
};
var $5b7ccabde48fae90$var$ChartDataPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuContext){
        super(/* html */ `<div class="ag-chart-data-wrapper ag-scrollable-container"></div>`);
        this.chartMenuContext = chartMenuContext;
        this.isSwitchCategorySeriesToggled = false;
        this.restoreSwitchCategorySeriesToggleFocus = false;
        this.panels = [];
        this.chartController = chartMenuContext.chartController;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
        this.chartSvc = beans.chartSvc;
    }
    postConstruct() {
        this.createSwitchCategorySeriesToggle();
        this.isSwitchCategorySeriesToggled = this.chartController.isCategorySeriesSwitched();
        this.updatePanels();
        const listener = this.updatePanels.bind(this);
        this.addManagedListeners(this.chartController, {
            chartModelUpdate: listener,
            chartApiUpdate: listener
        });
    }
    destroy() {
        this.clearPanelComponents();
        super.destroy();
    }
    updatePanels() {
        const currentChartType = this.chartType;
        const isSwitchCategorySeriesToggledCurrent = this.isSwitchCategorySeriesToggled;
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartController.getColStateForMenu();
        this.chartType = this.chartController.getChartType();
        this.isSwitchCategorySeriesToggled = this.chartController.isCategorySeriesSwitched();
        const hasChangedSwitchCategorySeries = this.isSwitchCategorySeriesToggled !== isSwitchCategorySeriesToggledCurrent;
        if (this.canRefresh(currentChartType, this.chartType) && !hasChangedSwitchCategorySeries) {
            this.categoriesDataPanel?.refresh(dimensionCols);
            this.seriesDataPanel?.refresh(valueCols);
            this.seriesChartTypePanel?.refresh(valueCols);
            this.chartSpecificPanel?.refresh();
        } else this.recreatePanels(dimensionCols, valueCols);
        const isSwitchCategorySeriesDisplayed = $5b7ccabde48fae90$var$supportsInvertedCategorySeries(this.chartType) && this.chartSvc.isEnterprise() && !this.chartController.isGrouping();
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.switchCategorySeriesToggle.getGui(), isSwitchCategorySeriesDisplayed);
        if (hasChangedSwitchCategorySeries) this.switchCategorySeriesToggle?.setValue(this.chartController.isCategorySeriesSwitched());
        if (this.restoreSwitchCategorySeriesToggleFocus) {
            this.restoreSwitchCategorySeriesToggleFocus = false;
            if (isSwitchCategorySeriesDisplayed) this.switchCategorySeriesToggle.getFocusableElement().focus();
        }
    }
    canRefresh(oldChartType, newChartType) {
        if (oldChartType === void 0) return false;
        if (oldChartType === newChartType) return true;
        const isCombo = (chartType)=>[
                "columnLineCombo",
                "areaColumnCombo",
                "customCombo"
            ].includes(chartType);
        if (isCombo(oldChartType) && isCombo(newChartType)) return true;
        return false;
    }
    recreatePanels(dimensionCols, valueCols) {
        this.clearPanelComponents();
        const { chartType: chartType } = this;
        if (!chartType) return;
        const isCategorySeriesSwitched = this.chartController.isCategorySeriesSwitched();
        this.getDataPanelDef().groups?.forEach(({ type: type, isOpen: isOpen })=>{
            if (type === (isCategorySeriesSwitched ? "series" : "categories")) {
                this.categoriesDataPanel = this.createBean(new $5b7ccabde48fae90$var$CategoriesDataPanel(this.chartController, this.getCategoryGroupTitle(isCategorySeriesSwitched), this.getCategoryGroupMultipleSelect(chartType, isCategorySeriesSwitched), dimensionCols, isOpen));
                this.panels.push(this.categoriesDataPanel);
            } else if (type === (isCategorySeriesSwitched ? "categories" : "series")) {
                this.seriesDataPanel = this.createBean(new $5b7ccabde48fae90$var$SeriesDataPanel(this.chartController, this.chartMenuContext.chartOptionsService, this.getSeriesGroupTitle(isCategorySeriesSwitched), this.getSeriesGroupMultipleSelect(chartType, isCategorySeriesSwitched), this.getSeriesGroupMaxSelection(chartType, isCategorySeriesSwitched), valueCols, isOpen));
                this.panels.push(this.seriesDataPanel);
            } else if (type === "seriesChartType") {
                if (this.chartController.isComboChart()) {
                    this.seriesChartTypePanel = this.createBean(new $5b7ccabde48fae90$var$SeriesChartTypePanel(this.chartController, valueCols, isOpen));
                    this.panels.push(this.seriesChartTypePanel);
                }
            } else if (type === "chartSpecific") {
                this.chartSpecificPanel = this.createBean(new $5b7ccabde48fae90$var$ChartSpecificDataPanel(this.chartMenuContext, isOpen));
                this.panels.push(this.chartSpecificPanel);
            } else (0, $437b23f6a393c3bf$export$545083624300f13d)(144, {
                type: type
            });
        });
        (isCategorySeriesSwitched ? this.categoriesDataPanel : this.seriesDataPanel)?.addItem(this.switchCategorySeriesToggle.getGui());
        this.addPanelComponents();
    }
    addPanelComponents() {
        if (!this.panels.length) return;
        const eDocument = (0, $437b23f6a393c3bf$export$f63d0991874c6f81)(this.beans);
        const fragment = eDocument.createDocumentFragment();
        for (const panel of this.panels){
            panel.addCss("ag-chart-data-section");
            fragment.appendChild(panel.getGui());
        }
        this.getGui().appendChild(fragment);
    }
    clearPanelComponents() {
        for (const panel of this.panels){
            panel.getGui().remove();
            this.destroyBean(panel);
        }
        this.panels = [];
    }
    getDataPanelDef() {
        return this.gos.get("chartToolPanelsDef")?.dataPanel ?? $5b7ccabde48fae90$var$DefaultDataPanelDef;
    }
    getCategoryGroupTitle(isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return this.chartTranslation.translate("seriesLabels");
        return this.chartTranslation.translate(this.chartController.isActiveXYChart() ? "labels" : "categories");
    }
    getCategoryGroupMultipleSelect(chartType, isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return false;
        return $5b7ccabde48fae90$var$getMaxNumCategories(chartType) !== 1;
    }
    getSeriesGroupTitle(isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return this.chartTranslation.translate("categoryValues");
        return this.chartTranslation.translate(this.chartController.isActiveXYChart() ? "xyValues" : "series");
    }
    getSeriesGroupMultipleSelect(chartType, isCategorySeriesSwitched) {
        return this.getSeriesGroupMaxSelection(chartType, isCategorySeriesSwitched) !== 1;
    }
    getSeriesGroupMaxSelection(chartType, isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return void 0;
        return $5b7ccabde48fae90$var$getMaxNumSeries(chartType);
    }
    createSwitchCategorySeriesToggle() {
        this.switchCategorySeriesToggle = this.createManagedBean(new (0, $437b23f6a393c3bf$export$167b21bf245ce0bf)({
            label: this.chartTranslation.translate("switchCategorySeries"),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex",
            value: this.chartController.isCategorySeriesSwitched(),
            onValueChange: (value)=>{
                this.restoreSwitchCategorySeriesToggleFocus = true;
                this.chartController.switchCategorySeries(value);
            }
        }));
    }
};
var $5b7ccabde48fae90$var$AgAngleSelect = class extends (0, $437b23f6a393c3bf$export$d72ea6e1c340e03b) {
    constructor(config){
        super(config, /* html */ `<div class="ag-angle-select">
            <div data-ref="eLabel"></div>
            <div class="ag-wrapper ag-angle-select-wrapper">
                <div class="ag-angle-select-field">
                    <div data-ref="eParentCircle" class="ag-angle-select-parent-circle">
                        <div data-ref="eChildCircle" class="ag-angle-select-child-circle"></div>
                    </div>
                </div>
                <ag-input-number-field data-ref="eAngleValue"></ag-input-number-field>
            </div>
        </div>`, [
            (0, $437b23f6a393c3bf$export$c18153c9c909b7d7)
        ]);
        this.eLabel = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eParentCircle = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eChildCircle = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eAngleValue = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.radius = 0;
        this.offsetX = 0;
        this.offsetY = 0;
    }
    wireBeans(beans) {
        this.dragSvc = beans.dragSvc;
    }
    postConstruct() {
        super.postConstruct();
        const { value: value, onValueChange: onValueChange } = this.config;
        if (value != null) this.setValue(value, void 0, true);
        if (onValueChange != null) this.onValueChange(onValueChange);
        this.dragListener = {
            eElement: this.eParentCircle,
            dragStartPixels: 0,
            onDragStart: ()=>{
                this.parentCircleRect = this.eParentCircle.getBoundingClientRect();
            },
            onDragging: (e)=>this.calculateAngleDrag(e),
            onDragStop: ()=>{}
        };
        this.dragSvc?.addDragSource(this.dragListener);
        this.eAngleValue.setLabel("").setLabelWidth(5).setInputWidth(45).setMin(0).setMax(360).setValue(`${this.degrees}`).onValueChange((value2)=>{
            if (value2 == null || value2 === "") value2 = "0";
            value2 = this.eAngleValue.normalizeValue(value2);
            let floatValue = parseFloat(value2);
            if (floatValue > 180) floatValue = floatValue - 360;
            this.setValue(floatValue);
        });
        this.updateNumberInput();
        if ((0, $437b23f6a393c3bf$export$25d27f17d3af40f7)(this.getValue())) this.eAngleValue.setValue(this.normalizeNegativeValue(this.getValue()).toString());
        this.addManagedListeners(this, {
            fieldValueChanged: ()=>{
                if (this.eAngleValue.getInputElement().contains((0, $437b23f6a393c3bf$export$16bc98d422315038)(this.beans))) return;
                this.updateNumberInput();
            }
        });
    }
    updateNumberInput() {
        const normalizedValue = this.normalizeNegativeValue(this.getValue());
        this.eAngleValue.setValue(normalizedValue.toString());
    }
    positionChildCircle(radians) {
        const rect = this.parentCircleRect || {
            width: 24,
            height: 24
        };
        const eChildCircle = this.eChildCircle;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        eChildCircle.style.left = `${centerX + Math.cos(radians) * 8}px`;
        eChildCircle.style.top = `${centerY + Math.sin(radians) * 8}px`;
    }
    calculatePolar() {
        const x = this.offsetX;
        const y = this.offsetY;
        const radians = Math.atan2(y, x);
        this.degrees = this.toDegrees(radians);
        this.radius = Math.sqrt(x * x + y * y);
        this.positionChildCircle(radians);
    }
    calculateCartesian() {
        const radians = this.toRadians(this.getValue());
        const radius = this.getRadius();
        this.setOffsetX(Math.cos(radians) * radius).setOffsetY(Math.sin(radians) * radius);
    }
    setOffsetX(offset) {
        if (this.offsetX !== offset) {
            this.offsetX = offset;
            this.calculatePolar();
        }
        return this;
    }
    setOffsetY(offset) {
        if (this.offsetY !== offset) {
            this.offsetY = offset;
            this.calculatePolar();
        }
        return this;
    }
    calculateAngleDrag(e) {
        const rect = this.parentCircleRect;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const dx = x - centerX;
        const dy = y - centerY;
        const radians = Math.atan2(dy, dx);
        this.setValue(radians, true);
    }
    toDegrees(radians) {
        return radians / Math.PI * 180;
    }
    toRadians(degrees) {
        return degrees / 180 * Math.PI;
    }
    normalizeNegativeValue(degrees) {
        return degrees < 0 ? 360 + degrees : degrees;
    }
    normalizeAngle180(radians) {
        radians %= Math.PI * 2;
        if (radians < -Math.PI) radians += Math.PI * 2;
        else if (radians >= Math.PI) radians -= Math.PI * 2;
        return radians;
    }
    getRadius() {
        return this.radius;
    }
    setRadius(r) {
        if (this.radius === r) return this;
        this.radius = r;
        this.calculateCartesian();
        return this;
    }
    onValueChange(callbackFn) {
        this.addManagedListeners(this, {
            fieldValueChanged: ()=>{
                callbackFn(this.degrees);
            }
        });
        return this;
    }
    getValue(radians) {
        return radians ? this.toRadians(this.degrees) : this.degrees;
    }
    setValue(degrees, radians, silent) {
        let radiansValue;
        if (!radians) radiansValue = this.normalizeAngle180(this.toRadians(degrees));
        else radiansValue = degrees;
        degrees = this.toDegrees(radiansValue);
        if (this.degrees !== degrees) {
            this.degrees = Math.floor(degrees);
            this.calculateCartesian();
            this.positionChildCircle(radiansValue);
            if (!silent) this.dispatchLocalEvent({
                type: "fieldValueChanged"
            });
        }
        return this;
    }
    setWidth(width) {
        (0, $437b23f6a393c3bf$export$ce98ba7f5cfe7725)(this.getGui(), width);
        return this;
    }
    setDisabled(disabled) {
        super.setDisabled(disabled);
        this.eAngleValue.setDisabled(disabled);
        return this;
    }
    destroy() {
        this.dragSvc?.removeDragSource(this.dragListener);
        super.destroy();
    }
};
function $5b7ccabde48fae90$var$_capitalise(str) {
    return str[0].toUpperCase() + str.substring(1).toLowerCase();
}
var $5b7ccabde48fae90$var$FontPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(params){
        super();
        this.params = params;
        this.fontGroup = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.activeComps = [];
        this.chartOptions = params.chartMenuParamsFactory.getChartOptions();
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { cssIdentifier: cssIdentifier = "charts-format-sub-level", name: title, enabled: enabled, onEnableChange: onEnableChange, suppressEnabledCheckbox: suppressEnabledCheckbox, chartMenuParamsFactory: chartMenuParamsFactory, keyMapper: keyMapper } = this.params;
        const fontGroupParams = {
            cssIdentifier: cssIdentifier,
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: title,
            enabled: enabled,
            suppressEnabledCheckbox: true,
            onEnableChange: (enabled2)=>{
                if (onEnableChange) onEnableChange(enabled2);
            },
            useToggle: !suppressEnabledCheckbox
        };
        this.setTemplate(/* html */ `<div class="ag-font-panel">
        <ag-group-component data-ref="fontGroup">
            <ag-select data-ref="familySelect"></ag-select>
            <ag-select data-ref="weightStyleSelect"></ag-select>
            <div class="ag-charts-font-size-color">
                <ag-select data-ref="sizeSelect"></ag-select>
                <ag-color-picker data-ref="colorPicker"></ag-color-picker>
            </div>
        </ag-group-component>
    </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            (0, $437b23f6a393c3bf$export$e32612175ad118ef),
            $5b7ccabde48fae90$var$ColorPickerSelector
        ], {
            fontGroup: fontGroupParams,
            familySelect: this.getFamilySelectParams(),
            weightStyleSelect: this.getWeightStyleSelectParams(),
            sizeSelect: this.getSizeSelectParams(),
            colorPicker: chartMenuParamsFactory.getDefaultColorPickerParams(keyMapper("color"))
        });
        this.toggleCss("ag-font-panel-no-header", !title);
    }
    addItem(comp, prepend) {
        if (prepend) this.fontGroup.prependItem(comp);
        else this.fontGroup.addItem(comp);
        this.activeComps.push(comp);
    }
    setEnabled(enabled) {
        this.fontGroup.setEnabled(enabled);
    }
    getFamilySelectParams() {
        const families = [
            "Arial, sans-serif",
            "Aria Black, sans-serif",
            "Book Antiqua,  serif",
            "Charcoal, sans-serif",
            "Comic Sans MS, cursive",
            "Courier, monospace",
            "Courier New, monospace",
            "Gadget, sans-serif",
            "Geneva, sans-serif",
            "Helvetica, sans-serif",
            "Impact, sans-serif",
            "Lucida Console, monospace",
            "Lucida Grande, sans-serif",
            "Lucida Sans Unicode,  sans-serif",
            "Monaco, monospace",
            "Palatino Linotype, serif",
            "Palatino, serif",
            "Times New Roman, serif",
            "Times, serif",
            "Verdana, sans-serif"
        ];
        const family = this.getInitialFontValue("fontFamily");
        let initialValue = families[0];
        if (family) {
            const lowerCaseValues = families.map((f)=>f.toLowerCase());
            const valueIndex = lowerCaseValues.indexOf(family.toLowerCase());
            if (valueIndex >= 0) initialValue = families[valueIndex];
            else {
                const capitalisedFontValue = $5b7ccabde48fae90$var$_capitalise(family);
                families.push(capitalisedFontValue);
                initialValue = capitalisedFontValue;
            }
        }
        const options = families.sort().map((value)=>({
                value: value,
                text: value
            }));
        return this.params.chartMenuParamsFactory.getDefaultSelectParamsWithoutValueParams("font", options, `${initialValue}`, (newValue)=>this.setFont({
                fontFamily: newValue
            }));
    }
    getSizeSelectParams() {
        const sizes = [
            8,
            10,
            12,
            14,
            16,
            18,
            20,
            22,
            24,
            26,
            28,
            30,
            32,
            34,
            36
        ];
        const size = this.getInitialFontValue("fontSize");
        if (!sizes.includes(size)) sizes.push(size);
        const options = sizes.sort((a, b)=>a - b).map((value)=>({
                value: `${value}`,
                text: `${value}`
            }));
        return this.params.chartMenuParamsFactory.getDefaultSelectParamsWithoutValueParams("size", options, `${size}`, (newValue)=>this.setFont({
                fontSize: parseInt(newValue, 10)
            }));
    }
    getWeightStyleSelectParams() {
        const weight = this.getInitialFontValue("fontWeight") ?? "normal";
        const style = this.getInitialFontValue("fontStyle") ?? "normal";
        const weightStyles = [
            {
                name: "normal",
                weight: "normal",
                style: "normal"
            },
            {
                name: "bold",
                weight: "bold",
                style: "normal"
            },
            {
                name: "italic",
                weight: "normal",
                style: "italic"
            },
            {
                name: "boldItalic",
                weight: "bold",
                style: "italic"
            }
        ];
        let selectedOption = weightStyles.find((x)=>x.weight === weight && x.style === style);
        if (!selectedOption) {
            selectedOption = {
                name: "predefined",
                weight: weight,
                style: style
            };
            weightStyles.unshift(selectedOption);
        }
        const options = weightStyles.map((ws)=>({
                value: ws.name,
                text: this.chartTranslation.translate(ws.name)
            }));
        return this.params.chartMenuParamsFactory.getDefaultSelectParamsWithoutValueParams("weight", options, selectedOption.name, (newValue)=>{
            const selectedWeightStyle = weightStyles.find((x)=>x.name === newValue);
            this.setFont({
                fontWeight: selectedWeightStyle.weight,
                fontStyle: selectedWeightStyle.style
            });
        });
    }
    destroyActiveComps() {
        for (const comp of this.activeComps){
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(comp.getGui());
            this.destroyBean(comp);
        }
    }
    destroy() {
        this.destroyActiveComps();
        super.destroy();
    }
    setFont(font) {
        const { keyMapper: keyMapper } = this.params;
        for (const fontKey of Object.keys(font)){
            const value = font[fontKey];
            if (value) this.chartOptions.setValue(keyMapper(fontKey), value);
        }
    }
    getInitialFontValue(fontKey) {
        const { keyMapper: keyMapper } = this.params;
        return this.chartOptions.getValue(keyMapper(fontKey));
    }
};
var $5b7ccabde48fae90$var$AxisTicksPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.axisTicksSizeSlider = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { chartMenuUtils: chartMenuUtils } = this;
        const axisTicksGroupParams = chartMenuUtils.addEnableParams("tick.enabled", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("ticks"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const axisTicksColorPickerParams = chartMenuUtils.getDefaultColorPickerParams("tick.stroke");
        const axisTicksWidthSliderParams = chartMenuUtils.getDefaultSliderParams("tick.width", "width", 10);
        const axisTicksSizeSliderParams = chartMenuUtils.getDefaultSliderParams("tick.size", "length", 30);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="axisTicksGroup">
                <ag-color-picker data-ref="axisTicksColorPicker"></ag-color-picker>
                <ag-slider data-ref="axisTicksWidthSlider"></ag-slider>
                <ag-slider data-ref="axisTicksSizeSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$var$ColorPickerSelector,
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            axisTicksGroup: axisTicksGroupParams,
            axisTicksColorPicker: axisTicksColorPickerParams,
            axisTicksWidthSlider: axisTicksWidthSliderParams,
            axisTicksSizeSlider: axisTicksSizeSliderParams
        });
    }
    setTickSizeSliderDisplayed(displayed) {
        this.axisTicksSizeSlider.setDisplayed(displayed);
    }
};
var $5b7ccabde48fae90$var$GridLinePanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.chartOptions = chartMenuUtils.getChartOptions();
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const gridLineGroupParams = this.chartMenuUtils.addEnableParams("gridLine.enabled", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("gridLines"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const gridLineColorPickerParams = this.getGridLineColorPickerParams("color");
        const gridLineWidthSliderParams = this.getGridLineWidthSliderParams("thickness");
        const gridLineLineDashSliderParams = this.getGridLineDashSliderParams("lineDash");
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="gridLineGroup">
                <ag-color-picker data-ref="gridLineColorPicker"></ag-color-picker>
                <ag-slider data-ref="gridLineWidthSlider"></ag-slider>
                <ag-slider data-ref="gridLineLineDashSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$var$ColorPickerSelector,
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            gridLineGroup: gridLineGroupParams,
            gridLineColorPicker: gridLineColorPickerParams,
            gridLineWidthSlider: gridLineWidthSliderParams,
            gridLineLineDashSlider: gridLineLineDashSliderParams
        });
    }
    getGridLineColorPickerParams(labelKey) {
        return this.chartMenuUtils.getDefaultColorPickerParams("gridLine.style", labelKey, {
            formatInputValue: (value)=>{
                return value?.[0]?.stroke;
            },
            parseInputValue: (value)=>{
                const styles = this.chartOptions.getValue("gridLine.style") ?? [];
                if (styles.length === 0) return [
                    {
                        stroke: value,
                        lineDash: []
                    }
                ];
                return [
                    {
                        ...styles[0],
                        stroke: value
                    }
                ];
            }
        });
    }
    getGridLineWidthSliderParams(labelKey) {
        return this.chartMenuUtils.getDefaultSliderParams("gridLine.width", labelKey, 10);
    }
    getGridLineDashSliderParams(labelKey) {
        const initialStyles = this.chartOptions.getValue("gridLine.style");
        const initialValue = initialStyles?.[0]?.lineDash?.[0];
        const params = this.chartMenuUtils.getDefaultSliderParamsWithoutValueParams(initialValue ?? 0, labelKey, 30);
        params.onValueChange = (value)=>{
            const stroke = this.chartOptions.getValue("gridLine.style.0.stroke");
            this.chartOptions.setValue("gridLine.style", [
                {
                    lineDash: [
                        value
                    ],
                    stroke: stroke
                }
            ]);
        };
        return params;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/axis/cartesianAxisPanel.ts
var $5b7ccabde48fae90$var$DEFAULT_TIME_AXIS_FORMAT = "%d %B %Y";
var $5b7ccabde48fae90$var$CartesianAxisPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(axisType, options){
        super();
        this.axisType = axisType;
        this.options = options;
        this.axisGroup = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.axisTypeSelect = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.axisPositionSelect = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.axisTimeFormatSelect = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.activePanels = [];
        this.updateFuncs = [];
        const { chartOptionsService: chartOptionsService, seriesType: seriesType, chartController: chartController } = options;
        this.chartOptionsService = chartOptionsService;
        this.chartController = chartController;
        this.chartOptionsSeriesProxy = chartOptionsService.getSeriesOptionsProxy(()=>seriesType);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { isExpandedOnInit: expanded, chartOptionsService: chartOptionsService, registerGroupComponent: registerGroupComponent } = this.options;
        const labelKey = this.axisType;
        const axisGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.translate(labelKey),
            expanded: expanded,
            suppressEnabledCheckbox: true
        };
        const chartAxisOptionsProxy = chartOptionsService.getCartesianAxisOptionsProxy(this.axisType);
        const chartAxisOptions = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(chartAxisOptionsProxy));
        const chartAxisThemeOverrides = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(chartOptionsService.getCartesianAxisThemeOverridesProxy(this.axisType)));
        const axisTypeSelectParams = this.getAxisTypeSelectParams(chartAxisOptions, chartOptionsService.getCartesianAxisAppliedThemeOverridesProxy(this.axisType));
        const axisPositionSelectParams = this.getAxisPositionSelectParams(chartAxisOptions);
        const axisTimeFormatSelectParams = this.getAxisTimeFormatSelectParams(chartAxisOptions);
        const axisColorInputParams = this.getAxisColorInputParams(chartAxisThemeOverrides);
        const axisLineWidthSliderParams = this.getAxisLineWidthSliderParams(chartAxisThemeOverrides);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="axisGroup">
                <ag-select data-ref="axisTypeSelect"></ag-select>
                <ag-select data-ref="axisTimeFormatSelect"></ag-select>
                <ag-select data-ref="axisPositionSelect"></ag-select>
                <ag-color-picker data-ref="axisColorInput"></ag-color-picker>
                <ag-slider data-ref="axisLineWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            (0, $437b23f6a393c3bf$export$e32612175ad118ef),
            $5b7ccabde48fae90$var$ColorPickerSelector,
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            axisGroup: axisGroupParams,
            axisTypeSelect: axisTypeSelectParams ?? void 0,
            axisPositionSelect: axisPositionSelectParams ?? void 0,
            axisTimeFormatSelect: axisTimeFormatSelectParams ?? void 0,
            axisColorInput: axisColorInputParams,
            axisLineWidthSlider: axisLineWidthSliderParams
        });
        registerGroupComponent(this.axisGroup);
        this.axisTypeSelect.setDisplayed(!!axisTypeSelectParams.options?.length);
        if (!axisPositionSelectParams) this.removeTemplateComponent(this.axisPositionSelect);
        const updateTimeFormatVisibility = ()=>{
            const isTimeAxis = chartAxisOptionsProxy.getValue("type") === "time";
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.axisTimeFormatSelect.getGui(), isTimeAxis);
        };
        if (!axisTimeFormatSelectParams) this.removeTemplateComponent(this.axisTimeFormatSelect);
        else {
            updateTimeFormatVisibility();
            this.addManagedEventListeners({
                chartOptionsChanged: ()=>{
                    updateTimeFormatVisibility();
                }
            });
        }
        this.initGridLines(chartAxisThemeOverrides);
        this.initAxisTicks(chartAxisThemeOverrides);
        this.initAxisLabels(chartAxisThemeOverrides);
        const updateFns = ()=>{
            for (const func of this.updateFuncs)func();
        };
        this.addManagedListeners(this.chartController, {
            chartUpdated: updateFns,
            chartModelUpdate: ()=>setTimeout(()=>{
                    if (!this.isAlive()) return;
                    this.refreshAxisTypeSelect(chartAxisOptions);
                    updateTimeFormatVisibility();
                })
        });
    }
    getAxisTypeSelectParams(chartAxisOptions, chartAxisAppliedThemeOverrides) {
        const chartOptions = chartAxisOptions.getChartOptions();
        const axisTypeSelectOptions = this.getAxisTypeSelectOptions();
        const params = chartAxisOptions.getDefaultSelectParams("type", "axisType", axisTypeSelectOptions);
        params.onValueChange = (value)=>{
            const previousAxisType = chartOptions.getValue("type");
            if (value === previousAxisType) return;
            const previousAxisThemeOverrides = chartAxisAppliedThemeOverrides.getValue("*");
            const previousAxisIsTimeAxis = previousAxisType === "time";
            const updatedAxisIsTimeAxis = value === "time";
            const updatedLabelFormat = previousAxisIsTimeAxis !== updatedAxisIsTimeAxis ? updatedAxisIsTimeAxis ? $5b7ccabde48fae90$var$DEFAULT_TIME_AXIS_FORMAT : void 0 : null;
            if (updatedLabelFormat === void 0) chartOptions.clearValue?.("label", "format");
            this.chartOptionsService.setCartesianCategoryAxisType(this.axisType, value);
            if (updatedLabelFormat != null) chartOptions.setValue("label.format", updatedLabelFormat);
            chartAxisAppliedThemeOverrides.setValue("*", previousAxisThemeOverrides);
        };
        return params;
    }
    refreshAxisTypeSelect(chartAxisOptions) {
        const options = this.getAxisTypeSelectOptions();
        const hasOptions = !!options.length;
        this.axisTypeSelect.setDisplayed(hasOptions);
        if (!hasOptions) return;
        this.axisTypeSelect.clearOptions().addOptions(options).setValue(chartAxisOptions.getChartOptions().getValue("type"));
    }
    getAxisTypeSelectOptions() {
        const controller = this.chartController;
        const chartType = controller.getChartType();
        const supportsNumericalAxis = ()=>{
            const testDatum = controller.getChartData()[0];
            if (!testDatum) return false;
            return controller.getSelectedDimensions().every((col)=>!isNaN(parseFloat(testDatum[col.colId])));
        };
        if ([
            "heatmap",
            "histogram",
            "boxPlot",
            "rangeBar",
            "scatter",
            "bubble"
        ].includes(chartType) || controller.isGrouping() || !this.isCategoryAxis() || controller.isCategorySeriesSwitched() || !supportsNumericalAxis()) return [];
        return [
            "category",
            "number",
            "time"
        ].map((value)=>({
                value: value,
                text: this.translate(value)
            }));
    }
    isCategoryAxis() {
        const isHorizontal = this.chartOptionsSeriesProxy.getValue("direction") === "horizontal";
        return isHorizontal && this.axisType === "yAxis" || !isHorizontal && this.axisType === "xAxis";
    }
    getAxisPositionSelectParams(chartAxisOptions) {
        const axisPositionSelectOptions = ((chartType, axisType)=>{
            if (chartType === "heatmap") return null;
            if (axisType === "xAxis") return [
                {
                    value: "top",
                    text: this.translate("top")
                },
                {
                    value: "bottom",
                    text: this.translate("bottom")
                }
            ];
            if (axisType === "yAxis") return [
                {
                    value: "left",
                    text: this.translate("left")
                },
                {
                    value: "right",
                    text: this.translate("right")
                }
            ];
        })(this.chartController.getChartType(), this.axisType);
        if (!axisPositionSelectOptions) return null;
        return chartAxisOptions.getDefaultSelectParams("position", "position", axisPositionSelectOptions);
    }
    getAxisTimeFormatSelectParams(chartAxisOptions) {
        if (!this.isCategoryAxis()) return null;
        const axisTimeFormatSelectOptions = [
            {
                value: "%d/%m/%Y",
                text: this.translate("timeFormatSlashesDDMMYYYY")
            },
            {
                value: "%m/%d/%Y",
                text: this.translate("timeFormatSlashesMMDDYYYY")
            },
            {
                value: "%d/%m/%y",
                text: this.translate("timeFormatSlashesDDMMYY")
            },
            {
                value: "%m/%d/%y",
                text: this.translate("timeFormatSlashesMMDDYY")
            },
            {
                value: "%d.%e.%y",
                text: this.translate("timeFormatDotsDDMYY")
            },
            {
                value: "%e.%d.%y",
                text: this.translate("timeFormatDotsMDDYY")
            },
            {
                value: "%Y-%m-%d",
                text: this.translate("timeFormatDashesYYYYMMDD")
            },
            {
                value: "%d %B %Y",
                text: this.translate("timeFormatSpacesDDMMMMYYYY")
            },
            {
                value: "%H:%M:%S",
                text: this.translate("timeFormatHHMMSS")
            },
            {
                value: "%I:%M:%S %p",
                text: this.translate("timeFormatHHMMSSAmPm")
            }
        ];
        return chartAxisOptions.getDefaultSelectParams("label.format", "timeFormat", axisTimeFormatSelectOptions);
    }
    getAxisColorInputParams(chartAxisThemeOverrides) {
        return chartAxisThemeOverrides.getDefaultColorPickerParams("line.stroke");
    }
    getAxisLineWidthSliderParams(chartAxisThemeOverrides) {
        const chartOptions = chartAxisThemeOverrides.getChartOptions();
        const getAxisLineWidth = ()=>{
            const isAxisLineEnabled = chartOptions.getValue("line.enabled");
            if (!isAxisLineEnabled) return null;
            return chartOptions.getValue("line.width");
        };
        const setAxisLineWidth = (value)=>{
            chartOptions.setValues([
                {
                    expression: "line.enabled",
                    value: value != null
                },
                {
                    expression: "line.width",
                    value: value ?? 0
                }
            ]);
        };
        const axisLineWidthSliderParams = chartAxisThemeOverrides.getDefaultSliderParamsWithoutValueParams(getAxisLineWidth() ?? 0, "thickness", 10);
        axisLineWidthSliderParams.onValueChange = (newValue)=>{
            setAxisLineWidth(newValue === 0 ? null : newValue);
        };
        return axisLineWidthSliderParams;
    }
    initGridLines(chartAxisThemeOverrides) {
        const chartType = this.chartController.getChartType();
        if (chartType === "heatmap") return;
        const gridLineComp = this.createBean(new $5b7ccabde48fae90$var$GridLinePanel(chartAxisThemeOverrides));
        this.axisGroup.addItem(gridLineComp);
        this.activePanels.push(gridLineComp);
    }
    initAxisTicks(chartAxisThemeOverrides) {
        if (!this.hasConfigurableAxisTicks()) return;
        const axisTicksComp = this.createBean(new $5b7ccabde48fae90$var$AxisTicksPanel(chartAxisThemeOverrides));
        this.axisGroup.addItem(axisTicksComp);
        this.activePanels.push(axisTicksComp);
        const updateTickFn = ()=>axisTicksComp.setTickSizeSliderDisplayed(this.isGroupedCategoryAxis());
        this.updateFuncs.push(updateTickFn);
        updateTickFn();
    }
    hasConfigurableAxisTicks() {
        const chartType = this.chartController.getChartType();
        switch(chartType){
            case "radarLine":
            case "radarArea":
            case "rangeBar":
            case "boxPlot":
            case "waterfall":
                return false;
            default:
                return true;
        }
    }
    initAxisLabels(chartAxisThemeOverrides) {
        const params = {
            name: this.translate("labels"),
            enabled: true,
            suppressEnabledCheckbox: true,
            chartMenuParamsFactory: chartAxisThemeOverrides,
            keyMapper: (key)=>`label.${key}`
        };
        const labelPanelComp = this.createBean(new $5b7ccabde48fae90$var$FontPanel(params));
        this.axisGroup.addItem(labelPanelComp);
        this.activePanels.push(labelPanelComp);
        this.addAdditionalLabelComps(labelPanelComp, chartAxisThemeOverrides);
    }
    addAdditionalLabelComps(labelPanelComp, chartAxisThemeOverrides) {
        this.addLabelPadding(labelPanelComp, chartAxisThemeOverrides);
        const rotationComp = this.createRotationWidget("labelRotation", chartAxisThemeOverrides);
        const autoRotateCb = this.initLabelRotation(rotationComp, chartAxisThemeOverrides);
        labelPanelComp.addItem(autoRotateCb);
        labelPanelComp.addItem(rotationComp);
    }
    initLabelRotation(rotationComp, chartAxisThemeOverrides) {
        const chartOptions = chartAxisThemeOverrides.getChartOptions();
        const getLabelRotationValue = ()=>{
            return chartOptions.getValue("label.rotation");
        };
        const getLabelAutoRotateValue = ()=>{
            return chartOptions.getValue("label.autoRotate");
        };
        const updateAutoRotate = (autoRotate2)=>{
            if (autoRotate2) this.prevRotation = getLabelRotationValue();
            chartOptions.setValues([
                {
                    expression: "label.autoRotate",
                    value: autoRotate2
                },
                // Clear the rotation option when activating auto-rotate, reinstate the previous value when deactivating
                {
                    expression: "label.rotation",
                    value: autoRotate2 ? void 0 : this.prevRotation
                }
            ]);
            rotationComp.setDisplayed(!autoRotate2);
        };
        const rotation = getLabelRotationValue();
        const autoRotate = typeof rotation === "number" ? false : getLabelAutoRotateValue();
        const autoRotateCheckbox = this.createBean(new (0, $437b23f6a393c3bf$export$b00c508c1ae18d07)({
            label: this.translate("autoRotate"),
            value: autoRotate,
            onValueChange: updateAutoRotate
        }));
        rotationComp.setDisplayed(!autoRotate);
        const autoRotateUpdateFn = ()=>autoRotateCheckbox.setDisplayed(this.isGroupedCategoryAxis());
        this.updateFuncs.push(autoRotateUpdateFn);
        autoRotateUpdateFn();
        return autoRotateCheckbox;
    }
    createRotationWidget(labelKey, chartAxisThemeOverrides) {
        const chartOptions = chartAxisThemeOverrides.getChartOptions();
        const getLabelRotationValue = ()=>{
            return chartOptions.getValue("label.rotation");
        };
        const setLabelRotationValue = (value)=>{
            return chartOptions.setValue("label.rotation", value);
        };
        const degreesSymbol = String.fromCharCode(176);
        const label = `${this.chartTranslation.translate(labelKey)} ${degreesSymbol}`;
        const angleSelect = new $5b7ccabde48fae90$var$AgAngleSelect({
            label: label,
            labelWidth: "flex",
            value: getLabelRotationValue() ?? 0,
            onValueChange: setLabelRotationValue
        });
        this.updateFuncs.push(()=>{
            angleSelect.setValue(getLabelRotationValue() ?? 0);
        });
        return this.createBean(angleSelect);
    }
    isGroupedCategoryAxis() {
        const axisOptionsType = this.chartOptionsService.getCartesianAxisOptionsProxy(this.axisType).getValue("type");
        if (axisOptionsType === "grouped-category") return !this.isCategoryAxis();
        return true;
    }
    addLabelPadding(labelPanelComp, chartAxisThemeOverrides) {
        const labelPaddingSlider = this.createBean(new $5b7ccabde48fae90$export$f781195bf2b12bc5(chartAxisThemeOverrides.getDefaultSliderParams("label.spacing", "padding", 30)));
        labelPanelComp.addItem(labelPaddingSlider);
    }
    translate(key) {
        return this.chartTranslation.translate(key);
    }
    removeTemplateComponent(component) {
        (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(component.getGui());
        this.destroyBean(component);
    }
    destroyActivePanels() {
        for (const panel of this.activePanels){
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(panel.getGui());
            this.destroyBean(panel);
        }
    }
    destroy() {
        this.destroyActivePanels();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$PolarAxisPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(options){
        super();
        this.options = options;
        this.axisGroup = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { isExpandedOnInit: expanded, chartAxisMenuParamsFactory: chartAxisMenuParamsFactory, registerGroupComponent: registerGroupComponent } = this.options;
        const axisGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.translate("polarAxis"),
            expanded: expanded,
            suppressEnabledCheckbox: true
        };
        const axisColorInputParams = chartAxisMenuParamsFactory.getDefaultColorPickerParams("line.stroke");
        const axisLineWidthSliderParams = chartAxisMenuParamsFactory.getDefaultSliderParams("line.width", "thickness", 10);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="axisGroup">
                <ag-color-picker data-ref="axisColorInput"></ag-color-picker>
                <ag-slider data-ref="axisLineWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$var$ColorPickerSelector,
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            axisGroup: axisGroupParams,
            axisColorInput: axisColorInputParams,
            axisLineWidthSlider: axisLineWidthSliderParams
        });
        registerGroupComponent(this.axisGroup);
        this.initAxis();
        this.initAxisLabels();
        this.initRadiusAxis();
    }
    initAxis() {
        const chartType = this.options.chartController.getChartType();
        const hasConfigurableAxisShape = [
            "radarLine",
            "radarArea"
        ].includes(chartType);
        if (hasConfigurableAxisShape) {
            const options = [
                {
                    value: "circle",
                    text: this.translate("circle")
                },
                {
                    value: "polygon",
                    text: this.translate("polygon")
                }
            ];
            this.axisGroup.addItem(this.createSelect({
                labelKey: "shape",
                options: options,
                property: "shape"
            }));
        }
        if (chartType !== "pie") this.axisGroup.addItem(this.createSlider({
            labelKey: "innerRadius",
            defaultMaxValue: 1,
            property: "innerRadiusRatio"
        }));
    }
    initAxisLabels() {
        const params = {
            name: this.translate("labels"),
            enabled: true,
            suppressEnabledCheckbox: true,
            chartMenuParamsFactory: this.options.chartAxisMenuParamsFactory,
            keyMapper: (key)=>`label.${key}`
        };
        const labelPanelComp = this.createManagedBean(new $5b7ccabde48fae90$var$FontPanel(params));
        const labelOrientationComp = this.createOrientationWidget();
        labelPanelComp.addItem(labelOrientationComp);
        this.axisGroup.addItem(labelPanelComp);
    }
    createOrientationWidget() {
        const options = [
            {
                value: "fixed",
                text: this.translate("fixed")
            },
            {
                value: "parallel",
                text: this.translate("parallel")
            },
            {
                value: "perpendicular",
                text: this.translate("perpendicular")
            }
        ];
        return this.createSelect({
            labelKey: "orientation",
            options: options,
            property: "label.orientation"
        });
    }
    initRadiusAxis() {
        const chartSeriesType = $5b7ccabde48fae90$var$getSeriesType(this.options.chartController.getChartType());
        if (!$5b7ccabde48fae90$var$isRadial(chartSeriesType)) return;
        const items = [
            this.createSlider({
                labelKey: "groupPadding",
                defaultMaxValue: 1,
                property: "paddingInner"
            }),
            this.createSlider({
                labelKey: "seriesPadding",
                defaultMaxValue: 1,
                property: "groupPaddingInner"
            })
        ];
        const paddingPanelComp = this.createManagedBean(new $5b7ccabde48fae90$export$9c4ea4ce92935a7e({
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            enabled: true,
            suppressEnabledCheckbox: true,
            title: this.translate("padding"),
            items: items
        })).hideEnabledCheckbox(true).hideOpenCloseIcons(true);
        this.axisGroup.addItem(paddingPanelComp);
    }
    createSlider(config) {
        const { labelKey: labelKey, defaultMaxValue: defaultMaxValue, step: step = 0.05, property: property } = config;
        const params = this.options.chartAxisMenuParamsFactory.getDefaultSliderParams(property, labelKey, defaultMaxValue);
        params.step = step;
        return this.createManagedBean(new $5b7ccabde48fae90$export$f781195bf2b12bc5(params));
    }
    createSelect(config) {
        const { labelKey: labelKey, options: options, property: property } = config;
        return this.createManagedBean(new (0, $437b23f6a393c3bf$export$6f9c460854d56032)(this.options.chartAxisMenuParamsFactory.getDefaultSelectParams(property, labelKey, options)));
    }
    translate(key) {
        return this.chartTranslation.translate(key);
    }
};
var $5b7ccabde48fae90$var$BackgroundPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const chartBackgroundGroupParams = this.chartMenuUtils.addEnableParams("background.visible", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("background"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const colorPickerParams = this.chartMenuUtils.getDefaultColorPickerParams("background.fill");
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="chartBackgroundGroup">
                <ag-color-picker data-ref="colorPicker"></ag-color-picker>
            </ag-group-component>
        <div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$var$ColorPickerSelector
        ], {
            chartBackgroundGroup: chartBackgroundGroupParams,
            colorPicker: colorPickerParams
        });
    }
};
var $5b7ccabde48fae90$var$PaddingPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils, chartController){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.chartController = chartController;
        this.paddingTopSlider = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const chartPaddingGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("padding"),
            suppressEnabledCheckbox: true
        };
        const getSliderParams = (property)=>this.chartMenuUtils.getDefaultSliderParams("padding." + property, property, 200);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="chartPaddingGroup">
                <ag-slider data-ref="paddingTopSlider"></ag-slider>
                <ag-slider data-ref="paddingRightSlider"></ag-slider>
                <ag-slider data-ref="paddingBottomSlider"></ag-slider>
                <ag-slider data-ref="paddingLeftSlider"></ag-slider>
            </ag-group-component>
        <div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            chartPaddingGroup: chartPaddingGroupParams,
            paddingTopSlider: getSliderParams("top"),
            paddingRightSlider: getSliderParams("right"),
            paddingBottomSlider: getSliderParams("bottom"),
            paddingLeftSlider: getSliderParams("left")
        });
        this.addManagedEventListeners({
            chartOptionsChanged: (e)=>{
                this.updateTopPadding(e.chartOptions);
            }
        });
    }
    updateTopPadding(chartOptions) {
        const topPadding = [
            ...this.chartController.getChartSeriesTypes(),
            "common"
        ].map((seriesType)=>chartOptions?.[seriesType]?.padding?.top).find((value)=>value != null);
        if (topPadding != null) this.paddingTopSlider.setValue(`${topPadding}`);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/chart/chartPanel.ts
var $5b7ccabde48fae90$var$ChartPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(options){
        super();
        this.options = options;
        this.chartGroup = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { chartController: chartController, chartMenuParamsFactory: chartMenuParamsFactory, isExpandedOnInit: expanded, registerGroupComponent: registerGroupComponent } = this.options;
        const chartGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.chartTranslation.translate("chartStyle"),
            expanded: expanded,
            suppressEnabledCheckbox: true,
            items: [
                this.createManagedBean(new $5b7ccabde48fae90$var$PaddingPanel(chartMenuParamsFactory, chartController)),
                this.createManagedBean(new $5b7ccabde48fae90$var$BackgroundPanel(chartMenuParamsFactory))
            ]
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="chartGroup"></ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a
        ], {
            chartGroup: chartGroupParams
        });
        registerGroupComponent(this.chartGroup);
    }
};
var $5b7ccabde48fae90$var$GroupExpansionFeature = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(groupContainer){
        super();
        this.groupContainer = groupContainer;
        this.id = 0;
        this.groupComponents = /* @__PURE__ */ new Map();
    }
    addGroupComponent(groupComponent) {
        const id = this.id++;
        this.groupComponents.set(id, groupComponent);
        if (groupComponent.isExpanded()) this.expandedGroupComponent = id;
        groupComponent.onExpandedChange((expanded)=>{
            if (expanded) {
                const previouslyExpandedGroupComponent = this.expandedGroupComponent;
                this.expandedGroupComponent = id;
                if (previouslyExpandedGroupComponent != null) {
                    const groupComponentGui = groupComponent.getGui();
                    const groupPositionInViewport = groupComponentGui.offsetTop - this.groupContainer.parentElement.scrollTop;
                    this.groupComponents.get(previouslyExpandedGroupComponent)?.toggleGroupExpand(false, true);
                    let newScrollTop = groupComponentGui.offsetTop - groupPositionInViewport;
                    if (newScrollTop < 0) newScrollTop = 0;
                    if (newScrollTop !== this.groupContainer.parentElement.scrollTop) this.groupContainer.parentElement.scrollTop = newScrollTop;
                }
            } else this.expandedGroupComponent = void 0;
        });
    }
    destroy() {
        this.groupComponents.clear();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$LegendPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(options, chartMenuContext){
        super();
        this.options = options;
        this.legendGroup = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.enabledGroup = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.isGradient = [
            "treemap",
            "sunburst",
            "heatmap"
        ].includes(options.seriesType);
        this.key = this.isGradient ? "gradientLegend" : "legend";
        this.chartController = chartMenuContext.chartController;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { chartMenuParamsFactory: chartMenuParamsFactory, isExpandedOnInit: expanded, registerGroupComponent: registerGroupComponent } = this.options;
        const positionSelect = this.createManagedBean(new (0, $437b23f6a393c3bf$export$6f9c460854d56032)(chartMenuParamsFactory.getDefaultSelectParams(`${this.key}.position`, "position", [
            "top",
            "right",
            "bottom",
            "left"
        ].map((position)=>({
                value: position,
                text: this.chartTranslation.translate(position)
            })))));
        this.enabledGroup = this.createManagedBean(new $5b7ccabde48fae90$export$9c4ea4ce92935a7e(chartMenuParamsFactory.addEnableParams(`${this.key}.enabled`, {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("legendEnabled"),
            suppressEnabledCheckbox: true,
            useToggle: true,
            items: [
                this.createLabelPanel(chartMenuParamsFactory),
                positionSelect,
                ...this.getItems(chartMenuParamsFactory)
            ]
        })));
        const legendGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.chartTranslation.translate("legend"),
            suppressEnabledCheckbox: true,
            expanded: expanded,
            items: [
                this.enabledGroup
            ]
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="legendGroup">
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a
        ], {
            legendGroup: legendGroupParams
        });
        registerGroupComponent(this.legendGroup);
        const listener = this.updateLegendEnabledState.bind(this);
        this.addManagedListeners(this.chartController, {
            chartModelUpdate: listener,
            chartApiUpdate: listener
        });
    }
    updateLegendEnabledState() {
        const { valueCols: valueCols } = this.chartController.getColStateForMenu();
        this.enabledGroup.setEnabled(valueCols.filter((vc)=>vc.selected).length > 1);
    }
    getItems(chartMenuParamsFactory) {
        const createSlider = (expression, labelKey, defaultMaxValue)=>this.createManagedBean(new $5b7ccabde48fae90$export$f781195bf2b12bc5(chartMenuParamsFactory.getDefaultSliderParams(`${this.key}.${expression}`, labelKey, defaultMaxValue)));
        if (this.isGradient) return [
            this.createManagedBean(new (0, $437b23f6a393c3bf$export$b00c508c1ae18d07)(chartMenuParamsFactory.addValueParams("gradientLegend.reverseOrder", {
                label: this.chartTranslation.translate("reverseDirection"),
                labelWidth: "flex"
            }))),
            createSlider("gradient.thickness", "thickness", 40),
            createSlider("gradient.preferredLength", "preferredLength", 300),
            createSlider("spacing", "spacing", 200)
        ];
        return [
            createSlider("spacing", "spacing", 200),
            createSlider("item.marker.size", "markerSize", 40),
            createSlider("item.marker.strokeWidth", "markerStroke", 10),
            createSlider("item.marker.padding", "itemSpacing", 20),
            createSlider("item.paddingX", "layoutHorizontalSpacing", 50),
            createSlider("item.paddingY", "layoutVerticalSpacing", 50)
        ];
    }
    createLabelPanel(chartMenuParamsFactory) {
        const rootKey = this.isGradient ? "gradientLegend.scale.label" : "legend.item.label";
        const params = {
            enabled: true,
            suppressEnabledCheckbox: true,
            chartMenuParamsFactory: chartMenuParamsFactory,
            keyMapper: (key)=>`${rootKey}.${key}`,
            cssIdentifier: "charts-format-sub-level-no-header"
        };
        return this.createManagedBean(new $5b7ccabde48fae90$var$FontPanel(params));
    }
};
var $5b7ccabde48fae90$var$ToggleablePanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(params){
        super();
        this.params = params;
        this.toggleableGroup = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.activeComps = [];
        this.chartOptions = params.chartMenuParamsFactory.getChartOptions();
    }
    postConstruct() {
        const { tag: tag, cssIdentifier: cssIdentifier = "charts-format-sub-level", title: title, suppressEnabledCheckbox: suppressEnabledCheckbox } = this.params;
        const groupParams = this.params.chartMenuParamsFactory.addEnableParams(`${tag}.enabled`, {
            cssIdentifier: cssIdentifier,
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: title,
            suppressEnabledCheckbox: true,
            useToggle: !suppressEnabledCheckbox
        });
        this.setTemplate(/* html */ `<div class="ag-toggleable-group-panel">
                <ag-group-component data-ref="toggleableGroup">
                </ag-group-component>
            </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a
        ], {
            toggleableGroup: groupParams
        });
        this.toggleCss(`ag-toggleable-group-panel-no-header`, !title);
    }
    addItem(comp, prepend) {
        if (prepend) this.toggleableGroup.prependItem(comp);
        else this.toggleableGroup.addItem(comp);
        this.activeComps.push(comp);
    }
    setEnabled(enabled) {
        this.toggleableGroup.setEnabled(enabled);
    }
    destroyActiveComps() {
        for (const comp of this.activeComps){
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(comp.getGui());
            this.destroyBean(comp);
        }
    }
    destroy() {
        this.destroyActiveComps();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$CalloutPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const calloutGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("callout"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="calloutGroup">
                <ag-slider data-ref="calloutLengthSlider"></ag-slider>
                <ag-slider data-ref="calloutStrokeWidthSlider"></ag-slider>
                <ag-slider data-ref="labelOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            calloutGroup: calloutGroupParams,
            calloutLengthSlider: this.chartMenuUtils.getDefaultSliderParams("calloutLine.length", "length", 40),
            calloutStrokeWidthSlider: this.chartMenuUtils.getDefaultSliderParams("calloutLine.strokeWidth", "strokeWidth", 10),
            labelOffsetSlider: this.chartMenuUtils.getDefaultSliderParams("calloutLabel.offset", "offset", 30)
        });
    }
};
var $5b7ccabde48fae90$var$CapsPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const capsGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("cap"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        const capLengthRatioSliderParams = this.chartMenuUtils.getDefaultSliderParams("cap.lengthRatio", "capLengthRatio", 1);
        capLengthRatioSliderParams.step = 0.05;
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="capsGroup">
                <ag-slider data-ref="capLengthRatioSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            capsGroup: capsGroupParams,
            capLengthRatioSlider: capLengthRatioSliderParams
        });
    }
};
var $5b7ccabde48fae90$var$ConnectorLinePanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const lineGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("connectorLine"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="lineGroup">
                <ag-color-picker data-ref="lineColorPicker"></ag-color-picker>
                <ag-slider data-ref="lineStrokeWidthSlider"></ag-slider>
                <ag-slider data-ref="lineOpacitySlider"></ag-slider>
                <ag-slider data-ref="lineDashSlider"></ag-slider>                
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$var$ColorPickerSelector,
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            lineGroup: lineGroupParams,
            lineColorPicker: this.chartMenuUtils.getDefaultColorPickerParams("line.stroke"),
            lineStrokeWidthSlider: this.getSliderParams("strokeWidth", 10, "line.strokeWidth"),
            lineDashSlider: this.getSliderParams("lineDash", 30, "line.lineDash", 1, true),
            lineOpacitySlider: this.getSliderParams("strokeOpacity", 1, "line.strokeOpacity", 0.05)
        });
    }
    getSliderParams(labelKey, maxValue, seriesOptionKey, step = 1, isArray = false) {
        const params = this.chartMenuUtils.getDefaultSliderParams(seriesOptionKey, labelKey, maxValue, isArray);
        params.step = step;
        return params;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/series/seriesUtils.ts
function $5b7ccabde48fae90$var$getShapeSelectOptions(chartTranslation) {
    return [
        "square",
        "circle",
        "cross",
        "diamond",
        "plus",
        "triangle",
        "heart"
    ].map((value)=>({
            value: value,
            text: chartTranslation.translate(value)
        }));
}
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/series/markersPanel.ts
var $5b7ccabde48fae90$var$MarkersPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const seriesMarkersGroupParams = this.chartMenuUtils.addEnableParams("marker.enabled", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("markers"),
            suppressEnabledCheckbox: true,
            useToggle: true,
            suppressOpenCloseIcons: true
        });
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="seriesMarkersGroup">
                <ag-select data-ref="seriesMarkerShapeSelect"></ag-select>
                <ag-slider data-ref="seriesMarkerSizeSlider"></ag-slider>
                <ag-slider data-ref="seriesMarkerStrokeWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            (0, $437b23f6a393c3bf$export$e32612175ad118ef),
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            seriesMarkersGroup: seriesMarkersGroupParams,
            seriesMarkerShapeSelect: this.chartMenuUtils.getDefaultSelectParams("marker.shape", "shape", $5b7ccabde48fae90$var$getShapeSelectOptions(this.chartTranslation)),
            seriesMarkerSizeSlider: this.chartMenuUtils.getDefaultSliderParams("marker.size", "size", 60),
            seriesMarkerStrokeWidthSlider: this.chartMenuUtils.getDefaultSliderParams("marker.strokeWidth", "strokeWidth", 10)
        });
    }
};
var $5b7ccabde48fae90$var$SeriesItemsPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.seriesItemsGroup = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.activePanels = [];
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const seriesItemsGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("seriesItems"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="seriesItemsGroup">
                <ag-select data-ref="seriesItemSelect"></ag-select>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            (0, $437b23f6a393c3bf$export$e32612175ad118ef)
        ], {
            seriesItemsGroup: seriesItemsGroupParams,
            seriesItemSelect: this.getSeriesItemsParams()
        });
        this.initSeriesControls();
    }
    getSeriesItemsParams() {
        const options = [
            {
                value: "positive",
                text: this.chartTranslation.translate("seriesItemPositive")
            },
            {
                value: "negative",
                text: this.chartTranslation.translate("seriesItemNegative")
            }
        ];
        const seriesItemChangedCallback = (newValue)=>{
            this.destroyActivePanels();
            this.initSeriesControls(newValue);
        };
        return this.chartMenuUtils.getDefaultSelectParamsWithoutValueParams("seriesItemType", options, "positive", seriesItemChangedCallback);
    }
    initSeriesControls(itemType = "positive") {
        this.initSlider("strokeWidth", 10, `item.${itemType}.strokeWidth`);
        this.initSlider("lineDash", 30, `item.${itemType}.lineDash`, 1, true);
        this.initSlider("strokeOpacity", 1, `item.${itemType}.strokeOpacity`, 0.05, false);
        this.initSlider("fillOpacity", 1, `item.${itemType}.fillOpacity`, 0.05, false);
        this.initItemLabels(itemType);
    }
    initSlider(labelKey, maxValue, seriesOptionKey, step = 1, isArray = false) {
        const params = this.chartMenuUtils.getDefaultSliderParams(seriesOptionKey, labelKey, maxValue, isArray);
        params.step = step;
        const itemSlider = this.seriesItemsGroup.createManagedBean(new $5b7ccabde48fae90$export$f781195bf2b12bc5(params));
        this.seriesItemsGroup.addItem(itemSlider);
        this.activePanels.push(itemSlider);
    }
    initItemLabels(itemType) {
        const sectorParams = this.chartMenuUtils.getDefaultFontPanelParams(`item.${itemType}.label`, "seriesItemLabels");
        const labelPanelComp = this.createBean(new $5b7ccabde48fae90$var$FontPanel(sectorParams));
        this.seriesItemsGroup.addItem(labelPanelComp);
        this.activePanels.push(labelPanelComp);
    }
    destroyActivePanels() {
        for (const panel of this.activePanels){
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(panel.getGui());
            this.destroyBean(panel);
        }
    }
    destroy() {
        this.destroyActivePanels();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ShadowPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils, propertyKey = "shadow"){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.propertyKey = propertyKey;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const propertyNamespace = this.propertyKey;
        const shadowGroupParams = this.chartMenuUtils.addEnableParams(`${propertyNamespace}.enabled`, {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslation.translate("shadow"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const shadowColorPickerParams = this.chartMenuUtils.getDefaultColorPickerParams(`${propertyNamespace}.color`);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="shadowGroup">
                <ag-color-picker data-ref="shadowColorPicker"></ag-color-picker>
                <ag-slider data-ref="shadowBlurSlider"></ag-slider>
                <ag-slider data-ref="shadowXOffsetSlider"></ag-slider>
                <ag-slider data-ref="shadowYOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$var$ColorPickerSelector,
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            shadowGroup: shadowGroupParams,
            shadowColorPicker: shadowColorPickerParams,
            shadowBlurSlider: this.getSliderParams("blur", 0, 20),
            shadowXOffsetSlider: this.getSliderParams("xOffset", -10, 10),
            shadowYOffsetSlider: this.getSliderParams("yOffset", -10, 10)
        });
    }
    getSliderParams(property, minValue, defaultMaxValue) {
        const expression = `${this.propertyKey}.${property}`;
        const params = this.chartMenuUtils.getDefaultSliderParams(expression, property, defaultMaxValue);
        params.minValue = minValue;
        return params;
    }
};
var $5b7ccabde48fae90$var$TileSpacingPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const groupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="groupSpacing">
                <ag-slider data-ref="groupPaddingSlider"></ag-slider>
                <ag-slider data-ref="groupSpacingSlider"></ag-slider>
            </ag-group-component>
            <ag-group-component data-ref="tileSpacing">
                <ag-slider data-ref="tilePaddingSlider"></ag-slider>
                <ag-slider data-ref="tileSpacingSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            groupSpacing: {
                ...groupParams,
                title: this.chartTranslation.translate("group")
            },
            tileSpacing: {
                ...groupParams,
                title: this.chartTranslation.translate("tile")
            },
            groupPaddingSlider: this.getSliderParams("padding", "group.padding"),
            groupSpacingSlider: this.getSliderParams("spacing", "group.gap"),
            tilePaddingSlider: this.getSliderParams("padding", "tile.padding"),
            tileSpacingSlider: this.getSliderParams("spacing", "tile.gap")
        });
    }
    getSliderParams(labelKey, key) {
        return this.chartMenuUtils.getDefaultSliderParams(key, labelKey, 10);
    }
};
function $5b7ccabde48fae90$var$_capitalise2(str) {
    return str[0].toUpperCase() + str.substring(1);
}
var $5b7ccabde48fae90$var$TooltipPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.tooltipMode = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    postConstruct() {
        const { chartMenuUtils: chartMenuUtils, beans: beans } = this;
        const propertyKey = "tooltip";
        const chartTranslation = beans.chartTranslation;
        const tooltipGroupParams = chartMenuUtils.addEnableParams(`${propertyKey}.enabled`, {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: chartTranslation.translate("tooltips"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const tooltipModeLocaleKey = "tooltipMode";
        const tooltipModeSelectionOptions = [
            "single",
            "shared",
            "compact"
        ].map((value)=>({
                value: value,
                text: chartTranslation.translate(`${tooltipModeLocaleKey}${$5b7ccabde48fae90$var$_capitalise2(value)}`)
            }));
        const tooltipModeExpression = `${propertyKey}.mode`;
        const tooltipModeSelectParams = chartMenuUtils.getDefaultSelectParams(tooltipModeExpression, tooltipModeLocaleKey, tooltipModeSelectionOptions);
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="tooltipGroup">
                <ag-select data-ref="tooltipMode"></ag-select>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            (0, $437b23f6a393c3bf$export$e32612175ad118ef)
        ], {
            tooltipGroup: tooltipGroupParams,
            tooltipMode: tooltipModeSelectParams
        });
        this.addManagedEventListeners({
            chartOptionsChanged: ()=>{
                const tooltipModeValue = chartMenuUtils.getChartOptions().getValue(tooltipModeExpression);
                this.tooltipMode.setValue(tooltipModeValue, true);
            }
        });
    }
};
var $5b7ccabde48fae90$var$WhiskersPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const whiskersGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslation.translate("whisker"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="whiskersGroup">
                <ag-color-picker data-ref="whiskerColorPicker"></ag-color-picker>
                <ag-slider data-ref="whiskerThicknessSlider"></ag-slider>
                <ag-slider data-ref="whiskerOpacitySlider"></ag-slider>
                <ag-slider data-ref="whiskerLineDashSlider"></ag-slider>
                <ag-slider data-ref="whiskerLineDashOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a,
            $5b7ccabde48fae90$var$ColorPickerSelector,
            $5b7ccabde48fae90$export$2be649a426f1e774
        ], {
            whiskersGroup: whiskersGroupParams,
            whiskerColorPicker: this.chartMenuUtils.getDefaultColorPickerParams("whisker.stroke"),
            whiskerThicknessSlider: this.chartMenuUtils.getDefaultSliderParams("whisker.strokeWidth", "strokeWidth", 10),
            whiskerOpacitySlider: this.chartMenuUtils.getDefaultSliderParams("whisker.strokeOpacity", "strokeOpacity", 1),
            whiskerLineDashSlider: this.chartMenuUtils.getDefaultSliderParams("whisker.lineDash", "lineDash", 30, true),
            whiskerLineDashOffsetSlider: this.chartMenuUtils.getDefaultSliderParams("whisker.lineDashOffset", "lineDashOffset", 30)
        });
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/series/seriesPanel.ts
var $5b7ccabde48fae90$var$tooltips = "tooltips";
var $5b7ccabde48fae90$var$strokeWidth = "strokeWidth";
var $5b7ccabde48fae90$var$lineWidth = "lineWidth";
var $5b7ccabde48fae90$var$lineDash = "lineDash";
var $5b7ccabde48fae90$var$lineOpacity = "lineOpacity";
var $5b7ccabde48fae90$var$fillOpacity = "fillOpacity";
var $5b7ccabde48fae90$var$labels = "labels";
var $5b7ccabde48fae90$var$shadow = "shadow";
var $5b7ccabde48fae90$var$stageLabels = "stageLabels";
var $5b7ccabde48fae90$var$markers = "markers";
var $5b7ccabde48fae90$var$SeriesPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(options){
        super();
        this.options = options;
        this.seriesGroup = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.activePanels = [];
        this.widgetFuncs = {
            lineWidth: ()=>this.initStrokeWidth($5b7ccabde48fae90$var$lineWidth),
            [$5b7ccabde48fae90$var$strokeWidth]: ()=>this.initStrokeWidth("strokeWidth"),
            lineColor: ()=>this.initLineColor(),
            [$5b7ccabde48fae90$var$lineDash]: ()=>this.initLineDash(),
            [$5b7ccabde48fae90$var$lineOpacity]: ()=>this.initOpacity("strokeOpacity"),
            [$5b7ccabde48fae90$var$fillOpacity]: ()=>this.initOpacity("fillOpacity"),
            markers: ()=>new $5b7ccabde48fae90$var$MarkersPanel(this.chartMenuUtils),
            [$5b7ccabde48fae90$var$labels]: ()=>this.initLabels(),
            sectorLabels: ()=>this.initSectorLabels(),
            [$5b7ccabde48fae90$var$shadow]: ()=>new $5b7ccabde48fae90$var$ShadowPanel(this.chartMenuUtils),
            [$5b7ccabde48fae90$var$tooltips]: ()=>new $5b7ccabde48fae90$var$TooltipPanel(this.options.chartMenuParamsFactory),
            bins: ()=>this.initBins(),
            whiskers: ()=>new $5b7ccabde48fae90$var$WhiskersPanel(this.chartMenuUtils),
            caps: ()=>new $5b7ccabde48fae90$var$CapsPanel(this.chartMenuUtils),
            connectorLine: ()=>new $5b7ccabde48fae90$var$ConnectorLinePanel(this.chartMenuUtils),
            seriesItems: ()=>new $5b7ccabde48fae90$var$SeriesItemsPanel(this.chartMenuUtils),
            tileSpacing: ()=>new $5b7ccabde48fae90$var$TileSpacingPanel(this.chartMenuUtils),
            shape: ()=>this.initShape(),
            size: ()=>this.initSize("size", "size"),
            minSize: ()=>this.initSize("size", "minSize"),
            maxSize: ()=>this.initSize("maxSize", "maxSize"),
            dropoff: ()=>this.initDropOff(),
            stageLabels: ()=>this.initStageLabels()
        };
        this.seriesWidgetMappings = {
            bar: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$shadow
            ],
            pie: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                "sectorLabels",
                $5b7ccabde48fae90$var$shadow
            ],
            donut: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                "sectorLabels",
                $5b7ccabde48fae90$var$shadow
            ],
            line: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$lineWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$markers,
                $5b7ccabde48fae90$var$labels
            ],
            scatter: [
                $5b7ccabde48fae90$var$tooltips,
                "shape",
                "size",
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$labels
            ],
            bubble: [
                $5b7ccabde48fae90$var$tooltips,
                "shape",
                "minSize",
                "maxSize",
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$labels
            ],
            area: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$lineWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$markers,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$shadow
            ],
            histogram: [
                $5b7ccabde48fae90$var$tooltips,
                "bins",
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$shadow
            ],
            "radial-column": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels
            ],
            "radial-bar": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels
            ],
            "radar-line": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$markers,
                $5b7ccabde48fae90$var$labels
            ],
            "radar-area": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$markers,
                $5b7ccabde48fae90$var$labels
            ],
            nightingale: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels
            ],
            "box-plot": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                "whiskers",
                "caps"
            ],
            "range-bar": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels
            ],
            "range-area": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$lineWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$markers,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$shadow
            ],
            treemap: [
                $5b7ccabde48fae90$var$tooltips,
                "tileSpacing"
            ],
            sunburst: [
                $5b7ccabde48fae90$var$tooltips
            ],
            heatmap: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$labels,
                "lineColor",
                $5b7ccabde48fae90$var$lineWidth,
                $5b7ccabde48fae90$var$lineOpacity
            ],
            waterfall: [
                $5b7ccabde48fae90$var$tooltips,
                "connectorLine",
                "seriesItems"
            ],
            funnel: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                "dropoff",
                $5b7ccabde48fae90$var$stageLabels,
                $5b7ccabde48fae90$var$shadow
            ],
            "cone-funnel": [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$stageLabels
            ],
            pyramid: [
                $5b7ccabde48fae90$var$tooltips,
                $5b7ccabde48fae90$var$strokeWidth,
                $5b7ccabde48fae90$var$lineDash,
                $5b7ccabde48fae90$var$lineOpacity,
                $5b7ccabde48fae90$var$fillOpacity,
                $5b7ccabde48fae90$var$labels,
                $5b7ccabde48fae90$var$stageLabels,
                $5b7ccabde48fae90$var$shadow
            ]
        };
        this.seriesType = options.seriesType;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { isExpandedOnInit: expanded, chartOptionsService: chartOptionsService, chartController: chartController, registerGroupComponent: registerGroupComponent } = this.options;
        const seriesGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.translate("series"),
            expanded: expanded,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="seriesGroup">
            </ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a
        ], {
            seriesGroup: seriesGroupParams
        });
        registerGroupComponent(this.seriesGroup);
        this.chartMenuUtils = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(chartOptionsService.getSeriesOptionsProxy(()=>this.seriesType)));
        this.addManagedListeners(chartController, {
            chartSeriesChartTypeChanged: this.refreshWidgets.bind(this)
        });
        this.refreshWidgets();
    }
    refreshWidgets() {
        const { chartController: chartController } = this.options;
        this.destroyActivePanels();
        const chart = chartController.getChartProxy().getChart();
        chart.waitForUpdate().then(()=>{
            const componentWasRemoved = !this.isAlive();
            if (componentWasRemoved) return;
            if (chartController.isComboChart()) {
                this.updateSeriesType();
                this.initSeriesSelect();
            }
            for (const w of this.seriesWidgetMappings[this.seriesType] ?? []){
                const widgetFuncResult = this.widgetFuncs[w]();
                let widget;
                if (Array.isArray(widgetFuncResult)) {
                    const comp = this.createBean(widgetFuncResult[0]);
                    widget = comp;
                    widgetFuncResult[1](comp);
                } else widget = this.createBean(widgetFuncResult);
                this.seriesGroup.addItem(widget);
                this.activePanels.push(widget);
            }
        }).catch((e)=>(0, $437b23f6a393c3bf$export$a20c7248650823a9)(105, {
                e: e
            }));
    }
    initSeriesSelect() {
        const seriesSelect = this.createBean(new (0, $437b23f6a393c3bf$export$6f9c460854d56032)(this.chartMenuUtils.getDefaultSelectParamsWithoutValueParams("seriesType", this.getSeriesSelectOptions(), `${this.seriesType}`, (newValue)=>{
            this.seriesType = newValue;
            this.refreshWidgets();
        })));
        this.seriesGroup.addItem(seriesSelect);
        this.activePanels.push(seriesSelect);
    }
    initLineColor() {
        return new $5b7ccabde48fae90$var$ColorPicker(this.chartMenuUtils.getDefaultColorPickerParams("stroke", "strokeColor"));
    }
    initStrokeWidth(labelKey, expression) {
        return new $5b7ccabde48fae90$export$f781195bf2b12bc5(this.chartMenuUtils.getDefaultSliderParams(expression ? `${expression}.${labelKey}` : "strokeWidth", labelKey, 10));
    }
    initLineDash(expression) {
        return new $5b7ccabde48fae90$export$f781195bf2b12bc5(this.chartMenuUtils.getDefaultSliderParams(expression ? `${expression}.lineDash` : "lineDash", "lineDash", 30, true));
    }
    initOpacity(type, expression) {
        const params = this.chartMenuUtils.getDefaultSliderParams(expression ? `${expression}.${type}` : type, type, 1);
        params.step = 0.05;
        return new $5b7ccabde48fae90$export$f781195bf2b12bc5(params);
    }
    initDropOff() {
        const dropOffGroup = new $5b7ccabde48fae90$var$ToggleablePanel({
            tag: "dropOff",
            cssIdentifier: "charts-format-sub-level",
            title: this.translate("dropOff"),
            suppressEnabledCheckbox: false,
            chartMenuParamsFactory: this.chartMenuUtils
        });
        const addItems = (groupComponent)=>{
            for (const comp of [
                this.initStrokeWidth("strokeWidth", "dropOff"),
                this.initLineDash("dropOff"),
                this.initOpacity("strokeOpacity", "dropOff"),
                this.initOpacity("fillOpacity", "dropOff")
            ]){
                const managed = groupComponent.createManagedBean(comp);
                groupComponent.addItem(managed);
                this.activePanels.push(managed);
            }
        };
        return [
            dropOffGroup,
            addItems
        ];
    }
    initLabels() {
        const isPieChart = $5b7ccabde48fae90$var$isPieChartSeries(this.seriesType);
        const seriesOptionLabelProperty = isPieChart ? "calloutLabel" : "label";
        const labelKey = isPieChart ? "calloutLabels" : "labels";
        const labelParams = this.chartMenuUtils.getDefaultFontPanelParams(seriesOptionLabelProperty, labelKey);
        const fontPanel = new $5b7ccabde48fae90$var$FontPanel(labelParams);
        const addItems = (labelPanelComp)=>{
            if (isPieChart) {
                const calloutPanelComp = labelPanelComp.createManagedBean(new $5b7ccabde48fae90$var$CalloutPanel(this.chartMenuUtils));
                labelPanelComp.addItem(calloutPanelComp);
                this.activePanels.push(calloutPanelComp);
            }
            if (this.seriesType === "range-bar") {
                const options = [
                    {
                        value: "inside",
                        text: this.translate("inside")
                    },
                    {
                        value: "outside",
                        text: this.translate("outside")
                    }
                ];
                const placementSelect = labelPanelComp.createManagedBean(new (0, $437b23f6a393c3bf$export$6f9c460854d56032)(this.chartMenuUtils.getDefaultSelectParams("label.placement", "labelPlacement", options)));
                labelPanelComp.addItem(placementSelect);
                this.activePanels.push(placementSelect);
                const paddingSlider = labelPanelComp.createManagedBean(new $5b7ccabde48fae90$export$f781195bf2b12bc5(this.chartMenuUtils.getDefaultSliderParams("label.padding", "padding", 200)));
                labelPanelComp.addItem(paddingSlider);
                this.activePanels.push(paddingSlider);
            }
        };
        return [
            fontPanel,
            addItems
        ];
    }
    initSectorLabels() {
        const sectorParams = this.chartMenuUtils.getDefaultFontPanelParams("sectorLabel", "sectorLabels");
        const fontPanel = new $5b7ccabde48fae90$var$FontPanel(sectorParams);
        const addItems = (sectorPanelComp)=>{
            const positionRatioParams = this.chartMenuUtils.getDefaultSliderParams("sectorLabel.positionRatio", "positionRatio", 1);
            positionRatioParams.step = 0.05;
            const positionRatioComp = sectorPanelComp.createManagedBean(new $5b7ccabde48fae90$export$f781195bf2b12bc5(positionRatioParams));
            sectorPanelComp.addItem(positionRatioComp);
        };
        return [
            fontPanel,
            addItems
        ];
    }
    initStageLabels() {
        return new $5b7ccabde48fae90$var$FontPanel(this.chartMenuUtils.getDefaultFontPanelParams("stageLabel", $5b7ccabde48fae90$var$stageLabels));
    }
    initBins() {
        const params = this.chartMenuUtils.getDefaultSliderParams("binCount", "histogramBinCount", 20);
        const chartOptions = this.chartMenuUtils.getChartOptions();
        const value = (chartOptions.getValue("bins") ?? chartOptions.getValue("calculatedBins", true)).length;
        params.value = `${value}`;
        params.maxValue = Math.max(value, 20);
        return new $5b7ccabde48fae90$export$f781195bf2b12bc5(params);
    }
    initShape() {
        return new (0, $437b23f6a393c3bf$export$6f9c460854d56032)(this.chartMenuUtils.getDefaultSelectParams("shape", "shape", $5b7ccabde48fae90$var$getShapeSelectOptions(this.chartTranslation)));
    }
    initSize(expression, labelKey) {
        return new $5b7ccabde48fae90$export$f781195bf2b12bc5(this.chartMenuUtils.getDefaultSliderParams(expression, labelKey, 60));
    }
    getSeriesSelectOptions() {
        const activeSeriesTypes = this.getActiveSeriesTypes();
        return [
            "area",
            "bar",
            "line"
        ].filter((seriesType)=>activeSeriesTypes.includes(seriesType)).map((value)=>({
                value: value,
                text: this.translate(value)
            }));
    }
    updateSeriesType() {
        const activeSeriesTypes = this.getActiveSeriesTypes();
        const invalidSeriesType = !activeSeriesTypes.includes(this.seriesType);
        if (invalidSeriesType && activeSeriesTypes.length > 0) this.seriesType = activeSeriesTypes[0];
    }
    getActiveSeriesTypes() {
        return this.options.chartController.getActiveSeriesChartTypes().map((s2)=>$5b7ccabde48fae90$var$getSeriesType(s2.chartType));
    }
    translate(key) {
        return this.chartTranslation.translate(key);
    }
    destroyActivePanels() {
        for (const panel of this.activePanels){
            (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(panel.getGui());
            this.destroyBean(panel);
        }
    }
    destroy() {
        this.destroyActivePanels();
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$TitlePanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuUtils, name, key){
        super(/* html */ `<div></div>`);
        this.chartMenuUtils = chartMenuUtils;
        this.name = name;
        this.key = key;
        this.chartOptions = chartMenuUtils.getChartOptions();
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        this.initFontPanel();
    }
    hasTitle() {
        const title = this.chartOptions.getValue(this.key);
        return title?.enabled && title.text && title.text.length > 0;
    }
    initFontPanel() {
        const hasTitle = this.hasTitle();
        const fontPanelParams = {
            name: this.chartTranslation.translate(this.name),
            enabled: hasTitle,
            suppressEnabledCheckbox: false,
            chartMenuParamsFactory: this.chartMenuUtils,
            keyMapper: (key)=>`${this.key}.${key}`,
            onEnableChange: (enabled)=>this.onEnableChange(enabled)
        };
        this.fontPanel = this.createManagedBean(new $5b7ccabde48fae90$var$FontPanel(fontPanelParams));
        this.fontPanel.addItem(this.createBean(new (0, $437b23f6a393c3bf$export$8c027679838afd47)(this.getTextInputParams())), true);
        this.fontPanel.addItem(this.createBean(new $5b7ccabde48fae90$export$f781195bf2b12bc5(this.getSpacingSliderParams())));
        this.getGui().appendChild(this.fontPanel.getGui());
    }
    getTextInputParams() {
        return this.chartMenuUtils.addValueParams(`${this.key}.text`, {
            label: this.chartTranslation.translate("title"),
            labelAlignment: "top"
        });
    }
    getSpacingSliderParams() {
        return this.chartMenuUtils.getDefaultSliderParams(`${this.key}.spacing`, "spacing", 100);
    }
    onEnableChange(enabled) {
        this.chartOptions.setValue(`${this.key}.enabled`, enabled);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/titles/chartTitlePanel.ts
var $5b7ccabde48fae90$var$ChartTitlePanel = class extends $5b7ccabde48fae90$var$TitlePanel {
    wireBeans(beans) {
        super.wireBeans(beans);
        this.chartMenuSvc = beans.chartMenuSvc;
    }
    postConstruct() {
        this.titlePlaceholder = this.chartTranslation.translate("titlePlaceholder");
        super.postConstruct();
        this.addManagedEventListeners({
            chartTitleEdit: ()=>{
                this.fontPanel.setEnabled(this.hasTitle());
            }
        });
    }
    getTextInputParams() {
        const params = super.getTextInputParams();
        if (this.shouldOverrideTextWithPlaceholder(params.value)) params.value = this.titlePlaceholder;
        return params;
    }
    getSpacingSliderParams() {
        const params = super.getSpacingSliderParams();
        params.value = "10";
        return params;
    }
    onEnableChange(enabled) {
        if (this.chartMenuSvc.doesChartToolbarExist()) {
            const topPadding = this.chartOptions.getValue("padding.top");
            this.chartOptions.setValue("padding.top", enabled ? topPadding - 20 : topPadding + 20);
        }
        this.chartOptions.setValue(`${this.key}.enabled`, enabled);
        const currentTitleText = this.chartOptions.getValue(`${this.key}.text`);
        if (enabled && this.shouldOverrideTextWithPlaceholder(currentTitleText)) this.chartOptions.setValue(`${this.key}.text`, this.titlePlaceholder);
    }
    shouldOverrideTextWithPlaceholder(currentTitleText) {
        return currentTitleText === "Title" || currentTitleText?.trim().length === 0;
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/titles/titlesPanel.ts
var $5b7ccabde48fae90$var$TitlesPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(options){
        super();
        this.options = options;
        this.titleGroup = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        const { chartMenuParamsFactory: chartMenuParamsFactory, chartAxisMenuParamsFactory: chartAxisMenuParamsFactory, chartOptionsService: chartOptionsService, seriesType: seriesType, isExpandedOnInit: expanded = false, registerGroupComponent: registerGroupComponent } = this.options;
        const axisTitlePanels = [];
        if ($5b7ccabde48fae90$var$isCartesian(seriesType) && seriesType !== "pyramid") {
            const createAxisParamsFactory = (axisType)=>this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(chartOptionsService.getCartesianAxisThemeOverridesProxy(axisType)));
            axisTitlePanels.push(this.createManagedBean(new $5b7ccabde48fae90$var$TitlePanel(createAxisParamsFactory("xAxis"), "horizontalAxisTitle", "title")));
            axisTitlePanels.push(this.createManagedBean(new $5b7ccabde48fae90$var$TitlePanel(createAxisParamsFactory("yAxis"), "verticalAxisTitle", "title")));
        } else if ($5b7ccabde48fae90$var$isPolar(seriesType)) axisTitlePanels.push(this.createManagedBean(new $5b7ccabde48fae90$var$TitlePanel(chartAxisMenuParamsFactory, "polarAxisTitle", "title")));
        const titleGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.chartTranslation.translate("chartTitles"),
            expanded: expanded,
            suppressEnabledCheckbox: true,
            items: [
                this.createManagedBean(new $5b7ccabde48fae90$var$ChartTitlePanel(chartMenuParamsFactory, "chartTitle", "title")),
                this.createManagedBean(new $5b7ccabde48fae90$var$TitlePanel(chartMenuParamsFactory, "chartSubtitle", "subtitle")),
                ...axisTitlePanels
            ]
        };
        this.setTemplate(/* html */ `<div>
            <ag-group-component data-ref="titleGroup"></ag-group-component>
        </div>`, [
            $5b7ccabde48fae90$export$e8864b221efeb73a
        ], {
            titleGroup: titleGroupParams
        });
        registerGroupComponent(this.titleGroup);
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/format/formatPanel.ts
var $5b7ccabde48fae90$var$DefaultFormatPanelDef = {
    groups: [
        {
            type: "chart"
        },
        {
            type: "titles"
        },
        {
            type: "legend"
        },
        {
            type: "series"
        },
        {
            type: "axis"
        }
    ]
};
var $5b7ccabde48fae90$var$AXIS_KEYS = [
    "axis",
    "horizontalAxis",
    "verticalAxis"
];
var $5b7ccabde48fae90$var$FormatPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartMenuContext){
        super(/* html */ `<div class="ag-chart-format-wrapper"></div>`);
        this.chartMenuContext = chartMenuContext;
    }
    postConstruct() {
        this.groupExpansionFeature = this.createManagedBean(new $5b7ccabde48fae90$var$GroupExpansionFeature(this.getGui()));
        this.chartPanelFeature = this.createManagedBean(new $5b7ccabde48fae90$var$ChartPanelFeature(this.chartMenuContext.chartController, this.getGui(), "ag-chart-format-section", (_chartType, seriesType)=>this.createPanels(seriesType)));
        this.chartPanelFeature.refreshPanels();
    }
    createPanels(seriesType) {
        let panelExpandedOnInit = false;
        this.getFormatPanelDef().groups?.forEach(({ type: group, isOpen: isExpandedOnInit = false })=>{
            if (!this.isGroupPanelShownInSeries(group, seriesType)) return;
            if (isExpandedOnInit) {
                if (panelExpandedOnInit) (0, $437b23f6a393c3bf$export$545083624300f13d)(145, {
                    group: group
                });
                panelExpandedOnInit = true;
            }
            const registerGroupComponent = (groupComponent)=>this.groupExpansionFeature.addGroupComponent(groupComponent);
            const opts = {
                ...this.chartMenuContext,
                isExpandedOnInit: isExpandedOnInit,
                seriesType: seriesType,
                registerGroupComponent: registerGroupComponent
            };
            switch(group){
                case "chart":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$ChartPanel(opts));
                    break;
                case "titles":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$TitlesPanel(opts));
                    break;
                case "legend":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$LegendPanel(opts, this.chartMenuContext));
                    break;
                case "axis":
                    if ($5b7ccabde48fae90$var$isPolar(seriesType)) this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$PolarAxisPanel(opts));
                    else if ($5b7ccabde48fae90$var$isCartesian(seriesType)) {
                        this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("xAxis", opts));
                        this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("yAxis", opts));
                    }
                    break;
                case "horizontalAxis":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("xAxis", opts));
                    break;
                case "verticalAxis":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("yAxis", opts));
                    break;
                case "series":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$SeriesPanel(opts));
                    break;
                default:
                    (0, $437b23f6a393c3bf$export$545083624300f13d)(147, {
                        group: group
                    });
            }
        });
    }
    getFormatPanelDef() {
        const userProvidedFormatPanelDef = this.gos.get("chartToolPanelsDef")?.formatPanel;
        return userProvidedFormatPanelDef ? userProvidedFormatPanelDef : $5b7ccabde48fae90$var$DefaultFormatPanelDef;
    }
    isGroupPanelShownInSeries(group, seriesType) {
        const enable = [
            "chart",
            "titles",
            "legend",
            "series"
        ].includes(group) || $5b7ccabde48fae90$var$isCartesian(seriesType) && $5b7ccabde48fae90$var$AXIS_KEYS.includes(group) || $5b7ccabde48fae90$var$isPolar(seriesType) && group === "axis";
        const disable = $5b7ccabde48fae90$var$isFunnel(seriesType) && group === "legend" || $5b7ccabde48fae90$var$isFunnel(seriesType) && $5b7ccabde48fae90$var$AXIS_KEYS.includes(group);
        return enable && !disable;
    }
};
var $5b7ccabde48fae90$var$CANVAS_CLASS = "ag-chart-mini-thumbnail-canvas";
var $5b7ccabde48fae90$var$MiniChart = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(container, agChartsExports, tooltipName){
        super();
        this.agChartsExports = agChartsExports;
        this.tooltipName = tooltipName;
        this.size = 58;
        this.padding = 5;
        const { _Scene: _Scene } = agChartsExports;
        this.root = new _Scene.Group();
        const scene = new _Scene.Scene({
            width: this.size,
            height: this.size
        });
        scene.canvas.element.classList.add($5b7ccabde48fae90$var$CANVAS_CLASS);
        scene.setRoot(this.root);
        scene.setContainer(container);
        this.scene = scene;
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        this.scene.canvas.element.title = this.chartTranslation.translate(this.tooltipName);
        try {
            this.scene.render();
        } catch (e) {
            (0, $437b23f6a393c3bf$export$a20c7248650823a9)(108, {
                e: e
            });
        }
    }
};
function $5b7ccabde48fae90$var$createColumnRects(params) {
    const { stacked: stacked, size: size, padding: padding, xScalePadding: xScalePadding, xScaleDomain: xScaleDomain, yScaleDomain: yScaleDomain, agChartsExports: { _Scene: _Scene } } = params;
    const xScale = new _Scene.CategoryScale();
    xScale.domain = xScaleDomain;
    xScale.range = [
        padding,
        size - padding
    ];
    xScale.paddingInner = xScalePadding;
    xScale.paddingOuter = xScalePadding;
    const yScale = new _Scene.LinearScale();
    yScale.domain = yScaleDomain;
    yScale.range = [
        size - padding,
        padding
    ];
    const createBars = (series, xScale2, yScale2)=>{
        return series.map((datum, i)=>{
            const top = yScale2.convert(datum);
            const rect = new _Scene.Rect();
            rect.x = xScale2.convert(i);
            rect.y = top;
            rect.width = xScale2.bandwidth;
            rect.height = yScale2.convert(0) - top;
            rect.strokeWidth = 0;
            rect.crisp = true;
            return rect;
        });
    };
    if (stacked) return params.data.map((d)=>createBars(d, xScale, yScale));
    return createBars(params.data, xScale, yScale);
}
function $5b7ccabde48fae90$var$prepareXYScales(_Scene, data, size, padding) {
    const xDomain = [];
    const yDomain = [];
    for (const item of data)for (const [x, y] of item){
        xDomain.push(x);
        yDomain.push(y);
    }
    const xScale = new _Scene.LinearScale();
    xScale.domain = [
        Math.min(...xDomain),
        Math.max(...xDomain)
    ];
    xScale.range = [
        padding,
        size - padding
    ];
    const yScale = new _Scene.LinearScale();
    yScale.domain = [
        Math.min(...yDomain),
        Math.max(...yDomain)
    ];
    yScale.range = [
        size - padding,
        padding
    ];
    return {
        xScale: xScale,
        yScale: yScale
    };
}
function $5b7ccabde48fae90$var$prepareLinearScene(_Scene, data, size, padding) {
    const xDomain = [
        0,
        data[0].length - 1
    ];
    const yDomain = data.reduce((acc, curr)=>{
        for (const datum of curr){
            if (datum < acc[0]) acc[0] = datum;
            if (datum > acc[1]) acc[1] = datum;
        }
        return acc;
    }, [
        Infinity,
        -Infinity
    ]);
    yDomain[0]--;
    yDomain[yDomain.length - 1]++;
    const xScale = new _Scene.LinearScale();
    xScale.domain = xDomain;
    xScale.range = [
        padding,
        size - padding
    ];
    const yScale = new _Scene.LinearScale();
    yScale.domain = yDomain;
    yScale.range = [
        size - padding,
        padding
    ];
    return {
        xScale: xScale,
        yScale: yScale
    };
}
function $5b7ccabde48fae90$var$createXPathCommands(data, xScale, yScale) {
    return data.map((series)=>series.map((datum, i)=>[
                i > 0 ? "lineTo" : "moveTo",
                xScale.convert(i),
                yScale.convert(datum)
            ]));
}
function $5b7ccabde48fae90$var$createXYPathCommands(shape, xScale, yScale) {
    return shape.map(([x, y], i)=>[
            i > 0 ? "lineTo" : "moveTo",
            xScale.convert(x),
            yScale.convert(y)
        ]);
}
function $5b7ccabde48fae90$var$closePath(commandSegments) {
    const closingCommand = commandSegments[0];
    const first = commandSegments[1];
    const last = (0, $437b23f6a393c3bf$export$236389741107357f)(commandSegments);
    if (first[1] !== last[1] || first[2] !== last[2]) commandSegments.push([
        closingCommand[0],
        first[1],
        first[2]
    ]);
    return commandSegments;
}
function $5b7ccabde48fae90$var$createPath(_Scene, commands) {
    const path = new _Scene.Path();
    commands.forEach(([command, x, y])=>path.path[command](x, y));
    return path;
}
function $5b7ccabde48fae90$var$createAreaPathCommands(commands, yScale, stacked) {
    return commands.map((pathCommands, index, all)=>{
        const closingPath = stacked ? $5b7ccabde48fae90$var$closePathViaPreviousSeries(all, index, yScale) : $5b7ccabde48fae90$var$closePathViaOrigin(pathCommands, yScale);
        const closingPathCommands = [
            ...closingPath
        ].reverse().map(([_, x, y])=>[
                "lineTo",
                x,
                y
            ]);
        const first = pathCommands[0];
        const last = (0, $437b23f6a393c3bf$export$236389741107357f)(closingPathCommands);
        if (first[1] !== last[1] || first[2] !== last[2]) closingPathCommands.push([
            "lineTo",
            first[1],
            first[2]
        ]);
        return [
            ...pathCommands,
            ...closingPathCommands
        ];
    });
}
function $5b7ccabde48fae90$var$closePathViaPreviousSeries(all, index, yScale) {
    if (index === 0) return $5b7ccabde48fae90$var$closePathViaOrigin(all[index], yScale);
    return [
        ...all[index - 1]
    ];
}
function $5b7ccabde48fae90$var$closePathViaOrigin(pathCommands, yScale) {
    return pathCommands.map(([c, x])=>[
            c,
            x,
            yScale.convert(0)
        ]);
}
function $5b7ccabde48fae90$var$commandsToPath(_Scene, commands) {
    const path = $5b7ccabde48fae90$var$createPath(_Scene, commands);
    path.fill = void 0;
    path.lineCap = "round";
    path.strokeWidth = 3;
    return path;
}
function $5b7ccabde48fae90$var$createShapePaths({ _Scene: _Scene }, root, shapes, size, padding) {
    const { xScale: xScale, yScale: yScale } = $5b7ccabde48fae90$var$prepareXYScales(_Scene, shapes, size, padding);
    const openPathsCommands = shapes.map((shape)=>$5b7ccabde48fae90$var$createXYPathCommands(shape, xScale, yScale));
    const shapesCommands = openPathsCommands.map((path)=>$5b7ccabde48fae90$var$closePath(path));
    const shapePaths = shapesCommands.map((shapeCommands)=>$5b7ccabde48fae90$var$commandsToPath(_Scene, shapeCommands));
    const paths = shapePaths.reduce((acc, curr)=>acc.concat(curr), []);
    const pathsGroup = new _Scene.Group();
    pathsGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
    pathsGroup.append(paths);
    root.append(pathsGroup);
    return paths;
}
function $5b7ccabde48fae90$var$createLinePaths({ _Scene: _Scene }, root, data, size, padding) {
    const { xScale: xScale, yScale: yScale } = $5b7ccabde48fae90$var$prepareLinearScene(_Scene, data, size, padding);
    const pathCommands = $5b7ccabde48fae90$var$createXPathCommands(data, xScale, yScale);
    const paths = pathCommands.map((commands)=>$5b7ccabde48fae90$var$commandsToPath(_Scene, commands));
    const pathsGroup = new _Scene.Group();
    pathsGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
    pathsGroup.append(paths);
    root.append(pathsGroup);
    return paths;
}
function $5b7ccabde48fae90$var$createAreaPaths(_Scene, root, data, size, padding, stacked = false) {
    const { xScale: xScale, yScale: yScale } = $5b7ccabde48fae90$var$prepareLinearScene(_Scene, data, size, padding);
    const pathCommands = $5b7ccabde48fae90$var$createAreaPathCommands($5b7ccabde48fae90$var$createXPathCommands(data, xScale, yScale), yScale, stacked);
    const areasGroup = new _Scene.Group();
    areasGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
    const paths = pathCommands.map((commands)=>$5b7ccabde48fae90$var$createPath(_Scene, commands));
    areasGroup.append(paths);
    root.append(areasGroup);
    return paths;
}
function $5b7ccabde48fae90$var$stackData(data) {
    return data.map((stack, sindex, array)=>stack.map((_y, i)=>array.slice(0, sindex + 1).reduce((p, c)=>p + c[i], 0)));
}
function $5b7ccabde48fae90$var$normalizeStackData(data) {
    const colSum = data.map((_, index)=>data.reduce((acc, cur)=>Math.max(acc, cur[index]), 0));
    return data.map((stack)=>stack.map((y, index)=>y / colSum[index] * 19));
}
function $5b7ccabde48fae90$var$createPolarPaths(agChartsExports, root, data, size, radius, innerRadius, markerSize = 0) {
    const { _Scene: _Scene } = agChartsExports;
    const angleScale = new _Scene.LinearScale();
    angleScale.domain = [
        0,
        7
    ];
    angleScale.range = [
        -Math.PI,
        Math.PI
    ].map((angle)=>angle + Math.PI / 2);
    const radiusScale = new _Scene.LinearScale();
    radiusScale.domain = [
        0,
        10
    ];
    radiusScale.range = [
        radius,
        innerRadius
    ];
    const markers2 = [];
    const center = size / 2;
    const paths = data.map((series)=>{
        const path = new _Scene.Path();
        path.strokeWidth = 1;
        path.strokeOpacity = 0.5;
        path.lineCap = "round";
        path.fill = void 0;
        path.fillOpacity = 0.8;
        series.forEach((datum, i)=>{
            const angle = angleScale.convert(i);
            const r = radius + innerRadius - radiusScale.convert(datum);
            const x = r * Math.cos(angle) + center;
            const y = r * Math.sin(angle) + center;
            path.path[i > 0 ? "lineTo" : "moveTo"](x, y);
            if (markerSize > 0) {
                const marker = new _Scene.Marker({
                    shape: "circle"
                });
                marker.x = x;
                marker.y = y;
                marker.size = markerSize;
                markers2.push(marker);
            }
        });
        path.path.closePath();
        return path;
    });
    const group = new _Scene.Group();
    group.append([
        ...paths,
        ...markers2
    ]);
    root.append(group);
    return {
        paths: paths,
        markers: markers2
    };
}
function $5b7ccabde48fae90$var$accumulateData(data) {
    let [min, max] = [
        Infinity,
        -Infinity
    ];
    const processedData = data.reduce((acc, curr, currIndex)=>{
        const previous = currIndex > 0 ? acc[currIndex - 1] : void 0;
        acc[currIndex] ?? (acc[currIndex] = []);
        const current = acc[currIndex];
        curr.forEach((datum, datumIndex)=>{
            if (previous) datum += previous[datumIndex];
            current[datumIndex] = datum;
            if (current[datumIndex] < min) min = current[datumIndex];
            if (current[datumIndex] > max) max = current[datumIndex];
        });
        return acc;
    }, []);
    return {
        processedData: processedData,
        min: min,
        max: max
    };
}
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/funnel/miniFunnel.ts
var $5b7ccabde48fae90$var$FUNNEL_SHAPES = [
    [
        [
            13,
            16
        ],
        [
            13,
            12
        ],
        [
            3,
            12
        ],
        [
            3,
            16
        ]
    ],
    [
        [
            12,
            11
        ],
        [
            12,
            7
        ],
        [
            4,
            7
        ],
        [
            4,
            11
        ]
    ],
    [
        [
            10.125,
            6
        ],
        [
            10.125,
            1.5
        ],
        [
            5.875,
            1.5
        ],
        [
            5.875,
            6
        ]
    ]
];
var $5b7ccabde48fae90$var$MiniFunnelClass = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, tooltipName = "funnelTooltip", data = $5b7ccabde48fae90$var$FUNNEL_SHAPES){
        super(container, agChartsExports, tooltipName);
        this.shapes = $5b7ccabde48fae90$var$createShapePaths(agChartsExports, this.root, data, this.size, this.padding);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        for (const bar of this.shapes){
            bar.fill = fills[0];
            bar.stroke = strokes[0];
            bar.strokeWidth = 0;
        }
    }
};
var $5b7ccabde48fae90$var$MiniFunnel = {
    chartType: "funnel",
    miniChart: $5b7ccabde48fae90$var$MiniFunnelClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/funnel/miniConeFunnel.ts
var $5b7ccabde48fae90$var$CONE_FUNNEL_SHAPES = [
    [
        [
            13,
            16
        ],
        [
            10.75,
            11.5
        ],
        [
            5.25,
            11.5
        ],
        [
            3,
            16
        ]
    ],
    [
        [
            10.75,
            11.5
        ],
        [
            8.875,
            6
        ],
        [
            7.125,
            6
        ],
        [
            5.25,
            11.5
        ]
    ],
    [
        [
            8.875,
            6
        ],
        [
            8.875,
            1.5
        ],
        [
            7.125,
            1.5
        ],
        [
            7.125,
            6
        ]
    ]
];
var $5b7ccabde48fae90$var$MiniConeFunnelClass = class extends $5b7ccabde48fae90$var$MiniFunnelClass {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, tooltipName = "coneFunnelTooltip"){
        super(container, agChartsExports, fills, strokes, _isCustomTheme, tooltipName, $5b7ccabde48fae90$var$CONE_FUNNEL_SHAPES);
    }
    updateColors(fills, strokes) {
        this.shapes.forEach((bar, i)=>{
            bar.fill = fills[0];
            bar.fillOpacity = 1 - i * 0.2;
            bar.stroke = strokes[0];
            bar.strokeWidth = 0;
        });
    }
};
var $5b7ccabde48fae90$var$MiniConeFunnel = {
    chartType: "coneFunnel",
    miniChart: $5b7ccabde48fae90$var$MiniConeFunnelClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/funnel/miniPyramid.ts
var $5b7ccabde48fae90$var$PYRAMID_SHAPES = [
    [
        [
            8,
            16
        ],
        [
            10,
            12
        ],
        [
            6,
            12
        ]
    ],
    [
        [
            10.5,
            11
        ],
        [
            12.5,
            7
        ],
        [
            3.5,
            7
        ],
        [
            5.5,
            11
        ]
    ],
    [
        [
            13,
            6
        ],
        [
            15.5,
            1.5
        ],
        [
            0.5,
            1.5
        ],
        [
            3,
            6
        ]
    ]
];
var $5b7ccabde48fae90$var$MiniPyramidClass = class extends $5b7ccabde48fae90$var$MiniFunnelClass {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, tooltipName = "pyramidTooltip"){
        super(container, agChartsExports, fills, strokes, _isCustomTheme, tooltipName, $5b7ccabde48fae90$var$PYRAMID_SHAPES);
    }
    updateColors(fills, strokes) {
        this.shapes.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
            bar.strokeWidth = 0;
        });
    }
};
var $5b7ccabde48fae90$var$MiniPyramid = {
    chartType: "pyramid",
    miniChart: $5b7ccabde48fae90$var$MiniPyramidClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/miniChartWithAxes.ts
var $5b7ccabde48fae90$var$MiniChartWithAxes = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, tooltipName){
        super(container, agChartsExports, tooltipName);
        this.stroke = "gray";
        this.axisOvershoot = 3;
    }
    postConstruct() {
        const { _Scene: _Scene } = this.agChartsExports;
        const size = this.size;
        const padding = this.padding;
        const leftAxis = new _Scene.Line();
        leftAxis.x1 = padding;
        leftAxis.y1 = padding;
        leftAxis.x2 = padding;
        leftAxis.y2 = size - padding + this.axisOvershoot;
        leftAxis.stroke = this.stroke;
        const bottomAxis = new _Scene.Line();
        bottomAxis.x1 = padding - this.axisOvershoot + 1;
        bottomAxis.y1 = size - padding;
        bottomAxis.x2 = size - padding + 1;
        bottomAxis.y2 = size - padding;
        bottomAxis.stroke = this.stroke;
        const root = this.root;
        root.append(leftAxis);
        root.append(bottomAxis);
        super.postConstruct();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/column/miniColumn.ts
var $5b7ccabde48fae90$var$MiniColumnClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "groupedColumnTooltip");
        this.columnData = [
            2,
            3,
            4
        ];
        const { root: root, columnData: columnData, size: size, padding: padding } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1,
                2
            ],
            yScaleDomain: [
                0,
                4
            ],
            xScalePadding: 0.3,
            agChartsExports: agChartsExports
        });
        root.append(this.columns);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.columns.forEach((column, i)=>{
            column.fill = fills[i];
            column.stroke = strokes[i];
        });
    }
};
var $5b7ccabde48fae90$var$MiniColumn = {
    chartType: "groupedColumn",
    miniChart: $5b7ccabde48fae90$var$MiniColumnClass
};
var $5b7ccabde48fae90$var$miniStackedColumnData = [
    [
        8,
        12,
        16
    ],
    [
        6,
        9,
        12
    ],
    [
        2,
        3,
        4
    ]
];
var $5b7ccabde48fae90$var$MiniStackedColumnClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniStackedColumnData, yScaleDomain = [
        0,
        16
    ], tooltipName = "stackedColumnTooltip"){
        super(container, agChartsExports, tooltipName);
        const { root: root, size: size, padding: padding } = this;
        this.stackedColumns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: true,
            root: root,
            data: data,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1,
                2
            ],
            yScaleDomain: yScaleDomain,
            xScalePadding: 0.3,
            agChartsExports: agChartsExports
        });
        root.append((0, $437b23f6a393c3bf$export$5e3f39c5068e375d)(this.stackedColumns));
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.stackedColumns.forEach((series, i)=>{
            for (const column of series){
                column.fill = fills[i];
                column.stroke = strokes[i];
            }
        });
    }
};
var $5b7ccabde48fae90$var$MiniStackedColumn = {
    chartType: "stackedColumn",
    miniChart: $5b7ccabde48fae90$var$MiniStackedColumnClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/column/miniNormalizedColumn.ts
var $5b7ccabde48fae90$var$miniNormalizedColumnData = [
    [
        10,
        10,
        10
    ],
    [
        6,
        7,
        8
    ],
    [
        2,
        4,
        6
    ]
];
var $5b7ccabde48fae90$var$MiniNormalizedColumnClass = class extends $5b7ccabde48fae90$var$MiniStackedColumnClass {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, fills, strokes, isCustomTheme, $5b7ccabde48fae90$var$miniNormalizedColumnData, [
            0,
            10
        ], "normalizedColumnTooltip");
    }
};
var $5b7ccabde48fae90$var$MiniNormalizedColumn = {
    chartType: "normalizedColumn",
    miniChart: $5b7ccabde48fae90$var$MiniNormalizedColumnClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/bar/miniBar.ts
var $5b7ccabde48fae90$var$MiniBarClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "groupedBarTooltip");
        const { _Scene: _Scene } = agChartsExports;
        const padding = this.padding;
        const size = this.size;
        const data = [
            2,
            3,
            4
        ];
        const yScale = new _Scene.CategoryScale();
        yScale.domain = [
            0,
            1,
            2
        ];
        yScale.range = [
            padding,
            size - padding
        ];
        yScale.paddingInner = 0.3;
        yScale.paddingOuter = 0.3;
        const xScale = new _Scene.LinearScale();
        xScale.domain = [
            0,
            4
        ];
        xScale.range = [
            size - padding,
            padding
        ];
        const bottom = xScale.convert(0);
        const height = yScale.bandwidth;
        this.bars = data.map((datum, i)=>{
            const rect = new _Scene.Rect();
            rect.x = padding;
            rect.y = yScale.convert(i);
            rect.width = bottom - xScale.convert(datum);
            rect.height = height;
            rect.strokeWidth = 0;
            rect.crisp = true;
            return rect;
        });
        this.updateColors(fills, strokes);
        this.root.append(this.bars);
    }
    updateColors(fills, strokes) {
        this.bars.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
    }
};
var $5b7ccabde48fae90$var$MiniBar = {
    chartType: "groupedBar",
    miniChart: $5b7ccabde48fae90$var$MiniBarClass
};
var $5b7ccabde48fae90$var$miniStackedBarData = [
    [
        8,
        12,
        16
    ],
    [
        6,
        9,
        12
    ],
    [
        2,
        3,
        4
    ]
];
var $5b7ccabde48fae90$var$MiniStackedBarClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniStackedBarData, xScaleDomain = [
        0,
        16
    ], tooltipName = "stackedBarTooltip"){
        super(container, agChartsExports, tooltipName);
        const { _Scene: _Scene } = agChartsExports;
        const size = this.size;
        const padding = this.padding;
        const yScale = new _Scene.CategoryScale();
        yScale.domain = [
            0,
            1,
            2
        ];
        yScale.range = [
            padding,
            size - padding
        ];
        yScale.paddingInner = 0.3;
        yScale.paddingOuter = 0.3;
        const xScale = new _Scene.LinearScale();
        xScale.domain = xScaleDomain;
        xScale.range = [
            size - padding,
            padding
        ];
        const bottom = xScale.convert(0);
        const height = yScale.bandwidth;
        this.bars = data.map((series)=>series.map((datum, i)=>{
                const rect = new _Scene.Rect();
                rect.x = padding;
                rect.y = yScale.convert(i);
                rect.width = bottom - xScale.convert(datum);
                rect.height = height;
                rect.strokeWidth = 0;
                rect.crisp = true;
                return rect;
            }));
        this.updateColors(fills, strokes);
        this.root.append((0, $437b23f6a393c3bf$export$5e3f39c5068e375d)(this.bars));
    }
    updateColors(fills, strokes) {
        this.bars.forEach((series, i)=>series.forEach((bar)=>{
                bar.fill = fills[i];
                bar.stroke = strokes[i];
            }));
    }
};
var $5b7ccabde48fae90$var$MiniStackedBar = {
    chartType: "stackedBar",
    miniChart: $5b7ccabde48fae90$var$MiniStackedBarClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/bar/miniNormalizedBar.ts
var $5b7ccabde48fae90$var$miniNormalizedBarData = [
    [
        10,
        10,
        10
    ],
    [
        6,
        7,
        8
    ],
    [
        2,
        4,
        6
    ]
];
var $5b7ccabde48fae90$var$MiniNormalizedBarClass = class extends $5b7ccabde48fae90$var$MiniStackedBarClass {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, fills, strokes, isCustomTheme, $5b7ccabde48fae90$var$miniNormalizedBarData, [
            0,
            10
        ], "normalizedBarTooltip");
    }
};
var $5b7ccabde48fae90$var$MiniNormalizedBar = {
    chartType: "normalizedBar",
    miniChart: $5b7ccabde48fae90$var$MiniNormalizedBarClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/pie/miniDonut.ts
var $5b7ccabde48fae90$var$MiniDonutClass = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, centerRadiusScaler = 0.6, tooltipName = "donutTooltip"){
        super(container, agChartsExports, tooltipName);
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const radius = (size - padding * 2) / 2;
        const center = radius + padding;
        const toRadians = _Scene.toRadians;
        const angles = [
            [
                toRadians(-90),
                toRadians(30)
            ],
            [
                toRadians(30),
                toRadians(120)
            ],
            [
                toRadians(120),
                toRadians(180)
            ],
            [
                toRadians(180),
                toRadians(210)
            ],
            [
                toRadians(210),
                toRadians(240)
            ],
            [
                toRadians(240),
                toRadians(270)
            ]
        ];
        this.sectors = angles.map(([startAngle, endAngle])=>{
            const sector = new _Scene.Sector();
            sector.centerX = center;
            sector.centerY = center;
            sector.innerRadius = radius * centerRadiusScaler;
            sector.outerRadius = radius;
            sector.startAngle = startAngle;
            sector.endAngle = endAngle;
            sector.stroke = void 0;
            sector.strokeWidth = 0;
            sector.inset = 0.75;
            return sector;
        });
        this.updateColors(fills, strokes);
        this.root.append(this.sectors);
    }
    updateColors(fills, strokes) {
        this.sectors.forEach((sector, i)=>{
            sector.fill = fills[i % fills.length];
            sector.stroke = strokes[i % strokes.length];
        });
    }
};
var $5b7ccabde48fae90$var$MiniDonut = {
    chartType: "donut",
    miniChart: $5b7ccabde48fae90$var$MiniDonutClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/pie/miniPie.ts
var $5b7ccabde48fae90$var$MiniPieClass = class extends $5b7ccabde48fae90$var$MiniDonutClass {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, fills, strokes, isCustomTheme, 0, "pieTooltip");
    }
};
var $5b7ccabde48fae90$var$MiniPie = {
    chartType: "pie",
    miniChart: $5b7ccabde48fae90$var$MiniPieClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/line/miniLine.ts
var $5b7ccabde48fae90$var$miniLineData = [
    [
        1,
        3,
        5
    ],
    [
        2,
        6,
        4
    ],
    [
        5,
        3,
        1
    ]
];
var $5b7ccabde48fae90$var$MiniLineClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniLineData, tooltipName = "lineTooltip"){
        super(container, agChartsExports, tooltipName);
        const { size: size, padding: padding, root: root } = this;
        this.lines = $5b7ccabde48fae90$var$createLinePaths(agChartsExports, root, data, size, padding);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, _strokes) {
        this.lines.forEach((line, i)=>{
            line.stroke = fills[i];
        });
    }
};
var $5b7ccabde48fae90$var$MiniLine = {
    chartType: "line",
    miniChart: $5b7ccabde48fae90$var$MiniLineClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/line/miniStackedLine.ts
var $5b7ccabde48fae90$var$miniStackedLineData = $5b7ccabde48fae90$var$stackData($5b7ccabde48fae90$var$miniLineData);
var $5b7ccabde48fae90$var$MiniStackedLineClass = class extends $5b7ccabde48fae90$var$MiniLineClass {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniStackedLineData, tooltipName = "stackedLineTooltip"){
        super(container, agChartsExports, fills, strokes, _isCustomTheme, data, tooltipName);
    }
};
var $5b7ccabde48fae90$var$MiniStackedLine = {
    chartType: "stackedLine",
    miniChart: $5b7ccabde48fae90$var$MiniStackedLineClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/line/miniNormalizedLine.ts
var $5b7ccabde48fae90$var$miniNormalizedLineData = $5b7ccabde48fae90$var$normalizeStackData($5b7ccabde48fae90$var$miniStackedLineData);
var $5b7ccabde48fae90$var$MiniNormalizedLineClass = class extends $5b7ccabde48fae90$var$MiniLineClass {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme, data = $5b7ccabde48fae90$var$miniNormalizedLineData, tooltipName = "normalizedLineTooltip"){
        super(container, agChartsExports, fills, strokes, isCustomTheme, data, tooltipName);
    }
};
var $5b7ccabde48fae90$var$MiniNormalizedLine = {
    chartType: "normalizedLine",
    miniChart: $5b7ccabde48fae90$var$MiniNormalizedLineClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/scatter/miniScatter.ts
var $5b7ccabde48fae90$var$MiniScatterClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "scatterTooltip");
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const data = [
            [
                [
                    0.3,
                    3
                ],
                [
                    1.1,
                    0.9
                ],
                [
                    2,
                    0.4
                ],
                [
                    3.4,
                    2.4
                ]
            ],
            [
                [
                    0,
                    0.3
                ],
                [
                    1,
                    2
                ],
                [
                    2.4,
                    1.4
                ],
                [
                    3,
                    0
                ]
            ]
        ];
        const xScale = new _Scene.LinearScale();
        xScale.domain = [
            -0.5,
            4
        ];
        xScale.range = [
            padding * 2,
            size - padding
        ];
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            -0.5,
            3.5
        ];
        yScale.range = [
            size - padding,
            padding
        ];
        const points = [];
        data.forEach((series)=>{
            series.forEach(([x, y])=>{
                const arc = new _Scene.Arc();
                arc.strokeWidth = 0;
                arc.centerX = xScale.convert(x);
                arc.centerY = yScale.convert(y);
                arc.radius = 2.5;
                points.push(arc);
            });
        });
        this.points = points;
        this.updateColors(fills, strokes);
        const pointsGroup = new _Scene.Group();
        pointsGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
        pointsGroup.append(this.points);
        this.root.append(pointsGroup);
    }
    updateColors(fills, strokes) {
        this.points.forEach((line, i)=>{
            line.stroke = strokes[i % strokes.length];
            line.fill = fills[i % fills.length];
        });
    }
};
var $5b7ccabde48fae90$var$MiniScatter = {
    chartType: "scatter",
    miniChart: $5b7ccabde48fae90$var$MiniScatterClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/scatter/miniBubble.ts
var $5b7ccabde48fae90$var$MiniBubbleClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "bubbleTooltip");
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const data = [
            [
                [
                    0.1,
                    0.3,
                    5
                ],
                [
                    0.5,
                    0.4,
                    7
                ],
                [
                    0.2,
                    0.8,
                    7
                ]
            ],
            [
                [
                    0.8,
                    0.7,
                    5
                ],
                [
                    0.7,
                    0.3,
                    9
                ]
            ]
        ];
        const xScale = new _Scene.LinearScale();
        xScale.domain = [
            0,
            1
        ];
        xScale.range = [
            padding * 2,
            size - padding
        ];
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            0,
            1
        ];
        yScale.range = [
            size - padding,
            padding
        ];
        const points = [];
        data.forEach((series)=>{
            series.forEach(([x, y, radius])=>{
                const arc = new _Scene.Arc();
                arc.strokeWidth = 0;
                arc.centerX = xScale.convert(x);
                arc.centerY = yScale.convert(y);
                arc.radius = radius;
                arc.fillOpacity = 0.7;
                points.push(arc);
            });
        });
        this.points = points;
        this.updateColors(fills, strokes);
        const pointsGroup = new _Scene.Group();
        pointsGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
        pointsGroup.append(this.points);
        this.root.append(pointsGroup);
    }
    updateColors(fills, strokes) {
        this.points.forEach((line, i)=>{
            line.stroke = strokes[i % strokes.length];
            line.fill = fills[i % fills.length];
        });
    }
};
var $5b7ccabde48fae90$var$MiniBubble = {
    chartType: "bubble",
    miniChart: $5b7ccabde48fae90$var$MiniBubbleClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/area/miniArea.ts
var $5b7ccabde48fae90$var$miniAreaData = $5b7ccabde48fae90$var$miniLineData;
var $5b7ccabde48fae90$var$MiniAreaClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniAreaData, tooltipName = "groupedAreaTooltip", stacked = false){
        super(container, agChartsExports, tooltipName);
        this.areas = $5b7ccabde48fae90$var$createAreaPaths(agChartsExports._Scene, this.root, data, this.size, this.padding, stacked);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
            area.strokeWidth = 1;
            area.strokeOpacity = 0.75;
            area.fillOpacity = 0.7;
        });
    }
};
var $5b7ccabde48fae90$var$MiniArea = {
    chartType: "area",
    miniChart: $5b7ccabde48fae90$var$MiniAreaClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/area/miniStackedArea.ts
var $5b7ccabde48fae90$var$miniStackedAreaData = $5b7ccabde48fae90$var$stackData($5b7ccabde48fae90$var$miniAreaData);
var $5b7ccabde48fae90$var$MiniStackedAreaClass = class extends $5b7ccabde48fae90$var$MiniAreaClass {
    constructor(container, agChartsExports, fills, strokes, _isCustomTheme, data = $5b7ccabde48fae90$var$miniStackedAreaData, tooltipName = "stackedAreaTooltip"){
        super(container, agChartsExports, fills, strokes, _isCustomTheme, data, tooltipName, true);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
    }
};
var $5b7ccabde48fae90$var$MiniStackedArea = {
    chartType: "stackedArea",
    miniChart: $5b7ccabde48fae90$var$MiniStackedAreaClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/area/miniNormalizedArea.ts
var $5b7ccabde48fae90$var$miniNormalizedAreaData = $5b7ccabde48fae90$var$normalizeStackData($5b7ccabde48fae90$var$miniStackedAreaData);
var $5b7ccabde48fae90$var$MiniNormalizedAreaClass = class extends $5b7ccabde48fae90$var$MiniStackedAreaClass {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme, data = $5b7ccabde48fae90$var$miniNormalizedAreaData, tooltipName = "normalizedAreaTooltip"){
        super(container, agChartsExports, fills, strokes, isCustomTheme, data, tooltipName);
    }
};
var $5b7ccabde48fae90$var$MiniNormalizedArea = {
    chartType: "normalizedArea",
    miniChart: $5b7ccabde48fae90$var$MiniNormalizedAreaClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/histogram/miniHistogram.ts
var $5b7ccabde48fae90$var$MiniHistogramClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "histogramTooltip");
        const { padding: padding, size: size, agChartsExports: { _Scene: _Scene } } = this;
        const data = [
            2,
            5,
            11,
            13,
            10,
            6,
            1
        ];
        const xScale = new _Scene.LinearScale();
        xScale.domain = [
            0,
            data.length
        ];
        xScale.range = [
            padding,
            size - padding
        ];
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            0,
            data.reduce((a, b)=>Math.max(a, b), 0)
        ];
        yScale.range = [
            size - padding,
            padding
        ];
        const bottom = yScale.convert(0);
        this.bars = data.map((datum, i)=>{
            const top = yScale.convert(datum);
            const left = xScale.convert(i);
            const right = xScale.convert(i + 1);
            const rect = new _Scene.Rect();
            rect.x = left;
            rect.y = top;
            rect.width = right - left;
            rect.height = bottom - top;
            rect.strokeWidth = 1;
            rect.strokeOpacity = 0.75;
            rect.crisp = true;
            return rect;
        });
        this.updateColors(fills, strokes);
        this.root.append(this.bars);
    }
    updateColors([fill], [stroke]) {
        for (const bar of this.bars){
            bar.fill = fill;
            bar.stroke = stroke;
        }
    }
};
var $5b7ccabde48fae90$var$MiniHistogram = {
    chartType: "histogram",
    miniChart: $5b7ccabde48fae90$var$MiniHistogramClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/miniChartWithPolarAxes.ts
var $5b7ccabde48fae90$var$MiniChartWithPolarAxes = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, tooltipName){
        super(container, agChartsExports, tooltipName);
        this.stroke = "gray";
        this.showRadiusAxisLine = true;
        this.showAngleAxisLines = true;
    }
    postConstruct() {
        const { _Scene: _Scene } = this.agChartsExports;
        const size = this.size;
        const padding = this.padding;
        const combinedPadding = padding * 2;
        const axisLineRadius = (size - combinedPadding) / 2;
        const gridRadii = this.showAngleAxisLines ? [
            axisLineRadius,
            axisLineRadius * 0.8,
            axisLineRadius * 0.6,
            axisLineRadius * 0.4
        ] : [];
        const radiusAxisLine = new _Scene.Line();
        radiusAxisLine.x1 = size / 2;
        radiusAxisLine.y1 = padding;
        radiusAxisLine.x2 = size / 2;
        radiusAxisLine.y2 = size - padding - axisLineRadius - gridRadii[gridRadii.length - 1];
        radiusAxisLine.stroke = this.stroke;
        radiusAxisLine.strokeOpacity = 0.5;
        radiusAxisLine.fill = void 0;
        radiusAxisLine.visible = this.showRadiusAxisLine;
        const x = padding + axisLineRadius;
        this.gridLines = gridRadii.map((radius, index)=>{
            const gridLine = new _Scene.Path();
            gridLine.path.arc(x, x, radius, 0, 2 * Math.PI);
            gridLine.strokeWidth = 1;
            gridLine.stroke = this.stroke;
            gridLine.strokeOpacity = index === 0 ? 0.5 : 0.2;
            gridLine.fill = void 0;
            return gridLine;
        });
        const root = this.root;
        root.append(radiusAxisLine);
        if (this.gridLines.length > 0) root.append(this.gridLines);
        super.postConstruct();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/polar/miniRadialColumn.ts
var $5b7ccabde48fae90$var$MiniRadialColumnClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "radialColumnTooltip");
        this.data = [
            [
                6,
                8,
                10,
                2,
                6,
                5
            ],
            [
                4,
                4,
                3,
                6,
                4,
                4
            ],
            [
                5,
                4,
                2,
                9,
                8,
                9
            ]
        ];
        this.showRadiusAxisLine = false;
        const { padding: padding, size: size, data: data, agChartsExports: { _Scene: _Scene } } = this;
        const radius = (size - padding * 2) / 2;
        const innerRadiusRatio = 0.4;
        const axisInnerRadius = radius * innerRadiusRatio;
        const angleScale = new _Scene.CategoryScale();
        angleScale.domain = data[0].map((_, index)=>index);
        angleScale.range = [
            0,
            2 * Math.PI
        ];
        angleScale.paddingInner = 0;
        angleScale.paddingOuter = 0;
        const bandwidth = angleScale.bandwidth * 0.7;
        const { processedData: processedData, max: max } = $5b7ccabde48fae90$var$accumulateData(data);
        const radiusScale = new _Scene.LinearScale();
        radiusScale.domain = [
            0,
            max
        ];
        radiusScale.range = [
            axisInnerRadius,
            radius
        ];
        const center = this.size / 2;
        this.series = processedData.map((series, seriesIndex)=>{
            const firstSeries = seriesIndex === 0;
            const previousSeries = firstSeries ? void 0 : processedData[seriesIndex - 1];
            const seriesGroup = new _Scene.TranslatableGroup({
                zIndex: 1e6
            });
            const seriesColumns = series.map((datum, i)=>{
                const previousDatum = previousSeries?.[i];
                const outerRadius = radiusScale.convert(datum);
                const innerRadius = radiusScale.convert(previousDatum ?? 0);
                const startAngle = angleScale.convert(i);
                const endAngle = startAngle + bandwidth;
                const columnWidth = _Scene.getRadialColumnWidth(startAngle, endAngle, radius, 0.5, 0.5);
                const column = new _Scene.RadialColumnShape();
                column.columnWidth = columnWidth;
                column.innerRadius = innerRadius;
                column.outerRadius = outerRadius;
                column.startAngle = startAngle;
                column.endAngle = endAngle;
                column.isBeveled = true;
                column.axisInnerRadius = axisInnerRadius;
                column.axisOuterRadius = radius;
                column.stroke = void 0;
                column.strokeWidth = 0;
                return column;
            });
            seriesGroup.append(seriesColumns);
            seriesGroup.translationX = center;
            seriesGroup.translationY = center;
            return seriesGroup;
        });
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            for (const sector of group.children()){
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            }
        });
    }
};
var $5b7ccabde48fae90$var$MiniRadialColumn = {
    chartType: "radialColumn",
    miniChart: $5b7ccabde48fae90$var$MiniRadialColumnClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/polar/miniRadialBar.ts
var $5b7ccabde48fae90$var$MiniRadialBarClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "radialBarTooltip");
        this.data = [
            [
                6,
                8,
                10
            ],
            [
                4,
                4,
                3
            ],
            [
                5,
                4,
                2
            ]
        ];
        this.showRadiusAxisLine = false;
        const { size: size, padding: padding, data: data, agChartsExports: { _Scene: _Scene } } = this;
        const radius = (size - padding) / 2;
        const innerRadiusRatio = 0.4;
        const innerRadius = radius * innerRadiusRatio;
        const radiusScale = new _Scene.CategoryScale();
        radiusScale.domain = data[0].map((_, index)=>index);
        radiusScale.range = [
            innerRadius,
            radius
        ];
        radiusScale.paddingInner = 0.5;
        radiusScale.paddingOuter = 0;
        const bandwidth = radiusScale.bandwidth;
        const { processedData: processedData, max: max } = $5b7ccabde48fae90$var$accumulateData(data);
        const angleScale = new _Scene.LinearScale();
        angleScale.domain = [
            0,
            Math.ceil(max * 1.5)
        ];
        const start = 1.5 * Math.PI;
        const end = start + 2 * Math.PI;
        angleScale.range = [
            start,
            end
        ];
        const center = size / 2;
        this.series = processedData.map((series, index)=>{
            const previousSeries = index < 0 ? void 0 : processedData[index - 1];
            const seriesGroup = new _Scene.Group({
                zIndex: 1e6
            });
            const seriesSectors = series.map((datum, i)=>{
                const previousDatum = previousSeries?.[i] ?? 0;
                const outerRadius = radiusScale.convert(i);
                const innerRadius2 = outerRadius - bandwidth;
                const startAngle = angleScale.convert(previousDatum);
                const endAngle = angleScale.convert(datum);
                const sector = new _Scene.Sector();
                sector.centerX = center;
                sector.centerY = center;
                sector.innerRadius = innerRadius2;
                sector.outerRadius = outerRadius;
                sector.startAngle = startAngle;
                sector.endAngle = endAngle;
                sector.stroke = void 0;
                sector.strokeWidth = 0;
                return sector;
            });
            seriesGroup.append(seriesSectors);
            return seriesGroup;
        });
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            for (const sector of group.children()){
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            }
        });
    }
};
var $5b7ccabde48fae90$var$MiniRadialBar = {
    chartType: "radialBar",
    miniChart: $5b7ccabde48fae90$var$MiniRadialBarClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/polar/miniRadarLine.ts
var $5b7ccabde48fae90$var$MiniRadarLineClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "radarLineTooltip");
        this.markerSize = 4;
        this.data = [
            [
                8,
                7,
                8,
                7,
                8,
                8,
                7,
                8
            ],
            [
                6,
                8,
                5,
                10,
                6,
                7,
                4,
                6
            ],
            [
                0,
                3,
                3,
                5,
                4,
                4,
                2,
                0
            ]
        ];
        this.showRadiusAxisLine = false;
        const { size: size, padding: padding, root: root, data: data } = this;
        const radius = (size - padding * 2) / 2;
        const innerRadius = 0;
        const { paths: paths, markers: markers2 } = $5b7ccabde48fae90$var$createPolarPaths(agChartsExports, root, data, size, radius, innerRadius, this.markerSize);
        this.lines = paths;
        this.markers = markers2;
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.lines.forEach((line, i)=>{
            const n = this.data[i].length;
            line.stroke = fills[i];
            const startIdx = i * n;
            const endIdx = startIdx + n;
            const markers2 = this.markers.slice(startIdx, endIdx);
            for (const marker of markers2){
                marker.stroke = strokes[i];
                marker.fill = fills[i];
            }
        });
    }
};
var $5b7ccabde48fae90$var$MiniRadarLine = {
    chartType: "radarLine",
    miniChart: $5b7ccabde48fae90$var$MiniRadarLineClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/polar/miniRadarArea.ts
var $5b7ccabde48fae90$var$MiniRadarAreaClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "radarAreaTooltip");
        this.data = [
            [
                8,
                10,
                5,
                7,
                4,
                1,
                5,
                8
            ],
            [
                1,
                1,
                2,
                7,
                7,
                8,
                10,
                1
            ],
            [
                4,
                5,
                9,
                9,
                4,
                2,
                3,
                4
            ]
        ];
        const { size: size, padding: padding, root: root, data: data } = this;
        this.showRadiusAxisLine = false;
        const radius = (size - padding * 2) / 2;
        const innerRadius = radius - size * 0.3;
        this.areas = $5b7ccabde48fae90$var$createPolarPaths(agChartsExports, root, data, size, radius, innerRadius).paths;
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
    }
};
var $5b7ccabde48fae90$var$MiniRadarArea = {
    chartType: "radarArea",
    miniChart: $5b7ccabde48fae90$var$MiniRadarAreaClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/polar/miniNightingale.ts
var $5b7ccabde48fae90$var$MiniNightingaleClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "nightingaleTooltip");
        this.data = [
            [
                6,
                10,
                9,
                8,
                7,
                8
            ],
            [
                4,
                6,
                5,
                4,
                5,
                5
            ],
            [
                3,
                5,
                4,
                3,
                4,
                7
            ]
        ];
        this.showRadiusAxisLine = false;
        const { size: size, padding: padding, data: data, agChartsExports: { _Scene: _Scene } } = this;
        const radius = (size - padding * 2) / 2;
        const angleScale = new _Scene.CategoryScale();
        angleScale.domain = data[0].map((_, index)=>index);
        angleScale.range = [
            -Math.PI,
            Math.PI
        ];
        angleScale.paddingInner = 0;
        angleScale.paddingOuter = 0;
        const bandwidth = angleScale.bandwidth * 0.7;
        const { processedData: processedData, max: max } = $5b7ccabde48fae90$var$accumulateData(data);
        const radiusScale = new _Scene.LinearScale();
        radiusScale.domain = [
            0,
            max
        ];
        radiusScale.range = [
            0,
            radius
        ];
        const center = size / 2;
        this.series = processedData.map((series, index)=>{
            const previousSeries = index < 0 ? void 0 : processedData[index - 1];
            const seriesGroup = new _Scene.Group({
                zIndex: 1e6
            });
            const seriesSectors = series.map((datum, i)=>{
                const previousDatum = previousSeries?.[i];
                const outerRadius = radiusScale.convert(datum);
                const innerRadius = radiusScale.convert(previousDatum ?? 0);
                const startAngle = angleScale.convert(i);
                const endAngle = startAngle + bandwidth;
                const sector = new _Scene.Sector();
                sector.centerX = center;
                sector.centerY = center;
                sector.innerRadius = innerRadius;
                sector.outerRadius = outerRadius;
                sector.startAngle = startAngle;
                sector.endAngle = endAngle;
                sector.stroke = void 0;
                sector.strokeWidth = 0;
                return sector;
            });
            seriesGroup.append(seriesSectors);
            return seriesGroup;
        });
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            for (const sector of group.children()){
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            }
        });
    }
};
var $5b7ccabde48fae90$var$MiniNightingale = {
    chartType: "nightingale",
    miniChart: $5b7ccabde48fae90$var$MiniNightingaleClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/statistical/miniRangeBar.ts
var $5b7ccabde48fae90$var$MiniRangeBarClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "rangeBarTooltip");
        const data = [
            3,
            3.5,
            3
        ];
        this.bars = this.createRangeBar(this.root, data, this.size, this.padding, "vertical");
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.bars.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
    }
    createRangeBar(root, data, size, padding, direction) {
        const barAlongX = direction === "horizontal";
        const scalePadding = 2 * padding;
        const { _Scene: _Scene } = this.agChartsExports;
        const xScale = new _Scene.CategoryScale();
        xScale.domain = data.map((_, index)=>index);
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.3;
        xScale.paddingOuter = 0.3;
        const lowRatio = 0.7;
        const highRatio = 1.3;
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            data.reduce((a, b)=>Math.min(a, b), Infinity) * lowRatio,
            data.reduce((a, b)=>Math.max(a, b), 0) * highRatio
        ];
        yScale.range = [
            scalePadding,
            size - scalePadding
        ];
        const width = xScale.bandwidth;
        const bars = data.map((datum, i)=>{
            const [low, high] = [
                datum * lowRatio,
                datum * highRatio
            ];
            const x = xScale.convert(i);
            const y = yScale.convert(low);
            const height = yScale.convert(high) - y;
            const rect = new _Scene.Rect();
            rect.x = barAlongX ? y : x;
            rect.y = barAlongX ? x : y;
            rect.width = barAlongX ? height : width;
            rect.height = barAlongX ? width : height;
            rect.strokeWidth = 0;
            rect.crisp = true;
            return rect;
        });
        root.append(bars);
        return bars;
    }
};
var $5b7ccabde48fae90$var$MiniRangeBar = {
    chartType: "rangeBar",
    miniChart: $5b7ccabde48fae90$var$MiniRangeBarClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/statistical/miniRangeArea.ts
var $5b7ccabde48fae90$var$MiniRangeAreaClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "rangeAreaTooltip");
        const period = 4;
        const dataSeriesMidpoints = [
            $5b7ccabde48fae90$var$zigzag({
                offset: 0.375 * period,
                length: period,
                pattern: {
                    low: 3,
                    high: 5,
                    period: period
                }
            }),
            $5b7ccabde48fae90$var$zigzag({
                offset: 0.375 * period,
                length: period,
                pattern: {
                    low: 2.25,
                    high: 4.25,
                    period: period
                }
            }),
            $5b7ccabde48fae90$var$zigzag({
                offset: 0.75 * period,
                length: period,
                pattern: {
                    low: 2.5,
                    high: 4.5,
                    period: period
                }
            })
        ];
        const dataSeriesWidth = 1.75;
        const data = dataSeriesMidpoints.map((series)=>series.map(([x, y])=>({
                    x: x,
                    low: y - 0.5 * dataSeriesWidth,
                    high: y + 0.5 * dataSeriesWidth
                })));
        const { lines: lines, areas: areas } = this.createRangeArea(this.root, data, this.size, this.padding);
        this.lines = lines;
        this.areas = areas;
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        fills = $5b7ccabde48fae90$var$swapArrayItems(fills, 1, 2);
        strokes = $5b7ccabde48fae90$var$swapArrayItems(strokes, 1, 2);
        this.lines.forEach(([highLine, lowLine], i)=>{
            highLine.fill = void 0;
            highLine.stroke = strokes[i];
            lowLine.fill = void 0;
            lowLine.stroke = strokes[i];
        });
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
        });
    }
    createRangeArea(root, data, size, padding) {
        const xMin = data.reduce((acc, series)=>series.reduce((acc2, { x: x })=>Math.min(acc2, x), acc), Infinity);
        const xMax = data.reduce((acc, series)=>series.reduce((acc2, { x: x })=>Math.max(acc2, x), acc), -Infinity);
        const yMin = data.reduce((acc, series)=>series.reduce((acc2, { low: low })=>Math.min(acc2, low), acc), Infinity);
        const yMax = data.reduce((acc, series)=>series.reduce((acc2, { high: high })=>Math.max(acc2, high), acc), -Infinity);
        const { _Scene: _Scene } = this.agChartsExports;
        const xScale = new _Scene.LinearScale();
        xScale.domain = [
            xMin,
            xMax
        ];
        xScale.range = [
            padding,
            size - padding
        ];
        const scalePadding = 2 * padding;
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            yMin,
            yMax
        ];
        yScale.range = [
            size - scalePadding,
            scalePadding
        ];
        const lines = [];
        const areas = [];
        const lowPoints = data.map((series)=>{
            const highLine = new _Scene.Path();
            const lowLine = new _Scene.Path();
            const area = new _Scene.Path();
            lines.push([
                highLine,
                lowLine
            ]);
            areas.push(area);
            highLine.strokeWidth = 0;
            lowLine.strokeWidth = 0;
            area.strokeWidth = 0;
            area.fillOpacity = 0.8;
            highLine.path.clear();
            lowLine.path.clear();
            area.path.clear();
            return series.map((datum, datumIndex)=>{
                const { x: x, low: low, high: high } = datum;
                const scaledX = xScale.convert(x);
                const yLow = yScale.convert(low);
                const yHigh = yScale.convert(high);
                const command = datumIndex > 0 ? "lineTo" : "moveTo";
                highLine.path[command](scaledX, yHigh);
                lowLine.path[command](scaledX, yLow);
                area.path[command](scaledX, yHigh);
                return [
                    scaledX,
                    yLow
                ];
            });
        });
        lowPoints.forEach((seriesLowPoints, seriesIndex)=>{
            const n = seriesLowPoints.length - 1;
            const area = areas[seriesIndex];
            for(let datumIndex = n; datumIndex >= 0; datumIndex--){
                const [x, y] = seriesLowPoints[datumIndex];
                area.path["lineTo"](x, y);
            }
        });
        root.append(areas.concat(...lines));
        return {
            lines: lines,
            areas: areas
        };
    }
};
function $5b7ccabde48fae90$var$zigzag(options) {
    const { offset: offset, length: length, pattern: pattern } = options;
    const points = getZigzagInflectionPoints(offset, length, pattern);
    const xMin = 0;
    const xMax = length;
    if (points.length === 0 || points[0][0] !== xMin) points.unshift(getZigzagPoint(xMin, offset, pattern));
    if (points[points.length - 1][0] !== xMax) points.push(getZigzagPoint(xMax, offset, pattern));
    return points;
    function getZigzagInflectionPoints(offset2, length2, pattern2) {
        const { period: period } = pattern2;
        const scaledOffset = offset2 / period;
        const patternInflectionPoints = [
            0,
            0.5
        ];
        const inflectionPoints = patternInflectionPoints.map((x)=>x - scaledOffset).map($5b7ccabde48fae90$var$getRemainderAbs).sort((a, b)=>a - b);
        const repeatedPoints = Array.from({
            length: Math.floor(inflectionPoints.length * (period / length2))
        }, (_, i)=>inflectionPoints[i % inflectionPoints.length] + Math.floor(i / inflectionPoints.length));
        return repeatedPoints.map((x)=>x * period).map((x)=>getZigzagPoint(x, offset2, pattern2));
    }
    function getZigzagPoint(x, offset2, pattern2) {
        return [
            x,
            getZigzagValue(offset2 + x, pattern2)
        ];
    }
    function getZigzagValue(x, pattern2) {
        const { low: low, high: high, period: period } = pattern2;
        const scaledX = $5b7ccabde48fae90$var$getRemainderAbs(x / period);
        const y = scaledX > 0.5 ? 1 - 2 * (scaledX - 0.5) : 2 * scaledX;
        return low + (high - low) * y;
    }
}
function $5b7ccabde48fae90$var$getRemainderAbs(value) {
    const remainder = value % 1;
    return remainder < 0 ? remainder + 1 : remainder;
}
function $5b7ccabde48fae90$var$swapArrayItems(items, leftIndex, rightIndex) {
    const results = [
        ...items
    ];
    const temp = results[leftIndex];
    results[leftIndex] = results[rightIndex];
    results[rightIndex] = temp;
    return results;
}
var $5b7ccabde48fae90$var$MiniRangeArea = {
    chartType: "rangeArea",
    miniChart: $5b7ccabde48fae90$var$MiniRangeAreaClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/statistical/miniBoxPlot.ts
var $5b7ccabde48fae90$var$MiniBoxPlotClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, "boxPlotTooltip");
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const data = [
            11,
            11.5,
            10.5
        ];
        const maxRatio = 1.2;
        const q3Ratio = 1.1;
        const q1Ratio = 0.9;
        const minRatio = 0.8;
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            data.reduce((a, b)=>Math.min(a, b), Infinity) * minRatio,
            data.reduce((a, b)=>Math.max(a, b), 0) * maxRatio
        ];
        yScale.range = [
            size - 1.5 * padding,
            padding
        ];
        const xScale = new _Scene.CategoryScale();
        xScale.domain = data.map((_, index)=>index);
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.4;
        xScale.paddingOuter = 0.2;
        const bandwidth = Math.round(xScale.bandwidth);
        const halfBandWidth = Math.round(xScale.bandwidth / 2);
        this.boxPlotGroups = data.map((datum, i)=>{
            const [minValue, q1Value, q3Value, maxValue] = [
                datum * minRatio,
                datum * q1Ratio,
                datum * q3Ratio,
                datum * maxRatio
            ];
            const top = Math.round(yScale.convert(q3Value));
            const left = Math.round(xScale.convert(i));
            const right = Math.round(left + bandwidth);
            const bottom = Math.round(yScale.convert(q1Value));
            const min = Math.round(yScale.convert(minValue));
            const mid = Math.round(yScale.convert(datum));
            const max = Math.round(yScale.convert(maxValue));
            const whiskerX = left + halfBandWidth;
            const boxPlotGroup = new _Scene.Group();
            const box = new _Scene.Rect();
            const median = new _Scene.Line();
            const topWhisker = new _Scene.Line();
            const bottomWhisker = new _Scene.Line();
            const topCap = new _Scene.Line();
            const bottomCap = new _Scene.Line();
            box.x = left;
            box.y = top;
            box.width = bandwidth;
            box.height = bottom - top;
            box.strokeWidth = 1;
            box.strokeOpacity = 0.75;
            box.crisp = true;
            this.setLineProperties(median, left, right, mid, mid);
            this.setLineProperties(topWhisker, whiskerX, whiskerX, max, top);
            this.setLineProperties(bottomWhisker, whiskerX, whiskerX, min, bottom);
            this.setLineProperties(topCap, left, right, max, max);
            this.setLineProperties(bottomCap, left, right, min, min);
            boxPlotGroup.append([
                box,
                median,
                topWhisker,
                bottomWhisker,
                topCap,
                bottomCap
            ]);
            return boxPlotGroup;
        });
        this.updateColors(fills, strokes, isCustomTheme);
        this.root.append(this.boxPlotGroups);
    }
    updateColors(fills, strokes, isCustomTheme) {
        const { _Theme: _Theme } = this.agChartsExports;
        this.boxPlotGroups.forEach((group, i)=>{
            for (const node of group.children()){
                const fill = fills[i % fills.length];
                node.fill = isCustomTheme ? fill : _Theme.resolveOperation({
                    $mix: [
                        fill,
                        {
                            $ref: "backgroundColor"
                        },
                        0.7
                    ]
                });
                node.stroke = strokes[i % strokes.length];
            }
        });
    }
    setLineProperties(line, x1, x2, y1, y2) {
        line.x1 = x1;
        line.x2 = x2;
        line.y1 = y1;
        line.y2 = y2;
        line.strokeOpacity = 0.75;
    }
};
var $5b7ccabde48fae90$var$MiniBoxPlot = {
    chartType: "boxPlot",
    miniChart: $5b7ccabde48fae90$var$MiniBoxPlotClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/hierarchical/miniTreemap.ts
var $5b7ccabde48fae90$var$MiniTreemapClass = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, "treemapTooltip");
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const data = [
            [
                1,
                1
            ],
            [
                3,
                2,
                1
            ]
        ];
        const treeSize = data.length;
        const treePadding = treeSize % 2 === 0 ? 0.3 : 0.2;
        const range = [
            padding,
            size - padding
        ];
        const columns = data.length;
        const columnParts = columns * (columns + 1) / 2;
        const columnPadding = treePadding / (columns - 1);
        const availableRange = range[1] - range[0];
        const availableWidth = availableRange - treePadding;
        let previousX = range[0];
        this.rects = data.reduce((rects, d, columnIndex)=>{
            rects ?? (rects = []);
            const widthRatio = (columns - columnIndex) / columnParts;
            const width = availableWidth * widthRatio;
            const rows = d.length;
            const rowParts = d.reduce((parts, ratio)=>parts + ratio, 0);
            const rowPadding = treePadding / (rows - 1 || 1);
            const availableHeight = rows > 1 ? availableRange - treePadding : availableRange;
            let previousY = range[0];
            const xRects = d.map((ratio)=>{
                const rect = new _Scene.Rect();
                const height = availableHeight * ratio / rowParts;
                rect.x = previousX;
                rect.y = previousY;
                rect.width = width;
                rect.height = height;
                rect.strokeWidth = 0.75;
                rect.crisp = true;
                previousY += height + rowPadding;
                return rect;
            });
            previousX += width + columnPadding;
            rects.push(...xRects);
            return rects;
        }, []);
        this.updateColors(fills, strokes, isCustomTheme);
        const rectGroup = new _Scene.Group();
        rectGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding, size - padding));
        rectGroup.append(this.rects);
        this.root.append(rectGroup);
    }
    updateColors(fills, strokes, isCustomTheme) {
        const { _Theme: _Theme } = this.agChartsExports;
        this.rects.forEach((rect, i)=>{
            rect.fill = fills[i % strokes.length];
            rect.stroke = isCustomTheme ? strokes[i % strokes.length] : _Theme.resolveOperation({
                $ref: "backgroundColor"
            });
        });
    }
};
var $5b7ccabde48fae90$var$MiniTreemap = {
    chartType: "treemap",
    miniChart: $5b7ccabde48fae90$var$MiniTreemapClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/hierarchical/miniSunburst.ts
var $5b7ccabde48fae90$var$MiniSunburstClass = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "sunburstTooltip");
        // Hierarchical data using multidimensional array
        this.data = [
            [
                [],
                []
            ],
            [
                [],
                []
            ],
            [
                [],
                []
            ]
        ];
        // Rotate the chart by the given angle (-90 degrees)
        this.angleOffset = -Math.PI / 2;
        this.innerRadiusRatio = 0;
        this.showRadiusAxisLine = false;
        this.showAngleAxisLines = false;
        const { data: data, size: size, padding: padding, angleOffset: angleOffset, innerRadiusRatio: innerRadiusRatio, agChartsExports: { _Scene: _Scene } } = this;
        const radius = (size - padding * 2) / 2;
        const angleRange = [
            angleOffset + 0,
            angleOffset + 2 * Math.PI
        ];
        const angleExtent = Math.abs(angleRange[1] - angleRange[0]);
        const radiusRange = [
            radius * innerRadiusRatio,
            radius
        ];
        const radiusExtent = Math.abs(radiusRange[1] - radiusRange[0]);
        let maxDepth = 0;
        const findMaxDepth = (data2, parentDepth)=>{
            for (const child of data2){
                const depth = parentDepth + 1;
                maxDepth = Math.max(maxDepth, depth);
                findMaxDepth(child, depth);
            }
        };
        findMaxDepth(data, 0);
        const radiusRatio = radiusExtent / maxDepth;
        const center = this.size / 2;
        const startAngle = angleRange[0];
        this.series = [];
        const createSectors = (data2, depth, startAngle2, availableAngle, group)=>{
            const isArray = Array.isArray(data2);
            if (!isArray) return;
            const childDepth = depth + 1;
            let previousAngle = startAngle2;
            data2.forEach((child, childIndex, children)=>{
                let childGroup = group;
                if (!childGroup) {
                    childGroup = new _Scene.Group();
                    this.series.push(childGroup);
                }
                const innerRadius = radiusRange[0] + depth * radiusRatio;
                const outerRadius = radiusRange[0] + childDepth * radiusRatio;
                const angleRatio = 1 / children.length;
                const start = previousAngle;
                const end = start + availableAngle * angleRatio;
                const sector = new _Scene.Sector();
                sector.centerX = center;
                sector.centerY = center;
                sector.innerRadius = innerRadius;
                sector.outerRadius = outerRadius;
                sector.startAngle = start;
                sector.endAngle = end;
                sector.stroke = void 0;
                sector.strokeWidth = 0;
                sector.inset = 0.75;
                previousAngle = end;
                childGroup.append(sector);
                createSectors(child, childDepth, start, Math.abs(end - start), childGroup);
            });
        };
        createSectors(data, 0, startAngle, angleExtent);
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            for (const sector of group.children()){
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            }
        });
    }
};
var $5b7ccabde48fae90$var$MiniSunburst = {
    chartType: "sunburst",
    miniChart: $5b7ccabde48fae90$var$MiniSunburstClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/specialized/miniHeatmap.ts
var $5b7ccabde48fae90$var$MiniHeatmapClass = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, "heatmapTooltip");
        const { size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        const heatmapSize = 3;
        const data = Array.from({
            length: heatmapSize
        }, (_, __)=>Array.from({
                length: heatmapSize
            }, (_2, yIndex)=>yIndex));
        const domain = data.map((_, index)=>index);
        const xScale = new _Scene.CategoryScale();
        xScale.domain = domain;
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.01;
        xScale.paddingOuter = 0.1;
        const yScale = new _Scene.CategoryScale();
        yScale.domain = domain;
        yScale.range = [
            padding,
            size - padding
        ];
        yScale.paddingInner = 0.01;
        yScale.paddingOuter = 0.1;
        const width = xScale.bandwidth ?? 0;
        const height = yScale.bandwidth ?? 0;
        this.rects = data.reduce((rects, d, index)=>{
            rects ?? (rects = []);
            const xRects = d.map((_, yIndex)=>{
                const rect = new _Scene.Rect();
                rect.x = xScale.convert(index);
                rect.y = yScale.convert(yIndex);
                rect.width = width;
                rect.height = height;
                rect.strokeWidth = 0;
                rect.crisp = true;
                return rect;
            });
            rects.push(...xRects);
            return rects;
        }, []);
        this.updateColors(fills, strokes, isCustomTheme);
        const rectGroup = new _Scene.Group();
        rectGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding, size - padding));
        rectGroup.append(this.rects);
        this.root.append(rectGroup);
    }
    updateColors(fills, strokes, isCustomTheme) {
        const { _Theme: _Theme, _Util: _Util } = this.agChartsExports;
        const colorRange = isCustomTheme ? [
            fills[0],
            fills[1]
        ] : _Theme.resolveOperation({
            $palette: "divergingColors"
        });
        const stroke = isCustomTheme ? strokes[0] : _Theme.resolveOperation({
            $ref: "backgroundColor"
        });
        const fillFn = _Util.interpolateColor(colorRange[0], colorRange[1]);
        this.rects.forEach((rect, i)=>{
            rect.fill = fillFn(i * 0.2);
            rect.stroke = stroke;
        });
    }
};
var $5b7ccabde48fae90$var$MiniHeatmap = {
    chartType: "heatmap",
    miniChart: $5b7ccabde48fae90$var$MiniHeatmapClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/specialized/miniWaterfall.ts
var $5b7ccabde48fae90$var$MiniWaterfallClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes, isCustomTheme){
        super(container, agChartsExports, "waterfallTooltip");
        this.data = [
            4,
            3,
            -3,
            6,
            -3
        ];
        this.bars = this.createWaterfall(this.root, this.data, this.size, this.padding, "vertical").bars;
        this.updateColors(fills, strokes, isCustomTheme);
    }
    updateColors(fills, strokes, isCustomTheme) {
        const { data: data, agChartsExports: { _Theme: _Theme } } = this;
        const positive = {
            fill: isCustomTheme ? fills[0] : _Theme.resolveOperation({
                $palette: "altUp.fill"
            }),
            stroke: isCustomTheme ? strokes[0] : _Theme.resolveOperation({
                $palette: "altUp.stroke"
            })
        };
        const negative = {
            fill: isCustomTheme ? fills[1] : _Theme.resolveOperation({
                $palette: "altDown.fill"
            }),
            stroke: isCustomTheme ? strokes[1] : _Theme.resolveOperation({
                $palette: "altDown.stroke"
            })
        };
        this.bars.forEach((bar, i)=>{
            const isPositive = data[i] >= 0;
            bar.fill = isPositive ? positive.fill : negative.fill;
            bar.stroke = isPositive ? positive.stroke : negative.stroke;
        });
    }
    createWaterfall(root, data, size, padding, direction) {
        const scalePadding = 2 * padding;
        const { processedData: processedData, min: min, max: max } = $5b7ccabde48fae90$var$accumulateData(data.map((d)=>[
                d
            ]));
        const flatData = processedData.reduce((flat, d)=>flat.concat(d), []);
        const { _Scene: _Scene } = this.agChartsExports;
        const yScale = new _Scene.LinearScale();
        yScale.domain = [
            Math.min(min, 0),
            max
        ];
        yScale.range = [
            size - scalePadding,
            scalePadding
        ];
        const xScale = new _Scene.CategoryScale();
        xScale.domain = data.map((_, index)=>index);
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.2;
        xScale.paddingOuter = 0.3;
        const width = xScale.bandwidth;
        const connectorLine = new _Scene.Path();
        connectorLine.stroke = "#575757";
        connectorLine.strokeWidth = 0;
        const pixelAlignmentOffset = Math.floor(connectorLine.strokeWidth) % 2 / 2;
        const connectorPath = connectorLine.path;
        connectorPath.clear();
        const barAlongX = direction === "horizontal";
        const bars = flatData.map((datum, i)=>{
            const previousDatum = i > 0 ? flatData[i - 1] : 0;
            const rawValue = data[i];
            const isPositive = rawValue > 0;
            const currY = Math.round(yScale.convert(datum));
            const trailY = Math.round(yScale.convert(previousDatum));
            const y = (isPositive ? currY : trailY) - pixelAlignmentOffset;
            const bottomY = (isPositive ? trailY : currY) + pixelAlignmentOffset;
            const height = Math.abs(bottomY - y);
            const x = xScale.convert(i);
            const rect = new _Scene.Rect();
            rect.x = barAlongX ? y : x;
            rect.y = barAlongX ? x : y;
            rect.width = barAlongX ? height : width;
            rect.height = barAlongX ? width : height;
            rect.strokeWidth = 0;
            rect.crisp = true;
            const moveTo = currY + pixelAlignmentOffset;
            const lineTo = trailY + pixelAlignmentOffset;
            if (i > 0) {
                const lineToX = barAlongX ? lineTo : rect.x;
                const lineToY = barAlongX ? rect.y : lineTo;
                connectorPath.lineTo(lineToX, lineToY);
            }
            const moveToX = barAlongX ? moveTo : rect.x;
            const moveToY = barAlongX ? rect.y : moveTo;
            connectorPath.moveTo(moveToX, moveToY);
            return rect;
        });
        root.append([
            connectorLine,
            ...bars
        ]);
        return {
            bars: bars
        };
    }
};
var $5b7ccabde48fae90$var$MiniWaterfall = {
    chartType: "waterfall",
    miniChart: $5b7ccabde48fae90$var$MiniWaterfallClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/combo/miniColumnLineCombo.ts
var $5b7ccabde48fae90$var$MiniColumnLineComboClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "columnLineComboTooltip");
        this.columnData = [
            3,
            4
        ];
        this.lineData = [
            [
                5,
                4,
                6,
                5,
                4
            ]
        ];
        const { root: root, columnData: columnData, lineData: lineData, size: size, padding: padding } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1
            ],
            yScaleDomain: [
                0,
                4
            ],
            xScalePadding: 0.5,
            agChartsExports: agChartsExports
        });
        root.append(this.columns);
        this.lines = $5b7ccabde48fae90$var$createLinePaths(agChartsExports, root, lineData, size, padding);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.columns.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
        this.lines.forEach((line, i)=>{
            line.stroke = fills[i + 2];
        });
    }
};
var $5b7ccabde48fae90$var$MiniColumnLineCombo = {
    chartType: "columnLineCombo",
    miniChart: $5b7ccabde48fae90$var$MiniColumnLineComboClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/combo/miniAreaColumnCombo.ts
var $5b7ccabde48fae90$var$MiniAreaColumnComboClass = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "areaColumnComboTooltip");
        this.columnData = [
            3,
            4.5
        ];
        this.areaData = [
            [
                5,
                4,
                6,
                5,
                4
            ]
        ];
        const { root: root, columnData: columnData, areaData: areaData, size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1
            ],
            yScaleDomain: [
                0,
                6
            ],
            xScalePadding: 0.5,
            agChartsExports: agChartsExports
        });
        const xScale = new _Scene.CategoryScale();
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.domain = [
            0,
            1,
            2,
            3,
            4
        ];
        xScale.paddingInner = 1;
        xScale.paddingOuter = 0;
        const yScale = new _Scene.LinearScale();
        yScale.range = [
            size - padding,
            padding
        ];
        yScale.domain = [
            0,
            6
        ];
        const pathData = [];
        const yZero = yScale.convert(0);
        const firstX = xScale.convert(0);
        areaData.forEach((series, i)=>{
            const points = pathData[i] || (pathData[i] = []);
            series.forEach((data, j)=>{
                const yDatum = data;
                const xDatum = j;
                const x = xScale.convert(xDatum);
                const y = yScale.convert(yDatum);
                points[j] = {
                    x: x,
                    y: y
                };
            });
            const lastX = xScale.convert(series.length - 1);
            pathData[i].push({
                x: lastX,
                y: yZero
            }, {
                x: firstX,
                y: yZero
            });
        });
        this.areas = pathData.map((points)=>{
            const area = new _Scene.Path();
            area.strokeWidth = 0;
            area.fillOpacity = 0.8;
            const path = area.path;
            points.forEach((point, i)=>path[i > 0 ? "lineTo" : "moveTo"](point.x, point.y));
            return area;
        });
        const areaGroup = new _Scene.Group();
        areaGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
        const columnGroup = new _Scene.Group();
        columnGroup.setClipRect(new _Scene.BBox(padding, padding, size - padding * 2, size - padding * 2));
        areaGroup.append(this.areas);
        columnGroup.append(this.columns);
        root.append(areaGroup);
        root.append(columnGroup);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
        this.columns.forEach((bar, i)=>{
            bar.fill = fills[i + 1];
            bar.stroke = strokes[i + 1];
        });
    }
};
var $5b7ccabde48fae90$var$MiniAreaColumnCombo = {
    chartType: "areaColumnCombo",
    miniChart: $5b7ccabde48fae90$var$MiniAreaColumnComboClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniCharts/combo/miniCustomCombo.ts
var $5b7ccabde48fae90$var$MiniCustomComboClass = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, agChartsExports, fills, strokes){
        super(container, agChartsExports, "customComboTooltip");
        this.columnData = [
            3,
            4
        ];
        this.lineData = [
            [
                5,
                4,
                6,
                5,
                4
            ]
        ];
        const { root: root, columnData: columnData, lineData: lineData, size: size, padding: padding, agChartsExports: { _Scene: _Scene } } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1
            ],
            yScaleDomain: [
                0,
                4
            ],
            xScalePadding: 0.5,
            agChartsExports: agChartsExports
        });
        root.append(this.columns);
        this.lines = $5b7ccabde48fae90$var$createLinePaths(this.agChartsExports, root, lineData, size, padding);
        const axisStroke = "grey";
        const axisOvershoot = 3;
        const leftAxis = new _Scene.Line();
        leftAxis.x1 = padding;
        leftAxis.y1 = padding;
        leftAxis.x2 = padding;
        leftAxis.y2 = size - padding + axisOvershoot;
        leftAxis.stroke = axisStroke;
        const bottomAxis = new _Scene.Line();
        bottomAxis.x1 = padding - axisOvershoot + 1;
        bottomAxis.y1 = size - padding;
        bottomAxis.x2 = size - padding + 1;
        bottomAxis.y2 = size - padding;
        bottomAxis.stroke = axisStroke;
        const penIcon = new _Scene.Path();
        this.buildPenIconPath(penIcon);
        penIcon.fill = "whitesmoke";
        penIcon.stroke = "darkslategrey";
        penIcon.strokeWidth = 1;
        root.append([
            bottomAxis,
            leftAxis,
            penIcon
        ]);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.columns.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
        this.lines.forEach((line, i)=>{
            line.stroke = fills[i + 2];
        });
    }
    buildPenIconPath(penIcon) {
        const { path: path } = penIcon;
        path.moveTo(25.76, 43.46);
        path.lineTo(31.27, 48.53);
        path.moveTo(49.86, 22);
        path.lineTo(49.86, 22);
        path.cubicCurveTo(49.01994659053345, 21.317514933510974, 47.89593834348529, 21.09645997825817, 46.86, 21.41);
        path.lineTo(46.86, 21.41);
        path.cubicCurveTo(45.55460035985361, 21.77260167850787, 44.38777081121966, 22.517979360321792, 43.51, 23.55);
        path.lineTo(25.51, 43.8);
        path.lineTo(25.43, 43.89);
        path.lineTo(23.01, 51.89);
        path.lineTo(22.83, 52.46);
        path.lineTo(31.02, 48.86);
        path.lineTo(49.02, 28.52);
        path.lineTo(49.02, 28.52);
        path.cubicCurveTo(49.940716461596224, 27.521914221246085, 50.54302631059587, 26.2720342455763, 50.75, 24.93);
        path.lineTo(50.75, 24.93);
        path.cubicCurveTo(50.95363374988308, 23.866379846512814, 50.62080640232334, 22.77066734274871, 49.86, 22);
        path.closePath();
        path.moveTo(41.76, 25.5);
        path.lineTo(47.34, 30.5);
        path.moveTo(40.74, 26.65);
        path.lineTo(46.25, 31.71);
    }
};
var $5b7ccabde48fae90$var$MiniCustomCombo = {
    chartType: "customCombo",
    miniChart: $5b7ccabde48fae90$var$MiniCustomComboClass
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/miniChartsContainer.ts
var $5b7ccabde48fae90$var$miniChartMapping = {
    columnGroup: {
        column: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniColumn
        },
        stackedColumn: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniStackedColumn
        },
        normalizedColumn: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniNormalizedColumn
        }
    },
    barGroup: {
        bar: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniBar
        },
        stackedBar: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniStackedBar
        },
        normalizedBar: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniNormalizedBar
        }
    },
    pieGroup: {
        pie: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniPie
        },
        donut: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniDonut
        },
        doughnut: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniDonut
        }
    },
    lineGroup: {
        line: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniLine
        },
        stackedLine: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniStackedLine
        },
        normalizedLine: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniNormalizedLine
        }
    },
    scatterGroup: {
        scatter: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniScatter
        },
        bubble: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniBubble
        }
    },
    areaGroup: {
        area: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniArea
        },
        stackedArea: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniStackedArea
        },
        normalizedArea: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniNormalizedArea
        }
    },
    polarGroup: {
        radarLine: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadarLine
        },
        radarArea: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadarArea
        },
        nightingale: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniNightingale
        },
        radialColumn: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadialColumn
        },
        radialBar: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadialBar
        }
    },
    statisticalGroup: {
        boxPlot: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniBoxPlot
        },
        histogram: {
            range: true,
            pivot: false,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniHistogram
        },
        rangeBar: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRangeBar
        },
        rangeArea: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRangeArea
        }
    },
    hierarchicalGroup: {
        treemap: {
            range: true,
            pivot: true,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniTreemap
        },
        sunburst: {
            range: true,
            pivot: true,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniSunburst
        }
    },
    specializedGroup: {
        heatmap: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniHeatmap
        },
        waterfall: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniWaterfall
        }
    },
    combinationGroup: {
        columnLineCombo: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniColumnLineCombo
        },
        areaColumnCombo: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniAreaColumnCombo
        },
        customCombo: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniCustomCombo
        }
    },
    funnelGroup: {
        funnel: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniFunnel
        },
        coneFunnel: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniConeFunnel
        },
        pyramid: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniPyramid
        }
    }
};
var $5b7ccabde48fae90$var$DEFAULT_CHART_GROUPS = {
    columnGroup: [
        "column",
        "stackedColumn",
        "normalizedColumn"
    ],
    barGroup: [
        "bar",
        "stackedBar",
        "normalizedBar"
    ],
    pieGroup: [
        "pie",
        "donut"
    ],
    lineGroup: [
        "line",
        "stackedLine",
        "normalizedLine"
    ],
    areaGroup: [
        "area",
        "stackedArea",
        "normalizedArea"
    ],
    scatterGroup: [
        "scatter",
        "bubble"
    ],
    polarGroup: [
        "radarLine",
        "radarArea",
        "nightingale",
        "radialColumn",
        "radialBar"
    ],
    statisticalGroup: [
        "boxPlot",
        "histogram",
        "rangeBar",
        "rangeArea"
    ],
    hierarchicalGroup: [
        "treemap",
        "sunburst"
    ],
    specializedGroup: [
        "heatmap",
        "waterfall"
    ],
    funnelGroup: [
        "funnel",
        "coneFunnel",
        "pyramid"
    ],
    combinationGroup: [
        "columnLineCombo",
        "areaColumnCombo",
        "customCombo"
    ]
};
var $5b7ccabde48fae90$var$MiniChartsContainer = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartController, fills, strokes, isCustomTheme, chartGroups = $5b7ccabde48fae90$var$DEFAULT_CHART_GROUPS){
        super(/* html */ `<div class="ag-chart-settings-mini-wrapper"></div>`);
        this.wrappers = /* @__PURE__ */ new Map();
        this.chartController = chartController;
        this.fills = fills;
        this.strokes = strokes;
        this.isCustomTheme = isCustomTheme;
        this.chartGroups = {
            ...chartGroups
        };
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        if (!this.chartController.customComboExists() && this.chartGroups.combinationGroup) this.chartGroups.combinationGroup = this.chartGroups.combinationGroup.filter((chartType)=>chartType !== "customCombo");
        const eGui = this.getGui();
        const isEnterprise = this.chartController.isEnterprise();
        const isPivotChart = this.chartController.isPivotChart();
        const isRangeChart = !isPivotChart;
        const displayedMenuGroups = Object.keys(this.chartGroups).map((group)=>{
            const menuGroup = group in $5b7ccabde48fae90$var$miniChartMapping ? $5b7ccabde48fae90$var$miniChartMapping[group] : void 0;
            if (!menuGroup) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(148, {
                    group: group
                });
                return null;
            }
            const chartGroupValues = this.chartGroups[group] ?? [];
            const menuItems = chartGroupValues.map((chartType)=>{
                const menuItem = chartType in menuGroup ? menuGroup[chartType] : void 0;
                if (!menuItem) {
                    (0, $437b23f6a393c3bf$export$545083624300f13d)(149, {
                        group: group,
                        chartType: chartType
                    });
                    return null;
                }
                if (!isEnterprise && menuItem.enterprise) return null;
                if (isRangeChart && menuItem.range) return menuItem;
                if (isPivotChart && menuItem.pivot) return menuItem;
                return null;
            }).filter((menuItem)=>menuItem != null);
            if (menuItems.length === 0) return null;
            return {
                label: this.chartTranslation.translate(group),
                items: menuItems
            };
        }).filter((menuGroup)=>menuGroup != null);
        for (const { label: label, items: items } of displayedMenuGroups){
            const groupComponent = this.createBean(new $5b7ccabde48fae90$export$9c4ea4ce92935a7e({
                title: label,
                suppressEnabledCheckbox: true,
                enabled: true,
                suppressOpenCloseIcons: true,
                cssIdentifier: "charts-settings",
                direction: "horizontal",
                suppressKeyboardNavigation: true
            }));
            for (const menuItem of items){
                const { miniChart: MiniClass, chartType: chartType } = menuItem.icon;
                const miniWrapper = document.createElement("div");
                miniWrapper.classList.add("ag-chart-mini-thumbnail");
                miniWrapper.setAttribute("tabindex", "0");
                miniWrapper.setAttribute("role", "button");
                const miniClassChartType = chartType;
                const listener = ()=>{
                    this.chartController.setChartType(miniClassChartType);
                    this.updateSelectedMiniChart();
                };
                this.addManagedListeners(miniWrapper, {
                    click: listener,
                    keydown: (event)=>{
                        if (event.key == (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).ENTER || event.key === (0, $437b23f6a393c3bf$export$e9e0d96f49f57c33).SPACE) {
                            event.preventDefault();
                            listener();
                        }
                    }
                });
                this.wrappers.set(miniClassChartType, miniWrapper);
                this.createBean(new MiniClass(miniWrapper, this.beans.agChartsExports, this.fills, this.strokes, this.isCustomTheme));
                groupComponent.addItem(miniWrapper);
            }
            eGui.appendChild(groupComponent.getGui());
        }
        this.updateSelectedMiniChart();
    }
    updateSelectedMiniChart() {
        const selectedChartType = this.chartController.getChartType();
        this.wrappers.forEach((miniChart, miniChartType)=>{
            const selected = miniChartType === selectedChartType;
            miniChart.classList.toggle("ag-selected", selected);
            const chartName = this.chartTranslation.translate($5b7ccabde48fae90$var$getFullChartNameTranslationKey(miniChartType));
            const ariaLabel = selected ? `${chartName}. ${this.chartTranslation.translate("ariaChartSelected")}` : chartName;
            (0, $437b23f6a393c3bf$export$e81cb0dd07f289f6)(miniChart, ariaLabel);
        });
    }
    destroy() {
        this.wrappers.clear();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/settings/chartSettingsPanel.ts
var $5b7ccabde48fae90$var$ChartSettingsPanel = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(chartController){
        super(/* html */ `<div class="ag-chart-settings-wrapper">
            <div data-ref="eMiniChartsContainer" class="ag-chart-settings-mini-charts-container ag-scrollable-container"></div>
            <div data-ref="eNavBar" class="ag-chart-settings-nav-bar">
                <div data-ref="ePrevBtn" class="ag-chart-settings-prev">
                    <button type="button" class="ag-button ag-chart-settings-prev-button"></button>
                </div>
                <div data-ref="eCardSelector" class="ag-chart-settings-card-selector"></div>
                <div data-ref="eNextBtn" class="ag-chart-settings-next">
                    <button type="button" class="ag-button ag-chart-settings-next-button"></button>
                </div>
            </div>
        </div>`);
        this.chartController = chartController;
        this.eMiniChartsContainer = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eNavBar = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eCardSelector = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.ePrevBtn = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eNextBtn = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.miniChartsContainers = [];
        this.cardItems = [];
        this.activePaletteIndex = 0;
        this.palettes = [];
        this.themes = [];
    }
    postConstruct() {
        this.resetPalettes();
        const isRtl = this.gos.get("enableRtl");
        this.ePrevBtn.insertAdjacentElement("afterbegin", (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(isRtl ? "chartsThemeNext" : "chartsThemePrevious", this.beans));
        this.eNextBtn.insertAdjacentElement("afterbegin", (0, $437b23f6a393c3bf$export$d8feba07bf373edb)(isRtl ? "chartsThemePrevious" : "chartsThemeNext", this.beans));
        this.addManagedElementListeners(this.ePrevBtn, {
            click: ()=>this.setActivePalette(this.getPrev(), "left")
        });
        this.addManagedElementListeners(this.eNextBtn, {
            click: ()=>this.setActivePalette(this.getNext(), "right")
        });
        const reset = ()=>this.resetPalettes(true);
        this.addManagedListeners(this.chartController, {
            chartTypeChanged: reset,
            chartApiUpdate: reset
        });
        this.scrollSelectedIntoView();
    }
    scrollSelectedIntoView() {
        setTimeout(()=>{
            const isMiniChartsContainerVisible = (miniChartsContainers)=>{
                return !miniChartsContainers.getGui().classList.contains("ag-hidden");
            };
            const currentMiniChartContainer = this.miniChartsContainers.find(isMiniChartsContainerVisible);
            const currentChart = currentMiniChartContainer.getGui().querySelector(".ag-selected");
            if (currentChart) {
                const parent = currentChart.offsetParent;
                if (parent) this.eMiniChartsContainer.scrollTo(0, parent.offsetTop);
            }
        }, 250);
    }
    resetPalettes(forceReset) {
        const palettes = this.chartController.getPalettes();
        const chartGroups = this.gos.get("chartToolPanelsDef")?.settingsPanel?.chartGroupsDef;
        if ((0, $437b23f6a393c3bf$export$893967cdb9833fdd)(palettes, this.palettes) && !forceReset || this.isAnimating) return;
        this.palettes = palettes;
        this.themes = this.chartController.getThemeNames();
        this.activePaletteIndex = this.themes.findIndex((name)=>name === this.chartController.getChartThemeName());
        this.cardItems = [];
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.eCardSelector);
        this.destroyMiniCharts();
        const { themes: themes } = this;
        this.palettes.forEach((palette, index)=>{
            const isActivePalette = this.activePaletteIndex === index;
            const { fills: fills = [], strokes: strokes = [] } = palette;
            const themeName = themes[index];
            const isCustomTheme = !$5b7ccabde48fae90$var$isStockTheme(themeName, this.beans.agChartsExports._Theme);
            const miniChartsContainer = this.createBean(new $5b7ccabde48fae90$var$MiniChartsContainer(this.chartController, fills, strokes, isCustomTheme, chartGroups));
            this.miniChartsContainers.push(miniChartsContainer);
            this.eMiniChartsContainer.appendChild(miniChartsContainer.getGui());
            this.addCardLink(index);
            if (isActivePalette) miniChartsContainer.updateSelectedMiniChart();
            else miniChartsContainer.setDisplayed(false);
        });
        (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eNavBar, this.palettes.length > 1);
        (0, $437b23f6a393c3bf$export$605571c1b2992cfe)(this.cardItems[this.activePaletteIndex], "ag-selected", "ag-not-selected");
    }
    addCardLink(index) {
        const link = document.createElement("div");
        link.classList.add("ag-chart-settings-card-item");
        this.addManagedElementListeners(link, {
            click: ()=>{
                this.setActivePalette(index, index < this.activePaletteIndex ? "left" : "right");
            }
        });
        this.eCardSelector.appendChild(link);
        this.cardItems.push(link);
    }
    getPrev() {
        let prev = this.activePaletteIndex - 1;
        if (prev < 0) prev = this.palettes.length - 1;
        return prev;
    }
    getNext() {
        let next = this.activePaletteIndex + 1;
        if (next >= this.palettes.length) next = 0;
        return next;
    }
    setActivePalette(index, animationDirection) {
        if (this.isAnimating || this.activePaletteIndex === index) return;
        (0, $437b23f6a393c3bf$export$605571c1b2992cfe)(this.cardItems[index], "ag-selected", "ag-not-selected");
        const currentPalette = this.miniChartsContainers[this.activePaletteIndex];
        const currentGui = currentPalette.getGui();
        const futurePalette = this.miniChartsContainers[index];
        const nextGui = futurePalette.getGui();
        currentPalette.updateSelectedMiniChart();
        futurePalette.updateSelectedMiniChart();
        const multiplier = animationDirection === "left" ? -1 : 1;
        const final = nextGui.style.left = `${(0, $437b23f6a393c3bf$export$642efcb17474eb51)(this.getGui()) * multiplier}px`;
        this.activePaletteIndex = index;
        this.isAnimating = true;
        const animatingClass = "ag-animating";
        futurePalette.setDisplayed(true);
        currentPalette.addCss(animatingClass);
        futurePalette.addCss(animatingClass);
        this.chartController.setChartThemeName(this.themes[index]);
        window.setTimeout(()=>{
            currentGui.style.left = `${-parseFloat(final)}px`;
            nextGui.style.left = "0px";
        }, 0);
        window.setTimeout(()=>{
            this.isAnimating = false;
            currentPalette.removeCss(animatingClass);
            futurePalette.removeCss(animatingClass);
            currentPalette.setDisplayed(false);
        }, 300);
    }
    destroyMiniCharts() {
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(this.eMiniChartsContainer);
        this.miniChartsContainers = this.destroyBeans(this.miniChartsContainers);
    }
    destroy() {
        this.destroyMiniCharts();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/tabbedChartMenu.ts
var $5b7ccabde48fae90$var$TAB_DATA = "data";
var $5b7ccabde48fae90$var$TAB_FORMAT = "format";
var $5b7ccabde48fae90$var$TabbedChartMenu = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(panels, chartMenuContext){
        super();
        this.panels = panels;
        this.chartMenuContext = chartMenuContext;
        this.tabs = [];
    }
    wireBeans(beans) {
        this.chartTranslation = beans.chartTranslation;
    }
    postConstruct() {
        for (const panel of this.panels){
            const panelType = panel.replace("chart", "").toLowerCase();
            const panelComp = this.createPanel(panelType);
            const tabItem = this.createTab(panel, panelType, panelComp);
            this.tabs.push(tabItem);
            this.addDestroyFunc(()=>this.destroyBean(panelComp));
        }
        this.tabbedLayout = new $5b7ccabde48fae90$export$1f389880cb99530f({
            items: this.tabs,
            cssClass: "ag-chart-tabbed-menu",
            keepScrollPosition: true,
            suppressFocusBodyOnOpen: true,
            suppressTrapFocus: true,
            enableCloseButton: true,
            closeButtonAriaLabel: this.chartTranslation.translate("ariaChartMenuClose"),
            onCloseClicked: ()=>{
                this.eventSource?.focus({
                    preventScroll: true
                });
                this.dispatchLocalEvent({
                    type: "closed"
                });
            }
        });
        this.createBean(this.tabbedLayout);
    }
    createTab(name, title, panelComp) {
        const eWrapperDiv = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div",
            cls: `ag-chart-tab ag-chart-${title}`
        });
        this.createBean(panelComp);
        eWrapperDiv.appendChild(panelComp.getGui());
        const translatedTitle = this.chartTranslation.translate(title);
        const titleEl = (0, $437b23f6a393c3bf$export$a232bb0480ae674a)({
            tag: "div",
            children: translatedTitle
        });
        return {
            title: titleEl,
            titleLabel: translatedTitle,
            bodyPromise: (0, $437b23f6a393c3bf$export$30ec7836a4847721).resolve(eWrapperDiv),
            getScrollableContainer: ()=>{
                const scrollableContainer = eWrapperDiv.querySelector(".ag-scrollable-container");
                return scrollableContainer || eWrapperDiv;
            },
            name: name
        };
    }
    showTab(tab) {
        const tabItem = this.tabs[tab];
        this.tabbedLayout.showItem(tabItem);
    }
    getGui() {
        return this.tabbedLayout?.getGui();
    }
    showMenu(eventSource, suppressFocus) {
        this.eventSource = eventSource;
        if (!suppressFocus) this.tabbedLayout?.focusHeader(true);
    }
    destroy() {
        if (this.parentComponent?.isAlive()) this.destroyBean(this.parentComponent);
        super.destroy();
    }
    createPanel(panelType) {
        switch(panelType){
            case $5b7ccabde48fae90$var$TAB_DATA:
                return new $5b7ccabde48fae90$var$ChartDataPanel(this.chartMenuContext);
            case $5b7ccabde48fae90$var$TAB_FORMAT:
                return new $5b7ccabde48fae90$var$FormatPanel(this.chartMenuContext);
            default:
                return new $5b7ccabde48fae90$var$ChartSettingsPanel(this.chartMenuContext.chartController);
        }
    }
};
// packages/ag-grid-enterprise/src/charts/chartComp/menu/chartMenu.ts
var $5b7ccabde48fae90$var$ChartMenu = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(eChartContainer, eMenuPanelContainer, chartMenuContext){
        super(/* html */ `<div class="ag-chart-menu-wrapper"></div>`);
        this.eChartContainer = eChartContainer;
        this.eMenuPanelContainer = eMenuPanelContainer;
        this.chartMenuContext = chartMenuContext;
        this.buttons = {
            chartLink: {
                iconName: "linked",
                callback: ()=>this.chartMenuSvc.toggleLinked(this.chartMenuContext)
            },
            chartUnlink: {
                iconName: "unlinked",
                callback: ()=>this.chartMenuSvc.toggleLinked(this.chartMenuContext)
            },
            chartDownload: {
                iconName: "chartsDownload",
                callback: ()=>this.chartMenuSvc.downloadChart(this.chartMenuContext)
            },
            chartMenu: {
                iconName: "chartsMenu",
                callback: (eventSource)=>this.showMenuList(eventSource)
            }
        };
        this.panels = [];
        this.menuVisible = false;
        this.chartController = chartMenuContext.chartController;
    }
    wireBeans(beans) {
        this.chartMenuSvc = beans.chartMenuSvc;
        this.chartMenuListFactory = beans.chartMenuListFactory;
    }
    postConstruct() {
        this.chartToolbar = this.createManagedBean(new $5b7ccabde48fae90$var$ChartToolbar());
        this.getGui().appendChild(this.chartToolbar.getGui());
        this.refreshToolbarAndPanels();
        this.addManagedEventListeners({
            chartCreated: (e)=>{
                if (e.chartId === this.chartController.getChartId()) {
                    const showDefaultToolPanel = Boolean(this.gos.get("chartToolPanelsDef")?.defaultToolPanel);
                    if (showDefaultToolPanel) this.showMenu({
                        panel: this.defaultPanel,
                        suppressFocus: true
                    });
                }
            }
        });
        this.addManagedListeners(this.chartController, {
            chartLinkedChanged: this.refreshToolbarAndPanels.bind(this)
        });
        this.refreshMenuClasses();
        this.addManagedListeners(this.chartController, {
            chartApiUpdate: this.refreshToolbarAndPanels.bind(this)
        });
    }
    isVisible() {
        return this.menuVisible;
    }
    getExtraPaddingDirections() {
        return [
            "chartMenu",
            "chartLink",
            "chartUnlink",
            "chartDownload"
        ].some((v)=>this.chartToolbarOptions.includes(v)) ? [
            "top"
        ] : [];
    }
    refreshToolbarAndPanels() {
        this.initToolbarOptionsAndPanels();
        this.updateToolbar();
    }
    initToolbarOptionsAndPanels() {
        const { panels: panels, defaultPanel: defaultPanel } = this.chartMenuSvc.getChartToolPanels(this.chartController);
        this.panels = panels;
        this.defaultPanel = defaultPanel;
        this.chartToolbarOptions = this.chartMenuSvc.getChartToolbarOptions();
    }
    updateToolbar() {
        const buttons = this.chartToolbarOptions.map((buttonName)=>{
            const { iconName: iconName, callback: callback } = this.buttons[buttonName];
            return {
                buttonName: buttonName,
                iconName: iconName,
                callback: callback
            };
        });
        this.chartToolbar.updateParams({
            buttons: buttons
        });
    }
    createMenuPanel(defaultTab) {
        const menuPanel = this.menuPanel = this.createBean(new $5b7ccabde48fae90$export$3057d1f56ef1c73f({
            height: "100%",
            closable: true,
            hideTitleBar: true,
            cssIdentifier: "chart-menu"
        }));
        menuPanel.setParentComponent(this);
        this.eMenuPanelContainer.appendChild(menuPanel.getGui());
        this.tabbedMenu = this.createBean(new $5b7ccabde48fae90$var$TabbedChartMenu(this.panels, this.chartMenuContext));
        this.addManagedListeners(this.tabbedMenu, {
            closed: ()=>{
                this.hideMenu();
            }
        });
        this.addManagedListeners(menuPanel, {
            destroyed: ()=>this.destroyBean(this.tabbedMenu)
        });
        return new (0, $437b23f6a393c3bf$export$30ec7836a4847721)((res)=>{
            window.setTimeout(()=>{
                menuPanel.setBodyComponent(this.tabbedMenu);
                this.tabbedMenu.showTab(defaultTab);
                res(menuPanel);
            }, 100);
        });
    }
    showContainer(eventSource, suppressFocus) {
        if (!this.menuPanel) return;
        this.menuVisible = true;
        this.refreshMenuClasses();
        this.tabbedMenu.showMenu(eventSource, suppressFocus);
    }
    showMenu(params) {
        const { panel: panel, eventSource: eventSource, suppressFocus: suppressFocus } = params ?? {};
        if (this.menuPanel && !panel) this.showContainer(eventSource, suppressFocus);
        else {
            const menuPanel = panel || this.defaultPanel;
            let tab = this.panels.indexOf(menuPanel);
            if (tab < 0) {
                (0, $437b23f6a393c3bf$export$545083624300f13d)(143, {
                    panel: panel
                });
                tab = this.panels.indexOf(this.defaultPanel);
            }
            if (this.menuPanel) {
                this.tabbedMenu.showTab(tab);
                this.showContainer(eventSource, suppressFocus);
            } else this.createMenuPanel(tab).then(()=>this.showContainer(eventSource, suppressFocus));
        }
    }
    hideMenu() {
        this.menuVisible = false;
        this.refreshMenuClasses();
    }
    refreshMenuClasses() {
        this.eChartContainer.classList.toggle("ag-chart-menu-visible", this.menuVisible);
        this.eChartContainer.classList.toggle("ag-chart-menu-hidden", !this.menuVisible);
    }
    showMenuList(eventSource) {
        this.chartMenuListFactory.showMenuList({
            eventSource: eventSource,
            showMenu: ()=>this.showMenu({
                    eventSource: eventSource
                }),
            chartMenuContext: this.chartMenuContext
        });
    }
    destroy() {
        super.destroy();
        if (this.menuPanel?.isAlive()) this.destroyBean(this.menuPanel);
        if (this.tabbedMenu?.isAlive()) this.destroyBean(this.tabbedMenu);
    }
};
var $5b7ccabde48fae90$var$CARTESIAN_AXIS_TYPES = [
    "number",
    "category",
    "time",
    "grouped-category"
];
var $5b7ccabde48fae90$var$POLAR_AXIS_TYPES = [
    "angle-category",
    "angle-number",
    "radius-category",
    "radius-number"
];
var $5b7ccabde48fae90$var$VALID_AXIS_TYPES = [
    ...$5b7ccabde48fae90$var$CARTESIAN_AXIS_TYPES,
    ...$5b7ccabde48fae90$var$POLAR_AXIS_TYPES
];
var $5b7ccabde48fae90$var$ChartOptionsService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(chartController){
        super();
        this.chartController = chartController;
    }
    getChartThemeOverridesProxy() {
        return {
            getValue: (expression)=>this.getChartOption(expression),
            setValue: (expression, value)=>this.setChartThemeOverrides([
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setChartThemeOverrides(properties)
        };
    }
    getAxisThemeOverridesProxy() {
        return {
            getValue: (expression)=>this.getAxisProperty(expression),
            setValue: (expression, value)=>this.setAxisThemeOverrides([
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setAxisThemeOverrides(properties)
        };
    }
    getCartesianAxisOptionsProxy(axisType) {
        return {
            getValue: (expression)=>this.getCartesianAxisProperty(axisType, expression),
            setValue: (expression, value)=>this.setCartesianAxisOptions(axisType, [
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setCartesianAxisOptions(axisType, properties),
            clearValue: (parentExpression, key)=>this.clearCartesianAxisOptions(axisType, parentExpression, key)
        };
    }
    getCartesianAxisThemeOverridesProxy(axisType) {
        return {
            getValue: (expression)=>this.getCartesianAxisProperty(axisType, expression),
            setValue: (expression, value)=>this.setCartesianAxisThemeOverrides(axisType, [
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setCartesianAxisThemeOverrides(axisType, properties)
        };
    }
    getCartesianAxisAppliedThemeOverridesProxy(axisType) {
        return {
            getValue: (expression)=>this.getCartesianAxisThemeOverride(axisType, // Allow the caller to specify a wildcard expression to retrieve the whole set of overrides
                expression === "*" ? null : expression),
            setValue: (expression, value)=>this.setCartesianAxisThemeOverrides(axisType, // Allow the caller to specify a wildcard expression to set the whole set of overrides
                [
                    {
                        expression: expression === "*" ? null : expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setCartesianAxisThemeOverrides(axisType, properties)
        };
    }
    getSeriesOptionsProxy(getSelectedSeries) {
        return {
            getValue: (expression, calculated)=>this.getSeriesOption(getSelectedSeries(), expression, calculated),
            setValue: (expression, value)=>this.setSeriesOptions(getSelectedSeries(), [
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setSeriesOptions(getSelectedSeries(), properties)
        };
    }
    /**
   * Determine the set of theme overrides that should be retained when transitioning from one chart type to another.
   */ getPersistedChartThemeOverrides(existingChartOptions, existingAxes, existingChartType, targetChartType) {
        const retainedThemeOverrideKeys = this.getRetainedChartThemeOverrideKeys(existingChartType, targetChartType);
        const retainedChartAxisThemeOverrideKeys = this.getRetainedChartAxisThemeOverrideKeys(null, existingChartType, targetChartType);
        const targetChartOptions = this.createChartOptions();
        for (const expression of retainedThemeOverrideKeys){
            const value = this.retrieveChartOptionsThemeOverride(existingChartOptions, existingChartType, expression);
            if (value !== void 0) this.assignChartOptionsThemeOverride(targetChartOptions, targetChartType, expression, value);
        }
        if (existingAxes) this.assignPersistedAxisOverrides({
            existingAxes: existingAxes,
            retainedChartAxisThemeOverrideKeys: retainedChartAxisThemeOverrideKeys,
            existingChartOptions: existingChartOptions,
            targetChartOptions: targetChartOptions,
            existingChartType: existingChartType,
            targetChartType: targetChartType
        });
        return targetChartOptions.theme.overrides;
    }
    assignPersistedAxisOverrides(params) {
        const { existingAxes: existingAxes, retainedChartAxisThemeOverrideKeys: retainedChartAxisThemeOverrideKeys, existingChartOptions: existingChartOptions, targetChartOptions: targetChartOptions, existingChartType: existingChartType, targetChartType: targetChartType } = params;
        for (const { expression: expression, targetAxisTypes: targetAxisTypes } of retainedChartAxisThemeOverrideKeys)for (const existingAxisType of existingAxes.map((axis)=>axis.type)){
            const value = this.retrieveChartOptionsThemeOverride(existingChartOptions, existingChartType, [
                "axes",
                existingAxisType,
                expression
            ].join("."));
            if (value !== void 0) for (const targetAxisType of targetAxisTypes)this.assignChartOptionsThemeOverride(targetChartOptions, targetChartType, [
                "axes",
                targetAxisType,
                expression
            ].join("."), value);
        }
    }
    getRetainedChartThemeOverrideKeys(existingChartType, targetChartType) {
        const UNIVERSAL_PERSISTED_THEME_OVERRIDES = [
            "animation"
        ];
        const PERSISTED_CARTESIAN_CHART_THEME_OVERRIDES = [
            "zoom",
            "navigator"
        ];
        const chartSpecificThemeOverrideKeys = ((previousChartType, updatedChartType)=>{
            const expressions = new Array();
            if ($5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(previousChartType)) && $5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(updatedChartType))) expressions.push(...PERSISTED_CARTESIAN_CHART_THEME_OVERRIDES);
            return expressions;
        })(existingChartType, targetChartType);
        return [
            ...UNIVERSAL_PERSISTED_THEME_OVERRIDES,
            ...chartSpecificThemeOverrideKeys
        ];
    }
    getRetainedChartAxisThemeOverrideKeys(axisType, existingChartType, targetChartType) {
        if ($5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(existingChartType)) && $5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(targetChartType))) {
            const retainedKeys = this.getRetainedCartesianAxisThemeOverrideKeys(axisType);
            return retainedKeys.map((expression)=>({
                    expression: expression,
                    targetAxisTypes: $5b7ccabde48fae90$var$CARTESIAN_AXIS_TYPES
                }));
        }
        return [];
    }
    getRetainedCartesianAxisThemeOverrideKeys(axisType) {
        const axisPositionSuffixes = axisType === "xAxis" ? [
            "",
            ".top",
            ".bottom"
        ] : axisType === "yAxis" ? [
            "",
            ".left",
            ".right"
        ] : [
            "",
            ".left",
            ".right",
            ".top",
            ".bottom"
        ];
        const PERSISTED_CARTESIAN_AXIS_THEME_OVERRIDES = [
            "crosshair"
        ];
        const expressions = new Array();
        for (const expression of PERSISTED_CARTESIAN_AXIS_THEME_OVERRIDES)for (const axisPositionSuffix of axisPositionSuffixes)expressions.push(`${expression}${axisPositionSuffix}`);
        return expressions;
    }
    getChartOption(expression) {
        return $5b7ccabde48fae90$var$get(this.getChart(), expression, void 0);
    }
    setChartThemeOverrides(properties) {
        const chartType = this.getChartType();
        const chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties)this.assignChartOptionsThemeOverride(chartOptions, chartType, expression, value);
        this.applyChartOptions(chartOptions);
    }
    applyChartOptions(chartOptions, options) {
        if (Object.keys(chartOptions).length === 0) return;
        this.updateChart(chartOptions);
        const shouldRaiseEvent = !options?.silent;
        if (shouldRaiseEvent) this.raiseChartOptionsChangedEvent();
    }
    awaitChartOptionUpdate(func) {
        const chart = this.chartController.getChartProxy().getChart();
        chart.waitForUpdate().then(()=>func()).catch((e)=>(0, $437b23f6a393c3bf$export$a20c7248650823a9)(108, {
                e: e
            }));
    }
    getAxisProperty(expression) {
        return $5b7ccabde48fae90$var$get(this.getChart().axes?.x, expression, void 0);
    }
    setAxisThemeOverrides(properties) {
        const chart = this.getChart();
        const chartType = this.getChartType();
        const chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties){
            const relevantAxes = Object.values(chart.axes ?? {}).filter((axis)=>{
                const parts = expression.split(".");
                let current = axis;
                for (const part of parts){
                    if (!(part in current)) return false;
                    current = current[part];
                }
                return true;
            });
            if (!relevantAxes) continue;
            for (const axis of relevantAxes){
                if (!this.isValidAxisType(axis)) continue;
                this.assignChartAxisThemeOverride(chartOptions, chartType, axis.type, null, expression, value);
            }
        }
        this.applyChartOptions(chartOptions);
    }
    getCartesianAxisProperty(axisType, expression) {
        const axes = this.getChartAxes();
        const axis = this.getCartesianAxis(axes, axisType);
        return $5b7ccabde48fae90$var$get(axis, expression, void 0);
    }
    getCartesianAxisThemeOverride(axisType, expression) {
        const axes = this.getChartAxes();
        const chartAxis = this.getCartesianAxis(axes, axisType);
        if (!chartAxis || !this.isValidAxisType(chartAxis)) return void 0;
        const chartType = this.getChartType();
        const chartOptions = this.getChart().getOptions();
        return this.retrieveChartAxisThemeOverride(chartOptions, chartType, chartAxis.type, axisType === "yAxis" ? [
            "left",
            "right"
        ] : [
            "bottom",
            "top"
        ], expression);
    }
    setCartesianAxisThemeOverrides(axisType, properties) {
        const axes = this.getChartAxes();
        const chartAxis = this.getCartesianAxis(axes, axisType);
        if (!chartAxis || !this.isValidAxisType(chartAxis)) return;
        const chartType = this.getChartType();
        const chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties)this.assignChartAxisThemeOverride(chartOptions, chartType, chartAxis.type, axisType === "yAxis" ? [
            "left",
            "right"
        ] : [
            "bottom",
            "top"
        ], expression, value);
        this.applyChartOptions(chartOptions);
    }
    setCartesianAxisOptions(axisType, properties) {
        this.updateCartesianAxisOptions(axisType, (chartOptions)=>{
            const axisId = axisType === "yAxis" ? "y" : "x";
            for (const { expression: expression, value: value } of properties)this.assignChartOption(chartOptions, `axes.${axisId}.${expression}`, value);
        });
    }
    clearCartesianAxisOptions(axisType, parentExpression, key) {
        this.updateCartesianAxisOptions(axisType, (chartOptions)=>{
            const axisId = axisType === "yAxis" ? "y" : "x";
            this.clearChartOption(chartOptions, `axes.${axisId}.${parentExpression}`, key);
        });
    }
    updateCartesianAxisOptions(axisType, updateFunc) {
        const existingChartOptions = this.getChart().getOptions();
        const axisOptions = "axes" in existingChartOptions ? existingChartOptions.axes : void 0;
        if (!existingChartOptions || !axisOptions) return;
        const axes = this.getChartAxes();
        const chartAxis = this.getCartesianAxis(axes, axisType);
        if (!chartAxis) return;
        const chartOptions = this.createChartOptions();
        chartOptions.axes = axisOptions;
        updateFunc(chartOptions, chartAxis, existingChartOptions);
        this.applyChartOptions(chartOptions);
    }
    setCartesianCategoryAxisType(axisType, value) {
        this.updateCartesianAxisOptions(axisType, (chartOptions, chartAxis, existingChartOptions)=>{
            const chartType = this.getChartType();
            this.assignPersistedAxisOverrides({
                existingAxes: [
                    chartAxis
                ],
                retainedChartAxisThemeOverrideKeys: this.getRetainedChartAxisThemeOverrideKeys(axisType, chartType, chartType),
                existingChartOptions: existingChartOptions,
                targetChartOptions: chartOptions,
                existingChartType: chartType,
                targetChartType: chartType
            });
            this.assignChartOption(chartOptions, `axes.x.type`, value);
            this.chartController.setCategoryAxisType(value);
        });
    }
    getCartesianAxis(axes, axisType) {
        if (axes.length < 2) return void 0;
        switch(axisType){
            case "xAxis":
                return axes[0].direction === "x" ? axes[0] : axes[1];
            case "yAxis":
                return axes[1].direction === "y" ? axes[1] : axes[0];
        }
    }
    getSeriesOption(seriesType, expression, calculated) {
        const series = this.getChart().series.find((s2)=>$5b7ccabde48fae90$var$isMatchingSeries(seriesType, s2));
        return $5b7ccabde48fae90$var$get(calculated ? series : series?.properties.toJson(), expression, void 0);
    }
    setSeriesOptions(seriesType, properties) {
        const chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties)this.assignChartOptionsSeriesThemeOverride(chartOptions, seriesType, `series.${expression}`, value);
        this.applyChartOptions(chartOptions);
    }
    getPairedMode() {
        return this.chartController.getChartProxy().isPaired();
    }
    setPairedMode(paired) {
        this.chartController.getChartProxy().setPaired(paired);
    }
    getChartAxes() {
        const chart = this.getChart();
        return Object.values(chart.axes ?? {});
    }
    retrieveChartAxisThemeOverride(chartOptions, chartType, axisType, axisPositions, expression) {
        if (axisPositions) for (const axisPosition of axisPositions){
            const value = this.retrieveChartOptionsThemeOverride(chartOptions, chartType, [
                "axes",
                axisType,
                axisPosition,
                ...expression ? [
                    expression
                ] : []
            ].join("."));
            if (value === void 0) continue;
            return value;
        }
        else return this.retrieveChartOptionsThemeOverride(chartOptions, chartType, [
            "axes",
            axisType,
            ...expression ? [
                expression
            ] : []
        ].join("."));
    }
    assignChartAxisThemeOverride(chartOptions, chartType, axisType, axisPositions, expression, value) {
        if (axisPositions) for (const axisPosition of axisPositions)this.assignChartOptionsThemeOverride(chartOptions, chartType, [
            "axes",
            axisType,
            axisPosition,
            ...expression ? [
                expression
            ] : []
        ].join("."), value);
        else this.assignChartOptionsThemeOverride(chartOptions, chartType, [
            "axes",
            axisType,
            ...expression ? [
                expression
            ] : []
        ].join("."), value);
    }
    isValidAxisType(chartAxis) {
        return $5b7ccabde48fae90$var$VALID_AXIS_TYPES.includes(chartAxis.type);
    }
    getChartType() {
        return this.chartController.getChartType();
    }
    getChart() {
        return this.chartController.getChartProxy().getChart();
    }
    updateChart(chartOptions) {
        const chartRef = this.chartController.getChartProxy().getChartRef();
        chartRef.skipAnimations();
        chartRef.updateDelta(chartOptions);
    }
    createChartOptions() {
        const chartOptions = {
            theme: {
                overrides: {}
            }
        };
        return chartOptions;
    }
    retrieveChartOptionsThemeOverride(chartOptions, chartType, expression) {
        const chartSeriesTypes = this.getChartThemeOverridesSeriesTypeKeys(chartType);
        for (const seriesType of chartSeriesTypes){
            const value = this.retrieveChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression);
            if (value === void 0) continue;
            return value;
        }
        return void 0;
    }
    assignChartOptionsThemeOverride(chartOptions, chartType, expression, value) {
        const chartSeriesTypes = this.getChartThemeOverridesSeriesTypeKeys(chartType);
        for (const seriesType of chartSeriesTypes)this.assignChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression, value);
    }
    retrieveChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression) {
        return this.retrieveChartOption(chartOptions, [
            "theme",
            "overrides",
            seriesType,
            ...expression ? [
                expression
            ] : []
        ].join("."));
    }
    assignChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression, value) {
        this.assignChartOption(chartOptions, [
            "theme",
            "overrides",
            seriesType,
            ...expression ? [
                expression
            ] : []
        ].join("."), value);
    }
    getChartThemeOverridesSeriesTypeKeys(chartType) {
        const chartSeriesTypes = this.chartController.getChartSeriesTypes(chartType);
        if (this.chartController.isComboChart()) chartSeriesTypes.push("common");
        return chartSeriesTypes;
    }
    retrieveChartOption(chartOptions, expression) {
        return $5b7ccabde48fae90$var$get(chartOptions, expression, void 0);
    }
    assignChartOption(chartOptions, expression, value) {
        $5b7ccabde48fae90$var$set(chartOptions, expression, value);
    }
    clearChartOption(chartOptions, parentExpression, key) {
        const parentObject = $5b7ccabde48fae90$var$get(chartOptions, parentExpression, void 0);
        if (parentObject) delete parentObject[key];
    }
    raiseChartOptionsChangedEvent() {
        const chartModel = this.chartController.getChartModel();
        this.eventSvc.dispatchEvent({
            type: "chartOptionsChanged",
            chartId: chartModel.chartId,
            chartType: chartModel.chartType,
            chartThemeName: this.chartController.getChartThemeName(),
            chartOptions: chartModel.chartOptions
        });
    }
};
function $5b7ccabde48fae90$var$isMatchingSeries(seriesType, series) {
    return $5b7ccabde48fae90$var$isSeriesType(seriesType) && series.type === seriesType;
}
// packages/ag-grid-enterprise/src/charts/chartComp/gridChartComp.ts
var $5b7ccabde48fae90$var$GridChartComp = class extends (0, $437b23f6a393c3bf$export$16fa2f45be04daa8) {
    constructor(params){
        super(/* html */ `
            <div style="height: 100%; width: 100%;">
                <div class="ag-chart" data-ref="eWrapper">
                    <div data-ref="eChartContainer" class="ag-chart-components-wrapper ag-chart-menu-hidden">
                        <div data-ref="eChart" class="ag-chart-canvas-wrapper"></div>
                        <div data-ref="eEmpty" class="ag-chart-empty-text ag-unselectable"></div>
                    </div>
                    <div data-ref="eMenuContainer" class="ag-chart-docked-container"></div>
                </div>
            </div>
            `);
        this.eChart = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eWrapper = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eChartContainer = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eMenuContainer = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.eEmpty = (0, $437b23f6a393c3bf$export$6c811454646ed8be);
        this.params = params;
    }
    wireBeans(beans) {
        this.crossFilterService = beans.chartCrossFilterSvc;
        this.chartTranslation = beans.chartTranslation;
        this.chartMenuSvc = beans.chartMenuSvc;
        this.focusSvc = beans.focusSvc;
        this.popupSvc = beans.popupSvc;
        this.enterpriseChartProxyFactory = beans.enterpriseChartProxyFactory;
        this.environment = beans.environment;
    }
    postConstruct() {
        const modelParams = {
            ...this.params,
            chartType: $5b7ccabde48fae90$var$getCanonicalChartType(this.params.chartType),
            chartThemeName: this.getThemeName()
        };
        const isRtl = this.gos.get("enableRtl");
        this.eWrapper.classList.add(isRtl ? "ag-rtl" : "ag-ltr");
        const model = this.createBean(new $5b7ccabde48fae90$var$ChartDataModel(modelParams));
        this.chartController = this.createManagedBean(new $5b7ccabde48fae90$var$ChartController(model));
        this.chartOptionsService = this.createManagedBean(new $5b7ccabde48fae90$var$ChartOptionsService(this.chartController));
        this.validateCustomThemes();
        this.createChart();
        if (this.params.insideDialog) this.addDialog();
        else {
            this.addManagedEventListeners({
                stylesChanged: this.updateTheme.bind(this)
            });
            this.updateTheme();
        }
        this.addMenu();
        this.addManagedElementListeners(this.getGui(), {
            focusin: this.setActiveChartCellRange.bind(this)
        });
        this.addManagedListeners(this.chartController, {
            chartModelUpdate: this.update.bind(this)
        });
        this.addManagedPropertyListeners([
            "chartThemeOverrides",
            "chartThemes"
        ], this.reactivePropertyUpdate.bind(this));
        this.update();
        this.raiseChartCreatedEvent();
    }
    updateTheme() {
        this.environment.applyThemeClasses(this.getGui());
    }
    createChart() {
        let chartInstance = void 0;
        if (this.chartProxy) chartInstance = this.chartProxy.destroy({
            keepChartInstance: true
        });
        const crossFilterCallback = (event, reset)=>{
            const ctx = this.params.crossFilteringContext;
            ctx.lastSelectedChartId = reset ? "" : this.chartController.getChartId();
            if (reset) this.params.crossFilteringResetCallback();
            this.crossFilterService.filter(event, reset);
        };
        const chartType = this.chartController.getChartType();
        const chartProxyParams = {
            agChartsExports: this.beans.agChartsExports,
            chartType: chartType,
            chartInstance: chartInstance,
            getChartThemeName: this.getChartThemeName.bind(this),
            getChartThemes: this.getChartThemes.bind(this),
            customChartThemes: this.gos.get("customChartThemes"),
            styleNonce: this.gos.get("styleNonce"),
            getGridOptionsChartThemeOverrides: ()=>this.getGridOptionsChartThemeOverrides(),
            getExtraPaddingDirections: ()=>this.chartMenu?.getExtraPaddingDirections() ?? [],
            apiChartThemeOverrides: this.params.chartThemeOverrides,
            crossFiltering: this.params.crossFiltering ?? false,
            crossFilterCallback: crossFilterCallback,
            parentElement: this.eChart,
            grouping: this.chartController.isGrouping(),
            chartThemeToRestore: this.params.chartThemeName,
            chartOptionsToRestore: this.params.chartOptionsToRestore,
            chartPaletteToRestore: this.params.chartPaletteToRestore,
            seriesChartTypes: this.chartController.getSeriesChartTypes(),
            translate: (toTranslate)=>this.chartTranslation.translate(toTranslate),
            context: (0, $437b23f6a393c3bf$export$fcfd03fd78c6cf24)(this.gos, {})
        };
        this.params.chartOptionsToRestore = void 0;
        this.chartType = chartType;
        this.chartProxy = this.createChartProxy(chartProxyParams);
        if (!this.chartProxy) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(138, {
                chartType: chartProxyParams.chartType
            });
            return;
        }
        this.chartController.setChartProxy(this.chartProxy);
        this.createMenuContext();
    }
    createMenuContext() {
        if (this.chartMenuContext) return;
        const chartMenuParamsFactory = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(this.chartOptionsService.getChartThemeOverridesProxy()));
        const chartAxisMenuParamsFactory = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(this.chartOptionsService.getAxisThemeOverridesProxy()));
        this.chartMenuContext = {
            chartController: this.chartController,
            chartOptionsService: this.chartOptionsService,
            chartMenuParamsFactory: chartMenuParamsFactory,
            chartAxisMenuParamsFactory: chartAxisMenuParamsFactory
        };
    }
    getChartThemeName() {
        return this.chartController.getChartThemeName();
    }
    getChartThemes() {
        return this.chartController.getThemeNames();
    }
    getGridOptionsChartThemeOverrides() {
        return this.gos.get("chartThemeOverrides");
    }
    createChartProxy(chartProxyParams) {
        const { chartType: chartType } = chartProxyParams;
        switch(chartType){
            case "column":
            case "bar":
            case "groupedColumn":
            case "stackedColumn":
            case "normalizedColumn":
            case "groupedBar":
            case "stackedBar":
            case "normalizedBar":
                return new $5b7ccabde48fae90$var$BarChartProxy(chartProxyParams);
            case "pie":
            case "donut":
            case "doughnut":
                return new $5b7ccabde48fae90$var$PieChartProxy(chartProxyParams);
            case "area":
            case "stackedArea":
            case "normalizedArea":
                return new $5b7ccabde48fae90$var$AreaChartProxy(chartProxyParams);
            case "line":
            case "stackedLine":
            case "normalizedLine":
                return new $5b7ccabde48fae90$var$LineChartProxy(chartProxyParams);
            case "scatter":
            case "bubble":
                return new $5b7ccabde48fae90$var$ScatterChartProxy(chartProxyParams);
            case "columnLineCombo":
            case "areaColumnCombo":
            case "customCombo":
                return new $5b7ccabde48fae90$var$ComboChartProxy(chartProxyParams);
        }
        const enterpriseChartProxy = this.enterpriseChartProxyFactory?.createChartProxy(chartProxyParams);
        if (!enterpriseChartProxy) throw (0, $437b23f6a393c3bf$export$680bb5102fca525e)(251, {
            chartType: chartType
        });
        return enterpriseChartProxy;
    }
    addDialog() {
        const title = this.chartTranslation.translate(this.params.pivotChart ? "pivotChartTitle" : "rangeChartTitle");
        const { width: width, height: height } = this.getBestDialogSize();
        const afterGuiAttached = this.params.focusDialogOnOpen ? ()=>setTimeout(()=>(0, $437b23f6a393c3bf$export$8598088d375f416f)(this.getGui())) : void 0;
        this.chartDialog = new $5b7ccabde48fae90$var$Dialog({
            resizable: true,
            movable: true,
            maximizable: true,
            title: title,
            width: width,
            height: height,
            component: this,
            centered: true,
            closable: true,
            afterGuiAttached: afterGuiAttached,
            postProcessPopupParams: {
                type: "chart"
            }
        });
        this.createBean(this.chartDialog);
        this.chartDialog.addEventListener("destroyed", ()=>{
            this.destroy();
            this.chartMenuSvc.hideAdvancedSettings();
            const lastFocusedCell = this.focusSvc.getFocusedCell();
            setTimeout(()=>{
                if (this.focusSvc.isAlive()) {
                    if (lastFocusedCell) this.focusSvc.setFocusedCell({
                        ...lastFocusedCell,
                        forceBrowserFocus: true
                    });
                    else (0, $437b23f6a393c3bf$export$b3beea4db79d8bb3)(this.beans);
                }
            });
        });
    }
    getBestDialogSize() {
        const popupParent = this.popupSvc.getPopupParent();
        const maxWidth = (0, $437b23f6a393c3bf$export$642efcb17474eb51)(popupParent) * 0.75;
        const maxHeight = (0, $437b23f6a393c3bf$export$d23c22492e0f7c0c)(popupParent) * 0.75;
        const ratio = 0.553;
        const chart = this.chartProxy.getChart();
        let width = this.params.insideDialog ? 850 : chart.width;
        let height = this.params.insideDialog ? 470 : chart.height;
        if (width > maxWidth || height > maxHeight) {
            width = Math.min(width, maxWidth);
            height = Math.round(width * ratio);
            if (height > maxHeight) {
                height = maxHeight;
                width = Math.min(width, Math.round(height / ratio));
            }
        }
        return {
            width: width,
            height: height
        };
    }
    addMenu() {
        if (!this.params.crossFiltering) {
            this.chartMenu = this.createBean(new $5b7ccabde48fae90$var$ChartMenu(this.eChartContainer, this.eMenuContainer, this.chartMenuContext));
            this.eChartContainer.appendChild(this.chartMenu.getGui());
        }
    }
    update(params) {
        if (params?.chartId) {
            const validUpdate = this.chartController.update(params);
            if (!validUpdate) return;
        }
        const updatedChartType = this.chartTypeChanged(params);
        const persistedThemeOverrides = updatedChartType || this.chartEmpty ? ((updatedChartType2)=>{
            const currentChartType = this.chartType;
            const targetChartType = updatedChartType2;
            const existingChartInstance = this.chartProxy.getChart();
            const existingChartOptions = existingChartInstance?.getOptions();
            const existingAxes = Object.values(existingChartInstance?.axes ?? {});
            return this.chartOptionsService.getPersistedChartThemeOverrides(existingChartOptions, existingAxes, currentChartType, targetChartType ?? currentChartType);
        })(updatedChartType) : void 0;
        if (updatedChartType) this.createChart();
        if (persistedThemeOverrides && params?.chartThemeOverrides) (0, $437b23f6a393c3bf$export$8ade6bd474fcde42)(persistedThemeOverrides, params.chartThemeOverrides);
        const updatedThemeOverrides = persistedThemeOverrides ?? params?.chartThemeOverrides;
        this.updateChart(updatedThemeOverrides);
        if (params?.chartId) this.chartProxy.getChart().waitForUpdate().then(()=>{
            this.chartController.raiseChartApiUpdateEvent();
        });
    }
    updateChart(updatedOverrides) {
        const { chartProxy: chartProxy } = this;
        const selectedCols = this.chartController.getSelectedValueColState();
        const data = this.chartController.getChartData();
        const chartEmpty = this.handleEmptyChart(data, selectedCols.length);
        this.chartEmpty = chartEmpty;
        if (chartEmpty) {
            if (updatedOverrides) this.chartController.updateThemeOverrides(updatedOverrides);
            return;
        }
        const chartUpdateParams = this.chartController.getChartUpdateParams(updatedOverrides);
        chartProxy.update(chartUpdateParams);
        this.chartProxy.getChart().waitForUpdate().then(()=>{
            this.chartController.raiseChartUpdatedEvent();
        });
    }
    chartTypeChanged(updateParams) {
        const [currentType, updatedChartType] = [
            this.chartController.getChartType(),
            updateParams?.chartType
        ];
        const targetChartType = updatedChartType ? $5b7ccabde48fae90$var$getCanonicalChartType(updatedChartType) : void 0;
        if (this.chartType !== currentType) return targetChartType ?? currentType;
        if (targetChartType && currentType !== targetChartType) return targetChartType;
        return null;
    }
    getChartModel() {
        return this.chartController.getChartModel();
    }
    getChartImageDataURL(fileFormat) {
        return this.chartProxy.getChartImageDataURL(fileFormat);
    }
    handleEmptyChart(data, numFields) {
        const pivotModeDisabled = this.chartController.isPivotChart() && !this.chartController.isPivotMode();
        const chartType = this.chartController.getChartType();
        let minFieldsRequired = 1;
        if (this.chartController.isActiveXYChart()) minFieldsRequired = chartType === "bubble" ? 3 : 2;
        else if ($5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(chartType))) minFieldsRequired = 0;
        const isEmptyChart = numFields < minFieldsRequired || data.length === 0;
        if (this.eChart) {
            const isEmpty = pivotModeDisabled || isEmptyChart;
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eChart, !isEmpty);
            (0, $437b23f6a393c3bf$export$9405f1cbb4e2383f)(this.eEmpty, isEmpty);
        }
        if (pivotModeDisabled) {
            this.eEmpty.textContent = this.chartTranslation.translate("pivotChartRequiresPivotMode");
            return true;
        }
        if (isEmptyChart) {
            this.eEmpty.textContent = this.chartTranslation.translate("noDataToChart");
            return true;
        }
        return false;
    }
    downloadChart(dimensions, fileName, fileFormat) {
        this.chartProxy.downloadChart(dimensions, fileName, fileFormat);
    }
    openChartToolPanel(panel) {
        const menuPanel = panel ? $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS[panel] : panel;
        this.chartMenu.showMenu({
            panel: menuPanel
        });
    }
    closeChartToolPanel() {
        this.chartMenu.hideMenu();
    }
    getChartId() {
        return this.chartController.getChartId();
    }
    getUnderlyingChart() {
        return this.chartProxy.getChartRef();
    }
    crossFilteringReset() {
        this.chartProxy.crossFilteringReset();
    }
    setMaximized(maximized) {
        this.chartDialog?.setMaximized(maximized);
    }
    setActiveChartCellRange(focusEvent) {
        if (this.getGui().contains(focusEvent.relatedTarget)) return;
        this.chartController.setChartRange(true);
    }
    getThemeName() {
        const availableChartThemes = this.gos.get("chartThemes") || $5b7ccabde48fae90$var$DEFAULT_THEMES;
        if (availableChartThemes.length === 0) throw new Error((0, $437b23f6a393c3bf$export$680bb5102fca525e)(254));
        const { chartThemeName: chartThemeName } = this.params;
        return availableChartThemes.includes(chartThemeName) ? chartThemeName : availableChartThemes[0];
    }
    getAllKeysInObjects(objects) {
        const allValues = {};
        for (const obj of objects.filter((obj2)=>obj2 != null))for (const key of Object.keys(obj))allValues[key] = null;
        return Object.keys(allValues);
    }
    validateCustomThemes() {
        const suppliedThemes = this.getChartThemes();
        const customChartThemes = this.gos.get("customChartThemes");
        if (customChartThemes) {
            for (const customThemeName of this.getAllKeysInObjects([
                customChartThemes
            ]))if (!suppliedThemes.includes(customThemeName)) (0, $437b23f6a393c3bf$export$545083624300f13d)(139, {
                customThemeName: customThemeName
            });
        }
    }
    reactivePropertyUpdate() {
        this.chartController.setChartThemeName(this.getThemeName(), true);
        const chartId = this.getChartId();
        const modelType = this.chartController.isCrossFilterChart() ? "crossFilter" : this.getChartModel().modelType;
        const chartThemeOverrides = this.gos.get("chartThemeOverrides") || {};
        this.update({
            type: `${modelType}ChartUpdate`,
            chartId: chartId,
            chartThemeOverrides: chartThemeOverrides
        });
    }
    raiseChartCreatedEvent() {
        this.chartProxy.getChart().waitForUpdate().then(()=>{
            this.eventSvc.dispatchEvent({
                type: "chartCreated",
                chartId: this.chartController.getChartId()
            });
        });
    }
    raiseChartDestroyedEvent() {
        this.eventSvc.dispatchEvent({
            type: "chartDestroyed",
            chartId: this.chartController.getChartId()
        });
    }
    destroy() {
        super.destroy();
        if (this.chartProxy) this.chartProxy.destroy();
        this.destroyBean(this.chartMenu);
        if (this.chartDialog?.isAlive()) this.destroyBean(this.chartDialog);
        this.onDestroyColorSchemeChangeListener?.();
        const eGui = this.getGui();
        (0, $437b23f6a393c3bf$export$69e6e10709eabd91)(eGui);
        (0, $437b23f6a393c3bf$export$dd4d52e41fb4cef5)(eGui);
        this.raiseChartDestroyedEvent();
    }
};
var $5b7ccabde48fae90$var$DEBUG = false;
function $5b7ccabde48fae90$var$upgradeChartModel(model) {
    const originalVersion = model.version;
    if (model.version == null) model.version = $5b7ccabde48fae90$var$heuristicVersionDetection(model);
    model = $5b7ccabde48fae90$var$migrateIfBefore("23.0.0", model, $5b7ccabde48fae90$var$migrateV23);
    model = $5b7ccabde48fae90$var$migrateIfBefore("24.0.0", model, $5b7ccabde48fae90$var$migrateV24);
    model = $5b7ccabde48fae90$var$migrateIfBefore("25.1.0", model, $5b7ccabde48fae90$var$migrateV25_1);
    model = $5b7ccabde48fae90$var$migrateIfBefore("26.0.0", model, $5b7ccabde48fae90$var$migrateV26);
    model = $5b7ccabde48fae90$var$migrateIfBefore("26.1.0", model, $5b7ccabde48fae90$var$migrateV26_1);
    model = $5b7ccabde48fae90$var$migrateIfBefore("26.2.0", model, $5b7ccabde48fae90$var$migrateV26_2);
    model = $5b7ccabde48fae90$var$migrateIfBefore("28.0.0", model, $5b7ccabde48fae90$var$migrateV28);
    model = $5b7ccabde48fae90$var$migrateIfBefore("28.2.0", model, $5b7ccabde48fae90$var$migrateV28_2);
    model = $5b7ccabde48fae90$var$migrateIfBefore("29.0.0", model, $5b7ccabde48fae90$var$migrateV29);
    model = $5b7ccabde48fae90$var$migrateIfBefore("29.1.0", model, $5b7ccabde48fae90$var$migrateV29_1);
    model = $5b7ccabde48fae90$var$migrateIfBefore("29.2.0", model, $5b7ccabde48fae90$var$migrateV29_2);
    model = $5b7ccabde48fae90$var$migrateIfBefore("30.0.0", model, $5b7ccabde48fae90$var$migrateV30);
    model = $5b7ccabde48fae90$var$migrateIfBefore("31.0.0", model, $5b7ccabde48fae90$var$migrateV31);
    model = $5b7ccabde48fae90$var$migrateIfBefore("32.0.0", model, $5b7ccabde48fae90$var$migrateV32);
    model = $5b7ccabde48fae90$var$migrateIfBefore("33.0.0", model, $5b7ccabde48fae90$var$migrateV33);
    model = $5b7ccabde48fae90$var$migrateIfBefore("34.0.0", model, $5b7ccabde48fae90$var$migrateV34);
    model = $5b7ccabde48fae90$var$cleanup(model);
    model = $5b7ccabde48fae90$var$migrateIfBefore($5b7ccabde48fae90$var$VERSION, model, (m)=>m);
    if ($5b7ccabde48fae90$var$DEBUG && originalVersion !== model.version) console.log("AG Grid: ChartModel migration complete", {
        model: model
    });
    return model;
}
function $5b7ccabde48fae90$var$migrateV23(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.legend.item.marker.type", "shape", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.seriesDefaults.marker.type", "shape", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.legend.padding", "spacing", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV24(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.marker.minSize", model);
    const { chartType: chartType, chartPalette: chartPalette, // Migrate.
    chartOptions: { xAxis: xAxis, yAxis: yAxis, ...chartOptions }, ...chartModel } = model;
    const axesTypes = $5b7ccabde48fae90$var$getLegacyAxisType(chartType);
    const axes = axesTypes?.map((type, i)=>({
            type: type,
            ...i === 0 ? xAxis : yAxis
        }));
    const LEGACY_PALETTES = {
        borneo: "ag-default",
        material: "ag-material",
        bright: "ag-vivid"
    };
    return {
        chartType: chartType,
        chartThemeName: LEGACY_PALETTES[chartPalette] ?? "ag-default",
        chartOptions: {
            ...chartOptions,
            axes: axes,
            xAxis: xAxis,
            yAxis: yAxis
        },
        ...chartModel
    };
}
function $5b7ccabde48fae90$var$migrateV25_1(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.seriesDefaults.label.minRequiredAngle", "minAngle", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV26(model) {
    const highlightOptUpdate = ({ dimOpacity: dimOpacity, ...opts })=>({
            ...opts,
            ...dimOpacity != null ? {
                series: {
                    dimOpacity: dimOpacity
                }
            } : {}
        });
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.seriesDefaults.highlightStyle", model, highlightOptUpdate);
    model = $5b7ccabde48fae90$var$jsonDelete("chart", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.tooltipClass", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.tooltipTracking", model);
    model = $5b7ccabde48fae90$var$jsonDeleteDefault("chartOptions.axes[].label.rotation", 0, model);
    model = $5b7ccabde48fae90$var$jsonDeleteDefault("chartOptions.axes[].label.rotation", 335, model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV26_1(model) {
    const highlightOptUpdate = ({ item: item, series: series, ...opts })=>({
            item: {
                ...opts,
                ...item
            },
            ...series ? {
                series: series
            } : {}
        });
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.seriesDefaults.highlightStyle", model, highlightOptUpdate);
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.series[].highlightStyle", model, highlightOptUpdate);
    return model;
}
function $5b7ccabde48fae90$var$migrateV26_2(model) {
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.seriesDefaults.fill.opacity", "chartOptions.seriesDefaults.fillOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.seriesDefaults.stroke.opacity", "chartOptions.seriesDefaults.strokeOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.seriesDefaults.stroke.width", "chartOptions.seriesDefaults.strokeWidth", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.fill", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.stroke", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.callout.colors", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.xAxis", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.yAxis", model);
    const { chartType: providedChartType, // disable no-unused-vars because `series` is required here, even though
    // unused, because it serves to take the `series` key out of otherChartOptions
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    chartOptions: { axes: axes, series: series, seriesDefaults: seriesDefaults, ...otherChartOptions }, ...otherModelProps } = model;
    const chartType = $5b7ccabde48fae90$var$getCanonicalChartType(providedChartType);
    const seriesType = $5b7ccabde48fae90$var$getSeriesType(chartType);
    const seriesTypes = [
        seriesType
    ];
    const chartTypeMixin = {};
    if (!$5b7ccabde48fae90$var$isPieChartSeries(seriesType)) {
        const minimalAxis = {
            top: {},
            bottom: {},
            left: {},
            right: {}
        };
        const updatedAxes = axes.map(({ type: type, ...axisProps })=>({
                [type]: {
                    ...minimalAxis,
                    ...axisProps
                }
            })).reduce($5b7ccabde48fae90$var$merge, {});
        for (const v of $5b7ccabde48fae90$var$ALL_AXIS_TYPES.filter((v2)=>updatedAxes[v2] == null))updatedAxes[v] = {
            ...minimalAxis
        };
        chartTypeMixin.axes = updatedAxes;
    }
    const updatedChartOptions = seriesTypes.map((t)=>({
            [t]: {
                ...chartTypeMixin,
                series: seriesDefaults,
                ...otherChartOptions
            }
        })).reduce($5b7ccabde48fae90$var$merge, {});
    model = {
        ...otherModelProps,
        chartType: chartType,
        chartOptions: updatedChartOptions
    };
    return model;
}
function $5b7ccabde48fae90$var$migrateV28(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.title.padding", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.subtitle.padding", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.*.title.padding", model);
    model = $5b7ccabde48fae90$var$jsonBackfill("chartOptions.*.axes.*.title.enabled", false, model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV28_2(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.callout", "calloutLine", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.label", "calloutLabel", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelKey", "sectorLabelKey", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelName", "sectorLabelName", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.callout", "calloutLine", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.label", "calloutLabel", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.labelKey", "sectorLabelKey", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.labelName", "sectorLabelName", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV29(model) {
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.fill", "chartOptions.scatter.series.marker.fill", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.fillOpacity", "chartOptions.scatter.series.marker.fillOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.stroke", "chartOptions.scatter.series.marker.stroke", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.strokeOpacity", "chartOptions.scatter.series.marker.strokeOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.strokeWidth", "chartOptions.scatter.series.marker.strokeWidth", model);
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.scatter.series.paired", "chartOptions.scatter.paired", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV29_1(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.axes[].tick.count", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV29_2(model) {
    const tooltipOptUpdate = ({ tracking: tracking, ...opts })=>{
        const output = {
            ...opts
        };
        if (tracking === false) {
            output.position ?? (output.position = {
                type: "pointer"
            });
            output.range ?? (output.range = "nearest");
        } else if (tracking === true) {
            output.position ?? (output.position = {
                type: "node"
            });
            output.range ?? (output.range = "nearest");
        }
        return output;
    };
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.*.tooltip", model, tooltipOptUpdate);
    return model;
}
function $5b7ccabde48fae90$var$migrateV30(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelKey", "sectorLabelKey", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelName", "sectorLabelName", model);
    model = $5b7ccabde48fae90$var$migrateV29_1(model);
    model = $5b7ccabde48fae90$var$migrateV29_2(model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.series.flipXY", model);
    model = $5b7ccabde48fae90$var$jsonAdd("chartOptions.common.legend.enabled", true, model);
    model = $5b7ccabde48fae90$var$jsonBackfill("chartOptions.common.legend.position", "right", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV31(model) {
    const V30_LEGACY_PALETTES = {
        "ag-pastel": "ag-sheets",
        "ag-solar": "ag-polychroma"
    };
    const updatedModel = $5b7ccabde48fae90$var$jsonRename("chartOptions.column", "bar", model);
    const chartThemeName = V30_LEGACY_PALETTES[updatedModel.chartThemeName] || updatedModel.chartThemeName;
    return {
        ...updatedModel,
        chartThemeName: chartThemeName
    };
}
function $5b7ccabde48fae90$var$migrateV32(model) {
    model = $5b7ccabde48fae90$var$jsonMutateProperty("chartOptions.*.autoSize", true, model, (parent, targetProp)=>{
        if (parent[targetProp] === true) ;
        else if (parent[targetProp] === false) {
            parent["minHeight"] = 600;
            parent["minWidth"] = 300;
        }
        delete parent[targetProp];
    });
    return model;
}
function $5b7ccabde48fae90$var$migrateV33(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.category.label.format", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.category.crosshair.label.format", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.angle-category.label.format", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.radius-category.label.format", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.*.axes.*.label.padding", "spacing", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.*.navigator.miniChart.label.padding", "spacing", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.*.crossLines.label.className", model);
    model = $5b7ccabde48fae90$var$jsonMutateProperty("chartOptions.*.axes.*.crossLines.label.position", true, model, (parent, targetProp)=>{
        if (typeof parent[targetProp] === "string") parent[targetProp] = parent[targetProp].replace(/([A-Z])/, "-$1").toLowerCase();
    });
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.bullet", model);
    model = $5b7ccabde48fae90$var$jsonRenameEnumValues("chartOptions.bar.series.label.placement", model, {
        inside: "inside-center",
        outside: "inside-end"
    });
    model = $5b7ccabde48fae90$var$jsonRenameEnumValues("chartOptions.waterfall.series.item.*.label.placement", model, {
        inside: "inside-center",
        start: "outside-start",
        end: "outside-end"
    });
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.navigator.min", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.navigator.max", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.zoom.ratioX", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.zoom.ratioY", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.zoom.rangeX", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.zoom.rangeY", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV34(model) {
    const highlightUpdate = (parent, targetProp)=>{
        const highlightStyle = parent[targetProp];
        if (highlightStyle == null) return;
        const highlight = {};
        if (highlightStyle.item) highlight.highlightedItem = highlightStyle.item;
        if (highlightStyle.series) {
            const { dimOpacity: dimOpacity, ...seriesOpts } = highlightStyle.series;
            if (dimOpacity != null) highlight.unhighlightedSeries = {
                opacity: dimOpacity
            };
            if (Object.keys(seriesOpts).length > 0) highlight.highlightedSeries = seriesOpts;
        }
        delete parent[targetProp];
        parent.highlight = highlight;
    };
    $5b7ccabde48fae90$var$jsonMutateProperty("chartOptions.series[].highlightStyle", true, model, highlightUpdate);
    return model;
}
function $5b7ccabde48fae90$var$cleanup(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.width", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.height", model);
    model = $5b7ccabde48fae90$var$jsonBackfill("chartOptions.*.axes.category.label.autoRotate", true, model);
    return model;
}
function $5b7ccabde48fae90$var$heuristicVersionDetection(model) {
    const modelAny = model;
    if (model.version != null) return model.version;
    const hasKey = (obj, ...keys)=>{
        return Object.keys(obj || {}).some((k)=>keys.includes(k));
    };
    const chartOptions = modelAny.chartOptions;
    const seriesOptions = hasKey(chartOptions, "seriesDefaults") ? chartOptions?.seriesDefaults : chartOptions?.[Object.keys(chartOptions)[0]];
    const hints = {
        "27.0.0": hasKey(modelAny, "seriesChartTypes"),
        "26.2.0": !hasKey(chartOptions, "seriesDefaults"),
        "26.1.0": hasKey(seriesOptions?.highlightStyle, "item"),
        "26.0.0": hasKey(seriesOptions?.highlightStyle, "series"),
        // '26.0.0': modelAny.chart === undefined,
        "25.1.0": hasKey(seriesOptions?.label, "minAngle"),
        "25.0.0": hasKey(modelAny, "modelType", "aggFunc", "unlinkChart", "suppressChartRanges") || hasKey(seriesOptions, "lineDash", "lineDashOffset"),
        "24.0.0": hasKey(modelAny, "chartThemeName", "chart") || hasKey(chartOptions, "series"),
        "23.2.0": hasKey(chartOptions, "navigator"),
        "23.0.0": hasKey(chartOptions?.legend?.item?.marker, "shape"),
        "22.1.0": hasKey(modelAny, "chartPalette", "chartType")
    };
    const defaultVersion = "27.1.0";
    const matchingHints = Object.entries(hints).filter(([_, match])=>match);
    if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
        heuristicVersionCandidates: matchingHints
    });
    const [heuristicVersion = defaultVersion] = matchingHints[0];
    if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
        heuristicVersion: heuristicVersion
    });
    return heuristicVersion;
}
function $5b7ccabde48fae90$var$migrateIfBefore(maxVersion, model, migration) {
    if ($5b7ccabde48fae90$var$versionNumber(maxVersion) > $5b7ccabde48fae90$var$versionNumber(model.version)) {
        if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
            migratingTo: maxVersion
        });
        const result = migration(model);
        result.version = maxVersion;
        if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
            migratedTo: maxVersion,
            result: result
        });
        return result;
    }
    return model;
}
function $5b7ccabde48fae90$var$versionParts(versionRaw) {
    const version = versionRaw.includes("-beta") ? versionRaw.replace(/-beta.*/, "") : versionRaw;
    const split = typeof version === "string" ? version.split(".").map((v)=>Number(v)) : [];
    if (split.length !== 3 || split.some((v)=>isNaN(v))) throw new Error((0, $437b23f6a393c3bf$export$680bb5102fca525e)(253, {
        version: version
    }));
    return {
        major: split[0],
        minor: split[1],
        patch: split[2]
    };
}
function $5b7ccabde48fae90$var$versionNumber(version) {
    const { major: major, minor: minor, patch: patch } = $5b7ccabde48fae90$var$versionParts(version);
    return major * 1e4 + minor * 100 + patch;
}
function $5b7ccabde48fae90$var$jsonDeleteDefault(path, defaultValue, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, true, json, (parent, prop)=>{
        if (parent[prop] === defaultValue) delete parent[prop];
    });
}
function $5b7ccabde48fae90$var$jsonBackfill(path, defaultValue, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, false, json, (parent, prop)=>{
        if (parent[prop] == null) parent[prop] = defaultValue;
    });
}
function $5b7ccabde48fae90$var$jsonAdd(path, value, json) {
    if (typeof path === "string") path = path.split(".");
    const nextPath = path[0];
    if (path.length > 1) json[nextPath] = $5b7ccabde48fae90$var$jsonAdd(path.slice(1), value, json[nextPath] ?? {});
    const hasProperty = Object.keys(json).includes(nextPath);
    if (!hasProperty) json[nextPath] = value;
    return json;
}
function $5b7ccabde48fae90$var$jsonMove(from, to, json) {
    let valueToMove = void 0;
    let valueFound = false;
    json = $5b7ccabde48fae90$var$jsonMutateProperty(from, true, json, (parent, prop)=>{
        valueFound = true;
        valueToMove = parent[prop];
        delete parent[prop];
    });
    if (!valueFound) return json;
    return $5b7ccabde48fae90$var$jsonMutateProperty(to, false, json, (parent, prop)=>{
        parent[prop] = valueToMove;
    });
}
function $5b7ccabde48fae90$var$jsonMoveIfMissing(from, to, json) {
    let valueToMove = void 0;
    let valueFound = false;
    json = $5b7ccabde48fae90$var$jsonMutateProperty(from, true, json, (parent, prop)=>{
        valueFound = true;
        valueToMove = parent[prop];
        delete parent[prop];
    });
    if (!valueFound) return json;
    return $5b7ccabde48fae90$var$jsonMutateProperty(to, false, json, (parent, prop)=>{
        if (parent[prop] === void 0) parent[prop] = valueToMove;
    });
}
function $5b7ccabde48fae90$var$jsonRename(path, renameTo, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, true, json, (parent, prop)=>{
        parent[renameTo] = parent[prop];
        delete parent[prop];
    });
}
function $5b7ccabde48fae90$var$jsonDelete(path, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, true, json, (parent, prop)=>delete parent[prop]);
}
function $5b7ccabde48fae90$var$jsonMutateProperty(path, skipMissing, json, mutator) {
    const pathElements = path instanceof Array ? path : path.split(".");
    const parentPathElements = pathElements.slice(0, pathElements.length - 1);
    const targetName = pathElements[pathElements.length - 1];
    return $5b7ccabde48fae90$var$jsonMutate(parentPathElements, json, (parent)=>{
        const hasProperty = Object.keys(parent).includes(targetName);
        if (skipMissing && !hasProperty) return parent;
        const result = {
            ...parent
        };
        mutator(result, targetName);
        return result;
    });
}
function $5b7ccabde48fae90$var$jsonMutate(path, json, mutator) {
    const pathElements = path instanceof Array ? path : path.split(".");
    json = {
        ...json
    };
    if (pathElements.length === 0) return mutator(json);
    else if (pathElements[0].startsWith("{")) {
        const pathOptions = pathElements[0].substring(1, pathElements[0].lastIndexOf("}")).split(",");
        for (const pathOption of pathOptions)if (json[pathOption] != null) json[pathOption] = $5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), json[pathOption], mutator);
    } else if (pathElements[0].endsWith("[]")) {
        const arrayName = pathElements[0].substring(0, path[0].indexOf("["));
        if (json[arrayName] instanceof Array) json[arrayName] = json[arrayName].map((v)=>$5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), v, mutator));
    } else if (pathElements[0] === "*") for (const jsonProp of Object.keys(json))json[jsonProp] = $5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), json[jsonProp], mutator);
    else if (json[pathElements[0]] != null) json[pathElements[0]] = $5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), json[pathElements[0]], mutator);
    return json;
}
function $5b7ccabde48fae90$var$jsonRenameEnumValues(path, json, values) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, true, json, (parent, targetProp)=>{
        if (typeof parent[targetProp] === "string") parent[targetProp] = values[targetProp] ?? targetProp;
    });
}
var $5b7ccabde48fae90$var$merge = (r, n)=>({
        ...r,
        ...n
    });
// packages/ag-grid-enterprise/src/charts/chartService.ts
var $5b7ccabde48fae90$var$ChartService = class extends (0, $437b23f6a393c3bf$export$2032c8ef3788dfbd) {
    constructor(){
        super(...arguments);
        this.beanName = "chartSvc";
        // we destroy all charts bound to this grid when grid is destroyed. activeCharts contains all charts, including
        // those in developer provided containers.
        this.activeCharts = /* @__PURE__ */ new Set();
        this.activeChartComps = /* @__PURE__ */ new Set();
        // this shared (singleton) context is used by cross filtering in line and area charts
        this.crossFilteringContext = {
            lastSelectedChartId: ""
        };
        this.isEnterprise = ()=>this.agChartsExports.isEnterprise;
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.rangeSvc = beans.rangeSvc;
        this.agChartsExports = beans.agChartsExports;
    }
    updateChart(params) {
        if (this.activeChartComps.size === 0) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(124);
            return;
        }
        const chartComp = [
            ...this.activeChartComps
        ].find((chartComp2)=>chartComp2.getChartId() === params.chartId);
        if (!chartComp) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(125, {
                chartId: params.chartId
            });
            return;
        }
        chartComp.update(params);
    }
    getChartModels() {
        const models = [];
        const versionedModel = (c)=>{
            return {
                ...c,
                version: $5b7ccabde48fae90$var$VERSION
            };
        };
        for (const c of this.activeChartComps)models.push(versionedModel(c.getChartModel()));
        return models;
    }
    getChartRef(chartId) {
        let chartRef;
        for (const cr of this.activeCharts)if (cr.chartId === chartId) chartRef = cr;
        return chartRef;
    }
    getChartComp(chartId) {
        let chartComp;
        for (const comp of this.activeChartComps)if (comp.getChartId() === chartId) chartComp = comp;
        return chartComp;
    }
    getChartImageDataURL(params) {
        let url;
        for (const c of this.activeChartComps)if (c.getChartId() === params.chartId) url = c.getChartImageDataURL(params.fileFormat);
        return url;
    }
    downloadChart(params) {
        const chartComp = Array.from(this.activeChartComps).find((c)=>c.getChartId() === params.chartId);
        chartComp?.downloadChart(params.dimensions, params.fileName, params.fileFormat);
    }
    openChartToolPanel(params) {
        const chartComp = Array.from(this.activeChartComps).find((c)=>c.getChartId() === params.chartId);
        chartComp?.openChartToolPanel(params.panel);
    }
    closeChartToolPanel(chartId) {
        const chartComp = Array.from(this.activeChartComps).find((c)=>c.getChartId() === chartId);
        chartComp?.closeChartToolPanel();
    }
    createChartFromCurrentRange(chartType = "groupedColumn", fromApi) {
        const cellRange = this.getSelectedRange();
        return this.createChart({
            cellRange: cellRange,
            chartType: chartType,
            focusDialogOnOpen: !fromApi
        });
    }
    restoreChart(model, chartContainer) {
        if (!model) {
            (0, $437b23f6a393c3bf$export$545083624300f13d)(126);
            return;
        }
        if (model.version !== $5b7ccabde48fae90$var$VERSION) model = $5b7ccabde48fae90$var$upgradeChartModel(model);
        let cellRange;
        let pivotChart;
        let suppressChartRanges;
        let chartPaletteToRestore;
        if (model.modelType === "pivot") {
            this.gos.updateGridOptions({
                options: {
                    pivotMode: true
                },
                source: "pivotChart"
            });
            cellRange = this.createCellRange(void 0, true);
            pivotChart = true;
            suppressChartRanges = true;
        } else {
            cellRange = this.createCellRange(model.cellRange);
            chartPaletteToRestore = model.chartPalette;
            suppressChartRanges = model.suppressChartRanges;
        }
        if (!cellRange) return;
        return this.createChart({
            ...model,
            cellRange: cellRange,
            pivotChart: pivotChart,
            suppressChartRanges: suppressChartRanges,
            chartContainer: chartContainer,
            chartOptionsToRestore: model.chartOptions,
            chartPaletteToRestore: chartPaletteToRestore
        });
    }
    createRangeChart(params, fromApi) {
        const cellRange = this.createCellRange(params.cellRange);
        if (!cellRange) return;
        return this.createChart({
            ...params,
            cellRange: cellRange,
            focusDialogOnOpen: !fromApi
        });
    }
    createPivotChart(params, fromApi) {
        this.gos.updateGridOptions({
            options: {
                pivotMode: true
            },
            source: "pivotChart"
        });
        const cellRange = this.createCellRange(void 0, true);
        if (!cellRange) return;
        return this.createChart({
            ...params,
            cellRange: cellRange,
            pivotChart: true,
            suppressChartRanges: true,
            focusDialogOnOpen: !fromApi
        });
    }
    createCrossFilterChart(params, fromApi) {
        const cellRange = this.createCellRange(params.cellRange);
        if (!cellRange) return;
        const suppressChartRangesSupplied = typeof params.suppressChartRanges !== "undefined" && params.suppressChartRanges !== null;
        const suppressChartRanges = suppressChartRangesSupplied ? params.suppressChartRanges : true;
        return this.createChart({
            ...params,
            cellRange: cellRange,
            suppressChartRanges: suppressChartRanges,
            crossFiltering: true,
            crossFilteringSort: params.sort,
            focusDialogOnOpen: !fromApi
        });
    }
    createChart(params) {
        const validationResult = $5b7ccabde48fae90$var$validateCreateParams(params, this.agChartsExports.isEnterprise);
        if (!validationResult) return void 0;
        params = validationResult === true ? params : validationResult;
        const { chartType: chartType, chartContainer: chartContainer } = params;
        const createChartContainerFunc = this.gos.getCallback("createChartContainer");
        const gridChartParams = {
            ...params,
            chartId: this.generateId(),
            chartType: $5b7ccabde48fae90$var$getCanonicalChartType(chartType),
            insideDialog: !(chartContainer || createChartContainerFunc),
            crossFilteringContext: this.crossFilteringContext,
            crossFilteringResetCallback: ()=>{
                for (const c of this.activeChartComps)c.crossFilteringReset();
            }
        };
        const chartComp = new $5b7ccabde48fae90$var$GridChartComp(gridChartParams);
        this.createBean(chartComp);
        const chartRef = this.createChartRef(chartComp);
        if (chartContainer) chartContainer.appendChild(chartRef.chartElement);
        else if (createChartContainerFunc) createChartContainerFunc(chartRef);
        else chartComp.addEventListener("destroyed", ()=>{
            this.activeChartComps.delete(chartComp);
            this.activeCharts.delete(chartRef);
        });
        return chartRef;
    }
    createChartRef(chartComp) {
        const chartRef = {
            destroyChart: ()=>{
                if (this.activeCharts.has(chartRef)) {
                    this.destroyBean(chartComp);
                    this.activeChartComps.delete(chartComp);
                    this.activeCharts.delete(chartRef);
                }
            },
            focusChart: ()=>{
                (0, $437b23f6a393c3bf$export$8598088d375f416f)(chartComp.getGui());
            },
            chartElement: chartComp.getGui(),
            chart: chartComp.getUnderlyingChart(),
            chartId: chartComp.getChartModel().chartId,
            setMaximized: chartComp.setMaximized.bind(chartComp)
        };
        this.activeCharts.add(chartRef);
        this.activeChartComps.add(chartComp);
        return chartRef;
    }
    getSelectedRange() {
        const ranges = this.rangeSvc?.getCellRanges();
        if (!ranges || ranges.length === 0) return {
            columns: []
        };
        const uCols = /* @__PURE__ */ new Set();
        let startRowIndex = Number.MAX_VALUE;
        let endRowIndex = -Number.MAX_VALUE;
        for (const { startRow: sr, endRow: er, columns: cols } of ranges){
            if (!(sr && er)) continue;
            for (const col of cols)uCols.add(col);
            let { rowIndex: sRowIndex, rowPinned: startRowPinned } = sr;
            let { rowIndex: eRowIndex, rowPinned: endRowPinned } = er;
            if (startRowPinned === "top") {
                if (endRowPinned === "top") continue;
                sRowIndex = 0;
            }
            if (endRowPinned === "bottom") {
                if (startRowPinned === "bottom") continue;
                eRowIndex = this.beans.pageBounds.getLastRow();
            }
            if (sRowIndex !== void 0) startRowIndex = Math.min(startRowIndex, sRowIndex);
            if (eRowIndex !== void 0) endRowIndex = Math.max(endRowIndex, eRowIndex);
        }
        if (startRowIndex === Number.MAX_VALUE || endRowIndex === -Number.MAX_VALUE) return {
            columns: []
        };
        const columns = Array.from(uCols);
        return {
            columns: // Don't specify id here, as it should be chart-specific
            // but we don't have that context yet
            columns,
            startColumn: columns[0],
            startRow: {
                rowIndex: startRowIndex,
                rowPinned: void 0
            },
            endRow: {
                rowIndex: endRowIndex,
                rowPinned: void 0
            }
        };
    }
    generateId() {
        return `id-${Math.random().toString(36).substring(2, 18)}`;
    }
    createCellRange(cellRangeParams, allRange) {
        const rangeParams = allRange ? {
            rowStartIndex: null,
            rowStartPinned: void 0,
            rowEndIndex: null,
            rowEndPinned: void 0,
            columns: this.visibleCols.allCols.map((col)=>col.getColId())
        } : cellRangeParams;
        const cellRange = rangeParams && this.rangeSvc?.createPartialCellRangeFromRangeParams(rangeParams, true);
        if (!cellRange) (0, $437b23f6a393c3bf$export$545083624300f13d)(127, {
            allRange: allRange
        });
        return cellRange;
    }
    destroy() {
        for (const chart of this.activeCharts)chart.destroyChart();
        super.destroy();
    }
};
// packages/ag-grid-enterprise/src/charts/chartsApi.ts
function $5b7ccabde48fae90$var$getChartModels(beans) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.getChartModels());
}
function $5b7ccabde48fae90$var$getChartRef(beans, chartId) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.getChartRef(chartId));
}
function $5b7ccabde48fae90$var$getChartImageDataURL(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.getChartImageDataURL(params));
}
function $5b7ccabde48fae90$var$downloadChart(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.downloadChart(params));
}
function $5b7ccabde48fae90$var$openChartToolPanel(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.openChartToolPanel(params));
}
function $5b7ccabde48fae90$var$closeChartToolPanel(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.closeChartToolPanel(params.chartId));
}
function $5b7ccabde48fae90$var$createRangeChart(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.createRangeChart(params, true));
}
function $5b7ccabde48fae90$var$createPivotChart(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.createPivotChart(params, true));
}
function $5b7ccabde48fae90$var$createCrossFilterChart(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.createCrossFilterChart(params, true));
}
function $5b7ccabde48fae90$var$updateChart(beans, params) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.updateChart(params));
}
function $5b7ccabde48fae90$var$restoreChart(beans, chartModel, chartContainer) {
    return beans.frameworkOverrides.wrapIncoming(()=>beans.chartSvc?.restoreChart(chartModel, chartContainer));
}
// packages/ag-grid-enterprise/src/charts/integratedChartsModule.css-GENERATED.ts
var $5b7ccabde48fae90$var$integratedChartsModuleCSS = /*css*/ `.ag-chart{display:flex;height:100%;position:relative;width:100%}.ag-chart-components-wrapper{display:flex}.ag-chart-canvas-wrapper,.ag-chart-components-wrapper{flex:1 1 auto;position:relative}.ag-chart-menu{background:var(--ag-background-color);background-color:color-mix(in srgb,transparent,var(--ag-background-color) 30%);border-radius:var(--ag-border-radius);display:flex;flex-direction:row;gap:20px;padding:4px 2px;position:absolute;top:8px;width:auto;--ag-icon-size:20px}:where(.ag-ltr) .ag-chart-menu{justify-content:right;right:calc(var(--ag-cell-horizontal-padding) + var(--ag-spacing) - 4px)}:where(.ag-rtl) .ag-chart-menu{justify-content:left;left:calc(var(--ag-cell-horizontal-padding) + var(--ag-spacing) - 4px)}.ag-chart-docked-container{min-width:var(--ag-chart-menu-panel-width);position:relative}:where(.ag-chart-menu-hidden)~.ag-chart-docked-container{display:none}.ag-chart-tabbed-menu{display:flex;flex-direction:column;height:100%;overflow:hidden;width:100%}.ag-chart-tabbed-menu-header{cursor:default;flex:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-chart-tabbed-menu-body{align-items:stretch;display:flex;flex:1 1 auto;overflow:hidden;position:relative;&:after{background:linear-gradient(var(--ag-background-color),transparent);content:"";display:block;height:16px;left:0;position:absolute;right:0;top:0}}.ag-chart-tab{overflow:hidden;overflow-y:auto;width:100%}.ag-chart-settings{overflow-x:hidden}.ag-chart-settings-wrapper{display:flex;flex-direction:column;height:100%;overflow:hidden;position:relative;width:100%}.ag-chart-settings-nav-bar{align-items:center;border-top:solid var(--ag-border-width) var(--ag-border-color);display:flex;height:30px;padding:0 10px;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}.ag-chart-settings-card-selector{align-items:center;display:flex;flex:1 1 auto;height:100%;justify-content:space-around;padding:0 10px}.ag-chart-settings-card-item{background-color:var(--ag-foreground-color);border-radius:4px;cursor:pointer;height:8px;position:relative;width:8px;&.ag-not-selected{opacity:.2}&:before{background-color:transparent;content:" ";display:block;height:20px;left:50%;margin-left:-10px;margin-top:-10px;position:absolute;top:50%;width:20px}&.ag-selected{background-color:var(--ag-accent-color)}}.ag-chart-settings-next,.ag-chart-settings-prev{flex:none;position:relative;&:focus-within{border-radius:1px;box-shadow:var(--ag-focus-shadow)}}.ag-chart-settings-next-button,.ag-chart-settings-prev-button{cursor:pointer;height:100%;left:0;opacity:0;position:absolute;top:0;width:100%}.ag-chart-settings-mini-charts-container{flex:1 1 auto;overflow:hidden auto;position:relative}.ag-chart-settings-mini-wrapper{display:flex;flex-direction:column;left:0;min-height:100%;overflow:hidden;padding-bottom:var(--ag-widget-container-vertical-padding);position:absolute;top:0;width:100%;&.ag-animating{transition:left .3s;transition-timing-function:ease-in-out}}.ag-chart-mini-thumbnail{border:solid var(--ag-border-width) var(--ag-border-color);border-radius:5px;cursor:pointer;padding:1px;&.ag-selected{border-color:var(--ag-accent-color);border-width:calc(var(--ag-border-width) + 1px);padding:unset}&:focus-visible{border-color:var(--ag-accent-color);box-shadow:var(--ag-focus-shadow)}}.ag-chart-mini-thumbnail-canvas{display:block}.ag-chart-advanced-settings-wrapper,.ag-chart-data-wrapper,.ag-chart-format-wrapper{display:flex;flex-direction:column;padding-bottom:16px;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-chart-advanced-settings-wrapper,.ag-chart-data-wrapper{height:100%;overflow-y:auto}.ag-chart-advanced-settings{background-color:var(--ag-chrome-background-color)}.ag-chart-advanced-settings,.ag-chart-advanced-settings-wrapper{width:100%}.ag-chart-advanced-settings-wrapper{padding-bottom:0}.ag-chart-advanced-settings-section{border-bottom:solid var(--ag-border-width) var(--ag-border-color);display:flex;margin:0;padding-bottom:var(--ag-widget-container-vertical-padding);padding-top:var(--ag-widget-container-vertical-padding)}.ag-chart-empty-text{align-items:center;background-color:var(--ag-background-color);display:flex;height:100%;justify-content:center;top:0;width:100%}.ag-charts-font-size-color{align-self:stretch;display:flex;justify-content:space-between}.ag-chart-menu-icon{border-radius:var(--ag-border-radius);cursor:pointer;margin:2px 0;opacity:.8;&:hover{opacity:1}}.ag-chart-menu-toolbar-button{background-color:unset;border:0;border-radius:1px;padding:0 2px}.ag-chart-data-column-drag-handle{margin-left:var(--ag-spacing)}.ag-chart-data-section,.ag-chart-format-section{display:flex;margin:0;:where(.ag-label:not(.ag-group-title-bar)){color:var(--ag-chart-menu-label-color)}:where(.ag-label-align-top .ag-label){margin-bottom:var(--ag-widget-vertical-spacing);margin-top:calc(var(--ag-widget-vertical-spacing)*.5)}:where(.ag-slider.ag-label-align-top .ag-label){margin-bottom:0}:where(label){display:inline-block}}.ag-chart-menu-panel{--ag-panel-background-color:var(--ag-chrome-background-color)}:where(.ag-ltr) .ag-chart-menu-panel{border-left:solid var(--ag-border-width) var(--ag-border-color)}:where(.ag-rtl) .ag-chart-menu-panel{border-right:solid var(--ag-border-width) var(--ag-border-color)}.ag-chart-data-wrapper,.ag-chart-format-wrapper{margin:0;padding:0}.ag-group{.ag-charts-data-group-item{padding-bottom:var(--ag-widget-container-vertical-padding);position:relative}.ag-charts-data-group-item:where(:not(:last-child)){margin-bottom:var(--ag-spacing)}.ag-charts-advanced-settings-top-level-group-title-bar{background-color:unset;position:relative}.ag-charts-data-group-item:where(:not(.ag-charts-format-sub-level-group,.ag-pill-select,.ag-select)){height:var(--ag-list-item-height)}.ag-charts-data-group-item:where(.ag-picker-field){margin-top:var(--ag-spacing)}.ag-charts-advanced-settings-top-level-group-item,.ag-charts-format-top-level-group-item{margin:var(--ag-spacing) 0}.ag-charts-format-sub-level-group-container{display:flex;flex-direction:column;padding:var(--ag-widget-vertical-spacing) 0}.ag-charts-settings-group-container{border-top:none;display:grid;font-weight:500;grid-template-columns:60px 1fr 60px 1fr 60px;row-gap:8px;:where(.ag-chart-mini-thumbnail:nth-child(3n+1)){grid-column:1}:where(.ag-chart-mini-thumbnail:nth-child(3n+2)){grid-column:3}:where(.ag-chart-mini-thumbnail:nth-child(3n+3)){grid-column:5}}.ag-charts-data-group-title-bar,.ag-charts-format-top-level-group-title-bar,.ag-charts-settings-group-title-bar{border-top:none;font-weight:500;margin:0;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:relative}.ag-charts-format-sub-level-group-title-bar{background:none;font-weight:500;padding:var(--ag-widget-vertical-spacing) 0}&.ag-charts-format-sub-level-group,&.ag-charts-format-top-level-group,.ag-charts-format-sub-level-group-container>*,.ag-charts-format-sub-level-group-item:last-child,.ag-charts-format-top-level-group-item{margin:0;padding:0}&.ag-charts-data-group,&.ag-charts-format-top-level-group{border-top:solid var(--ag-border-width) var(--ag-border-color)}.ag-charts-data-group-container,.ag-charts-format-top-level-group-container,.ag-charts-settings-group-container{margin:0;padding:0 var(--ag-widget-container-horizontal-padding)}.ag-charts-format-sub-level-group-container>*,.ag-charts-format-sub-level-no-header-group-container>*,.ag-charts-format-top-level-group-container>*{margin-bottom:var(--ag-widget-vertical-spacing)}.ag-charts-advanced-settings-top-level-group-container{margin:0}.ag-charts-advanced-settings-top-level-group-container,.ag-charts-advanced-settings-top-level-group-title-bar{padding:0 var(--ag-widget-container-horizontal-padding)}.ag-charts-advanced-settings-top-level-group-item{margin-bottom:0;margin-top:calc(var(--ag-widget-vertical-spacing)*2)}}.ag-chart-settings-card-item.ag-not-selected:hover{opacity:.35}.ag-angle-select{align-items:center;display:flex}.ag-angle-select-wrapper{display:flex}.ag-angle-select-parent-circle{background-color:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:12px;display:block;height:24px;position:relative;width:24px}.ag-angle-select-child-circle{background-color:var(--ag-foreground-color);border-radius:3px;height:6px;left:12px;margin-left:-3px;margin-top:-4px;position:absolute;top:4px;width:6px}.ag-slider-wrapper{display:flex;:where(.ag-input-field){flex:1 1 auto}}.ag-color-panel{display:flex;flex-direction:column;padding:var(--ag-spacing);text-align:center;width:100%}.ag-spectrum-color{cursor:default;flex:1 1 auto;overflow:visible;position:relative}.ag-spectrum-color,.ag-spectrum-fill{border-radius:var(--ag-border-radius)}.ag-spectrum-fill{inset:0;position:absolute}.ag-spectrum-val{background-image:linear-gradient(0deg,#000,hsla(20,42%,65%,0));cursor:pointer}.ag-spectrum-dragger{background:#000;border:var(--ag-color-picker-thumb-border-width) solid #fff;border-radius:var(--ag-color-picker-thumb-size);box-shadow:0 0 2px 0 rgba(0,0,0,.24);cursor:pointer;height:var(--ag-color-picker-thumb-size);pointer-events:none;position:absolute;width:var(--ag-color-picker-thumb-size)}.ag-spectrum-alpha,.ag-spectrum-hue{cursor:default}.ag-spectrum-hue-background{background:linear-gradient(270deg,red 3%,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red);height:100%;width:100%}.ag-spectrum-alpha-background{background:linear-gradient(to right,var(--ag-internal-spectrum-alpha-color-from),var(--ag-internal-spectrum-alpha-color-to)),url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="4" height="4"><rect x="0" y="0" width="4" height="4" fill="%23fff"/><path d="M0 0H2V4H4V2H0Z" fill="%23b2b2b2"/></svg>') 0 0 /4px 4px;height:100%;width:100%}.ag-spectrum-tool{cursor:pointer;height:var(--ag-color-picker-track-size);margin-bottom:10px;position:relative}.ag-spectrum-slider,.ag-spectrum-tool{border-radius:var(--ag-color-picker-thumb-size)}.ag-spectrum-slider{border:var(--ag-color-picker-thumb-border-width) solid #fff;box-shadow:0 1px 4px 0 rgba(0,0,0,.37);height:var(--ag-color-picker-thumb-size);margin-top:calc(var(--ag-color-picker-track-size)/2*-1 + var(--ag-color-picker-thumb-size)/2*-1);pointer-events:none;position:absolute;width:var(--ag-color-picker-thumb-size)}:where(.ag-spectrum-alpha) .ag-spectrum-slider{background:linear-gradient(to bottom,var(--ag-internal-spectrum-alpha-color),var(--ag-internal-spectrum-alpha-color)) var(--ag-background-color)}.ag-recent-colors{display:flex;gap:6px;margin:10px var(--ag-spacing) 2px}.ag-recent-color{border:solid var(--ag-border-width) var(--ag-border-color);cursor:pointer}.ag-angle-select[disabled]{opacity:.5;pointer-events:none}:where(.ag-ltr) .ag-angle-select-field,:where(.ag-ltr) .ag-slider-field{margin-right:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-angle-select-field,:where(.ag-rtl) .ag-slider-field{margin-left:calc(var(--ag-spacing)*2)}.ag-color-dialog{border-radius:5px}:where(.ag-color-picker){.ag-picker-field-wrapper{padding-left:var(--ag-spacing);padding-right:var(--ag-spacing)}.ag-picker-field-display{align-items:center;display:flex;flex-direction:row;min-height:var(--ag-list-item-height)}}:where(.ag-ltr) .ag-color-picker-color,:where(.ag-ltr) .ag-color-picker-value{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-color-picker-color,:where(.ag-rtl) .ag-color-picker-value{margin-left:var(--ag-spacing)}.ag-spectrum-tools{padding:10px 0 0}.ag-spectrum-alpha-background,.ag-spectrum-hue-background{border-radius:var(--ag-color-picker-track-border-radius)}.ag-color-input-color,.ag-color-picker-color,.ag-recent-color{border-radius:var(--ag-color-picker-color-border-radius)}.ag-spectrum-sat{background-image:linear-gradient(90deg,#fff,hsla(20,42%,65%,0))}.ag-recent-color,.ag-spectrum-color,.ag-spectrum-slider{&:where(:not(:disabled,[readonly])):focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-color-input-color,.ag-color-picker-color{border:solid var(--ag-border-width) var(--ag-border-color);height:var(--ag-icon-size);width:var(--ag-icon-size)}:where(.ag-ltr) .ag-color-input .ag-input-field-input{padding-left:calc(var(--ag-icon-size) + var(--ag-spacing)*2)}:where(.ag-rtl) .ag-color-input .ag-input-field-input{padding-right:calc(var(--ag-icon-size) + var(--ag-spacing)*2)}:where(.ag-color-input) .ag-color-input-color{position:absolute}:where(.ag-ltr) :where(.ag-color-input) .ag-color-input-color{margin-left:var(--ag-spacing)}:where(.ag-rtl) :where(.ag-color-input) .ag-color-input-color{margin-right:var(--ag-spacing)}.ag-range-field{align-items:center;display:flex;:where(.ag-input-wrapper){height:100%}}.ag-range-field-input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;height:100%;overflow:visible;padding:0;width:100%;&:disabled{opacity:.5}}.ag-range-field-input{&::-webkit-slider-runnable-track{background-color:var(--ag-border-color);border-radius:1.5px;height:3px;margin:0;padding:0;width:100%}&::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background-color:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:100%;height:var(--ag-icon-size);margin:0;padding:0;transform:translateY(calc(var(--ag-icon-size)*-.5 + 1.5px));width:var(--ag-icon-size)}&:focus::-webkit-slider-thumb{border-color:var(--ag-accent-color);box-shadow:var(--ag-focus-shadow)}&:active::-webkit-slider-runnable-track{background-color:var(--ag-accent-color)}}.ag-range-field-input{&::-moz-range-track{background-color:var(--ag-border-color);border-radius:1.5px;height:3px;margin:0;padding:0;width:100%}&::-moz-ag-range-thumb{-moz-appearance:none;appearance:none;background-color:var(--ag-background-color);border:solid var(--ag-border-width) var(--ag-border-color);border-radius:100%;height:var(--ag-icon-size);margin:0;padding:0;transform:translateY(calc(var(--ag-icon-size)*-.5 + 1.5px));width:var(--ag-icon-size)}&:focus::-moz-ag-range-thumb{border-color:var(--ag-accent-color);box-shadow:var(--ag-focus-shadow)}&:active::-moz-ag-range-track{background-color:var(--ag-accent-color)}}`;
// packages/ag-grid-enterprise/src/charts/utils/validGridChartsVersion.ts
var $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION = 28;
var $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION = 6;
function $5b7ccabde48fae90$var$isValidVersion(version) {
    return version?.match(/\d+\.\d+\.\d+/);
}
function $5b7ccabde48fae90$var$isValidMajorVersion({ gridMajorVersion: gridMajorVersion, chartsMajorVersion: chartsMajorVersion }) {
    const gridMajor = parseInt(gridMajorVersion, 10);
    const chartsMajor = parseInt(chartsMajorVersion, 10);
    const gridMajorDifference = gridMajor - $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION;
    const chartsMajorDifference = chartsMajor - $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION;
    const isFirstOrAfterVersion = gridMajorDifference >= 0;
    return gridMajorDifference === chartsMajorDifference && isFirstOrAfterVersion;
}
function $5b7ccabde48fae90$var$gridChartVersion(gridVersion) {
    if (!gridVersion || !$5b7ccabde48fae90$var$isValidVersion(gridVersion)) return void 0;
    const [gridMajor, gridMinor] = gridVersion.split(".") || [];
    const gridMajorMinor = `${gridMajor}.${gridMinor}.x`;
    const gridMajorNumber = parseInt(gridMajor, 10);
    const chartsMajor = gridMajorNumber - $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION + $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION;
    if (chartsMajor < 0) return void 0;
    const chartsMinor = gridMinor;
    const chartsMajorMinor = `${chartsMajor}.${chartsMinor}.x`;
    return {
        gridMajorMinor: gridMajorMinor,
        chartsMajorMinor: chartsMajorMinor
    };
}
function $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({ type: type, gridVersion: gridVersion, chartsVersion: chartsVersion }) {
    const invalidMessage = "AG Grid: AG Grid version is incompatible. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.";
    if (!gridVersion) return invalidMessage;
    const version = $5b7ccabde48fae90$var$gridChartVersion(gridVersion);
    if (!version) return invalidMessage;
    const { gridMajorMinor: gridMajorMinor, chartsMajorMinor: chartsMajorMinor } = version;
    if (type === "incompatible") return `AG Grid version ${gridVersion} and AG Charts version ${chartsVersion} is not supported. AG Grid version ${gridMajorMinor} should be used with AG Chart ${chartsMajorMinor}. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.`;
    else if (type === "invalidCharts") return `AG Grid version ${gridMajorMinor} should be used with AG Chart ${chartsMajorMinor} not ${chartsVersion}. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.`;
    return invalidMessage;
}
function $5b7ccabde48fae90$var$validGridChartsVersion({ gridVersion: gridVersion, chartsVersion: chartsVersion }) {
    if (!$5b7ccabde48fae90$var$isValidVersion(chartsVersion)) return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "invalidCharts",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
    if (!$5b7ccabde48fae90$var$isValidVersion(gridVersion)) return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "invalidGrid",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
    const [gridMajor, gridMinor] = gridVersion.split(".") || [];
    const [chartsMajor, chartsMinor, chartsPatch] = chartsVersion.split(".") || [];
    const isValidMajor = $5b7ccabde48fae90$var$isValidMajorVersion({
        gridMajorVersion: gridMajor,
        chartsMajorVersion: chartsMajor
    });
    if (isValidMajor && gridMinor === chartsMinor || chartsPatch.includes("beta")) return {
        isValid: true
    };
    else if (!isValidMajor || gridMinor !== chartsMinor) return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "incompatible",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
    return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "invalid",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
}
// packages/ag-grid-enterprise/src/charts/integratedChartsModule.ts
var $5b7ccabde48fae90$var$icons = {
    // shown on top right of chart when chart is linked to range data (click to unlink)
    linked: "linked",
    // shown on top right of chart when chart is not linked to range data (click to link)
    unlinked: "unlinked",
    // icon to open charts menu
    chartsMenu: "menu-alt",
    // download chart
    chartsDownload: "save",
    // Edit Chart menu item shown in Integrated Charts menu
    chartsMenuEdit: "chart",
    // Advanced Settings menu item shown in Integrated Charts menu
    chartsMenuAdvancedSettings: "settings",
    // shown in Integrated Charts menu add fields
    chartsMenuAdd: "plus",
    // shown in Integrated Charts tool panel color picker
    chartsColorPicker: "small-down",
    // previous in Integrated Charts settings tool panel theme switcher
    chartsThemePrevious: "previous",
    // next in Integrated Charts settings tool panel theme switcher
    chartsThemeNext: "next"
};
var $5b7ccabde48fae90$var$apiFunctions = {
    getChartModels: $5b7ccabde48fae90$var$getChartModels,
    getChartRef: $5b7ccabde48fae90$var$getChartRef,
    getChartImageDataURL: $5b7ccabde48fae90$var$getChartImageDataURL,
    downloadChart: $5b7ccabde48fae90$var$downloadChart,
    openChartToolPanel: $5b7ccabde48fae90$var$openChartToolPanel,
    closeChartToolPanel: $5b7ccabde48fae90$var$closeChartToolPanel,
    createRangeChart: $5b7ccabde48fae90$var$createRangeChart,
    createPivotChart: $5b7ccabde48fae90$var$createPivotChart,
    createCrossFilterChart: $5b7ccabde48fae90$var$createCrossFilterChart,
    updateChart: $5b7ccabde48fae90$var$updateChart,
    restoreChart: $5b7ccabde48fae90$var$restoreChart
};
var $5b7ccabde48fae90$var$dependsOn = [
    $5b7ccabde48fae90$export$6f4ee80b1242642d,
    $5b7ccabde48fae90$var$EnterpriseCoreModule,
    (0, $437b23f6a393c3bf$export$4ad116d131ade5b4),
    (0, $437b23f6a393c3bf$export$da5c9bb998e6c24d),
    $5b7ccabde48fae90$var$MenuItemModule
];
var $5b7ccabde48fae90$var$moduleName2 = "IntegratedCharts";
var $5b7ccabde48fae90$export$6248c9e5743f8c49 = {
    moduleName: "GridCharts",
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: $5b7ccabde48fae90$var$dependsOn,
    // included to avoid other false positive warnings about missing modules
    validate: ()=>{
        return {
            isValid: false,
            message: `AG Grid: As of v33, the "GridChartsModule" has been deprecated. Please use "IntegratedChartsModule.with(...)" instead.
 ${(0, $437b23f6a393c3bf$export$d73cab7876c2c868)(257)}`
        };
    }
};
var $5b7ccabde48fae90$export$31b991579b5608cb = {
    moduleName: $5b7ccabde48fae90$var$moduleName2,
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: $5b7ccabde48fae90$var$dependsOn,
    // included to avoid other false positive warnings about missing modules
    validate: ()=>{
        return {
            isValid: false,
            message: (0, $437b23f6a393c3bf$export$d73cab7876c2c868)(257)
        };
    },
    with: (params)=>{
        params.setup();
        params.setGridContext?.(true);
        if (params.isEnterprise && params.setLicenseKey) {
            const chartsManager = {
                setLicenseKey: params.setLicenseKey
            };
            $5b7ccabde48fae90$var$LicenseManager.setChartsLicenseManager(chartsManager);
        }
        return {
            moduleName: $5b7ccabde48fae90$var$moduleName2,
            version: $5b7ccabde48fae90$var$VERSION,
            icons: $5b7ccabde48fae90$var$icons,
            apiFunctions: $5b7ccabde48fae90$var$apiFunctions,
            dependsOn: $5b7ccabde48fae90$var$dependsOn,
            css: [
                $5b7ccabde48fae90$var$integratedChartsModuleCSS
            ],
            validate: ()=>{
                return $5b7ccabde48fae90$var$validGridChartsVersion({
                    gridVersion: $5b7ccabde48fae90$var$VERSION,
                    chartsVersion: params.VERSION
                });
            },
            beans: [
                // bind the params to the constructor to avoid the need for static properties
                $5b7ccabde48fae90$var$AgChartsExports.bind(null, params),
                $5b7ccabde48fae90$var$ChartService,
                $5b7ccabde48fae90$var$ChartTranslationService,
                $5b7ccabde48fae90$var$ChartCrossFilterService,
                $5b7ccabde48fae90$var$ChartMenuListFactory,
                $5b7ccabde48fae90$var$ChartMenuService,
                // Include enterprise beans for now for all users as tiny compared to charts bundle size
                $5b7ccabde48fae90$var$EnterpriseChartProxyFactory,
                $5b7ccabde48fae90$var$AdvancedSettingsMenuFactory
            ]
        };
    }
};
var $5b7ccabde48fae90$var$dependsOn2 = [
    (0, $437b23f6a393c3bf$export$526323caf9d1af13),
    $5b7ccabde48fae90$export$3a36bd45ca02edda,
    $5b7ccabde48fae90$export$8ff0dc87b3f8200e,
    $5b7ccabde48fae90$export$98f0c53ca0379def,
    $5b7ccabde48fae90$export$783953a68616c0a2,
    $5b7ccabde48fae90$export$5d9e175412b51985,
    $5b7ccabde48fae90$export$656cedc46227f6d2,
    $5b7ccabde48fae90$export$af7cdc2b9a7c9c3,
    $5b7ccabde48fae90$export$30ae2785d49a9f03,
    $5b7ccabde48fae90$export$6f4ee80b1242642d,
    $5b7ccabde48fae90$export$9bd93207561bb9c,
    $5b7ccabde48fae90$export$f0e5f58d7c17c748,
    $5b7ccabde48fae90$export$e67935bd41653107,
    $5b7ccabde48fae90$export$60c70655af65b0f1,
    $5b7ccabde48fae90$export$aca1637eb4e24373,
    $5b7ccabde48fae90$export$5c0e9f044c5e2dce,
    $5b7ccabde48fae90$export$208b04021c462957,
    $5b7ccabde48fae90$export$73682ece87e2337a,
    $5b7ccabde48fae90$export$4ab172eba3fdda9e,
    $5b7ccabde48fae90$export$8897e17f4dd9d13a,
    $5b7ccabde48fae90$export$5f40a5e44930bd02,
    $5b7ccabde48fae90$export$707a9bd30915b7fe,
    $5b7ccabde48fae90$export$76a316c8c2f3bc28,
    $5b7ccabde48fae90$export$5afa3276c0fcf76,
    $5b7ccabde48fae90$export$4fc40ce1b35c05e1,
    $5b7ccabde48fae90$export$3460d687131d67ba,
    $5b7ccabde48fae90$export$3b7f0581dcb7e440,
    $5b7ccabde48fae90$export$3b8008724bbc4e9f,
    $5b7ccabde48fae90$export$8e5f38fcc2e9340c
];
var $5b7ccabde48fae90$var$moduleName3 = "AllEnterprise";
var $5b7ccabde48fae90$export$22e6f186b688d81b = {
    with: (params)=>({
            moduleName: $5b7ccabde48fae90$var$moduleName3,
            version: $5b7ccabde48fae90$var$VERSION,
            dependsOn: [
                ...$5b7ccabde48fae90$var$dependsOn2,
                $5b7ccabde48fae90$export$31b991579b5608cb.with(params),
                $5b7ccabde48fae90$export$4e5a2f3bfb2b8795.with(params)
            ]
        }),
    moduleName: $5b7ccabde48fae90$var$moduleName3,
    version: $5b7ccabde48fae90$var$VERSION,
    dependsOn: $5b7ccabde48fae90$var$dependsOn2
};


const $616aa345b7ff1396$export$22856253e0e76a3f = (0, $5b7ccabde48fae90$export$22e6f186b688d81b).version;
class $616aa345b7ff1396$export$4d5f683626bc2ec6 {
    adaptableInstance;
    allAgGridModules = new Set();
    constructor(adaptableInstance){
        this.adaptableInstance = adaptableInstance;
        this.allAgGridModules = this.extractAgGridModuleNames((0, $5b7ccabde48fae90$export$22e6f186b688d81b));
    }
    destroy() {
        this.adaptableInstance = null;
        this.allAgGridModules.clear();
        this.allAgGridModules = null;
    }
    get agGridApi() {
        return this.adaptableInstance.agGridAdapter.getAgGridApi();
    }
    isAgGridModuleRegistered(moduleName) {
        let isModuleRegistered = this.agGridApi.isModuleRegistered(moduleName);
        if (!isModuleRegistered) {
            // SSRM module comes with its own implementations of Pivot, MasterDetail and TreeData
            // #ssrm_pivot_module
            const serverSideDependencies = [
                'PivotModule',
                'MasterDetailModule',
                'TreeDataModule'
            ];
            if (serverSideDependencies.includes(moduleName)) isModuleRegistered = this.agGridApi.isModuleRegistered('ServerSideRowModelModule');
        }
        return isModuleRegistered;
    }
    getAgGridRegisteredModules() {
        const registeredModules = [];
        this.allAgGridModules.forEach((module)=>{
            const agModuleName = `${module.moduleName}Module`;
            if (this.isAgGridModuleRegistered(agModuleName)) registeredModules.push(module);
        });
        return registeredModules;
    }
    getAgGridRegisteredModuleNames() {
        return this.getAgGridRegisteredModules().map((module)=>{
            const agModuleName = `${module.moduleName}Module`;
            return agModuleName;
        });
    }
    getMandatoryAgGridModuleNames() {
        const mandatoryModules = [];
        const rowModelType = this.agGridApi.getGridOption('rowModelType');
        switch(rowModelType){
            case 'serverSide':
                mandatoryModules.push('ServerSideRowModelModule');
                mandatoryModules.push('ServerSideRowModelApiModule');
                break;
            case 'infinite':
                (0, $7cde26aae0840b1a$export$a58502b374804b0f).consoleErrorBase("AdapTable does not support AG Grid's Infinite Row Model");
                break;
            case 'viewport':
                mandatoryModules.push('ViewportRowModelModule');
                break;
            default:
                mandatoryModules.push('ClientSideRowModelModule');
                mandatoryModules.push('ClientSideRowModelApiModule');
        }
        mandatoryModules.push('CellApiModule', 'CellStyleModule', 'ColumnApiModule', 'ColumnMenuModule', 'ContextMenuModule', 'CustomFilterModule', 'EventApiModule', 'ExternalFilterModule', 'GridStateModule', 'GroupFilterModule', 'RenderApiModule', 'RowApiModule', 'RowGroupingModule', 'RowStyleModule', 'ScrollApiModule');
        return mandatoryModules;
    }
    extractAgGridModuleNames(module, collectedModules = new Set()) {
        if (!module || !module.moduleName) return collectedModules;
        collectedModules.add(module);
        if (module.dependsOn) module.dependsOn.forEach((dep)=>{
            this.extractAgGridModuleNames(dep, collectedModules);
        });
        return collectedModules;
    }
}







var $acw62 = parcelRequire("acw62");







const $e87f8546c3d04463$export$f968906200a943b9 = ({ className: className })=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const rerender = (0, $5445b32c0b713891$export$14b855fd280765df)();
    (0, $acw62.useEffect)(()=>{
        return adaptable.api.eventApi.on('AdaptableStateChanged', rerender);
    }, [
        adaptable
    ]);
    const modules = adaptable.ModuleService.getModuleCollection();
    const baseClassName = 'ab-AdaptableObjectsSummary';
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(baseClassName, className)
    }, [
        ...modules
    ].map(([moduleName, module])=>{
        if (!module.isModuleVisible()) return null;
        const items = module?.toViewAll?.();
        if (!items?.length) return null;
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            "data-name": module.moduleInfo.ModuleName,
            className: `${baseClassName}__module-list`,
            key: module.moduleInfo.ModuleName
        }, $acw62.createElement("b", {
            className: `${baseClassName}__header`
        }, module.moduleInfo.FriendlyName), items?.length && $acw62.createElement((0, $e7b071cd434f710e$export$52f2aa84838d2a04), {
            items: items,
            module: module
        }));
    }));
};



const $a59287dd12f4a25c$var$adaptableVersion = (0, $5729c20ddc89490c$export$175d6ab8087f9060);
const $a59287dd12f4a25c$var$agGridVersion = (0, $616aa345b7ff1396$export$22856253e0e76a3f);
const $a59287dd12f4a25c$export$ca8e9f49356b02bc = (props)=>{
    const api = props.api;
    const keyValuePairs = [];
    const calcColumns = api.calculatedColumnApi.getCalculatedColumns().map((c)=>c.ColumnId);
    const actionColumns = api.actionColumnApi.getActionColumns().map((ac)=>ac.columnId);
    const freeTextColumns = api.freeTextColumnApi.getFreeTextColumns().map((c)=>c.ColumnId);
    const columnFilterDescription = api.filterApi.columnFilterApi.columnFiltersToString(api.filterApi.columnFilterApi.getColumnFilters());
    const gridFilterExpression = api.filterApi.gridFilterApi.getCurrentGridFilterExpression();
    const sorts = (0, $9g4SS.default).IsNotNullOrEmpty(props.api.gridApi.getColumnSorts()) ? api.gridApi.getColumnSorts().map((gs)=>{
        return api.columnApi.getFriendlyNameForColumnId(gs.ColumnId) + ': ' + gs.SortOrder;
    }) : null;
    const selectedRowInfo = api.gridApi.getSelectedRowInfo();
    if (api.optionsApi.getUserInterfaceOptions()?.showAdapTableVersion) keyValuePairs.push({
        Key: 'AdapTable Version',
        Value: $a59287dd12f4a25c$var$adaptableVersion
    });
    if (api.optionsApi.getUserInterfaceOptions()?.showAgGridVersion) keyValuePairs.push({
        Key: 'AG Grid Version',
        Value: $a59287dd12f4a25c$var$agGridVersion
    });
    keyValuePairs.push({
        Key: 'Sorted Columns',
        Value: (0, $9g4SS.default).IsNotNullOrEmpty(sorts) ? sorts.join('; ') : 'None'
    });
    keyValuePairs.push({
        Key: 'Column Filters',
        Value: columnFilterDescription
    });
    keyValuePairs.push({
        Key: 'Grid Filter',
        Value: gridFilterExpression
    });
    keyValuePairs.push({
        Key: 'All Rows',
        Value: props.api.gridApi.getRowCount()
    });
    keyValuePairs.push({
        Key: 'Visible Rows',
        Value: props.api.gridApi.getVisibleRowCount()
    });
    keyValuePairs.push({
        Key: 'Selected Rows',
        Value: selectedRowInfo?.gridRows.length
    });
    keyValuePairs.push({
        Key: 'Visible Selected Rows',
        Value: selectedRowInfo?.gridRows.filter((gr)=>gr.rowNode?.displayed == true).length
    });
    keyValuePairs.push({
        Key: 'All Columns',
        Value: props.api.gridApi.getColumnCount()
    });
    keyValuePairs.push({
        Key: 'Visible Columns',
        Value: props.api.gridApi.getVisibleColumnCount()
    });
    keyValuePairs.push({
        Key: 'Calculated Columns',
        Value: (0, $9g4SS.default).IsNotNullOrEmpty(calcColumns) ? (0, $9g4SS.default).createCommaSeparatedString(calcColumns) : 'None'
    });
    keyValuePairs.push({
        Key: 'Free Text Columns',
        Value: (0, $9g4SS.default).IsNotNullOrEmpty(freeTextColumns) ? (0, $9g4SS.default).createCommaSeparatedString(freeTextColumns) : 'None'
    });
    keyValuePairs.push({
        Key: 'CalcuActionlated Columns',
        Value: (0, $9g4SS.default).IsNotNullOrEmpty(actionColumns) ? (0, $9g4SS.default).createCommaSeparatedString(actionColumns) : 'None'
    });
    const domProps = {
        className: 'twa:flex-1 twa:min-h-0 twa:w-full'
    };
    keyValuePairs.map((keyValuePair)=>{
        return {
            Key: keyValuePair.Key,
            Value: keyValuePair.Value === 'Ignore' ? null : keyValuePair.Value
        };
    }).filter((x)=>x.Value);
    const columnsMap = {
        Key: {
            field: 'Key',
            header: 'Property',
            defaultFlex: 1
        },
        Value: {
            field: 'Value',
            header: 'Value',
            defaultFlex: 3
        }
    };
    const baseClassName = 'ab-GridInfo';
    return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(baseClassName),
        headerText: 'Grid Info',
        glyphicon: 'info',
        scrollable: false
    }, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: "twa:flex-1 twa:border-none twa:shadow-md twa:overflow-hidden"
    }, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039).FlexBody, null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:flex-1 twa:min-h-0"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Grid Summary"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Grid State"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
        data: keyValuePairs,
        primaryKey: "Key"
    }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
        domProps: domProps,
        columns: columnsMap
    }))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $e87f8546c3d04463$export$f968906200a943b9), {
        className: "twa:min-h-0 twa:overflow-auto twa:p-2"
    }))))));
};



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $c497b33b688e5695$export$d188a835a7bc5783 = $acw62.createContext({
    availableItems: [],
    permittedActions: {
        createTab: true,
        editTabName: true,
        dragAndDropTab: true,
        deleteTab: true
    }
});



var $acw62 = parcelRequire("acw62");





function $7b9838fe01ae1e93$export$e51a686c67fdaa2d({ tabs: tabs, onRemoveTab: onRemoveTab, onRemoveToolbar: onRemoveToolbar, onChangeTabName: onChangeTabName, disabled: disabled, onNewTab: onNewTab }) {
    return $acw62.createElement((0, $e52d5c02f19d68ad$export$423ec2075359570a), {
        droppableId: "MAIN",
        type: "TAB",
        direction: "horizontal"
    }, (provided)=>$acw62.createElement("div", {
            ...provided.droppableProps,
            className: "ab-ModuleSelector__TabList twa:flex twa:flex-1 twa:overflow-auto",
            ref: provided.innerRef,
            "data-name": "dashboard-tabs"
        }, tabs.map((tab, tabIndex)=>$acw62.createElement($7b9838fe01ae1e93$export$17043b9d35150718, {
                disabled: disabled,
                key: tabIndex,
                tabIndex: tabIndex,
                tab: tab,
                onRemove: ()=>onRemoveTab(tabIndex),
                onRemoveToolbar: (toolbarIndex)=>onRemoveToolbar(tabIndex, toolbarIndex),
                onChangeTabName: (tabName)=>onChangeTabName(tabIndex, tabName)
            })), !disabled && onNewTab ? $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center",
            justifyContent: "center",
            className: "ab-ModuleSelector__TabItem twa:min-w-32 twa:border-dashed twa:cursor-pointer twa:bg-primarylight twa:text-primary-foreground twa:hover:bg-primary",
            onClick: onNewTab
        }, $acw62.createElement("div", {
            className: "twa:text-8 twa:flex twa:flex-col twa:gap-4 twa:items-center twa:italic"
        }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
            name: "plus",
            size: 32
        }), "Click to add tab")) : null, provided.placeholder));
}
function $7b9838fe01ae1e93$export$17043b9d35150718({ tab: tab, tabIndex: tabIndex, onRemove: onRemove, onRemoveToolbar: onRemoveToolbar, onChangeTabName: onChangeTabName, disabled: disabled }) {
    const context = $acw62.useContext((0, $c497b33b688e5695$export$d188a835a7bc5783));
    const isDragDisabled = disabled || !context.permittedActions.dragAndDropTab;
    return $acw62.createElement((0, $1710e65dc30c5dd1$export$f2a139e5d18b9882), {
        isDragDisabled: isDragDisabled,
        draggableId: String(tabIndex),
        index: tabIndex
    }, (provided)=>{
        let showHeader = true;
        if (tab.Name === '' && !context.permittedActions.editTabName && !context.permittedActions.deleteTab) showHeader = false;
        return $acw62.createElement("div", {
            className: "ab-ModuleSelector__TabItem twa:min-w-32",
            "data-name": "dashboard-tab",
            ref: provided.innerRef,
            ...provided.draggableProps,
            style: {
                ...isDragDisabled ? {} : provided.draggableProps.style
            }
        }, showHeader ? $acw62.createElement("div", {
            className: "ab-ModuleSelector__TabItem__header"
        }, $acw62.createElement("div", {
            ...disabled ? {} : provided.dragHandleProps,
            style: context.permittedActions.dragAndDropTab ? {} : {
                display: 'none'
            }
        }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
            name: "drag"
        })), context.permittedActions.editTabName ? $acw62.createElement("input", {
            className: "ab-ModuleSelector__TabItem__header-input",
            type: "text",
            disabled: disabled,
            value: tab.Name,
            onChange: (event)=>{
                onChangeTabName(event.target.value);
            }
        }) : tab.Name, context.permittedActions.deleteTab && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            disabled: disabled,
            icon: "delete",
            variant: "text",
            onClick: onRemove
        })) : null, $acw62.createElement($7b9838fe01ae1e93$export$bde343d18770e41e, {
            disabled: disabled,
            toolbars: tab.Items,
            droppableId: String(tabIndex),
            onRemove: onRemoveToolbar
        }));
    });
}
function $7b9838fe01ae1e93$export$bde343d18770e41e({ toolbars: toolbars, droppableId: droppableId, onRemove: onRemove, disabled: disabled }) {
    return $acw62.createElement((0, $e52d5c02f19d68ad$export$423ec2075359570a), {
        droppableId: droppableId,
        type: "TOOLBAR"
    }, (provided, snapshot)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "ab-ModuleSelector__ToolbarList",
            ref: provided.innerRef,
            ...disabled ? {} : provided.droppableProps,
            "data-name": "dashboard-toolbar-drop-target",
            style: {
                backgroundColor: snapshot.isDraggingOver ? 'var(--ab-dashboard-tab-drop-target__background)' : ''
            }
        }, toolbars?.map((toolbar, toolbarIndex)=>$acw62.createElement($7b9838fe01ae1e93$export$cb67beb212e92bbd, {
                disabled: disabled,
                key: toolbar,
                toolbar: toolbar,
                toolbarIndex: toolbarIndex,
                onRemove: ()=>onRemove(toolbarIndex)
            })), toolbars.length === 0 ? $acw62.createElement("div", {
            className: "ab-ModuleSelector__ToolbarList__placeholder twa:flex twa:items-center twa:justify-center twa:h-full twa:italic twa:text-center"
        }, "Drag and drop toolbar here") : null, provided.placeholder));
}
function $7b9838fe01ae1e93$export$cb67beb212e92bbd({ toolbar: toolbar, toolbarIndex: toolbarIndex, onRemove: onRemove, disabled: disabled }) {
    const { availableItems: availableItems } = $acw62.useContext((0, $c497b33b688e5695$export$d188a835a7bc5783));
    let currentItem = availableItems.find((t)=>t.Id === toolbar);
    const title = currentItem ? currentItem.Title : toolbar;
    return $acw62.createElement((0, $1710e65dc30c5dd1$export$f2a139e5d18b9882), {
        isDragDisabled: disabled,
        draggableId: toolbar,
        index: toolbarIndex
    }, (provided, snapshot)=>$acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: `ab-ModuleSelector__ToolbarItem twa:mb-1 twa:pl-1`,
            alignItems: "center",
            ref: provided.innerRef,
            ...provided.draggableProps,
            ...provided.dragHandleProps,
            style: {
                ...provided.draggableProps.style,
                backgroundColor: snapshot.isDragging ? 'var(--ab-dashboard-toolbar-drag__background)' : 'var(--ab-color-primarylight)'
            }
        }, $acw62.createElement("div", {
            className: "twa:flex-1"
        }, title), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            disabled: disabled,
            icon: "close",
            variant: "text",
            className: "twa:p-1",
            onClick: onRemove
        })));
}



var $acw62 = parcelRequire("acw62");




function $067a5b51ab840cab$export$e0ca00cc48d0558d({ items: items, disabled: disabled, title: title, dragItemText: dragItemText }) {
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-ModuleSelector__UnusedPanel twa:mb-2 twa:pb-1",
        "data-name": "unusedpanel-items"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, $acw62.createElement("b", null, title), " (", dragItemText, ")"), $acw62.createElement($067a5b51ab840cab$var$UnusedItemList, {
        disabled: disabled,
        items: items
    }));
}
function $067a5b51ab840cab$var$UnusedItemList({ items: items, disabled: disabled }) {
    return $acw62.createElement((0, $e52d5c02f19d68ad$export$423ec2075359570a), {
        droppableId: "UNUSED",
        type: "TOOLBAR",
        isDropDisabled: true,
        direction: "horizontal"
    }, (provided)=>$acw62.createElement("div", {
            ref: provided.innerRef,
            "data-name": "unusedpanel-items-list",
            ...provided.droppableProps,
            className: 'twa:px-2 twa:flex-wrap twa:flex twa:flex-row twa:gap-1'
        }, items.map((unusedItem, unusedItemIndex)=>$acw62.createElement($067a5b51ab840cab$var$UnusedItem, {
                disabled: disabled,
                key: unusedItem,
                unusedItem: unusedItem,
                unusedItemIndex: unusedItemIndex
            })), provided.placeholder));
}
function $067a5b51ab840cab$var$UnusedItem({ unusedItem: unusedItem, unusedItemIndex: unusedItemIndex, disabled: disabled }) {
    const { availableItems: availableItems } = $acw62.useContext((0, $c497b33b688e5695$export$d188a835a7bc5783));
    let currentItem = availableItems.find((t)=>t.Id === unusedItem);
    const title = currentItem ? currentItem.Title : unusedItem;
    return $acw62.createElement((0, $1710e65dc30c5dd1$export$f2a139e5d18b9882), {
        isDragDisabled: disabled,
        draggableId: unusedItem,
        index: unusedItemIndex
    }, (provided, snapshot)=>{
        const eventHandlers = disabled ? {} : {
            ...provided.draggableProps,
            ...provided.dragHandleProps
        };
        const dragStyle = disabled ? {} : provided.draggableProps.style;
        return $acw62.createElement("div", {
            "data-name": "unused-item",
            ref: provided.innerRef,
            ...eventHandlers,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:rounded-md twa:text-sm twa:text-text-on-primary twa:p-2'),
            style: {
                ...dragStyle,
                border: '1px solid var(--ab-color-primary)',
                backgroundColor: snapshot.isDragging ? 'var(--ab-dashboard-toolbar-drag__background)' : 'var(--ab-color-primary)'
            }
        }, title);
    });
}





const $9e67de7320a14ea2$export$b4ba4f0359f0dde4 = (props)=>{
    const { availableItems: availableItems, tabs: tabs, onTabsChange: onTabsChange, tabsTitle: tabsTitle, disabled: disabled, unusedPanelTitle: unusedPanelTitle, dragItemText: dragItemText, permittedActions: permittedActions, className: className } = props;
    const contextValue = $acw62.useMemo(()=>{
        const preparedPermittedAction = {
            createTab: true,
            editTabName: true,
            dragAndDropTab: true,
            deleteTab: true,
            // override default permitted actions
            ...permittedActions
        };
        return {
            permittedActions: preparedPermittedAction,
            availableItems: props.availableItems
        };
    }, [
        props.availableItems,
        props.permittedActions
    ]);
    const unusedItems = $acw62.useMemo(()=>availableItems.map((t)=>t.Id).filter((item)=>{
            return !tabs.some((tab)=>tab.Items?.includes(item));
        }), [
        tabs,
        availableItems
    ]);
    const handleToolbarDragEnd = (result)=>{
        const { source: source, destination: destination, draggableId: draggableId } = result;
        if (!source || !destination) return;
        if (source.droppableId !== 'UNUSED') {
            const sourceTabToolbars = tabs[Number(source.droppableId)].Items;
            sourceTabToolbars.splice(source.index, 1);
        }
        if (destination.droppableId !== 'UNUSED') {
            const destinationTabToolbars = tabs[Number(destination.droppableId)].Items;
            destinationTabToolbars.splice(destination.index, 0, draggableId);
        }
        onTabsChange([
            ...tabs
        ]);
    };
    const handleTabDragEnd = (result)=>{
        const { source: source, destination: destination } = result;
        if (!source || !destination) return;
        const [removed] = tabs.splice(source.index, 1);
        tabs.splice(destination.index, 0, removed);
        onTabsChange([
            ...tabs
        ]);
    };
    const handleRemoveTab = (tabIndex)=>{
        onTabsChange(tabs.filter((_, index)=>index !== tabIndex));
    };
    const handleTabAdd = ()=>{
        onTabsChange([
            ...tabs,
            {
                Name: 'New Tab',
                Items: []
            }
        ]);
    };
    const handleRemoveToolbar = (tabIndex, toolbarIndex)=>{
        onTabsChange(tabs.map((tab, index)=>{
            if (index !== tabIndex) return tab;
            return {
                ...tab,
                Items: tab.Items.filter((_, index)=>index !== toolbarIndex)
            };
        }));
    };
    const handleChangeTabName = (tabIndex, tabName)=>{
        onTabsChange(tabs.map((tab, index)=>{
            if (index !== tabIndex) return tab;
            return {
                ...tab,
                Name: tabName
            };
        }));
    };
    return $acw62.createElement((0, $e52d5c02f19d68ad$export$237bd83162c14364), {
        onDragEnd: (result)=>{
            if (result.type === 'TAB') handleTabDragEnd(result);
            if (result.type === 'TOOLBAR') handleToolbarDragEnd(result);
        }
    }, $acw62.createElement((0, $c497b33b688e5695$export$d188a835a7bc5783).Provider, {
        value: contextValue
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-ModuleSelector twa:flex-1', className)
    }, $acw62.createElement((0, $067a5b51ab840cab$export$e0ca00cc48d0558d), {
        title: unusedPanelTitle,
        disabled: disabled,
        items: unusedItems,
        dragItemText: dragItemText
    }), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), {
        className: "twa:flex-1 twa:m-2 ab-ModuleSelector-UsedPanel"
    }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, {
        border: false
    }, tabsTitle), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, {
        className: "twa:px-2"
    }, $acw62.createElement((0, $7b9838fe01ae1e93$export$e51a686c67fdaa2d), {
        disabled: disabled,
        tabs: tabs,
        onRemoveTab: handleRemoveTab,
        onRemoveToolbar: handleRemoveToolbar,
        onChangeTabName: handleChangeTabName,
        onNewTab: contextValue.permittedActions.createTab ? handleTabAdd : undefined
    }))))));
};


const $8e42461b1da4c8cd$var$DashboardManager = ({ tabs: tabs, onTabsChange: onTabsChange, availableToolbars: availableToolbars, api: api, disabled: disabled })=>{
    const moduleService = api.internalApi.getModuleService();
    const moduleInfo = moduleService.getModuleInfoByModule('Dashboard');
    const moduleTabs = tabs.map((tab)=>{
        return {
            Name: tab.Name,
            Items: tab.Toolbars
        };
    });
    const handleTabsChange = $acw62.useCallback((tabs)=>{
        const dashboardTabs = tabs.map((tab)=>({
                Name: tab.Name,
                Toolbars: tab.Items
            }));
        onTabsChange(dashboardTabs);
    }, []);
    return $acw62.createElement((0, $9e67de7320a14ea2$export$b4ba4f0359f0dde4), {
        availableItems: availableToolbars,
        disabled: disabled,
        onTabsChange: handleTabsChange,
        tabs: moduleTabs,
        tabsTitle: moduleInfo.FriendlyName + ' Tabs',
        unusedPanelTitle: 'Available Toolbars',
        dragItemText: "Drag into a Tab below"
    });
};
var $8e42461b1da4c8cd$export$2e2bcd8739ae039 = $8e42461b1da4c8cd$var$DashboardManager;




var $acw62 = parcelRequire("acw62");




const $f458d6f90fdcbe5a$export$3ec9e42e3cbe09bf = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dashboardAccessLevel = api.entitlementApi.getEntitlementAccessLevelForModule('Dashboard');
    const isDashboardDisabled = dashboardAccessLevel === 'ReadOnly';
    const dashboardState = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Dashboard);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const pinnedToolbars = dashboardState.PinnedToolbars;
    const toolbars = $acw62.useMemo(()=>{
        const systemToolbars = api.dashboardApi.internalApi.getModuleToolbars().map((mt)=>({
                Id: mt.id,
                Title: mt.friendlyName
            }));
        const customToolbars = api.dashboardApi.getCustomToolbars().map((ct)=>({
                Id: ct.name,
                Title: ct.title ? ct.title : ct.name
            }));
        return [
            ...systemToolbars,
            ...customToolbars
        ];
    }, []);
    const tabs = $acw62.useMemo(()=>{
        return [
            {
                // Name: 'Pinned Toolbars',
                Name: '',
                Items: pinnedToolbars ?? []
            }
        ];
    }, [
        pinnedToolbars
    ]);
    return $acw62.createElement((0, $9e67de7320a14ea2$export$b4ba4f0359f0dde4), {
        className: "twa:flex-1",
        permittedActions: {
            createTab: false,
            dragAndDropTab: false,
            deleteTab: false,
            editTabName: false
        },
        onTabsChange: (tabs)=>{
            dispatch((0, $dc6bc6f406d56c84$export$6f65449fc8f69bb2)(tabs[0].Items));
        },
        disabled: isDashboardDisabled,
        tabs: tabs,
        availableItems: toolbars,
        tabsTitle: 'Pinned Toolbars',
        unusedPanelTitle: "Available Pinned Toolbars",
        dragItemText: "Drag into the Panel below"
    });
};






var $d2037bfd6b6a8b89$export$1490acf1d2ebfd17;
(function(DashboardConfigView) {
    DashboardConfigView["Toolbars"] = "Toolbars";
    DashboardConfigView["Buttons"] = "Buttons";
    DashboardConfigView["PinnedToolbars"] = "PinnedToolbars";
})($d2037bfd6b6a8b89$export$1490acf1d2ebfd17 || ($d2037bfd6b6a8b89$export$1490acf1d2ebfd17 = {}));
class $d2037bfd6b6a8b89$var$DashboardPopupComponent extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            DashboardConfigView: $d2037bfd6b6a8b89$export$1490acf1d2ebfd17.Toolbars
        };
    }
    render() {
        const systemToolbars = this.props.api.dashboardApi.internalApi.getModuleToolbars().map((toolbar)=>({
                Id: toolbar.id,
                Title: toolbar.friendlyName
            }));
        const customToolbars = this.props.api.dashboardApi.getCustomToolbars().map((ct)=>({
                Id: ct.name,
                Title: ct.title ? ct.title : ct.name
            }));
        const tabs = this.props.DashboardState.Tabs.map((tab)=>{
            const Toolbars = tab.Toolbars.filter((vt)=>{
                let customToolbar = this.props.api.dashboardApi.getCustomToolbars().find((ct)=>ct.name === vt);
                return customToolbar ? true : this.props.api.internalApi.getModuleService().isAdapTableModulePresent(vt);
            });
            return {
                ...tab,
                Toolbars: Toolbars
            };
        });
        let selectedModuleButtons = [];
        this.props.DashboardState.ModuleButtons.forEach((x)=>{
            let menuItem = this.props.InternalState.SettingsPanelModuleEntries.find((m)=>m.category == x);
            if (menuItem?.isVisible) selectedModuleButtons.push(x);
        });
        const allModuleButtons = this.props.InternalState.SettingsPanelModuleEntries.map((x)=>x.category);
        const baseClassName = 'ab-Dashboard-Popup';
        const dashboardAccessLevel = this.props.api.entitlementApi.getEntitlementAccessLevelForModule('Dashboard');
        const areDashboardSettingsVisible = dashboardAccessLevel == 'Full' || dashboardAccessLevel == 'ReadOnly';
        const isDashboardDisabled = dashboardAccessLevel === 'ReadOnly';
        const isModuleCheckboxDisabled = (module)=>{
            if (module === 'SettingsPanel') return this.props.api.optionsApi.getSettingsPanelOptions().alwaysShowInDashboard;
            return false;
        };
        const contentCls = '';
        return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
            headerText: this.props.moduleInfo.FriendlyName,
            glyphicon: this.props.moduleInfo.Glyph,
            infoLink: this.props.moduleInfo.HelpPage,
            infoLinkDisabled: !this.props.api.internalApi.isDocumentationLinksDisplayed()
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "column",
            className: "twa:h-full twa:gap-4"
        }, areDashboardSettingsVisible && $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), null, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, {
            gap: 8
        }, "Display Settings"), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, {
            gap: 2,
            className: "twa:p-2"
        }, $acw62.createElement("div", {
            className: "twa:flex twa:flex-row twa:items-center twa:justify-start twa:gap-3"
        }, $acw62.createElement((0, $c367b4f7d2ae39ea$export$d2b052e7b4be1756), {
            className: "twa:w-24",
            onChange: (visible)=>this.props.onSetDashboardHidden(!visible),
            checked: !this.props.IsHidden,
            "data-name": "dashboard-visibility"
        }, this.props.IsHidden ? 'Hidden' : 'Visible'), this.props.DashboardState.Tabs?.length > 0 ? $acw62.createElement((0, $c367b4f7d2ae39ea$export$d2b052e7b4be1756), {
            disabled: this.props.IsFloating,
            className: "twa:w-24",
            onChange: (expanded)=>this.props.onSetDashboardCollapsed(!expanded),
            checked: !this.props.IsCollapsed,
            "data-name": "expand-state"
        }, this.props.IsCollapsed ? 'Collapsed' : 'Expanded') : null, this.props.api.optionsApi.getDashboardOptions().canFloat ? $acw62.createElement((0, $c367b4f7d2ae39ea$export$d2b052e7b4be1756), {
            className: "twa:w-24",
            onChange: (pinned)=>this.props.onSetDashboardFloating(!pinned),
            checked: !this.props.IsFloating,
            "data-name": "floating"
        }, this.props.IsFloating ? 'Floating' : 'Pinned') : null)))), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41), {
            className: "twa:flex-1 twa:overflow-hidden",
            gap: 0
        }, $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Title, null, "Contents"), $acw62.createElement((0, $2f89a0dc2f97e4f0$export$60332b2344f7fe41).Body, {
            className: "twa:p-2"
        }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
            className: "twa:flex-1 twa:min-h-0"
        }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
            value: "pinned-toolbars"
        }, "Pinned Toolbars"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
            value: "tabbed-toolbars"
        }, "Tabs & Toolbars"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, {
            value: "buttons"
        }, "Buttons"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
            value: "pinned-toolbars",
            className: contentCls
        }, $acw62.createElement((0, $f458d6f90fdcbe5a$export$3ec9e42e3cbe09bf), null)), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
            value: "tabbed-toolbars",
            className: contentCls
        }, $acw62.createElement((0, $8e42461b1da4c8cd$export$2e2bcd8739ae039), {
            disabled: isDashboardDisabled,
            availableToolbars: [
                ...systemToolbars,
                ...customToolbars
            ],
            tabs: tabs,
            onTabsChange: this.props.onDashboardSetTabs,
            api: this.props.api
        })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, {
            value: "buttons",
            className: contentCls
        }, $acw62.createElement((0, $5460d6ff5d2c60f3$export$d0245a44c9a88495), {
            disabled: isDashboardDisabled,
            options: allModuleButtons,
            value: selectedModuleButtons,
            isOptionDisabled: isModuleCheckboxDisabled,
            onChange: (selectedValues)=>this.props.onDashboardSetModuleButtons(selectedValues)
        })))))));
    }
    onDashboardConfigViewChanged(event) {
        let e = event.target;
        let dashboardConfigView = e.value;
        this.setState({
            DashboardConfigView: dashboardConfigView
        });
    }
}
function $d2037bfd6b6a8b89$var$mapStateToProps(state, ownProps) {
    return {
        DashboardState: state.Dashboard,
        InternalState: state.Internal,
        IsCollapsed: state.Dashboard.IsCollapsed,
        IsHidden: state.Dashboard.IsHidden,
        IsFloating: state.Dashboard.IsFloating
    };
}
function $d2037bfd6b6a8b89$var$mapDispatchToProps(dispatch) {
    return {
        onDashboardSetModuleButtons: (moduleButtons)=>dispatch($dc6bc6f406d56c84$export$159d43c9de7aed08(moduleButtons)),
        onDashboardSetTabs: (Tabs)=>dispatch($dc6bc6f406d56c84$export$a79213d66294d5b2(Tabs)),
        onSetDashboardCollapsed: (isCollapsed)=>dispatch($dc6bc6f406d56c84$export$4a9fdbf5568e83b6(isCollapsed)),
        onSetDashboardHidden: (isHidden)=>dispatch($dc6bc6f406d56c84$export$b2de5be7510594c1(isHidden)),
        onSetDashboardFloating: (isFloating)=>dispatch($dc6bc6f406d56c84$export$d83abcde9deec805(isFloating))
    };
}
let $d2037bfd6b6a8b89$export$9c1efdcc2d838d4c = (0, $55388fc2f116d4d7$export$64605811ab45167f)($d2037bfd6b6a8b89$var$mapStateToProps, $d2037bfd6b6a8b89$var$mapDispatchToProps)($d2037bfd6b6a8b89$var$DashboardPopupComponent);



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");





var $bd97428302e1e578$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["DRAG_OVER"] = "DRAG_OVER";
    ActionTypes["DRAG_OUT"] = "DRAG_OUT";
    ActionTypes["SET_INVALID_FILE"] = "SET_INVALID_FILE";
    ActionTypes["DROP_SUCCES"] = "DROP_SUCCES";
})($bd97428302e1e578$export$1385d81a6c6bbcd4 || ($bd97428302e1e578$export$1385d81a6c6bbcd4 = {}));
const $bd97428302e1e578$var$reducer = (state, action)=>{
    if (action.type === $bd97428302e1e578$export$1385d81a6c6bbcd4.DRAG_OVER) return {
        ...state,
        dragOver: true
    };
    if (action.type === $bd97428302e1e578$export$1385d81a6c6bbcd4.DRAG_OUT) return {
        ...state,
        dragOver: false
    };
    if (action.type === $bd97428302e1e578$export$1385d81a6c6bbcd4.SET_INVALID_FILE) return {
        ...state,
        message: action.payload.message
    };
    if (action.type === $bd97428302e1e578$export$1385d81a6c6bbcd4.DROP_SUCCES) return {
        ...state,
        dragOver: false,
        message: action.payload.message
    };
    return state;
};
var $bd97428302e1e578$export$2e2bcd8739ae039 = $bd97428302e1e578$var$reducer;



const $ecc63bb8d4bdb327$var$initialState = {
    dragOver: false,
    message: null
};
const $ecc63bb8d4bdb327$var$preventEventPropagation = (e)=>{
    e.preventDefault();
    e.stopPropagation();
};
const $ecc63bb8d4bdb327$export$aa2c7ad2063c8ec6 = async (file, toJSON)=>{
    const reader = new FileReader();
    return new Promise((resolve, reject)=>{
        reader.onload = function(e) {
            try {
                const fn = toJSON || JSON.parse;
                const json = fn(e.target.result);
                Promise.resolve(json).then(resolve);
            } catch (ex) {
                reject('Invalid JSON');
            }
        };
        reader.onerror = function(e) {
            reject(e);
        };
        reader.readAsText(file);
    });
};
const $ecc63bb8d4bdb327$var$FileDroppable = (props = {})=>{
    const { onDropSuccess: onDropSuccess, message: message, fileAccept: fileAccept = '.json', helpText: helpText = 'AdapTable No Code Version', defaultText: defaultText = 'Click here to select a JSON file to load or drag it here', dragOverText: dragOverText = 'Drop file here to start Adaptable Wizard', icon: icon = $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "paperclip",
        size: 40
    }), value: value, ...domProps } = props;
    const [state, dispatch] = (0, $acw62.useReducer)((0, $bd97428302e1e578$export$2e2bcd8739ae039), $ecc63bb8d4bdb327$var$initialState);
    const onDragEnter = (e)=>{
        dispatch({
            type: (0, $bd97428302e1e578$export$1385d81a6c6bbcd4).DRAG_OVER
        });
    };
    const onDragLeave = (event)=>{
        $ecc63bb8d4bdb327$var$preventEventPropagation(event);
        if (domRef.current != event.target && (0, $a651380741b279ec$export$2e2bcd8739ae039)(domRef.current, event.target)) return;
        dispatch({
            type: (0, $bd97428302e1e578$export$1385d81a6c6bbcd4).DRAG_OUT
        });
    };
    const onDrop = async (e)=>{
        let files;
        $ecc63bb8d4bdb327$var$preventEventPropagation(e);
        let nativeEvent = e.nativeEvent;
        if (nativeEvent && nativeEvent.dataTransfer) files = nativeEvent.dataTransfer.files;
        else files = e.target.files;
        onDragLeave(e);
        const file = files[0];
        if (file) {
            let json;
            try {
                json = await (props.readFile || $ecc63bb8d4bdb327$export$aa2c7ad2063c8ec6)(file, props.toJSON);
                dispatch({
                    type: (0, $bd97428302e1e578$export$1385d81a6c6bbcd4).DROP_SUCCES,
                    payload: {
                        message: $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, props.loadingText === undefined ? 'Initializing adaptable...' : props.loadingText)
                    }
                });
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        if (onDropSuccess) onDropSuccess(json, file);
                    });
                });
            } catch (err) {
                dispatch({
                    type: (0, $bd97428302e1e578$export$1385d81a6c6bbcd4).SET_INVALID_FILE,
                    payload: {
                        message: $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, 'The file is not a valid JSON file! Please try again!')
                    }
                });
            }
        }
    };
    const domRef = (0, $acw62.useRef)(null);
    let form = $acw62.createElement("form", {
        onSubmit: $ecc63bb8d4bdb327$var$preventEventPropagation
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        style: {
            cursor: 'pointer'
        },
        variant: "outlined"
    }, $acw62.createElement("div", null, state.dragOver ? dragOverText : defaultText), $acw62.createElement("input", {
        type: "file",
        onChange: onDrop,
        accept: fileAccept,
        value: props?.file?.name,
        style: {
            opacity: 0,
            position: 'absolute',
            cursor: 'pointer',
            fontSize: 0,
            lineHeight: 0,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1
        }
    })));
    const msg = message || state.message;
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        ...domProps,
        flexDirection: "column",
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(props.className, 'ab-FileDroppable', state.dragOver ? 'ab-FileDroppable--drag-over' : ''),
        alignItems: "center",
        justifyContent: "center",
        onDragEnter: onDragEnter,
        onDragLeave: onDragLeave,
        onDrop: onDrop,
        onDragOver: $ecc63bb8d4bdb327$var$preventEventPropagation,
        ref: domRef
    }, props.children, helpText || icon ? $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, helpText ? $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        alignItems: "center",
        className: "twa:m-2"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), null, $acw62.createElement("b", null, helpText))) : null, icon ? $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        alignItems: "center",
        className: "twa:m-2"
    }, icon) : null) : null, msg, form);
};
var $ecc63bb8d4bdb327$export$2e2bcd8739ae039 = $ecc63bb8d4bdb327$var$FileDroppable;



const $e2ef1420d912e1c1$export$41861f0311224bab = (props)=>{
    const onLoadInitialState = (e)=>{
        const nativeEvent = e.nativeEvent;
        let files;
        if (nativeEvent && nativeEvent.dataTransfer) files = nativeEvent.dataTransfer.files;
        else files = e.target.files;
        const file = files[0];
        (0, $ecc63bb8d4bdb327$export$aa2c7ad2063c8ec6)(file).then((json)=>{
            props.onLoad(json);
        });
    };
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        ...props,
        className: "ab-StateManagement__Load-Button"
    }, $acw62.createElement("input", {
        "aria-label": "Load Adaptable State",
        type: "file",
        onChange: (json)=>onLoadInitialState(json),
        accept: '.json',
        style: {
            opacity: 0,
            position: 'absolute',
            cursor: 'pointer',
            fontSize: 0,
            lineHeight: 0,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1
        }
    }), ' ', props.children);
};



var $acw62 = parcelRequire("acw62");

const $1740bcc6d7e812be$export$13ec83e50bf04290 = (props)=>{
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        ...props,
        className: "ab-StateManagement__Clear-Button",
        tooltip: "Clear User State"
    }, props.children);
};



var $acw62 = parcelRequire("acw62");


const $c6796b139c17d7e2$export$ed52eb96622e03c7 = (type, name, state, api)=>{
    switch(type){
        case 'Clipboard':
            let stringifiedState = JSON.stringify(state);
            (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).copyToClipboard(stringifiedState);
            break;
        case 'Console':
            api.consoleLog('Adaptable state:', state);
            break;
        case 'JSON':
            const jsonFileName = name + '.json';
            const jsonContent = JSON.stringify(state);
            (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).createDownloadedFile(jsonContent, jsonFileName, 'application/json');
            break;
    }
};


const $7946c1b19352bba4$export$68283403dbd9b8ee = (props)=>{
    const handleChange = (destination)=>{
        switch(props.type){
            case 'adaptableState':
                const adaptableState = props.api.stateApi.getPersistentState();
                (0, $c6796b139c17d7e2$export$ed52eb96622e03c7)(destination, 'adaptableState', adaptableState, props.api);
                break;
            case 'initialState':
                const initialState = props.api.stateApi.getInitialState();
                (0, $c6796b139c17d7e2$export$ed52eb96622e03c7)(destination, 'initialState', initialState, props.api);
                break;
        }
    };
    const destinationOptions = [
        {
            value: 'Clipboard',
            label: 'Clipboard',
            onClick: ()=>handleChange('Clipboard')
        },
        {
            value: 'Console',
            label: 'Console',
            onClick: ()=>handleChange('Console')
        },
        {
            value: 'JSON',
            label: 'JSON',
            onClick: ()=>handleChange('JSON')
        }
    ];
    return $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        className: "ab-StateManagement__Export-Dropdown",
        ...props,
        items: destinationOptions,
        value: undefined
    });
};



const $2bfd39b339120b70$export$9b7ffd27007336c4 = (props)=>{
    const baseClassName = 'ab-ManageState';
    return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
        className: baseClassName,
        headerText: props.moduleInfo.FriendlyName,
        glyphicon: props.moduleInfo.Glyph,
        infoLink: props.moduleInfo.HelpPage,
        infoLinkDisabled: !props.api.internalApi.isDocumentationLinksDisplayed()
    }, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: `${baseClassName}__panel twa:mr-2 twa:mb-2 twa:h-auto twa:rounded-none`,
        "data-name": "user-state",
        header: 'User State',
        variant: "default"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mb-2"
    }, 'Clear all current user state that has been persisted'), $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        style: {
            color: 'var(--ab-color-warn)'
        }
    }, 'This will cause this window to close and any State you have previously created will be lost, and the Initial Adaptable State will be reapplied'), $acw62.createElement((0, $1740bcc6d7e812be$export$13ec83e50bf04290), {
        "data-name": "clear-user-state-button",
        tone: "info",
        variant: "raised",
        className: "twa:mt-2",
        accessLevel: props.accessLevel,
        onClick: ()=>props.api.stateApi.reloadInitialState()
    }, "Clear User State")), $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: `${baseClassName}__panel twa:mt-3 twa:mr-2 twa:mb-2 twa:h-auto twa:rounded-none`,
        "data-name": "initial-state",
        header: 'Initial Adaptable State',
        variant: "default"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mt-2"
    }, 'Load Initial Adaptable State (from a .json file) - this will cause this window to close'), ' ', $acw62.createElement((0, $e2ef1420d912e1c1$export$41861f0311224bab), {
        tone: "info",
        variant: "raised",
        className: "twa:mt-2",
        accessLevel: props.accessLevel,
        onLoad: (json)=>props.api.stateApi.reloadInitialState(json),
        "data-name": "load-initial-state-button"
    }, "Load Initial Adaptable State")), $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: `${baseClassName}__panel twa:mt-3 twa:mr-2 twa:mb-2 twa:h-auto twa:rounded-none`,
        "data-name": "adaptable-state",
        header: 'Export Adaptable State'
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:my-2"
    }, 'Exports the currently persisted Adaptable State'), ' ', $acw62.createElement((0, $7946c1b19352bba4$export$68283403dbd9b8ee), {
        api: props.api,
        type: "adaptableState",
        className: "twa:mr-3 twa:flex-1 twa:max-w-none",
        columns: [
            'label'
        ],
        "data-name": "export-adaptable-state-dropdown"
    }, "Select Export Destination")), $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: `${baseClassName}__panel twa:mt-3 twa:mr-2 twa:mb-2 twa:h-auto twa:rounded-none`,
        "data-name": "initial-state",
        header: 'Export Initial Adaptable State',
        variant: "default"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:my-2"
    }, 'Exports the Initial Adaptable State which was provided at design time'), ' ', $acw62.createElement((0, $7946c1b19352bba4$export$68283403dbd9b8ee), {
        api: props.api,
        type: "initialState",
        className: "twa:mr-3 twa:flex-1 twa:max-w-none",
        columns: [
            'label'
        ],
        "data-name": "export-initial-state-dropdown"
    }, "Select Export Destination")));
};




var $acw62 = parcelRequire("acw62");






var $9OAZF = parcelRequire("9OAZF");



var $acw62 = parcelRequire("acw62");


var $5aWMQ = parcelRequire("5aWMQ");







const $9a29e8ecea9ea872$export$6b9fba00b1ebf903 = (props)=>{
    const [valueType, setValueType] = $acw62.useState('existing');
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const columnDataType = props.selectedColumn?.dataType;
    const isDateType = props.selectedColumn && columnDataType === 'date';
    const columnId = props.selectedColumn?.columnId;
    // TODO = this seems to be called whenever we edit a cell
    // which is then triggering a get all values
    // not sure that we need to
    const permittedValueSelector = $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: 'twa:flex-1'
    }, $acw62.createElement((0, $280aaa838d007117$export$266b893610128c75), {
        allowNewValues: true,
        searchable: 'inline',
        disabled: props.disabled || !props.selectedColumn,
        value: props.selectedColumnValue === '' ? null : props.selectedColumnValue,
        columnId: columnId,
        placeholder: 'Select value',
        loadValues: (0, $acw62.useCallback)(({ currentSearchValue: currentSearchValue })=>{
            if (!columnId || !props.selectedGridCells.length) return Promise.resolve([]);
            return adaptable.api.gridApi.internalApi.getDistinctEditDisplayValuesForColumn({
                columnId: columnId,
                gridCell: props.selectedGridCells[0],
                currentSearchValue: currentSearchValue
            });
        }, [
            columnId,
            props.selectedGridCells?.[0]?.column.columnId,
            props.selectedGridCells?.[0]?.primaryKeyValue
        ]),
        onChange: (value)=>{
            props.onColumnValueChange(value || null);
        }
    }));
    const input = $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        "data-name": "bulkupdate-value-input",
        "aria-label": "Bulk Update Value Input",
        type: props.selectedColumn ? (0, $5aWMQ.default).getDescriptionForDataType(props.selectedColumn.dataType) : 'text',
        placeholder: props.selectedColumn ? (0, $5aWMQ.default).getPlaceholderForDataType(props.selectedColumn.dataType) : 'Enter Value',
        autoFocus: true,
        disabled: props.disabled,
        className: "twa:w-full",
        value: props.selectedColumnValue,
        onChange: (e)=>{
            props.onColumnValueChange(e.target.value);
        }
    });
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:overflow-visible twa:max-w-full', props.className),
        style: props.style
    }, isDateType ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $bb22383ceab68e70$export$6e5a9cd40e0c9b97), {
        Component: (0, $82c87f52da9ba110$export$f51f4c4ede09e011),
        "data-id": "bulk-update-input-wrapper",
        className: "twa:w-full"
    }, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        "aria-label": "Bulk Update Value Selector",
        "data-id": "bulk-update-value-type-selector",
        "data-value": valueType,
        columns: [
            'label'
        ],
        variant: "outlined",
        tone: "neutral",
        items: [
            {
                label: 'New',
                icon: $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                    name: "edit"
                }),
                onClick: ()=>setValueType('new')
            },
            {
                label: 'Existing',
                icon: $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                    name: "grid"
                }),
                onClick: ()=>setValueType('existing')
            }
        ]
    }, $acw62.createElement($acw62.Fragment, null, valueType === 'existing' ? $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "grid"
    }) : $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "edit"
    }))), valueType === 'new' ? input : permittedValueSelector)) : permittedValueSelector);
};





class $82b85f11be8b7368$var$BulkUpdatePopupComponent extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            isShowingError: false,
            errorText: '',
            useSelector: false
        };
    }
    componentDidMount() {
        this.props.onBulkUpdateValueChange('');
        this.props.onBulkUpdateCheckSelectedCells();
    }
    render() {
        let col = this.props.BulkUpdateValidationResult.Column;
        let hasDataTypeError = false;
        let dataTypeErrorMessage = '';
        if (col && (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(this.props.BulkUpdateValue)) {
            // check that the update value is a number for a numeric column.  not issue for dates as we dont allow free text
            if (col.dataType == 'number') {
                if (isNaN(Number(this.props.BulkUpdateValue))) {
                    hasDataTypeError = true;
                    dataTypeErrorMessage = 'This column only accepts numbers';
                }
            }
        }
        let globalValidationMessage = (0, $ffbf29d095efdf81$export$69a3593e4bb2f3c1).GetValidationMessage(this.props.PreviewInfo, this.props.BulkUpdateValue);
        let showPanel = this.props.PreviewInfo && (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(this.props.BulkUpdateValue) && (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(globalValidationMessage);
        let previewPanel = showPanel ? $acw62.createElement((0, $dab8d46725028be5$export$5a0a2ad814f1ffcd), {
            previewInfo: this.props.PreviewInfo,
            api: this.props.api,
            selectedColumn: col,
            showPanel: showPanel,
            showHeader: true
        }) : null;
        if (!col) return null;
        return $acw62.createElement((0, $283cf61293364231$export$226a98817755c0cc), {
            bodyProps: {
                className: 'twa:p-0'
            },
            glyphicon: this.props.moduleInfo.Glyph,
            header: this.props.moduleInfo.FriendlyName,
            infoLink: this.props.moduleInfo.HelpPage,
            infoLinkDisabled: !this.props.api.internalApi.isDocumentationLinksDisplayed(),
            variant: "primary"
        }, col.dataType == 'date' ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
            className: "twa:my-2"
        }, "Enter a date value. Alternatively, tick the checkbox and select from an existing column value."), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "row",
            alignItems: "center",
            className: "twa:p-2"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center",
            flexDirection: "row",
            className: "twa:flex-1 twa:mr-2"
        }, $acw62.createElement((0, $9a29e8ecea9ea872$export$6b9fba00b1ebf903), {
            selectedGridCells: this.props.SelectedGridCells,
            selectedColumnValue: this.props.BulkUpdateValue,
            selectedColumn: col,
            api: this.props.api,
            onColumnValueChange: (values)=>this.onColumnValueSelectedChanged(values),
            allowNew: false,
            className: "twa:w-full twa:max-w-[inherit]"
        })), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            disabled: (0, $9OAZF.StringExtensions).IsNullOrEmpty(this.props.BulkUpdateValue) || this.props.PreviewInfo.previewValidationSummary.validationResult == 'All',
            onClick: ()=>{
                this.onApplyClick();
            },
            variant: "raised",
            tone: "accent"
        }, "Apply Bulk Update"))) : $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
            className: "twa:my-2"
        }, "Select an existing Column value from the dropdown, or enter a new value"), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "row",
            alignItems: "center",
            className: "twa:mt-2 twa:gap-2 twa:items-stretch"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center",
            flexDirection: "row",
            className: "twa:mr-2 twa:flex-1"
        }, $acw62.createElement((0, $9a29e8ecea9ea872$export$6b9fba00b1ebf903), {
            selectedGridCells: this.props.SelectedGridCells,
            selectedColumnValue: this.props.BulkUpdateValue,
            selectedColumn: col,
            api: this.props.api,
            onColumnValueChange: (columns)=>this.onColumnValueSelectedChanged(columns),
            className: "twa:w-full twa:max-w-[inherit]"
        })), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            disabled: (0, $9OAZF.StringExtensions).IsNullOrEmpty(this.props.BulkUpdateValue) || this.props.PreviewInfo.previewValidationSummary.validationResult == 'All' || hasDataTypeError,
            variant: "raised",
            tone: "accent",
            onClick: ()=>{
                this.onApplyClick();
            }
        }, "Apply Bulk Update"), ' ', hasDataTypeError && $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
            headerText: 'Update Error',
            bodyText: [
                dataTypeErrorMessage
            ],
            MessageType: 'Error'
        }), (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(this.props.BulkUpdateValue) && this.props.PreviewInfo.previewValidationSummary.validationResult != 'None' && $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
            headerText: 'Validation Error',
            bodyText: [
                globalValidationMessage
            ],
            MessageType: 'Error'
        }))), previewPanel);
    }
    onColumnValueSelectedChanged(selectedColumnValue) {
        this.props.onBulkUpdateValueChange(selectedColumnValue);
    }
    onUseColumnValuesSelectorChanged(checked) {
        this.setState({
            useSelector: checked
        });
        this.props.onBulkUpdateValueChange('');
    }
    onBulkUpdateValueChange(event) {
        const e = event.target;
        this.props.onBulkUpdateValueChange(e.value);
    }
    onApplyClick() {
        this.onApplyBulkUpdate();
    }
    onApplyBulkUpdate() {
        this.props.onApplyBulkUpdate();
    }
}
function $82b85f11be8b7368$var$mapStateToProps(state, ownProps) {
    return {
        BulkUpdateValue: state.Internal.BulkUpdate.BulkUpdateValue,
        PreviewInfo: state.Internal.BulkUpdate.BulkUpdatePreviewInfo,
        BulkUpdateValidationResult: state.Internal.BulkUpdate.BulkUpdateValidationResult,
        SelectedGridCells: state.Internal.SelectedCellInfo?.gridCells
    };
}
function $82b85f11be8b7368$var$mapDispatchToProps(dispatch) {
    return {
        onBulkUpdateValueChange: (value)=>dispatch($5b564bb703f29152$export$eebc2801a7081e3f(value)),
        onBulkUpdateCheckSelectedCells: ()=>dispatch($5b564bb703f29152$export$d4ac7f658a02fdce()),
        onApplyBulkUpdate: ()=>dispatch($8713f41926484273$export$95e3d38d99d65522(false))
    };
}
let $82b85f11be8b7368$export$7df648d00e9fe111 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($82b85f11be8b7368$var$mapStateToProps, $82b85f11be8b7368$var$mapDispatchToProps)($82b85f11be8b7368$var$BulkUpdatePopupComponent);



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");






const $487671a773814f07$export$4feb352864cd93b8 = (props)=>{
    const { buttonContent: buttonContent } = props;
    const IconCmp = (0, $124c9aa27215a392$export$6aa6ecf6e8a98784)[props.glyphicon];
    const header = $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:w-full"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, props.glyphicon != null && (IconCmp ? $acw62.createElement(IconCmp, null) : null), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "space-before",
        className: "twa:mr-2"
    }), props.headerText, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": "space-after",
        className: "twa:mr-2"
    }), props.infoLink != null && !props.infoLinkDisabled && $acw62.createElement((0, $00c4532606fa3d4c$export$5a2ee34a0d054ab8), {
        onClick: ()=>window.open(props.infoLink, '_blank')
    })), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }), buttonContent ? $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        variant: "raised",
        tone: "accent",
        disabled: props.buttonDisabled,
        onClick: ()=>props.buttonClick ? props.buttonClick() : null
    }, buttonContent) : null, props.button ? $acw62.cloneElement(props.button) : null);
    return $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: (0, $85fc2fe65ff21506$exports.twMerge)('twa:flex-1 twa:rounded-none twa:border-none', props.className),
        bodyScroll: props.bodyScroll != null ? props.bodyScroll : true,
        bodyProps: props.bodyProps,
        variant: props.variant || 'primary',
        header: header,
        headerProps: props.headerProps,
        style: props.style
    }, props.children);
};


class $70fc57743f4ab094$var$CellSummaryPopupComponent extends $acw62.Component {
    componentDidMount() {
        if (this.props.popupParams?.source === 'ColumnMenu' && this.props.popupParams?.column) {
            // if the summary was requested from the column menu, we need to select the entire column
            // afterwards, we will go on with the cell summary logic, as that will evaluate the current(column) cell selection
            this.props.api.columnApi.selectColumn(this.props.popupParams?.column.columnId);
            // we also need to update the internal state of the selected cells
            this.props.api.internalApi.getAdaptableInstance().refreshSelectedCellsState();
        }
        this.props.onCreateCellSummary();
    }
    render() {
        return $acw62.createElement((0, $487671a773814f07$export$4feb352864cd93b8), {
            className: "twa:p-0!",
            variant: "primary",
            headerText: this.props.moduleInfo.FriendlyName,
            glyphicon: this.props.moduleInfo.Glyph,
            infoLink: this.props.moduleInfo.HelpPage,
            infoLinkDisabled: !this.props.api.internalApi.isDocumentationLinksDisplayed()
        }, $acw62.createElement((0, $2b7a09b743acf941$export$ee8c64b8520d04c6), {
            CellSummary: this.props.CellSummary
        }));
    }
}
function $70fc57743f4ab094$var$mapStateToProps(state, ownProps) {
    return {
        CellSummary: state.Internal.CellSummary.CellSummaryInfo
    };
}
function $70fc57743f4ab094$var$mapDispatchToProps(dispatch) {
    return {
        onCreateCellSummary: ()=>dispatch($5b564bb703f29152$export$1e02d3cd4f056ef1())
    };
}
let $70fc57743f4ab094$export$36cec22fff7be239 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($70fc57743f4ab094$var$mapStateToProps, $70fc57743f4ab094$var$mapDispatchToProps)($70fc57743f4ab094$var$CellSummaryPopupComponent);



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


class $ed593e549b3bde1e$export$fc3128f315bde179 extends $acw62.Component {
    render() {
        const headerItems = this.props.colItems.map((colItem, index)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                key: colItem.key || colItem.Content || index,
                className: "twa:font-bold twa:text-3 twa:px-1",
                style: {
                    flex: colItem.Size
                }
            }, colItem.Content));
        const header = $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center",
            className: "twa:w-full"
        }, headerItems);
        return $acw62.createElement("div", {
            style: this.props.style,
            className: this.props.className
        }, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
            bodyScroll: true,
            header: header,
            border: this.props.border,
            bodyProps: this.props.bodyProps
        }, this.props.children));
    }
}





const $0c63d8e3bfa8e1c3$export$c87e7bbb66bb77f7 = (props)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        style: props.style,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('ab-ObjectCollection twa:flex twa:flex-col', props.className)
    }, $acw62.createElement((0, $ed593e549b3bde1e$export$fc3128f315bde179), {
        border: "none",
        colItems: props.colItems
    }), $acw62.createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-ObjectCollection__items twa:shadow-none twa:flex-1', {
            'twa:overflow-y-visible': props.allowOverflow,
            'twa:overflow-y-auto': !props.allowOverflow
        })
    }, props.items));
};




var $acw62 = parcelRequire("acw62");


var $5aWMQ = parcelRequire("5aWMQ");



class $fcc1cb9accc8e1b0$export$7d7cadd872a7f3dc extends $acw62.Component {
    render() {
        let systemStatus = this.props.adaptableObject;
        let messageTypeColor = (0, $5aWMQ.default).getColorByMessageType(systemStatus?.statusType ?? 'Success');
        let colItems = (0, $f5fc3c9fe698fd70$export$d30aea6baca0538b)(this.props.colItems);
        colItems[0].Content = systemStatus ? $acw62.createElement("details", null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            title: systemStatus.statusFurtherInformation ? 'Click to see more' : '',
            className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)('ab-DashboardToolbar__SystemStatus__text', systemStatus.statusFurtherInformation && 'ab-DashboardToolbar__SystemStatus__text--expandable'),
            style: {
                backgroundColor: messageTypeColor
            },
            alignItems: "center",
            as: "summary"
        }, systemStatus.statusMessage, " ", systemStatus.statusFurtherInformation ? '...' : ''), systemStatus.statusFurtherInformation ? $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "ab-DashboardToolbar__SystemStatus__further-information twa:m-2"
        }, systemStatus.statusFurtherInformation) : null) : null;
        colItems[1].Content = systemStatus.timestamp.toLocaleString();
        return $acw62.createElement((0, $fc1f09638343e37f$export$1ed2661f78171539), {
            colItems: colItems
        });
    }
}



var $9g4SS = parcelRequire("9g4SS");


var $hrtGQ = parcelRequire("hrtGQ");

const $7daa9dcd7ea9e080$var$colItems = [
    {
        Content: 'Message',
        Size: 10
    },
    {
        Content: 'Timestamp',
        Size: 3
    }
];
class $7daa9dcd7ea9e080$var$SystemStatusPopupComponent extends $acw62.Component {
    constructor(props){
        super(props);
    // this.state = { EditedSystemStatusText: '', EditedStyle: null };
    }
    onSystemStatusMessageInfoDeleteAll() {
        this.props.onSystemStatusMessageInfoDeleteAll();
    }
    render() {
        let clearAllButton = $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            onClick: ()=>this.onSystemStatusMessageInfoDeleteAll(),
            tooltip: "Clear All",
            tone: "neutral",
            variant: "raised",
            accessLevel: this.props.accessLevel,
            disabled: (0, $9g4SS.default).IsNullOrEmpty(this.props.SystemStatusMessages)
        }, "Delete All Messages");
        const messages = (0, $9g4SS.default).sortArrayWithProperty((0, $hrtGQ.SortOrder).Desc, this.props.SystemStatusMessages, 'Timestamp').map((smi, index)=>{
            const accessLevel = (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).getAccessLevelForObject(smi, this.props.accessLevel);
            return $acw62.createElement((0, $fcc1cb9accc8e1b0$export$7d7cadd872a7f3dc), {
                adaptableObject: smi,
                key: 'smi' + index,
                onEdit: null,
                moduleInfo: this.props.moduleInfo,
                colItems: $7daa9dcd7ea9e080$var$colItems,
                api: this.props.api,
                accessLevel: accessLevel,
                teamSharingActivated: this.props.teamSharingActivated,
                onDeleteConfirm: null,
                onShare: null
            });
        });
        return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
            button: clearAllButton,
            headerText: this.props.moduleInfo.FriendlyName,
            infoLink: this.props.moduleInfo.HelpPage,
            infoLinkDisabled: !this.props.api.internalApi.isDocumentationLinksDisplayed()
        }, (0, $9g4SS.default).IsNotNullOrEmpty(this.props.SystemStatusMessages) && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "ab-SystemStatus-Popup-List twa:p-2"
        }, $acw62.createElement((0, $0c63d8e3bfa8e1c3$export$c87e7bbb66bb77f7), {
            colItems: $7daa9dcd7ea9e080$var$colItems,
            items: messages
        })));
    }
}
function $7daa9dcd7ea9e080$var$mapStateToProps(state, ownProps) {
    return {
        SystemStatusMessageInfos: state.Internal.SystemStatusMessages,
        SystemStatusMessages: state.Internal.SystemStatusMessages
    };
}
function $7daa9dcd7ea9e080$var$mapDispatchToProps(dispatch) {
    return {
        onSystemStatusMessageInfoDeleteAll: ()=>dispatch($5b564bb703f29152$export$939ffb83766a0a85())
    };
}
let $7daa9dcd7ea9e080$export$efb1b9ba5e9e0b2a = (0, $55388fc2f116d4d7$export$64605811ab45167f)($7daa9dcd7ea9e080$var$mapStateToProps, $7daa9dcd7ea9e080$var$mapDispatchToProps)($7daa9dcd7ea9e080$var$SystemStatusPopupComponent);



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

class $949eb332a4e17e68$export$b04863f4be28ad91 extends $acw62.Component {
    render() {
        const { showText: showText, showIcon: showIcon, ...innerProps } = this.props;
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "clear",
            tooltip: "Clear",
            iconSize: 20,
            icon: showIcon == false ? '' : 'close',
            ...innerProps,
            variant: "text"
        }, showText ? 'Clear' : '');
    }
}



class $2afd3d36e004f0c0$var$AlertViewPanelComponent extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            ShowMessage: false,
            Alerts: this.props.AdaptableAlerts
        };
    }
    componentDidUpdate() {
        if (this.state.Alerts.length != this.props.AdaptableAlerts.length) this.setState({
            ShowMessage: true,
            Alerts: this.props.AdaptableAlerts
        });
    }
    render() {
        const { color: buttonTextColor, background: buttonBackground } = (0, $f0dfcbaaec308d70$export$7ee14007d4852d6)(this.props.AdaptableAlerts);
        const collapsedText = this.props.AdaptableAlerts.length == 0 ? '0 Alerts' : this.props.AdaptableAlerts.length == 1 ? '1 Alert' : this.props.AdaptableAlerts.length + ' Alerts';
        const alertsPanel = $acw62.createElement((0, $d307fa676f2a25b1$export$71257f160d78693e), null);
        const isToolbar = this.props.viewType === 'Toolbar';
        const elementType = isToolbar ? 'DashboardToolbar' : 'ToolPanel';
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "stretch",
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`ab-${elementType}__Alert__wrap twa:gap-1`, {
                'twa:min-w-[140px] twa:w-[140px]': isToolbar,
                [`twa:flex-1`]: !isToolbar
            })
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            key: `${buttonTextColor}_${buttonBackground}_${collapsedText}`,
            className: `ab-${elementType}__Alert__text twa:flex-1 twa:rounded-standard twa:p-2 text-2 twa:items-center twa:justify-center twa:min-h-input`,
            style: {
                color: buttonTextColor,
                backgroundColor: buttonBackground
            }
        }, collapsedText), this.props.AdaptableAlerts.length > 0 && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: 'twa:gap-1'
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:flex twa:box-border"
        }, $acw62.createElement((0, $949eb332a4e17e68$export$b04863f4be28ad91), {
            "aria-label": 'Clear All Alerts',
            variant: 'outlined',
            className: `ab-${elementType}__Alert__clear`,
            onClick: ()=>this.props.onDeleteAllAlert(this.state.Alerts),
            tooltip: "Clear All Alerts",
            showText: this.props.viewType === 'ToolPanel'
        }, 'Clear Alerts')), $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
            className: `ab-${elementType}__Alert__info`,
            headerText: "Alerts Details",
            bodyText: [
                alertsPanel
            ],
            MessageType: 'Info',
            useButton: true,
            showEvent: 'focus',
            hideEvent: "blur",
            popoverMinWidth: 400
        })));
    }
}
function $2afd3d36e004f0c0$var$mapStateToProps(state, ownProps) {
    return {
        AlertDefinitions: state.Alert.AlertDefinitions,
        AdaptableAlerts: state.Internal.AdaptableAlerts
    };
}
function $2afd3d36e004f0c0$var$mapDispatchToProps(dispatch) {
    return {
        onDeleteAlert: (alert)=>dispatch($5b564bb703f29152$export$733f39b35c905b3d(alert)),
        onDeleteAllAlert: (alerts)=>dispatch($5b564bb703f29152$export$1fa9ee6ea5769397(alerts))
    };
}
const $2afd3d36e004f0c0$export$56824573e79b0fc9 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($2afd3d36e004f0c0$var$mapStateToProps, $2afd3d36e004f0c0$var$mapDispatchToProps)($2afd3d36e004f0c0$var$AlertViewPanelComponent);



var $acw62 = parcelRequire("acw62");

var $hrtGQ = parcelRequire("hrtGQ");




var $9OAZF = parcelRequire("9OAZF");

var $acw62 = parcelRequire("acw62");

class $88289245888644a1$export$f1a2d368aed6b73e extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "apply",
            tooltip: "Apply",
            iconSize: 20,
            icon: "check",
            variant: "outlined",
            ...this.props
        });
    }
}




var $5aWMQ = parcelRequire("5aWMQ");





class $27fffdda7aeb12e3$var$BulkUpdateViewPanelComponent extends $acw62.Component {
    cleanupEvent;
    constructor(props){
        super(props);
        this.state = {
            Disabled: true
        };
    }
    componentDidMount() {
        if (this.props.api) {
            let adaptable = this.props.api.internalApi.getAdaptableInstance();
            if (adaptable) this.cleanupEvent = adaptable._on('CellsSelected', ()=>{
                this.checkSelectedCells();
            });
        }
        this.checkSelectedCells();
    }
    componentWillUnmount() {
        this.cleanupEvent?.();
    }
    render() {
        let statusColour = this.getStatusColour();
        let selectedColumn = this.props.BulkUpdateValidationResult.Column;
        let previewPanel = $acw62.createElement((0, $dab8d46725028be5$export$5a0a2ad814f1ffcd), {
            previewInfo: this.props.PreviewInfo,
            api: this.props.api,
            selectedColumn: selectedColumn,
            showPanel: true,
            showHeader: false
        });
        const valueSelectorDisabled = this.props.accessLevel == 'ReadOnly' || !this.props.BulkUpdateValidationResult.IsValid || this.props.api.layoutApi.isCurrentLayoutPivot();
        const valueOperationDisabled = valueSelectorDisabled || (0, $9OAZF.StringExtensions).IsNullOrEmpty(this.props.BulkUpdateValue) || this.props.PreviewInfo != null && this.props.PreviewInfo.previewValidationSummary.validationResult == 'All';
        const applyStyle = {
            color: statusColour,
            fill: 'currentColor'
        };
        const isToolbar = this.props.viewType === 'Toolbar';
        const elementType = isToolbar ? 'DashboardToolbar' : 'ToolPanel';
        const messageStyle = (0, $5aWMQ.UIHelper).getMessageTypeByStatusColour(statusColour);
        const infoStyle = messageStyle === 'Success' ? 'Info' : messageStyle;
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(valueSelectorDisabled ? $58846ea7f4156db7$export$2c59109bdd218c0 : '', `ab-${elementType}__BulkUpdate__wrap twa:gap-1 twa:flex-row`, {
                'twa:min-w-[300px] twa:max-w-[300px] twa:w-[300px] twa:flex-nowrap': isToolbar,
                'twa:flex-1 twa:flex-wrap': !isToolbar
            }),
            flexWrap: isToolbar ? 'nowrap' : 'wrap'
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:flex-1', {
                'twa:min-w-[100px]': !isToolbar,
                'twa:min-w-0': isToolbar
            })
        }, $acw62.createElement((0, $9a29e8ecea9ea872$export$6b9fba00b1ebf903), {
            selectedGridCells: this.props.SelectedGridCells,
            newLabel: "New",
            existingLabel: "Existing",
            dropdownButtonProps: {
                listMinWidth: 160
            },
            className: `ab-${elementType}__BulkUpdate__select twa:w-full`,
            disabled: valueSelectorDisabled,
            selectedColumnValue: this.props.BulkUpdateValue,
            selectedColumn: selectedColumn,
            api: this.props.api,
            onColumnValueChange: (columns)=>this.onColumnValueSelectedChanged(columns)
        })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:flex-shrink-0 twa:gap-1"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:flex twa:box-border twa:items-center"
        }, $acw62.createElement((0, $88289245888644a1$export$f1a2d368aed6b73e), {
            className: `ab-${elementType}__BulkUpdate__apply twa:h-full`,
            onClick: ()=>this.onApplyClick(),
            style: applyStyle,
            tooltip: "Apply Bulk Update",
            disabled: valueOperationDisabled,
            accessLevel: this.props.accessLevel
        }, 'Apply')), $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
            popoverMinWidth: 360,
            popoverMaxWidth: 500,
            popupPadding: 0,
            className: `ab-${elementType}__BulkUpdate__info`,
            headerText: "Preview Results",
            bodyText: [
                previewPanel
            ],
            MessageType: infoStyle,
            useButton: true,
            showEvent: 'focus',
            hideEvent: "blur",
            disabled: valueSelectorDisabled || (0, $9OAZF.StringExtensions).IsNullOrEmpty(this.props.BulkUpdateValue)
        })));
    }
    onColumnValueSelectedChanged(selectedColumnValue) {
        this.props.onBulkUpdateValueChange(selectedColumnValue);
    }
    checkSelectedCells() {
        this.props.onBulkUpdateCheckSelectedCells();
        if ((0, $9OAZF.StringExtensions).IsNotNullOrEmpty(this.props.BulkUpdateValue)) this.props.onBulkUpdateValueChange('');
    }
    getStatusColour() {
        if ((0, $9OAZF.StringExtensions).IsNotNullOrEmpty(this.props.BulkUpdateValue) && this.props.PreviewInfo) {
            if (this.props.PreviewInfo.previewValidationSummary.validationResult == 'All') return (0, $hrtGQ.StatusColour).Error;
            if (this.props.PreviewInfo.previewValidationSummary.validationResult == 'Some') return (0, $hrtGQ.StatusColour).Warn;
        }
        return (0, $hrtGQ.StatusColour).Success;
    }
    onApplyClick() {
        this.props.onApplyBulkUpdate();
        this.props.onBulkUpdateValueChange(undefined);
    }
}
function $27fffdda7aeb12e3$var$mapStateToProps(state, ownProps) {
    return {
        SelectedGridCells: state.Internal.SelectedCellInfo?.gridCells,
        BulkUpdateValue: state.Internal.BulkUpdate.BulkUpdateValue,
        BulkUpdateValidationResult: state.Internal.BulkUpdate.BulkUpdateValidationResult,
        PreviewInfo: state.Internal.BulkUpdate.BulkUpdatePreviewInfo
    };
}
function $27fffdda7aeb12e3$var$mapDispatchToProps(dispatch) {
    return {
        onBulkUpdateValueChange: (value)=>dispatch($5b564bb703f29152$export$eebc2801a7081e3f(value)),
        onBulkUpdateCheckSelectedCells: ()=>dispatch($5b564bb703f29152$export$d4ac7f658a02fdce()),
        onApplyBulkUpdate: ()=>dispatch($8713f41926484273$export$95e3d38d99d65522(false))
    };
}
let $27fffdda7aeb12e3$export$9ffc51341cb2860d = (0, $55388fc2f116d4d7$export$64605811ab45167f)($27fffdda7aeb12e3$var$mapStateToProps, $27fffdda7aeb12e3$var$mapDispatchToProps)($27fffdda7aeb12e3$var$BulkUpdateViewPanelComponent);



var $acw62 = parcelRequire("acw62");


var $hrtGQ = parcelRequire("hrtGQ");

var $9g4SS = parcelRequire("9g4SS");

var $acw62 = parcelRequire("acw62");

const $f8eb78f27c7ba62d$export$672106b25adcad36 = (props)=>{
    return $acw62.createElement((0, $2b7a09b743acf941$export$ee8c64b8520d04c6), {
        CellSummary: props.CellSummary
    });
};









class $4cb59ce417ff5736$var$CellSummaryViewPanelComponent extends $acw62.Component {
    cleanupEvent;
    constructor(props){
        super(props);
    }
    componentDidMount() {
        let adaptable = this.props.api.internalApi.getAdaptableInstance();
        if (adaptable) this.cleanupEvent = adaptable._on('CellsSelected', ()=>{
            this.checkSelectedCells();
        });
        this.checkSelectedCells();
    }
    componentWillUnmount() {
        this.cleanupEvent?.();
    }
    render() {
        let operationMenuItems = (0, $3ca1f4c2b77d4ce9$export$51594d8e7854ff7d).getNames((0, $hrtGQ.SummaryOperation)).map((summaryOperation, index)=>{
            return {
                label: summaryOperation,
                value: summaryOperation
            };
        });
        const cellSummaryOperationDefinitions = this.props.api.cellSummaryApi.getCustomCellSummaryOperations();
        const operationDefinitions = (0, $9g4SS.default).IsNullOrEmpty(cellSummaryOperationDefinitions) ? [] : cellSummaryOperationDefinitions.map((operationDefinition)=>{
            return {
                value: operationDefinition.operationName,
                label: operationDefinition.operationName
            };
        });
        let cellSummaryPopover = $acw62.createElement((0, $f8eb78f27c7ba62d$export$672106b25adcad36), {
            CellSummary: this.props.CellSummary
        });
        let shouldDisable = this.props.accessLevel == 'ReadOnly' || this.props.CellSummary == null;
        const isToolbar = this.props.viewType === 'Toolbar';
        const elementType = isToolbar ? 'DashboardToolbar' : 'ToolPanel';
        const operationValue = this.getOperationValue() ?? 'N/A';
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(shouldDisable ? $58846ea7f4156db7$export$2c59109bdd218c0 : '', `ab-${elementType}__CellSummary__wrap twa:gap-2 twa:flex-row`, {
                'twa:min-w-[215px] twa:max-w-[215px] twa:w-[215px] twa:flex-nowrap': isToolbar,
                'twa:flex-1 twa:flex-wrap': !isToolbar
            })
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:flex-1"
        }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
            "aria-label": "Cell Summary Operation Selector",
            className: `ab-${elementType}__CellSummary__select twa:w-full`,
            disabled: shouldDisable,
            options: [
                ...operationMenuItems,
                ...operationDefinitions
            ],
            onChange: (x)=>this.props.onCellSummaryOperationChange(x),
            value: this.props.CellSummaryOperation
        })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:items-center twa:gap-1"
        }, $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`ab-${elementType}__CellSummary__value twa:min-w-[50px]`, {
                'twa:rounded-standard twa:text-color-text-on-info twa:bg-color-info twa:text-2': !isToolbar,
                'twa:flex-1 twa:text-color-text-on-primary twa:justify-center': isToolbar
            })
        }, operationValue), $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
            popoverMaxWidth: 360,
            className: "ab-ToolPanel__CellSummary__info",
            bodyText: [
                cellSummaryPopover
            ],
            useButton: true,
            showEvent: 'focus',
            hideEvent: "blur",
            tooltipText: 'Show Cell Summaries',
            disabled: !this.props.CellSummary?.Count
        }))));
    }
    checkSelectedCells() {
        this.props.onCreateCellSummary();
    }
    getOperationValue() {
        return this.props.api.cellSummaryApi.getCellSummaryOperationValue(this.props.CellSummaryOperation);
    }
}
function $4cb59ce417ff5736$var$mapStateToProps(state, ownProps) {
    return {
        SelectedCellInfo: state.Internal.SelectedCellInfo,
        CellSummaryOperation: state.Internal.CellSummary.CellSummaryOperation,
        CellSummary: state.Internal.CellSummary.CellSummaryInfo
    };
}
function $4cb59ce417ff5736$var$mapDispatchToProps(dispatch) {
    return {
        onCellSummaryOperationChange: (summaryOperation)=>dispatch($5b564bb703f29152$export$4379228241b0773f(summaryOperation)),
        onCreateCellSummary: ()=>dispatch($5b564bb703f29152$export$1e02d3cd4f056ef1())
    };
}
let $4cb59ce417ff5736$export$bb3b60cacf4656ce = (0, $55388fc2f116d4d7$export$64605811ab45167f)($4cb59ce417ff5736$var$mapStateToProps, $4cb59ce417ff5736$var$mapDispatchToProps)($4cb59ce417ff5736$var$CellSummaryViewPanelComponent);




var $acw62 = parcelRequire("acw62");


var $9g4SS = parcelRequire("9g4SS");








class $bb8f9c2dee17651a$var$FilterViewPanelComponent extends $acw62.Component {
    constructor(props){
        super(props);
    }
    render() {
        const elementType = this.props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
        const isAtLeastOneFilterActive = this.props.api.filterApi.columnFilterApi.getActiveColumnFilters().length > 0;
        const isAtLeastOneFilter = this.props.api.filterApi.columnFilterApi.getColumnFilters().length > 0;
        const handleSuspendUnsuspendAll = ()=>{
            if (isAtLeastOneFilterActive) this.props.api.filterApi.columnFilterApi.suspendAllColumnFilters();
            else this.props.api.filterApi.columnFilterApi.unSuspendAllColumnFilters();
        };
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "row",
            className: `ab-${elementType}__Filter__wrap`,
            flexWrap: this.props.viewType === 'ToolPanel' ? 'wrap' : 'nowrap'
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, (0, $9g4SS.ArrayExtensions).IsNotNullOrEmpty(this.props.ColumnFilters) && $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
            popupPadding: 0,
            className: `ab-${elementType}__Filter__info`,
            headerText: "",
            bodyText: [
                $acw62.createElement((0, $e706c69e752e91b5$export$db90d729d8e01fb3), null)
            ],
            useButton: true,
            showEvent: 'focus',
            hideEvent: "blur",
            popoverMinWidth: 400
        }), $acw62.createElement((0, $949eb332a4e17e68$export$b04863f4be28ad91), {
            "aria-label": 'Clear Filters',
            className: `ab-${elementType}__Filter__clear twa:mx-1 twa:mb-0`,
            onClick: ()=>this.onClearFilters(),
            tooltip: "Clear Filters",
            disabled: this.props.ColumnFilters.length == 0,
            showText: this.props.viewType === 'ToolPanel'
        }, this.props.viewType === 'ToolPanel' && 'Clear'), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "aria-label": isAtLeastOneFilterActive ? 'Suspend All Filters' : 'Resume All Filters',
            className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(`ab-${elementType}__Filter__suspend-button`, isAtLeastOneFilterActive && `ab-${elementType}__Filter__suspend-all`, !isAtLeastOneFilterActive && `ab-${elementType}__Filter__un-suspend-all`),
            disabled: !isAtLeastOneFilter,
            onClick: handleSuspendUnsuspendAll,
            tone: isAtLeastOneFilterActive ? 'neutral' : 'success',
            variant: "text",
            icon: isAtLeastOneFilterActive ? 'pause' : 'play',
            accessLevel: this.props.accessLevel
        })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center"
        }, this.props.api.filterApi.columnFilterApi.isQuickFilterAvailable() && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            "data-name": "quick-filter-toggle",
            className: `ab-${elementType}__Filter__active-check twa:my-0 twa:text-2 twa:p-1`,
            disabled: this.props.accessLevel === 'ReadOnly' || this.props.api.layoutApi.isCurrentLayoutPivot(),
            checked: this.props.IsQuickFilterVisible,
            onChange: (checked)=>{
                checked ? this.props.onShowQuickFilterBar() : this.props.onHideQuickFilterBar();
            }
        }, "Filter Bar")));
    }
    onClearFilters() {
        this.props.api.filterApi.columnFilterApi.clearColumnFilters();
    }
}
function $bb8f9c2dee17651a$var$mapStateToProps(state) {
    return {
        ColumnFilters: (0, $2c155f3e4804e29e$export$5decca837c0b76db)(state),
        IsQuickFilterVisible: state.Internal.IsQuickFilterVisible
    };
}
function $bb8f9c2dee17651a$var$mapDispatchToProps(dispatch) {
    return {
        onHideQuickFilterBar: ()=>dispatch($5b564bb703f29152$export$bffa6555fdf75754()),
        onShowQuickFilterBar: ()=>dispatch($5b564bb703f29152$export$c8d88f519547e598())
    };
}
const $bb8f9c2dee17651a$export$5e59a1b2b80445d4 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($bb8f9c2dee17651a$var$mapStateToProps, $bb8f9c2dee17651a$var$mapDispatchToProps)($bb8f9c2dee17651a$var$FilterViewPanelComponent);




var $acw62 = parcelRequire("acw62");



var $9g4SS = parcelRequire("9g4SS");

class $dd5640f82355729c$var$DashboardViewPanelComponent extends $acw62.Component {
    constructor(props){
        super(props);
    }
    render() {
        const elementType = this.props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "row",
            className: `ab-${elementType}__Dashboard__wrap`,
            flexWrap: this.props.viewType === 'ToolPanel' ? 'wrap' : 'nowrap'
        }, ' ', (0, $9g4SS.default).IsNotNullOrEmpty(this.props.api.dashboardApi.getDashboardState().Tabs) && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            className: `ab-${elementType}__Dashboard__collapsed-check twa:mt-0 twa:text-2 twa:p-1`,
            checked: this.props.IsCollapsed,
            onChange: (checked)=>this.props.onSetDashboardCollapsed(checked)
        }, "Collapse"), '', this.props.api.optionsApi.getDashboardOptions().canFloat && $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            className: `ab-${elementType}__Dashboard__collapsed-check twa:mt-0 twa:text-2 twa:p-1`,
            checked: this.props.IsFloating,
            onChange: (checked)=>this.props.onSetDashboardFloating(checked)
        }, "Float"), ' ', $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            className: `ab-${elementType}__Dashboard__hidden-check twa:mt-0 twa:text-2 twa:p-1`,
            checked: this.props.IsHidden,
            onChange: (checked)=>this.props.onSetDashboardHidden(checked)
        }, "Hidden"));
    }
}
function $dd5640f82355729c$var$mapStateToProps(state, ownProps) {
    return {
        IsCollapsed: state.Dashboard.IsCollapsed,
        IsHidden: state.Dashboard.IsHidden,
        IsFloating: state.Dashboard.IsFloating
    };
}
function $dd5640f82355729c$var$mapDispatchToProps(dispatch) {
    return {
        onSetDashboardCollapsed: (isCollapsed)=>dispatch($dc6bc6f406d56c84$export$4a9fdbf5568e83b6(isCollapsed)),
        onSetDashboardHidden: (isHidden)=>dispatch($dc6bc6f406d56c84$export$b2de5be7510594c1(isHidden)),
        onSetDashboardFloating: (isFloating)=>dispatch($dc6bc6f406d56c84$export$d83abcde9deec805(isFloating))
    };
}
let $dd5640f82355729c$export$ad2fb329bb32d88f = (0, $55388fc2f116d4d7$export$64605811ab45167f)($dd5640f82355729c$var$mapStateToProps, $dd5640f82355729c$var$mapDispatchToProps)($dd5640f82355729c$var$DashboardViewPanelComponent);



var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");


const $638939172b36e064$export$eda4ac1f0f4bc860 = (props)=>{
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "new",
        tone: props.tone || 'accent',
        icon: "plus",
        variant: props.variant || 'raised',
        tooltip: props.tooltip || 'New',
        accessLevel: props.accessLevel,
        onClick: props.onClick,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)(`twa:flex twa:flex-row twa:items-center`, props.className)
    }, props.children === undefined ? 'New' : props.children);
};



var $acw62 = parcelRequire("acw62");

const $cb264e95861b0567$export$d73c3aa70637f13a = (props)=>{
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "schedule",
        tooltip: "Schedule",
        iconSize: 20,
        icon: "schedule",
        variant: "text",
        ...props
    });
};







const $071db7aceca292b4$export$792e2fdfffef6e0 = (props)=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const exportApi = props.api.exportApi;
    const userReports = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Export.Reports);
    const currentReportName = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Export.CurrentReport);
    const currentFormat = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Export.CurrentFormat);
    const currentReport = exportApi.getReportByName(currentReportName);
    const accessLevel = (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).getAccessLevelForObject(currentReport, props.accessLevel);
    const deleteMessage = currentReport ? `Are you sure you want to delete '${currentReport.Name}'?` : 'Are you sure you want to delete this report?';
    const isToolbar = props.viewType === 'Toolbar';
    const elementType = isToolbar ? 'DashboardToolbar' : 'ToolPanel';
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`ab-${elementType}__CellSummary__wrap twa:gap-1 twa:flex-row`, {
            'twa:min-w-[486px] twa:flex-nowrap': isToolbar,
            'twa:flex-1 twa:flex-wrap': !isToolbar
        })
    }, $acw62.createElement((0, $70bf682cdf60405e$export$6fd82bc2349fee66), {
        viewType: props.viewType,
        reportName: currentReportName,
        userReports: userReports,
        onReportNameSelected: (reportName)=>exportApi.selectReport(reportName)
    }), $acw62.createElement((0, $cf8aebbb61cbdf00$export$673b1a0e3cf8a45), {
        viewType: props.viewType,
        reportName: currentReportName,
        reportFormat: currentFormat,
        onReportFormatSelected: (reportFormat)=>exportApi.selectFormat(reportFormat)
    }), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(accessLevel == 'ReadOnly' ? $58846ea7f4156db7$export$2c59109bdd218c0 : '', `ab-${elementType}__Export__controls twa:w-full`)
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:min-w-[44px]"
    }, $acw62.createElement((0, $8f7346cae58bd86f$export$469a85d60b6734a5), {
        viewType: props.viewType,
        reportName: currentReportName,
        reportFormat: currentFormat
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, $acw62.createElement((0, $c98867b89f88548d$export$f8a35005a0ddce8d), {
        onClick: ()=>dispatch($dc56b6267ce4d0bb$export$e2d5bba0b444685d($42e863194fcb493f$export$2bc329d2b6ae03ac, props.moduleInfo.Popup, {
                action: 'Edit',
                source: 'Toolbar'
            })),
        tooltip: "Edit Report",
        className: `ab-${elementType}__Export__edit`,
        disabled: currentReport == null,
        accessLevel: accessLevel
    }), $acw62.createElement((0, $638939172b36e064$export$eda4ac1f0f4bc860), {
        variant: "text",
        className: `ab-${elementType}__Export__new`,
        tone: "neutral",
        children: null,
        onClick: ()=>dispatch($dc56b6267ce4d0bb$export$e2d5bba0b444685d($42e863194fcb493f$export$2bc329d2b6ae03ac, props.moduleInfo.Popup, {
                action: 'New',
                source: 'Toolbar'
            })),
        tooltip: "Create New Report",
        accessLevel: props.accessLevel
    }), $acw62.createElement((0, $52184ede7cf4a09d$export$6c2dcda0a6ef7fa6), {
        tooltip: "Delete Report",
        className: `ab-${elementType}__Export__delete`,
        disabled: currentReport == null,
        ConfirmAction: $a3814690501f278b$export$4373a255555364a8(currentReport),
        ConfirmationMsg: deleteMessage,
        ConfirmationTitle: 'Delete Report',
        accessLevel: accessLevel
    }), props.api.entitlementApi.isModuleFullEntitlement('Schedule') && $acw62.createElement((0, $cb264e95861b0567$export$d73c3aa70637f13a), {
        className: `ab-${elementType}__Export__schedule`,
        onClick: ()=>{
            const reportSchedule = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateReportSchedule(currentReportName, currentFormat);
            dispatch($dc56b6267ce4d0bb$export$e2d5bba0b444685d($42e863194fcb493f$export$5dd6e67bf681ede8, 'SchedulePopup', {
                action: 'New',
                source: 'Toolbar',
                value: reportSchedule
            }));
        },
        tooltip: "Schedule",
        disabled: currentReport == null,
        accessLevel: props.accessLevel
    }))));
};



var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");

const $a741ad6fa9fa8edb$export$4131efd656a05c47 = (props)=>{
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "clone",
        tooltip: "Clone",
        tone: "accent",
        icon: "clone",
        variant: "raised",
        ...props
    }, props.children === undefined ? 'Clone' : props.children);
};








const $704cfbf03813c33a$export$5fd5f7863d989ddb = 'LayoutEditorStandalonePopup';
const $704cfbf03813c33a$var$LayoutViewPanelComponent = (props)=>{
    const { Layouts: Layouts, CurrentLayoutName: CurrentLayoutName, accessLevel: accessLevel, viewType: viewType, api: api, onSelectLayout: onSelectLayout, showMissingLayoutsError: showMissingLayoutsError } = props;
    const isErrorLayout = !Layouts.length || Layouts.length === 1 && (0, $f94a32af7542d5ef$export$2e2bcd8739ae039)(Layouts[0], (0, $58846ea7f4156db7$export$2657cb1ad92c69eb));
    $acw62.useEffect(()=>{
        if (isErrorLayout) showMissingLayoutsError();
    }, [
        isErrorLayout
    ]);
    const layoutEntity = Layouts.find((x)=>x.Name === CurrentLayoutName || x.Uuid === CurrentLayoutName);
    // the global access level (Layout Entitlement)
    const cloneAccessLevel = accessLevel;
    const newAccessLevel = accessLevel;
    const entityAccessLevel = (0, $792d5f2a0e72dfac$export$2e2bcd8739ae039).getAccessLevelForObject(layoutEntity, accessLevel);
    // Layout options for select
    const availableLayoutOptions = Layouts.map((layout)=>({
            ...layout,
            label: layout.Name,
            value: layout.Name,
            onClick: ()=>onSelectLayout(layout.Name)
        }));
    const elementType = viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
    const layoutSelectStyle = elementType === 'ToolPanel' ? {
        minWidth: '100%'
    } : {};
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        className: `ab-${elementType}__Layout__wrap`,
        flexWrap: viewType === 'ToolPanel' ? 'wrap' : 'nowrap'
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        style: layoutSelectStyle,
        className: "twa:flex-1"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        "aria-label": 'Select Layout',
        disabled: isErrorLayout,
        style: {
            width: '100%'
        },
        options: availableLayoutOptions,
        className: `ab-${elementType}__Layout__select`,
        value: layoutEntity ? layoutEntity.Name : null,
        onChange: (layout)=>onSelectLayout(layout)
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(accessLevel === 'ReadOnly' ? $58846ea7f4156db7$export$2c59109bdd218c0 : '', `ab-${elementType}__Layout__wrap`)
    }, $acw62.createElement((0, $c98867b89f88548d$export$f8a35005a0ddce8d), {
        disabled: isErrorLayout,
        onClick: ()=>api.layoutApi.showLayoutEditor(layoutEntity.Name),
        tooltip: (0, $58846ea7f4156db7$export$dd6e5189d7d26f8e),
        className: `ab-${elementType}__Layout__edit`,
        accessLevel: entityAccessLevel
    }), $acw62.createElement((0, $a741ad6fa9fa8edb$export$4131efd656a05c47), {
        disabled: isErrorLayout,
        onClick: ()=>api.layoutApi.showLayoutEditor(layoutEntity.Name, (0, $702a77ed6db22640$export$db5fe50348e92ffe)(layoutEntity) ? 'pivot' : 'table', 'Clone'),
        tooltip: (0, $58846ea7f4156db7$export$e8d786c594bb1b7e),
        className: `ab-${elementType}__Layout__clone`,
        tone: "neutral",
        variant: "text",
        children: null,
        accessLevel: cloneAccessLevel
    }), $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        variant: "text",
        tooltip: (0, $58846ea7f4156db7$export$676359c448a5b42f),
        columns: [
            'label'
        ],
        "data-name": "new",
        items: [
            {
                dataName: 'table',
                label: $acw62.createElement("span", {
                    style: {
                        whiteSpace: 'nowrap'
                    }
                }, "Table Layout"),
                onClick: ()=>api.layoutApi.showLayoutEditor(null, 'table', 'New')
            },
            {
                dataName: 'pivot',
                disabled: api.gridApi.isTreeDataGrid(),
                label: $acw62.createElement("span", {
                    style: {
                        whiteSpace: 'nowrap'
                    }
                }, "Pivot Layout"),
                onClick: ()=>api.layoutApi.showLayoutEditor(null, 'pivot', 'New')
            }
        ],
        tone: "neutral",
        accessLevel: newAccessLevel,
        className: `ab-${elementType}__Layout__new`
    }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "plus"
    })), $acw62.createElement((0, $52184ede7cf4a09d$export$6c2dcda0a6ef7fa6), {
        tooltip: (0, $58846ea7f4156db7$export$36d56111919541aa),
        disabled: Layouts.length <= 1,
        className: `ab-${elementType}__Layout__delete`,
        ConfirmAction: $2c155f3e4804e29e$export$16171190943cf4cb(layoutEntity),
        ConfirmationMsg: `Are you sure you want to delete '${CurrentLayoutName}'?`,
        ConfirmationTitle: 'Delete Layout',
        accessLevel: entityAccessLevel
    })));
};
function $704cfbf03813c33a$var$mapStateToProps(state, ownProps) {
    const CurrentLayoutName = state.Layout.CurrentLayout;
    const Layouts = state.Layout.Layouts || [
        (0, $58846ea7f4156db7$export$2657cb1ad92c69eb)
    ];
    const CurrentLayout = Layouts.find((l)=>l.Name === CurrentLayoutName) || (0, $58846ea7f4156db7$export$2657cb1ad92c69eb);
    return {
        CurrentLayoutName: CurrentLayoutName,
        CurrentLayout: CurrentLayout,
        Layouts: Layouts
    };
}
function $704cfbf03813c33a$var$mapDispatchToProps(dispatch) {
    return {
        onSelectLayout: (layoutName)=>dispatch($2c155f3e4804e29e$export$256743b3edbbec77(layoutName)),
        onSaveLayout: (layout)=>{
            dispatch($2c155f3e4804e29e$export$ca72012c06bdea95(layout));
        },
        showMissingLayoutsError: ()=>{
            dispatch($dc56b6267ce4d0bb$export$93a4701be822446e({
                Header: 'Missing Layouts',
                Msg: 'No Layouts have been defined. Please check the console for details.',
                ConfirmAction: null,
                ConfirmButtonText: 'OK',
                CancelButtonText: null,
                CancelAction: null,
                ShowInputBox: false,
                MessageType: 'Error'
            }));
        }
    };
}
const $704cfbf03813c33a$export$9ede731e9a9e7453 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($704cfbf03813c33a$var$mapStateToProps, $704cfbf03813c33a$var$mapDispatchToProps)($704cfbf03813c33a$var$LayoutViewPanelComponent);



var $acw62 = parcelRequire("acw62");


var $9OAZF = parcelRequire("9OAZF");



var $acw62 = parcelRequire("acw62");

class $0a78809ac22eb981$export$c89166be9b7f8fec extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "expand",
            tooltip: "Expand",
            iconSize: 20,
            icon: "arrow-expand",
            variant: "text",
            ...this.props
        });
    }
}



var $acw62 = parcelRequire("acw62");

class $aa03fcf3d2a4652b$export$9d5cf46e47ef518b extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "invalid",
            tooltip: "Invalid",
            iconSize: 20,
            icon: "warning",
            ...this.props
        });
    }
}




var $acw62 = parcelRequire("acw62");

class $131499484a307d31$export$f3a86bc668ab2bcc extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "save",
            iconSize: 20,
            icon: "save",
            tooltip: "Save",
            variant: "text",
            ...this.props
        });
    }
}



var $acw62 = parcelRequire("acw62");

class $81a220ee4e885aba$export$6bb7cb30b61dadd4 extends $acw62.Component {
    render() {
        const buttonIcon = this.props.fillColor === 'red' ? {
            name: 'resume',
            style: {
                fill: 'red'
            }
        } : {
            name: 'resume'
        };
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "unsuspend",
            tooltip: "Pause",
            iconSize: 20,
            icon: buttonIcon,
            variant: "text",
            ...this.props
        });
    }
}



var $acw62 = parcelRequire("acw62");





var $hrtGQ = parcelRequire("hrtGQ");

var $9g4SS = parcelRequire("9g4SS");


var $acw62 = parcelRequire("acw62");

class $1e12051cf43b5db7$export$f2078ac3fd120623 extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "open",
            iconSize: 20,
            icon: "folder-open",
            tooltip: "Open",
            variant: "text",
            ...this.props
        });
    }
}



const $398749e37288ae2c$export$a54a23f08e85b4fb = (props)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        justifyContent: "space-around",
        className: "twa:text-start twa:w-full"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-2 twa:flex-1"
    }, props.label), $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, props.expression));
};
const $398749e37288ae2c$export$f92becc81113ee47 = (props)=>{
    const sortedNamedQueries = (0, $9g4SS.default).sortArrayWithProperty((0, $hrtGQ.SortOrder).Asc, props.namedQueries, 'Name') ?? [];
    const availableSearches = sortedNamedQueries.map((expression)=>{
        return {
            label: $acw62.createElement($398749e37288ae2c$export$a54a23f08e85b4fb, {
                label: expression.Name,
                expression: expression.BooleanExpression
            }),
            icon: expression.BooleanExpression === props.currentQuery ? $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: 'check'
            }) : null,
            onClick: ()=>props.onSelect(expression.BooleanExpression)
        };
    });
    const cachedQueries = (0, $9g4SS.default).IsNotNullOrEmpty(props.cachedQueries) ? props.cachedQueries.slice(-3).reverse().map((item)=>({
            label: $acw62.createElement($398749e37288ae2c$export$a54a23f08e85b4fb, {
                label: `Grid Filter at ${item.time.toLocaleTimeString('en-US')}`,
                expression: item.expression
            }),
            icon: $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                name: 'history'
            }),
            onClick: ()=>props.setGridFilterExpression(item.expression)
        })) : null;
    return (0, $9g4SS.default).IsNotNullOrEmpty(cachedQueries) || (0, $9g4SS.default).IsNotNullOrEmpty(availableSearches) ? $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
        tooltipText: "Load Named Query",
        showIcon: false,
        popoverMinWidth: 300,
        bodyText: [
            $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                flexDirection: "column",
                className: "twa:justify-stretch"
            }, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
                header: "Named Queries"
            }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                flexDirection: "column"
            }, availableSearches.map((item, index)=>{
                return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
                    className: "twa:mb-2",
                    variant: "text",
                    key: index,
                    onClick: item.onClick
                }, item.label);
            }))), cachedQueries ? $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
                className: "twa:mt-2",
                header: "Recent Grid Filters"
            }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
                flexDirection: "column"
            }, cachedQueries.map((cachedQuery, index)=>{
                return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
                    disabled: props.disabled,
                    className: "twa:mb-2",
                    variant: "text",
                    key: index,
                    onClick: cachedQuery.onClick
                }, cachedQuery.label);
            })))) : null)
        ]
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        disabled: props.disabled,
        variant: "text",
        icon: "folder-open"
    }, props.children)) : $acw62.createElement((0, $1e12051cf43b5db7$export$f2078ac3fd120623), {
        tooltip: "Load Named Query",
        disabled: true
    });
};



var $acw62 = parcelRequire("acw62");




var $9OAZF = parcelRequire("9OAZF");


const $d30ef87cbb80b526$export$243b9188ed62d392 = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const currentLayout = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>{
        return state.Layout.Layouts.find((l)=>l.Name == state.Layout.CurrentLayout);
    });
    const isReadOnly = Boolean(currentLayout?.IsReadOnly);
    const gridFilter = currentLayout?.GridFilter;
    const [isAdaptableReady, setIsAdaptableReady] = $acw62.useState(false);
    const [expression, setExpression] = $acw62.useState(()=>{
        return adaptable.api.filterApi.gridFilterApi.getCurrentGridFilterExpression();
    });
    const namedQueries = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.NamedQuery.NamedQueries) ?? [];
    const cachedQueries = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Internal.CachedQueries) ?? [];
    const isSuspended = gridFilter?.IsSuspended ?? false;
    const onAddCachedQuery = (cachedQuery)=>{
        dispatch($5b564bb703f29152$export$e93f0b899b9e8352(cachedQuery));
    };
    const gridFilterHelpPage = adaptable.ModuleService.getModuleById('GridFilter').moduleInfo.HelpPage;
    const gridFilterLinkDisabled = !adaptable.api.internalApi.isDocumentationLinksDisplayed();
    $acw62.useEffect(()=>{
        adaptable.api.eventApi.on('AdaptableReady', ()=>{
            setIsAdaptableReady(true);
        });
    }, []);
    $acw62.useEffect(()=>{
        if (gridFilter?.Expression != expression) setExpression(gridFilter?.Expression ?? '');
    }, [
        gridFilter?.Expression
    ]);
    const isExpressionValid = expression == '' || adaptable.api.internalApi.getQueryLanguageService().validateBoolean(expression, (0, $42e863194fcb493f$export$97c45942f844607e)).isValid;
    const isExpressionNamedQuery = namedQueries.find((sq)=>sq.BooleanExpression == expression) != null;
    const availableColumns = adaptable.api.columnApi.getColumns().map((col)=>{
        return {
            columnId: col.columnId,
            label: col.friendlyName,
            onClick: ()=>{
                // Bogdan - im sure there is a better way to do this check with fancy operators i dont know
                const newExp = (0, $9OAZF.default).IsNotNullOrEmpty(expression) ? expression : '';
                setExpression(newExp + `[${col.columnId}]`);
            }
        };
    });
    const clearQuery = ()=>{
        adaptable.api.filterApi.gridFilterApi.clearGridFilter();
        setExpression('');
    };
    const runQuery = (newExpression = expression)=>{
        if ((0, $9OAZF.default).IsNullOrEmpty(newExpression) && (0, $9OAZF.default).IsNotNullOrEmpty(gridFilter?.Expression)) {
            // user pressed enter key with an empty input => clear existing expression
            adaptable.api.filterApi.gridFilterApi.setGridFilterExpression('');
            return;
        }
        if (!adaptable.api.internalApi.getQueryLanguageService().validateBoolean(newExpression, (0, $42e863194fcb493f$export$97c45942f844607e)).isValid) return;
        if ((0, $9OAZF.default).IsNotNullOrEmpty(expression)) {
            let cachedQuery = {
                expression: expression,
                time: new Date()
            };
            if (cachedQuery) onAddCachedQuery(cachedQuery);
        }
        adaptable.api.filterApi.gridFilterApi.setGridFilterExpression(newExpression);
    };
    const gridFilterAccessLevel = $acw62.useMemo(()=>{
        return adaptable.api.entitlementApi.getEntitlementAccessLevelForModule((0, $42e863194fcb493f$export$4908330cb20abb96));
    }, []);
    const namedQueryModuleAccessLevel = adaptable.api.entitlementApi.getEntitlementAccessLevelForModule((0, $42e863194fcb493f$export$97c45942f844607e));
    const onShowNamedQueries = (value, popup)=>dispatch($dc56b6267ce4d0bb$export$e2d5bba0b444685d((0, $42e863194fcb493f$export$97c45942f844607e), popup, {
            action: 'New',
            source: 'Other',
            value: value
        }));
    const saveQuery = ()=>{
        const namedqueryPopuName = adaptable.api.internalApi.getModuleService().getModuleById((0, $42e863194fcb493f$export$97c45942f844607e)).moduleInfo.Popup;
        onShowNamedQueries(expression, namedqueryPopuName);
    };
    const suspendGridFilter = ()=>{
        adaptable.api.filterApi.gridFilterApi.suspendGridFilter();
    };
    const unSuspendGridFilter = ()=>{
        adaptable.api.filterApi.gridFilterApi.unSuspendGridFilter();
    };
    return {
        isReadOnly: isReadOnly,
        namedQueryModuleAccessLevel: namedQueryModuleAccessLevel,
        cachedQueries: cachedQueries,
        expression: expression,
        setExpression: setExpression,
        isExpressionNamedQuery: isExpressionNamedQuery,
        isExpressionValid: isExpressionValid,
        isSuspended: isSuspended,
        gridFilter: gridFilter,
        isAdaptableReady: isAdaptableReady,
        namedQueries: namedQueries,
        onAddCachedQuery: onAddCachedQuery,
        availableColumns: availableColumns,
        runQuery: runQuery,
        clearQuery: clearQuery,
        onExpand: ()=>adaptable.api.filterApi.gridFilterApi.openUIEditorForGridFilter(expression),
        saveQuery: saveQuery,
        suspendGridFilter: suspendGridFilter,
        unSuspendGridFilter: unSuspendGridFilter,
        setGridFilterExpression: (expression)=>{
            adaptable.api.filterApi.gridFilterApi.setGridFilterExpression(expression);
        },
        gridFilterAccessLevel: gridFilterAccessLevel,
        gridFilterHelpPage: gridFilterHelpPage,
        gridFilterLinkDisabled: gridFilterLinkDisabled
    };
};




const $a83a6b82c274b5d4$var$QueryViewPanelComponent = (props)=>{
    const { cachedQueries: cachedQueries, expression: expression, isExpressionNamedQuery: isExpressionNamedQuery, isExpressionValid: isExpressionValid, isSuspended: isSuspended, gridFilter: gridFilter, isAdaptableReady: isAdaptableReady, namedQueries: namedQueries, runQuery: runQuery, onExpand: onExpand, clearQuery: clearQuery, namedQueryModuleAccessLevel: namedQueryModuleAccessLevel, saveQuery: saveQuery, suspendGridFilter: suspendGridFilter, unSuspendGridFilter: unSuspendGridFilter, setGridFilterExpression: setGridFilterExpression, gridFilterAccessLevel: gridFilterAccessLevel, isReadOnly: isReadOnly } = (0, $d30ef87cbb80b526$export$243b9188ed62d392)();
    if (!isAdaptableReady) return null;
    const elementType = props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
    const disabled = isReadOnly || isSuspended || gridFilterAccessLevel === 'ReadOnly';
    const buttonExpand = $acw62.createElement((0, $0a78809ac22eb981$export$c89166be9b7f8fec), {
        disabled: disabled,
        accessLevel: gridFilterAccessLevel,
        variant: "text",
        tone: "neutral",
        onClick: onExpand,
        tooltip: "Edit the Expression in UI",
        className: "twa:ml-1"
    });
    const renderExpressionLabel = ()=>{
        const baseClasses = 'twa:font-mono twa:text-s twa:py-2 twa:px-2 twa:overflow-hidden twa:text-ellipsis twa:whitespace-nowrap twa:bg-defaultbackground twa:text-text-on-defaultbackground twa:rounded twa:cursor-pointer twa:leading-4 twa:flex twa:items-center';
        const placeholderClasses = 'twa:text-gray-400 twa:italic';
        const labelClassName = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(baseClasses, {
            [placeholderClasses]: !expression
        });
        const expressionLabel = $acw62.createElement((0, $0735c2b2ea9ec97d$export$2e2bcd8739ae039), {
            label: expression || 'Click to edit Grid Filter'
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:flex-1 twa:h-full twa:min-w-0', labelClassName),
            "data-name": "grid-filter-input",
            onClick: onExpand
        }, expression || 'Grid Filter...'));
        return $acw62.createElement((0, $952730cad4910d4d$export$2e2bcd8739ae039), {
            className: "twa:flex-1 twa:min-w-0 twa:min-h-input twa:overflow-visible"
        }, buttonExpand, expressionLabel, gridFilter && !isExpressionValid && $acw62.createElement((0, $aa03fcf3d2a4652b$export$9d5cf46e47ef518b), {
            variant: "text",
            tone: "neutral",
            tooltip: "Invalid Grid Filter"
        }));
    };
    const hasExpression = (0, $9OAZF.default).IsNotNullOrEmpty(expression);
    const hasActiveGridFilter = gridFilter != null && hasExpression;
    const hasNamedQueries = namedQueries && namedQueries.length > 0;
    const clearButton = hasExpression ? $acw62.createElement((0, $949eb332a4e17e68$export$b04863f4be28ad91), {
        onClick: ()=>clearQuery(),
        tooltip: "Clear Grid Filter",
        accessLevel: gridFilterAccessLevel,
        variant: "text",
        tone: "neutral"
    }) : null;
    const saveButton = hasExpression ? $acw62.createElement((0, $131499484a307d31$export$f3a86bc668ab2bcc), {
        onClick: ()=>saveQuery(),
        tooltip: "Save as Named Query",
        accessLevel: namedQueryModuleAccessLevel,
        disabled: isReadOnly || gridFilterAccessLevel === 'ReadOnly' || !isExpressionValid || isExpressionNamedQuery,
        variant: "text",
        tone: "neutral"
    }) : null;
    const suspendButton = hasActiveGridFilter ? $acw62.createElement((0, $39b7a9837b4e4ef1$export$9a3ab81a844a27ca), {
        onClick: ()=>suspendGridFilter(),
        tooltip: "Suspend Grid Filter",
        accessLevel: gridFilterAccessLevel,
        disabled: disabled || !isExpressionValid,
        variant: "text",
        tone: "neutral"
    }) : null;
    const unSuspendButton = hasActiveGridFilter ? $acw62.createElement((0, $81a220ee4e885aba$export$6bb7cb30b61dadd4), {
        onClick: ()=>unSuspendGridFilter(),
        tooltip: "Unsuspend Grid Filter",
        accessLevel: gridFilterAccessLevel,
        disabled: !isExpressionValid,
        variant: "text",
        tone: "neutral"
    }) : null;
    const namedQuerySelector = hasNamedQueries ? $acw62.createElement((0, $398749e37288ae2c$export$f92becc81113ee47), {
        namedQueries: namedQueries,
        cachedQueries: cachedQueries,
        currentQuery: gridFilter?.Expression,
        onSelect: (query)=>runQuery(query),
        setGridFilterExpression: (query)=>setGridFilterExpression(query)
    }) : null;
    const renderButtons = ()=>{
        return $acw62.createElement($acw62.Fragment, null, clearButton, isSuspended ? unSuspendButton : suspendButton, saveButton, namedQuerySelector);
    };
    const isToolbar = props.viewType === 'Toolbar';
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: isToolbar ? 'row' : 'column',
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`ab-${elementType}__Query__wrap`, {
            'twa:w-[500px]': isToolbar
        })
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            'twa:flex-1 twa:min-w-0': isToolbar
        })
    }, renderExpressionLabel()), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:flex-shrink-0', {
            'twa:pl-1': isToolbar,
            'twa:pt-1': !isToolbar
        })
    }, renderButtons()));
};
const $a83a6b82c274b5d4$export$3d916a3db120b9b2 = $a83a6b82c274b5d4$var$QueryViewPanelComponent;



var $acw62 = parcelRequire("acw62");

const $814cc0fbc574ca51$export$42dedef674ff16eb = (props)=>{
    let elementType = props.viewType === 'ToolPanel' ? 'DashboardToolbar' : 'ToolPanel';
    return $acw62.createElement((0, $24eb18c810e68a5c$export$29e8bfda34c26ba7), {
        className: `ab-${elementType}__QuickSearch__text`,
        inputClassName: "twa:w-[15rem]"
    });
};





var $hrtGQ = parcelRequire("hrtGQ");

var $acw62 = parcelRequire("acw62");

var $9OAZF = parcelRequire("9OAZF");






var $5aWMQ = parcelRequire("5aWMQ");




class $f2a47a599017ed55$var$SmartEditViewPanelComponent extends $acw62.Component {
    cleanupEvent;
    constructor(props){
        super(props);
        this.state = {
            SelectedColumnId: ''
        };
    }
    componentDidMount() {
        if (this.props.api) {
            const adaptable = this.props.api.internalApi.getAdaptableInstance();
            if (adaptable) this.cleanupEvent = adaptable._on('CellsSelected', ()=>{
                this.checkSelectedCells();
            });
        }
        this.checkSelectedCells();
    }
    componentWillUnmount() {
        this.cleanupEvent?.();
    }
    render() {
        let statusColour = this.getStatusColour();
        let selectedColumn = (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(this.state.SelectedColumnId) ? this.props.api.columnApi.getColumnWithColumnId(this.state.SelectedColumnId) : null;
        let previewPanel = $acw62.createElement((0, $dab8d46725028be5$export$5a0a2ad814f1ffcd), {
            previewInfo: this.props.PreviewInfo,
            api: this.props.api,
            selectedColumn: selectedColumn,
            showPanel: true,
            showHeader: false
        });
        const operationMenuItems = (0, $3ca1f4c2b77d4ce9$export$51594d8e7854ff7d).getNames((0, $hrtGQ.MathOperation)).map((mathOperation, index)=>{
            return {
                onClick: ()=>this.props.onSmartEditOperationChange(mathOperation),
                value: mathOperation,
                label: mathOperation
            };
        });
        const customOperations = this.props.api.smartEditApi.getSmartEditCustomOperations();
        if (customOperations?.length) operationMenuItems.push(...customOperations.map((operation)=>{
            return {
                onClick: ()=>this.props.onSmartEditOperationChange(operation),
                label: operation.name,
                value: operation
            };
        }));
        const applyButtonStyle = {
            color: statusColour,
            fill: 'currentColor'
        };
        let shouldDisable = this.props.accessLevel == 'ReadOnly' || !this.props.IsValidSelection || this.props.api.layoutApi.isCurrentLayoutPivot() == true;
        const elementType = this.props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "row",
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`ab-${elementType}__SmartEdit__wrap twa:gap-1 twa:flex-row`, {
                'twa:flex-nowrap': this.props.viewType === 'Toolbar',
                'twa:flex-wrap': this.props.viewType !== 'Toolbar'
            }),
            flexWrap: this.props.viewType === 'ToolPanel' ? 'wrap' : 'nowrap'
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:gap-1"
        }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
            "aria-label": 'Select Smart Edit Operation',
            value: typeof this.props.SmartEditOperation === 'object' ? this.props.SmartEditOperation.name : this.props.SmartEditOperation,
            options: operationMenuItems,
            onChange: (operation)=>this.props.onSmartEditOperationChange(operation)
        }), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
            style: {
                width: '5rem'
            },
            className: `ab-${elementType}__SmartEdit__select-value`,
            value: this.props.SmartEditValue.toString(),
            type: "number",
            placeholder: "Enter a Number",
            step: "any",
            onChange: (e)=>this.onSmartEditValueChange(e),
            disabled: shouldDisable
        })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:gap-1"
        }, !shouldDisable && $acw62.createElement((0, $88289245888644a1$export$f1a2d368aed6b73e), {
            onClick: ()=>this.onApplyClick(),
            style: applyButtonStyle,
            className: `ab-${elementType}__SmartEdit__apply`,
            tooltip: "Apply Smart Edit",
            disabled: (0, $9OAZF.StringExtensions).IsNullOrEmpty(`${this.props.SmartEditValue}`) || this.props.PreviewInfo != null && this.props.PreviewInfo.previewValidationSummary.validationResult == 'All',
            accessLevel: this.props.accessLevel
        }, this.props.viewType === 'ToolPanel' && 'Apply Smart Edit'), !shouldDisable && $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
            headerText: "Preview Results",
            className: `ab-${elementType}__SmartEdit__info`,
            bodyText: [
                previewPanel
            ],
            popoverMinWidth: 360,
            popoverMaxWidth: 500,
            popupPadding: 0,
            MessageType: (0, $5aWMQ.UIHelper).getMessageTypeByStatusColour(statusColour),
            useButton: true,
            showEvent: 'focus',
            hideEvent: "blur"
        })));
    }
    checkSelectedCells() {
        this.props.onSmartEditCheckSelectedCells();
    }
    onSmartEditValueChange(event) {
        const e = event.target;
        this.props.onSmartEditValueChange(Number(e.value));
    }
    getStatusColour() {
        if ((0, $9OAZF.StringExtensions).IsNotNullOrEmpty(`${this.props.SmartEditValue}`) && this.props.PreviewInfo) {
            if (this.props.PreviewInfo.previewValidationSummary.validationResult == 'All') return (0, $hrtGQ.StatusColour).Error;
            if (this.props.PreviewInfo.previewValidationSummary.validationResult == 'Some') return (0, $hrtGQ.StatusColour).Warn;
        }
        return (0, $hrtGQ.StatusColour).Success;
    }
    onApplyClick() {
        this.onApplySmartEdit();
    }
    onApplySmartEdit() {
        this.props.onApplySmartEdit();
    }
}
function $f2a47a599017ed55$var$mapStateToProps(state, ownProps) {
    return {
        SmartEditValue: state.Internal.SmartEdit.SmartEditValue,
        SmartEditOperation: state.Internal.SmartEdit.SmartEditOperation,
        IsValidSelection: state.Internal.SmartEdit.IsValidSmartEditSelection,
        PreviewInfo: state.Internal.SmartEdit.SmartEditPreviewInfo
    };
}
function $f2a47a599017ed55$var$mapDispatchToProps(dispatch) {
    return {
        onSmartEditValueChange: (value)=>dispatch($5b564bb703f29152$export$c279917007950b1(value)),
        onSmartEditOperationChange: (SmartEditOperation)=>dispatch($5b564bb703f29152$export$bfdacd6a132082c7(SmartEditOperation)),
        onSmartEditCheckSelectedCells: ()=>dispatch($5b564bb703f29152$export$bd269cd9b387ea7f()),
        onApplySmartEdit: ()=>dispatch($eeed7eb8174868ba$export$686758e9d668ae5c(false))
    };
}
let $f2a47a599017ed55$export$37a1d6d8690607a3 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($f2a47a599017ed55$var$mapStateToProps, $f2a47a599017ed55$var$mapDispatchToProps)($f2a47a599017ed55$var$SmartEditViewPanelComponent);



var $acw62 = parcelRequire("acw62");



class $f2a972f75289f0b9$var$SystemStatusViewPanelComponent extends $acw62.Component {
    constructor(props){
        super(props);
    }
    render() {
        const currentSystemStatusMessageInfo = this.props.api.systemStatusApi.getCurrentSystemStatusMessageInfo();
        const { color: color, background: background } = (0, $b711f4225fda2a03$export$81f2fe300d687bc7)(currentSystemStatusMessageInfo);
        const message = currentSystemStatusMessageInfo?.statusMessage;
        const elementType = this.props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "stretch",
            className: `ab-${elementType}__SystemStatus__wrap`
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            style: {
                color: color,
                backgroundColor: message ? background : ''
            },
            className: `ab-${elementType}__SystemStatus__text twa:mr-2 twa:p-2 twa:text-2 twa:rounded-standard twa:min-h-input`,
            alignItems: "center",
            "data-name": "system-status-message"
        }, message || '0 Messages'));
    }
}
function $f2a972f75289f0b9$var$mapStateToProps(state) {
    return {
        SystemStatusMessageInfos: state.Internal.SystemStatusMessages
    };
}
function $f2a972f75289f0b9$var$mapDispatchToProps(dispatch) {
    return {};
}
let $f2a972f75289f0b9$export$22b15c4549030087 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($f2a972f75289f0b9$var$mapStateToProps, $f2a972f75289f0b9$var$mapDispatchToProps)($f2a972f75289f0b9$var$SystemStatusViewPanelComponent);



var $acw62 = parcelRequire("acw62");



const $3c26dfdffed76624$export$ca8a1071713d0e85 = (props)=>{
    const elementType = props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
    return $acw62.createElement("div", {
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(props.accessLevel == 'ReadOnly' ? $58846ea7f4156db7$export$2c59109bdd218c0 : '', `ab-${elementType}__Theme__wrap`)
    }, $acw62.createElement((0, $e4b19c37008c87ef$export$17c20d206da56716), null));
};




var $acw62 = parcelRequire("acw62");

var $9OAZF = parcelRequire("9OAZF");


var $9g4SS = parcelRequire("9g4SS");


class $fd16494c28d31d38$var$DataSetViewPanelComponent extends $acw62.Component {
    getCurrentDataSet() {
        return (0, $9OAZF.StringExtensions).IsNullOrEmpty(this.props.CurrentDataSetName) ? null : this.getDataSets().find((ds)=>ds.name == this.props.CurrentDataSetName);
    }
    getDataSets() {
        return this.props.api.dataSetApi.getDataSets();
    }
    render() {
        const selectDataSetString = 'Select Data Set';
        let currentDataSetName = this.getCurrentDataSet()?.name ?? selectDataSetString;
        let availableDataSets = this.getDataSets().map((dataSet)=>{
            return {
                value: dataSet.name,
                label: dataSet.name,
                onClick: ()=>this.onSelectedDataSetChanged(dataSet.name)
            };
        });
        const elementType = this.props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: "row",
            className: `ab-${elementType}__DataSet__wrap`
        }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
            "aria-label": 'Select Data Set',
            placeholder: 'Select Data Set',
            disabled: (0, $9g4SS.default).IsNullOrEmpty(availableDataSets),
            options: availableDataSets,
            value: currentDataSetName,
            className: `ab-${elementType}__DataSet__select twa:w-full`,
            onChange: (destination)=>this.onSelectedDataSetChanged(destination)
        }));
    }
    onSelectedDataSetChanged(dataSetName) {
        if ((0, $9OAZF.StringExtensions).IsNullOrEmpty(dataSetName)) this.setState({
            CurrentDataSet: null
        });
        else {
            let newDataSet = this.getDataSets().find((ds)=>ds.name == dataSetName);
            this.setState({
                CurrentDataSet: newDataSet
            });
            this.props.onSelectDataSet(newDataSet);
        }
    }
}
function $fd16494c28d31d38$var$mapStateToProps(state) {
    return {
        CurrentDataSetName: state.Internal.CurrentDataSet
    };
}
function $fd16494c28d31d38$var$mapDispatchToProps(dispatch) {
    return {
        onSelectDataSet: (dataSet)=>{
            return dispatch($5b564bb703f29152$export$a167b5ac2f0c10f3(dataSet));
        }
    };
}
let $fd16494c28d31d38$export$641e32dccec28126 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($fd16494c28d31d38$var$mapStateToProps, $fd16494c28d31d38$var$mapDispatchToProps)($fd16494c28d31d38$var$DataSetViewPanelComponent);



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



const $e47b39a53eb10cb9$export$950194f1fe3ab475 = (options, parentAdapTableApi, undoRowNode, clearRow)=>{
    let changeHistoryButtons = options.changeHistoryButton;
    if (!changeHistoryButtons || Array.isArray(changeHistoryButtons) && changeHistoryButtons.length === 0) return null;
    if (!Array.isArray(changeHistoryButtons)) changeHistoryButtons = [
        changeHistoryButtons
    ];
    const isGroupNode = (context)=>context.adaptableApi.gridApi.isGroupRowNode(context.rowNode);
    const onUndo = (context)=>{
        const rowNode = context.rowNode;
        if (context.adaptableApi.gridApi.isGroupRowNode(rowNode)) {
            // undo all children
            const childrenNodes = context.rowNode?.childrenAfterFilter;
            if (childrenNodes) childrenNodes.forEach((childNode)=>undoRowNode(childNode));
        } else undoRowNode(rowNode);
    };
    const onClearRow = (context)=>{
        const rowNode = context.rowNode;
        clearRow(rowNode);
    };
    const buildContext = (context)=>{
        const dataChangedInfo = context.rowNode.data.changeInfo;
        return {
            ...context,
            isGroupNode: isGroupNode(context),
            undoDataChange: ()=>onUndo(context),
            clearRow: ()=>onClearRow(context),
            dataChangedInfo: dataChangedInfo,
            parentAdapTableApi: parentAdapTableApi
        };
    };
    return changeHistoryButtons.map((actionColumnOption)=>({
            label: (button, context)=>{
                if (typeof actionColumnOption.label !== 'function') return actionColumnOption.label;
                return actionColumnOption.label(button, buildContext(context));
            },
            buttonStyle: (button, context)=>{
                if (typeof actionColumnOption.buttonStyle !== 'function') return actionColumnOption.buttonStyle;
                return actionColumnOption.buttonStyle(button, buildContext(context));
            },
            tooltip: (button, context)=>{
                if (typeof actionColumnOption.tooltip !== 'function') return actionColumnOption.tooltip;
                return actionColumnOption.tooltip(button, buildContext(context));
            },
            disabled: (button, context)=>{
                if (typeof actionColumnOption.disabled !== 'function') return actionColumnOption.disabled;
                return actionColumnOption.disabled(button, buildContext(context));
            },
            onClick: (button, context)=>{
                if (actionColumnOption.action === 'undo') onUndo(buildContext(context));
                if (actionColumnOption.action === 'clear') onClearRow(buildContext(context));
                if (typeof actionColumnOption.onClick === 'function') actionColumnOption.onClick(button, buildContext(context));
            },
            hidden: (button, context)=>{
                if (typeof actionColumnOption.hidden !== 'function') return actionColumnOption.hidden;
                return actionColumnOption.hidden(button, buildContext(context));
            },
            icon: actionColumnOption.icon
        }));
};



const $b47cee93b82e65ad$export$71184e586fbfd1ef = (props)=>{
    const { changeHistoryLog: changeHistoryLog, adaptableContainerId: adaptableContainerId, agGridContainerId: agGridContainerId, onUndoChange: onUndoChange, onClearRow: onClearRow } = props;
    const mainAdaptableInstance = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [_adaptableApi, setAdaptableApi] = (0, $acw62.useState)(null);
    const adaptableApiRef = (0, $acw62.useRef)(null);
    adaptableApiRef.current = _adaptableApi;
    const undoChangeEnabled = mainAdaptableInstance.api.entitlementApi.isModuleFullEntitlement((0, $42e863194fcb493f$export$376343cd8119f6bf));
    const previousChangeHistoryLog = (0, $013bfe010f8c54af$export$2e2bcd8739ae039)(changeHistoryLog, changeHistoryLog);
    // initialize Adaptable grid
    (0, $acw62.useEffect)(()=>{
        const initializeAdaptableGrid = async ()=>{
            const gridOptions = $b47cee93b82e65ad$var$buildGridOptions(mainAdaptableInstance, changeHistoryLog);
            const adaptableOptions = $b47cee93b82e65ad$var$buildAdaptableOptions(mainAdaptableInstance, adaptableContainerId, agGridContainerId, undoChangeEnabled, onUndoChange, onClearRow);
            const modules = mainAdaptableInstance.agGridModulesAdapter.getAgGridRegisteredModules();
            const dataChangeHistoryAdaptableApi = await (0, $2c60780b406d81af$export$a19c58cdd10e13f7)._initInternal({
                variant: 'vanilla',
                adaptableOptions: adaptableOptions,
                gridOptions: gridOptions,
                modules: modules
            });
            setAdaptableApi(dataChangeHistoryAdaptableApi);
        };
        initializeAdaptableGrid();
        return ()=>{
            requestAnimationFrame(()=>{
                adaptableApiRef.current?.internalApi.getAdaptableInstance().destroy({
                    unmount: true,
                    destroyAgGrid: true
                });
            });
        };
    }, []);
    // update row data
    (0, $acw62.useEffect)(()=>{
        const adaptableApi = adaptableApiRef.current;
        if (!adaptableApi) // initial render
        return;
        const addedChangeKeys = Object.keys(changeHistoryLog).filter((newChangeKey)=>{
            const previousChangeWithSameKey = previousChangeHistoryLog[newChangeKey];
            if (!previousChangeWithSameKey) return true;
            const addedChange = changeHistoryLog[newChangeKey];
            return addedChange.changedAt !== previousChangeWithSameKey.changedAt;
        });
        const removedChangeKeys = Object.keys(previousChangeHistoryLog).filter((previousChangeKey)=>{
            const newChangeWithSameKey = changeHistoryLog[previousChangeKey];
            if (!newChangeWithSameKey) return true;
            const previousChange = previousChangeHistoryLog[previousChangeKey];
            return previousChange.changedAt !== newChangeWithSameKey.changedAt;
        });
        const addedChangeHistoryLogs = $b47cee93b82e65ad$var$filterChangeHistoryLog(changeHistoryLog, addedChangeKeys);
        const removedChangeHistoryLogs = $b47cee93b82e65ad$var$filterChangeHistoryLog(previousChangeHistoryLog, removedChangeKeys);
        // here we access directly the AG Grid API, but this is OK because:
        // 1. this method (gridAPi.applyTransaction() is NOT accessible otherwise and making it public opens other cans of worms
        // 2. this UI will be reimplemented with Infinite Table anyway
        const addedRows = $b47cee93b82e65ad$var$mapChangeHistoryRowData(addedChangeHistoryLogs, mainAdaptableInstance);
        const removedRows = $b47cee93b82e65ad$var$mapChangeHistoryRowData(removedChangeHistoryLogs, mainAdaptableInstance);
        adaptableApi.agGridApi.applyTransactionAsync({
            add: addedRows,
            remove: removedRows
        });
    }, [
        changeHistoryLog
    ]);
    return $acw62.createElement($acw62.Fragment, null);
};
const $b47cee93b82e65ad$var$buildAdaptableOptions = (mainAdaptableInstance, adaptableContainerId, agGridContainerId, undoChangeEnabled, onUndoChange, onClearRow)=>{
    const mainAdaptableOptions = mainAdaptableInstance.adaptableOptions;
    const mainAdaptableTheme = mainAdaptableInstance.api.themeApi.getCurrentTheme();
    const undoRowNode = (rowNode)=>{
        const rowData = rowNode?.data;
        const changeKey = rowData?.['changeKey'];
        changeKey && onUndoChange(changeKey);
    };
    const clearRow = (rowNode)=>{
        const rowData = rowNode?.data;
        const changeKey = rowData?.['changeKey'];
        changeKey && onClearRow(changeKey);
    };
    const actionColumnButton = (0, $e47b39a53eb10cb9$export$950194f1fe3ab475)(mainAdaptableInstance.adaptableOptions?.dataChangeHistoryOptions, mainAdaptableInstance.api, undoRowNode, clearRow);
    let actionColumnOptions = undefined;
    if (actionColumnButton) actionColumnOptions = {
        actionColumns: [
            {
                columnId: 'undoActionColumn',
                friendlyName: ' ',
                rowScope: {
                    ExcludeGroupRows: true,
                    ExcludeSummaryRows: true,
                    ExcludeTotalRows: true
                },
                actionColumnSettings: {
                    suppressMenu: true,
                    suppressMovable: true
                },
                actionColumnButton: actionColumnButton
            }
        ]
    };
    const options = {
        primaryKey: 'primaryKey',
        licenseKey: mainAdaptableOptions.licenseKey,
        userName: `${mainAdaptableOptions.userName}`,
        adaptableId: `${mainAdaptableOptions.adaptableId}::DataChangeHistory`,
        containerOptions: {
            adaptableContainer: adaptableContainerId,
            agGridContainer: agGridContainerId
        },
        entitlementOptions: {
            defaultAccessLevel: 'Hidden'
        },
        actionColumnOptions: actionColumnOptions,
        initialState: {
            Layout: {
                Revision: Date.now(),
                CurrentLayout: 'DataChangeHistoryLayout',
                Layouts: [
                    {
                        Name: 'DataChangeHistoryLayout',
                        TableColumns: [
                            'changeInfo.primaryKeyValue',
                            'changedColumnLabel',
                            'changeInfo.oldValue',
                            'changeInfo.newValue',
                            'changeInfo.changedAt',
                            'changeTriggerLabel',
                            'undoActionColumn'
                        ],
                        ColumnSorts: [
                            {
                                ColumnId: 'changeInfo.changedAt',
                                SortOrder: 'Desc'
                            }
                        ],
                        ColumnSizing: {
                            'changeInfo.primaryKeyValue': {
                                Flex: 3
                            },
                            changedColumnLabel: {
                                Flex: 3
                            },
                            'changeInfo.oldValue': {
                                Flex: 3
                            },
                            'changeInfo.newValue': {
                                Flex: 3
                            },
                            'changeInfo.changedAt': {
                                Flex: 3
                            },
                            changeTriggerLabel: {
                                Flex: 2
                            },
                            undoActionColumn: {
                                Width: 110
                            }
                        },
                        ColumnPinning: {
                            undoActionColumn: 'right'
                        },
                        AutoSizeColumns: true
                    }
                ]
            },
            FormatColumn: {
                Revision: Date.now(),
                FormatColumns: [
                    {
                        Name: 'Changed At',
                        Scope: {
                            ColumnIds: [
                                'changeInfo.changedAt'
                            ]
                        },
                        DisplayFormat: {
                            Formatter: 'DateFormatter',
                            Options: {
                                Pattern: `${mainAdaptableOptions.userInterfaceOptions?.dateInputOptions?.dateFormat} HH:mm:ss`
                            }
                        }
                    }
                ]
            },
            Theme: {
                Revision: Date.now(),
                CurrentTheme: mainAdaptableTheme
            }
        }
    };
    if (!undoChangeEnabled) {
        const layoutColumns = options.initialState.Layout.Layouts[0].TableColumns;
        if (layoutColumns.includes('undoActionColumn')) // remove action column from layout
        options.initialState.Layout.Layouts[0].TableColumns = layoutColumns.filter((columnId)=>columnId !== 'undoActionColumn');
    }
    return options;
};
const $b47cee93b82e65ad$var$buildGridOptions = (mainAdaptableInstance, changeHistoryLog)=>{
    const mainPrimaryKeyColumnHeader = mainAdaptableInstance.api.columnApi.getPrimaryKeyColumn()?.friendlyName ?? 'Row ID';
    const options = {
        loading: false,
        overlayNoRowsTemplate: '<div style="font-size: var(--ab-font-size-2);color: var(--ab-color-text-on-primary);">No Data Changes</div>',
        defaultColDef: {
            floatingFilter: true,
            filter: true,
            sortable: true,
            resizable: true,
            enableRowGroup: true,
            editable: false,
            enablePivot: false,
            enableValue: false,
            lockPinned: true,
            // default set to true to pass this to the action column
            suppressAutoSize: true,
            menuTabs: [
                'generalMenuTab',
                'filterMenuTab'
            ]
        },
        autoGroupColumnDef: {
            sortable: true
        },
        columnDefs: [
            {
                field: 'primaryKey',
                cellDataType: 'text',
                hide: true
            },
            {
                headerName: `Row (${mainPrimaryKeyColumnHeader})`,
                field: 'changeInfo.primaryKeyValue',
                cellDataType: 'text'
            },
            {
                headerName: 'Column',
                field: 'changedColumnLabel',
                cellDataType: 'text'
            },
            {
                headerName: 'Previous',
                field: 'changeInfo.oldValue',
                cellDataType: 'text'
            },
            {
                headerName: 'New',
                field: 'changeInfo.newValue',
                cellDataType: 'text'
            },
            {
                headerName: 'Changed',
                field: 'changeInfo.changedAt',
                cellDataType: 'date'
            },
            {
                headerName: 'Source',
                field: 'changeTriggerLabel',
                cellDataType: 'text'
            }
        ],
        rowData: $b47cee93b82e65ad$var$mapChangeHistoryRowData(changeHistoryLog, mainAdaptableInstance),
        cellSelection: true,
        suppressColumnVirtualisation: false,
        sideBar: false,
        rowSelection: {
            mode: 'multiRow'
        },
        skipHeaderOnAutoSize: true
    };
    return options;
};
const $b47cee93b82e65ad$var$mapChangeHistoryRowData = (changeHistoryLog = {}, mainAdaptableInstance)=>{
    return Object.entries(changeHistoryLog).map(([changeKey, changeInfo])=>{
        return {
            primaryKey: `${changeKey}::${changeInfo.changedAt}`,
            changeKey: changeKey,
            changeTriggerLabel: $b47cee93b82e65ad$var$getChangeTriggerLabel(changeInfo),
            changedColumnLabel: $b47cee93b82e65ad$var$getColumnHeaderLabel(changeInfo.column.columnId, mainAdaptableInstance),
            changeInfo: changeInfo
        };
    });
};
// memoize headers to avoid unnecessary main grid lookups
const $b47cee93b82e65ad$var$headerMap = new Map();
const $b47cee93b82e65ad$var$getColumnHeaderLabel = (columnId, mainAdaptableInstance)=>{
    if (!$b47cee93b82e65ad$var$headerMap.has(columnId)) $b47cee93b82e65ad$var$headerMap.set(columnId, mainAdaptableInstance.api.columnApi.getColumnWithColumnId(columnId)?.friendlyName ?? columnId);
    return $b47cee93b82e65ad$var$headerMap.get(columnId);
};
const $b47cee93b82e65ad$var$getChangeTriggerLabel = (changeInfo)=>{
    return changeInfo.trigger === 'tick' ? 'Ticking' : 'User Edit';
};
const $b47cee93b82e65ad$var$filterChangeHistoryLog = (changeObject, filterValues)=>{
    const result = {};
    filterValues.forEach((allowedKey)=>{
        result[allowedKey] = changeObject[allowedKey];
    });
    return result;
};








class $c68710dde3fa468e$var$DataChangeHistoryPopupComponent extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            dataChangeHistoryAdaptableApi: undefined
        };
    }
    render() {
        const { changeHistoryMode: changeHistoryMode, activationTime: activationTime, suspensionTime: suspensionTime, onChangeHistoryEnable: onChangeHistoryEnable, onChangeHistoryDisable: onChangeHistoryDisable, onChangeHistorySuspend: onChangeHistorySuspend, onChangeHistoryResume: onChangeHistoryResume } = this.props;
        const adaptableContainerId = 'dataChangeHistoryAdaptableContainer';
        const agGridContainerId = 'dataChangeHistoryAgGridContainer';
        const enabled = changeHistoryMode === 'ACTIVE';
        const disabled = changeHistoryMode === 'INACTIVE';
        const suspended = changeHistoryMode === 'SUSPENDED';
        const buttonPanel = $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "ab-DataChangeHistoryPopup--button-panel twa:gap-1 twa:p-2"
        }, disabled && $acw62.createElement((0, $25a466b3a8eee6fb$export$23b1e8580c697083), {
            className: "ab-DataChangeHistoryPopup--button-activate",
            "data-name": 'data-change-history--button-activate"',
            variant: 'raised',
            tone: 'accent',
            tooltip: '',
            onClick: ()=>onChangeHistoryEnable()
        }, "Activate"), suspended && $acw62.createElement((0, $25a466b3a8eee6fb$export$23b1e8580c697083), {
            className: "ab-DataChangeHistoryPopup--button-resume",
            "data-name": 'data-change-history--button-resume',
            variant: 'outlined',
            tooltip: 'Resume tracking data changes',
            onClick: ()=>onChangeHistoryResume()
        }, "Resume"), enabled && $acw62.createElement((0, $39b7a9837b4e4ef1$export$9a3ab81a844a27ca), {
            className: "ab-DataChangeHistoryPopup--button-suspend",
            "data-name": 'data-change-history--button-suspend',
            variant: 'outlined',
            tooltip: 'Suspend tracking data changes',
            onClick: ()=>onChangeHistorySuspend()
        }, "Suspend"), (enabled || suspended) && $acw62.createElement((0, $53ea84fdc7f88e84$export$1c8def558a81e30e), {
            className: "ab-DataChangeHistoryPopup--button-deactivate",
            "data-name": 'data-change-history--button-deactivate',
            variant: 'outlined',
            tooltip: 'Deactivate data change tracking',
            onClick: ()=>onChangeHistoryDisable()
        }, "Deactivate"));
        const dateFormat = `${this.props.api.optionsApi.getUserInterfaceOptions().dateInputOptions.dateFormat} HH:mm:ss`;
        const statusPanel = $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "ab-DataChangeHistoryPopup--status-panel twa:gap-1",
            alignItems: 'center'
        }, enabled && $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "ab-DataChangeHistoryPanel--status-active twa:text-success twa:font-bold"
        }, "Active"), !!activationTime && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:text-2 twa:italic"
        }, "(since ", (0, $1fe81e1078ace264$export$ad991b66133851cf)(activationTime, {
            Pattern: dateFormat
        }), ")")), suspended && $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "ab-DataChangeHistoryPopup--status-suspended twa:text-warn twa:font-bold"
        }, "Suspended"), !!suspensionTime && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:text-2 twa:italic"
        }, "(since ", (0, $1fe81e1078ace264$export$ad991b66133851cf)(suspensionTime, {
            Pattern: dateFormat
        }), ")")), disabled && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "ab-DataChangeHistoryPopup--status-disabled twa:text-2"
        }));
        const handleChangeUndo = (changeKey)=>{
            const changeToBeUndone = this.props.changeHistoryLog[changeKey];
            if (changeToBeUndone) this.props.api.dataChangeHistoryApi.undoDataChangeHistoryEntry(changeToBeUndone);
        };
        const handleClearRow = (changeKey)=>{
            const changeToBeUndone = this.props.changeHistoryLog[changeKey];
            if (changeToBeUndone) this.props.api.dataChangeHistoryApi.clearDataChangeHistoryEntry(changeToBeUndone);
        };
        const agGridThemeMode = this.props.api.internalApi.getAdaptableInstance().agGridThemeAdapter.getAgGridThemeMode();
        const currentAgGridTheme = agGridThemeMode === 'legacy' ? this.props.api.themeApi.getAgGridCurrentThemeName() : '';
        return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
            headerText: this.props.moduleInfo.FriendlyName,
            glyphicon: this.props.moduleInfo.Glyph,
            infoLink: this.props.moduleInfo.HelpPage,
            infoLinkDisabled: !this.props.api.internalApi.isDocumentationLinksDisplayed()
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "ab-DataChangeHistoryPopup twa:h-full",
            flexDirection: "column"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            style: {
                color: 'var(--ab-dashboard__color)',
                background: 'var(--ab-dashboard__background)'
            }
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            flexDirection: 'row'
        }, buttonPanel, statusPanel)), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "ab-DataChangeHistoryPopup--grid twa:flex-1 twa:self-stretch",
            "data-name": 'data-change-history--grid',
            flexDirection: 'column'
        }, $acw62.createElement("div", {
            id: adaptableContainerId
        }), $acw62.createElement("div", {
            id: agGridContainerId,
            className: currentAgGridTheme,
            style: {
                height: '100%'
            }
        }), $acw62.createElement((0, $b47cee93b82e65ad$export$71184e586fbfd1ef), {
            adaptableContainerId: adaptableContainerId,
            agGridContainerId: agGridContainerId,
            changeHistoryLog: this.props.changeHistoryLog,
            onUndoChange: handleChangeUndo,
            onClearRow: handleClearRow
        }))));
    }
}
function $c68710dde3fa468e$var$mapStateToProps(state, ownProps) {
    return {
        changeHistoryLog: state.Internal.DataChangeHistory.logs,
        changeHistoryMode: state.Internal.DataChangeHistory.currentMode,
        activationTime: state.Internal.DataChangeHistory.enableTime,
        suspensionTime: state.Internal.DataChangeHistory.suspendTime
    };
}
function $c68710dde3fa468e$var$mapDispatchToProps(dispatch) {
    return {
        onChangeHistoryEnable: ()=>dispatch((0, $5b564bb703f29152$export$d4cbdbb82d50fbc3)()),
        onChangeHistoryDisable: ()=>dispatch((0, $5b564bb703f29152$export$4344ed6f5015b32c)()),
        onChangeHistorySuspend: ()=>dispatch((0, $5b564bb703f29152$export$89243c08c46c6822)()),
        onChangeHistoryResume: ()=>dispatch((0, $5b564bb703f29152$export$d6776ceaeb5c77dd)())
    };
}
let $c68710dde3fa468e$export$e3c0fc5a98e7dc2d = (0, $55388fc2f116d4d7$export$64605811ab45167f)($c68710dde3fa468e$var$mapStateToProps, $c68710dde3fa468e$var$mapDispatchToProps)($c68710dde3fa468e$var$DataChangeHistoryPopupComponent);




var $acw62 = parcelRequire("acw62");






const $15af8141406ea914$export$98795ddbdbbc68e4 = (props)=>{
    const isToolbar = props.viewType === 'Toolbar';
    const elementType = isToolbar ? 'DashboardToolbar' : 'ToolPanel';
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: isToolbar ? 'row' : 'column',
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(props.accessLevel == 'ReadOnly' ? $58846ea7f4156db7$export$2c59109bdd218c0 : '', `ab-${elementType}__StateManagement__wrap twa:min-h-input`)
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row"
    }, $acw62.createElement((0, $e2ef1420d912e1c1$export$41861f0311224bab), {
        tooltip: "Load Initial Adaptable State",
        variant: "text",
        icon: "upload",
        onLoad: (json)=>props.api.stateApi.reloadInitialState(json),
        accessLevel: props.accessLevel
    }, !isToolbar && 'Load'), $acw62.createElement((0, $1740bcc6d7e812be$export$13ec83e50bf04290), {
        icon: "delete",
        tooltip: "Clear User State",
        variant: "text",
        onClick: ()=>props.api.stateApi.reloadInitialState(),
        accessLevel: props.accessLevel
    }, !isToolbar && 'Clear')), $acw62.createElement((0, $7946c1b19352bba4$export$68283403dbd9b8ee), {
        api: props.api,
        type: "adaptableState"
    }, "All State"), $acw62.createElement((0, $7946c1b19352bba4$export$68283403dbd9b8ee), {
        api: props.api,
        type: "initialState"
    }, "Initial Adaptable State"));
};



var $acw62 = parcelRequire("acw62");







const $d0cd554d52d75dd8$export$e48c05a1e1507aec = (props)=>{
    const statusPanels = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((0, $264a0e58163aefb1$export$f3a658bc32c51d73));
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const tabs = $acw62.useMemo(()=>statusPanels.map((statusPanel)=>{
            return {
                Name: statusPanel.Key,
                Items: statusPanel.StatusBarPanels
            };
        }), [
        statusPanels
    ]);
    const handleTabChange = $acw62.useCallback((tabs)=>{
        const newStatusPanels = tabs.map((tab)=>{
            const statusPanel = statusPanels.find((sp)=>sp.Key === tab.Name);
            return {
                ...statusPanel,
                StatusBarPanels: tab.Items
            };
        });
        adaptable.api.statusBarApi.setStatusBarPanels(newStatusPanels);
    }, [
        statusPanels
    ]);
    const availableItems = (0, $c75adffdf90b3d81$export$bbefa93fc7e9cd4a).filter((panel)=>{
        const module = adaptable.ModuleService.getModuleById(panel);
        return module?.isModuleVisible();
    }).map((panel)=>{
        const module = adaptable.ModuleService.getModuleById(panel);
        return {
            Id: panel,
            Title: module.moduleInfo.FriendlyName
        };
    });
    const disabled = props.accessLevel === 'ReadOnly';
    return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
        headerText: props.moduleInfo.FriendlyName,
        glyphicon: props.moduleInfo.Glyph,
        infoLink: props.moduleInfo.HelpPage,
        infoLinkDisabled: !props.api.internalApi.isDocumentationLinksDisplayed()
    }, statusPanels.length ? $acw62.createElement((0, $9e67de7320a14ea2$export$b4ba4f0359f0dde4), {
        permittedActions: {
            createTab: false,
            dragAndDropTab: false,
            deleteTab: false,
            editTabName: false
        },
        onTabsChange: handleTabChange,
        disabled: disabled,
        tabs: tabs,
        availableItems: availableItems,
        tabsTitle: 'AdapTable Status Bar Panels',
        unusedPanelTitle: "Available Status Bar Components",
        dragItemText: "Drag into a Status Bar Panel below"
    }) : $acw62.createElement((0, $692d03a290feaea9$export$2e2bcd8739ae039), null, "To enable this feature add to Grid Options statusPanels the Adaptable Status Panel."));
};



var $acw62 = parcelRequire("acw62");


const $6dd6d1bc42e6f038$export$4c5ab965026a1e05 = (props)=>{
    const elementType = props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
    const { chartSelector: chartSelector, containerSelector: containerSelector, chartButton: chartButton, deleteButton: deleteButton, editButton: editButton } = (0, $413e3b2ece8fc74a$export$93ffd2cb272551dc)({
        elementType: elementType,
        accessLevel: props.accessLevel
    });
    if (elementType === 'DashboardToolbar') return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:w-full"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, chartSelector), containerSelector && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-1"
    }, containerSelector), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-1"
    }, chartButton, deleteButton, editButton));
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:w-full"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-1"
    }, chartSelector), containerSelector && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-1"
    }, containerSelector), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, chartButton, " ", deleteButton, " ", editButton));
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





var $9OAZF = parcelRequire("9OAZF");










const $e878743012e1c7f4$export$f842f1103da39e20 = (props)=>{
    const { expression: expression, isExpressionValid: isExpressionValid, isExpressionNamedQuery: isExpressionNamedQuery, isSuspended: isSuspended, isReadOnly: isReadOnly, availableColumns: availableColumns, namedQueries: namedQueries, cachedQueries: cachedQueries, currentGridFilterExpression: currentGridFilterExpression, headerText: headerText, glyphicon: glyphicon, infoLink: infoLink, infoLinkDisabled: infoLinkDisabled, onExpressionChange: onExpressionChange, onRunQuery: onRunQuery, onClearQuery: onClearQuery, onSaveQuery: onSaveQuery, onSuspend: onSuspend, onUnsuspend: onUnsuspend, onExpand: onExpand, onSelectNamedQuery: onSelectNamedQuery, onSetGridFilterExpression: onSetGridFilterExpression, gridFilterAccessLevel: gridFilterAccessLevel, namedQueryAccessLevel: namedQueryAccessLevel } = props;
    const disabled = isReadOnly || isSuspended || gridFilterAccessLevel === 'ReadOnly';
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') onRunQuery();
    };
    return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
        className: "ab-GridFilter",
        headerText: headerText,
        glyphicon: glyphicon,
        infoLink: infoLink,
        infoLinkDisabled: infoLinkDisabled
    }, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: "twa:flex-1 twa:border-none twa:shadow-md twa:overflow-hidden"
    }, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039).FlexBody, null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:grid twa:gap-3 twa:grid-cols-[auto_1fr] twa:items-center"
    }, "Expression:", $acw62.createElement((0, $952730cad4910d4d$export$2e2bcd8739ae039), {
        className: "twa:mr-1 twa:w-full"
    }, $acw62.createElement((0, $0a78809ac22eb981$export$c89166be9b7f8fec), {
        disabled: disabled,
        variant: "text",
        tone: "neutral",
        onClick: onExpand,
        tooltip: "Edit the Expression in UI",
        className: "twa:ml-1"
    }), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        onKeyDown: handleKeyDown,
        disabled: disabled,
        type: "text",
        "data-name": "grid-filter-input",
        placeholder: "Grid Filter",
        spellCheck: false,
        value: expression,
        onChange: (e)=>onExpressionChange(e.target.value),
        className: "twa:font-mono twa:text-2"
    }), isExpressionValid && $acw62.createElement((0, $25a466b3a8eee6fb$export$23b1e8580c697083), {
        onClick: ()=>onRunQuery(),
        tooltip: '',
        accessLevel: gridFilterAccessLevel,
        variant: "text",
        tone: "accent",
        disabled: disabled || expression === '' || expression === currentGridFilterExpression,
        className: "twa:mr-1"
    }), currentGridFilterExpression && !isExpressionValid && $acw62.createElement((0, $aa03fcf3d2a4652b$export$9d5cf46e47ef518b), {
        variant: "text",
        tone: "neutral",
        tooltip: "Invalid Grid Filter",
        className: "twa:mr-1"
    }), ' ', (0, $9OAZF.default).IsNotNullOrEmpty(expression) && $acw62.createElement((0, $949eb332a4e17e68$export$b04863f4be28ad91), {
        onClick: ()=>onClearQuery(),
        tooltip: "Clear Grid Filter",
        accessLevel: gridFilterAccessLevel
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        justifyContent: "space-around",
        className: "twa:col-start-2"
    }, $acw62.createElement((0, $131499484a307d31$export$f3a86bc668ab2bcc), {
        onClick: ()=>onSaveQuery(),
        tooltip: "Save as Named Query",
        accessLevel: namedQueryAccessLevel,
        disabled: disabled || !isExpressionValid || isExpressionNamedQuery || expression === '',
        variant: "text",
        tone: "neutral",
        className: "twa:mr-1"
    }, "Save"), isSuspended ? $acw62.createElement((0, $81a220ee4e885aba$export$6bb7cb30b61dadd4), {
        onClick: ()=>onUnsuspend(),
        tooltip: "Unsuspend Grid Filter",
        accessLevel: gridFilterAccessLevel,
        disabled: disabled || !isExpressionValid,
        variant: "text",
        tone: "neutral",
        className: "twa:mr-1"
    }, "Resume") : $acw62.createElement((0, $39b7a9837b4e4ef1$export$9a3ab81a844a27ca), {
        onClick: ()=>onSuspend(),
        tooltip: "Suspend Grid Filter",
        accessLevel: gridFilterAccessLevel,
        disabled: disabled || !isExpressionValid,
        variant: "text",
        tone: "neutral",
        className: "twa:mr-1"
    }, "Suspend"), $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        disabled: disabled,
        variant: "text",
        items: availableColumns,
        className: "twa:mr-1",
        tooltip: "Pick Columns",
        icon: "list",
        iconPosition: "start"
    }, "Columns"), $acw62.createElement((0, $398749e37288ae2c$export$f92becc81113ee47), {
        disabled: disabled,
        namedQueries: namedQueries,
        cachedQueries: cachedQueries,
        currentQuery: currentGridFilterExpression,
        onSelect: (query)=>onSelectNamedQuery(query),
        setGridFilterExpression: (query)=>onSetGridFilterExpression(query)
    }, "Named Queries"))))));
};


const $b5fe7a9480e81114$export$26fe6275db30557b = ()=>{
    const hookData = (0, $d30ef87cbb80b526$export$243b9188ed62d392)();
    // Create callback handlers
    const handleExpressionChange = (value)=>{
        hookData.setExpression(value);
    };
    const handleRunQuery = (expression)=>{
        hookData.runQuery(expression);
    };
    const handleClearQuery = ()=>{
        hookData.clearQuery();
    };
    const handleSaveQuery = ()=>{
        hookData.saveQuery();
    };
    const handleSuspend = ()=>{
        hookData.suspendGridFilter();
    };
    const handleUnsuspend = ()=>{
        hookData.unSuspendGridFilter();
    };
    const handleExpand = ()=>{
        hookData.onExpand();
    };
    const handleSelectNamedQuery = (query)=>{
        handleRunQuery(query);
    };
    const handleSetGridFilterExpression = (query)=>{
        hookData.setGridFilterExpression(query);
    };
    return $acw62.createElement((0, $e878743012e1c7f4$export$f842f1103da39e20), {
        expression: hookData.expression,
        isExpressionValid: hookData.isExpressionValid,
        isExpressionNamedQuery: hookData.isExpressionNamedQuery,
        isSuspended: hookData.isSuspended,
        isReadOnly: hookData.isReadOnly,
        availableColumns: hookData.availableColumns,
        namedQueries: hookData.namedQueries,
        cachedQueries: hookData.cachedQueries,
        currentGridFilterExpression: hookData.gridFilter?.Expression,
        headerText: "Grid Filter",
        glyphicon: "grid-filter",
        infoLink: hookData.gridFilterHelpPage,
        infoLinkDisabled: hookData.gridFilterLinkDisabled,
        onExpressionChange: handleExpressionChange,
        onRunQuery: handleRunQuery,
        onClearQuery: handleClearQuery,
        onSaveQuery: handleSaveQuery,
        onSuspend: handleSuspend,
        onUnsuspend: handleUnsuspend,
        onExpand: handleExpand,
        onSelectNamedQuery: handleSelectNamedQuery,
        onSetGridFilterExpression: handleSetGridFilterExpression,
        gridFilterAccessLevel: hookData.gridFilterAccessLevel,
        namedQueryAccessLevel: hookData.namedQueryModuleAccessLevel
    });
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");









var $9g4SS = parcelRequire("9g4SS");

const $162efce6a8fc61df$var$BASE_CLASS_NAME = 'ab-AdaptableColumns';
const $162efce6a8fc61df$var$domProps = {
    className: 'twa:flex-1 twa:min-h-0 twa:w-full'
};
// TODOS:
// - use column from props as initial value
// - table summary
// - access level for edit/new buttons
const $162efce6a8fc61df$var$MODULES_WITH_COLUMN = [
    'Alert',
    'CalculatedColumn',
    'CustomSort',
    'FormatColumn',
    'FlashingCell',
    'PlusMinus',
    'Shortcut',
    'StyledColumn'
];
const $162efce6a8fc61df$var$MODULES_WITH_SCOPE = [
    'Alert',
    'FormatColumn',
    'PlusMinus',
    'Shortcut',
    'StyledColumn'
];
const $162efce6a8fc61df$var$ColumnDefPreview = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    if (props.column) {
        const api = adaptable.api;
        const summary = api.columnApi.getColumnSummaryForColumnId(props.column.columnId);
        const keyValuePairs = [
            {
                Key: 'Column Id',
                Value: props.column.columnId
            },
            {
                Key: 'Header',
                Value: props.column.friendlyName
            },
            {
                Key: 'Data Type',
                Value: props.column.dataType
            },
            {
                Key: 'Column Types',
                Value: (0, $9g4SS.default).createCommaSeparatedString(props.column.columnTypes)
            },
            {
                Key: 'Primary Key Column',
                Value: props.column.isPrimaryKey ? 'Yes' : 'Ignore'
            },
            {
                Key: 'Calculated Column',
                Value: props.column.isCalculatedColumn ? 'Yes' : 'Ignore'
            },
            {
                Key: 'Free Text Column',
                Value: props.column.isFreeTextColumn ? 'Yes' : 'Ignore'
            },
            {
                Key: 'Action Column',
                Value: props.column.isActionColumn ? 'Yes' : 'Ignore'
            },
            {
                Key: 'Sparkline Column',
                Value: props.column.isSparkline ? 'Yes' : 'Ignore'
            },
            {
                Key: 'Column Group',
                Value: props.column.columnGroup ? props.column.columnGroup.friendlyName : 'Ignore'
            },
            {
                Key: 'Visible',
                Value: props.column.visible ? 'Yes' : 'No'
            },
            {
                Key: 'Width',
                Value: props.column.width
            },
            {
                Key: 'Row Grouped',
                Value: props.column.groupable ? props.column.isGrouped ? 'Yes' : 'No' : 'Ignore'
            },
            {
                Key: 'Groupable',
                Value: props.column.groupable ? 'Yes' : 'No'
            },
            {
                Key: 'Aggregatable',
                Value: props.column.aggregatable ? 'Yes' : 'No'
            },
            {
                Key: 'Aggregation Function',
                Value: props.column.aggregatable ? props.column.aggregationFunction : 'Ignore'
            },
            {
                Key: 'Filterable',
                Value: props.column.filterable ? 'Yes' : 'No'
            },
            {
                Key: 'Column Filter',
                Value: props.column.filterable ? api.filterApi.columnFilterApi.columnFilterToString(summary.columnFilter) : 'Ignore'
            },
            {
                Key: 'Hideable',
                Value: props.column.hideable ? 'Yes' : 'No'
            },
            {
                Key: 'Editable',
                Value: !props.column.IsReadOnly ? 'Yes' : 'No'
            },
            {
                Key: 'Moveable',
                Value: props.column.moveable ? 'Yes' : 'No'
            },
            {
                Key: 'Pivotable',
                Value: props.column.pivotable ? 'Yes' : 'No'
            },
            {
                Key: 'Queryable',
                Value: props.column.queryable ? 'Yes' : 'No'
            },
            {
                Key: 'Exportable',
                Value: props.column.exportable ? 'Yes' : 'No'
            },
            {
                Key: 'Sortable',
                Value: props.column.sortable ? 'Yes' : 'No'
            },
            {
                Key: 'No. Distinct Values',
                Value: summary.uniqueGridCells.length
            }
        ].map((keyValuePair)=>{
            return {
                Key: keyValuePair.Key,
                Value: keyValuePair.Value === 'Ignore' ? null : keyValuePair.Value
            };
        }).filter((x)=>x.Value);
        const columnsMap = {
            Key: {
                field: 'Key',
                header: 'Property',
                defaultFlex: 1
            },
            Value: {
                field: 'Value',
                header: 'Value',
                defaultFlex: 3
            }
        };
        return $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
            data: keyValuePairs,
            primaryKey: "Key"
        }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
            domProps: $162efce6a8fc61df$var$domProps,
            columns: columnsMap
        }));
    }
};
const $162efce6a8fc61df$var$ModuleView = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const module = adaptable.ModuleService.getModuleById(props.moduleName);
    if (!module?.isModuleVisible()) return null;
    const moduleInfo = module.moduleInfo;
    const [isWizardOpen, setIsWizardOpen] = $acw62.useState(false);
    const EditWizard = module?.getViewProperties?.()?.getEditWizard?.();
    const column = adaptable.api.columnApi.getColumnWithColumnId(props.selectedColumnId);
    const allItems = module?.toViewAll?.();
    // Dont show calculated column for non calc cols
    if (module.moduleInfo.ModuleName == 'CalculatedColumn' && !column.isCalculatedColumn) return $acw62.createElement($acw62.Fragment, null);
    // if (MODULES_WITH_VIEW_ONLY.includes(props.moduleName) && !allItems?.length) {
    //   return <></>;
    // }
    const itemsInScope = allItems.filter((item)=>{
        if ('Scope' in item.abObject) return adaptable.api.columnScopeApi.isColumnInScope(column, item.abObject.Scope);
        if ('ColumnId' in item.abObject) return item.abObject?.ColumnId === props.selectedColumnId;
        return false;
    });
    if (!itemsInScope) return null;
    const handleWizardClose = $acw62.useCallback(()=>{
        setIsWizardOpen(false);
    }, []);
    // filter out items with scope
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        "data-name": module.moduleInfo.ModuleName,
        className: `${$162efce6a8fc61df$var$BASE_CLASS_NAME}__module-list twa:mb-4`,
        key: module.moduleInfo.ModuleName
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, $acw62.createElement("b", {
        className: `${$162efce6a8fc61df$var$BASE_CLASS_NAME}__header`
    }, module.moduleInfo.FriendlyName), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }), $acw62.createElement((0, $638939172b36e064$export$eda4ac1f0f4bc860), {
        onClick: ()=>setIsWizardOpen(true)
    }, "New")), itemsInScope?.length ? $acw62.createElement((0, $e7b071cd434f710e$export$52f2aa84838d2a04), {
        items: itemsInScope,
        module: module
    }) : null, isWizardOpen && EditWizard && $acw62.createElement(EditWizard, {
        popupParams: {
            column: column,
            action: 'New',
            source: 'ModuleButton'
        },
        moduleInfo: moduleInfo,
        data: null,
        configEntities: null,
        onCloseWizard: handleWizardClose,
        onFinishWizard: handleWizardClose
    }));
};
const $162efce6a8fc61df$export$fb288f79c90984d1 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [selectedColumnId, setSelectedColumnId] = $acw62.useState(props.selectedColumnId);
    const column = adaptable.api.columnApi.getColumnWithColumnId(selectedColumnId);
    return $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: "twa:flex-1 twa:border-none twa:shadow-md twa:overflow-hidden"
    }, $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039).FlexBody, {
        className: "twa:gap-3"
    }, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Select Column"
    }, $acw62.createElement((0, $568d00bde2c337b2$export$e5d989eba9e871bb), {
        value: selectedColumnId,
        onChange: (columnId)=>setSelectedColumnId(columnId)
    }))), selectedColumnId && $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:min-h-0 twa:flex-1"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column Summary"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Column State"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, selectedColumnId && $acw62.createElement($162efce6a8fc61df$var$ColumnDefPreview, {
        column: column
    })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, selectedColumnId && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: $162efce6a8fc61df$var$BASE_CLASS_NAME
    }, $162efce6a8fc61df$var$MODULES_WITH_COLUMN.map((moduleName)=>{
        return $acw62.createElement($162efce6a8fc61df$var$ModuleView, {
            key: moduleName,
            moduleName: moduleName,
            selectedColumnId: selectedColumnId
        });
    }))))));
};



const $318e50810d5d681b$export$34a3502632c14c4c = (props)=>{
    return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
        headerText: 'Column Info',
        glyphicon: 'info'
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:flex-1 twa:h-full twa:[--ab-grid-row-height:45px]"
    }, $acw62.createElement((0, $162efce6a8fc61df$export$fb288f79c90984d1), {
        selectedColumnId: props.popupParams?.column?.columnId
    })));
};



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



const $4f56822e8a85bf43$export$51a0d41e070314af = (props)=>{
    let icon = props.icon;
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    if ((0, $9200d8ae4e589d35$export$dff472f8017c5d8b)(icon)) icon = adaptable.api.userInterfaceApi.internalApi.prepareAdaptableIconDef(icon);
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        ...props,
        icon: icon
    });
};




var $9OAZF = parcelRequire("9OAZF");

const $49183a0fe4e763e0$var$tableDOMProps = {
    style: {
        height: '100%',
        minWidth: '10rem'
    }
};
const $49183a0fe4e763e0$var$columnTypes = {
    default: {
        align: 'start',
        defaultFlex: 1,
        defaultSortable: false,
        style: {
            fontSize: 'var(--ab-font-size-3)'
        }
    }
};
const $49183a0fe4e763e0$var$headerOptions = {
    alwaysReserveSpaceForSortIcon: false
};
const $49183a0fe4e763e0$export$589a3dc9527a8da9 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const primaryKeyHeader = adaptable.api.columnApi.getPrimaryKeyColumn() ? adaptable.api.columnApi.getFriendlyNameForColumnId(adaptable.api.columnApi.getPrimaryKeyColumn().columnId) : (0, $9OAZF.default).Humanize(adaptable.adaptableOptions.primaryKey);
    const allNotes = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>(0, $b5b505fd5df04a9f$export$c20626bfec5066b7)(state.Note));
    const isReadOnlyModule = adaptable.api.entitlementApi.getEntitlementAccessLevelForModule('Note') === 'ReadOnly';
    const formatDate = (date, format)=>{
        return (0, $1fe81e1078ace264$export$2e2bcd8739ae039).DateFormatter(date, {
            Pattern: format
        });
    };
    const columnsMap = $acw62.useMemo(()=>{
        const columns = {
            primaryKey: {
                field: 'PrimaryKeyValue',
                header: primaryKeyHeader
            },
            column: {
                field: 'ColumnId',
                header: 'Column',
                valueGetter: (params)=>{
                    return adaptable.api.columnApi.getFriendlyNameForColumnId(params.data.ColumnId);
                }
            },
            text: {
                field: 'Text',
                header: 'Text',
                defaultEditable: !isReadOnlyModule,
                defaultFlex: 3
            },
            timestamp: {
                field: 'Timestamp',
                valueGetter: (params)=>{
                    return formatDate(params.data.Timestamp, adaptable.api.noteApi.internalApi.getNotesDateFormat());
                }
            },
            delete: {
                defaultWidth: 50,
                render: (params)=>{
                    return $acw62.createElement((0, $4f56822e8a85bf43$export$51a0d41e070314af), {
                        disabled: isReadOnlyModule,
                        variant: "text",
                        icon: "delete",
                        onClick: ()=>{
                            const note = adaptable.api.noteApi.getNoteByUuid(params.data.Uuid);
                            adaptable.api.noteApi.deleteNote(note);
                        }
                    });
                }
            }
        };
        return columns;
    }, []);
    return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
        headerText: 'Notes',
        glyphicon: 'import',
        infoLink: props.moduleInfo.HelpPage
    }, $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
        data: allNotes,
        primaryKey: "Uuid",
        onDataMutations: (params)=>{
            for (const mutation of params.mutations){
                const [uuid, changes] = mutation;
                for (const change of changes)if (change.type === 'update') {
                    const data = change.data;
                    const prevNote = allNotes.find((x)=>x.Uuid === uuid);
                    if (prevNote.Text !== data.Text) adaptable.api.noteApi.updateNoteText(data.Text, prevNote);
                }
            }
        }
    }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
        columnTypes: $49183a0fe4e763e0$var$columnTypes,
        headerOptions: $49183a0fe4e763e0$var$headerOptions,
        domProps: $49183a0fe4e763e0$var$tableDOMProps,
        columns: columnsMap
    })));
};



var $acw62 = parcelRequire("acw62");








const $c3a5018f7822d930$var$tableDOMProps = {
    style: {
        minHeight: 160,
        minWidth: '10rem'
    }
};
const $c3a5018f7822d930$var$columnTypes = {
    default: {
        align: 'start',
        defaultFlex: 1,
        defaultSortable: false
    }
};
const $c3a5018f7822d930$var$headerOptions = {
    alwaysReserveSpaceForSortIcon: false
};
const $c3a5018f7822d930$var$CellComments = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const isReadOnlyModule = adaptable.api.entitlementApi.getEntitlementAccessLevelForModule('Comment') === 'ReadOnly';
    const formatDate = (date, format)=>{
        return (0, $1fe81e1078ace264$export$2e2bcd8739ae039).DateFormatter(date, {
            Pattern: format
        });
    };
    const columnsMap = $acw62.useMemo(()=>{
        const columns = {
            author: {
                field: 'Author',
                maxWidth: 100,
                valueGetter: (params)=>params.data.Author.UserName
            },
            timestamp: {
                field: 'Timestamp',
                maxWidth: 150,
                valueGetter: (params)=>{
                    return formatDate(params.data.Timestamp, adaptable.api.commentApi.internalApi.getCommentsDateFormat());
                }
            },
            text: {
                header: 'Text',
                field: 'Value',
                defaultFlex: 3
            }
        };
        return columns;
    }, []);
    const cellValue = adaptable.api.gridApi.getCellDisplayValue(props.commentThread.PrimaryKeyValue, props.commentThread.ColumnId);
    const primaryKeyHeader = $acw62.useMemo(()=>{
        const primaryKey = adaptable.api.optionsApi.getPrimaryKey();
        return adaptable.api.columnApi.getFriendlyNameForColumnId(primaryKey);
    }, []);
    const columnFriendlyName = adaptable.api.columnApi.getFriendlyNameForColumnId(props.commentThread.ColumnId);
    return $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: "twa:mb-2",
        header: $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center",
            className: "twa:w-full"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mr-2"
        }, $acw62.createElement("b", null, "Cell Value:"), " ", cellValue), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:mr-2"
        }, $acw62.createElement("b", null, primaryKeyHeader, ":"), " ", props.commentThread.PrimaryKeyValue), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement("b", null, "Column:"), " ", columnFriendlyName), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:flex-1"
        }), $acw62.createElement((0, $4f56822e8a85bf43$export$51a0d41e070314af), {
            className: "twa:mr-1",
            variant: "text",
            icon: "visibility-on",
            onClick: ()=>{
                adaptable.api.internalApi.getAnnotationsService().showPopup({
                    ColumnId: props.commentThread.ColumnId,
                    PrimaryKeyValue: props.commentThread.PrimaryKeyValue
                }, true);
            }
        }), $acw62.createElement((0, $4f56822e8a85bf43$export$51a0d41e070314af), {
            icon: "delete",
            disabled: isReadOnlyModule,
            variant: "text",
            onClick: ()=>{
                adaptable.api.commentApi.deleteCommentThread(props.commentThread);
            }
        }))
    }, $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
        data: props.commentThread.Comments,
        primaryKey: "Uuid"
    }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
        columnTypes: $c3a5018f7822d930$var$columnTypes,
        headerOptions: $c3a5018f7822d930$var$headerOptions,
        domProps: $c3a5018f7822d930$var$tableDOMProps,
        columns: columnsMap
    })));
};
const $c3a5018f7822d930$export$de46feaa6ae4244f = (props)=>{
    const commentThreads = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>{
        return state.Comment.CommentThreads;
    });
    return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
        headerText: 'Comments',
        glyphicon: 'comments',
        infoLink: props.moduleInfo.HelpPage
    }, (commentThreads ?? []).map((commentThread, index)=>{
        return $acw62.createElement($c3a5018f7822d930$var$CellComments, {
            key: commentThread?.Uuid ?? index,
            commentThread: commentThread
        });
    }));
};



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");





const $f70ac85891b25d20$var$jsonHandler = {
    fileExtension: '.json',
    handleFile: (file)=>(0, $ecc63bb8d4bdb327$export$aa2c7ad2063c8ec6)(file)
};
const $f70ac85891b25d20$export$42ff9ca196b7255f = (content)=>{
    const lines = content.split('\n');
    const headers = lines[0].split(',');
    const data = [];
    if (lines.length <= 1) return null;
    for(let i = 1; i < lines.length; i++){
        const values = lines[i].split(',');
        if (values.length === headers.length) {
            const item = {};
            for(let j = 0; j < headers.length; j++){
                const value = values[j];
                item[headers[j]] = value === '' || isNaN(Number(value)) ? value : Number(value); // '0012345'
            }
            data.push(item);
        }
    }
    return data;
};
const $f70ac85891b25d20$var$csvFileHandler = {
    fileExtension: '.csv',
    handleFile: (file)=>{
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.onload = (event)=>{
                const content = event.target?.result;
                resolve($f70ac85891b25d20$export$42ff9ca196b7255f(content));
            };
            reader.readAsText(file);
        });
    }
};
const $f70ac85891b25d20$export$875cf39cdacc7004 = [
    $f70ac85891b25d20$var$jsonHandler,
    $f70ac85891b25d20$var$csvFileHandler
];



var $acw62 = parcelRequire("acw62");










var $5aWMQ = parcelRequire("5aWMQ");

const $206868a328e74f0d$var$tableDOMProps = {
    style: {
        height: '100%',
        minWidth: '10rem',
        minHeight: 300,
        flex: 1
    }
};
const $206868a328e74f0d$export$e7d304bbce738d09 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const primaryKey = api.optionsApi.getPrimaryKey();
    const allColumns = $acw62.useMemo(()=>{
        return api.columnApi.getUIAvailableColumns().filter((col)=>col.field).map((column)=>({
                label: column.friendlyName,
                value: column
            }));
    }, []);
    const handleColumnMapChange = (newColMap)=>{
        props.onColumnsChange(props.columnsMap?.map((cm)=>{
            if (cm.field === newColMap.field) return {
                ...cm,
                ...newColMap
            };
            return cm;
        }));
    };
    const columns = $acw62.useMemo(()=>{
        return {
            include: {
                field: 'include',
                header: 'Included',
                maxWidth: 110,
                align: 'center',
                render: (params)=>{
                    return $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                        disabled: params.data?.abColumn?.field === primaryKey,
                        onChange: (checked)=>{
                            handleColumnMapChange({
                                ...params.data,
                                include: checked
                            });
                        },
                        checked: Boolean(params.data.include)
                    });
                }
            },
            field: {
                field: 'field',
                header: 'Data Field'
            },
            abColumn: {
                header: 'AdapTable Column',
                render: (params)=>{
                    // filter out used columns
                    const availableColumns = allColumns.filter((c)=>!props.columnsMap?.find((cm)=>cm.abColumn === c.value)).map((col)=>{
                        return {
                            ...col,
                            onClick: ()=>{
                                handleColumnMapChange({
                                    ...params.data,
                                    abColumn: col.value,
                                    include: true
                                });
                            }
                        };
                    });
                    return $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
                        showClearButton: true,
                        onClear: ()=>{
                            handleColumnMapChange({
                                ...params.data,
                                abColumn: null,
                                include: false
                            });
                        },
                        className: "twa:w-full",
                        columns: [
                            'label'
                        ],
                        items: availableColumns
                    }, params.data?.abColumn?.friendlyName ?? params.data?.abColumn?.columnId ?? 'Select Column');
                }
            },
            valid: {
                header: 'Valid',
                maxWidth: 100,
                minWidth: 90,
                align: 'center',
                render: (row)=>{
                    if (!row.data.abColumn) return $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
                        popoverMinWidth: 200,
                        showEvent: "mouseenter",
                        hideEvent: "mouseleave",
                        headerText: 'Validation Error',
                        bodyText: [
                            'Select Column'
                        ],
                        MessageType: 'Error'
                    });
                    const successColor = (0, $5aWMQ.default).getColorByMessageType('Success');
                    return $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                        name: "check",
                        style: {
                            color: successColor,
                            fill: 'currentColor'
                        }
                    });
                }
            }
        };
    }, [
        props.columnsMap
    ]);
    if (!props.columnsMap) return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:text-error"
    }, "No Data has been Imported. Go to ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "Upload"), " step and provide Data"));
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:p-2 twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mb-2 twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Columns"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
        data: props.columnsMap,
        primaryKey: 'field'
    }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
        columnPinning: {
            valid: 'end',
            type: 'end'
        },
        columnTypes: {
            default: {
                minWidth: 100,
                defaultFlex: 1
            }
        },
        domProps: $206868a328e74f0d$var$tableDOMProps,
        columns: columns
    })))));
};
$206868a328e74f0d$export$e7d304bbce738d09.displayName = 'ColumnsSection';



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $93bd69aa7b132eaf$export$addfcf622000158d = (props)=>{
    return $acw62.createElement((0, $ecc63bb8d4bdb327$export$2e2bcd8739ae039), {
        loadingText: $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
            className: "twa:mb-2"
        }, "File loaded , file ready to be imported."),
        message: props.message,
        helpText: "Data Import",
        defaultText: "Click here to select a file to load, or drag it here",
        dragOverText: "Drop file here to start Data Import",
        className: "twa:h-full",
        fileAccept: props.supportedFileFormats,
        readFile: props.readFile
    });
};



var $acw62 = parcelRequire("acw62");


const $2939e5e5fcaf5827$export$4edf77d7dfd6b5d2 = (props)=>{
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $d541796d86c181e1$export$2e2bcd8739ae039), {
        value: props.text,
        onChange: (event)=>props.onTextChange(event.target.value),
        className: "twa:h-full"
    }), props.message && $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), null, props.message));
};



const $0651ad5d9004913b$export$c554dbaaf02e767a = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:p-2 twa:h-full"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mb-2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Import Type"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        onClick: ()=>props.onImportTypeChange('file'),
        checked: props.importType === 'file'
    }, "File"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        onClick: ()=>props.onImportTypeChange('text'),
        checked: props.importType === 'text'
    }, "Text")))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:flex-1"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, props.importType === 'file' ? 'File Upload' : 'Text'), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, props.importType === 'file' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $93bd69aa7b132eaf$export$addfcf622000158d), {
        readFile: props.readFile,
        supportedFileFormats: props.supportedFileFormats,
        message: props.fileMessage
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2939e5e5fcaf5827$export$4edf77d7dfd6b5d2), {
        message: props.textMessage,
        text: props.text,
        onTextChange: props.onTextChange
    }))));
};





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");







var $5aWMQ = parcelRequire("5aWMQ");
const $1533df04b9b34952$var$tableDOMProps = {
    style: {
        height: '100%',
        minWidth: '10rem',
        minHeight: 300,
        flex: 1
    }
};
const $1533df04b9b34952$var$getRowErrors = (errors, primaryKeyValue)=>{
    if (!errors) return null;
    if (!errors[primaryKeyValue]) return null;
    return errors[primaryKeyValue];
};
const $1533df04b9b34952$var$getCellError = (errors, primaryKeyValue, columnId)=>{
    return $1533df04b9b34952$var$getRowErrors(errors, primaryKeyValue)?.find((e)=>e.columnId === columnId) ?? null;
};
const $1533df04b9b34952$export$c68b8e1d975e84cd = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dataImportOptions = adaptable.api.optionsApi.getDataImportOptions();
    if (!props.data) return $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        color: 'var(--ab-color-error)'
    }, "No Data has been Imported. Go to ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, "Upload"), " step and provide Data");
    const primaryKey = adaptable.api.optionsApi.getPrimaryKey();
    const columns = $acw62.useMemo(()=>{
        const mappedAdaptableColumns = props.columnsMap?.filter((map)=>map.include && map.abColumn);
        const mapDataType = (dataType)=>{
            switch(dataType){
                case 'boolean':
                    return 'boolean';
                case 'date':
                    return 'date';
                case 'number':
                    return 'number';
                case 'text':
                    return 'string';
            }
            return dataType;
        };
        const getPrimaryKeyValue = (rowData)=>{
            if (typeof dataImportOptions._getPrimaryKeyValue === 'function') return dataImportOptions._getPrimaryKeyValue({
                ...adaptable.api.internalApi.buildBaseContext(),
                rowData: rowData
            });
            return rowData[primaryKey];
        };
        const infiniteColumns = mappedAdaptableColumns.reduce((acc, colMap)=>{
            const isPrimaryKey = colMap?.abColumn?.columnId === primaryKey;
            let editable = !isPrimaryKey;
            if (props.editable !== undefined && !isPrimaryKey) editable = props.editable;
            const abColumn = colMap.abColumn;
            acc[colMap.field] = {
                field: colMap.field,
                header: adaptable.api.columnApi.getFriendlyNameForColumnId(colMap.abColumn.columnId),
                dataType: mapDataType(abColumn.dataType),
                defaultEditable: editable,
                valueGetter: (params)=>{
                    if (abColumn.dataType === 'boolean') return params.data[colMap.field] ? 'True' : 'False';
                    else return params.data[colMap.field];
                }
            };
            return acc;
        }, {});
        infiniteColumns['valid'] = {
            header: 'Valid',
            maxWidth: 100,
            minWidth: 90,
            align: 'center',
            renderValue: (params)=>{
                const cellErrors = $1533df04b9b34952$var$getRowErrors(props.errors, getPrimaryKeyValue(params.data));
                const successColor = (0, $5aWMQ.default).getColorByMessageType('Success');
                if (!cellErrors || cellErrors.length === 0) return $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
                    name: "check",
                    style: {
                        color: successColor,
                        fill: 'currentColor'
                    }
                });
                const errorsStr = cellErrors.map((e)=>e.error).join(', ');
                return $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
                    popoverMinWidth: 200,
                    showEvent: "mouseenter",
                    hideEvent: "mouseleave",
                    headerText: 'Validation Error',
                    bodyText: [
                        errorsStr
                    ],
                    MessageType: 'Error'
                });
            }
        };
        infiniteColumns['type'] = {
            header: 'Type',
            maxWidth: 100,
            minWidth: 90,
            renderValue: (params)=>{
                try {
                    const isExistingRow = adaptable.api.gridApi.getRowNodeForPrimaryKey(getPrimaryKeyValue(params.data));
                    return isExistingRow ? 'Update' : 'New';
                } catch (error) {
                // empty
                }
                return $acw62.createElement($acw62.Fragment, null);
            }
        };
        return infiniteColumns;
    }, [
        props.data
    ]);
    const getCellErrorStyle = (columnId, primaryKeyValue)=>{
        const cellError = $1533df04b9b34952$var$getCellError(props.errors, primaryKeyValue, columnId);
        if (!cellError) return {};
        return {
            border: 'var(--ab-Dataimport-validation-error__border)'
        };
    };
    return $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
        data: props.data,
        primaryKey: primaryKey,
        onDataMutations: (params)=>{
            const newRowData = [
                ...props.data
            ];
            const mutationsList = (0, $826488674b2774ee$export$2e2bcd8739ae039)(Array.from(params.mutations.values()));
            if (!mutationsList.length) return;
            mutationsList.forEach((mutation)=>{
                const index = newRowData.findIndex((row)=>row[primaryKey] === mutation.primaryKey);
                if (index !== -1) newRowData[index] = {
                    ...newRowData[index],
                    ...mutation.data
                };
            });
            props.onDataChange(newRowData);
        }
    }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
        columnPinning: {
            valid: 'end',
            type: 'end'
        },
        columnTypes: {
            default: {
                style: (params)=>{
                    return getCellErrorStyle(params.column.id, params.rowInfo.id);
                },
                minWidth: 100,
                defaultFlex: 1
            }
        },
        domProps: $1533df04b9b34952$var$tableDOMProps,
        columns: columns
    }));
};



const $10f9e1e66eb7fc32$var$getRowErrors = (errors, primaryKeyValue)=>{
    if (!errors) return null;
    if (!errors[primaryKeyValue]) return null;
    return errors[primaryKeyValue];
};
const $10f9e1e66eb7fc32$export$e661dbd29743513b = (props)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:p-2 twa:h-full"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:mb-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Import Options"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), null, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Exclude Invalid Rows"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        onChange: ()=>{
            props.onSkipInvalidRowsChange(!props.skipInvalidRows);
        },
        checked: props.skipInvalidRows
    }))))), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), {
        className: "twa:flex-1"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Preview"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $1533df04b9b34952$export$c68b8e1d975e84cd), {
        columnsMap: props.columnsMap,
        data: props.data,
        errors: props.errors,
        editable: true,
        onDataChange: props.onDataChange
    }))));
};


const $d511777b1440a720$export$2037ce6fb835fb3d = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const adaptableApi = adaptable.api;
    const dataImportOptions = adaptableApi.optionsApi.getDataImportOptions();
    const module = adaptableApi.internalApi.getModuleService().getModuleById('DataImport');
    const [rowData, setRowData] = $acw62.useState(null);
    const [file, setFile] = $acw62.useState(null);
    const [text, setText] = $acw62.useState('');
    // This needs to be called only when:
    // - columnsMap changes
    // - new data is loaded
    const [importType, setImportType] = $acw62.useState('file');
    const primaryKey = adaptableApi.optionsApi.getPrimaryKey();
    const hasDynamicallyAddedPrimaryKey = typeof dataImportOptions._getPrimaryKeyValue === 'function';
    const getPrimaryKeyValue = (rowData)=>{
        if (hasDynamicallyAddedPrimaryKey) return dataImportOptions._getPrimaryKeyValue({
            ...adaptableApi.internalApi.buildBaseContext(),
            rowData: rowData
        });
        return rowData[primaryKey];
    };
    const preprocessRowData = (rowData)=>{
        if (typeof dataImportOptions?._preprocessRowData === 'function') return dataImportOptions._preprocessRowData({
            ...adaptableApi.internalApi.buildBaseContext(),
            rowData: rowData
        });
        // by default just trim the keys
        let processedRowData = {};
        if (rowData) processedRowData = Object.keys(rowData).reduce((acc, key)=>{
            acc[key.trim()] = rowData[key];
            return acc;
        }, processedRowData);
        return processedRowData;
    };
    // ---- COLUMNS ----
    const [columnsMap, setColumnsMap] = $acw62.useState(null);
    const mappedRowDataToColumns = $acw62.useMemo(()=>{
        return (rowData ?? []).map((row)=>{
            // pick only included columns, and need to map to abColumn.field
            return columnsMap?.reduce((acc, colMap)=>{
                if (colMap.include && colMap.abColumn && colMap.abColumn.field) acc[colMap.abColumn.field] = row[colMap.field];
                return acc;
            }, {});
        });
    }, [
        rowData,
        columnsMap
    ]);
    const columnsErrors = $acw62.useMemo(()=>{
        return columnsMap ? columnsMap.reduce((acc, colMap)=>{
            if (colMap.include && !colMap.abColumn) acc[colMap.field] = `Field ${colMap.field} does not have a coresponding column.`;
            return acc;
        }, {}) : null;
    }, [
        columnsMap
    ]);
    const handleNewRowData = $acw62.useCallback((data)=>{
        if (Array.isArray(data)) {
            const processedData = data.map((rowData)=>preprocessRowData(rowData));
            setRowData(processedData);
            const fields = new Set();
            processedData.forEach((row)=>{
                Object.keys(row).forEach((field)=>{
                    fields.add(field);
                });
            });
            const allAbColumns = adaptableApi.columnApi.getColumns();
            const columnsMap = Array.from(fields).map((field)=>{
                const abColumn = allAbColumns.find((c)=>{
                    // exact field match
                    if (c.field === field) return true;
                    // based on friendly name
                    const friendlyName = c.friendlyName;
                    if (typeof friendlyName !== 'string') return false;
                    // exact match
                    if (friendlyName === field) return true;
                    // match without case
                    if (friendlyName.toLowerCase() === field.toLowerCase()) return true;
                    // match without spaces and case, and special characters: ' ', '-', '_'
                    if (friendlyName.replace(/\s|-|_/g, '').toLowerCase() === field.toLowerCase()) return true;
                    return false;
                });
                return {
                    field: field,
                    abColumn: abColumn,
                    include: true
                };
            });
            setColumnsMap(columnsMap);
        } else {
            setRowData(null);
            setColumnsMap(null);
        }
    }, []);
    const handleRowDataChange = $acw62.useCallback((data)=>{
        if (Array.isArray(data)) setRowData(data);
        else setRowData(null);
    }, []);
    const handleChangeImportType = $acw62.useCallback((importType)=>{
        setImportType(importType);
        // clear data
        handleNewRowData(null);
        setFile(null);
        setText('');
    }, []);
    // ---- FILE HANDLERS ----
    const fileHandlers = $acw62.useMemo(()=>{
        const userDefinedHandlers = adaptableApi.optionsApi.getDataImportOptions()?.fileHandlers ?? [];
        return [
            ...userDefinedHandlers,
            ...(0, $f70ac85891b25d20$export$875cf39cdacc7004)
        ];
    }, []);
    const supportedFileFormats = $acw62.useMemo(()=>{
        return [
            ...new Set(fileHandlers.map((h)=>h.fileExtension)).values()
        ].join(', ');
    }, [
        fileHandlers
    ]);
    const readFile = $acw62.useCallback(async (file)=>{
        const userDefinedFileHandlers = adaptableApi.optionsApi.getDataImportOptions()?.fileHandlers ?? [];
        const fileExtension = `.${file.name.split('.').pop()}`;
        const handler = [
            ...userDefinedFileHandlers,
            ...(0, $f70ac85891b25d20$export$875cf39cdacc7004)
        ].find((fh)=>fh.fileExtension === fileExtension);
        if (!handler) {
            adaptableApi.logError(`No file handler found for file extension ${fileExtension}. Please provide a file handler in Data Import Options.`);
            return;
        }
        try {
            const data = await handler.handleFile(file);
            setFile(file);
            handleNewRowData(data);
            return data;
        } catch  {
            adaptableApi.logError(`Error reading file ${file.name}. Please check the file is valid.`);
        }
    }, [
        adaptable
    ]);
    const fileMessage = file ? $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mb-2"
    }, "File ", $acw62.createElement((0, $3283d8fe16778b21$export$3288d34c523a1192), null, file.name), " is ready to be imported.") : $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mb-2"
    }, "Supported file types: ", supportedFileFormats);
    // ---- TEXT IMPORT ----
    const [textError, setTextError] = $acw62.useState(null);
    const handleTextChange = $acw62.useCallback(async (text)=>{
        //
        let textHandler = adaptableApi.optionsApi.getDataImportOptions()?.textHandler;
        if (!textHandler) {
            // regex to test for json
            const jsonRegex = /^\s*[\[{]/;
            if (text && jsonRegex.test(text)) textHandler = JSON.parse;
            else textHandler = (0, $f70ac85891b25d20$export$42ff9ca196b7255f);
        }
        setText(text);
        let textRawData = null;
        if (!text || text === '') setTextError(null);
        else try {
            textRawData = await textHandler(text);
            if (Array.isArray(textRawData)) {
                handleNewRowData(textRawData);
                setTextError('');
            } else throw 'Error parsing text';
        } catch  {
            handleNewRowData(null);
            setTextError('Error parsing text');
        }
    }, []);
    const textMessage = textError ?? (!rowData ? 'Paste your data here' : '');
    // ---- VALIDATION ----
    const errors = $acw62.useMemo(()=>{
        if (!dataImportOptions?.validate) return null;
        if (!rowData) return null;
        return rowData?.reduce?.((acc, rowData)=>{
            const error = dataImportOptions.validate({
                rowData: rowData,
                ...adaptableApi.internalApi.buildBaseContext()
            });
            const primaryKeyValue = getPrimaryKeyValue(rowData);
            if (error && primaryKeyValue && error.length) acc[primaryKeyValue] = error;
            return acc;
        }, {});
    }, [
        rowData
    ]) ?? {};
    const [skipInvalidRows, setSkipInvalidRows] = $acw62.useState(false);
    const handleFinish = ()=>{
        const validData = mappedRowDataToColumns.filter((row)=>{
            const rowErrors = errors[getPrimaryKeyValue(row)];
            return !rowErrors || rowErrors.length === 0;
        });
        adaptableApi.dataImportApi.internalApi.importData(validData);
    };
    return $acw62.createElement((0, $e70b2e3a7d03e2cc$export$f5ccbfd9ce36e9e), {
        data: null,
        moduleInfo: module.moduleInfo,
        finishText: "Import",
        onFinish: ()=>{
            handleFinish();
            props.onClose();
        },
        onHide: ()=>{
            props.onClose();
        },
        sections: [
            {
                title: 'Upload',
                isValid: ()=>{
                    return rowData ? true : 'No valid data uploaded';
                },
                details: 'Upload the data',
                render: ()=>{
                    return $acw62.createElement((0, $0651ad5d9004913b$export$c554dbaaf02e767a), {
                        importType: importType,
                        onImportTypeChange: handleChangeImportType,
                        // FILE
                        readFile: readFile,
                        supportedFileFormats: supportedFileFormats,
                        fileMessage: fileMessage,
                        // TEXT
                        text: text,
                        onTextChange: handleTextChange,
                        textMessage: textMessage
                    });
                }
            },
            {
                title: 'Columns',
                isValid: ()=>{
                    if (columnsErrors && Object.keys(columnsErrors).length > 0) return 'Some fields do not have a corresponding column.';
                    if (!hasDynamicallyAddedPrimaryKey && !columnsMap?.some((map)=>map?.abColumn?.field === primaryKey)) return 'You need to select a column for the primary key.';
                    return true;
                },
                render: ()=>{
                    return $acw62.createElement((0, $206868a328e74f0d$export$e7d304bbce738d09), {
                        columnsMap: columnsMap,
                        onColumnsChange: (columnsMap)=>{
                            setColumnsMap(columnsMap);
                        }
                    });
                }
            },
            {
                title: 'Validation',
                details: 'Check the Data is Valid',
                isValid: ()=>{
                    if (errors && Object.keys(errors).length > 0) {
                        if (!skipInvalidRows) return 'There are errors in the data.';
                    }
                    return true;
                },
                render: ()=>{
                    return $acw62.createElement((0, $10f9e1e66eb7fc32$export$e661dbd29743513b), {
                        errors: errors,
                        data: rowData,
                        columnsMap: columnsMap,
                        onDataChange: handleRowDataChange,
                        skipInvalidRows: skipInvalidRows,
                        onSkipInvalidRowsChange: setSkipInvalidRows
                    });
                }
            }
        ]
    });
};





const $0beafd986a88ffe3$export$592cd1999dd55e4f = (props)=>{
    const [isWizardOpen, setIsWizardOpen] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (props?.popupParams == undefined || props.popupParams?.action === 'New' && props.popupParams?.source !== 'ModuleMenu') setIsWizardOpen(true);
    }, []);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
        headerText: 'Data Import',
        glyphicon: 'import',
        infoLink: props.moduleInfo.HelpPage
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mb-2 twa:text-3"
    }, "Click the 'Import Data' button to Insert or Update data into AdapTable"), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        icon: "import",
        variant: "raised",
        onClick: ()=>setIsWizardOpen(true)
    }, "Import Data"))), isWizardOpen && $acw62.createElement((0, $d511777b1440a720$export$2037ce6fb835fb3d), {
        onClose: ()=>{
            setIsWizardOpen(false);
            if (props?.popupParams == undefined || [
                'Toolbar',
                'ContextMenu',
                'ColumnMenu',
                'ModuleButton'
            ].includes(props?.popupParams?.source)) props.onClosePopup();
        }
    }));
};


const $b1f453bcc52a26e6$export$d4d53f0c4fbfa3c7 = {
    BulkUpdatePopup: $82b85f11be8b7368$export$7df648d00e9fe111,
    DashboardPopup: $d2037bfd6b6a8b89$export$9c1efdcc2d838d4c,
    StateManagementPopup: $2bfd39b339120b70$export$9b7ffd27007336c4,
    GridInfoPopup: $a59287dd12f4a25c$export$ca8e9f49356b02bc,
    ColumnInfoPopup: $318e50810d5d681b$export$34a3502632c14c4c,
    StatusBarPopup: $d0cd554d52d75dd8$export$e48c05a1e1507aec,
    QuickSearchPopup: $3994c9f0d97346a3$export$b772fc5147b4377e,
    CellSummaryPopup: $70fc57743f4ab094$export$36cec22fff7be239,
    SmartEditPopup: $7f9b56417e888f6c$export$4bc2a72351437dba,
    ThemePopup: $b63d155c7302e57f$export$bf2dfc01c820b299,
    ToolPanelPopup: $69de3722b23fa6b3$export$ee4d8524b10cd215,
    SystemStatusPopup: $7daa9dcd7ea9e080$export$efb1b9ba5e9e0b2a,
    DataChangeHistoryPopup: $c68710dde3fa468e$export$e3c0fc5a98e7dc2d,
    NotePopup: $49183a0fe4e763e0$export$589a3dc9527a8da9,
    CommentsPopup: $c3a5018f7822d930$export$de46feaa6ae4244f,
    DataImportPopup: $0beafd986a88ffe3$export$592cd1999dd55e4f,
    GridFilterPopup: $b5fe7a9480e81114$export$26fe6275db30557b
};
const $b1f453bcc52a26e6$export$c7001f4850704fce = new Map([
    [
        $42e863194fcb493f$export$40024cb74c2bb550,
        (0, $2afd3d36e004f0c0$export$56824573e79b0fc9)
    ],
    [
        $42e863194fcb493f$export$bc824d5002237871,
        (0, $27fffdda7aeb12e3$export$9ffc51341cb2860d)
    ],
    [
        $42e863194fcb493f$export$bbf6ee8f129590d,
        (0, $4cb59ce417ff5736$export$bb3b60cacf4656ce)
    ],
    [
        $42e863194fcb493f$export$edfe19743c8e0917,
        (0, $bb8f9c2dee17651a$export$5e59a1b2b80445d4)
    ],
    [
        $42e863194fcb493f$export$b74b667f10548947,
        (0, $dd5640f82355729c$export$ad2fb329bb32d88f)
    ],
    [
        $42e863194fcb493f$export$2bc329d2b6ae03ac,
        (0, $071db7aceca292b4$export$792e2fdfffef6e0)
    ],
    [
        $42e863194fcb493f$export$802bb096eb63f491,
        (0, $704cfbf03813c33a$export$9ede731e9a9e7453)
    ],
    [
        $42e863194fcb493f$export$4908330cb20abb96,
        (0, $a83a6b82c274b5d4$export$3d916a3db120b9b2)
    ],
    [
        $42e863194fcb493f$export$cf7621e489e71e3c,
        (0, $814cc0fbc574ca51$export$42dedef674ff16eb)
    ],
    [
        $42e863194fcb493f$export$3fb170c57e2678e6,
        (0, $f2a47a599017ed55$export$37a1d6d8690607a3)
    ],
    [
        $42e863194fcb493f$export$49045387ac7420d5,
        (0, $f2a972f75289f0b9$export$22b15c4549030087)
    ],
    [
        $42e863194fcb493f$export$ebf1703e41256059,
        (0, $3c26dfdffed76624$export$ca8a1071713d0e85)
    ],
    [
        $42e863194fcb493f$export$b0d2488aa9d7ee1f,
        (0, $fd16494c28d31d38$export$641e32dccec28126)
    ],
    [
        $42e863194fcb493f$export$376343cd8119f6bf,
        (0, $9496a3e89e38ca39$export$7b7ccfbe7e516813)
    ],
    [
        $42e863194fcb493f$export$826ed58486b36acd,
        (0, $15af8141406ea914$export$98795ddbdbbc68e4)
    ],
    [
        $42e863194fcb493f$export$a3fc1172140ca1e4,
        (0, $6dd6d1bc42e6f038$export$4c5ab965026a1e05)
    ]
]);



var $acw62 = parcelRequire("acw62");




const $8e02099e6cbe06cd$export$4fc4d4ceee184da7 = (props)=>{
    const { customToolPanel: customToolPanel } = props;
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const contentsDivDomRef = (0, $acw62.useRef)(null);
    const contentsDivId = `ab-ToolPanel__${customToolPanel.name}__contents`;
    const buttonsDivId = `ab-ToolPanel__${customToolPanel.name}__buttons`;
    const [contentsHTML, setContentsHTML] = (0, $acw62.useState)('');
    (0, $acw62.useLayoutEffect)(()=>{
        const element = contentsDivDomRef.current;
        if ($8e02099e6cbe06cd$var$hasCustomRenderFn(customToolPanel)) {
            const customRenderContext = {
                phase: 'onMount',
                element: element,
                ...api.internalApi.buildBaseContext()
            };
            const html = customToolPanel.render(customRenderContext);
            setContentsHTML(html);
        } else if ($8e02099e6cbe06cd$var$hasCustomFrameworkComponent(customToolPanel)) api.internalApi.createFrameworkComponent(element, customToolPanel.frameworkComponent, 'toolPanel');
        return ()=>{
            if ($8e02099e6cbe06cd$var$hasCustomRenderFn(customToolPanel)) customToolPanel.render({
                phase: 'onDestroy',
                element: element,
                ...api.internalApi.buildBaseContext()
            });
            else if ($8e02099e6cbe06cd$var$hasCustomFrameworkComponent(customToolPanel) && !api.isDestroyed()) api.internalApi.destroyFrameworkComponent(element, customToolPanel.frameworkComponent, 'toolPanel');
        };
    }, []);
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement("div", {
        ref: contentsDivDomRef,
        id: contentsDivId,
        className: contentsDivId,
        dangerouslySetInnerHTML: {
            __html: contentsHTML
        },
        style: {
            width: '100%'
        }
    }), customToolPanel.buttons?.length && $acw62.createElement("div", {
        id: buttonsDivId,
        className: `ab-ToolPanel__custom-content__buttons ${buttonsDivId}`
    }, customToolPanel.buttons.map((button)=>{
        // TODO: variants of this mapping are present in several places (just search for api.internalApi.getStyleForButton() usages)
        // with the next opportunity we should abstract it
        const toolPanelContext = {
            ...api.internalApi.buildBaseContext(),
            toolPanelState: api.toolPanelApi.getToolPanelState(),
            customToolPanel: customToolPanel
        };
        const buttonIcon = api.internalApi.getIconForButton(button, toolPanelContext);
        let buttonStyle = api.internalApi.getStyleForButton(button, toolPanelContext);
        let buttonLabel = api.internalApi.getLabelForButton(button, toolPanelContext);
        let buttonTooltip = api.internalApi.getTooltipForButton(button, toolPanelContext);
        if (button.hidden && button.hidden(button, toolPanelContext)) return null;
        const disabled = button.disabled && button.disabled(button, toolPanelContext);
        const buttonVariant = buttonStyle && buttonStyle.variant ? buttonStyle.variant : 'text';
        const buttonTone = buttonStyle && buttonStyle.tone ? buttonStyle.tone : 'none';
        const uniqueKey = buttonLabel ?? (0, $e48e47ebfd8103c5$export$10a020066a0f444a)();
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            key: uniqueKey,
            variant: buttonVariant,
            tone: buttonTone,
            className: `ab-ToolPanel__Home__${(0, $9ce0650a2a8dba81$export$2e2bcd8739ae039)(buttonLabel)} ${buttonStyle?.className || ''}`,
            tooltip: buttonTooltip,
            icon: buttonIcon,
            disabled: disabled,
            onClick: ()=>button.onClick(button, toolPanelContext),
            accessLevel: 'Full'
        }, buttonLabel);
    })));
};
const $8e02099e6cbe06cd$var$hasCustomRenderFn = (customToolPanel)=>customToolPanel.render;
const $8e02099e6cbe06cd$var$hasCustomFrameworkComponent = (customToolPanel)=>customToolPanel.frameworkComponent;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

class $69235b30b3892b3d$export$7f278fcd693ae9f2 extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "close",
            tooltip: "Close",
            iconSize: 20,
            icon: "close",
            ...this.props,
            variant: "text"
        });
    }
}




var $acw62 = parcelRequire("acw62");

class $91a6683bece890aa$export$6c5b8790fed25f49 extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "minimise",
            iconSize: 20,
            tooltip: "Minimise",
            ...this.props,
            variant: "text",
            icon: "arrow-up"
        });
    }
}



var $acw62 = parcelRequire("acw62");

class $733f8fc7cc0a1c52$export$1fc8c35cfa8874f7 extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "maximise",
            iconSize: 20,
            tooltip: "Maximize",
            icon: this.props.useHoirzontalChevron ? 'arrow-right' : 'arrow-down',
            variant: "text",
            ...this.props
        });
    }
}




class $2c31a9c151d05148$export$1929a08de907df5a extends $acw62.Component {
    static defaultProps = {
        headerText: '',
        onClose: null,
        onConfigure: null,
        onMinimiseChanged: null,
        isMinimised: true
    };
    render() {
        const { useDefaultPanelStyle: useDefaultPanelStyle, isMinimised: isMinimised, onMinimiseChanged: onMinimiseChanged, headerText: headerText, onClose: onClose, onConfigure: onConfigure, ...props } = this.props;
        let header = $acw62.createElement($acw62.Fragment, null, !isMinimised ? $acw62.createElement((0, $91a6683bece890aa$export$6c5b8790fed25f49), {
            className: "ab-ToolPanelPanel__header-minimise twa:mr-1",
            onClick: ()=>onMinimiseChanged()
        }) : $acw62.createElement((0, $733f8fc7cc0a1c52$export$1fc8c35cfa8874f7), {
            className: "ab-ToolPanelPanel__header-maximise twa:mr-1",
            onClick: ()=>onMinimiseChanged()
        }), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "ab-ToolPanelPanel__header-text twa:flex-1 twa:ml-0",
            alignItems: "center"
        }, headerText), onConfigure && $acw62.createElement((0, $a351badd06d496fe$export$dc1762fe2fbc8a24), {
            iconSize: 16,
            className: "ab-ToolPanelPanel__header-configure-button twa:ml-1",
            tooltip: 'Configure ' + headerText,
            onClick: ()=>onConfigure()
        }), onClose && $acw62.createElement((0, $69235b30b3892b3d$export$7f278fcd693ae9f2), {
            className: "ab-ToolPanelPanel__header-close-button twa:ml-0",
            tooltip: 'Close ' + headerText,
            onClick: ()=>onClose(),
            disabled: props.disabled
        }));
        return $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
            ...props,
            className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('ab-ToolPanelPanel', props.className),
            header: header,
            style: {
                ...props.style
            },
            headerProps: {
                ...props.headerProps,
                alignItems: 'stretch',
                className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:border-none', props.headerProps?.className),
                style: {
                    padding: 'var(--ab-cmp-toolpanelpanel_header__padding)',
                    background: 'var(--ab-cmp-toolpanelpanel_header__background)',
                    color: 'var(--ab-cmp-toolpanelpanel_header__color)',
                    fill: 'var(--ab-cmp-toolpanelpanel_header__fill)',
                    ...props.headerProps ? props.headerProps.style : null
                }
            },
            bodyProps: {
                ...props.bodyProps,
                className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:border-none twa:flex twa:flex-col', props.bodyProps?.className),
                style: {
                    padding: 'var(--ab-cmp-dashboardpanel_body__padding)',
                    background: 'var(--ab-cmp-dashboardpanel_body__background)',
                    ...props.bodyProps ? props.bodyProps.style : null
                }
            }
        });
    }
}





const $94051a6714e4ce21$export$73331999a6320a2a = (props)=>{
    const { adaptableToolPanel: adaptableToolPanel, customToolPanel: customToolPanel, visibilityMode: visibilityMode, onVisibilityModeChange: onVisibilityModeChange } = props;
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const getToolPanelConfiguration = ()=>{
        if (adaptableToolPanel) {
            const accessLevel = api.entitlementApi.getEntitlementAccessLevelForModule(adaptableToolPanel);
            const moduleInfo = api.internalApi.getModuleService().getModuleInfoByModule(adaptableToolPanel);
            const ModuleToolPanel = (0, $b1f453bcc52a26e6$export$c7001f4850704fce).get(adaptableToolPanel);
            return [
                adaptableToolPanel,
                moduleInfo.FriendlyName,
                ModuleToolPanel ? $acw62.createElement(ModuleToolPanel, {
                    viewType: "ToolPanel",
                    api: api,
                    accessLevel: accessLevel,
                    moduleInfo: moduleInfo
                }) : null,
                moduleInfo
            ];
        } else // custom toolPanel
        return [
            customToolPanel.name,
            customToolPanel?.title ?? customToolPanel.name,
            $acw62.createElement((0, $8e02099e6cbe06cd$export$4fc4d4ceee184da7), {
                customToolPanel: customToolPanel
            })
        ];
    };
    const [toolPanelName, toolPanelHeader, toolPanelContent, moduleInfo] = getToolPanelConfiguration();
    const isMinimised = visibilityMode === 'collapsed';
    const isConfigurable = // only module toolPanels are configurable
    !!moduleInfo && toolPanelName !== 'OpenFin' && toolPanelName !== 'IPushPull';
    const isToolPanelModuleConfigurable = api.internalApi.getModuleService().getModuleById((0, $42e863194fcb493f$export$6444167a07daa102)).isModuleEditable();
    return $acw62.createElement($acw62.Fragment, null, toolPanelContent && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: `twa:mt-1 ab-ToolPanel__container ab-ToolPanel__container--${toolPanelName}`
    }, $acw62.createElement((0, $2c31a9c151d05148$export$1929a08de907df5a), {
        className: `ab-ToolPanel__${toolPanelName}`,
        "data-name": `ab-ToolPanel__${toolPanelName}`,
        headerText: toolPanelHeader,
        disabled: !isToolPanelModuleConfigurable,
        onMinimiseChanged: ()=>{
            onVisibilityModeChange(isMinimised ? 'expanded' : 'collapsed');
        },
        isMinimised: isMinimised,
        onConfigure: isConfigurable ? ()=>{
            const maxWidth = api.internalApi.getModuleService().getPopupMaxWidth(moduleInfo.ModuleName);
            const popupParams = maxWidth ? {
                maxWidth: maxWidth,
                source: 'Toolbar'
            } : {
                source: 'Toolbar'
            };
            api.internalApi.dispatchReduxAction($dc56b6267ce4d0bb$export$e2d5bba0b444685d(moduleInfo.ModuleName, moduleInfo.Popup, popupParams));
        } : null,
        onClose: ()=>api.internalApi.dispatchReduxAction($297dbcf3bf27faf2$export$e7e637fbca1a6(toolPanelName))
    }, isMinimised ? null : toolPanelContent)));
};







const $e2d15fd9f3e503e3$var$preventDefault = (e)=>e.preventDefault();
const $e2d15fd9f3e503e3$var$AdaptableToolPanelComponent = (props)=>{
    const toolPanelsGlyph = $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: 'align-justify'
    });
    const moduleService = props.api.internalApi.getModuleService();
    const adaptableOptions = props.api.optionsApi.getAdaptableOptions();
    const toolPanelOptions = adaptableOptions.toolPanelOptions;
    const settingsPanelOptions = adaptableOptions.settingsPanelOptions;
    if (props.api.entitlementApi.isModuleHiddenEntitlement('ToolPanel')) // do NOT show any toolPanel content if the required entitlements are missing
    return $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:my-2 twa:p-2 twa:text-3"
    }, "Not enough rights");
    const availableModuleItems = props.MainMenuItems.filter((menuItem)=>menuItem.isVisible);
    const availableModules = availableModuleItems.map((menuItem)=>menuItem.category);
    // 'Dashboard' is a special case because it's not available in the dashboard menu items, s we have to add it manually
    if (!props.api.entitlementApi.isModuleHiddenEntitlement('Dashboard')) availableModules.push('Dashboard');
    if (props.api.pluginsApi.getipushpullPluginApi() && !props.api.entitlementApi.isModuleHiddenEntitlement('IPushPull')) availableModules.push('IPushPull');
    if (props.api.pluginsApi.getOpenFinPluginApi() && !props.api.entitlementApi.isModuleHiddenEntitlement('OpenFin')) availableModules.push('OpenFin');
    const availableModuleToolPanels = (0, $c75adffdf90b3d81$export$d064dfbe60243148).filter((moduleToolPanel)=>(0, $9g4SS.default).ContainsItem(availableModules, moduleToolPanel));
    const onStateChange = (toolPanel, visibilityMode)=>{
        if (visibilityMode === 'expanded') props.onExpandToolPanel(toolPanel);
        else props.onCollapseToolPanel(toolPanel);
    };
    const isToolPanelModuleConfigurable = props.api.internalApi.getModuleService().getModuleById((0, $42e863194fcb493f$export$6444167a07daa102)).isModuleEditable();
    const visibleToolPanels = [];
    const visibleToolPanelControls = (props.ToolPanels ?? []).map((toolPanelDefinition)=>{
        const visibilityMode = toolPanelDefinition.VisibilityMode ?? 'collapsed';
        // 1. check if it is a custom toolPanel
        const customToolPanel = props.api.toolPanelApi.getCustomToolPanelByName(toolPanelDefinition.Name);
        if (customToolPanel) {
            visibleToolPanels.push(customToolPanel.name);
            return $acw62.createElement((0, $94051a6714e4ce21$export$73331999a6320a2a), {
                key: customToolPanel.name,
                customToolPanel: customToolPanel,
                visibilityMode: visibilityMode,
                onVisibilityModeChange: (state)=>onStateChange(customToolPanel.name, state)
            });
        }
        // 2. check if it's an available module toolPanel
        if (availableModuleToolPanels.some((module)=>module === toolPanelDefinition.Name)) {
            // assertion is safe as if just checked it in the if clause
            const moduleToolPanel = toolPanelDefinition.Name;
            visibleToolPanels.push(moduleToolPanel);
            return $acw62.createElement((0, $94051a6714e4ce21$export$73331999a6320a2a), {
                key: moduleToolPanel,
                adaptableToolPanel: moduleToolPanel,
                visibilityMode: visibilityMode,
                onVisibilityModeChange: (state)=>onStateChange(moduleToolPanel, state)
            });
        }
    });
    const renderToolPanelDropdowns = ()=>{
        if (!toolPanelOptions.showToolPanelsDropdown) return;
        let toolpanelItems = [
            {
                clickable: false,
                label: $acw62.createElement("div", {
                    key: "toolPanelTitle"
                }, ' ', "\u00A0\u00A0", $acw62.createElement("b", null, 'Tool Panels'), renderToolPanelConfigureButton((0, $69de3722b23fa6b3$export$e3fe7c16944ed97).ToolPanels))
            }
        ];
        const isItemVisible = (panelItem)=>visibleToolPanels.includes(panelItem);
        const buildDropdownButtonItem = (toolPanel, label, isVisible)=>{
            return {
                id: toolPanel,
                onClick: ()=>{
                    onSetToolPanelVisibility(toolPanel, !isVisible);
                },
                label: $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                    className: "ab-dd-checkbox twa:my-0",
                    variant: "agGrid",
                    as: "div",
                    value: toolPanel,
                    key: toolPanel,
                    checked: isVisible,
                    onMouseDown: $e2d15fd9f3e503e3$var$preventDefault
                }, toolPanel)
            };
        };
        // 1. process custom tool panels
        props.api.toolPanelApi.getCustomToolPanels().forEach((customToolPanel)=>{
            const customToolPanelName = customToolPanel.name;
            toolpanelItems.push(buildDropdownButtonItem(customToolPanelName, customToolPanelName, isItemVisible(customToolPanelName)));
        });
        // 2. process module tool panels
        availableModuleToolPanels.forEach((toolPanel)=>{
            let moduleName = moduleService.getModuleInfoByModule(toolPanel).FriendlyName;
            toolpanelItems.push(buildDropdownButtonItem(toolPanel, moduleName, isItemVisible(toolPanel)));
        });
        // 3. sort the dropdown items alphabetically
        toolpanelItems.sort((first, second)=>{
            if (first.label < second.label) return -1;
            if (first.label > second.label) return 1;
            return 0;
        });
        return $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
            variant: "text",
            tone: "none",
            collapseOnItemClick: false,
            key: 'dropdown-toolpanels',
            id: 'dropdown-toolpanels',
            className: "ab-ToolPanel__toolbars",
            columns: [
                'label'
            ],
            items: toolpanelItems,
            tooltip: "Manage Tool Panels"
        }, toolPanelsGlyph);
    };
    const renderToolPanelButtons = ()=>{
        const toolPanelButtons = [];
        let moduleButtons = props.ModuleButtons;
        const shouldAddSettingsPanel = settingsPanelOptions.alwaysShowInToolPanel && !props.api.entitlementApi.isModuleHiddenEntitlement('SettingsPanel');
        if (shouldAddSettingsPanel && !moduleButtons.includes('SettingsPanel')) moduleButtons = [
            'SettingsPanel',
            ...moduleButtons
        ];
        if (moduleButtons?.length) toolPanelButtons.push(moduleButtons.map((x)=>{
            let menuItem = props.MainMenuItems.find((y)=>y.isVisible && y.category == x);
            if (menuItem) return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
                "data-name": menuItem.category,
                key: menuItem.label,
                icon: menuItem.icon,
                tone: "none",
                variant: "text",
                className: `ab-ToolPanel__Home__${(0, $9ce0650a2a8dba81$export$2e2bcd8739ae039)(menuItem.label)}`,
                tooltip: menuItem.label,
                onClick: ()=>props.onClick(menuItem.reduxAction),
                accessLevel: 'Full'
            });
        }));
        return toolPanelButtons;
    };
    const renderCustomToolPanelButtons = ()=>{
        return props.api.toolPanelApi.getCustomToolPanelButtons().map((button)=>{
            // TODO: variants of this mapping are present in several places (just search for api.internalApi.getStyleForButton() usages)
            // with the next opportunity we should abstract it
            const toolPanelContext = {
                ...props.api.internalApi.buildBaseContext(),
                toolPanelState: props.api.toolPanelApi.getToolPanelState()
            };
            const buttonIcon = props.api.internalApi.getIconForButton(button, toolPanelContext);
            let buttonStyle = props.api.internalApi.getStyleForButton(button, toolPanelContext);
            let buttonLabel = props.api.internalApi.getLabelForButton(button, toolPanelContext);
            let buttonTooltip = props.api.internalApi.getTooltipForButton(button, toolPanelContext);
            if (button.hidden && button.hidden(button, toolPanelContext)) return null;
            const disabled = button.disabled && button.disabled(button, toolPanelContext);
            const buttonVariant = buttonStyle && buttonStyle.variant ? buttonStyle.variant : 'text';
            const buttonTone = buttonStyle && buttonStyle.tone ? buttonStyle.tone : 'none';
            const uniqueKey = buttonLabel ?? (0, $e48e47ebfd8103c5$export$10a020066a0f444a)();
            return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
                key: uniqueKey,
                variant: buttonVariant,
                tone: buttonTone,
                className: `ab-ToolPanel__Home__${(0, $9ce0650a2a8dba81$export$2e2bcd8739ae039)(buttonLabel)} ${buttonStyle?.className || ''}`,
                tooltip: buttonTooltip,
                icon: buttonIcon,
                disabled: disabled,
                onClick: ()=>button.onClick(button, toolPanelContext),
                accessLevel: 'Full'
            }, buttonLabel);
        });
    };
    const onSetToolPanelVisibility = (name, checked)=>{
        if (checked) props.onShowToolPanel(name);
        else props.onHideToolPanel(name);
    };
    const renderToolPanelConfigureButton = (initialTab)=>{
        const moduleParams = initialTab ? {
            source: 'Other',
            config: {
                initialTab: initialTab
            }
        } : undefined;
        return $acw62.createElement((0, $a351badd06d496fe$export$dc1762fe2fbc8a24), {
            iconSize: 16,
            tone: "none",
            className: "ab-ToolPanel__configure-button twa:ml-2",
            tooltip: 'Configure ToolPanels',
            onClick: ()=>{
                props.api.internalApi.showSettingsPanel('ToolPanel', moduleParams);
            }
        });
    };
    const toolPanelButtons = renderToolPanelButtons();
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011 // Cannot have the with of the parent, on windows, when you have scrollbars
    ), {
        // the inner-width is smaller
        // minWidth: 'var(--ab-cmp-toolpanel__width)',
        className: "ab-ToolPanel twa:p-2 twa:w-full",
        "data-name": "adaptable-tool-panel",
        flexDirection: "column",
        justifyContent: "center"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-ToolPanel__header twa:p-1 twa:w-full twa:justify-start",
        flexDirection: "row",
        flexWrap: "wrap"
    }, isToolPanelModuleConfigurable && renderToolPanelDropdowns(), toolPanelButtons, isToolPanelModuleConfigurable && renderToolPanelConfigureButton()), Boolean(props.api.toolPanelApi.getCustomToolPanelButtons().length) && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-ToolPanel__header__buttons twa:p-1 twa:justify-start",
        flexDirection: "row",
        flexWrap: "wrap"
    }, renderCustomToolPanelButtons()), visibleToolPanelControls);
};
function $e2d15fd9f3e503e3$var$mapStateToProps(state) {
    return {
        ToolPanels: state.ToolPanel.ToolPanels,
        ModuleButtons: state.ToolPanel.ModuleButtons,
        MainMenuItems: state.Internal.SettingsPanelModuleEntries,
        Columns: state.Internal.Columns
    };
}
function $e2d15fd9f3e503e3$var$mapDispatchToProps(dispatch) {
    return {
        onClick: (action)=>dispatch(action),
        onSetToolPanelVisibility: (toolPanels)=>dispatch($297dbcf3bf27faf2$export$c8a6b1c32a7e4f85(toolPanels)),
        onShowToolPanel: (toolPanel)=>dispatch($297dbcf3bf27faf2$export$ae671580d1b5b91e(toolPanel)),
        onHideToolPanel: (toolPanel)=>dispatch($297dbcf3bf27faf2$export$e7e637fbca1a6(toolPanel)),
        onExpandToolPanel: (toolPanel)=>dispatch($297dbcf3bf27faf2$export$ee3eefa58024e7e9(toolPanel)),
        onCollapseToolPanel: (toolPanel)=>dispatch($297dbcf3bf27faf2$export$a5e2bec81f9383b9(toolPanel))
    };
}
const $e2d15fd9f3e503e3$export$62abe8bcdaa52e7d = (0, $55388fc2f116d4d7$export$64605811ab45167f)($e2d15fd9f3e503e3$var$mapStateToProps, $e2d15fd9f3e503e3$var$mapDispatchToProps)($e2d15fd9f3e503e3$var$AdaptableToolPanelComponent);
const $e2d15fd9f3e503e3$var$toolPanelContainerStyle = {
    width: '100%',
    overflow: 'auto'
};
const $e2d15fd9f3e503e3$export$c30f761c1e681c54 = (adaptable)=>{
    function getContainerId() {
        return 'adaptable-tool-panel_' + adaptable.adaptableOptions.adaptableId;
    }
    if (adaptable.variant === 'react') return ()=>{
        const content = (0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)($acw62.createElement($e2d15fd9f3e503e3$export$62abe8bcdaa52e7d, {
            api: adaptable.api,
            teamSharingActivated: false
        }), adaptable);
        return $acw62.createElement("div", {
            id: getContainerId(),
            className: 'ag-adaptable-panel',
            style: $e2d15fd9f3e503e3$var$toolPanelContainerStyle
        }, content);
    };
    return class AdaptableToolPanelAgGridComponent {
        gui;
        unmountReactRoot;
        init(params) {
            const api = adaptable.api;
            this.gui = document.createElement('div');
            this.gui.id = getContainerId();
            // preserve AG Grid naming convention
            this.gui.className = 'ag-adaptable-panel';
            Object.keys($e2d15fd9f3e503e3$var$toolPanelContainerStyle).forEach((key)=>{
                //@ts-ignore
                this.gui.style[key] = $e2d15fd9f3e503e3$var$toolPanelContainerStyle[key];
            });
            this.unmountReactRoot = adaptable.renderReactRoot((0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)($acw62.createElement($e2d15fd9f3e503e3$export$62abe8bcdaa52e7d, {
                api: api,
                teamSharingActivated: false
            }), adaptable), this.gui);
        }
        getGui() {
            if (!this.gui) this.init();
            return this.gui;
        }
        refresh() {
        // no refresh logic needed
        }
        destroy() {
            this.unmountReactRoot?.();
        }
    };
};


/**
 * Name of the component specified in AG Grid gridOptions.statusBar.statusPanels
 */ const $a6b60b03609a3dc0$export$eecaa732b65c0e22 = 'AdaptableStatusPanel';



var $acw62 = parcelRequire("acw62");






const $62fb192f03eeeaca$export$d289a9a7651cffc0 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const rerender = (0, $5445b32c0b713891$export$14b855fd280765df)();
    (0, $acw62.useEffect)(()=>{
        return adaptable.api.eventApi.on('AdaptableStateChanged', rerender);
    }, [
        adaptable
    ]);
    const statusPanels = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((0, $264a0e58163aefb1$export$f3a658bc32c51d73));
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const statusSubPanels = statusPanels.find((statusPanel)=>statusPanel.Key === props.context.Key);
    const allMenuItems = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state?.Internal?.SettingsPanelModuleEntries);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-StatusBar-Panel",
        "data-id": props.context.Key
    }, statusSubPanels?.StatusBarPanels?.map((subPanel)=>{
        const module = adaptable.ModuleService.getModuleById(subPanel);
        if (!module?.isModuleVisible()) return $acw62.createElement($acw62.Fragment, {
            key: subPanel
        });
        /**
         * Both view properties and status panel are optional.
         */ const statusBarPanelProps = module.getViewProperties?.()?.getStatusBarPanelProps?.() ?? {};
        const moduleInfo = module.moduleInfo;
        const onAction = statusBarPanelProps.onAction ?? (()=>{
            // #by-default-open-settings-panel-for-module
            const menuItem = allMenuItems.find((menuItem)=>menuItem.category === subPanel);
            if (menuItem?.reduxAction) dispatch(menuItem.reduxAction);
        });
        return $acw62.createElement((0, $c3c8f1b03eab6873$export$6e0a8a81c9521e24), {
            "data-name": subPanel,
            ...statusBarPanelProps,
            tooltip: moduleInfo.FriendlyName,
            onAction: onAction,
            icon: statusBarPanelProps.icon ?? moduleInfo.Glyph,
            key: subPanel
        });
    }));
};



var $9g4SS = parcelRequire("9g4SS");



var $9g4SS = parcelRequire("9g4SS");

class $391c88543ccf5f98$export$81e00ecf8a6c1766 {
    _adaptableInstance;
    constructor(_adaptableInstance){
        this._adaptableInstance = _adaptableInstance;
    }
    get adaptableOptions() {
        return this._adaptableInstance.adaptableOptions;
    }
    get adaptableApi() {
        return this._adaptableInstance.api;
    }
    destroy() {
        this._adaptableInstance = null;
    }
    buildColumnMenu(params, originalGetMainMenuItems) {
        const agGridMenuItems = params.defaultItems ? [
            ...params.defaultItems
        ] : [];
        if (!params.column) // return only AG Grid context if the Adaptable column is not found (should not happen)
        return agGridMenuItems;
        // If Adaptable UI is hidden, return only AG Grid default items
        if (!this.adaptableApi.userInterfaceApi.isAdaptableUIVisible()) return agGridMenuItems;
        const columnMenuOptions = this.adaptableOptions.columnMenuOptions;
        const adaptableColumn = this.adaptableApi.columnApi.getColumnWithColumnId(params.column?.getColId());
        const menuContext = this.createColumnMenuContextObject(adaptableColumn, params.column);
        /**
         * AG Grid items
         */ const agGridDefaultStructure = agGridMenuItems.map((itemName)=>this.mapAgGridItemTypeToAgGridMenuItem(itemName));
        const adaptableMenuItems = this.createAdaptableColumnMenuItems(menuContext);
        const defaultColumnMenuStructure = this.buildColumnMenuDefaultStructure(adaptableMenuItems, menuContext);
        // 1. first check if there is a custom column menu defined
        if (typeof columnMenuOptions.customColumnMenu === 'function') {
            const defaultAgGridMenuItems = agGridMenuItems.map((itemName)=>this.mapAgGridItemTypeToAgGridMenuItem(itemName));
            const defaultAdaptableMenuItems = adaptableMenuItems.map((adaptableItem)=>({
                    menuType: 'Adaptable',
                    ...adaptableItem
                }));
            const customMenuItems = columnMenuOptions.customColumnMenu({
                ...menuContext,
                defaultAgGridMenuItems: defaultAgGridMenuItems,
                defaultAdaptableMenuItems: defaultAdaptableMenuItems,
                defaultAdaptableMenuStructure: this.mapAdaptableMenuItemToSystemMenuItems(defaultColumnMenuStructure),
                defaultAgGridMenuStructure: agGridDefaultStructure
            }).filter(Boolean);
            return customMenuItems.map((customMenuItem)=>this.mapCustomMenuItemToAgGridMenuDefinition(customMenuItem, menuContext)).filter(Boolean);
        }
        // 2. if not, return the default context menu
        const defaultContextMenu = [
            ...agGridMenuItems,
            'separator',
            ...defaultColumnMenuStructure.map((adaptableItem)=>this.mapAdaptableMenuItemToAgGridMenuDefinition(adaptableItem))
        ];
        return this.removeConsecutiveSeparators(defaultContextMenu);
    }
    buildContextMenu(params, originalGetContextMenuItems) {
        if (!params.column) return [];
        // If Adaptable UI is hidden, return only AG Grid default items
        if (!this.adaptableApi.userInterfaceApi.isAdaptableUIVisible()) return params.defaultItems ? [
            ...params.defaultItems
        ] : [];
        // we do this in order to refresh the internal state of selected cells (technically query the AG Grid cellRanges)
        // (right-click selected the current cell, but this was not reflected in the internal state of the selected cells)
        this._adaptableInstance.refreshSelectedCellsState();
        const contextMenuOptions = this.adaptableOptions.contextMenuOptions;
        const adaptableColumn = this.adaptableApi.columnApi.getColumnWithColumnId(params.column?.getColId());
        const menuContext = this.createContextMenuContextObject(params, adaptableColumn);
        /**
         * AG Grid Items
         */ const agGridMenuItems = params.defaultItems ? [
            ...params.defaultItems
        ] : [];
        const agGridCopyItems = agGridMenuItems.filter((item)=>[
                'copy',
                'copyWithHeaders',
                'copyWithGroupHeaders',
                'cut',
                'paste'
            ].includes(item));
        const otherAgGridItems = agGridMenuItems.filter((item)=>!agGridCopyItems.includes(item) && // we provide Adaptable exports in the context menu
            ![
                'export',
                'csvExport',
                'excelExport'
            ].includes(item));
        const agGridDefaultStructure = [
            {
                menuType: 'Group',
                label: 'Copy & Paste',
                icon: {
                    name: 'copy'
                },
                subMenuItems: agGridCopyItems.map((item)=>this.mapAgGridItemTypeToAgGridMenuItem(item))
            },
            ...otherAgGridItems.filter((itemName)=>itemName !== 'separator').map((itemName)=>this.mapAgGridItemTypeToAgGridMenuItem(itemName))
        ];
        /**
         * Adaptable Items
         */ const adaptableMenuItems = this.createAdaptableContextMenuItems(menuContext);
        const adaptableDefaultStructure = this.buildContextMenuDefaultStructure(adaptableMenuItems, menuContext);
        /**
         * Build the context menu
         */ // 1. first check if there is a custom context menu defined
        if (typeof contextMenuOptions.customContextMenu === 'function') {
            const defaultAgGridMenuItems = agGridMenuItems.map((itemName)=>this.mapAgGridItemTypeToAgGridMenuItem(itemName));
            const defaultAdaptableMenuItems = adaptableMenuItems.map((adaptableItem)=>({
                    menuType: 'Adaptable',
                    ...adaptableItem
                }));
            const defaultAdaptableMenuStructure = this.mapAdaptableMenuItemToSystemMenuItems(adaptableDefaultStructure);
            const defaultAgGridMenuStructure = agGridDefaultStructure;
            const customMenuItems = contextMenuOptions.customContextMenu({
                ...menuContext,
                defaultAgGridMenuItems: defaultAgGridMenuItems,
                defaultAdaptableMenuItems: defaultAdaptableMenuItems,
                defaultAdaptableMenuStructure: defaultAdaptableMenuStructure,
                defaultAgGridMenuStructure: defaultAgGridMenuStructure
            }).filter(Boolean);
            return customMenuItems.map((customMenuItem)=>this.mapCustomMenuItemToAgGridMenuDefinition(customMenuItem, menuContext)).filter(Boolean);
        }
        // 2. if not, return the default context menu
        const defaultContextMenu = [
            ...agGridDefaultStructure.map((agGridItem)=>this.mapCustomMenuItemToAgGridMenuDefinition(agGridItem, menuContext)),
            'separator',
            ...adaptableDefaultStructure.map((adaptableItem)=>this.mapAdaptableMenuItemToAgGridMenuDefinition(adaptableItem))
        ];
        return this.removeConsecutiveSeparators(defaultContextMenu);
    }
    mapAgGridItemTypeToAgGridMenuItem(itemName) {
        return {
            menuType: 'AgGrid',
            name: itemName
        };
    }
    // due to entitlements or other reasons, some menu items might be hidden, leading to consecutive separators
    removeConsecutiveSeparators(menuItems, separator = 'separator') {
        return menuItems.reduce((acc, item, index, array)=>{
            if (item === separator && array[index + 1] === separator) return acc;
            acc.push(item);
            return acc;
        }, []);
    }
    createColumnMenuContextObject(adaptableColumn, agGridColumn) {
        return {
            ...this.adaptableApi.internalApi.buildBaseContext(),
            adaptableColumn: adaptableColumn,
            agGridColumn: agGridColumn,
            isRowGroupColumn: this.adaptableApi.columnApi.isAutoRowGroupColumn(agGridColumn.getColId())
        };
    }
    createAdaptableContextMenuItems(menuContext) {
        let contextMenuItems = [];
        this.adaptableApi.internalApi.getModules().forEach((module)=>{
            let menuItems = module.createContextMenuItems(menuContext);
            if (menuItems) contextMenuItems.push(...menuItems.filter(Boolean).filter((item)=>item.isVisible !== false));
        });
        this._adaptableInstance._emitSync('CreateAdaptableContextMenuItems', {
            items: contextMenuItems,
            menuContext: menuContext
        });
        return contextMenuItems;
    }
    createContextMenuContextObject(params, adaptableColumn) {
        // lets build a picture of what has been right clicked.  Will take time to get right but lets start
        let isSingleSelectedColumn = false;
        let isSelectedCell = false;
        let isSelectedRow = false;
        // row group columns dont provide an AdapTable Column so return bare minimum
        if (!adaptableColumn) return {
            ...this.adaptableApi.internalApi.buildBaseContext(),
            isSelectedCell: false,
            isSelectedRow: false,
            gridCell: undefined,
            adaptableColumn: undefined,
            agGridColumn: params.column,
            rowNode: params.node,
            isGroupedNode: params.node ? params.node.group : false,
            isSingleSelectedColumn: false,
            isSingleSelectedCell: false,
            primaryKeyValue: undefined,
            selectedCellInfo: undefined,
            selectedRowInfo: undefined,
            isRowGroupColumn: this.adaptableApi.columnApi.isAutoRowGroupColumn(params.column.getColId())
        };
        const clickedCell = this.adaptableApi.gridApi.getGridCellFromRowNode(params.node, adaptableColumn.columnId);
        const selectedCellInfo = this.adaptableApi.gridApi.getSelectedCellInfo();
        if (selectedCellInfo) {
            let matchedCell = selectedCellInfo.gridCells.find((gc)=>gc != null && gc.column == clickedCell.column && gc.primaryKeyValue == clickedCell.primaryKeyValue);
            isSelectedCell = matchedCell != null;
            if (isSelectedCell) isSingleSelectedColumn = (0, $9g4SS.default).CorrectLength(selectedCellInfo.columns, 1);
        }
        const selectedRowInfo = this.adaptableApi.gridApi.getSelectedRowInfo();
        if (selectedRowInfo) {
            const matchedPKValue = selectedRowInfo.gridRows.find((gr)=>gr != null && gr.primaryKeyValue == clickedCell.primaryKeyValue);
            isSelectedRow = matchedPKValue != null;
        }
        return {
            ...this.adaptableApi.internalApi.buildBaseContext(),
            isSelectedCell: isSelectedCell,
            isSelectedRow: isSelectedRow,
            gridCell: clickedCell,
            adaptableColumn: adaptableColumn,
            agGridColumn: params.column,
            rowNode: params.node,
            isGroupedNode: params.node ? params.node.group : false,
            isSingleSelectedColumn: isSingleSelectedColumn,
            isSingleSelectedCell: isSelectedCell && selectedCellInfo?.gridCells.length == 1,
            primaryKeyValue: clickedCell ? clickedCell.primaryKeyValue : undefined,
            selectedCellInfo: selectedCellInfo,
            selectedRowInfo: selectedRowInfo,
            isRowGroupColumn: this.adaptableApi.columnApi.isAutoRowGroupColumn(params.column.getColId())
        };
    }
    mapAdaptableMenuItemToAgGridMenuDefinition(adaptableMenuItem) {
        if (adaptableMenuItem === (0, $58846ea7f4156db7$export$86c4217d77f432b7)) return 'separator';
        const fullMenuItem = adaptableMenuItem;
        return {
            name: fullMenuItem.label,
            action: fullMenuItem.onClick ? fullMenuItem.onClick : fullMenuItem.reduxAction ? ()=>this.adaptableApi.internalApi.dispatchReduxAction(fullMenuItem.reduxAction) : undefined,
            icon: this.mapAdaptableIconToAgGridIcon(fullMenuItem.icon, {
                fill: 'var(--ab-color-text-on-primary)'
            }),
            subMenu: fullMenuItem.subItems?.map((subMenuItem)=>this.mapAdaptableMenuItemToAgGridMenuDefinition(subMenuItem))
        };
    }
    mapCustomMenuItemToAgGridMenuDefinition(customMenuItem, menuContext) {
        if (customMenuItem === '-') return 'separator';
        if (customMenuItem.menuType === 'Group') return {
            name: customMenuItem.label,
            icon: this.mapAdaptableIconToAgGridIcon(customMenuItem.icon, {
                fill: 'var(--ab-color-text-on-primary)'
            }),
            disabled: customMenuItem.disabled,
            subMenu: !customMenuItem.disabled ? customMenuItem.subMenuItems?.map((subMenuItem)=>this.mapCustomMenuItemToAgGridMenuDefinition(subMenuItem, menuContext)).filter(Boolean) : undefined
        };
        if (customMenuItem.menuType === 'AgGrid') return customMenuItem.name;
        if (customMenuItem.menuType === 'Adaptable') return this.mapAdaptableMenuItemToAgGridMenuDefinition(customMenuItem);
        if (customMenuItem.menuType === 'User') return this.mapUserMenuItemToAgGridMenuDefinition(customMenuItem, menuContext);
    }
    mapUserMenuItemToAgGridMenuDefinition(userMenuItem, menuContext) {
        if (userMenuItem.hidden) return;
        return {
            name: userMenuItem.label,
            action: ()=>userMenuItem.onClick ? userMenuItem.onClick(menuContext) : null,
            icon: this.mapAdaptableIconToAgGridIcon(userMenuItem.icon, {
                fill: 'var(--ab-color-text-on-primary)'
            }),
            disabled: userMenuItem.disabled,
            subMenu: userMenuItem.subMenuItems?.map((subMenuItem)=>{
                return this.mapCustomMenuItemToAgGridMenuDefinition(subMenuItem, menuContext);
            }).filter(Boolean)
        };
    }
    buildContextMenuDefaultStructure(availableMenuItems, menuContext) {
        // Alert
        const alertMenuItems = this.getModuleSpecificStructure('Alert', availableMenuItems);
        // BulkUpdate
        const bulkUpdateMenuItems = this.getModuleSpecificStructure('BulkUpdate', availableMenuItems);
        // CalculatedColumn
        const calculatedColumnMenuItems = this.getModuleSpecificStructure('CalculatedColumn', availableMenuItems);
        // CellSummary
        const cellSummaryMenuItems = this.getModuleSpecificStructure('CellSummary', availableMenuItems);
        // ColumnFilter
        const columnFilterMenuItems = this.getModuleSpecificStructure('ColumnFilter', availableMenuItems);
        // ColumnInfo
        const columnInfoMenuItems = this.getModuleSpecificStructure('ColumnInfo', availableMenuItems);
        // Comment
        const commentMenuItems = this.getModuleSpecificStructure('Comment', availableMenuItems);
        // Dashboard
        const dashboardMenuItems = this.getModuleSpecificStructure('Dashboard', availableMenuItems, 'dashboard-group');
        // DataImport
        const dataImportMenuItems = this.getModuleSpecificStructure('DataImport', availableMenuItems);
        // Export
        const exportMenuItems = this.getModuleSpecificStructure('Export', availableMenuItems);
        // FDC3
        const fdc3MenuItems = this.getModuleSpecificStructure('Fdc3', availableMenuItems);
        // FlashingCell
        const flashingCellMenuItems = this.getModuleSpecificStructure('FlashingCell', availableMenuItems);
        // GridInfo
        const gridInfoMenuItems = this.getModuleSpecificStructure('GridInfo', availableMenuItems);
        // Layout
        const [gridActionItems, otherLayoutItems] = this.getLayoutContextMenuStructure(availableMenuItems);
        // Note
        const noteMenuItems = this.getModuleSpecificStructure('Note', availableMenuItems);
        // SettingsPanel
        const settingsPanelMenuItems = this.getModuleSpecificStructure('SettingsPanel', availableMenuItems);
        // SmartEdit
        const smartEditMenuItems = this.getModuleSpecificStructure('SmartEdit', availableMenuItems);
        // SystemStatus
        const systemStatusMenuItems = this.getModuleSpecificStructure('SystemStatus', availableMenuItems);
        /**
         * Custom structures
         */ const gridMenuItem = {
            name: 'grid-group',
            label: 'Grid',
            category: 'Group',
            isVisible: true,
            icon: {
                name: 'grid'
            },
            subItems: [
                ...gridActionItems,
                ...otherLayoutItems,
                ...cellSummaryMenuItems,
                ...dataImportMenuItems,
                ...systemStatusMenuItems,
                ...gridInfoMenuItems
            ]
        };
        const editMenuItem = {
            name: 'edit-group',
            label: 'Edit',
            category: 'Group',
            isVisible: true,
            icon: {
                name: 'edit-table'
            },
            subItems: [
                ...bulkUpdateMenuItems,
                ...smartEditMenuItems
            ]
        };
        return this.removeConsecutiveSeparators([
            ...exportMenuItems,
            '-',
            ...calculatedColumnMenuItems,
            ...noteMenuItems,
            ...commentMenuItems,
            ...columnFilterMenuItems,
            ...flashingCellMenuItems,
            ...alertMenuItems,
            ...fdc3MenuItems,
            '-',
            ...settingsPanelMenuItems,
            ...dashboardMenuItems,
            '-',
            ...this.normalizeMenuGroup(editMenuItem),
            '-',
            ...this.normalizeMenuGroup(gridMenuItem),
            ...columnInfoMenuItems
        ], '-');
    }
    /**
     * Hide menu group with no subitems or elevate single subitem to parent level
     */ normalizeMenuGroup(menuItem) {
        if (!menuItem.subItems?.length) return [];
        if (menuItem.subItems?.length === 1) return [
            menuItem.subItems[0]
        ];
        return [
            menuItem
        ];
    }
    /**
     * Default strategy for menu items: return as is if there is only one item, otherwise group them under a parent item
     */ getModuleSpecificStructure(module, menuItems, groupName) {
        const moduleItems = menuItems.filter((menuItem)=>menuItem.category === module);
        if (moduleItems.length > 1) return [
            this.buildMenuGroupParent(module, moduleItems, {
                groupName: groupName
            })
        ];
        else return moduleItems;
    }
    getLayoutContextMenuStructure(menuItems) {
        const layoutMenuItems = menuItems.filter((menuItem)=>menuItem.category === 'Layout');
        if (!layoutMenuItems.length) return [
            [],
            []
        ];
        const gridActionsItemNames = [
            'layout-clear-selection',
            'layout-select-all',
            'layout-auto-size'
        ];
        const gridActionsItems = layoutMenuItems.filter((item)=>gridActionsItemNames.includes(item.name));
        const otherLayoutItems = layoutMenuItems.filter((item)=>!gridActionsItemNames.includes(item.name));
        return [
            gridActionsItems,
            otherLayoutItems
        ];
    }
    buildMenuGroupParent(module, menuItems, config) {
        const moduleInfo = this.adaptableApi.internalApi.getModuleService().getModuleInfoByModule(module);
        const icon = config && config.icon === false ? undefined : {
            name: config?.icon ?? moduleInfo.Glyph
        };
        return {
            name: config?.groupName ?? 'menu-group',
            label: config?.label ?? moduleInfo.FriendlyName,
            isVisible: true,
            category: moduleInfo.ModuleName,
            icon: icon,
            subItems: menuItems
        };
    }
    buildColumnMenuDefaultStructure(availableMenuItems, menuContext) {
        // CalculatedColumn
        const calculatedColumnMenuItems = this.getModuleSpecificStructure('CalculatedColumn', availableMenuItems);
        // CellSummary
        const cellSummaryMenuItems = this.getModuleSpecificStructure('CellSummary', availableMenuItems);
        // Chart
        const chartMenuItems = this.getModuleSpecificStructure('Charting', availableMenuItems);
        // ColumnFilter
        const [columnFilterGroup, filterVisibilityItems] = this.getColumnFilterColumnMenuStructure(availableMenuItems);
        // ColumnInfo
        const columnInfoMenuItems = this.getModuleSpecificStructure('ColumnInfo', availableMenuItems);
        // CustomSort
        const customSortMenuItems = this.getModuleSpecificStructure('CustomSort', availableMenuItems);
        // Dashboard
        const dashboardMenuItems = this.getModuleSpecificStructure('Dashboard', availableMenuItems, 'dashboard-group');
        // DataImport
        const dataImportMenuItems = this.getModuleSpecificStructure('DataImport', availableMenuItems);
        // FlashingCell
        const flashingCellMenuItems = this.getModuleSpecificStructure('FlashingCell', availableMenuItems);
        // FormatColumn
        const formatColumnMenuItems = this.getModuleSpecificStructure('FormatColumn', availableMenuItems);
        // FreeTextColumn
        const freeTextColumnMenuItems = this.getModuleSpecificStructure('FreeTextColumn', availableMenuItems);
        // GridInfo
        const gridInfoMenuItems = this.getModuleSpecificStructure('GridInfo', availableMenuItems);
        // Layout
        const [gridSelectItems, columnSelectItems, columnActionGroup, otherLayoutItems] = this.getLayoutColumnMenuStructure(availableMenuItems);
        // PlusMinus
        const plusMinusMenuItems = this.getModuleSpecificStructure('PlusMinus', availableMenuItems);
        // SettingsPanel
        const settingsPanelMenuItems = this.getModuleSpecificStructure('SettingsPanel', availableMenuItems);
        // StyledColumn
        const styledColumnMenuItems = this.getStyledColumnColumnMenuStructure(availableMenuItems);
        // SystemStatus
        const systemStatusMenuItems = this.getModuleSpecificStructure('SystemStatus', availableMenuItems);
        /**
         * Custom structures
         */ const gridMenuItem = {
            name: 'grid-group',
            label: 'Grid',
            category: 'Group',
            isVisible: true,
            icon: {
                name: 'grid'
            },
            subItems: [
                ...otherLayoutItems,
                ...filterVisibilityItems,
                ...gridSelectItems,
                ...cellSummaryMenuItems,
                ...chartMenuItems,
                ...dataImportMenuItems,
                ...systemStatusMenuItems,
                ...gridInfoMenuItems
            ]
        };
        /*
        const calculatedColumnMenuItem: AdaptableMenuItem = {
          name: 'calculated-column-group',
          label: 'Calculated Column',
          module: 'CalculatedColumn',
          isVisible: true,
          icon: {
            name: 'columns',
          },
          subItems: [
            ...calculatedColumnMenuItems,
          ],
        };
        */ const columnMenuItem = {
            name: 'column-group',
            label: 'Column',
            category: 'Group',
            isVisible: true,
            icon: {
                name: 'columns'
            },
            subItems: [
                ...columnActionGroup,
                ...freeTextColumnMenuItems,
                ...customSortMenuItems,
                ...plusMinusMenuItems,
                ...columnSelectItems,
                ...columnInfoMenuItems
            ]
        };
        const createStyleMenuItem = {
            name: 'styling-group',
            label: 'Styling',
            category: 'Group',
            isVisible: true,
            icon: {
                name: 'brush'
            },
            subItems: [
                ...formatColumnMenuItems,
                ...styledColumnMenuItems,
                ...flashingCellMenuItems
            ]
        };
        return this.removeConsecutiveSeparators([
            ...calculatedColumnMenuItems,
            ...settingsPanelMenuItems,
            ...dashboardMenuItems,
            ...columnFilterGroup,
            ...this.normalizeMenuGroup(createStyleMenuItem),
            ...this.normalizeMenuGroup(gridMenuItem),
            ...this.normalizeMenuGroup(columnMenuItem)
        ], '-');
    }
    getColumnFilterColumnMenuStructure(menuItems) {
        const columnFilterMenuItems = menuItems.filter((menuItem)=>menuItem.category === 'ColumnFilter');
        const filterVisibilityItems = columnFilterMenuItems.filter((item)=>[
                'column-filter-bar-hide',
                'column-filter-bar-show'
            ].includes(item.name));
        const filterActionItems = columnFilterMenuItems.filter((item)=>[
                'column-filter-clear',
                'column-filter-suspend',
                'column-filter-unsuspend'
            ].includes(item.name));
        const columnFilterGroup = filterActionItems.length ? [
            {
                name: 'column-filter-group',
                label: 'Filter',
                category: 'ColumnFilter',
                isVisible: true,
                icon: {
                    name: 'filter'
                },
                subItems: filterActionItems
            }
        ] : [];
        return [
            columnFilterGroup,
            filterVisibilityItems
        ];
    }
    getLayoutColumnMenuStructure(menuItems) {
        const layoutMenuItems = menuItems.filter((menuItem)=>menuItem.category === 'Layout');
        if (!layoutMenuItems.length) return [
            [],
            [],
            [],
            []
        ];
        const columnSelectItemNames = [
            'layout-column-select-preserve',
            'layout-column-select-reset',
            'layout-column-select'
        ];
        const columnSelectItems = layoutMenuItems.filter((item)=>columnSelectItemNames.includes(item.name));
        const gridSelectItems = layoutMenuItems.filter((item)=>item.name === 'layout-grid-select');
        const columnActionGroup = layoutMenuItems.filter((item)=>[
                'layout-column-caption-change',
                'layout-column-hide'
            ].includes(item.name));
        const otherLayoutItems = layoutMenuItems.filter((item)=>!columnSelectItemNames.includes(item.name) && ![
                'layout-column-caption-change',
                'layout-column-hide'
            ].includes(item.name) && item.name !== 'layout-grid-select');
        return [
            gridSelectItems,
            columnSelectItems,
            columnActionGroup,
            otherLayoutItems
        ];
    }
    getStyledColumnColumnMenuStructure(menuItems) {
        const styledColumnMenuItems = menuItems.filter((menuItem)=>menuItem.category === 'StyledColumn');
        return styledColumnMenuItems;
    }
    mapAdaptableMenuItemToSystemMenuItems(adaptableMenuItems) {
        if (!adaptableMenuItems) return;
        return adaptableMenuItems.map((menuItem)=>{
            if (menuItem === '-') return menuItem;
            // @ts-ignore
            const subItems = this.mapAdaptableMenuItemToSystemMenuItems(menuItem.subItems);
            return {
                ...menuItem,
                menuType: 'Adaptable',
                subItems: subItems
            };
        });
    }
    createAdaptableColumnMenuItems(menuContext) {
        let columnMenuItems = [];
        this.adaptableApi.internalApi.getModules().forEach((s)=>{
            let menuItems = s.createColumnMenuItems(menuContext.adaptableColumn);
            if (menuItems) columnMenuItems.push(...menuItems.filter(Boolean).filter((item)=>item.isVisible !== false));
        });
        return columnMenuItems;
    }
    // TODO AFL MIG: pretty sure this logic is duplicated in several other places
    mapAdaptableIconToAgGridIcon(adaptableIcon, style) {
        const icon = this.adaptableApi.userInterfaceApi.internalApi.prepareAdaptableIconDef(adaptableIcon);
        if ((0, $9200d8ae4e589d35$export$369455ce906a0ef2)(icon)) {
            let element = icon.element;
            if (typeof element === 'string') return element;
            // THe element neets to be cloned.
            // when it is used in more than one plce the element is removed from the DOM
            return element.cloneNode(true);
        } else return (0, $124c9aa27215a392$export$4ddaa9e47cfc2631)(icon, {
            fill: 'var(--ab-color-text-on-primary)'
        });
    }
    /**
     * The output of this function is used to build the column header menu if the AG Grid Menu Module is NOT present
     * This is controlled by the AdaptableAgGrid.embedColumnMenu property
     */ buildStandaloneColumnHeader(adaptableColumn) {
        const agGridColumn = this._adaptableInstance.getAgGridColumnForColumnId(adaptableColumn.columnId);
        const menuContext = this.createColumnMenuContextObject(adaptableColumn, agGridColumn);
        return this.createAdaptableColumnMenuItems(menuContext);
    }
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");






const $fed4c3a6395001ce$export$2b776f7e7ee60dbd = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { active: active, text: text, render: render, frameworkComponent: frameworkComponent, renderMode: renderMode } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Popup.ProgressIndicator);
    const [visible, setVisible] = (0, $acw62.useState)(false);
    const [progressIndicatorCoordinates, setProgressIndicatorCoordinates] = (0, $acw62.useState)({
        top: 0,
        left: 0,
        height: 0,
        width: 0
    });
    const disableAdaptableGrid = (containerElement, disabled)=>{
        const DISABLING_CSS_CLASS = 'ab-wait-for-progress-indicator';
        if (!containerElement) return;
        if (disabled) containerElement.classList.add(DISABLING_CSS_CLASS);
        else containerElement.classList.remove(DISABLING_CSS_CLASS);
    };
    const updateGridContainerCoordinates = (containerElement)=>{
        if (!containerElement) return;
        const { top: top, left: left, height: height, width: width } = containerElement.getBoundingClientRect();
        setProgressIndicatorCoordinates({
            top: top,
            left: left,
            height: height,
            width: width
        });
    };
    (0, $acw62.useEffect)(()=>{
        disableAdaptableGrid(adaptable.getAdaptableContainerElement(), active);
        disableAdaptableGrid(adaptable.getAgGridContainerElement(), active);
        updateGridContainerCoordinates(adaptable.getAgGridContainerElement());
        // #raf_progress_indicator
        // without rAF the progress indicator would be rendered instantly, without the 'transition-delay' defined via CSS
        requestAnimationFrame(()=>{
            setVisible(active);
        });
    }, [
        active
    ]);
    let customEl = null;
    if (render || frameworkComponent) customEl = $acw62.createElement((0, $1acaa6ff89593611$export$edafaa7cfa4a5013), {
        render: render,
        frameworkComponent: frameworkComponent
    });
    // Check if we should replace the default content
    const replaceContent = renderMode === 'dialog' && customEl;
    return $acw62.createElement($acw62.Fragment, null, active && $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
        modal: true,
        isOpen: true,
        showCloseButton: false,
        className: `ab-ProgressIndicator ${visible ? 'ab-ProgressIndicator--visible' : ''}`,
        modalProps: {
            style: progressIndicatorCoordinates
        }
    }, replaceContent ? // If renderMode is 'dialog', replace the entire content with custom element
    customEl : // Otherwise use the default Flex layout
    $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        flexDirection: "column",
        className: "ab-ProgressIndicator-body twa:p-3"
    }, $acw62.createElement((0, $ce6c64224079063e$export$57a80cbf859d803c), null), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, text && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, text), customEl))));
};





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




const $2b60159cb334c1a5$var$baseClassName = 'ab-Adaptable-Popup__TopBar';
const $2b60159cb334c1a5$export$c4e96258f3b6511 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const applicationIcon = adaptable.api.optionsApi.getUserInterfaceOptions()?.applicationIcon;
    let icon = $acw62.createElement($acw62.Fragment, null);
    const iconClassName = `${$2b60159cb334c1a5$var$baseClassName}__Icon`;
    if (props.icon === 'ConfigurationIcon') icon = $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
        iconClassName: iconClassName,
        icon: {
            name: 'settings'
        }
    });
    else if (props.icon === 'ApplicationIcon' && applicationIcon) icon = $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
        icon: applicationIcon,
        iconClassName: iconClassName
    });
    else if (typeof props.icon === 'object') icon = $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
        icon: props.icon,
        iconClassName: iconClassName
    });
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($2b60159cb334c1a5$var$baseClassName, 'twa:font-medium twa:p-3', 'twa:flex twa:flex-row twa:items-center twa:flex-0 twa:gap-2', 'twa:bg-(--ab-dashboard-header__background) twa:text-(--ab-dashboard-header__color)')
    }, icon, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: `${$2b60159cb334c1a5$var$baseClassName}__Title`
    }, props.children));
};
var $2b60159cb334c1a5$export$2e2bcd8739ae039 = $2b60159cb334c1a5$export$c4e96258f3b6511;




var $acw62 = parcelRequire("acw62");





const $b925c2ca401b3835$var$navigationItemClassName = 'ab-Adaptable-Popup__Navigation__List__Item';
const $b925c2ca401b3835$var$NavigationItem = ({ menuItem: menuItem, isActive: isActive, dataName: dataName, customIcon: customIcon, onAction: onAction, showModuleIcons: showModuleIcons })=>{
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (isActive) ref.current?.focus();
    }, [
        isActive
    ]);
    return $acw62.createElement("li", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($b925c2ca401b3835$var$navigationItemClassName, {
            [`${$b925c2ca401b3835$var$navigationItemClassName}--active`]: isActive
        })
    }, $acw62.createElement("button", {
        ref: ref,
        type: "button",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(`${$b925c2ca401b3835$var$navigationItemClassName}__Button ${(0, $c1f662de8a4d1882$export$39b0426676282ece).focusOutline}`, {
            'twa:flex twa:flex-row twa:items-center twa:gap-2': 'layout flex',
            [`twa:bg-transparent`]: !isActive,
            'twa:bg-accent twa:text-accentlight': isActive,
            'twa:px-2 twa:py-1.5': true,
            'twa:rounded-standard': true
        }),
        onMouseDown: ()=>onAction(),
        "data-name": dataName,
        tabIndex: isActive ? 0 : -1
    }, showModuleIcons && menuItem.icon && $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
        icon: menuItem.icon,
        iconClassName: `${$b925c2ca401b3835$var$navigationItemClassName}__Icon`
    }), customIcon ? $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
        icon: customIcon
    }) : null, menuItem.label));
};
const $b925c2ca401b3835$export$b8a61e5c71402559 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const makeActive = (menuItem)=>{
        dispatch(menuItem.reduxAction);
    };
    const getMenuItemForDirection = (direction)=>{
        const currentIndex = props.menuItems.findIndex((item)=>item !== '-' && (item.category === props.activeItem || item.label === props.activeItem));
        let foundMenuItem = null;
        if (direction === -1) {
            let candidate = props.menuItems[currentIndex - 1] !== '-' ? props.menuItems[currentIndex - 1] : props.menuItems[currentIndex - 2];
            foundMenuItem = candidate ? candidate : props.menuItems[props.menuItems.length - 1];
        } else {
            let candidate = props.menuItems[currentIndex + 1] !== '-' ? props.menuItems[currentIndex + 1] : props.menuItems[currentIndex + 2];
            foundMenuItem = candidate ? candidate : props.menuItems[0];
        }
        return foundMenuItem === '-' ? null : foundMenuItem;
    };
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const handleKeyPress = $acw62.useCallback((event)=>{
        const { code: code } = event;
        if (code === 'ArrowUp' || code === 'ArrowDown' || code === 'Home' || code === 'End') {
            event.preventDefault();
            event.stopPropagation();
            let nextMenuItem = null;
            if (code === 'Home') nextMenuItem = props.menuItems[0];
            else if (code === 'End') nextMenuItem = props.menuItems[props.menuItems.length - 1];
            else nextMenuItem = getMenuItemForDirection(event.code === 'ArrowUp' ? -1 : 1);
            if (nextMenuItem) makeActive(nextMenuItem);
        }
    }, [
        props.activeItem,
        props.menuItems
    ]);
    return $acw62.createElement("nav", {
        className: "ab-Adaptable-Popup__Navigation twa:overflow-auto",
        tabIndex: -1
    }, $acw62.createElement("ul", {
        className: "ab-Adaptable-Popup__Navigation__List twa:m-0 twa:list-none twa:py-3 twa:gap-1 twa:flex twa:flex-col",
        onKeyDown: handleKeyPress
    }, props.menuItems.map((menuItem, index)=>{
        if (menuItem === '-') return $acw62.createElement("li", {
            key: `separator-${index}`,
            className: `${$b925c2ca401b3835$var$navigationItemClassName}__Separator`
        });
        const isActive = props.activeItem === menuItem.category || menuItem.label === props.activeItem;
        let customIcon = props.customSettingsPanels?.find?.((customSettingPanel)=>customSettingPanel.name === menuItem.label)?.icon ?? null;
        const dataName = menuItem.category === 'CustomSettingsPanel' ? `CSP-${menuItem.label}` : menuItem.category ?? menuItem.label;
        return $acw62.createElement($b925c2ca401b3835$var$NavigationItem, {
            key: menuItem.label,
            menuItem: menuItem,
            isActive: isActive,
            dataName: dataName,
            customIcon: customIcon,
            showModuleIcons: api.optionsApi.getSettingsPanelOptions().showModuleIcons,
            onAction: ()=>makeActive(menuItem)
        });
    })));
};



var $acw62 = parcelRequire("acw62");
const $e1144fa2193cb217$var$PopupContext = $acw62.createContext({
    hidePopup: ()=>{}
});
const $e1144fa2193cb217$export$6b0a8531a102393f = ()=>{
    return $acw62.useContext($e1144fa2193cb217$var$PopupContext);
};
var $e1144fa2193cb217$export$2e2bcd8739ae039 = $e1144fa2193cb217$var$PopupContext;



var $acw62 = parcelRequire("acw62");

var $5aWMQ = parcelRequire("5aWMQ");


var $acw62 = parcelRequire("acw62");













const $bef12997692d3d1f$export$7f786fdd33c40095 = (props)=>{
    /**
     * This triggers a render for each state change.
     * NOT sure this is still needed... It is here for historical reasons.
     */ const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const rerender = (0, $5445b32c0b713891$export$14b855fd280765df)();
    (0, $acw62.useEffect)(()=>{
        return adaptable.api.eventApi.on('AdaptableStateChanged', rerender);
    }, [
        adaptable
    ]);
    const [abObjectType, setAbObjectType] = $acw62.useState(null);
    const moduleInfo = props.module.moduleInfo;
    const items = props.module?.toViewAll();
    const moduleViewProperties = props.module?.getViewProperties?.() ?? {};
    const EditWizard = moduleViewProperties?.getEditWizard?.();
    const [isWizardOpen, setIsWizardOpen] = $acw62.useState(()=>{
        return props.popupParams?.action === 'New' || props.popupParams?.action === 'Edit' || props.popupParams?.action === 'Clone';
    });
    const handleOpenEditPopup = $acw62.useCallback(()=>{
        if (EditWizard) setIsWizardOpen(true);
        if (moduleViewProperties.onOpenEditPopup) moduleViewProperties.onOpenEditPopup();
    }, []);
    $acw62.useEffect(()=>{
        moduleViewProperties?.onMount?.();
    }, []);
    $acw62.useEffect(()=>{
        if (props.popupParams?.action === 'New' || props.popupParams?.action === 'Edit' || props.popupParams?.action === 'Clone') handleOpenEditPopup();
    }, [
        props.popupParams?.action
    ]);
    const emptyView = moduleViewProperties.emptyView;
    let emptyContent = null;
    if (typeof emptyView === 'function') emptyContent = $acw62.createElement(emptyView, {
        module: props.module
    });
    else if (typeof emptyView === 'string') emptyContent = emptyView;
    const toolTipText = moduleViewProperties.newTooltipText ?? `Create ${moduleInfo.FriendlyName}`;
    // Some modules do not have new button
    // e.g. filter
    let newButton = null;
    if (moduleViewProperties?.abObjectTypes?.length) {
        const items = moduleViewProperties?.abObjectTypes.map((abObjectType)=>{
            return {
                disabled: abObjectType?.accessLevel === 'ReadOnly',
                onClick: ()=>{
                    setAbObjectType(abObjectType);
                    handleOpenEditPopup();
                },
                label: abObjectType.label ?? abObjectType.name
            };
        });
        newButton = $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
            tone: "accent",
            variant: "raised",
            columns: [
                'label'
            ],
            items: items,
            tooltip: toolTipText
        }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
            name: "plus"
        }), " New");
    } else if (!moduleViewProperties.hideNewButton && (EditWizard || moduleViewProperties.onOpenEditPopup)) newButton = $acw62.createElement((0, $638939172b36e064$export$eda4ac1f0f4bc860), {
        onClick: ()=>handleOpenEditPopup(),
        tooltip: toolTipText,
        accessLevel: props.accessLevel
    });
    let suspendButton = null;
    const editableObjects = items.filter((item)=>!item.abObject.IsReadOnly);
    if (editableObjects.length && moduleViewProperties?.getSuspendAllAction && moduleViewProperties?.getUnSuspendAllAction) {
        const isAtLeastOneAbObjectActive = editableObjects.some((item)=>{
            return !item.abObject?.IsSuspended;
        });
        const handleSuspendUnsuspendAll = ()=>{
            if (isAtLeastOneAbObjectActive) {
                const suspendAllAction = moduleViewProperties.getSuspendAllAction();
                dispatch(suspendAllAction);
            } else {
                const unsuspendAllAction = moduleViewProperties.getUnSuspendAllAction();
                dispatch(unsuspendAllAction);
            }
        };
        suspendButton = $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            className: "twa:mr-2",
            onMouseDown: ()=>handleSuspendUnsuspendAll(),
            tone: isAtLeastOneAbObjectActive ? 'neutral' : 'success',
            variant: "raised",
            icon: isAtLeastOneAbObjectActive ? 'pause' : 'resume',
            accessLevel: props.accessLevel
        }, isAtLeastOneAbObjectActive ? 'Suspend All' : 'Unsuspend All');
    }
    const handleWizardClose = ()=>{
        setAbObjectType(null);
        setIsWizardOpen(false);
        if ([
            'Toolbar',
            'ContextMenu',
            'ColumnMenu'
        ].includes(props?.popupParams?.source)) props.onClosePopup();
    };
    const adaptableModule = props.api.internalApi.getModuleService().getModuleById(props.module.moduleInfo.ModuleName);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const showLayoutNonExtendedObjects = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Internal.Layout.showLayoutNonExtendedObjects);
    const toggleButtonShowLayoutExtensionObjects = ()=>{
        if (!adaptableModule?.containsLayoutExtensions()) return;
        if (!props.api.layoutApi.internalApi.hasLayoutSpecificObjects()) return;
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: "twa:justify-start"
        }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            className: "twa:m-0 twa:p-0",
            checked: showLayoutNonExtendedObjects,
            onChange: (checked)=>dispatch((0, $5b564bb703f29152$export$28b9e963338cf73b)(checked))
        }, "Show ", moduleInfo.FriendlyName, "s not available in current Layout"));
    };
    return $acw62.createElement((0, $f2e321bc3b2b59f1$export$bb9c8cd02008fc9f), {
        glyphicon: moduleInfo.Glyph,
        infoLink: moduleInfo.HelpPage,
        headerText: moduleInfo.FriendlyName,
        button: $acw62.createElement($acw62.Fragment, null, suspendButton, " ", newButton),
        infoLinkDisabled: !props.api.internalApi.isDocumentationLinksDisplayed()
    }, moduleViewProperties.HeaderComponent && $acw62.createElement(moduleViewProperties.HeaderComponent, null), toggleButtonShowLayoutExtensionObjects(), items?.length ? $acw62.createElement((0, $e7b071cd434f710e$export$52f2aa84838d2a04), {
        module: props.module,
        items: items
    }) : $acw62.createElement((0, $692d03a290feaea9$export$2e2bcd8739ae039), null, emptyContent ?? `Click 'New' to create a new ${moduleInfo.FriendlyName}`), isWizardOpen && EditWizard && $acw62.createElement(EditWizard, {
        abObjectType: abObjectType,
        moduleInfo: moduleInfo,
        data: null,
        popupParams: props.popupParams,
        configEntities: null,
        onCloseWizard: handleWizardClose,
        onFinishWizard: handleWizardClose
    }));
};


const $8e43e96c35aac0e5$export$ed365ca63a243833 = (props)=>{
    const modalContainer = (0, $5aWMQ.UIHelper).getModalContainer(props.api.optionsApi.getAdaptableOptions(), document, props.api.internalApi.buildBaseContext());
    const moduleName = props.module.moduleInfo.ModuleName;
    const accessLevel = props.api.entitlementApi.getEntitlementAccessLevelForModule(moduleName);
    const moduleInfo = props.api.internalApi.getModuleService().getModuleInfoByModule(moduleName);
    const moduleProps = {
        popupParams: props.moduleParams,
        onClearPopupParams: ()=>props.onClearParams ? props.onClearParams() : null,
        onClosePopup: ()=>{
            if (props.onHide) props.onHide();
        },
        // show share button if TeamSharing is active & user has edit rights
        teamSharingActivated: props.api.teamSharingApi.isTeamSharingAvailable() && props.api.teamSharingApi.hasTeamSharingFullRights(),
        modalContainer: modalContainer,
        accessLevel: accessLevel,
        api: props.api,
        moduleInfo: moduleInfo
    };
    const BodyComponent = (0, $b1f453bcc52a26e6$export$d4d53f0c4fbfa3c7)?.[props?.componentName ?? moduleInfo.Popup] || (0, $bef12997692d3d1f$export$7f786fdd33c40095);
    // key is to make sure state is reset between views
    // most of the views use the `AdaptablePopupModuleView` component
    return $acw62.createElement(BodyComponent, {
        key: props?.componentName,
        module: props.module,
        ...moduleProps
    });
};




var $acw62 = parcelRequire("acw62");

const $d7521123b401547d$export$934d69f4a09b8ee2 = (props)=>{
    return $acw62.createElement((0, $1acaa6ff89593611$export$edafaa7cfa4a5013), {
        key: props.settingsPanel.name,
        render: props.settingsPanel.render,
        componentName: props.settingsPanel.name,
        frameworkComponent: props.settingsPanel.frameworkComponent
    });
};



var $acw62 = parcelRequire("acw62");

/**
 * This constant determines the items, and order, which appear in Settings Panel
 */ const $317584b93660b49b$export$5216e52813566562 = [
    'GridInfo',
    'ColumnInfo',
    'Dashboard',
    'ToolPanel',
    'StatusBar',
    'Theme',
    '-',
    'Layout',
    'CalculatedColumn',
    'CustomSort',
    'Alert',
    'SystemStatus',
    '-',
    'Export',
    'DataImport',
    '-',
    'FormatColumn',
    'StyledColumn',
    'FlashingCell',
    '-',
    'QuickSearch',
    'GridFilter',
    'ColumnFilter',
    'DataSet',
    'NamedQuery',
    '-',
    'Note',
    'Comment',
    'FreeTextColumn',
    '-',
    'PlusMinus',
    'Shortcut',
    'DataChangeHistory',
    '-',
    'Charting',
    'Schedule',
    'TeamSharing',
    'StateManagement'
];





const $642abceeb1f2669e$export$aad046bd9909db8f = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const settingsPanelOptions = adaptable.adaptableOptions.settingsPanelOptions;
    const allMenuItems = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state?.Internal?.SettingsPanelModuleEntries);
    return $acw62.useMemo(()=>{
        let navigationItems = settingsPanelOptions?.navigation?.items;
        if (!navigationItems) {
            navigationItems = [
                ...(0, $317584b93660b49b$export$5216e52813566562)
            ];
            if (settingsPanelOptions.customSettingsPanels) navigationItems.push(...settingsPanelOptions.customSettingsPanels.map((panel)=>panel.name));
        }
        const visibleItems = allMenuItems.filter((item)=>item.category !== 'General' && item.category !== 'CustomSettingsPanel' && item.category !== 'Group' && !(0, $58846ea7f4156db7$export$ed82a232da5d8bc7).includes(item.category) && item.isVisible);
        let navItems = navigationItems.map((moduleName)=>{
            if (moduleName === '-') return moduleName;
            const customSettingsPanel = settingsPanelOptions?.customSettingsPanels?.find?.((panel)=>panel.name === moduleName);
            let customPanelMenuItem = null;
            if (customSettingsPanel) // @ts-ignore
            customPanelMenuItem = {
                category: 'CustomSettingsPanel',
                label: customSettingsPanel.name,
                isVisible: true,
                reduxAction: $dc56b6267ce4d0bb$export$e2d5bba0b444685d(null, customSettingsPanel.name)
            };
            return customPanelMenuItem || visibleItems.find((item)=>item.category === moduleName);
        }).filter(Boolean);
        // remove sequential '-' items
        navItems = navItems.filter((item, index)=>{
            if (item === '-' && navItems[index - 1] === '-') return false;
            return true;
        });
        return navItems;
    }, [
        allMenuItems
    ]);
};



var $9AsCL = parcelRequire("9AsCL");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");






const $9379530d622d166d$var$WindowDialog = (props)=>{
    const { onChange: onChange, style: style, baseClassName: baseClassName, className: className, isActionModule: isActionModule, settingsPanelOptionsKey: settingsPanelOptionsKey, onHide: onHide, ...dialogProps } = props;
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const settingsPanelOptions = adaptable.adaptableOptions.settingsPanelOptions;
    let popupSettings = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state?.Internal?.SettingsPanel?.[settingsPanelOptionsKey]);
    const handleWindowSettings = (settings)=>{
        dispatch((0, $5b564bb703f29152$export$77fe906b2ea73993)(settingsPanelOptionsKey, settings));
    };
    if (!popupSettings) {
        const size = isActionModule ? (0, $e3355316da89bc6f$export$705e23ee65642488)() : settingsPanelOptions.size ?? (0, $e3355316da89bc6f$export$2a587b923ae1c91c)();
        popupSettings = {
            size: size,
            position: settingsPanelOptions.position ?? (0, $e3355316da89bc6f$export$b030b23cc5ca76ae)(size)
        };
    }
    const windowModalProps = {
        handleSelector: isActionModule ? `.${baseClassName} .ab-Panel__header` : '.ab-Adaptable-Popup__TopBar',
        minHeight: 460,
        minWidth: 400,
        size: popupSettings.size,
        position: popupSettings.position,
        onChange: handleWindowSettings
    };
    return $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
        windowModal: true,
        fixed: false,
        windowModalProps: windowModalProps,
        style: props.style,
        onDismiss: onHide,
        isOpen: true,
        showCloseButton: true,
        ...dialogProps,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:p-0 twa:h-full', className)
    });
};
const $9379530d622d166d$var$PopupDialog = (props)=>{
    const { style: style, className: className, onHide: onHide, children: children, ...dialogProps } = props;
    return $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
        fixed: false,
        style: props.style,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:p-0 twa:h-[90vh] twa:w-[90vw]', className),
        onDismiss: onHide,
        isOpen: true,
        showCloseButton: true,
        ...dialogProps
    }, children);
};
const $9379530d622d166d$export$11241f6cc0854a15 = (props)=>{
    const { isActionModule: isActionModule, style: style, friendlyName: friendlyName, baseClassName: baseClassName, className: className, children: children, onHide: onHide, isWindowModal: isWindowModal, modalContainer: modalContainer } = props;
    if (modalContainer) return (0, $1u0KT.createPortal)($acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
        "data-name": props.dataName,
        modal: false,
        fixed: false,
        onDismiss: onHide,
        className: className
    }, children), modalContainer);
    if (isWindowModal) {
        const settingsPanelOptionsKey = isActionModule ? `action-${friendlyName}` : 'settings';
        return $acw62.createElement($9379530d622d166d$var$WindowDialog, {
            dataName: props.dataName,
            settingsPanelOptionsKey: settingsPanelOptionsKey,
            isActionModule: isActionModule,
            onHide: onHide,
            style: style,
            baseClassName: baseClassName,
            className: className
        }, children);
    } else {
        if (isActionModule) return $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
            "data-name": props.dataName,
            fixed: false,
            style: {
                ...style,
                maxWidth: 800
            },
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:p-0 twa:max-h-[90vh]', className),
            onDismiss: onHide,
            isOpen: true,
            showCloseButton: true
        }, children);
        const modalStyle = {
            ...style,
            maxWidth: 1200,
            maxHeight: 1000
        };
        return $acw62.createElement($9379530d622d166d$var$PopupDialog, {
            "data-name": props.dataName,
            onHide: onHide,
            style: modalStyle,
            className: className
        }, children);
    }
};



const $6f2f5609ba5fa940$export$d1085bc8adf9a424 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const settingsPanelOptions = adaptable.adaptableOptions.settingsPanelOptions;
    const settingsPanelTitle = adaptable.ModuleService.getModuleFriendlyName('SettingsPanel');
    const menuItems = (0, $642abceeb1f2669e$export$aad046bd9909db8f)();
    const isWindowModal = settingsPanelOptions.popupType === 'window';
    const modalContainer = (0, $9AsCL.resolveContainerElement)(adaptable.adaptableOptions?.containerOptions?.modalContainer, props.api.internalApi.buildBaseContext());
    let friendlyName = null;
    /**
     * This means that it is not rendered in the context of Settings Panel
     * - no topbar
     * - no navigation
     */ let isStandalone = false;
    let moduleViewContent = null;
    let activeItem = null;
    let accessLevel = 'Full';
    const firstMenuItem = menuItems.find((menuItem)=>menuItem !== '-');
    const firstMenuModule = firstMenuItem?.category;
    let componentModule = props.componentModule;
    let componentName = props.componentName;
    // ts forces to check for General, there is no menu item General
    const useFirstItem = !props.componentName;
    if (useFirstItem && firstMenuModule !== 'General' && firstMenuModule !== 'CustomSettingsPanel' && firstMenuModule !== 'Group') componentModule = firstMenuModule;
    const customSettingsPanel = settingsPanelOptions?.customSettingsPanels?.find((customPanel)=>useFirstItem ? customPanel.name === firstMenuItem.label : customPanel.name === componentName);
    if (customSettingsPanel) {
        friendlyName = customSettingsPanel.name;
        activeItem = customSettingsPanel.name;
        moduleViewContent = $acw62.createElement((0, $d7521123b401547d$export$934d69f4a09b8ee2), {
            settingsPanel: customSettingsPanel
        });
    } else {
        const module = props.api.internalApi.getModuleService().getModuleById(componentModule);
        const moduleInfo = module?.moduleInfo;
        accessLevel = props.api.entitlementApi.getEntitlementAccessLevelForModule(componentModule);
        friendlyName = moduleInfo.FriendlyName;
        isStandalone = moduleInfo && ($58846ea7f4156db7$export$ed82a232da5d8bc7.includes(moduleInfo?.ModuleName) || props.componentName && props.componentName !== moduleInfo?.Popup);
        activeItem = moduleInfo.ModuleName;
        moduleViewContent = $acw62.createElement((0, $8e43e96c35aac0e5$export$ed365ca63a243833), {
            api: props.api,
            module: module,
            componentName: props.componentName,
            moduleParams: props.moduleParams,
            onClearParams: props.onClearParams,
            onHide: props.onHide
        });
    }
    const baseClassName = 'ab-Adaptable-Popup';
    const className = (0, $c72009da7485afc2$export$2e2bcd8739ae039)(baseClassName, `${baseClassName}--${isWindowModal ? 'window' : 'modal'}`, isStandalone ? `${baseClassName}--action-popup` : `${baseClassName}--settings-popup`);
    return $acw62.createElement((0, $e1144fa2193cb217$export$2e2bcd8739ae039).Provider, {
        value: {
            hidePopup: ()=>{
                if (props.onHide) props.onHide();
            }
        }
    }, $acw62.createElement((0, $9379530d622d166d$export$11241f6cc0854a15), {
        dataName: componentModule,
        baseClassName: baseClassName,
        className: className,
        friendlyName: friendlyName,
        isActionModule: isStandalone,
        isWindowModal: isWindowModal,
        onHide: props.onHide,
        modalContainer: modalContainer
    }, !isStandalone && $acw62.createElement((0, $2b60159cb334c1a5$export$2e2bcd8739ae039), {
        icon: settingsPanelOptions.icon
    }, settingsPanelTitle), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:flex twa:flex-row twa:flex-1 twa:min-h-0', 'twa:bg-defaultbackground twa:text-text-on-defaultbackground', accessLevel == 'ReadOnly' ? $58846ea7f4156db7$export$2c59109bdd218c0 : '')
    }, !isStandalone && $acw62.createElement((0, $b925c2ca401b3835$export$b8a61e5c71402559), {
        menuItems: menuItems,
        api: props.api,
        activeItem: activeItem,
        customSettingsPanels: settingsPanelOptions.customSettingsPanels
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('ab-Adaptable-Popup__Body', 'twa:bg-primarylight twa:text-primarylight-foreground', 'twa:flex twa:flex-1 twa:min-w-0 twa:overflow-auto', !isStandalone && 'twa:*:p-3')
    }, moduleViewContent))));
};





var $acw62 = parcelRequire("acw62");

var $5aWMQ = parcelRequire("5aWMQ");

var $9OAZF = parcelRequire("9OAZF");








const $fd14cf9051666165$export$cb4a2bc9bfa29565 = (props)=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [disableDeleteConfirmation, setDisableDeleteConfirmation] = $acw62.useState(false);
    const [promptText, setPromptText] = $acw62.useState('');
    const header = props.header;
    const glyph = (0, $5aWMQ.UIHelper).getGlyphByMessageType(props.messageType);
    function onCancelForm() {
        setPromptText('');
        props.onCancel();
    }
    function onConfirmmForm() {
        props.onConfirm(promptText);
        setPromptText('');
        if (disableDeleteConfirmation) dispatch($5b564bb703f29152$export$ece6b6ff8f71195d());
    }
    function changeContent(e) {
        setPromptText(e.target.value);
    }
    function canConfirm() {
        if (props.showInputBox) return (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(promptText);
        return true;
    }
    if (!props.showPopup) return $acw62.createElement($acw62.Fragment, null);
    return $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
        modal: true,
        "data-name": `confirmation-popup confirmation-popup--${props.messageType.toLowerCase()}`,
        isOpen: props.showPopup,
        onDismiss: props.onCancel,
        showCloseButton: false,
        style: {
            minHeight: 'auto',
            maxWidth: '50%'
        }
    }, $acw62.createElement((0, $283cf61293364231$export$226a98817755c0cc), {
        header: header,
        icon: glyph,
        variant: "primary"
    }, $acw62.createElement("div", null, $acw62.createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center'
        }
    }, props.messsage.split('\n').map(function(item, index) {
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            key: index,
            className: "twa:m-2"
        }, item, $acw62.createElement("br", null));
    })), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:pl-2"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: disableDeleteConfirmation,
        onChange: ()=>{
            setDisableDeleteConfirmation(!disableDeleteConfirmation);
        }
    }, "Do not show this again")), props.showInputBox && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2",
        "data-name": "body"
    }, $acw62.createElement("p", null, "Please enter a comment to confirm."), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        className: "twa:mt-2 twa:w-full",
        value: promptText,
        type: "string",
        placeholder: "Enter text",
        onChange: (e)=>changeContent(e)
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:mt-3 twa:p-2",
        "data-name": "footer",
        justifyContent: "space-between"
    }, props.cancelButtonText != null ? $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "cancel",
        tone: "neutral",
        variant: "raised",
        onClick: ()=>onCancelForm()
    }, props.cancelButtonText) : $acw62.createElement("div", null), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        tone: "error",
        "data-name": "delete",
        variant: "raised",
        disabled: !canConfirm(),
        onClick: ()=>onConfirmmForm()
    }, props.confirmButtonText)))));
};



var $acw62 = parcelRequire("acw62");

var $9OAZF = parcelRequire("9OAZF");





const $f818488879d418e9$export$8206e3f21d354d8a = (props)=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [promptText, setPromptText] = $acw62.useState(props.defaultValue ?? '');
    const onCloseForm = ()=>{
        setPromptText('');
        props.onClose();
    };
    const onConfirmForm = ()=>{
        props.onConfirm(promptText);
        const confirmationAction = typeof props.onConfirmActionCreator === 'function' && props.onConfirmActionCreator(promptText);
        if (confirmationAction) dispatch(confirmationAction);
        setPromptText('');
    };
    const changeContent = (e)=>{
        setPromptText(e.target.value);
    };
    return $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
        modal: true,
        "data-name": `prompt-popup`,
        isOpen: true,
        onDismiss: props.onClose,
        showCloseButton: false,
        className: "twa:min-h-auto twa:max-w-1/2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3 twa:mx-2"
    }, props.header), (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(props.message) && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3 twa:mx-2"
    }, ' ', $acw62.createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center'
        }
    }, props.message.split('\n').map(function(item, index) {
        return $acw62.createElement("span", {
            key: index
        }, item, $acw62.createElement("br", null));
    }))), $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        autoFocus: true,
        className: "twa:mt-3 twa:mx-3",
        value: promptText,
        type: "string",
        placeholder: "Enter text",
        onChange: (e)=>changeContent(e)
    }), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-3"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:p-2",
        "data-name": "footer",
        justifyContent: "space-between"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        tone: "neutral",
        variant: "raised",
        onClick: ()=>onCloseForm(),
        "data-name": "cancel"
    }, "Cancel"), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        tone: "accent",
        "data-name": "ok",
        variant: "raised",
        disabled: (0, $9OAZF.StringExtensions).IsNullOrEmpty(promptText),
        onClick: ()=>onConfirmForm()
    }, "OK")))));
};



var $acw62 = parcelRequire("acw62");



function $fdea50cf7b9d9a64$export$dcf3fd341269d23c(formDef) {
    return (formDef.fields || []).flat().reduce((data, field)=>{
        data[field.name] = field.defaultValue ?? '';
        return data;
    }, {});
}





const $43fcf747f0d47c9a$export$ed8869c34b2bb205 = ({ id: id, formProps: formProps, form: form, prepareContext: prepareContext })=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const [data, setData] = $acw62.useState(()=>{
        return (0, $fdea50cf7b9d9a64$export$dcf3fd341269d23c)(form);
    });
    const handleDismiss = ()=>{
        dispatch((0, $dc56b6267ce4d0bb$export$7429bcb1fd685d4f)(id));
    };
    const context = {
        adaptableApi: adaptable.api,
        formData: data,
        ...formProps
    };
    return $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
        isOpen: true,
        showCloseButton: false,
        className: "twa:min-h-auto twa:min-w-[400px] twa:max-h-[80vh]",
        onDismiss: handleDismiss
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: 'column',
        "data-name": "form-dialog",
        className: "twa:p-4 twa:h-full"
    }, $acw62.createElement((0, $7633ec1fcb7d68a8$export$6ccc12e28078d09e), {
        formDef: form,
        data: data,
        context: context,
        onChange: setData,
        api: adaptable.api,
        displayTitle: true,
        onButtonClick: async (button)=>{
            handleDismiss();
            const preparedContext = typeof prepareContext === 'function' ? await prepareContext(context) : context;
            button.onClick?.(button, preparedContext);
        }
    })));
};
const $43fcf747f0d47c9a$export$7ee7a06e459d6ea4 = ()=>{
    const forms = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Popup.FormPopup.FormList);
    return $acw62.createElement($acw62.Fragment, null, forms.map((form)=>{
        return $acw62.createElement($43fcf747f0d47c9a$export$ed8869c34b2bb205, {
            key: form.Id,
            prepareContext: form.prepareContext,
            id: form.Id,
            formProps: form.FormProps,
            form: form.Form
        });
    }));
};



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");










const $118a2ed9e577ba01$export$3f5d40b674071cc = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const showCloseButton = api.optionsApi.getCommentOptions()?.showPopupCloseButton ?? true;
    const cellAddress = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>(0, $5b564bb703f29152$export$7546faff8f4dea4d)(state.Internal));
    const userId = $acw62.useMemo(()=>{
        return api.optionsApi.getUserName();
    }, []);
    const commentThread = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>$4e814d4456d3e111$export$c662b749c0ef4d93(state.Comment, cellAddress));
    const isReadOnlyModule = api.entitlementApi.getEntitlementAccessLevelForModule('Comment') === 'ReadOnly';
    const [activeEditingComment, setActiveEditingComment] = $acw62.useState(()=>{
        /**
         * When opening the popup and there is only one comment, we want to open it in edit mode.
         * This happens usualy when a new comment is added via cell menu.
         */ // if (cellComments?.Comments?.length === 1 && cellComments?.Comments[0].Value === '') {
        //   return cellComments?.Comments[0].Uuid;
        // }
        return null;
    });
    const [newCommentText, setNewCommentText] = $acw62.useState('');
    const commentsWrapperRef = $acw62.useRef(null);
    const comments = commentThread?.Comments;
    const scrollToBottom = ()=>{
        commentsWrapperRef?.current?.scrollTo(0, commentsWrapperRef?.current?.scrollHeight);
    };
    $acw62.useEffect(()=>{
        scrollToBottom();
    }, []);
    if (!commentThread) return null;
    const formatDate = (date, format)=>{
        return (0, $1fe81e1078ace264$export$2e2bcd8739ae039).DateFormatter(date, {
            Pattern: format
        });
    };
    return $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        color: "var(--ab-color-text-on-primary)",
        onClick: ()=>props.enableEditMode(),
        className: "ab-CommentPopup twa:min-w-[250px]",
        onKeyDown: (event)=>{
            if (event.key === 'Escape') api.commentApi.hideCommentsPopup();
        }
    }, showCloseButton && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:flex-1"
    }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        onClick: (event)=>{
            event.stopPropagation();
            api.commentApi.hideCommentsPopup();
        },
        variant: "text",
        icon: "close"
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:overflow-auto twa:max-h-[300px]",
        flexDirection: "column",
        ref: commentsWrapperRef
    }, comments && comments.length > 0 && comments.map((comment, index)=>{
        if (!comment) return null;
        const isOwnComment = comment?.Author?.UserName ? comment?.Author?.UserName === userId : true; // no owner means it's the current user
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            key: comment.Uuid ?? index,
            className: "ab-Comment twa:p-2"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            alignItems: "center",
            className: "twa:mb-2"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            "data-name": "comment-username",
            className: "twa:text-3 twa:font-bold"
        }, comment?.Author?.UserName), comment.Timestamp && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            "data-name": "comment-timestamp",
            className: "twa:text-2"
        }, formatDate(comment.Timestamp, api.commentApi.internalApi.getCommentsDateFormat()))), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:flex-1"
        }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            variant: "text",
            icon: "edit",
            disabled: !isOwnComment || isReadOnlyModule,
            onClick: ()=>setActiveEditingComment(comment.Uuid)
        }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            variant: "text",
            icon: "delete",
            disabled: !isOwnComment || isReadOnlyModule,
            onClick: ()=>{
                api.commentApi.deleteComment(comment, cellAddress);
                requestAnimationFrame(()=>{
                    props.onRefreshContent();
                });
            }
        })), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            onClick: ()=>setActiveEditingComment(comment.Uuid)
        }, comment.Uuid === activeEditingComment ? $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
            autoFocus: true,
            className: "twa:w-full",
            defaultValue: comment.Value,
            disabled: isReadOnlyModule,
            onBlur: ()=>{
                if (comment.Uuid === activeEditingComment) setActiveEditingComment(null);
            },
            onChange: (event)=>{
                api.commentApi.editComment({
                    ...comment,
                    Value: event.target.value
                }, cellAddress);
            }
        }) : $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            "data-name": "comment-text"
        }, comment.Value)));
    })), $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        autoFocus: !comments || comments.length === 0,
        value: newCommentText,
        disabled: isReadOnlyModule,
        onChange: (event)=>{
            setNewCommentText(event.target.value);
        },
        onKeyDown: (event)=>{
            if (event.key === 'Enter') {
                api.commentApi.addComment(newCommentText, cellAddress);
                setNewCommentText('');
                requestAnimationFrame(()=>{
                    props.onRefreshContent();
                    scrollToBottom();
                });
            }
        },
        className: "twa:w-full twa:my-2",
        placeholder: "Write new Comment"
    }), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        className: "twa:w-full",
        variant: "raised",
        onClick: ()=>{
            api.settingsPanelApi.openSettingsPanel('Comment');
            api.internalApi.getAnnotationsService().hidePopup();
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mr-2"
    }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "folder"
    })), ' ', "Open all Comments"));
};




var $acw62 = parcelRequire("acw62");




const $e14b5e14a46f4454$export$9939e67821493b95 = ({ note: note, onNoteChange: onNoteChange, onClose: onClose, editMode: editMode, isReadonly: isReadonly })=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const showPopupCloseButton = api.optionsApi.getNoteOptions()?.showPopupCloseButton ?? true;
    const textAreaRef = $acw62.useRef(null);
    const [liveValue, setLiveValue] = $acw62.useState(note || '');
    const throttledOnChange = $acw62.useMemo(()=>{
        const throttled = (0, $3a4c9a3b92c4503b$export$2e2bcd8739ae039)((value)=>onNoteChange(value), 300);
        return (value)=>{
            setLiveValue(value);
            throttled(value);
        };
    }, []);
    $acw62.useEffect(()=>{
        if (editMode) textAreaRef.current?.focus();
    }, [
        editMode
    ]);
    if (note === undefined || note === null) return null;
    return $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $d541796d86c181e1$export$2e2bcd8739ae039), {
        readOnly: isReadonly,
        ref: textAreaRef,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)('twa:min-w-[180px] twa:min-h-[120px] twa:w-full', {
            'twa:pr-[30px]': showPopupCloseButton,
            'twa:pr-0': !showPopupCloseButton
        }),
        value: liveValue,
        onBlur: ()=>onClose(),
        onKeyDown: (event)=>{
            if (event.key === 'Escape') onClose();
        },
        onChange: (event)=>throttledOnChange(event.target.value)
    }), showPopupCloseButton && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        variant: "text",
        style: {
            position: 'absolute',
            right: 5,
            top: 5
        },
        icon: "close"
    }));
};



var $acw62 = parcelRequire("acw62");




var $5aWMQ = parcelRequire("5aWMQ");
let $0e40c5327c9f1055$var$portalElement;
const $0e40c5327c9f1055$var$ensurePortalElement = (className)=>{
    if (!(0, $5aWMQ.isBrowserDocumentAvailable)()) return;
    if ($0e40c5327c9f1055$var$portalElement) return;
    $0e40c5327c9f1055$var$portalElement = document.createElement('div');
    $0e40c5327c9f1055$var$portalElement.style.position = 'absolute';
    $0e40c5327c9f1055$var$portalElement.style.zIndex = '4'; // under the context menu
    $0e40c5327c9f1055$var$portalElement.style.top = '0px';
    $0e40c5327c9f1055$var$portalElement.style.left = '0px';
    if (className) $0e40c5327c9f1055$var$portalElement.className = className;
    document.body.appendChild($0e40c5327c9f1055$var$portalElement);
};
const $0e40c5327c9f1055$export$da1468fa7ea6d646 = $acw62.forwardRef((props, ref)=>{
    $0e40c5327c9f1055$var$ensurePortalElement(props.className);
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { showOverlay: showOverlay, clearAll: clearAllOverlays, hideOverlay: hideOverlay, portal: portal } = (0, $88ab1a78ec8ca4b4$export$ea8f71083e90600f)({
        portalContainer: $0e40c5327c9f1055$var$portalElement
    });
    const OVERLAY_ID = 'cell-overlay';
    const showCellPopupContent = ()=>{
        const cellSelector = `[row-id="${props.primaryKeyValue}"] [col-id="${props.columnId}"]`;
        const alignTo = document.querySelector(cellSelector);
        if (!alignTo) {
            adaptable.logger.consoleError(`Cell not found for selector "${cellSelector}". Unable to display popup.`);
            return;
        }
        const showOverlayOptions = {
            id: OVERLAY_ID,
            alignPosition: [
                // overlay - target
                [
                    'TopLeft',
                    'TopRight'
                ],
                [
                    'TopRight',
                    'TopLeft'
                ],
                [
                    'TopCenter',
                    'BottomCenter'
                ],
                [
                    'BottomCenter',
                    'TopCenter'
                ]
            ],
            constrainTo: adaptable.getAgGridContainerElement() ?? true,
            alignTo: (0, $2c56c77c53b8e90d$export$4b834cebd9e5cebe)(alignTo)
        };
        showOverlay(()=>props.children, showOverlayOptions);
    };
    $acw62.useEffect(()=>{
        if (props.isOpen) showCellPopupContent();
        else {
            clearAllOverlays();
            hideOverlay(OVERLAY_ID);
        }
    }, [
        props.isOpen
    ]);
    $acw62.useImperativeHandle(ref, ()=>{
        return {
            refreshContent: ()=>showCellPopupContent()
        };
    });
    return $acw62.createElement($acw62.Fragment, null, portal);
});



const $5f2e20103c93adcf$var$ConnectedNoteEditor = ({ enableEditMode: enableEditMode })=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const isReadonly = api.entitlementApi.isModuleReadOnlyEntitlement('Note');
    const editMode = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>(0, $5b564bb703f29152$export$8c3f353a3a9e8bd4)(state.Internal));
    const annotationsService = api.internalApi.getAnnotationsService();
    const cellAddress = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>(0, $5b564bb703f29152$export$7546faff8f4dea4d)(state.Internal));
    const note = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>{
        return cellAddress ? (0, $b5b505fd5df04a9f$export$382cdf5ac6d0bf8b)(state.Note, cellAddress) : null;
    });
    const handleNoteChange = $acw62.useCallback((value)=>{
        api.noteApi.updateNoteText(value, note);
    }, [
        note
    ]);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        onClick: ()=>enableEditMode(),
        flexDirection: "column",
        className: "ab-NotePopup"
    }, $acw62.createElement((0, $e14b5e14a46f4454$export$9939e67821493b95), {
        isReadonly: isReadonly,
        editMode: editMode,
        key: note?.Uuid,
        onClose: ()=>annotationsService.hidePopup(),
        note: note?.Text,
        onNoteChange: (value)=>handleNoteChange(value)
    }));
};
const $5f2e20103c93adcf$export$1f3861479a0f15f8 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const cellPopupRef = $acw62.useRef(null);
    const editMode = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>(0, $5b564bb703f29152$export$8c3f353a3a9e8bd4)(state.Internal));
    const focusedEntity = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>(0, $5b564bb703f29152$export$98c64374e991cee4)(state.Internal));
    const cellAddress = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>(0, $5b564bb703f29152$export$7546faff8f4dea4d)(state.Internal));
    const enableEditMode = (entity)=>{
        if (!editMode) {
            const annotationsService = api.internalApi.getAnnotationsService();
            annotationsService.showPopup(cellAddress, true);
            annotationsService.editFocusedEntity(entity);
        }
    };
    $acw62.useEffect(()=>{
        cellPopupRef?.current?.refreshContent?.();
    }, [
        focusedEntity
    ]);
    if (!cellAddress) return $acw62.createElement($acw62.Fragment, null);
    const noteEditor = $acw62.createElement($5f2e20103c93adcf$var$ConnectedNoteEditor, {
        enableEditMode: ()=>enableEditMode('Note')
    });
    const commentEditor = $acw62.createElement((0, $118a2ed9e577ba01$export$3f5d40b674071cc), {
        onRefreshContent: ()=>cellPopupRef?.current?.refreshContent?.(),
        enableEditMode: ()=>enableEditMode('Comment')
    });
    return $acw62.createElement((0, $0e40c5327c9f1055$export$da1468fa7ea6d646), {
        ref: cellPopupRef,
        key: `${cellAddress.PrimaryKeyValue}-${cellAddress.ColumnId}`,
        isOpen: true,
        primaryKeyValue: cellAddress.PrimaryKeyValue,
        columnId: cellAddress.ColumnId
    }, (()=>{
        switch(focusedEntity){
            case 'Note':
                return noteEditor;
            case 'Comment':
                return commentEditor;
            default:
                return $acw62.createElement($acw62.Fragment, null, noteEditor, commentEditor);
        }
    })());
};







var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



function $0f60550fdfd668aa$export$81c4ead743bd36d1(props) {
    return $acw62.createElement("div", {
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)('ab-Dashboard__toolbar', props.className)
    }, $acw62.createElement("div", {
        className: "ab-Dashboard__toolbar-content"
    }, props.children), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-Dashboard__toolbar-title twa:items-center twa:justify-center twa:px-2 twa:pb-1 twa:opacity-70",
        flexDirection: "row"
    }, $acw62.createElement("span", {
        className: "twa:text-2"
    }, props.title), props.showConfigure && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "aria-label": `Configure ${props.title}`,
        icon: "spanner",
        variant: "text",
        tone: "none",
        "data-name": "configure",
        iconSize: 16,
        className: "twa:ml-1",
        tooltip: props.tooltip || `Configure ${props.title}`,
        onClick: ()=>props.onConfigure()
    }), props.showClose && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "aria-label": `Close ${props.title}`,
        style: {
            alignSelf: 'flex-end'
        },
        disabled: props.accessLevel == 'ReadOnly',
        "data-name": "close",
        icon: "close",
        variant: "text",
        tone: "none",
        iconSize: 16,
        className: "twa:ml-1",
        tooltip: props.tooltip || `Close ${props.title} Toolbar`,
        onClick: ()=>props.onClose?.()
    })));
}



function $c4033ed4b9da2a4e$export$fe82a520fc33e5f4(props) {
    const { title: title, children: children, left: left, right: right, onShowDashboardPopup: onShowDashboardPopup } = props;
    const [activeTabIndex, setActiveTabIndex] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'activeTabIndex', 0);
    const [collapsed, setCollapsed] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'collapsed', false);
    const [floating, setFloating] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'floating', false);
    const [inline, setInline] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'inline', false);
    const [position, setPosition] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'position', {
        x: 0,
        y: 0
    });
    const expanded = !floating && !collapsed;
    const { handleRef: handleRef, targetRef: targetRef } = (0, $3aa7d52cc8af99a8$export$2e2bcd8739ae039)({
        onDrop (dx, dy) {
            setPosition(({ x: x, y: y })=>{
                return {
                    x: x + dx,
                    y: y + dy
                };
            });
        }
    });
    const floatingStyle = {
        position: 'absolute',
        left: position.x,
        top: position.y
    };
    const renderTabs = ()=>$acw62.createElement("div", {
            className: "ab-Dashboard__tabs"
        }, children && $acw62.Children.map(children, (child, index)=>$acw62.createElement("button", {
                type: "button",
                className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)('ab-Dashboard__tab', !collapsed && activeTabIndex === index ? 'ab-Dashboard__tab--active' : ''),
                key: index,
                onClick: ()=>{
                    if (activeTabIndex === index) setCollapsed(!collapsed);
                    else {
                        setActiveTabIndex(index);
                        setCollapsed(false);
                    }
                }
            }, child.props.title)));
    const renderTabsDropdown = ()=>{
        if (children && children.length < 2) return null;
        const activeTabTitle = children?.[activeTabIndex]?.props?.title ?? 'Select Toolbar';
        return $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
            className: "twa:ml-1",
            columns: [
                'label'
            ],
            items: $acw62.Children.map(children, (child, index)=>({
                    value: String(index),
                    label: child.props.title,
                    onClick: ()=>setActiveTabIndex(index)
                }))
        }, activeTabTitle);
    };
    const renderBar = ()=>$acw62.createElement("div", {
            className: "ab-Dashboard__header",
            onDoubleClick: (event)=>{
                const target = event.target;
                // ignore double clicks on buttons, inputs and their children
                if (!props.canFloat) return;
                if (target.closest('button, input')) return;
                setFloating(!floating);
            }
        }, $acw62.createElement("div", {
            className: "ab-Dashboard__header-left"
        }, left, !floating && renderTabs()), floating ? $acw62.createElement("div", {
            className: "ab-Dashboard__title",
            ref: handleRef,
            key: "title-drag",
            style: {
                cursor: 'move'
            }
        }, title) : $acw62.createElement("div", {
            className: "ab-Dashboard__title",
            key: "title"
        }, title), $acw62.createElement("div", {
            className: "ab-Dashboard__header-right"
        }, right));
    const renderHomeToolbar = ()=>$acw62.createElement((0, $0f60550fdfd668aa$export$81c4ead743bd36d1), {
            onConfigure: onShowDashboardPopup,
            className: "ab-Dashboard__home-toolbar",
            title: title,
            tooltip: `Configure Dashboard`,
            showConfigure: true,
            showClose: false,
            accessLevel: 'Full'
        }, left, right, children && children.length > 1, renderTabsDropdown());
    return $acw62.createElement("div", {
        // @ts-ignore
        ref: targetRef,
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(`ab-Dashboard`, collapsed ? 'ab-Dashboard--collapsed' : '', floating ? 'ab-Dashboard--floating' : '', inline ? 'ab-Dashboard--inline' : ''),
        style: floating ? floatingStyle : undefined
    }, expanded && inline ? renderHomeToolbar() : renderBar(), expanded && children && children.length ? $acw62.createElement("div", {
        className: "ab-Dashboard__content"
    }, children[activeTabIndex] ? children[activeTabIndex].props.children : null) : null, props.footer);
}


function $1227f9f058e0b3ba$export$da0841a0525c3b88(props) {
    return null;
}













var $5aWMQ = parcelRequire("5aWMQ");

var $acw62 = parcelRequire("acw62");


const $befed6cae480e847$export$a4dddf174a944351 = (props)=>{
    const { button: button } = props;
    const [componentRevision, setComponentRevision] = (0, $acw62.useState)(1);
    // TODO: variants of this mapping are present in several places (just search for api.internalApi.getStyleForButton() usages)
    // with the next opportunity we should abstract it
    const dashboardContext = {
        ...props.api.internalApi.buildBaseContext(),
        dashboardState: props.api.dashboardApi.getDashboardState()
    };
    const buttonIcon = props.api.internalApi.getIconForButton(button, dashboardContext);
    let buttonStyle = props.api.internalApi.getStyleForButton(button, dashboardContext);
    let buttonLabel = props.api.internalApi.getLabelForButton(button, dashboardContext);
    let buttonTooltip = props.api.internalApi.getTooltipForButton(button, dashboardContext);
    if (button.hidden && button.hidden(button, dashboardContext)) return null;
    const disabled = button.disabled && button.disabled(button, dashboardContext);
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        key: buttonLabel,
        "aria-label": buttonLabel,
        variant: buttonStyle && buttonStyle.variant ? buttonStyle.variant : 'text',
        tone: buttonStyle && buttonStyle.tone ? buttonStyle.tone : 'none',
        className: `ab-DashboardToolbar__Home__${(0, $9ce0650a2a8dba81$export$2e2bcd8739ae039)(buttonLabel)} ${buttonStyle?.className || ''}`,
        tooltip: buttonTooltip,
        icon: buttonIcon,
        disabled: disabled || props.accessLevel == 'ReadOnly',
        onClick: ()=>{
            button.onClick?.(button, dashboardContext);
            setTimeout(()=>{
                // mutate state to force a re-rendering
                setComponentRevision(componentRevision + 1);
            }, 16);
        },
        accessLevel: 'Full'
    }, buttonLabel);
};



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

class $352e9478e1637d6b$export$a3887830d07d04b extends $acw62.Component {
    static defaultProps = {
        showConfigureActionButton: true,
        showCloseActionButton: true,
        headerText: 'Module',
        onClose: null,
        onConfigure: null,
        accessLevel: 'Full'
    };
    render() {
        const { headerText: headerText, showConfigureActionButton: showConfigureActionButton, showCloseActionButton: showCloseActionButton, onConfigure: onConfigure, onClose: onClose, accessLevel: accessLevel, children: children } = this.props;
        return $acw62.createElement((0, $0f60550fdfd668aa$export$81c4ead743bd36d1), {
            title: headerText,
            onConfigure: onConfigure,
            showConfigure: showConfigureActionButton,
            showClose: showCloseActionButton,
            onClose: onClose,
            accessLevel: accessLevel
        }, children);
    }
}


const $1d852300dd5b919c$export$695bee4a34eff742 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    // dummy object which is used to force a re-render of the toolbar
    const [componentRevision, setComponentRevision] = (0, $acw62.useState)(1);
    const renderContentContainerId = api.dashboardApi.internalApi.getCustomToolbarRenderContainerId(props.customToolbar.name);
    const renderContentContainerRef = (0, $acw62.useRef)(null);
    const [renderedContentHTML, setRenderedContentHTML] = (0, $acw62.useState)('');
    const buttonsContainerId = api.dashboardApi.internalApi.getCustomToolbarButtonsContainerId(props.customToolbar.name);
    const componentContainerId = api.dashboardApi.internalApi.getCustomToolbarComponentContainerId(props.customToolbar.name);
    const componentContainerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        const element = renderContentContainerRef.current;
        const adaptableApi = api;
        if (props.customToolbar.render) {
            const html = props.customToolbar.render({
                phase: 'onMount',
                element: element,
                ...adaptableApi.internalApi.buildBaseContext()
            });
            setRenderedContentHTML(html);
        }
    }, [
        componentRevision,
        props.dashboardRevision
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        const element = renderContentContainerRef.current;
        const adaptableApi = api;
        // cleanup runs in a separate effect, this way it's executed only once on unmount
        return ()=>{
            if (props.customToolbar.render) props.customToolbar.render({
                phase: 'onDestroy',
                element: element,
                ...adaptableApi.internalApi.buildBaseContext()
            });
        };
    }, []);
    (0, $acw62.useLayoutEffect)(()=>{
        const containerElement = componentContainerRef.current;
        const adaptableApi = api;
        if (props.customToolbar.frameworkComponent) adaptableApi.internalApi.createFrameworkComponent(containerElement, props.customToolbar.frameworkComponent, 'toolbar');
        const destroyUnsubscribe = adaptableApi.eventApi.on('AdaptableDestroy', ()=>{
            adaptableApi?.internalApi?.destroyFrameworkComponent(containerElement, props.customToolbar.frameworkComponent, 'toolbar');
        });
        return ()=>{
            destroyUnsubscribe();
            if (props.customToolbar.frameworkComponent) adaptableApi?.internalApi?.destroyFrameworkComponent(containerElement, props.customToolbar.frameworkComponent, 'toolbar');
        };
    }, []);
    const CustomReactFrameworkComponent = props.customToolbar.frameworkComponent;
    return $acw62.createElement($acw62.Fragment, null, props.customToolbar.render && $acw62.createElement("div", {
        id: renderContentContainerId,
        ref: renderContentContainerRef,
        className: `ab-CustomToolbar__rendered-content ab-CustomToolbar--${props.customToolbar.name}`,
        style: {
            minHeight: 22
        },
        dangerouslySetInnerHTML: {
            __html: renderedContentHTML
        }
    }), props.customToolbar.toolbarButtons && $acw62.createElement("div", {
        id: buttonsContainerId,
        className: `ab-CustomToolbar__buttons ab-CustomToolbar--${props.customToolbar.name}`,
        style: {
            minHeight: 22
        }
    }, props.customToolbar.toolbarButtons.map((button, index)=>{
        const dashboardContext = {
            customToolbar: props.customToolbar,
            dashboardState: api.dashboardApi.getDashboardState(),
            ...api.internalApi.buildBaseContext()
        };
        const buttonIcon = api.internalApi.getIconForButton(button, dashboardContext);
        let buttonStyle = api.internalApi.getStyleForButton(button, dashboardContext);
        let buttonLabel = api.internalApi.getLabelForButton(button, dashboardContext);
        let buttonTooltip = api.internalApi.getTooltipForButton(button, dashboardContext);
        if (button.hidden && button.hidden(button, dashboardContext)) return null;
        const disabled = button.disabled && button.disabled(button, dashboardContext);
        let buttonVariant = buttonStyle && buttonStyle.variant ? buttonStyle.variant : 'outlined';
        let buttonTone = buttonStyle && buttonStyle.tone ? buttonStyle.tone : 'neutral';
        return $acw62.createElement((0, $4f56822e8a85bf43$export$51a0d41e070314af), {
            style: {
                marginLeft: index ? 'var(--ab-base-space)' : 0
            },
            key: index,
            disabled: disabled,
            tooltip: buttonTooltip,
            icon: buttonIcon,
            variant: buttonVariant,
            tone: buttonTone,
            className: buttonStyle?.className || '',
            onClick: ()=>{
                button.onClick && button.onClick(button, dashboardContext);
                setTimeout(()=>{
                    // mutate state to force a re-rendering
                    setComponentRevision(componentRevision + 1);
                }, 16);
            }
        }, buttonLabel);
    })), CustomReactFrameworkComponent && $acw62.createElement("div", {
        id: componentContainerId,
        ref: componentContainerRef,
        style: {
            minHeight: 22
        },
        className: `ab-CustomToolbar__component ab-CustomToolbar--${props.customToolbar.name}`
    }, api.gridApi.getVariant() === 'react' ? $acw62.createElement(CustomReactFrameworkComponent, {
        adaptableApi: api
    }) : null));
};
const $1d852300dd5b919c$export$d00caf473d0d2e0e = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    return $acw62.createElement((0, $352e9478e1637d6b$export$a3887830d07d04b), {
        headerText: props.customToolbar.title ? props.customToolbar.title : '',
        showConfigureActionButton: props.customToolbar.toolbarActions?.find((b)=>b == 'configure') != undefined,
        showCloseActionButton: props.customToolbar.toolbarActions?.find((b)=>b == 'close') != undefined,
        onConfigure: ()=>{
            const customToolbarConfiguredInfo = {
                ...api.internalApi.buildBaseContext(),
                customToolbar: props.customToolbar
            };
            api.eventApi.emit('CustomToolbarConfigured', customToolbarConfiguredInfo);
        },
        accessLevel: api.entitlementApi.getEntitlementAccessLevelForModule('Dashboard')
    }, $acw62.createElement($1d852300dd5b919c$export$695bee4a34eff742, {
        ...props
    }));
};



var $acw62 = parcelRequire("acw62");





const $b29040b92f77efb1$var$SystemDashboardToolbarFactory = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const moduleInfo = adaptable.api.internalApi.getModuleService().getModuleInfoByModule(props.toolbarName);
    const accessLevel = adaptable.api.entitlementApi.getEntitlementAccessLevelForModule(props.toolbarName);
    const moduleToolbarView = (0, $b1f453bcc52a26e6$export$c7001f4850704fce).get(props.toolbarName);
    if (!moduleToolbarView) return $acw62.createElement($acw62.Fragment, null);
    const moduleToolbarElement = $acw62.createElement(moduleToolbarView, {
        viewType: 'Toolbar',
        api: adaptable.api,
        accessLevel: accessLevel,
        moduleInfo: moduleInfo
    });
    return moduleToolbarElement;
};
const $b29040b92f77efb1$var$CustomDashboardToolbarFactory = (props)=>{
    const revision = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Internal.Dashboard.DashboardRevision);
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const customToolbars = adaptable.api.dashboardApi.getCustomToolbars();
    const customToolbar = customToolbars && customToolbars.find((ct)=>ct.name == props.toolbarName);
    if (customToolbar) return $acw62.createElement((0, $1d852300dd5b919c$export$695bee4a34eff742), {
        customToolbar: customToolbar,
        dashboardRevision: revision
    });
    return $acw62.createElement($acw62.Fragment, null);
};
const $b29040b92f77efb1$export$5650f07be39e091c = (props)=>{
    if ((0, $c75adffdf90b3d81$export$5d1c20aca6593e39).includes(props.toolbarName)) return $acw62.createElement($b29040b92f77efb1$var$SystemDashboardToolbarFactory, {
        toolbarName: props.toolbarName
    });
    else return $acw62.createElement($b29040b92f77efb1$var$CustomDashboardToolbarFactory, {
        toolbarName: props.toolbarName
    });
};



var $acw62 = parcelRequire("acw62");




const $ee2dd27766ed45cc$export$17c8f62c61769904 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const dashboardState = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.Dashboard);
    const pinnedToolbars = (dashboardState.PinnedToolbars ?? []).filter((tb)=>adaptable.api.dashboardApi.internalApi.isToolbarCustom(tb) || adaptable.api.internalApi.getModuleService().isAdapTableModulePresent(tb));
    if (!pinnedToolbars || pinnedToolbars.length == 0) return $acw62.createElement($acw62.Fragment, null);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-Dashboard__pinned twa:p-1"
    }, pinnedToolbars.map((toolbar, index)=>{
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            key: index,
            className: `twa:mr-1 twa:mb-1 ab-Dashboard__pinned-container ab-Dashboard__pinned-container--${toolbar}`
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "ab-Dashboard__toolbar-content"
        }, $acw62.createElement((0, $b29040b92f77efb1$export$5650f07be39e091c), {
            toolbarName: toolbar
        })));
    }));
};



var $acw62 = parcelRequire("acw62");




const $cfffd85853650f1f$export$e6eb774ab541dc4a = (props)=>{
    const moduleName = props.moduleInfo.ModuleName;
    const moduleFriendlyName = props.moduleInfo.FriendlyName;
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const isConfigurable = moduleName !== 'OpenFin' && moduleName !== 'IPushPull';
    return $acw62.createElement((0, $352e9478e1637d6b$export$a3887830d07d04b), {
        className: `ab-DashboardToolbar__${moduleName}`,
        "data-name": `ab-DashboardToolbar__${moduleName}`,
        headerText: moduleFriendlyName,
        showConfigureActionButton: isConfigurable,
        onConfigure: ()=>{
            const maxWidth = api.internalApi.getModuleService().getPopupMaxWidth(moduleName);
            const popupParams = maxWidth ? {
                maxWidth: maxWidth,
                source: 'Toolbar'
            } : {
                source: 'Toolbar'
            };
            api.internalApi.dispatchReduxAction($dc56b6267ce4d0bb$export$e2d5bba0b444685d(moduleName, props.moduleInfo.Popup, popupParams));
        },
        onClose: ()=>api.internalApi.dispatchReduxAction($dc6bc6f406d56c84$export$e9d8f4a531588479(moduleName)),
        accessLevel: props.accessLevel
    }, props.children);
};




const $3aa02d34677ce5a7$var$DashboardComponent = (props)=>{
    const dashboardAccessLevel = props.api.entitlementApi.getEntitlementAccessLevelForModule('Dashboard');
    const renderTab = (tab)=>{
        const visibleToolbarNames = tab.Toolbars.filter((vt)=>vt);
        const customToolbars = props.api.dashboardApi.getCustomToolbars();
        let visibleDashboardElements = visibleToolbarNames.map((visibleToolbarName)=>{
            let customToolbar = customToolbars && customToolbars.find((ct)=>ct.name == visibleToolbarName);
            if (customToolbar) {
                if (dashboardAccessLevel != 'Hidden') return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                    key: customToolbar.name,
                    className: `ab-Dashboard__container ab-Dashboard__container--customToolbar`
                }, $acw62.createElement((0, $1d852300dd5b919c$export$d00caf473d0d2e0e), {
                    customToolbar: customToolbar,
                    dashboardRevision: props.DashboardRevision
                }));
            } else {
                const moduleToolbarName = visibleToolbarName;
                if (props.api.internalApi.getModuleService().isAdapTableModulePresent(moduleToolbarName)) {
                    let moduleToolbarView = (0, $b1f453bcc52a26e6$export$c7001f4850704fce).get(moduleToolbarName);
                    if (moduleToolbarView) {
                        let moduleInfo = props.api.internalApi.getModuleService().getModuleInfoByModule(moduleToolbarName);
                        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                            key: moduleToolbarName,
                            className: `ab-Dashboard__container ab-Dashboard__container--${moduleToolbarName}`
                        }, $acw62.createElement((0, $cfffd85853650f1f$export$e6eb774ab541dc4a), {
                            moduleInfo: moduleInfo,
                            accessLevel: dashboardAccessLevel
                        }, $acw62.createElement((0, $b29040b92f77efb1$export$5650f07be39e091c), {
                            toolbarName: moduleToolbarName
                        })));
                    } else props.api.logError('Cannot find Dashboard Control for ' + visibleToolbarName);
                }
            }
        });
        return visibleDashboardElements;
    };
    const renderModuleButtons = ()=>{
        let shortcutsArray = props.DashboardState.ModuleButtons;
        let shortcuts = null;
        const alwaysShowInDashboard = props.api.optionsApi.getSettingsPanelOptions().alwaysShowInDashboard;
        const shouldAddSettingsPanel = alwaysShowInDashboard && !props.api.entitlementApi.isModuleHiddenEntitlement('SettingsPanel');
        if (shouldAddSettingsPanel && !shortcutsArray.includes('SettingsPanel')) shortcutsArray.push('SettingsPanel');
        if (shortcutsArray) shortcuts = shortcutsArray.map((x, index)=>{
            let menuItem = props.InternalState.Dashboard.DashboardModuleButtons.find((y)=>y.isVisible && y.category == x);
            if (menuItem) return $acw62.createElement((0, $4f56822e8a85bf43$export$51a0d41e070314af), {
                "data-name": `dashboard-module-button-${menuItem.category ?? 'custom-' + index}`,
                "aria-label": menuItem.label,
                key: menuItem.label,
                variant: menuItem.category === 'SystemStatus' ? 'outlined' : 'text',
                tone: menuItem.category === 'SystemStatus' ? 'neutral' : 'none',
                className: `ab-DashboardToolbar__Home__${(0, $9ce0650a2a8dba81$export$2e2bcd8739ae039)(menuItem.label)}`,
                icon: menuItem.icon,
                tooltip: menuItem.label,
                disabled: props.accessLevel == 'ReadOnly',
                onClick: ()=>props.dispatch(menuItem.reduxAction),
                accessLevel: 'Full',
                style: menuItem.category === 'SystemStatus' ? {
                    ...(0, $5aWMQ.default).getStyleForMessageType(props.api.systemStatusApi.getCurrentSystemStatusMessageInfo()?.statusType ?? 'Success'),
                    border: 0
                } : {}
            });
        });
        return shortcuts;
    };
    const renderDashboardButtons = ()=>{
        let dashboardButtonsArray = props.api.dashboardApi.getCustomDashboardButtons().filter(Boolean);
        let customDashboardButtons = null;
        if (dashboardButtonsArray?.length) customDashboardButtons = dashboardButtonsArray.map((button, index)=>$acw62.createElement((0, $befed6cae480e847$export$a4dddf174a944351), {
                key: `${button.label}-${index}`,
                button: button,
                api: props.api,
                accessLevel: props.accessLevel
            }));
        return customDashboardButtons;
    };
    const renderQuickSearch = ()=>{
        return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:ml-2"
        }, $acw62.createElement((0, $24eb18c810e68a5c$export$29e8bfda34c26ba7), {
            className: "ab-DashboardToolbar__QuickSearch__text",
            inputClassName: "twa:w-[7rem]"
        }));
    };
    let instanceName = props.api.internalApi.getToolbarTitle();
    let dashboardOptions = props.api.optionsApi.getDashboardOptions();
    const shouldRenderQuickSearchHeader = dashboardOptions.showQuickSearchInHeader && props.api.internalApi.getModuleService().isAdapTableModulePresent((0, $42e863194fcb493f$export$cf7621e489e71e3c));
    const applicationIcon = props.api.optionsApi.getUserInterfaceOptions().applicationIcon;
    if (props.DashboardState.IsHidden) return $acw62.createElement("div", null);
    return $acw62.createElement((0, $c4033ed4b9da2a4e$export$fe82a520fc33e5f4), {
        title: instanceName,
        canFloat: props.api.optionsApi.getDashboardOptions().canFloat,
        footer: $acw62.createElement((0, $ee2dd27766ed45cc$export$17c8f62c61769904), null),
        activeTabIndex: props.DashboardState.ActiveTabIndex,
        onActiveTabIndexChange: (ActiveTabIndex)=>{
            props.onSetActiveTabIndex(ActiveTabIndex);
        },
        collapsed: props.DashboardState.IsCollapsed,
        onCollapsedChange: (IsCollapsed)=>{
            props.onSetIsCollapsed(IsCollapsed);
        },
        floating: props.DashboardState.IsFloating,
        onFloatingChange: (IsFloating)=>{
            props.onSetIsFloating(IsFloating);
        },
        inline: props.DashboardState.IsInline,
        onInlineChange: (IsInline)=>{
            props.onSetIsInline(IsInline);
        },
        position: props.DashboardState.FloatingPosition,
        onPositionChange: (FloatingPositionCallback)=>{
            if (typeof FloatingPositionCallback === 'function') {
                const FloatingPosition = FloatingPositionCallback(props.DashboardState.FloatingPosition);
                props.onSetFloatingPosition(FloatingPosition);
            } else props.onSetFloatingPosition(FloatingPositionCallback);
        },
        left: $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
            icon: applicationIcon,
            iconClassName: "ab-Dashboard__application-icon"
        }), dashboardOptions.buttonsLocation === 'left' && renderModuleButtons(), dashboardOptions.buttonsLocation === 'left' && renderDashboardButtons()),
        right: $acw62.createElement($acw62.Fragment, null, dashboardOptions.buttonsLocation === 'right' && renderDashboardButtons(), dashboardOptions.buttonsLocation === 'right' && renderModuleButtons(), shouldRenderQuickSearchHeader && renderQuickSearch()),
        onShowDashboardPopup: props.onShowDashboardPopup
    }, props.DashboardState.Tabs && props.DashboardState.Tabs.map((tab, index)=>$acw62.createElement((0, $1227f9f058e0b3ba$export$da0841a0525c3b88), {
            key: index,
            title: tab.Name
        }, renderTab(tab))));
};
function $3aa02d34677ce5a7$var$mapStateToProps(state, ownProps) {
    return {
        DashboardRevision: state.Internal.Dashboard.DashboardRevision,
        DashboardState: state.Dashboard,
        InternalState: state.Internal,
        SystemStatusMessageInfos: state.Internal.SystemStatusMessages,
        QuickSearchText: state.QuickSearch.QuickSearchText
    };
}
function $3aa02d34677ce5a7$var$mapDispatchToProps(dispatch) {
    return {
        dispatch: (action)=>dispatch(action),
        onSetActiveTabIndex: (ActiveTabIndex)=>dispatch($dc6bc6f406d56c84$export$b0602226505423cf(ActiveTabIndex)),
        onSetIsCollapsed: (IsCollapsed)=>dispatch($dc6bc6f406d56c84$export$4a9fdbf5568e83b6(IsCollapsed)),
        onSetIsFloating: (IsFloating)=>dispatch($dc6bc6f406d56c84$export$d83abcde9deec805(IsFloating)),
        onSetFloatingPosition: (FloatingPosition)=>dispatch($dc6bc6f406d56c84$export$dfc443e4c0b6468d(FloatingPosition)),
        onRunQuickSearch: (newQuickSearchText)=>dispatch($a9684a89f07662ba$export$e6464f631b683a94(newQuickSearchText)),
        onShowQuickSearchPopup: ()=>dispatch($dc56b6267ce4d0bb$export$e2d5bba0b444685d($42e863194fcb493f$export$cf7621e489e71e3c, 'QuickSearchPopup')),
        onShowDashboardPopup: ()=>dispatch($dc56b6267ce4d0bb$export$e2d5bba0b444685d($42e863194fcb493f$export$b74b667f10548947, 'DashboardPopup'))
    };
}
let $3aa02d34677ce5a7$export$fe82a520fc33e5f4 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($3aa02d34677ce5a7$var$mapStateToProps, $3aa02d34677ce5a7$var$mapDispatchToProps)($3aa02d34677ce5a7$var$DashboardComponent);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $eeaae5b3d414be17$export$e6ff31bff12b7ff4 = (props)=>$acw62.createElement("svg", {
        width: "45",
        height: "45",
        viewBox: "0 0 45 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, $acw62.createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H12.6699V12.6H0V8Z",
        fill: "#004C79"
    }), $acw62.createElement("path", {
        d: "M16.165 0H36.9999C41.4182 0 45 3.58172 45 8V12.6H16.165V0Z",
        fill: "#004C79"
    }), $acw62.createElement("path", {
        d: "M0 32.4H28.8349V45H8C3.58173 45 0 41.4183 0 37V32.4Z",
        fill: "#004C79"
    }), $acw62.createElement("path", {
        d: "M32.3301 32.4H45V37C45 41.4183 41.4182 45 37 45H32.3301V32.4Z",
        fill: "#004C79"
    }), $acw62.createElement("rect", {
        x: "32.3301",
        y: "16.2001",
        width: "12.6699",
        height: "12.6",
        fill: "#004C79"
    }), $acw62.createElement("rect", {
        x: "16.165",
        y: "16.2001",
        width: "12.6699",
        height: "12.6",
        fill: "#00CAF2"
    }), $acw62.createElement("rect", {
        y: "16.2001",
        width: "12.6699",
        height: "12.6",
        fill: "#004C79"
    }));



const $3770be1d6f8540b9$var$o = {
    border: "1px solid var(--ab-color-error)",
    padding: "5px",
    fontWeight: 600,
    margin: "5px",
    fontSize: "14px",
    alignItems: "center",
    color: "var(--ab-color-text-on-defaultbackground)",
    background: "var(--ab-color-defaultbackground)"
}, $3770be1d6f8540b9$var$n = (e)=>{
    const t = [
        [
            "display",
            "none"
        ],
        [
            "opacity",
            "0"
        ],
        [
            "position",
            "absolute"
        ],
        [
            "position",
            "fixed"
        ],
        [
            "position",
            "relative"
        ],
        [
            "visibility",
            "hidden"
        ]
    ];
    for (const [r, o] of t)if (e.style[r] === o) return !1;
    return !0;
};
const $3770be1d6f8540b9$export$2e5283f6cc9fe520 = (i)=>{
    const l = $acw62.useRef(null);
    return $acw62.useEffect(()=>{
        const e = setInterval(()=>{
            l.current?.isConnected || alert("It is not allowed to remove the Adaptable watermark."), $3770be1d6f8540b9$var$n(l.current) || alert("It is not allowed to modify the Adaptable watermark."), l?.current?.style && (l.current.style.border = $3770be1d6f8540b9$var$o.border, l.current.style.padding = $3770be1d6f8540b9$var$o.padding, l.current.style.fontWeight = `${$3770be1d6f8540b9$var$o.fontWeight}`, l.current.style.margin = $3770be1d6f8540b9$var$o.margin, l.current.style.fontSize = $3770be1d6f8540b9$var$o.fontSize, l.current.style.color = $3770be1d6f8540b9$var$o.color, l.current.style.background = $3770be1d6f8540b9$var$o.background, l.current.style.display = "flex", l.current.style.position = "static", l.current.style.opacity = "1", l.current.style.visibility = "visible");
        }, 5e3);
        return ()=>clearTimeout(e);
    }, []), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        style: $3770be1d6f8540b9$var$o,
        ref: l
    }, $acw62.createElement((0, $eeaae5b3d414be17$export$e6ff31bff12b7ff4), {
        style: {
            marginRight: 10
        }
    }), $acw62.createElement("div", null, i.children));
};





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $614d478f87a7e8ee$export$4071300121a182f5 = (props)=>{
    const [isOpen, setIsOpen] = $acw62.useState(()=>{
        return props.open;
    });
    const [show, setShow] = $acw62.useState(props.open);
    $acw62.useEffect(()=>{
        // CLOSED -> OPEN
        // SHOW Element, with closed class
        // CHANGE class to opened
        if (!isOpen && props.open) {
            setShow(true);
            requestAnimationFrame(()=>{
                setIsOpen(true);
            });
        }
        // OPEN -> CLOSED
        // CHANGE class to closed
        // HIDE Element, when animation is finsihed
        if (isOpen && !props.open) setIsOpen(false);
    }, [
        props.open
    ]);
    const handleOnKeyDown = $acw62.useCallback((event)=>{
        // escape
        if (event.key === 'Escape') props.onOpenChange?.(false);
    }, []);
    const handletransitionEnd = ()=>{
        if (!isOpen) setShow(false);
    };
    if (!show) return null;
    const style = {
        position: 'fixed',
        top: 0,
        right: 0,
        zIndex: 1000,
        transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out'
    };
    if (isOpen) {
        style.transform = 'translateY(0)';
        style.opacity = 1;
    } else {
        style.transform = 'translateY(-120%)';
        style.opacity = 0;
    }
    return $acw62.createElement("div", {
        onKeyDown: handleOnKeyDown,
        style: style,
        onTransitionEnd: handletransitionEnd
    }, props.children);
};





const $c3840b6d120b6115$export$ae2efcb6f39a0c41 = ()=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const isOpen = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>(0, $5b564bb703f29152$export$df8b86410b5851e8)(state.Internal));
    return $acw62.createElement((0, $614d478f87a7e8ee$export$4071300121a182f5), {
        open: isOpen,
        onOpenChange: (open)=>{
            if (open) adaptable.api.quickSearchApi.showFloatingQuickSearch();
            else adaptable.api.quickSearchApi.hideFloatingQuickSearch();
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-FloatinQuickSearch ab-FloatingQuickSearch"
    }, $acw62.createElement((0, $24eb18c810e68a5c$export$29e8bfda34c26ba7), {
        autoFocus: true
    })));
};



class $13e96825b3d41372$var$AdaptableView extends $acw62.Component {
    render() {
        const watermark = this.props.AdaptableApi?.internalApi?.getInternalState()?.License?.watermark;
        const adaptableOptions = this.props.AdaptableApi.optionsApi.getAdaptableOptions();
        return $acw62.createElement("div", null, $acw62.createElement((0, $5f2e20103c93adcf$export$1f3861479a0f15f8), null), $acw62.createElement((0, $c3840b6d120b6115$export$ae2efcb6f39a0c41), null), this.props.AdaptableApi.internalApi.getModuleService().isAdapTableModulePresent('Dashboard') && $acw62.createElement((0, $3aa02d34677ce5a7$export$fe82a520fc33e5f4), {
            api: this.props.AdaptableApi
        }), this.props.PopupState.PromptPopup.ShowPromptPopup && $acw62.createElement((0, $f818488879d418e9$export$8206e3f21d354d8a), {
            message: this.props.PopupState.PromptPopup.Message,
            header: this.props.PopupState.PromptPopup.Header,
            onClose: this.props.onClosePromptPopup,
            onConfirm: this.props.onConfirmPromptPopup,
            onConfirmActionCreator: this.props.PopupState.PromptPopup.ConfirmActionCreator,
            defaultValue: this.props.PopupState.PromptPopup.DefaultValue
        }), Boolean(this.props.PopupState.ConfirmationPopup.ShowConfirmationPopup) && $acw62.createElement((0, $fd14cf9051666165$export$cb4a2bc9bfa29565), {
            header: this.props.PopupState.ConfirmationPopup.Header,
            messsage: this.props.PopupState.ConfirmationPopup.Msg,
            showPopup: this.props.PopupState.ConfirmationPopup.ShowConfirmationPopup,
            cancelButtonText: this.props.PopupState.ConfirmationPopup.CancelButtonText,
            confirmButtonText: this.props.PopupState.ConfirmationPopup.ConfirmButtonText,
            onCancel: this.props.onCancelConfirmationPopup,
            onConfirm: this.props.onConfirmConfirmationPopup,
            showInputBox: this.props.PopupState.ConfirmationPopup.ShowInputBox,
            messageType: this.props.PopupState.ConfirmationPopup.MessageType,
            api: this.props.AdaptableApi
        }), Boolean(this.props.PopupState.ScreenPopup.ShowScreenPopup) && $acw62.createElement((0, $6f2f5609ba5fa940$export$d1085bc8adf9a424), {
            componentName: this.props.PopupState.ScreenPopup.ComponentName,
            componentModule: this.props.PopupState.ScreenPopup.ComponentModule,
            onHide: this.props.onCloseScreenPopup,
            api: this.props.AdaptableApi,
            onClearParams: ()=>this.props.onClearPopupParams(),
            moduleParams: this.props.PopupState.ScreenPopup.Params,
            moduleProps: this.props.PopupState.ScreenPopup.PopupProps
        }), $acw62.createElement((0, $ad26fe773541dcd3$export$f2815235e76a62b9), {
            // Ensure to set containerId to avoid memory leaks when Adaptable instance is destroyed and re-created many times
            containerId: `Toastify-${adaptableOptions.adaptableId}`,
            limit: adaptableOptions.notificationsOptions.maxNotifications,
            closeButton: false,
            icon: false,
            theme: "colored"
        }), watermark?.show && $acw62.createElement((0, $3770be1d6f8540b9$export$2e5283f6cc9fe520), null, watermark?.text), $acw62.createElement((0, $90a81868d5ed90ff$export$7c6996a1f80fc67c), null), $acw62.createElement((0, $43fcf747f0d47c9a$export$7ee7a06e459d6ea4), null), $acw62.createElement((0, $fed4c3a6395001ce$export$2b776f7e7ee60dbd), null));
    }
}
function $13e96825b3d41372$var$mapStateToProps(state, ownProps) {
    return {
        PopupState: state.Popup,
        InternalState: state.Internal,
        AdaptableApi: ownProps.Adaptable.api
    };
}
function $13e96825b3d41372$var$mapDispatchToProps(dispatch) {
    return {
        onCloseScreenPopup: ()=>dispatch($dc56b6267ce4d0bb$export$b591761538bae019()),
        onClosePromptPopup: ()=>dispatch($dc56b6267ce4d0bb$export$7218cbaa092452b4()),
        onConfirmPromptPopup: (inputText)=>dispatch($dc56b6267ce4d0bb$export$83efedeed0717f26(inputText)),
        onConfirmConfirmationPopup: (comment)=>dispatch($dc56b6267ce4d0bb$export$1e1f0cada24ded37(comment)),
        onCancelConfirmationPopup: ()=>dispatch($dc56b6267ce4d0bb$export$4a108f1b63094f83()),
        showPopup: (componentModule, componentName, params)=>dispatch($dc56b6267ce4d0bb$export$e2d5bba0b444685d(componentModule, componentName, params)),
        onClearPopupParams: ()=>dispatch($dc56b6267ce4d0bb$export$da35e74a9cc56e38())
    };
}
let $13e96825b3d41372$var$AdaptableWrapper = (0, $55388fc2f116d4d7$export$64605811ab45167f)($13e96825b3d41372$var$mapStateToProps, $13e96825b3d41372$var$mapDispatchToProps)($13e96825b3d41372$var$AdaptableView);
const $13e96825b3d41372$export$f1b71ac9400d32a0 = ({ Adaptable: Adaptable })=>(0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)($acw62.createElement($13e96825b3d41372$var$AdaptableWrapper, {
        Adaptable: Adaptable
    }), Adaptable);


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


// we need to keep track of the roots to ensure we create a single root per container
// otherwise we get: "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
const $11cae39faa17d15e$var$renderWeakMap = new WeakMap();
const $11cae39faa17d15e$export$aec53ba866c983c7 = (el, container)=>{
    // Keeping a reference to previous roots causes an error.
    // Already (correctly) unmounted elements are not unmounted again, and triggers an error.
    let root = $11cae39faa17d15e$var$renderWeakMap.get(container);
    if (!root) $11cae39faa17d15e$var$renderWeakMap.set(container, root = $7e96a608cb33bf79$exports.createRoot(container));
    // const root = ReactDOMClient.createRoot(container);
    root.render(el);
    return ()=>{
        // requestAnimationFrame(() => {
        //   // This pervents this warning:
        //   // Warning: Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.
        //   // https:stackoverflow.com/questions/73459382/react-18-async-way-to-unmount-root
        // });
        // This needs to be synchronous, if not, in a raf it may be to late, the element may be gone.
        // To reproduce, move this in RAF and play with filters.
        root.unmount();
        $11cae39faa17d15e$var$renderWeakMap.delete(container);
    };
};


class $b8834b9ebb39e93d$export$35b551bc3dba5dab {
    adaptableInstance;
    gridOptionsPropertyCache;
    colDefPropertyCache;
    constructor(adaptableInstance){
        this.adaptableInstance = adaptableInstance;
        this.gridOptionsPropertyCache = new Map();
        this.colDefPropertyCache = new Map();
    }
    destroy() {
        this.gridOptionsPropertyCache.clear();
        this.colDefPropertyCache.clear();
        this.gridOptionsPropertyCache = null;
        this.colDefPropertyCache = null;
        this.adaptableInstance = null;
    }
    setGridOptionsProperty(gridOptions, propertyName, propertyGetter) {
        if (this.adaptableInstance.lifecycleState === 'preDestroyed') return;
        const userKey = `user.${propertyName}`;
        const adaptableKey = `adaptable.${propertyName}`;
        const value = gridOptions[propertyName];
        const isUserDefined = value !== this.gridOptionsPropertyCache.get(adaptableKey);
        if (isUserDefined) this.gridOptionsPropertyCache.set(userKey, value);
        const userValue = this.gridOptionsPropertyCache.get(userKey);
        let adaptableValue = propertyGetter(userValue);
        if (typeof adaptableValue === 'function') {
            const previousValue = adaptableValue;
            // @ts-ignore we know that adaptableValue is a function
            adaptableValue = (...args)=>{
                if (this.adaptableInstance.isDestroyed) return;
                this.agGridAdapter.grabAgGridApiOnTheFly(args);
                return previousValue(...args);
            };
        }
        if (adaptableValue != null) this.gridOptionsPropertyCache.set(adaptableKey, adaptableValue);
        gridOptions[propertyName] = adaptableValue ?? userValue;
        return gridOptions;
    }
    getUserGridOptionsProperty(propertyName) {
        const userKey = `user.${propertyName}`;
        return this.gridOptionsPropertyCache.get(userKey);
    }
    revertGridOptionsPropertyToUserValue(propertyName) {
        const userKey = `user.${propertyName}`;
        const userValue = this.gridOptionsPropertyCache.get(userKey);
        this.agGridAdapter.setGridOption(propertyName, userValue);
    }
    revertGridOptionsPropertiesToUserValue(gridOptions, propertyNames) {
        for (const propertyName of propertyNames){
            // see this.setGridOptionsProperty(...)
            const userKey = `user.${propertyName}`;
            const userValue = this.gridOptionsPropertyCache.get(userKey);
            gridOptions[propertyName] = userValue;
        }
    }
    get agGridAdapter() {
        return this.adaptableInstance.agGridAdapter;
    }
}







var $9OAZF = parcelRequire("9OAZF");



var $5aWMQ = parcelRequire("5aWMQ");


const $3206bef83a3aa737$export$42d85ff3a09ca2f2 = (styledColumn, abColumn, api)=>{
    if (!styledColumn.PercentBarStyle) return;
    return class PercentBarRenderer {
        eGui;
        init(params) {
            const min = api.styledColumnApi.internalApi.getNumericStyleMinValue(styledColumn, abColumn, params.node, params.value);
            const max = api.styledColumnApi.internalApi.getNumericStyleMaxValue(styledColumn, abColumn, params.node, params.value);
            let value = params.value;
            if ((0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).objectNotExists(value)) value = 0;
            // We no longer support showing Percent Bar in Group Rows as it only made sense for Min / Max
            if (api.gridApi.isGroupRowNode(params.node)) {
                if (params.value) {
                    this.eGui = document.createElement('div');
                    this.eGui.append(params.value);
                }
                return;
            }
            const percentBarStyle = styledColumn.PercentBarStyle;
            let percentageValue;
            let barWidthPercent;
            if (percentBarStyle.ColumnComparison) {
                // Finance convention: (difference / |base|) * 100 — signed %, use |price| when base is negative
                const absMax = Math.abs(max);
                percentageValue = absMax === 0 ? 0 : Number(value) / absMax * 100;
                // Bar width uses |percentage| so 50% and -50% have the same visual width
                barWidthPercent = Math.min(100, Math.abs(percentageValue));
            } else {
                const clampedValue = (0, $43438b6501a58e4a$export$2e2bcd8739ae039)(value, min, max);
                percentageValue = (clampedValue - min) / (max - min) * 100;
                barWidthPercent = percentageValue;
            }
            let cellBackColor;
            if (percentBarStyle.ColumnComparison) cellBackColor = percentBarStyle.ColumnComparison.Color;
            else {
                const matchingRange = api.styledColumnApi.internalApi.findRangeForColumn(percentBarStyle.CellRanges, abColumn, percentBarStyle.RangeValueType, params.value);
                if (matchingRange) cellBackColor = matchingRange.Color;
            }
            const hasCellText = percentBarStyle.CellText && percentBarStyle.CellText.length > 0;
            const isTextPositionMerged = percentBarStyle.CellTextPosition === 'Merged';
            if (cellBackColor) {
                this.eGui = document.createElement('div');
                this.eGui.className = 'ab-PercentBar__wrapper';
                this.eGui.style.height = hasCellText && !isTextPositionMerged ? '80%' : '100%';
                this.eGui.style.display = 'flex';
                this.eGui.style.flexDirection = 'column';
                this.eGui.style.justifyContent = 'center';
                const barEl = document.createElement('div');
                barEl.className = 'ab-PercentBar__bar';
                barEl.style.position = 'relative';
                barEl.style.background = percentBarStyle.BackColor;
                barEl.style.flex = '1';
                const barInsideEl = document.createElement('div');
                barInsideEl.className = 'ab-PercentBar__barInside';
                barInsideEl.style.background = cellBackColor;
                barInsideEl.style.height = '100%';
                barInsideEl.style.width = `${barWidthPercent.toFixed(0)}%`;
                barEl.append(barInsideEl);
                this.eGui.append(barEl);
                if (hasCellText) {
                    const textEl = document.createElement('div');
                    textEl.className = 'ab-PercentBar__text';
                    textEl.style.lineHeight = '1.2';
                    if (percentBarStyle.CellText.includes('CellValue')) textEl.innerText = params.formatValue?.(params.value) ?? params.value;
                    if (percentBarStyle.CellText.includes('PercentageValue')) textEl.innerText += ' ' + `${percentageValue.toFixed(0)}%`;
                    switch(percentBarStyle.CellTextPosition){
                        case 'Above':
                            this.eGui.prepend(textEl);
                            break;
                        case 'Below':
                            this.eGui.append(textEl);
                            break;
                        case 'Merged':
                            textEl.style.position = 'absolute';
                            // This allows to center verticly without knowing the height of the row
                            textEl.style.top = '50%';
                            textEl.style.transform = 'translateY(-50%)';
                            // adds a bit of padding to the start/end of the bar
                            textEl.style.left = '0';
                            textEl.style.right = '0';
                            textEl.style.paddingLeft = '5px';
                            textEl.style.paddingRight = '5px';
                            barEl.append(textEl);
                            break;
                        default:
                            this.eGui.append(textEl);
                            break;
                    }
                }
            }
        }
        getGui() {
            return this.eGui;
        }
        refresh(params) {
            // by returning FALSE we force a re-render every time the cell value changes
            return false;
        }
    };
};





var $acw62 = parcelRequire("acw62");
const $7707ebad78b35e4b$export$4dbc5fcac3c87889 = (badgeStyle, abColumn, api)=>{
    return class BadgetRenderer {
        eGui;
        unmountReactRoot;
        getAdaptableInstance(params) {
            const adaptable = params.context.__adaptable;
            return adaptable;
        }
        init(params) {
            const adaptable = this.getAdaptableInstance(params);
            const adaptableApi = adaptable.api;
            this.eGui = document.createElement('div');
            this.eGui.className = 'ab-Badge__wrapper';
            const isGroupedRow = params.node.group;
            const isSummaryRow = adaptableApi.gridApi.isSummaryNode(params.node);
            const isGrandTotalRowNode = adaptableApi.gridApi.isGrandTotalRowNode(params.node);
            let shouldRender = true;
            if (isGrandTotalRowNode) {
                if (badgeStyle.RowScope?.ExcludeTotalRows) shouldRender = false;
            } else if (isGroupedRow) {
                if (badgeStyle.RowScope?.ExcludeGroupRows) shouldRender = false;
            } else if (isSummaryRow) {
                if (badgeStyle.RowScope?.ExcludeSummaryRows) shouldRender = false;
            } else if (badgeStyle.RowScope?.ExcludeDataRows) shouldRender = false;
            if (!shouldRender) {
                const formattedValue = params.formatValue?.(params.value) ?? params.value ?? '';
                this.eGui.innerHTML = formattedValue;
                return;
            }
            const arrayTypes = [
                'numberArray',
                'textArray'
            ];
            if (arrayTypes.includes(abColumn.dataType)) this.renderArrayValues(params, adaptableApi);
            else this.renderSingularValues(params, adaptableApi);
        }
        renderArrayValues(params, adaptableApi) {
            let badgesConfig = [];
            if (!Array.isArray(params.value) || params.value.length === 0) {
                const formattedValue = params.formatValue?.(params.value) ?? params.value ?? '';
                this.eGui.innerHTML = formattedValue;
                return;
            }
            for (const value of params.value){
                const predicateDefHandlerContext = {
                    value: value,
                    rawValue: value,
                    oldValue: null,
                    displayValue: params.formatValue,
                    node: params.node,
                    column: abColumn,
                    ...adaptableApi.internalApi.buildBaseContext()
                };
                const badge = api.styledColumnApi.internalApi.getApplicableBadge(badgeStyle, predicateDefHandlerContext);
                const formattedValue = badge?.IconOnly ? '' : params.formatValue?.(value) ?? value ?? '';
                const isNullValue = formattedValue === '' || formattedValue === null || formattedValue === undefined;
                if (!isNullValue) {
                    const config = {
                        value: formattedValue
                    };
                    if (badge) config.badge = badge;
                    badgesConfig.push(config);
                }
            }
            this.renderBadges(badgesConfig, api, params);
        }
        renderSingularValues(params, adaptableApi) {
            let formattedValue = params.formatValue?.(params.value) ?? params.value ?? '';
            const predicateDefHandlerContext = {
                value: params.value,
                rawValue: params.value,
                oldValue: null,
                displayValue: params.formatValue,
                node: params.node,
                column: abColumn,
                ...adaptableApi.internalApi.buildBaseContext()
            };
            const badge = api.styledColumnApi.internalApi.getApplicableBadge(badgeStyle, predicateDefHandlerContext);
            const isNullValue = formattedValue === '' || formattedValue === null || formattedValue === undefined;
            // Return if empty values or no badge
            if (isNullValue || !badge) {
                this.eGui.innerHTML = formattedValue;
                return;
            }
            if (badge.IconOnly) formattedValue = '';
            this.renderBadges([
                {
                    badge: badge,
                    value: formattedValue
                }
            ], api, params);
        }
        renderBadges(config, api, params) {
            const adaptable = this.getAdaptableInstance(params);
            const badges = config.map(({ badge: badge, value: value }, index)=>{
                if (!badge) return $acw62.createElement('span', {
                    key: index,
                    className: 'ab-Badge ab-Badge__unstyled',
                    children: value
                });
                return $acw62.createElement((0, $8cca042f7654f935$export$37acb3580601e69a), {
                    key: index,
                    adaptableStyle: badge.Style,
                    children: value,
                    icon: badge.Icon,
                    iconPosition: badge.IconPosition ?? 'start',
                    gap: 5
                });
            });
            this.unmountReactRoot = api.internalApi.getAdaptableInstance().renderReactRoot((0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)($acw62.createElement($acw62.Fragment, {
                children: badges
            }), adaptable), this.eGui);
        }
        getGui() {
            return this.eGui;
        }
        destroy() {
            this.unmountReactRoot?.();
        }
        refresh(params) {
            // by returning FALSE we force a re-render every time the cell value changes
            return false;
        }
    };
};






/**
* Copyright (c) 2024, Leon Sorokin
* All rights reserved. (MIT Licensed)
*
* uDSV.js
* A small, fast CSV parser
* https://github.com/leeoniya/uDSV (v0.6.0)
*/ const $6f728bbff4ab11ac$var$comma = ',';
const $6f728bbff4ab11ac$var$quote = '"';
const $6f728bbff4ab11ac$var$tab = '\t';
const $6f728bbff4ab11ac$var$pipe = '|';
const $6f728bbff4ab11ac$var$semi = ';';
const $6f728bbff4ab11ac$var$ISO8601 = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d{3,})?(?:Z|[-+]\d{2}:?\d{2}))?$/;
const $6f728bbff4ab11ac$var$BOOL_RE = /^(?:t(?:rue)?|f(?:alse)?|y(?:es)?|n(?:o)?|0|1)$/i;
const $6f728bbff4ab11ac$var$COL_DELIMS = [
    $6f728bbff4ab11ac$var$tab,
    $6f728bbff4ab11ac$var$pipe,
    $6f728bbff4ab11ac$var$semi,
    $6f728bbff4ab11ac$var$comma
];
const $6f728bbff4ab11ac$var$CHUNK_SIZE = 1e3;
function $6f728bbff4ab11ac$var$boolTrue(v) {
    let [c0, c1 = ''] = v;
    return c0 == '1' || c0 == '0' ? '1' : c0 == 't' || c0 == 'f' ? c1 == '' ? 't' : 'true' : c0 == 'T' || c0 == 'F' ? c1 == '' ? 'T' : c1 == 'R' || c1 === 'A' ? 'TRUE' : 'True' : c0 == 'y' || c0 == 'n' ? c1 == '' ? 'y' : 'yes' : c0 == 'Y' || c0 == 'N' ? c1 == '' ? 'Y' : c1 == 'E' || c1 === 'O' ? 'YES' : 'Yes' : '';
}
function $6f728bbff4ab11ac$var$isJSON(v) {
    if (v[0] === '[' || v[0] === '{') try {
        JSON.parse(v);
        return true;
    } catch  {}
    return false;
}
const $6f728bbff4ab11ac$var$T_STRING = 's';
const $6f728bbff4ab11ac$var$T_DATE = 'd';
const $6f728bbff4ab11ac$var$T_NUMBER = 'n';
const $6f728bbff4ab11ac$var$T_JSON = 'j';
const $6f728bbff4ab11ac$var$T_BOOLEAN = 'b';
function $6f728bbff4ab11ac$var$guessType(ci, rows) {
    // row with a value to analyze
    let row = rows.findLast((r)=>r[ci] !== '' && r[ci] !== 'null' && r[ci] !== 'NULL' && r[ci] !== 'NaN');
    let t = $6f728bbff4ab11ac$var$T_STRING;
    if (row != null) {
        let v = row[ci];
        t = $6f728bbff4ab11ac$var$ISO8601.test(v) ? $6f728bbff4ab11ac$var$T_DATE : +v === +v ? $6f728bbff4ab11ac$var$T_NUMBER : $6f728bbff4ab11ac$var$BOOL_RE.test(v) ? $6f728bbff4ab11ac$var$T_BOOLEAN + ':' + $6f728bbff4ab11ac$var$boolTrue(v) : $6f728bbff4ab11ac$var$isJSON(v) ? $6f728bbff4ab11ac$var$T_JSON : t;
    }
    return t;
}
const $6f728bbff4ab11ac$var$toJSON = JSON.stringify;
const $6f728bbff4ab11ac$var$onlyStrEsc = (v)=>typeof v === 'string' ? $6f728bbff4ab11ac$var$toJSON(v) : v;
function $6f728bbff4ab11ac$var$getValParseExpr(ci, col) {
    let { type: type } = col;
    let rv = `r[${ci}]`;
    let parseExpr = type === $6f728bbff4ab11ac$var$T_DATE ? `new Date(${rv})` : type === $6f728bbff4ab11ac$var$T_JSON ? `JSON.parse(${rv})` : type === $6f728bbff4ab11ac$var$T_NUMBER ? `+${rv}` : type[0] === $6f728bbff4ab11ac$var$T_BOOLEAN ? `${rv} === ${$6f728bbff4ab11ac$var$toJSON(type.slice(2))} ? true : false` : rv;
    let { repl: repl } = col;
    let nanExpr = repl.NaN !== void 0 && type === $6f728bbff4ab11ac$var$T_NUMBER ? `${rv} === 'NaN' ? ${$6f728bbff4ab11ac$var$onlyStrEsc(repl.NaN)} : ` : '';
    let nullExpr = repl.null !== void 0 ? `${rv} === 'null' || ${rv} === 'NULL' ? ${$6f728bbff4ab11ac$var$onlyStrEsc(repl.null)} : ` : '';
    let emptyExpr = repl.empty !== void 0 ? `${rv} === '' ? ${$6f728bbff4ab11ac$var$onlyStrEsc(repl.empty)} : ` : '';
    return `${emptyExpr} ${nullExpr} ${nanExpr} ${parseExpr}`;
}
const $6f728bbff4ab11ac$var$segsRe = /\w+(?:\[|\]?[\.\[]?|$)/gm;
function $6f728bbff4ab11ac$var$genToTypedRows(cols, objs = false, deep = false) {
    let buf = '';
    if (objs && deep) {
        let tplObj = {};
        let colIdx = 0;
        let paths = cols.map((c)=>c.name.replace(/\.(\d+)\.?/gi, '[$1]'));
        do {
            let path = paths.shift();
            let segs = /\s/.test(path) ? [
                path
            ] : [
                ...path.matchAll($6f728bbff4ab11ac$var$segsRe)
            ].flatMap((m)=>m.map((m)=>m.replace(']', '')));
            let node = tplObj;
            do {
                let seg = segs.shift();
                let key = seg;
                let endChar = seg.at(-1);
                let hasKids = endChar == '.' || endChar == '[';
                if (hasKids) {
                    key = seg.slice(0, -1);
                    let nextNode = node[key] ?? (endChar == '.' ? {} : []);
                    node = node[key] = nextNode;
                } else node[key] = `\xa6${colIdx}\xa6`;
            }while (segs.length > 0);
            colIdx++;
        }while (paths.length > 0);
        buf = $6f728bbff4ab11ac$var$toJSON(tplObj).replace(/"¦(\d+)¦"/g, (m, ci)=>$6f728bbff4ab11ac$var$getValParseExpr(+ci, cols[+ci]));
    } else if (!objs && cols.every((c)=>c.type === $6f728bbff4ab11ac$var$T_STRING)) buf = 'r';
    else {
        buf = objs ? '{' : '[';
        cols.forEach((col, ci)=>{
            buf += objs ? `${$6f728bbff4ab11ac$var$toJSON(col.name)}:` : '';
            let parseVal = $6f728bbff4ab11ac$var$getValParseExpr(ci, col);
            buf += `${parseVal},`;
        });
        buf += objs ? '}' : ']';
    }
    let fnBody = `
		let arr = Array(rows.length);

		for (let i = 0; i < rows.length; i++) {
			let r = rows[i];
			arr[i] = ${buf};
		}

		return arr;
	`;
    let toObjFn = new Function('rows', fnBody);
    // console.log(fnBody);
    // console.log(toObjFn(chunk.slice(1, 5)));
    // process.exit();
    return toObjFn;
}
function $6f728bbff4ab11ac$var$genToCols(cols) {
    return new Function('rows', `
		let cols = [${cols.map(()=>`Array(rows.length)`).join(',')}];

		for (let i = 0; i < rows.length; i++) {
			let r = rows[i];
			${cols.map((c, i)=>`cols[${i}][i] = r[${i}]`).join(';')};
		}

		return cols;
	`);
}
// https://www.loc.gov/preservation/digital/formats/fdd/fdd000323.shtml
function $6f728bbff4ab11ac$export$1f42f54c9496a87f(csvStr, opts, maxRows) {
    let { header: headerFn, col: colDelim, row: rowDelim, encl: colEncl, esc: escEncl, trim: //	omit,  // #comments and empty lines (ignore:), needs callback for empty and comments?
    trim = false } = opts ?? {};
    // by default, grab first row, and skip it
    headerFn ??= (firstRows)=>[
            firstRows[0]
        ];
    maxRows ??= 10;
    // will fail if header contains line breaks in quoted value
    // will fail if single line without line breaks
    const rowRE = new RegExp(`(.*)(${rowDelim ?? '\r\n|\r|\n'})`);
    const firstRowMatch = csvStr.match(rowRE);
    const firstRowStr = firstRowMatch[1];
    rowDelim ??= firstRowMatch[2];
    colDelim ??= $6f728bbff4ab11ac$var$COL_DELIMS.find((delim)=>firstRowStr.indexOf(delim) > -1) ?? $6f728bbff4ab11ac$var$comma;
    const schema = {
        skip: 1,
        col: colDelim,
        row: rowDelim,
        encl: colEncl,
        esc: escEncl,
        trim: trim,
        cols: []
    };
    const _maxCols = firstRowStr.split(colDelim).length;
    const firstRows = [];
    $6f728bbff4ab11ac$var$parse(csvStr, schema, (chunk)=>{
        firstRows.push(...chunk);
    }, 0, true, maxRows, 1, _maxCols);
    let headerRows = headerFn(firstRows) ?? [];
    let skip = schema.skip = headerRows.length;
    // first non-null row
    let colNames = headerRows.find((row)=>row != null) ?? [
        ...Array(firstRows[0].length).keys()
    ];
    firstRows.splice(0, skip);
    colNames.forEach((colName, colIdx)=>{
        let type = $6f728bbff4ab11ac$var$guessType(colIdx, firstRows);
        let col = {
            name: colName,
            type: type,
            // this could be type-dependant (e.g. {empty: 0, null: 0, NaN: NaN} for numbers)
            repl: {
                empty: null,
                NaN: void 0,
                null: void 0
            }
        };
        schema.cols.push(col);
    });
    return schema;
}
function $6f728bbff4ab11ac$export$84bb9899435eeb61(schema, chunkSize) {
    let { skip: skip, cols: cols } = schema;
    let _toStrs = null;
    let _toArrs = null;
    let _toObjs = null;
    let _toDeep = null;
    let _toObjsS = null;
    let _toCols = null;
    let streamChunkNum = 0;
    let streamState = 0;
    let streamParse = null;
    let streamCb = null;
    let pendChunk = '';
    let prevUnparsed = '';
    let buf = null;
    function reset() {
        streamState = streamChunkNum = 0;
        prevUnparsed = pendChunk = '';
        streamParse = streamCb = buf = null;
    }
    let accum = (rows, add)=>{
        add(rows);
    };
    let initRows = ()=>[];
    let initCols = ()=>cols.map((c)=>[]);
    let addRows = (rows)=>{
        buf.push(...rows);
    };
    let addCols = (cols)=>{
        cols.forEach((vals, ci)=>{
            buf[ci].push(...vals);
        });
    };
    function gen(accInit, accAppend, genConvertRows) {
        let convertRows = null;
        return (csvStr, cb = accum)=>{
            convertRows ??= genConvertRows();
            buf ??= accInit();
            let out = buf;
            let withEOF = streamState === 0 || streamState === 2;
            let _skip = streamChunkNum === 0 ? skip : 0;
            $6f728bbff4ab11ac$var$parse(csvStr, schema, (rows, partial)=>{
                prevUnparsed = partial;
                let res = cb(convertRows(rows), accAppend);
                if (res === false && streamState !== 0) reset();
                return res;
            }, _skip, withEOF, chunkSize);
            if (withEOF) buf = null;
            return out;
        };
    }
    const stringArrs = gen(initRows, addRows, ()=>{
        _toStrs ??= (rows)=>rows;
        return _toStrs;
    });
    const stringObjs = gen(initRows, addRows, ()=>{
        _toObjsS ??= $6f728bbff4ab11ac$var$genToTypedRows(cols.map((col)=>({
                ...col,
                type: 's',
                repl: {
                    ...col.repl,
                    empty: void 0
                }
            })), true, false);
        return _toObjsS;
    });
    const typedArrs = gen(initRows, addRows, ()=>{
        _toArrs ??= $6f728bbff4ab11ac$var$genToTypedRows(cols, false, false);
        return _toArrs;
    });
    const typedObjs = gen(initRows, addRows, ()=>{
        _toObjs ??= $6f728bbff4ab11ac$var$genToTypedRows(cols, true, false);
        return _toObjs;
    });
    const typedDeep = gen(initRows, addRows, ()=>{
        _toDeep ??= $6f728bbff4ab11ac$var$genToTypedRows(cols, true, true);
        return _toDeep;
    });
    const typedCols = gen(initCols, addCols, ()=>{
        _toArrs ??= $6f728bbff4ab11ac$var$genToTypedRows(cols, false, false);
        _toCols ??= $6f728bbff4ab11ac$var$genToCols(cols);
        return (rows)=>_toCols(_toArrs(rows));
    });
    return {
        schema: schema,
        stringArrs: stringArrs,
        stringObjs: stringObjs,
        typedArrs: typedArrs,
        typedObjs: typedObjs,
        typedDeep: typedDeep,
        typedCols: typedCols,
        chunk (csvStr, parse = stringArrs, cb = accum) {
            streamParse ??= parse;
            streamCb ??= cb;
            if (streamState === 1) {
                streamParse(prevUnparsed + pendChunk, streamCb);
                streamChunkNum++;
            }
            pendChunk = csvStr;
            streamState = 1;
        },
        end () {
            streamState = 2;
            let out = streamParse(prevUnparsed + pendChunk, streamCb);
            reset();
            return out;
        }
    };
}
function $6f728bbff4ab11ac$var$parse(csvStr, schema, cb, skip = 0, withEOF = true, chunkSize = $6f728bbff4ab11ac$var$CHUNK_SIZE, chunkLimit = null, _maxCols = null) {
    let { row: rowDelim, col: colDelim, encl: colEncl, esc: escEncl, trim: trim } = schema;
    colEncl ??= csvStr.indexOf($6f728bbff4ab11ac$var$quote) > -1 ? $6f728bbff4ab11ac$var$quote : ''; // TODO: detect single quotes?
    escEncl ??= colEncl;
    let replEsc = `${escEncl}${colEncl}`;
    let numCols = _maxCols || schema.cols.length;
    let _limit = chunkLimit != null;
    // uses a slower regexp path for schema probing
    let _probe = _maxCols != null && _limit;
    let rowDelimLen = rowDelim.length;
    let colDelimLen = colDelim.length;
    let colEnclChar = colEncl.charCodeAt(0);
    let escEnclChar = escEncl.charCodeAt(0);
    let rowDelimChar = rowDelim.charCodeAt(0);
    let colDelimChar = colDelim.charCodeAt(0);
    let spaceChar = 32;
    let numChunks = 0;
    let pos = 0;
    let endPos = csvStr.length - 1;
    let linePos = 0;
    let rows = [];
    let rowTpl = Array(numCols).fill('');
    let row = rowTpl.slice();
    let colIdx = 0;
    let lastColIdx = numCols - 1;
    let filledColIdx = -1;
    if (colEncl === '') {
        while(pos <= endPos){
            if (colIdx === lastColIdx) {
                let pos2 = csvStr.indexOf(rowDelim, pos);
                if (pos2 === -1) {
                    if (!withEOF) break;
                    pos2 = endPos + 1;
                }
                let s = csvStr.slice(pos, pos2);
                row[colIdx] = trim ? s.trim() : s;
                --skip < 0 && rows.push(row);
                if (rows.length === chunkSize) {
                    let stop = cb(rows, '') === false;
                    rows = [];
                    if (stop || _limit && ++numChunks === chunkLimit) return;
                }
                row = rowTpl.slice();
                colIdx = 0;
                filledColIdx = -1;
                pos = pos2 + rowDelimLen;
                linePos = pos;
            } else // empty line
            if (colIdx === 0 && csvStr.charCodeAt(pos) === rowDelimChar) pos += rowDelimLen;
            else {
                let pos2 = csvStr.indexOf(colDelim, pos);
                if (pos2 === -1) {
                    if (!withEOF) break;
                }
                let s = csvStr.slice(pos, pos2);
                row[colIdx] = trim ? s.trim() : s;
                pos = pos2 + colDelimLen;
                filledColIdx = colIdx++;
            }
        }
        if (withEOF && colIdx === lastColIdx && filledColIdx > -1) --skip < 0 && rows.push(row);
        if (!withEOF || rows.length > 0) cb(rows, !withEOF ? csvStr.slice(linePos) : '');
        return;
    }
    // should this be * to handle ,, ?
    const takeToCommaOrEOL = _probe ? new RegExp(`[^${colDelim}${rowDelim}]+`, 'my') : null;
    // 0 = no
    // 1 = unquoted
    // 2 = quoted
    let inCol = 0;
    let v = '';
    let c = 0;
    let pos0 = pos;
    while(pos <= endPos){
        c = csvStr.charCodeAt(pos);
        if (inCol === 0) {
            if (c === colEnclChar) {
                inCol = 2;
                pos += 1;
                pos0 = pos;
                if (pos > endPos) break;
                c = csvStr.charCodeAt(pos);
            } else if (c === colDelimChar || c === rowDelimChar) {
                // PUSH MACRO START
                if (c === rowDelimChar && colIdx === 0) {
                    pos += rowDelimLen;
                    continue;
                }
                row[colIdx] = v;
                filledColIdx = colIdx;
                colIdx += 1;
                pos += 1;
                v = '';
                if (c === rowDelimChar) {
                    if (_probe && filledColIdx < lastColIdx && rows.length === 0) {
                        row.length = rowTpl.length = filledColIdx + 1;
                        lastColIdx = filledColIdx;
                    }
                    --skip < 0 && rows.push(row);
                    if (rows.length === chunkSize) {
                        let stop = cb(rows, '') === false;
                        rows = [];
                        if (stop || _limit && ++numChunks === chunkLimit) return;
                    }
                    row = rowTpl.slice();
                    colIdx = 0;
                    filledColIdx = -1;
                    pos += rowDelimLen - 1;
                    linePos = pos;
                }
                // PUSH MACRO END
                if (pos > endPos) break;
            } else {
                if (trim && c === spaceChar) while(c === spaceChar)c = csvStr.charCodeAt(++pos);
                else inCol = 1;
            }
        }
        if (inCol === 2) {
            let shouldRep = false;
            let posTo = 0;
            while(true)if (c === colEnclChar) {
                if (colEnclChar === escEnclChar) {
                    if (pos + 1 > endPos) {
                        posTo = pos;
                        pos = endPos + 1;
                        break;
                    }
                    let cNext = csvStr.charCodeAt(pos + 1);
                    if (cNext === colEnclChar) {
                        pos += 2;
                        // MACRO START
                        shouldRep = true;
                        if (pos > endPos) break;
                        c = csvStr.charCodeAt(pos);
                    // MACRO END
                    } else {
                        inCol = 0;
                        posTo = pos;
                        pos += 1;
                        break;
                    }
                } else {
                    let cPrev = csvStr.charCodeAt(pos - 1);
                    if (cPrev === escEnclChar) {
                        pos += 1;
                        // MACRO START
                        shouldRep = true;
                        if (pos > endPos) break;
                        c = csvStr.charCodeAt(pos);
                    // MACRO END
                    } else {
                        inCol = 0;
                        posTo = pos;
                        pos += 1;
                        break;
                    }
                }
            } else {
                let pos2 = csvStr.indexOf(colEncl, pos);
                if (pos2 === -1) {
                    pos = endPos + 1;
                    break;
                }
                pos = pos2;
                c = colEnclChar;
            }
            if (inCol === 0 || pos > endPos) v = shouldRep ? csvStr.slice(pos0, posTo).replaceAll(replEsc, colEncl) : csvStr.slice(pos0, posTo);
        } else if (inCol === 1) {
            if (c === colDelimChar || c === rowDelimChar) {
                // PUSH MACRO START
                if (c === rowDelimChar && colIdx === 0) {
                    pos += rowDelimLen;
                    continue;
                }
                row[colIdx] = v;
                filledColIdx = colIdx;
                colIdx += 1;
                pos += 1;
                v = '';
                if (c === rowDelimChar) {
                    if (_probe && filledColIdx < lastColIdx && rows.length === 0) {
                        row.length = rowTpl.length = filledColIdx + 1;
                        lastColIdx = filledColIdx;
                    }
                    --skip < 0 && rows.push(row);
                    if (rows.length === chunkSize) {
                        let stop = cb(rows, '') === false;
                        rows = [];
                        if (stop || _limit && ++numChunks === chunkLimit) return;
                    }
                    row = rowTpl.slice();
                    colIdx = 0;
                    filledColIdx = -1;
                    pos += rowDelimLen - 1;
                    linePos = pos;
                }
                // PUSH MACRO END
                inCol = 0;
            } else if (_probe) {
                takeToCommaOrEOL.lastIndex = pos;
                let m = takeToCommaOrEOL.exec(csvStr)[0];
                v = m;
                pos += m.length; // rowdelim when - 1
            } else {
                let pos2 = csvStr.indexOf(colIdx === lastColIdx ? rowDelim : colDelim, pos);
                if (pos2 === -1) pos2 = endPos + 1;
                let s = csvStr.slice(pos, pos2);
                v = trim ? s.trim() : s;
                pos = pos2;
            }
        }
    }
    if (withEOF && colIdx === lastColIdx) {
        row[colIdx] = v;
        --skip < 0 && rows.push(row);
        inCol = 0;
    }
    let partial = !withEOF && (inCol !== 0 || (filledColIdx === -1 ? v !== '' : filledColIdx < lastColIdx // not all cols filled
    ));
    cb(rows, partial ? csvStr.slice(linePos) : '');
}






var $9OAZF = parcelRequire("9OAZF");


// waits for the given ms milliseconds
function $35ee3d9a93769da8$export$89c19add7950a19d(ms) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
        }, ms);
    });
}


class $160c6fe5c8b728e7$export$d17645576d7c2129 {
    _adaptableInstance;
    /**
     * !!!
     * do NOT mutate this array reference, this is passed only initially to AG Grid and we can only change it's internal state
     */ DANGER_excelStyles = [];
    originalExcelStyles = [];
    excelStylesCache = {};
    cellOrHeaderClassKey2ExcelStyleIdMap = {};
    excelStylesWithFormattedDate = {};
    constructor(_adaptableInstance){
        this._adaptableInstance = _adaptableInstance;
    }
    get agGridApi() {
        return this._adaptableInstance.agGridAdapter.getAgGridApi();
    }
    get adaptableApi() {
        return this._adaptableInstance.api;
    }
    get exportOptions() {
        return this._adaptableInstance.api.optionsApi.getExportOptions();
    }
    get logger() {
        return this._adaptableInstance.logger;
    }
    static getExcelClassNameForCell(colId, primaryKeyValue, userDefinedCellClass) {
        let excelClassName = `--excel-cell-${colId}-${primaryKeyValue}`;
        if (excelClassName.indexOf(' ') > 0) excelClassName = excelClassName.replace(/\s/g, '_');
        return userDefinedCellClass != null ? `${excelClassName}-${Array.isArray(userDefinedCellClass) ? userDefinedCellClass.join('-') : userDefinedCellClass}` : excelClassName;
    }
    static getExcelClassNameForHeader(colId, userDefinedHeaderClass) {
        let excelClassName = `--excel-header-${colId}`;
        if (excelClassName.indexOf(' ') > 0) excelClassName = excelClassName.replace(/\s/g, '_');
        return userDefinedHeaderClass != null ? `${excelClassName}-${Array.isArray(userDefinedHeaderClass) ? userDefinedHeaderClass.join('-') : userDefinedHeaderClass}` : excelClassName;
    }
    destroy() {
        this.excelStylesCache = null;
        this.cellOrHeaderClassKey2ExcelStyleIdMap = null;
        this.excelStylesWithFormattedDate = null;
    }
    async exportData(config) {
        const { report: report, format: format, showProgressIndicator: showProgressIndicator } = config;
        let excelStylesWerePatched = false;
        try {
            if (showProgressIndicator) {
                this.adaptableApi.userInterfaceApi.showProgressIndicator({
                    text: `Exporting ${report.Name}...`
                });
                // waitForTimeout required to give the ProgressIndicator rendering a head-start (see rAF in ProgressIndicator implementation)
                // see #raf_progress_indicator
                await (0, $35ee3d9a93769da8$export$89c19add7950a19d)(16);
            }
            this.adaptableApi.exportApi.internalApi.setExportInProgress(config.report.Name, config.format, config.destination);
            const exportProcessData = this.buildExportProcessData(config);
            const { exportContext: exportContext, exportParams: exportParams } = exportProcessData;
            if (this.adaptableApi.layoutApi.isCurrentLayoutPivot() && config.report.ReportRowScope === 'AllRows') // if in pivot mode but the user wants to export all rows (aka the table row data), we cannot use AG Grids row model
            // we have to use an intermediary transient AG Grid instance
            return this.adaptableApi.exportApi.internalApi.exportAllDataInPivotMode(exportProcessData);
            if (exportContext.isVisualExcelReport) {
                // FIXME AFL patch styles only for exported columns!
                // or even better, only cells
                this.patchExcelStyles(exportContext);
                excelStylesWerePatched = true;
            }
            // see #export_data_synchronously
            // 1. easiest case, we download the file using AG Grid
            // these methods will automatically handle the file download
            if (exportContext.destination === 'Download' && exportContext.isExcelReport) {
                this.agGridApi.exportDataAsExcel(exportParams);
                return;
            }
            if (exportContext.destination === 'Download' && format === 'CSV') {
                this.agGridApi.exportDataAsCsv(exportParams);
                return;
            }
            // 2. we have to handle the export ourselves
            // we get the report data and return it, so that the caller can handle it
            if (exportContext.isExcelReport) return {
                type: 'excel',
                data: this.agGridApi.getDataAsExcel(exportParams)
            };
            const csvReportData = this.agGridApi.getDataAsCsv(exportParams);
            if (exportContext.format === 'CSV') return {
                type: 'csv',
                data: csvReportData
            };
            // convert the CSV data to JSON
            const jsonReportData = this.mapCsvToJson(csvReportData, exportContext);
            return {
                type: 'json',
                data: jsonReportData
            };
        } catch (error) {
            this.logger.consoleError(`Export failed: report="${report.Name}", format="${format}", destination="${config.destination}".`, error.stack);
        } finally{
            /**
             * Cleanup export process
             */ this.adaptableApi.exportApi.internalApi.setExportComplete();
            if (excelStylesWerePatched) this.resetExcelStyles();
            if (showProgressIndicator) this.adaptableApi.userInterfaceApi.hideProgressIndicator();
        }
    }
    /**
     * Creates export context and parameters for a given export configuration
     */ buildExportProcessData(config) {
        const exportContext = this.buildExportProcessContext(config);
        let exportParams = this.buildExportParams(exportContext);
        if (typeof config?.customExportParams === 'function') {
            this.logger.info(`Applying custom export params: report="${config.report.Name}", format="${config.format}".`);
            exportParams = config.customExportParams(exportParams);
        }
        exportContext.exportedColumnIds = exportParams.columnKeys;
        return {
            exportContext: exportContext,
            exportParams: exportParams
        };
    }
    buildExportParams(exportContext) {
        const baseExportParams = this.buildBaseExportParams(exportContext);
        if (exportContext.format === 'Excel' || exportContext.format === 'VisualExcel') {
            const excelExportParams = baseExportParams;
            const sheetName = typeof this.exportOptions.excelSheetName === 'function' ? this.exportOptions.excelSheetName(this.adaptableApi.exportApi.internalApi.buildBaseExportContext(exportContext.report.Name, exportContext.format, exportContext.destination)) : this.exportOptions.excelSheetName;
            excelExportParams.sheetName = sheetName;
            return excelExportParams;
        }
        // for everything else we use the CSV export
        const csvExportParams = baseExportParams;
        csvExportParams.columnSeparator = this.getCsvSeparator(exportContext);
        return csvExportParams;
    }
    buildBaseExportParams(exportContext) {
        // TODO AFL: get custom info from user/ExportOptions for ExcelExportParams?
        const params = {};
        const { columnKeys: columnKeys, exportedRows: exportedRows, shouldRowBeSkipped: shouldRowBeSkipped, skipRowGroups: skipRowGroups, rowGroupExpandState: rowGroupExpandState } = this.getReportColsAndRows(exportContext);
        params.columnKeys = columnKeys;
        params.exportedRows = exportedRows;
        params.shouldRowBeSkipped = shouldRowBeSkipped;
        params.skipRowGroups = skipRowGroups;
        // only Excel supports expanded state configuration, but setting it for all formats won't hurt, it will just be ignored
        params.rowGroupExpandState = rowGroupExpandState;
        params.fileName = this.adaptableApi.exportApi.internalApi.getReportFileName(exportContext.report.Name, exportContext.format, exportContext.destination);
        params.skipColumnHeaders = this.computeSkipColumnHeaders(exportContext);
        if (!exportContext.isExcelReport && exportContext.format !== 'CSV') // if we map CSV to JSON, we don't want to skip the column headers
        params.skipColumnHeaders = false;
        params.getCustomContentBelowRow = this.computeGetCustomContentBelowRow(exportContext);
        params.processCellCallback = this.computeProcessCellCallback(exportContext);
        params.processRowGroupCallback = this.computeProcessRowGroupCallback(exportContext);
        return params;
    }
    computeProcessRowGroupCallback(exportContext) {
        return (params)=>{
            // recreating the standard AG Grid styling for row groups: 'Parent -> Child'
            // additionally the values are formatted
            let rowGroupNode = params.node;
            const agColumn = params.column;
            const rowGroupSummary = [
                this.processRowGroupForExcelExport(rowGroupNode, exportContext, agColumn) ?? ''
            ];
            while(rowGroupNode.parent){
                rowGroupNode = rowGroupNode.parent;
                const formattedParentNode = this.processRowGroupForExcelExport(rowGroupNode, exportContext, agColumn);
                if (formattedParentNode) rowGroupSummary.push(formattedParentNode);
            }
            let summary = rowGroupSummary.reverse().join(' -> ');
            if (agColumn?.getColId() === (0, $58846ea7f4156db7$export$1fadf36dae8ed962) && rowGroupNode.footer) summary = `Total: ${summary}`;
            return summary;
        };
    }
    computeProcessCellCallback(exportContext) {
        return (params)=>{
            const { node: node, column: column, value: value } = params;
            const colId = column.getColId();
            if (exportContext.report.ReportRowScope === 'SelectedRows') {
                // handle case when this cell(column) is not selected
                if (// see #isCellPartOfSelection
                !exportContext.isCellPartOfSelection(params.node.id, colId)) return '';
            }
            const columnId = column.getColId();
            if (node?.group && (this.adaptableApi.columnApi.isAutoRowGroupColumn(columnId) || // we would still need to process the cell if this is a group row with an aggregated value
            node?.aggData?.[columnId] == undefined)) // skip processing of row groups, this was already handled in processRowGroupCallback()
            return value;
            return this.processCellForExcelExport(node, columnId, exportContext);
        };
    }
    getReportColsAndRows(exportContext) {
        const { report: report, exportedColumnIds: exportedColumnIds, isExportingVisibleColumnToJSON: isExportingVisibleColumnToJSON } = exportContext;
        /**
         *        1. columnKeys
         */ const columnKeys = exportedColumnIds;
        /**
         *        2. exportedRows
         */ let exportedRows = 'all'; // 'AllRows' or 'ExpressionRows'
        if (report.ReportRowScope === 'VisibleRows' || report.ReportRowScope === 'SelectedRows') exportedRows = 'filteredAndSorted';
        /**
         *        3. shouldRowBeSkipped
         */ let shouldRowBeSkipped;
        // 'AllRows' or 'VisibleRows': no need to skip rows as we are exporting all rows
        if (report.ReportRowScope === 'SelectedRows') {
            // mapping of row ids to column ids which contain selected cells
            // or true if the whole row is selected
            const selectedRowColumnMapping = new Map();
            // ids of selected rows
            this.adaptableApi.gridApi.getSelectedRowInfo().gridRows?.forEach((row)=>{
                if (row?.rowNode?.id) selectedRowColumnMapping.set(row.rowNode.id, true);
            });
            // ids of rows which contain selected cells
            this.adaptableApi.gridApi.getSelectedCellInfo().gridCells?.map((gridCell)=>{
                if (gridCell.rowNode?.id) {
                    const selectedColumns = selectedRowColumnMapping.get(gridCell.rowNode.id);
                    if (selectedColumns == null) selectedRowColumnMapping.set(gridCell.rowNode.id, new Set([
                        gridCell.column.columnId
                    ]));
                    else if (selectedColumns instanceof Set) selectedColumns.add(gridCell.column.columnId);
                // else no nothing, the entire row is selected
                }
            });
            shouldRowBeSkipped = (params)=>{
                return !selectedRowColumnMapping.has(params.node.id);
            };
            // #isCellPartOfSelection
            exportContext.isCellPartOfSelection = (rowId, columnId)=>{
                const selectedRow = selectedRowColumnMapping.get(rowId);
                if (selectedRow === true) return true;
                if (selectedRow instanceof Set) return selectedRow.has(columnId);
                return false;
            };
        }
        if (report.ReportRowScope === 'ExpressionRows') shouldRowBeSkipped = (params)=>{
            const rowNodeMatchesExpression = this.adaptableApi.internalApi.getQueryLanguageService().evaluateBooleanExpression(report?.Query?.BooleanExpression, (0, $42e863194fcb493f$export$2bc329d2b6ae03ac), params.node);
            return !rowNodeMatchesExpression;
        };
        /**
         *        4. skipRowGroups
         */ let skipRowGroups;
        if (report.ReportRowScope === 'AllRows' || isExportingVisibleColumnToJSON) // we want to return the entire data, without the groups
        skipRowGroups = true;
        if (this.isTreeDataGrid()) // we need the group rows for TreeData
        skipRowGroups = false;
        /**
         *        5. rowGroupExpandState
         */ let rowGroupExpandState = 'expanded';
        if (report.ReportRowScope === 'VisibleRows') rowGroupExpandState = 'match';
        return {
            columnKeys: columnKeys,
            exportedRows: exportedRows,
            shouldRowBeSkipped: shouldRowBeSkipped,
            skipRowGroups: skipRowGroups,
            rowGroupExpandState: rowGroupExpandState
        };
    }
    isTreeDataGrid() {
        return this.adaptableApi.gridApi.isTreeDataGrid();
    }
    buildExportProcessContext(config) {
        const { report: report } = config;
        const currentLayout = this.adaptableApi.layoutApi.getCurrentLayout();
        const groupColumnIds = this.isTreeDataGrid() ? [
            (0, $58846ea7f4156db7$export$1fadf36dae8ed962)
        ] : currentLayout.RowGroupedColumns ?? currentLayout.PivotGroupedColumns;
        const pivotColumnIds = currentLayout.PivotColumns;
        const isExportingVisibleColumnToJSON = config.format === 'JSON' && report.ReportColumnScope === 'VisibleColumns';
        const exportableColumnIds = this.adaptableApi.columnApi.getExportableColumns().map((col)=>col.columnId);
        const exportableColumnIdsSet = new Set(exportableColumnIds);
        // we compute the exported column keys early, as we need them for other parts of the export process
        const onlyExportableColumnIds = (columnId)=>exportableColumnIdsSet.has(columnId);
        const getVisibleColumnIds = ()=>{
            return this.adaptableApi.layoutApi.isCurrentLayoutPivot() ? this.adaptableApi.layoutApi.getCurrentVisibleColumnIdsForPivotLayout().filter(onlyExportableColumnIds) : this.adaptableApi.layoutApi.getCurrentVisibleColumnIdsForTableLayout().filter(onlyExportableColumnIds);
        };
        let exportedColumnIds = [];
        switch(report.ReportColumnScope){
            case 'AllColumns':
                exportedColumnIds = exportableColumnIds.filter((colId)=>this.isTreeDataGrid() || !this.adaptableApi.columnApi.isAutoRowGroupColumn(colId) && !this.adaptableApi.columnApi.isSelectionColumn(colId));
                break;
            case 'VisibleColumns':
                exportedColumnIds = getVisibleColumnIds();
                if (isExportingVisibleColumnToJSON) // for JSON we will export CSV and then convert to JSON
                // in this case we have to map the auto-group columns to the real keys
                exportedColumnIds = [
                    ...groupColumnIds,
                    ...exportedColumnIds.filter((columnId)=>this.isTreeDataGrid() || !this.adaptableApi.columnApi.isAutoRowGroupColumn(columnId) && !this.adaptableApi.columnApi.isSelectionColumn(columnId))
                ];
                break;
            case 'SelectedColumns':
                const selectedRowInfo = this.adaptableApi.gridApi.getSelectedRowInfo();
                if (selectedRowInfo?.gridRows?.length) // if there is at least one selected row, we have to export all visible columns
                exportedColumnIds = getVisibleColumnIds();
                else {
                    // otherwise, we can export only columns which contain selected cells
                    const selectedColumnIds = this.adaptableApi.gridApi.getSelectedCellInfo().columns?.map((column)=>column.columnId);
                    const selectedColumnIdsSet = new Set(selectedColumnIds.filter(onlyExportableColumnIds));
                    // ensure that column order is preserved
                    exportedColumnIds = getVisibleColumnIds().filter((colId)=>selectedColumnIdsSet.has(colId));
                }
                break;
            case 'ScopeColumns':
                if ('ColumnIds' in report.Scope) exportedColumnIds = report.Scope.ColumnIds?.filter(onlyExportableColumnIds);
                else exportedColumnIds = this.adaptableApi.columnScopeApi.getColumnsInScope(report.Scope).map((col)=>col.columnId).filter(onlyExportableColumnIds);
                break;
            default:
                this.adaptableApi.logError('Invalid ReportColumnScope: ', report.ReportColumnScope);
                // fallback to all columns
                exportedColumnIds = exportableColumnIds;
        }
        return {
            ...config,
            exportedColumnIds: exportedColumnIds,
            isExcelReport: config.format === 'Excel' || config.format === 'VisualExcel',
            isVisualExcelReport: config.format === 'VisualExcel',
            isExportingVisibleColumnToJSON: isExportingVisibleColumnToJSON,
            // will be overriden later, see #isCellPartOfSelection
            isCellPartOfSelection: ()=>false,
            getCurrent: ()=>{
                return {
                    layout: currentLayout,
                    groupColumnIds: groupColumnIds,
                    pivotColumnIds: pivotColumnIds
                };
            }
        };
    }
    processCellForExcelExport(rowNode, columnId, exportContext) {
        if (this.adaptableApi.exportApi.internalApi.isVisualDataExportInProgress()) {
            const cellKey = $160c6fe5c8b728e7$export$d17645576d7c2129.getExcelClassNameForCell(columnId, this.adaptableApi.gridApi.getPrimaryKeyValueForRowNode(rowNode));
            const isoFormattedDate = this.getExcelStyleWithFormattedDate(cellKey);
            if (isoFormattedDate) // this is a Date cell which will be formatted by Excel
            return isoFormattedDate;
        }
        return this.getCellExportValueFromRawValue(rowNode, this.adaptableApi.gridApi.getRawValueFromRowNode(rowNode, columnId), columnId, exportContext);
    }
    processRowGroupForExcelExport(rowNode, exportContext, agColumn) {
        if (this.isTreeDataGrid()) return rowNode.key;
        const getColIdAndRawValue = ()=>{
            if (this.adaptableApi.columnApi.isAutoRowGroupColumn(agColumn?.getColId())) {
                const columnId = rowNode.rowGroupColumn?.getColId() ?? rowNode.rowGroupColumn?.getColDef()?.field ?? rowNode.field;
                let rawValue = rowNode.key;
                return {
                    columnId: columnId,
                    rawValue: rawValue
                };
            }
            if (!!rowNode.aggData) {
                const columnId = agColumn.getColId();
                const rawValue = rowNode.aggData?.[columnId];
                return {
                    columnId: columnId,
                    rawValue: rawValue
                };
            }
            return {};
        };
        let { columnId: columnId, rawValue: rawValue } = getColIdAndRawValue();
        if (!columnId || rawValue == null) return;
        const columnDataType = this.adaptableApi.columnApi.getColumnDataTypeForColumnId(columnId);
        if (columnDataType === 'date' && typeof rawValue === 'string' && // rawValue is composed only of digits
        /^\d+$/.test(rawValue)) {
            // AG-Grid converts the value to string, we have to reconvert it back
            const dateRawValue = parseInt(rawValue);
            if (dateRawValue != undefined) // @ts-ignore
            rawValue = dateRawValue;
        }
        return this.getCellExportValueFromRawValue(rowNode, rawValue, columnId, exportContext);
    }
    patchExcelStyles(exportContext) {
        const exportExcelStyles = this.buildExcelStyles(exportContext);
        // Concatenate exportExcelStyles to DANGER_excelStyles without changing the array reference
        this.DANGER_excelStyles.push(...exportExcelStyles);
    }
    resetExcelStyles() {
        // Revert to original state without changing the array reference
        this.DANGER_excelStyles.splice(0, this.DANGER_excelStyles.length, ...this.originalExcelStyles);
        this.excelStylesCache = {};
        this.cellOrHeaderClassKey2ExcelStyleIdMap = {};
        this.excelStylesWithFormattedDate = {};
    }
    buildExcelStyles(exportContext) {
        // we make sure that we start with a clean slate
        // theoretically this should have happened at the end of the export process, but just in case
        this.resetExcelStyles();
        // we memoize as much as possible, as this is called quite A LOT
        const adaptableColumnMemo = {};
        const getAdaptableColumnWithColumnId = (columnId)=>{
            const memoizedColumn = adaptableColumnMemo[columnId];
            if (memoizedColumn) return memoizedColumn;
            const abColumn = this.adaptableApi.columnApi.getColumnWithColumnId(columnId);
            adaptableColumnMemo[columnId] = abColumn;
            return abColumn;
        };
        const formatColumnsWithDisplayFormatMemo = {};
        const getFormatColumnsWithDisplayFormatForColumn = (columnId)=>{
            const memoizedFormatColumns = formatColumnsWithDisplayFormatMemo[columnId];
            if (memoizedFormatColumns) return memoizedFormatColumns;
            const abColumn = getAdaptableColumnWithColumnId(columnId);
            const formatColumns = this.adaptableApi.formatColumnApi.internalApi.getFormatColumnsWithDisplayFormatForColumn(abColumn, {
                target: 'cell'
            });
            formatColumnsWithDisplayFormatMemo[columnId] = formatColumns;
            return formatColumns;
        };
        const agGridDisplayedColumns = this.agGridApi.getAllDisplayedColumns().filter((agCol)=>agCol.getId() !== (0, $58846ea7f4156db7$export$8866fbaadb96699c));
        const colDefs = agGridDisplayedColumns.map((column)=>{
            return column.getColDef();
        });
        const forAllVisibleRowNodesDoConfig = {
            includeGroupRows: true
        };
        const userExcelStyles = this.DANGER_excelStyles;
        // 1. Header Styles
        agGridDisplayedColumns.forEach((column, columnIndex)=>{
            const colDef = colDefs[columnIndex];
            const columnId = column.getId();
            const adaptableColumn = getAdaptableColumnWithColumnId(columnId);
            if (!adaptableColumn) {
                this.logger.warn(`Export styling: column "${columnId}" not found in Adaptable.`);
                return;
            }
            let headerClassParams = {
                colDef: colDef,
                column: column,
                floatingFilter: false,
                api: this.agGridApi,
                context: this.agGridApi.getGridOption('context')
            };
            const headerStyle = typeof colDef.headerStyle === 'function' ? colDef.headerStyle(headerClassParams) : {};
            const excelHeaderStyles = [];
            // add user defined excel styles
            let userColDefHeaderClass = this._adaptableInstance.agGridColumnAdapter.getUserColDefProperty(column.getColId(), 'headerClass');
            const userDefinedHeaderClass = typeof userColDefHeaderClass === 'function' ? userColDefHeaderClass(headerClassParams) : userColDefHeaderClass;
            const userDefinedExcelHeaderStyle = userDefinedHeaderClass && userExcelStyles.find((excelStyle)=>{
                return typeof userDefinedHeaderClass === 'string' ? userDefinedHeaderClass === excelStyle.id : userDefinedHeaderClass?.includes?.(excelStyle.id);
            });
            if (userDefinedExcelHeaderStyle) excelHeaderStyles.push(userDefinedExcelHeaderStyle);
            // add adaptable derived styles (format column etc.)
            const adaptableHeaderStyle = {
                ...Object.keys(headerStyle).reduce((result, key)=>{
                    if (headerStyle[key] !== null) result[key] = headerStyle[key];
                    return result;
                }, {})
            };
            const sanitizedAdaptableHeaderStyle = (0, $0f8018328b88def3$export$2709a6cd5918a828)(adaptableHeaderStyle);
            if (Object.values(sanitizedAdaptableHeaderStyle).some((style)=>style != null)) excelHeaderStyles.push(this.convertCSSToExcelStyle(sanitizedAdaptableHeaderStyle));
            // don't add the header style if it has no adaptable custom styles
            if (!excelHeaderStyles.length) return;
            const headerClassId = $160c6fe5c8b728e7$export$d17645576d7c2129.getExcelClassNameForHeader(column.getId(), userDefinedHeaderClass);
            const finalHeaderExcelStyle = Object.assign({}, ...excelHeaderStyles);
            this.registerExcelStyle(finalHeaderExcelStyle, headerClassId);
        });
        // 2. Cell Styles
        this.adaptableApi.internalApi.forAllVisibleRowNodesDo((node, rowIndex)=>{
            const rowParams = {
                node: node,
                data: node.data,
                rowIndex: rowIndex,
                api: this.agGridApi,
                context: this.agGridApi.getGridOption('context') || {}
            };
            const getRowStyleFn = this.agGridApi.getGridOption('getRowStyle');
            const rowStyle = getRowStyleFn ? getRowStyleFn(rowParams) : {};
            agGridDisplayedColumns.forEach((column, columnIndex)=>{
                const colDef = colDefs[columnIndex];
                const columnId = column.getId();
                const adaptableColumn = getAdaptableColumnWithColumnId(columnId);
                if (!adaptableColumn) {
                    this.logger.warn(`Export styling: column "${columnId}" not found in Adaptable.`);
                    return;
                }
                const isDateCellExportedAsFormattedValue = this.isDateCellExportedAsFormattedValue(adaptableColumn, exportContext);
                let cellClassParams;
                const getLazyCellClassParams = ()=>{
                    if (!cellClassParams) cellClassParams = {
                        colDef: colDef,
                        node: node,
                        column: column,
                        data: node.data,
                        value: this.adaptableApi.gridApi.getRawValueFromRowNode(node, columnId),
                        rowIndex: rowIndex,
                        api: this.agGridApi,
                        context: {}
                    };
                    return cellClassParams;
                };
                const cellStyle = typeof colDef.cellStyle === 'function' ? colDef.cellStyle(getLazyCellClassParams()) : {};
                const excelCellStyles = [];
                // add user defined excel styles
                let userColDefCellClass = this._adaptableInstance.agGridColumnAdapter.getUserColDefProperty(column.getColId(), 'cellClass');
                const userDefinedCellClass = typeof userColDefCellClass === 'function' ? userColDefCellClass(getLazyCellClassParams()) : userColDefCellClass;
                const userDefinedExcelStyle = userDefinedCellClass && userExcelStyles.find((excelStyle)=>{
                    return typeof userDefinedCellClass === 'string' ? userDefinedCellClass === excelStyle.id : userDefinedCellClass?.includes?.(excelStyle.id);
                });
                if (userDefinedExcelStyle) excelCellStyles.push(userDefinedExcelStyle);
                // add adaptable derived styles (format column etc.)
                const adaptableCellStyle = {
                    ...rowStyle,
                    ...Object.keys(cellStyle).reduce((result, key)=>{
                        if (cellStyle[key] !== null) result[key] = cellStyle[key];
                        return result;
                    }, {})
                };
                const sanitizedAdaptableCellStyle = (0, $0f8018328b88def3$export$2709a6cd5918a828)(adaptableCellStyle);
                if (Object.values(sanitizedAdaptableCellStyle).some((style)=>style != null)) excelCellStyles.push(this.convertCSSToExcelStyle(sanitizedAdaptableCellStyle));
                const excelDataType = this.getExcelDataType(adaptableColumn.dataType);
                const rawValue = this.adaptableApi.gridApi.getRawValueFromRowNode(node, column.getId());
                // don't add the cell style if it has no adaptable custom styles
                if (!excelCellStyles.length && // if this is a formatted Date value, we still need to add the AG GRID specific type & numberFormat below
                !(excelDataType === 'DateTime' && isDateCellExportedAsFormattedValue)) return;
                const cellClassId = $160c6fe5c8b728e7$export$d17645576d7c2129.getExcelClassNameForCell(column.getId(), this.adaptableApi.gridApi.getPrimaryKeyValueForRowNode(node), userDefinedCellClass);
                const finalCellExcelStyle = Object.assign({}, ...excelCellStyles);
                if (excelDataType === 'DateTime' && isDateCellExportedAsFormattedValue) {
                    let dateFormatPattern = this.exportOptions.exportDateFormat;
                    const abColumn = getAdaptableColumnWithColumnId(column.getColId());
                    if (!dateFormatPattern) {
                        const mostRelevantFormatColumn = this.adaptableApi.formatColumnApi.internalApi.getMostRelevantFormatColumnForColumn(getFormatColumnsWithDisplayFormatForColumn(column.getColId()), abColumn, {
                            node: node,
                            value: rawValue
                        });
                        dateFormatPattern = mostRelevantFormatColumn?.DisplayFormat?.Formatter === 'DateFormatter' && mostRelevantFormatColumn?.DisplayFormat?.Options?.Pattern;
                    }
                    if (dateFormatPattern) {
                        const customDateFormatPattern = typeof dateFormatPattern === 'function' ? dateFormatPattern({
                            ...this.adaptableApi.exportApi.internalApi.buildBaseExportContext(exportContext.report.Name, exportContext.format, exportContext.destination),
                            column: adaptableColumn
                        }) : dateFormatPattern;
                        const normalisedValue = this._adaptableInstance.getNormalisedValueFromRawValue(rawValue, abColumn);
                        if (normalisedValue) {
                            // we have to pass the date in the ISO format to Excel
                            // see https://www.ag-grid.com/javascript-data-grid/excel-export-data-types/#dates
                            // we can NOT use Date.toISOString() because we don't want the timezone corrections to kick in
                            const isoFormattedValue = (0, $1fe81e1078ace264$export$ad991b66133851cf)(normalisedValue, {
                                Pattern: `yyyy-MM-dd'T'HH:mm:ss.SSS`
                            });
                            if (isoFormattedValue) {
                                finalCellExcelStyle.dataType = 'DateTime';
                                finalCellExcelStyle.numberFormat = {
                                    format: customDateFormatPattern
                                };
                                // create a new cell key to ensure any user provided className does not interfere
                                const cellKey = $160c6fe5c8b728e7$export$d17645576d7c2129.getExcelClassNameForCell(column.getColId(), this.adaptableApi.gridApi.getPrimaryKeyValueForRowNode(node));
                                // we need to register so that later the cellProcessor will put the isoFormattedValue through (thus giving the formatting responsability to Excel)
                                this.registerExcelStyleWithFormattedDate(cellKey, isoFormattedValue);
                            }
                        }
                    }
                }
                this.registerExcelStyle(finalCellExcelStyle, cellClassId);
            });
        }, forAllVisibleRowNodesDoConfig);
        return Object.values(this.excelStylesCache);
    }
    registerExcelStyle(excelStyle, cellClassKey) {
        const excelStyleKey = JSON.stringify(excelStyle);
        if (!this.excelStylesCache[excelStyleKey]) {
            const excelStyleId = (0, $d7790b1d1a829cfc$export$10a020066a0f444a)();
            const excelStyleWithId = {
                ...excelStyle,
                id: excelStyleId
            };
            this.excelStylesCache[excelStyleKey] = excelStyleWithId;
        }
        this.cellOrHeaderClassKey2ExcelStyleIdMap[cellClassKey] = this.excelStylesCache[excelStyleKey].id;
    }
    registerExcelStyleWithFormattedDate(cellClassId, isoFormattedValue) {
        this.excelStylesWithFormattedDate[cellClassId] = isoFormattedValue;
    }
    isDateCellExportedAsFormattedValue(abColumn, exportContext) {
        return !!this.exportOptions.exportDateFormat || // FIXME AFL move this method here
        this.getCellExportFormatType(abColumn, 'date', exportContext) === 'formattedValue';
    }
    convertCSSToExcelStyle(style) {
        const getHexColor = (color)=>{
            const preparedColor = (0, $0f8018328b88def3$export$fb1c9088cfbed114)(color);
            const t = (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(preparedColor);
            const a = t.getAlpha();
            return (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports))).mix((0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))('white'), t, a * 100).toHexString();
        };
        let result = {};
        if (style.backgroundColor != null) result.interior = {
            color: getHexColor(style.backgroundColor),
            pattern: 'Solid'
        };
        if (style.borderColor != null) {
            const excelBorder = {
                color: style.borderColor,
                lineStyle: 'Continuous',
                weight: 1
            };
            result.borders = {
                borderBottom: excelBorder,
                borderLeft: excelBorder,
                borderRight: excelBorder,
                borderTop: excelBorder
            };
        }
        if (style.textAlign) result.alignment = {
            horizontal: (0, $9OAZF.default).CapitaliseFirstLetter(style.textAlign)
        };
        if (style.color != null) {
            if (!result.font) result.font = {};
            result.font = {
                color: getHexColor(style.color)
            };
        }
        if (style.fontStyle === 'italic') {
            if (!result.font) result.font = {};
            result.font.italic = true;
        }
        if (style.fontWeight != null && (style.fontWeight === 'bold' || Number(style.fontWeight) >= 600)) {
            if (!result.font) result.font = {};
            result.font.bold = true;
        }
        if (style.fontSize != null) {
            if (!result.font) result.font = {};
            result.font.size = (0, $0f8018328b88def3$export$c06e2b8d470b67bb)(style.fontSize);
        }
        return result;
    }
    getExcelDataType(adaptableColumnDataType) {
        switch(adaptableColumnDataType){
            case 'number':
                return 'Number';
            case 'boolean':
                return 'Boolean';
            case 'date':
                return 'DateTime';
            case 'text':
            default:
                return 'String';
        }
    }
    getExcelStyleIdForClassKey(cellOrHeaderClassKey) {
        return this.cellOrHeaderClassKey2ExcelStyleIdMap[cellOrHeaderClassKey];
    }
    getExcelStyleWithFormattedDate(cellClassId) {
        return this.excelStylesWithFormattedDate[cellClassId];
    }
    mapCsvToJson(csvReportData, exportContext) {
        const columns = exportContext.exportedColumnIds.map((columnId)=>this.adaptableApi.columnApi.getColumnWithColumnId(columnId)).map((column)=>({
                columnId: column.columnId,
                field: column.field ?? column.columnId,
                friendlyName: column.friendlyName,
                dataType: column.dataType
            }));
        const reportData = {
            columns: columns,
            rows: []
        };
        if (exportContext.report.ReportColumnScope === 'VisibleColumns') {
            if (exportContext.getCurrent().groupColumnIds?.length) reportData.groupColumnIds = exportContext.getCurrent().groupColumnIds;
            if (exportContext.getCurrent().pivotColumnIds?.length) reportData.pivotColumnIds = exportContext.getCurrent().pivotColumnIds;
        }
        // map Row Data
        const schema = (0, $6f728bbff4ab11ac$export$1f42f54c9496a87f)(csvReportData, {
            col: this.getCsvSeparator(exportContext),
            header: (rows)=>{
                const headerRow = rows[0];
                // replace headerNames with columnIds
                headerRow.forEach((headerName, index)=>{
                    const column = columns.find((col)=>col.friendlyName === headerName);
                    if (column) headerRow[index] = column.columnId;
                });
                return [
                    headerRow
                ];
            }
        });
        const parser = (0, $6f728bbff4ab11ac$export$84bb9899435eeb61)(schema);
        const jsonData = parser.typedObjs(csvReportData);
        reportData.rows = jsonData;
        return reportData;
    }
    getCsvSeparator(exportProcessContext) {
        if (typeof this.exportOptions.csvSeparator === 'function') return this.exportOptions.csvSeparator(this.adaptableApi.exportApi.internalApi.buildBaseExportContext(exportProcessContext.report.Name, exportProcessContext.format, exportProcessContext.destination));
        else return this.exportOptions.csvSeparator;
    }
    computeSkipColumnHeaders(exportProcessContext) {
        if (typeof this.exportOptions.skipColumnHeaders === 'function') return this.exportOptions.skipColumnHeaders(this.adaptableApi.exportApi.internalApi.buildBaseExportContext(exportProcessContext.report.Name, exportProcessContext.format, exportProcessContext.destination));
        else return this.exportOptions.skipColumnHeaders;
    }
    computeGetCustomContentBelowRow(exportContext) {
        if (!this.adaptableApi.gridApi.isMasterDetailGrid()) return;
        const getDetailsRowsFn = this.exportOptions.getDetailRows;
        if (typeof getDetailsRowsFn !== 'function') {
            this.adaptableApi.logInfo('ExportOptions.getDetailRows() is not defined, skipping detail rows export');
            return;
        }
        return (params)=>{
            const { node: node } = params;
            const shouldExportDetailRows = exportContext.report.ReportRowScope === 'AllRows' || exportContext.report.ReportRowScope === 'VisibleRows' && node.expanded;
            if (!shouldExportDetailRows) return;
            const context = {
                ...this.adaptableApi.exportApi.internalApi.buildBaseExportContext(exportContext.report.Name, exportContext.format, exportContext.destination),
                adaptableColumn: this.adaptableApi.columnApi.getColumnWithColumnId(params.column?.getId()),
                masterRowNode: node,
                masterRowData: node?.data,
                isExpanded: node.expanded,
                createCellCsv: (cellContent)=>this.adaptableApi.exportApi.internalApi.createCellCsv(cellContent),
                createCellExcel: (cellContent, cellType)=>this.adaptableApi.exportApi.internalApi.createCellExcel(cellContent, cellType),
                createCellHeader: (cellContent)=>{
                    return {
                        ...this.adaptableApi.exportApi.internalApi.createCellHeader(cellContent),
                        // see #masterDetailHeader
                        styleId: '_masterDetailHeader'
                    };
                }
            };
            const detailRows = getDetailsRowsFn(context);
            if (exportContext.isExcelReport) {
                const anyExcelRow = detailRows[0];
                if (anyExcelRow.cells == undefined) {
                    this.adaptableApi.logWarn(`Export ${exportContext.report.Name}: ExportOptions.getDetailRows() should return an array of ExcelRow objects`);
                    return;
                }
            } else {
                const anyCsvCell = detailRows[0]?.[0];
                if (anyCsvCell.data == undefined) {
                    this.adaptableApi.logWarn(`Export ${exportContext.report.Name}: ExportOptions.getDetailRows() should return an array of CsvRow objects`);
                    return;
                }
            }
            return detailRows;
        };
    }
    getCellExportValueFromRawValue(rowNode, cellRawValue, columnId, exportContext) {
        if ((0, $9OAZF.default).IsNullOrEmpty(cellRawValue)) return cellRawValue;
        const column = this.adaptableApi.columnApi.getColumnWithColumnId(columnId);
        const columnDataType = column.dataType;
        // 1. if it is a VisualExcel report format, we always ONLY send the formatted value and ignore all other properties
        if (exportContext.isVisualExcelReport) return this.getCellExportValueFromRawValueByType(rowNode, cellRawValue, columnId, 'formattedValue');
        const isDateColumn = columnDataType === 'date';
        // 2. if this is a date column and there is a custom export date format provided, that will next take precedence
        if (isDateColumn) {
            const customExportDateFormat = this.getCustomExportDateFormat(column, exportContext);
            if (!!customExportDateFormat) return (0, $1fe81e1078ace264$export$2e2bcd8739ae039).DateFormatter(cellRawValue, {
                Pattern: customExportDateFormat
            });
        }
        // 3. in all other cases check the general export format types
        const cellExportFormat = this.getCellExportFormatType(column, columnDataType, exportContext);
        return this.getCellExportValueFromRawValueByType(rowNode, cellRawValue, columnId, cellExportFormat);
    }
    getCustomExportDateFormat(column, exportContext) {
        const exportDateFormatOption = this.adaptableApi.optionsApi.getExportOptions().exportDateFormat;
        return typeof exportDateFormatOption === 'function' ? exportDateFormatOption({
            ...this.adaptableApi.exportApi.internalApi.buildBaseExportContext(exportContext.report.Name, exportContext.format, exportContext.destination),
            column: column
        }) : exportDateFormatOption;
    }
    getCellExportValueFromRawValueByType(rowNode, cellRawValue, columnId, // default to rawValue if, for some reason, the configs provide invalid values
    type = 'rawValue') {
        return type === 'rawValue' ? cellRawValue : this.adaptableApi.gridApi.getDisplayValueFromRawValue(rowNode, columnId, cellRawValue);
    }
    getCellExportFormatType(column, columnDataType, exportContext) {
        const exportDataFormat = this.exportOptions.exportDataFormat;
        // First check if a function was provided and return the result
        if (exportDataFormat != null && typeof exportDataFormat === 'function') {
            const context = {
                ...this.adaptableApi.exportApi.internalApi.buildBaseExportContext(exportContext.report.Name, exportContext.format, exportContext.destination),
                column: column
            };
            return exportDataFormat(context);
        }
        // Next Check if a "hard-coded" value has been provided and return that
        if (exportDataFormat === 'rawValue') return 'rawValue';
        if (exportDataFormat === 'formattedValue') return 'formattedValue';
        // Finally test if a DataType object has been provided and return the relevant property
        const dataFormatDataType = exportDataFormat;
        if (dataFormatDataType) // format is customized based on column data type
        switch(columnDataType){
            case 'text':
                return dataFormatDataType.text;
            case 'number':
                return dataFormatDataType.number;
            case 'date':
                return dataFormatDataType.date;
            default:
                // default to rawValue for all other column types
                return 'rawValue';
        }
        return 'rawValue';
    }
}



const $aba1af7dfef01b91$var$PROVIDED_BY_ADAPTABLE = Symbol('isProvidedByAdaptable');
function $aba1af7dfef01b91$export$12fe5405255479a6(fn) {
    fn[$aba1af7dfef01b91$var$PROVIDED_BY_ADAPTABLE] = true;
    return fn;
}
function $aba1af7dfef01b91$export$fd2dc7242e4494f2(fn) {
    return fn && !!fn[$aba1af7dfef01b91$var$PROVIDED_BY_ADAPTABLE];
}




var $acw62 = parcelRequire("acw62");


const $c168dc980eb01782$export$3082f1e1d504f03c = (adaptable)=>{
    function isFilterActive(colId) {
        // we need this here
        if (adaptable.isDestroyed) return false;
        //make the small filter icon to appear when there is a filter
        return adaptable.api.filterApi.columnFilterApi.isColumnFilterActiveForColumn(colId);
    }
    function getContainerId(colId) {
        return 'filter_' + colId + '_' + adaptable.adaptableOptions.adaptableId;
    }
    return class AgGridFilterAdapter {
        params;
        filterContainer;
        column;
        unmountReactRoot;
        init(params) {
            this.params = params;
            this.column = params.column;
            this.filterContainer = document.createElement('div');
            this.filterContainer.id = getContainerId(this.params.column.getColId());
        }
        getGui() {
            return this.filterContainer;
        }
        refresh(newParams) {
            // always reuse the current instance
            // the filter is refreshed in the underlying React component
            return true;
        }
        afterGuiAttached(params) {
            //we always unmount first so the autofocus from the form works... in other grids we unmount when hidden
            this.unmountReactRoot?.();
            const columnId = this.column.getColId();
            let column = adaptable.api.columnApi.getColumnWithColumnId(columnId);
            if (column) this.unmountReactRoot = adaptable.renderReactRoot((0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)($acw62.createElement((0, $c18eb22e16831d67$export$5d26e9d0e9751cd1), {
                columnId: columnId,
                wrapperProps: {
                    className: 'twa:p-2'
                },
                location: 'columnMenu'
            }), adaptable), this.filterContainer);
        }
        destroy() {
            this.unmountReactRoot?.();
            this.filterContainer = null;
        }
    };
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");




const $bfc6113edf10420c$var$ColumnFilterMenuItem = ({ active: active, onClick: onClick, icon: icon, label: label })=>{
    return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        className: "twa:p-1 twa:w-full",
        variant: "text",
        tone: active ? 'info' : 'none',
        onClick: onClick
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mr-2"
    }, icon), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:text-2"
    }, label));
};
const $bfc6113edf10420c$export$aca71856ce3eacfc = (props)=>{
    const [activeIndex, setActiveIndex] = $acw62.useState(()=>{
        const index = props.predicateDefs.findIndex((predicateDef)=>predicateDef.operator === props.predicate.operator);
        return index === -1 ? 0 : index;
    });
    const activeIndexRef = $acw62.useRef(activeIndex);
    const onPredicateChangeRef = $acw62.useRef(props.onPredicateChange);
    const predicateDefsRef = $acw62.useRef(props.predicateDefs);
    (0, $acw62.useLayoutEffect)(()=>{
        activeIndexRef.current = activeIndex;
        onPredicateChangeRef.current = props.onPredicateChange;
        predicateDefsRef.current = props.predicateDefs;
    });
    const confirm = $acw62.useCallback((predicateDef)=>{
        onPredicateChangeRef.current({
            operator: predicateDef.operator,
            args: []
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const onKeyDown = (e)=>{
            // Only handle arrow keys and Enter - let other keys (like Tab) pass through
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
            const activeIndex = activeIndexRef.current;
            const predicateDefs = predicateDefsRef.current;
            if (e.key === 'Enter') {
                const predicateDef = predicateDefs[activeIndex];
                if (predicateDef) confirm(predicateDef);
            }
            e.stopPropagation();
            e.preventDefault();
            const dir = e.key === 'ArrowDown' ? 1 : e.key === 'ArrowUp' ? -1 : 0;
            if (dir) {
                let nextIndex = activeIndex + dir;
                if (nextIndex < 0) nextIndex = predicateDefs.length - 1;
                else if (nextIndex >= predicateDefs.length) nextIndex = 0;
                setActiveIndex(nextIndex);
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return ()=>{
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [
        confirm
    ]);
    return $acw62.createElement((0, $6fe0561618a75b4b$export$2e2bcd8739ae039), {
        className: "twa:min-w-max"
    }, props.predicateDefs?.map((predicateDef, index)=>{
        const active = activeIndex === index;
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("twa:mb-1", active && "twa:bg-primarylight"),
            key: index,
            onMouseDownCapture: (e)=>{
                e.stopPropagation();
                e.preventDefault();
            }
        }, $acw62.createElement($bfc6113edf10420c$var$ColumnFilterMenuItem, {
            onClick: ()=>confirm(predicateDef),
            icon: predicateDef.icon,
            label: predicateDef.label,
            active: active
        }));
    }));
};




var $acw62 = parcelRequire("acw62");






const $772d2cbe84e8a448$export$7f5bc29b4aa4bc56 = (props)=>{
    const { api: api } = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const columnType = $acw62.useMemo(()=>{
        return api.columnApi.getColumnDataTypeForColumnId(props.columnId);
    }, [
        props.columnId
    ]);
    const predicateDef = (0, $ecbee8ce6dd7383f$export$89f99c33853c4e80)(props.predicate?.operator, props.predicateDefs);
    const fnTypeInput = (0, $47be09cb14df4bdb$export$d252517300e3b104)(columnType);
    const matchingInputs = predicateDef ? (0, $2298f961f09270fa$export$f89f94ec62712b0e)(fnTypeInput, predicateDef?.inputs, true) : [];
    const debouncedPredicateChange = $acw62.useCallback((0, $c34d1d35432b7498$export$2e2bcd8739ae039)((predicate)=>{
        props.onPredicateChange(predicate);
    }, 300), [
        props.predicate,
        props.columnId
    ]);
    if ([
        'date[]',
        'number[]',
        'text[]'
    ].includes(matchingInputs[0])) return $acw62.createElement((0, $318e9b87498d2460$export$2dda419fd76e4cf1), {
        inline: true,
        columnId: props.columnId,
        disabled: props.disabled,
        selectProps: {
            menuStyle: {
                left: -20
            }
        },
        onClear: ()=>{
            props.onPredicateChange({
                operator: props.predicate.operator,
                args: []
            });
        },
        onChange: (inputs)=>{
            props.onPredicateChange({
                operator: props.predicate.operator,
                args: inputs
            });
        },
        value: props.predicate.args,
        // are not known ql operators for now
        // should change when porting, it has knowledge about predicates
        type: props.predicate.operator === 'In' ? 'In' : 'NotIn'
    });
    return $acw62.createElement("div", {
        className: "twa:flex twa:flex-row twa:[&>*:not(:first-child)]:border-l! twa:[&>*:not(:first-child)]:border-inputborder!"
    }, (matchingInputs ?? []).map((input, index)=>{
        const value = props?.predicate?.args?.[index];
        return $acw62.createElement((0, $46949004880f344f$export$55a68ee1697fccf6), {
            filterType: "floating",
            columnId: props.columnId,
            usePrimitiveInputs: true,
            key: index,
            disabled: props.disabled,
            type: input,
            value: value,
            onKeyDown: props.onKeyDown,
            onClear: ()=>{
                const args = [
                    ...props.predicate.args
                ];
                args.splice(index, 1);
                const newPredicate = {
                    operator: props.predicate.operator,
                    args: args
                };
                debouncedPredicateChange(newPredicate);
            },
            onChange: (value)=>{
                const newPredicate = {
                    operator: props.predicate.operator,
                    args: [
                        ...props.predicate.args
                    ]
                };
                newPredicate.args[index] = value;
                debouncedPredicateChange(newPredicate);
            }
        });
    }));
};





const $0fed15bd056ea0f0$export$7721514076adf070 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    /**
     * We always have a syntetic predicate with AND or OR, so the logic is easyer.
     * The wrapper is in charge of constructing the correct column filter.
     */ const isMultiple = props.predicate?.args?.length > 1;
    const isManualApply = adaptable.api.filterApi.columnFilterApi.internalApi.shouldManuallyApplyColumnFilter(props.columnId);
    const isInlineEditable = !isMultiple && !isManualApply;
    // only used when there is only one filter selected
    let singleFilterPredicateDef = null;
    if (props.predicate.args.length === 1) singleFilterPredicateDef = props.predicateDefs.find((predicateDef)=>predicateDef.operator === props.predicate.args[0].operator);
    const noInputs = !singleFilterPredicateDef?.inputs || singleFilterPredicateDef.inputs.length === 0;
    let showLabel = isMultiple || noInputs || isManualApply;
    if (props.columnId === (0, $58846ea7f4156db7$export$1fadf36dae8ed962)) showLabel = false;
    let label = (0, $5b60d09ab87a9230$export$d9937b4f0cd29482)(props.predicate, props.predicateDefs);
    if (isManualApply && singleFilterPredicateDef && (0, $5b60d09ab87a9230$export$80f23550cb973ada)(props.predicate.args[0], singleFilterPredicateDef)) label = '';
    const showQuickFilterDropdown = adaptable.api.filterApi.columnFilterApi.internalApi.showQuickFilterDropdown(props.columnId);
    const handleClear = ()=>props.onClear?.();
    const showEvent = 'click';
    const hideEvent = 'blur';
    const [overlayVisible, setOverlayVisible] = $acw62.useState(false);
    let filterDropdown = null;
    const filterDropdownButton = $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        variant: "text",
        "data-name": "floating-filter-button",
        onBlur: ()=>{
            if (isInlineEditable) setOverlayVisible(false);
        },
        "data-value": props.predicate?.args[0]?.operator,
        onClick: ()=>{
            if (!isInlineEditable) adaptable.api.filterApi.columnFilterApi.internalApi.openColumnFilterPopup(props.columnId);
            else setOverlayVisible(true);
        },
        style: {
            textAlign: 'left',
            marginRight: 1,
            ...!isInlineEditable ? {
                minWidth: 0,
                flex: 1
            } : {}
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, !isManualApply && singleFilterPredicateDef?.icon ? singleFilterPredicateDef?.icon : $acw62.createElement((0, $1aae0b1146834d4d$export$8a2e09c1232b2f10), {
        icon: {
            name: 'filter'
        }
    })), showLabel && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "ab-FloatingFilter-label twa:ml-2 twa:flex-1",
        title: label
    }, label));
    if (isInlineEditable) filterDropdown = showQuickFilterDropdown && $acw62.createElement((0, $c9ce1fb924ab724e$export$2e2bcd8739ae039), {
        className: "ab-FloatingFilter-overlay",
        showEvent: showEvent,
        hideEvent: hideEvent,
        visible: overlayVisible,
        onVisibleChange: setOverlayVisible,
        preventPortalEventPropagation: showEvent === 'click',
        targetOffset: 10,
        hideDelay: 50,
        "data-name": "floating-filter-overlay",
        render: ()=>{
            // we render this only for single filter
            return $acw62.createElement((0, $bfc6113edf10420c$export$aca71856ce3eacfc), {
                columnId: props.columnId,
                disabled: props.disabled,
                predicate: props.predicate.args[0],
                predicateDefs: props.predicateDefs,
                onPredicateChange: (predicate)=>{
                    setOverlayVisible(false);
                    props.onPredicateChange({
                        operator: props.predicate.operator,
                        args: [
                            predicate
                        ]
                    });
                }
            });
        }
    }, filterDropdownButton);
    else filterDropdown = filterDropdownButton;
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "ab-FloatingFilter twa:w-full",
        onKeyDownCapture: (e)=>{
            // AG Grid's header keyboard navigation intercepts Tab and calls preventDefault(),
            // which prevents focus from moving between elements inside the floating filter.
            // We handle Tab manually in the capture phase (before AG Grid's handlers).
            if (e.key === 'Tab') {
                const target = e.target;
                const wrapper = e.currentTarget;
                if (!e.shiftKey) // Tab forward: from filter button → select input
                {
                    if (target.getAttribute('data-name') === 'floating-filter-button') {
                        const selectInput = wrapper.querySelector('[data-name="Select Values"] input');
                        if (selectInput) {
                            e.preventDefault();
                            e.nativeEvent.stopImmediatePropagation();
                            selectInput.focus();
                            // When the DummyInput gets focus, react-select sets isFocused=true,
                            // triggering a React re-render. During this re-render, unstable component
                            // references in selectComponents can cause the DummyInput to be removed
                            // from DOM and recreated, losing focus. We restore focus after the re-render.
                            requestAnimationFrame(()=>{
                                if (document.activeElement === document.body || document.activeElement === null) {
                                    const newInput = wrapper.querySelector('[data-name="Select Values"] input');
                                    newInput?.focus();
                                }
                            });
                        }
                    }
                }
            }
        }
    }, filterDropdown, isInlineEditable && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:flex-1 twa:min-w-0"
    }, $acw62.createElement((0, $772d2cbe84e8a448$export$7f5bc29b4aa4bc56), {
        onKeyDown: props.onKeydown,
        columnId: props.columnId,
        disabled: props.disabled,
        // It works only with a predicate
        predicate: props.predicate.args[0],
        predicateDefs: props.predicateDefs,
        onPredicateChange: (predicate)=>{
            props.onPredicateChange({
                operator: props.predicate.operator,
                args: [
                    predicate
                ]
            });
        }
    })), isInlineEditable && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        className: "twa:px-0",
        onClick: ()=>{
            adaptable.api.filterApi.columnFilterApi.internalApi.openColumnFilterPopup(props.columnId, {
                onChange: props.onChange
            });
        },
        "data-name": "expand-filter",
        icon: "expand",
        variant: "text"
    }), (isMultiple || !(0, $5b60d09ab87a9230$export$80f23550cb973ada)(props.predicate.args[0], singleFilterPredicateDef)) && $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        "data-name": "clear-filter",
        className: "twa:p-0",
        variant: "text",
        onClick: handleClear,
        icon: "close"
    }));
};



const $7db81a8a3ba88867$export$944aecd9eea3cb99 = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const { qlPredicate: qlPredicate, qlPredicateDefs: qlPredicateDefs, columnFilter: columnFilter, column: column, handlePredicateChange: handlePredicateChange, handleOnChange: handleOnChange, handleClear: handleClear } = (0, $ea27eebda6956d72$export$f434b594b08f4e1d)(props.Column.columnId, 'FilterBar');
    const onClear = $acw62.useCallback(()=>{
        handleClear();
    }, [
        handleClear
    ]);
    const onPredicateChange = $acw62.useCallback((newPredicate)=>{
        handlePredicateChange(newPredicate);
    }, [
        handlePredicateChange
    ]);
    if (!column) return null;
    return $acw62.createElement((0, $0fed15bd056ea0f0$export$7721514076adf070), {
        onKeydown: (event)=>{
            const key = event.key;
            const predicate = adaptable.api.filterApi.columnFilterApi.internalApi.findPredicateDefByShortcut(key, column);
            if (predicate) {
                event.stopPropagation();
                event.preventDefault();
                handleOnChange([
                    {
                        PredicateId: predicate.id,
                        Inputs: []
                    }
                ]);
            }
        },
        onClear: onClear,
        columnId: props.Column.columnId,
        predicate: qlPredicate,
        predicateDefs: qlPredicateDefs,
        disabled: columnFilter?.IsSuspended,
        onPredicateChange: onPredicateChange
    });
};


const $ba1513febca88082$var$filterContainerStyle = {
    overflow: 'hidden',
    minWidth: '0',
    height: '100%',
    display: 'flex',
    alignItems: 'stretch',
    position: 'relative',
    flex: '1 1 auto'
};
const $ba1513febca88082$export$d4bfbfc27496bf43 = (adaptable)=>{
    const adaptableApi = adaptable.api;
    function getContainerId(colId) {
        return `floatingFilter_${colId}_${adaptable.adaptableOptions.adaptableId}`;
    }
    function getFilterProps(colId) {
        const column = adaptableApi.columnApi.getColumnWithColumnId(colId);
        const columnFilterProps = {
            Column: column,
            Adaptable: adaptable,
            ShowCloseButton: false
        };
        return columnFilterProps;
    }
    function findParentWithClass(element, className, stopClasses, applyToAll) {
        let current = element.parentElement;
        while(current){
            // Stop traversing if we hit any of the stop classes
            if (stopClasses.some((stopClass)=>current.classList.contains(stopClass))) return null;
            if (current.classList.contains(className)) return current;
            applyToAll?.(current);
            current = current.parentElement;
        }
        return null;
    }
    function patchParentElement(filterContainer) {
        if (!filterContainer) return;
        const stopClasses = [
            'ag-header-row',
            'ag-header-row-column-filter'
        ];
        // Find and update floating filter body
        const filterBody = findParentWithClass(filterContainer, 'ag-floating-filter-full-body', stopClasses, (currentElem)=>{
            currentElem.style.height = '100%';
        });
        if (filterBody) filterBody.style.overflow = 'visible';
        // Find and update header cell
        const headerCell = findParentWithClass(filterContainer, 'ag-header-cell', stopClasses);
        if (headerCell?.classList.contains('ag-floating-filter')) headerCell.style.padding = 'var(--ab-base-space)';
    }
    return class AgGridFloatingFilterAdapter {
        colId;
        filterContainer;
        unmountReactRoot;
        init(params) {
            const colId = params.column.getColId();
            this.colId = colId;
            this.filterContainer = document.createElement('div');
            this.filterContainer.id = getContainerId(colId);
            Object.keys($ba1513febca88082$var$filterContainerStyle).forEach((key)=>{
                //@ts-ignore
                this.filterContainer.style[key] = $ba1513febca88082$var$filterContainerStyle[key];
            });
            const column = adaptableApi.columnApi.getColumnWithColumnId(colId);
            if (column) {
                const filterProps = getFilterProps(colId);
                this.unmountReactRoot = adaptable.renderReactRoot((0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)($acw62.createElement((0, $7db81a8a3ba88867$export$944aecd9eea3cb99), {
                    ...filterProps
                }), adaptable), this.filterContainer);
            }
        }
        onParentModelChanged(parentModel, filterChangedEvent) {
        // AFL: this should NOT be required, but AG Grid calls this method
        // most likely is a bug and will be removed in future versions
        }
        afterGuiAttached() {
            patchParentElement(this.filterContainer);
        }
        getGui() {
            return this.filterContainer;
        }
        refresh(params) {
            // always reuse the current instance
            // the filter is refreshed in the underlying React component
            return true;
        }
        destroy() {
            // Use setTimeout to defer unmounting to next event loop tick
            // This ensures we're not unmounting during React's rendering phase
            if (this.unmountReactRoot) {
                const unmount = this.unmountReactRoot;
                setTimeout(()=>{
                    unmount();
                }, 0);
                this.unmountReactRoot = undefined;
            }
            this.filterContainer = null;
        }
    };
};




function $a8be936b3426b8a3$export$550b747aaf69a6bc(columnDataType, variant) {
    if (columnDataType === 'number') return variant === 'react' ? (0, $c3d8609e2b1c456b$export$3ea9d4b212fbd8c8) : (0, $c3d8609e2b1c456b$export$68d9a13d1f99463a);
    if (columnDataType === 'date') return variant === 'react' ? (0, $1895fb0628decee6$export$d2567bcbf88954a7) : (0, $1895fb0628decee6$export$cb88f9a0542eb9dd);
}
class $a8be936b3426b8a3$export$caefbb91be8d6aaf {
    adaptableInstance;
    colDefPropertyCache;
    constructor(adaptableInstance){
        this.adaptableInstance = adaptableInstance;
        this.colDefPropertyCache = new Map();
    }
    getVariant() {
        return this.adaptableInstance.variant;
    }
    destroy() {
        this.adaptableInstance = null;
        this.colDefPropertyCache.clear();
        this.colDefPropertyCache = null;
    }
    get adaptableApi() {
        return this.adaptableInstance.api;
    }
    get adaptableOptions() {
        return this.adaptableInstance.adaptableOptions;
    }
    get agGridApi() {
        return this.adaptableApi.agGridApi;
    }
    setColDefProperty(col, propertyName, propertyGetter) {
        const colId = col.getColId();
        const colDef = col.getColDef();
        const colSetupInfo = {
            col: col,
            colDef: colDef,
            colId: colId
        };
        const userKey = `user.${colId}.${propertyName}`;
        const adaptableKey = `adaptable.${colId}.${propertyName}`;
        const value = colDef[propertyName];
        const isUserDefined = value !== this.colDefPropertyCache.get(adaptableKey);
        if (isUserDefined) this.colDefPropertyCache.set(userKey, value);
        const userValue = this.colDefPropertyCache.get(userKey);
        const adaptableValue = propertyGetter(userValue);
        if (adaptableValue != null) this.colDefPropertyCache.set(adaptableKey, adaptableValue);
        let theValue = adaptableValue ?? userValue;
        this.adaptableInstance.forPlugins((plugin)=>{
            if (plugin.interceptSetupColumnProperty) theValue = plugin.interceptSetupColumnProperty(colSetupInfo, propertyName, theValue, this.adaptableApi);
        });
        if (propertyName === 'aggFunc') {
            if (colDef[propertyName] !== (theValue ?? null)) this.agGridApi?.setColumnAggFunc(colId, theValue ?? null);
        }
        if (theValue === undefined && colDef[propertyName] === undefined) // already undefined, so don't set an own property to the same undefined value
        return;
        colDef[propertyName] = theValue;
    }
    getUserColDefProperty(columnId, propertyName) {
        const userKey = `user.${columnId}.${propertyName}`;
        return this.colDefPropertyCache.get(userKey);
    }
    shouldSkipColumn(colId) {
        /**
         * This skips special columns that ag grid will likely implement in the future
         *
         * BUT DOES NOT SKIP GROUP COLUMNS or SELECTION COLUMNS!!!
         *
         * It's probably here for historical reasons - previously it used to skip the selection column
         * but now it's not skipping it anymore
         */ return colId.startsWith('ag-Grid-') && !this.adaptableApi.columnApi.isAutoRowGroupColumn(colId) && !this.adaptableApi.columnApi.isSelectionColumn(colId);
    }
    getAllAgGridColumns() {
        const pivotMode = this.adaptableInstance.isInPivotMode();
        let cols = pivotMode ? this.agGridApi.getColumns() : // which also includes those that are generated for row grouping
        this.agGridApi.getAllGridColumns();
        if (pivotMode) {
            const pivotResultColumns = this.agGridApi.getPivotResultColumns() || [];
            const autoGroupColumns = this.agGridApi.getAllGridColumns().filter((column)=>this.adaptableApi.columnApi.isAutoRowGroupColumn(column.getColId()));
            cols = [
                ...autoGroupColumns,
                ...cols,
                ...pivotResultColumns
            ];
        }
        return cols;
    }
    /**
     * Setup all columns, or only those with the given Ids
     * @param specificColumnIds - optional list of column Ids to setup. If not provided, all columns are setup
     */ setupColumns(specificColumnIds) {
        let cols = this.getAllAgGridColumns();
        if (specificColumnIds?.length) cols = cols.filter((col)=>specificColumnIds.includes(col.getColId()));
        // this needs to be here, before the other setup below
        // so the setup methods below reference the correct columns in adaptable store
        cols.forEach((col)=>{
            const colDef = col.getColDef();
            const colId = col.getColId();
            if (this.shouldSkipColumn(colId)) return;
            const abColumn = this.adaptableApi.columnApi.getColumnWithColumnId(colId);
            const colSetupInfo = {
                col: col,
                colDef: colDef,
                colId: colId,
                abColumn: abColumn
            };
            const isAutoRowGroupColumn = this.adaptableApi.columnApi.isAutoRowGroupColumn(colId);
            this.setupColumnCellRenderer(colSetupInfo);
            this.setupColumnCellStyle(colSetupInfo);
            this.setupColumnCellClass(colSetupInfo);
            this.setupColumnHeaderStyle(colSetupInfo);
            this.setupColumnHeaderClass(colSetupInfo);
            this.setupColumnValueGetter(colSetupInfo);
            this.setupColumnTooltipValueGetter(colSetupInfo);
            if (!isAutoRowGroupColumn) {
                // we do NOT setup filtering for  auto row group columns
                // this is done via gridOptions.autoGroupColumnDef
                // see #autoGroupColumnDef
                this.setupColumnFilter(colSetupInfo);
                this.setupColumnFloatingFilter(colSetupInfo);
            }
            this.setupColumnValueFormatter(colSetupInfo);
            this.setupColumnEditable(colSetupInfo);
            this.setupColumnValueSetter(colSetupInfo);
            this.setupColumnComparator(colSetupInfo);
            this.setupColumnGetFindText(colSetupInfo);
            this.setupColumnCellEditor(colSetupInfo);
            this.setupColumnHeader(colSetupInfo);
            this.setupColumnQuickFilterText(colSetupInfo);
            this.setupColumnAllowedAggFuncs(colSetupInfo);
            this.setupColumnType(colSetupInfo);
            this.setupColumnCellDataType(colSetupInfo);
        });
    }
    setupColumnValueGetter({ col: col }) {
        // need this here if we want plugins to intercept
        this.setColDefProperty(col, 'valueGetter', (userValue)=>{
            return userValue;
        });
    }
    setupColumnCellClass({ col: col, colId: colId, abColumn: abColumn }) {
        this.setColDefProperty(col, 'cellClass', (userCellClass)=>{
            const formatColumns = this.adaptableApi.formatColumnApi.internalApi.getFormatColumnWithStyleClassNameForColumn(abColumn, {
                target: 'cell'
            });
            const quickSearchTextMatchStyle = this.getQuickSearchTextMatchStyle();
            const quickSearchCurrentTextMatchStyle = this.getQuickSearchCurrentTextMatchStyle();
            const cellClass = (params)=>{
                const gridCell = this.adaptableApi.gridApi.getGridCellFromRowNode(params.node, abColumn.columnId);
                if (!gridCell.column) return null;
                const isExcelExport = this.adaptableApi.exportApi.internalApi.isExcelExportInProgress();
                const isVisualDataExport = this.adaptableApi.exportApi.internalApi.isVisualDataExportInProgress();
                if (isExcelExport || isVisualDataExport) {
                    const excelStyleClasses = [];
                    const userDefinedCellClass = typeof userCellClass === 'function' ? userCellClass(params) : userCellClass;
                    if (userDefinedCellClass) {
                        if (Array.isArray(userDefinedCellClass)) excelStyleClasses.push(...userDefinedCellClass.filter(Boolean));
                        else excelStyleClasses.push(userDefinedCellClass);
                    }
                    if (isVisualDataExport) {
                        const cellClassKey = (0, $160c6fe5c8b728e7$export$d17645576d7c2129).getExcelClassNameForCell(colId, gridCell.primaryKeyValue, userDefinedCellClass);
                        const customCellClass = this.adaptableInstance.agGridExportAdapter.getExcelStyleIdForClassKey(cellClassKey);
                        if (customCellClass) excelStyleClasses.push(customCellClass);
                    }
                    return excelStyleClasses.length ? excelStyleClasses : null;
                }
                const isQuickSearchActive = this.isQuickSearchActive(gridCell);
                const editableClassName = this.getEditableCellClass(gridCell, params);
                const readonlyClassName = this.getReadonlyCellClass(gridCell, params);
                const editedClassName = this.getEditedCellClass(gridCell, params);
                const highlightAlertClassName = this.getAlertCellClass(gridCell, params);
                const flashingClassName = this.getFlashingCellClass(gridCell, params);
                const styledColumn = this.adaptableApi.styledColumnApi.getStyledColumnForColumnId(colId);
                const hasStyledColumn = !!styledColumn && !styledColumn.IsSuspended;
                const noteClassName = this.getNoteCellClassName(gridCell, params);
                const commentsClassName = this.getCommentCellClassName(gridCell, params);
                const returnValue = [
                    typeof userCellClass === 'function' ? userCellClass(params) : userCellClass,
                    !hasStyledColumn && formatColumns.length ? this.getFormatColumnCellClass(formatColumns, abColumn, params) : null,
                    //  isQuickSearchActive && hasQuickSearchStyleClassName ? quickSearchStyleClassName : null,
                    isQuickSearchActive && (quickSearchTextMatchStyle || quickSearchCurrentTextMatchStyle) ? 'ab-QuickSearchFind' : null,
                    editableClassName,
                    readonlyClassName,
                    editedClassName,
                    highlightAlertClassName,
                    flashingClassName,
                    noteClassName,
                    commentsClassName
                ]// we flatten the array because some rules ('userCellClass' etc)  might return a string[]
                .flat().filter((x)=>!!x);
                const result = returnValue.length ? returnValue : undefined;
                return result;
            };
            return cellClass;
        });
    }
    setupColumnHeaderClass({ col: col, colId: colId, abColumn: abColumn }) {
        this.setColDefProperty(col, 'headerClass', (userHeaderClass)=>{
            const headerClass = (params)=>{
                let baseHeaderClass = [];
                // inherit styles from user provided colDef property
                const userDefinedHeaderClass = typeof userHeaderClass === 'function' ? userHeaderClass(params) : userHeaderClass;
                if (userDefinedHeaderClass) baseHeaderClass = typeof userDefinedHeaderClass === 'string' ? [
                    userDefinedHeaderClass
                ] : Array.isArray(userDefinedHeaderClass) ? userDefinedHeaderClass : [
                    userDefinedHeaderClass
                ];
                if (params.floatingFilter) // we NEVER style floating filters
                return baseHeaderClass;
                if (params.columnGroup) // we TEMPORARILY do NOT style column groups
                // see https://github.com/AdaptableTools/adaptable/issues/2947#issuecomment-3062304655
                return baseHeaderClass;
                const isExcelExport = this.adaptableApi.exportApi.internalApi.isExcelExportInProgress();
                const isVisualDataExport = this.adaptableApi.exportApi.internalApi.isVisualDataExportInProgress();
                if (isExcelExport || isVisualDataExport) {
                    const excelStyleHeaderClasses = [];
                    if (userDefinedHeaderClass) {
                        if (Array.isArray(userDefinedHeaderClass)) excelStyleHeaderClasses.push(...userDefinedHeaderClass.filter(Boolean));
                        else excelStyleHeaderClasses.push(userDefinedHeaderClass);
                    }
                    if (isVisualDataExport) {
                        const headerClassKey = (0, $160c6fe5c8b728e7$export$d17645576d7c2129).getExcelClassNameForHeader(colId, userDefinedHeaderClass);
                        const customHeaderClass = this.adaptableInstance.agGridExportAdapter.getExcelStyleIdForClassKey(headerClassKey);
                        if (customHeaderClass) excelStyleHeaderClasses.push(customHeaderClass);
                    }
                    return excelStyleHeaderClasses.length ? excelStyleHeaderClasses : null;
                }
                const columnId = params.column.getColId();
                const adaptableColumn = this.adaptableApi.columnApi.getColumnWithColumnId(columnId);
                if (!adaptableColumn) return baseHeaderClass;
                const target = 'columnHeader';
                // handle special case of headers with text alignment
                // in this case, we add a specific class to the header
                // see #header_text_align
                const formatColumnWithTextAlignment = this.getRelevantFormatColumnHeaderStyles(abColumn)// we take the first one only, even if multiple are defined
                .find((fc)=>fc.Style?.Alignment != undefined);
                if (formatColumnWithTextAlignment) {
                    const alignment = formatColumnWithTextAlignment.Style.Alignment.toLowerCase();
                    baseHeaderClass = [
                        ...baseHeaderClass,
                        `ab-header__align-${alignment}`
                    ];
                }
                const formatColumns = this.adaptableApi.formatColumnApi.internalApi.getFormatColumnWithStyleClassNameForColumn(abColumn, {
                    target: target
                });
                if (!formatColumns.length) return baseHeaderClass;
                const formatColumnClasses = formatColumns.map((formatColumn)=>{
                    if (formatColumn.Style?.ClassName && this.adaptableApi.formatColumnApi.internalApi.formatColumnShouldRenderInHeader(formatColumn, abColumn)) return formatColumn.Style?.ClassName;
                }).filter((x)=>!!x);
                return [
                    ...baseHeaderClass,
                    ...formatColumnClasses
                ];
            };
            return headerClass;
        });
    }
    setupColumnCellStyle({ col: col }) {
        this.setColDefProperty(col, 'cellStyle', (userCellStyle)=>{
            const quickSearchStyle = this.getQuickSearchCellStyle();
            const quickSearchTextMatchStyle = this.getQuickSearchTextMatchStyle();
            const quickSearchCurrentTextMatchStyle = this.getQuickSearchCurrentTextMatchStyle();
            const textMatchStyle = quickSearchTextMatchStyle ? Object.entries(quickSearchTextMatchStyle).reduce((acc, [key, value])=>{
                // needed as AG-Grid vanilla turns all CSS props
                // to kebab, while AG Grid React does not
                // @ts-ignore
                acc[`--ab-dynamic-${(0, $9ce0650a2a8dba81$export$2e2bcd8739ae039)(key)}`] = value;
                return acc;
            }, {}) : undefined;
            const currentTextMatchStyle = quickSearchCurrentTextMatchStyle ? Object.entries(quickSearchCurrentTextMatchStyle).reduce((acc, [key, value])=>{
                // @ts-ignore
                acc[`--ab-dynamic-${(0, $9ce0650a2a8dba81$export$2e2bcd8739ae039)(key)}`] = value;
                return acc;
            }, {}) : undefined;
            const hasQuickSearchStyle = quickSearchStyle != undefined || quickSearchCurrentTextMatchStyle != undefined;
            const cellStyle = (params)=>{
                const columnId = params.column.getColId();
                const gridCell = this.adaptableApi.gridApi.getGridCellFromRowNode(params.node, columnId);
                if (!gridCell || !gridCell.column) return {};
                const isQuickSearchActive = hasQuickSearchStyle && this.isQuickSearchActive(gridCell);
                const isQuickSearchAvailable = this.adaptableApi.internalApi.getModuleService().isAdapTableModulePresent('QuickSearch');
                const isCurrentMatch = isQuickSearchAvailable && this.adaptableApi.agGridApi.findGetActiveMatch()?.node === params.node;
                const textStyleToApply = isCurrentMatch ? {
                    ...textMatchStyle,
                    ...currentTextMatchStyle
                } : textMatchStyle;
                let baseStyles = {};
                // this is required because otherwise, when AG Grid filters, it refreshed the pivotResultColDef and the base styles get lost
                // if pivot result col: inherit styles from base column
                if (this.adaptableApi.columnApi.isPivotResultColumn(columnId)) {
                    const baseColumn = params.column.getColDef()?.pivotValueColumn;
                    if (baseColumn) {
                        const baseColDefCellStyle = baseColumn?.getColDef()?.cellStyle;
                        const baseColParams = {
                            ...params,
                            column: baseColumn,
                            // @ts-ignore
                            // #derived_pivot_cell_style
                            __pivotResultColumn: params.column
                        };
                        baseStyles = typeof baseColDefCellStyle === 'function' ? baseColDefCellStyle(baseColParams) : baseColDefCellStyle;
                    }
                } else // inherit styles from user provided colDef property
                baseStyles = typeof userCellStyle === 'function' ? userCellStyle(params) : userCellStyle;
                const result = {
                    ...baseStyles,
                    ...this.getReadOnlyCellStyle(gridCell, params),
                    ...this.getEditableCellStyle(gridCell, params),
                    ...this.getEditedCellStyle(gridCell, params),
                    ...this.getFormatColumnAndStyledColumnCellStyle(gridCell.column, params),
                    ...isQuickSearchActive ? quickSearchStyle : {},
                    ...isQuickSearchActive && textStyleToApply ? textStyleToApply : {},
                    ...this.getAlertCellStyle(gridCell, params),
                    ...this.getFlashingCellStyle(gridCell, params),
                    ...this.getCellHighlightStyle(gridCell, params),
                    ...this.getColumnHighlightStyle(gridCell, params)
                };
                return (0, $0f8018328b88def3$export$8a5809405306d9ac)(result);
            };
            return cellStyle;
        });
    }
    setupColumnHeaderStyle({ col: col }) {
        this.setColDefProperty(col, 'headerStyle', (userHeaderStyle)=>{
            const headerStyleFunc = (params)=>{
                let baseStyles = {};
                // inherit styles from user provided colDef property
                baseStyles = typeof userHeaderStyle === 'function' ? userHeaderStyle(params) : userHeaderStyle;
                if (params.floatingFilter) // we NEVER style floating filters
                return baseStyles;
                const columnId = params.column.getColId();
                const adaptableColumn = this.adaptableApi.columnApi.getColumnWithColumnId(columnId);
                if (!adaptableColumn) return baseStyles;
                const result = {
                    ...baseStyles,
                    ...this.getFormatColumnHeaderStyle(adaptableColumn, params)
                };
                if (result['borderColor']) {
                    // by default, header cells don't have a border
                    // if the user defines a border-color, we assume he wants to show a border
                    result['borderWidth'] = `1px`;
                    result['borderStyle'] = 'solid';
                }
                return (0, $0f8018328b88def3$export$8a5809405306d9ac)(result);
            };
            return headerStyleFunc;
        });
    }
    setupColumnCellEditor({ colId: colId, col: col, colDef: colDef, abColumn: abColumn }) {
        const shouldShowSelectCellEditor = this.adaptableApi.userInterfaceApi.internalApi.shouldShowSelectCellEditor(abColumn);
        const hasRichSelectCellEditor = this.adaptableApi.internalApi.getAgGridModulesAdapter().isAgGridModuleRegistered('RichSelectModule');
        this.setColDefProperty(col, 'cellEditor', ()=>{
            if (shouldShowSelectCellEditor) {
                if (hasRichSelectCellEditor) return 'agRichSelectCellEditor';
                else {
                    this.adaptableApi.logWarn(`Cannot show Select Editor as missing required AG Grid module: RichSelect`);
                    return colDef.cellEditor;
                }
            } else {
                if (colDef.cellEditor) return colDef.cellEditor;
                const cellDataTypeEditor = $a8be936b3426b8a3$export$550b747aaf69a6bc(abColumn.dataType, this.getVariant());
                return cellDataTypeEditor;
            }
        });
        this.setColDefProperty(col, 'cellEditorParams', (params)=>{
            if (shouldShowSelectCellEditor) return (params)=>{
                const gridCell = this.adaptableApi.gridApi.getGridCellFromRowNode(params?.node, colId);
                const options = this.adaptableApi.gridApi.internalApi.getDistinctEditDisplayValuesForColumn({
                    columnId: colId,
                    gridCell: gridCell,
                    currentSearchValue: ''
                });
                const valueToLabelMap = new Map();
                const values = options.then((options)=>options.map((option)=>{
                        valueToLabelMap.set(option.value, option.label);
                        return option.value;
                    }));
                const fetchSelectItems = (_params)=>{
                    return values;
                };
                return {
                    // we need to pass a function which returns a Promise, that's what AG Grid expects
                    values: fetchSelectItems,
                    formatValue: (value)=>valueToLabelMap.get(value) ?? value
                };
            };
        });
    }
    setupColumnCellRenderer({ col: col, colId: colId, abColumn: abColumn }) {
        this.setColDefProperty(col, 'cellRenderer', ()=>{
            const styledColumn = this.adaptableApi.styledColumnApi.getStyledColumnForColumnId(abColumn.columnId);
            if (styledColumn && !styledColumn.IsSuspended) {
                if (styledColumn.PercentBarStyle) return (0, $3206bef83a3aa737$export$42d85ff3a09ca2f2)(styledColumn, abColumn, this.adaptableApi);
                if (styledColumn.BadgeStyle) return (0, $7707ebad78b35e4b$export$4dbc5fcac3c87889)(styledColumn.BadgeStyle, abColumn, this.adaptableApi);
                if (styledColumn.SparklineStyle) return 'agSparklineCellRenderer';
            }
        });
        this.setColDefProperty(col, 'cellRendererParams', (userDefined)=>{
            const styledColumn = this.adaptableApi.styledColumnApi.getStyledColumnForColumnId(abColumn.columnId);
            if (styledColumn && !styledColumn.IsSuspended) {
                if (styledColumn.SparklineStyle) {
                    const sanitizedSparklineOptions = (0, $792d5f2a0e72dfac$export$497fb46ca5a98a2f).removeAdaptableObjectPrimitives(styledColumn.SparklineStyle.options);
                    const sparklineOptions = (0, $88a6c58c74f77d1a$export$2e2bcd8739ae039)({}, userDefined?.sparklineOptions, sanitizedSparklineOptions);
                    return {
                        ...userDefined,
                        sparklineOptions: sparklineOptions
                    };
                }
            }
        });
    }
    setupColumnTooltipValueGetter({ col: col, colId: colId, abColumn: abColumn }) {
        let hasTooptip = false;
        this.setColDefProperty(col, 'tooltipValueGetter', ()=>{
            const styledColumn = this.adaptableApi.styledColumnApi.getStyledColumnForColumnId(colId);
            if (styledColumn && !styledColumn.IsSuspended && styledColumn.PercentBarStyle && styledColumn.PercentBarStyle.ToolTipText) {
                hasTooptip = true;
                if (styledColumn?.PercentBarStyle) return (params)=>{
                    const min = this.adaptableApi.styledColumnApi.internalApi.getNumericStyleMinValue(styledColumn, abColumn, params.node, params.value);
                    const max = this.adaptableApi.styledColumnApi.internalApi.getNumericStyleMaxValue(styledColumn, abColumn, params.node, params.value);
                    const textOptions = styledColumn.PercentBarStyle.ToolTipText;
                    let returnValue = '';
                    if (textOptions.includes('CellValue')) returnValue = params.value;
                    if (textOptions.includes('PercentageValue')) {
                        let percentageValue;
                        if (styledColumn.PercentBarStyle.ColumnComparison) {
                            const absMax = Math.abs(max);
                            percentageValue = absMax === 0 ? 0 : Number(params.value) / absMax * 100;
                        } else {
                            const clampedValue = (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).clamp(params.value, min, max);
                            percentageValue = (clampedValue - min) / (max - min) * 100;
                        }
                        returnValue += ' ' + `(${percentageValue.toFixed(0)}%)`;
                    }
                    return returnValue ? returnValue : params.value;
                };
            }
        });
    }
    setupColumnQuickFilterText({ col: col, abColumn: abColumn }) {
        this.setColDefProperty(col, 'getQuickFilterText', (userGetQuickFilterText)=>{
            if (userGetQuickFilterText) return userGetQuickFilterText;
            return (params)=>{
                const visibleColumnsMap = this.adaptableApi.layoutApi.getCurrentVisibleColumnIdsMapForTableLayout();
                const isVisible = visibleColumnsMap[abColumn.columnId];
                if (!isVisible) return '';
                return this.adaptableApi.gridApi.getDisplayValueFromRowNode(params.node, abColumn.columnId);
            };
        });
    }
    setupColumnAllowedAggFuncs({ col: col, abColumn: abColumn }) {
        this.setColDefProperty(col, 'allowedAggFuncs', ()=>{
            if (!abColumn.availableAggregationFunctions) return undefined;
            return abColumn.availableAggregationFunctions.filter((func)=>!(0, $8b34480a73f8989d$export$baafdf6332da7837)(func));
        });
    }
    setupColumnType(columnSetupInfo) {
        const { col: col, colId: colId } = columnSetupInfo;
        // AG Grid introduced since v30.x an inferred cellDataType
        // the problem is that it breaks the default value formatter and/or editor (especially for Date columns)
        this.setColDefProperty(col, 'type', (original_columnType)=>{
            const originalTypes = original_columnType == undefined ? [] : Array.isArray(original_columnType) ? original_columnType : [
                original_columnType
            ];
            const columnTypes = new Set(originalTypes);
            if (this.adaptableApi.columnApi.isCalculatedColumn(colId)) columnTypes.add((0, $b0d14b794bdca4f2$export$8e5ee678cfc318c5));
            if (this.adaptableApi.columnApi.isFreeTextColumn(colId)) columnTypes.add((0, $b0d14b794bdca4f2$export$2460c0dec1fc4d43));
            if (this.adaptableApi.columnApi.isActionColumn(colId)) columnTypes.add((0, $b0d14b794bdca4f2$export$bc60d51b21bb9885));
            if (this.adaptableApi.columnApi.isFdc3Column(colId)) columnTypes.add((0, $b0d14b794bdca4f2$export$aee5eaf013923665));
            return Array.from(columnTypes);
        });
    }
    setupColumnCellDataType(columnSetupInfo) {
        const { col: col, colId: colId } = columnSetupInfo;
        this.setColDefProperty(col, 'cellDataType', (original_cellDataType)=>{
            // #map_dateString_to_date
            if (original_cellDataType === 'dateString') {
                (0, $10f858c943b30cc8$export$45c997b35cb132f6)(`AG Grid: Column '${colId}' specifies cellDataType='dateString' which is no longer supported. It has been automatically replaced with cellDataType='date'. Please update your column definition.`);
                return 'date';
            }
            return original_cellDataType ?? true;
        });
    }
    setupColumnHeader({ col: col }) {
        this.setColDefProperty(col, 'headerValueGetter', (original_headerValueGetter)=>{
            // see #customize_header
            if (!(0, $aba1af7dfef01b91$export$fd2dc7242e4494f2)(original_headerValueGetter)) this.adaptableApi.logWarn(`colDef.headerValueGetter is defined for column '${col.getColId()}', and overrides the Adaptable custom header mechanism! We recommend using a ColumnOptions.columnHeader instead!`);
            return original_headerValueGetter;
        });
    }
    setupColumnFilter(columnSetup) {
        const { col: col, colDef: colDef, abColumn: abColumn, colId: colId } = columnSetup;
        const useAdaptableFilter = this.adaptableOptions.filterOptions.useAdaptableFiltering;
        if (!useAdaptableFilter) return;
        // setup Auto Group Column Filter
        if (this.adaptableApi.columnApi.isAutoRowGroupColumn(col.getColId())) {
            if (this.adaptableApi.gridApi.isTreeDataGrid()) this.setColDefProperty(col, 'filter', (original_filter)=>{
                const autoGroupColumnDef = this.agGridApi.getGridOption('autoGroupColumnDef');
                if (autoGroupColumnDef?.filter != undefined) // we plan to provide a TreeListColumnFilter
                // until then, it's the user's responsibility to explicitly set the filter in the provided `autoGroupColumnDef`
                return original_filter;
                else // if no filter is explicitly set, we do NOT provide a filter
                return false;
            });
            else // TODO only set auto group column as filterable if at least one group columns is filterable
            this.setColDefProperty(col, 'filter', ()=>{
                return 'agGroupColumnFilter';
            });
            if (this.adaptableApi.columnApi.isAutoRowGroupColumnForMulti(colId)) return;
        }
        // setup "normal" column filter
        this.setColDefProperty(col, 'filter', (original_filter)=>{
            const pivotMode = this.adaptableInstance.isInPivotMode();
            if (!useAdaptableFilter) return original_filter;
            if (!colDef.filter) return;
            if (typeof original_filter !== 'boolean' && typeof original_filter?.handler !== 'function' && !pivotMode) {
                this.adaptableApi.consoleError(`Column "${colId}" has a custom filter in colDef.filter, but Adaptable filtering only accepts boolean (true/false) values for this property.`);
                return false;
            }
            return {
                component: (0, $c168dc980eb01782$export$3082f1e1d504f03c)(this.adaptableInstance),
                handler: ()=>new (0, $a23991341724d458$export$e706c937f1e8c12d)(this.adaptableApi)
            };
        });
    }
    setupColumnFloatingFilter({ col: col, colDef: colDef }) {
        const userProvidedFilterProp = this.getUserColDefProperty(col.getColId(), 'filter');
        const hasInvalidFilterProp = typeof userProvidedFilterProp !== 'boolean' && typeof userProvidedFilterProp?.handler !== 'function' && !this.adaptableInstance.isInPivotMode();
        if (hasInvalidFilterProp) // warning is logged in the 'setupColumnFilter' method
        return false;
        const isFloatingFilterDisabled = !colDef.filter || !colDef.floatingFilter || !this.adaptableOptions.filterOptions.useAdaptableFiltering || !this.adaptableApi.filterApi.columnFilterApi.isQuickFilterVisible();
        if (this.adaptableApi.columnApi.isAutoRowGroupColumnForMulti(col.getColId())) {
            this.setColDefProperty(col, 'floatingFilter', (original_floatingFilter)=>{
                // the floating filter for the group column is "inherited" from the base column
                // via the colDef.filter =  'agGroupColumnFilter'
                // see #group_inherit_column_filter
                // https://www.ag-grid.com/javascript-data-grid/grouping-single-group-column/#inherit-row-grouped-columns-filters
                // https://www.ag-grid.com/javascript-data-grid/grouping-multiple-group-columns/#filtering
                return original_floatingFilter;
            });
            this.setColDefProperty(col, 'suppressFloatingFilterButton', ()=>{
                // hide button for multi column groups
                return true;
            });
            return;
        }
        this.setColDefProperty(col, 'floatingFilterComponent', ()=>{
            if (isFloatingFilterDisabled) return;
            return (0, $ba1513febca88082$export$d4bfbfc27496bf43)(this.adaptableInstance);
        });
        this.setColDefProperty(col, 'floatingFilter', ()=>{
            if (isFloatingFilterDisabled) return;
            return (0, $ba1513febca88082$export$d4bfbfc27496bf43)(this.adaptableInstance);
        });
        this.setColDefProperty(col, 'suppressFloatingFilterButton', ()=>{
            return !isFloatingFilterDisabled;
        });
    }
    setupColumnValueFormatter({ col: col, abColumn: abColumn }) {
        this.setColDefProperty(col, 'valueFormatter', (userPropertyValue)=>{
            const activeFormatColumnsWithDisplayFormat = this.adaptableApi.formatColumnApi.internalApi.getFormatColumnsWithDisplayFormatForColumn(abColumn, {
                target: 'cell'
            });
            if (!activeFormatColumnsWithDisplayFormat.length) return;
            return (params)=>{
                const { node: node, value: value } = params;
                const mostRelevantFormatColumn = this.adaptableApi.formatColumnApi.internalApi.getMostRelevantFormatColumnForColumn(activeFormatColumnsWithDisplayFormat, abColumn, {
                    node: node,
                    value: value
                });
                if (!mostRelevantFormatColumn) // ALL FormatColumns are conditional and NONE of them are relevant for this row
                return value;
                const formatterOptions = mostRelevantFormatColumn.DisplayFormat.Options;
                if (mostRelevantFormatColumn.DisplayFormat.Formatter === 'NumberFormatter') // change the Number format - if the scope allows it
                {
                    if (this.adaptableApi.columnScopeApi.isColumnInNumericScope(abColumn, mostRelevantFormatColumn.Scope)) {
                        let cellValue = params.value;
                        if (typeof params.value?.toNumber === 'function' && typeof params.value?.toString === 'function') // aggregation values are wrapped in an AG Grid specific object
                        cellValue = params.value.toNumber();
                        return this.adaptableApi.formatColumnApi.internalApi.getNumberFormattedValue(cellValue, params.node, abColumn, formatterOptions);
                    }
                }
                if (mostRelevantFormatColumn.DisplayFormat.Formatter === 'DateFormatter') // change the Date format - if the scope allows it
                {
                    if (this.adaptableApi.columnScopeApi.isColumnInDateScope(abColumn, mostRelevantFormatColumn.Scope)) {
                        let cellValue = params.value;
                        if (typeof params.value?.toNumber === 'function' && typeof params.value?.toString === 'function') // aggregation values are wrapped in an AG Grid specific object
                        cellValue = params.value.toString();
                        return this.adaptableApi.formatColumnApi.internalApi.getDateFormattedValue(cellValue, params.node, abColumn, formatterOptions);
                    }
                }
                if (mostRelevantFormatColumn.DisplayFormat.Formatter === 'StringFormatter') // change the String format - if the scope allows it
                {
                    if (this.adaptableApi.columnScopeApi.isColumnInTextScope(abColumn, mostRelevantFormatColumn.Scope)) {
                        let cellValue = params.value;
                        if (typeof params.value?.toNumber === 'function' && typeof params.value?.toString === 'function') // aggregation values are wrapped in an AG Grid specific object
                        cellValue = params.value.toString();
                        return this.adaptableApi.formatColumnApi.internalApi.getStringFormattedValue(cellValue, params.node, abColumn, formatterOptions);
                    }
                }
                // should NEVER arrive at this line, but just to be sure
                return value;
            };
        });
    }
    setupColumnEditable({ col: col }) {
        this.setColDefProperty(col, 'editable', (original_editable)=>{
            // cell is NOT editable by default
            const editableCallback = (params)=>{
                const getOriginalColDefEditable = ()=>{
                    if (typeof original_editable === 'function') return original_editable(params);
                    else return original_editable;
                };
                // 1. evaluate EditOptions.isCellEditable if provided
                if (this.adaptableApi.gridApi.internalApi.hasCellEditableAccordingToEditOptions()) {
                    const gridCell = this.adaptableApi.gridApi.getGridCellFromRowNode(params.node, params.column.getColId());
                    const editOptionsEditability = this.adaptableApi.gridApi.internalApi.isCellEditableAccordingToEditOptions(gridCell, getOriginalColDefEditable());
                    if (editOptionsEditability) return editOptionsEditability;
                }
                // 2. otherwise, fallback to colDef.editable
                return getOriginalColDefEditable();
            };
            return editableCallback;
        });
    }
    setupColumnValueSetter({ col: col, colId: colId, abColumn: abColumn }) {
        this.setColDefProperty(col, 'valueSetter', (userValueSetter)=>{
            const preventEditAlertsForColumn = this.adaptableApi.alertApi.internalApi.getAlertDefinitionsWithPreventEdit().filter((alertDefinition)=>{
                return this.adaptableApi.columnScopeApi.isColumnInScope(abColumn, alertDefinition.Scope);
            });
            const noValidations = !preventEditAlertsForColumn.length && !this.adaptableOptions.editOptions?.validateOnServer;
            if (noValidations) return;
            const valueSetter = (params)=>{
                const field = params.column.getColDef().field;
                if (noValidations) {
                    //TODO also consider the case when userValueSetter is a string
                    if (typeof userValueSetter === 'function') return userValueSetter(params);
                    // we allowed it go reach this point
                    // just to run isCellEditable
                    // and since this has already run and we have no other validations
                    // just assign the new value and exit
                    if (field) params.data[field] = params.newValue;
                    return true;
                }
                const cellDataChangedInfo = this.adaptableApi.internalApi.buildCellDataChangedInfo({
                    oldValue: params.oldValue,
                    newValue: params.newValue,
                    column: this.adaptableApi.columnApi.getColumnWithColumnId(params.column.getColId()),
                    primaryKeyValue: this.adaptableApi.gridApi.getPrimaryKeyValueForRowNode(params.node),
                    rowNode: params.node,
                    trigger: 'edit'
                });
                if (cellDataChangedInfo.oldValue === cellDataChangedInfo.newValue) return true;
                /**
                 * Validate on the future row, with the new value.
                 * structuredClone fails, it contains functions.
                 */ const newRow = {
                    ...params.node,
                    data: {
                        ...params.node.data
                    }
                };
                newRow.data[field] = params.newValue;
                const cellDataChangeInfoForSyncValidation = {
                    ...cellDataChangedInfo,
                    rowNode: newRow
                };
                if (!this.adaptableApi.internalApi.getValidationService().performValidation(cellDataChangeInfoForSyncValidation)) return false;
                const onServerValidationCompleted = ()=>{};
                if (this.adaptableOptions.editOptions?.validateOnServer) this.adaptableApi.internalApi.getValidationService().performServerValidation(cellDataChangedInfo, {
                    onServerValidationCompleted: onServerValidationCompleted
                })();
                //TODO also consider the case when userValueSetter is a string
                if (typeof userValueSetter === 'function') return userValueSetter(params);
                if (field) params.data[field] = params.newValue;
                else throw `Cannot edit a column without a field - column id was ${colId}`;
                return true;
            };
            return valueSetter;
        });
    }
    setupColumnComparator({ col: col, colId: colId, abColumn: abColumn }) {
        const customSort = this.adaptableApi.customSortApi.getCustomSortForColumn(colId);
        const customSortComparer = this.adaptableApi.customSortApi.internalApi.getCustomSortComparer(abColumn.columnId);
        const memoizedDateValues = new Map();
        const getDateValue = (rawDateValue)=>{
            if (memoizedDateValues.has(rawDateValue)) return memoizedDateValues.get(rawDateValue);
            const dateValue = this.adaptableApi.internalApi.parseDateValue(rawDateValue);
            memoizedDateValues.set(rawDateValue, dateValue);
            return dateValue;
        };
        const comparatorGetter = (propName)=>{
            return (userPropertyValue)=>{
                // CustomSort Comparer function takes precedence over CustomSort SortedValues
                if (customSortComparer) return customSortComparer.comparer;
                if (customSort && !customSort.IsSuspended) return this.adaptableApi.customSortApi.internalApi.getDefaultCustomSortComparer(customSort.ColumnId, customSort.SortedValues);
                if (userPropertyValue) return userPropertyValue;
                // for DATE columns we have to use the normalised values (Date objects) to compare
                if (abColumn.dataType === 'date') return (valueA, valueB)=>{
                    const dateA = getDateValue(valueA);
                    const dateB = getDateValue(valueB);
                    if (dateA && dateB) return dateA.getTime() - dateB.getTime();
                    else if (dateA) return 1; // consider non-null dates as greater than null/undefined
                    else if (dateB) return -1; // consider non-null dates as greater than null/undefined
                    else return 0; // both are null/undefined, considered equal
                };
            };
        };
        this.setColDefProperty(col, 'comparator', comparatorGetter('comparator'));
        this.setColDefProperty(col, 'pivotComparator', comparatorGetter('pivotComparator'));
    }
    setupColumnGetFindText({ col: col, abColumn: abColumn }) {
        this.setColDefProperty(col, 'getFindText', (userGetFindText)=>{
            return (params)=>{
                const gridCell = this.adaptableApi.gridApi.getGridCellFromRowNode(params.node, abColumn.columnId);
                if (!this.isCellSearchable(gridCell)) return null;
                const getCellSearchText = this.adaptableOptions.quickSearchOptions.getCellSearchText;
                if (getCellSearchText) return this.getCellSearchText(gridCell);
                return userGetFindText?.(params) ?? gridCell.displayValue;
            };
        });
    }
    getCellSearchText(gridCell) {
        const getCellSearchText = this.adaptableOptions.quickSearchOptions.getCellSearchText;
        if (getCellSearchText) {
            const quickSearchValue = this.adaptableApi.quickSearchApi.getQuickSearchValue();
            const quickSearchContext = {
                ...this.adaptableApi.internalApi.buildBaseContext(),
                gridCell: gridCell,
                quickSearchValue: quickSearchValue
            };
            return getCellSearchText(quickSearchContext);
        }
        return gridCell.displayValue;
    }
    isCellSearchable(gridCell) {
        const isCellSearchableFn = this.adaptableOptions.quickSearchOptions.isCellSearchable;
        if (!gridCell.column) return false;
        if (isCellSearchableFn) {
            const quickSearchValue = this.adaptableApi.quickSearchApi.getQuickSearchValue();
            const quickSearchContext = {
                ...this.adaptableApi.internalApi.buildBaseContext(),
                gridCell: gridCell,
                quickSearchValue: quickSearchValue
            };
            if (!isCellSearchableFn(quickSearchContext)) return false;
        }
        return true;
    }
    isQuickSearchActive(gridCell) {
        const isQuickSearchAvailable = this.adaptableApi.internalApi.getModuleService().isAdapTableModulePresent('QuickSearch');
        if (!isQuickSearchAvailable) return false;
        const quickSearchValue = this.adaptableApi.quickSearchApi.getQuickSearchValue();
        if (!quickSearchValue) return false;
        if (!this.isCellSearchable(gridCell)) return false;
        let column = this.agGridApi.getColumn(gridCell.column.columnId);
        if (!column && this.adaptableApi.layoutApi.isCurrentLayoutPivot()) column = this.agGridApi.getAllGridColumns().find((col)=>col.getColId() === gridCell.column.columnId);
        if (!column) return false;
        const isServerSideRowModel = this.adaptableApi.gridApi.getAgGridRowModelType() === 'serverSide';
        if (isServerSideRowModel) {
            const isCaseSensitive = this.adaptableOptions.quickSearchOptions.isQuickSearchCaseSensitive;
            const cellDisplayValue = String(this.getCellSearchText(gridCell));
            const displayValue = isCaseSensitive ? cellDisplayValue : cellDisplayValue.toLocaleLowerCase();
            const searchText = isCaseSensitive ? quickSearchValue : quickSearchValue.toLocaleLowerCase();
            return displayValue.indexOf(searchText) !== -1;
        }
        return this.agGridApi.findGetNumMatches({
            column: column,
            node: gridCell.rowNode
        }) > 0;
    }
    getEditableCellClass(gridCell, params) {
        const editableCellStyle = this.adaptableApi.userInterfaceApi.getEditableCellStyle();
        if (!editableCellStyle?.ClassName) return null;
        const isCellEditable = this.adaptableApi.gridApi.isCellEditable(gridCell);
        return isCellEditable ? editableCellStyle.ClassName : null;
    }
    getReadonlyCellClass(gridCell, params) {
        const readonlyCellStyle = this.adaptableApi.userInterfaceApi.getReadOnlyCellStyle();
        if (!readonlyCellStyle?.ClassName) return null;
        const isCellReadonly = !this.adaptableApi.gridApi.isCellEditable(gridCell);
        return isCellReadonly ? readonlyCellStyle.ClassName : null;
    }
    getEditedCellClass(gridCell, params) {
        const editedCellStyle = this.adaptableApi.userInterfaceApi.getEditedCellStyle();
        if (!editedCellStyle?.ClassName) return null;
        const isCellEdited = this.adaptableApi.gridApi.isCellEdited(gridCell);
        return isCellEdited ? editedCellStyle.ClassName : null;
    }
    getAlertCellClass(gridCell, params) {
        const alert = this.adaptableApi.alertApi.internalApi.getAdaptableAlertWithHighlightCell(gridCell.column.columnId, params.node);
        const highlightCell = alert?.alertDefinition?.AlertProperties?.HighlightCell;
        return typeof highlightCell === 'object' && highlightCell?.ClassName ? highlightCell?.ClassName : null;
    }
    getFlashingCellClass(gridcell, params) {
        const primaryKey = params.node.aggData ? params.node.id : gridcell.primaryKeyValue;
        const flashingCell = this.adaptableApi.flashingCellApi.internalApi.getAdaptableFlashingCellFor(primaryKey, gridcell.column.columnId);
        if (!flashingCell) return;
        return flashingCell.direction === 'up' ? flashingCell.flashingCellDefinition.UpChangeStyle?.ClassName : flashingCell.direction === 'down' ? flashingCell.flashingCellDefinition.DownChangeStyle?.ClassName : flashingCell.direction === 'neutral' ? flashingCell.flashingCellDefinition.NeutralChangeStyle?.ClassName : undefined;
    }
    getNoteCellClassName(gridCell, params) {
        if (!this.adaptableApi.internalApi.getModuleService().isAdapTableModulePresent('Note')) return;
        if (!this.adaptableApi.noteApi.internalApi.areNotesSupported()) return;
        const cellPosition = {
            PrimaryKeyValue: gridCell.primaryKeyValue,
            ColumnId: gridCell.column.columnId
        };
        const cellNote = this.adaptableApi.noteApi.getNoteForCell(cellPosition);
        if (!cellNote) return undefined;
        return 'ab-Cell-Note';
    }
    getCommentCellClassName(gridCell, params) {
        if (!this.adaptableApi.internalApi.getModuleService().isAdapTableModulePresent('Comment')) return;
        if (!this.adaptableApi.commentApi.internalApi.areCommentsSupportedInLayout()) return;
        const position = {
            PrimaryKeyValue: gridCell.primaryKeyValue,
            ColumnId: gridCell.column.columnId
        };
        const cellComments = this.adaptableApi.commentApi.getCommentThreadForCell(position);
        if (!cellComments) return undefined;
        return 'ab-Cell-Comment';
    }
    getFormatColumnCellClass(formatColumns, abColumn, params) {
        const classNames = formatColumns.map((formatColumn)=>{
            if (formatColumn.Style?.ClassName && this.adaptableApi.formatColumnApi.internalApi.formatColumnShouldRenderInCell(formatColumn, abColumn, params.node, params.value)) return formatColumn.Style?.ClassName;
        }).filter((x)=>!!x);
        return classNames;
    }
    getQuickSearchCellStyle() {
        const quickSearchStyle = this.adaptableApi.quickSearchApi.getQuickSearchCellMatchStyle();
        if (!quickSearchStyle || (0, $9OAZF.default).IsNotNullOrEmpty(quickSearchStyle.ClassName)) return undefined;
        return (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(quickSearchStyle);
    }
    getQuickSearchTextMatchStyle() {
        const quickSearchTextMatchStyle = this.adaptableApi.quickSearchApi.getQuickSearchTextMatchStyle();
        if (!quickSearchTextMatchStyle) return undefined;
        return (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(quickSearchTextMatchStyle);
    }
    getQuickSearchCurrentTextMatchStyle() {
        const quickSearchCurrentTextMatchStyle = this.adaptableApi.quickSearchApi.getQuickSearchCurrentTextMatchStyle();
        if (!quickSearchCurrentTextMatchStyle) return undefined;
        return (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(quickSearchCurrentTextMatchStyle);
    }
    getReadOnlyCellStyle(gridCell, params) {
        const editableCellStyle = this.adaptableApi.userInterfaceApi.getReadOnlyCellStyle();
        if (!editableCellStyle) return undefined;
        if (gridCell) {
            if (!this.adaptableApi.gridApi.isCellEditable(gridCell)) return (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(editableCellStyle);
        }
        return undefined;
    }
    getEditableCellStyle(gridCell, params) {
        const editableCellStyle = this.adaptableApi.userInterfaceApi.getEditableCellStyle();
        if (!editableCellStyle) return undefined;
        if (gridCell) {
            if (this.adaptableApi.gridApi.isCellEditable(gridCell)) return (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(editableCellStyle);
        }
        return undefined;
    }
    getEditedCellStyle(gridCell, params) {
        const editedCellStyle = this.adaptableApi.userInterfaceApi.getEditedCellStyle();
        if (!editedCellStyle) return undefined;
        if (gridCell) {
            if (this.adaptableApi.gridApi.isCellEdited(gridCell)) return (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(editedCellStyle);
        }
        return undefined;
    }
    /**
     * The combination of styled column and format cells
     * This function decides when the two can be merged.
     */ getFormatColumnAndStyledColumnCellStyle(column, params) {
        let styledColumn = this.adaptableApi.styledColumnApi.getStyledColumnForColumnId(column.columnId);
        let styledColumnStyle = {};
        if (styledColumn && !styledColumn?.IsSuspended) {
            const styledCellStyle = this.getStyledColumnStyle(styledColumn, column, params);
            // for percentbar we want to merge
            if (styledColumn.PercentBarStyle || styledColumn.BadgeStyle || styledColumn.GradientStyle) styledColumnStyle = styledCellStyle;
            else // For other ones wo do not want to merge
            return styledCellStyle;
        }
        const activeFormatColumnsWithStyle = this.adaptableApi.formatColumnApi.internalApi.getFormatColumnsWithStyleForColumn(column, {
            target: 'cell'
        });
        // background color of styledColumn.GradientStyle has precedence and wins over FormatColumn
        return {
            ...this.getFormatColumnCellStyle(column, activeFormatColumnsWithStyle, params),
            ...styledColumnStyle
        };
    }
    getFormatColumnHeaderStyle(column, params) {
        if (params.columnGroup) // FormatColumns are not supported in column groups
        // YET, see https://github.com/AdaptableTools/adaptable/issues/2947#issuecomment-3062304655
        return {};
        const relevantFormatColumnsWithStyle = this.getRelevantFormatColumnHeaderStyles(column);
        if (!relevantFormatColumnsWithStyle.length) return {};
        return this.getFormatColumnAdaptableStyle(relevantFormatColumnsWithStyle);
    }
    getStyledColumnStyle(styledColumn, abColumn, params) {
        let style = {};
        const gradientStyle = styledColumn?.GradientStyle;
        if (params.value === undefined) return;
        let colValue = params.value;
        if (this.adaptableApi.gridApi.isGroupRowNode(params.node)) return style;
        if (styledColumn.BadgeStyle && !styledColumn.BadgeStyle.RowScope?.ExcludeSummaryRows && this.adaptableApi.gridApi.isSummaryNode(params?.node)) return style;
        if (gradientStyle) {
            const min = this.adaptableApi.styledColumnApi.internalApi.getNumericStyleMinValue(styledColumn, abColumn, params.node, colValue);
            const max = this.adaptableApi.styledColumnApi.internalApi.getNumericStyleMaxValue(styledColumn, abColumn, params.node, colValue);
            let cellBackColor;
            let reverseGradient = false;
            if (gradientStyle.ColumnComparison) cellBackColor = gradientStyle.ColumnComparison.Color;
            else {
                const matchingRange = this.adaptableApi.styledColumnApi.internalApi.findRangeForColumn(gradientStyle.CellRanges, abColumn, gradientStyle.RangeValueType, colValue);
                if (matchingRange) {
                    cellBackColor = matchingRange.Color;
                    reverseGradient = matchingRange.ReverseGradient;
                }
            }
            const increase = Math.abs(max - min);
            const percentage = (colValue - min) / increase * 100;
            let alpha = Number((percentage / 100).toPrecision(2));
            if (reverseGradient) alpha = 1 - alpha;
            const preparedColor = (0, $0f8018328b88def3$export$fb1c9088cfbed114)(cellBackColor);
            // if no range match, do not apply color (black in this case)
            if (cellBackColor) style.backgroundColor = (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(preparedColor).setAlpha(alpha).toRgbString();
        }
        if (styledColumn.PercentBarStyle && styledColumn.PercentBarStyle.CellText) {
            style.paddingTop = 0;
            style.paddingBottom = 0;
        }
        return style;
    }
    getFormatColumnCellStyle(abColumn, activeFormatColumnsWithStyle, params) {
        if (!activeFormatColumnsWithStyle.length) return {};
        const relevantFormatColumnsWithStyle = activeFormatColumnsWithStyle.filter((formatColumn)=>{
            return this.adaptableApi.formatColumnApi.internalApi.formatColumnShouldRenderInCell(formatColumn, abColumn, params.node, params.value, // @ts-ignore see #derived_pivot_cell_style
            params.__pivotResultColumn);
        });
        return this.getFormatColumnAdaptableStyle(relevantFormatColumnsWithStyle);
    }
    getFormatColumnAdaptableStyle(formatColumns) {
        // first has more precedence, then they need to be applied in reverse order
        return formatColumns.reduceRight((style, formatColumn)=>{
            const formatColumnStyle = formatColumn.Style ? (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(formatColumn.Style) : {};
            return {
                ...style,
                ...formatColumnStyle
            };
        }, {});
    }
    getAlertCellStyle(gridCell, params) {
        const alert = this.adaptableApi.alertApi.internalApi.getAdaptableAlertWithHighlightCell(gridCell.column.columnId, params.node);
        if (alert) {
            const highlightCell = alert.alertDefinition.AlertProperties.HighlightCell;
            if (typeof highlightCell === 'object') return (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(highlightCell);
            return {
                backgroundColor: (0, $5aWMQ.default).getColorByMessageType(alert.alertDefinition.MessageType)
            };
        }
    }
    getFlashingCellStyle(gridCell, params) {
        const primaryKey = params.node.aggData ? params.node.id : gridCell.primaryKeyValue;
        const flashingCell = this.adaptableApi.flashingCellApi.internalApi.getAdaptableFlashingCellFor(primaryKey, gridCell.column.columnId);
        if (!flashingCell) return {};
        return (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)((flashingCell.direction === 'up' ? flashingCell.flashingCellDefinition.UpChangeStyle : flashingCell.direction === 'down' ? flashingCell.flashingCellDefinition.DownChangeStyle : flashingCell.flashingCellDefinition.NeutralChangeStyle) ?? {});
    }
    getCellHighlightStyle(gridCell, params) {
        const cellHighlight = this.adaptableApi.internalApi.getInternalState().CellHighlightInfo.find((cellHighlightInfo)=>{
            return gridCell.column.columnId === cellHighlightInfo.columnId && cellHighlightInfo.primaryKeyValue === gridCell.primaryKeyValue;
        });
        if (cellHighlight) return (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(cellHighlight.highlightStyle);
    }
    getColumnHighlightStyle(gridCell, params) {
        const columnHighlight = this.adaptableApi.internalApi.getInternalState().ColumnHighlightInfo.find((columnHighlightInfo)=>{
            return gridCell.column.columnId === columnHighlightInfo.columnId;
        });
        if (columnHighlight) return (0, $0f8018328b88def3$export$f3ef81ff0b20b4d5)(columnHighlight.highlightStyle);
    }
    isColGroupDef(columnDefinition) {
        // @ts-ignore
        return columnDefinition['children'] != null;
    }
    getRelevantFormatColumnHeaderStyles(column) {
        return this.adaptableApi.formatColumnApi.internalApi.getFormatColumnsWithStyleForColumn(column, {
            target: 'columnHeader'
        }).filter((formatColumn)=>{
            return this.adaptableApi.formatColumnApi.internalApi.formatColumnShouldRenderInHeader(formatColumn, column);
        });
    }
}


let $d9d5ba45a21efe90$var$scrollbarWidth;
var $d9d5ba45a21efe90$export$2e2bcd8739ae039 = ()=>{
    const globalObject = typeof globalThis !== 'undefined' ? globalThis : window;
    const document = globalObject ? globalObject.document : null;
    if ($d9d5ba45a21efe90$var$scrollbarWidth != null) return $d9d5ba45a21efe90$var$scrollbarWidth;
    let result;
    if (document) {
        const div = document.createElement('div');
        const elStyle = div.style;
        elStyle.position = 'absolute';
        elStyle.boxSizing = 'content-box';
        elStyle.width = '200px';
        elStyle.height = '200px';
        elStyle.top = '-99999px';
        elStyle.overflow = 'scroll';
        //@ts-ignore
        elStyle.MsOverflowStyle = 'scrollbar';
        document.body.appendChild(div);
        result = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else result = 0;
    return $d9d5ba45a21efe90$var$scrollbarWidth = result;
};



class $4a5626d4d32a5a40$export$408bbabeb32c84ca {
    adaptableApi;
    constructor(adaptableApi){
        this.adaptableApi = adaptableApi;
        if (adaptableApi.optionsApi.getRowFormOptions().autoHandle) adaptableApi.eventApi.on('RowFormSubmitted', (eventInfo)=>this.autoHandleRowFormButtons(eventInfo));
    }
    autoHandleRowFormButtons(rowFormSubmittedInfo) {
        const { adaptableApi: adaptableApi } = rowFormSubmittedInfo;
        if (rowFormSubmittedInfo.type === 'rowEdited') {
            const { rowNode: rowNode, formData: formData } = rowFormSubmittedInfo;
            const newRowData = {
                ...rowNode.data,
                ...formData
            };
            adaptableApi.gridApi.updateGridData([
                newRowData
            ]);
        }
        if (rowFormSubmittedInfo.type === 'rowDeleted') {
            const { rowNode: rowNode } = rowFormSubmittedInfo;
            const deletedRowData = rowNode.data;
            adaptableApi.gridApi.deleteGridData([
                deletedRowData
            ]);
        }
        if (rowFormSubmittedInfo.type === 'rowCreated') {
            const { formData: formData } = rowFormSubmittedInfo;
            let newRowData = formData;
            const setPrimaryKeyValueFunction = adaptableApi.optionsApi.getRowFormOptions().setPrimaryKeyValue;
            if (setPrimaryKeyValueFunction) {
                const context = {
                    rowData: formData,
                    ...adaptableApi.internalApi.buildBaseContext()
                };
                const pkValue = setPrimaryKeyValueFunction(context);
                const primaryKeyColumn = this.adaptableApi.columnApi.getPrimaryKeyColumn();
                newRowData[primaryKeyColumn.columnId] = pkValue;
            }
            const config = {
                addIndex: 0
            };
            adaptableApi.gridApi.addGridData([
                newRowData
            ], config);
        }
    }
    destroy() {
    // nothing yet
    }
}



var $hrtGQ = parcelRequire("hrtGQ");

class $4a350e5f65671210$export$6c32426769f5a7cf {
    logger;
    constructor(logger){
        this.logger = logger;
    }
    migrateStateWithMethods(state, methods) {
        for (let method of methods)state = method.call(this, state);
        return state;
    }
}



var $9g4SS = parcelRequire("9g4SS");


var $9OAZF = parcelRequire("9OAZF");
function $27277b7a5f87b0d4$export$b85af00aa7f4e7b0(rule) {
    if ('Predicate' in rule && rule.Predicate) {
        rule.Predicates = [
            rule.Predicate,
            ...rule.Predicates ?? []
        ];
        delete rule.Predicate;
    }
    return rule;
}


class $8eb4ca579bc06c14$export$645767afc9654e57 extends (0, $4a350e5f65671210$export$6c32426769f5a7cf) {
    migrateState(state) {
        return this.migrateStateWithMethods(state, [
            this.migrateCalculatedColumnState,
            this.migrateAlertState,
            this.migrateToolPanelState,
            this.migrateStyledColumnState,
            this.migrateNamedQueryState,
            this.migrateGridFilterState,
            this.migrateFreeTextColumnState,
            this.migrateFormatColumnState,
            this.migrateFlashinCellState,
            this.migrateDashboardState,
            this.migrateColumnFilterState,
            this.migrateChartingState
        ]);
    }
    migrateChartingState(state) {
        // const allChartDefinitions = this.api.chartingApi.getChartDefinitions();
        const allChartDefinitions = state.Charting?.ChartDefinitions;
        if (Array.isArray(allChartDefinitions)) allChartDefinitions.filter((chartDefinition)=>'model' in chartDefinition || !('Name' in chartDefinition)).forEach((charDefinition)=>{
            if ('model' in charDefinition) {
                charDefinition.Model = charDefinition.model;
                delete charDefinition.model;
            }
            if (!('Name' in charDefinition)) // default to chartId
            // @ts-ignore possible because First iteration had no 'Name' and model was under 'model' key (lowercase)
            charDefinition.Name = charDefinition.Model.chartId;
        });
        return state;
    }
    migrateColumnFilterState(state) {
        // Update Module Buttons
        const moduleButtons = state.Dashboard?.ModuleButtons;
        if (moduleButtons?.length && !moduleButtons.includes('ColumnFilter')) {
            const dashboardState = state.Dashboard ?? {};
            dashboardState.ModuleButtons = moduleButtons.map((moduleButton)=>{
                if (moduleButton == 'Filter') return 'ColumnFilter';
                return moduleButton;
            });
        }
        // Update Toolbars
        const tabs = state.Dashboard?.Tabs;
        if (Array.isArray(tabs)) state.Dashboard.Tabs = tabs.map((tab)=>{
            if (tab.Toolbars.includes('Filter') && !tab.Toolbars.includes('ColumnFilter')) return {
                ...tab,
                // replace with 'GridFilter'
                Toolbars: tab.Toolbars.map((t)=>t == 'Filter' ? 'ColumnFilter' : t)
            };
            return tab;
        });
        // - move pinned toolbars
        const pinnedToolbars = state.Dashboard?.PinnedToolbars;
        if (pinnedToolbars && !pinnedToolbars?.includes('ColumnFilter')) state.Dashboard.PinnedToolbars = pinnedToolbars.map((pinnedToolbar)=>{
            if (pinnedToolbar == 'Filter') return 'ColumnFilter';
            return pinnedToolbar;
        });
        // Update Status Bar
        const statusBars = state.StatusBar?.StatusBars;
        if (statusBars) state.StatusBar.StatusBars = statusBars.map((panel)=>{
            return {
                ...panel,
                StatusBarPanels: panel.StatusBarPanels.map((panel)=>{
                    if (panel === 'Filter') return 'ColumnFilter';
                    return panel;
                })
            };
        });
        return state;
    }
    migrateDashboardState(state) {
        // let dashboardState: any = this.api.dashboardApi.getDashboardState();
        let dashboardState = state.Dashboard;
        if (dashboardState?.VisibleButtons) {
            this.logger.warn(`Migrating deprecated DashboardState.VisibleButtons: [${dashboardState.VisibleButtons}].`);
            state.Dashboard.ModuleButtons = [
                ...state.Dashboard.ModuleButtons,
                ...dashboardState.VisibleButtons
            ];
            //@ts-ignore delete as no longer needed
            delete state.Dashboard.VisibleButtons;
        }
        return state;
    }
    migrateFlashinCellState(state) {
        const flashingCellState = state.FlashingCell;
        if (Array.isArray(flashingCellState?.FlashingCellDefinitions)) flashingCellState.FlashingCellDefinitions.forEach((flashingCellDefinition)=>{
            if (flashingCellDefinition.Rule && 'Predicate' in flashingCellDefinition.Rule) (0, $27277b7a5f87b0d4$export$b85af00aa7f4e7b0)(flashingCellDefinition.Rule);
        });
        return state;
    }
    migrateFormatColumnState(state) {
        // const formatColumns = this.api.formatColumnApi.getFormatColumns();
        const formatColumns = state.FormatColumn?.FormatColumns || [];
        formatColumns.forEach((formatColumn)=>{
            if (formatColumn.Rule && 'Predicate' in formatColumn.Rule) //@ts-ignore ignore
            (0, $27277b7a5f87b0d4$export$b85af00aa7f4e7b0)(formatColumn.Rule);
        });
        // update ConditionalStyle StatusBarPanel
        // const oldStatusBars = this.api.internalApi.getState().StatusBar.StatusBars;
        const statusBars = state.StatusBar?.StatusBars || [];
        let replaceConditionalStyleStatusBar = false;
        statusBars.forEach((statusBar)=>({
                ...statusBar,
                StatusBarPanels: [
                    ...new Set(statusBar.StatusBarPanels.map((statusBarPanel)=>{
                        if (statusBarPanel === 'ConditionalStyle') {
                            replaceConditionalStyleStatusBar = true;
                            return 'FormatColumn';
                        }
                        return statusBarPanel;
                    }))
                ]
            }));
        // update ConditionalStyle dashboard buttons
        // const dashboardModuleButtons = this.api.internalApi.getState().Dashboard.ModuleButtons as any;
        const dashboardModuleButtons = state.Dashboard?.ModuleButtons;
        if (dashboardModuleButtons && dashboardModuleButtons.includes('ConditionalStyle')) dashboardModuleButtons[dashboardModuleButtons.indexOf('ConditionalStyle')] = 'FormatColumn';
        // update ConditionalStyle toolPanel buttons
        // const toolPanelModuleButtons = this.api.internalApi.getState().ToolPanel.ModuleButtons as any;
        const toolPanelModuleButtons = state.ToolPanel?.ModuleButtons;
        if (toolPanelModuleButtons && toolPanelModuleButtons.includes('ConditionalStyle')) toolPanelModuleButtons[toolPanelModuleButtons.indexOf('ConditionalStyle')] = 'FormatColumn';
        return state;
    }
    migrateFreeTextColumnState(state) {
        // make sure all default to type string
        const allFreeTextColumns = state.FreeTextColumn?.FreeTextColumns || [];
        for (const freeTextColumn of allFreeTextColumns){
            const unTypedCol = freeTextColumn;
            if (unTypedCol.DataType) {
                const dataType = unTypedCol.DataType;
                delete unTypedCol['DataType'];
                if (!freeTextColumn.FreeTextColumnSettings) freeTextColumn.FreeTextColumnSettings = {
                    DataType: dataType
                };
                else freeTextColumn.FreeTextColumnSettings.DataType = dataType;
            }
            if (!freeTextColumn.FreeTextColumnSettings) freeTextColumn.FreeTextColumnSettings = {
                DataType: 'String'
            };
            if (!freeTextColumn.FreeTextColumnSettings.DataType) freeTextColumn.FreeTextColumnSettings.DataType = 'String';
        }
        return state;
    }
    migrateGridFilterState(state) {
        const oldQueryState = state.Query;
        if (!oldQueryState) return state;
        // - move query to current layout
        const expression = oldQueryState.CurrentQuery;
        const currentLayout = state.Layout.Layouts?.find((l)=>l.Name === state.Layout.CurrentLayout);
        const currentGridFilter = currentLayout?.GridFilter;
        const currentGridFilterExpression = currentGridFilter && !currentGridFilter.IsSuspended ? currentGridFilter.Expression || '' : '';
        if (expression && (0, $9OAZF.default).IsNullOrEmpty(currentGridFilterExpression)) currentLayout.GridFilter = {
            ...currentGridFilter,
            Expression: expression
        };
        // - move dashboard/toolbar
        state.Dashboard.Tabs?.forEach((tab)=>{
            if (tab.Toolbars.includes('Query')) tab.Toolbars = tab.Toolbars.map((t)=>t == 'Query' ? 'GridFilter' : t);
        });
        // - move pinned toolbars
        let updatePinnedToolbars = false;
        if (state.Dashboard.PinnedToolbars) state.Dashboard.PinnedToolbars = state.Dashboard.PinnedToolbars.map((pinnedToolbar)=>{
            if (pinnedToolbar == 'Query') return 'GridFilter';
            return pinnedToolbar;
        });
        return state;
    }
    migrateNamedQueryState(state) {
        // - move named queries from old Query State to this Module
        // Note: GridFilter Module moves the "old" CurrentQuery into Layout
        // const oldQueryState: QueryState = this.api.internalApi.getAdaptableState().Query;
        const oldQueryState = state.Query;
        const oldNamedQueries = oldQueryState?.NamedQueries;
        if ((0, $9g4SS.default).IsNotNullOrEmpty(oldNamedQueries)) {
            const currentNamedQueries = state.NamedQuery.NamedQueries;
            oldNamedQueries.forEach((oldNamedQuery)=>{
                const currentQuery = currentNamedQueries.find((q)=>q.Name === oldNamedQuery.Name);
                if (!currentQuery) state.NamedQuery?.NamedQueries?.push(oldNamedQuery);
            });
        }
        if (oldQueryState) delete state.Query;
        return state;
    }
    migrateStyledColumnState(state) {
        const formatColumnsWithColumnStyles = state.FormatColumn?.FormatColumns?.filter((fc)=>fc.ColumnStyle) || [];
        if (!formatColumnsWithColumnStyles.length) return state;
        this.logger.info(`Migrating ${formatColumnsWithColumnStyles.length} FormatColumn styles to StyledColumns.`, formatColumnsWithColumnStyles);
        // delete the format columns with column styles
        state.FormatColumn.FormatColumns = state.FormatColumn.FormatColumns?.filter((fc)=>!fc.ColumnStyle);
        const styledColumns = formatColumnsWithColumnStyles.map((formatColumn)=>{
            if (!('ColumnIds' in formatColumn.Scope)) return null;
            return {
                ...(0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateEmptyStyledColumn(),
                ColumnId: formatColumn.Scope.ColumnIds[0],
                ...formatColumn.ColumnStyle
            };
        }).filter(Boolean);
        state.StyledColumn.StyledColumns ??= [];
        styledColumns.forEach((styledColumn)=>{
            state.StyledColumn.StyledColumns.push(styledColumn);
        });
        return state;
    }
    migrateToolPanelState(state) {
        // const deprecatedToolPanelConfigs: AdaptableToolPanels | undefined = (
        //   this.api.toolPanelApi.getToolPanelState() as any
        // ).VisibleToolPanels;
        const deprecatedToolPanelConfigs = state.ToolPanel?.VisibleToolPanels;
        if (deprecatedToolPanelConfigs?.length) {
            this.logger.warn(`Migrating deprecated ToolPanelState.VisibleToolPanels: [${deprecatedToolPanelConfigs}].`);
            const migratedToolPanelConfigs = deprecatedToolPanelConfigs.map((toolPanel)=>({
                    Name: toolPanel,
                    State: 'collapsed'
                }));
            state.ToolPanel.ToolPanels = migratedToolPanelConfigs;
        }
        return state;
    }
    migrateAlertState(state) {
        state.Alert?.AlertDefinitions?.forEach((alertDefinition)=>{
            if (alertDefinition.Rule && 'Predicate' in alertDefinition.Rule) (0, $27277b7a5f87b0d4$export$b85af00aa7f4e7b0)(alertDefinition.Rule);
        });
        const alertState = state.Alert;
        if ((0, $9g4SS.default).IsEmpty(state.FlashingCell?.FlashingCellDefinitions) && (0, $9g4SS.default).IsNotNullOrEmpty(alertState?.FlashingAlertDefinitions)) {
            state.FlashingCell.FlashingCellDefinitions = alertState.FlashingAlertDefinitions;
            //@ts-ignore delete as no longer needed
            delete state.Alert.FlashingAlertDefinitions;
        }
        state.Alert?.AlertDefinitions?.forEach((alertDefinition)=>{
            // if ShowPopup then change to DisplayNotificate
            if (alertDefinition.AlertProperties && alertDefinition.AlertProperties.ShowPopup && alertDefinition.AlertProperties.ShowPopup == true && !alertDefinition.AlertProperties.DisplayNotification) {
                alertDefinition.AlertProperties.DisplayNotification = true;
                alertDefinition.AlertProperties.ShowPopup = undefined;
            }
            // if no rule but a predicate then use that
            if (!alertDefinition.Rule) {
                if (alertDefinition.Predicate && alertDefinition.Predicate != undefined) {
                    const predicate = alertDefinition.Predicate;
                    alertDefinition.Rule = {
                        Predicate: predicate
                    };
                    alertDefinition.Predicate = undefined;
                }
            } else {
                //migrate alert definitions with `AggregationExpression` (now `AggregatedBooleanExpression`)
                const obsoleteAggregationExpression = alertDefinition.Rule['AggregationExpression'];
                if (obsoleteAggregationExpression) alertDefinition.Rule.AggregatedBooleanExpression = obsoleteAggregationExpression;
            }
        });
        return state;
    }
    migrateCalculatedColumnState(state) {
        state.CalculatedColumn?.CalculatedColumns?.forEach((cc)=>{
            if (cc.ColumnExpression && !cc.Query) {
                cc.Query = {
                    ScalarExpression: cc.ColumnExpression
                };
                cc.ColumnExpression = undefined;
            }
            if (!cc.CalculatedColumnSettings) {
                cc.CalculatedColumnSettings = {
                    DataType: 'number'
                };
                this.logger.warn(`Migrating Calculated Column "${cc.ColumnId}": adding default CalculatedColumnSettings.`);
            }
        });
        return state;
    }
    migrateUserState(state) {
        return state;
    }
}



class $0539ceb1c7cefe06$export$ce3b81356a811ae4 extends (0, $4a350e5f65671210$export$6c32426769f5a7cf) {
    migrateState(state) {
        return state;
    }
}





function $f68787f41a9f6c5c$var$transition_pre_20(layout) {
    const l = layout;
    if (l.Columns && !l.EnablePivot) {
        layout.TableColumns = l.Columns;
        delete l.Columns;
        delete layout.PivotColumns;
    }
    if (l.PinnedColumnsMap) {
        layout.ColumnPinning = {
            ...l.PinnedColumnsMap
        };
        delete l.PinnedColumnsMap;
    }
    if (l.ColumnHeadersMap) {
        layout.ColumnHeaders = l.ColumnHeadersMap;
        delete l.ColumnHeadersMap;
    }
    if (l.ColumnWidthMap) {
        //@ts-ignore
        layout.ColumnWidths = l.ColumnWidthMap;
        delete l.ColumnWidthMap;
    }
    if (l.EnablePivot) {
        layout.PivotColumns = l.PivotColumns || [];
        delete l.Columns;
        delete layout.TableColumns;
        delete l.EnablePivot;
        if (l.AggregationColumns) {
            layout.PivotAggregationColumns = (Object.entries(l.AggregationColumns) || []).map(([ColumnId, AggFunc])=>{
                return {
                    ColumnId: ColumnId,
                    AggFunc: AggFunc
                };
            });
            delete layout.TableAggregationColumns;
            delete l.AggregationColumns;
        }
        if (l.RowGroupedColumns) {
            layout.PivotGroupedColumns = l.RowGroupedColumns;
            delete l.RowGroupedColumns;
        }
    } else if (l.AggregationColumns && !Array.isArray(l.AggregationColumns)) {
        const oldAggs = l.AggregationColumns || {};
        const newAggs = Object.entries(oldAggs).map(([ColumnId, AggFunc])=>({
                ColumnId: ColumnId,
                AggFunc: AggFunc
            }));
        layout.TableAggregationColumns = newAggs;
        delete l.AggregationColumns;
    }
    if (l.ExpandedRowGroupValues) {
        layout.RowGroupValues = {
            RowGroupDefaultBehavior: 'collapsed',
            ExceptionGroupKeys: l.ExpandedRowGroupValues
        };
        delete l.ExpandedRowGroupValues;
    }
    if (Array.isArray(l.ColumnFilters)) layout.ColumnFilters = l.ColumnFilters.map((columnFilter)=>{
        const filter = {
            ...columnFilter
        };
        // version 19 had a single predicate, while version 20 has an array of predicates
        // @ts-ignore
        if (filter.Predicate) {
            // @ts-ignore
            filter.Predicates = [
                filter.Predicate
            ];
            // @ts-ignore
            delete filter.Predicate;
        }
        if (!Array.isArray(filter.Predicates)) filter.Predicates = [];
        filter.Predicates = filter.Predicates.map((p)=>{
            // the following predicate ids were renamed:
            // Values -> In
            if (p.PredicateId === 'Values') {
                p = {
                    ...p
                };
                p.PredicateId = 'In';
            }
            // ExcludeValues -> NotIn
            if (p.PredicateId === 'ExcludeValues') {
                p = {
                    ...p
                };
                p.PredicateId = 'NotIn';
            }
            return p;
        });
        return filter;
    });
    return layout;
}
function $f68787f41a9f6c5c$var$hasUpToDateDataType(dataType) {
    return (0, $66ac1c1926a7c094$export$a57edebad87b3bdd).includes(dataType);
}
function $f68787f41a9f6c5c$export$952a7d7a55818ca6(previousType) {
    if ((0, $66ac1c1926a7c094$export$a57edebad87b3bdd).includes(previousType)) return previousType;
    switch(previousType){
        case 'abColDefBoolean':
        case 'Boolean':
            return 'boolean';
        case 'abColDefDate':
        case 'Date':
            return 'date';
        case 'abColDefNumber':
        case 'Number':
            return 'number';
        case 'abColDefString':
        case 'String':
            return 'text';
        case 'abColDefObject':
        case 'Object':
            return 'object';
        case 'abColDefStringArray':
        case 'StringArray':
            return 'textArray';
        case 'abColDefNumberArray':
        case 'NumberArray':
            return 'numberArray';
        case 'abColDefTupleNumberArray':
        case 'TupleNumberArray':
            return 'tupleArray';
        case 'abColDefObjectNumberArray':
        case 'ObjectNumberArray':
            return 'objectArray';
        default:
            return 'unknown';
    }
}
class $f68787f41a9f6c5c$export$6571f63b702175e1 extends (0, $4a350e5f65671210$export$6c32426769f5a7cf) {
    migrateState(state) {
        this.migrateLayoutState(state);
        this.migrateColTypeToDataType(state);
        this.migrateSparklineState(state);
        return state;
    }
    migrateLayoutState(state) {
        const layoutState = state.Layout;
        if (layoutState && layoutState.Layouts) layoutState.Layouts = layoutState.Layouts.map((layout)=>{
            return $f68787f41a9f6c5c$var$transition_pre_20(layout);
        });
        return state;
    }
    migrateColTypeToDataType(state) {
        this.logger.info('Migrating column types to data types.');
        // Calculated Column DataType
        const calculatedColumnState = state.CalculatedColumn;
        if (calculatedColumnState && calculatedColumnState.CalculatedColumns) calculatedColumnState.CalculatedColumns.forEach((cc)=>{
            if (cc.CalculatedColumnSettings?.DataType) {
                if ($f68787f41a9f6c5c$var$hasUpToDateDataType(cc.CalculatedColumnSettings.DataType)) return;
                const newDataType = $f68787f41a9f6c5c$export$952a7d7a55818ca6(cc.CalculatedColumnSettings.DataType);
                if (newDataType === 'unknown') this.logger.warn(`Calculated Column "${cc.ColumnId}" has unrecognized DataType: "${cc.CalculatedColumnSettings.DataType}".`);
                else cc.CalculatedColumnSettings.DataType = newDataType;
            }
        });
        // FreeText Column DataType
        const freeTextColumnState = state.FreeTextColumn;
        if (freeTextColumnState && freeTextColumnState.FreeTextColumns) freeTextColumnState.FreeTextColumns.forEach((fc)=>{
            if (fc.FreeTextColumnSettings?.DataType) {
                if ($f68787f41a9f6c5c$var$hasUpToDateDataType(fc.FreeTextColumnSettings.DataType)) return;
                const newDataType = $f68787f41a9f6c5c$export$952a7d7a55818ca6(fc.FreeTextColumnSettings.DataType);
                if (newDataType === 'unknown') this.logger.warn(`FreeText Column "${fc.ColumnId}" has unrecognized DataType: "${fc.FreeTextColumnSettings.DataType}".`);
                else fc.FreeTextColumnSettings.DataType = newDataType;
            }
        });
    }
    migrateSparklineState(state) {
        this.logger.info('Migrating Sparkline state.');
        const sparklineState = state.StyledColumn;
        if (sparklineState && sparklineState.StyledColumns) sparklineState.StyledColumns.forEach((styledColumn)=>{
            // @ts-ignore renamed 'SparkLineStyle' to 'SparklineStyle'
            if (styledColumn.SparkLineStyle == undefined) return;
            // @ts-ignore renamed 'SparkLineStyle' to 'SparklineStyle'
            // @ts-ignore
            styledColumn.SparklineStyle = styledColumn.SparkLineStyle;
            // @ts-ignore
            delete styledColumn.SparkLineStyle;
            // @ts-ignore the previous type was "column"
            if (styledColumn.SparklineStyle?.options?.type === 'column') {
                // @ts-ignore the previous type was "column"
                styledColumn.SparklineStyle.options.type = 'bar';
                styledColumn.SparklineStyle.options.direction = 'vertical';
            }
            if (styledColumn.SparklineStyle?.options?.type === 'bar') styledColumn.SparklineStyle.options.direction = 'horizontal';
            if (styledColumn.SparklineStyle?.options?.line) {
                const previousLineOpts = (styledColumn.SparklineStyle?.options).line;
                styledColumn.SparklineStyle.options.stroke = previousLineOpts.stroke;
                styledColumn.SparklineStyle.options.strokeWidth = previousLineOpts.strokeWidth;
                delete styledColumn.SparklineStyle.options.line;
            }
            if (styledColumn.SparklineStyle?.options?.axis && styledColumn.SparklineStyle?.options?.axis?.type == undefined) styledColumn.SparklineStyle.options.axis.type = 'category';
            const obsoleteHighlightStyle = styledColumn.SparklineStyle?.options?.highlightStyle;
            if (obsoleteHighlightStyle) {
                const obsoleteKeys = [
                    'fill',
                    'stroke',
                    'strokeWidth'
                ];
                obsoleteKeys.forEach((obsoleteKey)=>{
                    if (// @ts-ignore
                    obsoleteHighlightStyle?.[obsoleteKey] != undefined) {
                        const itemHighlightStyle = obsoleteHighlightStyle.item ?? {};
                        // @ts-ignore
                        itemHighlightStyle[obsoleteKey] = obsoleteHighlightStyle?.[obsoleteKey];
                        // @ts-ignore
                        delete styledColumn.SparklineStyle.options.highlightStyle[obsoleteKey];
                    }
                });
            }
            if ((styledColumn.SparklineStyle?.options).paddingInner != undefined) {
                const axisOpts = styledColumn.SparklineStyle.options.axis ?? {
                    type: 'category'
                };
                axisOpts.paddingInner = (styledColumn.SparklineStyle?.options).paddingInner;
                delete (styledColumn.SparklineStyle?.options).paddingInner;
            }
            if ((styledColumn.SparklineStyle?.options).paddingOuter != undefined) {
                const axisOpts = styledColumn.SparklineStyle.options.axis ?? {
                    type: 'category'
                };
                axisOpts.paddingOuter = (styledColumn.SparklineStyle?.options).paddingOuter;
                delete (styledColumn.SparklineStyle?.options).paddingOuter;
            }
            if ((styledColumn.SparklineStyle?.options).marker != undefined) (styledColumn.SparklineStyle?.options).marker.enabled = true;
        });
    }
}




class $01cbd1b1fabf894d$export$aaa8a464fd28557e extends (0, $4a350e5f65671210$export$6c32426769f5a7cf) {
    migrateState(state) {
        this.migrateLayoutState(state);
        return state;
    }
    migrateLayoutState(state) {
        const layoutState = state.Layout;
        if (layoutState && layoutState.Layouts) layoutState.Layouts = layoutState.Layouts.map((layout)=>{
            //@ts-ignore
            if (layout.ColumnWidths && !layout.ColumnSizing) {
                //@ts-ignore
                layout.ColumnSizing = (0, $702a77ed6db22640$export$22a158c5774ce85f)(layout.ColumnWidths);
                //@ts-ignore
                delete layout.ColumnWidths;
            }
            return layout;
        });
        return state;
    }
}




class $445a774884659844$export$db85c22dbc0a8d35 extends (0, $4a350e5f65671210$export$6c32426769f5a7cf) {
    migrateState(state) {
        this.migrateFormatColumnState(state);
        this.migrateNamedObjectState(state);
        return state;
    }
    // We have added a Name property to all AdapTable objects
    migrateNamedObjectState(state) {
        this.patchCustomSortName(state.CustomSort);
        this.patchFlashingCellName(state.FlashingCell);
        this.patchFormatColumnName(state.FormatColumn);
        this.patchPlusMinusNudgeName(state.PlusMinus);
        this.patchShortcutName(state.Shortcut);
        this.patchAlertName(state.Alert);
        this.patchScheduleName(state.Schedule);
    }
    // We have moved CellAlignment (renamed Alignment) from independent property into Style
    migrateFormatColumnState(state) {
        const formatColumnState = state.FormatColumn;
        if (formatColumnState && formatColumnState.FormatColumns) formatColumnState.FormatColumns = formatColumnState.FormatColumns.map((formatColumn)=>{
            if (!formatColumn.RowScope) formatColumn.RowScope = {
                ExcludeDataRows: false,
                ExcludeGroupRows: false,
                ExcludeSummaryRows: false,
                ExcludeTotalRows: false
            };
            //@ts-ignore
            if (formatColumn.CellAlignment) {
                formatColumn.Style = {
                    ...formatColumn.Style,
                    //@ts-ignore
                    Alignment: formatColumn.CellAlignment
                };
                //@ts-ignore
                delete formatColumn.CellAlignment;
            }
            return formatColumn;
        });
        return state;
    }
    patchCustomSortName(customSortState) {
        if (!customSortState) return;
        customSortState.CustomSorts?.forEach((customSort)=>{
            if (!customSort.Name) {
                const sortedValues = (customSort.SortedValues || []).join();
                customSort.Name = `CustomSort-${customSort.ColumnId}-${this.hashStrings([
                    'CustomSort',
                    customSort.ColumnId,
                    sortedValues
                ])}`;
            }
        });
    }
    patchFlashingCellName(flashingCellState) {
        if (!flashingCellState) return;
        flashingCellState.FlashingCellDefinitions?.forEach((flashingCell)=>{
            if (!flashingCell.Name) {
                const scopeStr = this.scopeToString(flashingCell.Scope);
                const ruleStr = flashingCell.Rule?.BooleanExpression || '';
                flashingCell.Name = `FlashingCell-${this.hashStrings([
                    'FlashingCell',
                    scopeStr,
                    ruleStr
                ])}`;
            }
        });
    }
    patchFormatColumnName(formatColumnState) {
        if (!formatColumnState) return;
        formatColumnState.FormatColumns?.forEach((formatColumn)=>{
            if (!formatColumn.Name) {
                const scopeStr = this.scopeToString(formatColumn.Scope);
                const styleStr = this.stringifyWithoutMetadata(formatColumn.Style);
                formatColumn.Name = `FormatColumn-${this.hashStrings([
                    'FormatColumn',
                    scopeStr,
                    styleStr
                ])}`;
            }
        });
    }
    patchPlusMinusNudgeName(plusMinusState) {
        if (!plusMinusState) return;
        plusMinusState.PlusMinusNudges?.forEach((nudge)=>{
            if (!nudge.Name) {
                const scopeStr = this.scopeToString(nudge.Scope);
                const nudgeValue = String(nudge.NudgeValue ?? '');
                nudge.Name = `PlusMinus-${this.hashStrings([
                    'PlusMinus',
                    scopeStr,
                    nudgeValue
                ])}`;
            }
        });
    }
    patchShortcutName(shortcutState) {
        if (!shortcutState) return;
        shortcutState.Shortcuts?.forEach((shortcut)=>{
            if (!shortcut.Name) {
                const key = shortcut.ShortcutKey || '';
                const operation = shortcut.ShortcutOperation || '';
                const value = String(shortcut.ShortcutValue ?? '');
                shortcut.Name = `Shortcut-${key}-${this.hashStrings([
                    'Shortcut',
                    key,
                    operation,
                    value
                ])}`;
            }
        });
    }
    patchAlertName(alertState) {
        if (!alertState) return;
        alertState.AlertDefinitions?.forEach((alert)=>{
            if (!alert.Name) {
                const scopeStr = this.scopeToString(alert.Scope);
                const messageType = alert.MessageType || '';
                const ruleStr = this.stringifyWithoutMetadata(alert.Rule);
                alert.Name = `Alert-${messageType}-${this.hashStrings([
                    'Alert',
                    scopeStr,
                    messageType,
                    ruleStr
                ])}`;
            }
        });
    }
    patchScheduleName(scheduleState) {
        if (!scheduleState) return;
        // Patch Reminder Schedules
        scheduleState.Reminders?.forEach((reminder)=>{
            if (!reminder.Name) {
                const header = reminder.Header || '';
                const message = reminder.Message || '';
                reminder.Name = `Reminder-${this.hashStrings([
                    'Reminder',
                    header,
                    message
                ])}`;
            }
        });
        // Patch Report Schedules
        scheduleState.ReportSchedules?.forEach((report)=>{
            if (!report.Name) {
                const reportName = report.ReportName || '';
                const format = report.ReportFormat || '';
                report.Name = `ReportSchedule-${this.hashStrings([
                    'ReportSchedule',
                    reportName,
                    format
                ])}`;
            }
        });
        // Patch IPushPull Schedules
        scheduleState.IPushPullSchedules?.forEach((ipp)=>{
            if (!ipp.Name) {
                const reportName = ipp.IPushPullReport?.ReportName || '';
                const folder = ipp.IPushPullReport?.Folder || '';
                const page = ipp.IPushPullReport?.Page || '';
                ipp.Name = `IPushPullSchedule-${this.hashStrings([
                    'IPushPullSchedule',
                    reportName,
                    folder,
                    page
                ])}`;
            }
        });
        // Patch OpenFin Schedules
        scheduleState.OpenFinSchedules?.forEach((openfin)=>{
            if (!openfin.Name) {
                const reportName = openfin.OpenFinReport?.ReportName || '';
                openfin.Name = `OpenFinSchedule-${this.hashStrings([
                    'OpenFinSchedule',
                    reportName
                ])}`;
            }
        });
    }
    scopeToString(scope) {
        if (!scope) return '';
        if ('All' in scope && scope.All) return 'All';
        if ('ColumnIds' in scope && scope.ColumnIds) return scope.ColumnIds.join(',');
        if ('DataTypes' in scope && scope.DataTypes) return scope.DataTypes.join(',');
        if ('ColumnTypes' in scope && scope.ColumnTypes) return scope.ColumnTypes.join(',');
        return '';
    }
    hashStrings(strings) {
        let hash = 0;
        for (const str of strings)for(let i = 0; i < str.length; i++)hash = (hash * 31 + str.charCodeAt(i)) % 9000;
        return hash + 1000;
    }
    /**
     * Stringifies an object after removing metadata properties (Uuid, Source, AdaptableVersion)
     * to ensure deterministic hashing regardless of generated values.
     */ stringifyWithoutMetadata(obj) {
        if (!obj) return '';
        const cloned = structuredClone(obj);
        (0, $792d5f2a0e72dfac$export$c6d9bd35e7cf8d09)(cloned);
        return JSON.stringify(cloned);
    }
}


class $cc99a2866dd5bf8d$export$760ebbf3c2f6fe3a {
    currentMajorVersion;
    versionUpgrades;
    logger;
    constructor(logger){
        this.currentMajorVersion = this.getCurrentMajorVersion((0, $5729c20ddc89490c$export$175d6ab8087f9060));
        this.logger = logger || this.getConsoleLogger();
        this.versionUpgrades = new Map();
        this.versionUpgrades.set(17, new (0, $8eb4ca579bc06c14$export$645767afc9654e57)(this.logger));
        this.versionUpgrades.set(18, new (0, $0539ceb1c7cefe06$export$ce3b81356a811ae4)(this.logger));
        this.versionUpgrades.set(20, new (0, $f68787f41a9f6c5c$export$6571f63b702175e1)(this.logger));
        this.versionUpgrades.set(21, new (0, $01cbd1b1fabf894d$export$aaa8a464fd28557e)(this.logger));
        this.versionUpgrades.set(22, new (0, $445a774884659844$export$db85c22dbc0a8d35)(this.logger));
    }
    static migrateAdaptableState(state, config) {
        const upgradeHelper = new $cc99a2866dd5bf8d$export$760ebbf3c2f6fe3a(config.logger);
        let fromVersion = config?.fromVersion || 16;
        const toVersion = config?.toVersion || upgradeHelper.currentMajorVersion;
        if (fromVersion >= toVersion) {
            console.warn(`The fromVersion (${fromVersion}) should be less than toVersion (${toVersion})!`);
            return state;
        }
        if (fromVersion < 16) // until version 16 we didn't have versioning
        fromVersion = 16;
        const versionUpgrades = Array.from(upgradeHelper.versionUpgrades.keys());
        let updatedState = structuredClone(state);
        for (const version of versionUpgrades)if (version > fromVersion && version <= toVersion) {
            upgradeHelper.logger.info(`Migration to version ${version} started.`);
            updatedState = upgradeHelper.versionUpgrades.get(version).migrateState(updatedState);
            upgradeHelper.logger.info(`Migration to version ${version} completed.`);
        }
        return updatedState;
    }
    getCurrentMajorVersion(version) {
        // is good enough for now, we just need to make sure we don't forget to update it
        return parseInt(version.split('.')[0]) || 22;
    }
    getConsoleLogger() {
        return {
            success: console.log,
            info: console.info,
            warn: console.warn,
            error: console.error
        };
    }
}




var $acw62 = parcelRequire("acw62");


function $845d8a1062d21b2f$export$828beb49cc455674(props) {
    const { showLoadingScreen: showLoadingScreen, loadingScreenDelay: loadingScreenDelay, loadingScreenTitle: loadingScreenTitle, loadingScreenText: loadingScreenText } = props;
    const [delayElapsed, setDelayElapsed] = $acw62.useState(typeof loadingScreenDelay === 'number' ? false : showLoadingScreen);
    $acw62.useEffect(()=>{
        if (typeof loadingScreenDelay === 'number') {
            const timeoutId = setTimeout(()=>{
                setDelayElapsed(true);
            }, loadingScreenDelay);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
    }, [
        loadingScreenDelay
    ]);
    return $acw62.createElement((0, $468c20c9461c2ca5$export$2e2bcd8739ae039), {
        modal: true,
        isOpen: delayElapsed ? showLoadingScreen : false,
        onDismiss: props.onClose,
        showCloseButton: false,
        className: "ab-LoadingScreen twa:min-h-auto"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-3"
    }, $acw62.createElement("h4", null, loadingScreenTitle ?? 'Initialising Grid'), $acw62.createElement("p", null, loadingScreenText ?? 'Retrieving your settings and setting up the grid...')));
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $72e5c71dc76eda7c$export$3b5d5e20d76ac2a9 = (component, adaptable, context)=>{
    if (adaptable.variant === 'react') return (props)=>{
        const children = (0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)($acw62.createElement(component, {
            params: props,
            adaptableApi: adaptable.api,
            context: context
        }), adaptable);
        return $acw62.createElement("div", {
            className: "ab-StatusBar",
            ref: (node)=>{
                if (node) // in React rendering, AG Grid renders an additional extra div
                // around the status panel container, with className of 'ag-react-container'
                // which needs to be stretched in order to fill the status panel
                node.parentElement.style.display = 'flex';
            }
        }, children);
    };
    return class StatusBarRenderer {
        params;
        eGui;
        unmountReactRoot;
        init(params) {
            this.params = params;
            this.eGui = document.createElement('div');
            this.eGui.classList.add('ab-StatusBar');
            this.render();
        }
        render() {
            const props = {
                params: this.params,
                adaptableApi: adaptable.api,
                context: context
            };
            const children = (0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)($acw62.createElement(component, props), adaptable);
            this.unmountReactRoot = adaptable.renderReactRoot(children, this.eGui);
        }
        getGui() {
            return this.eGui;
        }
        destroy() {
            this.unmountReactRoot?.();
        }
    };
};


function $9434656588b6dea7$var$createOnlyResult(distinctValues) {
    const value = distinctValues.size === 1 ? distinctValues.values().next().value : null;
    return {
        distinctValues: distinctValues,
        value: value,
        toString () {
            return value != null ? String(value) : '';
        }
    };
}
const $9434656588b6dea7$export$fe98000b1ab912f3 = (params)=>{
    const { values: values } = params;
    const distinctValues = new Set();
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (typeof value === 'number' || typeof value === 'string') distinctValues.add(value);
        else if (value != null && typeof value === 'object' && 'distinctValues' in value) // sub-group: merge pre-computed distinct values (set has at most 2 elements)
        for (const v of value.distinctValues)distinctValues.add(v);
        if (distinctValues.size > 1) return $9434656588b6dea7$var$createOnlyResult(distinctValues);
    }
    return $9434656588b6dea7$var$createOnlyResult(distinctValues);
};



const $d19eb99599b33e51$export$7d1258ebb7625a0d = (input)=>{
    if (typeof input === 'number') return input;
    const numericValue = (0, $16335fc5a6eeb2c1$export$2e2bcd8739ae039)(input);
    return isNaN(numericValue) ? null : numericValue;
};
const $d19eb99599b33e51$export$ac406cb80381c5f9 = (params, columnId, weightColumnId)=>{
    const { api: gridApi, rowNode: groupRowNode, values: values } = params;
    // numerator: Σ(value × weight)
    let weightedValueSum = 0;
    // denominator: Σ(weight)
    let totalWeight = 0;
    // params.values already respects suppressAggFilteredOnly.
    // We need the matching child nodes only for leaf rows (to look up weight column values).
    const childNodes = $d19eb99599b33e51$var$getMatchingChildNodes(groupRowNode, values.length);
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value != null && typeof value === 'object') {
            // sub-group: partial sums already computed by a previous aggregation pass
            weightedValueSum += value[columnId] ?? 0;
            totalWeight += value[weightColumnId] ?? 0;
        } else {
            // leaf row: compute value × weight from cell data
            const childNode = childNodes[i];
            if (!childNode) continue;
            // values might be strings during editing
            const columnValue = $d19eb99599b33e51$export$7d1258ebb7625a0d(value);
            const weightValue = $d19eb99599b33e51$export$7d1258ebb7625a0d(gridApi.getCellValue({
                colKey: weightColumnId,
                rowNode: childNode
            }));
            if (weightValue !== null) totalWeight += weightValue;
            if (columnValue !== null && weightValue !== null) weightedValueSum += columnValue * weightValue;
        }
    }
    const result = totalWeight !== 0 ? weightedValueSum / totalWeight : 0;
    return {
        // toString/toNumber let AG Grid's default cell renderer display and sort the value
        toString: ()=>String(result),
        toNumber: ()=>result,
        // partial sums stored so parent groups can combine sub-group results
        [columnId]: weightedValueSum,
        [weightColumnId]: totalWeight
    };
};
/**
 * Returns the child node list that corresponds to params.values.
 * When suppressAggFilteredOnly is false, params.values comes from childrenAfterFilter.
 * When true, it comes from childrenAfterGroup (all children).
 * We match by length to pick the right list without checking the grid option directly.
 */ function $d19eb99599b33e51$var$getMatchingChildNodes(groupRowNode, valueCount) {
    if (groupRowNode.childrenAfterFilter?.length === valueCount) return groupRowNode.childrenAfterFilter;
    return groupRowNode.childrenAfterGroup ?? [];
}











class $173cef15c1f89f96$export$7152f9cd2e6a982b {
    _adaptableInstance;
    agGridThemeMode;
    constructor(_adaptableInstance){
        this._adaptableInstance = _adaptableInstance;
    }
    destroy() {}
    get logger() {
        return this._adaptableInstance.logger;
    }
    get api() {
        return this._adaptableInstance.api;
    }
    setAgGridThemeMode(themeMode) {
        this.agGridThemeMode = themeMode;
    }
    getAgGridThemeMode() {
        return this.agGridThemeMode;
    }
    applyAgGridThemeOnAdaptableThemeChange(adaptableTheme, variantTheme, agGridContainer, themesToRemove) {
        if (this.agGridThemeMode === 'legacy') this.legacy_applyAgGridThemeOnAdaptableThemeChange(adaptableTheme, variantTheme, agGridContainer, themesToRemove);
        const themeName = adaptableTheme.Name;
        const isSystemTheme = this.api.themeApi.internalApi.isSystemTheme(themeName);
        if (adaptableTheme && (isSystemTheme || variantTheme)) {
            if ((variantTheme || themeName) === (0, $58846ea7f4156db7$export$ee8dd85a2e01b86f)) document.body.dataset.agThemeMode = adaptableTheme.AgThemeMode ?? 'light';
            if ((variantTheme || themeName) === (0, $58846ea7f4156db7$export$84426164da6cf571)) document.body.dataset.agThemeMode = adaptableTheme.AgThemeMode ?? 'dark';
        }
    }
    getAgGridContainerElement() {
        return this._adaptableInstance.getAgGridContainerElement();
    }
    legacy_applyAgGridThemeOnAdaptableThemeChange(adaptableTheme, variantTheme, agGridContainer, themesToRemove) {
        const themeName = adaptableTheme.Name;
        const isSystemTheme = this.api.themeApi.internalApi.isSystemTheme(themeName);
        const getAgGridLightThemeName = ()=>this.getAgGridLightThemeName();
        const getAgGridDarkThemeName = ()=>getAgGridLightThemeName() + '-dark';
        if (adaptableTheme && (isSystemTheme || variantTheme)) {
            if ((variantTheme || themeName) === (0, $58846ea7f4156db7$export$ee8dd85a2e01b86f)) adaptableTheme.AgGridClassName = adaptableTheme.AgGridClassName || getAgGridLightThemeName();
            if ((variantTheme || themeName) === (0, $58846ea7f4156db7$export$84426164da6cf571)) adaptableTheme.AgGridClassName = adaptableTheme.AgGridClassName || getAgGridDarkThemeName();
        }
        if (!adaptableTheme.AgGridClassName) // default AG Grid to its light theme
        adaptableTheme.AgGridClassName = getAgGridLightThemeName();
        if (agGridContainer != null) {
            if (themesToRemove.length) themesToRemove.forEach((theme)=>{
                if (theme.AgGridClassName) agGridContainer.classList.remove(theme.AgGridClassName);
            });
            // also remove all AG Grid theme class names
            const agGridClassNamesToRemove = [];
            agGridContainer.classList.forEach((x)=>{
                if (x && x.indexOf('ag-theme-') === 0) agGridClassNamesToRemove.push(x);
            });
            agGridClassNamesToRemove.forEach((x)=>agGridContainer.classList.remove(x));
            if (adaptableTheme && adaptableTheme.AgGridClassName) agGridContainer.classList.add(adaptableTheme.AgGridClassName);
        }
    }
    getAgGridCurrentThemeClassNames() {
        if (this.agGridThemeMode === 'legacy') this.legacy_getAgGridCurrentThemeClassNames();
        const currentAgGridTheme = this._adaptableInstance.agGridAdapter.getGridOption('theme');
        if (currentAgGridTheme === 'legacy') return this.legacy_getAgGridCurrentThemeClassNames();
        // @ts-ignore no other way than to use internals
        const currentAgGridTheme__cssClassCache = currentAgGridTheme?._cssClassCache;
        return currentAgGridTheme__cssClassCache ?? '';
    }
    getAgGridLightThemeName() {
        const container = this.getAgGridContainerElement();
        if (container && container.classList) {
            // we detect the ag theme class
            const classList = container.classList;
            for(let i = 0, len = classList.length; i < len; i++){
                const cls = classList[i];
                if (cls.indexOf('ag-theme-') === 0) // even if dark theme is included, we compute the light theme name out of it
                return cls.replace('-dark', '');
            }
        } else this.logger.warn('AG Grid container not found. Defaulting to ag-theme-balham for the light theme.');
        this.logger.warn('No ag-theme-* class found on the grid container. Defaulting to ag-theme-balham.');
        // fallback to the default light theme
        return 'ag-theme-balham';
    }
    legacy_getAgGridCurrentThemeClassNames() {
        const container = this.getAgGridContainerElement();
        if (container && container.classList) {
            // we detect the ag theme class
            const classList = container.classList;
            for(let i = 0, len = classList.length; i < len; i++){
                const cls = classList[i];
                if (cls.indexOf('ag-theme-') === 0) return cls;
            }
        }
        return this.getAgGridLightThemeName();
    }
}












const $2c60780b406d81af$var$LocalEventService_Prototype = (0, $437b23f6a393c3bf$export$820da7696a401cdc).prototype;
const $2c60780b406d81af$var$LocalEventService_dispatchEvent = $2c60780b406d81af$var$LocalEventService_Prototype.dispatchEvent;
$2c60780b406d81af$var$LocalEventService_Prototype.dispatchEvent = function(event) {
    const agGridApi = event.api;
    if (agGridApi?.isDestroyed()) // do nothing if AG Grid was destroyed in the meantime
    return;
    $2c60780b406d81af$var$LocalEventService_dispatchEvent.apply(this, arguments);
    if (event.type === 'cellChanged' || event.type === 'dataChanged') {
        // @ts-ignore
        const eventRowNode = event.node;
        if (!eventRowNode) {
            (0, $10f858c943b30cc8$export$a58502b374804b0f).consoleErrorBase(`No RowNode found in passed event, this should never happen!`, event);
            return;
        }
        const extractGridApiFromRowNode = (rowNode)=>{
            const rowNodeApi = rowNode?.beans?.gridApi;
            if (!rowNodeApi) (0, $10f858c943b30cc8$export$a58502b374804b0f).consoleErrorBase(`No GridAPI found in passed RowNode, this should never happen!`, rowNode);
            return rowNodeApi;
        };
        // we don't know from which instance of aggrid this is coming,
        // as this fn is shared by all instances
        if (eventRowNode) $2c60780b406d81af$export$a19c58cdd10e13f7.forEachAdaptable((adaptable)=>{
            if (extractGridApiFromRowNode(eventRowNode) !== adaptable.agGridAdapter?.getAgGridApi(true)) // the event is coming from another aggrid instance
            // so IGNORE IT
            return;
            if (adaptable.isDestroyed) // do nothing if adaptable is destroyed (this is a rare case and happens when Adaptable is quickly destroyed and recreated)
            return;
            // we're on the correct instance, so do this
            //@ts-ignore
            const fn = adaptable.rowListeners ? adaptable.rowListeners[event.type] : null;
            if (fn) fn(event);
        });
    }
};
const $2c60780b406d81af$var$adaptableInstances = {};
const $2c60780b406d81af$var$publishTimestamp = Number((0, $5729c20ddc89490c$export$b2e35ef07067ff16));
class $2c60780b406d81af$export$a19c58cdd10e13f7 {
    logger;
    _id;
    lifecycleState;
    variant;
    emitter;
    /**
     * Runtime flags
     */ hasAutogeneratedPrimaryKey;
    hasAdaptableToolPanel;
    initWithLazyData;
    _rawAdaptableOptions;
    adaptableOptions;
    _isDetailGrid;
    _isDetailGridForIndex;
    agGridOptionsService;
    agGridAdapter;
    agGridColumnAdapter;
    agGridMenuAdapter;
    agGridExportAdapter;
    agGridThemeAdapter;
    agGridModulesAdapter;
    DANGER_USE_GETTER_adaptableContainerElement;
    DANGER_USE_GETTER_agGridContainerElement;
    api;
    adaptableStore;
    adaptableModules;
    DataService;
    CalculatedColumnExpressionService;
    ModuleService;
    ValidationService;
    QueryLanguageService;
    AlertService;
    TeamSharingService;
    MetamodelService;
    RowFormService;
    Fdc3Service;
    AnnotationsService;
    FlashingCellService;
    ThemeService;
    LicenseService;
    ChartingService;
    rowListeners;
    throttleFilterOnDataChange;
    debouncedSetSelectedRows;
    debouncedSetSelectedCells;
    agGridListenerKeydown;
    agGridListenerMouseEnter;
    agGridListenerMouseLeave;
    listenerGlobalSetRowSelection;
    listenerGlobalChartingChanges;
    listenerCellEditingStarted;
    listenerFirstDataRendered;
    listenerPivotChanged;
    listenerCellSelectionChanged;
    listenerSortChanged;
    listenerColumnGroupOpened;
    layoutManager;
    columnMinMaxValuesCache = {};
    renderReactRoot = (node, container)=>(0, $11cae39faa17d15e$export$aec53ba866c983c7)(node, container);
    unmountReactRoot;
    unmountLoadingScreen;
    /**
     * Temporary, these are MIGRATION technical debts, and should be removed as soon as possible
     */ adaptableStatusPanelKeys = [];
    adaptableStatusPanelDefs = [];
    hasAdaptableStatusBar;
    // see #no_additional_react_root
    _PRIVATE_adaptableJSXElement;
    _prevLayout;
    __prevLayoutForRefresh;
    constructor(config){
        this.lifecycleState = 'initial';
        this.emitter = new (0, $7ddf72f79776fa87$export$2e2bcd8739ae039)();
        this.agGridOptionsService = new (0, $b8834b9ebb39e93d$export$35b551bc3dba5dab)(this);
        this.agGridAdapter = new (0, $45759c221bd07273$export$787bb8cf103677e0)(this, config);
        this.agGridMenuAdapter = new (0, $391c88543ccf5f98$export$81e00ecf8a6c1766)(this);
        this.agGridColumnAdapter = new (0, $a8be936b3426b8a3$export$caefbb91be8d6aaf)(this);
        this.agGridExportAdapter = new (0, $160c6fe5c8b728e7$export$d17645576d7c2129)(this);
        this.agGridThemeAdapter = new (0, $173cef15c1f89f96$export$7152f9cd2e6a982b)(this);
        this.agGridModulesAdapter = new (0, $616aa345b7ff1396$export$4d5f683626bc2ec6)(this);
        this.DataService = new (0, $52eb362f093aaad8$export$7f2f61054d5119ac)(this);
    }
    static forEachAdaptable(fn) {
        Object.keys($2c60780b406d81af$var$adaptableInstances).forEach((key)=>{
            fn($2c60780b406d81af$var$adaptableInstances[key]);
        });
    }
    static collectInstance(adaptable, adaptableId) {
        adaptable._id = adaptableId;
        $2c60780b406d81af$var$adaptableInstances[adaptable._id] = adaptable;
    }
    static dismissInstance(adaptable) {
        delete $2c60780b406d81af$var$adaptableInstances[adaptable._id];
    }
    get isAgGridInitialising() {
        return this.lifecycleState === 'initAgGrid';
    }
    get isReady() {
        return this.lifecycleState === 'ready';
    }
    get isAvailable() {
        return this.lifecycleState === 'available' || this.lifecycleState === 'ready';
    }
    get isDestroyed() {
        return this.lifecycleState === 'preDestroyed';
    }
    // only for our private / internal events used within Adaptable
    // public events are emitted through the EventApi
    _emit = (eventName, data)=>{
        if (this.emitter) return this.emitter.emit(eventName, data);
    };
    _emitSync = (eventName, data)=>{
        if (this.emitter) return this.emitter.emitSync(eventName, data);
    };
    _on = (eventName, callback)=>{
        if (!this.emitter) return ()=>{};
        return this.emitter.on(eventName, callback);
    };
    _onIncludeFired = (eventName, callback)=>{
        if (!this.emitter) return ()=>{};
        return this.emitter.onIncludeFired(eventName, callback);
    };
    /**
     * Internal initializer for Adaptable, directly called by the React and Angular Adaptable wrappers
     * @private
     */ static async _initInternal(config) {
        let promise = null;
        if (Array.isArray(config.adaptableOptions.plugins)) {
            const agGridOptions = {
                gridOptions: config.gridOptions,
                modules: config.modules
            };
            for (let plugin of config.adaptableOptions.plugins)promise = promise && promise.then ? promise.then(()=>{
                return plugin.beforeInit(config.adaptableOptions, agGridOptions);
            }) : plugin.beforeInit(config.adaptableOptions, agGridOptions);
            // if gridOptions changed, we need to update the runtimeConfig
            if (agGridOptions.gridOptions !== config.gridOptions) // This allows plugins to modify
            // FIXME AFL MIG: clarify if this is still needed (for NoCode Plugin?)
            // it looks like a code smell, ideally we should get rid of it
            config.gridOptions = agGridOptions.gridOptions;
        }
        const doInit = (adaptableInstance)=>{
            return adaptableInstance._initAdaptableAgGrid(config).then((api)=>{
                if (Array.isArray(config.adaptableOptions.plugins)) config.adaptableOptions.plugins.forEach((plugin)=>{
                    plugin.afterInit(adaptableInstance);
                });
                return api;
            });
        };
        if (promise && promise.then) return promise.then(()=>{
            const adaptableInstance = new $2c60780b406d81af$export$a19c58cdd10e13f7({
                getAgGridColumnApiModuleReference: config.getAgGridColumnApiModuleReference
            });
            return doInit(adaptableInstance);
        });
        else {
            const adaptableInstance = new $2c60780b406d81af$export$a19c58cdd10e13f7({
                getAgGridColumnApiModuleReference: config.getAgGridColumnApiModuleReference
            });
            return doInit(adaptableInstance);
        }
    }
    async _initAdaptableAgGrid(config) {
        // Phase 1: Preprocess Adaptable Options
        this._isDetailGrid = config.isDetailGrid === true;
        this._isDetailGridForIndex = config.isDetailGridForRowIndex;
        this.lifecycleState = 'preprocessOptions';
        this._rawAdaptableOptions = config.adaptableOptions;
        if ((0, $9OAZF.default).IsNullOrEmptyOrWhiteSpace(this._rawAdaptableOptions.adaptableId)) this._rawAdaptableOptions.adaptableId = `adaptable_id_${Date.now()}`;
        this.logger = this.logger ?? new (0, $10f858c943b30cc8$export$a58502b374804b0f)(this._rawAdaptableOptions.adaptableId);
        const adaptableId = this._rawAdaptableOptions.adaptableId;
        const initMarker = (0, $640f77453ad4a03c$export$cd7dd5b5380f942f)(adaptableId).track.Init.label.Init.start();
        const perfInitAdaptableAgGrid = this.logger.beginPerf(`Adaptable._initAdaptableAgGrid()`);
        $2c60780b406d81af$export$a19c58cdd10e13f7.collectInstance(this, this._rawAdaptableOptions.adaptableId);
        this.variant = config.variant;
        this.initWithLazyData = config.gridOptions.rowData == undefined || config.gridOptions.rowData.length === 0;
        this.hasAutogeneratedPrimaryKey = !!this._rawAdaptableOptions.autogeneratePrimaryKey;
        this.adaptableOptions = (0, $b7240075c75a7844$export$38d7e410c90a5f7e)(this._rawAdaptableOptions);
        this.adaptableOptions = this.normalizeAdaptableOptions(this.adaptableOptions);
        const { showLoadingScreen: showLoadingScreen, loadingScreenDelay: loadingScreenDelay, loadingScreenText: loadingScreenText, loadingScreenTitle: loadingScreenTitle } = this.adaptableOptions.userInterfaceOptions.loadingScreenOptions;
        if (showLoadingScreen) {
            this.logger.info('Showing loading screen');
            // it's important to use ensureLoadingScreenPortalElement
            // and not ensurePortalElement, because multiple adaptable instances share the same portal element
            // so when displaying the second one, the react root associated to the portal element
            // seems to be somewhat shared via the html element, so the portal element of the first one is destroyed
            // resulting in the settings popup not being displayed anymore
            const portalElement = (0, $addd0c5b92150265$export$1237d7d2d4232a6)();
            if (portalElement) this.unmountLoadingScreen = this.renderReactRoot((0, $acw62.createElement)((0, $845d8a1062d21b2f$export$828beb49cc455674), {
                showLoadingScreen: showLoadingScreen,
                loadingScreenDelay: loadingScreenDelay,
                loadingScreenText: loadingScreenText,
                loadingScreenTitle: loadingScreenTitle
            }), portalElement);
            else this.logger.consoleError('Failed to create loading screen portal element.');
        }
        this.forPlugins((plugin)=>plugin.afterInitOptions(this, this.adaptableOptions));
        this.api = new (0, $817f0462ed83c088$export$7b1465d94b24e17c)(this);
        this.forPlugins((plugin)=>plugin.afterInitApi(this, this.api));
        this.lifecycleState = 'initAdaptableState';
        this.initServices();
        this.forPlugins((plugin)=>plugin.afterInitServices(this));
        this.adaptableModules = this.initModules();
        this.forPlugins((plugin)=>plugin.afterInitModules(this, this.adaptableModules));
        const loadStoreMarker = (0, $640f77453ad4a03c$export$cd7dd5b5380f942f)(adaptableId).track.Init.label.LoadStore.start();
        const perfLoadStore = this.logger.beginPerf(`loadStore()`);
        this.adaptableStore = this.initAdaptableStore();
        this.forPlugins((plugin)=>plugin.afterInitStore(this));
        await this.adaptableStore.loadStore({
            adaptable: this,
            adaptableStateKey: this.adaptableOptions.adaptableStateKey,
            /**
             * This method is called after the store is loaded;
             * it allows to modify the state before it is used by the application
             * e.g. migrating deprecated state, etc.
             */ postLoadHook: (state)=>{
                if (this.adaptableOptions.stateOptions.autoMigrateState) {
                    this.api.logError;
                    const config = {
                        // version 16 actually includes all versions up until 16
                        fromVersion: 16,
                        logger: this.logger
                    };
                    state = (0, $cc99a2866dd5bf8d$export$760ebbf3c2f6fe3a).migrateAdaptableState(state, config);
                }
                state = this.normalizeAdaptableState(state, config.gridOptions);
                return state;
            }
        });
        perfLoadStore.end();
        loadStoreMarker.end();
        // just in case Adaptable was destroyed while loading the store (which is an async operation)
        if (this.isDestroyed) {
            this.midwayDestroy();
            return Promise.reject('Adaptable was destroyed while loading the store.');
        // FIXME AFL MIG: is this enough?! talk with the team
        }
        this.forPlugins((plugin)=>plugin.afterInitialStateLoaded(this));
        // do this now so it sets module entitlements
        this.api.entitlementApi.internalApi.setModulesEntitlements();
        /**
         * At this point it's mandatory to have the ALL the Adaptable blocks initialized:
         * Store, APIs, Services, Modules
         */ this.lifecycleState = 'setupAgGrid';
        const gridOptions = config.gridOptions;
        // Needed here because special column defs are required for deriving the adaptable column state
        let columnDefs = this.agGridAdapter.getColumnDefinitionsInclSpecialColumns(gridOptions.columnDefs || []);
        // see #map_dateString_to_date
        this.agGridAdapter.patchColDefs(columnDefs, (colDef)=>{
            if (colDef.cellDataType === 'dateString') {
                this.logger.consoleError(`Column "${colDef.colId}" uses cellDataType="dateString" which is no longer supported. It has been replaced with cellDataType="date". Please update your column definition.`);
                colDef.cellDataType = 'date';
            }
        });
        gridOptions.columnDefs = columnDefs;
        this.setInitialGridOptions(gridOptions, config.variant);
        const { gridState: initialGridState, layoutModel: layoutModel } = this.mapAdaptableStateToAgGridState(this.adaptableStore.TheStore.getState(), gridOptions.columnDefs, {
            isTree: !!gridOptions.treeData,
            colTypes: gridOptions.columnTypes,
            defaultColDef: gridOptions.defaultColDef
        });
        columnDefs = (0, $34e0a646a54b76b6$export$4a04ad01c410b415).getColumnDefsChangesForLayout(layoutModel, columnDefs) ?? columnDefs;
        gridOptions.columnDefs = columnDefs;
        gridOptions.initialState = initialGridState;
        if (layoutModel) {
            if ((0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(layoutModel)) gridOptions.pivotDefaultExpanded = layoutModel.PivotExpandLevel;
            gridOptions.groupDisplayType = layoutModel.RowGroupDisplayType === 'multi' ? 'multipleColumns' : 'singleColumn';
            // fixes issue #3053
            gridOptions.suppressAggFuncInHeader = !!layoutModel.SuppressAggFuncInHeader;
        }
        this.lifecycleState = 'initAgGrid';
        this.agGridAdapter.initialGridOptions = gridOptions;
        const perfInitAgGrid = this.logger.beginPerf(`initAgGrid()`);
        const initAgGridMarker = (0, $640f77453ad4a03c$export$cd7dd5b5380f942f)(adaptableId).track.Init.label.InitAGGrid.start();
        this.validateColumnDefTypes(gridOptions.columnDefs);
        const agGridApi = await this.initializeAgGrid(gridOptions, config.modules, config.renderAgGridFrameworkComponent);
        if (agGridApi === false) {
            this.midwayDestroy();
            this.logger.consoleError('Failed to initialize AG Grid.');
            return Promise.reject('Failed to initialize AG Grid.');
        }
        this.layoutManager = new (0, $34e0a646a54b76b6$export$4a04ad01c410b415)({
            gridApi: agGridApi,
            debugId: this.adaptableOptions.adaptableId
        });
        this.silentUpdateCurrentLayoutModel(layoutModel);
        // this shouldn't be needed
        // but AG Grid has a bug, and in pivot layout,
        // even if we provide an initial AG Grid state with
        // the aggregations in the correct order,
        // they will end up in the wrong order
        // so we need to force the layout to be applied again
        if ((0, $dba0ee26b73908a4$export$453fc3fd17cf05a5)(layoutModel)) this.layoutManager.setLayout(layoutModel, {
            force: true
        });
        this.layoutManager.onChange((layoutModel)=>{
            const newLayoutObject = (0, $702a77ed6db22640$export$538c1d9eb946f389)(layoutModel);
            this.onLayoutChange(newLayoutObject);
        });
        this.layoutManager.onColumnDefsChanged(()=>{
            this.updateColumnModelAndRefreshGrid();
        });
        this.logger.info('Hiding loading screen');
        this.unmountLoadingScreen?.();
        perfInitAgGrid.end();
        initAgGridMarker.end();
        // we need to intercept several AG Grid Api methods and trigger Adaptable state changes
        this.agGridAdapter.setAgGridApi(agGridApi);
        this.agGridAdapter.monkeyPatchingGridOptionsUpdates();
        this.agGridAdapter.monkeyPatchingAggColumnFilters();
        this.lifecycleState = 'agGridReady';
        this.api.entitlementApi.internalApi.setModulesAgGridDepsInfos();
        this.ModuleService.logMissingAgGridDepsInfos();
        this.logger.info('Registered AG Grid modules (including dependents):', this.agGridModulesAdapter.getAgGridRegisteredModuleNames().sort());
        /**
         * At this point AG Grid is initialized!
         */ this.deriveAdaptableColumnStateFromAgGrid();
        this.agGridColumnAdapter.setupColumns();
        // we need this because we need the internal Column state to be ready before doing any extra business logic
        this.lifecycleState = 'available';
        this.api.themeApi.applyCurrentTheme();
        this.validatePrimaryKey();
        this.checkShouldClearExistingFiltersOrSearches();
        // initial filter model
        const filteringApplied = this.applyFiltering();
        // We may need to re-apply sort if there are ColumnSorts for columns with CustomSort defined
        // This is required because AG Grid wasn't aware of the CustomSort when applying sorting initially
        // this is not required when filtering was applied because filtering also triggers a sort refresh internally
        if (!filteringApplied) this.refreshInitialSortIfNeeded();
        // apply quick search if there is one
        // yes, we could have put this on the gridOptions.findSearchValue
        // but we need to wait for setupColumns to run first so as to correctly
        // determine on which columns the quick search should be applied or not
        // and also to setup the quick search style
        const quickSearchState = this.api.stateApi.getQuickSearchState();
        if (quickSearchState.QuickSearchText) this.setAgGridFindSearchValue(quickSearchState.QuickSearchText);
        this.addGridEventListeners();
        this.temporaryAdaptableStateUpdates();
        this.redrawBody();
        this.refreshHeader();
        const currentLayout = this.api.layoutApi.getCurrentLayout();
        (0, $702a77ed6db22640$export$88f5e04cb6a7b262)(currentLayout);
        this._prevLayout = currentLayout;
        this.__prevLayoutForRefresh = currentLayout;
        const layoutModelForApply = (0, $702a77ed6db22640$export$3732e731bff1a886)(currentLayout);
        this.layoutManager.applyRowGroupValues(layoutModelForApply.RowGroupValues, layoutModelForApply.RowGroupedColumns);
        this.layoutManager.applyColumnGroupCollapseExpandState(layoutModelForApply);
        this.autoSizeLayoutIfNeeded();
        this.ModuleService.createModuleUIItems();
        const adaptableContainerElem = this.getAdaptableContainerElement();
        if (adaptableContainerElem != null) {
            adaptableContainerElem.innerHTML = '';
            if (this.variant === 'react') /**
                 * #no_additional_react_root
                 * This is only used for the React variant
                 * Where we don't want to create a new React render tree here
                 * by rendering it as a React root, but instead we want to
                 * render it as is in the React tree of our AdaptableReact component
                 */ this._PRIVATE_adaptableJSXElement = (0, $13e96825b3d41372$export$f1b71ac9400d32a0)({
                Adaptable: this
            });
            else this.unmountReactRoot = this.renderReactRoot((0, $13e96825b3d41372$export$f1b71ac9400d32a0)({
                Adaptable: this
            }), adaptableContainerElem);
        }
        this.lifecycleState = 'ready';
        this.forPlugins((plugin)=>plugin.onAdaptableReady(this, this.adaptableOptions));
        setTimeout(()=>{
            // without the setTimeout, calling autoSizeAllColumns immediately in the onAdaptableReady
            // does not work. (I prefer setTimeout to rAF, as raf is not running when you switch tabs)
            //
            // it also makes it possible to listen to CALCULATED_COLUMN_READY, DASHBOARD_READY, etc.
            // in onAdaptableReady - without this those event listeners are not triggered
            this.api?.eventApi?.emit('AdaptableReady', {
                adaptableApi: this.api,
                agGridApi: this.agGridAdapter.getAgGridApi()
            });
        });
        perfInitAdaptableAgGrid.end();
        initMarker.end();
        return Promise.resolve(this.api);
    }
    midwayDestroy() {
        this.destroy({
            destroyAgGrid: false,
            unmount: false
        });
    }
    normalizeAdaptableState(state, agGridOptions) {
        state = this.normaliseLayoutState(state, agGridOptions);
        state = this.normaliseToolPanelState(state);
        return state;
    }
    normaliseLayoutState(state, gridOptions) {
        const layoutState = state.Layout;
        // ensure that at least one Layout has been provided
        if (!layoutState || !layoutState.Layouts?.length) this.logger.consoleError('No Layouts defined in InitialState.Layout.Layouts[]. At least one Layout is required.');
        // ensure CurrentLayout is valid
        if (!layoutState.CurrentLayout || !layoutState.Layouts.find((l)=>l.Name === layoutState.CurrentLayout)) layoutState.CurrentLayout = layoutState.Layouts?.[0]?.Name;
        /**
         * Viewport mode does not support a few AG Grid features which are contained in a Layout
         * Accordingly we remove this when using this Row Model
         */ if (gridOptions.rowModelType === 'viewport') {
            if (state.Layout.Layouts) state.Layout.Layouts = state.Layout.Layouts.filter((layout)=>{
                if ((0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)) return false;
                if (layout.RowGroupedColumns) delete layout.RowGroupedColumns;
                if (layout.TableAggregationColumns) delete layout.TableAggregationColumns;
                return true;
            });
        }
        if (state.Layout.Layouts) {
            const normalizeOptions = {
                isTree: !!gridOptions.treeData
            };
            // it's very important that we do this here
            // as the layout may not be fully specified in the initialState
            // eg: might not include the generated row group columns in the column order
            // but the normalization does this for us
            state.Layout.Layouts = state.Layout.Layouts.map((layout)=>(0, $702a77ed6db22640$export$d859d72b10c9a984)(layout, normalizeOptions));
            //now let's normalize the In/NotIn predicate for the group column
            // the inputs in this predicate should be an array of arrays
            // but for ease of use (and also for similarity with the In predicate for
            // other columns) we allow the inputs to be an array of strings
            // and change them to an array of arrays
            state.Layout.Layouts = state.Layout.Layouts.map((layout)=>{
                if (Array.isArray(layout.ColumnFilters)) layout.ColumnFilters = layout.ColumnFilters.map((columnFilter)=>{
                    if (columnFilter.ColumnId === (0, $58846ea7f4156db7$export$1fadf36dae8ed962)) {
                        if (Array.isArray(columnFilter.Predicates)) columnFilter.Predicates = columnFilter.Predicates.map((predicate)=>{
                            if (predicate.PredicateId === 'In' || predicate.PredicateId === 'NotIn') {
                                if (Array.isArray(predicate.Inputs)) predicate.Inputs = predicate.Inputs.map((input)=>{
                                    if (!Array.isArray(input)) return [
                                        input
                                    ];
                                    return input;
                                });
                            }
                            return predicate;
                        });
                    }
                    return columnFilter;
                });
                return layout;
            });
        }
        return state;
    }
    normaliseToolPanelState(state) {
        if (state?.ToolPanel?.ToolPanels) return state;
        // no Initial Adaptable State provided, we will display all the panels collapsed (custom & module)
        const defaultToolPanels = [];
        this.adaptableOptions.toolPanelOptions?.customToolPanels?.forEach((customToolPanel)=>defaultToolPanels.push({
                Name: customToolPanel.name
            }));
        (0, $c75adffdf90b3d81$export$d064dfbe60243148).forEach((moduleToolPanel)=>defaultToolPanels.push({
                Name: moduleToolPanel
            }));
        const toolPanelState = state.ToolPanel || {};
        toolPanelState.ToolPanels = defaultToolPanels;
        state.ToolPanel = toolPanelState;
        return state;
    }
    getCurrentLayoutModel() {
        const currentLayout = this.api.layoutApi.getCurrentLayout();
        if (!currentLayout) return null;
        return (0, $702a77ed6db22640$export$3732e731bff1a886)(currentLayout);
    }
    silentUpdateCurrentLayoutModel(layoutModel = this.getCurrentLayoutModel()) {
        if (!layoutModel) return;
        this.layoutManager.silentSetCurrentLayout(layoutModel, {
            normalize: true
        });
    }
    /**
     * Returns TRUE if filtering was applied, FALSE otherwise
     * This is important in the INIT phase because applying filtering will automatically refresh AG Grids columnState,
     * implicitly refreshing the sorting state too (hence we don't need to apply sorting separately)
     */ applyFiltering(config) {
        let filteringApplied = false;
        // default updateColumnFilterModel to TRUE, if not provided
        const updateColumnFilterModel = config?.updateColumnFilterModel ?? true;
        const agGridApi = this.agGridAdapter.getAgGridApi();
        if (updateColumnFilterModel) {
            const columnFilters = this.api.filterApi.columnFilterApi.getActiveColumnFilters()// we need this additional filter because 'getActiveColumnFilters' checks only for suspended while 'isColumnFilterActive' also checkss for COMPLETE filters
            .filter((columnFilter)=>this.api.filterApi.columnFilterApi.isColumnFilterActive(columnFilter));
            const filterModel = {};
            columnFilters.forEach((columnFilter)=>{
                filterModel[columnFilter.ColumnId] = columnFilter;
            });
            agGridApi.setFilterModel(filterModel);
            filteringApplied = Object.keys(filterModel).length > 0;
        }
        // FIXME AFL FILTER why is this needed???
        this.refreshSelectedCellsState();
        this.refreshSelectedRowsState();
        // agGridApi.setFilterModel() already triggered onFilterChanged(), so we skip it if updateColumnFilterModel is TRUE
        if (!filteringApplied) {
            agGridApi.onFilterChanged();
            filteringApplied = true;
        }
        this._emit('AdapTableFiltersApplied');
        return filteringApplied;
    }
    /**
     * Checks if the current layout has ColumnSorts for columns that have CustomSort defined
     * (either via initialState CustomSorts or via customSortComparers option) and refreshes the sort if needed.
     */ refreshInitialSortIfNeeded() {
        const currentLayout = this.api.layoutApi.getCurrentLayout();
        const columnSorts = currentLayout?.ColumnSorts;
        if (!columnSorts || columnSorts.length === 0) return;
        const hasCustomSortForSortedColumn = columnSorts.some((columnSort)=>{
            // Check if there's a CustomSort defined in state for this column
            const customSort = this.api.customSortApi.getCustomSortForColumn(columnSort.ColumnId);
            if (customSort && !customSort.IsSuspended) return true;
            // Check if there's a customSortComparer defined in options for this column
            if (this.api.customSortApi.internalApi.columnHasCustomSortComparer(columnSort.ColumnId)) return true;
            return false;
        });
        if (hasCustomSortForSortedColumn) this.layoutManager.refreshSort();
    }
    showQuickFilter() {
        const height = this.api.optionsApi.getFilterOptions().columnFilterOptions.quickFilterHeight;
        this.agGridAdapter.getAgGridApi().setGridOption('floatingFiltersHeight', height);
    }
    hideQuickFilter() {
        this.agGridAdapter.getAgGridApi().setGridOption('floatingFiltersHeight', 0);
    }
    showAdaptableToolPanel() {
        if (!this.hasAdaptableToolPanel) {
            // don't re-add the ToolPanel if it's hidden by entitlement
            if (this.api.entitlementApi.isModuleHiddenEntitlement('ToolPanel')) return;
            const currentSideBar = this.agGridAdapter.getGridOption('sideBar');
            if (currentSideBar?.toolPanels) {
                const updatedSideBar = {
                    ...currentSideBar,
                    toolPanels: [
                        ...currentSideBar.toolPanels,
                        this.buildAdaptableToolPanelDef()
                    ]
                };
                this.agGridAdapter.setGridOption('sideBar', updatedSideBar);
                this.hasAdaptableToolPanel = true;
            }
        }
    }
    hideAdaptableToolPanel() {
        if (this.hasAdaptableToolPanel) {
            // close the tool panel if it's currently open
            this.api.toolPanelApi.closeAdapTableToolPanel();
            const currentSideBar = this.agGridAdapter.getGridOption('sideBar');
            if (currentSideBar?.toolPanels) {
                const updatedSideBar = {
                    ...currentSideBar,
                    toolPanels: currentSideBar.toolPanels.filter((toolPanelDef)=>{
                        if (typeof toolPanelDef === 'string') return toolPanelDef !== $58846ea7f4156db7$export$f5231957f9b36e9c;
                        return toolPanelDef.id !== $58846ea7f4156db7$export$f5231957f9b36e9c;
                    })
                };
                this.agGridAdapter.setGridOption('sideBar', updatedSideBar);
            }
            this.hasAdaptableToolPanel = false;
        }
    }
    buildAdaptableToolPanelDef() {
        return {
            id: $58846ea7f4156db7$export$f5231957f9b36e9c,
            toolPanel: $58846ea7f4156db7$export$3d55de7351197e08,
            labelDefault: $58846ea7f4156db7$export$15c400f7cef9b84d,
            labelKey: 'adaptable',
            iconKey: 'menu',
            width: (0, $5aWMQ.default).getAdaptableToolPanelWidth(),
            minWidth: (0, $5aWMQ.default).getAdaptableToolPanelWidth()
        };
    }
    showAdaptableStatusBar() {
        if (!this.hasAdaptableStatusBar && this.adaptableStatusPanelDefs.length > 0) {
            const currentStatusBar = this.agGridAdapter.getGridOption('statusBar');
            if (currentStatusBar) {
                // filter out any Adaptable panels that may already exist to avoid duplicates
                const existingNonAdaptablePanels = (currentStatusBar.statusPanels ?? []).filter((panel)=>!this.adaptableStatusPanelKeys.includes(panel.key));
                const updatedStatusBar = {
                    ...currentStatusBar,
                    statusPanels: [
                        ...existingNonAdaptablePanels,
                        ...this.adaptableStatusPanelDefs
                    ]
                };
                this.agGridAdapter.setGridOption('statusBar', updatedStatusBar);
                this.hasAdaptableStatusBar = true;
            }
        }
    }
    hideAdaptableStatusBar() {
        if (this.hasAdaptableStatusBar) {
            const currentStatusBar = this.agGridAdapter.getGridOption('statusBar');
            if (currentStatusBar?.statusPanels) {
                const updatedStatusBar = {
                    ...currentStatusBar,
                    statusPanels: currentStatusBar.statusPanels.filter((panel)=>!this.adaptableStatusPanelKeys.includes(panel.key))
                };
                this.agGridAdapter.setGridOption('statusBar', updatedStatusBar);
            }
            this.hasAdaptableStatusBar = false;
        }
    }
    normalizeAdaptableOptions(adaptableOptions) {
        if (this.hasAutogeneratedPrimaryKey) {
            this.logger.warn(`Autogenerated primary key is enabled (adaptableOptions.autogeneratedPrimaryKey = true). This should be a last resort as it limits some Adaptable features. See: ${(0, $53c62e7ff907ad8d$export$67bdec9cfb148ab5)}`);
            this.adaptableOptions.primaryKey = (0, $58846ea7f4156db7$export$a1806c9475ecdc0);
            return this.adaptableOptions;
        }
        if ((0, $9OAZF.default).IsNullOrEmpty(adaptableOptions.primaryKey)) this.logger.consoleError(`adaptableOptions.primaryKey is required and must not be empty. As a fallback, set adaptableOptions.autogeneratedPrimaryKey = true. See: ${(0, $53c62e7ff907ad8d$export$67bdec9cfb148ab5)}`);
        return adaptableOptions;
    }
    setInitialGridOptions(gridOptions, variant) {
        /**
         * set Adaptable instance on the AG Grid context
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'context', (original_context)=>{
            const userContext = original_context || {};
            return {
                ...userContext,
                __adaptable: this,
                adaptableApi: this.api
            };
        });
        /**
         * `gridId`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'gridId', (original_gridId)=>{
            let agGridId = original_gridId || this.adaptableOptions.adaptableId;
            if (this._isDetailGridForIndex != null) agGridId = `${agGridId}_detail-${this._isDetailGridForIndex}`;
            this.agGridAdapter.setAgGridId(agGridId);
            return agGridId;
        });
        /**
         * `defaultColDef`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'defaultColDef', (original_defaultColDef)=>{
            if (original_defaultColDef?.headerValueGetter) {
                this.logger.warn('defaultColDef.headerValueGetter overrides the Adaptable header mechanism. Consider using ColumnOptions.columnHeader instead.');
                return original_defaultColDef;
            }
            // #customize_header
            const defaultColDef = {
                ...original_defaultColDef
            };
            defaultColDef.headerValueGetter = (0, $aba1af7dfef01b91$export$12fe5405255479a6)((params)=>{
                const columnHeaderName = this.api.columnApi.internalApi.getColumnHeaderName(params);
                const formattedHeaderName = this.api.formatColumnApi.internalApi.formatColumnHeaderName(columnHeaderName, params);
                return formattedHeaderName;
            });
            return defaultColDef;
        });
        /**
         * `defaultColGroupDef`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'defaultColGroupDef', (original_defaultColGroupDef)=>{
            if (original_defaultColGroupDef?.headerValueGetter) {
                this.logger.warn('defaultColGroupDef.headerValueGetter overrides the Adaptable header mechanism. Consider using ColumnOptions.tableColumnHeader instead.');
                return original_defaultColGroupDef;
            }
            const defaultColGroupDef = {
                ...original_defaultColGroupDef
            };
            defaultColGroupDef.headerValueGetter = (0, $aba1af7dfef01b91$export$12fe5405255479a6)((params)=>{
                return this.api.columnApi.internalApi.getColumnHeaderName(params);
            });
            return defaultColGroupDef;
        });
        /**
         * `autoGroupColumnDef`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'autoGroupColumnDef', (original_autoGroupColumnDef)=>{
            // #autoGroupColumnDef
            const useAdaptableFilter = this.adaptableOptions.filterOptions.useAdaptableFiltering;
            if (!useAdaptableFilter) return original_autoGroupColumnDef;
            if (original_autoGroupColumnDef?.filter === false) {
                // if user disables filter on autoGroupColumnDef, we respect that
                this.logger.info('autoGroupColumnDef.filter is disabled via user configuration.');
                return original_autoGroupColumnDef;
            }
            if (typeof original_autoGroupColumnDef?.filter === 'object') {
                this.logger.consoleWarn('autoGroupColumnDef.filter overrides the Adaptable filtering mechanism for the Group Column. Adaptable-managed filters will not apply to this column. Contact support for alternatives.');
                return original_autoGroupColumnDef;
            }
            const autoGroupColumnDef = {
                ...original_autoGroupColumnDef
            };
            // this is required to make sure that AG Grid doesn't disable the filter
            // !! DO NOT REMOVE THIS !!
            // see https://github.com/ag-grid/ag-grid/blob/6f43ff257c2e285068eb425b655e58d6eeb89816/packages/ag-grid-enterprise/src/rowHierarchy/autoColService.ts#L225
            autoGroupColumnDef.filterValueGetter = (params)=>{
                this.logger.consoleWarn('Unexpected invocation of autoGroupColumnDef.filterValueGetter. This is not expected under normal operation. Please contact support.', params);
                return '';
            };
            // !! it is important that we always return the same component / handler instances
            // otherwise AG Grid will re-create the filter instance on each filterModel change
            const autoGroupFilterComponent = (0, $c168dc980eb01782$export$3082f1e1d504f03c)(this);
            const autoGroupFilterHandlerGenerator = ()=>new (0, $a23991341724d458$export$e706c937f1e8c12d)(this.api);
            // Use a getter to dynamically return different filter values based on Layout.RowGroupDisplayType
            Object.defineProperty(autoGroupColumnDef, 'filter', {
                get: ()=>{
                    const rowGroupDisplayType = this.api.layoutApi.internalApi.getCurrentLayoutRowGroupDisplayType();
                    if (rowGroupDisplayType === 'single') return {
                        component: autoGroupFilterComponent,
                        handler: autoGroupFilterHandlerGenerator
                    };
                    const groupedColumnFilterConfig = this.api.layoutApi.internalApi.areAllGroupedColumnsFilterable();
                    if (groupedColumnFilterConfig.filter) return 'agGroupColumnFilter';
                    return original_autoGroupColumnDef?.filter;
                },
                enumerable: true,
                configurable: true
            });
            if (original_autoGroupColumnDef?.floatingFilter !== false) {
                autoGroupColumnDef.suppressFloatingFilterButton = true;
                Object.defineProperty(autoGroupColumnDef, 'floatingFilter', {
                    get: ()=>{
                        const rowGroupDisplayType = this.api.layoutApi.internalApi.getCurrentLayoutRowGroupDisplayType();
                        if (rowGroupDisplayType === 'single') return true;
                        // this is required because of AG Grid bug, see https://github.com/AdaptableTools/adaptable/issues/3212
                        if (rowGroupDisplayType === 'multi') {
                            const groupedColumnFilterConfig = this.api.layoutApi.internalApi.areAllGroupedColumnsFilterable();
                            if (groupedColumnFilterConfig.floatingFilter) return true;
                        }
                        return original_autoGroupColumnDef?.floatingFilter;
                    },
                    enumerable: true,
                    configurable: true
                });
                // !! it is important that we always return the same component / handler instances
                // otherwise AG Grid will re-create the filter instance on each filterModel change
                const autoGroupFloatingFilterComponent = (0, $ba1513febca88082$export$d4bfbfc27496bf43)(this);
                // Use a getter to dynamically return different floatingFilterComponent values based on Layout.RowGroupDisplayType
                Object.defineProperty(autoGroupColumnDef, 'floatingFilterComponent', {
                    get: ()=>{
                        const rowGroupDisplayType = this.api.layoutApi.internalApi.getCurrentLayoutRowGroupDisplayType();
                        if (rowGroupDisplayType === 'single') return autoGroupFloatingFilterComponent;
                        return;
                    },
                    enumerable: true,
                    configurable: true
                });
            }
            return autoGroupColumnDef;
        });
        /**
         * `theme`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'theme', (original_theme)=>{
            this.agGridThemeAdapter.setAgGridThemeMode(original_theme === 'legacy' ? 'legacy' : 'themingApi');
            return original_theme;
        });
        /**
         *  `getRowId`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'getRowId', (original_getRowId)=>{
            if (original_getRowId) return original_getRowId;
            const primaryKey = this.adaptableOptions.primaryKey;
            if ((0, $9OAZF.default).IsNullOrEmpty(primaryKey)) // if no valid PK then do nothing
            return original_getRowId;
            if (this.hasAutogeneratedPrimaryKey) return (params)=>{
                // if the PK value is autogenerated, we need to make sure that the rowData has a valid PK value
                // this should be taken care of in the Adaptable.[loadDataSource/setDataSource/updateRows]() methods, but the users will always make silly decisions
                // so just to be safe we'll check here and add a PK value is missing
                // thus adding a side-effect in a getter, but what can we do against it?! :)
                if ((0, $f5fc3c9fe698fd70$export$37ddbc38b6af2a38).objectNotExists(params.data[primaryKey])) params.data[primaryKey] = (0, $e48e47ebfd8103c5$export$10a020066a0f444a)();
                return params.data[primaryKey];
            };
            return (params)=>{
                // might be a summary row
                if (params.data?.[0, $a22f97369f02628d$export$6220e2e98f7e58ca]) return params.data[0, $a22f97369f02628d$export$6220e2e98f7e58ca];
                if (params.level > 0) {
                    const parentKeys = params.parentKeys ?? [];
                    const values = Object.values(params.data);
                    let hash = 0;
                    for(let i = 0; i < values.length; i++){
                        const str = String(values[i] ?? '');
                        for(let j = 0; j < str.length; j++)hash = (hash << 5) - hash + str.charCodeAt(j) | 0;
                    }
                    const id = [
                        ...parentKeys,
                        Math.abs(hash)
                    ].join('/');
                    return id;
                }
                if (params.data?.[primaryKey]) {
                    const primaryKeyValue = params.data[primaryKey];
                    return typeof primaryKeyValue === 'number' ? `${primaryKeyValue}` : params.data[primaryKey];
                }
                // fallback
                const parentKeys = params.parentKeys ?? [];
                const values = Object.values(params.data);
                if (values.length) {
                    const id = [
                        ...parentKeys,
                        values[0]
                    ].join('/');
                    return id;
                }
            };
        });
        // this is necessary here for the initialisation of the LayoutManager
        /**
         * `grandTotalRow`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'grandTotalRow', (original_grandTotalRow)=>{
            const currentLayout = this.api.layoutApi.getCurrentLayout();
            if (!currentLayout) return original_grandTotalRow;
            return currentLayout.GrandTotalRow === true ? 'top' : currentLayout.GrandTotalRow === false ? undefined : currentLayout.GrandTotalRow;
        });
        // this is necessary here for the initialisation of the LayoutManager
        /**
         * `suppressAggFuncInHeader`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'suppressAggFuncInHeader', (original_suppressAggFuncInHeader)=>{
            const currentLayout = this.api.layoutApi.getCurrentLayout();
            if (!currentLayout) return original_suppressAggFuncInHeader;
            return currentLayout.SuppressAggFuncInHeader;
        });
        /**
         * `aggFuncs`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'aggFuncs', (original_aggFuncs)=>{
            const aggregationFunctions = original_aggFuncs || {};
            aggregationFunctions[0, $8b34480a73f8989d$export$2a68a8b27a7ccde7] = (params)=>{
                return (0, $9434656588b6dea7$export$fe98000b1ab912f3)(params);
            };
            aggregationFunctions[0, $8b34480a73f8989d$export$cddc429232233701] = (params)=>{
                const columnId = params.column.getColId();
                const adaptableAggFunc = this.getActiveAdaptableAggFuncForCol(columnId);
                if (!adaptableAggFunc) return undefined;
                if (adaptableAggFunc.type === 'weightedAverage') return (0, $d19eb99599b33e51$export$ac406cb80381c5f9)(params, params.colDef.colId, adaptableAggFunc.weightedColumnId);
                return undefined;
            };
            return aggregationFunctions;
        });
        /**
         * `allowContextMenuWithControlKey`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'allowContextMenuWithControlKey', (original_allowContextMenuWithControlKey)=>{
            return original_allowContextMenuWithControlKey === undefined ? true : original_allowContextMenuWithControlKey;
        });
        /**
         * `enableFilterHandlers`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'enableFilterHandlers', (original_enableFilterHandlers)=>{
            const useAdaptableFiltering = this.api.optionsApi.getFilterOptions().useAdaptableFiltering;
            if (useAdaptableFiltering) return true;
            return original_enableFilterHandlers;
        });
        /**
         * `suppressSetFilterByDefault`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'suppressSetFilterByDefault', (original_suppressSetFilterByDefault)=>{
            const useAdaptableFiltering = this.api.optionsApi.getFilterOptions().useAdaptableFiltering;
            if (useAdaptableFiltering) return true;
            return original_suppressSetFilterByDefault;
        });
        /**
         * `isExternalFilterPresent`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'isExternalFilterPresent', (original_isExternalFilterPresent)=>{
            return (params)=>{
                if (!this.isAvailable) return false;
                const isGridFilterActive = (0, $9OAZF.default).IsNotNullOrEmpty(this.api.filterApi.gridFilterApi.getCurrentGridFilterExpression());
                return isGridFilterActive || // it means that userPropertyValue will be called so we re-init that collection
                (original_isExternalFilterPresent ? original_isExternalFilterPresent(params) : false);
            };
        });
        /**
         * `doesExternalFilterPass`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'doesExternalFilterPass', (original_doesExternalFilterPass)=>{
            return (node)=>{
                if (!this.isAvailable) return true;
                if (this.isGroupRowNode(node)) {
                    if (this.api.gridApi.isTreeDataGrid()) {
                        if (node.data == undefined) // Filler Groups are not filterable
                        // see https://www.ag-grid.com/javascript-data-grid/tree-data-paths/#filler-groups
                        return false;
                    } else // for non-Tree Data Grids, we don't filter Group Rows
                    // not sure if that's 100% correct, but we did it like this in the past
                    // so we keep it like this for now until bugs are reported
                    return true;
                }
                // first assess if the Row is filterable - if not, then return true so it always appears in Grid
                const isRowFilterable = this.api.gridApi.internalApi.isRowFilterable(node);
                if (!isRowFilterable) return true;
                // next we assess a Grid Filter (if its running locally)
                const currentGridFilterExpression = this.api.filterApi.gridFilterApi.getCurrentGridFilterExpression();
                if ((0, $9OAZF.default).IsNotNullOrEmpty(currentGridFilterExpression)) {
                    const evaluateGridFilterOnClient = this.api.expressionApi.internalApi.evaluateExpressionInAdaptableQL('GridFilter', undefined, currentGridFilterExpression);
                    if (evaluateGridFilterOnClient) {
                        const isCurrentGridFilterValid = this.api.expressionApi.isValidBooleanExpression(currentGridFilterExpression, (0, $42e863194fcb493f$export$4908330cb20abb96), `Invalid Grid Filter '${currentGridFilterExpression}'`);
                        // Not sure about this - what should we do with an invalid Grid Filter?
                        // Here we essentially clear the Grid for invalid Grid Filter by returning false for each row
                        if (!isCurrentGridFilterValid) return false;
                        const gridFilterEvaluationResult = this.api.internalApi.getQueryLanguageService().evaluateBooleanExpression(currentGridFilterExpression, (0, $42e863194fcb493f$export$4908330cb20abb96), node);
                        if (!gridFilterEvaluationResult) return false;
                    }
                }
                const result = original_doesExternalFilterPass ? original_doesExternalFilterPass(node) : true;
                return result;
            };
        });
        /**
         * `getMainMenuItems`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'getMainMenuItems', (original_getMainMenuItems)=>{
            return (params)=>{
                // couldnt find a way to listen for menu close. There is a Menu Item Select, but you can also close menu from filter and clicking outside menu....
                return this.agGridMenuAdapter.buildColumnMenu(params, original_getMainMenuItems);
            };
        });
        /**
         * `getContextMenuItems`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'getContextMenuItems', (original_getContextMenuItems)=>{
            return (params)=>{
                return this.agGridMenuAdapter.buildContextMenu(params, original_getContextMenuItems);
            };
        });
        /**
         * `components`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'components', (original_components)=>{
            const AdaptableToolPanel = (0, $e2d15fd9f3e503e3$export$c30f761c1e681c54)(this);
            const components = original_components || {};
            const adaptableComponents = {
                ...components,
                AdaptableToolPanel: AdaptableToolPanel
            };
            return adaptableComponents;
        });
        variant;
        /**
         * `sidebar`
         */ if (gridOptions.sideBar != undefined) this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'sideBar', (original_sideBar)=>{
            if (!original_sideBar) // lucky us, no sideBar is defined, so we don't have to do anything
            return original_sideBar;
            const isAdaptableToolPanelHidden = this.api.entitlementApi.isModuleHiddenEntitlement('ToolPanel');
            const adaptableToolPanelDef = this.buildAdaptableToolPanelDef();
            const mapToolPanelDefs = (toolPanelDefs = [])=>{
                // if it's an alias for the adaptable tool panel, map it to a ToolPanelDef, otherwise return it as it is
                return toolPanelDefs.map((toolPanelDef)=>toolPanelDef === $58846ea7f4156db7$export$f5231957f9b36e9c ? adaptableToolPanelDef : toolPanelDef);
            };
            const isSideBarDefObject = (sidebarDef)=>{
                return Array.isArray(sidebarDef?.toolPanels);
            };
            let result;
            if (original_sideBar === true) {
                // create all tool panels with default settings
                const toolPanels = [];
                toolPanels.push($58846ea7f4156db7$export$2c23aaff732b6533);
                toolPanels.push($58846ea7f4156db7$export$2a33b96a8c752891);
                if (!isAdaptableToolPanelHidden) toolPanels.push(adaptableToolPanelDef);
                result = {
                    toolPanels: toolPanels
                };
            } else if (typeof original_sideBar === 'string') {
                if (gridOptions.sideBar === $58846ea7f4156db7$export$f5231957f9b36e9c) {
                    if (!isAdaptableToolPanelHidden) result = {
                        toolPanels: [
                            adaptableToolPanelDef
                        ]
                    };
                } else result = original_sideBar;
            } else if (Array.isArray(original_sideBar)) {
                if (!original_sideBar.includes($58846ea7f4156db7$export$f5231957f9b36e9c) || isAdaptableToolPanelHidden) result = original_sideBar;
                // if it's an array, process the tool panel definitions
                const sidebarDef = {};
                sidebarDef.toolPanels = mapToolPanelDefs(original_sideBar);
                result = sidebarDef;
            } else if (isSideBarDefObject(original_sideBar)) {
                if (original_sideBar.toolPanels?.some((toolpanelDef)=>typeof toolpanelDef !== 'string' && toolpanelDef.id === $58846ea7f4156db7$export$f5231957f9b36e9c && !isAdaptableToolPanelHidden)) // if there is an Adaptable SideBarDef, don't touch it as it may contain user-defined properties
                result = original_sideBar;
                else result = {
                    ...original_sideBar,
                    toolPanels: mapToolPanelDefs(original_sideBar.toolPanels)
                };
            }
            this.hasAdaptableToolPanel = isSideBarDefObject(result) && result.toolPanels?.some((toolPanelDef)=>typeof toolPanelDef !== 'string' && toolPanelDef.id === $58846ea7f4156db7$export$f5231957f9b36e9c);
            return result;
        });
        if (gridOptions.statusBar != undefined) {
            /**
             * `statusBar`
             */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'statusBar', (original_statusBar)=>{
                const statusPanels = (original_statusBar?.statusPanels ?? [])?.map((statusPanel)=>{
                    if (statusPanel.statusPanel === (0, $a6b60b03609a3dc0$export$eecaa732b65c0e22)) {
                        if (!statusPanel.key) {
                            this.logger.consoleWarn('AdaptableStatusPanel is missing a "key" property. This panel will not be managed by HideAdaptableUI. Please provide a unique key.');
                            return statusPanel;
                        }
                        this.adaptableStatusPanelKeys.push(statusPanel.key);
                        const context = {
                            Key: statusPanel.key
                        };
                        const adaptablePanelDef = {
                            ...statusPanel,
                            statusPanel: (0, $72e5c71dc76eda7c$export$3b5d5e20d76ac2a9)((0, $62fb192f03eeeaca$export$d289a9a7651cffc0), this, context)
                        };
                        this.adaptableStatusPanelDefs.push(adaptablePanelDef);
                        return adaptablePanelDef;
                    }
                    return statusPanel;
                });
                return {
                    ...original_statusBar,
                    statusPanels: statusPanels
                };
            });
            this.hasAdaptableStatusBar = this.adaptableStatusPanelKeys.length > 0;
        } else this.hasAdaptableStatusBar = false;
        /**
         * `getRowStyle`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'getRowStyle', (original_getRowStyle)=>{
            return (params)=>{
                const result = {
                    ...original_getRowStyle?.(params),
                    ...this.api.gridApi.internalApi.getRowHighlightStyle(params),
                    ...this.api.gridApi.internalApi.getAlertRowStyle(params)
                };
                return result;
            };
        });
        /**
         * `getRowClass`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'getRowClass', (original_getRowClass)=>{
            return (params)=>{
                const alertHighlightClassName = this.api.gridApi.internalApi.getAlertRowClass(params);
                const highlightClassName = this.api.gridApi.internalApi.getRowHighlightClass(params);
                const returnValue = [
                    typeof original_getRowClass === 'function' ? original_getRowClass(params) : original_getRowClass,
                    highlightClassName,
                    alertHighlightClassName
                ]// we flatten it because 'original_getRowClass' might return a string[]
                .flat().filter((x)=>!!x);
                return returnValue?.length ? returnValue : undefined;
            };
        });
        /**
         * `floatingFiltersHeight`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'floatingFiltersHeight', (original_floatingFiltersHeight)=>{
            if (this.api.layoutApi.isCurrentLayoutPivot()) // if Current Layout is Pivot, hide the floating filters from the beginning, otherwise we get an annoying flicker
            return 0;
            return original_floatingFiltersHeight;
        });
        /**
         * `excelStyles`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'excelStyles', (original_excelStyles)=>{
            const excelStyles = original_excelStyles || [];
            // see ##masterDetailHeader
            excelStyles.push({
                id: '_masterDetailHeader',
                interior: {
                    color: '#aaaaaa',
                    pattern: 'Solid'
                }
            }, // see #EXCEL_EXPORT_DATA_TYPES
            {
                id: 'stringExcelType',
                dataType: 'String'
            }, {
                id: 'booleanExcelType',
                dataType: 'Boolean'
            }, {
                id: 'dateExcelType',
                dataType: 'DateTime'
            }, {
                id: 'numberExcelType',
                // dataType: 'Number',
                // AG Grid requires either dataType or numberFormat to be set for Numbers
                numberFormat: {
                    format: '0.###############'
                }
            });
            // store original excel styles, we will have to revert to them after each VISUAL EXPORT
            this.agGridExportAdapter.originalExcelStyles = [
                ...excelStyles
            ];
            this.agGridExportAdapter.DANGER_excelStyles = excelStyles;
            // this array reference will be used for the entire AG Grid session
            return this.agGridExportAdapter.DANGER_excelStyles;
        });
        /**
         * `maintainColumnOrder`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'maintainColumnOrder', ()=>{
            // see https://www.ag-grid.com/javascript-data-grid/column-updating-definitions/#maintain-column-order
            // we want to always maintain the column order (provided by Adaptable Layouts), even when column definitions change
            return true;
        });
        /**
         * `columnTypes`
         */ // this will have to go/be heavily extended with https://github.com/AdaptableTools/adaptable/issues/2230
        this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'columnTypes', (original_columnTypes)=>{
            const providedColumnTypes = original_columnTypes || {};
            const adaptableSpecialColumnTypes = {
                [(0, $b0d14b794bdca4f2$export$24fbfbd19a58a666)]: (0, $b0d14b794bdca4f2$export$95c5db576df1e7e6),
                [(0, $b0d14b794bdca4f2$export$8e5ee678cfc318c5)]: {},
                [(0, $b0d14b794bdca4f2$export$2460c0dec1fc4d43)]: {},
                [(0, $b0d14b794bdca4f2$export$bc60d51b21bb9885)]: {},
                [(0, $b0d14b794bdca4f2$export$aee5eaf013923665)]: {},
                [(0, $b0d14b794bdca4f2$export$afddfaff376a8546)]: {},
                [(0, $b0d14b794bdca4f2$export$f744fcf34ea00f2c)]: {},
                [(0, $b0d14b794bdca4f2$export$9a588f369e2c5bd7)]: {},
                [(0, $b0d14b794bdca4f2$export$77dcda55adab6007)]: {}
            };
            const patchedColumnTypes = Object.assign({}, providedColumnTypes, adaptableSpecialColumnTypes);
            const customColumnTypes = this.api.columnApi.getColumnTypes() ?? [];
            for (const customColumnType of customColumnTypes)if (!patchedColumnTypes[customColumnType]) patchedColumnTypes[customColumnType] = {};
            return patchedColumnTypes;
        });
        /**
         * `dataTypeDefinitions`
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'dataTypeDefinitions', ()=>{
            const revertedDateTypeDefinitions = (0, $66ac1c1926a7c094$export$4b0da9e77110f922);
            return revertedDateTypeDefinitions;
        });
        this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'findOptions', (original_findOptions)=>{
            return {
                ...original_findOptions,
                caseSensitive: !!this.adaptableOptions.quickSearchOptions.isQuickSearchCaseSensitive
            };
        });
        /**
         * suppressOverlays
         */ this.agGridOptionsService.setGridOptionsProperty(gridOptions, 'suppressOverlays', (original_suppressOverlays)=>{
            // we want to suppress the exporting overlay because having it enabled will turn api.exportDataAsExcel() and api.exportDataAsCsv() into async operations,
            // see #export_data_synchronously
            let suppressOverlays = original_suppressOverlays || [];
            if (!suppressOverlays.includes('exporting')) suppressOverlays.push('exporting');
            return suppressOverlays;
        });
    }
    /**
     * Either initializes the AG Grid instance or delegates it to the framework wrappers (React/Anglar)
     */ async initializeAgGrid(gridOptions, modules, renderAgGridFrameworkComponent) {
        if (renderAgGridFrameworkComponent) {
            let result = false;
            try {
                result = await renderAgGridFrameworkComponent(gridOptions);
            } catch (err) {
                result = false;
            }
            if (result === false) return false;
            const agGridApi = result;
            // framework wrapper may have altered the context value via props
            // in that case, we have to re-populate it with the Adaptable context values
            const agGridContext = agGridApi.getGridOption('context');
            if (!agGridContext) return false;
            if (!agGridContext.__adaptable) {
                agGridContext.__adaptable = this;
                agGridContext.adaptableApi = this.api;
            }
            // framework wrapper may pass the rowData as a prop
            const rowData = agGridApi.getGridOption('rowData');
            this.initWithLazyData = rowData == undefined || rowData.length === 0;
            if (this.initWithLazyData) this.logger.info('Initializing with lazy data (no initial rowData).');
            if (!this.getAgGridContainerElement()) {
                // initialize the agGridContainerElement from the AgGrid instance
                const gridRoot = this.agGridAdapter.getAgGridRootElement();
                const gridContainer = gridRoot?.closest('[class*="ag-theme"]');
                if (!gridContainer) this.logger.consoleError('Failed to derive AG Grid container from the framework wrapper. Please provide a valid container element via ContainerOptions.agGridContainer.');
                this.DANGER_USE_GETTER_agGridContainerElement = gridContainer;
            }
            return agGridApi;
        }
        const agGridContainer = this.getAgGridContainerElement();
        if (!agGridContainer) {
            this.logger.consoleError('AG Grid container element not found in the DOM. Please provide a valid element via ContainerOptions.agGridContainer.');
            return Promise.resolve(false);
        }
        let gridParams;
        if (modules?.length) gridParams = {
            modules: modules
        };
        const agGridApi = (0, $437b23f6a393c3bf$export$fce123c48a7b4eae)(agGridContainer, gridOptions, gridParams);
        return agGridApi;
    }
    useRowNodeLookUp() {
        return this.agGridAdapter.getAgGridApi().getGridOption('getRowId') != undefined;
    }
    buildInitContainerContext() {
        return {
            adaptableId: this.adaptableOptions?.adaptableId ?? '',
            adaptableStateKey: this.adaptableOptions?.adaptableStateKey ?? '',
            adaptableContext: this.adaptableOptions?.adaptableContext
        };
    }
    getAgGridContainerElement() {
        if (!this.DANGER_USE_GETTER_agGridContainerElement) this.DANGER_USE_GETTER_agGridContainerElement = (0, $9AsCL.resolveContainerElement)(this.adaptableOptions?.containerOptions?.agGridContainer, this.buildInitContainerContext());
        return this.DANGER_USE_GETTER_agGridContainerElement;
    }
    getAdaptableContainerElement() {
        if (!this.DANGER_USE_GETTER_adaptableContainerElement) this.DANGER_USE_GETTER_adaptableContainerElement = (0, $9AsCL.resolveContainerElement)(this.adaptableOptions?.containerOptions?.adaptableContainer, this.buildInitContainerContext());
        return this.DANGER_USE_GETTER_adaptableContainerElement;
    }
    // This method returns selected cells ONLY (if selection mode is cells or multiple cells).
    // If the selection mode is row it will returns nothing - use the setSelectedRows() method
    refreshSelectedCellsState() {
        if (!this.isGridRangeSelectable()) return;
        const selectedCellInfo = this.agGridAdapter.deriveSelectedCellInfoFromAgGrid();
        this.api.gridApi.internalApi.setSelectedCells(selectedCellInfo);
        this._emit('CellsSelected');
        let cellSelectionChangedInfo = {
            ...this.api.internalApi.buildBaseContext(),
            selectedCellInfo: this.api.gridApi.getInternalState().SelectedCellInfo
        };
        this.api.eventApi.emit('CellSelectionChanged', cellSelectionChangedInfo);
        return selectedCellInfo;
    }
    refreshSelectedRowsState() {
        if (!this.isGridRowSelectable()) return;
        const selectedRowInfo = this.agGridAdapter.deriveSelectedRowInfoFromAgGrid();
        this.api.gridApi.internalApi.setSelectedRows(selectedRowInfo);
        const rowSelectionChangedInfo = {
            ...this.api.internalApi.buildBaseContext(),
            selectedRowInfo: this.api.gridApi.getInternalState().SelectedRowInfo
        };
        this.api.eventApi.emit('RowSelectionChanged', rowSelectionChangedInfo);
        return selectedRowInfo;
    }
    isGridRowSelectable() {
        if (!this.agGridModulesAdapter.isAgGridModuleRegistered('RowSelectionModule')) return false;
        const rowSelection = this.agGridAdapter.getAgGridApi().getGridOption('rowSelection');
        if (rowSelection == undefined) return false;
        if (rowSelection === 'single' || rowSelection === 'multiple') return true;
        if (rowSelection.mode === 'singleRow' || rowSelection.mode === 'multiRow') return true;
        return false;
    }
    isGridRangeSelectable() {
        if (!this.agGridModulesAdapter.isAgGridModuleRegistered('CellSelectionModule')) return false;
        return this.agGridAdapter.getGridOption('enableRangeSelection') || !!this.agGridAdapter.getGridOption('cellSelection');
    }
    initAdaptableStore() {
        const perfNewAdaptableStore = this.logger.beginPerf(`initAdaptableStore()`);
        const initAdaptableStoreMarker = (0, $640f77453ad4a03c$export$cd7dd5b5380f942f)(this.adaptableOptions.adaptableId).track.Init.label.InitStore.start();
        const adaptableStore = new (0, $5d2a87b18b3438b7$export$6c5ec8e858a8397e)(this);
        adaptableStore.onBeforeAny((eventName, data)=>{
            if (this.isReady) this.api.eventApi.internalApi.fireBeforeAdaptableStateChangeEvent(data.action, data.state);
            this.forPlugins((plugin)=>plugin.onBeforeStoreEvent?.(eventName, data, this.adaptableStore));
        });
        adaptableStore.onAny((eventName, data)=>{
            if (this.isReady) this.api.eventApi.internalApi.fireAdaptableStateChangedEvent(data.action, data.state, data.newState);
            this.forPlugins((plugin)=>plugin.onStoreEvent(eventName, data, this.adaptableStore));
        });
        perfNewAdaptableStore.end();
        initAdaptableStoreMarker.end();
        return adaptableStore;
    }
    mapAdaptableStateToAgGridState(adaptableState, agGridColDefs, options) {
        const currentLayoutName = adaptableState.Layout?.CurrentLayout;
        let currentLayout = currentLayoutName && adaptableState.Layout?.Layouts?.find((l)=>l.Name === currentLayoutName);
        if (!currentLayout) currentLayout = (0, $58846ea7f4156db7$export$2657cb1ad92c69eb);
        const layoutModel = (0, $702a77ed6db22640$export$3732e731bff1a886)(currentLayout);
        return {
            gridState: (0, $34e0a646a54b76b6$export$4a04ad01c410b415).getAGGridInitialStateForLayout(layoutModel, agGridColDefs, options),
            currentLayout: currentLayout,
            layoutModel: layoutModel
        };
    }
    addGridEventListeners() {
        /**
         * Intercept 3 DOM events and emit them as Adaptable events:
         * KeyDown
         * MouseEnter
         * MouseLeave
         */ const gridContainerElement = this.getAgGridContainerElement();
        if (gridContainerElement) {
            gridContainerElement.addEventListener('keydown', this.agGridListenerKeydown = (event)=>this._emit('KeyDown', event), // This is needed to be able to prevent the editor to be opened
            // in bubling phase the opening is not prevented with ag-grid v30
            true);
            gridContainerElement.addEventListener('mouseenter', this.agGridListenerMouseEnter = (event)=>{
                this._emit('MouseEnter', event);
            }, true);
            gridContainerElement.addEventListener('mouseleave', this.agGridListenerMouseLeave = (event)=>this._emit('MouseLeave', event));
        }
        this.throttleFilterOnDataChange = (0, $3a4c9a3b92c4503b$export$2e2bcd8739ae039)(// the extra function is to make sure we have a reference to ag-grid-api
        ()=>this.agGridAdapter.getAgGridApi()?.onFilterChanged(), this.adaptableOptions.filterOptions.filterActionOnDataChange.throttleDelay, {
            trailing: true,
            leading: false
        });
        /**
         * Use Case: User has started inline editing but its disabled in Row Form Options
         * Action: Stop editing
         */ this.agGridAdapter.getAgGridApi().addEventListener('cellEditingStarted', this.listenerCellEditingStarted = ()=>{
            if (this.adaptableOptions.rowFormOptions.disableInlineEditing) this.agGridAdapter.getAgGridApi().stopEditing();
        });
        /**
         * Use Case: Grid was already set up and now the initial data has been displayed
         * Action1: Update the Column Model
         * Action2: Refresh Calculated Columns
         */ this.agGridAdapter.getAgGridApi().addEventListener('firstDataRendered', this.listenerFirstDataRendered = ()=>{
            if (this.initWithLazyData) {
                this.updateColumnModelAndRefreshGrid();
                this.api.calculatedColumnApi.refreshAggregatedCalculatedColumns();
                this._emit('FirstDataRendered');
            }
            this.autoSizeLayoutIfNeeded();
        });
        /**
         * Use Case: A format column that has ColumnGroupScope needs to be re-evaluated
         * whenever a column group is expanded or collapsed
         */ this.agGridAdapter.getAgGridApi().addEventListener('columnGroupOpened', this.listenerColumnGroupOpened = ()=>{
            if (this.api.formatColumnApi.getActiveFormatColumns().some((fc)=>{
                return fc.ColumnGroupScope != null;
            })) this.updateColumnModelAndRefreshGrid();
        });
        /**
         * Use Case: A pivot column has changed
         * Action: Autosize pivot columns (if autosize pivot in Layout is true)
         */ this.agGridAdapter.getAgGridApi().addEventListener('columnPivotChanged', this.listenerPivotChanged = (params)=>{
            if (params.type == 'columnPivotChanged' && params.columnApi != null && params.columnApi.columnController != null && params.columnApi.columnController.pivotMode == true) {
                if (this.api.layoutApi.getCurrentLayout().AutoSizeColumns) this.agGridAdapter.getAgGridApi().autoSizeAllColumns();
            }
        });
        /**
         * Use Case: User has selected Rows or opened a Row Group
         * Action: Set Selected Rows (on a debounce of 500ms)
         */ this.debouncedSetSelectedRows = (0, $c34d1d35432b7498$export$2e2bcd8739ae039)(()=>{
            if (!this.isReady) return;
            this.refreshSelectedRowsState();
        }, (0, $58846ea7f4156db7$export$3b574867feb0ac0a));
        const columnEventsThatTriggerSetRowSelection = [
            'rowGroupOpened',
            'selectionChanged',
            'rowSelected'
        ];
        this.agGridAdapter.getAgGridApi().addGlobalListener(this.listenerGlobalSetRowSelection = (type)=>{
            if ((0, $9g4SS.default).ContainsItem(columnEventsThatTriggerSetRowSelection, type)) this.debouncedSetSelectedRows();
        });
        /**
         * Use Case: User has selected a range of cells
         * Action: Set Selected Cells (on a debounce of 250ms)
         */ this.debouncedSetSelectedCells = (0, $c34d1d35432b7498$export$2e2bcd8739ae039)(()=>{
            if (!this.isReady) return;
            this.refreshSelectedCellsState();
        }, (0, $58846ea7f4156db7$export$a507d980baa6b21f));
        this.agGridAdapter.getAgGridApi().addEventListener('cellSelectionChanged', this.listenerCellSelectionChanged = (params)=>{
            if (params.finished == true) this.debouncedSetSelectedCells();
        });
        /**
         * Use Case: Sort has changed in the Grid
         * Action1: Fire the Grid Sorted Event
         * Action2: Set Selected Cells (on a debounce)
         */ this.agGridAdapter.getAgGridApi().addEventListener('sortChanged', this.listenerSortChanged = ()=>{
            this.debouncedSetSelectedCells();
            this.api.eventApi.internalApi.fireGridSortedEvent();
        });
        /**
         * Use Case: Charts have been created or destroyed, Chart ranges selected or Chart options changed
         * Action: Call onChartModelChange in Charting Service
         */ const eventsThatTriggerChartingChanges = [
            'chartCreated',
            'chartRangeSelectionChanged',
            'chartOptionsChanged',
            'chartDestroyed'
        ];
        if (this.ModuleService.isAdapTableModulePresent('Charting')) {
            // We need to break the loop of charting changes for 'chartOptionsChanged', which is triggered by the subsequent agGridApi.updateChart(...)
            // see #ag_grid_update_chart_loop
            let lastChartOptionsChangePayload = '';
            this.listenerGlobalChartingChanges = (type, params)=>{
                if (eventsThatTriggerChartingChanges.includes(type)) {
                    if (type === 'chartOptionsChanged') {
                        // Exclude api and context
                        const { api: api, context: context, ...sanitizedParams } = params || {};
                        const eventPayload = JSON.stringify(sanitizedParams);
                        if (eventPayload === lastChartOptionsChangePayload) // this is a loop, so we ignore it
                        return;
                        lastChartOptionsChangePayload = eventPayload;
                    }
                    this.ChartingService.onChartModelChange(this.getChartModels(), type, params);
                }
            };
            this.agGridAdapter.getAgGridApi().addGlobalListener(this.listenerGlobalChartingChanges);
        }
        /**
         * Row and Cell listeners created in 2020
         * These have supplanted many of the events we previously had and simplified things
         */ this.rowListeners = {
            dataChanged: (event)=>{
                this.onRowDataChanged({
                    rowNode: event.node,
                    oldData: event.oldData,
                    newData: event.newData
                });
            },
            cellChanged: (event)=>{
                if (event.column) this.onCellDataChanged({
                    rowNode: event.node,
                    oldValue: event.oldValue,
                    newValue: event.newValue,
                    colId: event.column.colId
                });
            }
        };
    }
    shouldAutoSizeLayout() {
        const { layoutApi: layoutApi } = this.api;
        const currentLayout = layoutApi.getCurrentLayout();
        if (currentLayout.ColumnSizing && Object.keys(currentLayout.ColumnSizing).length > 0) return;
        return currentLayout.AutoSizeColumns;
    }
    autoSizeLayoutIfNeeded() {
        if (this.isAvailable && this.shouldAutoSizeLayout()) requestAnimationFrame(()=>{
            if (this.isAvailable) this.autoSizeAllColumns();
        });
    }
    forPlugins(callback) {
        if (Array.isArray(this.adaptableOptions.plugins)) this.adaptableOptions.plugins.forEach((plugin)=>{
            callback(plugin);
        });
    }
    getPluginProperty(pluginId, propertyName, ...args) {
        const plugins = this.adaptableOptions.plugins || [];
        const thePlugin = plugins.filter((p)=>p.pluginId === pluginId)[0];
        if (!thePlugin) throw `Cannot find plugin "${pluginId}". Make sure you spelled it right!`;
        if (thePlugin && thePlugin.hasProperty(propertyName)) return thePlugin.getProperty(propertyName)(...args);
    }
    getPlugin(pluginId) {
        const plugins = this.adaptableOptions.plugins || [];
        const thePlugin = plugins.filter((p)=>p.pluginId === pluginId)[0];
        if (!thePlugin) throw `Cannot find plugin "${pluginId}". Make sure you spelled it right!`;
        return thePlugin;
    }
    initServices() {
        // create the services
        this.LicenseService = this.initLicenseService();
        this.ChartingService = new (0, $e673deae37b98ce7$export$2e228d739b828e61)(this.api);
        this.ThemeService = new (0, $1b6bd0cf526f1c1c$export$c7501d0b7167aa9c)(this.api);
        this.ValidationService = new (0, $168c119cef991c21$export$7b25d229d5ec5033)(this.api);
        this.ModuleService = new (0, $39930c593ebd1c90$export$c98e455cccfe5cdb)(this.api);
        this.CalculatedColumnExpressionService = new (0, $c2ad72040957a875$export$121b2b63ac6c1a0c)(this.api);
        this.QueryLanguageService = new (0, $caf984f725867dd9$export$fac7c1d0dc89d92)(this.api);
        this.AlertService = new (0, $0ddb4c2559a88c07$export$6efe27c077f7cc6e)(this.api);
        this.TeamSharingService = new (0, $834607a0c4cd07c3$export$403179f218b160b0)(this.api);
        this.Fdc3Service = new (0, $434e1eb25d78d3e3$export$ef0666579ee49e99)(this.api);
        this.AnnotationsService = new (0, $7c292221d5e0caef$export$1b7119c6164d748a)(this.api);
        this.FlashingCellService = new (0, $988d8536461217b3$export$370bae6f7382e373)(this.api);
        this.RowFormService = new (0, $4a5626d4d32a5a40$export$408bbabeb32c84ca)(this.api);
        this.MetamodelService = new (0, $ec66a350fedeed6e$export$15a16ddbf1f39b24)(()=>this.api.optionsApi.getAdaptableOptions(), true);
    }
    initLicenseService() {
        const globalObject = typeof globalThis !== 'undefined' ? globalThis : window;
        const licenseKey = globalObject.ADAPTABLE_LICENSE_KEY || this.api.optionsApi.getLicenseKey();
        return new (0, $10cef49c9bd5fdd1$export$4bd85f9bf0db45)(this, licenseKey, {
            publishedAt: $2c60780b406d81af$var$publishTimestamp
        });
    }
    initModules() {
        const modules = new Map();
        modules.set($42e863194fcb493f$export$40024cb74c2bb550, new (0, $c2cfd3844e646d31$export$d4fd38c7e1150c4c)(this.api));
        modules.set($42e863194fcb493f$export$bc824d5002237871, new (0, $fca4286b812b2474$export$60e0e2d379eaac21)(this.api));
        modules.set($42e863194fcb493f$export$6619e71706e8514a, new (0, $04067d70db82621f$export$bad396be621b2e0a)(this.api));
        modules.set($42e863194fcb493f$export$bbf6ee8f129590d, new (0, $880b22dbd1564ec7$export$b1ea15659c0d3dd7)(this.api));
        modules.set($42e863194fcb493f$export$a3fc1172140ca1e4, new (0, $8e7998a46635d406$export$d320d532394aec28)(this.api));
        modules.set($42e863194fcb493f$export$edfe19743c8e0917, new (0, $9e901c51b5ca5798$export$960e24ee5487e289)(this.api));
        modules.set($42e863194fcb493f$export$59d09157d833a722, new (0, $743a31e838ad08bd$export$4cca8c3df8ca97ce)(this.api));
        modules.set($42e863194fcb493f$export$8d2ece562190bba1, new (0, $7ecee0e3afb2d5ab$export$35701fbb80ff093c)(this.api));
        modules.set($42e863194fcb493f$export$efdce168daed1549, new (0, $577549681a4e9b4b$export$f8cd338d60465d1b)(this.api));
        modules.set($42e863194fcb493f$export$b74b667f10548947, new (0, $636f4a55659b8ab7$export$50e1859f8e9b5fbb)(this.api));
        modules.set($42e863194fcb493f$export$376343cd8119f6bf, new (0, $093cc3ebd7f6bade$export$d2d584b75ea1eea3)(this.api));
        modules.set($42e863194fcb493f$export$65414e618c4e5904, new (0, $70b8aa59f5184f63$export$f073b1cfee4f38c4)(this.api));
        modules.set($42e863194fcb493f$export$b0d2488aa9d7ee1f, new (0, $d28ea97b07ebee59$export$99f71b933943be1)(this.api));
        modules.set($42e863194fcb493f$export$2bc329d2b6ae03ac, new (0, $9dc91de22c22579f$export$4e0f34fd9829977c)(this.api));
        modules.set($42e863194fcb493f$export$2cb53cfc1e4dddff, new (0, $ba7513b9a5b9695a$export$588a7a1511cdbc26)(this.api));
        modules.set($42e863194fcb493f$export$fc2170ec34a40864, new (0, $75216ec6a421da93$export$b382ba0f444e793a)(this.api));
        modules.set($42e863194fcb493f$export$7b96a9104aea727f, new (0, $52a77959e4f37a8d$export$24547111cdcfae13)(this.api));
        modules.set($42e863194fcb493f$export$7a2c7140815c0686, new (0, $a6cec02de2e9f7ff$export$6cbdea0b0178ad2d)(this.api));
        modules.set($42e863194fcb493f$export$4908330cb20abb96, new (0, $b87b6abba9b4f74d$export$5aa43b9b4ba284c3)(this.api));
        modules.set($42e863194fcb493f$export$1ec41f9c955a8b42, new (0, $8c138402ab60471f$export$aeaf6a0e556907f0)(this.api));
        modules.set($42e863194fcb493f$export$802bb096eb63f491, new (0, $f9bd6737c8d30fe2$export$8b06f1a6fe6dd818)(this.api));
        modules.set($42e863194fcb493f$export$97c45942f844607e, new (0, $72b8202d702ec972$export$67db688dcb64f441)(this.api));
        modules.set($42e863194fcb493f$export$7e30a30684cd1b52, new (0, $db47de99b5aa2d0d$export$3ebd7045d5dcea8e)(this.api));
        modules.set($42e863194fcb493f$export$1d33a3a77a9299ff, new (0, $8f237c8d7ccf415d$export$1e2df413e6695b34)(this.api));
        modules.set($42e863194fcb493f$export$cf7621e489e71e3c, new (0, $1e1484d9cd25466c$export$e91e2ed8ea7ffd8e)(this.api));
        modules.set($42e863194fcb493f$export$5dd6e67bf681ede8, new (0, $31173d676d3230c8$export$601f3c059bcd564f)(this.api));
        modules.set($42e863194fcb493f$export$79267ef32fe02008, new (0, $5f022ddeb63d19dd$export$c1cbc51db0d3b620)(this.api));
        modules.set($42e863194fcb493f$export$ef61c24f038f357f, new (0, $d300e4dbdd7eb83d$export$5494cf856edd6bfc)(this.api));
        modules.set($42e863194fcb493f$export$3fb170c57e2678e6, new (0, $908b1e4108668a4d$export$14b2e5f093b518fb)(this.api));
        modules.set($42e863194fcb493f$export$826ed58486b36acd, new (0, $3fc4d5eef037acba$export$f1d99b83d64cea7)(this.api));
        modules.set($42e863194fcb493f$export$273162015487179c, new (0, $ba77a83e85e38041$export$76a316c8c2f3bc28)(this.api));
        modules.set($42e863194fcb493f$export$7d380408a8ffe7db, new (0, $75d3e1639e04c6e4$export$a737e359cf86c265)(this.api));
        modules.set($42e863194fcb493f$export$49045387ac7420d5, new (0, $cca283709585569d$export$c6d893bb4363e4f3)(this.api));
        modules.set($42e863194fcb493f$export$ecef34e06f3704d9, new (0, $fa8ed542eb34daf4$export$2067c51f3488fae5)(this.api));
        modules.set($42e863194fcb493f$export$ebf1703e41256059, new (0, $eb83a50ae1ab468b$export$4e24a31cd466cf4e)(this.api));
        modules.set($42e863194fcb493f$export$6444167a07daa102, new (0, $5ff5075a2e720521$export$aeeb812d88921b15)(this.api));
        return modules;
    }
    /**
     * This method contains all the updates on the AdaptableState which were made AFTER Adaptbale was ready
     * This was contidioned because we required AG Grid to be ready before we could make these updates
     * We should be able to refactor the code, no that we no fore sure that Adaptable State is ready BEFORE AG Grid init
     */ temporaryAdaptableStateUpdates() {
        this.api.eventApi.on('AdaptableReady', ()=>{
            // update status bar state
            const adaptableStatusPanels = this.agGridAdapter.getAgGridApi().getGridOption('statusBar')?.statusPanels?.filter((statusPanel)=>this.adaptableStatusPanelKeys.includes(statusPanel.key)) ?? [];
            const statusBarModule = this.ModuleService.getModuleById($42e863194fcb493f$export$273162015487179c);
            // need to add only the adaptable panels
            statusBarModule.syncStateWithOptions(adaptableStatusPanels);
        });
    }
    validatePrimaryKey() {
        if (this.hasAutogeneratedPrimaryKey) return;
        const primaryKey = this.adaptableOptions.primaryKey;
        // first check if there is a primary key column
        const primaryKeyColDef = this.agGridAdapter.getAgGridApi().getColumnDef(primaryKey);
        if (!primaryKeyColDef) {
            let errorMessage;
            // if no primary key column then lets check the first row to see if its a data item
            const primaryKeyDataItem = this.getFirstRowNode()?.data[primaryKey];
            if (!primaryKeyDataItem) {
                errorMessage = `Primary key column "${this.adaptableOptions.primaryKey}" not found. This will affect many Adaptable features.`;
                if (this.adaptableOptions.alertOptions.showMissingPrimaryKeyAlert) // show an alert if that is the option
                this.api.alertApi.showAlertError('No Primary Key', errorMessage);
                else if (this.adaptableOptions.columnOptions.showMissingColumnsWarning) this.logger.consoleError(errorMessage);
            }
        }
    }
    isInPivotMode() {
        return this.agGridModulesAdapter.isAgGridModuleRegistered('PivotModule') && this.agGridAdapter.getAgGridApi().isPivotMode();
    }
    deriveAdaptableColumnStateFromAgGrid() {
        const allColumns = [];
        const gridApi = this.agGridAdapter.getAgGridApi();
        let agGridCols = this.agGridColumnAdapter.getAllAgGridColumns();
        const columnGroupChildren = gridApi.getAllDisplayedColumnGroups();
        const groupsCount = {};
        const colsToGroups = (columnGroupChildren ?? []).reduce((acc, columnGroup)=>{
            if (!columnGroup.getProvidedColumnGroup?.()?.getColGroupDef()) return acc;
            const ColumnGroupId = columnGroup.getGroupId();
            const AllowGroupSplit = !columnGroup.getProvidedColumnGroup().getColGroupDef().marryChildren;
            const FriendlyName = columnGroup.getProvidedColumnGroup().getColGroupDef().headerName ?? ColumnGroupId;
            const columnsInGroup = columnGroup.getLeafColumns();
            columnsInGroup.forEach((col)=>{
                const group = {
                    columnGroupId: ColumnGroupId,
                    friendlyName: FriendlyName,
                    allowGroupSplit: AllowGroupSplit,
                    groupCount: 0
                };
                groupsCount[group.columnGroupId] = groupsCount[group.columnGroupId] || 0;
                groupsCount[group.columnGroupId] += columnsInGroup.length;
                acc[col.getColId()] = group;
            });
            return acc;
        }, {});
        Object.keys(colsToGroups).forEach((colId)=>{
            colsToGroups[colId].groupCount = groupsCount[colsToGroups[colId].columnGroupId];
        });
        agGridCols = agGridCols.filter((agGridColumn)=>!this.agGridColumnAdapter.shouldSkipColumn(agGridColumn.getId()));
        agGridCols.forEach((agGridColumn)=>{
            allColumns.push(this.agGridAdapter.createAdaptableColumnFromAgGridColumn(agGridColumn, colsToGroups));
        });
        this.api.gridApi.internalApi.setColumns(allColumns);
    }
    checkShouldClearExistingFiltersOrSearches() {
        // if they have selected to clear Filters on startup then do it
        if (this.adaptableOptions.filterOptions.clearFiltersOnStartUp) {
            this.logger.warn('Clearing saved filters (clearFiltersOnStartUp is enabled).');
            this.api.filterApi.clearAllFilters();
        }
        // if they have selected to clear searches on startup then do it
        if (this.adaptableOptions.quickSearchOptions.clearQuickSearchOnStartUp) {
            this.logger.warn('Clearing saved Quick Search (clearQuickSearchOnStartUp is enabled).');
            this.api.quickSearchApi.clearQuickSearch();
        }
    }
    getGridCellFromRowNode(rowNode, columnId) {
        if (rowNode == null) return undefined;
        return this.createGridCell(rowNode, columnId);
    }
    isRowNodeAvailableAfterFiltering(rowNode) {
        if (rowNode.displayed) return true;
        const parentRowNode = rowNode.parent;
        if (parentRowNode == null || parentRowNode.id == 'ROOT_NODE_ID') return false;
        const foundNode = parentRowNode.childrenAfterFilter?.find((c)=>c.id == rowNode.id);
        return foundNode != null;
    }
    /**
     * Use (lazy evaluated) getters to avoid unnecessary calculations and memoization to avoid recalculating the same values
     */ createGridCell(rowNode, columnId, defaults) {
        let _column;
        let _primaryKeyValue;
        let _rawValue = defaults ? defaults.rawValue : undefined;
        let _displayValue = defaults ? defaults.displayValue : undefined;
        let _normalisedValue = defaults ? defaults.normalisedValue : undefined;
        let _isRowGroupCell;
        let _isPivotCell;
        const self = this;
        const api = this.api;
        const getIsPivotCell = ()=>{
            if (_isPivotCell === undefined) _isPivotCell = api.columnApi.isPivotResultColumn(columnId) || api.columnApi.isPivotAggColumnWithNoPivotColumns(columnId);
            return _isPivotCell;
        };
        const getRawValue = ()=>{
            if (_rawValue === undefined) {
                _rawValue = self.getRawValueFromRowNode(rowNode, columnId);
                if (_rawValue?.value != undefined && getIsPivotCell()) // for pivot result columns, the raw value is an object with a value property
                // we want to return the value property as the raw value
                _rawValue = _rawValue.value;
            }
            return _rawValue;
        };
        const getColumn = ()=>{
            if (_column === undefined) _column = api.columnApi.getColumnWithColumnId(columnId);
            return _column;
        };
        return {
            get rawValue () {
                return getRawValue();
            },
            get visible () {
                return self.isRowNodeAvailableAfterFiltering(rowNode);
            },
            get displayValue () {
                if (_displayValue === undefined) _displayValue = self.getDisplayValueFromRawValue(rowNode, columnId, getRawValue());
                return _displayValue;
            },
            get normalisedValue () {
                if (_normalisedValue === undefined) _normalisedValue = self.getNormalisedValueFromRawValue(getRawValue(), getColumn());
                return _normalisedValue;
            },
            get column () {
                return getColumn();
            },
            get primaryKeyValue () {
                if (_primaryKeyValue === undefined) _primaryKeyValue = self.getPrimaryKeyValueFromRowNode(rowNode);
                return _primaryKeyValue;
            },
            get isPivotCell () {
                return getIsPivotCell();
            },
            get isRowGroupCell () {
                if (_isRowGroupCell === undefined) _isRowGroupCell = rowNode.group;
                return _isRowGroupCell;
            },
            rowNode: rowNode
        };
    }
    getPrimaryKeyValueFromRowNode(rowNode, gridApi) {
        if (!rowNode) return null;
        const agGridApi = gridApi || this.agGridAdapter.getAgGridApi();
        let result;
        if (!this.hasAutogeneratedPrimaryKey) // support both AG Grid pre & post v31.3.x
        // TODO remove this with the next major Adaptable version
        result = this.agGridAdapter._agGridApi_getValue(this.adaptableOptions.primaryKey, rowNode, agGridApi);
        if (result == undefined && rowNode.data) result = rowNode.data[this.adaptableOptions.primaryKey];
        if (result == undefined && rowNode.id != undefined) // when getPrimaryKeyValueFromRowNode is called for group rows,
        // which don't have a rowNode.data object, the result is undefined
        // but we do have an id property on the rowNode object, so we'll use that
        result = rowNode.id;
        return result;
    }
    getRawValueFromRowNode(rowNode, columnId) {
        if (rowNode == null) return undefined;
        return this.agGridAdapter._agGridApi_getValue(columnId, rowNode);
    }
    getDisplayValueFromRowNode(rowNode, columnId) {
        if (rowNode == null) return undefined;
        const rawValue = this.getRawValueFromRowNode(rowNode, columnId);
        return this.getDisplayValueFromRawValue(rowNode, columnId, rawValue);
    }
    getDisplayValueFromRawValue(rowNode, columnId, rawValue) {
        const isActionColumn = this.api.columnApi.isActionColumn(columnId);
        if (isActionColumn) return this.getCleanValue(rawValue);
        const colDef = this.agGridAdapter.getAgGridApi().getColumnDef(columnId);
        if (colDef) {
            if (typeof colDef.valueFormatter == 'function') {
                const column = this.agGridAdapter.getAgGridApi().getColumn(columnId);
                const params = {
                    value: rawValue,
                    node: rowNode,
                    data: rowNode.data,
                    colDef: colDef,
                    column: column,
                    api: this.agGridAdapter.getAgGridApi(),
                    context: this.agGridAdapter.getGridOption('context')
                };
                const formattedValue = colDef.valueFormatter(params);
                return formattedValue || '';
            }
        } else if (this.api.columnApi.isPivotResultColumn(columnId)) {
            const pivotResultColumn = this.agGridAdapter.getAgGridApi().getPivotResultColumns().find((col)=>col.getColId() === columnId);
            const pivotResultColDef = pivotResultColumn?.getColDef();
            if (pivotResultColDef && typeof pivotResultColDef.valueFormatter === 'function') {
                const params = {
                    value: rawValue,
                    node: rowNode,
                    data: rowNode.data,
                    colDef: pivotResultColDef,
                    column: pivotResultColumn,
                    api: this.agGridAdapter.getAgGridApi(),
                    context: this.agGridAdapter.getGridOption('context')
                };
                const formattedValue = pivotResultColDef.valueFormatter(params);
                return formattedValue || '';
            }
        }
        return this.getCleanValue(rawValue);
    }
    getCleanValue(value) {
        if (typeof value === 'string') return value;
        if (value == null || value == 'null' || value == undefined || value == 'undefined') return undefined;
        return String(value) || '';
    }
    getNormalisedValueFromRawValue(rawValue, column) {
        if (!column) return rawValue;
        // prevents from null
        if (rawValue === undefined || rawValue === null) return rawValue;
        const dataType = column.dataType;
        if (dataType === 'text') return typeof rawValue !== 'string' ? String(rawValue) : rawValue;
        if (dataType === 'number') {
            if (typeof rawValue === 'number') return rawValue;
            // empty string or space should not be converted to 0
            if (typeof rawValue === 'string') return (0, $9OAZF.default).IsNumeric(rawValue) ? Number(rawValue) : rawValue;
            // handle objects with toString() (e.g. from valueGetters)
            const numValue = Number(rawValue);
            return isNaN(numValue) ? rawValue : numValue;
        }
        if (dataType === 'boolean') return typeof rawValue !== 'boolean' ? Boolean(rawValue) : rawValue;
        if (dataType === 'date') return rawValue instanceof Date ? rawValue : (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(rawValue);
        return rawValue;
    }
    __updateColumnModelAndRefreshGrid_already_called = false;
    updateColumnModelAndRefreshGrid() {
        if (this.__updateColumnModelAndRefreshGrid_already_called) return;
        try {
            this._updateColumnModelAndRefreshGridNow();
            this.__updateColumnModelAndRefreshGrid_already_called = true;
        } finally{
            queueMicrotask(()=>{
                this.__updateColumnModelAndRefreshGrid_already_called = false;
            });
        }
    }
    _updateColumnModelAndRefreshGridNow() {
        this.logger.info('Updating column model and refreshing grid.');
        this.deriveAdaptableColumnStateFromAgGrid();
        this.agGridColumnAdapter.setupColumns();
        this.redrawBody();
        this.refreshHeader();
    }
    redrawBody() {
        this.redrawRows();
        this._emit('GridRefreshed');
    }
    refreshHeader() {
        this.agGridAdapter.getAgGridApi().refreshHeader();
    }
    // TODO AFL: this method seems to be used A LOT
    // we should check if we couldn't use the `refresh` method instead for some cases
    // see https://www.ag-grid.com/react-data-grid/view-refresh/#redraw-rows
    redrawRows(rowNodes) {
        const redrawRowsParams = rowNodes ? {
            rowNodes: rowNodes
        } : undefined;
        try {
            this.agGridAdapter.getAgGridApi().redrawRows(redrawRowsParams);
        } catch (ex) {
            this.logger.consoleError('AG Grid redrawRows failed to locate some row nodes.', rowNodes, ex);
        }
    }
    refreshGridHeader() {
        this.agGridAdapter.getAgGridApi().refreshHeader();
    }
    redrawRow(rowNode) {
        this.redrawRows([
            rowNode
        ]);
    }
    refreshCell(rowNode, column, forceUpdate, suppressFlash = false) {
        this.refreshCells(rowNode, [
            column
        ], forceUpdate, suppressFlash);
    }
    refreshCells(rowNode, columns, forceUpdate, suppressFlash = false) {
        const refreshCellParams = {
            rowNodes: [
                rowNode
            ],
            columns: columns,
            force: forceUpdate,
            suppressFlash: suppressFlash
        };
        this.agGridAdapter.getAgGridApi().refreshCells(refreshCellParams);
    }
    refreshAllCells(forceUpdate) {
        this.agGridAdapter.getAgGridApi().refreshCells({
            force: forceUpdate
        });
    }
    refreshColumns(columns, forceUpdate, suppressFlash) {
        const refreshCellParams = {
            rowNodes: null,
            columns: columns,
            force: forceUpdate,
            suppressFlash: suppressFlash
        };
        this.agGridAdapter.getAgGridApi().refreshCells(refreshCellParams);
    }
    jumpToRow(rowNode) {
        this.agGridAdapter.getAgGridApi().ensureNodeVisible(rowNode, 'middle');
    }
    jumpToColumn(columnId) {
        this.agGridAdapter.getAgGridApi().ensureColumnVisible(columnId);
    }
    jumpToCell(columnId, rowNode) {
        this.jumpToRow(rowNode);
        this.jumpToColumn(columnId);
    }
    selectColumn(columnId, config) {
        if (!config?.keepExistingSelection) this.agGridAdapter.getAgGridApi().clearCellSelection();
        const cellRangeParams = {
            rowStartIndex: 0,
            rowEndIndex: this.agGridAdapter.getAgGridApi().getDisplayedRowCount() - 1,
            columnStart: columnId,
            columnEnd: columnId
        };
        this.agGridAdapter.getAgGridApi().addCellRange(cellRangeParams);
    }
    selectColumns(columnIds, config) {
        if (!config?.keepExistingSelection) this.agGridAdapter.getAgGridApi().clearCellSelection();
        const rowCount = this.agGridAdapter.getAgGridApi().getDisplayedRowCount();
        columnIds.forEach((colId)=>{
            const cellRangeParams = {
                rowStartIndex: 0,
                rowEndIndex: rowCount - 1,
                columnStart: colId,
                columnEnd: colId
            };
            this.agGridAdapter.getAgGridApi().addCellRange(cellRangeParams);
        });
    }
    selectAll() {
        this.agGridAdapter.getAgGridApi().selectAll();
    }
    deselectAll() {
        // need to do both as first just clears selected rows and second clears ranges
        this.agGridAdapter.getAgGridApi().deselectAll();
        this.agGridAdapter.getAgGridApi().clearCellSelection();
    }
    setGridData(dataSource) {
        if (!this.isReady) return;
        if (this.hasAutogeneratedPrimaryKey) this.addSyntheticPrimaryKey(dataSource);
        this.agGridAdapter.setGridOption('rowData', dataSource);
        this.updateRowGroupsAndColumnGroupsExpandedState();
    // this.updateColumnModelAndRefreshGrid();
    }
    getGridData() {
        const data = [];
        this.agGridAdapter.getAgGridApi().forEachNode((rowNode)=>{
            if (!this.isGroupRowNode(rowNode)) data.push(rowNode.data);
        });
        return data;
    }
    addSyntheticPrimaryKey(rowData = []) {
        for(let i = 0; i < rowData.length; i++)rowData[i][0, $58846ea7f4156db7$export$a1806c9475ecdc0] = (0, $e48e47ebfd8103c5$export$10a020066a0f444a)();
    }
    // add a synthetic PK only if missing (useful in case of updating row data)
    addSyntheticPrimaryKeyIfMissing(rowData = []) {
        this.adaptableOptions.primaryKey = (0, $58846ea7f4156db7$export$a1806c9475ecdc0);
        for(let i = 0; i < rowData.length; i++)if (!rowData[i][0, $58846ea7f4156db7$export$a1806c9475ecdc0]) rowData[i][0, $58846ea7f4156db7$export$a1806c9475ecdc0] = (0, $e48e47ebfd8103c5$export$10a020066a0f444a)();
    }
    getFirstDisplayedRowNode() {
        const firstDisplayedRowIndex = this.agGridAdapter.getAgGridApi().getFirstDisplayedRowIndex();
        return this.agGridAdapter.getAgGridApi().getDisplayedRowAtIndex(firstDisplayedRowIndex);
    }
    getFirstRowNode() {
        let firstRowNode = this.getFirstDisplayedRowNode();
        if (firstRowNode?.group) // all groups may be closed so it is safer to get first leaf node
        // all groups should have at least one leafe node (though not necessarily if using SSRM)
        {
            if ((0, $9g4SS.default).IsNotNullOrEmpty(firstRowNode.allLeafChildren)) firstRowNode = firstRowNode.allLeafChildren[0];
        }
        return firstRowNode;
    }
    updateRowGroupsAndColumnGroupsExpandedState(layout) {
        if (!layout) layout = this.api.layoutApi.getCurrentLayout();
        const layoutModel = (0, $702a77ed6db22640$export$3732e731bff1a886)(layout);
        this.layoutManager.applyRowGroupValues(layoutModel.RowGroupValues, layoutModel.RowGroupedColumns);
        this.layoutManager.applyColumnGroupCollapseExpandState(layoutModel);
    }
    isGroupRowNode(rowNode) {
        if (!rowNode) return false;
        if (rowNode.group === true || rowNode.leafGroup === true) return true;
        return false;
    }
    isGrandTotalRowNode(rowNode) {
        if (!rowNode) return false;
        return rowNode.id === (0, $58846ea7f4156db7$export$e090b1dbb8c13c1b);
    }
    getFilteredData() {
        const data = [];
        this.agGridAdapter.getAgGridApi().forEachNodeAfterFilter((rowNode)=>{
            if (!this.isGroupRowNode(rowNode)) data.push(rowNode.data);
        });
        return data;
    }
    /**
     * This method internally differentiates between server-side and client-side row model
     * and correctly calls the appropriate method as per the current row model type
     */ applyAgGridTransaction(transaction) {
        const isServerSideRowModel = this.getAgGridRowModelType() === 'serverSide';
        const agGridApi = this.agGridAdapter.getAgGridApi();
        return isServerSideRowModel ? agGridApi.applyServerSideTransaction(transaction) : agGridApi.applyTransaction(transaction);
    }
    /**
     * This method internally differentiates between server-side and client-side row model
     * and correctly calls the appropriate method as per the current row model type
     */ applyAgGridTransactionAsync(transaction, callback) {
        const isServerSideRowModel = this.getAgGridRowModelType() === 'serverSide';
        const agGridApi = this.agGridAdapter.getAgGridApi();
        return isServerSideRowModel ? agGridApi.applyServerSideTransactionAsync(transaction, callback) : agGridApi.applyTransactionAsync(transaction, callback);
    }
    updateRows(dataRows, dataUpdateConfig) {
        if (this.hasAutogeneratedPrimaryKey) this.addSyntheticPrimaryKeyIfMissing(dataRows);
        dataUpdateConfig = dataUpdateConfig || {};
        if (dataUpdateConfig.runAsync) return new Promise((resolve)=>{
            this.applyAgGridTransactionAsync({
                update: dataRows
            }, (transaction)=>{
                if (typeof dataUpdateConfig.callback === 'function') dataUpdateConfig.callback(transaction);
                resolve(transaction?.update);
            });
            if (dataUpdateConfig.flushAsync) this.agGridAdapter.getAgGridApi().flushAsyncTransactions();
        });
        else {
            const transaction = this.applyAgGridTransaction({
                update: dataRows
            });
            if (dataUpdateConfig.flushAsync) this.agGridAdapter.getAgGridApi().flushAsyncTransactions();
            return Promise.resolve(transaction?.update);
        }
    }
    addRows(dataRows, dataUpdateConfig) {
        if (this.hasAutogeneratedPrimaryKey) this.addSyntheticPrimaryKey(dataRows);
        dataUpdateConfig = dataUpdateConfig || {};
        const newData = {
            add: dataRows
        };
        if (dataUpdateConfig.addIndex !== undefined) newData.addIndex = dataUpdateConfig.addIndex;
        if (dataUpdateConfig.runAsync) return new Promise((resolve)=>{
            this.applyAgGridTransactionAsync(newData, (transaction)=>{
                if (typeof dataUpdateConfig.callback === 'function') dataUpdateConfig.callback(transaction);
                resolve(transaction?.add);
                this.updateRowGroupsAndColumnGroupsExpandedState();
            });
            if (dataUpdateConfig.flushAsync) this.agGridAdapter.getAgGridApi().flushAsyncTransactions();
        });
        else {
            const transaction = this.applyAgGridTransaction(newData);
            if (dataUpdateConfig.flushAsync) this.agGridAdapter.getAgGridApi().flushAsyncTransactions();
            this.updateRowGroupsAndColumnGroupsExpandedState();
            return Promise.resolve(transaction?.add);
        }
    }
    addOrUpdateRows(dataRows, dataUpdateConfig) {
        const addDataRows = [];
        const updateDataRows = [];
        const primaryKey = this.adaptableOptions.primaryKey;
        dataRows.forEach((dataRow)=>{
            const node = this.getRowNodeForPrimaryKey(dataRow[primaryKey]);
            if (node) updateDataRows.push(dataRow);
            else addDataRows.push(dataRow);
        });
        if (this.hasAutogeneratedPrimaryKey) this.addSyntheticPrimaryKeyIfMissing(addDataRows);
        dataUpdateConfig = dataUpdateConfig || {};
        if (dataUpdateConfig.runAsync) return new Promise((resolve)=>{
            this.applyAgGridTransactionAsync({
                update: updateDataRows,
                add: addDataRows,
                addIndex: dataUpdateConfig.addIndex
            }, (transaction)=>{
                if (typeof dataUpdateConfig.callback === 'function') dataUpdateConfig.callback(transaction);
                if (transaction?.add) this.updateRowGroupsAndColumnGroupsExpandedState();
                resolve({
                    added: transaction?.add,
                    updated: transaction?.update
                });
            });
            if (dataUpdateConfig.flushAsync) this.agGridAdapter.getAgGridApi().flushAsyncTransactions();
        });
        else {
            const transaction = this.applyAgGridTransaction({
                update: updateDataRows,
                add: addDataRows,
                addIndex: dataUpdateConfig.addIndex
            });
            if (transaction?.add) this.updateRowGroupsAndColumnGroupsExpandedState();
            if (dataUpdateConfig.flushAsync) this.agGridAdapter.getAgGridApi().flushAsyncTransactions();
            return Promise.resolve({
                added: transaction?.add,
                updated: transaction?.update
            });
        }
    }
    async manageGridRows(dataRowConfig, dataUpdateConfig = {}) {
        const result = {
            addedRows: [],
            updatedRows: [],
            removedRows: []
        };
        if (!dataRowConfig) return result;
        if (!dataRowConfig.addRows || !dataRowConfig.updateRows || !dataRowConfig.deleteRows) return result;
        const addDataRows = dataRowConfig.addRows;
        const updateDataRows = dataRowConfig.updateRows;
        const removeDataRows = dataRowConfig.deleteRows;
        if (this.hasAutogeneratedPrimaryKey) this.addSyntheticPrimaryKeyIfMissing(addDataRows);
        if (dataUpdateConfig.runAsync) return new Promise((resolve)=>{
            this.applyAgGridTransactionAsync({
                update: updateDataRows,
                add: addDataRows,
                remove: removeDataRows,
                addIndex: dataUpdateConfig.addIndex
            }, (transaction)=>{
                if (typeof dataUpdateConfig.callback === 'function') dataUpdateConfig.callback(transaction);
                if (transaction?.add) this.updateRowGroupsAndColumnGroupsExpandedState();
                resolve({
                    addedRows: transaction?.add,
                    updatedRows: transaction?.update,
                    removedRows: transaction?.remove
                });
            });
            if (dataUpdateConfig.flushAsync) this.agGridAdapter.getAgGridApi().flushAsyncTransactions();
        });
        else {
            const transaction = this.applyAgGridTransaction({
                update: updateDataRows,
                add: addDataRows,
                remove: removeDataRows,
                addIndex: dataUpdateConfig.addIndex
            });
            if (transaction?.add) this.updateRowGroupsAndColumnGroupsExpandedState();
            if (dataUpdateConfig.flushAsync) this.agGridAdapter.getAgGridApi().flushAsyncTransactions();
            return Promise.resolve({
                addedRows: transaction?.add,
                updatedRows: transaction?.update,
                removedRows: transaction?.remove
            });
        }
    }
    deleteRows(dataRows, dataUpdateConfig) {
        dataUpdateConfig = dataUpdateConfig || {};
        if (dataUpdateConfig.runAsync) return new Promise((resolve)=>{
            this.applyAgGridTransactionAsync({
                remove: dataRows
            }, (transaction)=>{
                if (typeof dataUpdateConfig.callback === 'function') dataUpdateConfig.callback(transaction);
                resolve(transaction?.remove);
            });
            if (dataUpdateConfig.flushAsync) this.agGridAdapter.getAgGridApi().flushAsyncTransactions();
        });
        else {
            const transaction = this.applyAgGridTransaction({
                remove: dataRows
            });
            if (dataUpdateConfig.flushAsync) this.agGridAdapter.getAgGridApi().flushAsyncTransactions();
            return Promise.resolve(transaction.remove);
        }
    }
    getRowNodeForPrimaryKey(primaryKeyValue) {
        if (this.useRowNodeLookUp) return this.agGridAdapter.getAgGridApi().getRowNode(primaryKeyValue);
        else this.agGridAdapter.getAgGridApi().forEachNode((rowNode)=>{
            if (primaryKeyValue == this.getPrimaryKeyValueFromRowNode(rowNode)) return rowNode;
        });
    }
    hideColumn(columnId) {
        let agGridColumn = this.agGridAdapter.getAgGridApi().getColumn(columnId);
        if (agGridColumn) {
            this.agGridAdapter.getAgGridApi().setColumnsVisible([
                columnId
            ], false);
            this.deriveAdaptableColumnStateFromAgGrid();
        }
    }
    showColumn(columnId) {
        let agGridColumn = this.agGridAdapter.getAgGridApi().getColumn(columnId);
        if (agGridColumn) {
            this.agGridAdapter.getAgGridApi().setColumnsVisible([
                columnId
            ], true);
            this.deriveAdaptableColumnStateFromAgGrid();
        }
    }
    autoSizeColumn(columnId) {
        this.autoSizeColumns([
            columnId
        ]);
    }
    autoSizeColumns(columnIds) {
        if (!this.agGridModulesAdapter.isAgGridModuleRegistered('ColumnAutoSizeModule')) {
            this.logger.consoleError(`Auto-sizing columns [${columnIds}] requires the AG Grid "ColumnAutoSizeModule". Please register this module.`);
            return;
        }
        this.layoutManager.autoSizeColumns(columnIds);
    }
    autoSizeAllColumns() {
        if (!this.agGridModulesAdapter.isAgGridModuleRegistered('ColumnAutoSizeModule')) {
            this.logger.consoleError('Auto-sizing all columns requires the AG Grid "ColumnAutoSizeModule". Please register this module.');
            return;
        }
        const agGridApi = this.agGridAdapter.getAgGridApi();
        if (agGridApi) agGridApi.autoSizeAllColumns();
    }
    async getDistinctValuesForColumn(column) {
        return this.getDistinctGridCellsForColumn(column);
    }
    async getDistinctFilterValuesForColumn(options) {
        const { column: column, previousResult: previousResult } = options;
        const self = this;
        // First get the Grid Cells in the Column
        let currentGridCells;
        const getCurrentGridCells = ()=>{
            // we do this in a function so it's lazy
            // but we also store in the outside closure, so we can reuse the value if
            // already called
            if (currentGridCells) return currentGridCells;
            return currentGridCells = column.columnId === (0, $58846ea7f4156db7$export$1fadf36dae8ed962) ? this.getDistinctGridCellsForGroupedColumn() : column.dataType === 'date' ? this.getDistinctGridCellsForDateColumn(column) : this.getDistinctGridCellsForColumn(column);
        };
        // No distinct values so lets return unique grid cells
        const mapFn = (gridCell, level)=>{
            if (level || Array.isArray(gridCell.children)) {
                const cell = gridCell;
                const inFilterValue = {
                    value: gridCell.rawValue,
                    label: gridCell.displayValue,
                    level: level ?? 0,
                    tooltip: false,
                    get visible () {
                        return gridCell.visible;
                    },
                    count: gridCell.count ?? 0,
                    leafChildrenCount: cell.leafChildrenCount ?? 0,
                    get visibleCount () {
                        return gridCell.visibleCount ?? 0;
                    },
                    isSelected: gridCell.rowNode.displayed,
                    children: cell.children ? cell.children.map((v)=>mapFn(v, level ? level + 1 : 1)) : undefined
                };
                return inFilterValue;
            }
            return {
                value: gridCell.rawValue,
                label: gridCell.displayValue
            };
        };
        // If there are custom distinct value, return them; otherwise return the Grids Cells just retrieved
        const customInFilterValues = this.adaptableOptions.filterOptions.customInFilterValues;
        if (customInFilterValues) {
            const gridApiInternal = this.api.gridApi.internalApi;
            const customInFilterValuesContext = {
                ...this.api.internalApi.buildBaseContext(),
                column: column,
                previousFilterResult: previousResult,
                get currentSearchValue () {
                    return options.currentSearchValue;
                },
                get sortedValues () {
                    const result = gridApiInternal.sortDistinctValues(getCurrentGridCells(), column).map((gridCell)=>{
                        return {
                            label: gridCell.displayValue,
                            value: gridCell.rawValue,
                            isSelected: gridCell.rowNode.displayed,
                            count: gridCell.count ?? 0,
                            tooltip: false,
                            level: 0,
                            leafChildrenCount: gridCell.leafChildrenCount ?? 0,
                            get children () {
                                if (!gridCell.children) return undefined;
                                return gridCell.children.map((gridCell)=>mapFn(gridCell, 1));
                            },
                            get visible () {
                                return gridCell.visible;
                            },
                            get visibleCount () {
                                return gridCell.visibleCount ?? 0;
                            }
                        };
                    });
                    return result;
                },
                get defaultValues () {
                    const result = getCurrentGridCells().map((gridCell)=>{
                        return {
                            label: gridCell.displayValue,
                            value: gridCell.rawValue,
                            isSelected: gridCell.rowNode.displayed,
                            count: gridCell.count ?? 0,
                            tooltip: false,
                            level: 0,
                            leafChildrenCount: gridCell.leafChildrenCount ?? 0,
                            get children () {
                                if (!gridCell.children) return undefined;
                                return gridCell.children.map((gridCell)=>mapFn(gridCell, 1));
                            },
                            get visible () {
                                return gridCell.visible;
                            },
                            get visibleCount () {
                                return gridCell.visibleCount ?? 0;
                            }
                        };
                    });
                    return result;
                },
                get orderedValues () {
                    const rowNodes = gridApiInternal.getSortedRowNodesWithCurrentLayoutSortOrder();
                    const currentGridCells = self.getDistinctGridCellsForColumn(column, rowNodes);
                    const result = currentGridCells.map((gridCell)=>{
                        return {
                            label: gridCell.displayValue,
                            value: gridCell.rawValue,
                            isSelected: gridCell.rowNode.displayed,
                            count: gridCell.count,
                            tooltip: false,
                            level: 0,
                            get children () {
                                if (!gridCell.children) return undefined;
                                return gridCell.children.map((gridCell)=>mapFn(gridCell, 1));
                            },
                            leafChildrenCount: gridCell.leafChildrenCount ?? 0,
                            get visible () {
                                return gridCell.visible;
                            },
                            get visibleCount () {
                                return gridCell.visibleCount;
                            }
                        };
                    });
                    return result;
                }
            };
            let customInFilterValuesResult;
            try {
                customInFilterValuesResult = await customInFilterValues(customInFilterValuesContext);
            } catch (error) {
                this.logger.consoleError('Failed to retrieve custom filter values.', column, error);
            }
            return customInFilterValuesResult;
        }
        const values = getCurrentGridCells().map((gridCell)=>mapFn(gridCell));
        return {
            values: values
        };
    }
    async getDistinctEditValuesForColumn(options) {
        const { column: column, gridCell: gridCell } = options;
        // First get the Grid Cells in the Column
        const currentGridCells = this.getDistinctGridCellsForColumn(column);
        // If there are custom distinct value, return them, but only if a module has been specifically set
        const customEditColumnValues = this.adaptableOptions.editOptions.customEditColumnValues;
        if (customEditColumnValues) {
            const customEditValuesContext = {
                ...this.api.internalApi.buildBaseContext(),
                column: column,
                gridCell: gridCell,
                get currentSearchValue () {
                    return options.currentSearchValue;
                },
                get defaultValues () {
                    const result = currentGridCells.map((gridCell)=>{
                        return {
                            label: gridCell.displayValue,
                            value: gridCell.rawValue,
                            get visible () {
                                return gridCell.visible;
                            }
                        };
                    });
                    return result;
                }
            };
            if (customEditColumnValues) {
                let customDistinctValues;
                try {
                    customDistinctValues = await customEditColumnValues(customEditValuesContext);
                } catch (error) {
                    this.logger.consoleError('Failed to retrieve custom edit values.', column, error);
                }
                return customDistinctValues ?? [];
            }
        }
        // No distinct values so lets return unique grid cells
        return currentGridCells.map((gridCell)=>{
            const result = {
                value: gridCell.rawValue,
                label: gridCell.displayValue
            };
            return result;
        });
    }
    getDistinctGridCellsForGroupedColumn(rowNodes) {
        const groupedColumns = this.api.columnApi.getRowGroupedColumns();
        const treeMode = this.api.gridApi.isTreeDataGrid();
        // if we're not in tree mode, return if there are no grouped columns
        // but in tree mode, we have to continue, even if there are no grouped columns
        if (!groupedColumns.length && !treeMode) return [];
        let prevLevel = -1;
        const currentGroupKey = [];
        const currentParentGridCells = [];
        const topLevelGridCells = [];
        const includeLeafNodes = treeMode || !!this.agGridAdapter.getAgGridApi().getColumnDef((0, $58846ea7f4156db7$export$1fadf36dae8ed962))?.field;
        const rowNodeCallback = (rowNode)=>{
            if (!rowNode.group && !includeLeafNodes) return;
            const level = rowNode.level;
            const key = rowNode.key;
            if (level <= prevLevel) {
                currentGroupKey.length = level;
                currentParentGridCells.length = level;
            }
            prevLevel = level;
            // for non-tree mode
            // or for tree mode, if the rowNode has data - so it's not a filler group
            if (!treeMode || treeMode && rowNode.data) currentGroupKey.push(key);
            const parentGridCell = currentParentGridCells[currentParentGridCells.length - 1];
            const gridCell = this.addDistinctColumnValue(rowNode, (0, $58846ea7f4156db7$export$1fadf36dae8ed962), false);
            // for tree-mode filler nodes, we might end up without a gridCell
            // so we need to make sure it's defined
            if (gridCell) {
                gridCell.leafChildrenCount = rowNode.allLeafChildren?.length ?? 0;
                currentParentGridCells.push(gridCell);
                if (parentGridCell) {
                    parentGridCell.children = parentGridCell.children || [];
                    parentGridCell.children.push(gridCell);
                }
                if (level === 0 && gridCell) topLevelGridCells.push(gridCell);
            }
        };
        if (rowNodes) rowNodes.forEach(rowNodeCallback);
        else this.agGridAdapter.getAgGridApi().forEachNode(rowNodeCallback);
        const column = this.api.columnApi.getColumnWithColumnId((0, $58846ea7f4156db7$export$1fadf36dae8ed962));
        return this.getUniqueGridCells(column, topLevelGridCells);
    }
    getDistinctGridCellsForDateColumn(column, rowNodes) {
        const topLevelGridCells = [];
        const treeDeepMap = new (0, $88ab1a78ec8ca4b4$export$1c737028a0cb2e00)();
        const isPivotResultColumn = column.isGeneratedPivotResultColumn;
        const includeTime = this.api.predicateApi.internalApi.shouldEvaluateInPredicateUsingTime(column.columnId);
        const colId = column.columnId;
        const rowNodeCallback = (rowNode)=>{
            if (!rowNode) return;
            const initialCell = this.addDistinctColumnValue(rowNode, column.columnId, isPivotResultColumn);
            if (initialCell) {
                const value = initialCell.rawValue;
                // we want to filter out empty values
                if (value === '' || value === null || value === undefined) return;
                const dateInstance = (0, $eccba2ee7b674d85$export$220ff045e4b830ec)(value);
                if (!(dateInstance instanceof Date)) return;
                const year = dateInstance.getFullYear();
                const month = dateInstance.getMonth() + 1;
                const day = dateInstance.getDate();
                const yearRawValue = `${year}`;
                const monthRawValue = `${year}-${`${month}`.padStart(2, '0')}`;
                const dayRawValue = `${monthRawValue}-${`${day}`.padStart(2, '0')}`;
                const yearCells = treeDeepMap.get([
                    year
                ]) || [];
                const yearCell = this.createGridCell(rowNode, colId, {
                    rawValue: yearRawValue,
                    displayValue: yearRawValue,
                    normalisedValue: yearRawValue
                });
                yearCells.push(yearCell);
                treeDeepMap.set([
                    year
                ], yearCells);
                const monthCells = treeDeepMap.get([
                    year,
                    month
                ]) || [];
                const monthCell = this.createGridCell(rowNode, colId, {
                    rawValue: monthRawValue,
                    displayValue: (0, $1fe81e1078ace264$export$ad991b66133851cf)(`${monthRawValue}-01`, {
                        Pattern: 'LLLL'
                    }),
                    normalisedValue: monthRawValue
                });
                monthCells.push(monthCell);
                treeDeepMap.set([
                    year,
                    month
                ], monthCells);
                const dayCells = treeDeepMap.get([
                    year,
                    month,
                    day
                ]) || [];
                const dayCell = this.createGridCell(rowNode, colId, {
                    rawValue: dayRawValue,
                    displayValue: `${day}`.padStart(2, '0'),
                    normalisedValue: dayRawValue
                });
                dayCells.push(dayCell);
                treeDeepMap.set([
                    year,
                    month,
                    day
                ], dayCells);
                if (includeTime) {
                    const timeCells = treeDeepMap.get([
                        year,
                        month,
                        day,
                        dateInstance.getTime()
                    ]) || [];
                    // if the value is a string, let's use it as the final raw value
                    const timeRawValue = typeof value === 'string' ? value : `${dateInstance.toISOString()}`;
                    let timeDisplayValue = typeof value === 'string' ? value : [
                        dateInstance.getHours(),
                        dateInstance.getMinutes(),
                        dateInstance.getSeconds()
                    ].map((v)=>`${v}`.padStart(2, '0')).join(':').concat(dateInstance.getMilliseconds() ? `.${dateInstance.getMilliseconds().toString().padStart(3, '0')}` : '');
                    const timeCell = this.createGridCell(rowNode, colId, {
                        rawValue: timeRawValue,
                        displayValue: timeDisplayValue,
                        normalisedValue: timeRawValue
                    });
                    timeCells.push(timeCell);
                    treeDeepMap.set([
                        year,
                        month,
                        day,
                        dateInstance.getTime()
                    ], timeCells);
                }
            }
        };
        if (rowNodes) rowNodes.forEach(rowNodeCallback);
        else this.agGridAdapter.getAgGridApi().forEachNode(rowNodeCallback);
        const years = treeDeepMap.getKeysStartingWith([], {
            excludeSelf: true,
            depthLimit: 1
        });
        for (const keys of years){
            const [year] = keys;
            const yearCells = treeDeepMap.get([
                year
            ]) || [];
            // should only be one item in the uniqueYearCells array
            const uniqueYearCell = this.getUniqueGridCells(column, yearCells)[0];
            if (!uniqueYearCell) continue;
            uniqueYearCell.children = [];
            topLevelGridCells.push(uniqueYearCell);
            const keysForYear = treeDeepMap.getKeysStartingWith([
                year
            ], {
                depthLimit: 1,
                excludeSelf: true
            });
            for (const keys of keysForYear){
                const [_, month] = keys;
                const monthCells = treeDeepMap.get([
                    year,
                    month
                ]) || [];
                const uniqueMonthCell = this.getUniqueGridCells(column, monthCells)[0];
                if (!uniqueMonthCell) continue;
                uniqueMonthCell.children = [];
                uniqueYearCell.children.push(uniqueMonthCell);
                // those are all the days for which there are values in this year/month
                const keysForMonth = treeDeepMap.getKeysStartingWith([
                    year,
                    month
                ], {
                    depthLimit: 1,
                    excludeSelf: true
                });
                for (const keys of keysForMonth){
                    const [_, __, day] = keys;
                    const dayCells = treeDeepMap.get([
                        year,
                        month,
                        day
                    ]) || [];
                    const uniqueDayCell = this.getUniqueGridCells(column, dayCells)[0];
                    if (!uniqueDayCell) continue;
                    uniqueMonthCell.children.push(uniqueDayCell);
                    if (includeTime) {
                        uniqueDayCell.children = [];
                        const keysForDay = treeDeepMap.getKeysStartingWith([
                            year,
                            month,
                            day
                        ], {
                            depthLimit: 1,
                            excludeSelf: true
                        });
                        for (const keys of keysForDay){
                            const [_, __, ___, time] = keys;
                            const timeCells = treeDeepMap.get([
                                year,
                                month,
                                day,
                                time
                            ]) || [];
                            const uniqueTimeCell = this.getUniqueGridCells(column, timeCells)[0];
                            if (!uniqueTimeCell) continue;
                            uniqueDayCell.children.push(uniqueTimeCell);
                        }
                        uniqueDayCell.leafChildrenCount = treeDeepMap.getKeysForLeafNodesStartingWith([
                            year,
                            month,
                            day
                        ]).length;
                        uniqueDayCell.children.sort((dayCell1, dayCell2)=>{
                            return dayCell1.rawValue.localeCompare(dayCell2.rawValue);
                        });
                    }
                }
                uniqueMonthCell.leafChildrenCount = treeDeepMap.getKeysForLeafNodesStartingWith([
                    year,
                    month
                ]).length;
                uniqueMonthCell.children.sort((monthCell1, monthCell2)=>{
                    return monthCell1.rawValue.localeCompare(monthCell2.rawValue);
                });
            }
            uniqueYearCell.leafChildrenCount = treeDeepMap.getKeysForLeafNodesStartingWith([
                year
            ]).length;
            uniqueYearCell.children.sort((monthCell1, monthCell2)=>{
                return monthCell1.rawValue.localeCompare(monthCell2.rawValue);
            });
        }
        topLevelGridCells.sort((yearCell1, yearCell2)=>{
            return yearCell1.rawValue.localeCompare(yearCell2.rawValue);
        });
        return topLevelGridCells;
    }
    getDistinctGridCellsForColumn(column, rowNodes) {
        let gridCells = [];
        const isPivotResultColumn = column.isGeneratedPivotResultColumn;
        const rowNodeCallback = (rowNode)=>{
            const gridCell = this.addDistinctColumnValue(rowNode, column.columnId, isPivotResultColumn);
            if (gridCell) {
                const value = gridCell.rawValue;
                // we want to filter out empty values
                value === '' || value;
                gridCells.push(gridCell);
            }
        };
        if (rowNodes) rowNodes.forEach(rowNodeCallback);
        else this.agGridAdapter.getAgGridApi().forEachNode(rowNodeCallback);
        return this.getUniqueGridCells(column, gridCells);
    }
    addDistinctColumnValue(rowNode, columnId, isPivotResultColumn) {
        if (!rowNode) return;
        if (!isPivotResultColumn && this.isGroupRowNode(rowNode)) {
            if (this.api.gridApi.isTreeDataGrid()) {
                if (rowNode.data == undefined) // skip Tree Filler Groups
                // see https://www.ag-grid.com/javascript-data-grid/tree-data-paths/#filler-groups
                return;
                // if (columnId !== AG_GRID_GROUPED_COLUMN) {
                //   return;
                // }
                return this.getGridCellFromRowNode(rowNode, columnId);
            } else {
                // for normal Table Columns we do NOT return the values of the aggregates
                if (columnId !== (0, $58846ea7f4156db7$export$1fadf36dae8ed962)) return;
                return this.getGridCellFromRowNode(rowNode, columnId);
            }
        }
        if (isPivotResultColumn) {
            // if it's a Pivot Result Column, we are interested only in the aggregated(pivoted) data
            if (!rowNode.aggData) return;
            if (!rowNode.leafGroup) // if it's a Pivot Result Column, we are interested only in the leaf groups (pivot results, NOT group aggregates)
            return;
        }
        const returnValue = this.getGridCellFromRowNode(rowNode, columnId);
        return returnValue;
    }
    getUniqueGridCells(column, gridCells) {
        let gridCellsToUse = gridCells;
        const cache = new Map();
        const lowercase = this.api.predicateApi.useCaseSensitivity(column.columnId);
        const getter = (dataItem)=>{
            let value = dataItem.rawValue;
            if (value instanceof Date) return value.toISOString();
            if (lowercase && column.dataType == 'text') value = dataItem.displayValue.toLowerCase();
            return value;
        };
        const self = this;
        // handle the special case where GridCells have arrays as values
        // in this case we want to treat each value in the array as a separate value
        if (this.api.columnApi.internalApi.hasArrayDataType(column)) gridCellsToUse = gridCellsToUse.flatMap((gridCell)=>{
            const rawValueArray = gridCell.rawValue;
            if (Array.isArray(rawValueArray)) return rawValueArray.map((rawValue)=>({
                    ...gridCell,
                    // for now just map the rawValue
                    // extracting displayValue and normalisedValue is possible
                    // but it could have a significant performance impact
                    rawValue: rawValue,
                    displayValue: rawValue,
                    normalisedValue: rawValue
                }));
            return [
                gridCell
            ];
        });
        // those are grid cells unique per primary key - so cells corresponding to this column
        // by for every row in the grid
        // but here we want to collapse them down to values/cells unique by the
        // value of this column: eg - if this is country column and we have multiple rownodes
        // in the grid with country: UK, and multiple with country: France, then the end result
        // of the current function should be 2 cells: one for UK and one for France
        gridCellsToUse.forEach((dataItem)=>{
            const value = getter(dataItem);
            if (!cache.has(value)) cache.set(value, {
                count: 1,
                cell: dataItem,
                rowNodesWithSameCellValue: [
                    dataItem.rowNode
                ]
            });
            else {
                const data = cache.get(value);
                data.count++;
                data.rowNodesWithSameCellValue.push(dataItem.rowNode);
            }
        });
        const result = [];
        cache.forEach(({ count: count, cell: cell, rowNodesWithSameCellValue: rowNodesWithSameCellValue })=>{
            const cellWithCount = cell;
            cellWithCount.count = count;
            // the visibility of this cell is true if any of the row nodes with this value is visible
            Object.defineProperty(cellWithCount, 'visible', {
                get: ()=>{
                    return rowNodesWithSameCellValue.findIndex((pk)=>self.isRowNodeAvailableAfterFiltering(pk) === true) !== -1;
                }
            });
            Object.defineProperty(cellWithCount, 'visibleCount', {
                get: ()=>{
                    return rowNodesWithSameCellValue.filter((pk)=>self.isRowNodeAvailableAfterFiltering(pk) === true).length;
                }
            });
            result.push(cellWithCount);
        });
        return result;
    }
    getGridCellsForColumn(columnId, onlyVisibleRows = false) {
        let returnValues = [];
        const handler = (rowNode)=>{
            if (!this.isGroupRowNode(rowNode)) {
                const gridCell = this.getGridCellFromRowNode(rowNode, columnId);
                if (gridCell && gridCell.rawValue !== undefined && gridCell.rawValue !== null) returnValues.push(gridCell);
            }
        };
        if (onlyVisibleRows) this.agGridAdapter.getAgGridApi().forEachNodeAfterFilter(handler);
        else this.agGridAdapter.getAgGridApi().forEachNode(handler);
        return returnValues;
    }
    getRowNodesForPrimaryKeys(primaryKeyValues) {
        let rowNodes = [];
        if (this.useRowNodeLookUp) primaryKeyValues.forEach((pkValue)=>{
            const rowNode = this.agGridAdapter.getAgGridApi().getRowNode(pkValue);
            if (rowNode) rowNodes.push(rowNode);
        });
        else primaryKeyValues.forEach((pkValue)=>{
            let foundRow = false;
            this.agGridAdapter.getAgGridApi().forEachNode((rowNode)=>{
                if (!foundRow && pkValue == this.getPrimaryKeyValueFromRowNode(rowNode)) {
                    rowNodes.push(rowNode);
                    foundRow = true;
                }
            });
        });
        return rowNodes;
    }
    getRowNodeByIndex(index) {
        return this.agGridAdapter.getAgGridApi().getDisplayedRowAtIndex(index);
    }
    getAgGridStatusPanels() {
        return this.agGridAdapter.getGridOption('statusBar')?.statusPanels ?? [];
    }
    setDataValue(value, column, primaryKeyValue, rowNode) {
        // note: because we use RowNode.setDataValue() this will cause Validation to fire
        // see https://www.ag-grid.com/javascript-data-grid/change-detection/#triggering-value-change-detection
        let newValue;
        let dataType = column.dataType;
        newValue = dataType == 'number' ? Number(value) : value;
        if (dataType == undefined) return; // no point continuing as probably a wrong column
        if (rowNode) rowNode.setDataValue(column.columnId, newValue);
        else if (this.useRowNodeLookUp) {
            const rowNode = this.agGridAdapter.getAgGridApi().getRowNode(primaryKeyValue);
            if (rowNode != null) rowNode.setDataValue(column.columnId, newValue);
        } else {
            let isUpdated = false;
            // prefer not to use this method but if we do then at least we can prevent further lookups once we find
            this.agGridAdapter.getAgGridApi().forEachNode((rowNode)=>{
                if (!isUpdated) {
                    if (primaryKeyValue == this.getPrimaryKeyValueFromRowNode(rowNode)) {
                        rowNode.setDataValue(column.columnId, newValue);
                        isUpdated = true;
                    }
                }
            });
        }
    }
    forAllRowNodesDo(func, config) {
        this.agGridAdapter.getAgGridApi().forEachNode((rowNode, rowIndex)=>{
            const includeGroupRows = config?.includeGroupRows || !this.isGroupRowNode(rowNode);
            const filterFnFulfilled = !config?.filterFn || config?.filterFn(rowNode);
            if (includeGroupRows && filterFnFulfilled) func(rowNode, rowIndex);
        });
    }
    forAllVisibleRowNodesDo(func, config) {
        if (this.getAgGridRowModelType() !== 'clientSide') {
            // only in client-side row model can we loop through filtered&sorted rows
            // see https://www.ag-grid.com/javascript-data-grid/accessing-data/#iterating-rows
            this.logger.warn('forAllVisibleRowNodesDo() is only supported with client-side row model. Falling back to forAllRowNodesDo().');
            return this.forAllRowNodesDo(func, config);
        }
        this.agGridAdapter.getAgGridApi().forEachNodeAfterFilterAndSort((rowNode, rowIndex)=>{
            const includeGroupRows = config?.includeGroupRows || !this.isGroupRowNode(rowNode);
            const filterFnFulfilled = !config?.filterFn || config?.filterFn(rowNode);
            if (includeGroupRows && filterFnFulfilled) func(rowNode, rowIndex);
        });
    }
    getAgGridRowModelType(gridOptions) {
        // it seems that this can be null so we need explicitly to return "clientSide" in this case
        // need to check that for ServerSideRowModel it is ALWAYS returned...
        if (gridOptions) return gridOptions.rowModelType ?? 'clientSide';
        return this.agGridAdapter.getAgGridApi().getGridOption('rowModelType') ?? 'clientSide';
    }
    getAllRowNodes(config) {
        let rowNodes = [];
        this.forAllRowNodesDo((rowNode)=>rowNodes.push(rowNode), config);
        return rowNodes;
    }
    getGroupRowNodes() {
        return this.getAllRowNodes({
            includeGroupRows: true,
            filterFn: (rowNode)=>this.isGroupRowNode(rowNode)
        });
    }
    getRowsInViewport() {
        return this.agGridAdapter.getAgGridApi().getRenderedNodes();
    }
    isRowNodeVisible(rowNode) {
        const foundNode = this.agGridAdapter.getAgGridApi().getRenderedNodes().find((n)=>n.id == rowNode.id);
        return foundNode != null;
    }
    selectNodes(rowNodes, clearSelection) {
        if ((0, $9g4SS.default).IsNotNullOrEmpty(rowNodes)) rowNodes.forEach((node)=>this.selectNode(node, clearSelection));
    }
    deSelectNodes(rowNodes, clearSelection) {
        if ((0, $9g4SS.default).IsNotNullOrEmpty(rowNodes)) rowNodes.forEach((node)=>this.deSelectNode(node, clearSelection));
    }
    selectNode(rowNode, clearSelection) {
        if (!rowNode) {
            this.logger.error('Cannot select: row node is null.');
            return;
        }
        rowNode.setSelected(true, clearSelection);
    }
    deSelectNode(rowNode, clearSelection) {
        if (!rowNode) {
            this.logger.error('Cannot deselect: row node is null.');
            return;
        }
        rowNode.setSelected(false, clearSelection);
    }
    selectCells(columnIds, startNode, endNode, clearSelection) {
        if (clearSelection) this.agGridAdapter.getAgGridApi().clearCellSelection();
        const cellRangeParams = {
            rowStartIndex: startNode.rowIndex,
            rowEndIndex: endNode.rowIndex,
            columns: columnIds
        };
        this.agGridAdapter.getAgGridApi().addCellRange(cellRangeParams);
    }
    getAgGridColumnType(columnId) {
        const { type: type } = this.agGridAdapter.getAgGridApi().getColumnDef(columnId) ?? {};
        return type || '';
    }
    setColumnSort(columnSorts) {
        if (!this.isReady) return;
        const columnSortsMap = columnSorts?.reduce((acc, columnSort, index)=>{
            acc[columnSort.ColumnId] = {
                ...columnSort,
                SortIndex: index
            };
            return acc;
        }, {});
        const newColumnState = this.agGridAdapter.getAgGridApi().getColumnState().map((colState)=>{
            const { colId: colId } = colState;
            const state = {
                ...colState
            };
            const colSort = columnSortsMap ? columnSortsMap[colId] : undefined;
            if (colSort) {
                state.sort = colSort.SortOrder === 'Asc' ? 'asc' : 'desc';
                state.sortIndex = colSort.SortIndex;
            } else {
                state.sort = null;
                state.sortIndex = null;
            }
            return state;
        });
        this.agGridAdapter.getAgGridApi().applyColumnState({
            state: newColumnState,
            applyOrder: true
        });
        this.agGridAdapter.getAgGridApi().onSortChanged();
    }
    clearColumnSort() {
        this.setColumnSort(null);
    }
    clearColumnFiltering() {
        this.agGridAdapter.getAgGridApi().getColumns().forEach((c)=>{
            this.agGridAdapter.getAgGridApi().destroyFilter(c);
        });
    }
    clearColumnFilteringForColumns(columnIds) {
        columnIds.forEach((c)=>{
            const column = this.agGridAdapter.getAgGridApi().getColumns().find((col)=>col.getColId() === c);
            if (column) this.agGridAdapter.getAgGridApi().destroyFilter(column);
        });
    }
    canGenerateCharts() {
        const chartingModule = this.ModuleService.getModuleById('Charting');
        return chartingModule.isModuleEnabled() && chartingModule.isModuleAvailable();
    }
    canDisplaySparklines() {
        return this.agGridModulesAdapter.isAgGridModuleRegistered('SparklinesModule');
    }
    showCharts(chartsDefinitions, chartContainer) {
        return chartsDefinitions.map((chartDefinition)=>this.showChart(chartDefinition, chartContainer));
    }
    showChart(chartDefinition, container) {
        if (!this.isReady) {
            this.logger.consoleError('Cannot call showChart before Adaptable is fully initialized.');
            return null;
        }
        /**
         * Ag-grid always creates new charts behind the sences.
         * So we need to update the model inside adaptable state.
         * This is important to be done as soon as possible so it is not considered new.
         */ const chartRef = this.agGridAdapter.getAgGridApi().restoreChart(chartDefinition.Model, container);
        const chartModel = this.getChartModels().find((chartModel)=>chartModel.chartId === chartRef.chartId);
        // Update the definition in state so it is not considered new
        this.api.chartingApi.editChartDefinition({
            ...chartDefinition,
            Model: chartModel
        });
        return chartRef;
    }
    updateChart(chart) {
        if (!chart.Model) {
            this.logger.consoleError(`Cannot update chart "${chart.Name}": the chart definition is missing the required Model property.`);
            return;
        }
        const upgradableProperties = {
            // Only Range charts are supported to be created at run time
            // the other two are pivot & cross-filter
            type: 'rangeChartUpdate',
            chartId: chart.Model.chartId,
            unlinkChart: Boolean(chart.Model.unlinkChart),
            suppressChartRanges: Boolean(chart.Model.suppressChartRanges),
            aggFunc: chart.Model.aggFunc
        };
        // Skip the AG Grid API call if the upgradable properties haven't changed
        // to avoid unnecessary chartOptionsChanged events (see #ag_grid_update_chart_loop)
        const currentModel = this.getChartModels().find((model)=>model.chartId === chart.Model.chartId);
        if (currentModel && Boolean(currentModel.unlinkChart) === upgradableProperties.unlinkChart && Boolean(currentModel.suppressChartRanges) === upgradableProperties.suppressChartRanges && currentModel.aggFunc === upgradableProperties.aggFunc) return;
        // see also #ag_grid_update_chart_loop
        this.agGridAdapter.getAgGridApi().updateChart(upgradableProperties);
    }
    getChartModels() {
        if (!this.isReady) {
            this.logger.consoleError('Cannot call getChartModels before Adaptable is fully initialized.');
            return [];
        }
        return this.agGridAdapter.getAgGridApi().getChartModels();
    }
    getRowCount() {
        const allNodes = this.getAllRowNodes({
            includeGroupRows: false
        });
        return allNodes.length;
    }
    getVisibleRowCount() {
        return this.agGridAdapter.getAgGridApi().getDisplayedRowCount();
    }
    getColumnCount() {
        return this.agGridAdapter.getAgGridApi().getColumns()?.length ?? 0;
    }
    getVisibleColumnCount() {
        return this.agGridAdapter.getAgGridApi().getColumns()?.filter((c)=>c.isVisible()).length ?? 0;
    }
    isGridGroupingActive() {
        let isGroupedActive = false;
        this.agGridAdapter.getAgGridApi().forEachNode((node)=>{
            if (!isGroupedActive) {
                if (node.group) isGroupedActive = true;
            }
        });
        return isGroupedActive;
    }
    setAgGridQuickSearch(searchText) {
        if (!this.agGridModulesAdapter.isAgGridModuleRegistered('QuickFilterModule')) {
            this.logger.consoleError('Quick Search requires the AG Grid "QuickFilterModule". Please register this module to enable Quick Search.');
            return;
        }
        this.agGridAdapter.setGridOption('quickFilterText', searchText);
    }
    clearAgGridQuickSearch() {
        this.setAgGridQuickSearch('');
    }
    setAgGridFindSearchValue(searchText) {
        if (!this.agGridModulesAdapter.isAgGridModuleRegistered('FindModule')) {
            this.logger.consoleError('Find Search requires the AG Grid "FindModule". Please register this module to enable Find Search.');
            return;
        }
        this.agGridAdapter.setGridOption('findSearchValue', searchText);
    }
    applyAdaptableTheme(theme) {
        const container = this.getAgGridContainerElement();
        if (container != null) {
            container.classList.add('ab-Grid');
            if (this.adaptableOptions.filterOptions.columnFilterOptions.indicateFilteredColumns) container.classList.add('ab-Grid--indicate-filtered-columns');
        }
        if (this._isDetailGrid) return;
        theme = this.ThemeService.mapOsTheme(theme);
        const themeName = typeof theme === 'string' ? theme : theme.Name;
        const isSystemTheme = this.api.themeApi.internalApi.isSystemTheme(themeName);
        const themeClassNamesToRemove = [];
        const themesToRemove = [];
        const allThemes = this.api.themeApi.getThemes().map((t)=>{
            // we mutate the theme later,
            // and since we don't want the mutation to end up in state
            // we better clone it here
            return {
                ...t
            };
        });
        const allThemesMap = allThemes.reduce((acc, theme)=>{
            acc[theme.Name] = theme;
            return acc;
        }, {});
        const themeObject = allThemesMap[themeName];
        // REMOVE PREVIOUS THEME
        // const themePrefix = 'ab--theme-'
        const el = document.documentElement;
        el.classList.forEach((cssClassName)=>{
            const index = cssClassName.indexOf($58846ea7f4156db7$export$2918e1c8357d59c9);
            if (index === 0) {
                themeClassNamesToRemove.push(cssClassName);
                const themeName = cssClassName.substring($58846ea7f4156db7$export$2918e1c8357d59c9.length);
                if (allThemesMap[themeName]) themesToRemove.push(allThemesMap[themeName]);
            }
        });
        themeClassNamesToRemove.forEach((cssClassName)=>el.classList.remove(cssClassName));
        // remove infinite table classnames
        themesToRemove.forEach((theme)=>{
            el.classList.remove(`infinite-theme-mode--${theme.Name}`);
        });
        el.classList.remove(`infinite-theme-name--default`);
        // VARIANT
        let variantTheme = '';
        if (!isSystemTheme && themeObject.Variant) variantTheme = themeObject.Variant;
        // APPLY NEW THEME
        const newTheme = allThemesMap[themeName];
        const getClassName = (theme)=>$58846ea7f4156db7$export$2918e1c8357d59c9 + theme;
        el.classList.add(getClassName(themeName));
        if (variantTheme) el.classList.add(getClassName(variantTheme));
        if (isSystemTheme) // add infinite table classname for theme
        el.classList.add(`infinite-theme-mode--${themeName}`);
        else if (variantTheme) el.classList.add(`infinite-theme-mode--${variantTheme}`);
        el.classList.add(`infinite-theme-name--default`);
        // Update AG THEME
        this.agGridThemeAdapter.applyAgGridThemeOnAdaptableThemeChange(newTheme, variantTheme, container, themesToRemove);
        // MAC LIKE SCROLLBARS
        if (this.adaptableOptions.userInterfaceOptions && this.adaptableOptions.userInterfaceOptions.useCustomMacLikeScrollbars && (0, $d9d5ba45a21efe90$export$2e2bcd8739ae039)() > 0) el.classList.add('ab--custom-mac-like-scrollbars');
        else el.classList.remove('ab--custom-mac-like-scrollbars');
    }
    setRowGroupColumns(columnIds) {
        this.agGridAdapter.getAgGridApi().setRowGroupColumns(columnIds);
    }
    getAllGridColumns() {
        return this.agGridAdapter.getAgGridApi().getAllGridColumns();
    }
    clearRowGroupColumns() {
        this.agGridAdapter.getAgGridApi().removeRowGroupColumns(this.agGridAdapter.getAgGridApi().getRowGroupColumns());
    }
    expandAllRowGroups() {
        this.agGridAdapter.getAgGridApi().expandAll();
    }
    collapseAllRowGroups() {
        this.agGridAdapter.getAgGridApi().collapseAll();
    }
    expandRowGroupsForValues(columnValues) {
        if ((0, $9g4SS.default).IsNotNullOrEmpty(columnValues)) {
            const expandedKeys = columnValues.reduce((acc, key)=>{
                acc[key] = true;
                return acc;
            }, {});
            this.agGridAdapter.getAgGridApi().forEachNode((node)=>{
                if (node.group && !node.expanded) {
                    const nodePath = [];
                    let current = node;
                    while(current){
                        nodePath.push(current.key);
                        current = current.parent;
                    }
                    const nodeKey = nodePath.filter((x)=>!!x).reverse().join((0, $58846ea7f4156db7$export$5018118ad9245c30));
                    if (expandedKeys[nodeKey]) node.setExpanded(true);
                }
            });
            this.agGridAdapter.getAgGridApi().onGroupExpandedOrCollapsed();
        }
    }
    getAgGridColumnForColumnId(columnId) {
        return this.agGridAdapter.getAgGridApi().getColumn(columnId);
    }
    getMinMaxCachedValueForColumn(column, minMax) {
        const { columnId: columnId, dataType: dataType } = column;
        if (dataType !== 'number') return undefined;
        let value = this.columnMinMaxValuesCache[columnId]?.[minMax];
        if (value !== undefined) return value;
        const distinctRawValues = this.api.gridApi.internalApi.getUnsortedDistinctRawValuesForColumn(columnId).map((item)=>item.rawValue);
        value = minMax === 'min' ? Math.min(...distinctRawValues) : Math.max(...distinctRawValues);
        this.columnMinMaxValuesCache[columnId] = {
            ...this.columnMinMaxValuesCache[columnId],
            [minMax]: value
        };
        return value;
    }
    destroy(config) {
        if (!config) config = {
            unmount: true,
            destroyAgGrid: true
        };
        else {
            // should not happen unless someone ignored the TypeScript warnings
            if (config.unmount == undefined) config.unmount = true;
            if (config.destroyAgGrid == undefined) config.destroyAgGrid = true;
        }
        this.__prevLayoutForRefresh = undefined;
        this.layoutManager?.destroy();
        this.layoutManager = null;
        (0, $4d3ef767231dfbdc$export$a3d8d83e3da47e22)();
        const agGridApi = this.agGridAdapter?.getAgGridApi();
        if (agGridApi && !agGridApi.isDestroyed()) {
            agGridApi.removeEventListener('firstDataRendered', this.listenerFirstDataRendered);
            agGridApi.removeEventListener('columnPivotChanged', this.listenerPivotChanged);
            agGridApi.removeEventListener('cellEditingStarted', this.listenerCellEditingStarted);
            agGridApi.removeEventListener('cellSelectionChanged', this.listenerCellSelectionChanged);
            agGridApi.removeEventListener('columnGroupOpened', this.listenerColumnGroupOpened);
            agGridApi.removeEventListener('sortChanged', this.listenerSortChanged);
            agGridApi.removeGlobalListener(this.listenerGlobalSetRowSelection);
            if (this.listenerGlobalChartingChanges) this.agGridAdapter.getAgGridApi().removeGlobalListener(this.listenerGlobalChartingChanges);
            this.listenerFirstDataRendered = null;
            this.listenerPivotChanged = null;
            this.listenerColumnGroupOpened = null;
            this.listenerCellEditingStarted = null;
            this.listenerCellSelectionChanged = null;
            this.listenerGlobalSetRowSelection = null;
            this.listenerSortChanged = null;
            this.throttleFilterOnDataChange = null;
            const liveGridOptions = this.agGridAdapter.DANGER_getLiveGridOptions();
            if (liveGridOptions) {
                this.agGridOptionsService.revertGridOptionsPropertiesToUserValue(liveGridOptions, [
                    'aggFuncs',
                    'allowContextMenuWithControlKey',
                    'columnTypes',
                    'components',
                    'context',
                    'dataTypeDefinitions',
                    'doesExternalFilterPass',
                    'excelStyles',
                    'getContextMenuItems',
                    'getMainMenuItems',
                    'getRowClass',
                    'getRowId',
                    'getRowStyle',
                    'gridId',
                    'isExternalFilterPresent',
                    'sideBar',
                    'statusBar',
                    'suppressAggFuncInHeader',
                    'defaultColDef'
                ]);
                if (liveGridOptions.components) liveGridOptions.components.AdaptableToolPanel = null;
            }
        }
        if (config?.destroyAgGrid === true) this.agGridAdapter.getAgGridApi()?.destroy();
        const gridContainerElement = this.getAgGridContainerElement();
        if (gridContainerElement) {
            gridContainerElement.removeEventListener('keydown', this.agGridListenerKeydown, true);
            gridContainerElement.removeEventListener('mouseenter', this.agGridListenerMouseEnter, true);
            gridContainerElement.removeEventListener('mouseleave', this.agGridListenerMouseLeave);
            this.agGridListenerKeydown = null;
            this.agGridListenerMouseEnter = null;
            this.agGridListenerMouseLeave = null;
        }
        this.api._internalDestroySelf();
        this.agGridOptionsService?.destroy();
        this.agGridOptionsService = null;
        this.agGridAdapter?.destroy();
        this.agGridAdapter = null;
        this.agGridMenuAdapter?.destroy();
        this.agGridMenuAdapter = null;
        this.agGridColumnAdapter?.destroy();
        this.agGridColumnAdapter = null;
        this.agGridExportAdapter?.destroy();
        this.agGridExportAdapter = null;
        this.agGridThemeAdapter?.destroy();
        this.agGridThemeAdapter = null;
        this.agGridModulesAdapter?.destroy();
        this.agGridModulesAdapter = null;
        this.rowListeners = null;
        this.emitter.destroy();
        this.emitter = null;
        this.adaptableOptions = null;
        this.columnMinMaxValuesCache = null;
        this.lifecycleState = 'preDestroyed';
        $2c60780b406d81af$export$a19c58cdd10e13f7.dismissInstance(this);
        // !! this has to be before clearing up references to container and/or adaptableOptions
        if (config?.unmount) {
            const abContainerElement = this.getAdaptableContainerElement();
            if (abContainerElement != null) this.unmountReactRoot?.();
            this.unmountReactRoot = null;
        }
        this.DANGER_USE_GETTER_adaptableContainerElement = null;
        this.DANGER_USE_GETTER_agGridContainerElement = null;
        this.debouncedSetSelectedCells?.cancel?.();
        this.debouncedSetSelectedCells = null;
        this.debouncedSetSelectedRows?.cancel?.();
        this.debouncedSetSelectedRows = null;
        this.adaptableStore?.destroy();
        this.adaptableStore = null;
        this.adaptableModules?.clear();
        this.adaptableModules = null;
        this.adaptableOptions = null;
        this.adaptableStatusPanelKeys = null;
        this.CalculatedColumnExpressionService?.destroy?.();
        this.CalculatedColumnExpressionService = null;
        this.DataService?.destroy?.();
        this.DataService = null;
        this.Fdc3Service?.destroy?.();
        this.Fdc3Service = null;
        this.ModuleService?.destroy?.();
        this.ModuleService = null;
        this.ValidationService?.destroy?.();
        this.ValidationService = null;
        this.QueryLanguageService?.destroy?.();
        this.QueryLanguageService = null;
        this.AlertService?.destroy?.();
        this.AlertService = null;
        this.TeamSharingService?.destroy?.();
        this.TeamSharingService = null;
        this.RowFormService?.destroy?.();
        this.RowFormService = null;
        this.MetamodelService?.destroy?.();
        this.MetamodelService = null;
        this.LicenseService?.destroy?.();
        this.LicenseService = null;
        this.FlashingCellService?.destroy?.();
        this.FlashingCellService = null;
        this.ThemeService?.destroy?.();
        this.ThemeService = null;
        this.ChartingService?.destroy?.();
        this.ChartingService = null;
        this.AnnotationsService?.destroy?.();
        this.AnnotationsService = null;
        this.unmountLoadingScreen?.();
        this.unmountLoadingScreen = null;
    }
    canExportToExcel() {
        return this.agGridModulesAdapter.isAgGridModuleRegistered('ExcelExportModule');
    }
    canExportToCsv() {
        return this.agGridModulesAdapter.isAgGridModuleRegistered('CsvExportModule');
    }
    isQuickFilterAvailable() {
        return this.hasFloatingFilterOnAtLeastOneColumn(this.agGridAdapter.getAgGridApi().getColumnDefs());
    }
    hasFloatingFilterOnAtLeastOneColumn(columnDefs) {
        let col;
        for (col of columnDefs){
            if (col.floatingFilter) return true;
            if (col.children) {
                if (this.hasFloatingFilterOnAtLeastOneColumn(col.children)) return true;
            }
        }
        return false;
    }
    getChartRef(chartId) {
        return this.agGridAdapter.getAgGridApi().getChartRef(chartId);
    }
    updateLayoutInManagerAfterStoreHasChanged(layout = this.api.layoutApi.getCurrentLayout()) {
        (0, $702a77ed6db22640$export$88f5e04cb6a7b262)(layout);
        const isLayoutSwitch = this._prevLayout && layout.Name != this._prevLayout.Name;
        let shouldUpdateExpandState = isLayoutSwitch;
        if (!isLayoutSwitch && this._prevLayout) {
            if (layout.RowGroupValues?.RowGroupDefaultBehavior && this._prevLayout?.RowGroupValues?.RowGroupDefaultBehavior != layout.RowGroupValues?.RowGroupDefaultBehavior) shouldUpdateExpandState = true;
            else {
                const prevLayoutExceptionGroupKeys = (0, $702a77ed6db22640$export$5cdc7948b93f9a16)(this._prevLayout).flat().join(',');
                const currentLayoutExceptionGroupKeys = (0, $702a77ed6db22640$export$5cdc7948b93f9a16)(layout).flat().join(',');
                if (prevLayoutExceptionGroupKeys !== currentLayoutExceptionGroupKeys) shouldUpdateExpandState = true;
            }
        }
        const prevLayout = this._prevLayout;
        this._prevLayout = layout;
        const perfSetLayout = this.logger.beginPerf(`setLayout(${layout.Name})`);
        const setLayoutMarker = (0, $640f77453ad4a03c$export$cd7dd5b5380f942f)(this.adaptableOptions.adaptableId).track.Runtime.label.SetLayout.start();
        const isPivot = (0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout);
        // update the header name for all columns
        this.agGridAdapter.getAgGridApi().getColumns().forEach((col)=>{
            const colDef = col.getColDef();
            const colId = col.getColId();
            const abColumn = this.api.columnApi.getColumnWithColumnId(colId);
            const colSetupInfo = {
                col: col,
                colDef: colDef,
                colId: colId,
                abColumn: abColumn
            };
            this.agGridColumnAdapter.setupColumnHeader(colSetupInfo);
        });
        // need to refresh the header,
        // as the Layout.ColumnHeaders state property is not implemented in the LayoutManager
        // and is specific to Adaptable, therefore we need to refresh it manually
        if (!prevLayout || JSON.stringify(prevLayout.ColumnHeaders) !== JSON.stringify(layout.ColumnHeaders)) this.refreshHeader();
        const layoutModel = (0, $702a77ed6db22640$export$3732e731bff1a886)(layout);
        this.layoutManager?.setLayout(layoutModel, {
            skipApplyRowGroupsExpandedState: !shouldUpdateExpandState,
            skipTriggerChange: true
        });
        this.refreshAdaptableAfterLayoutChange(layout);
        if (layout.AutoSizeColumns) {
            if (isPivot) requestAnimationFrame(()=>{
                if (this.isAvailable) this.agGridAdapter.getAgGridApi().autoSizeAllColumns();
            });
            else requestAnimationFrame(()=>{
                this.autoSizeColumns();
            });
        }
        // this.showQuickFilter()
        this.forPlugins((plugin)=>{
            if (plugin.afterSetLayout) plugin.afterSetLayout(this, layout);
        });
        perfSetLayout.end();
        setLayoutMarker.end({
            details: [
                {
                    name: 'Layout name',
                    value: layout.Name
                },
                {
                    name: 'Type',
                    value: isPivot ? 'Pivot' : 'Table'
                },
                {
                    name: isPivot ? 'Pivot Columns' : 'Table Columns',
                    value: isPivot ? layout.PivotColumns.join(', ') : layout.TableColumns.join(', ')
                }
            ]
        });
    }
    getActiveAdaptableAggFuncForCol(columnId) {
        if (!columnId) return null;
        const currentLayout = this.api.layoutApi.getCurrentLayout();
        const aggregationFunctionsColumnsMap = ((0, $702a77ed6db22640$export$db5fe50348e92ffe)(currentLayout) ? currentLayout.PivotAggregationColumns : currentLayout.TableAggregationColumns).reduce((acc, col)=>{
            acc[col.ColumnId] = col.AggFunc;
            return acc;
        }, {});
        const adaptableAggFunc = aggregationFunctionsColumnsMap[columnId];
        if (typeof adaptableAggFunc === 'object' && 'type' in adaptableAggFunc && adaptableAggFunc.type === 'weightedAverage') return adaptableAggFunc;
        return null;
    }
    onRowDataChanged({ rowNode: rowNode, oldData: oldData, newData: newData }) {
        if (oldData == null || oldData == undefined) return;
        if (oldData == newData) return;
        const primaryKeyValue = this.getPrimaryKeyValueFromRowNode(rowNode);
        if (!primaryKeyValue) return;
        let cellDataChangedInfos = [];
        Object.keys(oldData).forEach((key)=>{
            if (this.api.columnApi.isColumnInGrid(key)) {
                const oldValue = oldData[key];
                const newValue = newData[key];
                if (oldValue != newValue) {
                    const cellDataChangedInfo = this.api.internalApi.buildCellDataChangedInfo({
                        oldValue: oldValue,
                        newValue: newValue,
                        column: this.api.columnApi.getColumnWithColumnId(key),
                        primaryKeyValue: primaryKeyValue,
                        rowNode: rowNode,
                        trigger: 'tick'
                    });
                    if (this.isUndoChange(cellDataChangedInfo)) cellDataChangedInfo.trigger = 'undo';
                    cellDataChangedInfos.push(cellDataChangedInfo);
                }
            }
        });
        this.performPostEditChecks(rowNode, cellDataChangedInfos);
    }
    onCellDataChanged({ rowNode: rowNode, oldValue: oldValue, newValue: newValue, colId: colId }) {
        if (oldValue == newValue) return;
        const abColumn = this.api.columnApi.getColumnWithColumnId(colId);
        if (!abColumn) return;
        if (this.isGroupRowNode(rowNode)) {
            const cellDataChangedInfo = this.api.internalApi.buildCellDataChangedInfo({
                oldValue: oldValue,
                newValue: newValue,
                column: abColumn,
                /**
                 * A grouped row does not have an underling data item.
                 * Because of this we use the rowNode.id as an identifier.
                 */ primaryKeyValue: rowNode.id,
                rowNode: rowNode,
                trigger: 'aggChange'
            });
            this.DataService.CreateCellDataChangedEvent(cellDataChangedInfo);
            return;
        }
        const primaryKeyValue = this.getPrimaryKeyValueFromRowNode(rowNode);
        if (!primaryKeyValue) return;
        const cellDataChangedInfo = this.api.internalApi.buildCellDataChangedInfo({
            oldValue: oldValue,
            newValue: newValue,
            column: abColumn,
            primaryKeyValue: primaryKeyValue,
            rowNode: rowNode,
            trigger: 'edit'
        });
        if (this.isUndoChange(cellDataChangedInfo)) cellDataChangedInfo.trigger = 'undo';
        this.performPostEditChecks(rowNode, [
            cellDataChangedInfo
        ]);
    }
    isUndoChange(dataChange) {
        // check if this is not a reverted change
        const undoChange = this.api.internalApi.getDataService().extractUndoChange(dataChange);
        return !!undoChange;
    }
    /**
     * There are a few things we need to do AFTER we edit a cell and it makes sense to put them in one place
     */ performPostEditChecks(rowNode, cellDataChangedInfos) {
        cellDataChangedInfos.forEach((cellDataChangedInfo)=>{
            // if a Cell Data Change is undone, log to the Console
            if (cellDataChangedInfo.trigger === 'undo') this.logger.info(`Data change reverted: column="${cellDataChangedInfo.column}", primaryKey="${cellDataChangedInfo.primaryKeyValue}", from=${cellDataChangedInfo.newValue} to=${cellDataChangedInfo.oldValue}`);
            // For Changes except Aggregations, reset cell selection if required
            if (cellDataChangedInfo.trigger === 'edit' || cellDataChangedInfo.trigger === 'undo' || cellDataChangedInfo.trigger === 'tick') this.checkIfChangedCellCurrentlySelected(cellDataChangedInfo);
            // Call the Data Service to create an Internal Event so other parts of App can respond
            this.DataService.CreateCellDataChangedEvent(cellDataChangedInfo);
            // Reset Min and Max values for the Column
            this.resetMinMaxCachedValueForColumn(cellDataChangedInfo.column);
        });
        this.refreshCellsBasedOnCellDataChange(rowNode, cellDataChangedInfos);
        this.refreshColumnsBasedOnCellDataChange(cellDataChangedInfos);
        const colIds = cellDataChangedInfos.map((c)=>c.column.columnId);
        const { columnFilterApi: columnFilterApi, gridFilterApi: gridFilterApi } = this.api.filterApi;
        const isGridFilterActive = !!gridFilterApi.getCurrentGridFilterExpression();
        const isColumnFilterActive = colIds.some((colId)=>columnFilterApi.isColumnFilterActiveForColumn(colId));
        const shouldFilter = isGridFilterActive || isColumnFilterActive;
        if (shouldFilter) this.filterOnDataChange();
    }
    refreshCellsBasedOnCellDataChange(rowNode, cellDataChangedInfos) {
        //  Check if node is visible as otherwise AG Grid wont refresh
        if (this.agGridAdapter.isVisibleNode(rowNode)) {
            let dataChangedScope = {
                wholeRow: false,
                columnIds: new Set()
            };
            // First check Format Column Expressions
            this.checkFormatColumnExpressionStyleChanges(dataChangedScope, cellDataChangedInfos);
            //  If Scope is whole row then redraw row and return
            if (dataChangedScope.wholeRow) {
                this.redrawRow(rowNode);
                return;
            }
            // Next check for Format Column Predicates, Styled Columns and FreeText Columns to update the ColumnIds refresh list as required
            this.checkFormatColumnPredicateStyleChanges(dataChangedScope, cellDataChangedInfos);
            this.checkFreeTextColumnChanges(dataChangedScope, cellDataChangedInfos);
            this.checkStyledColumnComparisonChanges(dataChangedScope, cellDataChangedInfos);
            if (dataChangedScope.columnIds.size > 0) this.refreshCells(rowNode, Array.from(dataChangedScope.columnIds.values()), true);
        }
    }
    refreshColumnsBasedOnCellDataChange(cellDataChangedInfos) {
        const columnIdsToUpdate = [];
        // The only use case is Styled Columns with a Relative Cell Range
        cellDataChangedInfos.forEach((cellDataChangeInfo)=>{
            const styledColumn = this.api.styledColumnApi.getActiveStyledColumnForColumn(cellDataChangeInfo.column);
            if (styledColumn && this.api.styledColumnApi.internalApi.hasStyledColumnRelativeCellRange(styledColumn)) columnIdsToUpdate.push(styledColumn.ColumnId);
        });
        if ((0, $9g4SS.default).IsNotNullOrEmpty(columnIdsToUpdate)) this.refreshColumns(columnIdsToUpdate, true);
    }
    checkStyledColumnComparisonChanges(dataChangedScope, cellDataChangedInfos) {
        this.api.styledColumnApi.getStyledColumns().forEach((sc)=>{
            let columnComparison = this.api.styledColumnApi.internalApi.getColumnComparisonForStyledColumn(sc);
            if (columnComparison) {
                let affectedColumnIds = this.api.styledColumnApi.internalApi.getColumnIdsFromColumnComparison(columnComparison);
                if ((0, $9g4SS.default).IsNotNullOrEmpty(affectedColumnIds)) cellDataChangedInfos.forEach((cellDataChangedInfo)=>{
                    if (affectedColumnIds.includes(cellDataChangedInfo.column.columnId)) dataChangedScope.columnIds.add(sc.ColumnId);
                });
            }
        });
    }
    checkFormatColumnPredicateStyleChanges(dataChangedScope, cellDataChangedInfos) {
        cellDataChangedInfos.forEach((cellDataChangeInfo)=>{
            const dependentColumns = this.api.formatColumnApi.internalApi.getFormatColumnColumnsDependentOnColumnChange(cellDataChangeInfo.column);
            for (let colId of dependentColumns)dataChangedScope.columnIds.add(colId);
        });
    }
    checkFreeTextColumnChanges(dataChangedScope, cellDataChangedInfos) {
        cellDataChangedInfos.forEach((cellDataChangedInfo)=>{
            const freeTextColumn = this.api.freeTextColumnApi.getFreeTextColumns().find((fc)=>fc.ColumnId == cellDataChangedInfo.column.columnId);
            if (freeTextColumn) {
                dataChangedScope.columnIds.add(freeTextColumn.ColumnId);
                const refencedCalcColumns = this.api.calculatedColumnApi.internalApi.getCalculatedColumnsReferencingColumnId(cellDataChangedInfo.column.columnId);
                refencedCalcColumns.forEach((calculatedColumn)=>{
                    dataChangedScope.columnIds.add(calculatedColumn.ColumnId);
                });
            }
        });
    }
    checkFormatColumnExpressionStyleChanges(dataChangedScope, cellDataChangedInfos) {
        const formatColumnsWithExpression = [];
        formatColumnsWithExpression.push(...this.api.formatColumnApi.internalApi.getFormatColumnsWithExpression());
        if ((0, $9g4SS.default).IsNullOrEmpty(formatColumnsWithExpression)) return;
        cellDataChangedInfos.forEach((cellDataChangedInfo)=>{
            if (!dataChangedScope.wholeRow) formatColumnsWithExpression.forEach((formatColumn)=>{
                if (!dataChangedScope.wholeRow) {
                    const columnIds = this.api.expressionApi.getColumnsFromExpression(formatColumn.Rule.BooleanExpression);
                    if (columnIds.includes(cellDataChangedInfo.column.columnId)) {
                        if (this.api.columnScopeApi.scopeIsAll(formatColumn.Scope)) {
                            dataChangedScope.wholeRow = true;
                            return;
                        } else this.api.columnScopeApi.getColumnsInScope(formatColumn.Scope).map((c)=>c.columnId).forEach((colId)=>{
                            dataChangedScope.columnIds.add(colId);
                        });
                    }
                }
            });
        });
    }
    checkIfChangedCellCurrentlySelected(cellDataChangedInfo) {
        let selectedCellInfo = this.api.gridApi.getSelectedCellInfo();
        if (selectedCellInfo && (0, $9g4SS.default).IsNotNullOrEmpty(selectedCellInfo.gridCells)) {
            let matchingCell = selectedCellInfo.gridCells.find((gc)=>gc.primaryKeyValue == cellDataChangedInfo.primaryKeyValue && gc.column == cellDataChangedInfo.column);
            if (matchingCell) this.debouncedSetSelectedCells();
        }
        let selectedRowInfo = this.api.gridApi.getSelectedRowInfo();
        if (selectedRowInfo && (0, $9g4SS.default).IsNotNullOrEmpty(selectedRowInfo.gridRows)) {
            let matchingRow = selectedRowInfo.gridRows.find((gr)=>gr.primaryKeyValue == cellDataChangedInfo.primaryKeyValue);
            if (matchingRow) this.debouncedSetSelectedRows();
        }
    }
    resetMinMaxCachedValueForColumn(column) {
        if (!column) this.columnMinMaxValuesCache[column.columnId] = {};
        if (this.columnMinMaxValuesCache[column.columnId]) this.columnMinMaxValuesCache[column.columnId] = undefined;
    }
    filterOnDataChange() {
        if (this.adaptableOptions.filterOptions.filterActionOnDataChange.applyFilter == (0, $hrtGQ.FilterOnDataChangeOptions).Always) this.agGridAdapter.getAgGridApi()?.onFilterChanged();
        else if (this.adaptableOptions.filterOptions.filterActionOnDataChange.applyFilter == (0, $hrtGQ.FilterOnDataChangeOptions).Throttle) this.throttleFilterOnDataChange();
    }
    refreshLayout() {
        const columnDefs = this.agGridAdapter.getColumnDefinitionsInclSpecialColumns();
        // this setGridOption call will also trigger layout.onColumnDefsChanged()
        // which will in turn call updateColumnModelAndRefreshGrid
        this.agGridAdapter.setGridOption('columnDefs', columnDefs);
        // this is needed here for when we call setAdaptableStateKey
        // and pass a new config
        this.updateLayoutInManagerAfterStoreHasChanged();
        this.applyFiltering();
    }
    isRowGroupDifferentInLayout(one, other) {
        const prevRowGroupedColumns = one.RowGroupedColumns || one.PivotGroupedColumns || [];
        const currentRowGroupedColumns = other.RowGroupedColumns || other.PivotGroupedColumns || [];
        const prevRowGroupDisplayType = one.RowGroupDisplayType ?? 'single';
        const currentRowGroupDisplayType = other.RowGroupDisplayType ?? 'single';
        if (prevRowGroupDisplayType !== currentRowGroupDisplayType) return true;
        return prevRowGroupedColumns.join(',') !== currentRowGroupedColumns.join(',');
    }
    hasPivotTotalsInLayout(one, other) {
        const hasPivotTotals = (layout)=>{
            if (!(0, $702a77ed6db22640$export$db5fe50348e92ffe)(layout)) return false;
            if (layout.PivotGrandTotal) return true;
            if (layout.PivotColumnTotal) return true;
            if (layout.PivotAggregationColumns) return layout.PivotAggregationColumns.some((col)=>!!col.Total);
        };
        return hasPivotTotals(one) || hasPivotTotals(other);
    }
    onLayoutChange(layout) {
        layout = this.refreshAdaptableAfterLayoutChange(layout);
        this.api.layoutApi.createOrUpdateLayout(layout);
    }
    refreshAdaptableAfterLayoutChange(layout) {
        this.logger.info('Refreshing Adaptable after layout change.');
        const prevLayoutForRefresh = this.__prevLayoutForRefresh || this.api.layoutApi.getCurrentLayout();
        // see #on-regroup-expect-group-column-to-be-recomputed-and-setup-properly
        const rowGroupsChanged = this.isRowGroupDifferentInLayout(prevLayoutForRefresh, layout);
        if (rowGroupsChanged) {
            // when grouping changes, if we have a filter on the grouped column, we need to remove it
            // as it is no longer valid
            if (layout.ColumnFilters) {
                const newFilters = layout.ColumnFilters.filter((filter)=>filter.ColumnId !== (0, $58846ea7f4156db7$export$1fadf36dae8ed962));
                if (newFilters.length != layout.ColumnFilters.length) {
                    layout = {
                        ...layout
                    };
                    layout.ColumnFilters = newFilters;
                }
            }
            // also we need to reset the cache for the group column, when we have rowGripDisplayType single
            if (layout.RowGroupDisplayType === 'single' && (layout.RowGroupedColumns?.length || layout.PivotGroupedColumns?.length)) this.api.filterApi.columnFilterApi.resetFilterValues((0, $58846ea7f4156db7$export$1fadf36dae8ed962));
        }
        const hasPivotTotalsInLayout = this.hasPivotTotalsInLayout(prevLayoutForRefresh, layout);
        const pivotColsChanged = JSON.stringify(layout.PivotColumns) !== JSON.stringify(prevLayoutForRefresh.PivotColumns);
        if (rowGroupsChanged || pivotColsChanged || hasPivotTotalsInLayout) this.updateColumnModelAndRefreshGrid();
        else this.deriveAdaptableColumnStateFromAgGrid();
        this.__prevLayoutForRefresh = layout;
        return layout;
    }
    validateColumnDefTypes(columnDefs) {
        // in Adaptable version 20 we switched from colDef.type to colDef.cellDataType
        // although we documented this change and try to infer the correct cellDataTypes, it's best to also check if the client dev forgot to adjust his colDefs
        columnDefs.forEach((colDef)=>{
            if (colDef.children?.length) this.validateColumnDefTypes(colDef.children);
            const columnDefinition = colDef;
            const colDefType = columnDefinition.type;
            const colDefTypes = typeof colDefType === 'string' ? [
                colDefType
            ] : colDefType || [];
            colDefTypes.filter((colType)=>colType.startsWith('abColDef')).forEach((colType)=>{
                const newValidCellDataType = (0, $f68787f41a9f6c5c$export$952a7d7a55818ca6)(colType);
                if (newValidCellDataType) this.logger.consoleWarn(`Column "${columnDefinition.colId ?? columnDefinition.field}" uses deprecated type "${colType}"${newValidCellDataType !== 'unknown' ? `. Use colDef.cellDataType="${newValidCellDataType}" instead.` : '. This type is no longer supported.'}`);
            });
        });
    }
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * There are two ways in which the datasource can be dropped in the wizard:
 *
 * 1. array of objects - eg: [{"lastName":"John","firstName":"Bobson"},{"lastName":"Mike","firstName":"Richardson"},...]
 * 2. array of arrays - eg: [["lastName","firstName"],["John","Bobson"],["Mike","Richardson"],...]
 *
 * Although the second one is more compact, the first one is what we need for the datasource of the grid,
 * so if we receive v2, we transform it to 1
 * @param json
 */ const $c4631e67ee172a41$export$7d8e66552092b12e = (json, _file)=>{
    if (!Array.isArray(json) || !json.length) return {
        primaryKey: undefined,
        columns: [],
        data: []
    };
    let columns = [];
    let data = [];
    let primaryKey;
    if (Array.isArray(json[0])) {
        // we are in v2, as described above, so this is the list of columns
        columns = json[0];
        for(let i = 1, len = json.length; i < len; i++){
            const it = json[i];
            const obj = {};
            for(let j = 0; j < columns.length; j++)obj[columns[j]] = it[j];
            data.push(obj);
        }
    } else {
        columns = Object.keys(json[0]);
        data = json;
    }
    primaryKey = columns[0];
    return {
        primaryKey: primaryKey,
        columns: columns,
        data: data
    };
};
const $c4631e67ee172a41$var$typeToColType = {
    string: 'text',
    number: 'number',
    boolean: 'boolean',
    date: 'date'
};
const $c4631e67ee172a41$export$34613fc9cc9f6ae3 = (value)=>{
    const dataType = typeof value;
    let columnDataType = $c4631e67ee172a41$var$typeToColType[dataType] || $c4631e67ee172a41$var$typeToColType.string;
    if (value instanceof Date) columnDataType = $c4631e67ee172a41$var$typeToColType.date;
    if (Array.isArray(value) && value.length && typeof value[0] === 'number') columnDataType = 'numberArray';
    return columnDataType;
};
const $c4631e67ee172a41$export$c6cc045f65d3c987 = (dataSourceInfo, defaultGridOptions)=>{
    const firstItem = dataSourceInfo.data[0];
    const columnDefs = dataSourceInfo.columns.map((columnName)=>{
        const firstItemValue = firstItem[columnName];
        const columnType = $c4631e67ee172a41$export$34613fc9cc9f6ae3(firstItemValue);
        return {
            headerName: columnName,
            field: columnName,
            type: columnType,
            filter: true,
            sortable: true,
            enableRowGroup: true,
            resizable: true,
            editable: true
        };
    });
    const gridOptions = {
        ...defaultGridOptions,
        defaultColDef: {
            floatingFilter: true
        },
        rowData: dataSourceInfo.data,
        columnDefs: columnDefs,
        cellSelection: true,
        rowSelection: {
            mode: 'multiRow'
        },
        rowHeight: 30
    };
    return gridOptions;
};



var $acw62 = parcelRequire("acw62");

var $9OAZF = parcelRequire("9OAZF");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $f0d6c65c6fd96528$var$useSelection = (columns, defaultValue, fieldName, changeListeners)=>{
    changeListeners = changeListeners || {};
    const onChange = changeListeners.onChange || ((column, flag)=>{});
    const onBatchChange = changeListeners.onBatchChange || ((flag)=>{});
    const [selected, setSelected] = (0, $acw62.useState)(typeof defaultValue === 'object' ? defaultValue : columns.reduce((acc, col)=>{
        const flag = fieldName ? col[fieldName] : defaultValue;
        if (flag) acc[col.field] = flag;
        return acc;
    }, {}));
    const getColumn = (field)=>columns.filter((c)=>c.field === field)[0];
    const result = {
        selected: selected,
        isSelected: (field)=>!!selected[field],
        isAllSelected: ()=>Object.keys(selected).length === columns.length,
        isNoneSelected: ()=>Object.keys(selected).length === 0,
        selectColumn: (field)=>{
            if (!selected[field]) {
                setSelected({
                    ...selected,
                    [field]: true
                });
                onChange(getColumn(field), true);
            }
        },
        deselectColumn: (field)=>{
            if (selected[field]) {
                const newSelected = {
                    ...selected
                };
                delete newSelected[field];
                setSelected(newSelected);
                onChange(getColumn(field), false);
            }
        },
        toggleColumn: (field)=>{
            if (result.isSelected(field)) result.deselectColumn(field);
            else result.selectColumn(field);
        },
        deselectAll: ()=>{
            setSelected({});
            columns.forEach((col)=>{
                onChange(col, false);
            });
            onBatchChange(false);
        },
        selectAll: ()=>{
            setSelected(columns.reduce((acc, col)=>{
                acc[col.field] = true;
                return acc;
            }, {}));
            onBatchChange(true);
        }
    };
    return result;
};
var $f0d6c65c6fd96528$export$2e2bcd8739ae039 = $f0d6c65c6fd96528$var$useSelection;





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

const $225ddeb60412b51f$var$Arrows = ()=>{
    return $acw62.createElement("div", {
        style: {
            display: 'flex',
            flexFlow: 'column',
            position: 'absolute',
            // background: 'var(--ab-color-defaultbackground)',
            fill: 'var(--ab-cmp-dropdown__fill)',
            top: '50%',
            right: 'var(--ab-base-space)',
            transform: 'translate3d(0px, -50%, 0px)',
            cursor: 'pointer'
        }
    }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "triangle-up",
        size: 20,
        style: {
            position: 'relative',
            top: 7
        }
    }), $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        name: "triangle-down",
        size: 20,
        style: {
            position: 'relative',
            top: -7
        }
    }));
};
var $225ddeb60412b51f$export$2e2bcd8739ae039 = $225ddeb60412b51f$var$Arrows;





const $c018d682831fd26f$var$baseClassName = 'ab-Dropdown';
const $c018d682831fd26f$var$Dropdown = (props)=>{
    let { options: options, multiple: multiple, name: name, autoFocus: autoFocus, showEmptyItem: showEmptyItem = true, showClearButton: showClearButton, disabled: disabled, allowSearch: allowSearch, clearButtonProps: clearButtonProps, value: _, onChange: __, style: style, onExpand: onExpand, ...boxProps } = props;
    if (showClearButton !== false) showClearButton = true;
    let [value, setValue] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'value', undefined, {
        onChange: props.onChange
    });
    let selectedOption = null;
    let [lazyOptions, setLazyOptions] = (0, $acw62.useState)([]);
    let onMouseDown = ()=>{
        if (onExpand) onExpand();
    };
    if (typeof options === 'function') {
        const lazyOptionsFn = options;
        onMouseDown = ()=>{
            const newOptions = lazyOptionsFn();
            setLazyOptions(newOptions);
            if (onExpand) onExpand();
        };
        options = lazyOptions;
    }
    let placeholder = props.emptyText || (typeof props.placeholder === 'string' ? props.placeholder : null) || 'Select an option';
    const finalOptions = options.map((option)=>{
        if (typeof option === 'string') option = {
            label: option,
            value: option
        };
        if (value === option.value) selectedOption = option;
        return option;
    });
    if (showEmptyItem) finalOptions.splice(0, 0, {
        label: placeholder,
        value: ''
    });
    const onChange = (option, e)=>{
        setValue(option ? option.value : option, e, option);
    };
    const selectRef = (0, $acw62.useRef)(null);
    const domRef = (0, $acw62.useRef)(null);
    const [focused, setFocused] = (0, $acw62.useState)(false);
    const onFocus = (e)=>{
        if (e.target === selectRef.current) {
            setFocused(true);
            return;
        }
        if (e.target === domRef.current) selectRef.current?.focus();
    };
    const onBlur = ()=>{
        setFocused(false);
    };
    const defaultLabel = selectedOption ? selectedOption.label : null;
    let selectedText = props.renderLabel ? props.renderLabel(defaultLabel, selectedOption) : defaultLabel;
    if (!selectedOption) selectedText = placeholder;
    //20  ... 20 16
    const renderClearButton = ()=>$acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            variant: "text",
            icon: "close",
            tone: "none",
            tooltip: "Clear",
            iconSize: 20,
            ...clearButtonProps,
            className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:p-0 twa:mr-1 twa:z-10 twa:color-inherit', clearButtonProps?.className),
            style: {
                ...clearButtonProps ? clearButtonProps.style : null
            },
            onClick: (e)=>{
                e.preventDefault();
                onChange(null, e);
            }
        });
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        ref: domRef,
        flexDirection: 'row',
        alignItems: "center",
        ...boxProps,
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(props.className, $c018d682831fd26f$var$baseClassName, !selectedOption ? `${$c018d682831fd26f$var$baseClassName}--empty` : `${$c018d682831fd26f$var$baseClassName}--not-empty`, focused ? `${$c018d682831fd26f$var$baseClassName}--focused` : `${$c018d682831fd26f$var$baseClassName}--not-focused`, disabled ? `${$c018d682831fd26f$var$baseClassName}--disabled` : null),
        style: style,
        tabIndex: focused ? -1 : props.tabIndex || 0,
        onFocus: onFocus,
        onBlur: onBlur
    }, $acw62.createElement("div", {
        className: `${$c018d682831fd26f$var$baseClassName}__text twa:inline-block`
    }, selectedText, $acw62.createElement((0, $225ddeb60412b51f$export$2e2bcd8739ae039), null)), $acw62.createElement("select", {
        ref: selectRef,
        tabIndex: -1,
        disabled: disabled,
        value: value == null ? '' : value,
        onChange: (e)=>{
            const selected = finalOptions.filter((o)=>o.value == e.target.value)[0];
            onChange(selected, e);
        },
        style: {
            opacity: 0,
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            zIndex: 1
        },
        onMouseDown: onMouseDown,
        name: name,
        multiple: multiple,
        autoFocus: autoFocus
    }, finalOptions.map((o)=>{
        return $acw62.createElement("option", {
            key: o.value,
            value: o.value
        }, o.label);
    })), showClearButton && selectedOption ? renderClearButton() : null);
};
var $c018d682831fd26f$export$2e2bcd8739ae039 = $c018d682831fd26f$var$Dropdown;




var $9OAZF = parcelRequire("9OAZF");




const $65d7d9bc65a9124f$var$dataTypes = [
    {
        value: 'text',
        label: 'Text (string)'
    },
    {
        value: 'number',
        label: 'Number'
    },
    {
        value: 'date',
        label: 'Date'
    },
    {
        value: 'boolean',
        label: 'Boolean'
    }
];
const $65d7d9bc65a9124f$var$inputStyle = {
    width: '100%',
    minWidth: 80,
    textAlign: 'start'
};
const $65d7d9bc65a9124f$var$useForceRender = ()=>{
    const [, setNow] = (0, $acw62.useState)(Date.now());
    return ()=>{
        setNow(Date.now());
    };
};
const $65d7d9bc65a9124f$var$ThrottledInput = $acw62.memo((props)=>{
    const [stateValue, setStateValue] = (0, $acw62.useState)(props.value);
    const throttleOnChange = $acw62.useRef((0, $3a4c9a3b92c4503b$export$2e2bcd8739ae039)(props.onChange, 600, {
        leading: false
    }));
    const handleChange = $acw62.useCallback((event)=>{
        const newValue = event.target.value;
        setStateValue(newValue);
        throttleOnChange.current(newValue);
    }, []);
    $acw62.useEffect(()=>{
        setStateValue(props.value);
    }, [
        props.value
    ]);
    return $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        style: props.style,
        value: stateValue,
        onChange: handleChange
    });
});
const $65d7d9bc65a9124f$var$tableDOMProps = {
    style: {
        height: '100%',
        minWidth: '10rem',
        minHeight: 600
    }
};
const $65d7d9bc65a9124f$var$ColumnsList = ({ columns: cols, handle: handle, onValidityChange: onValidityChange, onChange: onChange, onSelectionChange: onSelectionChange, selectedColumns: selectedColumns, theme: theme })=>{
    const rerender = $65d7d9bc65a9124f$var$useForceRender();
    const columnsRef = (0, $acw62.useRef)(cols);
    const silentSetColumns = (columns)=>{
        columnsRef.current = columns;
        onChange?.(columns);
    };
    const setColumns = (columns)=>{
        silentSetColumns(columns);
        rerender();
    };
    const getColumns = ()=>columnsRef.current;
    const columns = columnsRef.current;
    const onColumnChange = (col, value, property)=>{
        col = {
            ...col,
            [property]: value
        };
        const cols = getColumns().map((c)=>{
            if (c.field === col.field) return col;
            return c;
        });
        setColumns(cols);
    };
    const onColumnBatchChange = (value, property)=>{
        const cols = getColumns().map((c)=>({
                ...c,
                [property]: value
            }));
        setColumns(cols);
    };
    const setColumnCaption = (caption, field)=>{
        const cols = getColumns().map((c)=>{
            if (c.field === field) {
                const newCol = {
                    ...c,
                    caption: caption
                };
                return newCol;
            }
            return c;
        });
        setColumns(cols);
    };
    const onColumnTypeChange = (col, type)=>{
        const cols = getColumns().map((c)=>{
            if (c.field === col.field) return {
                ...c,
                type: type
            };
            return c;
        });
        setColumns(cols);
    };
    const [primaryKeyField, setPrimaryKeyField] = $acw62.useState(columns[0].field);
    const { selected: includedColumnsMap, isSelected: isIncludedColumn, isAllSelected: isAllIncludedColumns, isNoneSelected: isNoneIncludedColumns, selectColumn: includeColumn, deselectColumn: excludeColumn, selectAll: includeAllColumns, deselectAll: excludeAllColumns } = (0, $f0d6c65c6fd96528$export$2e2bcd8739ae039)(columns, selectedColumns ?? true, null, {
        onChange: onSelectionChange
    });
    handle.current = {
        getColumns: ()=>getColumns().filter((col)=>isIncludedColumn(col.field)),
        getPrimaryKey: ()=>primaryKeyField
    };
    const { isSelected: isSortableColumn, isAllSelected: isAllSortableColumns, isNoneSelected: isNoneSortableColumns, selectColumn: setSortableColumn, deselectColumn: setUnsortableColumn, selectAll: setAllSortable, deselectAll: setAllUnsortable } = (0, $f0d6c65c6fd96528$export$2e2bcd8739ae039)(columns, true, 'sortable', {
        onBatchChange: (flag)=>{
            onColumnBatchChange(flag, 'sortable');
        },
        onChange: (col, flag)=>{
            onColumnChange(col, flag, 'sortable');
        }
    });
    const { isSelected: isGroupableColumn, isAllSelected: isAllGroupableColumns, isNoneSelected: isNoneGroupableColumns, selectColumn: setGroupableColumn, deselectColumn: setUngroupableColumn, selectAll: setAllGroupable, deselectAll: setAllUngroupable } = (0, $f0d6c65c6fd96528$export$2e2bcd8739ae039)(columns, true, 'enableRowGroup', {
        onBatchChange: (flag)=>{
            onColumnBatchChange(flag, 'enableRowGroup');
        },
        onChange: (col, flag)=>{
            onColumnChange(col, flag, 'enableRowGroup');
        }
    });
    const { isSelected: isResizableColumn, isAllSelected: isAllResizableColumns, isNoneSelected: isNoneResizableColumns, selectColumn: setResizableColumn, deselectColumn: setUnresizableColumn, selectAll: setAllResizable, deselectAll: setAllUnresizable } = (0, $f0d6c65c6fd96528$export$2e2bcd8739ae039)(columns, true, 'resizable', {
        onBatchChange: (flag)=>{
            onColumnBatchChange(flag, 'resizable');
        },
        onChange: (col, flag)=>{
            onColumnChange(col, flag, 'resizable');
        }
    });
    const { isSelected: isEditableColumn, isAllSelected: isAllEditableColumns, isNoneSelected: isNoneEditableColumns, selectColumn: setEditableColumn, deselectColumn: setUneditableColumn, selectAll: setAllEditable, deselectAll: setAllUneditable } = (0, $f0d6c65c6fd96528$export$2e2bcd8739ae039)(columns, true, 'editable', {
        onBatchChange: (flag)=>{
            onColumnBatchChange(flag, 'editable');
        },
        onChange: (col, flag)=>{
            onColumnChange(col, flag, 'editable');
        }
    });
    const { isSelected: isFilterableColumn, isAllSelected: isAllFilterableColumns, isNoneSelected: isNoneFilterableColumns, selectColumn: setFilterableColumn, deselectColumn: setUnFilterableColumn, selectAll: setAllFilterable, deselectAll: setAllUnfilterable } = (0, $f0d6c65c6fd96528$export$2e2bcd8739ae039)(columns, true, 'filter', {
        onBatchChange: (flag)=>{
            onColumnBatchChange(flag, 'filter');
        },
        onChange: (col, flag)=>{
            onColumnChange(col, flag, 'filter');
        }
    });
    const allIncluded = isAllIncludedColumns();
    const allExcluded = isNoneIncludedColumns();
    $acw62.useEffect(()=>{
        onValidityChange(isIncludedColumn(primaryKeyField));
    }, [
        includedColumnsMap,
        primaryKeyField
    ]);
    const data = columns;
    const CellWrapper = (props)=>{
        return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
            ...props,
            style: {
                ...props.style,
                position: 'absolute',
                textAlign: 'center',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                whiteSpace: 'normal'
            },
            justifyContent: "center",
            alignItems: "center"
        }, props.children);
    };
    const HeaderCellWrapper = (props)=>$acw62.createElement(CellWrapper, {
            ...props,
            className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:text-3 twa:font-bold', props.className)
        });
    const HeaderWithCheckbox = (props)=>{
        const { label: label, onChange: onChange, checked: checked, ...flexProps } = props;
        return $acw62.createElement(HeaderCellWrapper, {
            ...flexProps,
            flexDirection: "column"
        }, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, label), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
            className: "twa:text-center twa:ml-1"
        }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            checked: checked,
            onChange: onChange
        })));
    };
    const columnsMap = {
        pk: {
            header: ()=>$acw62.createElement(HeaderCellWrapper, null, "Primary Key"),
            maxWidth: 80,
            defaultSortable: false,
            renderMenuIcon: false,
            render: (params)=>{
                const { data: data } = params;
                const column = data;
                const isPrimaryKey = column?.field === primaryKeyField;
                return $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
                    checked: isPrimaryKey,
                    onChange: (checked)=>{
                        if (checked && isIncludedColumn(column.field)) setPrimaryKeyField(column.field);
                    }
                });
            }
        },
        included: {
            maxWidth: 80,
            resizable: true,
            renderMenuIcon: false,
            header: ()=>$acw62.createElement(HeaderWithCheckbox, {
                    label: "Included",
                    checked: allIncluded ? true : allExcluded ? false : null,
                    onChange: (allIncluded)=>{
                        if (allIncluded) includeAllColumns();
                        else excludeAllColumns();
                    }
                }),
            render: (params)=>{
                const column = params.data;
                return $acw62.createElement(CellWrapper, null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                    checked: isIncludedColumn(column.field),
                    onChange: (included)=>{
                        if (included) includeColumn(column.field);
                        else excludeColumn(column.field);
                    }
                }));
            }
        },
        field: {
            header: $acw62.createElement(HeaderCellWrapper, null, "Field"),
            field: 'field',
            minWidth: 150,
            renderMenuIcon: false,
            render: (params)=>{
                const column = params.data;
                const humanized = (0, $9OAZF.default).Humanize(column.field);
                return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
                    className: "twa:p-2"
                }, $acw62.createElement($65d7d9bc65a9124f$var$ThrottledInput, {
                    key: column.field,
                    style: $65d7d9bc65a9124f$var$inputStyle,
                    value: column.caption != undefined ? column.caption : humanized,
                    placeholder: humanized,
                    onChange: (value)=>{
                        setColumnCaption(value, column.field);
                    }
                }));
            }
        },
        type: {
            header: $acw62.createElement(HeaderCellWrapper, null, "Type"),
            maxWidth: 140,
            renderMenuIcon: false,
            render: (params)=>{
                const column = params.data;
                return $acw62.createElement(CellWrapper, {
                    className: "twa:px-1"
                }, $acw62.createElement((0, $c018d682831fd26f$export$2e2bcd8739ae039), {
                    style: $65d7d9bc65a9124f$var$inputStyle,
                    showClearButton: false,
                    options: $65d7d9bc65a9124f$var$dataTypes,
                    value: column?.type ?? '',
                    onChange: onColumnTypeChange.bind(null, column)
                }));
            }
        },
        sortable: {
            renderMenuIcon: false,
            header: $acw62.createElement(HeaderWithCheckbox, {
                label: "Sortable",
                checked: isAllSortableColumns() ? true : isNoneSortableColumns() ? false : null,
                onChange: (allSortable)=>{
                    if (allSortable) setAllSortable();
                    else setAllUnsortable();
                }
            }),
            render: (params)=>{
                const column = params.data;
                return $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                    checked: isSortableColumn(column.field),
                    onChange: (sortable)=>{
                        sortable ? setSortableColumn(column.field) : setUnsortableColumn(column.field);
                    }
                });
            }
        },
        editable: {
            renderMenuIcon: false,
            header: $acw62.createElement(HeaderWithCheckbox, {
                label: "Editable",
                checked: isAllEditableColumns() ? true : isNoneEditableColumns() ? false : null,
                onChange: (allEditable)=>{
                    if (allEditable) setAllEditable();
                    else setAllUneditable();
                }
            }),
            render: (params)=>{
                const col = params.data;
                return $acw62.createElement(CellWrapper, null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                    checked: isEditableColumn(col.field),
                    onChange: (editable)=>{
                        editable ? setEditableColumn(col.field) : setUneditableColumn(col.field);
                    }
                }));
            }
        },
        resizable: {
            renderMenuIcon: false,
            header: $acw62.createElement(HeaderWithCheckbox, {
                label: "Resizable",
                checked: isAllResizableColumns() ? true : isNoneResizableColumns() ? false : null,
                onChange: (allResizable)=>{
                    if (allResizable) setAllResizable();
                    else setAllUnresizable();
                }
            }),
            render: (params)=>{
                const col = params.data;
                return $acw62.createElement(CellWrapper, null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                    checked: isResizableColumn(col.field),
                    onChange: (resizable)=>{
                        resizable ? setResizableColumn(col.field) : setUnresizableColumn(col.field);
                    }
                }));
            }
        },
        groupable: {
            renderMenuIcon: false,
            header: $acw62.createElement(HeaderWithCheckbox, {
                label: "Groupable",
                checked: isAllGroupableColumns() ? true : isNoneGroupableColumns() ? false : null,
                onChange: (allGroupable)=>{
                    if (allGroupable) setAllGroupable();
                    else setAllUngroupable();
                }
            }),
            render: (params)=>{
                const col = params.data;
                return $acw62.createElement(CellWrapper, null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                    checked: isGroupableColumn(col.field),
                    onChange: (groupable)=>{
                        groupable ? setGroupableColumn(col.field) : setUngroupableColumn(col.field);
                    }
                }));
            }
        },
        filterable: {
            renderMenuIcon: false,
            header: $acw62.createElement(HeaderWithCheckbox, {
                label: "Filterable",
                checked: isAllFilterableColumns() ? true : isNoneFilterableColumns() ? false : null,
                onChange: (allFilterable)=>{
                    if (allFilterable) setAllFilterable();
                    else setAllUnfilterable();
                }
            }),
            render: (params)=>{
                const col = params.data;
                return $acw62.createElement(CellWrapper, null, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                    checked: isFilterableColumn(col.field),
                    onChange: (filterable)=>{
                        filterable ? setFilterableColumn(col.field) : setUnFilterableColumn(col.field);
                    }
                }));
            }
        }
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('twa:p-2 twa:h-full', theme)
    }, $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
        data: data,
        primaryKey: "colId"
    }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
        columnTypes: {
            default: {
                defaultFlex: 1,
                align: 'center',
                defaultSortable: false
            }
        },
        rowHeight: 40,
        columnHeaderHeight: 60,
        headerOptions: {
            alwaysReserveSpaceForSortIcon: false
        },
        domProps: $65d7d9bc65a9124f$var$tableDOMProps,
        columns: columnsMap
    })));
};
function $65d7d9bc65a9124f$var$areEqual() {
    /**
     * Make the ColumnList not render on subsequent prop changes
     * in order to boost performance
     */ return true;
}
var $65d7d9bc65a9124f$export$2e2bcd8739ae039 = $acw62.memo($65d7d9bc65a9124f$var$ColumnsList, $65d7d9bc65a9124f$var$areEqual);


const $eef8e7c812b5f05f$export$50938231d516ff40 = (props)=>{
    let theme = 'light';
    if (typeof props.adaptableConfig.adaptableOptions.initialState === 'object' && props.adaptableConfig.adaptableOptions.initialState.Theme?.CurrentTheme) theme = props.adaptableConfig.adaptableOptions.initialState.Theme.CurrentTheme;
    return $acw62.createElement((0, $65d7d9bc65a9124f$export$2e2bcd8739ae039), {
        theme: theme,
        handle: props.columnsHandle,
        onValidityChange: (valid)=>{
            props.setPrimaryKeyIsNotSelected(valid);
        },
        selectedColumns: props.selectedColumns,
        onChange: props.onColumnChange,
        onSelectionChange: props.onSelectionChange,
        columns: props.adaptableConfig.gridOptions?.columnDefs
    });
};



var $acw62 = parcelRequire("acw62");




const $b738949de4496db5$var$GridOptionsForm = (props)=>{
    let { gridOptions: gridOptions } = props;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), null, "Grid Options"), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:m-2",
        columns: [
            {
                name: 'children'
            },
            {
                name: 'label',
                style: {
                    textAlign: 'start'
                }
            }
        ]
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Enable Cell Selection"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: !!gridOptions.cellSelection,
        onChange: (enableCellSelection)=>{
            gridOptions = {
                ...gridOptions,
                cellSelection: enableCellSelection
            };
            props.onChangedGridOptions(gridOptions);
        }
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Show Filter Bar"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: gridOptions.defaultColDef?.floatingFilter,
        onChange: (floatingFilter)=>{
            gridOptions = {
                ...gridOptions,
                defaultColDef: {
                    floatingFilter: floatingFilter
                }
            };
            props.onChangedGridOptions(gridOptions);
        }
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Suppress Column Virtualisation"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: gridOptions.suppressColumnVirtualisation,
        onChange: (suppressColumnVirtualisation)=>{
            gridOptions = {
                ...gridOptions,
                suppressColumnVirtualisation: suppressColumnVirtualisation
            };
            props.onChangedGridOptions(gridOptions);
        }
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Show Column Menu Button"
    }, $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
        checked: gridOptions.suppressMenuHide,
        onChange: (suppressMenuHide)=>{
            gridOptions = {
                ...gridOptions,
                suppressMenuHide: suppressMenuHide
            };
            props.onChangedGridOptions(gridOptions);
        }
    }))));
};
var $b738949de4496db5$export$2e2bcd8739ae039 = $b738949de4496db5$var$GridOptionsForm;



var $acw62 = parcelRequire("acw62");







const $7361f716f1bf9859$var$ALL_ENTITLEMENTS_MODULES = (0, $c75adffdf90b3d81$export$5d1c20aca6593e39);
const $7361f716f1bf9859$var$tableDOMProps = {
    style: {
        height: '100%',
        minWidth: '10rem',
        minHeight: 600
    }
};
const $7361f716f1bf9859$var$columnTypes = {
    default: {
        defaultFlex: 1,
        align: 'center',
        defaultSortable: false
    }
};
const $7361f716f1bf9859$var$headerOptions = {
    alwaysReserveSpaceForSortIcon: false
};
const $7361f716f1bf9859$var$EntitlementsListForm = (props)=>{
    let abOptions = props.adaptableOptions;
    const entitlements = abOptions?.entitlementOptions?.moduleEntitlements ?? [];
    if (typeof entitlements === 'function') return $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mt-2"
    }, "Entitlements cannot be customized, they are handled by a custom function.");
    const entitlementsMap = $acw62.useMemo(()=>{
        return entitlements.reduce((acc, entitlement)=>{
            acc[entitlement.adaptableModule] = entitlement.accessLevel;
            return acc;
        }, {});
    }, [
        abOptions?.entitlementOptions
    ]);
    const handleOnChange = $acw62.useCallback((module, accessLevel)=>{
        let newEntitlements = entitlements;
        // change
        if (entitlementsMap[module]) newEntitlements = newEntitlements.map((entitlement)=>{
            if (entitlement.adaptableModule === module) entitlement.accessLevel = accessLevel;
            return entitlement;
        });
        else // new
        newEntitlements = [
            ...newEntitlements,
            {
                adaptableModule: module,
                accessLevel: accessLevel
            }
        ];
        props.onChangedAptableOptions({
            ...abOptions,
            entitlementOptions: {
                ...abOptions.entitlementOptions,
                moduleEntitlements: newEntitlements
            }
        });
    }, [
        abOptions?.entitlementOptions
    ]);
    if (typeof entitlements === 'function') return $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mb-2"
    }, "Entitlements cannot be customized, they are handled by a custom function.");
    const columnsMap = {
        name: {
            header: 'Module Name',
            align: 'start',
            renderValue: (params)=>{
                return $acw62.createElement($acw62.Fragment, null, params.data.name);
            }
        },
        full: {
            header: 'Full',
            render: (params)=>{
                const module = params.data.name;
                const accessLevel = entitlementsMap[module];
                return $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
                    onClick: ()=>handleOnChange(module, 'Full'),
                    checked: accessLevel === 'Full'
                });
            }
        },
        readonly: {
            header: 'Read Only',
            render: (params)=>{
                const module = params.data.name;
                const accessLevel = entitlementsMap[module];
                return $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
                    onClick: ()=>handleOnChange(module, 'ReadOnly'),
                    checked: accessLevel === 'ReadOnly'
                });
            }
        },
        hidden: {
            header: 'Hidden',
            render: (params)=>{
                const module = params.data.name;
                const accessLevel = entitlementsMap[module];
                return $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
                    onClick: ()=>handleOnChange(module, 'Hidden'),
                    checked: accessLevel === 'Hidden'
                });
            }
        }
    };
    const data = $7361f716f1bf9859$var$ALL_ENTITLEMENTS_MODULES.map((module)=>({
            name: (0, $42e863194fcb493f$export$d4f7ec57c355ff81)[module]
        }));
    let theme = 'light';
    if (typeof props.adaptableOptions.initialState === 'object' && props.adaptableOptions.initialState.Theme?.CurrentTheme) theme = props.adaptableOptions.initialState.Theme.CurrentTheme;
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: `${theme} twa:flex-1 twa:h-full`
    }, $acw62.createElement((0, $88ab1a78ec8ca4b4$export$accd73d198d77d2f), {
        data: data,
        primaryKey: "name"
    }, $acw62.createElement((0, $81462d2b980242cc$export$ce138889c9c682e8), {
        columnTypes: $7361f716f1bf9859$var$columnTypes,
        headerOptions: $7361f716f1bf9859$var$headerOptions,
        domProps: $7361f716f1bf9859$var$tableDOMProps,
        columns: columnsMap
    })));
};
const $7361f716f1bf9859$var$DefaultEntitlementForm = (props)=>{
    const abOptions = props.adaptableOptions;
    const entitlementOptions = props.adaptableOptions?.entitlementOptions;
    const defaultEntitlement = entitlementOptions?.defaultAccessLevel;
    if (typeof defaultEntitlement === 'function') return $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mb-2"
    }, "Default Entitlement is controlled by a custom function");
    const handleDefaultEntitlementChange = $acw62.useCallback((accessLevel)=>{
        props.onChangedAptableOptions({
            ...abOptions,
            entitlementOptions: {
                ...abOptions.entitlementOptions,
                defaultAccessLevel: accessLevel
            }
        });
    }, [
        abOptions?.entitlementOptions?.defaultAccessLevel
    ]);
    return $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:mb-2"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Default Entitlement:"
    }, $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        onClick: ()=>handleDefaultEntitlementChange('Full'),
        checked: defaultEntitlement === 'Full',
        className: "twa:mr-3"
    }, "Visible"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        onClick: ()=>handleDefaultEntitlementChange('ReadOnly'),
        checked: defaultEntitlement === 'ReadOnly',
        className: "twa:mr-3"
    }, "Read Only"), $acw62.createElement((0, $d6ef3253c01d4163$export$2e2bcd8739ae039), {
        onClick: ()=>handleDefaultEntitlementChange('Hidden'),
        checked: defaultEntitlement === 'Hidden'
    }, "Hidden")));
};
const $7361f716f1bf9859$var$EntitlementsForm = (props)=>{
    let abOptions = props.adaptableOptions;
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:p-2 twa:h-full"
    }, $acw62.createElement($7361f716f1bf9859$var$DefaultEntitlementForm, {
        ...props
    }), $acw62.createElement($7361f716f1bf9859$var$EntitlementsListForm, {
        ...props
    }));
};
var $7361f716f1bf9859$export$2e2bcd8739ae039 = $7361f716f1bf9859$var$EntitlementsForm;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





var $9OAZF = parcelRequire("9OAZF");

const $52d5c0d1d203b2b6$var$ALL_SIDEBAR_OPTIONS = [
    'columns',
    'filters',
    'adaptable'
];
const $52d5c0d1d203b2b6$var$prepareSidebarDef = (sideBar)=>{
    sideBar;
    if (typeof sideBar === 'boolean') sideBar = {
        toolPanels: $52d5c0d1d203b2b6$var$ALL_SIDEBAR_OPTIONS
    };
    if (typeof sideBar === 'string') sideBar = {
        toolPanels: [
            sideBar
        ]
    };
    if (Array.isArray(sideBar)) sideBar = {
        toolPanels: sideBar
    };
    return sideBar ?? {
        toolPanels: []
    };
};
const $52d5c0d1d203b2b6$var$isSidebarChecked = (sideBar, panelName)=>{
    return (sideBar?.toolPanels ?? []).some((panel)=>{
        const panelId = typeof panel === 'string' ? panel : panel.id;
        return panelId === panelName;
    });
};
const $52d5c0d1d203b2b6$export$69a61153f4701c48 = (props)=>{
    const { gridOptions: gridOptions, onChange: onChange } = props;
    const sideBar = $52d5c0d1d203b2b6$var$prepareSidebarDef(gridOptions.sideBar);
    const renderSidebarCheckbox = (sidebarName)=>{
        return $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
            className: "twa:mr-3",
            key: sidebarName,
            checked: $52d5c0d1d203b2b6$var$isSidebarChecked(sideBar, sidebarName),
            onChange: (check)=>handleToolpanelsChange(sidebarName, check)
        }, (0, $9OAZF.default).Humanize(sidebarName));
    };
    const handleToolpanelsChange = (panelName, check)=>{
        let newPanels = sideBar?.toolPanels ?? [];
        if (check) newPanels = [
            ...newPanels,
            panelName
        ];
        else newPanels = newPanels.filter((panel)=>{
            const panelId = typeof panel === 'string' ? panel : panel.id;
            return panelId !== panelName;
        });
        let hiddenByDefault = sideBar.hiddenByDefault ?? false;
        if (newPanels.length === 0) hiddenByDefault = true;
        const newGridOptions = {
            ...gridOptions,
            sideBar: {
                ...sideBar,
                toolPanels: newPanels,
                hiddenByDefault: hiddenByDefault
            }
        };
        props.onChange(newGridOptions);
    };
    let sidebarPosition = sideBar?.position ?? 'right';
    const handleSidebarPositionChange = (position)=>{
        const newGridOptions = {
            ...gridOptions,
            sideBar: {
                ...sideBar,
                position: position
            }
        };
        props.onChange(newGridOptions);
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), null, "Tool Panels"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:m-2"
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:mb-2"
    }, $52d5c0d1d203b2b6$var$ALL_SIDEBAR_OPTIONS.map(renderSidebarCheckbox)), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        columns: [
            {
                name: 'label'
            },
            {
                name: 'children'
            }
        ]
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Position"
    }, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        columns: [
            'label'
        ],
        items: [
            {
                label: 'Left',
                onClick: ()=>handleSidebarPositionChange('left')
            },
            {
                label: 'Right',
                onClick: ()=>handleSidebarPositionChange('right')
            }
        ]
    }, sidebarPosition === 'left' ? 'Left' : 'Right')))));
};



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");


const $4f066e5eb9600baa$export$fbe934559868e839 = (props)=>$acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        ...props,
        className: (0, $a59241ddd28bd42d$export$b4660bb6000dfbc9)('ab-NocodeWizardFormBox twa:p-2 twa:mb-2', props.className)
    });



const $4643e4c413e5f953$export$c644fefd1e5f2317 = (props)=>{
    const allPanels = props.gridOptions?.statusBar?.statusPanels ?? [];
    const panelIdtoPanel = (panelsIds, align)=>panelsIds.map((panelId)=>{
            const previousItem = allPanels.find((panel)=>panel.key === panelId || panel.statusPanel === panelId);
            if (previousItem) return {
                ...previousItem,
                align: align
            };
            else {
                const newPanel = {
                    statusPanel: panelId,
                    align: align
                };
                return newPanel;
            }
        });
    const leftPanels = allPanels.filter((panel)=>!panel?.align || panel.align === 'left');
    const centerPanels = allPanels.filter((panel)=>panel.align === 'center');
    const rightPanels = allPanels.filter((panel)=>panel.align === 'right');
    const handleTabChange = (tabs)=>{
        const leftPanels = panelIdtoPanel(tabs[0].Items, 'left');
        const centerPanels = panelIdtoPanel(tabs[1].Items, 'center');
        const rightPanels = panelIdtoPanel(tabs[2].Items, 'right');
        const newStatusbarPanels = [
            ...leftPanels,
            ...centerPanels,
            ...rightPanels
        ];
        props.onChange({
            ...props.gridOptions,
            statusBar: {
                ...props.gridOptions.statusBar,
                statusPanels: newStatusbarPanels
            }
        });
    };
    const disabled = false;
    const panelToTabItemId = (panel)=>panel.key ?? panel.statusPanel;
    const tabs = [
        {
            Name: 'Left',
            Items: leftPanels.map(panelToTabItemId)
        },
        {
            Name: 'Center',
            Items: centerPanels.map(panelToTabItemId)
        },
        {
            Name: 'Right',
            Items: rightPanels.map(panelToTabItemId)
        }
    ];
    const allOptions = [
        {
            Id: 'agTotalRowCountComponent',
            Title: 'Row Count'
        },
        {
            Id: 'agTotalAndFilteredRowCountComponent',
            Title: 'Totals and Filtered Row Count'
        },
        {
            Id: 'agFilteredRowCountComponent',
            Title: 'Filtered Row Count'
        },
        {
            Id: 'agSelectedRowCountComponent',
            Title: 'Selected Row Count'
        },
        {
            Id: 'agAggregationComponent',
            Title: 'Aggregation'
        }
    ];
    const availableItems = allOptions;
    const [adaptablePanelTitle, setAdaptablePanelTitle] = $acw62.useState('');
    const [adaptablePanelAlign, setAdaptablePanelAlign] = $acw62.useState('left');
    const isAdaptablePanelTitleAvailable = !allPanels.some((panel)=>panel.key === adaptablePanelTitle);
    const alignOptions = [
        {
            onClick: ()=>setAdaptablePanelAlign('left'),
            value: 'left',
            label: 'Left'
        },
        {
            onClick: ()=>setAdaptablePanelAlign('center'),
            value: 'center',
            label: 'Center'
        },
        {
            onClick: ()=>setAdaptablePanelAlign('right'),
            value: 'right',
            label: 'Right'
        }
    ];
    const handleNewAdaptablePanel = ()=>{
        const newAdaptablePanel = {
            statusPanel: 'AdaptableStatusPanel',
            align: adaptablePanelAlign,
            key: adaptablePanelTitle
        };
        const newStatusbarPanels = [
            ...allPanels,
            newAdaptablePanel
        ];
        setAdaptablePanelTitle('');
        setAdaptablePanelAlign('left');
        props.onChange({
            ...props.gridOptions,
            statusBar: {
                ...props.gridOptions.statusBar,
                statusPanels: newStatusbarPanels
            }
        });
    };
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), null, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), null, "Status Bar"), $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $4f066e5eb9600baa$export$fbe934559868e839), null, $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        as: "b"
    }, "Create Adaptable Statusbar Panel"), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:mt-2"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Panel Name"
    }, $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
        value: adaptablePanelTitle,
        placeholder: 'Adaptable Panel Name',
        onChange: (event)=>setAdaptablePanelTitle(event.target.value)
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Align"
    }, $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
        columns: [
            'label'
        ],
        items: alignOptions
    }, alignOptions.find((option)=>option.value === adaptablePanelAlign)?.label)), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        disabled: !isAdaptablePanelTitleAvailable,
        onClick: handleNewAdaptablePanel,
        icon: "plus",
        variant: "raised"
    }, "Add"), !isAdaptablePanelTitleAvailable && $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mt-2 twa:text-error"
    }, "Adaptable panel name must be unique.")))), $acw62.createElement((0, $9e67de7320a14ea2$export$b4ba4f0359f0dde4), {
        permittedActions: {
            createTab: false,
            dragAndDropTab: false,
            deleteTab: false,
            editTabName: false
        },
        onTabsChange: handleTabChange,
        disabled: disabled,
        tabs: tabs,
        availableItems: availableItems,
        tabsTitle: 'Status Bar Panels',
        unusedPanelTitle: "Ag Grid Status Bar Panels",
        dragItemText: "Drag into a Status Bar Panel below"
    })));
};



const $3540602897eb5870$export$f1c38b2088a62a40 = (props)=>{
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c), null, $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Tool Panel"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Tab, null, "Status Bar"), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $52d5c0d1d203b2b6$export$69a61153f4701c48), {
        gridOptions: props.gridOptions,
        onChange: props.onChangedGridOptions
    })), $acw62.createElement((0, $33d60c54c2c535f0$export$b2539bed5023c21c).Content, null, $acw62.createElement((0, $4643e4c413e5f953$export$c644fefd1e5f2317), {
        gridOptions: props.gridOptions,
        onChange: props.onChangedGridOptions
    })), ' '));
};



var $acw62 = parcelRequire("acw62");





var $9OAZF = parcelRequire("9OAZF");



const $41b9f9246b634931$var$SUPPORTED_PRIMITEVE_TYPES = [
    's',
    'n',
    'b'
];
const $41b9f9246b634931$var$OptionInput = (props)=>{
    const { name: name, defaultValue: defaultValue, value: value, description: description, uiLabel: uiLabel } = props.option;
    const label = uiLabel ?? (0, $9OAZF.default).Humanize(name);
    let input = $acw62.createElement($acw62.Fragment, null);
    const info = $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:ml-2"
    }, $acw62.createElement((0, $e0f4084337386050$export$9d50a40845f09423), {
        headerText: null,
        bodyText: [
            description
        ]
    }));
    const handleInputChange = (event)=>props.onChange({
            ...props.option,
            value: event.currentTarget.value
        });
    const handleCheckboxChange = (checked)=>props.onChange({
            ...props.option,
            value: checked
        });
    // option is mutated to acomodate complex types overrides
    const option = {
        ...props.option
    };
    const isOptionNonHomogenusUnion = (option)=>{
        const isUnion = option.kind.includes('|');
        return isUnion && option.kind.split('|').some((unionEl)=>!/['"]/.test(unionEl));
    };
    if (isOptionNonHomogenusUnion(option)) {
        // pick the first type
        const newKind = option.kind.split('|').find((unionEl)=>$41b9f9246b634931$var$SUPPORTED_PRIMITEVE_TYPES.includes(unionEl.trim())).trim();
        if (newKind) option.kind = newKind;
    }
    const inputProps = {
        value: value ?? defaultValue,
        minWidth: 200,
        fontSize: 3,
        mr: 2
    };
    if (option.kind.includes('|')) {
        const options = option.kind.split('|').map((str)=>str.trim().replace(/['"]/g, '')).map((str)=>({
                label: (0, $9OAZF.default).Humanize(str),
                onClick: ()=>props.onChange({
                        ...option,
                        value: str
                    })
            }));
        input = $acw62.createElement((0, $3c0be5e51ee36e80$export$2e2bcd8739ae039), {
            ...inputProps,
            columns: [
                'label'
            ],
            items: options
        }, (0, $9OAZF.default).Humanize(value));
    } else switch(option.kind){
        case 'n':
            input = $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
                type: "number",
                onChange: handleInputChange,
                ...inputProps
            });
            break;
        case 's':
            input = $acw62.createElement((0, $9e4562887d5c909d$export$2e2bcd8739ae039), {
                type: "text",
                onChange: handleInputChange,
                ...inputProps
            });
            break;
        case 'b':
            input = $acw62.createElement((0, $40d6849704e90728$export$ea5f704b89d806f6), {
                onChange: handleCheckboxChange,
                checked: Boolean(value),
                type: "date"
            }, label);
            break;
    }
    let content = $acw62.createElement($acw62.Fragment, null, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center",
        className: "twa:min-w-[250px]"
    }, label, " ", info), input);
    if (option.kind === 'b') content = $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        alignItems: "center"
    }, input, " ", info);
    return $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:mb-2 twa:pl-1"
    }, content);
};
const $41b9f9246b634931$var$OptionsSection = (props)=>{
    if (!props.options.length) return $acw62.createElement($acw62.Fragment, null);
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:mb-2"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mb-2"
    }, props.name ?? props.id), props.options.map((option, index)=>$acw62.createElement($41b9f9246b634931$var$OptionInput, {
            key: index,
            option: option,
            onChange: props.onChange
        })));
};
const $41b9f9246b634931$export$f1a91d664fe287c8 = (props)=>{
    const nocodeOptions = $acw62.useMemo(()=>{
        const metamodelService = new (0, $ec66a350fedeed6e$export$15a16ddbf1f39b24)(()=>props.adaptableOptions);
        return [
            ...metamodelService.getGridInfoNoCodeOptions()
        ];
    }, [
        props.adaptableOptions
    ]);
    const handleOptionChange = (sectionName)=>(option)=>{
            const adaptableOptions = {
                ...props.adaptableOptions
            };
            if (sectionName === 'baseOptions') // @ts-ignore
            adaptableOptions[option.name] = option.value;
            else // @ts-ignore
            adaptableOptions[sectionName] = {
                // @ts-ignore
                ...adaptableOptions[sectionName],
                [option.name]: option.value
            };
            props.onChangedAdaptableOptions(adaptableOptions);
        };
    return $acw62.createElement((0, $82c87f52da9ba110$export$e71c4d32a2263218), {
        className: "twa:p-2"
    }, nocodeOptions.map(([sectionName, { containerLabel: containerLabel, items: items }])=>{
        return $acw62.createElement($41b9f9246b634931$var$OptionsSection, {
            onChange: handleOptionChange(sectionName),
            key: sectionName,
            id: sectionName,
            name: containerLabel,
            options: items
        });
    }));
};



const $7ab548183f6300fe$export$8869c4afb4308f87 = (props)=>{
    const [isPrimaryKeySelected, setIsValid] = $acw62.useState(true);
    const [adaptableConfig, setAdaptableConfig] = (0, $acw62.useState)(()=>{
        const gridOptionDefaults = {
            sideBar: {
                toolPanels: [
                    'columns',
                    'filters',
                    'adaptable'
                ]
            }
        };
        const gridOptions = {
            ...gridOptionDefaults,
            ...props.adaptableConfig.gridOptions
        };
        const adaptableOptions = (0, $b7240075c75a7844$export$38d7e410c90a5f7e)(props.adaptableConfig.adaptableOptions);
        return {
            gridOptions: gridOptions,
            adaptableOptions: adaptableOptions
        };
    });
    const [selectedColumns, setSelectedColumns] = (0, $acw62.useState)(()=>{
        return props.adaptableConfig.gridOptions?.columnDefs?.reduce((acc, col)=>{
            acc[col.field] = true;
            return acc;
        }, {});
    });
    const columnsHandle = $acw62.useRef(null);
    const handleFinish = ()=>{
        const newAdaptableOptions = {
            ...adaptableConfig.adaptableOptions
        };
        const newGridOptions = {
            ...adaptableConfig.gridOptions
        };
        if (columnsHandle.current) {
            adaptableConfig.gridOptions.columnDefs = columnsHandle.current.getColumns().map((column)=>{
                const newColumn = {
                    ...column,
                    headerName: column.caption || (0, $9OAZF.default).Humanize(column.field)
                };
                delete newColumn.caption;
                return newColumn;
            });
            const columnDefs = adaptableConfig.gridOptions.columnDefs;
            // handle the layout creation
            let Layouts = newAdaptableOptions.initialState?.Layout?.Layouts || [];
            const NewLayout = {
                TableColumns: columnDefs.map((col)=>col.colId ?? col.field),
                Name: 'Default Layout'
            };
            let currentLayoutName = NewLayout.Name;
            let found = false;
            if (!Layouts.length) // no layouts, make this the only one
            Layouts = [
                NewLayout
            ];
            else {
                Layouts = Layouts.map((layout)=>{
                    if (found) return layout;
                    if (layout.TableColumns?.length === 0) {
                        // when finding the first empty layout
                        // set its column to be those of the new layout
                        found = true;
                        // and grab the name so we can put it in the Layout.CurrentLayout state
                        currentLayoutName = layout.Name;
                        layout = {
                            ...layout
                        };
                        layout.TableColumns = NewLayout.TableColumns;
                    }
                    return layout;
                });
                if (!found) Layouts.push(NewLayout);
            }
            newAdaptableOptions.initialState = {
                ...newAdaptableOptions.initialState,
                Layout: {
                    ...newAdaptableOptions.initialState.Layout,
                    Layouts: Layouts,
                    CurrentLayout: currentLayoutName
                }
            };
            newAdaptableOptions.primaryKey = columnsHandle.current.getPrimaryKey();
        }
        const newAdaptableConfig = {
            adaptableOptions: newAdaptableOptions,
            gridOptions: newGridOptions
        };
        setAdaptableConfig(newAdaptableConfig);
        props.onFinish(newAdaptableConfig);
    };
    const handlePrimaryKeyColumnIsNotSelected = $acw62.useCallback((newIsValid)=>{
        setIsValid(newIsValid);
    }, []);
    const handleColumnsChange = $acw62.useCallback((columns)=>{
        setAdaptableConfig((adaptableConfig)=>({
                ...adaptableConfig,
                gridOptions: {
                    ...adaptableConfig.gridOptions,
                    columnDefs: columns
                }
            }));
    }, []);
    const handleColumnSelectionChange = $acw62.useCallback((col, flag)=>{
        setSelectedColumns((selectedColumns)=>{
            const newSelectedColumns = selectedColumns ?? {};
            newSelectedColumns[col.field] = flag;
            return newSelectedColumns;
        });
    }, []);
    const handleAdaptableOptionsChange = $acw62.useCallback((adaptableOptions)=>{
        setAdaptableConfig((adaptableConfig)=>({
                ...adaptableConfig,
                adaptableOptions: adaptableOptions
            }));
    }, []);
    const handleGridOptionsChange = $acw62.useCallback((gridOptions)=>{
        setAdaptableConfig((adaptableConfig)=>({
                ...adaptableConfig,
                gridOptions: gridOptions
            }));
    }, []);
    let sections = [
        {
            title: 'Columns',
            details: 'Configure Columns',
            isValid: ()=>{
                if (!isPrimaryKeySelected) return 'Primary key column must be included';
                return true;
            },
            render: ()=>$acw62.createElement((0, $eef8e7c812b5f05f$export$50938231d516ff40), {
                    adaptableConfig: adaptableConfig,
                    setPrimaryKeyIsNotSelected: handlePrimaryKeyColumnIsNotSelected,
                    onChange: setAdaptableConfig,
                    selectedColumns: selectedColumns,
                    onSelectionChange: handleColumnSelectionChange,
                    onColumnChange: handleColumnsChange,
                    columnsHandle: columnsHandle
                })
        },
        {
            title: 'AdapTable Options',
            details: 'Configure Adaptable Options',
            isValid: ()=>adaptableConfig.adaptableOptions.adaptableId ? true : 'Adaptable ID is required',
            render: ()=>$acw62.createElement((0, $41b9f9246b634931$export$f1a91d664fe287c8), {
                    adaptableOptions: adaptableConfig.adaptableOptions,
                    onChangedAdaptableOptions: handleAdaptableOptionsChange
                })
        },
        {
            title: 'AG Grid Options',
            details: 'Configure AG Grid Options',
            render: ()=>$acw62.createElement((0, $b738949de4496db5$export$2e2bcd8739ae039), {
                    gridOptions: adaptableConfig.gridOptions,
                    onChangedGridOptions: handleGridOptionsChange
                })
        },
        {
            title: 'UI Elements',
            details: 'Configure UI Elements',
            render: ()=>$acw62.createElement((0, $3540602897eb5870$export$f1c38b2088a62a40), {
                    adaptableOptions: adaptableConfig.adaptableOptions,
                    gridOptions: adaptableConfig.gridOptions,
                    onChangedAdaptableOptions: handleAdaptableOptionsChange,
                    onChangedGridOptions: handleGridOptionsChange
                })
        },
        {
            title: 'Entitlements',
            details: 'Configure Entitlements',
            render: ()=>$acw62.createElement((0, $7361f716f1bf9859$export$2e2bcd8739ae039), {
                    adaptableOptions: adaptableConfig.adaptableOptions,
                    onChangedAptableOptions: handleAdaptableOptionsChange
                })
        }
    ].filter(Boolean);
    if (props.startSections) sections = [
        ...props.startSections.map((section)=>{
            return {
                title: section.title,
                isValid: section.isValid,
                isVisible: section.isVisible,
                render: ()=>{
                    return section.render(adaptableConfig, setAdaptableConfig, setSelectedColumns);
                }
            };
        }),
        ...sections
    ];
    return $acw62.createElement((0, $16482cb6c18088bf$export$6d2e999e122179b5), {
        data: adaptableConfig,
        name: "Configure",
        defaultCurrentSectionName: 'default section name',
        onHide: ()=>null,
        onFinish: handleFinish,
        sections: sections
    });
};


var $9e83912843cff55c$export$2e2bcd8739ae039 = (0, $7ab548183f6300fe$export$8869c4afb4308f87);



const $cde14bf89a4289fe$export$6694b9caef900eb6 = (dataSourceInfo)=>{
    if (!dataSourceInfo || !Array.isArray(dataSourceInfo.columns)) throw `We can't find any columns in your configuration`;
    if (!dataSourceInfo.columns.length) throw 'You should have at least one column';
    const allStringColumns = dataSourceInfo.columns.reduce((acc, col)=>{
        if (!col || typeof col !== 'string') return false;
        return acc;
    }, true);
    if (!allStringColumns) throw `Some of your columns are not strings`;
    if (!Array.isArray(dataSourceInfo.data)) throw `We can't find the data array in your configuration`;
    return true;
};



const $4c155c50bc4f18ba$export$d4c72bab9d6cc13a = {
    dropped: false
};
const $4c155c50bc4f18ba$export$1650419e431d3ba3 = (state, action)=>{
    if (action.type === 'DROPPED') return {
        ...state,
        adaptableOptions: action.payload.adaptableOptions,
        gridOptions: action.payload.gridOptions,
        dropped: true,
        error: null
    };
    if (action.type === 'ERROR') return {
        ...state,
        dropped: false,
        error: action.payload
    };
    if (action.type === 'CANCEL') return {
        ...state,
        error: null,
        dropped: false
    };
    return state;
};
const $4c155c50bc4f18ba$export$c6a37f46d6629cf2 = (props)=>{
    const [state, dispatch] = (0, $acw62.useReducer)($4c155c50bc4f18ba$export$1650419e431d3ba3, {
        ...$4c155c50bc4f18ba$export$d4c72bab9d6cc13a,
        adaptableOptions: props.adaptableOptions,
        gridOptions: props.gridOptions
    });
    const [droppableKey, setDroppableKey] = (0, $acw62.useState)(Date.now());
    const [isDataLoading, setIsDataLoading] = (0, $acw62.useState)(false);
    const handleDataSource = (array, file)=>{
        const dataSourceInfo = (props.prepareData || (0, $c4631e67ee172a41$export$7d8e66552092b12e))(array, file);
        try {
            (0, $cde14bf89a4289fe$export$6694b9caef900eb6)(dataSourceInfo);
        } catch (err) {
            return dispatch({
                type: 'ERROR',
                payload: `Invalid adaptable configuration - ${err}`
            });
        }
        const gridOptions = (0, $c4631e67ee172a41$export$c6cc045f65d3c987)(dataSourceInfo, props.gridOptions);
        const adaptableOptions = {
            ...props.adaptableOptions
        };
        adaptableOptions.adaptableId = adaptableOptions.adaptableId || (file ? file.name : '');
        if (dataSourceInfo.primaryKey) adaptableOptions.primaryKey = dataSourceInfo.primaryKey;
        const shouldShowWizard = props.fetchData ? Boolean(props.showFetchDataWizard) : true;
        if (shouldShowWizard) dispatch({
            type: 'DROPPED',
            payload: {
                adaptableOptions: adaptableOptions,
                gridOptions: gridOptions
            }
        });
        else props.onInit(adaptableOptions, gridOptions);
    };
    let wizard;
    if (props.skipToWizard || state.dropped) wizard = $acw62.createElement((0, $9e83912843cff55c$export$2e2bcd8739ae039), {
        startSections: props.startSections,
        adaptableConfig: {
            adaptableOptions: state.adaptableOptions,
            gridOptions: state.gridOptions
        },
        onCancel: ()=>{
            // change the file droppable component key
            // so it's remounted and it's in the initial state
            setDroppableKey(Date.now());
            dispatch({
                type: 'CANCEL'
            });
        },
        onFinish: (adaptableConfig)=>{
            props.onInit(adaptableConfig.adaptableOptions, adaptableConfig.gridOptions);
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (props.fetchData) {
            setIsDataLoading(true);
            props.fetchData().then((data)=>{
                handleDataSource(data);
                setIsDataLoading(false);
            });
        }
    }, []);
    const ddEnabled = props.ddEnabled ?? !props.fetchData;
    return $acw62.createElement($acw62.Fragment, null, ddEnabled && $acw62.createElement((0, $ecc63bb8d4bdb327$export$2e2bcd8739ae039), {
        key: droppableKey,
        className: 'ab-NocodeWizard',
        toJSON: props.fileContentsToJSON,
        readFile: props.readFile,
        fileAccept: props.fileAccept,
        helpText: props.helpText,
        message: state.error,
        defaultText: props.defaultActionMessage,
        dragOverText: props.dragOverActionMessage,
        loadingText: props.loadingMessage,
        onDropSuccess: handleDataSource
    }), isDataLoading && $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: 'ab-NocodeWizard',
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column"
    }, props.loadingMessage || 'Loading ...'), wizard);
};


const $66da0392520b4d26$var$AdaptableWizardView = (props)=>$acw62.createElement((0, $4c155c50bc4f18ba$export$c6a37f46d6629cf2), {
        ...props
    });
var $66da0392520b4d26$export$2e2bcd8739ae039 = $66da0392520b4d26$var$AdaptableWizardView;



var $9AsCL = parcelRequire("9AsCL");
class $e401474bda52dd99$export$bce2160a81063cd3 {
    /**
     * Initializer for Adaptable
     *
     * @param adaptableOptions the AdaptableOptions
     * @param agGridConfig AG Grid
     * @returns a Promise containing the AdaptableAPI object in order to enable run-time access to Adaptable's properties and functions
     */ static init(adaptableOptions, agGridConfig) {
        if (!agGridConfig?.modules?.length) (0, $10f858c943b30cc8$export$a58502b374804b0f).consoleErrorBase(`No AG Grid modules were provided, thus limiting AdapTables features significantly!\n\nRead further info here:${(0, $53c62e7ff907ad8d$export$1f919f567885fa35)}`);
        return (0, $2c60780b406d81af$export$a19c58cdd10e13f7)._initInternal({
            ...agGridConfig,
            adaptableOptions: adaptableOptions,
            variant: 'vanilla'
        });
    }
}
class $e401474bda52dd99$export$8bb77d35e3bf416b {
    init;
    adaptableOptions;
    extraOptions;
    agGridModules;
    /**
     * @param adaptableOptions
     */ constructor(adaptableOptions, extraOptions = {}, agGridOptions){
        const defaultInit = async ({ gridOptions: gridOptions, adaptableOptions: adaptableOptions, agGridModules: agGridModules })=>{
            return await $e401474bda52dd99$export$bce2160a81063cd3.init(adaptableOptions, {
                gridOptions: gridOptions,
                modules: agGridModules
            });
        };
        this.adaptableOptions = adaptableOptions;
        this.init = extraOptions.onInit || defaultInit;
        this.extraOptions = extraOptions;
        this.agGridModules = [];
        this.render();
    }
    render(container) {
        if (!container) {
            const initContext = {
                adaptableId: this.adaptableOptions?.adaptableId ?? '',
                adaptableStateKey: this.adaptableOptions?.adaptableStateKey ?? '',
                adaptableContext: this.adaptableOptions?.adaptableContext
            };
            container = (0, $9AsCL.resolveContainerElement)(this.adaptableOptions.containerOptions?.adaptableContainer, initContext);
        }
        if (!container) {
            const defaultId = (0, $b7240075c75a7844$export$ae6abdb725d7cdd7)().containerOptions.adaptableContainer || 'adaptable';
            container = document.getElementById(defaultId);
        }
        if (!container) throw new Error('Cannot find container in which to render Adaptable No Code Wizard');
        // this allows people to customize the wizard dimensions & styling
        // when it's visible
        container.classList.add('adaptable--in-wizard');
        const unmount = (0, $11cae39faa17d15e$export$aec53ba866c983c7)($acw62.createElement((0, $66da0392520b4d26$export$2e2bcd8739ae039), {
            adaptableOptions: this.adaptableOptions,
            ...this.extraOptions,
            onInit: (adaptableOptions, gridOptions)=>{
                container.classList.remove('adaptable--in-wizard');
                unmount();
                this.init({
                    adaptableOptions: adaptableOptions,
                    gridOptions: gridOptions,
                    agGridModules: [
                        ...this.agGridModules
                    ]
                });
            }
        }), container);
    }
}




var $7cde26aae0840b1a$export$2e2bcd8739ae039 = (0, $e401474bda52dd99$export$bce2160a81063cd3);
const $7cde26aae0840b1a$export$8bb77d35e3bf416b = (0, $e401474bda52dd99$export$8bb77d35e3bf416b);
const $7cde26aae0840b1a$export$a58502b374804b0f = (0, $10f858c943b30cc8$export$a58502b374804b0f);










var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



const $c05d43e7a7f44e74$var$fillStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
};
const $c05d43e7a7f44e74$var$hostStyle = {
    ...$c05d43e7a7f44e74$var$fillStyle,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
};
const $c05d43e7a7f44e74$var$inputStyle = {
    position: 'relative',
    background: 'transparent',
    boxSizing: 'border-box',
    color: 'currentcolor',
    minWidth: 0,
    outline: 'none',
    textAlign: 'right',
    width: '100%',
    border: 'none',
    boxShadow: 'none',
    paddingRight: '3ch'
};
const $c05d43e7a7f44e74$export$3cb0d60714a01c06 = $acw62.forwardRef(function InternalAdaptablePercentageEditorFn(props, ref) {
    const inputRef = $acw62.useRef(null);
    const focus = ()=>{
        inputRef.current?.focus();
    };
    const [value, setValue] = (0, $c1d95a30df368692$export$2e2bcd8739ae039)(props, 'value', props.defaultValue, {
        onChange: (value)=>{
            if (value !== '' && value == Number(value)) value = Number(value);
            props.onValueChange?.(value);
        }
    });
    $acw62.useImperativeHandle(ref, ()=>{
        return {
            focus: focus,
            setValue: setValue
        };
    });
    const showClear = props.showClearButton && props.emptyValue != null && value != props.emptyValue;
    return $acw62.createElement("div", {
        style: $c05d43e7a7f44e74$var$hostStyle,
        className: "ab-PercentageEditor",
        onKeyDown: (e)=>{
            if (e.key === 'Tab' && showClear && document.activeElement === inputRef.current) e.stopPropagation();
        }
    }, $acw62.createElement((0, $8f18596f06454d86$export$6bf0cd3a219bbade), {
        type: props.type ?? 'number',
        className: "ab-PercentageEditor-Input",
        value: value,
        noArrows: true,
        autoFocus: true,
        onChange: $acw62.useCallback((value)=>{
            setValue(value);
        }, []),
        style: $c05d43e7a7f44e74$var$inputStyle,
        ref: inputRef
    }), showClear ? $acw62.createElement("div", {
        className: "twa:inline-block twa:mx-1",
        onClick: (e)=>{
            if (props.emptyValue != null) {
                setValue(props.emptyValue);
                e.stopPropagation();
                focus();
            }
        },
        onKeyDown: (e)=>{
            if (props.emptyValue != null && e.key === 'Enter') {
                setValue(props.emptyValue);
                e.stopPropagation();
                focus();
            }
        }
    }, $acw62.createElement((0, $124c9aa27215a392$export$f04a61298a47a40f), {
        size: 15,
        name: "close",
        tabIndex: 0
    })) : null, $acw62.createElement("div", {
        style: {
            position: 'absolute',
            right: showClear ? 20 : 0,
            paddingInlineEnd: '0.5ch'
        }
    }, "%"));
});



function $2792726619c1dfdf$export$36d5e0d2b514f546(numberToAbbreviate) {
    let str = '';
    if (numberToAbbreviate >= 1000000000) str = (numberToAbbreviate / 1000000000).toFixed(1) + 'B';
    else if (numberToAbbreviate >= 1000000) str = (numberToAbbreviate / 1000000).toFixed(1) + 'M';
    else if (numberToAbbreviate >= 1000) str = (numberToAbbreviate / 1000).toFixed(1) + 'K';
    else str = numberToAbbreviate.toString();
    return str;
}
function $2792726619c1dfdf$export$f84113e22e60b529(numberToWrap) {
    return ' (' + numberToWrap + ')';
}
function $2792726619c1dfdf$export$788e80b491e4225c(value) {
    // the simple solution does not work
    // return value * 100;
    // needed because 0.12676 * 100 = 12.676000000000002
    // but we dont want that to happen
    // this solution does not handle  -0 correctly
    // also 1267.6 * 100 is 126759.99999999999
    // which is not what we want
    // return parseFloat((value * 100).toFixed(12));
    if (isNaN(value) || !value) return value;
    const valueAsStr = value.toPrecision();
    const separator = Number(1.1).toLocaleString()[1];
    const indexOfSeparator = valueAsStr.indexOf(separator);
    if (indexOfSeparator === -1) return value * 100;
    const [integer, decimal] = valueAsStr.split(separator);
    const num = [
        ...`${integer}${decimal ?? ''}00`
    ];
    num.splice(indexOfSeparator + 2, 0, separator);
    return Number(num.join(''));
}
function $2792726619c1dfdf$export$baff7be7d4683db0(value) {
    // the simple solution does not work
    // return value / 100;
    // needed because 4012.3456/100 = 40.123456000000004
    // but we dont want that to happen
    // this solution does not handle  -0 correctly
    // return parseFloat((value / 100).toFixed(12));
    if (isNaN(value) || !value) return value;
    const isNegative = value < 0;
    if (isNegative) value = -value;
    const valueAsStr = value.toPrecision();
    const separator = Number(1.1).toLocaleString()[1];
    let indexOfSeparator = valueAsStr.indexOf(separator);
    if (indexOfSeparator === -1) indexOfSeparator = 0;
    let [integer = '', decimal] = valueAsStr.split(separator);
    decimal = decimal || '';
    integer = integer.padStart(2, '0');
    const integerArr = [
        ...integer
    ];
    const num = integerArr.slice(0, integerArr.length - 2).join('') + separator + integerArr.slice(-2).join('') + decimal;
    return Number(num) * (isNegative ? -1 : 1);
}
const $2792726619c1dfdf$export$9d1b44f4bc729c5f = {
    abbreviateNumber: $2792726619c1dfdf$export$36d5e0d2b514f546,
    wrapInParentheses: $2792726619c1dfdf$export$f84113e22e60b529,
    timesBy100: $2792726619c1dfdf$export$788e80b491e4225c,
    divideBy100: $2792726619c1dfdf$export$baff7be7d4683db0
};
var $2792726619c1dfdf$export$2e2bcd8739ae039 = $2792726619c1dfdf$export$9d1b44f4bc729c5f;


const $ee0cc06af11297a6$var$defaultValueParser = ({ newValue: newValue, oldValue: _ })=>{
    return newValue;
};
const $ee0cc06af11297a6$var$style = {
    position: 'absolute',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px'
};
const $ee0cc06af11297a6$export$b666bf9b390c82c8 = (0, $acw62.forwardRef)((props, ref)=>{
    const [initialValue] = (0, $acw62.useState)(()=>(0, $2792726619c1dfdf$export$2e2bcd8739ae039).timesBy100((0, $c3d8609e2b1c456b$export$e2d7eaa2ea5b61c4)(props)));
    const valueRef = (0, $acw62.useRef)(initialValue);
    const columnId = props.column.getColId();
    const adaptable = props.context.__adaptable;
    const colValueParser = props.column.getColDef().valueParser;
    const valueParser = typeof colValueParser === 'function' ? colValueParser : $ee0cc06af11297a6$var$defaultValueParser;
    function onValueChange(value) {
        const newValue = valueParser ? valueParser({
            ...props,
            oldValue: props.value,
            newValue: value
        }) : value;
        valueRef.current = newValue;
        props.onValueChange?.((0, $2792726619c1dfdf$export$2e2bcd8739ae039).divideBy100(newValue));
    }
    const editorRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return {
            focusIn () {
                editorRef.current?.focus();
            },
            // the final value to send to the grid, on completion of editing
            getValue () {
                return (0, $2792726619c1dfdf$export$2e2bcd8739ae039).divideBy100(valueRef.current);
            }
        };
    });
    const editorElement = $acw62.createElement((0, $c05d43e7a7f44e74$export$3cb0d60714a01c06), {
        defaultValue: initialValue,
        showClearButton: props.showClearButton ?? true,
        emptyValue: props.emptyValue ?? '',
        onValueChange: onValueChange,
        ref: (editor)=>{
            editorRef.current = editor;
            editor?.focus();
        }
    });
    function onKeyDown(keyDownEvent) {
        adaptable._emit('CellEditorKeyDown', {
            keyDownEvent: keyDownEvent,
            cellValue: valueRef.current,
            columnId: columnId,
            updateValueCallback: (updatedValue)=>{
                editorRef.current.setValue(updatedValue);
            }
        });
    }
    return $acw62.createElement("div", {
        style: $ee0cc06af11297a6$var$style,
        onKeyDown: onKeyDown
    }, (0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)(editorElement, adaptable));
});
$ee0cc06af11297a6$export$b666bf9b390c82c8.displayName = 'AdaptableReactPercentageEditor';
class $ee0cc06af11297a6$export$e39a0f903b93fa3e {
    value;
    columnId;
    el;
    params;
    editor;
    valueParser = $ee0cc06af11297a6$var$defaultValueParser;
    unmountReactRoot;
    init(params) {
        this.value = (0, $c3d8609e2b1c456b$export$e2d7eaa2ea5b61c4)(params);
        this.params = params;
        this.columnId = params.column.getColId();
        const { valueParser: valueParser } = params.column.getColDef();
        if (typeof valueParser === 'function') this.valueParser = valueParser;
        this.el = document.createElement('div');
        Object.keys($ee0cc06af11297a6$var$style).forEach((key)=>{
            //@ts-ignore
            this.el.style[key] = $ee0cc06af11297a6$var$style[key];
        });
    }
    /* Component Editor Lifecycle methods */ // gets called once when grid ready to insert the element
    getGui() {
        return this.el;
    }
    // the final value to send to the grid, on completion of editing
    getValue() {
        return this.value;
    }
    focusIn() {
        this.editor?.focus();
    }
    focusOut() {}
    // after this component has been created and inserted into the grid
    afterGuiAttached() {
        const adaptable = this.params.context.__adaptable;
        const defaultValue = (0, $2792726619c1dfdf$export$2e2bcd8739ae039).timesBy100(this.value);
        const editorElement = $acw62.createElement((0, $c05d43e7a7f44e74$export$3cb0d60714a01c06), {
            defaultValue: defaultValue,
            showClearButton: this.params.showClearButton ?? true,
            emptyValue: this.params.emptyValue ?? '',
            onValueChange: this.onValueChange,
            ref: (editor)=>{
                this.editor = editor;
                editor?.focus();
            }
        });
        this.unmountReactRoot = adaptable.renderReactRoot((0, $675a8d61c71f0ed7$export$4a37e504e8ce5970)(editorElement, adaptable), this.el);
        this.getGui().addEventListener('keydown', (keyDownEvent)=>{
            adaptable._emit('CellEditorKeyDown', {
                keyDownEvent: keyDownEvent,
                cellValue: this.value,
                columnId: this.columnId,
                updateValueCallback: (updatedValue)=>{
                    this.editor.setValue(updatedValue);
                }
            });
        });
    }
    destroy() {
        this.unmountReactRoot?.();
    }
    onValueChange = (value)=>{
        const newValue = this.valueParser ? this.valueParser({
            ...this.params,
            oldValue: this.params.value,
            newValue: value
        }) : value;
        this.value = (0, $2792726619c1dfdf$export$2e2bcd8739ae039).divideBy100(newValue);
    };
}




// @ts-ignore

const $495be9204b6623d2$var$cache = {};
const $495be9204b6623d2$var$getParser = ()=>{
    return 0, $4d4558776f9ec89d$export$2e2bcd8739ae039;
};
function $495be9204b6623d2$export$f901672b588105c0(expression) {
    if ($495be9204b6623d2$var$cache[expression]) return $495be9204b6623d2$var$cache[expression];
    const tokens = [];
    const lexer = $495be9204b6623d2$var$getParser().lexer;
    lexer.setInput(expression);
    while(!lexer.done){
        const id = lexer.lex();
        const location = lexer.matched.length;
        tokens.push({
            type: $495be9204b6623d2$var$getParser().terminals_[id],
            value: lexer.yytext,
            range: [
                location - lexer.yytext.length,
                location
            ]
        });
    }
    // remove eof
    tokens.pop();
    $495be9204b6623d2$var$cache[expression] = tokens;
    return tokens;
}





// Base Types
// Expressions
/**
 * Base class for all AdapTable Plugins
 */ class $7065642dbd07b89e$export$d0a8f6d266c2073a {
    options;
    values;
    pluginId = '';
    constructor(options){
        this.options = options;
        this.values = {};
    }
    registerProperty(name, fn) {
        this.values[name] = fn;
    }
    getProperty(name) {
        return (...args)=>{
            const fn = this.values[name];
            if (fn) return fn(...args);
        };
    }
    rootReducer;
    reduxMiddleware;
    hasProperty(name) {
        return !!this.values[name];
    }
    // plugin lifecycle methods, executed in this exact order
    // wondering if this is better?
    beforeInit(adaptableOptions, // adding a nested object allows plugins to modify gridOptions
    agGridOptions) {}
    afterInitOptions(adaptable, adaptableOptions) {}
    afterInitApi(adaptable, api) {}
    afterInitServices(adaptable) {}
    afterInitialStateLoaded(adaptable) {}
    afterInitModules(adaptable, strategies) {}
    afterInitStore(adaptable) {}
    afterInit(ab) {}
    // hook executed after each layout update (Adaptable.setLayout())
    afterSetLayout(adaptable, layout) {}
    onBeforeStoreEvent(eventName, data, adaptableStore) {}
    onStoreEvent(eventName, data, adaptableStore) {}
    onAdaptableReady(adaptable, adaptableOptions) {}
    interceptSetupColumnProperty;
}




var // TODO remove default export in v23
$abd2ddc91bd0539c$export$2e2bcd8739ae039 = (0, $7cde26aae0840b1a$export$2e2bcd8739ae039);
const $abd2ddc91bd0539c$export$fe4e4969f6492a57 = (0, $2c60780b406d81af$export$a19c58cdd10e13f7);
const $abd2ddc91bd0539c$export$8bb77d35e3bf416b = (0, $7cde26aae0840b1a$export$8bb77d35e3bf416b);
const $abd2ddc91bd0539c$export$51300d9d22693baf = (0, $7cde26aae0840b1a$export$a58502b374804b0f);
const $abd2ddc91bd0539c$export$200bb4a8484e3ac6 = {
    BooleanFunctions: (0, $759293e9f6921c8e$export$7ff6566f3afad7fd),
    ScalarFunctions: (0, $ef36e87b7f218a7a$export$4ed26c334ed58531),
    ObservableFunctions: (0, $7391114ea121c72d$export$e493db97372bc557),
    AggregatedBooleanFunctions: (0, $d33604e1c9cd4b4a$export$e3988a154eaa30a1),
    AggregatedScalarFunctions: (0, $3c4f25bf4245f8cf$export$5ce66781776cba84),
    getAbstractSyntaxTree: (0, $3f77892da2e22ac4$export$3846c6cc0ea43ce0),
    getTokens: (0, $495be9204b6623d2$export$f901672b588105c0)
};
const $abd2ddc91bd0539c$export$a8919b42bcc60037 = {
    /**
     * A column that is used to display an action button or link.
     */ ActionColumn: (0, $b0d14b794bdca4f2$export$bc60d51b21bb9885),
    /**
     * A column that is calculated based on other columns in the table.
     */ CalculatedColumn: (0, $b0d14b794bdca4f2$export$8e5ee678cfc318c5),
    /**
     * A column that is used to display FDC3 data/actions.
     */ Fdc3Column: (0, $b0d14b794bdca4f2$export$aee5eaf013923665),
    /**
     * A column that is NOT stored in the grid but in the state, allowing run-time users to "attach" custom data
     */ FreeTextColumn: (0, $b0d14b794bdca4f2$export$2460c0dec1fc4d43),
    /**
     * A column that is never displayed in the UI, but it's still available programmatically.
     */ HiddenColumn: (0, $b0d14b794bdca4f2$export$24fbfbd19a58a666),
    /**
     * Any column that is used to display Pivot Totals: PivotGrandTotal, PivotGroupTotal or PivotAggregationTotal
     */ PivotAnyTotal: (0, $b0d14b794bdca4f2$export$afddfaff376a8546),
    /**
     * A column that is used to display the Grand Total of ALL Pivot Columns.
     */ PivotGrandTotal: (0, $b0d14b794bdca4f2$export$f744fcf34ea00f2c),
    /**
     * A column that is used to display a single Total for EACH Pivot Column Group.
     */ PivotColumnTotal: (0, $b0d14b794bdca4f2$export$9a588f369e2c5bd7),
    /**
     * A column that is used to display the Totals of Pivot Aggregation Columns.
     */ PivotAggregationTotal: (0, $b0d14b794bdca4f2$export$77dcda55adab6007)
};



const $796acad2fe7c3f00$export$60c8979c505fed66 = [
    {
        OrderId: 11142,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Michael Suyama',
        InvoicedCost: 855.45,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 95.05,
        OrderCost: 950.5,
        PackageCost: 12.7,
        OrderDate: 1549494000000,
        RequiredDate: 1551913200000,
        ShippedDate: 1549753200000,
        ShipVia: 'Federal Shipping',
        Freight: 4.07,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 11140,
        CustomerReference: 'TOMSP',
        CompanyName: "Toms Spezialit\xe4ten",
        ContactName: 'Karin Josephs',
        Employee: 'Janet Leverling',
        InvoicedCost: 738.7263,
        ItemCount: 13,
        ChangeLastOrder: -12,
        ItemCost: 55.17,
        OrderCost: 717.21,
        PackageCost: 14.95,
        OrderDate: 1549407600000,
        RequiredDate: 1551826800000,
        ShippedDate: 1550098800000,
        ShipVia: 'United Package',
        Freight: 8.24,
        ShipName: "Toms Spezialit\xe4ten",
        ShipAddress: 'Luisenstr. 48',
        ShipCity: "M\xfcnster",
        ShipRegion: null,
        ShipPostalCode: 44087,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 11138,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Laura Callahan',
        InvoicedCost: 1060.1955,
        ItemCount: 13,
        ChangeLastOrder: 41,
        ItemCost: 77.67,
        OrderCost: 1009.71,
        PackageCost: 18.577,
        OrderDate: 1549321200000,
        RequiredDate: 1551740400000,
        ShippedDate: 1549926000000,
        ShipVia: 'Speedy Express',
        Freight: 19.97,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 11137,
        CustomerReference: 'BLONP',
        CompanyName: "Blondel p\xe8re et fils",
        ContactName: "Fr\xe9d\xe9rique Citeaux",
        Employee: 'Janet Leverling',
        InvoicedCost: 874.8739999999999,
        ItemCount: 14,
        ChangeLastOrder: 4,
        ItemCost: 54.34,
        OrderCost: 760.76,
        PackageCost: 7.5600000000000005,
        OrderDate: 1549321200000,
        RequiredDate: 1551740400000,
        ShippedDate: 1549839600000,
        ShipVia: 'United Package',
        Freight: 156.66,
        ShipName: "Blondel p\xe8re et fils",
        ShipAddress: "24, place Kl\xe9ber",
        ShipCity: 'Strasbourg',
        ShipRegion: null,
        ShipPostalCode: 67000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 11136,
        CustomerReference: 'CONSH',
        CompanyName: 'Consolidated Holdings',
        ContactName: 'Elizabeth Brown',
        Employee: 'Laura Callahan',
        InvoicedCost: 815.4,
        ItemCount: 10,
        ChangeLastOrder: -3,
        ItemCost: 90.6,
        OrderCost: 906,
        PackageCost: 12.7,
        OrderDate: 1549234800000,
        RequiredDate: 1552863600000,
        ShippedDate: 1549494000000,
        ShipVia: 'United Package',
        Freight: 9.21,
        ShipName: 'Consolidated Holdings',
        ShipAddress: 'Berkeley Gardens, 12  Brewery',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'WX1 6LT',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 11135,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Janet Leverling',
        InvoicedCost: 335.745,
        ItemCount: 9,
        ChangeLastOrder: -1,
        ItemCost: 41.45,
        OrderCost: 373.05,
        PackageCost: 11.43,
        OrderDate: 1549148400000,
        RequiredDate: 1551567600000,
        ShippedDate: 1550012400000,
        ShipVia: 'United Package',
        Freight: 17.92,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 11134,
        CustomerReference: 'PRINI',
        CompanyName: 'Princesa Isabel Vinhos',
        ContactName: 'Isabel de Castro',
        Employee: 'Janet Leverling',
        InvoicedCost: 208.25,
        ItemCount: 10,
        ChangeLastOrder: -14,
        ItemCost: 24.5,
        OrderCost: 245,
        PackageCost: 11.5,
        OrderDate: 1549148400000,
        RequiredDate: 1551567600000,
        ShippedDate: 1551654000000,
        ShipVia: 'Federal Shipping',
        Freight: 73.83,
        ShipName: 'Princesa Isabel Vinhos',
        ShipAddress: "Estrada da sa\xfade n. 58",
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1756,
        ShipCountry: 'Portugal',
        ArriveOnTime: 0
    },
    {
        OrderId: 11133,
        CustomerReference: 'SPLIR',
        CompanyName: 'Split Rail Beer & Ale',
        ContactName: 'Art Braunschweiger',
        Employee: 'Janet Leverling',
        InvoicedCost: 922.11,
        ItemCount: 10,
        ChangeLastOrder: 9,
        ItemCost: 87.82,
        OrderCost: 878.1999999999999,
        PackageCost: 14.290000000000001,
        OrderDate: 1548889200000,
        RequiredDate: 1550098800000,
        ShippedDate: 1549494000000,
        ShipVia: 'United Package',
        Freight: 4.34,
        ShipName: 'Split Rail Beer & Ale',
        ShipAddress: 'P.O. Box 555',
        ShipCity: 'Lander',
        ShipRegion: 'WY',
        ShipPostalCode: 82520,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 11131,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Margaret Peacock',
        InvoicedCost: 2122.659,
        ItemCount: 21,
        ChangeLastOrder: 4,
        ItemCost: 112.31,
        OrderCost: 2358.51,
        PackageCost: 11.34,
        OrderDate: 1548802800000,
        RequiredDate: 1550012400000,
        ShippedDate: 1549494000000,
        ShipVia: 'United Package',
        Freight: 44.17,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 11128,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Margaret Peacock',
        InvoicedCost: 69.92999999999999,
        ItemCount: 10,
        ChangeLastOrder: 15,
        ItemCost: 6.66,
        OrderCost: 66.6,
        PackageCost: 14.290000000000001,
        OrderDate: 1548802800000,
        RequiredDate: 1550012400000,
        ShippedDate: 1549148400000,
        ShipVia: 'Speedy Express',
        Freight: 458.78,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 11125,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Janet Leverling',
        InvoicedCost: 402.732,
        ItemCount: 11,
        ChangeLastOrder: 1,
        ItemCost: 40.68,
        OrderCost: 447.48,
        PackageCost: 13.97,
        OrderDate: 1548716400000,
        RequiredDate: 1552345200000,
        ShippedDate: 1549494000000,
        ShipVia: 'United Package',
        Freight: 56.63,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 11122,
        CustomerReference: 'REGGC',
        CompanyName: 'Reggiani Caseifici',
        ContactName: 'Maurizio Moroni',
        Employee: 'Robert King',
        InvoicedCost: 475.16149999999993,
        ItemCount: 11,
        ChangeLastOrder: -14,
        ItemCost: 45.47,
        OrderCost: 500.16999999999996,
        PackageCost: 12.649999999999999,
        OrderDate: 1548630000000,
        RequiredDate: 1551049200000,
        ShippedDate: 1549234800000,
        ShipVia: 'Speedy Express',
        Freight: 11.09,
        ShipName: 'Reggiani Caseifici',
        ShipAddress: 'Strada Provinciale 124',
        ShipCity: 'Reggio Emilia',
        ShipRegion: null,
        ShipPostalCode: 42100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 11119,
        CustomerReference: 'PICCO',
        CompanyName: 'Piccolo und mehr',
        ContactName: 'Georg Pipps',
        Employee: 'Margaret Peacock',
        InvoicedCost: 158.688,
        ItemCount: 9,
        ChangeLastOrder: -3,
        ItemCost: 12.16,
        OrderCost: 109.44,
        PackageCost: 11.43,
        OrderDate: 1548543600000,
        RequiredDate: 1550962800000,
        ShippedDate: 1551567600000,
        ShipVia: 'United Package',
        Freight: 31.29,
        ShipName: 'Piccolo und mehr',
        ShipAddress: 'Geislweg 14',
        ShipCity: 'Salzburg',
        ShipRegion: null,
        ShipPostalCode: 5020,
        ShipCountry: 'Austria',
        ArriveOnTime: 1
    },
    {
        OrderId: 11116,
        CustomerReference: 'GALED',
        CompanyName: "Galer\xeda del gastr\xf3nomo",
        ContactName: 'Eduardo Saavedra',
        Employee: 'Margaret Peacock',
        InvoicedCost: 223.14600000000002,
        ItemCount: 12,
        ChangeLastOrder: 5,
        ItemCost: 17.71,
        OrderCost: 212.52,
        PackageCost: 6.48,
        OrderDate: 1548543600000,
        RequiredDate: 1550962800000,
        ShippedDate: 1549407600000,
        ShipVia: 'Speedy Express',
        Freight: 18.69,
        ShipName: "Galer\xeda del gastron\xf3mo",
        ShipAddress: "Rambla de Catalu\xf1a, 23",
        ShipCity: 'Barcelona',
        ShipRegion: null,
        ShipPostalCode: 8022,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 11113,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Michael Suyama',
        InvoicedCost: 601.8,
        ItemCount: 10,
        ChangeLastOrder: 6,
        ItemCost: 70.8,
        OrderCost: 708,
        PackageCost: 13.81,
        OrderDate: 1548284400000,
        RequiredDate: 1550703600000,
        ShippedDate: 1550098800000,
        ShipVia: 'United Package',
        Freight: 7.93,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 11110,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Robert King',
        InvoicedCost: 140.31,
        ItemCount: 5,
        ChangeLastOrder: 2,
        ItemCost: 31.18,
        OrderCost: 155.9,
        PackageCost: 6.35,
        OrderDate: 1548198000000,
        RequiredDate: 1550617200000,
        ShippedDate: 1548543600000,
        ShipVia: 'United Package',
        Freight: 370.61,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 11107,
        CustomerReference: 'GOURL',
        CompanyName: 'Gourmet Lanchonetes',
        ContactName: "Andr\xe9 Fonseca",
        Employee: 'Michael Suyama',
        InvoicedCost: 271.65299999999996,
        ItemCount: 6,
        ChangeLastOrder: -2,
        ItemCost: 39.37,
        OrderCost: 236.21999999999997,
        PackageCost: 7.62,
        OrderDate: 1548198000000,
        RequiredDate: 1549407600000,
        ShippedDate: 1550962800000,
        ShipVia: 'Federal Shipping',
        Freight: 24.5,
        ShipName: 'Gourmet Lanchonetes',
        ShipAddress: 'Av. Brasil, 442',
        ShipCity: 'Campinas',
        ShipRegion: 'SP',
        ShipPostalCode: '04876-786',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 11104,
        CustomerReference: 'FRANS',
        CompanyName: 'Franchi S.p.A.',
        ContactName: 'Paolo Accorti',
        Employee: 'Andrew Fuller',
        InvoicedCost: 415.344,
        ItemCount: 12,
        ChangeLastOrder: -34,
        ItemCost: 40.72,
        OrderCost: 488.64,
        PackageCost: 13.799999999999999,
        OrderDate: 1548111600000,
        RequiredDate: 1550530800000,
        ShippedDate: 1548889200000,
        ShipVia: 'Speedy Express',
        Freight: 3.02,
        ShipName: 'Franchi S.p.A.',
        ShipAddress: 'Via Monte Bianco 34',
        ShipCity: 'Torino',
        ShipRegion: null,
        ShipPostalCode: 10100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 11101,
        CustomerReference: 'QUEDE',
        CompanyName: "Que Del\xedcia",
        ContactName: 'Bernardo Batista',
        Employee: 'Laura Callahan',
        InvoicedCost: 976.419,
        ItemCount: 9,
        ChangeLastOrder: -5,
        ItemCost: 94.34,
        OrderCost: 849.0600000000001,
        PackageCost: 10.35,
        OrderDate: 1548025200000,
        RequiredDate: 1551654000000,
        ShippedDate: 1548543600000,
        ShipVia: 'Speedy Express',
        Freight: 99.23,
        ShipName: "Que Del\xedcia",
        ShipAddress: 'Rua da Panificadora, 12',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-673',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 11098,
        CustomerReference: 'WELLI',
        CompanyName: 'Wellington Importadora',
        ContactName: 'Paula Parente',
        Employee: 'Janet Leverling',
        InvoicedCost: 293.556,
        ItemCount: 8,
        ChangeLastOrder: -14,
        ItemCost: 43.17,
        OrderCost: 345.36,
        PackageCost: 9.2,
        OrderDate: 1548025200000,
        RequiredDate: 1550444400000,
        ShippedDate: 1548543600000,
        ShipVia: 'Speedy Express',
        Freight: 44.12,
        ShipName: 'Wellington Importadora',
        ShipAddress: 'Rua do Mercado, 12',
        ShipCity: 'Resende',
        ShipRegion: 'SP',
        ShipPostalCode: '08737-363',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 11095,
        CustomerReference: 'RICSU',
        CompanyName: 'Richter Supermarkt',
        ContactName: 'Michael Holz',
        Employee: 'Margaret Peacock',
        InvoicedCost: 236.64,
        ItemCount: 10,
        ChangeLastOrder: -1,
        ItemCost: 27.84,
        OrderCost: 278.4,
        PackageCost: 12.7,
        OrderDate: 1547938800000,
        RequiredDate: 1550358000000,
        ShippedDate: 1548802800000,
        ShipVia: 'United Package',
        Freight: 137.35,
        ShipName: 'Richter Supermarkt',
        ShipAddress: 'Starenweg 5',
        ShipCity: "Gen\xe8ve",
        ShipRegion: null,
        ShipPostalCode: 1204,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 0
    },
    {
        OrderId: 11092,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Margaret Peacock',
        InvoicedCost: 423.9,
        ItemCount: 9,
        ChangeLastOrder: -5,
        ItemCost: 37.68,
        OrderCost: 339.12,
        PackageCost: 10.35,
        OrderDate: 1547679600000,
        RequiredDate: 1550098800000,
        ShippedDate: 1548284400000,
        ShipVia: 'Speedy Express',
        Freight: 17.55,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 11090,
        CustomerReference: 'SIMOB',
        CompanyName: 'Simons bistro',
        ContactName: 'Jytte Petersen',
        Employee: 'Margaret Peacock',
        InvoicedCost: 56.474,
        ItemCount: 11,
        ChangeLastOrder: 4,
        ItemCost: 6.04,
        OrderCost: 66.44,
        PackageCost: 5.94,
        OrderDate: 1547593200000,
        RequiredDate: 1550012400000,
        ShippedDate: 1548630000000,
        ShipVia: 'Federal Shipping',
        Freight: 70.29,
        ShipName: 'Simons bistro',
        ShipAddress: "Vinb\xe6ltet 34",
        ShipCity: "K\xf8benhavn",
        ShipRegion: null,
        ShipPostalCode: 1734,
        ShipCountry: 'Denmark',
        ArriveOnTime: 0
    },
    {
        OrderId: 11088,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Laura Callahan',
        InvoicedCost: 409.248,
        ItemCount: 12,
        ChangeLastOrder: -31,
        ItemCost: 32.48,
        OrderCost: 389.76,
        PackageCost: 13.799999999999999,
        OrderDate: 1547593200000,
        RequiredDate: 1550012400000,
        ShippedDate: 1548543600000,
        ShipVia: 'Federal Shipping',
        Freight: 22.72,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 11086,
        CustomerReference: 'HUNGC',
        CompanyName: 'Hungry Coyote Import Store',
        ContactName: 'Yoshi Latimer',
        Employee: 'Janet Leverling',
        InvoicedCost: 474.60599999999994,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 47.94,
        OrderCost: 527.3399999999999,
        PackageCost: 13.97,
        OrderDate: 1547506800000,
        RequiredDate: 1549926000000,
        ShippedDate: 1548284400000,
        ShipVia: 'Speedy Express',
        Freight: 0.2,
        ShipName: 'Hungry Coyote Import Store',
        ShipAddress: 'City Center Plaza, 516 Main St.',
        ShipCity: 'Elgin',
        ShipRegion: 'OR',
        ShipPostalCode: 97827,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 11084,
        CustomerReference: 'FAMIA',
        CompanyName: 'Familia Arquibaldo',
        ContactName: 'Aria Cruz',
        Employee: 'Andrew Fuller',
        InvoicedCost: 189.397,
        ItemCount: 13,
        ChangeLastOrder: -35,
        ItemCost: 17.14,
        OrderCost: 222.82,
        PackageCost: 14.95,
        OrderDate: 1547420400000,
        RequiredDate: 1549839600000,
        ShippedDate: 1547679600000,
        ShipVia: 'Federal Shipping',
        Freight: 21.48,
        ShipName: 'Familia Arquibaldo',
        ShipAddress: "Rua Or\xf3s, 92",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05442-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 11082,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Janet Leverling',
        InvoicedCost: 614.975,
        ItemCount: 10,
        ChangeLastOrder: 6,
        ItemCost: 72.35,
        OrderCost: 723.5,
        PackageCost: 13.81,
        OrderDate: 1547420400000,
        RequiredDate: 1549839600000,
        ShippedDate: 1547593200000,
        ShipVia: 'United Package',
        Freight: 95.66,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 11080,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Laura Callahan',
        InvoicedCost: 264.033,
        ItemCount: 11,
        ChangeLastOrder: -27,
        ItemCost: 22.86,
        OrderCost: 251.45999999999998,
        PackageCost: 12.649999999999999,
        OrderDate: 1547334000000,
        RequiredDate: 1549753200000,
        ShippedDate: 1547506800000,
        ShipVia: 'United Package',
        Freight: 3.77,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 11078,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 709.488,
        ItemCount: 13,
        ChangeLastOrder: 4,
        ItemCost: 60.64,
        OrderCost: 788.32,
        PackageCost: 7.0200000000000005,
        OrderDate: 1547074800000,
        RequiredDate: 1549494000000,
        ShippedDate: 1548025200000,
        ShipVia: 'Federal Shipping',
        Freight: 23.65,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 11076,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Janet Leverling',
        InvoicedCost: 741.852,
        ItemCount: 12,
        ChangeLastOrder: 4,
        ItemCost: 68.69,
        OrderCost: 824.28,
        PackageCost: 6.48,
        OrderDate: 1547074800000,
        RequiredDate: 1549494000000,
        ShippedDate: 1547506800000,
        ShipVia: 'Federal Shipping',
        Freight: 2.4,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 11074,
        CustomerReference: 'OCEAN',
        CompanyName: "Oc\xe9ano Atl\xe1ntico Ltda.",
        ContactName: 'Yvonne Moncada',
        Employee: 'Janet Leverling',
        InvoicedCost: 255.935,
        ItemCount: 10,
        ChangeLastOrder: 35,
        ItemCost: 30.11,
        OrderCost: 301.1,
        PackageCost: 14.290000000000001,
        OrderDate: 1546988400000,
        RequiredDate: 1549407600000,
        ShippedDate: 1547420400000,
        ShipVia: 'Speedy Express',
        Freight: 29.83,
        ShipName: "Oc\xe9ano Atl\xe1ntico Ltda.",
        ShipAddress: 'Ing. Gustavo Moncada 8585, Piso 20-A',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 1
    },
    {
        OrderId: 11072,
        CustomerReference: 'FOLIG',
        CompanyName: 'Folies gourmandes',
        ContactName: "Martine Ranc\xe9",
        Employee: 'Laura Callahan',
        InvoicedCost: 260.544,
        ItemCount: 8,
        ChangeLastOrder: 5,
        ItemCost: 28.32,
        OrderCost: 226.56,
        PackageCost: 4.32,
        OrderDate: 1546902000000,
        RequiredDate: 1549321200000,
        ShippedDate: 1547420400000,
        ShipVia: 'Speedy Express',
        Freight: 11.26,
        ShipName: 'Folies gourmandes',
        ShipAddress: "184, chauss\xe9e de Tournai",
        ShipCity: 'Lille',
        ShipRegion: null,
        ShipPostalCode: 59000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 11070,
        CustomerReference: 'OTTIK',
        CompanyName: "Ottilies K\xe4seladen",
        ContactName: 'Henriette Pfalzheim',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1007.7449999999999,
        ItemCount: 10,
        ChangeLastOrder: 22,
        ItemCost: 87.63,
        OrderCost: 876.3,
        PackageCost: 14.290000000000001,
        OrderDate: 1546815600000,
        RequiredDate: 1549234800000,
        ShippedDate: 1548802800000,
        ShipVia: 'United Package',
        Freight: 91.48,
        ShipName: "Ottilies K\xe4seladen",
        ShipAddress: 'Mehrheimerstr. 369',
        ShipCity: "K\xf6ln",
        ShipRegion: null,
        ShipPostalCode: 50739,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 11068,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Robert King',
        InvoicedCost: 55.233000000000004,
        ItemCount: 6,
        ChangeLastOrder: -2,
        ItemCost: 10.83,
        OrderCost: 64.98,
        PackageCost: 7.62,
        OrderDate: 1546815600000,
        RequiredDate: 1550444400000,
        ShippedDate: 1547334000000,
        ShipVia: 'Speedy Express',
        Freight: 108.04,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 11066,
        CustomerReference: 'LINOD',
        CompanyName: 'LINO-Delicateses',
        ContactName: 'Felipe Izquierdo',
        Employee: 'Nancy Davolio',
        InvoicedCost: 538.53,
        ItemCount: 12,
        ChangeLastOrder: -3,
        ItemCost: 30.95,
        OrderCost: 371.4,
        PackageCost: 15.24,
        OrderDate: 1546729200000,
        RequiredDate: 1549148400000,
        ShippedDate: 1548111600000,
        ShipVia: 'Speedy Express',
        Freight: 34.82,
        ShipName: 'LINO-Delicateses',
        ShipAddress: 'Ave. 5 de Mayo Porlamar',
        ShipCity: 'I. de Margarita',
        ShipRegion: 'Nueva Esparta',
        ShipPostalCode: 4980,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 11064,
        CustomerReference: 'MAGAA',
        CompanyName: 'Magazzini Alimentari Riuniti',
        ContactName: 'Giovanni Rovelli',
        Employee: 'Andrew Fuller',
        InvoicedCost: 32.2575,
        ItemCount: 11,
        ChangeLastOrder: -16,
        ItemCost: 3.45,
        OrderCost: 37.95,
        PackageCost: 12.649999999999999,
        OrderDate: 1546470000000,
        RequiredDate: 1548889200000,
        ShippedDate: 1546902000000,
        ShipVia: 'Speedy Express',
        Freight: 155.97,
        ShipName: 'Magazzini Alimentari Riuniti',
        ShipAddress: 'Via Ludovico il Moro 22',
        ShipCity: 'Bergamo',
        ShipRegion: null,
        ShipPostalCode: 24100,
        ShipCountry: 'Italy',
        ArriveOnTime: 0
    },
    {
        OrderId: 11062,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Margaret Peacock',
        InvoicedCost: 573.6150000000001,
        ItemCount: 10,
        ChangeLastOrder: 3,
        ItemCost: 54.63,
        OrderCost: 546.3000000000001,
        PackageCost: 5.4,
        OrderDate: 1546470000000,
        RequiredDate: 1548889200000,
        ShippedDate: 1546988400000,
        ShipVia: 'Federal Shipping',
        Freight: 73.79,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 11060,
        CustomerReference: 'FRANS',
        CompanyName: 'Franchi S.p.A.',
        ContactName: 'Paolo Accorti',
        Employee: 'Andrew Fuller',
        InvoicedCost: 831.1979999999999,
        ItemCount: 12,
        ChangeLastOrder: -22,
        ItemCost: 81.49,
        OrderCost: 977.8799999999999,
        PackageCost: 13.799999999999999,
        OrderDate: 1525042800000,
        RequiredDate: 1527462000000,
        ShippedDate: 1525388400000,
        ShipVia: 'United Package',
        Freight: 10.98,
        ShipName: 'Franchi S.p.A.',
        ShipAddress: 'Via Monte Bianco 34',
        ShipCity: 'Torino',
        ShipRegion: null,
        ShipPostalCode: 10100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 11057,
        CustomerReference: 'NORTS',
        CompanyName: 'North/South',
        ContactName: 'Simon Crowther',
        Employee: 'Janet Leverling',
        InvoicedCost: 438.97499999999997,
        ItemCount: 6,
        ChangeLastOrder: 8,
        ItemCost: 97.55,
        OrderCost: 585.3,
        PackageCost: 8.286,
        OrderDate: 1524956400000,
        RequiredDate: 1527375600000,
        ShippedDate: 1525129200000,
        ShipVia: 'Federal Shipping',
        Freight: 4.13,
        ShipName: 'North/South',
        ShipAddress: 'South House, 300 Queensbridge',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'SW7 1RZ',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 11056,
        CustomerReference: 'EASTC',
        CompanyName: 'Eastern Connection',
        ContactName: 'Ann Devon',
        Employee: 'Laura Callahan',
        InvoicedCost: 0.9373000000000001,
        ItemCount: 13,
        ChangeLastOrder: 2,
        ItemCost: 0.07,
        OrderCost: 0.9100000000000001,
        PackageCost: 16.51,
        OrderDate: 1524870000000,
        RequiredDate: 1526079600000,
        ShippedDate: 1525129200000,
        ShipVia: 'United Package',
        Freight: 278.96,
        ShipName: 'Eastern Connection',
        ShipAddress: '35 King George',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'WX3 6FW',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 11053,
        CustomerReference: 'PICCO',
        CompanyName: 'Piccolo und mehr',
        ContactName: 'Georg Pipps',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1402.1802,
        ItemCount: 9,
        ChangeLastOrder: -2,
        ItemCost: 151.26,
        OrderCost: 1361.34,
        PackageCost: 11.43,
        OrderDate: 1524783600000,
        RequiredDate: 1527202800000,
        ShippedDate: 1524956400000,
        ShipVia: 'United Package',
        Freight: 53.05,
        ShipName: 'Piccolo und mehr',
        ShipAddress: 'Geislweg 14',
        ShipCity: 'Salzburg',
        ShipRegion: null,
        ShipPostalCode: 5020,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 11052,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Janet Leverling',
        InvoicedCost: 785.9525000000001,
        ItemCount: 5,
        ChangeLastOrder: -20,
        ItemCost: 184.93,
        OrderCost: 924.6500000000001,
        PackageCost: 5.75,
        OrderDate: 1524783600000,
        RequiredDate: 1527202800000,
        ShippedDate: 1525129200000,
        ShipVia: 'Speedy Express',
        Freight: 67.26,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 11048,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Robert King',
        InvoicedCost: 2099.9537,
        ItemCount: 13,
        ChangeLastOrder: 4,
        ItemCost: 156.83,
        OrderCost: 2038.7900000000002,
        PackageCost: 7.0200000000000005,
        OrderDate: 1524524400000,
        RequiredDate: 1526943600000,
        ShippedDate: 1525042800000,
        ShipVia: 'Federal Shipping',
        Freight: 24.12,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 11047,
        CustomerReference: 'EASTC',
        CompanyName: 'Eastern Connection',
        ContactName: 'Ann Devon',
        Employee: 'Robert King',
        InvoicedCost: 1959.3072000000002,
        ItemCount: 12,
        ChangeLastOrder: 2,
        ItemCost: 158.52,
        OrderCost: 1902.2400000000002,
        PackageCost: 15.24,
        OrderDate: 1524524400000,
        RequiredDate: 1526943600000,
        ShippedDate: 1525129200000,
        ShipVia: 'Federal Shipping',
        Freight: 46.62,
        ShipName: 'Eastern Connection',
        ShipAddress: '35 King George',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'WX3 6FW',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 11046,
        CustomerReference: 'WANDK',
        CompanyName: 'Die Wandernde Kuh',
        ContactName: "Rita M\xfcller",
        Employee: 'Laura Callahan',
        InvoicedCost: 227.4195,
        ItemCount: 11,
        ChangeLastOrder: 0,
        ItemCost: 19.69,
        OrderCost: 216.59,
        PackageCost: 13.97,
        OrderDate: 1524438000000,
        RequiredDate: 1526857200000,
        ShippedDate: 1524524400000,
        ShipVia: 'United Package',
        Freight: 71.64,
        ShipName: 'Die Wandernde Kuh',
        ShipAddress: 'Adenauerallee 900',
        ShipCity: 'Stuttgart',
        ShipRegion: null,
        ShipPostalCode: 70563,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 11044,
        CustomerReference: 'WOLZA',
        CompanyName: 'Wolski  Zajazd',
        ContactName: 'Zbyszek Piestrzeniewicz',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1151.5812,
        ItemCount: 12,
        ChangeLastOrder: 29,
        ItemCost: 93.17,
        OrderCost: 1118.04,
        PackageCost: 17.148,
        OrderDate: 1524438000000,
        RequiredDate: 1526857200000,
        ShippedDate: 1525129200000,
        ShipVia: 'Speedy Express',
        Freight: 8.72,
        ShipName: 'Wolski Zajazd',
        ShipAddress: 'ul. Filtrowa 68',
        ShipCity: 'Warszawa',
        ShipRegion: null,
        ShipPostalCode: '01-012',
        ShipCountry: 'Poland',
        ArriveOnTime: 1
    },
    {
        OrderId: 11043,
        CustomerReference: 'SPECD',
        CompanyName: "Sp\xe9cialit\xe9s du monde",
        ContactName: 'Dominique Perrier',
        Employee: 'Steven Buchanan',
        InvoicedCost: 274.848,
        ItemCount: 8,
        ChangeLastOrder: 4,
        ItemCost: 32.72,
        OrderCost: 261.76,
        PackageCost: 4.32,
        OrderDate: 1524351600000,
        RequiredDate: 1526770800000,
        ShippedDate: 1524956400000,
        ShipVia: 'United Package',
        Freight: 8.8,
        ShipName: "Sp\xe9cialit\xe9s du monde",
        ShipAddress: '25, rue Lauriston',
        ShipCity: 'Paris',
        ShipRegion: null,
        ShipPostalCode: 75016,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 11042,
        CustomerReference: 'COMMI',
        CompanyName: "Com\xe9rcio Mineiro",
        ContactName: 'Pedro Afonso',
        Employee: 'Laura Callahan',
        InvoicedCost: 1173.9315,
        ItemCount: 7,
        ChangeLastOrder: -3,
        ItemCost: 145.83,
        OrderCost: 1020.8100000000001,
        PackageCost: 8.89,
        OrderDate: 1524351600000,
        RequiredDate: 1525561200000,
        ShippedDate: 1525129200000,
        ShipVia: 'Speedy Express',
        Freight: 29.99,
        ShipName: "Com\xe9rcio Mineiro",
        ShipAddress: "Av. dos Lus\xedadas, 23",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05432-043',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 11041,
        CustomerReference: 'CHOPS',
        CompanyName: 'Chop-suey Chinese',
        ContactName: 'Yang Wang',
        Employee: 'Janet Leverling',
        InvoicedCost: 1288.7,
        ItemCount: 8,
        ChangeLastOrder: -12,
        ItemCost: 184.1,
        OrderCost: 1472.8,
        PackageCost: 9.2,
        OrderDate: 1524351600000,
        RequiredDate: 1526770800000,
        ShippedDate: 1524870000000,
        ShipVia: 'United Package',
        Freight: 48.22,
        ShipName: 'Chop-suey Chinese',
        ShipAddress: 'Hauptstr. 31',
        ShipCity: 'Bern',
        ShipRegion: null,
        ShipPostalCode: 3012,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 0
    },
    {
        OrderId: 11038,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Nancy Davolio',
        InvoicedCost: 461.7696,
        ItemCount: 8,
        ChangeLastOrder: -4,
        ItemCost: 56.04,
        OrderCost: 448.32,
        PackageCost: 9.2,
        OrderDate: 1524265200000,
        RequiredDate: 1526684400000,
        ShippedDate: 1525042800000,
        ShipVia: 'United Package',
        Freight: 29.59,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 1
    },
    {
        OrderId: 11037,
        CustomerReference: 'GODOS',
        CompanyName: "Godos Cocina T\xedpica",
        ContactName: "Jos\xe9 Pedro Freyre",
        Employee: 'Robert King',
        InvoicedCost: 836.9689999999999,
        ItemCount: 7,
        ChangeLastOrder: -5,
        ItemCost: 125.86,
        OrderCost: 881.02,
        PackageCost: 8.049999999999999,
        OrderDate: 1524265200000,
        RequiredDate: 1526684400000,
        ShippedDate: 1524783600000,
        ShipVia: 'Speedy Express',
        Freight: 3.2,
        ShipName: "Godos Cocina T\xedpica",
        ShipAddress: 'C/ Romero, 33',
        ShipCity: 'Sevilla',
        ShipRegion: null,
        ShipPostalCode: 41101,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 11036,
        CustomerReference: 'DRACD',
        CompanyName: 'Drachenblut Delikatessen',
        ContactName: 'Sven Ottlieb',
        Employee: 'Laura Callahan',
        InvoicedCost: 1215.159,
        ItemCount: 6,
        ChangeLastOrder: -2,
        ItemCost: 176.11,
        OrderCost: 1056.66,
        PackageCost: 7.62,
        OrderDate: 1524178800000,
        RequiredDate: 1526598000000,
        ShippedDate: 1524351600000,
        ShipVia: 'Federal Shipping',
        Freight: 149.47,
        ShipName: 'Drachenblut Delikatessen',
        ShipAddress: 'Walserweg 21',
        ShipCity: 'Aachen',
        ShipRegion: null,
        ShipPostalCode: 52066,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 11035,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Andrew Fuller',
        InvoicedCost: 137.7728,
        ItemCount: 8,
        ChangeLastOrder: -4,
        ItemCost: 16.72,
        OrderCost: 133.76,
        PackageCost: 9.2,
        OrderDate: 1524178800000,
        RequiredDate: 1526598000000,
        ShippedDate: 1524524400000,
        ShipVia: 'United Package',
        Freight: 0.17,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 1
    },
    {
        OrderId: 11034,
        CustomerReference: 'OLDWO',
        CompanyName: 'Old World Delicatessen',
        ContactName: 'Rene Phillips',
        Employee: 'Laura Callahan',
        InvoicedCost: 117.9556,
        ItemCount: 7,
        ChangeLastOrder: 3,
        ItemCost: 16.36,
        OrderCost: 114.52,
        PackageCost: 3.7800000000000002,
        OrderDate: 1524178800000,
        RequiredDate: 1527807600000,
        ShippedDate: 1524783600000,
        ShipVia: 'Speedy Express',
        Freight: 40.32,
        ShipName: 'Old World Delicatessen',
        ShipAddress: '2743 Bering St.',
        ShipCity: 'Anchorage',
        ShipRegion: 'AK',
        ShipPostalCode: 99508,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 11033,
        CustomerReference: 'RICSU',
        CompanyName: 'Richter Supermarkt',
        ContactName: 'Michael Holz',
        Employee: 'Robert King',
        InvoicedCost: 41.395,
        ItemCount: 10,
        ChangeLastOrder: -3,
        ItemCost: 4.87,
        OrderCost: 48.7,
        PackageCost: 12.7,
        OrderDate: 1523919600000,
        RequiredDate: 1526338800000,
        ShippedDate: 1524438000000,
        ShipVia: 'Federal Shipping',
        Freight: 84.74,
        ShipName: 'Richter Supermarkt',
        ShipAddress: 'Starenweg 5',
        ShipCity: "Gen\xe8ve",
        ShipRegion: null,
        ShipPostalCode: 1204,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 0
    },
    {
        OrderId: 11032,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1382.6617,
        ItemCount: 7,
        ChangeLastOrder: 6,
        ItemCost: 191.77,
        OrderCost: 1342.39,
        PackageCost: 9.667,
        OrderDate: 1523919600000,
        RequiredDate: 1526338800000,
        ShippedDate: 1524438000000,
        ShipVia: 'Federal Shipping',
        Freight: 606.19,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 11031,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Michael Suyama',
        InvoicedCost: 398.58,
        ItemCount: 13,
        ChangeLastOrder: 5,
        ItemCost: 29.2,
        OrderCost: 379.59999999999997,
        PackageCost: 7.0200000000000005,
        OrderDate: 1523919600000,
        RequiredDate: 1526338800000,
        ShippedDate: 1524524400000,
        ShipVia: 'United Package',
        Freight: 227.22,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 11030,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Robert King',
        InvoicedCost: 1849.029,
        ItemCount: 13,
        ChangeLastOrder: 5,
        ItemCost: 135.46,
        OrderCost: 1760.98,
        PackageCost: 7.0200000000000005,
        OrderDate: 1523919600000,
        RequiredDate: 1526338800000,
        ShippedDate: 1524783600000,
        ShipVia: 'United Package',
        Freight: 830.75,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 11029,
        CustomerReference: 'CHOPS',
        CompanyName: 'Chop-suey Chinese',
        ContactName: 'Yang Wang',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1636.1279999999997,
        ItemCount: 13,
        ChangeLastOrder: -17,
        ItemCost: 132.48,
        OrderCost: 1722.2399999999998,
        PackageCost: 14.95,
        OrderDate: 1523833200000,
        RequiredDate: 1526252400000,
        ShippedDate: 1524783600000,
        ShipVia: 'Speedy Express',
        Freight: 47.84,
        ShipName: 'Chop-suey Chinese',
        ShipAddress: 'Hauptstr. 31',
        ShipCity: 'Bern',
        ShipRegion: null,
        ShipPostalCode: 3012,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 0
    },
    {
        OrderId: 11028,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Andrew Fuller',
        InvoicedCost: 719.9415,
        ItemCount: 9,
        ChangeLastOrder: 41,
        ItemCost: 94.11,
        OrderCost: 846.99,
        PackageCost: 12.861,
        OrderDate: 1523833200000,
        RequiredDate: 1526252400000,
        ShippedDate: 1524351600000,
        ShipVia: 'Speedy Express',
        Freight: 29.59,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 11027,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Nancy Davolio',
        InvoicedCost: 447.741,
        ItemCount: 9,
        ChangeLastOrder: 4,
        ItemCost: 48.3,
        OrderCost: 434.7,
        PackageCost: 4.86,
        OrderDate: 1523833200000,
        RequiredDate: 1526252400000,
        ShippedDate: 1524178800000,
        ShipVia: 'Speedy Express',
        Freight: 52.52,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 11026,
        CustomerReference: 'FRANS',
        CompanyName: 'Franchi S.p.A.',
        ContactName: 'Paolo Accorti',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1576.8004999999998,
        ItemCount: 11,
        ChangeLastOrder: -31,
        ItemCost: 150.89,
        OrderCost: 1659.79,
        PackageCost: 12.649999999999999,
        OrderDate: 1523746800000,
        RequiredDate: 1526166000000,
        ShippedDate: 1524870000000,
        ShipVia: 'Speedy Express',
        Freight: 47.09,
        ShipName: 'Franchi S.p.A.',
        ShipAddress: 'Via Monte Bianco 34',
        ShipCity: 'Torino',
        ShipRegion: null,
        ShipPostalCode: 10100,
        ShipCountry: 'Italy',
        ArriveOnTime: 0
    },
    {
        OrderId: 11025,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Michael Suyama',
        InvoicedCost: 991.116,
        ItemCount: 9,
        ChangeLastOrder: 44,
        ItemCost: 104.88,
        OrderCost: 943.92,
        PackageCost: 12.861,
        OrderDate: 1523746800000,
        RequiredDate: 1526166000000,
        ShippedDate: 1524524400000,
        ShipVia: 'Federal Shipping',
        Freight: 29.17,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 11024,
        CustomerReference: 'EASTC',
        CompanyName: 'Eastern Connection',
        ContactName: 'Ann Devon',
        Employee: 'Margaret Peacock',
        InvoicedCost: 856.1360000000001,
        ItemCount: 8,
        ChangeLastOrder: 2,
        ItemCost: 103.9,
        OrderCost: 831.2,
        PackageCost: 10.16,
        OrderDate: 1523746800000,
        RequiredDate: 1526166000000,
        ShippedDate: 1524178800000,
        ShipVia: 'Speedy Express',
        Freight: 74.36,
        ShipName: 'Eastern Connection',
        ShipAddress: '35 King George',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'WX3 6FW',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 11023,
        CustomerReference: 'BSBEV',
        CompanyName: "B's Beverages",
        ContactName: 'Victoria Ashworth',
        Employee: 'Nancy Davolio',
        InvoicedCost: 1502.4713000000002,
        ItemCount: 11,
        ChangeLastOrder: -17,
        ItemCost: 132.61,
        OrderCost: 1458.71,
        PackageCost: 12.649999999999999,
        OrderDate: 1523660400000,
        RequiredDate: 1524870000000,
        ShippedDate: 1524524400000,
        ShipVia: 'United Package',
        Freight: 123.83,
        ShipName: "B's Beverages",
        ShipAddress: 'Fauntleroy Circus',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'EC2 5NT',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 11021,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Janet Leverling',
        InvoicedCost: 687.0375,
        ItemCount: 9,
        ChangeLastOrder: -15,
        ItemCost: 61.07,
        OrderCost: 549.63,
        PackageCost: 10.35,
        OrderDate: 1523660400000,
        RequiredDate: 1526079600000,
        ShippedDate: 1524265200000,
        ShipVia: 'Speedy Express',
        Freight: 297.18,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 11020,
        CustomerReference: 'OTTIK',
        CompanyName: "Ottilies K\xe4seladen",
        ContactName: 'Henriette Pfalzheim',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1168.3496000000002,
        ItemCount: 11,
        ChangeLastOrder: 28,
        ItemCost: 103.12,
        OrderCost: 1134.3200000000002,
        PackageCost: 15.719000000000001,
        OrderDate: 1523660400000,
        RequiredDate: 1526079600000,
        ShippedDate: 1523833200000,
        ShipVia: 'United Package',
        Freight: 43.3,
        ShipName: "Ottilies K\xe4seladen",
        ShipAddress: 'Mehrheimerstr. 369',
        ShipCity: "K\xf6ln",
        ShipRegion: null,
        ShipPostalCode: 50739,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 11018,
        CustomerReference: 'LONEP',
        CompanyName: 'Lonesome Pine Restaurant',
        ContactName: 'Fran Wilson',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1471.3545,
        ItemCount: 11,
        ChangeLastOrder: 1,
        ItemCost: 127.39,
        OrderCost: 1401.29,
        PackageCost: 13.97,
        OrderDate: 1523574000000,
        RequiredDate: 1525993200000,
        ShippedDate: 1523833200000,
        ShipVia: 'United Package',
        Freight: 11.65,
        ShipName: 'Lonesome Pine Restaurant',
        ShipAddress: '89 Chiaroscuro Rd.',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97219,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 11017,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1545.9675,
        ItemCount: 11,
        ChangeLastOrder: -8,
        ItemCost: 133.85,
        OrderCost: 1472.35,
        PackageCost: 12.649999999999999,
        OrderDate: 1523574000000,
        RequiredDate: 1525993200000,
        ShippedDate: 1524178800000,
        ShipVia: 'United Package',
        Freight: 754.26,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 11016,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 335.84180000000003,
        ItemCount: 7,
        ChangeLastOrder: -4,
        ItemCost: 46.58,
        OrderCost: 326.06,
        PackageCost: 8.049999999999999,
        OrderDate: 1523314800000,
        RequiredDate: 1525734000000,
        ShippedDate: 1523574000000,
        ShipVia: 'United Package',
        Freight: 33.8,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 11015,
        CustomerReference: 'SANTG',
        CompanyName: "Sant\xe9 Gourmet",
        ContactName: 'Jonas Bergulfsen',
        Employee: 'Andrew Fuller',
        InvoicedCost: 757.775,
        ItemCount: 10,
        ChangeLastOrder: -7,
        ItemCost: 89.15,
        OrderCost: 891.5,
        PackageCost: 11.5,
        OrderDate: 1523314800000,
        RequiredDate: 1524524400000,
        ShippedDate: 1524178800000,
        ShipVia: 'United Package',
        Freight: 4.62,
        ShipName: "Sant\xe9 Gourmet",
        ShipAddress: 'Erling Skakkes gate 78',
        ShipCity: 'Stavern',
        ShipRegion: null,
        ShipPostalCode: 4110,
        ShipCountry: 'Norway',
        ArriveOnTime: 1
    },
    {
        OrderId: 11014,
        CustomerReference: 'LINOD',
        CompanyName: 'LINO-Delicateses',
        ContactName: 'Felipe Izquierdo',
        Employee: 'Andrew Fuller',
        InvoicedCost: 707.0228999999999,
        ItemCount: 9,
        ChangeLastOrder: -3,
        ItemCost: 76.27,
        OrderCost: 686.43,
        PackageCost: 11.43,
        OrderDate: 1523314800000,
        RequiredDate: 1525734000000,
        ShippedDate: 1523746800000,
        ShipVia: 'Federal Shipping',
        Freight: 23.6,
        ShipName: 'LINO-Delicateses',
        ShipAddress: 'Ave. 5 de Mayo Porlamar',
        ShipCity: 'I. de Margarita',
        ShipRegion: 'Nueva Esparta',
        ShipPostalCode: 4980,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 11013,
        CustomerReference: 'ROMEY',
        CompanyName: 'Romero y tomillo',
        ContactName: 'Alejandra Camino',
        Employee: 'Andrew Fuller',
        InvoicedCost: 2365.8894999999998,
        ItemCount: 13,
        ChangeLastOrder: -7,
        ItemCost: 191.57,
        OrderCost: 2490.41,
        PackageCost: 14.95,
        OrderDate: 1523228400000,
        RequiredDate: 1525647600000,
        ShippedDate: 1523314800000,
        ShipVia: 'Speedy Express',
        Freight: 32.99,
        ShipName: 'Romero y tomillo',
        ShipAddress: "Gran V\xeda, 1",
        ShipCity: 'Madrid',
        ShipRegion: null,
        ShipPostalCode: 28001,
        ShipCountry: 'Spain',
        ArriveOnTime: 0
    },
    {
        OrderId: 11012,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Nancy Davolio',
        InvoicedCost: 662.8650000000001,
        ItemCount: 5,
        ChangeLastOrder: -4,
        ItemCost: 126.26,
        OrderCost: 631.3000000000001,
        PackageCost: 5.75,
        OrderDate: 1523228400000,
        RequiredDate: 1524438000000,
        ShippedDate: 1523919600000,
        ShipVia: 'Federal Shipping',
        Freight: 242.95,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 11011,
        CustomerReference: 'ALFKI',
        CompanyName: 'Alfreds Futterkiste',
        ContactName: 'Maria Anders',
        Employee: 'Janet Leverling',
        InvoicedCost: 131.784,
        ItemCount: 12,
        ChangeLastOrder: 16,
        ItemCost: 12.92,
        OrderCost: 155.04,
        PackageCost: 17.148,
        OrderDate: 1523228400000,
        RequiredDate: 1525647600000,
        ShippedDate: 1523574000000,
        ShipVia: 'Speedy Express',
        Freight: 1.21,
        ShipName: 'Alfreds Futterkiste',
        ShipAddress: 'Obere Str. 57',
        ShipCity: 'Berlin',
        ShipRegion: null,
        ShipPostalCode: 12209,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 11010,
        CustomerReference: 'REGGC',
        CompanyName: 'Reggiani Caseifici',
        ContactName: 'Maurizio Moroni',
        Employee: 'Andrew Fuller',
        InvoicedCost: 677.768,
        ItemCount: 7,
        ChangeLastOrder: -10,
        ItemCost: 101.92,
        OrderCost: 713.44,
        PackageCost: 8.049999999999999,
        OrderDate: 1523228400000,
        RequiredDate: 1525647600000,
        ShippedDate: 1524265200000,
        ShipVia: 'United Package',
        Freight: 28.71,
        ShipName: 'Reggiani Caseifici',
        ShipAddress: 'Strada Provinciale 124',
        ShipCity: 'Reggio Emilia',
        ShipRegion: null,
        ShipPostalCode: 42100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 11009,
        CustomerReference: 'GODOS',
        CompanyName: "Godos Cocina T\xedpica",
        ContactName: "Jos\xe9 Pedro Freyre",
        Employee: 'Andrew Fuller',
        InvoicedCost: 1264.545,
        ItemCount: 10,
        ChangeLastOrder: -4,
        ItemCost: 133.11,
        OrderCost: 1331.1000000000001,
        PackageCost: 11.5,
        OrderDate: 1523142000000,
        RequiredDate: 1525561200000,
        ShippedDate: 1523314800000,
        ShipVia: 'Speedy Express',
        Freight: 59.11,
        ShipName: "Godos Cocina T\xedpica",
        ShipAddress: 'C/ Romero, 33',
        ShipCity: 'Sevilla',
        ShipRegion: null,
        ShipPostalCode: 41101,
        ShipCountry: 'Spain',
        ArriveOnTime: 0
    },
    {
        OrderId: 11007,
        CustomerReference: 'PRINI',
        CompanyName: 'Princesa Isabel Vinhos',
        ContactName: 'Isabel de Castro',
        Employee: 'Laura Callahan',
        InvoicedCost: 142.341,
        ItemCount: 6,
        ChangeLastOrder: -15,
        ItemCost: 27.91,
        OrderCost: 167.46,
        PackageCost: 6.8999999999999995,
        OrderDate: 1523142000000,
        RequiredDate: 1525561200000,
        ShippedDate: 1523574000000,
        ShipVia: 'United Package',
        Freight: 202.24,
        ShipName: 'Princesa Isabel Vinhos',
        ShipAddress: "Estrada da sa\xfade n. 58",
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1756,
        ShipCountry: 'Portugal',
        ArriveOnTime: 0
    },
    {
        OrderId: 11006,
        CustomerReference: 'GREAL',
        CompanyName: 'Great Lakes Food Market',
        ContactName: 'Howard Snyder',
        Employee: 'Janet Leverling',
        InvoicedCost: 806.0059000000001,
        ItemCount: 7,
        ChangeLastOrder: 3,
        ItemCost: 111.79,
        OrderCost: 782.5300000000001,
        PackageCost: 3.7800000000000002,
        OrderDate: 1523055600000,
        RequiredDate: 1525474800000,
        ShippedDate: 1523746800000,
        ShipVia: 'United Package',
        Freight: 25.19,
        ShipName: 'Great Lakes Food Market',
        ShipAddress: '2732 Baker Blvd.',
        ShipCity: 'Eugene',
        ShipRegion: 'OR',
        ShipPostalCode: 97403,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 11005,
        CustomerReference: 'WILMK',
        CompanyName: 'Wilman Kala',
        ContactName: 'Matti Karttunen',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1406.405,
        ItemCount: 13,
        ChangeLastOrder: 25,
        ItemCost: 123.64,
        OrderCost: 1607.32,
        PackageCost: 18.577,
        OrderDate: 1523055600000,
        RequiredDate: 1525474800000,
        ShippedDate: 1523314800000,
        ShipVia: 'Speedy Express',
        Freight: 0.75,
        ShipName: 'Wilman Kala',
        ShipAddress: 'Keskuskatu 45',
        ShipCity: 'Helsinki',
        ShipRegion: null,
        ShipPostalCode: 21240,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 11004,
        CustomerReference: 'MAISD',
        CompanyName: 'Maison Dewey',
        ContactName: 'Catherine Dewey',
        Employee: 'Janet Leverling',
        InvoicedCost: 1434.0381,
        ItemCount: 11,
        ChangeLastOrder: -38,
        ItemCost: 126.57,
        OrderCost: 1392.27,
        PackageCost: 12.649999999999999,
        OrderDate: 1523055600000,
        RequiredDate: 1525474800000,
        ShippedDate: 1524178800000,
        ShipVia: 'Speedy Express',
        Freight: 44.84,
        ShipName: 'Maison Dewey',
        ShipAddress: 'Rue Joseph-Bens 532',
        ShipCity: 'Bruxelles',
        ShipRegion: null,
        ShipPostalCode: 'B-1180',
        ShipCountry: 'Belgium',
        ArriveOnTime: 0
    },
    {
        OrderId: 11003,
        CustomerReference: 'THECR',
        CompanyName: 'The Cracker Box',
        ContactName: 'Liu Wong',
        Employee: 'Janet Leverling',
        InvoicedCost: 1608.1184,
        ItemCount: 14,
        ChangeLastOrder: 2,
        ItemCost: 111.52,
        OrderCost: 1561.28,
        PackageCost: 17.78,
        OrderDate: 1522969200000,
        RequiredDate: 1525388400000,
        ShippedDate: 1523142000000,
        ShipVia: 'Federal Shipping',
        Freight: 14.91,
        ShipName: 'The Cracker Box',
        ShipAddress: '55 Grizzly Peak Rd.',
        ShipCity: 'Butte',
        ShipRegion: 'MT',
        ShipPostalCode: 59801,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 11002,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Margaret Peacock',
        InvoicedCost: 473.44500000000005,
        ItemCount: 5,
        ChangeLastOrder: 5,
        ItemCost: 90.18,
        OrderCost: 450.90000000000003,
        PackageCost: 2.7,
        OrderDate: 1522969200000,
        RequiredDate: 1525388400000,
        ShippedDate: 1523833200000,
        ShipVia: 'Speedy Express',
        Freight: 141.16,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 11001,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Andrew Fuller',
        InvoicedCost: 240.3505,
        ItemCount: 13,
        ChangeLastOrder: -1,
        ItemCost: 17.95,
        OrderCost: 233.35,
        PackageCost: 16.51,
        OrderDate: 1522969200000,
        RequiredDate: 1525388400000,
        ShippedDate: 1523660400000,
        ShipVia: 'United Package',
        Freight: 197.3,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 11000,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Andrew Fuller',
        InvoicedCost: 96.012,
        ItemCount: 8,
        ChangeLastOrder: 3,
        ItemCost: 11.43,
        OrderCost: 91.44,
        PackageCost: 4.32,
        OrderDate: 1522969200000,
        RequiredDate: 1525388400000,
        ShippedDate: 1523660400000,
        ShipVia: 'Federal Shipping',
        Freight: 55.12,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10999,
        CustomerReference: 'OTTIK',
        CompanyName: "Ottilies K\xe4seladen",
        ContactName: 'Henriette Pfalzheim',
        Employee: 'Michael Suyama',
        InvoicedCost: 45.936,
        ItemCount: 8,
        ChangeLastOrder: 30,
        ItemCost: 3.96,
        OrderCost: 31.68,
        PackageCost: 11.432,
        OrderDate: 1522710000000,
        RequiredDate: 1525129200000,
        ShippedDate: 1523314800000,
        ShipVia: 'United Package',
        Freight: 96.35,
        ShipName: "Ottilies K\xe4seladen",
        ShipAddress: 'Mehrheimerstr. 369',
        ShipCity: "K\xf6ln",
        ShipRegion: null,
        ShipPostalCode: 50739,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10998,
        CustomerReference: 'WOLZA',
        CompanyName: 'Wolski  Zajazd',
        ContactName: 'Zbyszek Piestrzeniewicz',
        Employee: 'Laura Callahan',
        InvoicedCost: 295.65000000000003,
        ItemCount: 9,
        ChangeLastOrder: 23,
        ItemCost: 26.28,
        OrderCost: 236.52,
        PackageCost: 12.861,
        OrderDate: 1522710000000,
        RequiredDate: 1523919600000,
        ShippedDate: 1523919600000,
        ShipVia: 'United Package',
        Freight: 20.31,
        ShipName: 'Wolski Zajazd',
        ShipAddress: 'ul. Filtrowa 68',
        ShipCity: 'Warszawa',
        ShipRegion: null,
        ShipPostalCode: '01-012',
        ShipCountry: 'Poland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10997,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Laura Callahan',
        InvoicedCost: 594.7025,
        ItemCount: 7,
        ChangeLastOrder: 12,
        ItemCost: 99.95,
        OrderCost: 699.65,
        PackageCost: 10.003,
        OrderDate: 1522710000000,
        RequiredDate: 1526338800000,
        ShippedDate: 1523574000000,
        ShipVia: 'United Package',
        Freight: 73.91,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10996,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Margaret Peacock',
        InvoicedCost: 992.6007,
        ItemCount: 13,
        ChangeLastOrder: -21,
        ItemCost: 74.13,
        OrderCost: 963.6899999999999,
        PackageCost: 14.95,
        OrderDate: 1522623600000,
        RequiredDate: 1525042800000,
        ShippedDate: 1523314800000,
        ShipVia: 'United Package',
        Freight: 1.12,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10995,
        CustomerReference: 'PERIC',
        CompanyName: "Pericles Comidas cl\xe1sicas",
        ContactName: "Guillermo Fern\xe1ndez",
        Employee: 'Nancy Davolio',
        InvoicedCost: 1525.2240000000002,
        ItemCount: 10,
        ChangeLastOrder: -5,
        ItemCost: 148.08,
        OrderCost: 1480.8000000000002,
        PackageCost: 11.5,
        OrderDate: 1522623600000,
        RequiredDate: 1525042800000,
        ShippedDate: 1522969200000,
        ShipVia: 'Federal Shipping',
        Freight: 46,
        ShipName: "Pericles Comidas cl\xe1sicas",
        ShipAddress: 'Calle Dr. Jorge Cash 321',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10994,
        CustomerReference: 'VAFFE',
        CompanyName: 'Vaffeljernet',
        ContactName: 'Palle Ibsen',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1286.9640000000002,
        ItemCount: 8,
        ChangeLastOrder: 9,
        ItemCost: 153.21,
        OrderCost: 1225.68,
        PackageCost: 11.432,
        OrderDate: 1522623600000,
        RequiredDate: 1523833200000,
        ShippedDate: 1523228400000,
        ShipVia: 'Federal Shipping',
        Freight: 65.53,
        ShipName: 'Vaffeljernet',
        ShipAddress: "Smagsl\xf8get 45",
        ShipCity: "\xc5rhus",
        ShipRegion: null,
        ShipPostalCode: 8200,
        ShipCountry: 'Denmark',
        ArriveOnTime: 0
    },
    {
        OrderId: 10993,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Robert King',
        InvoicedCost: 67.42380000000001,
        ItemCount: 6,
        ChangeLastOrder: -1,
        ItemCost: 10.91,
        OrderCost: 65.46000000000001,
        PackageCost: 7.62,
        OrderDate: 1522537200000,
        RequiredDate: 1524956400000,
        ShippedDate: 1523314800000,
        ShipVia: 'Federal Shipping',
        Freight: 8.81,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10992,
        CustomerReference: 'THEBI',
        CompanyName: 'The Big Cheese',
        ContactName: 'Liz Nixon',
        Employee: 'Nancy Davolio',
        InvoicedCost: 443.184,
        ItemCount: 8,
        ChangeLastOrder: 0,
        ItemCost: 52.76,
        OrderCost: 422.08,
        PackageCost: 10.16,
        OrderDate: 1522537200000,
        RequiredDate: 1524956400000,
        ShippedDate: 1522710000000,
        ShipVia: 'Federal Shipping',
        Freight: 4.27,
        ShipName: 'The Big Cheese',
        ShipAddress: '92 Jefferson Way Suite 2',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97201,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10991,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Nancy Davolio',
        InvoicedCost: 453.975,
        ItemCount: 6,
        ChangeLastOrder: -7,
        ItemCost: 60.53,
        OrderCost: 363.18,
        PackageCost: 6.8999999999999995,
        OrderDate: 1522537200000,
        RequiredDate: 1524956400000,
        ShippedDate: 1523055600000,
        ShipVia: 'Speedy Express',
        Freight: 38.51,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10990,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Andrew Fuller',
        InvoicedCost: 295.93199999999996,
        ItemCount: 8,
        ChangeLastOrder: 9,
        ItemCost: 35.23,
        OrderCost: 281.84,
        PackageCost: 11.432,
        OrderDate: 1522537200000,
        RequiredDate: 1526166000000,
        ShippedDate: 1523055600000,
        ShipVia: 'Federal Shipping',
        Freight: 117.61,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10989,
        CustomerReference: 'QUEDE',
        CompanyName: "Que Del\xedcia",
        ContactName: 'Bernardo Batista',
        Employee: 'Andrew Fuller',
        InvoicedCost: 817.6999999999999,
        ItemCount: 13,
        ChangeLastOrder: -7,
        ItemCost: 50.32,
        OrderCost: 654.16,
        PackageCost: 14.95,
        OrderDate: 1522450800000,
        RequiredDate: 1524870000000,
        ShippedDate: 1522623600000,
        ShipVia: 'Speedy Express',
        Freight: 34.76,
        ShipName: "Que Del\xedcia",
        ShipAddress: 'Rua da Panificadora, 12',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-673',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10988,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Janet Leverling',
        InvoicedCost: 1303.365,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 124.13,
        OrderCost: 1241.3,
        PackageCost: 12.7,
        OrderDate: 1522450800000,
        RequiredDate: 1524870000000,
        ShippedDate: 1523314800000,
        ShipVia: 'United Package',
        Freight: 61.14,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10987,
        CustomerReference: 'EASTC',
        CompanyName: 'Eastern Connection',
        ContactName: 'Ann Devon',
        Employee: 'Laura Callahan',
        InvoicedCost: 814.0913999999999,
        ItemCount: 6,
        ChangeLastOrder: 2,
        ItemCost: 131.73,
        OrderCost: 790.3799999999999,
        PackageCost: 7.62,
        OrderDate: 1522450800000,
        RequiredDate: 1524870000000,
        ShippedDate: 1522969200000,
        ShipVia: 'Speedy Express',
        Freight: 185.48,
        ShipName: 'Eastern Connection',
        ShipAddress: '35 King George',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'WX3 6FW',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10986,
        CustomerReference: 'OCEAN',
        CompanyName: "Oc\xe9ano Atl\xe1ntico Ltda.",
        ContactName: 'Yvonne Moncada',
        Employee: 'Laura Callahan',
        InvoicedCost: 537.6419999999999,
        ItemCount: 7,
        ChangeLastOrder: 36,
        ItemCost: 90.36,
        OrderCost: 632.52,
        PackageCost: 10.003,
        OrderDate: 1522364400000,
        RequiredDate: 1524783600000,
        ShippedDate: 1524265200000,
        ShipVia: 'United Package',
        Freight: 217.86,
        ShipName: "Oc\xe9ano Atl\xe1ntico Ltda.",
        ShipAddress: 'Ing. Gustavo Moncada 8585, Piso 20-A',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 0
    },
    {
        OrderId: 10985,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1069.8156,
        ItemCount: 7,
        ChangeLastOrder: 2,
        ItemCost: 141.51,
        OrderCost: 990.5699999999999,
        PackageCost: 8.89,
        OrderDate: 1522364400000,
        RequiredDate: 1524783600000,
        ShippedDate: 1522623600000,
        ShipVia: 'Speedy Express',
        Freight: 91.51,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10984,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Nancy Davolio',
        InvoicedCost: 1468.152,
        ItemCount: 12,
        ChangeLastOrder: 5,
        ItemCost: 116.52,
        OrderCost: 1398.24,
        PackageCost: 6.48,
        OrderDate: 1522364400000,
        RequiredDate: 1524783600000,
        ShippedDate: 1522710000000,
        ShipVia: 'Federal Shipping',
        Freight: 211.22,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10983,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1087.4325000000001,
        ItemCount: 11,
        ChangeLastOrder: 5,
        ItemCost: 94.15,
        OrderCost: 1035.65,
        PackageCost: 5.94,
        OrderDate: 1522105200000,
        RequiredDate: 1524524400000,
        ShippedDate: 1522969200000,
        ShipVia: 'United Package',
        Freight: 657.54,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10982,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Andrew Fuller',
        InvoicedCost: 914.5871999999999,
        ItemCount: 12,
        ChangeLastOrder: 4,
        ItemCost: 70.57,
        OrderCost: 846.8399999999999,
        PackageCost: 6.48,
        OrderDate: 1522105200000,
        RequiredDate: 1524524400000,
        ShippedDate: 1523142000000,
        ShipVia: 'Speedy Express',
        Freight: 14.01,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 10981,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Nancy Davolio',
        InvoicedCost: 494.496,
        ItemCount: 12,
        ChangeLastOrder: -22,
        ItemCost: 48.48,
        OrderCost: 581.76,
        PackageCost: 13.799999999999999,
        OrderDate: 1522105200000,
        RequiredDate: 1524524400000,
        ShippedDate: 1522623600000,
        ShipVia: 'United Package',
        Freight: 193.37,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10980,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Margaret Peacock',
        InvoicedCost: 139.70880000000002,
        ItemCount: 8,
        ChangeLastOrder: -1,
        ItemCost: 16.17,
        OrderCost: 129.36,
        PackageCost: 10.16,
        OrderDate: 1522105200000,
        RequiredDate: 1525734000000,
        ShippedDate: 1523919600000,
        ShipVia: 'Speedy Express',
        Freight: 1.26,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10979,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Laura Callahan',
        InvoicedCost: 1342.0365000000002,
        ItemCount: 7,
        ChangeLastOrder: -7,
        ItemCost: 182.59,
        OrderCost: 1278.13,
        PackageCost: 8.049999999999999,
        OrderDate: 1522018800000,
        RequiredDate: 1524438000000,
        ShippedDate: 1522450800000,
        ShipVia: 'United Package',
        Freight: 353.07,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10978,
        CustomerReference: 'MAISD',
        CompanyName: 'Maison Dewey',
        ContactName: 'Catherine Dewey',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1276.9812,
        ItemCount: 11,
        ChangeLastOrder: -39,
        ItemCost: 107.49,
        OrderCost: 1182.3899999999999,
        PackageCost: 12.649999999999999,
        OrderDate: 1522018800000,
        RequiredDate: 1524438000000,
        ShippedDate: 1524438000000,
        ShipVia: 'United Package',
        Freight: 32.82,
        ShipName: 'Maison Dewey',
        ShipAddress: 'Rue Joseph-Bens 532',
        ShipCity: 'Bruxelles',
        ShipRegion: null,
        ShipPostalCode: 'B-1180',
        ShipCountry: 'Belgium',
        ArriveOnTime: 0
    },
    {
        OrderId: 10977,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Laura Callahan',
        InvoicedCost: 1166.8536000000001,
        ItemCount: 6,
        ChangeLastOrder: -1,
        ItemCost: 180.07,
        OrderCost: 1080.42,
        PackageCost: 7.62,
        OrderDate: 1522018800000,
        RequiredDate: 1524438000000,
        ShippedDate: 1523314800000,
        ShipVia: 'Federal Shipping',
        Freight: 208.5,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10976,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Nancy Davolio',
        InvoicedCost: 1287.5618000000002,
        ItemCount: 7,
        ChangeLastOrder: -5,
        ItemCost: 178.58,
        OrderCost: 1250.0600000000002,
        PackageCost: 8.049999999999999,
        OrderDate: 1521932400000,
        RequiredDate: 1525561200000,
        ShippedDate: 1522710000000,
        ShipVia: 'Speedy Express',
        Freight: 37.97,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10975,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Nancy Davolio',
        InvoicedCost: 2159.3952000000004,
        ItemCount: 12,
        ChangeLastOrder: 4,
        ItemCost: 166.62,
        OrderCost: 1999.44,
        PackageCost: 6.48,
        OrderDate: 1521932400000,
        RequiredDate: 1524351600000,
        ShippedDate: 1522105200000,
        ShipVia: 'Federal Shipping',
        Freight: 32.27,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 10974,
        CustomerReference: 'SPLIR',
        CompanyName: 'Split Rail Beer & Ale',
        ContactName: 'Art Braunschweiger',
        Employee: 'Janet Leverling',
        InvoicedCost: 810.4845,
        ItemCount: 7,
        ChangeLastOrder: 10,
        ItemCost: 110.27,
        OrderCost: 771.89,
        PackageCost: 10.003,
        OrderDate: 1521932400000,
        RequiredDate: 1523142000000,
        ShippedDate: 1522710000000,
        ShipVia: 'Federal Shipping',
        Freight: 12.96,
        ShipName: 'Split Rail Beer & Ale',
        ShipAddress: 'P.O. Box 555',
        ShipCity: 'Lander',
        ShipRegion: 'WY',
        ShipPostalCode: 82520,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10973,
        CustomerReference: 'LACOR',
        CompanyName: "La corne d'abondance",
        ContactName: 'Daniel Tonini',
        Employee: 'Michael Suyama',
        InvoicedCost: 2536.9890000000005,
        ItemCount: 13,
        ChangeLastOrder: 2,
        ItemCost: 185.86,
        OrderCost: 2416.1800000000003,
        PackageCost: 16.51,
        OrderDate: 1521846000000,
        RequiredDate: 1524265200000,
        ShippedDate: 1522105200000,
        ShipVia: 'United Package',
        Freight: 15.17,
        ShipName: "La corne d'abondance",
        ShipAddress: "67, avenue de l'Europe",
        ShipCity: 'Versailles',
        ShipRegion: null,
        ShipPostalCode: 78000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10972,
        CustomerReference: 'LACOR',
        CompanyName: "La corne d'abondance",
        ContactName: 'Daniel Tonini',
        Employee: 'Margaret Peacock',
        InvoicedCost: 2010.96,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 191.52,
        OrderCost: 1915.2,
        PackageCost: 12.7,
        OrderDate: 1521846000000,
        RequiredDate: 1524265200000,
        ShippedDate: 1522018800000,
        ShipVia: 'United Package',
        Freight: 0.02,
        ShipName: "La corne d'abondance",
        ShipAddress: "67, avenue de l'Europe",
        ShipCity: 'Versailles',
        ShipRegion: null,
        ShipPostalCode: 78000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10971,
        CustomerReference: 'FRANR',
        CompanyName: 'France restauration',
        ContactName: 'Carine Schmitt',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1396.3859999999997,
        ItemCount: 12,
        ChangeLastOrder: 2,
        ItemCost: 122.49,
        OrderCost: 1469.8799999999999,
        PackageCost: 15.24,
        OrderDate: 1521846000000,
        RequiredDate: 1524265200000,
        ShippedDate: 1522623600000,
        ShipVia: 'United Package',
        Freight: 121.82,
        ShipName: 'France restauration',
        ShipAddress: '54, rue Royale',
        ShipCity: 'Nantes',
        ShipRegion: null,
        ShipPostalCode: 44000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10970,
        CustomerReference: 'BOLID',
        CompanyName: "B\xf3lido Comidas preparadas",
        ContactName: "Mart\xedn Sommer",
        Employee: 'Anne Dodsworth',
        InvoicedCost: 972.468,
        ItemCount: 9,
        ChangeLastOrder: -4,
        ItemCost: 127.12,
        OrderCost: 1144.08,
        PackageCost: 10.35,
        OrderDate: 1521846000000,
        RequiredDate: 1523055600000,
        ShippedDate: 1524524400000,
        ShipVia: 'Speedy Express',
        Freight: 16.16,
        ShipName: "B\xf3lido Comidas preparadas",
        ShipAddress: 'C/ Araquil, 67',
        ShipCity: 'Madrid',
        ShipRegion: null,
        ShipPostalCode: 28023,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10969,
        CustomerReference: 'COMMI',
        CompanyName: "Com\xe9rcio Mineiro",
        ContactName: 'Pedro Afonso',
        Employee: 'Laura Callahan',
        InvoicedCost: 1144.6749999999997,
        ItemCount: 10,
        ChangeLastOrder: -3,
        ItemCost: 130.82,
        OrderCost: 1308.1999999999998,
        PackageCost: 12.7,
        OrderDate: 1521759600000,
        RequiredDate: 1524178800000,
        ShippedDate: 1522364400000,
        ShipVia: 'United Package',
        Freight: 0.21,
        ShipName: "Com\xe9rcio Mineiro",
        ShipAddress: "Av. dos Lus\xedadas, 23",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05432-043',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10968,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Nancy Davolio',
        InvoicedCost: 101.493,
        ItemCount: 9,
        ChangeLastOrder: 13,
        ItemCost: 10.74,
        OrderCost: 96.66,
        PackageCost: 12.861,
        OrderDate: 1521759600000,
        RequiredDate: 1524178800000,
        ShippedDate: 1522537200000,
        ShipVia: 'Federal Shipping',
        Freight: 74.6,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10967,
        CustomerReference: 'TOMSP',
        CompanyName: "Toms Spezialit\xe4ten",
        ContactName: 'Karin Josephs',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1854.515,
        ItemCount: 10,
        ChangeLastOrder: -14,
        ItemCost: 180.05,
        OrderCost: 1800.5,
        PackageCost: 11.5,
        OrderDate: 1521759600000,
        RequiredDate: 1524178800000,
        ShippedDate: 1522623600000,
        ShipVia: 'United Package',
        Freight: 62.22,
        ShipName: "Toms Spezialit\xe4ten",
        ShipAddress: 'Luisenstr. 48',
        ShipCity: "M\xfcnster",
        ShipRegion: null,
        ShipPostalCode: 44087,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10966,
        CustomerReference: 'CHOPS',
        CompanyName: 'Chop-suey Chinese',
        ContactName: 'Yang Wang',
        Employee: 'Margaret Peacock',
        InvoicedCost: 329.71500000000003,
        ItemCount: 9,
        ChangeLastOrder: -18,
        ItemCost: 43.1,
        OrderCost: 387.90000000000003,
        PackageCost: 10.35,
        OrderDate: 1521500400000,
        RequiredDate: 1523919600000,
        ShippedDate: 1523142000000,
        ShipVia: 'Speedy Express',
        Freight: 27.19,
        ShipName: 'Chop-suey Chinese',
        ShipAddress: 'Hauptstr. 31',
        ShipCity: 'Bern',
        ShipRegion: null,
        ShipPostalCode: 3012,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10965,
        CustomerReference: 'OLDWO',
        CompanyName: 'Old World Delicatessen',
        ContactName: 'Rene Phillips',
        Employee: 'Michael Suyama',
        InvoicedCost: 367.98840000000007,
        ItemCount: 13,
        ChangeLastOrder: 3,
        ItemCost: 26.21,
        OrderCost: 340.73,
        PackageCost: 7.0200000000000005,
        OrderDate: 1521500400000,
        RequiredDate: 1523919600000,
        ShippedDate: 1522364400000,
        ShipVia: 'Federal Shipping',
        Freight: 144.38,
        ShipName: 'Old World Delicatessen',
        ShipAddress: '2743 Bering St.',
        ShipCity: 'Anchorage',
        ShipRegion: 'AK',
        ShipPostalCode: 99508,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10964,
        CustomerReference: 'SPECD',
        CompanyName: "Sp\xe9cialit\xe9s du monde",
        ContactName: 'Dominique Perrier',
        Employee: 'Janet Leverling',
        InvoicedCost: 1196.9370000000001,
        ItemCount: 9,
        ChangeLastOrder: 4,
        ItemCost: 126.66,
        OrderCost: 1139.94,
        PackageCost: 4.86,
        OrderDate: 1521500400000,
        RequiredDate: 1523919600000,
        ShippedDate: 1521846000000,
        ShipVia: 'United Package',
        Freight: 87.38,
        ShipName: "Sp\xe9cialit\xe9s du monde",
        ShipAddress: '25, rue Lauriston',
        ShipCity: 'Paris',
        ShipRegion: null,
        ShipPostalCode: 75016,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10963,
        CustomerReference: 'FURIB',
        CompanyName: 'Furia Bacalhau e Frutos do Mar',
        ContactName: 'Lino Rodriguez',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1699.208,
        ItemCount: 14,
        ChangeLastOrder: 31,
        ItemCost: 127.76,
        OrderCost: 1788.64,
        PackageCost: 20.006,
        OrderDate: 1521414000000,
        RequiredDate: 1523833200000,
        ShippedDate: 1522018800000,
        ShipVia: 'Federal Shipping',
        Freight: 2.7,
        ShipName: 'Furia Bacalhau e Frutos do Mar',
        ShipAddress: 'Jardim das rosas n. 32',
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1675,
        ShipCountry: 'Portugal',
        ArriveOnTime: 1
    },
    {
        OrderId: 10962,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Laura Callahan',
        InvoicedCost: 187.25,
        ItemCount: 5,
        ChangeLastOrder: 9,
        ItemCost: 29.96,
        OrderCost: 149.8,
        PackageCost: 7.1450000000000005,
        OrderDate: 1521414000000,
        RequiredDate: 1523833200000,
        ShippedDate: 1521759600000,
        ShipVia: 'United Package',
        Freight: 275.79,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10961,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Laura Callahan',
        InvoicedCost: 11.985,
        ItemCount: 10,
        ChangeLastOrder: -2,
        ItemCost: 1.41,
        OrderCost: 14.1,
        PackageCost: 12.7,
        OrderDate: 1521414000000,
        RequiredDate: 1523833200000,
        ShippedDate: 1522364400000,
        ShipVia: 'Speedy Express',
        Freight: 104.47,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10960,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Janet Leverling',
        InvoicedCost: 175.52249999999998,
        ItemCount: 9,
        ChangeLastOrder: -5,
        ItemCost: 13.45,
        OrderCost: 121.05,
        PackageCost: 10.35,
        OrderDate: 1521414000000,
        RequiredDate: 1522623600000,
        ShippedDate: 1523142000000,
        ShipVia: 'Speedy Express',
        Freight: 2.08,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10959,
        CustomerReference: 'GOURL',
        CompanyName: 'Gourmet Lanchonetes',
        ContactName: "Andr\xe9 Fonseca",
        Employee: 'Michael Suyama',
        InvoicedCost: 1185.696,
        ItemCount: 12,
        ChangeLastOrder: -2,
        ItemCost: 85.92,
        OrderCost: 1031.04,
        PackageCost: 15.24,
        OrderDate: 1521327600000,
        RequiredDate: 1524956400000,
        ShippedDate: 1521759600000,
        ShipVia: 'United Package',
        Freight: 4.98,
        ShipName: 'Gourmet Lanchonetes',
        ShipAddress: 'Av. Brasil, 442',
        ShipCity: 'Campinas',
        ShipRegion: 'SP',
        ShipPostalCode: '04876-786',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10958,
        CustomerReference: 'OCEAN',
        CompanyName: "Oc\xe9ano Atl\xe1ntico Ltda.",
        ContactName: 'Yvonne Moncada',
        Employee: 'Robert King',
        InvoicedCost: 4.1055,
        ItemCount: 7,
        ChangeLastOrder: 34,
        ItemCost: 0.69,
        OrderCost: 4.83,
        PackageCost: 10.003,
        OrderDate: 1521327600000,
        RequiredDate: 1523746800000,
        ShippedDate: 1522105200000,
        ShipVia: 'United Package',
        Freight: 49.56,
        ShipName: "Oc\xe9ano Atl\xe1ntico Ltda.",
        ShipAddress: 'Ing. Gustavo Moncada 8585, Piso 20-A',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 0
    },
    {
        OrderId: 10957,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Laura Callahan',
        InvoicedCost: 1446.8616,
        ItemCount: 12,
        ChangeLastOrder: -5,
        ItemCost: 117.06,
        OrderCost: 1404.72,
        PackageCost: 13.799999999999999,
        OrderDate: 1521327600000,
        RequiredDate: 1523746800000,
        ShippedDate: 1522105200000,
        ShipVia: 'Federal Shipping',
        Freight: 105.36,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10956,
        CustomerReference: 'BLAUS',
        CompanyName: 'Blauer See Delikatessen',
        ContactName: 'Hanna Moos',
        Employee: 'Michael Suyama',
        InvoicedCost: 1628.3682000000001,
        ItemCount: 9,
        ChangeLastOrder: 19,
        ItemCost: 175.66,
        OrderCost: 1580.94,
        PackageCost: 12.861,
        OrderDate: 1521241200000,
        RequiredDate: 1524870000000,
        ShippedDate: 1521500400000,
        ShipVia: 'United Package',
        Freight: 44.65,
        ShipName: 'Blauer See Delikatessen',
        ShipAddress: 'Forsterstr. 57',
        ShipCity: 'Mannheim',
        ShipRegion: null,
        ShipPostalCode: 68306,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10955,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Laura Callahan',
        InvoicedCost: 89.48880000000001,
        ItemCount: 6,
        ChangeLastOrder: -1,
        ItemCost: 13.81,
        OrderCost: 82.86,
        PackageCost: 7.62,
        OrderDate: 1521241200000,
        RequiredDate: 1523660400000,
        ShippedDate: 1521500400000,
        ShipVia: 'United Package',
        Freight: 3.26,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10954,
        CustomerReference: 'LINOD',
        CompanyName: 'LINO-Delicateses',
        ContactName: 'Felipe Izquierdo',
        Employee: 'Steven Buchanan',
        InvoicedCost: 582.671,
        ItemCount: 10,
        ChangeLastOrder: -3,
        ItemCost: 56.57,
        OrderCost: 565.7,
        PackageCost: 12.7,
        OrderDate: 1521241200000,
        RequiredDate: 1524870000000,
        ShippedDate: 1521500400000,
        ShipVia: 'Speedy Express',
        Freight: 27.91,
        ShipName: 'LINO-Delicateses',
        ShipAddress: 'Ave. 5 de Mayo Porlamar',
        ShipCity: 'I. de Margarita',
        ShipRegion: 'Nueva Esparta',
        ShipPostalCode: 4980,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10953,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 0,
        ItemCount: 7,
        ChangeLastOrder: -4,
        ItemCost: 0,
        OrderCost: 0,
        PackageCost: 8.049999999999999,
        OrderDate: 1521154800000,
        RequiredDate: 1522364400000,
        ShippedDate: 1521932400000,
        ShipVia: 'United Package',
        Freight: 23.72,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10952,
        CustomerReference: 'ALFKI',
        CompanyName: 'Alfreds Futterkiste',
        ContactName: 'Maria Anders',
        Employee: 'Nancy Davolio',
        InvoicedCost: 897.5064999999998,
        ItemCount: 11,
        ChangeLastOrder: 20,
        ItemCost: 95.99,
        OrderCost: 1055.8899999999999,
        PackageCost: 15.719000000000001,
        OrderDate: 1521154800000,
        RequiredDate: 1524783600000,
        ShippedDate: 1521846000000,
        ShipVia: 'Speedy Express',
        Freight: 40.42,
        ShipName: 'Alfreds Futterkiste',
        ShipAddress: 'Obere Str. 57',
        ShipCity: 'Berlin',
        ShipRegion: null,
        ShipPostalCode: 12209,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10951,
        CustomerReference: 'RICSU',
        CompanyName: 'Richter Supermarkt',
        ContactName: 'Michael Holz',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1297.8,
        ItemCount: 8,
        ChangeLastOrder: 4,
        ItemCost: 185.4,
        OrderCost: 1483.2,
        PackageCost: 4.32,
        OrderDate: 1521154800000,
        RequiredDate: 1524783600000,
        ShippedDate: 1523055600000,
        ShipVia: 'United Package',
        Freight: 30.85,
        ShipName: 'Richter Supermarkt',
        ShipAddress: 'Starenweg 5',
        ShipCity: "Gen\xe8ve",
        ShipRegion: null,
        ShipPostalCode: 1204,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10950,
        CustomerReference: 'MAGAA',
        CompanyName: 'Magazzini Alimentari Riuniti',
        ContactName: 'Giovanni Rovelli',
        Employee: 'Nancy Davolio',
        InvoicedCost: 244.749,
        ItemCount: 6,
        ChangeLastOrder: -10,
        ItemCost: 47.99,
        OrderCost: 287.94,
        PackageCost: 6.8999999999999995,
        OrderDate: 1521154800000,
        RequiredDate: 1523574000000,
        ShippedDate: 1521759600000,
        ShipVia: 'United Package',
        Freight: 2.5,
        ShipName: 'Magazzini Alimentari Riuniti',
        ShipAddress: 'Via Ludovico il Moro 22',
        ShipCity: 'Bergamo',
        ShipRegion: null,
        ShipPostalCode: 24100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10949,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1394.9279999999999,
        ItemCount: 10,
        ChangeLastOrder: 4,
        ItemCost: 129.16,
        OrderCost: 1291.6,
        PackageCost: 5.4,
        OrderDate: 1520895600000,
        RequiredDate: 1523314800000,
        ShippedDate: 1521241200000,
        ShipVia: 'Federal Shipping',
        Freight: 74.44,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10948,
        CustomerReference: 'GODOS',
        CompanyName: "Godos Cocina T\xedpica",
        ContactName: "Jos\xe9 Pedro Freyre",
        Employee: 'Janet Leverling',
        InvoicedCost: 1676.9115,
        ItemCount: 9,
        ChangeLastOrder: -4,
        ItemCost: 196.13,
        OrderCost: 1765.17,
        PackageCost: 10.35,
        OrderDate: 1520895600000,
        RequiredDate: 1523314800000,
        ShippedDate: 1521414000000,
        ShipVia: 'Federal Shipping',
        Freight: 23.39,
        ShipName: "Godos Cocina T\xedpica",
        ShipAddress: 'C/ Romero, 33',
        ShipCity: 'Sevilla',
        ShipRegion: null,
        ShipPostalCode: 41101,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10947,
        CustomerReference: 'BSBEV',
        CompanyName: "B's Beverages",
        ContactName: 'Victoria Ashworth',
        Employee: 'Janet Leverling',
        InvoicedCost: 1132.6392,
        ItemCount: 7,
        ChangeLastOrder: -18,
        ItemCost: 149.82,
        OrderCost: 1048.74,
        PackageCost: 8.049999999999999,
        OrderDate: 1520895600000,
        RequiredDate: 1523314800000,
        ShippedDate: 1521154800000,
        ShipVia: 'United Package',
        Freight: 3.26,
        ShipName: "B's Beverages",
        ShipAddress: 'Fauntleroy Circus',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'EC2 5NT',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10946,
        CustomerReference: 'VAFFE',
        CompanyName: 'Vaffeljernet',
        ContactName: 'Palle Ibsen',
        Employee: 'Nancy Davolio',
        InvoicedCost: 20.37,
        ItemCount: 10,
        ChangeLastOrder: 19,
        ItemCost: 1.94,
        OrderCost: 19.4,
        PackageCost: 14.290000000000001,
        OrderDate: 1520809200000,
        RequiredDate: 1523228400000,
        ShippedDate: 1521414000000,
        ShipVia: 'United Package',
        Freight: 27.2,
        ShipName: 'Vaffeljernet',
        ShipAddress: "Smagsl\xf8get 45",
        ShipCity: "\xc5rhus",
        ShipRegion: null,
        ShipPostalCode: 8200,
        ShipCountry: 'Denmark',
        ArriveOnTime: 1
    },
    {
        OrderId: 10945,
        CustomerReference: 'MORGK',
        CompanyName: 'Morgenstern Gesundkost',
        ContactName: 'Alexander Feuer',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1827.3951000000002,
        ItemCount: 9,
        ChangeLastOrder: -21,
        ItemCost: 197.13,
        OrderCost: 1774.17,
        PackageCost: 10.35,
        OrderDate: 1520809200000,
        RequiredDate: 1523228400000,
        ShippedDate: 1521327600000,
        ShipVia: 'Speedy Express',
        Freight: 10.22,
        ShipName: 'Morgenstern Gesundkost',
        ShipAddress: 'Heerstr. 22',
        ShipCity: 'Leipzig',
        ShipRegion: null,
        ShipPostalCode: 4179,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10944,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Michael Suyama',
        InvoicedCost: 2458.1232,
        ItemCount: 13,
        ChangeLastOrder: 4,
        ItemCost: 175.08,
        OrderCost: 2276.04,
        PackageCost: 7.0200000000000005,
        OrderDate: 1520809200000,
        RequiredDate: 1522018800000,
        ShippedDate: 1520895600000,
        ShipVia: 'Federal Shipping',
        Freight: 52.92,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10943,
        CustomerReference: 'BSBEV',
        CompanyName: "B's Beverages",
        ContactName: 'Victoria Ashworth',
        Employee: 'Margaret Peacock',
        InvoicedCost: 409.6008,
        ItemCount: 9,
        ChangeLastOrder: -19,
        ItemCost: 42.14,
        OrderCost: 379.26,
        PackageCost: 10.35,
        OrderDate: 1520722800000,
        RequiredDate: 1523142000000,
        ShippedDate: 1521414000000,
        ShipVia: 'United Package',
        Freight: 2.17,
        ShipName: "B's Beverages",
        ShipAddress: 'Fauntleroy Circus',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'EC2 5NT',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10942,
        CustomerReference: 'REGGC',
        CompanyName: 'Reggiani Caseifici',
        ContactName: 'Maurizio Moroni',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 37.422000000000004,
        ItemCount: 7,
        ChangeLastOrder: -7,
        ItemCost: 11.88,
        OrderCost: 83.16000000000001,
        PackageCost: 8.049999999999999,
        OrderDate: 1520722800000,
        RequiredDate: 1523142000000,
        ShippedDate: 1521327600000,
        ShipVia: 'Federal Shipping',
        Freight: 17.95,
        ShipName: 'Reggiani Caseifici',
        ShipAddress: 'Strada Provinciale 124',
        ShipCity: 'Reggio Emilia',
        ShipRegion: null,
        ShipPostalCode: 42100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10941,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Robert King',
        InvoicedCost: 512.295,
        ItemCount: 5,
        ChangeLastOrder: 5,
        ItemCost: 97.58,
        OrderCost: 487.9,
        PackageCost: 2.7,
        OrderDate: 1520722800000,
        RequiredDate: 1523142000000,
        ShippedDate: 1521500400000,
        ShipVia: 'United Package',
        Freight: 400.81,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10940,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Laura Callahan',
        InvoicedCost: 838.644,
        ItemCount: 12,
        ChangeLastOrder: 6,
        ItemCost: 82.22,
        OrderCost: 986.64,
        PackageCost: 16.572,
        OrderDate: 1520722800000,
        RequiredDate: 1523142000000,
        ShippedDate: 1521759600000,
        ShipVia: 'Federal Shipping',
        Freight: 19.77,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10939,
        CustomerReference: 'MAGAA',
        CompanyName: 'Magazzini Alimentari Riuniti',
        ContactName: 'Giovanni Rovelli',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1264.27,
        ItemCount: 8,
        ChangeLastOrder: 8,
        ItemCost: 180.61,
        OrderCost: 1444.88,
        PackageCost: 11.048,
        OrderDate: 1520636400000,
        RequiredDate: 1523055600000,
        ShippedDate: 1520895600000,
        ShipVia: 'United Package',
        Freight: 76.33,
        ShipName: 'Magazzini Alimentari Riuniti',
        ShipAddress: 'Via Ludovico il Moro 22',
        ShipCity: 'Bergamo',
        ShipRegion: null,
        ShipPostalCode: 24100,
        ShipCountry: 'Italy',
        ArriveOnTime: 0
    },
    {
        OrderId: 10938,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Janet Leverling',
        InvoicedCost: 511.36249999999995,
        ItemCount: 11,
        ChangeLastOrder: -9,
        ItemCost: 37.19,
        OrderCost: 409.09,
        PackageCost: 12.649999999999999,
        OrderDate: 1520636400000,
        RequiredDate: 1523055600000,
        ShippedDate: 1521154800000,
        ShipVia: 'United Package',
        Freight: 31.89,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10937,
        CustomerReference: 'CACTU',
        CompanyName: 'Cactus Comidas para llevar',
        ContactName: 'Patricio Simpson',
        Employee: 'Robert King',
        InvoicedCost: 608.9399999999999,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 71.64,
        OrderCost: 716.4,
        PackageCost: 12.7,
        OrderDate: 1520636400000,
        RequiredDate: 1521846000000,
        ShippedDate: 1520895600000,
        ShipVia: 'Federal Shipping',
        Freight: 31.51,
        ShipName: 'Cactus Comidas para llevar',
        ShipAddress: 'Cerrito 333',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 1
    },
    {
        OrderId: 10936,
        CustomerReference: 'GREAL',
        CompanyName: 'Great Lakes Food Market',
        ContactName: 'Howard Snyder',
        Employee: 'Janet Leverling',
        InvoicedCost: 295.06680000000006,
        ItemCount: 7,
        ChangeLastOrder: 3,
        ItemCost: 39.03,
        OrderCost: 273.21000000000004,
        PackageCost: 3.7800000000000002,
        OrderDate: 1520550000000,
        RequiredDate: 1522969200000,
        ShippedDate: 1521327600000,
        ShipVia: 'United Package',
        Freight: 33.68,
        ShipName: 'Great Lakes Food Market',
        ShipAddress: '2732 Baker Blvd.',
        ShipCity: 'Eugene',
        ShipRegion: 'OR',
        ShipPostalCode: 97403,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10935,
        CustomerReference: 'WELLI',
        CompanyName: 'Wellington Importadora',
        ContactName: 'Paula Parente',
        Employee: 'Margaret Peacock',
        InvoicedCost: 675.92,
        ItemCount: 7,
        ChangeLastOrder: -10,
        ItemCost: 113.6,
        OrderCost: 795.1999999999999,
        PackageCost: 8.049999999999999,
        OrderDate: 1520550000000,
        RequiredDate: 1522969200000,
        ShippedDate: 1521327600000,
        ShipVia: 'Federal Shipping',
        Freight: 47.59,
        ShipName: 'Wellington Importadora',
        ShipAddress: 'Rua do Mercado, 12',
        ShipCity: 'Resende',
        ShipRegion: 'SP',
        ShipPostalCode: '08737-363',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10934,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Janet Leverling',
        InvoicedCost: 423.90149999999994,
        ItemCount: 11,
        ChangeLastOrder: -22,
        ItemCost: 33.51,
        OrderCost: 368.60999999999996,
        PackageCost: 12.649999999999999,
        OrderDate: 1520550000000,
        RequiredDate: 1522969200000,
        ShippedDate: 1520809200000,
        ShipVia: 'Federal Shipping',
        Freight: 32.01,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10933,
        CustomerReference: 'ISLAT',
        CompanyName: 'Island Trading',
        ContactName: 'Helen Bennett',
        Employee: 'Michael Suyama',
        InvoicedCost: 1430.5248000000001,
        ItemCount: 12,
        ChangeLastOrder: 13,
        ItemCost: 110.38,
        OrderCost: 1324.56,
        PackageCost: 17.148,
        OrderDate: 1520290800000,
        RequiredDate: 1522710000000,
        ShippedDate: 1521154800000,
        ShipVia: 'Federal Shipping',
        Freight: 54.15,
        ShipName: 'Island Trading',
        ShipAddress: 'Garden House, Crowther Way',
        ShipCity: 'Cowes',
        ShipRegion: 'Isle of Wight',
        ShipPostalCode: 'PO31 7PJ',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10932,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Laura Callahan',
        InvoicedCost: 441.06499999999994,
        ItemCount: 10,
        ChangeLastOrder: 5,
        ItemCost: 51.89,
        OrderCost: 518.9,
        PackageCost: 5.4,
        OrderDate: 1520290800000,
        RequiredDate: 1522710000000,
        ShippedDate: 1521846000000,
        ShipVia: 'Speedy Express',
        Freight: 134.64,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10931,
        CustomerReference: 'RICSU',
        CompanyName: 'Richter Supermarkt',
        ContactName: 'Michael Holz',
        Employee: 'Margaret Peacock',
        InvoicedCost: 990.216,
        ItemCount: 12,
        ChangeLastOrder: 3,
        ItemCost: 97.08,
        OrderCost: 1164.96,
        PackageCost: 6.48,
        OrderDate: 1520290800000,
        RequiredDate: 1521500400000,
        ShippedDate: 1521414000000,
        ShipVia: 'United Package',
        Freight: 13.6,
        ShipName: 'Richter Supermarkt',
        ShipAddress: 'Starenweg 5',
        ShipCity: "Gen\xe8ve",
        ShipRegion: null,
        ShipPostalCode: 1204,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10930,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Margaret Peacock',
        InvoicedCost: 651.1752,
        ItemCount: 6,
        ChangeLastOrder: -4,
        ItemCost: 100.49,
        OrderCost: 602.9399999999999,
        PackageCost: 6.8999999999999995,
        OrderDate: 1520290800000,
        RequiredDate: 1523919600000,
        ShippedDate: 1521327600000,
        ShipVia: 'Federal Shipping',
        Freight: 15.55,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 1
    },
    {
        OrderId: 10929,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Michael Suyama',
        InvoicedCost: 661.689,
        ItemCount: 9,
        ChangeLastOrder: -4,
        ItemCost: 70.02,
        OrderCost: 630.18,
        PackageCost: 10.35,
        OrderDate: 1520204400000,
        RequiredDate: 1522623600000,
        ShippedDate: 1520809200000,
        ShipVia: 'Speedy Express',
        Freight: 33.93,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10928,
        CustomerReference: 'GALED',
        CompanyName: "Galer\xeda del gastr\xf3nomo",
        ContactName: 'Eduardo Saavedra',
        Employee: 'Nancy Davolio',
        InvoicedCost: 1358.8575,
        ItemCount: 11,
        ChangeLastOrder: 1,
        ItemCost: 117.65,
        OrderCost: 1294.15,
        PackageCost: 13.97,
        OrderDate: 1520204400000,
        RequiredDate: 1522623600000,
        ShippedDate: 1521327600000,
        ShipVia: 'Speedy Express',
        Freight: 1.36,
        ShipName: "Galer\xeda del gastron\xf3mo",
        ShipAddress: "Rambla de Catalu\xf1a, 23",
        ShipCity: 'Barcelona',
        ShipRegion: null,
        ShipPostalCode: 8022,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10927,
        CustomerReference: 'LACOR',
        CompanyName: "La corne d'abondance",
        ContactName: 'Daniel Tonini',
        Employee: 'Margaret Peacock',
        InvoicedCost: 797.1390000000001,
        ItemCount: 6,
        ChangeLastOrder: 2,
        ItemCost: 126.53,
        OrderCost: 759.1800000000001,
        PackageCost: 7.62,
        OrderDate: 1520204400000,
        RequiredDate: 1522623600000,
        ShippedDate: 1523142000000,
        ShipVia: 'Speedy Express',
        Freight: 19.79,
        ShipName: "La corne d'abondance",
        ShipAddress: "67, avenue de l'Europe",
        ShipCity: 'Versailles',
        ShipRegion: null,
        ShipPostalCode: 78000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10926,
        CustomerReference: 'ANATR',
        CompanyName: 'Ana Trujillo Emparedados y helados',
        ContactName: 'Ana Trujillo',
        Employee: 'Margaret Peacock',
        InvoicedCost: 863.6039999999999,
        ItemCount: 7,
        ChangeLastOrder: -3,
        ItemCost: 107.28,
        OrderCost: 750.96,
        PackageCost: 8.89,
        OrderDate: 1520118000000,
        RequiredDate: 1522537200000,
        ShippedDate: 1520722800000,
        ShipVia: 'Federal Shipping',
        Freight: 39.92,
        ShipName: 'Ana Trujillo Emparedados y helados',
        ShipAddress: "Avda. de la Constituci\xf3n 2222",
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5021,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10925,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Janet Leverling',
        InvoicedCost: 1765.9549999999997,
        ItemCount: 10,
        ChangeLastOrder: -21,
        ItemCost: 185.89,
        OrderCost: 1858.8999999999999,
        PackageCost: 11.5,
        OrderDate: 1520118000000,
        RequiredDate: 1522537200000,
        ShippedDate: 1520895600000,
        ShipVia: 'Speedy Express',
        Freight: 2.27,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10924,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Janet Leverling',
        InvoicedCost: 1248.0156,
        ItemCount: 13,
        ChangeLastOrder: -3,
        ItemCost: 88.89,
        OrderCost: 1155.57,
        PackageCost: 16.51,
        OrderDate: 1520118000000,
        RequiredDate: 1522537200000,
        ShippedDate: 1523142000000,
        ShipVia: 'United Package',
        Freight: 151.52,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10923,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Robert King',
        InvoicedCost: 1817.1505,
        ItemCount: 11,
        ChangeLastOrder: 6,
        ItemCost: 173.89,
        OrderCost: 1912.79,
        PackageCost: 15.191,
        OrderDate: 1520031600000,
        RequiredDate: 1523660400000,
        ShippedDate: 1520895600000,
        ShipVia: 'Federal Shipping',
        Freight: 68.26,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10922,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Steven Buchanan',
        InvoicedCost: 210.001,
        ItemCount: 11,
        ChangeLastOrder: -26,
        ItemCost: 22.46,
        OrderCost: 247.06,
        PackageCost: 12.649999999999999,
        OrderDate: 1520031600000,
        RequiredDate: 1522450800000,
        ShippedDate: 1520204400000,
        ShipVia: 'Federal Shipping',
        Freight: 62.74,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10921,
        CustomerReference: 'VAFFE',
        CompanyName: 'Vaffeljernet',
        ContactName: 'Palle Ibsen',
        Employee: 'Nancy Davolio',
        InvoicedCost: 432.05400000000003,
        ItemCount: 12,
        ChangeLastOrder: 12,
        ItemCost: 34.29,
        OrderCost: 411.48,
        PackageCost: 17.148,
        OrderDate: 1520031600000,
        RequiredDate: 1523660400000,
        ShippedDate: 1520550000000,
        ShipVia: 'Speedy Express',
        Freight: 176.48,
        ShipName: 'Vaffeljernet',
        ShipAddress: "Smagsl\xf8get 45",
        ShipCity: "\xc5rhus",
        ShipRegion: null,
        ShipPostalCode: 8200,
        ShipCountry: 'Denmark',
        ArriveOnTime: 0
    },
    {
        OrderId: 10920,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1606.7160000000001,
        ItemCount: 10,
        ChangeLastOrder: -4,
        ItemCost: 148.77,
        OrderCost: 1487.7,
        PackageCost: 11.5,
        OrderDate: 1520031600000,
        RequiredDate: 1522450800000,
        ShippedDate: 1520550000000,
        ShipVia: 'United Package',
        Freight: 29.61,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10919,
        CustomerReference: 'LINOD',
        CompanyName: 'LINO-Delicateses',
        ContactName: 'Felipe Izquierdo',
        Employee: 'Andrew Fuller',
        InvoicedCost: 2306.9631,
        ItemCount: 13,
        ChangeLastOrder: -3,
        ItemCost: 172.29,
        OrderCost: 2239.77,
        PackageCost: 16.51,
        OrderDate: 1519945200000,
        RequiredDate: 1522364400000,
        ShippedDate: 1520118000000,
        ShipVia: 'United Package',
        Freight: 19.8,
        ShipName: 'LINO-Delicateses',
        ShipAddress: 'Ave. 5 de Mayo Porlamar',
        ShipCity: 'I. de Margarita',
        ShipRegion: 'Nueva Esparta',
        ShipPostalCode: 4980,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10918,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Janet Leverling',
        InvoicedCost: 1611.2736000000002,
        ItemCount: 8,
        ChangeLastOrder: 4,
        ItemCost: 186.49,
        OrderCost: 1491.92,
        PackageCost: 4.32,
        OrderDate: 1519945200000,
        RequiredDate: 1522364400000,
        ShippedDate: 1520722800000,
        ShipVia: 'Federal Shipping',
        Freight: 48.83,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10917,
        CustomerReference: 'ROMEY',
        CompanyName: 'Romero y tomillo',
        ContactName: 'Alejandra Camino',
        Employee: 'Margaret Peacock',
        InvoicedCost: 480.92999999999995,
        ItemCount: 10,
        ChangeLastOrder: -8,
        ItemCost: 56.58,
        OrderCost: 565.8,
        PackageCost: 11.5,
        OrderDate: 1519945200000,
        RequiredDate: 1522364400000,
        ShippedDate: 1520722800000,
        ShipVia: 'United Package',
        Freight: 8.29,
        ShipName: 'Romero y tomillo',
        ShipAddress: "Gran V\xeda, 1",
        ShipCity: 'Madrid',
        ShipRegion: null,
        ShipPostalCode: 28001,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10916,
        CustomerReference: 'RANCH',
        CompanyName: 'Rancho grande',
        ContactName: "Sergio Guti\xe9rrez",
        Employee: 'Nancy Davolio',
        InvoicedCost: 915.0419999999999,
        ItemCount: 12,
        ChangeLastOrder: -2,
        ItemCost: 89.71,
        OrderCost: 1076.52,
        PackageCost: 15.24,
        OrderDate: 1519686000000,
        RequiredDate: 1522105200000,
        ShippedDate: 1520550000000,
        ShipVia: 'United Package',
        Freight: 63.77,
        ShipName: 'Rancho grande',
        ShipAddress: 'Av. del Libertador 900',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 0
    },
    {
        OrderId: 10915,
        CustomerReference: 'TORTU',
        CompanyName: 'Tortuga Restaurante',
        ContactName: 'Miguel Angel Paolino',
        Employee: 'Andrew Fuller',
        InvoicedCost: 595.424,
        ItemCount: 8,
        ChangeLastOrder: -3,
        ItemCost: 64.72,
        OrderCost: 517.76,
        PackageCost: 10.16,
        OrderDate: 1519686000000,
        RequiredDate: 1522105200000,
        ShippedDate: 1519945200000,
        ShipVia: 'United Package',
        Freight: 3.51,
        ShipName: 'Tortuga Restaurante',
        ShipAddress: 'Avda. Azteca 123',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10914,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Michael Suyama',
        InvoicedCost: 106.641,
        ItemCount: 6,
        ChangeLastOrder: -2,
        ItemCost: 20.91,
        OrderCost: 125.46000000000001,
        PackageCost: 7.62,
        OrderDate: 1519686000000,
        RequiredDate: 1522105200000,
        ShippedDate: 1519945200000,
        ShipVia: 'Speedy Express',
        Freight: 21.19,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10913,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Margaret Peacock',
        InvoicedCost: 125.62999999999998,
        ItemCount: 10,
        ChangeLastOrder: -2,
        ItemCost: 14.78,
        OrderCost: 147.79999999999998,
        PackageCost: 12.7,
        OrderDate: 1519599600000,
        RequiredDate: 1522018800000,
        ShippedDate: 1520118000000,
        ShipVia: 'Speedy Express',
        Freight: 33.05,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10912,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1372.95,
        ItemCount: 9,
        ChangeLastOrder: 2,
        ItemCost: 141.25,
        OrderCost: 1271.25,
        PackageCost: 11.43,
        OrderDate: 1519599600000,
        RequiredDate: 1522018800000,
        ShippedDate: 1521327600000,
        ShipVia: 'United Package',
        Freight: 580.91,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10911,
        CustomerReference: 'GODOS',
        CompanyName: "Godos Cocina T\xedpica",
        ContactName: "Jos\xe9 Pedro Freyre",
        Employee: 'Janet Leverling',
        InvoicedCost: 39.447,
        ItemCount: 6,
        ChangeLastOrder: -4,
        ItemCost: 14.61,
        OrderCost: 87.66,
        PackageCost: 6.8999999999999995,
        OrderDate: 1519599600000,
        RequiredDate: 1522018800000,
        ShippedDate: 1520204400000,
        ShipVia: 'Speedy Express',
        Freight: 38.19,
        ShipName: "Godos Cocina T\xedpica",
        ShipAddress: 'C/ Romero, 33',
        ShipCity: 'Sevilla',
        ShipRegion: null,
        ShipPostalCode: 41101,
        ShipCountry: 'Spain',
        ArriveOnTime: 0
    },
    {
        OrderId: 10910,
        CustomerReference: 'WILMK',
        CompanyName: 'Wilman Kala',
        ContactName: 'Matti Karttunen',
        Employee: 'Nancy Davolio',
        InvoicedCost: 2198.9175,
        ItemCount: 13,
        ChangeLastOrder: 23,
        ItemCost: 178.05,
        OrderCost: 2314.65,
        PackageCost: 18.577,
        OrderDate: 1519599600000,
        RequiredDate: 1522018800000,
        ShippedDate: 1520118000000,
        ShipVia: 'Federal Shipping',
        Freight: 38.11,
        ShipName: 'Wilman Kala',
        ShipAddress: 'Keskuskatu 45',
        ShipCity: 'Helsinki',
        ShipRegion: null,
        ShipPostalCode: 21240,
        ShipCountry: 'Finland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10909,
        CustomerReference: 'SANTG',
        CompanyName: "Sant\xe9 Gourmet",
        ContactName: 'Jonas Bergulfsen',
        Employee: 'Nancy Davolio',
        InvoicedCost: 905.641,
        ItemCount: 11,
        ChangeLastOrder: -6,
        ItemCost: 96.86,
        OrderCost: 1065.46,
        PackageCost: 12.649999999999999,
        OrderDate: 1519599600000,
        RequiredDate: 1522018800000,
        ShippedDate: 1520636400000,
        ShipVia: 'United Package',
        Freight: 53.05,
        ShipName: "Sant\xe9 Gourmet",
        ShipAddress: 'Erling Skakkes gate 78',
        ShipCity: 'Stavern',
        ShipRegion: null,
        ShipPostalCode: 4110,
        ShipCountry: 'Norway',
        ArriveOnTime: 0
    },
    {
        OrderId: 10908,
        CustomerReference: 'REGGC',
        CompanyName: 'Reggiani Caseifici',
        ContactName: 'Maurizio Moroni',
        Employee: 'Margaret Peacock',
        InvoicedCost: 910.784,
        ItemCount: 8,
        ChangeLastOrder: -6,
        ItemCost: 119.84,
        OrderCost: 958.72,
        PackageCost: 9.2,
        OrderDate: 1519599600000,
        RequiredDate: 1522018800000,
        ShippedDate: 1520290800000,
        ShipVia: 'United Package',
        Freight: 32.96,
        ShipName: 'Reggiani Caseifici',
        ShipAddress: 'Strada Provinciale 124',
        ShipCity: 'Reggio Emilia',
        ShipRegion: null,
        ShipPostalCode: 42100,
        ShipCountry: 'Italy',
        ArriveOnTime: 0
    },
    {
        OrderId: 10907,
        CustomerReference: 'SPECD',
        CompanyName: "Sp\xe9cialit\xe9s du monde",
        ContactName: 'Dominique Perrier',
        Employee: 'Michael Suyama',
        InvoicedCost: 1449.21,
        ItemCount: 10,
        ChangeLastOrder: 4,
        ItemCost: 138.02,
        OrderCost: 1380.2,
        PackageCost: 5.4,
        OrderDate: 1519513200000,
        RequiredDate: 1521932400000,
        ShippedDate: 1519686000000,
        ShipVia: 'Federal Shipping',
        Freight: 9.19,
        ShipName: "Sp\xe9cialit\xe9s du monde",
        ShipAddress: '25, rue Lauriston',
        ShipCity: 'Paris',
        ShipRegion: null,
        ShipPostalCode: 75016,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10906,
        CustomerReference: 'WOLZA',
        CompanyName: 'Wolski  Zajazd',
        ContactName: 'Zbyszek Piestrzeniewicz',
        Employee: 'Margaret Peacock',
        InvoicedCost: 905.9056,
        ItemCount: 8,
        ChangeLastOrder: 32,
        ItemCost: 109.94,
        OrderCost: 879.52,
        PackageCost: 11.432,
        OrderDate: 1519513200000,
        RequiredDate: 1520722800000,
        ShippedDate: 1520031600000,
        ShipVia: 'Federal Shipping',
        Freight: 26.29,
        ShipName: 'Wolski Zajazd',
        ShipAddress: 'ul. Filtrowa 68',
        ShipCity: 'Warszawa',
        ShipRegion: null,
        ShipPostalCode: '01-012',
        ShipCountry: 'Poland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10905,
        CustomerReference: 'WELLI',
        CompanyName: 'Wellington Importadora',
        ContactName: 'Paula Parente',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 89.964,
        ItemCount: 9,
        ChangeLastOrder: -17,
        ItemCost: 11.76,
        OrderCost: 105.84,
        PackageCost: 10.35,
        OrderDate: 1519426800000,
        RequiredDate: 1521846000000,
        ShippedDate: 1520290800000,
        ShipVia: 'United Package',
        Freight: 13.72,
        ShipName: 'Wellington Importadora',
        ShipAddress: 'Rua do Mercado, 12',
        ShipCity: 'Resende',
        ShipRegion: 'SP',
        ShipPostalCode: '08737-363',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10904,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Janet Leverling',
        InvoicedCost: 815.0112,
        ItemCount: 8,
        ChangeLastOrder: 6,
        ItemCost: 94.33,
        OrderCost: 754.64,
        PackageCost: 11.048,
        OrderDate: 1519426800000,
        RequiredDate: 1521846000000,
        ShippedDate: 1519686000000,
        ShipVia: 'Federal Shipping',
        Freight: 162.95,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10903,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Janet Leverling',
        InvoicedCost: 814.266,
        ItemCount: 6,
        ChangeLastOrder: -19,
        ItemCost: 159.66,
        OrderCost: 957.96,
        PackageCost: 6.8999999999999995,
        OrderDate: 1519426800000,
        RequiredDate: 1521846000000,
        ShippedDate: 1520118000000,
        ShipVia: 'Federal Shipping',
        Freight: 36.71,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10902,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Nancy Davolio',
        InvoicedCost: 561.492,
        ItemCount: 10,
        ChangeLastOrder: -1,
        ItemCost: 51.99,
        OrderCost: 519.9,
        PackageCost: 12.7,
        OrderDate: 1519340400000,
        RequiredDate: 1521759600000,
        ShippedDate: 1520031600000,
        ShipVia: 'Speedy Express',
        Freight: 44.15,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10901,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Margaret Peacock',
        InvoicedCost: 580.9817999999999,
        ItemCount: 7,
        ChangeLastOrder: -5,
        ItemCost: 80.58,
        OrderCost: 564.06,
        PackageCost: 8.049999999999999,
        OrderDate: 1519340400000,
        RequiredDate: 1521759600000,
        ShippedDate: 1519599600000,
        ShipVia: 'Speedy Express',
        Freight: 62.09,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10900,
        CustomerReference: 'WELLI',
        CompanyName: 'Wellington Importadora',
        ContactName: 'Paula Parente',
        Employee: 'Nancy Davolio',
        InvoicedCost: 970.9975,
        ItemCount: 11,
        ChangeLastOrder: -9,
        ItemCost: 103.85,
        OrderCost: 1142.35,
        PackageCost: 12.649999999999999,
        OrderDate: 1519081200000,
        RequiredDate: 1521500400000,
        ShippedDate: 1520118000000,
        ShipVia: 'United Package',
        Freight: 1.66,
        ShipName: 'Wellington Importadora',
        ShipAddress: 'Rua do Mercado, 12',
        ShipCity: 'Resende',
        ShipRegion: 'SP',
        ShipPostalCode: '08737-363',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10899,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Steven Buchanan',
        InvoicedCost: 1053.4475,
        ItemCount: 7,
        ChangeLastOrder: 16,
        ItemCost: 177.05,
        OrderCost: 1239.3500000000001,
        PackageCost: 10.003,
        OrderDate: 1519081200000,
        RequiredDate: 1521500400000,
        ShippedDate: 1519599600000,
        ShipVia: 'Federal Shipping',
        Freight: 1.21,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10898,
        CustomerReference: 'OCEAN',
        CompanyName: "Oc\xe9ano Atl\xe1ntico Ltda.",
        ContactName: 'Yvonne Moncada',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1073.8390000000002,
        ItemCount: 13,
        ChangeLastOrder: -25,
        ItemCost: 97.18,
        OrderCost: 1263.3400000000001,
        PackageCost: 14.95,
        OrderDate: 1519081200000,
        RequiredDate: 1521500400000,
        ShippedDate: 1520290800000,
        ShipVia: 'United Package',
        Freight: 1.27,
        ShipName: "Oc\xe9ano Atl\xe1ntico Ltda.",
        ShipAddress: 'Ing. Gustavo Moncada 8585, Piso 20-A',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 1
    },
    {
        OrderId: 10897,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Janet Leverling',
        InvoicedCost: 738.99,
        ItemCount: 7,
        ChangeLastOrder: 2,
        ItemCost: 97.75,
        OrderCost: 684.25,
        PackageCost: 8.89,
        OrderDate: 1518994800000,
        RequiredDate: 1521414000000,
        ShippedDate: 1519513200000,
        ShipVia: 'United Package',
        Freight: 603.54,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10896,
        CustomerReference: 'MAISD',
        CompanyName: 'Maison Dewey',
        ContactName: 'Catherine Dewey',
        Employee: 'Robert King',
        InvoicedCost: 576.6768000000001,
        ItemCount: 14,
        ChangeLastOrder: -40,
        ItemCost: 38.14,
        OrderCost: 533.96,
        PackageCost: 16.099999999999998,
        OrderDate: 1518994800000,
        RequiredDate: 1521414000000,
        ShippedDate: 1519686000000,
        ShipVia: 'Federal Shipping',
        Freight: 32.45,
        ShipName: 'Maison Dewey',
        ShipAddress: 'Rue Joseph-Bens 532',
        ShipCity: 'Bruxelles',
        ShipRegion: null,
        ShipPostalCode: 'B-1180',
        ShipCountry: 'Belgium',
        ArriveOnTime: 1
    },
    {
        OrderId: 10895,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Janet Leverling',
        InvoicedCost: 155.862,
        ItemCount: 6,
        ChangeLastOrder: 12,
        ItemCost: 24.74,
        OrderCost: 148.44,
        PackageCost: 8.574,
        OrderDate: 1518908400000,
        RequiredDate: 1521327600000,
        ShippedDate: 1519340400000,
        ShipVia: 'Speedy Express',
        Freight: 162.75,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10894,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Nancy Davolio',
        InvoicedCost: 961.8210000000001,
        ItemCount: 7,
        ChangeLastOrder: 5,
        ItemCost: 130.86,
        OrderCost: 916.0200000000001,
        PackageCost: 3.7800000000000002,
        OrderDate: 1518908400000,
        RequiredDate: 1521327600000,
        ShippedDate: 1519081200000,
        ShipVia: 'Speedy Express',
        Freight: 116.13,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10893,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1341.4624999999999,
        ItemCount: 10,
        ChangeLastOrder: -37,
        ItemCost: 153.31,
        OrderCost: 1533.1,
        PackageCost: 11.5,
        OrderDate: 1518908400000,
        RequiredDate: 1521327600000,
        ShippedDate: 1519081200000,
        ShipVia: 'United Package',
        Freight: 77.78,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10892,
        CustomerReference: 'MAISD',
        CompanyName: 'Maison Dewey',
        ContactName: 'Catherine Dewey',
        Employee: 'Margaret Peacock',
        InvoicedCost: 191.50560000000004,
        ItemCount: 11,
        ChangeLastOrder: -41,
        ItemCost: 16.12,
        OrderCost: 177.32000000000002,
        PackageCost: 12.649999999999999,
        OrderDate: 1518822000000,
        RequiredDate: 1521241200000,
        ShippedDate: 1518994800000,
        ShipVia: 'United Package',
        Freight: 120.27,
        ShipName: 'Maison Dewey',
        ShipAddress: 'Rue Joseph-Bens 532',
        ShipCity: 'Bruxelles',
        ShipRegion: null,
        ShipPostalCode: 'B-1180',
        ShipCountry: 'Belgium',
        ArriveOnTime: 0
    },
    {
        OrderId: 10891,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Robert King',
        InvoicedCost: 1638.2768,
        ItemCount: 8,
        ChangeLastOrder: -21,
        ItemCost: 198.82,
        OrderCost: 1590.56,
        PackageCost: 9.2,
        OrderDate: 1518822000000,
        RequiredDate: 1521241200000,
        ShippedDate: 1518994800000,
        ShipVia: 'United Package',
        Freight: 20.37,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10890,
        CustomerReference: 'DUMON',
        CompanyName: 'Du monde entier',
        ContactName: 'Janine Labrune',
        Employee: 'Robert King',
        InvoicedCost: 2120.1245,
        ItemCount: 13,
        ChangeLastOrder: 2,
        ItemCost: 171.67,
        OrderCost: 2231.71,
        PackageCost: 16.51,
        OrderDate: 1518735600000,
        RequiredDate: 1521154800000,
        ShippedDate: 1518908400000,
        ShipVia: 'Speedy Express',
        Freight: 32.76,
        ShipName: 'Du monde entier',
        ShipAddress: '67, rue des Cinquante Otages',
        ShipCity: 'Nantes',
        ShipRegion: null,
        ShipPostalCode: 44000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10889,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1171.59,
        ItemCount: 7,
        ChangeLastOrder: 2,
        ItemCost: 159.4,
        OrderCost: 1115.8,
        PackageCost: 8.89,
        OrderDate: 1518735600000,
        RequiredDate: 1521154800000,
        ShippedDate: 1519340400000,
        ShipVia: 'Federal Shipping',
        Freight: 280.61,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10888,
        CustomerReference: 'GODOS',
        CompanyName: "Godos Cocina T\xedpica",
        ContactName: "Jos\xe9 Pedro Freyre",
        Employee: 'Nancy Davolio',
        InvoicedCost: 2389.3545,
        ItemCount: 13,
        ChangeLastOrder: -4,
        ItemCost: 193.47,
        OrderCost: 2515.11,
        PackageCost: 14.95,
        OrderDate: 1518735600000,
        RequiredDate: 1521154800000,
        ShippedDate: 1519340400000,
        ShipVia: 'United Package',
        Freight: 51.87,
        ShipName: "Godos Cocina T\xedpica",
        ShipAddress: 'C/ Romero, 33',
        ShipCity: 'Sevilla',
        ShipRegion: null,
        ShipPostalCode: 41101,
        ShipCountry: 'Spain',
        ArriveOnTime: 0
    },
    {
        OrderId: 10887,
        CustomerReference: 'GALED',
        CompanyName: "Galer\xeda del gastr\xf3nomo",
        ContactName: 'Eduardo Saavedra',
        Employee: 'Laura Callahan',
        InvoicedCost: 252.1785,
        ItemCount: 7,
        ChangeLastOrder: 4,
        ItemCost: 34.31,
        OrderCost: 240.17000000000002,
        PackageCost: 3.7800000000000002,
        OrderDate: 1518476400000,
        RequiredDate: 1520895600000,
        ShippedDate: 1518735600000,
        ShipVia: 'Federal Shipping',
        Freight: 1.25,
        ShipName: "Galer\xeda del gastron\xf3mo",
        ShipAddress: "Rambla de Catalu\xf1a, 23",
        ShipCity: 'Barcelona',
        ShipRegion: null,
        ShipPostalCode: 8022,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10886,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Nancy Davolio',
        InvoicedCost: 951.813,
        ItemCount: 9,
        ChangeLastOrder: -18,
        ItemCost: 124.42,
        OrderCost: 1119.78,
        PackageCost: 10.35,
        OrderDate: 1518476400000,
        RequiredDate: 1520895600000,
        ShippedDate: 1519945200000,
        ShipVia: 'Speedy Express',
        Freight: 4.99,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10885,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Michael Suyama',
        InvoicedCost: 1782.5184000000002,
        ItemCount: 13,
        ChangeLastOrder: -4,
        ItemCost: 126.96,
        OrderCost: 1650.48,
        PackageCost: 14.95,
        OrderDate: 1518390000000,
        RequiredDate: 1520809200000,
        ShippedDate: 1518908400000,
        ShipVia: 'Federal Shipping',
        Freight: 5.64,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 1
    },
    {
        OrderId: 10884,
        CustomerReference: 'LETSS',
        CompanyName: "Let's Stop N Shop",
        ContactName: 'Jaime Yorres',
        Employee: 'Margaret Peacock',
        InvoicedCost: 818.244,
        ItemCount: 8,
        ChangeLastOrder: 0,
        ItemCost: 97.41,
        OrderCost: 779.28,
        PackageCost: 10.16,
        OrderDate: 1518390000000,
        RequiredDate: 1520809200000,
        ShippedDate: 1518476400000,
        ShipVia: 'United Package',
        Freight: 90.97,
        ShipName: "Let's Stop N Shop",
        ShipAddress: '90 Polk St. Suite 5',
        ShipCity: 'San Francisco',
        ShipRegion: 'CA',
        ShipPostalCode: 94117,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10883,
        CustomerReference: 'LONEP',
        CompanyName: 'Lonesome Pine Restaurant',
        ContactName: 'Fran Wilson',
        Employee: 'Laura Callahan',
        InvoicedCost: 229.58249999999998,
        ItemCount: 5,
        ChangeLastOrder: 1,
        ItemCost: 43.73,
        OrderCost: 218.64999999999998,
        PackageCost: 6.35,
        OrderDate: 1518390000000,
        RequiredDate: 1520809200000,
        ShippedDate: 1519081200000,
        ShipVia: 'Federal Shipping',
        Freight: 0.53,
        ShipName: 'Lonesome Pine Restaurant',
        ShipAddress: '89 Chiaroscuro Rd.',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97219,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10882,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Margaret Peacock',
        InvoicedCost: 2655.8804999999998,
        ItemCount: 13,
        ChangeLastOrder: 5,
        ItemCost: 194.57,
        OrderCost: 2529.41,
        PackageCost: 7.0200000000000005,
        OrderDate: 1518303600000,
        RequiredDate: 1520722800000,
        ShippedDate: 1519081200000,
        ShipVia: 'Federal Shipping',
        Freight: 23.1,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10881,
        CustomerReference: 'CACTU',
        CompanyName: 'Cactus Comidas para llevar',
        ContactName: 'Patricio Simpson',
        Employee: 'Margaret Peacock',
        InvoicedCost: 695.385,
        ItemCount: 9,
        ChangeLastOrder: 4,
        ItemCost: 90.9,
        OrderCost: 818.1,
        PackageCost: 4.86,
        OrderDate: 1518303600000,
        RequiredDate: 1520722800000,
        ShippedDate: 1518908400000,
        ShipVia: 'Speedy Express',
        Freight: 2.84,
        ShipName: 'Cactus Comidas para llevar',
        ShipAddress: 'Cerrito 333',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 1
    },
    {
        OrderId: 10880,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Robert King',
        InvoicedCost: 346.41,
        ItemCount: 5,
        ChangeLastOrder: -1,
        ItemCost: 64.15,
        OrderCost: 320.75,
        PackageCost: 6.35,
        OrderDate: 1518217200000,
        RequiredDate: 1521846000000,
        ShippedDate: 1518908400000,
        ShipVia: 'Speedy Express',
        Freight: 88.01,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10879,
        CustomerReference: 'WILMK',
        CompanyName: 'Wilman Kala',
        ContactName: 'Matti Karttunen',
        Employee: 'Janet Leverling',
        InvoicedCost: 282.795,
        ItemCount: 5,
        ChangeLastOrder: 21,
        ItemCost: 66.54,
        OrderCost: 332.70000000000005,
        PackageCost: 7.1450000000000005,
        OrderDate: 1518217200000,
        RequiredDate: 1520636400000,
        ShippedDate: 1518390000000,
        ShipVia: 'Federal Shipping',
        Freight: 8.5,
        ShipName: 'Wilman Kala',
        ShipAddress: 'Keskuskatu 45',
        ShipCity: 'Helsinki',
        ShipRegion: null,
        ShipPostalCode: 21240,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10878,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1530.8787,
        ItemCount: 13,
        ChangeLastOrder: 5,
        ItemCost: 114.33,
        OrderCost: 1486.29,
        PackageCost: 7.0200000000000005,
        OrderDate: 1518217200000,
        RequiredDate: 1520636400000,
        ShippedDate: 1518390000000,
        ShipVia: 'Speedy Express',
        Freight: 46.69,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10877,
        CustomerReference: 'RICAR',
        CompanyName: 'Ricardo Adocicados',
        ContactName: 'Janete Limeira',
        Employee: 'Nancy Davolio',
        InvoicedCost: 1543.1849999999997,
        ItemCount: 7,
        ChangeLastOrder: -2,
        ItemCost: 191.7,
        OrderCost: 1341.8999999999999,
        PackageCost: 8.89,
        OrderDate: 1518130800000,
        RequiredDate: 1520550000000,
        ShippedDate: 1518994800000,
        ShipVia: 'Speedy Express',
        Freight: 38.06,
        ShipName: 'Ricardo Adocicados',
        ShipAddress: 'Av. Copacabana, 267',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-890',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10876,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Robert King',
        InvoicedCost: 885.6999999999999,
        ItemCount: 10,
        ChangeLastOrder: 6,
        ItemCost: 104.2,
        OrderCost: 1042,
        PackageCost: 13.81,
        OrderDate: 1518130800000,
        RequiredDate: 1520550000000,
        ShippedDate: 1518390000000,
        ShipVia: 'Federal Shipping',
        Freight: 60.42,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10875,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1522.4220000000003,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 128.15,
        OrderCost: 1409.65,
        PackageCost: 13.97,
        OrderDate: 1517871600000,
        RequiredDate: 1520290800000,
        ShippedDate: 1520031600000,
        ShipVia: 'United Package',
        Freight: 32.37,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10874,
        CustomerReference: 'GODOS',
        CompanyName: "Godos Cocina T\xedpica",
        ContactName: "Jos\xe9 Pedro Freyre",
        Employee: 'Steven Buchanan',
        InvoicedCost: 308.93625,
        ItemCount: 9,
        ChangeLastOrder: -4,
        ItemCost: 39.23,
        OrderCost: 353.07,
        PackageCost: 10.35,
        OrderDate: 1517871600000,
        RequiredDate: 1520290800000,
        ShippedDate: 1518303600000,
        ShipVia: 'United Package',
        Freight: 19.58,
        ShipName: "Godos Cocina T\xedpica",
        ShipAddress: 'C/ Romero, 33',
        ShipCity: 'Sevilla',
        ShipRegion: null,
        ShipPostalCode: 41101,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10873,
        CustomerReference: 'WILMK',
        CompanyName: 'Wilman Kala',
        ContactName: 'Matti Karttunen',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1268.9249999999997,
        ItemCount: 12,
        ChangeLastOrder: 24,
        ItemCost: 120.85,
        OrderCost: 1450.1999999999998,
        PackageCost: 17.148,
        OrderDate: 1517871600000,
        RequiredDate: 1520290800000,
        ShippedDate: 1518130800000,
        ShipVia: 'Speedy Express',
        Freight: 0.82,
        ShipName: 'Wilman Kala',
        ShipAddress: 'Keskuskatu 45',
        ShipCity: 'Helsinki',
        ShipRegion: null,
        ShipPostalCode: 21240,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10872,
        CustomerReference: 'GODOS',
        CompanyName: "Godos Cocina T\xedpica",
        ContactName: "Jos\xe9 Pedro Freyre",
        Employee: 'Steven Buchanan',
        InvoicedCost: 655.348,
        ItemCount: 8,
        ChangeLastOrder: -5,
        ItemCost: 86.23,
        OrderCost: 689.84,
        PackageCost: 9.2,
        OrderDate: 1517785200000,
        RequiredDate: 1520204400000,
        ShippedDate: 1518130800000,
        ShipVia: 'United Package',
        Freight: 175.32,
        ShipName: "Godos Cocina T\xedpica",
        ShipAddress: 'C/ Romero, 33',
        ShipCity: 'Sevilla',
        ShipRegion: null,
        ShipPostalCode: 41101,
        ShipCountry: 'Spain',
        ArriveOnTime: 0
    },
    {
        OrderId: 10871,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 498.49100000000004,
        ItemCount: 7,
        ChangeLastOrder: 5,
        ItemCost: 83.78,
        OrderCost: 586.46,
        PackageCost: 3.7800000000000002,
        OrderDate: 1517785200000,
        RequiredDate: 1520204400000,
        ShippedDate: 1518217200000,
        ShipVia: 'United Package',
        Freight: 112.27,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10870,
        CustomerReference: 'WOLZA',
        CompanyName: 'Wolski  Zajazd',
        ContactName: 'Zbyszek Piestrzeniewicz',
        Employee: 'Steven Buchanan',
        InvoicedCost: 390.3,
        ItemCount: 8,
        ChangeLastOrder: 20,
        ItemCost: 39.03,
        OrderCost: 312.24,
        PackageCost: 11.432,
        OrderDate: 1517698800000,
        RequiredDate: 1520118000000,
        ShippedDate: 1518476400000,
        ShipVia: 'Federal Shipping',
        Freight: 12.04,
        ShipName: 'Wolski Zajazd',
        ShipAddress: 'ul. Filtrowa 68',
        ShipCity: 'Warszawa',
        ShipRegion: null,
        ShipPostalCode: '01-012',
        ShipCountry: 'Poland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10869,
        CustomerReference: 'SEVES',
        CompanyName: 'Seven Seas Imports',
        ContactName: 'Hari Kumar',
        Employee: 'Steven Buchanan',
        InvoicedCost: 791.2080000000001,
        ItemCount: 9,
        ChangeLastOrder: 0,
        ItemCost: 81.4,
        OrderCost: 732.6,
        PackageCost: 11.43,
        OrderDate: 1517698800000,
        RequiredDate: 1520118000000,
        ShippedDate: 1518130800000,
        ShipVia: 'Speedy Express',
        Freight: 143.28,
        ShipName: 'Seven Seas Imports',
        ShipAddress: '90 Wadhurst Rd.',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'OX15 4NB',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10868,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Robert King',
        InvoicedCost: 974.1,
        ItemCount: 12,
        ChangeLastOrder: -2,
        ItemCost: 95.5,
        OrderCost: 1146,
        PackageCost: 15.24,
        OrderDate: 1517698800000,
        RequiredDate: 1520118000000,
        ShippedDate: 1519340400000,
        ShipVia: 'United Package',
        Freight: 191.27,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10867,
        CustomerReference: 'LONEP',
        CompanyName: 'Lonesome Pine Restaurant',
        ContactName: 'Fran Wilson',
        Employee: 'Michael Suyama',
        InvoicedCost: 220.794,
        ItemCount: 7,
        ChangeLastOrder: 1,
        ItemCost: 30.04,
        OrderCost: 210.28,
        PackageCost: 8.89,
        OrderDate: 1517612400000,
        RequiredDate: 1521241200000,
        ShippedDate: 1518303600000,
        ShipVia: 'Speedy Express',
        Freight: 1.93,
        ShipName: 'Lonesome Pine Restaurant',
        ShipAddress: '89 Chiaroscuro Rd.',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97219,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10866,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Steven Buchanan',
        InvoicedCost: 184.464,
        ItemCount: 10,
        ChangeLastOrder: -3,
        ItemCost: 17.08,
        OrderCost: 170.79999999999998,
        PackageCost: 12.7,
        OrderDate: 1517612400000,
        RequiredDate: 1520031600000,
        ShippedDate: 1518390000000,
        ShipVia: 'Speedy Express',
        Freight: 109.11,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10865,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Andrew Fuller',
        InvoicedCost: 897.3359999999999,
        ItemCount: 9,
        ChangeLastOrder: -20,
        ItemCost: 96.8,
        OrderCost: 871.1999999999999,
        PackageCost: 10.35,
        OrderDate: 1517526000000,
        RequiredDate: 1518735600000,
        ShippedDate: 1518390000000,
        ShipVia: 'Speedy Express',
        Freight: 348.14,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10864,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Margaret Peacock',
        InvoicedCost: 845.856,
        ItemCount: 10,
        ChangeLastOrder: -4,
        ItemCost: 78.32,
        OrderCost: 783.1999999999999,
        PackageCost: 11.5,
        OrderDate: 1517526000000,
        RequiredDate: 1519945200000,
        ShippedDate: 1518130800000,
        ShipVia: 'United Package',
        Freight: 3.04,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10863,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Margaret Peacock',
        InvoicedCost: 947.4352,
        ItemCount: 8,
        ChangeLastOrder: -5,
        ItemCost: 114.98,
        OrderCost: 919.84,
        PackageCost: 9.2,
        OrderDate: 1517526000000,
        RequiredDate: 1519945200000,
        ShippedDate: 1518822000000,
        ShipVia: 'United Package',
        Freight: 30.26,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10862,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Laura Callahan',
        InvoicedCost: 931.431,
        ItemCount: 6,
        ChangeLastOrder: -27,
        ItemCost: 134.99,
        OrderCost: 809.94,
        PackageCost: 6.8999999999999995,
        OrderDate: 1517266800000,
        RequiredDate: 1520895600000,
        ShippedDate: 1517526000000,
        ShipVia: 'United Package',
        Freight: 53.23,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10861,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Margaret Peacock',
        InvoicedCost: 391.1544,
        ItemCount: 14,
        ChangeLastOrder: 6,
        ItemCost: 25.87,
        OrderCost: 362.18,
        PackageCost: 19.334,
        OrderDate: 1517266800000,
        RequiredDate: 1519686000000,
        ShippedDate: 1518822000000,
        ShipVia: 'United Package',
        Freight: 14.93,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10860,
        CustomerReference: 'FRANR',
        CompanyName: 'France restauration',
        ContactName: 'Carine Schmitt',
        Employee: 'Janet Leverling',
        InvoicedCost: 1293.71,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 136.18,
        OrderCost: 1361.8000000000002,
        PackageCost: 12.7,
        OrderDate: 1517180400000,
        RequiredDate: 1519599600000,
        ShippedDate: 1517698800000,
        ShipVia: 'Federal Shipping',
        Freight: 19.26,
        ShipName: 'France restauration',
        ShipAddress: '54, rue Royale',
        ShipCity: 'Nantes',
        ShipRegion: null,
        ShipPostalCode: 44000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10859,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Nancy Davolio',
        InvoicedCost: 238.518,
        ItemCount: 9,
        ChangeLastOrder: -3,
        ItemCost: 25.24,
        OrderCost: 227.16,
        PackageCost: 11.43,
        OrderDate: 1517180400000,
        RequiredDate: 1519599600000,
        ShippedDate: 1517526000000,
        ShipVia: 'United Package',
        Freight: 76.1,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10858,
        CustomerReference: 'LACOR',
        CompanyName: "La corne d'abondance",
        ContactName: 'Daniel Tonini',
        Employee: 'Andrew Fuller',
        InvoicedCost: 120.33000000000001,
        ItemCount: 6,
        ChangeLastOrder: 2,
        ItemCost: 19.1,
        OrderCost: 114.60000000000001,
        PackageCost: 7.62,
        OrderDate: 1517180400000,
        RequiredDate: 1519599600000,
        ShippedDate: 1517612400000,
        ShipVia: 'Speedy Express',
        Freight: 52.51,
        ShipName: "La corne d'abondance",
        ShipAddress: "67, avenue de l'Europe",
        ShipCity: 'Versailles',
        ShipRegion: null,
        ShipPostalCode: 78000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10857,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Laura Callahan',
        InvoicedCost: 649.4796,
        ItemCount: 7,
        ChangeLastOrder: -3,
        ItemCost: 85.91,
        OrderCost: 601.37,
        PackageCost: 8.89,
        OrderDate: 1517094000000,
        RequiredDate: 1519513200000,
        ShippedDate: 1517871600000,
        ShipVia: 'United Package',
        Freight: 188.85,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10856,
        CustomerReference: 'ANTON',
        CompanyName: "Antonio Moreno Taquer\xeda",
        ContactName: 'Antonio Moreno',
        Employee: 'Janet Leverling',
        InvoicedCost: 680.3974999999999,
        ItemCount: 5,
        ChangeLastOrder: -33,
        ItemCost: 118.33,
        OrderCost: 591.65,
        PackageCost: 5.75,
        OrderDate: 1517094000000,
        RequiredDate: 1519513200000,
        ShippedDate: 1518217200000,
        ShipVia: 'United Package',
        Freight: 58.43,
        ShipName: "Antonio Moreno Taquer\xeda",
        ShipAddress: 'Mataderos  2312',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5023,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10855,
        CustomerReference: 'OLDWO',
        CompanyName: 'Old World Delicatessen',
        ContactName: 'Rene Phillips',
        Employee: 'Janet Leverling',
        InvoicedCost: 540.8208000000001,
        ItemCount: 9,
        ChangeLastOrder: 3,
        ItemCost: 55.64,
        OrderCost: 500.76,
        PackageCost: 4.86,
        OrderDate: 1517007600000,
        RequiredDate: 1519426800000,
        ShippedDate: 1517698800000,
        ShipVia: 'Speedy Express',
        Freight: 170.97,
        ShipName: 'Old World Delicatessen',
        ShipAddress: '2743 Bering St.',
        ShipCity: 'Anchorage',
        ShipRegion: 'AK',
        ShipPostalCode: 99508,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10854,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Janet Leverling',
        InvoicedCost: 16.128,
        ItemCount: 6,
        ChangeLastOrder: 18,
        ItemCost: 2.56,
        OrderCost: 15.36,
        PackageCost: 8.574,
        OrderDate: 1517007600000,
        RequiredDate: 1519426800000,
        ShippedDate: 1517785200000,
        ShipVia: 'United Package',
        Freight: 100.22,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10853,
        CustomerReference: 'BLAUS',
        CompanyName: 'Blauer See Delikatessen',
        ContactName: 'Hanna Moos',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1408.4279999999999,
        ItemCount: 9,
        ChangeLastOrder: 14,
        ItemCost: 136.08,
        OrderCost: 1224.72,
        PackageCost: 12.861,
        OrderDate: 1517007600000,
        RequiredDate: 1519426800000,
        ShippedDate: 1517612400000,
        ShipVia: 'United Package',
        Freight: 53.83,
        ShipName: 'Blauer See Delikatessen',
        ShipAddress: 'Forsterstr. 57',
        ShipCity: 'Mannheim',
        ShipRegion: null,
        ShipPostalCode: 68306,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10852,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Laura Callahan',
        InvoicedCost: 1289.484,
        ItemCount: 7,
        ChangeLastOrder: 2,
        ItemCost: 175.44,
        OrderCost: 1228.08,
        PackageCost: 8.89,
        OrderDate: 1516921200000,
        RequiredDate: 1518130800000,
        ShippedDate: 1517266800000,
        ShipVia: 'Speedy Express',
        Freight: 174.05,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10851,
        CustomerReference: 'RICAR',
        CompanyName: 'Ricardo Adocicados',
        ContactName: 'Janete Limeira',
        Employee: 'Steven Buchanan',
        InvoicedCost: 695.5199999999999,
        ItemCount: 8,
        ChangeLastOrder: -2,
        ItemCost: 75.6,
        OrderCost: 604.8,
        PackageCost: 10.16,
        OrderDate: 1516921200000,
        RequiredDate: 1519340400000,
        ShippedDate: 1517526000000,
        ShipVia: 'Speedy Express',
        Freight: 160.55,
        ShipName: 'Ricardo Adocicados',
        ShipAddress: 'Av. Copacabana, 267',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-890',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10850,
        CustomerReference: 'VICTE',
        CompanyName: 'Victuailles en stock',
        ContactName: 'Mary Saveley',
        Employee: 'Nancy Davolio',
        InvoicedCost: 9.119499999999999,
        ItemCount: 13,
        ChangeLastOrder: 5,
        ItemCost: 0.61,
        OrderCost: 7.93,
        PackageCost: 7.0200000000000005,
        OrderDate: 1516662000000,
        RequiredDate: 1520290800000,
        ShippedDate: 1517266800000,
        ShipVia: 'Speedy Express',
        Freight: 49.19,
        ShipName: 'Victuailles en stock',
        ShipAddress: '2, rue du Commerce',
        ShipCity: 'Lyon',
        ShipRegion: null,
        ShipPostalCode: 69004,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10849,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 624.24,
        ItemCount: 6,
        ChangeLastOrder: 39,
        ItemCost: 122.4,
        OrderCost: 734.4000000000001,
        PackageCost: 8.574,
        OrderDate: 1516662000000,
        RequiredDate: 1519081200000,
        ShippedDate: 1517266800000,
        ShipVia: 'United Package',
        Freight: 0.56,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10848,
        CustomerReference: 'CONSH',
        CompanyName: 'Consolidated Holdings',
        ContactName: 'Elizabeth Brown',
        Employee: 'Robert King',
        InvoicedCost: 28.0476,
        ItemCount: 7,
        ChangeLastOrder: -3,
        ItemCost: 3.71,
        OrderCost: 25.97,
        PackageCost: 8.89,
        OrderDate: 1516662000000,
        RequiredDate: 1519081200000,
        ShippedDate: 1517180400000,
        ShipVia: 'United Package',
        Freight: 38.24,
        ShipName: 'Consolidated Holdings',
        ShipAddress: 'Berkeley Gardens, 12  Brewery',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'WX1 6LT',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10847,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Margaret Peacock',
        InvoicedCost: 697.032,
        ItemCount: 12,
        ChangeLastOrder: 5,
        ItemCost: 55.32,
        OrderCost: 663.84,
        PackageCost: 6.48,
        OrderDate: 1516575600000,
        RequiredDate: 1517785200000,
        ShippedDate: 1518217200000,
        ShipVia: 'Federal Shipping',
        Freight: 487.57,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10846,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1590.8832,
        ItemCount: 8,
        ChangeLastOrder: -4,
        ItemCost: 184.13,
        OrderCost: 1473.04,
        PackageCost: 9.2,
        OrderDate: 1516575600000,
        RequiredDate: 1520204400000,
        ShippedDate: 1516662000000,
        ShipVia: 'Federal Shipping',
        Freight: 56.46,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 0
    },
    {
        OrderId: 10845,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Laura Callahan',
        InvoicedCost: 1799.719,
        ItemCount: 10,
        ChangeLastOrder: 3,
        ItemCost: 174.73,
        OrderCost: 1747.3,
        PackageCost: 5.4,
        OrderDate: 1516489200000,
        RequiredDate: 1517698800000,
        ShippedDate: 1517266800000,
        ShipVia: 'Speedy Express',
        Freight: 212.98,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10844,
        CustomerReference: 'PICCO',
        CompanyName: 'Piccolo und mehr',
        ContactName: 'Georg Pipps',
        Employee: 'Laura Callahan',
        InvoicedCost: 856.8879,
        ItemCount: 11,
        ChangeLastOrder: 1,
        ItemCost: 75.63,
        OrderCost: 831.93,
        PackageCost: 13.97,
        OrderDate: 1516489200000,
        RequiredDate: 1518908400000,
        ShippedDate: 1516921200000,
        ShipVia: 'United Package',
        Freight: 25.22,
        ShipName: 'Piccolo und mehr',
        ShipAddress: 'Geislweg 14',
        ShipCity: 'Salzburg',
        ShipRegion: null,
        ShipPostalCode: 5020,
        ShipCountry: 'Austria',
        ArriveOnTime: 1
    },
    {
        OrderId: 10843,
        CustomerReference: 'VICTE',
        CompanyName: 'Victuailles en stock',
        ContactName: 'Mary Saveley',
        Employee: 'Margaret Peacock',
        InvoicedCost: 607.8209999999999,
        ItemCount: 6,
        ChangeLastOrder: 4,
        ItemCost: 88.09,
        OrderCost: 528.54,
        PackageCost: 3.24,
        OrderDate: 1516489200000,
        RequiredDate: 1518908400000,
        ShippedDate: 1516921200000,
        ShipVia: 'United Package',
        Freight: 9.26,
        ShipName: 'Victuailles en stock',
        ShipAddress: '2, rue du Commerce',
        ShipCity: 'Lyon',
        ShipRegion: null,
        ShipPostalCode: 69004,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10842,
        CustomerReference: 'TORTU',
        CompanyName: 'Tortuga Restaurante',
        ContactName: 'Miguel Angel Paolino',
        Employee: 'Nancy Davolio',
        InvoicedCost: 130.64,
        ItemCount: 5,
        ChangeLastOrder: -3,
        ItemCost: 22.72,
        OrderCost: 113.6,
        PackageCost: 6.35,
        OrderDate: 1516402800000,
        RequiredDate: 1518822000000,
        ShippedDate: 1517180400000,
        ShipVia: 'Federal Shipping',
        Freight: 54.42,
        ShipName: 'Tortuga Restaurante',
        ShipAddress: 'Avda. Azteca 123',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10841,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Steven Buchanan',
        InvoicedCost: 763.1064,
        ItemCount: 7,
        ChangeLastOrder: -4,
        ItemCost: 100.94,
        OrderCost: 706.5799999999999,
        PackageCost: 8.049999999999999,
        OrderDate: 1516402800000,
        RequiredDate: 1518822000000,
        ShippedDate: 1517180400000,
        ShipVia: 'United Package',
        Freight: 424.3,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 0
    },
    {
        OrderId: 10840,
        CustomerReference: 'LINOD',
        CompanyName: 'LINO-Delicateses',
        ContactName: 'Felipe Izquierdo',
        Employee: 'Margaret Peacock',
        InvoicedCost: 817.3462,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 72.14,
        OrderCost: 793.54,
        PackageCost: 13.97,
        OrderDate: 1516316400000,
        RequiredDate: 1519945200000,
        ShippedDate: 1518735600000,
        ShipVia: 'United Package',
        Freight: 2.71,
        ShipName: 'LINO-Delicateses',
        ShipAddress: 'Ave. 5 de Mayo Porlamar',
        ShipCity: 'I. de Margarita',
        ShipRegion: 'Nueva Esparta',
        ShipPostalCode: 4980,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10839,
        CustomerReference: 'TRADH',
        CompanyName: "Tradi\xe7\xe3o Hipermercados",
        ContactName: 'Anabela Domingues',
        Employee: 'Janet Leverling',
        InvoicedCost: 120.666,
        ItemCount: 12,
        ChangeLastOrder: -3,
        ItemCost: 11.83,
        OrderCost: 141.96,
        PackageCost: 15.24,
        OrderDate: 1516316400000,
        RequiredDate: 1518735600000,
        ShippedDate: 1516575600000,
        ShipVia: 'Federal Shipping',
        Freight: 35.43,
        ShipName: "Tradi\xe7\xe3o Hipermercados",
        ShipAddress: "Av. In\xeas de Castro, 414",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05634-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10838,
        CustomerReference: 'LINOD',
        CompanyName: 'LINO-Delicateses',
        ContactName: 'Felipe Izquierdo',
        Employee: 'Janet Leverling',
        InvoicedCost: 1768.1598000000001,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 156.06,
        OrderCost: 1716.66,
        PackageCost: 13.97,
        OrderDate: 1516316400000,
        RequiredDate: 1518735600000,
        ShippedDate: 1516662000000,
        ShipVia: 'Federal Shipping',
        Freight: 59.28,
        ShipName: 'LINO-Delicateses',
        ShipAddress: 'Ave. 5 de Mayo Porlamar',
        ShipCity: 'I. de Margarita',
        ShipRegion: 'Nueva Esparta',
        ShipPostalCode: 4980,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10837,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1709.7912000000001,
        ItemCount: 13,
        ChangeLastOrder: -3,
        ItemCost: 121.78,
        OrderCost: 1583.14,
        PackageCost: 16.51,
        OrderDate: 1516057200000,
        RequiredDate: 1518476400000,
        ShippedDate: 1516662000000,
        ShipVia: 'Federal Shipping',
        Freight: 13.32,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10836,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Robert King',
        InvoicedCost: 1937.8799999999999,
        ItemCount: 10,
        ChangeLastOrder: -9,
        ItemCost: 184.56,
        OrderCost: 1845.6,
        PackageCost: 11.5,
        OrderDate: 1516057200000,
        RequiredDate: 1518476400000,
        ShippedDate: 1516489200000,
        ShipVia: 'Speedy Express',
        Freight: 411.88,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10835,
        CustomerReference: 'ALFKI',
        CompanyName: 'Alfreds Futterkiste',
        ContactName: 'Maria Anders',
        Employee: 'Nancy Davolio',
        InvoicedCost: 789.208,
        ItemCount: 8,
        ChangeLastOrder: 19,
        ItemCost: 116.06,
        OrderCost: 928.48,
        PackageCost: 11.432,
        OrderDate: 1515970800000,
        RequiredDate: 1518390000000,
        ShippedDate: 1516489200000,
        ShipVia: 'Federal Shipping',
        Freight: 69.53,
        ShipName: 'Alfreds Futterkiste',
        ShipAddress: 'Obere Str. 57',
        ShipCity: 'Berlin',
        ShipRegion: null,
        ShipPostalCode: 12209,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10834,
        CustomerReference: 'TRADH',
        CompanyName: "Tradi\xe7\xe3o Hipermercados",
        ContactName: 'Anabela Domingues',
        Employee: 'Nancy Davolio',
        InvoicedCost: 44.13199999999999,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 4.72,
        OrderCost: 51.919999999999995,
        PackageCost: 13.97,
        OrderDate: 1515970800000,
        RequiredDate: 1518390000000,
        ShippedDate: 1516316400000,
        ShipVia: 'Federal Shipping',
        Freight: 29.78,
        ShipName: "Tradi\xe7\xe3o Hipermercados",
        ShipAddress: "Av. In\xeas de Castro, 414",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05634-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10833,
        CustomerReference: 'OTTIK',
        CompanyName: "Ottilies K\xe4seladen",
        ContactName: 'Henriette Pfalzheim',
        Employee: 'Michael Suyama',
        InvoicedCost: 782.46,
        ItemCount: 12,
        ChangeLastOrder: 23,
        ItemCost: 56.7,
        OrderCost: 680.4000000000001,
        PackageCost: 17.148,
        OrderDate: 1515970800000,
        RequiredDate: 1518390000000,
        ShippedDate: 1516662000000,
        ShipVia: 'United Package',
        Freight: 71.49,
        ShipName: "Ottilies K\xe4seladen",
        ShipAddress: 'Mehrheimerstr. 369',
        ShipCity: "K\xf6ln",
        ShipRegion: null,
        ShipPostalCode: 50739,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10832,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1614.3919999999998,
        ItemCount: 13,
        ChangeLastOrder: 6,
        ItemCost: 130.72,
        OrderCost: 1699.36,
        PackageCost: 17.953,
        OrderDate: 1515884400000,
        RequiredDate: 1518303600000,
        ShippedDate: 1516316400000,
        ShipVia: 'United Package',
        Freight: 43.26,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10831,
        CustomerReference: 'SANTG',
        CompanyName: "Sant\xe9 Gourmet",
        ContactName: 'Jonas Bergulfsen',
        Employee: 'Janet Leverling',
        InvoicedCost: 442.377,
        ItemCount: 13,
        ChangeLastOrder: -11,
        ItemCost: 35.82,
        OrderCost: 465.66,
        PackageCost: 14.95,
        OrderDate: 1515884400000,
        RequiredDate: 1518303600000,
        ShippedDate: 1516662000000,
        ShipVia: 'United Package',
        Freight: 72.19,
        ShipName: "Sant\xe9 Gourmet",
        ShipAddress: 'Erling Skakkes gate 78',
        ShipCity: 'Stavern',
        ShipRegion: null,
        ShipPostalCode: 4110,
        ShipCountry: 'Norway',
        ArriveOnTime: 0
    },
    {
        OrderId: 10830,
        CustomerReference: 'TRADH',
        CompanyName: "Tradi\xe7\xe3o Hipermercados",
        ContactName: 'Anabela Domingues',
        Employee: 'Margaret Peacock',
        InvoicedCost: 943.1599999999999,
        ItemCount: 8,
        ChangeLastOrder: -3,
        ItemCost: 138.7,
        OrderCost: 1109.6,
        PackageCost: 10.16,
        OrderDate: 1515798000000,
        RequiredDate: 1519426800000,
        ShippedDate: 1516489200000,
        ShipVia: 'United Package',
        Freight: 81.83,
        ShipName: "Tradi\xe7\xe3o Hipermercados",
        ShipAddress: "Av. In\xeas de Castro, 414",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05634-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10829,
        CustomerReference: 'ISLAT',
        CompanyName: 'Island Trading',
        ContactName: 'Helen Bennett',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1682.8128000000002,
        ItemCount: 8,
        ChangeLastOrder: 12,
        ItemCost: 194.77,
        OrderCost: 1558.16,
        PackageCost: 11.432,
        OrderDate: 1515798000000,
        RequiredDate: 1518217200000,
        ShippedDate: 1516662000000,
        ShipVia: 'Speedy Express',
        Freight: 154.72,
        ShipName: 'Island Trading',
        ShipAddress: 'Garden House, Crowther Way',
        ShipCity: 'Cowes',
        ShipRegion: 'Isle of Wight',
        ShipPostalCode: 'PO31 7PJ',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10828,
        CustomerReference: 'RANCH',
        CompanyName: 'Rancho grande',
        ContactName: "Sergio Guti\xe9rrez",
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1271.55,
        ItemCount: 8,
        ChangeLastOrder: -2,
        ItemCost: 181.65,
        OrderCost: 1453.2,
        PackageCost: 10.16,
        OrderDate: 1515798000000,
        RequiredDate: 1517007600000,
        ShippedDate: 1517698800000,
        ShipVia: 'Speedy Express',
        Freight: 90.85,
        ShipName: 'Rancho grande',
        ShipAddress: 'Av. del Libertador 900',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 0
    },
    {
        OrderId: 10827,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Nancy Davolio',
        InvoicedCost: 890.562,
        ItemCount: 12,
        ChangeLastOrder: 6,
        ItemCost: 87.31,
        OrderCost: 1047.72,
        PackageCost: 16.572,
        OrderDate: 1515711600000,
        RequiredDate: 1516921200000,
        ShippedDate: 1517871600000,
        ShipVia: 'United Package',
        Freight: 63.54,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10826,
        CustomerReference: 'BLONP',
        CompanyName: "Blondel p\xe8re et fils",
        ContactName: "Fr\xe9d\xe9rique Citeaux",
        Employee: 'Michael Suyama',
        InvoicedCost: 1586.9424999999999,
        ItemCount: 13,
        ChangeLastOrder: 4,
        ItemCost: 106.15,
        OrderCost: 1379.95,
        PackageCost: 7.0200000000000005,
        OrderDate: 1515711600000,
        RequiredDate: 1518130800000,
        ShippedDate: 1517871600000,
        ShipVia: 'Speedy Express',
        Freight: 7.09,
        ShipName: "Blondel p\xe8re et fils",
        ShipAddress: "24, place Kl\xe9ber",
        ShipCity: 'Strasbourg',
        ShipRegion: null,
        ShipPostalCode: 67000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10825,
        CustomerReference: 'DRACD',
        CompanyName: 'Drachenblut Delikatessen',
        ContactName: 'Sven Ottlieb',
        Employee: 'Nancy Davolio',
        InvoicedCost: 578.91,
        ItemCount: 6,
        ChangeLastOrder: 0,
        ItemCost: 83.9,
        OrderCost: 503.40000000000003,
        PackageCost: 7.62,
        OrderDate: 1515452400000,
        RequiredDate: 1517871600000,
        ShippedDate: 1515884400000,
        ShipVia: 'Speedy Express',
        Freight: 79.25,
        ShipName: 'Drachenblut Delikatessen',
        ShipAddress: 'Walserweg 21',
        ShipCity: 'Aachen',
        ShipRegion: null,
        ShipPostalCode: 52066,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10824,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Laura Callahan',
        InvoicedCost: 811.9332,
        ItemCount: 13,
        ChangeLastOrder: -1,
        ItemCost: 57.83,
        OrderCost: 751.79,
        PackageCost: 16.51,
        OrderDate: 1515452400000,
        RequiredDate: 1517871600000,
        ShippedDate: 1517266800000,
        ShipVia: 'Speedy Express',
        Freight: 1.23,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10823,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Steven Buchanan',
        InvoicedCost: 378.41999999999996,
        ItemCount: 7,
        ChangeLastOrder: 9,
        ItemCost: 63.6,
        OrderCost: 445.2,
        PackageCost: 10.003,
        OrderDate: 1515452400000,
        RequiredDate: 1517871600000,
        ShippedDate: 1515798000000,
        ShipVia: 'United Package',
        Freight: 163.97,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10822,
        CustomerReference: 'TRAIH',
        CompanyName: "Trail's Head Gourmet Provisioners",
        ContactName: 'Helvetius Nagy',
        Employee: 'Michael Suyama',
        InvoicedCost: 824.5692,
        ItemCount: 7,
        ChangeLastOrder: 2,
        ItemCost: 109.07,
        OrderCost: 763.49,
        PackageCost: 8.89,
        OrderDate: 1515366000000,
        RequiredDate: 1517785200000,
        ShippedDate: 1516057200000,
        ShipVia: 'Federal Shipping',
        Freight: 7,
        ShipName: "Trail's Head Gourmet Provisioners",
        ShipAddress: '722 DaVinci Blvd.',
        ShipCity: 'Kirkland',
        ShipRegion: 'WA',
        ShipPostalCode: 98034,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10821,
        CustomerReference: 'SPLIR',
        CompanyName: 'Split Rail Beer & Ale',
        ContactName: 'Art Braunschweiger',
        Employee: 'Nancy Davolio',
        InvoicedCost: 1964.8020000000001,
        ItemCount: 14,
        ChangeLastOrder: 6,
        ItemCost: 133.66,
        OrderCost: 1871.24,
        PackageCost: 19.334,
        OrderDate: 1515366000000,
        RequiredDate: 1517785200000,
        ShippedDate: 1515970800000,
        ShipVia: 'Speedy Express',
        Freight: 36.68,
        ShipName: 'Split Rail Beer & Ale',
        ShipAddress: 'P.O. Box 555',
        ShipCity: 'Lander',
        ShipRegion: 'WY',
        ShipPostalCode: 82520,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10820,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Janet Leverling',
        InvoicedCost: 403.57800000000003,
        ItemCount: 6,
        ChangeLastOrder: 3,
        ItemCost: 64.06,
        OrderCost: 384.36,
        PackageCost: 3.24,
        OrderDate: 1515279600000,
        RequiredDate: 1517698800000,
        ShippedDate: 1515798000000,
        ShipVia: 'United Package',
        Freight: 37.52,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10819,
        CustomerReference: 'CACTU',
        CompanyName: 'Cactus Comidas para llevar',
        ContactName: 'Patricio Simpson',
        Employee: 'Andrew Fuller',
        InvoicedCost: 2172.7355000000002,
        ItemCount: 13,
        ChangeLastOrder: 3,
        ItemCost: 175.93,
        OrderCost: 2287.09,
        PackageCost: 7.0200000000000005,
        OrderDate: 1515279600000,
        RequiredDate: 1517698800000,
        ShippedDate: 1516057200000,
        ShipVia: 'Federal Shipping',
        Freight: 19.76,
        ShipName: 'Cactus Comidas para llevar',
        ShipAddress: 'Cerrito 333',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 1
    },
    {
        OrderId: 10818,
        CustomerReference: 'MAGAA',
        CompanyName: 'Magazzini Alimentari Riuniti',
        ContactName: 'Giovanni Rovelli',
        Employee: 'Robert King',
        InvoicedCost: 650.4879999999999,
        ItemCount: 8,
        ChangeLastOrder: -1,
        ItemCost: 95.66,
        OrderCost: 765.28,
        PackageCost: 10.16,
        OrderDate: 1515279600000,
        RequiredDate: 1517698800000,
        ShippedDate: 1515711600000,
        ShipVia: 'Federal Shipping',
        Freight: 65.48,
        ShipName: 'Magazzini Alimentari Riuniti',
        ShipAddress: 'Via Ludovico il Moro 22',
        ShipCity: 'Bergamo',
        ShipRegion: null,
        ShipPostalCode: 24100,
        ShipCountry: 'Italy',
        ArriveOnTime: 0
    },
    {
        OrderId: 10817,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Janet Leverling',
        InvoicedCost: 1794.588,
        ItemCount: 12,
        ChangeLastOrder: 37,
        ItemCost: 157.42,
        OrderCost: 1889.04,
        PackageCost: 17.148,
        OrderDate: 1515193200000,
        RequiredDate: 1516402800000,
        ShippedDate: 1515798000000,
        ShipVia: 'United Package',
        Freight: 306.07,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10816,
        CustomerReference: 'GREAL',
        CompanyName: 'Great Lakes Food Market',
        ContactName: 'Howard Snyder',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1060.2144,
        ItemCount: 8,
        ChangeLastOrder: 3,
        ItemCost: 122.71,
        OrderCost: 981.68,
        PackageCost: 4.32,
        OrderDate: 1515193200000,
        RequiredDate: 1517612400000,
        ShippedDate: 1517698800000,
        ShipVia: 'United Package',
        Freight: 719.78,
        ShipName: 'Great Lakes Food Market',
        ShipAddress: '2732 Baker Blvd.',
        ShipCity: 'Eugene',
        ShipRegion: 'OR',
        ShipPostalCode: 97403,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10815,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1502.9279999999999,
        ItemCount: 8,
        ChangeLastOrder: 5,
        ItemCost: 178.92,
        OrderCost: 1431.36,
        PackageCost: 4.32,
        OrderDate: 1515106800000,
        RequiredDate: 1517526000000,
        ShippedDate: 1515884400000,
        ShipVia: 'Federal Shipping',
        Freight: 14.62,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10814,
        CustomerReference: 'VICTE',
        CompanyName: 'Victuailles en stock',
        ContactName: 'Mary Saveley',
        Employee: 'Janet Leverling',
        InvoicedCost: 497.90399999999994,
        ItemCount: 6,
        ChangeLastOrder: 5,
        ItemCost: 72.16,
        OrderCost: 432.96,
        PackageCost: 3.24,
        OrderDate: 1515106800000,
        RequiredDate: 1517526000000,
        ShippedDate: 1515884400000,
        ShipVia: 'Federal Shipping',
        Freight: 130.94,
        ShipName: 'Victuailles en stock',
        ShipAddress: '2, rue du Commerce',
        ShipCity: 'Lyon',
        ShipRegion: null,
        ShipPostalCode: 69004,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10813,
        CustomerReference: 'RICAR',
        CompanyName: 'Ricardo Adocicados',
        ContactName: 'Janete Limeira',
        Employee: 'Nancy Davolio',
        InvoicedCost: 1488.1459999999997,
        ItemCount: 11,
        ChangeLastOrder: -2,
        ItemCost: 117.64,
        OrderCost: 1294.04,
        PackageCost: 13.97,
        OrderDate: 1515106800000,
        RequiredDate: 1517526000000,
        ShippedDate: 1515452400000,
        ShipVia: 'Speedy Express',
        Freight: 47.38,
        ShipName: 'Ricardo Adocicados',
        ShipAddress: 'Av. Copacabana, 267',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-890',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10812,
        CustomerReference: 'REGGC',
        CompanyName: 'Reggiani Caseifici',
        ContactName: 'Maurizio Moroni',
        Employee: 'Steven Buchanan',
        InvoicedCost: 658.2644999999999,
        ItemCount: 9,
        ChangeLastOrder: -11,
        ItemCost: 76.99,
        OrderCost: 692.91,
        PackageCost: 10.35,
        OrderDate: 1514847600000,
        RequiredDate: 1517266800000,
        ShippedDate: 1515711600000,
        ShipVia: 'Speedy Express',
        Freight: 59.78,
        ShipName: 'Reggiani Caseifici',
        ShipAddress: 'Strada Provinciale 124',
        ShipCity: 'Reggio Emilia',
        ShipRegion: null,
        ShipPostalCode: 42100,
        ShipCountry: 'Italy',
        ArriveOnTime: 0
    },
    {
        OrderId: 10811,
        CustomerReference: 'LINOD',
        CompanyName: 'LINO-Delicateses',
        ContactName: 'Felipe Izquierdo',
        Employee: 'Laura Callahan',
        InvoicedCost: 1714.4556,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 151.32,
        OrderCost: 1664.52,
        PackageCost: 13.97,
        OrderDate: 1514847600000,
        RequiredDate: 1517266800000,
        ShippedDate: 1515366000000,
        ShipVia: 'Speedy Express',
        Freight: 31.22,
        ShipName: 'LINO-Delicateses',
        ShipAddress: 'Ave. 5 de Mayo Porlamar',
        ShipCity: 'I. de Margarita',
        ShipRegion: 'Nueva Esparta',
        ShipPostalCode: 4980,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10810,
        CustomerReference: 'LAUGB',
        CompanyName: 'Laughing Bacchus Wine Cellars',
        ContactName: 'Yoshi Tannamuri',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1349.6868000000002,
        ItemCount: 11,
        ChangeLastOrder: 4,
        ItemCost: 113.61,
        OrderCost: 1249.71,
        PackageCost: 5.94,
        OrderDate: 1514761200000,
        RequiredDate: 1517180400000,
        ShippedDate: 1515279600000,
        ShipVia: 'Federal Shipping',
        Freight: 4.33,
        ShipName: 'Laughing Bacchus Wine Cellars',
        ShipAddress: '2319 Elm St.',
        ShipCity: 'Vancouver',
        ShipRegion: 'BC',
        ShipPostalCode: 'V3F 2K1',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 10809,
        CustomerReference: 'WELLI',
        CompanyName: 'Wellington Importadora',
        ContactName: 'Paula Parente',
        Employee: 'Robert King',
        InvoicedCost: 1818.3,
        ItemCount: 11,
        ChangeLastOrder: -12,
        ItemCost: 174,
        OrderCost: 1914,
        PackageCost: 12.649999999999999,
        OrderDate: 1514761200000,
        RequiredDate: 1517180400000,
        ShippedDate: 1515279600000,
        ShipVia: 'Speedy Express',
        Freight: 4.87,
        ShipName: 'Wellington Importadora',
        ShipAddress: 'Rua do Mercado, 12',
        ShipCity: 'Resende',
        ShipRegion: 'SP',
        ShipPostalCode: '08737-363',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10808,
        CustomerReference: 'PRINI',
        CompanyName: 'Princesa Isabel Vinhos',
        ContactName: 'Isabel de Castro',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1544.2596,
        ItemCount: 13,
        ChangeLastOrder: 3,
        ItemCost: 109.99,
        OrderCost: 1429.87,
        PackageCost: 7.0200000000000005,
        OrderDate: 1514761200000,
        RequiredDate: 1517180400000,
        ShippedDate: 1515452400000,
        ShipVia: 'Federal Shipping',
        Freight: 45.53,
        ShipName: 'Old World Delicatessen',
        ShipAddress: '2743 Bering St.',
        ShipCity: 'Anchorage',
        ShipRegion: 'AK',
        ShipPostalCode: 99508,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10807,
        CustomerReference: 'FRANS',
        CompanyName: 'Franchi S.p.A.',
        ContactName: 'Paolo Accorti',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1213.8087500000001,
        ItemCount: 11,
        ChangeLastOrder: -19,
        ItemCost: 126.11,
        OrderCost: 1387.21,
        PackageCost: 12.649999999999999,
        OrderDate: 1514674800000,
        RequiredDate: 1517094000000,
        ShippedDate: 1517266800000,
        ShipVia: 'Speedy Express',
        Freight: 1.36,
        ShipName: 'Franchi S.p.A.',
        ShipAddress: 'Via Monte Bianco 34',
        ShipCity: 'Torino',
        ShipRegion: null,
        ShipPostalCode: 10100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10806,
        CustomerReference: 'VICTE',
        CompanyName: 'Victuailles en stock',
        ContactName: 'Mary Saveley',
        Employee: 'Janet Leverling',
        InvoicedCost: 528.0224999999999,
        ItemCount: 5,
        ChangeLastOrder: 4,
        ItemCost: 91.83,
        OrderCost: 459.15,
        PackageCost: 2.7,
        OrderDate: 1514674800000,
        RequiredDate: 1517094000000,
        ShippedDate: 1515106800000,
        ShipVia: 'United Package',
        Freight: 22.11,
        ShipName: 'Victuailles en stock',
        ShipAddress: '2, rue du Commerce',
        ShipCity: 'Lyon',
        ShipRegion: null,
        ShipPostalCode: 69004,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10805,
        CustomerReference: 'THEBI',
        CompanyName: 'The Big Cheese',
        ContactName: 'Liz Nixon',
        Employee: 'Andrew Fuller',
        InvoicedCost: 374.15700000000004,
        ItemCount: 6,
        ChangeLastOrder: 0,
        ItemCost: 59.39,
        OrderCost: 356.34000000000003,
        PackageCost: 7.62,
        OrderDate: 1514588400000,
        RequiredDate: 1517007600000,
        ShippedDate: 1515452400000,
        ShipVia: 'Federal Shipping',
        Freight: 237.34,
        ShipName: 'The Big Cheese',
        ShipAddress: '91 Jefferson Way Suite 2',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97201,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10804,
        CustomerReference: 'SEVES',
        CompanyName: 'Seven Seas Imports',
        ContactName: 'Hari Kumar',
        Employee: 'Michael Suyama',
        InvoicedCost: 1362.3012,
        ItemCount: 13,
        ChangeLastOrder: 0,
        ItemCost: 97.03,
        OrderCost: 1261.39,
        PackageCost: 16.51,
        OrderDate: 1514588400000,
        RequiredDate: 1517007600000,
        ShippedDate: 1515279600000,
        ShipVia: 'United Package',
        Freight: 27.33,
        ShipName: 'Seven Seas Imports',
        ShipAddress: '90 Wadhurst Rd.',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'OX15 4NB',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10803,
        CustomerReference: 'WELLI',
        CompanyName: 'Wellington Importadora',
        ContactName: 'Paula Parente',
        Employee: 'Margaret Peacock',
        InvoicedCost: 226.54199999999997,
        ItemCount: 12,
        ChangeLastOrder: -15,
        ItemCost: 22.21,
        OrderCost: 266.52,
        PackageCost: 13.799999999999999,
        OrderDate: 1514588400000,
        RequiredDate: 1517007600000,
        ShippedDate: 1515193200000,
        ShipVia: 'Speedy Express',
        Freight: 55.23,
        ShipName: 'Wellington Importadora',
        ShipAddress: 'Rua do Mercado, 12',
        ShipCity: 'Resende',
        ShipRegion: 'SP',
        ShipPostalCode: '08737-363',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10802,
        CustomerReference: 'SIMOB',
        CompanyName: 'Simons bistro',
        ContactName: 'Jytte Petersen',
        Employee: 'Margaret Peacock',
        InvoicedCost: 98.9485,
        ItemCount: 7,
        ChangeLastOrder: 5,
        ItemCost: 16.63,
        OrderCost: 116.41,
        PackageCost: 3.7800000000000002,
        OrderDate: 1514502000000,
        RequiredDate: 1516921200000,
        ShippedDate: 1514847600000,
        ShipVia: 'United Package',
        Freight: 257.26,
        ShipName: 'Simons bistro',
        ShipAddress: "Vinb\xe6ltet 34",
        ShipCity: "K\xf8benhavn",
        ShipRegion: null,
        ShipPostalCode: 1734,
        ShipCountry: 'Denmark',
        ArriveOnTime: 0
    },
    {
        OrderId: 10801,
        CustomerReference: 'BOLID',
        CompanyName: "B\xf3lido Comidas preparadas",
        ContactName: "Mart\xedn Sommer",
        Employee: 'Margaret Peacock',
        InvoicedCost: 1076.032,
        ItemCount: 8,
        ChangeLastOrder: -4,
        ItemCost: 158.24,
        OrderCost: 1265.92,
        PackageCost: 9.2,
        OrderDate: 1514502000000,
        RequiredDate: 1516921200000,
        ShippedDate: 1514674800000,
        ShipVia: 'United Package',
        Freight: 97.09,
        ShipName: "B\xf3lido Comidas preparadas",
        ShipAddress: 'C/ Araquil, 67',
        ShipCity: 'Madrid',
        ShipRegion: null,
        ShipPostalCode: 28023,
        ShipCountry: 'Spain',
        ArriveOnTime: 0
    },
    {
        OrderId: 10800,
        CustomerReference: 'SEVES',
        CompanyName: 'Seven Seas Imports',
        ContactName: 'Hari Kumar',
        Employee: 'Nancy Davolio',
        InvoicedCost: 214.44480000000001,
        ItemCount: 8,
        ChangeLastOrder: 0,
        ItemCost: 24.82,
        OrderCost: 198.56,
        PackageCost: 10.16,
        OrderDate: 1514242800000,
        RequiredDate: 1516662000000,
        ShippedDate: 1515106800000,
        ShipVia: 'Federal Shipping',
        Freight: 137.44,
        ShipName: 'Seven Seas Imports',
        ShipAddress: '90 Wadhurst Rd.',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'OX15 4NB',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10799,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 642.8125,
        ItemCount: 11,
        ChangeLastOrder: 40,
        ItemCost: 68.75,
        OrderCost: 756.25,
        PackageCost: 15.719000000000001,
        OrderDate: 1514242800000,
        RequiredDate: 1517871600000,
        ShippedDate: 1515106800000,
        ShipVia: 'Federal Shipping',
        Freight: 30.76,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10798,
        CustomerReference: 'ISLAT',
        CompanyName: 'Island Trading',
        ContactName: 'Helen Bennett',
        Employee: 'Andrew Fuller',
        InvoicedCost: 2421.1872000000003,
        ItemCount: 12,
        ChangeLastOrder: 11,
        ItemCost: 186.82,
        OrderCost: 2241.84,
        PackageCost: 17.148,
        OrderDate: 1514242800000,
        RequiredDate: 1516662000000,
        ShippedDate: 1515106800000,
        ShipVia: 'Speedy Express',
        Freight: 2.33,
        ShipName: 'Island Trading',
        ShipAddress: 'Garden House, Crowther Way',
        ShipCity: 'Cowes',
        ShipRegion: 'Isle of Wight',
        ShipPostalCode: 'PO31 7PJ',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10797,
        CustomerReference: 'DRACD',
        CompanyName: 'Drachenblut Delikatessen',
        ContactName: 'Sven Ottlieb',
        Employee: 'Robert King',
        InvoicedCost: 1531.0126,
        ItemCount: 13,
        ChangeLastOrder: 2,
        ItemCost: 114.34,
        OrderCost: 1486.42,
        PackageCost: 16.51,
        OrderDate: 1514156400000,
        RequiredDate: 1516575600000,
        ShippedDate: 1515106800000,
        ShipVia: 'United Package',
        Freight: 33.35,
        ShipName: 'Drachenblut Delikatessen',
        ShipAddress: 'Walserweg 21',
        ShipCity: 'Aachen',
        ShipRegion: null,
        ShipPostalCode: 52066,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10796,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Janet Leverling',
        InvoicedCost: 825.5244,
        ItemCount: 6,
        ChangeLastOrder: -5,
        ItemCost: 133.58,
        OrderCost: 801.48,
        PackageCost: 6.8999999999999995,
        OrderDate: 1514156400000,
        RequiredDate: 1516575600000,
        ShippedDate: 1515884400000,
        ShipVia: 'Speedy Express',
        Freight: 26.52,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10795,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Laura Callahan',
        InvoicedCost: 776.076,
        ItemCount: 8,
        ChangeLastOrder: -5,
        ItemCost: 92.39,
        OrderCost: 739.12,
        PackageCost: 9.2,
        OrderDate: 1514070000000,
        RequiredDate: 1516489200000,
        ShippedDate: 1516402800000,
        ShipVia: 'United Package',
        Freight: 126.66,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10794,
        CustomerReference: 'QUEDE',
        CompanyName: "Que Del\xedcia",
        ContactName: 'Bernardo Batista',
        Employee: 'Michael Suyama',
        InvoicedCost: 2044.3440000000003,
        ItemCount: 12,
        ChangeLastOrder: -2,
        ItemCost: 165.4,
        OrderCost: 1984.8000000000002,
        PackageCost: 15.24,
        OrderDate: 1514070000000,
        RequiredDate: 1516489200000,
        ShippedDate: 1514847600000,
        ShipVia: 'Speedy Express',
        Freight: 21.49,
        ShipName: "Que Del\xedcia",
        ShipAddress: 'Rua da Panificadora, 12',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-673',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10793,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Janet Leverling',
        InvoicedCost: 236.64960000000002,
        ItemCount: 6,
        ChangeLastOrder: -4,
        ItemCost: 36.52,
        OrderCost: 219.12,
        PackageCost: 6.8999999999999995,
        OrderDate: 1514070000000,
        RequiredDate: 1516489200000,
        ShippedDate: 1515366000000,
        ShipVia: 'Federal Shipping',
        Freight: 4.52,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10792,
        CustomerReference: 'WOLZA',
        CompanyName: 'Wolski  Zajazd',
        ContactName: 'Zbyszek Piestrzeniewicz',
        Employee: 'Nancy Davolio',
        InvoicedCost: 1599.7033,
        ItemCount: 13,
        ChangeLastOrder: 26,
        ItemCost: 119.47,
        OrderCost: 1553.11,
        PackageCost: 18.577,
        OrderDate: 1513983600000,
        RequiredDate: 1516402800000,
        ShippedDate: 1514674800000,
        ShipVia: 'Federal Shipping',
        Freight: 23.79,
        ShipName: 'Wolski Zajazd',
        ShipAddress: 'ul. Filtrowa 68',
        ShipCity: 'Warszawa',
        ShipRegion: null,
        ShipPostalCode: '01-012',
        ShipCountry: 'Poland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10791,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Michael Suyama',
        InvoicedCost: 478.1700000000001,
        ItemCount: 6,
        ChangeLastOrder: -3,
        ItemCost: 75.9,
        OrderCost: 455.40000000000003,
        PackageCost: 7.62,
        OrderDate: 1513983600000,
        RequiredDate: 1516402800000,
        ShippedDate: 1514761200000,
        ShipVia: 'United Package',
        Freight: 16.85,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10790,
        CustomerReference: 'GOURL',
        CompanyName: 'Gourmet Lanchonetes',
        ContactName: "Andr\xe9 Fonseca",
        Employee: 'Michael Suyama',
        InvoicedCost: 118.12799999999999,
        ItemCount: 12,
        ChangeLastOrder: -2,
        ItemCost: 8.56,
        OrderCost: 102.72,
        PackageCost: 15.24,
        OrderDate: 1513897200000,
        RequiredDate: 1516316400000,
        ShippedDate: 1514242800000,
        ShipVia: 'Speedy Express',
        Freight: 28.23,
        ShipName: 'Gourmet Lanchonetes',
        ShipAddress: 'Av. Brasil, 442',
        ShipCity: 'Campinas',
        ShipRegion: 'SP',
        ShipPostalCode: '04876-786',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10789,
        CustomerReference: 'FOLIG',
        CompanyName: 'Folies gourmandes',
        ContactName: "Martine Ranc\xe9",
        Employee: 'Nancy Davolio',
        InvoicedCost: 203.54999999999998,
        ItemCount: 12,
        ChangeLastOrder: 5,
        ItemCost: 14.75,
        OrderCost: 177,
        PackageCost: 6.48,
        OrderDate: 1513897200000,
        RequiredDate: 1516316400000,
        ShippedDate: 1514674800000,
        ShipVia: 'United Package',
        Freight: 100.6,
        ShipName: 'Folies gourmandes',
        ShipAddress: "184, chauss\xe9e de Tournai",
        ShipCity: 'Lille',
        ShipRegion: null,
        ShipPostalCode: 59000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10788,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Nancy Davolio',
        InvoicedCost: 128.70000000000002,
        ItemCount: 6,
        ChangeLastOrder: -19,
        ItemCost: 17.16,
        OrderCost: 102.96000000000001,
        PackageCost: 6.8999999999999995,
        OrderDate: 1513897200000,
        RequiredDate: 1516316400000,
        ShippedDate: 1516316400000,
        ShipVia: 'United Package',
        Freight: 42.7,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10787,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Andrew Fuller',
        InvoicedCost: 284.88599999999997,
        ItemCount: 6,
        ChangeLastOrder: 6,
        ItemCost: 55.86,
        OrderCost: 335.15999999999997,
        PackageCost: 8.286,
        OrderDate: 1513638000000,
        RequiredDate: 1514847600000,
        ShippedDate: 1514242800000,
        ShipVia: 'Speedy Express',
        Freight: 249.93,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10786,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Laura Callahan',
        InvoicedCost: 609.688,
        ItemCount: 8,
        ChangeLastOrder: -2,
        ItemCost: 89.66,
        OrderCost: 717.28,
        PackageCost: 10.16,
        OrderDate: 1513638000000,
        RequiredDate: 1516057200000,
        ShippedDate: 1513983600000,
        ShipVia: 'Speedy Express',
        Freight: 110.87,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10785,
        CustomerReference: 'GROSR',
        CompanyName: 'GROSELLA-Restaurante',
        ContactName: 'Manuel Pereira',
        Employee: 'Nancy Davolio',
        InvoicedCost: 905.0545,
        ItemCount: 7,
        ChangeLastOrder: 2,
        ItemCost: 152.11,
        OrderCost: 1064.77,
        PackageCost: 8.89,
        OrderDate: 1513551600000,
        RequiredDate: 1515970800000,
        ShippedDate: 1514070000000,
        ShipVia: 'Federal Shipping',
        Freight: 1.51,
        ShipName: 'GROSELLA-Restaurante',
        ShipAddress: "5\xaa Ave. Los Palos Grandes",
        ShipCity: 'Caracas',
        ShipRegion: 'DF',
        ShipPostalCode: 1081,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10784,
        CustomerReference: 'MAGAA',
        CompanyName: 'Magazzini Alimentari Riuniti',
        ContactName: 'Giovanni Rovelli',
        Employee: 'Margaret Peacock',
        InvoicedCost: 610.9799999999999,
        ItemCount: 8,
        ChangeLastOrder: -4,
        ItemCost: 89.85,
        OrderCost: 718.8,
        PackageCost: 9.2,
        OrderDate: 1513551600000,
        RequiredDate: 1515970800000,
        ShippedDate: 1513897200000,
        ShipVia: 'Federal Shipping',
        Freight: 70.09,
        ShipName: 'Magazzini Alimentari Riuniti',
        ShipAddress: 'Via Ludovico il Moro 22',
        ShipCity: 'Bergamo',
        ShipRegion: null,
        ShipPostalCode: 24100,
        ShipCountry: 'Italy',
        ArriveOnTime: 0
    },
    {
        OrderId: 10783,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Margaret Peacock',
        InvoicedCost: 129.064,
        ItemCount: 13,
        ChangeLastOrder: -29,
        ItemCost: 11.68,
        OrderCost: 151.84,
        PackageCost: 14.95,
        OrderDate: 1513551600000,
        RequiredDate: 1515970800000,
        ShippedDate: 1513638000000,
        ShipVia: 'United Package',
        Freight: 124.98,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10782,
        CustomerReference: 'CACTU',
        CompanyName: 'Cactus Comidas para llevar',
        ContactName: 'Patricio Simpson',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 510.27200000000005,
        ItemCount: 7,
        ChangeLastOrder: 0,
        ItemCost: 85.76,
        OrderCost: 600.32,
        PackageCost: 8.89,
        OrderDate: 1513465200000,
        RequiredDate: 1515884400000,
        ShippedDate: 1513897200000,
        ShipVia: 'Federal Shipping',
        Freight: 1.1,
        ShipName: 'Cactus Comidas para llevar',
        ShipAddress: 'Cerrito 333',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 1
    },
    {
        OrderId: 10781,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Andrew Fuller',
        InvoicedCost: 530.124,
        ItemCount: 8,
        ChangeLastOrder: -37,
        ItemCost: 63.11,
        OrderCost: 504.88,
        PackageCost: 9.2,
        OrderDate: 1513465200000,
        RequiredDate: 1515884400000,
        ShippedDate: 1513638000000,
        ShipVia: 'Federal Shipping',
        Freight: 73.16,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10780,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Andrew Fuller',
        InvoicedCost: 989.553,
        ItemCount: 6,
        ChangeLastOrder: 15,
        ItemCost: 194.03,
        OrderCost: 1164.18,
        PackageCost: 8.574,
        OrderDate: 1513378800000,
        RequiredDate: 1514588400000,
        ShippedDate: 1514156400000,
        ShipVia: 'Speedy Express',
        Freight: 42.13,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10779,
        CustomerReference: 'MORGK',
        CompanyName: 'Morgenstern Gesundkost',
        ContactName: 'Alexander Feuer',
        Employee: 'Janet Leverling',
        InvoicedCost: 1561.355,
        ItemCount: 10,
        ChangeLastOrder: -24,
        ItemCost: 135.77,
        OrderCost: 1357.7,
        PackageCost: 11.5,
        OrderDate: 1513378800000,
        RequiredDate: 1515798000000,
        ShippedDate: 1515884400000,
        ShipVia: 'United Package',
        Freight: 58.13,
        ShipName: 'Morgenstern Gesundkost',
        ShipAddress: 'Heerstr. 22',
        ShipCity: 'Leipzig',
        ShipRegion: null,
        ShipPostalCode: 4179,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10778,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Janet Leverling',
        InvoicedCost: 595.4040000000001,
        ItemCount: 10,
        ChangeLastOrder: -3,
        ItemCost: 55.13,
        OrderCost: 551.3000000000001,
        PackageCost: 12.7,
        OrderDate: 1513378800000,
        RequiredDate: 1515798000000,
        ShippedDate: 1514070000000,
        ShipVia: 'Speedy Express',
        Freight: 6.79,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10777,
        CustomerReference: 'GOURL',
        CompanyName: 'Gourmet Lanchonetes',
        ContactName: "Andr\xe9 Fonseca",
        Employee: 'Robert King',
        InvoicedCost: 142.34699999999998,
        ItemCount: 6,
        ChangeLastOrder: -2,
        ItemCost: 20.63,
        OrderCost: 123.78,
        PackageCost: 7.62,
        OrderDate: 1513292400000,
        RequiredDate: 1514502000000,
        ShippedDate: 1516489200000,
        ShipVia: 'United Package',
        Freight: 3.01,
        ShipName: 'Gourmet Lanchonetes',
        ShipAddress: 'Av. Brasil, 442',
        ShipCity: 'Campinas',
        ShipRegion: 'SP',
        ShipPostalCode: '04876-786',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10776,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Nancy Davolio',
        InvoicedCost: 713.5380000000001,
        ItemCount: 12,
        ChangeLastOrder: -3,
        ItemCost: 56.63,
        OrderCost: 679.5600000000001,
        PackageCost: 15.24,
        OrderDate: 1513292400000,
        RequiredDate: 1515711600000,
        ShippedDate: 1513551600000,
        ShipVia: 'Federal Shipping',
        Freight: 351.53,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10775,
        CustomerReference: 'THECR',
        CompanyName: 'The Cracker Box',
        ContactName: 'Liu Wong',
        Employee: 'Robert King',
        InvoicedCost: 507.5525,
        ItemCount: 13,
        ChangeLastOrder: 2,
        ItemCost: 33.95,
        OrderCost: 441.35,
        PackageCost: 16.51,
        OrderDate: 1513033200000,
        RequiredDate: 1515452400000,
        ShippedDate: 1514242800000,
        ShipVia: 'Speedy Express',
        Freight: 20.25,
        ShipName: 'The Cracker Box',
        ShipAddress: '55 Grizzly Peak Rd.',
        ShipCity: 'Butte',
        ShipRegion: 'MT',
        ShipPostalCode: 59801,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10774,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Margaret Peacock',
        InvoicedCost: 270.3456,
        ItemCount: 12,
        ChangeLastOrder: -1,
        ItemCost: 20.86,
        OrderCost: 250.32,
        PackageCost: 15.24,
        OrderDate: 1512946800000,
        RequiredDate: 1514156400000,
        ShippedDate: 1513033200000,
        ShipVia: 'Speedy Express',
        Freight: 48.2,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10773,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Nancy Davolio',
        InvoicedCost: 548.31,
        ItemCount: 7,
        ChangeLastOrder: 5,
        ItemCost: 74.6,
        OrderCost: 522.1999999999999,
        PackageCost: 3.7800000000000002,
        OrderDate: 1512946800000,
        RequiredDate: 1515366000000,
        ShippedDate: 1513378800000,
        ShipVia: 'Federal Shipping',
        Freight: 96.43,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10772,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Janet Leverling',
        InvoicedCost: 707.894,
        ItemCount: 11,
        ChangeLastOrder: -25,
        ItemCost: 55.96,
        OrderCost: 615.5600000000001,
        PackageCost: 12.649999999999999,
        OrderDate: 1512860400000,
        RequiredDate: 1515279600000,
        ShippedDate: 1513638000000,
        ShipVia: 'United Package',
        Freight: 91.28,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10771,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 81.396,
        ItemCount: 12,
        ChangeLastOrder: 14,
        ItemCost: 6.46,
        OrderCost: 77.52,
        PackageCost: 17.148,
        OrderDate: 1512860400000,
        RequiredDate: 1515279600000,
        ShippedDate: 1514847600000,
        ShipVia: 'United Package',
        Freight: 11.19,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 1
    },
    {
        OrderId: 10770,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Laura Callahan',
        InvoicedCost: 229.04100000000003,
        ItemCount: 9,
        ChangeLastOrder: -25,
        ItemCost: 29.94,
        OrderCost: 269.46000000000004,
        PackageCost: 10.35,
        OrderDate: 1512774000000,
        RequiredDate: 1515193200000,
        ShippedDate: 1513465200000,
        ShipVia: 'Federal Shipping',
        Freight: 5.32,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10769,
        CustomerReference: 'VAFFE',
        CompanyName: 'Vaffeljernet',
        ContactName: 'Palle Ibsen',
        Employee: 'Janet Leverling',
        InvoicedCost: 409.773,
        ItemCount: 13,
        ChangeLastOrder: 13,
        ItemCost: 30.02,
        OrderCost: 390.26,
        PackageCost: 18.577,
        OrderDate: 1512687600000,
        RequiredDate: 1515106800000,
        ShippedDate: 1513033200000,
        ShipVia: 'Speedy Express',
        Freight: 65.06,
        ShipName: 'Vaffeljernet',
        ShipAddress: "Smagsl\xf8get 45",
        ShipCity: "\xc5rhus",
        ShipRegion: null,
        ShipPostalCode: 8200,
        ShipCountry: 'Denmark',
        ArriveOnTime: 0
    },
    {
        OrderId: 10768,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Janet Leverling',
        InvoicedCost: 803.9736,
        ItemCount: 6,
        ChangeLastOrder: -4,
        ItemCost: 124.07,
        OrderCost: 744.42,
        PackageCost: 6.8999999999999995,
        OrderDate: 1512687600000,
        RequiredDate: 1515106800000,
        ShippedDate: 1513292400000,
        ShipVia: 'United Package',
        Freight: 146.32,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10767,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1611.3816000000002,
        ItemCount: 9,
        ChangeLastOrder: -4,
        ItemCost: 165.78,
        OrderCost: 1492.02,
        PackageCost: 10.35,
        OrderDate: 1512428400000,
        RequiredDate: 1514847600000,
        ShippedDate: 1513292400000,
        ShipVia: 'Federal Shipping',
        Freight: 1.59,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 1
    },
    {
        OrderId: 10766,
        CustomerReference: 'OTTIK',
        CompanyName: "Ottilies K\xe4seladen",
        ContactName: 'Henriette Pfalzheim',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1505.0969999999998,
        ItemCount: 11,
        ChangeLastOrder: 21,
        ItemCost: 118.98,
        OrderCost: 1308.78,
        PackageCost: 15.719000000000001,
        OrderDate: 1512428400000,
        RequiredDate: 1514847600000,
        ShippedDate: 1512774000000,
        ShipVia: 'Speedy Express',
        Freight: 157.55,
        ShipName: "Ottilies K\xe4seladen",
        ShipAddress: 'Mehrheimerstr. 369',
        ShipCity: "K\xf6ln",
        ShipRegion: null,
        ShipPostalCode: 50739,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10765,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Janet Leverling',
        InvoicedCost: 911.9,
        ItemCount: 11,
        ChangeLastOrder: -23,
        ItemCost: 66.32,
        OrderCost: 729.52,
        PackageCost: 12.649999999999999,
        OrderDate: 1512342000000,
        RequiredDate: 1514761200000,
        ShippedDate: 1512774000000,
        ShipVia: 'Federal Shipping',
        Freight: 42.74,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10764,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Michael Suyama',
        InvoicedCost: 31.248000000000005,
        ItemCount: 8,
        ChangeLastOrder: 17,
        ItemCost: 3.72,
        OrderCost: 29.76,
        PackageCost: 11.432,
        OrderDate: 1512255600000,
        RequiredDate: 1514674800000,
        ShippedDate: 1512687600000,
        ShipVia: 'Federal Shipping',
        Freight: 145.45,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10763,
        CustomerReference: 'FOLIG',
        CompanyName: 'Folies gourmandes',
        ContactName: "Martine Ranc\xe9",
        Employee: 'Janet Leverling',
        InvoicedCost: 1123.32,
        ItemCount: 11,
        ChangeLastOrder: 5,
        ItemCost: 88.8,
        OrderCost: 976.8,
        PackageCost: 5.94,
        OrderDate: 1512255600000,
        RequiredDate: 1514674800000,
        ShippedDate: 1512687600000,
        ShipVia: 'Federal Shipping',
        Freight: 37.35,
        ShipName: 'Folies gourmandes',
        ShipAddress: "184, chauss\xe9e de Tournai",
        ShipCity: 'Lille',
        ShipRegion: null,
        ShipPostalCode: 59000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10762,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Janet Leverling',
        InvoicedCost: 1076.3064,
        ItemCount: 13,
        ChangeLastOrder: -1,
        ItemCost: 76.66,
        OrderCost: 996.5799999999999,
        PackageCost: 16.51,
        OrderDate: 1512169200000,
        RequiredDate: 1514588400000,
        ShippedDate: 1512774000000,
        ShipVia: 'Speedy Express',
        Freight: 328.74,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10761,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Steven Buchanan',
        InvoicedCost: 1193.8290000000002,
        ItemCount: 13,
        ChangeLastOrder: 2,
        ItemCost: 87.46,
        OrderCost: 1136.98,
        PackageCost: 16.51,
        OrderDate: 1512169200000,
        RequiredDate: 1514588400000,
        ShippedDate: 1512687600000,
        ShipVia: 'United Package',
        Freight: 18.66,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10760,
        CustomerReference: 'MAISD',
        CompanyName: 'Maison Dewey',
        ContactName: 'Catherine Dewey',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1186.8120000000001,
        ItemCount: 10,
        ChangeLastOrder: 23,
        ItemCost: 109.89,
        OrderCost: 1098.9,
        PackageCost: 14.290000000000001,
        OrderDate: 1512082800000,
        RequiredDate: 1514502000000,
        ShippedDate: 1512860400000,
        ShipVia: 'Speedy Express',
        Freight: 155.64,
        ShipName: 'Maison Dewey',
        ShipAddress: 'Rue Joseph-Bens 532',
        ShipCity: 'Bruxelles',
        ShipRegion: null,
        ShipPostalCode: 'B-1180',
        ShipCountry: 'Belgium',
        ArriveOnTime: 0
    },
    {
        OrderId: 10759,
        CustomerReference: 'ANATR',
        CompanyName: 'Ana Trujillo Emparedados y helados',
        ContactName: 'Ana Trujillo',
        Employee: 'Janet Leverling',
        InvoicedCost: 1132.9799999999998,
        ItemCount: 6,
        ChangeLastOrder: -3,
        ItemCost: 164.2,
        OrderCost: 985.1999999999999,
        PackageCost: 7.62,
        OrderDate: 1511823600000,
        RequiredDate: 1514242800000,
        ShippedDate: 1513033200000,
        ShipVia: 'Federal Shipping',
        Freight: 11.99,
        ShipName: 'Ana Trujillo Emparedados y helados',
        ShipAddress: "Avda. de la Constituci\xf3n 2222",
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5021,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10758,
        CustomerReference: 'RICSU',
        CompanyName: 'Richter Supermarkt',
        ContactName: 'Michael Holz',
        Employee: 'Janet Leverling',
        InvoicedCost: 712.776,
        ItemCount: 12,
        ChangeLastOrder: 2,
        ItemCost: 69.88,
        OrderCost: 838.56,
        PackageCost: 15.24,
        OrderDate: 1511823600000,
        RequiredDate: 1514242800000,
        ShippedDate: 1512342000000,
        ShipVia: 'Federal Shipping',
        Freight: 138.17,
        ShipName: 'Richter Supermarkt',
        ShipAddress: 'Starenweg 5',
        ShipCity: "Gen\xe8ve",
        ShipRegion: null,
        ShipPostalCode: 1204,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10757,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Michael Suyama',
        InvoicedCost: 1574.8319999999999,
        ItemCount: 8,
        ChangeLastOrder: 5,
        ItemCost: 187.48,
        OrderCost: 1499.84,
        PackageCost: 4.32,
        OrderDate: 1511737200000,
        RequiredDate: 1514156400000,
        ShippedDate: 1513292400000,
        ShipVia: 'Speedy Express',
        Freight: 8.19,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10756,
        CustomerReference: 'SPLIR',
        CompanyName: 'Split Rail Beer & Ale',
        ContactName: 'Art Braunschweiger',
        Employee: 'Laura Callahan',
        InvoicedCost: 669.5849999999999,
        ItemCount: 7,
        ChangeLastOrder: 13,
        ItemCost: 91.1,
        OrderCost: 637.6999999999999,
        PackageCost: 10.003,
        OrderDate: 1511737200000,
        RequiredDate: 1514156400000,
        ShippedDate: 1512169200000,
        ShipVia: 'United Package',
        Freight: 73.21,
        ShipName: 'Split Rail Beer & Ale',
        ShipAddress: 'P.O. Box 555',
        ShipCity: 'Lander',
        ShipRegion: 'WY',
        ShipPostalCode: 82520,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10755,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1730.235,
        ItemCount: 10,
        ChangeLastOrder: 5,
        ItemCost: 182.13,
        OrderCost: 1821.3,
        PackageCost: 5.4,
        OrderDate: 1511650800000,
        RequiredDate: 1514070000000,
        ShippedDate: 1511823600000,
        ShipVia: 'United Package',
        Freight: 16.71,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10754,
        CustomerReference: 'MAGAA',
        CompanyName: 'Magazzini Alimentari Riuniti',
        ContactName: 'Giovanni Rovelli',
        Employee: 'Michael Suyama',
        InvoicedCost: 1405.60875,
        ItemCount: 9,
        ChangeLastOrder: 11,
        ItemCost: 178.49,
        OrderCost: 1606.41,
        PackageCost: 12.861,
        OrderDate: 1511564400000,
        RequiredDate: 1513983600000,
        ShippedDate: 1511737200000,
        ShipVia: 'Federal Shipping',
        Freight: 2.38,
        ShipName: 'Magazzini Alimentari Riuniti',
        ShipAddress: 'Via Ludovico il Moro 22',
        ShipCity: 'Bergamo',
        ShipRegion: null,
        ShipPostalCode: 24100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10753,
        CustomerReference: 'FRANS',
        CompanyName: 'Franchi S.p.A.',
        ContactName: 'Paolo Accorti',
        Employee: 'Janet Leverling',
        InvoicedCost: 524.6370000000001,
        ItemCount: 6,
        ChangeLastOrder: -28,
        ItemCost: 102.87,
        OrderCost: 617.22,
        PackageCost: 6.8999999999999995,
        OrderDate: 1511564400000,
        RequiredDate: 1513983600000,
        ShippedDate: 1511737200000,
        ShipVia: 'Speedy Express',
        Freight: 7.7,
        ShipName: 'Franchi S.p.A.',
        ShipAddress: 'Via Monte Bianco 34',
        ShipCity: 'Torino',
        ShipRegion: null,
        ShipPostalCode: 10100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10752,
        CustomerReference: 'NORTS',
        CompanyName: 'North/South',
        ContactName: 'Simon Crowther',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1815.858,
        ItemCount: 11,
        ChangeLastOrder: 7,
        ItemCost: 152.85,
        OrderCost: 1681.35,
        PackageCost: 15.191,
        OrderDate: 1511478000000,
        RequiredDate: 1513897200000,
        ShippedDate: 1511823600000,
        ShipVia: 'Federal Shipping',
        Freight: 1.39,
        ShipName: 'North/South',
        ShipAddress: 'South House, 300 Queensbridge',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'SW7 1RZ',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10751,
        CustomerReference: 'RICSU',
        CompanyName: 'Richter Supermarkt',
        ContactName: 'Michael Holz',
        Employee: 'Janet Leverling',
        InvoicedCost: 1346.5375,
        ItemCount: 10,
        ChangeLastOrder: 5,
        ItemCost: 153.89,
        OrderCost: 1538.8999999999999,
        PackageCost: 5.4,
        OrderDate: 1511478000000,
        RequiredDate: 1513897200000,
        ShippedDate: 1512255600000,
        ShipVia: 'Federal Shipping',
        Freight: 130.79,
        ShipName: 'Richter Supermarkt',
        ShipAddress: 'Starenweg 5',
        ShipCity: "Gen\xe8ve",
        ShipRegion: null,
        ShipPostalCode: 1204,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10750,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1155.7140000000002,
        ItemCount: 7,
        ChangeLastOrder: 38,
        ItemCost: 157.24,
        OrderCost: 1100.68,
        PackageCost: 10.003,
        OrderDate: 1511218800000,
        RequiredDate: 1513638000000,
        ShippedDate: 1511478000000,
        ShipVia: 'Speedy Express',
        Freight: 79.3,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10749,
        CustomerReference: 'ISLAT',
        CompanyName: 'Island Trading',
        ContactName: 'Helen Bennett',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1227.2364,
        ItemCount: 13,
        ChangeLastOrder: 10,
        ItemCost: 87.41,
        OrderCost: 1136.33,
        PackageCost: 18.577,
        OrderDate: 1511132400000,
        RequiredDate: 1513551600000,
        ShippedDate: 1513638000000,
        ShipVia: 'United Package',
        Freight: 61.53,
        ShipName: 'Island Trading',
        ShipAddress: 'Garden House, Crowther Way',
        ShipCity: 'Cowes',
        ShipRegion: 'Isle of Wight',
        ShipPostalCode: 'PO31 7PJ',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10748,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Janet Leverling',
        InvoicedCost: 17.325,
        ItemCount: 11,
        ChangeLastOrder: 5,
        ItemCost: 1.5,
        OrderCost: 16.5,
        PackageCost: 5.94,
        OrderDate: 1511132400000,
        RequiredDate: 1513551600000,
        ShippedDate: 1511823600000,
        ShipVia: 'Speedy Express',
        Freight: 232.55,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10747,
        CustomerReference: 'PICCO',
        CompanyName: 'Piccolo und mehr',
        ContactName: 'Georg Pipps',
        Employee: 'Michael Suyama',
        InvoicedCost: 1103.2536000000002,
        ItemCount: 12,
        ChangeLastOrder: -1,
        ItemCost: 89.26,
        OrderCost: 1071.1200000000001,
        PackageCost: 15.24,
        OrderDate: 1511046000000,
        RequiredDate: 1513465200000,
        ShippedDate: 1511650800000,
        ShipVia: 'Speedy Express',
        Freight: 117.33,
        ShipName: 'Piccolo und mehr',
        ShipAddress: 'Geislweg 14',
        ShipCity: 'Salzburg',
        ShipRegion: null,
        ShipPostalCode: 5020,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10746,
        CustomerReference: 'CHOPS',
        CompanyName: 'Chop-suey Chinese',
        ContactName: 'Yang Wang',
        Employee: 'Nancy Davolio',
        InvoicedCost: 2061.576,
        ItemCount: 11,
        ChangeLastOrder: -15,
        ItemCost: 197.28,
        OrderCost: 2170.08,
        PackageCost: 12.649999999999999,
        OrderDate: 1511046000000,
        RequiredDate: 1513465200000,
        ShippedDate: 1511218800000,
        ShipVia: 'Federal Shipping',
        Freight: 31.43,
        ShipName: 'Chop-suey Chinese',
        ShipAddress: 'Hauptstr. 31',
        ShipCity: 'Bern',
        ShipRegion: null,
        ShipPostalCode: 3012,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10745,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1010.8625999999999,
        ItemCount: 11,
        ChangeLastOrder: -23,
        ItemCost: 89.22,
        OrderCost: 981.42,
        PackageCost: 12.649999999999999,
        OrderDate: 1510959600000,
        RequiredDate: 1513378800000,
        ShippedDate: 1511737200000,
        ShipVia: 'Speedy Express',
        Freight: 3.52,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10744,
        CustomerReference: 'VAFFE',
        CompanyName: 'Vaffeljernet',
        ContactName: 'Palle Ibsen',
        Employee: 'Michael Suyama',
        InvoicedCost: 151.1055,
        ItemCount: 13,
        ChangeLastOrder: 16,
        ItemCost: 11.07,
        OrderCost: 143.91,
        PackageCost: 18.577,
        OrderDate: 1510873200000,
        RequiredDate: 1513292400000,
        ShippedDate: 1511478000000,
        ShipVia: 'Speedy Express',
        Freight: 69.19,
        ShipName: 'Vaffeljernet',
        ShipAddress: "Smagsl\xf8get 45",
        ShipCity: "\xc5rhus",
        ShipRegion: null,
        ShipPostalCode: 8200,
        ShipCountry: 'Denmark',
        ArriveOnTime: 0
    },
    {
        OrderId: 10743,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Nancy Davolio',
        InvoicedCost: 2810.5056,
        ItemCount: 14,
        ChangeLastOrder: -4,
        ItemCost: 185.88,
        OrderCost: 2602.3199999999997,
        PackageCost: 16.099999999999998,
        OrderDate: 1510873200000,
        RequiredDate: 1513292400000,
        ShippedDate: 1511218800000,
        ShipVia: 'United Package',
        Freight: 23.72,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10742,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Janet Leverling',
        InvoicedCost: 1002.5532000000001,
        ItemCount: 11,
        ChangeLastOrder: 4,
        ItemCost: 84.39,
        OrderCost: 928.29,
        PackageCost: 5.94,
        OrderDate: 1510614000000,
        RequiredDate: 1513033200000,
        ShippedDate: 1510959600000,
        ShipVia: 'Federal Shipping',
        Freight: 243.73,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10741,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Margaret Peacock',
        InvoicedCost: 824.7744,
        ItemCount: 8,
        ChangeLastOrder: -4,
        ItemCost: 95.46,
        OrderCost: 763.68,
        PackageCost: 9.2,
        OrderDate: 1510614000000,
        RequiredDate: 1511823600000,
        ShippedDate: 1510959600000,
        ShipVia: 'Federal Shipping',
        Freight: 10.96,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10740,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Margaret Peacock',
        InvoicedCost: 308.1024,
        ItemCount: 8,
        ChangeLastOrder: 6,
        ItemCost: 35.66,
        OrderCost: 285.28,
        PackageCost: 11.048,
        OrderDate: 1510527600000,
        RequiredDate: 1512946800000,
        ShippedDate: 1511564400000,
        ShipVia: 'United Package',
        Freight: 81.88,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10739,
        CustomerReference: 'VINET',
        CompanyName: 'Vins et alcools Chevalier',
        ContactName: 'Paul Henriot',
        Employee: 'Janet Leverling',
        InvoicedCost: 1074.3645,
        ItemCount: 11,
        ChangeLastOrder: 2,
        ItemCost: 84.93,
        OrderCost: 934.23,
        PackageCost: 13.97,
        OrderDate: 1510441200000,
        RequiredDate: 1512860400000,
        ShippedDate: 1510873200000,
        ShipVia: 'Federal Shipping',
        Freight: 11.08,
        ShipName: 'Vins et alcools Chevalier',
        ShipAddress: "59 rue de l'Abbaye",
        ShipCity: 'Reims',
        ShipRegion: null,
        ShipPostalCode: 51100,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10738,
        CustomerReference: 'SPECD',
        CompanyName: "Sp\xe9cialit\xe9s du monde",
        ContactName: 'Dominique Perrier',
        Employee: 'Andrew Fuller',
        InvoicedCost: 851.7284999999999,
        ItemCount: 9,
        ChangeLastOrder: 4,
        ItemCost: 90.13,
        OrderCost: 811.17,
        PackageCost: 4.86,
        OrderDate: 1510441200000,
        RequiredDate: 1512860400000,
        ShippedDate: 1510959600000,
        ShipVia: 'Speedy Express',
        Freight: 2.91,
        ShipName: "Sp\xe9cialit\xe9s du monde",
        ShipAddress: '25, rue Lauriston',
        ShipCity: 'Paris',
        ShipRegion: null,
        ShipPostalCode: 75016,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10737,
        CustomerReference: 'VINET',
        CompanyName: 'Vins et alcools Chevalier',
        ContactName: 'Paul Henriot',
        Employee: 'Andrew Fuller',
        InvoicedCost: 623.116,
        ItemCount: 13,
        ChangeLastOrder: 2,
        ItemCost: 41.68,
        OrderCost: 541.84,
        PackageCost: 16.51,
        OrderDate: 1510354800000,
        RequiredDate: 1512774000000,
        ShippedDate: 1510959600000,
        ShipVia: 'United Package',
        Freight: 7.79,
        ShipName: 'Vins et alcools Chevalier',
        ShipAddress: "59 rue de l'Abbaye",
        ShipCity: 'Reims',
        ShipRegion: null,
        ShipPostalCode: 51100,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10736,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1406.4840000000002,
        ItemCount: 9,
        ChangeLastOrder: 2,
        ItemCost: 144.7,
        OrderCost: 1302.3,
        PackageCost: 11.43,
        OrderDate: 1510354800000,
        RequiredDate: 1512774000000,
        ShippedDate: 1511218800000,
        ShipVia: 'United Package',
        Freight: 44.1,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10735,
        CustomerReference: 'LETSS',
        CompanyName: "Let's Stop N Shop",
        ContactName: 'Jaime Yorres',
        Employee: 'Michael Suyama',
        InvoicedCost: 101.682,
        ItemCount: 9,
        ChangeLastOrder: 1,
        ItemCost: 10.76,
        OrderCost: 96.84,
        PackageCost: 11.43,
        OrderDate: 1510268400000,
        RequiredDate: 1512687600000,
        ShippedDate: 1511218800000,
        ShipVia: 'United Package',
        Freight: 45.97,
        ShipName: "Let's Stop N Shop",
        ShipAddress: '89 Polk St. Suite 5',
        ShipCity: 'San Francisco',
        ShipRegion: 'CA',
        ShipPostalCode: 94117,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10734,
        CustomerReference: 'GOURL',
        CompanyName: 'Gourmet Lanchonetes',
        ContactName: "Andr\xe9 Fonseca",
        Employee: 'Andrew Fuller',
        InvoicedCost: 36.984,
        ItemCount: 12,
        ChangeLastOrder: -2,
        ItemCost: 2.68,
        OrderCost: 32.160000000000004,
        PackageCost: 15.24,
        OrderDate: 1510009200000,
        RequiredDate: 1512428400000,
        ShippedDate: 1510441200000,
        ShipVia: 'Federal Shipping',
        Freight: 1.63,
        ShipName: 'Gourmet Lanchonetes',
        ShipAddress: 'Av. Brasil, 442',
        ShipCity: 'Campinas',
        ShipRegion: 'SP',
        ShipPostalCode: '04876-786',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10733,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Nancy Davolio',
        InvoicedCost: 294.624,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 24.8,
        OrderCost: 272.8,
        PackageCost: 13.97,
        OrderDate: 1510009200000,
        RequiredDate: 1512428400000,
        ShippedDate: 1510268400000,
        ShipVia: 'Federal Shipping',
        Freight: 110.11,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10732,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Janet Leverling',
        InvoicedCost: 519.4860000000001,
        ItemCount: 11,
        ChangeLastOrder: 6,
        ItemCost: 55.56,
        OrderCost: 611.1600000000001,
        PackageCost: 15.191,
        OrderDate: 1509922800000,
        RequiredDate: 1512342000000,
        ShippedDate: 1510009200000,
        ShipVia: 'Speedy Express',
        Freight: 16.97,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10731,
        CustomerReference: 'CHOPS',
        CompanyName: 'Chop-suey Chinese',
        ContactName: 'Yang Wang',
        Employee: 'Robert King',
        InvoicedCost: 2058.7259999999997,
        ItemCount: 12,
        ChangeLastOrder: -16,
        ItemCost: 180.59,
        OrderCost: 2167.08,
        PackageCost: 13.799999999999999,
        OrderDate: 1509922800000,
        RequiredDate: 1512342000000,
        ShippedDate: 1510614000000,
        ShipVia: 'Speedy Express',
        Freight: 96.65,
        ShipName: 'Chop-suey Chinese',
        ShipAddress: 'Hauptstr. 31',
        ShipCity: 'Bern',
        ShipRegion: null,
        ShipPostalCode: 3012,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10730,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Steven Buchanan',
        InvoicedCost: 505.971,
        ItemCount: 6,
        ChangeLastOrder: 5,
        ItemCost: 99.21,
        OrderCost: 595.26,
        PackageCost: 3.24,
        OrderDate: 1509836400000,
        RequiredDate: 1512255600000,
        ShippedDate: 1510614000000,
        ShipVia: 'Speedy Express',
        Freight: 20.12,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10729,
        CustomerReference: 'LINOD',
        CompanyName: 'LINO-Delicateses',
        ContactName: 'Felipe Izquierdo',
        Employee: 'Laura Callahan',
        InvoicedCost: 799.1049,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 70.53,
        OrderCost: 775.83,
        PackageCost: 13.97,
        OrderDate: 1509750000000,
        RequiredDate: 1513378800000,
        ShippedDate: 1510614000000,
        ShipVia: 'Federal Shipping',
        Freight: 141.06,
        ShipName: 'LINO-Delicateses',
        ShipAddress: 'Ave. 5 de Mayo Porlamar',
        ShipCity: 'I. de Margarita',
        ShipRegion: 'Nueva Esparta',
        ShipPostalCode: 4980,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10728,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Margaret Peacock',
        InvoicedCost: 1056.5415,
        ItemCount: 7,
        ChangeLastOrder: -2,
        ItemCost: 177.57,
        OrderCost: 1242.99,
        PackageCost: 8.89,
        OrderDate: 1509750000000,
        RequiredDate: 1512169200000,
        ShippedDate: 1510354800000,
        ShipVia: 'United Package',
        Freight: 58.33,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10727,
        CustomerReference: 'REGGC',
        CompanyName: 'Reggiani Caseifici',
        ContactName: 'Maurizio Moroni',
        Employee: 'Andrew Fuller',
        InvoicedCost: 680.751,
        ItemCount: 6,
        ChangeLastOrder: -9,
        ItemCost: 119.43,
        OrderCost: 716.58,
        PackageCost: 6.8999999999999995,
        OrderDate: 1509663600000,
        RequiredDate: 1512082800000,
        ShippedDate: 1512428400000,
        ShipVia: 'Speedy Express',
        Freight: 89.9,
        ShipName: 'Reggiani Caseifici',
        ShipAddress: 'Strada Provinciale 124',
        ShipCity: 'Reggio Emilia',
        ShipRegion: null,
        ShipPostalCode: 42100,
        ShipCountry: 'Italy',
        ArriveOnTime: 0
    },
    {
        OrderId: 10726,
        CustomerReference: 'EASTC',
        CompanyName: 'Eastern Connection',
        ContactName: 'Ann Devon',
        Employee: 'Margaret Peacock',
        InvoicedCost: 653.1840000000001,
        ItemCount: 7,
        ChangeLastOrder: 2,
        ItemCost: 86.4,
        OrderCost: 604.8000000000001,
        PackageCost: 8.89,
        OrderDate: 1509663600000,
        RequiredDate: 1510873200000,
        ShippedDate: 1512428400000,
        ShipVia: 'Speedy Express',
        Freight: 16.56,
        ShipName: 'Eastern Connection',
        ShipAddress: '35 King George',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'WX3 6FW',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10725,
        CustomerReference: 'FAMIA',
        CompanyName: 'Familia Arquibaldo',
        ContactName: 'Aria Cruz',
        Employee: 'Margaret Peacock',
        InvoicedCost: 118.473,
        ItemCount: 6,
        ChangeLastOrder: -36,
        ItemCost: 23.23,
        OrderCost: 139.38,
        PackageCost: 6.8999999999999995,
        OrderDate: 1509404400000,
        RequiredDate: 1511823600000,
        ShippedDate: 1509836400000,
        ShipVia: 'Federal Shipping',
        Freight: 10.83,
        ShipName: 'Familia Arquibaldo',
        ShipAddress: "Rua Or\xf3s, 92",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05442-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10724,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Laura Callahan',
        InvoicedCost: 2525.1264,
        ItemCount: 12,
        ChangeLastOrder: 2,
        ItemCost: 194.84,
        OrderCost: 2338.08,
        PackageCost: 15.24,
        OrderDate: 1509318000000,
        RequiredDate: 1512946800000,
        ShippedDate: 1509836400000,
        ShipVia: 'United Package',
        Freight: 57.75,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10723,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Janet Leverling',
        InvoicedCost: 880.0704000000001,
        ItemCount: 11,
        ChangeLastOrder: 6,
        ItemCost: 74.08,
        OrderCost: 814.88,
        PackageCost: 15.191,
        OrderDate: 1509318000000,
        RequiredDate: 1511737200000,
        ShippedDate: 1511564400000,
        ShipVia: 'Speedy Express',
        Freight: 21.72,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10722,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Laura Callahan',
        InvoicedCost: 665.7840000000001,
        ItemCount: 8,
        ChangeLastOrder: 5,
        ItemCost: 79.26,
        OrderCost: 634.08,
        PackageCost: 4.32,
        OrderDate: 1509231600000,
        RequiredDate: 1512860400000,
        ShippedDate: 1509750000000,
        ShipVia: 'Speedy Express',
        Freight: 74.58,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10721,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Steven Buchanan',
        InvoicedCost: 121.05000000000001,
        ItemCount: 12,
        ChangeLastOrder: -18,
        ItemCost: 8.07,
        OrderCost: 96.84,
        PackageCost: 13.799999999999999,
        OrderDate: 1509231600000,
        RequiredDate: 1511650800000,
        ShippedDate: 1509404400000,
        ShipVia: 'Federal Shipping',
        Freight: 48.92,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10720,
        CustomerReference: 'QUEDE',
        CompanyName: "Que Del\xedcia",
        ContactName: 'Bernardo Batista',
        Employee: 'Laura Callahan',
        InvoicedCost: 1064.992,
        ItemCount: 8,
        ChangeLastOrder: -6,
        ItemCost: 115.76,
        OrderCost: 926.08,
        PackageCost: 9.2,
        OrderDate: 1509145200000,
        RequiredDate: 1510354800000,
        ShippedDate: 1509836400000,
        ShipVia: 'United Package',
        Freight: 9.53,
        ShipName: "Que Del\xedcia",
        ShipAddress: 'Rua da Panificadora, 12',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-673',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10719,
        CustomerReference: 'LETSS',
        CompanyName: "Let's Stop N Shop",
        ContactName: 'Jaime Yorres',
        Employee: 'Laura Callahan',
        InvoicedCost: 718.2840000000001,
        ItemCount: 8,
        ChangeLastOrder: 1,
        ItemCost: 85.51,
        OrderCost: 684.08,
        PackageCost: 10.16,
        OrderDate: 1509058800000,
        RequiredDate: 1511478000000,
        ShippedDate: 1509836400000,
        ShipVia: 'United Package',
        Freight: 51.44,
        ShipName: "Let's Stop N Shop",
        ShipAddress: '88 Polk St. Suite 5',
        ShipCity: 'San Francisco',
        ShipRegion: 'CA',
        ShipPostalCode: 94117,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10718,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Nancy Davolio',
        InvoicedCost: 461.125,
        ItemCount: 7,
        ChangeLastOrder: 35,
        ItemCost: 77.5,
        OrderCost: 542.5,
        PackageCost: 10.003,
        OrderDate: 1509058800000,
        RequiredDate: 1511478000000,
        ShippedDate: 1509231600000,
        ShipVia: 'Federal Shipping',
        Freight: 170.88,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10717,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Nancy Davolio',
        InvoicedCost: 398.307,
        ItemCount: 13,
        ChangeLastOrder: -3,
        ItemCost: 29.18,
        OrderCost: 379.34,
        PackageCost: 16.51,
        OrderDate: 1508799600000,
        RequiredDate: 1511218800000,
        ShippedDate: 1509231600000,
        ShipVia: 'United Package',
        Freight: 59.25,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10716,
        CustomerReference: 'RANCH',
        CompanyName: 'Rancho grande',
        ContactName: "Sergio Guti\xe9rrez",
        Employee: 'Margaret Peacock',
        InvoicedCost: 219.232,
        ItemCount: 8,
        ChangeLastOrder: -2,
        ItemCost: 32.24,
        OrderCost: 257.92,
        PackageCost: 10.16,
        OrderDate: 1508799600000,
        RequiredDate: 1511218800000,
        ShippedDate: 1509058800000,
        ShipVia: 'United Package',
        Freight: 22.57,
        ShipName: 'Rancho grande',
        ShipAddress: 'Av. del Libertador 900',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 1
    },
    {
        OrderId: 10715,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Janet Leverling',
        InvoicedCost: 329.392,
        ItemCount: 7,
        ChangeLastOrder: 5,
        ItemCost: 55.36,
        OrderCost: 387.52,
        PackageCost: 3.7800000000000002,
        OrderDate: 1508713200000,
        RequiredDate: 1509922800000,
        ShippedDate: 1509231600000,
        ShipVia: 'Speedy Express',
        Freight: 63.2,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10714,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Steven Buchanan',
        InvoicedCost: 288.372,
        ItemCount: 8,
        ChangeLastOrder: 5,
        ItemCost: 34.33,
        OrderCost: 274.64,
        PackageCost: 4.32,
        OrderDate: 1508626800000,
        RequiredDate: 1511046000000,
        ShippedDate: 1509058800000,
        ShipVia: 'Federal Shipping',
        Freight: 24.49,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10713,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Nancy Davolio',
        InvoicedCost: 997.0799999999999,
        ItemCount: 10,
        ChangeLastOrder: 5,
        ItemCost: 94.96,
        OrderCost: 949.5999999999999,
        PackageCost: 5.4,
        OrderDate: 1508626800000,
        RequiredDate: 1511046000000,
        ShippedDate: 1508799600000,
        ShipVia: 'Speedy Express',
        Freight: 167.05,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10712,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Janet Leverling',
        InvoicedCost: 680.4000000000001,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 63,
        OrderCost: 630,
        PackageCost: 12.7,
        OrderDate: 1508540400000,
        RequiredDate: 1510959600000,
        ShippedDate: 1509404400000,
        ShipVia: 'Speedy Express',
        Freight: 89.93,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10711,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Steven Buchanan',
        InvoicedCost: 708.96,
        ItemCount: 8,
        ChangeLastOrder: 5,
        ItemCost: 84.4,
        OrderCost: 675.2,
        PackageCost: 4.32,
        OrderDate: 1508540400000,
        RequiredDate: 1512169200000,
        ShippedDate: 1509231600000,
        ShipVia: 'United Package',
        Freight: 52.41,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10710,
        CustomerReference: 'FRANS',
        CompanyName: 'Franchi S.p.A.',
        ContactName: 'Paolo Accorti',
        Employee: 'Nancy Davolio',
        InvoicedCost: 534.2760000000001,
        ItemCount: 12,
        ChangeLastOrder: -25,
        ItemCost: 52.38,
        OrderCost: 628.5600000000001,
        PackageCost: 13.799999999999999,
        OrderDate: 1508454000000,
        RequiredDate: 1510873200000,
        ShippedDate: 1508713200000,
        ShipVia: 'Speedy Express',
        Freight: 4.98,
        ShipName: 'Franchi S.p.A.',
        ShipAddress: 'Via Monte Bianco 34',
        ShipCity: 'Torino',
        ShipRegion: null,
        ShipPostalCode: 10100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10709,
        CustomerReference: 'GOURL',
        CompanyName: 'Gourmet Lanchonetes',
        ContactName: "Andr\xe9 Fonseca",
        Employee: 'Nancy Davolio',
        InvoicedCost: 1643.5504,
        ItemCount: 8,
        ChangeLastOrder: -2,
        ItemCost: 199.46,
        OrderCost: 1595.68,
        PackageCost: 10.16,
        OrderDate: 1508194800000,
        RequiredDate: 1510614000000,
        ShippedDate: 1511132400000,
        ShipVia: 'Federal Shipping',
        Freight: 210.8,
        ShipName: 'Gourmet Lanchonetes',
        ShipAddress: 'Av. Brasil, 442',
        ShipCity: 'Campinas',
        ShipRegion: 'SP',
        ShipPostalCode: '04876-786',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10708,
        CustomerReference: 'THEBI',
        CompanyName: 'The Big Cheese',
        ContactName: 'Liz Nixon',
        Employee: 'Michael Suyama',
        InvoicedCost: 1212.939,
        ItemCount: 13,
        ChangeLastOrder: 0,
        ItemCost: 88.86,
        OrderCost: 1155.18,
        PackageCost: 16.51,
        OrderDate: 1508194800000,
        RequiredDate: 1511823600000,
        ShippedDate: 1509836400000,
        ShipVia: 'United Package',
        Freight: 2.96,
        ShipName: 'The Big Cheese',
        ShipAddress: '90 Jefferson Way Suite 2',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97201,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10707,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Margaret Peacock',
        InvoicedCost: 160.27200000000002,
        ItemCount: 8,
        ChangeLastOrder: -4,
        ItemCost: 18.55,
        OrderCost: 148.4,
        PackageCost: 9.2,
        OrderDate: 1508108400000,
        RequiredDate: 1509318000000,
        ShippedDate: 1508713200000,
        ShipVia: 'Federal Shipping',
        Freight: 21.74,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10706,
        CustomerReference: 'OLDWO',
        CompanyName: 'Old World Delicatessen',
        ContactName: 'Rene Phillips',
        Employee: 'Laura Callahan',
        InvoicedCost: 118.80000000000001,
        ItemCount: 11,
        ChangeLastOrder: 3,
        ItemCost: 10,
        OrderCost: 110,
        PackageCost: 5.94,
        OrderDate: 1508108400000,
        RequiredDate: 1510527600000,
        ShippedDate: 1508540400000,
        ShipVia: 'Federal Shipping',
        Freight: 135.63,
        ShipName: 'Old World Delicatessen',
        ShipAddress: '2743 Bering St.',
        ShipCity: 'Anchorage',
        ShipRegion: 'AK',
        ShipPostalCode: 99508,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10705,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Anne Dodsworth',
        InvoicedCost: 1031.6995,
        ItemCount: 13,
        ChangeLastOrder: -5,
        ItemCost: 77.05,
        OrderCost: 1001.65,
        PackageCost: 14.95,
        OrderDate: 1508022000000,
        RequiredDate: 1510441200000,
        ShippedDate: 1510959600000,
        ShipVia: 'United Package',
        Freight: 3.52,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10704,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Michael Suyama',
        InvoicedCost: 896.155,
        ItemCount: 13,
        ChangeLastOrder: -2,
        ItemCost: 81.1,
        OrderCost: 1054.3,
        PackageCost: 16.51,
        OrderDate: 1507935600000,
        RequiredDate: 1510354800000,
        ShippedDate: 1510009200000,
        ShipVia: 'Speedy Express',
        Freight: 4.78,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10703,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Michael Suyama',
        InvoicedCost: 1110.564,
        ItemCount: 14,
        ChangeLastOrder: -1,
        ItemCost: 73.45,
        OrderCost: 1028.3,
        PackageCost: 17.78,
        OrderDate: 1507935600000,
        RequiredDate: 1510354800000,
        ShippedDate: 1508454000000,
        ShipVia: 'United Package',
        Freight: 152.3,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10702,
        CustomerReference: 'ALFKI',
        CompanyName: 'Alfreds Futterkiste',
        ContactName: 'Maria Anders',
        Employee: 'Margaret Peacock',
        InvoicedCost: 233.41000000000003,
        ItemCount: 5,
        ChangeLastOrder: 17,
        ItemCost: 54.92,
        OrderCost: 274.6,
        PackageCost: 7.1450000000000005,
        OrderDate: 1507849200000,
        RequiredDate: 1511478000000,
        ShippedDate: 1508540400000,
        ShipVia: 'Speedy Express',
        Freight: 23.94,
        ShipName: 'Alfreds Futterkiste',
        ShipAddress: 'Obere Str. 57',
        ShipCity: 'Berlin',
        ShipRegion: null,
        ShipPostalCode: 12209,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10701,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Michael Suyama',
        InvoicedCost: 1436.2488,
        ItemCount: 14,
        ChangeLastOrder: 2,
        ItemCost: 94.99,
        OrderCost: 1329.86,
        PackageCost: 17.78,
        OrderDate: 1507849200000,
        RequiredDate: 1509058800000,
        ShippedDate: 1508022000000,
        ShipVia: 'Federal Shipping',
        Freight: 220.31,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10700,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Janet Leverling',
        InvoicedCost: 11.088000000000001,
        ItemCount: 6,
        ChangeLastOrder: 5,
        ItemCost: 1.76,
        OrderCost: 10.56,
        PackageCost: 3.24,
        OrderDate: 1507590000000,
        RequiredDate: 1510009200000,
        ShippedDate: 1508108400000,
        ShipVia: 'Speedy Express',
        Freight: 65.1,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10699,
        CustomerReference: 'MORGK',
        CompanyName: 'Morgenstern Gesundkost',
        ContactName: 'Alexander Feuer',
        Employee: 'Janet Leverling',
        InvoicedCost: 14.765999999999998,
        ItemCount: 12,
        ChangeLastOrder: -20,
        ItemCost: 1.07,
        OrderCost: 12.84,
        PackageCost: 13.799999999999999,
        OrderDate: 1507503600000,
        RequiredDate: 1509922800000,
        ShippedDate: 1507849200000,
        ShipVia: 'Federal Shipping',
        Freight: 0.58,
        ShipName: 'Morgenstern Gesundkost',
        ShipAddress: 'Heerstr. 22',
        ShipCity: 'Leipzig',
        ShipRegion: null,
        ShipPostalCode: 4179,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10698,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Margaret Peacock',
        InvoicedCost: 67.32600000000001,
        ItemCount: 7,
        ChangeLastOrder: 16,
        ItemCost: 9.16,
        OrderCost: 64.12,
        PackageCost: 10.003,
        OrderDate: 1507503600000,
        RequiredDate: 1509922800000,
        ShippedDate: 1508194800000,
        ShipVia: 'Speedy Express',
        Freight: 272.47,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10697,
        CustomerReference: 'LINOD',
        CompanyName: 'LINO-Delicateses',
        ContactName: 'Felipe Izquierdo',
        Employee: 'Janet Leverling',
        InvoicedCost: 1117.9620000000002,
        ItemCount: 12,
        ChangeLastOrder: -3,
        ItemCost: 90.45,
        OrderCost: 1085.4,
        PackageCost: 15.24,
        OrderDate: 1507417200000,
        RequiredDate: 1509836400000,
        ShippedDate: 1507935600000,
        ShipVia: 'Speedy Express',
        Freight: 45.52,
        ShipName: 'LINO-Delicateses',
        ShipAddress: 'Ave. 5 de Mayo Porlamar',
        ShipCity: 'I. de Margarita',
        ShipRegion: 'Nueva Esparta',
        ShipPostalCode: 4980,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10696,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Laura Callahan',
        InvoicedCost: 1010.34,
        ItemCount: 10,
        ChangeLastOrder: 6,
        ItemCost: 93.55,
        OrderCost: 935.5,
        PackageCost: 13.81,
        OrderDate: 1507417200000,
        RequiredDate: 1511046000000,
        ShippedDate: 1507935600000,
        ShipVia: 'Federal Shipping',
        Freight: 102.55,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10695,
        CustomerReference: 'WILMK',
        CompanyName: 'Wilman Kala',
        ContactName: 'Matti Karttunen',
        Employee: 'Robert King',
        InvoicedCost: 244.71499999999997,
        ItemCount: 10,
        ChangeLastOrder: 19,
        ItemCost: 28.79,
        OrderCost: 287.9,
        PackageCost: 14.290000000000001,
        OrderDate: 1507330800000,
        RequiredDate: 1510959600000,
        ShippedDate: 1507935600000,
        ShipVia: 'Speedy Express',
        Freight: 16.72,
        ShipName: 'Wilman Kala',
        ShipAddress: 'Keskuskatu 45',
        ShipCity: 'Helsinki',
        ShipRegion: null,
        ShipPostalCode: 21240,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10694,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Laura Callahan',
        InvoicedCost: 839.4749999999999,
        ItemCount: 7,
        ChangeLastOrder: -17,
        ItemCost: 95.94,
        OrderCost: 671.5799999999999,
        PackageCost: 8.049999999999999,
        OrderDate: 1507244400000,
        RequiredDate: 1509663600000,
        ShippedDate: 1507503600000,
        ShipVia: 'Federal Shipping',
        Freight: 398.36,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10693,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Janet Leverling',
        InvoicedCost: 552.7872000000001,
        ItemCount: 7,
        ChangeLastOrder: 6,
        ItemCost: 73.12,
        OrderCost: 511.84000000000003,
        PackageCost: 9.667,
        OrderDate: 1507244400000,
        RequiredDate: 1508454000000,
        ShippedDate: 1507590000000,
        ShipVia: 'Federal Shipping',
        Freight: 139.34,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10692,
        CustomerReference: 'ALFKI',
        CompanyName: 'Alfreds Futterkiste',
        ContactName: 'Maria Anders',
        Employee: 'Margaret Peacock',
        InvoicedCost: 258.26399999999995,
        ItemCount: 9,
        ChangeLastOrder: 18,
        ItemCost: 33.76,
        OrderCost: 303.84,
        PackageCost: 12.861,
        OrderDate: 1506985200000,
        RequiredDate: 1509404400000,
        ShippedDate: 1507849200000,
        ShipVia: 'United Package',
        Freight: 61.02,
        ShipName: 'Alfreds Futterkiste',
        ShipAddress: 'Obere Str. 57',
        ShipCity: 'Berlin',
        ShipRegion: null,
        ShipPostalCode: 12209,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10691,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Andrew Fuller',
        InvoicedCost: 409.49999999999994,
        ItemCount: 10,
        ChangeLastOrder: -3,
        ItemCost: 32.76,
        OrderCost: 327.59999999999997,
        PackageCost: 12.7,
        OrderDate: 1506985200000,
        RequiredDate: 1510614000000,
        ShippedDate: 1508626800000,
        ShipVia: 'United Package',
        Freight: 810.05,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10690,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Nancy Davolio',
        InvoicedCost: 288.558,
        ItemCount: 12,
        ChangeLastOrder: -24,
        ItemCost: 28.29,
        OrderCost: 339.48,
        PackageCost: 13.799999999999999,
        OrderDate: 1506898800000,
        RequiredDate: 1509318000000,
        ShippedDate: 1506985200000,
        ShipVia: 'Speedy Express',
        Freight: 15.8,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10689,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Nancy Davolio',
        InvoicedCost: 923.2703999999999,
        ItemCount: 12,
        ChangeLastOrder: -3,
        ItemCost: 71.24,
        OrderCost: 854.8799999999999,
        PackageCost: 15.24,
        OrderDate: 1506812400000,
        RequiredDate: 1509231600000,
        ShippedDate: 1507330800000,
        ShipVia: 'United Package',
        Freight: 13.42,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10688,
        CustomerReference: 'VAFFE',
        CompanyName: 'Vaffeljernet',
        ContactName: 'Palle Ibsen',
        Employee: 'Margaret Peacock',
        InvoicedCost: 88.30499999999999,
        ItemCount: 10,
        ChangeLastOrder: 17,
        ItemCost: 8.41,
        OrderCost: 84.1,
        PackageCost: 14.290000000000001,
        OrderDate: 1506812400000,
        RequiredDate: 1508022000000,
        ShippedDate: 1507330800000,
        ShipVia: 'United Package',
        Freight: 299.09,
        ShipName: 'Vaffeljernet',
        ShipAddress: "Smagsl\xf8get 45",
        ShipCity: "\xc5rhus",
        ShipRegion: null,
        ShipPostalCode: 8200,
        ShipCountry: 'Denmark',
        ArriveOnTime: 0
    },
    {
        OrderId: 10687,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 76.65840000000001,
        ItemCount: 6,
        ChangeLastOrder: 2,
        ItemCost: 11.83,
        OrderCost: 70.98,
        PackageCost: 7.62,
        OrderDate: 1506726000000,
        RequiredDate: 1509145200000,
        ShippedDate: 1509318000000,
        ShipVia: 'United Package',
        Freight: 296.43,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10686,
        CustomerReference: 'PICCO',
        CompanyName: 'Piccolo und mehr',
        ContactName: 'Georg Pipps',
        Employee: 'Andrew Fuller',
        InvoicedCost: 753.033,
        ItemCount: 10,
        ChangeLastOrder: 3,
        ItemCost: 73.11,
        OrderCost: 731.1,
        PackageCost: 5.4,
        OrderDate: 1506726000000,
        RequiredDate: 1509145200000,
        ShippedDate: 1507417200000,
        ShipVia: 'Speedy Express',
        Freight: 96.5,
        ShipName: 'Piccolo und mehr',
        ShipAddress: 'Geislweg 14',
        ShipCity: 'Salzburg',
        ShipRegion: null,
        ShipPostalCode: 5020,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10685,
        CustomerReference: 'GOURL',
        CompanyName: 'Gourmet Lanchonetes',
        ContactName: "Andr\xe9 Fonseca",
        Employee: 'Margaret Peacock',
        InvoicedCost: 408.825,
        ItemCount: 9,
        ChangeLastOrder: -2,
        ItemCost: 39.5,
        OrderCost: 355.5,
        PackageCost: 11.43,
        OrderDate: 1506639600000,
        RequiredDate: 1507849200000,
        ShippedDate: 1506985200000,
        ShipVia: 'United Package',
        Freight: 33.75,
        ShipName: 'Gourmet Lanchonetes',
        ShipAddress: 'Av. Brasil, 442',
        ShipCity: 'Campinas',
        ShipRegion: 'SP',
        ShipPostalCode: '04876-786',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10684,
        CustomerReference: 'OTTIK',
        CompanyName: "Ottilies K\xe4seladen",
        ContactName: 'Henriette Pfalzheim',
        Employee: 'Janet Leverling',
        InvoicedCost: 123.26849999999999,
        ItemCount: 9,
        ChangeLastOrder: 29,
        ItemCost: 11.91,
        OrderCost: 107.19,
        PackageCost: 12.861,
        OrderDate: 1506380400000,
        RequiredDate: 1508799600000,
        ShippedDate: 1506726000000,
        ShipVia: 'Speedy Express',
        Freight: 145.63,
        ShipName: "Ottilies K\xe4seladen",
        ShipAddress: 'Mehrheimerstr. 369',
        ShipCity: "K\xf6ln",
        ShipRegion: null,
        ShipPostalCode: 50739,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10683,
        CustomerReference: 'DUMON',
        CompanyName: 'Du monde entier',
        ContactName: 'Janine Labrune',
        Employee: 'Andrew Fuller',
        InvoicedCost: 644.0796,
        ItemCount: 9,
        ChangeLastOrder: 2,
        ItemCost: 69.48,
        OrderCost: 625.32,
        PackageCost: 11.43,
        OrderDate: 1506380400000,
        RequiredDate: 1508799600000,
        ShippedDate: 1506812400000,
        ShipVia: 'Speedy Express',
        Freight: 4.4,
        ShipName: 'Du monde entier',
        ShipAddress: '67, rue des Cinquante Otages',
        ShipCity: 'Nantes',
        ShipRegion: null,
        ShipPostalCode: 44000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10682,
        CustomerReference: 'ANTON',
        CompanyName: "Antonio Moreno Taquer\xeda",
        ContactName: 'Antonio Moreno',
        Employee: 'Janet Leverling',
        InvoicedCost: 290.76599999999996,
        ItemCount: 6,
        ChangeLastOrder: -31,
        ItemCost: 42.14,
        OrderCost: 252.84,
        PackageCost: 6.8999999999999995,
        OrderDate: 1506294000000,
        RequiredDate: 1508713200000,
        ShippedDate: 1506812400000,
        ShipVia: 'United Package',
        Freight: 36.13,
        ShipName: "Antonio Moreno Taquer\xeda",
        ShipAddress: 'Mataderos  2312',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5023,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10681,
        CustomerReference: 'GREAL',
        CompanyName: 'Great Lakes Food Market',
        ContactName: 'Howard Snyder',
        Employee: 'Janet Leverling',
        InvoicedCost: 1271.4624000000001,
        ItemCount: 13,
        ChangeLastOrder: 3,
        ItemCost: 90.56,
        OrderCost: 1177.28,
        PackageCost: 7.0200000000000005,
        OrderDate: 1506294000000,
        RequiredDate: 1508713200000,
        ShippedDate: 1506726000000,
        ShipVia: 'Federal Shipping',
        Freight: 76.13,
        ShipName: 'Great Lakes Food Market',
        ShipAddress: '2732 Baker Blvd.',
        ShipCity: 'Eugene',
        ShipRegion: 'OR',
        ShipPostalCode: 97403,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10680,
        CustomerReference: 'OLDWO',
        CompanyName: 'Old World Delicatessen',
        ContactName: 'Rene Phillips',
        Employee: 'Nancy Davolio',
        InvoicedCost: 469.47600000000006,
        ItemCount: 6,
        ChangeLastOrder: 3,
        ItemCost: 72.45,
        OrderCost: 434.70000000000005,
        PackageCost: 3.24,
        OrderDate: 1506207600000,
        RequiredDate: 1508626800000,
        ShippedDate: 1506380400000,
        ShipVia: 'Speedy Express',
        Freight: 26.61,
        ShipName: 'Old World Delicatessen',
        ShipAddress: '2743 Bering St.',
        ShipCity: 'Anchorage',
        ShipRegion: 'AK',
        ShipPostalCode: 99508,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10679,
        CustomerReference: 'BLONP',
        CompanyName: "Blondel p\xe8re et fils",
        ContactName: "Fr\xe9d\xe9rique Citeaux",
        Employee: 'Laura Callahan',
        InvoicedCost: 513.222,
        ItemCount: 6,
        ChangeLastOrder: 4,
        ItemCost: 74.38,
        OrderCost: 446.28,
        PackageCost: 3.24,
        OrderDate: 1506121200000,
        RequiredDate: 1508540400000,
        ShippedDate: 1506726000000,
        ShipVia: 'Federal Shipping',
        Freight: 27.94,
        ShipName: "Blondel p\xe8re et fils",
        ShipAddress: "24, place Kl\xe9ber",
        ShipCity: 'Strasbourg',
        ShipRegion: null,
        ShipPostalCode: 67000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10678,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Robert King',
        InvoicedCost: 809.8650000000001,
        ItemCount: 9,
        ChangeLastOrder: 5,
        ItemCost: 85.7,
        OrderCost: 771.3000000000001,
        PackageCost: 4.86,
        OrderDate: 1506121200000,
        RequiredDate: 1508540400000,
        ShippedDate: 1508108400000,
        ShipVia: 'Federal Shipping',
        Freight: 388.98,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10677,
        CustomerReference: 'ANTON',
        CompanyName: "Antonio Moreno Taquer\xeda",
        ContactName: 'Antonio Moreno',
        Employee: 'Nancy Davolio',
        InvoicedCost: 524.538,
        ItemCount: 7,
        ChangeLastOrder: -32,
        ItemCost: 65.16,
        OrderCost: 456.12,
        PackageCost: 8.049999999999999,
        OrderDate: 1506034800000,
        RequiredDate: 1508454000000,
        ShippedDate: 1506380400000,
        ShipVia: 'Federal Shipping',
        Freight: 4.03,
        ShipName: "Antonio Moreno Taquer\xeda",
        ShipAddress: 'Mataderos  2312',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5023,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10676,
        CustomerReference: 'TORTU',
        CompanyName: 'Tortuga Restaurante',
        ContactName: 'Miguel Angel Paolino',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1042.59,
        ItemCount: 12,
        ChangeLastOrder: -3,
        ItemCost: 75.55,
        OrderCost: 906.5999999999999,
        PackageCost: 15.24,
        OrderDate: 1506034800000,
        RequiredDate: 1508454000000,
        ShippedDate: 1506639600000,
        ShipVia: 'United Package',
        Freight: 2.01,
        ShipName: 'Tortuga Restaurante',
        ShipAddress: 'Avda. Azteca 123',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10675,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Steven Buchanan',
        InvoicedCost: 575.652,
        ItemCount: 7,
        ChangeLastOrder: -4,
        ItemCost: 78.32,
        OrderCost: 548.24,
        PackageCost: 8.049999999999999,
        OrderDate: 1505775600000,
        RequiredDate: 1508194800000,
        ShippedDate: 1506121200000,
        ShipVia: 'United Package',
        Freight: 31.85,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10674,
        CustomerReference: 'ISLAT',
        CompanyName: 'Island Trading',
        ContactName: 'Helen Bennett',
        Employee: 'Margaret Peacock',
        InvoicedCost: 718.5024,
        ItemCount: 12,
        ChangeLastOrder: 9,
        ItemCost: 55.44,
        OrderCost: 665.28,
        PackageCost: 17.148,
        OrderDate: 1505689200000,
        RequiredDate: 1508108400000,
        ShippedDate: 1506726000000,
        ShipVia: 'United Package',
        Freight: 0.9,
        ShipName: 'Island Trading',
        ShipAddress: 'Garden House, Crowther Way',
        ShipCity: 'Cowes',
        ShipRegion: 'Isle of Wight',
        ShipPostalCode: 'PO31 7PJ',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10673,
        CustomerReference: 'WILMK',
        CompanyName: 'Wilman Kala',
        ContactName: 'Matti Karttunen',
        Employee: 'Andrew Fuller',
        InvoicedCost: 282.74399999999997,
        ItemCount: 8,
        ChangeLastOrder: 20,
        ItemCost: 41.58,
        OrderCost: 332.64,
        PackageCost: 11.432,
        OrderDate: 1505689200000,
        RequiredDate: 1508108400000,
        ShippedDate: 1505775600000,
        ShipVia: 'Speedy Express',
        Freight: 22.76,
        ShipName: 'Wilman Kala',
        ShipAddress: 'Keskuskatu 45',
        ShipCity: 'Helsinki',
        ShipRegion: null,
        ShipPostalCode: 21240,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10672,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 40.39200000000001,
        ItemCount: 5,
        ChangeLastOrder: -3,
        ItemCost: 7.48,
        OrderCost: 37.400000000000006,
        PackageCost: 6.35,
        OrderDate: 1505602800000,
        RequiredDate: 1506812400000,
        ShippedDate: 1506380400000,
        ShipVia: 'United Package',
        Freight: 95.75,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10671,
        CustomerReference: 'FRANR',
        CompanyName: 'France restauration',
        ContactName: 'Carine Schmitt',
        Employee: 'Nancy Davolio',
        InvoicedCost: 459.534,
        ItemCount: 6,
        ChangeLastOrder: 2,
        ItemCost: 52.82,
        OrderCost: 316.92,
        PackageCost: 7.62,
        OrderDate: 1505602800000,
        RequiredDate: 1508022000000,
        ShippedDate: 1506207600000,
        ShipVia: 'Speedy Express',
        Freight: 30.34,
        ShipName: 'France restauration',
        ShipAddress: '54, rue Royale',
        ShipCity: 'Nantes',
        ShipRegion: null,
        ShipPostalCode: 44000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10670,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Margaret Peacock',
        InvoicedCost: 33.7365,
        ItemCount: 7,
        ChangeLastOrder: -3,
        ItemCost: 4.59,
        OrderCost: 32.129999999999995,
        PackageCost: 8.89,
        OrderDate: 1505516400000,
        RequiredDate: 1507935600000,
        ShippedDate: 1505689200000,
        ShipVia: 'Speedy Express',
        Freight: 203.48,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10669,
        CustomerReference: 'SIMOB',
        CompanyName: 'Simons bistro',
        ContactName: 'Jytte Petersen',
        Employee: 'Andrew Fuller',
        InvoicedCost: 16.915,
        ItemCount: 10,
        ChangeLastOrder: 3,
        ItemCost: 1.99,
        OrderCost: 19.9,
        PackageCost: 5.4,
        OrderDate: 1505430000000,
        RequiredDate: 1507849200000,
        ShippedDate: 1506034800000,
        ShipVia: 'Speedy Express',
        Freight: 24.39,
        ShipName: 'Simons bistro',
        ShipAddress: "Vinb\xe6ltet 34",
        ShipCity: "K\xf8benhavn",
        ShipRegion: null,
        ShipPostalCode: 1734,
        ShipCountry: 'Denmark',
        ArriveOnTime: 1
    },
    {
        OrderId: 10668,
        CustomerReference: 'WANDK',
        CompanyName: 'Die Wandernde Kuh',
        ContactName: "Rita M\xfcller",
        Employee: 'Nancy Davolio',
        InvoicedCost: 633.045,
        ItemCount: 10,
        ChangeLastOrder: 0,
        ItemCost: 60.29,
        OrderCost: 602.9,
        PackageCost: 12.7,
        OrderDate: 1505430000000,
        RequiredDate: 1507849200000,
        ShippedDate: 1506121200000,
        ShipVia: 'United Package',
        Freight: 47.22,
        ShipName: 'Die Wandernde Kuh',
        ShipAddress: 'Adenauerallee 900',
        ShipCity: 'Stuttgart',
        ShipRegion: null,
        ShipPostalCode: 70563,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10667,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Robert King',
        InvoicedCost: 576.576,
        ItemCount: 6,
        ChangeLastOrder: 2,
        ItemCost: 91.52,
        OrderCost: 549.12,
        PackageCost: 7.62,
        OrderDate: 1505170800000,
        RequiredDate: 1507590000000,
        ShippedDate: 1505775600000,
        ShipVia: 'Speedy Express',
        Freight: 78.09,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10666,
        CustomerReference: 'RICSU',
        CompanyName: 'Richter Supermarkt',
        ContactName: 'Michael Holz',
        Employee: 'Robert King',
        InvoicedCost: 612.68,
        ItemCount: 10,
        ChangeLastOrder: 1,
        ItemCost: 72.08,
        OrderCost: 720.8,
        PackageCost: 12.7,
        OrderDate: 1505170800000,
        RequiredDate: 1507590000000,
        ShippedDate: 1506034800000,
        ShipVia: 'United Package',
        Freight: 232.42,
        ShipName: 'Richter Supermarkt',
        ShipAddress: 'Starenweg 5',
        ShipCity: "Gen\xe8ve",
        ShipRegion: null,
        ShipPostalCode: 1204,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10665,
        CustomerReference: 'LONEP',
        CompanyName: 'Lonesome Pine Restaurant',
        ContactName: 'Fran Wilson',
        Employee: 'Nancy Davolio',
        InvoicedCost: 185.493,
        ItemCount: 11,
        ChangeLastOrder: 1,
        ItemCost: 16.06,
        OrderCost: 176.66,
        PackageCost: 13.97,
        OrderDate: 1505084400000,
        RequiredDate: 1507503600000,
        ShippedDate: 1505602800000,
        ShipVia: 'United Package',
        Freight: 26.31,
        ShipName: 'Lonesome Pine Restaurant',
        ShipAddress: '89 Chiaroscuro Rd.',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97219,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10664,
        CustomerReference: 'FURIB',
        CompanyName: 'Furia Bacalhau e Frutos do Mar',
        ContactName: 'Lino Rodriguez',
        Employee: 'Nancy Davolio',
        InvoicedCost: 640.764,
        ItemCount: 12,
        ChangeLastOrder: 32,
        ItemCost: 62.82,
        OrderCost: 753.84,
        PackageCost: 17.148,
        OrderDate: 1504998000000,
        RequiredDate: 1507417200000,
        ShippedDate: 1505775600000,
        ShipVia: 'Federal Shipping',
        Freight: 1.27,
        ShipName: 'Furia Bacalhau e Frutos do Mar',
        ShipAddress: 'Jardim das rosas n. 32',
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1675,
        ShipCountry: 'Portugal',
        ArriveOnTime: 1
    },
    {
        OrderId: 10663,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Andrew Fuller',
        InvoicedCost: 80.784,
        ItemCount: 9,
        ChangeLastOrder: 5,
        ItemCost: 10.56,
        OrderCost: 95.04,
        PackageCost: 4.86,
        OrderDate: 1504998000000,
        RequiredDate: 1506207600000,
        ShippedDate: 1506985200000,
        ShipVia: 'United Package',
        Freight: 113.15,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10662,
        CustomerReference: 'LONEP',
        CompanyName: 'Lonesome Pine Restaurant',
        ContactName: 'Fran Wilson',
        Employee: 'Janet Leverling',
        InvoicedCost: 470.24250000000006,
        ItemCount: 13,
        ChangeLastOrder: 1,
        ItemCost: 34.45,
        OrderCost: 447.85,
        PackageCost: 16.51,
        OrderDate: 1504911600000,
        RequiredDate: 1507330800000,
        ShippedDate: 1505689200000,
        ShipVia: 'United Package',
        Freight: 1.28,
        ShipName: 'Lonesome Pine Restaurant',
        ShipAddress: '89 Chiaroscuro Rd.',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97219,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10661,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Robert King',
        InvoicedCost: 401.6304,
        ItemCount: 9,
        ChangeLastOrder: 1,
        ItemCost: 41.32,
        OrderCost: 371.88,
        PackageCost: 11.43,
        OrderDate: 1504911600000,
        RequiredDate: 1507330800000,
        ShippedDate: 1505430000000,
        ShipVia: 'Federal Shipping',
        Freight: 17.55,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10660,
        CustomerReference: 'HUNGC',
        CompanyName: 'Hungry Coyote Import Store',
        ContactName: 'Yoshi Latimer',
        Employee: 'Laura Callahan',
        InvoicedCost: 265.14000000000004,
        ItemCount: 10,
        ChangeLastOrder: -1,
        ItemCost: 24.55,
        OrderCost: 245.5,
        PackageCost: 12.7,
        OrderDate: 1504825200000,
        RequiredDate: 1507244400000,
        ShippedDate: 1508022000000,
        ShipVia: 'Speedy Express',
        Freight: 111.29,
        ShipName: 'Hungry Coyote Import Store',
        ShipAddress: 'City Center Plaza, 516 Main St.',
        ShipCity: 'Elgin',
        ShipRegion: 'OR',
        ShipPostalCode: 97827,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10659,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Robert King',
        InvoicedCost: 55.54749999999999,
        ItemCount: 5,
        ChangeLastOrder: -2,
        ItemCost: 13.07,
        OrderCost: 65.35,
        PackageCost: 6.35,
        OrderDate: 1504566000000,
        RequiredDate: 1506985200000,
        ShippedDate: 1504998000000,
        ShipVia: 'United Package',
        Freight: 105.81,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10658,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Margaret Peacock',
        InvoicedCost: 165.375,
        ItemCount: 10,
        ChangeLastOrder: 11,
        ItemCost: 13.23,
        OrderCost: 132.3,
        PackageCost: 14.290000000000001,
        OrderDate: 1504566000000,
        RequiredDate: 1506985200000,
        ShippedDate: 1504825200000,
        ShipVia: 'Speedy Express',
        Freight: 364.15,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10657,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Andrew Fuller',
        InvoicedCost: 830.7600000000001,
        ItemCount: 10,
        ChangeLastOrder: 5,
        ItemCost: 79.12,
        OrderCost: 791.2,
        PackageCost: 5.4,
        OrderDate: 1504479600000,
        RequiredDate: 1506898800000,
        ShippedDate: 1505430000000,
        ShipVia: 'United Package',
        Freight: 352.69,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10656,
        CustomerReference: 'GREAL',
        CompanyName: 'Great Lakes Food Market',
        ContactName: 'Howard Snyder',
        Employee: 'Michael Suyama',
        InvoicedCost: 1162.9332,
        ItemCount: 13,
        ChangeLastOrder: 3,
        ItemCost: 82.83,
        OrderCost: 1076.79,
        PackageCost: 7.0200000000000005,
        OrderDate: 1504479600000,
        RequiredDate: 1506898800000,
        ShippedDate: 1504998000000,
        ShipVia: 'Speedy Express',
        Freight: 57.15,
        ShipName: 'Great Lakes Food Market',
        ShipAddress: '2732 Baker Blvd.',
        ShipCity: 'Eugene',
        ShipRegion: 'OR',
        ShipPostalCode: 97403,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10655,
        CustomerReference: 'REGGC',
        CompanyName: 'Reggiani Caseifici',
        ContactName: 'Maurizio Moroni',
        Employee: 'Nancy Davolio',
        InvoicedCost: 503.272,
        ItemCount: 11,
        ChangeLastOrder: -13,
        ItemCost: 48.16,
        OrderCost: 529.76,
        PackageCost: 12.649999999999999,
        OrderDate: 1504393200000,
        RequiredDate: 1506812400000,
        ShippedDate: 1505084400000,
        ShipVia: 'United Package',
        Freight: 4.41,
        ShipName: 'Reggiani Caseifici',
        ShipAddress: 'Strada Provinciale 124',
        ShipCity: 'Reggio Emilia',
        ShipRegion: null,
        ShipPostalCode: 42100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10654,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Steven Buchanan',
        InvoicedCost: 882.09,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 74.25,
        OrderCost: 816.75,
        PackageCost: 13.97,
        OrderDate: 1504306800000,
        RequiredDate: 1506726000000,
        ShippedDate: 1505084400000,
        ShipVia: 'Speedy Express',
        Freight: 55.26,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10653,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Nancy Davolio',
        InvoicedCost: 844.1895000000001,
        ItemCount: 11,
        ChangeLastOrder: -4,
        ItemCost: 73.09,
        OrderCost: 803.99,
        PackageCost: 12.649999999999999,
        OrderDate: 1504306800000,
        RequiredDate: 1506726000000,
        ShippedDate: 1505775600000,
        ShipVia: 'Speedy Express',
        Freight: 93.25,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10652,
        CustomerReference: 'GOURL',
        CompanyName: 'Gourmet Lanchonetes',
        ContactName: "Andr\xe9 Fonseca",
        Employee: 'Margaret Peacock',
        InvoicedCost: 449.67299999999994,
        ItemCount: 6,
        ChangeLastOrder: -2,
        ItemCost: 65.17,
        OrderCost: 391.02,
        PackageCost: 7.62,
        OrderDate: 1504220400000,
        RequiredDate: 1506639600000,
        ShippedDate: 1504825200000,
        ShipVia: 'United Package',
        Freight: 7.14,
        ShipName: 'Gourmet Lanchonetes',
        ShipAddress: 'Av. Brasil, 442',
        ShipCity: 'Campinas',
        ShipRegion: 'SP',
        ShipPostalCode: '04876-786',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10651,
        CustomerReference: 'WANDK',
        CompanyName: 'Die Wandernde Kuh',
        ContactName: "Rita M\xfcller",
        Employee: 'Laura Callahan',
        InvoicedCost: 883.2914999999999,
        ItemCount: 13,
        ChangeLastOrder: 0,
        ItemCost: 64.71,
        OrderCost: 841.2299999999999,
        PackageCost: 16.51,
        OrderDate: 1504220400000,
        RequiredDate: 1506639600000,
        ShippedDate: 1505084400000,
        ShipVia: 'United Package',
        Freight: 20.6,
        ShipName: 'Die Wandernde Kuh',
        ShipAddress: 'Adenauerallee 900',
        ShipCity: 'Stuttgart',
        ShipRegion: null,
        ShipPostalCode: 70563,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10650,
        CustomerReference: 'FAMIA',
        CompanyName: 'Familia Arquibaldo',
        ContactName: 'Aria Cruz',
        Employee: 'Steven Buchanan',
        InvoicedCost: 77.17150000000001,
        ItemCount: 7,
        ChangeLastOrder: -37,
        ItemCost: 12.97,
        OrderCost: 90.79,
        PackageCost: 8.049999999999999,
        OrderDate: 1503961200000,
        RequiredDate: 1506380400000,
        ShippedDate: 1504393200000,
        ShipVia: 'Federal Shipping',
        Freight: 176.81,
        ShipName: 'Familia Arquibaldo',
        ShipAddress: "Rua Or\xf3s, 92",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05442-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10649,
        CustomerReference: 'MAISD',
        CompanyName: 'Maison Dewey',
        ContactName: 'Catherine Dewey',
        Employee: 'Steven Buchanan',
        InvoicedCost: 450.1224,
        ItemCount: 14,
        ChangeLastOrder: 22,
        ItemCost: 29.77,
        OrderCost: 416.78,
        PackageCost: 20.006,
        OrderDate: 1503874800000,
        RequiredDate: 1506294000000,
        ShippedDate: 1503961200000,
        ShipVia: 'Federal Shipping',
        Freight: 6.2,
        ShipName: 'Maison Dewey',
        ShipAddress: 'Rue Joseph-Bens 532',
        ShipCity: 'Bruxelles',
        ShipRegion: null,
        ShipPostalCode: 'B-1180',
        ShipCountry: 'Belgium',
        ArriveOnTime: 1
    },
    {
        OrderId: 10648,
        CustomerReference: 'RICAR',
        CompanyName: 'Ricardo Adocicados',
        ContactName: 'Janete Limeira',
        Employee: 'Steven Buchanan',
        InvoicedCost: 1105.9895,
        ItemCount: 11,
        ChangeLastOrder: -2,
        ItemCost: 87.43,
        OrderCost: 961.73,
        PackageCost: 13.97,
        OrderDate: 1503874800000,
        RequiredDate: 1507503600000,
        ShippedDate: 1504911600000,
        ShipVia: 'United Package',
        Freight: 14.25,
        ShipName: 'Ricardo Adocicados',
        ShipAddress: 'Av. Copacabana, 267',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-890',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10647,
        CustomerReference: 'QUEDE',
        CompanyName: "Que Del\xedcia",
        ContactName: 'Bernardo Batista',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1566.2079999999999,
        ItemCount: 14,
        ChangeLastOrder: -8,
        ItemCost: 97.28,
        OrderCost: 1361.92,
        PackageCost: 16.099999999999998,
        OrderDate: 1503788400000,
        RequiredDate: 1504998000000,
        ShippedDate: 1504393200000,
        ShipVia: 'United Package',
        Freight: 45.54,
        ShipName: "Que Del\xedcia",
        ShipAddress: 'Rua da Panificadora, 12',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-673',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10646,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 244.5552,
        ItemCount: 12,
        ChangeLastOrder: 1,
        ItemCost: 18.87,
        OrderCost: 226.44,
        PackageCost: 15.24,
        OrderDate: 1503788400000,
        RequiredDate: 1507417200000,
        ShippedDate: 1504393200000,
        ShipVia: 'Federal Shipping',
        Freight: 142.33,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10645,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Margaret Peacock',
        InvoicedCost: 137.275,
        ItemCount: 10,
        ChangeLastOrder: -28,
        ItemCost: 16.15,
        OrderCost: 161.5,
        PackageCost: 11.5,
        OrderDate: 1503702000000,
        RequiredDate: 1506121200000,
        ShippedDate: 1504306800000,
        ShipVia: 'Speedy Express',
        Freight: 12.41,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10644,
        CustomerReference: 'WELLI',
        CompanyName: 'Wellington Importadora',
        ContactName: 'Paula Parente',
        Employee: 'Janet Leverling',
        InvoicedCost: 178.2025,
        ItemCount: 7,
        ChangeLastOrder: -16,
        ItemCost: 29.95,
        OrderCost: 209.65,
        PackageCost: 8.049999999999999,
        OrderDate: 1503615600000,
        RequiredDate: 1506034800000,
        ShippedDate: 1504220400000,
        ShipVia: 'United Package',
        Freight: 0.14,
        ShipName: 'Wellington Importadora',
        ShipAddress: 'Rua do Mercado, 12',
        ShipCity: 'Resende',
        ShipRegion: 'SP',
        ShipPostalCode: '08737-363',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10643,
        CustomerReference: 'ALFKI',
        CompanyName: 'Alfreds Futterkiste',
        ContactName: 'Maria Anders',
        Employee: 'Michael Suyama',
        InvoicedCost: 109.038,
        ItemCount: 6,
        ChangeLastOrder: 15,
        ItemCost: 21.38,
        OrderCost: 128.28,
        PackageCost: 8.574,
        OrderDate: 1503615600000,
        RequiredDate: 1506034800000,
        ShippedDate: 1504306800000,
        ShipVia: 'Speedy Express',
        Freight: 29.46,
        ShipName: 'Alfreds Futterkiste',
        ShipAddress: 'Obere Str. 57',
        ShipCity: 'Berlin',
        ShipRegion: null,
        ShipPostalCode: 12209,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10642,
        CustomerReference: 'SIMOB',
        CompanyName: 'Simons bistro',
        ContactName: 'Jytte Petersen',
        Employee: 'Robert King',
        InvoicedCost: 373.1925,
        ItemCount: 5,
        ChangeLastOrder: 7,
        ItemCost: 87.81,
        OrderCost: 439.05,
        PackageCost: 6.905,
        OrderDate: 1503356400000,
        RequiredDate: 1505775600000,
        ShippedDate: 1504566000000,
        ShipVia: 'Federal Shipping',
        Freight: 41.89,
        ShipName: 'Simons bistro',
        ShipAddress: "Vinb\xe6ltet 34",
        ShipCity: "K\xf8benhavn",
        ShipRegion: null,
        ShipPostalCode: 1734,
        ShipCountry: 'Denmark',
        ArriveOnTime: 0
    },
    {
        OrderId: 10641,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Margaret Peacock',
        InvoicedCost: 1178.2581999999998,
        ItemCount: 14,
        ChangeLastOrder: -5,
        ItemCost: 81.71,
        OrderCost: 1143.9399999999998,
        PackageCost: 16.099999999999998,
        OrderDate: 1503356400000,
        RequiredDate: 1505775600000,
        ShippedDate: 1503702000000,
        ShipVia: 'United Package',
        Freight: 179.61,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10640,
        CustomerReference: 'WANDK',
        CompanyName: 'Die Wandernde Kuh',
        ContactName: "Rita M\xfcller",
        Employee: 'Margaret Peacock',
        InvoicedCost: 427.77000000000004,
        ItemCount: 5,
        ChangeLastOrder: 0,
        ItemCost: 81.48,
        OrderCost: 407.40000000000003,
        PackageCost: 6.35,
        OrderDate: 1503270000000,
        RequiredDate: 1505689200000,
        ShippedDate: 1503874800000,
        ShipVia: 'Speedy Express',
        Freight: 23.55,
        ShipName: 'Die Wandernde Kuh',
        ShipAddress: 'Adenauerallee 900',
        ShipCity: 'Stuttgart',
        ShipRegion: null,
        ShipPostalCode: 70563,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10639,
        CustomerReference: 'SANTG',
        CompanyName: "Sant\xe9 Gourmet",
        ContactName: 'Jonas Bergulfsen',
        Employee: 'Robert King',
        InvoicedCost: 395.4825,
        ItemCount: 9,
        ChangeLastOrder: -9,
        ItemCost: 50.22,
        OrderCost: 451.98,
        PackageCost: 10.35,
        OrderDate: 1503183600000,
        RequiredDate: 1505602800000,
        ShippedDate: 1503788400000,
        ShipVia: 'Federal Shipping',
        Freight: 38.64,
        ShipName: "Sant\xe9 Gourmet",
        ShipAddress: 'Erling Skakkes gate 78',
        ShipCity: 'Stavern',
        ShipRegion: null,
        ShipPostalCode: 4110,
        ShipCountry: 'Norway',
        ArriveOnTime: 0
    },
    {
        OrderId: 10638,
        CustomerReference: 'LINOD',
        CompanyName: 'LINO-Delicateses',
        ContactName: 'Felipe Izquierdo',
        Employee: 'Janet Leverling',
        InvoicedCost: 1022.4192,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 90.24,
        OrderCost: 992.64,
        PackageCost: 13.97,
        OrderDate: 1503183600000,
        RequiredDate: 1505602800000,
        ShippedDate: 1504220400000,
        ShipVia: 'Speedy Express',
        Freight: 158.44,
        ShipName: 'LINO-Delicateses',
        ShipAddress: 'Ave. 5 de Mayo Porlamar',
        ShipCity: 'I. de Margarita',
        ShipRegion: 'Nueva Esparta',
        ShipPostalCode: 4980,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10637,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Michael Suyama',
        InvoicedCost: 49.8355,
        ItemCount: 11,
        ChangeLastOrder: -2,
        ItemCost: 5.33,
        OrderCost: 58.63,
        PackageCost: 13.97,
        OrderDate: 1503097200000,
        RequiredDate: 1505516400000,
        ShippedDate: 1503702000000,
        ShipVia: 'Speedy Express',
        Freight: 201.29,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10636,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Margaret Peacock',
        InvoicedCost: 626.22,
        ItemCount: 10,
        ChangeLastOrder: 56,
        ItemCost: 59.64,
        OrderCost: 596.4,
        PackageCost: 14.290000000000001,
        OrderDate: 1503097200000,
        RequiredDate: 1505516400000,
        ShippedDate: 1503702000000,
        ShipVia: 'Speedy Express',
        Freight: 1.15,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10635,
        CustomerReference: 'MAGAA',
        CompanyName: 'Magazzini Alimentari Riuniti',
        ContactName: 'Giovanni Rovelli',
        Employee: 'Laura Callahan',
        InvoicedCost: 890.562,
        ItemCount: 12,
        ChangeLastOrder: 5,
        ItemCost: 87.31,
        OrderCost: 1047.72,
        PackageCost: 6.48,
        OrderDate: 1503010800000,
        RequiredDate: 1505430000000,
        ShippedDate: 1503270000000,
        ShipVia: 'Federal Shipping',
        Freight: 47.46,
        ShipName: 'Magazzini Alimentari Riuniti',
        ShipAddress: 'Via Ludovico il Moro 22',
        ShipCity: 'Bergamo',
        ShipRegion: null,
        ShipPostalCode: 24100,
        ShipCountry: 'Italy',
        ArriveOnTime: 0
    },
    {
        OrderId: 10634,
        CustomerReference: 'FOLIG',
        CompanyName: 'Folies gourmandes',
        ContactName: "Martine Ranc\xe9",
        Employee: 'Margaret Peacock',
        InvoicedCost: 235.35899999999998,
        ItemCount: 6,
        ChangeLastOrder: 5,
        ItemCost: 34.11,
        OrderCost: 204.66,
        PackageCost: 3.24,
        OrderDate: 1502751600000,
        RequiredDate: 1505170800000,
        ShippedDate: 1503270000000,
        ShipVia: 'Federal Shipping',
        Freight: 487.38,
        ShipName: 'Folies gourmandes',
        ShipAddress: "184, chauss\xe9e de Tournai",
        ShipCity: 'Lille',
        ShipRegion: null,
        ShipPostalCode: 59000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10633,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Robert King',
        InvoicedCost: 720.1845000000001,
        ItemCount: 9,
        ChangeLastOrder: -4,
        ItemCost: 76.21,
        OrderCost: 685.89,
        PackageCost: 10.35,
        OrderDate: 1502751600000,
        RequiredDate: 1505170800000,
        ShippedDate: 1503010800000,
        ShipVia: 'Federal Shipping',
        Freight: 477.9,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10632,
        CustomerReference: 'WANDK',
        CompanyName: 'Die Wandernde Kuh',
        ContactName: "Rita M\xfcller",
        Employee: 'Laura Callahan',
        InvoicedCost: 360.80100000000004,
        ItemCount: 6,
        ChangeLastOrder: 0,
        ItemCost: 57.27,
        OrderCost: 343.62,
        PackageCost: 7.62,
        OrderDate: 1502665200000,
        RequiredDate: 1505084400000,
        ShippedDate: 1503097200000,
        ShipVia: 'Speedy Express',
        Freight: 41.38,
        ShipName: 'Die Wandernde Kuh',
        ShipAddress: 'Adenauerallee 900',
        ShipCity: 'Stuttgart',
        ShipRegion: null,
        ShipPostalCode: 70563,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10631,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Laura Callahan',
        InvoicedCost: 378.658,
        ItemCount: 7,
        ChangeLastOrder: 6,
        ItemCost: 63.64,
        OrderCost: 445.48,
        PackageCost: 9.667,
        OrderDate: 1502665200000,
        RequiredDate: 1505084400000,
        ShippedDate: 1502751600000,
        ShipVia: 'Speedy Express',
        Freight: 0.87,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10630,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Nancy Davolio',
        InvoicedCost: 565.3095000000001,
        ItemCount: 7,
        ChangeLastOrder: 38,
        ItemCost: 95.01,
        OrderCost: 665.07,
        PackageCost: 10.003,
        OrderDate: 1502578800000,
        RequiredDate: 1504998000000,
        ShippedDate: 1503097200000,
        ShipVia: 'United Package',
        Freight: 32.35,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10629,
        CustomerReference: 'GODOS',
        CompanyName: "Godos Cocina T\xedpica",
        ContactName: "Jos\xe9 Pedro Freyre",
        Employee: 'Margaret Peacock',
        InvoicedCost: 483.455,
        ItemCount: 14,
        ChangeLastOrder: -5,
        ItemCost: 36.35,
        OrderCost: 508.90000000000003,
        PackageCost: 16.099999999999998,
        OrderDate: 1502492400000,
        RequiredDate: 1504911600000,
        ShippedDate: 1503183600000,
        ShipVia: 'Federal Shipping',
        Freight: 85.46,
        ShipName: "Godos Cocina T\xedpica",
        ShipAddress: 'C/ Romero, 33',
        ShipCity: 'Sevilla',
        ShipRegion: null,
        ShipPostalCode: 41101,
        ShipCountry: 'Spain',
        ArriveOnTime: 0
    },
    {
        OrderId: 10628,
        CustomerReference: 'BLONP',
        CompanyName: "Blondel p\xe8re et fils",
        ContactName: "Fr\xe9d\xe9rique Citeaux",
        Employee: 'Margaret Peacock',
        InvoicedCost: 238.464,
        ItemCount: 8,
        ChangeLastOrder: 4,
        ItemCost: 25.92,
        OrderCost: 207.36,
        PackageCost: 4.32,
        OrderDate: 1502492400000,
        RequiredDate: 1504911600000,
        ShippedDate: 1503183600000,
        ShipVia: 'Federal Shipping',
        Freight: 30.36,
        ShipName: "Blondel p\xe8re et fils",
        ShipAddress: "24, place Kl\xe9ber",
        ShipCity: 'Strasbourg',
        ShipRegion: null,
        ShipPostalCode: 67000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10627,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Laura Callahan',
        InvoicedCost: 259.623,
        ItemCount: 13,
        ChangeLastOrder: 5,
        ItemCost: 19.02,
        OrderCost: 247.26,
        PackageCost: 7.0200000000000005,
        OrderDate: 1502406000000,
        RequiredDate: 1506034800000,
        ShippedDate: 1503270000000,
        ShipVia: 'Federal Shipping',
        Freight: 107.46,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10626,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Nancy Davolio',
        InvoicedCost: 394.8588,
        ItemCount: 7,
        ChangeLastOrder: -3,
        ItemCost: 52.23,
        OrderCost: 365.60999999999996,
        PackageCost: 8.89,
        OrderDate: 1502406000000,
        RequiredDate: 1504825200000,
        ShippedDate: 1503183600000,
        ShipVia: 'United Package',
        Freight: 138.69,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10625,
        CustomerReference: 'ANATR',
        CompanyName: 'Ana Trujillo Emparedados y helados',
        ContactName: 'Ana Trujillo',
        Employee: 'Janet Leverling',
        InvoicedCost: 520.6049999999999,
        ItemCount: 9,
        ChangeLastOrder: -3,
        ItemCost: 50.3,
        OrderCost: 452.7,
        PackageCost: 11.43,
        OrderDate: 1502146800000,
        RequiredDate: 1504566000000,
        ShippedDate: 1502665200000,
        ShipVia: 'Speedy Express',
        Freight: 43.9,
        ShipName: 'Ana Trujillo Emparedados y helados',
        ShipAddress: "Avda. de la Constituci\xf3n 2222",
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5021,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10624,
        CustomerReference: 'THECR',
        CompanyName: 'The Cracker Box',
        ContactName: 'Liu Wong',
        Employee: 'Margaret Peacock',
        InvoicedCost: 555.588,
        ItemCount: 8,
        ChangeLastOrder: 2,
        ItemCost: 60.39,
        OrderCost: 483.12,
        PackageCost: 10.16,
        OrderDate: 1502060400000,
        RequiredDate: 1504479600000,
        ShippedDate: 1503097200000,
        ShipVia: 'United Package',
        Freight: 94.8,
        ShipName: 'The Cracker Box',
        ShipAddress: '55 Grizzly Peak Rd.',
        ShipCity: 'Butte',
        ShipRegion: 'MT',
        ShipPostalCode: 59801,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10623,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Laura Callahan',
        InvoicedCost: 416.17800000000005,
        ItemCount: 12,
        ChangeLastOrder: -3,
        ItemCost: 33.03,
        OrderCost: 396.36,
        PackageCost: 15.24,
        OrderDate: 1502060400000,
        RequiredDate: 1504479600000,
        ShippedDate: 1502492400000,
        ShipVia: 'United Package',
        Freight: 97.18,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10622,
        CustomerReference: 'RICAR',
        CompanyName: 'Ricardo Adocicados',
        ContactName: 'Janete Limeira',
        Employee: 'Margaret Peacock',
        InvoicedCost: 347.7025,
        ItemCount: 5,
        ChangeLastOrder: -2,
        ItemCost: 60.47,
        OrderCost: 302.35,
        PackageCost: 6.35,
        OrderDate: 1501974000000,
        RequiredDate: 1504393200000,
        ShippedDate: 1502406000000,
        ShipVia: 'Federal Shipping',
        Freight: 50.97,
        ShipName: 'Ricardo Adocicados',
        ShipAddress: 'Av. Copacabana, 267',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-890',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10621,
        CustomerReference: 'ISLAT',
        CompanyName: 'Island Trading',
        ContactName: 'Helen Bennett',
        Employee: 'Margaret Peacock',
        InvoicedCost: 252.93600000000004,
        ItemCount: 8,
        ChangeLastOrder: 8,
        ItemCost: 35.13,
        OrderCost: 281.04,
        PackageCost: 11.048,
        OrderDate: 1501887600000,
        RequiredDate: 1504306800000,
        ShippedDate: 1502406000000,
        ShipVia: 'United Package',
        Freight: 23.73,
        ShipName: 'Island Trading',
        ShipAddress: 'Garden House, Crowther Way',
        ShipCity: 'Cowes',
        ShipRegion: 'Isle of Wight',
        ShipPostalCode: 'PO31 7PJ',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10620,
        CustomerReference: 'LAUGB',
        CompanyName: 'Laughing Bacchus Wine Cellars',
        ContactName: 'Yoshi Tannamuri',
        Employee: 'Andrew Fuller',
        InvoicedCost: 615.33,
        ItemCount: 10,
        ChangeLastOrder: 4,
        ItemCost: 68.37,
        OrderCost: 683.7,
        PackageCost: 5.4,
        OrderDate: 1501887600000,
        RequiredDate: 1504306800000,
        ShippedDate: 1502665200000,
        ShipVia: 'Federal Shipping',
        Freight: 0.94,
        ShipName: 'Laughing Bacchus Wine Cellars',
        ShipAddress: '2319 Elm St.',
        ShipCity: 'Vancouver',
        ShipRegion: 'BC',
        ShipPostalCode: 'V3F 2K1',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 10619,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Janet Leverling',
        InvoicedCost: 536.976,
        ItemCount: 8,
        ChangeLastOrder: 2,
        ItemCost: 74.58,
        OrderCost: 596.64,
        PackageCost: 10.16,
        OrderDate: 1501801200000,
        RequiredDate: 1504220400000,
        ShippedDate: 1502060400000,
        ShipVia: 'Federal Shipping',
        Freight: 91.05,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10618,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Nancy Davolio',
        InvoicedCost: 743.652,
        ItemCount: 14,
        ChangeLastOrder: 2,
        ItemCost: 59.02,
        OrderCost: 826.2800000000001,
        PackageCost: 17.78,
        OrderDate: 1501542000000,
        RequiredDate: 1505170800000,
        ShippedDate: 1502146800000,
        ShipVia: 'Speedy Express',
        Freight: 154.68,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10617,
        CustomerReference: 'GREAL',
        CompanyName: 'Great Lakes Food Market',
        ContactName: 'Howard Snyder',
        Employee: 'Margaret Peacock',
        InvoicedCost: 976.8600000000001,
        ItemCount: 12,
        ChangeLastOrder: 3,
        ItemCost: 90.45,
        OrderCost: 1085.4,
        PackageCost: 6.48,
        OrderDate: 1501455600000,
        RequiredDate: 1503874800000,
        ShippedDate: 1501801200000,
        ShipVia: 'United Package',
        Freight: 18.53,
        ShipName: 'Great Lakes Food Market',
        ShipAddress: '2732 Baker Blvd.',
        ShipCity: 'Eugene',
        ShipRegion: 'OR',
        ShipPostalCode: 97403,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10616,
        CustomerReference: 'GREAL',
        CompanyName: 'Great Lakes Food Market',
        ContactName: 'Howard Snyder',
        Employee: 'Nancy Davolio',
        InvoicedCost: 1141.92,
        ItemCount: 13,
        ChangeLastOrder: 3,
        ItemCost: 97.6,
        OrderCost: 1268.8,
        PackageCost: 7.0200000000000005,
        OrderDate: 1501455600000,
        RequiredDate: 1503874800000,
        ShippedDate: 1501887600000,
        ShipVia: 'United Package',
        Freight: 116.53,
        ShipName: 'Great Lakes Food Market',
        ShipAddress: '2732 Baker Blvd.',
        ShipCity: 'Eugene',
        ShipRegion: 'OR',
        ShipPostalCode: 97403,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10615,
        CustomerReference: 'WILMK',
        CompanyName: 'Wilman Kala',
        ContactName: 'Matti Karttunen',
        Employee: 'Andrew Fuller',
        InvoicedCost: 450.73799999999994,
        ItemCount: 9,
        ChangeLastOrder: 22,
        ItemCost: 58.92,
        OrderCost: 530.28,
        PackageCost: 12.861,
        OrderDate: 1501369200000,
        RequiredDate: 1503788400000,
        ShippedDate: 1501974000000,
        ShipVia: 'Federal Shipping',
        Freight: 0.75,
        ShipName: 'Wilman Kala',
        ShipAddress: 'Keskuskatu 45',
        ShipCity: 'Helsinki',
        ShipRegion: null,
        ShipPostalCode: 21240,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10614,
        CustomerReference: 'BLAUS',
        CompanyName: 'Blauer See Delikatessen',
        ContactName: 'Hanna Moos',
        Employee: 'Laura Callahan',
        InvoicedCost: 409.676,
        ItemCount: 8,
        ChangeLastOrder: 18,
        ItemCost: 44.53,
        OrderCost: 356.24,
        PackageCost: 11.432,
        OrderDate: 1501282800000,
        RequiredDate: 1503702000000,
        ShippedDate: 1501542000000,
        ShipVia: 'Federal Shipping',
        Freight: 1.93,
        ShipName: 'Blauer See Delikatessen',
        ShipAddress: 'Forsterstr. 57',
        ShipCity: 'Mannheim',
        ShipRegion: null,
        ShipPostalCode: 68306,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10613,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Margaret Peacock',
        InvoicedCost: 569.7919999999999,
        ItemCount: 8,
        ChangeLastOrder: 18,
        ItemCost: 49.12,
        OrderCost: 392.96,
        PackageCost: 11.432,
        OrderDate: 1501282800000,
        RequiredDate: 1503702000000,
        ShippedDate: 1501542000000,
        ShipVia: 'United Package',
        Freight: 8.11,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10612,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Nancy Davolio',
        InvoicedCost: 271.089,
        ItemCount: 13,
        ChangeLastOrder: 5,
        ItemCost: 19.86,
        OrderCost: 258.18,
        PackageCost: 7.0200000000000005,
        OrderDate: 1501196400000,
        RequiredDate: 1503615600000,
        ShippedDate: 1501542000000,
        ShipVia: 'United Package',
        Freight: 544.08,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10611,
        CustomerReference: 'WOLZA',
        CompanyName: 'Wolski  Zajazd',
        ContactName: 'Zbyszek Piestrzeniewicz',
        Employee: 'Michael Suyama',
        InvoicedCost: 563.5,
        ItemCount: 10,
        ChangeLastOrder: 17,
        ItemCost: 45.08,
        OrderCost: 450.79999999999995,
        PackageCost: 14.290000000000001,
        OrderDate: 1500937200000,
        RequiredDate: 1503356400000,
        ShippedDate: 1501542000000,
        ShipVia: 'United Package',
        Freight: 80.65,
        ShipName: 'Wolski Zajazd',
        ShipAddress: 'ul. Filtrowa 68',
        ShipCity: 'Warszawa',
        ShipRegion: null,
        ShipPostalCode: '01-012',
        ShipCountry: 'Poland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10610,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Laura Callahan',
        InvoicedCost: 208.79399999999998,
        ItemCount: 6,
        ChangeLastOrder: 6,
        ItemCost: 40.94,
        OrderCost: 245.64,
        PackageCost: 8.286,
        OrderDate: 1500937200000,
        RequiredDate: 1503356400000,
        ShippedDate: 1501974000000,
        ShipVia: 'Speedy Express',
        Freight: 26.78,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10609,
        CustomerReference: 'DUMON',
        CompanyName: 'Du monde entier',
        ContactName: 'Janine Labrune',
        Employee: 'Robert King',
        InvoicedCost: 626.6899999999999,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 43.22,
        OrderCost: 432.2,
        PackageCost: 12.7,
        OrderDate: 1500850800000,
        RequiredDate: 1503270000000,
        ShippedDate: 1501369200000,
        ShipVia: 'United Package',
        Freight: 1.85,
        ShipName: 'Du monde entier',
        ShipAddress: '67, rue des Cinquante Otages',
        ShipCity: 'Nantes',
        ShipRegion: null,
        ShipPostalCode: 44000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10608,
        CustomerReference: 'TOMSP',
        CompanyName: "Toms Spezialit\xe4ten",
        ContactName: 'Karin Josephs',
        Employee: 'Margaret Peacock',
        InvoicedCost: 834.3927000000001,
        ItemCount: 9,
        ChangeLastOrder: -13,
        ItemCost: 90.01,
        OrderCost: 810.09,
        PackageCost: 10.35,
        OrderDate: 1500764400000,
        RequiredDate: 1503183600000,
        ShippedDate: 1501542000000,
        ShipVia: 'United Package',
        Freight: 27.79,
        ShipName: "Toms Spezialit\xe4ten",
        ShipAddress: 'Luisenstr. 48',
        ShipCity: "M\xfcnster",
        ShipRegion: null,
        ShipPostalCode: 44087,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10607,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Steven Buchanan',
        InvoicedCost: 713.664,
        ItemCount: 8,
        ChangeLastOrder: 5,
        ItemCost: 84.96,
        OrderCost: 679.68,
        PackageCost: 4.32,
        OrderDate: 1500678000000,
        RequiredDate: 1503097200000,
        ShippedDate: 1500937200000,
        ShipVia: 'Speedy Express',
        Freight: 200.24,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10606,
        CustomerReference: 'TRADH',
        CompanyName: "Tradi\xe7\xe3o Hipermercados",
        ContactName: 'Anabela Domingues',
        Employee: 'Margaret Peacock',
        InvoicedCost: 212.61899999999997,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 22.74,
        OrderCost: 250.14,
        PackageCost: 13.97,
        OrderDate: 1500678000000,
        RequiredDate: 1503097200000,
        ShippedDate: 1501455600000,
        ShipVia: 'Federal Shipping',
        Freight: 79.4,
        ShipName: "Tradi\xe7\xe3o Hipermercados",
        ShipAddress: "Av. In\xeas de Castro, 414",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05634-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10605,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Nancy Davolio',
        InvoicedCost: 323.757,
        ItemCount: 7,
        ChangeLastOrder: 2,
        ItemCost: 51.39,
        OrderCost: 359.73,
        PackageCost: 8.89,
        OrderDate: 1500591600000,
        RequiredDate: 1503010800000,
        ShippedDate: 1501282800000,
        ShipVia: 'United Package',
        Freight: 379.13,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10604,
        CustomerReference: 'FURIB',
        CompanyName: 'Furia Bacalhau e Frutos do Mar',
        ContactName: 'Lino Rodriguez',
        Employee: 'Nancy Davolio',
        InvoicedCost: 838.1424999999999,
        ItemCount: 13,
        ChangeLastOrder: 33,
        ItemCost: 75.85,
        OrderCost: 986.05,
        PackageCost: 18.577,
        OrderDate: 1500332400000,
        RequiredDate: 1502751600000,
        ShippedDate: 1501282800000,
        ShipVia: 'Speedy Express',
        Freight: 7.46,
        ShipName: 'Furia Bacalhau e Frutos do Mar',
        ShipAddress: 'Jardim das rosas n. 32',
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1675,
        ShipCountry: 'Portugal',
        ArriveOnTime: 1
    },
    {
        OrderId: 10603,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Laura Callahan',
        InvoicedCost: 206.01000000000002,
        ItemCount: 9,
        ChangeLastOrder: 5,
        ItemCost: 21.8,
        OrderCost: 196.20000000000002,
        PackageCost: 4.86,
        OrderDate: 1500332400000,
        RequiredDate: 1502751600000,
        ShippedDate: 1502146800000,
        ShipVia: 'United Package',
        Freight: 48.77,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10602,
        CustomerReference: 'VAFFE',
        CompanyName: 'Vaffeljernet',
        ContactName: 'Palle Ibsen',
        Employee: 'Laura Callahan',
        InvoicedCost: 61.236000000000004,
        ItemCount: 8,
        ChangeLastOrder: 18,
        ItemCost: 7.29,
        OrderCost: 58.32,
        PackageCost: 11.432,
        OrderDate: 1500246000000,
        RequiredDate: 1502665200000,
        ShippedDate: 1500678000000,
        ShipVia: 'United Package',
        Freight: 2.92,
        ShipName: 'Vaffeljernet',
        ShipAddress: "Smagsl\xf8get 45",
        ShipCity: "\xc5rhus",
        ShipRegion: null,
        ShipPostalCode: 8200,
        ShipCountry: 'Denmark',
        ArriveOnTime: 1
    },
    {
        OrderId: 10601,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Robert King',
        InvoicedCost: 167.011,
        ItemCount: 13,
        ChangeLastOrder: -5,
        ItemCost: 8.86,
        OrderCost: 115.17999999999999,
        PackageCost: 14.95,
        OrderDate: 1500159600000,
        RequiredDate: 1503788400000,
        ShippedDate: 1500678000000,
        ShipVia: 'Speedy Express',
        Freight: 58.3,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10600,
        CustomerReference: 'HUNGC',
        CompanyName: 'Hungry Coyote Import Store',
        ContactName: 'Yoshi Latimer',
        Employee: 'Margaret Peacock',
        InvoicedCost: 279.396,
        ItemCount: 13,
        ChangeLastOrder: -2,
        ItemCost: 23.88,
        OrderCost: 310.44,
        PackageCost: 16.51,
        OrderDate: 1500159600000,
        RequiredDate: 1502578800000,
        ShippedDate: 1500591600000,
        ShipVia: 'Speedy Express',
        Freight: 45.13,
        ShipName: 'Hungry Coyote Import Store',
        ShipAddress: 'City Center Plaza, 516 Main St.',
        ShipCity: 'Elgin',
        ShipRegion: 'OR',
        ShipPostalCode: 97827,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10599,
        CustomerReference: 'BSBEV',
        CompanyName: "B's Beverages",
        ContactName: 'Victoria Ashworth',
        Employee: 'Michael Suyama',
        InvoicedCost: 79.632,
        ItemCount: 7,
        ChangeLastOrder: -20,
        ItemCost: 12.64,
        OrderCost: 88.48,
        PackageCost: 8.049999999999999,
        OrderDate: 1500073200000,
        RequiredDate: 1503702000000,
        ShippedDate: 1500591600000,
        ShipVia: 'Federal Shipping',
        Freight: 29.98,
        ShipName: "B's Beverages",
        ShipAddress: 'Fauntleroy Circus',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'EC2 5NT',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10598,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Nancy Davolio',
        InvoicedCost: 608.013,
        ItemCount: 9,
        ChangeLastOrder: 2,
        ItemCost: 64.34,
        OrderCost: 579.0600000000001,
        PackageCost: 11.43,
        OrderDate: 1499986800000,
        RequiredDate: 1502406000000,
        ShippedDate: 1500332400000,
        ShipVia: 'Federal Shipping',
        Freight: 44.42,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10597,
        CustomerReference: 'PICCO',
        CompanyName: 'Piccolo und mehr',
        ContactName: 'Georg Pipps',
        Employee: 'Robert King',
        InvoicedCost: 909.2943000000001,
        ItemCount: 9,
        ChangeLastOrder: 0,
        ItemCost: 98.09,
        OrderCost: 882.8100000000001,
        PackageCost: 11.43,
        OrderDate: 1499727600000,
        RequiredDate: 1502146800000,
        ShippedDate: 1500332400000,
        ShipVia: 'Federal Shipping',
        Freight: 35.12,
        ShipName: 'Piccolo und mehr',
        ShipAddress: 'Geislweg 14',
        ShipCity: 'Salzburg',
        ShipRegion: null,
        ShipPostalCode: 5020,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10596,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Laura Callahan',
        InvoicedCost: 700.4879999999999,
        ItemCount: 12,
        ChangeLastOrder: 6,
        ItemCost: 64.86,
        OrderCost: 778.3199999999999,
        PackageCost: 16.572,
        OrderDate: 1499727600000,
        RequiredDate: 1502146800000,
        ShippedDate: 1502492400000,
        ShipVia: 'Speedy Express',
        Freight: 16.34,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10595,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Andrew Fuller',
        InvoicedCost: 288.981,
        ItemCount: 11,
        ChangeLastOrder: 10,
        ItemCost: 25.02,
        OrderCost: 275.21999999999997,
        PackageCost: 15.719000000000001,
        OrderDate: 1499641200000,
        RequiredDate: 1502060400000,
        ShippedDate: 1499986800000,
        ShipVia: 'Speedy Express',
        Freight: 96.78,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10594,
        CustomerReference: 'OLDWO',
        CompanyName: 'Old World Delicatessen',
        ContactName: 'Rene Phillips',
        Employee: 'Janet Leverling',
        InvoicedCost: 418.869,
        ItemCount: 11,
        ChangeLastOrder: 3,
        ItemCost: 42.31,
        OrderCost: 465.41,
        PackageCost: 5.94,
        OrderDate: 1499554800000,
        RequiredDate: 1501974000000,
        ShippedDate: 1500159600000,
        ShipVia: 'United Package',
        Freight: 5.24,
        ShipName: 'Old World Delicatessen',
        ShipAddress: '2743 Bering St.',
        ShipCity: 'Anchorage',
        ShipRegion: 'AK',
        ShipPostalCode: 99508,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10593,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Robert King',
        InvoicedCost: 321.264,
        ItemCount: 8,
        ChangeLastOrder: -20,
        ItemCost: 34.92,
        OrderCost: 279.36,
        PackageCost: 9.2,
        OrderDate: 1499554800000,
        RequiredDate: 1501974000000,
        ShippedDate: 1502578800000,
        ShipVia: 'United Package',
        Freight: 174.2,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10592,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Janet Leverling',
        InvoicedCost: 276.46,
        ItemCount: 5,
        ChangeLastOrder: -18,
        ItemCost: 48.08,
        OrderCost: 240.39999999999998,
        PackageCost: 5.75,
        OrderDate: 1499468400000,
        RequiredDate: 1501887600000,
        ShippedDate: 1500159600000,
        ShipVia: 'Speedy Express',
        Freight: 32.1,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10591,
        CustomerReference: 'VAFFE',
        CompanyName: 'Vaffeljernet',
        ContactName: 'Palle Ibsen',
        Employee: 'Nancy Davolio',
        InvoicedCost: 1055.313,
        ItemCount: 14,
        ChangeLastOrder: 10,
        ItemCost: 71.79,
        OrderCost: 1005.0600000000001,
        PackageCost: 20.006,
        OrderDate: 1499382000000,
        RequiredDate: 1500591600000,
        ShippedDate: 1500159600000,
        ShipVia: 'Speedy Express',
        Freight: 55.92,
        ShipName: 'Vaffeljernet',
        ShipAddress: "Smagsl\xf8get 45",
        ShipCity: "\xc5rhus",
        ShipRegion: null,
        ShipPostalCode: 8200,
        ShipCountry: 'Denmark',
        ArriveOnTime: 0
    },
    {
        OrderId: 10590,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Margaret Peacock',
        InvoicedCost: 256.446,
        ItemCount: 9,
        ChangeLastOrder: 2,
        ItemCost: 31.66,
        OrderCost: 284.94,
        PackageCost: 11.43,
        OrderDate: 1499382000000,
        RequiredDate: 1501801200000,
        ShippedDate: 1499986800000,
        ShipVia: 'Federal Shipping',
        Freight: 44.77,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10589,
        CustomerReference: 'GREAL',
        CompanyName: 'Great Lakes Food Market',
        ContactName: 'Howard Snyder',
        Employee: 'Laura Callahan',
        InvoicedCost: 504.252,
        ItemCount: 12,
        ChangeLastOrder: 3,
        ItemCost: 46.69,
        OrderCost: 560.28,
        PackageCost: 6.48,
        OrderDate: 1499122800000,
        RequiredDate: 1501542000000,
        ShippedDate: 1499986800000,
        ShipVia: 'United Package',
        Freight: 4.42,
        ShipName: 'Great Lakes Food Market',
        ShipAddress: '2732 Baker Blvd.',
        ShipCity: 'Eugene',
        ShipRegion: 'OR',
        ShipPostalCode: 97403,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10588,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Andrew Fuller',
        InvoicedCost: 288.25,
        ItemCount: 10,
        ChangeLastOrder: 1,
        ItemCost: 23.06,
        OrderCost: 230.6,
        PackageCost: 12.7,
        OrderDate: 1499036400000,
        RequiredDate: 1501455600000,
        ShippedDate: 1499641200000,
        ShipVia: 'Federal Shipping',
        Freight: 194.67,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10587,
        CustomerReference: 'QUEDE',
        CompanyName: "Que Del\xedcia",
        ContactName: 'Bernardo Batista',
        Employee: 'Nancy Davolio',
        InvoicedCost: 682.4100000000001,
        ItemCount: 6,
        ChangeLastOrder: -3,
        ItemCost: 98.9,
        OrderCost: 593.4000000000001,
        PackageCost: 7.62,
        OrderDate: 1498950000000,
        RequiredDate: 1501369200000,
        ShippedDate: 1499554800000,
        ShipVia: 'Speedy Express',
        Freight: 62.52,
        ShipName: "Que Del\xedcia",
        ShipAddress: 'Rua da Panificadora, 12',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-673',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10586,
        CustomerReference: 'REGGC',
        CompanyName: 'Reggiani Caseifici',
        ContactName: 'Maurizio Moroni',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 342.26500000000004,
        ItemCount: 14,
        ChangeLastOrder: -5,
        ItemCost: 27.94,
        OrderCost: 391.16,
        PackageCost: 16.099999999999998,
        OrderDate: 1498950000000,
        RequiredDate: 1501369200000,
        ShippedDate: 1499554800000,
        ShipVia: 'Speedy Express',
        Freight: 0.48,
        ShipName: 'Reggiani Caseifici',
        ShipAddress: 'Strada Provinciale 124',
        ShipCity: 'Reggio Emilia',
        ShipRegion: null,
        ShipPostalCode: 42100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10585,
        CustomerReference: 'WELLI',
        CompanyName: 'Wellington Importadora',
        ContactName: 'Paula Parente',
        Employee: 'Robert King',
        InvoicedCost: 379.34649999999993,
        ItemCount: 13,
        ChangeLastOrder: -13,
        ItemCost: 34.33,
        OrderCost: 446.28999999999996,
        PackageCost: 14.95,
        OrderDate: 1498863600000,
        RequiredDate: 1501282800000,
        ShippedDate: 1499641200000,
        ShipVia: 'Speedy Express',
        Freight: 13.41,
        ShipName: 'Wellington Importadora',
        ShipAddress: 'Rua do Mercado, 12',
        ShipCity: 'Resende',
        ShipRegion: 'SP',
        ShipPostalCode: '08737-363',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10584,
        CustomerReference: 'BLONP',
        CompanyName: "Blondel p\xe8re et fils",
        ContactName: "Fr\xe9d\xe9rique Citeaux",
        Employee: 'Margaret Peacock',
        InvoicedCost: 758.0339999999999,
        ItemCount: 12,
        ChangeLastOrder: 4,
        ItemCost: 54.93,
        OrderCost: 659.16,
        PackageCost: 6.48,
        OrderDate: 1498777200000,
        RequiredDate: 1501196400000,
        ShippedDate: 1499122800000,
        ShipVia: 'Speedy Express',
        Freight: 59.14,
        ShipName: "Blondel p\xe8re et fils",
        ShipAddress: "24, place Kl\xe9ber",
        ShipCity: 'Strasbourg',
        ShipRegion: null,
        ShipPostalCode: 67000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10583,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Andrew Fuller',
        InvoicedCost: 707.8995,
        ItemCount: 9,
        ChangeLastOrder: 50,
        ItemCost: 74.91,
        OrderCost: 674.1899999999999,
        PackageCost: 12.861,
        OrderDate: 1498777200000,
        RequiredDate: 1501196400000,
        ShippedDate: 1499122800000,
        ShipVia: 'United Package',
        Freight: 7.28,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10582,
        CustomerReference: 'BLAUS',
        CompanyName: 'Blauer See Delikatessen',
        ContactName: 'Hanna Moos',
        Employee: 'Janet Leverling',
        InvoicedCost: 657.5355,
        ItemCount: 9,
        ChangeLastOrder: 16,
        ItemCost: 63.53,
        OrderCost: 571.77,
        PackageCost: 12.861,
        OrderDate: 1498518000000,
        RequiredDate: 1500937200000,
        ShippedDate: 1499986800000,
        ShipVia: 'United Package',
        Freight: 27.71,
        ShipName: 'Blauer See Delikatessen',
        ShipAddress: 'Forsterstr. 57',
        ShipCity: 'Mannheim',
        ShipRegion: null,
        ShipPostalCode: 68306,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10581,
        CustomerReference: 'FAMIA',
        CompanyName: 'Familia Arquibaldo',
        ContactName: 'Aria Cruz',
        Employee: 'Janet Leverling',
        InvoicedCost: 492.8299999999999,
        ItemCount: 10,
        ChangeLastOrder: -33,
        ItemCost: 57.98,
        OrderCost: 579.8,
        PackageCost: 11.5,
        OrderDate: 1498431600000,
        RequiredDate: 1500850800000,
        ShippedDate: 1498950000000,
        ShipVia: 'Speedy Express',
        Freight: 3.01,
        ShipName: 'Familia Arquibaldo',
        ShipAddress: "Rua Or\xf3s, 92",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05442-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10580,
        CustomerReference: 'OTTIK',
        CompanyName: "Ottilies K\xe4seladen",
        ContactName: 'Henriette Pfalzheim',
        Employee: 'Margaret Peacock',
        InvoicedCost: 411.424,
        ItemCount: 13,
        ChangeLastOrder: 27,
        ItemCost: 27.52,
        OrderCost: 357.76,
        PackageCost: 18.577,
        OrderDate: 1498431600000,
        RequiredDate: 1500850800000,
        ShippedDate: 1498863600000,
        ShipVia: 'Federal Shipping',
        Freight: 75.89,
        ShipName: "Ottilies K\xe4seladen",
        ShipAddress: 'Mehrheimerstr. 369',
        ShipCity: "K\xf6ln",
        ShipRegion: null,
        ShipPostalCode: 50739,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10579,
        CustomerReference: 'LETSS',
        CompanyName: "Let's Stop N Shop",
        ContactName: 'Jaime Yorres',
        Employee: 'Nancy Davolio',
        InvoicedCost: 740.5020000000001,
        ItemCount: 12,
        ChangeLastOrder: 1,
        ItemCost: 58.77,
        OrderCost: 705.24,
        PackageCost: 15.24,
        OrderDate: 1498345200000,
        RequiredDate: 1500764400000,
        ShippedDate: 1499122800000,
        ShipVia: 'United Package',
        Freight: 13.73,
        ShipName: "Let's Stop N Shop",
        ShipAddress: '87 Polk St. Suite 5',
        ShipCity: 'San Francisco',
        ShipRegion: 'CA',
        ShipPostalCode: 94117,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10578,
        CustomerReference: 'BSBEV',
        CompanyName: "B's Beverages",
        ContactName: 'Victoria Ashworth',
        Employee: 'Margaret Peacock',
        InvoicedCost: 485.01,
        ItemCount: 10,
        ChangeLastOrder: 24,
        ItemCost: 53.89,
        OrderCost: 538.9,
        PackageCost: 14.290000000000001,
        OrderDate: 1498258800000,
        RequiredDate: 1500678000000,
        ShippedDate: 1500937200000,
        ShipVia: 'Federal Shipping',
        Freight: 29.6,
        ShipName: "B's Beverages",
        ShipAddress: 'Fauntleroy Circus',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'EC2 5NT',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10577,
        CustomerReference: 'TRAIH',
        CompanyName: "Trail's Head Gourmet Provisioners",
        ContactName: 'Helvetius Nagy',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 480.168,
        ItemCount: 6,
        ChangeLastOrder: 2,
        ItemCost: 88.92,
        OrderCost: 533.52,
        PackageCost: 7.62,
        OrderDate: 1498172400000,
        RequiredDate: 1501801200000,
        ShippedDate: 1498777200000,
        ShipVia: 'United Package',
        Freight: 25.41,
        ShipName: "Trail's Head Gourmet Provisioners",
        ShipAddress: '722 DaVinci Blvd.',
        ShipCity: 'Kirkland',
        ShipRegion: 'WA',
        ShipPostalCode: 98034,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10576,
        CustomerReference: 'TORTU',
        CompanyName: 'Tortuga Restaurante',
        ContactName: 'Miguel Angel Paolino',
        Employee: 'Janet Leverling',
        InvoicedCost: 259.8539999999999,
        ItemCount: 12,
        ChangeLastOrder: -3,
        ItemCost: 18.83,
        OrderCost: 225.95999999999998,
        PackageCost: 15.24,
        OrderDate: 1498172400000,
        RequiredDate: 1499382000000,
        ShippedDate: 1498777200000,
        ShipVia: 'Federal Shipping',
        Freight: 18.56,
        ShipName: 'Tortuga Restaurante',
        ShipAddress: 'Avda. Azteca 123',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10575,
        CustomerReference: 'MORGK',
        CompanyName: 'Morgenstern Gesundkost',
        ContactName: 'Alexander Feuer',
        Employee: 'Steven Buchanan',
        InvoicedCost: 1150.8509999999999,
        ItemCount: 13,
        ChangeLastOrder: -22,
        ItemCost: 76.98,
        OrderCost: 1000.74,
        PackageCost: 14.95,
        OrderDate: 1497913200000,
        RequiredDate: 1499122800000,
        ShippedDate: 1498777200000,
        ShipVia: 'Speedy Express',
        Freight: 127.34,
        ShipName: 'Morgenstern Gesundkost',
        ShipAddress: 'Heerstr. 22',
        ShipCity: 'Leipzig',
        ShipRegion: null,
        ShipPostalCode: 4179,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10574,
        CustomerReference: 'TRAIH',
        CompanyName: "Trail's Head Gourmet Provisioners",
        ContactName: 'Helvetius Nagy',
        Employee: 'Margaret Peacock',
        InvoicedCost: 104.94,
        ItemCount: 11,
        ChangeLastOrder: 2,
        ItemCost: 10.6,
        OrderCost: 116.6,
        PackageCost: 13.97,
        OrderDate: 1497826800000,
        RequiredDate: 1500246000000,
        ShippedDate: 1498777200000,
        ShipVia: 'United Package',
        Freight: 37.6,
        ShipName: "Trail's Head Gourmet Provisioners",
        ShipAddress: '722 DaVinci Blvd.',
        ShipCity: 'Kirkland',
        ShipRegion: 'WA',
        ShipPostalCode: 98034,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10573,
        CustomerReference: 'ANTON',
        CompanyName: "Antonio Moreno Taquer\xeda",
        ContactName: 'Antonio Moreno',
        Employee: 'Robert King',
        InvoicedCost: 1002.7079999999999,
        ItemCount: 9,
        ChangeLastOrder: -35,
        ItemCost: 96.88,
        OrderCost: 871.92,
        PackageCost: 10.35,
        OrderDate: 1497826800000,
        RequiredDate: 1500246000000,
        ShippedDate: 1497913200000,
        ShipVia: 'Federal Shipping',
        Freight: 84.84,
        ShipName: "Antonio Moreno Taquer\xeda",
        ShipAddress: 'Mataderos  2312',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5023,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10572,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Janet Leverling',
        InvoicedCost: 89.85600000000001,
        ItemCount: 8,
        ChangeLastOrder: -3,
        ItemCost: 12.48,
        OrderCost: 99.84,
        PackageCost: 10.16,
        OrderDate: 1497740400000,
        RequiredDate: 1500159600000,
        ShippedDate: 1498345200000,
        ShipVia: 'United Package',
        Freight: 116.43,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10571,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Laura Callahan',
        InvoicedCost: 603.918,
        ItemCount: 12,
        ChangeLastOrder: 1,
        ItemCost: 47.93,
        OrderCost: 575.16,
        PackageCost: 15.24,
        OrderDate: 1497654000000,
        RequiredDate: 1501282800000,
        ShippedDate: 1499122800000,
        ShipVia: 'Federal Shipping',
        Freight: 26.06,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 1
    },
    {
        OrderId: 10570,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Janet Leverling',
        InvoicedCost: 292.32,
        ItemCount: 14,
        ChangeLastOrder: 2,
        ItemCost: 23.2,
        OrderCost: 324.8,
        PackageCost: 17.78,
        OrderDate: 1497654000000,
        RequiredDate: 1500073200000,
        ShippedDate: 1497826800000,
        ShipVia: 'Federal Shipping',
        Freight: 188.99,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10569,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Steven Buchanan',
        InvoicedCost: 293.475,
        ItemCount: 5,
        ChangeLastOrder: 3,
        ItemCost: 55.9,
        OrderCost: 279.5,
        PackageCost: 2.7,
        OrderDate: 1497567600000,
        RequiredDate: 1499986800000,
        ShippedDate: 1499727600000,
        ShipVia: 'Speedy Express',
        Freight: 58.98,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10568,
        CustomerReference: 'GALED',
        CompanyName: "Galer\xeda del gastr\xf3nomo",
        ContactName: 'Eduardo Saavedra',
        Employee: 'Janet Leverling',
        InvoicedCost: 565.9290000000001,
        ItemCount: 6,
        ChangeLastOrder: 3,
        ItemCost: 89.83,
        OrderCost: 538.98,
        PackageCost: 3.24,
        OrderDate: 1497308400000,
        RequiredDate: 1499727600000,
        ShippedDate: 1499554800000,
        ShipVia: 'Federal Shipping',
        Freight: 6.54,
        ShipName: "Galer\xeda del gastron\xf3mo",
        ShipAddress: "Rambla de Catalu\xf1a, 23",
        ShipCity: 'Barcelona',
        ShipRegion: null,
        ShipPostalCode: 8022,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10567,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Nancy Davolio',
        InvoicedCost: 380.646,
        ItemCount: 7,
        ChangeLastOrder: 1,
        ItemCost: 60.42,
        OrderCost: 422.94,
        PackageCost: 8.89,
        OrderDate: 1497222000000,
        RequiredDate: 1499641200000,
        ShippedDate: 1497654000000,
        ShipVia: 'Speedy Express',
        Freight: 33.97,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10566,
        CustomerReference: 'BLONP',
        CompanyName: "Blondel p\xe8re et fils",
        ContactName: "Fr\xe9d\xe9rique Citeaux",
        Employee: 'Anne Dodsworth',
        InvoicedCost: 92.73599999999999,
        ItemCount: 6,
        ChangeLastOrder: 4,
        ItemCost: 13.44,
        OrderCost: 80.64,
        PackageCost: 3.24,
        OrderDate: 1497222000000,
        RequiredDate: 1499641200000,
        ShippedDate: 1497740400000,
        ShipVia: 'Speedy Express',
        Freight: 88.4,
        ShipName: "Blondel p\xe8re et fils",
        ShipAddress: "24, place Kl\xe9ber",
        ShipCity: 'Strasbourg',
        ShipRegion: null,
        ShipPostalCode: 67000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10565,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Laura Callahan',
        InvoicedCost: 224.28000000000003,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 24.92,
        OrderCost: 249.20000000000002,
        PackageCost: 12.7,
        OrderDate: 1497135600000,
        RequiredDate: 1499554800000,
        ShippedDate: 1497740400000,
        ShipVia: 'United Package',
        Freight: 7.15,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 10564,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Margaret Peacock',
        InvoicedCost: 428.988,
        ItemCount: 8,
        ChangeLastOrder: 3,
        ItemCost: 51.07,
        OrderCost: 408.56,
        PackageCost: 4.32,
        OrderDate: 1497049200000,
        RequiredDate: 1499468400000,
        ShippedDate: 1497567600000,
        ShipVia: 'Federal Shipping',
        Freight: 13.75,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10563,
        CustomerReference: 'RICAR',
        CompanyName: 'Ricardo Adocicados',
        ContactName: 'Janete Limeira',
        Employee: 'Andrew Fuller',
        InvoicedCost: 678.1665,
        ItemCount: 11,
        ChangeLastOrder: -2,
        ItemCost: 53.61,
        OrderCost: 589.71,
        PackageCost: 13.97,
        OrderDate: 1497049200000,
        RequiredDate: 1500678000000,
        ShippedDate: 1498258800000,
        ShipVia: 'United Package',
        Freight: 60.43,
        ShipName: 'Ricardo Adocicados',
        ShipAddress: 'Av. Copacabana, 267',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-890',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10562,
        CustomerReference: 'REGGC',
        CompanyName: 'Reggiani Caseifici',
        ContactName: 'Maurizio Moroni',
        Employee: 'Nancy Davolio',
        InvoicedCost: 574.769,
        ItemCount: 13,
        ChangeLastOrder: -12,
        ItemCost: 46.54,
        OrderCost: 605.02,
        PackageCost: 14.95,
        OrderDate: 1496962800000,
        RequiredDate: 1499382000000,
        ShippedDate: 1497222000000,
        ShipVia: 'Speedy Express',
        Freight: 22.95,
        ShipName: 'Reggiani Caseifici',
        ShipAddress: 'Strada Provinciale 124',
        ShipCity: 'Reggio Emilia',
        ShipRegion: null,
        ShipPostalCode: 42100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10561,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Andrew Fuller',
        InvoicedCost: 637.5600000000001,
        ItemCount: 10,
        ChangeLastOrder: -1,
        ItemCost: 70.84,
        OrderCost: 708.4000000000001,
        PackageCost: 12.7,
        OrderDate: 1496703600000,
        RequiredDate: 1499122800000,
        ShippedDate: 1496962800000,
        ShipVia: 'United Package',
        Freight: 242.21,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10560,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Laura Callahan',
        InvoicedCost: 516.705,
        ItemCount: 7,
        ChangeLastOrder: -3,
        ItemCost: 70.3,
        OrderCost: 492.09999999999997,
        PackageCost: 8.89,
        OrderDate: 1496703600000,
        RequiredDate: 1499122800000,
        ShippedDate: 1496962800000,
        ShipVia: 'Speedy Express',
        Freight: 36.65,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10559,
        CustomerReference: 'BLONP',
        CompanyName: "Blondel p\xe8re et fils",
        ContactName: "Fr\xe9d\xe9rique Citeaux",
        Employee: 'Michael Suyama',
        InvoicedCost: 1021.3149999999999,
        ItemCount: 10,
        ChangeLastOrder: 4,
        ItemCost: 88.81,
        OrderCost: 888.1,
        PackageCost: 5.4,
        OrderDate: 1496617200000,
        RequiredDate: 1499036400000,
        ShippedDate: 1497308400000,
        ShipVia: 'Speedy Express',
        Freight: 8.05,
        ShipName: "Blondel p\xe8re et fils",
        ShipAddress: "24, place Kl\xe9ber",
        ShipCity: 'Strasbourg',
        ShipRegion: null,
        ShipPostalCode: 67000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10558,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Nancy Davolio',
        InvoicedCost: 384.345,
        ItemCount: 9,
        ChangeLastOrder: -4,
        ItemCost: 47.45,
        OrderCost: 427.05,
        PackageCost: 10.35,
        OrderDate: 1496530800000,
        RequiredDate: 1498950000000,
        ShippedDate: 1497049200000,
        ShipVia: 'United Package',
        Freight: 72.97,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10557,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 261.924,
        ItemCount: 6,
        ChangeLastOrder: -17,
        ItemCost: 37.96,
        OrderCost: 227.76,
        PackageCost: 6.8999999999999995,
        OrderDate: 1496444400000,
        RequiredDate: 1497654000000,
        ShippedDate: 1496703600000,
        ShipVia: 'United Package',
        Freight: 96.72,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10556,
        CustomerReference: 'SIMOB',
        CompanyName: 'Simons bistro',
        ContactName: 'Jytte Petersen',
        Employee: 'Andrew Fuller',
        InvoicedCost: 156.7485,
        ItemCount: 9,
        ChangeLastOrder: 6,
        ItemCost: 20.49,
        OrderCost: 184.41,
        PackageCost: 12.429,
        OrderDate: 1496444400000,
        RequiredDate: 1500073200000,
        ShippedDate: 1497308400000,
        ShipVia: 'Speedy Express',
        Freight: 9.8,
        ShipName: 'Simons bistro',
        ShipAddress: "Vinb\xe6ltet 34",
        ShipCity: "K\xf8benhavn",
        ShipRegion: null,
        ShipPostalCode: 1734,
        ShipCountry: 'Denmark',
        ArriveOnTime: 1
    },
    {
        OrderId: 10555,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Michael Suyama',
        InvoicedCost: 554.5260000000001,
        ItemCount: 6,
        ChangeLastOrder: 5,
        ItemCost: 88.02,
        OrderCost: 528.12,
        PackageCost: 3.24,
        OrderDate: 1496358000000,
        RequiredDate: 1498777200000,
        ShippedDate: 1496530800000,
        ShipVia: 'Federal Shipping',
        Freight: 252.49,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10554,
        CustomerReference: 'OTTIK',
        CompanyName: "Ottilies K\xe4seladen",
        ContactName: 'Henriette Pfalzheim',
        Employee: 'Margaret Peacock',
        InvoicedCost: 645.6559999999998,
        ItemCount: 11,
        ChangeLastOrder: 25,
        ItemCost: 51.04,
        OrderCost: 561.4399999999999,
        PackageCost: 15.719000000000001,
        OrderDate: 1496098800000,
        RequiredDate: 1498518000000,
        ShippedDate: 1496617200000,
        ShipVia: 'Federal Shipping',
        Freight: 120.97,
        ShipName: "Ottilies K\xe4seladen",
        ShipAddress: 'Mehrheimerstr. 369',
        ShipCity: "K\xf6ln",
        ShipRegion: null,
        ShipPostalCode: 50739,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10553,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Andrew Fuller',
        InvoicedCost: 382.11600000000004,
        ItemCount: 8,
        ChangeLastOrder: -29,
        ItemCost: 45.49,
        OrderCost: 363.92,
        PackageCost: 9.2,
        OrderDate: 1496098800000,
        RequiredDate: 1498518000000,
        ShippedDate: 1496444400000,
        ShipVia: 'United Package',
        Freight: 149.49,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10552,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Andrew Fuller',
        InvoicedCost: 922.88,
        ItemCount: 10,
        ChangeLastOrder: -5,
        ItemCost: 89.6,
        OrderCost: 896,
        PackageCost: 11.5,
        OrderDate: 1496012400000,
        RequiredDate: 1498431600000,
        ShippedDate: 1496617200000,
        ShipVia: 'Speedy Express',
        Freight: 83.22,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10551,
        CustomerReference: 'FURIB',
        CompanyName: 'Furia Bacalhau e Frutos do Mar',
        ContactName: 'Lino Rodriguez',
        Employee: 'Margaret Peacock',
        InvoicedCost: 230.724,
        ItemCount: 9,
        ChangeLastOrder: 28,
        ItemCost: 30.16,
        OrderCost: 271.44,
        PackageCost: 12.861,
        OrderDate: 1495926000000,
        RequiredDate: 1499554800000,
        ShippedDate: 1496703600000,
        ShipVia: 'Federal Shipping',
        Freight: 72.95,
        ShipName: 'Furia Bacalhau e Frutos do Mar',
        ShipAddress: 'Jardim das rosas n. 32',
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1675,
        ShipCountry: 'Portugal',
        ArriveOnTime: 0
    },
    {
        OrderId: 10550,
        CustomerReference: 'GODOS',
        CompanyName: "Godos Cocina T\xedpica",
        ContactName: "Jos\xe9 Pedro Freyre",
        Employee: 'Robert King',
        InvoicedCost: 749.322,
        ItemCount: 9,
        ChangeLastOrder: -5,
        ItemCost: 87.64,
        OrderCost: 788.76,
        PackageCost: 10.35,
        OrderDate: 1495926000000,
        RequiredDate: 1498345200000,
        ShippedDate: 1496703600000,
        ShipVia: 'Federal Shipping',
        Freight: 4.32,
        ShipName: "Godos Cocina T\xedpica",
        ShipAddress: 'C/ Romero, 33',
        ShipCity: 'Sevilla',
        ShipRegion: null,
        ShipPostalCode: 41101,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10549,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Steven Buchanan',
        InvoicedCost: 603.2125,
        ItemCount: 11,
        ChangeLastOrder: -11,
        ItemCost: 43.87,
        OrderCost: 482.57,
        PackageCost: 12.649999999999999,
        OrderDate: 1495839600000,
        RequiredDate: 1497049200000,
        ShippedDate: 1496098800000,
        ShipVia: 'Speedy Express',
        Freight: 171.24,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10548,
        CustomerReference: 'TOMSP',
        CompanyName: "Toms Spezialit\xe4ten",
        ContactName: 'Karin Josephs',
        Employee: 'Janet Leverling',
        InvoicedCost: 607.5355,
        ItemCount: 11,
        ChangeLastOrder: -15,
        ItemCost: 38.09,
        OrderCost: 418.99,
        PackageCost: 12.649999999999999,
        OrderDate: 1495753200000,
        RequiredDate: 1498172400000,
        ShippedDate: 1496358000000,
        ShipVia: 'United Package',
        Freight: 1.43,
        ShipName: "Toms Spezialit\xe4ten",
        ShipAddress: 'Luisenstr. 48',
        ShipCity: "M\xfcnster",
        ShipRegion: null,
        ShipPostalCode: 44087,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10547,
        CustomerReference: 'SEVES',
        CompanyName: 'Seven Seas Imports',
        ContactName: 'Hari Kumar',
        Employee: 'Janet Leverling',
        InvoicedCost: 1022.4900000000001,
        ItemCount: 14,
        ChangeLastOrder: 0,
        ItemCost: 81.15,
        OrderCost: 1136.1000000000001,
        PackageCost: 17.78,
        OrderDate: 1495494000000,
        RequiredDate: 1497913200000,
        ShippedDate: 1496358000000,
        ShipVia: 'United Package',
        Freight: 178.43,
        ShipName: 'Seven Seas Imports',
        ShipAddress: '90 Wadhurst Rd.',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'OX15 4NB',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10546,
        CustomerReference: 'VICTE',
        CompanyName: 'Victuailles en stock',
        ContactName: 'Mary Saveley',
        Employee: 'Nancy Davolio',
        InvoicedCost: 431.94,
        ItemCount: 5,
        ChangeLastOrder: 5,
        ItemCost: 75.12,
        OrderCost: 375.6,
        PackageCost: 2.7,
        OrderDate: 1495494000000,
        RequiredDate: 1497913200000,
        ShippedDate: 1495839600000,
        ShipVia: 'Federal Shipping',
        Freight: 194.72,
        ShipName: 'Victuailles en stock',
        ShipAddress: '2, rue du Commerce',
        ShipCity: 'Lyon',
        ShipRegion: null,
        ShipPostalCode: 69004,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10545,
        CustomerReference: 'LAZYK',
        CompanyName: 'Lazy K Kountry Store',
        ContactName: 'John Steel',
        Employee: 'Laura Callahan',
        InvoicedCost: 267.687,
        ItemCount: 7,
        ChangeLastOrder: 6,
        ItemCost: 42.49,
        OrderCost: 297.43,
        PackageCost: 9.667,
        OrderDate: 1495407600000,
        RequiredDate: 1497826800000,
        ShippedDate: 1498431600000,
        ShipVia: 'United Package',
        Freight: 11.92,
        ShipName: 'Lazy K Kountry Store',
        ShipAddress: '12 Orchestra Terrace',
        ShipCity: 'Walla Walla',
        ShipRegion: 'WA',
        ShipPostalCode: 99362,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10544,
        CustomerReference: 'LONEP',
        CompanyName: 'Lonesome Pine Restaurant',
        ContactName: 'Fran Wilson',
        Employee: 'Margaret Peacock',
        InvoicedCost: 560.7,
        ItemCount: 12,
        ChangeLastOrder: 1,
        ItemCost: 44.5,
        OrderCost: 534,
        PackageCost: 15.24,
        OrderDate: 1495321200000,
        RequiredDate: 1497740400000,
        ShippedDate: 1496098800000,
        ShipVia: 'Speedy Express',
        Freight: 24.91,
        ShipName: 'Lonesome Pine Restaurant',
        ShipAddress: '89 Chiaroscuro Rd.',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97219,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10543,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Laura Callahan',
        InvoicedCost: 452.34450000000004,
        ItemCount: 9,
        ChangeLastOrder: 10,
        ItemCost: 59.13,
        OrderCost: 532.1700000000001,
        PackageCost: 12.861,
        OrderDate: 1495321200000,
        RequiredDate: 1497740400000,
        ShippedDate: 1495494000000,
        ShipVia: 'United Package',
        Freight: 48.17,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10542,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Nancy Davolio',
        InvoicedCost: 4.5815,
        ItemCount: 7,
        ChangeLastOrder: 31,
        ItemCost: 0.77,
        OrderCost: 5.390000000000001,
        PackageCost: 10.003,
        OrderDate: 1495234800000,
        RequiredDate: 1497654000000,
        ShippedDate: 1495753200000,
        ShipVia: 'Federal Shipping',
        Freight: 10.95,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10541,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Andrew Fuller',
        InvoicedCost: 178.67,
        ItemCount: 10,
        ChangeLastOrder: -27,
        ItemCost: 21.02,
        OrderCost: 210.2,
        PackageCost: 11.5,
        OrderDate: 1495148400000,
        RequiredDate: 1497567600000,
        ShippedDate: 1496012400000,
        ShipVia: 'Speedy Express',
        Freight: 68.65,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10540,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Janet Leverling',
        InvoicedCost: 97.4375,
        ItemCount: 5,
        ChangeLastOrder: -15,
        ItemCost: 15.59,
        OrderCost: 77.95,
        PackageCost: 5.75,
        OrderDate: 1495148400000,
        RequiredDate: 1497567600000,
        ShippedDate: 1497308400000,
        ShipVia: 'Federal Shipping',
        Freight: 1007.64,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10539,
        CustomerReference: 'BSBEV',
        CompanyName: "B's Beverages",
        ContactName: 'Victoria Ashworth',
        Employee: 'Michael Suyama',
        InvoicedCost: 579.852,
        ItemCount: 12,
        ChangeLastOrder: 24,
        ItemCost: 53.69,
        OrderCost: 644.28,
        PackageCost: 17.148,
        OrderDate: 1494889200000,
        RequiredDate: 1497308400000,
        ShippedDate: 1495494000000,
        ShipVia: 'Federal Shipping',
        Freight: 12.36,
        ShipName: "B's Beverages",
        ShipAddress: 'Fauntleroy Circus',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'EC2 5NT',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10538,
        CustomerReference: 'BSBEV',
        CompanyName: "B's Beverages",
        ContactName: 'Victoria Ashworth',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 698.841,
        ItemCount: 11,
        ChangeLastOrder: 23,
        ItemCost: 70.59,
        OrderCost: 776.49,
        PackageCost: 15.719000000000001,
        OrderDate: 1494802800000,
        RequiredDate: 1497222000000,
        ShippedDate: 1494889200000,
        ShipVia: 'Federal Shipping',
        Freight: 4.87,
        ShipName: "B's Beverages",
        ShipAddress: 'Fauntleroy Circus',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'EC2 5NT',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10537,
        CustomerReference: 'RICSU',
        CompanyName: 'Richter Supermarkt',
        ContactName: 'Michael Holz',
        Employee: 'Nancy Davolio',
        InvoicedCost: 288.1075,
        ItemCount: 5,
        ChangeLastOrder: 0,
        ItemCost: 67.79,
        OrderCost: 338.95000000000005,
        PackageCost: 6.35,
        OrderDate: 1494716400000,
        RequiredDate: 1495926000000,
        ShippedDate: 1495148400000,
        ShipVia: 'Speedy Express',
        Freight: 78.85,
        ShipName: 'Richter Supermarkt',
        ShipAddress: 'Starenweg 5',
        ShipCity: "Gen\xe8ve",
        ShipRegion: null,
        ShipPostalCode: 1204,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10536,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Janet Leverling',
        InvoicedCost: 188.43899999999996,
        ItemCount: 6,
        ChangeLastOrder: -16,
        ItemCost: 27.31,
        OrderCost: 163.85999999999999,
        PackageCost: 6.8999999999999995,
        OrderDate: 1494716400000,
        RequiredDate: 1497135600000,
        ShippedDate: 1496703600000,
        ShipVia: 'United Package',
        Freight: 58.88,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10535,
        CustomerReference: 'ANTON',
        CompanyName: "Antonio Moreno Taquer\xeda",
        ContactName: 'Antonio Moreno',
        Employee: 'Margaret Peacock',
        InvoicedCost: 755.4119999999999,
        ItemCount: 8,
        ChangeLastOrder: -34,
        ItemCost: 82.11,
        OrderCost: 656.88,
        PackageCost: 9.2,
        OrderDate: 1494630000000,
        RequiredDate: 1497049200000,
        ShippedDate: 1495321200000,
        ShipVia: 'Speedy Express',
        Freight: 15.64,
        ShipName: "Antonio Moreno Taquer\xeda",
        ShipAddress: 'Mataderos  2312',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5023,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10534,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Laura Callahan',
        InvoicedCost: 292.62899999999996,
        ItemCount: 6,
        ChangeLastOrder: -19,
        ItemCost: 42.41,
        OrderCost: 254.45999999999998,
        PackageCost: 6.8999999999999995,
        OrderDate: 1494543600000,
        RequiredDate: 1496962800000,
        ShippedDate: 1494716400000,
        ShipVia: 'United Package',
        Freight: 27.94,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10533,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Laura Callahan',
        InvoicedCost: 176.499,
        ItemCount: 9,
        ChangeLastOrder: -1,
        ItemCost: 21.79,
        OrderCost: 196.10999999999999,
        PackageCost: 11.43,
        OrderDate: 1494543600000,
        RequiredDate: 1496962800000,
        ShippedDate: 1495407600000,
        ShipVia: 'Speedy Express',
        Freight: 188.04,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10532,
        CustomerReference: 'EASTC',
        CompanyName: 'Eastern Connection',
        ContactName: 'Ann Devon',
        Employee: 'Robert King',
        InvoicedCost: 50.22,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 5.58,
        OrderCost: 55.8,
        PackageCost: 12.7,
        OrderDate: 1494284400000,
        RequiredDate: 1496703600000,
        ShippedDate: 1494543600000,
        ShipVia: 'Federal Shipping',
        Freight: 74.46,
        ShipName: 'Eastern Connection',
        ShipAddress: '35 King George',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'WX3 6FW',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10531,
        CustomerReference: 'OCEAN',
        CompanyName: "Oc\xe9ano Atl\xe1ntico Ltda.",
        ContactName: 'Yvonne Moncada',
        Employee: 'Robert King',
        InvoicedCost: 644.9799999999999,
        ItemCount: 8,
        ChangeLastOrder: -26,
        ItemCost: 94.85,
        OrderCost: 758.8,
        PackageCost: 9.2,
        OrderDate: 1494198000000,
        RequiredDate: 1496617200000,
        ShippedDate: 1495148400000,
        ShipVia: 'Speedy Express',
        Freight: 8.12,
        ShipName: "Oc\xe9ano Atl\xe1ntico Ltda.",
        ShipAddress: 'Ing. Gustavo Moncada 8585, Piso 20-A',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 1
    },
    {
        OrderId: 10530,
        CustomerReference: 'PICCO',
        CompanyName: 'Piccolo und mehr',
        ContactName: 'Georg Pipps',
        Employee: 'Janet Leverling',
        InvoicedCost: 824.5356,
        ItemCount: 12,
        ChangeLastOrder: 2,
        ItemCost: 66.71,
        OrderCost: 800.52,
        PackageCost: 15.24,
        OrderDate: 1494198000000,
        RequiredDate: 1496617200000,
        ShippedDate: 1494543600000,
        ShipVia: 'United Package',
        Freight: 339.22,
        ShipName: 'Piccolo und mehr',
        ShipAddress: 'Geislweg 14',
        ShipCity: 'Salzburg',
        ShipRegion: null,
        ShipPostalCode: 5020,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10529,
        CustomerReference: 'MAISD',
        CompanyName: 'Maison Dewey',
        ContactName: 'Catherine Dewey',
        Employee: 'Steven Buchanan',
        InvoicedCost: 955.548,
        ItemCount: 11,
        ChangeLastOrder: 21,
        ItemCost: 96.52,
        OrderCost: 1061.72,
        PackageCost: 15.719000000000001,
        OrderDate: 1494111600000,
        RequiredDate: 1496530800000,
        ShippedDate: 1494284400000,
        ShipVia: 'United Package',
        Freight: 66.69,
        ShipName: 'Maison Dewey',
        ShipAddress: 'Rue Joseph-Bens 532',
        ShipCity: 'Bruxelles',
        ShipRegion: null,
        ShipPostalCode: 'B-1180',
        ShipCountry: 'Belgium',
        ArriveOnTime: 0
    },
    {
        OrderId: 10528,
        CustomerReference: 'GREAL',
        CompanyName: 'Great Lakes Food Market',
        ContactName: 'Howard Snyder',
        Employee: 'Michael Suyama',
        InvoicedCost: 169.55999999999997,
        ItemCount: 6,
        ChangeLastOrder: 3,
        ItemCost: 31.4,
        OrderCost: 188.39999999999998,
        PackageCost: 3.24,
        OrderDate: 1494025200000,
        RequiredDate: 1495234800000,
        ShippedDate: 1494284400000,
        ShipVia: 'United Package',
        Freight: 3.35,
        ShipName: 'Great Lakes Food Market',
        ShipAddress: '2732 Baker Blvd.',
        ShipCity: 'Eugene',
        ShipRegion: 'OR',
        ShipPostalCode: 97403,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10527,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Robert King',
        InvoicedCost: 354.9875,
        ItemCount: 7,
        ChangeLastOrder: -1,
        ItemCost: 40.57,
        OrderCost: 283.99,
        PackageCost: 8.89,
        OrderDate: 1493938800000,
        RequiredDate: 1496358000000,
        ShippedDate: 1494111600000,
        ShipVia: 'Speedy Express',
        Freight: 41.9,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10526,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1345.785,
        ItemCount: 14,
        ChangeLastOrder: 35,
        ItemCost: 91.55,
        OrderCost: 1281.7,
        PackageCost: 20.006,
        OrderDate: 1493938800000,
        RequiredDate: 1496358000000,
        ShippedDate: 1494802800000,
        ShipVia: 'United Package',
        Freight: 58.59,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10525,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Nancy Davolio',
        InvoicedCost: 289.3995,
        ItemCount: 13,
        ChangeLastOrder: 5,
        ItemCost: 26.19,
        OrderCost: 340.47,
        PackageCost: 7.0200000000000005,
        OrderDate: 1493679600000,
        RequiredDate: 1496098800000,
        ShippedDate: 1495494000000,
        ShipVia: 'United Package',
        Freight: 11.06,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10524,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Nancy Davolio',
        InvoicedCost: 492.984,
        ItemCount: 8,
        ChangeLastOrder: -3,
        ItemCost: 68.47,
        OrderCost: 547.76,
        PackageCost: 10.16,
        OrderDate: 1493593200000,
        RequiredDate: 1496012400000,
        ShippedDate: 1494111600000,
        ShipVia: 'United Package',
        Freight: 244.79,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10523,
        CustomerReference: 'SEVES',
        CompanyName: 'Seven Seas Imports',
        ContactName: 'Hari Kumar',
        Employee: 'Robert King',
        InvoicedCost: 628.3439999999999,
        ItemCount: 8,
        ChangeLastOrder: 0,
        ItemCost: 87.27,
        OrderCost: 698.16,
        PackageCost: 10.16,
        OrderDate: 1493593200000,
        RequiredDate: 1496012400000,
        ShippedDate: 1496098800000,
        ShipVia: 'United Package',
        Freight: 77.63,
        ShipName: 'Seven Seas Imports',
        ShipAddress: '90 Wadhurst Rd.',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'OX15 4NB',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10522,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Margaret Peacock',
        InvoicedCost: 590.0649999999999,
        ItemCount: 10,
        ChangeLastOrder: -23,
        ItemCost: 51.31,
        OrderCost: 513.1,
        PackageCost: 11.5,
        OrderDate: 1493506800000,
        RequiredDate: 1495926000000,
        ShippedDate: 1494025200000,
        ShipVia: 'Speedy Express',
        Freight: 45.33,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10521,
        CustomerReference: 'CACTU',
        CompanyName: 'Cactus Comidas para llevar',
        ContactName: 'Patricio Simpson',
        Employee: 'Laura Callahan',
        InvoicedCost: 580.278,
        ItemCount: 12,
        ChangeLastOrder: 1,
        ItemCost: 56.89,
        OrderCost: 682.6800000000001,
        PackageCost: 15.24,
        OrderDate: 1493420400000,
        RequiredDate: 1495839600000,
        ShippedDate: 1493679600000,
        ShipVia: 'United Package',
        Freight: 17.22,
        ShipName: 'Cactus Comidas para llevar',
        ShipAddress: 'Cerrito 333',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 1
    },
    {
        OrderId: 10520,
        CustomerReference: 'SANTG',
        CompanyName: "Sant\xe9 Gourmet",
        ContactName: 'Jonas Bergulfsen',
        Employee: 'Robert King',
        InvoicedCost: 43.739999999999995,
        ItemCount: 12,
        ChangeLastOrder: -10,
        ItemCost: 8.1,
        OrderCost: 97.19999999999999,
        PackageCost: 13.799999999999999,
        OrderDate: 1493420400000,
        RequiredDate: 1495839600000,
        ShippedDate: 1493593200000,
        ShipVia: 'Speedy Express',
        Freight: 13.37,
        ShipName: "Sant\xe9 Gourmet",
        ShipAddress: 'Erling Skakkes gate 78',
        ShipCity: 'Stavern',
        ShipRegion: null,
        ShipPostalCode: 4110,
        ShipCountry: 'Norway',
        ArriveOnTime: 1
    },
    {
        OrderId: 10519,
        CustomerReference: 'CHOPS',
        CompanyName: 'Chop-suey Chinese',
        ContactName: 'Yang Wang',
        Employee: 'Michael Suyama',
        InvoicedCost: 749.5215,
        ItemCount: 13,
        ChangeLastOrder: -14,
        ItemCost: 67.83,
        OrderCost: 881.79,
        PackageCost: 14.95,
        OrderDate: 1493334000000,
        RequiredDate: 1495753200000,
        ShippedDate: 1493593200000,
        ShipVia: 'Federal Shipping',
        Freight: 91.76,
        ShipName: 'Chop-suey Chinese',
        ShipAddress: 'Hauptstr. 31',
        ShipCity: 'Bern',
        ShipRegion: null,
        ShipPostalCode: 3012,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10518,
        CustomerReference: 'TORTU',
        CompanyName: 'Tortuga Restaurante',
        ContactName: 'Miguel Angel Paolino',
        Employee: 'Margaret Peacock',
        InvoicedCost: 351.34799999999996,
        ItemCount: 12,
        ChangeLastOrder: -3,
        ItemCost: 25.46,
        OrderCost: 305.52,
        PackageCost: 15.24,
        OrderDate: 1493074800000,
        RequiredDate: 1494284400000,
        ShippedDate: 1493938800000,
        ShipVia: 'United Package',
        Freight: 218.15,
        ShipName: 'Tortuga Restaurante',
        ShipAddress: 'Avda. Azteca 123',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10517,
        CustomerReference: 'NORTS',
        CompanyName: 'North/South',
        ContactName: 'Simon Crowther',
        Employee: 'Janet Leverling',
        InvoicedCost: 625.0229999999999,
        ItemCount: 7,
        ChangeLastOrder: 6,
        ItemCost: 99.21,
        OrderCost: 694.4699999999999,
        PackageCost: 9.667,
        OrderDate: 1492988400000,
        RequiredDate: 1495407600000,
        ShippedDate: 1493420400000,
        ShipVia: 'Federal Shipping',
        Freight: 32.07,
        ShipName: 'North/South',
        ShipAddress: 'South House, 300 Queensbridge',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'SW7 1RZ',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10516,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Andrew Fuller',
        InvoicedCost: 679.536,
        ItemCount: 12,
        ChangeLastOrder: 1,
        ItemCost: 62.92,
        OrderCost: 755.04,
        PackageCost: 15.24,
        OrderDate: 1492988400000,
        RequiredDate: 1495407600000,
        ShippedDate: 1493593200000,
        ShipVia: 'Federal Shipping',
        Freight: 62.78,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10515,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Andrew Fuller',
        InvoicedCost: 858.9,
        ItemCount: 14,
        ChangeLastOrder: -19,
        ItemCost: 49.08,
        OrderCost: 687.12,
        PackageCost: 16.099999999999998,
        OrderDate: 1492902000000,
        RequiredDate: 1494111600000,
        ShippedDate: 1495494000000,
        ShipVia: 'Speedy Express',
        Freight: 204.47,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10514,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Janet Leverling',
        InvoicedCost: 553.0875,
        ItemCount: 7,
        ChangeLastOrder: 4,
        ItemCost: 75.25,
        OrderCost: 526.75,
        PackageCost: 3.7800000000000002,
        OrderDate: 1492815600000,
        RequiredDate: 1495234800000,
        ShippedDate: 1494889200000,
        ShipVia: 'United Package',
        Freight: 789.95,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10513,
        CustomerReference: 'WANDK',
        CompanyName: 'Die Wandernde Kuh',
        ContactName: "Rita M\xfcller",
        Employee: 'Robert King',
        InvoicedCost: 802.3050000000001,
        ItemCount: 9,
        ChangeLastOrder: 0,
        ItemCost: 84.9,
        OrderCost: 764.1,
        PackageCost: 11.43,
        OrderDate: 1492815600000,
        RequiredDate: 1496444400000,
        ShippedDate: 1493334000000,
        ShipVia: 'Speedy Express',
        Freight: 105.65,
        ShipName: 'Die Wandernde Kuh',
        ShipAddress: 'Adenauerallee 900',
        ShipCity: 'Stuttgart',
        ShipRegion: null,
        ShipPostalCode: 70563,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10512,
        CustomerReference: 'FAMIA',
        CompanyName: 'Familia Arquibaldo',
        ContactName: 'Aria Cruz',
        Employee: 'Robert King',
        InvoicedCost: 340.221,
        ItemCount: 7,
        ChangeLastOrder: -34,
        ItemCost: 57.18,
        OrderCost: 400.26,
        PackageCost: 8.049999999999999,
        OrderDate: 1492729200000,
        RequiredDate: 1495148400000,
        ShippedDate: 1492988400000,
        ShipVia: 'United Package',
        Freight: 3.53,
        ShipName: 'Familia Arquibaldo',
        ShipAddress: "Rua Or\xf3s, 92",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05442-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10511,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Margaret Peacock',
        InvoicedCost: 583.508,
        ItemCount: 8,
        ChangeLastOrder: 6,
        ItemCost: 85.81,
        OrderCost: 686.48,
        PackageCost: 11.048,
        OrderDate: 1492470000000,
        RequiredDate: 1494889200000,
        ShippedDate: 1492729200000,
        ShipVia: 'Federal Shipping',
        Freight: 350.64,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10510,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Michael Suyama',
        InvoicedCost: 599.2560000000001,
        ItemCount: 6,
        ChangeLastOrder: 5,
        ItemCost: 95.12,
        OrderCost: 570.72,
        PackageCost: 3.24,
        OrderDate: 1492470000000,
        RequiredDate: 1494889200000,
        ShippedDate: 1493334000000,
        ShipVia: 'Federal Shipping',
        Freight: 367.63,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10509,
        CustomerReference: 'BLAUS',
        CompanyName: 'Blauer See Delikatessen',
        ContactName: 'Hanna Moos',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1086.0024999999998,
        ItemCount: 11,
        ChangeLastOrder: 15,
        ItemCost: 85.85,
        OrderCost: 944.3499999999999,
        PackageCost: 15.719000000000001,
        OrderDate: 1492383600000,
        RequiredDate: 1494802800000,
        ShippedDate: 1493420400000,
        ShipVia: 'Speedy Express',
        Freight: 0.15,
        ShipName: 'Blauer See Delikatessen',
        ShipAddress: 'Forsterstr. 57',
        ShipCity: 'Mannheim',
        ShipRegion: null,
        ShipPostalCode: 68306,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10508,
        CustomerReference: 'OTTIK',
        CompanyName: "Ottilies K\xe4seladen",
        ContactName: 'Henriette Pfalzheim',
        Employee: 'Nancy Davolio',
        InvoicedCost: 714.978,
        ItemCount: 11,
        ChangeLastOrder: 24,
        ItemCost: 56.52,
        OrderCost: 621.72,
        PackageCost: 15.719000000000001,
        OrderDate: 1492297200000,
        RequiredDate: 1494716400000,
        ShippedDate: 1494630000000,
        ShipVia: 'United Package',
        Freight: 4.99,
        ShipName: "Ottilies K\xe4seladen",
        ShipAddress: 'Mehrheimerstr. 369',
        ShipCity: "K\xf6ln",
        ShipRegion: null,
        ShipPostalCode: 50739,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10507,
        CustomerReference: 'ANTON',
        CompanyName: "Antonio Moreno Taquer\xeda",
        ContactName: 'Antonio Moreno',
        Employee: 'Robert King',
        InvoicedCost: 1481.6945,
        ItemCount: 13,
        ChangeLastOrder: -36,
        ItemCost: 99.11,
        OrderCost: 1288.43,
        PackageCost: 14.95,
        OrderDate: 1492210800000,
        RequiredDate: 1494630000000,
        ShippedDate: 1492815600000,
        ShipVia: 'Speedy Express',
        Freight: 47.45,
        ShipName: "Antonio Moreno Taquer\xeda",
        ShipAddress: 'Mataderos  2312',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5023,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10506,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 370.98249999999996,
        ItemCount: 7,
        ChangeLastOrder: 34,
        ItemCost: 62.35,
        OrderCost: 436.45,
        PackageCost: 10.003,
        OrderDate: 1492210800000,
        RequiredDate: 1494630000000,
        ShippedDate: 1493679600000,
        ShipVia: 'United Package',
        Freight: 21.19,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10505,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Janet Leverling',
        InvoicedCost: 516.7890000000001,
        ItemCount: 7,
        ChangeLastOrder: 2,
        ItemCost: 82.03,
        OrderCost: 574.21,
        PackageCost: 8.89,
        OrderDate: 1492124400000,
        RequiredDate: 1494543600000,
        ShippedDate: 1492729200000,
        ShipVia: 'Federal Shipping',
        Freight: 7.13,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 10504,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Margaret Peacock',
        InvoicedCost: 528.1200000000001,
        ItemCount: 9,
        ChangeLastOrder: 6,
        ItemCost: 65.2,
        OrderCost: 586.8000000000001,
        PackageCost: 12.429,
        OrderDate: 1491865200000,
        RequiredDate: 1494284400000,
        ShippedDate: 1492470000000,
        ShipVia: 'Federal Shipping',
        Freight: 59.13,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10503,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Michael Suyama',
        InvoicedCost: 532.089,
        ItemCount: 9,
        ChangeLastOrder: 1,
        ItemCost: 65.69,
        OrderCost: 591.21,
        PackageCost: 11.43,
        OrderDate: 1491865200000,
        RequiredDate: 1494284400000,
        ShippedDate: 1492297200000,
        ShipVia: 'United Package',
        Freight: 16.74,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10502,
        CustomerReference: 'PERIC',
        CompanyName: "Pericles Comidas cl\xe1sicas",
        ContactName: "Guillermo Fern\xe1ndez",
        Employee: 'Andrew Fuller',
        InvoicedCost: 245.364,
        ItemCount: 6,
        ChangeLastOrder: -5,
        ItemCost: 35.56,
        OrderCost: 213.36,
        PackageCost: 6.8999999999999995,
        OrderDate: 1491778800000,
        RequiredDate: 1494198000000,
        ShippedDate: 1493420400000,
        ShipVia: 'Speedy Express',
        Freight: 69.32,
        ShipName: "Pericles Comidas cl\xe1sicas",
        ShipAddress: 'Calle Dr. Jorge Cash 321',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10501,
        CustomerReference: 'BLAUS',
        CompanyName: 'Blauer See Delikatessen',
        ContactName: 'Hanna Moos',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 569.02,
        ItemCount: 8,
        ChangeLastOrder: 17,
        ItemCost: 61.85,
        OrderCost: 494.8,
        PackageCost: 11.432,
        OrderDate: 1491692400000,
        RequiredDate: 1494111600000,
        ShippedDate: 1492297200000,
        ShipVia: 'Federal Shipping',
        Freight: 8.85,
        ShipName: 'Blauer See Delikatessen',
        ShipAddress: 'Forsterstr. 57',
        ShipCity: 'Mannheim',
        ShipRegion: null,
        ShipPostalCode: 68306,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10500,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Michael Suyama',
        InvoicedCost: 569.7719999999999,
        ItemCount: 12,
        ChangeLastOrder: 6,
        ItemCost: 55.86,
        OrderCost: 670.3199999999999,
        PackageCost: 16.572,
        OrderDate: 1491692400000,
        RequiredDate: 1494111600000,
        ShippedDate: 1492383600000,
        ShipVia: 'Speedy Express',
        Freight: 42.68,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10499,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Margaret Peacock',
        InvoicedCost: 833.68,
        ItemCount: 10,
        ChangeLastOrder: 14,
        ItemCost: 98.08,
        OrderCost: 980.8,
        PackageCost: 14.290000000000001,
        OrderDate: 1491606000000,
        RequiredDate: 1494025200000,
        ShippedDate: 1492297200000,
        ShipVia: 'United Package',
        Freight: 102.02,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10498,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Laura Callahan',
        InvoicedCost: 645.3774000000001,
        ItemCount: 9,
        ChangeLastOrder: -5,
        ItemCost: 69.62,
        OrderCost: 626.58,
        PackageCost: 10.35,
        OrderDate: 1491519600000,
        RequiredDate: 1493938800000,
        ShippedDate: 1491865200000,
        ShipVia: 'United Package',
        Freight: 29.75,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10497,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Robert King',
        InvoicedCost: 1086.06,
        ItemCount: 10,
        ChangeLastOrder: -28,
        ItemCost: 94.44,
        OrderCost: 944.4,
        PackageCost: 11.5,
        OrderDate: 1491260400000,
        RequiredDate: 1493679600000,
        ShippedDate: 1491519600000,
        ShipVia: 'Speedy Express',
        Freight: 36.21,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10496,
        CustomerReference: 'TRADH',
        CompanyName: "Tradi\xe7\xe3o Hipermercados",
        ContactName: 'Anabela Domingues',
        Employee: 'Robert King',
        InvoicedCost: 373.218,
        ItemCount: 6,
        ChangeLastOrder: -3,
        ItemCost: 73.18,
        OrderCost: 439.08000000000004,
        PackageCost: 7.62,
        OrderDate: 1491260400000,
        RequiredDate: 1493679600000,
        ShippedDate: 1491519600000,
        ShipVia: 'United Package',
        Freight: 46.77,
        ShipName: "Tradi\xe7\xe3o Hipermercados",
        ShipAddress: "Av. In\xeas de Castro, 414",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05634-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10495,
        CustomerReference: 'LAUGB',
        CompanyName: 'Laughing Bacchus Wine Cellars',
        ContactName: 'Yoshi Tannamuri',
        Employee: 'Janet Leverling',
        InvoicedCost: 75.16799999999999,
        ItemCount: 9,
        ChangeLastOrder: 4,
        ItemCost: 9.28,
        OrderCost: 83.52,
        PackageCost: 4.86,
        OrderDate: 1491174000000,
        RequiredDate: 1493593200000,
        ShippedDate: 1491865200000,
        ShipVia: 'Federal Shipping',
        Freight: 4.65,
        ShipName: 'Laughing Bacchus Wine Cellars',
        ShipAddress: '2319 Elm St.',
        ShipCity: 'Vancouver',
        ShipRegion: 'BC',
        ShipPostalCode: 'V3F 2K1',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 10494,
        CustomerReference: 'COMMI',
        CompanyName: "Com\xe9rcio Mineiro",
        ContactName: 'Pedro Afonso',
        Employee: 'Laura Callahan',
        InvoicedCost: 604.945,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 64.7,
        OrderCost: 711.7,
        PackageCost: 13.97,
        OrderDate: 1491087600000,
        RequiredDate: 1493506800000,
        ShippedDate: 1491692400000,
        ShipVia: 'United Package',
        Freight: 65.99,
        ShipName: "Com\xe9rcio Mineiro",
        ShipAddress: "Av. dos Lus\xedadas, 23",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05432-043',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10493,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Margaret Peacock',
        InvoicedCost: 235.365,
        ItemCount: 10,
        ChangeLastOrder: 6,
        ItemCost: 27.69,
        OrderCost: 276.90000000000003,
        PackageCost: 13.81,
        OrderDate: 1491087600000,
        RequiredDate: 1493506800000,
        ShippedDate: 1491778800000,
        ShipVia: 'Federal Shipping',
        Freight: 10.64,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10492,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Janet Leverling',
        InvoicedCost: 901.836,
        ItemCount: 13,
        ChangeLastOrder: 4,
        ItemCost: 77.08,
        OrderCost: 1002.04,
        PackageCost: 7.0200000000000005,
        OrderDate: 1491001200000,
        RequiredDate: 1493420400000,
        ShippedDate: 1491865200000,
        ShipVia: 'Speedy Express',
        Freight: 62.89,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10491,
        CustomerReference: 'FURIB',
        CompanyName: 'Furia Bacalhau e Frutos do Mar',
        ContactName: 'Lino Rodriguez',
        Employee: 'Laura Callahan',
        InvoicedCost: 69.5725,
        ItemCount: 5,
        ChangeLastOrder: 26,
        ItemCost: 16.37,
        OrderCost: 81.85000000000001,
        PackageCost: 7.1450000000000005,
        OrderDate: 1490914800000,
        RequiredDate: 1493334000000,
        ShippedDate: 1491606000000,
        ShipVia: 'Federal Shipping',
        Freight: 16.96,
        ShipName: 'Furia Bacalhau e Frutos do Mar',
        ShipAddress: 'Jardim das rosas n. 32',
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1675,
        ShipCountry: 'Portugal',
        ArriveOnTime: 1
    },
    {
        OrderId: 10490,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Robert King',
        InvoicedCost: 222.9955,
        ItemCount: 7,
        ChangeLastOrder: -5,
        ItemCost: 21.97,
        OrderCost: 153.79,
        PackageCost: 8.049999999999999,
        OrderDate: 1490914800000,
        RequiredDate: 1493334000000,
        ShippedDate: 1491174000000,
        ShipVia: 'United Package',
        Freight: 210.19,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10489,
        CustomerReference: 'PICCO',
        CompanyName: 'Piccolo und mehr',
        ContactName: 'Georg Pipps',
        Employee: 'Michael Suyama',
        InvoicedCost: 228.28799999999998,
        ItemCount: 6,
        ChangeLastOrder: -5,
        ItemCost: 26.24,
        OrderCost: 157.44,
        PackageCost: 6.8999999999999995,
        OrderDate: 1490655600000,
        RequiredDate: 1493074800000,
        ShippedDate: 1491692400000,
        ShipVia: 'United Package',
        Freight: 5.29,
        ShipName: 'Piccolo und mehr',
        ShipAddress: 'Geislweg 14',
        ShipCity: 'Salzburg',
        ShipRegion: null,
        ShipPostalCode: 5020,
        ShipCountry: 'Austria',
        ArriveOnTime: 1
    },
    {
        OrderId: 10488,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Laura Callahan',
        InvoicedCost: 371.511,
        ItemCount: 6,
        ChangeLastOrder: -3,
        ItemCost: 58.97,
        OrderCost: 353.82,
        PackageCost: 7.62,
        OrderDate: 1490569200000,
        RequiredDate: 1492988400000,
        ShippedDate: 1491087600000,
        ShipVia: 'United Package',
        Freight: 4.93,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10487,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Andrew Fuller',
        InvoicedCost: 578.204,
        ItemCount: 8,
        ChangeLastOrder: -2,
        ItemCost: 85.03,
        OrderCost: 680.24,
        PackageCost: 10.16,
        OrderDate: 1490482800000,
        RequiredDate: 1492902000000,
        ShippedDate: 1490655600000,
        ShipVia: 'United Package',
        Freight: 71.07,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10486,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Nancy Davolio',
        InvoicedCost: 371.2,
        ItemCount: 8,
        ChangeLastOrder: -5,
        ItemCost: 32,
        OrderCost: 256,
        PackageCost: 9.2,
        OrderDate: 1490482800000,
        RequiredDate: 1492902000000,
        ShippedDate: 1491087600000,
        ShipVia: 'United Package',
        Freight: 30.53,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10485,
        CustomerReference: 'LINOD',
        CompanyName: 'LINO-Delicateses',
        ContactName: 'Felipe Izquierdo',
        Employee: 'Margaret Peacock',
        InvoicedCost: 494.1734,
        ItemCount: 7,
        ChangeLastOrder: -3,
        ItemCost: 68.54,
        OrderCost: 479.78000000000003,
        PackageCost: 8.89,
        OrderDate: 1490396400000,
        RequiredDate: 1491606000000,
        ShippedDate: 1490914800000,
        ShipVia: 'United Package',
        Freight: 64.45,
        ShipName: 'LINO-Delicateses',
        ShipAddress: 'Ave. 5 de Mayo Porlamar',
        ShipCity: 'I. de Margarita',
        ShipRegion: 'Nueva Esparta',
        ShipPostalCode: 4980,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10484,
        CustomerReference: 'BSBEV',
        CompanyName: "B's Beverages",
        ContactName: 'Victoria Ashworth',
        Employee: 'Janet Leverling',
        InvoicedCost: 486.405,
        ItemCount: 9,
        ChangeLastOrder: 22,
        ItemCost: 60.05,
        OrderCost: 540.4499999999999,
        PackageCost: 12.861,
        OrderDate: 1490310000000,
        RequiredDate: 1492729200000,
        ShippedDate: 1491001200000,
        ShipVia: 'Federal Shipping',
        Freight: 6.88,
        ShipName: "B's Beverages",
        ShipAddress: 'Fauntleroy Circus',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'EC2 5NT',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10483,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Robert King',
        InvoicedCost: 413.64000000000004,
        ItemCount: 10,
        ChangeLastOrder: 6,
        ItemCost: 45.96,
        OrderCost: 459.6,
        PackageCost: 13.81,
        OrderDate: 1490310000000,
        RequiredDate: 1492729200000,
        ShippedDate: 1493074800000,
        ShipVia: 'United Package',
        Freight: 15.28,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10482,
        CustomerReference: 'LAZYK',
        CompanyName: 'Lazy K Kountry Store',
        ContactName: 'John Steel',
        Employee: 'Nancy Davolio',
        InvoicedCost: 792.09,
        ItemCount: 13,
        ChangeLastOrder: 6,
        ItemCost: 67.7,
        OrderCost: 880.1,
        PackageCost: 17.953,
        OrderDate: 1490050800000,
        RequiredDate: 1492470000000,
        ShippedDate: 1491778800000,
        ShipVia: 'Federal Shipping',
        Freight: 7.48,
        ShipName: 'Lazy K Kountry Store',
        ShipAddress: '12 Orchestra Terrace',
        ShipCity: 'Walla Walla',
        ShipRegion: 'WA',
        ShipPostalCode: 99362,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10481,
        CustomerReference: 'RICAR',
        CompanyName: 'Ricardo Adocicados',
        ContactName: 'Janete Limeira',
        Employee: 'Laura Callahan',
        InvoicedCost: 718.1404999999999,
        ItemCount: 7,
        ChangeLastOrder: -2,
        ItemCost: 89.21,
        OrderCost: 624.4699999999999,
        PackageCost: 8.89,
        OrderDate: 1489964400000,
        RequiredDate: 1492383600000,
        ShippedDate: 1490396400000,
        ShipVia: 'United Package',
        Freight: 64.33,
        ShipName: 'Ricardo Adocicados',
        ShipAddress: 'Av. Copacabana, 267',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-890',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10480,
        CustomerReference: 'FOLIG',
        CompanyName: 'Folies gourmandes',
        ContactName: "Martine Ranc\xe9",
        Employee: 'Michael Suyama',
        InvoicedCost: 294.492,
        ItemCount: 11,
        ChangeLastOrder: 5,
        ItemCost: 23.28,
        OrderCost: 256.08000000000004,
        PackageCost: 5.94,
        OrderDate: 1489964400000,
        RequiredDate: 1492383600000,
        ShippedDate: 1490310000000,
        ShipVia: 'United Package',
        Freight: 1.35,
        ShipName: 'Folies gourmandes',
        ShipAddress: "184, chauss\xe9e de Tournai",
        ShipCity: 'Lille',
        ShipRegion: null,
        ShipPostalCode: 59000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10479,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Janet Leverling',
        InvoicedCost: 511.203,
        ItemCount: 11,
        ChangeLastOrder: 2,
        ItemCost: 44.26,
        OrderCost: 486.85999999999996,
        PackageCost: 5.94,
        OrderDate: 1489878000000,
        RequiredDate: 1492297200000,
        ShippedDate: 1490050800000,
        ShipVia: 'Federal Shipping',
        Freight: 708.95,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10478,
        CustomerReference: 'VICTE',
        CompanyName: 'Victuailles en stock',
        ContactName: 'Mary Saveley',
        Employee: 'Andrew Fuller',
        InvoicedCost: 644.184,
        ItemCount: 12,
        ChangeLastOrder: 4,
        ItemCost: 46.68,
        OrderCost: 560.16,
        PackageCost: 6.48,
        OrderDate: 1489791600000,
        RequiredDate: 1491001200000,
        ShippedDate: 1490482800000,
        ShipVia: 'Federal Shipping',
        Freight: 4.81,
        ShipName: 'Victuailles en stock',
        ShipAddress: '2, rue du Commerce',
        ShipCity: 'Lyon',
        ShipRegion: null,
        ShipPostalCode: 69004,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10477,
        CustomerReference: 'PRINI',
        CompanyName: 'Princesa Isabel Vinhos',
        ContactName: 'Isabel de Castro',
        Employee: 'Steven Buchanan',
        InvoicedCost: 219.402,
        ItemCount: 9,
        ChangeLastOrder: -13,
        ItemCost: 28.68,
        OrderCost: 258.12,
        PackageCost: 10.35,
        OrderDate: 1489705200000,
        RequiredDate: 1492124400000,
        ShippedDate: 1490396400000,
        ShipVia: 'United Package',
        Freight: 13.02,
        ShipName: 'Princesa Isabel Vinhos',
        ShipAddress: "Estrada da sa\xfade n. 58",
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1756,
        ShipCountry: 'Portugal',
        ArriveOnTime: 1
    },
    {
        OrderId: 10476,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Laura Callahan',
        InvoicedCost: 396.2849999999999,
        ItemCount: 10,
        ChangeLastOrder: -5,
        ItemCost: 27.33,
        OrderCost: 273.29999999999995,
        PackageCost: 11.5,
        OrderDate: 1489705200000,
        RequiredDate: 1492124400000,
        ShippedDate: 1490310000000,
        ShipVia: 'Federal Shipping',
        Freight: 4.41,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10475,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 463.11300000000006,
        ItemCount: 7,
        ChangeLastOrder: -4,
        ItemCost: 73.51,
        OrderCost: 514.57,
        PackageCost: 8.049999999999999,
        OrderDate: 1489446000000,
        RequiredDate: 1491865200000,
        ShippedDate: 1491260400000,
        ShipVia: 'Speedy Express',
        Freight: 68.52,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 0
    },
    {
        OrderId: 10474,
        CustomerReference: 'PERIC',
        CompanyName: "Pericles Comidas cl\xe1sicas",
        ContactName: "Guillermo Fern\xe1ndez",
        Employee: 'Steven Buchanan',
        InvoicedCost: 97.014,
        ItemCount: 12,
        ChangeLastOrder: -5,
        ItemCost: 7.03,
        OrderCost: 84.36,
        PackageCost: 13.799999999999999,
        OrderDate: 1489359600000,
        RequiredDate: 1491778800000,
        ShippedDate: 1490050800000,
        ShipVia: 'United Package',
        Freight: 83.49,
        ShipName: "Pericles Comidas cl\xe1sicas",
        ShipAddress: 'Calle Dr. Jorge Cash 321',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10473,
        CustomerReference: 'ISLAT',
        CompanyName: 'Island Trading',
        ContactName: 'Helen Bennett',
        Employee: 'Nancy Davolio',
        InvoicedCost: 547.992,
        ItemCount: 12,
        ChangeLastOrder: 7,
        ItemCost: 50.74,
        OrderCost: 608.88,
        PackageCost: 16.572,
        OrderDate: 1489359600000,
        RequiredDate: 1490569200000,
        ShippedDate: 1490050800000,
        ShipVia: 'Federal Shipping',
        Freight: 16.37,
        ShipName: 'Island Trading',
        ShipAddress: 'Garden House, Crowther Way',
        ShipCity: 'Cowes',
        ShipRegion: 'Isle of Wight',
        ShipPostalCode: 'PO31 7PJ',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10472,
        CustomerReference: 'SEVES',
        CompanyName: 'Seven Seas Imports',
        ContactName: 'Hari Kumar',
        Employee: 'Laura Callahan',
        InvoicedCost: 555.048,
        ItemCount: 8,
        ChangeLastOrder: 0,
        ItemCost: 77.09,
        OrderCost: 616.72,
        PackageCost: 10.16,
        OrderDate: 1489273200000,
        RequiredDate: 1491692400000,
        ShippedDate: 1489878000000,
        ShipVia: 'Speedy Express',
        Freight: 4.2,
        ShipName: 'Seven Seas Imports',
        ShipAddress: '90 Wadhurst Rd.',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'OX15 4NB',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10471,
        CustomerReference: 'BSBEV',
        CompanyName: "B's Beverages",
        ContactName: 'Victoria Ashworth',
        Employee: 'Andrew Fuller',
        InvoicedCost: 478.54799999999994,
        ItemCount: 7,
        ChangeLastOrder: 21,
        ItemCost: 75.96,
        OrderCost: 531.7199999999999,
        PackageCost: 10.003,
        OrderDate: 1489186800000,
        RequiredDate: 1491606000000,
        ShippedDate: 1489791600000,
        ShipVia: 'Federal Shipping',
        Freight: 45.59,
        ShipName: "B's Beverages",
        ShipAddress: 'Fauntleroy Circus',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'EC2 5NT',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10470,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1009.358,
        ItemCount: 14,
        ChangeLastOrder: 6,
        ItemCost: 84.82,
        OrderCost: 1187.48,
        PackageCost: 19.334,
        OrderDate: 1489186800000,
        RequiredDate: 1491606000000,
        ShippedDate: 1489446000000,
        ShipVia: 'United Package',
        Freight: 64.56,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10469,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Nancy Davolio',
        InvoicedCost: 435.96000000000004,
        ItemCount: 14,
        ChangeLastOrder: 6,
        ItemCost: 34.6,
        OrderCost: 484.40000000000003,
        PackageCost: 19.334,
        OrderDate: 1489100400000,
        RequiredDate: 1491519600000,
        ShippedDate: 1489446000000,
        ShipVia: 'Speedy Express',
        Freight: 60.18,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10468,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Janet Leverling',
        InvoicedCost: 203.065,
        ItemCount: 5,
        ChangeLastOrder: 33,
        ItemCost: 47.78,
        OrderCost: 238.9,
        PackageCost: 7.1450000000000005,
        OrderDate: 1488841200000,
        RequiredDate: 1491260400000,
        ShippedDate: 1489273200000,
        ShipVia: 'Federal Shipping',
        Freight: 44.12,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10467,
        CustomerReference: 'MAGAA',
        CompanyName: 'Magazzini Alimentari Riuniti',
        ContactName: 'Giovanni Rovelli',
        Employee: 'Laura Callahan',
        InvoicedCost: 80.41000000000001,
        ItemCount: 10,
        ChangeLastOrder: -13,
        ItemCost: 9.46,
        OrderCost: 94.60000000000001,
        PackageCost: 11.5,
        OrderDate: 1488754800000,
        RequiredDate: 1491174000000,
        ShippedDate: 1489186800000,
        ShipVia: 'United Package',
        Freight: 4.93,
        ShipName: 'Magazzini Alimentari Riuniti',
        ShipAddress: 'Via Ludovico il Moro 22',
        ShipCity: 'Bergamo',
        ShipRegion: null,
        ShipPostalCode: 24100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10466,
        CustomerReference: 'COMMI',
        CompanyName: "Com\xe9rcio Mineiro",
        ContactName: 'Pedro Afonso',
        Employee: 'Laura Callahan',
        InvoicedCost: 195.942,
        ItemCount: 6,
        ChangeLastOrder: -3,
        ItemCost: 38.42,
        OrderCost: 230.52,
        PackageCost: 7.62,
        OrderDate: 1488754800000,
        RequiredDate: 1491174000000,
        ShippedDate: 1489359600000,
        ShipVia: 'Speedy Express',
        Freight: 11.93,
        ShipName: "Com\xe9rcio Mineiro",
        ShipAddress: "Av. dos Lus\xedadas, 23",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05432-043',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10465,
        CustomerReference: 'VAFFE',
        CompanyName: 'Vaffeljernet',
        ContactName: 'Palle Ibsen',
        Employee: 'Nancy Davolio',
        InvoicedCost: 923.7690000000001,
        ItemCount: 11,
        ChangeLastOrder: 11,
        ItemCost: 79.98,
        OrderCost: 879.7800000000001,
        PackageCost: 15.719000000000001,
        OrderDate: 1488668400000,
        RequiredDate: 1491087600000,
        ShippedDate: 1489446000000,
        ShipVia: 'Federal Shipping',
        Freight: 145.04,
        ShipName: 'Vaffeljernet',
        ShipAddress: "Smagsl\xf8get 45",
        ShipCity: "\xc5rhus",
        ShipRegion: null,
        ShipPostalCode: 8200,
        ShipCountry: 'Denmark',
        ArriveOnTime: 0
    },
    {
        OrderId: 10464,
        CustomerReference: 'FURIB',
        CompanyName: 'Furia Bacalhau e Frutos do Mar',
        ContactName: 'Lino Rodriguez',
        Employee: 'Margaret Peacock',
        InvoicedCost: 398.65,
        ItemCount: 5,
        ChangeLastOrder: 30,
        ItemCost: 93.8,
        OrderCost: 469,
        PackageCost: 7.1450000000000005,
        OrderDate: 1488582000000,
        RequiredDate: 1491001200000,
        ShippedDate: 1489446000000,
        ShipVia: 'United Package',
        Freight: 89,
        ShipName: 'Furia Bacalhau e Frutos do Mar',
        ShipAddress: 'Jardim das rosas n. 32',
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1675,
        ShipCountry: 'Portugal',
        ArriveOnTime: 0
    },
    {
        OrderId: 10463,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Steven Buchanan',
        InvoicedCost: 295.425,
        ItemCount: 13,
        ChangeLastOrder: -4,
        ItemCost: 25.25,
        OrderCost: 328.25,
        PackageCost: 14.95,
        OrderDate: 1488582000000,
        RequiredDate: 1491001200000,
        ShippedDate: 1488754800000,
        ShipVia: 'Federal Shipping',
        Freight: 14.78,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 1
    },
    {
        OrderId: 10462,
        CustomerReference: 'CONSH',
        CompanyName: 'Consolidated Holdings',
        ContactName: 'Elizabeth Brown',
        Employee: 'Andrew Fuller',
        InvoicedCost: 913.68,
        ItemCount: 12,
        ChangeLastOrder: -3,
        ItemCost: 84.6,
        OrderCost: 1015.1999999999999,
        PackageCost: 15.24,
        OrderDate: 1488495600000,
        RequiredDate: 1490914800000,
        ShippedDate: 1489791600000,
        ShipVia: 'Speedy Express',
        Freight: 6.17,
        ShipName: 'Consolidated Holdings',
        ShipAddress: 'Berkeley Gardens, 12  Brewery',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'WX1 6LT',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10461,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Nancy Davolio',
        InvoicedCost: 229.6105,
        ItemCount: 7,
        ChangeLastOrder: 6,
        ItemCost: 38.59,
        OrderCost: 270.13,
        PackageCost: 9.667,
        OrderDate: 1488236400000,
        RequiredDate: 1490655600000,
        ShippedDate: 1488668400000,
        ShipVia: 'Federal Shipping',
        Freight: 148.61,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10460,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Laura Callahan',
        InvoicedCost: 56.295,
        ItemCount: 9,
        ChangeLastOrder: -1,
        ItemCost: 6.95,
        OrderCost: 62.550000000000004,
        PackageCost: 11.43,
        OrderDate: 1488236400000,
        RequiredDate: 1490655600000,
        ShippedDate: 1488495600000,
        ShipVia: 'Speedy Express',
        Freight: 16.27,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10459,
        CustomerReference: 'VICTE',
        CompanyName: 'Victuailles en stock',
        ContactName: 'Mary Saveley',
        Employee: 'Margaret Peacock',
        InvoicedCost: 498.157,
        ItemCount: 11,
        ChangeLastOrder: 4,
        ItemCost: 39.38,
        OrderCost: 433.18,
        PackageCost: 5.94,
        OrderDate: 1488150000000,
        RequiredDate: 1490569200000,
        ShippedDate: 1488236400000,
        ShipVia: 'United Package',
        Freight: 25.09,
        ShipName: 'Victuailles en stock',
        ShipAddress: '2, rue du Commerce',
        ShipCity: 'Lyon',
        ShipRegion: null,
        ShipPostalCode: 69004,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10458,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Robert King',
        InvoicedCost: 60.29100000000001,
        ItemCount: 7,
        ChangeLastOrder: -4,
        ItemCost: 9.57,
        OrderCost: 66.99000000000001,
        PackageCost: 8.049999999999999,
        OrderDate: 1488063600000,
        RequiredDate: 1490482800000,
        ShippedDate: 1488582000000,
        ShipVia: 'Federal Shipping',
        Freight: 147.06,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 0
    },
    {
        OrderId: 10457,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Andrew Fuller',
        InvoicedCost: 484.7975,
        ItemCount: 11,
        ChangeLastOrder: 36,
        ItemCost: 51.85,
        OrderCost: 570.35,
        PackageCost: 15.719000000000001,
        OrderDate: 1487977200000,
        RequiredDate: 1490396400000,
        ShippedDate: 1488495600000,
        ShipVia: 'Speedy Express',
        Freight: 11.57,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10456,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Laura Callahan',
        InvoicedCost: 897.1325,
        ItemCount: 11,
        ChangeLastOrder: -38,
        ItemCost: 95.95,
        OrderCost: 1055.45,
        PackageCost: 12.649999999999999,
        OrderDate: 1487977200000,
        RequiredDate: 1491606000000,
        ShippedDate: 1488236400000,
        ShipVia: 'United Package',
        Freight: 8.12,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10455,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Laura Callahan',
        InvoicedCost: 424.8090000000001,
        ItemCount: 11,
        ChangeLastOrder: -35,
        ItemCost: 36.78,
        OrderCost: 404.58000000000004,
        PackageCost: 12.649999999999999,
        OrderDate: 1487890800000,
        RequiredDate: 1491519600000,
        ShippedDate: 1488495600000,
        ShipVia: 'United Package',
        Freight: 180.45,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10454,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Margaret Peacock',
        InvoicedCost: 131.93699999999998,
        ItemCount: 6,
        ChangeLastOrder: 6,
        ItemCost: 25.87,
        OrderCost: 155.22,
        PackageCost: 8.286,
        OrderDate: 1487631600000,
        RequiredDate: 1490050800000,
        ShippedDate: 1487977200000,
        ShipVia: 'Federal Shipping',
        Freight: 2.74,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10453,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Nancy Davolio',
        InvoicedCost: 114.804,
        ItemCount: 6,
        ChangeLastOrder: -4,
        ItemCost: 21.26,
        OrderCost: 127.56,
        PackageCost: 6.8999999999999995,
        OrderDate: 1487631600000,
        RequiredDate: 1490050800000,
        ShippedDate: 1488063600000,
        ShipVia: 'United Package',
        Freight: 25.36,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10452,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Laura Callahan',
        InvoicedCost: 34.776,
        ItemCount: 9,
        ChangeLastOrder: 5,
        ItemCost: 3.68,
        OrderCost: 33.120000000000005,
        PackageCost: 4.86,
        OrderDate: 1487545200000,
        RequiredDate: 1489964400000,
        ShippedDate: 1488063600000,
        ShipVia: 'Speedy Express',
        Freight: 140.26,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10451,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Margaret Peacock',
        InvoicedCost: 995.4126000000001,
        ItemCount: 13,
        ChangeLastOrder: -22,
        ItemCost: 74.34,
        OrderCost: 966.4200000000001,
        PackageCost: 14.95,
        OrderDate: 1487458800000,
        RequiredDate: 1488668400000,
        ShippedDate: 1489273200000,
        ShipVia: 'Federal Shipping',
        Freight: 189.09,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10450,
        CustomerReference: 'VICTE',
        CompanyName: 'Victuailles en stock',
        ContactName: 'Mary Saveley',
        Employee: 'Laura Callahan',
        InvoicedCost: 513.9809999999999,
        ItemCount: 6,
        ChangeLastOrder: 4,
        ItemCost: 74.49,
        OrderCost: 446.93999999999994,
        PackageCost: 3.24,
        OrderDate: 1487458800000,
        RequiredDate: 1489878000000,
        ShippedDate: 1489186800000,
        ShipVia: 'United Package',
        Freight: 7.23,
        ShipName: 'Victuailles en stock',
        ShipAddress: '2, rue du Commerce',
        ShipCity: 'Lyon',
        ShipRegion: null,
        ShipPostalCode: 69004,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10449,
        CustomerReference: 'BLONP',
        CompanyName: "Blondel p\xe8re et fils",
        ContactName: "Fr\xe9d\xe9rique Citeaux",
        Employee: 'Janet Leverling',
        InvoicedCost: 261.234,
        ItemCount: 12,
        ChangeLastOrder: 4,
        ItemCost: 18.93,
        OrderCost: 227.16,
        PackageCost: 6.48,
        OrderDate: 1487372400000,
        RequiredDate: 1489791600000,
        ShippedDate: 1488150000000,
        ShipVia: 'United Package',
        Freight: 53.3,
        ShipName: "Blondel p\xe8re et fils",
        ShipAddress: "24, place Kl\xe9ber",
        ShipCity: 'Strasbourg',
        ShipRegion: null,
        ShipPostalCode: 67000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10448,
        CustomerReference: 'RANCH',
        CompanyName: 'Rancho grande',
        ContactName: "Sergio Guti\xe9rrez",
        Employee: 'Margaret Peacock',
        InvoicedCost: 180.625,
        ItemCount: 10,
        ChangeLastOrder: -3,
        ItemCost: 21.25,
        OrderCost: 212.5,
        PackageCost: 12.7,
        OrderDate: 1487286000000,
        RequiredDate: 1489705200000,
        ShippedDate: 1487890800000,
        ShipVia: 'United Package',
        Freight: 38.82,
        ShipName: 'Rancho grande',
        ShipAddress: 'Av. del Libertador 900',
        ShipCity: 'Buenos Aires',
        ShipRegion: null,
        ShipPostalCode: 1010,
        ShipCountry: 'Argentina',
        ArriveOnTime: 0
    },
    {
        OrderId: 10447,
        CustomerReference: 'RICAR',
        CompanyName: 'Ricardo Adocicados',
        ContactName: 'Janete Limeira',
        Employee: 'Margaret Peacock',
        InvoicedCost: 472.075,
        ItemCount: 10,
        ChangeLastOrder: -2,
        ItemCost: 41.05,
        OrderCost: 410.5,
        PackageCost: 12.7,
        OrderDate: 1487026800000,
        RequiredDate: 1489446000000,
        ShippedDate: 1488841200000,
        ShipVia: 'United Package',
        Freight: 68.66,
        ShipName: 'Ricardo Adocicados',
        ShipAddress: 'Av. Copacabana, 267',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-890',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10446,
        CustomerReference: 'TOMSP',
        CompanyName: "Toms Spezialit\xe4ten",
        ContactName: 'Karin Josephs',
        Employee: 'Michael Suyama',
        InvoicedCost: 569.2192,
        ItemCount: 11,
        ChangeLastOrder: -11,
        ItemCost: 50.24,
        OrderCost: 552.64,
        PackageCost: 12.649999999999999,
        OrderDate: 1487026800000,
        RequiredDate: 1489446000000,
        ShippedDate: 1487458800000,
        ShipVia: 'Speedy Express',
        Freight: 14.68,
        ShipName: "Toms Spezialit\xe4ten",
        ShipAddress: 'Luisenstr. 48',
        ShipCity: "M\xfcnster",
        ShipRegion: null,
        ShipPostalCode: 44087,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10445,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Janet Leverling',
        InvoicedCost: 585.072,
        ItemCount: 8,
        ChangeLastOrder: -3,
        ItemCost: 81.26,
        OrderCost: 650.08,
        PackageCost: 10.16,
        OrderDate: 1486940400000,
        RequiredDate: 1489359600000,
        ShippedDate: 1487545200000,
        ShipVia: 'Speedy Express',
        Freight: 9.3,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10444,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Janet Leverling',
        InvoicedCost: 478.9800000000001,
        ItemCount: 6,
        ChangeLastOrder: -3,
        ItemCost: 88.7,
        OrderCost: 532.2,
        PackageCost: 7.62,
        OrderDate: 1486854000000,
        RequiredDate: 1489273200000,
        ShippedDate: 1487631600000,
        ShipVia: 'Federal Shipping',
        Freight: 3.5,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10443,
        CustomerReference: 'REGGC',
        CompanyName: 'Reggiani Caseifici',
        ContactName: 'Maurizio Moroni',
        Employee: 'Laura Callahan',
        InvoicedCost: 46.5345,
        ItemCount: 9,
        ChangeLastOrder: -4,
        ItemCost: 11.49,
        OrderCost: 103.41,
        PackageCost: 10.35,
        OrderDate: 1486854000000,
        RequiredDate: 1489273200000,
        ShippedDate: 1487026800000,
        ShipVia: 'Speedy Express',
        Freight: 13.95,
        ShipName: 'Reggiani Caseifici',
        ShipAddress: 'Strada Provinciale 124',
        ShipCity: 'Reggio Emilia',
        ShipRegion: null,
        ShipPostalCode: 42100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10442,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Janet Leverling',
        InvoicedCost: 313.3725,
        ItemCount: 5,
        ChangeLastOrder: 8,
        ItemCost: 59.69,
        OrderCost: 298.45,
        PackageCost: 6.905,
        OrderDate: 1486767600000,
        RequiredDate: 1489186800000,
        ShippedDate: 1487372400000,
        ShipVia: 'United Package',
        Freight: 47.94,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10441,
        CustomerReference: 'OLDWO',
        CompanyName: 'Old World Delicatessen',
        ContactName: 'Rene Phillips',
        Employee: 'Janet Leverling',
        InvoicedCost: 36.765,
        ItemCount: 5,
        ChangeLastOrder: 3,
        ItemCost: 8.17,
        OrderCost: 40.85,
        PackageCost: 2.7,
        OrderDate: 1486681200000,
        RequiredDate: 1490310000000,
        ShippedDate: 1489446000000,
        ShipVia: 'United Package',
        Freight: 73.02,
        ShipName: 'Old World Delicatessen',
        ShipAddress: '2743 Bering St.',
        ShipCity: 'Anchorage',
        ShipRegion: 'AK',
        ShipPostalCode: 99508,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10440,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Margaret Peacock',
        InvoicedCost: 228.56400000000002,
        ItemCount: 12,
        ChangeLastOrder: 5,
        ItemCost: 18.14,
        OrderCost: 217.68,
        PackageCost: 6.48,
        OrderDate: 1486681200000,
        RequiredDate: 1489100400000,
        ShippedDate: 1488236400000,
        ShipVia: 'United Package',
        Freight: 86.53,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10402,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Laura Callahan',
        InvoicedCost: 235.05300000000003,
        ItemCount: 7,
        ChangeLastOrder: 11,
        ItemCost: 31.98,
        OrderCost: 223.86,
        PackageCost: 10.003,
        OrderDate: 1483311600000,
        RequiredDate: 1486940400000,
        ShippedDate: 1484002800000,
        ShipVia: 'United Package',
        Freight: 67.88,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10401,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Nancy Davolio',
        InvoicedCost: 104.07600000000001,
        ItemCount: 6,
        ChangeLastOrder: 3,
        ItemCost: 16.52,
        OrderCost: 99.12,
        PackageCost: 3.24,
        OrderDate: 1483225200000,
        RequiredDate: 1485644400000,
        ShippedDate: 1484002800000,
        ShipVia: 'Speedy Express',
        Freight: 12.51,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10400,
        CustomerReference: 'EASTC',
        CompanyName: 'Eastern Connection',
        ContactName: 'Ann Devon',
        Employee: 'Nancy Davolio',
        InvoicedCost: 117.99,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 13.11,
        OrderCost: 131.1,
        PackageCost: 5.4,
        OrderDate: 1483225200000,
        RequiredDate: 1485644400000,
        ShippedDate: 1484521200000,
        ShipVia: 'Federal Shipping',
        Freight: 83.93,
        ShipName: 'Eastern Connection',
        ShipAddress: '35 King George',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'WX3 6FW',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10399,
        CustomerReference: 'VAFFE',
        CompanyName: 'Vaffeljernet',
        ContactName: 'Palle Ibsen',
        Employee: 'Laura Callahan',
        InvoicedCost: 404.019,
        ItemCount: 6,
        ChangeLastOrder: 14,
        ItemCost: 64.13,
        OrderCost: 384.78,
        PackageCost: 8.574,
        OrderDate: 1483138800000,
        RequiredDate: 1484348400000,
        ShippedDate: 1483830000000,
        ShipVia: 'Federal Shipping',
        Freight: 27.36,
        ShipName: 'Vaffeljernet',
        ShipAddress: "Smagsl\xf8get 45",
        ShipCity: "\xc5rhus",
        ShipRegion: null,
        ShipPostalCode: 8200,
        ShipCountry: 'Denmark',
        ArriveOnTime: 1
    },
    {
        OrderId: 10398,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Andrew Fuller',
        InvoicedCost: 242.55,
        ItemCount: 12,
        ChangeLastOrder: 5,
        ItemCost: 19.25,
        OrderCost: 231,
        PackageCost: 6.48,
        OrderDate: 1483052400000,
        RequiredDate: 1485471600000,
        ShippedDate: 1483916400000,
        ShipVia: 'Federal Shipping',
        Freight: 89.16,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10397,
        CustomerReference: 'PRINI',
        CompanyName: 'Princesa Isabel Vinhos',
        ContactName: 'Isabel de Castro',
        Employee: 'Steven Buchanan',
        InvoicedCost: 134.589,
        ItemCount: 6,
        ChangeLastOrder: -16,
        ItemCost: 26.39,
        OrderCost: 158.34,
        PackageCost: 6.8999999999999995,
        OrderDate: 1482793200000,
        RequiredDate: 1485212400000,
        ShippedDate: 1483311600000,
        ShipVia: 'Speedy Express',
        Freight: 60.26,
        ShipName: 'Princesa Isabel Vinhos',
        ShipAddress: "Estrada da sa\xfade n. 58",
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1756,
        ShipCountry: 'Portugal',
        ArriveOnTime: 0
    },
    {
        OrderId: 10396,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Nancy Davolio',
        InvoicedCost: 455.07,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 39.4,
        OrderCost: 433.4,
        PackageCost: 13.97,
        OrderDate: 1482793200000,
        RequiredDate: 1484002800000,
        ShippedDate: 1483657200000,
        ShipVia: 'Federal Shipping',
        Freight: 135.35,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10395,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Michael Suyama',
        InvoicedCost: 609.406,
        ItemCount: 14,
        ChangeLastOrder: 17,
        ItemCost: 30.02,
        OrderCost: 420.28,
        PackageCost: 20.006,
        OrderDate: 1482706800000,
        RequiredDate: 1485126000000,
        ShippedDate: 1483398000000,
        ShipVia: 'Speedy Express',
        Freight: 184.41,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10394,
        CustomerReference: 'HUNGC',
        CompanyName: 'Hungry Coyote Import Store',
        ContactName: 'Yoshi Latimer',
        Employee: 'Nancy Davolio',
        InvoicedCost: 271.557,
        ItemCount: 11,
        ChangeLastOrder: -4,
        ItemCost: 27.43,
        OrderCost: 301.73,
        PackageCost: 12.649999999999999,
        OrderDate: 1482620400000,
        RequiredDate: 1485039600000,
        ShippedDate: 1483398000000,
        ShipVia: 'Federal Shipping',
        Freight: 30.34,
        ShipName: 'Hungry Coyote Import Store',
        ShipAddress: 'City Center Plaza, 516 Main St.',
        ShipCity: 'Elgin',
        ShipRegion: 'OR',
        ShipPostalCode: 97827,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10393,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Nancy Davolio',
        InvoicedCost: 217.56,
        ItemCount: 8,
        ChangeLastOrder: 5,
        ItemCost: 25.9,
        OrderCost: 207.2,
        PackageCost: 11.048,
        OrderDate: 1482620400000,
        RequiredDate: 1485039600000,
        ShippedDate: 1483398000000,
        ShipVia: 'Federal Shipping',
        Freight: 126.56,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10392,
        CustomerReference: 'PICCO',
        CompanyName: 'Piccolo und mehr',
        ContactName: 'Georg Pipps',
        Employee: 'Andrew Fuller',
        InvoicedCost: 321.233,
        ItemCount: 11,
        ChangeLastOrder: -6,
        ItemCost: 20.14,
        OrderCost: 221.54000000000002,
        PackageCost: 12.649999999999999,
        OrderDate: 1482534000000,
        RequiredDate: 1484953200000,
        ShippedDate: 1483225200000,
        ShipVia: 'Federal Shipping',
        Freight: 122.46,
        ShipName: 'Piccolo und mehr',
        ShipAddress: 'Geislweg 14',
        ShipCity: 'Salzburg',
        ShipRegion: null,
        ShipPostalCode: 5020,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10391,
        CustomerReference: 'DRACD',
        CompanyName: 'Drachenblut Delikatessen',
        ContactName: 'Sven Ottlieb',
        Employee: 'Janet Leverling',
        InvoicedCost: 562.856,
        ItemCount: 7,
        ChangeLastOrder: 1,
        ItemCost: 69.92,
        OrderCost: 489.44,
        PackageCost: 8.89,
        OrderDate: 1482447600000,
        RequiredDate: 1484866800000,
        ShippedDate: 1483138800000,
        ShipVia: 'Federal Shipping',
        Freight: 5.45,
        ShipName: 'Drachenblut Delikatessen',
        ShipAddress: 'Walserweg 21',
        ShipCity: 'Aachen',
        ShipRegion: null,
        ShipPostalCode: 52066,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10390,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Michael Suyama',
        InvoicedCost: 458.32500000000005,
        ItemCount: 10,
        ChangeLastOrder: 6,
        ItemCost: 43.65,
        OrderCost: 436.5,
        PackageCost: 13.81,
        OrderDate: 1482447600000,
        RequiredDate: 1484866800000,
        ShippedDate: 1482706800000,
        ShipVia: 'Speedy Express',
        Freight: 126.38,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10389,
        CustomerReference: 'BOTTM',
        CompanyName: 'Bottom-Dollar Markets',
        ContactName: 'Elizabeth Lincoln',
        Employee: 'Margaret Peacock',
        InvoicedCost: 235.305,
        ItemCount: 9,
        ChangeLastOrder: 4,
        ItemCost: 29.05,
        OrderCost: 261.45,
        PackageCost: 4.86,
        OrderDate: 1482188400000,
        RequiredDate: 1484607600000,
        ShippedDate: 1482534000000,
        ShipVia: 'United Package',
        Freight: 47.42,
        ShipName: 'Bottom-Dollar Markets',
        ShipAddress: '23 Tsawassen Blvd.',
        ShipCity: 'Tsawassen',
        ShipRegion: 'BC',
        ShipPostalCode: 'T2F 8M4',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10388,
        CustomerReference: 'SEVES',
        CompanyName: 'Seven Seas Imports',
        ContactName: 'Hari Kumar',
        Employee: 'Andrew Fuller',
        InvoicedCost: 572.184,
        ItemCount: 9,
        ChangeLastOrder: 0,
        ItemCost: 70.64,
        OrderCost: 635.76,
        PackageCost: 11.43,
        OrderDate: 1482102000000,
        RequiredDate: 1484521200000,
        ShippedDate: 1482188400000,
        ShipVia: 'Speedy Express',
        Freight: 34.86,
        ShipName: 'Seven Seas Imports',
        ShipAddress: '90 Wadhurst Rd.',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'OX15 4NB',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10387,
        CustomerReference: 'ROMEY',
        CompanyName: 'Romero y tomillo',
        ContactName: 'Alejandra Camino',
        Employee: 'Nancy Davolio',
        InvoicedCost: 1130.0819999999999,
        ItemCount: 12,
        ChangeLastOrder: -8,
        ItemCost: 99.13,
        OrderCost: 1189.56,
        PackageCost: 13.799999999999999,
        OrderDate: 1482015600000,
        RequiredDate: 1484434800000,
        ShippedDate: 1482188400000,
        ShipVia: 'United Package',
        Freight: 93.63,
        ShipName: "Sant\xe9 Gourmet",
        ShipAddress: 'Erling Skakkes gate 78',
        ShipCity: 'Stavern',
        ShipRegion: null,
        ShipPostalCode: 4110,
        ShipCountry: 'Norway',
        ArriveOnTime: 0
    },
    {
        OrderId: 10386,
        CustomerReference: 'FAMIA',
        CompanyName: 'Familia Arquibaldo',
        ContactName: 'Aria Cruz',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 978.3839999999999,
        ItemCount: 12,
        ChangeLastOrder: -31,
        ItemCost: 95.92,
        OrderCost: 1151.04,
        PackageCost: 13.799999999999999,
        OrderDate: 1482015600000,
        RequiredDate: 1483225200000,
        ShippedDate: 1482620400000,
        ShipVia: 'Federal Shipping',
        Freight: 13.99,
        ShipName: 'Familia Arquibaldo',
        ShipAddress: "Rua Or\xf3s, 92",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05442-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10385,
        CustomerReference: 'SPLIR',
        CompanyName: 'Split Rail Beer & Ale',
        ContactName: 'Art Braunschweiger',
        Employee: 'Nancy Davolio',
        InvoicedCost: 733.9605,
        ItemCount: 13,
        ChangeLastOrder: 11,
        ItemCost: 53.77,
        OrderCost: 699.01,
        PackageCost: 18.577,
        OrderDate: 1481929200000,
        RequiredDate: 1484348400000,
        ShippedDate: 1482447600000,
        ShipVia: 'United Package',
        Freight: 30.96,
        ShipName: 'Split Rail Beer & Ale',
        ShipAddress: 'P.O. Box 555',
        ShipCity: 'Lander',
        ShipRegion: 'WY',
        ShipPostalCode: 82520,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10384,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Janet Leverling',
        InvoicedCost: 263.952,
        ItemCount: 8,
        ChangeLastOrder: -3,
        ItemCost: 36.66,
        OrderCost: 293.28,
        PackageCost: 10.16,
        OrderDate: 1481842800000,
        RequiredDate: 1484262000000,
        ShippedDate: 1482188400000,
        ShipVia: 'Federal Shipping',
        Freight: 168.64,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10383,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Laura Callahan',
        InvoicedCost: 738.3600000000001,
        ItemCount: 10,
        ChangeLastOrder: -4,
        ItemCost: 82.04,
        OrderCost: 820.4000000000001,
        PackageCost: 11.5,
        OrderDate: 1481842800000,
        RequiredDate: 1484262000000,
        ShippedDate: 1482015600000,
        ShipVia: 'Federal Shipping',
        Freight: 34.24,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10382,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Margaret Peacock',
        InvoicedCost: 642.5055,
        ItemCount: 13,
        ChangeLastOrder: -1,
        ItemCost: 47.07,
        OrderCost: 611.91,
        PackageCost: 16.51,
        OrderDate: 1481583600000,
        RequiredDate: 1484002800000,
        ShippedDate: 1481842800000,
        ShipVia: 'Speedy Express',
        Freight: 94.77,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10381,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Janet Leverling',
        InvoicedCost: 265.6845,
        ItemCount: 9,
        ChangeLastOrder: 7,
        ItemCost: 34.73,
        OrderCost: 312.57,
        PackageCost: 12.429,
        OrderDate: 1481497200000,
        RequiredDate: 1483916400000,
        ShippedDate: 1481583600000,
        ShipVia: 'Federal Shipping',
        Freight: 7.99,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10380,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Laura Callahan',
        InvoicedCost: 91.51200000000001,
        ItemCount: 8,
        ChangeLastOrder: 1,
        ItemCost: 12.71,
        OrderCost: 101.68,
        PackageCost: 10.16,
        OrderDate: 1481497200000,
        RequiredDate: 1483916400000,
        ShippedDate: 1484521200000,
        ShipVia: 'Federal Shipping',
        Freight: 35.03,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10379,
        CustomerReference: 'QUEDE',
        CompanyName: "Que Del\xedcia",
        ContactName: 'Bernardo Batista',
        Employee: 'Andrew Fuller',
        InvoicedCost: 170.25749999999996,
        ItemCount: 7,
        ChangeLastOrder: 0,
        ItemCost: 21.15,
        OrderCost: 148.04999999999998,
        PackageCost: 8.89,
        OrderDate: 1481410800000,
        RequiredDate: 1483830000000,
        ShippedDate: 1481583600000,
        ShipVia: 'Speedy Express',
        Freight: 45.03,
        ShipName: "Que Del\xedcia",
        ShipAddress: 'Rua da Panificadora, 12',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-673',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10378,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Steven Buchanan',
        InvoicedCost: 251.3511,
        ItemCount: 11,
        ChangeLastOrder: -1,
        ItemCost: 24.57,
        OrderCost: 270.27,
        PackageCost: 13.97,
        OrderDate: 1481324400000,
        RequiredDate: 1483743600000,
        ShippedDate: 1482102000000,
        ShipVia: 'Federal Shipping',
        Freight: 5.44,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10377,
        CustomerReference: 'SEVES',
        CompanyName: 'Seven Seas Imports',
        ContactName: 'Hari Kumar',
        Employee: 'Nancy Davolio',
        InvoicedCost: 337.1064,
        ItemCount: 8,
        ChangeLastOrder: 0,
        ItemCost: 45.31,
        OrderCost: 362.48,
        PackageCost: 10.16,
        OrderDate: 1481238000000,
        RequiredDate: 1483657200000,
        ShippedDate: 1481583600000,
        ShipVia: 'Federal Shipping',
        Freight: 22.21,
        ShipName: 'Seven Seas Imports',
        ShipAddress: '90 Wadhurst Rd.',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'OX15 4NB',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10376,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Nancy Davolio',
        InvoicedCost: 256.959,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 27.63,
        OrderCost: 276.3,
        PackageCost: 5.4,
        OrderDate: 1481238000000,
        RequiredDate: 1483657200000,
        ShippedDate: 1481583600000,
        ShipVia: 'United Package',
        Freight: 20.39,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 10375,
        CustomerReference: 'HUNGC',
        CompanyName: 'Hungry Coyote Import Store',
        ContactName: 'Yoshi Latimer',
        Employee: 'Janet Leverling',
        InvoicedCost: 568.5834,
        ItemCount: 11,
        ChangeLastOrder: -5,
        ItemCost: 55.58,
        OrderCost: 611.38,
        PackageCost: 12.649999999999999,
        OrderDate: 1480978800000,
        RequiredDate: 1483398000000,
        ShippedDate: 1481238000000,
        ShipVia: 'United Package',
        Freight: 20.12,
        ShipName: 'Hungry Coyote Import Store',
        ShipAddress: 'City Center Plaza, 516 Main St.',
        ShipCity: 'Elgin',
        ShipRegion: 'OR',
        ShipPostalCode: 97827,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10374,
        CustomerReference: 'WOLZA',
        CompanyName: 'Wolski  Zajazd',
        ContactName: 'Zbyszek Piestrzeniewicz',
        Employee: 'Nancy Davolio',
        InvoicedCost: 565.4250000000001,
        ItemCount: 6,
        ChangeLastOrder: 14,
        ItemCost: 75.39,
        OrderCost: 452.34000000000003,
        PackageCost: 8.574,
        OrderDate: 1480892400000,
        RequiredDate: 1483311600000,
        ShippedDate: 1481238000000,
        ShipVia: 'Federal Shipping',
        Freight: 3.94,
        ShipName: 'Wolski Zajazd',
        ShipAddress: 'ul. Filtrowa 68',
        ShipCity: 'Warszawa',
        ShipRegion: null,
        ShipPostalCode: '01-012',
        ShipCountry: 'Poland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10373,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Margaret Peacock',
        InvoicedCost: 667.926,
        ItemCount: 12,
        ChangeLastOrder: 1,
        ItemCost: 59.85,
        OrderCost: 718.2,
        PackageCost: 15.24,
        OrderDate: 1480892400000,
        RequiredDate: 1483311600000,
        ShippedDate: 1481410800000,
        ShipVia: 'Federal Shipping',
        Freight: 124.12,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10372,
        CustomerReference: 'QUEEN',
        CompanyName: 'Queen Cozinha',
        ContactName: "L\xfacia Carvalho",
        Employee: 'Steven Buchanan',
        InvoicedCost: 1055.53,
        ItemCount: 14,
        ChangeLastOrder: -2,
        ItemCost: 88.7,
        OrderCost: 1241.8,
        PackageCost: 17.78,
        OrderDate: 1480806000000,
        RequiredDate: 1483225200000,
        ShippedDate: 1481238000000,
        ShipVia: 'United Package',
        Freight: 890.78,
        ShipName: 'Queen Cozinha',
        ShipAddress: "Alameda dos Can\xe0rios, 891",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05487-020',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10371,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Nancy Davolio',
        InvoicedCost: 373.66,
        ItemCount: 10,
        ChangeLastOrder: 6,
        ItemCost: 43.96,
        OrderCost: 439.6,
        PackageCost: 13.81,
        OrderDate: 1480719600000,
        RequiredDate: 1483138800000,
        ShippedDate: 1482534000000,
        ShipVia: 'Speedy Express',
        Freight: 0.45,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10370,
        CustomerReference: 'CHOPS',
        CompanyName: 'Chop-suey Chinese',
        ContactName: 'Yang Wang',
        Employee: 'Michael Suyama',
        InvoicedCost: 882.8270000000001,
        ItemCount: 11,
        ChangeLastOrder: -13,
        ItemCost: 94.42,
        OrderCost: 1038.6200000000001,
        PackageCost: 12.649999999999999,
        OrderDate: 1480719600000,
        RequiredDate: 1483138800000,
        ShippedDate: 1482793200000,
        ShipVia: 'United Package',
        Freight: 1.17,
        ShipName: 'Chop-suey Chinese',
        ShipAddress: 'Hauptstr. 31',
        ShipCity: 'Bern',
        ShipRegion: null,
        ShipPostalCode: 3012,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10369,
        CustomerReference: 'SPLIR',
        CompanyName: 'Split Rail Beer & Ale',
        ContactName: 'Art Braunschweiger',
        Employee: 'Laura Callahan',
        InvoicedCost: 102.69,
        ItemCount: 10,
        ChangeLastOrder: 14,
        ItemCost: 9.78,
        OrderCost: 97.8,
        PackageCost: 14.290000000000001,
        OrderDate: 1480633200000,
        RequiredDate: 1483052400000,
        ShippedDate: 1481238000000,
        ShipVia: 'United Package',
        Freight: 195.68,
        ShipName: 'Split Rail Beer & Ale',
        ShipAddress: 'P.O. Box 555',
        ShipCity: 'Lander',
        ShipRegion: 'WY',
        ShipPostalCode: 82520,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10368,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Andrew Fuller',
        InvoicedCost: 707.091,
        ItemCount: 11,
        ChangeLastOrder: -2,
        ItemCost: 61.22,
        OrderCost: 673.42,
        PackageCost: 13.97,
        OrderDate: 1480374000000,
        RequiredDate: 1482793200000,
        ShippedDate: 1480633200000,
        ShipVia: 'United Package',
        Freight: 101.95,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10367,
        CustomerReference: 'VAFFE',
        CompanyName: 'Vaffeljernet',
        ContactName: 'Palle Ibsen',
        Employee: 'Robert King',
        InvoicedCost: 218.589,
        ItemCount: 7,
        ChangeLastOrder: 15,
        ItemCost: 29.74,
        OrderCost: 208.17999999999998,
        PackageCost: 10.003,
        OrderDate: 1480287600000,
        RequiredDate: 1482706800000,
        ShippedDate: 1480633200000,
        ShipVia: 'Federal Shipping',
        Freight: 13.55,
        ShipName: 'Vaffeljernet',
        ShipAddress: "Smagsl\xf8get 45",
        ShipCity: "\xc5rhus",
        ShipRegion: null,
        ShipPostalCode: 8200,
        ShipCountry: 'Denmark',
        ArriveOnTime: 1
    },
    {
        OrderId: 10366,
        CustomerReference: 'GALED',
        CompanyName: "Galer\xeda del gastr\xf3nomo",
        ContactName: 'Eduardo Saavedra',
        Employee: 'Laura Callahan',
        InvoicedCost: 1246.245,
        ItemCount: 13,
        ChangeLastOrder: 2,
        ItemCost: 91.3,
        OrderCost: 1186.8999999999999,
        PackageCost: 7.0200000000000005,
        OrderDate: 1480287600000,
        RequiredDate: 1483916400000,
        ShippedDate: 1483052400000,
        ShipVia: 'United Package',
        Freight: 10.14,
        ShipName: "Galer\xeda del gastron\xf3mo",
        ShipAddress: "Rambla de Catalu\xf1a, 23",
        ShipCity: 'Barcelona',
        ShipRegion: null,
        ShipPostalCode: 8022,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10365,
        CustomerReference: 'ANTON',
        CompanyName: "Antonio Moreno Taquer\xeda",
        ContactName: 'Antonio Moreno',
        Employee: 'Janet Leverling',
        InvoicedCost: 266.96099999999996,
        ItemCount: 6,
        ChangeLastOrder: -30,
        ItemCost: 38.69,
        OrderCost: 232.14,
        PackageCost: 6.8999999999999995,
        OrderDate: 1480201200000,
        RequiredDate: 1482620400000,
        ShippedDate: 1480633200000,
        ShipVia: 'United Package',
        Freight: 22,
        ShipName: "Antonio Moreno Taquer\xeda",
        ShipAddress: 'Mataderos  2312',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5023,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10364,
        CustomerReference: 'EASTC',
        CompanyName: 'Eastern Connection',
        ContactName: 'Ann Devon',
        Employee: 'Nancy Davolio',
        InvoicedCost: 697.4814,
        ItemCount: 11,
        ChangeLastOrder: 2,
        ItemCost: 68.18,
        OrderCost: 749.98,
        PackageCost: 5.94,
        OrderDate: 1480114800000,
        RequiredDate: 1483743600000,
        ShippedDate: 1480806000000,
        ShipVia: 'Speedy Express',
        Freight: 71.97,
        ShipName: 'Eastern Connection',
        ShipAddress: '35 King George',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'WX3 6FW',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10363,
        CustomerReference: 'DRACD',
        CompanyName: 'Drachenblut Delikatessen',
        ContactName: 'Sven Ottlieb',
        Employee: 'Margaret Peacock',
        InvoicedCost: 612.49,
        ItemCount: 10,
        ChangeLastOrder: -1,
        ItemCost: 53.26,
        OrderCost: 532.6,
        PackageCost: 12.7,
        OrderDate: 1480114800000,
        RequiredDate: 1482534000000,
        ShippedDate: 1480806000000,
        ShipVia: 'Federal Shipping',
        Freight: 30.54,
        ShipName: 'Drachenblut Delikatessen',
        ShipAddress: 'Walserweg 21',
        ShipCity: 'Aachen',
        ShipRegion: null,
        ShipPostalCode: 52066,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10362,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Janet Leverling',
        InvoicedCost: 337.90049999999997,
        ItemCount: 7,
        ChangeLastOrder: 5,
        ItemCost: 56.79,
        OrderCost: 397.53,
        PackageCost: 9.667,
        OrderDate: 1480028400000,
        RequiredDate: 1482447600000,
        ShippedDate: 1480287600000,
        ShipVia: 'Speedy Express',
        Freight: 96.04,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10361,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Nancy Davolio',
        InvoicedCost: 151.275,
        ItemCount: 6,
        ChangeLastOrder: -24,
        ItemCost: 20.17,
        OrderCost: 121.02000000000001,
        PackageCost: 6.8999999999999995,
        OrderDate: 1479769200000,
        RequiredDate: 1482188400000,
        ShippedDate: 1480719600000,
        ShipVia: 'United Package',
        Freight: 183.17,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10360,
        CustomerReference: 'BLONP',
        CompanyName: "Blondel p\xe8re et fils",
        ContactName: "Fr\xe9d\xe9rique Citeaux",
        Employee: 'Margaret Peacock',
        InvoicedCost: 288.282,
        ItemCount: 6,
        ChangeLastOrder: 4,
        ItemCost: 41.78,
        OrderCost: 250.68,
        PackageCost: 3.24,
        OrderDate: 1479769200000,
        RequiredDate: 1482188400000,
        ShippedDate: 1480633200000,
        ShipVia: 'Federal Shipping',
        Freight: 131.7,
        ShipName: "Blondel p\xe8re et fils",
        ShipAddress: "24, place Kl\xe9ber",
        ShipCity: 'Strasbourg',
        ShipRegion: null,
        ShipPostalCode: 67000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10359,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Steven Buchanan',
        InvoicedCost: 868.1829,
        ItemCount: 13,
        ChangeLastOrder: 0,
        ItemCost: 71.81,
        OrderCost: 933.53,
        PackageCost: 16.51,
        OrderDate: 1479682800000,
        RequiredDate: 1482102000000,
        ShippedDate: 1480114800000,
        ShipVia: 'Federal Shipping',
        Freight: 288.43,
        ShipName: 'Seven Seas Imports',
        ShipAddress: '90 Wadhurst Rd.',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'OX15 4NB',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10358,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Steven Buchanan',
        InvoicedCost: 639.9225,
        ItemCount: 9,
        ChangeLastOrder: 6,
        ItemCost: 83.65,
        OrderCost: 752.85,
        PackageCost: 12.429,
        OrderDate: 1479596400000,
        RequiredDate: 1482015600000,
        ShippedDate: 1480201200000,
        ShipVia: 'Speedy Express',
        Freight: 19.64,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10357,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Nancy Davolio',
        InvoicedCost: 696.9915,
        ItemCount: 9,
        ChangeLastOrder: 13,
        ItemCost: 91.11,
        OrderCost: 819.99,
        PackageCost: 12.861,
        OrderDate: 1479510000000,
        RequiredDate: 1481929200000,
        ShippedDate: 1480633200000,
        ShipVia: 'Federal Shipping',
        Freight: 34.88,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10356,
        CustomerReference: 'WANDK',
        CompanyName: 'Die Wandernde Kuh',
        ContactName: "Rita M\xfcller",
        Employee: 'Michael Suyama',
        InvoicedCost: 623.7,
        ItemCount: 11,
        ChangeLastOrder: 0,
        ItemCost: 54,
        OrderCost: 594,
        PackageCost: 13.97,
        OrderDate: 1479423600000,
        RequiredDate: 1481842800000,
        ShippedDate: 1480201200000,
        ShipVia: 'United Package',
        Freight: 36.71,
        ShipName: 'Die Wandernde Kuh',
        ShipAddress: 'Adenauerallee 900',
        ShipCity: 'Stuttgart',
        ShipRegion: null,
        ShipPostalCode: 70563,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10355,
        CustomerReference: 'AROUT',
        CompanyName: 'Around the Horn',
        ContactName: 'Thomas Hardy',
        Employee: 'Michael Suyama',
        InvoicedCost: 506.96160000000003,
        ItemCount: 8,
        ChangeLastOrder: -4,
        ItemCost: 68.14,
        OrderCost: 545.12,
        PackageCost: 9.2,
        OrderDate: 1479164400000,
        RequiredDate: 1481583600000,
        ShippedDate: 1479596400000,
        ShipVia: 'Speedy Express',
        Freight: 41.95,
        ShipName: 'Around the Horn',
        ShipAddress: 'Brook Farm, Stratford St. Mary',
        ShipCity: 'Colchester',
        ShipRegion: 'Essex',
        ShipPostalCode: 'CO7 6JX',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10354,
        CustomerReference: 'PERIC',
        CompanyName: "Pericles Comidas cl\xe1sicas",
        ContactName: "Guillermo Fern\xe1ndez",
        Employee: 'Laura Callahan',
        InvoicedCost: 604.5549999999998,
        ItemCount: 14,
        ChangeLastOrder: -5,
        ItemCost: 37.55,
        OrderCost: 525.6999999999999,
        PackageCost: 16.099999999999998,
        OrderDate: 1479078000000,
        RequiredDate: 1481497200000,
        ShippedDate: 1479596400000,
        ShipVia: 'Federal Shipping',
        Freight: 53.8,
        ShipName: "Pericles Comidas cl\xe1sicas",
        ShipAddress: 'Calle Dr. Jorge Cash 321',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10353,
        CustomerReference: 'PICCO',
        CompanyName: 'Piccolo und mehr',
        ContactName: 'Georg Pipps',
        Employee: 'Robert King',
        InvoicedCost: 179.82899999999998,
        ItemCount: 9,
        ChangeLastOrder: -4,
        ItemCost: 13.78,
        OrderCost: 124.02,
        PackageCost: 10.35,
        OrderDate: 1478991600000,
        RequiredDate: 1481410800000,
        ShippedDate: 1480028400000,
        ShipVia: 'Federal Shipping',
        Freight: 360.63,
        ShipName: 'Piccolo und mehr',
        ShipAddress: 'Geislweg 14',
        ShipCity: 'Salzburg',
        ShipRegion: null,
        ShipPostalCode: 5020,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10352,
        CustomerReference: 'FURIB',
        CompanyName: 'Furia Bacalhau e Frutos do Mar',
        ContactName: 'Lino Rodriguez',
        Employee: 'Janet Leverling',
        InvoicedCost: 251.42999999999995,
        ItemCount: 10,
        ChangeLastOrder: 29,
        ItemCost: 29.58,
        OrderCost: 295.79999999999995,
        PackageCost: 14.290000000000001,
        OrderDate: 1478905200000,
        RequiredDate: 1480114800000,
        ShippedDate: 1479423600000,
        ShipVia: 'Federal Shipping',
        Freight: 1.3,
        ShipName: 'Furia Bacalhau e Frutos do Mar',
        ShipAddress: 'Jardim das rosas n. 32',
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1675,
        ShipCountry: 'Portugal',
        ArriveOnTime: 1
    },
    {
        OrderId: 10351,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Nancy Davolio',
        InvoicedCost: 611.6565,
        ItemCount: 13,
        ChangeLastOrder: 0,
        ItemCost: 44.81,
        OrderCost: 582.53,
        PackageCost: 16.51,
        OrderDate: 1478818800000,
        RequiredDate: 1481238000000,
        ShippedDate: 1479596400000,
        ShipVia: 'Speedy Express',
        Freight: 162.33,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10350,
        CustomerReference: 'LAMAI',
        CompanyName: "La maison d'Asie",
        ContactName: 'Annette Roulet',
        Employee: 'Michael Suyama',
        InvoicedCost: 559.7845,
        ItemCount: 11,
        ChangeLastOrder: 6,
        ItemCost: 59.87,
        OrderCost: 658.5699999999999,
        PackageCost: 15.191,
        OrderDate: 1478818800000,
        RequiredDate: 1481238000000,
        ShippedDate: 1480719600000,
        ShipVia: 'United Package',
        Freight: 64.19,
        ShipName: "La maison d'Asie",
        ShipAddress: '1 rue Alsace-Lorraine',
        ShipCity: 'Toulouse',
        ShipRegion: null,
        ShipPostalCode: 31000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10349,
        CustomerReference: 'SPLIR',
        CompanyName: 'Split Rail Beer & Ale',
        ContactName: 'Art Braunschweiger',
        Employee: 'Robert King',
        InvoicedCost: 1015.329,
        ItemCount: 14,
        ChangeLastOrder: 8,
        ItemCost: 69.07,
        OrderCost: 966.9799999999999,
        PackageCost: 19.334,
        OrderDate: 1478559600000,
        RequiredDate: 1480978800000,
        ShippedDate: 1479164400000,
        ShipVia: 'Speedy Express',
        Freight: 8.63,
        ShipName: 'Split Rail Beer & Ale',
        ShipAddress: 'P.O. Box 555',
        ShipCity: 'Lander',
        ShipRegion: 'WY',
        ShipPostalCode: 82520,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10348,
        CustomerReference: 'WANDK',
        CompanyName: 'Die Wandernde Kuh',
        ContactName: "Rita M\xfcller",
        Employee: 'Margaret Peacock',
        InvoicedCost: 558.5580000000001,
        ItemCount: 11,
        ChangeLastOrder: 0,
        ItemCost: 48.36,
        OrderCost: 531.96,
        PackageCost: 13.97,
        OrderDate: 1478473200000,
        RequiredDate: 1480892400000,
        ShippedDate: 1479164400000,
        ShipVia: 'United Package',
        Freight: 0.78,
        ShipName: 'Die Wandernde Kuh',
        ShipAddress: 'Adenauerallee 900',
        ShipCity: 'Stuttgart',
        ShipRegion: null,
        ShipPostalCode: 70563,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10347,
        CustomerReference: 'FAMIA',
        CompanyName: 'Familia Arquibaldo',
        ContactName: 'Aria Cruz',
        Employee: 'Margaret Peacock',
        InvoicedCost: 516.681,
        ItemCount: 9,
        ChangeLastOrder: -32,
        ItemCost: 67.54,
        OrderCost: 607.86,
        PackageCost: 10.35,
        OrderDate: 1478386800000,
        RequiredDate: 1480806000000,
        ShippedDate: 1478559600000,
        ShipVia: 'Federal Shipping',
        Freight: 3.1,
        ShipName: 'Familia Arquibaldo',
        ShipAddress: "Rua Or\xf3s, 92",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05442-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10346,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Janet Leverling',
        InvoicedCost: 947.3100000000001,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 90.22,
        OrderCost: 902.2,
        PackageCost: 5.4,
        OrderDate: 1478300400000,
        RequiredDate: 1481929200000,
        ShippedDate: 1478559600000,
        ShipVia: 'Federal Shipping',
        Freight: 142.08,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10345,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Andrew Fuller',
        InvoicedCost: 892.05,
        ItemCount: 12,
        ChangeLastOrder: -21,
        ItemCost: 59.47,
        OrderCost: 713.64,
        PackageCost: 13.799999999999999,
        OrderDate: 1478214000000,
        RequiredDate: 1480633200000,
        ShippedDate: 1478818800000,
        ShipVia: 'United Package',
        Freight: 249.06,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10344,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Margaret Peacock',
        InvoicedCost: 556.8840000000001,
        ItemCount: 10,
        ChangeLastOrder: 6,
        ItemCost: 59.88,
        OrderCost: 598.8000000000001,
        PackageCost: 13.81,
        OrderDate: 1477954800000,
        RequiredDate: 1480374000000,
        ShippedDate: 1478300400000,
        ShipVia: 'United Package',
        Freight: 23.29,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10343,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Margaret Peacock',
        InvoicedCost: 717.7379999999999,
        ItemCount: 7,
        ChangeLastOrder: -26,
        ItemCost: 89.16,
        OrderCost: 624.12,
        PackageCost: 8.049999999999999,
        OrderDate: 1477868400000,
        RequiredDate: 1480287600000,
        ShippedDate: 1478386800000,
        ShipVia: 'Speedy Express',
        Freight: 110.37,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10342,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Margaret Peacock',
        InvoicedCost: 76.6395,
        ItemCount: 9,
        ChangeLastOrder: -3,
        ItemCost: 8.11,
        OrderCost: 72.99,
        PackageCost: 11.43,
        OrderDate: 1477782000000,
        RequiredDate: 1478991600000,
        ShippedDate: 1478214000000,
        ShipVia: 'United Package',
        Freight: 54.83,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10341,
        CustomerReference: 'SIMOB',
        CompanyName: 'Simons bistro',
        ContactName: 'Jytte Petersen',
        Employee: 'Robert King',
        InvoicedCost: 419.322,
        ItemCount: 6,
        ChangeLastOrder: 8,
        ItemCost: 82.22,
        OrderCost: 493.32,
        PackageCost: 8.286,
        OrderDate: 1477695600000,
        RequiredDate: 1480114800000,
        ShippedDate: 1478300400000,
        ShipVia: 'Federal Shipping',
        Freight: 26.78,
        ShipName: 'Simons bistro',
        ShipAddress: "Vinb\xe6ltet 34",
        ShipCity: "K\xf8benhavn",
        ShipRegion: null,
        ShipPostalCode: 1734,
        ShipCountry: 'Denmark',
        ArriveOnTime: 1
    },
    {
        OrderId: 10340,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Nancy Davolio',
        InvoicedCost: 394.74,
        ItemCount: 12,
        ChangeLastOrder: 5,
        ItemCost: 38.7,
        OrderCost: 464.40000000000003,
        PackageCost: 16.572,
        OrderDate: 1477695600000,
        RequiredDate: 1480114800000,
        ShippedDate: 1478559600000,
        ShipVia: 'Federal Shipping',
        Freight: 166.31,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10339,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Andrew Fuller',
        InvoicedCost: 53.6424,
        ItemCount: 8,
        ChangeLastOrder: 2,
        ItemCost: 7.21,
        OrderCost: 57.68,
        PackageCost: 4.32,
        OrderDate: 1477609200000,
        RequiredDate: 1480028400000,
        ShippedDate: 1478214000000,
        ShipVia: 'United Package',
        Freight: 15.66,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 1
    },
    {
        OrderId: 10338,
        CustomerReference: 'OLDWO',
        CompanyName: 'Old World Delicatessen',
        ContactName: 'Rene Phillips',
        Employee: 'Margaret Peacock',
        InvoicedCost: 71.2287,
        ItemCount: 9,
        ChangeLastOrder: 3,
        ItemCost: 8.51,
        OrderCost: 76.59,
        PackageCost: 4.86,
        OrderDate: 1477350000000,
        RequiredDate: 1479769200000,
        ShippedDate: 1477695600000,
        ShipVia: 'Federal Shipping',
        Freight: 84.21,
        ShipName: 'Old World Delicatessen',
        ShipAddress: '2743 Bering St.',
        ShipCity: 'Anchorage',
        ShipRegion: 'AK',
        ShipPostalCode: 99508,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10337,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1067.598,
        ItemCount: 12,
        ChangeLastOrder: -4,
        ItemCost: 84.73,
        OrderCost: 1016.76,
        PackageCost: 13.799999999999999,
        OrderDate: 1477263600000,
        RequiredDate: 1479682800000,
        ShippedDate: 1477695600000,
        ShipVia: 'Federal Shipping',
        Freight: 108.26,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10336,
        CustomerReference: 'PRINI',
        CompanyName: 'Princesa Isabel Vinhos',
        ContactName: 'Isabel de Castro',
        Employee: 'Robert King',
        InvoicedCost: 575.365,
        ItemCount: 10,
        ChangeLastOrder: -12,
        ItemCost: 67.69,
        OrderCost: 676.9,
        PackageCost: 11.5,
        OrderDate: 1477177200000,
        RequiredDate: 1479596400000,
        ShippedDate: 1477350000000,
        ShipVia: 'United Package',
        Freight: 15.51,
        ShipName: 'Princesa Isabel Vinhos',
        ShipAddress: "Estrada da sa\xfade n. 58",
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1756,
        ShipCountry: 'Portugal',
        ArriveOnTime: 1
    },
    {
        OrderId: 10335,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Robert King',
        InvoicedCost: 567.579,
        ItemCount: 10,
        ChangeLastOrder: 1,
        ItemCost: 61.03,
        OrderCost: 610.3,
        PackageCost: 12.7,
        OrderDate: 1477090800000,
        RequiredDate: 1479510000000,
        ShippedDate: 1477263600000,
        ShipVia: 'United Package',
        Freight: 42.11,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10334,
        CustomerReference: 'VICTE',
        CompanyName: 'Victuailles en stock',
        ContactName: 'Mary Saveley',
        Employee: 'Laura Callahan',
        InvoicedCost: 317.31,
        ItemCount: 5,
        ChangeLastOrder: 5,
        ItemCost: 60.44,
        OrderCost: 302.2,
        PackageCost: 6.905,
        OrderDate: 1477004400000,
        RequiredDate: 1479423600000,
        ShippedDate: 1477609200000,
        ShipVia: 'United Package',
        Freight: 8.56,
        ShipName: 'Victuailles en stock',
        ShipAddress: '2, rue du Commerce',
        ShipCity: 'Lyon',
        ShipRegion: null,
        ShipPostalCode: 69004,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10333,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Steven Buchanan',
        InvoicedCost: 48.9825,
        ItemCount: 5,
        ChangeLastOrder: -25,
        ItemCost: 9.33,
        OrderCost: 46.65,
        PackageCost: 5.75,
        OrderDate: 1476745200000,
        RequiredDate: 1479164400000,
        ShippedDate: 1477350000000,
        ShipVia: 'Federal Shipping',
        Freight: 0.59,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10332,
        CustomerReference: 'MEREP',
        CompanyName: "M\xe8re Paillarde",
        ContactName: "Jean Fresni\xe8re",
        Employee: 'Janet Leverling',
        InvoicedCost: 431.7060000000001,
        ItemCount: 11,
        ChangeLastOrder: 2,
        ItemCost: 42.2,
        OrderCost: 464.20000000000005,
        PackageCost: 5.94,
        OrderDate: 1476658800000,
        RequiredDate: 1480287600000,
        ShippedDate: 1477004400000,
        ShipVia: 'United Package',
        Freight: 52.84,
        ShipName: "M\xe8re Paillarde",
        ShipAddress: '43 rue St. Laurent',
        ShipCity: "Montr\xe9al",
        ShipRegion: 'Quebec',
        ShipPostalCode: 'H1J 1C3',
        ShipCountry: 'Canada',
        ArriveOnTime: 0
    },
    {
        OrderId: 10331,
        CustomerReference: 'BONAP',
        CompanyName: "Bon app'",
        ContactName: 'Laurence Lebihan',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 505.5119999999999,
        ItemCount: 7,
        ChangeLastOrder: 5,
        ItemCost: 84.96,
        OrderCost: 594.7199999999999,
        PackageCost: 9.667,
        OrderDate: 1476572400000,
        RequiredDate: 1480201200000,
        ShippedDate: 1477004400000,
        ShipVia: 'Speedy Express',
        Freight: 10.19,
        ShipName: "Bon app'",
        ShipAddress: '12, rue des Bouchers',
        ShipCity: 'Marseille',
        ShipRegion: null,
        ShipPostalCode: 13008,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10330,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Janet Leverling',
        InvoicedCost: 285.19199999999995,
        ItemCount: 6,
        ChangeLastOrder: 8,
        ItemCost: 55.92,
        OrderCost: 335.52,
        PackageCost: 8.286,
        OrderDate: 1476572400000,
        RequiredDate: 1478991600000,
        ShippedDate: 1477609200000,
        ShipVia: 'Speedy Express',
        Freight: 12.75,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10329,
        CustomerReference: 'SPLIR',
        CompanyName: 'Split Rail Beer & Ale',
        ContactName: 'Art Braunschweiger',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1355.8545,
        ItemCount: 13,
        ChangeLastOrder: 7,
        ItemCost: 99.33,
        OrderCost: 1291.29,
        PackageCost: 17.953,
        OrderDate: 1476486000000,
        RequiredDate: 1480114800000,
        ShippedDate: 1477177200000,
        ShipVia: 'United Package',
        Freight: 191.67,
        ShipName: 'Split Rail Beer & Ale',
        ShipAddress: 'P.O. Box 555',
        ShipCity: 'Lander',
        ShipRegion: 'WY',
        ShipPostalCode: 82520,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10328,
        CustomerReference: 'FURIB',
        CompanyName: 'Furia Bacalhau e Frutos do Mar',
        ContactName: 'Lino Rodriguez',
        Employee: 'Margaret Peacock',
        InvoicedCost: 148.75,
        ItemCount: 14,
        ChangeLastOrder: 27,
        ItemCost: 12.5,
        OrderCost: 175,
        PackageCost: 20.006,
        OrderDate: 1476399600000,
        RequiredDate: 1478818800000,
        ShippedDate: 1476658800000,
        ShipVia: 'Federal Shipping',
        Freight: 87.03,
        ShipName: 'Furia Bacalhau e Frutos do Mar',
        ShipAddress: 'Jardim das rosas n. 32',
        ShipCity: 'Lisboa',
        ShipRegion: null,
        ShipPostalCode: 1675,
        ShipCountry: 'Portugal',
        ArriveOnTime: 0
    },
    {
        OrderId: 10327,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Andrew Fuller',
        InvoicedCost: 132.74820000000003,
        ItemCount: 13,
        ChangeLastOrder: -1,
        ItemCost: 10.98,
        OrderCost: 142.74,
        PackageCost: 16.51,
        OrderDate: 1476140400000,
        RequiredDate: 1478559600000,
        ShippedDate: 1476399600000,
        ShipVia: 'Speedy Express',
        Freight: 63.36,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10326,
        CustomerReference: 'BOLID',
        CompanyName: "B\xf3lido Comidas preparadas",
        ContactName: "Mart\xedn Sommer",
        Employee: 'Margaret Peacock',
        InvoicedCost: 183.87199999999999,
        ItemCount: 8,
        ChangeLastOrder: -4,
        ItemCost: 27.04,
        OrderCost: 216.32,
        PackageCost: 10.16,
        OrderDate: 1476054000000,
        RequiredDate: 1478473200000,
        ShippedDate: 1476399600000,
        ShipVia: 'United Package',
        Freight: 77.92,
        ShipName: "B\xf3lido Comidas preparadas",
        ShipAddress: 'C/ Araquil, 67',
        ShipCity: 'Madrid',
        ShipRegion: null,
        ShipPostalCode: 28023,
        ShipCountry: 'Spain',
        ArriveOnTime: 0
    },
    {
        OrderId: 10325,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Nancy Davolio',
        InvoicedCost: 46.818,
        ItemCount: 6,
        ChangeLastOrder: 32,
        ItemCost: 9.18,
        OrderCost: 55.08,
        PackageCost: 8.574,
        OrderDate: 1475967600000,
        RequiredDate: 1477177200000,
        ShippedDate: 1476399600000,
        ShipVia: 'Federal Shipping',
        Freight: 64.86,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10324,
        CustomerReference: 'SAVEA',
        CompanyName: 'Save-a-lot Markets',
        ContactName: 'Jose Pavarotti',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 100.80000000000001,
        ItemCount: 5,
        ChangeLastOrder: 5,
        ItemCost: 19.2,
        OrderCost: 96,
        PackageCost: 6.905,
        OrderDate: 1475881200000,
        RequiredDate: 1478300400000,
        ShippedDate: 1476054000000,
        ShipVia: 'Speedy Express',
        Freight: 214.27,
        ShipName: 'Save-a-lot Markets',
        ShipAddress: '187 Suffolk Ln.',
        ShipCity: 'Boise',
        ShipRegion: 'ID',
        ShipPostalCode: 83720,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10323,
        CustomerReference: 'KOENE',
        CompanyName: "K\xf6niglich Essen",
        ContactName: 'Philip Cramer',
        Employee: 'Margaret Peacock',
        InvoicedCost: 780.725,
        ItemCount: 10,
        ChangeLastOrder: 42,
        ItemCost: 91.85,
        OrderCost: 918.5,
        PackageCost: 14.290000000000001,
        OrderDate: 1475794800000,
        RequiredDate: 1478214000000,
        ShippedDate: 1476399600000,
        ShipVia: 'Speedy Express',
        Freight: 4.88,
        ShipName: "K\xf6niglich Essen",
        ShipAddress: 'Maubelstr. 90',
        ShipCity: 'Brandenburg',
        ShipRegion: null,
        ShipPostalCode: 14776,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10322,
        CustomerReference: 'PERIC',
        CompanyName: "Pericles Comidas cl\xe1sicas",
        ContactName: "Guillermo Fern\xe1ndez",
        Employee: 'Robert King',
        InvoicedCost: 68.586,
        ItemCount: 12,
        ChangeLastOrder: -5,
        ItemCost: 4.97,
        OrderCost: 59.64,
        PackageCost: 13.799999999999999,
        OrderDate: 1475535600000,
        RequiredDate: 1477954800000,
        ShippedDate: 1477177200000,
        ShipVia: 'Federal Shipping',
        Freight: 0.4,
        ShipName: "Pericles Comidas cl\xe1sicas",
        ShipAddress: 'Calle Dr. Jorge Cash 321',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10321,
        CustomerReference: 'ISLAT',
        CompanyName: 'Island Trading',
        ContactName: 'Helen Bennett',
        Employee: 'Janet Leverling',
        InvoicedCost: 488.05469999999997,
        ItemCount: 9,
        ChangeLastOrder: 6,
        ItemCost: 58.31,
        OrderCost: 524.79,
        PackageCost: 12.429,
        OrderDate: 1475449200000,
        RequiredDate: 1477868400000,
        ShippedDate: 1476140400000,
        ShipVia: 'United Package',
        Freight: 3.43,
        ShipName: 'Island Trading',
        ShipAddress: 'Garden House, Crowther Way',
        ShipCity: 'Cowes',
        ShipRegion: 'Isle of Wight',
        ShipPostalCode: 'PO31 7PJ',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10320,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Steven Buchanan',
        InvoicedCost: 424.69350000000003,
        ItemCount: 11,
        ChangeLastOrder: -33,
        ItemCost: 36.77,
        OrderCost: 404.47,
        PackageCost: 12.649999999999999,
        OrderDate: 1475449200000,
        RequiredDate: 1476658800000,
        ShippedDate: 1476745200000,
        ShipVia: 'Federal Shipping',
        Freight: 34.57,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10319,
        CustomerReference: 'TORTU',
        CompanyName: 'Tortuga Restaurante',
        ContactName: 'Miguel Angel Paolino',
        Employee: 'Robert King',
        InvoicedCost: 223.0425,
        ItemCount: 9,
        ChangeLastOrder: -3,
        ItemCost: 21.55,
        OrderCost: 193.95000000000002,
        PackageCost: 11.43,
        OrderDate: 1475362800000,
        RequiredDate: 1477782000000,
        ShippedDate: 1476140400000,
        ShipVia: 'Federal Shipping',
        Freight: 64.5,
        ShipName: 'Tortuga Restaurante',
        ShipAddress: 'Avda. Azteca 123',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10318,
        CustomerReference: 'ISLAT',
        CompanyName: 'Island Trading',
        ContactName: 'Helen Bennett',
        Employee: 'Laura Callahan',
        InvoicedCost: 43.524,
        ItemCount: 6,
        ChangeLastOrder: 5,
        ItemCost: 7.8,
        OrderCost: 46.8,
        PackageCost: 8.286,
        OrderDate: 1475276400000,
        RequiredDate: 1477695600000,
        ShippedDate: 1475535600000,
        ShipVia: 'United Package',
        Freight: 4.73,
        ShipName: 'Island Trading',
        ShipAddress: 'Garden House, Crowther Way',
        ShipCity: 'Cowes',
        ShipRegion: 'Isle of Wight',
        ShipPostalCode: 'PO31 7PJ',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10317,
        CustomerReference: 'LONEP',
        CompanyName: 'Lonesome Pine Restaurant',
        ContactName: 'Fran Wilson',
        Employee: 'Michael Suyama',
        InvoicedCost: 1.2276,
        ItemCount: 11,
        ChangeLastOrder: 1,
        ItemCost: 0.12,
        OrderCost: 1.3199999999999998,
        PackageCost: 13.97,
        OrderDate: 1475190000000,
        RequiredDate: 1477609200000,
        ShippedDate: 1476054000000,
        ShipVia: 'Speedy Express',
        Freight: 12.69,
        ShipName: 'Lonesome Pine Restaurant',
        ShipAddress: '89 Chiaroscuro Rd.',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97219,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10316,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Nancy Davolio',
        InvoicedCost: 354.73199999999997,
        ItemCount: 8,
        ChangeLastOrder: 3,
        ItemCost: 42.23,
        OrderCost: 337.84,
        PackageCost: 4.32,
        OrderDate: 1474930800000,
        RequiredDate: 1477350000000,
        ShippedDate: 1475881200000,
        ShipVia: 'Federal Shipping',
        Freight: 150.15,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10315,
        CustomerReference: 'ISLAT',
        CompanyName: 'Island Trading',
        ContactName: 'Helen Bennett',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1050.4536,
        ItemCount: 14,
        ChangeLastOrder: 4,
        ItemCost: 80.68,
        OrderCost: 1129.52,
        PackageCost: 7.5600000000000005,
        OrderDate: 1474844400000,
        RequiredDate: 1477263600000,
        ShippedDate: 1475449200000,
        ShipVia: 'United Package',
        Freight: 41.76,
        ShipName: 'Island Trading',
        ShipAddress: 'Garden House, Crowther Way',
        ShipCity: 'Cowes',
        ShipRegion: 'Isle of Wight',
        ShipPostalCode: 'PO31 7PJ',
        ShipCountry: 'UK',
        ArriveOnTime: 0
    },
    {
        OrderId: 10314,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Nancy Davolio',
        InvoicedCost: 321.9825,
        ItemCount: 5,
        ChangeLastOrder: 3,
        ItemCost: 61.33,
        OrderCost: 306.65,
        PackageCost: 2.7,
        OrderDate: 1474758000000,
        RequiredDate: 1477177200000,
        ShippedDate: 1475535600000,
        ShipVia: 'United Package',
        Freight: 74.16,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10313,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Andrew Fuller',
        InvoicedCost: 118.6,
        ItemCount: 8,
        ChangeLastOrder: -16,
        ItemCost: 11.86,
        OrderCost: 94.88,
        PackageCost: 9.2,
        OrderDate: 1474671600000,
        RequiredDate: 1477090800000,
        ShippedDate: 1475535600000,
        ShipVia: 'United Package',
        Freight: 1.96,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10312,
        CustomerReference: 'WANDK',
        CompanyName: 'Die Wandernde Kuh',
        ContactName: "Rita M\xfcller",
        Employee: 'Andrew Fuller',
        InvoicedCost: 427.26599999999996,
        ItemCount: 6,
        ChangeLastOrder: 0,
        ItemCost: 67.82,
        OrderCost: 406.91999999999996,
        PackageCost: 7.62,
        OrderDate: 1474585200000,
        RequiredDate: 1477004400000,
        ShippedDate: 1475449200000,
        ShipVia: 'United Package',
        Freight: 40.26,
        ShipName: 'Die Wandernde Kuh',
        ShipAddress: 'Adenauerallee 900',
        ShipCity: 'Stuttgart',
        ShipRegion: null,
        ShipPostalCode: 70563,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10311,
        CustomerReference: 'DUMON',
        CompanyName: 'Du monde entier',
        ContactName: 'Janine Labrune',
        Employee: 'Nancy Davolio',
        InvoicedCost: 264.132,
        ItemCount: 11,
        ChangeLastOrder: 2,
        ItemCost: 16.56,
        OrderCost: 182.16,
        PackageCost: 5.94,
        OrderDate: 1474326000000,
        RequiredDate: 1475535600000,
        ShippedDate: 1474844400000,
        ShipVia: 'Federal Shipping',
        Freight: 24.69,
        ShipName: 'Du monde entier',
        ShipAddress: '67, rue des Cinquante Otages',
        ShipCity: 'Nantes',
        ShipRegion: null,
        ShipPostalCode: 44000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10310,
        CustomerReference: 'THEBI',
        CompanyName: 'The Big Cheese',
        ContactName: 'Liz Nixon',
        Employee: 'Laura Callahan',
        InvoicedCost: 228.585,
        ItemCount: 5,
        ChangeLastOrder: 1,
        ItemCost: 43.54,
        OrderCost: 217.7,
        PackageCost: 6.35,
        OrderDate: 1474326000000,
        RequiredDate: 1476745200000,
        ShippedDate: 1474930800000,
        ShipVia: 'United Package',
        Freight: 17.52,
        ShipName: 'The Big Cheese',
        ShipAddress: '89 Jefferson Way Suite 2',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97201,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10309,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Janet Leverling',
        InvoicedCost: 242.22780000000006,
        ItemCount: 9,
        ChangeLastOrder: 1,
        ItemCost: 28.94,
        OrderCost: 260.46000000000004,
        PackageCost: 11.43,
        OrderDate: 1474239600000,
        RequiredDate: 1476658800000,
        ShippedDate: 1477177200000,
        ShipVia: 'Speedy Express',
        Freight: 47.3,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10308,
        CustomerReference: 'ANATR',
        CompanyName: 'Ana Trujillo Emparedados y helados',
        ContactName: 'Ana Trujillo',
        Employee: 'Robert King',
        InvoicedCost: 706.4449999999999,
        ItemCount: 10,
        ChangeLastOrder: -3,
        ItemCost: 61.43,
        OrderCost: 614.3,
        PackageCost: 12.7,
        OrderDate: 1474153200000,
        RequiredDate: 1476572400000,
        ShippedDate: 1474671600000,
        ShipVia: 'Federal Shipping',
        Freight: 1.61,
        ShipName: 'Ana Trujillo Emparedados y helados',
        ShipAddress: "Avda. de la Constituci\xf3n 2222",
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5021,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10307,
        CustomerReference: 'LONEP',
        CompanyName: 'Lonesome Pine Restaurant',
        ContactName: 'Fran Wilson',
        Employee: 'Andrew Fuller',
        InvoicedCost: 503.01840000000004,
        ItemCount: 8,
        ChangeLastOrder: 1,
        ItemCost: 67.61,
        OrderCost: 540.88,
        PackageCost: 10.16,
        OrderDate: 1474066800000,
        RequiredDate: 1476486000000,
        ShippedDate: 1474758000000,
        ShipVia: 'United Package',
        Freight: 0.56,
        ShipName: 'Lonesome Pine Restaurant',
        ShipAddress: '89 Chiaroscuro Rd.',
        ShipCity: 'Portland',
        ShipRegion: 'OR',
        ShipPostalCode: 97219,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10306,
        CustomerReference: 'ROMEY',
        CompanyName: 'Romero y tomillo',
        ContactName: 'Alejandra Camino',
        Employee: 'Nancy Davolio',
        InvoicedCost: 236.81,
        ItemCount: 10,
        ChangeLastOrder: -10,
        ItemCost: 27.86,
        OrderCost: 278.6,
        PackageCost: 11.5,
        OrderDate: 1473980400000,
        RequiredDate: 1476399600000,
        ShippedDate: 1474585200000,
        ShipVia: 'Federal Shipping',
        Freight: 7.56,
        ShipName: 'Romero y tomillo',
        ShipAddress: "Gran V\xeda, 1",
        ShipCity: 'Madrid',
        ShipRegion: null,
        ShipPostalCode: 28001,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10305,
        CustomerReference: 'OLDWO',
        CompanyName: 'Old World Delicatessen',
        ContactName: 'Rene Phillips',
        Employee: 'Laura Callahan',
        InvoicedCost: 528.426,
        ItemCount: 6,
        ChangeLastOrder: 3,
        ItemCost: 94.7,
        OrderCost: 568.2,
        PackageCost: 3.24,
        OrderDate: 1473721200000,
        RequiredDate: 1476140400000,
        ShippedDate: 1475967600000,
        ShipVia: 'Federal Shipping',
        Freight: 257.62,
        ShipName: 'Old World Delicatessen',
        ShipAddress: '2743 Bering St.',
        ShipCity: 'Anchorage',
        ShipRegion: 'AK',
        ShipPostalCode: 99508,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10304,
        CustomerReference: 'TORTU',
        CompanyName: 'Tortuga Restaurante',
        ContactName: 'Miguel Angel Paolino',
        Employee: 'Nancy Davolio',
        InvoicedCost: 885.1204999999999,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 69.97,
        OrderCost: 769.67,
        PackageCost: 13.97,
        OrderDate: 1473634800000,
        RequiredDate: 1476054000000,
        ShippedDate: 1474066800000,
        ShipVia: 'United Package',
        Freight: 63.79,
        ShipName: 'Tortuga Restaurante',
        ShipAddress: 'Avda. Azteca 123',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 0
    },
    {
        OrderId: 10303,
        CustomerReference: 'GODOS',
        CompanyName: "Godos Cocina T\xedpica",
        ContactName: "Jos\xe9 Pedro Freyre",
        Employee: 'Robert King',
        InvoicedCost: 317.33624999999995,
        ItemCount: 11,
        ChangeLastOrder: -4,
        ItemCost: 32.97,
        OrderCost: 362.66999999999996,
        PackageCost: 13.97,
        OrderDate: 1473548400000,
        RequiredDate: 1475967600000,
        ShippedDate: 1474153200000,
        ShipVia: 'United Package',
        Freight: 107.83,
        ShipName: "Godos Cocina T\xedpica",
        ShipAddress: 'C/ Romero, 33',
        ShipCity: 'Sevilla',
        ShipRegion: null,
        ShipPostalCode: 41101,
        ShipCountry: 'Spain',
        ArriveOnTime: 0
    },
    {
        OrderId: 10302,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Margaret Peacock',
        InvoicedCost: 408.0375,
        ItemCount: 13,
        ChangeLastOrder: -4,
        ItemCost: 33.75,
        OrderCost: 438.75,
        PackageCost: 16.51,
        OrderDate: 1473462000000,
        RequiredDate: 1475881200000,
        ShippedDate: 1475967600000,
        ShipVia: 'United Package',
        Freight: 6.27,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 1
    },
    {
        OrderId: 10301,
        CustomerReference: 'WANDK',
        CompanyName: 'Die Wandernde Kuh',
        ContactName: "Rita M\xfcller",
        Employee: 'Laura Callahan',
        InvoicedCost: 815.472,
        ItemCount: 12,
        ChangeLastOrder: 0,
        ItemCost: 64.72,
        OrderCost: 776.64,
        PackageCost: 15.24,
        OrderDate: 1473375600000,
        RequiredDate: 1475794800000,
        ShippedDate: 1474066800000,
        ShipVia: 'United Package',
        Freight: 45.08,
        ShipName: 'Die Wandernde Kuh',
        ShipAddress: 'Adenauerallee 900',
        ShipCity: 'Stuttgart',
        ShipRegion: null,
        ShipPostalCode: 70563,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10300,
        CustomerReference: 'MAGAA',
        CompanyName: 'Magazzini Alimentari Riuniti',
        ContactName: 'Giovanni Rovelli',
        Employee: 'Andrew Fuller',
        InvoicedCost: 511.07099999999997,
        ItemCount: 11,
        ChangeLastOrder: -7,
        ItemCost: 54.66,
        OrderCost: 601.26,
        PackageCost: 12.649999999999999,
        OrderDate: 1473375600000,
        RequiredDate: 1475794800000,
        ShippedDate: 1474153200000,
        ShipVia: 'United Package',
        Freight: 17.68,
        ShipName: 'Magazzini Alimentari Riuniti',
        ShipAddress: 'Via Ludovico il Moro 22',
        ShipCity: 'Bergamo',
        ShipRegion: null,
        ShipPostalCode: 24100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10299,
        CustomerReference: 'RICAR',
        CompanyName: 'Ricardo Adocicados',
        ContactName: 'Janete Limeira',
        Employee: 'Margaret Peacock',
        InvoicedCost: 670.2199999999999,
        ItemCount: 10,
        ChangeLastOrder: -2,
        ItemCost: 58.28,
        OrderCost: 582.8,
        PackageCost: 12.7,
        OrderDate: 1473116400000,
        RequiredDate: 1475535600000,
        ShippedDate: 1473721200000,
        ShipVia: 'United Package',
        Freight: 29.76,
        ShipName: 'Ricardo Adocicados',
        ShipAddress: 'Av. Copacabana, 267',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-890',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10298,
        CustomerReference: 'HUNGO',
        CompanyName: 'Hungry Owl All-Night Grocers',
        ContactName: 'Patricia McKenna',
        Employee: 'Michael Suyama',
        InvoicedCost: 1145.0439000000001,
        ItemCount: 13,
        ChangeLastOrder: 1,
        ItemCost: 94.71,
        OrderCost: 1231.23,
        PackageCost: 16.51,
        OrderDate: 1473030000000,
        RequiredDate: 1475449200000,
        ShippedDate: 1473548400000,
        ShipVia: 'United Package',
        Freight: 168.22,
        ShipName: 'Hungry Owl All-Night Grocers',
        ShipAddress: '8 Johnstown Road',
        ShipCity: 'Cork',
        ShipRegion: 'Co. Cork',
        ShipPostalCode: null,
        ShipCountry: 'Ireland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10297,
        CustomerReference: 'BLONP',
        CompanyName: "Blondel p\xe8re et fils",
        ContactName: "Fr\xe9d\xe9rique Citeaux",
        Employee: 'Steven Buchanan',
        InvoicedCost: 42.78,
        ItemCount: 5,
        ChangeLastOrder: 4,
        ItemCost: 7.44,
        OrderCost: 37.2,
        PackageCost: 2.7,
        OrderDate: 1472943600000,
        RequiredDate: 1476572400000,
        ShippedDate: 1473462000000,
        ShipVia: 'United Package',
        Freight: 5.74,
        ShipName: "Blondel p\xe8re et fils",
        ShipAddress: "24, place Kl\xe9ber",
        ShipCity: 'Strasbourg',
        ShipRegion: null,
        ShipPostalCode: 67000,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10296,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Michael Suyama',
        InvoicedCost: 556.5035,
        ItemCount: 7,
        ChangeLastOrder: 11,
        ItemCost: 93.53,
        OrderCost: 654.71,
        PackageCost: 10.003,
        OrderDate: 1472857200000,
        RequiredDate: 1475276400000,
        ShippedDate: 1473548400000,
        ShipVia: 'Speedy Express',
        Freight: 0.12,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 1
    },
    {
        OrderId: 10295,
        CustomerReference: 'VINET',
        CompanyName: 'Vins et alcools Chevalier',
        ContactName: 'Paul Henriot',
        Employee: 'Andrew Fuller',
        InvoicedCost: 870.6995,
        ItemCount: 11,
        ChangeLastOrder: 2,
        ItemCost: 68.83,
        OrderCost: 757.13,
        PackageCost: 5.94,
        OrderDate: 1472770800000,
        RequiredDate: 1475190000000,
        ShippedDate: 1473462000000,
        ShipVia: 'United Package',
        Freight: 1.15,
        ShipName: 'Vins et alcools Chevalier',
        ShipAddress: "59 rue de l'Abbaye",
        ShipCity: 'Reims',
        ShipRegion: null,
        ShipPostalCode: 51100,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10294,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Margaret Peacock',
        InvoicedCost: 295.848,
        ItemCount: 8,
        ChangeLastOrder: 3,
        ItemCost: 35.22,
        OrderCost: 281.76,
        PackageCost: 4.32,
        OrderDate: 1472511600000,
        RequiredDate: 1474930800000,
        ShippedDate: 1473030000000,
        ShipVia: 'United Package',
        Freight: 147.26,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10293,
        CustomerReference: 'TORTU',
        CompanyName: 'Tortuga Restaurante',
        ContactName: 'Miguel Angel Paolino',
        Employee: 'Nancy Davolio',
        InvoicedCost: 747.3849999999999,
        ItemCount: 10,
        ChangeLastOrder: -3,
        ItemCost: 64.99,
        OrderCost: 649.9,
        PackageCost: 12.7,
        OrderDate: 1472425200000,
        RequiredDate: 1474844400000,
        ShippedDate: 1473548400000,
        ShipVia: 'Federal Shipping',
        Freight: 21.18,
        ShipName: 'Tortuga Restaurante',
        ShipAddress: 'Avda. Azteca 123',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10292,
        CustomerReference: 'TRADH',
        CompanyName: "Tradi\xe7\xe3o Hipermercados",
        ContactName: 'Anabela Domingues',
        Employee: 'Nancy Davolio',
        InvoicedCost: 298.554,
        ItemCount: 6,
        ChangeLastOrder: -3,
        ItemCost: 58.54,
        OrderCost: 351.24,
        PackageCost: 7.62,
        OrderDate: 1472338800000,
        RequiredDate: 1474758000000,
        ShippedDate: 1472770800000,
        ShipVia: 'United Package',
        Freight: 1.35,
        ShipName: "Tradi\xe7\xe3o Hipermercados",
        ShipAddress: "Av. In\xeas de Castro, 414",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05634-030',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10291,
        CustomerReference: 'QUEDE',
        CompanyName: "Que Del\xedcia",
        ContactName: 'Bernardo Batista',
        Employee: 'Michael Suyama',
        InvoicedCost: 748.6959999999999,
        ItemCount: 8,
        ChangeLastOrder: -4,
        ItemCost: 81.38,
        OrderCost: 651.04,
        PackageCost: 10.16,
        OrderDate: 1472252400000,
        RequiredDate: 1474671600000,
        ShippedDate: 1472943600000,
        ShipVia: 'United Package',
        Freight: 6.4,
        ShipName: "Que Del\xedcia",
        ShipAddress: 'Rua da Panificadora, 12',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-673',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10290,
        CustomerReference: 'COMMI',
        CompanyName: "Com\xe9rcio Mineiro",
        ContactName: 'Pedro Afonso',
        Employee: 'Laura Callahan',
        InvoicedCost: 596.904,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 63.84,
        OrderCost: 702.24,
        PackageCost: 13.97,
        OrderDate: 1472252400000,
        RequiredDate: 1474671600000,
        ShippedDate: 1472857200000,
        ShipVia: 'Speedy Express',
        Freight: 79.7,
        ShipName: "Com\xe9rcio Mineiro",
        ShipAddress: "Av. dos Lus\xedadas, 23",
        ShipCity: "S\xe3o Paulo",
        ShipRegion: 'SP',
        ShipPostalCode: '05432-043',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10289,
        CustomerReference: 'BSBEV',
        CompanyName: "B's Beverages",
        ContactName: 'Victoria Ashworth',
        Employee: 'Robert King',
        InvoicedCost: 1063.92,
        ItemCount: 13,
        ChangeLastOrder: 20,
        ItemCost: 88,
        OrderCost: 1144,
        PackageCost: 18.577,
        OrderDate: 1472166000000,
        RequiredDate: 1474585200000,
        ShippedDate: 1472338800000,
        ShipVia: 'Federal Shipping',
        Freight: 22.77,
        ShipName: "B's Beverages",
        ShipAddress: 'Fauntleroy Circus',
        ShipCity: 'London',
        ShipRegion: null,
        ShipPostalCode: 'EC2 5NT',
        ShipCountry: 'UK',
        ArriveOnTime: 1
    },
    {
        OrderId: 10288,
        CustomerReference: 'REGGC',
        CompanyName: 'Reggiani Caseifici',
        ContactName: 'Maurizio Moroni',
        Employee: 'Margaret Peacock',
        InvoicedCost: 775.1999999999999,
        ItemCount: 10,
        ChangeLastOrder: -8,
        ItemCost: 81.6,
        OrderCost: 816,
        PackageCost: 11.5,
        OrderDate: 1471906800000,
        RequiredDate: 1474326000000,
        ShippedDate: 1472857200000,
        ShipVia: 'Speedy Express',
        Freight: 7.45,
        ShipName: 'Reggiani Caseifici',
        ShipAddress: 'Strada Provinciale 124',
        ShipCity: 'Reggio Emilia',
        ShipRegion: null,
        ShipPostalCode: 42100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10287,
        CustomerReference: 'RICAR',
        CompanyName: 'Ricardo Adocicados',
        ContactName: 'Janete Limeira',
        Employee: 'Laura Callahan',
        InvoicedCost: 1205.292,
        ItemCount: 11,
        ChangeLastOrder: -2,
        ItemCost: 95.28,
        OrderCost: 1048.08,
        PackageCost: 13.97,
        OrderDate: 1471820400000,
        RequiredDate: 1474239600000,
        ShippedDate: 1472338800000,
        ShipVia: 'Federal Shipping',
        Freight: 12.76,
        ShipName: 'Ricardo Adocicados',
        ShipAddress: 'Av. Copacabana, 267',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-890',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10286,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Laura Callahan',
        InvoicedCost: 118.69999999999999,
        ItemCount: 8,
        ChangeLastOrder: -17,
        ItemCost: 11.87,
        OrderCost: 94.96,
        PackageCost: 9.2,
        OrderDate: 1471734000000,
        RequiredDate: 1474153200000,
        ShippedDate: 1472511600000,
        ShipVia: 'Federal Shipping',
        Freight: 229.24,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10285,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Nancy Davolio',
        InvoicedCost: 209,
        ItemCount: 11,
        ChangeLastOrder: 7,
        ItemCost: 15.2,
        OrderCost: 167.2,
        PackageCost: 15.191,
        OrderDate: 1471647600000,
        RequiredDate: 1474066800000,
        ShippedDate: 1472166000000,
        ShipVia: 'United Package',
        Freight: 76.83,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10284,
        CustomerReference: 'LEHMS',
        CompanyName: 'Lehmanns Marktstand',
        ContactName: 'Renate Messner',
        Employee: 'Margaret Peacock',
        InvoicedCost: 1102.206,
        ItemCount: 12,
        ChangeLastOrder: -29,
        ItemCost: 79.87,
        OrderCost: 958.44,
        PackageCost: 13.799999999999999,
        OrderDate: 1471561200000,
        RequiredDate: 1473980400000,
        ShippedDate: 1472252400000,
        ShipVia: 'Speedy Express',
        Freight: 76.56,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10283,
        CustomerReference: 'LILAS',
        CompanyName: 'LILA-Supermercado',
        ContactName: "Carlos Gonz\xe1lez",
        Employee: 'Janet Leverling',
        InvoicedCost: 96.38999999999999,
        ItemCount: 6,
        ChangeLastOrder: 5,
        ItemCost: 18.9,
        OrderCost: 113.39999999999999,
        PackageCost: 8.286,
        OrderDate: 1471302000000,
        RequiredDate: 1473721200000,
        ShippedDate: 1471906800000,
        ShipVia: 'Federal Shipping',
        Freight: 84.81,
        ShipName: 'LILA-Supermercado',
        ShipAddress: "Carrera 52 con Ave. Bol\xedvar #65-98 Llano Largo",
        ShipCity: 'Barquisimeto',
        ShipRegion: 'Lara',
        ShipPostalCode: 3508,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10282,
        CustomerReference: 'ROMEY',
        CompanyName: 'Romero y tomillo',
        ContactName: 'Alejandra Camino',
        Employee: 'Margaret Peacock',
        InvoicedCost: 8.9505,
        ItemCount: 13,
        ChangeLastOrder: -11,
        ItemCost: 0.81,
        OrderCost: 10.530000000000001,
        PackageCost: 14.95,
        OrderDate: 1471215600000,
        RequiredDate: 1473634800000,
        ShippedDate: 1471734000000,
        ShipVia: 'Speedy Express',
        Freight: 12.69,
        ShipName: 'Romero y tomillo',
        ShipAddress: "Gran V\xeda, 1",
        ShipCity: 'Madrid',
        ShipRegion: null,
        ShipPostalCode: 28001,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10281,
        CustomerReference: 'ROMEY',
        CompanyName: 'Romero y tomillo',
        ContactName: 'Alejandra Camino',
        Employee: 'Margaret Peacock',
        InvoicedCost: 454.3759999999999,
        ItemCount: 13,
        ChangeLastOrder: -9,
        ItemCost: 41.12,
        OrderCost: 534.56,
        PackageCost: 14.95,
        OrderDate: 1471129200000,
        RequiredDate: 1472338800000,
        ShippedDate: 1471734000000,
        ShipVia: 'Speedy Express',
        Freight: 2.94,
        ShipName: 'Romero y tomillo',
        ShipAddress: "Gran V\xeda, 1",
        ShipCity: 'Madrid',
        ShipRegion: null,
        ShipPostalCode: 28001,
        ShipCountry: 'Spain',
        ArriveOnTime: 1
    },
    {
        OrderId: 10280,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Andrew Fuller',
        InvoicedCost: 648.1728,
        ItemCount: 8,
        ChangeLastOrder: -3,
        ItemCost: 87.12,
        OrderCost: 696.96,
        PackageCost: 10.16,
        OrderDate: 1471129200000,
        RequiredDate: 1473548400000,
        ShippedDate: 1473634800000,
        ShipVia: 'Speedy Express',
        Freight: 8.98,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10279,
        CustomerReference: 'LAZYK',
        CompanyName: 'Lazy K Kountry Store',
        ContactName: 'John Steel',
        Employee: 'Laura Callahan',
        InvoicedCost: 705.7549999999999,
        ItemCount: 10,
        ChangeLastOrder: -24,
        ItemCost: 61.37,
        OrderCost: 613.6999999999999,
        PackageCost: 11.5,
        OrderDate: 1471042800000,
        RequiredDate: 1473462000000,
        ShippedDate: 1471302000000,
        ShipVia: 'United Package',
        Freight: 25.83,
        ShipName: 'Lehmanns Marktstand',
        ShipAddress: 'Magazinweg 7',
        ShipCity: 'Frankfurt a.M.',
        ShipRegion: null,
        ShipPostalCode: 60528,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10278,
        CustomerReference: 'BERGS',
        CompanyName: "Berglunds snabbk\xf6p",
        ContactName: 'Christina Berglund',
        Employee: 'Laura Callahan',
        InvoicedCost: 68.72699999999999,
        ItemCount: 5,
        ChangeLastOrder: -3,
        ItemCost: 14.78,
        OrderCost: 73.89999999999999,
        PackageCost: 6.35,
        OrderDate: 1470956400000,
        RequiredDate: 1473375600000,
        ShippedDate: 1471302000000,
        ShipVia: 'United Package',
        Freight: 92.69,
        ShipName: "Berglunds snabbk\xf6p",
        ShipAddress: "Berguvsv\xe4gen  8",
        ShipCity: "Lule\xe5",
        ShipRegion: null,
        ShipPostalCode: 'S-958 22',
        ShipCountry: 'Sweden',
        ArriveOnTime: 0
    },
    {
        OrderId: 10277,
        CustomerReference: 'MORGK',
        CompanyName: 'Morgenstern Gesundkost',
        ContactName: 'Alexander Feuer',
        Employee: 'Andrew Fuller',
        InvoicedCost: 1181.1419999999998,
        ItemCount: 12,
        ChangeLastOrder: -23,
        ItemCost: 85.59,
        OrderCost: 1027.08,
        PackageCost: 13.799999999999999,
        OrderDate: 1470697200000,
        RequiredDate: 1473116400000,
        ShippedDate: 1471042800000,
        ShipVia: 'Federal Shipping',
        Freight: 125.77,
        ShipName: 'Morgenstern Gesundkost',
        ShipAddress: 'Heerstr. 22',
        ShipCity: 'Leipzig',
        ShipRegion: null,
        ShipPostalCode: 4179,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10276,
        CustomerReference: 'TORTU',
        CompanyName: 'Tortuga Restaurante',
        ContactName: 'Miguel Angel Paolino',
        Employee: 'Laura Callahan',
        InvoicedCost: 514.7284999999999,
        ItemCount: 11,
        ChangeLastOrder: -3,
        ItemCost: 40.69,
        OrderCost: 447.59,
        PackageCost: 13.97,
        OrderDate: 1470610800000,
        RequiredDate: 1471820400000,
        ShippedDate: 1471129200000,
        ShipVia: 'Federal Shipping',
        Freight: 13.84,
        ShipName: 'Tortuga Restaurante',
        ShipAddress: 'Avda. Azteca 123',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5033,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10275,
        CustomerReference: 'MAGAA',
        CompanyName: 'Magazzini Alimentari Riuniti',
        ContactName: 'Giovanni Rovelli',
        Employee: 'Nancy Davolio',
        InvoicedCost: 881.7899999999998,
        ItemCount: 13,
        ChangeLastOrder: 2,
        ItemCost: 79.8,
        OrderCost: 1037.3999999999999,
        PackageCost: 7.0200000000000005,
        OrderDate: 1470524400000,
        RequiredDate: 1472943600000,
        ShippedDate: 1470697200000,
        ShipVia: 'Speedy Express',
        Freight: 26.93,
        ShipName: 'Magazzini Alimentari Riuniti',
        ShipAddress: 'Via Ludovico il Moro 22',
        ShipCity: 'Bergamo',
        ShipRegion: null,
        ShipPostalCode: 24100,
        ShipCountry: 'Italy',
        ArriveOnTime: 1
    },
    {
        OrderId: 10274,
        CustomerReference: 'VINET',
        CompanyName: 'Vins et alcools Chevalier',
        ContactName: 'Paul Henriot',
        Employee: 'Michael Suyama',
        InvoicedCost: 76.17599999999999,
        ItemCount: 6,
        ChangeLastOrder: 2,
        ItemCost: 11.04,
        OrderCost: 66.24,
        PackageCost: 3.24,
        OrderDate: 1470438000000,
        RequiredDate: 1472857200000,
        ShippedDate: 1471302000000,
        ShipVia: 'Speedy Express',
        Freight: 6.01,
        ShipName: 'Vins et alcools Chevalier',
        ShipAddress: "59 rue de l'Abbaye",
        ShipCity: 'Reims',
        ShipRegion: null,
        ShipPostalCode: 51100,
        ShipCountry: 'France',
        ArriveOnTime: 1
    },
    {
        OrderId: 10273,
        CustomerReference: 'QUICK',
        CompanyName: 'QUICK-Stop',
        ContactName: 'Horst Kloss',
        Employee: 'Janet Leverling',
        InvoicedCost: 636.8375,
        ItemCount: 13,
        ChangeLastOrder: -13,
        ItemCost: 39.19,
        OrderCost: 509.46999999999997,
        PackageCost: 14.95,
        OrderDate: 1470351600000,
        RequiredDate: 1472770800000,
        ShippedDate: 1470956400000,
        ShipVia: 'Federal Shipping',
        Freight: 76.07,
        ShipName: 'QUICK-Stop',
        ShipAddress: "Taucherstra\xdfe 10",
        ShipCity: 'Cunewalde',
        ShipRegion: null,
        ShipPostalCode: 1307,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10272,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Michael Suyama',
        InvoicedCost: 280.098,
        ItemCount: 6,
        ChangeLastOrder: 3,
        ItemCost: 44.46,
        OrderCost: 266.76,
        PackageCost: 3.24,
        OrderDate: 1470092400000,
        RequiredDate: 1472511600000,
        ShippedDate: 1470438000000,
        ShipVia: 'United Package',
        Freight: 98.03,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10271,
        CustomerReference: 'SPLIR',
        CompanyName: 'Split Rail Beer & Ale',
        ContactName: 'Art Braunschweiger',
        Employee: 'Michael Suyama',
        InvoicedCost: 712.572,
        ItemCount: 8,
        ChangeLastOrder: 12,
        ItemCost: 84.83,
        OrderCost: 678.64,
        PackageCost: 11.432,
        OrderDate: 1470006000000,
        RequiredDate: 1472425200000,
        ShippedDate: 1472511600000,
        ShipVia: 'United Package',
        Freight: 4.54,
        ShipName: 'Split Rail Beer & Ale',
        ShipAddress: 'P.O. Box 555',
        ShipCity: 'Lander',
        ShipRegion: 'WY',
        ShipPostalCode: 82520,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10270,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Nancy Davolio',
        InvoicedCost: 628.2044999999999,
        ItemCount: 7,
        ChangeLastOrder: 53,
        ItemCost: 85.47,
        OrderCost: 598.29,
        PackageCost: 10.003,
        OrderDate: 1470006000000,
        RequiredDate: 1472425200000,
        ShippedDate: 1470092400000,
        ShipVia: 'Speedy Express',
        Freight: 136.54,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10269,
        CustomerReference: 'WHITC',
        CompanyName: 'White Clover Markets',
        ContactName: 'Karl Jablonski',
        Employee: 'Steven Buchanan',
        InvoicedCost: 479.3220000000001,
        ItemCount: 12,
        ChangeLastOrder: 6,
        ItemCost: 42.95,
        OrderCost: 515.4000000000001,
        PackageCost: 16.572,
        OrderDate: 1469919600000,
        RequiredDate: 1471129200000,
        ShippedDate: 1470697200000,
        ShipVia: 'Speedy Express',
        Freight: 4.56,
        ShipName: 'White Clover Markets',
        ShipAddress: '1029 - 12th Ave. S.',
        ShipCity: 'Seattle',
        ShipRegion: 'WA',
        ShipPostalCode: 98124,
        ShipCountry: 'USA',
        ArriveOnTime: 1
    },
    {
        OrderId: 10268,
        CustomerReference: 'GROSR',
        CompanyName: 'GROSELLA-Restaurante',
        ContactName: 'Manuel Pereira',
        Employee: 'Laura Callahan',
        InvoicedCost: 81.26,
        ItemCount: 10,
        ChangeLastOrder: 2,
        ItemCost: 9.56,
        OrderCost: 95.60000000000001,
        PackageCost: 5.4,
        OrderDate: 1469833200000,
        RequiredDate: 1472252400000,
        ShippedDate: 1470092400000,
        ShipVia: 'Federal Shipping',
        Freight: 66.29,
        ShipName: 'GROSELLA-Restaurante',
        ShipAddress: "5\xaa Ave. Los Palos Grandes",
        ShipCity: 'Caracas',
        ShipRegion: 'DF',
        ShipPostalCode: 1081,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10267,
        CustomerReference: 'FRANK',
        CompanyName: 'Frankenversand',
        ContactName: 'Peter Franken',
        Employee: 'Margaret Peacock',
        InvoicedCost: 920.052,
        ItemCount: 9,
        ChangeLastOrder: -4,
        ItemCost: 97.36,
        OrderCost: 876.24,
        PackageCost: 11.43,
        OrderDate: 1469746800000,
        RequiredDate: 1472166000000,
        ShippedDate: 1470438000000,
        ShipVia: 'Speedy Express',
        Freight: 208.58,
        ShipName: 'Frankenversand',
        ShipAddress: 'Berliner Platz 43',
        ShipCity: "M\xfcnchen",
        ShipRegion: null,
        ShipPostalCode: 80805,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10266,
        CustomerReference: 'WARTH',
        CompanyName: 'Wartian Herkku',
        ContactName: 'Pirkko Koskitalo',
        Employee: 'Janet Leverling',
        InvoicedCost: 931.392,
        ItemCount: 12,
        ChangeLastOrder: 47,
        ItemCost: 73.92,
        OrderCost: 887.04,
        PackageCost: 17.148,
        OrderDate: 1469487600000,
        RequiredDate: 1473116400000,
        ShippedDate: 1469919600000,
        ShipVia: 'Federal Shipping',
        Freight: 25.73,
        ShipName: 'Wartian Herkku',
        ShipAddress: 'Torikatu 38',
        ShipCity: 'Oulu',
        ShipRegion: null,
        ShipPostalCode: 90110,
        ShipCountry: 'Finland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10265,
        CustomerReference: 'BLONP',
        CompanyName: "Blondel p\xe8re et fils",
        ContactName: "Fr\xe9d\xe9rique Citeaux",
        Employee: 'Andrew Fuller',
        InvoicedCost: 319.9529999999999,
        ItemCount: 6,
        ChangeLastOrder: 4,
        ItemCost: 46.37,
        OrderCost: 278.21999999999997,
        PackageCost: 3.24,
        OrderDate: 1469401200000,
        RequiredDate: 1471820400000,
        ShippedDate: 1470956400000,
        ShipVia: 'Speedy Express',
        Freight: 55.28,
        ShipName: "Blondel p\xe8re et fils",
        ShipAddress: "24, place Kl\xe9ber",
        ShipCity: 'Strasbourg',
        ShipRegion: null,
        ShipPostalCode: 67000,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10264,
        CustomerReference: 'FOLKO',
        CompanyName: "Folk och f\xe4 HB",
        ContactName: 'Maria Larsson',
        Employee: 'Michael Suyama',
        InvoicedCost: 736.467,
        ItemCount: 10,
        ChangeLastOrder: -1,
        ItemCost: 79.19,
        OrderCost: 791.9,
        PackageCost: 12.7,
        OrderDate: 1469314800000,
        RequiredDate: 1471734000000,
        ShippedDate: 1471906800000,
        ShipVia: 'Federal Shipping',
        Freight: 3.67,
        ShipName: "Folk och f\xe4 HB",
        ShipAddress: "\xc5kergatan 24",
        ShipCity: "Br\xe4cke",
        ShipRegion: null,
        ShipPostalCode: 'S-844 67',
        ShipCountry: 'Sweden',
        ArriveOnTime: 1
    },
    {
        OrderId: 10263,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 386.80950000000007,
        ItemCount: 11,
        ChangeLastOrder: 7,
        ItemCost: 33.49,
        OrderCost: 368.39000000000004,
        PackageCost: 15.191,
        OrderDate: 1469228400000,
        RequiredDate: 1471647600000,
        ShippedDate: 1469919600000,
        ShipVia: 'Federal Shipping',
        Freight: 146.06,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10262,
        CustomerReference: 'RATTC',
        CompanyName: 'Rattlesnake Canyon Grocery',
        ContactName: 'Paula Wilson',
        Employee: 'Laura Callahan',
        InvoicedCost: 1100.19,
        ItemCount: 13,
        ChangeLastOrder: 2,
        ItemCost: 80.6,
        OrderCost: 1047.8,
        PackageCost: 7.0200000000000005,
        OrderDate: 1469142000000,
        RequiredDate: 1471561200000,
        ShippedDate: 1469401200000,
        ShipVia: 'Federal Shipping',
        Freight: 48.29,
        ShipName: 'Rattlesnake Canyon Grocery',
        ShipAddress: '2817 Milton Dr.',
        ShipCity: 'Albuquerque',
        ShipRegion: 'NM',
        ShipPostalCode: 87110,
        ShipCountry: 'USA',
        ArriveOnTime: 0
    },
    {
        OrderId: 10261,
        CustomerReference: 'QUEDE',
        CompanyName: "Que Del\xedcia",
        ContactName: 'Bernardo Batista',
        Employee: 'Margaret Peacock',
        InvoicedCost: 270.94,
        ItemCount: 8,
        ChangeLastOrder: -1,
        ItemCost: 29.45,
        OrderCost: 235.6,
        PackageCost: 10.16,
        OrderDate: 1468882800000,
        RequiredDate: 1471302000000,
        ShippedDate: 1469833200000,
        ShipVia: 'United Package',
        Freight: 3.05,
        ShipName: "Que Del\xedcia",
        ShipAddress: 'Rua da Panificadora, 12',
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '02389-673',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10260,
        CustomerReference: 'OLDWO',
        CompanyName: 'Old World Delicatessen',
        ContactName: 'Rene Phillips',
        Employee: 'Margaret Peacock',
        InvoicedCost: 547.9749999999999,
        ItemCount: 10,
        ChangeLastOrder: 26,
        ItemCost: 47.65,
        OrderCost: 476.5,
        PackageCost: 14.290000000000001,
        OrderDate: 1468882800000,
        RequiredDate: 1471302000000,
        ShippedDate: 1469746800000,
        ShipVia: 'Speedy Express',
        Freight: 55.09,
        ShipName: "Ottilies K\xe4seladen",
        ShipAddress: 'Mehrheimerstr. 369',
        ShipCity: "K\xf6ln",
        ShipRegion: null,
        ShipPostalCode: 50739,
        ShipCountry: 'Germany',
        ArriveOnTime: 0
    },
    {
        OrderId: 10259,
        CustomerReference: 'CENTC',
        CompanyName: 'Centro comercial Moctezuma',
        ContactName: 'Francisco Chang',
        Employee: 'Margaret Peacock',
        InvoicedCost: 868.4339999999999,
        ItemCount: 12,
        ChangeLastOrder: 20,
        ItemCost: 62.93,
        OrderCost: 755.16,
        PackageCost: 17.148,
        OrderDate: 1468796400000,
        RequiredDate: 1471215600000,
        ShippedDate: 1469401200000,
        ShipVia: 'Federal Shipping',
        Freight: 3.25,
        ShipName: 'Centro comercial Moctezuma',
        ShipAddress: 'Sierras de Granada 9993',
        ShipCity: "M\xe9xico D.F.",
        ShipRegion: null,
        ShipPostalCode: 5022,
        ShipCountry: 'Mexico',
        ArriveOnTime: 1
    },
    {
        OrderId: 10258,
        CustomerReference: 'ERNSH',
        CompanyName: 'Ernst Handel',
        ContactName: 'Roland Mendel',
        Employee: 'Nancy Davolio',
        InvoicedCost: 1182.7725,
        ItemCount: 13,
        ChangeLastOrder: -6,
        ItemCost: 86.65,
        OrderCost: 1126.45,
        PackageCost: 14.95,
        OrderDate: 1468710000000,
        RequiredDate: 1471129200000,
        ShippedDate: 1469228400000,
        ShipVia: 'Speedy Express',
        Freight: 140.51,
        ShipName: 'Ernst Handel',
        ShipAddress: 'Kirchgasse 6',
        ShipCity: 'Graz',
        ShipRegion: null,
        ShipPostalCode: 8010,
        ShipCountry: 'Austria',
        ArriveOnTime: 0
    },
    {
        OrderId: 10257,
        CustomerReference: 'HILAA',
        CompanyName: "HILARI\xd3N-Abastos",
        ContactName: "Carlos Hern\xe1ndez",
        Employee: 'Margaret Peacock',
        InvoicedCost: 764.5896,
        ItemCount: 9,
        ChangeLastOrder: -5,
        ItemCost: 82.48,
        OrderCost: 742.32,
        PackageCost: 10.35,
        OrderDate: 1468623600000,
        RequiredDate: 1471042800000,
        ShippedDate: 1469142000000,
        ShipVia: 'Federal Shipping',
        Freight: 81.91,
        ShipName: "HILARI\xd3N-Abastos",
        ShipAddress: 'Carrera 22 con Ave. Carlos Soublette #8-35',
        ShipCity: "San Crist\xf3bal",
        ShipRegion: "T\xe1chira",
        ShipPostalCode: 5022,
        ShipCountry: 'Venezuela',
        ArriveOnTime: 0
    },
    {
        OrderId: 10256,
        CustomerReference: 'WELLI',
        CompanyName: 'Wellington Importadora',
        ContactName: 'Paula Parente',
        Employee: 'Janet Leverling',
        InvoicedCost: 624.5459999999999,
        ItemCount: 12,
        ChangeLastOrder: -11,
        ItemCost: 61.23,
        OrderCost: 734.76,
        PackageCost: 13.799999999999999,
        OrderDate: 1468537200000,
        RequiredDate: 1470956400000,
        ShippedDate: 1468710000000,
        ShipVia: 'United Package',
        Freight: 13.97,
        ShipName: 'Wellington Importadora',
        ShipAddress: 'Rua do Mercado, 12',
        ShipCity: 'Resende',
        ShipRegion: 'SP',
        ShipPostalCode: '08737-363',
        ShipCountry: 'Brazil',
        ArriveOnTime: 1
    },
    {
        OrderId: 10255,
        CustomerReference: 'RICSU',
        CompanyName: 'Richter Supermarkt',
        ContactName: 'Michael Holz',
        Employee: 'Anne Dodsworth',
        InvoicedCost: 208.896,
        ItemCount: 12,
        ChangeLastOrder: -2,
        ItemCost: 20.48,
        OrderCost: 245.76,
        PackageCost: 15.24,
        OrderDate: 1468278000000,
        RequiredDate: 1470697200000,
        ShippedDate: 1468537200000,
        ShipVia: 'Federal Shipping',
        Freight: 148.33,
        ShipName: 'Richter Supermarkt',
        ShipAddress: 'Starenweg 5',
        ShipCity: "Gen\xe8ve",
        ShipRegion: null,
        ShipPostalCode: 1204,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 0
    },
    {
        OrderId: 10254,
        CustomerReference: 'CHOPS',
        CompanyName: 'Chop-suey Chinese',
        ContactName: 'Yang Wang',
        Employee: 'Steven Buchanan',
        InvoicedCost: 183.75300000000001,
        ItemCount: 6,
        ChangeLastOrder: -19,
        ItemCost: 36.03,
        OrderCost: 216.18,
        PackageCost: 6.8999999999999995,
        OrderDate: 1468191600000,
        RequiredDate: 1470610800000,
        ShippedDate: 1469228400000,
        ShipVia: 'United Package',
        Freight: 22.98,
        ShipName: 'Chop-suey Chinese',
        ShipAddress: 'Hauptstr. 31',
        ShipCity: 'Bern',
        ShipRegion: null,
        ShipPostalCode: 3012,
        ShipCountry: 'Switzerland',
        ArriveOnTime: 1
    },
    {
        OrderId: 10253,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Janet Leverling',
        InvoicedCost: 425.24649999999997,
        ItemCount: 7,
        ChangeLastOrder: -23,
        ItemCost: 71.47,
        OrderCost: 500.28999999999996,
        PackageCost: 8.049999999999999,
        OrderDate: 1468105200000,
        RequiredDate: 1469314800000,
        ShippedDate: 1468623600000,
        ShipVia: 'United Package',
        Freight: 58.17,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10252,
        CustomerReference: 'SUPRD',
        CompanyName: "Supr\xeames d\xe9lices",
        ContactName: 'Pascale Cartrain',
        Employee: 'Margaret Peacock',
        InvoicedCost: 740.2800000000001,
        ItemCount: 10,
        ChangeLastOrder: -4,
        ItemCost: 79.6,
        OrderCost: 796,
        PackageCost: 12.7,
        OrderDate: 1468018800000,
        RequiredDate: 1470438000000,
        ShippedDate: 1468191600000,
        ShipVia: 'United Package',
        Freight: 51.3,
        ShipName: "Supr\xeames d\xe9lices",
        ShipAddress: 'Boulevard Tirou, 255',
        ShipCity: 'Charleroi',
        ShipRegion: null,
        ShipPostalCode: 'B-6000',
        ShipCountry: 'Belgium',
        ArriveOnTime: 0
    },
    {
        OrderId: 10251,
        CustomerReference: 'VICTE',
        CompanyName: 'Victuailles en stock',
        ContactName: 'Mary Saveley',
        Employee: 'Janet Leverling',
        InvoicedCost: 45.885000000000005,
        ItemCount: 10,
        ChangeLastOrder: 5,
        ItemCost: 4.37,
        OrderCost: 43.7,
        PackageCost: 13.81,
        OrderDate: 1467932400000,
        RequiredDate: 1470351600000,
        ShippedDate: 1468537200000,
        ShipVia: 'Speedy Express',
        Freight: 41.34,
        ShipName: 'Victuailles en stock',
        ShipAddress: '2, rue du Commerce',
        ShipCity: 'Lyon',
        ShipRegion: null,
        ShipPostalCode: 69004,
        ShipCountry: 'France',
        ArriveOnTime: 0
    },
    {
        OrderId: 10250,
        CustomerReference: 'HANAR',
        CompanyName: 'Hanari Carnes',
        ContactName: 'Mario Pontes',
        Employee: 'Margaret Peacock',
        InvoicedCost: 44.625,
        ItemCount: 7,
        ChangeLastOrder: -30,
        ItemCost: 7.5,
        OrderCost: 52.5,
        PackageCost: 8.049999999999999,
        OrderDate: 1467932400000,
        RequiredDate: 1470351600000,
        ShippedDate: 1468278000000,
        ShipVia: 'United Package',
        Freight: 65.83,
        ShipName: 'Hanari Carnes',
        ShipAddress: "Rua do Pa\xe7o, 67",
        ShipCity: 'Rio de Janeiro',
        ShipRegion: 'RJ',
        ShipPostalCode: '05454-876',
        ShipCountry: 'Brazil',
        ArriveOnTime: 0
    },
    {
        OrderId: 10249,
        CustomerReference: 'TRADH',
        CompanyName: "Tradi\xe7\xe3o Hipermercados",
        ContactName: 'Anabela Domingues',
        Employee: 'Michael Suyama',
        InvoicedCost: 535.7442,
        ItemCount: 6,
        ChangeLastOrder: -10,
        ItemCost: 86.69,
        OrderCost: 520.14,
        PackageCost: 6.8999999999999995,
        OrderDate: 1467673200000,
        RequiredDate: 1471302000000,
        ShippedDate: 1468105200000,
        ShipVia: 'Speedy Express',
        Freight: 11.61,
        ShipName: "Toms Spezialit\xe4ten",
        ShipAddress: 'Luisenstr. 48',
        ShipCity: "M\xfcnster",
        ShipRegion: null,
        ShipPostalCode: 44087,
        ShipCountry: 'Germany',
        ArriveOnTime: 1
    },
    {
        OrderId: 10248,
        CustomerReference: 'WILMK',
        CompanyName: 'Wilman Kala',
        ContactName: 'Matti Karttunen',
        Employee: 'Steven Buchanan',
        InvoicedCost: 545.8705,
        ItemCount: 7,
        ChangeLastOrder: 2,
        ItemCost: 67.81,
        OrderCost: 474.67,
        PackageCost: 3.7800000000000002,
        OrderDate: 1467586800000,
        RequiredDate: 1470006000000,
        ShippedDate: 1468623600000,
        ShipVia: 'Federal Shipping',
        Freight: 32.38,
        ShipName: 'Vins et alcools Chevalier',
        ShipAddress: "59 rue de l'Abbaye",
        ShipCity: 'Reims',
        ShipRegion: null,
        ShipPostalCode: 51100,
        ShipCountry: 'France',
        ArriveOnTime: 1
    }
];







var $ac1da9cc72705fce$export$2e2bcd8739ae039 = {
    IPUSHPULL_API_KEY: "CbBaMaoqHVifScrYwKssGnGyNkv5xHOhQVGm3cYP",
    IPUSHPULL_API_SECRET: "xYzE51kuHyyt9kQCvMe0tz0H2sDSjyEQcF5SOBlPQmcL9em0NqcCzyqLYj5fhpuZxQ8BiVcYl6zoOHeI6GYZj1TkUiiLVFoW3HUxiCdEUjlPS8Vl2YHUMEPD5qkLYnGj"
};


var $cd1eed0c389a45a8$exports = {};
$cd1eed0c389a45a8$exports = JSON.parse("{\"name\":\"@adaptabletools/adaptable-plugin-ipushpull\",\"version\":\"22.0.3\",\"description\":\"\",\"homepage\":\"http://www.adaptabletools.com/\",\"author\":{\"name\":\"Jonny Wolfson\",\"email\":\"jonny.wolfson@adaptabletools.com\"},\"typings\":\"src/index.d.ts\",\"dependencies\":{\"react\":\"^18.0.0 || ^19.0.0\",\"react-redux\":\"^9.2.0\",\"redux\":\"^5.0.1\",\"styled-components\":\"^4.4.1\",\"tslib\":\"^2.8.1\"},\"type\":\"module\",\"module\":\"src/index.js\"}");










const $fb84a652b34fae33$var$EQUAL_DATA_ERR = 'equal data, so not sending';
class $fb84a652b34fae33$export$96a886b20fd8468c extends (0, $882fe271edda834e$export$4233ed07d8ff5f4c) {
    isSendingData = false;
    ippService = null;
    adaptable;
    throttledRecomputeAndSendLiveDataEvent;
    lastData;
    constructor(api){
        super($42e863194fcb493f$export$d7882f1fbc82745, 'ipushpull', 'download', null, 'Send data from AdapTable to ipushpull', api);
        this.adaptable = api.internalApi.getAdaptableInstance();
        this.api.eventApi.on('AdaptableReady', ()=>{
            setTimeout(()=>{
                this.throttledRecomputeAndSendLiveDataEvent = (0, $3a4c9a3b92c4503b$export$2e2bcd8739ae039)(()=>this.sendNewLiveData(), this.getThrottleTimeFromState());
            }, 1000);
            // if a piece of data has updated then update any live reports except cell or row selected where the data change is relevant
            // currently we DONT send deltas - we simply send everything to ipushpull every time a relevant change happens
            this.api.internalApi.getDataService().on('CellDataChanged', (cellDataChangedInfo)=>{
                const api = this.getIPPApi();
                const exportApi = this.api.exportApi;
                if (api.isIPushPullLiveDataRunning()) {
                    let currentLiveIPushPullReport = api.getCurrentLiveIPushPullReport();
                    if (currentLiveIPushPullReport && currentLiveIPushPullReport.ReportName !== (0, $58846ea7f4156db7$export$4c13590ee8958b49) && exportApi.internalApi.isDataChangeInReport(cellDataChangedInfo, this.getCurrentReport())) this.throttledRecomputeAndSendLiveDataEvent();
                }
            });
            // if the grid has refreshed then update all live reports
            this.adaptable._on('GridRefreshed', ()=>{
                if (this.getIPPApi().isIPushPullLiveDataRunning()) this.throttledRecomputeAndSendLiveDataEvent();
            });
            // if the grid filters have changed then update any live reports except cell or row selected
            this.adaptable._on('AdapTableFiltersApplied', ()=>{
                // Rerun all reports except selected cells / rows when filter changes
                if (this.getIPPApi().isIPushPullLiveDataRunning()) {
                    let currentLiveIPushPullReport = this.getIPPApi().getCurrentLiveIPushPullReport();
                    if (currentLiveIPushPullReport && currentLiveIPushPullReport.ReportName !== (0, $58846ea7f4156db7$export$4c13590ee8958b49)) this.throttledRecomputeAndSendLiveDataEvent();
                }
            });
            // if grid selection has changed and the ipushpull Live report is 'Selected Cells' or 'Selected Rows' then send updated data
            this.api.eventApi.on('CellSelectionChanged', ()=>{
                if (this.getIPPApi().isIPushPullLiveDataRunning()) {
                    let currentLiveIPushPullReport = this.getIPPApi().getCurrentLiveIPushPullReport();
                    if (currentLiveIPushPullReport && currentLiveIPushPullReport.ReportName === (0, $58846ea7f4156db7$export$4c13590ee8958b49)) this.throttledRecomputeAndSendLiveDataEvent();
                }
            });
            this.api.eventApi.on('RowSelectionChanged', ()=>{
                if (this.getIPPApi().isIPushPullLiveDataRunning()) {
                    let currentLiveIPushPullReport = this.getIPPApi().getCurrentLiveIPushPullReport();
                    if (currentLiveIPushPullReport && currentLiveIPushPullReport.ReportName === (0, $58846ea7f4156db7$export$4c13590ee8958b49)) this.throttledRecomputeAndSendLiveDataEvent();
                }
            });
        });
    }
    getViewAccessLevel() {
        return 'Full';
    }
    setModuleEntitlement() {
        // TODO
        if (!this.api.pluginsApi.getipushpullPluginApi().isIPushPullAvailable()) this.AccessLevel = 'Hidden';
        else this.AccessLevel = this.api.entitlementApi.getEntitlementAccessLevelForModule(this.moduleInfo.ModuleName);
    }
    getIPPApi() {
        return this.api.pluginsApi.getipushpullPluginApi();
    }
    getCurrentReport() {
        const api = this.getIPPApi();
        const exportApi = this.api.exportApi;
        if (api.isIPushPullLiveDataRunning()) {
            let currentLiveIPushPullReport = api.getCurrentLiveIPushPullReport();
            return currentLiveIPushPullReport ? exportApi.getReportByName(currentLiveIPushPullReport.ReportName) : null;
        }
        return null;
    }
    getIPPService() {
        if (!this.ippService) this.ippService = this.adaptable.getPluginProperty('ipushpull', 'service') || null;
        return this.ippService;
    }
    sendNewLiveData() {
        // We wait for the last sendNewLiveData to finish
        if (this.isSendingData === true) {
            this.throttledRecomputeAndSendLiveDataEvent();
            return;
        }
        const currentLiveIPushPullReport = this.getIPPApi().getCurrentLiveIPushPullReport();
        if (currentLiveIPushPullReport) {
            this.isSendingData = true;
            this.api.exportApi.getReportData(currentLiveIPushPullReport.ReportName, 'JSON').then((exportResultData)=>{
                if (exportResultData?.type !== 'json' || !exportResultData.data) throw new Error('No data in the report');
                const reportDataAsArray = this.api.exportApi.internalApi.convertReportDataToArray(exportResultData.data);
                const currentData = JSON.stringify(reportDataAsArray);
                if (currentData === this.lastData) {
                    this.adaptable.logger.warn($fb84a652b34fae33$var$EQUAL_DATA_ERR);
                    this.isSendingData = false;
                    throw new Error($fb84a652b34fae33$var$EQUAL_DATA_ERR); // Using throw to exit the promise chain
                }
                return {
                    reportDataAsArray: reportDataAsArray,
                    currentData: currentData
                };
            }).then(({ reportDataAsArray: reportDataAsArray, currentData: currentData })=>{
                return this.getIPPService().pushData(currentLiveIPushPullReport.Page, reportDataAsArray).then(()=>currentData); // Pass currentData to the next then
            }).then((currentData)=>{
                this.lastData = currentData;
                this.adaptable.logger.success('Live report data sent successfully.');
                this.isSendingData = false;
                return this.api.exportApi.internalApi.publishLiveLiveDataChangedEvent('ipushpull', 'LiveDataUpdated', currentLiveIPushPullReport);
            }).catch((reason)=>{
                // Skip logging for expected cases
                if (reason?.message !== $fb84a652b34fae33$var$EQUAL_DATA_ERR) {
                    this.isSendingData = false;
                    this.adaptable.logger.warn(`Failed to send data to ipushpull for report "${currentLiveIPushPullReport.ReportName}".`, reason);
                    this.stopLiveData();
                    let errorMessage = 'Export failed';
                    if (reason) errorMessage += ': ' + reason;
                    errorMessage += '. The live export has been cancelled.';
                    this.api.alertApi.showAlertError('ipushpull Export', errorMessage);
                }
            });
        }
    }
    sendSnapshot(iPushPullReport) {
        this.getIPPService().loadPage(iPushPullReport.Folder, iPushPullReport.Page).then(()=>{
            return this.api.exportApi.getReportData(iPushPullReport.ReportName, 'JSON');
        }).then((exportResultData)=>{
            if (exportResultData?.type === 'json' && exportResultData?.data) {
                const reportDataAsArray = this.api.exportApi.internalApi.convertReportDataToArray(exportResultData.data);
                return this.getIPPService().pushData(iPushPullReport.Page, reportDataAsArray);
            }
        }).catch((error)=>{
            this.adaptable.logger.warn(`Failed to send snapshot for report "${iPushPullReport.ReportName}".`, error);
        });
    }
    startLiveData(iPushPullReport) {
        this.getIPPService().loadPage(iPushPullReport.Folder, iPushPullReport.Page).then(()=>{
            this.getIPPApi().startLiveData(iPushPullReport);
        });
    }
    stopLiveData() {
        this.lastData = '';
        this.getIPPApi().stopLiveData();
    }
    getThrottleTimeFromState() {
        let iPushPullThrottleTime;
        if (this.getIPPApi().isIPushPullRunning()) iPushPullThrottleTime = this.getIPPApi().getIPushPullThrottleTime();
        return iPushPullThrottleTime ? iPushPullThrottleTime : (0, $58846ea7f4156db7$export$aa2a8da74cb7a351);
    }
}






const $8f5053e15e66a59b$export$e299ae49b4187a35 = (throttleTime)=>({
        type: (0, $b332b9d7a4fcbf15$export$bf8267dee15d27a1),
        throttleTime: throttleTime
    });
const $8f5053e15e66a59b$export$4895b0ddade012ff = (iPushPullReport)=>({
        type: (0, $b332b9d7a4fcbf15$export$5cf68f01567f5ed0),
        iPushPullReport: iPushPullReport
    });
const $8f5053e15e66a59b$export$d7db8c3d4d7faf2a = (iPushPullReport)=>({
        type: (0, $b332b9d7a4fcbf15$export$823995ecb5bf874d),
        iPushPullReport: iPushPullReport
    });
const $8f5053e15e66a59b$export$ce060e5a3887b0a0 = ()=>({
        type: (0, $b332b9d7a4fcbf15$export$18523e8ab138b69e)
    });
const $8f5053e15e66a59b$export$a7873a5d150c8c7d = (username, password)=>({
        type: (0, $b332b9d7a4fcbf15$export$97611c4cb3a0ddd),
        username: username,
        password: password
    });
const $8f5053e15e66a59b$export$9fd02cd905cbd199 = ()=>({
        type: (0, $b332b9d7a4fcbf15$export$ee380c94afcad085)
    });
const $8f5053e15e66a59b$export$dcf1733b0c2d1450 = (username, password)=>({
        type: (0, $b332b9d7a4fcbf15$export$1cc9a47c9c4d4576),
        username: username,
        password: password
    });
const $8f5053e15e66a59b$export$850d38e17332428d = (errorMessage)=>({
        type: (0, $b332b9d7a4fcbf15$export$1e66daa4a0883a40),
        errorMessage: errorMessage
    });
const $8f5053e15e66a59b$export$e4776ae873a0598 = (folder, page)=>({
        type: (0, $b332b9d7a4fcbf15$export$719706ab038ecef2),
        folder: folder,
        page: page
    });
const $8f5053e15e66a59b$export$61d7b3e456009f7d = ()=>({
        type: (0, $b332b9d7a4fcbf15$export$326dcf8038b1f6b4)
    });
const $8f5053e15e66a59b$export$d30d86f3dddd8ab6 = ()=>({
        type: (0, $b332b9d7a4fcbf15$export$c355a1c1eba845f)
    });
const $8f5053e15e66a59b$export$ff12813568adabab = ()=>({
        type: (0, $b332b9d7a4fcbf15$export$ff61e0626166116d)
    });
const $8f5053e15e66a59b$export$e8f9c2845f3cf4ad = ()=>({
        type: (0, $b332b9d7a4fcbf15$export$4da857739f70194b)
    });
const $8f5053e15e66a59b$export$f6b6c97faf76cd6f = (IPushPullDomainsPages)=>{
    return {
        type: (0, $b332b9d7a4fcbf15$export$90fd41a2d8f80c6d),
        IPushPullDomainsPages: IPushPullDomainsPages
    };
};
const $8f5053e15e66a59b$export$9bc9d407cc12202a = ()=>{
    return {
        type: (0, $b332b9d7a4fcbf15$export$a4523662c2a48494)
    };
};
const $8f5053e15e66a59b$export$6e1a09392c0479ce = (iPushPullReport)=>({
        type: (0, $b332b9d7a4fcbf15$export$517a85d932dcb8ac),
        iPushPullReport: iPushPullReport
    });
const $8f5053e15e66a59b$export$6468a1977505a334 = ()=>({
        type: (0, $b332b9d7a4fcbf15$export$929ea367be1723ce)
    });
const $8f5053e15e66a59b$export$d9e0ea8cfc47aa7a = (reportName)=>({
        type: (0, $b332b9d7a4fcbf15$export$724fba4549257566),
        reportName: reportName
    });
const $8f5053e15e66a59b$export$3f022151ad608e08 = (folder)=>({
        type: (0, $b332b9d7a4fcbf15$export$91291e6c6b03ce02),
        folder: folder
    });
const $8f5053e15e66a59b$export$503949f7c3c5a524 = (page)=>({
        type: (0, $b332b9d7a4fcbf15$export$1fc55e03b87b7d30),
        page: page
    });
const $8f5053e15e66a59b$export$5156292a65af67d6 = (availablePages)=>({
        type: (0, $b332b9d7a4fcbf15$export$68fb732f543467a4),
        availablePages: availablePages
    });
const $8f5053e15e66a59b$export$3c0028bf13480f9d = {
    IsIPushPullRunning: false,
    IPushPullDomainsPages: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
    CurrentLiveIPushPullReport: undefined,
    IPushPullLoginErrorMessage: undefined,
    IPushPullCurrentReportName: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
    IPushPullCurrentFolder: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
    IPushPullCurrentPage: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
    IPushPullCurrentAvailablePages: (0, $58846ea7f4156db7$export$2c66e96878bf4792)
};
const $8f5053e15e66a59b$export$3266d8d988b14ac = (// initial state is handled in the plugin rootReducer
state, action)=>{
    switch(action.type){
        case 0, $b332b9d7a4fcbf15$export$326dcf8038b1f6b4:
            return Object.assign({}, state, {
                IsIPushPullAvailable: true
            });
        case 0, $b332b9d7a4fcbf15$export$c355a1c1eba845f:
            return Object.assign({}, state, {
                IsIPushPullAvailable: false
            });
        case 0, $b332b9d7a4fcbf15$export$ff61e0626166116d:
            return Object.assign({}, state, {
                IsIPushPullRunning: true
            });
        case 0, $b332b9d7a4fcbf15$export$4da857739f70194b:
            return Object.assign({}, state, {
                IsIPushPullRunning: false
            });
        case 0, $b332b9d7a4fcbf15$export$1cc9a47c9c4d4576:
            {
                let loginAction = action;
                return {
                    ...state,
                    CurrentIPushpullUsername: loginAction.username,
                    CurrentIPushpullPassword: loginAction.password
                };
            }
        case 0, $b332b9d7a4fcbf15$export$ee380c94afcad085:
            return {
                ...state,
                CurrentIPushpullUsername: undefined,
                CurrentIPushpullPassword: undefined
            };
        case 0, $b332b9d7a4fcbf15$export$1e66daa4a0883a40:
            return {
                ...state,
                IPushPullLoginErrorMessage: action.errorMessage
            };
        case 0, $b332b9d7a4fcbf15$export$90fd41a2d8f80c6d:
            return Object.assign({}, state, {
                IPushPullDomainsPages: action.IPushPullDomainsPages || []
            });
        case 0, $b332b9d7a4fcbf15$export$a4523662c2a48494:
            return Object.assign({}, state, {
                IPushPullDomainsPages: []
            });
        case 0, $b332b9d7a4fcbf15$export$517a85d932dcb8ac:
            {
                const actionType = action;
                return Object.assign({}, state, {
                    CurrentLiveIPushPullReport: actionType.iPushPullReport
                });
            }
        case 0, $b332b9d7a4fcbf15$export$929ea367be1723ce:
            // const atctionType = action as IPushPullLiveReportSetAction;
            return Object.assign({}, state, {
                CurrentLiveIPushPullReport: undefined
            });
        case 0, $b332b9d7a4fcbf15$export$724fba4549257566:
            {
                const actionTyped = action;
                return Object.assign({}, state, {
                    IPushPullCurrentReportName: actionTyped.reportName
                });
            }
        case 0, $b332b9d7a4fcbf15$export$91291e6c6b03ce02:
            {
                const actionTyped = action;
                return Object.assign({}, state, {
                    IPushPullCurrentFolder: actionTyped.folder
                });
            }
        case 0, $b332b9d7a4fcbf15$export$1fc55e03b87b7d30:
            {
                const actionTyped = action;
                return Object.assign({}, state, {
                    IPushPullCurrentPage: actionTyped.page
                });
            }
        case 0, $b332b9d7a4fcbf15$export$68fb732f543467a4:
            {
                const actionTyped = action;
                return Object.assign({}, state, {
                    IPushPullCurrentAvailablePages: actionTyped.availablePages
                });
            }
        default:
            return state;
    }
};



var $9g4SS = parcelRequire("9g4SS");

class $6d7a15ca39e40bfa$export$5484c21b36f98c91 extends (0, $0805c8271aca8a4c$export$4e7c329e089d8cc5) {
    ippInstance = null;
    ippService = null;
    options;
    constructor(_adaptable, options){
        super(_adaptable);
        this.options = options;
    }
    getCurrentIPushPullUsername() {
        return this.getAdaptableState().Internal.CurrentIPushpullUsername;
    }
    getCurrentIPushPullPassword() {
        return this.getAdaptableState().Internal.CurrentIPushpullPassword;
    }
    getIPushPullUsername() {
        return this.options.username;
    }
    getIPushPullPassword() {
        return this.options.password;
    }
    getAutoLogin() {
        return this.options.autoLogin ?? false;
    }
    getCurrentLiveIPushPullReport() {
        return this.getAdaptableState().Internal.CurrentLiveIPushPullReport;
    }
    setIPushPullInstance(ippInstance) {
        this.ippInstance = ippInstance;
    }
    getIPushPullInstance() {
        return this.ippInstance;
    }
    sendSnapshot(iPushPullReport) {
        if (this.checkItemExists(iPushPullReport, iPushPullReport.ReportName, 'IPushPull Report')) {
            this.dispatchAction($8f5053e15e66a59b$export$4895b0ddade012ff(iPushPullReport));
            this.getExportApi().internalApi.publishLiveLiveDataChangedEvent('ipushpull', 'SnapshotSent');
        }
    }
    startLiveData(iPushPullReport) {
        if (this.checkItemExists(iPushPullReport, iPushPullReport.ReportName, 'IPushPull Report')) {
            this.dispatchAction($8f5053e15e66a59b$export$6e1a09392c0479ce(iPushPullReport));
            this.getExportApi().internalApi.publishLiveLiveDataChangedEvent('ipushpull', 'LiveDataStarted', iPushPullReport);
        }
    }
    stopLiveData() {
        let currentLiveReport = this.getCurrentLiveIPushPullReport();
        if (!currentLiveReport) return;
        this.getIPPService().unloadPage(currentLiveReport.Page);
        // clear the live report
        this.dispatchAction($8f5053e15e66a59b$export$6468a1977505a334());
        // fire the Live Report event for Export Stopped
        this.getExportApi().internalApi.publishLiveLiveDataChangedEvent('ipushpull', 'LiveDataStopped', currentLiveReport);
    }
    isIPushPullReportLive(iPushPullReport) {
        if (!iPushPullReport) return false;
        const CurrentLiveIPushPullReport = this.getCurrentLiveIPushPullReport();
        return CurrentLiveIPushPullReport != null && CurrentLiveIPushPullReport == iPushPullReport;
    }
    isIPushPullAvailable() {
        return true;
    }
    isIPushPullRunning() {
        return this.getAdaptableState().Internal.IsIPushPullRunning;
    }
    getIPushPullDomains() {
        return this.getAdaptableState().Internal.IPushPullDomainsPages || [];
    }
    getPagesForIPushPullDomain(folderName) {
        let returnArray = [];
        let iPushPullDomains = this.getIPushPullDomains();
        if ((0, $9g4SS.default).IsNotNullOrEmpty(iPushPullDomains)) {
            let iPushPullDomain = iPushPullDomains.find((f)=>f.Name == folderName);
            if (iPushPullDomain) returnArray = iPushPullDomain.Pages;
        }
        return returnArray;
    }
    setIPushPullLoginErrorMessage(loginErrorMessage) {
        this.dispatchAction($8f5053e15e66a59b$export$850d38e17332428d(loginErrorMessage));
    }
    getFolderIdForName(folderName) {
        let iPushPullDomains = this.getIPushPullDomains();
        return iPushPullDomains.find((i)=>i.Name == folderName).FolderId;
    }
    addNewIPushPullPage(folderName, pageName) {
        let folderId = this.getFolderIdForName(folderName);
        this.getIPPService().addNewPage(folderId, pageName);
    }
    getIPushPullThrottleTime() {
        return this.options.throttleTime;
    }
    setIPushPullThrottleTime(throttleTime) {
        this.dispatchAction($8f5053e15e66a59b$export$e299ae49b4187a35(throttleTime));
    }
    setIPushPullDomains(iPushPullDomains) {
        this.dispatchAction($8f5053e15e66a59b$export$f6b6c97faf76cd6f(iPushPullDomains));
    }
    clearIPushPullDomains() {
        this.dispatchAction($8f5053e15e66a59b$export$9bc9d407cc12202a());
    }
    getIPushPullSchedules() {
        return this.getAdaptableState().Schedule.IPushPullSchedules || [];
    }
    showIPushPullPopup() {
        this.showModulePopup($42e863194fcb493f$export$d7882f1fbc82745);
    }
    setIPushPullAvailableOn() {
        this.dispatchAction($8f5053e15e66a59b$export$61d7b3e456009f7d());
    }
    setIPushPullAvailableOff() {
        this.dispatchAction($8f5053e15e66a59b$export$d30d86f3dddd8ab6());
    }
    setIPushPullRunningOn() {
        this.dispatchAction($8f5053e15e66a59b$export$ff12813568adabab());
        this.getExportApi().internalApi.publishLiveLiveDataChangedEvent('ipushpull', 'Connected');
    }
    setIPushPullRunningOff() {
        this.dispatchAction($8f5053e15e66a59b$export$e8f9c2845f3cf4ad());
        this.getExportApi().internalApi.publishLiveLiveDataChangedEvent('ipushpull', 'Disconnected');
    }
    isIPushPullLiveDataRunning() {
        return (0, $f5fc3c9fe698fd70$export$2e2bcd8739ae039).objectExists(this.getCurrentLiveIPushPullReport());
    }
    getIPPService() {
        if (!this.ippService) this.ippService = this._adaptable.getPluginProperty('ipushpull', 'service') || null;
        return this.ippService;
    }
    async loginToIPushPull(userName, password) {
        await this.getIPPService().login(userName, password);
        const domainpages = await this.getIPPService().getDomainPages();
        this.setIPushPullDomains(domainpages);
        this.setIPushPullRunningOn();
        this.getAdaptableInternalApi().hidePopupScreen();
        this.setIPushPullLoginErrorMessage('');
        this.dispatchAction($8f5053e15e66a59b$export$dcf1733b0c2d1450(userName, password));
    }
    async retrieveIPushPullDomainsFromIPushPull() {
        this.clearIPushPullDomains();
        const domainpages = await this.getIPPService().getDomainPages();
        this.setIPushPullDomains(domainpages);
    }
    logoutFromIPushPull() {
        this.clearIPushPullInternalState();
        this.dispatchAction($8f5053e15e66a59b$export$9fd02cd905cbd199());
        this.getAdaptableInternalApi().hidePopupScreen();
    }
    includeSystemReports() {
        return this.options.includeSystemReports || false;
    }
    clearIPushPullInternalState() {
        this.setIPushPullDomains([]);
        this.setIPushPullRunningOff();
        this.setIPushPullLoginErrorMessage('');
        this.dispatchAction($8f5053e15e66a59b$export$6468a1977505a334());
    }
}



var $9OAZF = parcelRequire("9OAZF");
class $c2e77a5e5d854c6a$export$c2014b65c1098257 {
    config;
    tokens = null;
    refreshPromise = null;
    constructor(config){
        this.config = config;
    }
    getBasicAuthHeader() {
        const credentials = `${this.config.api_key}:${this.config.api_secret}`;
        return `Basic ${btoa(credentials)}`;
    }
    buildOAuthBody(params) {
        return Object.entries(params).map(([k, v])=>`${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
    }
    async login(username, password) {
        const url = `${this.config.api_url}/oauth/token/`;
        const body = this.buildOAuthBody({
            grant_type: 'password',
            username: username,
            password: password
        });
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: this.getBasicAuthHeader()
            },
            body: body
        });
        if (!response.ok) {
            const errorData = await response.json().catch(()=>({}));
            const message = errorData.error_description || errorData.error || response.statusText;
            const err = new Error(message);
            err.data = errorData;
            throw err;
        }
        this.tokens = await response.json();
        return this.tokens;
    }
    async refreshToken() {
        if (!this.tokens?.refresh_token) throw new Error('No refresh token available. Please login first.');
        // Deduplicate concurrent refresh attempts
        if (this.refreshPromise) return this.refreshPromise;
        this.refreshPromise = this.doRefreshToken();
        try {
            const result = await this.refreshPromise;
            return result;
        } finally{
            this.refreshPromise = null;
        }
    }
    async doRefreshToken() {
        const url = `${this.config.api_url}/oauth/token/`;
        const body = this.buildOAuthBody({
            grant_type: 'refresh_token',
            refresh_token: this.tokens.refresh_token
        });
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: this.getBasicAuthHeader()
            },
            body: body
        });
        if (!response.ok) {
            this.tokens = null;
            const errorData = await response.json().catch(()=>({}));
            throw new Error(errorData.error_description || errorData.error || 'Token refresh failed');
        }
        this.tokens = await response.json();
        return this.tokens;
    }
    async logout() {
        if (!this.tokens?.access_token) return;
        const url = `${this.config.api_url}/oauth/logout/`;
        await fetch(url, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${this.tokens.access_token}`
            }
        });
        this.tokens = null;
    }
    async getDomainsAndPages() {
        const url = `${this.config.api_url}/domain_page_access`;
        const response = await this.fetchWithAuth(url);
        const data = await response.json();
        return (data.domains ?? data).map((domain)=>({
                id: domain.id,
                name: domain.name,
                pages: (domain.current_user_domain_page_access?.pages ?? domain.pages ?? []).map((page)=>({
                        id: page.id,
                        name: page.name,
                        special_page_type: page.special_page_type ?? 0,
                        write_access: page.write_access ?? false
                    }))
            }));
    }
    async getPageContent(folderId, pageId) {
        const baseUrl = this.config.api_url.replace(/\/api\/1\.0\/?$/, '');
        const url = `${baseUrl}/api/2.0/domains/id/${folderId}/page_content/id/${pageId}/`;
        const response = await this.fetchWithAuth(url);
        return response.json();
    }
    async updatePageContent(folderId, pageId, payload) {
        const baseUrl = this.config.api_url.replace(/\/api\/1\.0\/?$/, '');
        const url = `${baseUrl}/api/2.0/domains/id/${folderId}/page_content/id/${pageId}/`;
        const response = await this.fetchWithAuth(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        return response.json();
    }
    async createPage(folderId, pageName, description) {
        const url = `${this.config.api_url}/domains/${folderId}/pages/`;
        const response = await this.fetchWithAuth(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: pageName,
                description: description ?? ''
            })
        });
        return response.json();
    }
    isAuthenticated() {
        return this.tokens != null;
    }
    async fetchWithAuth(url, options = {}) {
        if (!this.tokens?.access_token) throw new Error('Not authenticated. Please login first.');
        const headers = new Headers(options.headers);
        headers.set('Authorization', `Bearer ${this.tokens.access_token}`);
        let response = await fetch(url, {
            ...options,
            headers: headers
        });
        if (response.status === 401) {
            await this.refreshToken();
            headers.set('Authorization', `Bearer ${this.tokens.access_token}`);
            response = await fetch(url, {
                ...options,
                headers: headers
            });
        }
        if (!response.ok) {
            const errorData = await response.json().catch(()=>({}));
            const message = errorData.detail || errorData.error || response.statusText;
            throw new Error(message);
        }
        return response;
    }
}
function $c2e77a5e5d854c6a$export$1aff2728f6a46a4b(cellData) {
    const values = [];
    const formattedValues = [];
    const uniqueStyles = [];
    const cellStyles = [];
    const styleIndex = new Map();
    for (const row of cellData){
        const rowValues = [];
        const rowFormattedValues = [];
        const rowStyleIndices = [];
        for (const cell of row){
            rowValues.push(cell.value);
            rowFormattedValues.push(cell.formatted_value);
            const styleKey = JSON.stringify(cell.style);
            let idx = styleIndex.get(styleKey);
            if (idx === undefined) {
                idx = uniqueStyles.length;
                uniqueStyles.push(cell.style);
                styleIndex.set(styleKey, idx);
            }
            rowStyleIndices.push(idx);
        }
        values.push(rowValues);
        formattedValues.push(rowFormattedValues);
        cellStyles.push(rowStyleIndices);
    }
    return {
        content: {
            values: values,
            formatted_values: formattedValues,
            unique_styles: uniqueStyles,
            cell_styles: cellStyles
        }
    };
}


const $719b15b876485522$var$lightTheme = {
    headerStyle: {
        'background-color': '4a86c8',
        color: 'FFFFFF',
        'font-family': 'Calibri',
        'font-size': '12pt',
        'font-style': 'normal',
        'font-weight': 'bold',
        'text-align': 'center',
        'vertical-align': 'middle',
        'text-wrap': 'normal',
        'white-space': 'nowrap',
        'word-wrap': 'normal',
        height: '24px',
        bbc: 'dae1e7',
        bbs: 'solid',
        bbw: 'thin',
        lbc: 'dae1e7',
        lbs: 'solid',
        lbw: 'thin',
        rbc: 'dae1e7',
        rbs: 'solid',
        rbw: 'thin',
        tbc: 'dae1e7',
        tbs: 'solid',
        tbw: 'thin'
    },
    rowStyle: {
        'background-color': 'FFFFFF',
        color: '000000',
        'font-family': 'Calibri',
        'font-size': '11pt',
        'font-style': 'normal',
        'font-weight': 'normal',
        'text-align': 'left',
        'vertical-align': 'middle',
        'text-wrap': 'normal',
        height: '20px',
        bbc: 'dae1e7',
        bbs: 'solid',
        bbw: 'thin',
        lbc: 'dae1e7',
        lbs: 'solid',
        lbw: 'thin',
        rbc: 'dae1e7',
        rbs: 'solid',
        rbw: 'thin',
        tbc: 'dae1e7',
        tbs: 'solid',
        tbw: 'thin'
    },
    altRowStyle: {
        'background-color': 'f5f7f7',
        color: '000000',
        'font-family': 'Calibri',
        'font-size': '11pt',
        'font-style': 'normal',
        'font-weight': 'normal',
        'text-align': 'left',
        'vertical-align': 'middle',
        'text-wrap': 'normal',
        height: '20px',
        bbc: 'dae1e7',
        bbs: 'solid',
        bbw: 'thin',
        lbc: 'dae1e7',
        lbs: 'solid',
        lbw: 'thin',
        rbc: 'dae1e7',
        rbs: 'solid',
        rbw: 'thin',
        tbc: 'dae1e7',
        tbs: 'solid',
        tbw: 'thin'
    }
};
const $719b15b876485522$var$darkTheme = {
    headerStyle: {
        'background-color': '2d3748',
        color: 'FFFFFF',
        'font-family': 'Calibri',
        'font-size': '12pt',
        'font-style': 'normal',
        'font-weight': 'bold',
        'text-align': 'center',
        'vertical-align': 'middle',
        'text-wrap': 'normal',
        'white-space': 'nowrap',
        'word-wrap': 'normal',
        height: '24px',
        bbc: '4a5568',
        bbs: 'solid',
        bbw: 'thin',
        lbc: '4a5568',
        lbs: 'solid',
        lbw: 'thin',
        rbc: '4a5568',
        rbs: 'solid',
        rbw: 'thin',
        tbc: '4a5568',
        tbs: 'solid',
        tbw: 'thin'
    },
    rowStyle: {
        'background-color': '1a202c',
        color: 'e2e8f0',
        'font-family': 'Calibri',
        'font-size': '11pt',
        'font-style': 'normal',
        'font-weight': 'normal',
        'text-align': 'left',
        'vertical-align': 'middle',
        'text-wrap': 'normal',
        height: '20px',
        bbc: '4a5568',
        bbs: 'solid',
        bbw: 'thin',
        lbc: '4a5568',
        lbs: 'solid',
        lbw: 'thin',
        rbc: '4a5568',
        rbs: 'solid',
        rbw: 'thin',
        tbc: '4a5568',
        tbs: 'solid',
        tbw: 'thin'
    },
    altRowStyle: {
        'background-color': '2d3748',
        color: 'e2e8f0',
        'font-family': 'Calibri',
        'font-size': '11pt',
        'font-style': 'normal',
        'font-weight': 'normal',
        'text-align': 'left',
        'vertical-align': 'middle',
        'text-wrap': 'normal',
        height: '20px',
        bbc: '4a5568',
        bbs: 'solid',
        bbw: 'thin',
        lbc: '4a5568',
        lbs: 'solid',
        lbw: 'thin',
        rbc: '4a5568',
        rbs: 'solid',
        rbw: 'thin',
        tbc: '4a5568',
        tbs: 'solid',
        tbw: 'thin'
    }
};
const $719b15b876485522$var$themes = {
    lightTheme: $719b15b876485522$var$lightTheme,
    darkTheme: $719b15b876485522$var$darkTheme
};
function $719b15b876485522$export$a3fc04b8551e006a(theme) {
    return $719b15b876485522$var$themes[theme];
}




var $3d92a4bf8a69e5be$export$a522ceaa9e4a21ee;
(function(ServiceStatus) {
    ServiceStatus["Unknown"] = "Unknown";
    ServiceStatus["Disconnected"] = "Disconnected";
    ServiceStatus["Connected"] = "Connected";
    ServiceStatus["Error"] = "Error";
})($3d92a4bf8a69e5be$export$a522ceaa9e4a21ee || ($3d92a4bf8a69e5be$export$a522ceaa9e4a21ee = {}));
class $3d92a4bf8a69e5be$export$42b2330309c28cf9 {
    adaptable;
    client = null;
    status = $3d92a4bf8a69e5be$export$a522ceaa9e4a21ee.Unknown;
    cellStylesOption;
    pages = new Map();
    pageNameToId = new Map();
    folderNameToId = new Map();
    constructor(adaptable, cellStyles){
        this.adaptable = adaptable;
        this.adaptable = adaptable;
        this.cellStylesOption = cellStyles;
        this.adaptable.api.eventApi.on('AdaptableReady', async ()=>{
            this.getIPPApi().clearIPushPullInternalState();
            this.getIPPApi().setIPushPullAvailableOff();
            if (!this.client) {
                let instance = this.getIPPApi().getIPushPullInstance();
                if (instance) {
                    this.client = instance;
                    this.getIPPApi().setIPushPullAvailableOn();
                    let autoLogin = this.getIPPApi().getAutoLogin();
                    if (autoLogin) {
                        let userName = this.getIPPApi().getIPushPullUsername();
                        let password = this.getIPPApi().getIPushPullPassword();
                        if ((0, $9OAZF.default).IsNotNullOrEmpty(userName) && (0, $9OAZF.default).IsNotNullOrEmpty(password)) try {
                            this.getIPPApi().loginToIPushPull(userName, password);
                        } catch (err) {
                            this.getIPPApi().setIPushPullRunningOff();
                        }
                    }
                }
            }
        });
    }
    getIPushPullStatus() {
        if (!this.client) return $3d92a4bf8a69e5be$export$a522ceaa9e4a21ee.Error;
        return this.status;
    }
    getIPPApi() {
        return this.adaptable.api.pluginsApi.getipushpullPluginApi();
    }
    /**
     * Derives the IPushPull theme from Adaptable's current theme at call-time,
     * respecting the 'os' theme by checking `prefers-color-scheme`.
     */ deriveDefaultTheme() {
        const themeName = this.adaptable.api.themeApi.getCurrentTheme();
        if (themeName === 'os') {
            const preferred = this.adaptable.api.themeApi.internalApi.getDOMPreferredColorScheme();
            return preferred === 'dark' ? 'darkTheme' : 'lightTheme';
        }
        const themeObj = this.adaptable.api.themeApi.getCurrentThemeObject();
        if (themeObj?.Variant === 'dark') return 'darkTheme';
        if (themeName === 'dark') return 'darkTheme';
        return 'lightTheme';
    }
    /**
     * Returns the resolved IPushPull theme, honouring the `cellStyles` option.
     * If `cellStyles` is a string, it's used directly.
     * If not set, the theme is derived from Adaptable's current theme.
     */ getResolvedTheme() {
        const defaultCellStyles = this.deriveDefaultTheme();
        if (!this.cellStylesOption) return defaultCellStyles;
        return this.cellStylesOption;
    }
    async login(login, password) {
        if (!this.client) return Promise.reject('No ipushpull instance found!');
        try {
            const result = await this.client.login(login, password);
            this.status = $3d92a4bf8a69e5be$export$a522ceaa9e4a21ee.Connected;
            this.adaptable.logger.success('Logged in to ipushpull.');
            return result;
        } catch (err) {
            this.status = $3d92a4bf8a69e5be$export$a522ceaa9e4a21ee.Error;
            const message = err.data ? err.data.error_description || err.message : err.message;
            this.getIPPApi().setIPushPullLoginErrorMessage(message);
            throw message;
        }
    }
    async getDomainPages() {
        if (!this.client) return Promise.reject('No ipushpull instance found.');
        try {
            const domains = await this.client.getDomainsAndPages();
            this.adaptable.logger.success('Retrieved ipushpull folder and page info.');
            this.folderNameToId.clear();
            this.pageNameToId.clear();
            const result = domains.map((domain)=>{
                this.folderNameToId.set(domain.name, domain.id);
                const writablePages = domain.pages.filter((page)=>page.special_page_type == 0 && page.write_access).map((page)=>{
                    this.pageNameToId.set(`${domain.name}/${page.name}`, page.id);
                    return page.name;
                });
                return {
                    Name: domain.name,
                    FolderId: domain.id,
                    Pages: writablePages
                };
            });
            return result;
        } catch (error) {
            this.adaptable.logger.error('Failed to retrieve folders and pages from ipushpull.', error);
            throw error.message ?? error;
        }
    }
    async loadPage(folderIPP, pageIPP) {
        if (!this.client) return Promise.reject('No ipushpull instance found.');
        const folderId = this.folderNameToId.get(folderIPP);
        const pageId = this.pageNameToId.get(`${folderIPP}/${pageIPP}`);
        if (folderId == null || pageId == null) throw new Error(`Could not resolve IDs for folder "${folderIPP}" / page "${pageIPP}".`);
        await this.client.getPageContent(folderId, pageId);
        this.pages.set(pageIPP, {
            folderId: folderId,
            pageId: pageId
        });
        this.adaptable.logger.info(`Page ready: "${pageIPP}".`);
    }
    unloadPage(page) {
        if (this.pages.has(page)) {
            this.pages.delete(page);
            this.adaptable.logger.info(`Page unloaded: "${page}".`);
        }
    }
    async addNewPage(folderId, page) {
        if (!this.client) return Promise.reject('No ipushpull instance found.');
        try {
            await this.client.createPage(folderId, page);
            let message = `Page "${page}" created successfully.`;
            this.adaptable.api.alertApi.showAlertSuccess('ipushpull', message);
            this.adaptable.api.internalApi.hidePopupScreen();
            return this.getIPPApi().retrieveIPushPullDomainsFromIPushPull();
        } catch (err) {
            this.adaptable.logger.error(`Failed to create page "${page}": ${err}`);
        }
    }
    async pushData(page, data) {
        const pageRef = this.pages.get(page);
        if (!pageRef || !this.client) throw new Error(`Page "${page}" is not loaded or client is not available.`);
        const themeStyles = (0, $719b15b876485522$export$a3fc04b8551e006a)(this.getResolvedTheme());
        const cellData = data.map((row, rowIndex)=>row.map((cell)=>{
                let style;
                if (rowIndex === 0) style = themeStyles.headerStyle;
                else if (rowIndex % 2 === 1) style = themeStyles.rowStyle;
                else style = themeStyles.altRowStyle;
                return {
                    value: cell,
                    formatted_value: cell,
                    style: style
                };
            }));
        const payload = (0, $c2e77a5e5d854c6a$export$1aff2728f6a46a4b)(cellData);
        try {
            await this.client.updatePageContent(pageRef.folderId, pageRef.pageId, payload);
            this.adaptable.logger.success(`Data pushed for ipushpull page "${page}".`);
        } catch (err) {
            this.adaptable.logger.error(`Failed to push data for ipushpull page "${page}".`);
            throw err;
        }
    }
}





var $acw62 = parcelRequire("acw62");





var $9OAZF = parcelRequire("9OAZF");








const $d3b237c12dfb84a2$var$IPushPullLoginComponent = (props)=>{
    const adaptable = (0, $4f57eeaf0bf16291$export$4f8242d5bf1189fc)();
    const options = adaptable.getPlugin('ipushpull').options;
    const [state, setState] = $acw62.useState({
        Login: options.username || '',
        Password: options.password || ''
    });
    const { hidePopup: hidePopup } = (0, $e1144fa2193cb217$export$6b0a8531a102393f)();
    const onSubmit = ()=>{
        props.onLogin(state.Login || '', state.Password || '');
    };
    const onLoginChange = (event)=>{
        const e = event.target;
        setState({
            ...state,
            Login: e.value
        });
    };
    const onPasswordChange = (event)=>{
        const e = event.target;
        setState({
            ...state,
            Password: e.value
        });
    };
    return $acw62.createElement((0, $283cf61293364231$export$226a98817755c0cc), {
        header: "ipushpull Login Details",
        glyphicon: "login",
        variant: "primary"
    }, $acw62.createElement("form", {
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit();
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:p-2 twa:m-2"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mb-1"
    }, "Login to ipushpull using your login (email address) and password."), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:m-3"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "User"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        className: "twa:w-full",
        type: "email",
        placeholder: "Email address",
        value: state.Login,
        onChange: onLoginChange
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Password"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        className: "twa:w-full",
        type: "password",
        placeholder: "Password",
        value: state.Password,
        onChange: onPasswordChange
    })), props.pushpullLoginErrorMessage ? $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), null, props.pushpullLoginErrorMessage)) : null)), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:p-2",
        justifyContent: "space-between"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        tone: "neutral",
        variant: "outlined",
        tooltip: "Close",
        onClick: (e)=>{
            e.stopPropagation();
            hidePopup();
        }
    }, "CLOSE"), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        tone: "accent",
        variant: "raised",
        type: "submit",
        disabled: (0, $9OAZF.StringExtensions).IsNullOrEmpty(state.Password),
        icon: 'check'
    }, "Login"))));
};
function $d3b237c12dfb84a2$var$mapStateToProps(state) {
    return {
        // pushpullLogin: state.IPushPull ? state.IPushPull!.Username : undefined,
        // pushpullPassword: state.IPushPull ? state.IPushPull!.Password : undefined,
        // pushpullLoginErrorMessage: state.IPushPull.IPushPullLoginErrorMessage,
        pushpullLoginErrorMessage: state.Internal.IPushPullLoginErrorMessage
    };
}
function $d3b237c12dfb84a2$var$mapDispatchToProps(dispatch) {
    return {
        onLogin: (login, password)=>dispatch($8f5053e15e66a59b$export$a7873a5d150c8c7d(login, password)),
        onCancel: ()=>{
            dispatch($dc56b6267ce4d0bb$export$b591761538bae019());
            dispatch($8f5053e15e66a59b$export$850d38e17332428d(''));
        }
    };
}
let $d3b237c12dfb84a2$export$b5ebc5ad3cbaab0b = (0, $55388fc2f116d4d7$export$64605811ab45167f)($d3b237c12dfb84a2$var$mapStateToProps, $d3b237c12dfb84a2$var$mapDispatchToProps)($d3b237c12dfb84a2$var$IPushPullLoginComponent);



var $acw62 = parcelRequire("acw62");




var $9OAZF = parcelRequire("9OAZF");











var $9g4SS = parcelRequire("9g4SS");
const $ca28b63f45c80d4c$var$IPushPullAddPageComponent = (props)=>{
    const [state, setState] = $acw62.useState({
        Folder: '',
        Page: '',
        AvailablePages: (0, $58846ea7f4156db7$export$2c66e96878bf4792),
        ErrorMessage: ''
    });
    const { hidePopup: hidePopup } = (0, $e1144fa2193cb217$export$6b0a8531a102393f)();
    const onSubmit = ()=>{
        if ((0, $9g4SS.default).ContainsItem(state.AvailablePages, state.Page)) setState({
            ...state,
            ErrorMessage: 'A page with that name already exists in this folder.'
        });
        else props.onAddPage(state.Folder, state.Page);
    };
    const onPageNameChange = (event)=>{
        const e = event.target;
        setState({
            ...state,
            Page: e.value
        });
    };
    const onFolderChanged = (folderName)=>{
        if ((0, $9OAZF.StringExtensions).IsNotNullOrEmpty(folderName)) {
            let availablePages = props.IPushPullDomainsPages.find((f)=>f.Name == folderName)?.Pages ?? [];
            setState({
                Folder: folderName,
                AvailablePages: availablePages,
                Page: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
                ErrorMessage: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1)
            });
        } else setState({
            Folder: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
            AvailablePages: [],
            Page: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1),
            ErrorMessage: (0, $58846ea7f4156db7$export$8d34a8e2e1d6bcc1)
        });
    };
    const availableFolders = props.IPushPullDomainsPages.map((iPushPullDomain)=>{
        return {
            label: iPushPullDomain.Name,
            value: iPushPullDomain.Name
        };
    });
    return $acw62.createElement((0, $283cf61293364231$export$226a98817755c0cc), {
        header: "Add ipushpull Page",
        glyphicon: "newpage",
        variant: "primary"
    }, $acw62.createElement("form", {
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit();
        }
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "column",
        className: "twa:p-2 twa:m-2"
    }, $acw62.createElement((0, $0b17b48a3a2d8049$export$2e2bcd8739ae039), {
        className: "twa:mb-1"
    }, "Select a folder and then choose the name of the new ipushpull page it should contain."), $acw62.createElement((0, $6ab992db590f467f$export$2e2bcd8739ae039), {
        className: "twa:m-3"
    }, $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Folder"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        disabled: availableFolders.length == 0,
        options: availableFolders,
        className: "ab-Popup__IPushPull__select twa:min-w-[50%] twa:mr-2",
        onChange: (folder)=>onFolderChanged(folder),
        value: state.Folder || undefined,
        placeholder: "Select Folder",
        isClearable: true
    })), $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: "Page"
    }, $acw62.createElement((0, $4bf904b9c2b894aa$export$2e2bcd8739ae039), {
        className: "twa:w-1/2",
        type: "text",
        placeholder: "Page Name",
        value: state.Page,
        disabled: (0, $9OAZF.StringExtensions).IsNullOrEmpty(state.Folder),
        onChange: onPageNameChange
    })), state.ErrorMessage ? $acw62.createElement((0, $6ab992db590f467f$export$b534bc812df080fd), {
        label: ""
    }, $acw62.createElement((0, $d2a0551c8cf8e625$export$2e2bcd8739ae039), null, state.ErrorMessage)) : null)), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:p-2",
        justifyContent: "space-between"
    }, $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        tone: "neutral",
        variant: "outlined",
        tooltip: "Close",
        onClick: (e)=>{
            e.stopPropagation();
            hidePopup();
        }
    }, "CLOSE"), $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
        tone: "accent",
        variant: "raised",
        type: "submit",
        disabled: (0, $9OAZF.StringExtensions).IsNullOrEmpty(state.Folder) || (0, $9OAZF.StringExtensions).IsNullOrEmpty(state.Page),
        icon: 'check'
    }, "Add Page"))));
};
function $ca28b63f45c80d4c$var$mapStateToProps(state) {
    return {
        IPushPullDomainsPages: state.Internal.IPushPullDomainsPages
    };
}
function $ca28b63f45c80d4c$var$mapDispatchToProps(dispatch) {
    return {
        onAddPage: (folder, page)=>dispatch($8f5053e15e66a59b$export$e4776ae873a0598(folder, page)),
        onCancel: ()=>{
            dispatch($dc56b6267ce4d0bb$export$b591761538bae019());
        }
    };
}
let $ca28b63f45c80d4c$export$3805d08084ee6743 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($ca28b63f45c80d4c$var$mapStateToProps, $ca28b63f45c80d4c$var$mapDispatchToProps)($ca28b63f45c80d4c$var$IPushPullAddPageComponent);




var $9OAZF = parcelRequire("9OAZF");



var $acw62 = parcelRequire("acw62");


var $9OAZF = parcelRequire("9OAZF");









var $acw62 = parcelRequire("acw62");

class $b1e14570a83a7476$export$4e1b87f9b1292908 extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "new-page",
            tooltip: "New Page",
            iconSize: 20,
            icon: "newpage" // arrow-up
            ,
            variant: "text",
            ...this.props
        });
    }
}



var $acw62 = parcelRequire("acw62");

class $0c0b834a16ecdf39$export$a7fc65aa9bf80250 extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "logout",
            tooltip: "Logout",
            iconSize: 20,
            icon: "logout",
            variant: "text",
            ...this.props
        });
    }
}



var $acw62 = parcelRequire("acw62");

class $dc031d84898b0336$export$8c7ca84906984345 extends $acw62.Component {
    render() {
        return $acw62.createElement((0, $306da9675b57419a$export$2e2bcd8739ae039), {
            "data-name": "login",
            tooltip: "Login",
            iconSize: 20,
            icon: "person",
            variant: "text",
            ...this.props
        });
    }
}




const $bb0d81cc4a3df5a4$var$IPushPullViewPanelComponent = (props)=>{
    const [_, update] = $acw62.useState(0);
    const forceUpdate = ()=>update((x)=>x + 1);
    const onLiveDataChanged = $acw62.useCallback((liveDataChangedInfo)=>{
        if (liveDataChangedInfo.reportDestination == 'ipushpull' && (liveDataChangedInfo.liveDataTrigger == 'Connected' || liveDataChangedInfo.liveDataTrigger == 'Disconnected')) forceUpdate();
    }, []);
    const getIPPApi = $acw62.useCallback(()=>{
        return props.api.pluginsApi.getipushpullPluginApi();
    }, []);
    $acw62.useEffect(()=>{
        props.api.eventApi.on('LiveDataChanged', onLiveDataChanged);
        return ()=>{
            props.api.eventApi.off('LiveDataChanged', onLiveDataChanged);
        };
    }, []);
    const onSelectedReportChanged = (reportName)=>props.onCurrentIPushPullReportNameChange(reportName);
    const onFolderChanged = (folder)=>props.onCurrentIPushPullFolderChange(folder);
    const onPageChanged = (page)=>props.onCurrentIPushPullPageChange(page);
    const onIPushPullSendSnapshot = ()=>{
        props.onIPushPullSendSnapshot(createIPushPullReportFromState());
    };
    const onIPushPullStartLiveData = ()=>{
        props.onIPushPullStartLiveData(createIPushPullReportFromState());
    };
    const onNewIPushPullSchedule = ()=>{
        let iPushPullSchedule = (0, $c94ad2cb10a8d2c3$export$2e2bcd8739ae039).CreateIPushPullSchedule(createIPushPullReportFromState());
        props.onNewIPushPullSchedule(iPushPullSchedule);
    };
    // perhaps this should be props and in real state?
    const createIPushPullReportFromState = ()=>{
        return {
            ReportName: props.CurrentIPushPullReportName,
            Folder: props.CurrentIPushPullFolder,
            Page: props.CurrentIPushPullPage
        };
    };
    let systemReports = getIPPApi().includeSystemReports() ? props.api.exportApi.getAvailableSystemReports() : [];
    let allReports = systemReports.filter((s)=>props.api.exportApi.internalApi.isSystemReportActive(s)).concat(props.Reports.map((r)=>r.Name));
    let availableReports = allReports.map((report)=>({
            label: report,
            value: report
        }));
    let availableFolders = props.IPushPullDomainsPages?.map((iPushPullDomain)=>({
            label: iPushPullDomain.Name,
            value: iPushPullDomain.Name
        })) ?? [];
    let availablePages = props.CurrentIPushPullAvailablePages?.map((page)=>({
            label: page,
            value: page
        })) ?? [];
    let hasReport = (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(props.CurrentIPushPullReportName);
    let hasFolder = (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(props.CurrentIPushPullFolder);
    let hasPage = (0, $9OAZF.StringExtensions).IsNotNullOrEmpty(props.CurrentIPushPullPage);
    let isCompletedReport = hasReport && hasFolder && hasPage;
    let isLiveIPushPullReport = isCompletedReport && props.CurrentLiveIPushPullReport && props.CurrentIPushPullReportName == props.CurrentLiveIPushPullReport.ReportName && props.CurrentIPushPullFolder == props.CurrentLiveIPushPullReport.Folder && props.CurrentIPushPullPage == props.CurrentLiveIPushPullReport.Page;
    const elementType = props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
    return props.IsIPushPullRunning ? $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        flexDirection: "row",
        className: `ab-${elementType}__IPushPull__wrap twa:gap-1`,
        flexWrap: props.viewType === 'ToolPanel' ? 'wrap' : 'nowrap'
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:min-w-[140px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        disabled: allReports.length == 0 || isLiveIPushPullReport,
        options: availableReports,
        className: `ab-${elementType}__IPushPull__select twa:w-full`,
        placeholder: "Select Report",
        onChange: (reportName)=>onSelectedReportChanged(reportName),
        value: props.CurrentIPushPullReportName,
        isClearable: true
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:min-w-[140px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        disabled: !hasReport || isLiveIPushPullReport,
        options: availableFolders,
        className: `ab-${elementType}__IPushPull__select twa:w-full`,
        placeholder: "Select Folder",
        onChange: (folder)=>onFolderChanged(folder),
        value: props.CurrentIPushPullFolder,
        isClearable: true
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: "twa:min-w-[140px]"
    }, $acw62.createElement((0, $765350da0379ad82$export$ef9b1a59e592288f), {
        disabled: !hasFolder || isLiveIPushPullReport,
        options: availablePages,
        className: `ab-${elementType}__IPushPull__select twa:w-full`,
        placeholder: "Select Page",
        onChange: (page)=>onPageChanged(page),
        value: props.CurrentIPushPullPage,
        isClearable: true
    })), $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), {
        className: (0, $c72009da7485afc2$export$2e2bcd8739ae039)(props.accessLevel == 'ReadOnly' ? $58846ea7f4156db7$export$2c59109bdd218c0 : '', `ab-${elementType}__IPushPull__controls twa:w-full`)
    }, $acw62.createElement((0, $82c87f52da9ba110$export$f51f4c4ede09e011), null, $acw62.createElement((0, $ce2fc2cff0df2441$export$8eb2896c2698648c), {
        className: `ab-${elementType}__IPushPull__export`,
        onClick: ()=>onIPushPullSendSnapshot(),
        tooltip: "Send Snapshot to ipushpull",
        disabled: isLiveIPushPullReport || !isCompletedReport,
        accessLevel: props.accessLevel
    }), isLiveIPushPullReport ? $acw62.createElement((0, $39b7a9837b4e4ef1$export$9a3ab81a844a27ca), {
        className: `ab-${elementType}__IPushPull__pause twa:fill-red-500`,
        onClick: ()=>props.onIPushPullStopLiveData(),
        tooltip: "Stop sync with ipushpull",
        disabled: !isLiveIPushPullReport,
        accessLevel: props.accessLevel
    }) : $acw62.createElement((0, $25a466b3a8eee6fb$export$23b1e8580c697083), {
        className: `ab-${elementType}__IPushPull__play`,
        onClick: ()=>onIPushPullStartLiveData(),
        tooltip: "Start sync with ipushpull",
        disabled: isLiveIPushPullReport || !isCompletedReport,
        accessLevel: props.accessLevel
    }), props.api.entitlementApi.isModuleFullEntitlement('Schedule') && $acw62.createElement((0, $cb264e95861b0567$export$d73c3aa70637f13a), {
        className: `ab-${elementType}__IPushPull__schedule`,
        onClick: ()=>onNewIPushPullSchedule(),
        tooltip: "Schedule",
        disabled: isLiveIPushPullReport || !isCompletedReport,
        accessLevel: props.accessLevel
    }), $acw62.createElement((0, $b1e14570a83a7476$export$4e1b87f9b1292908), {
        className: `ab-${elementType}__IPushPull__newpage`,
        onClick: ()=>props.onShowAddIPushPullPage(),
        tooltip: "New Page",
        disabled: !hasFolder || isLiveIPushPullReport,
        accessLevel: props.accessLevel
    }), $acw62.createElement((0, $0c0b834a16ecdf39$export$a7fc65aa9bf80250), {
        className: `ab-${elementType}__IPushPull__logout`,
        onClick: ()=>getIPPApi().logoutFromIPushPull(),
        tooltip: "Logout",
        disabled: isLiveIPushPullReport,
        accessLevel: props.accessLevel
    })))) : $acw62.createElement((0, $dc031d84898b0336$export$8c7ca84906984345), {
        className: `ab-${elementType}__IPushPull__login twa:ml-1`,
        onClick: ()=>props.onShowIPushPullLogin(),
        tooltip: "Login to ipushpull",
        accessLevel: props.accessLevel
    }, ' ', "Login");
};
function $bb0d81cc4a3df5a4$var$mapStateToProps(state) {
    return {
        CurrentLiveIPushPullReport: state.Internal.CurrentLiveIPushPullReport,
        Reports: state.Export.Reports,
        IPushPullDomainsPages: state.Internal.IPushPullDomainsPages,
        IsIPushPullRunning: state.Internal.IsIPushPullRunning,
        CurrentIPushPullReportName: state.Internal.IPushPullCurrentReportName,
        CurrentIPushPullFolder: state.Internal.IPushPullCurrentFolder,
        CurrentIPushPullPage: state.Internal.IPushPullCurrentPage,
        CurrentIPushPullAvailablePages: state.Internal.IPushPullCurrentAvailablePages
    };
}
function $bb0d81cc4a3df5a4$var$mapDispatchToProps(dispatch) {
    return {
        onIPushPullSendSnapshot: (iPushPullReport)=>dispatch($8f5053e15e66a59b$export$4895b0ddade012ff(iPushPullReport)),
        onIPushPullStartLiveData: (iPushPullReport)=>dispatch($8f5053e15e66a59b$export$d7db8c3d4d7faf2a(iPushPullReport)),
        onIPushPullStopLiveData: ()=>dispatch($8f5053e15e66a59b$export$ce060e5a3887b0a0()),
        onNewIPushPullSchedule: (iPushPullSchedule)=>dispatch($dc56b6267ce4d0bb$export$e2d5bba0b444685d($42e863194fcb493f$export$5dd6e67bf681ede8, 'SchedulePopup', {
                action: 'New',
                source: 'Toolbar',
                value: iPushPullSchedule
            })),
        onShowIPushPullLogin: ()=>dispatch($dc56b6267ce4d0bb$export$e2d5bba0b444685d($42e863194fcb493f$export$d7882f1fbc82745, 'IPushPullLoginPopup', undefined, {
                footer: false
            })),
        onShowAddIPushPullPage: ()=>dispatch($dc56b6267ce4d0bb$export$e2d5bba0b444685d($42e863194fcb493f$export$d7882f1fbc82745, 'IPushPullAddPagePopup', undefined, {
                footer: false
            })),
        onCurrentIPushPullReportNameChange: (reportName)=>dispatch($8f5053e15e66a59b$export$d9e0ea8cfc47aa7a(reportName)),
        onCurrentIPushPullFolderChange: (folder)=>dispatch($8f5053e15e66a59b$export$3f022151ad608e08(folder)),
        onCurrentIPushPullPageChange: (page)=>dispatch($8f5053e15e66a59b$export$503949f7c3c5a524(page))
    };
}
const $bb0d81cc4a3df5a4$export$3d19f7baa45eeb82 = (0, $55388fc2f116d4d7$export$64605811ab45167f)($bb0d81cc4a3df5a4$var$mapStateToProps, $bb0d81cc4a3df5a4$var$mapDispatchToProps)($bb0d81cc4a3df5a4$var$IPushPullViewPanelComponent);


const { version: $b796b23c0ea2fe50$var$version, name: $b796b23c0ea2fe50$var$name } = (0, (/*@__PURE__*/$parcel$interopDefault($cd1eed0c389a45a8$exports)));
const { version: $b796b23c0ea2fe50$var$coreVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($c0db9ead212244f8$exports)));
const $b796b23c0ea2fe50$var$suffix = $b796b23c0ea2fe50$var$name.endsWith('-cjs') ? '-cjs' : '';
if ($b796b23c0ea2fe50$var$version !== $b796b23c0ea2fe50$var$coreVersion) console.warn(`Version mismatch: "@adaptabletools/adaptable-plugin-ipushpull${$b796b23c0ea2fe50$var$suffix}" (v${$b796b23c0ea2fe50$var$version}) and "@adaptabletools/adaptable${$b796b23c0ea2fe50$var$suffix}" (v${$b796b23c0ea2fe50$var$coreVersion}) have different versions. They should be the exact same version.`);
const $b796b23c0ea2fe50$var$DEFAULT_API_URL = 'https://test.ipushpull.com/api/1.0';
const $b796b23c0ea2fe50$var$getApiKey = ()=>{
    return (0, $ac1da9cc72705fce$export$2e2bcd8739ae039).IPUSHPULL_API_KEY || '';
};
const $b796b23c0ea2fe50$var$getApiSecret = ()=>{
    return (0, $ac1da9cc72705fce$export$2e2bcd8739ae039).IPUSHPULL_API_SECRET || '';
};
const $b796b23c0ea2fe50$var$defaultOptions = {
    ippConfig: {
        api_key: $b796b23c0ea2fe50$var$getApiKey(),
        api_secret: $b796b23c0ea2fe50$var$getApiSecret(),
        api_url: $b796b23c0ea2fe50$var$DEFAULT_API_URL
    },
    autoLogin: false,
    throttleTime: 2000,
    includeSystemReports: true
};
class $b796b23c0ea2fe50$var$IPushPullPlugin extends (0, $7065642dbd07b89e$export$d0a8f6d266c2073a) {
    pluginId = 'ipushpull';
    iPushPullApi;
    PushPullService;
    constructor(options){
        super(options);
        const defaults = $b796b23c0ea2fe50$var$defaultOptions.ippConfig;
        const userConfig = options?.ippConfig;
        const ippConfig = {
            api_url: userConfig?.api_url ?? defaults.api_url ?? $b796b23c0ea2fe50$var$DEFAULT_API_URL,
            api_key: userConfig?.api_key || defaults.api_key,
            api_secret: userConfig?.api_secret || defaults.api_secret
        };
        this.options = {
            ...$b796b23c0ea2fe50$var$defaultOptions,
            ...options,
            ippConfig: ippConfig
        };
    }
    afterInitApi(adaptable) {
        const config = this.options.ippConfig;
        const client = new (0, $c2e77a5e5d854c6a$export$c2014b65c1098257)({
            api_url: config.api_url ?? $b796b23c0ea2fe50$var$DEFAULT_API_URL,
            api_key: config.api_key,
            api_secret: config.api_secret
        });
        this.iPushPullApi = new (0, $6d7a15ca39e40bfa$export$5484c21b36f98c91)(adaptable, this.options);
        this.PushPullService = new (0, $3d92a4bf8a69e5be$export$42b2330309c28cf9)(adaptable, this.options.cellStyles);
        this.iPushPullApi.setIPushPullInstance(client);
        this.registerProperty('api', ()=>this.iPushPullApi);
        this.registerProperty('service', ()=>this.PushPullService);
    }
    // FIXME AFL improve typing
    rootReducer = (rootReducer)=>{
        return {
            Internal: (state, action)=>{
                let augmentedState = rootReducer.Internal(state, action);
                if (!state) // required for store initialization
                // (idiomatic way of default parameter value in reducer is not feasible because the passed argument is already initialized by the System reducer)
                augmentedState = Object.assign({}, augmentedState, (0, $8f5053e15e66a59b$export$3c0028bf13480f9d));
                return (0, $8f5053e15e66a59b$export$3266d8d988b14ac)(augmentedState, action);
            }
        };
    };
    reduxMiddleware = (adaptable)=>(middlewareAPI)=>{
            return (next)=>{
                return (action)=>{
                    switch(action.type){
                        case 0, $b332b9d7a4fcbf15$export$97611c4cb3a0ddd:
                            {
                                const actionTyped = action;
                                this.iPushPullApi.loginToIPushPull(actionTyped.username, actionTyped.password);
                                return next(action);
                            }
                        case 0, $b332b9d7a4fcbf15$export$5cf68f01567f5ed0:
                            {
                                let iPushPullModule = adaptable.adaptableModules.get($42e863194fcb493f$export$d7882f1fbc82745);
                                const actionTyped = action;
                                iPushPullModule.sendSnapshot(actionTyped.iPushPullReport);
                                middlewareAPI.dispatch($dc56b6267ce4d0bb$export$b591761538bae019());
                                return next(action);
                            }
                        case 0, $b332b9d7a4fcbf15$export$823995ecb5bf874d:
                            {
                                let iPushPullModule = adaptable.adaptableModules.get($42e863194fcb493f$export$d7882f1fbc82745);
                                const actionTyped = action;
                                iPushPullModule.startLiveData(actionTyped.iPushPullReport);
                                middlewareAPI.dispatch($dc56b6267ce4d0bb$export$b591761538bae019());
                                return next(action);
                            }
                        case 0, $b332b9d7a4fcbf15$export$18523e8ab138b69e:
                            {
                                let iPushPullModule = adaptable.adaptableModules.get($42e863194fcb493f$export$d7882f1fbc82745);
                                iPushPullModule.stopLiveData();
                                return next(action);
                            }
                        case 0, $b332b9d7a4fcbf15$export$719706ab038ecef2:
                            {
                                const actionTyped = action;
                                this.iPushPullApi.addNewIPushPullPage(actionTyped.folder, actionTyped.page);
                                return next(action);
                            }
                        case 0, $b332b9d7a4fcbf15$export$91291e6c6b03ce02:
                            {
                                const actionTyped = action;
                                const currentFolder = actionTyped.folder;
                                const isFolderValid = (0, $9OAZF.default).IsNotNullOrEmpty(currentFolder);
                                const availablePages = isFolderValid ? adaptable.api.pluginsApi.getipushpullPluginApi().getPagesForIPushPullDomain(currentFolder) : [];
                                middlewareAPI.dispatch((0, $8f5053e15e66a59b$export$5156292a65af67d6)(availablePages));
                                middlewareAPI.dispatch((0, $8f5053e15e66a59b$export$503949f7c3c5a524)(''));
                                return next(action);
                            }
                        case 0, $b332b9d7a4fcbf15$export$90fd41a2d8f80c6d:
                            {
                                const result = next(action);
                                const currentFolder = middlewareAPI.getState().Internal.IPushPullCurrentFolder;
                                const isFolderValid = (0, $9OAZF.default).IsNotNullOrEmpty(currentFolder);
                                if (isFolderValid) {
                                    const availablePages = adaptable.api.pluginsApi.getipushpullPluginApi().getPagesForIPushPullDomain(currentFolder);
                                    middlewareAPI.dispatch((0, $8f5053e15e66a59b$export$5156292a65af67d6)(availablePages));
                                }
                                return result;
                            }
                        default:
                            return next(action);
                    }
                };
            };
        };
    afterInitStore(adaptable) {
        adaptable.adaptableModules.set((0, $42e863194fcb493f$export$d7882f1fbc82745), new (0, $fb84a652b34fae33$export$96a886b20fd8468c)(adaptable.api));
        (0, $b1f453bcc52a26e6$export$d4d53f0c4fbfa3c7).IPushPullLoginPopup = (0, $d3b237c12dfb84a2$export$b5ebc5ad3cbaab0b);
        (0, $b1f453bcc52a26e6$export$d4d53f0c4fbfa3c7).IPushPullAddPagePopup = (0, $ca28b63f45c80d4c$export$3805d08084ee6743);
        (0, $b1f453bcc52a26e6$export$c7001f4850704fce).set((0, $42e863194fcb493f$export$d7882f1fbc82745), (0, $bb0d81cc4a3df5a4$export$3d19f7baa45eeb82));
    }
}
const $b796b23c0ea2fe50$export$6429bdb2ffb98874 = (options)=>new $b796b23c0ea2fe50$var$IPushPullPlugin(options);
var $b796b23c0ea2fe50$export$2e2bcd8739ae039 = $b796b23c0ea2fe50$export$6429bdb2ffb98874;


const $19c99a26d4619bf2$export$5f30cdac9dff15e2 = {
    resizable: true,
    sortable: true,
    editable: true,
    filter: true,
    floatingFilter: true
};
const $19c99a26d4619bf2$export$d6bc7e4be37f31f1 = [
    {
        field: 'OrderId',
        cellDataType: 'number'
    },
    {
        field: 'CompanyName',
        cellDataType: 'text'
    },
    {
        field: 'ContactName',
        cellDataType: 'text'
    },
    {
        field: 'Employee',
        cellDataType: 'text'
    },
    {
        field: 'InvoicedCost',
        cellDataType: 'number'
    }
];



const $2b41e1f6da8699bd$export$eced545e825ecbd0 = [
    (0, $5b7ccabde48fae90$export$22e6f186b688d81b)
];


const $b4e14b6b8da86996$var$licenseKey = undefined;
const $b4e14b6b8da86996$var$adaptableOptions = {
    primaryKey: 'id',
    licenseKey: $b4e14b6b8da86996$var$licenseKey,
    userName: 'ipushpull user',
    adaptableId: 'Adaptable iPushpull',
    plugins: [
        (0, $b796b23c0ea2fe50$export$2e2bcd8739ae039)({
            autoLogin: false,
            ippConfig: {
                api_key: "DFm9DsojbtVvmP5l4QYfkNqMJUzR2AvktF6cJFo7" ?? '',
                api_secret: "SJdyU2Q07fzmUD46B43ztWuwijUzyxZgCllDZi8K1f8cEvAjF1iQ2XuJwI97GKV51z0AroeI1WuDHadbF5F6sajKbtNm8mjG9P9LW5au1kufkFUpWXNbMuNdFlU3IcJk" ?? ''
            }
        })
    ],
    initialState: {
        Dashboard: {
            PinnedToolbars: [
                'Layout',
                'IPushPull',
                'Export'
            ]
        },
        Layout: {
            Layouts: [
                {
                    Name: 'Layout Toolbars',
                    TableColumns: [
                        'OrderId',
                        'ContactName',
                        'Employee',
                        'InvoicedCost'
                    ]
                }
            ]
        },
        Export: {
            Reports: [
                {
                    Name: 'Invoice greater than 500',
                    ReportColumnScope: 'AllColumns',
                    ReportRowScope: 'ExpressionRows',
                    Query: {
                        BooleanExpression: '[InvoicedCost] > 500'
                    }
                },
                {
                    Name: 'Wilman Kala Contracts',
                    ReportColumnScope: 'AllColumns',
                    ReportRowScope: 'ExpressionRows',
                    Query: {
                        BooleanExpression: '[CompanyName] = "Wilman Kala"'
                    }
                }
            ]
        }
    }
};
// Create an AG Grid GridOptions object with the Column Definitions and Row Data created above
const $b4e14b6b8da86996$var$gridOptions = {
    defaultColDef: $19c99a26d4619bf2$export$5f30cdac9dff15e2,
    columnDefs: $19c99a26d4619bf2$export$d6bc7e4be37f31f1,
    rowData: $796acad2fe7c3f00$export$60c8979c505fed66,
    theme: (0, $437b23f6a393c3bf$export$495b90cf446940a1)
};
// Create an AG Grid Config object which contains AG Grid Grid Options and Modules
const $b4e14b6b8da86996$var$agGridConfig = {
    modules: (0, $2b41e1f6da8699bd$export$eced545e825ecbd0),
    gridOptions: $b4e14b6b8da86996$var$gridOptions
};
// Asynchronously instantiate AdapTable with Adaptable Options and AG Grid Config
(0, $7cde26aae0840b1a$export$2e2bcd8739ae039).init($b4e14b6b8da86996$var$adaptableOptions, $b4e14b6b8da86996$var$agGridConfig).then((adaptableApi)=>{
    const ipushpullApi = adaptableApi.pluginsApi.getipushpullPluginApi();
});


//# sourceMappingURL=repo.1951f8cf.js.map
